/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		5: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"0":"8975be1d","1":"fcb92a00","2":"d296fe3d","3":"5767a4e9","4":"b3d2145d"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 739);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(746);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/**
 * @module zrender/core/util
 */
// 用于处理merge时无法遍历Date等对象的问题
var BUILTIN_OBJECT = {
  '[object Function]': 1,
  '[object RegExp]': 1,
  '[object Date]': 1,
  '[object Error]': 1,
  '[object CanvasGradient]': 1,
  '[object CanvasPattern]': 1,
  // For node-canvas
  '[object Image]': 1,
  '[object Canvas]': 1
};
var TYPED_ARRAY = {
  '[object Int8Array]': 1,
  '[object Uint8Array]': 1,
  '[object Uint8ClampedArray]': 1,
  '[object Int16Array]': 1,
  '[object Uint16Array]': 1,
  '[object Int32Array]': 1,
  '[object Uint32Array]': 1,
  '[object Float32Array]': 1,
  '[object Float64Array]': 1
};
var objToString = Object.prototype.toString;
var arrayProto = Array.prototype;
var nativeForEach = arrayProto.forEach;
var nativeFilter = arrayProto.filter;
var nativeSlice = arrayProto.slice;
var nativeMap = arrayProto.map;
var nativeReduce = arrayProto.reduce; // Avoid assign to an exported variable, for transforming to cjs.

var methods = {};

function $override(name, fn) {
  // Clear ctx instance for different environment
  if (name === 'createCanvas') {
    _ctx = null;
  }

  methods[name] = fn;
}
/**
 * Those data types can be cloned:
 *     Plain object, Array, TypedArray, number, string, null, undefined.
 * Those data types will be assgined using the orginal data:
 *     BUILTIN_OBJECT
 * Instance of user defined class will be cloned to a plain object, without
 * properties in prototype.
 * Other data types is not supported (not sure what will happen).
 *
 * Caution: do not support clone Date, for performance consideration.
 * (There might be a large number of date in `series.data`).
 * So date should not be modified in and out of echarts.
 *
 * @param {*} source
 * @return {*} new
 */


function clone(source) {
  if (source == null || typeof source !== 'object') {
    return source;
  }

  var result = source;
  var typeStr = objToString.call(source);

  if (typeStr === '[object Array]') {
    if (!isPrimitive(source)) {
      result = [];

      for (var i = 0, len = source.length; i < len; i++) {
        result[i] = clone(source[i]);
      }
    }
  } else if (TYPED_ARRAY[typeStr]) {
    if (!isPrimitive(source)) {
      var Ctor = source.constructor;

      if (source.constructor.from) {
        result = Ctor.from(source);
      } else {
        result = new Ctor(source.length);

        for (var i = 0, len = source.length; i < len; i++) {
          result[i] = clone(source[i]);
        }
      }
    }
  } else if (!BUILTIN_OBJECT[typeStr] && !isPrimitive(source) && !isDom(source)) {
    result = {};

    for (var key in source) {
      if (source.hasOwnProperty(key)) {
        result[key] = clone(source[key]);
      }
    }
  }

  return result;
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} target
 * @param {*} source
 * @param {boolean} [overwrite=false]
 */


function merge(target, source, overwrite) {
  // We should escapse that source is string
  // and enter for ... in ...
  if (!isObject(source) || !isObject(target)) {
    return overwrite ? clone(source) : target;
  }

  for (var key in source) {
    if (source.hasOwnProperty(key)) {
      var targetProp = target[key];
      var sourceProp = source[key];

      if (isObject(sourceProp) && isObject(targetProp) && !isArray(sourceProp) && !isArray(targetProp) && !isDom(sourceProp) && !isDom(targetProp) && !isBuiltInObject(sourceProp) && !isBuiltInObject(targetProp) && !isPrimitive(sourceProp) && !isPrimitive(targetProp)) {
        // 如果需要递归覆盖，就递归调用merge
        merge(targetProp, sourceProp, overwrite);
      } else if (overwrite || !(key in target)) {
        // 否则只处理overwrite为true，或者在目标对象中没有此属性的情况
        // NOTE，在 target[key] 不存在的时候也是直接覆盖
        target[key] = clone(source[key], true);
      }
    }
  }

  return target;
}
/**
 * @param {Array} targetAndSources The first item is target, and the rests are source.
 * @param {boolean} [overwrite=false]
 * @return {*} target
 */


function mergeAll(targetAndSources, overwrite) {
  var result = targetAndSources[0];

  for (var i = 1, len = targetAndSources.length; i < len; i++) {
    result = merge(result, targetAndSources[i], overwrite);
  }

  return result;
}
/**
 * @param {*} target
 * @param {*} source
 * @memberOf module:zrender/core/util
 */


function extend(target, source) {
  for (var key in source) {
    if (source.hasOwnProperty(key)) {
      target[key] = source[key];
    }
  }

  return target;
}
/**
 * @param {*} target
 * @param {*} source
 * @param {boolean} [overlay=false]
 * @memberOf module:zrender/core/util
 */


function defaults(target, source, overlay) {
  for (var key in source) {
    if (source.hasOwnProperty(key) && (overlay ? source[key] != null : target[key] == null)) {
      target[key] = source[key];
    }
  }

  return target;
}

var createCanvas = function () {
  return methods.createCanvas();
};

methods.createCanvas = function () {
  return document.createElement('canvas');
}; // FIXME


var _ctx;

function getContext() {
  if (!_ctx) {
    // Use util.createCanvas instead of createCanvas
    // because createCanvas may be overwritten in different environment
    _ctx = createCanvas().getContext('2d');
  }

  return _ctx;
}
/**
 * 查询数组中元素的index
 * @memberOf module:zrender/core/util
 */


function indexOf(array, value) {
  if (array) {
    if (array.indexOf) {
      return array.indexOf(value);
    }

    for (var i = 0, len = array.length; i < len; i++) {
      if (array[i] === value) {
        return i;
      }
    }
  }

  return -1;
}
/**
 * 构造类继承关系
 *
 * @memberOf module:zrender/core/util
 * @param {Function} clazz 源类
 * @param {Function} baseClazz 基类
 */


function inherits(clazz, baseClazz) {
  var clazzPrototype = clazz.prototype;

  function F() {}

  F.prototype = baseClazz.prototype;
  clazz.prototype = new F();

  for (var prop in clazzPrototype) {
    if (clazzPrototype.hasOwnProperty(prop)) {
      clazz.prototype[prop] = clazzPrototype[prop];
    }
  }

  clazz.prototype.constructor = clazz;
  clazz.superClass = baseClazz;
}
/**
 * @memberOf module:zrender/core/util
 * @param {Object|Function} target
 * @param {Object|Function} sorce
 * @param {boolean} overlay
 */


function mixin(target, source, overlay) {
  target = 'prototype' in target ? target.prototype : target;
  source = 'prototype' in source ? source.prototype : source;
  defaults(target, source, overlay);
}
/**
 * Consider typed array.
 * @param {Array|TypedArray} data
 */


function isArrayLike(data) {
  if (!data) {
    return;
  }

  if (typeof data === 'string') {
    return false;
  }

  return typeof data.length === 'number';
}
/**
 * 数组或对象遍历
 * @memberOf module:zrender/core/util
 * @param {Object|Array} obj
 * @param {Function} cb
 * @param {*} [context]
 */


function each(obj, cb, context) {
  if (!(obj && cb)) {
    return;
  }

  if (obj.forEach && obj.forEach === nativeForEach) {
    obj.forEach(cb, context);
  } else if (obj.length === +obj.length) {
    for (var i = 0, len = obj.length; i < len; i++) {
      cb.call(context, obj[i], i, obj);
    }
  } else {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        cb.call(context, obj[key], key, obj);
      }
    }
  }
}
/**
 * 数组映射
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {*} [context]
 * @return {Array}
 */


function map(obj, cb, context) {
  if (!(obj && cb)) {
    return;
  }

  if (obj.map && obj.map === nativeMap) {
    return obj.map(cb, context);
  } else {
    var result = [];

    for (var i = 0, len = obj.length; i < len; i++) {
      result.push(cb.call(context, obj[i], i, obj));
    }

    return result;
  }
}
/**
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {Object} [memo]
 * @param {*} [context]
 * @return {Array}
 */


function reduce(obj, cb, memo, context) {
  if (!(obj && cb)) {
    return;
  }

  if (obj.reduce && obj.reduce === nativeReduce) {
    return obj.reduce(cb, memo, context);
  } else {
    for (var i = 0, len = obj.length; i < len; i++) {
      memo = cb.call(context, memo, obj[i], i, obj);
    }

    return memo;
  }
}
/**
 * 数组过滤
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {*} [context]
 * @return {Array}
 */


function filter(obj, cb, context) {
  if (!(obj && cb)) {
    return;
  }

  if (obj.filter && obj.filter === nativeFilter) {
    return obj.filter(cb, context);
  } else {
    var result = [];

    for (var i = 0, len = obj.length; i < len; i++) {
      if (cb.call(context, obj[i], i, obj)) {
        result.push(obj[i]);
      }
    }

    return result;
  }
}
/**
 * 数组项查找
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {*} [context]
 * @return {*}
 */


function find(obj, cb, context) {
  if (!(obj && cb)) {
    return;
  }

  for (var i = 0, len = obj.length; i < len; i++) {
    if (cb.call(context, obj[i], i, obj)) {
      return obj[i];
    }
  }
}
/**
 * @memberOf module:zrender/core/util
 * @param {Function} func
 * @param {*} context
 * @return {Function}
 */


function bind(func, context) {
  var args = nativeSlice.call(arguments, 2);
  return function () {
    return func.apply(context, args.concat(nativeSlice.call(arguments)));
  };
}
/**
 * @memberOf module:zrender/core/util
 * @param {Function} func
 * @return {Function}
 */


function curry(func) {
  var args = nativeSlice.call(arguments, 1);
  return function () {
    return func.apply(this, args.concat(nativeSlice.call(arguments)));
  };
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isArray(value) {
  return objToString.call(value) === '[object Array]';
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isFunction(value) {
  return typeof value === 'function';
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isString(value) {
  return objToString.call(value) === '[object String]';
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return type === 'function' || !!value && type === 'object';
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isBuiltInObject(value) {
  return !!BUILTIN_OBJECT[objToString.call(value)];
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isTypedArray(value) {
  return !!TYPED_ARRAY[objToString.call(value)];
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isDom(value) {
  return typeof value === 'object' && typeof value.nodeType === 'number' && typeof value.ownerDocument === 'object';
}
/**
 * Whether is exactly NaN. Notice isNaN('a') returns true.
 * @param {*} value
 * @return {boolean}
 */


function eqNaN(value) {
  /* eslint-disable-next-line no-self-compare */
  return value !== value;
}
/**
 * If value1 is not null, then return value1, otherwise judget rest of values.
 * Low performance.
 * @memberOf module:zrender/core/util
 * @return {*} Final value
 */


function retrieve(values) {
  for (var i = 0, len = arguments.length; i < len; i++) {
    if (arguments[i] != null) {
      return arguments[i];
    }
  }
}

function retrieve2(value0, value1) {
  return value0 != null ? value0 : value1;
}

function retrieve3(value0, value1, value2) {
  return value0 != null ? value0 : value1 != null ? value1 : value2;
}
/**
 * @memberOf module:zrender/core/util
 * @param {Array} arr
 * @param {number} startIndex
 * @param {number} endIndex
 * @return {Array}
 */


function slice() {
  return Function.call.apply(nativeSlice, arguments);
}
/**
 * Normalize css liked array configuration
 * e.g.
 *  3 => [3, 3, 3, 3]
 *  [4, 2] => [4, 2, 4, 2]
 *  [4, 3, 2] => [4, 3, 2, 3]
 * @param {number|Array.<number>} val
 * @return {Array.<number>}
 */


function normalizeCssArray(val) {
  if (typeof val === 'number') {
    return [val, val, val, val];
  }

  var len = val.length;

  if (len === 2) {
    // vertical | horizontal
    return [val[0], val[1], val[0], val[1]];
  } else if (len === 3) {
    // top | horizontal | bottom
    return [val[0], val[1], val[2], val[1]];
  }

  return val;
}
/**
 * @memberOf module:zrender/core/util
 * @param {boolean} condition
 * @param {string} message
 */


function assert(condition, message) {
  if (!condition) {
    throw new Error(message);
  }
}
/**
 * @memberOf module:zrender/core/util
 * @param {string} str string to be trimed
 * @return {string} trimed string
 */


function trim(str) {
  if (str == null) {
    return null;
  } else if (typeof str.trim === 'function') {
    return str.trim();
  } else {
    return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  }
}

var primitiveKey = '__ec_primitive__';
/**
 * Set an object as primitive to be ignored traversing children in clone or merge
 */

function setAsPrimitive(obj) {
  obj[primitiveKey] = true;
}

function isPrimitive(obj) {
  return obj[primitiveKey];
}
/**
 * @constructor
 * @param {Object} obj Only apply `ownProperty`.
 */


function HashMap(obj) {
  var isArr = isArray(obj); // Key should not be set on this, otherwise
  // methods get/set/... may be overrided.

  this.data = {};
  var thisMap = this;
  obj instanceof HashMap ? obj.each(visit) : obj && each(obj, visit);

  function visit(value, key) {
    isArr ? thisMap.set(value, key) : thisMap.set(key, value);
  }
}

HashMap.prototype = {
  constructor: HashMap,
  // Do not provide `has` method to avoid defining what is `has`.
  // (We usually treat `null` and `undefined` as the same, different
  // from ES6 Map).
  get: function (key) {
    return this.data.hasOwnProperty(key) ? this.data[key] : null;
  },
  set: function (key, value) {
    // Comparing with invocation chaining, `return value` is more commonly
    // used in this case: `var someVal = map.set('a', genVal());`
    return this.data[key] = value;
  },
  // Although util.each can be performed on this hashMap directly, user
  // should not use the exposed keys, who are prefixed.
  each: function (cb, context) {
    context !== void 0 && (cb = bind(cb, context));
    /* eslint-disable guard-for-in */

    for (var key in this.data) {
      this.data.hasOwnProperty(key) && cb(this.data[key], key);
    }
    /* eslint-enable guard-for-in */

  },
  // Do not use this method if performance sensitive.
  removeKey: function (key) {
    delete this.data[key];
  }
};

function createHashMap(obj) {
  return new HashMap(obj);
}

function concatArray(a, b) {
  var newArray = new a.constructor(a.length + b.length);

  for (var i = 0; i < a.length; i++) {
    newArray[i] = a[i];
  }

  var offset = a.length;

  for (i = 0; i < b.length; i++) {
    newArray[i + offset] = b[i];
  }

  return newArray;
}

function noop() {}

exports.$override = $override;
exports.clone = clone;
exports.merge = merge;
exports.mergeAll = mergeAll;
exports.extend = extend;
exports.defaults = defaults;
exports.createCanvas = createCanvas;
exports.getContext = getContext;
exports.indexOf = indexOf;
exports.inherits = inherits;
exports.mixin = mixin;
exports.isArrayLike = isArrayLike;
exports.each = each;
exports.map = map;
exports.reduce = reduce;
exports.filter = filter;
exports.find = find;
exports.bind = bind;
exports.curry = curry;
exports.isArray = isArray;
exports.isFunction = isFunction;
exports.isString = isString;
exports.isObject = isObject;
exports.isBuiltInObject = isBuiltInObject;
exports.isTypedArray = isTypedArray;
exports.isDom = isDom;
exports.eqNaN = eqNaN;
exports.retrieve = retrieve;
exports.retrieve2 = retrieve2;
exports.retrieve3 = retrieve3;
exports.slice = slice;
exports.normalizeCssArray = normalizeCssArray;
exports.assert = assert;
exports.trim = trim;
exports.setAsPrimitive = setAsPrimitive;
exports.isPrimitive = isPrimitive;
exports.createHashMap = createHashMap;
exports.concatArray = concatArray;
exports.noop = noop;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(220)(module)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _grid = __webpack_require__(261);

var _default = _grid.Row;
exports["default"] = _default;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(345);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _button = _interopRequireDefault(__webpack_require__(751));

var _buttonGroup = _interopRequireDefault(__webpack_require__(809));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_button["default"].Group = _buttonGroup["default"];
var _default = _button["default"];
exports["default"] = _default;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(831);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Table = _interopRequireDefault(__webpack_require__(977));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _Table["default"];
exports["default"] = _default;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(1094);

__webpack_require__(365);

__webpack_require__(127);

__webpack_require__(534);

__webpack_require__(366);

__webpack_require__(12);

__webpack_require__(367);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcNotification = _interopRequireDefault(__webpack_require__(464));

var _icon = _interopRequireDefault(__webpack_require__(38));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var defaultDuration = 3;
var defaultTop;
var messageInstance;
var key = 1;
var prefixCls = 'ant-message';
var transitionName = 'move-up';
var getContainer;
var maxCount;

function getMessageInstance(callback) {
  if (messageInstance) {
    callback(messageInstance);
    return;
  }

  _rcNotification["default"].newInstance({
    prefixCls: prefixCls,
    transitionName: transitionName,
    style: {
      top: defaultTop
    },
    getContainer: getContainer,
    maxCount: maxCount
  }, function (instance) {
    if (messageInstance) {
      callback(messageInstance);
      return;
    }

    messageInstance = instance;
    callback(instance);
  });
}

function notice(args) {
  var duration = args.duration !== undefined ? args.duration : defaultDuration;
  var iconType = {
    info: 'info-circle',
    success: 'check-circle',
    error: 'close-circle',
    warning: 'exclamation-circle',
    loading: 'loading'
  }[args.type];
  var target = args.key || key++;
  var closePromise = new Promise(function (resolve) {
    var callback = function callback() {
      if (typeof args.onClose === 'function') {
        args.onClose();
      }

      return resolve(true);
    };

    getMessageInstance(function (instance) {
      var iconNode = /*#__PURE__*/React.createElement(_icon["default"], {
        type: iconType,
        theme: iconType === 'loading' ? 'outlined' : 'filled'
      });
      var switchIconNode = iconType ? iconNode : '';
      instance.notice({
        key: target,
        duration: duration,
        style: {},
        content: /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-custom-content").concat(args.type ? " ".concat(prefixCls, "-").concat(args.type) : '')
        }, args.icon ? args.icon : switchIconNode, /*#__PURE__*/React.createElement("span", null, args.content)),
        onClose: callback
      });
    });
  });

  var result = function result() {
    if (messageInstance) {
      messageInstance.removeNotice(target);
    }
  };

  result.then = function (filled, rejected) {
    return closePromise.then(filled, rejected);
  };

  result.promise = closePromise;
  return result;
}

function isArgsProps(content) {
  return Object.prototype.toString.call(content) === '[object Object]' && !!content.content;
}

var api = {
  open: notice,
  config: function config(options) {
    if (options.top !== undefined) {
      defaultTop = options.top;
      messageInstance = null; // delete messageInstance for new defaultTop
    }

    if (options.duration !== undefined) {
      defaultDuration = options.duration;
    }

    if (options.prefixCls !== undefined) {
      prefixCls = options.prefixCls;
    }

    if (options.getContainer !== undefined) {
      getContainer = options.getContainer;
    }

    if (options.transitionName !== undefined) {
      transitionName = options.transitionName;
      messageInstance = null; // delete messageInstance for new transitionName
    }

    if (options.maxCount !== undefined) {
      maxCount = options.maxCount;
      messageInstance = null;
    }
  },
  destroy: function destroy() {
    if (messageInstance) {
      messageInstance.destroy();
      messageInstance = null;
    }
  }
};
['success', 'info', 'warning', 'error', 'loading'].forEach(function (type) {
  api[type] = function (content, duration, onClose) {
    if (isArgsProps(content)) {
      return api.open(_extends(_extends({}, content), {
        type: type
      }));
    }

    if (typeof duration === 'function') {
      onClose = duration;
      duration = undefined;
    }

    return api.open({
      content: content,
      duration: duration,
      type: type,
      onClose: onClose
    });
  };
});
api.warn = api.warning;
var _default = api;
exports["default"] = _default;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(832);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(19));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _omit = _interopRequireDefault(__webpack_require__(71));

var _debounce = _interopRequireDefault(__webpack_require__(532));

var _configProvider = __webpack_require__(39);

var _type = __webpack_require__(130);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var SpinSizes = (0, _type.tuple)('small', 'default', 'large'); // Render indicator

var defaultIndicator = null;

function renderIndicator(prefixCls, props) {
  var indicator = props.indicator;
  var dotClassName = "".concat(prefixCls, "-dot"); // should not be render default indicator when indicator value is null

  if (indicator === null) {
    return null;
  }

  if ( /*#__PURE__*/React.isValidElement(indicator)) {
    return /*#__PURE__*/React.cloneElement(indicator, {
      className: (0, _classnames["default"])(indicator.props.className, dotClassName)
    });
  }

  if ( /*#__PURE__*/React.isValidElement(defaultIndicator)) {
    return /*#__PURE__*/React.cloneElement(defaultIndicator, {
      className: (0, _classnames["default"])(defaultIndicator.props.className, dotClassName)
    });
  }

  return /*#__PURE__*/React.createElement("span", {
    className: (0, _classnames["default"])(dotClassName, "".concat(prefixCls, "-dot-spin"))
  }, /*#__PURE__*/React.createElement("i", {
    className: "".concat(prefixCls, "-dot-item")
  }), /*#__PURE__*/React.createElement("i", {
    className: "".concat(prefixCls, "-dot-item")
  }), /*#__PURE__*/React.createElement("i", {
    className: "".concat(prefixCls, "-dot-item")
  }), /*#__PURE__*/React.createElement("i", {
    className: "".concat(prefixCls, "-dot-item")
  }));
}

function shouldDelay(spinning, delay) {
  return !!spinning && !!delay && !isNaN(Number(delay));
}

var Spin = /*#__PURE__*/function (_React$Component) {
  _inherits(Spin, _React$Component);

  var _super = _createSuper(Spin);

  function Spin(props) {
    var _this;

    _classCallCheck(this, Spin);

    _this = _super.call(this, props);

    _this.debouncifyUpdateSpinning = function (props) {
      var _ref = props || _this.props,
          delay = _ref.delay;

      if (delay) {
        _this.cancelExistingSpin();

        _this.updateSpinning = (0, _debounce["default"])(_this.originalUpdateSpinning, delay);
      }
    };

    _this.updateSpinning = function () {
      var spinning = _this.props.spinning;
      var currentSpinning = _this.state.spinning;

      if (currentSpinning !== spinning) {
        _this.setState({
          spinning: spinning
        });
      }
    };

    _this.renderSpin = function (_ref2) {
      var _classNames;

      var getPrefixCls = _ref2.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          className = _a.className,
          size = _a.size,
          tip = _a.tip,
          wrapperClassName = _a.wrapperClassName,
          style = _a.style,
          restProps = __rest(_a, ["prefixCls", "className", "size", "tip", "wrapperClassName", "style"]);

      var spinning = _this.state.spinning;
      var prefixCls = getPrefixCls('spin', customizePrefixCls);
      var spinClassName = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-spinning"), spinning), _defineProperty(_classNames, "".concat(prefixCls, "-show-text"), !!tip), _classNames), className); // fix https://fb.me/react-unknown-prop

      var divProps = (0, _omit["default"])(restProps, ['spinning', 'delay', 'indicator']);
      var spinElement = /*#__PURE__*/React.createElement("div", _extends({}, divProps, {
        style: style,
        className: spinClassName
      }), renderIndicator(prefixCls, _this.props), tip ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-text")
      }, tip) : null);

      if (_this.isNestedPattern()) {
        var containerClassName = (0, _classnames["default"])("".concat(prefixCls, "-container"), _defineProperty({}, "".concat(prefixCls, "-blur"), spinning));
        return /*#__PURE__*/React.createElement("div", _extends({}, divProps, {
          className: (0, _classnames["default"])("".concat(prefixCls, "-nested-loading"), wrapperClassName)
        }), spinning && /*#__PURE__*/React.createElement("div", {
          key: "loading"
        }, spinElement), /*#__PURE__*/React.createElement("div", {
          className: containerClassName,
          key: "container"
        }, _this.props.children));
      }

      return spinElement;
    };

    var spinning = props.spinning,
        delay = props.delay;
    var shouldBeDelayed = shouldDelay(spinning, delay);
    _this.state = {
      spinning: spinning && !shouldBeDelayed
    };
    _this.originalUpdateSpinning = _this.updateSpinning;

    _this.debouncifyUpdateSpinning(props);

    return _this;
  }

  _createClass(Spin, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateSpinning();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.debouncifyUpdateSpinning();
      this.updateSpinning();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelExistingSpin();
    }
  }, {
    key: "cancelExistingSpin",
    value: function cancelExistingSpin() {
      var updateSpinning = this.updateSpinning;

      if (updateSpinning && updateSpinning.cancel) {
        updateSpinning.cancel();
      }
    }
  }, {
    key: "isNestedPattern",
    value: function isNestedPattern() {
      return !!(this.props && this.props.children);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSpin);
    }
  }], [{
    key: "setDefaultIndicator",
    value: function setDefaultIndicator(indicator) {
      defaultIndicator = indicator;
    }
  }]);

  return Spin;
}(React.Component);

Spin.defaultProps = {
  spinning: true,
  size: 'default',
  wrapperClassName: ''
};
Spin.propTypes = {
  prefixCls: PropTypes.string,
  className: PropTypes.string,
  spinning: PropTypes.bool,
  size: PropTypes.oneOf(SpinSizes),
  wrapperClassName: PropTypes.string,
  indicator: PropTypes.element
};
var _default = Spin;
exports["default"] = _default;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(1099);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _rcCalendar = _interopRequireDefault(__webpack_require__(495));

var _MonthCalendar = _interopRequireDefault(__webpack_require__(498));

var _createPicker = _interopRequireDefault(__webpack_require__(949));

var _wrapPicker = _interopRequireDefault(__webpack_require__(952));

var _RangePicker = _interopRequireDefault(__webpack_require__(960));

var _WeekPicker = _interopRequireDefault(__webpack_require__(970));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DatePicker = (0, _wrapPicker["default"])((0, _createPicker["default"])(_rcCalendar["default"]), 'date');
var MonthPicker = (0, _wrapPicker["default"])((0, _createPicker["default"])(_MonthCalendar["default"]), 'month');

_extends(DatePicker, {
  RangePicker: (0, _wrapPicker["default"])(_RangePicker["default"], 'date'),
  MonthPicker: MonthPicker,
  WeekPicker: (0, _wrapPicker["default"])(_WeekPicker["default"], 'week')
});

var _default = DatePicker;
exports["default"] = _default;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(972);

__webpack_require__(25);

__webpack_require__(973);

__webpack_require__(975);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(49);
var core = __webpack_require__(102);
var hide = __webpack_require__(90);
var redefine = __webpack_require__(91);
var ctx = __webpack_require__(103);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Auth=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Auth,_Component);function Auth(){_classCallCheck(this,Auth);return _possibleConstructorReturn(this,(Auth.__proto__||Object.getPrototypeOf(Auth)).apply(this,arguments));}_createClass(Auth,[{key:'render',value:function render(){var _props$store$auth=this.props.store.auth,_props$store$auth$ES=_props$store$auth.ES,data=_props$store$auth$ES===undefined?[]:_props$store$auth$ES,isCloseMonth=_props$store$auth.isCloseMonth,isSave=_props$store$auth.isSave,user=_props$store$auth.user,isAdmin=_props$store$auth.isAdmin;if(user.email==='admin')return this.props.children;if(isAdmin)return null;var noAuth=['edit_week','edit_daily'];// 未付费、表格关闭
if(!isSave)return null;// 超出表格关闭日期表格关闭保存按钮
if(isCloseMonth&&!noAuth.includes(this.props.auth)){return null;}if(data.includes(this.props.auth)){return this.props.children;}else{return null;}}}]);return Auth;}(_react.Component))||_class)||_class);exports.default=Auth;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(810);


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "propTypes", function() { return propTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return propTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onError", function() { return onError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observer", function() { return observer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Observer", function() { return Observer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderReporter", function() { return renderReporter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentByNodeRegistery", function() { return componentByNodeRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentByNodeRegistry", function() { return componentByNodeRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trackComponents", function() { return trackComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useStaticRendering", function() { return useStaticRendering; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return inject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disposeOnUnmount", function() { return disposeOnUnmount; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/** @license mobx-react v5.4.4
 * index.module.js
 *
 * Copyright (c) 2015 Michel Weststrate.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */




function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

// These functions can be stubbed out in specific environments

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x.default : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var reactIs_production_min = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,r=b?Symbol.for("react.memo"):
60115,t=b?Symbol.for("react.lazy"):60116;function u(a){if("object"===typeof a&&null!==a){var q=a.$$typeof;switch(q){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return q}}case d:return q}}}function v(a){return u(a)===m}exports.typeOf=u;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;
exports.Profiler=g;exports.Portal=d;exports.StrictMode=f;exports.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||u(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return u(a)===k};exports.isContextProvider=function(a){return u(a)===h};
exports.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return u(a)===n};exports.isFragment=function(a){return u(a)===e};exports.isProfiler=function(a){return u(a)===g};exports.isPortal=function(a){return u(a)===d};exports.isStrictMode=function(a){return u(a)===f};
});

unwrapExports(reactIs_production_min);
var reactIs_production_min_1 = reactIs_production_min.typeOf;
var reactIs_production_min_2 = reactIs_production_min.AsyncMode;
var reactIs_production_min_3 = reactIs_production_min.ConcurrentMode;
var reactIs_production_min_4 = reactIs_production_min.ContextConsumer;
var reactIs_production_min_5 = reactIs_production_min.ContextProvider;
var reactIs_production_min_6 = reactIs_production_min.Element;
var reactIs_production_min_7 = reactIs_production_min.ForwardRef;
var reactIs_production_min_8 = reactIs_production_min.Fragment;
var reactIs_production_min_9 = reactIs_production_min.Profiler;
var reactIs_production_min_10 = reactIs_production_min.Portal;
var reactIs_production_min_11 = reactIs_production_min.StrictMode;
var reactIs_production_min_12 = reactIs_production_min.isValidElementType;
var reactIs_production_min_13 = reactIs_production_min.isAsyncMode;
var reactIs_production_min_14 = reactIs_production_min.isConcurrentMode;
var reactIs_production_min_15 = reactIs_production_min.isContextConsumer;
var reactIs_production_min_16 = reactIs_production_min.isContextProvider;
var reactIs_production_min_17 = reactIs_production_min.isElement;
var reactIs_production_min_18 = reactIs_production_min.isForwardRef;
var reactIs_production_min_19 = reactIs_production_min.isFragment;
var reactIs_production_min_20 = reactIs_production_min.isProfiler;
var reactIs_production_min_21 = reactIs_production_min.isPortal;
var reactIs_production_min_22 = reactIs_production_min.isStrictMode;

var reactIs = createCommonjsModule(function (module) {

{
  module.exports = reactIs_production_min;
}
});

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = TYPE_STATICS[targetComponent['$$typeof']] || REACT_STATICS;
        var sourceStatics = TYPE_STATICS[sourceComponent['$$typeof']] || REACT_STATICS;

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

var EventEmitter =
/*#__PURE__*/
function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.listeners = [];
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(cb) {
      var _this = this;

      this.listeners.push(cb);
      return function () {
        var index = _this.listeners.indexOf(cb);

        if (index !== -1) _this.listeners.splice(index, 1);
      };
    }
  }, {
    key: "emit",
    value: function emit(data) {
      this.listeners.forEach(function (fn) {
        return fn(data);
      });
    }
  }]);

  return EventEmitter;
}();

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      rest[_key - 6] = arguments[_key];
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["untracked"])(function () {
      componentName = componentName || "<<anonymous>>";
      propFullName = propFullName || propName;

      if (props[propName] == null) {
        if (isRequired) {
          var actual = props[propName] === null ? "null" : "undefined";
          return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
        }

        return null;
      } else {
        return validate.apply(void 0, [props, propName, componentName, location, propFullName].concat(rest));
      }
    });
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);
  return chainedCheckType;
} // Copied from React.PropTypes


function isSymbol(propType, propValue) {
  // Native Symbol.
  if (propType === "symbol") {
    return true;
  } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


  if (propValue["@@toStringTag"] === "Symbol") {
    return true;
  } // Fallback for non-spec compliant Symbols which are polyfilled.


  if (typeof Symbol === "function" && propValue instanceof Symbol) {
    return true;
  }

  return false;
} // Copied from React.PropTypes


function getPropType(propValue) {
  var propType = _typeof(propValue);

  if (Array.isArray(propValue)) {
    return "array";
  }

  if (propValue instanceof RegExp) {
    // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
  }

  if (isSymbol(propType, propValue)) {
    return "symbol";
  }

  return propType;
} // This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes


function getPreciseType(propValue) {
  var propType = getPropType(propValue);

  if (propType === "object") {
    if (propValue instanceof Date) {
      return "date";
    } else if (propValue instanceof RegExp) {
      return "regexp";
    }
  }

  return propType;
}

function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
  return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["untracked"])(function () {
      if (allowNativeType) {
        if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
      }

      var mobxChecker;

      switch (mobxType) {
        case "Array":
          mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableArray"];
          break;

        case "Object":
          mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableObject"];
          break;

        case "Map":
          mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableMap"];
          break;

        default:
          throw new Error("Unexpected mobxType: ".concat(mobxType));
      }

      var propValue = props[propName];

      if (!mobxChecker(propValue)) {
        var preciseType = getPreciseType(propValue);
        var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
        return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
      }

      return null;
    });
  });
}

function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
  return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
      rest[_key2 - 5] = arguments[_key2];
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["untracked"])(function () {
      if (typeof typeChecker !== "function") {
        return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
      }

      var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
      if (error instanceof Error) return error;
      var propValue = props[propName];

      for (var i = 0; i < propValue.length; i++) {
        error = typeChecker.apply(void 0, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
        if (error instanceof Error) return error;
      }

      return null;
    });
  });
}

var observableArray = createObservableTypeCheckerCreator(false, "Array");
var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
var observableMap = createObservableTypeCheckerCreator(false, "Map");
var observableObject = createObservableTypeCheckerCreator(false, "Object");
var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");

var propTypes = /*#__PURE__*/Object.freeze({
  observableArray: observableArray,
  observableArrayOf: observableArrayOf,
  observableMap: observableMap,
  observableObject: observableObject,
  arrayOrObservableArray: arrayOrObservableArray,
  arrayOrObservableArrayOf: arrayOrObservableArrayOf,
  objectOrObservableObject: objectOrObservableObject
});

function isStateless(component) {
  // `function() {}` has prototype, but `() => {}` doesn't
  // `() => {}` via Babel has prototype too.
  return !(component.prototype && component.prototype.render);
}
var symbolId = 0;

function createSymbol(name) {
  if (typeof Symbol === "function") {
    return Symbol(name);
  }

  var symbol = "__$mobx-react ".concat(name, " (").concat(symbolId, ")");
  symbolId++;
  return symbol;
}

var createdSymbols = {};
function newSymbol(name) {
  if (!createdSymbols[name]) {
    createdSymbols[name] = createSymbol(name);
  }

  return createdSymbols[name];
}
var mobxMixins = newSymbol("patchMixins");
var mobxPatchedDefinition = newSymbol("patchedDefinition");

function getMixins(target, methodName) {
  var mixins = target[mobxMixins] = target[mobxMixins] || {};
  var methodMixins = mixins[methodName] = mixins[methodName] || {};
  methodMixins.locks = methodMixins.locks || 0;
  methodMixins.methods = methodMixins.methods || [];
  return methodMixins;
}

function wrapper(realMethod, mixins) {
  var _this = this;

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
  mixins.locks++;

  try {
    var retVal;

    if (realMethod !== undefined && realMethod !== null) {
      retVal = realMethod.apply(this, args);
    }

    return retVal;
  } finally {
    mixins.locks--;

    if (mixins.locks === 0) {
      mixins.methods.forEach(function (mx) {
        mx.apply(_this, args);
      });
    }
  }
}

function wrapFunction(realMethod, mixins) {
  var fn = function fn() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    wrapper.call.apply(wrapper, [this, realMethod, mixins].concat(args));
  };

  return fn;
}

function patch(target, methodName) {
  var mixins = getMixins(target, methodName);

  for (var _len3 = arguments.length, mixinMethods = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    mixinMethods[_key3 - 2] = arguments[_key3];
  }

  for (var _i = 0; _i < mixinMethods.length; _i++) {
    var mixinMethod = mixinMethods[_i];

    if (mixins.methods.indexOf(mixinMethod) < 0) {
      mixins.methods.push(mixinMethod);
    }
  }

  var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);

  if (oldDefinition && oldDefinition[mobxPatchedDefinition]) {
    // already patched definition, do not repatch
    return;
  }

  var originalMethod = target[methodName];
  var newDefinition = createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
  Object.defineProperty(target, methodName, newDefinition);
}

function createDefinition(target, methodName, enumerable, mixins, originalMethod) {
  var _ref;

  var wrappedFunc = wrapFunction(originalMethod, mixins);
  return _ref = {}, _defineProperty(_ref, mobxPatchedDefinition, true), _defineProperty(_ref, "get", function get() {
    return wrappedFunc;
  }), _defineProperty(_ref, "set", function set(value) {
    if (this === target) {
      wrappedFunc = wrapFunction(value, mixins);
    } else {
      // when it is an instance of the prototype/a child prototype patch that particular case again separately
      // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
      // e.g. the method for super might not be the same as the method for the prototype which might be not the same
      // as the method for the instance
      var newDefinition = createDefinition(this, methodName, enumerable, mixins, value);
      Object.defineProperty(this, methodName, newDefinition);
    }
  }), _defineProperty(_ref, "configurable", true), _defineProperty(_ref, "enumerable", enumerable), _ref;
}

var injectorContextTypes = {
  mobxStores: objectOrObservableObject
};
Object.seal(injectorContextTypes);
var proxiedInjectorProps = {
  contextTypes: {
    get: function get() {
      return injectorContextTypes;
    },
    set: function set(_) {
      console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
    },
    configurable: true,
    enumerable: false
  },
  isMobxInjector: {
    value: true,
    writable: true,
    configurable: true,
    enumerable: true
  }
  /**
   * Store Injection
   */

};

function createStoreInjector(grabStoresFn, component, injectNames) {
  var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
  if (injectNames) displayName += "-with-" + injectNames;

  var Injector =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Injector, _Component);

    function Injector() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, Injector);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Injector)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _this.storeRef = function (instance) {
        _this.wrappedInstance = instance;
      };

      return _this;
    }

    _createClass(Injector, [{
      key: "render",
      value: function render() {
        // Optimization: it might be more efficient to apply the mapper function *outside* the render method
        // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
        // See this test: 'using a custom injector is not too reactive' in inject.js
        var newProps = {};

        for (var key in this.props) {
          if (this.props.hasOwnProperty(key)) {
            newProps[key] = this.props[key];
          }
        }

        var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};

        for (var _key2 in additionalProps) {
          newProps[_key2] = additionalProps[_key2];
        }

        if (!isStateless(component)) {
          newProps.ref = this.storeRef;
        }

        return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, newProps);
      }
    }]);

    return Injector;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]); // Static fields from component should be visible on the generated Injector


  Injector.displayName = displayName;
  hoistNonReactStatics_cjs(Injector, component);
  Injector.wrappedComponent = component;
  Object.defineProperties(Injector, proxiedInjectorProps);
  return Injector;
}

function grabStoresByName(storeNames) {
  return function (baseStores, nextProps) {
    storeNames.forEach(function (storeName) {
      if (storeName in nextProps // prefer props over stores
      ) return;
      if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
      nextProps[storeName] = baseStores[storeName];
    });
    return nextProps;
  };
}
/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */


function inject()
/* fn(stores, nextProps) or ...storeNames */
{
  var grabStoresFn;

  if (typeof arguments[0] === "function") {
    grabStoresFn = arguments[0];
    return function (componentClass) {
      var injected = createStoreInjector(grabStoresFn, componentClass);
      injected.isMobxInjector = false; // supress warning
      // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
      // see #111

      injected = observer(injected);
      injected.isMobxInjector = true; // restore warning

      return injected;
    };
  } else {
    var storeNames = [];

    for (var i = 0; i < arguments.length; i++) {
      storeNames[i] = arguments[i];
    }

    grabStoresFn = grabStoresByName(storeNames);
    return function (componentClass) {
      return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
    };
  }
}

var mobxAdminProperty = __WEBPACK_IMPORTED_MODULE_0_mobx__["$mobx"] || "$mobx";
var mobxIsUnmounted = newSymbol("isUnmounted");
/**
 * dev tool support
 */

var isDevtoolsEnabled = false;
var isUsingStaticRendering = false;
var warnedAboutObserverInjectDeprecation = false; // WeakMap<Node, Object>;

var componentByNodeRegistry = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
var renderReporter = new EventEmitter();
var skipRenderKey = newSymbol("skipRender");
var isForcingUpdateKey = newSymbol("isForcingUpdate"); // Using react-is had some issues (and operates on elements, not on types), see #608 / #609

var ReactForwardRefSymbol = typeof __WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"] === "function" && Object(__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"])(function (_props, _ref) {})["$$typeof"];
/**
 * Helper to set `prop` to `this` as non-enumerable (hidden prop)
 * @param target
 * @param prop
 * @param value
 */

function setHiddenProp(target, prop, value) {
  if (!Object.hasOwnProperty.call(target, prop)) {
    Object.defineProperty(target, prop, {
      enumerable: false,
      configurable: true,
      writable: true,
      value: value
    });
  } else {
    target[prop] = value;
  }
}

function findDOMNode$2(component) {
  if (__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"]) {
    try {
      return Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(component);
    } catch (e) {
      // findDOMNode will throw in react-test-renderer, see:
      // See https://github.com/mobxjs/mobx-react/issues/216
      // Is there a better heuristic?
      return null;
    }
  }

  return null;
}

function reportRendering(component) {
  var node = findDOMNode$2(component);
  if (node && componentByNodeRegistry) componentByNodeRegistry.set(node, component);
  renderReporter.emit({
    event: "render",
    renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
    totalTime: Date.now() - component.__$mobRenderStart,
    component: component,
    node: node
  });
}

function trackComponents() {
  if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
  if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
}
function useStaticRendering(useStaticRendering) {
  isUsingStaticRendering = useStaticRendering;
}
/**
 * Errors reporter
 */

var errorsReporter = new EventEmitter();
/**
 * Utilities
 */

function patch$1(target, funcName) {
  patch(target, funcName, reactiveMixin[funcName]);
}

function shallowEqual(objA, objB) {
  //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
  if (is(objA, objB)) return true;

  if (_typeof(objA) !== "object" || objA === null || _typeof(objB) !== "object" || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

function is(x, y) {
  // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function makeComponentReactive(render) {
  var _this2 = this;

  if (isUsingStaticRendering === true) return render.call(this);

  function reactiveRender() {
    var _this = this;

    isRenderingPending = false;
    var exception = undefined;
    var rendering = undefined;
    reaction.track(function () {
      if (isDevtoolsEnabled) {
        _this.__$mobRenderStart = Date.now();
      }

      try {
        rendering = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["_allowStateChanges"])(false, baseRender);
      } catch (e) {
        exception = e;
      }

      if (isDevtoolsEnabled) {
        _this.__$mobRenderEnd = Date.now();
      }
    });

    if (exception) {
      errorsReporter.emit(exception);
      throw exception;
    }

    return rendering;
  } // Generate friendly name for debugging


  var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
  var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalInstance && this._reactInternalInstance._debugID || this._reactInternalFiber && this._reactInternalFiber._debugID;
  /**
   * If props are shallowly modified, react will render anyway,
   * so atom.reportChanged() should not result in yet another re-render
   */

  setHiddenProp(this, skipRenderKey, false);
  /**
   * forceUpdate will re-assign this.props. We don't want that to cause a loop,
   * so detect these changes
   */

  setHiddenProp(this, isForcingUpdateKey, false); // wire up reactive render

  var baseRender = render.bind(this);
  var isRenderingPending = false;
  var reaction = new __WEBPACK_IMPORTED_MODULE_0_mobx__["Reaction"]("".concat(initialName, "#").concat(rootNodeID, ".render()"), function () {
    if (!isRenderingPending) {
      // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
      // This unidiomatic React usage but React will correctly warn about this so we continue as usual
      // See #85 / Pull #44
      isRenderingPending = true;
      if (typeof _this2.componentWillReact === "function") _this2.componentWillReact(); // TODO: wrap in action?

      if (_this2[mobxIsUnmounted] !== true) {
        // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
        // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
        // However, people also claim this might happen during unit tests..
        var hasError = true;

        try {
          setHiddenProp(_this2, isForcingUpdateKey, true);
          if (!_this2[skipRenderKey]) __WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.forceUpdate.call(_this2);
          hasError = false;
        } finally {
          setHiddenProp(_this2, isForcingUpdateKey, false);
          if (hasError) reaction.dispose();
        }
      }
    }
  });
  reaction.reactComponent = this;
  reactiveRender[mobxAdminProperty] = reaction;
  this.render = reactiveRender;
  return reactiveRender.call(this);
}
/**
 * ReactiveMixin
 */


var reactiveMixin = {
  componentWillUnmount: function componentWillUnmount() {
    if (isUsingStaticRendering === true) return;
    this.render[mobxAdminProperty] && this.render[mobxAdminProperty].dispose();
    this[mobxIsUnmounted] = true;

    if (isDevtoolsEnabled) {
      var node = findDOMNode$2(this);

      if (node && componentByNodeRegistry) {
        componentByNodeRegistry.delete(node);
      }

      renderReporter.emit({
        event: "destroy",
        component: this,
        node: node
      });
    }
  },
  componentDidMount: function componentDidMount() {
    if (isDevtoolsEnabled) {
      reportRendering(this);
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    if (isDevtoolsEnabled) {
      reportRendering(this);
    }
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    if (isUsingStaticRendering) {
      console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
    } // update on any state changes (as is the default)


    if (this.state !== nextState) {
      return true;
    } // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.


    return !shallowEqual(this.props, nextProps);
  }
};

function makeObservableProp(target, propName) {
  var valueHolderKey = newSymbol("reactProp_".concat(propName, "_valueHolder"));
  var atomHolderKey = newSymbol("reactProp_".concat(propName, "_atomHolder"));

  function getAtom() {
    if (!this[atomHolderKey]) {
      setHiddenProp(this, atomHolderKey, Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["createAtom"])("reactive " + propName));
    }

    return this[atomHolderKey];
  }

  Object.defineProperty(target, propName, {
    configurable: true,
    enumerable: true,
    get: function get() {
      getAtom.call(this).reportObserved();
      return this[valueHolderKey];
    },
    set: function set(v) {
      if (!this[isForcingUpdateKey] && !shallowEqual(this[valueHolderKey], v)) {
        setHiddenProp(this, valueHolderKey, v);
        setHiddenProp(this, skipRenderKey, true);
        getAtom.call(this).reportChanged();
        setHiddenProp(this, skipRenderKey, false);
      } else {
        setHiddenProp(this, valueHolderKey, v);
      }
    }
  });
}
/**
 * Observer function / decorator
 */


function observer(arg1, arg2) {
  if (typeof arg1 === "string") {
    throw new Error("Store names should be provided as array");
  }

  if (Array.isArray(arg1)) {
    // TODO: remove in next major
    // component needs stores
    if (!warnedAboutObserverInjectDeprecation) {
      warnedAboutObserverInjectDeprecation = true;
      console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
    }

    if (!arg2) {
      // invoked as decorator
      return function (componentClass) {
        return observer(arg1, componentClass);
      };
    } else {
      return inject.apply(null, arg1)(observer(arg2));
    }
  }

  var componentClass = arg1;

  if (componentClass.isMobxInjector === true) {
    console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
  }

  if (componentClass.__proto__ === __WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]) {
    console.warn("Mobx observer: You are using 'observer' on React.PureComponent. These two achieve two opposite goals and should not be used together");
  } // Unwrap forward refs into `<Observer>` component
  // we need to unwrap the render, because it is the inner render that needs to be tracked,
  // not the ForwardRef HoC


  if (ReactForwardRefSymbol && componentClass["$$typeof"] === ReactForwardRefSymbol) {
    var _baseRender = componentClass.render;
    if (typeof _baseRender !== "function") throw new Error("render property of ForwardRef was not a function"); // TODO: do we need to hoist statics from baseRender to the forward ref?

    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"])(function ObserverForwardRef() {
      var _arguments = arguments;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Observer, null, function () {
        return _baseRender.apply(undefined, _arguments);
      });
    });
  } // Stateless function component:
  // If it is function but doesn't seem to be a react class constructor,
  // wrap it to a react class automatically


  if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !__WEBPACK_IMPORTED_MODULE_1_react__["Component"].isPrototypeOf(componentClass)) {
    var _class, _temp;

    var observerComponent = observer((_temp = _class =
    /*#__PURE__*/
    function (_Component) {
      _inherits(_class, _Component);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
      }

      _createClass(_class, [{
        key: "render",
        value: function render() {
          return componentClass.call(this, this.props, this.context);
        }
      }]);

      return _class;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
    hoistNonReactStatics_cjs(observerComponent, componentClass);
    return observerComponent;
  }

  if (!componentClass) {
    throw new Error("Please pass a valid component to 'observer'");
  }

  var target = componentClass.prototype || componentClass;
  mixinLifecycleEvents(target);
  componentClass.isMobXReactObserver = true;
  makeObservableProp(target, "props");
  makeObservableProp(target, "state");
  var baseRender = target.render;

  target.render = function () {
    return makeComponentReactive.call(this, baseRender);
  };

  return componentClass;
}

function mixinLifecycleEvents(target) {
  ["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
    patch$1(target, funcName);
  });

  if (!target.shouldComponentUpdate) {
    target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
  } else {
    if (target.shouldComponentUpdate !== reactiveMixin.shouldComponentUpdate) {
      // TODO: make throw in next major
      console.warn("Use `shouldComponentUpdate` in an `observer` based component breaks the behavior of `observer` and might lead to unexpected results. Manually implementing `sCU` should not be needed when using mobx-react.");
    }
  }
}

var Observer = observer(function (_ref2) {
  var children = _ref2.children,
      observerInject = _ref2.inject,
      render = _ref2.render;
  var component = children || render;

  if (typeof component === "undefined") {
    return null;
  }

  if (!observerInject) {
    return component();
  } // TODO: remove in next major


  console.warn("<Observer inject=.../> is no longer supported. Please use inject on the enclosing component instead");
  var InjectComponent = inject(observerInject)(component);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InjectComponent, null);
});
Observer.displayName = "Observer";

var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
  var extraKey = key === "children" ? "render" : "children";

  if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
    return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
  }

  if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
    return;
  }

  return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
};

Observer.propTypes = {
  render: ObserverPropsCheck,
  children: ObserverPropsCheck
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component$$1) {
  var prototype = Component$$1.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component$$1.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component$$1;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component$$1.displayName || Component$$1.name;
    var newApiName =
      typeof Component$$1.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component$$1.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component$$1;
}

var specialReactKeys = {
  children: true,
  key: true,
  ref: true
};

var Provider =
/*#__PURE__*/
function (_Component) {
  _inherits(Provider, _Component);

  function Provider(props, context) {
    var _this;

    _classCallCheck(this, Provider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Provider).call(this, props, context));
    _this.state = {};
    copyStores(props, _this.state);
    return _this;
  }

  _createClass(Provider, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      var stores = {}; // inherit stores

      copyStores(this.context.mobxStores, stores); // add own stores

      copyStores(this.props, stores);
      return {
        mobxStores: stores
      };
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (!nextProps) return null;
      if (!prevState) return nextProps; // Maybe this warning is too aggressive?

      if (Object.keys(nextProps).filter(validStoreName).length !== Object.keys(prevState).filter(validStoreName).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
      if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
        if (validStoreName(key) && prevState[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
      }
      return nextProps;
    }
  }]);

  return Provider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Provider.contextTypes = {
  mobxStores: objectOrObservableObject
};
Provider.childContextTypes = {
  mobxStores: objectOrObservableObject.isRequired
};

function copyStores(from, to) {
  if (!from) return;

  for (var key in from) {
    if (validStoreName(key)) to[key] = from[key];
  }
}

function validStoreName(key) {
  return !specialReactKeys[key] && key !== "suppressChangedStoreWarning";
} // TODO: kill in next major


polyfill(Provider);

var storeKey = newSymbol("disposeOnUnmount");

function runDisposersOnWillUnmount() {
  var _this = this;

  if (!this[storeKey]) {
    // when disposeOnUnmount is only set to some instances of a component it will still patch the prototype
    return;
  }

  this[storeKey].forEach(function (propKeyOrFunction) {
    var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;

    if (prop !== undefined && prop !== null) {
      if (typeof prop !== "function") {
        throw new Error("[mobx-react] disposeOnUnmount only works on functions such as disposers returned by reactions, autorun, etc.");
      }

      prop();
    }
  });
  this[storeKey] = [];
}

function disposeOnUnmount(target, propertyKeyOrFunction) {
  if (Array.isArray(propertyKeyOrFunction)) {
    return propertyKeyOrFunction.map(function (fn) {
      return disposeOnUnmount(target, fn);
    });
  }

  if (!target instanceof __WEBPACK_IMPORTED_MODULE_1_react__["Component"]) {
    throw new Error("[mobx-react] disposeOnUnmount only works on class based React components.");
  }

  if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function") {
    throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
  } // add property key / function we want run (disposed) to the store


  var componentWasAlreadyModified = !!target[storeKey];
  var store = target[storeKey] || (target[storeKey] = []);
  store.push(propertyKeyOrFunction); // tweak the component class componentWillUnmount if not done already

  if (!componentWasAlreadyModified) {
    patch(target, "componentWillUnmount", runDisposersOnWillUnmount);
  } // return the disposer as is if invoked as a non decorator


  if (typeof propertyKeyOrFunction !== "string") {
    return propertyKeyOrFunction;
  }
}

if (!__WEBPACK_IMPORTED_MODULE_1_react__["Component"]) throw new Error("mobx-react requires React to be available");
if (!__WEBPACK_IMPORTED_MODULE_0_mobx__["spy"]) throw new Error("mobx-react requires mobx to be available");
if (typeof __WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"] === "function") Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["configure"])({
  reactionScheduler: __WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"]
});
var onError = function onError(fn) {
  return errorsReporter.on(fn);
};

if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
  var mobx = {
    spy: __WEBPACK_IMPORTED_MODULE_0_mobx__["spy"],
    extras: {
      getDebugName: __WEBPACK_IMPORTED_MODULE_0_mobx__["getDebugName"]
    }
  };
  var mobxReact = {
    renderReporter: renderReporter,
    componentByNodeRegistry: componentByNodeRegistry,
    componentByNodeRegistery: componentByNodeRegistry,
    trackComponents: trackComponents
  };

  __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx);
}




/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(752)();
}


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.delay=exports.Num=exports.getNumber=exports.getJson=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.numConvert=numConvert;exports.calculation=calculation;exports.sum=sum;exports.moneyNumber=moneyNumber;exports.isArray=isArray;exports.getDeepMenu=getDeepMenu;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var getJson=exports.getJson=function getJson(arr,obj){var value=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;return arr.reduce(function(a,b){return a&&a[b]?a[b]:value;},obj);};var getNumber=exports.getNumber=function getNumber(arr,obj){var value=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;return Number(arr.reduce(function(a,b){return a&&a[b]?a[b]:value;},obj)||'0');};function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var fixed=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;num=Number(num||"0");if(fixed!==false)return num.toFixed(fixed);return num;};// 除法
function calculation(){var molecule=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var denominator=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var decimal=arguments.length>2&&arguments[2]!==undefined?arguments[2]:2;if(denominator==0||molecule==0||!denominator||!denominator){return 0;}return(molecule/denominator).toFixed(decimal);}// 和
function sum(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var decimal=arguments.length>1&&arguments[1]!==undefined?arguments[1]:2;return data.reduce(function(a,b){a+=numConvert(b);return a;},0).toFixed(decimal);}// 金额格式
function moneyNumber(text){return Number(text||'0')<0?_react2.default.createElement("span",{style:{color:"red"}},"(",Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),")"):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');}function isArray(o){return Object.prototype.toString.call(o)=='[object Array]';}// 拉取权限内的菜单
function getDeepMenu(auth,authData){var data=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];authData.forEach(function(item,index){if(item.children.length>0&&item.children[0].title=='查看'&&auth.includes(item.children[0].key)){data.push(item);}else if(item.children.length>0&&item.children[0].title!='查看'){var child=getDeepMenu(auth,item.children,child);data.push(_extends({},item,{children:child}));}});return data;}exports.default=getJson;var Num=exports.Num=numConvert;var delay=exports.delay=function delay(){var time=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1000;return new Promise(function(resolve){return setTimeout(resolve,time);});};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _imgtopdf=__webpack_require__(128);var _imgtopdf2=_interopRequireDefault(_imgtopdf);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var imgToPdf=_imgtopdf2.default.imgToPdf;var noMonth=['0.00','2.20','2.30','3.50','3.60','4.20','4.50','7.30','7.60','9.90','5.50'];exports.default=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(id){var multiple=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1.5;var sort=arguments[2];var date=arguments.length>3&&arguments[3]!==undefined?arguments[3]:(0,_moment2.default)().format('YYYY-MM');return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:return _context.abrupt('return',new Promise(function(res,rej){imgToPdf(id,multiple).then(function(img){fetch('/getPdf?'+('sort='+sort+'&year='+(0,_moment2.default)(date).format('YYYY')+(!noMonth.includes(sort)?'&month='+(0,_moment2.default)(date).format('MM'):"&month=null")),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){var dataFrom=new FormData();dataFrom.append('img',img.img);dataFrom.append('sort',sort);dataFrom.append('height',img.canvas.height);dataFrom.append('width',img.canvas.width);dataFrom.append('year',(0,_moment2.default)(date).format('YYYY'));dataFrom.append('add_time',(0,_moment2.default)().format('YYYY-MM-DD HH:mm:ss'));if(!noMonth.includes(sort)){dataFrom.append('month',(0,_moment2.default)(date).format('MM'));}if(x.data&&x.data.length>0){dataFrom.append('id',x.data[0].id);}var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/addPdf',headres).then(function(x){return x.json();}).then(function(data){res(data);}).catch(function(err){rej(err);});}).catch(function(err){rej(err);});}).catch(function(err){rej(err);});}));case 1:case'end':return _context.stop();}}},_callee,this);}));function imgSave(_x){return _ref.apply(this,arguments);}return imgSave;}();function dataURItoBlob(dataURI){var byteString=atob(dataURI.split(',')[1]);var mimeString=dataURI.split(',')[0].split(':')[1].split(';')[0];var ab=new ArrayBuffer(byteString.length);var ia=new Uint8Array(ab);for(var i=0;i<byteString.length;i++){ia[i]=byteString.charCodeAt(i);}return new Blob([ab],{type:mimeString});}function blobToDataURL(blob,callback){var a=new FileReader();a.onload=function(e){callback(e.target.result);};a.readAsDataURL(blob);}function delay(time){return new Promise(function(res,rej){var timer=setTimeout(function(){clearTimeout(timer);res();},time);});}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var zrender = __webpack_require__(291);

var zrUtil = __webpack_require__(1);

var colorTool = __webpack_require__(122);

var env = __webpack_require__(67);

var timsort = __webpack_require__(404);

var Eventful = __webpack_require__(173);

var GlobalModel = __webpack_require__(623);

var ExtensionAPI = __webpack_require__(636);

var CoordinateSystemManager = __webpack_require__(108);

var OptionManager = __webpack_require__(1556);

var backwardCompat = __webpack_require__(1557);

var dataStack = __webpack_require__(1559);

var ComponentModel = __webpack_require__(73);

var SeriesModel = __webpack_require__(74);

var ComponentView = __webpack_require__(297);

var ChartView = __webpack_require__(123);

var graphic = __webpack_require__(27);

var modelUtil = __webpack_require__(44);

var _throttle = __webpack_require__(148);

var throttle = _throttle.throttle;

var seriesColor = __webpack_require__(1560);

var aria = __webpack_require__(1561);

var loadingDefault = __webpack_require__(1562);

var Scheduler = __webpack_require__(1563);

var lightTheme = __webpack_require__(1564);

var darkTheme = __webpack_require__(1565);

__webpack_require__(637);

var mapDataStorage = __webpack_require__(413);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var assert = zrUtil.assert;
var each = zrUtil.each;
var isFunction = zrUtil.isFunction;
var isObject = zrUtil.isObject;
var parseClassType = ComponentModel.parseClassType;
var version = '4.9.0';
var dependencies = {
  zrender: '4.3.2'
};
var TEST_FRAME_REMAIN_TIME = 1;
var PRIORITY_PROCESSOR_FILTER = 1000;
var PRIORITY_PROCESSOR_SERIES_FILTER = 800;
var PRIORITY_PROCESSOR_DATASTACK = 900;
var PRIORITY_PROCESSOR_STATISTIC = 5000;
var PRIORITY_VISUAL_LAYOUT = 1000;
var PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
var PRIORITY_VISUAL_GLOBAL = 2000;
var PRIORITY_VISUAL_CHART = 3000;
var PRIORITY_VISUAL_POST_CHART_LAYOUT = 3500;
var PRIORITY_VISUAL_COMPONENT = 4000; // FIXME
// necessary?

var PRIORITY_VISUAL_BRUSH = 5000;
var PRIORITY = {
  PROCESSOR: {
    FILTER: PRIORITY_PROCESSOR_FILTER,
    SERIES_FILTER: PRIORITY_PROCESSOR_SERIES_FILTER,
    STATISTIC: PRIORITY_PROCESSOR_STATISTIC
  },
  VISUAL: {
    LAYOUT: PRIORITY_VISUAL_LAYOUT,
    PROGRESSIVE_LAYOUT: PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
    GLOBAL: PRIORITY_VISUAL_GLOBAL,
    CHART: PRIORITY_VISUAL_CHART,
    POST_CHART_LAYOUT: PRIORITY_VISUAL_POST_CHART_LAYOUT,
    COMPONENT: PRIORITY_VISUAL_COMPONENT,
    BRUSH: PRIORITY_VISUAL_BRUSH
  }
}; // Main process have three entries: `setOption`, `dispatchAction` and `resize`,
// where they must not be invoked nestedly, except the only case: invoke
// dispatchAction with updateMethod "none" in main process.
// This flag is used to carry out this rule.
// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).

var IN_MAIN_PROCESS = '__flagInMainProcess';
var OPTION_UPDATED = '__optionUpdated';
var ACTION_REG = /^[a-zA-Z0-9_]+$/;

function createRegisterEventWithLowercaseName(method, ignoreDisposed) {
  return function (eventName, handler, context) {
    if (!ignoreDisposed && this._disposed) {
      disposedWarning(this.id);
      return;
    } // Event name is all lowercase


    eventName = eventName && eventName.toLowerCase();
    Eventful.prototype[method].call(this, eventName, handler, context);
  };
}
/**
 * @module echarts~MessageCenter
 */


function MessageCenter() {
  Eventful.call(this);
}

MessageCenter.prototype.on = createRegisterEventWithLowercaseName('on', true);
MessageCenter.prototype.off = createRegisterEventWithLowercaseName('off', true);
MessageCenter.prototype.one = createRegisterEventWithLowercaseName('one', true);
zrUtil.mixin(MessageCenter, Eventful);
/**
 * @module echarts~ECharts
 */

function ECharts(dom, theme, opts) {
  opts = opts || {}; // Get theme by name

  if (typeof theme === 'string') {
    theme = themeStorage[theme];
  }
  /**
   * @type {string}
   */


  this.id;
  /**
   * Group id
   * @type {string}
   */

  this.group;
  /**
   * @type {HTMLElement}
   * @private
   */

  this._dom = dom;
  var defaultRenderer = 'canvas';

  /**
   * @type {module:zrender/ZRender}
   * @private
   */
  var zr = this._zr = zrender.init(dom, {
    renderer: opts.renderer || defaultRenderer,
    devicePixelRatio: opts.devicePixelRatio,
    width: opts.width,
    height: opts.height
  });
  /**
   * Expect 60 fps.
   * @type {Function}
   * @private
   */

  this._throttledZrFlush = throttle(zrUtil.bind(zr.flush, zr), 17);
  var theme = zrUtil.clone(theme);
  theme && backwardCompat(theme, true);
  /**
   * @type {Object}
   * @private
   */

  this._theme = theme;
  /**
   * @type {Array.<module:echarts/view/Chart>}
   * @private
   */

  this._chartsViews = [];
  /**
   * @type {Object.<string, module:echarts/view/Chart>}
   * @private
   */

  this._chartsMap = {};
  /**
   * @type {Array.<module:echarts/view/Component>}
   * @private
   */

  this._componentsViews = [];
  /**
   * @type {Object.<string, module:echarts/view/Component>}
   * @private
   */

  this._componentsMap = {};
  /**
   * @type {module:echarts/CoordinateSystem}
   * @private
   */

  this._coordSysMgr = new CoordinateSystemManager();
  /**
   * @type {module:echarts/ExtensionAPI}
   * @private
   */

  var api = this._api = createExtensionAPI(this); // Sort on demand

  function prioritySortFunc(a, b) {
    return a.__prio - b.__prio;
  }

  timsort(visualFuncs, prioritySortFunc);
  timsort(dataProcessorFuncs, prioritySortFunc);
  /**
   * @type {module:echarts/stream/Scheduler}
   */

  this._scheduler = new Scheduler(this, api, dataProcessorFuncs, visualFuncs);
  Eventful.call(this, this._ecEventProcessor = new EventProcessor());
  /**
   * @type {module:echarts~MessageCenter}
   * @private
   */

  this._messageCenter = new MessageCenter(); // Init mouse events

  this._initEvents(); // In case some people write `window.onresize = chart.resize`


  this.resize = zrUtil.bind(this.resize, this); // Can't dispatch action during rendering procedure

  this._pendingActions = [];
  zr.animation.on('frame', this._onframe, this);
  bindRenderedEvent(zr, this); // ECharts instance can be used as value.

  zrUtil.setAsPrimitive(this);
}

var echartsProto = ECharts.prototype;

echartsProto._onframe = function () {
  if (this._disposed) {
    return;
  }

  var scheduler = this._scheduler; // Lazy update

  if (this[OPTION_UPDATED]) {
    var silent = this[OPTION_UPDATED].silent;
    this[IN_MAIN_PROCESS] = true;
    prepare(this);
    updateMethods.update.call(this);
    this[IN_MAIN_PROCESS] = false;
    this[OPTION_UPDATED] = false;
    flushPendingActions.call(this, silent);
    triggerUpdatedEvent.call(this, silent);
  } // Avoid do both lazy update and progress in one frame.
  else if (scheduler.unfinished) {
      // Stream progress.
      var remainTime = TEST_FRAME_REMAIN_TIME;
      var ecModel = this._model;
      var api = this._api;
      scheduler.unfinished = false;

      do {
        var startTime = +new Date();
        scheduler.performSeriesTasks(ecModel); // Currently dataProcessorFuncs do not check threshold.

        scheduler.performDataProcessorTasks(ecModel);
        updateStreamModes(this, ecModel); // Do not update coordinate system here. Because that coord system update in
        // each frame is not a good user experience. So we follow the rule that
        // the extent of the coordinate system is determin in the first frame (the
        // frame is executed immedietely after task reset.
        // this._coordSysMgr.update(ecModel, api);
        // console.log('--- ec frame visual ---', remainTime);

        scheduler.performVisualTasks(ecModel);
        renderSeries(this, this._model, api, 'remain');
        remainTime -= +new Date() - startTime;
      } while (remainTime > 0 && scheduler.unfinished); // Call flush explicitly for trigger finished event.


      if (!scheduler.unfinished) {
        this._zr.flush();
      } // Else, zr flushing be ensue within the same frame,
      // because zr flushing is after onframe event.

    }
};
/**
 * @return {HTMLElement}
 */


echartsProto.getDom = function () {
  return this._dom;
};
/**
 * @return {module:zrender~ZRender}
 */


echartsProto.getZr = function () {
  return this._zr;
};
/**
 * Usage:
 * chart.setOption(option, notMerge, lazyUpdate);
 * chart.setOption(option, {
 *     notMerge: ...,
 *     lazyUpdate: ...,
 *     silent: ...
 * });
 *
 * @param {Object} option
 * @param {Object|boolean} [opts] opts or notMerge.
 * @param {boolean} [opts.notMerge=false]
 * @param {boolean} [opts.lazyUpdate=false] Useful when setOption frequently.
 */


echartsProto.setOption = function (option, notMerge, lazyUpdate) {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  var silent;

  if (isObject(notMerge)) {
    lazyUpdate = notMerge.lazyUpdate;
    silent = notMerge.silent;
    notMerge = notMerge.notMerge;
  }

  this[IN_MAIN_PROCESS] = true;

  if (!this._model || notMerge) {
    var optionManager = new OptionManager(this._api);
    var theme = this._theme;
    var ecModel = this._model = new GlobalModel();
    ecModel.scheduler = this._scheduler;
    ecModel.init(null, null, theme, optionManager);
  }

  this._model.setOption(option, optionPreprocessorFuncs);

  if (lazyUpdate) {
    this[OPTION_UPDATED] = {
      silent: silent
    };
    this[IN_MAIN_PROCESS] = false;
  } else {
    prepare(this);
    updateMethods.update.call(this); // Ensure zr refresh sychronously, and then pixel in canvas can be
    // fetched after `setOption`.

    this._zr.flush();

    this[OPTION_UPDATED] = false;
    this[IN_MAIN_PROCESS] = false;
    flushPendingActions.call(this, silent);
    triggerUpdatedEvent.call(this, silent);
  }
};
/**
 * @DEPRECATED
 */


echartsProto.setTheme = function () {
  console.error('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
};
/**
 * @return {module:echarts/model/Global}
 */


echartsProto.getModel = function () {
  return this._model;
};
/**
 * @return {Object}
 */


echartsProto.getOption = function () {
  return this._model && this._model.getOption();
};
/**
 * @return {number}
 */


echartsProto.getWidth = function () {
  return this._zr.getWidth();
};
/**
 * @return {number}
 */


echartsProto.getHeight = function () {
  return this._zr.getHeight();
};
/**
 * @return {number}
 */


echartsProto.getDevicePixelRatio = function () {
  return this._zr.painter.dpr || window.devicePixelRatio || 1;
};
/**
 * Get canvas which has all thing rendered
 * @param {Object} opts
 * @param {string} [opts.backgroundColor]
 * @return {string}
 */


echartsProto.getRenderedCanvas = function (opts) {
  if (!env.canvasSupported) {
    return;
  }

  opts = opts || {};
  opts.pixelRatio = opts.pixelRatio || 1;
  opts.backgroundColor = opts.backgroundColor || this._model.get('backgroundColor');
  var zr = this._zr; // var list = zr.storage.getDisplayList();
  // Stop animations
  // Never works before in init animation, so remove it.
  // zrUtil.each(list, function (el) {
  //     el.stopAnimation(true);
  // });

  return zr.painter.getRenderedCanvas(opts);
};
/**
 * Get svg data url
 * @return {string}
 */


echartsProto.getSvgDataURL = function () {
  if (!env.svgSupported) {
    return;
  }

  var zr = this._zr;
  var list = zr.storage.getDisplayList(); // Stop animations

  zrUtil.each(list, function (el) {
    el.stopAnimation(true);
  });
  return zr.painter.toDataURL();
};
/**
 * @return {string}
 * @param {Object} opts
 * @param {string} [opts.type='png']
 * @param {string} [opts.pixelRatio=1]
 * @param {string} [opts.backgroundColor]
 * @param {string} [opts.excludeComponents]
 */


echartsProto.getDataURL = function (opts) {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  opts = opts || {};
  var excludeComponents = opts.excludeComponents;
  var ecModel = this._model;
  var excludesComponentViews = [];
  var self = this;
  each(excludeComponents, function (componentType) {
    ecModel.eachComponent({
      mainType: componentType
    }, function (component) {
      var view = self._componentsMap[component.__viewId];

      if (!view.group.ignore) {
        excludesComponentViews.push(view);
        view.group.ignore = true;
      }
    });
  });
  var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataURL() : this.getRenderedCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
  each(excludesComponentViews, function (view) {
    view.group.ignore = false;
  });
  return url;
};
/**
 * @return {string}
 * @param {Object} opts
 * @param {string} [opts.type='png']
 * @param {string} [opts.pixelRatio=1]
 * @param {string} [opts.backgroundColor]
 */


echartsProto.getConnectedDataURL = function (opts) {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  if (!env.canvasSupported) {
    return;
  }

  var isSvg = opts.type === 'svg';
  var groupId = this.group;
  var mathMin = Math.min;
  var mathMax = Math.max;
  var MAX_NUMBER = Infinity;

  if (connectedGroups[groupId]) {
    var left = MAX_NUMBER;
    var top = MAX_NUMBER;
    var right = -MAX_NUMBER;
    var bottom = -MAX_NUMBER;
    var canvasList = [];
    var dpr = opts && opts.pixelRatio || 1;
    zrUtil.each(instances, function (chart, id) {
      if (chart.group === groupId) {
        var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.getRenderedCanvas(zrUtil.clone(opts));
        var boundingRect = chart.getDom().getBoundingClientRect();
        left = mathMin(boundingRect.left, left);
        top = mathMin(boundingRect.top, top);
        right = mathMax(boundingRect.right, right);
        bottom = mathMax(boundingRect.bottom, bottom);
        canvasList.push({
          dom: canvas,
          left: boundingRect.left,
          top: boundingRect.top
        });
      }
    });
    left *= dpr;
    top *= dpr;
    right *= dpr;
    bottom *= dpr;
    var width = right - left;
    var height = bottom - top;
    var targetCanvas = zrUtil.createCanvas();
    var zr = zrender.init(targetCanvas, {
      renderer: isSvg ? 'svg' : 'canvas'
    });
    zr.resize({
      width: width,
      height: height
    });

    if (isSvg) {
      var content = '';
      each(canvasList, function (item) {
        var x = item.left - left;
        var y = item.top - top;
        content += '<g transform="translate(' + x + ',' + y + ')">' + item.dom + '</g>';
      });
      zr.painter.getSvgRoot().innerHTML = content;

      if (opts.connectedBackgroundColor) {
        zr.painter.setBackgroundColor(opts.connectedBackgroundColor);
      }

      zr.refreshImmediately();
      return zr.painter.toDataURL();
    } else {
      // Background between the charts
      if (opts.connectedBackgroundColor) {
        zr.add(new graphic.Rect({
          shape: {
            x: 0,
            y: 0,
            width: width,
            height: height
          },
          style: {
            fill: opts.connectedBackgroundColor
          }
        }));
      }

      each(canvasList, function (item) {
        var img = new graphic.Image({
          style: {
            x: item.left * dpr - left,
            y: item.top * dpr - top,
            image: item.dom
          }
        });
        zr.add(img);
      });
      zr.refreshImmediately();
      return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
    }
  } else {
    return this.getDataURL(opts);
  }
};
/**
 * Convert from logical coordinate system to pixel coordinate system.
 * See CoordinateSystem#convertToPixel.
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            geoIndex / geoId, geoName,
 *            bmapIndex / bmapId / bmapName,
 *            xAxisIndex / xAxisId / xAxisName,
 *            yAxisIndex / yAxisId / yAxisName,
 *            gridIndex / gridId / gridName,
 *            ... (can be extended)
 *        }
 * @param {Array|number} value
 * @return {Array|number} result
 */


echartsProto.convertToPixel = zrUtil.curry(doConvertPixel, 'convertToPixel');
/**
 * Convert from pixel coordinate system to logical coordinate system.
 * See CoordinateSystem#convertFromPixel.
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            geoIndex / geoId / geoName,
 *            bmapIndex / bmapId / bmapName,
 *            xAxisIndex / xAxisId / xAxisName,
 *            yAxisIndex / yAxisId / yAxisName
 *            gridIndex / gridId / gridName,
 *            ... (can be extended)
 *        }
 * @param {Array|number} value
 * @return {Array|number} result
 */

echartsProto.convertFromPixel = zrUtil.curry(doConvertPixel, 'convertFromPixel');

function doConvertPixel(methodName, finder, value) {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  var ecModel = this._model;

  var coordSysList = this._coordSysMgr.getCoordinateSystems();

  var result;
  finder = modelUtil.parseFinder(ecModel, finder);

  for (var i = 0; i < coordSysList.length; i++) {
    var coordSys = coordSysList[i];

    if (coordSys[methodName] && (result = coordSys[methodName](ecModel, finder, value)) != null) {
      return result;
    }
  }
}
/**
 * Is the specified coordinate systems or components contain the given pixel point.
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            geoIndex / geoId / geoName,
 *            bmapIndex / bmapId / bmapName,
 *            xAxisIndex / xAxisId / xAxisName,
 *            yAxisIndex / yAxisId / yAxisName,
 *            gridIndex / gridId / gridName,
 *            ... (can be extended)
 *        }
 * @param {Array|number} value
 * @return {boolean} result
 */


echartsProto.containPixel = function (finder, value) {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  var ecModel = this._model;
  var result;
  finder = modelUtil.parseFinder(ecModel, finder);
  zrUtil.each(finder, function (models, key) {
    key.indexOf('Models') >= 0 && zrUtil.each(models, function (model) {
      var coordSys = model.coordinateSystem;

      if (coordSys && coordSys.containPoint) {
        result |= !!coordSys.containPoint(value);
      } else if (key === 'seriesModels') {
        var view = this._chartsMap[model.__viewId];

        if (view && view.containPoint) {
          result |= view.containPoint(value, model);
        } else {}
      } else {}
    }, this);
  }, this);
  return !!result;
};
/**
 * Get visual from series or data.
 * @param {string|Object} finder
 *        If string, e.g., 'series', means {seriesIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            dataIndex / dataIndexInside
 *        }
 *        If dataIndex is not specified, series visual will be fetched,
 *        but not data item visual.
 *        If all of seriesIndex, seriesId, seriesName are not specified,
 *        visual will be fetched from first series.
 * @param {string} visualType 'color', 'symbol', 'symbolSize'
 */


echartsProto.getVisual = function (finder, visualType) {
  var ecModel = this._model;
  finder = modelUtil.parseFinder(ecModel, finder, {
    defaultMainType: 'series'
  });
  var seriesModel = finder.seriesModel;
  var data = seriesModel.getData();
  var dataIndexInside = finder.hasOwnProperty('dataIndexInside') ? finder.dataIndexInside : finder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(finder.dataIndex) : null;
  return dataIndexInside != null ? data.getItemVisual(dataIndexInside, visualType) : data.getVisual(visualType);
};
/**
 * Get view of corresponding component model
 * @param  {module:echarts/model/Component} componentModel
 * @return {module:echarts/view/Component}
 */


echartsProto.getViewOfComponentModel = function (componentModel) {
  return this._componentsMap[componentModel.__viewId];
};
/**
 * Get view of corresponding series model
 * @param  {module:echarts/model/Series} seriesModel
 * @return {module:echarts/view/Chart}
 */


echartsProto.getViewOfSeriesModel = function (seriesModel) {
  return this._chartsMap[seriesModel.__viewId];
};

var updateMethods = {
  prepareAndUpdate: function (payload) {
    prepare(this);
    updateMethods.update.call(this, payload);
  },

  /**
   * @param {Object} payload
   * @private
   */
  update: function (payload) {
    // console.profile && console.profile('update');
    var ecModel = this._model;
    var api = this._api;
    var zr = this._zr;
    var coordSysMgr = this._coordSysMgr;
    var scheduler = this._scheduler; // update before setOption

    if (!ecModel) {
      return;
    }

    scheduler.restoreData(ecModel, payload);
    scheduler.performSeriesTasks(ecModel); // TODO
    // Save total ecModel here for undo/redo (after restoring data and before processing data).
    // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
    // Create new coordinate system each update
    // In LineView may save the old coordinate system and use it to get the orignal point

    coordSysMgr.create(ecModel, api);
    scheduler.performDataProcessorTasks(ecModel, payload); // Current stream render is not supported in data process. So we can update
    // stream modes after data processing, where the filtered data is used to
    // deteming whether use progressive rendering.

    updateStreamModes(this, ecModel); // We update stream modes before coordinate system updated, then the modes info
    // can be fetched when coord sys updating (consider the barGrid extent fix). But
    // the drawback is the full coord info can not be fetched. Fortunately this full
    // coord is not requied in stream mode updater currently.

    coordSysMgr.update(ecModel, api);
    clearColorPalette(ecModel);
    scheduler.performVisualTasks(ecModel, payload);
    render(this, ecModel, api, payload); // Set background

    var backgroundColor = ecModel.get('backgroundColor') || 'transparent'; // In IE8

    if (!env.canvasSupported) {
      var colorArr = colorTool.parse(backgroundColor);
      backgroundColor = colorTool.stringify(colorArr, 'rgb');

      if (colorArr[3] === 0) {
        backgroundColor = 'transparent';
      }
    } else {
      zr.setBackgroundColor(backgroundColor);
    }

    performPostUpdateFuncs(ecModel, api); // console.profile && console.profileEnd('update');
  },

  /**
   * @param {Object} payload
   * @private
   */
  updateTransform: function (payload) {
    var ecModel = this._model;
    var ecIns = this;
    var api = this._api; // update before setOption

    if (!ecModel) {
      return;
    } // ChartView.markUpdateMethod(payload, 'updateTransform');


    var componentDirtyList = [];
    ecModel.eachComponent(function (componentType, componentModel) {
      var componentView = ecIns.getViewOfComponentModel(componentModel);

      if (componentView && componentView.__alive) {
        if (componentView.updateTransform) {
          var result = componentView.updateTransform(componentModel, ecModel, api, payload);
          result && result.update && componentDirtyList.push(componentView);
        } else {
          componentDirtyList.push(componentView);
        }
      }
    });
    var seriesDirtyMap = zrUtil.createHashMap();
    ecModel.eachSeries(function (seriesModel) {
      var chartView = ecIns._chartsMap[seriesModel.__viewId];

      if (chartView.updateTransform) {
        var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
        result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
      } else {
        seriesDirtyMap.set(seriesModel.uid, 1);
      }
    });
    clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
    // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);

    this._scheduler.performVisualTasks(ecModel, payload, {
      setDirty: true,
      dirtyMap: seriesDirtyMap
    }); // Currently, not call render of components. Geo render cost a lot.
    // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);


    renderSeries(ecIns, ecModel, api, payload, seriesDirtyMap);
    performPostUpdateFuncs(ecModel, this._api);
  },

  /**
   * @param {Object} payload
   * @private
   */
  updateView: function (payload) {
    var ecModel = this._model; // update before setOption

    if (!ecModel) {
      return;
    }

    ChartView.markUpdateMethod(payload, 'updateView');
    clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.

    this._scheduler.performVisualTasks(ecModel, payload, {
      setDirty: true
    });

    render(this, this._model, this._api, payload);
    performPostUpdateFuncs(ecModel, this._api);
  },

  /**
   * @param {Object} payload
   * @private
   */
  updateVisual: function (payload) {
    updateMethods.update.call(this, payload); // var ecModel = this._model;
    // // update before setOption
    // if (!ecModel) {
    //     return;
    // }
    // ChartView.markUpdateMethod(payload, 'updateVisual');
    // clearColorPalette(ecModel);
    // // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
    // this._scheduler.performVisualTasks(ecModel, payload, {visualType: 'visual', setDirty: true});
    // render(this, this._model, this._api, payload);
    // performPostUpdateFuncs(ecModel, this._api);
  },

  /**
   * @param {Object} payload
   * @private
   */
  updateLayout: function (payload) {
    updateMethods.update.call(this, payload); // var ecModel = this._model;
    // // update before setOption
    // if (!ecModel) {
    //     return;
    // }
    // ChartView.markUpdateMethod(payload, 'updateLayout');
    // // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
    // // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
    // this._scheduler.performVisualTasks(ecModel, payload, {setDirty: true});
    // render(this, this._model, this._api, payload);
    // performPostUpdateFuncs(ecModel, this._api);
  }
};

function prepare(ecIns) {
  var ecModel = ecIns._model;
  var scheduler = ecIns._scheduler;
  scheduler.restorePipelines(ecModel);
  scheduler.prepareStageTasks();
  prepareView(ecIns, 'component', ecModel, scheduler);
  prepareView(ecIns, 'chart', ecModel, scheduler);
  scheduler.plan();
}
/**
 * @private
 */


function updateDirectly(ecIns, method, payload, mainType, subType) {
  var ecModel = ecIns._model; // broadcast

  if (!mainType) {
    // FIXME
    // Chart will not be update directly here, except set dirty.
    // But there is no such scenario now.
    each(ecIns._componentsViews.concat(ecIns._chartsViews), callView);
    return;
  }

  var query = {};
  query[mainType + 'Id'] = payload[mainType + 'Id'];
  query[mainType + 'Index'] = payload[mainType + 'Index'];
  query[mainType + 'Name'] = payload[mainType + 'Name'];
  var condition = {
    mainType: mainType,
    query: query
  };
  subType && (condition.subType = subType); // subType may be '' by parseClassType;

  var excludeSeriesId = payload.excludeSeriesId;

  if (excludeSeriesId != null) {
    excludeSeriesId = zrUtil.createHashMap(modelUtil.normalizeToArray(excludeSeriesId));
  } // If dispatchAction before setOption, do nothing.


  ecModel && ecModel.eachComponent(condition, function (model) {
    if (!excludeSeriesId || excludeSeriesId.get(model.id) == null) {
      callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
    }
  }, ecIns);

  function callView(view) {
    view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
  }
}
/**
 * Resize the chart
 * @param {Object} opts
 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
 * @param {boolean} [opts.silent=false]
 */


echartsProto.resize = function (opts) {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  this._zr.resize(opts);

  var ecModel = this._model; // Resize loading effect

  this._loadingFX && this._loadingFX.resize();

  if (!ecModel) {
    return;
  }

  var optionChanged = ecModel.resetOption('media');
  var silent = opts && opts.silent;
  this[IN_MAIN_PROCESS] = true;
  optionChanged && prepare(this);
  updateMethods.update.call(this);
  this[IN_MAIN_PROCESS] = false;
  flushPendingActions.call(this, silent);
  triggerUpdatedEvent.call(this, silent);
};

function updateStreamModes(ecIns, ecModel) {
  var chartsMap = ecIns._chartsMap;
  var scheduler = ecIns._scheduler;
  ecModel.eachSeries(function (seriesModel) {
    scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
  });
}
/**
 * Show loading effect
 * @param  {string} [name='default']
 * @param  {Object} [cfg]
 */


echartsProto.showLoading = function (name, cfg) {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  if (isObject(name)) {
    cfg = name;
    name = '';
  }

  name = name || 'default';
  this.hideLoading();

  if (!loadingEffects[name]) {
    return;
  }

  var el = loadingEffects[name](this._api, cfg);
  var zr = this._zr;
  this._loadingFX = el;
  zr.add(el);
};
/**
 * Hide loading effect
 */


echartsProto.hideLoading = function () {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  this._loadingFX && this._zr.remove(this._loadingFX);
  this._loadingFX = null;
};
/**
 * @param {Object} eventObj
 * @return {Object}
 */


echartsProto.makeActionFromEvent = function (eventObj) {
  var payload = zrUtil.extend({}, eventObj);
  payload.type = eventActionMap[eventObj.type];
  return payload;
};
/**
 * @pubilc
 * @param {Object} payload
 * @param {string} [payload.type] Action type
 * @param {Object|boolean} [opt] If pass boolean, means opt.silent
 * @param {boolean} [opt.silent=false] Whether trigger events.
 * @param {boolean} [opt.flush=undefined]
 *                  true: Flush immediately, and then pixel in canvas can be fetched
 *                      immediately. Caution: it might affect performance.
 *                  false: Not flush.
 *                  undefined: Auto decide whether perform flush.
 */


echartsProto.dispatchAction = function (payload, opt) {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  if (!isObject(opt)) {
    opt = {
      silent: !!opt
    };
  }

  if (!actions[payload.type]) {
    return;
  } // Avoid dispatch action before setOption. Especially in `connect`.


  if (!this._model) {
    return;
  } // May dispatchAction in rendering procedure


  if (this[IN_MAIN_PROCESS]) {
    this._pendingActions.push(payload);

    return;
  }

  doDispatchAction.call(this, payload, opt.silent);

  if (opt.flush) {
    this._zr.flush(true);
  } else if (opt.flush !== false && env.browser.weChat) {
    // In WeChat embeded browser, `requestAnimationFrame` and `setInterval`
    // hang when sliding page (on touch event), which cause that zr does not
    // refresh util user interaction finished, which is not expected.
    // But `dispatchAction` may be called too frequently when pan on touch
    // screen, which impacts performance if do not throttle them.
    this._throttledZrFlush();
  }

  flushPendingActions.call(this, opt.silent);
  triggerUpdatedEvent.call(this, opt.silent);
};

function doDispatchAction(payload, silent) {
  var payloadType = payload.type;
  var escapeConnect = payload.escapeConnect;
  var actionWrap = actions[payloadType];
  var actionInfo = actionWrap.actionInfo;
  var cptType = (actionInfo.update || 'update').split(':');
  var updateMethod = cptType.pop();
  cptType = cptType[0] != null && parseClassType(cptType[0]);
  this[IN_MAIN_PROCESS] = true;
  var payloads = [payload];
  var batched = false; // Batch action

  if (payload.batch) {
    batched = true;
    payloads = zrUtil.map(payload.batch, function (item) {
      item = zrUtil.defaults(zrUtil.extend({}, item), payload);
      item.batch = null;
      return item;
    });
  }

  var eventObjBatch = [];
  var eventObj;
  var isHighDown = payloadType === 'highlight' || payloadType === 'downplay';
  each(payloads, function (batchItem) {
    // Action can specify the event by return it.
    eventObj = actionWrap.action(batchItem, this._model, this._api); // Emit event outside

    eventObj = eventObj || zrUtil.extend({}, batchItem); // Convert type to eventType

    eventObj.type = actionInfo.event || eventObj.type;
    eventObjBatch.push(eventObj); // light update does not perform data process, layout and visual.

    if (isHighDown) {
      // method, payload, mainType, subType
      updateDirectly(this, updateMethod, batchItem, 'series');
    } else if (cptType) {
      updateDirectly(this, updateMethod, batchItem, cptType.main, cptType.sub);
    }
  }, this);

  if (updateMethod !== 'none' && !isHighDown && !cptType) {
    // Still dirty
    if (this[OPTION_UPDATED]) {
      // FIXME Pass payload ?
      prepare(this);
      updateMethods.update.call(this, payload);
      this[OPTION_UPDATED] = false;
    } else {
      updateMethods[updateMethod].call(this, payload);
    }
  } // Follow the rule of action batch


  if (batched) {
    eventObj = {
      type: actionInfo.event || payloadType,
      escapeConnect: escapeConnect,
      batch: eventObjBatch
    };
  } else {
    eventObj = eventObjBatch[0];
  }

  this[IN_MAIN_PROCESS] = false;
  !silent && this._messageCenter.trigger(eventObj.type, eventObj);
}

function flushPendingActions(silent) {
  var pendingActions = this._pendingActions;

  while (pendingActions.length) {
    var payload = pendingActions.shift();
    doDispatchAction.call(this, payload, silent);
  }
}

function triggerUpdatedEvent(silent) {
  !silent && this.trigger('updated');
}
/**
 * Event `rendered` is triggered when zr
 * rendered. It is useful for realtime
 * snapshot (reflect animation).
 *
 * Event `finished` is triggered when:
 * (1) zrender rendering finished.
 * (2) initial animation finished.
 * (3) progressive rendering finished.
 * (4) no pending action.
 * (5) no delayed setOption needs to be processed.
 */


function bindRenderedEvent(zr, ecIns) {
  zr.on('rendered', function () {
    ecIns.trigger('rendered'); // The `finished` event should not be triggered repeatly,
    // so it should only be triggered when rendering indeed happend
    // in zrender. (Consider the case that dipatchAction is keep
    // triggering when mouse move).

    if ( // Although zr is dirty if initial animation is not finished
    // and this checking is called on frame, we also check
    // animation finished for robustness.
    zr.animation.isFinished() && !ecIns[OPTION_UPDATED] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) {
      ecIns.trigger('finished');
    }
  });
}
/**
 * @param {Object} params
 * @param {number} params.seriesIndex
 * @param {Array|TypedArray} params.data
 */


echartsProto.appendData = function (params) {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  var seriesIndex = params.seriesIndex;
  var ecModel = this.getModel();
  var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
  seriesModel.appendData(params); // Note: `appendData` does not support that update extent of coordinate
  // system, util some scenario require that. In the expected usage of
  // `appendData`, the initial extent of coordinate system should better
  // be fixed by axis `min`/`max` setting or initial data, otherwise if
  // the extent changed while `appendData`, the location of the painted
  // graphic elements have to be changed, which make the usage of
  // `appendData` meaningless.

  this._scheduler.unfinished = true;
};
/**
 * Register event
 * @method
 */


echartsProto.on = createRegisterEventWithLowercaseName('on', false);
echartsProto.off = createRegisterEventWithLowercaseName('off', false);
echartsProto.one = createRegisterEventWithLowercaseName('one', false);
/**
 * Prepare view instances of charts and components
 * @param  {module:echarts/model/Global} ecModel
 * @private
 */

function prepareView(ecIns, type, ecModel, scheduler) {
  var isComponent = type === 'component';
  var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
  var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
  var zr = ecIns._zr;
  var api = ecIns._api;

  for (var i = 0; i < viewList.length; i++) {
    viewList[i].__alive = false;
  }

  isComponent ? ecModel.eachComponent(function (componentType, model) {
    componentType !== 'series' && doPrepare(model);
  }) : ecModel.eachSeries(doPrepare);

  function doPrepare(model) {
    // Consider: id same and type changed.
    var viewId = '_ec_' + model.id + '_' + model.type;
    var view = viewMap[viewId];

    if (!view) {
      var classType = parseClassType(model.type);
      var Clazz = isComponent ? ComponentView.getClass(classType.main, classType.sub) : ChartView.getClass(classType.sub);
      view = new Clazz();
      view.init(ecModel, api);
      viewMap[viewId] = view;
      viewList.push(view);
      zr.add(view.group);
    }

    model.__viewId = view.__id = viewId;
    view.__alive = true;
    view.__model = model;
    view.group.__ecComponentInfo = {
      mainType: model.mainType,
      index: model.componentIndex
    };
    !isComponent && scheduler.prepareView(view, model, ecModel, api);
  }

  for (var i = 0; i < viewList.length;) {
    var view = viewList[i];

    if (!view.__alive) {
      !isComponent && view.renderTask.dispose();
      zr.remove(view.group);
      view.dispose(ecModel, api);
      viewList.splice(i, 1);
      delete viewMap[view.__id];
      view.__id = view.group.__ecComponentInfo = null;
    } else {
      i++;
    }
  }
} // /**
//  * Encode visual infomation from data after data processing
//  *
//  * @param {module:echarts/model/Global} ecModel
//  * @param {object} layout
//  * @param {boolean} [layoutFilter] `true`: only layout,
//  *                                 `false`: only not layout,
//  *                                 `null`/`undefined`: all.
//  * @param {string} taskBaseTag
//  * @private
//  */
// function startVisualEncoding(ecIns, ecModel, api, payload, layoutFilter) {
//     each(visualFuncs, function (visual, index) {
//         var isLayout = visual.isLayout;
//         if (layoutFilter == null
//             || (layoutFilter === false && !isLayout)
//             || (layoutFilter === true && isLayout)
//         ) {
//             visual.func(ecModel, api, payload);
//         }
//     });
// }


function clearColorPalette(ecModel) {
  ecModel.clearColorPalette();
  ecModel.eachSeries(function (seriesModel) {
    seriesModel.clearColorPalette();
  });
}

function render(ecIns, ecModel, api, payload) {
  renderComponents(ecIns, ecModel, api, payload);
  each(ecIns._chartsViews, function (chart) {
    chart.__alive = false;
  });
  renderSeries(ecIns, ecModel, api, payload); // Remove groups of unrendered charts

  each(ecIns._chartsViews, function (chart) {
    if (!chart.__alive) {
      chart.remove(ecModel, api);
    }
  });
}

function renderComponents(ecIns, ecModel, api, payload, dirtyList) {
  each(dirtyList || ecIns._componentsViews, function (componentView) {
    var componentModel = componentView.__model;
    componentView.render(componentModel, ecModel, api, payload);
    updateZ(componentModel, componentView);
  });
}
/**
 * Render each chart and component
 * @private
 */


function renderSeries(ecIns, ecModel, api, payload, dirtyMap) {
  // Render all charts
  var scheduler = ecIns._scheduler;
  var unfinished;
  ecModel.eachSeries(function (seriesModel) {
    var chartView = ecIns._chartsMap[seriesModel.__viewId];
    chartView.__alive = true;
    var renderTask = chartView.renderTask;
    scheduler.updatePayload(renderTask, payload);

    if (dirtyMap && dirtyMap.get(seriesModel.uid)) {
      renderTask.dirty();
    }

    unfinished |= renderTask.perform(scheduler.getPerformArgs(renderTask));
    chartView.group.silent = !!seriesModel.get('silent');
    updateZ(seriesModel, chartView);
    updateBlend(seriesModel, chartView);
  });
  scheduler.unfinished |= unfinished; // If use hover layer

  updateHoverLayerStatus(ecIns, ecModel); // Add aria

  aria(ecIns._zr.dom, ecModel);
}

function performPostUpdateFuncs(ecModel, api) {
  each(postUpdateFuncs, function (func) {
    func(ecModel, api);
  });
}

var MOUSE_EVENT_NAMES = ['click', 'dblclick', 'mouseover', 'mouseout', 'mousemove', 'mousedown', 'mouseup', 'globalout', 'contextmenu'];
/**
 * @private
 */

echartsProto._initEvents = function () {
  each(MOUSE_EVENT_NAMES, function (eveName) {
    var handler = function (e) {
      var ecModel = this.getModel();
      var el = e.target;
      var params;
      var isGlobalOut = eveName === 'globalout'; // no e.target when 'globalout'.

      if (isGlobalOut) {
        params = {};
      } else if (el && el.dataIndex != null) {
        var dataModel = el.dataModel || ecModel.getSeriesByIndex(el.seriesIndex);
        params = dataModel && dataModel.getDataParams(el.dataIndex, el.dataType, el) || {};
      } // If element has custom eventData of components
      else if (el && el.eventData) {
          params = zrUtil.extend({}, el.eventData);
        } // Contract: if params prepared in mouse event,
      // these properties must be specified:
      // {
      //    componentType: string (component main type)
      //    componentIndex: number
      // }
      // Otherwise event query can not work.


      if (params) {
        var componentType = params.componentType;
        var componentIndex = params.componentIndex; // Special handling for historic reason: when trigger by
        // markLine/markPoint/markArea, the componentType is
        // 'markLine'/'markPoint'/'markArea', but we should better
        // enable them to be queried by seriesIndex, since their
        // option is set in each series.

        if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
          componentType = 'series';
          componentIndex = params.seriesIndex;
        }

        var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
        var view = model && this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];
        params.event = e;
        params.type = eveName;
        this._ecEventProcessor.eventInfo = {
          targetEl: el,
          packedEvent: params,
          model: model,
          view: view
        };
        this.trigger(eveName, params);
      }
    }; // Consider that some component (like tooltip, brush, ...)
    // register zr event handler, but user event handler might
    // do anything, such as call `setOption` or `dispatchAction`,
    // which probably update any of the content and probably
    // cause problem if it is called previous other inner handlers.


    handler.zrEventfulCallAtLast = true;

    this._zr.on(eveName, handler, this);
  }, this);
  each(eventActionMap, function (actionType, eventType) {
    this._messageCenter.on(eventType, function (event) {
      this.trigger(eventType, event);
    }, this);
  }, this);
};
/**
 * @return {boolean}
 */


echartsProto.isDisposed = function () {
  return this._disposed;
};
/**
 * Clear
 */


echartsProto.clear = function () {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  this.setOption({
    series: []
  }, true);
};
/**
 * Dispose instance
 */


echartsProto.dispose = function () {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  this._disposed = true;
  modelUtil.setAttribute(this.getDom(), DOM_ATTRIBUTE_KEY, '');
  var api = this._api;
  var ecModel = this._model;
  each(this._componentsViews, function (component) {
    component.dispose(ecModel, api);
  });
  each(this._chartsViews, function (chart) {
    chart.dispose(ecModel, api);
  }); // Dispose after all views disposed

  this._zr.dispose();

  delete instances[this.id];
};

zrUtil.mixin(ECharts, Eventful);

function disposedWarning(id) {}

function updateHoverLayerStatus(ecIns, ecModel) {
  var zr = ecIns._zr;
  var storage = zr.storage;
  var elCount = 0;
  storage.traverse(function (el) {
    elCount++;
  });

  if (elCount > ecModel.get('hoverLayerThreshold') && !env.node) {
    ecModel.eachSeries(function (seriesModel) {
      if (seriesModel.preventUsingHoverLayer) {
        return;
      }

      var chartView = ecIns._chartsMap[seriesModel.__viewId];

      if (chartView.__alive) {
        chartView.group.traverse(function (el) {
          // Don't switch back.
          el.useHoverLayer = true;
        });
      }
    });
  }
}
/**
 * Update chart progressive and blend.
 * @param {module:echarts/model/Series|module:echarts/model/Component} model
 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
 */


function updateBlend(seriesModel, chartView) {
  var blendMode = seriesModel.get('blendMode') || null;
  chartView.group.traverse(function (el) {
    // FIXME marker and other components
    if (!el.isGroup) {
      // Only set if blendMode is changed. In case element is incremental and don't wan't to rerender.
      if (el.style.blend !== blendMode) {
        el.setStyle('blend', blendMode);
      }
    }

    if (el.eachPendingDisplayable) {
      el.eachPendingDisplayable(function (displayable) {
        displayable.setStyle('blend', blendMode);
      });
    }
  });
}
/**
 * @param {module:echarts/model/Series|module:echarts/model/Component} model
 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
 */


function updateZ(model, view) {
  var z = model.get('z');
  var zlevel = model.get('zlevel'); // Set z and zlevel

  view.group.traverse(function (el) {
    if (el.type !== 'group') {
      z != null && (el.z = z);
      zlevel != null && (el.zlevel = zlevel);
    }
  });
}

function createExtensionAPI(ecInstance) {
  var coordSysMgr = ecInstance._coordSysMgr;
  return zrUtil.extend(new ExtensionAPI(ecInstance), {
    // Inject methods
    getCoordinateSystems: zrUtil.bind(coordSysMgr.getCoordinateSystems, coordSysMgr),
    getComponentByElement: function (el) {
      while (el) {
        var modelInfo = el.__ecComponentInfo;

        if (modelInfo != null) {
          return ecInstance._model.getComponent(modelInfo.mainType, modelInfo.index);
        }

        el = el.parent;
      }
    }
  });
}
/**
 * @class
 * Usage of query:
 * `chart.on('click', query, handler);`
 * The `query` can be:
 * + The component type query string, only `mainType` or `mainType.subType`,
 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
 * + The component query object, like:
 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
 * + The data query object, like:
 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
 * + The other query object (cmponent customized query), like:
 *   `{element: 'some'}` (only available in custom series).
 *
 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
 * same as there is no such prop in the `query` object.
 */


function EventProcessor() {
  // These info required: targetEl, packedEvent, model, view
  this.eventInfo;
}

EventProcessor.prototype = {
  constructor: EventProcessor,
  normalizeQuery: function (query) {
    var cptQuery = {};
    var dataQuery = {};
    var otherQuery = {}; // `query` is `mainType` or `mainType.subType` of component.

    if (zrUtil.isString(query)) {
      var condCptType = parseClassType(query); // `.main` and `.sub` may be ''.

      cptQuery.mainType = condCptType.main || null;
      cptQuery.subType = condCptType.sub || null;
    } // `query` is an object, convert to {mainType, index, name, id}.
    else {
        // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
        // can not be used in `compomentModel.filterForExposedEvent`.
        var suffixes = ['Index', 'Name', 'Id'];
        var dataKeys = {
          name: 1,
          dataIndex: 1,
          dataType: 1
        };
        zrUtil.each(query, function (val, key) {
          var reserved = false;

          for (var i = 0; i < suffixes.length; i++) {
            var propSuffix = suffixes[i];
            var suffixPos = key.lastIndexOf(propSuffix);

            if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
              var mainType = key.slice(0, suffixPos); // Consider `dataIndex`.

              if (mainType !== 'data') {
                cptQuery.mainType = mainType;
                cptQuery[propSuffix.toLowerCase()] = val;
                reserved = true;
              }
            }
          }

          if (dataKeys.hasOwnProperty(key)) {
            dataQuery[key] = val;
            reserved = true;
          }

          if (!reserved) {
            otherQuery[key] = val;
          }
        });
      }

    return {
      cptQuery: cptQuery,
      dataQuery: dataQuery,
      otherQuery: otherQuery
    };
  },
  filter: function (eventType, query, args) {
    // They should be assigned before each trigger call.
    var eventInfo = this.eventInfo;

    if (!eventInfo) {
      return true;
    }

    var targetEl = eventInfo.targetEl;
    var packedEvent = eventInfo.packedEvent;
    var model = eventInfo.model;
    var view = eventInfo.view; // For event like 'globalout'.

    if (!model || !view) {
      return true;
    }

    var cptQuery = query.cptQuery;
    var dataQuery = query.dataQuery;
    return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));

    function check(query, host, prop, propOnHost) {
      return query[prop] == null || host[propOnHost || prop] === query[prop];
    }
  },
  afterTrigger: function () {
    // Make sure the eventInfo wont be used in next trigger.
    this.eventInfo = null;
  }
};
/**
 * @type {Object} key: actionType.
 * @inner
 */

var actions = {};
/**
 * Map eventType to actionType
 * @type {Object}
 */

var eventActionMap = {};
/**
 * Data processor functions of each stage
 * @type {Array.<Object.<string, Function>>}
 * @inner
 */

var dataProcessorFuncs = [];
/**
 * @type {Array.<Function>}
 * @inner
 */

var optionPreprocessorFuncs = [];
/**
 * @type {Array.<Function>}
 * @inner
 */

var postUpdateFuncs = [];
/**
 * Visual encoding functions of each stage
 * @type {Array.<Object.<string, Function>>}
 */

var visualFuncs = [];
/**
 * Theme storage
 * @type {Object.<key, Object>}
 */

var themeStorage = {};
/**
 * Loading effects
 */

var loadingEffects = {};
var instances = {};
var connectedGroups = {};
var idBase = new Date() - 0;
var groupIdBase = new Date() - 0;
var DOM_ATTRIBUTE_KEY = '_echarts_instance_';

function enableConnect(chart) {
  var STATUS_PENDING = 0;
  var STATUS_UPDATING = 1;
  var STATUS_UPDATED = 2;
  var STATUS_KEY = '__connectUpdateStatus';

  function updateConnectedChartsStatus(charts, status) {
    for (var i = 0; i < charts.length; i++) {
      var otherChart = charts[i];
      otherChart[STATUS_KEY] = status;
    }
  }

  each(eventActionMap, function (actionType, eventType) {
    chart._messageCenter.on(eventType, function (event) {
      if (connectedGroups[chart.group] && chart[STATUS_KEY] !== STATUS_PENDING) {
        if (event && event.escapeConnect) {
          return;
        }

        var action = chart.makeActionFromEvent(event);
        var otherCharts = [];
        each(instances, function (otherChart) {
          if (otherChart !== chart && otherChart.group === chart.group) {
            otherCharts.push(otherChart);
          }
        });
        updateConnectedChartsStatus(otherCharts, STATUS_PENDING);
        each(otherCharts, function (otherChart) {
          if (otherChart[STATUS_KEY] !== STATUS_UPDATING) {
            otherChart.dispatchAction(action);
          }
        });
        updateConnectedChartsStatus(otherCharts, STATUS_UPDATED);
      }
    });
  });
}
/**
 * @param {HTMLElement} dom
 * @param {Object} [theme]
 * @param {Object} opts
 * @param {number} [opts.devicePixelRatio] Use window.devicePixelRatio by default
 * @param {string} [opts.renderer] Can choose 'canvas' or 'svg' to render the chart.
 * @param {number} [opts.width] Use clientWidth of the input `dom` by default.
 *                              Can be 'auto' (the same as null/undefined)
 * @param {number} [opts.height] Use clientHeight of the input `dom` by default.
 *                               Can be 'auto' (the same as null/undefined)
 */


function init(dom, theme, opts) {
  var existInstance = getInstanceByDom(dom);

  if (existInstance) {
    return existInstance;
  }

  var chart = new ECharts(dom, theme, opts);
  chart.id = 'ec_' + idBase++;
  instances[chart.id] = chart;
  modelUtil.setAttribute(dom, DOM_ATTRIBUTE_KEY, chart.id);
  enableConnect(chart);
  return chart;
}
/**
 * @return {string|Array.<module:echarts~ECharts>} groupId
 */


function connect(groupId) {
  // Is array of charts
  if (zrUtil.isArray(groupId)) {
    var charts = groupId;
    groupId = null; // If any chart has group

    each(charts, function (chart) {
      if (chart.group != null) {
        groupId = chart.group;
      }
    });
    groupId = groupId || 'g_' + groupIdBase++;
    each(charts, function (chart) {
      chart.group = groupId;
    });
  }

  connectedGroups[groupId] = true;
  return groupId;
}
/**
 * @DEPRECATED
 * @return {string} groupId
 */


function disConnect(groupId) {
  connectedGroups[groupId] = false;
}
/**
 * @return {string} groupId
 */


var disconnect = disConnect;
/**
 * Dispose a chart instance
 * @param  {module:echarts~ECharts|HTMLDomElement|string} chart
 */

function dispose(chart) {
  if (typeof chart === 'string') {
    chart = instances[chart];
  } else if (!(chart instanceof ECharts)) {
    // Try to treat as dom
    chart = getInstanceByDom(chart);
  }

  if (chart instanceof ECharts && !chart.isDisposed()) {
    chart.dispose();
  }
}
/**
 * @param  {HTMLElement} dom
 * @return {echarts~ECharts}
 */


function getInstanceByDom(dom) {
  return instances[modelUtil.getAttribute(dom, DOM_ATTRIBUTE_KEY)];
}
/**
 * @param {string} key
 * @return {echarts~ECharts}
 */


function getInstanceById(key) {
  return instances[key];
}
/**
 * Register theme
 */


function registerTheme(name, theme) {
  themeStorage[name] = theme;
}
/**
 * Register option preprocessor
 * @param {Function} preprocessorFunc
 */


function registerPreprocessor(preprocessorFunc) {
  optionPreprocessorFuncs.push(preprocessorFunc);
}
/**
 * @param {number} [priority=1000]
 * @param {Object|Function} processor
 */


function registerProcessor(priority, processor) {
  normalizeRegister(dataProcessorFuncs, priority, processor, PRIORITY_PROCESSOR_FILTER);
}
/**
 * Register postUpdater
 * @param {Function} postUpdateFunc
 */


function registerPostUpdate(postUpdateFunc) {
  postUpdateFuncs.push(postUpdateFunc);
}
/**
 * Usage:
 * registerAction('someAction', 'someEvent', function () { ... });
 * registerAction('someAction', function () { ... });
 * registerAction(
 *     {type: 'someAction', event: 'someEvent', update: 'updateView'},
 *     function () { ... }
 * );
 *
 * @param {(string|Object)} actionInfo
 * @param {string} actionInfo.type
 * @param {string} [actionInfo.event]
 * @param {string} [actionInfo.update]
 * @param {string} [eventName]
 * @param {Function} action
 */


function registerAction(actionInfo, eventName, action) {
  if (typeof eventName === 'function') {
    action = eventName;
    eventName = '';
  }

  var actionType = isObject(actionInfo) ? actionInfo.type : [actionInfo, actionInfo = {
    event: eventName
  }][0]; // Event name is all lowercase

  actionInfo.event = (actionInfo.event || actionType).toLowerCase();
  eventName = actionInfo.event; // Validate action type and event name.

  assert(ACTION_REG.test(actionType) && ACTION_REG.test(eventName));

  if (!actions[actionType]) {
    actions[actionType] = {
      action: action,
      actionInfo: actionInfo
    };
  }

  eventActionMap[eventName] = actionType;
}
/**
 * @param {string} type
 * @param {*} CoordinateSystem
 */


function registerCoordinateSystem(type, CoordinateSystem) {
  CoordinateSystemManager.register(type, CoordinateSystem);
}
/**
 * Get dimensions of specified coordinate system.
 * @param {string} type
 * @return {Array.<string|Object>}
 */


function getCoordinateSystemDimensions(type) {
  var coordSysCreator = CoordinateSystemManager.get(type);

  if (coordSysCreator) {
    return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
  }
}
/**
 * Layout is a special stage of visual encoding
 * Most visual encoding like color are common for different chart
 * But each chart has it's own layout algorithm
 *
 * @param {number} [priority=1000]
 * @param {Function} layoutTask
 */


function registerLayout(priority, layoutTask) {
  normalizeRegister(visualFuncs, priority, layoutTask, PRIORITY_VISUAL_LAYOUT, 'layout');
}
/**
 * @param {number} [priority=3000]
 * @param {module:echarts/stream/Task} visualTask
 */


function registerVisual(priority, visualTask) {
  normalizeRegister(visualFuncs, priority, visualTask, PRIORITY_VISUAL_CHART, 'visual');
}
/**
 * @param {Object|Function} fn: {seriesType, createOnAllSeries, performRawSeries, reset}
 */


function normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
  if (isFunction(priority) || isObject(priority)) {
    fn = priority;
    priority = defaultPriority;
  }

  var stageHandler = Scheduler.wrapStageHandler(fn, visualType);
  stageHandler.__prio = priority;
  stageHandler.__raw = fn;
  targetList.push(stageHandler);
  return stageHandler;
}
/**
 * @param {string} name
 */


function registerLoading(name, loadingFx) {
  loadingEffects[name] = loadingFx;
}
/**
 * @param {Object} opts
 * @param {string} [superClass]
 */


function extendComponentModel(opts
/*, superClass*/
) {
  // var Clazz = ComponentModel;
  // if (superClass) {
  //     var classType = parseClassType(superClass);
  //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
  // }
  return ComponentModel.extend(opts);
}
/**
 * @param {Object} opts
 * @param {string} [superClass]
 */


function extendComponentView(opts
/*, superClass*/
) {
  // var Clazz = ComponentView;
  // if (superClass) {
  //     var classType = parseClassType(superClass);
  //     Clazz = ComponentView.getClass(classType.main, classType.sub, true);
  // }
  return ComponentView.extend(opts);
}
/**
 * @param {Object} opts
 * @param {string} [superClass]
 */


function extendSeriesModel(opts
/*, superClass*/
) {
  // var Clazz = SeriesModel;
  // if (superClass) {
  //     superClass = 'series.' + superClass.replace('series.', '');
  //     var classType = parseClassType(superClass);
  //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
  // }
  return SeriesModel.extend(opts);
}
/**
 * @param {Object} opts
 * @param {string} [superClass]
 */


function extendChartView(opts
/*, superClass*/
) {
  // var Clazz = ChartView;
  // if (superClass) {
  //     superClass = superClass.replace('series.', '');
  //     var classType = parseClassType(superClass);
  //     Clazz = ChartView.getClass(classType.main, true);
  // }
  return ChartView.extend(opts);
}
/**
 * ZRender need a canvas context to do measureText.
 * But in node environment canvas may be created by node-canvas.
 * So we need to specify how to create a canvas instead of using document.createElement('canvas')
 *
 * Be careful of using it in the browser.
 *
 * @param {Function} creator
 * @example
 *     var Canvas = require('canvas');
 *     var echarts = require('echarts');
 *     echarts.setCanvasCreator(function () {
 *         // Small size is enough.
 *         return new Canvas(32, 32);
 *     });
 */


function setCanvasCreator(creator) {
  zrUtil.$override('createCanvas', creator);
}
/**
 * @param {string} mapName
 * @param {Array.<Object>|Object|string} geoJson
 * @param {Object} [specialAreas]
 *
 * @example GeoJSON
 *     $.get('USA.json', function (geoJson) {
 *         echarts.registerMap('USA', geoJson);
 *         // Or
 *         echarts.registerMap('USA', {
 *             geoJson: geoJson,
 *             specialAreas: {}
 *         })
 *     });
 *
 *     $.get('airport.svg', function (svg) {
 *         echarts.registerMap('airport', {
 *             svg: svg
 *         }
 *     });
 *
 *     echarts.registerMap('eu', [
 *         {svg: eu-topographic.svg},
 *         {geoJSON: eu.json}
 *     ])
 */


function registerMap(mapName, geoJson, specialAreas) {
  mapDataStorage.registerMap(mapName, geoJson, specialAreas);
}
/**
 * @param {string} mapName
 * @return {Object}
 */


function getMap(mapName) {
  // For backward compatibility, only return the first one.
  var records = mapDataStorage.retrieveMap(mapName);
  return records && records[0] && {
    geoJson: records[0].geoJSON,
    specialAreas: records[0].specialAreas
  };
}

registerVisual(PRIORITY_VISUAL_GLOBAL, seriesColor);
registerPreprocessor(backwardCompat);
registerProcessor(PRIORITY_PROCESSOR_DATASTACK, dataStack);
registerLoading('default', loadingDefault); // Default actions

registerAction({
  type: 'highlight',
  event: 'highlight',
  update: 'highlight'
}, zrUtil.noop);
registerAction({
  type: 'downplay',
  event: 'downplay',
  update: 'downplay'
}, zrUtil.noop); // Default theme

registerTheme('light', lightTheme);
registerTheme('dark', darkTheme); // For backward compatibility, where the namespace `dataTool` will
// be mounted on `echarts` is the extension `dataTool` is imported.

var dataTool = {};
exports.version = version;
exports.dependencies = dependencies;
exports.PRIORITY = PRIORITY;
exports.init = init;
exports.connect = connect;
exports.disConnect = disConnect;
exports.disconnect = disconnect;
exports.dispose = dispose;
exports.getInstanceByDom = getInstanceByDom;
exports.getInstanceById = getInstanceById;
exports.registerTheme = registerTheme;
exports.registerPreprocessor = registerPreprocessor;
exports.registerProcessor = registerProcessor;
exports.registerPostUpdate = registerPostUpdate;
exports.registerAction = registerAction;
exports.registerCoordinateSystem = registerCoordinateSystem;
exports.getCoordinateSystemDimensions = getCoordinateSystemDimensions;
exports.registerLayout = registerLayout;
exports.registerVisual = registerVisual;
exports.registerLoading = registerLoading;
exports.extendComponentModel = extendComponentModel;
exports.extendComponentView = extendComponentView;
exports.extendSeriesModel = extendSeriesModel;
exports.extendChartView = extendChartView;
exports.setCanvasCreator = setCanvasCreator;
exports.registerMap = registerMap;
exports.getMap = getMap;
exports.dataTool = dataTool;
var ___ec_export = __webpack_require__(639);
(function () {
    for (var key in ___ec_export) {
        if (___ec_export.hasOwnProperty(key)) {
            exports[key] = ___ec_export[key];
        }
    }
})();

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _tooltip=__webpack_require__(87);var _tooltip2=_interopRequireDefault(_tooltip);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(35);__webpack_require__(100);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * @name:  
 * @description:  
 * @Author: Han bei 
 * @Date: 2018-10-15 15:46:36 
 * @Last Modified by: Bei.HanBeiBei
 * @Last Modified time: 2020-07-27 14:00:53
 *  
 *  text  value值
 *  index 索引
 *  type  需要组件类型   text、number、percent、input、inputNumber、inputPercent 不传值默认不显示文本
 *  name  行名称
 *  title 表头
 *  record 行数据 Object
 *  totolIndex  汇总的行、需要颜色区分
 *  sqlName  数据库名称 自定义表格需要
 *  onChange 利用父级函数更新数据
 */var TextArea=_input2.default.TextArea;var TableText=function(_Component){_inherits(TableText,_Component);function TableText(){_classCallCheck(this,TableText);return _possibleConstructorReturn(this,(TableText.__proto__||Object.getPrototypeOf(TableText)).apply(this,arguments));}_createClass(TableText,[{key:'render',value:function render(){var _props$data=this.props.data,_props$data$text=_props$data.text,text=_props$data$text===undefined?'':_props$data$text,index=_props$data.index,type=_props$data.type,name=_props$data.name,onChange=_props$data.onChange,_props$data$totalInde=_props$data.totalIndex,totalIndex=_props$data$totalInde===undefined?[]:_props$data$totalInde,warn=_props$data.warn,_props$data$yellowTex=_props$data.yellowText,yellowText=_props$data$yellowTex===undefined?"":_props$data$yellowTex,_props$data$minRows=_props$data.minRows,minRows=_props$data$minRows===undefined?4:_props$data$minRows;var _ref=this.props.data.compared||{},_ref$title=_ref.title,title=_ref$title===undefined?[]:_ref$title,_ref$record=_ref.record,record=_ref$record===undefined?{}:_ref$record,_ref$sqlName=_ref.sqlName,sqlName=_ref$sqlName===undefined?"":_ref$sqlName,_ref$t_type=_ref.t_type,t_type=_ref$t_type===undefined?"":_ref$t_type;switch(type){case'input':if(this.props.data.compared){return _react2.default.createElement(_Compared2.default,{data:{index:index,t_type:t_type,key:name,title:title,sqlName:sqlName,name:record.name,type:"text"}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";onChange(name,value,index);}})));}return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";onChange(name,value,index);}}));break;case'textArea':return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(TextArea,{autosize:{minRows:minRows}// className="table_numInput"
,defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";onChange(name,value,index);}}));break;case'number':if(this.props.data.compared){if(warn){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:name,title:title,sqlName:sqlName,name:record.name,t_type:t_type,type:"number"}},_react2.default.createElement(_tooltip2.default,{title:yellowText},_react2.default.createElement('div',{className:'table-padding\n                                          heightAuto \n                                          heightAutoNum \n                                          '+(totalIndex.includes(index)?'table-color-footer':'')+' \n                                          '+(warn?"table-text-warn":"")+' \n                                          '+(yellowText&&"yellowWaring")+'\n                                          '},_react2.default.createElement('div',{style:{color:"red"}},Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')))));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:name,title:title,sqlName:sqlName,name:record.name,t_type:t_type,type:"number"}},_react2.default.createElement(_tooltip2.default,{title:yellowText},_react2.default.createElement('div',{className:'table-padding heightAuto heightAutoNum '+(totalIndex.includes(index)?'table-color-footer':'')+' \n                                  '+(yellowText&&"yellowWaring")+'\n                                '},_react2.default.createElement('div',null,Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')))));}if(warn){return _react2.default.createElement(_tooltip2.default,{title:yellowText},_react2.default.createElement('div',{className:'table-padding heightAuto heightAutoNum '+(totalIndex.includes(index)?'table-color-footer':'')+' '+(warn?"table-text-warn":"")+'  \n                             '+(yellowText&&"yellowWaring")+'\n                            '},_react2.default.createElement('div',{style:{color:"red"}},Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','))));}return _react2.default.createElement(_tooltip2.default,{title:yellowText},_react2.default.createElement('div',{className:'table-padding heightAuto heightAutoNum '+(totalIndex.includes(index)?'table-color-footer':'')+' \n                         '+(yellowText&&"yellowWaring")+'\n                        '},_react2.default.createElement('div',null,Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','))));break;case'inputPercent':if(this.props.data.compared){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:name,title:title,sqlName:sqlName,name:record.name,t_type:t_type,type:"percent"}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{defaultValue:Number(text||"0")*100||"",className:'table_numInput',precision:1,formatter:function formatter(value){return(value+'%').replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){var parseValue=value;parseValue=value.replace('%','').replace(/\$\s?|(,*)/g,'');return parseValue;},onBlur:function onBlur(e){var value=Number(e.target.value.replace(/%|,/g,'')||'0');value=Number(value.toFixed(1)/100).toFixed(3);onChange(name,value,index);}})));}else{return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{defaultValue:Number(text||"0")*100||"",className:'table_numInput',precision:1,formatter:function formatter(value){return(value+'%').replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){var parseValue=value;parseValue=value.replace('%','').replace(/\$\s?|(,*)/g,'');return parseValue;},onBlur:function onBlur(e){var value=Number(e.target.value.replace(/%|,/g,'')||'0');value=Number(value.toFixed(1)/100).toFixed(3);onChange(name,value,index);}}));}break;case'inputNumber':if(this.props.data.compared){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:name,title:title,sqlName:sqlName,name:record.name,t_type:t_type,type:"number"}},_react2.default.createElement('div',{className:'table-padding table-color-number '+(warn?"table-inputNumber-err":"")},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));onChange(name,value,index);}})));}else{return _react2.default.createElement('div',{className:'table-padding table-color-number '+(warn?"table-inputNumber-err":"")},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));onChange(name,value,index);}}));}break;case'percent':// 百分比位数根据传值进行变动
var num=(text.toString().split('.')[1]||"").length<=3?1:(text.toString().split('.')[1]||"").length-2;if(this.props.data.compared){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:name,title:title,sqlName:sqlName,name:record.name,t_type:t_type,type:"percent"}},_react2.default.createElement(_tooltip2.default,{title:yellowText},_react2.default.createElement('div',{className:'table-padding heightAuto heightAutoNum '+(totalIndex.includes(index)?'table-color-footer':'')+' \n                                '+(yellowText&&"yellowWaring")+'\n                                '+(warn?"table-text-warn":"")+' \n                                '},_react2.default.createElement('div',null,Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',((Math.abs(text)*100).toFixed(num).toLocaleString()=="-0"?"0":(Math.abs(text)*100).toFixed(num).toLocaleString())+'%',')'):((text*100).toFixed(num).toLocaleString()=="-0"?"0":(text*100).toFixed(num).toLocaleString())+'%'))));}else{return _react2.default.createElement(_tooltip2.default,{title:yellowText},_react2.default.createElement('div',{className:'table-padding heightAuto heightAutoNum '+(totalIndex.includes(index)?'table-color-footer':'')+' \n                            '+(yellowText&&"yellowWaring")+'\n                            '+(warn?"table-text-warn":"")+' \n                            '},_react2.default.createElement('div',null,Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',((Math.abs(text)*100).toFixed(num).toLocaleString()=="-0"?"0":(Math.abs(text)*100).toFixed(num).toLocaleString())+'%',')'):((text*100).toFixed(num).toLocaleString()=="-0"?"0":(text*100).toFixed(num).toLocaleString())+'%')));}break;case'text':case'string':case'textcenter':if(warn){return _react2.default.createElement(_tooltip2.default,{title:yellowText},_react2.default.createElement('div',{className:'table-padding heightAuto '+(warn?"table-text-warn":"")+'  \n                            '+(yellowText&&"yellowWaring")+'\n                            '+(type=='textcenter'&&"textcenter")+'\n                            ',style:{textAlign:"left"}},_react2.default.createElement('div',{style:{color:"red"},dangerouslySetInnerHTML:{__html:text||"-"}})));}return _react2.default.createElement(_tooltip2.default,{title:yellowText},_react2.default.createElement('div',{className:'table-padding heightAuto '+(totalIndex.includes(index)?'table-color-footer':'')+' \n                            '+(yellowText&&"yellowWaring")+'\n                            '+(type=='textcenter'&&"textcenter")+'\n                            ',style:{whiteSpace:'initial',textAlign:type==='string'?'right':type==='textcenter'?'center':"left"}},_react2.default.createElement('div',{dangerouslySetInnerHTML:{__html:text||"-"}})));break;default:return _react2.default.createElement(_tooltip2.default,{title:yellowText},_react2.default.createElement('div',{className:'table-padding heightAuto '+(totalIndex.includes(index)?'table-color-footer':'')+' \n                        '+(yellowText&&"yellowWaring")+'\n                        '},_react2.default.createElement('div',{style:{justifyContent:"flex-end"}},'-')));break;}}}]);return TableText;}(_react.Component);exports.default=TableText;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(879);

__webpack_require__(6);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Input = _interopRequireDefault(__webpack_require__(221));

var _Group = _interopRequireDefault(__webpack_require__(861));

var _Search = _interopRequireDefault(__webpack_require__(862));

var _TextArea = _interopRequireDefault(__webpack_require__(864));

var _Password = _interopRequireDefault(__webpack_require__(871));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Input["default"].Group = _Group["default"];
_Input["default"].Search = _Search["default"];
_Input["default"].TextArea = _TextArea["default"];
_Input["default"].Password = _Password["default"];
var _default = _Input["default"];
exports["default"] = _default;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var pathTool = __webpack_require__(624);

var colorTool = __webpack_require__(122);

var matrix = __webpack_require__(82);

var vector = __webpack_require__(55);

var Path = __webpack_require__(65);

var Transformable = __webpack_require__(292);

var ZImage = __webpack_require__(203);

exports.Image = ZImage;

var Group = __webpack_require__(174);

exports.Group = Group;

var Text = __webpack_require__(175);

exports.Text = Text;

var Circle = __webpack_require__(629);

exports.Circle = Circle;

var Sector = __webpack_require__(1545);

exports.Sector = Sector;

var Ring = __webpack_require__(1546);

exports.Ring = Ring;

var Polygon = __webpack_require__(631);

exports.Polygon = Polygon;

var Polyline = __webpack_require__(633);

exports.Polyline = Polyline;

var Rect = __webpack_require__(407);

exports.Rect = Rect;

var Line = __webpack_require__(634);

exports.Line = Line;

var BezierCurve = __webpack_require__(1549);

exports.BezierCurve = BezierCurve;

var Arc = __webpack_require__(1550);

exports.Arc = Arc;

var CompoundPath = __webpack_require__(1551);

exports.CompoundPath = CompoundPath;

var LinearGradient = __webpack_require__(409);

exports.LinearGradient = LinearGradient;

var RadialGradient = __webpack_require__(1552);

exports.RadialGradient = RadialGradient;

var BoundingRect = __webpack_require__(57);

exports.BoundingRect = BoundingRect;

var IncrementalDisplayable = __webpack_require__(410);

exports.IncrementalDisplayable = IncrementalDisplayable;

var subPixelOptimizeUtil = __webpack_require__(408);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var mathMax = Math.max;
var mathMin = Math.min;
var EMPTY_OBJ = {};
var Z2_EMPHASIS_LIFT = 1; // key: label model property nane, value: style property name.

var CACHED_LABEL_STYLE_PROPERTIES = {
  color: 'textFill',
  textBorderColor: 'textStroke',
  textBorderWidth: 'textStrokeWidth'
};
var EMPHASIS = 'emphasis';
var NORMAL = 'normal'; // Reserve 0 as default.

var _highlightNextDigit = 1;
var _highlightKeyMap = {};
var _customShapeMap = {};
/**
 * Extend shape with parameters
 */

function extendShape(opts) {
  return Path.extend(opts);
}
/**
 * Extend path
 */


function extendPath(pathData, opts) {
  return pathTool.extendFromString(pathData, opts);
}
/**
 * Register a user defined shape.
 * The shape class can be fetched by `getShapeClass`
 * This method will overwrite the registered shapes, including
 * the registered built-in shapes, if using the same `name`.
 * The shape can be used in `custom series` and
 * `graphic component` by declaring `{type: name}`.
 *
 * @param {string} name
 * @param {Object} ShapeClass Can be generated by `extendShape`.
 */


function registerShape(name, ShapeClass) {
  _customShapeMap[name] = ShapeClass;
}
/**
 * Find shape class registered by `registerShape`. Usually used in
 * fetching user defined shape.
 *
 * [Caution]:
 * (1) This method **MUST NOT be used inside echarts !!!**, unless it is prepared
 * to use user registered shapes.
 * Because the built-in shape (see `getBuiltInShape`) will be registered by
 * `registerShape` by default. That enables users to get both built-in
 * shapes as well as the shapes belonging to themsleves. But users can overwrite
 * the built-in shapes by using names like 'circle', 'rect' via calling
 * `registerShape`. So the echarts inner featrues should not fetch shapes from here
 * in case that it is overwritten by users, except that some features, like
 * `custom series`, `graphic component`, do it deliberately.
 *
 * (2) In the features like `custom series`, `graphic component`, the user input
 * `{tpye: 'xxx'}` does not only specify shapes but also specify other graphic
 * elements like `'group'`, `'text'`, `'image'` or event `'path'`. Those names
 * are reserved names, that is, if some user register a shape named `'image'`,
 * the shape will not be used. If we intending to add some more reserved names
 * in feature, that might bring break changes (disable some existing user shape
 * names). But that case probably rearly happen. So we dont make more mechanism
 * to resolve this issue here.
 *
 * @param {string} name
 * @return {Object} The shape class. If not found, return nothing.
 */


function getShapeClass(name) {
  if (_customShapeMap.hasOwnProperty(name)) {
    return _customShapeMap[name];
  }
}
/**
 * Create a path element from path data string
 * @param {string} pathData
 * @param {Object} opts
 * @param {module:zrender/core/BoundingRect} rect
 * @param {string} [layout=cover] 'center' or 'cover'
 */


function makePath(pathData, opts, rect, layout) {
  var path = pathTool.createFromString(pathData, opts);

  if (rect) {
    if (layout === 'center') {
      rect = centerGraphic(rect, path.getBoundingRect());
    }

    resizePath(path, rect);
  }

  return path;
}
/**
 * Create a image element from image url
 * @param {string} imageUrl image url
 * @param {Object} opts options
 * @param {module:zrender/core/BoundingRect} rect constrain rect
 * @param {string} [layout=cover] 'center' or 'cover'
 */


function makeImage(imageUrl, rect, layout) {
  var path = new ZImage({
    style: {
      image: imageUrl,
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    },
    onload: function (img) {
      if (layout === 'center') {
        var boundingRect = {
          width: img.width,
          height: img.height
        };
        path.setStyle(centerGraphic(rect, boundingRect));
      }
    }
  });
  return path;
}
/**
 * Get position of centered element in bounding box.
 *
 * @param  {Object} rect         element local bounding box
 * @param  {Object} boundingRect constraint bounding box
 * @return {Object} element position containing x, y, width, and height
 */


function centerGraphic(rect, boundingRect) {
  // Set rect to center, keep width / height ratio.
  var aspect = boundingRect.width / boundingRect.height;
  var width = rect.height * aspect;
  var height;

  if (width <= rect.width) {
    height = rect.height;
  } else {
    width = rect.width;
    height = width / aspect;
  }

  var cx = rect.x + rect.width / 2;
  var cy = rect.y + rect.height / 2;
  return {
    x: cx - width / 2,
    y: cy - height / 2,
    width: width,
    height: height
  };
}

var mergePath = pathTool.mergePath;
/**
 * Resize a path to fit the rect
 * @param {module:zrender/graphic/Path} path
 * @param {Object} rect
 */

function resizePath(path, rect) {
  if (!path.applyTransform) {
    return;
  }

  var pathRect = path.getBoundingRect();
  var m = pathRect.calculateTransform(rect);
  path.applyTransform(m);
}
/**
 * Sub pixel optimize line for canvas
 *
 * @param {Object} param
 * @param {Object} [param.shape]
 * @param {number} [param.shape.x1]
 * @param {number} [param.shape.y1]
 * @param {number} [param.shape.x2]
 * @param {number} [param.shape.y2]
 * @param {Object} [param.style]
 * @param {number} [param.style.lineWidth]
 * @return {Object} Modified param
 */


function subPixelOptimizeLine(param) {
  subPixelOptimizeUtil.subPixelOptimizeLine(param.shape, param.shape, param.style);
  return param;
}
/**
 * Sub pixel optimize rect for canvas
 *
 * @param {Object} param
 * @param {Object} [param.shape]
 * @param {number} [param.shape.x]
 * @param {number} [param.shape.y]
 * @param {number} [param.shape.width]
 * @param {number} [param.shape.height]
 * @param {Object} [param.style]
 * @param {number} [param.style.lineWidth]
 * @return {Object} Modified param
 */


function subPixelOptimizeRect(param) {
  subPixelOptimizeUtil.subPixelOptimizeRect(param.shape, param.shape, param.style);
  return param;
}
/**
 * Sub pixel optimize for canvas
 *
 * @param {number} position Coordinate, such as x, y
 * @param {number} lineWidth Should be nonnegative integer.
 * @param {boolean=} positiveOrNegative Default false (negative).
 * @return {number} Optimized position.
 */


var subPixelOptimize = subPixelOptimizeUtil.subPixelOptimize;

function hasFillOrStroke(fillOrStroke) {
  return fillOrStroke != null && fillOrStroke !== 'none';
} // Most lifted color are duplicated.


var liftedColorMap = zrUtil.createHashMap();
var liftedColorCount = 0;

function liftColor(color) {
  if (typeof color !== 'string') {
    return color;
  }

  var liftedColor = liftedColorMap.get(color);

  if (!liftedColor) {
    liftedColor = colorTool.lift(color, -0.1);

    if (liftedColorCount < 10000) {
      liftedColorMap.set(color, liftedColor);
      liftedColorCount++;
    }
  }

  return liftedColor;
}

function cacheElementStl(el) {
  if (!el.__hoverStlDirty) {
    return;
  }

  el.__hoverStlDirty = false;
  var hoverStyle = el.__hoverStl;

  if (!hoverStyle) {
    el.__cachedNormalStl = el.__cachedNormalZ2 = null;
    return;
  }

  var normalStyle = el.__cachedNormalStl = {};
  el.__cachedNormalZ2 = el.z2;
  var elStyle = el.style;

  for (var name in hoverStyle) {
    // See comment in `singleEnterEmphasis`.
    if (hoverStyle[name] != null) {
      normalStyle[name] = elStyle[name];
    }
  } // Always cache fill and stroke to normalStyle for lifting color.


  normalStyle.fill = elStyle.fill;
  normalStyle.stroke = elStyle.stroke;
}

function singleEnterEmphasis(el) {
  var hoverStl = el.__hoverStl;

  if (!hoverStl || el.__highlighted) {
    return;
  }

  var zr = el.__zr;
  var useHoverLayer = el.useHoverLayer && zr && zr.painter.type === 'canvas';
  el.__highlighted = useHoverLayer ? 'layer' : 'plain';

  if (el.isGroup || !zr && el.useHoverLayer) {
    return;
  }

  var elTarget = el;
  var targetStyle = el.style;

  if (useHoverLayer) {
    elTarget = zr.addHover(el);
    targetStyle = elTarget.style;
  }

  rollbackDefaultTextStyle(targetStyle);

  if (!useHoverLayer) {
    cacheElementStl(elTarget);
  } // styles can be:
  // {
  //    label: {
  //        show: false,
  //        position: 'outside',
  //        fontSize: 18
  //    },
  //    emphasis: {
  //        label: {
  //            show: true
  //        }
  //    }
  // },
  // where properties of `emphasis` may not appear in `normal`. We previously use
  // module:echarts/util/model#defaultEmphasis to merge `normal` to `emphasis`.
  // But consider rich text and setOption in merge mode, it is impossible to cover
  // all properties in merge. So we use merge mode when setting style here.
  // But we choose the merge strategy that only properties that is not `null/undefined`.
  // Because when making a textStyle (espacially rich text), it is not easy to distinguish
  // `hasOwnProperty` and `null/undefined` in code, so we trade them as the same for simplicity.
  // But this strategy brings a trouble that `null/undefined` can not be used to remove
  // style any more in `emphasis`. Users can both set properties directly on normal and
  // emphasis to avoid this issue, or we might support `'none'` for this case if required.


  targetStyle.extendFrom(hoverStl);
  setDefaultHoverFillStroke(targetStyle, hoverStl, 'fill');
  setDefaultHoverFillStroke(targetStyle, hoverStl, 'stroke');
  applyDefaultTextStyle(targetStyle);

  if (!useHoverLayer) {
    el.dirty(false);
    el.z2 += Z2_EMPHASIS_LIFT;
  }
}

function setDefaultHoverFillStroke(targetStyle, hoverStyle, prop) {
  if (!hasFillOrStroke(hoverStyle[prop]) && hasFillOrStroke(targetStyle[prop])) {
    targetStyle[prop] = liftColor(targetStyle[prop]);
  }
}

function singleEnterNormal(el) {
  var highlighted = el.__highlighted;

  if (!highlighted) {
    return;
  }

  el.__highlighted = false;

  if (el.isGroup) {
    return;
  }

  if (highlighted === 'layer') {
    el.__zr && el.__zr.removeHover(el);
  } else {
    var style = el.style;
    var normalStl = el.__cachedNormalStl;

    if (normalStl) {
      rollbackDefaultTextStyle(style);
      el.setStyle(normalStl);
      applyDefaultTextStyle(style);
    } // `__cachedNormalZ2` will not be reset if calling `setElementHoverStyle`
    // when `el` is on emphasis state. So here by comparing with 1, we try
    // hard to make the bug case rare.


    var normalZ2 = el.__cachedNormalZ2;

    if (normalZ2 != null && el.z2 - normalZ2 === Z2_EMPHASIS_LIFT) {
      el.z2 = normalZ2;
    }
  }
}

function traverseUpdate(el, updater, commonParam) {
  // If root is group, also enter updater for `highDownOnUpdate`.
  var fromState = NORMAL;
  var toState = NORMAL;
  var trigger; // See the rule of `highDownOnUpdate` on `graphic.setAsHighDownDispatcher`.

  el.__highlighted && (fromState = EMPHASIS, trigger = true);
  updater(el, commonParam);
  el.__highlighted && (toState = EMPHASIS, trigger = true);
  el.isGroup && el.traverse(function (child) {
    !child.isGroup && updater(child, commonParam);
  });
  trigger && el.__highDownOnUpdate && el.__highDownOnUpdate(fromState, toState);
}
/**
 * Set hover style (namely "emphasis style") of element, based on the current
 * style of the given `el`.
 * This method should be called after all of the normal styles have been adopted
 * to the `el`. See the reason on `setHoverStyle`.
 *
 * @param {module:zrender/Element} el Should not be `zrender/container/Group`.
 * @param {Object} [el.hoverStyle] Can be set on el or its descendants,
 *        e.g., `el.hoverStyle = ...; graphic.setHoverStyle(el); `.
 *        Often used when item group has a label element and it's hoverStyle is different.
 * @param {Object|boolean} [hoverStl] The specified hover style.
 *        If set as `false`, disable the hover style.
 *        Similarly, The `el.hoverStyle` can alse be set
 *        as `false` to disable the hover style.
 *        Otherwise, use the default hover style if not provided.
 */


function setElementHoverStyle(el, hoverStl) {
  // For performance consideration, it might be better to make the "hover style" only the
  // difference properties from the "normal style", but not a entire copy of all styles.
  hoverStl = el.__hoverStl = hoverStl !== false && (el.hoverStyle || hoverStl || {});
  el.__hoverStlDirty = true; // FIXME
  // It is not completely right to save "normal"/"emphasis" flag on elements.
  // It probably should be saved on `data` of series. Consider the cases:
  // (1) A highlighted elements are moved out of the view port and re-enter
  // again by dataZoom.
  // (2) call `setOption` and replace elements totally when they are highlighted.

  if (el.__highlighted) {
    // Consider the case:
    // The styles of a highlighted `el` is being updated. The new "emphasis style"
    // should be adapted to the `el`. Notice here new "normal styles" should have
    // been set outside and the cached "normal style" is out of date.
    el.__cachedNormalStl = null; // Do not clear `__cachedNormalZ2` here, because setting `z2` is not a constraint
    // of this method. In most cases, `z2` is not set and hover style should be able
    // to rollback. Of course, that would bring bug, but only in a rare case, see
    // `doSingleLeaveHover` for details.

    singleEnterNormal(el);
    singleEnterEmphasis(el);
  }
}

function onElementMouseOver(e) {
  !shouldSilent(this, e) // "emphasis" event highlight has higher priority than mouse highlight.
  && !this.__highByOuter && traverseUpdate(this, singleEnterEmphasis);
}

function onElementMouseOut(e) {
  !shouldSilent(this, e) // "emphasis" event highlight has higher priority than mouse highlight.
  && !this.__highByOuter && traverseUpdate(this, singleEnterNormal);
}

function onElementEmphasisEvent(highlightDigit) {
  this.__highByOuter |= 1 << (highlightDigit || 0);
  traverseUpdate(this, singleEnterEmphasis);
}

function onElementNormalEvent(highlightDigit) {
  !(this.__highByOuter &= ~(1 << (highlightDigit || 0))) && traverseUpdate(this, singleEnterNormal);
}

function shouldSilent(el, e) {
  return el.__highDownSilentOnTouch && e.zrByTouch;
}
/**
 * Set hover style (namely "emphasis style") of element,
 * based on the current style of the given `el`.
 *
 * (1)
 * **CONSTRAINTS** for this method:
 * <A> This method MUST be called after all of the normal styles having been adopted
 * to the `el`.
 * <B> The input `hoverStyle` (that is, "emphasis style") MUST be the subset of the
 * "normal style" having been set to the el.
 * <C> `color` MUST be one of the "normal styles" (because color might be lifted as
 * a default hover style).
 *
 * The reason: this method treat the current style of the `el` as the "normal style"
 * and cache them when enter/update the "emphasis style". Consider the case: the `el`
 * is in "emphasis" state and `setOption`/`dispatchAction` trigger the style updating
 * logic, where the el should shift from the original emphasis style to the new
 * "emphasis style" and should be able to "downplay" back to the new "normal style".
 *
 * Indeed, it is error-prone to make a interface has so many constraints, but I have
 * not found a better solution yet to fit the backward compatibility, performance and
 * the current programming style.
 *
 * (2)
 * Call the method for a "root" element once. Do not call it for each descendants.
 * If the descendants elemenets of a group has itself hover style different from the
 * root group, we can simply mount the style on `el.hoverStyle` for them, but should
 * not call this method for them.
 *
 * (3) These input parameters can be set directly on `el`:
 *
 * @param {module:zrender/Element} el
 * @param {Object} [el.hoverStyle] See `graphic.setElementHoverStyle`.
 * @param {boolean} [el.highDownSilentOnTouch=false] See `graphic.setAsHighDownDispatcher`.
 * @param {Function} [el.highDownOnUpdate] See `graphic.setAsHighDownDispatcher`.
 * @param {Object|boolean} [hoverStyle] See `graphic.setElementHoverStyle`.
 */


function setHoverStyle(el, hoverStyle) {
  setAsHighDownDispatcher(el, true);
  traverseUpdate(el, setElementHoverStyle, hoverStyle);
}
/**
 * @param {module:zrender/Element} el
 * @param {Function} [el.highDownOnUpdate] Called when state updated.
 *        Since `setHoverStyle` has the constraint that it must be called after
 *        all of the normal style updated, `highDownOnUpdate` is not needed to
 *        trigger if both `fromState` and `toState` is 'normal', and needed to
 *        trigger if both `fromState` and `toState` is 'emphasis', which enables
 *        to sync outside style settings to "emphasis" state.
 *        @this {string} This dispatcher `el`.
 *        @param {string} fromState Can be "normal" or "emphasis".
 *               `fromState` might equal to `toState`,
 *               for example, when this method is called when `el` is
 *               on "emphasis" state.
 *        @param {string} toState Can be "normal" or "emphasis".
 *
 *        FIXME
 *        CAUTION: Do not expose `highDownOnUpdate` outside echarts.
 *        Because it is not a complete solution. The update
 *        listener should not have been mount in element,
 *        and the normal/emphasis state should not have
 *        mantained on elements.
 *
 * @param {boolean} [el.highDownSilentOnTouch=false]
 *        In touch device, mouseover event will be trigger on touchstart event
 *        (see module:zrender/dom/HandlerProxy). By this mechanism, we can
 *        conveniently use hoverStyle when tap on touch screen without additional
 *        code for compatibility.
 *        But if the chart/component has select feature, which usually also use
 *        hoverStyle, there might be conflict between 'select-highlight' and
 *        'hover-highlight' especially when roam is enabled (see geo for example).
 *        In this case, `highDownSilentOnTouch` should be used to disable
 *        hover-highlight on touch device.
 * @param {boolean} [asDispatcher=true] If `false`, do not set as "highDownDispatcher".
 */


function setAsHighDownDispatcher(el, asDispatcher) {
  var disable = asDispatcher === false; // Make `highDownSilentOnTouch` and `highDownOnUpdate` only work after
  // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.

  el.__highDownSilentOnTouch = el.highDownSilentOnTouch;
  el.__highDownOnUpdate = el.highDownOnUpdate; // Simple optimize, since this method might be
  // called for each elements of a group in some cases.

  if (!disable || el.__highDownDispatcher) {
    var method = disable ? 'off' : 'on'; // Duplicated function will be auto-ignored, see Eventful.js.

    el[method]('mouseover', onElementMouseOver)[method]('mouseout', onElementMouseOut); // Emphasis, normal can be triggered manually by API or other components like hover link.

    el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent); // Also keep previous record.

    el.__highByOuter = el.__highByOuter || 0;
    el.__highDownDispatcher = !disable;
  }
}
/**
 * @param {module:zrender/src/Element} el
 * @return {boolean}
 */


function isHighDownDispatcher(el) {
  return !!(el && el.__highDownDispatcher);
}
/**
 * Support hightlight/downplay record on each elements.
 * For the case: hover highlight/downplay (legend, visualMap, ...) and
 * user triggerred hightlight/downplay should not conflict.
 * Only all of the highlightDigit cleared, return to normal.
 * @param {string} highlightKey
 * @return {number} highlightDigit
 */


function getHighlightDigit(highlightKey) {
  var highlightDigit = _highlightKeyMap[highlightKey];

  if (highlightDigit == null && _highlightNextDigit <= 32) {
    highlightDigit = _highlightKeyMap[highlightKey] = _highlightNextDigit++;
  }

  return highlightDigit;
}
/**
 * See more info in `setTextStyleCommon`.
 * @param {Object|module:zrender/graphic/Style} normalStyle
 * @param {Object} emphasisStyle
 * @param {module:echarts/model/Model} normalModel
 * @param {module:echarts/model/Model} emphasisModel
 * @param {Object} opt Check `opt` of `setTextStyleCommon` to find other props.
 * @param {string|Function} [opt.defaultText]
 * @param {module:echarts/model/Model} [opt.labelFetcher] Fetch text by
 *      `opt.labelFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
 * @param {number} [opt.labelDataIndex] Fetch text by
 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
 * @param {number} [opt.labelDimIndex] Fetch text by
 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
 * @param {string} [opt.labelProp] Fetch text by
 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
 * @param {Object} [normalSpecified]
 * @param {Object} [emphasisSpecified]
 */


function setLabelStyle(normalStyle, emphasisStyle, normalModel, emphasisModel, opt, normalSpecified, emphasisSpecified) {
  opt = opt || EMPTY_OBJ;
  var labelFetcher = opt.labelFetcher;
  var labelDataIndex = opt.labelDataIndex;
  var labelDimIndex = opt.labelDimIndex;
  var labelProp = opt.labelProp; // This scenario, `label.normal.show = true; label.emphasis.show = false`,
  // is not supported util someone requests.

  var showNormal = normalModel.getShallow('show');
  var showEmphasis = emphasisModel.getShallow('show'); // Consider performance, only fetch label when necessary.
  // If `normal.show` is `false` and `emphasis.show` is `true` and `emphasis.formatter` is not set,
  // label should be displayed, where text is fetched by `normal.formatter` or `opt.defaultText`.

  var baseText;

  if (showNormal || showEmphasis) {
    if (labelFetcher) {
      baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex, labelProp);
    }

    if (baseText == null) {
      baseText = zrUtil.isFunction(opt.defaultText) ? opt.defaultText(labelDataIndex, opt) : opt.defaultText;
    }
  }

  var normalStyleText = showNormal ? baseText : null;
  var emphasisStyleText = showEmphasis ? zrUtil.retrieve2(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, 'emphasis', null, labelDimIndex, labelProp) : null, baseText) : null; // Optimize: If style.text is null, text will not be drawn.

  if (normalStyleText != null || emphasisStyleText != null) {
    // Always set `textStyle` even if `normalStyle.text` is null, because default
    // values have to be set on `normalStyle`.
    // If we set default values on `emphasisStyle`, consider case:
    // Firstly, `setOption(... label: {normal: {text: null}, emphasis: {show: true}} ...);`
    // Secondly, `setOption(... label: {noraml: {show: true, text: 'abc', color: 'red'} ...);`
    // Then the 'red' will not work on emphasis.
    setTextStyle(normalStyle, normalModel, normalSpecified, opt);
    setTextStyle(emphasisStyle, emphasisModel, emphasisSpecified, opt, true);
  }

  normalStyle.text = normalStyleText;
  emphasisStyle.text = emphasisStyleText;
}
/**
 * Modify label style manually.
 * Only works after `setLabelStyle` and `setElementHoverStyle` called.
 *
 * @param {module:zrender/src/Element} el
 * @param {Object} [normalStyleProps] optional
 * @param {Object} [emphasisStyleProps] optional
 */


function modifyLabelStyle(el, normalStyleProps, emphasisStyleProps) {
  var elStyle = el.style;

  if (normalStyleProps) {
    rollbackDefaultTextStyle(elStyle);
    el.setStyle(normalStyleProps);
    applyDefaultTextStyle(elStyle);
  }

  elStyle = el.__hoverStl;

  if (emphasisStyleProps && elStyle) {
    rollbackDefaultTextStyle(elStyle);
    zrUtil.extend(elStyle, emphasisStyleProps);
    applyDefaultTextStyle(elStyle);
  }
}
/**
 * Set basic textStyle properties.
 * See more info in `setTextStyleCommon`.
 * @param {Object|module:zrender/graphic/Style} textStyle
 * @param {module:echarts/model/Model} model
 * @param {Object} [specifiedTextStyle] Can be overrided by settings in model.
 * @param {Object} [opt] See `opt` of `setTextStyleCommon`.
 * @param {boolean} [isEmphasis]
 */


function setTextStyle(textStyle, textStyleModel, specifiedTextStyle, opt, isEmphasis) {
  setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis);
  specifiedTextStyle && zrUtil.extend(textStyle, specifiedTextStyle); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);

  return textStyle;
}
/**
 * Set text option in the style.
 * See more info in `setTextStyleCommon`.
 * @deprecated
 * @param {Object} textStyle
 * @param {module:echarts/model/Model} labelModel
 * @param {string|boolean} defaultColor Default text color.
 *        If set as false, it will be processed as a emphasis style.
 */


function setText(textStyle, labelModel, defaultColor) {
  var opt = {
    isRectText: true
  };
  var isEmphasis;

  if (defaultColor === false) {
    isEmphasis = true;
  } else {
    // Support setting color as 'auto' to get visual color.
    opt.autoColor = defaultColor;
  }

  setTextStyleCommon(textStyle, labelModel, opt, isEmphasis); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
}
/**
 * The uniform entry of set text style, that is, retrieve style definitions
 * from `model` and set to `textStyle` object.
 *
 * Never in merge mode, but in overwrite mode, that is, all of the text style
 * properties will be set. (Consider the states of normal and emphasis and
 * default value can be adopted, merge would make the logic too complicated
 * to manage.)
 *
 * The `textStyle` object can either be a plain object or an instance of
 * `zrender/src/graphic/Style`, and either be the style of normal or emphasis.
 * After this mothod called, the `textStyle` object can then be used in
 * `el.setStyle(textStyle)` or `el.hoverStyle = textStyle`.
 *
 * Default value will be adopted and `insideRollbackOpt` will be created.
 * See `applyDefaultTextStyle` `rollbackDefaultTextStyle` for more details.
 *
 * opt: {
 *      disableBox: boolean, Whether diable drawing box of block (outer most).
 *      isRectText: boolean,
 *      autoColor: string, specify a color when color is 'auto',
 *              for textFill, textStroke, textBackgroundColor, and textBorderColor.
 *              If autoColor specified, it is used as default textFill.
 *      useInsideStyle:
 *              `true`: Use inside style (textFill, textStroke, textStrokeWidth)
 *                  if `textFill` is not specified.
 *              `false`: Do not use inside style.
 *              `null/undefined`: use inside style if `isRectText` is true and
 *                  `textFill` is not specified and textPosition contains `'inside'`.
 *      forceRich: boolean
 * }
 */


function setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis) {
  // Consider there will be abnormal when merge hover style to normal style if given default value.
  opt = opt || EMPTY_OBJ;

  if (opt.isRectText) {
    var textPosition;

    if (opt.getTextPosition) {
      textPosition = opt.getTextPosition(textStyleModel, isEmphasis);
    } else {
      textPosition = textStyleModel.getShallow('position') || (isEmphasis ? null : 'inside'); // 'outside' is not a valid zr textPostion value, but used
      // in bar series, and magric type should be considered.

      textPosition === 'outside' && (textPosition = 'top');
    }

    textStyle.textPosition = textPosition;
    textStyle.textOffset = textStyleModel.getShallow('offset');
    var labelRotate = textStyleModel.getShallow('rotate');
    labelRotate != null && (labelRotate *= Math.PI / 180);
    textStyle.textRotation = labelRotate;
    textStyle.textDistance = zrUtil.retrieve2(textStyleModel.getShallow('distance'), isEmphasis ? null : 5);
  }

  var ecModel = textStyleModel.ecModel;
  var globalTextStyle = ecModel && ecModel.option.textStyle; // Consider case:
  // {
  //     data: [{
  //         value: 12,
  //         label: {
  //             rich: {
  //                 // no 'a' here but using parent 'a'.
  //             }
  //         }
  //     }],
  //     rich: {
  //         a: { ... }
  //     }
  // }

  var richItemNames = getRichItemNames(textStyleModel);
  var richResult;

  if (richItemNames) {
    richResult = {};

    for (var name in richItemNames) {
      if (richItemNames.hasOwnProperty(name)) {
        // Cascade is supported in rich.
        var richTextStyle = textStyleModel.getModel(['rich', name]); // In rich, never `disableBox`.
        // FIXME: consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
        // the default color `'blue'` will not be adopted if no color declared in `rich`.
        // That might confuses users. So probably we should put `textStyleModel` as the
        // root ancestor of the `richTextStyle`. But that would be a break change.

        setTokenTextStyle(richResult[name] = {}, richTextStyle, globalTextStyle, opt, isEmphasis);
      }
    }
  }

  textStyle.rich = richResult;
  setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, true);

  if (opt.forceRich && !opt.textStyle) {
    opt.textStyle = {};
  }

  return textStyle;
} // Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             rich: {
//                 // no 'a' here but using parent 'a'.
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }


function getRichItemNames(textStyleModel) {
  // Use object to remove duplicated names.
  var richItemNameMap;

  while (textStyleModel && textStyleModel !== textStyleModel.ecModel) {
    var rich = (textStyleModel.option || EMPTY_OBJ).rich;

    if (rich) {
      richItemNameMap = richItemNameMap || {};

      for (var name in rich) {
        if (rich.hasOwnProperty(name)) {
          richItemNameMap[name] = 1;
        }
      }
    }

    textStyleModel = textStyleModel.parentModel;
  }

  return richItemNameMap;
}

function setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, isBlock) {
  // In merge mode, default value should not be given.
  globalTextStyle = !isEmphasis && globalTextStyle || EMPTY_OBJ;
  textStyle.textFill = getAutoColor(textStyleModel.getShallow('color'), opt) || globalTextStyle.color;
  textStyle.textStroke = getAutoColor(textStyleModel.getShallow('textBorderColor'), opt) || globalTextStyle.textBorderColor;
  textStyle.textStrokeWidth = zrUtil.retrieve2(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);

  if (!isEmphasis) {
    if (isBlock) {
      textStyle.insideRollbackOpt = opt;
      applyDefaultTextStyle(textStyle);
    } // Set default finally.


    if (textStyle.textFill == null) {
      textStyle.textFill = opt.autoColor;
    }
  } // Do not use `getFont` here, because merge should be supported, where
  // part of these properties may be changed in emphasis style, and the
  // others should remain their original value got from normal style.


  textStyle.fontStyle = textStyleModel.getShallow('fontStyle') || globalTextStyle.fontStyle;
  textStyle.fontWeight = textStyleModel.getShallow('fontWeight') || globalTextStyle.fontWeight;
  textStyle.fontSize = textStyleModel.getShallow('fontSize') || globalTextStyle.fontSize;
  textStyle.fontFamily = textStyleModel.getShallow('fontFamily') || globalTextStyle.fontFamily;
  textStyle.textAlign = textStyleModel.getShallow('align');
  textStyle.textVerticalAlign = textStyleModel.getShallow('verticalAlign') || textStyleModel.getShallow('baseline');
  textStyle.textLineHeight = textStyleModel.getShallow('lineHeight');
  textStyle.textWidth = textStyleModel.getShallow('width');
  textStyle.textHeight = textStyleModel.getShallow('height');
  textStyle.textTag = textStyleModel.getShallow('tag');

  if (!isBlock || !opt.disableBox) {
    textStyle.textBackgroundColor = getAutoColor(textStyleModel.getShallow('backgroundColor'), opt);
    textStyle.textPadding = textStyleModel.getShallow('padding');
    textStyle.textBorderColor = getAutoColor(textStyleModel.getShallow('borderColor'), opt);
    textStyle.textBorderWidth = textStyleModel.getShallow('borderWidth');
    textStyle.textBorderRadius = textStyleModel.getShallow('borderRadius');
    textStyle.textBoxShadowColor = textStyleModel.getShallow('shadowColor');
    textStyle.textBoxShadowBlur = textStyleModel.getShallow('shadowBlur');
    textStyle.textBoxShadowOffsetX = textStyleModel.getShallow('shadowOffsetX');
    textStyle.textBoxShadowOffsetY = textStyleModel.getShallow('shadowOffsetY');
  }

  textStyle.textShadowColor = textStyleModel.getShallow('textShadowColor') || globalTextStyle.textShadowColor;
  textStyle.textShadowBlur = textStyleModel.getShallow('textShadowBlur') || globalTextStyle.textShadowBlur;
  textStyle.textShadowOffsetX = textStyleModel.getShallow('textShadowOffsetX') || globalTextStyle.textShadowOffsetX;
  textStyle.textShadowOffsetY = textStyleModel.getShallow('textShadowOffsetY') || globalTextStyle.textShadowOffsetY;
}

function getAutoColor(color, opt) {
  return color !== 'auto' ? color : opt && opt.autoColor ? opt.autoColor : null;
}
/**
 * Give some default value to the input `textStyle` object, based on the current settings
 * in this `textStyle` object.
 *
 * The Scenario:
 * when text position is `inside` and `textFill` is not specified, we show
 * text border by default for better view. But it should be considered that text position
 * might be changed when hovering or being emphasis, where the `insideRollback` is used to
 * restore the style.
 *
 * Usage (& NOTICE):
 * When a style object (eithor plain object or instance of `zrender/src/graphic/Style`) is
 * about to be modified on its text related properties, `rollbackDefaultTextStyle` should
 * be called before the modification and `applyDefaultTextStyle` should be called after that.
 * (For the case that all of the text related properties is reset, like `setTextStyleCommon`
 * does, `rollbackDefaultTextStyle` is not needed to be called).
 */


function applyDefaultTextStyle(textStyle) {
  var textPosition = textStyle.textPosition;
  var opt = textStyle.insideRollbackOpt;
  var insideRollback;

  if (opt && textStyle.textFill == null) {
    var autoColor = opt.autoColor;
    var isRectText = opt.isRectText;
    var useInsideStyle = opt.useInsideStyle;
    var useInsideStyleCache = useInsideStyle !== false && (useInsideStyle === true || isRectText && textPosition // textPosition can be [10, 30]
    && typeof textPosition === 'string' && textPosition.indexOf('inside') >= 0);
    var useAutoColorCache = !useInsideStyleCache && autoColor != null; // All of the props declared in `CACHED_LABEL_STYLE_PROPERTIES` are to be cached.

    if (useInsideStyleCache || useAutoColorCache) {
      insideRollback = {
        textFill: textStyle.textFill,
        textStroke: textStyle.textStroke,
        textStrokeWidth: textStyle.textStrokeWidth
      };
    }

    if (useInsideStyleCache) {
      textStyle.textFill = '#fff'; // Consider text with #fff overflow its container.

      if (textStyle.textStroke == null) {
        textStyle.textStroke = autoColor;
        textStyle.textStrokeWidth == null && (textStyle.textStrokeWidth = 2);
      }
    }

    if (useAutoColorCache) {
      textStyle.textFill = autoColor;
    }
  } // Always set `insideRollback`, so that the previous one can be cleared.


  textStyle.insideRollback = insideRollback;
}
/**
 * Consider the case: in a scatter,
 * label: {
 *     normal: {position: 'inside'},
 *     emphasis: {position: 'top'}
 * }
 * In the normal state, the `textFill` will be set as '#fff' for pretty view (see
 * `applyDefaultTextStyle`), but when switching to emphasis state, the `textFill`
 * should be retured to 'autoColor', but not keep '#fff'.
 */


function rollbackDefaultTextStyle(style) {
  var insideRollback = style.insideRollback;

  if (insideRollback) {
    // Reset all of the props in `CACHED_LABEL_STYLE_PROPERTIES`.
    style.textFill = insideRollback.textFill;
    style.textStroke = insideRollback.textStroke;
    style.textStrokeWidth = insideRollback.textStrokeWidth;
    style.insideRollback = null;
  }
}

function getFont(opt, ecModel) {
  var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
  return zrUtil.trim([// FIXME in node-canvas fontWeight is before fontStyle
  opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '', opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '', (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px', opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'].join(' '));
}

function animateOrSetProps(isUpdate, el, props, animatableModel, dataIndex, cb) {
  if (typeof dataIndex === 'function') {
    cb = dataIndex;
    dataIndex = null;
  } // Do not check 'animation' property directly here. Consider this case:
  // animation model is an `itemModel`, whose does not have `isAnimationEnabled`
  // but its parent model (`seriesModel`) does.


  var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();

  if (animationEnabled) {
    var postfix = isUpdate ? 'Update' : '';
    var duration = animatableModel.getShallow('animationDuration' + postfix);
    var animationEasing = animatableModel.getShallow('animationEasing' + postfix);
    var animationDelay = animatableModel.getShallow('animationDelay' + postfix);

    if (typeof animationDelay === 'function') {
      animationDelay = animationDelay(dataIndex, animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
    }

    if (typeof duration === 'function') {
      duration = duration(dataIndex);
    }

    duration > 0 ? el.animateTo(props, duration, animationDelay || 0, animationEasing, cb, !!cb) : (el.stopAnimation(), el.attr(props), cb && cb());
  } else {
    el.stopAnimation();
    el.attr(props);
    cb && cb();
  }
}
/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 *
 * @param {module:zrender/Element} el
 * @param {Object} props
 * @param {module:echarts/model/Model} [animatableModel]
 * @param {number} [dataIndex]
 * @param {Function} [cb]
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */


function updateProps(el, props, animatableModel, dataIndex, cb) {
  animateOrSetProps(true, el, props, animatableModel, dataIndex, cb);
}
/**
 * Init graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 *
 * @param {module:zrender/Element} el
 * @param {Object} props
 * @param {module:echarts/model/Model} [animatableModel]
 * @param {number} [dataIndex]
 * @param {Function} cb
 */


function initProps(el, props, animatableModel, dataIndex, cb) {
  animateOrSetProps(false, el, props, animatableModel, dataIndex, cb);
}
/**
 * Get transform matrix of target (param target),
 * in coordinate of its ancestor (param ancestor)
 *
 * @param {module:zrender/mixin/Transformable} target
 * @param {module:zrender/mixin/Transformable} [ancestor]
 */


function getTransform(target, ancestor) {
  var mat = matrix.identity([]);

  while (target && target !== ancestor) {
    matrix.mul(mat, target.getLocalTransform(), mat);
    target = target.parent;
  }

  return mat;
}
/**
 * Apply transform to an vertex.
 * @param {Array.<number>} target [x, y]
 * @param {Array.<number>|TypedArray.<number>|Object} transform Can be:
 *      + Transform matrix: like [1, 0, 0, 1, 0, 0]
 *      + {position, rotation, scale}, the same as `zrender/Transformable`.
 * @param {boolean=} invert Whether use invert matrix.
 * @return {Array.<number>} [x, y]
 */


function applyTransform(target, transform, invert) {
  if (transform && !zrUtil.isArrayLike(transform)) {
    transform = Transformable.getLocalTransform(transform);
  }

  if (invert) {
    transform = matrix.invert([], transform);
  }

  return vector.applyTransform([], target, transform);
}
/**
 * @param {string} direction 'left' 'right' 'top' 'bottom'
 * @param {Array.<number>} transform Transform matrix: like [1, 0, 0, 1, 0, 0]
 * @param {boolean=} invert Whether use invert matrix.
 * @return {string} Transformed direction. 'left' 'right' 'top' 'bottom'
 */


function transformDirection(direction, transform, invert) {
  // Pick a base, ensure that transform result will not be (0, 0).
  var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
  var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
  var vertex = [direction === 'left' ? -hBase : direction === 'right' ? hBase : 0, direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0];
  vertex = applyTransform(vertex, transform, invert);
  return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
}
/**
 * Apply group transition animation from g1 to g2.
 * If no animatableModel, no animation.
 */


function groupTransition(g1, g2, animatableModel, cb) {
  if (!g1 || !g2) {
    return;
  }

  function getElMap(g) {
    var elMap = {};
    g.traverse(function (el) {
      if (!el.isGroup && el.anid) {
        elMap[el.anid] = el;
      }
    });
    return elMap;
  }

  function getAnimatableProps(el) {
    var obj = {
      position: vector.clone(el.position),
      rotation: el.rotation
    };

    if (el.shape) {
      obj.shape = zrUtil.extend({}, el.shape);
    }

    return obj;
  }

  var elMap1 = getElMap(g1);
  g2.traverse(function (el) {
    if (!el.isGroup && el.anid) {
      var oldEl = elMap1[el.anid];

      if (oldEl) {
        var newProp = getAnimatableProps(el);
        el.attr(getAnimatableProps(oldEl));
        updateProps(el, newProp, animatableModel, el.dataIndex);
      } // else {
      //     if (el.previousProps) {
      //         graphic.updateProps
      //     }
      // }

    }
  });
}
/**
 * @param {Array.<Array.<number>>} points Like: [[23, 44], [53, 66], ...]
 * @param {Object} rect {x, y, width, height}
 * @return {Array.<Array.<number>>} A new clipped points.
 */


function clipPointsByRect(points, rect) {
  // FIXME: this way migth be incorrect when grpahic clipped by a corner.
  // and when element have border.
  return zrUtil.map(points, function (point) {
    var x = point[0];
    x = mathMax(x, rect.x);
    x = mathMin(x, rect.x + rect.width);
    var y = point[1];
    y = mathMax(y, rect.y);
    y = mathMin(y, rect.y + rect.height);
    return [x, y];
  });
}
/**
 * @param {Object} targetRect {x, y, width, height}
 * @param {Object} rect {x, y, width, height}
 * @return {Object} A new clipped rect. If rect size are negative, return undefined.
 */


function clipRectByRect(targetRect, rect) {
  var x = mathMax(targetRect.x, rect.x);
  var x2 = mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
  var y = mathMax(targetRect.y, rect.y);
  var y2 = mathMin(targetRect.y + targetRect.height, rect.y + rect.height); // If the total rect is cliped, nothing, including the border,
  // should be painted. So return undefined.

  if (x2 >= x && y2 >= y) {
    return {
      x: x,
      y: y,
      width: x2 - x,
      height: y2 - y
    };
  }
}
/**
 * @param {string} iconStr Support 'image://' or 'path://' or direct svg path.
 * @param {Object} [opt] Properties of `module:zrender/Element`, except `style`.
 * @param {Object} [rect] {x, y, width, height}
 * @return {module:zrender/Element} Icon path or image element.
 */


function createIcon(iconStr, opt, rect) {
  opt = zrUtil.extend({
    rectHover: true
  }, opt);
  var style = opt.style = {
    strokeNoScale: true
  };
  rect = rect || {
    x: -1,
    y: -1,
    width: 2,
    height: 2
  };

  if (iconStr) {
    return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), zrUtil.defaults(style, rect), new ZImage(opt)) : makePath(iconStr.replace('path://', ''), opt, rect, 'center');
  }
}
/**
 * Return `true` if the given line (line `a`) and the given polygon
 * are intersect.
 * Note that we do not count colinear as intersect here because no
 * requirement for that. We could do that if required in future.
 *
 * @param {number} a1x
 * @param {number} a1y
 * @param {number} a2x
 * @param {number} a2y
 * @param {Array.<Array.<number>>} points Points of the polygon.
 * @return {boolean}
 */


function linePolygonIntersect(a1x, a1y, a2x, a2y, points) {
  for (var i = 0, p2 = points[points.length - 1]; i < points.length; i++) {
    var p = points[i];

    if (lineLineIntersect(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) {
      return true;
    }

    p2 = p;
  }
}
/**
 * Return `true` if the given two lines (line `a` and line `b`)
 * are intersect.
 * Note that we do not count colinear as intersect here because no
 * requirement for that. We could do that if required in future.
 *
 * @param {number} a1x
 * @param {number} a1y
 * @param {number} a2x
 * @param {number} a2y
 * @param {number} b1x
 * @param {number} b1y
 * @param {number} b2x
 * @param {number} b2y
 * @return {boolean}
 */


function lineLineIntersect(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
  // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
  var mx = a2x - a1x;
  var my = a2y - a1y;
  var nx = b2x - b1x;
  var ny = b2y - b1y; // `vec_m` and `vec_n` are parallel iff
  //     exising `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.

  var nmCrossProduct = crossProduct2d(nx, ny, mx, my);

  if (nearZero(nmCrossProduct)) {
    return false;
  } // `vec_m` and `vec_n` are intersect iff
  //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
  //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
  //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.


  var b1a1x = a1x - b1x;
  var b1a1y = a1y - b1y;
  var q = crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;

  if (q < 0 || q > 1) {
    return false;
  }

  var p = crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;

  if (p < 0 || p > 1) {
    return false;
  }

  return true;
}
/**
 * Cross product of 2-dimension vector.
 */


function crossProduct2d(x1, y1, x2, y2) {
  return x1 * y2 - x2 * y1;
}

function nearZero(val) {
  return val <= 1e-6 && val >= -1e-6;
} // Register built-in shapes. These shapes might be overwirtten
// by users, although we do not recommend that.


registerShape('circle', Circle);
registerShape('sector', Sector);
registerShape('ring', Ring);
registerShape('polygon', Polygon);
registerShape('polyline', Polyline);
registerShape('rect', Rect);
registerShape('line', Line);
registerShape('bezierCurve', BezierCurve);
registerShape('arc', Arc);
exports.Z2_EMPHASIS_LIFT = Z2_EMPHASIS_LIFT;
exports.CACHED_LABEL_STYLE_PROPERTIES = CACHED_LABEL_STYLE_PROPERTIES;
exports.extendShape = extendShape;
exports.extendPath = extendPath;
exports.registerShape = registerShape;
exports.getShapeClass = getShapeClass;
exports.makePath = makePath;
exports.makeImage = makeImage;
exports.mergePath = mergePath;
exports.resizePath = resizePath;
exports.subPixelOptimizeLine = subPixelOptimizeLine;
exports.subPixelOptimizeRect = subPixelOptimizeRect;
exports.subPixelOptimize = subPixelOptimize;
exports.setElementHoverStyle = setElementHoverStyle;
exports.setHoverStyle = setHoverStyle;
exports.setAsHighDownDispatcher = setAsHighDownDispatcher;
exports.isHighDownDispatcher = isHighDownDispatcher;
exports.getHighlightDigit = getHighlightDigit;
exports.setLabelStyle = setLabelStyle;
exports.modifyLabelStyle = modifyLabelStyle;
exports.setTextStyle = setTextStyle;
exports.setText = setText;
exports.getFont = getFont;
exports.updateProps = updateProps;
exports.initProps = initProps;
exports.getTransform = getTransform;
exports.applyTransform = applyTransform;
exports.transformDirection = transformDirection;
exports.groupTransition = groupTransition;
exports.clipPointsByRect = clipPointsByRect;
exports.clipRectByRect = clipRectByRect;
exports.createIcon = createIcon;
exports.linePolygonIntersect = linePolygonIntersect;
exports.lineLineIntersect = lineLineIntersect;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(a,b){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)b();else{b(),a.FileSaver={exports:{}}.exports}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(a,b,c){var d=new XMLHttpRequest;d.open("GET",a),d.responseType="blob",d.onload=function(){g(d.response,b,c)},d.onerror=function(){console.error("could not download file")},d.send()}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send()}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof global&&global.global===global?global:void 0,a=f.navigator&&/Macintosh/.test(navigator.userAgent)&&/AppleWebKit/.test(navigator.userAgent)&&!/Safari/.test(navigator.userAgent),g=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype&&!a?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(b,d,e,g){if(g=g||open("","_blank"),g&&(g.document.title=g.document.body.innerText="downloading..."),"string"==typeof b)return c(b,d,e);var h="application/octet-stream"===b.type,i=/constructor/i.test(f.HTMLElement)||f.safari,j=/CriOS\/[\d]+/.test(navigator.userAgent);if((j||h&&i||a)&&"undefined"!=typeof FileReader){var k=new FileReader;k.onloadend=function(){var a=k.result;a=j?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),g?g.location.href=a:location=a,g=null},k.readAsDataURL(b)}else{var l=f.URL||f.webkitURL,m=l.createObjectURL(b);g?g.location=m:location.href=m,g=null,setTimeout(function(){l.revokeObjectURL(m)},4E4)}});f.saveAs=g.saveAs=g,"undefined"!=typeof module&&(module.exports=g)});

//# sourceMappingURL=FileSaver.min.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.18.1';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`',
      INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            };
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);

      // Prevent prototype pollution:
      // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
      // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
      var index = -1,
          length = path.length;

      if (!length) {
        return true;
      }

      while (++index < length) {
        var key = toKey(path[index]);

        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) {
          return false;
        }

        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) {
          return false;
        }
      }

      var obj = parent(object, path);
      return obj == null || delete obj[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        baseAssignValue(result, pair[0], pair[1]);
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      arrayEach(importsKeys, function(key) {
        if (reForbiddenIdentifierChars.test(key)) {
          throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
        }
      });

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80), __webpack_require__(220)(module)))

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "$mobx", function() { return $mobx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FlowCancellationError", function() { return FlowCancellationError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IDerivationState", function() { return IDerivationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableMap", function() { return ObservableMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableSet", function() { return ObservableSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Reaction", function() { return Reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_allowStateChanges", function() { return allowStateChanges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_allowStateChangesInsideComputed", function() { return allowStateChangesInsideComputed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_allowStateReadsEnd", function() { return allowStateReadsEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_allowStateReadsStart", function() { return allowStateReadsStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_endAction", function() { return _endAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_getAdministration", function() { return getAdministration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_getGlobalState", function() { return getGlobalState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_interceptReads", function() { return interceptReads; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_isComputingDerivation", function() { return isComputingDerivation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_resetGlobalState", function() { return resetGlobalState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_startAction", function() { return _startAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "action", function() { return action; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autorun", function() { return autorun; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "comparer", function() { return comparer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computed", function() { return computed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "configure", function() { return configure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createAtom", function() { return createAtom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decorate", function() { return decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "entries", function() { return entries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendObservable", function() { return extendObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendShallowObservable", function() { return extendShallowObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flow", function() { return flow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAtom", function() { return getAtom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDebugName", function() { return getDebugName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDependencyTree", function() { return getDependencyTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getObserverTree", function() { return getObserverTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "has", function() { return has; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intercept", function() { return intercept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAction", function() { return isAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isArrayLike", function() { return isArrayLike; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBoxedObservable", function() { return isObservableValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isComputed", function() { return isComputed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isComputedProp", function() { return isComputedProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFlowCancellationError", function() { return isFlowCancellationError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservable", function() { return isObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableArray", function() { return isObservableArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableMap", function() { return isObservableMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableObject", function() { return isObservableObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableProp", function() { return isObservableProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableSet", function() { return isObservableSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keys", function() { return keys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observable", function() { return observable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observe", function() { return observe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBecomeObserved", function() { return onBecomeObserved; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBecomeUnobserved", function() { return onBecomeUnobserved; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onReactionError", function() { return onReactionError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reaction", function() { return reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "remove", function() { return remove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runInAction", function() { return runInAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "set", function() { return set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "spy", function() { return spy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toJS", function() { return toJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trace", function() { return trace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transaction", function() { return transaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "untracked", function() { return untracked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "values", function() { return values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "when", function() { return when; });
/** MobX - (c) Michel Weststrate 2015 - 2020 - MIT Licensed */
var OBFUSCATED_ERROR = "An invariant failed, however the error is obfuscated because this is an production build.";
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var mockGlobal = {};
function getGlobal() {
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    return mockGlobal;
}
function getNextId() {
    return ++globalState.mobxGuid;
}
function fail(message) {
    invariant(false, message);
    throw "X"; // unreachable
}
function invariant(check, message) {
    if (!check)
        throw new Error("[mobx] " + (message || OBFUSCATED_ERROR));
}
/**
 * Prints a deprecation message, but only one time.
 * Returns false if the deprecated message was already printed before
 */
var deprecatedMessages = [];
function deprecated(msg, thing) {
    if (true)
        return false;
    if (thing) {
        return deprecated("'" + msg + "', use '" + thing + "' instead.");
    }
    if (deprecatedMessages.indexOf(msg) !== -1)
        return false;
    deprecatedMessages.push(msg);
    console.error("[mobx] Deprecated: " + msg);
    return true;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */
function once(func) {
    var invoked = false;
    return function () {
        if (invoked)
            return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function () { };
function unique(list) {
    var res = [];
    list.forEach(function (item) {
        if (res.indexOf(item) === -1)
            res.push(item);
    });
    return res;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (value === null || typeof value !== "object")
        return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) {
        return dataStructure;
    }
    else if (Array.isArray(dataStructure)) {
        return new Map(dataStructure);
    }
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for (var key in dataStructure) {
            map.set(key, dataStructure[key]);
        }
        return map;
    }
    else {
        return fail("Cannot convert to map from '" + dataStructure + "'");
    }
}
function makeNonEnumerable(object, propNames) {
    for (var i = 0; i < propNames.length; i++) {
        addHiddenProp(object, propNames[i], object[propNames[i]]);
    }
}
function addHiddenProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function isPropertyConfigurable(object, prop) {
    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
}
function assertPropertyConfigurable(object, prop) {
    if (false)
        fail("Cannot make property '" + prop + "' observable, it is not configurable and writable in the target object");
}
function createInstanceofPredicate(name, clazz) {
    var propName = "isMobX" + name;
    clazz.prototype[propName] = true;
    return function (x) {
        return isObject(x) && x[propName] === true;
    };
}
function areBothNaN(a, b) {
    return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
}
/**
 * Returns whether the argument is an array, disregarding observability.
 */
function isArrayLike(x) {
    return Array.isArray(x) || isObservableArray(x);
}
function isES6Map(thing) {
    if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map)
        return true;
    return false;
}
function isES6Set(thing) {
    return thing instanceof Set;
}
// use Array.from in Mobx 5
function iteratorToArray(it) {
    var res = [];
    while (true) {
        var r = it.next();
        if (r.done)
            break;
        res.push(r.value);
    }
    return res;
}
function primitiveSymbol() {
    // es-disable-next-line
    return (typeof Symbol === "function" && Symbol.toPrimitive) || "@@toPrimitive";
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
// Use "for of" in V5
function forOf(iter, callback) {
    var next = iter.next();
    while (!next.done) {
        callback(next.value);
        next = iter.next();
    }
}

function iteratorSymbol() {
    return (typeof Symbol === "function" && Symbol.iterator) || "@@iterator";
}
function declareIterator(prototType, iteratorFactory) {
    addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
}
function makeIterable(iterator) {
    iterator[iteratorSymbol()] = getSelf;
    return iterator;
}
function toStringTagSymbol() {
    return (typeof Symbol === "function" && Symbol.toStringTag) || "@@toStringTag";
}
function getSelf() {
    return this;
}

/**
 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
 *
 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
 */
var Atom = /** @class */ (function () {
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function Atom(name) {
        if (name === void 0) { name = "Atom@" + getNextId(); }
        this.name = name;
        this.isPendingUnobservation = false; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
        this.isBeingObserved = false;
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.NOT_TRACKING;
    }
    Atom.prototype.onBecomeUnobserved = function () {
        // noop
    };
    Atom.prototype.onBecomeObserved = function () {
        /* noop */
    };
    /**
     * Invoke this method to notify mobx that your atom has been used somehow.
     * Returns true if there is currently a reactive context.
     */
    Atom.prototype.reportObserved = function () {
        return reportObserved(this);
    };
    /**
     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
     */
    Atom.prototype.reportChanged = function () {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    Atom.prototype.toString = function () {
        return this.name;
    };
    return Atom;
}());
var isAtom = createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop; }
    if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop; }
    var atom = new Atom(name);
    onBecomeObserved(atom, onBecomeObservedHandler);
    onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}

function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    return areBothNaN(a, b) || identityComparer(a, b);
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    default: defaultComparer,
    shallow: shallowComparer
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var enumerableDescriptorCache = {};
var nonEnumerableDescriptorCache = {};
function createPropertyInitializerDescriptor(prop, enumerable) {
    var cache = enumerable ? enumerableDescriptorCache : nonEnumerableDescriptorCache;
    return (cache[prop] ||
        (cache[prop] = {
            configurable: true,
            enumerable: enumerable,
            get: function () {
                initializeInstance(this);
                return this[prop];
            },
            set: function (value) {
                initializeInstance(this);
                this[prop] = value;
            }
        }));
}
function initializeInstance(target) {
    if (target.__mobxDidRunLazyInitializers === true)
        return;
    var decorators = target.__mobxDecorators;
    if (decorators) {
        addHiddenProp(target, "__mobxDidRunLazyInitializers", true);
        for (var key in decorators) {
            var d = decorators[key];
            d.propertyCreator(target, d.prop, d.descriptor, d.decoratorTarget, d.decoratorArguments);
        }
    }
}
function createPropDecorator(propertyInitiallyEnumerable, propertyCreator) {
    return function decoratorFactory() {
        var decoratorArguments;
        var decorator = function decorate(target, prop, descriptor, applyImmediately
        // This is a special parameter to signal the direct application of a decorator, allow extendObservable to skip the entire type decoration part,
        // as the instance to apply the decorator to equals the target
        ) {
            if (applyImmediately === true) {
                propertyCreator(target, prop, descriptor, target, decoratorArguments);
                return null;
            }
            if (false)
                fail("This function is a decorator, but it wasn't invoked like a decorator");
            if (!Object.prototype.hasOwnProperty.call(target, "__mobxDecorators")) {
                var inheritedDecorators = target.__mobxDecorators;
                addHiddenProp(target, "__mobxDecorators", __assign({}, inheritedDecorators));
            }
            target.__mobxDecorators[prop] = {
                prop: prop,
                propertyCreator: propertyCreator,
                descriptor: descriptor,
                decoratorTarget: target,
                decoratorArguments: decoratorArguments
            };
            return createPropertyInitializerDescriptor(prop, propertyInitiallyEnumerable);
        };
        if (quacksLikeADecorator(arguments)) {
            // @decorator
            decoratorArguments = EMPTY_ARRAY;
            return decorator.apply(null, arguments);
        }
        else {
            // @decorator(args)
            decoratorArguments = Array.prototype.slice.call(arguments);
            return decorator;
        }
    };
}
function quacksLikeADecorator(args) {
    return (((args.length === 2 || args.length === 3) && typeof args[1] === "string") ||
        (args.length === 4 && args[3] === true));
}

function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return observable.array(v, { name: name });
    if (isPlainObject(v))
        return observable.object(v, undefined, { name: name });
    if (isES6Map(v))
        return observable.map(v, { name: name });
    if (isES6Set(v))
        return observable.set(v, { name: name });
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null)
        return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v))
        return v;
    if (Array.isArray(v))
        return observable.array(v, { name: name, deep: false });
    if (isPlainObject(v))
        return observable.object(v, undefined, { name: name, deep: false });
    if (isES6Map(v))
        return observable.map(v, { name: name, deep: false });
    if (isES6Set(v))
        return observable.set(v, { name: name, deep: false });
    return fail("production" !== "production" &&
        "The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue, name) {
    if (false)
        throw "observable.struct should not be used with observable values";
    if (deepEqual(v, oldValue))
        return oldValue;
    return v;
}

function createDecoratorForEnhancer(enhancer) {
    invariant(enhancer);
    var decorator = createPropDecorator(true, function (target, propertyName, descriptor, _decoratorTarget, decoratorArgs) {
        if (false) {
            invariant(!descriptor || !descriptor.get, "@observable cannot be used on getter (property \"" + propertyName + "\"), use @computed instead.");
        }
        var initialValue = descriptor
            ? descriptor.initializer
                ? descriptor.initializer.call(target)
                : descriptor.value
            : undefined;
        defineObservableProperty(target, propertyName, initialValue, enhancer);
    });
    var res = 
    // Extra process checks, as this happens during module initialization
    typeof process !== "undefined" && Object({"NODE_ENV":"production","PUBLIC_URL":""}) && "production" !== "production"
        ? function observableDecorator() {
            // This wrapper function is just to detect illegal decorator invocations, deprecate in a next version
            // and simply return the created prop decorator
            if (arguments.length < 2)
                return fail("Incorrect decorator invocation. @observable decorator doesn't expect any arguments");
            return decorator.apply(null, arguments);
        }
        : decorator;
    res.enhancer = enhancer;
    return res;
}

// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined
};
var shallowCreateObservableOptions = {
    deep: false,
    name: undefined,
    defaultDecorator: undefined
};
Object.freeze(defaultCreateObservableOptions);
Object.freeze(shallowCreateObservableOptions);
function assertValidOption(key) {
    if (!/^(deep|name|equals|defaultDecorator)$/.test(key))
        fail("invalid option for (extend)observable: " + key);
}
function asCreateObservableOptions(thing) {
    if (thing === null || thing === undefined)
        return defaultCreateObservableOptions;
    if (typeof thing === "string")
        return { name: thing, deep: true };
    if (false) {
        if (typeof thing !== "object")
            return fail("expected options object");
        Object.keys(thing).forEach(assertValidOption);
    }
    return thing;
}
function getEnhancerFromOptions(options) {
    return options.defaultDecorator
        ? options.defaultDecorator.enhancer
        : options.deep === false
            ? referenceEnhancer
            : deepEnhancer;
}
var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */
function createObservable(v, arg2, arg3) {
    // @observable someProp;
    if (typeof arguments[1] === "string") {
        return deepDecorator.apply(null, arguments);
    }
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    var res = isPlainObject(v)
        ? observable.object(v, arg2, arg3)
        : Array.isArray(v)
            ? observable.array(v, arg2)
            : isES6Map(v)
                ? observable.map(v, arg2)
                : isES6Set(v)
                    ? observable.set(v, arg2)
                    : v;
    // this value could be converted to a new observable data structure, return it
    if (res !== v)
        return res;
    // otherwise, just box it
    fail("production" !== "production" &&
        "The provided value could not be converted into an observable. If you want just create an observable reference to the object use 'observable.box(value)'");
}
var observableFactories = {
    box: function (value, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("box");
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    shallowBox: function (value, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowBox");
        deprecated("observable.shallowBox", "observable.box(value, { deep: false })");
        return observable.box(value, { name: name, deep: false });
    },
    array: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("array");
        var o = asCreateObservableOptions(options);
        return new ObservableArray(initialValues, getEnhancerFromOptions(o), o.name);
    },
    shallowArray: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowArray");
        deprecated("observable.shallowArray", "observable.array(values, { deep: false })");
        return observable.array(initialValues, { name: name, deep: false });
    },
    map: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("map");
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    shallowMap: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowMap");
        deprecated("observable.shallowMap", "observable.map(values, { deep: false })");
        return observable.map(initialValues, { name: name, deep: false });
    },
    set: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("set");
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function (props, decorators, options) {
        if (typeof arguments[1] === "string")
            incorrectlyUsedAsDecorator("object");
        var o = asCreateObservableOptions(options);
        return extendObservable({}, props, decorators, o);
    },
    shallowObject: function (props, name) {
        if (typeof arguments[1] === "string")
            incorrectlyUsedAsDecorator("shallowObject");
        deprecated("observable.shallowObject", "observable.object(values, {}, { deep: false })");
        return observable.object(props, {}, { name: name, deep: false });
    },
    ref: refDecorator,
    shallow: shallowDecorator,
    deep: deepDecorator,
    struct: refStructDecorator
};
var observable = createObservable;
// weird trick to keep our typings nicely with our funcs, and still extend the observable function
Object.keys(observableFactories).forEach(function (name) { return (observable[name] = observableFactories[name]); });
function incorrectlyUsedAsDecorator(methodName) {
    fail(
    // process.env.NODE_ENV !== "production" &&
    "Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
}

var computedDecorator = createPropDecorator(false, function (instance, propertyName, descriptor, decoratorTarget, decoratorArgs) {
    if (false) {
        invariant(descriptor && descriptor.get, "Trying to declare a computed value for unspecified getter '" + propertyName + "'");
    }
    var get = descriptor.get, set = descriptor.set; // initialValue is the descriptor for get / set props
    // Optimization: faster on decorator target or instance? Assuming target
    // Optimization: find out if declaring on instance isn't just faster. (also makes the property descriptor simpler). But, more memory usage..
    // Forcing instance now, fixes hot reloadig issues on React Native:
    var options = decoratorArgs[0] || {};
    defineComputedProperty(instance, propertyName, __assign({ get: get, set: set }, options));
});
var computedStructDecorator = computedDecorator({ equals: comparer.structural });
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */
var computed = function computed(arg1, arg2, arg3) {
    if (typeof arg2 === "string") {
        // @computed
        return computedDecorator.apply(null, arguments);
    }
    if (arg1 !== null && typeof arg1 === "object" && arguments.length === 1) {
        // @computed({ options })
        return computedDecorator.apply(null, arguments);
    }
    // computed(expr, options?)
    if (false) {
        invariant(typeof arg1 === "function", "First argument to `computed` should be an expression.");
        invariant(arguments.length < 3, "Computed takes one or two arguments if used as function");
    }
    var opts = typeof arg2 === "object" ? arg2 : {};
    opts.get = arg1;
    opts.set = typeof arg2 === "function" ? arg2 : opts.set;
    opts.name = opts.name || arg1.name || ""; /* for generated name */
    return new ComputedValue(opts);
};
computed.struct = computedStructDecorator;

var IDerivationState;
(function (IDerivationState) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
})(IDerivationState || (IDerivationState = {}));
var TraceMode;
(function (TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = /** @class */ (function () {
    function CaughtException(cause) {
        this.cause = cause;
        // Empty
    }
    return CaughtException;
}());
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */
function shouldCompute(derivation) {
    switch (derivation.dependenciesState) {
        case IDerivationState.UP_TO_DATE:
            return false;
        case IDerivationState.NOT_TRACKING:
        case IDerivationState.STALE:
            return true;
        case IDerivationState.POSSIBLY_STALE: {
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing, l = obs.length;
            for (var i = 0; i < l; i++) {
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) {
                        obj.get();
                    }
                    else {
                        try {
                            obj.get();
                        }
                        catch (e) {
                            // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                            untrackedEnd(prevUntracked);
                            allowStateReadsEnd(prevAllowStateReads);
                            return true;
                        }
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState === IDerivationState.STALE) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
        }
    }
}
// function invariantShouldCompute(derivation: IDerivation) {
//     const newDepState = (derivation as any).dependenciesState
//     if (
//         process.env.NODE_ENV === "production" &&
//         (newDepState === IDerivationState.POSSIBLY_STALE ||
//             newDepState === IDerivationState.NOT_TRACKING)
//     )
//         fail("Illegal dependency state")
// }
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers = atom.observers.length > 0;
    // Should never be possible to change an observed observable from inside computed, see #798
    if (globalState.computationDepth > 0 && hasObservers)
        fail("production" !== "production" &&
            "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: " + atom.name);
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState.allowStateChanges && (hasObservers || globalState.enforceActions === "strict"))
        fail("production" !== "production" &&
            (globalState.enforceActions
                ? "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: "
                : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ") +
                atom.name);
}
function checkIfStateReadsAreAllowed(observable) {
    if (false) {
        console.warn("[mobx] Observable " + observable.name + " being read outside a reactive context");
    }
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */
function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving = new Array(derivation.observing.length + 100);
    derivation.unboundDepsCount = 0;
    derivation.runId = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    var result;
    if (globalState.disableErrorBoundaries === true) {
        result = f.call(context);
    }
    else {
        try {
            result = f.call(context);
        }
        catch (e) {
            result = new CaughtException(e);
        }
    }
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    if (derivation.observing.length === 0) {
        warnAboutDerivationWithoutDependencies(derivation);
    }
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    if (true)
        return;
    if (globalState.reactionRequiresObservable || derivation.requiresObservable) {
        console.warn("[mobx] Derivation " + derivation.name + " is created/updated without reading any observable value");
    }
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */
function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing;
    var observing = (derivation.observing = derivation.newObserving);
    var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount;
    for (var i = 0; i < l; i++) {
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i)
                observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState > lowestNewObservingDerivationState) {
            lowestNewObservingDerivationState = dep.dependenciesState;
        }
    }
    observing.length = i0;
    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while (l--) {
        var dep = prevObserving[l];
        if (dep.diffValue === 0) {
            removeObserver(dep, derivation);
        }
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while (i0--) {
        var dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            addObserver(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
        derivation.dependenciesState = lowestNewObservingDerivationState;
        derivation.onBecomeStale();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing;
    derivation.observing = [];
    var i = obs.length;
    while (i--)
        removeObserver(obs[i], derivation);
    derivation.dependenciesState = IDerivationState.NOT_TRACKING;
}
function untracked(action) {
    var prev = untrackedStart();
    var res = action();
    untrackedEnd(prev);
    return res;
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */
function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState === IDerivationState.UP_TO_DATE)
        return;
    derivation.dependenciesState = IDerivationState.UP_TO_DATE;
    var obs = derivation.observing;
    var i = obs.length;
    while (i--)
        obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
}

// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var functionNameDescriptor = Object.getOwnPropertyDescriptor(function () { }, "name");
var isFunctionNameConfigurable = functionNameDescriptor && functionNameDescriptor.configurable;
function createAction(actionName, fn) {
    if (false) {
        invariant(typeof fn === "function", "`action` can only be invoked on functions");
        if (typeof actionName !== "string" || !actionName)
            fail("actions should have valid names, got: '" + actionName + "'");
    }
    var res = function () {
        return executeAction(actionName, fn, this, arguments);
    };
    if (false) {
        if (isFunctionNameConfigurable) {
            Object.defineProperty(res, "name", { value: actionName });
        }
    }
    res.isMobxAction = true;
    return res;
}
function executeAction(actionName, fn, scope, args) {
    var runInfo = _startAction(actionName, scope, args);
    try {
        return fn.apply(scope, args);
    }
    catch (err) {
        runInfo.error = err;
        throw err;
    }
    finally {
        _endAction(runInfo);
    }
}
function _startAction(actionName, scope, args) {
    var notifySpy = isSpyEnabled() && !!actionName;
    var startTime = 0;
    if (notifySpy) {
        startTime = Date.now();
        var l = (args && args.length) || 0;
        var flattendArgs = new Array(l);
        if (l > 0)
            for (var i = 0; i < l; i++)
                flattendArgs[i] = args[i];
        spyReportStart({
            type: "action",
            name: actionName,
            object: scope,
            arguments: flattendArgs
        });
    }
    var prevDerivation = untrackedStart();
    startBatch();
    var prevAllowStateChanges = allowStateChangesStart(true);
    var prevAllowStateReads = allowStateReadsStart(true);
    var runInfo = {
        prevDerivation: prevDerivation,
        prevAllowStateChanges: prevAllowStateChanges,
        prevAllowStateReads: prevAllowStateReads,
        notifySpy: notifySpy,
        startTime: startTime,
        actionId: nextActionId++,
        parentActionId: currentActionId
    };
    currentActionId = runInfo.actionId;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId) {
        fail("invalid action stack. did you forget to finish an action?");
    }
    currentActionId = runInfo.parentActionId;
    if (runInfo.error !== undefined) {
        globalState.suppressReactionErrors = true;
    }
    allowStateChangesEnd(runInfo.prevAllowStateChanges);
    allowStateReadsEnd(runInfo.prevAllowStateReads);
    endBatch();
    untrackedEnd(runInfo.prevDerivation);
    if (runInfo.notifySpy) {
        spyReportEnd({ time: Date.now() - runInfo.startTime });
    }
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    var res;
    try {
        res = func();
    }
    finally {
        allowStateChangesEnd(prev);
    }
    return res;
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
function allowStateChangesInsideComputed(func) {
    var prev = globalState.computationDepth;
    globalState.computationDepth = 0;
    var res;
    try {
        res = func();
    }
    finally {
        globalState.computationDepth = prev;
    }
    return res;
}

var ObservableValue = /** @class */ (function (_super) {
    __extends(ObservableValue, _super);
    function ObservableValue(value, enhancer, name, notifySpy, equals) {
        if (name === void 0) { name = "ObservableValue@" + getNextId(); }
        if (notifySpy === void 0) { notifySpy = true; }
        if (equals === void 0) { equals = comparer.default; }
        var _this = _super.call(this, name) || this;
        _this.enhancer = enhancer;
        _this.name = name;
        _this.equals = equals;
        _this.hasUnreportedChange = false;
        _this.value = enhancer(value, undefined, name);
        if (notifySpy && isSpyEnabled()) {
            // only notify spy if this is a stand-alone observable
            spyReport({ type: "create", name: _this.name, newValue: "" + _this.value });
        }
        return _this;
    }
    ObservableValue.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableValue.prototype.set = function (newValue) {
        var oldValue = this.value;
        newValue = this.prepareNewValue(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            if (notifySpy) {
                spyReportStart({
                    type: "update",
                    name: this.name,
                    newValue: newValue,
                    oldValue: oldValue
                });
            }
            this.setNewValue(newValue);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableValue.prototype.prepareNewValue = function (newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: "update",
                newValue: newValue
            });
            if (!change)
                return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value, this.name);
        return this.equals(this.value, newValue) ? globalState.UNCHANGED : newValue;
    };
    ObservableValue.prototype.setNewValue = function (newValue) {
        var oldValue = this.value;
        this.value = newValue;
        this.reportChanged();
        if (hasListeners(this)) {
            notifyListeners(this, {
                type: "update",
                object: this,
                newValue: newValue,
                oldValue: oldValue
            });
        }
    };
    ObservableValue.prototype.get = function () {
        this.reportObserved();
        return this.dehanceValue(this.value);
    };
    ObservableValue.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableValue.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately)
            listener({
                object: this,
                type: "update",
                newValue: this.value,
                oldValue: undefined
            });
        return registerListener(this, listener);
    };
    ObservableValue.prototype.toJSON = function () {
        return this.get();
    };
    ObservableValue.prototype.toString = function () {
        return this.name + "[" + this.value + "]";
    };
    ObservableValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    return ObservableValue;
}(Atom));
ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);

/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */
var ComputedValue = /** @class */ (function () {
    /**
     * Create a new computed value based on a function expression.
     *
     * The `name` property is for debug purposes only.
     *
     * The `equals` property specifies the comparer function to use to determine if a newly produced
     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
     * Structural comparison can be convenient if you always produce a new aggregated object and
     * don't want to notify observers if it is structurally the same.
     * This is useful for working with vectors, mouse coordinates etc.
     */
    function ComputedValue(options) {
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = null; // during tracking it's an array with new observed observers
        this.isBeingObserved = false;
        this.isPendingUnobservation = false;
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.runId = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.UP_TO_DATE;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.value = new CaughtException(null);
        this.isComputing = false; // to check for cycles
        this.isRunningSetter = false;
        this.isTracing = TraceMode.NONE;
        invariant(options.get, "missing option for computed: get");
        this.derivation = options.get;
        this.name = options.name || "ComputedValue@" + getNextId();
        if (options.set)
            this.setter = createAction(this.name + "-setter", options.set);
        this.equals =
            options.equals ||
                (options.compareStructural || options.struct
                    ? comparer.structural
                    : comparer.default);
        this.scope = options.context;
        this.requiresReaction = !!options.requiresReaction;
        this.keepAlive = !!options.keepAlive;
    }
    ComputedValue.prototype.onBecomeStale = function () {
        propagateMaybeChanged(this);
    };
    ComputedValue.prototype.onBecomeUnobserved = function () { };
    ComputedValue.prototype.onBecomeObserved = function () { };
    /**
     * Returns the current value of this computed value.
     * Will evaluate its computation first if needed.
     */
    ComputedValue.prototype.get = function () {
        if (this.isComputing)
            fail("Cycle detected in computation " + this.name + ": " + this.derivation);
        if (globalState.inBatch === 0 && this.observers.length === 0 && !this.keepAlive) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead();
                startBatch(); // See perf test 'computed memoization'
                this.value = this.computeValue(false);
                endBatch();
            }
        }
        else {
            reportObserved(this);
            if (shouldCompute(this))
                if (this.trackAndCompute())
                    propagateChangeConfirmed(this);
        }
        var result = this.value;
        if (isCaughtException(result))
            throw result.cause;
        return result;
    };
    ComputedValue.prototype.peek = function () {
        var res = this.computeValue(false);
        if (isCaughtException(res))
            throw res.cause;
        return res;
    };
    ComputedValue.prototype.set = function (value) {
        if (this.setter) {
            invariant(!this.isRunningSetter, "The setter of computed value '" + this.name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
            this.isRunningSetter = true;
            try {
                this.setter.call(this.scope, value);
            }
            finally {
                this.isRunningSetter = false;
            }
        }
        else
            invariant(false, "production" !== "production" &&
                "[ComputedValue '" + this.name + "'] It is not possible to assign a new value to a computed value.");
    };
    ComputedValue.prototype.trackAndCompute = function () {
        if (isSpyEnabled()) {
            spyReport({
                object: this.scope,
                type: "compute",
                name: this.name
            });
        }
        var oldValue = this.value;
        var wasSuspended = 
        /* see #1208 */ this.dependenciesState === IDerivationState.NOT_TRACKING;
        var newValue = this.computeValue(true);
        var changed = wasSuspended ||
            isCaughtException(oldValue) ||
            isCaughtException(newValue) ||
            !this.equals(oldValue, newValue);
        if (changed) {
            this.value = newValue;
        }
        return changed;
    };
    ComputedValue.prototype.computeValue = function (track) {
        this.isComputing = true;
        globalState.computationDepth++;
        var res;
        if (track) {
            res = trackDerivedFunction(this, this.derivation, this.scope);
        }
        else {
            if (globalState.disableErrorBoundaries === true) {
                res = this.derivation.call(this.scope);
            }
            else {
                try {
                    res = this.derivation.call(this.scope);
                }
                catch (e) {
                    res = new CaughtException(e);
                }
            }
        }
        globalState.computationDepth--;
        this.isComputing = false;
        return res;
    };
    ComputedValue.prototype.suspend = function () {
        if (!this.keepAlive) {
            clearObserving(this);
            this.value = undefined; // don't hold on to computed value!
        }
    };
    ComputedValue.prototype.observe = function (listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function () {
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    type: "update",
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    ComputedValue.prototype.warnAboutUntrackedRead = function () {
        if (true)
            return;
        if (this.requiresReaction === true) {
            fail("[mobx] Computed value " + this.name + " is read outside a reactive context");
        }
        if (this.isTracing !== TraceMode.NONE) {
            console.log("[mobx.trace] '" + this.name + "' is being read outside a reactive context. Doing a full recompute");
        }
        if (globalState.computedRequiresReaction) {
            console.warn("[mobx] Computed value " + this.name + " is being read outside a reactive context. Doing a full recompute");
        }
    };
    ComputedValue.prototype.toJSON = function () {
        return this.get();
    };
    ComputedValue.prototype.toString = function () {
        return this.name + "[" + this.derivation.toString() + "]";
    };
    ComputedValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    return ComputedValue;
}());
ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);

/**
 * These values will persist if global state is reset
 */
var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED"
];
var MobXGlobals = /** @class */ (function () {
    function MobXGlobals() {
        /**
         * MobXGlobals version.
         * MobX compatiblity with other versions loaded in memory as long as this version matches.
         * It indicates that the global state still stores similar information
         *
         * N.B: this version is unrelated to the package version of MobX, and is only the version of the
         * internal state storage of MobX, and can be the same across many different package versions
         */
        this.version = 5;
        /**
         * globally unique token to signal unchanged
         */
        this.UNCHANGED = {};
        /**
         * Currently running derivation
         */
        this.trackingDerivation = null;
        /**
         * Are we running a computation currently? (not a reaction)
         */
        this.computationDepth = 0;
        /**
         * Each time a derivation is tracked, it is assigned a unique run-id
         */
        this.runId = 0;
        /**
         * 'guid' for general purpose. Will be persisted amongst resets.
         */
        this.mobxGuid = 0;
        /**
         * Are we in a batch block? (and how many of them)
         */
        this.inBatch = 0;
        /**
         * Observables that don't have observers anymore, and are about to be
         * suspended, unless somebody else accesses it in the same batch
         *
         * @type {IObservable[]}
         */
        this.pendingUnobservations = [];
        /**
         * List of scheduled, not yet executed, reactions.
         */
        this.pendingReactions = [];
        /**
         * Are we currently processing reactions?
         */
        this.isRunningReactions = false;
        /**
         * Is it allowed to change observables at this point?
         * In general, MobX doesn't allow that when running computations and React.render.
         * To ensure that those functions stay pure.
         */
        this.allowStateChanges = true;
        /**
         * Is it allowed to read observables at this point?
         * Used to hold the state needed for `observableRequiresReaction`
         */
        this.allowStateReads = true;
        /**
         * If strict mode is enabled, state changes are by default not allowed
         */
        this.enforceActions = false;
        /**
         * Spy callbacks
         */
        this.spyListeners = [];
        /**
         * Globally attached error handlers that react specifically to errors in reactions
         */
        this.globalReactionErrorHandlers = [];
        /**
         * Warn if computed values are accessed outside a reactive context
         */
        this.computedRequiresReaction = false;
        /**
         * (Experimental)
         * Warn if you try to create to derivation / reactive context without accessing any observable.
         */
        this.reactionRequiresObservable = false;
        /**
         * (Experimental)
         * Warn if observables are accessed outside a reactive context
         */
        this.observableRequiresReaction = false;
        /**
         * Allows overwriting of computed properties, useful in tests but not prod as it can cause
         * memory leaks. See https://github.com/mobxjs/mobx/issues/1867
         */
        this.computedConfigurable = false;
        /*
         * Don't catch and rethrow exceptions. This is useful for inspecting the state of
         * the stack when an exception occurs while debugging.
         */
        this.disableErrorBoundaries = false;
        /*
         * If true, we are already handling an exception in an action. Any errors in reactions should be supressed, as
         * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
         */
        this.suppressReactionErrors = false;
    }
    return MobXGlobals;
}());
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = (function () {
    var global = getGlobal();
    if (global.__mobxInstanceCount > 0 && !global.__mobxGlobals)
        canMergeGlobalState = false;
    if (global.__mobxGlobals && global.__mobxGlobals.version !== new MobXGlobals().version)
        canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        setTimeout(function () {
            if (!isolateCalled) {
                fail("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`");
            }
        }, 1);
        return new MobXGlobals();
    }
    else if (global.__mobxGlobals) {
        global.__mobxInstanceCount += 1;
        if (!global.__mobxGlobals.UNCHANGED)
            global.__mobxGlobals.UNCHANGED = {}; // make merge backward compatible
        return global.__mobxGlobals;
    }
    else {
        global.__mobxInstanceCount = 1;
        return (global.__mobxGlobals = new MobXGlobals());
    }
})();
function isolateGlobalState() {
    if (globalState.pendingReactions.length ||
        globalState.inBatch ||
        globalState.isRunningReactions)
        fail("isolateGlobalState should be called before MobX is running any reactions");
    isolateCalled = true;
    if (canMergeGlobalState) {
        if (--getGlobal().__mobxInstanceCount === 0)
            getGlobal().__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */
function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for (var key in defaultGlobals)
        if (persistentKeys.indexOf(key) === -1)
            globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}

function hasObservers(observable) {
    return observable.observers && observable.observers.length > 0;
}
function getObservers(observable) {
    return observable.observers;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    var l = observable.observers.length;
    if (l) {
        // because object assignment is relatively expensive, let's not store data about index 0.
        observable.observersIndexes[node.__mapid] = l;
    }
    observable.observers[l] = node;
    if (observable.lowestObserverState > node.dependenciesState)
        observable.lowestObserverState = node.dependenciesState;
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    if (observable.observers.length === 1) {
        // deleting last observer
        observable.observers.length = 0;
        queueForUnobservation(observable);
    }
    else {
        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
        var list = observable.observers;
        var map = observable.observersIndexes;
        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes
        if (filler !== node) {
            // otherwise node was the last element, which already got removed from array
            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
            if (index) {
                // map store all indexes but 0, see comment in `addObserver`
                map[filler.__mapid] = index;
            }
            else {
                delete map[filler.__mapid];
            }
            list[index] = filler;
        }
        delete map[node.__mapid];
    }
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */
function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for (var i = 0; i < list.length; i++) {
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers.length === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBecomeUnobserved();
                }
                if (observable instanceof ComputedValue) {
                    // computed values are automatically teared down when the last observer leaves
                    // this process happens recursively, this computed might be the last observable of another, etc..
                    observable.suspend();
                }
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
         * Simple optimization, give each derivation run an unique id (runId)
         * Check if last time this observable was accessed the same runId is used
         * if this is the case, the relation is already known
         */
        if (derivation.runId !== observable.lastAccessedBy) {
            observable.lastAccessedBy = derivation.runId;
            derivation.newObserving[derivation.unboundDepsCount++] = observable;
            if (!observable.isBeingObserved) {
                observable.isBeingObserved = true;
                observable.onBecomeObserved();
            }
        }
        return true;
    }
    else if (observable.observers.length === 0 && globalState.inBatch > 0) {
        queueForUnobservation(observable);
    }
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */
// Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
        d.dependenciesState = IDerivationState.STALE;
    }
    // invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.POSSIBLY_STALE)
            d.dependenciesState = IDerivationState.STALE;
        else if (d.dependenciesState === IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
        )
            observable.lowestObserverState = IDerivationState.UP_TO_DATE;
    }
    // invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState !== IDerivationState.UP_TO_DATE)
        return;
    observable.lowestObserverState = IDerivationState.POSSIBLY_STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            d.dependenciesState = IDerivationState.POSSIBLY_STALE;
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
    }
    // invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
    if (derivation.isTracing === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
    if (tree.dependencies)
        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
}

var Reaction = /** @class */ (function () {
    function Reaction(name, onInvalidate, errorHandler, requiresObservable) {
        if (name === void 0) { name = "Reaction@" + getNextId(); }
        if (requiresObservable === void 0) { requiresObservable = false; }
        this.name = name;
        this.onInvalidate = onInvalidate;
        this.errorHandler = errorHandler;
        this.requiresObservable = requiresObservable;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = [];
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.diffValue = 0;
        this.runId = 0;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.isDisposed = false;
        this._isScheduled = false;
        this._isTrackPending = false;
        this._isRunning = false;
        this.isTracing = TraceMode.NONE;
    }
    Reaction.prototype.onBecomeStale = function () {
        this.schedule();
    };
    Reaction.prototype.schedule = function () {
        if (!this._isScheduled) {
            this._isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    Reaction.prototype.isScheduled = function () {
        return this._isScheduled;
    };
    /**
     * internal, use schedule() if you intend to kick off a reaction
     */
    Reaction.prototype.runReaction = function () {
        if (!this.isDisposed) {
            startBatch();
            this._isScheduled = false;
            if (shouldCompute(this)) {
                this._isTrackPending = true;
                try {
                    this.onInvalidate();
                    if (this._isTrackPending && isSpyEnabled()) {
                        // onInvalidate didn't trigger track right away..
                        spyReport({
                            name: this.name,
                            type: "scheduled-reaction"
                        });
                    }
                }
                catch (e) {
                    this.reportExceptionInDerivation(e);
                }
            }
            endBatch();
        }
    };
    Reaction.prototype.track = function (fn) {
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        if (notify) {
            startTime = Date.now();
            spyReportStart({
                name: this.name,
                type: "reaction"
            });
        }
        this._isRunning = true;
        var result = trackDerivedFunction(this, fn, undefined);
        this._isRunning = false;
        this._isTrackPending = false;
        if (this.isDisposed) {
            // disposed during last run. Clean up everything that was bound after the dispose call.
            clearObserving(this);
        }
        if (isCaughtException(result))
            this.reportExceptionInDerivation(result.cause);
        if (notify) {
            spyReportEnd({
                time: Date.now() - startTime
            });
        }
        endBatch();
    };
    Reaction.prototype.reportExceptionInDerivation = function (error) {
        var _this = this;
        if (this.errorHandler) {
            this.errorHandler(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries)
            throw error;
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'";
        if (globalState.suppressReactionErrors) {
            console.warn("[mobx] (error in reaction '" + this.name + "' suppressed, fix error of causing action below)"); // prettier-ignore
        }
        else {
            console.error(message, error);
            /** If debugging brought you here, please, read the above message :-). Tnx! */
        }
        if (isSpyEnabled()) {
            spyReport({
                type: "error",
                name: this.name,
                message: message,
                error: "" + error
            });
        }
        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
    };
    Reaction.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this._isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    Reaction.prototype.getDisposer = function () {
        var r = this.dispose.bind(this);
        r.$mobx = this;
        return r;
    };
    Reaction.prototype.toString = function () {
        return "Reaction[" + this.name + "]";
    };
    Reaction.prototype.trace = function (enterBreakPoint) {
        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
        trace(this, enterBreakPoint);
    };
    return Reaction;
}());
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function () {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0)
            globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function (f) { return f(); };
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions)
        return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while (allReactions.length > 0) {
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for (var i = 0, l = remainingReactions.length; i < l; i++)
            remainingReactions[i].runReaction();
    }
    globalState.isRunningReactions = false;
}
var isReaction = createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
}

function isSpyEnabled() {
    return !!globalState.spyListeners.length;
}
function spyReport(event) {
    if (!globalState.spyListeners.length)
        return;
    var listeners = globalState.spyListeners;
    for (var i = 0, l = listeners.length; i < l; i++)
        listeners[i](event);
}
function spyReportStart(event) {
    var change = __assign(__assign({}, event), { spyReportStart: true });
    spyReport(change);
}
var END_EVENT = { spyReportEnd: true };
function spyReportEnd(change) {
    if (change)
        spyReport(__assign(__assign({}, change), { spyReportEnd: true }));
    else
        spyReport(END_EVENT);
}
function spy(listener) {
    globalState.spyListeners.push(listener);
    return once(function () {
        globalState.spyListeners = globalState.spyListeners.filter(function (l) { return l !== listener; });
    });
}

function dontReassignFields() {
    fail("production" !== "production" && "@action fields are not reassignable");
}
function namedActionDecorator(name) {
    return function (target, prop, descriptor) {
        if (descriptor) {
            if (false) {
                return fail("@action cannot be used with getters");
            }
            // babel / typescript
            // @action method() { }
            if (descriptor.value) {
                // typescript
                return {
                    value: createAction(name, descriptor.value),
                    enumerable: false,
                    configurable: true,
                    writable: true // for typescript, this must be writable, otherwise it cannot inherit :/ (see inheritable actions test)
                };
            }
            // babel only: @action method = () => {}
            var initializer_1 = descriptor.initializer;
            return {
                enumerable: false,
                configurable: true,
                writable: true,
                initializer: function () {
                    // N.B: we can't immediately invoke initializer; this would be wrong
                    return createAction(name, initializer_1.call(this));
                }
            };
        }
        // bound instance methods
        return actionFieldDecorator(name).apply(this, arguments);
    };
}
function actionFieldDecorator(name) {
    // Simple property that writes on first invocation to the current instance
    return function (target, prop, descriptor) {
        Object.defineProperty(target, prop, {
            configurable: true,
            enumerable: false,
            get: function () {
                return undefined;
            },
            set: function (value) {
                addHiddenProp(this, prop, action(name, value));
            }
        });
    };
}
function boundActionDecorator(target, propertyName, descriptor, applyToInstance) {
    if (applyToInstance === true) {
        defineBoundAction(target, propertyName, descriptor.value);
        return null;
    }
    if (descriptor) {
        // if (descriptor.value)
        // Typescript / Babel: @action.bound method() { }
        // also: babel @action.bound method = () => {}
        return {
            configurable: true,
            enumerable: false,
            get: function () {
                defineBoundAction(this, propertyName, descriptor.value || descriptor.initializer.call(this));
                return this[propertyName];
            },
            set: dontReassignFields
        };
    }
    // field decorator Typescript @action.bound method = () => {}
    return {
        enumerable: false,
        configurable: true,
        set: function (v) {
            defineBoundAction(this, propertyName, v);
        },
        get: function () {
            return undefined;
        }
    };
}

var action = function action(arg1, arg2, arg3, arg4) {
    // action(fn() {})
    if (arguments.length === 1 && typeof arg1 === "function")
        return createAction(arg1.name || "<unnamed action>", arg1);
    // action("name", fn() {})
    if (arguments.length === 2 && typeof arg2 === "function")
        return createAction(arg1, arg2);
    // @action("name") fn() {}
    if (arguments.length === 1 && typeof arg1 === "string")
        return namedActionDecorator(arg1);
    // @action fn() {}
    if (arg4 === true) {
        // apply to instance immediately
        arg1[arg2] = createAction(arg1.name || arg2, arg3.value);
    }
    else {
        return namedActionDecorator(arg2).apply(null, arguments);
    }
};
action.bound = boundActionDecorator;
function runInAction(arg1, arg2) {
    // TODO: deprecate?
    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
    var fn = typeof arg1 === "function" ? arg1 : arg2;
    if (false) {
        invariant(typeof fn === "function" && fn.length === 0, "`runInAction` expects a function without arguments");
        if (typeof actionName !== "string" || !actionName)
            fail("actions should have valid names, got: '" + actionName + "'");
    }
    return executeAction(actionName, fn, this, undefined);
}
function isAction(thing) {
    return typeof thing === "function" && thing.isMobxAction === true;
}
function defineBoundAction(target, propertyName, fn) {
    addHiddenProp(target, propertyName, createAction(propertyName, fn.bind(target)));
}

/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */
function autorun(view, opts) {
    if (opts === void 0) { opts = EMPTY_OBJECT; }
    if (false) {
        invariant(typeof view === "function", "Autorun expects a function as first argument");
        invariant(isAction(view) === false, "Autorun does not accept actions since actions are untrackable");
    }
    var name = (opts && opts.name) || view.name || "Autorun@" + getNextId();
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) {
        // normal autorun
        reaction = new Reaction(name, function () {
            this.track(reactionRunner);
        }, opts.onError, opts.requiresObservable);
    }
    else {
        var scheduler_1 = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled_1 = false;
        reaction = new Reaction(name, function () {
            if (!isScheduled_1) {
                isScheduled_1 = true;
                scheduler_1(function () {
                    isScheduled_1 = false;
                    if (!reaction.isDisposed)
                        reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    reaction.schedule();
    return reaction.getDisposer();
}
var run = function (f) { return f(); };
function createSchedulerFromOptions(opts) {
    return opts.scheduler
        ? opts.scheduler
        : opts.delay
            ? function (f) { return setTimeout(f, opts.delay); }
            : run;
}
function reaction(expression, effect, opts) {
    if (opts === void 0) { opts = EMPTY_OBJECT; }
    if (typeof opts === "boolean") {
        opts = { fireImmediately: opts };
        deprecated("Using fireImmediately as argument is deprecated. Use '{ fireImmediately: true }' instead");
    }
    if (false) {
        invariant(typeof expression === "function", "First argument to reaction should be a function");
        invariant(typeof opts === "object", "Third argument of reactions should be an object");
    }
    var name = opts.name || "Reaction@" + getNextId();
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural
        ? comparer.structural
        : opts.equals || comparer.default;
    var r = new Reaction(name, function () {
        if (firstTime || runSync) {
            reactionRunner();
        }
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false; // Q: move into reaction runner?
        if (r.isDisposed)
            return;
        var changed = false;
        r.track(function () {
            var nextValue = expression(r);
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately)
            effectAction(value, r);
        if (!firstTime && changed === true)
            effectAction(value, r);
        if (firstTime)
            firstTime = false;
    }
    r.schedule();
    return r.getDisposer();
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function () {
        try {
            return baseFn.apply(this, arguments);
        }
        catch (e) {
            errorHandler.call(this, e);
        }
    };
}

function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook("onBecomeObserved", thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook("onBecomeUnobserved", thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = typeof arg3 === "function" ? arg3 : arg2;
    var orig = atom[hook];
    if (typeof orig !== "function")
        return fail("production" !== "production" && "Not an atom that can be (un)observed");
    atom[hook] = function () {
        orig.call(this);
        cb.call(this);
    };
    return function () {
        atom[hook] = orig;
    };
}

function configure(options) {
    var enforceActions = options.enforceActions, computedRequiresReaction = options.computedRequiresReaction, computedConfigurable = options.computedConfigurable, disableErrorBoundaries = options.disableErrorBoundaries, arrayBuffer = options.arrayBuffer, reactionScheduler = options.reactionScheduler, reactionRequiresObservable = options.reactionRequiresObservable, observableRequiresReaction = options.observableRequiresReaction;
    if (options.isolateGlobalState === true) {
        isolateGlobalState();
    }
    if (enforceActions !== undefined) {
        if (typeof enforceActions === "boolean" || enforceActions === "strict")
            deprecated("Deprecated value for 'enforceActions', use 'false' => '\"never\"', 'true' => '\"observed\"', '\"strict\"' => \"'always'\" instead");
        var ea = void 0;
        switch (enforceActions) {
            case true:
            case "observed":
                ea = true;
                break;
            case false:
            case "never":
                ea = false;
                break;
            case "strict":
            case "always":
                ea = "strict";
                break;
            default:
                fail("Invalid value for 'enforceActions': '" + enforceActions + "', expected 'never', 'always' or 'observed'");
        }
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === "strict" ? false : true;
    }
    if (computedRequiresReaction !== undefined) {
        globalState.computedRequiresReaction = !!computedRequiresReaction;
    }
    if (reactionRequiresObservable !== undefined) {
        globalState.reactionRequiresObservable = !!reactionRequiresObservable;
    }
    if (observableRequiresReaction !== undefined) {
        globalState.observableRequiresReaction = !!observableRequiresReaction;
        globalState.allowStateReads = !globalState.observableRequiresReaction;
    }
    if (computedConfigurable !== undefined) {
        globalState.computedConfigurable = !!computedConfigurable;
    }
    if (disableErrorBoundaries !== undefined) {
        if (disableErrorBoundaries === true)
            console.warn("WARNING: Debug feature only. MobX will NOT recover from errors if this is on.");
        globalState.disableErrorBoundaries = !!disableErrorBoundaries;
    }
    if (typeof arrayBuffer === "number") {
        reserveArrayBuffer(arrayBuffer);
    }
    if (reactionScheduler) {
        setReactionScheduler(reactionScheduler);
    }
}

function decorate(thing, decorators) {
    if (false)
        fail("Decorators should be a key value map");
    var target = typeof thing === "function" ? thing.prototype : thing;
    var _loop_1 = function (prop) {
        var propertyDecorators = decorators[prop];
        if (!Array.isArray(propertyDecorators)) {
            propertyDecorators = [propertyDecorators];
        }
        // prettier-ignore
        if (false)
            fail("Decorate: expected a decorator function or array of decorator functions for '" + prop + "'");
        var descriptor = Object.getOwnPropertyDescriptor(target, prop);
        var newDescriptor = propertyDecorators.reduce(function (accDescriptor, decorator) { return decorator(target, prop, accDescriptor); }, descriptor);
        if (newDescriptor)
            Object.defineProperty(target, prop, newDescriptor);
    };
    for (var prop in decorators) {
        _loop_1(prop);
    }
    return thing;
}

function extendShallowObservable(target, properties, decorators) {
    deprecated("'extendShallowObservable' is deprecated, use 'extendObservable(target, props, { deep: false })' instead");
    return extendObservable(target, properties, decorators, shallowCreateObservableOptions);
}
function extendObservable(target, properties, decorators, options) {
    if (false) {
        invariant(arguments.length >= 2 && arguments.length <= 4, "'extendObservable' expected 2-4 arguments");
        invariant(typeof target === "object", "'extendObservable' expects an object as first argument");
        invariant(!isObservableMap(target), "'extendObservable' should not be used on maps, use map.merge instead");
        invariant(!isObservable(properties), "Extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540");
        if (decorators)
            for (var key in decorators)
                if (!(key in properties))
                    fail("Trying to declare a decorator for unspecified property '" + key + "'");
    }
    options = asCreateObservableOptions(options);
    var defaultDecorator = options.defaultDecorator || (options.deep === false ? refDecorator : deepDecorator);
    initializeInstance(target);
    asObservableObject(target, options.name, defaultDecorator.enhancer); // make sure object is observable, even without initial props
    startBatch();
    try {
        var keys = Object.getOwnPropertyNames(properties);
        for (var i = 0, l = keys.length; i < l; i++) {
            var key = keys[i];
            var descriptor = Object.getOwnPropertyDescriptor(properties, key);
            if (false) {
                if (isComputed(descriptor.value))
                    fail("Passing a 'computed' as initial property value is no longer supported by extendObservable. Use a getter or decorator instead");
            }
            var decorator = decorators && key in decorators
                ? decorators[key]
                : descriptor.get
                    ? computedDecorator
                    : defaultDecorator;
            if (false)
                return fail("Not a valid decorator for '" + key + "', got: " + decorator);
            var resultDescriptor = decorator(target, key, descriptor, true);
            if (resultDescriptor // otherwise, assume already applied, due to `applyToInstance`
            )
                Object.defineProperty(target, key, resultDescriptor);
        }
    }
    finally {
        endBatch();
    }
    return target;
}

function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name
    };
    if (node.observing && node.observing.length > 0)
        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name
    };
    if (hasObservers(node))
        result.observers = getObservers(node).map(nodeToObserverTree);
    return result;
}

var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
function flow(generator) {
    if (arguments.length !== 1)
        fail(!!"production" && "Flow expects one 1 argument and cannot be used as decorator");
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    return function () {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var res = new Promise(function (resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                }
                catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.throw).call(gen, err);
                }
                catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (ret && typeof ret.then === "function") {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done)
                    return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        res.cancel = action(name + " - runid: " + runId + " - cancel", function () {
            try {
                if (pendingPromise)
                    cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var res_1 = gen.return(undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(res_1.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            }
            catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return res;
    };
}
function cancelPromise(promise) {
    if (typeof promise.cancel === "function")
        promise.cancel();
}

function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
        target = getAdministration(thing);
    }
    else if (isObservableObject(thing)) {
        if (typeof propOrHandler !== "string")
            return fail("production" !== "production" &&
                "InterceptReads can only be used with a specific property, not with an object in general");
        target = getAdministration(thing, propOrHandler);
    }
    else {
        return fail("production" !== "production" &&
            "Expected observable map, object or array as first array");
    }
    if (target.dehancer !== undefined)
        return fail("production" !== "production" && "An intercept reader was already established");
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function () {
        target.dehancer = undefined;
    };
}

function intercept(thing, propOrHandler, handler) {
    if (typeof handler === "function")
        return interceptProperty(thing, propOrHandler, handler);
    else
        return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept(handler);
}

function _isComputed(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableObject(value) === false)
            return false;
        if (!value.$mobx.values[property])
            return false;
        var atom = getAtom(value, property);
        return isComputedValue(atom);
    }
    return isComputedValue(value);
}
function isComputed(value) {
    if (arguments.length > 1)
        return fail("production" !== "production" &&
            "isComputed expects only 1 argument. Use isObservableProp to inspect the observability of a property");
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    if (typeof propName !== "string")
        return fail("production" !== "production" &&
            "isComputed expected a property name as second argument");
    return _isComputed(value, propName);
}

function _isObservable(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (false)
            return fail("isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.");
        if (isObservableObject(value)) {
            var o = value.$mobx;
            return o.values && !!o.values[property];
        }
        return false;
    }
    // For first check, see #701
    return (isObservableObject(value) ||
        !!value.$mobx ||
        isAtom(value) ||
        isReaction(value) ||
        isComputedValue(value));
}
function isObservable(value) {
    if (arguments.length !== 1)
        fail("production" !== "production" &&
            "isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property");
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    if (typeof propName !== "string")
        return fail("production" !== "production" && "expected a property name as second argument");
    return _isObservable(value, propName);
}

function keys(obj) {
    if (isObservableObject(obj)) {
        return obj.$mobx.getKeys();
    }
    if (isObservableMap(obj)) {
        return iteratorToArray(obj.keys());
    }
    if (isObservableSet(obj)) {
        return iteratorToArray(obj.keys());
    }
    if (isObservableArray(obj)) {
        return obj.map(function (_, index) { return index; });
    }
    return fail("production" !== "production" &&
        "'keys()' can only be used on observable objects, arrays, sets and maps");
}
function values(obj) {
    if (isObservableObject(obj)) {
        return keys(obj).map(function (key) { return obj[key]; });
    }
    if (isObservableMap(obj)) {
        return keys(obj).map(function (key) { return obj.get(key); });
    }
    if (isObservableSet(obj)) {
        return iteratorToArray(obj.values());
    }
    if (isObservableArray(obj)) {
        return obj.slice();
    }
    return fail("production" !== "production" &&
        "'values()' can only be used on observable objects, arrays, sets and maps");
}
function entries(obj) {
    if (isObservableObject(obj)) {
        return keys(obj).map(function (key) { return [key, obj[key]]; });
    }
    if (isObservableMap(obj)) {
        return keys(obj).map(function (key) { return [key, obj.get(key)]; });
    }
    if (isObservableSet(obj)) {
        return iteratorToArray(obj.entries());
    }
    if (isObservableArray(obj)) {
        return obj.map(function (key, index) { return [index, key]; });
    }
    return fail("production" !== "production" &&
        "'entries()' can only be used on observable objects, arrays and maps");
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var values_1 = key;
        try {
            for (var key_1 in values_1)
                set(obj, key_1, values_1[key_1]);
        }
        finally {
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) {
        var adm = obj.$mobx;
        var existingObservable = adm.values[key];
        if (existingObservable) {
            adm.write(obj, key, value);
        }
        else {
            defineObservableProperty(obj, key, value, adm.defaultEnhancer);
        }
    }
    else if (isObservableMap(obj)) {
        obj.set(key, value);
    }
    else if (isObservableSet(obj)) {
        obj.add(key);
    }
    else if (isObservableArray(obj)) {
        if (typeof key !== "number")
            key = parseInt(key, 10);
        invariant(key >= 0, "Not a valid index: '" + key + "'");
        startBatch();
        if (key >= obj.length)
            obj.length = key + 1;
        obj[key] = value;
        endBatch();
    }
    else {
        return fail("production" !== "production" &&
            "'set()' can only be used on observable objects, arrays and maps");
    }
}
function remove(obj, key) {
    if (isObservableObject(obj)) {
        obj.$mobx.remove(key);
    }
    else if (isObservableMap(obj)) {
        obj.delete(key);
    }
    else if (isObservableSet(obj)) {
        obj.delete(key);
    }
    else if (isObservableArray(obj)) {
        if (typeof key !== "number")
            key = parseInt(key, 10);
        invariant(key >= 0, "Not a valid index: '" + key + "'");
        obj.splice(key, 1);
    }
    else {
        return fail("production" !== "production" &&
            "'remove()' can only be used on observable objects, arrays and maps");
    }
}
function has(obj, key) {
    if (isObservableObject(obj)) {
        // return keys(obj).indexOf(key) >= 0
        var adm = getAdministration(obj);
        adm.getKeys(); // make sure we get notified of key changes, but for performance, use the values map to look up existence
        return !!adm.values[key];
    }
    else if (isObservableMap(obj)) {
        return obj.has(key);
    }
    else if (isObservableSet(obj)) {
        return obj.has(key);
    }
    else if (isObservableArray(obj)) {
        return key >= 0 && key < obj.length;
    }
    else {
        return fail("production" !== "production" &&
            "'has()' can only be used on observable objects, arrays and maps");
    }
}
function get(obj, key) {
    if (!has(obj, key))
        return undefined;
    if (isObservableObject(obj)) {
        return obj[key];
    }
    else if (isObservableMap(obj)) {
        return obj.get(key);
    }
    else if (isObservableArray(obj)) {
        return obj[key];
    }
    else {
        return fail("production" !== "production" &&
            "'get()' can only be used on observable objects, arrays and maps");
    }
}

function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (typeof cbOrFire === "function")
        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else
        return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe(listener, fireImmediately);
}

var defaultOptions = {
    detectCycles: true,
    exportMapsAsObjects: true,
    recurseEverything: false
};
function cache(map, key, value, options) {
    if (options.detectCycles)
        map.set(key, value);
    return value;
}
function toJSHelper(source, options, __alreadySeen) {
    if (!options.recurseEverything && !isObservable(source))
        return source;
    if (typeof source !== "object")
        return source;
    // Directly return null if source is null
    if (source === null)
        return null;
    // Directly return the Date object itself if contained in the observable
    if (source instanceof Date)
        return source;
    if (isObservableValue(source))
        return toJSHelper(source.get(), options, __alreadySeen);
    // make sure we track the keys of the object
    if (isObservable(source))
        keys(source);
    var detectCycles = options.detectCycles === true;
    if (detectCycles && source !== null && __alreadySeen.has(source)) {
        return __alreadySeen.get(source);
    }
    if (isObservableArray(source) || Array.isArray(source)) {
        var res_1 = cache(__alreadySeen, source, [], options);
        var toAdd = source.map(function (value) { return toJSHelper(value, options, __alreadySeen); });
        res_1.length = toAdd.length;
        for (var i = 0, l = toAdd.length; i < l; i++)
            res_1[i] = toAdd[i];
        return res_1;
    }
    if (isObservableSet(source) || Object.getPrototypeOf(source) === Set.prototype) {
        if (options.exportMapsAsObjects === false) {
            var res_2 = cache(__alreadySeen, source, new Set(), options);
            source.forEach(function (value) {
                res_2.add(toJSHelper(value, options, __alreadySeen));
            });
            return res_2;
        }
        else {
            var res_3 = cache(__alreadySeen, source, [], options);
            source.forEach(function (value) {
                res_3.push(toJSHelper(value, options, __alreadySeen));
            });
            return res_3;
        }
    }
    if (isObservableMap(source) || Object.getPrototypeOf(source) === Map.prototype) {
        if (options.exportMapsAsObjects === false) {
            var res_4 = cache(__alreadySeen, source, new Map(), options);
            source.forEach(function (value, key) {
                res_4.set(key, toJSHelper(value, options, __alreadySeen));
            });
            return res_4;
        }
        else {
            var res_5 = cache(__alreadySeen, source, {}, options);
            source.forEach(function (value, key) {
                res_5[key] = toJSHelper(value, options, __alreadySeen);
            });
            return res_5;
        }
    }
    // Fallback to the situation that source is an ObservableObject or a plain object
    var res = cache(__alreadySeen, source, {}, options);
    for (var key in source) {
        res[key] = toJSHelper(source[key], options, __alreadySeen);
    }
    return res;
}
function toJS(source, options) {
    // backward compatibility
    if (typeof options === "boolean")
        options = { detectCycles: options };
    if (!options)
        options = defaultOptions;
    options.detectCycles =
        options.detectCycles === undefined
            ? options.recurseEverything === true
            : options.detectCycles === true;
    var __alreadySeen;
    if (options.detectCycles)
        __alreadySeen = new Map();
    return toJSHelper(source, options, __alreadySeen);
}

function trace() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var enterBreakPoint = false;
    if (typeof args[args.length - 1] === "boolean")
        enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) {
        return fail("production" !== "production" &&
            "'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    }
    if (derivation.isTracing === TraceMode.NONE) {
        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
    }
    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
    switch (args.length) {
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}

/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */
function transaction(action, thisArg) {
    if (thisArg === void 0) { thisArg = undefined; }
    startBatch();
    try {
        return action.apply(thisArg);
    }
    finally {
        endBatch();
    }
}

function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || (arg1 && typeof arg1 === "object"))
        return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        timeoutHandle = setTimeout(function () {
            if (!disposer.$mobx.isDisposed) {
                disposer();
                var error = new Error("WHEN_TIMEOUT");
                if (opts.onError)
                    opts.onError(error);
                else
                    throw error;
            }
        }, opts.timeout);
    }
    opts.name = opts.name || "When@" + getNextId();
    var effectAction = createAction(opts.name + "-effect", effect);
    var disposer = autorun(function (r) {
        if (predicate()) {
            r.dispose();
            if (timeoutHandle)
                clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    if (false)
        return fail("the options 'onError' and 'promise' cannot be combined");
    var cancel;
    var res = new Promise(function (resolve, reject) {
        var disposer = _when(predicate, resolve, __assign(__assign({}, opts), { onError: reject }));
        cancel = function () {
            disposer();
            reject("WHEN_CANCELLED");
        };
    });
    res.cancel = cancel;
    return res;
}

function hasInterceptors(interceptable) {
    return interceptable.interceptors !== undefined && interceptable.interceptors.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
    interceptors.push(handler);
    return once(function () {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1)
            interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        var interceptors = interceptable.interceptors;
        if (interceptors)
            for (var i = 0, l = interceptors.length; i < l; i++) {
                change = interceptors[i](change);
                invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
                if (!change)
                    break;
            }
        return change;
    }
    finally {
        untrackedEnd(prevU);
    }
}

function hasListeners(listenable) {
    return listenable.changeListeners !== undefined && listenable.changeListeners.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
    listeners.push(handler);
    return once(function () {
        var idx = listeners.indexOf(handler);
        if (idx !== -1)
            listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners;
    if (!listeners)
        return;
    listeners = listeners.slice();
    for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i](change);
    }
    untrackedEnd(prevU);
}

var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
var safariPrototypeSetterInheritanceBug = (function () {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function () {
            v = true;
        }
    });
    Object.create(p)["0"] = 1;
    return v === false;
})();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */
var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = /** @class */ (function () {
    function StubArray() {
    }
    return StubArray;
}());
function inherit(ctor, proto) {
    if (typeof Object["setPrototypeOf"] !== "undefined") {
        Object["setPrototypeOf"](ctor.prototype, proto);
    }
    else if (typeof ctor.prototype.__proto__ !== "undefined") {
        ctor.prototype.__proto__ = proto;
    }
    else {
        ctor["prototype"] = proto;
    }
}
inherit(StubArray, Array.prototype);
// Weex freeze Array.prototype
// Make them writeable and configurable in prototype chain
// https://github.com/alibaba/weex/pull/1529
if (Object.isFrozen(Array)) {
    [
        "constructor",
        "push",
        "shift",
        "concat",
        "pop",
        "unshift",
        "replace",
        "find",
        "findIndex",
        "splice",
        "reverse",
        "sort"
    ].forEach(function (key) {
        Object.defineProperty(StubArray.prototype, key, {
            configurable: true,
            writable: true,
            value: Array.prototype[key]
        });
    });
}
var ObservableArrayAdministration = /** @class */ (function () {
    function ObservableArrayAdministration(name, enhancer, array, owned) {
        this.array = array;
        this.owned = owned;
        this.values = [];
        this.lastKnownLength = 0;
        this.atom = new Atom(name || "ObservableArray@" + getNextId());
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
    }
    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
        if (this.dehancer !== undefined && values.length > 0)
            return values.map(this.dehancer);
        return values;
    };
    ObservableArrayAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        if (fireImmediately) {
            listener({
                object: this.array,
                type: "splice",
                index: 0,
                added: this.values.slice(),
                addedCount: this.values.length,
                removed: [],
                removedCount: 0
            });
        }
        return registerListener(this, listener);
    };
    ObservableArrayAdministration.prototype.getArrayLength = function () {
        this.atom.reportObserved();
        return this.values.length;
    };
    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
        if (typeof newLength !== "number" || newLength < 0)
            throw new Error("[mobx.array] Out of range: " + newLength);
        var currentLength = this.values.length;
        if (newLength === currentLength)
            return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for (var i = 0; i < newLength - currentLength; i++)
                newItems[i] = undefined; // No Array.fill everywhere...
            this.spliceWithArray(currentLength, 0, newItems);
        }
        else
            this.spliceWithArray(newLength, currentLength - newLength);
    };
    // adds / removes the necessary numeric properties to this object
    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
        if (oldLength !== this.lastKnownLength)
            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
        this.lastKnownLength += delta;
        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE)
            reserveArrayBuffer(oldLength + delta + 1);
    };
    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom);
        var length = this.values.length;
        if (index === undefined)
            index = 0;
        else if (index > length)
            index = length;
        else if (index < 0)
            index = Math.max(0, length + index);
        if (arguments.length === 1)
            deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null)
            deleteCount = 0;
        else
            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined)
            newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.array,
                type: "splice",
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change)
                return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems =
            newItems.length === 0 ? newItems : newItems.map(function (v) { return _this.enhancer(v, undefined); });
        var lengthDelta = newItems.length - deleteCount;
        this.updateArrayLength(length, lengthDelta); // create or remove new entries
        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0)
            this.notifyArraySplice(index, newItems, res);
        return this.dehanceValues(res);
    };
    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
        var _a;
        if (newItems.length < MAX_SPLICE_SIZE) {
            return (_a = this.values).splice.apply(_a, __spread([index, deleteCount], newItems));
        }
        else {
            var res = this.values.slice(index, index + deleteCount);
            this.values = this.values
                .slice(0, index)
                .concat(newItems, this.values.slice(index + deleteCount));
            return res;
        }
    };
    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "update",
                index: index,
                newValue: newValue,
                oldValue: oldValue
            }
            : null;
        if (notifySpy)
            spyReportStart(__assign(__assign({}, change), { name: this.atom.name }));
        this.atom.reportChanged();
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "splice",
                index: index,
                removed: removed,
                added: added,
                removedCount: removed.length,
                addedCount: added.length
            }
            : null;
        if (notifySpy)
            spyReportStart(__assign(__assign({}, change), { name: this.atom.name }));
        this.atom.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    return ObservableArrayAdministration;
}());
var ObservableArray = /** @class */ (function (_super) {
    __extends(ObservableArray, _super);
    function ObservableArray(initialValues, enhancer, name, owned) {
        if (name === void 0) { name = "ObservableArray@" + getNextId(); }
        if (owned === void 0) { owned = false; }
        var _this = _super.call(this) || this;
        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
        addHiddenFinalProp(_this, "$mobx", adm);
        if (initialValues && initialValues.length) {
            var prev = allowStateChangesStart(true);
            _this.spliceWithArray(0, 0, initialValues);
            allowStateChangesEnd(prev);
        }
        if (safariPrototypeSetterInheritanceBug) {
            // Seems that Safari won't use numeric prototype setter untill any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(adm.array, "0", ENTRY_0);
        }
        return _this;
    }
    ObservableArray.prototype.intercept = function (handler) {
        return this.$mobx.intercept(handler);
    };
    ObservableArray.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        return this.$mobx.observe(listener, fireImmediately);
    };
    ObservableArray.prototype.clear = function () {
        return this.splice(0);
    };
    ObservableArray.prototype.concat = function () {
        var arrays = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arrays[_i] = arguments[_i];
        }
        this.$mobx.atom.reportObserved();
        return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) { return (isObservableArray(a) ? a.peek() : a); }));
    };
    ObservableArray.prototype.replace = function (newItems) {
        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
    };
    /**
     * Converts this array back to a (shallow) javascript structure.
     * For a deep clone use mobx.toJS
     */
    ObservableArray.prototype.toJS = function () {
        return this.slice();
    };
    ObservableArray.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableArray.prototype.peek = function () {
        this.$mobx.atom.reportObserved();
        return this.$mobx.dehanceValues(this.$mobx.values);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
    ObservableArray.prototype.find = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        if (arguments.length === 3)
            deprecated("The array.find fromIndex argument to find will not be supported anymore in the next major");
        var idx = this.findIndex.apply(this, arguments);
        return idx === -1 ? undefined : this.get(idx);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
    ObservableArray.prototype.findIndex = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        if (arguments.length === 3)
            deprecated("The array.findIndex fromIndex argument to find will not be supported anymore in the next major");
        var items = this.peek(), l = items.length;
        for (var i = fromIndex; i < l; i++)
            if (predicate.call(thisArg, items[i], i, this))
                return i;
        return -1;
    };
    /*
     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
     * since these functions alter the inner structure of the array, the have side effects.
     * Because the have side effects, they should not be used in computed function,
     * and for that reason the do not call dependencyState.notifyObserved
     */
    ObservableArray.prototype.splice = function (index, deleteCount) {
        var newItems = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            newItems[_i - 2] = arguments[_i];
        }
        switch (arguments.length) {
            case 0:
                return [];
            case 1:
                return this.$mobx.spliceWithArray(index);
            case 2:
                return this.$mobx.spliceWithArray(index, deleteCount);
        }
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.push = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(adm.values.length, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.pop = function () {
        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
    };
    ObservableArray.prototype.shift = function () {
        return this.splice(0, 1)[0];
    };
    ObservableArray.prototype.unshift = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(0, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.reverse = function () {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        // so we deviate from the default and just make it an dervitation
        var clone = this.slice();
        return clone.reverse.apply(clone, arguments);
    };
    ObservableArray.prototype.sort = function (compareFn) {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        var clone = this.slice();
        return clone.sort.apply(clone, arguments);
    };
    ObservableArray.prototype.remove = function (value) {
        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    };
    ObservableArray.prototype.move = function (fromIndex, toIndex) {
        deprecated("observableArray.move is deprecated, use .slice() & .replace() instead");
        function checkIndex(index) {
            if (index < 0) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
            }
            var length = this.$mobx.values.length;
            if (index >= length) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
            }
        }
        checkIndex.call(this, fromIndex);
        checkIndex.call(this, toIndex);
        if (fromIndex === toIndex) {
            return;
        }
        var oldItems = this.$mobx.values;
        var newItems;
        if (fromIndex < toIndex) {
            newItems = __spread(oldItems.slice(0, fromIndex), oldItems.slice(fromIndex + 1, toIndex + 1), [
                oldItems[fromIndex]
            ], oldItems.slice(toIndex + 1));
        }
        else {
            // toIndex < fromIndex
            newItems = __spread(oldItems.slice(0, toIndex), [
                oldItems[fromIndex]
            ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
        }
        this.replace(newItems);
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.get = function (index) {
        var impl = this.$mobx;
        if (impl) {
            if (index < impl.values.length) {
                impl.atom.reportObserved();
                return impl.dehanceValue(impl.values[index]);
            }
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl.values.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
        }
        return undefined;
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.set = function (index, newValue) {
        var adm = this.$mobx;
        var values = adm.values;
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(adm.atom);
            var oldValue = values[index];
            if (hasInterceptors(adm)) {
                var change = interceptChange(adm, {
                    type: "update",
                    object: this,
                    index: index,
                    newValue: newValue
                });
                if (!change)
                    return;
                newValue = change.newValue;
            }
            newValue = adm.enhancer(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                adm.notifyArrayChildUpdate(index, newValue, oldValue);
            }
        }
        else if (index === values.length) {
            // add a new item
            adm.spliceWithArray(index, 0, [newValue]);
        }
        else {
            // out of bounds
            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
        }
    };
    return ObservableArray;
}(StubArray));
declareIterator(ObservableArray.prototype, function () {
    this.$mobx.atom.reportObserved();
    var self = this;
    var nextIndex = 0;
    return makeIterable({
        next: function () {
            return nextIndex < self.length
                ? { value: self[nextIndex++], done: false }
                : { done: true, value: undefined };
        }
    });
});
Object.defineProperty(ObservableArray.prototype, "length", {
    enumerable: false,
    configurable: true,
    get: function () {
        return this.$mobx.getArrayLength();
    },
    set: function (newLength) {
        this.$mobx.setArrayLength(newLength);
    }
});
addHiddenProp(ObservableArray.prototype, toStringTagSymbol(), "Array");
["indexOf", "join", "lastIndexOf", "slice", "toString", "toLocaleString"].forEach(function (funcName) {
    var baseFunc = Array.prototype[funcName];
    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
    addHiddenProp(ObservableArray.prototype, funcName, function () {
        return baseFunc.apply(this.peek(), arguments);
    });
});
[
    "every",
    "filter",
    //"find", // implemented individually (IE support)
    //"findIndex", // implemented individually (IE support)
    //"flatMap", // not supported
    "forEach",
    "map",
    "some"
].forEach(function (funcName) {
    var baseFunc = Array.prototype[funcName];
    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
    addHiddenProp(ObservableArray.prototype, funcName, function (callback, thisArg) {
        var _this = this;
        var adm = this.$mobx;
        adm.atom.reportObserved();
        var dehancedValues = adm.dehanceValues(adm.values);
        return dehancedValues[funcName](function (element, index) {
            return callback.call(thisArg, element, index, _this);
        }, thisArg);
    });
});
["reduce", "reduceRight"].forEach(function (funcName) {
    addHiddenProp(ObservableArray.prototype, funcName, function () {
        var _this = this;
        var adm = this.$mobx;
        adm.atom.reportObserved();
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function (accumulator, currentValue, index) {
            currentValue = adm.dehanceValue(currentValue);
            return callback(accumulator, currentValue, index, _this);
        };
        return adm.values[funcName].apply(adm.values, arguments);
    });
});
/**
 * We don't want those to show up in `for (const key in ar)` ...
 */
makeNonEnumerable(ObservableArray.prototype, [
    "constructor",
    "intercept",
    "observe",
    "clear",
    "concat",
    "get",
    "replace",
    "toJS",
    "toJSON",
    "peek",
    "find",
    "findIndex",
    "splice",
    "spliceWithArray",
    "push",
    "pop",
    "set",
    "shift",
    "unshift",
    "reverse",
    "sort",
    "remove",
    "move",
    "toString",
    "toLocaleString"
]);
// See #364
var ENTRY_0 = createArrayEntryDescriptor(0);
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: false,
        get: function () {
            return this.get(index);
        },
        set: function (value) {
            this.set(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)
        createArrayBufferItem(index);
    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
}
reserveArrayBuffer(1000);
var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
}

var ObservableMapMarker = {};
var ObservableMap = /** @class */ (function () {
    function ObservableMap(initialData, enhancer, name) {
        if (enhancer === void 0) { enhancer = deepEnhancer; }
        if (name === void 0) { name = "ObservableMap@" + getNextId(); }
        this.enhancer = enhancer;
        this.name = name;
        this.$mobx = ObservableMapMarker;
        this._keysAtom = createAtom(this.name + ".keys()");
        if (typeof Map !== "function") {
            throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
        }
        this._data = new Map();
        this._hasMap = new Map();
        this.merge(initialData);
    }
    ObservableMap.prototype._has = function (key) {
        return this._data.has(key);
    };
    ObservableMap.prototype.has = function (key) {
        var _this = this;
        if (!globalState.trackingDerivation)
            return this._has(key);
        var entry = this._hasMap.get(key);
        if (!entry) {
            // todo: replace with atom (breaking change)
            var newEntry = (entry = new ObservableValue(this._has(key), referenceEnhancer, this.name + "." + stringifyKey(key) + "?", false));
            this._hasMap.set(key, newEntry);
            onBecomeUnobserved(newEntry, function () { return _this._hasMap.delete(key); });
        }
        return entry.get();
    };
    ObservableMap.prototype.set = function (key, value) {
        var hasKey = this._has(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? "update" : "add",
                object: this,
                newValue: value,
                name: key
            });
            if (!change)
                return this;
            value = change.newValue;
        }
        if (hasKey) {
            this._updateValue(key, value);
        }
        else {
            this._addValue(key, value);
        }
        return this;
    };
    ObservableMap.prototype.delete = function (key) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this._keysAtom);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                name: key
            });
            if (!change)
                return false;
        }
        if (this._has(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "delete",
                    object: this,
                    oldValue: this._data.get(key).value,
                    name: key
                }
                : null;
            if (notifySpy)
                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
            transaction(function () {
                _this._keysAtom.reportChanged();
                _this._updateHasMapEntry(key, false);
                var observable = _this._data.get(key);
                observable.setNewValue(undefined);
                _this._data.delete(key);
            });
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
        var entry = this._hasMap.get(key);
        if (entry) {
            entry.setNewValue(value);
        }
    };
    ObservableMap.prototype._updateValue = function (key, newValue) {
        var observable = this._data.get(key);
        newValue = observable.prepareNewValue(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: this,
                    oldValue: observable.value,
                    name: key,
                    newValue: newValue
                }
                : null;
            if (notifySpy)
                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
            observable.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableMap.prototype._addValue = function (key, newValue) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this._keysAtom);
        transaction(function () {
            var observable = new ObservableValue(newValue, _this.enhancer, _this.name + "." + stringifyKey(key), false);
            _this._data.set(key, observable);
            newValue = observable.value; // value might have been changed
            _this._updateHasMapEntry(key, true);
            _this._keysAtom.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                type: "add",
                object: this,
                name: key,
                newValue: newValue
            }
            : null;
        if (notifySpy)
            spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableMap.prototype.get = function (key) {
        if (this.has(key))
            return this.dehanceValue(this._data.get(key).get());
        return this.dehanceValue(undefined);
    };
    ObservableMap.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableMap.prototype.keys = function () {
        this._keysAtom.reportObserved();
        return this._data.keys();
    };
    ObservableMap.prototype.values = function () {
        var self = this;
        var keys = this.keys();
        return makeIterable({
            next: function () {
                var _a = keys.next(), done = _a.done, value = _a.value;
                return {
                    done: done,
                    value: done ? undefined : self.get(value)
                };
            }
        });
    };
    ObservableMap.prototype.entries = function () {
        var self = this;
        var keys = this.keys();
        return makeIterable({
            next: function () {
                var _a = keys.next(), done = _a.done, value = _a.value;
                return {
                    done: done,
                    value: done ? undefined : [value, self.get(value)]
                };
            }
        });
    };
    ObservableMap.prototype.forEach = function (callback, thisArg) {
        var _this = this;
        this._keysAtom.reportObserved();
        this._data.forEach(function (_, key) { return callback.call(thisArg, _this.get(key), key, _this); });
    };
    /** Merge another object into this object, returns this. */
    ObservableMap.prototype.merge = function (other) {
        var _this = this;
        if (isObservableMap(other)) {
            other = other.toJS();
        }
        transaction(function () {
            var prev = allowStateChangesStart(true);
            try {
                if (isPlainObject(other))
                    Object.keys(other).forEach(function (key) { return _this.set(key, other[key]); });
                else if (Array.isArray(other))
                    other.forEach(function (_a) {
                        var _b = __read(_a, 2), key = _b[0], value = _b[1];
                        return _this.set(key, value);
                    });
                else if (isES6Map(other)) {
                    if (other.constructor !== Map)
                        fail("Cannot initialize from classes that inherit from Map: " + other.constructor.name); // prettier-ignore
                    else
                        other.forEach(function (value, key) { return _this.set(key, value); });
                }
                else if (other !== null && other !== undefined)
                    fail("Cannot initialize map from " + other);
            }
            finally {
                allowStateChangesEnd(prev);
            }
        });
        return this;
    };
    ObservableMap.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                // Note we are concurrently reading/deleting the same keys
                // forEach handles this properly
                _this._data.forEach(function (_, key) { return _this.delete(key); });
            });
        });
    };
    ObservableMap.prototype.replace = function (values) {
        var _this = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function () {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            forOf(_this._data.keys(), function (key) {
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this.delete(key);
                    // Was the key removed?
                    if (deleted) {
                        // _keysAtom.reportChanged() was already called
                        keysReportChangedCalled = true;
                    }
                    else {
                        // Delete prevented by interceptor
                        var value = _this._data.get(key);
                        orderedData.set(key, value);
                    }
                }
            });
            // Merge entries
            forOf(replacementMap.entries(), function (_a) {
                var _b = __read(_a, 2), key = _b[0], value = _b[1];
                // We will want to know whether a new key is added
                var keyExisted = _this._data.has(key);
                // Add or update value
                _this.set(key, value);
                // The addition could have been prevent by interceptor
                if (_this._data.has(key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var value_1 = _this._data.get(key);
                    orderedData.set(key, value_1);
                    // Was a new key added?
                    if (!keyExisted) {
                        // _keysAtom.reportChanged() was already called
                        keysReportChangedCalled = true;
                    }
                }
            });
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this._data.size !== orderedData.size) {
                    // If size differs, keys are definitely modified
                    _this._keysAtom.reportChanged();
                }
                else {
                    var iter1 = _this._data.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while (!next1.done) {
                        if (next1.value !== next2.value) {
                            _this._keysAtom.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this._data = orderedData;
        });
        return this;
    };
    Object.defineProperty(ObservableMap.prototype, "size", {
        get: function () {
            this._keysAtom.reportObserved();
            return this._data.size;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a plain object that represents this map.
     * Note that all the keys being stringified.
     * If there are duplicating keys after converting them to strings, behaviour is undetermined.
     */
    ObservableMap.prototype.toPOJO = function () {
        var _this = this;
        var res = {};
        this.forEach(function (_, key) {
            return (res[typeof key === "symbol" ? key : stringifyKey(key)] = _this.get(key));
        });
        return res;
    };
    /**
     * Returns a shallow non observable object clone of this map.
     * Note that the values migth still be observable. For a deep clone use mobx.toJS.
     */
    ObservableMap.prototype.toJS = function () {
        return new Map(this);
    };
    ObservableMap.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toPOJO();
    };
    ObservableMap.prototype.toString = function () {
        var _this = this;
        return (this.name +
            "[{ " +
            iteratorToArray(this.keys())
                .map(function (key) { return stringifyKey(key) + ": " + ("" + _this.get(key)); })
                .join(", ") +
            " }]");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableMap.prototype.observe = function (listener, fireImmediately) {
        "production" !== "production" &&
            invariant(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with maps.");
        return registerListener(this, listener);
    };
    ObservableMap.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableMap;
}());
function stringifyKey(key) {
    if (key && key.toString)
        return key.toString();
    else
        return new String(key).toString();
}
declareIterator(ObservableMap.prototype, function () {
    return this.entries();
});
addHiddenFinalProp(ObservableMap.prototype, toStringTagSymbol(), "Map");
/* 'var' fixes small-build issue */
var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);

var ObservableSetMarker = {};
var ObservableSet = /** @class */ (function () {
    function ObservableSet(initialData, enhancer, name) {
        if (enhancer === void 0) { enhancer = deepEnhancer; }
        if (name === void 0) { name = "ObservableSet@" + getNextId(); }
        this.name = name;
        this.$mobx = ObservableSetMarker;
        this._data = new Set();
        this._atom = createAtom(this.name);
        if (typeof Set !== "function") {
            throw new Error("mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js");
        }
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name); };
        if (initialData) {
            this.replace(initialData);
        }
    }
    ObservableSet.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableSet.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                _this._data.forEach(function (value) {
                    _this.delete(value);
                });
            });
        });
    };
    ObservableSet.prototype.forEach = function (callbackFn, thisArg) {
        var _this = this;
        this._atom.reportObserved();
        this._data.forEach(function (value) {
            callbackFn.call(thisArg, value, value, _this);
        });
    };
    Object.defineProperty(ObservableSet.prototype, "size", {
        get: function () {
            this._atom.reportObserved();
            return this._data.size;
        },
        enumerable: true,
        configurable: true
    });
    ObservableSet.prototype.add = function (value) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this._atom);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "add",
                object: this,
                newValue: value
            });
            if (!change)
                return this;
            // TODO: ideally, value = change.value would be done here, so that values can be
            // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function () {
                _this._data.add(_this.enhancer(value, undefined));
                _this._atom.reportChanged();
            });
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "add",
                    object: this,
                    newValue: value
                }
                : null;
            if (notifySpy && "production" !== "production")
                spyReportStart(change);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy && "production" !== "production")
                spyReportEnd();
        }
        return this;
    };
    ObservableSet.prototype.delete = function (value) {
        var _this = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                oldValue: value
            });
            if (!change)
                return false;
        }
        if (this.has(value)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "delete",
                    object: this,
                    oldValue: value
                }
                : null;
            if (notifySpy && "production" !== "production")
                spyReportStart(__assign(__assign({}, change), { name: this.name }));
            transaction(function () {
                _this._atom.reportChanged();
                _this._data.delete(value);
            });
            if (notify)
                notifyListeners(this, change);
            if (notifySpy && "production" !== "production")
                spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableSet.prototype.has = function (value) {
        this._atom.reportObserved();
        return this._data.has(this.dehanceValue(value));
    };
    ObservableSet.prototype.entries = function () {
        var nextIndex = 0;
        var keys = iteratorToArray(this.keys());
        var values = iteratorToArray(this.values());
        return makeIterable({
            next: function () {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length
                    ? { value: [keys[index], values[index]], done: false }
                    : { done: true };
            }
        });
    };
    ObservableSet.prototype.keys = function () {
        return this.values();
    };
    ObservableSet.prototype.values = function () {
        this._atom.reportObserved();
        var self = this;
        var nextIndex = 0;
        var observableValues;
        if (this._data.values !== undefined) {
            observableValues = iteratorToArray(this._data.values());
        }
        else {
            // There is no values function in IE11
            observableValues = [];
            this._data.forEach(function (e) { return observableValues.push(e); });
        }
        return makeIterable({
            next: function () {
                return nextIndex < observableValues.length
                    ? { value: self.dehanceValue(observableValues[nextIndex++]), done: false }
                    : { done: true };
            }
        });
    };
    ObservableSet.prototype.replace = function (other) {
        var _this = this;
        if (isObservableSet(other)) {
            other = other.toJS();
        }
        transaction(function () {
            var prev = allowStateChangesStart(true);
            try {
                if (Array.isArray(other)) {
                    _this.clear();
                    other.forEach(function (value) { return _this.add(value); });
                }
                else if (isES6Set(other)) {
                    _this.clear();
                    other.forEach(function (value) { return _this.add(value); });
                }
                else if (other !== null && other !== undefined) {
                    fail("Cannot initialize set from " + other);
                }
            }
            finally {
                allowStateChangesEnd(prev);
            }
        });
        return this;
    };
    ObservableSet.prototype.observe = function (listener, fireImmediately) {
        // TODO 'fireImmediately' can be true?
        "production" !== "production" &&
            invariant(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with sets.");
        return registerListener(this, listener);
    };
    ObservableSet.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableSet.prototype.toJS = function () {
        return new Set(this);
    };
    ObservableSet.prototype.toString = function () {
        return this.name + "[ " + iteratorToArray(this.keys()).join(", ") + " ]";
    };
    return ObservableSet;
}());
declareIterator(ObservableSet.prototype, function () {
    return this.values();
});
addHiddenFinalProp(ObservableSet.prototype, toStringTagSymbol(), "Set");
var isObservableSet = createInstanceofPredicate("ObservableSet", ObservableSet);

var ObservableObjectAdministration = /** @class */ (function () {
    function ObservableObjectAdministration(target, name, defaultEnhancer) {
        this.target = target;
        this.name = name;
        this.defaultEnhancer = defaultEnhancer;
        this.values = {};
    }
    ObservableObjectAdministration.prototype.read = function (owner, key) {
        if ("production" === "production" && this.target !== owner) {
            this.illegalAccess(owner, key);
            if (!this.values[key])
                return undefined;
        }
        return this.values[key].get();
    };
    ObservableObjectAdministration.prototype.write = function (owner, key, newValue) {
        var instance = this.target;
        if ("production" === "production" && instance !== owner) {
            this.illegalAccess(owner, key);
        }
        var observable = this.values[key];
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "update",
                object: instance,
                name: key,
                newValue: newValue
            });
            if (!change)
                return;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: instance,
                    oldValue: observable.value,
                    name: key,
                    newValue: newValue
                }
                : null;
            if (notifySpy)
                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
            observable.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableObjectAdministration.prototype.remove = function (key) {
        if (!this.values[key])
            return;
        var target = this.target;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: target,
                name: key,
                type: "remove"
            });
            if (!change)
                return;
        }
        try {
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var oldValue = this.values[key].get();
            if (this.keys)
                this.keys.remove(key);
            delete this.values[key];
            delete this.target[key];
            var change = notify || notifySpy
                ? {
                    type: "remove",
                    object: target,
                    oldValue: oldValue,
                    name: key
                }
                : null;
            if (notifySpy)
                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
        }
        finally {
            endBatch();
        }
    };
    ObservableObjectAdministration.prototype.illegalAccess = function (owner, propName) {
        /**
         * This happens if a property is accessed through the prototype chain, but the property was
         * declared directly as own property on the prototype.
         *
         * E.g.:
         * class A {
         * }
         * extendObservable(A.prototype, { x: 1 })
         *
         * classB extens A {
         * }
         * console.log(new B().x)
         *
         * It is unclear whether the property should be considered 'static' or inherited.
         * Either use `console.log(A.x)`
         * or: decorate(A, { x: observable })
         *
         * When using decorate, the property will always be redeclared as own property on the actual instance
         */
        console.warn("Property '" + propName + "' of '" + owner + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
        "production" !== "production" &&
            invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
        return registerListener(this, callback);
    };
    ObservableObjectAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableObjectAdministration.prototype.getKeys = function () {
        var _this = this;
        if (this.keys === undefined) {
            this.keys = (new ObservableArray(Object.keys(this.values).filter(function (key) { return _this.values[key] instanceof ObservableValue; }), referenceEnhancer, "keys(" + this.name + ")", true));
        }
        return this.keys.slice();
    };
    return ObservableObjectAdministration;
}());
function asObservableObject(target, name, defaultEnhancer) {
    if (name === void 0) { name = ""; }
    if (defaultEnhancer === void 0) { defaultEnhancer = deepEnhancer; }
    var adm = target.$mobx;
    if (adm)
        return adm;
    "production" !== "production" &&
        invariant(Object.isExtensible(target), "Cannot make the designated object observable; it is not extensible");
    if (!isPlainObject(target))
        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
    if (!name)
        name = "ObservableObject@" + getNextId();
    adm = new ObservableObjectAdministration(target, name, defaultEnhancer);
    addHiddenFinalProp(target, "$mobx", adm);
    return adm;
}
function defineObservableProperty(target, propName, newValue, enhancer) {
    var adm = asObservableObject(target);
    assertPropertyConfigurable(target, propName);
    if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
            object: target,
            name: propName,
            type: "add",
            newValue: newValue
        });
        if (!change)
            return;
        newValue = change.newValue;
    }
    var observable = (adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false));
    newValue = observable.value; // observableValue might have changed it
    Object.defineProperty(target, propName, generateObservablePropConfig(propName));
    if (adm.keys)
        adm.keys.push(propName);
    notifyPropertyAddition(adm, target, propName, newValue);
}
function defineComputedProperty(target, // which objects holds the observable and provides `this` context?
propName, options) {
    var adm = asObservableObject(target);
    options.name = adm.name + "." + propName;
    options.context = target;
    adm.values[propName] = new ComputedValue(options);
    Object.defineProperty(target, propName, generateComputedPropConfig(propName));
}
var observablePropertyConfigs = Object.create(null);
var computedPropertyConfigs = Object.create(null);
function generateObservablePropConfig(propName) {
    return (observablePropertyConfigs[propName] ||
        (observablePropertyConfigs[propName] = {
            configurable: true,
            enumerable: true,
            get: function () {
                return this.$mobx.read(this, propName);
            },
            set: function (v) {
                this.$mobx.write(this, propName, v);
            }
        }));
}
function getAdministrationForComputedPropOwner(owner) {
    var adm = owner.$mobx;
    if (!adm) {
        // because computed props are declared on proty,
        // the current instance might not have been initialized yet
        initializeInstance(owner);
        return owner.$mobx;
    }
    return adm;
}
function generateComputedPropConfig(propName) {
    return (computedPropertyConfigs[propName] ||
        (computedPropertyConfigs[propName] = {
            configurable: globalState.computedConfigurable,
            enumerable: false,
            get: function () {
                return getAdministrationForComputedPropOwner(this).read(this, propName);
            },
            set: function (v) {
                getAdministrationForComputedPropOwner(this).write(this, propName, v);
            }
        }));
}
function notifyPropertyAddition(adm, object, key, newValue) {
    var notify = hasListeners(adm);
    var notifySpy = isSpyEnabled();
    var change = notify || notifySpy
        ? {
            type: "add",
            object: object,
            name: key,
            newValue: newValue
        }
        : null;
    if (notifySpy)
        spyReportStart(__assign(__assign({}, change), { name: adm.name, key: key }));
    if (notify)
        notifyListeners(adm, change);
    if (notifySpy)
        spyReportEnd();
}
var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function isObservableObject(thing) {
    if (isObject(thing)) {
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance(thing);
        return isObservableObjectAdministration(thing.$mobx);
    }
    return false;
}

function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined)
                fail("production" !== "production" &&
                    "It is not possible to get index atoms from arrays");
            return thing.$mobx.atom;
        }
        if (isObservableSet(thing)) {
            return thing.$mobx;
        }
        if (isObservableMap(thing)) {
            var anyThing = thing;
            if (property === undefined)
                return anyThing._keysAtom;
            var observable = anyThing._data.get(property) || anyThing._hasMap.get(property);
            if (!observable)
                fail("production" !== "production" &&
                    "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
            return observable;
        }
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance(thing);
        if (property && !thing.$mobx)
            thing[property]; // See #1072
        if (isObservableObject(thing)) {
            if (!property)
                return fail("production" !== "production" && "please specify a property");
            var observable = thing.$mobx.values[property];
            if (!observable)
                fail("production" !== "production" &&
                    "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
            return observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
            return thing;
        }
    }
    else if (typeof thing === "function") {
        if (isReaction(thing.$mobx)) {
            // disposer function
            return thing.$mobx;
        }
    }
    return fail("production" !== "production" && "Cannot obtain atom from " + thing);
}
function getAdministration(thing, property) {
    if (!thing)
        fail("Expecting some object");
    if (property !== undefined)
        return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
        return thing;
    if (isObservableMap(thing) || isObservableSet(thing))
        return thing;
    // Initializers run lazily when transpiling to babel, so make sure they are run...
    initializeInstance(thing);
    if (thing.$mobx)
        return thing.$mobx;
    fail("production" !== "production" && "Cannot obtain administration from " + thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined)
        named = getAtom(thing, property);
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing))
        named = getAdministration(thing);
    else
        named = getAtom(thing); // valid for arrays as well
    return named.name;
}

var toString = Object.prototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) { depth = -1; }
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b)
        return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null)
        return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a)
        return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object")
        return false;
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b))
        return false;
    switch (className) {
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a)
                return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return (
            // eslint-disable-next-line
            typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
    }
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object")
            return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor &&
            !(typeof aCtor === "function" &&
                aCtor instanceof aCtor &&
                typeof bCtor === "function" &&
                bCtor instanceof bCtor) &&
            ("constructor" in a && "constructor" in b)) {
            return false;
        }
    }
    if (depth === 0) {
        return false;
    }
    else if (depth < 0) {
        depth = -1;
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a)
            return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length)
            return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while (length--) {
            if (!eq(a[length], b[length], depth - 1, aStack, bStack))
                return false;
        }
    }
    else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key = void 0;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length)
            return false;
        while (length--) {
            // Deep compare each member
            key = keys[length];
            if (!(has$1(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack)))
                return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a))
        return a.peek();
    if (isES6Map(a) || isObservableMap(a))
        return iteratorToArray(a.entries());
    if (isES6Set(a) || isObservableSet(a))
        return iteratorToArray(a.entries());
    return a;
}
function has$1(a, key) {
    return Object.prototype.hasOwnProperty.call(a, key);
}

/**
 * (c) Michel Weststrate 2015 - 2019
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */
try {
    // define process.env if needed
    // if this is not a production build in the first place
    // (in which case the expression below would be substituted with 'production')
    // tslint:disable-next-line
    "production";
}
catch (e) {
    var g = getGlobal();
    if (typeof process === "undefined")
        g.process = {};
    g.process.env = {};
}
(function () {
    function testCodeMinification() { }
    if (testCodeMinification.name !== "testCodeMinification" &&
        "production" !== "production" &&
        typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":""}).IGNORE_MOBX_MINIFY_WARNING !== "true") {
        // trick so it doesn't get replaced
        var varName = ["process", "env", "NODE_ENV"].join(".");
        console.warn("[mobx] you are running a minified build, but '" + varName + "' was not set to 'production' in your bundler. This results in an unnecessarily large and slow bundle");
    }
})();
// forward compatibility with mobx, so that packages can easily support mobx 4 & 5
var $mobx = "$mobx";
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
    // See: https://github.com/andykog/mobx-devtools/
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
        spy: spy,
        extras: {
            getDebugName: getDebugName
        },
        $mobx: $mobx
    });
}
// TODO: remove in some future build
if (false) {
    var warnedAboutDefaultExport_1 = false;
    Object.defineProperty(module.exports, "default", {
        enumerable: false,
        get: function () {
            if (!warnedAboutDefaultExport_1) {
                warnedAboutDefaultExport_1 = true;
                console.warn("The MobX package does not have a default export. Use 'import { thing } from \"mobx\"' (recommended) or 'import * as mobx from \"mobx\"' instead.\"");
            }
            return undefined;
        }
    });
    [
        "extras",
        "Atom",
        "BaseAtom",
        "asFlat",
        "asMap",
        "asReference",
        "asStructure",
        "autorunAsync",
        "createTranformer",
        "expr",
        "isModifierDescriptor",
        "isStrictModeEnabled",
        "map",
        "useStrict",
        "whyRun"
    ].forEach(function (prop) {
        Object.defineProperty(module.exports, prop, {
            enumerable: false,
            get: function () {
                fail("'" + prop + "' is no longer part of the public MobX api. Please consult the changelog to find out where this functionality went");
            },
            set: function () { }
        });
    });
}



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(80), __webpack_require__(258)))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(325);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(785);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(789);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(325);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _rcInputNumber = _interopRequireDefault(__webpack_require__(1371));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _configProvider = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var InputNumber = /*#__PURE__*/function (_React$Component) {
  _inherits(InputNumber, _React$Component);

  var _super = _createSuper(InputNumber);

  function InputNumber() {
    var _this;

    _classCallCheck(this, InputNumber);

    _this = _super.apply(this, arguments);

    _this.saveInputNumber = function (inputNumberRef) {
      _this.inputNumberRef = inputNumberRef;
    };

    _this.renderInputNumber = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          className = _a.className,
          size = _a.size,
          customizePrefixCls = _a.prefixCls,
          others = __rest(_a, ["className", "size", "prefixCls"]);

      var prefixCls = getPrefixCls('input-number', customizePrefixCls);
      var inputNumberClass = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames), className);
      var upIcon = /*#__PURE__*/React.createElement(_icon["default"], {
        type: "up",
        className: "".concat(prefixCls, "-handler-up-inner")
      });
      var downIcon = /*#__PURE__*/React.createElement(_icon["default"], {
        type: "down",
        className: "".concat(prefixCls, "-handler-down-inner")
      });
      return /*#__PURE__*/React.createElement(_rcInputNumber["default"], _extends({
        ref: _this.saveInputNumber,
        className: inputNumberClass,
        upHandler: upIcon,
        downHandler: downIcon,
        prefixCls: prefixCls
      }, others));
    };

    return _this;
  }

  _createClass(InputNumber, [{
    key: "focus",
    value: function focus() {
      this.inputNumberRef.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.inputNumberRef.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderInputNumber);
    }
  }]);

  return InputNumber;
}(React.Component);

exports["default"] = InputNumber;
InputNumber.defaultProps = {
  step: 1
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(1375);

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* A third-party license is embeded for some of the code in this file:
* The method "quantile" was copied from "d3.js".
* (See more details in the comment of the method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/
var RADIAN_EPSILON = 1e-4;

function _trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
}
/**
 * Linear mapping a value from domain to range
 * @memberOf module:echarts/util/number
 * @param  {(number|Array.<number>)} val
 * @param  {Array.<number>} domain Domain extent domain[0] can be bigger than domain[1]
 * @param  {Array.<number>} range  Range extent range[0] can be bigger than range[1]
 * @param  {boolean} clamp
 * @return {(number|Array.<number>}
 */


function linearMap(val, domain, range, clamp) {
  var subDomain = domain[1] - domain[0];
  var subRange = range[1] - range[0];

  if (subDomain === 0) {
    return subRange === 0 ? range[0] : (range[0] + range[1]) / 2;
  } // Avoid accuracy problem in edge, such as
  // 146.39 - 62.83 === 83.55999999999999.
  // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
  // It is a little verbose for efficiency considering this method
  // is a hotspot.


  if (clamp) {
    if (subDomain > 0) {
      if (val <= domain[0]) {
        return range[0];
      } else if (val >= domain[1]) {
        return range[1];
      }
    } else {
      if (val >= domain[0]) {
        return range[0];
      } else if (val <= domain[1]) {
        return range[1];
      }
    }
  } else {
    if (val === domain[0]) {
      return range[0];
    }

    if (val === domain[1]) {
      return range[1];
    }
  }

  return (val - domain[0]) / subDomain * subRange + range[0];
}
/**
 * Convert a percent string to absolute number.
 * Returns NaN if percent is not a valid string or number
 * @memberOf module:echarts/util/number
 * @param {string|number} percent
 * @param {number} all
 * @return {number}
 */


function parsePercent(percent, all) {
  switch (percent) {
    case 'center':
    case 'middle':
      percent = '50%';
      break;

    case 'left':
    case 'top':
      percent = '0%';
      break;

    case 'right':
    case 'bottom':
      percent = '100%';
      break;
  }

  if (typeof percent === 'string') {
    if (_trim(percent).match(/%$/)) {
      return parseFloat(percent) / 100 * all;
    }

    return parseFloat(percent);
  }

  return percent == null ? NaN : +percent;
}
/**
 * (1) Fix rounding error of float numbers.
 * (2) Support return string to avoid scientific notation like '3.5e-7'.
 *
 * @param {number} x
 * @param {number} [precision]
 * @param {boolean} [returnStr]
 * @return {number|string}
 */


function round(x, precision, returnStr) {
  if (precision == null) {
    precision = 10;
  } // Avoid range error


  precision = Math.min(Math.max(0, precision), 20);
  x = (+x).toFixed(precision);
  return returnStr ? x : +x;
}
/**
 * asc sort arr.
 * The input arr will be modified.
 *
 * @param {Array} arr
 * @return {Array} The input arr.
 */


function asc(arr) {
  arr.sort(function (a, b) {
    return a - b;
  });
  return arr;
}
/**
 * Get precision
 * @param {number} val
 */


function getPrecision(val) {
  val = +val;

  if (isNaN(val)) {
    return 0;
  } // It is much faster than methods converting number to string as follows
  //      var tmp = val.toString();
  //      return tmp.length - 1 - tmp.indexOf('.');
  // especially when precision is low


  var e = 1;
  var count = 0;

  while (Math.round(val * e) / e !== val) {
    e *= 10;
    count++;
  }

  return count;
}
/**
 * @param {string|number} val
 * @return {number}
 */


function getPrecisionSafe(val) {
  var str = val.toString(); // Consider scientific notation: '3.4e-12' '3.4e+12'

  var eIndex = str.indexOf('e');

  if (eIndex > 0) {
    var precision = +str.slice(eIndex + 1);
    return precision < 0 ? -precision : 0;
  } else {
    var dotIndex = str.indexOf('.');
    return dotIndex < 0 ? 0 : str.length - 1 - dotIndex;
  }
}
/**
 * Minimal dicernible data precisioin according to a single pixel.
 *
 * @param {Array.<number>} dataExtent
 * @param {Array.<number>} pixelExtent
 * @return {number} precision
 */


function getPixelPrecision(dataExtent, pixelExtent) {
  var log = Math.log;
  var LN10 = Math.LN10;
  var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
  var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10); // toFixed() digits argument must be between 0 and 20.

  var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
  return !isFinite(precision) ? 20 : precision;
}
/**
 * Get a data of given precision, assuring the sum of percentages
 * in valueList is 1.
 * The largest remainer method is used.
 * https://en.wikipedia.org/wiki/Largest_remainder_method
 *
 * @param {Array.<number>} valueList a list of all data
 * @param {number} idx index of the data to be processed in valueList
 * @param {number} precision integer number showing digits of precision
 * @return {number} percent ranging from 0 to 100
 */


function getPercentWithPrecision(valueList, idx, precision) {
  if (!valueList[idx]) {
    return 0;
  }

  var sum = zrUtil.reduce(valueList, function (acc, val) {
    return acc + (isNaN(val) ? 0 : val);
  }, 0);

  if (sum === 0) {
    return 0;
  }

  var digits = Math.pow(10, precision);
  var votesPerQuota = zrUtil.map(valueList, function (val) {
    return (isNaN(val) ? 0 : val) / sum * digits * 100;
  });
  var targetSeats = digits * 100;
  var seats = zrUtil.map(votesPerQuota, function (votes) {
    // Assign automatic seats.
    return Math.floor(votes);
  });
  var currentSum = zrUtil.reduce(seats, function (acc, val) {
    return acc + val;
  }, 0);
  var remainder = zrUtil.map(votesPerQuota, function (votes, idx) {
    return votes - seats[idx];
  }); // Has remainding votes.

  while (currentSum < targetSeats) {
    // Find next largest remainder.
    var max = Number.NEGATIVE_INFINITY;
    var maxId = null;

    for (var i = 0, len = remainder.length; i < len; ++i) {
      if (remainder[i] > max) {
        max = remainder[i];
        maxId = i;
      }
    } // Add a vote to max remainder.


    ++seats[maxId];
    remainder[maxId] = 0;
    ++currentSum;
  }

  return seats[idx] / digits;
} // Number.MAX_SAFE_INTEGER, ie do not support.


var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * To 0 - 2 * PI, considering negative radian.
 * @param {number} radian
 * @return {number}
 */

function remRadian(radian) {
  var pi2 = Math.PI * 2;
  return (radian % pi2 + pi2) % pi2;
}
/**
 * @param {type} radian
 * @return {boolean}
 */


function isRadianAroundZero(val) {
  return val > -RADIAN_EPSILON && val < RADIAN_EPSILON;
}
/* eslint-disable */


var TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d\d)(?::(\d\d)(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line

/* eslint-enable */

/**
 * @param {string|Date|number} value These values can be accepted:
 *   + An instance of Date, represent a time in its own time zone.
 *   + Or string in a subset of ISO 8601, only including:
 *     + only year, month, date: '2012-03', '2012-03-01', '2012-03-01 05', '2012-03-01 05:06',
 *     + separated with T or space: '2012-03-01T12:22:33.123', '2012-03-01 12:22:33.123',
 *     + time zone: '2012-03-01T12:22:33Z', '2012-03-01T12:22:33+8000', '2012-03-01T12:22:33-05:00',
 *     all of which will be treated as local time if time zone is not specified
 *     (see <https://momentjs.com/>).
 *   + Or other string format, including (all of which will be treated as loacal time):
 *     '2012', '2012-3-1', '2012/3/1', '2012/03/01',
 *     '2009/6/12 2:00', '2009/6/12 2:05:08', '2009/6/12 2:05:08.123'
 *   + a timestamp, which represent a time in UTC.
 * @return {Date} date
 */

function parseDate(value) {
  if (value instanceof Date) {
    return value;
  } else if (typeof value === 'string') {
    // Different browsers parse date in different way, so we parse it manually.
    // Some other issues:
    // new Date('1970-01-01') is UTC,
    // new Date('1970/01/01') and new Date('1970-1-01') is local.
    // See issue #3623
    var match = TIME_REG.exec(value);

    if (!match) {
      // return Invalid Date.
      return new Date(NaN);
    } // Use local time when no timezone offset specifed.


    if (!match[8]) {
      // match[n] can only be string or undefined.
      // But take care of '12' + 1 => '121'.
      return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, +match[7] || 0);
    } // Timezoneoffset of Javascript Date has considered DST (Daylight Saving Time,
    // https://tc39.github.io/ecma262/#sec-daylight-saving-time-adjustment).
    // For example, system timezone is set as "Time Zone: America/Toronto",
    // then these code will get different result:
    // `new Date(1478411999999).getTimezoneOffset();  // get 240`
    // `new Date(1478412000000).getTimezoneOffset();  // get 300`
    // So we should not use `new Date`, but use `Date.UTC`.
    else {
        var hour = +match[4] || 0;

        if (match[8].toUpperCase() !== 'Z') {
          hour -= match[8].slice(0, 3);
        }

        return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, +match[7] || 0));
      }
  } else if (value == null) {
    return new Date(NaN);
  }

  return new Date(Math.round(value));
}
/**
 * Quantity of a number. e.g. 0.1, 1, 10, 100
 *
 * @param  {number} val
 * @return {number}
 */


function quantity(val) {
  return Math.pow(10, quantityExponent(val));
}
/**
 * Exponent of the quantity of a number
 * e.g., 1234 equals to 1.234*10^3, so quantityExponent(1234) is 3
 *
 * @param  {number} val non-negative value
 * @return {number}
 */


function quantityExponent(val) {
  if (val === 0) {
    return 0;
  }

  var exp = Math.floor(Math.log(val) / Math.LN10);
  /**
   * exp is expected to be the rounded-down result of the base-10 log of val.
   * But due to the precision loss with Math.log(val), we need to restore it
   * using 10^exp to make sure we can get val back from exp. #11249
   */

  if (val / Math.pow(10, exp) >= 10) {
    exp++;
  }

  return exp;
}
/**
 * find a “nice” number approximately equal to x. Round the number if round = true,
 * take ceiling if round = false. The primary observation is that the “nicest”
 * numbers in decimal are 1, 2, and 5, and all power-of-ten multiples of these numbers.
 *
 * See "Nice Numbers for Graph Labels" of Graphic Gems.
 *
 * @param  {number} val Non-negative value.
 * @param  {boolean} round
 * @return {number}
 */


function nice(val, round) {
  var exponent = quantityExponent(val);
  var exp10 = Math.pow(10, exponent);
  var f = val / exp10; // 1 <= f < 10

  var nf;

  if (round) {
    if (f < 1.5) {
      nf = 1;
    } else if (f < 2.5) {
      nf = 2;
    } else if (f < 4) {
      nf = 3;
    } else if (f < 7) {
      nf = 5;
    } else {
      nf = 10;
    }
  } else {
    if (f < 1) {
      nf = 1;
    } else if (f < 2) {
      nf = 2;
    } else if (f < 3) {
      nf = 3;
    } else if (f < 5) {
      nf = 5;
    } else {
      nf = 10;
    }
  }

  val = nf * exp10; // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
  // 20 is the uppper bound of toFixed.

  return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
}
/**
 * This code was copied from "d3.js"
 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/arrays/quantile.js>.
 * See the license statement at the head of this file.
 * @param {Array.<number>} ascArr
 */


function quantile(ascArr, p) {
  var H = (ascArr.length - 1) * p + 1;
  var h = Math.floor(H);
  var v = +ascArr[h - 1];
  var e = H - h;
  return e ? v + e * (ascArr[h] - v) : v;
}
/**
 * Order intervals asc, and split them when overlap.
 * expect(numberUtil.reformIntervals([
 *     {interval: [18, 62], close: [1, 1]},
 *     {interval: [-Infinity, -70], close: [0, 0]},
 *     {interval: [-70, -26], close: [1, 1]},
 *     {interval: [-26, 18], close: [1, 1]},
 *     {interval: [62, 150], close: [1, 1]},
 *     {interval: [106, 150], close: [1, 1]},
 *     {interval: [150, Infinity], close: [0, 0]}
 * ])).toEqual([
 *     {interval: [-Infinity, -70], close: [0, 0]},
 *     {interval: [-70, -26], close: [1, 1]},
 *     {interval: [-26, 18], close: [0, 1]},
 *     {interval: [18, 62], close: [0, 1]},
 *     {interval: [62, 150], close: [0, 1]},
 *     {interval: [150, Infinity], close: [0, 0]}
 * ]);
 * @param {Array.<Object>} list, where `close` mean open or close
 *        of the interval, and Infinity can be used.
 * @return {Array.<Object>} The origin list, which has been reformed.
 */


function reformIntervals(list) {
  list.sort(function (a, b) {
    return littleThan(a, b, 0) ? -1 : 1;
  });
  var curr = -Infinity;
  var currClose = 1;

  for (var i = 0; i < list.length;) {
    var interval = list[i].interval;
    var close = list[i].close;

    for (var lg = 0; lg < 2; lg++) {
      if (interval[lg] <= curr) {
        interval[lg] = curr;
        close[lg] = !lg ? 1 - currClose : 1;
      }

      curr = interval[lg];
      currClose = close[lg];
    }

    if (interval[0] === interval[1] && close[0] * close[1] !== 1) {
      list.splice(i, 1);
    } else {
      i++;
    }
  }

  return list;

  function littleThan(a, b, lg) {
    return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
  }
}
/**
 * parseFloat NaNs numeric-cast false positives (null|true|false|"")
 * ...but misinterprets leading-number strings, particularly hex literals ("0x...")
 * subtraction forces infinities to NaN
 *
 * @param {*} v
 * @return {boolean}
 */


function isNumeric(v) {
  return v - parseFloat(v) >= 0;
}

exports.linearMap = linearMap;
exports.parsePercent = parsePercent;
exports.round = round;
exports.asc = asc;
exports.getPrecision = getPrecision;
exports.getPrecisionSafe = getPrecisionSafe;
exports.getPixelPrecision = getPixelPrecision;
exports.getPercentWithPrecision = getPercentWithPrecision;
exports.MAX_SAFE_INTEGER = MAX_SAFE_INTEGER;
exports.remRadian = remRadian;
exports.isRadianAroundZero = isRadianAroundZero;
exports.parseDate = parseDate;
exports.quantity = quantity;
exports.quantityExponent = quantityExponent;
exports.nice = nice;
exports.quantile = quantile;
exports.reformIntervals = reformIntervals;
exports.isNumeric = isNumeric;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var allIcons = _interopRequireWildcard(__webpack_require__(761));

var _iconsReact = _interopRequireDefault(__webpack_require__(454));

var _IconFont = _interopRequireDefault(__webpack_require__(796));

var _utils = __webpack_require__(797);

var _warning = _interopRequireDefault(__webpack_require__(69));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(113));

var _twoTonePrimaryColor = __webpack_require__(799);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable camelcase */


// Initial setting
_iconsReact["default"].add.apply(_iconsReact["default"], _toConsumableArray(Object.keys(allIcons).map(function (key) {
  return allIcons[key];
})));

(0, _twoTonePrimaryColor.setTwoToneColor)('#1890ff');
var defaultTheme = 'outlined';
var dangerousTheme;

function unstable_ChangeThemeOfIconsDangerously(theme) {
  (0, _warning["default"])(false, 'Icon', "You are using the unstable method 'Icon.unstable_ChangeThemeOfAllIconsDangerously', " + "make sure that all the icons with theme '".concat(theme, "' display correctly."));
  dangerousTheme = theme;
}

function unstable_ChangeDefaultThemeOfIcons(theme) {
  (0, _warning["default"])(false, 'Icon', "You are using the unstable method 'Icon.unstable_ChangeDefaultThemeOfIcons', " + "make sure that all the icons with theme '".concat(theme, "' display correctly."));
  defaultTheme = theme;
}

var Icon = function Icon(props) {
  var _classNames;

  var className = props.className,
      type = props.type,
      Component = props.component,
      viewBox = props.viewBox,
      spin = props.spin,
      rotate = props.rotate,
      tabIndex = props.tabIndex,
      onClick = props.onClick,
      children = props.children,
      theme = props.theme,
      twoToneColor = props.twoToneColor,
      restProps = __rest(props, ["className", "type", "component", "viewBox", "spin", "rotate", "tabIndex", "onClick", "children", "theme", "twoToneColor"]);

  (0, _warning["default"])(Boolean(type || Component || children), 'Icon', 'Should have `type` prop or `component` prop or `children`.');
  var classString = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "anticon", true), _defineProperty(_classNames, "anticon-".concat(type), Boolean(type)), _classNames), className);
  var svgClassString = (0, _classnames["default"])(_defineProperty({}, "anticon-spin", !!spin || type === 'loading'));
  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : undefined;

  var innerSvgProps = _extends(_extends({}, _utils.svgBaseProps), {
    className: svgClassString,
    style: svgStyle,
    viewBox: viewBox
  });

  if (!viewBox) {
    delete innerSvgProps.viewBox;
  }

  var renderInnerNode = function renderInnerNode() {
    // component > children > type
    if (Component) {
      return /*#__PURE__*/React.createElement(Component, innerSvgProps, children);
    }

    if (children) {
      (0, _warning["default"])(Boolean(viewBox) || React.Children.count(children) === 1 && /*#__PURE__*/React.isValidElement(children) && React.Children.only(children).type === 'use', 'Icon', 'Make sure that you provide correct `viewBox`' + ' prop (default `0 0 1024 1024`) to the icon.');
      return /*#__PURE__*/React.createElement("svg", _extends({}, innerSvgProps, {
        viewBox: viewBox
      }), children);
    }

    if (typeof type === 'string') {
      var computedType = type;

      if (theme) {
        var themeInName = (0, _utils.getThemeFromTypeName)(type);
        (0, _warning["default"])(!themeInName || theme === themeInName, 'Icon', "The icon name '".concat(type, "' already specify a theme '").concat(themeInName, "',") + " the 'theme' prop '".concat(theme, "' will be ignored."));
      }

      computedType = (0, _utils.withThemeSuffix)((0, _utils.removeTypeTheme)((0, _utils.alias)(computedType)), dangerousTheme || theme || defaultTheme);
      return /*#__PURE__*/React.createElement(_iconsReact["default"], {
        className: svgClassString,
        type: computedType,
        primaryColor: twoToneColor,
        style: svgStyle
      });
    }
  };

  var iconTabIndex = tabIndex;

  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }

  return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
    componentName: "Icon"
  }, function (locale) {
    return /*#__PURE__*/React.createElement("i", _extends({
      "aria-label": type && "".concat(locale.icon, ": ").concat(type)
    }, restProps, {
      tabIndex: iconTabIndex,
      onClick: onClick,
      className: classString
    }), renderInnerNode());
  });
};

Icon.createFromIconfontCN = _IconFont["default"];
Icon.getTwoToneColor = _twoTonePrimaryColor.getTwoToneColor;
Icon.setTwoToneColor = _twoTonePrimaryColor.setTwoToneColor;
var _default = Icon;
exports["default"] = _default;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ConfigConsumer", {
  enumerable: true,
  get: function get() {
    return _context.ConfigConsumer;
  }
});
exports["default"] = exports.configConsumerProps = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _localeProvider = _interopRequireWildcard(__webpack_require__(800));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(113));

var _context = __webpack_require__(801);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var configConsumerProps = ['getPopupContainer', 'rootPrefixCls', 'getPrefixCls', 'renderEmpty', 'csp', 'autoInsertSpaceInButton', 'locale', 'pageHeader'];
exports.configConsumerProps = configConsumerProps;

var ConfigProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(ConfigProvider, _React$Component);

  var _super = _createSuper(ConfigProvider);

  function ConfigProvider() {
    var _this;

    _classCallCheck(this, ConfigProvider);

    _this = _super.apply(this, arguments);

    _this.getPrefixCls = function (suffixCls, customizePrefixCls) {
      var _this$props$prefixCls = _this.props.prefixCls,
          prefixCls = _this$props$prefixCls === void 0 ? 'ant' : _this$props$prefixCls;
      if (customizePrefixCls) return customizePrefixCls;
      return suffixCls ? "".concat(prefixCls, "-").concat(suffixCls) : prefixCls;
    };

    _this.renderProvider = function (context, legacyLocale) {
      var _this$props = _this.props,
          children = _this$props.children,
          getPopupContainer = _this$props.getPopupContainer,
          renderEmpty = _this$props.renderEmpty,
          csp = _this$props.csp,
          autoInsertSpaceInButton = _this$props.autoInsertSpaceInButton,
          locale = _this$props.locale,
          pageHeader = _this$props.pageHeader;

      var config = _extends(_extends({}, context), {
        getPrefixCls: _this.getPrefixCls,
        csp: csp,
        autoInsertSpaceInButton: autoInsertSpaceInButton
      });

      if (getPopupContainer) {
        config.getPopupContainer = getPopupContainer;
      }

      if (renderEmpty) {
        config.renderEmpty = renderEmpty;
      }

      if (pageHeader) {
        config.pageHeader = pageHeader;
      }

      return /*#__PURE__*/React.createElement(_context.ConfigContext.Provider, {
        value: config
      }, /*#__PURE__*/React.createElement(_localeProvider["default"], {
        locale: locale || legacyLocale,
        _ANT_MARK__: _localeProvider.ANT_MARK
      }, children));
    };

    return _this;
  }

  _createClass(ConfigProvider, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], null, function (_, __, legacyLocale) {
        return /*#__PURE__*/React.createElement(_context.ConfigConsumer, null, function (context) {
          return _this2.renderProvider(context, legacyLocale);
        });
      });
    }
  }]);

  return ConfigProvider;
}(React.Component);

var _default = ConfigProvider;
exports["default"] = _default;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.qs=undefined;var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};__webpack_require__(10);var _reactRouterDom=__webpack_require__(85);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/*
 * @Descripttion: 
 * @version: 
 * @Author: HanBeiBei
 * @Date: 2020-08-20 18:37:12
 * @LastEditors: HanBeiBei
 * @LastEditTime: 2023-10-31 11:33:31
 */exports.default=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var url=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var config=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var json,res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return fetch(url,_extends({credentials:'include'},config));case 3:json=_context.sent;_context.next=6;return json.json();case 6:res=_context.sent;if(res.status!=1)_message3.default.error(res.msg);return _context.abrupt('return',res);case 11:_context.prev=11;_context.t0=_context['catch'](0);console.log(_context.t0);fetch('/accept/error?title=\u63A5\u53E3\u8FD4\u56DE\u9519\u8BEF&content='+JSON.stringify(_context.t0)+'&url='+url,{credentials:'include'});return _context.abrupt('return',false);case 16:case'end':return _context.stop();}}},_callee,undefined,[[0,11]]);}));return function(){return _ref.apply(this,arguments);};}();var qs=exports.qs=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var url=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var config=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var json,res;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return fetch('/qiansheng/'+url,_extends({credentials:'include'},config));case 3:json=_context2.sent;_context2.next=6;return json.json();case 6:res=_context2.sent;if(res.code!=200)_message3.default.error(res.message);if(!(res.code==401)){_context2.next=12;break;}_message3.default.error(res.message);location.href="/login";return _context2.abrupt('return');case 12:return _context2.abrupt('return',res);case 15:_context2.prev=15;_context2.t0=_context2['catch'](0);console.log(_context2.t0);_message3.default.error(_context2.t0.message||"请求错误！");return _context2.abrupt('return',false);case 20:case'end':return _context2.stop();}}},_callee2,undefined,[[0,15]]);}));return function qs(){return _ref2.apply(this,arguments);};}();

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(19));

var _rcSelect = _interopRequireWildcard(__webpack_require__(1085));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _omit = _interopRequireDefault(__webpack_require__(71));

var _configProvider = __webpack_require__(39);

var _warning = _interopRequireDefault(__webpack_require__(69));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _type = __webpack_require__(130);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var SelectSizes = (0, _type.tuple)('default', 'large', 'small');
var ModeOptions = (0, _type.tuple)('default', 'multiple', 'tags', 'combobox', 'SECRET_COMBOBOX_MODE_DO_NOT_USE');
var SelectPropTypes = {
  prefixCls: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(SelectSizes),
  notFoundContent: PropTypes.any,
  showSearch: PropTypes.bool,
  optionLabelProp: PropTypes.string,
  transitionName: PropTypes.string,
  choiceTransitionName: PropTypes.string,
  id: PropTypes.string
};

var Select = /*#__PURE__*/function (_React$Component) {
  _inherits(Select, _React$Component);

  var _super = _createSuper(Select);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _super.call(this, props);

    _this.saveSelect = function (node) {
      _this.rcSelect = node;
    };

    _this.renderSelect = function (_ref) {
      var _classNames;

      var getContextPopupContainer = _ref.getPopupContainer,
          getPrefixCls = _ref.getPrefixCls,
          renderEmpty = _ref.renderEmpty;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          _a$className = _a.className,
          className = _a$className === void 0 ? '' : _a$className,
          size = _a.size,
          mode = _a.mode,
          getPopupContainer = _a.getPopupContainer,
          removeIcon = _a.removeIcon,
          clearIcon = _a.clearIcon,
          menuItemSelectedIcon = _a.menuItemSelectedIcon,
          showArrow = _a.showArrow,
          restProps = __rest(_a, ["prefixCls", "className", "size", "mode", "getPopupContainer", "removeIcon", "clearIcon", "menuItemSelectedIcon", "showArrow"]);

      var rest = (0, _omit["default"])(restProps, ['inputIcon']);
      var prefixCls = getPrefixCls('select', customizePrefixCls);
      var cls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-show-arrow"), showArrow), _classNames), className);
      var optionLabelProp = _this.props.optionLabelProp;

      if (_this.isCombobox()) {
        // children 带 dom 结构时，无法填入输入框
        optionLabelProp = optionLabelProp || 'value';
      }

      var modeConfig = {
        multiple: mode === 'multiple',
        tags: mode === 'tags',
        combobox: _this.isCombobox()
      };
      var finalRemoveIcon = removeIcon && ( /*#__PURE__*/React.isValidElement(removeIcon) ? /*#__PURE__*/React.cloneElement(removeIcon, {
        className: (0, _classnames["default"])(removeIcon.props.className, "".concat(prefixCls, "-remove-icon"))
      }) : removeIcon) || /*#__PURE__*/React.createElement(_icon["default"], {
        type: "close",
        className: "".concat(prefixCls, "-remove-icon")
      });
      var finalClearIcon = clearIcon && ( /*#__PURE__*/React.isValidElement(clearIcon) ? /*#__PURE__*/React.cloneElement(clearIcon, {
        className: (0, _classnames["default"])(clearIcon.props.className, "".concat(prefixCls, "-clear-icon"))
      }) : clearIcon) || /*#__PURE__*/React.createElement(_icon["default"], {
        type: "close-circle",
        theme: "filled",
        className: "".concat(prefixCls, "-clear-icon")
      });
      var finalMenuItemSelectedIcon = menuItemSelectedIcon && ( /*#__PURE__*/React.isValidElement(menuItemSelectedIcon) ? /*#__PURE__*/React.cloneElement(menuItemSelectedIcon, {
        className: (0, _classnames["default"])(menuItemSelectedIcon.props.className, "".concat(prefixCls, "-selected-icon"))
      }) : menuItemSelectedIcon) || /*#__PURE__*/React.createElement(_icon["default"], {
        type: "check",
        className: "".concat(prefixCls, "-selected-icon")
      });
      return /*#__PURE__*/React.createElement(_rcSelect["default"], _extends({
        inputIcon: _this.renderSuffixIcon(prefixCls),
        removeIcon: finalRemoveIcon,
        clearIcon: finalClearIcon,
        menuItemSelectedIcon: finalMenuItemSelectedIcon,
        showArrow: showArrow
      }, rest, modeConfig, {
        prefixCls: prefixCls,
        className: cls,
        optionLabelProp: optionLabelProp || 'children',
        notFoundContent: _this.getNotFoundContent(renderEmpty),
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        ref: _this.saveSelect
      }));
    };

    (0, _warning["default"])(props.mode !== 'combobox', 'Select', 'The combobox mode is deprecated, ' + 'it will be removed in next major version, ' + 'please use AutoComplete instead');
    return _this;
  }

  _createClass(Select, [{
    key: "getNotFoundContent",
    value: function getNotFoundContent(renderEmpty) {
      var notFoundContent = this.props.notFoundContent;

      if (notFoundContent !== undefined) {
        return notFoundContent;
      }

      if (this.isCombobox()) {
        return null;
      }

      return renderEmpty('Select');
    }
  }, {
    key: "focus",
    value: function focus() {
      this.rcSelect.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.rcSelect.blur();
    }
  }, {
    key: "isCombobox",
    value: function isCombobox() {
      var mode = this.props.mode;
      return mode === 'combobox' || mode === Select.SECRET_COMBOBOX_MODE_DO_NOT_USE;
    }
  }, {
    key: "renderSuffixIcon",
    value: function renderSuffixIcon(prefixCls) {
      var _this$props = this.props,
          loading = _this$props.loading,
          suffixIcon = _this$props.suffixIcon;

      if (suffixIcon) {
        return /*#__PURE__*/React.isValidElement(suffixIcon) ? /*#__PURE__*/React.cloneElement(suffixIcon, {
          className: (0, _classnames["default"])(suffixIcon.props.className, "".concat(prefixCls, "-arrow-icon"))
        }) : suffixIcon;
      }

      if (loading) {
        return /*#__PURE__*/React.createElement(_icon["default"], {
          type: "loading"
        });
      }

      return /*#__PURE__*/React.createElement(_icon["default"], {
        type: "down",
        className: "".concat(prefixCls, "-arrow-icon")
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSelect);
    }
  }]);

  return Select;
}(React.Component);

exports["default"] = Select;
Select.Option = _rcSelect.Option;
Select.OptGroup = _rcSelect.OptGroup;
Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
Select.defaultProps = {
  showSearch: false,
  transitionName: 'slide-up',
  choiceTransitionName: 'zoom'
};
Select.propTypes = SelectPropTypes;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(1101);

__webpack_require__(365);

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _popover=__webpack_require__(396);var _popover2=_interopRequireDefault(_popover);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(287);__webpack_require__(6);__webpack_require__(10);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Compared=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Compared,_Component);function Compared(props){_classCallCheck(this,Compared);var _this=_possibleConstructorReturn(this,(Compared.__proto__||Object.getPrototypeOf(Compared)).call(this,props));_this.addCompared=function(){_this.setState({loading:true});var data=_this.props.data;if(!data.t_type)delete data.t_type;data=_extends({},data,{title:data.title.toString(),add_time:(0,_moment2.default)().format('YYYY-MM-DD HH:mm:ss')});var headres={method:'post',credentials:'include',headers:{contentType:"application/json;charset=utf-8"},body:JSON.stringify(data)};fetch('/addECompared',headres).then(function(x){return x.json();}).then(function(x){if(x.status==1){_message3.default.success('添加成功');}else{_message3.default.error('添加失败！');}_this.setState({loading:false});}).catch(function(err){console.error(err);_this.setState({loading:false});});};_this.state={loading:false};return _this;}_createClass(Compared,[{key:'render',value:function render(){var content=_react2.default.createElement(_button2.default,{style:{width:"100%"},onClick:this.addCompared,loading:this.state.loading},'\u6DFB\u52A0');// return (
//     <Popover content={content} title="点击添加到对比数据">
//         {this.props.children}
//     </Popover>
// )
if(this.props.store.compared.state){return _react2.default.createElement(_popover2.default,{content:content,title:_react2.default.createElement('div',{style:{textAlign:'center'}},'\u70B9\u51FB\u6DFB\u52A0\u5230\u5BF9\u6BD4\u6570\u636E')},this.props.children);}return this.props.children;}}]);return Compared;}(_react.Component))||_class)||_class);exports.default=Compared;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var env = __webpack_require__(67);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var each = zrUtil.each;
var isObject = zrUtil.isObject;
var isArray = zrUtil.isArray;
/**
 * Make the name displayable. But we should
 * make sure it is not duplicated with user
 * specified name, so use '\0';
 */

var DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
/**
 * If value is not array, then translate it to array.
 * @param  {*} value
 * @return {Array} [value] or value
 */

function normalizeToArray(value) {
  return value instanceof Array ? value : value == null ? [] : [value];
}
/**
 * Sync default option between normal and emphasis like `position` and `show`
 * In case some one will write code like
 *     label: {
 *          show: false,
 *          position: 'outside',
 *          fontSize: 18
 *     },
 *     emphasis: {
 *          label: { show: true }
 *     }
 * @param {Object} opt
 * @param {string} key
 * @param {Array.<string>} subOpts
 */


function defaultEmphasis(opt, key, subOpts) {
  // Caution: performance sensitive.
  if (opt) {
    opt[key] = opt[key] || {};
    opt.emphasis = opt.emphasis || {};
    opt.emphasis[key] = opt.emphasis[key] || {}; // Default emphasis option from normal

    for (var i = 0, len = subOpts.length; i < len; i++) {
      var subOptName = subOpts[i];

      if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) {
        opt.emphasis[key][subOptName] = opt[key][subOptName];
      }
    }
  }
}

var TEXT_STYLE_OPTIONS = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily', 'rich', 'tag', 'color', 'textBorderColor', 'textBorderWidth', 'width', 'height', 'lineHeight', 'align', 'verticalAlign', 'baseline', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY', 'textShadowColor', 'textShadowBlur', 'textShadowOffsetX', 'textShadowOffsetY', 'backgroundColor', 'borderColor', 'borderWidth', 'borderRadius', 'padding']; // modelUtil.LABEL_OPTIONS = modelUtil.TEXT_STYLE_OPTIONS.concat([
//     'position', 'offset', 'rotate', 'origin', 'show', 'distance', 'formatter',
//     'fontStyle', 'fontWeight', 'fontSize', 'fontFamily',
//     // FIXME: deprecated, check and remove it.
//     'textStyle'
// ]);

/**
 * The method do not ensure performance.
 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
 * This helper method retieves value from data.
 * @param {string|number|Date|Array|Object} dataItem
 * @return {number|string|Date|Array.<number|string|Date>}
 */

function getDataItemValue(dataItem) {
  return isObject(dataItem) && !isArray(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
}
/**
 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
 * This helper method determine if dataItem has extra option besides value
 * @param {string|number|Date|Array|Object} dataItem
 */


function isDataItemOption(dataItem) {
  return isObject(dataItem) && !(dataItem instanceof Array); // // markLine data can be array
  // && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}
/**
 * Mapping to exists for merge.
 *
 * @public
 * @param {Array.<Object>|Array.<module:echarts/model/Component>} exists
 * @param {Object|Array.<Object>} newCptOptions
 * @return {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
 *                          index of which is the same as exists.
 */


function mappingToExists(exists, newCptOptions) {
  // Mapping by the order by original option (but not order of
  // new option) in merge mode. Because we should ensure
  // some specified index (like xAxisIndex) is consistent with
  // original option, which is easy to understand, espatially in
  // media query. And in most case, merge option is used to
  // update partial option but not be expected to change order.
  newCptOptions = (newCptOptions || []).slice();
  var result = zrUtil.map(exists || [], function (obj, index) {
    return {
      exist: obj
    };
  }); // Mapping by id or name if specified.

  each(newCptOptions, function (cptOption, index) {
    if (!isObject(cptOption)) {
      return;
    } // id has highest priority.


    for (var i = 0; i < result.length; i++) {
      if (!result[i].option // Consider name: two map to one.
      && cptOption.id != null && result[i].exist.id === cptOption.id + '') {
        result[i].option = cptOption;
        newCptOptions[index] = null;
        return;
      }
    }

    for (var i = 0; i < result.length; i++) {
      var exist = result[i].exist;

      if (!result[i].option // Consider name: two map to one.
      // Can not match when both ids exist but different.
      && (exist.id == null || cptOption.id == null) && cptOption.name != null && !isIdInner(cptOption) && !isIdInner(exist) && exist.name === cptOption.name + '') {
        result[i].option = cptOption;
        newCptOptions[index] = null;
        return;
      }
    }
  }); // Otherwise mapping by index.

  each(newCptOptions, function (cptOption, index) {
    if (!isObject(cptOption)) {
      return;
    }

    var i = 0;

    for (; i < result.length; i++) {
      var exist = result[i].exist;

      if (!result[i].option // Existing model that already has id should be able to
      // mapped to (because after mapping performed model may
      // be assigned with a id, whish should not affect next
      // mapping), except those has inner id.
      && !isIdInner(exist) // Caution:
      // Do not overwrite id. But name can be overwritten,
      // because axis use name as 'show label text'.
      // 'exist' always has id and name and we dont
      // need to check it.
      && cptOption.id == null) {
        result[i].option = cptOption;
        break;
      }
    }

    if (i >= result.length) {
      result.push({
        option: cptOption
      });
    }
  });
  return result;
}
/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 *
 * @public
 * @param {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
 *                          which order is the same as exists.
 * @return {Array.<Object>} The input.
 */


function makeIdAndName(mapResult) {
  // We use this id to hash component models and view instances
  // in echarts. id can be specified by user, or auto generated.
  // The id generation rule ensures new view instance are able
  // to mapped to old instance when setOption are called in
  // no-merge mode. So we generate model id by name and plus
  // type in view id.
  // name can be duplicated among components, which is convenient
  // to specify multi components (like series) by one name.
  // Ensure that each id is distinct.
  var idMap = zrUtil.createHashMap();
  each(mapResult, function (item, index) {
    var existCpt = item.exist;
    existCpt && idMap.set(existCpt.id, item);
  });
  each(mapResult, function (item, index) {
    var opt = item.option;
    zrUtil.assert(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
    opt && opt.id != null && idMap.set(opt.id, item);
    !item.keyInfo && (item.keyInfo = {});
  }); // Make name and id.

  each(mapResult, function (item, index) {
    var existCpt = item.exist;
    var opt = item.option;
    var keyInfo = item.keyInfo;

    if (!isObject(opt)) {
      return;
    } // name can be overwitten. Consider case: axis.name = '20km'.
    // But id generated by name will not be changed, which affect
    // only in that case: setOption with 'not merge mode' and view
    // instance will be recreated, which can be accepted.


    keyInfo.name = opt.name != null ? opt.name + '' : existCpt ? existCpt.name // Avoid diffferent series has the same name,
    // because name may be used like in color pallet.
    : DUMMY_COMPONENT_NAME_PREFIX + index;

    if (existCpt) {
      keyInfo.id = existCpt.id;
    } else if (opt.id != null) {
      keyInfo.id = opt.id + '';
    } else {
      // Consider this situatoin:
      //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
      //  optionB [{..}, {name: 'a'}, {name: 'a'}]
      // Series with the same name between optionA and optionB
      // should be mapped.
      var idNum = 0;

      do {
        keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
      } while (idMap.get(keyInfo.id));
    }

    idMap.set(keyInfo.id, item);
  });
}

function isNameSpecified(componentModel) {
  var name = componentModel.name; // Is specified when `indexOf` get -1 or > 0.

  return !!(name && name.indexOf(DUMMY_COMPONENT_NAME_PREFIX));
}
/**
 * @public
 * @param {Object} cptOption
 * @return {boolean}
 */


function isIdInner(cptOption) {
  return isObject(cptOption) && cptOption.id && (cptOption.id + '').indexOf('\0_ec_\0') === 0;
}
/**
 * A helper for removing duplicate items between batchA and batchB,
 * and in themselves, and categorize by series.
 *
 * @param {Array.<Object>} batchA Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
 * @param {Array.<Object>} batchB Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
 * @return {Array.<Array.<Object>, Array.<Object>>} result: [resultBatchA, resultBatchB]
 */


function compressBatches(batchA, batchB) {
  var mapA = {};
  var mapB = {};
  makeMap(batchA || [], mapA);
  makeMap(batchB || [], mapB, mapA);
  return [mapToArray(mapA), mapToArray(mapB)];

  function makeMap(sourceBatch, map, otherMap) {
    for (var i = 0, len = sourceBatch.length; i < len; i++) {
      var seriesId = sourceBatch[i].seriesId;
      var dataIndices = normalizeToArray(sourceBatch[i].dataIndex);
      var otherDataIndices = otherMap && otherMap[seriesId];

      for (var j = 0, lenj = dataIndices.length; j < lenj; j++) {
        var dataIndex = dataIndices[j];

        if (otherDataIndices && otherDataIndices[dataIndex]) {
          otherDataIndices[dataIndex] = null;
        } else {
          (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
        }
      }
    }
  }

  function mapToArray(map, isData) {
    var result = [];

    for (var i in map) {
      if (map.hasOwnProperty(i) && map[i] != null) {
        if (isData) {
          result.push(+i);
        } else {
          var dataIndices = mapToArray(map[i], true);
          dataIndices.length && result.push({
            seriesId: i,
            dataIndex: dataIndices
          });
        }
      }
    }

    return result;
  }
}
/**
 * @param {module:echarts/data/List} data
 * @param {Object} payload Contains dataIndex (means rawIndex) / dataIndexInside / name
 *                         each of which can be Array or primary type.
 * @return {number|Array.<number>} dataIndex If not found, return undefined/null.
 */


function queryDataIndex(data, payload) {
  if (payload.dataIndexInside != null) {
    return payload.dataIndexInside;
  } else if (payload.dataIndex != null) {
    return zrUtil.isArray(payload.dataIndex) ? zrUtil.map(payload.dataIndex, function (value) {
      return data.indexOfRawIndex(value);
    }) : data.indexOfRawIndex(payload.dataIndex);
  } else if (payload.name != null) {
    return zrUtil.isArray(payload.name) ? zrUtil.map(payload.name, function (value) {
      return data.indexOfName(value);
    }) : data.indexOfName(payload.name);
  }
}
/**
 * Enable property storage to any host object.
 * Notice: Serialization is not supported.
 *
 * For example:
 * var inner = zrUitl.makeInner();
 *
 * function some1(hostObj) {
 *      inner(hostObj).someProperty = 1212;
 *      ...
 * }
 * function some2() {
 *      var fields = inner(this);
 *      fields.someProperty1 = 1212;
 *      fields.someProperty2 = 'xx';
 *      ...
 * }
 *
 * @return {Function}
 */


function makeInner() {
  // Consider different scope by es module import.
  var key = '__\0ec_inner_' + innerUniqueIndex++ + '_' + Math.random().toFixed(5);
  return function (hostObj) {
    return hostObj[key] || (hostObj[key] = {});
  };
}

var innerUniqueIndex = 0;
/**
 * @param {module:echarts/model/Global} ecModel
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex, seriesId, seriesName,
 *            geoIndex, geoId, geoName,
 *            bmapIndex, bmapId, bmapName,
 *            xAxisIndex, xAxisId, xAxisName,
 *            yAxisIndex, yAxisId, yAxisName,
 *            gridIndex, gridId, gridName,
 *            ... (can be extended)
 *        }
 *        Each properties can be number|string|Array.<number>|Array.<string>
 *        For example, a finder could be
 *        {
 *            seriesIndex: 3,
 *            geoId: ['aa', 'cc'],
 *            gridName: ['xx', 'rr']
 *        }
 *        xxxIndex can be set as 'all' (means all xxx) or 'none' (means not specify)
 *        If nothing or null/undefined specified, return nothing.
 * @param {Object} [opt]
 * @param {string} [opt.defaultMainType]
 * @param {Array.<string>} [opt.includeMainTypes]
 * @return {Object} result like:
 *        {
 *            seriesModels: [seriesModel1, seriesModel2],
 *            seriesModel: seriesModel1, // The first model
 *            geoModels: [geoModel1, geoModel2],
 *            geoModel: geoModel1, // The first model
 *            ...
 *        }
 */

function parseFinder(ecModel, finder, opt) {
  if (zrUtil.isString(finder)) {
    var obj = {};
    obj[finder + 'Index'] = 0;
    finder = obj;
  }

  var defaultMainType = opt && opt.defaultMainType;

  if (defaultMainType && !has(finder, defaultMainType + 'Index') && !has(finder, defaultMainType + 'Id') && !has(finder, defaultMainType + 'Name')) {
    finder[defaultMainType + 'Index'] = 0;
  }

  var result = {};
  each(finder, function (value, key) {
    var value = finder[key]; // Exclude 'dataIndex' and other illgal keys.

    if (key === 'dataIndex' || key === 'dataIndexInside') {
      result[key] = value;
      return;
    }

    var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
    var mainType = parsedKey[1];
    var queryType = (parsedKey[2] || '').toLowerCase();

    if (!mainType || !queryType || value == null || queryType === 'index' && value === 'none' || opt && opt.includeMainTypes && zrUtil.indexOf(opt.includeMainTypes, mainType) < 0) {
      return;
    }

    var queryParam = {
      mainType: mainType
    };

    if (queryType !== 'index' || value !== 'all') {
      queryParam[queryType] = value;
    }

    var models = ecModel.queryComponents(queryParam);
    result[mainType + 'Models'] = models;
    result[mainType + 'Model'] = models[0];
  });
  return result;
}

function has(obj, prop) {
  return obj && obj.hasOwnProperty(prop);
}

function setAttribute(dom, key, value) {
  dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
}

function getAttribute(dom, key) {
  return dom.getAttribute ? dom.getAttribute(key) : dom[key];
}

function getTooltipRenderMode(renderModeOption) {
  if (renderModeOption === 'auto') {
    // Using html when `document` exists, use richText otherwise
    return env.domSupported ? 'html' : 'richText';
  } else {
    return renderModeOption || 'html';
  }
}
/**
 * Group a list by key.
 *
 * @param {Array} array
 * @param {Function} getKey
 *        param {*} Array item
 *        return {string} key
 * @return {Object} Result
 *        {Array}: keys,
 *        {module:zrender/core/util/HashMap} buckets: {key -> Array}
 */


function groupData(array, getKey) {
  var buckets = zrUtil.createHashMap();
  var keys = [];
  zrUtil.each(array, function (item) {
    var key = getKey(item);
    (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
  });
  return {
    keys: keys,
    buckets: buckets
  };
}

exports.normalizeToArray = normalizeToArray;
exports.defaultEmphasis = defaultEmphasis;
exports.TEXT_STYLE_OPTIONS = TEXT_STYLE_OPTIONS;
exports.getDataItemValue = getDataItemValue;
exports.isDataItemOption = isDataItemOption;
exports.mappingToExists = mappingToExists;
exports.makeIdAndName = makeIdAndName;
exports.isNameSpecified = isNameSpecified;
exports.isIdInner = isIdInner;
exports.compressBatches = compressBatches;
exports.queryDataIndex = queryDataIndex;
exports.makeInner = makeInner;
exports.parseFinder = parseFinder;
exports.setAttribute = setAttribute;
exports.getAttribute = getAttribute;
exports.getTooltipRenderMode = getTooltipRenderMode;
exports.groupData = groupData;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(52);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(747);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// (1) The code `if (__DEV__) ...` can be removed by build tool.
// (2) If intend to use `__DEV__`, this module should be imported. Use a global
// variable `__DEV__` may cause that miss the declaration (see #6535), or the
// declaration is behind of the using position (for example in `Model.extent`,
// And tools like rollup can not analysis the dependency if not import).
var dev; // In browser

if (typeof window !== 'undefined') {
  dev = window.__DEV__;
} // In node
else if (typeof global !== 'undefined') {
    dev = global.__DEV__;
  }

if (typeof dev === 'undefined') {
  dev = true;
}

var __DEV__ = dev;
exports.__DEV__ = __DEV__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(754);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var BoundingRect = __webpack_require__(57);

var _number = __webpack_require__(37);

var parsePercent = _number.parsePercent;

var formatUtil = __webpack_require__(54);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Layout helpers for each component positioning
var each = zrUtil.each;
/**
 * @public
 */

var LOCATION_PARAMS = ['left', 'right', 'top', 'bottom', 'width', 'height'];
/**
 * @public
 */

var HV_NAMES = [['width', 'left', 'right'], ['height', 'top', 'bottom']];

function boxLayout(orient, group, gap, maxWidth, maxHeight) {
  var x = 0;
  var y = 0;

  if (maxWidth == null) {
    maxWidth = Infinity;
  }

  if (maxHeight == null) {
    maxHeight = Infinity;
  }

  var currentLineMaxSize = 0;
  group.eachChild(function (child, idx) {
    var position = child.position;
    var rect = child.getBoundingRect();
    var nextChild = group.childAt(idx + 1);
    var nextChildRect = nextChild && nextChild.getBoundingRect();
    var nextX;
    var nextY;

    if (orient === 'horizontal') {
      var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
      nextX = x + moveX; // Wrap when width exceeds maxWidth or meet a `newline` group
      // FIXME compare before adding gap?

      if (nextX > maxWidth || child.newline) {
        x = 0;
        nextX = moveX;
        y += currentLineMaxSize + gap;
        currentLineMaxSize = rect.height;
      } else {
        // FIXME: consider rect.y is not `0`?
        currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
      }
    } else {
      var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
      nextY = y + moveY; // Wrap when width exceeds maxHeight or meet a `newline` group

      if (nextY > maxHeight || child.newline) {
        x += currentLineMaxSize + gap;
        y = 0;
        nextY = moveY;
        currentLineMaxSize = rect.width;
      } else {
        currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
      }
    }

    if (child.newline) {
      return;
    }

    position[0] = x;
    position[1] = y;
    orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
  });
}
/**
 * VBox or HBox layouting
 * @param {string} orient
 * @param {module:zrender/container/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */


var box = boxLayout;
/**
 * VBox layouting
 * @param {module:zrender/container/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */

var vbox = zrUtil.curry(boxLayout, 'vertical');
/**
 * HBox layouting
 * @param {module:zrender/container/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */

var hbox = zrUtil.curry(boxLayout, 'horizontal');
/**
 * If x or x2 is not specified or 'center' 'left' 'right',
 * the width would be as long as possible.
 * If y or y2 is not specified or 'middle' 'top' 'bottom',
 * the height would be as long as possible.
 *
 * @param {Object} positionInfo
 * @param {number|string} [positionInfo.x]
 * @param {number|string} [positionInfo.y]
 * @param {number|string} [positionInfo.x2]
 * @param {number|string} [positionInfo.y2]
 * @param {Object} containerRect {width, height}
 * @param {string|number} margin
 * @return {Object} {width, height}
 */

function getAvailableSize(positionInfo, containerRect, margin) {
  var containerWidth = containerRect.width;
  var containerHeight = containerRect.height;
  var x = parsePercent(positionInfo.x, containerWidth);
  var y = parsePercent(positionInfo.y, containerHeight);
  var x2 = parsePercent(positionInfo.x2, containerWidth);
  var y2 = parsePercent(positionInfo.y2, containerHeight);
  (isNaN(x) || isNaN(parseFloat(positionInfo.x))) && (x = 0);
  (isNaN(x2) || isNaN(parseFloat(positionInfo.x2))) && (x2 = containerWidth);
  (isNaN(y) || isNaN(parseFloat(positionInfo.y))) && (y = 0);
  (isNaN(y2) || isNaN(parseFloat(positionInfo.y2))) && (y2 = containerHeight);
  margin = formatUtil.normalizeCssArray(margin || 0);
  return {
    width: Math.max(x2 - x - margin[1] - margin[3], 0),
    height: Math.max(y2 - y - margin[0] - margin[2], 0)
  };
}
/**
 * Parse position info.
 *
 * @param {Object} positionInfo
 * @param {number|string} [positionInfo.left]
 * @param {number|string} [positionInfo.top]
 * @param {number|string} [positionInfo.right]
 * @param {number|string} [positionInfo.bottom]
 * @param {number|string} [positionInfo.width]
 * @param {number|string} [positionInfo.height]
 * @param {number|string} [positionInfo.aspect] Aspect is width / height
 * @param {Object} containerRect
 * @param {string|number} [margin]
 *
 * @return {module:zrender/core/BoundingRect}
 */


function getLayoutRect(positionInfo, containerRect, margin) {
  margin = formatUtil.normalizeCssArray(margin || 0);
  var containerWidth = containerRect.width;
  var containerHeight = containerRect.height;
  var left = parsePercent(positionInfo.left, containerWidth);
  var top = parsePercent(positionInfo.top, containerHeight);
  var right = parsePercent(positionInfo.right, containerWidth);
  var bottom = parsePercent(positionInfo.bottom, containerHeight);
  var width = parsePercent(positionInfo.width, containerWidth);
  var height = parsePercent(positionInfo.height, containerHeight);
  var verticalMargin = margin[2] + margin[0];
  var horizontalMargin = margin[1] + margin[3];
  var aspect = positionInfo.aspect; // If width is not specified, calculate width from left and right

  if (isNaN(width)) {
    width = containerWidth - right - horizontalMargin - left;
  }

  if (isNaN(height)) {
    height = containerHeight - bottom - verticalMargin - top;
  }

  if (aspect != null) {
    // If width and height are not given
    // 1. Graph should not exceeds the container
    // 2. Aspect must be keeped
    // 3. Graph should take the space as more as possible
    // FIXME
    // Margin is not considered, because there is no case that both
    // using margin and aspect so far.
    if (isNaN(width) && isNaN(height)) {
      if (aspect > containerWidth / containerHeight) {
        width = containerWidth * 0.8;
      } else {
        height = containerHeight * 0.8;
      }
    } // Calculate width or height with given aspect


    if (isNaN(width)) {
      width = aspect * height;
    }

    if (isNaN(height)) {
      height = width / aspect;
    }
  } // If left is not specified, calculate left from right and width


  if (isNaN(left)) {
    left = containerWidth - right - width - horizontalMargin;
  }

  if (isNaN(top)) {
    top = containerHeight - bottom - height - verticalMargin;
  } // Align left and top


  switch (positionInfo.left || positionInfo.right) {
    case 'center':
      left = containerWidth / 2 - width / 2 - margin[3];
      break;

    case 'right':
      left = containerWidth - width - horizontalMargin;
      break;
  }

  switch (positionInfo.top || positionInfo.bottom) {
    case 'middle':
    case 'center':
      top = containerHeight / 2 - height / 2 - margin[0];
      break;

    case 'bottom':
      top = containerHeight - height - verticalMargin;
      break;
  } // If something is wrong and left, top, width, height are calculated as NaN


  left = left || 0;
  top = top || 0;

  if (isNaN(width)) {
    // Width may be NaN if only one value is given except width
    width = containerWidth - horizontalMargin - left - (right || 0);
  }

  if (isNaN(height)) {
    // Height may be NaN if only one value is given except height
    height = containerHeight - verticalMargin - top - (bottom || 0);
  }

  var rect = new BoundingRect(left + margin[3], top + margin[0], width, height);
  rect.margin = margin;
  return rect;
}
/**
 * Position a zr element in viewport
 *  Group position is specified by either
 *  {left, top}, {right, bottom}
 *  If all properties exists, right and bottom will be igonred.
 *
 * Logic:
 *     1. Scale (against origin point in parent coord)
 *     2. Rotate (against origin point in parent coord)
 *     3. Traslate (with el.position by this method)
 * So this method only fixes the last step 'Traslate', which does not affect
 * scaling and rotating.
 *
 * If be called repeatly with the same input el, the same result will be gotten.
 *
 * @param {module:zrender/Element} el Should have `getBoundingRect` method.
 * @param {Object} positionInfo
 * @param {number|string} [positionInfo.left]
 * @param {number|string} [positionInfo.top]
 * @param {number|string} [positionInfo.right]
 * @param {number|string} [positionInfo.bottom]
 * @param {number|string} [positionInfo.width] Only for opt.boundingModel: 'raw'
 * @param {number|string} [positionInfo.height] Only for opt.boundingModel: 'raw'
 * @param {Object} containerRect
 * @param {string|number} margin
 * @param {Object} [opt]
 * @param {Array.<number>} [opt.hv=[1,1]] Only horizontal or only vertical.
 * @param {Array.<number>} [opt.boundingMode='all']
 *        Specify how to calculate boundingRect when locating.
 *        'all': Position the boundingRect that is transformed and uioned
 *               both itself and its descendants.
 *               This mode simplies confine the elements in the bounding
 *               of their container (e.g., using 'right: 0').
 *        'raw': Position the boundingRect that is not transformed and only itself.
 *               This mode is useful when you want a element can overflow its
 *               container. (Consider a rotated circle needs to be located in a corner.)
 *               In this mode positionInfo.width/height can only be number.
 */


function positionElement(el, positionInfo, containerRect, margin, opt) {
  var h = !opt || !opt.hv || opt.hv[0];
  var v = !opt || !opt.hv || opt.hv[1];
  var boundingMode = opt && opt.boundingMode || 'all';

  if (!h && !v) {
    return;
  }

  var rect;

  if (boundingMode === 'raw') {
    rect = el.type === 'group' ? new BoundingRect(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
  } else {
    rect = el.getBoundingRect();

    if (el.needLocalTransform()) {
      var transform = el.getLocalTransform(); // Notice: raw rect may be inner object of el,
      // which should not be modified.

      rect = rect.clone();
      rect.applyTransform(transform);
    }
  } // The real width and height can not be specified but calculated by the given el.


  positionInfo = getLayoutRect(zrUtil.defaults({
    width: rect.width,
    height: rect.height
  }, positionInfo), containerRect, margin); // Because 'tranlate' is the last step in transform
  // (see zrender/core/Transformable#getLocalTransform),
  // we can just only modify el.position to get final result.

  var elPos = el.position;
  var dx = h ? positionInfo.x - rect.x : 0;
  var dy = v ? positionInfo.y - rect.y : 0;
  el.attr('position', boundingMode === 'raw' ? [dx, dy] : [elPos[0] + dx, elPos[1] + dy]);
}
/**
 * @param {Object} option Contains some of the properties in HV_NAMES.
 * @param {number} hvIdx 0: horizontal; 1: vertical.
 */


function sizeCalculable(option, hvIdx) {
  return option[HV_NAMES[hvIdx][0]] != null || option[HV_NAMES[hvIdx][1]] != null && option[HV_NAMES[hvIdx][2]] != null;
}
/**
 * Consider Case:
 * When defulat option has {left: 0, width: 100}, and we set {right: 0}
 * through setOption or media query, using normal zrUtil.merge will cause
 * {right: 0} does not take effect.
 *
 * @example
 * ComponentModel.extend({
 *     init: function () {
 *         ...
 *         var inputPositionParams = layout.getLayoutParams(option);
 *         this.mergeOption(inputPositionParams);
 *     },
 *     mergeOption: function (newOption) {
 *         newOption && zrUtil.merge(thisOption, newOption, true);
 *         layout.mergeLayoutParam(thisOption, newOption);
 *     }
 * });
 *
 * @param {Object} targetOption
 * @param {Object} newOption
 * @param {Object|string} [opt]
 * @param {boolean|Array.<boolean>} [opt.ignoreSize=false] Used for the components
 *  that width (or height) should not be calculated by left and right (or top and bottom).
 */


function mergeLayoutParam(targetOption, newOption, opt) {
  !zrUtil.isObject(opt) && (opt = {});
  var ignoreSize = opt.ignoreSize;
  !zrUtil.isArray(ignoreSize) && (ignoreSize = [ignoreSize, ignoreSize]);
  var hResult = merge(HV_NAMES[0], 0);
  var vResult = merge(HV_NAMES[1], 1);
  copy(HV_NAMES[0], targetOption, hResult);
  copy(HV_NAMES[1], targetOption, vResult);

  function merge(names, hvIdx) {
    var newParams = {};
    var newValueCount = 0;
    var merged = {};
    var mergedValueCount = 0;
    var enoughParamNumber = 2;
    each(names, function (name) {
      merged[name] = targetOption[name];
    });
    each(names, function (name) {
      // Consider case: newOption.width is null, which is
      // set by user for removing width setting.
      hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
      hasValue(newParams, name) && newValueCount++;
      hasValue(merged, name) && mergedValueCount++;
    });

    if (ignoreSize[hvIdx]) {
      // Only one of left/right is premitted to exist.
      if (hasValue(newOption, names[1])) {
        merged[names[2]] = null;
      } else if (hasValue(newOption, names[2])) {
        merged[names[1]] = null;
      }

      return merged;
    } // Case: newOption: {width: ..., right: ...},
    // or targetOption: {right: ...} and newOption: {width: ...},
    // There is no conflict when merged only has params count
    // little than enoughParamNumber.


    if (mergedValueCount === enoughParamNumber || !newValueCount) {
      return merged;
    } // Case: newOption: {width: ..., right: ...},
    // Than we can make sure user only want those two, and ignore
    // all origin params in targetOption.
    else if (newValueCount >= enoughParamNumber) {
        return newParams;
      } else {
        // Chose another param from targetOption by priority.
        for (var i = 0; i < names.length; i++) {
          var name = names[i];

          if (!hasProp(newParams, name) && hasProp(targetOption, name)) {
            newParams[name] = targetOption[name];
            break;
          }
        }

        return newParams;
      }
  }

  function hasProp(obj, name) {
    return obj.hasOwnProperty(name);
  }

  function hasValue(obj, name) {
    return obj[name] != null && obj[name] !== 'auto';
  }

  function copy(names, target, source) {
    each(names, function (name) {
      target[name] = source[name];
    });
  }
}
/**
 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
 * @param {Object} source
 * @return {Object} Result contains those props.
 */


function getLayoutParams(source) {
  return copyLayoutParams({}, source);
}
/**
 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
 * @param {Object} source
 * @return {Object} Result contains those props.
 */


function copyLayoutParams(target, source) {
  source && target && each(LOCATION_PARAMS, function (name) {
    source.hasOwnProperty(name) && (target[name] = source[name]);
  });
  return target;
}

exports.LOCATION_PARAMS = LOCATION_PARAMS;
exports.HV_NAMES = HV_NAMES;
exports.box = box;
exports.vbox = vbox;
exports.hbox = hbox;
exports.getAvailableSize = getAvailableSize;
exports.getLayoutRect = getLayoutRect;
exports.positionElement = positionElement;
exports.sizeCalculable = sizeCalculable;
exports.mergeLayoutParam = mergeLayoutParam;
exports.getLayoutParams = getLayoutParams;
exports.copyLayoutParams = copyLayoutParams;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var textContain = __webpack_require__(93);

var numberUtil = __webpack_require__(37);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// import Text from 'zrender/src/graphic/Text';

/**
 * add commas after every three numbers
 * @param {string|number} x
 * @return {string}
 */
function addCommas(x) {
  if (isNaN(x)) {
    return '-';
  }

  x = (x + '').split('.');
  return x[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (x.length > 1 ? '.' + x[1] : '');
}
/**
 * @param {string} str
 * @param {boolean} [upperCaseFirst=false]
 * @return {string} str
 */


function toCamelCase(str, upperCaseFirst) {
  str = (str || '').toLowerCase().replace(/-(.)/g, function (match, group1) {
    return group1.toUpperCase();
  });

  if (upperCaseFirst && str) {
    str = str.charAt(0).toUpperCase() + str.slice(1);
  }

  return str;
}

var normalizeCssArray = zrUtil.normalizeCssArray;
var replaceReg = /([&<>"'])/g;
var replaceMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '\'': '&#39;'
};

function encodeHTML(source) {
  return source == null ? '' : (source + '').replace(replaceReg, function (str, c) {
    return replaceMap[c];
  });
}

var TPL_VAR_ALIAS = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];

var wrapVar = function (varName, seriesIdx) {
  return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
};
/**
 * Template formatter
 * @param {string} tpl
 * @param {Array.<Object>|Object} paramsList
 * @param {boolean} [encode=false]
 * @return {string}
 */


function formatTpl(tpl, paramsList, encode) {
  if (!zrUtil.isArray(paramsList)) {
    paramsList = [paramsList];
  }

  var seriesLen = paramsList.length;

  if (!seriesLen) {
    return '';
  }

  var $vars = paramsList[0].$vars || [];

  for (var i = 0; i < $vars.length; i++) {
    var alias = TPL_VAR_ALIAS[i];
    tpl = tpl.replace(wrapVar(alias), wrapVar(alias, 0));
  }

  for (var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++) {
    for (var k = 0; k < $vars.length; k++) {
      var val = paramsList[seriesIdx][$vars[k]];
      tpl = tpl.replace(wrapVar(TPL_VAR_ALIAS[k], seriesIdx), encode ? encodeHTML(val) : val);
    }
  }

  return tpl;
}
/**
 * simple Template formatter
 *
 * @param {string} tpl
 * @param {Object} param
 * @param {boolean} [encode=false]
 * @return {string}
 */


function formatTplSimple(tpl, param, encode) {
  zrUtil.each(param, function (value, key) {
    tpl = tpl.replace('{' + key + '}', encode ? encodeHTML(value) : value);
  });
  return tpl;
}
/**
 * @param {Object|string} [opt] If string, means color.
 * @param {string} [opt.color]
 * @param {string} [opt.extraCssText]
 * @param {string} [opt.type='item'] 'item' or 'subItem'
 * @param {string} [opt.renderMode='html'] render mode of tooltip, 'html' or 'richText'
 * @param {string} [opt.markerId='X'] id name for marker. If only one marker is in a rich text, this can be omitted.
 * @return {string}
 */


function getTooltipMarker(opt, extraCssText) {
  opt = zrUtil.isString(opt) ? {
    color: opt,
    extraCssText: extraCssText
  } : opt || {};
  var color = opt.color;
  var type = opt.type;
  var extraCssText = opt.extraCssText;
  var renderMode = opt.renderMode || 'html';
  var markerId = opt.markerId || 'X';

  if (!color) {
    return '';
  }

  if (renderMode === 'html') {
    return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;' + 'border-radius:4px;width:4px;height:4px;background-color:' + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:5px;' + 'border-radius:10px;width:10px;height:10px;background-color:' + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>';
  } else {
    // Space for rich element marker
    return {
      renderMode: renderMode,
      content: '{marker' + markerId + '|}  ',
      style: {
        color: color
      }
    };
  }
}

function pad(str, len) {
  str += '';
  return '0000'.substr(0, len - str.length) + str;
}
/**
 * ISO Date format
 * @param {string} tpl
 * @param {number} value
 * @param {boolean} [isUTC=false] Default in local time.
 *           see `module:echarts/scale/Time`
 *           and `module:echarts/util/number#parseDate`.
 * @inner
 */


function formatTime(tpl, value, isUTC) {
  if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') {
    tpl = 'MM-dd\nyyyy';
  }

  var date = numberUtil.parseDate(value);
  var utc = isUTC ? 'UTC' : '';
  var y = date['get' + utc + 'FullYear']();
  var M = date['get' + utc + 'Month']() + 1;
  var d = date['get' + utc + 'Date']();
  var h = date['get' + utc + 'Hours']();
  var m = date['get' + utc + 'Minutes']();
  var s = date['get' + utc + 'Seconds']();
  var S = date['get' + utc + 'Milliseconds']();
  tpl = tpl.replace('MM', pad(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', y % 100).replace('dd', pad(d, 2)).replace('d', d).replace('hh', pad(h, 2)).replace('h', h).replace('mm', pad(m, 2)).replace('m', m).replace('ss', pad(s, 2)).replace('s', s).replace('SSS', pad(S, 3));
  return tpl;
}
/**
 * Capital first
 * @param {string} str
 * @return {string}
 */


function capitalFirst(str) {
  return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
}

var truncateText = textContain.truncateText;
/**
 * @public
 * @param {Object} opt
 * @param {string} opt.text
 * @param {string} opt.font
 * @param {string} [opt.textAlign='left']
 * @param {string} [opt.textVerticalAlign='top']
 * @param {Array.<number>} [opt.textPadding]
 * @param {number} [opt.textLineHeight]
 * @param {Object} [opt.rich]
 * @param {Object} [opt.truncate]
 * @return {Object} {x, y, width, height, lineHeight}
 */

function getTextBoundingRect(opt) {
  return textContain.getBoundingRect(opt.text, opt.font, opt.textAlign, opt.textVerticalAlign, opt.textPadding, opt.textLineHeight, opt.rich, opt.truncate);
}
/**
 * @deprecated
 * the `textLineHeight` was added later.
 * For backward compatiblility, put it as the last parameter.
 * But deprecated this interface. Please use `getTextBoundingRect` instead.
 */


function getTextRect(text, font, textAlign, textVerticalAlign, textPadding, rich, truncate, textLineHeight) {
  return textContain.getBoundingRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate);
}
/**
 * open new tab
 * @param {string} link url
 * @param {string} target blank or self
 */


function windowOpen(link, target) {
  if (target === '_blank' || target === 'blank') {
    var blank = window.open();
    blank.opener = null;
    blank.location = link;
  } else {
    window.open(link, target);
  }
}

exports.addCommas = addCommas;
exports.toCamelCase = toCamelCase;
exports.normalizeCssArray = normalizeCssArray;
exports.encodeHTML = encodeHTML;
exports.formatTpl = formatTpl;
exports.formatTplSimple = formatTplSimple;
exports.getTooltipMarker = getTooltipMarker;
exports.formatTime = formatTime;
exports.capitalFirst = capitalFirst;
exports.truncateText = truncateText;
exports.getTextBoundingRect = getTextBoundingRect;
exports.getTextRect = getTextRect;
exports.windowOpen = windowOpen;

/***/ }),
/* 55 */
/***/ (function(module, exports) {

/* global Float32Array */
var ArrayCtor = typeof Float32Array === 'undefined' ? Array : Float32Array;
/**
 * 创建一个向量
 * @param {number} [x=0]
 * @param {number} [y=0]
 * @return {Vector2}
 */

function create(x, y) {
  var out = new ArrayCtor(2);

  if (x == null) {
    x = 0;
  }

  if (y == null) {
    y = 0;
  }

  out[0] = x;
  out[1] = y;
  return out;
}
/**
 * 复制向量数据
 * @param {Vector2} out
 * @param {Vector2} v
 * @return {Vector2}
 */


function copy(out, v) {
  out[0] = v[0];
  out[1] = v[1];
  return out;
}
/**
 * 克隆一个向量
 * @param {Vector2} v
 * @return {Vector2}
 */


function clone(v) {
  var out = new ArrayCtor(2);
  out[0] = v[0];
  out[1] = v[1];
  return out;
}
/**
 * 设置向量的两个项
 * @param {Vector2} out
 * @param {number} a
 * @param {number} b
 * @return {Vector2} 结果
 */


function set(out, a, b) {
  out[0] = a;
  out[1] = b;
  return out;
}
/**
 * 向量相加
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */


function add(out, v1, v2) {
  out[0] = v1[0] + v2[0];
  out[1] = v1[1] + v2[1];
  return out;
}
/**
 * 向量缩放后相加
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @param {number} a
 */


function scaleAndAdd(out, v1, v2, a) {
  out[0] = v1[0] + v2[0] * a;
  out[1] = v1[1] + v2[1] * a;
  return out;
}
/**
 * 向量相减
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */


function sub(out, v1, v2) {
  out[0] = v1[0] - v2[0];
  out[1] = v1[1] - v2[1];
  return out;
}
/**
 * 向量长度
 * @param {Vector2} v
 * @return {number}
 */


function len(v) {
  return Math.sqrt(lenSquare(v));
}

var length = len; // jshint ignore:line

/**
 * 向量长度平方
 * @param {Vector2} v
 * @return {number}
 */

function lenSquare(v) {
  return v[0] * v[0] + v[1] * v[1];
}

var lengthSquare = lenSquare;
/**
 * 向量乘法
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */

function mul(out, v1, v2) {
  out[0] = v1[0] * v2[0];
  out[1] = v1[1] * v2[1];
  return out;
}
/**
 * 向量除法
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */


function div(out, v1, v2) {
  out[0] = v1[0] / v2[0];
  out[1] = v1[1] / v2[1];
  return out;
}
/**
 * 向量点乘
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @return {number}
 */


function dot(v1, v2) {
  return v1[0] * v2[0] + v1[1] * v2[1];
}
/**
 * 向量缩放
 * @param {Vector2} out
 * @param {Vector2} v
 * @param {number} s
 */


function scale(out, v, s) {
  out[0] = v[0] * s;
  out[1] = v[1] * s;
  return out;
}
/**
 * 向量归一化
 * @param {Vector2} out
 * @param {Vector2} v
 */


function normalize(out, v) {
  var d = len(v);

  if (d === 0) {
    out[0] = 0;
    out[1] = 0;
  } else {
    out[0] = v[0] / d;
    out[1] = v[1] / d;
  }

  return out;
}
/**
 * 计算向量间距离
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @return {number}
 */


function distance(v1, v2) {
  return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
}

var dist = distance;
/**
 * 向量距离平方
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @return {number}
 */

function distanceSquare(v1, v2) {
  return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
}

var distSquare = distanceSquare;
/**
 * 求负向量
 * @param {Vector2} out
 * @param {Vector2} v
 */

function negate(out, v) {
  out[0] = -v[0];
  out[1] = -v[1];
  return out;
}
/**
 * 插值两个点
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @param {number} t
 */


function lerp(out, v1, v2, t) {
  out[0] = v1[0] + t * (v2[0] - v1[0]);
  out[1] = v1[1] + t * (v2[1] - v1[1]);
  return out;
}
/**
 * 矩阵左乘向量
 * @param {Vector2} out
 * @param {Vector2} v
 * @param {Vector2} m
 */


function applyTransform(out, v, m) {
  var x = v[0];
  var y = v[1];
  out[0] = m[0] * x + m[2] * y + m[4];
  out[1] = m[1] * x + m[3] * y + m[5];
  return out;
}
/**
 * 求两个向量最小值
 * @param  {Vector2} out
 * @param  {Vector2} v1
 * @param  {Vector2} v2
 */


function min(out, v1, v2) {
  out[0] = Math.min(v1[0], v2[0]);
  out[1] = Math.min(v1[1], v2[1]);
  return out;
}
/**
 * 求两个向量最大值
 * @param  {Vector2} out
 * @param  {Vector2} v1
 * @param  {Vector2} v2
 */


function max(out, v1, v2) {
  out[0] = Math.max(v1[0], v2[0]);
  out[1] = Math.max(v1[1], v2[1]);
  return out;
}

exports.create = create;
exports.copy = copy;
exports.clone = clone;
exports.set = set;
exports.add = add;
exports.scaleAndAdd = scaleAndAdd;
exports.sub = sub;
exports.len = len;
exports.length = length;
exports.lenSquare = lenSquare;
exports.lengthSquare = lengthSquare;
exports.mul = mul;
exports.div = div;
exports.dot = dot;
exports.scale = scale;
exports.normalize = normalize;
exports.distance = distance;
exports.dist = dist;
exports.distanceSquare = distanceSquare;
exports.distSquare = distSquare;
exports.negate = negate;
exports.lerp = lerp;
exports.applyTransform = applyTransform;
exports.min = min;
exports.max = max;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(226)('wks');
var uid = __webpack_require__(161);
var Symbol = __webpack_require__(49).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var vec2 = __webpack_require__(55);

var matrix = __webpack_require__(82);

/**
 * @module echarts/core/BoundingRect
 */
var v2ApplyTransform = vec2.applyTransform;
var mathMin = Math.min;
var mathMax = Math.max;
/**
 * @alias module:echarts/core/BoundingRect
 */

function BoundingRect(x, y, width, height) {
  if (width < 0) {
    x = x + width;
    width = -width;
  }

  if (height < 0) {
    y = y + height;
    height = -height;
  }
  /**
   * @type {number}
   */


  this.x = x;
  /**
   * @type {number}
   */

  this.y = y;
  /**
   * @type {number}
   */

  this.width = width;
  /**
   * @type {number}
   */

  this.height = height;
}

BoundingRect.prototype = {
  constructor: BoundingRect,

  /**
   * @param {module:echarts/core/BoundingRect} other
   */
  union: function (other) {
    var x = mathMin(other.x, this.x);
    var y = mathMin(other.y, this.y);
    this.width = mathMax(other.x + other.width, this.x + this.width) - x;
    this.height = mathMax(other.y + other.height, this.y + this.height) - y;
    this.x = x;
    this.y = y;
  },

  /**
   * @param {Array.<number>} m
   * @methods
   */
  applyTransform: function () {
    var lt = [];
    var rb = [];
    var lb = [];
    var rt = [];
    return function (m) {
      // In case usage like this
      // el.getBoundingRect().applyTransform(el.transform)
      // And element has no transform
      if (!m) {
        return;
      }

      lt[0] = lb[0] = this.x;
      lt[1] = rt[1] = this.y;
      rb[0] = rt[0] = this.x + this.width;
      rb[1] = lb[1] = this.y + this.height;
      v2ApplyTransform(lt, lt, m);
      v2ApplyTransform(rb, rb, m);
      v2ApplyTransform(lb, lb, m);
      v2ApplyTransform(rt, rt, m);
      this.x = mathMin(lt[0], rb[0], lb[0], rt[0]);
      this.y = mathMin(lt[1], rb[1], lb[1], rt[1]);
      var maxX = mathMax(lt[0], rb[0], lb[0], rt[0]);
      var maxY = mathMax(lt[1], rb[1], lb[1], rt[1]);
      this.width = maxX - this.x;
      this.height = maxY - this.y;
    };
  }(),

  /**
   * Calculate matrix of transforming from self to target rect
   * @param  {module:zrender/core/BoundingRect} b
   * @return {Array.<number>}
   */
  calculateTransform: function (b) {
    var a = this;
    var sx = b.width / a.width;
    var sy = b.height / a.height;
    var m = matrix.create(); // 矩阵右乘

    matrix.translate(m, m, [-a.x, -a.y]);
    matrix.scale(m, m, [sx, sy]);
    matrix.translate(m, m, [b.x, b.y]);
    return m;
  },

  /**
   * @param {(module:echarts/core/BoundingRect|Object)} b
   * @return {boolean}
   */
  intersect: function (b) {
    if (!b) {
      return false;
    }

    if (!(b instanceof BoundingRect)) {
      // Normalize negative width/height.
      b = BoundingRect.create(b);
    }

    var a = this;
    var ax0 = a.x;
    var ax1 = a.x + a.width;
    var ay0 = a.y;
    var ay1 = a.y + a.height;
    var bx0 = b.x;
    var bx1 = b.x + b.width;
    var by0 = b.y;
    var by1 = b.y + b.height;
    return !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
  },
  contain: function (x, y) {
    var rect = this;
    return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
  },

  /**
   * @return {module:echarts/core/BoundingRect}
   */
  clone: function () {
    return new BoundingRect(this.x, this.y, this.width, this.height);
  },

  /**
   * Copy from another rect
   */
  copy: function (other) {
    this.x = other.x;
    this.y = other.y;
    this.width = other.width;
    this.height = other.height;
  },
  plain: function () {
    return {
      x: this.x,
      y: this.y,
      width: this.width,
      height: this.height
    };
  }
};
/**
 * @param {Object|module:zrender/core/BoundingRect} rect
 * @param {number} rect.x
 * @param {number} rect.y
 * @param {number} rect.width
 * @param {number} rect.height
 * @return {module:zrender/core/BoundingRect}
 */

BoundingRect.create = function (rect) {
  return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
};

var _default = BoundingRect;
module.exports = _default;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(105);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _grid = __webpack_require__(261);

var _default = _grid.Col;
exports["default"] = _default;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(345);

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _Modal = _interopRequireWildcard(__webpack_require__(468));

var _confirm = _interopRequireDefault(__webpack_require__(828));

var _icon = _interopRequireDefault(__webpack_require__(38));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function modalWarn(props) {
  var config = _extends({
    type: 'warning',
    icon: /*#__PURE__*/React.createElement(_icon["default"], {
      type: "exclamation-circle"
    }),
    okCancel: false
  }, props);

  return (0, _confirm["default"])(config);
}

_Modal["default"].info = function infoFn(props) {
  var config = _extends({
    type: 'info',
    icon: /*#__PURE__*/React.createElement(_icon["default"], {
      type: "info-circle"
    }),
    okCancel: false
  }, props);

  return (0, _confirm["default"])(config);
};

_Modal["default"].success = function successFn(props) {
  var config = _extends({
    type: 'success',
    icon: /*#__PURE__*/React.createElement(_icon["default"], {
      type: "check-circle"
    }),
    okCancel: false
  }, props);

  return (0, _confirm["default"])(config);
};

_Modal["default"].error = function errorFn(props) {
  var config = _extends({
    type: 'error',
    icon: /*#__PURE__*/React.createElement(_icon["default"], {
      type: "close-circle"
    }),
    okCancel: false
  }, props);

  return (0, _confirm["default"])(config);
};

_Modal["default"].warning = modalWarn;
_Modal["default"].warn = modalWarn;

_Modal["default"].confirm = function confirmFn(props) {
  var config = _extends({
    type: 'confirm',
    okCancel: true
  }, props);

  return (0, _confirm["default"])(config);
};

_Modal["default"].destroyAll = function destroyAllFn() {
  while (_Modal.destroyFns.length) {
    var close = _Modal.destroyFns.pop();

    if (close) {
      close();
    }
  }
};

var _default = _Modal["default"];
exports["default"] = _default;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(835);

__webpack_require__(6);

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(51)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _echarts = __webpack_require__(23);

(function () {
  for (var key in _echarts) {
    if (_echarts == null || !_echarts.hasOwnProperty(key) || key === 'default' || key === '__esModule') return;
    exports[key] = _echarts[key];
  }
})();

var _export = __webpack_require__(639);

(function () {
  for (var key in _export) {
    if (_export == null || !_export.hasOwnProperty(key) || key === 'default' || key === '__esModule') return;
    exports[key] = _export[key];
  }
})();

__webpack_require__(637);

__webpack_require__(1572);

__webpack_require__(1583);

__webpack_require__(1588);

__webpack_require__(1593);

__webpack_require__(1597);

__webpack_require__(1607);

__webpack_require__(1621);

__webpack_require__(1627);

__webpack_require__(1635);

__webpack_require__(1650);

__webpack_require__(1654);

__webpack_require__(1658);

__webpack_require__(1670);

__webpack_require__(1676);

__webpack_require__(1681);

__webpack_require__(1687);

__webpack_require__(1691);

__webpack_require__(1697);

__webpack_require__(1701);

__webpack_require__(1704);

__webpack_require__(1718);

__webpack_require__(1724);

__webpack_require__(1730);

__webpack_require__(1731);

__webpack_require__(1743);

__webpack_require__(673);

__webpack_require__(666);

__webpack_require__(1746);

__webpack_require__(1750);

__webpack_require__(1751);

__webpack_require__(1763);

__webpack_require__(246);

__webpack_require__(1768);

__webpack_require__(1775);

__webpack_require__(1776);

__webpack_require__(1785);

__webpack_require__(1788);

__webpack_require__(1791);

__webpack_require__(1794);

__webpack_require__(682);

__webpack_require__(1800);

__webpack_require__(686);

__webpack_require__(685);

__webpack_require__(1806);

__webpack_require__(687);

__webpack_require__(696);

__webpack_require__(1811);

__webpack_require__(1814);

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var Displayable = __webpack_require__(233);

var zrUtil = __webpack_require__(1);

var PathProxy = __webpack_require__(205);

var pathContain = __webpack_require__(1541);

var Pattern = __webpack_require__(619);

var getCanvasPattern = Pattern.prototype.getCanvasPattern;
var abs = Math.abs;
var pathProxyForDraw = new PathProxy(true);
/**
 * @alias module:zrender/graphic/Path
 * @extends module:zrender/graphic/Displayable
 * @constructor
 * @param {Object} opts
 */

function Path(opts) {
  Displayable.call(this, opts);
  /**
   * @type {module:zrender/core/PathProxy}
   * @readOnly
   */

  this.path = null;
}

Path.prototype = {
  constructor: Path,
  type: 'path',
  __dirtyPath: true,
  strokeContainThreshold: 5,
  // This item default to be false. But in map series in echarts,
  // in order to improve performance, it should be set to true,
  // so the shorty segment won't draw.
  segmentIgnoreThreshold: 0,

  /**
   * See `module:zrender/src/graphic/helper/subPixelOptimize`.
   * @type {boolean}
   */
  subPixelOptimize: false,
  brush: function (ctx, prevEl) {
    var style = this.style;
    var path = this.path || pathProxyForDraw;
    var hasStroke = style.hasStroke();
    var hasFill = style.hasFill();
    var fill = style.fill;
    var stroke = style.stroke;
    var hasFillGradient = hasFill && !!fill.colorStops;
    var hasStrokeGradient = hasStroke && !!stroke.colorStops;
    var hasFillPattern = hasFill && !!fill.image;
    var hasStrokePattern = hasStroke && !!stroke.image;
    style.bind(ctx, this, prevEl);
    this.setTransform(ctx);

    if (this.__dirty) {
      var rect; // Update gradient because bounding rect may changed

      if (hasFillGradient) {
        rect = rect || this.getBoundingRect();
        this._fillGradient = style.getGradient(ctx, fill, rect);
      }

      if (hasStrokeGradient) {
        rect = rect || this.getBoundingRect();
        this._strokeGradient = style.getGradient(ctx, stroke, rect);
      }
    } // Use the gradient or pattern


    if (hasFillGradient) {
      // PENDING If may have affect the state
      ctx.fillStyle = this._fillGradient;
    } else if (hasFillPattern) {
      ctx.fillStyle = getCanvasPattern.call(fill, ctx);
    }

    if (hasStrokeGradient) {
      ctx.strokeStyle = this._strokeGradient;
    } else if (hasStrokePattern) {
      ctx.strokeStyle = getCanvasPattern.call(stroke, ctx);
    }

    var lineDash = style.lineDash;
    var lineDashOffset = style.lineDashOffset;
    var ctxLineDash = !!ctx.setLineDash; // Update path sx, sy

    var scale = this.getGlobalScale();
    path.setScale(scale[0], scale[1], this.segmentIgnoreThreshold); // Proxy context
    // Rebuild path in following 2 cases
    // 1. Path is dirty
    // 2. Path needs javascript implemented lineDash stroking.
    //    In this case, lineDash information will not be saved in PathProxy

    if (this.__dirtyPath || lineDash && !ctxLineDash && hasStroke) {
      path.beginPath(ctx); // Setting line dash before build path

      if (lineDash && !ctxLineDash) {
        path.setLineDash(lineDash);
        path.setLineDashOffset(lineDashOffset);
      }

      this.buildPath(path, this.shape, false); // Clear path dirty flag

      if (this.path) {
        this.__dirtyPath = false;
      }
    } else {
      // Replay path building
      ctx.beginPath();
      this.path.rebuildPath(ctx);
    }

    if (hasFill) {
      if (style.fillOpacity != null) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.fillOpacity * style.opacity;
        path.fill(ctx);
        ctx.globalAlpha = originalGlobalAlpha;
      } else {
        path.fill(ctx);
      }
    }

    if (lineDash && ctxLineDash) {
      ctx.setLineDash(lineDash);
      ctx.lineDashOffset = lineDashOffset;
    }

    if (hasStroke) {
      if (style.strokeOpacity != null) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.strokeOpacity * style.opacity;
        path.stroke(ctx);
        ctx.globalAlpha = originalGlobalAlpha;
      } else {
        path.stroke(ctx);
      }
    }

    if (lineDash && ctxLineDash) {
      // PENDING
      // Remove lineDash
      ctx.setLineDash([]);
    } // Draw rect text


    if (style.text != null) {
      // Only restore transform when needs draw text.
      this.restoreTransform(ctx);
      this.drawRectText(ctx, this.getBoundingRect());
    }
  },
  // When bundling path, some shape may decide if use moveTo to begin a new subpath or closePath
  // Like in circle
  buildPath: function (ctx, shapeCfg, inBundle) {},
  createPathProxy: function () {
    this.path = new PathProxy();
  },
  getBoundingRect: function () {
    var rect = this._rect;
    var style = this.style;
    var needsUpdateRect = !rect;

    if (needsUpdateRect) {
      var path = this.path;

      if (!path) {
        // Create path on demand.
        path = this.path = new PathProxy();
      }

      if (this.__dirtyPath) {
        path.beginPath();
        this.buildPath(path, this.shape, false);
      }

      rect = path.getBoundingRect();
    }

    this._rect = rect;

    if (style.hasStroke()) {
      // Needs update rect with stroke lineWidth when
      // 1. Element changes scale or lineWidth
      // 2. Shape is changed
      var rectWithStroke = this._rectWithStroke || (this._rectWithStroke = rect.clone());

      if (this.__dirty || needsUpdateRect) {
        rectWithStroke.copy(rect); // FIXME Must after updateTransform

        var w = style.lineWidth; // PENDING, Min line width is needed when line is horizontal or vertical

        var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Only add extra hover lineWidth when there are no fill

        if (!style.hasFill()) {
          w = Math.max(w, this.strokeContainThreshold || 4);
        } // Consider line width
        // Line scale can't be 0;


        if (lineScale > 1e-10) {
          rectWithStroke.width += w / lineScale;
          rectWithStroke.height += w / lineScale;
          rectWithStroke.x -= w / lineScale / 2;
          rectWithStroke.y -= w / lineScale / 2;
        }
      } // Return rect with stroke


      return rectWithStroke;
    }

    return rect;
  },
  contain: function (x, y) {
    var localPos = this.transformCoordToLocal(x, y);
    var rect = this.getBoundingRect();
    var style = this.style;
    x = localPos[0];
    y = localPos[1];

    if (rect.contain(x, y)) {
      var pathData = this.path.data;

      if (style.hasStroke()) {
        var lineWidth = style.lineWidth;
        var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Line scale can't be 0;

        if (lineScale > 1e-10) {
          // Only add extra hover lineWidth when there are no fill
          if (!style.hasFill()) {
            lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
          }

          if (pathContain.containStroke(pathData, lineWidth / lineScale, x, y)) {
            return true;
          }
        }
      }

      if (style.hasFill()) {
        return pathContain.contain(pathData, x, y);
      }
    }

    return false;
  },

  /**
   * @param  {boolean} dirtyPath
   */
  dirty: function (dirtyPath) {
    if (dirtyPath == null) {
      dirtyPath = true;
    } // Only mark dirty, not mark clean


    if (dirtyPath) {
      this.__dirtyPath = dirtyPath;
      this._rect = null;
    }

    this.__dirty = this.__dirtyText = true;
    this.__zr && this.__zr.refresh(); // Used as a clipping path

    if (this.__clipTarget) {
      this.__clipTarget.dirty();
    }
  },

  /**
   * Alias for animate('shape')
   * @param {boolean} loop
   */
  animateShape: function (loop) {
    return this.animate('shape', loop);
  },
  // Overwrite attrKV
  attrKV: function (key, value) {
    // FIXME
    if (key === 'shape') {
      this.setShape(value);
      this.__dirtyPath = true;
      this._rect = null;
    } else {
      Displayable.prototype.attrKV.call(this, key, value);
    }
  },

  /**
   * @param {Object|string} key
   * @param {*} value
   */
  setShape: function (key, value) {
    var shape = this.shape; // Path from string may not have shape

    if (shape) {
      if (zrUtil.isObject(key)) {
        for (var name in key) {
          if (key.hasOwnProperty(name)) {
            shape[name] = key[name];
          }
        }
      } else {
        shape[key] = value;
      }

      this.dirty(true);
    }

    return this;
  },
  getLineScale: function () {
    var m = this.transform; // Get the line scale.
    // Determinant of `m` means how much the area is enlarged by the
    // transformation. So its square root can be used as a scale factor
    // for width.

    return m && abs(m[0] - 1) > 1e-10 && abs(m[3] - 1) > 1e-10 ? Math.sqrt(abs(m[0] * m[3] - m[2] * m[1])) : 1;
  }
};
/**
 * 扩展一个 Path element, 比如星形，圆等。
 * Extend a path element
 * @param {Object} props
 * @param {string} props.type Path type
 * @param {Function} props.init Initialize
 * @param {Function} props.buildPath Overwrite buildPath method
 * @param {Object} [props.style] Extended default style config
 * @param {Object} [props.shape] Extended default shape config
 */

Path.extend = function (defaults) {
  var Sub = function (opts) {
    Path.call(this, opts);

    if (defaults.style) {
      // Extend default style
      this.style.extendFrom(defaults.style, false);
    } // Extend default shape


    var defaultShape = defaults.shape;

    if (defaultShape) {
      this.shape = this.shape || {};
      var thisShape = this.shape;

      for (var name in defaultShape) {
        if (!thisShape.hasOwnProperty(name) && defaultShape.hasOwnProperty(name)) {
          thisShape[name] = defaultShape[name];
        }
      }
    }

    defaults.init && defaults.init.call(this, opts);
  };

  zrUtil.inherits(Sub, Path); // FIXME 不能 extend position, rotation 等引用对象

  for (var name in defaults) {
    // Extending prototype values and methods
    if (name !== 'style' && name !== 'shape') {
      Sub.prototype[name] = defaults[name];
    }
  }

  return Sub;
};

zrUtil.inherits(Path, Displayable);
var _default = Path;
module.exports = _default;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(45);
var IE8_DOM_DEFINE = __webpack_require__(541);
var toPrimitive = __webpack_require__(117);
var dP = Object.defineProperty;

exports.f = __webpack_require__(63) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

/**
 * echarts设备环境识别
 *
 * @desc echarts基于Canvas，纯Javascript图表库，提供直观，生动，可交互，可个性化定制的数据统计图表。
 * @author firede[firede@firede.us]
 * @desc thanks zepto.
 */

/* global wx */
var env = {};

if (typeof wx === 'object' && typeof wx.getSystemInfoSync === 'function') {
  // In Weixin Application
  env = {
    browser: {},
    os: {},
    node: false,
    wxa: true,
    // Weixin Application
    canvasSupported: true,
    svgSupported: false,
    touchEventsSupported: true,
    domSupported: false
  };
} else if (typeof document === 'undefined' && typeof self !== 'undefined') {
  // In worker
  env = {
    browser: {},
    os: {},
    node: false,
    worker: true,
    canvasSupported: true,
    domSupported: false
  };
} else if (typeof navigator === 'undefined') {
  // In node
  env = {
    browser: {},
    os: {},
    node: true,
    worker: false,
    // Assume canvas is supported
    canvasSupported: true,
    svgSupported: true,
    domSupported: false
  };
} else {
  env = detect(navigator.userAgent);
}

var _default = env; // Zepto.js
// (c) 2010-2013 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.

function detect(ua) {
  var os = {};
  var browser = {}; // var webkit = ua.match(/Web[kK]it[\/]{0,1}([\d.]+)/);
  // var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
  // var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  // var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  // var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
  // var webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/);
  // var touchpad = webos && ua.match(/TouchPad/);
  // var kindle = ua.match(/Kindle\/([\d.]+)/);
  // var silk = ua.match(/Silk\/([\d._]+)/);
  // var blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/);
  // var bb10 = ua.match(/(BB10).*Version\/([\d.]+)/);
  // var rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/);
  // var playbook = ua.match(/PlayBook/);
  // var chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/);

  var firefox = ua.match(/Firefox\/([\d.]+)/); // var safari = webkit && ua.match(/Mobile\//) && !chrome;
  // var webview = ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/) && !chrome;

  var ie = ua.match(/MSIE\s([\d.]+)/) // IE 11 Trident/7.0; rv:11.0
  || ua.match(/Trident\/.+?rv:(([\d.]+))/);
  var edge = ua.match(/Edge\/([\d.]+)/); // IE 12 and 12+

  var weChat = /micromessenger/i.test(ua); // Todo: clean this up with a better OS/browser seperation:
  // - discern (more) between multiple browsers on android
  // - decide if kindle fire in silk mode is android or not
  // - Firefox on Android doesn't specify the Android version
  // - possibly devide in os, device and browser hashes
  // if (browser.webkit = !!webkit) browser.version = webkit[1];
  // if (android) os.android = true, os.version = android[2];
  // if (iphone && !ipod) os.ios = os.iphone = true, os.version = iphone[2].replace(/_/g, '.');
  // if (ipad) os.ios = os.ipad = true, os.version = ipad[2].replace(/_/g, '.');
  // if (ipod) os.ios = os.ipod = true, os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
  // if (webos) os.webos = true, os.version = webos[2];
  // if (touchpad) os.touchpad = true;
  // if (blackberry) os.blackberry = true, os.version = blackberry[2];
  // if (bb10) os.bb10 = true, os.version = bb10[2];
  // if (rimtabletos) os.rimtabletos = true, os.version = rimtabletos[2];
  // if (playbook) browser.playbook = true;
  // if (kindle) os.kindle = true, os.version = kindle[1];
  // if (silk) browser.silk = true, browser.version = silk[1];
  // if (!silk && os.android && ua.match(/Kindle Fire/)) browser.silk = true;
  // if (chrome) browser.chrome = true, browser.version = chrome[1];

  if (firefox) {
    browser.firefox = true;
    browser.version = firefox[1];
  } // if (safari && (ua.match(/Safari/) || !!os.ios)) browser.safari = true;
  // if (webview) browser.webview = true;


  if (ie) {
    browser.ie = true;
    browser.version = ie[1];
  }

  if (edge) {
    browser.edge = true;
    browser.version = edge[1];
  } // It is difficult to detect WeChat in Win Phone precisely, because ua can
  // not be set on win phone. So we do not consider Win Phone.


  if (weChat) {
    browser.weChat = true;
  } // os.tablet = !!(ipad || playbook || (android && !ua.match(/Mobile/)) ||
  //     (firefox && ua.match(/Tablet/)) || (ie && !ua.match(/Phone/) && ua.match(/Touch/)));
  // os.phone  = !!(!os.tablet && !os.ipod && (android || iphone || webos ||
  //     (chrome && ua.match(/Android/)) || (chrome && ua.match(/CriOS\/([\d.]+)/)) ||
  //     (firefox && ua.match(/Mobile/)) || (ie && ua.match(/Touch/))));


  return {
    browser: browser,
    os: os,
    node: false,
    // 原生canvas支持，改极端点了
    // canvasSupported : !(browser.ie && parseFloat(browser.version) < 9)
    canvasSupported: !!document.createElement('canvas').getContext,
    svgSupported: typeof SVGRect !== 'undefined',
    // works on most browsers
    // IE10/11 does not support touch event, and MS Edge supports them but not by
    // default, so we dont check navigator.maxTouchPoints for them here.
    touchEventsSupported: 'ontouchstart' in window && !browser.ie && !browser.edge,
    // <http://caniuse.com/#search=pointer%20event>.
    pointerEventsSupported: // (1) Firefox supports pointer but not by default, only MS browsers are reliable on pointer
    // events currently. So we dont use that on other browsers unless tested sufficiently.
    // For example, in iOS 13 Mobile Chromium 78, if the touching behavior starts page
    // scroll, the `pointermove` event can not be fired any more. That will break some
    // features like "pan horizontally to move something and pan vertically to page scroll".
    // The horizontal pan probably be interrupted by the casually triggered page scroll.
    // (2) Although IE 10 supports pointer event, it use old style and is different from the
    // standard. So we exclude that. (IE 10 is hardly used on touch device)
    'onpointerdown' in window && (browser.edge || browser.ie && browser.version >= 11),
    // passiveSupported: detectPassiveSupport()
    domSupported: typeof document !== 'undefined'
  };
} // See https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
// function detectPassiveSupport() {
//     // Test via a getter in the options object to see if the passive property is accessed
//     var supportsPassive = false;
//     try {
//         var opts = Object.defineProperty({}, 'passive', {
//             get: function() {
//                 supportsPassive = true;
//             }
//         });
//         window.addEventListener('testPassive', function() {}, opts);
//     } catch (e) {
//     }
//     return supportsPassive;
// }


module.exports = _default;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var env = __webpack_require__(67);

var _model = __webpack_require__(44);

var makeInner = _model.makeInner;

var _clazz = __webpack_require__(135);

var enableClassExtend = _clazz.enableClassExtend;
var enableClassCheck = _clazz.enableClassCheck;

var lineStyleMixin = __webpack_require__(1538);

var areaStyleMixin = __webpack_require__(1539);

var textStyleMixin = __webpack_require__(1540);

var itemStyleMixin = __webpack_require__(1553);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @module echarts/model/Model
 */
var mixin = zrUtil.mixin;
var inner = makeInner();
/**
 * @alias module:echarts/model/Model
 * @constructor
 * @param {Object} [option]
 * @param {module:echarts/model/Model} [parentModel]
 * @param {module:echarts/model/Global} [ecModel]
 */

function Model(option, parentModel, ecModel) {
  /**
   * @type {module:echarts/model/Model}
   * @readOnly
   */
  this.parentModel = parentModel;
  /**
   * @type {module:echarts/model/Global}
   * @readOnly
   */

  this.ecModel = ecModel;
  /**
   * @type {Object}
   * @protected
   */

  this.option = option; // Simple optimization
  // if (this.init) {
  //     if (arguments.length <= 4) {
  //         this.init(option, parentModel, ecModel, extraOpt);
  //     }
  //     else {
  //         this.init.apply(this, arguments);
  //     }
  // }
}

Model.prototype = {
  constructor: Model,

  /**
   * Model 的初始化函数
   * @param {Object} option
   */
  init: null,

  /**
   * 从新的 Option merge
   */
  mergeOption: function (option) {
    zrUtil.merge(this.option, option, true);
  },

  /**
   * @param {string|Array.<string>} path
   * @param {boolean} [ignoreParent=false]
   * @return {*}
   */
  get: function (path, ignoreParent) {
    if (path == null) {
      return this.option;
    }

    return doGet(this.option, this.parsePath(path), !ignoreParent && getParent(this, path));
  },

  /**
   * @param {string} key
   * @param {boolean} [ignoreParent=false]
   * @return {*}
   */
  getShallow: function (key, ignoreParent) {
    var option = this.option;
    var val = option == null ? option : option[key];
    var parentModel = !ignoreParent && getParent(this, key);

    if (val == null && parentModel) {
      val = parentModel.getShallow(key);
    }

    return val;
  },

  /**
   * @param {string|Array.<string>} [path]
   * @param {module:echarts/model/Model} [parentModel]
   * @return {module:echarts/model/Model}
   */
  getModel: function (path, parentModel) {
    var obj = path == null ? this.option : doGet(this.option, path = this.parsePath(path));
    var thisParentModel;
    parentModel = parentModel || (thisParentModel = getParent(this, path)) && thisParentModel.getModel(path);
    return new Model(obj, parentModel, this.ecModel);
  },

  /**
   * If model has option
   */
  isEmpty: function () {
    return this.option == null;
  },
  restoreData: function () {},
  // Pending
  clone: function () {
    var Ctor = this.constructor;
    return new Ctor(zrUtil.clone(this.option));
  },
  setReadOnly: function (properties) {// clazzUtil.setReadOnly(this, properties);
  },
  // If path is null/undefined, return null/undefined.
  parsePath: function (path) {
    if (typeof path === 'string') {
      path = path.split('.');
    }

    return path;
  },

  /**
   * @param {Function} getParentMethod
   *        param {Array.<string>|string} path
   *        return {module:echarts/model/Model}
   */
  customizeGetParent: function (getParentMethod) {
    inner(this).getParent = getParentMethod;
  },
  isAnimationEnabled: function () {
    if (!env.node) {
      if (this.option.animation != null) {
        return !!this.option.animation;
      } else if (this.parentModel) {
        return this.parentModel.isAnimationEnabled();
      }
    }
  }
};

function doGet(obj, pathArr, parentModel) {
  for (var i = 0; i < pathArr.length; i++) {
    // Ignore empty
    if (!pathArr[i]) {
      continue;
    } // obj could be number/string/... (like 0)


    obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;

    if (obj == null) {
      break;
    }
  }

  if (obj == null && parentModel) {
    obj = parentModel.get(pathArr);
  }

  return obj;
} // `path` can be null/undefined


function getParent(model, path) {
  var getParentMethod = inner(model).getParent;
  return getParentMethod ? getParentMethod.call(model, path) : model.parentModel;
} // Enable Model.extend.


enableClassExtend(Model);
enableClassCheck(Model);
mixin(Model, lineStyleMixin);
mixin(Model, areaStyleMixin);
mixin(Model, textStyleMixin);
mixin(Model, itemStyleMixin);
var _default = Model;
module.exports = _default;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "resetWarned", {
  enumerable: true,
  get: function get() {
    return _warning.resetWarned;
  }
});
exports["default"] = void 0;

var _warning = _interopRequireWildcard(__webpack_require__(259));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = function _default(valid, component, message) {
  (0, _warning["default"])(valid, "[antd: ".concat(component, "] ").concat(message));
};

exports["default"] = _default;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(118);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function omit(obj, fields) {
  var shallowCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj);
  for (var i = 0; i < fields.length; i++) {
    var key = fields[i];
    delete shallowCopy[key];
  }
  return shallowCopy;
}

/* harmony default export */ __webpack_exports__["default"] = (omit);

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(455);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var Model = __webpack_require__(68);

var componentUtil = __webpack_require__(235);

var _clazz = __webpack_require__(135);

var enableClassManagement = _clazz.enableClassManagement;
var parseClassType = _clazz.parseClassType;

var _model = __webpack_require__(44);

var makeInner = _model.makeInner;

var layout = __webpack_require__(53);

var boxLayoutMixin = __webpack_require__(1554);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Component model
 *
 * @module echarts/model/Component
 */
var inner = makeInner();
/**
 * @alias module:echarts/model/Component
 * @constructor
 * @param {Object} option
 * @param {module:echarts/model/Model} parentModel
 * @param {module:echarts/model/Model} ecModel
 */

var ComponentModel = Model.extend({
  type: 'component',

  /**
   * @readOnly
   * @type {string}
   */
  id: '',

  /**
   * Because simplified concept is probably better, series.name (or component.name)
   * has been having too many resposibilities:
   * (1) Generating id (which requires name in option should not be modified).
   * (2) As an index to mapping series when merging option or calling API (a name
   * can refer to more then one components, which is convinient is some case).
   * (3) Display.
   * @readOnly
   */
  name: '',

  /**
   * @readOnly
   * @type {string}
   */
  mainType: '',

  /**
   * @readOnly
   * @type {string}
   */
  subType: '',

  /**
   * @readOnly
   * @type {number}
   */
  componentIndex: 0,

  /**
   * @type {Object}
   * @protected
   */
  defaultOption: null,

  /**
   * @type {module:echarts/model/Global}
   * @readOnly
   */
  ecModel: null,

  /**
   * key: componentType
   * value:  Component model list, can not be null.
   * @type {Object.<string, Array.<module:echarts/model/Model>>}
   * @readOnly
   */
  dependentModels: [],

  /**
   * @type {string}
   * @readOnly
   */
  uid: null,

  /**
   * Support merge layout params.
   * Only support 'box' now (left/right/top/bottom/width/height).
   * @type {string|Object} Object can be {ignoreSize: true}
   * @readOnly
   */
  layoutMode: null,
  $constructor: function (option, parentModel, ecModel, extraOpt) {
    Model.call(this, option, parentModel, ecModel, extraOpt);
    this.uid = componentUtil.getUID('ec_cpt_model');
  },
  init: function (option, parentModel, ecModel, extraOpt) {
    this.mergeDefaultAndTheme(option, ecModel);
  },
  mergeDefaultAndTheme: function (option, ecModel) {
    var layoutMode = this.layoutMode;
    var inputPositionParams = layoutMode ? layout.getLayoutParams(option) : {};
    var themeModel = ecModel.getTheme();
    zrUtil.merge(option, themeModel.get(this.mainType));
    zrUtil.merge(option, this.getDefaultOption());

    if (layoutMode) {
      layout.mergeLayoutParam(option, inputPositionParams, layoutMode);
    }
  },
  mergeOption: function (option, extraOpt) {
    zrUtil.merge(this.option, option, true);
    var layoutMode = this.layoutMode;

    if (layoutMode) {
      layout.mergeLayoutParam(this.option, option, layoutMode);
    }
  },
  // Hooker after init or mergeOption
  optionUpdated: function (newCptOption, isInit) {},
  getDefaultOption: function () {
    var fields = inner(this);

    if (!fields.defaultOption) {
      var optList = [];
      var Class = this.constructor;

      while (Class) {
        var opt = Class.prototype.defaultOption;
        opt && optList.push(opt);
        Class = Class.superClass;
      }

      var defaultOption = {};

      for (var i = optList.length - 1; i >= 0; i--) {
        defaultOption = zrUtil.merge(defaultOption, optList[i], true);
      }

      fields.defaultOption = defaultOption;
    }

    return fields.defaultOption;
  },
  getReferringComponents: function (mainType) {
    return this.ecModel.queryComponents({
      mainType: mainType,
      index: this.get(mainType + 'Index', true),
      id: this.get(mainType + 'Id', true)
    });
  }
}); // Reset ComponentModel.extend, add preConstruct.
// clazzUtil.enableClassExtend(
//     ComponentModel,
//     function (option, parentModel, ecModel, extraOpt) {
//         // Set dependentModels, componentIndex, name, id, mainType, subType.
//         zrUtil.extend(this, extraOpt);
//         this.uid = componentUtil.getUID('componentModel');
//         // this.setReadOnly([
//         //     'type', 'id', 'uid', 'name', 'mainType', 'subType',
//         //     'dependentModels', 'componentIndex'
//         // ]);
//     }
// );
// Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.

enableClassManagement(ComponentModel, {
  registerWhenExtend: true
});
componentUtil.enableSubTypeDefaulter(ComponentModel); // Add capability of ComponentModel.topologicalTravel.

componentUtil.enableTopologicalTravel(ComponentModel, getDependencies);

function getDependencies(componentType) {
  var deps = [];
  zrUtil.each(ComponentModel.getClassesByMainType(componentType), function (Clazz) {
    deps = deps.concat(Clazz.prototype.dependencies || []);
  }); // Ensure main type.

  deps = zrUtil.map(deps, function (type) {
    return parseClassType(type).main;
  }); // Hack dataset for convenience.

  if (componentType !== 'dataset' && zrUtil.indexOf(deps, 'dataset') <= 0) {
    deps.unshift('dataset');
  }

  return deps;
}

zrUtil.mixin(ComponentModel, boxLayoutMixin);
var _default = ComponentModel;
module.exports = _default;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(1);

var env = __webpack_require__(67);

var _format = __webpack_require__(54);

var formatTime = _format.formatTime;
var encodeHTML = _format.encodeHTML;
var addCommas = _format.addCommas;
var getTooltipMarker = _format.getTooltipMarker;

var modelUtil = __webpack_require__(44);

var ComponentModel = __webpack_require__(73);

var colorPaletteMixin = __webpack_require__(635);

var dataFormatMixin = __webpack_require__(411);

var _layout = __webpack_require__(53);

var getLayoutParams = _layout.getLayoutParams;
var mergeLayoutParam = _layout.mergeLayoutParam;

var _task = __webpack_require__(412);

var createTask = _task.createTask;

var _sourceHelper = __webpack_require__(136);

var prepareSource = _sourceHelper.prepareSource;
var getSource = _sourceHelper.getSource;

var _dataProvider = __webpack_require__(176);

var retrieveRawValue = _dataProvider.retrieveRawValue;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var inner = modelUtil.makeInner();
var SeriesModel = ComponentModel.extend({
  type: 'series.__base__',

  /**
   * @readOnly
   */
  seriesIndex: 0,
  // coodinateSystem will be injected in the echarts/CoordinateSystem
  coordinateSystem: null,

  /**
   * @type {Object}
   * @protected
   */
  defaultOption: null,

  /**
   * legend visual provider to the legend component
   * @type {Object}
   */
  // PENDING
  legendVisualProvider: null,

  /**
   * Access path of color for visual
   */
  visualColorAccessPath: 'itemStyle.color',

  /**
   * Access path of borderColor for visual
   */
  visualBorderColorAccessPath: 'itemStyle.borderColor',

  /**
   * Support merge layout params.
   * Only support 'box' now (left/right/top/bottom/width/height).
   * @type {string|Object} Object can be {ignoreSize: true}
   * @readOnly
   */
  layoutMode: null,
  init: function (option, parentModel, ecModel, extraOpt) {
    /**
     * @type {number}
     * @readOnly
     */
    this.seriesIndex = this.componentIndex;
    this.dataTask = createTask({
      count: dataTaskCount,
      reset: dataTaskReset
    });
    this.dataTask.context = {
      model: this
    };
    this.mergeDefaultAndTheme(option, ecModel);
    prepareSource(this);
    var data = this.getInitialData(option, ecModel);
    wrapData(data, this);
    this.dataTask.context.data = data;

    /**
     * @type {module:echarts/data/List|module:echarts/data/Tree|module:echarts/data/Graph}
     * @private
     */
    inner(this).dataBeforeProcessed = data; // If we reverse the order (make data firstly, and then make
    // dataBeforeProcessed by cloneShallow), cloneShallow will
    // cause data.graph.data !== data when using
    // module:echarts/data/Graph or module:echarts/data/Tree.
    // See module:echarts/data/helper/linkList
    // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
    // init or merge stage, because the data can be restored. So we do not `restoreData`
    // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
    // Call `seriesModel.getRawData()` instead.
    // this.restoreData();

    autoSeriesName(this);
  },

  /**
   * Util for merge default and theme to option
   * @param  {Object} option
   * @param  {module:echarts/model/Global} ecModel
   */
  mergeDefaultAndTheme: function (option, ecModel) {
    var layoutMode = this.layoutMode;
    var inputPositionParams = layoutMode ? getLayoutParams(option) : {}; // Backward compat: using subType on theme.
    // But if name duplicate between series subType
    // (for example: parallel) add component mainType,
    // add suffix 'Series'.

    var themeSubType = this.subType;

    if (ComponentModel.hasClass(themeSubType)) {
      themeSubType += 'Series';
    }

    zrUtil.merge(option, ecModel.getTheme().get(this.subType));
    zrUtil.merge(option, this.getDefaultOption()); // Default label emphasis `show`

    modelUtil.defaultEmphasis(option, 'label', ['show']);
    this.fillDataTextStyle(option.data);

    if (layoutMode) {
      mergeLayoutParam(option, inputPositionParams, layoutMode);
    }
  },
  mergeOption: function (newSeriesOption, ecModel) {
    // this.settingTask.dirty();
    newSeriesOption = zrUtil.merge(this.option, newSeriesOption, true);
    this.fillDataTextStyle(newSeriesOption.data);
    var layoutMode = this.layoutMode;

    if (layoutMode) {
      mergeLayoutParam(this.option, newSeriesOption, layoutMode);
    }

    prepareSource(this);
    var data = this.getInitialData(newSeriesOption, ecModel);
    wrapData(data, this);
    this.dataTask.dirty();
    this.dataTask.context.data = data;
    inner(this).dataBeforeProcessed = data;
    autoSeriesName(this);
  },
  fillDataTextStyle: function (data) {
    // Default data label emphasis `show`
    // FIXME Tree structure data ?
    // FIXME Performance ?
    if (data && !zrUtil.isTypedArray(data)) {
      var props = ['show'];

      for (var i = 0; i < data.length; i++) {
        if (data[i] && data[i].label) {
          modelUtil.defaultEmphasis(data[i], 'label', props);
        }
      }
    }
  },

  /**
   * Init a data structure from data related option in series
   * Must be overwritten
   */
  getInitialData: function () {},

  /**
   * Append data to list
   * @param {Object} params
   * @param {Array|TypedArray} params.data
   */
  appendData: function (params) {
    // FIXME ???
    // (1) If data from dataset, forbidden append.
    // (2) support append data of dataset.
    var data = this.getRawData();
    data.appendData(params.data);
  },

  /**
   * Consider some method like `filter`, `map` need make new data,
   * We should make sure that `seriesModel.getData()` get correct
   * data in the stream procedure. So we fetch data from upstream
   * each time `task.perform` called.
   * @param {string} [dataType]
   * @return {module:echarts/data/List}
   */
  getData: function (dataType) {
    var task = getCurrentTask(this);

    if (task) {
      var data = task.context.data;
      return dataType == null ? data : data.getLinkedData(dataType);
    } else {
      // When series is not alive (that may happen when click toolbox
      // restore or setOption with not merge mode), series data may
      // be still need to judge animation or something when graphic
      // elements want to know whether fade out.
      return inner(this).data;
    }
  },

  /**
   * @param {module:echarts/data/List} data
   */
  setData: function (data) {
    var task = getCurrentTask(this);

    if (task) {
      var context = task.context; // Consider case: filter, data sample.

      if (context.data !== data && task.modifyOutputEnd) {
        task.setOutputEnd(data.count());
      }

      context.outputData = data; // Caution: setData should update context.data,
      // Because getData may be called multiply in a
      // single stage and expect to get the data just
      // set. (For example, AxisProxy, x y both call
      // getData and setDate sequentially).
      // So the context.data should be fetched from
      // upstream each time when a stage starts to be
      // performed.

      if (task !== this.dataTask) {
        context.data = data;
      }
    }

    inner(this).data = data;
  },

  /**
   * @see {module:echarts/data/helper/sourceHelper#getSource}
   * @return {module:echarts/data/Source} source
   */
  getSource: function () {
    return getSource(this);
  },

  /**
   * Get data before processed
   * @return {module:echarts/data/List}
   */
  getRawData: function () {
    return inner(this).dataBeforeProcessed;
  },

  /**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overrided for some chart.
   * @return {type} description
   */
  getBaseAxis: function () {
    var coordSys = this.coordinateSystem;
    return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
  },
  // FIXME

  /**
   * Default tooltip formatter
   *
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {number} [dataType]
   * @param {string} [renderMode='html'] valid values: 'html' and 'richText'.
   *                                     'html' is used for rendering tooltip in extra DOM form, and the result
   *                                     string is used as DOM HTML content.
   *                                     'richText' is used for rendering tooltip in rich text form, for those where
   *                                     DOM operation is not supported.
   * @return {Object} formatted tooltip with `html` and `markers`
   */
  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
    var series = this;
    renderMode = renderMode || 'html';
    var newLine = renderMode === 'html' ? '<br/>' : '\n';
    var isRichText = renderMode === 'richText';
    var markers = {};
    var markerId = 0;

    function formatArrayValue(value) {
      // ??? TODO refactor these logic.
      // check: category-no-encode-has-axis-data in dataset.html
      var vertially = zrUtil.reduce(value, function (vertially, val, idx) {
        var dimItem = data.getDimensionInfo(idx);
        return vertially |= dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
      }, 0);
      var result = [];
      tooltipDims.length ? zrUtil.each(tooltipDims, function (dim) {
        setEachItem(retrieveRawValue(data, dataIndex, dim), dim);
      }) // By default, all dims is used on tooltip.
      : zrUtil.each(value, setEachItem);

      function setEachItem(val, dim) {
        var dimInfo = data.getDimensionInfo(dim); // If `dimInfo.tooltip` is not set, show tooltip.

        if (!dimInfo || dimInfo.otherDims.tooltip === false) {
          return;
        }

        var dimType = dimInfo.type;
        var markName = 'sub' + series.seriesIndex + 'at' + markerId;
        var dimHead = getTooltipMarker({
          color: color,
          type: 'subItem',
          renderMode: renderMode,
          markerId: markName
        });
        var dimHeadStr = typeof dimHead === 'string' ? dimHead : dimHead.content;
        var valStr = (vertially ? dimHeadStr + encodeHTML(dimInfo.displayName || '-') + ': ' : '') + // FIXME should not format time for raw data?
        encodeHTML(dimType === 'ordinal' ? val + '' : dimType === 'time' ? multipleSeries ? '' : formatTime('yyyy/MM/dd hh:mm:ss', val) : addCommas(val));
        valStr && result.push(valStr);

        if (isRichText) {
          markers[markName] = color;
          ++markerId;
        }
      }

      var newLine = vertially ? isRichText ? '\n' : '<br/>' : '';
      var content = newLine + result.join(newLine || ', ');
      return {
        renderMode: renderMode,
        content: content,
        style: markers
      };
    }

    function formatSingleValue(val) {
      // return encodeHTML(addCommas(val));
      return {
        renderMode: renderMode,
        content: encodeHTML(addCommas(val)),
        style: markers
      };
    }

    var data = this.getData();
    var tooltipDims = data.mapDimension('defaultedTooltip', true);
    var tooltipDimLen = tooltipDims.length;
    var value = this.getRawValue(dataIndex);
    var isValueArr = zrUtil.isArray(value);
    var color = data.getItemVisual(dataIndex, 'color');

    if (zrUtil.isObject(color) && color.colorStops) {
      color = (color.colorStops[0] || {}).color;
    }

    color = color || 'transparent'; // Complicated rule for pretty tooltip.

    var formattedValue = tooltipDimLen > 1 || isValueArr && !tooltipDimLen ? formatArrayValue(value) : tooltipDimLen ? formatSingleValue(retrieveRawValue(data, dataIndex, tooltipDims[0])) : formatSingleValue(isValueArr ? value[0] : value);
    var content = formattedValue.content;
    var markName = series.seriesIndex + 'at' + markerId;
    var colorEl = getTooltipMarker({
      color: color,
      type: 'item',
      renderMode: renderMode,
      markerId: markName
    });
    markers[markName] = color;
    ++markerId;
    var name = data.getName(dataIndex);
    var seriesName = this.name;

    if (!modelUtil.isNameSpecified(this)) {
      seriesName = '';
    }

    seriesName = seriesName ? encodeHTML(seriesName) + (!multipleSeries ? newLine : ': ') : '';
    var colorStr = typeof colorEl === 'string' ? colorEl : colorEl.content;
    var html = !multipleSeries ? seriesName + colorStr + (name ? encodeHTML(name) + ': ' + content : content) : colorStr + seriesName + content;
    return {
      html: html,
      markers: markers
    };
  },

  /**
   * @return {boolean}
   */
  isAnimationEnabled: function () {
    if (env.node) {
      return false;
    }

    var animationEnabled = this.getShallow('animation');

    if (animationEnabled) {
      if (this.getData().count() > this.getShallow('animationThreshold')) {
        animationEnabled = false;
      }
    }

    return animationEnabled;
  },
  restoreData: function () {
    this.dataTask.dirty();
  },
  getColorFromPalette: function (name, scope, requestColorNum) {
    var ecModel = this.ecModel; // PENDING

    var color = colorPaletteMixin.getColorFromPalette.call(this, name, scope, requestColorNum);

    if (!color) {
      color = ecModel.getColorFromPalette(name, scope, requestColorNum);
    }

    return color;
  },

  /**
   * Use `data.mapDimension(coordDim, true)` instead.
   * @deprecated
   */
  coordDimToDataDim: function (coordDim) {
    return this.getRawData().mapDimension(coordDim, true);
  },

  /**
   * Get progressive rendering count each step
   * @return {number}
   */
  getProgressive: function () {
    return this.get('progressive');
  },

  /**
   * Get progressive rendering count each step
   * @return {number}
   */
  getProgressiveThreshold: function () {
    return this.get('progressiveThreshold');
  },

  /**
   * Get data indices for show tooltip content. See tooltip.
   * @abstract
   * @param {Array.<string>|string} dim
   * @param {Array.<number>} value
   * @param {module:echarts/coord/single/SingleAxis} baseAxis
   * @return {Object} {dataIndices, nestestValue}.
   */
  getAxisTooltipData: null,

  /**
   * See tooltip.
   * @abstract
   * @param {number} dataIndex
   * @return {Array.<number>} Point of tooltip. null/undefined can be returned.
   */
  getTooltipPosition: null,

  /**
   * @see {module:echarts/stream/Scheduler}
   */
  pipeTask: null,

  /**
   * Convinient for override in extended class.
   * @protected
   * @type {Function}
   */
  preventIncremental: null,

  /**
   * @public
   * @readOnly
   * @type {Object}
   */
  pipelineContext: null
});
zrUtil.mixin(SeriesModel, dataFormatMixin);
zrUtil.mixin(SeriesModel, colorPaletteMixin);
/**
 * MUST be called after `prepareSource` called
 * Here we need to make auto series, especially for auto legend. But we
 * do not modify series.name in option to avoid side effects.
 */

function autoSeriesName(seriesModel) {
  // User specified name has higher priority, otherwise it may cause
  // series can not be queried unexpectedly.
  var name = seriesModel.name;

  if (!modelUtil.isNameSpecified(seriesModel)) {
    seriesModel.name = getSeriesAutoName(seriesModel) || name;
  }
}

function getSeriesAutoName(seriesModel) {
  var data = seriesModel.getRawData();
  var dataDims = data.mapDimension('seriesName', true);
  var nameArr = [];
  zrUtil.each(dataDims, function (dataDim) {
    var dimInfo = data.getDimensionInfo(dataDim);
    dimInfo.displayName && nameArr.push(dimInfo.displayName);
  });
  return nameArr.join(' ');
}

function dataTaskCount(context) {
  return context.model.getRawData().count();
}

function dataTaskReset(context) {
  var seriesModel = context.model;
  seriesModel.setData(seriesModel.getRawData().cloneShallow());
  return dataTaskProgress;
}

function dataTaskProgress(param, context) {
  // Avoid repead cloneShallow when data just created in reset.
  if (context.outputData && param.end > context.outputData.count()) {
    context.model.getRawData().cloneShallow(context.outputData);
  }
} // TODO refactor


function wrapData(data, seriesModel) {
  zrUtil.each(data.CHANGABLE_METHODS, function (methodName) {
    data.wrapMethod(methodName, zrUtil.curry(onDataSelfChange, seriesModel));
  });
}

function onDataSelfChange(seriesModel) {
  var task = getCurrentTask(seriesModel);

  if (task) {
    // Consider case: filter, selectRange
    task.setOutputEnd(this.count());
  }
}

function getCurrentTask(seriesModel) {
  var scheduler = (seriesModel.ecModel || {}).scheduler;
  var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);

  if (pipeline) {
    // When pipline finished, the currrentTask keep the last
    // task (renderTask).
    var task = pipeline.currentTask;

    if (task) {
      var agentStubMap = task.agentStubMap;

      if (agentStubMap) {
        task = agentStubMap.get(seriesModel.uid);
      }
    }

    return task;
  }
}

var _default = SeriesModel;
module.exports = _default;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(880);

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(577);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(455);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}exports.default=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2){var _ref2$name=_ref2.name,name=_ref2$name===undefined?"":_ref2$name,_ref2$date=_ref2.date,date=_ref2$date===undefined?undefined:_ref2$date,_ref2$id=_ref2.id,id=_ref2$id===undefined?"":_ref2$id;var innerHtml,html,blob;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:name+=" "+(0,_moment2.default)(date).format('YYYY-MM');innerHtml="\n      <caption>"+name+"</caption>\n      "+document.getElementById(id).innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n    ";html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";blob=new Blob([html],{type:"application/vnd.ms-excel"});_context.next=6;return _fileSaver2.default.saveAs(blob,name+".xls");case 6:return _context.abrupt("return");case 7:case"end":return _context.stop();}}},_callee,undefined);}));return function(_x){return _ref.apply(this,arguments);};}();

/***/ }),
/* 80 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

/**
 * 3x2矩阵操作类
 * @exports zrender/tool/matrix
 */

/* global Float32Array */
var ArrayCtor = typeof Float32Array === 'undefined' ? Array : Float32Array;
/**
 * Create a identity matrix.
 * @return {Float32Array|Array.<number>}
 */

function create() {
  var out = new ArrayCtor(6);
  identity(out);
  return out;
}
/**
 * 设置矩阵为单位矩阵
 * @param {Float32Array|Array.<number>} out
 */


function identity(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  out[4] = 0;
  out[5] = 0;
  return out;
}
/**
 * 复制矩阵
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} m
 */


function copy(out, m) {
  out[0] = m[0];
  out[1] = m[1];
  out[2] = m[2];
  out[3] = m[3];
  out[4] = m[4];
  out[5] = m[5];
  return out;
}
/**
 * 矩阵相乘
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} m1
 * @param {Float32Array|Array.<number>} m2
 */


function mul(out, m1, m2) {
  // Consider matrix.mul(m, m2, m);
  // where out is the same as m2.
  // So use temp variable to escape error.
  var out0 = m1[0] * m2[0] + m1[2] * m2[1];
  var out1 = m1[1] * m2[0] + m1[3] * m2[1];
  var out2 = m1[0] * m2[2] + m1[2] * m2[3];
  var out3 = m1[1] * m2[2] + m1[3] * m2[3];
  var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
  var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
  out[0] = out0;
  out[1] = out1;
  out[2] = out2;
  out[3] = out3;
  out[4] = out4;
  out[5] = out5;
  return out;
}
/**
 * 平移变换
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 * @param {Float32Array|Array.<number>} v
 */


function translate(out, a, v) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4] + v[0];
  out[5] = a[5] + v[1];
  return out;
}
/**
 * 旋转变换
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 * @param {number} rad
 */


function rotate(out, a, rad) {
  var aa = a[0];
  var ac = a[2];
  var atx = a[4];
  var ab = a[1];
  var ad = a[3];
  var aty = a[5];
  var st = Math.sin(rad);
  var ct = Math.cos(rad);
  out[0] = aa * ct + ab * st;
  out[1] = -aa * st + ab * ct;
  out[2] = ac * ct + ad * st;
  out[3] = -ac * st + ct * ad;
  out[4] = ct * atx + st * aty;
  out[5] = ct * aty - st * atx;
  return out;
}
/**
 * 缩放变换
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 * @param {Float32Array|Array.<number>} v
 */


function scale(out, a, v) {
  var vx = v[0];
  var vy = v[1];
  out[0] = a[0] * vx;
  out[1] = a[1] * vy;
  out[2] = a[2] * vx;
  out[3] = a[3] * vy;
  out[4] = a[4] * vx;
  out[5] = a[5] * vy;
  return out;
}
/**
 * 求逆矩阵
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 */


function invert(out, a) {
  var aa = a[0];
  var ac = a[2];
  var atx = a[4];
  var ab = a[1];
  var ad = a[3];
  var aty = a[5];
  var det = aa * ad - ab * ac;

  if (!det) {
    return null;
  }

  det = 1.0 / det;
  out[0] = ad * det;
  out[1] = -ab * det;
  out[2] = -ac * det;
  out[3] = aa * det;
  out[4] = (ac * aty - ad * atx) * det;
  out[5] = (ab * atx - aa * aty) * det;
  return out;
}
/**
 * Clone a new matrix.
 * @param {Float32Array|Array.<number>} a
 */


function clone(a) {
  var b = create();
  copy(b, a);
  return b;
}

exports.create = create;
exports.identity = identity;
exports.copy = copy;
exports.mul = mul;
exports.translate = translate;
exports.rotate = rotate;
exports.scale = scale;
exports.invert = invert;
exports.clone = clone;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var ReactDOM = _interopRequireWildcard(__webpack_require__(46));

var _rcAnimate = _interopRequireDefault(__webpack_require__(188));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _configProvider = __webpack_require__(39);

var _getDataOrAriaProps = _interopRequireDefault(__webpack_require__(494));

var _warning = _interopRequireDefault(__webpack_require__(69));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function noop() {}

var Alert = /*#__PURE__*/function (_React$Component) {
  _inherits(Alert, _React$Component);

  var _super = _createSuper(Alert);

  function Alert(props) {
    var _this;

    _classCallCheck(this, Alert);

    _this = _super.call(this, props);

    _this.handleClose = function (e) {
      e.preventDefault();
      var dom = ReactDOM.findDOMNode(_assertThisInitialized(_this));
      dom.style.height = "".concat(dom.offsetHeight, "px"); // Magic code
      // 重复一次后才能正确设置 height

      dom.style.height = "".concat(dom.offsetHeight, "px");

      _this.setState({
        closing: true
      });

      (_this.props.onClose || noop)(e);
    };

    _this.animationEnd = function () {
      _this.setState({
        closing: false,
        closed: true
      });

      (_this.props.afterClose || noop)();
    };

    _this.renderAlert = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          description = _this$props.description,
          customizePrefixCls = _this$props.prefixCls,
          message = _this$props.message,
          closeText = _this$props.closeText,
          banner = _this$props.banner,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          style = _this$props.style,
          icon = _this$props.icon;
      var _this$props2 = _this.props,
          closable = _this$props2.closable,
          type = _this$props2.type,
          showIcon = _this$props2.showIcon,
          iconType = _this$props2.iconType;
      var _this$state = _this.state,
          closing = _this$state.closing,
          closed = _this$state.closed;
      var prefixCls = getPrefixCls('alert', customizePrefixCls); // banner模式默认有 Icon

      showIcon = banner && showIcon === undefined ? true : showIcon; // banner模式默认为警告

      type = banner && type === undefined ? 'warning' : type || 'info';
      var iconTheme = 'filled';

      if (!iconType) {
        switch (type) {
          case 'success':
            iconType = 'check-circle';
            break;

          case 'info':
            iconType = 'info-circle';
            break;

          case 'error':
            iconType = 'close-circle';
            break;

          case 'warning':
            iconType = 'exclamation-circle';
            break;

          default:
            iconType = 'default';
        } // use outline icon in alert with description


        if (description) {
          iconTheme = 'outlined';
        }
      } // closeable when closeText is assigned


      if (closeText) {
        closable = true;
      }

      var alertCls = (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-").concat(type), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-closing"), closing), _defineProperty(_classNames, "".concat(prefixCls, "-with-description"), !!description), _defineProperty(_classNames, "".concat(prefixCls, "-no-icon"), !showIcon), _defineProperty(_classNames, "".concat(prefixCls, "-banner"), !!banner), _defineProperty(_classNames, "".concat(prefixCls, "-closable"), closable), _classNames), className);
      var closeIcon = closable ? /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: _this.handleClose,
        className: "".concat(prefixCls, "-close-icon"),
        tabIndex: 0
      }, closeText ? /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-close-text")
      }, closeText) : /*#__PURE__*/React.createElement(_icon["default"], {
        type: "close"
      })) : null;
      var dataOrAriaProps = (0, _getDataOrAriaProps["default"])(_this.props);
      var iconNode = icon && ( /*#__PURE__*/React.isValidElement(icon) ? /*#__PURE__*/React.cloneElement(icon, {
        className: (0, _classnames["default"])("".concat(prefixCls, "-icon"), _defineProperty({}, icon.props.className, icon.props.className))
      }) : /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-icon")
      }, icon)) || /*#__PURE__*/React.createElement(_icon["default"], {
        className: "".concat(prefixCls, "-icon"),
        type: iconType,
        theme: iconTheme
      });
      return closed ? null : /*#__PURE__*/React.createElement(_rcAnimate["default"], {
        component: "",
        showProp: "data-show",
        transitionName: "".concat(prefixCls, "-slide-up"),
        onEnd: _this.animationEnd
      }, /*#__PURE__*/React.createElement("div", _extends({
        "data-show": !closing,
        className: alertCls,
        style: style
      }, dataOrAriaProps), showIcon ? iconNode : null, /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-message")
      }, message), /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-description")
      }, description), closeIcon));
    };

    (0, _warning["default"])(!('iconType' in props), 'Alert', '`iconType` is deprecated. Please use `icon` instead.');
    _this.state = {
      closing: false,
      closed: false
    };
    return _this;
  }

  _createClass(Alert, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAlert);
    }
  }]);

  return Alert;
}(React.Component);

exports["default"] = Alert;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(971);

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(836);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(842);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(473);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(843);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(845);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(847);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_5__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(849);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(474);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(339);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(851);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(853);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(855);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "generatePath", function() { return __WEBPACK_IMPORTED_MODULE_11__generatePath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(856);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_12__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(857);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);__webpack_require__(10);var _axios=__webpack_require__(1322);var _axios2=_interopRequireDefault(_axios);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var instance=_axios2.default.create({// 设置默认的请求baseURL
baseURL:'/qiansheng',// 设置默认的请求超时时间
timeout:20000,// 设置默认的请求头
headers:{'Content-Type':'application/json'},withCredentials:true});// 请求拦截器
instance.interceptors.request.use(function(config){// 在发送请求之前可以做一些处理，例如添加token等
// config.headers['Authorization'] = 'Bearer ' + getToken();
return config;},function(error){return Promise.reject(error);});// 响应拦截器
instance.interceptors.response.use(function(response){// 对响应数据进行处理，例如获取数据、错误处理等
if(response.data.code!=200){_message3.default.error(response.data.message||"操作失败！");return response.data;}if(response.data.code==401){_message3.default.error(response.data.message);location.href="/login";return;}return response.data;},function(error){// 处理请求错误，例如根据状态码进行不同的操作
_message3.default.error(error.message||"请求错误");return Promise.reject(error);});// 封装常用的请求方法
var request={get:function get(url,params){return instance.get(url,{params:params});},post:function post(url,data){return instance.post(url,data);},put:function put(url,data){return instance.put(url,data);},delete:function _delete(url){return instance.delete(url);}};exports.default=request;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(36);

var _rcTooltip = _interopRequireDefault(__webpack_require__(916));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _placements = _interopRequireDefault(__webpack_require__(920));

var _configProvider = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var splitObject = function splitObject(obj, keys) {
  var picked = {};

  var omitted = _extends({}, obj);

  keys.forEach(function (key) {
    if (obj && key in obj) {
      picked[key] = obj[key];
      delete omitted[key];
    }
  });
  return {
    picked: picked,
    omitted: omitted
  };
}; // Fix Tooltip won't hide at disabled button
// mouse events don't trigger at disabled button in Chrome
// https://github.com/react-component/tooltip/issues/18


function getDisabledCompatibleChildren(element) {
  var elementType = element.type;

  if ((elementType.__ANT_BUTTON === true || elementType.__ANT_SWITCH === true || elementType.__ANT_CHECKBOX === true || element.type === 'button') && element.props.disabled) {
    // Pick some layout related style properties up to span
    // Prevent layout bugs like https://github.com/ant-design/ant-design/issues/5254
    var _splitObject = splitObject(element.props.style, ['position', 'left', 'right', 'top', 'bottom', 'float', 'display', 'zIndex']),
        picked = _splitObject.picked,
        omitted = _splitObject.omitted;

    var spanStyle = _extends(_extends({
      display: 'inline-block'
    }, picked), {
      cursor: 'not-allowed',
      width: element.props.block ? '100%' : null
    });

    var buttonStyle = _extends(_extends({}, omitted), {
      pointerEvents: 'none'
    });

    var child = /*#__PURE__*/React.cloneElement(element, {
      style: buttonStyle,
      className: null
    });
    return /*#__PURE__*/React.createElement("span", {
      style: spanStyle,
      className: element.props.className
    }, child);
  }

  return element;
}

var Tooltip = /*#__PURE__*/function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  var _super = _createSuper(Tooltip);

  function Tooltip(props) {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _super.call(this, props);

    _this.onVisibleChange = function (visible) {
      var onVisibleChange = _this.props.onVisibleChange;

      if (!('visible' in _this.props)) {
        _this.setState({
          visible: _this.isNoTitle() ? false : visible
        });
      }

      if (onVisibleChange && !_this.isNoTitle()) {
        onVisibleChange(visible);
      }
    };

    _this.saveTooltip = function (node) {
      _this.tooltip = node;
    }; // 动态设置动画点


    _this.onPopupAlign = function (domNode, align) {
      var placements = _this.getPlacements(); // 当前返回的位置


      var placement = Object.keys(placements).filter(function (key) {
        return placements[key].points[0] === align.points[0] && placements[key].points[1] === align.points[1];
      })[0];

      if (!placement) {
        return;
      } // 根据当前坐标设置动画点


      var rect = domNode.getBoundingClientRect();
      var transformOrigin = {
        top: '50%',
        left: '50%'
      };

      if (placement.indexOf('top') >= 0 || placement.indexOf('Bottom') >= 0) {
        transformOrigin.top = "".concat(rect.height - align.offset[1], "px");
      } else if (placement.indexOf('Top') >= 0 || placement.indexOf('bottom') >= 0) {
        transformOrigin.top = "".concat(-align.offset[1], "px");
      }

      if (placement.indexOf('left') >= 0 || placement.indexOf('Right') >= 0) {
        transformOrigin.left = "".concat(rect.width - align.offset[0], "px");
      } else if (placement.indexOf('right') >= 0 || placement.indexOf('Left') >= 0) {
        transformOrigin.left = "".concat(-align.offset[0], "px");
      }

      domNode.style.transformOrigin = "".concat(transformOrigin.left, " ").concat(transformOrigin.top);
    };

    _this.renderTooltip = function (_ref) {
      var getContextPopupContainer = _ref.getPopupContainer,
          getPrefixCls = _ref.getPrefixCls;

      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props,
          state = _assertThisInitialize.state;

      var customizePrefixCls = props.prefixCls,
          openClassName = props.openClassName,
          getPopupContainer = props.getPopupContainer,
          getTooltipContainer = props.getTooltipContainer;
      var children = props.children;
      var prefixCls = getPrefixCls('tooltip', customizePrefixCls);
      var visible = state.visible; // Hide tooltip when there is no title

      if (!('visible' in props) && _this.isNoTitle()) {
        visible = false;
      }

      var child = getDisabledCompatibleChildren( /*#__PURE__*/React.isValidElement(children) ? children : /*#__PURE__*/React.createElement("span", null, children));
      var childProps = child.props;
      var childCls = (0, _classnames["default"])(childProps.className, _defineProperty({}, openClassName || "".concat(prefixCls, "-open"), true));
      return /*#__PURE__*/React.createElement(_rcTooltip["default"], _extends({}, _this.props, {
        prefixCls: prefixCls,
        getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
        ref: _this.saveTooltip,
        builtinPlacements: _this.getPlacements(),
        overlay: _this.getOverlay(),
        visible: visible,
        onVisibleChange: _this.onVisibleChange,
        onPopupAlign: _this.onPopupAlign
      }), visible ? /*#__PURE__*/React.cloneElement(child, {
        className: childCls
      }) : child);
    };

    _this.state = {
      visible: !!props.visible || !!props.defaultVisible
    };
    return _this;
  }

  _createClass(Tooltip, [{
    key: "getPopupDomNode",
    value: function getPopupDomNode() {
      return this.tooltip.getPopupDomNode();
    }
  }, {
    key: "getPlacements",
    value: function getPlacements() {
      var _this$props = this.props,
          builtinPlacements = _this$props.builtinPlacements,
          arrowPointAtCenter = _this$props.arrowPointAtCenter,
          autoAdjustOverflow = _this$props.autoAdjustOverflow;
      return builtinPlacements || (0, _placements["default"])({
        arrowPointAtCenter: arrowPointAtCenter,
        verticalArrowShift: 8,
        autoAdjustOverflow: autoAdjustOverflow
      });
    }
  }, {
    key: "isNoTitle",
    value: function isNoTitle() {
      var _this$props2 = this.props,
          title = _this$props2.title,
          overlay = _this$props2.overlay;
      return !title && !overlay && title !== 0; // overlay for old version compatibility
    }
  }, {
    key: "getOverlay",
    value: function getOverlay() {
      var _this$props3 = this.props,
          title = _this$props3.title,
          overlay = _this$props3.overlay;

      if (title === 0) {
        return title;
      }

      return overlay || title || '';
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTooltip);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('visible' in nextProps) {
        return {
          visible: nextProps.visible
        };
      }

      return null;
    }
  }]);

  return Tooltip;
}(React.Component);

Tooltip.defaultProps = {
  placement: 'top',
  transitionName: 'zoom-big-fast',
  mouseEnterDelay: 0.1,
  mouseLeaveDelay: 0.1,
  arrowPointAtCenter: false,
  autoAdjustOverflow: true
};
(0, _reactLifecyclesCompat.polyfill)(Tooltip);
var _default = Tooltip;
exports["default"] = _default;

/***/ }),
/* 88 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 89 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(66);
var createDesc = __webpack_require__(160);
module.exports = __webpack_require__(63) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(49);
var hide = __webpack_require__(90);
var has = __webpack_require__(94);
var SRC = __webpack_require__(161)('src');
var $toString = __webpack_require__(1122);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(102).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(15);
var fails = __webpack_require__(51);
var defined = __webpack_require__(118);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var BoundingRect = __webpack_require__(57);

var imageHelper = __webpack_require__(406);

var _util = __webpack_require__(1);

var getContext = _util.getContext;
var extend = _util.extend;
var retrieve2 = _util.retrieve2;
var retrieve3 = _util.retrieve3;
var trim = _util.trim;
var textWidthCache = {};
var textWidthCacheCounter = 0;
var TEXT_CACHE_MAX = 5000;
var STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
var DEFAULT_FONT = '12px sans-serif'; // Avoid assign to an exported variable, for transforming to cjs.

var methods = {};

function $override(name, fn) {
  methods[name] = fn;
}
/**
 * @public
 * @param {string} text
 * @param {string} font
 * @return {number} width
 */


function getWidth(text, font) {
  font = font || DEFAULT_FONT;
  var key = text + ':' + font;

  if (textWidthCache[key]) {
    return textWidthCache[key];
  }

  var textLines = (text + '').split('\n');
  var width = 0;

  for (var i = 0, l = textLines.length; i < l; i++) {
    // textContain.measureText may be overrided in SVG or VML
    width = Math.max(measureText(textLines[i], font).width, width);
  }

  if (textWidthCacheCounter > TEXT_CACHE_MAX) {
    textWidthCacheCounter = 0;
    textWidthCache = {};
  }

  textWidthCacheCounter++;
  textWidthCache[key] = width;
  return width;
}
/**
 * @public
 * @param {string} text
 * @param {string} font
 * @param {string} [textAlign='left']
 * @param {string} [textVerticalAlign='top']
 * @param {Array.<number>} [textPadding]
 * @param {Object} [rich]
 * @param {Object} [truncate]
 * @return {Object} {x, y, width, height, lineHeight}
 */


function getBoundingRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) {
  return rich ? getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) : getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, truncate);
}

function getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, truncate) {
  var contentBlock = parsePlainText(text, font, textPadding, textLineHeight, truncate);
  var outerWidth = getWidth(text, font);

  if (textPadding) {
    outerWidth += textPadding[1] + textPadding[3];
  }

  var outerHeight = contentBlock.outerHeight;
  var x = adjustTextX(0, outerWidth, textAlign);
  var y = adjustTextY(0, outerHeight, textVerticalAlign);
  var rect = new BoundingRect(x, y, outerWidth, outerHeight);
  rect.lineHeight = contentBlock.lineHeight;
  return rect;
}

function getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) {
  var contentBlock = parseRichText(text, {
    rich: rich,
    truncate: truncate,
    font: font,
    textAlign: textAlign,
    textPadding: textPadding,
    textLineHeight: textLineHeight
  });
  var outerWidth = contentBlock.outerWidth;
  var outerHeight = contentBlock.outerHeight;
  var x = adjustTextX(0, outerWidth, textAlign);
  var y = adjustTextY(0, outerHeight, textVerticalAlign);
  return new BoundingRect(x, y, outerWidth, outerHeight);
}
/**
 * @public
 * @param {number} x
 * @param {number} width
 * @param {string} [textAlign='left']
 * @return {number} Adjusted x.
 */


function adjustTextX(x, width, textAlign) {
  // FIXME Right to left language
  if (textAlign === 'right') {
    x -= width;
  } else if (textAlign === 'center') {
    x -= width / 2;
  }

  return x;
}
/**
 * @public
 * @param {number} y
 * @param {number} height
 * @param {string} [textVerticalAlign='top']
 * @return {number} Adjusted y.
 */


function adjustTextY(y, height, textVerticalAlign) {
  if (textVerticalAlign === 'middle') {
    y -= height / 2;
  } else if (textVerticalAlign === 'bottom') {
    y -= height;
  }

  return y;
}
/**
 * Follow same interface to `Displayable.prototype.calculateTextPosition`.
 * @public
 * @param {Obejct} [out] Prepared out object. If not input, auto created in the method.
 * @param {module:zrender/graphic/Style} style where `textPosition` and `textDistance` are visited.
 * @param {Object} rect {x, y, width, height} Rect of the host elment, according to which the text positioned.
 * @return {Object} The input `out`. Set: {x, y, textAlign, textVerticalAlign}
 */


function calculateTextPosition(out, style, rect) {
  var textPosition = style.textPosition;
  var distance = style.textDistance;
  var x = rect.x;
  var y = rect.y;
  distance = distance || 0;
  var height = rect.height;
  var width = rect.width;
  var halfHeight = height / 2;
  var textAlign = 'left';
  var textVerticalAlign = 'top';

  switch (textPosition) {
    case 'left':
      x -= distance;
      y += halfHeight;
      textAlign = 'right';
      textVerticalAlign = 'middle';
      break;

    case 'right':
      x += distance + width;
      y += halfHeight;
      textVerticalAlign = 'middle';
      break;

    case 'top':
      x += width / 2;
      y -= distance;
      textAlign = 'center';
      textVerticalAlign = 'bottom';
      break;

    case 'bottom':
      x += width / 2;
      y += height + distance;
      textAlign = 'center';
      break;

    case 'inside':
      x += width / 2;
      y += halfHeight;
      textAlign = 'center';
      textVerticalAlign = 'middle';
      break;

    case 'insideLeft':
      x += distance;
      y += halfHeight;
      textVerticalAlign = 'middle';
      break;

    case 'insideRight':
      x += width - distance;
      y += halfHeight;
      textAlign = 'right';
      textVerticalAlign = 'middle';
      break;

    case 'insideTop':
      x += width / 2;
      y += distance;
      textAlign = 'center';
      break;

    case 'insideBottom':
      x += width / 2;
      y += height - distance;
      textAlign = 'center';
      textVerticalAlign = 'bottom';
      break;

    case 'insideTopLeft':
      x += distance;
      y += distance;
      break;

    case 'insideTopRight':
      x += width - distance;
      y += distance;
      textAlign = 'right';
      break;

    case 'insideBottomLeft':
      x += distance;
      y += height - distance;
      textVerticalAlign = 'bottom';
      break;

    case 'insideBottomRight':
      x += width - distance;
      y += height - distance;
      textAlign = 'right';
      textVerticalAlign = 'bottom';
      break;
  }

  out = out || {};
  out.x = x;
  out.y = y;
  out.textAlign = textAlign;
  out.textVerticalAlign = textVerticalAlign;
  return out;
}
/**
 * To be removed. But still do not remove in case that some one has imported it.
 * @deprecated
 * @public
 * @param {stirng} textPosition
 * @param {Object} rect {x, y, width, height}
 * @param {number} distance
 * @return {Object} {x, y, textAlign, textVerticalAlign}
 */


function adjustTextPositionOnRect(textPosition, rect, distance) {
  var dummyStyle = {
    textPosition: textPosition,
    textDistance: distance
  };
  return calculateTextPosition({}, dummyStyle, rect);
}
/**
 * Show ellipsis if overflow.
 *
 * @public
 * @param  {string} text
 * @param  {string} containerWidth
 * @param  {string} font
 * @param  {number} [ellipsis='...']
 * @param  {Object} [options]
 * @param  {number} [options.maxIterations=3]
 * @param  {number} [options.minChar=0] If truncate result are less
 *                  then minChar, ellipsis will not show, which is
 *                  better for user hint in some cases.
 * @param  {number} [options.placeholder=''] When all truncated, use the placeholder.
 * @return {string}
 */


function truncateText(text, containerWidth, font, ellipsis, options) {
  if (!containerWidth) {
    return '';
  }

  var textLines = (text + '').split('\n');
  options = prepareTruncateOptions(containerWidth, font, ellipsis, options); // FIXME
  // It is not appropriate that every line has '...' when truncate multiple lines.

  for (var i = 0, len = textLines.length; i < len; i++) {
    textLines[i] = truncateSingleLine(textLines[i], options);
  }

  return textLines.join('\n');
}

function prepareTruncateOptions(containerWidth, font, ellipsis, options) {
  options = extend({}, options);
  options.font = font;
  var ellipsis = retrieve2(ellipsis, '...');
  options.maxIterations = retrieve2(options.maxIterations, 2);
  var minChar = options.minChar = retrieve2(options.minChar, 0); // FIXME
  // Other languages?

  options.cnCharWidth = getWidth('国', font); // FIXME
  // Consider proportional font?

  var ascCharWidth = options.ascCharWidth = getWidth('a', font);
  options.placeholder = retrieve2(options.placeholder, ''); // Example 1: minChar: 3, text: 'asdfzxcv', truncate result: 'asdf', but not: 'a...'.
  // Example 2: minChar: 3, text: '维度', truncate result: '维', but not: '...'.

  var contentWidth = containerWidth = Math.max(0, containerWidth - 1); // Reserve some gap.

  for (var i = 0; i < minChar && contentWidth >= ascCharWidth; i++) {
    contentWidth -= ascCharWidth;
  }

  var ellipsisWidth = getWidth(ellipsis, font);

  if (ellipsisWidth > contentWidth) {
    ellipsis = '';
    ellipsisWidth = 0;
  }

  contentWidth = containerWidth - ellipsisWidth;
  options.ellipsis = ellipsis;
  options.ellipsisWidth = ellipsisWidth;
  options.contentWidth = contentWidth;
  options.containerWidth = containerWidth;
  return options;
}

function truncateSingleLine(textLine, options) {
  var containerWidth = options.containerWidth;
  var font = options.font;
  var contentWidth = options.contentWidth;

  if (!containerWidth) {
    return '';
  }

  var lineWidth = getWidth(textLine, font);

  if (lineWidth <= containerWidth) {
    return textLine;
  }

  for (var j = 0;; j++) {
    if (lineWidth <= contentWidth || j >= options.maxIterations) {
      textLine += options.ellipsis;
      break;
    }

    var subLength = j === 0 ? estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
    textLine = textLine.substr(0, subLength);
    lineWidth = getWidth(textLine, font);
  }

  if (textLine === '') {
    textLine = options.placeholder;
  }

  return textLine;
}

function estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
  var width = 0;
  var i = 0;

  for (var len = text.length; i < len && width < contentWidth; i++) {
    var charCode = text.charCodeAt(i);
    width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
  }

  return i;
}
/**
 * @public
 * @param {string} font
 * @return {number} line height
 */


function getLineHeight(font) {
  // FIXME A rough approach.
  return getWidth('国', font);
}
/**
 * @public
 * @param {string} text
 * @param {string} font
 * @return {Object} width
 */


function measureText(text, font) {
  return methods.measureText(text, font);
} // Avoid assign to an exported variable, for transforming to cjs.


methods.measureText = function (text, font) {
  var ctx = getContext();
  ctx.font = font || DEFAULT_FONT;
  return ctx.measureText(text);
};
/**
 * @public
 * @param {string} text
 * @param {string} font
 * @param {Object} [truncate]
 * @return {Object} block: {lineHeight, lines, height, outerHeight, canCacheByTextString}
 *  Notice: for performance, do not calculate outerWidth util needed.
 *  `canCacheByTextString` means the result `lines` is only determined by the input `text`.
 *  Thus we can simply comparing the `input` text to determin whether the result changed,
 *  without travel the result `lines`.
 */


function parsePlainText(text, font, padding, textLineHeight, truncate) {
  text != null && (text += '');
  var lineHeight = retrieve2(textLineHeight, getLineHeight(font));
  var lines = text ? text.split('\n') : [];
  var height = lines.length * lineHeight;
  var outerHeight = height;
  var canCacheByTextString = true;

  if (padding) {
    outerHeight += padding[0] + padding[2];
  }

  if (text && truncate) {
    canCacheByTextString = false;
    var truncOuterHeight = truncate.outerHeight;
    var truncOuterWidth = truncate.outerWidth;

    if (truncOuterHeight != null && outerHeight > truncOuterHeight) {
      text = '';
      lines = [];
    } else if (truncOuterWidth != null) {
      var options = prepareTruncateOptions(truncOuterWidth - (padding ? padding[1] + padding[3] : 0), font, truncate.ellipsis, {
        minChar: truncate.minChar,
        placeholder: truncate.placeholder
      }); // FIXME
      // It is not appropriate that every line has '...' when truncate multiple lines.

      for (var i = 0, len = lines.length; i < len; i++) {
        lines[i] = truncateSingleLine(lines[i], options);
      }
    }
  }

  return {
    lines: lines,
    height: height,
    outerHeight: outerHeight,
    lineHeight: lineHeight,
    canCacheByTextString: canCacheByTextString
  };
}
/**
 * For example: 'some text {a|some text}other text{b|some text}xxx{c|}xxx'
 * Also consider 'bbbb{a|xxx\nzzz}xxxx\naaaa'.
 *
 * @public
 * @param {string} text
 * @param {Object} style
 * @return {Object} block
 * {
 *      width,
 *      height,
 *      lines: [{
 *          lineHeight,
 *          width,
 *          tokens: [[{
 *              styleName,
 *              text,
 *              width,      // include textPadding
 *              height,     // include textPadding
 *              textWidth, // pure text width
 *              textHeight, // pure text height
 *              lineHeihgt,
 *              font,
 *              textAlign,
 *              textVerticalAlign
 *          }], [...], ...]
 *      }, ...]
 * }
 * If styleName is undefined, it is plain text.
 */


function parseRichText(text, style) {
  var contentBlock = {
    lines: [],
    width: 0,
    height: 0
  };
  text != null && (text += '');

  if (!text) {
    return contentBlock;
  }

  var lastIndex = STYLE_REG.lastIndex = 0;
  var result;

  while ((result = STYLE_REG.exec(text)) != null) {
    var matchedIndex = result.index;

    if (matchedIndex > lastIndex) {
      pushTokens(contentBlock, text.substring(lastIndex, matchedIndex));
    }

    pushTokens(contentBlock, result[2], result[1]);
    lastIndex = STYLE_REG.lastIndex;
  }

  if (lastIndex < text.length) {
    pushTokens(contentBlock, text.substring(lastIndex, text.length));
  }

  var lines = contentBlock.lines;
  var contentHeight = 0;
  var contentWidth = 0; // For `textWidth: 100%`

  var pendingList = [];
  var stlPadding = style.textPadding;
  var truncate = style.truncate;
  var truncateWidth = truncate && truncate.outerWidth;
  var truncateHeight = truncate && truncate.outerHeight;

  if (stlPadding) {
    truncateWidth != null && (truncateWidth -= stlPadding[1] + stlPadding[3]);
    truncateHeight != null && (truncateHeight -= stlPadding[0] + stlPadding[2]);
  } // Calculate layout info of tokens.


  for (var i = 0; i < lines.length; i++) {
    var line = lines[i];
    var lineHeight = 0;
    var lineWidth = 0;

    for (var j = 0; j < line.tokens.length; j++) {
      var token = line.tokens[j];
      var tokenStyle = token.styleName && style.rich[token.styleName] || {}; // textPadding should not inherit from style.

      var textPadding = token.textPadding = tokenStyle.textPadding; // textFont has been asigned to font by `normalizeStyle`.

      var font = token.font = tokenStyle.font || style.font; // textHeight can be used when textVerticalAlign is specified in token.

      var tokenHeight = token.textHeight = retrieve2( // textHeight should not be inherited, consider it can be specified
      // as box height of the block.
      tokenStyle.textHeight, getLineHeight(font));
      textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
      token.height = tokenHeight;
      token.lineHeight = retrieve3(tokenStyle.textLineHeight, style.textLineHeight, tokenHeight);
      token.textAlign = tokenStyle && tokenStyle.textAlign || style.textAlign;
      token.textVerticalAlign = tokenStyle && tokenStyle.textVerticalAlign || 'middle';

      if (truncateHeight != null && contentHeight + token.lineHeight > truncateHeight) {
        return {
          lines: [],
          width: 0,
          height: 0
        };
      }

      token.textWidth = getWidth(token.text, font);
      var tokenWidth = tokenStyle.textWidth;
      var tokenWidthNotSpecified = tokenWidth == null || tokenWidth === 'auto'; // Percent width, can be `100%`, can be used in drawing separate
      // line when box width is needed to be auto.

      if (typeof tokenWidth === 'string' && tokenWidth.charAt(tokenWidth.length - 1) === '%') {
        token.percentWidth = tokenWidth;
        pendingList.push(token);
        tokenWidth = 0; // Do not truncate in this case, because there is no user case
        // and it is too complicated.
      } else {
        if (tokenWidthNotSpecified) {
          tokenWidth = token.textWidth; // FIXME: If image is not loaded and textWidth is not specified, calling
          // `getBoundingRect()` will not get correct result.

          var textBackgroundColor = tokenStyle.textBackgroundColor;
          var bgImg = textBackgroundColor && textBackgroundColor.image; // Use cases:
          // (1) If image is not loaded, it will be loaded at render phase and call
          // `dirty()` and `textBackgroundColor.image` will be replaced with the loaded
          // image, and then the right size will be calculated here at the next tick.
          // See `graphic/helper/text.js`.
          // (2) If image loaded, and `textBackgroundColor.image` is image src string,
          // use `imageHelper.findExistImage` to find cached image.
          // `imageHelper.findExistImage` will always be called here before
          // `imageHelper.createOrUpdateImage` in `graphic/helper/text.js#renderRichText`
          // which ensures that image will not be rendered before correct size calcualted.

          if (bgImg) {
            bgImg = imageHelper.findExistImage(bgImg);

            if (imageHelper.isImageReady(bgImg)) {
              tokenWidth = Math.max(tokenWidth, bgImg.width * tokenHeight / bgImg.height);
            }
          }
        }

        var paddingW = textPadding ? textPadding[1] + textPadding[3] : 0;
        tokenWidth += paddingW;
        var remianTruncWidth = truncateWidth != null ? truncateWidth - lineWidth : null;

        if (remianTruncWidth != null && remianTruncWidth < tokenWidth) {
          if (!tokenWidthNotSpecified || remianTruncWidth < paddingW) {
            token.text = '';
            token.textWidth = tokenWidth = 0;
          } else {
            token.text = truncateText(token.text, remianTruncWidth - paddingW, font, truncate.ellipsis, {
              minChar: truncate.minChar
            });
            token.textWidth = getWidth(token.text, font);
            tokenWidth = token.textWidth + paddingW;
          }
        }
      }

      lineWidth += token.width = tokenWidth;
      tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
    }

    line.width = lineWidth;
    line.lineHeight = lineHeight;
    contentHeight += lineHeight;
    contentWidth = Math.max(contentWidth, lineWidth);
  }

  contentBlock.outerWidth = contentBlock.width = retrieve2(style.textWidth, contentWidth);
  contentBlock.outerHeight = contentBlock.height = retrieve2(style.textHeight, contentHeight);

  if (stlPadding) {
    contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
    contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
  }

  for (var i = 0; i < pendingList.length; i++) {
    var token = pendingList[i];
    var percentWidth = token.percentWidth; // Should not base on outerWidth, because token can not be placed out of padding.

    token.width = parseInt(percentWidth, 10) / 100 * contentWidth;
  }

  return contentBlock;
}

function pushTokens(block, str, styleName) {
  var isEmptyStr = str === '';
  var strs = str.split('\n');
  var lines = block.lines;

  for (var i = 0; i < strs.length; i++) {
    var text = strs[i];
    var token = {
      styleName: styleName,
      text: text,
      isLineHolder: !text && !isEmptyStr
    }; // The first token should be appended to the last line.

    if (!i) {
      var tokens = (lines[lines.length - 1] || (lines[0] = {
        tokens: []
      })).tokens; // Consider cases:
      // (1) ''.split('\n') => ['', '\n', ''], the '' at the first item
      // (which is a placeholder) should be replaced by new token.
      // (2) A image backage, where token likes {a|}.
      // (3) A redundant '' will affect textAlign in line.
      // (4) tokens with the same tplName should not be merged, because
      // they should be displayed in different box (with border and padding).

      var tokensLen = tokens.length;
      tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : // Consider text is '', only insert when it is the "lineHolder" or
      // "emptyStr". Otherwise a redundant '' will affect textAlign in line.
      (text || !tokensLen || isEmptyStr) && tokens.push(token);
    } // Other tokens always start a new line.
    else {
        // If there is '', insert it as a placeholder.
        lines.push({
          tokens: [token]
        });
      }
  }
}

function makeFont(style) {
  // FIXME in node-canvas fontWeight is before fontStyle
  // Use `fontSize` `fontFamily` to check whether font properties are defined.
  var font = (style.fontSize || style.fontFamily) && [style.fontStyle, style.fontWeight, (style.fontSize || 12) + 'px', // If font properties are defined, `fontFamily` should not be ignored.
  style.fontFamily || 'sans-serif'].join(' ');
  return font && trim(font) || style.textFont || style.font;
}

exports.DEFAULT_FONT = DEFAULT_FONT;
exports.$override = $override;
exports.getWidth = getWidth;
exports.getBoundingRect = getBoundingRect;
exports.adjustTextX = adjustTextX;
exports.adjustTextY = adjustTextY;
exports.calculateTextPosition = calculateTextPosition;
exports.adjustTextPositionOnRect = adjustTextPositionOnRect;
exports.truncateText = truncateText;
exports.getLineHeight = getLineHeight;
exports.measureText = measureText;
exports.parsePlainText = parsePlainText;
exports.parseRichText = parseRichText;
exports.makeFont = makeFont;

/***/ }),
/* 94 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(227);
var defined = __webpack_require__(118);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(228);
var createDesc = __webpack_require__(160);
var toIObject = __webpack_require__(95);
var toPrimitive = __webpack_require__(117);
var has = __webpack_require__(94);
var IE8_DOM_DEFINE = __webpack_require__(541);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(63) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(94);
var toObject = __webpack_require__(70);
var IE_PROTO = __webpack_require__(371)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(1);

var Model = __webpack_require__(68);

var DataDiffer = __webpack_require__(177);

var Source = __webpack_require__(236);

var _dataProvider = __webpack_require__(176);

var defaultDimValueGetters = _dataProvider.defaultDimValueGetters;
var DefaultDataProvider = _dataProvider.DefaultDataProvider;

var _dimensionHelper = __webpack_require__(238);

var summarizeDimensions = _dimensionHelper.summarizeDimensions;

var DataDimensionInfo = __webpack_require__(640);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/* global Float64Array, Int32Array, Uint32Array, Uint16Array */

/**
 * List for data storage
 * @module echarts/data/List
 */
var isObject = zrUtil.isObject;
var UNDEFINED = 'undefined';
var INDEX_NOT_FOUND = -1; // Use prefix to avoid index to be the same as otherIdList[idx],
// which will cause weird udpate animation.

var ID_PREFIX = 'e\0\0';
var dataCtors = {
  'float': typeof Float64Array === UNDEFINED ? Array : Float64Array,
  'int': typeof Int32Array === UNDEFINED ? Array : Int32Array,
  // Ordinal data type can be string or int
  'ordinal': Array,
  'number': Array,
  'time': Array
}; // Caution: MUST not use `new CtorUint32Array(arr, 0, len)`, because the Ctor of array is
// different from the Ctor of typed array.

var CtorUint32Array = typeof Uint32Array === UNDEFINED ? Array : Uint32Array;
var CtorInt32Array = typeof Int32Array === UNDEFINED ? Array : Int32Array;
var CtorUint16Array = typeof Uint16Array === UNDEFINED ? Array : Uint16Array;

function getIndicesCtor(list) {
  // The possible max value in this._indicies is always this._rawCount despite of filtering.
  return list._rawCount > 65535 ? CtorUint32Array : CtorUint16Array;
}

function cloneChunk(originalChunk) {
  var Ctor = originalChunk.constructor; // Only shallow clone is enough when Array.

  return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
}

var TRANSFERABLE_PROPERTIES = ['hasItemOption', '_nameList', '_idList', '_invertedIndicesMap', '_rawData', '_chunkSize', '_chunkCount', '_dimValueGetter', '_count', '_rawCount', '_nameDimIdx', '_idDimIdx'];
var CLONE_PROPERTIES = ['_extent', '_approximateExtent', '_rawExtent'];

function transferProperties(target, source) {
  zrUtil.each(TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function (propName) {
    if (source.hasOwnProperty(propName)) {
      target[propName] = source[propName];
    }
  });
  target.__wrappedMethods = source.__wrappedMethods;
  zrUtil.each(CLONE_PROPERTIES, function (propName) {
    target[propName] = zrUtil.clone(source[propName]);
  });
  target._calculationInfo = zrUtil.extend(source._calculationInfo);
}
/**
 * @constructor
 * @alias module:echarts/data/List
 *
 * @param {Array.<string|Object|module:data/DataDimensionInfo>} dimensions
 *      For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
 *      Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
 * @param {module:echarts/model/Model} hostModel
 */


var List = function (dimensions, hostModel) {
  dimensions = dimensions || ['x', 'y'];
  var dimensionInfos = {};
  var dimensionNames = [];
  var invertedIndicesMap = {};

  for (var i = 0; i < dimensions.length; i++) {
    // Use the original dimensions[i], where other flag props may exists.
    var dimensionInfo = dimensions[i];

    if (zrUtil.isString(dimensionInfo)) {
      dimensionInfo = new DataDimensionInfo({
        name: dimensionInfo
      });
    } else if (!(dimensionInfo instanceof DataDimensionInfo)) {
      dimensionInfo = new DataDimensionInfo(dimensionInfo);
    }

    var dimensionName = dimensionInfo.name;
    dimensionInfo.type = dimensionInfo.type || 'float';

    if (!dimensionInfo.coordDim) {
      dimensionInfo.coordDim = dimensionName;
      dimensionInfo.coordDimIndex = 0;
    }

    dimensionInfo.otherDims = dimensionInfo.otherDims || {};
    dimensionNames.push(dimensionName);
    dimensionInfos[dimensionName] = dimensionInfo;
    dimensionInfo.index = i;

    if (dimensionInfo.createInvertedIndices) {
      invertedIndicesMap[dimensionName] = [];
    }
  }
  /**
   * @readOnly
   * @type {Array.<string>}
   */


  this.dimensions = dimensionNames;
  /**
   * Infomation of each data dimension, like data type.
   * @type {Object}
   */

  this._dimensionInfos = dimensionInfos;
  /**
   * @type {module:echarts/model/Model}
   */

  this.hostModel = hostModel;
  /**
   * @type {module:echarts/model/Model}
   */

  this.dataType;
  /**
   * Indices stores the indices of data subset after filtered.
   * This data subset will be used in chart.
   * @type {Array.<number>}
   * @readOnly
   */

  this._indices = null;
  this._count = 0;
  this._rawCount = 0;
  /**
   * Data storage
   * @type {Object.<key, Array.<TypedArray|Array>>}
   * @private
   */

  this._storage = {};
  /**
   * @type {Array.<string>}
   */

  this._nameList = [];
  /**
   * @type {Array.<string>}
   */

  this._idList = [];
  /**
   * Models of data option is stored sparse for optimizing memory cost
   * @type {Array.<module:echarts/model/Model>}
   * @private
   */

  this._optionModels = [];
  /**
   * Global visual properties after visual coding
   * @type {Object}
   * @private
   */

  this._visual = {};
  /**
   * Globel layout properties.
   * @type {Object}
   * @private
   */

  this._layout = {};
  /**
   * Item visual properties after visual coding
   * @type {Array.<Object>}
   * @private
   */

  this._itemVisuals = [];
  /**
   * Key: visual type, Value: boolean
   * @type {Object}
   * @readOnly
   */

  this.hasItemVisual = {};
  /**
   * Item layout properties after layout
   * @type {Array.<Object>}
   * @private
   */

  this._itemLayouts = [];
  /**
   * Graphic elemnents
   * @type {Array.<module:zrender/Element>}
   * @private
   */

  this._graphicEls = [];
  /**
   * Max size of each chunk.
   * @type {number}
   * @private
   */

  this._chunkSize = 1e5;
  /**
   * @type {number}
   * @private
   */

  this._chunkCount = 0;
  /**
   * @type {Array.<Array|Object>}
   * @private
   */

  this._rawData;
  /**
   * Raw extent will not be cloned, but only transfered.
   * It will not be calculated util needed.
   * key: dim,
   * value: {end: number, extent: Array.<number>}
   * @type {Object}
   * @private
   */

  this._rawExtent = {};
  /**
   * @type {Object}
   * @private
   */

  this._extent = {};
  /**
   * key: dim
   * value: extent
   * @type {Object}
   * @private
   */

  this._approximateExtent = {};
  /**
   * Cache summary info for fast visit. See "dimensionHelper".
   * @type {Object}
   * @private
   */

  this._dimensionsSummary = summarizeDimensions(this);
  /**
   * @type {Object.<Array|TypedArray>}
   * @private
   */

  this._invertedIndicesMap = invertedIndicesMap;
  /**
   * @type {Object}
   * @private
   */

  this._calculationInfo = {};
  /**
   * User output info of this data.
   * DO NOT use it in other places!
   *
   * When preparing user params for user callbacks, we have
   * to clone these inner data structures to prevent users
   * from modifying them to effect built-in logic. And for
   * performance consideration we make this `userOutput` to
   * avoid clone them too many times.
   *
   * @type {Object}
   * @readOnly
   */

  this.userOutput = this._dimensionsSummary.userOutput;
};

var listProto = List.prototype;
listProto.type = 'list';
/**
 * If each data item has it's own option
 * @type {boolean}
 */

listProto.hasItemOption = true;
/**
 * The meanings of the input parameter `dim`:
 *
 * + If dim is a number (e.g., `1`), it means the index of the dimension.
 *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
 * + If dim is a number-like string (e.g., `"1"`):
 *     + If there is the same concrete dim name defined in `this.dimensions`, it means that concrete name.
 *     + If not, it will be converted to a number, which means the index of the dimension.
 *        (why? because of the backward compatbility. We have been tolerating number-like string in
 *        dimension setting, although now it seems that it is not a good idea.)
 *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
 *     if no dimension name is defined as `"1"`.
 * + If dim is a not-number-like string, it means the concrete dim name.
 *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
 *   or customized in `dimensions` property of option like `"age"`.
 *
 * Get dimension name
 * @param {string|number} dim See above.
 * @return {string} Concrete dim name.
 */

listProto.getDimension = function (dim) {
  if (typeof dim === 'number' // If being a number-like string but not being defined a dimension name.
  || !isNaN(dim) && !this._dimensionInfos.hasOwnProperty(dim)) {
    dim = this.dimensions[dim];
  }

  return dim;
};
/**
 * Get type and calculation info of particular dimension
 * @param {string|number} dim
 *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
 *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
 */


listProto.getDimensionInfo = function (dim) {
  // Do not clone, because there may be categories in dimInfo.
  return this._dimensionInfos[this.getDimension(dim)];
};
/**
 * @return {Array.<string>} concrete dimension name list on coord.
 */


listProto.getDimensionsOnCoord = function () {
  return this._dimensionsSummary.dataDimsOnCoord.slice();
};
/**
 * @param {string} coordDim
 * @param {number} [idx] A coordDim may map to more than one data dim.
 *        If idx is `true`, return a array of all mapped dims.
 *        If idx is not specified, return the first dim not extra.
 * @return {string|Array.<string>} concrete data dim.
 *        If idx is number, and not found, return null/undefined.
 *        If idx is `true`, and not found, return empty array (always return array).
 */


listProto.mapDimension = function (coordDim, idx) {
  var dimensionsSummary = this._dimensionsSummary;

  if (idx == null) {
    return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
  }

  var dims = dimensionsSummary.encode[coordDim];
  return idx === true // always return array if idx is `true`
  ? (dims || []).slice() : dims && dims[idx];
};
/**
 * Initialize from data
 * @param {Array.<Object|number|Array>} data source or data or data provider.
 * @param {Array.<string>} [nameLIst] The name of a datum is used on data diff and
 *        default label/tooltip.
 *        A name can be specified in encode.itemName,
 *        or dataItem.name (only for series option data),
 *        or provided in nameList from outside.
 * @param {Function} [dimValueGetter] (dataItem, dimName, dataIndex, dimIndex) => number
 */


listProto.initData = function (data, nameList, dimValueGetter) {
  var notProvider = Source.isInstance(data) || zrUtil.isArrayLike(data);

  if (notProvider) {
    data = new DefaultDataProvider(data, this.dimensions.length);
  }

  this._rawData = data; // Clear

  this._storage = {};
  this._indices = null;
  this._nameList = nameList || [];
  this._idList = [];
  this._nameRepeatCount = {};

  if (!dimValueGetter) {
    this.hasItemOption = false;
  }
  /**
   * @readOnly
   */


  this.defaultDimValueGetter = defaultDimValueGetters[this._rawData.getSource().sourceFormat]; // Default dim value getter

  this._dimValueGetter = dimValueGetter = dimValueGetter || this.defaultDimValueGetter;
  this._dimValueGetterArrayRows = defaultDimValueGetters.arrayRows; // Reset raw extent.

  this._rawExtent = {};

  this._initDataFromProvider(0, data.count()); // If data has no item option.


  if (data.pure) {
    this.hasItemOption = false;
  }
};

listProto.getProvider = function () {
  return this._rawData;
};
/**
 * Caution: Can be only called on raw data (before `this._indices` created).
 */


listProto.appendData = function (data) {
  var rawData = this._rawData;
  var start = this.count();
  rawData.appendData(data);
  var end = rawData.count();

  if (!rawData.persistent) {
    end += start;
  }

  this._initDataFromProvider(start, end);
};
/**
 * Caution: Can be only called on raw data (before `this._indices` created).
 * This method does not modify `rawData` (`dataProvider`), but only
 * add values to storage.
 *
 * The final count will be increased by `Math.max(values.length, names.length)`.
 *
 * @param {Array.<Array.<*>>} values That is the SourceType: 'arrayRows', like
 *        [
 *            [12, 33, 44],
 *            [NaN, 43, 1],
 *            ['-', 'asdf', 0]
 *        ]
 *        Each item is exaclty cooresponding to a dimension.
 * @param {Array.<string>} [names]
 */


listProto.appendValues = function (values, names) {
  var chunkSize = this._chunkSize;
  var storage = this._storage;
  var dimensions = this.dimensions;
  var dimLen = dimensions.length;
  var rawExtent = this._rawExtent;
  var start = this.count();
  var end = start + Math.max(values.length, names ? names.length : 0);
  var originalChunkCount = this._chunkCount;

  for (var i = 0; i < dimLen; i++) {
    var dim = dimensions[i];

    if (!rawExtent[dim]) {
      rawExtent[dim] = getInitialExtent();
    }

    if (!storage[dim]) {
      storage[dim] = [];
    }

    prepareChunks(storage, this._dimensionInfos[dim], chunkSize, originalChunkCount, end);
    this._chunkCount = storage[dim].length;
  }

  var emptyDataItem = new Array(dimLen);

  for (var idx = start; idx < end; idx++) {
    var sourceIdx = idx - start;
    var chunkIndex = Math.floor(idx / chunkSize);
    var chunkOffset = idx % chunkSize; // Store the data by dimensions

    for (var k = 0; k < dimLen; k++) {
      var dim = dimensions[k];

      var val = this._dimValueGetterArrayRows(values[sourceIdx] || emptyDataItem, dim, sourceIdx, k);

      storage[dim][chunkIndex][chunkOffset] = val;
      var dimRawExtent = rawExtent[dim];
      val < dimRawExtent[0] && (dimRawExtent[0] = val);
      val > dimRawExtent[1] && (dimRawExtent[1] = val);
    }

    if (names) {
      this._nameList[idx] = names[sourceIdx];
    }
  }

  this._rawCount = this._count = end; // Reset data extent

  this._extent = {};
  prepareInvertedIndex(this);
};

listProto._initDataFromProvider = function (start, end) {
  // Optimize.
  if (start >= end) {
    return;
  }

  var chunkSize = this._chunkSize;
  var rawData = this._rawData;
  var storage = this._storage;
  var dimensions = this.dimensions;
  var dimLen = dimensions.length;
  var dimensionInfoMap = this._dimensionInfos;
  var nameList = this._nameList;
  var idList = this._idList;
  var rawExtent = this._rawExtent;
  var nameRepeatCount = this._nameRepeatCount = {};
  var nameDimIdx;
  var originalChunkCount = this._chunkCount;

  for (var i = 0; i < dimLen; i++) {
    var dim = dimensions[i];

    if (!rawExtent[dim]) {
      rawExtent[dim] = getInitialExtent();
    }

    var dimInfo = dimensionInfoMap[dim];

    if (dimInfo.otherDims.itemName === 0) {
      nameDimIdx = this._nameDimIdx = i;
    }

    if (dimInfo.otherDims.itemId === 0) {
      this._idDimIdx = i;
    }

    if (!storage[dim]) {
      storage[dim] = [];
    }

    prepareChunks(storage, dimInfo, chunkSize, originalChunkCount, end);
    this._chunkCount = storage[dim].length;
  }

  var dataItem = new Array(dimLen);

  for (var idx = start; idx < end; idx++) {
    // NOTICE: Try not to write things into dataItem
    dataItem = rawData.getItem(idx, dataItem); // Each data item is value
    // [1, 2]
    // 2
    // Bar chart, line chart which uses category axis
    // only gives the 'y' value. 'x' value is the indices of category
    // Use a tempValue to normalize the value to be a (x, y) value

    var chunkIndex = Math.floor(idx / chunkSize);
    var chunkOffset = idx % chunkSize; // Store the data by dimensions

    for (var k = 0; k < dimLen; k++) {
      var dim = dimensions[k];
      var dimStorage = storage[dim][chunkIndex]; // PENDING NULL is empty or zero

      var val = this._dimValueGetter(dataItem, dim, idx, k);

      dimStorage[chunkOffset] = val;
      var dimRawExtent = rawExtent[dim];
      val < dimRawExtent[0] && (dimRawExtent[0] = val);
      val > dimRawExtent[1] && (dimRawExtent[1] = val);
    } // ??? FIXME not check by pure but sourceFormat?
    // TODO refactor these logic.


    if (!rawData.pure) {
      var name = nameList[idx];

      if (dataItem && name == null) {
        // If dataItem is {name: ...}, it has highest priority.
        // That is appropriate for many common cases.
        if (dataItem.name != null) {
          // There is no other place to persistent dataItem.name,
          // so save it to nameList.
          nameList[idx] = name = dataItem.name;
        } else if (nameDimIdx != null) {
          var nameDim = dimensions[nameDimIdx];
          var nameDimChunk = storage[nameDim][chunkIndex];

          if (nameDimChunk) {
            name = nameDimChunk[chunkOffset];
            var ordinalMeta = dimensionInfoMap[nameDim].ordinalMeta;

            if (ordinalMeta && ordinalMeta.categories.length) {
              name = ordinalMeta.categories[name];
            }
          }
        }
      } // Try using the id in option
      // id or name is used on dynamical data, mapping old and new items.


      var id = dataItem == null ? null : dataItem.id;

      if (id == null && name != null) {
        // Use name as id and add counter to avoid same name
        nameRepeatCount[name] = nameRepeatCount[name] || 0;
        id = name;

        if (nameRepeatCount[name] > 0) {
          id += '__ec__' + nameRepeatCount[name];
        }

        nameRepeatCount[name]++;
      }

      id != null && (idList[idx] = id);
    }
  }

  if (!rawData.persistent && rawData.clean) {
    // Clean unused data if data source is typed array.
    rawData.clean();
  }

  this._rawCount = this._count = end; // Reset data extent

  this._extent = {};
  prepareInvertedIndex(this);
};

function prepareChunks(storage, dimInfo, chunkSize, chunkCount, end) {
  var DataCtor = dataCtors[dimInfo.type];
  var lastChunkIndex = chunkCount - 1;
  var dim = dimInfo.name;
  var resizeChunkArray = storage[dim][lastChunkIndex];

  if (resizeChunkArray && resizeChunkArray.length < chunkSize) {
    var newStore = new DataCtor(Math.min(end - lastChunkIndex * chunkSize, chunkSize)); // The cost of the copy is probably inconsiderable
    // within the initial chunkSize.

    for (var j = 0; j < resizeChunkArray.length; j++) {
      newStore[j] = resizeChunkArray[j];
    }

    storage[dim][lastChunkIndex] = newStore;
  } // Create new chunks.


  for (var k = chunkCount * chunkSize; k < end; k += chunkSize) {
    storage[dim].push(new DataCtor(Math.min(end - k, chunkSize)));
  }
}

function prepareInvertedIndex(list) {
  var invertedIndicesMap = list._invertedIndicesMap;
  zrUtil.each(invertedIndicesMap, function (invertedIndices, dim) {
    var dimInfo = list._dimensionInfos[dim]; // Currently, only dimensions that has ordinalMeta can create inverted indices.

    var ordinalMeta = dimInfo.ordinalMeta;

    if (ordinalMeta) {
      invertedIndices = invertedIndicesMap[dim] = new CtorInt32Array(ordinalMeta.categories.length); // The default value of TypedArray is 0. To avoid miss
      // mapping to 0, we should set it as INDEX_NOT_FOUND.

      for (var i = 0; i < invertedIndices.length; i++) {
        invertedIndices[i] = INDEX_NOT_FOUND;
      }

      for (var i = 0; i < list._count; i++) {
        // Only support the case that all values are distinct.
        invertedIndices[list.get(dim, i)] = i;
      }
    }
  });
}

function getRawValueFromStore(list, dimIndex, rawIndex) {
  var val;

  if (dimIndex != null) {
    var chunkSize = list._chunkSize;
    var chunkIndex = Math.floor(rawIndex / chunkSize);
    var chunkOffset = rawIndex % chunkSize;
    var dim = list.dimensions[dimIndex];
    var chunk = list._storage[dim][chunkIndex];

    if (chunk) {
      val = chunk[chunkOffset];
      var ordinalMeta = list._dimensionInfos[dim].ordinalMeta;

      if (ordinalMeta && ordinalMeta.categories.length) {
        val = ordinalMeta.categories[val];
      }
    }
  }

  return val;
}
/**
 * @return {number}
 */


listProto.count = function () {
  return this._count;
};

listProto.getIndices = function () {
  var newIndices;
  var indices = this._indices;

  if (indices) {
    var Ctor = indices.constructor;
    var thisCount = this._count; // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.

    if (Ctor === Array) {
      newIndices = new Ctor(thisCount);

      for (var i = 0; i < thisCount; i++) {
        newIndices[i] = indices[i];
      }
    } else {
      newIndices = new Ctor(indices.buffer, 0, thisCount);
    }
  } else {
    var Ctor = getIndicesCtor(this);
    var newIndices = new Ctor(this.count());

    for (var i = 0; i < newIndices.length; i++) {
      newIndices[i] = i;
    }
  }

  return newIndices;
};
/**
 * Get value. Return NaN if idx is out of range.
 * @param {string} dim Dim must be concrete name.
 * @param {number} idx
 * @param {boolean} stack
 * @return {number}
 */


listProto.get = function (dim, idx
/*, stack */
) {
  if (!(idx >= 0 && idx < this._count)) {
    return NaN;
  }

  var storage = this._storage;

  if (!storage[dim]) {
    // TODO Warn ?
    return NaN;
  }

  idx = this.getRawIndex(idx);
  var chunkIndex = Math.floor(idx / this._chunkSize);
  var chunkOffset = idx % this._chunkSize;
  var chunkStore = storage[dim][chunkIndex];
  var value = chunkStore[chunkOffset]; // FIXME ordinal data type is not stackable
  // if (stack) {
  //     var dimensionInfo = this._dimensionInfos[dim];
  //     if (dimensionInfo && dimensionInfo.stackable) {
  //         var stackedOn = this.stackedOn;
  //         while (stackedOn) {
  //             // Get no stacked data of stacked on
  //             var stackedValue = stackedOn.get(dim, idx);
  //             // Considering positive stack, negative stack and empty data
  //             if ((value >= 0 && stackedValue > 0)  // Positive stack
  //                 || (value <= 0 && stackedValue < 0) // Negative stack
  //             ) {
  //                 value += stackedValue;
  //             }
  //             stackedOn = stackedOn.stackedOn;
  //         }
  //     }
  // }

  return value;
};
/**
 * @param {string} dim concrete dim
 * @param {number} rawIndex
 * @return {number|string}
 */


listProto.getByRawIndex = function (dim, rawIdx) {
  if (!(rawIdx >= 0 && rawIdx < this._rawCount)) {
    return NaN;
  }

  var dimStore = this._storage[dim];

  if (!dimStore) {
    // TODO Warn ?
    return NaN;
  }

  var chunkIndex = Math.floor(rawIdx / this._chunkSize);
  var chunkOffset = rawIdx % this._chunkSize;
  var chunkStore = dimStore[chunkIndex];
  return chunkStore[chunkOffset];
};
/**
 * FIXME Use `get` on chrome maybe slow(in filterSelf and selectRange).
 * Hack a much simpler _getFast
 * @private
 */


listProto._getFast = function (dim, rawIdx) {
  var chunkIndex = Math.floor(rawIdx / this._chunkSize);
  var chunkOffset = rawIdx % this._chunkSize;
  var chunkStore = this._storage[dim][chunkIndex];
  return chunkStore[chunkOffset];
};
/**
 * Get value for multi dimensions.
 * @param {Array.<string>} [dimensions] If ignored, using all dimensions.
 * @param {number} idx
 * @return {number}
 */


listProto.getValues = function (dimensions, idx
/*, stack */
) {
  var values = [];

  if (!zrUtil.isArray(dimensions)) {
    // stack = idx;
    idx = dimensions;
    dimensions = this.dimensions;
  }

  for (var i = 0, len = dimensions.length; i < len; i++) {
    values.push(this.get(dimensions[i], idx
    /*, stack */
    ));
  }

  return values;
};
/**
 * If value is NaN. Inlcuding '-'
 * Only check the coord dimensions.
 * @param {string} dim
 * @param {number} idx
 * @return {number}
 */


listProto.hasValue = function (idx) {
  var dataDimsOnCoord = this._dimensionsSummary.dataDimsOnCoord;

  for (var i = 0, len = dataDimsOnCoord.length; i < len; i++) {
    // Ordinal type originally can be string or number.
    // But when an ordinal type is used on coord, it can
    // not be string but only number. So we can also use isNaN.
    if (isNaN(this.get(dataDimsOnCoord[i], idx))) {
      return false;
    }
  }

  return true;
};
/**
 * Get extent of data in one dimension
 * @param {string} dim
 * @param {boolean} stack
 */


listProto.getDataExtent = function (dim
/*, stack */
) {
  // Make sure use concrete dim as cache name.
  dim = this.getDimension(dim);
  var dimData = this._storage[dim];
  var initialExtent = getInitialExtent(); // stack = !!((stack || false) && this.getCalculationInfo(dim));

  if (!dimData) {
    return initialExtent;
  } // Make more strict checkings to ensure hitting cache.


  var currEnd = this.count(); // var cacheName = [dim, !!stack].join('_');
  // var cacheName = dim;
  // Consider the most cases when using data zoom, `getDataExtent`
  // happened before filtering. We cache raw extent, which is not
  // necessary to be cleared and recalculated when restore data.

  var useRaw = !this._indices; // && !stack;

  var dimExtent;

  if (useRaw) {
    return this._rawExtent[dim].slice();
  }

  dimExtent = this._extent[dim];

  if (dimExtent) {
    return dimExtent.slice();
  }

  dimExtent = initialExtent;
  var min = dimExtent[0];
  var max = dimExtent[1];

  for (var i = 0; i < currEnd; i++) {
    // var value = stack ? this.get(dim, i, true) : this._getFast(dim, this.getRawIndex(i));
    var value = this._getFast(dim, this.getRawIndex(i));

    value < min && (min = value);
    value > max && (max = value);
  }

  dimExtent = [min, max];
  this._extent[dim] = dimExtent;
  return dimExtent;
};
/**
 * Optimize for the scenario that data is filtered by a given extent.
 * Consider that if data amount is more than hundreds of thousand,
 * extent calculation will cost more than 10ms and the cache will
 * be erased because of the filtering.
 */


listProto.getApproximateExtent = function (dim
/*, stack */
) {
  dim = this.getDimension(dim);
  return this._approximateExtent[dim] || this.getDataExtent(dim
  /*, stack */
  );
};

listProto.setApproximateExtent = function (extent, dim
/*, stack */
) {
  dim = this.getDimension(dim);
  this._approximateExtent[dim] = extent.slice();
};
/**
 * @param {string} key
 * @return {*}
 */


listProto.getCalculationInfo = function (key) {
  return this._calculationInfo[key];
};
/**
 * @param {string|Object} key or k-v object
 * @param {*} [value]
 */


listProto.setCalculationInfo = function (key, value) {
  isObject(key) ? zrUtil.extend(this._calculationInfo, key) : this._calculationInfo[key] = value;
};
/**
 * Get sum of data in one dimension
 * @param {string} dim
 */


listProto.getSum = function (dim
/*, stack */
) {
  var dimData = this._storage[dim];
  var sum = 0;

  if (dimData) {
    for (var i = 0, len = this.count(); i < len; i++) {
      var value = this.get(dim, i
      /*, stack */
      );

      if (!isNaN(value)) {
        sum += value;
      }
    }
  }

  return sum;
};
/**
 * Get median of data in one dimension
 * @param {string} dim
 */


listProto.getMedian = function (dim
/*, stack */
) {
  var dimDataArray = []; // map all data of one dimension

  this.each(dim, function (val, idx) {
    if (!isNaN(val)) {
      dimDataArray.push(val);
    }
  }); // TODO
  // Use quick select?
  // immutability & sort

  var sortedDimDataArray = [].concat(dimDataArray).sort(function (a, b) {
    return a - b;
  });
  var len = this.count(); // calculate median

  return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
}; // /**
//  * Retreive the index with given value
//  * @param {string} dim Concrete dimension.
//  * @param {number} value
//  * @return {number}
//  */
// Currently incorrect: should return dataIndex but not rawIndex.
// Do not fix it until this method is to be used somewhere.
// FIXME Precision of float value
// listProto.indexOf = function (dim, value) {
//     var storage = this._storage;
//     var dimData = storage[dim];
//     var chunkSize = this._chunkSize;
//     if (dimData) {
//         for (var i = 0, len = this.count(); i < len; i++) {
//             var chunkIndex = Math.floor(i / chunkSize);
//             var chunkOffset = i % chunkSize;
//             if (dimData[chunkIndex][chunkOffset] === value) {
//                 return i;
//             }
//         }
//     }
//     return -1;
// };

/**
 * Only support the dimension which inverted index created.
 * Do not support other cases until required.
 * @param {string} concrete dim
 * @param {number|string} value
 * @return {number} rawIndex
 */


listProto.rawIndexOf = function (dim, value) {
  var invertedIndices = dim && this._invertedIndicesMap[dim];
  var rawIndex = invertedIndices[value];

  if (rawIndex == null || isNaN(rawIndex)) {
    return INDEX_NOT_FOUND;
  }

  return rawIndex;
};
/**
 * Retreive the index with given name
 * @param {number} idx
 * @param {number} name
 * @return {number}
 */


listProto.indexOfName = function (name) {
  for (var i = 0, len = this.count(); i < len; i++) {
    if (this.getName(i) === name) {
      return i;
    }
  }

  return -1;
};
/**
 * Retreive the index with given raw data index
 * @param {number} idx
 * @param {number} name
 * @return {number}
 */


listProto.indexOfRawIndex = function (rawIndex) {
  if (rawIndex >= this._rawCount || rawIndex < 0) {
    return -1;
  }

  if (!this._indices) {
    return rawIndex;
  } // Indices are ascending


  var indices = this._indices; // If rawIndex === dataIndex

  var rawDataIndex = indices[rawIndex];

  if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) {
    return rawIndex;
  }

  var left = 0;
  var right = this._count - 1;

  while (left <= right) {
    var mid = (left + right) / 2 | 0;

    if (indices[mid] < rawIndex) {
      left = mid + 1;
    } else if (indices[mid] > rawIndex) {
      right = mid - 1;
    } else {
      return mid;
    }
  }

  return -1;
};
/**
 * Retreive the index of nearest value
 * @param {string} dim
 * @param {number} value
 * @param {number} [maxDistance=Infinity]
 * @return {Array.<number>} If and only if multiple indices has
 *        the same value, they are put to the result.
 */


listProto.indicesOfNearest = function (dim, value, maxDistance) {
  var storage = this._storage;
  var dimData = storage[dim];
  var nearestIndices = [];

  if (!dimData) {
    return nearestIndices;
  }

  if (maxDistance == null) {
    maxDistance = Infinity;
  }

  var minDist = Infinity;
  var minDiff = -1;
  var nearestIndicesLen = 0; // Check the test case of `test/ut/spec/data/List.js`.

  for (var i = 0, len = this.count(); i < len; i++) {
    var diff = value - this.get(dim, i);
    var dist = Math.abs(diff);

    if (dist <= maxDistance) {
      // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
      // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
      // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
      // So we chose the one that `diff >= 0` in this csae.
      // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
      // should be push to `nearestIndices`.
      if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
        minDist = dist;
        minDiff = diff;
        nearestIndicesLen = 0;
      }

      if (diff === minDiff) {
        nearestIndices[nearestIndicesLen++] = i;
      }
    }
  }

  nearestIndices.length = nearestIndicesLen;
  return nearestIndices;
};
/**
 * Get raw data index
 * @param {number} idx
 * @return {number}
 */


listProto.getRawIndex = getRawIndexWithoutIndices;

function getRawIndexWithoutIndices(idx) {
  return idx;
}

function getRawIndexWithIndices(idx) {
  if (idx < this._count && idx >= 0) {
    return this._indices[idx];
  }

  return -1;
}
/**
 * Get raw data item
 * @param {number} idx
 * @return {number}
 */


listProto.getRawDataItem = function (idx) {
  if (!this._rawData.persistent) {
    var val = [];

    for (var i = 0; i < this.dimensions.length; i++) {
      var dim = this.dimensions[i];
      val.push(this.get(dim, idx));
    }

    return val;
  } else {
    return this._rawData.getItem(this.getRawIndex(idx));
  }
};
/**
 * @param {number} idx
 * @param {boolean} [notDefaultIdx=false]
 * @return {string}
 */


listProto.getName = function (idx) {
  var rawIndex = this.getRawIndex(idx);
  return this._nameList[rawIndex] || getRawValueFromStore(this, this._nameDimIdx, rawIndex) || '';
};
/**
 * @param {number} idx
 * @param {boolean} [notDefaultIdx=false]
 * @return {string}
 */


listProto.getId = function (idx) {
  return getId(this, this.getRawIndex(idx));
};

function getId(list, rawIndex) {
  var id = list._idList[rawIndex];

  if (id == null) {
    id = getRawValueFromStore(list, list._idDimIdx, rawIndex);
  }

  if (id == null) {
    // FIXME Check the usage in graph, should not use prefix.
    id = ID_PREFIX + rawIndex;
  }

  return id;
}

function normalizeDimensions(dimensions) {
  if (!zrUtil.isArray(dimensions)) {
    dimensions = [dimensions];
  }

  return dimensions;
}

function validateDimensions(list, dims) {
  for (var i = 0; i < dims.length; i++) {
    // stroage may be empty when no data, so use
    // dimensionInfos to check.
    if (!list._dimensionInfos[dims[i]]) {
      console.error('Unkown dimension ' + dims[i]);
    }
  }
}
/**
 * Data iteration
 * @param {string|Array.<string>}
 * @param {Function} cb
 * @param {*} [context=this]
 *
 * @example
 *  list.each('x', function (x, idx) {});
 *  list.each(['x', 'y'], function (x, y, idx) {});
 *  list.each(function (idx) {})
 */


listProto.each = function (dims, cb, context, contextCompat) {
  'use strict';

  if (!this._count) {
    return;
  }

  if (typeof dims === 'function') {
    contextCompat = context;
    context = cb;
    cb = dims;
    dims = [];
  } // contextCompat just for compat echarts3


  context = context || contextCompat || this;
  dims = zrUtil.map(normalizeDimensions(dims), this.getDimension, this);
  var dimSize = dims.length;

  for (var i = 0; i < this.count(); i++) {
    // Simple optimization
    switch (dimSize) {
      case 0:
        cb.call(context, i);
        break;

      case 1:
        cb.call(context, this.get(dims[0], i), i);
        break;

      case 2:
        cb.call(context, this.get(dims[0], i), this.get(dims[1], i), i);
        break;

      default:
        var k = 0;
        var value = [];

        for (; k < dimSize; k++) {
          value[k] = this.get(dims[k], i);
        } // Index


        value[k] = i;
        cb.apply(context, value);
    }
  }
};
/**
 * Data filter
 * @param {string|Array.<string>}
 * @param {Function} cb
 * @param {*} [context=this]
 */


listProto.filterSelf = function (dimensions, cb, context, contextCompat) {
  'use strict';

  if (!this._count) {
    return;
  }

  if (typeof dimensions === 'function') {
    contextCompat = context;
    context = cb;
    cb = dimensions;
    dimensions = [];
  } // contextCompat just for compat echarts3


  context = context || contextCompat || this;
  dimensions = zrUtil.map(normalizeDimensions(dimensions), this.getDimension, this);
  var count = this.count();
  var Ctor = getIndicesCtor(this);
  var newIndices = new Ctor(count);
  var value = [];
  var dimSize = dimensions.length;
  var offset = 0;
  var dim0 = dimensions[0];

  for (var i = 0; i < count; i++) {
    var keep;
    var rawIdx = this.getRawIndex(i); // Simple optimization

    if (dimSize === 0) {
      keep = cb.call(context, i);
    } else if (dimSize === 1) {
      var val = this._getFast(dim0, rawIdx);

      keep = cb.call(context, val, i);
    } else {
      for (var k = 0; k < dimSize; k++) {
        value[k] = this._getFast(dim0, rawIdx);
      }

      value[k] = i;
      keep = cb.apply(context, value);
    }

    if (keep) {
      newIndices[offset++] = rawIdx;
    }
  } // Set indices after filtered.


  if (offset < count) {
    this._indices = newIndices;
  }

  this._count = offset; // Reset data extent

  this._extent = {};
  this.getRawIndex = this._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
  return this;
};
/**
 * Select data in range. (For optimization of filter)
 * (Manually inline code, support 5 million data filtering in data zoom.)
 */


listProto.selectRange = function (range) {
  'use strict';

  if (!this._count) {
    return;
  }

  var dimensions = [];

  for (var dim in range) {
    if (range.hasOwnProperty(dim)) {
      dimensions.push(dim);
    }
  }

  var dimSize = dimensions.length;

  if (!dimSize) {
    return;
  }

  var originalCount = this.count();
  var Ctor = getIndicesCtor(this);
  var newIndices = new Ctor(originalCount);
  var offset = 0;
  var dim0 = dimensions[0];
  var min = range[dim0][0];
  var max = range[dim0][1];
  var quickFinished = false;

  if (!this._indices) {
    // Extreme optimization for common case. About 2x faster in chrome.
    var idx = 0;

    if (dimSize === 1) {
      var dimStorage = this._storage[dimensions[0]];

      for (var k = 0; k < this._chunkCount; k++) {
        var chunkStorage = dimStorage[k];
        var len = Math.min(this._count - k * this._chunkSize, this._chunkSize);

        for (var i = 0; i < len; i++) {
          var val = chunkStorage[i]; // NaN will not be filtered. Consider the case, in line chart, empty
          // value indicates the line should be broken. But for the case like
          // scatter plot, a data item with empty value will not be rendered,
          // but the axis extent may be effected if some other dim of the data
          // item has value. Fortunately it is not a significant negative effect.

          if (val >= min && val <= max || isNaN(val)) {
            newIndices[offset++] = idx;
          }

          idx++;
        }
      }

      quickFinished = true;
    } else if (dimSize === 2) {
      var dimStorage = this._storage[dim0];
      var dimStorage2 = this._storage[dimensions[1]];
      var min2 = range[dimensions[1]][0];
      var max2 = range[dimensions[1]][1];

      for (var k = 0; k < this._chunkCount; k++) {
        var chunkStorage = dimStorage[k];
        var chunkStorage2 = dimStorage2[k];
        var len = Math.min(this._count - k * this._chunkSize, this._chunkSize);

        for (var i = 0; i < len; i++) {
          var val = chunkStorage[i];
          var val2 = chunkStorage2[i]; // Do not filter NaN, see comment above.

          if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) {
            newIndices[offset++] = idx;
          }

          idx++;
        }
      }

      quickFinished = true;
    }
  }

  if (!quickFinished) {
    if (dimSize === 1) {
      for (var i = 0; i < originalCount; i++) {
        var rawIndex = this.getRawIndex(i);

        var val = this._getFast(dim0, rawIndex); // Do not filter NaN, see comment above.


        if (val >= min && val <= max || isNaN(val)) {
          newIndices[offset++] = rawIndex;
        }
      }
    } else {
      for (var i = 0; i < originalCount; i++) {
        var keep = true;
        var rawIndex = this.getRawIndex(i);

        for (var k = 0; k < dimSize; k++) {
          var dimk = dimensions[k];

          var val = this._getFast(dim, rawIndex); // Do not filter NaN, see comment above.


          if (val < range[dimk][0] || val > range[dimk][1]) {
            keep = false;
          }
        }

        if (keep) {
          newIndices[offset++] = this.getRawIndex(i);
        }
      }
    }
  } // Set indices after filtered.


  if (offset < originalCount) {
    this._indices = newIndices;
  }

  this._count = offset; // Reset data extent

  this._extent = {};
  this.getRawIndex = this._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
  return this;
};
/**
 * Data mapping to a plain array
 * @param {string|Array.<string>} [dimensions]
 * @param {Function} cb
 * @param {*} [context=this]
 * @return {Array}
 */


listProto.mapArray = function (dimensions, cb, context, contextCompat) {
  'use strict';

  if (typeof dimensions === 'function') {
    contextCompat = context;
    context = cb;
    cb = dimensions;
    dimensions = [];
  } // contextCompat just for compat echarts3


  context = context || contextCompat || this;
  var result = [];
  this.each(dimensions, function () {
    result.push(cb && cb.apply(this, arguments));
  }, context);
  return result;
}; // Data in excludeDimensions is copied, otherwise transfered.


function cloneListForMapAndSample(original, excludeDimensions) {
  var allDimensions = original.dimensions;
  var list = new List(zrUtil.map(allDimensions, original.getDimensionInfo, original), original.hostModel); // FIXME If needs stackedOn, value may already been stacked

  transferProperties(list, original);
  var storage = list._storage = {};
  var originalStorage = original._storage; // Init storage

  for (var i = 0; i < allDimensions.length; i++) {
    var dim = allDimensions[i];

    if (originalStorage[dim]) {
      // Notice that we do not reset invertedIndicesMap here, becuase
      // there is no scenario of mapping or sampling ordinal dimension.
      if (zrUtil.indexOf(excludeDimensions, dim) >= 0) {
        storage[dim] = cloneDimStore(originalStorage[dim]);
        list._rawExtent[dim] = getInitialExtent();
        list._extent[dim] = null;
      } else {
        // Direct reference for other dimensions
        storage[dim] = originalStorage[dim];
      }
    }
  }

  return list;
}

function cloneDimStore(originalDimStore) {
  var newDimStore = new Array(originalDimStore.length);

  for (var j = 0; j < originalDimStore.length; j++) {
    newDimStore[j] = cloneChunk(originalDimStore[j]);
  }

  return newDimStore;
}

function getInitialExtent() {
  return [Infinity, -Infinity];
}
/**
 * Data mapping to a new List with given dimensions
 * @param {string|Array.<string>} dimensions
 * @param {Function} cb
 * @param {*} [context=this]
 * @return {Array}
 */


listProto.map = function (dimensions, cb, context, contextCompat) {
  'use strict'; // contextCompat just for compat echarts3

  context = context || contextCompat || this;
  dimensions = zrUtil.map(normalizeDimensions(dimensions), this.getDimension, this);
  var list = cloneListForMapAndSample(this, dimensions); // Following properties are all immutable.
  // So we can reference to the same value

  list._indices = this._indices;
  list.getRawIndex = list._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
  var storage = list._storage;
  var tmpRetValue = [];
  var chunkSize = this._chunkSize;
  var dimSize = dimensions.length;
  var dataCount = this.count();
  var values = [];
  var rawExtent = list._rawExtent;

  for (var dataIndex = 0; dataIndex < dataCount; dataIndex++) {
    for (var dimIndex = 0; dimIndex < dimSize; dimIndex++) {
      values[dimIndex] = this.get(dimensions[dimIndex], dataIndex
      /*, stack */
      );
    }

    values[dimSize] = dataIndex;
    var retValue = cb && cb.apply(context, values);

    if (retValue != null) {
      // a number or string (in oridinal dimension)?
      if (typeof retValue !== 'object') {
        tmpRetValue[0] = retValue;
        retValue = tmpRetValue;
      }

      var rawIndex = this.getRawIndex(dataIndex);
      var chunkIndex = Math.floor(rawIndex / chunkSize);
      var chunkOffset = rawIndex % chunkSize;

      for (var i = 0; i < retValue.length; i++) {
        var dim = dimensions[i];
        var val = retValue[i];
        var rawExtentOnDim = rawExtent[dim];
        var dimStore = storage[dim];

        if (dimStore) {
          dimStore[chunkIndex][chunkOffset] = val;
        }

        if (val < rawExtentOnDim[0]) {
          rawExtentOnDim[0] = val;
        }

        if (val > rawExtentOnDim[1]) {
          rawExtentOnDim[1] = val;
        }
      }
    }
  }

  return list;
};
/**
 * Large data down sampling on given dimension
 * @param {string} dimension
 * @param {number} rate
 * @param {Function} sampleValue
 * @param {Function} sampleIndex Sample index for name and id
 */


listProto.downSample = function (dimension, rate, sampleValue, sampleIndex) {
  var list = cloneListForMapAndSample(this, [dimension]);
  var targetStorage = list._storage;
  var frameValues = [];
  var frameSize = Math.floor(1 / rate);
  var dimStore = targetStorage[dimension];
  var len = this.count();
  var chunkSize = this._chunkSize;
  var rawExtentOnDim = list._rawExtent[dimension];
  var newIndices = new (getIndicesCtor(this))(len);
  var offset = 0;

  for (var i = 0; i < len; i += frameSize) {
    // Last frame
    if (frameSize > len - i) {
      frameSize = len - i;
      frameValues.length = frameSize;
    }

    for (var k = 0; k < frameSize; k++) {
      var dataIdx = this.getRawIndex(i + k);
      var originalChunkIndex = Math.floor(dataIdx / chunkSize);
      var originalChunkOffset = dataIdx % chunkSize;
      frameValues[k] = dimStore[originalChunkIndex][originalChunkOffset];
    }

    var value = sampleValue(frameValues);
    var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1));
    var sampleChunkIndex = Math.floor(sampleFrameIdx / chunkSize);
    var sampleChunkOffset = sampleFrameIdx % chunkSize; // Only write value on the filtered data

    dimStore[sampleChunkIndex][sampleChunkOffset] = value;

    if (value < rawExtentOnDim[0]) {
      rawExtentOnDim[0] = value;
    }

    if (value > rawExtentOnDim[1]) {
      rawExtentOnDim[1] = value;
    }

    newIndices[offset++] = sampleFrameIdx;
  }

  list._count = offset;
  list._indices = newIndices;
  list.getRawIndex = getRawIndexWithIndices;
  return list;
};
/**
 * Get model of one data item.
 *
 * @param {number} idx
 */
// FIXME Model proxy ?


listProto.getItemModel = function (idx) {
  var hostModel = this.hostModel;
  return new Model(this.getRawDataItem(idx), hostModel, hostModel && hostModel.ecModel);
};
/**
 * Create a data differ
 * @param {module:echarts/data/List} otherList
 * @return {module:echarts/data/DataDiffer}
 */


listProto.diff = function (otherList) {
  var thisList = this;
  return new DataDiffer(otherList ? otherList.getIndices() : [], this.getIndices(), function (idx) {
    return getId(otherList, idx);
  }, function (idx) {
    return getId(thisList, idx);
  });
};
/**
 * Get visual property.
 * @param {string} key
 */


listProto.getVisual = function (key) {
  var visual = this._visual;
  return visual && visual[key];
};
/**
 * Set visual property
 * @param {string|Object} key
 * @param {*} [value]
 *
 * @example
 *  setVisual('color', color);
 *  setVisual({
 *      'color': color
 *  });
 */


listProto.setVisual = function (key, val) {
  if (isObject(key)) {
    for (var name in key) {
      if (key.hasOwnProperty(name)) {
        this.setVisual(name, key[name]);
      }
    }

    return;
  }

  this._visual = this._visual || {};
  this._visual[key] = val;
};
/**
 * Set layout property.
 * @param {string|Object} key
 * @param {*} [val]
 */


listProto.setLayout = function (key, val) {
  if (isObject(key)) {
    for (var name in key) {
      if (key.hasOwnProperty(name)) {
        this.setLayout(name, key[name]);
      }
    }

    return;
  }

  this._layout[key] = val;
};
/**
 * Get layout property.
 * @param  {string} key.
 * @return {*}
 */


listProto.getLayout = function (key) {
  return this._layout[key];
};
/**
 * Get layout of single data item
 * @param {number} idx
 */


listProto.getItemLayout = function (idx) {
  return this._itemLayouts[idx];
};
/**
 * Set layout of single data item
 * @param {number} idx
 * @param {Object} layout
 * @param {boolean=} [merge=false]
 */


listProto.setItemLayout = function (idx, layout, merge) {
  this._itemLayouts[idx] = merge ? zrUtil.extend(this._itemLayouts[idx] || {}, layout) : layout;
};
/**
 * Clear all layout of single data item
 */


listProto.clearItemLayouts = function () {
  this._itemLayouts.length = 0;
};
/**
 * Get visual property of single data item
 * @param {number} idx
 * @param {string} key
 * @param {boolean} [ignoreParent=false]
 */


listProto.getItemVisual = function (idx, key, ignoreParent) {
  var itemVisual = this._itemVisuals[idx];
  var val = itemVisual && itemVisual[key];

  if (val == null && !ignoreParent) {
    // Use global visual property
    return this.getVisual(key);
  }

  return val;
};
/**
 * Set visual property of single data item
 *
 * @param {number} idx
 * @param {string|Object} key
 * @param {*} [value]
 *
 * @example
 *  setItemVisual(0, 'color', color);
 *  setItemVisual(0, {
 *      'color': color
 *  });
 */


listProto.setItemVisual = function (idx, key, value) {
  var itemVisual = this._itemVisuals[idx] || {};
  var hasItemVisual = this.hasItemVisual;
  this._itemVisuals[idx] = itemVisual;

  if (isObject(key)) {
    for (var name in key) {
      if (key.hasOwnProperty(name)) {
        itemVisual[name] = key[name];
        hasItemVisual[name] = true;
      }
    }

    return;
  }

  itemVisual[key] = value;
  hasItemVisual[key] = true;
};
/**
 * Clear itemVisuals and list visual.
 */


listProto.clearAllVisual = function () {
  this._visual = {};
  this._itemVisuals = [];
  this.hasItemVisual = {};
};

var setItemDataAndSeriesIndex = function (child) {
  child.seriesIndex = this.seriesIndex;
  child.dataIndex = this.dataIndex;
  child.dataType = this.dataType;
};
/**
 * Set graphic element relative to data. It can be set as null
 * @param {number} idx
 * @param {module:zrender/Element} [el]
 */


listProto.setItemGraphicEl = function (idx, el) {
  var hostModel = this.hostModel;

  if (el) {
    // Add data index and series index for indexing the data by element
    // Useful in tooltip
    el.dataIndex = idx;
    el.dataType = this.dataType;
    el.seriesIndex = hostModel && hostModel.seriesIndex;

    if (el.type === 'group') {
      el.traverse(setItemDataAndSeriesIndex, el);
    }
  }

  this._graphicEls[idx] = el;
};
/**
 * @param {number} idx
 * @return {module:zrender/Element}
 */


listProto.getItemGraphicEl = function (idx) {
  return this._graphicEls[idx];
};
/**
 * @param {Function} cb
 * @param {*} context
 */


listProto.eachItemGraphicEl = function (cb, context) {
  zrUtil.each(this._graphicEls, function (el, idx) {
    if (el) {
      cb && cb.call(context, el, idx);
    }
  });
};
/**
 * Shallow clone a new list except visual and layout properties, and graph elements.
 * New list only change the indices.
 */


listProto.cloneShallow = function (list) {
  if (!list) {
    var dimensionInfoList = zrUtil.map(this.dimensions, this.getDimensionInfo, this);
    list = new List(dimensionInfoList, this.hostModel);
  } // FIXME


  list._storage = this._storage;
  transferProperties(list, this); // Clone will not change the data extent and indices

  if (this._indices) {
    var Ctor = this._indices.constructor;
    list._indices = new Ctor(this._indices);
  } else {
    list._indices = null;
  }

  list.getRawIndex = list._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
  return list;
};
/**
 * Wrap some method to add more feature
 * @param {string} methodName
 * @param {Function} injectFunction
 */


listProto.wrapMethod = function (methodName, injectFunction) {
  var originalMethod = this[methodName];

  if (typeof originalMethod !== 'function') {
    return;
  }

  this.__wrappedMethods = this.__wrappedMethods || [];

  this.__wrappedMethods.push(methodName);

  this[methodName] = function () {
    var res = originalMethod.apply(this, arguments);
    return injectFunction.apply(this, [res].concat(zrUtil.slice(arguments)));
  };
}; // Methods that create a new list based on this list should be listed here.
// Notice that those method should `RETURN` the new list.


listProto.TRANSFERABLE_METHODS = ['cloneShallow', 'downSample', 'map']; // Methods that change indices of this list should be listed here.

listProto.CHANGABLE_METHODS = ['filterSelf', 'selectRange'];
var _default = List;
module.exports = _default;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var graphic = __webpack_require__(27);

var BoundingRect = __webpack_require__(57);

var _text = __webpack_require__(93);

var calculateTextPosition = _text.calculateTextPosition;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Symbol factory

/**
 * Triangle shape
 * @inner
 */
var Triangle = graphic.extendShape({
  type: 'triangle',
  shape: {
    cx: 0,
    cy: 0,
    width: 0,
    height: 0
  },
  buildPath: function (path, shape) {
    var cx = shape.cx;
    var cy = shape.cy;
    var width = shape.width / 2;
    var height = shape.height / 2;
    path.moveTo(cx, cy - height);
    path.lineTo(cx + width, cy + height);
    path.lineTo(cx - width, cy + height);
    path.closePath();
  }
});
/**
 * Diamond shape
 * @inner
 */

var Diamond = graphic.extendShape({
  type: 'diamond',
  shape: {
    cx: 0,
    cy: 0,
    width: 0,
    height: 0
  },
  buildPath: function (path, shape) {
    var cx = shape.cx;
    var cy = shape.cy;
    var width = shape.width / 2;
    var height = shape.height / 2;
    path.moveTo(cx, cy - height);
    path.lineTo(cx + width, cy);
    path.lineTo(cx, cy + height);
    path.lineTo(cx - width, cy);
    path.closePath();
  }
});
/**
 * Pin shape
 * @inner
 */

var Pin = graphic.extendShape({
  type: 'pin',
  shape: {
    // x, y on the cusp
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  buildPath: function (path, shape) {
    var x = shape.x;
    var y = shape.y;
    var w = shape.width / 5 * 3; // Height must be larger than width

    var h = Math.max(w, shape.height);
    var r = w / 2; // Dist on y with tangent point and circle center

    var dy = r * r / (h - r);
    var cy = y - h + r + dy;
    var angle = Math.asin(dy / r); // Dist on x with tangent point and circle center

    var dx = Math.cos(angle) * r;
    var tanX = Math.sin(angle);
    var tanY = Math.cos(angle);
    var cpLen = r * 0.6;
    var cpLen2 = r * 0.7;
    path.moveTo(x - dx, cy + dy);
    path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
    path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
    path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
    path.closePath();
  }
});
/**
 * Arrow shape
 * @inner
 */

var Arrow = graphic.extendShape({
  type: 'arrow',
  shape: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  buildPath: function (ctx, shape) {
    var height = shape.height;
    var width = shape.width;
    var x = shape.x;
    var y = shape.y;
    var dx = width / 3 * 2;
    ctx.moveTo(x, y);
    ctx.lineTo(x + dx, y + height);
    ctx.lineTo(x, y + height / 4 * 3);
    ctx.lineTo(x - dx, y + height);
    ctx.lineTo(x, y);
    ctx.closePath();
  }
});
/**
 * Map of path contructors
 * @type {Object.<string, module:zrender/graphic/Path>}
 */

var symbolCtors = {
  line: graphic.Line,
  rect: graphic.Rect,
  roundRect: graphic.Rect,
  square: graphic.Rect,
  circle: graphic.Circle,
  diamond: Diamond,
  pin: Pin,
  arrow: Arrow,
  triangle: Triangle
};
var symbolShapeMakers = {
  line: function (x, y, w, h, shape) {
    // FIXME
    shape.x1 = x;
    shape.y1 = y + h / 2;
    shape.x2 = x + w;
    shape.y2 = y + h / 2;
  },
  rect: function (x, y, w, h, shape) {
    shape.x = x;
    shape.y = y;
    shape.width = w;
    shape.height = h;
  },
  roundRect: function (x, y, w, h, shape) {
    shape.x = x;
    shape.y = y;
    shape.width = w;
    shape.height = h;
    shape.r = Math.min(w, h) / 4;
  },
  square: function (x, y, w, h, shape) {
    var size = Math.min(w, h);
    shape.x = x;
    shape.y = y;
    shape.width = size;
    shape.height = size;
  },
  circle: function (x, y, w, h, shape) {
    // Put circle in the center of square
    shape.cx = x + w / 2;
    shape.cy = y + h / 2;
    shape.r = Math.min(w, h) / 2;
  },
  diamond: function (x, y, w, h, shape) {
    shape.cx = x + w / 2;
    shape.cy = y + h / 2;
    shape.width = w;
    shape.height = h;
  },
  pin: function (x, y, w, h, shape) {
    shape.x = x + w / 2;
    shape.y = y + h / 2;
    shape.width = w;
    shape.height = h;
  },
  arrow: function (x, y, w, h, shape) {
    shape.x = x + w / 2;
    shape.y = y + h / 2;
    shape.width = w;
    shape.height = h;
  },
  triangle: function (x, y, w, h, shape) {
    shape.cx = x + w / 2;
    shape.cy = y + h / 2;
    shape.width = w;
    shape.height = h;
  }
};
var symbolBuildProxies = {};
zrUtil.each(symbolCtors, function (Ctor, name) {
  symbolBuildProxies[name] = new Ctor();
});
var SymbolClz = graphic.extendShape({
  type: 'symbol',
  shape: {
    symbolType: '',
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  calculateTextPosition: function (out, style, rect) {
    var res = calculateTextPosition(out, style, rect);
    var shape = this.shape;

    if (shape && shape.symbolType === 'pin' && style.textPosition === 'inside') {
      res.y = rect.y + rect.height * 0.4;
    }

    return res;
  },
  buildPath: function (ctx, shape, inBundle) {
    var symbolType = shape.symbolType;

    if (symbolType !== 'none') {
      var proxySymbol = symbolBuildProxies[symbolType];

      if (!proxySymbol) {
        // Default rect
        symbolType = 'rect';
        proxySymbol = symbolBuildProxies[symbolType];
      }

      symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
      proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
    }
  }
}); // Provide setColor helper method to avoid determine if set the fill or stroke outside

function symbolPathSetColor(color, innerColor) {
  if (this.type !== 'image') {
    var symbolStyle = this.style;
    var symbolShape = this.shape;

    if (symbolShape && symbolShape.symbolType === 'line') {
      symbolStyle.stroke = color;
    } else if (this.__isEmptyBrush) {
      symbolStyle.stroke = color;
      symbolStyle.fill = innerColor || '#fff';
    } else {
      // FIXME 判断图形默认是填充还是描边，使用 onlyStroke ?
      symbolStyle.fill && (symbolStyle.fill = color);
      symbolStyle.stroke && (symbolStyle.stroke = color);
    }

    this.dirty(false);
  }
}
/**
 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
 * @param {string} symbolType
 * @param {number} x
 * @param {number} y
 * @param {number} w
 * @param {number} h
 * @param {string} color
 * @param {boolean} [keepAspect=false] whether to keep the ratio of w/h,
 *                            for path and image only.
 */


function createSymbol(symbolType, x, y, w, h, color, keepAspect) {
  // TODO Support image object, DynamicImage.
  var isEmpty = symbolType.indexOf('empty') === 0;

  if (isEmpty) {
    symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
  }

  var symbolPath;

  if (symbolType.indexOf('image://') === 0) {
    symbolPath = graphic.makeImage(symbolType.slice(8), new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
  } else if (symbolType.indexOf('path://') === 0) {
    symbolPath = graphic.makePath(symbolType.slice(7), {}, new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
  } else {
    symbolPath = new SymbolClz({
      shape: {
        symbolType: symbolType,
        x: x,
        y: y,
        width: w,
        height: h
      }
    });
  }

  symbolPath.__isEmptyBrush = isEmpty;
  symbolPath.setColor = symbolPathSetColor;
  symbolPath.setColor(color);
  return symbolPath;
}

exports.createSymbol = createSymbol;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(925);

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(508);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 102 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(81);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 104 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 105 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(51);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Auth=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Auth,_Component);function Auth(){_classCallCheck(this,Auth);return _possibleConstructorReturn(this,(Auth.__proto__||Object.getPrototypeOf(Auth)).apply(this,arguments));}_createClass(Auth,[{key:'render',value:function render(){var _this2=this;var _props$store$auth$ES=this.props.store.auth.ES,data=_props$store$auth$ES===undefined?[]:_props$store$auth$ES;if(data.includes(this.props.auth)){return _react2.default.createElement('span',{style:{cursor:"pointer",color:"#1890ff"},onClick:function onClick(){if(_this2.props.path.includes('#')){document.getElementById(_this2.props.path.replace('#',"")).scrollIntoView();return;}_this2.props.history.push(_this2.props.path);}},' ',this.props.children);}else{return this.props.children;}}}]);return Auth;}(_react.Component))||_class)||_class);exports.default=Auth;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var coordinateSystemCreators = {};

function CoordinateSystemManager() {
  this._coordinateSystems = [];
}

CoordinateSystemManager.prototype = {
  constructor: CoordinateSystemManager,
  create: function (ecModel, api) {
    var coordinateSystems = [];
    zrUtil.each(coordinateSystemCreators, function (creater, type) {
      var list = creater.create(ecModel, api);
      coordinateSystems = coordinateSystems.concat(list || []);
    });
    this._coordinateSystems = coordinateSystems;
  },
  update: function (ecModel, api) {
    zrUtil.each(this._coordinateSystems, function (coordSys) {
      coordSys.update && coordSys.update(ecModel, api);
    });
  },
  getCoordinateSystems: function () {
    return this._coordinateSystems.slice();
  }
};

CoordinateSystemManager.register = function (type, coordinateSystemCreator) {
  coordinateSystemCreators[type] = coordinateSystemCreator;
};

CoordinateSystemManager.get = function (type) {
  return coordinateSystemCreators[type];
};

var _default = CoordinateSystemManager;
module.exports = _default;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(1);

var OrdinalScale = __webpack_require__(1569);

var IntervalScale = __webpack_require__(299);

var Scale = __webpack_require__(298);

var numberUtil = __webpack_require__(37);

var _barGrid = __webpack_require__(300);

var prepareLayoutBarSeries = _barGrid.prepareLayoutBarSeries;
var makeColumnLayout = _barGrid.makeColumnLayout;
var retrieveColumnLayout = _barGrid.retrieveColumnLayout;

var BoundingRect = __webpack_require__(57);

__webpack_require__(1570);

__webpack_require__(644);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Get axis scale extent before niced.
 * Item of returned array can only be number (including Infinity and NaN).
 */
function getScaleExtent(scale, model) {
  var scaleType = scale.type;
  var min = model.getMin();
  var max = model.getMax();
  var originalExtent = scale.getExtent();
  var axisDataLen;
  var boundaryGap;
  var span;

  if (scaleType === 'ordinal') {
    axisDataLen = model.getCategories().length;
  } else {
    boundaryGap = model.get('boundaryGap');

    if (!zrUtil.isArray(boundaryGap)) {
      boundaryGap = [boundaryGap || 0, boundaryGap || 0];
    }

    if (typeof boundaryGap[0] === 'boolean') {
      boundaryGap = [0, 0];
    }

    boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], 1);
    boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], 1);
    span = originalExtent[1] - originalExtent[0] || Math.abs(originalExtent[0]);
  } // Notice: When min/max is not set (that is, when there are null/undefined,
  // which is the most common case), these cases should be ensured:
  // (1) For 'ordinal', show all axis.data.
  // (2) For others:
  //      + `boundaryGap` is applied (if min/max set, boundaryGap is
  //      disabled).
  //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
  //      be the result that originalExtent enlarged by boundaryGap.
  // (3) If no data, it should be ensured that `scale.setBlank` is set.
  // FIXME
  // (1) When min/max is 'dataMin' or 'dataMax', should boundaryGap be able to used?
  // (2) When `needCrossZero` and all data is positive/negative, should it be ensured
  // that the results processed by boundaryGap are positive/negative?


  if (min === 'dataMin') {
    min = originalExtent[0];
  } else if (typeof min === 'function') {
    min = min({
      min: originalExtent[0],
      max: originalExtent[1]
    });
  }

  if (max === 'dataMax') {
    max = originalExtent[1];
  } else if (typeof max === 'function') {
    max = max({
      min: originalExtent[0],
      max: originalExtent[1]
    });
  }

  var fixMin = min != null;
  var fixMax = max != null;

  if (min == null) {
    min = scaleType === 'ordinal' ? axisDataLen ? 0 : NaN : originalExtent[0] - boundaryGap[0] * span;
  }

  if (max == null) {
    max = scaleType === 'ordinal' ? axisDataLen ? axisDataLen - 1 : NaN : originalExtent[1] + boundaryGap[1] * span;
  }

  (min == null || !isFinite(min)) && (min = NaN);
  (max == null || !isFinite(max)) && (max = NaN);
  scale.setBlank(zrUtil.eqNaN(min) || zrUtil.eqNaN(max) || scaleType === 'ordinal' && !scale.getOrdinalMeta().categories.length); // Evaluate if axis needs cross zero

  if (model.getNeedCrossZero()) {
    // Axis is over zero and min is not set
    if (min > 0 && max > 0 && !fixMin) {
      min = 0;
    } // Axis is under zero and max is not set


    if (min < 0 && max < 0 && !fixMax) {
      max = 0;
    }
  } // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
  // is base axis
  // FIXME
  // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
  // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
  //     Should not depend on series type `bar`?
  // (3) Fix that might overlap when using dataZoom.
  // (4) Consider other chart types using `barGrid`?
  // See #6728, #4862, `test/bar-overflow-time-plot.html`


  var ecModel = model.ecModel;

  if (ecModel && scaleType === 'time'
  /*|| scaleType === 'interval' */
  ) {
    var barSeriesModels = prepareLayoutBarSeries('bar', ecModel);
    var isBaseAxisAndHasBarSeries;
    zrUtil.each(barSeriesModels, function (seriesModel) {
      isBaseAxisAndHasBarSeries |= seriesModel.getBaseAxis() === model.axis;
    });

    if (isBaseAxisAndHasBarSeries) {
      // Calculate placement of bars on axis
      var barWidthAndOffset = makeColumnLayout(barSeriesModels); // Adjust axis min and max to account for overflow

      var adjustedScale = adjustScaleForOverflow(min, max, model, barWidthAndOffset);
      min = adjustedScale.min;
      max = adjustedScale.max;
    }
  }

  return {
    extent: [min, max],
    // "fix" means "fixed", the value should not be
    // changed in the subsequent steps.
    fixMin: fixMin,
    fixMax: fixMax
  };
}

function adjustScaleForOverflow(min, max, model, barWidthAndOffset) {
  // Get Axis Length
  var axisExtent = model.axis.getExtent();
  var axisLength = axisExtent[1] - axisExtent[0]; // Get bars on current base axis and calculate min and max overflow

  var barsOnCurrentAxis = retrieveColumnLayout(barWidthAndOffset, model.axis);

  if (barsOnCurrentAxis === undefined) {
    return {
      min: min,
      max: max
    };
  }

  var minOverflow = Infinity;
  zrUtil.each(barsOnCurrentAxis, function (item) {
    minOverflow = Math.min(item.offset, minOverflow);
  });
  var maxOverflow = -Infinity;
  zrUtil.each(barsOnCurrentAxis, function (item) {
    maxOverflow = Math.max(item.offset + item.width, maxOverflow);
  });
  minOverflow = Math.abs(minOverflow);
  maxOverflow = Math.abs(maxOverflow);
  var totalOverFlow = minOverflow + maxOverflow; // Calulate required buffer based on old range and overflow

  var oldRange = max - min;
  var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
  var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
  max += overflowBuffer * (maxOverflow / totalOverFlow);
  min -= overflowBuffer * (minOverflow / totalOverFlow);
  return {
    min: min,
    max: max
  };
}

function niceScaleExtent(scale, model) {
  var extentInfo = getScaleExtent(scale, model);
  var extent = extentInfo.extent;
  var splitNumber = model.get('splitNumber');

  if (scale.type === 'log') {
    scale.base = model.get('logBase');
  }

  var scaleType = scale.type;
  scale.setExtent(extent[0], extent[1]);
  scale.niceExtent({
    splitNumber: splitNumber,
    fixMin: extentInfo.fixMin,
    fixMax: extentInfo.fixMax,
    minInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('minInterval') : null,
    maxInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('maxInterval') : null
  }); // If some one specified the min, max. And the default calculated interval
  // is not good enough. He can specify the interval. It is often appeared
  // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
  // to be 60.
  // FIXME

  var interval = model.get('interval');

  if (interval != null) {
    scale.setInterval && scale.setInterval(interval);
  }
}
/**
 * @param {module:echarts/model/Model} model
 * @param {string} [axisType] Default retrieve from model.type
 * @return {module:echarts/scale/*}
 */


function createScaleByModel(model, axisType) {
  axisType = axisType || model.get('type');

  if (axisType) {
    switch (axisType) {
      // Buildin scale
      case 'category':
        return new OrdinalScale(model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(), [Infinity, -Infinity]);

      case 'value':
        return new IntervalScale();
      // Extended scale, like time and log

      default:
        return (Scale.getClass(axisType) || IntervalScale).create(model);
    }
  }
}
/**
 * Check if the axis corss 0
 */


function ifAxisCrossZero(axis) {
  var dataExtent = axis.scale.getExtent();
  var min = dataExtent[0];
  var max = dataExtent[1];
  return !(min > 0 && max > 0 || min < 0 && max < 0);
}
/**
 * @param {module:echarts/coord/Axis} axis
 * @return {Function} Label formatter function.
 *         param: {number} tickValue,
 *         param: {number} idx, the index in all ticks.
 *                         If category axis, this param is not requied.
 *         return: {string} label string.
 */


function makeLabelFormatter(axis) {
  var labelFormatter = axis.getLabelModel().get('formatter');
  var categoryTickStart = axis.type === 'category' ? axis.scale.getExtent()[0] : null;

  if (typeof labelFormatter === 'string') {
    labelFormatter = function (tpl) {
      return function (val) {
        // For category axis, get raw value; for numeric axis,
        // get foramtted label like '1,333,444'.
        val = axis.scale.getLabel(val);
        return tpl.replace('{value}', val != null ? val : '');
      };
    }(labelFormatter); // Consider empty array


    return labelFormatter;
  } else if (typeof labelFormatter === 'function') {
    return function (tickValue, idx) {
      // The original intention of `idx` is "the index of the tick in all ticks".
      // But the previous implementation of category axis do not consider the
      // `axisLabel.interval`, which cause that, for example, the `interval` is
      // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
      // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
      // the definition here for back compatibility.
      if (categoryTickStart != null) {
        idx = tickValue - categoryTickStart;
      }

      return labelFormatter(getAxisRawValue(axis, tickValue), idx);
    };
  } else {
    return function (tick) {
      return axis.scale.getLabel(tick);
    };
  }
}

function getAxisRawValue(axis, value) {
  // In category axis with data zoom, tick is not the original
  // index of axis.data. So tick should not be exposed to user
  // in category axis.
  return axis.type === 'category' ? axis.scale.getLabel(value) : value;
}
/**
 * @param {module:echarts/coord/Axis} axis
 * @return {module:zrender/core/BoundingRect} Be null/undefined if no labels.
 */


function estimateLabelUnionRect(axis) {
  var axisModel = axis.model;
  var scale = axis.scale;

  if (!axisModel.get('axisLabel.show') || scale.isBlank()) {
    return;
  }

  var isCategory = axis.type === 'category';
  var realNumberScaleTicks;
  var tickCount;
  var categoryScaleExtent = scale.getExtent(); // Optimize for large category data, avoid call `getTicks()`.

  if (isCategory) {
    tickCount = scale.count();
  } else {
    realNumberScaleTicks = scale.getTicks();
    tickCount = realNumberScaleTicks.length;
  }

  var axisLabelModel = axis.getLabelModel();
  var labelFormatter = makeLabelFormatter(axis);
  var rect;
  var step = 1; // Simple optimization for large amount of labels

  if (tickCount > 40) {
    step = Math.ceil(tickCount / 40);
  }

  for (var i = 0; i < tickCount; i += step) {
    var tickValue = realNumberScaleTicks ? realNumberScaleTicks[i] : categoryScaleExtent[0] + i;
    var label = labelFormatter(tickValue);
    var unrotatedSingleRect = axisLabelModel.getTextRect(label);
    var singleRect = rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
    rect ? rect.union(singleRect) : rect = singleRect;
  }

  return rect;
}

function rotateTextRect(textRect, rotate) {
  var rotateRadians = rotate * Math.PI / 180;
  var boundingBox = textRect.plain();
  var beforeWidth = boundingBox.width;
  var beforeHeight = boundingBox.height;
  var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
  var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
  var rotatedRect = new BoundingRect(boundingBox.x, boundingBox.y, afterWidth, afterHeight);
  return rotatedRect;
}
/**
 * @param {module:echarts/src/model/Model} model axisLabelModel or axisTickModel
 * @return {number|String} Can be null|'auto'|number|function
 */


function getOptionCategoryInterval(model) {
  var interval = model.get('interval');
  return interval == null ? 'auto' : interval;
}
/**
 * Set `categoryInterval` as 0 implicitly indicates that
 * show all labels reguardless of overlap.
 * @param {Object} axis axisModel.axis
 * @return {boolean}
 */


function shouldShowAllLabels(axis) {
  return axis.type === 'category' && getOptionCategoryInterval(axis.getLabelModel()) === 0;
}

exports.getScaleExtent = getScaleExtent;
exports.niceScaleExtent = niceScaleExtent;
exports.createScaleByModel = createScaleByModel;
exports.ifAxisCrossZero = ifAxisCrossZero;
exports.makeLabelFormatter = makeLabelFormatter;
exports.getAxisRawValue = getAxisRawValue;
exports.estimateLabelUnionRect = estimateLabelUnionRect;
exports.getOptionCategoryInterval = getOptionCategoryInterval;
exports.shouldShowAllLabels = shouldShowAllLabels;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(36);

var _tooltip = _interopRequireDefault(__webpack_require__(87));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _button = _interopRequireDefault(__webpack_require__(5));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(113));

var _default2 = _interopRequireDefault(__webpack_require__(219));

var _configProvider = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Popconfirm = /*#__PURE__*/function (_React$Component) {
  _inherits(Popconfirm, _React$Component);

  var _super = _createSuper(Popconfirm);

  function Popconfirm(props) {
    var _this;

    _classCallCheck(this, Popconfirm);

    _this = _super.call(this, props);

    _this.onConfirm = function (e) {
      _this.setVisible(false, e);

      var onConfirm = _this.props.onConfirm;

      if (onConfirm) {
        onConfirm.call(_assertThisInitialized(_this), e);
      }
    };

    _this.onCancel = function (e) {
      _this.setVisible(false, e);

      var onCancel = _this.props.onCancel;

      if (onCancel) {
        onCancel.call(_assertThisInitialized(_this), e);
      }
    };

    _this.onVisibleChange = function (visible) {
      var disabled = _this.props.disabled;

      if (disabled) {
        return;
      }

      _this.setVisible(visible);
    };

    _this.saveTooltip = function (node) {
      _this.tooltip = node;
    };

    _this.renderOverlay = function (prefixCls, popconfirmLocale) {
      var _this$props = _this.props,
          okButtonProps = _this$props.okButtonProps,
          cancelButtonProps = _this$props.cancelButtonProps,
          title = _this$props.title,
          cancelText = _this$props.cancelText,
          okText = _this$props.okText,
          okType = _this$props.okType,
          icon = _this$props.icon;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-inner-content")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-message")
      }, icon, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-message-title")
      }, title)), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-buttons")
      }, /*#__PURE__*/React.createElement(_button["default"], _extends({
        onClick: _this.onCancel,
        size: "small"
      }, cancelButtonProps), cancelText || popconfirmLocale.cancelText), /*#__PURE__*/React.createElement(_button["default"], _extends({
        onClick: _this.onConfirm,
        type: okType,
        size: "small"
      }, okButtonProps), okText || popconfirmLocale.okText))));
    };

    _this.renderConfirm = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          placement = _a.placement,
          restProps = __rest(_a, ["prefixCls", "placement"]);

      var prefixCls = getPrefixCls('popover', customizePrefixCls);
      var overlay = /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
        componentName: "Popconfirm",
        defaultLocale: _default2["default"].Popconfirm
      }, function (popconfirmLocale) {
        return _this.renderOverlay(prefixCls, popconfirmLocale);
      });
      return /*#__PURE__*/React.createElement(_tooltip["default"], _extends({}, restProps, {
        prefixCls: prefixCls,
        placement: placement,
        onVisibleChange: _this.onVisibleChange,
        visible: _this.state.visible,
        overlay: overlay,
        ref: _this.saveTooltip
      }));
    };

    _this.state = {
      visible: props.visible
    };
    return _this;
  }

  _createClass(Popconfirm, [{
    key: "getPopupDomNode",
    value: function getPopupDomNode() {
      return this.tooltip.getPopupDomNode();
    }
  }, {
    key: "setVisible",
    value: function setVisible(visible, e) {
      var props = this.props;

      if (!('visible' in props)) {
        this.setState({
          visible: visible
        });
      }

      var onVisibleChange = props.onVisibleChange;

      if (onVisibleChange) {
        onVisibleChange(visible, e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderConfirm);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('visible' in nextProps) {
        return {
          visible: nextProps.visible
        };
      }

      if ('defaultVisible' in nextProps) {
        return {
          visible: nextProps.defaultVisible
        };
      }

      return null;
    }
  }]);

  return Popconfirm;
}(React.Component);

Popconfirm.defaultProps = {
  transitionName: 'zoom-big',
  placement: 'top',
  trigger: 'click',
  okType: 'primary',
  icon: /*#__PURE__*/React.createElement(_icon["default"], {
    type: "exclamation-circle",
    theme: "filled"
  }),
  disabled: false
};
(0, _reactLifecyclesCompat.polyfill)(Popconfirm);
var _default = Popconfirm;
exports["default"] = _default;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(287);

__webpack_require__(6);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Group", {
  enumerable: true,
  get: function get() {
    return _group["default"];
  }
});
Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return _radioButton["default"];
  }
});
exports["default"] = void 0;

var _radio = _interopRequireDefault(__webpack_require__(362));

var _group = _interopRequireDefault(__webpack_require__(1066));

var _radioButton = _interopRequireDefault(__webpack_require__(1067));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_radio["default"].Button = _radioButton["default"];
_radio["default"].Group = _group["default"];
var _default = _radio["default"];
exports["default"] = _default;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(19));

var _default = _interopRequireDefault(__webpack_require__(798));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var LocaleReceiver = /*#__PURE__*/function (_React$Component) {
  _inherits(LocaleReceiver, _React$Component);

  var _super = _createSuper(LocaleReceiver);

  function LocaleReceiver() {
    _classCallCheck(this, LocaleReceiver);

    return _super.apply(this, arguments);
  }

  _createClass(LocaleReceiver, [{
    key: "getLocale",
    value: function getLocale() {
      var _this$props = this.props,
          componentName = _this$props.componentName,
          defaultLocale = _this$props.defaultLocale;
      var locale = defaultLocale || _default["default"][componentName || 'global'];
      var antLocale = this.context.antLocale;
      var localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
      return _extends(_extends({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
    }
  }, {
    key: "getLocaleCode",
    value: function getLocaleCode() {
      var antLocale = this.context.antLocale;
      var localeCode = antLocale && antLocale.locale; // Had use LocaleProvide but didn't set locale

      if (antLocale && antLocale.exist && !localeCode) {
        return _default["default"].locale;
      }

      return localeCode;
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.getLocale(), this.getLocaleCode(), this.context.antLocale);
    }
  }]);

  return LocaleReceiver;
}(React.Component);

exports["default"] = LocaleReceiver;
LocaleReceiver.defaultProps = {
  componentName: 'global'
};
LocaleReceiver.contextTypes = {
  antLocale: PropTypes.object
};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(322)('wks');
var uid = __webpack_require__(256);
var Symbol = __webpack_require__(141).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.connect = exports.Provider = undefined;

var _Provider2 = __webpack_require__(891);

var _Provider3 = _interopRequireDefault(_Provider2);

var _connect2 = __webpack_require__(892);

var _connect3 = _interopRequireDefault(_connect2);

var _create2 = __webpack_require__(894);

var _create3 = _interopRequireDefault(_create2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Provider = _Provider3.default;
exports.connect = _connect3.default;
exports.create = _create3.default;

/***/ }),
/* 116 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(52);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 118 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(15);
var core = __webpack_require__(102);
var fails = __webpack_require__(51);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(103);
var IObject = __webpack_require__(227);
var toObject = __webpack_require__(70);
var toLength = __webpack_require__(58);
var asc = __webpack_require__(387);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Eventful = __webpack_require__(173);

exports.Dispatcher = Eventful;

var env = __webpack_require__(67);

var _dom = __webpack_require__(614);

var isCanvasEl = _dom.isCanvasEl;
var transformCoordWithViewport = _dom.transformCoordWithViewport;

/**
 * Utilities for mouse or touch events.
 */
var isDomLevel2 = typeof window !== 'undefined' && !!window.addEventListener;
var MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
var _calcOut = [];
/**
 * Get the `zrX` and `zrY`, which are relative to the top-left of
 * the input `el`.
 * CSS transform (2D & 3D) is supported.
 *
 * The strategy to fetch the coords:
 * + If `calculate` is not set as `true`, users of this method should
 * ensure that `el` is the same or the same size & location as `e.target`.
 * Otherwise the result coords are probably not expected. Because we
 * firstly try to get coords from e.offsetX/e.offsetY.
 * + If `calculate` is set as `true`, the input `el` can be any element
 * and we force to calculate the coords based on `el`.
 * + The input `el` should be positionable (not position:static).
 *
 * The force `calculate` can be used in case like:
 * When mousemove event triggered on ec tooltip, `e.target` is not `el`(zr painter.dom).
 *
 * @param {HTMLElement} el DOM element.
 * @param {Event} e Mouse event or touch event.
 * @param {Object} out Get `out.zrX` and `out.zrY` as the result.
 * @param {boolean} [calculate=false] Whether to force calculate
 *        the coordinates but not use ones provided by browser.
 */

function clientToLocal(el, e, out, calculate) {
  out = out || {}; // According to the W3C Working Draft, offsetX and offsetY should be relative
  // to the padding edge of the target element. The only browser using this convention
  // is IE. Webkit uses the border edge, Opera uses the content edge, and FireFox does
  // not support the properties.
  // (see http://www.jacklmoore.com/notes/mouse-position/)
  // In zr painter.dom, padding edge equals to border edge.

  if (calculate || !env.canvasSupported) {
    calculateZrXY(el, e, out);
  } // Caution: In FireFox, layerX/layerY Mouse position relative to the closest positioned
  // ancestor element, so we should make sure el is positioned (e.g., not position:static).
  // BTW1, Webkit don't return the same results as FF in non-simple cases (like add
  // zoom-factor, overflow / opacity layers, transforms ...)
  // BTW2, (ev.offsetY || ev.pageY - $(ev.target).offset().top) is not correct in preserve-3d.
  // <https://bugs.jquery.com/ticket/8523#comment:14>
  // BTW3, In ff, offsetX/offsetY is always 0.
  else if (env.browser.firefox && e.layerX != null && e.layerX !== e.offsetX) {
      out.zrX = e.layerX;
      out.zrY = e.layerY;
    } // For IE6+, chrome, safari, opera. (When will ff support offsetX?)
    else if (e.offsetX != null) {
        out.zrX = e.offsetX;
        out.zrY = e.offsetY;
      } // For some other device, e.g., IOS safari.
      else {
          calculateZrXY(el, e, out);
        }

  return out;
}

function calculateZrXY(el, e, out) {
  // BlackBerry 5, iOS 3 (original iPhone) don't have getBoundingRect.
  if (env.domSupported && el.getBoundingClientRect) {
    var ex = e.clientX;
    var ey = e.clientY;

    if (isCanvasEl(el)) {
      // Original approach, which do not support CSS transform.
      // marker can not be locationed in a canvas container
      // (getBoundingClientRect is always 0). We do not support
      // that input a pre-created canvas to zr while using css
      // transform in iOS.
      var box = el.getBoundingClientRect();
      out.zrX = ex - box.left;
      out.zrY = ey - box.top;
      return;
    } else {
      if (transformCoordWithViewport(_calcOut, el, ex, ey)) {
        out.zrX = _calcOut[0];
        out.zrY = _calcOut[1];
        return;
      }
    }
  }

  out.zrX = out.zrY = 0;
}
/**
 * Find native event compat for legency IE.
 * Should be called at the begining of a native event listener.
 *
 * @param {Event} [e] Mouse event or touch event or pointer event.
 *        For lagency IE, we use `window.event` is used.
 * @return {Event} The native event.
 */


function getNativeEvent(e) {
  return e || window.event;
}
/**
 * Normalize the coordinates of the input event.
 *
 * Get the `e.zrX` and `e.zrY`, which are relative to the top-left of
 * the input `el`.
 * Get `e.zrDelta` if using mouse wheel.
 * Get `e.which`, see the comment inside this function.
 *
 * Do not calculate repeatly if `zrX` and `zrY` already exist.
 *
 * Notice: see comments in `clientToLocal`. check the relationship
 * between the result coords and the parameters `el` and `calculate`.
 *
 * @param {HTMLElement} el DOM element.
 * @param {Event} [e] See `getNativeEvent`.
 * @param {boolean} [calculate=false] Whether to force calculate
 *        the coordinates but not use ones provided by browser.
 * @return {UIEvent} The normalized native UIEvent.
 */


function normalizeEvent(el, e, calculate) {
  e = getNativeEvent(e);

  if (e.zrX != null) {
    return e;
  }

  var eventType = e.type;
  var isTouch = eventType && eventType.indexOf('touch') >= 0;

  if (!isTouch) {
    clientToLocal(el, e, e, calculate);
    e.zrDelta = e.wheelDelta ? e.wheelDelta / 120 : -(e.detail || 0) / 3;
  } else {
    var touch = eventType !== 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
    touch && clientToLocal(el, touch, e, calculate);
  } // Add which for click: 1 === left; 2 === middle; 3 === right; otherwise: 0;
  // See jQuery: https://github.com/jquery/jquery/blob/master/src/event.js
  // If e.which has been defined, it may be readonly,
  // see: https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/which


  var button = e.button;

  if (e.which == null && button !== undefined && MOUSE_EVENT_REG.test(e.type)) {
    e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
  } // [Caution]: `e.which` from browser is not always reliable. For example,
  // when press left button and `mousemove (pointermove)` in Edge, the `e.which`
  // is 65536 and the `e.button` is -1. But the `mouseup (pointerup)` and
  // `mousedown (pointerdown)` is the same as Chrome does.


  return e;
}
/**
 * @param {HTMLElement} el
 * @param {string} name
 * @param {Function} handler
 * @param {Object|boolean} opt If boolean, means `opt.capture`
 * @param {boolean} [opt.capture=false]
 * @param {boolean} [opt.passive=false]
 */


function addEventListener(el, name, handler, opt) {
  if (isDomLevel2) {
    // Reproduct the console warning:
    // [Violation] Added non-passive event listener to a scroll-blocking <some> event.
    // Consider marking event handler as 'passive' to make the page more responsive.
    // Just set console log level: verbose in chrome dev tool.
    // then the warning log will be printed when addEventListener called.
    // See https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
    // We have not yet found a neat way to using passive. Because in zrender the dom event
    // listener delegate all of the upper events of element. Some of those events need
    // to prevent default. For example, the feature `preventDefaultMouseMove` of echarts.
    // Before passive can be adopted, these issues should be considered:
    // (1) Whether and how a zrender user specifies an event listener passive. And by default,
    // passive or not.
    // (2) How to tread that some zrender event listener is passive, and some is not. If
    // we use other way but not preventDefault of mousewheel and touchmove, browser
    // compatibility should be handled.
    // var opts = (env.passiveSupported && name === 'mousewheel')
    //     ? {passive: true}
    //     // By default, the third param of el.addEventListener is `capture: false`.
    //     : void 0;
    // el.addEventListener(name, handler /* , opts */);
    el.addEventListener(name, handler, opt);
  } else {
    // For simplicity, do not implement `setCapture` for IE9-.
    el.attachEvent('on' + name, handler);
  }
}
/**
 * Parameter are the same as `addEventListener`.
 *
 * Notice that if a listener is registered twice, one with capture and one without,
 * remove each one separately. Removal of a capturing listener does not affect a
 * non-capturing version of the same listener, and vice versa.
 */


function removeEventListener(el, name, handler, opt) {
  if (isDomLevel2) {
    el.removeEventListener(name, handler, opt);
  } else {
    el.detachEvent('on' + name, handler);
  }
}
/**
 * preventDefault and stopPropagation.
 * Notice: do not use this method in zrender. It can only be
 * used by upper applications if necessary.
 *
 * @param {Event} e A mouse or touch event.
 */


var stop = isDomLevel2 ? function (e) {
  e.preventDefault();
  e.stopPropagation();
  e.cancelBubble = true;
} : function (e) {
  e.returnValue = false;
  e.cancelBubble = true;
};
/**
 * This method only works for mouseup and mousedown. The functionality is restricted
 * for fault tolerance, See the `e.which` compatibility above.
 *
 * @param {MouseEvent} e
 * @return {boolean}
 */

function isMiddleOrRightButtonOnMouseUpDown(e) {
  return e.which === 2 || e.which === 3;
}
/**
 * To be removed.
 * @deprecated
 */


function notLeftMouse(e) {
  // If e.which is undefined, considered as left mouse event.
  return e.which > 1;
} // For backward compatibility


exports.clientToLocal = clientToLocal;
exports.getNativeEvent = getNativeEvent;
exports.normalizeEvent = normalizeEvent;
exports.addEventListener = addEventListener;
exports.removeEventListener = removeEventListener;
exports.stop = stop;
exports.isMiddleOrRightButtonOnMouseUpDown = isMiddleOrRightButtonOnMouseUpDown;
exports.notLeftMouse = notLeftMouse;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var LRU = __webpack_require__(617);

var kCSSColorTable = {
  'transparent': [0, 0, 0, 0],
  'aliceblue': [240, 248, 255, 1],
  'antiquewhite': [250, 235, 215, 1],
  'aqua': [0, 255, 255, 1],
  'aquamarine': [127, 255, 212, 1],
  'azure': [240, 255, 255, 1],
  'beige': [245, 245, 220, 1],
  'bisque': [255, 228, 196, 1],
  'black': [0, 0, 0, 1],
  'blanchedalmond': [255, 235, 205, 1],
  'blue': [0, 0, 255, 1],
  'blueviolet': [138, 43, 226, 1],
  'brown': [165, 42, 42, 1],
  'burlywood': [222, 184, 135, 1],
  'cadetblue': [95, 158, 160, 1],
  'chartreuse': [127, 255, 0, 1],
  'chocolate': [210, 105, 30, 1],
  'coral': [255, 127, 80, 1],
  'cornflowerblue': [100, 149, 237, 1],
  'cornsilk': [255, 248, 220, 1],
  'crimson': [220, 20, 60, 1],
  'cyan': [0, 255, 255, 1],
  'darkblue': [0, 0, 139, 1],
  'darkcyan': [0, 139, 139, 1],
  'darkgoldenrod': [184, 134, 11, 1],
  'darkgray': [169, 169, 169, 1],
  'darkgreen': [0, 100, 0, 1],
  'darkgrey': [169, 169, 169, 1],
  'darkkhaki': [189, 183, 107, 1],
  'darkmagenta': [139, 0, 139, 1],
  'darkolivegreen': [85, 107, 47, 1],
  'darkorange': [255, 140, 0, 1],
  'darkorchid': [153, 50, 204, 1],
  'darkred': [139, 0, 0, 1],
  'darksalmon': [233, 150, 122, 1],
  'darkseagreen': [143, 188, 143, 1],
  'darkslateblue': [72, 61, 139, 1],
  'darkslategray': [47, 79, 79, 1],
  'darkslategrey': [47, 79, 79, 1],
  'darkturquoise': [0, 206, 209, 1],
  'darkviolet': [148, 0, 211, 1],
  'deeppink': [255, 20, 147, 1],
  'deepskyblue': [0, 191, 255, 1],
  'dimgray': [105, 105, 105, 1],
  'dimgrey': [105, 105, 105, 1],
  'dodgerblue': [30, 144, 255, 1],
  'firebrick': [178, 34, 34, 1],
  'floralwhite': [255, 250, 240, 1],
  'forestgreen': [34, 139, 34, 1],
  'fuchsia': [255, 0, 255, 1],
  'gainsboro': [220, 220, 220, 1],
  'ghostwhite': [248, 248, 255, 1],
  'gold': [255, 215, 0, 1],
  'goldenrod': [218, 165, 32, 1],
  'gray': [128, 128, 128, 1],
  'green': [0, 128, 0, 1],
  'greenyellow': [173, 255, 47, 1],
  'grey': [128, 128, 128, 1],
  'honeydew': [240, 255, 240, 1],
  'hotpink': [255, 105, 180, 1],
  'indianred': [205, 92, 92, 1],
  'indigo': [75, 0, 130, 1],
  'ivory': [255, 255, 240, 1],
  'khaki': [240, 230, 140, 1],
  'lavender': [230, 230, 250, 1],
  'lavenderblush': [255, 240, 245, 1],
  'lawngreen': [124, 252, 0, 1],
  'lemonchiffon': [255, 250, 205, 1],
  'lightblue': [173, 216, 230, 1],
  'lightcoral': [240, 128, 128, 1],
  'lightcyan': [224, 255, 255, 1],
  'lightgoldenrodyellow': [250, 250, 210, 1],
  'lightgray': [211, 211, 211, 1],
  'lightgreen': [144, 238, 144, 1],
  'lightgrey': [211, 211, 211, 1],
  'lightpink': [255, 182, 193, 1],
  'lightsalmon': [255, 160, 122, 1],
  'lightseagreen': [32, 178, 170, 1],
  'lightskyblue': [135, 206, 250, 1],
  'lightslategray': [119, 136, 153, 1],
  'lightslategrey': [119, 136, 153, 1],
  'lightsteelblue': [176, 196, 222, 1],
  'lightyellow': [255, 255, 224, 1],
  'lime': [0, 255, 0, 1],
  'limegreen': [50, 205, 50, 1],
  'linen': [250, 240, 230, 1],
  'magenta': [255, 0, 255, 1],
  'maroon': [128, 0, 0, 1],
  'mediumaquamarine': [102, 205, 170, 1],
  'mediumblue': [0, 0, 205, 1],
  'mediumorchid': [186, 85, 211, 1],
  'mediumpurple': [147, 112, 219, 1],
  'mediumseagreen': [60, 179, 113, 1],
  'mediumslateblue': [123, 104, 238, 1],
  'mediumspringgreen': [0, 250, 154, 1],
  'mediumturquoise': [72, 209, 204, 1],
  'mediumvioletred': [199, 21, 133, 1],
  'midnightblue': [25, 25, 112, 1],
  'mintcream': [245, 255, 250, 1],
  'mistyrose': [255, 228, 225, 1],
  'moccasin': [255, 228, 181, 1],
  'navajowhite': [255, 222, 173, 1],
  'navy': [0, 0, 128, 1],
  'oldlace': [253, 245, 230, 1],
  'olive': [128, 128, 0, 1],
  'olivedrab': [107, 142, 35, 1],
  'orange': [255, 165, 0, 1],
  'orangered': [255, 69, 0, 1],
  'orchid': [218, 112, 214, 1],
  'palegoldenrod': [238, 232, 170, 1],
  'palegreen': [152, 251, 152, 1],
  'paleturquoise': [175, 238, 238, 1],
  'palevioletred': [219, 112, 147, 1],
  'papayawhip': [255, 239, 213, 1],
  'peachpuff': [255, 218, 185, 1],
  'peru': [205, 133, 63, 1],
  'pink': [255, 192, 203, 1],
  'plum': [221, 160, 221, 1],
  'powderblue': [176, 224, 230, 1],
  'purple': [128, 0, 128, 1],
  'red': [255, 0, 0, 1],
  'rosybrown': [188, 143, 143, 1],
  'royalblue': [65, 105, 225, 1],
  'saddlebrown': [139, 69, 19, 1],
  'salmon': [250, 128, 114, 1],
  'sandybrown': [244, 164, 96, 1],
  'seagreen': [46, 139, 87, 1],
  'seashell': [255, 245, 238, 1],
  'sienna': [160, 82, 45, 1],
  'silver': [192, 192, 192, 1],
  'skyblue': [135, 206, 235, 1],
  'slateblue': [106, 90, 205, 1],
  'slategray': [112, 128, 144, 1],
  'slategrey': [112, 128, 144, 1],
  'snow': [255, 250, 250, 1],
  'springgreen': [0, 255, 127, 1],
  'steelblue': [70, 130, 180, 1],
  'tan': [210, 180, 140, 1],
  'teal': [0, 128, 128, 1],
  'thistle': [216, 191, 216, 1],
  'tomato': [255, 99, 71, 1],
  'turquoise': [64, 224, 208, 1],
  'violet': [238, 130, 238, 1],
  'wheat': [245, 222, 179, 1],
  'white': [255, 255, 255, 1],
  'whitesmoke': [245, 245, 245, 1],
  'yellow': [255, 255, 0, 1],
  'yellowgreen': [154, 205, 50, 1]
};

function clampCssByte(i) {
  // Clamp to integer 0 .. 255.
  i = Math.round(i); // Seems to be what Chrome does (vs truncation).

  return i < 0 ? 0 : i > 255 ? 255 : i;
}

function clampCssAngle(i) {
  // Clamp to integer 0 .. 360.
  i = Math.round(i); // Seems to be what Chrome does (vs truncation).

  return i < 0 ? 0 : i > 360 ? 360 : i;
}

function clampCssFloat(f) {
  // Clamp to float 0.0 .. 1.0.
  return f < 0 ? 0 : f > 1 ? 1 : f;
}

function parseCssInt(str) {
  // int or percentage.
  if (str.length && str.charAt(str.length - 1) === '%') {
    return clampCssByte(parseFloat(str) / 100 * 255);
  }

  return clampCssByte(parseInt(str, 10));
}

function parseCssFloat(str) {
  // float or percentage.
  if (str.length && str.charAt(str.length - 1) === '%') {
    return clampCssFloat(parseFloat(str) / 100);
  }

  return clampCssFloat(parseFloat(str));
}

function cssHueToRgb(m1, m2, h) {
  if (h < 0) {
    h += 1;
  } else if (h > 1) {
    h -= 1;
  }

  if (h * 6 < 1) {
    return m1 + (m2 - m1) * h * 6;
  }

  if (h * 2 < 1) {
    return m2;
  }

  if (h * 3 < 2) {
    return m1 + (m2 - m1) * (2 / 3 - h) * 6;
  }

  return m1;
}

function lerpNumber(a, b, p) {
  return a + (b - a) * p;
}

function setRgba(out, r, g, b, a) {
  out[0] = r;
  out[1] = g;
  out[2] = b;
  out[3] = a;
  return out;
}

function copyRgba(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  return out;
}

var colorCache = new LRU(20);
var lastRemovedArr = null;

function putToCache(colorStr, rgbaArr) {
  // Reuse removed array
  if (lastRemovedArr) {
    copyRgba(lastRemovedArr, rgbaArr);
  }

  lastRemovedArr = colorCache.put(colorStr, lastRemovedArr || rgbaArr.slice());
}
/**
 * @param {string} colorStr
 * @param {Array.<number>} out
 * @return {Array.<number>}
 * @memberOf module:zrender/util/color
 */


function parse(colorStr, rgbaArr) {
  if (!colorStr) {
    return;
  }

  rgbaArr = rgbaArr || [];
  var cached = colorCache.get(colorStr);

  if (cached) {
    return copyRgba(rgbaArr, cached);
  } // colorStr may be not string


  colorStr = colorStr + ''; // Remove all whitespace, not compliant, but should just be more accepting.

  var str = colorStr.replace(/ /g, '').toLowerCase(); // Color keywords (and transparent) lookup.

  if (str in kCSSColorTable) {
    copyRgba(rgbaArr, kCSSColorTable[str]);
    putToCache(colorStr, rgbaArr);
    return rgbaArr;
  } // #abc and #abc123 syntax.


  if (str.charAt(0) === '#') {
    if (str.length === 4) {
      var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.

      if (!(iv >= 0 && iv <= 0xfff)) {
        setRgba(rgbaArr, 0, 0, 0, 1);
        return; // Covers NaN.
      }

      setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, 1);
      putToCache(colorStr, rgbaArr);
      return rgbaArr;
    } else if (str.length === 7) {
      var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.

      if (!(iv >= 0 && iv <= 0xffffff)) {
        setRgba(rgbaArr, 0, 0, 0, 1);
        return; // Covers NaN.
      }

      setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, 1);
      putToCache(colorStr, rgbaArr);
      return rgbaArr;
    }

    return;
  }

  var op = str.indexOf('(');
  var ep = str.indexOf(')');

  if (op !== -1 && ep + 1 === str.length) {
    var fname = str.substr(0, op);
    var params = str.substr(op + 1, ep - (op + 1)).split(',');
    var alpha = 1; // To allow case fallthrough.

    switch (fname) {
      case 'rgba':
        if (params.length !== 4) {
          setRgba(rgbaArr, 0, 0, 0, 1);
          return;
        }

        alpha = parseCssFloat(params.pop());
      // jshint ignore:line
      // Fall through.

      case 'rgb':
        if (params.length !== 3) {
          setRgba(rgbaArr, 0, 0, 0, 1);
          return;
        }

        setRgba(rgbaArr, parseCssInt(params[0]), parseCssInt(params[1]), parseCssInt(params[2]), alpha);
        putToCache(colorStr, rgbaArr);
        return rgbaArr;

      case 'hsla':
        if (params.length !== 4) {
          setRgba(rgbaArr, 0, 0, 0, 1);
          return;
        }

        params[3] = parseCssFloat(params[3]);
        hsla2rgba(params, rgbaArr);
        putToCache(colorStr, rgbaArr);
        return rgbaArr;

      case 'hsl':
        if (params.length !== 3) {
          setRgba(rgbaArr, 0, 0, 0, 1);
          return;
        }

        hsla2rgba(params, rgbaArr);
        putToCache(colorStr, rgbaArr);
        return rgbaArr;

      default:
        return;
    }
  }

  setRgba(rgbaArr, 0, 0, 0, 1);
  return;
}
/**
 * @param {Array.<number>} hsla
 * @param {Array.<number>} rgba
 * @return {Array.<number>} rgba
 */


function hsla2rgba(hsla, rgba) {
  var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360; // 0 .. 1
  // NOTE(deanm): According to the CSS spec s/l should only be
  // percentages, but we don't bother and let float or percentage.

  var s = parseCssFloat(hsla[1]);
  var l = parseCssFloat(hsla[2]);
  var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
  var m1 = l * 2 - m2;
  rgba = rgba || [];
  setRgba(rgba, clampCssByte(cssHueToRgb(m1, m2, h + 1 / 3) * 255), clampCssByte(cssHueToRgb(m1, m2, h) * 255), clampCssByte(cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);

  if (hsla.length === 4) {
    rgba[3] = hsla[3];
  }

  return rgba;
}
/**
 * @param {Array.<number>} rgba
 * @return {Array.<number>} hsla
 */


function rgba2hsla(rgba) {
  if (!rgba) {
    return;
  } // RGB from 0 to 255


  var R = rgba[0] / 255;
  var G = rgba[1] / 255;
  var B = rgba[2] / 255;
  var vMin = Math.min(R, G, B); // Min. value of RGB

  var vMax = Math.max(R, G, B); // Max. value of RGB

  var delta = vMax - vMin; // Delta RGB value

  var L = (vMax + vMin) / 2;
  var H;
  var S; // HSL results from 0 to 1

  if (delta === 0) {
    H = 0;
    S = 0;
  } else {
    if (L < 0.5) {
      S = delta / (vMax + vMin);
    } else {
      S = delta / (2 - vMax - vMin);
    }

    var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
    var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
    var deltaB = ((vMax - B) / 6 + delta / 2) / delta;

    if (R === vMax) {
      H = deltaB - deltaG;
    } else if (G === vMax) {
      H = 1 / 3 + deltaR - deltaB;
    } else if (B === vMax) {
      H = 2 / 3 + deltaG - deltaR;
    }

    if (H < 0) {
      H += 1;
    }

    if (H > 1) {
      H -= 1;
    }
  }

  var hsla = [H * 360, S, L];

  if (rgba[3] != null) {
    hsla.push(rgba[3]);
  }

  return hsla;
}
/**
 * @param {string} color
 * @param {number} level
 * @return {string}
 * @memberOf module:zrender/util/color
 */


function lift(color, level) {
  var colorArr = parse(color);

  if (colorArr) {
    for (var i = 0; i < 3; i++) {
      if (level < 0) {
        colorArr[i] = colorArr[i] * (1 - level) | 0;
      } else {
        colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
      }

      if (colorArr[i] > 255) {
        colorArr[i] = 255;
      } else if (color[i] < 0) {
        colorArr[i] = 0;
      }
    }

    return stringify(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
  }
}
/**
 * @param {string} color
 * @return {string}
 * @memberOf module:zrender/util/color
 */


function toHex(color) {
  var colorArr = parse(color);

  if (colorArr) {
    return ((1 << 24) + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
  }
}
/**
 * Map value to color. Faster than lerp methods because color is represented by rgba array.
 * @param {number} normalizedValue A float between 0 and 1.
 * @param {Array.<Array.<number>>} colors List of rgba color array
 * @param {Array.<number>} [out] Mapped gba color array
 * @return {Array.<number>} will be null/undefined if input illegal.
 */


function fastLerp(normalizedValue, colors, out) {
  if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) {
    return;
  }

  out = out || [];
  var value = normalizedValue * (colors.length - 1);
  var leftIndex = Math.floor(value);
  var rightIndex = Math.ceil(value);
  var leftColor = colors[leftIndex];
  var rightColor = colors[rightIndex];
  var dv = value - leftIndex;
  out[0] = clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv));
  out[1] = clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv));
  out[2] = clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv));
  out[3] = clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv));
  return out;
}
/**
 * @deprecated
 */


var fastMapToColor = fastLerp;
/**
 * @param {number} normalizedValue A float between 0 and 1.
 * @param {Array.<string>} colors Color list.
 * @param {boolean=} fullOutput Default false.
 * @return {(string|Object)} Result color. If fullOutput,
 *                           return {color: ..., leftIndex: ..., rightIndex: ..., value: ...},
 * @memberOf module:zrender/util/color
 */

function lerp(normalizedValue, colors, fullOutput) {
  if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) {
    return;
  }

  var value = normalizedValue * (colors.length - 1);
  var leftIndex = Math.floor(value);
  var rightIndex = Math.ceil(value);
  var leftColor = parse(colors[leftIndex]);
  var rightColor = parse(colors[rightIndex]);
  var dv = value - leftIndex;
  var color = stringify([clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv)), clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv)), clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv)), clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv))], 'rgba');
  return fullOutput ? {
    color: color,
    leftIndex: leftIndex,
    rightIndex: rightIndex,
    value: value
  } : color;
}
/**
 * @deprecated
 */


var mapToColor = lerp;
/**
 * @param {string} color
 * @param {number=} h 0 ~ 360, ignore when null.
 * @param {number=} s 0 ~ 1, ignore when null.
 * @param {number=} l 0 ~ 1, ignore when null.
 * @return {string} Color string in rgba format.
 * @memberOf module:zrender/util/color
 */

function modifyHSL(color, h, s, l) {
  color = parse(color);

  if (color) {
    color = rgba2hsla(color);
    h != null && (color[0] = clampCssAngle(h));
    s != null && (color[1] = parseCssFloat(s));
    l != null && (color[2] = parseCssFloat(l));
    return stringify(hsla2rgba(color), 'rgba');
  }
}
/**
 * @param {string} color
 * @param {number=} alpha 0 ~ 1
 * @return {string} Color string in rgba format.
 * @memberOf module:zrender/util/color
 */


function modifyAlpha(color, alpha) {
  color = parse(color);

  if (color && alpha != null) {
    color[3] = clampCssFloat(alpha);
    return stringify(color, 'rgba');
  }
}
/**
 * @param {Array.<number>} arrColor like [12,33,44,0.4]
 * @param {string} type 'rgba', 'hsva', ...
 * @return {string} Result color. (If input illegal, return undefined).
 */


function stringify(arrColor, type) {
  if (!arrColor || !arrColor.length) {
    return;
  }

  var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];

  if (type === 'rgba' || type === 'hsva' || type === 'hsla') {
    colorStr += ',' + arrColor[3];
  }

  return type + '(' + colorStr + ')';
}

exports.parse = parse;
exports.lift = lift;
exports.toHex = toHex;
exports.fastLerp = fastLerp;
exports.fastMapToColor = fastMapToColor;
exports.lerp = lerp;
exports.mapToColor = mapToColor;
exports.modifyHSL = modifyHSL;
exports.modifyAlpha = modifyAlpha;
exports.stringify = stringify;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(1);

var each = _util.each;

var Group = __webpack_require__(174);

var componentUtil = __webpack_require__(235);

var clazzUtil = __webpack_require__(135);

var modelUtil = __webpack_require__(44);

var graphicUtil = __webpack_require__(27);

var _task = __webpack_require__(412);

var createTask = _task.createTask;

var createRenderPlanner = __webpack_require__(206);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var inner = modelUtil.makeInner();
var renderPlanner = createRenderPlanner();

function Chart() {
  /**
   * @type {module:zrender/container/Group}
   * @readOnly
   */
  this.group = new Group();
  /**
   * @type {string}
   * @readOnly
   */

  this.uid = componentUtil.getUID('viewChart');
  this.renderTask = createTask({
    plan: renderTaskPlan,
    reset: renderTaskReset
  });
  this.renderTask.context = {
    view: this
  };
}

Chart.prototype = {
  type: 'chart',

  /**
   * Init the chart.
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */
  init: function (ecModel, api) {},

  /**
   * Render the chart.
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */
  render: function (seriesModel, ecModel, api, payload) {},

  /**
   * Highlight series or specified data item.
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */
  highlight: function (seriesModel, ecModel, api, payload) {
    toggleHighlight(seriesModel.getData(), payload, 'emphasis');
  },

  /**
   * Downplay series or specified data item.
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */
  downplay: function (seriesModel, ecModel, api, payload) {
    toggleHighlight(seriesModel.getData(), payload, 'normal');
  },

  /**
   * Remove self.
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */
  remove: function (ecModel, api) {
    this.group.removeAll();
  },

  /**
   * Dispose self.
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */
  dispose: function () {},

  /**
   * Rendering preparation in progressive mode.
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */
  incrementalPrepareRender: null,

  /**
   * Render in progressive mode.
   * @param  {Object} params See taskParams in `stream/task.js`
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */
  incrementalRender: null,

  /**
   * Update transform directly.
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   * @return {Object} {update: true}
   */
  updateTransform: null,

  /**
   * The view contains the given point.
   * @interface
   * @param {Array.<number>} point
   * @return {boolean}
   */
  // containPoint: function () {}

  /**
   * @param {string} eventType
   * @param {Object} query
   * @param {module:zrender/Element} targetEl
   * @param {Object} packedEvent
   * @return {boolen} Pass only when return `true`.
   */
  filterForExposedEvent: null
};
var chartProto = Chart.prototype;

chartProto.updateView = chartProto.updateLayout = chartProto.updateVisual = function (seriesModel, ecModel, api, payload) {
  this.render(seriesModel, ecModel, api, payload);
};
/**
 * Set state of single element
 * @param {module:zrender/Element} el
 * @param {string} state 'normal'|'emphasis'
 * @param {number} highlightDigit
 */


function elSetState(el, state, highlightDigit) {
  if (el) {
    el.trigger(state, highlightDigit);

    if (el.isGroup // Simple optimize.
    && !graphicUtil.isHighDownDispatcher(el)) {
      for (var i = 0, len = el.childCount(); i < len; i++) {
        elSetState(el.childAt(i), state, highlightDigit);
      }
    }
  }
}
/**
 * @param {module:echarts/data/List} data
 * @param {Object} payload
 * @param {string} state 'normal'|'emphasis'
 */


function toggleHighlight(data, payload, state) {
  var dataIndex = modelUtil.queryDataIndex(data, payload);
  var highlightDigit = payload && payload.highlightKey != null ? graphicUtil.getHighlightDigit(payload.highlightKey) : null;

  if (dataIndex != null) {
    each(modelUtil.normalizeToArray(dataIndex), function (dataIdx) {
      elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
    });
  } else {
    data.eachItemGraphicEl(function (el) {
      elSetState(el, state, highlightDigit);
    });
  }
} // Enable Chart.extend.


clazzUtil.enableClassExtend(Chart, ['dispose']); // Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.

clazzUtil.enableClassManagement(Chart, {
  registerWhenExtend: true
});

Chart.markUpdateMethod = function (payload, methodName) {
  inner(payload).updateMethod = methodName;
};

function renderTaskPlan(context) {
  return renderPlanner(context.model);
}

function renderTaskReset(context) {
  var seriesModel = context.model;
  var ecModel = context.ecModel;
  var api = context.api;
  var payload = context.payload; // ???! remove updateView updateVisual

  var progressiveRender = seriesModel.pipelineContext.progressiveRender;
  var view = context.view;
  var updateMethod = payload && inner(payload).updateMethod;
  var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod // `appendData` is also supported when data amount
  // is less than progressive threshold.
  : 'render';

  if (methodName !== 'render') {
    view[methodName](seriesModel, ecModel, api, payload);
  }

  return progressMethodMap[methodName];
}

var progressMethodMap = {
  incrementalPrepareRender: {
    progress: function (params, context) {
      context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
    }
  },
  render: {
    // Put view.render in `progress` to support appendData. But in this case
    // view.render should not be called in reset, otherwise it will be called
    // twise. Use `forceFirstProgress` to make sure that view.render is called
    // in any cases.
    forceFirstProgress: true,
    progress: function (params, context) {
      context.view.render(context.model, context.ecModel, context.api, context.payload);
    }
  }
};
var _default = Chart;
module.exports = _default;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(1);

var each = _util.each;
var isString = _util.isString;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Note that it is too complicated to support 3d stack by value
 * (have to create two-dimension inverted index), so in 3d case
 * we just support that stacked by index.
 *
 * @param {module:echarts/model/Series} seriesModel
 * @param {Array.<string|Object>} dimensionInfoList The same as the input of <module:echarts/data/List>.
 *        The input dimensionInfoList will be modified.
 * @param {Object} [opt]
 * @param {boolean} [opt.stackedCoordDimension=''] Specify a coord dimension if needed.
 * @param {boolean} [opt.byIndex=false]
 * @return {Object} calculationInfo
 * {
 *     stackedDimension: string
 *     stackedByDimension: string
 *     isStackedByIndex: boolean
 *     stackedOverDimension: string
 *     stackResultDimension: string
 * }
 */
function enableDataStack(seriesModel, dimensionInfoList, opt) {
  opt = opt || {};
  var byIndex = opt.byIndex;
  var stackedCoordDimension = opt.stackedCoordDimension; // Compatibal: when `stack` is set as '', do not stack.

  var mayStack = !!(seriesModel && seriesModel.get('stack'));
  var stackedByDimInfo;
  var stackedDimInfo;
  var stackResultDimension;
  var stackedOverDimension;
  each(dimensionInfoList, function (dimensionInfo, index) {
    if (isString(dimensionInfo)) {
      dimensionInfoList[index] = dimensionInfo = {
        name: dimensionInfo
      };
    }

    if (mayStack && !dimensionInfo.isExtraCoord) {
      // Find the first ordinal dimension as the stackedByDimInfo.
      if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) {
        stackedByDimInfo = dimensionInfo;
      } // Find the first stackable dimension as the stackedDimInfo.


      if (!stackedDimInfo && dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time' && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) {
        stackedDimInfo = dimensionInfo;
      }
    }
  });

  if (stackedDimInfo && !byIndex && !stackedByDimInfo) {
    // Compatible with previous design, value axis (time axis) only stack by index.
    // It may make sense if the user provides elaborately constructed data.
    byIndex = true;
  } // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
  // That put stack logic in List is for using conveniently in echarts extensions, but it
  // might not be a good way.


  if (stackedDimInfo) {
    // Use a weird name that not duplicated with other names.
    stackResultDimension = '__\0ecstackresult';
    stackedOverDimension = '__\0ecstackedover'; // Create inverted index to fast query index by value.

    if (stackedByDimInfo) {
      stackedByDimInfo.createInvertedIndices = true;
    }

    var stackedDimCoordDim = stackedDimInfo.coordDim;
    var stackedDimType = stackedDimInfo.type;
    var stackedDimCoordIndex = 0;
    each(dimensionInfoList, function (dimensionInfo) {
      if (dimensionInfo.coordDim === stackedDimCoordDim) {
        stackedDimCoordIndex++;
      }
    });
    dimensionInfoList.push({
      name: stackResultDimension,
      coordDim: stackedDimCoordDim,
      coordDimIndex: stackedDimCoordIndex,
      type: stackedDimType,
      isExtraCoord: true,
      isCalculationCoord: true
    });
    stackedDimCoordIndex++;
    dimensionInfoList.push({
      name: stackedOverDimension,
      // This dimension contains stack base (generally, 0), so do not set it as
      // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
      coordDim: stackedOverDimension,
      coordDimIndex: stackedDimCoordIndex,
      type: stackedDimType,
      isExtraCoord: true,
      isCalculationCoord: true
    });
  }

  return {
    stackedDimension: stackedDimInfo && stackedDimInfo.name,
    stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
    isStackedByIndex: byIndex,
    stackedOverDimension: stackedOverDimension,
    stackResultDimension: stackResultDimension
  };
}
/**
 * @param {module:echarts/data/List} data
 * @param {string} stackedDim
 */


function isDimensionStacked(data, stackedDim
/*, stackedByDim*/
) {
  // Each single series only maps to one pair of axis. So we do not need to
  // check stackByDim, whatever stacked by a dimension or stacked by index.
  return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension'); // && (
  //     stackedByDim != null
  //         ? stackedByDim === data.getCalculationInfo('stackedByDimension')
  //         : data.getCalculationInfo('isStackedByIndex')
  // );
}
/**
 * @param {module:echarts/data/List} data
 * @param {string} targetDim
 * @param {string} [stackedByDim] If not input this parameter, check whether
 *                                stacked by index.
 * @return {string} dimension
 */


function getStackedDimension(data, targetDim) {
  return isDimensionStacked(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
}

exports.enableDataStack = enableDataStack;
exports.isDimensionStacked = isDimensionStacked;
exports.getStackedDimension = getStackedDimension;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setOption=exports.setKarte=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.setColumn=setColumn;exports.draw=draw;exports.setYCategory=setYCategory;var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);var _index=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var COLOR=['#fb734e','#94d96c','#0bbcb7','#1a9bfc','#7049f0','#e32f46'];function setColumn(data,isOnResize){var dataY=data.dataY,dataX=data.dataX,id=data.id,_data$color=data.color,color=_data$color===undefined?COLOR:_data$color;var myChart=_echarts2.default.init(document.getElementById(id));myChart.resize();if(isOnResize){return;}var option={color:color,tooltip:{trigger:'axis',axisPointer:{type:'cross'},formatter:function formatter(params){return params[0].name+" <br/> "+params.map(function(item){return item.marker+" "+item.seriesName+" "+item.value+"% <br/>";}).join('')+"\n                ";}},textStyle:{color:"#000",fontSize:14},grid:{top:30,bottom:80},legend:{data:[].concat(_toConsumableArray(dataY)).map(function(x){return x.name;}),bottom:"bottom"},xAxis:[{type:'category',axisLabel:{color:"black",fontSize:14},data:dataX,splitLine:{show:false}}],yAxis:[{type:'value',axisLabel:{formatter:'{value} %'},splitLine:{show:false},axisLine:{show:false}}],series:[].concat(_toConsumableArray(dataY)).map(function(x){return{name:x.name,type:"bar",data:x.data.map(function(item){return((0,_index.numConvert)(item)*100).toFixed(3);}),barMaxWidth:'50',label:{normal:{show:true,position:'top',textStyle:{color:'#000',fontSize:'14'},formatter:function formatter(params){return params.value!=0?params.value+"%":'';}}}};})};myChart.setOption(option);}function draw(id,color){var canvas=document.getElementById(id);var ctx=canvas.getContext('2d');canvas.width='130';canvas.height='130';ctx.beginPath();ctx.moveTo(0,0);ctx.quadraticCurveTo(30,100,60,120);ctx.quadraticCurveTo(60,120,70,120);ctx.quadraticCurveTo(100,105,130,0);ctx.lineTo(0,0);ctx.strokeStyle=color;ctx.stroke();ctx.fillStyle=color;//填充颜色
ctx.fill();//填充
}function setYCategory(data,isOnResize){var dataY=data.dataY,dataX=data.dataX,id=data.id,color=data.color,grid=data.grid;var myChart=_echarts2.default.init(document.getElementById(id));myChart.resize();if(isOnResize){return;}var option={color:color,tooltip:{trigger:'axis',axisPointer:{type:'cross'},formatter:function formatter(params){return params[0].name+" <br/> "+params.map(function(item){return item.marker+" "+item.seriesName+" "+item.value+"% <br/>";}).join('')+"\n                ";}},textStyle:{color:"#000",fontSize:14},grid:_extends({top:30,bottom:80,left:100},grid),legend:{data:[].concat(_toConsumableArray(dataX)).map(function(x){return x.name;}),bottom:"bottom"},xAxis:[{type:'value',axisLabel:{formatter:'{value} %'},splitLine:{show:false}}],yAxis:{type:'category',splitLine:{show:false},axisLabel:{color:"black",fontSize:16},z:10,data:dataY},series:[].concat(_toConsumableArray(dataX)).map(function(x){return{name:x.name,type:"bar",data:x.data.map(function(item){return((0,_index.numConvert)(item)*100).toFixed(3);}),barMaxWidth:'50',label:{normal:{show:true,position:'right',textStyle:{color:'#000',fontSize:'14'},formatter:function formatter(params){return params.value!=0?params.value+"%":'';}}}};})};myChart.setOption(option);}var setKarte=exports.setKarte=function setKarte(_ref,isOnResize){var dataX=_ref.dataX,dataY=_ref.dataY,title=_ref.title,_ref$type=_ref.type,type=_ref$type===undefined?"":_ref$type,id=_ref.id,_ref$color=_ref.color,color=_ref$color===undefined?COLOR:_ref$color,_ref$yAxis=_ref.yAxis,yAxis=_ref$yAxis===undefined?{}:_ref$yAxis,_ref$grid=_ref.grid,grid=_ref$grid===undefined?{}:_ref$grid,_ref$titleOption=_ref.titleOption,titleOption=_ref$titleOption===undefined?{}:_ref$titleOption;var myChart=_echarts2.default.init(document.getElementById(id));myChart.resize();if(isOnResize){return;}var option={color:color,title:_extends({text:title,textStyle:{fontSize:20}},titleOption),tooltip:{trigger:'axis',axisPointer:{type:'shadow'}},grid:_extends({top:120},grid),legend:{top:30,data:dataY.map(function(x){return x.name;}),textStyle:{fontSize:18}},toolbox:{feature:{saveAsImage:{show:true}}},xAxis:[{type:'category',axisLabel:{color:"black",fontSize:14,interval:0},data:dataX}],yAxis:yAxis instanceof Array?yAxis.map(function(x){return _extends({},x,{type:'value',name:'',axisLabel:{formatter:type=='perncet'?'{value}%':'{value}'}});}):_extends({},yAxis,{type:'value',name:'',axisLabel:{formatter:type=='perncet'?'{value}%':'{value}'}}),series:dataY.map(function(x,i){return _extends({},x,{name:x.name,type:x.type||"line",smooth:true,data:type=="percent"?x.data.map(function(x){return(x*100).toFixed(1);}):x.data});})};myChart.setOption(option);};var setOption=exports.setOption=function setOption(_ref2,isOnResize){var dataX=_ref2.dataX,dataY=_ref2.dataY,title=_ref2.title,_ref2$type=_ref2.type,type=_ref2$type===undefined?"":_ref2$type,id=_ref2.id,_ref2$color=_ref2.color,color=_ref2$color===undefined?COLOR:_ref2$color,xAxis=_ref2.xAxis,_ref2$yAxis=_ref2.yAxis,yAxis=_ref2$yAxis===undefined?{}:_ref2$yAxis;var myChart=_echarts2.default.init(document.getElementById(id));myChart.resize();console.log(xAxis);if(isOnResize){return;}var option={color:color,title:{text:title,textStyle:{fontSize:20}},tooltip:{trigger:'axis',axisPointer:{type:'cross'}},grid:{top:120},legend:{top:30,data:dataY.map(function(x){return x.name;}),textStyle:{fontSize:18}},toolbox:{feature:{saveAsImage:{show:true}}},xAxis:xAxis||[{type:'category',axisLabel:{color:"black",fontSize:14},data:dataX}],yAxis:_extends({},yAxis,{type:'value',name:'',axisLabel:{formatter:type=='perncet'?'{value}%':'{value}'}}),series:dataY.map(function(x,i){return{name:x.name,type:x.type||"line",smooth:true,data:type=="percent"?x.data.map(function(x){return(x*100).toFixed(1);}):x.data};})};myChart.setOption(option);};

/***/ }),
/* 126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(1096);

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var html2canvas = __webpack_require__(540);
var jsPDF = __webpack_require__(183);
__webpack_require__(1119)
module.exports = {
    imgToPdf: function imgToPdf(id) {
        var multiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.8;
        var isPdf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var pdfName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'pdf';

        return new Promise(function (res, rej) {
            try {
                const e = document.getElementById(id);
                const e_width = e.offsetWidth;
                const e_height = e.offsetHeight; 
                html2canvas(e, {
                    width: e_width,
                    height: e_height, 
                    scale: multiple
                }).then(function (canvas) {
                    //返回图片URL，参数：图片格式和清晰度(0-1)
                    var pageData = canvas.toDataURL("'image/png'");
                    if (isPdf) {

                        //方向默认横向，尺寸ponits, 按照图片大小进行输出
                        var pdf = new jsPDF('l', 'px', [canvas.width, canvas.height]);
                        //需要dataUrl格式
                        pdf.addImage(pageData, 'PNG', 0, 0, canvas.width, canvas.height);
                        pdf.save(pdfName + '.pdf');
                    }
                    res({ img: pageData, canvas: canvas });
                }).catch(function (err) {
                    return rej(err);
                });
            } catch (error) {
                rej(error);
            }
        });
    },

    addPagePdf: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var imgData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [{}];
            var name = arguments[1];

            var data, i, canvas, width, height, ctx, parameter, pdf, _i;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            data = [];
                            _context.prev = 1;
                            i = 0;

                        case 3:
                            if (!(i < imgData.length)) {
                                _context.next = 10;
                                break;
                            }

                            _context.next = 6;
                            return imgToPdf(imgData[i].id, imgData[i].multiple);

                        case 6:
                            data[i] = _context.sent;

                        case 7:
                            i++;
                            _context.next = 3;
                            break;

                        case 10:
                            canvas = document.createElement("canvas"); //创建一个canvas节点

                            width = 0, height = 0;
                            // 计算最大宽度和高度，暂时无法针对每个页面进行设置款到，否则会出现图片显示不完全

                            data.forEach(function (item) {
                                if (width < item.canvas.width) {
                                    width = item.canvas.width;
                                }
                                if (height < item.canvas.height) {
                                    height = item.canvas.height;
                                }
                            });
                            canvas.width = width;
                            canvas.height = height;
                            ctx = canvas.getContext("2d");
                            parameter = [];
                            pdf = new jsPDF('l', 'px', [width, height]);

                            for (_i = 0; _i < data.length; _i++) {

                                // 循环往pdf中插入图片
                                pdf.addImage(data[_i].img, 'PNG', 0, 0, data[_i].canvas.width, data[_i].canvas.height);

                                if (_i === data.length - 1) {
                                    pdf.save(name + '.pdf');
                                } else {
                                    pdf.addPage();
                                }
                            }
                            _context.next = 24;
                            break;

                        case 21:
                            _context.prev = 21;
                            _context.t0 = _context['catch'](1);

                            console.error(_context.t0);

                        case 24:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[1, 21]]);
        }));

        return function addPagePdf() {
            return _ref.apply(this, arguments);
        };
    }(),

    // 传入图片导出
    addImgToPdf: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [{}];
            var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "pdf";
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            return _context2.abrupt('return', new Promise(function (res, rej) {
                                try {
                                    var width = 0,
                                        height = 0;

                                    // 计算最大宽度和高度，暂时无法针对每个页面进行设置款到，否则会出现图片显示不完全
                                    data.forEach(function (item) {
                                        if (width < item.width) {
                                            width = item.width;
                                        }
                                        if (height < item.height) {
                                            height = item.height;
                                        }
                                    });
                                    var pdf = new jsPDF('l', 'px', [width, height]);
                                    for (var i = 0; i < data.length; i++) {

                                        // 循环往pdf中插入图片
                                        pdf.addImage(data[i].img, 'PNG', 0, 0, data[i].width, data[i].height);

                                        if (i === data.length - 1) {
                                            pdf.save(name + '.pdf');
                                            res({ status: 1, msg: "导出成功" });
                                        } else {
                                            pdf.addPage();
                                        }
                                    }
                                } catch (error) {
                                    console.error(error);
                                    rej(error);
                                }
                            }));

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined);
        }));

        return function addImgToPdf() {
            return _ref2.apply(this, arguments);
        };
    }()
};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tupleNum = exports.tuple = void 0;

// https://stackoverflow.com/questions/46176165/ways-to-get-string-literal-type-of-array-values-without-enum-overhead
var tuple = function tuple() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args;
};

exports.tuple = tuple;

var tupleNum = function tupleNum() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return args;
};

exports.tupleNum = tupleNum;

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,

  /**
   * BACKSPACE
   */
  BACKSPACE: 8,

  /**
   * TAB
   */
  TAB: 9,

  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,

  /**
   * ENTER
   */
  ENTER: 13,

  /**
   * SHIFT
   */
  SHIFT: 16,

  /**
   * CTRL
   */
  CTRL: 17,

  /**
   * ALT
   */
  ALT: 18,

  /**
   * PAUSE
   */
  PAUSE: 19,

  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,

  /**
   * ESC
   */
  ESC: 27,

  /**
   * SPACE
   */
  SPACE: 32,

  /**
   * PAGE_UP
   */
  PAGE_UP: 33,

  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,

  /**
   * END
   */
  END: 35,

  /**
   * HOME
   */
  HOME: 36,

  /**
   * LEFT
   */
  LEFT: 37,

  /**
   * UP
   */
  UP: 38,

  /**
   * RIGHT
   */
  RIGHT: 39,

  /**
   * DOWN
   */
  DOWN: 40,

  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,

  /**
   * INSERT
   */
  INSERT: 45,

  /**
   * DELETE
   */
  DELETE: 46,

  /**
   * ZERO
   */
  ZERO: 48,

  /**
   * ONE
   */
  ONE: 49,

  /**
   * TWO
   */
  TWO: 50,

  /**
   * THREE
   */
  THREE: 51,

  /**
   * FOUR
   */
  FOUR: 52,

  /**
   * FIVE
   */
  FIVE: 53,

  /**
   * SIX
   */
  SIX: 54,

  /**
   * SEVEN
   */
  SEVEN: 55,

  /**
   * EIGHT
   */
  EIGHT: 56,

  /**
   * NINE
   */
  NINE: 57,

  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,

  /**
   * A
   */
  A: 65,

  /**
   * B
   */
  B: 66,

  /**
   * C
   */
  C: 67,

  /**
   * D
   */
  D: 68,

  /**
   * E
   */
  E: 69,

  /**
   * F
   */
  F: 70,

  /**
   * G
   */
  G: 71,

  /**
   * H
   */
  H: 72,

  /**
   * I
   */
  I: 73,

  /**
   * J
   */
  J: 74,

  /**
   * K
   */
  K: 75,

  /**
   * L
   */
  L: 76,

  /**
   * M
   */
  M: 77,

  /**
   * N
   */
  N: 78,

  /**
   * O
   */
  O: 79,

  /**
   * P
   */
  P: 80,

  /**
   * Q
   */
  Q: 81,

  /**
   * R
   */
  R: 82,

  /**
   * S
   */
  S: 83,

  /**
   * T
   */
  T: 84,

  /**
   * U
   */
  U: 85,

  /**
   * V
   */
  V: 86,

  /**
   * W
   */
  W: 87,

  /**
   * X
   */
  X: 88,

  /**
   * Y
   */
  Y: 89,

  /**
   * Z
   */
  Z: 90,

  /**
   * META
   */
  META: 91,

  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,

  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,

  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,

  /**
   * NUM_ONE
   */
  NUM_ONE: 97,

  /**
   * NUM_TWO
   */
  NUM_TWO: 98,

  /**
   * NUM_THREE
   */
  NUM_THREE: 99,

  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,

  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,

  /**
   * NUM_SIX
   */
  NUM_SIX: 102,

  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,

  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,

  /**
   * NUM_NINE
   */
  NUM_NINE: 105,

  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,

  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,

  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,

  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,

  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,

  /**
   * F1
   */
  F1: 112,

  /**
   * F2
   */
  F2: 113,

  /**
   * F3
   */
  F3: 114,

  /**
   * F4
   */
  F4: 115,

  /**
   * F5
   */
  F5: 116,

  /**
   * F6
   */
  F6: 117,

  /**
   * F7
   */
  F7: 118,

  /**
   * F8
   */
  F8: 119,

  /**
   * F9
   */
  F9: 120,

  /**
   * F10
   */
  F10: 121,

  /**
   * F11
   */
  F11: 122,

  /**
   * F12
   */
  F12: 123,

  /**
   * NUMLOCK
   */
  NUMLOCK: 144,

  /**
   * SEMICOLON
   */
  SEMICOLON: 186,

  /**
   * DASH
   */
  DASH: 189,

  /**
   * EQUALS
   */
  EQUALS: 187,

  /**
   * COMMA
   */
  COMMA: 188,

  /**
   * PERIOD
   */
  PERIOD: 190,

  /**
   * SLASH
   */
  SLASH: 191,

  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,

  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,

  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,

  /**
   * BACKSLASH
   */
  BACKSLASH: 220,

  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,

  /**
   * WIN_KEY
   */
  WIN_KEY: 224,

  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,

  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================

  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;

    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    } // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.


    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;

      default:
        return true;
    }
  },

  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }

    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }

    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    } // Safari sends zero key code for non-latin characters.


    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }

    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;

      default:
        return false;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (KeyCode);

/***/ }),
/* 132 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(63)) {
  var LIBRARY = __webpack_require__(144);
  var global = __webpack_require__(49);
  var fails = __webpack_require__(51);
  var $export = __webpack_require__(15);
  var $typed = __webpack_require__(283);
  var $buffer = __webpack_require__(395);
  var ctx = __webpack_require__(103);
  var anInstance = __webpack_require__(167);
  var propertyDesc = __webpack_require__(160);
  var hide = __webpack_require__(90);
  var redefineAll = __webpack_require__(169);
  var toInteger = __webpack_require__(105);
  var toLength = __webpack_require__(58);
  var toIndex = __webpack_require__(569);
  var toAbsoluteIndex = __webpack_require__(163);
  var toPrimitive = __webpack_require__(117);
  var has = __webpack_require__(94);
  var classof = __webpack_require__(199);
  var isObject = __webpack_require__(52);
  var toObject = __webpack_require__(70);
  var isArrayIter = __webpack_require__(384);
  var create = __webpack_require__(164);
  var getPrototypeOf = __webpack_require__(97);
  var gOPN = __webpack_require__(165).f;
  var getIterFn = __webpack_require__(386);
  var uid = __webpack_require__(161);
  var wks = __webpack_require__(56);
  var createArrayMethod = __webpack_require__(120);
  var createArrayIncludes = __webpack_require__(273);
  var speciesConstructor = __webpack_require__(230);
  var ArrayIterators = __webpack_require__(389);
  var Iterators = __webpack_require__(201);
  var $iterDetect = __webpack_require__(278);
  var setSpecies = __webpack_require__(166);
  var arrayFill = __webpack_require__(388);
  var arrayCopyWithin = __webpack_require__(558);
  var $DP = __webpack_require__(66);
  var $GOPD = __webpack_require__(96);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(564);
var $export = __webpack_require__(15);
var shared = __webpack_require__(226)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(567))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var TYPE_DELIMITER = '.';
var IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
/**
 * Notice, parseClassType('') should returns {main: '', sub: ''}
 * @public
 */

function parseClassType(componentType) {
  var ret = {
    main: '',
    sub: ''
  };

  if (componentType) {
    componentType = componentType.split(TYPE_DELIMITER);
    ret.main = componentType[0] || '';
    ret.sub = componentType[1] || '';
  }

  return ret;
}
/**
 * @public
 */


function checkClassType(componentType) {
  zrUtil.assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
}
/**
 * @public
 */


function enableClassExtend(RootClass, mandatoryMethods) {
  RootClass.$constructor = RootClass;

  RootClass.extend = function (proto) {
    var superClass = this;

    var ExtendedClass = function () {
      if (!proto.$constructor) {
        superClass.apply(this, arguments);
      } else {
        proto.$constructor.apply(this, arguments);
      }
    };

    zrUtil.extend(ExtendedClass.prototype, proto);
    ExtendedClass.extend = this.extend;
    ExtendedClass.superCall = superCall;
    ExtendedClass.superApply = superApply;
    zrUtil.inherits(ExtendedClass, this);
    ExtendedClass.superClass = superClass;
    return ExtendedClass;
  };
}

var classBase = 0;
/**
 * Can not use instanceof, consider different scope by
 * cross domain or es module import in ec extensions.
 * Mount a method "isInstance()" to Clz.
 */

function enableClassCheck(Clz) {
  var classAttr = ['__\0is_clz', classBase++, Math.random().toFixed(3)].join('_');
  Clz.prototype[classAttr] = true;

  Clz.isInstance = function (obj) {
    return !!(obj && obj[classAttr]);
  };
} // superCall should have class info, which can not be fetch from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, do not overrides method f,
// then when method of class C is called, dead loop occured.


function superCall(context, methodName) {
  var args = zrUtil.slice(arguments, 2);
  return this.superClass.prototype[methodName].apply(context, args);
}

function superApply(context, methodName, args) {
  return this.superClass.prototype[methodName].apply(context, args);
}
/**
 * @param {Object} entity
 * @param {Object} options
 * @param {boolean} [options.registerWhenExtend]
 * @public
 */


function enableClassManagement(entity, options) {
  options = options || {};
  /**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'xxx'
   *     or Object.<subKey, componentClass>, when componentType is 'xxx.yy'
   * @type {Object}
   */

  var storage = {};

  entity.registerClass = function (Clazz, componentType) {
    if (componentType) {
      checkClassType(componentType);
      componentType = parseClassType(componentType);

      if (!componentType.sub) {
        storage[componentType.main] = Clazz;
      } else if (componentType.sub !== IS_CONTAINER) {
        var container = makeContainer(componentType);
        container[componentType.sub] = Clazz;
      }
    }

    return Clazz;
  };

  entity.getClass = function (componentMainType, subType, throwWhenNotFound) {
    var Clazz = storage[componentMainType];

    if (Clazz && Clazz[IS_CONTAINER]) {
      Clazz = subType ? Clazz[subType] : null;
    }

    if (throwWhenNotFound && !Clazz) {
      throw new Error(!subType ? componentMainType + '.' + 'type should be specified.' : 'Component ' + componentMainType + '.' + (subType || '') + ' not exists. Load it first.');
    }

    return Clazz;
  };

  entity.getClassesByMainType = function (componentType) {
    componentType = parseClassType(componentType);
    var result = [];
    var obj = storage[componentType.main];

    if (obj && obj[IS_CONTAINER]) {
      zrUtil.each(obj, function (o, type) {
        type !== IS_CONTAINER && result.push(o);
      });
    } else {
      result.push(obj);
    }

    return result;
  };

  entity.hasClass = function (componentType) {
    // Just consider componentType.main.
    componentType = parseClassType(componentType);
    return !!storage[componentType.main];
  };
  /**
   * @return {Array.<string>} Like ['aa', 'bb'], but can not be ['aa.xx']
   */


  entity.getAllClassMainTypes = function () {
    var types = [];
    zrUtil.each(storage, function (obj, type) {
      types.push(type);
    });
    return types;
  };
  /**
   * If a main type is container and has sub types
   * @param  {string}  mainType
   * @return {boolean}
   */


  entity.hasSubTypes = function (componentType) {
    componentType = parseClassType(componentType);
    var obj = storage[componentType.main];
    return obj && obj[IS_CONTAINER];
  };

  entity.parseClassType = parseClassType;

  function makeContainer(componentType) {
    var container = storage[componentType.main];

    if (!container || !container[IS_CONTAINER]) {
      container = storage[componentType.main] = {};
      container[IS_CONTAINER] = true;
    }

    return container;
  }

  if (options.registerWhenExtend) {
    var originalExtend = entity.extend;

    if (originalExtend) {
      entity.extend = function (proto) {
        var ExtendedClass = originalExtend.call(this, proto);
        return entity.registerClass(ExtendedClass, proto.type);
      };
    }
  }

  return entity;
}
/**
 * @param {string|Array.<string>} properties
 */


function setReadOnly(obj, properties) {// FIXME It seems broken in IE8 simulation of IE11
  // if (!zrUtil.isArray(properties)) {
  //     properties = properties != null ? [properties] : [];
  // }
  // zrUtil.each(properties, function (prop) {
  //     var value = obj[prop];
  //     Object.defineProperty
  //         && Object.defineProperty(obj, prop, {
  //             value: value, writable: false
  //         });
  //     zrUtil.isArray(obj[prop])
  //         && Object.freeze
  //         && Object.freeze(obj[prop]);
  // });
}

exports.parseClassType = parseClassType;
exports.enableClassExtend = enableClassExtend;
exports.enableClassCheck = enableClassCheck;
exports.enableClassManagement = enableClassManagement;
exports.setReadOnly = setReadOnly;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var _model = __webpack_require__(44);

var makeInner = _model.makeInner;
var getDataItemValue = _model.getDataItemValue;

var _util = __webpack_require__(1);

var createHashMap = _util.createHashMap;
var each = _util.each;
var map = _util.map;
var isArray = _util.isArray;
var isString = _util.isString;
var isObject = _util.isObject;
var isTypedArray = _util.isTypedArray;
var isArrayLike = _util.isArrayLike;
var extend = _util.extend;
var assert = _util.assert;

var Source = __webpack_require__(236);

var _sourceType = __webpack_require__(237);

var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
var SOURCE_FORMAT_ARRAY_ROWS = _sourceType.SOURCE_FORMAT_ARRAY_ROWS;
var SOURCE_FORMAT_OBJECT_ROWS = _sourceType.SOURCE_FORMAT_OBJECT_ROWS;
var SOURCE_FORMAT_KEYED_COLUMNS = _sourceType.SOURCE_FORMAT_KEYED_COLUMNS;
var SOURCE_FORMAT_UNKNOWN = _sourceType.SOURCE_FORMAT_UNKNOWN;
var SOURCE_FORMAT_TYPED_ARRAY = _sourceType.SOURCE_FORMAT_TYPED_ARRAY;
var SERIES_LAYOUT_BY_ROW = _sourceType.SERIES_LAYOUT_BY_ROW;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// The result of `guessOrdinal`.
var BE_ORDINAL = {
  Must: 1,
  // Encounter string but not '-' and not number-like.
  Might: 2,
  // Encounter string but number-like.
  Not: 3 // Other cases

};
var inner = makeInner();
/**
 * @see {module:echarts/data/Source}
 * @param {module:echarts/component/dataset/DatasetModel} datasetModel
 * @return {string} sourceFormat
 */

function detectSourceFormat(datasetModel) {
  var data = datasetModel.option.source;
  var sourceFormat = SOURCE_FORMAT_UNKNOWN;

  if (isTypedArray(data)) {
    sourceFormat = SOURCE_FORMAT_TYPED_ARRAY;
  } else if (isArray(data)) {
    // FIXME Whether tolerate null in top level array?
    if (data.length === 0) {
      sourceFormat = SOURCE_FORMAT_ARRAY_ROWS;
    }

    for (var i = 0, len = data.length; i < len; i++) {
      var item = data[i];

      if (item == null) {
        continue;
      } else if (isArray(item)) {
        sourceFormat = SOURCE_FORMAT_ARRAY_ROWS;
        break;
      } else if (isObject(item)) {
        sourceFormat = SOURCE_FORMAT_OBJECT_ROWS;
        break;
      }
    }
  } else if (isObject(data)) {
    for (var key in data) {
      if (data.hasOwnProperty(key) && isArrayLike(data[key])) {
        sourceFormat = SOURCE_FORMAT_KEYED_COLUMNS;
        break;
      }
    }
  } else if (data != null) {
    throw new Error('Invalid data');
  }

  inner(datasetModel).sourceFormat = sourceFormat;
}
/**
 * [Scenarios]:
 * (1) Provide source data directly:
 *     series: {
 *         encode: {...},
 *         dimensions: [...]
 *         seriesLayoutBy: 'row',
 *         data: [[...]]
 *     }
 * (2) Refer to datasetModel.
 *     series: [{
 *         encode: {...}
 *         // Ignore datasetIndex means `datasetIndex: 0`
 *         // and the dimensions defination in dataset is used
 *     }, {
 *         encode: {...},
 *         seriesLayoutBy: 'column',
 *         datasetIndex: 1
 *     }]
 *
 * Get data from series itself or datset.
 * @return {module:echarts/data/Source} source
 */


function getSource(seriesModel) {
  return inner(seriesModel).source;
}
/**
 * MUST be called before mergeOption of all series.
 * @param {module:echarts/model/Global} ecModel
 */


function resetSourceDefaulter(ecModel) {
  // `datasetMap` is used to make default encode.
  inner(ecModel).datasetMap = createHashMap();
}
/**
 * [Caution]:
 * MUST be called after series option merged and
 * before "series.getInitailData()" called.
 *
 * [The rule of making default encode]:
 * Category axis (if exists) alway map to the first dimension.
 * Each other axis occupies a subsequent dimension.
 *
 * [Why make default encode]:
 * Simplify the typing of encode in option, avoiding the case like that:
 * series: [{encode: {x: 0, y: 1}}, {encode: {x: 0, y: 2}}, {encode: {x: 0, y: 3}}],
 * where the "y" have to be manually typed as "1, 2, 3, ...".
 *
 * @param {module:echarts/model/Series} seriesModel
 */


function prepareSource(seriesModel) {
  var seriesOption = seriesModel.option;
  var data = seriesOption.data;
  var sourceFormat = isTypedArray(data) ? SOURCE_FORMAT_TYPED_ARRAY : SOURCE_FORMAT_ORIGINAL;
  var fromDataset = false;
  var seriesLayoutBy = seriesOption.seriesLayoutBy;
  var sourceHeader = seriesOption.sourceHeader;
  var dimensionsDefine = seriesOption.dimensions;
  var datasetModel = getDatasetModel(seriesModel);

  if (datasetModel) {
    var datasetOption = datasetModel.option;
    data = datasetOption.source;
    sourceFormat = inner(datasetModel).sourceFormat;
    fromDataset = true; // These settings from series has higher priority.

    seriesLayoutBy = seriesLayoutBy || datasetOption.seriesLayoutBy;
    sourceHeader == null && (sourceHeader = datasetOption.sourceHeader);
    dimensionsDefine = dimensionsDefine || datasetOption.dimensions;
  }

  var completeResult = completeBySourceData(data, sourceFormat, seriesLayoutBy, sourceHeader, dimensionsDefine);
  inner(seriesModel).source = new Source({
    data: data,
    fromDataset: fromDataset,
    seriesLayoutBy: seriesLayoutBy,
    sourceFormat: sourceFormat,
    dimensionsDefine: completeResult.dimensionsDefine,
    startIndex: completeResult.startIndex,
    dimensionsDetectCount: completeResult.dimensionsDetectCount,
    // Note: dataset option does not have `encode`.
    encodeDefine: seriesOption.encode
  });
} // return {startIndex, dimensionsDefine, dimensionsCount}


function completeBySourceData(data, sourceFormat, seriesLayoutBy, sourceHeader, dimensionsDefine) {
  if (!data) {
    return {
      dimensionsDefine: normalizeDimensionsDefine(dimensionsDefine)
    };
  }

  var dimensionsDetectCount;
  var startIndex;

  if (sourceFormat === SOURCE_FORMAT_ARRAY_ROWS) {
    // Rule: Most of the first line are string: it is header.
    // Caution: consider a line with 5 string and 1 number,
    // it still can not be sure it is a head, because the
    // 5 string may be 5 values of category columns.
    if (sourceHeader === 'auto' || sourceHeader == null) {
      arrayRowsTravelFirst(function (val) {
        // '-' is regarded as null/undefined.
        if (val != null && val !== '-') {
          if (isString(val)) {
            startIndex == null && (startIndex = 1);
          } else {
            startIndex = 0;
          }
        } // 10 is an experience number, avoid long loop.

      }, seriesLayoutBy, data, 10);
    } else {
      startIndex = sourceHeader ? 1 : 0;
    }

    if (!dimensionsDefine && startIndex === 1) {
      dimensionsDefine = [];
      arrayRowsTravelFirst(function (val, index) {
        dimensionsDefine[index] = val != null ? val : '';
      }, seriesLayoutBy, data);
    }

    dimensionsDetectCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === SERIES_LAYOUT_BY_ROW ? data.length : data[0] ? data[0].length : null;
  } else if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS) {
    if (!dimensionsDefine) {
      dimensionsDefine = objectRowsCollectDimensions(data);
    }
  } else if (sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
    if (!dimensionsDefine) {
      dimensionsDefine = [];
      each(data, function (colArr, key) {
        dimensionsDefine.push(key);
      });
    }
  } else if (sourceFormat === SOURCE_FORMAT_ORIGINAL) {
    var value0 = getDataItemValue(data[0]);
    dimensionsDetectCount = isArray(value0) && value0.length || 1;
  } else if (sourceFormat === SOURCE_FORMAT_TYPED_ARRAY) {}

  return {
    startIndex: startIndex,
    dimensionsDefine: normalizeDimensionsDefine(dimensionsDefine),
    dimensionsDetectCount: dimensionsDetectCount
  };
} // Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
// which is reasonable. But dimension name is duplicated.
// Returns undefined or an array contains only object without null/undefiend or string.


function normalizeDimensionsDefine(dimensionsDefine) {
  if (!dimensionsDefine) {
    // The meaning of null/undefined is different from empty array.
    return;
  }

  var nameMap = createHashMap();
  return map(dimensionsDefine, function (item, index) {
    item = extend({}, isObject(item) ? item : {
      name: item
    }); // User can set null in dimensions.
    // We dont auto specify name, othewise a given name may
    // cause it be refered unexpectedly.

    if (item.name == null) {
      return item;
    } // Also consider number form like 2012.


    item.name += ''; // User may also specify displayName.
    // displayName will always exists except user not
    // specified or dim name is not specified or detected.
    // (A auto generated dim name will not be used as
    // displayName).

    if (item.displayName == null) {
      item.displayName = item.name;
    }

    var exist = nameMap.get(item.name);

    if (!exist) {
      nameMap.set(item.name, {
        count: 1
      });
    } else {
      item.name += '-' + exist.count++;
    }

    return item;
  });
}

function arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
  maxLoop == null && (maxLoop = Infinity);

  if (seriesLayoutBy === SERIES_LAYOUT_BY_ROW) {
    for (var i = 0; i < data.length && i < maxLoop; i++) {
      cb(data[i] ? data[i][0] : null, i);
    }
  } else {
    var value0 = data[0] || [];

    for (var i = 0; i < value0.length && i < maxLoop; i++) {
      cb(value0[i], i);
    }
  }
}

function objectRowsCollectDimensions(data) {
  var firstIndex = 0;
  var obj;

  while (firstIndex < data.length && !(obj = data[firstIndex++])) {} // jshint ignore: line


  if (obj) {
    var dimensions = [];
    each(obj, function (value, key) {
      dimensions.push(key);
    });
    return dimensions;
  }
}
/**
 * [The strategy of the arrengment of data dimensions for dataset]:
 * "value way": all axes are non-category axes. So series one by one take
 *     several (the number is coordSysDims.length) dimensions from dataset.
 *     The result of data arrengment of data dimensions like:
 *     | ser0_x | ser0_y | ser1_x | ser1_y | ser2_x | ser2_y |
 * "category way": at least one axis is category axis. So the the first data
 *     dimension is always mapped to the first category axis and shared by
 *     all of the series. The other data dimensions are taken by series like
 *     "value way" does.
 *     The result of data arrengment of data dimensions like:
 *     | ser_shared_x | ser0_y | ser1_y | ser2_y |
 *
 * @param {Array.<Object|string>} coordDimensions [{name: <string>, type: <string>, dimsDef: <Array>}, ...]
 * @param {module:model/Series} seriesModel
 * @param {module:data/Source} source
 * @return {Object} encode Never be `null/undefined`.
 */


function makeSeriesEncodeForAxisCoordSys(coordDimensions, seriesModel, source) {
  var encode = {};
  var datasetModel = getDatasetModel(seriesModel); // Currently only make default when using dataset, util more reqirements occur.

  if (!datasetModel || !coordDimensions) {
    return encode;
  }

  var encodeItemName = [];
  var encodeSeriesName = [];
  var ecModel = seriesModel.ecModel;
  var datasetMap = inner(ecModel).datasetMap;
  var key = datasetModel.uid + '_' + source.seriesLayoutBy;
  var baseCategoryDimIndex;
  var categoryWayValueDimStart;
  coordDimensions = coordDimensions.slice();
  each(coordDimensions, function (coordDimInfo, coordDimIdx) {
    !isObject(coordDimInfo) && (coordDimensions[coordDimIdx] = {
      name: coordDimInfo
    });

    if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
      baseCategoryDimIndex = coordDimIdx;
      categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimensions[coordDimIdx]);
    }

    encode[coordDimInfo.name] = [];
  });
  var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
    categoryWayDim: categoryWayValueDimStart,
    valueWayDim: 0
  }); // TODO
  // Auto detect first time axis and do arrangement.

  each(coordDimensions, function (coordDimInfo, coordDimIdx) {
    var coordDimName = coordDimInfo.name;
    var count = getDataDimCountOnCoordDim(coordDimInfo); // In value way.

    if (baseCategoryDimIndex == null) {
      var start = datasetRecord.valueWayDim;
      pushDim(encode[coordDimName], start, count);
      pushDim(encodeSeriesName, start, count);
      datasetRecord.valueWayDim += count; // ??? TODO give a better default series name rule?
      // especially when encode x y specified.
      // consider: when mutiple series share one dimension
      // category axis, series name should better use
      // the other dimsion name. On the other hand, use
      // both dimensions name.
    } // In category way, the first category axis.
    else if (baseCategoryDimIndex === coordDimIdx) {
        pushDim(encode[coordDimName], 0, count);
        pushDim(encodeItemName, 0, count);
      } // In category way, the other axis.
      else {
          var start = datasetRecord.categoryWayDim;
          pushDim(encode[coordDimName], start, count);
          pushDim(encodeSeriesName, start, count);
          datasetRecord.categoryWayDim += count;
        }
  });

  function pushDim(dimIdxArr, idxFrom, idxCount) {
    for (var i = 0; i < idxCount; i++) {
      dimIdxArr.push(idxFrom + i);
    }
  }

  function getDataDimCountOnCoordDim(coordDimInfo) {
    var dimsDef = coordDimInfo.dimsDef;
    return dimsDef ? dimsDef.length : 1;
  }

  encodeItemName.length && (encode.itemName = encodeItemName);
  encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
  return encode;
}
/**
 * Work for data like [{name: ..., value: ...}, ...].
 *
 * @param {module:model/Series} seriesModel
 * @param {module:data/Source} source
 * @return {Object} encode Never be `null/undefined`.
 */


function makeSeriesEncodeForNameBased(seriesModel, source, dimCount) {
  var encode = {};
  var datasetModel = getDatasetModel(seriesModel); // Currently only make default when using dataset, util more reqirements occur.

  if (!datasetModel) {
    return encode;
  }

  var sourceFormat = source.sourceFormat;
  var dimensionsDefine = source.dimensionsDefine;
  var potentialNameDimIndex;

  if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS || sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
    each(dimensionsDefine, function (dim, idx) {
      if ((isObject(dim) ? dim.name : dim) === 'name') {
        potentialNameDimIndex = idx;
      }
    });
  } // idxResult: {v, n}.


  var idxResult = function () {
    var idxRes0 = {};
    var idxRes1 = {};
    var guessRecords = []; // 5 is an experience value.

    for (var i = 0, len = Math.min(5, dimCount); i < len; i++) {
      var guessResult = doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
      guessRecords.push(guessResult);
      var isPureNumber = guessResult === BE_ORDINAL.Not; // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
      // and then find a name dim with the priority:
      // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".

      if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) {
        idxRes0.v = i;
      }

      if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === BE_ORDINAL.Not) {
        idxRes0.n = i;
      }

      if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== BE_ORDINAL.Not) {
        return idxRes0;
      } // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
      // find the first BE_ORDINAL.Might as the value dim,
      // and then find a name dim with the priority:
      // "other dim" > "the value dim itself".
      // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
      // treated as number.


      if (!isPureNumber) {
        if (guessResult === BE_ORDINAL.Might && idxRes1.v == null && i !== potentialNameDimIndex) {
          idxRes1.v = i;
        }

        if (idxRes1.n == null || idxRes1.n === idxRes1.v) {
          idxRes1.n = i;
        }
      }
    }

    function fulfilled(idxResult) {
      return idxResult.v != null && idxResult.n != null;
    }

    return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
  }();

  if (idxResult) {
    encode.value = idxResult.v; // `potentialNameDimIndex` has highest priority.

    var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n; // By default, label use itemName in charts.
    // So we dont set encodeLabel here.

    encode.itemName = [nameDimIndex];
    encode.seriesName = [nameDimIndex];
  }

  return encode;
}
/**
 * If return null/undefined, indicate that should not use datasetModel.
 */


function getDatasetModel(seriesModel) {
  var option = seriesModel.option; // Caution: consider the scenario:
  // A dataset is declared and a series is not expected to use the dataset,
  // and at the beginning `setOption({series: { noData })` (just prepare other
  // option but no data), then `setOption({series: {data: [...]}); In this case,
  // the user should set an empty array to avoid that dataset is used by default.

  var thisData = option.data;

  if (!thisData) {
    return seriesModel.ecModel.getComponent('dataset', option.datasetIndex || 0);
  }
}
/**
 * The rule should not be complex, otherwise user might not
 * be able to known where the data is wrong.
 * The code is ugly, but how to make it neat?
 *
 * @param {module:echars/data/Source} source
 * @param {number} dimIndex
 * @return {BE_ORDINAL} guess result.
 */


function guessOrdinal(source, dimIndex) {
  return doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
} // dimIndex may be overflow source data.
// return {BE_ORDINAL}


function doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
  var result; // Experience value.

  var maxLoop = 5;

  if (isTypedArray(data)) {
    return BE_ORDINAL.Not;
  } // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
  // always exists in source.


  var dimName;
  var dimType;

  if (dimensionsDefine) {
    var dimDefItem = dimensionsDefine[dimIndex];

    if (isObject(dimDefItem)) {
      dimName = dimDefItem.name;
      dimType = dimDefItem.type;
    } else if (isString(dimDefItem)) {
      dimName = dimDefItem;
    }
  }

  if (dimType != null) {
    return dimType === 'ordinal' ? BE_ORDINAL.Must : BE_ORDINAL.Not;
  }

  if (sourceFormat === SOURCE_FORMAT_ARRAY_ROWS) {
    if (seriesLayoutBy === SERIES_LAYOUT_BY_ROW) {
      var sample = data[dimIndex];

      for (var i = 0; i < (sample || []).length && i < maxLoop; i++) {
        if ((result = detectValue(sample[startIndex + i])) != null) {
          return result;
        }
      }
    } else {
      for (var i = 0; i < data.length && i < maxLoop; i++) {
        var row = data[startIndex + i];

        if (row && (result = detectValue(row[dimIndex])) != null) {
          return result;
        }
      }
    }
  } else if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS) {
    if (!dimName) {
      return BE_ORDINAL.Not;
    }

    for (var i = 0; i < data.length && i < maxLoop; i++) {
      var item = data[i];

      if (item && (result = detectValue(item[dimName])) != null) {
        return result;
      }
    }
  } else if (sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
    if (!dimName) {
      return BE_ORDINAL.Not;
    }

    var sample = data[dimName];

    if (!sample || isTypedArray(sample)) {
      return BE_ORDINAL.Not;
    }

    for (var i = 0; i < sample.length && i < maxLoop; i++) {
      if ((result = detectValue(sample[i])) != null) {
        return result;
      }
    }
  } else if (sourceFormat === SOURCE_FORMAT_ORIGINAL) {
    for (var i = 0; i < data.length && i < maxLoop; i++) {
      var item = data[i];
      var val = getDataItemValue(item);

      if (!isArray(val)) {
        return BE_ORDINAL.Not;
      }

      if ((result = detectValue(val[dimIndex])) != null) {
        return result;
      }
    }
  }

  function detectValue(val) {
    var beStr = isString(val); // Consider usage convenience, '1', '2' will be treated as "number".
    // `isFinit('')` get `true`.

    if (val != null && isFinite(val) && val !== '') {
      return beStr ? BE_ORDINAL.Might : BE_ORDINAL.Not;
    } else if (beStr && val !== '-') {
      return BE_ORDINAL.Must;
    }
  }

  return BE_ORDINAL.Not;
}

exports.BE_ORDINAL = BE_ORDINAL;
exports.detectSourceFormat = detectSourceFormat;
exports.getSource = getSource;
exports.resetSourceDefaulter = resetSourceDefaulter;
exports.prepareSource = prepareSource;
exports.makeSeriesEncodeForAxisCoordSys = makeSeriesEncodeForAxisCoordSys;
exports.makeSeriesEncodeForNameBased = makeSeriesEncodeForNameBased;
exports.guessOrdinal = guessOrdinal;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var List = __webpack_require__(98);

var createDimensions = __webpack_require__(207);

var _sourceType = __webpack_require__(237);

var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;

var _dimensionHelper = __webpack_require__(238);

var getDimensionTypeByAxis = _dimensionHelper.getDimensionTypeByAxis;

var _model = __webpack_require__(44);

var getDataItemValue = _model.getDataItemValue;

var CoordinateSystem = __webpack_require__(108);

var _referHelper = __webpack_require__(1568);

var getCoordSysInfoBySeries = _referHelper.getCoordSysInfoBySeries;

var Source = __webpack_require__(236);

var _dataStackHelper = __webpack_require__(124);

var enableDataStack = _dataStackHelper.enableDataStack;

var _sourceHelper = __webpack_require__(136);

var makeSeriesEncodeForAxisCoordSys = _sourceHelper.makeSeriesEncodeForAxisCoordSys;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @param {module:echarts/data/Source|Array} source Or raw data.
 * @param {module:echarts/model/Series} seriesModel
 * @param {Object} [opt]
 * @param {string} [opt.generateCoord]
 * @param {boolean} [opt.useEncodeDefaulter]
 */
function createListFromArray(source, seriesModel, opt) {
  opt = opt || {};

  if (!Source.isInstance(source)) {
    source = Source.seriesDataToSource(source);
  }

  var coordSysName = seriesModel.get('coordinateSystem');
  var registeredCoordSys = CoordinateSystem.get(coordSysName);
  var coordSysInfo = getCoordSysInfoBySeries(seriesModel);
  var coordSysDimDefs;

  if (coordSysInfo) {
    coordSysDimDefs = zrUtil.map(coordSysInfo.coordSysDims, function (dim) {
      var dimInfo = {
        name: dim
      };
      var axisModel = coordSysInfo.axisMap.get(dim);

      if (axisModel) {
        var axisType = axisModel.get('type');
        dimInfo.type = getDimensionTypeByAxis(axisType); // dimInfo.stackable = isStackable(axisType);
      }

      return dimInfo;
    });
  }

  if (!coordSysDimDefs) {
    // Get dimensions from registered coordinate system
    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || ['x', 'y'];
  }

  var dimInfoList = createDimensions(source, {
    coordDimensions: coordSysDimDefs,
    generateCoord: opt.generateCoord,
    encodeDefaulter: opt.useEncodeDefaulter ? zrUtil.curry(makeSeriesEncodeForAxisCoordSys, coordSysDimDefs, seriesModel) : null
  });
  var firstCategoryDimIndex;
  var hasNameEncode;
  coordSysInfo && zrUtil.each(dimInfoList, function (dimInfo, dimIndex) {
    var coordDim = dimInfo.coordDim;
    var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);

    if (categoryAxisModel) {
      if (firstCategoryDimIndex == null) {
        firstCategoryDimIndex = dimIndex;
      }

      dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
    }

    if (dimInfo.otherDims.itemName != null) {
      hasNameEncode = true;
    }
  });

  if (!hasNameEncode && firstCategoryDimIndex != null) {
    dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
  }

  var stackCalculationInfo = enableDataStack(seriesModel, dimInfoList);
  var list = new List(dimInfoList, seriesModel);
  list.setCalculationInfo(stackCalculationInfo);
  var dimValueGetter = firstCategoryDimIndex != null && isNeedCompleteOrdinalData(source) ? function (itemOpt, dimName, dataIndex, dimIndex) {
    // Use dataIndex as ordinal value in categoryAxis
    return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
  } : null;
  list.hasItemOption = false;
  list.initData(source, null, dimValueGetter);
  return list;
}

function isNeedCompleteOrdinalData(source) {
  if (source.sourceFormat === SOURCE_FORMAT_ORIGINAL) {
    var sampleItem = firstDataNotNull(source.data || []);
    return sampleItem != null && !zrUtil.isArray(getDataItemValue(sampleItem));
  }
}

function firstDataNotNull(data) {
  var i = 0;

  while (i < data.length && data[i] == null) {
    i++;
  }

  return data[i];
}

var _default = createListFromArray;
module.exports = _default;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.data=exports.data2=exports.data1=exports.columns8=exports.columns7=exports.columns6=exports.columns5=exports.columns4=exports.columns3=exports.columns2=exports.columns1=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var columns1=exports.columns1=function columns1(print){return[{title:_react2.default.createElement("div",null,"Key Performance Indicator ",_react2.default.createElement("br",null)," \u9910\u996E\u5173\u952E\u7EE9\u6548\u6307\u6570"),dataIndex:'name',key:'name',align:"center",width:200,fixed:print?false:"left",render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"F&Brevenue ",_react2.default.createElement("br",null)," \u9910\u996E\u6536\u5165"),dataIndex:'fb',key:'fb',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"fb"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"F&B Revenue/ Total Revenue % ",_react2.default.createElement("br",null)," \u9910\u996E\u6536\u5165\u5360\u9152\u5E97\u603B\u6536\u5165%"),dataIndex:'fb_prop',key:'fb_prop',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"fb_prop"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"A/C ",_react2.default.createElement("br",null)," \u4EBA\u5747\u6D88\u8D39"),dataIndex:'ac',key:'ac',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"ac"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Covers ",_react2.default.createElement("br",null)," \u7528\u9910\u603B\u4EBA\u6570"),dataIndex:'covers',key:'covers',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"covers"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"F&B Dep't Profit % ",_react2.default.createElement("br",null),"  \u9910\u996E\u90E8\u95E8\u5229\u6DA6\u7387"),dataIndex:'fb_profit',key:'fb_profit',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"fb_profit"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"F&B Total Payroll and Expenses ",_react2.default.createElement("br",null)," \u9910\u996E\u90E8\u95E8\u85AA\u916C\u53CA\u76F8\u5173\u798F\u5229\u5408\u8BA1%"),dataIndex:'fb_payroll',key:'fb_payroll',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"fb_payroll"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Total Cost of Food and Beverage Sales % ",_react2.default.createElement("br",null)," \u9910\u996E\u6210\u672C\u5360\u90E8\u95E8\u6536\u5165\u767E\u5206\u6BD4"),dataIndex:'fb_sales',key:'fb_sales',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"fb_sales"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"F&Brevenue ",_react2.default.createElement("br",null)," \u9910\u996E\u6536\u5165"),dataIndex:'fb_last',key:'fb_last',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"fb_last"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Vs2019/预算",dataIndex:'fb_vs',key:'fb_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"fb_vs"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"F&B Revenue/ Total Revenue % ",_react2.default.createElement("br",null)," \u9910\u996E\u6536\u5165\u5360\u9152\u5E97\u603B\u6536\u5165%"),dataIndex:'fb_prop_last',key:'fb_prop_last',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"fb_prop_last"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Vs2019/预算",dataIndex:'fb_prop_vs',key:'fb_prop_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"fb_prop_vs"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"A/C ",_react2.default.createElement("br",null)," \u4EBA\u5747\u6D88\u8D39"),dataIndex:'ac_last',key:'ac_last',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"ac_last"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Vs2019/预算",dataIndex:'ac_vs',key:'ac_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"ac_vs"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Covers 用餐总人数",dataIndex:'covers_last',key:'covers_last',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"covers_last"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Vs2019/预算",dataIndex:'covers_vs',key:'covers_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"covers_vs"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"F&B Dep't Profit % ",_react2.default.createElement("br",null),"\u9910\u996E\u90E8\u95E8\u5229\u6DA6\u7387"),dataIndex:'fb_profit_last',key:'fb_profit_last',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"fb_profit_last"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Vs2019/预算",dataIndex:'fb_profit_vs',key:'fb_profit_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"fb_profit_vs"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"F&B Total Payroll and Expenses ",_react2.default.createElement("br",null)," \u9910\u996E\u90E8\u95E8\u85AA\u916C\u53CA\u76F8\u5173\u798F\u5229\u5408\u8BA1%"),dataIndex:'fb_payroll_last',key:'fb_payroll_last',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"fb_payroll_last"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Vs2019/预算",dataIndex:'fb_payroll_vs',key:'fb_payroll_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"fb_payroll_vs"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Total Cost of Food and Beverage Sales % ",_react2.default.createElement("br",null)," \u9910\u996E\u6210\u672C\u5360\u90E8\u95E8\u6536\u5165\u767E\u5206\u6BD4"),dataIndex:'fb_sales_last',key:'fb_sales_last',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"fb_sales_last"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Vs2019/预算",dataIndex:'fb_sales_vs',key:'fb_sales_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"fb_sales_vs"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];};var columns2=exports.columns2=function columns2(){return[{title:_react2.default.createElement("div",null,"Banquet Revenue ",_react2.default.createElement("br",null),"  \u5BB4\u4F1A\u6536\u5165"),dataIndex:'rev',key:'rev',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"rev",totalIndex:[0,2]};if(index==0||index==2){return{props:{colSpan:5},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:index==0?"YTD-Actual年累计实际":'MTD-Actual月累计实际'})})};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Revenue Mix ",_react2.default.createElement("br",null),"  \u6536\u5165\u4EFD\u989D% "),dataIndex:'mix',key:'mix',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"mix",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"A/C \u4EBA\u5747\u6D88\u8D39"),dataIndex:'ac',key:'ac',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"ac",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Cost% ",_react2.default.createElement("br",null),"\u6210\u672C\u767E\u5206\u6BD4"),dataIndex:'cost',key:'cost',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"mix",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Covers \u7528\u9910\u4EBA\u6570"),dataIndex:'covers',key:'covers',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"covers",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Banquet Revenue ",_react2.default.createElement("br",null),"\u5BB4\u4F1A\u6536\u5165"),dataIndex:'brev',key:'brev',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"brev",totalIndex:[0,2]};if(index==0||index==2){return{props:{colSpan:10},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:index==0?"YTD-Actual Vs.Budget 年累计-实际对比预算":'MTD-Actual Vs.Budget 年累计-实际对比预算'})})};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'vs',key:'vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Revenue Mix",_react2.default.createElement("br",null),"\u6536\u5165\u4EFD\u989D%"),dataIndex:'bmix',key:'bmix',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bvs',key:'bvs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"bvs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"A/C \u4EBA\u5747\u6D88\u8D39"),dataIndex:'bac',key:'bac',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bac",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bac_vs',key:'bac_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bac_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Cost% \u6210\u672C\u767E\u5206\u6BD4"),dataIndex:'bcost',key:'bcost',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"bcost",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bcost_vs',key:'bcost_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"bcost_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Covers \u7528\u9910\u4EBA\u6570"),dataIndex:'bcovers',key:'bcovers',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bcovers",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bcovers_vs',key:'bcovers_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bcovers_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Banquet Revenue ",_react2.default.createElement("br",null)," \u5BB4\u4F1A\u6536\u5165"),dataIndex:'last_rev',key:'last_rev',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_rev",totalIndex:[0,2]};if(index==0||index==2){return{props:{colSpan:10},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:index==0?"YTD-Actual Vs.2019 年累计-实际对比2019":'MTD-Actual Vs.2019 年累计-实际对比2019'})})};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_vs',key:'last_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Revenue Mix ",_react2.default.createElement("br",null)," \u6536\u5165\u4EFD\u989D%"),dataIndex:'last_mix',key:'last_mix',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_mix",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_mix_vs',key:'last_mix_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_mix_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"A/C \u4EBA\u5747\u6D88\u8D39"),dataIndex:'last_ac',key:'last_ac',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_ac",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_ac_vs',key:'last_ac_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_ac_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Cost% \u6210\u672C\u767E\u5206\u6BD4"),dataIndex:'last_cost',key:'last_cost',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_cost",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_cost_vs',key:'last_cost_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_cost_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Covers \u7528\u9910\u4EBA\u6570"),dataIndex:'last_covers',key:'last_covers',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_covers",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_covers_vs',key:'last_covers_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_covers_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];};var columns3=exports.columns3=function columns3(){return[{title:_react2.default.createElement("div",null,"Coffee Shop Revenue ",_react2.default.createElement("br",null)," \u5496\u5561\u5385\u6536\u5165"),dataIndex:'rev',key:'rev',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"rev",totalIndex:[0,2]};if(index==0||index==2){return{props:{colSpan:5},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:index==0?"YTD-Actual年累计实际":'MTD-Actual月累计实际'})})};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Revenue Mix ",_react2.default.createElement("br",null),"  \u6536\u5165\u4EFD\u989D% "),dataIndex:'mix',key:'mix',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"mix",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"A/C \u4EBA\u5747\u6D88\u8D39"),dataIndex:'ac',key:'ac',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"ac",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Cost% ",_react2.default.createElement("br",null),"\u6210\u672C\u767E\u5206\u6BD4"),dataIndex:'cost',key:'cost',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"mix",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Covers \u7528\u9910\u4EBA\u6570"),dataIndex:'covers',key:'covers',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"covers",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Coffee Shop Revenue ",_react2.default.createElement("br",null)," \u5496\u5561\u5385\u6536\u5165"),dataIndex:'brev',key:'brev',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"brev",totalIndex:[0,2]};if(index==0||index==2){return{props:{colSpan:10},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:index==0?"YTD-Actual Vs.Budget 年累计-实际对比预算":'MTD-Actual Vs.Budget 年累计-实际对比预算'})})};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'vs',key:'vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Revenue Mix",_react2.default.createElement("br",null),"\u6536\u5165\u4EFD\u989D%"),dataIndex:'bmix',key:'vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bvs',key:'bvs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"bvs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"A/C \u4EBA\u5747\u6D88\u8D39"),dataIndex:'bac',key:'bac',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bac",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bac_vs',key:'bac_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bac_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Cost% \u6210\u672C\u767E\u5206\u6BD4"),dataIndex:'bcost',key:'bcost',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"bcost",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bcost_vs',key:'bcost_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"bcost_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Covers \u7528\u9910\u4EBA\u6570"),dataIndex:'bcovers',key:'bcovers',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bcovers",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bcovers_vs',key:'bcovers_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bcovers_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Coffee Shop Revenue ",_react2.default.createElement("br",null)," \u5496\u5561\u5385\u6536\u5165"),dataIndex:'last_rev',key:'last_rev',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_rev",totalIndex:[0,2]};if(index==0||index==2){return{props:{colSpan:10},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:index==0?"YTD-Actual Vs.2019 年累计-实际对比2019":'MTD-Actual Vs.2019 年累计-实际对比2019'})})};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_vs',key:'last_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Revenue Mix ",_react2.default.createElement("br",null)," \u6536\u5165\u4EFD\u989D%"),dataIndex:'last_mix',key:'last_mix',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_mix",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_mix_vs',key:'last_mix_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_mix_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"A/C \u4EBA\u5747\u6D88\u8D39"),dataIndex:'last_ac',key:'last_ac',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_ac",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_ac_vs',key:'last_ac_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_ac_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Cost% \u6210\u672C\u767E\u5206\u6BD4"),dataIndex:'last_cost',key:'last_cost',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_cost",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_cost_vs',key:'last_cost_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_cost_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Covers \u7528\u9910\u4EBA\u6570"),dataIndex:'last_covers',key:'last_covers',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_covers",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_covers_vs',key:'last_covers_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_covers_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];};var columns4=exports.columns4=function columns4(){return[{title:_react2.default.createElement("div",null,"Chinese RestaurantRevenue ",_react2.default.createElement("br",null),"\u4E2D\u9910\u5385\u6536\u5165"),dataIndex:'rev',key:'rev',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"rev",totalIndex:[0,2]};if(index==0||index==2){return{props:{colSpan:5},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:index==0?"YTD-Actual年累计实际":'MTD-Actual月累计实际'})})};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Revenue Mix ",_react2.default.createElement("br",null),"  \u6536\u5165\u4EFD\u989D% "),dataIndex:'mix',key:'mix',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"mix",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"A/C \u4EBA\u5747\u6D88\u8D39"),dataIndex:'ac',key:'ac',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"ac",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Cost% ",_react2.default.createElement("br",null),"\u6210\u672C\u767E\u5206\u6BD4"),dataIndex:'cost',key:'cost',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"mix",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Covers \u7528\u9910\u4EBA\u6570"),dataIndex:'covers',key:'covers',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"covers",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Chinese RestaurantRevenue ",_react2.default.createElement("br",null),"\u4E2D\u9910\u5385\u6536\u5165"),dataIndex:'brev',key:'brev',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"brev",totalIndex:[0,2]};if(index==0||index==2){return{props:{colSpan:10},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:index==0?"YTD-Actual Vs.Budget 年累计-实际对比预算":'MTD-Actual Vs.Budget 年累计-实际对比预算'})})};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'vs',key:'vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Revenue Mix",_react2.default.createElement("br",null),"\u6536\u5165\u4EFD\u989D%"),dataIndex:'bmix',key:'vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bvs',key:'bvs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"bvs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"A/C \u4EBA\u5747\u6D88\u8D39"),dataIndex:'bac',key:'bac',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bac",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bac_vs',key:'bac_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bac_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Cost% \u6210\u672C\u767E\u5206\u6BD4"),dataIndex:'bcost',key:'bcost',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"bcost",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bcost_vs',key:'bcost_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"bcost_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Covers \u7528\u9910\u4EBA\u6570"),dataIndex:'bcovers',key:'bcovers',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bcovers",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bcovers_vs',key:'bcovers_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bcovers_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Chinese RestaurantRevenue ",_react2.default.createElement("br",null),"\u4E2D\u9910\u5385\u6536\u5165"),dataIndex:'last_rev',key:'last_rev',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_rev",totalIndex:[0,2]};if(index==0||index==2){return{props:{colSpan:10},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:index==0?"YTD-Actual Vs.2019 年累计-实际对比2019":'MTD-Actual Vs.2019 年累计-实际对比2019'})})};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_vs',key:'last_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Revenue Mix ",_react2.default.createElement("br",null)," \u6536\u5165\u4EFD\u989D%"),dataIndex:'last_mix',key:'last_mix',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_mix",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_mix_vs',key:'last_mix_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_mix_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"A/C \u4EBA\u5747\u6D88\u8D39"),dataIndex:'last_ac',key:'last_ac',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_ac",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_ac_vs',key:'last_ac_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_ac_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Cost% \u6210\u672C\u767E\u5206\u6BD4"),dataIndex:'last_cost',key:'last_cost',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_cost",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_cost_vs',key:'last_cost_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_cost_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Covers \u7528\u9910\u4EBA\u6570"),dataIndex:'last_covers',key:'last_covers',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_covers",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_covers_vs',key:'last_covers_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_covers_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];};var columns5=exports.columns5=function columns5(){return[{title:_react2.default.createElement("div",null," Special Restaurant Revenue ",_react2.default.createElement("br",null)," \u7279\u8272\u9910\u5385\u6536\u5165"),dataIndex:'rev',key:'rev',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"rev",totalIndex:[0,2]};if(index==0||index==2){return{props:{colSpan:5},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:index==0?"YTD-Actual年累计实际":'MTD-Actual月累计实际'})})};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Revenue Mix ",_react2.default.createElement("br",null),"  \u6536\u5165\u4EFD\u989D% "),dataIndex:'mix',key:'mix',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"mix",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"A/C \u4EBA\u5747\u6D88\u8D39"),dataIndex:'ac',key:'ac',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"ac",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Cost% ",_react2.default.createElement("br",null),"\u6210\u672C\u767E\u5206\u6BD4"),dataIndex:'cost',key:'cost',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"mix",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Covers \u7528\u9910\u4EBA\u6570"),dataIndex:'covers',key:'covers',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"covers",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null," Special Restaurant Revenue ",_react2.default.createElement("br",null)," \u7279\u8272\u9910\u5385\u6536\u5165"),dataIndex:'brev',key:'brev',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"brev",totalIndex:[0,2]};if(index==0||index==2){return{props:{colSpan:10},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:index==0?"YTD-Actual Vs.Budget 年累计-实际对比预算":'MTD-Actual Vs.Budget 年累计-实际对比预算'})})};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'vs',key:'vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Revenue Mix",_react2.default.createElement("br",null),"\u6536\u5165\u4EFD\u989D%"),dataIndex:'bmix',key:'vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bvs',key:'bvs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"bvs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"A/C \u4EBA\u5747\u6D88\u8D39"),dataIndex:'bac',key:'bac',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bac",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bac_vs',key:'bac_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bac_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Cost% \u6210\u672C\u767E\u5206\u6BD4"),dataIndex:'bcost',key:'bcost',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"bcost",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bcost_vs',key:'bcost_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"bcost_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Covers \u7528\u9910\u4EBA\u6570"),dataIndex:'bcovers',key:'bcovers',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bcovers",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bcovers_vs',key:'bcovers_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bcovers_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null," Special Restaurant Revenue ",_react2.default.createElement("br",null)," \u7279\u8272\u9910\u5385\u6536\u5165"),dataIndex:'last_rev',key:'last_rev',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_rev",totalIndex:[0,2]};if(index==0||index==2){return{props:{colSpan:10},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:index==0?"YTD-Actual Vs.2019 年累计-实际对比2019":'MTD-Actual Vs.2019 年累计-实际对比2019'})})};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_vs',key:'last_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Revenue Mix ",_react2.default.createElement("br",null)," \u6536\u5165\u4EFD\u989D%"),dataIndex:'last_mix',key:'last_mix',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_mix",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_mix_vs',key:'last_mix_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_mix_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"A/C \u4EBA\u5747\u6D88\u8D39"),dataIndex:'last_ac',key:'last_ac',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_ac",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_ac_vs',key:'last_ac_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_ac_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Cost% \u6210\u672C\u767E\u5206\u6BD4"),dataIndex:'last_cost',key:'last_cost',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_cost",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_cost_vs',key:'last_cost_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_cost_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Covers \u7528\u9910\u4EBA\u6570"),dataIndex:'last_covers',key:'last_covers',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_covers",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_covers_vs',key:'last_covers_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_covers_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];};var columns6=exports.columns6=function columns6(){return[{title:_react2.default.createElement("div",null,"Lobby Bar Revenue ",_react2.default.createElement("br",null)," \u5927\u5802\u5427\u6536\u5165"),dataIndex:'rev',key:'rev',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"rev",totalIndex:[0,2]};if(index==0||index==2){return{props:{colSpan:5},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:index==0?"YTD-Actual年累计实际":'MTD-Actual月累计实际'})})};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Revenue Mix ",_react2.default.createElement("br",null),"  \u6536\u5165\u4EFD\u989D% "),dataIndex:'mix',key:'mix',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"mix",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"A/C \u4EBA\u5747\u6D88\u8D39"),dataIndex:'ac',key:'ac',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"ac",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Cost% ",_react2.default.createElement("br",null),"\u6210\u672C\u767E\u5206\u6BD4"),dataIndex:'cost',key:'cost',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"mix",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Covers \u7528\u9910\u4EBA\u6570"),dataIndex:'covers',key:'covers',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"covers",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Lobby Bar Revenue ",_react2.default.createElement("br",null)," \u5927\u5802\u5427\u6536\u5165"),dataIndex:'brev',key:'brev',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"brev",totalIndex:[0,2]};if(index==0||index==2){return{props:{colSpan:10},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:index==0?"YTD-Actual Vs.Budget 年累计-实际对比预算":'MTD-Actual Vs.Budget 年累计-实际对比预算'})})};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'vs',key:'vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Revenue Mix",_react2.default.createElement("br",null),"\u6536\u5165\u4EFD\u989D%"),dataIndex:'bmix',key:'vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bvs',key:'bvs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"bvs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"A/C \u4EBA\u5747\u6D88\u8D39"),dataIndex:'bac',key:'bac',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bac",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bac_vs',key:'bac_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bac_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Cost% \u6210\u672C\u767E\u5206\u6BD4"),dataIndex:'bcost',key:'bcost',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"bcost",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bcost_vs',key:'bcost_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"bcost_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Covers \u7528\u9910\u4EBA\u6570"),dataIndex:'bcovers',key:'bcovers',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bcovers",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bcovers_vs',key:'bcovers_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bcovers_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Lobby Bar Revenue ",_react2.default.createElement("br",null)," \u5927\u5802\u5427\u6536\u5165"),dataIndex:'last_rev',key:'last_rev',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_rev",totalIndex:[0,2]};if(index==0||index==2){return{props:{colSpan:10},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:index==0?"YTD-Actual Vs.2019 年累计-实际对比2019":'MTD-Actual Vs.2019 年累计-实际对比2019'})})};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_vs',key:'last_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Revenue Mix ",_react2.default.createElement("br",null)," \u6536\u5165\u4EFD\u989D%"),dataIndex:'last_mix',key:'last_mix',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_mix",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_mix_vs',key:'last_mix_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_mix_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"A/C \u4EBA\u5747\u6D88\u8D39"),dataIndex:'last_ac',key:'last_ac',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_ac",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_ac_vs',key:'last_ac_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_ac_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Cost% \u6210\u672C\u767E\u5206\u6BD4"),dataIndex:'last_cost',key:'last_cost',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_cost",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_cost_vs',key:'last_cost_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_cost_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Covers \u7528\u9910\u4EBA\u6570"),dataIndex:'last_covers',key:'last_covers',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_covers",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_covers_vs',key:'last_covers_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_covers_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];};var columns7=exports.columns7=function columns7(){return[{title:_react2.default.createElement("div",null,"Room Service Revenue ",_react2.default.createElement("br",null)," \u5BA2\u623F\u9001\u9910\u6536\u5165"),dataIndex:'rev',key:'rev',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"rev",totalIndex:[0,2]};if(index==0||index==2){return{props:{colSpan:5},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:index==0?"YTD-Actual年累计实际":'MTD-Actual月累计实际'})})};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Revenue Mix ",_react2.default.createElement("br",null),"  \u6536\u5165\u4EFD\u989D% "),dataIndex:'mix',key:'mix',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"mix",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"A/C \u4EBA\u5747\u6D88\u8D39"),dataIndex:'ac',key:'ac',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"ac",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Cost% ",_react2.default.createElement("br",null),"\u6210\u672C\u767E\u5206\u6BD4"),dataIndex:'cost',key:'cost',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"mix",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Covers \u7528\u9910\u4EBA\u6570"),dataIndex:'covers',key:'covers',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"covers",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Room Service Revenue ",_react2.default.createElement("br",null)," \u5BA2\u623F\u9001\u9910\u6536\u5165"),dataIndex:'brev',key:'brev',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"brev",totalIndex:[0,2]};if(index==0||index==2){return{props:{colSpan:10},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:index==0?"YTD-Actual Vs.Budget 年累计-实际对比预算":'MTD-Actual Vs.Budget 年累计-实际对比预算'})})};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'vs',key:'vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Revenue Mix",_react2.default.createElement("br",null),"\u6536\u5165\u4EFD\u989D%"),dataIndex:'bmix',key:'vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bvs',key:'bvs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"bvs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"A/C \u4EBA\u5747\u6D88\u8D39"),dataIndex:'bac',key:'bac',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bac",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bac_vs',key:'bac_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bac_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Cost% \u6210\u672C\u767E\u5206\u6BD4"),dataIndex:'bcost',key:'bcost',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"bcost",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bcost_vs',key:'bcost_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"bcost_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Covers \u7528\u9910\u4EBA\u6570"),dataIndex:'bcovers',key:'bcovers',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bcovers",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs Budget"),dataIndex:'bcovers_vs',key:'bcovers_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"bcovers_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Room Service Revenue ",_react2.default.createElement("br",null)," \u5BA2\u623F\u9001\u9910\u6536\u5165"),dataIndex:'last_rev',key:'last_rev',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_rev",totalIndex:[0,2]};if(index==0||index==2){return{props:{colSpan:10},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:index==0?"YTD-Actual Vs.2019 年累计-实际对比2019":'MTD-Actual Vs.2019 年累计-实际对比2019'})})};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_vs',key:'last_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Revenue Mix ",_react2.default.createElement("br",null)," \u6536\u5165\u4EFD\u989D%"),dataIndex:'last_mix',key:'last_mix',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_mix",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_mix_vs',key:'last_mix_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_mix_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"A/C \u4EBA\u5747\u6D88\u8D39"),dataIndex:'last_ac',key:'last_ac',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_ac",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_ac_vs',key:'last_ac_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_ac_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Cost% \u6210\u672C\u767E\u5206\u6BD4"),dataIndex:'last_cost',key:'last_cost',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_cost",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_cost_vs',key:'last_cost_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"last_cost_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Covers \u7528\u9910\u4EBA\u6570"),dataIndex:'last_covers',key:'last_covers',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_covers",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("div",null,"Vs 2019"),dataIndex:'last_covers_vs',key:'last_covers_vs',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_covers_vs",totalIndex:[0,2]};if(index==0||index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];};var columns8=exports.columns8=function columns8(print){return[{title:_react2.default.createElement("div",null,"Key Performance Indicator ",_react2.default.createElement("br",null)," \u5173\u952E\u6570\u636E"),dataIndex:'name',key:'name',align:"center",width:150,fixed:print?false:'left',render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Jan 一月",dataIndex:'jan',key:'jan',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"jan"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Feb 二月",dataIndex:'feb',key:'feb',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"feb"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Mar 三月",dataIndex:'mar',key:'mar',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"mar"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Apr 四月",dataIndex:'apr',key:'apr',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"apr"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"May 五月",dataIndex:'may',key:'may',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"may"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Jun 六月",dataIndex:'jun',key:'jun',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"jun"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Jul 七月",dataIndex:'jul',key:'jul',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"jul"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Aug 八月",dataIndex:'aug',key:'aug',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"aug"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Sep 九月",dataIndex:'sep',key:'sep',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"sep"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Oct 十月",dataIndex:'oct',key:'oct',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"oct"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Nov 十一月",dataIndex:'nov',key:'nov',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"nov"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Dec 十二月",dataIndex:'dec',key:'dec',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"dec"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Whole Year Budget全年预算",dataIndex:'budget',key:'budget',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"budget"};if(index==0){return{props:{rowSpan:2},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props)})};}return{props:{rowSpan:0}};}},{title:"Whole Year Forecast全年预测",dataIndex:'forecast',key:'forecast',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"forecast"};if(index==0){return{props:{rowSpan:2},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props)})};}return{props:{rowSpan:0}};}},{title:"YTD-Actual 年累计实际",dataIndex:'actual',key:'actual',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"actual"};if(index==0){return{props:{rowSpan:2},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props)})};}return{props:{rowSpan:0}};}}];};var data1=exports.data1=[{sort:0,name:"YTD-Actual Vs. 2019 <br /> 年累计-实际对比2019",fb:"",fb_prop:"",ac:"",covers:"",fb_profit:"",fb_payroll:"",fb_sales:"",fb_last:"",fb_vs:"",fb_prop_last:"",fb_prop_vs:"",ac_last:"",ac_vs:"",covers_last:"",covers_vs:"",fb_profit_last:"",fb_profit_vs:"",fb_payroll_last:"",fb_payroll_vs:"",fb_sales_last:"",fb_sales_vs:""},{sort:1,name:"YTD-Actual Vs. Budget <br /> 年累计-实际对比预算",fb:"",fb_prop:"",ac:"",covers:"",fb_profit:"",fb_payroll:"",fb_sales:"",fb_last:"",fb_vs:"",fb_prop_last:"",fb_prop_vs:"",ac_last:"",ac_vs:"",covers_last:"",covers_vs:"",fb_profit_last:"",fb_profit_vs:"",fb_payroll_last:"",fb_payroll_vs:"",fb_sales_last:"",fb_sales_vs:""},{sort:2,name:"MTD-Actual Vs. 2019 <br /> 月累计-实际对比2019",fb:"",fb_prop:"",ac:"",covers:"",fb_profit:"",fb_payroll:"",fb_sales:"",fb_last:"",fb_vs:"",fb_prop_last:"",fb_prop_vs:"",ac_last:"",ac_vs:"",covers_last:"",covers_vs:"",fb_profit_last:"",fb_profit_vs:"",fb_payroll_last:"",fb_payroll_vs:"",fb_sales_last:"",fb_sales_vs:""},{sort:3,name:"MTD-Actual Vs. Budget <br /> 月累计-实际对比预算",fb:"",fb_prop:"",ac:"",covers:"",fb_profit:"",fb_payroll:"",fb_sales:"",fb_last:"",fb_vs:"",fb_prop_last:"",fb_prop_vs:"",ac_last:"",ac_vs:"",covers_last:"",covers_vs:"",fb_profit_last:"",fb_profit_vs:"",fb_payroll_last:"",fb_payroll_vs:"",fb_sales_last:"",fb_sales_vs:""}];var data2=exports.data2=[{sort:0,rev:0,mix:0,ac:0,cost:0,covers:0,brev:0,vs:0,bmix:0,bvs:0,bac:0,bac_vs:0,bcost:0,bcost_vs:0,bcovers:0,bcovers_vs:0,last_rev:0,last_vs:0,last_mix:0,last_mix_vs:0,last_ac:0,last_ac_vs:0,last_cost:0,last_cost_vs:0,last_covers:0,last_covers_vs:0},{sort:1,rev:0,mix:0,ac:0,cost:0,covers:0,brev:0,vs:0,bmix:0,bvs:0,bac:0,bac_vs:0,bcost:0,bcost_vs:0,bcovers:0,bcovers_vs:0,last_rev:0,last_vs:0,last_mix:0,last_mix_vs:0,last_ac:0,last_ac_vs:0,last_cost:0,last_cost_vs:0,last_covers:0,last_covers_vs:0},{sort:2,rev:0,mix:0,ac:0,cost:0,covers:0,brev:0,vs:0,bmix:0,bvs:0,bac:0,bac_vs:0,bcost:0,bcost_vs:0,bcovers:0,bcovers_vs:0,last_rev:0,last_vs:0,last_mix:0,last_mix_vs:0,last_ac:0,last_ac_vs:0,last_cost:0,last_cost_vs:0,last_covers:0,last_covers_vs:0},{sort:3,rev:0,mix:0,ac:0,cost:0,covers:0,brev:0,vs:0,bmix:0,bvs:0,bac:0,bac_vs:0,bcost:0,bcost_vs:0,bcovers:0,bcovers_vs:0,last_rev:0,last_vs:0,last_mix:0,last_mix_vs:0,last_ac:0,last_ac_vs:0,last_cost:0,last_cost_vs:0,last_covers:0,last_covers_vs:0}];var data=exports.data=[{sort:0,name:"Budget餐饮预算",jan:0,feb:0,mar:0,apr:0,may:0,jun:0,jul:0,aug:0,sep:0,oct:0,nov:0,dec:0,budget:0,forecast:0,actual:0},{sort:1,name:"Forecast餐饮预测",jan:0,feb:0,mar:0,apr:0,may:0,jun:0,jul:0,aug:0,sep:0,oct:0,nov:0,dec:0,budget:0,forecast:0,actual:0}];

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(35);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Compared=__webpack_require__(1969);var _Compared2=_interopRequireDefault(_Compared);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * @name:  
 * @description:  
 * @Author: Han bei 
 * @Date: 2018-10-15 15:46:36 
 * @Last Modified by: Han bei
 * @Last Modified time: 2019-07-18 16:35:58
 *  
 *  text  value值
 *  index 索引
 *  type  需要组件类型   text、number、percent、input、inputNumber、inputPercent 不传值默认不显示文本
 *  name  行名称
 *  title 表头
 *  record 行数据 Object
 *  totolIndex  汇总的行、需要颜色区分
 *  sqlName  数据库名称 自定义表格需要
 *  onChange 利用父级函数更新数据
 */Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var TableText=function(_Component){_inherits(TableText,_Component);function TableText(){_classCallCheck(this,TableText);return _possibleConstructorReturn(this,(TableText.__proto__||Object.getPrototypeOf(TableText)).apply(this,arguments));}_createClass(TableText,[{key:'render',value:function render(){var _props$data=this.props.data,text=_props$data.text,index=_props$data.index,type=_props$data.type,name=_props$data.name,onChange=_props$data.onChange,_props$data$totalInde=_props$data.totalIndex,totalIndex=_props$data$totalInde===undefined?[]:_props$data$totalInde,warn=_props$data.warn;var _ref=this.props.data.compared||{},_ref$title=_ref.title,title=_ref$title===undefined?[]:_ref$title,_ref$record=_ref.record,record=_ref$record===undefined?{}:_ref$record,_ref$sqlName=_ref.sqlName,sqlName=_ref$sqlName===undefined?"":_ref$sqlName;switch(type){case'input':return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";onChange(name,value,index);}}));break;case'number':if(this.props.data.compared){if(warn){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:name,title:title,sqlName:sqlName,name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '+(warn?"table-text-warn":"")+' '},_react2.default.createElement('span',{style:{color:"red"}},Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','))));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:name,title:title,sqlName:sqlName,name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+'  '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}if(warn){return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '+(warn?"table-text-warn":"")+'  '},_react2.default.createElement('span',{style:{color:"red"}},Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+'  '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));break;case'inputPercent':if(this.props.data.compared){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:name,title:title,sqlName:sqlName,name:record.name,type:"percent"}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{defaultValue:Number(text||"0")*100||"",className:'table_numInput',precision:1,formatter:function formatter(value){return(value+'%').replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){var parseValue=value;parseValue=value.replace('%','').replace(/\$\s?|(,*)/g,'');return parseValue;},onBlur:function onBlur(e){var value=Number(e.target.value.replace(/%|,/g,'')||'0');value=Number(value.toFixed(1)/100).toFixed(3);onChange(name,value,index);}})));}else{return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{defaultValue:Number(text||"0")*100||"",className:'table_numInput',precision:1,formatter:function formatter(value){return(value+'%').replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){var parseValue=value;parseValue=value.replace('%','').replace(/\$\s?|(,*)/g,'');return parseValue;},onBlur:function onBlur(e){var value=Number(e.target.value.replace(/%|,/g,'')||'0');value=Number(value.toFixed(1)/100).toFixed(3);onChange(name,value,index);}}));}break;case'inputNumber':if(this.props.data.compared){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:name,title:title,sqlName:sqlName,name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding table-color-number '+(warn?"table-inputNumber-err":"")},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));onChange(name,value,index);}})));}else{return _react2.default.createElement('div',{className:'table-padding table-color-number '+(warn?"table-inputNumber-err":"")},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));onChange(name,value,index);}}));}break;case'percent':// 百分比位数根据传值进行变动
var num=(text.toString().split('.')[1]||"").length<=3?1:(text.toString().split('.')[1]||"").length-2;if(this.props.data.compared){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:name,title:title,sqlName:sqlName,name:record.name,type:"percent"}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',((Math.abs(text)*100).toFixed(num).toLocaleString()=="-0"?"0":(Math.abs(text)*100).toFixed(num).toLocaleString())+'%',')'):((text*100).toFixed(num).toLocaleString()=="-0"?"0":(text*100).toFixed(num).toLocaleString())+'%'));}else{return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',((Math.abs(text)*100).toFixed(num).toLocaleString()=="-0"?"0":(Math.abs(text)*100).toFixed(num).toLocaleString())+'%',')'):((text*100).toFixed(num).toLocaleString()=="-0"?"0":(text*100).toFixed(num).toLocaleString())+'%');}break;case'text':if(warn){return _react2.default.createElement('div',{className:'table-padding '+(warn?"table-text-warn":"")+'  ',style:{textAlign:"left"}},_react2.default.createElement('span',{style:{color:"red"},dangerouslySetInnerHTML:{__html:text||"-"}}));}return _react2.default.createElement('div',{className:'table-padding  '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"left"},dangerouslySetInnerHTML:{__html:text||"-"}});break;default:return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"center"}},'-');break;}}}]);return TableText;}(_react.Component);exports.default=TableText;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(141);
var core = __webpack_require__(88);
var ctx = __webpack_require__(316);
var hide = __webpack_require__(184);
var has = __webpack_require__(154);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 141 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(185);
var IE8_DOM_DEFINE = __webpack_require__(449);
var toPrimitive = __webpack_require__(317);
var dP = Object.defineProperty;

exports.f = __webpack_require__(143) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(187)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(161)('meta');
var isObject = __webpack_require__(52);
var has = __webpack_require__(94);
var setDesc = __webpack_require__(66).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(51)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(56)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(90)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var _vector = __webpack_require__(55);

var v2Create = _vector.create;
var v2DistSquare = _vector.distSquare;

/**
 * 曲线辅助模块
 * @module zrender/core/curve
 * @author pissang(https://www.github.com/pissang)
 */
var mathPow = Math.pow;
var mathSqrt = Math.sqrt;
var EPSILON = 1e-8;
var EPSILON_NUMERIC = 1e-4;
var THREE_SQRT = mathSqrt(3);
var ONE_THIRD = 1 / 3; // 临时变量

var _v0 = v2Create();

var _v1 = v2Create();

var _v2 = v2Create();

function isAroundZero(val) {
  return val > -EPSILON && val < EPSILON;
}

function isNotAroundZero(val) {
  return val > EPSILON || val < -EPSILON;
}
/**
 * 计算三次贝塞尔值
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @return {number}
 */


function cubicAt(p0, p1, p2, p3, t) {
  var onet = 1 - t;
  return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
}
/**
 * 计算三次贝塞尔导数值
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @return {number}
 */


function cubicDerivativeAt(p0, p1, p2, p3, t) {
  var onet = 1 - t;
  return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
}
/**
 * 计算三次贝塞尔方程根，使用盛金公式
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} val
 * @param  {Array.<number>} roots
 * @return {number} 有效根数目
 */


function cubicRootAt(p0, p1, p2, p3, val, roots) {
  // Evaluate roots of cubic functions
  var a = p3 + 3 * (p1 - p2) - p0;
  var b = 3 * (p2 - p1 * 2 + p0);
  var c = 3 * (p1 - p0);
  var d = p0 - val;
  var A = b * b - 3 * a * c;
  var B = b * c - 9 * a * d;
  var C = c * c - 3 * b * d;
  var n = 0;

  if (isAroundZero(A) && isAroundZero(B)) {
    if (isAroundZero(b)) {
      roots[0] = 0;
    } else {
      var t1 = -c / b; //t1, t2, t3, b is not zero

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }
    }
  } else {
    var disc = B * B - 4 * A * C;

    if (isAroundZero(disc)) {
      var K = B / A;
      var t1 = -b / a + K; // t1, a is not zero

      var t2 = -K / 2; // t2, t3

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }

      if (t2 >= 0 && t2 <= 1) {
        roots[n++] = t2;
      }
    } else if (disc > 0) {
      var discSqrt = mathSqrt(disc);
      var Y1 = A * b + 1.5 * a * (-B + discSqrt);
      var Y2 = A * b + 1.5 * a * (-B - discSqrt);

      if (Y1 < 0) {
        Y1 = -mathPow(-Y1, ONE_THIRD);
      } else {
        Y1 = mathPow(Y1, ONE_THIRD);
      }

      if (Y2 < 0) {
        Y2 = -mathPow(-Y2, ONE_THIRD);
      } else {
        Y2 = mathPow(Y2, ONE_THIRD);
      }

      var t1 = (-b - (Y1 + Y2)) / (3 * a);

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }
    } else {
      var T = (2 * A * b - 3 * a * B) / (2 * mathSqrt(A * A * A));
      var theta = Math.acos(T) / 3;
      var ASqrt = mathSqrt(A);
      var tmp = Math.cos(theta);
      var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
      var t2 = (-b + ASqrt * (tmp + THREE_SQRT * Math.sin(theta))) / (3 * a);
      var t3 = (-b + ASqrt * (tmp - THREE_SQRT * Math.sin(theta))) / (3 * a);

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }

      if (t2 >= 0 && t2 <= 1) {
        roots[n++] = t2;
      }

      if (t3 >= 0 && t3 <= 1) {
        roots[n++] = t3;
      }
    }
  }

  return n;
}
/**
 * 计算三次贝塞尔方程极限值的位置
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {Array.<number>} extrema
 * @return {number} 有效数目
 */


function cubicExtrema(p0, p1, p2, p3, extrema) {
  var b = 6 * p2 - 12 * p1 + 6 * p0;
  var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
  var c = 3 * p1 - 3 * p0;
  var n = 0;

  if (isAroundZero(a)) {
    if (isNotAroundZero(b)) {
      var t1 = -c / b;

      if (t1 >= 0 && t1 <= 1) {
        extrema[n++] = t1;
      }
    }
  } else {
    var disc = b * b - 4 * a * c;

    if (isAroundZero(disc)) {
      extrema[0] = -b / (2 * a);
    } else if (disc > 0) {
      var discSqrt = mathSqrt(disc);
      var t1 = (-b + discSqrt) / (2 * a);
      var t2 = (-b - discSqrt) / (2 * a);

      if (t1 >= 0 && t1 <= 1) {
        extrema[n++] = t1;
      }

      if (t2 >= 0 && t2 <= 1) {
        extrema[n++] = t2;
      }
    }
  }

  return n;
}
/**
 * 细分三次贝塞尔曲线
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @param  {Array.<number>} out
 */


function cubicSubdivide(p0, p1, p2, p3, t, out) {
  var p01 = (p1 - p0) * t + p0;
  var p12 = (p2 - p1) * t + p1;
  var p23 = (p3 - p2) * t + p2;
  var p012 = (p12 - p01) * t + p01;
  var p123 = (p23 - p12) * t + p12;
  var p0123 = (p123 - p012) * t + p012; // Seg0

  out[0] = p0;
  out[1] = p01;
  out[2] = p012;
  out[3] = p0123; // Seg1

  out[4] = p0123;
  out[5] = p123;
  out[6] = p23;
  out[7] = p3;
}
/**
 * 投射点到三次贝塞尔曲线上，返回投射距离。
 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {number} x3
 * @param {number} y3
 * @param {number} x
 * @param {number} y
 * @param {Array.<number>} [out] 投射点
 * @return {number}
 */


function cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
  // http://pomax.github.io/bezierinfo/#projections
  var t;
  var interval = 0.005;
  var d = Infinity;
  var prev;
  var next;
  var d1;
  var d2;
  _v0[0] = x;
  _v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
  // PENDING

  for (var _t = 0; _t < 1; _t += 0.05) {
    _v1[0] = cubicAt(x0, x1, x2, x3, _t);
    _v1[1] = cubicAt(y0, y1, y2, y3, _t);
    d1 = v2DistSquare(_v0, _v1);

    if (d1 < d) {
      t = _t;
      d = d1;
    }
  }

  d = Infinity; // At most 32 iteration

  for (var i = 0; i < 32; i++) {
    if (interval < EPSILON_NUMERIC) {
      break;
    }

    prev = t - interval;
    next = t + interval; // t - interval

    _v1[0] = cubicAt(x0, x1, x2, x3, prev);
    _v1[1] = cubicAt(y0, y1, y2, y3, prev);
    d1 = v2DistSquare(_v1, _v0);

    if (prev >= 0 && d1 < d) {
      t = prev;
      d = d1;
    } else {
      // t + interval
      _v2[0] = cubicAt(x0, x1, x2, x3, next);
      _v2[1] = cubicAt(y0, y1, y2, y3, next);
      d2 = v2DistSquare(_v2, _v0);

      if (next <= 1 && d2 < d) {
        t = next;
        d = d2;
      } else {
        interval *= 0.5;
      }
    }
  } // t


  if (out) {
    out[0] = cubicAt(x0, x1, x2, x3, t);
    out[1] = cubicAt(y0, y1, y2, y3, t);
  } // console.log(interval, i);


  return mathSqrt(d);
}
/**
 * 计算二次方贝塞尔值
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @return {number}
 */


function quadraticAt(p0, p1, p2, t) {
  var onet = 1 - t;
  return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
}
/**
 * 计算二次方贝塞尔导数值
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @return {number}
 */


function quadraticDerivativeAt(p0, p1, p2, t) {
  return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
}
/**
 * 计算二次方贝塞尔方程根
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @param  {Array.<number>} roots
 * @return {number} 有效根数目
 */


function quadraticRootAt(p0, p1, p2, val, roots) {
  var a = p0 - 2 * p1 + p2;
  var b = 2 * (p1 - p0);
  var c = p0 - val;
  var n = 0;

  if (isAroundZero(a)) {
    if (isNotAroundZero(b)) {
      var t1 = -c / b;

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }
    }
  } else {
    var disc = b * b - 4 * a * c;

    if (isAroundZero(disc)) {
      var t1 = -b / (2 * a);

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }
    } else if (disc > 0) {
      var discSqrt = mathSqrt(disc);
      var t1 = (-b + discSqrt) / (2 * a);
      var t2 = (-b - discSqrt) / (2 * a);

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }

      if (t2 >= 0 && t2 <= 1) {
        roots[n++] = t2;
      }
    }
  }

  return n;
}
/**
 * 计算二次贝塞尔方程极限值
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @return {number}
 */


function quadraticExtremum(p0, p1, p2) {
  var divider = p0 + p2 - 2 * p1;

  if (divider === 0) {
    // p1 is center of p0 and p2
    return 0.5;
  } else {
    return (p0 - p1) / divider;
  }
}
/**
 * 细分二次贝塞尔曲线
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @param  {Array.<number>} out
 */


function quadraticSubdivide(p0, p1, p2, t, out) {
  var p01 = (p1 - p0) * t + p0;
  var p12 = (p2 - p1) * t + p1;
  var p012 = (p12 - p01) * t + p01; // Seg0

  out[0] = p0;
  out[1] = p01;
  out[2] = p012; // Seg1

  out[3] = p012;
  out[4] = p12;
  out[5] = p2;
}
/**
 * 投射点到二次贝塞尔曲线上，返回投射距离。
 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {number} x
 * @param {number} y
 * @param {Array.<number>} out 投射点
 * @return {number}
 */


function quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, out) {
  // http://pomax.github.io/bezierinfo/#projections
  var t;
  var interval = 0.005;
  var d = Infinity;
  _v0[0] = x;
  _v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
  // PENDING

  for (var _t = 0; _t < 1; _t += 0.05) {
    _v1[0] = quadraticAt(x0, x1, x2, _t);
    _v1[1] = quadraticAt(y0, y1, y2, _t);
    var d1 = v2DistSquare(_v0, _v1);

    if (d1 < d) {
      t = _t;
      d = d1;
    }
  }

  d = Infinity; // At most 32 iteration

  for (var i = 0; i < 32; i++) {
    if (interval < EPSILON_NUMERIC) {
      break;
    }

    var prev = t - interval;
    var next = t + interval; // t - interval

    _v1[0] = quadraticAt(x0, x1, x2, prev);
    _v1[1] = quadraticAt(y0, y1, y2, prev);
    var d1 = v2DistSquare(_v1, _v0);

    if (prev >= 0 && d1 < d) {
      t = prev;
      d = d1;
    } else {
      // t + interval
      _v2[0] = quadraticAt(x0, x1, x2, next);
      _v2[1] = quadraticAt(y0, y1, y2, next);
      var d2 = v2DistSquare(_v2, _v0);

      if (next <= 1 && d2 < d) {
        t = next;
        d = d2;
      } else {
        interval *= 0.5;
      }
    }
  } // t


  if (out) {
    out[0] = quadraticAt(x0, x1, x2, t);
    out[1] = quadraticAt(y0, y1, y2, t);
  } // console.log(interval, i);


  return mathSqrt(d);
}

exports.cubicAt = cubicAt;
exports.cubicDerivativeAt = cubicDerivativeAt;
exports.cubicRootAt = cubicRootAt;
exports.cubicExtrema = cubicExtrema;
exports.cubicSubdivide = cubicSubdivide;
exports.cubicProjectPoint = cubicProjectPoint;
exports.quadraticAt = quadraticAt;
exports.quadraticDerivativeAt = quadraticDerivativeAt;
exports.quadraticRootAt = quadraticRootAt;
exports.quadraticExtremum = quadraticExtremum;
exports.quadraticSubdivide = quadraticSubdivide;
exports.quadraticProjectPoint = quadraticProjectPoint;

/***/ }),
/* 148 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var ORIGIN_METHOD = '\0__throttleOriginMethod';
var RATE = '\0__throttleRate';
var THROTTLE_TYPE = '\0__throttleType';
/**
 * @public
 * @param {(Function)} fn
 * @param {number} [delay=0] Unit: ms.
 * @param {boolean} [debounce=false]
 *        true: If call interval less than `delay`, only the last call works.
 *        false: If call interval less than `delay, call works on fixed rate.
 * @return {(Function)} throttled fn.
 */

function throttle(fn, delay, debounce) {
  var currCall;
  var lastCall = 0;
  var lastExec = 0;
  var timer = null;
  var diff;
  var scope;
  var args;
  var debounceNextCall;
  delay = delay || 0;

  function exec() {
    lastExec = new Date().getTime();
    timer = null;
    fn.apply(scope, args || []);
  }

  var cb = function () {
    currCall = new Date().getTime();
    scope = this;
    args = arguments;
    var thisDelay = debounceNextCall || delay;
    var thisDebounce = debounceNextCall || debounce;
    debounceNextCall = null;
    diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
    clearTimeout(timer); // Here we should make sure that: the `exec` SHOULD NOT be called later
    // than a new call of `cb`, that is, preserving the command order. Consider
    // calculating "scale rate" when roaming as an example. When a call of `cb`
    // happens, either the `exec` is called dierectly, or the call is delayed.
    // But the delayed call should never be later than next call of `cb`. Under
    // this assurance, we can simply update view state each time `dispatchAction`
    // triggered by user roaming, but not need to add extra code to avoid the
    // state being "rolled-back".

    if (thisDebounce) {
      timer = setTimeout(exec, thisDelay);
    } else {
      if (diff >= 0) {
        exec();
      } else {
        timer = setTimeout(exec, -diff);
      }
    }

    lastCall = currCall;
  };
  /**
   * Clear throttle.
   * @public
   */


  cb.clear = function () {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };
  /**
   * Enable debounce once.
   */


  cb.debounceNextCall = function (debounceDelay) {
    debounceNextCall = debounceDelay;
  };

  return cb;
}
/**
 * Create throttle method or update throttle rate.
 *
 * @example
 * ComponentView.prototype.render = function () {
 *     ...
 *     throttle.createOrUpdate(
 *         this,
 *         '_dispatchAction',
 *         this.model.get('throttle'),
 *         'fixRate'
 *     );
 * };
 * ComponentView.prototype.remove = function () {
 *     throttle.clear(this, '_dispatchAction');
 * };
 * ComponentView.prototype.dispose = function () {
 *     throttle.clear(this, '_dispatchAction');
 * };
 *
 * @public
 * @param {Object} obj
 * @param {string} fnAttr
 * @param {number} [rate]
 * @param {string} [throttleType='fixRate'] 'fixRate' or 'debounce'
 * @return {Function} throttled function.
 */


function createOrUpdate(obj, fnAttr, rate, throttleType) {
  var fn = obj[fnAttr];

  if (!fn) {
    return;
  }

  var originFn = fn[ORIGIN_METHOD] || fn;
  var lastThrottleType = fn[THROTTLE_TYPE];
  var lastRate = fn[RATE];

  if (lastRate !== rate || lastThrottleType !== throttleType) {
    if (rate == null || !throttleType) {
      return obj[fnAttr] = originFn;
    }

    fn = obj[fnAttr] = throttle(originFn, rate, throttleType === 'debounce');
    fn[ORIGIN_METHOD] = originFn;
    fn[THROTTLE_TYPE] = throttleType;
    fn[RATE] = rate;
  }

  return fn;
}
/**
 * Clear throttle. Example see throttle.createOrUpdate.
 *
 * @public
 * @param {Object} obj
 * @param {string} fnAttr
 */


function clear(obj, fnAttr) {
  var fn = obj[fnAttr];

  if (fn && fn[ORIGIN_METHOD]) {
    obj[fnAttr] = fn[ORIGIN_METHOD];
  }
}

exports.throttle = throttle;
exports.createOrUpdate = createOrUpdate;
exports.clear = clear;

/***/ }),
/* 149 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Language: (Simplified) Chinese.
 */
var _default = {
  legend: {
    selector: {
      all: '全选',
      inverse: '反选'
    }
  },
  toolbox: {
    brush: {
      title: {
        rect: '矩形选择',
        polygon: '圈选',
        lineX: '横向选择',
        lineY: '纵向选择',
        keep: '保持选择',
        clear: '清除选择'
      }
    },
    dataView: {
      title: '数据视图',
      lang: ['数据视图', '关闭', '刷新']
    },
    dataZoom: {
      title: {
        zoom: '区域缩放',
        back: '区域缩放还原'
      }
    },
    magicType: {
      title: {
        line: '切换为折线图',
        bar: '切换为柱状图',
        stack: '切换为堆叠',
        tiled: '切换为平铺'
      }
    },
    restore: {
      title: '还原'
    },
    saveAsImage: {
      title: '保存为图片',
      lang: ['右键另存为图片']
    }
  },
  series: {
    typeNames: {
      pie: '饼图',
      bar: '柱状图',
      line: '折线图',
      scatter: '散点图',
      effectScatter: '涟漪散点图',
      radar: '雷达图',
      tree: '树图',
      treemap: '矩形树图',
      boxplot: '箱型图',
      candlestick: 'K线图',
      k: 'K线图',
      heatmap: '热力图',
      map: '地图',
      parallel: '平行坐标图',
      lines: '线图',
      graph: '关系图',
      sankey: '桑基图',
      funnel: '漏斗图',
      gauge: '仪表盘图',
      pictorialBar: '象形柱图',
      themeRiver: '主题河流图',
      sunburst: '旭日图'
    }
  },
  aria: {
    general: {
      withTitle: '这是一个关于“{title}”的图表。',
      withoutTitle: '这是一个图表，'
    },
    series: {
      single: {
        prefix: '',
        withName: '图表类型是{seriesType}，表示{seriesName}。',
        withoutName: '图表类型是{seriesType}。'
      },
      multiple: {
        prefix: '它由{seriesCount}个图表系列组成。',
        withName: '第{seriesId}个系列是一个表示{seriesName}的{seriesType}，',
        withoutName: '第{seriesId}个系列是一个{seriesType}，',
        separator: {
          middle: '；',
          end: '。'
        }
      }
    },
    data: {
      allData: '其数据是——',
      partialData: '其中，前{displayCnt}项是——',
      withName: '{name}的数据是{value}',
      withoutName: '{value}',
      separator: {
        middle: '，',
        end: ''
      }
    }
  }
};
module.exports = _default;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(1);

var each = _util.each;
var map = _util.map;

var _number = __webpack_require__(37);

var linearMap = _number.linearMap;
var getPixelPrecision = _number.getPixelPrecision;
var round = _number.round;

var _axisTickLabelBuilder = __webpack_require__(1571);

var createAxisTicks = _axisTickLabelBuilder.createAxisTicks;
var createAxisLabels = _axisTickLabelBuilder.createAxisLabels;
var calculateCategoryInterval = _axisTickLabelBuilder.calculateCategoryInterval;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var NORMALIZED_EXTENT = [0, 1];
/**
 * Base class of Axis.
 * @constructor
 */

var Axis = function (dim, scale, extent) {
  /**
   * Axis dimension. Such as 'x', 'y', 'z', 'angle', 'radius'.
   * @type {string}
   */
  this.dim = dim;
  /**
   * Axis scale
   * @type {module:echarts/coord/scale/*}
   */

  this.scale = scale;
  /**
   * @type {Array.<number>}
   * @private
   */

  this._extent = extent || [0, 0];
  /**
   * @type {boolean}
   */

  this.inverse = false;
  /**
   * Usually true when axis has a ordinal scale
   * @type {boolean}
   */

  this.onBand = false;
};

Axis.prototype = {
  constructor: Axis,

  /**
   * If axis extent contain given coord
   * @param {number} coord
   * @return {boolean}
   */
  contain: function (coord) {
    var extent = this._extent;
    var min = Math.min(extent[0], extent[1]);
    var max = Math.max(extent[0], extent[1]);
    return coord >= min && coord <= max;
  },

  /**
   * If axis extent contain given data
   * @param {number} data
   * @return {boolean}
   */
  containData: function (data) {
    return this.scale.contain(data);
  },

  /**
   * Get coord extent.
   * @return {Array.<number>}
   */
  getExtent: function () {
    return this._extent.slice();
  },

  /**
   * Get precision used for formatting
   * @param {Array.<number>} [dataExtent]
   * @return {number}
   */
  getPixelPrecision: function (dataExtent) {
    return getPixelPrecision(dataExtent || this.scale.getExtent(), this._extent);
  },

  /**
   * Set coord extent
   * @param {number} start
   * @param {number} end
   */
  setExtent: function (start, end) {
    var extent = this._extent;
    extent[0] = start;
    extent[1] = end;
  },

  /**
   * Convert data to coord. Data is the rank if it has an ordinal scale
   * @param {number} data
   * @param  {boolean} clamp
   * @return {number}
   */
  dataToCoord: function (data, clamp) {
    var extent = this._extent;
    var scale = this.scale;
    data = scale.normalize(data);

    if (this.onBand && scale.type === 'ordinal') {
      extent = extent.slice();
      fixExtentWithBands(extent, scale.count());
    }

    return linearMap(data, NORMALIZED_EXTENT, extent, clamp);
  },

  /**
   * Convert coord to data. Data is the rank if it has an ordinal scale
   * @param {number} coord
   * @param  {boolean} clamp
   * @return {number}
   */
  coordToData: function (coord, clamp) {
    var extent = this._extent;
    var scale = this.scale;

    if (this.onBand && scale.type === 'ordinal') {
      extent = extent.slice();
      fixExtentWithBands(extent, scale.count());
    }

    var t = linearMap(coord, extent, NORMALIZED_EXTENT, clamp);
    return this.scale.scale(t);
  },

  /**
   * Convert pixel point to data in axis
   * @param {Array.<number>} point
   * @param  {boolean} clamp
   * @return {number} data
   */
  pointToData: function (point, clamp) {// Should be implemented in derived class if necessary.
  },

  /**
   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
   * `axis.getTicksCoords` considers `onBand`, which is used by
   * `boundaryGap:true` of category axis and splitLine and splitArea.
   * @param {Object} [opt]
   * @param {Model} [opt.tickModel=axis.model.getModel('axisTick')]
   * @param {boolean} [opt.clamp] If `true`, the first and the last
   *        tick must be at the axis end points. Otherwise, clip ticks
   *        that outside the axis extent.
   * @return {Array.<Object>} [{
   *     coord: ...,
   *     tickValue: ...
   * }, ...]
   */
  getTicksCoords: function (opt) {
    opt = opt || {};
    var tickModel = opt.tickModel || this.getTickModel();
    var result = createAxisTicks(this, tickModel);
    var ticks = result.ticks;
    var ticksCoords = map(ticks, function (tickValue) {
      return {
        coord: this.dataToCoord(tickValue),
        tickValue: tickValue
      };
    }, this);
    var alignWithLabel = tickModel.get('alignWithLabel');
    fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
    return ticksCoords;
  },

  /**
   * @return {Array.<Array.<Object>>} [{ coord: ..., tickValue: ...}]
   */
  getMinorTicksCoords: function () {
    if (this.scale.type === 'ordinal') {
      // Category axis doesn't support minor ticks
      return [];
    }

    var minorTickModel = this.model.getModel('minorTick');
    var splitNumber = minorTickModel.get('splitNumber'); // Protection.

    if (!(splitNumber > 0 && splitNumber < 100)) {
      splitNumber = 5;
    }

    var minorTicks = this.scale.getMinorTicks(splitNumber);
    var minorTicksCoords = map(minorTicks, function (minorTicksGroup) {
      return map(minorTicksGroup, function (minorTick) {
        return {
          coord: this.dataToCoord(minorTick),
          tickValue: minorTick
        };
      }, this);
    }, this);
    return minorTicksCoords;
  },

  /**
   * @return {Array.<Object>} [{
   *     formattedLabel: string,
   *     rawLabel: axis.scale.getLabel(tickValue)
   *     tickValue: number
   * }, ...]
   */
  getViewLabels: function () {
    return createAxisLabels(this).labels;
  },

  /**
   * @return {module:echarts/coord/model/Model}
   */
  getLabelModel: function () {
    return this.model.getModel('axisLabel');
  },

  /**
   * Notice here we only get the default tick model. For splitLine
   * or splitArea, we should pass the splitLineModel or splitAreaModel
   * manually when calling `getTicksCoords`.
   * In GL, this method may be overrided to:
   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
   * @return {module:echarts/coord/model/Model}
   */
  getTickModel: function () {
    return this.model.getModel('axisTick');
  },

  /**
   * Get width of band
   * @return {number}
   */
  getBandWidth: function () {
    var axisExtent = this._extent;
    var dataExtent = this.scale.getExtent();
    var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0); // Fix #2728, avoid NaN when only one data.

    len === 0 && (len = 1);
    var size = Math.abs(axisExtent[1] - axisExtent[0]);
    return Math.abs(size) / len;
  },

  /**
   * @abstract
   * @return {boolean} Is horizontal
   */
  isHorizontal: null,

  /**
   * @abstract
   * @return {number} Get axis rotate, by degree.
   */
  getRotate: null,

  /**
   * Only be called in category axis.
   * Can be overrided, consider other axes like in 3D.
   * @return {number} Auto interval for cateogry axis tick and label
   */
  calculateCategoryInterval: function () {
    return calculateCategoryInterval(this);
  }
};

function fixExtentWithBands(extent, nTick) {
  var size = extent[1] - extent[0];
  var len = nTick;
  var margin = size / len / 2;
  extent[0] += margin;
  extent[1] -= margin;
} // If axis has labels [1, 2, 3, 4]. Bands on the axis are
// |---1---|---2---|---3---|---4---|.
// So the displayed ticks and splitLine/splitArea should between
// each data item, otherwise cause misleading (e.g., split tow bars
// of a single data item when there are two bar series).
// Also consider if tickCategoryInterval > 0 and onBand, ticks and
// splitLine/spliteArea should layout appropriately corresponding
// to displayed labels. (So we should not use `getBandWidth` in this
// case).


function fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
  var ticksLen = ticksCoords.length;

  if (!axis.onBand || alignWithLabel || !ticksLen) {
    return;
  }

  var axisExtent = axis.getExtent();
  var last;
  var diffSize;

  if (ticksLen === 1) {
    ticksCoords[0].coord = axisExtent[0];
    last = ticksCoords[1] = {
      coord: axisExtent[0]
    };
  } else {
    var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
    var shift = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
    each(ticksCoords, function (ticksItem) {
      ticksItem.coord -= shift / 2;
    });
    var dataExtent = axis.scale.getExtent();
    diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
    last = {
      coord: ticksCoords[ticksLen - 1].coord + shift * diffSize
    };
    ticksCoords.push(last);
  }

  var inverse = axisExtent[0] > axisExtent[1]; // Handling clamp.

  if (littleThan(ticksCoords[0].coord, axisExtent[0])) {
    clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
  }

  if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) {
    ticksCoords.unshift({
      coord: axisExtent[0]
    });
  }

  if (littleThan(axisExtent[1], last.coord)) {
    clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
  }

  if (clamp && littleThan(last.coord, axisExtent[1])) {
    ticksCoords.push({
      coord: axisExtent[1]
    });
  }

  function littleThan(a, b) {
    // Avoid rounding error cause calculated tick coord different with extent.
    // It may cause an extra unecessary tick added.
    a = round(a);
    b = round(b);
    return inverse ? a > b : a < b;
  }
}

var _default = Axis;
module.exports = _default;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(1);

var retrieve = _util.retrieve;
var defaults = _util.defaults;
var extend = _util.extend;
var each = _util.each;

var formatUtil = __webpack_require__(54);

var graphic = __webpack_require__(27);

var Model = __webpack_require__(68);

var _number = __webpack_require__(37);

var isRadianAroundZero = _number.isRadianAroundZero;
var remRadian = _number.remRadian;

var _symbol = __webpack_require__(99);

var createSymbol = _symbol.createSymbol;

var matrixUtil = __webpack_require__(82);

var _vector = __webpack_require__(55);

var v2ApplyTransform = _vector.applyTransform;

var _axisHelper = __webpack_require__(109);

var shouldShowAllLabels = _axisHelper.shouldShowAllLabels;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var PI = Math.PI;
/**
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
 * for example: (0, 0) ------------> (0, 50)
 *
 * nameDirection or tickDirection or labelDirection is 1 means tick
 * or label is below the standard axis, whereas is -1 means above
 * the standard axis. labelOffset means offset between label and axis,
 * which is useful when 'onZero', where axisLabel is in the grid and
 * label in outside grid.
 *
 * Tips: like always,
 * positive rotation represents anticlockwise, and negative rotation
 * represents clockwise.
 * The direction of position coordinate is the same as the direction
 * of screen coordinate.
 *
 * Do not need to consider axis 'inverse', which is auto processed by
 * axis extent.
 *
 * @param {module:zrender/container/Group} group
 * @param {Object} axisModel
 * @param {Object} opt Standard axis parameters.
 * @param {Array.<number>} opt.position [x, y]
 * @param {number} opt.rotation by radian
 * @param {number} [opt.nameDirection=1] 1 or -1 Used when nameLocation is 'middle' or 'center'.
 * @param {number} [opt.tickDirection=1] 1 or -1
 * @param {number} [opt.labelDirection=1] 1 or -1
 * @param {number} [opt.labelOffset=0] Usefull when onZero.
 * @param {string} [opt.axisLabelShow] default get from axisModel.
 * @param {string} [opt.axisName] default get from axisModel.
 * @param {number} [opt.axisNameAvailableWidth]
 * @param {number} [opt.labelRotate] by degree, default get from axisModel.
 * @param {number} [opt.strokeContainThreshold] Default label interval when label
 * @param {number} [opt.nameTruncateMaxWidth]
 */

var AxisBuilder = function (axisModel, opt) {
  /**
   * @readOnly
   */
  this.opt = opt;
  /**
   * @readOnly
   */

  this.axisModel = axisModel; // Default value

  defaults(opt, {
    labelOffset: 0,
    nameDirection: 1,
    tickDirection: 1,
    labelDirection: 1,
    silent: true
  });
  /**
   * @readOnly
   */

  this.group = new graphic.Group(); // FIXME Not use a seperate text group?

  var dumbGroup = new graphic.Group({
    position: opt.position.slice(),
    rotation: opt.rotation
  }); // this.group.add(dumbGroup);
  // this._dumbGroup = dumbGroup;

  dumbGroup.updateTransform();
  this._transform = dumbGroup.transform;
  this._dumbGroup = dumbGroup;
};

AxisBuilder.prototype = {
  constructor: AxisBuilder,
  hasBuilder: function (name) {
    return !!builders[name];
  },
  add: function (name) {
    builders[name].call(this);
  },
  getGroup: function () {
    return this.group;
  }
};
var builders = {
  /**
   * @private
   */
  axisLine: function () {
    var opt = this.opt;
    var axisModel = this.axisModel;

    if (!axisModel.get('axisLine.show')) {
      return;
    }

    var extent = this.axisModel.axis.getExtent();
    var matrix = this._transform;
    var pt1 = [extent[0], 0];
    var pt2 = [extent[1], 0];

    if (matrix) {
      v2ApplyTransform(pt1, pt1, matrix);
      v2ApplyTransform(pt2, pt2, matrix);
    }

    var lineStyle = extend({
      lineCap: 'round'
    }, axisModel.getModel('axisLine.lineStyle').getLineStyle());
    this.group.add(new graphic.Line({
      // Id for animation
      anid: 'line',
      subPixelOptimize: true,
      shape: {
        x1: pt1[0],
        y1: pt1[1],
        x2: pt2[0],
        y2: pt2[1]
      },
      style: lineStyle,
      strokeContainThreshold: opt.strokeContainThreshold || 5,
      silent: true,
      z2: 1
    }));
    var arrows = axisModel.get('axisLine.symbol');
    var arrowSize = axisModel.get('axisLine.symbolSize');
    var arrowOffset = axisModel.get('axisLine.symbolOffset') || 0;

    if (typeof arrowOffset === 'number') {
      arrowOffset = [arrowOffset, arrowOffset];
    }

    if (arrows != null) {
      if (typeof arrows === 'string') {
        // Use the same arrow for start and end point
        arrows = [arrows, arrows];
      }

      if (typeof arrowSize === 'string' || typeof arrowSize === 'number') {
        // Use the same size for width and height
        arrowSize = [arrowSize, arrowSize];
      }

      var symbolWidth = arrowSize[0];
      var symbolHeight = arrowSize[1];
      each([{
        rotate: opt.rotation + Math.PI / 2,
        offset: arrowOffset[0],
        r: 0
      }, {
        rotate: opt.rotation - Math.PI / 2,
        offset: arrowOffset[1],
        r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
      }], function (point, index) {
        if (arrows[index] !== 'none' && arrows[index] != null) {
          var symbol = createSymbol(arrows[index], -symbolWidth / 2, -symbolHeight / 2, symbolWidth, symbolHeight, lineStyle.stroke, true); // Calculate arrow position with offset

          var r = point.r + point.offset;
          var pos = [pt1[0] + r * Math.cos(opt.rotation), pt1[1] - r * Math.sin(opt.rotation)];
          symbol.attr({
            rotation: point.rotate,
            position: pos,
            silent: true,
            z2: 11
          });
          this.group.add(symbol);
        }
      }, this);
    }
  },

  /**
   * @private
   */
  axisTickLabel: function () {
    var axisModel = this.axisModel;
    var opt = this.opt;
    var ticksEls = buildAxisMajorTicks(this, axisModel, opt);
    var labelEls = buildAxisLabel(this, axisModel, opt);
    fixMinMaxLabelShow(axisModel, labelEls, ticksEls);
    buildAxisMinorTicks(this, axisModel, opt);
  },

  /**
   * @private
   */
  axisName: function () {
    var opt = this.opt;
    var axisModel = this.axisModel;
    var name = retrieve(opt.axisName, axisModel.get('name'));

    if (!name) {
      return;
    }

    var nameLocation = axisModel.get('nameLocation');
    var nameDirection = opt.nameDirection;
    var textStyleModel = axisModel.getModel('nameTextStyle');
    var gap = axisModel.get('nameGap') || 0;
    var extent = this.axisModel.axis.getExtent();
    var gapSignal = extent[0] > extent[1] ? -1 : 1;
    var pos = [nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2, // 'middle'
    // Reuse labelOffset.
    isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0];
    var labelLayout;
    var nameRotation = axisModel.get('nameRotate');

    if (nameRotation != null) {
      nameRotation = nameRotation * PI / 180; // To radian.
    }

    var axisNameAvailableWidth;

    if (isNameLocationCenter(nameLocation)) {
      labelLayout = innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, // Adapt to axis.
      nameDirection);
    } else {
      labelLayout = endTextLayout(opt, nameLocation, nameRotation || 0, extent);
      axisNameAvailableWidth = opt.axisNameAvailableWidth;

      if (axisNameAvailableWidth != null) {
        axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
        !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
      }
    }

    var textFont = textStyleModel.getFont();
    var truncateOpt = axisModel.get('nameTruncate', true) || {};
    var ellipsis = truncateOpt.ellipsis;
    var maxWidth = retrieve(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth); // FIXME
    // truncate rich text? (consider performance)

    var truncatedText = ellipsis != null && maxWidth != null ? formatUtil.truncateText(name, maxWidth, textFont, ellipsis, {
      minChar: 2,
      placeholder: truncateOpt.placeholder
    }) : name;
    var tooltipOpt = axisModel.get('tooltip', true);
    var mainType = axisModel.mainType;
    var formatterParams = {
      componentType: mainType,
      name: name,
      $vars: ['name']
    };
    formatterParams[mainType + 'Index'] = axisModel.componentIndex;
    var textEl = new graphic.Text({
      // Id for animation
      anid: 'name',
      __fullText: name,
      __truncatedText: truncatedText,
      position: pos,
      rotation: labelLayout.rotation,
      silent: isLabelSilent(axisModel),
      z2: 1,
      tooltip: tooltipOpt && tooltipOpt.show ? extend({
        content: name,
        formatter: function () {
          return name;
        },
        formatterParams: formatterParams
      }, tooltipOpt) : null
    });
    graphic.setTextStyle(textEl.style, textStyleModel, {
      text: truncatedText,
      textFont: textFont,
      textFill: textStyleModel.getTextColor() || axisModel.get('axisLine.lineStyle.color'),
      textAlign: textStyleModel.get('align') || labelLayout.textAlign,
      textVerticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
    });

    if (axisModel.get('triggerEvent')) {
      textEl.eventData = makeAxisEventDataBase(axisModel);
      textEl.eventData.targetType = 'axisName';
      textEl.eventData.name = name;
    } // FIXME


    this._dumbGroup.add(textEl);

    textEl.updateTransform();
    this.group.add(textEl);
    textEl.decomposeTransform();
  }
};

var makeAxisEventDataBase = AxisBuilder.makeAxisEventDataBase = function (axisModel) {
  var eventData = {
    componentType: axisModel.mainType,
    componentIndex: axisModel.componentIndex
  };
  eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
  return eventData;
};
/**
 * @public
 * @static
 * @param {Object} opt
 * @param {number} axisRotation in radian
 * @param {number} textRotation in radian
 * @param {number} direction
 * @return {Object} {
 *  rotation, // according to axis
 *  textAlign,
 *  textVerticalAlign
 * }
 */


var innerTextLayout = AxisBuilder.innerTextLayout = function (axisRotation, textRotation, direction) {
  var rotationDiff = remRadian(textRotation - axisRotation);
  var textAlign;
  var textVerticalAlign;

  if (isRadianAroundZero(rotationDiff)) {
    // Label is parallel with axis line.
    textVerticalAlign = direction > 0 ? 'top' : 'bottom';
    textAlign = 'center';
  } else if (isRadianAroundZero(rotationDiff - PI)) {
    // Label is inverse parallel with axis line.
    textVerticalAlign = direction > 0 ? 'bottom' : 'top';
    textAlign = 'center';
  } else {
    textVerticalAlign = 'middle';

    if (rotationDiff > 0 && rotationDiff < PI) {
      textAlign = direction > 0 ? 'right' : 'left';
    } else {
      textAlign = direction > 0 ? 'left' : 'right';
    }
  }

  return {
    rotation: rotationDiff,
    textAlign: textAlign,
    textVerticalAlign: textVerticalAlign
  };
};

function endTextLayout(opt, textPosition, textRotate, extent) {
  var rotationDiff = remRadian(textRotate - opt.rotation);
  var textAlign;
  var textVerticalAlign;
  var inverse = extent[0] > extent[1];
  var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;

  if (isRadianAroundZero(rotationDiff - PI / 2)) {
    textVerticalAlign = onLeft ? 'bottom' : 'top';
    textAlign = 'center';
  } else if (isRadianAroundZero(rotationDiff - PI * 1.5)) {
    textVerticalAlign = onLeft ? 'top' : 'bottom';
    textAlign = 'center';
  } else {
    textVerticalAlign = 'middle';

    if (rotationDiff < PI * 1.5 && rotationDiff > PI / 2) {
      textAlign = onLeft ? 'left' : 'right';
    } else {
      textAlign = onLeft ? 'right' : 'left';
    }
  }

  return {
    rotation: rotationDiff,
    textAlign: textAlign,
    textVerticalAlign: textVerticalAlign
  };
}

var isLabelSilent = AxisBuilder.isLabelSilent = function (axisModel) {
  var tooltipOpt = axisModel.get('tooltip');
  return axisModel.get('silent') // Consider mouse cursor, add these restrictions.
  || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
};

function fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
  if (shouldShowAllLabels(axisModel.axis)) {
    return;
  } // If min or max are user set, we need to check
  // If the tick on min(max) are overlap on their neighbour tick
  // If they are overlapped, we need to hide the min(max) tick label


  var showMinLabel = axisModel.get('axisLabel.showMinLabel');
  var showMaxLabel = axisModel.get('axisLabel.showMaxLabel'); // FIXME
  // Have not consider onBand yet, where tick els is more than label els.

  labelEls = labelEls || [];
  tickEls = tickEls || [];
  var firstLabel = labelEls[0];
  var nextLabel = labelEls[1];
  var lastLabel = labelEls[labelEls.length - 1];
  var prevLabel = labelEls[labelEls.length - 2];
  var firstTick = tickEls[0];
  var nextTick = tickEls[1];
  var lastTick = tickEls[tickEls.length - 1];
  var prevTick = tickEls[tickEls.length - 2];

  if (showMinLabel === false) {
    ignoreEl(firstLabel);
    ignoreEl(firstTick);
  } else if (isTwoLabelOverlapped(firstLabel, nextLabel)) {
    if (showMinLabel) {
      ignoreEl(nextLabel);
      ignoreEl(nextTick);
    } else {
      ignoreEl(firstLabel);
      ignoreEl(firstTick);
    }
  }

  if (showMaxLabel === false) {
    ignoreEl(lastLabel);
    ignoreEl(lastTick);
  } else if (isTwoLabelOverlapped(prevLabel, lastLabel)) {
    if (showMaxLabel) {
      ignoreEl(prevLabel);
      ignoreEl(prevTick);
    } else {
      ignoreEl(lastLabel);
      ignoreEl(lastTick);
    }
  }
}

function ignoreEl(el) {
  el && (el.ignore = true);
}

function isTwoLabelOverlapped(current, next, labelLayout) {
  // current and next has the same rotation.
  var firstRect = current && current.getBoundingRect().clone();
  var nextRect = next && next.getBoundingRect().clone();

  if (!firstRect || !nextRect) {
    return;
  } // When checking intersect of two rotated labels, we use mRotationBack
  // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.


  var mRotationBack = matrixUtil.identity([]);
  matrixUtil.rotate(mRotationBack, mRotationBack, -current.rotation);
  firstRect.applyTransform(matrixUtil.mul([], mRotationBack, current.getLocalTransform()));
  nextRect.applyTransform(matrixUtil.mul([], mRotationBack, next.getLocalTransform()));
  return firstRect.intersect(nextRect);
}

function isNameLocationCenter(nameLocation) {
  return nameLocation === 'middle' || nameLocation === 'center';
}

function createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, aniid) {
  var tickEls = [];
  var pt1 = [];
  var pt2 = [];

  for (var i = 0; i < ticksCoords.length; i++) {
    var tickCoord = ticksCoords[i].coord;
    pt1[0] = tickCoord;
    pt1[1] = 0;
    pt2[0] = tickCoord;
    pt2[1] = tickEndCoord;

    if (tickTransform) {
      v2ApplyTransform(pt1, pt1, tickTransform);
      v2ApplyTransform(pt2, pt2, tickTransform);
    } // Tick line, Not use group transform to have better line draw


    var tickEl = new graphic.Line({
      // Id for animation
      anid: aniid + '_' + ticksCoords[i].tickValue,
      subPixelOptimize: true,
      shape: {
        x1: pt1[0],
        y1: pt1[1],
        x2: pt2[0],
        y2: pt2[1]
      },
      style: tickLineStyle,
      z2: 2,
      silent: true
    });
    tickEls.push(tickEl);
  }

  return tickEls;
}

function buildAxisMajorTicks(axisBuilder, axisModel, opt) {
  var axis = axisModel.axis;
  var tickModel = axisModel.getModel('axisTick');

  if (!tickModel.get('show') || axis.scale.isBlank()) {
    return;
  }

  var lineStyleModel = tickModel.getModel('lineStyle');
  var tickEndCoord = opt.tickDirection * tickModel.get('length');
  var ticksCoords = axis.getTicksCoords();
  var ticksEls = createTicks(ticksCoords, axisBuilder._transform, tickEndCoord, defaults(lineStyleModel.getLineStyle(), {
    stroke: axisModel.get('axisLine.lineStyle.color')
  }), 'ticks');

  for (var i = 0; i < ticksEls.length; i++) {
    axisBuilder.group.add(ticksEls[i]);
  }

  return ticksEls;
}

function buildAxisMinorTicks(axisBuilder, axisModel, opt) {
  var axis = axisModel.axis;
  var minorTickModel = axisModel.getModel('minorTick');

  if (!minorTickModel.get('show') || axis.scale.isBlank()) {
    return;
  }

  var minorTicksCoords = axis.getMinorTicksCoords();

  if (!minorTicksCoords.length) {
    return;
  }

  var lineStyleModel = minorTickModel.getModel('lineStyle');
  var tickEndCoord = opt.tickDirection * minorTickModel.get('length');
  var minorTickLineStyle = defaults(lineStyleModel.getLineStyle(), defaults(axisModel.getModel('axisTick').getLineStyle(), {
    stroke: axisModel.get('axisLine.lineStyle.color')
  }));

  for (var i = 0; i < minorTicksCoords.length; i++) {
    var minorTicksEls = createTicks(minorTicksCoords[i], axisBuilder._transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);

    for (var k = 0; k < minorTicksEls.length; k++) {
      axisBuilder.group.add(minorTicksEls[k]);
    }
  }
}

function buildAxisLabel(axisBuilder, axisModel, opt) {
  var axis = axisModel.axis;
  var show = retrieve(opt.axisLabelShow, axisModel.get('axisLabel.show'));

  if (!show || axis.scale.isBlank()) {
    return;
  }

  var labelModel = axisModel.getModel('axisLabel');
  var labelMargin = labelModel.get('margin');
  var labels = axis.getViewLabels(); // Special label rotate.

  var labelRotation = (retrieve(opt.labelRotate, labelModel.get('rotate')) || 0) * PI / 180;
  var labelLayout = innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
  var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
  var labelEls = [];
  var silent = isLabelSilent(axisModel);
  var triggerEvent = axisModel.get('triggerEvent');
  each(labels, function (labelItem, index) {
    var tickValue = labelItem.tickValue;
    var formattedLabel = labelItem.formattedLabel;
    var rawLabel = labelItem.rawLabel;
    var itemLabelModel = labelModel;

    if (rawCategoryData && rawCategoryData[tickValue] && rawCategoryData[tickValue].textStyle) {
      itemLabelModel = new Model(rawCategoryData[tickValue].textStyle, labelModel, axisModel.ecModel);
    }

    var textColor = itemLabelModel.getTextColor() || axisModel.get('axisLine.lineStyle.color');
    var tickCoord = axis.dataToCoord(tickValue);
    var pos = [tickCoord, opt.labelOffset + opt.labelDirection * labelMargin];
    var textEl = new graphic.Text({
      // Id for animation
      anid: 'label_' + tickValue,
      position: pos,
      rotation: labelLayout.rotation,
      silent: silent,
      z2: 10
    });
    graphic.setTextStyle(textEl.style, itemLabelModel, {
      text: formattedLabel,
      textAlign: itemLabelModel.getShallow('align', true) || labelLayout.textAlign,
      textVerticalAlign: itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign,
      textFill: typeof textColor === 'function' ? textColor( // (1) In category axis with data zoom, tick is not the original
      // index of axis.data. So tick should not be exposed to user
      // in category axis.
      // (2) Compatible with previous version, which always use formatted label as
      // input. But in interval scale the formatted label is like '223,445', which
      // maked user repalce ','. So we modify it to return original val but remain
      // it as 'string' to avoid error in replacing.
      axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
    }); // Pack data for mouse event

    if (triggerEvent) {
      textEl.eventData = makeAxisEventDataBase(axisModel);
      textEl.eventData.targetType = 'axisLabel';
      textEl.eventData.value = rawLabel;
    } // FIXME


    axisBuilder._dumbGroup.add(textEl);

    textEl.updateTransform();
    labelEls.push(textEl);
    axisBuilder.group.add(textEl);
    textEl.decomposeTransform();
  });
  return labelEls;
}

var _default = AxisBuilder;
module.exports = _default;

/***/ }),
/* 152 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var features = {};

function register(name, ctor) {
  features[name] = ctor;
}

function get(name) {
  return features[name];
}

exports.register = register;
exports.get = get;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(48);

var _extends3 = _interopRequireDefault(_extends2);

exports.getTodayTime = getTodayTime;
exports.getTitleString = getTitleString;
exports.getTodayTimeStr = getTodayTimeStr;
exports.getMonthName = getMonthName;
exports.syncTime = syncTime;
exports.getTimeConfig = getTimeConfig;
exports.isTimeValidByConfig = isTimeValidByConfig;
exports.isTimeValid = isTimeValid;
exports.isAllowedDate = isAllowedDate;
exports.formatDate = formatDate;

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var defaultDisabledTime = {
  disabledHours: function disabledHours() {
    return [];
  },
  disabledMinutes: function disabledMinutes() {
    return [];
  },
  disabledSeconds: function disabledSeconds() {
    return [];
  }
};

function getTodayTime(value) {
  var today = (0, _moment2['default'])();
  today.locale(value.locale()).utcOffset(value.utcOffset());
  return today;
}

function getTitleString(value) {
  return value.format('LL');
}

function getTodayTimeStr(value) {
  var today = getTodayTime(value);
  return getTitleString(today);
}

function getMonthName(month) {
  var locale = month.locale();
  var localeData = month.localeData();
  return localeData[locale === 'zh-cn' ? 'months' : 'monthsShort'](month);
}

function syncTime(from, to) {
  if (!_moment2['default'].isMoment(from) || !_moment2['default'].isMoment(to)) return;
  to.hour(from.hour());
  to.minute(from.minute());
  to.second(from.second());
  to.millisecond(from.millisecond());
}

function getTimeConfig(value, disabledTime) {
  var disabledTimeConfig = disabledTime ? disabledTime(value) : {};
  disabledTimeConfig = (0, _extends3['default'])({}, defaultDisabledTime, disabledTimeConfig);
  return disabledTimeConfig;
}

function isTimeValidByConfig(value, disabledTimeConfig) {
  var invalidTime = false;
  if (value) {
    var hour = value.hour();
    var minutes = value.minute();
    var seconds = value.second();
    var disabledHours = disabledTimeConfig.disabledHours();
    if (disabledHours.indexOf(hour) === -1) {
      var disabledMinutes = disabledTimeConfig.disabledMinutes(hour);
      if (disabledMinutes.indexOf(minutes) === -1) {
        var disabledSeconds = disabledTimeConfig.disabledSeconds(hour, minutes);
        invalidTime = disabledSeconds.indexOf(seconds) !== -1;
      } else {
        invalidTime = true;
      }
    } else {
      invalidTime = true;
    }
  }
  return !invalidTime;
}

function isTimeValid(value, disabledTime) {
  var disabledTimeConfig = getTimeConfig(value, disabledTime);
  return isTimeValidByConfig(value, disabledTimeConfig);
}

function isAllowedDate(value, disabledDate, disabledTime) {
  if (disabledDate) {
    if (disabledDate(value)) {
      return false;
    }
  }
  if (disabledTime) {
    if (!isTimeValid(value, disabledTime)) {
      return false;
    }
  }
  return true;
}

function formatDate(value, format) {
  if (!value) {
    return '';
  }

  if (Array.isArray(format)) {
    format = format[0];
  }

  return value.format(format);
}

/***/ }),
/* 154 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(452);
var defined = __webpack_require__(319);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(802);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(992),
    getValue = __webpack_require__(997);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 159 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 161 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(543);
var enumBugKeys = __webpack_require__(372);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(105);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(45);
var dPs = __webpack_require__(544);
var enumBugKeys = __webpack_require__(372);
var IE_PROTO = __webpack_require__(371)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(369)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(373).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(543);
var hiddenKeys = __webpack_require__(372).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(49);
var dP = __webpack_require__(66);
var DESCRIPTORS = __webpack_require__(63);
var SPECIES = __webpack_require__(56)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(103);
var call = __webpack_require__(556);
var isArrayIter = __webpack_require__(384);
var anObject = __webpack_require__(45);
var toLength = __webpack_require__(58);
var getIterFn = __webpack_require__(386);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(91);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(52);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Upload = _interopRequireDefault(__webpack_require__(589));

var _Dragger = _interopRequireDefault(__webpack_require__(1470));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Upload["default"].Dragger = _Dragger["default"];
var _default = _Upload["default"];
exports["default"] = _default;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(1471);

__webpack_require__(605);

__webpack_require__(100);

/***/ }),
/* 173 */
/***/ (function(module, exports) {

/**
 * Event Mixin
 * @module zrender/mixin/Eventful
 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         pissang (https://www.github.com/pissang)
 */
var arrySlice = Array.prototype.slice;
/**
 * Event dispatcher.
 *
 * @alias module:zrender/mixin/Eventful
 * @constructor
 * @param {Object} [eventProcessor] The object eventProcessor is the scope when
 *        `eventProcessor.xxx` called.
 * @param {Function} [eventProcessor.normalizeQuery]
 *        param: {string|Object} Raw query.
 *        return: {string|Object} Normalized query.
 * @param {Function} [eventProcessor.filter] Event will be dispatched only
 *        if it returns `true`.
 *        param: {string} eventType
 *        param: {string|Object} query
 *        return: {boolean}
 * @param {Function} [eventProcessor.afterTrigger] Called after all handlers called.
 *        param: {string} eventType
 */

var Eventful = function (eventProcessor) {
  this._$handlers = {};
  this._$eventProcessor = eventProcessor;
};

Eventful.prototype = {
  constructor: Eventful,

  /**
   * The handler can only be triggered once, then removed.
   *
   * @param {string} event The event name.
   * @param {string|Object} [query] Condition used on event filter.
   * @param {Function} handler The event handler.
   * @param {Object} context
   */
  one: function (event, query, handler, context) {
    return on(this, event, query, handler, context, true);
  },

  /**
   * Bind a handler.
   *
   * @param {string} event The event name.
   * @param {string|Object} [query] Condition used on event filter.
   * @param {Function} handler The event handler.
   * @param {Object} [context]
   */
  on: function (event, query, handler, context) {
    return on(this, event, query, handler, context, false);
  },

  /**
   * Whether any handler has bound.
   *
   * @param  {string}  event
   * @return {boolean}
   */
  isSilent: function (event) {
    var _h = this._$handlers;
    return !_h[event] || !_h[event].length;
  },

  /**
   * Unbind a event.
   *
   * @param {string} [event] The event name.
   *        If no `event` input, "off" all listeners.
   * @param {Function} [handler] The event handler.
   *        If no `handler` input, "off" all listeners of the `event`.
   */
  off: function (event, handler) {
    var _h = this._$handlers;

    if (!event) {
      this._$handlers = {};
      return this;
    }

    if (handler) {
      if (_h[event]) {
        var newList = [];

        for (var i = 0, l = _h[event].length; i < l; i++) {
          if (_h[event][i].h !== handler) {
            newList.push(_h[event][i]);
          }
        }

        _h[event] = newList;
      }

      if (_h[event] && _h[event].length === 0) {
        delete _h[event];
      }
    } else {
      delete _h[event];
    }

    return this;
  },

  /**
   * Dispatch a event.
   *
   * @param {string} type The event name.
   */
  trigger: function (type) {
    var _h = this._$handlers[type];
    var eventProcessor = this._$eventProcessor;

    if (_h) {
      var args = arguments;
      var argLen = args.length;

      if (argLen > 3) {
        args = arrySlice.call(args, 1);
      }

      var len = _h.length;

      for (var i = 0; i < len;) {
        var hItem = _h[i];

        if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) {
          i++;
          continue;
        } // Optimize advise from backbone


        switch (argLen) {
          case 1:
            hItem.h.call(hItem.ctx);
            break;

          case 2:
            hItem.h.call(hItem.ctx, args[1]);
            break;

          case 3:
            hItem.h.call(hItem.ctx, args[1], args[2]);
            break;

          default:
            // have more than 2 given arguments
            hItem.h.apply(hItem.ctx, args);
            break;
        }

        if (hItem.one) {
          _h.splice(i, 1);

          len--;
        } else {
          i++;
        }
      }
    }

    eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
    return this;
  },

  /**
   * Dispatch a event with context, which is specified at the last parameter.
   *
   * @param {string} type The event name.
   */
  triggerWithContext: function (type) {
    var _h = this._$handlers[type];
    var eventProcessor = this._$eventProcessor;

    if (_h) {
      var args = arguments;
      var argLen = args.length;

      if (argLen > 4) {
        args = arrySlice.call(args, 1, args.length - 1);
      }

      var ctx = args[args.length - 1];
      var len = _h.length;

      for (var i = 0; i < len;) {
        var hItem = _h[i];

        if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) {
          i++;
          continue;
        } // Optimize advise from backbone


        switch (argLen) {
          case 1:
            hItem.h.call(ctx);
            break;

          case 2:
            hItem.h.call(ctx, args[1]);
            break;

          case 3:
            hItem.h.call(ctx, args[1], args[2]);
            break;

          default:
            // have more than 2 given arguments
            hItem.h.apply(ctx, args);
            break;
        }

        if (hItem.one) {
          _h.splice(i, 1);

          len--;
        } else {
          i++;
        }
      }
    }

    eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
    return this;
  }
};

function normalizeQuery(host, query) {
  var eventProcessor = host._$eventProcessor;

  if (query != null && eventProcessor && eventProcessor.normalizeQuery) {
    query = eventProcessor.normalizeQuery(query);
  }

  return query;
}

function on(eventful, event, query, handler, context, isOnce) {
  var _h = eventful._$handlers;

  if (typeof query === 'function') {
    context = handler;
    handler = query;
    query = null;
  }

  if (!handler || !event) {
    return eventful;
  }

  query = normalizeQuery(eventful, query);

  if (!_h[event]) {
    _h[event] = [];
  }

  for (var i = 0; i < _h[event].length; i++) {
    if (_h[event][i].h === handler) {
      return eventful;
    }
  }

  var wrap = {
    h: handler,
    one: isOnce,
    query: query,
    ctx: context || eventful,
    // FIXME
    // Do not publish this feature util it is proved that it makes sense.
    callAtLast: handler.zrEventfulCallAtLast
  };
  var lastIndex = _h[event].length - 1;
  var lastWrap = _h[event][lastIndex];
  lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
  return eventful;
} // ----------------------
// The events in zrender
// ----------------------

/**
 * @event module:zrender/mixin/Eventful#onclick
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmouseover
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmouseout
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmousemove
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmousewheel
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmousedown
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmouseup
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondrag
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondragstart
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondragend
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondragenter
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondragleave
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondragover
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondrop
 * @type {Function}
 * @default null
 */


var _default = Eventful;
module.exports = _default;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(1);

var Element = __webpack_require__(615);

var BoundingRect = __webpack_require__(57);

/**
 * Group是一个容器，可以插入子节点，Group的变换也会被应用到子节点上
 * @module zrender/graphic/Group
 * @example
 *     var Group = require('zrender/container/Group');
 *     var Circle = require('zrender/graphic/shape/Circle');
 *     var g = new Group();
 *     g.position[0] = 100;
 *     g.position[1] = 100;
 *     g.add(new Circle({
 *         style: {
 *             x: 100,
 *             y: 100,
 *             r: 20,
 *         }
 *     }));
 *     zr.add(g);
 */

/**
 * @alias module:zrender/graphic/Group
 * @constructor
 * @extends module:zrender/mixin/Transformable
 * @extends module:zrender/mixin/Eventful
 */
var Group = function (opts) {
  opts = opts || {};
  Element.call(this, opts);

  for (var key in opts) {
    if (opts.hasOwnProperty(key)) {
      this[key] = opts[key];
    }
  }

  this._children = [];
  this.__storage = null;
  this.__dirty = true;
};

Group.prototype = {
  constructor: Group,
  isGroup: true,

  /**
   * @type {string}
   */
  type: 'group',

  /**
   * 所有子孙元素是否响应鼠标事件
   * @name module:/zrender/container/Group#silent
   * @type {boolean}
   * @default false
   */
  silent: false,

  /**
   * @return {Array.<module:zrender/Element>}
   */
  children: function () {
    return this._children.slice();
  },

  /**
   * 获取指定 index 的儿子节点
   * @param  {number} idx
   * @return {module:zrender/Element}
   */
  childAt: function (idx) {
    return this._children[idx];
  },

  /**
   * 获取指定名字的儿子节点
   * @param  {string} name
   * @return {module:zrender/Element}
   */
  childOfName: function (name) {
    var children = this._children;

    for (var i = 0; i < children.length; i++) {
      if (children[i].name === name) {
        return children[i];
      }
    }
  },

  /**
   * @return {number}
   */
  childCount: function () {
    return this._children.length;
  },

  /**
   * 添加子节点到最后
   * @param {module:zrender/Element} child
   */
  add: function (child) {
    if (child && child !== this && child.parent !== this) {
      this._children.push(child);

      this._doAdd(child);
    }

    return this;
  },

  /**
   * 添加子节点在 nextSibling 之前
   * @param {module:zrender/Element} child
   * @param {module:zrender/Element} nextSibling
   */
  addBefore: function (child, nextSibling) {
    if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
      var children = this._children;
      var idx = children.indexOf(nextSibling);

      if (idx >= 0) {
        children.splice(idx, 0, child);

        this._doAdd(child);
      }
    }

    return this;
  },
  _doAdd: function (child) {
    if (child.parent) {
      child.parent.remove(child);
    }

    child.parent = this;
    var storage = this.__storage;
    var zr = this.__zr;

    if (storage && storage !== child.__storage) {
      storage.addToStorage(child);

      if (child instanceof Group) {
        child.addChildrenToStorage(storage);
      }
    }

    zr && zr.refresh();
  },

  /**
   * 移除子节点
   * @param {module:zrender/Element} child
   */
  remove: function (child) {
    var zr = this.__zr;
    var storage = this.__storage;
    var children = this._children;
    var idx = zrUtil.indexOf(children, child);

    if (idx < 0) {
      return this;
    }

    children.splice(idx, 1);
    child.parent = null;

    if (storage) {
      storage.delFromStorage(child);

      if (child instanceof Group) {
        child.delChildrenFromStorage(storage);
      }
    }

    zr && zr.refresh();
    return this;
  },

  /**
   * 移除所有子节点
   */
  removeAll: function () {
    var children = this._children;
    var storage = this.__storage;
    var child;
    var i;

    for (i = 0; i < children.length; i++) {
      child = children[i];

      if (storage) {
        storage.delFromStorage(child);

        if (child instanceof Group) {
          child.delChildrenFromStorage(storage);
        }
      }

      child.parent = null;
    }

    children.length = 0;
    return this;
  },

  /**
   * 遍历所有子节点
   * @param  {Function} cb
   * @param  {}   context
   */
  eachChild: function (cb, context) {
    var children = this._children;

    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      cb.call(context, child, i);
    }

    return this;
  },

  /**
   * 深度优先遍历所有子孙节点
   * @param  {Function} cb
   * @param  {}   context
   */
  traverse: function (cb, context) {
    for (var i = 0; i < this._children.length; i++) {
      var child = this._children[i];
      cb.call(context, child);

      if (child.type === 'group') {
        child.traverse(cb, context);
      }
    }

    return this;
  },
  addChildrenToStorage: function (storage) {
    for (var i = 0; i < this._children.length; i++) {
      var child = this._children[i];
      storage.addToStorage(child);

      if (child instanceof Group) {
        child.addChildrenToStorage(storage);
      }
    }
  },
  delChildrenFromStorage: function (storage) {
    for (var i = 0; i < this._children.length; i++) {
      var child = this._children[i];
      storage.delFromStorage(child);

      if (child instanceof Group) {
        child.delChildrenFromStorage(storage);
      }
    }
  },
  dirty: function () {
    this.__dirty = true;
    this.__zr && this.__zr.refresh();
    return this;
  },

  /**
   * @return {module:zrender/core/BoundingRect}
   */
  getBoundingRect: function (includeChildren) {
    // TODO Caching
    var rect = null;
    var tmpRect = new BoundingRect(0, 0, 0, 0);
    var children = includeChildren || this._children;
    var tmpMat = [];

    for (var i = 0; i < children.length; i++) {
      var child = children[i];

      if (child.ignore || child.invisible) {
        continue;
      }

      var childRect = child.getBoundingRect();
      var transform = child.getLocalTransform(tmpMat); // TODO
      // The boundingRect cacluated by transforming original
      // rect may be bigger than the actual bundingRect when rotation
      // is used. (Consider a circle rotated aginst its center, where
      // the actual boundingRect should be the same as that not be
      // rotated.) But we can not find better approach to calculate
      // actual boundingRect yet, considering performance.

      if (transform) {
        tmpRect.copy(childRect);
        tmpRect.applyTransform(transform);
        rect = rect || tmpRect.clone();
        rect.union(tmpRect);
      } else {
        rect = rect || childRect.clone();
        rect.union(childRect);
      }
    }

    return rect || tmpRect;
  }
};
zrUtil.inherits(Group, Element);
var _default = Group;
module.exports = _default;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Displayable = __webpack_require__(233);

var zrUtil = __webpack_require__(1);

var textContain = __webpack_require__(93);

var textHelper = __webpack_require__(295);

var _constant = __webpack_require__(294);

var ContextCachedBy = _constant.ContextCachedBy;

/**
 * @alias zrender/graphic/Text
 * @extends module:zrender/graphic/Displayable
 * @constructor
 * @param {Object} opts
 */
var Text = function (opts) {
  // jshint ignore:line
  Displayable.call(this, opts);
};

Text.prototype = {
  constructor: Text,
  type: 'text',
  brush: function (ctx, prevEl) {
    var style = this.style; // Optimize, avoid normalize every time.

    this.__dirty && textHelper.normalizeTextStyle(style, true); // Use props with prefix 'text'.

    style.fill = style.stroke = style.shadowBlur = style.shadowColor = style.shadowOffsetX = style.shadowOffsetY = null;
    var text = style.text; // Convert to string

    text != null && (text += ''); // Do not apply style.bind in Text node. Because the real bind job
    // is in textHelper.renderText, and performance of text render should
    // be considered.
    // style.bind(ctx, this, prevEl);

    if (!textHelper.needDrawText(text, style)) {
      // The current el.style is not applied
      // and should not be used as cache.
      ctx.__attrCachedBy = ContextCachedBy.NONE;
      return;
    }

    this.setTransform(ctx);
    textHelper.renderText(this, ctx, text, style, null, prevEl);
    this.restoreTransform(ctx);
  },
  getBoundingRect: function () {
    var style = this.style; // Optimize, avoid normalize every time.

    this.__dirty && textHelper.normalizeTextStyle(style, true);

    if (!this._rect) {
      var text = style.text;
      text != null ? text += '' : text = '';
      var rect = textContain.getBoundingRect(style.text + '', style.font, style.textAlign, style.textVerticalAlign, style.textPadding, style.textLineHeight, style.rich);
      rect.x += style.x || 0;
      rect.y += style.y || 0;

      if (textHelper.getStroke(style.textStroke, style.textStrokeWidth)) {
        var w = style.textStrokeWidth;
        rect.x -= w / 2;
        rect.y -= w / 2;
        rect.width += w;
        rect.height += w;
      }

      this._rect = rect;
    }

    return this._rect;
  }
};
zrUtil.inherits(Text, Displayable);
var _default = Text;
module.exports = _default;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var _util = __webpack_require__(1);

var isTypedArray = _util.isTypedArray;
var extend = _util.extend;
var assert = _util.assert;
var each = _util.each;
var isObject = _util.isObject;

var _model = __webpack_require__(44);

var getDataItemValue = _model.getDataItemValue;
var isDataItemOption = _model.isDataItemOption;

var _number = __webpack_require__(37);

var parseDate = _number.parseDate;

var Source = __webpack_require__(236);

var _sourceType = __webpack_require__(237);

var SOURCE_FORMAT_TYPED_ARRAY = _sourceType.SOURCE_FORMAT_TYPED_ARRAY;
var SOURCE_FORMAT_ARRAY_ROWS = _sourceType.SOURCE_FORMAT_ARRAY_ROWS;
var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
var SOURCE_FORMAT_OBJECT_ROWS = _sourceType.SOURCE_FORMAT_OBJECT_ROWS;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// TODO
// ??? refactor? check the outer usage of data provider.
// merge with defaultDimValueGetter?

/**
 * If normal array used, mutable chunk size is supported.
 * If typed array used, chunk size must be fixed.
 */
function DefaultDataProvider(source, dimSize) {
  if (!Source.isInstance(source)) {
    source = Source.seriesDataToSource(source);
  }

  this._source = source;
  var data = this._data = source.data;
  var sourceFormat = source.sourceFormat; // Typed array. TODO IE10+?

  if (sourceFormat === SOURCE_FORMAT_TYPED_ARRAY) {
    this._offset = 0;
    this._dimSize = dimSize;
    this._data = data;
  }

  var methods = providerMethods[sourceFormat === SOURCE_FORMAT_ARRAY_ROWS ? sourceFormat + '_' + source.seriesLayoutBy : sourceFormat];
  extend(this, methods);
}

var providerProto = DefaultDataProvider.prototype; // If data is pure without style configuration

providerProto.pure = false; // If data is persistent and will not be released after use.

providerProto.persistent = true; // ???! FIXME legacy data provider do not has method getSource

providerProto.getSource = function () {
  return this._source;
};

var providerMethods = {
  'arrayRows_column': {
    pure: true,
    count: function () {
      return Math.max(0, this._data.length - this._source.startIndex);
    },
    getItem: function (idx) {
      return this._data[idx + this._source.startIndex];
    },
    appendData: appendDataSimply
  },
  'arrayRows_row': {
    pure: true,
    count: function () {
      var row = this._data[0];
      return row ? Math.max(0, row.length - this._source.startIndex) : 0;
    },
    getItem: function (idx) {
      idx += this._source.startIndex;
      var item = [];
      var data = this._data;

      for (var i = 0; i < data.length; i++) {
        var row = data[i];
        item.push(row ? row[idx] : null);
      }

      return item;
    },
    appendData: function () {
      throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
    }
  },
  'objectRows': {
    pure: true,
    count: countSimply,
    getItem: getItemSimply,
    appendData: appendDataSimply
  },
  'keyedColumns': {
    pure: true,
    count: function () {
      var dimName = this._source.dimensionsDefine[0].name;
      var col = this._data[dimName];
      return col ? col.length : 0;
    },
    getItem: function (idx) {
      var item = [];
      var dims = this._source.dimensionsDefine;

      for (var i = 0; i < dims.length; i++) {
        var col = this._data[dims[i].name];
        item.push(col ? col[idx] : null);
      }

      return item;
    },
    appendData: function (newData) {
      var data = this._data;
      each(newData, function (newCol, key) {
        var oldCol = data[key] || (data[key] = []);

        for (var i = 0; i < (newCol || []).length; i++) {
          oldCol.push(newCol[i]);
        }
      });
    }
  },
  'original': {
    count: countSimply,
    getItem: getItemSimply,
    appendData: appendDataSimply
  },
  'typedArray': {
    persistent: false,
    pure: true,
    count: function () {
      return this._data ? this._data.length / this._dimSize : 0;
    },
    getItem: function (idx, out) {
      idx = idx - this._offset;
      out = out || [];
      var offset = this._dimSize * idx;

      for (var i = 0; i < this._dimSize; i++) {
        out[i] = this._data[offset + i];
      }

      return out;
    },
    appendData: function (newData) {
      this._data = newData;
    },
    // Clean self if data is already used.
    clean: function () {
      // PENDING
      this._offset += this.count();
      this._data = null;
    }
  }
};

function countSimply() {
  return this._data.length;
}

function getItemSimply(idx) {
  return this._data[idx];
}

function appendDataSimply(newData) {
  for (var i = 0; i < newData.length; i++) {
    this._data.push(newData[i]);
  }
}

var rawValueGetters = {
  arrayRows: getRawValueSimply,
  objectRows: function (dataItem, dataIndex, dimIndex, dimName) {
    return dimIndex != null ? dataItem[dimName] : dataItem;
  },
  keyedColumns: getRawValueSimply,
  original: function (dataItem, dataIndex, dimIndex, dimName) {
    // FIXME
    // In some case (markpoint in geo (geo-map.html)), dataItem
    // is {coord: [...]}
    var value = getDataItemValue(dataItem);
    return dimIndex == null || !(value instanceof Array) ? value : value[dimIndex];
  },
  typedArray: getRawValueSimply
};

function getRawValueSimply(dataItem, dataIndex, dimIndex, dimName) {
  return dimIndex != null ? dataItem[dimIndex] : dataItem;
}

var defaultDimValueGetters = {
  arrayRows: getDimValueSimply,
  objectRows: function (dataItem, dimName, dataIndex, dimIndex) {
    return converDataValue(dataItem[dimName], this._dimensionInfos[dimName]);
  },
  keyedColumns: getDimValueSimply,
  original: function (dataItem, dimName, dataIndex, dimIndex) {
    // Performance sensitive, do not use modelUtil.getDataItemValue.
    // If dataItem is an plain object with no value field, the var `value`
    // will be assigned with the object, but it will be tread correctly
    // in the `convertDataValue`.
    var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value); // If any dataItem is like { value: 10 }

    if (!this._rawData.pure && isDataItemOption(dataItem)) {
      this.hasItemOption = true;
    }

    return converDataValue(value instanceof Array ? value[dimIndex] // If value is a single number or something else not array.
    : value, this._dimensionInfos[dimName]);
  },
  typedArray: function (dataItem, dimName, dataIndex, dimIndex) {
    return dataItem[dimIndex];
  }
};

function getDimValueSimply(dataItem, dimName, dataIndex, dimIndex) {
  return converDataValue(dataItem[dimIndex], this._dimensionInfos[dimName]);
}
/**
 * This helper method convert value in data.
 * @param {string|number|Date} value
 * @param {Object|string} [dimInfo] If string (like 'x'), dimType defaults 'number'.
 *        If "dimInfo.ordinalParseAndSave", ordinal value can be parsed.
 */


function converDataValue(value, dimInfo) {
  // Performance sensitive.
  var dimType = dimInfo && dimInfo.type;

  if (dimType === 'ordinal') {
    // If given value is a category string
    var ordinalMeta = dimInfo && dimInfo.ordinalMeta;
    return ordinalMeta ? ordinalMeta.parseAndCollect(value) : value;
  }

  if (dimType === 'time' // spead up when using timestamp
  && typeof value !== 'number' && value != null && value !== '-') {
    value = +parseDate(value);
  } // dimType defaults 'number'.
  // If dimType is not ordinal and value is null or undefined or NaN or '-',
  // parse to NaN.


  return value == null || value === '' ? NaN // If string (like '-'), using '+' parse to NaN
  // If object, also parse to NaN
  : +value;
} // ??? FIXME can these logic be more neat: getRawValue, getRawDataItem,
// Consider persistent.
// Caution: why use raw value to display on label or tooltip?
// A reason is to avoid format. For example time value we do not know
// how to format is expected. More over, if stack is used, calculated
// value may be 0.91000000001, which have brings trouble to display.
// TODO: consider how to treat null/undefined/NaN when display?

/**
 * @param {module:echarts/data/List} data
 * @param {number} dataIndex
 * @param {string|number} [dim] dimName or dimIndex
 * @return {Array.<number>|string|number} can be null/undefined.
 */


function retrieveRawValue(data, dataIndex, dim) {
  if (!data) {
    return;
  } // Consider data may be not persistent.


  var dataItem = data.getRawDataItem(dataIndex);

  if (dataItem == null) {
    return;
  }

  var sourceFormat = data.getProvider().getSource().sourceFormat;
  var dimName;
  var dimIndex;
  var dimInfo = data.getDimensionInfo(dim);

  if (dimInfo) {
    dimName = dimInfo.name;
    dimIndex = dimInfo.index;
  }

  return rawValueGetters[sourceFormat](dataItem, dataIndex, dimIndex, dimName);
}
/**
 * Compatible with some cases (in pie, map) like:
 * data: [{name: 'xx', value: 5, selected: true}, ...]
 * where only sourceFormat is 'original' and 'objectRows' supported.
 *
 * ??? TODO
 * Supported detail options in data item when using 'arrayRows'.
 *
 * @param {module:echarts/data/List} data
 * @param {number} dataIndex
 * @param {string} attr like 'selected'
 */


function retrieveRawAttr(data, dataIndex, attr) {
  if (!data) {
    return;
  }

  var sourceFormat = data.getProvider().getSource().sourceFormat;

  if (sourceFormat !== SOURCE_FORMAT_ORIGINAL && sourceFormat !== SOURCE_FORMAT_OBJECT_ROWS) {
    return;
  }

  var dataItem = data.getRawDataItem(dataIndex);

  if (sourceFormat === SOURCE_FORMAT_ORIGINAL && !isObject(dataItem)) {
    dataItem = null;
  }

  if (dataItem) {
    return dataItem[attr];
  }
}

exports.DefaultDataProvider = DefaultDataProvider;
exports.defaultDimValueGetters = defaultDimValueGetters;
exports.retrieveRawValue = retrieveRawValue;
exports.retrieveRawAttr = retrieveRawAttr;

/***/ }),
/* 177 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function defaultKeyGetter(item) {
  return item;
}
/**
 * @param {Array} oldArr
 * @param {Array} newArr
 * @param {Function} oldKeyGetter
 * @param {Function} newKeyGetter
 * @param {Object} [context] Can be visited by this.context in callback.
 */


function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context) {
  this._old = oldArr;
  this._new = newArr;
  this._oldKeyGetter = oldKeyGetter || defaultKeyGetter;
  this._newKeyGetter = newKeyGetter || defaultKeyGetter;
  this.context = context;
}

DataDiffer.prototype = {
  constructor: DataDiffer,

  /**
   * Callback function when add a data
   */
  add: function (func) {
    this._add = func;
    return this;
  },

  /**
   * Callback function when update a data
   */
  update: function (func) {
    this._update = func;
    return this;
  },

  /**
   * Callback function when remove a data
   */
  remove: function (func) {
    this._remove = func;
    return this;
  },
  execute: function () {
    var oldArr = this._old;
    var newArr = this._new;
    var oldDataIndexMap = {};
    var newDataIndexMap = {};
    var oldDataKeyArr = [];
    var newDataKeyArr = [];
    var i;
    initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter', this);
    initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter', this);

    for (i = 0; i < oldArr.length; i++) {
      var key = oldDataKeyArr[i];
      var idx = newDataIndexMap[key]; // idx can never be empty array here. see 'set null' logic below.

      if (idx != null) {
        // Consider there is duplicate key (for example, use dataItem.name as key).
        // We should make sure every item in newArr and oldArr can be visited.
        var len = idx.length;

        if (len) {
          len === 1 && (newDataIndexMap[key] = null);
          idx = idx.shift();
        } else {
          newDataIndexMap[key] = null;
        }

        this._update && this._update(idx, i);
      } else {
        this._remove && this._remove(i);
      }
    }

    for (var i = 0; i < newDataKeyArr.length; i++) {
      var key = newDataKeyArr[i];

      if (newDataIndexMap.hasOwnProperty(key)) {
        var idx = newDataIndexMap[key];

        if (idx == null) {
          continue;
        } // idx can never be empty array here. see 'set null' logic above.


        if (!idx.length) {
          this._add && this._add(idx);
        } else {
          for (var j = 0, len = idx.length; j < len; j++) {
            this._add && this._add(idx[j]);
          }
        }
      }
    }
  }
};

function initIndexMap(arr, map, keyArr, keyGetterName, dataDiffer) {
  for (var i = 0; i < arr.length; i++) {
    // Add prefix to avoid conflict with Object.prototype.
    var key = '_ec_' + dataDiffer[keyGetterName](arr[i], i);
    var existence = map[key];

    if (existence == null) {
      keyArr.push(key);
      map[key] = i;
    } else {
      if (!existence.length) {
        map[key] = existence = [existence];
      }

      existence.push(i);
    }
  }
}

var _default = DataDiffer;
module.exports = _default;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(1);

var isFunction = _util.isFunction;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(seriesType, defaultSymbolType, legendSymbol) {
  // Encoding visual for all series include which is filtered for legend drawing
  return {
    seriesType: seriesType,
    // For legend.
    performRawSeries: true,
    reset: function (seriesModel, ecModel, api) {
      var data = seriesModel.getData();
      var symbolType = seriesModel.get('symbol');
      var symbolSize = seriesModel.get('symbolSize');
      var keepAspect = seriesModel.get('symbolKeepAspect');
      var symbolRotate = seriesModel.get('symbolRotate');
      var hasSymbolTypeCallback = isFunction(symbolType);
      var hasSymbolSizeCallback = isFunction(symbolSize);
      var hasSymbolRotateCallback = isFunction(symbolRotate);
      var hasCallback = hasSymbolTypeCallback || hasSymbolSizeCallback || hasSymbolRotateCallback;
      var seriesSymbol = !hasSymbolTypeCallback && symbolType ? symbolType : defaultSymbolType;
      var seriesSymbolSize = !hasSymbolSizeCallback ? symbolSize : null;
      var seriesSymbolRotate = !hasSymbolRotateCallback ? seriesSymbolRotate : null;
      data.setVisual({
        legendSymbol: legendSymbol || seriesSymbol,
        // If seting callback functions on `symbol` or `symbolSize`, for simplicity and avoiding
        // to bring trouble, we do not pick a reuslt from one of its calling on data item here,
        // but just use the default value. Callback on `symbol` or `symbolSize` is convenient in
        // some cases but generally it is not recommanded.
        symbol: seriesSymbol,
        symbolSize: seriesSymbolSize,
        symbolKeepAspect: keepAspect,
        symbolRotate: symbolRotate
      }); // Only visible series has each data be visual encoded

      if (ecModel.isSeriesFiltered(seriesModel)) {
        return;
      }

      function dataEach(data, idx) {
        if (hasCallback) {
          var rawValue = seriesModel.getRawValue(idx);
          var params = seriesModel.getDataParams(idx);
          hasSymbolTypeCallback && data.setItemVisual(idx, 'symbol', symbolType(rawValue, params));
          hasSymbolSizeCallback && data.setItemVisual(idx, 'symbolSize', symbolSize(rawValue, params));
          hasSymbolRotateCallback && data.setItemVisual(idx, 'symbolRotate', symbolRotate(rawValue, params));
        }

        if (data.hasItemOption) {
          var itemModel = data.getItemModel(idx);
          var itemSymbolType = itemModel.getShallow('symbol', true);
          var itemSymbolSize = itemModel.getShallow('symbolSize', true);
          var itemSymbolRotate = itemModel.getShallow('symbolRotate', true);
          var itemSymbolKeepAspect = itemModel.getShallow('symbolKeepAspect', true); // If has item symbol

          if (itemSymbolType != null) {
            data.setItemVisual(idx, 'symbol', itemSymbolType);
          }

          if (itemSymbolSize != null) {
            // PENDING Transform symbolSize ?
            data.setItemVisual(idx, 'symbolSize', itemSymbolSize);
          }

          if (itemSymbolRotate != null) {
            data.setItemVisual(idx, 'symbolRotate', itemSymbolRotate);
          }

          if (itemSymbolKeepAspect != null) {
            data.setItemVisual(idx, 'symbolKeepAspect', itemSymbolKeepAspect);
          }
        }
      }

      return {
        dataEach: data.hasItemOption || hasCallback ? dataEach : null
      };
    }
  };
}

module.exports = _default;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(23);

var axisPointerModelHelper = __webpack_require__(303);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Base class of AxisView.
 */
var AxisView = echarts.extendComponentView({
  type: 'axis',

  /**
   * @private
   */
  _axisPointer: null,

  /**
   * @protected
   * @type {string}
   */
  axisPointerClass: null,

  /**
   * @override
   */
  render: function (axisModel, ecModel, api, payload) {
    // FIXME
    // This process should proformed after coordinate systems updated
    // (axis scale updated), and should be performed each time update.
    // So put it here temporarily, although it is not appropriate to
    // put a model-writing procedure in `view`.
    this.axisPointerClass && axisPointerModelHelper.fixValue(axisModel);
    AxisView.superApply(this, 'render', arguments);
    updateAxisPointer(this, axisModel, ecModel, api, payload, true);
  },

  /**
   * Action handler.
   * @public
   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
   * @param {module:echarts/model/Global} ecModel
   * @param {module:echarts/ExtensionAPI} api
   * @param {Object} payload
   */
  updateAxisPointer: function (axisModel, ecModel, api, payload, force) {
    updateAxisPointer(this, axisModel, ecModel, api, payload, false);
  },

  /**
   * @override
   */
  remove: function (ecModel, api) {
    var axisPointer = this._axisPointer;
    axisPointer && axisPointer.remove(api);
    AxisView.superApply(this, 'remove', arguments);
  },

  /**
   * @override
   */
  dispose: function (ecModel, api) {
    disposeAxisPointer(this, api);
    AxisView.superApply(this, 'dispose', arguments);
  }
});

function updateAxisPointer(axisView, axisModel, ecModel, api, payload, forceRender) {
  var Clazz = AxisView.getAxisPointerClass(axisView.axisPointerClass);

  if (!Clazz) {
    return;
  }

  var axisPointerModel = axisPointerModelHelper.getAxisPointerModel(axisModel);
  axisPointerModel ? (axisView._axisPointer || (axisView._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : disposeAxisPointer(axisView, api);
}

function disposeAxisPointer(axisView, ecModel, api) {
  var axisPointer = axisView._axisPointer;
  axisPointer && axisPointer.dispose(ecModel, api);
  axisView._axisPointer = null;
}

var axisPointerClazz = [];

AxisView.registerAxisPointerClass = function (type, clazz) {
  axisPointerClazz[type] = clazz;
};

AxisView.getAxisPointerClass = function (type) {
  return type && axisPointerClazz[type];
};

var _default = AxisView;
module.exports = _default;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function retrieveTargetInfo(payload, validPayloadTypes, seriesModel) {
  if (payload && zrUtil.indexOf(validPayloadTypes, payload.type) >= 0) {
    var root = seriesModel.getData().tree.root;
    var targetNode = payload.targetNode;

    if (typeof targetNode === 'string') {
      targetNode = root.getNodeById(targetNode);
    }

    if (targetNode && root.contains(targetNode)) {
      return {
        node: targetNode
      };
    }

    var targetNodeId = payload.targetNodeId;

    if (targetNodeId != null && (targetNode = root.getNodeById(targetNodeId))) {
      return {
        node: targetNode
      };
    }
  }
} // Not includes the given node at the last item.


function getPathToRoot(node) {
  var path = [];

  while (node) {
    node = node.parentNode;
    node && path.push(node);
  }

  return path.reverse();
}

function aboveViewRoot(viewRoot, node) {
  var viewPath = getPathToRoot(viewRoot);
  return zrUtil.indexOf(viewPath, node) >= 0;
} // From root to the input node (the input node will be included).


function wrapTreePathInfo(node, seriesModel) {
  var treePathInfo = [];

  while (node) {
    var nodeDataIndex = node.dataIndex;
    treePathInfo.push({
      name: node.name,
      dataIndex: nodeDataIndex,
      value: seriesModel.getRawValue(nodeDataIndex)
    });
    node = node.parentNode;
  }

  treePathInfo.reverse();
  return treePathInfo;
}

exports.retrieveTargetInfo = retrieveTargetInfo;
exports.getPathToRoot = getPathToRoot;
exports.aboveViewRoot = aboveViewRoot;
exports.wrapTreePathInfo = wrapTreePathInfo;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var zrColor = __webpack_require__(122);

var _number = __webpack_require__(37);

var linearMap = _number.linearMap;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var each = zrUtil.each;
var isObject = zrUtil.isObject;
var CATEGORY_DEFAULT_VISUAL_INDEX = -1;
/**
 * @param {Object} option
 * @param {string} [option.type] See visualHandlers.
 * @param {string} [option.mappingMethod] 'linear' or 'piecewise' or 'category' or 'fixed'
 * @param {Array.<number>=} [option.dataExtent] [minExtent, maxExtent],
 *                                              required when mappingMethod is 'linear'
 * @param {Array.<Object>=} [option.pieceList] [
 *                                             {value: someValue},
 *                                             {interval: [min1, max1], visual: {...}},
 *                                             {interval: [min2, max2]}
 *                                             ],
 *                                            required when mappingMethod is 'piecewise'.
 *                                            Visual for only each piece can be specified.
 * @param {Array.<string|Object>=} [option.categories] ['cate1', 'cate2']
 *                                            required when mappingMethod is 'category'.
 *                                            If no option.categories, categories is set
 *                                            as [0, 1, 2, ...].
 * @param {boolean} [option.loop=false] Whether loop mapping when mappingMethod is 'category'.
 * @param {(Array|Object|*)} [option.visual]  Visual data.
 *                                            when mappingMethod is 'category',
 *                                            visual data can be array or object
 *                                            (like: {cate1: '#222', none: '#fff'})
 *                                            or primary types (which represents
 *                                            default category visual), otherwise visual
 *                                            can be array or primary (which will be
 *                                            normalized to array).
 *
 */

var VisualMapping = function (option) {
  var mappingMethod = option.mappingMethod;
  var visualType = option.type;
  /**
   * @readOnly
   * @type {Object}
   */

  var thisOption = this.option = zrUtil.clone(option);
  /**
   * @readOnly
   * @type {string}
   */

  this.type = visualType;
  /**
   * @readOnly
   * @type {string}
   */

  this.mappingMethod = mappingMethod;
  /**
   * @private
   * @type {Function}
   */

  this._normalizeData = normalizers[mappingMethod];
  var visualHandler = visualHandlers[visualType];
  /**
   * @public
   * @type {Function}
   */

  this.applyVisual = visualHandler.applyVisual;
  /**
   * @public
   * @type {Function}
   */

  this.getColorMapper = visualHandler.getColorMapper;
  /**
   * @private
   * @type {Function}
   */

  this._doMap = visualHandler._doMap[mappingMethod];

  if (mappingMethod === 'piecewise') {
    normalizeVisualRange(thisOption);
    preprocessForPiecewise(thisOption);
  } else if (mappingMethod === 'category') {
    thisOption.categories ? preprocessForSpecifiedCategory(thisOption) // categories is ordinal when thisOption.categories not specified,
    // which need no more preprocess except normalize visual.
    : normalizeVisualRange(thisOption, true);
  } else {
    // mappingMethod === 'linear' or 'fixed'
    zrUtil.assert(mappingMethod !== 'linear' || thisOption.dataExtent);
    normalizeVisualRange(thisOption);
  }
};

VisualMapping.prototype = {
  constructor: VisualMapping,
  mapValueToVisual: function (value) {
    var normalized = this._normalizeData(value);

    return this._doMap(normalized, value);
  },
  getNormalizer: function () {
    return zrUtil.bind(this._normalizeData, this);
  }
};
var visualHandlers = VisualMapping.visualHandlers = {
  color: {
    applyVisual: makeApplyVisual('color'),

    /**
     * Create a mapper function
     * @return {Function}
     */
    getColorMapper: function () {
      var thisOption = this.option;
      return zrUtil.bind(thisOption.mappingMethod === 'category' ? function (value, isNormalized) {
        !isNormalized && (value = this._normalizeData(value));
        return doMapCategory.call(this, value);
      } : function (value, isNormalized, out) {
        // If output rgb array
        // which will be much faster and useful in pixel manipulation
        var returnRGBArray = !!out;
        !isNormalized && (value = this._normalizeData(value));
        out = zrColor.fastLerp(value, thisOption.parsedVisual, out);
        return returnRGBArray ? out : zrColor.stringify(out, 'rgba');
      }, this);
    },
    _doMap: {
      linear: function (normalized) {
        return zrColor.stringify(zrColor.fastLerp(normalized, this.option.parsedVisual), 'rgba');
      },
      category: doMapCategory,
      piecewise: function (normalized, value) {
        var result = getSpecifiedVisual.call(this, value);

        if (result == null) {
          result = zrColor.stringify(zrColor.fastLerp(normalized, this.option.parsedVisual), 'rgba');
        }

        return result;
      },
      fixed: doMapFixed
    }
  },
  colorHue: makePartialColorVisualHandler(function (color, value) {
    return zrColor.modifyHSL(color, value);
  }),
  colorSaturation: makePartialColorVisualHandler(function (color, value) {
    return zrColor.modifyHSL(color, null, value);
  }),
  colorLightness: makePartialColorVisualHandler(function (color, value) {
    return zrColor.modifyHSL(color, null, null, value);
  }),
  colorAlpha: makePartialColorVisualHandler(function (color, value) {
    return zrColor.modifyAlpha(color, value);
  }),
  opacity: {
    applyVisual: makeApplyVisual('opacity'),
    _doMap: makeDoMap([0, 1])
  },
  liftZ: {
    applyVisual: makeApplyVisual('liftZ'),
    _doMap: {
      linear: doMapFixed,
      category: doMapFixed,
      piecewise: doMapFixed,
      fixed: doMapFixed
    }
  },
  symbol: {
    applyVisual: function (value, getter, setter) {
      var symbolCfg = this.mapValueToVisual(value);

      if (zrUtil.isString(symbolCfg)) {
        setter('symbol', symbolCfg);
      } else if (isObject(symbolCfg)) {
        for (var name in symbolCfg) {
          if (symbolCfg.hasOwnProperty(name)) {
            setter(name, symbolCfg[name]);
          }
        }
      }
    },
    _doMap: {
      linear: doMapToArray,
      category: doMapCategory,
      piecewise: function (normalized, value) {
        var result = getSpecifiedVisual.call(this, value);

        if (result == null) {
          result = doMapToArray.call(this, normalized);
        }

        return result;
      },
      fixed: doMapFixed
    }
  },
  symbolSize: {
    applyVisual: makeApplyVisual('symbolSize'),
    _doMap: makeDoMap([0, 1])
  }
};

function preprocessForPiecewise(thisOption) {
  var pieceList = thisOption.pieceList;
  thisOption.hasSpecialVisual = false;
  zrUtil.each(pieceList, function (piece, index) {
    piece.originIndex = index; // piece.visual is "result visual value" but not
    // a visual range, so it does not need to be normalized.

    if (piece.visual != null) {
      thisOption.hasSpecialVisual = true;
    }
  });
}

function preprocessForSpecifiedCategory(thisOption) {
  // Hash categories.
  var categories = thisOption.categories;
  var visual = thisOption.visual;
  var categoryMap = thisOption.categoryMap = {};
  each(categories, function (cate, index) {
    categoryMap[cate] = index;
  }); // Process visual map input.

  if (!zrUtil.isArray(visual)) {
    var visualArr = [];

    if (zrUtil.isObject(visual)) {
      each(visual, function (v, cate) {
        var index = categoryMap[cate];
        visualArr[index != null ? index : CATEGORY_DEFAULT_VISUAL_INDEX] = v;
      });
    } else {
      // Is primary type, represents default visual.
      visualArr[CATEGORY_DEFAULT_VISUAL_INDEX] = visual;
    }

    visual = setVisualToOption(thisOption, visualArr);
  } // Remove categories that has no visual,
  // then we can mapping them to CATEGORY_DEFAULT_VISUAL_INDEX.


  for (var i = categories.length - 1; i >= 0; i--) {
    if (visual[i] == null) {
      delete categoryMap[categories[i]];
      categories.pop();
    }
  }
}

function normalizeVisualRange(thisOption, isCategory) {
  var visual = thisOption.visual;
  var visualArr = [];

  if (zrUtil.isObject(visual)) {
    each(visual, function (v) {
      visualArr.push(v);
    });
  } else if (visual != null) {
    visualArr.push(visual);
  }

  var doNotNeedPair = {
    color: 1,
    symbol: 1
  };

  if (!isCategory && visualArr.length === 1 && !doNotNeedPair.hasOwnProperty(thisOption.type)) {
    // Do not care visualArr.length === 0, which is illegal.
    visualArr[1] = visualArr[0];
  }

  setVisualToOption(thisOption, visualArr);
}

function makePartialColorVisualHandler(applyValue) {
  return {
    applyVisual: function (value, getter, setter) {
      value = this.mapValueToVisual(value); // Must not be array value

      setter('color', applyValue(getter('color'), value));
    },
    _doMap: makeDoMap([0, 1])
  };
}

function doMapToArray(normalized) {
  var visual = this.option.visual;
  return visual[Math.round(linearMap(normalized, [0, 1], [0, visual.length - 1], true))] || {};
}

function makeApplyVisual(visualType) {
  return function (value, getter, setter) {
    setter(visualType, this.mapValueToVisual(value));
  };
}

function doMapCategory(normalized) {
  var visual = this.option.visual;
  return visual[this.option.loop && normalized !== CATEGORY_DEFAULT_VISUAL_INDEX ? normalized % visual.length : normalized];
}

function doMapFixed() {
  return this.option.visual[0];
}

function makeDoMap(sourceExtent) {
  return {
    linear: function (normalized) {
      return linearMap(normalized, sourceExtent, this.option.visual, true);
    },
    category: doMapCategory,
    piecewise: function (normalized, value) {
      var result = getSpecifiedVisual.call(this, value);

      if (result == null) {
        result = linearMap(normalized, sourceExtent, this.option.visual, true);
      }

      return result;
    },
    fixed: doMapFixed
  };
}

function getSpecifiedVisual(value) {
  var thisOption = this.option;
  var pieceList = thisOption.pieceList;

  if (thisOption.hasSpecialVisual) {
    var pieceIndex = VisualMapping.findPieceIndex(value, pieceList);
    var piece = pieceList[pieceIndex];

    if (piece && piece.visual) {
      return piece.visual[this.type];
    }
  }
}

function setVisualToOption(thisOption, visualArr) {
  thisOption.visual = visualArr;

  if (thisOption.type === 'color') {
    thisOption.parsedVisual = zrUtil.map(visualArr, function (item) {
      return zrColor.parse(item);
    });
  }

  return visualArr;
}
/**
 * Normalizers by mapping methods.
 */


var normalizers = {
  linear: function (value) {
    return linearMap(value, this.option.dataExtent, [0, 1], true);
  },
  piecewise: function (value) {
    var pieceList = this.option.pieceList;
    var pieceIndex = VisualMapping.findPieceIndex(value, pieceList, true);

    if (pieceIndex != null) {
      return linearMap(pieceIndex, [0, pieceList.length - 1], [0, 1], true);
    }
  },
  category: function (value) {
    var index = this.option.categories ? this.option.categoryMap[value] : value; // ordinal

    return index == null ? CATEGORY_DEFAULT_VISUAL_INDEX : index;
  },
  fixed: zrUtil.noop
};
/**
 * List available visual types.
 *
 * @public
 * @return {Array.<string>}
 */

VisualMapping.listVisualTypes = function () {
  var visualTypes = [];
  zrUtil.each(visualHandlers, function (handler, key) {
    visualTypes.push(key);
  });
  return visualTypes;
};
/**
 * @public
 */


VisualMapping.addVisualHandler = function (name, handler) {
  visualHandlers[name] = handler;
};
/**
 * @public
 */


VisualMapping.isValidType = function (visualType) {
  return visualHandlers.hasOwnProperty(visualType);
};
/**
 * Convinent method.
 * Visual can be Object or Array or primary type.
 *
 * @public
 */


VisualMapping.eachVisual = function (visual, callback, context) {
  if (zrUtil.isObject(visual)) {
    zrUtil.each(visual, callback, context);
  } else {
    callback.call(context, visual);
  }
};

VisualMapping.mapVisual = function (visual, callback, context) {
  var isPrimary;
  var newVisual = zrUtil.isArray(visual) ? [] : zrUtil.isObject(visual) ? {} : (isPrimary = true, null);
  VisualMapping.eachVisual(visual, function (v, key) {
    var newVal = callback.call(context, v, key);
    isPrimary ? newVisual = newVal : newVisual[key] = newVal;
  });
  return newVisual;
};
/**
 * @public
 * @param {Object} obj
 * @return {Object} new object containers visual values.
 *                 If no visuals, return null.
 */


VisualMapping.retrieveVisuals = function (obj) {
  var ret = {};
  var hasVisual;
  obj && each(visualHandlers, function (h, visualType) {
    if (obj.hasOwnProperty(visualType)) {
      ret[visualType] = obj[visualType];
      hasVisual = true;
    }
  });
  return hasVisual ? ret : null;
};
/**
 * Give order to visual types, considering colorSaturation, colorAlpha depends on color.
 *
 * @public
 * @param {(Object|Array)} visualTypes If Object, like: {color: ..., colorSaturation: ...}
 *                                     IF Array, like: ['color', 'symbol', 'colorSaturation']
 * @return {Array.<string>} Sorted visual types.
 */


VisualMapping.prepareVisualTypes = function (visualTypes) {
  if (isObject(visualTypes)) {
    var types = [];
    each(visualTypes, function (item, type) {
      types.push(type);
    });
    visualTypes = types;
  } else if (zrUtil.isArray(visualTypes)) {
    visualTypes = visualTypes.slice();
  } else {
    return [];
  }

  visualTypes.sort(function (type1, type2) {
    // color should be front of colorSaturation, colorAlpha, ...
    // symbol and symbolSize do not matter.
    return type2 === 'color' && type1 !== 'color' && type1.indexOf('color') === 0 ? 1 : -1;
  });
  return visualTypes;
};
/**
 * 'color', 'colorSaturation', 'colorAlpha', ... are depends on 'color'.
 * Other visuals are only depends on themself.
 *
 * @public
 * @param {string} visualType1
 * @param {string} visualType2
 * @return {boolean}
 */


VisualMapping.dependsOn = function (visualType1, visualType2) {
  return visualType2 === 'color' ? !!(visualType1 && visualType1.indexOf(visualType2) === 0) : visualType1 === visualType2;
};
/**
 * @param {number} value
 * @param {Array.<Object>} pieceList [{value: ..., interval: [min, max]}, ...]
 *                         Always from small to big.
 * @param {boolean} [findClosestWhenOutside=false]
 * @return {number} index
 */


VisualMapping.findPieceIndex = function (value, pieceList, findClosestWhenOutside) {
  var possibleI;
  var abs = Infinity; // value has the higher priority.

  for (var i = 0, len = pieceList.length; i < len; i++) {
    var pieceValue = pieceList[i].value;

    if (pieceValue != null) {
      if (pieceValue === value // FIXME
      // It is supposed to compare value according to value type of dimension,
      // but currently value type can exactly be string or number.
      // Compromise for numeric-like string (like '12'), especially
      // in the case that visualMap.categories is ['22', '33'].
      || typeof pieceValue === 'string' && pieceValue === value + '') {
        return i;
      }

      findClosestWhenOutside && updatePossible(pieceValue, i);
    }
  }

  for (var i = 0, len = pieceList.length; i < len; i++) {
    var piece = pieceList[i];
    var interval = piece.interval;
    var close = piece.close;

    if (interval) {
      if (interval[0] === -Infinity) {
        if (littleThan(close[1], value, interval[1])) {
          return i;
        }
      } else if (interval[1] === Infinity) {
        if (littleThan(close[0], interval[0], value)) {
          return i;
        }
      } else if (littleThan(close[0], interval[0], value) && littleThan(close[1], value, interval[1])) {
        return i;
      }

      findClosestWhenOutside && updatePossible(interval[0], i);
      findClosestWhenOutside && updatePossible(interval[1], i);
    }
  }

  if (findClosestWhenOutside) {
    return value === Infinity ? pieceList.length - 1 : value === -Infinity ? 0 : possibleI;
  }

  function updatePossible(val, index) {
    var newAbs = Math.abs(val - value);

    if (newAbs < abs) {
      abs = newAbs;
      possibleI = index;
    }
  }
};

function littleThan(close, a, b) {
  return close ? a <= b : a < b;
}

var _default = VisualMapping;
module.exports = _default;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = interopDefault;

// https://github.com/moment/moment/issues/3650
// since we are using ts 3.5.1, it should be safe to remove.
function interopDefault(m) {
  return m["default"] || m;
}

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_RESULT__;!function(t){ true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):t()}(function(){"use strict";
/** @license
   * jsPDF - PDF Document creation from JavaScript
   * Version 1.5.3 Built on 2018-12-27T14:11:42.696Z
   *                      CommitID d93d28db14
   *
   * Copyright (c) 2010-2016 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
   *               2010 Aaron Spike, https://github.com/acspike
   *               2012 Willow Systems Corporation, willow-systems.com
   *               2012 Pablo Hess, https://github.com/pablohess
   *               2012 Florian Jenett, https://github.com/fjenett
   *               2013 Warren Weckesser, https://github.com/warrenweckesser
   *               2013 Youssef Beddad, https://github.com/lifof
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2013 Stefan Slonevskiy, https://github.com/stefslon
   *               2013 Jeremy Morel, https://github.com/jmorel
   *               2013 Christoph Hartmann, https://github.com/chris-rock
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Makes, https://github.com/dollaruw
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Steven Spungin, https://github.com/Flamenco
   *               2014 Kenneth Glassey, https://github.com/Gavvers
   *
   * Licensed under the MIT License
   *
   * Contributor(s):
   *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
   *    kim3er, mfo, alnorth, Flamenco
   */function se(t){return(se="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}!function(t){if("object"!==se(t.console)){t.console={};for(var e,n,r=t.console,i=function(){},o=["memory"],a="assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(",");e=o.pop();)r[e]||(r[e]={});for(;n=a.pop();)r[n]||(r[n]=i)}var s,l,h,u,c="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";void 0===t.btoa&&(t.btoa=function(t){var e,n,r,i,o,a=0,s=0,l="",h=[];if(!t)return t;for(;e=(o=t.charCodeAt(a++)<<16|t.charCodeAt(a++)<<8|t.charCodeAt(a++))>>18&63,n=o>>12&63,r=o>>6&63,i=63&o,h[s++]=c.charAt(e)+c.charAt(n)+c.charAt(r)+c.charAt(i),a<t.length;);l=h.join("");var u=t.length%3;return(u?l.slice(0,u-3):l)+"===".slice(u||3)}),void 0===t.atob&&(t.atob=function(t){var e,n,r,i,o,a,s=0,l=0,h=[];if(!t)return t;for(t+="";e=(a=c.indexOf(t.charAt(s++))<<18|c.indexOf(t.charAt(s++))<<12|(i=c.indexOf(t.charAt(s++)))<<6|(o=c.indexOf(t.charAt(s++))))>>16&255,n=a>>8&255,r=255&a,h[l++]=64==i?String.fromCharCode(e):64==o?String.fromCharCode(e,n):String.fromCharCode(e,n,r),s<t.length;);return h.join("")}),Array.prototype.map||(Array.prototype.map=function(t){if(null==this||"function"!=typeof t)throw new TypeError;for(var e=Object(this),n=e.length>>>0,r=new Array(n),i=1<arguments.length?arguments[1]:void 0,o=0;o<n;o++)o in e&&(r[o]=t.call(i,e[o],o,e));return r}),Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),Array.prototype.forEach||(Array.prototype.forEach=function(t,e){if(null==this||"function"!=typeof t)throw new TypeError;for(var n=Object(this),r=n.length>>>0,i=0;i<r;i++)i in n&&t.call(e,n[i],i,n)}),Array.prototype.find||Object.defineProperty(Array.prototype,"find",{value:function(t){if(null==this)throw new TypeError('"this" is null or not defined');var e=Object(this),n=e.length>>>0;if("function"!=typeof t)throw new TypeError("predicate must be a function");for(var r=arguments[1],i=0;i<n;){var o=e[i];if(t.call(r,o,i,e))return o;i++}},configurable:!0,writable:!0}),Object.keys||(Object.keys=(s=Object.prototype.hasOwnProperty,l=!{toString:null}.propertyIsEnumerable("toString"),u=(h=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"]).length,function(t){if("object"!==se(t)&&("function"!=typeof t||null===t))throw new TypeError;var e,n,r=[];for(e in t)s.call(t,e)&&r.push(e);if(l)for(n=0;n<u;n++)s.call(t,h[n])&&r.push(h[n]);return r})),"function"!=typeof Object.assign&&(Object.assign=function(t){if(null==t)throw new TypeError("Cannot convert undefined or null to object");t=Object(t);for(var e=1;e<arguments.length;e++){var n=arguments[e];if(null!=n)for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}),String.prototype.trim||(String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")}),String.prototype.trimLeft||(String.prototype.trimLeft=function(){return this.replace(/^\s+/g,"")}),String.prototype.trimRight||(String.prototype.trimRight=function(){return this.replace(/\s+$/g,"")}),Number.isInteger=Number.isInteger||function(t){return"number"==typeof t&&isFinite(t)&&Math.floor(t)===t}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());var t,e,n,_,l,F,P,p,d,k,a,o,s,h,u,c,r,i,f,g,m,y,v,w,b,x,I,C,B,N,L,A,S,j,E,M,O,q,T,R,D,U,z,H,W,V,G,Y,J,X,K,Z,Q,$,tt,et,nt,rt,it,ot,at,st,lt=function(ie){function oe(o){if("object"!==se(o))throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");var a={};this.subscribe=function(t,e,n){if(n=n||!1,"string"!=typeof t||"function"!=typeof e||"boolean"!=typeof n)throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");a.hasOwnProperty(t)||(a[t]={});var r=Math.random().toString(35);return a[t][r]=[e,!!n],r},this.unsubscribe=function(t){for(var e in a)if(a[e][t])return delete a[e][t],0===Object.keys(a[e]).length&&delete a[e],!0;return!1},this.publish=function(t){if(a.hasOwnProperty(t)){var e=Array.prototype.slice.call(arguments,1),n=[];for(var r in a[t]){var i=a[t][r];try{i[0].apply(o,e)}catch(t){ie.console&&console.error("jsPDF PubSub Error",t.message,t)}i[1]&&n.push(r)}n.length&&n.forEach(this.unsubscribe)}},this.getTopics=function(){return a}}function ae(t,e,i,n){var r={},o=[],a=1;"object"===se(t)&&(t=(r=t).orientation,e=r.unit||e,i=r.format||i,n=r.compress||r.compressPdf||n,o=r.filters||(!0===n?["FlateEncode"]:o),a="number"==typeof r.userUnit?Math.abs(r.userUnit):1),e=e||"mm",t=(""+(t||"P")).toLowerCase();var s=r.putOnlyUsedFonts||!0,K={},l={internal:{},__private__:{}};l.__private__.PubSub=oe;var h="1.3",u=l.__private__.getPdfVersion=function(){return h},c=(l.__private__.setPdfVersion=function(t){h=t},{a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]}),f=(l.__private__.getPageFormats=function(){return c},l.__private__.getPageFormat=function(t){return c[t]});"string"==typeof i&&(i=f(i)),i=i||f("a4");var p,Z=l.f2=l.__private__.f2=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return t.toFixed(2)},Q=l.__private__.f3=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f3");return t.toFixed(3)},d="00000000000000000000000000000000",g=l.__private__.getFileId=function(){return d},m=l.__private__.setFileId=function(t){return t=t||"12345678901234567890123456789012".split("").map(function(){return"ABCDEF0123456789".charAt(Math.floor(16*Math.random()))}).join(""),d=t};l.setFileId=function(t){return m(t),this},l.getFileId=function(){return g()};var y=l.__private__.convertDateToPDFDate=function(t){var e=t.getTimezoneOffset(),n=e<0?"+":"-",r=Math.floor(Math.abs(e/60)),i=Math.abs(e%60),o=[n,P(r),"'",P(i),"'"].join("");return["D:",t.getFullYear(),P(t.getMonth()+1),P(t.getDate()),P(t.getHours()),P(t.getMinutes()),P(t.getSeconds()),o].join("")},v=l.__private__.convertPDFDateToDate=function(t){var e=parseInt(t.substr(2,4),10),n=parseInt(t.substr(6,2),10)-1,r=parseInt(t.substr(8,2),10),i=parseInt(t.substr(10,2),10),o=parseInt(t.substr(12,2),10),a=parseInt(t.substr(14,2),10);parseInt(t.substr(16,2),10),parseInt(t.substr(20,2),10);return new Date(e,n,r,i,o,a,0)},w=l.__private__.setCreationDate=function(t){var e;if(void 0===t&&(t=new Date),"object"===se(t)&&"[object Date]"===Object.prototype.toString.call(t))e=y(t);else{if(!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|\-0[0-9]|\-1[0-1])\'(0[0-9]|[1-5][0-9])\'?$/.test(t))throw new Error("Invalid argument passed to jsPDF.setCreationDate");e=t}return p=e},b=l.__private__.getCreationDate=function(t){var e=p;return"jsDate"===t&&(e=v(p)),e};l.setCreationDate=function(t){return w(t),this},l.getCreationDate=function(t){return b(t)};var x,N,L,A,S,$,_,F,P=l.__private__.padd2=function(t){return("0"+parseInt(t)).slice(-2)},k=!1,I=[],C=[],B=0,tt=(l.__private__.setCustomOutputDestination=function(t){N=t},l.__private__.resetCustomOutputDestination=function(t){N=void 0},l.__private__.out=function(t){var e;return t="string"==typeof t?t:t.toString(),(e=void 0===N?k?I[x]:C:N).push(t),k||(B+=t.length+1),e}),j=l.__private__.write=function(t){return tt(1===arguments.length?t.toString():Array.prototype.join.call(arguments," "))},E=l.__private__.getArrayBuffer=function(t){for(var e=t.length,n=new ArrayBuffer(e),r=new Uint8Array(n);e--;)r[e]=t.charCodeAt(e);return n},M=[["Helvetica","helvetica","normal","WinAnsiEncoding"],["Helvetica-Bold","helvetica","bold","WinAnsiEncoding"],["Helvetica-Oblique","helvetica","italic","WinAnsiEncoding"],["Helvetica-BoldOblique","helvetica","bolditalic","WinAnsiEncoding"],["Courier","courier","normal","WinAnsiEncoding"],["Courier-Bold","courier","bold","WinAnsiEncoding"],["Courier-Oblique","courier","italic","WinAnsiEncoding"],["Courier-BoldOblique","courier","bolditalic","WinAnsiEncoding"],["Times-Roman","times","normal","WinAnsiEncoding"],["Times-Bold","times","bold","WinAnsiEncoding"],["Times-Italic","times","italic","WinAnsiEncoding"],["Times-BoldItalic","times","bolditalic","WinAnsiEncoding"],["ZapfDingbats","zapfdingbats","normal",null],["Symbol","symbol","normal",null]],et=(l.__private__.getStandardFonts=function(t){return M},r.fontSize||16),O=(l.__private__.setFontSize=l.setFontSize=function(t){return et=t,this},l.__private__.getFontSize=l.getFontSize=function(){return et}),nt=r.R2L||!1,q=(l.__private__.setR2L=l.setR2L=function(t){return nt=t,this},l.__private__.getR2L=l.getR2L=function(t){return nt},l.__private__.setZoomMode=function(t){var e=[void 0,null,"fullwidth","fullheight","fullpage","original"];if(/^\d*\.?\d*\%$/.test(t))L=t;else if(isNaN(t)){if(-1===e.indexOf(t))throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "'+t+'" is not recognized.');L=t}else L=parseInt(t,10)}),T=(l.__private__.getZoomMode=function(){return L},l.__private__.setPageMode=function(t){if(-1==[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"].indexOf(t))throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+t+'" is not recognized.');A=t}),R=(l.__private__.getPageMode=function(){return A},l.__private__.setLayoutMode=function(t){if(-1==[void 0,null,"continuous","single","twoleft","tworight","two"].indexOf(t))throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "'+t+'" is not recognized.');S=t}),D=(l.__private__.getLayoutMode=function(){return S},l.__private__.setDisplayMode=l.setDisplayMode=function(t,e,n){return q(t),R(e),T(n),this},{title:"",subject:"",author:"",keywords:"",creator:""}),U=(l.__private__.getDocumentProperty=function(t){if(-1===Object.keys(D).indexOf(t))throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");return D[t]},l.__private__.getDocumentProperties=function(t){return D},l.__private__.setDocumentProperties=l.setProperties=l.setDocumentProperties=function(t){for(var e in D)D.hasOwnProperty(e)&&t[e]&&(D[e]=t[e]);return this},l.__private__.setDocumentProperty=function(t,e){if(-1===Object.keys(D).indexOf(t))throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");return D[t]=e},0),z=[],rt={},H={},W=0,V=[],G=[],it=new oe(l),Y=r.hotfixes||[],J=l.__private__.newObject=function(){var t=X();return ot(t,!0),t},X=l.__private__.newObjectDeferred=function(){return z[++U]=function(){return B},U},ot=function(t,e){return e="boolean"==typeof e&&e,z[t]=B,e&&tt(t+" 0 obj"),t},at=l.__private__.newAdditionalObject=function(){var t={objId:X(),content:""};return G.push(t),t},st=X(),lt=X(),ht=l.__private__.decodeColorString=function(t){var e=t.split(" ");if(2===e.length&&("g"===e[1]||"G"===e[1])){var n=parseFloat(e[0]);e=[n,n,n,"r"]}for(var r="#",i=0;i<3;i++)r+=("0"+Math.floor(255*parseFloat(e[i])).toString(16)).slice(-2);return r},ut=l.__private__.encodeColorString=function(t){var e;"string"==typeof t&&(t={ch1:t});var n=t.ch1,r=t.ch2,i=t.ch3,o=t.ch4,a=(t.precision,"draw"===t.pdfColorType?["G","RG","K"]:["g","rg","k"]);if("string"==typeof n&&"#"!==n.charAt(0)){var s=new RGBColor(n);if(s.ok)n=s.toHex();else if(!/^\d*\.?\d*$/.test(n))throw new Error('Invalid color "'+n+'" passed to jsPDF.encodeColorString.')}if("string"==typeof n&&/^#[0-9A-Fa-f]{3}$/.test(n)&&(n="#"+n[1]+n[1]+n[2]+n[2]+n[3]+n[3]),"string"==typeof n&&/^#[0-9A-Fa-f]{6}$/.test(n)){var l=parseInt(n.substr(1),16);n=l>>16&255,r=l>>8&255,i=255&l}if(void 0===r||void 0===o&&n===r&&r===i)if("string"==typeof n)e=n+" "+a[0];else switch(t.precision){case 2:e=Z(n/255)+" "+a[0];break;case 3:default:e=Q(n/255)+" "+a[0]}else if(void 0===o||"object"===se(o)){if(o&&!isNaN(o.a)&&0===o.a)return e=["1.000","1.000","1.000",a[1]].join(" ");if("string"==typeof n)e=[n,r,i,a[1]].join(" ");else switch(t.precision){case 2:e=[Z(n/255),Z(r/255),Z(i/255),a[1]].join(" ");break;default:case 3:e=[Q(n/255),Q(r/255),Q(i/255),a[1]].join(" ")}}else if("string"==typeof n)e=[n,r,i,o,a[2]].join(" ");else switch(t.precision){case 2:e=[Z(n/255),Z(r/255),Z(i/255),Z(o/255),a[2]].join(" ");break;case 3:default:e=[Q(n/255),Q(r/255),Q(i/255),Q(o/255),a[2]].join(" ")}return e},ct=l.__private__.getFilters=function(){return o},ft=l.__private__.putStream=function(t){var e=(t=t||{}).data||"",n=t.filters||ct(),r=t.alreadyAppliedFilters||[],i=t.addLength1||!1,o=e.length,a={};!0===n&&(n=["FlateEncode"]);var s=t.additionalKeyValues||[],l=(a=void 0!==ae.API.processDataByFilters?ae.API.processDataByFilters(e,n):{data:e,reverseChain:[]}).reverseChain+(Array.isArray(r)?r.join(" "):r.toString());0!==a.data.length&&(s.push({key:"Length",value:a.data.length}),!0===i&&s.push({key:"Length1",value:o})),0!=l.length&&(l.split("/").length-1==1?s.push({key:"Filter",value:l}):s.push({key:"Filter",value:"["+l+"]"})),tt("<<");for(var h=0;h<s.length;h++)tt("/"+s[h].key+" "+s[h].value);tt(">>"),0!==a.data.length&&(tt("stream"),tt(a.data),tt("endstream"))},pt=l.__private__.putPage=function(t){t.mediaBox;var e=t.number,n=t.data,r=t.objId,i=t.contentsObjId;ot(r,!0);V[x].mediaBox.topRightX,V[x].mediaBox.bottomLeftX,V[x].mediaBox.topRightY,V[x].mediaBox.bottomLeftY;tt("<</Type /Page"),tt("/Parent "+t.rootDictionaryObjId+" 0 R"),tt("/Resources "+t.resourceDictionaryObjId+" 0 R"),tt("/MediaBox ["+parseFloat(Z(t.mediaBox.bottomLeftX))+" "+parseFloat(Z(t.mediaBox.bottomLeftY))+" "+Z(t.mediaBox.topRightX)+" "+Z(t.mediaBox.topRightY)+"]"),null!==t.cropBox&&tt("/CropBox ["+Z(t.cropBox.bottomLeftX)+" "+Z(t.cropBox.bottomLeftY)+" "+Z(t.cropBox.topRightX)+" "+Z(t.cropBox.topRightY)+"]"),null!==t.bleedBox&&tt("/BleedBox ["+Z(t.bleedBox.bottomLeftX)+" "+Z(t.bleedBox.bottomLeftY)+" "+Z(t.bleedBox.topRightX)+" "+Z(t.bleedBox.topRightY)+"]"),null!==t.trimBox&&tt("/TrimBox ["+Z(t.trimBox.bottomLeftX)+" "+Z(t.trimBox.bottomLeftY)+" "+Z(t.trimBox.topRightX)+" "+Z(t.trimBox.topRightY)+"]"),null!==t.artBox&&tt("/ArtBox ["+Z(t.artBox.bottomLeftX)+" "+Z(t.artBox.bottomLeftY)+" "+Z(t.artBox.topRightX)+" "+Z(t.artBox.topRightY)+"]"),"number"==typeof t.userUnit&&1!==t.userUnit&&tt("/UserUnit "+t.userUnit),it.publish("putPage",{objId:r,pageContext:V[e],pageNumber:e,page:n}),tt("/Contents "+i+" 0 R"),tt(">>"),tt("endobj");var o=n.join("\n");return ot(i,!0),ft({data:o,filters:ct()}),tt("endobj"),r},dt=l.__private__.putPages=function(){var t,e,n=[];for(t=1;t<=W;t++)V[t].objId=X(),V[t].contentsObjId=X();for(t=1;t<=W;t++)n.push(pt({number:t,data:I[t],objId:V[t].objId,contentsObjId:V[t].contentsObjId,mediaBox:V[t].mediaBox,cropBox:V[t].cropBox,bleedBox:V[t].bleedBox,trimBox:V[t].trimBox,artBox:V[t].artBox,userUnit:V[t].userUnit,rootDictionaryObjId:st,resourceDictionaryObjId:lt}));ot(st,!0),tt("<</Type /Pages");var r="/Kids [";for(e=0;e<W;e++)r+=n[e]+" 0 R ";tt(r+"]"),tt("/Count "+W),tt(">>"),tt("endobj"),it.publish("postPutPages")},gt=function(){!function(){for(var t in rt)rt.hasOwnProperty(t)&&(!1===s||!0===s&&K.hasOwnProperty(t))&&(e=rt[t],it.publish("putFont",{font:e,out:tt,newObject:J,putStream:ft}),!0!==e.isAlreadyPutted&&(e.objectNumber=J(),tt("<<"),tt("/Type /Font"),tt("/BaseFont /"+e.postScriptName),tt("/Subtype /Type1"),"string"==typeof e.encoding&&tt("/Encoding /"+e.encoding),tt("/FirstChar 32"),tt("/LastChar 255"),tt(">>"),tt("endobj")));var e}(),it.publish("putResources"),ot(lt,!0),tt("<<"),function(){for(var t in tt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),tt("/Font <<"),rt)rt.hasOwnProperty(t)&&(!1===s||!0===s&&K.hasOwnProperty(t))&&tt("/"+t+" "+rt[t].objectNumber+" 0 R");tt(">>"),tt("/XObject <<"),it.publish("putXobjectDict"),tt(">>")}(),tt(">>"),tt("endobj"),it.publish("postPutResources")},mt=function(t,e,n){H.hasOwnProperty(e)||(H[e]={}),H[e][n]=t},yt=function(t,e,n,r,i){i=i||!1;var o="F"+(Object.keys(rt).length+1).toString(10),a={id:o,postScriptName:t,fontName:e,fontStyle:n,encoding:r,isStandardFont:i,metadata:{}};return it.publish("addFont",{font:a,instance:this}),void 0!==o&&(rt[o]=a,mt(o,e,n)),o},vt=l.__private__.pdfEscape=l.pdfEscape=function(t,e){return function(t,e){var n,r,i,o,a,s,l,h,u;if(i=(e=e||{}).sourceEncoding||"Unicode",a=e.outputEncoding,(e.autoencode||a)&&rt[$].metadata&&rt[$].metadata[i]&&rt[$].metadata[i].encoding&&(o=rt[$].metadata[i].encoding,!a&&rt[$].encoding&&(a=rt[$].encoding),!a&&o.codePages&&(a=o.codePages[0]),"string"==typeof a&&(a=o[a]),a)){for(l=!1,s=[],n=0,r=t.length;n<r;n++)(h=a[t.charCodeAt(n)])?s.push(String.fromCharCode(h)):s.push(t[n]),s[n].charCodeAt(0)>>8&&(l=!0);t=s.join("")}for(n=t.length;void 0===l&&0!==n;)t.charCodeAt(n-1)>>8&&(l=!0),n--;if(!l)return t;for(s=e.noBOM?[]:[254,255],n=0,r=t.length;n<r;n++){if((u=(h=t.charCodeAt(n))>>8)>>8)throw new Error("Character at position "+n+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(u),s.push(h-(u<<8))}return String.fromCharCode.apply(void 0,s)}(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},wt=l.__private__.beginPage=function(t,e){var n,r="string"==typeof e&&e.toLowerCase();if("string"==typeof t&&(n=f(t.toLowerCase()))&&(t=n[0],e=n[1]),Array.isArray(t)&&(e=t[1],t=t[0]),(isNaN(t)||isNaN(e))&&(t=i[0],e=i[1]),r){switch(r.substr(0,1)){case"l":t<e&&(r="s");break;case"p":e<t&&(r="s")}"s"===r&&(n=t,t=e,e=n)}(14400<t||14400<e)&&(console.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"),t=Math.min(14400,t),e=Math.min(14400,e)),i=[t,e],k=!0,I[++W]=[],V[W]={objId:0,contentsObjId:0,userUnit:Number(a),artBox:null,bleedBox:null,cropBox:null,trimBox:null,mediaBox:{bottomLeftX:0,bottomLeftY:0,topRightX:Number(t),topRightY:Number(e)}},xt(W)},bt=function(){wt.apply(this,arguments),Dt(Rt),tt(Jt),0!==te&&tt(te+" J"),0!==ne&&tt(ne+" j"),it.publish("addPage",{pageNumber:W})},xt=function(t){0<t&&t<=W&&(x=t)},Nt=l.__private__.getNumberOfPages=l.getNumberOfPages=function(){return I.length-1},Lt=function(t,e,n){var r,i=void 0;return n=n||{},t=void 0!==t?t:rt[$].fontName,e=void 0!==e?e:rt[$].fontStyle,r=t.toLowerCase(),void 0!==H[r]&&void 0!==H[r][e]?i=H[r][e]:void 0!==H[t]&&void 0!==H[t][e]?i=H[t][e]:!1===n.disableWarning&&console.warn("Unable to look up font label for font '"+t+"', '"+e+"'. Refer to getFontList() for available fonts."),i||n.noFallback||null==(i=H.times[e])&&(i=H.times.normal),i},At=l.__private__.putInfo=function(){for(var t in J(),tt("<<"),tt("/Producer (jsPDF "+ae.version+")"),D)D.hasOwnProperty(t)&&D[t]&&tt("/"+t.substr(0,1).toUpperCase()+t.substr(1)+" ("+vt(D[t])+")");tt("/CreationDate ("+p+")"),tt(">>"),tt("endobj")},St=l.__private__.putCatalog=function(t){var e=(t=t||{}).rootDictionaryObjId||st;switch(J(),tt("<<"),tt("/Type /Catalog"),tt("/Pages "+e+" 0 R"),L||(L="fullwidth"),L){case"fullwidth":tt("/OpenAction [3 0 R /FitH null]");break;case"fullheight":tt("/OpenAction [3 0 R /FitV null]");break;case"fullpage":tt("/OpenAction [3 0 R /Fit]");break;case"original":tt("/OpenAction [3 0 R /XYZ null null 1]");break;default:var n=""+L;"%"===n.substr(n.length-1)&&(L=parseInt(L)/100),"number"==typeof L&&tt("/OpenAction [3 0 R /XYZ null null "+Z(L)+"]")}switch(S||(S="continuous"),S){case"continuous":tt("/PageLayout /OneColumn");break;case"single":tt("/PageLayout /SinglePage");break;case"two":case"twoleft":tt("/PageLayout /TwoColumnLeft");break;case"tworight":tt("/PageLayout /TwoColumnRight")}A&&tt("/PageMode /"+A),it.publish("putCatalog"),tt(">>"),tt("endobj")},_t=l.__private__.putTrailer=function(){tt("trailer"),tt("<<"),tt("/Size "+(U+1)),tt("/Root "+U+" 0 R"),tt("/Info "+(U-1)+" 0 R"),tt("/ID [ <"+d+"> <"+d+"> ]"),tt(">>")},Ft=l.__private__.putHeader=function(){tt("%PDF-"+h),tt("%ºß¬à")},Pt=l.__private__.putXRef=function(){var t=1,e="0000000000";for(tt("xref"),tt("0 "+(U+1)),tt("0000000000 65535 f "),t=1;t<=U;t++){"function"==typeof z[t]?tt((e+z[t]()).slice(-10)+" 00000 n "):void 0!==z[t]?tt((e+z[t]).slice(-10)+" 00000 n "):tt("0000000000 00000 n ")}},kt=l.__private__.buildDocument=function(){k=!1,B=U=0,C=[],z=[],G=[],st=X(),lt=X(),it.publish("buildDocument"),Ft(),dt(),function(){it.publish("putAdditionalObjects");for(var t=0;t<G.length;t++){var e=G[t];ot(e.objId,!0),tt(e.content),tt("endobj")}it.publish("postPutAdditionalObjects")}(),gt(),At(),St();var t=B;return Pt(),_t(),tt("startxref"),tt(""+t),tt("%%EOF"),k=!0,C.join("\n")},It=l.__private__.getBlob=function(t){return new Blob([E(t)],{type:"application/pdf"})},Ct=l.output=l.__private__.output=((F=function(t,e){e=e||{};var n=kt();switch("string"==typeof e?e={filename:e}:e.filename=e.filename||"generated.pdf",t){case void 0:return n;case"save":l.save(e.filename);break;case"arraybuffer":return E(n);case"blob":return It(n);case"bloburi":case"bloburl":if(void 0!==ie.URL&&"function"==typeof ie.URL.createObjectURL)return ie.URL&&ie.URL.createObjectURL(It(n))||void 0;console.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");break;case"datauristring":case"dataurlstring":return"data:application/pdf;filename="+e.filename+";base64,"+btoa(n);case"dataurlnewwindow":var r='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="'+this.output("datauristring")+'"></iframe></body></html>',i=ie.open();if(null!==i&&i.document.write(r),i||"undefined"==typeof safari)return i;case"datauri":case"dataurl":return ie.document.location.href="data:application/pdf;filename="+e.filename+";base64,"+btoa(n);default:return null}}).foo=function(){try{return F.apply(this,arguments)}catch(t){var e=t.stack||"";~e.indexOf(" at ")&&(e=e.split(" at ")[1]);var n="Error in function "+e.split("\n")[0].split("<")[0]+": "+t.message;if(!ie.console)throw new Error(n);ie.console.error(n,t),ie.alert&&alert(n)}},(F.foo.bar=F).foo),Bt=function(t){return!0===Array.isArray(Y)&&-1<Y.indexOf(t)};switch(e){case"pt":_=1;break;case"mm":_=72/25.4;break;case"cm":_=72/2.54;break;case"in":_=72;break;case"px":_=1==Bt("px_scaling")?.75:96/72;break;case"pc":case"em":_=12;break;case"ex":_=6;break;default:throw new Error("Invalid unit: "+e)}w(),m();var jt=l.__private__.getPageInfo=function(t){if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfo");return{objId:V[t].objId,pageNumber:t,pageContext:V[t]}},Et=l.__private__.getPageInfoByObjId=function(t){for(var e in V)if(V[e].objId===t)break;if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");return jt(e)},Mt=l.__private__.getCurrentPageInfo=function(){return{objId:V[x].objId,pageNumber:x,pageContext:V[x]}};l.addPage=function(){return bt.apply(this,arguments),this},l.setPage=function(){return xt.apply(this,arguments),this},l.insertPage=function(t){return this.addPage(),this.movePage(x,t),this},l.movePage=function(t,e){if(e<t){for(var n=I[t],r=V[t],i=t;e<i;i--)I[i]=I[i-1],V[i]=V[i-1];I[e]=n,V[e]=r,this.setPage(e)}else if(t<e){for(n=I[t],r=V[t],i=t;i<e;i++)I[i]=I[i+1],V[i]=V[i+1];I[e]=n,V[e]=r,this.setPage(e)}return this},l.deletePage=function(){return function(t){0<t&&t<=W&&(I.splice(t,1),--W<x&&(x=W),this.setPage(x))}.apply(this,arguments),this};l.__private__.text=l.text=function(t,e,n,i){var r;"number"!=typeof t||"number"!=typeof e||"string"!=typeof n&&!Array.isArray(n)||(r=n,n=e,e=t,t=r);var o=arguments[3],a=arguments[4],s=arguments[5];if("object"===se(o)&&null!==o||("string"==typeof a&&(s=a,a=null),"string"==typeof o&&(s=o,o=null),"number"==typeof o&&(a=o,o=null),i={flags:o,angle:a,align:s}),(o=o||{}).noBOM=o.noBOM||!0,o.autoencode=o.autoencode||!0,isNaN(e)||isNaN(n)||null==t)throw new Error("Invalid arguments passed to jsPDF.text");if(0===t.length)return c;var l,h="",u="number"==typeof i.lineHeightFactor?i.lineHeightFactor:Tt,c=i.scope||this;function f(t){for(var e,n=t.concat(),r=[],i=n.length;i--;)"string"==typeof(e=n.shift())?r.push(e):Array.isArray(t)&&1===e.length?r.push(e[0]):r.push([e[0],e[1],e[2]]);return r}function p(t,e){var n;if("string"==typeof t)n=e(t)[0];else if(Array.isArray(t)){for(var r,i,o=t.concat(),a=[],s=o.length;s--;)"string"==typeof(r=o.shift())?a.push(e(r)[0]):Array.isArray(r)&&"string"===r[0]&&(i=e(r[0],r[1],r[2]),a.push([i[0],i[1],i[2]]));n=a}return n}var d=!1,g=!0;if("string"==typeof t)d=!0;else if(Array.isArray(t)){for(var m,y=t.concat(),v=[],w=y.length;w--;)("string"!=typeof(m=y.shift())||Array.isArray(m)&&"string"!=typeof m[0])&&(g=!1);d=g}if(!1===d)throw new Error('Type of text must be string or Array. "'+t+'" is not recognized.');var b=rt[$].encoding;"WinAnsiEncoding"!==b&&"StandardEncoding"!==b||(t=p(t,function(t,e,n){return[(r=t,r=r.split("\t").join(Array(i.TabLen||9).join(" ")),vt(r,o)),e,n];var r})),"string"==typeof t&&(t=t.match(/[\r?\n]/)?t.split(/\r\n|\r|\n/g):[t]);var x=et/c.internal.scaleFactor,N=x*(Tt-1);switch(i.baseline){case"bottom":n-=N;break;case"top":n+=x-N;break;case"hanging":n+=x-2*N;break;case"middle":n+=x/2-N}0<(O=i.maxWidth||0)&&("string"==typeof t?t=c.splitTextToSize(t,O):"[object Array]"===Object.prototype.toString.call(t)&&(t=c.splitTextToSize(t.join(" "),O)));var L={text:t,x:e,y:n,options:i,mutex:{pdfEscape:vt,activeFontKey:$,fonts:rt,activeFontSize:et}};it.publish("preProcessText",L),t=L.text;a=(i=L.options).angle;var A=c.internal.scaleFactor,S=[];if(a){a*=Math.PI/180;var _=Math.cos(a),F=Math.sin(a);S=[Z(_),Z(F),Z(-1*F),Z(_)]}void 0!==(M=i.charSpace)&&(h+=Q(M*A)+" Tc\n");i.lang;var P=-1,k=void 0!==i.renderingMode?i.renderingMode:i.stroke,I=c.internal.getCurrentPageInfo().pageContext;switch(k){case 0:case!1:case"fill":P=0;break;case 1:case!0:case"stroke":P=1;break;case 2:case"fillThenStroke":P=2;break;case 3:case"invisible":P=3;break;case 4:case"fillAndAddForClipping":P=4;break;case 5:case"strokeAndAddPathForClipping":P=5;break;case 6:case"fillThenStrokeAndAddToPathForClipping":P=6;break;case 7:case"addToPathForClipping":P=7}var C=void 0!==I.usedRenderingMode?I.usedRenderingMode:-1;-1!==P?h+=P+" Tr\n":-1!==C&&(h+="0 Tr\n"),-1!==P&&(I.usedRenderingMode=P);s=i.align||"left";var B=et*u,j=c.internal.pageSize.getWidth(),E=(A=c.internal.scaleFactor,rt[$]),M=i.charSpace||Qt,O=i.maxWidth||0,q=(o={},[]);if("[object Array]"===Object.prototype.toString.call(t)){var T,R;v=f(t);"left"!==s&&(R=v.map(function(t){return c.getStringUnitWidth(t,{font:E,charSpace:M,fontSize:et})*et/A}));var D,U=Math.max.apply(Math,R),z=0;if("right"===s){e-=R[0],t=[];var H=0;for(w=v.length;H<w;H++)U-R[H],T=0===H?(D=Wt(e),Vt(n)):(D=(z-R[H])*A,-B),t.push([v[H],D,T]),z=R[H]}else if("center"===s){e-=R[0]/2,t=[];for(H=0,w=v.length;H<w;H++)(U-R[H])/2,T=0===H?(D=Wt(e),Vt(n)):(D=(z-R[H])/2*A,-B),t.push([v[H],D,T]),z=R[H]}else if("left"===s){t=[];for(H=0,w=v.length;H<w;H++)T=0===H?Vt(n):-B,D=0===H?Wt(e):0,t.push(v[H])}else{if("justify"!==s)throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');t=[];for(O=0!==O?O:j,H=0,w=v.length;H<w;H++)T=0===H?Vt(n):-B,D=0===H?Wt(e):0,H<w-1&&q.push(((O-R[H])/(v[H].split(" ").length-1)*A).toFixed(2)),t.push([v[H],D,T])}}!0===("boolean"==typeof i.R2L?i.R2L:nt)&&(t=p(t,function(t,e,n){return[t.split("").reverse().join(""),e,n]}));L={text:t,x:e,y:n,options:i,mutex:{pdfEscape:vt,activeFontKey:$,fonts:rt,activeFontSize:et}};it.publish("postProcessText",L),t=L.text,l=L.mutex.isHex;v=f(t);t=[];var W,V,G,Y=0,J=(w=v.length,"");for(H=0;H<w;H++)J="",Array.isArray(v[H])?(W=parseFloat(v[H][1]),V=parseFloat(v[H][2]),G=(l?"<":"(")+v[H][0]+(l?">":")"),Y=1):(W=Wt(e),V=Vt(n),G=(l?"<":"(")+v[H]+(l?">":")")),void 0!==q&&void 0!==q[H]&&(J=q[H]+" Tw\n"),0!==S.length&&0===H?t.push(J+S.join(" ")+" "+W.toFixed(2)+" "+V.toFixed(2)+" Tm\n"+G):1===Y||0===Y&&0===H?t.push(J+W.toFixed(2)+" "+V.toFixed(2)+" Td\n"+G):t.push(J+G);t=0===Y?t.join(" Tj\nT* "):t.join(" Tj\n"),t+=" Tj\n";var X="BT\n/"+$+" "+et+" Tf\n"+(et*u).toFixed(2)+" TL\n"+Kt+"\n";return X+=h,X+=t,tt(X+="ET"),K[$]=!0,c},l.__private__.lstext=l.lstext=function(t,e,n,r){return console.warn("jsPDF.lstext is deprecated"),this.text(t,e,n,{charSpace:r})},l.__private__.clip=l.clip=function(t){tt("evenodd"===t?"W*":"W"),tt("n")},l.__private__.clip_fixed=l.clip_fixed=function(t){console.log("clip_fixed is deprecated"),l.clip(t)};var Ot=l.__private__.isValidStyle=function(t){var e=!1;return-1!==[void 0,null,"S","F","DF","FD","f","f*","B","B*"].indexOf(t)&&(e=!0),e},qt=l.__private__.getStyle=function(t){var e="S";return"F"===t?e="f":"FD"===t||"DF"===t?e="B":"f"!==t&&"f*"!==t&&"B"!==t&&"B*"!==t||(e=t),e};l.__private__.line=l.line=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw new Error("Invalid arguments passed to jsPDF.line");return this.lines([[n-t,r-e]],t,e)},l.__private__.lines=l.lines=function(t,e,n,r,i,o){var a,s,l,h,u,c,f,p,d,g,m,y;if("number"==typeof t&&(y=n,n=e,e=t,t=y),r=r||[1,1],o=o||!1,isNaN(e)||isNaN(n)||!Array.isArray(t)||!Array.isArray(r)||!Ot(i)||"boolean"!=typeof o)throw new Error("Invalid arguments passed to jsPDF.lines");for(tt(Q(Wt(e))+" "+Q(Vt(n))+" m "),a=r[0],s=r[1],h=t.length,g=e,m=n,l=0;l<h;l++)2===(u=t[l]).length?(g=u[0]*a+g,m=u[1]*s+m,tt(Q(Wt(g))+" "+Q(Vt(m))+" l")):(c=u[0]*a+g,f=u[1]*s+m,p=u[2]*a+g,d=u[3]*s+m,g=u[4]*a+g,m=u[5]*s+m,tt(Q(Wt(c))+" "+Q(Vt(f))+" "+Q(Wt(p))+" "+Q(Vt(d))+" "+Q(Wt(g))+" "+Q(Vt(m))+" c"));return o&&tt(" h"),null!==i&&tt(qt(i)),this},l.__private__.rect=l.rect=function(t,e,n,r,i){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||!Ot(i))throw new Error("Invalid arguments passed to jsPDF.rect");return tt([Z(Wt(t)),Z(Vt(e)),Z(n*_),Z(-r*_),"re"].join(" ")),null!==i&&tt(qt(i)),this},l.__private__.triangle=l.triangle=function(t,e,n,r,i,o,a){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(o)||!Ot(a))throw new Error("Invalid arguments passed to jsPDF.triangle");return this.lines([[n-t,r-e],[i-n,o-r],[t-i,e-o]],t,e,[1,1],a,!0),this},l.__private__.roundedRect=l.roundedRect=function(t,e,n,r,i,o,a){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(o)||!Ot(a))throw new Error("Invalid arguments passed to jsPDF.roundedRect");var s=4/3*(Math.SQRT2-1);return this.lines([[n-2*i,0],[i*s,0,i,o-o*s,i,o],[0,r-2*o],[0,o*s,-i*s,o,-i,o],[2*i-n,0],[-i*s,0,-i,-o*s,-i,-o],[0,2*o-r],[0,-o*s,i*s,-o,i,-o]],t+i,e,[1,1],a),this},l.__private__.ellipse=l.ellipse=function(t,e,n,r,i){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||!Ot(i))throw new Error("Invalid arguments passed to jsPDF.ellipse");var o=4/3*(Math.SQRT2-1)*n,a=4/3*(Math.SQRT2-1)*r;return tt([Z(Wt(t+n)),Z(Vt(e)),"m",Z(Wt(t+n)),Z(Vt(e-a)),Z(Wt(t+o)),Z(Vt(e-r)),Z(Wt(t)),Z(Vt(e-r)),"c"].join(" ")),tt([Z(Wt(t-o)),Z(Vt(e-r)),Z(Wt(t-n)),Z(Vt(e-a)),Z(Wt(t-n)),Z(Vt(e)),"c"].join(" ")),tt([Z(Wt(t-n)),Z(Vt(e+a)),Z(Wt(t-o)),Z(Vt(e+r)),Z(Wt(t)),Z(Vt(e+r)),"c"].join(" ")),tt([Z(Wt(t+o)),Z(Vt(e+r)),Z(Wt(t+n)),Z(Vt(e+a)),Z(Wt(t+n)),Z(Vt(e)),"c"].join(" ")),null!==i&&tt(qt(i)),this},l.__private__.circle=l.circle=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||!Ot(r))throw new Error("Invalid arguments passed to jsPDF.circle");return this.ellipse(t,e,n,n,r)};l.setFont=function(t,e){return $=Lt(t,e,{disableWarning:!1}),this},l.setFontStyle=l.setFontType=function(t){return $=Lt(void 0,t),this};l.__private__.getFontList=l.getFontList=function(){var t,e,n,r={};for(t in H)if(H.hasOwnProperty(t))for(e in r[t]=n=[],H[t])H[t].hasOwnProperty(e)&&n.push(e);return r};l.addFont=function(t,e,n,r){yt.call(this,t,e,n,r=r||"Identity-H")};var Tt,Rt=r.lineWidth||.200025,Dt=l.__private__.setLineWidth=l.setLineWidth=function(t){return tt((t*_).toFixed(2)+" w"),this},Ut=(l.__private__.setLineDash=ae.API.setLineDash=function(t,e){if(t=t||[],e=e||0,isNaN(e)||!Array.isArray(t))throw new Error("Invalid arguments passed to jsPDF.setLineDash");return t=t.map(function(t){return(t*_).toFixed(3)}).join(" "),e=parseFloat((e*_).toFixed(3)),tt("["+t+"] "+e+" d"),this},l.__private__.getLineHeight=l.getLineHeight=function(){return et*Tt}),zt=(Ut=l.__private__.getLineHeight=l.getLineHeight=function(){return et*Tt},l.__private__.setLineHeightFactor=l.setLineHeightFactor=function(t){return"number"==typeof(t=t||1.15)&&(Tt=t),this}),Ht=l.__private__.getLineHeightFactor=l.getLineHeightFactor=function(){return Tt};zt(r.lineHeight);var Wt=l.__private__.getHorizontalCoordinate=function(t){return t*_},Vt=l.__private__.getVerticalCoordinate=function(t){return V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY-t*_},Gt=l.__private__.getHorizontalCoordinateString=function(t){return Z(t*_)},Yt=l.__private__.getVerticalCoordinateString=function(t){return Z(V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY-t*_)},Jt=r.strokeColor||"0 G",Xt=(l.__private__.getStrokeColor=l.getDrawColor=function(){return ht(Jt)},l.__private__.setStrokeColor=l.setDrawColor=function(t,e,n,r){return Jt=ut({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"draw",precision:2}),tt(Jt),this},r.fillColor||"0 g"),Kt=(l.__private__.getFillColor=l.getFillColor=function(){return ht(Xt)},l.__private__.setFillColor=l.setFillColor=function(t,e,n,r){return Xt=ut({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"fill",precision:2}),tt(Xt),this},r.textColor||"0 g"),Zt=l.__private__.getTextColor=l.getTextColor=function(){return ht(Kt)},Qt=(l.__private__.setTextColor=l.setTextColor=function(t,e,n,r){return Kt=ut({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"text",precision:3}),this},r.charSpace||0),$t=l.__private__.getCharSpace=l.getCharSpace=function(){return Qt},te=(l.__private__.setCharSpace=l.setCharSpace=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.setCharSpace");return Qt=t,this},0);l.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2};l.__private__.setLineCap=l.setLineCap=function(t){var e=l.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return tt((te=e)+" J"),this};var ee,ne=0;l.__private__.setLineJoin=l.setLineJoin=function(t){var e=l.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return tt((ne=e)+" j"),this},l.__private__.setMiterLimit=l.setMiterLimit=function(t){if(t=t||0,isNaN(t))throw new Error("Invalid argument passed to jsPDF.setMiterLimit");return ee=parseFloat(Z(t*_)),tt(ee+" M"),this};for(var re in l.save=function(r,t){if(r=r||"generated.pdf",(t=t||{}).returnPromise=t.returnPromise||!1,!1!==t.returnPromise)return new Promise(function(t,e){try{var n=le(It(kt()),r);"function"==typeof le.unload&&ie.setTimeout&&setTimeout(le.unload,911),t(n)}catch(t){e(t.message)}});le(It(kt()),r),"function"==typeof le.unload&&ie.setTimeout&&setTimeout(le.unload,911)},ae.API)ae.API.hasOwnProperty(re)&&("events"===re&&ae.API.events.length?function(t,e){var n,r,i;for(i=e.length-1;-1!==i;i--)n=e[i][0],r=e[i][1],t.subscribe.apply(t,[n].concat("function"==typeof r?[r]:r))}(it,ae.API.events):l[re]=ae.API[re]);return l.internal={pdfEscape:vt,getStyle:qt,getFont:function(){return rt[Lt.apply(l,arguments)]},getFontSize:O,getCharSpace:$t,getTextColor:Zt,getLineHeight:Ut,getLineHeightFactor:Ht,write:j,getHorizontalCoordinate:Wt,getVerticalCoordinate:Vt,getCoordinateString:Gt,getVerticalCoordinateString:Yt,collections:{},newObject:J,newAdditionalObject:at,newObjectDeferred:X,newObjectDeferredBegin:ot,getFilters:ct,putStream:ft,events:it,scaleFactor:_,pageSize:{getWidth:function(){return(V[x].mediaBox.topRightX-V[x].mediaBox.bottomLeftX)/_},setWidth:function(t){V[x].mediaBox.topRightX=t*_+V[x].mediaBox.bottomLeftX},getHeight:function(){return(V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY)/_},setHeight:function(t){V[x].mediaBox.topRightY=t*_+V[x].mediaBox.bottomLeftY}},output:Ct,getNumberOfPages:Nt,pages:I,out:tt,f2:Z,f3:Q,getPageInfo:jt,getPageInfoByObjId:Et,getCurrentPageInfo:Mt,getPDFVersion:u,hasHotfix:Bt},Object.defineProperty(l.internal.pageSize,"width",{get:function(){return(V[x].mediaBox.topRightX-V[x].mediaBox.bottomLeftX)/_},set:function(t){V[x].mediaBox.topRightX=t*_+V[x].mediaBox.bottomLeftX},enumerable:!0,configurable:!0}),Object.defineProperty(l.internal.pageSize,"height",{get:function(){return(V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY)/_},set:function(t){V[x].mediaBox.topRightY=t*_+V[x].mediaBox.bottomLeftY},enumerable:!0,configurable:!0}),function(t){for(var e=0,n=M.length;e<n;e++){var r=yt(t[e][0],t[e][1],t[e][2],M[e][3],!0);K[r]=!0;var i=t[e][0].split("-");mt(r,i[0],i[1]||"")}it.publish("addFonts",{fonts:rt,dictionary:H})}(M),$="F1",bt(i,t),it.publish("initialized"),l}return ae.API={events:[]},ae.version="1.5.3", true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return ae}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof module&&module.exports?(module.exports=ae,module.exports.jsPDF=ae):ie.jsPDF=ae,ae}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());
/**
   * @license
   * Copyright (c) 2016 Alexander Weidt,
   * https://github.com/BiggA94
   * 
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */
(function(t,e){var A,n=1,S=function(t){return t.replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},y=function(t){return t.replace(/\\\\/g,"\\").replace(/\\\(/g,"(").replace(/\\\)/g,")")},_=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return t.toFixed(2)},s=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return t.toFixed(5)};t.__acroform__={};var r=function(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t},v=function(t){return t*n},w=function(t){return t/n},l=function(t){var e=new j,n=Y.internal.getHeight(t)||0,r=Y.internal.getWidth(t)||0;return e.BBox=[0,0,Number(_(r)),Number(_(n))],e},i=t.__acroform__.setBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");return t|=1<<e},o=t.__acroform__.clearBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");return t&=~(1<<e)},a=t.__acroform__.getBit=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");return 0==(t&1<<e)?0:1},b=t.__acroform__.getBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");return a(t,e-1)},x=t.__acroform__.setBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");return i(t,e-1)},N=t.__acroform__.clearBitForPdf=function(t,e,n){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");return o(t,e-1)},c=t.__acroform__.calculateCoordinates=function(t){var e=this.internal.getHorizontalCoordinate,n=this.internal.getVerticalCoordinate,r=t[0],i=t[1],o=t[2],a=t[3],s={};return s.lowerLeft_X=e(r)||0,s.lowerLeft_Y=n(i+a)||0,s.upperRight_X=e(r+o)||0,s.upperRight_Y=n(i)||0,[Number(_(s.lowerLeft_X)),Number(_(s.lowerLeft_Y)),Number(_(s.upperRight_X)),Number(_(s.upperRight_Y))]},f=function(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e=[],n=t.V||t.DV,r=h(t,n),i=A.internal.getFont(t.fontName,t.fontStyle).id;e.push("/Tx BMC"),e.push("q"),e.push("BT"),e.push(A.__private__.encodeColorString(t.color)),e.push("/"+i+" "+_(r.fontSize)+" Tf"),e.push("1 0 0 1 0 0 Tm"),e.push(r.text),e.push("ET"),e.push("Q"),e.push("EMC");var o=new l(t);return o.stream=e.join("\n"),o}},h=function(i,t){var e=i.maxFontSize||12,n=(i.fontName,{text:"",fontSize:""}),o=(t=")"==(t="("==t.substr(0,1)?t.substr(1):t).substr(t.length-1)?t.substr(0,t.length-1):t).split(" "),r=(A.__private__.encodeColorString(i.color),e),a=Y.internal.getHeight(i)||0;a=a<0?-a:a;var s=Y.internal.getWidth(i)||0;s=s<0?-s:s;var l=function(t,e,n){if(t+1<o.length){var r=e+" "+o[t+1];return F(r,i,n).width<=s-4}return!1};r++;t:for(;;){t="";var h=F("3",i,--r).height,u=i.multiline?a-r:(a-h)/2,c=-2,f=u+=2,p=0,d=0,g=0;if(r<=0){t="(...) Tj\n",t+="% Width of Text: "+F(t,i,r=12).width+", FieldWidth:"+s+"\n";break}g=F(o[0]+" ",i,r).width;var m="",y=0;for(var v in o)if(o.hasOwnProperty(v)){m=" "==(m+=o[v]+" ").substr(m.length-1)?m.substr(0,m.length-1):m;var w=parseInt(v);g=F(m+" ",i,r).width;var b=l(w,m,r),x=v>=o.length-1;if(b&&!x){m+=" ";continue}if(b||x){if(x)d=w;else if(i.multiline&&a<(h+2)*(y+2)+2)continue t}else{if(!i.multiline)continue t;if(a<(h+2)*(y+2)+2)continue t;d=w}for(var N="",L=p;L<=d;L++)N+=o[L]+" ";switch(N=" "==N.substr(N.length-1)?N.substr(0,N.length-1):N,g=F(N,i,r).width,i.textAlign){case"right":c=s-g-2;break;case"center":c=(s-g)/2;break;case"left":default:c=2}t+=_(c)+" "+_(f)+" Td\n",t+="("+S(N)+") Tj\n",t+=-_(c)+" 0 Td\n",f=-(r+2),g=0,p=d+1,y++,m=""}else;break}return n.text=t,n.fontSize=r,n},F=function(t,e,n){var r=A.internal.getFont(e.fontName,e.fontStyle),i=A.getStringUnitWidth(t,{font:r,fontSize:parseFloat(n),charSpace:0})*parseFloat(n);return{height:A.getStringUnitWidth("3",{font:r,fontSize:parseFloat(n),charSpace:0})*parseFloat(n)*1.5,width:i}},u={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null,isInitialized:!1},p=function(){A.internal.acroformPlugin.acroFormDictionaryRoot.objId=void 0;var t=A.internal.acroformPlugin.acroFormDictionaryRoot.Fields;for(var e in t)if(t.hasOwnProperty(e)){var n=t[e];n.objId=void 0,n.hasAnnotation&&d.call(A,n)}},d=function(t){var e={type:"reference",object:t};void 0===A.internal.getPageInfo(t.page).pageContext.annotations.find(function(t){return t.type===e.type&&t.object===e.object})&&A.internal.getPageInfo(t.page).pageContext.annotations.push(e)},g=function(){if(void 0===A.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("putCatalogCallback: Root missing.");A.internal.write("/AcroForm "+A.internal.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R")},m=function(){A.internal.events.unsubscribe(A.internal.acroformPlugin.acroFormDictionaryRoot._eventID),delete A.internal.acroformPlugin.acroFormDictionaryRoot._eventID,A.internal.acroformPlugin.printedOut=!0},L=function(t){var e=!t;t||(A.internal.newObjectDeferredBegin(A.internal.acroformPlugin.acroFormDictionaryRoot.objId,!0),A.internal.acroformPlugin.acroFormDictionaryRoot.putStream());t=t||A.internal.acroformPlugin.acroFormDictionaryRoot.Kids;for(var n in t)if(t.hasOwnProperty(n)){var r=t[n],i=[],o=r.Rect;if(r.Rect&&(r.Rect=c.call(this,r.Rect)),A.internal.newObjectDeferredBegin(r.objId,!0),r.DA=Y.createDefaultAppearanceStream(r),"object"===se(r)&&"function"==typeof r.getKeyValueListForStream&&(i=r.getKeyValueListForStream()),r.Rect=o,r.hasAppearanceStream&&!r.appearanceStreamContent){var a=f.call(this,r);i.push({key:"AP",value:"<</N "+a+">>"}),A.internal.acroformPlugin.xForms.push(a)}if(r.appearanceStreamContent){var s="";for(var l in r.appearanceStreamContent)if(r.appearanceStreamContent.hasOwnProperty(l)){var h=r.appearanceStreamContent[l];if(s+="/"+l+" ",s+="<<",1<=Object.keys(h).length||Array.isArray(h))for(var n in h){var u;if(h.hasOwnProperty(n))"function"==typeof(u=h[n])&&(u=u.call(this,r)),s+="/"+n+" "+u+" ",0<=A.internal.acroformPlugin.xForms.indexOf(u)||A.internal.acroformPlugin.xForms.push(u)}else"function"==typeof(u=h)&&(u=u.call(this,r)),s+="/"+n+" "+u,0<=A.internal.acroformPlugin.xForms.indexOf(u)||A.internal.acroformPlugin.xForms.push(u);s+=">>"}i.push({key:"AP",value:"<<\n"+s+">>"})}A.internal.putStream({additionalKeyValues:i}),A.internal.out("endobj")}e&&P.call(this,A.internal.acroformPlugin.xForms)},P=function(t){for(var e in t)if(t.hasOwnProperty(e)){var n=e,r=t[e];A.internal.newObjectDeferredBegin(r&&r.objId,!0),"object"===se(r)&&"function"==typeof r.putStream&&r.putStream(),delete t[n]}},k=function(){if(void 0!==this.internal&&(void 0===this.internal.acroformPlugin||!1===this.internal.acroformPlugin.isInitialized)){if(A=this,M.FieldNum=0,this.internal.acroformPlugin=JSON.parse(JSON.stringify(u)),this.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");n=A.internal.scaleFactor,A.internal.acroformPlugin.acroFormDictionaryRoot=new E,A.internal.acroformPlugin.acroFormDictionaryRoot._eventID=A.internal.events.subscribe("postPutResources",m),A.internal.events.subscribe("buildDocument",p),A.internal.events.subscribe("putCatalog",g),A.internal.events.subscribe("postPutPages",L),A.internal.acroformPlugin.isInitialized=!0}},I=t.__acroform__.arrayToPdfArray=function(t){if(Array.isArray(t)){for(var e="[",n=0;n<t.length;n++)switch(0!==n&&(e+=" "),se(t[n])){case"boolean":case"number":case"object":e+=t[n].toString();break;case"string":"/"!==t[n].substr(0,1)?e+="("+S(t[n].toString())+")":e+=t[n].toString()}return e+="]"}throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray")};var C=function(t){return(t=t||"").toString(),t="("+S(t)+")"},B=function(){var e;Object.defineProperty(this,"objId",{configurable:!0,get:function(){if(e||(e=A.internal.newObjectDeferred()),!e)throw new Error("AcroFormPDFObject: Couldn't create Object ID");return e},set:function(t){e=t}})};B.prototype.toString=function(){return this.objId+" 0 R"},B.prototype.putStream=function(){var t=this.getKeyValueListForStream();A.internal.putStream({data:this.stream,additionalKeyValues:t}),A.internal.out("endobj")},B.prototype.getKeyValueListForStream=function(){return function(t){var e=[],n=Object.getOwnPropertyNames(t).filter(function(t){return"content"!=t&&"appearanceStreamContent"!=t&&"_"!=t.substring(0,1)});for(var r in n)if(!1===Object.getOwnPropertyDescriptor(t,n[r]).configurable){var i=n[r],o=t[i];o&&(Array.isArray(o)?e.push({key:i,value:I(o)}):o instanceof B?e.push({key:i,value:o.objId+" 0 R"}):"function"!=typeof o&&e.push({key:i,value:o}))}return e}(this)};var j=function(){B.call(this),Object.defineProperty(this,"Type",{value:"/XObject",configurable:!1,writeable:!0}),Object.defineProperty(this,"Subtype",{value:"/Form",configurable:!1,writeable:!0}),Object.defineProperty(this,"FormType",{value:1,configurable:!1,writeable:!0});var e,n=[];Object.defineProperty(this,"BBox",{configurable:!1,writeable:!0,get:function(){return n},set:function(t){n=t}}),Object.defineProperty(this,"Resources",{value:"2 0 R",configurable:!1,writeable:!0}),Object.defineProperty(this,"stream",{enumerable:!1,configurable:!0,set:function(t){e=t.trim()},get:function(){return e||null}})};r(j,B);var E=function(){B.call(this);var e,t=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return 0<t.length?t:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!1,configurable:!1,get:function(){return t}}),Object.defineProperty(this,"DA",{enumerable:!1,configurable:!1,get:function(){if(e)return"("+e+")"},set:function(t){e=t}})};r(E,B);var M=function t(){B.call(this);var e=4;Object.defineProperty(this,"F",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute F supplied.');e=t}}),Object.defineProperty(this,"showWhenPrinted",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(e,3))},set:function(t){!0===Boolean(t)?this.F=x(e,3):this.F=N(e,3)}});var n=0;Object.defineProperty(this,"Ff",{enumerable:!1,configurable:!1,get:function(){return n},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute Ff supplied.');n=t}});var r=[];Object.defineProperty(this,"Rect",{enumerable:!1,configurable:!1,get:function(){if(0!==r.length)return r},set:function(t){r=void 0!==t?t:[]}}),Object.defineProperty(this,"x",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[0])?0:w(r[0])},set:function(t){r[0]=v(t)}}),Object.defineProperty(this,"y",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[1])?0:w(r[1])},set:function(t){r[1]=v(t)}}),Object.defineProperty(this,"width",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[2])?0:w(r[2])},set:function(t){r[2]=v(t)}}),Object.defineProperty(this,"height",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[3])?0:w(r[3])},set:function(t){r[3]=v(t)}});var i="";Object.defineProperty(this,"FT",{enumerable:!0,configurable:!1,get:function(){return i},set:function(t){switch(t){case"/Btn":case"/Tx":case"/Ch":case"/Sig":i=t;break;default:throw new Error('Invalid value "'+t+'" for attribute FT supplied.')}}});var o=null;Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,get:function(){if(!o||o.length<1){if(this instanceof H)return;o="FieldObject"+t.FieldNum++}return"("+S(o)+")"},set:function(t){o=t.toString()}}),Object.defineProperty(this,"fieldName",{configurable:!0,enumerable:!0,get:function(){return o},set:function(t){o=t}});var a="helvetica";Object.defineProperty(this,"fontName",{enumerable:!0,configurable:!0,get:function(){return a},set:function(t){a=t}});var s="normal";Object.defineProperty(this,"fontStyle",{enumerable:!0,configurable:!0,get:function(){return s},set:function(t){s=t}});var l=0;Object.defineProperty(this,"fontSize",{enumerable:!0,configurable:!0,get:function(){return w(l)},set:function(t){l=v(t)}});var h=50;Object.defineProperty(this,"maxFontSize",{enumerable:!0,configurable:!0,get:function(){return w(h)},set:function(t){h=v(t)}});var u="black";Object.defineProperty(this,"color",{enumerable:!0,configurable:!0,get:function(){return u},set:function(t){u=t}});var c="/F1 0 Tf 0 g";Object.defineProperty(this,"DA",{enumerable:!0,configurable:!1,get:function(){if(!(!c||this instanceof H||this instanceof V))return C(c)},set:function(t){t=t.toString(),c=t}});var f=null;Object.defineProperty(this,"DV",{enumerable:!1,configurable:!1,get:function(){if(f)return this instanceof D==!1?C(f):f},set:function(t){t=t.toString(),f=this instanceof D==!1?"("===t.substr(0,1)?y(t.substr(1,t.length-2)):y(t):t}}),Object.defineProperty(this,"defaultValue",{enumerable:!0,configurable:!0,get:function(){return this instanceof D==!0?y(f.substr(1,f.length-1)):f},set:function(t){t=t.toString(),f=this instanceof D==!0?"/"+t:t}});var p=null;Object.defineProperty(this,"V",{enumerable:!1,configurable:!1,get:function(){if(p)return this instanceof D==!1?C(p):p},set:function(t){t=t.toString(),p=this instanceof D==!1?"("===t.substr(0,1)?y(t.substr(1,t.length-2)):y(t):t}}),Object.defineProperty(this,"value",{enumerable:!0,configurable:!0,get:function(){return this instanceof D==!0?y(p.substr(1,p.length-1)):p},set:function(t){t=t.toString(),p=this instanceof D==!0?"/"+t:t}}),Object.defineProperty(this,"hasAnnotation",{enumerable:!0,configurable:!0,get:function(){return this.Rect}}),Object.defineProperty(this,"Type",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Widget":null}});var d,g=!1;Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,writeable:!0,get:function(){return g},set:function(t){t=Boolean(t),g=t}}),Object.defineProperty(this,"page",{enumerable:!0,configurable:!0,writeable:!0,get:function(){if(d)return d},set:function(t){d=t}}),Object.defineProperty(this,"readOnly",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,1))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,1):this.Ff=N(this.Ff,1)}}),Object.defineProperty(this,"required",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,2))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,2):this.Ff=N(this.Ff,2)}}),Object.defineProperty(this,"noExport",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,3))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,3):this.Ff=N(this.Ff,3)}});var m=null;Object.defineProperty(this,"Q",{enumerable:!0,configurable:!1,get:function(){if(null!==m)return m},set:function(t){if(-1===[0,1,2].indexOf(t))throw new Error('Invalid value "'+t+'" for attribute Q supplied.');m=t}}),Object.defineProperty(this,"textAlign",{get:function(){var t="left";switch(m){case 0:default:t="left";break;case 1:t="center";break;case 2:t="right"}return t},configurable:!0,enumerable:!0,set:function(t){switch(t){case"right":case 2:m=2;break;case"center":case 1:m=1;break;case"left":case 0:default:m=0}}})};r(M,B);var O=function(){M.call(this),this.FT="/Ch",this.V="()",this.fontName="zapfdingbats";var e=0;Object.defineProperty(this,"TI",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"topIndex",{enumerable:!0,configurable:!0,get:function(){return e},set:function(t){e=t}});var r=[];Object.defineProperty(this,"Opt",{enumerable:!0,configurable:!1,get:function(){return I(r)},set:function(t){var e,n;n=[],"string"==typeof(e=t)&&(n=function(t,e,n){n||(n=1);for(var r,i=[];r=e.exec(t);)i.push(r[n]);return i}(e,/\((.*?)\)/g)),r=n}}),this.getOptions=function(){return r},this.setOptions=function(t){r=t,this.sort&&r.sort()},this.addOption=function(t){t=(t=t||"").toString(),r.push(t),this.sort&&r.sort()},this.removeOption=function(t,e){for(e=e||!1,t=(t=t||"").toString();-1!==r.indexOf(t)&&(r.splice(r.indexOf(t),1),!1!==e););},Object.defineProperty(this,"combo",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,18))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,18):this.Ff=N(this.Ff,18)}}),Object.defineProperty(this,"edit",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,19))},set:function(t){!0===this.combo&&(!0===Boolean(t)?this.Ff=x(this.Ff,19):this.Ff=N(this.Ff,19))}}),Object.defineProperty(this,"sort",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,20))},set:function(t){!0===Boolean(t)?(this.Ff=x(this.Ff,20),r.sort()):this.Ff=N(this.Ff,20)}}),Object.defineProperty(this,"multiSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,22))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,22):this.Ff=N(this.Ff,22)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,23):this.Ff=N(this.Ff,23)}}),Object.defineProperty(this,"commitOnSelChange",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,27))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,27):this.Ff=N(this.Ff,27)}}),this.hasAppearanceStream=!1};r(O,M);var q=function(){O.call(this),this.fontName="helvetica",this.combo=!1};r(q,O);var T=function(){q.call(this),this.combo=!0};r(T,q);var R=function(){T.call(this),this.edit=!0};r(R,T);var D=function(){M.call(this),this.FT="/Btn",Object.defineProperty(this,"noToggleToOff",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,15))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,15):this.Ff=N(this.Ff,15)}}),Object.defineProperty(this,"radio",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,16))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,16):this.Ff=N(this.Ff,16)}}),Object.defineProperty(this,"pushButton",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,17))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,17):this.Ff=N(this.Ff,17)}}),Object.defineProperty(this,"radioIsUnison",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,26):this.Ff=N(this.Ff,26)}});var e,n={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){if(0!==Object.keys(n).length){var t,e=[];for(t in e.push("<<"),n)e.push("/"+t+" ("+n[t]+")");return e.push(">>"),e.join("\n")}},set:function(t){"object"===se(t)&&(n=t)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return n.CA||""},set:function(t){"string"==typeof t&&(n.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return e.substr(1,e.length-1)},set:function(t){e="/"+t}})};r(D,M);var U=function(){D.call(this),this.pushButton=!0};r(U,D);var z=function(){D.call(this),this.radio=!0,this.pushButton=!1;var e=[];Object.defineProperty(this,"Kids",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=void 0!==t?t:[]}})};r(z,D);var H=function(){var e,n;M.call(this),Object.defineProperty(this,"Parent",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"optionName",{enumerable:!1,configurable:!0,get:function(){return n},set:function(t){n=t}});var r,i={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){var t,e=[];for(t in e.push("<<"),i)e.push("/"+t+" ("+i[t]+")");return e.push(">>"),e.join("\n")},set:function(t){"object"===se(t)&&(i=t)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return i.CA||""},set:function(t){"string"==typeof t&&(i.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return r},set:function(t){r=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return r.substr(1,r.length-1)},set:function(t){r="/"+t}}),this.optionName=name,this.caption="l",this.appearanceState="Off",this._AppearanceType=Y.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(name)};r(H,M),z.prototype.setAppearance=function(t){if(!("createAppearanceStream"in t&&"getCA"in t))throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");for(var e in this.Kids)if(this.Kids.hasOwnProperty(e)){var n=this.Kids[e];n.appearanceStreamContent=t.createAppearanceStream(n.optionName),n.caption=t.getCA()}},z.prototype.createOption=function(t){this.Kids.length;var e=new H;return e.Parent=this,e.optionName=t,this.Kids.push(e),J.call(this,e),e};var W=function(){D.call(this),this.fontName="zapfdingbats",this.caption="3",this.appearanceState="On",this.value="On",this.textAlign="center",this.appearanceStreamContent=Y.CheckBox.createAppearanceStream()};r(W,D);var V=function(){M.call(this),this.FT="/Tx",Object.defineProperty(this,"multiline",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,13))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,13):this.Ff=N(this.Ff,13)}}),Object.defineProperty(this,"fileSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,21))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,21):this.Ff=N(this.Ff,21)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,23):this.Ff=N(this.Ff,23)}}),Object.defineProperty(this,"doNotScroll",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,24))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,24):this.Ff=N(this.Ff,24)}}),Object.defineProperty(this,"comb",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,25))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,25):this.Ff=N(this.Ff,25)}}),Object.defineProperty(this,"richText",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,26):this.Ff=N(this.Ff,26)}});var e=null;Object.defineProperty(this,"MaxLen",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"maxLength",{enumerable:!0,configurable:!0,get:function(){return e},set:function(t){Number.isInteger(t)&&(e=t)}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,get:function(){return this.V||this.DV}})};r(V,M);var G=function(){V.call(this),Object.defineProperty(this,"password",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,14))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,14):this.Ff=N(this.Ff,14)}}),this.password=!0};r(G,V);var Y={CheckBox:{createAppearanceStream:function(){return{N:{On:Y.CheckBox.YesNormal},D:{On:Y.CheckBox.YesPushDown,Off:Y.CheckBox.OffPushDown}}},YesPushDown:function(t){var e=l(t),n=[],r=A.internal.getFont(t.fontName,t.fontStyle).id,i=A.__private__.encodeColorString(t.color),o=h(t,t.caption);return n.push("0.749023 g"),n.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),n.push("f"),n.push("BMC"),n.push("q"),n.push("0 0 1 rg"),n.push("/"+r+" "+_(o.fontSize)+" Tf "+i),n.push("BT"),n.push(o.text),n.push("ET"),n.push("Q"),n.push("EMC"),e.stream=n.join("\n"),e},YesNormal:function(t){var e=l(t),n=A.internal.getFont(t.fontName,t.fontStyle).id,r=A.__private__.encodeColorString(t.color),i=[],o=Y.internal.getHeight(t),a=Y.internal.getWidth(t),s=h(t,t.caption);return i.push("1 g"),i.push("0 0 "+_(a)+" "+_(o)+" re"),i.push("f"),i.push("q"),i.push("0 0 1 rg"),i.push("0 0 "+_(a-1)+" "+_(o-1)+" re"),i.push("W"),i.push("n"),i.push("0 g"),i.push("BT"),i.push("/"+n+" "+_(s.fontSize)+" Tf "+r),i.push(s.text),i.push("ET"),i.push("Q"),e.stream=i.join("\n"),e},OffPushDown:function(t){var e=l(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),n.push("f"),e.stream=n.join("\n"),e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:Y.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=Y.RadioButton.Circle.YesNormal,e.D[t]=Y.RadioButton.Circle.YesPushDown,e},getCA:function(){return"l"},YesNormal:function(t){var e=l(t),n=[],r=Y.internal.getWidth(t)<=Y.internal.getHeight(t)?Y.internal.getWidth(t)/4:Y.internal.getHeight(t)/4;r=Number((.9*r).toFixed(5));var i=Y.internal.Bezier_C,o=Number((r*i).toFixed(5));return n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(r+" 0 m"),n.push(r+" "+o+" "+o+" "+r+" 0 "+r+" c"),n.push("-"+o+" "+r+" -"+r+" "+o+" -"+r+" 0 c"),n.push("-"+r+" -"+o+" -"+o+" -"+r+" 0 -"+r+" c"),n.push(o+" -"+r+" "+r+" -"+o+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=l(t),n=[],r=Y.internal.getWidth(t)<=Y.internal.getHeight(t)?Y.internal.getWidth(t)/4:Y.internal.getHeight(t)/4,i=(r=Number((.9*r).toFixed(5)),Number((2*r).toFixed(5))),o=Number((i*Y.internal.Bezier_C).toFixed(5)),a=Number((r*Y.internal.Bezier_C).toFixed(5));return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),n.push("0 g"),n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(r+" 0 m"),n.push(r+" "+a+" "+a+" "+r+" 0 "+r+" c"),n.push("-"+a+" "+r+" -"+r+" "+a+" -"+r+" 0 c"),n.push("-"+r+" -"+a+" -"+a+" -"+r+" 0 -"+r+" c"),n.push(a+" -"+r+" "+r+" -"+a+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},OffPushDown:function(t){var e=l(t),n=[],r=Y.internal.getWidth(t)<=Y.internal.getHeight(t)?Y.internal.getWidth(t)/4:Y.internal.getHeight(t)/4,i=(r=Number((.9*r).toFixed(5)),Number((2*r).toFixed(5))),o=Number((i*Y.internal.Bezier_C).toFixed(5));return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:Y.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=Y.RadioButton.Cross.YesNormal,e.D[t]=Y.RadioButton.Cross.YesPushDown,e},getCA:function(){return"8"},YesNormal:function(t){var e=l(t),n=[],r=Y.internal.calculateCross(t);return n.push("q"),n.push("1 1 "+_(Y.internal.getWidth(t)-2)+" "+_(Y.internal.getHeight(t)-2)+" re"),n.push("W"),n.push("n"),n.push(_(r.x1.x)+" "+_(r.x1.y)+" m"),n.push(_(r.x2.x)+" "+_(r.x2.y)+" l"),n.push(_(r.x4.x)+" "+_(r.x4.y)+" m"),n.push(_(r.x3.x)+" "+_(r.x3.y)+" l"),n.push("s"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=l(t),n=Y.internal.calculateCross(t),r=[];return r.push("0.749023 g"),r.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),r.push("f"),r.push("q"),r.push("1 1 "+_(Y.internal.getWidth(t)-2)+" "+_(Y.internal.getHeight(t)-2)+" re"),r.push("W"),r.push("n"),r.push(_(n.x1.x)+" "+_(n.x1.y)+" m"),r.push(_(n.x2.x)+" "+_(n.x2.y)+" l"),r.push(_(n.x4.x)+" "+_(n.x4.y)+" m"),r.push(_(n.x3.x)+" "+_(n.x3.y)+" l"),r.push("s"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=l(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),n.push("f"),e.stream=n.join("\n"),e}}},createDefaultAppearanceStream:function(t){var e=A.internal.getFont(t.fontName,t.fontStyle).id,n=A.__private__.encodeColorString(t.color);return"/"+e+" "+t.fontSize+" Tf "+n}};Y.internal={Bezier_C:.551915024494,calculateCross:function(t){var e=Y.internal.getWidth(t),n=Y.internal.getHeight(t),r=Math.min(e,n);return{x1:{x:(e-r)/2,y:(n-r)/2+r},x2:{x:(e-r)/2+r,y:(n-r)/2},x3:{x:(e-r)/2,y:(n-r)/2},x4:{x:(e-r)/2+r,y:(n-r)/2+r}}}},Y.internal.getWidth=function(t){var e=0;return"object"===se(t)&&(e=v(t.Rect[2])),e},Y.internal.getHeight=function(t){var e=0;return"object"===se(t)&&(e=v(t.Rect[3])),e};var J=t.addField=function(t){if(k.call(this),!(t instanceof M))throw new Error("Invalid argument passed to jsPDF.addField.");return function(t){A.internal.acroformPlugin.printedOut&&(A.internal.acroformPlugin.printedOut=!1,A.internal.acroformPlugin.acroFormDictionaryRoot=null),A.internal.acroformPlugin.acroFormDictionaryRoot||k.call(A),A.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t)}.call(this,t),t.page=A.internal.getCurrentPageInfo().pageNumber,this};t.addButton=function(t){if(t instanceof D==!1)throw new Error("Invalid argument passed to jsPDF.addButton.");return J.call(this,t)},t.addTextField=function(t){if(t instanceof V==!1)throw new Error("Invalid argument passed to jsPDF.addTextField.");return J.call(this,t)},t.addChoiceField=function(t){if(t instanceof O==!1)throw new Error("Invalid argument passed to jsPDF.addChoiceField.");return J.call(this,t)};"object"==se(e)&&void 0===e.ChoiceField&&void 0===e.ListBox&&void 0===e.ComboBox&&void 0===e.EditBox&&void 0===e.Button&&void 0===e.PushButton&&void 0===e.RadioButton&&void 0===e.CheckBox&&void 0===e.TextField&&void 0===e.PasswordField?(e.ChoiceField=O,e.ListBox=q,e.ComboBox=T,e.EditBox=R,e.Button=D,e.PushButton=U,e.RadioButton=z,e.CheckBox=W,e.TextField=V,e.PasswordField=G,e.AcroForm={Appearance:Y}):console.warn("AcroForm-Classes are not populated into global-namespace, because the class-Names exist already."),t.AcroFormChoiceField=O,t.AcroFormListBox=q,t.AcroFormComboBox=T,t.AcroFormEditBox=R,t.AcroFormButton=D,t.AcroFormPushButton=U,t.AcroFormRadioButton=z,t.AcroFormCheckBox=W,t.AcroFormTextField=V,t.AcroFormPasswordField=G,t.AcroFormAppearance=Y,t.AcroForm={ChoiceField:O,ListBox:q,ComboBox:T,EditBox:R,Button:D,PushButton:U,RadioButton:z,CheckBox:W,TextField:V,PasswordField:G,Appearance:Y}})((window.tmp=lt).API,"undefined"!=typeof window&&window||"undefined"!=typeof global&&global),
/** @license
   * jsPDF addImage plugin
   * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
   *               2013 Chris Dowling, https://github.com/gingerchris
   *               2013 Trinh Ho, https://github.com/ineedfat
   *               2013 Edwin Alejandro Perez, https://github.com/eaparango
   *               2013 Norah Smith, https://github.com/burnburnrocket
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   */
function(x){var N="addImage_",l={PNG:[[137,80,78,71]],TIFF:[[77,77,0,42],[73,73,42,0]],JPEG:[[255,216,255,224,void 0,void 0,74,70,73,70,0],[255,216,255,225,void 0,void 0,69,120,105,102,0,0]],JPEG2000:[[0,0,0,12,106,80,32,32]],GIF87a:[[71,73,70,56,55,97]],GIF89a:[[71,73,70,56,57,97]],BMP:[[66,77],[66,65],[67,73],[67,80],[73,67],[80,84]]},h=x.getImageFileTypeByImageData=function(t,e){var n,r;e=e||"UNKNOWN";var i,o,a,s="UNKNOWN";for(a in x.isArrayBufferView(t)&&(t=x.arrayBufferToBinaryString(t)),l)for(i=l[a],n=0;n<i.length;n+=1){for(o=!0,r=0;r<i[n].length;r+=1)if(void 0!==i[n][r]&&i[n][r]!==t.charCodeAt(r)){o=!1;break}if(!0===o){s=a;break}}return"UNKNOWN"===s&&"UNKNOWN"!==e&&(console.warn('FileType of Image not recognized. Processing image as "'+e+'".'),s=e),s},n=function t(e){for(var n=this.internal.newObject(),r=this.internal.write,i=this.internal.putStream,o=(0,this.internal.getFilters)();-1!==o.indexOf("FlateEncode");)o.splice(o.indexOf("FlateEncode"),1);e.n=n;var a=[];if(a.push({key:"Type",value:"/XObject"}),a.push({key:"Subtype",value:"/Image"}),a.push({key:"Width",value:e.w}),a.push({key:"Height",value:e.h}),e.cs===this.color_spaces.INDEXED?a.push({key:"ColorSpace",value:"[/Indexed /DeviceRGB "+(e.pal.length/3-1)+" "+("smask"in e?n+2:n+1)+" 0 R]"}):(a.push({key:"ColorSpace",value:"/"+e.cs}),e.cs===this.color_spaces.DEVICE_CMYK&&a.push({key:"Decode",value:"[1 0 1 0 1 0 1 0]"})),a.push({key:"BitsPerComponent",value:e.bpc}),"dp"in e&&a.push({key:"DecodeParms",value:"<<"+e.dp+">>"}),"trns"in e&&e.trns.constructor==Array){for(var s="",l=0,h=e.trns.length;l<h;l++)s+=e.trns[l]+" "+e.trns[l]+" ";a.push({key:"Mask",value:"["+s+"]"})}"smask"in e&&a.push({key:"SMask",value:n+1+" 0 R"});var u=void 0!==e.f?["/"+e.f]:void 0;if(i({data:e.data,additionalKeyValues:a,alreadyAppliedFilters:u}),r("endobj"),"smask"in e){var c="/Predictor "+e.p+" /Colors 1 /BitsPerComponent "+e.bpc+" /Columns "+e.w,f={w:e.w,h:e.h,cs:"DeviceGray",bpc:e.bpc,dp:c,data:e.smask};"f"in e&&(f.f=e.f),t.call(this,f)}e.cs===this.color_spaces.INDEXED&&(this.internal.newObject(),i({data:this.arrayBufferToBinaryString(new Uint8Array(e.pal))}),r("endobj"))},L=function(){var t=this.internal.collections[N+"images"];for(var e in t)n.call(this,t[e])},A=function(){var t,e=this.internal.collections[N+"images"],n=this.internal.write;for(var r in e)n("/I"+(t=e[r]).i,t.n,"0","R")},S=function(t){return"function"==typeof x["process"+t.toUpperCase()]},_=function(t){return"object"===se(t)&&1===t.nodeType},F=function(t,e){if("IMG"===t.nodeName&&t.hasAttribute("src")){var n=""+t.getAttribute("src");if(0===n.indexOf("data:image/"))return unescape(n);var r=x.loadFile(n);if(void 0!==r)return btoa(r)}if("CANVAS"===t.nodeName){var i=t;return t.toDataURL("image/jpeg",1)}(i=document.createElement("canvas")).width=t.clientWidth||t.width,i.height=t.clientHeight||t.height;var o=i.getContext("2d");if(!o)throw"addImage requires canvas to be supported by browser.";return o.drawImage(t,0,0,i.width,i.height),i.toDataURL("png"==(""+e).toLowerCase()?"image/png":"image/jpeg")},P=function(t,e){var n;if(e)for(var r in e)if(t===e[r].alias){n=e[r];break}return n};x.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"},x.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"},x.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},x.sHashCode=function(t){var e,n=0;if(0===(t=t||"").length)return n;for(e=0;e<t.length;e++)n=(n<<5)-n+t.charCodeAt(e),n|=0;return n},x.isString=function(t){return"string"==typeof t},x.validateStringAsBase64=function(t){(t=t||"").toString().trim();var e=!0;return 0===t.length&&(e=!1),t.length%4!=0&&(e=!1),!1===/^[A-Za-z0-9+\/]+$/.test(t.substr(0,t.length-2))&&(e=!1),!1===/^[A-Za-z0-9\/][A-Za-z0-9+\/]|[A-Za-z0-9+\/]=|==$/.test(t.substr(-2))&&(e=!1),e},x.extractInfoFromBase64DataURI=function(t){return/^data:([\w]+?\/([\w]+?));\S*;*base64,(.+)$/g.exec(t)},x.extractImageFromDataUrl=function(t){var e=(t=t||"").split("base64,"),n=null;if(2===e.length){var r=/^data:(\w*\/\w*);*(charset=[\w=-]*)*;*$/.exec(e[0]);Array.isArray(r)&&(n={mimeType:r[1],charset:r[2],data:e[1]})}return n},x.supportsArrayBuffer=function(){return"undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array},x.isArrayBuffer=function(t){return!!this.supportsArrayBuffer()&&t instanceof ArrayBuffer},x.isArrayBufferView=function(t){return!!this.supportsArrayBuffer()&&("undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array))},x.binaryStringToUint8Array=function(t){for(var e=t.length,n=new Uint8Array(e),r=0;r<e;r++)n[r]=t.charCodeAt(r);return n},x.arrayBufferToBinaryString=function(t){if("function"==typeof atob)return atob(this.arrayBufferToBase64(t))},x.arrayBufferToBase64=function(t){for(var e,n="",r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",i=new Uint8Array(t),o=i.byteLength,a=o%3,s=o-a,l=0;l<s;l+=3)n+=r[(16515072&(e=i[l]<<16|i[l+1]<<8|i[l+2]))>>18]+r[(258048&e)>>12]+r[(4032&e)>>6]+r[63&e];return 1==a?n+=r[(252&(e=i[s]))>>2]+r[(3&e)<<4]+"==":2==a&&(n+=r[(64512&(e=i[s]<<8|i[s+1]))>>10]+r[(1008&e)>>4]+r[(15&e)<<2]+"="),n},x.createImageInfo=function(t,e,n,r,i,o,a,s,l,h,u,c,f){var p={alias:s,w:e,h:n,cs:r,bpc:i,i:a,data:t};return o&&(p.f=o),l&&(p.dp=l),h&&(p.trns=h),u&&(p.pal=u),c&&(p.smask=c),f&&(p.p=f),p},x.addImage=function(t,e,n,r,i,o,a,s,l){var h="";if("string"!=typeof e){var u=o;o=i,i=r,r=n,n=e,e=u}if("object"===se(t)&&!_(t)&&"imageData"in t){var c=t;t=c.imageData,e=c.format||e||"UNKNOWN",n=c.x||n||0,r=c.y||r||0,i=c.w||i,o=c.h||o,a=c.alias||a,s=c.compression||s,l=c.rotation||c.angle||l}var f=this.internal.getFilters();if(void 0===s&&-1!==f.indexOf("FlateEncode")&&(s="SLOW"),"string"==typeof t&&(t=unescape(t)),isNaN(n)||isNaN(r))throw console.error("jsPDF.addImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addImage");var p,d,g,m,y,v,w,b=function(){var t=this.internal.collections[N+"images"];return t||(this.internal.collections[N+"images"]=t={},this.internal.events.subscribe("putResources",L),this.internal.events.subscribe("putXobjectDict",A)),t}.call(this);if(!((p=P(t,b))||(_(t)&&(t=F(t,e)),(null==(w=a)||0===w.length)&&(a="string"==typeof(v=t)?x.sHashCode(v):x.isArrayBufferView(v)?x.sHashCode(x.arrayBufferToBinaryString(v)):null),p=P(a,b)))){if(this.isString(t)&&(""!==(h=this.convertStringToImageData(t))?t=h:void 0!==(h=x.loadFile(t))&&(t=h)),e=this.getImageFileTypeByImageData(t,e),!S(e))throw new Error("addImage does not support files of type '"+e+"', please ensure that a plugin for '"+e+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(d=t,t=this.binaryStringToUint8Array(t))),!(p=this["process"+e.toUpperCase()](t,(y=0,(m=b)&&(y=Object.keys?Object.keys(m).length:function(t){var e=0;for(var n in t)t.hasOwnProperty(n)&&e++;return e}(m)),y),a,((g=s)&&"string"==typeof g&&(g=g.toUpperCase()),g in x.image_compression?g:x.image_compression.NONE),d)))throw new Error("An unknown error occurred whilst processing the image")}return function(t,e,n,r,i,o,a,s){var l=function(t,e,n){return t||e||(e=t=-96),t<0&&(t=-1*n.w*72/t/this.internal.scaleFactor),e<0&&(e=-1*n.h*72/e/this.internal.scaleFactor),0===t&&(t=e*n.w/n.h),0===e&&(e=t*n.h/n.w),[t,e]}.call(this,n,r,i),h=this.internal.getCoordinateString,u=this.internal.getVerticalCoordinateString;if(n=l[0],r=l[1],a[o]=i,s){s*=Math.PI/180;var c=Math.cos(s),f=Math.sin(s),p=function(t){return t.toFixed(4)},d=[p(c),p(f),p(-1*f),p(c),0,0,"cm"]}this.internal.write("q"),s?(this.internal.write([1,"0","0",1,h(t),u(e+r),"cm"].join(" ")),this.internal.write(d.join(" ")),this.internal.write([h(n),"0","0",h(r),"0","0","cm"].join(" "))):this.internal.write([h(n),"0","0",h(r),h(t),u(e+r),"cm"].join(" ")),this.internal.write("/I"+i.i+" Do"),this.internal.write("Q")}.call(this,n,r,i,o,p,p.i,b,l),this},x.convertStringToImageData=function(t){var e,n="";if(this.isString(t)){var r;e=null!==(r=this.extractImageFromDataUrl(t))?r.data:t;try{n=atob(e)}catch(t){throw x.validateStringAsBase64(e)?new Error("atob-Error in jsPDF.convertStringToImageData "+t.message):new Error("Supplied Data is not a valid base64-String jsPDF.convertStringToImageData ")}}return n};var u=function(t,e){return t.subarray(e,e+5)};x.processJPEG=function(t,e,n,r,i,o){var a,s=this.decode.DCT_DECODE;if(!this.isString(t)&&!this.isArrayBuffer(t)&&!this.isArrayBufferView(t))return null;if(this.isString(t)&&(a=function(t){var e;if("JPEG"!==h(t))throw new Error("getJpegSize requires a binary string jpeg file");for(var n=256*t.charCodeAt(4)+t.charCodeAt(5),r=4,i=t.length;r<i;){if(r+=n,255!==t.charCodeAt(r))throw new Error("getJpegSize could not find the size of the image");if(192===t.charCodeAt(r+1)||193===t.charCodeAt(r+1)||194===t.charCodeAt(r+1)||195===t.charCodeAt(r+1)||196===t.charCodeAt(r+1)||197===t.charCodeAt(r+1)||198===t.charCodeAt(r+1)||199===t.charCodeAt(r+1))return e=256*t.charCodeAt(r+5)+t.charCodeAt(r+6),[256*t.charCodeAt(r+7)+t.charCodeAt(r+8),e,t.charCodeAt(r+9)];r+=2,n=256*t.charCodeAt(r)+t.charCodeAt(r+1)}}(t)),this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)&&(a=function(t){if(65496!=(t[0]<<8|t[1]))throw new Error("Supplied data is not a JPEG");for(var e,n=t.length,r=(t[4]<<8)+t[5],i=4;i<n;){if(r=((e=u(t,i+=r))[2]<<8)+e[3],(192===e[1]||194===e[1])&&255===e[0]&&7<r)return{width:((e=u(t,i+5))[2]<<8)+e[3],height:(e[0]<<8)+e[1],numcomponents:e[4]};i+=2}throw new Error("getJpegSizeFromBytes could not find the size of the image")}(t),t=i||this.arrayBufferToBinaryString(t)),void 0===o)switch(a.numcomponents){case 1:o=this.color_spaces.DEVICE_GRAY;break;case 4:o=this.color_spaces.DEVICE_CMYK;break;default:case 3:o=this.color_spaces.DEVICE_RGB}return this.createImageInfo(t,a.width,a.height,o,8,s,e,n)},x.processJPG=function(){return this.processJPEG.apply(this,arguments)},x.getImageProperties=function(t){var e,n,r="";if(_(t)&&(t=F(t)),this.isString(t)&&(""!==(r=this.convertStringToImageData(t))?t=r:void 0!==(r=x.loadFile(t))&&(t=r)),n=this.getImageFileTypeByImageData(t),!S(n))throw new Error("addImage does not support files of type '"+n+"', please ensure that a plugin for '"+n+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(t=this.binaryStringToUint8Array(t))),!(e=this["process"+n.toUpperCase()](t)))throw new Error("An unknown error occurred whilst processing the image");return{fileType:n,width:e.w,height:e.h,colorSpace:e.cs,compressionMode:e.f,bitsPerComponent:e.bpc}}}(lt.API),
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
t=lt.API,lt.API.events.push(["addPage",function(t){this.internal.getPageInfo(t.pageNumber).pageContext.annotations=[]}]),t.events.push(["putPage",function(t){for(var e=this.internal.getPageInfoByObjId(t.objId),n=t.pageContext.annotations,r=function(t){if(void 0!==t&&""!=t)return!0},i=!1,o=0;o<n.length&&!i;o++)switch((l=n[o]).type){case"link":if(r(l.options.url)||r(l.options.pageNumber)){i=!0;break}case"reference":case"text":case"freetext":i=!0}if(0!=i){this.internal.write("/Annots ["),this.internal.pageSize.height;var a=this.internal.getCoordinateString,s=this.internal.getVerticalCoordinateString;for(o=0;o<n.length;o++){var l;switch((l=n[o]).type){case"reference":this.internal.write(" "+l.object.objId+" 0 R ");break;case"text":var h=this.internal.newAdditionalObject(),u=this.internal.newAdditionalObject(),c=l.title||"Note";m="<</Type /Annot /Subtype /Text "+(p="/Rect ["+a(l.bounds.x)+" "+s(l.bounds.y+l.bounds.h)+" "+a(l.bounds.x+l.bounds.w)+" "+s(l.bounds.y)+"] ")+"/Contents ("+l.contents+")",m+=" /Popup "+u.objId+" 0 R",m+=" /P "+e.objId+" 0 R",m+=" /T ("+c+") >>",h.content=m;var f=h.objId+" 0 R";m="<</Type /Annot /Subtype /Popup "+(p="/Rect ["+a(l.bounds.x+30)+" "+s(l.bounds.y+l.bounds.h)+" "+a(l.bounds.x+l.bounds.w+30)+" "+s(l.bounds.y)+"] ")+" /Parent "+f,l.open&&(m+=" /Open true"),m+=" >>",u.content=m,this.internal.write(h.objId,"0 R",u.objId,"0 R");break;case"freetext":var p="/Rect ["+a(l.bounds.x)+" "+s(l.bounds.y)+" "+a(l.bounds.x+l.bounds.w)+" "+s(l.bounds.y+l.bounds.h)+"] ",d=l.color||"#000000";m="<</Type /Annot /Subtype /FreeText "+p+"/Contents ("+l.contents+")",m+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+d+")",m+=" /Border [0 0 0]",m+=" >>",this.internal.write(m);break;case"link":if(l.options.name){var g=this.annotations._nameMap[l.options.name];l.options.pageNumber=g.page,l.options.top=g.y}else l.options.top||(l.options.top=0);p="/Rect ["+a(l.x)+" "+s(l.y)+" "+a(l.x+l.w)+" "+s(l.y+l.h)+"] ";var m="";if(l.options.url)m="<</Type /Annot /Subtype /Link "+p+"/Border [0 0 0] /A <</S /URI /URI ("+l.options.url+") >>";else if(l.options.pageNumber)switch(m="<</Type /Annot /Subtype /Link "+p+"/Border [0 0 0] /Dest ["+this.internal.getPageInfo(l.options.pageNumber).objId+" 0 R",l.options.magFactor=l.options.magFactor||"XYZ",l.options.magFactor){case"Fit":m+=" /Fit]";break;case"FitH":m+=" /FitH "+l.options.top+"]";break;case"FitV":l.options.left=l.options.left||0,m+=" /FitV "+l.options.left+"]";break;case"XYZ":default:var y=s(l.options.top);l.options.left=l.options.left||0,void 0===l.options.zoom&&(l.options.zoom=0),m+=" /XYZ "+l.options.left+" "+y+" "+l.options.zoom+"]"}""!=m&&(m+=" >>",this.internal.write(m))}}this.internal.write("]")}}]),t.createAnnotation=function(t){var e=this.internal.getCurrentPageInfo();switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":e.pageContext.annotations.push(t)}},t.link=function(t,e,n,r,i){this.internal.getCurrentPageInfo().pageContext.annotations.push({x:t,y:e,w:n,h:r,options:i,type:"link"})},t.textWithLink=function(t,e,n,r){var i=this.getTextWidth(t),o=this.internal.getLineHeight()/this.internal.scaleFactor;return this.text(t,e,n),n+=.2*o,this.link(e,n-o,i,o,r),i},t.getTextWidth=function(t){var e=this.internal.getFontSize();return this.getStringUnitWidth(t)*e/this.internal.scaleFactor},
/**
   * @license
   * Copyright (c) 2017 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
function(t){var h={1569:[65152],1570:[65153,65154],1571:[65155,65156],1572:[65157,65158],1573:[65159,65160],1574:[65161,65162,65163,65164],1575:[65165,65166],1576:[65167,65168,65169,65170],1577:[65171,65172],1578:[65173,65174,65175,65176],1579:[65177,65178,65179,65180],1580:[65181,65182,65183,65184],1581:[65185,65186,65187,65188],1582:[65189,65190,65191,65192],1583:[65193,65194],1584:[65195,65196],1585:[65197,65198],1586:[65199,65200],1587:[65201,65202,65203,65204],1588:[65205,65206,65207,65208],1589:[65209,65210,65211,65212],1590:[65213,65214,65215,65216],1591:[65217,65218,65219,65220],1592:[65221,65222,65223,65224],1593:[65225,65226,65227,65228],1594:[65229,65230,65231,65232],1601:[65233,65234,65235,65236],1602:[65237,65238,65239,65240],1603:[65241,65242,65243,65244],1604:[65245,65246,65247,65248],1605:[65249,65250,65251,65252],1606:[65253,65254,65255,65256],1607:[65257,65258,65259,65260],1608:[65261,65262],1609:[65263,65264,64488,64489],1610:[65265,65266,65267,65268],1649:[64336,64337],1655:[64477],1657:[64358,64359,64360,64361],1658:[64350,64351,64352,64353],1659:[64338,64339,64340,64341],1662:[64342,64343,64344,64345],1663:[64354,64355,64356,64357],1664:[64346,64347,64348,64349],1667:[64374,64375,64376,64377],1668:[64370,64371,64372,64373],1670:[64378,64379,64380,64381],1671:[64382,64383,64384,64385],1672:[64392,64393],1676:[64388,64389],1677:[64386,64387],1678:[64390,64391],1681:[64396,64397],1688:[64394,64395],1700:[64362,64363,64364,64365],1702:[64366,64367,64368,64369],1705:[64398,64399,64400,64401],1709:[64467,64468,64469,64470],1711:[64402,64403,64404,64405],1713:[64410,64411,64412,64413],1715:[64406,64407,64408,64409],1722:[64414,64415],1723:[64416,64417,64418,64419],1726:[64426,64427,64428,64429],1728:[64420,64421],1729:[64422,64423,64424,64425],1733:[64480,64481],1734:[64473,64474],1735:[64471,64472],1736:[64475,64476],1737:[64482,64483],1739:[64478,64479],1740:[64508,64509,64510,64511],1744:[64484,64485,64486,64487],1746:[64430,64431],1747:[64432,64433]},a={65247:{65154:65269,65156:65271,65160:65273,65166:65275},65248:{65154:65270,65156:65272,65160:65274,65166:65276},65165:{65247:{65248:{65258:65010}}},1617:{1612:64606,1613:64607,1614:64608,1615:64609,1616:64610}},e={1612:64606,1613:64607,1614:64608,1615:64609,1616:64610},n=[1570,1571,1573,1575];t.__arabicParser__={};var r=t.__arabicParser__.isInArabicSubstitutionA=function(t){return void 0!==h[t.charCodeAt(0)]},u=t.__arabicParser__.isArabicLetter=function(t){return"string"==typeof t&&/^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t)},i=t.__arabicParser__.isArabicEndLetter=function(t){return u(t)&&r(t)&&h[t.charCodeAt(0)].length<=2},o=t.__arabicParser__.isArabicAlfLetter=function(t){return u(t)&&0<=n.indexOf(t.charCodeAt(0))},s=(t.__arabicParser__.arabicLetterHasIsolatedForm=function(t){return u(t)&&r(t)&&1<=h[t.charCodeAt(0)].length},t.__arabicParser__.arabicLetterHasFinalForm=function(t){return u(t)&&r(t)&&2<=h[t.charCodeAt(0)].length}),l=(t.__arabicParser__.arabicLetterHasInitialForm=function(t){return u(t)&&r(t)&&3<=h[t.charCodeAt(0)].length},t.__arabicParser__.arabicLetterHasMedialForm=function(t){return u(t)&&r(t)&&4==h[t.charCodeAt(0)].length}),c=t.__arabicParser__.resolveLigatures=function(t){var e=0,n=a,r=0,i="",o=0;for(e=0;e<t.length;e+=1)void 0!==n[t.charCodeAt(e)]?(o++,"number"==typeof(n=n[t.charCodeAt(e)])&&(r=-1!==(r=f(t.charAt(e),t.charAt(e-o),t.charAt(e+1)))?r:0,i+=String.fromCharCode(n),n=a,o=0),e===t.length-1&&(n=a,i+=t.charAt(e-(o-1)),e-=o-1,o=0)):(n=a,i+=t.charAt(e-o),e-=o,o=0);return i},f=(t.__arabicParser__.isArabicDiacritic=function(t){return void 0!==t&&void 0!==e[t.charCodeAt(0)]},t.__arabicParser__.getCorrectForm=function(t,e,n){return u(t)?!1===r(t)?-1:!s(t)||!u(e)&&!u(n)||!u(n)&&i(e)||i(t)&&!u(e)||i(t)&&o(e)||i(t)&&i(e)?0:l(t)&&u(e)&&!i(e)&&u(n)&&s(n)?3:i(t)||!u(n)?1:2:-1}),p=t.__arabicParser__.processArabic=t.processArabic=function(t){var e=0,n=0,r=0,i="",o="",a="",s=(t=t||"").split("\\s+"),l=[];for(e=0;e<s.length;e+=1){for(l.push(""),n=0;n<s[e].length;n+=1)i=s[e][n],o=s[e][n-1],a=s[e][n+1],u(i)?(r=f(i,o,a),l[e]+=-1!==r?String.fromCharCode(h[i.charCodeAt(0)][r]):i):l[e]+=i;l[e]=c(l[e])}return l.join(" ")};t.events.push(["preProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),r=(t.mutex,n.lang,[]);if("[object Array]"===Object.prototype.toString.call(e)){var i=0;for(r=[],i=0;i<e.length;i+=1)"[object Array]"===Object.prototype.toString.call(e[i])?r.push([p(e[i][0]),e[i][1],e[i][2]]):r.push([p(e[i])]);t.text=r}else t.text=p(e)}])}(lt.API),lt.API.autoPrint=function(t){var e;switch((t=t||{}).variant=t.variant||"non-conform",t.variant){case"javascript":this.addJS("print({});");break;case"non-conform":default:this.internal.events.subscribe("postPutResources",function(){e=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /Named"),this.internal.out("/Type /Action"),this.internal.out("/N /Print"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){this.internal.out("/OpenAction "+e+" 0 R")})}return this},
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
e=lt.API,(n=function(){var e=void 0;Object.defineProperty(this,"pdf",{get:function(){return e},set:function(t){e=t}});var n=150;Object.defineProperty(this,"width",{get:function(){return n},set:function(t){n=isNaN(t)||!1===Number.isInteger(t)||t<0?150:t,this.getContext("2d").pageWrapXEnabled&&(this.getContext("2d").pageWrapX=n+1)}});var r=300;Object.defineProperty(this,"height",{get:function(){return r},set:function(t){r=isNaN(t)||!1===Number.isInteger(t)||t<0?300:t,this.getContext("2d").pageWrapYEnabled&&(this.getContext("2d").pageWrapY=r+1)}});var i=[];Object.defineProperty(this,"childNodes",{get:function(){return i},set:function(t){i=t}});var o={};Object.defineProperty(this,"style",{get:function(){return o},set:function(t){o=t}}),Object.defineProperty(this,"parentNode",{get:function(){return!1}})}).prototype.getContext=function(t,e){var n;if("2d"!==(t=t||"2d"))return null;for(n in e)this.pdf.context2d.hasOwnProperty(n)&&(this.pdf.context2d[n]=e[n]);return(this.pdf.context2d._canvas=this).pdf.context2d},n.prototype.toDataURL=function(){throw new Error("toDataURL is not implemented.")},e.events.push(["initialized",function(){this.canvas=new n,this.canvas.pdf=this}]),
/** 
   * @license
   * ====================================================================
   * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
   *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Hall, james@parall.ax
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */
_=lt.API,F={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},P=1,p=function(t,e,n,r,i){F={x:t,y:e,w:n,h:r,ln:i}},d=function(){return F},k={left:0,top:0,bottom:0},_.setHeaderFunction=function(t){l=t},_.getTextDimensions=function(t,e){var n=this.table_font_size||this.internal.getFontSize(),r=(this.internal.getFont().fontStyle,(e=e||{}).scaleFactor||this.internal.scaleFactor),i=0,o=0,a=0;if("string"==typeof t)0!=(i=this.getStringUnitWidth(t)*n)&&(o=1);else{if("[object Array]"!==Object.prototype.toString.call(t))throw new Error("getTextDimensions expects text-parameter to be of type String or an Array of Strings.");for(var s=0;s<t.length;s++)i<(a=this.getStringUnitWidth(t[s])*n)&&(i=a);0!==i&&(o=t.length)}return{w:i/=r,h:Math.max((o*n*this.getLineHeightFactor()-n*(this.getLineHeightFactor()-1))/r,0)}},_.cellAddPage=function(){var t=this.margins||k;this.addPage(),p(t.left,t.top,void 0,void 0),P+=1},_.cellInitialize=function(){F={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},P=1},_.cell=function(t,e,n,r,i,o,a){var s=d(),l=!1;if(void 0!==s.ln)if(s.ln===o)t=s.x+s.w,e=s.y;else{var h=this.margins||k;s.y+s.h+r+13>=this.internal.pageSize.getHeight()-h.bottom&&(this.cellAddPage(),l=!0,this.printHeaders&&this.tableHeaderRow&&this.printHeaderRow(o,!0)),e=d().y+d().h,l&&(e=23)}if(void 0!==i[0])if(this.printingHeaderRow?this.rect(t,e,n,r,"FD"):this.rect(t,e,n,r),"right"===a){i instanceof Array||(i=[i]);for(var u=0;u<i.length;u++){var c=i[u],f=this.getStringUnitWidth(c)*this.internal.getFontSize()/this.internal.scaleFactor;this.text(c,t+n-f-3,e+this.internal.getLineHeight()*(u+1))}}else this.text(i,t+3,e+this.internal.getLineHeight());return p(t,e,n,r,o),this},_.arrayMax=function(t,e){var n,r,i,o=t[0];for(n=0,r=t.length;n<r;n+=1)i=t[n],e?-1===e(o,i)&&(o=i):o<i&&(o=i);return o},_.table=function(t,e,n,r,i){if(!n)throw"No data for PDF table";var o,a,s,l,h,u,c,f,p,d,g=[],m=[],y={},v={},w=[],b=[],x=!1,N=!0,L=12,A=k;if(A.width=this.internal.pageSize.getWidth(),i&&(!0===i.autoSize&&(x=!0),!1===i.printHeaders&&(N=!1),i.fontSize&&(L=i.fontSize),i.css&&void 0!==i.css["font-size"]&&(L=16*i.css["font-size"]),i.margins&&(A=i.margins)),this.lnMod=0,F={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},P=1,this.printHeaders=N,this.margins=A,this.setFontSize(L),this.table_font_size=L,null==r)g=Object.keys(n[0]);else if(r[0]&&"string"!=typeof r[0])for(a=0,s=r.length;a<s;a+=1)o=r[a],g.push(o.name),m.push(o.prompt),v[o.name]=o.width*(19.049976/25.4);else g=r;if(x)for(d=function(t){return t[o]},a=0,s=g.length;a<s;a+=1){for(y[o=g[a]]=n.map(d),w.push(this.getTextDimensions(m[a]||o,{scaleFactor:1}).w),c=0,l=(u=y[o]).length;c<l;c+=1)h=u[c],w.push(this.getTextDimensions(h,{scaleFactor:1}).w);v[o]=_.arrayMax(w),w=[]}if(N){var S=this.calculateLineHeight(g,v,m.length?m:g);for(a=0,s=g.length;a<s;a+=1)o=g[a],b.push([t,e,v[o],S,String(m.length?m[a]:o)]);this.setTableHeaderRow(b),this.printHeaderRow(1,!1)}for(a=0,s=n.length;a<s;a+=1)for(f=n[a],S=this.calculateLineHeight(g,v,f),c=0,p=g.length;c<p;c+=1)o=g[c],this.cell(t,e,v[o],S,f[o],a+2,o.align);return this.lastCellPos=F,this.table_x=t,this.table_y=e,this},_.calculateLineHeight=function(t,e,n){for(var r,i=0,o=0;o<t.length;o++){n[r=t[o]]=this.splitTextToSize(String(n[r]),e[r]-3);var a=this.internal.getLineHeight()*n[r].length+3;i<a&&(i=a)}return i},_.setTableHeaderRow=function(t){this.tableHeaderRow=t},_.printHeaderRow=function(t,e){if(!this.tableHeaderRow)throw"Property tableHeaderRow does not exist.";var n,r,i,o;if(this.printingHeaderRow=!0,void 0!==l){var a=l(this,P);p(a[0],a[1],a[2],a[3],-1)}this.setFontStyle("bold");var s=[];for(i=0,o=this.tableHeaderRow.length;i<o;i+=1)this.setFillColor(200,200,200),n=this.tableHeaderRow[i],e&&(this.margins.top=13,n[1]=this.margins&&this.margins.top||0,s.push(n)),r=[].concat(n),this.cell.apply(this,r.concat(t));0<s.length&&this.setTableHeaderRow(s),this.setFontStyle("normal"),this.printingHeaderRow=!1},
/**
   * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
   *
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */
function(t,e){var l,i,o,h,u,c=function(t){return t=t||{},this.isStrokeTransparent=t.isStrokeTransparent||!1,this.strokeOpacity=t.strokeOpacity||1,this.strokeStyle=t.strokeStyle||"#000000",this.fillStyle=t.fillStyle||"#000000",this.isFillTransparent=t.isFillTransparent||!1,this.fillOpacity=t.fillOpacity||1,this.font=t.font||"10px sans-serif",this.textBaseline=t.textBaseline||"alphabetic",this.textAlign=t.textAlign||"left",this.lineWidth=t.lineWidth||1,this.lineJoin=t.lineJoin||"miter",this.lineCap=t.lineCap||"butt",this.path=t.path||[],this.transform=void 0!==t.transform?t.transform.clone():new M,this.globalCompositeOperation=t.globalCompositeOperation||"normal",this.globalAlpha=t.globalAlpha||1,this.clip_path=t.clip_path||[],this.currentPoint=t.currentPoint||new j,this.miterLimit=t.miterLimit||10,this.lastPoint=t.lastPoint||new j,this.ignoreClearRect="boolean"!=typeof t.ignoreClearRect||t.ignoreClearRect,this};t.events.push(["initialized",function(){this.context2d=new n(this),l=this.internal.f2,this.internal.f3,i=this.internal.getCoordinateString,o=this.internal.getVerticalCoordinateString,h=this.internal.getHorizontalCoordinate,u=this.internal.getVerticalCoordinate}]);var n=function(t){Object.defineProperty(this,"canvas",{get:function(){return{parentNode:!1,style:!1}}}),Object.defineProperty(this,"pdf",{get:function(){return t}});var e=!1;Object.defineProperty(this,"pageWrapXEnabled",{get:function(){return e},set:function(t){e=Boolean(t)}});var n=!1;Object.defineProperty(this,"pageWrapYEnabled",{get:function(){return n},set:function(t){n=Boolean(t)}});var r=0;Object.defineProperty(this,"posX",{get:function(){return r},set:function(t){isNaN(t)||(r=t)}});var i=0;Object.defineProperty(this,"posY",{get:function(){return i},set:function(t){isNaN(t)||(i=t)}});var o=!1;Object.defineProperty(this,"autoPaging",{get:function(){return o},set:function(t){o=Boolean(t)}});var a=0;Object.defineProperty(this,"lastBreak",{get:function(){return a},set:function(t){a=t}});var s=[];Object.defineProperty(this,"pageBreaks",{get:function(){return s},set:function(t){s=t}});var l=new c;Object.defineProperty(this,"ctx",{get:function(){return l},set:function(t){t instanceof c&&(l=t)}}),Object.defineProperty(this,"path",{get:function(){return l.path},set:function(t){l.path=t}});var h=[];Object.defineProperty(this,"ctxStack",{get:function(){return h},set:function(t){h=t}}),Object.defineProperty(this,"fillStyle",{get:function(){return this.ctx.fillStyle},set:function(t){var e;e=f(t),this.ctx.fillStyle=e.style,this.ctx.isFillTransparent=0===e.a,this.ctx.fillOpacity=e.a,this.pdf.setFillColor(e.r,e.g,e.b,{a:e.a}),this.pdf.setTextColor(e.r,e.g,e.b,{a:e.a})}}),Object.defineProperty(this,"strokeStyle",{get:function(){return this.ctx.strokeStyle},set:function(t){var e=f(t);this.ctx.strokeStyle=e.style,this.ctx.isStrokeTransparent=0===e.a,this.ctx.strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):(e.a,this.pdf.setDrawColor(e.r,e.g,e.b))}}),Object.defineProperty(this,"lineCap",{get:function(){return this.ctx.lineCap},set:function(t){-1!==["butt","round","square"].indexOf(t)&&(this.ctx.lineCap=t,this.pdf.setLineCap(t))}}),Object.defineProperty(this,"lineWidth",{get:function(){return this.ctx.lineWidth},set:function(t){isNaN(t)||(this.ctx.lineWidth=t,this.pdf.setLineWidth(t))}}),Object.defineProperty(this,"lineJoin",{get:function(){return this.ctx.lineJoin},set:function(t){-1!==["bevel","round","miter"].indexOf(t)&&(this.ctx.lineJoin=t,this.pdf.setLineJoin(t))}}),Object.defineProperty(this,"miterLimit",{get:function(){return this.ctx.miterLimit},set:function(t){isNaN(t)||(this.ctx.miterLimit=t,this.pdf.setMiterLimit(t))}}),Object.defineProperty(this,"textBaseline",{get:function(){return this.ctx.textBaseline},set:function(t){this.ctx.textBaseline=t}}),Object.defineProperty(this,"textAlign",{get:function(){return this.ctx.textAlign},set:function(t){-1!==["right","end","center","left","start"].indexOf(t)&&(this.ctx.textAlign=t)}}),Object.defineProperty(this,"font",{get:function(){return this.ctx.font},set:function(t){var e;if(this.ctx.font=t,null!==(e=/^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))){var n=e[1],r=(e[2],e[3]),i=e[4],o=e[5],a=e[6];i="px"===o?Math.floor(parseFloat(i)):"em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(i)),this.pdf.setFontSize(i);var s="";("bold"===r||700<=parseInt(r,10)||"bold"===n)&&(s="bold"),"italic"===n&&(s+="italic"),0===s.length&&(s="normal");for(var l="",h=a.toLowerCase().replace(/"|'/g,"").split(/\s*,\s*/),u={arial:"Helvetica",verdana:"Helvetica",helvetica:"Helvetica","sans-serif":"Helvetica",fixed:"Courier",monospace:"Courier",terminal:"Courier",courier:"Courier",times:"Times",cursive:"Times",fantasy:"Times",serif:"Times"},c=0;c<h.length;c++){if(void 0!==this.pdf.internal.getFont(h[c],s,{noFallback:!0,disableWarning:!0})){l=h[c];break}if("bolditalic"===s&&void 0!==this.pdf.internal.getFont(h[c],"bold",{noFallback:!0,disableWarning:!0}))l=h[c],s="bold";else if(void 0!==this.pdf.internal.getFont(h[c],"normal",{noFallback:!0,disableWarning:!0})){l=h[c],s="normal";break}}if(""===l)for(c=0;c<h.length;c++)if(u[h[c]]){l=u[h[c]];break}l=""===l?"Times":l,this.pdf.setFont(l,s)}}}),Object.defineProperty(this,"globalCompositeOperation",{get:function(){return this.ctx.globalCompositeOperation},set:function(t){this.ctx.globalCompositeOperation=t}}),Object.defineProperty(this,"globalAlpha",{get:function(){return this.ctx.globalAlpha},set:function(t){this.ctx.globalAlpha=t}}),Object.defineProperty(this,"ignoreClearRect",{get:function(){return this.ctx.ignoreClearRect},set:function(t){this.ctx.ignoreClearRect=Boolean(t)}})};n.prototype.fill=function(){r.call(this,"fill",!1)},n.prototype.stroke=function(){r.call(this,"stroke",!1)},n.prototype.beginPath=function(){this.path=[{type:"begin"}]},n.prototype.moveTo=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.moveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.moveTo");var n=this.ctx.transform.applyToPoint(new j(t,e));this.path.push({type:"mt",x:n.x,y:n.y}),this.ctx.lastPoint=new j(t,e)},n.prototype.closePath=function(){var t=new j(0,0),e=0;for(e=this.path.length-1;-1!==e;e--)if("begin"===this.path[e].type&&"object"===se(this.path[e+1])&&"number"==typeof this.path[e+1].x){t=new j(this.path[e+1].x,this.path[e+1].y),this.path.push({type:"lt",x:t.x,y:t.y});break}"object"===se(this.path[e+2])&&"number"==typeof this.path[e+2].x&&this.path.push(JSON.parse(JSON.stringify(this.path[e+2]))),this.path.push({type:"close"}),this.ctx.lastPoint=new j(t.x,t.y)},n.prototype.lineTo=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.lineTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.lineTo");var n=this.ctx.transform.applyToPoint(new j(t,e));this.path.push({type:"lt",x:n.x,y:n.y}),this.ctx.lastPoint=new j(n.x,n.y)},n.prototype.clip=function(){this.ctx.clip_path=JSON.parse(JSON.stringify(this.path)),r.call(this,null,!0)},n.prototype.quadraticCurveTo=function(t,e,n,r){if(isNaN(n)||isNaN(r)||isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");var i=this.ctx.transform.applyToPoint(new j(n,r)),o=this.ctx.transform.applyToPoint(new j(t,e));this.path.push({type:"qct",x1:o.x,y1:o.y,x:i.x,y:i.y}),this.ctx.lastPoint=new j(i.x,i.y)},n.prototype.bezierCurveTo=function(t,e,n,r,i,o){if(isNaN(i)||isNaN(o)||isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.bezierCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");var a=this.ctx.transform.applyToPoint(new j(i,o)),s=this.ctx.transform.applyToPoint(new j(t,e)),l=this.ctx.transform.applyToPoint(new j(n,r));this.path.push({type:"bct",x1:s.x,y1:s.y,x2:l.x,y2:l.y,x:a.x,y:a.y}),this.ctx.lastPoint=new j(a.x,a.y)},n.prototype.arc=function(t,e,n,r,i,o){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i))throw console.error("jsPDF.context2d.arc: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.arc");if(o=Boolean(o),!this.ctx.transform.isIdentity){var a=this.ctx.transform.applyToPoint(new j(t,e));t=a.x,e=a.y;var s=this.ctx.transform.applyToPoint(new j(0,n)),l=this.ctx.transform.applyToPoint(new j(0,0));n=Math.sqrt(Math.pow(s.x-l.x,2)+Math.pow(s.y-l.y,2))}Math.abs(i-r)>=2*Math.PI&&(r=0,i=2*Math.PI),this.path.push({type:"arc",x:t,y:e,radius:n,startAngle:r,endAngle:i,counterclockwise:o})},n.prototype.arcTo=function(t,e,n,r,i){throw new Error("arcTo not implemented.")},n.prototype.rect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.rect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rect");this.moveTo(t,e),this.lineTo(t+n,e),this.lineTo(t+n,e+r),this.lineTo(t,e+r),this.lineTo(t,e),this.lineTo(t+n,e),this.lineTo(t,e)},n.prototype.fillRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.fillRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillRect");if(!N.call(this)){var i={};"butt"!==this.lineCap&&(i.lineCap=this.lineCap,this.lineCap="butt"),"miter"!==this.lineJoin&&(i.lineJoin=this.lineJoin,this.lineJoin="miter"),this.beginPath(),this.rect(t,e,n,r),this.fill(),i.hasOwnProperty("lineCap")&&(this.lineCap=i.lineCap),i.hasOwnProperty("lineJoin")&&(this.lineJoin=i.lineJoin)}},n.prototype.strokeRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.strokeRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");L.call(this)||(this.beginPath(),this.rect(t,e,n,r),this.stroke())},n.prototype.clearRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.clearRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.clearRect");this.ignoreClearRect||(this.fillStyle="#ffffff",this.fillRect(t,e,n,r))},n.prototype.save=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,n=0;n<this.pdf.internal.getNumberOfPages();n++)this.pdf.setPage(n+1),this.pdf.internal.out("q");if(this.pdf.setPage(e),t){this.ctx.fontSize=this.pdf.internal.getFontSize();var r=new c(this.ctx);this.ctxStack.push(this.ctx),this.ctx=r}},n.prototype.restore=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,n=0;n<this.pdf.internal.getNumberOfPages();n++)this.pdf.setPage(n+1),this.pdf.internal.out("Q");this.pdf.setPage(e),t&&0!==this.ctxStack.length&&(this.ctx=this.ctxStack.pop(),this.fillStyle=this.ctx.fillStyle,this.strokeStyle=this.ctx.strokeStyle,this.font=this.ctx.font,this.lineCap=this.ctx.lineCap,this.lineWidth=this.ctx.lineWidth,this.lineJoin=this.ctx.lineJoin)},n.prototype.toDataURL=function(){throw new Error("toDataUrl not implemented.")};var f=function(t){var e,n,r,i;if(!0===t.isCanvasGradient&&(t=t.getColor()),!t)return{r:0,g:0,b:0,a:0,style:t};if(/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t))i=r=n=e=0;else{var o=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);if(null!==o)e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3]),i=1;else if(null!==(o=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/.exec(t)))e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3]),i=parseFloat(o[4]);else{if(i=1,"string"==typeof t&&"#"!==t.charAt(0)){var a=new RGBColor(t);t=a.ok?a.toHex():"#000000"}4===t.length?(e=t.substring(1,2),e+=e,n=t.substring(2,3),n+=n,r=t.substring(3,4),r+=r):(e=t.substring(1,3),n=t.substring(3,5),r=t.substring(5,7)),e=parseInt(e,16),n=parseInt(n,16),r=parseInt(r,16)}}return{r:e,g:n,b:r,a:i,style:t}},N=function(){return this.ctx.isFillTransparent||0==this.globalAlpha},L=function(){return Boolean(this.ctx.isStrokeTransparent||0==this.globalAlpha)};n.prototype.fillText=function(t,e,n,r){if(isNaN(e)||isNaN(n)||"string"!=typeof t)throw console.error("jsPDF.context2d.fillText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillText");if(r=isNaN(r)?void 0:r,!N.call(this)){n=a.call(this,n);var i=B(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;s.call(this,{text:t,x:e,y:n,scale:o,angle:i,align:this.textAlign,maxWidth:r})}},n.prototype.strokeText=function(t,e,n,r){if(isNaN(e)||isNaN(n)||"string"!=typeof t)throw console.error("jsPDF.context2d.strokeText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeText");if(!L.call(this)){r=isNaN(r)?void 0:r,n=a.call(this,n);var i=B(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;s.call(this,{text:t,x:e,y:n,scale:o,renderingMode:"stroke",angle:i,align:this.textAlign,maxWidth:r})}},n.prototype.measureText=function(t){if("string"!=typeof t)throw console.error("jsPDF.context2d.measureText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.measureText");var e=this.pdf,n=this.pdf.internal.scaleFactor,r=e.internal.getFontSize(),i=e.getStringUnitWidth(t)*r/e.internal.scaleFactor;return new function(t){var e=(t=t||{}).width||0;return Object.defineProperty(this,"width",{get:function(){return e}}),this}({width:i*=Math.round(96*n/72*1e4)/1e4})},n.prototype.scale=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.scale: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.scale");var n=new M(t,0,0,e,0,0);this.ctx.transform=this.ctx.transform.multiply(n)},n.prototype.rotate=function(t){if(isNaN(t))throw console.error("jsPDF.context2d.rotate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rotate");var e=new M(Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0);this.ctx.transform=this.ctx.transform.multiply(e)},n.prototype.translate=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.translate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.translate");var n=new M(1,0,0,1,t,e);this.ctx.transform=this.ctx.transform.multiply(n)},n.prototype.transform=function(t,e,n,r,i,o){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(o))throw console.error("jsPDF.context2d.transform: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.transform");var a=new M(t,e,n,r,i,o);this.ctx.transform=this.ctx.transform.multiply(a)},n.prototype.setTransform=function(t,e,n,r,i,o){t=isNaN(t)?1:t,e=isNaN(e)?0:e,n=isNaN(n)?0:n,r=isNaN(r)?1:r,i=isNaN(i)?0:i,o=isNaN(o)?0:o,this.ctx.transform=new M(t,e,n,r,i,o)},n.prototype.drawImage=function(t,e,n,r,i,o,a,s,l){var h=this.pdf.getImageProperties(t),u=1,c=1,f=1,p=1;void 0!==r&&void 0!==s&&(f=s/r,p=l/i,u=h.width/r*s/r,c=h.height/i*l/i),void 0===o&&(o=e,a=n,n=e=0),void 0!==r&&void 0===s&&(s=r,l=i),void 0===r&&void 0===s&&(s=h.width,l=h.height);var d=this.ctx.transform.decompose(),g=B(d.rotate.shx);d.scale.sx,d.scale.sy;for(var m,y=new M,v=((y=(y=(y=y.multiply(d.translate)).multiply(d.skew)).multiply(d.scale)).applyToPoint(new j(s,l)),y.applyToRectangle(new E(o-e*f,a-n*p,r*u,i*c))),w=F.call(this,v),b=[],x=0;x<w.length;x+=1)-1===b.indexOf(w[x])&&b.push(w[x]);if(b.sort(),this.autoPaging)for(var N=b[0],L=b[b.length-1],A=N;A<L+1;A++){if(this.pdf.setPage(A),0!==this.ctx.clip_path.length){var S=this.path;m=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=P(m,this.posX,-1*this.pdf.internal.pageSize.height*(A-1)+this.posY),k.call(this,"fill",!0),this.path=S}var _=JSON.parse(JSON.stringify(v));_=P([_],this.posX,-1*this.pdf.internal.pageSize.height*(A-1)+this.posY)[0],this.pdf.addImage(t,"jpg",_.x,_.y,_.w,_.h,null,null,g)}else this.pdf.addImage(t,"jpg",v.x,v.y,v.w,v.h,null,null,g)};var F=function(t,e,n){var r=[];switch(e=e||this.pdf.internal.pageSize.width,n=n||this.pdf.internal.pageSize.height,t.type){default:case"mt":case"lt":r.push(Math.floor((t.y+this.posY)/n)+1);break;case"arc":r.push(Math.floor((t.y+this.posY-t.radius)/n)+1),r.push(Math.floor((t.y+this.posY+t.radius)/n)+1);break;case"qct":var i=w(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x,t.y);r.push(Math.floor(i.y/n)+1),r.push(Math.floor((i.y+i.h)/n)+1);break;case"bct":var o=b(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x2,t.y2,t.x,t.y);r.push(Math.floor(o.y/n)+1),r.push(Math.floor((o.y+o.h)/n)+1);break;case"rect":r.push(Math.floor((t.y+this.posY)/n)+1),r.push(Math.floor((t.y+t.h+this.posY)/n)+1)}for(var a=0;a<r.length;a+=1)for(;this.pdf.internal.getNumberOfPages()<r[a];)v.call(this);return r},v=function(){var t=this.fillStyle,e=this.strokeStyle,n=this.font,r=this.lineCap,i=this.lineWidth,o=this.lineJoin;this.pdf.addPage(),this.fillStyle=t,this.strokeStyle=e,this.font=n,this.lineCap=r,this.lineWidth=i,this.lineJoin=o},P=function(t,e,n){for(var r=0;r<t.length;r++)switch(t[r].type){case"bct":t[r].x2+=e,t[r].y2+=n;case"qct":t[r].x1+=e,t[r].y1+=n;case"mt":case"lt":case"arc":default:t[r].x+=e,t[r].y+=n}return t},r=function(t,e){for(var n,r,i=this.fillStyle,o=this.strokeStyle,a=(this.font,this.lineCap),s=this.lineWidth,l=this.lineJoin,h=JSON.parse(JSON.stringify(this.path)),u=JSON.parse(JSON.stringify(this.path)),c=[],f=0;f<u.length;f++)if(void 0!==u[f].x)for(var p=F.call(this,u[f]),d=0;d<p.length;d+=1)-1===c.indexOf(p[d])&&c.push(p[d]);for(f=0;f<c.length;f++)for(;this.pdf.internal.getNumberOfPages()<c[f];)v.call(this);if(c.sort(),this.autoPaging){var g=c[0],m=c[c.length-1];for(f=g;f<m+1;f++){if(this.pdf.setPage(f),this.fillStyle=i,this.strokeStyle=o,this.lineCap=a,this.lineWidth=s,this.lineJoin=l,0!==this.ctx.clip_path.length){var y=this.path;n=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=P(n,this.posX,-1*this.pdf.internal.pageSize.height*(f-1)+this.posY),k.call(this,t,!0),this.path=y}r=JSON.parse(JSON.stringify(h)),this.path=P(r,this.posX,-1*this.pdf.internal.pageSize.height*(f-1)+this.posY),!1!==e&&0!==f||k.call(this,t,e)}}else k.call(this,t,e);this.path=h},k=function(t,e){if(("stroke"!==t||e||!L.call(this))&&("stroke"===t||e||!N.call(this))){var n=[];this.ctx.globalAlpha;this.ctx.fillOpacity<1&&this.ctx.fillOpacity;for(var r,i=this.path,o=0;o<i.length;o++){var a=i[o];switch(a.type){case"begin":n.push({begin:!0});break;case"close":n.push({close:!0});break;case"mt":n.push({start:a,deltas:[],abs:[]});break;case"lt":var s=n.length;if(!isNaN(i[o-1].x)){var l=[a.x-i[o-1].x,a.y-i[o-1].y];if(0<s)for(;0<=s;s--)if(!0!==n[s-1].close&&!0!==n[s-1].begin){n[s-1].deltas.push(l),n[s-1].abs.push(a);break}}break;case"bct":l=[a.x1-i[o-1].x,a.y1-i[o-1].y,a.x2-i[o-1].x,a.y2-i[o-1].y,a.x-i[o-1].x,a.y-i[o-1].y];n[n.length-1].deltas.push(l);break;case"qct":var h=i[o-1].x+2/3*(a.x1-i[o-1].x),u=i[o-1].y+2/3*(a.y1-i[o-1].y),c=a.x+2/3*(a.x1-a.x),f=a.y+2/3*(a.y1-a.y),p=a.x,d=a.y;l=[h-i[o-1].x,u-i[o-1].y,c-i[o-1].x,f-i[o-1].y,p-i[o-1].x,d-i[o-1].y];n[n.length-1].deltas.push(l);break;case"arc":n.push({deltas:[],abs:[],arc:!0}),Array.isArray(n[n.length-1].abs)&&n[n.length-1].abs.push(a)}}r=e?null:"stroke"===t?"stroke":"fill";for(o=0;o<n.length;o++){if(n[o].arc)for(var g=n[o].abs,m=0;m<g.length;m++){var y=g[m];if(void 0!==y.startAngle){var v=B(y.startAngle),w=B(y.endAngle),b=y.x,x=y.y;A.call(this,b,x,y.radius,v,w,y.counterclockwise,r,e)}else I.call(this,y.x,y.y)}if(!n[o].arc&&!0!==n[o].close&&!0!==n[o].begin){b=n[o].start.x,x=n[o].start.y;C.call(this,n[o].deltas,b,x,null,null)}}r&&S.call(this,r),e&&_.call(this)}},a=function(t){var e=this.pdf.internal.getFontSize()/this.pdf.internal.scaleFactor,n=e*(this.pdf.internal.getLineHeightFactor()-1);switch(this.ctx.textBaseline){case"bottom":return t-n;case"top":return t+e-n;case"hanging":return t+e-2*n;case"middle":return t+e/2-n;case"ideographic":return t;case"alphabetic":default:return t}};n.prototype.createLinearGradient=function(){var t=function(){};return t.colorStops=[],t.addColorStop=function(t,e){this.colorStops.push([t,e])},t.getColor=function(){return 0===this.colorStops.length?"#000000":this.colorStops[0][1]},t.isCanvasGradient=!0,t},n.prototype.createPattern=function(){return this.createLinearGradient()},n.prototype.createRadialGradient=function(){return this.createLinearGradient()};var A=function(t,e,n,r,i,o,a,s){this.pdf.internal.scaleFactor;for(var l=y(r),h=y(i),u=g.call(this,n,l,h,o),c=0;c<u.length;c++){var f=u[c];0===c&&p.call(this,f.x1+t,f.y1+e),d.call(this,t,e,f.x2,f.y2,f.x3,f.y3,f.x4,f.y4)}s?_.call(this):S.call(this,a)},S=function(t){switch(t){case"stroke":this.pdf.internal.out("S");break;case"fill":this.pdf.internal.out("f")}},_=function(){this.pdf.clip()},p=function(t,e){this.pdf.internal.out(i(t)+" "+o(e)+" m")},s=function(t){var e;switch(t.align){case"right":case"end":e="right";break;case"center":e="center";break;case"left":case"start":default:e="left"}var n=this.ctx.transform.applyToPoint(new j(t.x,t.y)),r=this.ctx.transform.decompose(),i=new M;i=(i=(i=i.multiply(r.translate)).multiply(r.skew)).multiply(r.scale);for(var o,a=this.pdf.getTextDimensions(t.text),s=this.ctx.transform.applyToRectangle(new E(t.x,t.y,a.w,a.h)),l=i.applyToRectangle(new E(t.x,t.y-a.h,a.w,a.h)),h=F.call(this,l),u=[],c=0;c<h.length;c+=1)-1===u.indexOf(h[c])&&u.push(h[c]);if(u.sort(),!0===this.autoPaging)for(var f=u[0],p=u[u.length-1],d=f;d<p+1;d++){if(this.pdf.setPage(d),0!==this.ctx.clip_path.length){var g=this.path;o=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=P(o,this.posX,-1*this.pdf.internal.pageSize.height*(d-1)+this.posY),k.call(this,"fill",!0),this.path=g}var m=JSON.parse(JSON.stringify(s));if(m=P([m],this.posX,-1*this.pdf.internal.pageSize.height*(d-1)+this.posY)[0],.01<=t.scale){var y=this.pdf.internal.getFontSize();this.pdf.setFontSize(y*t.scale)}this.pdf.text(t.text,m.x,m.y,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),.01<=t.scale&&this.pdf.setFontSize(y)}else{if(.01<=t.scale){y=this.pdf.internal.getFontSize();this.pdf.setFontSize(y*t.scale)}this.pdf.text(t.text,n.x+this.posX,n.y+this.posY,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),.01<=t.scale&&this.pdf.setFontSize(y)}},I=function(t,e,n,r){n=n||0,r=r||0,this.pdf.internal.out(i(t+n)+" "+o(e+r)+" l")},C=function(t,e,n){return this.pdf.lines(t,e,n,null,null)},d=function(t,e,n,r,i,o,a,s){this.pdf.internal.out([l(h(n+t)),l(u(r+e)),l(h(i+t)),l(u(o+e)),l(h(a+t)),l(u(s+e)),"c"].join(" "))},g=function(t,e,n,r){var i=2*Math.PI,o=e;(o<i||i<o)&&(o%=i);var a=n;(a<i||i<a)&&(a%=i);for(var s=[],l=Math.PI/2,h=r?-1:1,u=e,c=Math.min(i,Math.abs(a-o));1e-5<c;){var f=u+h*Math.min(c,l);s.push(m.call(this,t,u,f)),c-=Math.abs(f-u),u=f}return s},m=function(t,e,n){var r=(n-e)/2,i=t*Math.cos(r),o=t*Math.sin(r),a=i,s=-o,l=a*a+s*s,h=l+a*i+s*o,u=4/3*(Math.sqrt(2*l*h)-h)/(a*o-s*i),c=a-u*s,f=s+u*a,p=c,d=-f,g=r+e,m=Math.cos(g),y=Math.sin(g);return{x1:t*Math.cos(e),y1:t*Math.sin(e),x2:c*m-f*y,y2:c*y+f*m,x3:p*m-d*y,y3:p*y+d*m,x4:t*Math.cos(n),y4:t*Math.sin(n)}},B=function(t){return 180*t/Math.PI},y=function(t){return t*Math.PI/180},w=function(t,e,n,r,i,o){var a=t+.5*(n-t),s=e+.5*(r-e),l=i+.5*(n-i),h=o+.5*(r-o),u=Math.min(t,i,a,l),c=Math.max(t,i,a,l),f=Math.min(e,o,s,h),p=Math.max(e,o,s,h);return new E(u,f,c-u,p-f)},b=function(t,e,n,r,i,o,a,s){for(var l,h,u,c,f,p,d,g,m,y,v,w,b,x=n-t,N=r-e,L=i-n,A=o-r,S=a-i,_=s-o,F=0;F<41;F++)g=(p=(h=t+(l=F/40)*x)+l*((c=n+l*L)-h))+l*(c+l*(i+l*S-c)-p),m=(d=(u=e+l*N)+l*((f=r+l*A)-u))+l*(f+l*(o+l*_-f)-d),b=0==F?(w=y=g,v=m):(y=Math.min(y,g),v=Math.min(v,m),w=Math.max(w,g),Math.max(b,m));return new E(Math.round(y),Math.round(v),Math.round(w-y),Math.round(b-v))},j=function(t,e){var n=t||0;Object.defineProperty(this,"x",{enumerable:!0,get:function(){return n},set:function(t){isNaN(t)||(n=parseFloat(t))}});var r=e||0;Object.defineProperty(this,"y",{enumerable:!0,get:function(){return r},set:function(t){isNaN(t)||(r=parseFloat(t))}});var i="pt";return Object.defineProperty(this,"type",{enumerable:!0,get:function(){return i},set:function(t){i=t.toString()}}),this},E=function(t,e,n,r){j.call(this,t,e),this.type="rect";var i=n||0;Object.defineProperty(this,"w",{enumerable:!0,get:function(){return i},set:function(t){isNaN(t)||(i=parseFloat(t))}});var o=r||0;return Object.defineProperty(this,"h",{enumerable:!0,get:function(){return o},set:function(t){isNaN(t)||(o=parseFloat(t))}}),this},M=function(t,e,n,r,i,o){var a=[];return Object.defineProperty(this,"sx",{get:function(){return a[0]},set:function(t){a[0]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"shy",{get:function(){return a[1]},set:function(t){a[1]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"shx",{get:function(){return a[2]},set:function(t){a[2]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"sy",{get:function(){return a[3]},set:function(t){a[3]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"tx",{get:function(){return a[4]},set:function(t){a[4]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"ty",{get:function(){return a[5]},set:function(t){a[5]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"rotation",{get:function(){return Math.atan2(this.shx,this.sx)}}),Object.defineProperty(this,"scaleX",{get:function(){return this.decompose().scale.sx}}),Object.defineProperty(this,"scaleY",{get:function(){return this.decompose().scale.sy}}),Object.defineProperty(this,"isIdentity",{get:function(){return 1===this.sx&&(0===this.shy&&(0===this.shx&&(1===this.sy&&(0===this.tx&&0===this.ty))))}}),this.sx=isNaN(t)?1:t,this.shy=isNaN(e)?0:e,this.shx=isNaN(n)?0:n,this.sy=isNaN(r)?1:r,this.tx=isNaN(i)?0:i,this.ty=isNaN(o)?0:o,this};M.prototype.multiply=function(t){var e=t.sx*this.sx+t.shy*this.shx,n=t.sx*this.shy+t.shy*this.sy,r=t.shx*this.sx+t.sy*this.shx,i=t.shx*this.shy+t.sy*this.sy,o=t.tx*this.sx+t.ty*this.shx+this.tx,a=t.tx*this.shy+t.ty*this.sy+this.ty;return new M(e,n,r,i,o,a)},M.prototype.decompose=function(){var t=this.sx,e=this.shy,n=this.shx,r=this.sy,i=this.tx,o=this.ty,a=Math.sqrt(t*t+e*e),s=(t/=a)*n+(e/=a)*r;n-=t*s,r-=e*s;var l=Math.sqrt(n*n+r*r);return s/=l,t*(r/=l)<e*(n/=l)&&(t=-t,e=-e,s=-s,a=-a),{scale:new M(a,0,0,l,0,0),translate:new M(1,0,0,1,i,o),rotate:new M(t,e,-e,t,0,0),skew:new M(1,0,s,1,0,0)}},M.prototype.applyToPoint=function(t){var e=t.x*this.sx+t.y*this.shx+this.tx,n=t.x*this.shy+t.y*this.sy+this.ty;return new j(e,n)},M.prototype.applyToRectangle=function(t){var e=this.applyToPoint(t),n=this.applyToPoint(new j(t.x+t.w,t.y+t.h));return new E(e.x,e.y,n.x-e.x,n.y-e.y)},M.prototype.clone=function(){var t=this.sx,e=this.shy,n=this.shx,r=this.sy,i=this.tx,o=this.ty;return new M(t,e,n,r,i,o)}}(lt.API,"undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),
/**
   * jsPDF filters PlugIn
   * Copyright (c) 2014 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
a=lt.API,o=function(t){var r,e,n,i,o,a,s,l,h,u;for(/[^\x00-\xFF]/.test(t),e=[],n=0,i=(t+=r="\0\0\0\0".slice(t.length%4||4)).length;n<i;n+=4)0!==(o=(t.charCodeAt(n)<<24)+(t.charCodeAt(n+1)<<16)+(t.charCodeAt(n+2)<<8)+t.charCodeAt(n+3))?(a=(o=((o=((o=((o=(o-(u=o%85))/85)-(h=o%85))/85)-(l=o%85))/85)-(s=o%85))/85)%85,e.push(a+33,s+33,l+33,h+33,u+33)):e.push(122);return function(t,e){for(var n=r.length;0<n;n--)t.pop()}(e),String.fromCharCode.apply(String,e)+"~>"},s=function(t){var r,e,n,i,o,a=String,s="length",l="charCodeAt",h="slice",u="replace";for(t[h](-2),t=t[h](0,-2)[u](/\s/g,"")[u]("z","!!!!!"),n=[],i=0,o=(t+=r="uuuuu"[h](t[s]%5||5))[s];i<o;i+=5)e=52200625*(t[l](i)-33)+614125*(t[l](i+1)-33)+7225*(t[l](i+2)-33)+85*(t[l](i+3)-33)+(t[l](i+4)-33),n.push(255&e>>24,255&e>>16,255&e>>8,255&e);return function(t,e){for(var n=r[s];0<n;n--)t.pop()}(n),a.fromCharCode.apply(a,n)},h=function(t){for(var e="",n=0;n<t.length;n+=1)e+=("0"+t.charCodeAt(n).toString(16)).slice(-2);return e+=">"},u=function(t){var e=new RegExp(/^([0-9A-Fa-f]{2})+$/);if(-1!==(t=t.replace(/\s/g,"")).indexOf(">")&&(t=t.substr(0,t.indexOf(">"))),t.length%2&&(t+="0"),!1===e.test(t))return"";for(var n="",r=0;r<t.length;r+=2)n+=String.fromCharCode("0x"+(t[r]+t[r+1]));return n},c=function(t,e){e=Object.assign({predictor:1,colors:1,bitsPerComponent:8,columns:1},e);for(var n,r,i=[],o=t.length;o--;)i[o]=t.charCodeAt(o);return n=a.adler32cs.from(t),(r=new Deflater(6)).append(new Uint8Array(i)),t=r.flush(),(i=new Uint8Array(t.length+6)).set(new Uint8Array([120,156])),i.set(t,2),i.set(new Uint8Array([255&n,n>>8&255,n>>16&255,n>>24&255]),t.length+2),t=String.fromCharCode.apply(null,i)},a.processDataByFilters=function(t,e){var n=0,r=t||"",i=[];for("string"==typeof(e=e||[])&&(e=[e]),n=0;n<e.length;n+=1)switch(e[n]){case"ASCII85Decode":case"/ASCII85Decode":r=s(r),i.push("/ASCII85Encode");break;case"ASCII85Encode":case"/ASCII85Encode":r=o(r),i.push("/ASCII85Decode");break;case"ASCIIHexDecode":case"/ASCIIHexDecode":r=u(r),i.push("/ASCIIHexEncode");break;case"ASCIIHexEncode":case"/ASCIIHexEncode":r=h(r),i.push("/ASCIIHexDecode");break;case"FlateEncode":case"/FlateEncode":r=c(r),i.push("/FlateDecode");break;default:throw'The filter: "'+e[n]+'" is not implemented'}return{data:r,reverseChain:i.reverse().join(" ")}},(
/**
   * jsPDF fileloading PlugIn
   * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
r=lt.API).loadFile=function(t,e,n){var r;e=e||!0,n=n||function(){};try{r=function(t,e,n){var r=new XMLHttpRequest,i=[],o=0,a=function(t){var e=t.length,n=String.fromCharCode;for(o=0;o<e;o+=1)i.push(n(255&t.charCodeAt(o)));return i.join("")};if(r.open("GET",t,!e),r.overrideMimeType("text/plain; charset=x-user-defined"),!1===e&&(r.onload=function(){return a(this.responseText)}),r.send(null),200===r.status)return e?a(r.responseText):void 0;console.warn('Unable to load file "'+t+'"')}(t,e)}catch(t){r=void 0}return r},r.loadImageFile=r.loadFile,
/**
   * Copyright (c) 2018 Erik Koopmans
   * Released under the MIT License.
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
i=lt.API,f="undefined"!=typeof window&&window||"undefined"!=typeof global&&global,g=function(t){var e=se(t);return"undefined"===e?"undefined":"string"===e||t instanceof String?"string":"number"===e||t instanceof Number?"number":"function"===e||t instanceof Function?"function":t&&t.constructor===Array?"array":t&&1===t.nodeType?"element":"object"===e?"object":"unknown"},m=function(t,e){var n=document.createElement(t);if(e.className&&(n.className=e.className),e.innerHTML){n.innerHTML=e.innerHTML;for(var r=n.getElementsByTagName("script"),i=r.length;0<i--;null)r[i].parentNode.removeChild(r[i])}for(var o in e.style)n.style[o]=e.style[o];return n},(((y=function t(e){var n=Object.assign(t.convert(Promise.resolve()),JSON.parse(JSON.stringify(t.template))),r=t.convert(Promise.resolve(),n);return r=(r=r.setProgress(1,t,1,[t])).set(e)}).prototype=Object.create(Promise.prototype)).constructor=y).convert=function(t,e){return t.__proto__=e||y.prototype,t},y.template={prop:{src:null,container:null,overlay:null,canvas:null,img:null,pdf:null,pageSize:null,callback:function(){}},progress:{val:0,state:null,n:0,stack:[]},opt:{filename:"file.pdf",margin:[0,0,0,0],enableLinks:!0,x:0,y:0,html2canvas:{},jsPDF:{}}},y.prototype.from=function(t,e){return this.then(function(){switch(e=e||function(t){switch(g(t)){case"string":return"string";case"element":return"canvas"===t.nodeName.toLowerCase?"canvas":"element";default:return"unknown"}}(t)){case"string":return this.set({src:m("div",{innerHTML:t})});case"element":return this.set({src:t});case"canvas":return this.set({canvas:t});case"img":return this.set({img:t});default:return this.error("Unknown source type.")}})},y.prototype.to=function(t){switch(t){case"container":return this.toContainer();case"canvas":return this.toCanvas();case"img":return this.toImg();case"pdf":return this.toPdf();default:return this.error("Invalid target.")}},y.prototype.toContainer=function(){return this.thenList([function(){return this.prop.src||this.error("Cannot duplicate - no source HTML.")},function(){return this.prop.pageSize||this.setPageSize()}]).then(function(){var t={position:"relative",display:"inline-block",width:Math.max(this.prop.src.clientWidth,this.prop.src.scrollWidth,this.prop.src.offsetWidth)+"px",left:0,right:0,top:0,margin:"auto",backgroundColor:"white"},e=function t(e,n){for(var r=3===e.nodeType?document.createTextNode(e.nodeValue):e.cloneNode(!1),i=e.firstChild;i;i=i.nextSibling)!0!==n&&1===i.nodeType&&"SCRIPT"===i.nodeName||r.appendChild(t(i,n));return 1===e.nodeType&&("CANVAS"===e.nodeName?(r.width=e.width,r.height=e.height,r.getContext("2d").drawImage(e,0,0)):"TEXTAREA"!==e.nodeName&&"SELECT"!==e.nodeName||(r.value=e.value),r.addEventListener("load",function(){r.scrollTop=e.scrollTop,r.scrollLeft=e.scrollLeft},!0)),r}(this.prop.src,this.opt.html2canvas.javascriptEnabled);"BODY"===e.tagName&&(t.height=Math.max(document.body.scrollHeight,document.body.offsetHeight,document.documentElement.clientHeight,document.documentElement.scrollHeight,document.documentElement.offsetHeight)+"px"),this.prop.overlay=m("div",{className:"html2pdf__overlay",style:{position:"fixed",overflow:"hidden",zIndex:1e3,left:"-100000px",right:0,bottom:0,top:0}}),this.prop.container=m("div",{className:"html2pdf__container",style:t}),this.prop.container.appendChild(e),this.prop.container.firstChild.appendChild(m("div",{style:{clear:"both",border:"0 none transparent",margin:0,padding:0,height:0}})),this.prop.container.style.float="none",this.prop.overlay.appendChild(this.prop.container),document.body.appendChild(this.prop.overlay),this.prop.container.firstChild.style.position="relative",this.prop.container.height=Math.max(this.prop.container.firstChild.clientHeight,this.prop.container.firstChild.scrollHeight,this.prop.container.firstChild.offsetHeight)+"px"})},y.prototype.toCanvas=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(function(){var t=Object.assign({},this.opt.html2canvas);if(delete t.onrendered,this.isHtml2CanvasLoaded())return html2canvas(this.prop.container,t)}).then(function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)})},y.prototype.toContext2d=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(function(){var t=this.opt.jsPDF,e=Object.assign({async:!0,allowTaint:!0,backgroundColor:"#ffffff",imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1},this.opt.html2canvas);if(delete e.onrendered,t.context2d.autoPaging=!0,t.context2d.posX=this.opt.x,t.context2d.posY=this.opt.y,e.windowHeight=e.windowHeight||0,e.windowHeight=0==e.windowHeight?Math.max(this.prop.container.clientHeight,this.prop.container.scrollHeight,this.prop.container.offsetHeight):e.windowHeight,this.isHtml2CanvasLoaded())return html2canvas(this.prop.container,e)}).then(function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)})},y.prototype.toImg=function(){return this.thenList([function(){return this.prop.canvas||this.toCanvas()}]).then(function(){var t=this.prop.canvas.toDataURL("image/"+this.opt.image.type,this.opt.image.quality);this.prop.img=document.createElement("img"),this.prop.img.src=t})},y.prototype.toPdf=function(){return this.thenList([function(){return this.toContext2d()}]).then(function(){this.prop.pdf=this.prop.pdf||this.opt.jsPDF})},y.prototype.output=function(t,e,n){return"img"===(n=n||"pdf").toLowerCase()||"image"===n.toLowerCase()?this.outputImg(t,e):this.outputPdf(t,e)},y.prototype.outputPdf=function(t,e){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then(function(){return this.prop.pdf.output(t,e)})},y.prototype.outputImg=function(t,e){return this.thenList([function(){return this.prop.img||this.toImg()}]).then(function(){switch(t){case void 0:case"img":return this.prop.img;case"datauristring":case"dataurlstring":return this.prop.img.src;case"datauri":case"dataurl":return document.location.href=this.prop.img.src;default:throw'Image output type "'+t+'" is not supported.'}})},y.prototype.isHtml2CanvasLoaded=function(){var t=void 0!==f.html2canvas;return t||console.error("html2canvas not loaded."),t},y.prototype.save=function(t){if(this.isHtml2CanvasLoaded())return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).set(t?{filename:t}:null).then(function(){this.prop.pdf.save(this.opt.filename)})},y.prototype.doCallback=function(t){if(this.isHtml2CanvasLoaded())return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then(function(){this.prop.callback(this.prop.pdf)})},y.prototype.set=function(e){if("object"!==g(e))return this;var t=Object.keys(e||{}).map(function(t){if(t in y.template.prop)return function(){this.prop[t]=e[t]};switch(t){case"margin":return this.setMargin.bind(this,e.margin);case"jsPDF":return function(){return this.opt.jsPDF=e.jsPDF,this.setPageSize()};case"pageSize":return this.setPageSize.bind(this,e.pageSize);default:return function(){this.opt[t]=e[t]}}},this);return this.then(function(){return this.thenList(t)})},y.prototype.get=function(e,n){return this.then(function(){var t=e in y.template.prop?this.prop[e]:this.opt[e];return n?n(t):t})},y.prototype.setMargin=function(t){return this.then(function(){switch(g(t)){case"number":t=[t,t,t,t];case"array":if(2===t.length&&(t=[t[0],t[1],t[0],t[1]]),4===t.length)break;default:return this.error("Invalid margin array.")}this.opt.margin=t}).then(this.setPageSize)},y.prototype.setPageSize=function(t){function e(t,e){return Math.floor(t*e/72*96)}return this.then(function(){(t=t||lt.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner")||(t.inner={width:t.width-this.opt.margin[1]-this.opt.margin[3],height:t.height-this.opt.margin[0]-this.opt.margin[2]},t.inner.px={width:e(t.inner.width,t.k),height:e(t.inner.height,t.k)},t.inner.ratio=t.inner.height/t.inner.width),this.prop.pageSize=t})},y.prototype.setProgress=function(t,e,n,r){return null!=t&&(this.progress.val=t),null!=e&&(this.progress.state=e),null!=n&&(this.progress.n=n),null!=r&&(this.progress.stack=r),this.progress.ratio=this.progress.val/this.progress.state,this},y.prototype.updateProgress=function(t,e,n,r){return this.setProgress(t?this.progress.val+t:null,e||null,n?this.progress.n+n:null,r?this.progress.stack.concat(r):null)},y.prototype.then=function(t,e){var n=this;return this.thenCore(t,e,function(e,t){return n.updateProgress(null,null,1,[e]),Promise.prototype.then.call(this,function(t){return n.updateProgress(null,e),t}).then(e,t).then(function(t){return n.updateProgress(1),t})})},y.prototype.thenCore=function(t,e,n){n=n||Promise.prototype.then;var r=this;t&&(t=t.bind(r)),e&&(e=e.bind(r));var i=-1!==Promise.toString().indexOf("[native code]")&&"Promise"===Promise.name?r:y.convert(Object.assign({},r),Promise.prototype),o=n.call(i,t,e);return y.convert(o,r.__proto__)},y.prototype.thenExternal=function(t,e){return Promise.prototype.then.call(this,t,e)},y.prototype.thenList=function(t){var e=this;return t.forEach(function(t){e=e.thenCore(t)}),e},y.prototype.catch=function(t){t&&(t=t.bind(this));var e=Promise.prototype.catch.call(this,t);return y.convert(e,this)},y.prototype.catchExternal=function(t){return Promise.prototype.catch.call(this,t)},y.prototype.error=function(t){return this.then(function(){throw new Error(t)})},y.prototype.using=y.prototype.set,y.prototype.saveAs=y.prototype.save,y.prototype.export=y.prototype.output,y.prototype.run=y.prototype.then,lt.getPageSize=function(t,e,n){if("object"===se(t)){var r=t;t=r.orientation,e=r.unit||e,n=r.format||n}e=e||"mm",n=n||"a4",t=(""+(t||"P")).toLowerCase();var i=(""+n).toLowerCase(),o={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};switch(e){case"pt":var a=1;break;case"mm":a=72/25.4;break;case"cm":a=72/2.54;break;case"in":a=72;break;case"px":a=.75;break;case"pc":case"em":a=12;break;case"ex":a=6;break;default:throw"Invalid unit: "+e}if(o.hasOwnProperty(i))var s=o[i][1]/a,l=o[i][0]/a;else try{s=n[1],l=n[0]}catch(t){throw new Error("Invalid format: "+n)}if("p"===t||"portrait"===t){if(t="p",s<l){var h=l;l=s,s=h}}else{if("l"!==t&&"landscape"!==t)throw"Invalid orientation: "+t;t="l",l<s&&(h=l,l=s,s=h)}return{width:l,height:s,unit:e,k:a}},i.html=function(t,e){(e=e||{}).callback=e.callback||function(){},e.html2canvas=e.html2canvas||{},e.html2canvas.canvas=e.html2canvas.canvas||this.canvas,e.jsPDF=e.jsPDF||this,e.jsPDF;var n=new y(e);return e.worker?n:n.from(t).doCallback()},lt.API.addJS=function(t){return b=t,this.internal.events.subscribe("postPutResources",function(t){v=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/Names [(EmbeddedJS) "+(v+1)+" 0 R]"),this.internal.out(">>"),this.internal.out("endobj"),w=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /JavaScript"),this.internal.out("/JS ("+b+")"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){void 0!==v&&void 0!==w&&this.internal.out("/Names <</JavaScript "+v+" 0 R>>")}),this},(
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
x=lt.API).events.push(["postPutResources",function(){var t=this,e=/^(\d+) 0 obj$/;if(0<this.outline.root.children.length)for(var n=t.outline.render().split(/\r\n/),r=0;r<n.length;r++){var i=n[r],o=e.exec(i);if(null!=o){var a=o[1];t.internal.newObjectDeferredBegin(a,!1)}t.internal.write(i)}if(this.outline.createNamedDestinations){var s=this.internal.pages.length,l=[];for(r=0;r<s;r++){var h=t.internal.newObject();l.push(h);var u=t.internal.getPageInfo(r+1);t.internal.write("<< /D["+u.objId+" 0 R /XYZ null null null]>> endobj")}var c=t.internal.newObject();for(t.internal.write("<< /Names [ "),r=0;r<l.length;r++)t.internal.write("(page_"+(r+1)+")"+l[r]+" 0 R");t.internal.write(" ] >>","endobj"),t.internal.newObject(),t.internal.write("<< /Dests "+c+" 0 R"),t.internal.write(">>","endobj")}}]),x.events.push(["putCatalog",function(){0<this.outline.root.children.length&&(this.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&this.internal.write("/Names "+namesOid+" 0 R"))}]),x.events.push(["initialized",function(){var a=this;a.outline={createNamedDestinations:!1,root:{children:[]}},a.outline.add=function(t,e,n){var r={title:e,options:n,children:[]};return null==t&&(t=this.root),t.children.push(r),r},a.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=a,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},a.outline.genIds_r=function(t){t.id=a.internal.newObjectDeferred();for(var e=0;e<t.children.length;e++)this.genIds_r(t.children[e])},a.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),0<t.children.length&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd()},a.outline.renderItems=function(t){this.ctx.pdf.internal.getCoordinateString;for(var e=this.ctx.pdf.internal.getVerticalCoordinateString,n=0;n<t.children.length;n++){var r=t.children[n];this.objStart(r),this.line("/Title "+this.makeString(r.title)),this.line("/Parent "+this.makeRef(t)),0<n&&this.line("/Prev "+this.makeRef(t.children[n-1])),n<t.children.length-1&&this.line("/Next "+this.makeRef(t.children[n+1])),0<r.children.length&&(this.line("/First "+this.makeRef(r.children[0])),this.line("/Last "+this.makeRef(r.children[r.children.length-1])));var i=this.count=this.count_r({count:0},r);if(0<i&&this.line("/Count "+i),r.options&&r.options.pageNumber){var o=a.internal.getPageInfo(r.options.pageNumber);this.line("/Dest ["+o.objId+" 0 R /XYZ 0 "+e(0)+" 0]")}this.objEnd()}for(n=0;n<t.children.length;n++)r=t.children[n],this.renderItems(r)},a.outline.line=function(t){this.ctx.val+=t+"\r\n"},a.outline.makeRef=function(t){return t.id+" 0 R"},a.outline.makeString=function(t){return"("+a.internal.pdfEscape(t)+")"},a.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n"},a.outline.objEnd=function(t){this.ctx.val+=">> \r\nendobj\r\n"},a.outline.count_r=function(t,e){for(var n=0;n<e.children.length;n++)t.count++,this.count_r(t,e.children[n]);return t.count}}]),
/**
   * @license
   * 
   * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   * ====================================================================
   */
I=lt.API,C=function(){var t="function"==typeof Deflater;if(!t)throw new Error("requires deflate.js for compression");return t},B=function(t,e,n,r){var i=5,o=E;switch(r){case I.image_compression.FAST:i=3,o=j;break;case I.image_compression.MEDIUM:i=6,o=M;break;case I.image_compression.SLOW:i=9,o=O}t=A(t,e,n,o);var a=new Uint8Array(N(i)),s=L(t),l=new Deflater(i),h=l.append(t),u=l.flush(),c=a.length+h.length+u.length,f=new Uint8Array(c+4);return f.set(a),f.set(h,a.length),f.set(u,a.length+h.length),f[c++]=s>>>24&255,f[c++]=s>>>16&255,f[c++]=s>>>8&255,f[c++]=255&s,I.arrayBufferToBinaryString(f)},N=function(t,e){var n=Math.LOG2E*Math.log(32768)-8<<4|8,r=n<<8;return r|=Math.min(3,(e-1&255)>>1)<<6,r|=0,[n,255&(r+=31-r%31)]},L=function(t,e){for(var n,r=1,i=0,o=t.length,a=0;0<o;){for(o-=n=e<o?e:o;i+=r+=t[a++],--n;);r%=65521,i%=65521}return(i<<16|r)>>>0},A=function(t,e,n,r){for(var i,o,a,s=t.length/e,l=new Uint8Array(t.length+s),h=T(),u=0;u<s;u++){if(a=u*e,i=t.subarray(a,a+e),r)l.set(r(i,n,o),a+u);else{for(var c=0,f=h.length,p=[];c<f;c++)p[c]=h[c](i,n,o);var d=R(p.concat());l.set(p[d],a+u)}o=i}return l},S=function(t,e,n){var r=Array.apply([],t);return r.unshift(0),r},j=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=1;o<a;o++)r=t[o-e]||0,i[o+1]=t[o]-r+256&255;return i},E=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=2;o<a;o++)r=n&&n[o]||0,i[o+1]=t[o]-r+256&255;return i},M=function(t,e,n){var r,i,o=[],a=0,s=t.length;for(o[0]=3;a<s;a++)r=t[a-e]||0,i=n&&n[a]||0,o[a+1]=t[a]+256-(r+i>>>1)&255;return o},O=function(t,e,n){var r,i,o,a,s=[],l=0,h=t.length;for(s[0]=4;l<h;l++)r=t[l-e]||0,i=n&&n[l]||0,o=n&&n[l-e]||0,a=q(r,i,o),s[l+1]=t[l]-a+256&255;return s},q=function(t,e,n){var r=t+e-n,i=Math.abs(r-t),o=Math.abs(r-e),a=Math.abs(r-n);return i<=o&&i<=a?t:o<=a?e:n},T=function(){return[S,j,E,M,O]},R=function(t){for(var e,n,r,i=0,o=t.length;i<o;)((e=D(t[i].slice(1)))<n||!n)&&(n=e,r=i),i++;return r},D=function(t){for(var e=0,n=t.length,r=0;e<n;)r+=Math.abs(t[e++]);return r},I.processPNG=function(t,e,n,r,i){var o,a,s,l,h,u,c=this.color_spaces.DEVICE_RGB,f=this.decode.FLATE_DECODE,p=8;if(this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)){if("function"!=typeof PNG||"function"!=typeof kt)throw new Error("PNG support requires png.js and zlib.js");if(t=(o=new PNG(t)).imgData,p=o.bits,c=o.colorSpace,l=o.colors,-1!==[4,6].indexOf(o.colorType)){if(8===o.bits)for(var d,g=(_=32==o.pixelBitlength?new Uint32Array(o.decodePixels().buffer):16==o.pixelBitlength?new Uint16Array(o.decodePixels().buffer):new Uint8Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*o.colors),y=new Uint8Array(g),v=o.pixelBitlength-o.bits,w=0,b=0;w<g;w++){for(x=_[w],d=0;d<v;)m[b++]=x>>>d&255,d+=o.bits;y[w]=x>>>d&255}if(16===o.bits){g=(_=new Uint32Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*(32/o.pixelBitlength)*o.colors),y=new Uint8Array(g*(32/o.pixelBitlength));for(var x,N=1<o.colors,L=b=w=0;w<g;)x=_[w++],m[b++]=x>>>0&255,N&&(m[b++]=x>>>16&255,x=_[w++],m[b++]=x>>>0&255),y[L++]=x>>>16&255;p=8}r!==I.image_compression.NONE&&C()?(t=B(m,o.width*o.colors,o.colors,r),u=B(y,o.width,1,r)):(t=m,u=y,f=null)}if(3===o.colorType&&(c=this.color_spaces.INDEXED,h=o.palette,o.transparency.indexed)){var A=o.transparency.indexed,S=0;for(w=0,g=A.length;w<g;++w)S+=A[w];if((S/=255)==g-1&&-1!==A.indexOf(0))s=[A.indexOf(0)];else if(S!==g){var _=o.decodePixels();for(y=new Uint8Array(_.length),w=0,g=_.length;w<g;w++)y[w]=A[_[w]];u=B(y,o.width,1)}}var F=function(t){var e;switch(t){case I.image_compression.FAST:e=11;break;case I.image_compression.MEDIUM:e=13;break;case I.image_compression.SLOW:e=14;break;default:e=12}return e}(r);return a=f===this.decode.FLATE_DECODE?"/Predictor "+F+" /Colors "+l+" /BitsPerComponent "+p+" /Columns "+o.width:"/Colors "+l+" /BitsPerComponent "+p+" /Columns "+o.width,(this.isArrayBuffer(t)||this.isArrayBufferView(t))&&(t=this.arrayBufferToBinaryString(t)),(u&&this.isArrayBuffer(u)||this.isArrayBufferView(u))&&(u=this.arrayBufferToBinaryString(u)),this.createImageInfo(t,o.width,o.height,c,p,f,e,n,a,s,h,u,F)}throw new Error("Unsupported PNG image data, try using JPEG instead.")},(
/**
   * @license
   * Copyright (c) 2017 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
U=lt.API).processGIF89A=function(t,e,n,r,i){var o=new At(t),a=o.width,s=o.height,l=[];o.decodeAndBlitFrameRGBA(0,l);var h={data:l,width:a,height:s},u=new _t(100).encode(h,100);return U.processJPEG.call(this,u,e,n,r)},U.processGIF87A=U.processGIF89A,(
/**
   * Copyright (c) 2018 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
z=lt.API).processBMP=function(t,e,n,r,i){var o=new Ft(t,!1),a=o.width,s=o.height,l={data:o.getData(),width:a,height:s},h=new _t(100).encode(l,100);return z.processJPEG.call(this,h,e,n,r)},lt.API.setLanguage=function(t){return void 0===this.internal.languageSettings&&(this.internal.languageSettings={},this.internal.languageSettings.isSubscribed=!1),void 0!=={af:"Afrikaans",sq:"Albanian",ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",an:"Aragonese",hy:"Armenian",as:"Assamese",ast:"Asturian",az:"Azerbaijani",eu:"Basque",be:"Belarusian",bn:"Bengali",bs:"Bosnian",br:"Breton",bg:"Bulgarian",my:"Burmese",ca:"Catalan",ch:"Chamorro",ce:"Chechen",zh:"Chinese","zh-HK":"Chinese (Hong Kong)","zh-CN":"Chinese (PRC)","zh-SG":"Chinese (Singapore)","zh-TW":"Chinese (Taiwan)",cv:"Chuvash",co:"Corsican",cr:"Cree",hr:"Croatian",cs:"Czech",da:"Danish",nl:"Dutch (Standard)","nl-BE":"Dutch (Belgian)",en:"English","en-AU":"English (Australia)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-IE":"English (Ireland)","en-JM":"English (Jamaica)","en-NZ":"English (New Zealand)","en-PH":"English (Philippines)","en-ZA":"English (South Africa)","en-TT":"English (Trinidad & Tobago)","en-GB":"English (United Kingdom)","en-US":"English (United States)","en-ZW":"English (Zimbabwe)",eo:"Esperanto",et:"Estonian",fo:"Faeroese",fj:"Fijian",fi:"Finnish",fr:"French (Standard)","fr-BE":"French (Belgium)","fr-CA":"French (Canada)","fr-FR":"French (France)","fr-LU":"French (Luxembourg)","fr-MC":"French (Monaco)","fr-CH":"French (Switzerland)",fy:"Frisian",fur:"Friulian",gd:"Gaelic (Scots)","gd-IE":"Gaelic (Irish)",gl:"Galacian",ka:"Georgian",de:"German (Standard)","de-AT":"German (Austria)","de-DE":"German (Germany)","de-LI":"German (Liechtenstein)","de-LU":"German (Luxembourg)","de-CH":"German (Switzerland)",el:"Greek",gu:"Gujurati",ht:"Haitian",he:"Hebrew",hi:"Hindi",hu:"Hungarian",is:"Icelandic",id:"Indonesian",iu:"Inuktitut",ga:"Irish",it:"Italian (Standard)","it-CH":"Italian (Switzerland)",ja:"Japanese",kn:"Kannada",ks:"Kashmiri",kk:"Kazakh",km:"Khmer",ky:"Kirghiz",tlh:"Klingon",ko:"Korean","ko-KP":"Korean (North Korea)","ko-KR":"Korean (South Korea)",la:"Latin",lv:"Latvian",lt:"Lithuanian",lb:"Luxembourgish",mk:"FYRO Macedonian",ms:"Malay",ml:"Malayalam",mt:"Maltese",mi:"Maori",mr:"Marathi",mo:"Moldavian",nv:"Navajo",ng:"Ndonga",ne:"Nepali",no:"Norwegian",nb:"Norwegian (Bokmal)",nn:"Norwegian (Nynorsk)",oc:"Occitan",or:"Oriya",om:"Oromo",fa:"Persian","fa-IR":"Persian/Iran",pl:"Polish",pt:"Portuguese","pt-BR":"Portuguese (Brazil)",pa:"Punjabi","pa-IN":"Punjabi (India)","pa-PK":"Punjabi (Pakistan)",qu:"Quechua",rm:"Rhaeto-Romanic",ro:"Romanian","ro-MO":"Romanian (Moldavia)",ru:"Russian","ru-MO":"Russian (Moldavia)",sz:"Sami (Lappish)",sg:"Sango",sa:"Sanskrit",sc:"Sardinian",sd:"Sindhi",si:"Singhalese",sr:"Serbian",sk:"Slovak",sl:"Slovenian",so:"Somani",sb:"Sorbian",es:"Spanish","es-AR":"Spanish (Argentina)","es-BO":"Spanish (Bolivia)","es-CL":"Spanish (Chile)","es-CO":"Spanish (Colombia)","es-CR":"Spanish (Costa Rica)","es-DO":"Spanish (Dominican Republic)","es-EC":"Spanish (Ecuador)","es-SV":"Spanish (El Salvador)","es-GT":"Spanish (Guatemala)","es-HN":"Spanish (Honduras)","es-MX":"Spanish (Mexico)","es-NI":"Spanish (Nicaragua)","es-PA":"Spanish (Panama)","es-PY":"Spanish (Paraguay)","es-PE":"Spanish (Peru)","es-PR":"Spanish (Puerto Rico)","es-ES":"Spanish (Spain)","es-UY":"Spanish (Uruguay)","es-VE":"Spanish (Venezuela)",sx:"Sutu",sw:"Swahili",sv:"Swedish","sv-FI":"Swedish (Finland)","sv-SV":"Swedish (Sweden)",ta:"Tamil",tt:"Tatar",te:"Teluga",th:"Thai",tig:"Tigre",ts:"Tsonga",tn:"Tswana",tr:"Turkish",tk:"Turkmen",uk:"Ukrainian",hsb:"Upper Sorbian",ur:"Urdu",ve:"Venda",vi:"Vietnamese",vo:"Volapuk",wa:"Walloon",cy:"Welsh",xh:"Xhosa",ji:"Yiddish",zu:"Zulu"}[t]&&(this.internal.languageSettings.languageCode=t,!1===this.internal.languageSettings.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){this.internal.write("/Lang ("+this.internal.languageSettings.languageCode+")")}),this.internal.languageSettings.isSubscribed=!0)),this},
/** @license
   * MIT license.
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */
H=lt.API,W=H.getCharWidthsArray=function(t,e){var n,r,i,o=(e=e||{}).font||this.internal.getFont(),a=e.fontSize||this.internal.getFontSize(),s=e.charSpace||this.internal.getCharSpace(),l=e.widths?e.widths:o.metadata.Unicode.widths,h=l.fof?l.fof:1,u=e.kerning?e.kerning:o.metadata.Unicode.kerning,c=u.fof?u.fof:1,f=0,p=l[0]||h,d=[];for(n=0,r=t.length;n<r;n++)i=t.charCodeAt(n),"function"==typeof o.metadata.widthOfString?d.push((o.metadata.widthOfGlyph(o.metadata.characterToGlyph(i))+s*(1e3/a)||0)/1e3):d.push((l[i]||p)/h+(u[i]&&u[i][f]||0)/c),f=i;return d},V=H.getArraySum=function(t){for(var e=t.length,n=0;e;)n+=t[--e];return n},G=H.getStringUnitWidth=function(t,e){var n=(e=e||{}).fontSize||this.internal.getFontSize(),r=e.font||this.internal.getFont(),i=e.charSpace||this.internal.getCharSpace();return"function"==typeof r.metadata.widthOfString?r.metadata.widthOfString(t,n,i)/n:V(W.apply(this,arguments))},Y=function(t,e,n,r){for(var i=[],o=0,a=t.length,s=0;o!==a&&s+e[o]<n;)s+=e[o],o++;i.push(t.slice(0,o));var l=o;for(s=0;o!==a;)s+e[o]>r&&(i.push(t.slice(l,o)),s=0,l=o),s+=e[o],o++;return l!==o&&i.push(t.slice(l,o)),i},J=function(t,e,n){n||(n={});var r,i,o,a,s,l,h=[],u=[h],c=n.textIndent||0,f=0,p=0,d=t.split(" "),g=W.apply(this,[" ",n])[0];if(l=-1===n.lineIndent?d[0].length+2:n.lineIndent||0){var m=Array(l).join(" "),y=[];d.map(function(t){1<(t=t.split(/\s*\n/)).length?y=y.concat(t.map(function(t,e){return(e&&t.length?"\n":"")+t})):y.push(t[0])}),d=y,l=G.apply(this,[m,n])}for(o=0,a=d.length;o<a;o++){var v=0;if(r=d[o],l&&"\n"==r[0]&&(r=r.substr(1),v=1),i=W.apply(this,[r,n]),e<c+f+(p=V(i))||v){if(e<p){for(s=Y.apply(this,[r,i,e-(c+f),e]),h.push(s.shift()),h=[s.pop()];s.length;)u.push([s.shift()]);p=V(i.slice(r.length-(h[0]?h[0].length:0)))}else h=[r];u.push(h),c=p+l,f=g}else h.push(r),c+=f+p,f=g}if(l)var w=function(t,e){return(e?m:"")+t.join(" ")};else w=function(t){return t.join(" ")};return u.map(w)},H.splitTextToSize=function(t,e,n){var r,i=(n=n||{}).fontSize||this.internal.getFontSize(),o=function(t){var e={0:1},n={};if(t.widths&&t.kerning)return{widths:t.widths,kerning:t.kerning};var r=this.internal.getFont(t.fontName,t.fontStyle),i="Unicode";return r.metadata[i]?{widths:r.metadata[i].widths||e,kerning:r.metadata[i].kerning||n}:{font:r.metadata,fontSize:this.internal.getFontSize(),charSpace:this.internal.getCharSpace()}}.call(this,n);r=Array.isArray(t)?t:t.split(/\r?\n/);var a=1*this.internal.scaleFactor*e/i;o.textIndent=n.textIndent?1*n.textIndent*this.internal.scaleFactor/i:0,o.lineIndent=n.lineIndent;var s,l,h=[];for(s=0,l=r.length;s<l;s++)h=h.concat(J.apply(this,[r[s],a,o]));return h},
/** @license
   jsPDF standard_fonts_metrics plugin
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   * MIT license.
   * 
   * ====================================================================
   */
X=lt.API,Z={codePages:["WinAnsiEncoding"],WinAnsiEncoding:(K=function(t){for(var e="klmnopqrstuvwxyz",n={},r=0;r<e.length;r++)n[e[r]]="0123456789abcdef"[r];var i,o,a,s,l,h={},u=1,c=h,f=[],p="",d="",g=t.length-1;for(r=1;r!=g;)l=t[r],r+=1,"'"==l?o=o?(s=o.join(""),i):[]:o?o.push(l):"{"==l?(f.push([c,s]),c={},s=i):"}"==l?((a=f.pop())[0][a[1]]=c,s=i,c=a[0]):"-"==l?u=-1:s===i?n.hasOwnProperty(l)?(p+=n[l],s=parseInt(p,16)*u,u=1,p=""):p+=l:n.hasOwnProperty(l)?(d+=n[l],c[s]=parseInt(d,16)*u,u=1,s=i,d=""):d+=l;return h})("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},Q={Unicode:{Courier:Z,"Courier-Bold":Z,"Courier-BoldOblique":Z,"Courier-Oblique":Z,Helvetica:Z,"Helvetica-Bold":Z,"Helvetica-BoldOblique":Z,"Helvetica-Oblique":Z,"Times-Roman":Z,"Times-Bold":Z,"Times-BoldItalic":Z,"Times-Italic":Z}},$={Unicode:{"Courier-Oblique":K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":K("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":K("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":K("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Symbol:K("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),Helvetica:K("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":K("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),ZapfDingbats:K("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-Bold":K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":K("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":K("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":K("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}},X.events.push(["addFont",function(t){var e,n,r,i=t.font,o="Unicode";(e=$[o][i.postScriptName])&&((n=i.metadata[o]?i.metadata[o]:i.metadata[o]={}).widths=e.widths,n.kerning=e.kerning),(r=Q[o][i.postScriptName])&&((n=i.metadata[o]?i.metadata[o]:i.metadata[o]={}).encoding=r).codePages&&r.codePages.length&&(i.encoding=r.codePages[0])}]),
/**
   * @license
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
tt=lt,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")(),tt.API.events.push(["addFont",function(t){var e=t.font,n=t.instance;if(void 0!==n&&n.existsFileInVFS(e.postScriptName)){var r=n.getFileFromVFS(e.postScriptName);if("string"!=typeof r)throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('"+e.postScriptName+"').");e.metadata=tt.API.TTFFont.open(e.postScriptName,e.fontName,r,e.encoding),e.metadata.Unicode=e.metadata.Unicode||{encoding:{},kerning:{},widths:[]},e.metadata.glyIdsUsed=[0]}else if(!1===e.isStandardFont)throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('"+e.postScriptName+"').")}]),(
/** @license
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   * 
   * 
   * ====================================================================
   */
et=lt.API).addSvg=function(t,e,n,r,i){if(void 0===e||void 0===n)throw new Error("addSVG needs values for 'x' and 'y'");function o(t){for(var e=parseFloat(t[1]),n=parseFloat(t[2]),r=[],i=3,o=t.length;i<o;)"c"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2]),parseFloat(t[i+3]),parseFloat(t[i+4]),parseFloat(t[i+5]),parseFloat(t[i+6])]),i+=7):"l"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2])]),i+=3):i+=1;return[e,n,r]}var a,s,l,h,u,c,f,p,d=(h=document,p=h.createElement("iframe"),u=".jsPDF_sillysvg_iframe {display:none;position:absolute;}",(f=(c=h).createElement("style")).type="text/css",f.styleSheet?f.styleSheet.cssText=u:f.appendChild(c.createTextNode(u)),c.getElementsByTagName("head")[0].appendChild(f),p.name="childframe",p.setAttribute("width",0),p.setAttribute("height",0),p.setAttribute("frameborder","0"),p.setAttribute("scrolling","no"),p.setAttribute("seamless","seamless"),p.setAttribute("class","jsPDF_sillysvg_iframe"),h.body.appendChild(p),p),g=(a=t,(l=((s=d).contentWindow||s.contentDocument).document).write(a),l.close(),l.getElementsByTagName("svg")[0]),m=[1,1],y=parseFloat(g.getAttribute("width")),v=parseFloat(g.getAttribute("height"));y&&v&&(r&&i?m=[r/y,i/v]:r?m=[r/y,r/y]:i&&(m=[i/v,i/v]));var w,b,x,N,L=g.childNodes;for(w=0,b=L.length;w<b;w++)(x=L[w]).tagName&&"PATH"===x.tagName.toUpperCase()&&((N=o(x.getAttribute("d").split(" ")))[0]=N[0]*m[0]+e,N[1]=N[1]*m[1]+n,this.lines.call(this,N[2],N[0],N[1],m));return this},et.addSVG=et.addSvg,et.addSvgAsImage=function(t,e,n,r,i,o,a,s){if(isNaN(e)||isNaN(n))throw console.error("jsPDF.addSvgAsImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");if(isNaN(r)||isNaN(i))throw console.error("jsPDF.addSvgAsImage: Invalid measurements",arguments),new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");var l=document.createElement("canvas");l.width=r,l.height=i;var h=l.getContext("2d");return h.fillStyle="#fff",h.fillRect(0,0,l.width,l.height),canvg(l,t,{ignoreMouse:!0,ignoreAnimation:!0,ignoreDimensions:!0,ignoreClear:!0}),this.addImage(l.toDataURL("image/jpeg",1),e,n,r,i,a,s),this},lt.API.putTotalPages=function(t){var e,n=0;n=parseInt(this.internal.getFont().id.substr(1),10)<15?(e=new RegExp(t,"g"),this.internal.getNumberOfPages()):(e=new RegExp(this.pdfEscape16(t,this.internal.getFont()),"g"),this.pdfEscape16(this.internal.getNumberOfPages()+"",this.internal.getFont()));for(var r=1;r<=this.internal.getNumberOfPages();r++)for(var i=0;i<this.internal.pages[r].length;i++)this.internal.pages[r][i]=this.internal.pages[r][i].replace(e,n);return this},lt.API.viewerPreferences=function(t,e){var n;t=t||{},e=e||!1;var r,i,o={HideToolbar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideMenubar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideWindowUI:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},FitWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},CenterWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},DisplayDocTitle:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.4},NonFullScreenPageMode:{defaultValue:"UseNone",value:"UseNone",type:"name",explicitSet:!1,valueSet:["UseNone","UseOutlines","UseThumbs","UseOC"],pdfVersion:1.3},Direction:{defaultValue:"L2R",value:"L2R",type:"name",explicitSet:!1,valueSet:["L2R","R2L"],pdfVersion:1.3},ViewArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},ViewClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintScaling:{defaultValue:"AppDefault",value:"AppDefault",type:"name",explicitSet:!1,valueSet:["AppDefault","None"],pdfVersion:1.6},Duplex:{defaultValue:"",value:"none",type:"name",explicitSet:!1,valueSet:["Simplex","DuplexFlipShortEdge","DuplexFlipLongEdge","none"],pdfVersion:1.7},PickTrayByPDFSize:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.7},PrintPageRange:{defaultValue:"",value:"",type:"array",explicitSet:!1,valueSet:null,pdfVersion:1.7},NumCopies:{defaultValue:1,value:1,type:"integer",explicitSet:!1,valueSet:null,pdfVersion:1.7}},a=Object.keys(o),s=[],l=0,h=0,u=0,c=!0;function f(t,e){var n,r=!1;for(n=0;n<t.length;n+=1)t[n]===e&&(r=!0);return r}if(void 0===this.internal.viewerpreferences&&(this.internal.viewerpreferences={},this.internal.viewerpreferences.configuration=JSON.parse(JSON.stringify(o)),this.internal.viewerpreferences.isSubscribed=!1),n=this.internal.viewerpreferences.configuration,"reset"===t||!0===e){var p=a.length;for(u=0;u<p;u+=1)n[a[u]].value=n[a[u]].defaultValue,n[a[u]].explicitSet=!1}if("object"===se(t))for(r in t)if(i=t[r],f(a,r)&&void 0!==i){if("boolean"===n[r].type&&"boolean"==typeof i)n[r].value=i;else if("name"===n[r].type&&f(n[r].valueSet,i))n[r].value=i;else if("integer"===n[r].type&&Number.isInteger(i))n[r].value=i;else if("array"===n[r].type){for(l=0;l<i.length;l+=1)if(c=!0,1===i[l].length&&"number"==typeof i[l][0])s.push(String(i[l]-1));else if(1<i[l].length){for(h=0;h<i[l].length;h+=1)"number"!=typeof i[l][h]&&(c=!1);!0===c&&s.push([i[l][0]-1,i[l][1]-1].join(" "))}n[r].value="["+s.join(" ")+"]"}else n[r].value=n[r].defaultValue;n[r].explicitSet=!0}return!1===this.internal.viewerpreferences.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){var t,e=[];for(t in n)!0===n[t].explicitSet&&("name"===n[t].type?e.push("/"+t+" /"+n[t].value):e.push("/"+t+" "+n[t].value));0!==e.length&&this.internal.write("/ViewerPreferences\n<<\n"+e.join("\n")+"\n>>")}),this.internal.viewerpreferences.isSubscribed=!0),this.internal.viewerpreferences.configuration=n,this},
/** ==================================================================== 
   * jsPDF XMP metadata plugin
   * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
   * 
   * 
   * ====================================================================
   */
nt=lt.API,ot=it=rt="",nt.addMetadata=function(t,e){return it=e||"http://jspdf.default.namespaceuri/",rt=t,this.internal.events.subscribe("postPutResources",function(){if(rt){var t='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+it+'"><jspdf:metadata>',e=unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),n=unescape(encodeURIComponent(t)),r=unescape(encodeURIComponent(rt)),i=unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),o=unescape(encodeURIComponent("</x:xmpmeta>")),a=n.length+r.length+i.length+e.length+o.length;ot=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+a+" >>"),this.internal.write("stream"),this.internal.write(e+n+r+i+o),this.internal.write("endstream"),this.internal.write("endobj")}else ot=""}),this.internal.events.subscribe("putCatalog",function(){ot&&this.internal.write("/Metadata "+ot+" 0 R")}),this},function(f,t){var e=f.API;var m=e.pdfEscape16=function(t,e){for(var n,r=e.metadata.Unicode.widths,i=["","0","00","000","0000"],o=[""],a=0,s=t.length;a<s;++a){if(n=e.metadata.characterToGlyph(t.charCodeAt(a)),e.metadata.glyIdsUsed.push(n),e.metadata.toUnicode[n]=t.charCodeAt(a),-1==r.indexOf(n)&&(r.push(n),r.push([parseInt(e.metadata.widthOfGlyph(n),10)])),"0"==n)return o.join("");n=n.toString(16),o.push(i[4-n.length],n)}return o.join("")},p=function(t){var e,n,r,i,o,a,s;for(o="/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange",r=[],a=0,s=(n=Object.keys(t).sort(function(t,e){return t-e})).length;a<s;a++)e=n[a],100<=r.length&&(o+="\n"+r.length+" beginbfchar\n"+r.join("\n")+"\nendbfchar",r=[]),i=("0000"+t[e].toString(16)).slice(-4),e=("0000"+(+e).toString(16)).slice(-4),r.push("<"+e+"><"+i+">");return r.length&&(o+="\n"+r.length+" beginbfchar\n"+r.join("\n")+"\nendbfchar\n"),o+="endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend"};e.events.push(["putFont",function(t){!function(t,e,n,r){if(t.metadata instanceof f.API.TTFFont&&"Identity-H"===t.encoding){for(var i=t.metadata.Unicode.widths,o=t.metadata.subset.encode(t.metadata.glyIdsUsed,1),a="",s=0;s<o.length;s++)a+=String.fromCharCode(o[s]);var l=n();r({data:a,addLength1:!0}),e("endobj");var h=n();r({data:p(t.metadata.toUnicode),addLength1:!0}),e("endobj");var u=n();e("<<"),e("/Type /FontDescriptor"),e("/FontName /"+t.fontName),e("/FontFile2 "+l+" 0 R"),e("/FontBBox "+f.API.PDFObject.convert(t.metadata.bbox)),e("/Flags "+t.metadata.flags),e("/StemV "+t.metadata.stemV),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e(">>"),e("endobj");var c=n();e("<<"),e("/Type /Font"),e("/BaseFont /"+t.fontName),e("/FontDescriptor "+u+" 0 R"),e("/W "+f.API.PDFObject.convert(i)),e("/CIDToGIDMap /Identity"),e("/DW 1000"),e("/Subtype /CIDFontType2"),e("/CIDSystemInfo"),e("<<"),e("/Supplement 0"),e("/Registry (Adobe)"),e("/Ordering ("+t.encoding+")"),e(">>"),e(">>"),e("endobj"),t.objectNumber=n(),e("<<"),e("/Type /Font"),e("/Subtype /Type0"),e("/ToUnicode "+h+" 0 R"),e("/BaseFont /"+t.fontName),e("/Encoding /"+t.encoding),e("/DescendantFonts ["+c+" 0 R]"),e(">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject,t.putStream)}]);e.events.push(["putFont",function(t){!function(t,e,n,r){if(t.metadata instanceof f.API.TTFFont&&"WinAnsiEncoding"===t.encoding){t.metadata.Unicode.widths;for(var i=t.metadata.rawData,o="",a=0;a<i.length;a++)o+=String.fromCharCode(i[a]);var s=n();r({data:o,addLength1:!0}),e("endobj");var l=n();r({data:p(t.metadata.toUnicode),addLength1:!0}),e("endobj");var h=n();for(e("<<"),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e("/StemV "+t.metadata.stemV),e("/Type /FontDescriptor"),e("/FontFile2 "+s+" 0 R"),e("/Flags 96"),e("/FontBBox "+f.API.PDFObject.convert(t.metadata.bbox)),e("/FontName /"+t.fontName),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e(">>"),e("endobj"),t.objectNumber=n(),a=0;a<t.metadata.hmtx.widths.length;a++)t.metadata.hmtx.widths[a]=parseInt(t.metadata.hmtx.widths[a]*(1e3/t.metadata.head.unitsPerEm));e("<</Subtype/TrueType/Type/Font/ToUnicode "+l+" 0 R/BaseFont/"+t.fontName+"/FontDescriptor "+h+" 0 R/Encoding/"+t.encoding+" /FirstChar 29 /LastChar 255 /Widths "+f.API.PDFObject.convert(t.metadata.hmtx.widths)+">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject,t.putStream)}]);var h=function(t){var e,n,r=t.text||"",i=t.x,o=t.y,a=t.options||{},s=t.mutex||{},l=s.pdfEscape,h=s.activeFontKey,u=s.fonts,c=(s.activeFontSize,""),f=0,p="",d=u[n=h].encoding;if("Identity-H"!==u[n].encoding)return{text:r,x:i,y:o,options:a,mutex:s};for(p=r,n=h,"[object Array]"===Object.prototype.toString.call(r)&&(p=r[0]),f=0;f<p.length;f+=1)u[n].metadata.hasOwnProperty("cmap")&&(e=u[n].metadata.cmap.unicode.codeMap[p[f].charCodeAt(0)]),e?c+=p[f]:p[f].charCodeAt(0)<256&&u[n].metadata.hasOwnProperty("Unicode")?c+=p[f]:c+="";var g="";return parseInt(n.slice(1))<14||"WinAnsiEncoding"===d?g=function(t){for(var e="",n=0;n<t.length;n++)e+=""+t.charCodeAt(n).toString(16);return e}(l(c,n)):"Identity-H"===d&&(g=m(c,u[n])),s.isHex=!0,{text:g,x:i,y:o,options:a,mutex:s}};e.events.push(["postProcessText",function(t){var e=t.text||"",n=t.x,r=t.y,i=t.options,o=t.mutex,a=(i.lang,[]),s={text:e,x:n,y:r,options:i,mutex:o};if("[object Array]"===Object.prototype.toString.call(e)){var l=0;for(l=0;l<e.length;l+=1)"[object Array]"===Object.prototype.toString.call(e[l])&&3===e[l].length?a.push([h(Object.assign({},s,{text:e[l][0]})).text,e[l][1],e[l][2]]):a.push(h(Object.assign({},s,{text:e[l]})).text);t.text=a}else t.text=h(Object.assign({},s,{text:e})).text}])}(lt,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")()),at=lt.API,st=function(t){return void 0!==t&&(void 0===t.vFS&&(t.vFS={}),!0)},at.existsFileInVFS=function(t){return!!st(this.internal)&&void 0!==this.internal.vFS[t]},at.addFileToVFS=function(t,e){return st(this.internal),this.internal.vFS[t]=e,this},at.getFileFromVFS=function(t){return st(this.internal),void 0!==this.internal.vFS[t]?this.internal.vFS[t]:null},lt.API.addHTML=function(t,d,g,s,m){if("undefined"==typeof html2canvas&&"undefined"==typeof rasterizeHTML)throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");"number"!=typeof d&&(s=d,m=g),"function"==typeof s&&(m=s,s=null),"function"!=typeof m&&(m=function(){});var e=this.internal,y=e.scaleFactor,v=e.pageSize.getWidth(),w=e.pageSize.getHeight();if((s=s||{}).onrendered=function(l){d=parseInt(d)||0,g=parseInt(g)||0;var t=s.dim||{},h=Object.assign({top:0,right:0,bottom:0,left:0,useFor:"content"},s.margin),e=t.h||Math.min(w,l.height/y),u=t.w||Math.min(v,l.width/y)-d,c=s.format||"JPEG",f=s.imageCompression||"SLOW";if(l.height>w-h.top-h.bottom&&s.pagesplit){var p=function(t,e,n,r,i){var o=document.createElement("canvas");o.height=i,o.width=r;var a=o.getContext("2d");return a.mozImageSmoothingEnabled=!1,a.webkitImageSmoothingEnabled=!1,a.msImageSmoothingEnabled=!1,a.imageSmoothingEnabled=!1,a.fillStyle=s.backgroundColor||"#ffffff",a.fillRect(0,0,r,i),a.drawImage(t,e,n,r,i,0,0,r,i),o},n=function(){for(var t,e,n=0,r=0,i={},o=!1;;){var a;if(r=0,i.top=0!==n?h.top:g,i.left=0!==n?h.left:d,o=(v-h.left-h.right)*y<l.width,"content"===h.useFor?0===n?(t=Math.min((v-h.left)*y,l.width),e=Math.min((w-h.top)*y,l.height-n)):(t=Math.min(v*y,l.width),e=Math.min(w*y,l.height-n),i.top=0):(t=Math.min((v-h.left-h.right)*y,l.width),e=Math.min((w-h.bottom-h.top)*y,l.height-n)),o)for(;;){"content"===h.useFor&&(0===r?t=Math.min((v-h.left)*y,l.width):(t=Math.min(v*y,l.width-r),i.left=0));var s=[a=p(l,r,n,t,e),i.left,i.top,a.width/y,a.height/y,c,null,f];if(this.addImage.apply(this,s),(r+=t)>=l.width)break;this.addPage()}else s=[a=p(l,0,n,t,e),i.left,i.top,a.width/y,a.height/y,c,null,f],this.addImage.apply(this,s);if((n+=e)>=l.height)break;this.addPage()}m(u,n,null,s)}.bind(this);if("CANVAS"===l.nodeName){var r=new Image;r.onload=n,r.src=l.toDataURL("image/png"),l=r}else n()}else{var i=Math.random().toString(35),o=[l,d,g,u,e,c,i,f];this.addImage.apply(this,o),m(u,e,i,o)}}.bind(this),"undefined"!=typeof html2canvas&&!s.rstz)return html2canvas(t,s);if("undefined"==typeof rasterizeHTML)return null;var n="drawDocument";return"string"==typeof t&&(n=/^http/.test(t)?"drawURL":"drawHTML"),s.width=s.width||v*y,rasterizeHTML[n](t,void 0,s).then(function(t){s.onrendered(t.image)},function(t){m(null,t)})},
/**
   * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Daniel Husar, https://github.com/danielhusar
   *               2014 Wolfgang Gassler, https://github.com/woolfg
   *               2014 Steven Spungin, https://github.com/flamenco
   *
   * @license
   * 
   * ====================================================================
   */
function(t){var P,k,i,a,s,l,h,u,I,w,f,c,p,n,C,B,d,g,m,j;P=function(){return function(t){return e.prototype=t,new e};function e(){}}(),w=function(t){var e,n,r,i,o,a,s;for(n=0,r=t.length,e=void 0,a=i=!1;!i&&n!==r;)(e=t[n]=t[n].trimLeft())&&(i=!0),n++;for(n=r-1;r&&!a&&-1!==n;)(e=t[n]=t[n].trimRight())&&(a=!0),n--;for(o=/\s+$/g,s=!0,n=0;n!==r;)"\u2028"!=t[n]&&(e=t[n].replace(/\s+/g," "),s&&(e=e.trimLeft()),e&&(s=o.test(e)),t[n]=e),n++;return t},c=function(t){var e,n,r;for(e=void 0,n=(r=t.split(",")).shift();!e&&n;)e=i[n.trim().toLowerCase()],n=r.shift();return e},p=function(t){var e;return-1<(t="auto"===t?"0px":t).indexOf("em")&&!isNaN(Number(t.replace("em","")))&&(t=18.719*Number(t.replace("em",""))+"px"),-1<t.indexOf("pt")&&!isNaN(Number(t.replace("pt","")))&&(t=1.333*Number(t.replace("pt",""))+"px"),void 0,16,(e=n[t])?e:void 0!==(e={"xx-small":9,"x-small":11,small:13,medium:16,large:19,"x-large":23,"xx-large":28,auto:0}[t])?n[t]=e/16:(e=parseFloat(t))?n[t]=e/16:(e=t.match(/([\d\.]+)(px)/),Array.isArray(e)&&3===e.length?n[t]=parseFloat(e[1])/16:n[t]=1)},I=function(t){var e,n,r,i,o;return o=t,i=document.defaultView&&document.defaultView.getComputedStyle?document.defaultView.getComputedStyle(o,null):o.currentStyle?o.currentStyle:o.style,n=void 0,(e={})["font-family"]=c((r=function(t){return t=t.replace(/-\D/g,function(t){return t.charAt(1).toUpperCase()}),i[t]})("font-family"))||"times",e["font-style"]=a[r("font-style")]||"normal",e["text-align"]=s[r("text-align")]||"left","bold"===(n=l[r("font-weight")]||"normal")&&("normal"===e["font-style"]?e["font-style"]=n:e["font-style"]=n+e["font-style"]),e["font-size"]=p(r("font-size"))||1,e["line-height"]=p(r("line-height"))||1,e.display="inline"===r("display")?"inline":"block",n="block"===e.display,e["margin-top"]=n&&p(r("margin-top"))||0,e["margin-bottom"]=n&&p(r("margin-bottom"))||0,e["padding-top"]=n&&p(r("padding-top"))||0,e["padding-bottom"]=n&&p(r("padding-bottom"))||0,e["margin-left"]=n&&p(r("margin-left"))||0,e["margin-right"]=n&&p(r("margin-right"))||0,e["padding-left"]=n&&p(r("padding-left"))||0,e["padding-right"]=n&&p(r("padding-right"))||0,e["page-break-before"]=r("page-break-before")||"auto",e.float=h[r("cssFloat")]||"none",e.clear=u[r("clear")]||"none",e.color=r("color"),e},C=function(t,e,n){var r,i,o,a,s;if(o=!1,a=i=void 0,r=n["#"+t.id])if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;if(r=n[t.nodeName],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;for(s="string"==typeof t.className?t.className.split(" "):[],i=0;i<s.length;i++)if(r=n["."+s[i]],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;return o},j=function(t,e){var n,r,i,o,a,s,l,h,u;for(n=[],r=[],i=0,u=t.rows[0].cells.length,l=t.clientWidth;i<u;)h=t.rows[0].cells[i],r[i]={name:h.textContent.toLowerCase().replace(/\s+/g,""),prompt:h.textContent.replace(/\r?\n/g,""),width:h.clientWidth/l*e.pdf.internal.pageSize.getWidth()},i++;for(i=1;i<t.rows.length;){for(s=t.rows[i],a={},o=0;o<s.cells.length;)a[r[o].name]=s.cells[o].textContent.replace(/\r?\n/g,""),o++;n.push(a),i++}return{rows:n,headers:r}};var E={SCRIPT:1,STYLE:1,NOSCRIPT:1,OBJECT:1,EMBED:1,SELECT:1},M=1;k=function(t,i,e){var n,r,o,a,s,l,h,u;for(r=t.childNodes,n=void 0,(s="block"===(o=I(t)).display)&&(i.setBlockBoundary(),i.setBlockStyle(o)),a=0,l=r.length;a<l;){if("object"===se(n=r[a])){if(i.executeWatchFunctions(n),1===n.nodeType&&"HEADER"===n.nodeName){var c=n,f=i.pdf.margins_doc.top;i.pdf.internal.events.subscribe("addPage",function(t){i.y=f,k(c,i,e),i.pdf.margins_doc.top=i.y+10,i.y+=10},!1)}if(8===n.nodeType&&"#comment"===n.nodeName)~n.textContent.indexOf("ADD_PAGE")&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top);else if(1!==n.nodeType||E[n.nodeName])if(3===n.nodeType){var p=n.nodeValue;if(n.nodeValue&&"LI"===n.parentNode.nodeName)if("OL"===n.parentNode.parentNode.nodeName)p=M+++". "+p;else{var d=o["font-size"],g=(3-.75*d)*i.pdf.internal.scaleFactor,m=.75*d*i.pdf.internal.scaleFactor,y=1.74*d/i.pdf.internal.scaleFactor;u=function(t,e){this.pdf.circle(t+g,e+m,y,"FD")}}16&n.ownerDocument.body.compareDocumentPosition(n)&&i.addText(p,o)}else"string"==typeof n&&i.addText(n,o);else{var v;if("IMG"===n.nodeName){var w=n.getAttribute("src");v=B[i.pdf.sHashCode(w)||w]}if(v){i.pdf.internal.pageSize.getHeight()-i.pdf.margins_doc.bottom<i.y+n.height&&i.y>i.pdf.margins_doc.top&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top,i.executeWatchFunctions(n));var b=I(n),x=i.x,N=12/i.pdf.internal.scaleFactor,L=(b["margin-left"]+b["padding-left"])*N,A=(b["margin-right"]+b["padding-right"])*N,S=(b["margin-top"]+b["padding-top"])*N,_=(b["margin-bottom"]+b["padding-bottom"])*N;void 0!==b.float&&"right"===b.float?x+=i.settings.width-n.width-A:x+=L,i.pdf.addImage(v,x,i.y+S,n.width,n.height),v=void 0,"right"===b.float||"left"===b.float?(i.watchFunctions.push(function(t,e,n,r){return i.y>=e?(i.x+=t,i.settings.width+=n,!0):!!(r&&1===r.nodeType&&!E[r.nodeName]&&i.x+r.width>i.pdf.margins_doc.left+i.pdf.margins_doc.width)&&(i.x+=t,i.y=e,i.settings.width+=n,!0)}.bind(this,"left"===b.float?-n.width-L-A:0,i.y+n.height+S+_,n.width)),i.watchFunctions.push(function(t,e,n){return!(i.y<t&&e===i.pdf.internal.getNumberOfPages())||1===n.nodeType&&"both"===I(n).clear&&(i.y=t,!0)}.bind(this,i.y+n.height,i.pdf.internal.getNumberOfPages())),i.settings.width-=n.width+L+A,"left"===b.float&&(i.x+=n.width+L+A)):i.y+=n.height+S+_}else if("TABLE"===n.nodeName)h=j(n,i),i.y+=10,i.pdf.table(i.x,i.y,h.rows,h.headers,{autoSize:!1,printHeaders:e.printHeaders,margins:i.pdf.margins_doc,css:I(n)}),i.y=i.pdf.lastCellPos.y+i.pdf.lastCellPos.h+20;else if("OL"===n.nodeName||"UL"===n.nodeName)M=1,C(n,i,e)||k(n,i,e),i.y+=10;else if("LI"===n.nodeName){var F=i.x;i.x+=20/i.pdf.internal.scaleFactor,i.y+=3,C(n,i,e)||k(n,i,e),i.x=F}else"BR"===n.nodeName?(i.y+=o["font-size"]*i.pdf.internal.scaleFactor,i.addText("\u2028",P(o))):C(n,i,e)||k(n,i,e)}}a++}if(e.outY=i.y,s)return i.setBlockBoundary(u)},B={},d=function(t,o,e,n){var a,r=t.getElementsByTagName("img"),i=r.length,s=0;function l(){o.pdf.internal.events.publish("imagesLoaded"),n(a)}function h(e,n,r){if(e){var i=new Image;a=++s,i.crossOrigin="",i.onerror=i.onload=function(){if(i.complete&&(0===i.src.indexOf("data:image/")&&(i.width=n||i.width||0,i.height=r||i.height||0),i.width+i.height)){var t=o.pdf.sHashCode(e)||e;B[t]=B[t]||i}--s||l()},i.src=e}}for(;i--;)h(r[i].getAttribute("src"),r[i].width,r[i].height);return s||l()},g=function(t,o,a){var s=t.getElementsByTagName("footer");if(0<s.length){s=s[0];var e=o.pdf.internal.write,n=o.y;o.pdf.internal.write=function(){},k(s,o,a);var l=Math.ceil(o.y-n)+5;o.y=n,o.pdf.internal.write=e,o.pdf.margins_doc.bottom+=l;for(var r=function(t){var e=void 0!==t?t.pageNumber:1,n=o.y;o.y=o.pdf.internal.pageSize.getHeight()-o.pdf.margins_doc.bottom,o.pdf.margins_doc.bottom-=l;for(var r=s.getElementsByTagName("span"),i=0;i<r.length;++i)-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" pageCounter ")&&(r[i].innerHTML=e),-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&(r[i].innerHTML="###jsPDFVarTotalPages###");k(s,o,a),o.pdf.margins_doc.bottom+=l,o.y=n},i=s.getElementsByTagName("span"),h=0;h<i.length;++h)-1<(" "+i[h].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&o.pdf.internal.events.subscribe("htmlRenderingFinished",o.pdf.putTotalPages.bind(o.pdf,"###jsPDFVarTotalPages###"),!0);o.pdf.internal.events.subscribe("addPage",r,!1),r(),E.FOOTER=1}},m=function(t,e,n,r,i,o){if(!e)return!1;var a,s,l,h;"string"==typeof e||e.parentNode||(e=""+e.innerHTML),"string"==typeof e&&(a=e.replace(/<\/?script[^>]*?>/gi,""),h="jsPDFhtmlText"+Date.now().toString()+(1e3*Math.random()).toFixed(0),(l=document.createElement("div")).style.cssText="position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;",l.innerHTML='<iframe style="height:1px;width:1px" name="'+h+'" />',document.body.appendChild(l),(s=window.frames[h]).document.open(),s.document.writeln(a),s.document.close(),e=s.document.body);var u,c=new f(t,n,r,i);return d.call(this,e,c,i.elementHandlers,function(t){g(e,c,i.elementHandlers),k(e,c,i.elementHandlers),c.pdf.internal.events.publish("htmlRenderingFinished"),u=c.dispose(),"function"==typeof o?o(u):t&&console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!")}),u||{x:c.x,y:c.y}},(f=function(t,e,n,r){return this.pdf=t,this.x=e,this.y=n,this.settings=r,this.watchFunctions=[],this.init(),this}).prototype.init=function(){return this.paragraph={text:[],style:[]},this.pdf.internal.write("q")},f.prototype.dispose=function(){return this.pdf.internal.write("Q"),{x:this.x,y:this.y,ready:!0}},f.prototype.executeWatchFunctions=function(t){var e=!1,n=[];if(0<this.watchFunctions.length){for(var r=0;r<this.watchFunctions.length;++r)!0===this.watchFunctions[r](t)?e=!0:n.push(this.watchFunctions[r]);this.watchFunctions=n}return e},f.prototype.splitFragmentsIntoLines=function(t,e){var n,r,i,o,a,s,l,h,u,c,f,p,d,g;for(12,c=this.pdf.internal.scaleFactor,o={},s=l=h=g=a=i=u=r=void 0,p=[f=[]],n=0,d=this.settings.width;t.length;)if(a=t.shift(),g=e.shift(),a)if((i=o[(r=g["font-family"])+(u=g["font-style"])])||(i=this.pdf.internal.getFont(r,u).metadata.Unicode,o[r+u]=i),h={widths:i.widths,kerning:i.kerning,fontSize:12*g["font-size"],textIndent:n},l=this.pdf.getStringUnitWidth(a,h)*h.fontSize/c,"\u2028"==a)f=[],p.push(f);else if(d<n+l){for(s=this.pdf.splitTextToSize(a,d,h),f.push([s.shift(),g]);s.length;)f=[[s.shift(),g]],p.push(f);n=this.pdf.getStringUnitWidth(f[0][0],h)*h.fontSize/c}else f.push([a,g]),n+=l;if(void 0!==g["text-align"]&&("center"===g["text-align"]||"right"===g["text-align"]||"justify"===g["text-align"]))for(var m=0;m<p.length;++m){var y=this.pdf.getStringUnitWidth(p[m][0][0],h)*h.fontSize/c;0<m&&(p[m][0][1]=P(p[m][0][1]));var v=d-y;if("right"===g["text-align"])p[m][0][1]["margin-left"]=v;else if("center"===g["text-align"])p[m][0][1]["margin-left"]=v/2;else if("justify"===g["text-align"]){var w=p[m][0][0].split(" ").length-1;p[m][0][1]["word-spacing"]=v/w,m===p.length-1&&(p[m][0][1]["word-spacing"]=0)}}return p},f.prototype.RenderTextFragment=function(t,e){var n,r;r=0,this.pdf.internal.pageSize.getHeight()-this.pdf.margins_doc.bottom<this.y+this.pdf.internal.getFontSize()&&(this.pdf.internal.write("ET","Q"),this.pdf.addPage(),this.y=this.pdf.margins_doc.top,this.pdf.internal.write("q","BT",this.getPdfColor(e.color),this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td"),r=Math.max(r,e["line-height"],e["font-size"]),this.pdf.internal.write(0,(-12*r).toFixed(2),"Td")),n=this.pdf.internal.getFont(e["font-family"],e["font-style"]);var i=this.getPdfColor(e.color);i!==this.lastTextColor&&(this.pdf.internal.write(i),this.lastTextColor=i),void 0!==e["word-spacing"]&&0<e["word-spacing"]&&this.pdf.internal.write(e["word-spacing"].toFixed(2),"Tw"),this.pdf.internal.write("/"+n.id,(12*e["font-size"]).toFixed(2),"Tf","("+this.pdf.internal.pdfEscape(t)+") Tj"),void 0!==e["word-spacing"]&&this.pdf.internal.write(0,"Tw")},f.prototype.getPdfColor=function(t){var e,n,r,i=/rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/.exec(t);if(null!=i)e=parseInt(i[1]),n=parseInt(i[2]),r=parseInt(i[3]);else{if("string"==typeof t&&"#"!=t.charAt(0)){var o=new RGBColor(t);t=o.ok?o.toHex():"#000000"}e=t.substring(1,3),e=parseInt(e,16),n=t.substring(3,5),n=parseInt(n,16),r=t.substring(5,7),r=parseInt(r,16)}if("string"==typeof e&&/^#[0-9A-Fa-f]{6}$/.test(e)){var a=parseInt(e.substr(1),16);e=a>>16&255,n=a>>8&255,r=255&a}var s=this.f3;return 0===e&&0===n&&0===r||void 0===n?s(e/255)+" g":[s(e/255),s(n/255),s(r/255),"rg"].join(" ")},f.prototype.f3=function(t){return t.toFixed(3)},f.prototype.renderParagraph=function(t){var e,n,r,i,o,a,s,l,h,u,c,f,p;if(r=w(this.paragraph.text),f=this.paragraph.style,e=this.paragraph.blockstyle,this.paragraph.priorblockstyle||{},this.paragraph={text:[],style:[],blockstyle:{},priorblockstyle:e},r.join("").trim()){s=this.splitFragmentsIntoLines(r,f),l=a=void 0,n=12/this.pdf.internal.scaleFactor,this.priorMarginBottom=this.priorMarginBottom||0,c=(Math.max((e["margin-top"]||0)-this.priorMarginBottom,0)+(e["padding-top"]||0))*n,u=((e["margin-bottom"]||0)+(e["padding-bottom"]||0))*n,this.priorMarginBottom=e["margin-bottom"]||0,"always"===e["page-break-before"]&&(this.pdf.addPage(),this.y=0,c=((e["margin-top"]||0)+(e["padding-top"]||0))*n),h=this.pdf.internal.write,o=i=void 0,this.y+=c,h("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td");for(var d=0;s.length;){for(i=l=0,o=(a=s.shift()).length;i!==o;)a[i][0].trim()&&(l=Math.max(l,a[i][1]["line-height"],a[i][1]["font-size"]),p=7*a[i][1]["font-size"]),i++;var g=0,m=0;for(void 0!==a[0][1]["margin-left"]&&0<a[0][1]["margin-left"]&&(g=(m=this.pdf.internal.getCoordinateString(a[0][1]["margin-left"]))-d,d=m),h(g+Math.max(e["margin-left"]||0,0)*n,(-12*l).toFixed(2),"Td"),i=0,o=a.length;i!==o;)a[i][0]&&this.RenderTextFragment(a[i][0],a[i][1]),i++;if(this.y+=l*n,this.executeWatchFunctions(a[0][1])&&0<s.length){var y=[],v=[];s.forEach(function(t){for(var e=0,n=t.length;e!==n;)t[e][0]&&(y.push(t[e][0]+" "),v.push(t[e][1])),++e}),s=this.splitFragmentsIntoLines(w(y),v),h("ET","Q"),h("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td")}}return t&&"function"==typeof t&&t.call(this,this.x-9,this.y-p/2),h("ET","Q"),this.y+=u}},f.prototype.setBlockBoundary=function(t){return this.renderParagraph(t)},f.prototype.setBlockStyle=function(t){return this.paragraph.blockstyle=t},f.prototype.addText=function(t,e){return this.paragraph.text.push(t),this.paragraph.style.push(e)},i={helvetica:"helvetica","sans-serif":"helvetica","times new roman":"times",serif:"times",times:"times",monospace:"courier",courier:"courier"},l={100:"normal",200:"normal",300:"normal",400:"normal",500:"bold",600:"bold",700:"bold",800:"bold",900:"bold",normal:"normal",bold:"bold",bolder:"bold",lighter:"normal"},a={normal:"normal",italic:"italic",oblique:"italic"},s={left:"left",right:"right",center:"center",justify:"justify"},h={none:"none",right:"right",left:"left"},u={none:"none",both:"both"},n={normal:1},t.fromHTML=function(t,e,n,r,i,o){return this.margins_doc=o||{top:0,bottom:0},r||(r={}),r.elementHandlers||(r.elementHandlers={}),m(this,t,isNaN(e)?4:e,isNaN(n)?4:n,r,i)}}(lt.API),lt.API,("undefined"!=typeof window&&window||"undefined"!=typeof global&&global).html2pdf=function(t,a,e){var n=a.canvas;if(n){var r,i;if((n.pdf=a).annotations={_nameMap:[],createAnnotation:function(t,e){var n,r=a.context2d._wrapX(e.left),i=a.context2d._wrapY(e.top),o=(a.context2d._page(e.top),t.indexOf("#"));n=0<=o?{name:t.substring(o+1)}:{url:t},a.link(r,i,e.right-e.left,e.bottom-e.top,n)},setName:function(t,e){var n=a.context2d._wrapX(e.left),r=a.context2d._wrapY(e.top),i=a.context2d._page(e.top);this._nameMap[t]={page:i,x:n,y:r}}},n.annotations=a.annotations,a.context2d._pageBreakAt=function(t){this.pageBreaks.push(t)},a.context2d._gotoPage=function(t){for(;a.internal.getNumberOfPages()<t;)a.addPage();a.setPage(t)},"string"==typeof t){t=t.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,"");var o,s,l=document.createElement("iframe");document.body.appendChild(l),null!=(o=l.contentDocument)&&null!=o||(o=l.contentWindow.document),o.open(),o.write(t),o.close(),r=o.body,s=o.body||{},t=o.documentElement||{},i=Math.max(s.scrollHeight,s.offsetHeight,t.clientHeight,t.scrollHeight,t.offsetHeight)}else s=(r=t).body||{},i=Math.max(s.scrollHeight,s.offsetHeight,t.clientHeight,t.scrollHeight,t.offsetHeight);var h={async:!0,allowTaint:!0,backgroundColor:"#ffffff",canvas:n,imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1,windowHeight:i=a.internal.pageSize.getHeight(),scrollY:i};a.context2d.pageWrapYEnabled=!0,a.context2d.pageWrapY=a.internal.pageSize.getHeight(),html2canvas(r,h).then(function(t){e&&(l&&l.parentElement.removeChild(l),e(a))})}else alert("jsPDF canvas plugin not installed")},window.tmp=html2pdf,function(f){var r=f.BlobBuilder||f.WebKitBlobBuilder||f.MSBlobBuilder||f.MozBlobBuilder;f.URL=f.URL||f.webkitURL||function(t,e){return(e=document.createElement("a")).href=t,e};var n=f.Blob,p=URL.createObjectURL,d=URL.revokeObjectURL,o=f.Symbol&&f.Symbol.toStringTag,t=!1,e=!1,g=!!f.ArrayBuffer,i=r&&r.prototype.append&&r.prototype.getBlob;try{t=2===new Blob(["ä"]).size,e=2===new Blob([new Uint8Array([1,2])]).size}catch(t){}function a(t){return t.map(function(t){if(t.buffer instanceof ArrayBuffer){var e=t.buffer;if(t.byteLength!==e.byteLength){var n=new Uint8Array(t.byteLength);n.set(new Uint8Array(e,t.byteOffset,t.byteLength)),e=n.buffer}return e}return t})}function s(t,e){e=e||{};var n=new r;return a(t).forEach(function(t){n.append(t)}),e.type?n.getBlob(e.type):n.getBlob()}function l(t,e){return new n(a(t),e||{})}if(f.Blob&&(s.prototype=Blob.prototype,l.prototype=Blob.prototype),o)try{File.prototype[o]="File",Blob.prototype[o]="Blob",FileReader.prototype[o]="FileReader"}catch(t){}function h(){var t=!!f.ActiveXObject||"-ms-scroll-limit"in document.documentElement.style&&"-ms-ime-align"in document.documentElement.style,e=f.XMLHttpRequest&&f.XMLHttpRequest.prototype.send;t&&e&&(XMLHttpRequest.prototype.send=function(t){t instanceof Blob&&this.setRequestHeader("Content-Type",t.type),e.call(this,t)});try{new File([],"")}catch(t){try{var n=new Function('class File extends Blob {constructor(chunks, name, opts) {opts = opts || {};super(chunks, opts || {});this.name = name;this.lastModifiedDate = opts.lastModified ? new Date(opts.lastModified) : new Date;this.lastModified = +this.lastModifiedDate;}};return new File([], ""), File')();f.File=n}catch(t){n=function(t,e,n){var r=new Blob(t,n),i=n&&void 0!==n.lastModified?new Date(n.lastModified):new Date;return r.name=e,r.lastModifiedDate=i,r.lastModified=+i,r.toString=function(){return"[object File]"},o&&(r[o]="File"),r};f.File=n}}}t?(h(),f.Blob=e?f.Blob:l):i?(h(),f.Blob=s):function(){function a(t){for(var e=[],n=0;n<t.length;n++){var r=t.charCodeAt(n);r<128?e.push(r):r<2048?e.push(192|r>>6,128|63&r):r<55296||57344<=r?e.push(224|r>>12,128|r>>6&63,128|63&r):(n++,r=65536+((1023&r)<<10|1023&t.charCodeAt(n)),e.push(240|r>>18,128|r>>12&63,128|r>>6&63,128|63&r))}return e}function e(t){var e,n,r,i,o,a;for(e="",r=t.length,n=0;n<r;)switch((i=t[n++])>>4){case 0:case 1:case 2:case 3:case 4:case 5:case 6:case 7:e+=String.fromCharCode(i);break;case 12:case 13:o=t[n++],e+=String.fromCharCode((31&i)<<6|63&o);break;case 14:o=t[n++],a=t[n++],e+=String.fromCharCode((15&i)<<12|(63&o)<<6|(63&a)<<0)}return e}function s(t){for(var e=new Array(t.byteLength),n=new Uint8Array(t),r=e.length;r--;)e[r]=n[r];return e}function n(t){for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",n=[],r=0;r<t.length;r+=3){var i=t[r],o=r+1<t.length,a=o?t[r+1]:0,s=r+2<t.length,l=s?t[r+2]:0,h=i>>2,u=(3&i)<<4|a>>4,c=(15&a)<<2|l>>6,f=63&l;s||(f=64,o||(c=64)),n.push(e[h],e[u],e[c],e[f])}return n.join("")}var t=Object.create||function(t){function e(){}return e.prototype=t,new e};if(g)var r=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],l=ArrayBuffer.isView||function(t){return t&&-1<r.indexOf(Object.prototype.toString.call(t))};function h(t,e){for(var n=0,r=(t=t||[]).length;n<r;n++){var i=t[n];i instanceof h?t[n]=i._buffer:"string"==typeof i?t[n]=a(i):g&&(ArrayBuffer.prototype.isPrototypeOf(i)||l(i))?t[n]=s(i):g&&(o=i)&&DataView.prototype.isPrototypeOf(o)?t[n]=s(i.buffer):t[n]=a(String(i))}var o;this._buffer=[].concat.apply([],t),this.size=this._buffer.length,this.type=e&&e.type||""}function i(t,e,n){var r=h.call(this,t,n=n||{})||this;return r.name=e,r.lastModifiedDate=n.lastModified?new Date(n.lastModified):new Date,r.lastModified=+r.lastModifiedDate,r}if(h.prototype.slice=function(t,e,n){return new h([this._buffer.slice(t||0,e||this._buffer.length)],{type:n})},h.prototype.toString=function(){return"[object Blob]"},(i.prototype=t(h.prototype)).constructor=i,Object.setPrototypeOf)Object.setPrototypeOf(i,h);else try{i.__proto__=h}catch(t){}function o(){if(!(this instanceof o))throw new TypeError("Failed to construct 'FileReader': Please use the 'new' operator, this DOM object constructor cannot be called as a function.");var n=document.createDocumentFragment();this.addEventListener=n.addEventListener,this.dispatchEvent=function(t){var e=this["on"+t.type];"function"==typeof e&&e(t),n.dispatchEvent(t)},this.removeEventListener=n.removeEventListener}function u(t,e,n){if(!(e instanceof h))throw new TypeError("Failed to execute '"+n+"' on 'FileReader': parameter 1 is not of type 'Blob'.");t.result="",setTimeout(function(){this.readyState=o.LOADING,t.dispatchEvent(new Event("load")),t.dispatchEvent(new Event("loadend"))})}i.prototype.toString=function(){return"[object File]"},o.EMPTY=0,o.LOADING=1,o.DONE=2,o.prototype.error=null,o.prototype.onabort=null,o.prototype.onerror=null,o.prototype.onload=null,o.prototype.onloadend=null,o.prototype.onloadstart=null,o.prototype.onprogress=null,o.prototype.readAsDataURL=function(t){u(this,t,"readAsDataURL"),this.result="data:"+t.type+";base64,"+n(t._buffer)},o.prototype.readAsText=function(t){u(this,t,"readAsText"),this.result=e(t._buffer)},o.prototype.readAsArrayBuffer=function(t){u(this,t,"readAsText"),this.result=t._buffer.slice()},o.prototype.abort=function(){},URL.createObjectURL=function(t){return t instanceof h?"data:"+t.type+";base64,"+n(t._buffer):p.call(URL,t)},URL.revokeObjectURL=function(t){d&&d.call(URL,t)};var c=f.XMLHttpRequest&&f.XMLHttpRequest.prototype.send;c&&(XMLHttpRequest.prototype.send=function(t){t instanceof h?(this.setRequestHeader("Content-Type",t.type),c.call(this,e(t._buffer))):c.call(this,t)}),f.FileReader=o,f.File=i,f.Blob=h}()}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());var ht,ut,ct,ft,pt,dt,gt,mt,yt,vt,wt,bt,xt,Nt,Lt,le=le||function(s){if(!(void 0===s||"undefined"!=typeof navigator&&/MSIE [1-9]\./.test(navigator.userAgent))){var t=s.document,l=function(){return s.URL||s.webkitURL||s},h=t.createElementNS("http://www.w3.org/1999/xhtml","a"),u="download"in h,c=/constructor/i.test(s.HTMLElement)||s.safari,f=/CriOS\/[\d]+/.test(navigator.userAgent),p=s.setImmediate||s.setTimeout,d=function(t){p(function(){throw t},0)},g=function(t){setTimeout(function(){"string"==typeof t?l().revokeObjectURL(t):t.remove()},4e4)},m=function(t){return/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type)?new Blob([String.fromCharCode(65279),t],{type:t.type}):t},r=function(t,n,e){e||(t=m(t));var r,i=this,o="application/octet-stream"===t.type,a=function(){!function(t,e,n){for(var r=(e=[].concat(e)).length;r--;){var i=t["on"+e[r]];if("function"==typeof i)try{i.call(t,n||t)}catch(t){d(t)}}}(i,"writestart progress write writeend".split(" "))};if(i.readyState=i.INIT,u)return r=l().createObjectURL(t),void p(function(){var t,e;h.href=r,h.download=n,t=h,e=new MouseEvent("click"),t.dispatchEvent(e),a(),g(r),i.readyState=i.DONE},0);!function(){if((f||o&&c)&&s.FileReader){var e=new FileReader;return e.onloadend=function(){var t=f?e.result:e.result.replace(/^data:[^;]*;/,"data:attachment/file;");s.open(t,"_blank")||(s.location.href=t),t=void 0,i.readyState=i.DONE,a()},e.readAsDataURL(t),i.readyState=i.INIT}r||(r=l().createObjectURL(t)),o?s.location.href=r:s.open(r,"_blank")||(s.location.href=r);i.readyState=i.DONE,a(),g(r)}()},e=r.prototype;return"undefined"!=typeof navigator&&navigator.msSaveOrOpenBlob?function(t,e,n){return e=e||t.name||"download",n||(t=m(t)),navigator.msSaveOrOpenBlob(t,e)}:(e.abort=function(){},e.readyState=e.INIT=0,e.WRITING=1,e.DONE=2,e.error=e.onwritestart=e.onprogress=e.onwrite=e.onabort=e.onerror=e.onwriteend=null,function(t,e,n){return new r(t,e||t.name||"download",n)})}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||void 0);function At(x){var t=0;if(71!==x[t++]||73!==x[t++]||70!==x[t++]||56!==x[t++]||56!=(x[t++]+1&253)||97!==x[t++])throw"Invalid GIF 87a/89a header.";var N=x[t++]|x[t++]<<8,e=x[t++]|x[t++]<<8,n=x[t++],r=n>>7,i=1<<(7&n)+1;x[t++];x[t++];var o=null;r&&(o=t,t+=3*i);var a=!0,s=[],l=0,h=null,u=0,c=null;for(this.width=N,this.height=e;a&&t<x.length;)switch(x[t++]){case 33:switch(x[t++]){case 255:if(11!==x[t]||78==x[t+1]&&69==x[t+2]&&84==x[t+3]&&83==x[t+4]&&67==x[t+5]&&65==x[t+6]&&80==x[t+7]&&69==x[t+8]&&50==x[t+9]&&46==x[t+10]&&48==x[t+11]&&3==x[t+12]&&1==x[t+13]&&0==x[t+16])t+=14,c=x[t++]|x[t++]<<8,t++;else for(t+=12;;){if(0===(A=x[t++]))break;t+=A}break;case 249:if(4!==x[t++]||0!==x[t+4])throw"Invalid graphics extension block.";var f=x[t++];l=x[t++]|x[t++]<<8,h=x[t++],0==(1&f)&&(h=null),u=f>>2&7,t++;break;case 254:for(;;){if(0===(A=x[t++]))break;t+=A}break;default:throw"Unknown graphic control label: 0x"+x[t-1].toString(16)}break;case 44:var p=x[t++]|x[t++]<<8,d=x[t++]|x[t++]<<8,g=x[t++]|x[t++]<<8,m=x[t++]|x[t++]<<8,y=x[t++],v=y>>6&1,w=o,b=!1;if(y>>7){b=!0;w=t,t+=3*(1<<(7&y)+1)}var L=t;for(t++;;){var A;if(0===(A=x[t++]))break;t+=A}s.push({x:p,y:d,width:g,height:m,has_local_palette:b,palette_offset:w,data_offset:L,data_length:t-L,transparent_index:h,interlaced:!!v,delay:l,disposal:u});break;case 59:a=!1;break;default:throw"Unknown gif block: 0x"+x[t-1].toString(16)}this.numFrames=function(){return s.length},this.loopCount=function(){return c},this.frameInfo=function(t){if(t<0||t>=s.length)throw"Frame index out of range.";return s[t]},this.decodeAndBlitFrameBGRA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);St(x,n.data_offset,i,r);var o=n.palette_offset,a=n.transparent_index;null===a&&(a=256);var s=n.width,l=N-s,h=s,u=4*(n.y*N+n.x),c=4*((n.y+n.height)*N+n.x),f=u,p=4*l;!0===n.interlaced&&(p+=4*(s+l)*7);for(var d=8,g=0,m=i.length;g<m;++g){var y=i[g];if(0===h&&(h=s,c<=(f+=p)&&(p=l+4*(s+l)*(d-1),f=u+(s+l)*(d<<1),d>>=1)),y===a)f+=4;else{var v=x[o+3*y],w=x[o+3*y+1],b=x[o+3*y+2];e[f++]=b,e[f++]=w,e[f++]=v,e[f++]=255}--h}},this.decodeAndBlitFrameRGBA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);St(x,n.data_offset,i,r);var o=n.palette_offset,a=n.transparent_index;null===a&&(a=256);var s=n.width,l=N-s,h=s,u=4*(n.y*N+n.x),c=4*((n.y+n.height)*N+n.x),f=u,p=4*l;!0===n.interlaced&&(p+=4*(s+l)*7);for(var d=8,g=0,m=i.length;g<m;++g){var y=i[g];if(0===h&&(h=s,c<=(f+=p)&&(p=l+4*(s+l)*(d-1),f=u+(s+l)*(d<<1),d>>=1)),y===a)f+=4;else{var v=x[o+3*y],w=x[o+3*y+1],b=x[o+3*y+2];e[f++]=v,e[f++]=w,e[f++]=b,e[f++]=255}--h}}}function St(t,e,n,r){for(var i=t[e++],o=1<<i,a=o+1,s=a+1,l=i+1,h=(1<<l)-1,u=0,c=0,f=0,p=t[e++],d=new Int32Array(4096),g=null;;){for(;u<16&&0!==p;)c|=t[e++]<<u,u+=8,1===p?p=t[e++]:--p;if(u<l)break;var m=c&h;if(c>>=l,u-=l,m!==o){if(m===a)break;for(var y=m<s?m:g,v=0,w=y;o<w;)w=d[w]>>8,++v;var b=w;if(r<f+v+(y!==m?1:0))return void console.log("Warning, gif stream longer than expected.");n[f++]=b;var x=f+=v;for(y!==m&&(n[f++]=b),w=y;v--;)w=d[w],n[--x]=255&w,w>>=8;null!==g&&s<4096&&(d[s++]=g<<8|b,h+1<=s&&l<12&&(++l,h=h<<1|1)),g=m}else s=a+1,h=(1<<(l=i+1))-1,g=null}return f!==r&&console.log("Warning, gif stream shorter than expected."),n}try{exports.GifWriter=function(y,t,e,n){var v=0,r=void 0===(n=void 0===n?{}:n).loop?null:n.loop,w=void 0===n.palette?null:n.palette;if(t<=0||e<=0||65535<t||65535<e)throw"Width/Height invalid.";function b(t){var e=t.length;if(e<2||256<e||e&e-1)throw"Invalid code/color length, must be power of 2 and 2 .. 256.";return e}y[v++]=71,y[v++]=73,y[v++]=70,y[v++]=56,y[v++]=57,y[v++]=97;var i=0,o=0;if(null!==w){for(var a=b(w);a>>=1;)++i;if(a=1<<i,--i,void 0!==n.background){if(a<=(o=n.background))throw"Background index out of range.";if(0===o)throw"Background index explicitly passed as 0."}}if(y[v++]=255&t,y[v++]=t>>8&255,y[v++]=255&e,y[v++]=e>>8&255,y[v++]=(null!==w?128:0)|i,y[v++]=o,y[v++]=0,null!==w)for(var s=0,l=w.length;s<l;++s){var h=w[s];y[v++]=h>>16&255,y[v++]=h>>8&255,y[v++]=255&h}if(null!==r){if(r<0||65535<r)throw"Loop count invalid.";y[v++]=33,y[v++]=255,y[v++]=11,y[v++]=78,y[v++]=69,y[v++]=84,y[v++]=83,y[v++]=67,y[v++]=65,y[v++]=80,y[v++]=69,y[v++]=50,y[v++]=46,y[v++]=48,y[v++]=3,y[v++]=1,y[v++]=255&r,y[v++]=r>>8&255,y[v++]=0}var x=!1;this.addFrame=function(t,e,n,r,i,o){if(!0===x&&(--v,x=!1),o=void 0===o?{}:o,t<0||e<0||65535<t||65535<e)throw"x/y invalid.";if(n<=0||r<=0||65535<n||65535<r)throw"Width/Height invalid.";if(i.length<n*r)throw"Not enough pixels for the frame size.";var a=!0,s=o.palette;if(null==s&&(a=!1,s=w),null==s)throw"Must supply either a local or global palette.";for(var l=b(s),h=0;l>>=1;)++h;l=1<<h;var u=void 0===o.delay?0:o.delay,c=void 0===o.disposal?0:o.disposal;if(c<0||3<c)throw"Disposal out of range.";var f=!1,p=0;if(void 0!==o.transparent&&null!==o.transparent&&(f=!0,(p=o.transparent)<0||l<=p))throw"Transparent color index.";if((0!==c||f||0!==u)&&(y[v++]=33,y[v++]=249,y[v++]=4,y[v++]=c<<2|(!0===f?1:0),y[v++]=255&u,y[v++]=u>>8&255,y[v++]=p,y[v++]=0),y[v++]=44,y[v++]=255&t,y[v++]=t>>8&255,y[v++]=255&e,y[v++]=e>>8&255,y[v++]=255&n,y[v++]=n>>8&255,y[v++]=255&r,y[v++]=r>>8&255,y[v++]=!0===a?128|h-1:0,!0===a)for(var d=0,g=s.length;d<g;++d){var m=s[d];y[v++]=m>>16&255,y[v++]=m>>8&255,y[v++]=255&m}v=function(e,n,t,r){e[n++]=t;var i=n++,o=1<<t,a=o-1,s=o+1,l=s+1,h=t+1,u=0,c=0;function f(t){for(;t<=u;)e[n++]=255&c,c>>=8,u-=8,n===i+256&&(e[i]=255,i=n++)}function p(t){c|=t<<u,u+=h,f(8)}var d=r[0]&a,g={};p(o);for(var m=1,y=r.length;m<y;++m){var v=r[m]&a,w=d<<8|v,b=g[w];if(void 0===b){for(c|=d<<u,u+=h;8<=u;)e[n++]=255&c,c>>=8,u-=8,n===i+256&&(e[i]=255,i=n++);4096===l?(p(o),l=s+1,h=t+1,g={}):(1<<h<=l&&++h,g[w]=l++),d=v}else d=b}return p(d),p(s),f(1),i+1===n?e[i]=0:(e[i]=n-i-1,e[n++]=0),n}(y,v,h<2?2:h,i)},this.end=function(){return!1===x&&(y[v++]=59,x=!0),v}},exports.GifReader=At}catch(t){}
/*
    Copyright (c) 2008, Adobe Systems Incorporated
    All rights reserved.

    Redistribution and use in source and binary forms, with or without 
    modification, are permitted provided that the following conditions are
    met:

    * Redistributions of source code must retain the above copyright notice, 
      this list of conditions and the following disclaimer.
    
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the 
      documentation and/or other materials provided with the distribution.
    
    * Neither the name of Adobe Systems Incorporated nor the names of its 
      contributors may be used to endorse or promote products derived from 
      this software without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
    IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
    THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
    PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
    CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
    EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
    PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
    PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
    LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
    NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
    SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */
function _t(t){var N,L,A,S,e,c=Math.floor,_=new Array(64),F=new Array(64),P=new Array(64),k=new Array(64),y=new Array(65535),v=new Array(65535),Z=new Array(64),w=new Array(64),I=[],C=0,B=7,j=new Array(64),E=new Array(64),M=new Array(64),n=new Array(256),O=new Array(2048),b=[0,1,5,6,14,15,27,28,2,4,7,13,16,26,29,42,3,8,12,17,25,30,41,43,9,11,18,24,31,40,44,53,10,19,23,32,39,45,52,54,20,22,33,38,46,51,55,60,21,34,37,47,50,56,59,61,35,36,48,49,57,58,62,63],q=[0,0,1,5,1,1,1,1,1,1,0,0,0,0,0,0,0],T=[0,1,2,3,4,5,6,7,8,9,10,11],R=[0,0,2,1,3,3,2,4,3,5,5,4,4,0,0,1,125],D=[1,2,3,0,4,17,5,18,33,49,65,6,19,81,97,7,34,113,20,50,129,145,161,8,35,66,177,193,21,82,209,240,36,51,98,114,130,9,10,22,23,24,25,26,37,38,39,40,41,42,52,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,225,226,227,228,229,230,231,232,233,234,241,242,243,244,245,246,247,248,249,250],U=[0,0,3,1,1,1,1,1,1,1,1,1,0,0,0,0,0],z=[0,1,2,3,4,5,6,7,8,9,10,11],H=[0,0,2,1,2,4,4,3,4,7,5,4,4,0,1,2,119],W=[0,1,2,3,17,4,5,33,49,6,18,65,81,7,97,113,19,34,50,129,8,20,66,145,161,177,193,9,35,51,82,240,21,98,114,209,10,22,36,52,225,37,241,23,24,25,26,38,39,40,41,42,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,130,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,226,227,228,229,230,231,232,233,234,242,243,244,245,246,247,248,249,250];function r(t,e){for(var n=0,r=0,i=new Array,o=1;o<=16;o++){for(var a=1;a<=t[o];a++)i[e[r]]=[],i[e[r]][0]=n,i[e[r]][1]=o,r++,n++;n*=2}return i}function V(t){for(var e=t[0],n=t[1]-1;0<=n;)e&1<<n&&(C|=1<<B),n--,--B<0&&(255==C?(G(255),G(0)):G(C),B=7,C=0)}function G(t){I.push(t)}function Y(t){G(t>>8&255),G(255&t)}function J(t,e,n,r,i){for(var o,a=i[0],s=i[240],l=function(t,e){var n,r,i,o,a,s,l,h,u,c,f=0;for(u=0;u<8;++u){n=t[f],r=t[f+1],i=t[f+2],o=t[f+3],a=t[f+4],s=t[f+5],l=t[f+6];var p=n+(h=t[f+7]),d=n-h,g=r+l,m=r-l,y=i+s,v=i-s,w=o+a,b=o-a,x=p+w,N=p-w,L=g+y,A=g-y;t[f]=x+L,t[f+4]=x-L;var S=.707106781*(A+N);t[f+2]=N+S,t[f+6]=N-S;var _=.382683433*((x=b+v)-(A=m+d)),F=.5411961*x+_,P=1.306562965*A+_,k=.707106781*(L=v+m),I=d+k,C=d-k;t[f+5]=C+F,t[f+3]=C-F,t[f+1]=I+P,t[f+7]=I-P,f+=8}for(u=f=0;u<8;++u){n=t[f],r=t[f+8],i=t[f+16],o=t[f+24],a=t[f+32],s=t[f+40],l=t[f+48];var B=n+(h=t[f+56]),j=n-h,E=r+l,M=r-l,O=i+s,q=i-s,T=o+a,R=o-a,D=B+T,U=B-T,z=E+O,H=E-O;t[f]=D+z,t[f+32]=D-z;var W=.707106781*(H+U);t[f+16]=U+W,t[f+48]=U-W;var V=.382683433*((D=R+q)-(H=M+j)),G=.5411961*D+V,Y=1.306562965*H+V,J=.707106781*(z=q+M),X=j+J,K=j-J;t[f+40]=K+G,t[f+24]=K-G,t[f+8]=X+Y,t[f+56]=X-Y,f++}for(u=0;u<64;++u)c=t[u]*e[u],Z[u]=0<c?c+.5|0:c-.5|0;return Z}(t,e),h=0;h<64;++h)w[b[h]]=l[h];var u=w[0]-n;n=w[0],0==u?V(r[0]):(V(r[v[o=32767+u]]),V(y[o]));for(var c=63;0<c&&0==w[c];c--);if(0==c)return V(a),n;for(var f,p=1;p<=c;){for(var d=p;0==w[p]&&p<=c;++p);var g=p-d;if(16<=g){f=g>>4;for(var m=1;m<=f;++m)V(s);g&=15}o=32767+w[p],V(i[(g<<4)+v[o]]),V(y[o]),p++}return 63!=c&&V(a),n}function X(t){if(t<=0&&(t=1),100<t&&(t=100),e!=t){(function(t){for(var e=[16,11,10,16,24,40,51,61,12,12,14,19,26,58,60,55,14,13,16,24,40,57,69,56,14,17,22,29,51,87,80,62,18,22,37,56,68,109,103,77,24,35,55,64,81,104,113,92,49,64,78,87,103,121,120,101,72,92,95,98,112,100,103,99],n=0;n<64;n++){var r=c((e[n]*t+50)/100);r<1?r=1:255<r&&(r=255),_[b[n]]=r}for(var i=[17,18,24,47,99,99,99,99,18,21,26,66,99,99,99,99,24,26,56,99,99,99,99,99,47,66,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99],o=0;o<64;o++){var a=c((i[o]*t+50)/100);a<1?a=1:255<a&&(a=255),F[b[o]]=a}for(var s=[1,1.387039845,1.306562965,1.175875602,1,.785694958,.5411961,.275899379],l=0,h=0;h<8;h++)for(var u=0;u<8;u++)P[l]=1/(_[b[l]]*s[h]*s[u]*8),k[l]=1/(F[b[l]]*s[h]*s[u]*8),l++})(t<50?Math.floor(5e3/t):Math.floor(200-2*t)),e=t}}this.encode=function(t,e){var n,r;(new Date).getTime();e&&X(e),I=new Array,C=0,B=7,Y(65496),Y(65504),Y(16),G(74),G(70),G(73),G(70),G(0),G(1),G(1),G(0),Y(1),Y(1),G(0),G(0),function(){Y(65499),Y(132),G(0);for(var t=0;t<64;t++)G(_[t]);G(1);for(var e=0;e<64;e++)G(F[e])}(),n=t.width,r=t.height,Y(65472),Y(17),G(8),Y(r),Y(n),G(3),G(1),G(17),G(0),G(2),G(17),G(1),G(3),G(17),G(1),function(){Y(65476),Y(418),G(0);for(var t=0;t<16;t++)G(q[t+1]);for(var e=0;e<=11;e++)G(T[e]);G(16);for(var n=0;n<16;n++)G(R[n+1]);for(var r=0;r<=161;r++)G(D[r]);G(1);for(var i=0;i<16;i++)G(U[i+1]);for(var o=0;o<=11;o++)G(z[o]);G(17);for(var a=0;a<16;a++)G(H[a+1]);for(var s=0;s<=161;s++)G(W[s])}(),Y(65498),Y(12),G(3),G(1),G(0),G(2),G(17),G(3),G(17),G(0),G(63),G(0);var i=0,o=0,a=0;C=0,B=7,this.encode.displayName="_encode_";for(var s,l,h,u,c,f,p,d,g,m=t.data,y=t.width,v=t.height,w=4*y,b=0;b<v;){for(s=0;s<w;){for(f=c=w*b+s,p=-1,g=d=0;g<64;g++)f=c+(d=g>>3)*w+(p=4*(7&g)),v<=b+d&&(f-=w*(b+1+d-v)),w<=s+p&&(f-=s+p-w+4),l=m[f++],h=m[f++],u=m[f++],j[g]=(O[l]+O[h+256>>0]+O[u+512>>0]>>16)-128,E[g]=(O[l+768>>0]+O[h+1024>>0]+O[u+1280>>0]>>16)-128,M[g]=(O[l+1280>>0]+O[h+1536>>0]+O[u+1792>>0]>>16)-128;i=J(j,P,i,N,A),o=J(E,k,o,L,S),a=J(M,k,a,L,S),s+=32}b+=8}if(0<=B){var x=[];x[1]=B+1,x[0]=(1<<B+1)-1,V(x)}return Y(65497),new Uint8Array(I)},function(){(new Date).getTime();t||(t=50),function(){for(var t=String.fromCharCode,e=0;e<256;e++)n[e]=t(e)}(),N=r(q,T),L=r(U,z),A=r(R,D),S=r(H,W),function(){for(var t=1,e=2,n=1;n<=15;n++){for(var r=t;r<e;r++)v[32767+r]=n,y[32767+r]=[],y[32767+r][1]=n,y[32767+r][0]=r;for(var i=-(e-1);i<=-t;i++)v[32767+i]=n,y[32767+i]=[],y[32767+i][1]=n,y[32767+i][0]=e-1+i;t<<=1,e<<=1}}(),function(){for(var t=0;t<256;t++)O[t]=19595*t,O[t+256>>0]=38470*t,O[t+512>>0]=7471*t+32768,O[t+768>>0]=-11059*t,O[t+1024>>0]=-21709*t,O[t+1280>>0]=32768*t+8421375,O[t+1536>>0]=-27439*t,O[t+1792>>0]=-5329*t}(),X(t),(new Date).getTime()}()}function Ft(t,e){if(this.pos=0,this.buffer=t,this.datav=new DataView(t.buffer),this.is_with_alpha=!!e,this.bottom_up=!0,this.flag=String.fromCharCode(this.buffer[0])+String.fromCharCode(this.buffer[1]),this.pos+=2,-1===["BM","BA","CI","CP","IC","PT"].indexOf(this.flag))throw new Error("Invalid BMP File");this.parseHeader(),this.parseBGR()}window.tmp=At,lt.API.adler32cs=(dt="function"==typeof ArrayBuffer&&"function"==typeof Uint8Array,gt=null,mt=function(){if(!dt)return function(){return!1};try{var t={};"function"==typeof t.Buffer&&(gt=t.Buffer)}catch(t){}return function(t){return t instanceof ArrayBuffer||null!==gt&&t instanceof gt}}(),yt=null!==gt?function(t){return new gt(t,"utf8").toString("binary")}:function(t){return unescape(encodeURIComponent(t))},vt=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+(255&e.charCodeAt(i)))%65521,r=(r+n)%65521;return(r<<16|n)>>>0},wt=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+e[i])%65521,r=(r+n)%65521;return(r<<16|n)>>>0},xt=(bt={}).Adler32=(((pt=(ft=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(!isFinite(t=null==t?1:+t))throw new Error("First arguments needs to be a finite number.");this.checksum=t>>>0}).prototype={}).constructor=ft).from=((ht=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");this.checksum=vt(1,t.toString())}).prototype=pt,ht),ft.fromUtf8=((ut=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");var e=yt(t.toString());this.checksum=vt(1,e)}).prototype=pt,ut),dt&&(ft.fromBuffer=((ct=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(!mt(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=wt(1,e)}).prototype=pt,ct)),pt.update=function(t){if(null==t)throw new Error("First argument needs to be a string.");return t=t.toString(),this.checksum=vt(this.checksum,t)},pt.updateUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=yt(t.toString());return this.checksum=vt(this.checksum,e)},dt&&(pt.updateBuffer=function(t){if(!mt(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=wt(this.checksum,e)}),pt.clone=function(){return new xt(this.checksum)},ft),bt.from=function(t){if(null==t)throw new Error("First argument needs to be a string.");return vt(1,t.toString())},bt.fromUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=yt(t.toString());return vt(1,e)},dt&&(bt.fromBuffer=function(t){if(!mt(t))throw new Error("First argument need to be ArrayBuffer.");var e=new Uint8Array(t);return wt(1,e)}),bt),function(t){t.__bidiEngine__=t.prototype.__bidiEngine__=function(t){var d,g,c,f,i,o,a,s=e,m=[[0,3,0,1,0,0,0],[0,3,0,1,2,2,0],[0,3,0,17,2,0,1],[0,3,5,5,4,1,0],[0,3,21,21,4,0,1],[0,3,5,5,4,2,0]],y=[[2,0,1,1,0,1,0],[2,0,1,1,0,2,0],[2,0,2,1,3,2,0],[2,0,2,33,3,1,1]],v={L:0,R:1,EN:2,AN:3,N:4,B:5,S:6},l={0:0,5:1,6:2,7:3,32:4,251:5,254:6,255:7},h=["(",")","(","<",">","<","[","]","[","{","}","{","«","»","«","‹","›","‹","⁅","⁆","⁅","⁽","⁾","⁽","₍","₎","₍","≤","≥","≤","〈","〉","〈","﹙","﹚","﹙","﹛","﹜","﹛","﹝","﹞","﹝","﹤","﹥","﹤"],u=new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/),w=!1,b=0;this.__bidiEngine__={};var x=function(t){var e=t.charCodeAt(),n=e>>8,r=l[n];return void 0!==r?s[256*r+(255&e)]:252===n||253===n?"AL":u.test(n)?"L":8===n?"R":"N"},p=function(t){for(var e,n=0;n<t.length;n++){if("L"===(e=x(t.charAt(n))))return!1;if("R"===e)return!0}return!1},N=function(t,e,n,r){var i,o,a,s,l=e[r];switch(l){case"L":case"R":w=!1;break;case"N":case"AN":break;case"EN":w&&(l="AN");break;case"AL":w=!0,l="R";break;case"WS":l="N";break;case"CS":r<1||r+1>=e.length||"EN"!==(i=n[r-1])&&"AN"!==i||"EN"!==(o=e[r+1])&&"AN"!==o?l="N":w&&(o="AN"),l=o===i?o:"N";break;case"ES":l="EN"===(i=0<r?n[r-1]:"B")&&r+1<e.length&&"EN"===e[r+1]?"EN":"N";break;case"ET":if(0<r&&"EN"===n[r-1]){l="EN";break}if(w){l="N";break}for(a=r+1,s=e.length;a<s&&"ET"===e[a];)a++;l=a<s&&"EN"===e[a]?"EN":"N";break;case"NSM":if(c&&!f){for(s=e.length,a=r+1;a<s&&"NSM"===e[a];)a++;if(a<s){var h=t[r],u=1425<=h&&h<=2303||64286===h;if(i=e[a],u&&("R"===i||"AL"===i)){l="R";break}}}l=r<1||"B"===(i=e[r-1])?"N":n[r-1];break;case"B":d=!(w=!1),l=b;break;case"S":g=!0,l="N";break;case"LRE":case"RLE":case"LRO":case"RLO":case"PDF":w=!1;break;case"BN":l="N"}return l},L=function(t,e,n){var r=t.split("");return n&&A(r,n,{hiLevel:b}),r.reverse(),e&&e.reverse(),r.join("")},A=function(t,e,n){var r,i,o,a,s,l=-1,h=t.length,u=0,c=[],f=b?y:m,p=[];for(g=d=w=!1,i=0;i<h;i++)p[i]=x(t[i]);for(o=0;o<h;o++){if(s=u,c[o]=N(t,p,c,o),r=240&(u=f[s][v[c[o]]]),u&=15,e[o]=a=f[u][5],0<r)if(16===r){for(i=l;i<o;i++)e[i]=1;l=-1}else l=-1;if(f[u][6])-1===l&&(l=o);else if(-1<l){for(i=l;i<o;i++)e[i]=a;l=-1}"B"===p[o]&&(e[o]=0),n.hiLevel|=a}g&&function(t,e,n){for(var r=0;r<n;r++)if("S"===t[r]){e[r]=b;for(var i=r-1;0<=i&&"WS"===t[i];i--)e[i]=b}}(p,e,h)},S=function(t,e,n,r,i){if(!(i.hiLevel<t)){if(1===t&&1===b&&!d)return e.reverse(),void(n&&n.reverse());for(var o,a,s,l,h=e.length,u=0;u<h;){if(r[u]>=t){for(s=u+1;s<h&&r[s]>=t;)s++;for(l=u,a=s-1;l<a;l++,a--)o=e[l],e[l]=e[a],e[a]=o,n&&(o=n[l],n[l]=n[a],n[a]=o);u=s}u++}}},_=function(t,e,n){var r=t.split(""),i={hiLevel:b};return n||(n=[]),A(r,n,i),function(t,e,n){if(0!==n.hiLevel&&a)for(var r,i=0;i<t.length;i++)1===e[i]&&0<=(r=h.indexOf(t[i]))&&(t[i]=h[r+1])}(r,n,i),S(2,r,e,n,i),S(1,r,e,n,i),r.join("")};return this.__bidiEngine__.doBidiReorder=function(t,e,n){if(function(t,e){if(e)for(var n=0;n<t.length;n++)e[n]=n;void 0===f&&(f=p(t)),void 0===o&&(o=p(t))}(t,e),c||!i||o)if(c&&i&&f^o)b=f?1:0,t=L(t,e,n);else if(!c&&i&&o)b=f?1:0,t=_(t,e,n),t=L(t,e);else if(!c||f||i||o){if(c&&!i&&f^o)t=L(t,e),t=f?(b=0,_(t,e,n)):(b=1,t=_(t,e,n),L(t,e));else if(c&&f&&!i&&o)b=1,t=_(t,e,n),t=L(t,e);else if(!c&&!i&&f^o){var r=a;f?(b=1,t=_(t,e,n),b=0,a=!1,t=_(t,e,n),a=r):(b=0,t=_(t,e,n),t=L(t,e),a=!(b=1),t=_(t,e,n),a=r,t=L(t,e))}}else b=0,t=_(t,e,n);else b=f?1:0,t=_(t,e,n);return t},this.__bidiEngine__.setOptions=function(t){t&&(c=t.isInputVisual,i=t.isOutputVisual,f=t.isInputRtl,o=t.isOutputRtl,a=t.isSymmetricSwapping)},this.__bidiEngine__.setOptions(t),this.__bidiEngine__};var e=["BN","BN","BN","BN","BN","BN","BN","BN","BN","S","B","S","WS","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","B","B","B","S","WS","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","BN","BN","BN","BN","BN","BN","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","CS","N","ET","ET","ET","ET","N","N","N","N","L","N","N","BN","N","N","ET","ET","EN","EN","N","L","N","N","N","EN","L","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","N","N","N","N","N","ET","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","NSM","R","NSM","NSM","R","NSM","NSM","R","NSM","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","N","N","N","N","N","R","R","R","R","R","N","N","N","N","N","N","N","N","N","N","N","AN","AN","AN","AN","AN","AN","N","N","AL","ET","ET","AL","CS","AL","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","AN","AN","AN","AN","AN","AN","AN","AN","AN","ET","AN","AN","AL","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","N","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","NSM","NSM","N","NSM","NSM","NSM","NSM","AL","AL","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","R","N","N","N","N","R","N","N","N","N","N","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","BN","BN","BN","L","R","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","B","LRE","RLE","PDF","LRO","RLO","CS","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","BN","BN","BN","BN","BN","N","LRI","RLI","FSI","PDI","BN","BN","BN","BN","BN","BN","EN","L","N","N","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","L","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","N","N","N","N","N","R","NSM","R","R","R","R","R","R","R","R","R","R","ES","R","R","R","R","R","R","R","R","R","R","R","R","R","N","R","R","R","R","R","N","R","N","R","R","N","R","R","N","R","R","R","R","R","R","R","R","R","R","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","CS","N","N","CS","N","N","N","N","N","N","N","N","N","ET","N","N","ES","ES","N","N","N","N","N","ET","ET","N","N","N","N","N","AL","AL","AL","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","BN","N","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","N","N","N","ET","ET","N","N","N","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N"],o=new t.__bidiEngine__({isInputVisual:!0});t.API.events.push(["postProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),r=(t.mutex,n.lang,[]);if("[object Array]"===Object.prototype.toString.call(e)){var i=0;for(r=[],i=0;i<e.length;i+=1)"[object Array]"===Object.prototype.toString.call(e[i])?r.push([o.doBidiReorder(e[i][0]),e[i][1],e[i][2]]):r.push([o.doBidiReorder(e[i])]);t.text=r}else t.text=o.doBidiReorder(e)}])}(lt),window.tmp=_t,Ft.prototype.parseHeader=function(){if(this.fileSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.reserved=this.datav.getUint32(this.pos,!0),this.pos+=4,this.offset=this.datav.getUint32(this.pos,!0),this.pos+=4,this.headerSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.width=this.datav.getUint32(this.pos,!0),this.pos+=4,this.height=this.datav.getInt32(this.pos,!0),this.pos+=4,this.planes=this.datav.getUint16(this.pos,!0),this.pos+=2,this.bitPP=this.datav.getUint16(this.pos,!0),this.pos+=2,this.compress=this.datav.getUint32(this.pos,!0),this.pos+=4,this.rawSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.hr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.vr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.colors=this.datav.getUint32(this.pos,!0),this.pos+=4,this.importantColors=this.datav.getUint32(this.pos,!0),this.pos+=4,16===this.bitPP&&this.is_with_alpha&&(this.bitPP=15),this.bitPP<15){var t=0===this.colors?1<<this.bitPP:this.colors;this.palette=new Array(t);for(var e=0;e<t;e++){var n=this.datav.getUint8(this.pos++,!0),r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0);this.palette[e]={red:i,green:r,blue:n,quad:o}}}this.height<0&&(this.height*=-1,this.bottom_up=!1)},Ft.prototype.parseBGR=function(){this.pos=this.offset;try{var t="bit"+this.bitPP,e=this.width*this.height*4;this.data=new Uint8Array(e),this[t]()}catch(t){console.log("bit decode error:"+t)}},Ft.prototype.bit1=function(){var t=Math.ceil(this.width/8),e=t%4,n=0<=this.height?this.height-1:-this.height;for(n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<t;i++)for(var o=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+8*i*4,s=0;s<8&&8*i+s<this.width;s++){var l=this.palette[o>>7-s&1];this.data[a+4*s]=l.blue,this.data[a+4*s+1]=l.green,this.data[a+4*s+2]=l.red,this.data[a+4*s+3]=255}0!=e&&(this.pos+=4-e)}},Ft.prototype.bit4=function(){for(var t=Math.ceil(this.width/2),e=t%4,n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<t;i++){var o=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+2*i*4,s=o>>4,l=15&o,h=this.palette[s];if(this.data[a]=h.blue,this.data[a+1]=h.green,this.data[a+2]=h.red,this.data[a+3]=255,2*i+1>=this.width)break;h=this.palette[l],this.data[a+4]=h.blue,this.data[a+4+1]=h.green,this.data[a+4+2]=h.red,this.data[a+4+3]=255}0!=e&&(this.pos+=4-e)}},Ft.prototype.bit8=function(){for(var t=this.width%4,e=this.height-1;0<=e;e--){for(var n=this.bottom_up?e:this.height-1-e,r=0;r<this.width;r++){var i=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+4*r;if(i<this.palette.length){var a=this.palette[i];this.data[o]=a.red,this.data[o+1]=a.green,this.data[o+2]=a.blue,this.data[o+3]=255}else this.data[o]=255,this.data[o+1]=255,this.data[o+2]=255,this.data[o+3]=255}0!=t&&(this.pos+=4-t)}},Ft.prototype.bit15=function(){for(var t=this.width%3,e=parseInt("11111",2),n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<this.width;i++){var o=this.datav.getUint16(this.pos,!0);this.pos+=2;var a=(o&e)/e*255|0,s=(o>>5&e)/e*255|0,l=(o>>10&e)/e*255|0,h=o>>15?255:0,u=r*this.width*4+4*i;this.data[u]=l,this.data[u+1]=s,this.data[u+2]=a,this.data[u+3]=h}this.pos+=t}},Ft.prototype.bit16=function(){for(var t=this.width%3,e=parseInt("11111",2),n=parseInt("111111",2),r=this.height-1;0<=r;r--){for(var i=this.bottom_up?r:this.height-1-r,o=0;o<this.width;o++){var a=this.datav.getUint16(this.pos,!0);this.pos+=2;var s=(a&e)/e*255|0,l=(a>>5&n)/n*255|0,h=(a>>11)/e*255|0,u=i*this.width*4+4*o;this.data[u]=h,this.data[u+1]=l,this.data[u+2]=s,this.data[u+3]=255}this.pos+=t}},Ft.prototype.bit24=function(){for(var t=this.height-1;0<=t;t--){for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),a=e*this.width*4+4*n;this.data[a]=o,this.data[a+1]=i,this.data[a+2]=r,this.data[a+3]=255}this.pos+=this.width%4}},Ft.prototype.bit32=function(){for(var t=this.height-1;0<=t;t--)for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),s=e*this.width*4+4*n;this.data[s]=o,this.data[s+1]=i,this.data[s+2]=r,this.data[s+3]=a}},Ft.prototype.getData=function(){return this.data},window.tmp=Ft,
/*
   Copyright (c) 2013 Gildas Lormeau. All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:

   1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

   2. Redistributions in binary form must reproduce the above copyright 
   notice, this list of conditions and the following disclaimer in 
   the documentation and/or other materials provided with the distribution.

   3. The names of the authors may not be used to endorse or promote products
   derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */
function(t){var d=15,g=573,e=[0,1,2,3,4,4,5,5,6,6,6,6,7,7,7,7,8,8,8,8,8,8,8,8,9,9,9,9,9,9,9,9,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,0,0,16,17,18,18,19,19,20,20,20,20,21,21,21,21,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29];function ct(){var p=this;function l(t,e){for(var n=0;n|=1&t,t>>>=1,n<<=1,0<--e;);return n>>>1}p.build_tree=function(t){var e,n,r,i=p.dyn_tree,o=p.stat_desc.static_tree,a=p.stat_desc.elems,s=-1;for(t.heap_len=0,t.heap_max=g,e=0;e<a;e++)0!==i[2*e]?(t.heap[++t.heap_len]=s=e,t.depth[e]=0):i[2*e+1]=0;for(;t.heap_len<2;)i[2*(r=t.heap[++t.heap_len]=s<2?++s:0)]=1,t.depth[r]=0,t.opt_len--,o&&(t.static_len-=o[2*r+1]);for(p.max_code=s,e=Math.floor(t.heap_len/2);1<=e;e--)t.pqdownheap(i,e);for(r=a;e=t.heap[1],t.heap[1]=t.heap[t.heap_len--],t.pqdownheap(i,1),n=t.heap[1],t.heap[--t.heap_max]=e,t.heap[--t.heap_max]=n,i[2*r]=i[2*e]+i[2*n],t.depth[r]=Math.max(t.depth[e],t.depth[n])+1,i[2*e+1]=i[2*n+1]=r,t.heap[1]=r++,t.pqdownheap(i,1),2<=t.heap_len;);t.heap[--t.heap_max]=t.heap[1],function(t){var e,n,r,i,o,a,s=p.dyn_tree,l=p.stat_desc.static_tree,h=p.stat_desc.extra_bits,u=p.stat_desc.extra_base,c=p.stat_desc.max_length,f=0;for(i=0;i<=d;i++)t.bl_count[i]=0;for(s[2*t.heap[t.heap_max]+1]=0,e=t.heap_max+1;e<g;e++)c<(i=s[2*s[2*(n=t.heap[e])+1]+1]+1)&&(i=c,f++),s[2*n+1]=i,n>p.max_code||(t.bl_count[i]++,o=0,u<=n&&(o=h[n-u]),a=s[2*n],t.opt_len+=a*(i+o),l&&(t.static_len+=a*(l[2*n+1]+o)));if(0!==f){do{for(i=c-1;0===t.bl_count[i];)i--;t.bl_count[i]--,t.bl_count[i+1]+=2,t.bl_count[c]--,f-=2}while(0<f);for(i=c;0!==i;i--)for(n=t.bl_count[i];0!==n;)(r=t.heap[--e])>p.max_code||(s[2*r+1]!=i&&(t.opt_len+=(i-s[2*r+1])*s[2*r],s[2*r+1]=i),n--)}}(t),function(t,e,n){var r,i,o,a=[],s=0;for(r=1;r<=d;r++)a[r]=s=s+n[r-1]<<1;for(i=0;i<=e;i++)0!==(o=t[2*i+1])&&(t[2*i]=l(a[o]++,o))}(i,p.max_code,t.bl_count)}}function ft(t,e,n,r,i){this.static_tree=t,this.extra_bits=e,this.extra_base=n,this.elems=r,this.max_length=i}ct._length_code=[0,1,2,3,4,5,6,7,8,8,9,9,10,10,11,11,12,12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,16,16,16,16,17,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28],ct.base_length=[0,1,2,3,4,5,6,7,8,10,12,14,16,20,24,28,32,40,48,56,64,80,96,112,128,160,192,224,0],ct.base_dist=[0,1,2,3,4,6,8,12,16,24,32,48,64,96,128,192,256,384,512,768,1024,1536,2048,3072,4096,6144,8192,12288,16384,24576],ct.d_code=function(t){return t<256?e[t]:e[256+(t>>>7)]},ct.extra_lbits=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],ct.extra_dbits=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],ct.extra_blbits=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],ct.bl_order=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],ft.static_ltree=[12,8,140,8,76,8,204,8,44,8,172,8,108,8,236,8,28,8,156,8,92,8,220,8,60,8,188,8,124,8,252,8,2,8,130,8,66,8,194,8,34,8,162,8,98,8,226,8,18,8,146,8,82,8,210,8,50,8,178,8,114,8,242,8,10,8,138,8,74,8,202,8,42,8,170,8,106,8,234,8,26,8,154,8,90,8,218,8,58,8,186,8,122,8,250,8,6,8,134,8,70,8,198,8,38,8,166,8,102,8,230,8,22,8,150,8,86,8,214,8,54,8,182,8,118,8,246,8,14,8,142,8,78,8,206,8,46,8,174,8,110,8,238,8,30,8,158,8,94,8,222,8,62,8,190,8,126,8,254,8,1,8,129,8,65,8,193,8,33,8,161,8,97,8,225,8,17,8,145,8,81,8,209,8,49,8,177,8,113,8,241,8,9,8,137,8,73,8,201,8,41,8,169,8,105,8,233,8,25,8,153,8,89,8,217,8,57,8,185,8,121,8,249,8,5,8,133,8,69,8,197,8,37,8,165,8,101,8,229,8,21,8,149,8,85,8,213,8,53,8,181,8,117,8,245,8,13,8,141,8,77,8,205,8,45,8,173,8,109,8,237,8,29,8,157,8,93,8,221,8,61,8,189,8,125,8,253,8,19,9,275,9,147,9,403,9,83,9,339,9,211,9,467,9,51,9,307,9,179,9,435,9,115,9,371,9,243,9,499,9,11,9,267,9,139,9,395,9,75,9,331,9,203,9,459,9,43,9,299,9,171,9,427,9,107,9,363,9,235,9,491,9,27,9,283,9,155,9,411,9,91,9,347,9,219,9,475,9,59,9,315,9,187,9,443,9,123,9,379,9,251,9,507,9,7,9,263,9,135,9,391,9,71,9,327,9,199,9,455,9,39,9,295,9,167,9,423,9,103,9,359,9,231,9,487,9,23,9,279,9,151,9,407,9,87,9,343,9,215,9,471,9,55,9,311,9,183,9,439,9,119,9,375,9,247,9,503,9,15,9,271,9,143,9,399,9,79,9,335,9,207,9,463,9,47,9,303,9,175,9,431,9,111,9,367,9,239,9,495,9,31,9,287,9,159,9,415,9,95,9,351,9,223,9,479,9,63,9,319,9,191,9,447,9,127,9,383,9,255,9,511,9,0,7,64,7,32,7,96,7,16,7,80,7,48,7,112,7,8,7,72,7,40,7,104,7,24,7,88,7,56,7,120,7,4,7,68,7,36,7,100,7,20,7,84,7,52,7,116,7,3,8,131,8,67,8,195,8,35,8,163,8,99,8,227,8],ft.static_dtree=[0,5,16,5,8,5,24,5,4,5,20,5,12,5,28,5,2,5,18,5,10,5,26,5,6,5,22,5,14,5,30,5,1,5,17,5,9,5,25,5,5,5,21,5,13,5,29,5,3,5,19,5,11,5,27,5,7,5,23,5],ft.static_l_desc=new ft(ft.static_ltree,ct.extra_lbits,257,286,d),ft.static_d_desc=new ft(ft.static_dtree,ct.extra_dbits,0,30,d),ft.static_bl_desc=new ft(null,ct.extra_blbits,0,19,7);function n(t,e,n,r,i){this.good_length=t,this.max_lazy=e,this.nice_length=n,this.max_chain=r,this.func=i}var pt=[new n(0,0,0,0,0),new n(4,4,8,4,1),new n(4,5,16,8,1),new n(4,6,32,32,1),new n(4,4,16,16,2),new n(8,16,32,32,2),new n(8,16,128,128,2),new n(8,32,128,256,2),new n(32,128,258,1024,2),new n(32,258,258,4096,2)],dt=["need dictionary","stream end","","","stream error","data error","","buffer error","",""];function gt(t,e,n,r){var i=t[2*e],o=t[2*n];return i<o||i==o&&r[e]<=r[n]}function r(){var l,h,u,c,f,p,d,g,i,m,y,v,w,a,b,x,N,L,A,S,_,F,P,k,I,C,B,j,E,M,s,O,q,T,R,D,U,o,z,H,W,V=this,G=new ct,Y=new ct,J=new ct;function X(){var t;for(t=0;t<286;t++)s[2*t]=0;for(t=0;t<30;t++)O[2*t]=0;for(t=0;t<19;t++)q[2*t]=0;s[512]=1,V.opt_len=V.static_len=0,D=o=0}function K(t,e){var n,r,i=-1,o=t[1],a=0,s=7,l=4;for(0===o&&(s=138,l=3),t[2*(e+1)+1]=65535,n=0;n<=e;n++)r=o,o=t[2*(n+1)+1],++a<s&&r==o||(a<l?q[2*r]+=a:0!==r?(r!=i&&q[2*r]++,q[32]++):a<=10?q[34]++:q[36]++,i=r,l=(a=0)===o?(s=138,3):r==o?(s=6,3):(s=7,4))}function Z(t){V.pending_buf[V.pending++]=t}function Q(t){Z(255&t),Z(t>>>8&255)}function $(t,e){var n,r=e;16-r<W?(Q(H|=(n=t)<<W&65535),H=n>>>16-W,W+=r-16):(H|=t<<W&65535,W+=r)}function tt(t,e){var n=2*t;$(65535&e[n],65535&e[n+1])}function et(t,e){var n,r,i=-1,o=t[1],a=0,s=7,l=4;for(0===o&&(s=138,l=3),n=0;n<=e;n++)if(r=o,o=t[2*(n+1)+1],!(++a<s&&r==o)){if(a<l)for(;tt(r,q),0!=--a;);else 0!==r?(r!=i&&(tt(r,q),a--),tt(16,q),$(a-3,2)):a<=10?(tt(17,q),$(a-3,3)):(tt(18,q),$(a-11,7));i=r,l=(a=0)===o?(s=138,3):r==o?(s=6,3):(s=7,4)}}function nt(){16==W?(Q(H),W=H=0):8<=W&&(Z(255&H),H>>>=8,W-=8)}function rt(t,e){var n,r,i;if(V.pending_buf[U+2*D]=t>>>8&255,V.pending_buf[U+2*D+1]=255&t,V.pending_buf[T+D]=255&e,D++,0===t?s[2*e]++:(o++,t--,s[2*(ct._length_code[e]+256+1)]++,O[2*ct.d_code(t)]++),0==(8191&D)&&2<B){for(n=8*D,r=_-N,i=0;i<30;i++)n+=O[2*i]*(5+ct.extra_dbits[i]);if(n>>>=3,o<Math.floor(D/2)&&n<Math.floor(r/2))return!0}return D==R-1}function it(t,e){var n,r,i,o,a=0;if(0!==D)for(;n=V.pending_buf[U+2*a]<<8&65280|255&V.pending_buf[U+2*a+1],r=255&V.pending_buf[T+a],a++,0===n?tt(r,t):(tt((i=ct._length_code[r])+256+1,t),0!==(o=ct.extra_lbits[i])&&$(r-=ct.base_length[i],o),tt(i=ct.d_code(--n),e),0!==(o=ct.extra_dbits[i])&&$(n-=ct.base_dist[i],o)),a<D;);tt(256,t),z=t[513]}function ot(){8<W?Q(H):0<W&&Z(255&H),W=H=0}function at(t,e,n){var r,i,o;$(0+(n?1:0),3),r=t,i=e,o=!0,ot(),z=8,o&&(Q(i),Q(~i)),V.pending_buf.set(g.subarray(r,r+i),V.pending),V.pending+=i}function e(t,e,n){var r,i,o=0;0<B?(G.build_tree(V),Y.build_tree(V),o=function(){var t;for(K(s,G.max_code),K(O,Y.max_code),J.build_tree(V),t=18;3<=t&&0===q[2*ct.bl_order[t]+1];t--);return V.opt_len+=3*(t+1)+5+5+4,t}(),r=V.opt_len+3+7>>>3,(i=V.static_len+3+7>>>3)<=r&&(r=i)):r=i=e+5,e+4<=r&&-1!=t?at(t,e,n):i==r?($(2+(n?1:0),3),it(ft.static_ltree,ft.static_dtree)):($(4+(n?1:0),3),function(t,e,n){var r;for($(t-257,5),$(e-1,5),$(n-4,4),r=0;r<n;r++)$(q[2*ct.bl_order[r]+1],3);et(s,t-1),et(O,e-1)}(G.max_code+1,Y.max_code+1,o+1),it(s,O)),X(),n&&ot()}function st(t){e(0<=N?N:-1,_-N,t),N=_,l.flush_pending()}function lt(){var t,e,n,r;do{if(0===(r=i-P-_)&&0===_&&0===P)r=f;else if(-1==r)r--;else if(f+f-262<=_){for(g.set(g.subarray(f,f+f),0),F-=f,_-=f,N-=f,n=t=w;e=65535&y[--n],y[n]=f<=e?e-f:0,0!=--t;);for(n=t=f;e=65535&m[--n],m[n]=f<=e?e-f:0,0!=--t;);r+=f}if(0===l.avail_in)return;t=l.read_buf(g,_+P,r),3<=(P+=t)&&(v=((v=255&g[_])<<x^255&g[_+1])&b)}while(P<262&&0!==l.avail_in)}function ht(t){var e,n,r=I,i=_,o=k,a=f-262<_?_-(f-262):0,s=M,l=d,h=_+258,u=g[i+o-1],c=g[i+o];E<=k&&(r>>=2),P<s&&(s=P);do{if(g[(e=t)+o]==c&&g[e+o-1]==u&&g[e]==g[i]&&g[++e]==g[i+1]){i+=2,e++;do{}while(g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&i<h);if(n=258-(h-i),i=h-258,o<n){if(F=t,s<=(o=n))break;u=g[i+o-1],c=g[i+o]}}}while((t=65535&m[t&l])>a&&0!=--r);return o<=P?o:P}function ut(t){return t.total_in=t.total_out=0,t.msg=null,V.pending=0,V.pending_out=0,h=113,c=0,G.dyn_tree=s,G.stat_desc=ft.static_l_desc,Y.dyn_tree=O,Y.stat_desc=ft.static_d_desc,J.dyn_tree=q,J.stat_desc=ft.static_bl_desc,W=H=0,z=8,X(),function(){var t;for(i=2*f,t=y[w-1]=0;t<w-1;t++)y[t]=0;C=pt[B].max_lazy,E=pt[B].good_length,M=pt[B].nice_length,I=pt[B].max_chain,L=k=2,v=S=P=N=_=0}(),0}V.depth=[],V.bl_count=[],V.heap=[],s=[],O=[],q=[],V.pqdownheap=function(t,e){for(var n=V.heap,r=n[e],i=e<<1;i<=V.heap_len&&(i<V.heap_len&&gt(t,n[i+1],n[i],V.depth)&&i++,!gt(t,r,n[i],V.depth));)n[e]=n[i],e=i,i<<=1;n[e]=r},V.deflateInit=function(t,e,n,r,i,o){return r||(r=8),i||(i=8),o||(o=0),t.msg=null,-1==e&&(e=6),i<1||9<i||8!=r||n<9||15<n||e<0||9<e||o<0||2<o?-2:(t.dstate=V,d=(f=1<<(p=n))-1,b=(w=1<<(a=i+7))-1,x=Math.floor((a+3-1)/3),g=new Uint8Array(2*f),m=[],y=[],R=1<<i+6,V.pending_buf=new Uint8Array(4*R),u=4*R,U=Math.floor(R/2),T=3*R,B=e,j=o,ut(t))},V.deflateEnd=function(){return 42!=h&&113!=h&&666!=h?-2:(V.pending_buf=null,g=m=y=null,V.dstate=null,113==h?-3:0)},V.deflateParams=function(t,e,n){var r=0;return-1==e&&(e=6),e<0||9<e||n<0||2<n?-2:(pt[B].func!=pt[e].func&&0!==t.total_in&&(r=t.deflate(1)),B!=e&&(C=pt[B=e].max_lazy,E=pt[B].good_length,M=pt[B].nice_length,I=pt[B].max_chain),j=n,r)},V.deflateSetDictionary=function(t,e,n){var r,i=n,o=0;if(!e||42!=h)return-2;if(i<3)return 0;for(f-262<i&&(o=n-(i=f-262)),g.set(e.subarray(o,o+i),0),N=_=i,v=((v=255&g[0])<<x^255&g[1])&b,r=0;r<=i-3;r++)v=(v<<x^255&g[r+2])&b,m[r&d]=y[v],y[v]=r;return 0},V.deflate=function(t,e){var n,r,i,o,a,s;if(4<e||e<0)return-2;if(!t.next_out||!t.next_in&&0!==t.avail_in||666==h&&4!=e)return t.msg=dt[4],-2;if(0===t.avail_out)return t.msg=dt[7],-5;if(l=t,o=c,c=e,42==h&&(r=8+(p-8<<4)<<8,3<(i=(B-1&255)>>1)&&(i=3),r|=i<<6,0!==_&&(r|=32),h=113,Z((s=r+=31-r%31)>>8&255),Z(255&s)),0!==V.pending){if(l.flush_pending(),0===l.avail_out)return c=-1,0}else if(0===l.avail_in&&e<=o&&4!=e)return l.msg=dt[7],-5;if(666==h&&0!==l.avail_in)return t.msg=dt[7],-5;if(0!==l.avail_in||0!==P||0!=e&&666!=h){switch(a=-1,pt[B].func){case 0:a=function(t){var e,n=65535;for(u-5<n&&(n=u-5);;){if(P<=1){if(lt(),0===P&&0==t)return 0;if(0===P)break}if(_+=P,e=N+n,((P=0)===_||e<=_)&&(P=_-e,_=e,st(!1),0===l.avail_out))return 0;if(f-262<=_-N&&(st(!1),0===l.avail_out))return 0}return st(4==t),0===l.avail_out?4==t?2:0:4==t?3:1}(e);break;case 1:a=function(t){for(var e,n=0;;){if(P<262){if(lt(),P<262&&0==t)return 0;if(0===P)break}if(3<=P&&(v=(v<<x^255&g[_+2])&b,n=65535&y[v],m[_&d]=y[v],y[v]=_),0!==n&&(_-n&65535)<=f-262&&2!=j&&(L=ht(n)),3<=L)if(e=rt(_-F,L-3),P-=L,L<=C&&3<=P){for(L--;v=(v<<x^255&g[++_+2])&b,n=65535&y[v],m[_&d]=y[v],y[v]=_,0!=--L;);_++}else _+=L,L=0,v=((v=255&g[_])<<x^255&g[_+1])&b;else e=rt(0,255&g[_]),P--,_++;if(e&&(st(!1),0===l.avail_out))return 0}return st(4==t),0===l.avail_out?4==t?2:0:4==t?3:1}(e);break;case 2:a=function(t){for(var e,n,r=0;;){if(P<262){if(lt(),P<262&&0==t)return 0;if(0===P)break}if(3<=P&&(v=(v<<x^255&g[_+2])&b,r=65535&y[v],m[_&d]=y[v],y[v]=_),k=L,A=F,L=2,0!==r&&k<C&&(_-r&65535)<=f-262&&(2!=j&&(L=ht(r)),L<=5&&(1==j||3==L&&4096<_-F)&&(L=2)),3<=k&&L<=k){for(n=_+P-3,e=rt(_-1-A,k-3),P-=k-1,k-=2;++_<=n&&(v=(v<<x^255&g[_+2])&b,r=65535&y[v],m[_&d]=y[v],y[v]=_),0!=--k;);if(S=0,L=2,_++,e&&(st(!1),0===l.avail_out))return 0}else if(0!==S){if((e=rt(0,255&g[_-1]))&&st(!1),_++,P--,0===l.avail_out)return 0}else S=1,_++,P--}return 0!==S&&(e=rt(0,255&g[_-1]),S=0),st(4==t),0===l.avail_out?4==t?2:0:4==t?3:1}(e)}if(2!=a&&3!=a||(h=666),0==a||2==a)return 0===l.avail_out&&(c=-1),0;if(1==a){if(1==e)$(2,3),tt(256,ft.static_ltree),nt(),1+z+10-W<9&&($(2,3),tt(256,ft.static_ltree),nt()),z=7;else if(at(0,0,!1),3==e)for(n=0;n<w;n++)y[n]=0;if(l.flush_pending(),0===l.avail_out)return c=-1,0}}return 4!=e?0:1}}function i(){this.next_in_index=0,this.next_out_index=0,this.avail_in=0,this.total_in=0,this.avail_out=0,this.total_out=0}i.prototype={deflateInit:function(t,e){return this.dstate=new r,e||(e=d),this.dstate.deflateInit(this,t,e)},deflate:function(t){return this.dstate?this.dstate.deflate(this,t):-2},deflateEnd:function(){if(!this.dstate)return-2;var t=this.dstate.deflateEnd();return this.dstate=null,t},deflateParams:function(t,e){return this.dstate?this.dstate.deflateParams(this,t,e):-2},deflateSetDictionary:function(t,e){return this.dstate?this.dstate.deflateSetDictionary(this,t,e):-2},read_buf:function(t,e,n){var r=this.avail_in;return n<r&&(r=n),0===r?0:(this.avail_in-=r,t.set(this.next_in.subarray(this.next_in_index,this.next_in_index+r),e),this.next_in_index+=r,this.total_in+=r,r)},flush_pending:function(){var t=this,e=t.dstate.pending;e>t.avail_out&&(e=t.avail_out),0!==e&&(t.next_out.set(t.dstate.pending_buf.subarray(t.dstate.pending_out,t.dstate.pending_out+e),t.next_out_index),t.next_out_index+=e,t.dstate.pending_out+=e,t.total_out+=e,t.avail_out-=e,t.dstate.pending-=e,0===t.dstate.pending&&(t.dstate.pending_out=0))}};var o=t.zip||t;o.Deflater=o._jzlib_Deflater=function(t){var s=new i,l=new Uint8Array(512),e=t?t.level:-1;void 0===e&&(e=-1),s.deflateInit(e),s.next_out=l,this.append=function(t,e){var n,r=[],i=0,o=0,a=0;if(t.length){s.next_in_index=0,s.next_in=t,s.avail_in=t.length;do{if(s.next_out_index=0,s.avail_out=512,0!=s.deflate(0))throw new Error("deflating: "+s.msg);s.next_out_index&&(512==s.next_out_index?r.push(new Uint8Array(l)):r.push(new Uint8Array(l.subarray(0,s.next_out_index)))),a+=s.next_out_index,e&&0<s.next_in_index&&s.next_in_index!=i&&(e(s.next_in_index),i=s.next_in_index)}while(0<s.avail_in||0===s.avail_out);return n=new Uint8Array(a),r.forEach(function(t){n.set(t,o),o+=t.length}),n}},this.flush=function(){var t,e,n=[],r=0,i=0;do{if(s.next_out_index=0,s.avail_out=512,1!=(t=s.deflate(4))&&0!=t)throw new Error("deflating: "+s.msg);0<512-s.avail_out&&n.push(new Uint8Array(l.subarray(0,s.next_out_index))),i+=s.next_out_index}while(0<s.avail_in||0===s.avail_out);return s.deflateEnd(),e=new Uint8Array(i),n.forEach(function(t){e.set(t,r),r+=t.length}),e}}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()).RGBColor=function(t){var e;t=t||"",this.ok=!1,"#"==t.charAt(0)&&(t=t.substr(1,6)),t=(t=t.replace(/ /g,"")).toLowerCase();var n={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"00ffff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000000",blanchedalmond:"ffebcd",blue:"0000ff",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"00ffff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dodgerblue:"1e90ff",feldspar:"d19275",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"ff00ff",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgrey:"d3d3d3",lightgreen:"90ee90",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslateblue:"8470ff",lightslategray:"778899",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"00ff00",limegreen:"32cd32",linen:"faf0e6",magenta:"ff00ff",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370d8",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"d87093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",red:"ff0000",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",violetred:"d02090",wheat:"f5deb3",white:"ffffff",whitesmoke:"f5f5f5",yellow:"ffff00",yellowgreen:"9acd32"};for(var r in n)t==r&&(t=n[r]);for(var i=[{re:/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,example:["rgb(123, 234, 45)","rgb(255,234,245)"],process:function(t){return[parseInt(t[1]),parseInt(t[2]),parseInt(t[3])]}},{re:/^(\w{2})(\w{2})(\w{2})$/,example:["#00ff00","336699"],process:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/^(\w{1})(\w{1})(\w{1})$/,example:["#fb0","f0f"],process:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}}],o=0;o<i.length;o++){var a=i[o].re,s=i[o].process,l=a.exec(t);l&&(e=s(l),this.r=e[0],this.g=e[1],this.b=e[2],this.ok=!0)}this.r=this.r<0||isNaN(this.r)?0:255<this.r?255:this.r,this.g=this.g<0||isNaN(this.g)?0:255<this.g?255:this.g,this.b=this.b<0||isNaN(this.b)?0:255<this.b?255:this.b,this.toRGB=function(){return"rgb("+this.r+", "+this.g+", "+this.b+")"},this.toHex=function(){var t=this.r.toString(16),e=this.g.toString(16),n=this.b.toString(16);return 1==t.length&&(t="0"+t),1==e.length&&(e="0"+e),1==n.length&&(n="0"+n),"#"+t+e+n}},function(t){var n="+".charCodeAt(0),r="/".charCodeAt(0),i="0".charCodeAt(0),o="a".charCodeAt(0),a="A".charCodeAt(0),s="-".charCodeAt(0),l="_".charCodeAt(0),u=function(t){var e=t.charCodeAt(0);return e===n||e===s?62:e===r||e===l?63:e<i?-1:e<i+10?e-i+26+26:e<a+26?e-a:e<o+26?e-o+26:void 0};t.API.TTFFont=function(){function i(t,e,n){var r;if(this.rawData=t,r=this.contents=new J(t),this.contents.pos=4,"ttcf"===r.readString(4)){if(!e)throw new Error("Must specify a font name for TTC files.");throw new Error("Font "+e+" not found in TTC file.")}r.pos=0,this.parse(),this.subset=new P(this),this.registerTTF()}return i.open=function(t,e,n,r){if("string"!=typeof n)throw new Error("Invalid argument supplied in TTFFont.open");return new i(function(t){var e,n,r,i,o,a;if(0<t.length%4)throw new Error("Invalid string. Length must be a multiple of 4");var s=t.length;o="="===t.charAt(s-2)?2:"="===t.charAt(s-1)?1:0,a=new Uint8Array(3*t.length/4-o),r=0<o?t.length-4:t.length;var l=0;function h(t){a[l++]=t}for(n=e=0;e<r;e+=4,n+=3)h((16711680&(i=u(t.charAt(e))<<18|u(t.charAt(e+1))<<12|u(t.charAt(e+2))<<6|u(t.charAt(e+3))))>>16),h((65280&i)>>8),h(255&i);return 2===o?h(255&(i=u(t.charAt(e))<<2|u(t.charAt(e+1))>>4)):1===o&&(h((i=u(t.charAt(e))<<10|u(t.charAt(e+1))<<4|u(t.charAt(e+2))>>2)>>8&255),h(255&i)),a}(n),e,r)},i.prototype.parse=function(){return this.directory=new e(this.contents),this.head=new p(this),this.name=new b(this),this.cmap=new y(this),this.toUnicode=new Map,this.hhea=new g(this),this.maxp=new x(this),this.hmtx=new N(this),this.post=new v(this),this.os2=new m(this),this.loca=new F(this),this.glyf=new A(this),this.ascender=this.os2.exists&&this.os2.ascender||this.hhea.ascender,this.decender=this.os2.exists&&this.os2.decender||this.hhea.decender,this.lineGap=this.os2.exists&&this.os2.lineGap||this.hhea.lineGap,this.bbox=[this.head.xMin,this.head.yMin,this.head.xMax,this.head.yMax]},i.prototype.registerTTF=function(){var i,t,e,n,r;if(this.scaleFactor=1e3/this.head.unitsPerEm,this.bbox=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.bbox).length;t<e;t++)i=n[t],r.push(Math.round(i*this.scaleFactor));return r}.call(this),this.stemV=0,this.post.exists?(e=255&(n=this.post.italic_angle),!0&(t=n>>16)&&(t=-(1+(65535^t))),this.italicAngle=+(t+"."+e)):this.italicAngle=0,this.ascender=Math.round(this.ascender*this.scaleFactor),this.decender=Math.round(this.decender*this.scaleFactor),this.lineGap=Math.round(this.lineGap*this.scaleFactor),this.capHeight=this.os2.exists&&this.os2.capHeight||this.ascender,this.xHeight=this.os2.exists&&this.os2.xHeight||0,this.familyClass=(this.os2.exists&&this.os2.familyClass||0)>>8,this.isSerif=1===(r=this.familyClass)||2===r||3===r||4===r||5===r||7===r,this.isScript=10===this.familyClass,this.flags=0,this.post.isFixedPitch&&(this.flags|=1),this.isSerif&&(this.flags|=2),this.isScript&&(this.flags|=8),0!==this.italicAngle&&(this.flags|=64),this.flags|=32,!this.cmap.unicode)throw new Error("No unicode cmap for font")},i.prototype.characterToGlyph=function(t){var e;return(null!=(e=this.cmap.unicode)?e.codeMap[t]:void 0)||0},i.prototype.widthOfGlyph=function(t){var e;return e=1e3/this.head.unitsPerEm,this.hmtx.forGlyph(t).advance*e},i.prototype.widthOfString=function(t,e,n){var r,i,o,a,s;for(i=a=o=0,s=(t=""+t).length;0<=s?a<s:s<a;i=0<=s?++a:--a)r=t.charCodeAt(i),o+=this.widthOfGlyph(this.characterToGlyph(r))+n*(1e3/e)||0;return o*(e/1e3)},i.prototype.lineHeight=function(t,e){var n;return null==e&&(e=!1),n=e?this.lineGap:0,(this.ascender+n-this.decender)/1e3*t},i}();var h,J=function(){function t(t){this.data=null!=t?t:[],this.pos=0,this.length=this.data.length}return t.prototype.readByte=function(){return this.data[this.pos++]},t.prototype.writeByte=function(t){return this.data[this.pos++]=t},t.prototype.readUInt32=function(){return 16777216*this.readByte()+(this.readByte()<<16)+(this.readByte()<<8)+this.readByte()},t.prototype.writeUInt32=function(t){return this.writeByte(t>>>24&255),this.writeByte(t>>16&255),this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt32=function(){var t;return 2147483648<=(t=this.readUInt32())?t-4294967296:t},t.prototype.writeInt32=function(t){return t<0&&(t+=4294967296),this.writeUInt32(t)},t.prototype.readUInt16=function(){return this.readByte()<<8|this.readByte()},t.prototype.writeUInt16=function(t){return this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt16=function(){var t;return 32768<=(t=this.readUInt16())?t-65536:t},t.prototype.writeInt16=function(t){return t<0&&(t+=65536),this.writeUInt16(t)},t.prototype.readString=function(t){var e,n,r;for(n=[],e=r=0;0<=t?r<t:t<r;e=0<=t?++r:--r)n[e]=String.fromCharCode(this.readByte());return n.join("")},t.prototype.writeString=function(t){var e,n,r,i;for(i=[],e=n=0,r=t.length;0<=r?n<r:r<n;e=0<=r?++n:--n)i.push(this.writeByte(t.charCodeAt(e)));return i},t.prototype.readShort=function(){return this.readInt16()},t.prototype.writeShort=function(t){return this.writeInt16(t)},t.prototype.readLongLong=function(){var t,e,n,r,i,o,a,s;return t=this.readByte(),e=this.readByte(),n=this.readByte(),r=this.readByte(),i=this.readByte(),o=this.readByte(),a=this.readByte(),s=this.readByte(),128&t?-1*(72057594037927940*(255^t)+281474976710656*(255^e)+1099511627776*(255^n)+4294967296*(255^r)+16777216*(255^i)+65536*(255^o)+256*(255^a)+(255^s)+1):72057594037927940*t+281474976710656*e+1099511627776*n+4294967296*r+16777216*i+65536*o+256*a+s},t.prototype.writeLongLong=function(t){var e,n;return e=Math.floor(t/4294967296),n=4294967295&t,this.writeByte(e>>24&255),this.writeByte(e>>16&255),this.writeByte(e>>8&255),this.writeByte(255&e),this.writeByte(n>>24&255),this.writeByte(n>>16&255),this.writeByte(n>>8&255),this.writeByte(255&n)},t.prototype.readInt=function(){return this.readInt32()},t.prototype.writeInt=function(t){return this.writeInt32(t)},t.prototype.read=function(t){var e,n;for(e=[],n=0;0<=t?n<t:t<n;0<=t?++n:--n)e.push(this.readByte());return e},t.prototype.write=function(t){var e,n,r,i;for(i=[],n=0,r=t.length;n<r;n++)e=t[n],i.push(this.writeByte(e));return i},t}(),e=function(){var d;function t(t){var e,n,r;for(this.scalarType=t.readInt(),this.tableCount=t.readShort(),this.searchRange=t.readShort(),this.entrySelector=t.readShort(),this.rangeShift=t.readShort(),this.tables={},n=0,r=this.tableCount;0<=r?n<r:r<n;0<=r?++n:--n)e={tag:t.readString(4),checksum:t.readInt(),offset:t.readInt(),length:t.readInt()},this.tables[e.tag]=e}return t.prototype.encode=function(t){var e,n,r,i,o,a,s,l,h,u,c,f,p;for(p in c=Object.keys(t).length,a=Math.log(2),h=16*Math.floor(Math.log(c)/a),i=Math.floor(h/a),l=16*c-h,(n=new J).writeInt(this.scalarType),n.writeShort(c),n.writeShort(h),n.writeShort(i),n.writeShort(l),r=16*c,s=n.pos+r,o=null,f=[],t)for(u=t[p],n.writeString(p),n.writeInt(d(u)),n.writeInt(s),n.writeInt(u.length),f=f.concat(u),"head"===p&&(o=s),s+=u.length;s%4;)f.push(0),s++;return n.write(f),e=2981146554-d(n.data),n.pos=o+8,n.writeUInt32(e),n.data},d=function(t){var e,n,r,i;for(t=L.call(t);t.length%4;)t.push(0);for(n=new J(t),r=e=0,i=t.length;r<i;r+=4)e+=n.readUInt32();return 4294967295&e},t}(),c={}.hasOwnProperty,f=function(t,e){for(var n in e)c.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}return r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype,t};h=function(){function t(t){var e;this.file=t,e=this.file.directory.tables[this.tag],this.exists=!!e,e&&(this.offset=e.offset,this.length=e.length,this.parse(this.file.contents))}return t.prototype.parse=function(){},t.prototype.encode=function(){},t.prototype.raw=function(){return this.exists?(this.file.contents.pos=this.offset,this.file.contents.read(this.length)):null},t}();var p=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="head",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.revision=t.readInt(),this.checkSumAdjustment=t.readInt(),this.magicNumber=t.readInt(),this.flags=t.readShort(),this.unitsPerEm=t.readShort(),this.created=t.readLongLong(),this.modified=t.readLongLong(),this.xMin=t.readShort(),this.yMin=t.readShort(),this.xMax=t.readShort(),this.yMax=t.readShort(),this.macStyle=t.readShort(),this.lowestRecPPEM=t.readShort(),this.fontDirectionHint=t.readShort(),this.indexToLocFormat=t.readShort(),this.glyphDataFormat=t.readShort()},e.prototype.encode=function(t){var e;return(e=new J).writeInt(this.version),e.writeInt(this.revision),e.writeInt(this.checkSumAdjustment),e.writeInt(this.magicNumber),e.writeShort(this.flags),e.writeShort(this.unitsPerEm),e.writeLongLong(this.created),e.writeLongLong(this.modified),e.writeShort(this.xMin),e.writeShort(this.yMin),e.writeShort(this.xMax),e.writeShort(this.yMax),e.writeShort(this.macStyle),e.writeShort(this.lowestRecPPEM),e.writeShort(this.fontDirectionHint),e.writeShort(t),e.writeShort(this.glyphDataFormat),e.data},e}(),d=function(){function t(n,t){var e,r,i,o,a,s,l,h,u,c,f,p,d,g,m,y,v,w;switch(this.platformID=n.readUInt16(),this.encodingID=n.readShort(),this.offset=t+n.readInt(),u=n.pos,n.pos=this.offset,this.format=n.readUInt16(),this.length=n.readUInt16(),this.language=n.readUInt16(),this.isUnicode=3===this.platformID&&1===this.encodingID&&4===this.format||0===this.platformID&&4===this.format,this.codeMap={},this.format){case 0:for(s=m=0;m<256;s=++m)this.codeMap[s]=n.readByte();break;case 4:for(f=n.readUInt16(),c=f/2,n.pos+=6,i=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),n.pos+=2,d=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),l=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),h=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),r=(this.length-n.pos+this.offset)/2,a=function(){var t,e;for(e=[],s=t=0;0<=r?t<r:r<t;s=0<=r?++t:--t)e.push(n.readUInt16());return e}(),s=y=0,w=i.length;y<w;s=++y)for(g=i[s],e=v=p=d[s];p<=g?v<=g:g<=v;e=p<=g?++v:--v)0===h[s]?o=e+l[s]:0!==(o=a[h[s]/2+(e-p)-(c-s)]||0)&&(o+=l[s]),this.codeMap[e]=65535&o}n.pos=u}return t.encode=function(t,e){var n,r,i,o,a,s,l,h,u,c,f,p,d,g,m,y,v,w,b,x,N,L,A,S,_,F,P,k,I,C,B,j,E,M,O,q,T,R,D,U,z,H,W,V,G,Y;switch(k=new J,o=Object.keys(t).sort(function(t,e){return t-e}),e){case"macroman":for(d=0,g=function(){var t,e;for(e=[],p=t=0;t<256;p=++t)e.push(0);return e}(),y={0:0},i={},I=0,E=o.length;I<E;I++)null==y[W=t[r=o[I]]]&&(y[W]=++d),i[r]={old:t[r],new:y[t[r]]},g[r]=y[t[r]];return k.writeUInt16(1),k.writeUInt16(0),k.writeUInt32(12),k.writeUInt16(0),k.writeUInt16(262),k.writeUInt16(0),k.write(g),{charMap:i,subtable:k.data,maxGlyphID:d+1};case"unicode":for(F=[],u=[],y={},n={},m=l=null,C=v=0,M=o.length;C<M;C++)null==y[b=t[r=o[C]]]&&(y[b]=++v),n[r]={old:b,new:y[b]},a=y[b]-r,null!=m&&a===l||(m&&u.push(m),F.push(r),l=a),m=r;for(m&&u.push(m),u.push(65535),F.push(65535),S=2*(A=F.length),L=2*Math.pow(Math.log(A)/Math.LN2,2),c=Math.log(L/2)/Math.LN2,N=2*A-L,s=[],x=[],f=[],p=B=0,O=F.length;B<O;p=++B){if(_=F[p],h=u[p],65535===_){s.push(0),x.push(0);break}if(32768<=_-(P=n[_].new))for(s.push(0),x.push(2*(f.length+A-p)),r=j=_;_<=h?j<=h:h<=j;r=_<=h?++j:--j)f.push(n[r].new);else s.push(P-_),x.push(0)}for(k.writeUInt16(3),k.writeUInt16(1),k.writeUInt32(12),k.writeUInt16(4),k.writeUInt16(16+8*A+2*f.length),k.writeUInt16(0),k.writeUInt16(S),k.writeUInt16(L),k.writeUInt16(c),k.writeUInt16(N),z=0,q=u.length;z<q;z++)r=u[z],k.writeUInt16(r);for(k.writeUInt16(0),H=0,T=F.length;H<T;H++)r=F[H],k.writeUInt16(r);for(V=0,R=s.length;V<R;V++)a=s[V],k.writeUInt16(a);for(G=0,D=x.length;G<D;G++)w=x[G],k.writeUInt16(w);for(Y=0,U=f.length;Y<U;Y++)d=f[Y],k.writeUInt16(d);return{charMap:n,subtable:k.data,maxGlyphID:v+1}}},t}(),y=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="cmap",e.prototype.parse=function(t){var e,n,r;for(t.pos=this.offset,this.version=t.readUInt16(),n=t.readUInt16(),this.tables=[],this.unicode=null,r=0;0<=n?r<n:n<r;0<=n?++r:--r)e=new d(t,this.offset),this.tables.push(e),e.isUnicode&&null==this.unicode&&(this.unicode=e);return!0},e.encode=function(t,e){var n,r;return null==e&&(e="macroman"),n=d.encode(t,e),(r=new J).writeUInt16(0),r.writeUInt16(1),n.table=r.data.concat(n.subtable),n},e}(),g=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="hhea",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.ascender=t.readShort(),this.decender=t.readShort(),this.lineGap=t.readShort(),this.advanceWidthMax=t.readShort(),this.minLeftSideBearing=t.readShort(),this.minRightSideBearing=t.readShort(),this.xMaxExtent=t.readShort(),this.caretSlopeRise=t.readShort(),this.caretSlopeRun=t.readShort(),this.caretOffset=t.readShort(),t.pos+=8,this.metricDataFormat=t.readShort(),this.numberOfMetrics=t.readUInt16()},e}(),m=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="OS/2",e.prototype.parse=function(n){if(n.pos=this.offset,this.version=n.readUInt16(),this.averageCharWidth=n.readShort(),this.weightClass=n.readUInt16(),this.widthClass=n.readUInt16(),this.type=n.readShort(),this.ySubscriptXSize=n.readShort(),this.ySubscriptYSize=n.readShort(),this.ySubscriptXOffset=n.readShort(),this.ySubscriptYOffset=n.readShort(),this.ySuperscriptXSize=n.readShort(),this.ySuperscriptYSize=n.readShort(),this.ySuperscriptXOffset=n.readShort(),this.ySuperscriptYOffset=n.readShort(),this.yStrikeoutSize=n.readShort(),this.yStrikeoutPosition=n.readShort(),this.familyClass=n.readShort(),this.panose=function(){var t,e;for(e=[],t=0;t<10;++t)e.push(n.readByte());return e}(),this.charRange=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(n.readInt());return e}(),this.vendorID=n.readString(4),this.selection=n.readShort(),this.firstCharIndex=n.readShort(),this.lastCharIndex=n.readShort(),0<this.version&&(this.ascent=n.readShort(),this.descent=n.readShort(),this.lineGap=n.readShort(),this.winAscent=n.readShort(),this.winDescent=n.readShort(),this.codePageRange=function(){var t,e;for(e=[],t=0;t<2;++t)e.push(n.readInt());return e}(),1<this.version))return this.xHeight=n.readShort(),this.capHeight=n.readShort(),this.defaultChar=n.readShort(),this.breakChar=n.readShort(),this.maxContext=n.readShort()},e}(),v=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="post",e.prototype.parse=function(r){var t,e,n,i;switch(r.pos=this.offset,this.format=r.readInt(),this.italicAngle=r.readInt(),this.underlinePosition=r.readShort(),this.underlineThickness=r.readShort(),this.isFixedPitch=r.readInt(),this.minMemType42=r.readInt(),this.maxMemType42=r.readInt(),this.minMemType1=r.readInt(),this.maxMemType1=r.readInt(),this.format){case 65536:break;case 131072:for(e=r.readUInt16(),this.glyphNameIndex=[],n=0;0<=e?n<e:e<n;0<=e?++n:--n)this.glyphNameIndex.push(r.readUInt16());for(this.names=[],i=[];r.pos<this.offset+this.length;)t=r.readByte(),i.push(this.names.push(r.readString(t)));return i;case 151552:return e=r.readUInt16(),this.offsets=r.read(e);case 196608:break;case 262144:return this.map=function(){var t,e,n;for(n=[],t=0,e=this.file.maxp.numGlyphs;0<=e?t<e:e<t;0<=e?++t:--t)n.push(r.readUInt32());return n}.call(this)}},e}(),w=function(t,e){this.raw=t,this.length=t.length,this.platformID=e.platformID,this.encodingID=e.encodingID,this.languageID=e.languageID},b=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="name",e.prototype.parse=function(t){var e,n,r,i,o,a,s,l,h,u,c,f;for(t.pos=this.offset,t.readShort(),e=t.readShort(),a=t.readShort(),n=[],i=h=0;0<=e?h<e:e<h;i=0<=e?++h:--h)n.push({platformID:t.readShort(),encodingID:t.readShort(),languageID:t.readShort(),nameID:t.readShort(),length:t.readShort(),offset:this.offset+a+t.readShort()});for(s={},i=u=0,c=n.length;u<c;i=++u)r=n[i],t.pos=r.offset,l=t.readString(r.length),o=new w(l,r),null==s[f=r.nameID]&&(s[f]=[]),s[r.nameID].push(o);this.strings=s,this.copyright=s[0],this.fontFamily=s[1],this.fontSubfamily=s[2],this.uniqueSubfamily=s[3],this.fontName=s[4],this.version=s[5];try{this.postscriptName=s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}catch(t){this.postscriptName=s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}return this.trademark=s[7],this.manufacturer=s[8],this.designer=s[9],this.description=s[10],this.vendorUrl=s[11],this.designerUrl=s[12],this.license=s[13],this.licenseUrl=s[14],this.preferredFamily=s[15],this.preferredSubfamily=s[17],this.compatibleFull=s[18],this.sampleText=s[19]},e}(),x=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="maxp",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.numGlyphs=t.readUInt16(),this.maxPoints=t.readUInt16(),this.maxContours=t.readUInt16(),this.maxCompositePoints=t.readUInt16(),this.maxComponentContours=t.readUInt16(),this.maxZones=t.readUInt16(),this.maxTwilightPoints=t.readUInt16(),this.maxStorage=t.readUInt16(),this.maxFunctionDefs=t.readUInt16(),this.maxInstructionDefs=t.readUInt16(),this.maxStackElements=t.readUInt16(),this.maxSizeOfInstructions=t.readUInt16(),this.maxComponentElements=t.readUInt16(),this.maxComponentDepth=t.readUInt16()},e}(),N=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="hmtx",e.prototype.parse=function(n){var t,r,i,e,o,a,s;for(n.pos=this.offset,this.metrics=[],e=0,a=this.file.hhea.numberOfMetrics;0<=a?e<a:a<e;0<=a?++e:--e)this.metrics.push({advance:n.readUInt16(),lsb:n.readInt16()});for(r=this.file.maxp.numGlyphs-this.file.hhea.numberOfMetrics,this.leftSideBearings=function(){var t,e;for(e=[],t=0;0<=r?t<r:r<t;0<=r?++t:--t)e.push(n.readInt16());return e}(),this.widths=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.metrics).length;t<e;t++)i=n[t],r.push(i.advance);return r}.call(this),t=this.widths[this.widths.length-1],s=[],o=0;0<=r?o<r:r<o;0<=r?++o:--o)s.push(this.widths.push(t));return s},e.prototype.forGlyph=function(t){return t in this.metrics?this.metrics[t]:{advance:this.metrics[this.metrics.length-1].advance,lsb:this.leftSideBearings[t-this.metrics.length]}},e}(),L=[].slice,A=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="glyf",e.prototype.parse=function(t){return this.cache={}},e.prototype.glyphFor=function(t){var e,n,r,i,o,a,s,l,h,u;return(t=t)in this.cache?this.cache[t]:(i=this.file.loca,e=this.file.contents,n=i.indexOf(t),0===(r=i.lengthOf(t))?this.cache[t]=null:(e.pos=this.offset+n,o=(a=new J(e.read(r))).readShort(),l=a.readShort(),u=a.readShort(),s=a.readShort(),h=a.readShort(),this.cache[t]=-1===o?new _(a,l,u,s,h):new S(a,o,l,u,s,h),this.cache[t]))},e.prototype.encode=function(t,e,n){var r,i,o,a,s;for(o=[],i=[],a=0,s=e.length;a<s;a++)r=t[e[a]],i.push(o.length),r&&(o=o.concat(r.encode(n)));return i.push(o.length),{table:o,offsets:i}},e}(),S=function(){function t(t,e,n,r,i,o){this.raw=t,this.numberOfContours=e,this.xMin=n,this.yMin=r,this.xMax=i,this.yMax=o,this.compound=!1}return t.prototype.encode=function(){return this.raw.data},t}(),_=function(){function t(t,e,n,r,i){var o,a;for(this.raw=t,this.xMin=e,this.yMin=n,this.xMax=r,this.yMax=i,this.compound=!0,this.glyphIDs=[],this.glyphOffsets=[],o=this.raw;a=o.readShort(),this.glyphOffsets.push(o.pos),this.glyphIDs.push(o.readShort()),32&a;)o.pos+=1&a?4:2,128&a?o.pos+=8:64&a?o.pos+=4:8&a&&(o.pos+=2)}return 1,8,32,64,128,t.prototype.encode=function(t){var e,n,r,i,o;for(n=new J(L.call(this.raw.data)),e=r=0,i=(o=this.glyphIDs).length;r<i;e=++r)o[e],n.pos=this.glyphOffsets[e];return n.data},t}(),F=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="loca",e.prototype.parse=function(r){var t;return r.pos=this.offset,t=this.file.head.indexToLocFormat,this.offsets=0===t?function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=2)n.push(2*r.readUInt16());return n}.call(this):function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=4)n.push(r.readUInt32());return n}.call(this)},e.prototype.indexOf=function(t){return this.offsets[t]},e.prototype.lengthOf=function(t){return this.offsets[t+1]-this.offsets[t]},e.prototype.encode=function(t,e){for(var n=new Uint32Array(this.offsets.length),r=0,i=0,o=0;o<n.length;++o)if(n[o]=r,i<e.length&&e[i]==o){++i,n[o]=r;var a=this.offsets[o],s=this.offsets[o+1]-a;0<s&&(r+=s)}for(var l=new Array(4*n.length),h=0;h<n.length;++h)l[4*h+3]=255&n[h],l[4*h+2]=(65280&n[h])>>8,l[4*h+1]=(16711680&n[h])>>16,l[4*h]=(4278190080&n[h])>>24;return l},e}(),P=function(){function t(t){this.font=t,this.subset={},this.unicodes={},this.next=33}return t.prototype.generateCmap=function(){var t,e,n,r,i;for(e in r=this.font.cmap.tables[0].codeMap,t={},i=this.subset)n=i[e],t[e]=r[n];return t},t.prototype.glyphsFor=function(t){var e,n,r,i,o,a,s;for(r={},o=0,a=t.length;o<a;o++)r[i=t[o]]=this.font.glyf.glyphFor(i);for(i in e=[],r)(null!=(n=r[i])?n.compound:void 0)&&e.push.apply(e,n.glyphIDs);if(0<e.length)for(i in s=this.glyphsFor(e))n=s[i],r[i]=n;return r},t.prototype.encode=function(t,e){var n,r,i,o,a,s,l,h,u,c,f,p,d,g,m;for(r in n=y.encode(this.generateCmap(),"unicode"),o=this.glyphsFor(t),f={0:0},m=n.charMap)f[(s=m[r]).old]=s.new;for(p in c=n.maxGlyphID,o)p in f||(f[p]=c++);return h=function(t){var e,n;for(e in n={},t)n[t[e]]=e;return n}(f),u=Object.keys(h).sort(function(t,e){return t-e}),d=function(){var t,e,n;for(n=[],t=0,e=u.length;t<e;t++)a=u[t],n.push(h[a]);return n}(),i=this.font.glyf.encode(o,d,f),l=this.font.loca.encode(i.offsets,d),g={cmap:this.font.cmap.raw(),glyf:i.table,loca:l,hmtx:this.font.hmtx.raw(),hhea:this.font.hhea.raw(),maxp:this.font.maxp.raw(),post:this.font.post.raw(),name:this.font.name.raw(),head:this.font.head.encode(e)},this.font.os2.exists&&(g["OS/2"]=this.font.os2.raw()),this.font.directory.encode(g)},t}();t.API.PDFObject=function(){var o;function a(){}return o=function(t,e){return(Array(e+1).join("0")+t).slice(-e)},a.convert=function(r){var i,t,e,n;if(Array.isArray(r))return"["+function(){var t,e,n;for(n=[],t=0,e=r.length;t<e;t++)i=r[t],n.push(a.convert(i));return n}().join(" ")+"]";if("string"==typeof r)return"/"+r;if(null!=r?r.isString:void 0)return"("+r+")";if(r instanceof Date)return"(D:"+o(r.getUTCFullYear(),4)+o(r.getUTCMonth(),2)+o(r.getUTCDate(),2)+o(r.getUTCHours(),2)+o(r.getUTCMinutes(),2)+o(r.getUTCSeconds(),2)+"Z)";if("[object Object]"!=={}.toString.call(r))return""+r;for(t in e=["<<"],r)n=r[t],e.push("/"+t+" "+a.convert(n));return e.push(">>"),e.join("\n")},a}()}(lt),
/*
  # PNG.js
  # Copyright (c) 2011 Devon Govett
  # MIT LICENSE
  # 
  # 
  */
Nt="undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")(),Lt=function(){var h,n,r;function i(t){var e,n,r,i,o,a,s,l,h,u,c,f,p,d;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},a=null;;){switch(e=this.readUInt32(),h=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":a&&this.animation.frames.push(a),this.pos+=4,a={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},o=this.readUInt16(),i=this.readUInt16()||100,a.delay=1e3*o/i,a.disposeOp=this.data[this.pos++],a.blendOp=this.data[this.pos++],a.data=[];break;case"IDAT":case"fdAT":for("fdAT"===h&&(this.pos+=4,e-=4),t=(null!=a?a.data:void 0)||this.imgData,f=0;0<=e?f<e:e<f;0<=e?++f:--f)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(r=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>r)throw new Error("More transparent colors than palette size");if(0<(u=r-this.transparency.indexed.length))for(p=0;0<=u?p<u:u<p;0<=u?++p:--p)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e)}break;case"tEXt":s=(c=this.read(e)).indexOf(0),l=String.fromCharCode.apply(String,c.slice(0,s)),this.text[l]=String.fromCharCode.apply(String,c.slice(s+1));break;case"IEND":return a&&this.animation.frames.push(a),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(d=this.colorType)||6===d,n=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*n,this.colorSpace=function(){switch(this.colors){case 1:return"DeviceGray";case 3:return"DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}i.load=function(t,e,n){var r;return"function"==typeof e&&(n=e),(r=new XMLHttpRequest).open("GET",t,!0),r.responseType="arraybuffer",r.onload=function(){var t;return t=new i(new Uint8Array(r.response||r.mozResponseArrayBuffer)),"function"==typeof(null!=e?e.getContext:void 0)&&t.render(e),"function"==typeof n?n(t):void 0},r.send(null)},i.prototype.read=function(t){var e,n;for(n=[],e=0;0<=t?e<t:t<e;0<=t?++e:--e)n.push(this.data[this.pos++]);return n},i.prototype.readUInt32=function(){return this.data[this.pos++]<<24|this.data[this.pos++]<<16|this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.readUInt16=function(){return this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.decodePixels=function(C){var B=this.pixelBitlength/8,j=new Uint8Array(this.width*this.height*B),E=0,M=this;if(null==C&&(C=this.imgData),0===C.length)return new Uint8Array(0);function t(t,e,n,r){var i,o,a,s,l,h,u,c,f,p,d,g,m,y,v,w,b,x,N,L,A,S=Math.ceil((M.width-t)/n),_=Math.ceil((M.height-e)/r),F=M.width==S&&M.height==_;for(y=B*S,g=F?j:new Uint8Array(y*_),h=C.length,o=m=0;m<_&&E<h;){switch(C[E++]){case 0:for(s=b=0;b<y;s=b+=1)g[o++]=C[E++];break;case 1:for(s=x=0;x<y;s=x+=1)i=C[E++],l=s<B?0:g[o-B],g[o++]=(i+l)%256;break;case 2:for(s=N=0;N<y;s=N+=1)i=C[E++],a=(s-s%B)/B,v=m&&g[(m-1)*y+a*B+s%B],g[o++]=(v+i)%256;break;case 3:for(s=L=0;L<y;s=L+=1)i=C[E++],a=(s-s%B)/B,l=s<B?0:g[o-B],v=m&&g[(m-1)*y+a*B+s%B],g[o++]=(i+Math.floor((l+v)/2))%256;break;case 4:for(s=A=0;A<y;s=A+=1)i=C[E++],a=(s-s%B)/B,l=s<B?0:g[o-B],0===m?v=w=0:(v=g[(m-1)*y+a*B+s%B],w=a&&g[(m-1)*y+(a-1)*B+s%B]),u=l+v-w,c=Math.abs(u-l),p=Math.abs(u-v),d=Math.abs(u-w),f=c<=p&&c<=d?l:p<=d?v:w,g[o++]=(i+f)%256;break;default:throw new Error("Invalid filter algorithm: "+C[E-1])}if(!F){var P=((e+m*r)*M.width+t)*B,k=m*y;for(s=0;s<S;s+=1){for(var I=0;I<B;I+=1)j[P++]=g[k++];P+=(n-1)*B}}m++}}return C=(C=new kt(C)).getBytes(),1==M.interlaceMethod?(t(0,0,8,8),t(4,0,8,8),t(0,4,4,8),t(2,0,4,4),t(0,2,2,4),t(1,0,2,2),t(0,1,1,2)):t(0,0,1,1),j},i.prototype.decodePalette=function(){var t,e,n,r,i,o,a,s,l;for(n=this.palette,o=this.transparency.indexed||[],i=new Uint8Array((o.length||0)+n.length),r=0,n.length,e=a=t=0,s=n.length;a<s;e=a+=3)i[r++]=n[e],i[r++]=n[e+1],i[r++]=n[e+2],i[r++]=null!=(l=o[t++])?l:255;return i},i.prototype.copyToImageData=function(t,e){var n,r,i,o,a,s,l,h,u,c,f;if(r=this.colors,u=null,n=this.hasAlphaChannel,this.palette.length&&(u=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),r=4,n=!0),h=(i=t.data||t).length,a=u||e,o=s=0,1===r)for(;o<h;)l=u?4*e[o/4]:s,c=a[l++],i[o++]=c,i[o++]=c,i[o++]=c,i[o++]=n?a[l++]:255,s=l;else for(;o<h;)l=u?4*e[o/4]:s,i[o++]=a[l++],i[o++]=a[l++],i[o++]=a[l++],i[o++]=n?a[l++]:255,s=l},i.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t};try{n=Nt.document.createElement("canvas"),r=n.getContext("2d")}catch(t){return-1}return h=function(t){var e;return r.width=t.width,r.height=t.height,r.clearRect(0,0,t.width,t.height),r.putImageData(t,0,0),(e=new Image).src=n.toDataURL(),e},i.prototype.decodeFrames=function(t){var e,n,r,i,o,a,s,l;if(this.animation){for(l=[],n=o=0,a=(s=this.animation.frames).length;o<a;n=++o)e=s[n],r=t.createImageData(e.width,e.height),i=this.decodePixels(new Uint8Array(e.data)),this.copyToImageData(r,i),e.imageData=r,l.push(e.image=h(r));return l}},i.prototype.renderFrame=function(t,e){var n,r,i;return n=(r=this.animation.frames)[e],i=r[e-1],0===e&&t.clearRect(0,0,this.width,this.height),1===(null!=i?i.disposeOp:void 0)?t.clearRect(i.xOffset,i.yOffset,i.width,i.height):2===(null!=i?i.disposeOp:void 0)&&t.putImageData(i.imageData,i.xOffset,i.yOffset),0===n.blendOp&&t.clearRect(n.xOffset,n.yOffset,n.width,n.height),t.drawImage(n.image,n.xOffset,n.yOffset)},i.prototype.animate=function(n){var r,i,o,a,s,t,l=this;return i=0,t=this.animation,a=t.numFrames,o=t.frames,s=t.numPlays,(r=function(){var t,e;if(t=i++%a,e=o[t],l.renderFrame(n,t),1<a&&i/a<s)return l.animation._timeout=setTimeout(r,e.delay)})()},i.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},i.prototype.render=function(t){var e,n;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(n=e.createImageData(this.width,this.height),this.copyToImageData(n,this.decodePixels()),e.putImageData(n,0,0))},i}(),Nt.PNG=Lt;
/*
   * Extracted from pdf.js
   * https://github.com/andreasgal/pdf.js
   *
   * Copyright (c) 2011 Mozilla Foundation
   *
   * Contributors: Andreas Gal <gal@mozilla.com>
   *               Chris G Jones <cjones@mozilla.com>
   *               Shaon Barman <shaon.barman@gmail.com>
   *               Vivien Nicolas <21@vingtetun.org>
   *               Justin D'Arcangelo <justindarc@gmail.com>
   *               Yury Delendik
   *
   * 
   */
var Pt=function(){function t(){this.pos=0,this.bufferLength=0,this.eof=!1,this.buffer=null}return t.prototype={ensureBuffer:function(t){var e=this.buffer,n=e?e.byteLength:0;if(t<n)return e;for(var r=512;r<t;)r<<=1;for(var i=new Uint8Array(r),o=0;o<n;++o)i[o]=e[o];return this.buffer=i},getByte:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return this.buffer[this.pos++]},getBytes:function(t){var e=this.pos;if(t){this.ensureBuffer(e+t);for(var n=e+t;!this.eof&&this.bufferLength<n;)this.readBlock();var r=this.bufferLength;r<n&&(n=r)}else{for(;!this.eof;)this.readBlock();n=this.bufferLength}return this.pos=n,this.buffer.subarray(e,n)},lookChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos])},getChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos++])},makeSubStream:function(t,e,n){for(var r=t+e;this.bufferLength<=r&&!this.eof;)this.readBlock();return new Stream(this.buffer,t,e,n)},skip:function(t){t||(t=1),this.pos+=t},reset:function(){this.pos=0}},t}(),kt=function(){if("undefined"!=typeof Uint32Array){var k=new Uint32Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),I=new Uint32Array([3,4,5,6,7,8,9,10,65547,65549,65551,65553,131091,131095,131099,131103,196643,196651,196659,196667,262211,262227,262243,262259,327811,327843,327875,327907,258,258,258]),C=new Uint32Array([1,2,3,4,65541,65543,131081,131085,196625,196633,262177,262193,327745,327777,393345,393409,459009,459137,524801,525057,590849,591361,657409,658433,724993,727041,794625,798721,868353,876545]),B=[new Uint32Array([459008,524368,524304,524568,459024,524400,524336,590016,459016,524384,524320,589984,524288,524416,524352,590048,459012,524376,524312,589968,459028,524408,524344,590032,459020,524392,524328,59e4,524296,524424,524360,590064,459010,524372,524308,524572,459026,524404,524340,590024,459018,524388,524324,589992,524292,524420,524356,590056,459014,524380,524316,589976,459030,524412,524348,590040,459022,524396,524332,590008,524300,524428,524364,590072,459009,524370,524306,524570,459025,524402,524338,590020,459017,524386,524322,589988,524290,524418,524354,590052,459013,524378,524314,589972,459029,524410,524346,590036,459021,524394,524330,590004,524298,524426,524362,590068,459011,524374,524310,524574,459027,524406,524342,590028,459019,524390,524326,589996,524294,524422,524358,590060,459015,524382,524318,589980,459031,524414,524350,590044,459023,524398,524334,590012,524302,524430,524366,590076,459008,524369,524305,524569,459024,524401,524337,590018,459016,524385,524321,589986,524289,524417,524353,590050,459012,524377,524313,589970,459028,524409,524345,590034,459020,524393,524329,590002,524297,524425,524361,590066,459010,524373,524309,524573,459026,524405,524341,590026,459018,524389,524325,589994,524293,524421,524357,590058,459014,524381,524317,589978,459030,524413,524349,590042,459022,524397,524333,590010,524301,524429,524365,590074,459009,524371,524307,524571,459025,524403,524339,590022,459017,524387,524323,589990,524291,524419,524355,590054,459013,524379,524315,589974,459029,524411,524347,590038,459021,524395,524331,590006,524299,524427,524363,590070,459011,524375,524311,524575,459027,524407,524343,590030,459019,524391,524327,589998,524295,524423,524359,590062,459015,524383,524319,589982,459031,524415,524351,590046,459023,524399,524335,590014,524303,524431,524367,590078,459008,524368,524304,524568,459024,524400,524336,590017,459016,524384,524320,589985,524288,524416,524352,590049,459012,524376,524312,589969,459028,524408,524344,590033,459020,524392,524328,590001,524296,524424,524360,590065,459010,524372,524308,524572,459026,524404,524340,590025,459018,524388,524324,589993,524292,524420,524356,590057,459014,524380,524316,589977,459030,524412,524348,590041,459022,524396,524332,590009,524300,524428,524364,590073,459009,524370,524306,524570,459025,524402,524338,590021,459017,524386,524322,589989,524290,524418,524354,590053,459013,524378,524314,589973,459029,524410,524346,590037,459021,524394,524330,590005,524298,524426,524362,590069,459011,524374,524310,524574,459027,524406,524342,590029,459019,524390,524326,589997,524294,524422,524358,590061,459015,524382,524318,589981,459031,524414,524350,590045,459023,524398,524334,590013,524302,524430,524366,590077,459008,524369,524305,524569,459024,524401,524337,590019,459016,524385,524321,589987,524289,524417,524353,590051,459012,524377,524313,589971,459028,524409,524345,590035,459020,524393,524329,590003,524297,524425,524361,590067,459010,524373,524309,524573,459026,524405,524341,590027,459018,524389,524325,589995,524293,524421,524357,590059,459014,524381,524317,589979,459030,524413,524349,590043,459022,524397,524333,590011,524301,524429,524365,590075,459009,524371,524307,524571,459025,524403,524339,590023,459017,524387,524323,589991,524291,524419,524355,590055,459013,524379,524315,589975,459029,524411,524347,590039,459021,524395,524331,590007,524299,524427,524363,590071,459011,524375,524311,524575,459027,524407,524343,590031,459019,524391,524327,589999,524295,524423,524359,590063,459015,524383,524319,589983,459031,524415,524351,590047,459023,524399,524335,590015,524303,524431,524367,590079]),9],j=[new Uint32Array([327680,327696,327688,327704,327684,327700,327692,327708,327682,327698,327690,327706,327686,327702,327694,0,327681,327697,327689,327705,327685,327701,327693,327709,327683,327699,327691,327707,327687,327703,327695,0]),5];return(t.prototype=Object.create(Pt.prototype)).getBits=function(t){for(var e,n=this.codeSize,r=this.codeBuf,i=this.bytes,o=this.bytesPos;n<t;)void 0===(e=i[o++])&&E("Bad encoding in flate stream"),r|=e<<n,n+=8;return e=r&(1<<t)-1,this.codeBuf=r>>t,this.codeSize=n-=t,this.bytesPos=o,e},t.prototype.getCode=function(t){for(var e=t[0],n=t[1],r=this.codeSize,i=this.codeBuf,o=this.bytes,a=this.bytesPos;r<n;){var s;void 0===(s=o[a++])&&E("Bad encoding in flate stream"),i|=s<<r,r+=8}var l=e[i&(1<<n)-1],h=l>>16,u=65535&l;return(0==r||r<h||0==h)&&E("Bad encoding in flate stream"),this.codeBuf=i>>h,this.codeSize=r-h,this.bytesPos=a,u},t.prototype.generateHuffmanTable=function(t){for(var e=t.length,n=0,r=0;r<e;++r)t[r]>n&&(n=t[r]);for(var i=1<<n,o=new Uint32Array(i),a=1,s=0,l=2;a<=n;++a,s<<=1,l<<=1)for(var h=0;h<e;++h)if(t[h]==a){var u=0,c=s;for(r=0;r<a;++r)u=u<<1|1&c,c>>=1;for(r=u;r<i;r+=l)o[r]=a<<16|h;++s}return[o,n]},t.prototype.readBlock=function(){function t(t,e,n,r,i){for(var o=t.getBits(n)+r;0<o--;)e[l++]=i}var e=this.getBits(3);if(1&e&&(this.eof=!0),0!=(e>>=1)){var n,r;if(1==e)n=B,r=j;else if(2==e){for(var i=this.getBits(5)+257,o=this.getBits(5)+1,a=this.getBits(4)+4,s=Array(k.length),l=0;l<a;)s[k[l++]]=this.getBits(3);for(var h=this.generateHuffmanTable(s),u=0,c=(l=0,i+o),f=new Array(c);l<c;){var p=this.getCode(h);16==p?t(this,f,2,3,u):17==p?t(this,f,3,3,u=0):18==p?t(this,f,7,11,u=0):f[l++]=u=p}n=this.generateHuffmanTable(f.slice(0,i)),r=this.generateHuffmanTable(f.slice(i,c))}else E("Unknown block type in flate stream");for(var d=(_=this.buffer)?_.length:0,g=this.bufferLength;;){var m=this.getCode(n);if(m<256)d<=g+1&&(d=(_=this.ensureBuffer(g+1)).length),_[g++]=m;else{if(256==m)return void(this.bufferLength=g);var y=(m=I[m-=257])>>16;0<y&&(y=this.getBits(y));u=(65535&m)+y;m=this.getCode(r),0<(y=(m=C[m])>>16)&&(y=this.getBits(y));var v=(65535&m)+y;d<=g+u&&(d=(_=this.ensureBuffer(g+u)).length);for(var w=0;w<u;++w,++g)_[g]=_[g-v]}}}else{var b,x=this.bytes,N=this.bytesPos;void 0===(b=x[N++])&&E("Bad block header in flate stream");var L=b;void 0===(b=x[N++])&&E("Bad block header in flate stream"),L|=b<<8,void 0===(b=x[N++])&&E("Bad block header in flate stream");var A=b;void 0===(b=x[N++])&&E("Bad block header in flate stream"),(A|=b<<8)!=(65535&~L)&&E("Bad uncompressed block length in flate stream"),this.codeBuf=0,this.codeSize=0;var S=this.bufferLength,_=this.ensureBuffer(S+L),F=S+L;this.bufferLength=F;for(var P=S;P<F;++P){if(void 0===(b=x[N++])){this.eof=!0;break}_[P]=b}this.bytesPos=N}},t}function E(t){throw new Error(t)}function t(t){var e=0,n=t[e++],r=t[e++];-1!=n&&-1!=r||E("Invalid header in flate stream"),8!=(15&n)&&E("Unknown compression method in flate stream"),((n<<8)+r)%31!=0&&E("Bad FCHECK in flate stream"),32&r&&E("FDICT bit set in flate stream"),this.bytes=t,this.bytesPos=2,this.codeSize=0,this.codeBuf=0,Pt.call(this)}}();window.tmp=kt});try{module.exports=jsPDF}catch(t){}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(142);
var createDesc = __webpack_require__(216);
module.exports = __webpack_require__(143) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(186);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnimateChild__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_animate__ = __webpack_require__(466);













var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__["a" /* default */])(Animate));

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(841);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubMenu__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuItem__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Divider__ = __webpack_require__(913);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SubMenu", function() { return __WEBPACK_IMPORTED_MODULE_1__SubMenu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Item", function() { return __WEBPACK_IMPORTED_MODULE_2__MenuItem__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return __WEBPACK_IMPORTED_MODULE_2__MenuItem__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuItemGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ItemGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Divider", function() { return __WEBPACK_IMPORTED_MODULE_4__Divider__["a"]; });






/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Menu__["a" /* default */]);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = noop;
/* harmony export (immutable) */ __webpack_exports__["a"] = getKeyFromChildrenIndex;
/* harmony export (immutable) */ __webpack_exports__["b"] = getMenuIdFromSubMenuEventKey;
/* harmony export (immutable) */ __webpack_exports__["e"] = loopMenuItem;
/* harmony export (immutable) */ __webpack_exports__["f"] = loopMenuItemRecursively;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return menuAllProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isMobileDevice; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_isMobile__ = __webpack_require__(895);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }



function noop() {}
function getKeyFromChildrenIndex(child, menuEventKey, index) {
  var prefix = menuEventKey || '';
  return child.key || "".concat(prefix, "item_").concat(index);
}
function getMenuIdFromSubMenuEventKey(eventKey) {
  return "".concat(eventKey, "-menu-");
}
function loopMenuItem(children, cb) {
  var index = -1;
  __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(children, function (c) {
    index += 1;

    if (c && c.type && c.type.isMenuItemGroup) {
      __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(c.props.children, function (c2) {
        index += 1;
        cb(c2, index);
      });
    } else {
      cb(c, index);
    }
  });
}
function loopMenuItemRecursively(children, keys, ret) {
  /* istanbul ignore if */
  if (!children || ret.find) {
    return;
  }

  __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(children, function (c) {
    if (c) {
      var construct = c.type;

      if (!construct || !(construct.isSubMenu || construct.isMenuItem || construct.isMenuItemGroup)) {
        return;
      }

      if (keys.indexOf(c.key) !== -1) {
        ret.find = true;
      } else if (c.props.children) {
        loopMenuItemRecursively(c.props.children, keys, ret);
      }
    }
  });
}
var menuAllProps = ['defaultSelectedKeys', 'selectedKeys', 'defaultOpenKeys', 'openKeys', 'mode', 'getPopupContainer', 'onSelect', 'onDeselect', 'onDestroy', 'openTransitionName', 'openAnimation', 'subMenuOpenDelay', 'subMenuCloseDelay', 'forceSubMenuRender', 'triggerSubMenuAction', 'level', 'selectable', 'multiple', 'onOpenChange', 'visible', 'focusable', 'defaultActiveFirst', 'prefixCls', 'inlineIndent', 'parentMenu', 'title', 'rootPrefixCls', 'eventKey', 'active', 'onItemHover', 'onTitleMouseEnter', 'onTitleMouseLeave', 'onTitleClick', 'popupAlign', 'popupOffset', 'isOpen', 'renderMenuItem', 'manualRef', 'subMenuKey', 'disabled', 'index', 'isSelected', 'store', 'activeKey', 'builtinPlacements', 'overflowedIndicator', 'motion', // the following keys found need to be removed from test regression
'attribute', 'value', 'popupClassName', 'inlineCollapsed', 'menu', 'theme', 'itemIcon', 'expandIcon']; // ref: https://github.com/ant-design/ant-design/issues/14007
// ref: https://bugs.chromium.org/p/chromium/issues/detail?id=360889
// getBoundingClientRect return the full precision value, which is
// not the same behavior as on chrome. Set the precision to 6 to
// unify their behavior

var getWidth = function getWidth(elem) {
  var width = elem && typeof elem.getBoundingClientRect === 'function' && elem.getBoundingClientRect().width;

  if (width) {
    width = +width.toFixed(6);
  }

  return width || 0;
};
var setStyle = function setStyle(elem, styleProperty, value) {
  if (elem && _typeof(elem.style) === 'object') {
    elem.style[styleProperty] = value;
  }
};
var isMobileDevice = function isMobileDevice() {
  return __WEBPACK_IMPORTED_MODULE_1__utils_isMobile__["a" /* default */].any;
};

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Popup__ = __webpack_require__(897);

















function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom__["createPortal"];

var contextTypes = {
  rcTrigger: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    onPopupMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  })
};

var Trigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Trigger, _React$Component);

  function Trigger(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Trigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }

    _this.state = {
      prevPopupVisible: popupVisible,
      popupVisible: popupVisible
    };

    ALL_HANDLERS.forEach(function (h) {
      _this['fire' + h] = function (e) {
        _this.fireEvents(h, e);
      };
    });
    return _this;
  }

  Trigger.prototype.getChildContext = function getChildContext() {
    return {
      rcTrigger: {
        onPopupMouseDown: this.onPopupMouseDown
      }
    };
  };

  Trigger.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  };

  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    };
    if (!IS_REACT_16) {
      this.renderComponent(null, triggerAfterPopupVisibleChange);
    }

    // We must listen to `mousedown` or `touchstart`, edge case:
    // https://github.com/ant-design/ant-design/issues/5804
    // https://github.com/react-component/calendar/issues/250
    // https://github.com/react-component/trigger/issues/50
    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
      }
      // always hide on mobile
      if (!this.touchOutsideHandler) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
      }
      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
        currentDocument = currentDocument || props.getDocument();
        this.contextMenuOutsideHandler1 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
      }
      // close popup when trigger type contains 'onContextMenu' and window is blur.
      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
        this.contextMenuOutsideHandler2 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
      }
      return;
    }

    this.clearOutsideHandler();
  };

  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
    clearTimeout(this.mouseDownTimeout);
  };

  Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var popupVisible = _ref.popupVisible;

    var newState = {};

    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
      newState.popupVisible = popupVisible;
      newState.prevPopupVisible = prevState.popupVisible;
    }

    return newState;
  };

  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
    // for test
    if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  };

  Trigger.prototype.getPopupAlign = function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return Object(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  };

  /**
   * @param popupVisible    Show or not the popup element
   * @param event           SyntheticEvent, used for `pointAlign`
   */
  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
    var alignPoint = this.props.alignPoint;
    var prevPopupVisible = this.state.popupVisible;


    this.clearDelayTimer();

    if (prevPopupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({ popupVisible: popupVisible, prevPopupVisible: prevPopupVisible });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }

    // Always record the point position since mouseEnterDelay will delay the show
    if (alignPoint && event) {
      this.setPoint(event);
    }
  };

  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
    var _this2 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
      this.delayTimer = setTimeout(function () {
        _this2.setPopupVisible(visible, point);
        _this2.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible, event);
    }
  };

  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  };

  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.contextMenuOutsideHandler1) {
      this.contextMenuOutsideHandler1.remove();
      this.contextMenuOutsideHandler1 = null;
    }

    if (this.contextMenuOutsideHandler2) {
      this.contextMenuOutsideHandler2.remove();
      this.contextMenuOutsideHandler2 = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  };

  Trigger.prototype.createTwoChains = function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  };

  Trigger.prototype.isClickToShow = function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
    var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;

    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
  };

  Trigger.prototype.isClickToHide = function isClickToHide() {
    var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
    var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  };

  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
    var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  };

  Trigger.prototype.isFocusToShow = function isFocusToShow() {
    var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  };

  Trigger.prototype.isBlurToHide = function isBlurToHide() {
    var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  };

  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  };

  Trigger.prototype.fireEvents = function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  };

  Trigger.prototype.close = function close() {
    this.setPopupVisible(false);
  };

  Trigger.prototype.render = function render() {
    var _this3 = this;

    var popupVisible = this.state.popupVisible;
    var _props8 = this.props,
        children = _props8.children,
        forceRender = _props8.forceRender,
        alignPoint = _props8.alignPoint,
        className = _props8.className;

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    var newChildProps = { key: 'trigger' };

    if (this.isContextMenuToShow()) {
      newChildProps.onContextMenu = this.onContextMenu;
    } else {
      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
    }

    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
      if (alignPoint) {
        newChildProps.onMouseMove = this.onMouseMove;
      }
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    var childrenClassName = __WEBPACK_IMPORTED_MODULE_12_classnames___default()(child && child.props && child.props.className, className);
    if (childrenClassName) {
      newChildProps.className = childrenClassName;
    }
    var trigger = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newChildProps);

    if (!IS_REACT_16) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__["a" /* default */],
        {
          parent: this,
          visible: popupVisible,
          autoMount: false,
          forceRender: forceRender,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        },
        function (_ref2) {
          var renderComponent = _ref2.renderComponent;

          _this3.renderComponent = renderComponent;
          return trigger;
        }
      );
    }

    var portal = void 0;
    // prevent unmounting after it's rendered
    if (popupVisible || this._component || forceRender) {
      portal = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__["a" /* default */],
        { key: 'portal', getContainer: this.getContainer, didUpdate: this.handlePortalUpdate },
        this.getComponent()
      );
    }

    return [trigger, portal];
  };

  return Trigger;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Trigger.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  action: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  showAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  hideAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  popupStyle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  popupAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  focusDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  blurDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getDocument: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  forceRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  mask: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskClosable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onPopupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultPopupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  maskAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  alignPoint: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool // Maybe we can support user pass position in the future
};
Trigger.contextTypes = contextTypes;
Trigger.childContextTypes = contextTypes;
Trigger.defaultProps = {
  prefixCls: 'rc-trigger-popup',
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: noop,
  afterPopupVisibleChange: noop,
  onPopupAlign: noop,
  popupClassName: '',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: false,
  popupAlign: {},
  defaultPopupVisible: false,
  mask: false,
  maskClosable: true,
  action: [],
  showAction: [],
  hideAction: []
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onMouseEnter = function (e) {
    var mouseEnterDelay = _this4.props.mouseEnterDelay;

    _this4.fireEvents('onMouseEnter', e);
    _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
  };

  this.onMouseMove = function (e) {
    _this4.fireEvents('onMouseMove', e);
    _this4.setPoint(e);
  };

  this.onMouseLeave = function (e) {
    _this4.fireEvents('onMouseLeave', e);
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onPopupMouseEnter = function () {
    _this4.clearDelayTimer();
  };

  this.onPopupMouseLeave = function (e) {
    // https://github.com/react-component/trigger/pull/13
    // react bug?
    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(_this4._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onFocus = function (e) {
    _this4.fireEvents('onFocus', e);
    // incase focusin and focusout
    _this4.clearDelayTimer();
    if (_this4.isFocusToShow()) {
      _this4.focusTime = Date.now();
      _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
    }
  };

  this.onMouseDown = function (e) {
    _this4.fireEvents('onMouseDown', e);
    _this4.preClickTime = Date.now();
  };

  this.onTouchStart = function (e) {
    _this4.fireEvents('onTouchStart', e);
    _this4.preTouchTime = Date.now();
  };

  this.onBlur = function (e) {
    _this4.fireEvents('onBlur', e);
    _this4.clearDelayTimer();
    if (_this4.isBlurToHide()) {
      _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
    }
  };

  this.onContextMenu = function (e) {
    e.preventDefault();
    _this4.fireEvents('onContextMenu', e);
    _this4.setPopupVisible(true, e);
  };

  this.onContextMenuClose = function () {
    if (_this4.isContextMenuToShow()) {
      _this4.close();
    }
  };

  this.onClick = function (event) {
    _this4.fireEvents('onClick', event);
    // focus will trigger click
    if (_this4.focusTime) {
      var preTime = void 0;
      if (_this4.preClickTime && _this4.preTouchTime) {
        preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
      } else if (_this4.preClickTime) {
        preTime = _this4.preClickTime;
      } else if (_this4.preTouchTime) {
        preTime = _this4.preTouchTime;
      }
      if (Math.abs(preTime - _this4.focusTime) < 20) {
        return;
      }
      _this4.focusTime = 0;
    }
    _this4.preClickTime = 0;
    _this4.preTouchTime = 0;

    // Only prevent default when all the action is click.
    // https://github.com/ant-design/ant-design/issues/17043
    // https://github.com/ant-design/ant-design/issues/17291
    if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) {
      event.preventDefault();
    }
    var nextVisible = !_this4.state.popupVisible;
    if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
      _this4.setPopupVisible(!_this4.state.popupVisible, event);
    }
  };

  this.onPopupMouseDown = function () {
    var _context$rcTrigger = _this4.context.rcTrigger,
        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;

    _this4.hasPopupMouseDown = true;

    clearTimeout(_this4.mouseDownTimeout);
    _this4.mouseDownTimeout = setTimeout(function () {
      _this4.hasPopupMouseDown = false;
    }, 0);

    if (rcTrigger.onPopupMouseDown) {
      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
    }
  };

  this.onDocumentClick = function (event) {
    if (_this4.props.mask && !_this4.props.maskClosable) {
      return;
    }

    var target = event.target;
    var root = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
    if (!Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !_this4.hasPopupMouseDown) {
      _this4.close();
    }
  };

  this.getRootDomNode = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
  };

  this.getPopupClassNameFromAlign = function (align) {
    var className = [];
    var _props9 = _this4.props,
        popupPlacement = _props9.popupPlacement,
        builtinPlacements = _props9.builtinPlacements,
        prefixCls = _props9.prefixCls,
        alignPoint = _props9.alignPoint,
        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;

    if (popupPlacement && builtinPlacements) {
      className.push(Object(__WEBPACK_IMPORTED_MODULE_13__utils__["b" /* getAlignPopupClassName */])(builtinPlacements, prefixCls, align, alignPoint));
    }
    if (getPopupClassNameFromAlign) {
      className.push(getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  };

  this.getComponent = function () {
    var _props10 = _this4.props,
        prefixCls = _props10.prefixCls,
        destroyPopupOnHide = _props10.destroyPopupOnHide,
        popupClassName = _props10.popupClassName,
        action = _props10.action,
        onPopupAlign = _props10.onPopupAlign,
        popupAnimation = _props10.popupAnimation,
        popupTransitionName = _props10.popupTransitionName,
        popupStyle = _props10.popupStyle,
        mask = _props10.mask,
        maskAnimation = _props10.maskAnimation,
        maskTransitionName = _props10.maskTransitionName,
        zIndex = _props10.zIndex,
        popup = _props10.popup,
        stretch = _props10.stretch,
        alignPoint = _props10.alignPoint;
    var _state = _this4.state,
        popupVisible = _state.popupVisible,
        point = _state.point;


    var align = _this4.getPopupAlign();

    var mouseProps = {};
    if (_this4.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
    }
    if (_this4.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
    }

    mouseProps.onMouseDown = _this4.onPopupMouseDown;
    mouseProps.onTouchStart = _this4.onPopupMouseDown;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_14__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: prefixCls,
        destroyPopupOnHide: destroyPopupOnHide,
        visible: popupVisible,
        point: alignPoint && point,
        className: popupClassName,
        action: action,
        align: align,
        onAlign: onPopupAlign,
        animation: popupAnimation,
        getClassNameFromAlign: _this4.getPopupClassNameFromAlign
      }, mouseProps, {
        stretch: stretch,
        getRootDomNode: _this4.getRootDomNode,
        style: popupStyle,
        mask: mask,
        zIndex: zIndex,
        transitionName: popupTransitionName,
        maskAnimation: maskAnimation,
        maskTransitionName: maskTransitionName,
        ref: _this4.savePopup
      }),
      typeof popup === 'function' ? popup() : popup
    );
  };

  this.getContainer = function () {
    var props = _this4.props;

    var popupContainer = document.createElement('div');
    // Make sure default popup container will never cause scrollbar appearing
    // https://github.com/react-component/trigger/issues/41
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4)) : props.getDocument().body;
    mountNode.appendChild(popupContainer);
    return popupContainer;
  };

  this.setPoint = function (point) {
    var alignPoint = _this4.props.alignPoint;

    if (!alignPoint || !point) return;

    _this4.setState({
      point: {
        pageX: point.pageX,
        pageY: point.pageY
      }
    });
  };

  this.handlePortalUpdate = function () {
    if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) {
      _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
    }
  };

  this.savePopup = function (node) {
    _this4._component = node;
  };
};

Object(__WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__["polyfill"])(Trigger);

/* harmony default export */ __webpack_exports__["default"] = (Trigger);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getTodayTime;
/* harmony export (immutable) */ __webpack_exports__["d"] = getTitleString;
/* harmony export (immutable) */ __webpack_exports__["f"] = getTodayTimeStr;
/* harmony export (immutable) */ __webpack_exports__["b"] = getMonthName;
/* harmony export (immutable) */ __webpack_exports__["h"] = syncTime;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTimeConfig;
/* unused harmony export isTimeValidByConfig */
/* unused harmony export isTimeValid */
/* harmony export (immutable) */ __webpack_exports__["g"] = isAllowedDate;
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



var defaultDisabledTime = {
  disabledHours: function disabledHours() {
    return [];
  },
  disabledMinutes: function disabledMinutes() {
    return [];
  },
  disabledSeconds: function disabledSeconds() {
    return [];
  }
};

function getTodayTime(value) {
  var today = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
  today.locale(value.locale()).utcOffset(value.utcOffset());
  return today;
}

function getTitleString(value) {
  return value.format('LL');
}

function getTodayTimeStr(value) {
  var today = getTodayTime(value);
  return getTitleString(today);
}

function getMonthName(month) {
  var locale = month.locale();
  var localeData = month.localeData();
  return localeData[locale === 'zh-cn' ? 'months' : 'monthsShort'](month);
}

function syncTime(from, to) {
  if (!__WEBPACK_IMPORTED_MODULE_1_moment___default.a.isMoment(from) || !__WEBPACK_IMPORTED_MODULE_1_moment___default.a.isMoment(to)) return;
  to.hour(from.hour());
  to.minute(from.minute());
  to.second(from.second());
  to.millisecond(from.millisecond());
}

function getTimeConfig(value, disabledTime) {
  var disabledTimeConfig = disabledTime ? disabledTime(value) : {};
  disabledTimeConfig = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultDisabledTime, disabledTimeConfig);
  return disabledTimeConfig;
}

function isTimeValidByConfig(value, disabledTimeConfig) {
  var invalidTime = false;
  if (value) {
    var hour = value.hour();
    var minutes = value.minute();
    var seconds = value.second();
    var disabledHours = disabledTimeConfig.disabledHours();
    if (disabledHours.indexOf(hour) === -1) {
      var disabledMinutes = disabledTimeConfig.disabledMinutes(hour);
      if (disabledMinutes.indexOf(minutes) === -1) {
        var disabledSeconds = disabledTimeConfig.disabledSeconds(hour, minutes);
        invalidTime = disabledSeconds.indexOf(seconds) !== -1;
      } else {
        invalidTime = true;
      }
    } else {
      invalidTime = true;
    }
  }
  return !invalidTime;
}

function isTimeValid(value, disabledTime) {
  var disabledTimeConfig = getTimeConfig(value, disabledTime);
  return isTimeValidByConfig(value, disabledTimeConfig);
}

function isAllowedDate(value, disabledDate, disabledTime) {
  if (disabledDate) {
    if (disabledDate(value)) {
      return false;
    }
  }
  if (disabledTime) {
    if (!isTimeValid(value, disabledTime)) {
      return false;
    }
  }
  return true;
}

function formatDate(value, format) {
  if (!value) {
    return '';
  }

  if (Array.isArray(format)) {
    format = format[0];
  }

  return value.format(format);
}

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,

  /**
   * BACKSPACE
   */
  BACKSPACE: 8,

  /**
   * TAB
   */
  TAB: 9,

  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,

  /**
   * ENTER
   */
  ENTER: 13,

  /**
   * SHIFT
   */
  SHIFT: 16,

  /**
   * CTRL
   */
  CTRL: 17,

  /**
   * ALT
   */
  ALT: 18,

  /**
   * PAUSE
   */
  PAUSE: 19,

  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,

  /**
   * ESC
   */
  ESC: 27,

  /**
   * SPACE
   */
  SPACE: 32,

  /**
   * PAGE_UP
   */
  PAGE_UP: 33,

  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,

  /**
   * END
   */
  END: 35,

  /**
   * HOME
   */
  HOME: 36,

  /**
   * LEFT
   */
  LEFT: 37,

  /**
   * UP
   */
  UP: 38,

  /**
   * RIGHT
   */
  RIGHT: 39,

  /**
   * DOWN
   */
  DOWN: 40,

  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,

  /**
   * INSERT
   */
  INSERT: 45,

  /**
   * DELETE
   */
  DELETE: 46,

  /**
   * ZERO
   */
  ZERO: 48,

  /**
   * ONE
   */
  ONE: 49,

  /**
   * TWO
   */
  TWO: 50,

  /**
   * THREE
   */
  THREE: 51,

  /**
   * FOUR
   */
  FOUR: 52,

  /**
   * FIVE
   */
  FIVE: 53,

  /**
   * SIX
   */
  SIX: 54,

  /**
   * SEVEN
   */
  SEVEN: 55,

  /**
   * EIGHT
   */
  EIGHT: 56,

  /**
   * NINE
   */
  NINE: 57,

  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,

  /**
   * A
   */
  A: 65,

  /**
   * B
   */
  B: 66,

  /**
   * C
   */
  C: 67,

  /**
   * D
   */
  D: 68,

  /**
   * E
   */
  E: 69,

  /**
   * F
   */
  F: 70,

  /**
   * G
   */
  G: 71,

  /**
   * H
   */
  H: 72,

  /**
   * I
   */
  I: 73,

  /**
   * J
   */
  J: 74,

  /**
   * K
   */
  K: 75,

  /**
   * L
   */
  L: 76,

  /**
   * M
   */
  M: 77,

  /**
   * N
   */
  N: 78,

  /**
   * O
   */
  O: 79,

  /**
   * P
   */
  P: 80,

  /**
   * Q
   */
  Q: 81,

  /**
   * R
   */
  R: 82,

  /**
   * S
   */
  S: 83,

  /**
   * T
   */
  T: 84,

  /**
   * U
   */
  U: 85,

  /**
   * V
   */
  V: 86,

  /**
   * W
   */
  W: 87,

  /**
   * X
   */
  X: 88,

  /**
   * Y
   */
  Y: 89,

  /**
   * Z
   */
  Z: 90,

  /**
   * META
   */
  META: 91,

  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,

  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,

  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,

  /**
   * NUM_ONE
   */
  NUM_ONE: 97,

  /**
   * NUM_TWO
   */
  NUM_TWO: 98,

  /**
   * NUM_THREE
   */
  NUM_THREE: 99,

  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,

  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,

  /**
   * NUM_SIX
   */
  NUM_SIX: 102,

  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,

  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,

  /**
   * NUM_NINE
   */
  NUM_NINE: 105,

  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,

  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,

  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,

  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,

  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,

  /**
   * F1
   */
  F1: 112,

  /**
   * F2
   */
  F2: 113,

  /**
   * F3
   */
  F3: 114,

  /**
   * F4
   */
  F4: 115,

  /**
   * F5
   */
  F5: 116,

  /**
   * F6
   */
  F6: 117,

  /**
   * F7
   */
  F7: 118,

  /**
   * F8
   */
  F8: 119,

  /**
   * F9
   */
  F9: 120,

  /**
   * F10
   */
  F10: 121,

  /**
   * F11
   */
  F11: 122,

  /**
   * F12
   */
  F12: 123,

  /**
   * NUMLOCK
   */
  NUMLOCK: 144,

  /**
   * SEMICOLON
   */
  SEMICOLON: 186,

  /**
   * DASH
   */
  DASH: 189,

  /**
   * EQUALS
   */
  EQUALS: 187,

  /**
   * COMMA
   */
  COMMA: 188,

  /**
   * PERIOD
   */
  PERIOD: 190,

  /**
   * SLASH
   */
  SLASH: 191,

  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,

  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,

  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,

  /**
   * BACKSLASH
   */
  BACKSLASH: 220,

  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,

  /**
   * WIN_KEY
   */
  WIN_KEY: 224,

  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,

  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================

  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;

    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    } // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.


    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;

      default:
        return true;
    }
  },

  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }

    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }

    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    } // Safari sends zero key code for non-latin characters.


    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }

    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;

      default:
        return false;
    }
  }
};
var _default = KeyCode;
exports.default = _default;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(265),
    getRawTag = __webpack_require__(993),
    objectToString = __webpack_require__(994);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var scrollbarVerticalSize;
var scrollbarHorizontalSize; // Measure scrollbar width for padding body during modal show/hide

var scrollbarMeasure = {
  position: 'absolute',
  top: '-9999px',
  width: '50px',
  height: '50px'
}; // This const is used for colgroup.col internal props. And should not provides to user.

exports.INTERNAL_COL_DEFINE = 'RC_TABLE_INTERNAL_COL_DEFINE';

function measureScrollbar(_ref) {
  var _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'vertical' : _ref$direction,
      prefixCls = _ref.prefixCls;

  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return 0;
  }

  var isVertical = direction === 'vertical';

  if (isVertical && scrollbarVerticalSize) {
    return scrollbarVerticalSize;
  }

  if (!isVertical && scrollbarHorizontalSize) {
    return scrollbarHorizontalSize;
  }

  var scrollDiv = document.createElement('div');
  Object.keys(scrollbarMeasure).forEach(function (scrollProp) {
    scrollDiv.style[scrollProp] = scrollbarMeasure[scrollProp];
  }); // apply hide scrollbar className ahead

  scrollDiv.className = "".concat(prefixCls, "-hide-scrollbar scroll-div-append-to-body"); // Append related overflow style

  if (isVertical) {
    scrollDiv.style.overflowY = 'scroll';
  } else {
    scrollDiv.style.overflowX = 'scroll';
  }

  document.body.appendChild(scrollDiv);
  var size = 0;

  if (isVertical) {
    size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    scrollbarVerticalSize = size;
  } else {
    size = scrollDiv.offsetHeight - scrollDiv.clientHeight;
    scrollbarHorizontalSize = size;
  }

  document.body.removeChild(scrollDiv);
  return size;
}

exports.measureScrollbar = measureScrollbar;

function debounce(func, wait, immediate) {
  var timeout;

  function debounceFunc() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var context = this; // https://fb.me/react-event-pooling

    if (args[0] && args[0].persist) {
      args[0].persist();
    }

    var later = function later() {
      timeout = null;

      if (!immediate) {
        func.apply(context, args);
      }
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow) {
      func.apply(context, args);
    }
  }

  debounceFunc.cancel = function cancel() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounceFunc;
}

exports.debounce = debounce;

function remove(array, item) {
  var index = array.indexOf(item);
  var front = array.slice(0, index);
  var last = array.slice(index + 1, array.length);
  return front.concat(last);
}

exports.remove = remove;
/**
 * Returns only data- and aria- key/value pairs
 * @param {object} props
 */

function getDataAndAriaProps(props) {
  return Object.keys(props).reduce(function (memo, key) {
    if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-') {
      memo[key] = props[key];
    }

    return memo;
  }, {});
}

exports.getDataAndAriaProps = getDataAndAriaProps;

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(66).f;
var has = __webpack_require__(94);
var TAG = __webpack_require__(56)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(104);
var TAG = __webpack_require__(56)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(15);
var defined = __webpack_require__(118);
var fails = __webpack_require__(51);
var spaces = __webpack_require__(375);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var Displayable = __webpack_require__(233);

var BoundingRect = __webpack_require__(57);

var zrUtil = __webpack_require__(1);

var imageHelper = __webpack_require__(406);

/**
 * @alias zrender/graphic/Image
 * @extends module:zrender/graphic/Displayable
 * @constructor
 * @param {Object} opts
 */
function ZImage(opts) {
  Displayable.call(this, opts);
}

ZImage.prototype = {
  constructor: ZImage,
  type: 'image',
  brush: function (ctx, prevEl) {
    var style = this.style;
    var src = style.image; // Must bind each time

    style.bind(ctx, this, prevEl);
    var image = this._image = imageHelper.createOrUpdateImage(src, this._image, this, this.onload);

    if (!image || !imageHelper.isImageReady(image)) {
      return;
    } // 图片已经加载完成
    // if (image.nodeName.toUpperCase() == 'IMG') {
    //     if (!image.complete) {
    //         return;
    //     }
    // }
    // Else is canvas


    var x = style.x || 0;
    var y = style.y || 0;
    var width = style.width;
    var height = style.height;
    var aspect = image.width / image.height;

    if (width == null && height != null) {
      // Keep image/height ratio
      width = height * aspect;
    } else if (height == null && width != null) {
      height = width / aspect;
    } else if (width == null && height == null) {
      width = image.width;
      height = image.height;
    } // 设置transform


    this.setTransform(ctx);

    if (style.sWidth && style.sHeight) {
      var sx = style.sx || 0;
      var sy = style.sy || 0;
      ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
    } else if (style.sx && style.sy) {
      var sx = style.sx;
      var sy = style.sy;
      var sWidth = width - sx;
      var sHeight = height - sy;
      ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
    } else {
      ctx.drawImage(image, x, y, width, height);
    } // Draw rect text


    if (style.text != null) {
      // Only restore transform when needs draw text.
      this.restoreTransform(ctx);
      this.drawRectText(ctx, this.getBoundingRect());
    }
  },
  getBoundingRect: function () {
    var style = this.style;

    if (!this._rect) {
      this._rect = new BoundingRect(style.x || 0, style.y || 0, style.width || 0, style.height || 0);
    }

    return this._rect;
  }
};
zrUtil.inherits(ZImage, Displayable);
var _default = ZImage;
module.exports = _default;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// TODO Parse shadow style
// TODO Only shallow path support
function _default(properties) {
  // Normalize
  for (var i = 0; i < properties.length; i++) {
    if (!properties[i][1]) {
      properties[i][1] = properties[i][0];
    }
  }

  return function (model, excludes, includes) {
    var style = {};

    for (var i = 0; i < properties.length; i++) {
      var propName = properties[i][1];

      if (excludes && zrUtil.indexOf(excludes, propName) >= 0 || includes && zrUtil.indexOf(includes, propName) < 0) {
        continue;
      }

      var val = model.getShallow(propName);

      if (val != null) {
        style[properties[i][0]] = val;
      }
    }

    return style;
  };
}

module.exports = _default;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var curve = __webpack_require__(147);

var vec2 = __webpack_require__(55);

var bbox = __webpack_require__(234);

var BoundingRect = __webpack_require__(57);

var _config = __webpack_require__(293);

var dpr = _config.devicePixelRatio;

/**
 * Path 代理，可以在`buildPath`中用于替代`ctx`, 会保存每个path操作的命令到pathCommands属性中
 * 可以用于 isInsidePath 判断以及获取boundingRect
 *
 * @module zrender/core/PathProxy
 * @author Yi Shen (http://www.github.com/pissang)
 */
// TODO getTotalLength, getPointAtLength

/* global Float32Array */
var CMD = {
  M: 1,
  L: 2,
  C: 3,
  Q: 4,
  A: 5,
  Z: 6,
  // Rect
  R: 7
}; // var CMD_MEM_SIZE = {
//     M: 3,
//     L: 3,
//     C: 7,
//     Q: 5,
//     A: 9,
//     R: 5,
//     Z: 1
// };

var min = [];
var max = [];
var min2 = [];
var max2 = [];
var mathMin = Math.min;
var mathMax = Math.max;
var mathCos = Math.cos;
var mathSin = Math.sin;
var mathSqrt = Math.sqrt;
var mathAbs = Math.abs;
var hasTypedArray = typeof Float32Array !== 'undefined';
/**
 * @alias module:zrender/core/PathProxy
 * @constructor
 */

var PathProxy = function (notSaveData) {
  this._saveData = !(notSaveData || false);

  if (this._saveData) {
    /**
     * Path data. Stored as flat array
     * @type {Array.<Object>}
     */
    this.data = [];
  }

  this._ctx = null;
};
/**
 * 快速计算Path包围盒（并不是最小包围盒）
 * @return {Object}
 */


PathProxy.prototype = {
  constructor: PathProxy,
  _xi: 0,
  _yi: 0,
  _x0: 0,
  _y0: 0,
  // Unit x, Unit y. Provide for avoiding drawing that too short line segment
  _ux: 0,
  _uy: 0,
  _len: 0,
  _lineDash: null,
  _dashOffset: 0,
  _dashIdx: 0,
  _dashSum: 0,

  /**
   * @readOnly
   */
  setScale: function (sx, sy, segmentIgnoreThreshold) {
    // Compat. Previously there is no segmentIgnoreThreshold.
    segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
    this._ux = mathAbs(segmentIgnoreThreshold / dpr / sx) || 0;
    this._uy = mathAbs(segmentIgnoreThreshold / dpr / sy) || 0;
  },
  getContext: function () {
    return this._ctx;
  },

  /**
   * @param  {CanvasRenderingContext2D} ctx
   * @return {module:zrender/core/PathProxy}
   */
  beginPath: function (ctx) {
    this._ctx = ctx;
    ctx && ctx.beginPath();
    ctx && (this.dpr = ctx.dpr); // Reset

    if (this._saveData) {
      this._len = 0;
    }

    if (this._lineDash) {
      this._lineDash = null;
      this._dashOffset = 0;
    }

    return this;
  },

  /**
   * @param  {number} x
   * @param  {number} y
   * @return {module:zrender/core/PathProxy}
   */
  moveTo: function (x, y) {
    this.addData(CMD.M, x, y);
    this._ctx && this._ctx.moveTo(x, y); // x0, y0, xi, yi 是记录在 _dashedXXXXTo 方法中使用
    // xi, yi 记录当前点, x0, y0 在 closePath 的时候回到起始点。
    // 有可能在 beginPath 之后直接调用 lineTo，这时候 x0, y0 需要
    // 在 lineTo 方法中记录，这里先不考虑这种情况，dashed line 也只在 IE10- 中不支持

    this._x0 = x;
    this._y0 = y;
    this._xi = x;
    this._yi = y;
    return this;
  },

  /**
   * @param  {number} x
   * @param  {number} y
   * @return {module:zrender/core/PathProxy}
   */
  lineTo: function (x, y) {
    var exceedUnit = mathAbs(x - this._xi) > this._ux || mathAbs(y - this._yi) > this._uy // Force draw the first segment
    || this._len < 5;
    this.addData(CMD.L, x, y);

    if (this._ctx && exceedUnit) {
      this._needsDash() ? this._dashedLineTo(x, y) : this._ctx.lineTo(x, y);
    }

    if (exceedUnit) {
      this._xi = x;
      this._yi = y;
    }

    return this;
  },

  /**
   * @param  {number} x1
   * @param  {number} y1
   * @param  {number} x2
   * @param  {number} y2
   * @param  {number} x3
   * @param  {number} y3
   * @return {module:zrender/core/PathProxy}
   */
  bezierCurveTo: function (x1, y1, x2, y2, x3, y3) {
    this.addData(CMD.C, x1, y1, x2, y2, x3, y3);

    if (this._ctx) {
      this._needsDash() ? this._dashedBezierTo(x1, y1, x2, y2, x3, y3) : this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
    }

    this._xi = x3;
    this._yi = y3;
    return this;
  },

  /**
   * @param  {number} x1
   * @param  {number} y1
   * @param  {number} x2
   * @param  {number} y2
   * @return {module:zrender/core/PathProxy}
   */
  quadraticCurveTo: function (x1, y1, x2, y2) {
    this.addData(CMD.Q, x1, y1, x2, y2);

    if (this._ctx) {
      this._needsDash() ? this._dashedQuadraticTo(x1, y1, x2, y2) : this._ctx.quadraticCurveTo(x1, y1, x2, y2);
    }

    this._xi = x2;
    this._yi = y2;
    return this;
  },

  /**
   * @param  {number} cx
   * @param  {number} cy
   * @param  {number} r
   * @param  {number} startAngle
   * @param  {number} endAngle
   * @param  {boolean} anticlockwise
   * @return {module:zrender/core/PathProxy}
   */
  arc: function (cx, cy, r, startAngle, endAngle, anticlockwise) {
    this.addData(CMD.A, cx, cy, r, r, startAngle, endAngle - startAngle, 0, anticlockwise ? 0 : 1);
    this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
    this._xi = mathCos(endAngle) * r + cx;
    this._yi = mathSin(endAngle) * r + cy;
    return this;
  },
  // TODO
  arcTo: function (x1, y1, x2, y2, radius) {
    if (this._ctx) {
      this._ctx.arcTo(x1, y1, x2, y2, radius);
    }

    return this;
  },
  // TODO
  rect: function (x, y, w, h) {
    this._ctx && this._ctx.rect(x, y, w, h);
    this.addData(CMD.R, x, y, w, h);
    return this;
  },

  /**
   * @return {module:zrender/core/PathProxy}
   */
  closePath: function () {
    this.addData(CMD.Z);
    var ctx = this._ctx;
    var x0 = this._x0;
    var y0 = this._y0;

    if (ctx) {
      this._needsDash() && this._dashedLineTo(x0, y0);
      ctx.closePath();
    }

    this._xi = x0;
    this._yi = y0;
    return this;
  },

  /**
   * Context 从外部传入，因为有可能是 rebuildPath 完之后再 fill。
   * stroke 同样
   * @param {CanvasRenderingContext2D} ctx
   * @return {module:zrender/core/PathProxy}
   */
  fill: function (ctx) {
    ctx && ctx.fill();
    this.toStatic();
  },

  /**
   * @param {CanvasRenderingContext2D} ctx
   * @return {module:zrender/core/PathProxy}
   */
  stroke: function (ctx) {
    ctx && ctx.stroke();
    this.toStatic();
  },

  /**
   * 必须在其它绘制命令前调用
   * Must be invoked before all other path drawing methods
   * @return {module:zrender/core/PathProxy}
   */
  setLineDash: function (lineDash) {
    if (lineDash instanceof Array) {
      this._lineDash = lineDash;
      this._dashIdx = 0;
      var lineDashSum = 0;

      for (var i = 0; i < lineDash.length; i++) {
        lineDashSum += lineDash[i];
      }

      this._dashSum = lineDashSum;
    }

    return this;
  },

  /**
   * 必须在其它绘制命令前调用
   * Must be invoked before all other path drawing methods
   * @return {module:zrender/core/PathProxy}
   */
  setLineDashOffset: function (offset) {
    this._dashOffset = offset;
    return this;
  },

  /**
   *
   * @return {boolean}
   */
  len: function () {
    return this._len;
  },

  /**
   * 直接设置 Path 数据
   */
  setData: function (data) {
    var len = data.length;

    if (!(this.data && this.data.length === len) && hasTypedArray) {
      this.data = new Float32Array(len);
    }

    for (var i = 0; i < len; i++) {
      this.data[i] = data[i];
    }

    this._len = len;
  },

  /**
   * 添加子路径
   * @param {module:zrender/core/PathProxy|Array.<module:zrender/core/PathProxy>} path
   */
  appendPath: function (path) {
    if (!(path instanceof Array)) {
      path = [path];
    }

    var len = path.length;
    var appendSize = 0;
    var offset = this._len;

    for (var i = 0; i < len; i++) {
      appendSize += path[i].len();
    }

    if (hasTypedArray && this.data instanceof Float32Array) {
      this.data = new Float32Array(offset + appendSize);
    }

    for (var i = 0; i < len; i++) {
      var appendPathData = path[i].data;

      for (var k = 0; k < appendPathData.length; k++) {
        this.data[offset++] = appendPathData[k];
      }
    }

    this._len = offset;
  },

  /**
   * 填充 Path 数据。
   * 尽量复用而不申明新的数组。大部分图形重绘的指令数据长度都是不变的。
   */
  addData: function (cmd) {
    if (!this._saveData) {
      return;
    }

    var data = this.data;

    if (this._len + arguments.length > data.length) {
      // 因为之前的数组已经转换成静态的 Float32Array
      // 所以不够用时需要扩展一个新的动态数组
      this._expandData();

      data = this.data;
    }

    for (var i = 0; i < arguments.length; i++) {
      data[this._len++] = arguments[i];
    }

    this._prevCmd = cmd;
  },
  _expandData: function () {
    // Only if data is Float32Array
    if (!(this.data instanceof Array)) {
      var newData = [];

      for (var i = 0; i < this._len; i++) {
        newData[i] = this.data[i];
      }

      this.data = newData;
    }
  },

  /**
   * If needs js implemented dashed line
   * @return {boolean}
   * @private
   */
  _needsDash: function () {
    return this._lineDash;
  },
  _dashedLineTo: function (x1, y1) {
    var dashSum = this._dashSum;
    var offset = this._dashOffset;
    var lineDash = this._lineDash;
    var ctx = this._ctx;
    var x0 = this._xi;
    var y0 = this._yi;
    var dx = x1 - x0;
    var dy = y1 - y0;
    var dist = mathSqrt(dx * dx + dy * dy);
    var x = x0;
    var y = y0;
    var dash;
    var nDash = lineDash.length;
    var idx;
    dx /= dist;
    dy /= dist;

    if (offset < 0) {
      // Convert to positive offset
      offset = dashSum + offset;
    }

    offset %= dashSum;
    x -= offset * dx;
    y -= offset * dy;

    while (dx > 0 && x <= x1 || dx < 0 && x >= x1 || dx === 0 && (dy > 0 && y <= y1 || dy < 0 && y >= y1)) {
      idx = this._dashIdx;
      dash = lineDash[idx];
      x += dx * dash;
      y += dy * dash;
      this._dashIdx = (idx + 1) % nDash; // Skip positive offset

      if (dx > 0 && x < x0 || dx < 0 && x > x0 || dy > 0 && y < y0 || dy < 0 && y > y0) {
        continue;
      }

      ctx[idx % 2 ? 'moveTo' : 'lineTo'](dx >= 0 ? mathMin(x, x1) : mathMax(x, x1), dy >= 0 ? mathMin(y, y1) : mathMax(y, y1));
    } // Offset for next lineTo


    dx = x - x1;
    dy = y - y1;
    this._dashOffset = -mathSqrt(dx * dx + dy * dy);
  },
  // Not accurate dashed line to
  _dashedBezierTo: function (x1, y1, x2, y2, x3, y3) {
    var dashSum = this._dashSum;
    var offset = this._dashOffset;
    var lineDash = this._lineDash;
    var ctx = this._ctx;
    var x0 = this._xi;
    var y0 = this._yi;
    var t;
    var dx;
    var dy;
    var cubicAt = curve.cubicAt;
    var bezierLen = 0;
    var idx = this._dashIdx;
    var nDash = lineDash.length;
    var x;
    var y;
    var tmpLen = 0;

    if (offset < 0) {
      // Convert to positive offset
      offset = dashSum + offset;
    }

    offset %= dashSum; // Bezier approx length

    for (t = 0; t < 1; t += 0.1) {
      dx = cubicAt(x0, x1, x2, x3, t + 0.1) - cubicAt(x0, x1, x2, x3, t);
      dy = cubicAt(y0, y1, y2, y3, t + 0.1) - cubicAt(y0, y1, y2, y3, t);
      bezierLen += mathSqrt(dx * dx + dy * dy);
    } // Find idx after add offset


    for (; idx < nDash; idx++) {
      tmpLen += lineDash[idx];

      if (tmpLen > offset) {
        break;
      }
    }

    t = (tmpLen - offset) / bezierLen;

    while (t <= 1) {
      x = cubicAt(x0, x1, x2, x3, t);
      y = cubicAt(y0, y1, y2, y3, t); // Use line to approximate dashed bezier
      // Bad result if dash is long

      idx % 2 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
      t += lineDash[idx] / bezierLen;
      idx = (idx + 1) % nDash;
    } // Finish the last segment and calculate the new offset


    idx % 2 !== 0 && ctx.lineTo(x3, y3);
    dx = x3 - x;
    dy = y3 - y;
    this._dashOffset = -mathSqrt(dx * dx + dy * dy);
  },
  _dashedQuadraticTo: function (x1, y1, x2, y2) {
    // Convert quadratic to cubic using degree elevation
    var x3 = x2;
    var y3 = y2;
    x2 = (x2 + 2 * x1) / 3;
    y2 = (y2 + 2 * y1) / 3;
    x1 = (this._xi + 2 * x1) / 3;
    y1 = (this._yi + 2 * y1) / 3;

    this._dashedBezierTo(x1, y1, x2, y2, x3, y3);
  },

  /**
   * 转成静态的 Float32Array 减少堆内存占用
   * Convert dynamic array to static Float32Array
   */
  toStatic: function () {
    var data = this.data;

    if (data instanceof Array) {
      data.length = this._len;

      if (hasTypedArray) {
        this.data = new Float32Array(data);
      }
    }
  },

  /**
   * @return {module:zrender/core/BoundingRect}
   */
  getBoundingRect: function () {
    min[0] = min[1] = min2[0] = min2[1] = Number.MAX_VALUE;
    max[0] = max[1] = max2[0] = max2[1] = -Number.MAX_VALUE;
    var data = this.data;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;

    for (var i = 0; i < data.length;) {
      var cmd = data[i++];

      if (i === 1) {
        // 如果第一个命令是 L, C, Q
        // 则 previous point 同绘制命令的第一个 point
        //
        // 第一个命令为 Arc 的情况下会在后面特殊处理
        xi = data[i];
        yi = data[i + 1];
        x0 = xi;
        y0 = yi;
      }

      switch (cmd) {
        case CMD.M:
          // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
          // 在 closePath 的时候使用
          x0 = data[i++];
          y0 = data[i++];
          xi = x0;
          yi = y0;
          min2[0] = x0;
          min2[1] = y0;
          max2[0] = x0;
          max2[1] = y0;
          break;

        case CMD.L:
          bbox.fromLine(xi, yi, data[i], data[i + 1], min2, max2);
          xi = data[i++];
          yi = data[i++];
          break;

        case CMD.C:
          bbox.fromCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], min2, max2);
          xi = data[i++];
          yi = data[i++];
          break;

        case CMD.Q:
          bbox.fromQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], min2, max2);
          xi = data[i++];
          yi = data[i++];
          break;

        case CMD.A:
          // TODO Arc 判断的开销比较大
          var cx = data[i++];
          var cy = data[i++];
          var rx = data[i++];
          var ry = data[i++];
          var startAngle = data[i++];
          var endAngle = data[i++] + startAngle; // TODO Arc 旋转

          i += 1;
          var anticlockwise = 1 - data[i++];

          if (i === 1) {
            // 直接使用 arc 命令
            // 第一个命令起点还未定义
            x0 = mathCos(startAngle) * rx + cx;
            y0 = mathSin(startAngle) * ry + cy;
          }

          bbox.fromArc(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, min2, max2);
          xi = mathCos(endAngle) * rx + cx;
          yi = mathSin(endAngle) * ry + cy;
          break;

        case CMD.R:
          x0 = xi = data[i++];
          y0 = yi = data[i++];
          var width = data[i++];
          var height = data[i++]; // Use fromLine

          bbox.fromLine(x0, y0, x0 + width, y0 + height, min2, max2);
          break;

        case CMD.Z:
          xi = x0;
          yi = y0;
          break;
      } // Union


      vec2.min(min, min, min2);
      vec2.max(max, max, max2);
    } // No data


    if (i === 0) {
      min[0] = min[1] = max[0] = max[1] = 0;
    }

    return new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
  },

  /**
   * Rebuild path from current data
   * Rebuild path will not consider javascript implemented line dash.
   * @param {CanvasRenderingContext2D} ctx
   */
  rebuildPath: function (ctx) {
    var d = this.data;
    var x0;
    var y0;
    var xi;
    var yi;
    var x;
    var y;
    var ux = this._ux;
    var uy = this._uy;
    var len = this._len;

    for (var i = 0; i < len;) {
      var cmd = d[i++];

      if (i === 1) {
        // 如果第一个命令是 L, C, Q
        // 则 previous point 同绘制命令的第一个 point
        //
        // 第一个命令为 Arc 的情况下会在后面特殊处理
        xi = d[i];
        yi = d[i + 1];
        x0 = xi;
        y0 = yi;
      }

      switch (cmd) {
        case CMD.M:
          x0 = xi = d[i++];
          y0 = yi = d[i++];
          ctx.moveTo(xi, yi);
          break;

        case CMD.L:
          x = d[i++];
          y = d[i++]; // Not draw too small seg between

          if (mathAbs(x - xi) > ux || mathAbs(y - yi) > uy || i === len - 1) {
            ctx.lineTo(x, y);
            xi = x;
            yi = y;
          }

          break;

        case CMD.C:
          ctx.bezierCurveTo(d[i++], d[i++], d[i++], d[i++], d[i++], d[i++]);
          xi = d[i - 2];
          yi = d[i - 1];
          break;

        case CMD.Q:
          ctx.quadraticCurveTo(d[i++], d[i++], d[i++], d[i++]);
          xi = d[i - 2];
          yi = d[i - 1];
          break;

        case CMD.A:
          var cx = d[i++];
          var cy = d[i++];
          var rx = d[i++];
          var ry = d[i++];
          var theta = d[i++];
          var dTheta = d[i++];
          var psi = d[i++];
          var fs = d[i++];
          var r = rx > ry ? rx : ry;
          var scaleX = rx > ry ? 1 : rx / ry;
          var scaleY = rx > ry ? ry / rx : 1;
          var isEllipse = Math.abs(rx - ry) > 1e-3;
          var endAngle = theta + dTheta;

          if (isEllipse) {
            ctx.translate(cx, cy);
            ctx.rotate(psi);
            ctx.scale(scaleX, scaleY);
            ctx.arc(0, 0, r, theta, endAngle, 1 - fs);
            ctx.scale(1 / scaleX, 1 / scaleY);
            ctx.rotate(-psi);
            ctx.translate(-cx, -cy);
          } else {
            ctx.arc(cx, cy, r, theta, endAngle, 1 - fs);
          }

          if (i === 1) {
            // 直接使用 arc 命令
            // 第一个命令起点还未定义
            x0 = mathCos(theta) * rx + cx;
            y0 = mathSin(theta) * ry + cy;
          }

          xi = mathCos(endAngle) * rx + cx;
          yi = mathSin(endAngle) * ry + cy;
          break;

        case CMD.R:
          x0 = xi = d[i];
          y0 = yi = d[i + 1];
          ctx.rect(d[i++], d[i++], d[i++], d[i++]);
          break;

        case CMD.Z:
          ctx.closePath();
          xi = x0;
          yi = y0;
      }
    }
  }
};
PathProxy.CMD = CMD;
var _default = PathProxy;
module.exports = _default;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _model = __webpack_require__(44);

var makeInner = _model.makeInner;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @return {string} If large mode changed, return string 'reset';
 */
function _default() {
  var inner = makeInner();
  return function (seriesModel) {
    var fields = inner(seriesModel);
    var pipelineContext = seriesModel.pipelineContext;
    var originalLarge = fields.large;
    var originalProgressive = fields.progressiveRender; // FIXME: if the planner works on a filtered series, `pipelineContext` does not
    // exists. See #11611 . Probably we need to modify this structure, see the comment
    // on `performRawSeries` in `Schedular.js`.

    var large = fields.large = pipelineContext && pipelineContext.large;
    var progressive = fields.progressiveRender = pipelineContext && pipelineContext.progressiveRender;
    return !!(originalLarge ^ large || originalProgressive ^ progressive) && 'reset';
  };
}

module.exports = _default;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var completeDimensions = __webpack_require__(641);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Substitute `completeDimensions`.
 * `completeDimensions` is to be deprecated.
 */

/**
 * @param {module:echarts/data/Source|module:echarts/data/List} source or data.
 * @param {Object|Array} [opt]
 * @param {Array.<string|Object>} [opt.coordDimensions=[]]
 * @param {number} [opt.dimensionsCount]
 * @param {string} [opt.generateCoord]
 * @param {string} [opt.generateCoordCount]
 * @param {Array.<string|Object>} [opt.dimensionsDefine=source.dimensionsDefine] Overwrite source define.
 * @param {Object|HashMap} [opt.encodeDefine=source.encodeDefine] Overwrite source define.
 * @param {Function} [opt.encodeDefaulter] Make default encode if user not specified.
 * @return {Array.<Object>} dimensionsInfo
 */
function _default(source, opt) {
  opt = opt || {};
  return completeDimensions(opt.coordDimensions || [], source, {
    dimsDef: opt.dimensionsDefine || source.dimensionsDefine,
    encodeDef: opt.encodeDefine || source.encodeDefine,
    dimCount: opt.dimensionsCount,
    encodeDefaulter: opt.encodeDefaulter,
    generateCoord: opt.generateCoord,
    generateCoordCount: opt.generateCoordCount
  });
}

module.exports = _default;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// import * as axisHelper from './axisHelper';
var _default = {
  /**
   * @param {boolean} origin
   * @return {number|string} min value or 'dataMin' or null/undefined (means auto) or NaN
   */
  getMin: function (origin) {
    var option = this.option;
    var min = !origin && option.rangeStart != null ? option.rangeStart : option.min;

    if (this.axis && min != null && min !== 'dataMin' && typeof min !== 'function' && !zrUtil.eqNaN(min)) {
      min = this.axis.scale.parse(min);
    }

    return min;
  },

  /**
   * @param {boolean} origin
   * @return {number|string} max value or 'dataMax' or null/undefined (means auto) or NaN
   */
  getMax: function (origin) {
    var option = this.option;
    var max = !origin && option.rangeEnd != null ? option.rangeEnd : option.max;

    if (this.axis && max != null && max !== 'dataMax' && typeof max !== 'function' && !zrUtil.eqNaN(max)) {
      max = this.axis.scale.parse(max);
    }

    return max;
  },

  /**
   * @return {boolean}
   */
  getNeedCrossZero: function () {
    var option = this.option;
    return option.rangeStart != null || option.rangeEnd != null ? false : !option.scale;
  },

  /**
   * Should be implemented by each axis model if necessary.
   * @return {module:echarts/model/Component} coordinate system model
   */
  getCoordSysModel: zrUtil.noop,

  /**
   * @param {number} rangeStart Can only be finite number or null/undefined or NaN.
   * @param {number} rangeEnd Can only be finite number or null/undefined or NaN.
   */
  setRange: function (rangeStart, rangeEnd) {
    this.option.rangeStart = rangeStart;
    this.option.rangeEnd = rangeEnd;
  },

  /**
   * Reset range
   */
  resetRange: function () {
    // rangeStart and rangeEnd is readonly.
    this.option.rangeStart = this.option.rangeEnd = null;
  }
};
module.exports = _default;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var createDimensions = __webpack_require__(207);

var List = __webpack_require__(98);

var _util = __webpack_require__(1);

var extend = _util.extend;
var isArray = _util.isArray;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * [Usage]:
 * (1)
 * createListSimply(seriesModel, ['value']);
 * (2)
 * createListSimply(seriesModel, {
 *     coordDimensions: ['value'],
 *     dimensionsCount: 5
 * });
 *
 * @param {module:echarts/model/Series} seriesModel
 * @param {Object|Array.<string|Object>} opt opt or coordDimensions
 *        The options in opt, see `echarts/data/helper/createDimensions`
 * @param {Array.<string>} [nameList]
 * @return {module:echarts/data/List}
 */
function _default(seriesModel, opt, nameList) {
  opt = isArray(opt) && {
    coordDimensions: opt
  } || extend({}, opt);
  var source = seriesModel.getSource();
  var dimensionsInfo = createDimensions(source, opt);
  var list = new List(dimensionsInfo, seriesModel);
  list.initData(source, nameList);
  return list;
}

module.exports = _default;

/***/ }),
/* 210 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Calculate slider move result.
 * Usage:
 * (1) If both handle0 and handle1 are needed to be moved, set minSpan the same as
 * maxSpan and the same as `Math.abs(handleEnd[1] - handleEnds[0])`.
 * (2) If handle0 is forbidden to cross handle1, set minSpan as `0`.
 *
 * @param {number} delta Move length.
 * @param {Array.<number>} handleEnds handleEnds[0] can be bigger then handleEnds[1].
 *              handleEnds will be modified in this method.
 * @param {Array.<number>} extent handleEnds is restricted by extent.
 *              extent[0] should less or equals than extent[1].
 * @param {number|string} handleIndex Can be 'all', means that both move the two handleEnds.
 * @param {number} [minSpan] The range of dataZoom can not be smaller than that.
 *              If not set, handle0 and cross handle1. If set as a non-negative
 *              number (including `0`), handles will push each other when reaching
 *              the minSpan.
 * @param {number} [maxSpan] The range of dataZoom can not be larger than that.
 * @return {Array.<number>} The input handleEnds.
 */
function _default(delta, handleEnds, extent, handleIndex, minSpan, maxSpan) {
  delta = delta || 0;
  var extentSpan = extent[1] - extent[0]; // Notice maxSpan and minSpan can be null/undefined.

  if (minSpan != null) {
    minSpan = restrict(minSpan, [0, extentSpan]);
  }

  if (maxSpan != null) {
    maxSpan = Math.max(maxSpan, minSpan != null ? minSpan : 0);
  }

  if (handleIndex === 'all') {
    var handleSpan = Math.abs(handleEnds[1] - handleEnds[0]);
    handleSpan = restrict(handleSpan, [0, extentSpan]);
    minSpan = maxSpan = restrict(handleSpan, [minSpan, maxSpan]);
    handleIndex = 0;
  }

  handleEnds[0] = restrict(handleEnds[0], extent);
  handleEnds[1] = restrict(handleEnds[1], extent);
  var originalDistSign = getSpanSign(handleEnds, handleIndex);
  handleEnds[handleIndex] += delta; // Restrict in extent.

  var extentMinSpan = minSpan || 0;
  var realExtent = extent.slice();
  originalDistSign.sign < 0 ? realExtent[0] += extentMinSpan : realExtent[1] -= extentMinSpan;
  handleEnds[handleIndex] = restrict(handleEnds[handleIndex], realExtent); // Expand span.

  var currDistSign = getSpanSign(handleEnds, handleIndex);

  if (minSpan != null && (currDistSign.sign !== originalDistSign.sign || currDistSign.span < minSpan)) {
    // If minSpan exists, 'cross' is forbidden.
    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + originalDistSign.sign * minSpan;
  } // Shrink span.


  var currDistSign = getSpanSign(handleEnds, handleIndex);

  if (maxSpan != null && currDistSign.span > maxSpan) {
    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + currDistSign.sign * maxSpan;
  }

  return handleEnds;
}

function getSpanSign(handleEnds, handleIndex) {
  var dist = handleEnds[handleIndex] - handleEnds[1 - handleIndex]; // If `handleEnds[0] === handleEnds[1]`, always believe that handleEnd[0]
  // is at left of handleEnds[1] for non-cross case.

  return {
    span: Math.abs(dist),
    sign: dist > 0 ? -1 : dist < 0 ? 1 : handleIndex ? -1 : 1
  };
}

function restrict(value, extend) {
  return Math.min(extend[1] != null ? extend[1] : Infinity, Math.max(extend[0] != null ? extend[0] : -Infinity, value));
}

module.exports = _default;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var env = __webpack_require__(67);

var modelUtil = __webpack_require__(44);

var helper = __webpack_require__(429);

var AxisProxy = __webpack_require__(1759);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var each = zrUtil.each;
var eachAxisDim = helper.eachAxisDim;
var DataZoomModel = echarts.extendComponentModel({
  type: 'dataZoom',
  dependencies: ['xAxis', 'yAxis', 'zAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'series'],

  /**
   * @protected
   */
  defaultOption: {
    zlevel: 0,
    z: 4,
    // Higher than normal component (z: 2).
    orient: null,
    // Default auto by axisIndex. Possible value: 'horizontal', 'vertical'.
    xAxisIndex: null,
    // Default the first horizontal category axis.
    yAxisIndex: null,
    // Default the first vertical category axis.
    filterMode: 'filter',
    // Possible values: 'filter' or 'empty' or 'weakFilter'.
    // 'filter': data items which are out of window will be removed. This option is
    //          applicable when filtering outliers. For each data item, it will be
    //          filtered if one of the relevant dimensions is out of the window.
    // 'weakFilter': data items which are out of window will be removed. This option
    //          is applicable when filtering outliers. For each data item, it will be
    //          filtered only if all  of the relevant dimensions are out of the same
    //          side of the window.
    // 'empty': data items which are out of window will be set to empty.
    //          This option is applicable when user should not neglect
    //          that there are some data items out of window.
    // 'none': Do not filter.
    // Taking line chart as an example, line will be broken in
    // the filtered points when filterModel is set to 'empty', but
    // be connected when set to 'filter'.
    throttle: null,
    // Dispatch action by the fixed rate, avoid frequency.
    // default 100. Do not throttle when use null/undefined.
    // If animation === true and animationDurationUpdate > 0,
    // default value is 100, otherwise 20.
    start: 0,
    // Start percent. 0 ~ 100
    end: 100,
    // End percent. 0 ~ 100
    startValue: null,
    // Start value. If startValue specified, start is ignored.
    endValue: null,
    // End value. If endValue specified, end is ignored.
    minSpan: null,
    // 0 ~ 100
    maxSpan: null,
    // 0 ~ 100
    minValueSpan: null,
    // The range of dataZoom can not be smaller than that.
    maxValueSpan: null,
    // The range of dataZoom can not be larger than that.
    rangeMode: null // Array, can be 'value' or 'percent'.

  },

  /**
   * @override
   */
  init: function (option, parentModel, ecModel) {
    /**
     * key like x_0, y_1
     * @private
     * @type {Object}
     */
    this._dataIntervalByAxis = {};
    /**
     * @private
     */

    this._dataInfo = {};
    /**
     * key like x_0, y_1
     * @private
     */

    this._axisProxies = {};
    /**
     * @readOnly
     */

    this.textStyleModel;
    /**
     * @private
     */

    this._autoThrottle = true;
    /**
     * It is `[rangeModeForMin, rangeModeForMax]`.
     * The optional values for `rangeMode`:
     * + `'value'` mode: the axis extent will always be determined by
     *     `dataZoom.startValue` and `dataZoom.endValue`, despite
     *     how data like and how `axis.min` and `axis.max` are.
     * + `'percent'` mode: `100` represents 100% of the `[dMin, dMax]`,
     *     where `dMin` is `axis.min` if `axis.min` specified, otherwise `data.extent[0]`,
     *     and `dMax` is `axis.max` if `axis.max` specified, otherwise `data.extent[1]`.
     *     Axis extent will be determined by the result of the percent of `[dMin, dMax]`.
     *
     * For example, when users are using dynamic data (update data periodically via `setOption`),
     * if in `'value`' mode, the window will be kept in a fixed value range despite how
     * data are appended, while if in `'percent'` mode, whe window range will be changed alone with
     * the appended data (suppose `axis.min` and `axis.max` are not specified).
     *
     * @private
     */

    this._rangePropMode = ['percent', 'percent'];
    var inputRawOption = retrieveRawOption(option);
    /**
     * Suppose a "main process" start at the point that model prepared (that is,
     * model initialized or merged or method called in `action`).
     * We should keep the `main process` idempotent, that is, given a set of values
     * on `option`, we get the same result.
     *
     * But sometimes, values on `option` will be updated for providing users
     * a "final calculated value" (`dataZoomProcessor` will do that). Those value
     * should not be the base/input of the `main process`.
     *
     * So in that case we should save and keep the input of the `main process`
     * separately, called `settledOption`.
     *
     * For example, consider the case:
     * (Step_1) brush zoom the grid by `toolbox.dataZoom`,
     *     where the original input `option.startValue`, `option.endValue` are earsed by
     *     calculated value.
     * (Step)2) click the legend to hide and show a series,
     *     where the new range is calculated by the earsed `startValue` and `endValue`,
     *     which brings incorrect result.
     *
     * @readOnly
     */

    this.settledOption = inputRawOption;
    this.mergeDefaultAndTheme(option, ecModel);
    this.doInit(inputRawOption);
  },

  /**
   * @override
   */
  mergeOption: function (newOption) {
    var inputRawOption = retrieveRawOption(newOption); //FIX #2591

    zrUtil.merge(this.option, newOption, true);
    zrUtil.merge(this.settledOption, inputRawOption, true);
    this.doInit(inputRawOption);
  },

  /**
   * @protected
   */
  doInit: function (inputRawOption) {
    var thisOption = this.option; // Disable realtime view update if canvas is not supported.

    if (!env.canvasSupported) {
      thisOption.realtime = false;
    }

    this._setDefaultThrottle(inputRawOption);

    updateRangeUse(this, inputRawOption);
    var settledOption = this.settledOption;
    each([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
      // start/end has higher priority over startValue/endValue if they
      // both set, but we should make chart.setOption({endValue: 1000})
      // effective, rather than chart.setOption({endValue: 1000, end: null}).
      if (this._rangePropMode[index] === 'value') {
        thisOption[names[0]] = settledOption[names[0]] = null;
      } // Otherwise do nothing and use the merge result.

    }, this);
    this.textStyleModel = this.getModel('textStyle');

    this._resetTarget();

    this._giveAxisProxies();
  },

  /**
   * @private
   */
  _giveAxisProxies: function () {
    var axisProxies = this._axisProxies;
    this.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel, ecModel) {
      var axisModel = this.dependentModels[dimNames.axis][axisIndex]; // If exists, share axisProxy with other dataZoomModels.

      var axisProxy = axisModel.__dzAxisProxy || ( // Use the first dataZoomModel as the main model of axisProxy.
      axisModel.__dzAxisProxy = new AxisProxy(dimNames.name, axisIndex, this, ecModel)); // FIXME
      // dispose __dzAxisProxy

      axisProxies[dimNames.name + '_' + axisIndex] = axisProxy;
    }, this);
  },

  /**
   * @private
   */
  _resetTarget: function () {
    var thisOption = this.option;

    var autoMode = this._judgeAutoMode();

    eachAxisDim(function (dimNames) {
      var axisIndexName = dimNames.axisIndex;
      thisOption[axisIndexName] = modelUtil.normalizeToArray(thisOption[axisIndexName]);
    }, this);

    if (autoMode === 'axisIndex') {
      this._autoSetAxisIndex();
    } else if (autoMode === 'orient') {
      this._autoSetOrient();
    }
  },

  /**
   * @private
   */
  _judgeAutoMode: function () {
    // Auto set only works for setOption at the first time.
    // The following is user's reponsibility. So using merged
    // option is OK.
    var thisOption = this.option;
    var hasIndexSpecified = false;
    eachAxisDim(function (dimNames) {
      // When user set axisIndex as a empty array, we think that user specify axisIndex
      // but do not want use auto mode. Because empty array may be encountered when
      // some error occured.
      if (thisOption[dimNames.axisIndex] != null) {
        hasIndexSpecified = true;
      }
    }, this);
    var orient = thisOption.orient;

    if (orient == null && hasIndexSpecified) {
      return 'orient';
    } else if (!hasIndexSpecified) {
      if (orient == null) {
        thisOption.orient = 'horizontal';
      }

      return 'axisIndex';
    }
  },

  /**
   * @private
   */
  _autoSetAxisIndex: function () {
    var autoAxisIndex = true;
    var orient = this.get('orient', true);
    var thisOption = this.option;
    var dependentModels = this.dependentModels;

    if (autoAxisIndex) {
      // Find axis that parallel to dataZoom as default.
      var dimName = orient === 'vertical' ? 'y' : 'x';

      if (dependentModels[dimName + 'Axis'].length) {
        thisOption[dimName + 'AxisIndex'] = [0];
        autoAxisIndex = false;
      } else {
        each(dependentModels.singleAxis, function (singleAxisModel) {
          if (autoAxisIndex && singleAxisModel.get('orient', true) === orient) {
            thisOption.singleAxisIndex = [singleAxisModel.componentIndex];
            autoAxisIndex = false;
          }
        });
      }
    }

    if (autoAxisIndex) {
      // Find the first category axis as default. (consider polar)
      eachAxisDim(function (dimNames) {
        if (!autoAxisIndex) {
          return;
        }

        var axisIndices = [];
        var axisModels = this.dependentModels[dimNames.axis];

        if (axisModels.length && !axisIndices.length) {
          for (var i = 0, len = axisModels.length; i < len; i++) {
            if (axisModels[i].get('type') === 'category') {
              axisIndices.push(i);
            }
          }
        }

        thisOption[dimNames.axisIndex] = axisIndices;

        if (axisIndices.length) {
          autoAxisIndex = false;
        }
      }, this);
    }

    if (autoAxisIndex) {
      // FIXME
      // 这里是兼容ec2的写法（没指定xAxisIndex和yAxisIndex时把scatter和双数值轴折柱纳入dataZoom控制），
      // 但是实际是否需要Grid.js#getScaleByOption来判断（考虑time，log等axis type）？
      // If both dataZoom.xAxisIndex and dataZoom.yAxisIndex is not specified,
      // dataZoom component auto adopts series that reference to
      // both xAxis and yAxis which type is 'value'.
      this.ecModel.eachSeries(function (seriesModel) {
        if (this._isSeriesHasAllAxesTypeOf(seriesModel, 'value')) {
          eachAxisDim(function (dimNames) {
            var axisIndices = thisOption[dimNames.axisIndex];
            var axisIndex = seriesModel.get(dimNames.axisIndex);
            var axisId = seriesModel.get(dimNames.axisId);
            var axisModel = seriesModel.ecModel.queryComponents({
              mainType: dimNames.axis,
              index: axisIndex,
              id: axisId
            })[0];
            axisIndex = axisModel.componentIndex;

            if (zrUtil.indexOf(axisIndices, axisIndex) < 0) {
              axisIndices.push(axisIndex);
            }
          });
        }
      }, this);
    }
  },

  /**
   * @private
   */
  _autoSetOrient: function () {
    var dim; // Find the first axis

    this.eachTargetAxis(function (dimNames) {
      !dim && (dim = dimNames.name);
    }, this);
    this.option.orient = dim === 'y' ? 'vertical' : 'horizontal';
  },

  /**
   * @private
   */
  _isSeriesHasAllAxesTypeOf: function (seriesModel, axisType) {
    // FIXME
    // 需要series的xAxisIndex和yAxisIndex都首先自动设置上。
    // 例如series.type === scatter时。
    var is = true;
    eachAxisDim(function (dimNames) {
      var seriesAxisIndex = seriesModel.get(dimNames.axisIndex);
      var axisModel = this.dependentModels[dimNames.axis][seriesAxisIndex];

      if (!axisModel || axisModel.get('type') !== axisType) {
        is = false;
      }
    }, this);
    return is;
  },

  /**
   * @private
   */
  _setDefaultThrottle: function (inputRawOption) {
    // When first time user set throttle, auto throttle ends.
    if (inputRawOption.hasOwnProperty('throttle')) {
      this._autoThrottle = false;
    }

    if (this._autoThrottle) {
      var globalOption = this.ecModel.option;
      this.option.throttle = globalOption.animation && globalOption.animationDurationUpdate > 0 ? 100 : 20;
    }
  },

  /**
   * @public
   */
  getFirstTargetAxisModel: function () {
    var firstAxisModel;
    eachAxisDim(function (dimNames) {
      if (firstAxisModel == null) {
        var indices = this.get(dimNames.axisIndex);

        if (indices.length) {
          firstAxisModel = this.dependentModels[dimNames.axis][indices[0]];
        }
      }
    }, this);
    return firstAxisModel;
  },

  /**
   * @public
   * @param {Function} callback param: axisModel, dimNames, axisIndex, dataZoomModel, ecModel
   */
  eachTargetAxis: function (callback, context) {
    var ecModel = this.ecModel;
    eachAxisDim(function (dimNames) {
      each(this.get(dimNames.axisIndex), function (axisIndex) {
        callback.call(context, dimNames, axisIndex, this, ecModel);
      }, this);
    }, this);
  },

  /**
   * @param {string} dimName
   * @param {number} axisIndex
   * @return {module:echarts/component/dataZoom/AxisProxy} If not found, return null/undefined.
   */
  getAxisProxy: function (dimName, axisIndex) {
    return this._axisProxies[dimName + '_' + axisIndex];
  },

  /**
   * @param {string} dimName
   * @param {number} axisIndex
   * @return {module:echarts/model/Model} If not found, return null/undefined.
   */
  getAxisModel: function (dimName, axisIndex) {
    var axisProxy = this.getAxisProxy(dimName, axisIndex);
    return axisProxy && axisProxy.getAxisModel();
  },

  /**
   * If not specified, set to undefined.
   *
   * @public
   * @param {Object} opt
   * @param {number} [opt.start]
   * @param {number} [opt.end]
   * @param {number} [opt.startValue]
   * @param {number} [opt.endValue]
   */
  setRawRange: function (opt) {
    var thisOption = this.option;
    var settledOption = this.settledOption;
    each([['start', 'startValue'], ['end', 'endValue']], function (names) {
      // Consider the pair <start, startValue>:
      // If one has value and the other one is `null/undefined`, we both set them
      // to `settledOption`. This strategy enables the feature to clear the original
      // value in `settledOption` to `null/undefined`.
      // But if both of them are `null/undefined`, we do not set them to `settledOption`
      // and keep `settledOption` with the original value. This strategy enables users to
      // only set <end or endValue> but not set <start or startValue> when calling
      // `dispatchAction`.
      // The pair <end, endValue> is treated in the same way.
      if (opt[names[0]] != null || opt[names[1]] != null) {
        thisOption[names[0]] = settledOption[names[0]] = opt[names[0]];
        thisOption[names[1]] = settledOption[names[1]] = opt[names[1]];
      }
    }, this);
    updateRangeUse(this, opt);
  },

  /**
   * @public
   * @param {Object} opt
   * @param {number} [opt.start]
   * @param {number} [opt.end]
   * @param {number} [opt.startValue]
   * @param {number} [opt.endValue]
   */
  setCalculatedRange: function (opt) {
    var option = this.option;
    each(['start', 'startValue', 'end', 'endValue'], function (name) {
      option[name] = opt[name];
    });
  },

  /**
   * @public
   * @return {Array.<number>} [startPercent, endPercent]
   */
  getPercentRange: function () {
    var axisProxy = this.findRepresentativeAxisProxy();

    if (axisProxy) {
      return axisProxy.getDataPercentWindow();
    }
  },

  /**
   * @public
   * For example, chart.getModel().getComponent('dataZoom').getValueRange('y', 0);
   *
   * @param {string} [axisDimName]
   * @param {number} [axisIndex]
   * @return {Array.<number>} [startValue, endValue] value can only be '-' or finite number.
   */
  getValueRange: function (axisDimName, axisIndex) {
    if (axisDimName == null && axisIndex == null) {
      var axisProxy = this.findRepresentativeAxisProxy();

      if (axisProxy) {
        return axisProxy.getDataValueWindow();
      }
    } else {
      return this.getAxisProxy(axisDimName, axisIndex).getDataValueWindow();
    }
  },

  /**
   * @public
   * @param {module:echarts/model/Model} [axisModel] If axisModel given, find axisProxy
   *      corresponding to the axisModel
   * @return {module:echarts/component/dataZoom/AxisProxy}
   */
  findRepresentativeAxisProxy: function (axisModel) {
    if (axisModel) {
      return axisModel.__dzAxisProxy;
    } // Find the first hosted axisProxy


    var axisProxies = this._axisProxies;

    for (var key in axisProxies) {
      if (axisProxies.hasOwnProperty(key) && axisProxies[key].hostedBy(this)) {
        return axisProxies[key];
      }
    } // If no hosted axis find not hosted axisProxy.
    // Consider this case: dataZoomModel1 and dataZoomModel2 control the same axis,
    // and the option.start or option.end settings are different. The percentRange
    // should follow axisProxy.
    // (We encounter this problem in toolbox data zoom.)


    for (var key in axisProxies) {
      if (axisProxies.hasOwnProperty(key) && !axisProxies[key].hostedBy(this)) {
        return axisProxies[key];
      }
    }
  },

  /**
   * @return {Array.<string>}
   */
  getRangePropMode: function () {
    return this._rangePropMode.slice();
  }
});
/**
 * Retrieve the those raw params from option, which will be cached separately.
 * becasue they will be overwritten by normalized/calculated values in the main
 * process.
 */

function retrieveRawOption(option) {
  var ret = {};
  each(['start', 'end', 'startValue', 'endValue', 'throttle'], function (name) {
    option.hasOwnProperty(name) && (ret[name] = option[name]);
  });
  return ret;
}

function updateRangeUse(dataZoomModel, inputRawOption) {
  var rangePropMode = dataZoomModel._rangePropMode;
  var rangeModeInOption = dataZoomModel.get('rangeMode');
  each([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
    var percentSpecified = inputRawOption[names[0]] != null;
    var valueSpecified = inputRawOption[names[1]] != null;

    if (percentSpecified && !valueSpecified) {
      rangePropMode[index] = 'percent';
    } else if (!percentSpecified && valueSpecified) {
      rangePropMode[index] = 'value';
    } else if (rangeModeInOption) {
      rangePropMode[index] = rangeModeInOption[index];
    } else if (percentSpecified) {
      // percentSpecified && valueSpecified
      rangePropMode[index] = 'percent';
    } // else remain its original setting.

  });
}

var _default = DataZoomModel;
module.exports = _default;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var ComponentView = __webpack_require__(297);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = ComponentView.extend({
  type: 'dataZoom',
  render: function (dataZoomModel, ecModel, api, payload) {
    this.dataZoomModel = dataZoomModel;
    this.ecModel = ecModel;
    this.api = api;
  },

  /**
   * Find the first target coordinate system.
   *
   * @protected
   * @return {Object} {
   *                   grid: [
   *                       {model: coord0, axisModels: [axis1, axis3], coordIndex: 1},
   *                       {model: coord1, axisModels: [axis0, axis2], coordIndex: 0},
   *                       ...
   *                   ],  // cartesians must not be null/undefined.
   *                   polar: [
   *                       {model: coord0, axisModels: [axis4], coordIndex: 0},
   *                       ...
   *                   ],  // polars must not be null/undefined.
   *                   singleAxis: [
   *                       {model: coord0, axisModels: [], coordIndex: 0}
   *                   ]
   */
  getTargetCoordInfo: function () {
    var dataZoomModel = this.dataZoomModel;
    var ecModel = this.ecModel;
    var coordSysLists = {};
    dataZoomModel.eachTargetAxis(function (dimNames, axisIndex) {
      var axisModel = ecModel.getComponent(dimNames.axis, axisIndex);

      if (axisModel) {
        var coordModel = axisModel.getCoordSysModel();
        coordModel && save(coordModel, axisModel, coordSysLists[coordModel.mainType] || (coordSysLists[coordModel.mainType] = []), coordModel.componentIndex);
      }
    }, this);

    function save(coordModel, axisModel, store, coordIndex) {
      var item;

      for (var i = 0; i < store.length; i++) {
        if (store[i].model === coordModel) {
          item = store[i];
          break;
        }
      }

      if (!item) {
        store.push(item = {
          model: coordModel,
          axisModels: [],
          coordIndex: coordIndex
        });
      }

      item.axisModels.push(axisModel);
    }

    return coordSysLists;
  }
});

module.exports = _default;

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=imgSave;var _imgtopdf=__webpack_require__(128);var _imgtopdf2=_interopRequireDefault(_imgtopdf);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _html2canvas=__webpack_require__(540);var _html2canvas2=_interopRequireDefault(_html2canvas);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var imgToPdf=_imgtopdf2.default.imgToPdf;function imgSave(id){var multiple=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1.5;var sort=arguments[2];var date=arguments.length>3&&arguments[3]!==undefined?arguments[3]:(0,_moment2.default)().format('YYYY-MM');return new Promise(function(res,rej){// const opts = {
//     logging: false, //日志开关
//     removeContainer: false,
//     useCORS: false,
//     allowTaint: true, //是否允许画布收到污染
// };
// html2canvas(document.getElementById(id), opts).then(x => {
//     console.log(x.toDataURL('image/png', 0.1));
// })
// return 
imgToPdf(id,sort=='14.00'?0.9:multiple).then(function(img){console.log(img);fetch('/getPdf_bp?'+("sort="+sort+"&year="+(0,_moment2.default)(date).format('YYYY')),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){var dataFrom=new FormData();dataFrom.append('img',img.img);dataFrom.append('sort',sort);dataFrom.append('height',img.canvas.height);dataFrom.append('width',img.canvas.width);dataFrom.append('year',(0,_moment2.default)(date).format('YYYY'));dataFrom.append('add_time',(0,_moment2.default)().format('YYYY-MM-DD HH:mm:ss'));if(x.data&&x.data.length>0){dataFrom.append('id',x.data[0].id);}var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/addPdf_bp',headres).then(function(x){return x.json();}).then(function(data){res(data);}).catch(function(err){rej(err);});}).catch(function(err){rej(err);});}).catch(function(err){rej(err);});});}function getBlobBydataURI(dataURI,type){var binary=atob(dataURI.split(',')[1]);var array=[];for(var i=0;i<binary.length;i++){array.push(binary.charCodeAt(i));}return new Blob([new Uint8Array(array)],{type:type});}

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(35);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Compared=__webpack_require__(726);var _Compared2=_interopRequireDefault(_Compared);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * @name:  
 * @description:  
 * @Author: Han bei 
 * @Date: 2018-10-15 15:46:36 
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2019-08-12 17:52:01
 *  
 *  text  value值
 *  index 索引
 *  type  需要组件类型   text、number、percent、input、inputNumber、inputPercent 不传值默认不显示文本
 *  name  行名称
 *  title 表头
 *  record 行数据 Object
 *  totolIndex  汇总的行、需要颜色区分
 *  sqlName  数据库名称 自定义表格需要
 *  onChange 利用父级函数更新数据
 */var TextArea=_input2.default.TextArea;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var TableText=function(_Component){_inherits(TableText,_Component);function TableText(){_classCallCheck(this,TableText);return _possibleConstructorReturn(this,(TableText.__proto__||Object.getPrototypeOf(TableText)).apply(this,arguments));}_createClass(TableText,[{key:'render',value:function render(){var _props$data=this.props.data,_props$data$text=_props$data.text,text=_props$data$text===undefined?0:_props$data$text,index=_props$data.index,type=_props$data.type,name=_props$data.name,onChange=_props$data.onChange,_props$data$totalInde=_props$data.totalIndex,totalIndex=_props$data$totalInde===undefined?[]:_props$data$totalInde,warn=_props$data.warn,style=_props$data.style;var _ref=this.props.data.compared||{},_ref$title=_ref.title,title=_ref$title===undefined?[]:_ref$title,_ref$record=_ref.record,record=_ref$record===undefined?{}:_ref$record,_ref$sqlName=_ref.sqlName,sqlName=_ref$sqlName===undefined?"":_ref$sqlName;switch(type){case'input':return _react2.default.createElement('div',{className:'table-padding table-color-number '+(totalIndex.includes(index)?'table-color-footer':'')+' '+(totalIndex.includes(index)?'table-color-footer':'')+' '},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";onChange(name,value,index);}}));break;case'textArea':return _react2.default.createElement('div',{className:'table-padding table-color-number '+(totalIndex.includes(index)?'table-color-footer':'')+' '+(totalIndex.includes(index)?'table-color-footer':'')+' '},_react2.default.createElement(TextArea,{autosize:{minRows:2},className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";onChange(name,value,index);}}));break;case'number':if(this.props.data.compared){if(warn){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:name,title:title,sqlName:sqlName,name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding  heightAuto heightAutoNum '+(totalIndex.includes(index)?'table-color-footer':'')+' '+(warn?"table-text-warn":"")+' '},_react2.default.createElement('div',{style:{color:"red"}},Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','))));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:name,title:title,sqlName:sqlName,name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding heightAuto heightAutoNum '+(totalIndex.includes(index)?'table-color-footer':'')+'  '},_react2.default.createElement('div',null,Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','))));}if(warn){return _react2.default.createElement('div',{className:'table-padding heightAuto heightAutoNum '+(totalIndex.includes(index)?'table-color-footer':'')+' '+(warn?"table-text-warn":"")+'  '},_react2.default.createElement('div',{style:{color:"red"}},Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement('div',{className:'table-padding heightAuto heightAutoNum '+(totalIndex.includes(index)?'table-color-footer':'')+'  '},_react2.default.createElement('div',null,Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));break;case'inputPercent':if(this.props.data.compared){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:name,title:title,sqlName:sqlName,name:record.name,type:"percent"}},_react2.default.createElement('div',{className:'table-padding table-color-number '+(totalIndex.includes(index)?'table-color-footer':'')+' '},_react2.default.createElement(_inputNumber2.default,{defaultValue:Number(text||"0")*100||"",className:'table_numInput',precision:1,formatter:function formatter(value){return value+'%';},parser:function parser(value){return value.replace('%','');},onBlur:function onBlur(e){var value=Number(e.target.value.replace(/%/g,'')||'0');value=Number(value.toFixed(1)/100).toFixed(3);onChange(name,value,index);}})));}else{return _react2.default.createElement('div',{className:'table-padding table-color-number '+(totalIndex.includes(index)?'table-color-footer':'')+' '},_react2.default.createElement(_inputNumber2.default,{defaultValue:Number(text||"0")*100||"",className:'table_numInput',precision:1,formatter:function formatter(value){return value+'%';},parser:function parser(value){return value.replace('%','');},onBlur:function onBlur(e){var value=Number(e.target.value.replace(/%/g,'')||'0');value=Number(value.toFixed(1)/100).toFixed(3);onChange(name,value,index);}}));}break;case'inputNumber':if(this.props.data.compared){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:name,title:title,sqlName:sqlName,name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding table-color-number '+(warn?"table-inputNumber-err":"")+' '+(totalIndex.includes(index)?'table-color-footer':'')},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));onChange(name,value,index);}})));}else{return _react2.default.createElement('div',{className:'table-padding table-color-number '+(totalIndex.includes(index)?'table-color-footer':'')+' '+(warn?"table-inputNumber-err":"")},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));onChange(name,value,index);}}));}break;case'percent':// 百分比位数根据传值进行变动
var num=(text.toString().split('.')[1]||"").length<=3?1:(text.toString().split('.')[1]||"").length-2;if(this.props.data.compared){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:name,title:title,sqlName:sqlName,name:record.name,type:"percent"}},_react2.default.createElement('div',{className:'table-padding heightAuto heightAutoNum '+(totalIndex.includes(index)?'table-color-footer':'')+' '},_react2.default.createElement('div',null,Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(num)+'%',')'):(text*100).toFixed(num)+'%')));}else{return _react2.default.createElement('div',{className:'table-padding heightAuto heightAutoNum '+(totalIndex.includes(index)?'table-color-footer':'')+' '},_react2.default.createElement('div',null,Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(num)+'%',')'):(text*100).toFixed(num)+'%'));}break;case'text':case'string':case'textcenter':if(warn){return _react2.default.createElement('div',{className:'table-padding heightAuto '+(warn?"table-text-warn":"")+'  ',style:{textAlign:"left"}},_react2.default.createElement('div',{style:_extends({color:"red"},style),dangerouslySetInnerHTML:{__html:text||"-"}}));}return _react2.default.createElement('div',{className:'table-padding heightAuto '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:type==='string'?'right':type==='textcenter'?'center':"left",justifyContent:type==='string'?'flex-end':type==='textcenter'?'center':"flex-start"}},_react2.default.createElement('div',{style:_extends({textAlign:type==='string'?'right':type==='textcenter'?'center':"left",justifyContent:type==='string'?'flex-end':type==='textcenter'?'center':"flex-start"},style),dangerouslySetInnerHTML:{__html:text||"-"}}));break;default:return _react2.default.createElement('div',{className:'table-padding heightAuto '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"center"}},_react2.default.createElement('div',null,'-'));break;}}}]);return TableText;}(_react.Component);exports.default=TableText;

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(319);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 218 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _en_US = _interopRequireDefault(__webpack_require__(461));

var _en_US2 = _interopRequireDefault(__webpack_require__(331));

var _en_US3 = _interopRequireDefault(__webpack_require__(332));

var _en_US4 = _interopRequireDefault(__webpack_require__(731));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  locale: 'en',
  Pagination: _en_US["default"],
  DatePicker: _en_US2["default"],
  TimePicker: _en_US3["default"],
  Calendar: _en_US4["default"],
  global: {
    placeholder: 'Please select'
  },
  Table: {
    filterTitle: 'Filter menu',
    filterConfirm: 'OK',
    filterReset: 'Reset',
    selectAll: 'Select current page',
    selectInvert: 'Invert current page',
    sortTitle: 'Sort',
    expand: 'Expand row',
    collapse: 'Collapse row'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Cancel',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Cancel'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Search here',
    itemUnit: 'item',
    itemsUnit: 'items'
  },
  Upload: {
    uploading: 'Uploading...',
    removeFile: 'Remove file',
    uploadError: 'Upload error',
    previewFile: 'Preview file',
    downloadFile: 'Download file'
  },
  Empty: {
    description: 'No Data'
  },
  Icon: {
    icon: 'icon'
  },
  Text: {
    edit: 'Edit',
    copy: 'Copy',
    copied: 'Copied',
    expand: 'Expand'
  },
  PageHeader: {
    back: 'Back'
  }
};
exports["default"] = _default;

/***/ }),
/* 220 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixControlledValue = fixControlledValue;
exports.resolveOnChange = resolveOnChange;
exports.getInputClassName = getInputClassName;
exports["default"] = exports.InputSizes = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(19));

var _reactLifecyclesCompat = __webpack_require__(36);

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _omit = _interopRequireDefault(__webpack_require__(71));

var _type = __webpack_require__(130);

var _ClearableLabeledInput = _interopRequireWildcard(__webpack_require__(478));

var _configProvider = __webpack_require__(39);

var _warning = _interopRequireDefault(__webpack_require__(69));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InputSizes = (0, _type.tuple)('small', 'default', 'large');
exports.InputSizes = InputSizes;

function fixControlledValue(value) {
  if (typeof value === 'undefined' || value === null) {
    return '';
  }

  return value;
}

function resolveOnChange(target, e, onChange) {
  if (onChange) {
    var event = e;

    if (e.type === 'click') {
      // click clear icon
      event = Object.create(e);
      event.target = target;
      event.currentTarget = target;
      var originalInputValue = target.value; // change target ref value cause e.target.value should be '' when clear input

      target.value = '';
      onChange(event); // reset target ref value

      target.value = originalInputValue;
      return;
    }

    onChange(event);
  }
}

function getInputClassName(prefixCls, size, disabled) {
  var _classNames;

  return (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
}

var Input = /*#__PURE__*/function (_React$Component) {
  _inherits(Input, _React$Component);

  var _super = _createSuper(Input);

  function Input(props) {
    var _this;

    _classCallCheck(this, Input);

    _this = _super.call(this, props);

    _this.saveClearableInput = function (input) {
      _this.clearableInput = input;
    };

    _this.saveInput = function (input) {
      _this.input = input;
    };

    _this.handleReset = function (e) {
      _this.setValue('', function () {
        _this.focus();
      });

      resolveOnChange(_this.input, e, _this.props.onChange);
    };

    _this.renderInput = function (prefixCls) {
      var _this$props = _this.props,
          className = _this$props.className,
          addonBefore = _this$props.addonBefore,
          addonAfter = _this$props.addonAfter,
          size = _this$props.size,
          disabled = _this$props.disabled; // Fix https://fb.me/react-unknown-prop

      var otherProps = (0, _omit["default"])(_this.props, ['prefixCls', 'onPressEnter', 'addonBefore', 'addonAfter', 'prefix', 'suffix', 'allowClear', // Input elements must be either controlled or uncontrolled,
      // specify either the value prop, or the defaultValue prop, but not both.
      'defaultValue', 'size', 'inputType']);
      return /*#__PURE__*/React.createElement("input", _extends({}, otherProps, {
        onChange: _this.handleChange,
        onKeyDown: _this.handleKeyDown,
        className: (0, _classnames["default"])(getInputClassName(prefixCls, size, disabled), _defineProperty({}, className, className && !addonBefore && !addonAfter)),
        ref: _this.saveInput
      }));
    };

    _this.clearPasswordValueAttribute = function () {
      // https://github.com/ant-design/ant-design/issues/20541
      _this.removePasswordTimeout = setTimeout(function () {
        if (_this.input && _this.input.getAttribute('type') === 'password' && _this.input.hasAttribute('value')) {
          _this.input.removeAttribute('value');
        }
      });
    };

    _this.handleChange = function (e) {
      _this.setValue(e.target.value, _this.clearPasswordValueAttribute);

      resolveOnChange(_this.input, e, _this.props.onChange);
    };

    _this.handleKeyDown = function (e) {
      var _this$props2 = _this.props,
          onPressEnter = _this$props2.onPressEnter,
          onKeyDown = _this$props2.onKeyDown;

      if (e.keyCode === 13 && onPressEnter) {
        onPressEnter(e);
      }

      if (onKeyDown) {
        onKeyDown(e);
      }
    };

    _this.renderComponent = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var value = _this.state.value;
      var customizePrefixCls = _this.props.prefixCls;
      var prefixCls = getPrefixCls('input', customizePrefixCls);
      return /*#__PURE__*/React.createElement(_ClearableLabeledInput["default"], _extends({}, _this.props, {
        prefixCls: prefixCls,
        inputType: "input",
        value: fixControlledValue(value),
        element: _this.renderInput(prefixCls),
        handleReset: _this.handleReset,
        ref: _this.saveClearableInput
      }));
    };

    var value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
    _this.state = {
      value: value
    };
    return _this;
  }

  _createClass(Input, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.clearPasswordValueAttribute();
    } // Since polyfill `getSnapshotBeforeUpdate` need work with `componentDidUpdate`.
    // We keep an empty function here.

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      if ((0, _ClearableLabeledInput.hasPrefixSuffix)(prevProps) !== (0, _ClearableLabeledInput.hasPrefixSuffix)(this.props)) {
        (0, _warning["default"])(this.input !== document.activeElement, 'Input', "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ");
      }

      return null;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.removePasswordTimeout) {
        clearTimeout(this.removePasswordTimeout);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "select",
    value: function select() {
      this.input.select();
    }
  }, {
    key: "setValue",
    value: function setValue(value, callback) {
      if (!('value' in this.props)) {
        this.setState({
          value: value
        }, callback);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: nextProps.value
        };
      }

      return null;
    }
  }]);

  return Input;
}(React.Component);

Input.defaultProps = {
  type: 'text'
};
Input.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  size: PropTypes.oneOf(InputSizes),
  maxLength: PropTypes.number,
  disabled: PropTypes.bool,
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  className: PropTypes.string,
  addonBefore: PropTypes.node,
  addonAfter: PropTypes.node,
  prefixCls: PropTypes.string,
  onPressEnter: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  allowClear: PropTypes.bool
};
(0, _reactLifecyclesCompat.polyfill)(Input);
var _default = Input;
exports["default"] = _default;

/***/ }),
/* 222 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_is__);


function toArray(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (child === undefined || child === null) {
      return;
    }

    if (Array.isArray(child)) {
      ret = ret.concat(toArray(child));
    } else if (Object(__WEBPACK_IMPORTED_MODULE_1_react_is__["isFragment"])(child) && child.props) {
      ret = ret.concat(toArray(child.props.children));
    } else {
      ret.push(child);
    }
  });
  return ret;
}

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Tree = _interopRequireDefault(__webpack_require__(536));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _Tree["default"];
exports["default"] = _default;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(1112);

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(102);
var global = __webpack_require__(49);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(144) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(104);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 228 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(45);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(45);
var aFunction = __webpack_require__(81);
var SPECIES = __webpack_require__(56)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(293);

var debugMode = _config.debugMode;

var logError = function () {};

if (debugMode === 1) {
  logError = console.error;
}

var _default = logError;
module.exports = _default;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(1);

var Style = __webpack_require__(405);

var Element = __webpack_require__(615);

var RectText = __webpack_require__(621);

/**
 * Base class of all displayable graphic objects
 * @module zrender/graphic/Displayable
 */

/**
 * @alias module:zrender/graphic/Displayable
 * @extends module:zrender/Element
 * @extends module:zrender/graphic/mixin/RectText
 */
function Displayable(opts) {
  opts = opts || {};
  Element.call(this, opts); // Extend properties

  for (var name in opts) {
    if (opts.hasOwnProperty(name) && name !== 'style') {
      this[name] = opts[name];
    }
  }
  /**
   * @type {module:zrender/graphic/Style}
   */


  this.style = new Style(opts.style, this);
  this._rect = null; // Shapes for cascade clipping.
  // Can only be `null`/`undefined` or an non-empty array, MUST NOT be an empty array.
  // because it is easy to only using null to check whether clipPaths changed.

  this.__clipPaths = null; // FIXME Stateful must be mixined after style is setted
  // Stateful.call(this, opts);
}

Displayable.prototype = {
  constructor: Displayable,
  type: 'displayable',

  /**
   * Dirty flag. From which painter will determine if this displayable object needs brush.
   * @name module:zrender/graphic/Displayable#__dirty
   * @type {boolean}
   */
  __dirty: true,

  /**
   * Whether the displayable object is visible. when it is true, the displayable object
   * is not drawn, but the mouse event can still trigger the object.
   * @name module:/zrender/graphic/Displayable#invisible
   * @type {boolean}
   * @default false
   */
  invisible: false,

  /**
   * @name module:/zrender/graphic/Displayable#z
   * @type {number}
   * @default 0
   */
  z: 0,

  /**
   * @name module:/zrender/graphic/Displayable#z
   * @type {number}
   * @default 0
   */
  z2: 0,

  /**
   * The z level determines the displayable object can be drawn in which layer canvas.
   * @name module:/zrender/graphic/Displayable#zlevel
   * @type {number}
   * @default 0
   */
  zlevel: 0,

  /**
   * Whether it can be dragged.
   * @name module:/zrender/graphic/Displayable#draggable
   * @type {boolean}
   * @default false
   */
  draggable: false,

  /**
   * Whether is it dragging.
   * @name module:/zrender/graphic/Displayable#draggable
   * @type {boolean}
   * @default false
   */
  dragging: false,

  /**
   * Whether to respond to mouse events.
   * @name module:/zrender/graphic/Displayable#silent
   * @type {boolean}
   * @default false
   */
  silent: false,

  /**
   * If enable culling
   * @type {boolean}
   * @default false
   */
  culling: false,

  /**
   * Mouse cursor when hovered
   * @name module:/zrender/graphic/Displayable#cursor
   * @type {string}
   */
  cursor: 'pointer',

  /**
   * If hover area is bounding rect
   * @name module:/zrender/graphic/Displayable#rectHover
   * @type {string}
   */
  rectHover: false,

  /**
   * Render the element progressively when the value >= 0,
   * usefull for large data.
   * @type {boolean}
   */
  progressive: false,

  /**
   * @type {boolean}
   */
  incremental: false,

  /**
   * Scale ratio for global scale.
   * @type {boolean}
   */
  globalScaleRatio: 1,
  beforeBrush: function (ctx) {},
  afterBrush: function (ctx) {},

  /**
   * Graphic drawing method.
   * @param {CanvasRenderingContext2D} ctx
   */
  // Interface
  brush: function (ctx, prevEl) {},

  /**
   * Get the minimum bounding box.
   * @return {module:zrender/core/BoundingRect}
   */
  // Interface
  getBoundingRect: function () {},

  /**
   * If displayable element contain coord x, y
   * @param  {number} x
   * @param  {number} y
   * @return {boolean}
   */
  contain: function (x, y) {
    return this.rectContain(x, y);
  },

  /**
   * @param  {Function} cb
   * @param  {}   context
   */
  traverse: function (cb, context) {
    cb.call(context, this);
  },

  /**
   * If bounding rect of element contain coord x, y
   * @param  {number} x
   * @param  {number} y
   * @return {boolean}
   */
  rectContain: function (x, y) {
    var coord = this.transformCoordToLocal(x, y);
    var rect = this.getBoundingRect();
    return rect.contain(coord[0], coord[1]);
  },

  /**
   * Mark displayable element dirty and refresh next frame
   */
  dirty: function () {
    this.__dirty = this.__dirtyText = true;
    this._rect = null;
    this.__zr && this.__zr.refresh();
  },

  /**
   * If displayable object binded any event
   * @return {boolean}
   */
  // TODO, events bound by bind
  // isSilent: function () {
  //     return !(
  //         this.hoverable || this.draggable
  //         || this.onmousemove || this.onmouseover || this.onmouseout
  //         || this.onmousedown || this.onmouseup || this.onclick
  //         || this.ondragenter || this.ondragover || this.ondragleave
  //         || this.ondrop
  //     );
  // },

  /**
   * Alias for animate('style')
   * @param {boolean} loop
   */
  animateStyle: function (loop) {
    return this.animate('style', loop);
  },
  attrKV: function (key, value) {
    if (key !== 'style') {
      Element.prototype.attrKV.call(this, key, value);
    } else {
      this.style.set(value);
    }
  },

  /**
   * @param {Object|string} key
   * @param {*} value
   */
  setStyle: function (key, value) {
    this.style.set(key, value);
    this.dirty(false);
    return this;
  },

  /**
   * Use given style object
   * @param  {Object} obj
   */
  useStyle: function (obj) {
    this.style = new Style(obj, this);
    this.dirty(false);
    return this;
  },

  /**
   * The string value of `textPosition` needs to be calculated to a real postion.
   * For example, `'inside'` is calculated to `[rect.width/2, rect.height/2]`
   * by default. See `contain/text.js#calculateTextPosition` for more details.
   * But some coutom shapes like "pin", "flag" have center that is not exactly
   * `[width/2, height/2]`. So we provide this hook to customize the calculation
   * for those shapes. It will be called if the `style.textPosition` is a string.
   * @param {Obejct} [out] Prepared out object. If not provided, this method should
   *        be responsible for creating one.
   * @param {module:zrender/graphic/Style} style
   * @param {Object} rect {x, y, width, height}
   * @return {Obejct} out The same as the input out.
   *         {
   *             x: number. mandatory.
   *             y: number. mandatory.
   *             textAlign: string. optional. use style.textAlign by default.
   *             textVerticalAlign: string. optional. use style.textVerticalAlign by default.
   *         }
   */
  calculateTextPosition: null
};
zrUtil.inherits(Displayable, Element);
zrUtil.mixin(Displayable, RectText); // zrUtil.mixin(Displayable, Stateful);

var _default = Displayable;
module.exports = _default;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var vec2 = __webpack_require__(55);

var curve = __webpack_require__(147);

/**
 * @author Yi Shen(https://github.com/pissang)
 */
var mathMin = Math.min;
var mathMax = Math.max;
var mathSin = Math.sin;
var mathCos = Math.cos;
var PI2 = Math.PI * 2;
var start = vec2.create();
var end = vec2.create();
var extremity = vec2.create();
/**
 * 从顶点数组中计算出最小包围盒，写入`min`和`max`中
 * @module zrender/core/bbox
 * @param {Array<Object>} points 顶点数组
 * @param {number} min
 * @param {number} max
 */

function fromPoints(points, min, max) {
  if (points.length === 0) {
    return;
  }

  var p = points[0];
  var left = p[0];
  var right = p[0];
  var top = p[1];
  var bottom = p[1];
  var i;

  for (i = 1; i < points.length; i++) {
    p = points[i];
    left = mathMin(left, p[0]);
    right = mathMax(right, p[0]);
    top = mathMin(top, p[1]);
    bottom = mathMax(bottom, p[1]);
  }

  min[0] = left;
  min[1] = top;
  max[0] = right;
  max[1] = bottom;
}
/**
 * @memberOf module:zrender/core/bbox
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */


function fromLine(x0, y0, x1, y1, min, max) {
  min[0] = mathMin(x0, x1);
  min[1] = mathMin(y0, y1);
  max[0] = mathMax(x0, x1);
  max[1] = mathMax(y0, y1);
}

var xDim = [];
var yDim = [];
/**
 * 从三阶贝塞尔曲线(p0, p1, p2, p3)中计算出最小包围盒，写入`min`和`max`中
 * @memberOf module:zrender/core/bbox
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {number} x3
 * @param {number} y3
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */

function fromCubic(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
  var cubicExtrema = curve.cubicExtrema;
  var cubicAt = curve.cubicAt;
  var i;
  var n = cubicExtrema(x0, x1, x2, x3, xDim);
  min[0] = Infinity;
  min[1] = Infinity;
  max[0] = -Infinity;
  max[1] = -Infinity;

  for (i = 0; i < n; i++) {
    var x = cubicAt(x0, x1, x2, x3, xDim[i]);
    min[0] = mathMin(x, min[0]);
    max[0] = mathMax(x, max[0]);
  }

  n = cubicExtrema(y0, y1, y2, y3, yDim);

  for (i = 0; i < n; i++) {
    var y = cubicAt(y0, y1, y2, y3, yDim[i]);
    min[1] = mathMin(y, min[1]);
    max[1] = mathMax(y, max[1]);
  }

  min[0] = mathMin(x0, min[0]);
  max[0] = mathMax(x0, max[0]);
  min[0] = mathMin(x3, min[0]);
  max[0] = mathMax(x3, max[0]);
  min[1] = mathMin(y0, min[1]);
  max[1] = mathMax(y0, max[1]);
  min[1] = mathMin(y3, min[1]);
  max[1] = mathMax(y3, max[1]);
}
/**
 * 从二阶贝塞尔曲线(p0, p1, p2)中计算出最小包围盒，写入`min`和`max`中
 * @memberOf module:zrender/core/bbox
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */


function fromQuadratic(x0, y0, x1, y1, x2, y2, min, max) {
  var quadraticExtremum = curve.quadraticExtremum;
  var quadraticAt = curve.quadraticAt; // Find extremities, where derivative in x dim or y dim is zero

  var tx = mathMax(mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
  var ty = mathMax(mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
  var x = quadraticAt(x0, x1, x2, tx);
  var y = quadraticAt(y0, y1, y2, ty);
  min[0] = mathMin(x0, x2, x);
  min[1] = mathMin(y0, y2, y);
  max[0] = mathMax(x0, x2, x);
  max[1] = mathMax(y0, y2, y);
}
/**
 * 从圆弧中计算出最小包围盒，写入`min`和`max`中
 * @method
 * @memberOf module:zrender/core/bbox
 * @param {number} x
 * @param {number} y
 * @param {number} rx
 * @param {number} ry
 * @param {number} startAngle
 * @param {number} endAngle
 * @param {number} anticlockwise
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */


function fromArc(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
  var vec2Min = vec2.min;
  var vec2Max = vec2.max;
  var diff = Math.abs(startAngle - endAngle);

  if (diff % PI2 < 1e-4 && diff > 1e-4) {
    // Is a circle
    min[0] = x - rx;
    min[1] = y - ry;
    max[0] = x + rx;
    max[1] = y + ry;
    return;
  }

  start[0] = mathCos(startAngle) * rx + x;
  start[1] = mathSin(startAngle) * ry + y;
  end[0] = mathCos(endAngle) * rx + x;
  end[1] = mathSin(endAngle) * ry + y;
  vec2Min(min, start, end);
  vec2Max(max, start, end); // Thresh to [0, Math.PI * 2]

  startAngle = startAngle % PI2;

  if (startAngle < 0) {
    startAngle = startAngle + PI2;
  }

  endAngle = endAngle % PI2;

  if (endAngle < 0) {
    endAngle = endAngle + PI2;
  }

  if (startAngle > endAngle && !anticlockwise) {
    endAngle += PI2;
  } else if (startAngle < endAngle && anticlockwise) {
    startAngle += PI2;
  }

  if (anticlockwise) {
    var tmp = endAngle;
    endAngle = startAngle;
    startAngle = tmp;
  } // var number = 0;
  // var step = (anticlockwise ? -Math.PI : Math.PI) / 2;


  for (var angle = 0; angle < endAngle; angle += Math.PI / 2) {
    if (angle > startAngle) {
      extremity[0] = mathCos(angle) * rx + x;
      extremity[1] = mathSin(angle) * ry + y;
      vec2Min(min, extremity, min);
      vec2Max(max, extremity, max);
    }
  }
}

exports.fromPoints = fromPoints;
exports.fromLine = fromLine;
exports.fromCubic = fromCubic;
exports.fromQuadratic = fromQuadratic;
exports.fromArc = fromArc;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var _clazz = __webpack_require__(135);

var parseClassType = _clazz.parseClassType;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var base = 0;
/**
 * @public
 * @param {string} type
 * @return {string}
 */

function getUID(type) {
  // Considering the case of crossing js context,
  // use Math.random to make id as unique as possible.
  return [type || '', base++, Math.random().toFixed(5)].join('_');
}
/**
 * @inner
 */


function enableSubTypeDefaulter(entity) {
  var subTypeDefaulters = {};

  entity.registerSubTypeDefaulter = function (componentType, defaulter) {
    componentType = parseClassType(componentType);
    subTypeDefaulters[componentType.main] = defaulter;
  };

  entity.determineSubType = function (componentType, option) {
    var type = option.type;

    if (!type) {
      var componentTypeMain = parseClassType(componentType).main;

      if (entity.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) {
        type = subTypeDefaulters[componentTypeMain](option);
      }
    }

    return type;
  };

  return entity;
}
/**
 * Topological travel on Activity Network (Activity On Vertices).
 * Dependencies is defined in Model.prototype.dependencies, like ['xAxis', 'yAxis'].
 *
 * If 'xAxis' or 'yAxis' is absent in componentTypeList, just ignore it in topology.
 *
 * If there is circle dependencey, Error will be thrown.
 *
 */


function enableTopologicalTravel(entity, dependencyGetter) {
  /**
   * @public
   * @param {Array.<string>} targetNameList Target Component type list.
   *                                           Can be ['aa', 'bb', 'aa.xx']
   * @param {Array.<string>} fullNameList By which we can build dependency graph.
   * @param {Function} callback Params: componentType, dependencies.
   * @param {Object} context Scope of callback.
   */
  entity.topologicalTravel = function (targetNameList, fullNameList, callback, context) {
    if (!targetNameList.length) {
      return;
    }

    var result = makeDepndencyGraph(fullNameList);
    var graph = result.graph;
    var stack = result.noEntryList;
    var targetNameSet = {};
    zrUtil.each(targetNameList, function (name) {
      targetNameSet[name] = true;
    });

    while (stack.length) {
      var currComponentType = stack.pop();
      var currVertex = graph[currComponentType];
      var isInTargetNameSet = !!targetNameSet[currComponentType];

      if (isInTargetNameSet) {
        callback.call(context, currComponentType, currVertex.originalDeps.slice());
        delete targetNameSet[currComponentType];
      }

      zrUtil.each(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
    }

    zrUtil.each(targetNameSet, function () {
      throw new Error('Circle dependency may exists');
    });

    function removeEdge(succComponentType) {
      graph[succComponentType].entryCount--;

      if (graph[succComponentType].entryCount === 0) {
        stack.push(succComponentType);
      }
    } // Consider this case: legend depends on series, and we call
    // chart.setOption({series: [...]}), where only series is in option.
    // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
    // not be called, but only sereis.mergeOption is called. Thus legend
    // have no chance to update its local record about series (like which
    // name of series is available in legend).


    function removeEdgeAndAdd(succComponentType) {
      targetNameSet[succComponentType] = true;
      removeEdge(succComponentType);
    }
  };
  /**
   * DepndencyGraph: {Object}
   * key: conponentType,
   * value: {
   *     successor: [conponentTypes...],
   *     originalDeps: [conponentTypes...],
   *     entryCount: {number}
   * }
   */


  function makeDepndencyGraph(fullNameList) {
    var graph = {};
    var noEntryList = [];
    zrUtil.each(fullNameList, function (name) {
      var thisItem = createDependencyGraphItem(graph, name);
      var originalDeps = thisItem.originalDeps = dependencyGetter(name);
      var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
      thisItem.entryCount = availableDeps.length;

      if (thisItem.entryCount === 0) {
        noEntryList.push(name);
      }

      zrUtil.each(availableDeps, function (dependentName) {
        if (zrUtil.indexOf(thisItem.predecessor, dependentName) < 0) {
          thisItem.predecessor.push(dependentName);
        }

        var thatItem = createDependencyGraphItem(graph, dependentName);

        if (zrUtil.indexOf(thatItem.successor, dependentName) < 0) {
          thatItem.successor.push(name);
        }
      });
    });
    return {
      graph: graph,
      noEntryList: noEntryList
    };
  }

  function createDependencyGraphItem(graph, name) {
    if (!graph[name]) {
      graph[name] = {
        predecessor: [],
        successor: []
      };
    }

    return graph[name];
  }

  function getAvailableDependencies(originalDeps, fullNameList) {
    var availableDeps = [];
    zrUtil.each(originalDeps, function (dep) {
      zrUtil.indexOf(fullNameList, dep) >= 0 && availableDeps.push(dep);
    });
    return availableDeps;
  }
}

exports.getUID = getUID;
exports.enableSubTypeDefaulter = enableSubTypeDefaulter;
exports.enableTopologicalTravel = enableTopologicalTravel;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(1);

var createHashMap = _util.createHashMap;
var isTypedArray = _util.isTypedArray;

var _clazz = __webpack_require__(135);

var enableClassCheck = _clazz.enableClassCheck;

var _sourceType = __webpack_require__(237);

var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
var SERIES_LAYOUT_BY_COLUMN = _sourceType.SERIES_LAYOUT_BY_COLUMN;
var SOURCE_FORMAT_UNKNOWN = _sourceType.SOURCE_FORMAT_UNKNOWN;
var SOURCE_FORMAT_TYPED_ARRAY = _sourceType.SOURCE_FORMAT_TYPED_ARRAY;
var SOURCE_FORMAT_KEYED_COLUMNS = _sourceType.SOURCE_FORMAT_KEYED_COLUMNS;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * [sourceFormat]
 *
 * + "original":
 * This format is only used in series.data, where
 * itemStyle can be specified in data item.
 *
 * + "arrayRows":
 * [
 *     ['product', 'score', 'amount'],
 *     ['Matcha Latte', 89.3, 95.8],
 *     ['Milk Tea', 92.1, 89.4],
 *     ['Cheese Cocoa', 94.4, 91.2],
 *     ['Walnut Brownie', 85.4, 76.9]
 * ]
 *
 * + "objectRows":
 * [
 *     {product: 'Matcha Latte', score: 89.3, amount: 95.8},
 *     {product: 'Milk Tea', score: 92.1, amount: 89.4},
 *     {product: 'Cheese Cocoa', score: 94.4, amount: 91.2},
 *     {product: 'Walnut Brownie', score: 85.4, amount: 76.9}
 * ]
 *
 * + "keyedColumns":
 * {
 *     'product': ['Matcha Latte', 'Milk Tea', 'Cheese Cocoa', 'Walnut Brownie'],
 *     'count': [823, 235, 1042, 988],
 *     'score': [95.8, 81.4, 91.2, 76.9]
 * }
 *
 * + "typedArray"
 *
 * + "unknown"
 */

/**
 * @constructor
 * @param {Object} fields
 * @param {string} fields.sourceFormat
 * @param {Array|Object} fields.fromDataset
 * @param {Array|Object} [fields.data]
 * @param {string} [seriesLayoutBy='column']
 * @param {Array.<Object|string>} [dimensionsDefine]
 * @param {Objet|HashMap} [encodeDefine]
 * @param {number} [startIndex=0]
 * @param {number} [dimensionsDetectCount]
 */
function Source(fields) {
  /**
   * @type {boolean}
   */
  this.fromDataset = fields.fromDataset;
  /**
   * Not null/undefined.
   * @type {Array|Object}
   */

  this.data = fields.data || (fields.sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS ? {} : []);
  /**
   * See also "detectSourceFormat".
   * Not null/undefined.
   * @type {string}
   */

  this.sourceFormat = fields.sourceFormat || SOURCE_FORMAT_UNKNOWN;
  /**
   * 'row' or 'column'
   * Not null/undefined.
   * @type {string} seriesLayoutBy
   */

  this.seriesLayoutBy = fields.seriesLayoutBy || SERIES_LAYOUT_BY_COLUMN;
  /**
   * dimensions definition in option.
   * can be null/undefined.
   * @type {Array.<Object|string>}
   */

  this.dimensionsDefine = fields.dimensionsDefine;
  /**
   * encode definition in option.
   * can be null/undefined.
   * @type {Objet|HashMap}
   */

  this.encodeDefine = fields.encodeDefine && createHashMap(fields.encodeDefine);
  /**
   * Not null/undefined, uint.
   * @type {number}
   */

  this.startIndex = fields.startIndex || 0;
  /**
   * Can be null/undefined (when unknown), uint.
   * @type {number}
   */

  this.dimensionsDetectCount = fields.dimensionsDetectCount;
}
/**
 * Wrap original series data for some compatibility cases.
 */


Source.seriesDataToSource = function (data) {
  return new Source({
    data: data,
    sourceFormat: isTypedArray(data) ? SOURCE_FORMAT_TYPED_ARRAY : SOURCE_FORMAT_ORIGINAL,
    fromDataset: false
  });
};

enableClassCheck(Source);
var _default = Source;
module.exports = _default;

/***/ }),
/* 237 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Avoid typo.
var SOURCE_FORMAT_ORIGINAL = 'original';
var SOURCE_FORMAT_ARRAY_ROWS = 'arrayRows';
var SOURCE_FORMAT_OBJECT_ROWS = 'objectRows';
var SOURCE_FORMAT_KEYED_COLUMNS = 'keyedColumns';
var SOURCE_FORMAT_UNKNOWN = 'unknown'; // ??? CHANGE A NAME

var SOURCE_FORMAT_TYPED_ARRAY = 'typedArray';
var SERIES_LAYOUT_BY_COLUMN = 'column';
var SERIES_LAYOUT_BY_ROW = 'row';
exports.SOURCE_FORMAT_ORIGINAL = SOURCE_FORMAT_ORIGINAL;
exports.SOURCE_FORMAT_ARRAY_ROWS = SOURCE_FORMAT_ARRAY_ROWS;
exports.SOURCE_FORMAT_OBJECT_ROWS = SOURCE_FORMAT_OBJECT_ROWS;
exports.SOURCE_FORMAT_KEYED_COLUMNS = SOURCE_FORMAT_KEYED_COLUMNS;
exports.SOURCE_FORMAT_UNKNOWN = SOURCE_FORMAT_UNKNOWN;
exports.SOURCE_FORMAT_TYPED_ARRAY = SOURCE_FORMAT_TYPED_ARRAY;
exports.SERIES_LAYOUT_BY_COLUMN = SERIES_LAYOUT_BY_COLUMN;
exports.SERIES_LAYOUT_BY_ROW = SERIES_LAYOUT_BY_ROW;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(1);

var each = _util.each;
var createHashMap = _util.createHashMap;
var assert = _util.assert;

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var OTHER_DIMENSIONS = createHashMap(['tooltip', 'label', 'itemName', 'itemId', 'seriesName']);

function summarizeDimensions(data) {
  var summary = {};
  var encode = summary.encode = {};
  var notExtraCoordDimMap = createHashMap();
  var defaultedLabel = [];
  var defaultedTooltip = []; // See the comment of `List.js#userOutput`.

  var userOutput = summary.userOutput = {
    dimensionNames: data.dimensions.slice(),
    encode: {}
  };
  each(data.dimensions, function (dimName) {
    var dimItem = data.getDimensionInfo(dimName);
    var coordDim = dimItem.coordDim;

    if (coordDim) {
      var coordDimIndex = dimItem.coordDimIndex;
      getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;

      if (!dimItem.isExtraCoord) {
        notExtraCoordDimMap.set(coordDim, 1); // Use the last coord dim (and label friendly) as default label,
        // because when dataset is used, it is hard to guess which dimension
        // can be value dimension. If both show x, y on label is not look good,
        // and conventionally y axis is focused more.

        if (mayLabelDimType(dimItem.type)) {
          defaultedLabel[0] = dimName;
        } // User output encode do not contain generated coords.
        // And it only has index. User can use index to retrieve value from the raw item array.


        getOrCreateEncodeArr(userOutput.encode, coordDim)[coordDimIndex] = dimItem.index;
      }

      if (dimItem.defaultTooltip) {
        defaultedTooltip.push(dimName);
      }
    }

    OTHER_DIMENSIONS.each(function (v, otherDim) {
      var encodeArr = getOrCreateEncodeArr(encode, otherDim);
      var dimIndex = dimItem.otherDims[otherDim];

      if (dimIndex != null && dimIndex !== false) {
        encodeArr[dimIndex] = dimItem.name;
      }
    });
  });
  var dataDimsOnCoord = [];
  var encodeFirstDimNotExtra = {};
  notExtraCoordDimMap.each(function (v, coordDim) {
    var dimArr = encode[coordDim]; // ??? FIXME extra coord should not be set in dataDimsOnCoord.
    // But should fix the case that radar axes: simplify the logic
    // of `completeDimension`, remove `extraPrefix`.

    encodeFirstDimNotExtra[coordDim] = dimArr[0]; // Not necessary to remove duplicate, because a data
    // dim canot on more than one coordDim.

    dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
  });
  summary.dataDimsOnCoord = dataDimsOnCoord;
  summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
  var encodeLabel = encode.label; // FIXME `encode.label` is not recommanded, because formatter can not be set
  // in this way. Use label.formatter instead. May be remove this approach someday.

  if (encodeLabel && encodeLabel.length) {
    defaultedLabel = encodeLabel.slice();
  }

  var encodeTooltip = encode.tooltip;

  if (encodeTooltip && encodeTooltip.length) {
    defaultedTooltip = encodeTooltip.slice();
  } else if (!defaultedTooltip.length) {
    defaultedTooltip = defaultedLabel.slice();
  }

  encode.defaultedLabel = defaultedLabel;
  encode.defaultedTooltip = defaultedTooltip;
  return summary;
}

function getOrCreateEncodeArr(encode, dim) {
  if (!encode.hasOwnProperty(dim)) {
    encode[dim] = [];
  }

  return encode[dim];
}

function getDimensionTypeByAxis(axisType) {
  return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
}

function mayLabelDimType(dimType) {
  // In most cases, ordinal and time do not suitable for label.
  // Ordinal info can be displayed on axis. Time is too long.
  return !(dimType === 'ordinal' || dimType === 'time');
} // function findTheLastDimMayLabel(data) {
//     // Get last value dim
//     var dimensions = data.dimensions.slice();
//     var valueType;
//     var valueDim;
//     while (dimensions.length && (
//         valueDim = dimensions.pop(),
//         valueType = data.getDimensionInfo(valueDim).type,
//         valueType === 'ordinal' || valueType === 'time'
//     )) {} // jshint ignore:line
//     return valueDim;
// }


exports.OTHER_DIMENSIONS = OTHER_DIMENSIONS;
exports.summarizeDimensions = summarizeDimensions;
exports.getDimensionTypeByAxis = getDimensionTypeByAxis;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var graphic = __webpack_require__(27);

var SymbolClz = __webpack_require__(301);

var _util = __webpack_require__(1);

var isObject = _util.isObject;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @module echarts/chart/helper/SymbolDraw
 */

/**
 * @constructor
 * @alias module:echarts/chart/helper/SymbolDraw
 * @param {module:zrender/graphic/Group} [symbolCtor]
 */
function SymbolDraw(symbolCtor) {
  this.group = new graphic.Group();
  this._symbolCtor = symbolCtor || SymbolClz;
}

var symbolDrawProto = SymbolDraw.prototype;

function symbolNeedsDraw(data, point, idx, opt) {
  return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx)) // We do not set clipShape on group, because it will cut part of
  // the symbol element shape. We use the same clip shape here as
  // the line clip.
  && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, 'symbol') !== 'none';
}
/**
 * Update symbols draw by new data
 * @param {module:echarts/data/List} data
 * @param {Object} [opt] Or isIgnore
 * @param {Function} [opt.isIgnore]
 * @param {Object} [opt.clipShape]
 */


symbolDrawProto.updateData = function (data, opt) {
  opt = normalizeUpdateOpt(opt);
  var group = this.group;
  var seriesModel = data.hostModel;
  var oldData = this._data;
  var SymbolCtor = this._symbolCtor;
  var seriesScope = makeSeriesScope(data); // There is no oldLineData only when first rendering or switching from
  // stream mode to normal mode, where previous elements should be removed.

  if (!oldData) {
    group.removeAll();
  }

  data.diff(oldData).add(function (newIdx) {
    var point = data.getItemLayout(newIdx);

    if (symbolNeedsDraw(data, point, newIdx, opt)) {
      var symbolEl = new SymbolCtor(data, newIdx, seriesScope);
      symbolEl.attr('position', point);
      data.setItemGraphicEl(newIdx, symbolEl);
      group.add(symbolEl);
    }
  }).update(function (newIdx, oldIdx) {
    var symbolEl = oldData.getItemGraphicEl(oldIdx);
    var point = data.getItemLayout(newIdx);

    if (!symbolNeedsDraw(data, point, newIdx, opt)) {
      group.remove(symbolEl);
      return;
    }

    if (!symbolEl) {
      symbolEl = new SymbolCtor(data, newIdx);
      symbolEl.attr('position', point);
    } else {
      symbolEl.updateData(data, newIdx, seriesScope);
      graphic.updateProps(symbolEl, {
        position: point
      }, seriesModel);
    } // Add back


    group.add(symbolEl);
    data.setItemGraphicEl(newIdx, symbolEl);
  }).remove(function (oldIdx) {
    var el = oldData.getItemGraphicEl(oldIdx);
    el && el.fadeOut(function () {
      group.remove(el);
    });
  }).execute();
  this._data = data;
};

symbolDrawProto.isPersistent = function () {
  return true;
};

symbolDrawProto.updateLayout = function () {
  var data = this._data;

  if (data) {
    // Not use animation
    data.eachItemGraphicEl(function (el, idx) {
      var point = data.getItemLayout(idx);
      el.attr('position', point);
    });
  }
};

symbolDrawProto.incrementalPrepareUpdate = function (data) {
  this._seriesScope = makeSeriesScope(data);
  this._data = null;
  this.group.removeAll();
};
/**
 * Update symbols draw by new data
 * @param {module:echarts/data/List} data
 * @param {Object} [opt] Or isIgnore
 * @param {Function} [opt.isIgnore]
 * @param {Object} [opt.clipShape]
 */


symbolDrawProto.incrementalUpdate = function (taskParams, data, opt) {
  opt = normalizeUpdateOpt(opt);

  function updateIncrementalAndHover(el) {
    if (!el.isGroup) {
      el.incremental = el.useHoverLayer = true;
    }
  }

  for (var idx = taskParams.start; idx < taskParams.end; idx++) {
    var point = data.getItemLayout(idx);

    if (symbolNeedsDraw(data, point, idx, opt)) {
      var el = new this._symbolCtor(data, idx, this._seriesScope);
      el.traverse(updateIncrementalAndHover);
      el.attr('position', point);
      this.group.add(el);
      data.setItemGraphicEl(idx, el);
    }
  }
};

function normalizeUpdateOpt(opt) {
  if (opt != null && !isObject(opt)) {
    opt = {
      isIgnore: opt
    };
  }

  return opt || {};
}

symbolDrawProto.remove = function (enableAnimation) {
  var group = this.group;
  var data = this._data; // Incremental model do not have this._data.

  if (data && enableAnimation) {
    data.eachItemGraphicEl(function (el) {
      el.fadeOut(function () {
        group.remove(el);
      });
    });
  } else {
    group.removeAll();
  }
};

function makeSeriesScope(data) {
  var seriesModel = data.hostModel;
  return {
    itemStyle: seriesModel.getModel('itemStyle').getItemStyle(['color']),
    hoverItemStyle: seriesModel.getModel('emphasis.itemStyle').getItemStyle(),
    symbolRotate: seriesModel.get('symbolRotate'),
    symbolOffset: seriesModel.get('symbolOffset'),
    hoverAnimation: seriesModel.get('hoverAnimation'),
    labelModel: seriesModel.getModel('label'),
    hoverLabelModel: seriesModel.getModel('emphasis.label'),
    cursorStyle: seriesModel.get('cursor')
  };
}

var _default = SymbolDraw;
module.exports = _default;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var graphic = __webpack_require__(27);

var _number = __webpack_require__(37);

var round = _number.round;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function createGridClipPath(cartesian, hasAnimation, seriesModel) {
  var rect = cartesian.getArea();
  var isHorizontal = cartesian.getBaseAxis().isHorizontal();
  var x = rect.x;
  var y = rect.y;
  var width = rect.width;
  var height = rect.height;
  var lineWidth = seriesModel.get('lineStyle.width') || 2; // Expand the clip path a bit to avoid the border is clipped and looks thinner

  x -= lineWidth / 2;
  y -= lineWidth / 2;
  width += lineWidth;
  height += lineWidth; // fix: https://github.com/apache/incubator-echarts/issues/11369

  x = Math.floor(x);
  width = Math.round(width);
  var clipPath = new graphic.Rect({
    shape: {
      x: x,
      y: y,
      width: width,
      height: height
    }
  });

  if (hasAnimation) {
    clipPath.shape[isHorizontal ? 'width' : 'height'] = 0;
    graphic.initProps(clipPath, {
      shape: {
        width: width,
        height: height
      }
    }, seriesModel);
  }

  return clipPath;
}

function createPolarClipPath(polar, hasAnimation, seriesModel) {
  var sectorArea = polar.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.

  var clipPath = new graphic.Sector({
    shape: {
      cx: round(polar.cx, 1),
      cy: round(polar.cy, 1),
      r0: round(sectorArea.r0, 1),
      r: round(sectorArea.r, 1),
      startAngle: sectorArea.startAngle,
      endAngle: sectorArea.endAngle,
      clockwise: sectorArea.clockwise
    }
  });

  if (hasAnimation) {
    clipPath.shape.endAngle = sectorArea.startAngle;
    graphic.initProps(clipPath, {
      shape: {
        endAngle: sectorArea.endAngle
      }
    }, seriesModel);
  }

  return clipPath;
}

function createClipPath(coordSys, hasAnimation, seriesModel) {
  if (!coordSys) {
    return null;
  } else if (coordSys.type === 'polar') {
    return createPolarClipPath(coordSys, hasAnimation, seriesModel);
  } else if (coordSys.type === 'cartesian2d') {
    return createGridClipPath(coordSys, hasAnimation, seriesModel);
  }

  return null;
}

exports.createGridClipPath = createGridClipPath;
exports.createPolarClipPath = createPolarClipPath;
exports.createClipPath = createClipPath;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(1);

var map = _util.map;

var createRenderPlanner = __webpack_require__(206);

var _dataStackHelper = __webpack_require__(124);

var isDimensionStacked = _dataStackHelper.isDimensionStacked;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/* global Float32Array */
function _default(seriesType) {
  return {
    seriesType: seriesType,
    plan: createRenderPlanner(),
    reset: function (seriesModel) {
      var data = seriesModel.getData();
      var coordSys = seriesModel.coordinateSystem;
      var pipelineContext = seriesModel.pipelineContext;
      var isLargeRender = pipelineContext.large;

      if (!coordSys) {
        return;
      }

      var dims = map(coordSys.dimensions, function (dim) {
        return data.mapDimension(dim);
      }).slice(0, 2);
      var dimLen = dims.length;
      var stackResultDim = data.getCalculationInfo('stackResultDimension');

      if (isDimensionStacked(data, dims[0]
      /*, dims[1]*/
      )) {
        dims[0] = stackResultDim;
      }

      if (isDimensionStacked(data, dims[1]
      /*, dims[0]*/
      )) {
        dims[1] = stackResultDim;
      }

      function progress(params, data) {
        var segCount = params.end - params.start;
        var points = isLargeRender && new Float32Array(segCount * dimLen);

        for (var i = params.start, offset = 0, tmpIn = [], tmpOut = []; i < params.end; i++) {
          var point;

          if (dimLen === 1) {
            var x = data.get(dims[0], i);
            point = !isNaN(x) && coordSys.dataToPoint(x, null, tmpOut);
          } else {
            var x = tmpIn[0] = data.get(dims[0], i);
            var y = tmpIn[1] = data.get(dims[1], i); // Also {Array.<number>}, not undefined to avoid if...else... statement

            point = !isNaN(x) && !isNaN(y) && coordSys.dataToPoint(tmpIn, null, tmpOut);
          }

          if (isLargeRender) {
            points[offset++] = point ? point[0] : NaN;
            points[offset++] = point ? point[1] : NaN;
          } else {
            data.setItemLayout(i, point && point.slice() || [NaN, NaN]);
          }
        }

        isLargeRender && data.setLayout('symbolPoints', points);
      }

      return dimLen && {
        progress: progress
      };
    }
  };
}

module.exports = _default;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var graphic = __webpack_require__(27);

__webpack_require__(415);

__webpack_require__(1581);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Grid view
echarts.extendComponentView({
  type: 'grid',
  render: function (gridModel, ecModel) {
    this.group.removeAll();

    if (gridModel.get('show')) {
      this.group.add(new graphic.Rect({
        shape: gridModel.coordinateSystem.getRect(),
        style: zrUtil.defaults({
          fill: gridModel.get('backgroundColor')
        }, gridModel.getItemStyle()),
        silent: true,
        z2: -1
      }));
    }
  }
});
echarts.registerPreprocessor(function (option) {
  // Only create grid when need
  if (option.xAxis && option.yAxis && !option.grid) {
    option.grid = {};
  }
});

/***/ }),
/* 243 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * LegendVisualProvider is an bridge that pick encoded color from data and
 * provide to the legend component.
 * @param {Function} getDataWithEncodedVisual Function to get data after filtered. It stores all the encoding info
 * @param {Function} getRawData Function to get raw data before filtered.
 */
function LegendVisualProvider(getDataWithEncodedVisual, getRawData) {
  this.getAllNames = function () {
    var rawData = getRawData(); // We find the name from the raw data. In case it's filtered by the legend component.
    // Normally, the name can be found in rawData, but can't be found in filtered data will display as gray.

    return rawData.mapArray(rawData.getName);
  };

  this.containName = function (name) {
    var rawData = getRawData();
    return rawData.indexOfName(name) >= 0;
  };

  this.indexOfName = function (name) {
    // Only get data when necessary.
    // Because LegendVisualProvider constructor may be new in the stage that data is not prepared yet.
    // Invoking Series#getData immediately will throw an error.
    var dataWithEncodedVisual = getDataWithEncodedVisual();
    return dataWithEncodedVisual.indexOfName(name);
  };

  this.getItemVisual = function (dataIndex, key) {
    // Get encoded visual properties from final filtered data.
    var dataWithEncodedVisual = getDataWithEncodedVisual();
    return dataWithEncodedVisual.getItemVisual(dataIndex, key);
  };
}

var _default = LegendVisualProvider;
module.exports = _default;

/***/ }),
/* 244 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(seriesType) {
  return {
    seriesType: seriesType,
    reset: function (seriesModel, ecModel) {
      var legendModels = ecModel.findComponents({
        mainType: 'legend'
      });

      if (!legendModels || !legendModels.length) {
        return;
      }

      var data = seriesModel.getData();
      data.filterSelf(function (idx) {
        var name = data.getName(idx); // If in any legend component the status is not selected.

        for (var i = 0; i < legendModels.length; i++) {
          if (!legendModels[i].isSelected(name)) {
            return false;
          }
        }

        return true;
      });
    }
  };
}

module.exports = _default;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var Eventful = __webpack_require__(173);

var eventTool = __webpack_require__(121);

var interactionMutex = __webpack_require__(658);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @alias module:echarts/component/helper/RoamController
 * @constructor
 * @mixin {module:zrender/mixin/Eventful}
 *
 * @param {module:zrender/zrender~ZRender} zr
 */
function RoamController(zr) {
  /**
   * @type {Function}
   */
  this.pointerChecker;
  /**
   * @type {module:zrender}
   */

  this._zr = zr;
  /**
   * @type {Object}
   */

  this._opt = {}; // Avoid two roamController bind the same handler

  var bind = zrUtil.bind;
  var mousedownHandler = bind(mousedown, this);
  var mousemoveHandler = bind(mousemove, this);
  var mouseupHandler = bind(mouseup, this);
  var mousewheelHandler = bind(mousewheel, this);
  var pinchHandler = bind(pinch, this);
  Eventful.call(this);
  /**
   * @param {Function} pointerChecker
   *                   input: x, y
   *                   output: boolean
   */

  this.setPointerChecker = function (pointerChecker) {
    this.pointerChecker = pointerChecker;
  };
  /**
   * Notice: only enable needed types. For example, if 'zoom'
   * is not needed, 'zoom' should not be enabled, otherwise
   * default mousewheel behaviour (scroll page) will be disabled.
   *
   * @param  {boolean|string} [controlType=true] Specify the control type,
   *                          which can be null/undefined or true/false
   *                          or 'pan/move' or 'zoom'/'scale'
   * @param {Object} [opt]
   * @param {Object} [opt.zoomOnMouseWheel=true] The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
   * @param {Object} [opt.moveOnMouseMove=true] The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
   * @param {Object} [opt.moveOnMouseWheel=false] The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
   * @param {Object} [opt.preventDefaultMouseMove=true] When pan.
   */


  this.enable = function (controlType, opt) {
    // Disable previous first
    this.disable();
    this._opt = zrUtil.defaults(zrUtil.clone(opt) || {}, {
      zoomOnMouseWheel: true,
      moveOnMouseMove: true,
      // By default, wheel do not trigger move.
      moveOnMouseWheel: false,
      preventDefaultMouseMove: true
    });

    if (controlType == null) {
      controlType = true;
    }

    if (controlType === true || controlType === 'move' || controlType === 'pan') {
      zr.on('mousedown', mousedownHandler);
      zr.on('mousemove', mousemoveHandler);
      zr.on('mouseup', mouseupHandler);
    }

    if (controlType === true || controlType === 'scale' || controlType === 'zoom') {
      zr.on('mousewheel', mousewheelHandler);
      zr.on('pinch', pinchHandler);
    }
  };

  this.disable = function () {
    zr.off('mousedown', mousedownHandler);
    zr.off('mousemove', mousemoveHandler);
    zr.off('mouseup', mouseupHandler);
    zr.off('mousewheel', mousewheelHandler);
    zr.off('pinch', pinchHandler);
  };

  this.dispose = this.disable;

  this.isDragging = function () {
    return this._dragging;
  };

  this.isPinching = function () {
    return this._pinching;
  };
}

zrUtil.mixin(RoamController, Eventful);

function mousedown(e) {
  if (eventTool.isMiddleOrRightButtonOnMouseUpDown(e) || e.target && e.target.draggable) {
    return;
  }

  var x = e.offsetX;
  var y = e.offsetY; // Only check on mosedown, but not mousemove.
  // Mouse can be out of target when mouse moving.

  if (this.pointerChecker && this.pointerChecker(e, x, y)) {
    this._x = x;
    this._y = y;
    this._dragging = true;
  }
}

function mousemove(e) {
  if (!this._dragging || !isAvailableBehavior('moveOnMouseMove', e, this._opt) || e.gestureEvent === 'pinch' || interactionMutex.isTaken(this._zr, 'globalPan')) {
    return;
  }

  var x = e.offsetX;
  var y = e.offsetY;
  var oldX = this._x;
  var oldY = this._y;
  var dx = x - oldX;
  var dy = y - oldY;
  this._x = x;
  this._y = y;
  this._opt.preventDefaultMouseMove && eventTool.stop(e.event);
  trigger(this, 'pan', 'moveOnMouseMove', e, {
    dx: dx,
    dy: dy,
    oldX: oldX,
    oldY: oldY,
    newX: x,
    newY: y
  });
}

function mouseup(e) {
  if (!eventTool.isMiddleOrRightButtonOnMouseUpDown(e)) {
    this._dragging = false;
  }
}

function mousewheel(e) {
  var shouldZoom = isAvailableBehavior('zoomOnMouseWheel', e, this._opt);
  var shouldMove = isAvailableBehavior('moveOnMouseWheel', e, this._opt);
  var wheelDelta = e.wheelDelta;
  var absWheelDeltaDelta = Math.abs(wheelDelta);
  var originX = e.offsetX;
  var originY = e.offsetY; // wheelDelta maybe -0 in chrome mac.

  if (wheelDelta === 0 || !shouldZoom && !shouldMove) {
    return;
  } // If both `shouldZoom` and `shouldMove` is true, trigger
  // their event both, and the final behavior is determined
  // by event listener themselves.


  if (shouldZoom) {
    // Convenience:
    // Mac and VM Windows on Mac: scroll up: zoom out.
    // Windows: scroll up: zoom in.
    // FIXME: Should do more test in different environment.
    // wheelDelta is too complicated in difference nvironment
    // (https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel),
    // although it has been normallized by zrender.
    // wheelDelta of mouse wheel is bigger than touch pad.
    var factor = absWheelDeltaDelta > 3 ? 1.4 : absWheelDeltaDelta > 1 ? 1.2 : 1.1;
    var scale = wheelDelta > 0 ? factor : 1 / factor;
    checkPointerAndTrigger(this, 'zoom', 'zoomOnMouseWheel', e, {
      scale: scale,
      originX: originX,
      originY: originY
    });
  }

  if (shouldMove) {
    // FIXME: Should do more test in different environment.
    var absDelta = Math.abs(wheelDelta); // wheelDelta of mouse wheel is bigger than touch pad.

    var scrollDelta = (wheelDelta > 0 ? 1 : -1) * (absDelta > 3 ? 0.4 : absDelta > 1 ? 0.15 : 0.05);
    checkPointerAndTrigger(this, 'scrollMove', 'moveOnMouseWheel', e, {
      scrollDelta: scrollDelta,
      originX: originX,
      originY: originY
    });
  }
}

function pinch(e) {
  if (interactionMutex.isTaken(this._zr, 'globalPan')) {
    return;
  }

  var scale = e.pinchScale > 1 ? 1.1 : 1 / 1.1;
  checkPointerAndTrigger(this, 'zoom', null, e, {
    scale: scale,
    originX: e.pinchX,
    originY: e.pinchY
  });
}

function checkPointerAndTrigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
  if (controller.pointerChecker && controller.pointerChecker(e, contollerEvent.originX, contollerEvent.originY)) {
    // When mouse is out of roamController rect,
    // default befavoius should not be be disabled, otherwise
    // page sliding is disabled, contrary to expectation.
    eventTool.stop(e.event);
    trigger(controller, eventName, behaviorToCheck, e, contollerEvent);
  }
}

function trigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
  // Also provide behavior checker for event listener, for some case that
  // multiple components share one listener.
  contollerEvent.isAvailableBehavior = zrUtil.bind(isAvailableBehavior, null, behaviorToCheck, e);
  controller.trigger(eventName, contollerEvent);
} // settings: {
//     zoomOnMouseWheel
//     moveOnMouseMove
//     moveOnMouseWheel
// }
// The value can be: true / false / 'shift' / 'ctrl' / 'alt'.


function isAvailableBehavior(behaviorToCheck, e, settings) {
  var setting = settings[behaviorToCheck];
  return !behaviorToCheck || setting && (!zrUtil.isString(setting) || e.event[setting + 'Key']);
}

var _default = RoamController;
module.exports = _default;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var axisPointerModelHelper = __webpack_require__(303);

var axisTrigger = __webpack_require__(1710);

__webpack_require__(1711);

__webpack_require__(1712);

__webpack_require__(677);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// CartesianAxisPointer is not supposed to be required here. But consider
// echarts.simple.js and online build tooltip, which only require gridSimple,
// CartesianAxisPointer should be able to required somewhere.
echarts.registerPreprocessor(function (option) {
  // Always has a global axisPointerModel for default setting.
  if (option) {
    (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
    var link = option.axisPointer.link; // Normalize to array to avoid object mergin. But if link
    // is not set, remain null/undefined, otherwise it will
    // override existent link setting.

    if (link && !zrUtil.isArray(link)) {
      option.axisPointer.link = [link];
    }
  }
}); // This process should proformed after coordinate systems created
// and series data processed. So put it on statistic processing stage.

echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, function (ecModel, api) {
  // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
  // allAxesInfo should be updated when setOption performed.
  ecModel.getComponent('axisPointer').coordSysAxesInfo = axisPointerModelHelper.collect(ecModel, api);
}); // Broadcast to all views.

echarts.registerAction({
  type: 'updateAxisPointer',
  event: 'updateAxisPointer',
  update: ':updateAxisPointer'
}, axisTrigger);

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});// 春节日期维护
var chineseNewYear=exports.chineseNewYear={2017:{m:1,d:27},2018:{m:2,d:15},2019:{m:2,d:4},2020:{m:1,d:24},2021:{m:2,d:11},2022:{m:2,d:1},2023:{m:1,d:21},2024:{m:2,d:9},2025:{m:1,d:28},2026:{m:2,d:16},2027:{m:2,d:5}};// 收入区间
var incomeRange=exports.incomeRange={1:"一亿以上",2:"6500-1亿",3:"4000-6500万",4:"3000-4000万",5:"2000-3000万",6:"1000-2000万",7:"<1000万"};

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(19));

var _rcSwitch = _interopRequireDefault(__webpack_require__(1348));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _omit = _interopRequireDefault(__webpack_require__(71));

var _wave = _interopRequireDefault(__webpack_require__(334));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _configProvider = __webpack_require__(39);

var _warning = _interopRequireDefault(__webpack_require__(69));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Switch = /*#__PURE__*/function (_React$Component) {
  _inherits(Switch, _React$Component);

  var _super = _createSuper(Switch);

  function Switch(props) {
    var _this;

    _classCallCheck(this, Switch);

    _this = _super.call(this, props);

    _this.saveSwitch = function (node) {
      _this.rcSwitch = node;
    };

    _this.renderSwitch = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          size = _this$props.size,
          loading = _this$props.loading,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          disabled = _this$props.disabled;
      var prefixCls = getPrefixCls('switch', customizePrefixCls);
      var classes = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-small"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), loading), _classNames));
      var loadingIcon = loading ? /*#__PURE__*/React.createElement(_icon["default"], {
        type: "loading",
        className: "".concat(prefixCls, "-loading-icon")
      }) : null;
      return /*#__PURE__*/React.createElement(_wave["default"], {
        insertExtraNode: true
      }, /*#__PURE__*/React.createElement(_rcSwitch["default"], _extends({}, (0, _omit["default"])(_this.props, ['loading']), {
        prefixCls: prefixCls,
        className: classes,
        disabled: disabled || loading,
        ref: _this.saveSwitch,
        loadingIcon: loadingIcon
      })));
    };

    (0, _warning["default"])('checked' in props || !('value' in props), 'Switch', '`value` is not validate prop, do you mean `checked`?');
    return _this;
  }

  _createClass(Switch, [{
    key: "focus",
    value: function focus() {
      this.rcSwitch.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.rcSwitch.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSwitch);
    }
  }]);

  return Switch;
}(React.Component);

exports["default"] = Switch;
Switch.__ANT_SWITCH = true;
Switch.propTypes = {
  prefixCls: PropTypes.string,
  // HACK: https://github.com/ant-design/ant-design/issues/5368
  // size=default and size=large are the same
  size: PropTypes.oneOf(['small', 'default', 'large']),
  className: PropTypes.string
};

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(1350);

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcMenu = _interopRequireWildcard(__webpack_require__(190));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _omit = _interopRequireDefault(__webpack_require__(71));

var _reactLifecyclesCompat = __webpack_require__(36);

var _SubMenu = _interopRequireDefault(__webpack_require__(914));

var _MenuItem = _interopRequireDefault(__webpack_require__(915));

var _configProvider = __webpack_require__(39);

var _warning = _interopRequireDefault(__webpack_require__(69));

var _Sider = __webpack_require__(492);

var _raf = _interopRequireDefault(__webpack_require__(335));

var _motion = _interopRequireDefault(__webpack_require__(493));

var _MenuContext = _interopRequireDefault(__webpack_require__(346));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var InternalMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(InternalMenu, _React$Component);

  var _super = _createSuper(InternalMenu);

  function InternalMenu(props) {
    var _this;

    _classCallCheck(this, InternalMenu);

    _this = _super.call(this, props); // Restore vertical mode when menu is collapsed responsively when mounted
    // https://github.com/ant-design/ant-design/issues/13104
    // TODO: not a perfect solution, looking a new way to avoid setting switchingModeFromInline in this situation

    _this.handleMouseEnter = function (e) {
      _this.restoreModeVerticalFromInline();

      var onMouseEnter = _this.props.onMouseEnter;

      if (onMouseEnter) {
        onMouseEnter(e);
      }
    };

    _this.handleTransitionEnd = function (e) {
      // when inlineCollapsed menu width animation finished
      // https://github.com/ant-design/ant-design/issues/12864
      var widthCollapsed = e.propertyName === 'width' && e.target === e.currentTarget; // Fix SVGElement e.target.className.indexOf is not a function
      // https://github.com/ant-design/ant-design/issues/15699

      var className = e.target.className; // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during an animation.

      var classNameValue = Object.prototype.toString.call(className) === '[object SVGAnimatedString]' ? className.animVal : className; // Fix for <Menu style={{ width: '100%' }} />, the width transition won't trigger when menu is collapsed
      // https://github.com/ant-design/ant-design-pro/issues/2783

      var iconScaled = e.propertyName === 'font-size' && classNameValue.indexOf('anticon') >= 0;

      if (widthCollapsed || iconScaled) {
        _this.restoreModeVerticalFromInline();
      }
    };

    _this.handleClick = function (e) {
      _this.handleOpenChange([]);

      var onClick = _this.props.onClick;

      if (onClick) {
        onClick(e);
      }
    };

    _this.handleOpenChange = function (openKeys) {
      _this.setOpenKeys(openKeys);

      var onOpenChange = _this.props.onOpenChange;

      if (onOpenChange) {
        onOpenChange(openKeys);
      }
    };

    _this.renderMenu = function (_ref) {
      var getPopupContainer = _ref.getPopupContainer,
          getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          className = _this$props.className,
          theme = _this$props.theme,
          collapsedWidth = _this$props.collapsedWidth;
      var passProps = (0, _omit["default"])(_this.props, ['collapsedWidth', 'siderCollapsed']);

      var menuMode = _this.getRealMenuMode();

      var menuOpenMotion = _this.getOpenMotionProps(menuMode);

      var prefixCls = getPrefixCls('menu', customizePrefixCls);
      var menuClassName = (0, _classnames["default"])(className, "".concat(prefixCls, "-").concat(theme), _defineProperty({}, "".concat(prefixCls, "-inline-collapsed"), _this.getInlineCollapsed()));

      var menuProps = _extends({
        openKeys: _this.state.openKeys,
        onOpenChange: _this.handleOpenChange,
        className: menuClassName,
        mode: menuMode
      }, menuOpenMotion);

      if (menuMode !== 'inline') {
        // closing vertical popup submenu after click it
        menuProps.onClick = _this.handleClick;
      } // https://github.com/ant-design/ant-design/issues/8587


      var hideMenu = _this.getInlineCollapsed() && (collapsedWidth === 0 || collapsedWidth === '0' || collapsedWidth === '0px');

      if (hideMenu) {
        menuProps.openKeys = [];
      }

      return /*#__PURE__*/React.createElement(_rcMenu["default"], _extends({
        getPopupContainer: getPopupContainer
      }, passProps, menuProps, {
        prefixCls: prefixCls,
        onTransitionEnd: _this.handleTransitionEnd,
        onMouseEnter: _this.handleMouseEnter
      }));
    };

    (0, _warning["default"])(!('onOpen' in props || 'onClose' in props), 'Menu', '`onOpen` and `onClose` are removed, please use `onOpenChange` instead, ' + 'see: https://u.ant.design/menu-on-open-change.');
    (0, _warning["default"])(!('inlineCollapsed' in props && props.mode !== 'inline'), 'Menu', '`inlineCollapsed` should only be used when `mode` is inline.');
    (0, _warning["default"])(!(props.siderCollapsed !== undefined && 'inlineCollapsed' in props), 'Menu', '`inlineCollapsed` not control Menu under Sider. Should set `collapsed` on Sider instead.');
    var openKeys;

    if ('openKeys' in props) {
      openKeys = props.openKeys;
    } else if ('defaultOpenKeys' in props) {
      openKeys = props.defaultOpenKeys;
    }

    _this.state = {
      openKeys: openKeys || [],
      switchingModeFromInline: false,
      inlineOpenKeys: [],
      prevProps: props
    };
    return _this;
  }

  _createClass(InternalMenu, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _raf["default"].cancel(this.mountRafId);
    }
  }, {
    key: "setOpenKeys",
    value: function setOpenKeys(openKeys) {
      if (!('openKeys' in this.props)) {
        this.setState({
          openKeys: openKeys
        });
      }
    }
  }, {
    key: "getRealMenuMode",
    value: function getRealMenuMode() {
      var inlineCollapsed = this.getInlineCollapsed();

      if (this.state.switchingModeFromInline && inlineCollapsed) {
        return 'inline';
      }

      var mode = this.props.mode;
      return inlineCollapsed ? 'vertical' : mode;
    }
  }, {
    key: "getInlineCollapsed",
    value: function getInlineCollapsed() {
      var inlineCollapsed = this.props.inlineCollapsed;

      if (this.props.siderCollapsed !== undefined) {
        return this.props.siderCollapsed;
      }

      return inlineCollapsed;
    }
  }, {
    key: "getOpenMotionProps",
    value: function getOpenMotionProps(menuMode) {
      var _this$props2 = this.props,
          openTransitionName = _this$props2.openTransitionName,
          openAnimation = _this$props2.openAnimation,
          motion = _this$props2.motion; // Provides by user

      if (motion) {
        return {
          motion: motion
        };
      }

      if (openAnimation) {
        (0, _warning["default"])(typeof openAnimation === 'string', 'Menu', '`openAnimation` do not support object. Please use `motion` instead.');
        return {
          openAnimation: openAnimation
        };
      }

      if (openTransitionName) {
        return {
          openTransitionName: openTransitionName
        };
      } // Default logic


      if (menuMode === 'horizontal') {
        return {
          motion: {
            motionName: 'slide-up'
          }
        };
      }

      if (menuMode === 'inline') {
        return {
          motion: _motion["default"]
        };
      } // When mode switch from inline
      // submenu should hide without animation


      return {
        motion: {
          motionName: this.state.switchingModeFromInline ? '' : 'zoom-big'
        }
      };
    }
  }, {
    key: "restoreModeVerticalFromInline",
    value: function restoreModeVerticalFromInline() {
      var switchingModeFromInline = this.state.switchingModeFromInline;

      if (switchingModeFromInline) {
        this.setState({
          switchingModeFromInline: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_MenuContext["default"].Provider, {
        value: {
          inlineCollapsed: this.getInlineCollapsed() || false,
          antdMenuTheme: this.props.theme
        }
      }, /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderMenu));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var prevProps = prevState.prevProps;
      var newState = {
        prevProps: nextProps
      };

      if (prevProps.mode === 'inline' && nextProps.mode !== 'inline') {
        newState.switchingModeFromInline = true;
      }

      if ('openKeys' in nextProps) {
        newState.openKeys = nextProps.openKeys;
      } else {
        // [Legacy] Old code will return after `openKeys` changed.
        // Not sure the reason, we should keep this logic still.
        if (nextProps.inlineCollapsed && !prevProps.inlineCollapsed || nextProps.siderCollapsed && !prevProps.siderCollapsed) {
          newState.switchingModeFromInline = true;
          newState.inlineOpenKeys = prevState.openKeys;
          newState.openKeys = [];
        }

        if (!nextProps.inlineCollapsed && prevProps.inlineCollapsed || !nextProps.siderCollapsed && prevProps.siderCollapsed) {
          newState.openKeys = prevState.inlineOpenKeys;
          newState.inlineOpenKeys = [];
        }
      }

      return newState;
    }
  }]);

  return InternalMenu;
}(React.Component);

InternalMenu.defaultProps = {
  className: '',
  theme: 'light',
  focusable: false
};
(0, _reactLifecyclesCompat.polyfill)(InternalMenu); // We should keep this as ref-able

var Menu = /*#__PURE__*/function (_React$Component2) {
  _inherits(Menu, _React$Component2);

  var _super2 = _createSuper(Menu);

  function Menu() {
    _classCallCheck(this, Menu);

    return _super2.apply(this, arguments);
  }

  _createClass(Menu, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(_Sider.SiderContext.Consumer, null, function (context) {
        return /*#__PURE__*/React.createElement(InternalMenu, _extends({}, _this2.props, context));
      });
    }
  }]);

  return Menu;
}(React.Component);

exports["default"] = Menu;
Menu.Divider = _rcMenu.Divider;
Menu.Item = _MenuItem["default"];
Menu.SubMenu = _SubMenu["default"];
Menu.ItemGroup = _rcMenu.ItemGroup;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var getJson=function getJson(arr,obj){var value=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;return arr.reduce(function(a,b){return a&&a[b]?a[b]:value;},obj);};exports.default=getJson;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(451);
var enumBugKeys = __webpack_require__(323);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 256 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 257 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 258 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warning = warning;
exports.note = note;
exports.resetWarned = resetWarned;
exports.call = call;
exports.warningOnce = warningOnce;
exports.noteOnce = noteOnce;
exports.default = void 0;

/* eslint-disable no-console */
var warned = {};

function warning(valid, message) {
  // Support uglify
  if (false) {
    console.error("Warning: ".concat(message));
  }
}

function note(valid, message) {
  // Support uglify
  if (false) {
    console.warn("Note: ".concat(message));
  }
}

function resetWarned() {
  warned = {};
}

function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}

function warningOnce(valid, message) {
  call(warning, valid, message);
}

function noteOnce(valid, message) {
  call(note, valid, message);
}

var _default = warningOnce;
/* eslint-enable */

exports.default = _default;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addEventListenerWrap;

var _addDomEventListener = _interopRequireDefault(__webpack_require__(472));

var _reactDom = _interopRequireDefault(__webpack_require__(46));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = _reactDom.default.unstable_batchedUpdates ? function run(e) {
    _reactDom.default.unstable_batchedUpdates(cb, e);
  } : cb;
  return (0, _addDomEventListener.default)(target, eventType, callback, option);
}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Row", {
  enumerable: true,
  get: function get() {
    return _row["default"];
  }
});
Object.defineProperty(exports, "Col", {
  enumerable: true,
  get: function get() {
    return _col["default"];
  }
});

var _row = _interopRequireDefault(__webpack_require__(872));

var _col = _interopRequireDefault(__webpack_require__(878));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(336)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(982),
    listCacheDelete = __webpack_require__(983),
    listCacheGet = __webpack_require__(984),
    listCacheHas = __webpack_require__(985),
    listCacheSet = __webpack_require__(986);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(222);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(101);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(158);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1006);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(351),
    isLength = __webpack_require__(356);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(195),
    isObjectLike = __webpack_require__(159);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(269);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dropdown = _interopRequireDefault(__webpack_require__(525));

var _dropdownButton = _interopRequireDefault(__webpack_require__(1063));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_dropdown["default"].Button = _dropdownButton["default"];
var _default = _dropdown["default"];
exports["default"] = _default;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Checkbox = _interopRequireDefault(__webpack_require__(526));

var _Group = _interopRequireDefault(__webpack_require__(1065));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Checkbox["default"].Group = _Group["default"];
var _default = _Checkbox["default"];
exports["default"] = _default;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(95);
var toLength = __webpack_require__(58);
var toAbsoluteIndex = __webpack_require__(163);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 274 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(104);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(105);
var defined = __webpack_require__(118);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(52);
var cof = __webpack_require__(104);
var MATCH = __webpack_require__(56)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(56)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(199);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(560);
var redefine = __webpack_require__(91);
var hide = __webpack_require__(90);
var fails = __webpack_require__(51);
var defined = __webpack_require__(118);
var wks = __webpack_require__(56);
var regexpExec = __webpack_require__(390);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(49);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(49);
var $export = __webpack_require__(15);
var redefine = __webpack_require__(91);
var redefineAll = __webpack_require__(169);
var meta = __webpack_require__(145);
var forOf = __webpack_require__(168);
var anInstance = __webpack_require__(167);
var isObject = __webpack_require__(52);
var fails = __webpack_require__(51);
var $iterDetect = __webpack_require__(278);
var setToStringTag = __webpack_require__(198);
var inheritIfRequired = __webpack_require__(376);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(49);
var hide = __webpack_require__(90);
var uid = __webpack_require__(161);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(144) || !__webpack_require__(51)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(49)[K];
});


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(15);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(15);
var aFunction = __webpack_require__(81);
var ctx = __webpack_require__(103);
var forOf = __webpack_require__(168);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(1321);

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(202);
var utils = __webpack_require__(77);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var dataDefault=exports.dataDefault=[{name:'现金流量期初余额',Jan:'0',Feb:'0',Mar:'0',Apr:'0',May:'0',Jun:'0',Jul:'0',Aug:'0',Sep:'0',Oct:'0',Nov:'0',Dec:'0',sort:0},{name:'现金增加',Jan:'0',Feb:'0',Mar:'0',Apr:'0',May:'0',Jun:'0',Jul:'0',Aug:'0',Sep:'0',Oct:'0',Nov:'0',Dec:'0',sort:1},{name:'现金减少',Jan:'0',Feb:'0',Mar:'0',Apr:'0',May:'0',Jun:'0',Jul:'0',Aug:'0',Sep:'0',Oct:'0',Nov:'0',Dec:'0',sort:2},{name:'现金流量期末余额',Jan:'0',Feb:'0',Mar:'0',Apr:'0',May:'0',Jun:'0',Jul:'0',Aug:'0',Sep:'0',Oct:'0',Nov:'0',Dec:'0',sort:3},{name:'应收账款周转天数',Jan:'0',Feb:'0',Mar:'0',Apr:'0',May:'0',Jun:'0',Jul:'0',Aug:'0',Sep:'0',Oct:'0',Nov:'0',Dec:'0',sort:4},{name:'存货周转天数',Jan:'0',Feb:'0',Mar:'0',Apr:'0',May:'0',Jun:'0',Jul:'0',Aug:'0',Sep:'0',Oct:'0',Nov:'0',Dec:'0',sort:5},{name:'客房利润率',Jan:'0',Feb:'0',Mar:'0',Apr:'0',May:'0',Jun:'0',Jul:'0',Aug:'0',Sep:'0',Oct:'0',Nov:'0',Dec:'0',sort:6},{name:'餐饮利润率',Jan:'0',Feb:'0',Mar:'0',Apr:'0',May:'0',Jun:'0',Jul:'0',Aug:'0',Sep:'0',Oct:'0',Nov:'0',Dec:'0',sort:7},{name:'经营毛利率',Jan:'0',Feb:'0',Mar:'0',Apr:'0',May:'0',Jun:'0',Jul:'0',Aug:'0',Sep:'0',Oct:'0',Nov:'0',Dec:'0',sort:8},{name:'销售收入增长率',Jan:'0',Feb:'0',Mar:'0',Apr:'0',May:'0',Jun:'0',Jul:'0',Aug:'0',Sep:'0',Oct:'0',Nov:'0',Dec:'0',sort:9},{name:'经营毛利润增长率',Jan:'0',Feb:'0',Mar:'0',Apr:'0',May:'0',Jun:'0',Jul:'0',Aug:'0',Sep:'0',Oct:'0',Nov:'0',Dec:'0',sort:10}];var columnsData=exports.columnsData=[{title:"项目",key:"name",type:"text"},{title:"Jan",key:"Jan",type:"percent"},{title:"Feb",key:"Feb",type:"percent"},{title:"Mar",key:"Mar",type:"percent"},{title:"Apr",key:"Apr",type:"percent"},{title:"May",key:"May",type:"percent"},{title:"Jun",key:"Jun",type:"percent"},{title:"Jul",key:"Jul",type:"percent"},{title:"Aug",key:"Aug",type:"percent"},{title:"Sep",key:"Sep",type:"percent"},{title:"Oct",key:"Oct",type:"percent"},{title:"Nov",key:"Nov",type:"percent"},{title:"Dec",key:"Dec",type:"percent"}];var costData=exports.costData=[{name:'食品成本率',Jan:'0',Feb:'0',Mar:'0',Apr:'0',May:'0',Jun:'0',Jul:'0',Aug:'0',Sep:'0',Oct:'0',Nov:'0',Dec:'0',sort:0},{name:'人力成本率',Jan:'0',Feb:'0',Mar:'0',Apr:'0',May:'0',Jun:'0',Jul:'0',Aug:'0',Sep:'0',Oct:'0',Nov:'0',Dec:'0',sort:1},{name:'能源成本率',Jan:'0',Feb:'0',Mar:'0',Apr:'0',May:'0',Jun:'0',Jul:'0',Aug:'0',Sep:'0',Oct:'0',Nov:'0',Dec:'0',sort:2},{name:'其他费用及成本率',Jan:'0',Feb:'0',Mar:'0',Apr:'0',May:'0',Jun:'0',Jul:'0',Aug:'0',Sep:'0',Oct:'0',Nov:'0',Dec:'0',sort:3}];var depositData=exports.depositData=[{name:'银行存款期初余额',Jan:'0',Feb:'0',Mar:'0',Apr:'0',May:'0',Jun:'0',Jul:'0',Aug:'0',Sep:'0',Oct:'0',Nov:'0',Dec:'0',sort:0},{name:'银行存款增加',Jan:'0',Feb:'0',Mar:'0',Apr:'0',May:'0',Jun:'0',Jul:'0',Aug:'0',Sep:'0',Oct:'0',Nov:'0',Dec:'0',sort:1},{name:'银行存款减少',Jan:'0',Feb:'0',Mar:'0',Apr:'0',May:'0',Jun:'0',Jul:'0',Aug:'0',Sep:'0',Oct:'0',Nov:'0',Dec:'0',sort:2},{name:'银行存款期末余额',Jan:'0',Feb:'0',Mar:'0',Apr:'0',May:'0',Jun:'0',Jul:'0',Aug:'0',Sep:'0',Oct:'0',Nov:'0',Dec:'0',sort:3}];exports.default=dataDefault;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data3_1_1=exports.data3_1_1=[{name:'',name_code:"Rooms_Available",rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1},{name:'',name_code:"Rooms_Available",rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1},{name:'',name_code:"Rooms_Available",rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1},{name:'',name_code:"Rooms_Available",rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1},{name:'',name_code:"Rooms_Available",rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1},{name:'Total',name_code:"Rooms_Available",rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1}];

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var guid = __webpack_require__(613);

var env = __webpack_require__(67);

var zrUtil = __webpack_require__(1);

var Handler = __webpack_require__(1526);

var Storage = __webpack_require__(1530);

var Painter = __webpack_require__(1534);

var Animation = __webpack_require__(1536);

var HandlerProxy = __webpack_require__(1537);

/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
*/
var useVML = !env.canvasSupported;
var painterCtors = {
  canvas: Painter
};
var instances = {}; // ZRender实例map索引

/**
 * @type {string}
 */

var version = '4.3.2';
/**
 * Initializing a zrender instance
 * @param {HTMLElement} dom
 * @param {Object} [opts]
 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
 * @param {number} [opts.devicePixelRatio]
 * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
 * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
 * @return {module:zrender/ZRender}
 */

function init(dom, opts) {
  var zr = new ZRender(guid(), dom, opts);
  instances[zr.id] = zr;
  return zr;
}
/**
 * Dispose zrender instance
 * @param {module:zrender/ZRender} zr
 */


function dispose(zr) {
  if (zr) {
    zr.dispose();
  } else {
    for (var key in instances) {
      if (instances.hasOwnProperty(key)) {
        instances[key].dispose();
      }
    }

    instances = {};
  }

  return this;
}
/**
 * Get zrender instance by id
 * @param {string} id zrender instance id
 * @return {module:zrender/ZRender}
 */


function getInstance(id) {
  return instances[id];
}

function registerPainter(name, Ctor) {
  painterCtors[name] = Ctor;
}

function delInstance(id) {
  delete instances[id];
}
/**
 * @module zrender/ZRender
 */

/**
 * @constructor
 * @alias module:zrender/ZRender
 * @param {string} id
 * @param {HTMLElement} dom
 * @param {Object} opts
 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
 * @param {number} [opts.devicePixelRatio]
 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
 */


var ZRender = function (id, dom, opts) {
  opts = opts || {};
  /**
   * @type {HTMLDomElement}
   */

  this.dom = dom;
  /**
   * @type {string}
   */

  this.id = id;
  var self = this;
  var storage = new Storage();
  var rendererType = opts.renderer; // TODO WebGL

  if (useVML) {
    if (!painterCtors.vml) {
      throw new Error('You need to require \'zrender/vml/vml\' to support IE8');
    }

    rendererType = 'vml';
  } else if (!rendererType || !painterCtors[rendererType]) {
    rendererType = 'canvas';
  }

  var painter = new painterCtors[rendererType](dom, storage, opts, id);
  this.storage = storage;
  this.painter = painter;
  var handerProxy = !env.node && !env.worker ? new HandlerProxy(painter.getViewportRoot(), painter.root) : null;
  this.handler = new Handler(storage, painter, handerProxy, painter.root);
  /**
   * @type {module:zrender/animation/Animation}
   */

  this.animation = new Animation({
    stage: {
      update: zrUtil.bind(this.flush, this)
    }
  });
  this.animation.start();
  /**
   * @type {boolean}
   * @private
   */

  this._needsRefresh; // 修改 storage.delFromStorage, 每次删除元素之前删除动画
  // FIXME 有点ugly

  var oldDelFromStorage = storage.delFromStorage;
  var oldAddToStorage = storage.addToStorage;

  storage.delFromStorage = function (el) {
    oldDelFromStorage.call(storage, el);
    el && el.removeSelfFromZr(self);
  };

  storage.addToStorage = function (el) {
    oldAddToStorage.call(storage, el);
    el.addSelfToZr(self);
  };
};

ZRender.prototype = {
  constructor: ZRender,

  /**
   * 获取实例唯一标识
   * @return {string}
   */
  getId: function () {
    return this.id;
  },

  /**
   * 添加元素
   * @param  {module:zrender/Element} el
   */
  add: function (el) {
    this.storage.addRoot(el);
    this._needsRefresh = true;
  },

  /**
   * 删除元素
   * @param  {module:zrender/Element} el
   */
  remove: function (el) {
    this.storage.delRoot(el);
    this._needsRefresh = true;
  },

  /**
   * Change configuration of layer
   * @param {string} zLevel
   * @param {Object} config
   * @param {string} [config.clearColor=0] Clear color
   * @param {string} [config.motionBlur=false] If enable motion blur
   * @param {number} [config.lastFrameAlpha=0.7] Motion blur factor. Larger value cause longer trailer
  */
  configLayer: function (zLevel, config) {
    if (this.painter.configLayer) {
      this.painter.configLayer(zLevel, config);
    }

    this._needsRefresh = true;
  },

  /**
   * Set background color
   * @param {string} backgroundColor
   */
  setBackgroundColor: function (backgroundColor) {
    if (this.painter.setBackgroundColor) {
      this.painter.setBackgroundColor(backgroundColor);
    }

    this._needsRefresh = true;
  },

  /**
   * Repaint the canvas immediately
   */
  refreshImmediately: function () {
    // var start = new Date();
    // Clear needsRefresh ahead to avoid something wrong happens in refresh
    // Or it will cause zrender refreshes again and again.
    this._needsRefresh = this._needsRefreshHover = false;
    this.painter.refresh(); // Avoid trigger zr.refresh in Element#beforeUpdate hook

    this._needsRefresh = this._needsRefreshHover = false; // var end = new Date();
    // var log = document.getElementById('log');
    // if (log) {
    //     log.innerHTML = log.innerHTML + '<br>' + (end - start);
    // }
  },

  /**
   * Mark and repaint the canvas in the next frame of browser
   */
  refresh: function () {
    this._needsRefresh = true;
  },

  /**
   * Perform all refresh
   */
  flush: function () {
    var triggerRendered;

    if (this._needsRefresh) {
      triggerRendered = true;
      this.refreshImmediately();
    }

    if (this._needsRefreshHover) {
      triggerRendered = true;
      this.refreshHoverImmediately();
    }

    triggerRendered && this.trigger('rendered');
  },

  /**
   * Add element to hover layer
   * @param  {module:zrender/Element} el
   * @param {Object} style
   */
  addHover: function (el, style) {
    if (this.painter.addHover) {
      var elMirror = this.painter.addHover(el, style);
      this.refreshHover();
      return elMirror;
    }
  },

  /**
   * Add element from hover layer
   * @param  {module:zrender/Element} el
   */
  removeHover: function (el) {
    if (this.painter.removeHover) {
      this.painter.removeHover(el);
      this.refreshHover();
    }
  },

  /**
   * Clear all hover elements in hover layer
   * @param  {module:zrender/Element} el
   */
  clearHover: function () {
    if (this.painter.clearHover) {
      this.painter.clearHover();
      this.refreshHover();
    }
  },

  /**
   * Refresh hover in next frame
   */
  refreshHover: function () {
    this._needsRefreshHover = true;
  },

  /**
   * Refresh hover immediately
   */
  refreshHoverImmediately: function () {
    this._needsRefreshHover = false;
    this.painter.refreshHover && this.painter.refreshHover();
  },

  /**
   * Resize the canvas.
   * Should be invoked when container size is changed
   * @param {Object} [opts]
   * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
   * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
   */
  resize: function (opts) {
    opts = opts || {};
    this.painter.resize(opts.width, opts.height);
    this.handler.resize();
  },

  /**
   * Stop and clear all animation immediately
   */
  clearAnimation: function () {
    this.animation.clear();
  },

  /**
   * Get container width
   */
  getWidth: function () {
    return this.painter.getWidth();
  },

  /**
   * Get container height
   */
  getHeight: function () {
    return this.painter.getHeight();
  },

  /**
   * Export the canvas as Base64 URL
   * @param {string} type
   * @param {string} [backgroundColor='#fff']
   * @return {string} Base64 URL
   */
  // toDataURL: function(type, backgroundColor) {
  //     return this.painter.getRenderedCanvas({
  //         backgroundColor: backgroundColor
  //     }).toDataURL(type);
  // },

  /**
   * Converting a path to image.
   * It has much better performance of drawing image rather than drawing a vector path.
   * @param {module:zrender/graphic/Path} e
   * @param {number} width
   * @param {number} height
   */
  pathToImage: function (e, dpr) {
    return this.painter.pathToImage(e, dpr);
  },

  /**
   * Set default cursor
   * @param {string} [cursorStyle='default'] 例如 crosshair
   */
  setCursorStyle: function (cursorStyle) {
    this.handler.setCursorStyle(cursorStyle);
  },

  /**
   * Find hovered element
   * @param {number} x
   * @param {number} y
   * @return {Object} {target, topTarget}
   */
  findHover: function (x, y) {
    return this.handler.findHover(x, y);
  },

  /**
   * Bind event
   *
   * @param {string} eventName Event name
   * @param {Function} eventHandler Handler function
   * @param {Object} [context] Context object
   */
  on: function (eventName, eventHandler, context) {
    this.handler.on(eventName, eventHandler, context);
  },

  /**
   * Unbind event
   * @param {string} eventName Event name
   * @param {Function} [eventHandler] Handler function
   */
  off: function (eventName, eventHandler) {
    this.handler.off(eventName, eventHandler);
  },

  /**
   * Trigger event manually
   *
   * @param {string} eventName Event name
   * @param {event=} event Event object
   */
  trigger: function (eventName, event) {
    this.handler.trigger(eventName, event);
  },

  /**
   * Clear all objects and the canvas.
   */
  clear: function () {
    this.storage.delRoot();
    this.painter.clear();
  },

  /**
   * Dispose self.
   */
  dispose: function () {
    this.animation.stop();
    this.clear();
    this.storage.dispose();
    this.painter.dispose();
    this.handler.dispose();
    this.animation = this.storage = this.painter = this.handler = null;
    delInstance(this.id);
  }
};
exports.version = version;
exports.init = init;
exports.dispose = dispose;
exports.getInstance = getInstance;
exports.registerPainter = registerPainter;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var matrix = __webpack_require__(82);

var vector = __webpack_require__(55);

/**
 * 提供变换扩展
 * @module zrender/mixin/Transformable
 * @author pissang (https://www.github.com/pissang)
 */
var mIdentity = matrix.identity;
var EPSILON = 5e-5;

function isNotAroundZero(val) {
  return val > EPSILON || val < -EPSILON;
}
/**
 * @alias module:zrender/mixin/Transformable
 * @constructor
 */


var Transformable = function (opts) {
  opts = opts || {}; // If there are no given position, rotation, scale

  if (!opts.position) {
    /**
     * 平移
     * @type {Array.<number>}
     * @default [0, 0]
     */
    this.position = [0, 0];
  }

  if (opts.rotation == null) {
    /**
     * 旋转
     * @type {Array.<number>}
     * @default 0
     */
    this.rotation = 0;
  }

  if (!opts.scale) {
    /**
     * 缩放
     * @type {Array.<number>}
     * @default [1, 1]
     */
    this.scale = [1, 1];
  }
  /**
   * 旋转和缩放的原点
   * @type {Array.<number>}
   * @default null
   */


  this.origin = this.origin || null;
};

var transformableProto = Transformable.prototype;
transformableProto.transform = null;
/**
 * 判断是否需要有坐标变换
 * 如果有坐标变换, 则从position, rotation, scale以及父节点的transform计算出自身的transform矩阵
 */

transformableProto.needLocalTransform = function () {
  return isNotAroundZero(this.rotation) || isNotAroundZero(this.position[0]) || isNotAroundZero(this.position[1]) || isNotAroundZero(this.scale[0] - 1) || isNotAroundZero(this.scale[1] - 1);
};

var scaleTmp = [];

transformableProto.updateTransform = function () {
  var parent = this.parent;
  var parentHasTransform = parent && parent.transform;
  var needLocalTransform = this.needLocalTransform();
  var m = this.transform;

  if (!(needLocalTransform || parentHasTransform)) {
    m && mIdentity(m);
    return;
  }

  m = m || matrix.create();

  if (needLocalTransform) {
    this.getLocalTransform(m);
  } else {
    mIdentity(m);
  } // 应用父节点变换


  if (parentHasTransform) {
    if (needLocalTransform) {
      matrix.mul(m, parent.transform, m);
    } else {
      matrix.copy(m, parent.transform);
    }
  } // 保存这个变换矩阵


  this.transform = m;
  var globalScaleRatio = this.globalScaleRatio;

  if (globalScaleRatio != null && globalScaleRatio !== 1) {
    this.getGlobalScale(scaleTmp);
    var relX = scaleTmp[0] < 0 ? -1 : 1;
    var relY = scaleTmp[1] < 0 ? -1 : 1;
    var sx = ((scaleTmp[0] - relX) * globalScaleRatio + relX) / scaleTmp[0] || 0;
    var sy = ((scaleTmp[1] - relY) * globalScaleRatio + relY) / scaleTmp[1] || 0;
    m[0] *= sx;
    m[1] *= sx;
    m[2] *= sy;
    m[3] *= sy;
  }

  this.invTransform = this.invTransform || matrix.create();
  matrix.invert(this.invTransform, m);
};

transformableProto.getLocalTransform = function (m) {
  return Transformable.getLocalTransform(this, m);
};
/**
 * 将自己的transform应用到context上
 * @param {CanvasRenderingContext2D} ctx
 */


transformableProto.setTransform = function (ctx) {
  var m = this.transform;
  var dpr = ctx.dpr || 1;

  if (m) {
    ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
  } else {
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
};

transformableProto.restoreTransform = function (ctx) {
  var dpr = ctx.dpr || 1;
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
};

var tmpTransform = [];
var originTransform = matrix.create();

transformableProto.setLocalTransform = function (m) {
  if (!m) {
    // TODO return or set identity?
    return;
  }

  var sx = m[0] * m[0] + m[1] * m[1];
  var sy = m[2] * m[2] + m[3] * m[3];
  var position = this.position;
  var scale = this.scale;

  if (isNotAroundZero(sx - 1)) {
    sx = Math.sqrt(sx);
  }

  if (isNotAroundZero(sy - 1)) {
    sy = Math.sqrt(sy);
  }

  if (m[0] < 0) {
    sx = -sx;
  }

  if (m[3] < 0) {
    sy = -sy;
  }

  position[0] = m[4];
  position[1] = m[5];
  scale[0] = sx;
  scale[1] = sy;
  this.rotation = Math.atan2(-m[1] / sy, m[0] / sx);
};
/**
 * 分解`transform`矩阵到`position`, `rotation`, `scale`
 */


transformableProto.decomposeTransform = function () {
  if (!this.transform) {
    return;
  }

  var parent = this.parent;
  var m = this.transform;

  if (parent && parent.transform) {
    // Get local transform and decompose them to position, scale, rotation
    matrix.mul(tmpTransform, parent.invTransform, m);
    m = tmpTransform;
  }

  var origin = this.origin;

  if (origin && (origin[0] || origin[1])) {
    originTransform[4] = origin[0];
    originTransform[5] = origin[1];
    matrix.mul(tmpTransform, m, originTransform);
    tmpTransform[4] -= origin[0];
    tmpTransform[5] -= origin[1];
    m = tmpTransform;
  }

  this.setLocalTransform(m);
};
/**
 * Get global scale
 * @return {Array.<number>}
 */


transformableProto.getGlobalScale = function (out) {
  var m = this.transform;
  out = out || [];

  if (!m) {
    out[0] = 1;
    out[1] = 1;
    return out;
  }

  out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
  out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);

  if (m[0] < 0) {
    out[0] = -out[0];
  }

  if (m[3] < 0) {
    out[1] = -out[1];
  }

  return out;
};
/**
 * 变换坐标位置到 shape 的局部坐标空间
 * @method
 * @param {number} x
 * @param {number} y
 * @return {Array.<number>}
 */


transformableProto.transformCoordToLocal = function (x, y) {
  var v2 = [x, y];
  var invTransform = this.invTransform;

  if (invTransform) {
    vector.applyTransform(v2, v2, invTransform);
  }

  return v2;
};
/**
 * 变换局部坐标位置到全局坐标空间
 * @method
 * @param {number} x
 * @param {number} y
 * @return {Array.<number>}
 */


transformableProto.transformCoordToGlobal = function (x, y) {
  var v2 = [x, y];
  var transform = this.transform;

  if (transform) {
    vector.applyTransform(v2, v2, transform);
  }

  return v2;
};
/**
 * @static
 * @param {Object} target
 * @param {Array.<number>} target.origin
 * @param {number} target.rotation
 * @param {Array.<number>} target.position
 * @param {Array.<number>} [m]
 */


Transformable.getLocalTransform = function (target, m) {
  m = m || [];
  mIdentity(m);
  var origin = target.origin;
  var scale = target.scale || [1, 1];
  var rotation = target.rotation || 0;
  var position = target.position || [0, 0];

  if (origin) {
    // Translate to origin
    m[4] -= origin[0];
    m[5] -= origin[1];
  }

  matrix.scale(m, m, scale);

  if (rotation) {
    matrix.rotate(m, m, rotation);
  }

  if (origin) {
    // Translate back from origin
    m[4] += origin[0];
    m[5] += origin[1];
  }

  m[4] += position[0];
  m[5] += position[1];
  return m;
};

var _default = Transformable;
module.exports = _default;

/***/ }),
/* 293 */
/***/ (function(module, exports) {

var dpr = 1; // If in browser environment

if (typeof window !== 'undefined') {
  dpr = Math.max(window.devicePixelRatio || 1, 1);
}
/**
 * config默认配置项
 * @exports zrender/config
 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
 */

/**
 * Debug log mode:
 * 0: Do nothing, for release.
 * 1: console.error, for debug.
 */


var debugMode = 0; // retina 屏幕优化

var devicePixelRatio = dpr;
exports.debugMode = debugMode;
exports.devicePixelRatio = devicePixelRatio;

/***/ }),
/* 294 */
/***/ (function(module, exports) {

var ContextCachedBy = {
  NONE: 0,
  STYLE_BIND: 1,
  PLAIN_TEXT: 2
}; // Avoid confused with 0/false.

var WILL_BE_RESTORED = 9;
exports.ContextCachedBy = ContextCachedBy;
exports.WILL_BE_RESTORED = WILL_BE_RESTORED;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var _util = __webpack_require__(1);

var retrieve2 = _util.retrieve2;
var retrieve3 = _util.retrieve3;
var each = _util.each;
var normalizeCssArray = _util.normalizeCssArray;
var isString = _util.isString;
var isObject = _util.isObject;

var textContain = __webpack_require__(93);

var roundRectHelper = __webpack_require__(622);

var imageHelper = __webpack_require__(406);

var fixShadow = __webpack_require__(618);

var _constant = __webpack_require__(294);

var ContextCachedBy = _constant.ContextCachedBy;
var WILL_BE_RESTORED = _constant.WILL_BE_RESTORED;
var DEFAULT_FONT = textContain.DEFAULT_FONT; // TODO: Have not support 'start', 'end' yet.

var VALID_TEXT_ALIGN = {
  left: 1,
  right: 1,
  center: 1
};
var VALID_TEXT_VERTICAL_ALIGN = {
  top: 1,
  bottom: 1,
  middle: 1
}; // Different from `STYLE_COMMON_PROPS` of `graphic/Style`,
// the default value of shadowColor is `'transparent'`.

var SHADOW_STYLE_COMMON_PROPS = [['textShadowBlur', 'shadowBlur', 0], ['textShadowOffsetX', 'shadowOffsetX', 0], ['textShadowOffsetY', 'shadowOffsetY', 0], ['textShadowColor', 'shadowColor', 'transparent']];
var _tmpTextPositionResult = {};
var _tmpBoxPositionResult = {};
/**
 * @param {module:zrender/graphic/Style} style
 * @return {module:zrender/graphic/Style} The input style.
 */

function normalizeTextStyle(style) {
  normalizeStyle(style);
  each(style.rich, normalizeStyle);
  return style;
}

function normalizeStyle(style) {
  if (style) {
    style.font = textContain.makeFont(style);
    var textAlign = style.textAlign;
    textAlign === 'middle' && (textAlign = 'center');
    style.textAlign = textAlign == null || VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left'; // Compatible with textBaseline.

    var textVerticalAlign = style.textVerticalAlign || style.textBaseline;
    textVerticalAlign === 'center' && (textVerticalAlign = 'middle');
    style.textVerticalAlign = textVerticalAlign == null || VALID_TEXT_VERTICAL_ALIGN[textVerticalAlign] ? textVerticalAlign : 'top';
    var textPadding = style.textPadding;

    if (textPadding) {
      style.textPadding = normalizeCssArray(style.textPadding);
    }
  }
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {string} text
 * @param {module:zrender/graphic/Style} style
 * @param {Object|boolean} [rect] {x, y, width, height}
 *                  If set false, rect text is not used.
 * @param {Element|module:zrender/graphic/helper/constant.WILL_BE_RESTORED} [prevEl] For ctx prop cache.
 */


function renderText(hostEl, ctx, text, style, rect, prevEl) {
  style.rich ? renderRichText(hostEl, ctx, text, style, rect, prevEl) : renderPlainText(hostEl, ctx, text, style, rect, prevEl);
} // Avoid setting to ctx according to prevEl if possible for
// performance in scenarios of large amount text.


function renderPlainText(hostEl, ctx, text, style, rect, prevEl) {
  'use strict';

  var needDrawBg = needDrawBackground(style);
  var prevStyle;
  var checkCache = false;
  var cachedByMe = ctx.__attrCachedBy === ContextCachedBy.PLAIN_TEXT; // Only take and check cache for `Text` el, but not RectText.

  if (prevEl !== WILL_BE_RESTORED) {
    if (prevEl) {
      prevStyle = prevEl.style;
      checkCache = !needDrawBg && cachedByMe && prevStyle;
    } // Prevent from using cache in `Style::bind`, because of the case:
    // ctx property is modified by other properties than `Style::bind`
    // used, and Style::bind is called next.


    ctx.__attrCachedBy = needDrawBg ? ContextCachedBy.NONE : ContextCachedBy.PLAIN_TEXT;
  } // Since this will be restored, prevent from using these props to check cache in the next
  // entering of this method. But do not need to clear other cache like `Style::bind`.
  else if (cachedByMe) {
      ctx.__attrCachedBy = ContextCachedBy.NONE;
    }

  var styleFont = style.font || DEFAULT_FONT; // PENDING
  // Only `Text` el set `font` and keep it (`RectText` will restore). So theoretically
  // we can make font cache on ctx, which can cache for text el that are discontinuous.
  // But layer save/restore needed to be considered.
  // if (styleFont !== ctx.__fontCache) {
  //     ctx.font = styleFont;
  //     if (prevEl !== WILL_BE_RESTORED) {
  //         ctx.__fontCache = styleFont;
  //     }
  // }

  if (!checkCache || styleFont !== (prevStyle.font || DEFAULT_FONT)) {
    ctx.font = styleFont;
  } // Use the final font from context-2d, because the final
  // font might not be the style.font when it is illegal.
  // But get `ctx.font` might be time consuming.


  var computedFont = hostEl.__computedFont;

  if (hostEl.__styleFont !== styleFont) {
    hostEl.__styleFont = styleFont;
    computedFont = hostEl.__computedFont = ctx.font;
  }

  var textPadding = style.textPadding;
  var textLineHeight = style.textLineHeight;
  var contentBlock = hostEl.__textCotentBlock;

  if (!contentBlock || hostEl.__dirtyText) {
    contentBlock = hostEl.__textCotentBlock = textContain.parsePlainText(text, computedFont, textPadding, textLineHeight, style.truncate);
  }

  var outerHeight = contentBlock.outerHeight;
  var textLines = contentBlock.lines;
  var lineHeight = contentBlock.lineHeight;
  var boxPos = getBoxPosition(_tmpBoxPositionResult, hostEl, style, rect);
  var baseX = boxPos.baseX;
  var baseY = boxPos.baseY;
  var textAlign = boxPos.textAlign || 'left';
  var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.

  applyTextRotation(ctx, style, rect, baseX, baseY);
  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
  var textX = baseX;
  var textY = boxY;

  if (needDrawBg || textPadding) {
    // Consider performance, do not call getTextWidth util necessary.
    var textWidth = textContain.getWidth(text, computedFont);
    var outerWidth = textWidth;
    textPadding && (outerWidth += textPadding[1] + textPadding[3]);
    var boxX = textContain.adjustTextX(baseX, outerWidth, textAlign);
    needDrawBg && drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);

    if (textPadding) {
      textX = getTextXForPadding(baseX, textAlign, textPadding);
      textY += textPadding[0];
    }
  } // Always set textAlign and textBase line, because it is difficute to calculate
  // textAlign from prevEl, and we dont sure whether textAlign will be reset if
  // font set happened.


  ctx.textAlign = textAlign; // Force baseline to be "middle". Otherwise, if using "top", the
  // text will offset downward a little bit in font "Microsoft YaHei".

  ctx.textBaseline = 'middle'; // Set text opacity

  ctx.globalAlpha = style.opacity || 1; // Always set shadowBlur and shadowOffset to avoid leak from displayable.

  for (var i = 0; i < SHADOW_STYLE_COMMON_PROPS.length; i++) {
    var propItem = SHADOW_STYLE_COMMON_PROPS[i];
    var styleProp = propItem[0];
    var ctxProp = propItem[1];
    var val = style[styleProp];

    if (!checkCache || val !== prevStyle[styleProp]) {
      ctx[ctxProp] = fixShadow(ctx, ctxProp, val || propItem[2]);
    }
  } // `textBaseline` is set as 'middle'.


  textY += lineHeight / 2;
  var textStrokeWidth = style.textStrokeWidth;
  var textStrokeWidthPrev = checkCache ? prevStyle.textStrokeWidth : null;
  var strokeWidthChanged = !checkCache || textStrokeWidth !== textStrokeWidthPrev;
  var strokeChanged = !checkCache || strokeWidthChanged || style.textStroke !== prevStyle.textStroke;
  var textStroke = getStroke(style.textStroke, textStrokeWidth);
  var textFill = getFill(style.textFill);

  if (textStroke) {
    if (strokeWidthChanged) {
      ctx.lineWidth = textStrokeWidth;
    }

    if (strokeChanged) {
      ctx.strokeStyle = textStroke;
    }
  }

  if (textFill) {
    if (!checkCache || style.textFill !== prevStyle.textFill) {
      ctx.fillStyle = textFill;
    }
  } // Optimize simply, in most cases only one line exists.


  if (textLines.length === 1) {
    // Fill after stroke so the outline will not cover the main part.
    textStroke && ctx.strokeText(textLines[0], textX, textY);
    textFill && ctx.fillText(textLines[0], textX, textY);
  } else {
    for (var i = 0; i < textLines.length; i++) {
      // Fill after stroke so the outline will not cover the main part.
      textStroke && ctx.strokeText(textLines[i], textX, textY);
      textFill && ctx.fillText(textLines[i], textX, textY);
      textY += lineHeight;
    }
  }
}

function renderRichText(hostEl, ctx, text, style, rect, prevEl) {
  // Do not do cache for rich text because of the complexity.
  // But `RectText` this will be restored, do not need to clear other cache like `Style::bind`.
  if (prevEl !== WILL_BE_RESTORED) {
    ctx.__attrCachedBy = ContextCachedBy.NONE;
  }

  var contentBlock = hostEl.__textCotentBlock;

  if (!contentBlock || hostEl.__dirtyText) {
    contentBlock = hostEl.__textCotentBlock = textContain.parseRichText(text, style);
  }

  drawRichText(hostEl, ctx, contentBlock, style, rect);
}

function drawRichText(hostEl, ctx, contentBlock, style, rect) {
  var contentWidth = contentBlock.width;
  var outerWidth = contentBlock.outerWidth;
  var outerHeight = contentBlock.outerHeight;
  var textPadding = style.textPadding;
  var boxPos = getBoxPosition(_tmpBoxPositionResult, hostEl, style, rect);
  var baseX = boxPos.baseX;
  var baseY = boxPos.baseY;
  var textAlign = boxPos.textAlign;
  var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.

  applyTextRotation(ctx, style, rect, baseX, baseY);
  var boxX = textContain.adjustTextX(baseX, outerWidth, textAlign);
  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
  var xLeft = boxX;
  var lineTop = boxY;

  if (textPadding) {
    xLeft += textPadding[3];
    lineTop += textPadding[0];
  }

  var xRight = xLeft + contentWidth;
  needDrawBackground(style) && drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);

  for (var i = 0; i < contentBlock.lines.length; i++) {
    var line = contentBlock.lines[i];
    var tokens = line.tokens;
    var tokenCount = tokens.length;
    var lineHeight = line.lineHeight;
    var usedWidth = line.width;
    var leftIndex = 0;
    var lineXLeft = xLeft;
    var lineXRight = xRight;
    var rightIndex = tokenCount - 1;
    var token;

    while (leftIndex < tokenCount && (token = tokens[leftIndex], !token.textAlign || token.textAlign === 'left')) {
      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft, 'left');
      usedWidth -= token.width;
      lineXLeft += token.width;
      leftIndex++;
    }

    while (rightIndex >= 0 && (token = tokens[rightIndex], token.textAlign === 'right')) {
      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXRight, 'right');
      usedWidth -= token.width;
      lineXRight -= token.width;
      rightIndex--;
    } // The other tokens are placed as textAlign 'center' if there is enough space.


    lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - usedWidth) / 2;

    while (leftIndex <= rightIndex) {
      token = tokens[leftIndex]; // Consider width specified by user, use 'center' rather than 'left'.

      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center');
      lineXLeft += token.width;
      leftIndex++;
    }

    lineTop += lineHeight;
  }
}

function applyTextRotation(ctx, style, rect, x, y) {
  // textRotation only apply in RectText.
  if (rect && style.textRotation) {
    var origin = style.textOrigin;

    if (origin === 'center') {
      x = rect.width / 2 + rect.x;
      y = rect.height / 2 + rect.y;
    } else if (origin) {
      x = origin[0] + rect.x;
      y = origin[1] + rect.y;
    }

    ctx.translate(x, y); // Positive: anticlockwise

    ctx.rotate(-style.textRotation);
    ctx.translate(-x, -y);
  }
}

function placeToken(hostEl, ctx, token, style, lineHeight, lineTop, x, textAlign) {
  var tokenStyle = style.rich[token.styleName] || {};
  tokenStyle.text = token.text; // 'ctx.textBaseline' is always set as 'middle', for sake of
  // the bias of "Microsoft YaHei".

  var textVerticalAlign = token.textVerticalAlign;
  var y = lineTop + lineHeight / 2;

  if (textVerticalAlign === 'top') {
    y = lineTop + token.height / 2;
  } else if (textVerticalAlign === 'bottom') {
    y = lineTop + lineHeight - token.height / 2;
  }

  !token.isLineHolder && needDrawBackground(tokenStyle) && drawBackground(hostEl, ctx, tokenStyle, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
  var textPadding = token.textPadding;

  if (textPadding) {
    x = getTextXForPadding(x, textAlign, textPadding);
    y -= token.height / 2 - textPadding[2] - token.textHeight / 2;
  }

  setCtx(ctx, 'shadowBlur', retrieve3(tokenStyle.textShadowBlur, style.textShadowBlur, 0));
  setCtx(ctx, 'shadowColor', tokenStyle.textShadowColor || style.textShadowColor || 'transparent');
  setCtx(ctx, 'shadowOffsetX', retrieve3(tokenStyle.textShadowOffsetX, style.textShadowOffsetX, 0));
  setCtx(ctx, 'shadowOffsetY', retrieve3(tokenStyle.textShadowOffsetY, style.textShadowOffsetY, 0));
  setCtx(ctx, 'textAlign', textAlign); // Force baseline to be "middle". Otherwise, if using "top", the
  // text will offset downward a little bit in font "Microsoft YaHei".

  setCtx(ctx, 'textBaseline', 'middle');
  setCtx(ctx, 'font', token.font || DEFAULT_FONT);
  var textStroke = getStroke(tokenStyle.textStroke || style.textStroke, textStrokeWidth);
  var textFill = getFill(tokenStyle.textFill || style.textFill);
  var textStrokeWidth = retrieve2(tokenStyle.textStrokeWidth, style.textStrokeWidth); // Fill after stroke so the outline will not cover the main part.

  if (textStroke) {
    setCtx(ctx, 'lineWidth', textStrokeWidth);
    setCtx(ctx, 'strokeStyle', textStroke);
    ctx.strokeText(token.text, x, y);
  }

  if (textFill) {
    setCtx(ctx, 'fillStyle', textFill);
    ctx.fillText(token.text, x, y);
  }
}

function needDrawBackground(style) {
  return !!(style.textBackgroundColor || style.textBorderWidth && style.textBorderColor);
} // style: {textBackgroundColor, textBorderWidth, textBorderColor, textBorderRadius, text}
// shape: {x, y, width, height}


function drawBackground(hostEl, ctx, style, x, y, width, height) {
  var textBackgroundColor = style.textBackgroundColor;
  var textBorderWidth = style.textBorderWidth;
  var textBorderColor = style.textBorderColor;
  var isPlainBg = isString(textBackgroundColor);
  setCtx(ctx, 'shadowBlur', style.textBoxShadowBlur || 0);
  setCtx(ctx, 'shadowColor', style.textBoxShadowColor || 'transparent');
  setCtx(ctx, 'shadowOffsetX', style.textBoxShadowOffsetX || 0);
  setCtx(ctx, 'shadowOffsetY', style.textBoxShadowOffsetY || 0);

  if (isPlainBg || textBorderWidth && textBorderColor) {
    ctx.beginPath();
    var textBorderRadius = style.textBorderRadius;

    if (!textBorderRadius) {
      ctx.rect(x, y, width, height);
    } else {
      roundRectHelper.buildPath(ctx, {
        x: x,
        y: y,
        width: width,
        height: height,
        r: textBorderRadius
      });
    }

    ctx.closePath();
  }

  if (isPlainBg) {
    setCtx(ctx, 'fillStyle', textBackgroundColor);

    if (style.fillOpacity != null) {
      var originalGlobalAlpha = ctx.globalAlpha;
      ctx.globalAlpha = style.fillOpacity * style.opacity;
      ctx.fill();
      ctx.globalAlpha = originalGlobalAlpha;
    } else {
      ctx.fill();
    }
  } else if (isObject(textBackgroundColor)) {
    var image = textBackgroundColor.image;
    image = imageHelper.createOrUpdateImage(image, null, hostEl, onBgImageLoaded, textBackgroundColor);

    if (image && imageHelper.isImageReady(image)) {
      ctx.drawImage(image, x, y, width, height);
    }
  }

  if (textBorderWidth && textBorderColor) {
    setCtx(ctx, 'lineWidth', textBorderWidth);
    setCtx(ctx, 'strokeStyle', textBorderColor);

    if (style.strokeOpacity != null) {
      var originalGlobalAlpha = ctx.globalAlpha;
      ctx.globalAlpha = style.strokeOpacity * style.opacity;
      ctx.stroke();
      ctx.globalAlpha = originalGlobalAlpha;
    } else {
      ctx.stroke();
    }
  }
}

function onBgImageLoaded(image, textBackgroundColor) {
  // Replace image, so that `contain/text.js#parseRichText`
  // will get correct result in next tick.
  textBackgroundColor.image = image;
}

function getBoxPosition(out, hostEl, style, rect) {
  var baseX = style.x || 0;
  var baseY = style.y || 0;
  var textAlign = style.textAlign;
  var textVerticalAlign = style.textVerticalAlign; // Text position represented by coord

  if (rect) {
    var textPosition = style.textPosition;

    if (textPosition instanceof Array) {
      // Percent
      baseX = rect.x + parsePercent(textPosition[0], rect.width);
      baseY = rect.y + parsePercent(textPosition[1], rect.height);
    } else {
      var res = hostEl && hostEl.calculateTextPosition ? hostEl.calculateTextPosition(_tmpTextPositionResult, style, rect) : textContain.calculateTextPosition(_tmpTextPositionResult, style, rect);
      baseX = res.x;
      baseY = res.y; // Default align and baseline when has textPosition

      textAlign = textAlign || res.textAlign;
      textVerticalAlign = textVerticalAlign || res.textVerticalAlign;
    } // textOffset is only support in RectText, otherwise
    // we have to adjust boundingRect for textOffset.


    var textOffset = style.textOffset;

    if (textOffset) {
      baseX += textOffset[0];
      baseY += textOffset[1];
    }
  }

  out = out || {};
  out.baseX = baseX;
  out.baseY = baseY;
  out.textAlign = textAlign;
  out.textVerticalAlign = textVerticalAlign;
  return out;
}

function setCtx(ctx, prop, value) {
  ctx[prop] = fixShadow(ctx, prop, value);
  return ctx[prop];
}
/**
 * @param {string} [stroke] If specified, do not check style.textStroke.
 * @param {string} [lineWidth] If specified, do not check style.textStroke.
 * @param {number} style
 */


function getStroke(stroke, lineWidth) {
  return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null // TODO pattern and gradient?
  : stroke.image || stroke.colorStops ? '#000' : stroke;
}

function getFill(fill) {
  return fill == null || fill === 'none' ? null // TODO pattern and gradient?
  : fill.image || fill.colorStops ? '#000' : fill;
}

function parsePercent(value, maxValue) {
  if (typeof value === 'string') {
    if (value.lastIndexOf('%') >= 0) {
      return parseFloat(value) / 100 * maxValue;
    }

    return parseFloat(value);
  }

  return value;
}

function getTextXForPadding(x, textAlign, textPadding) {
  return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
}
/**
 * @param {string} text
 * @param {module:zrender/Style} style
 * @return {boolean}
 */


function needDrawText(text, style) {
  return text != null && (text || style.textBackgroundColor || style.textBorderWidth && style.textBorderColor || style.textPadding);
}

exports.normalizeTextStyle = normalizeTextStyle;
exports.renderText = renderText;
exports.getBoxPosition = getBoxPosition;
exports.getStroke = getStroke;
exports.getFill = getFill;
exports.parsePercent = parsePercent;
exports.needDrawText = needDrawText;

/***/ }),
/* 296 */
/***/ (function(module, exports) {

/**
 * @param {Array.<Object>} colorStops
 */
var Gradient = function (colorStops) {
  this.colorStops = colorStops || [];
};

Gradient.prototype = {
  constructor: Gradient,
  addColorStop: function (offset, color) {
    this.colorStops.push({
      offset: offset,
      color: color
    });
  }
};
var _default = Gradient;
module.exports = _default;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var Group = __webpack_require__(174);

var componentUtil = __webpack_require__(235);

var clazzUtil = __webpack_require__(135);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var Component = function () {
  /**
   * @type {module:zrender/container/Group}
   * @readOnly
   */
  this.group = new Group();
  /**
   * @type {string}
   * @readOnly
   */

  this.uid = componentUtil.getUID('viewComponent');
};

Component.prototype = {
  constructor: Component,
  init: function (ecModel, api) {},
  render: function (componentModel, ecModel, api, payload) {},
  dispose: function () {},

  /**
   * @param {string} eventType
   * @param {Object} query
   * @param {module:zrender/Element} targetEl
   * @param {Object} packedEvent
   * @return {boolen} Pass only when return `true`.
   */
  filterForExposedEvent: null
};
var componentProto = Component.prototype;

componentProto.updateView = componentProto.updateLayout = componentProto.updateVisual = function (seriesModel, ecModel, api, payload) {// Do nothing;
}; // Enable Component.extend.


clazzUtil.enableClassExtend(Component); // Enable capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.

clazzUtil.enableClassManagement(Component, {
  registerWhenExtend: true
});
var _default = Component;
module.exports = _default;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var clazzUtil = __webpack_require__(135);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * // Scale class management
 * @module echarts/scale/Scale
 */

/**
 * @param {Object} [setting]
 */
function Scale(setting) {
  this._setting = setting || {};
  /**
   * Extent
   * @type {Array.<number>}
   * @protected
   */

  this._extent = [Infinity, -Infinity];
  /**
   * Step is calculated in adjustExtent
   * @type {Array.<number>}
   * @protected
   */

  this._interval = 0;
  this.init && this.init.apply(this, arguments);
}
/**
 * Parse input val to valid inner number.
 * @param {*} val
 * @return {number}
 */


Scale.prototype.parse = function (val) {
  // Notice: This would be a trap here, If the implementation
  // of this method depends on extent, and this method is used
  // before extent set (like in dataZoom), it would be wrong.
  // Nevertheless, parse does not depend on extent generally.
  return val;
};

Scale.prototype.getSetting = function (name) {
  return this._setting[name];
};

Scale.prototype.contain = function (val) {
  var extent = this._extent;
  return val >= extent[0] && val <= extent[1];
};
/**
 * Normalize value to linear [0, 1], return 0.5 if extent span is 0
 * @param {number} val
 * @return {number}
 */


Scale.prototype.normalize = function (val) {
  var extent = this._extent;

  if (extent[1] === extent[0]) {
    return 0.5;
  }

  return (val - extent[0]) / (extent[1] - extent[0]);
};
/**
 * Scale normalized value
 * @param {number} val
 * @return {number}
 */


Scale.prototype.scale = function (val) {
  var extent = this._extent;
  return val * (extent[1] - extent[0]) + extent[0];
};
/**
 * Set extent from data
 * @param {Array.<number>} other
 */


Scale.prototype.unionExtent = function (other) {
  var extent = this._extent;
  other[0] < extent[0] && (extent[0] = other[0]);
  other[1] > extent[1] && (extent[1] = other[1]); // not setExtent because in log axis it may transformed to power
  // this.setExtent(extent[0], extent[1]);
};
/**
 * Set extent from data
 * @param {module:echarts/data/List} data
 * @param {string} dim
 */


Scale.prototype.unionExtentFromData = function (data, dim) {
  this.unionExtent(data.getApproximateExtent(dim));
};
/**
 * Get extent
 * @return {Array.<number>}
 */


Scale.prototype.getExtent = function () {
  return this._extent.slice();
};
/**
 * Set extent
 * @param {number} start
 * @param {number} end
 */


Scale.prototype.setExtent = function (start, end) {
  var thisExtent = this._extent;

  if (!isNaN(start)) {
    thisExtent[0] = start;
  }

  if (!isNaN(end)) {
    thisExtent[1] = end;
  }
};
/**
 * When axis extent depends on data and no data exists,
 * axis ticks should not be drawn, which is named 'blank'.
 */


Scale.prototype.isBlank = function () {
  return this._isBlank;
},
/**
 * When axis extent depends on data and no data exists,
 * axis ticks should not be drawn, which is named 'blank'.
 */
Scale.prototype.setBlank = function (isBlank) {
  this._isBlank = isBlank;
};
/**
 * @abstract
 * @param {*} tick
 * @return {string} label of the tick.
 */

Scale.prototype.getLabel = null;
clazzUtil.enableClassExtend(Scale);
clazzUtil.enableClassManagement(Scale, {
  registerWhenExtend: true
});
var _default = Scale;
module.exports = _default;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var numberUtil = __webpack_require__(37);

var formatUtil = __webpack_require__(54);

var Scale = __webpack_require__(298);

var helper = __webpack_require__(643);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Interval scale
 * @module echarts/scale/Interval
 */
var roundNumber = numberUtil.round;
/**
 * @alias module:echarts/coord/scale/Interval
 * @constructor
 */

var IntervalScale = Scale.extend({
  type: 'interval',
  _interval: 0,
  _intervalPrecision: 2,
  setExtent: function (start, end) {
    var thisExtent = this._extent; //start,end may be a Number like '25',so...

    if (!isNaN(start)) {
      thisExtent[0] = parseFloat(start);
    }

    if (!isNaN(end)) {
      thisExtent[1] = parseFloat(end);
    }
  },
  unionExtent: function (other) {
    var extent = this._extent;
    other[0] < extent[0] && (extent[0] = other[0]);
    other[1] > extent[1] && (extent[1] = other[1]); // unionExtent may called by it's sub classes

    IntervalScale.prototype.setExtent.call(this, extent[0], extent[1]);
  },

  /**
   * Get interval
   */
  getInterval: function () {
    return this._interval;
  },

  /**
   * Set interval
   */
  setInterval: function (interval) {
    this._interval = interval; // Dropped auto calculated niceExtent and use user setted extent
    // We assume user wan't to set both interval, min, max to get a better result

    this._niceExtent = this._extent.slice();
    this._intervalPrecision = helper.getIntervalPrecision(interval);
  },

  /**
   * @param {boolean} [expandToNicedExtent=false] If expand the ticks to niced extent.
   * @return {Array.<number>}
   */
  getTicks: function (expandToNicedExtent) {
    var interval = this._interval;
    var extent = this._extent;
    var niceTickExtent = this._niceExtent;
    var intervalPrecision = this._intervalPrecision;
    var ticks = []; // If interval is 0, return [];

    if (!interval) {
      return ticks;
    } // Consider this case: using dataZoom toolbox, zoom and zoom.


    var safeLimit = 10000;

    if (extent[0] < niceTickExtent[0]) {
      if (expandToNicedExtent) {
        ticks.push(roundNumber(niceTickExtent[0] - interval, intervalPrecision));
      } else {
        ticks.push(extent[0]);
      }
    }

    var tick = niceTickExtent[0];

    while (tick <= niceTickExtent[1]) {
      ticks.push(tick); // Avoid rounding error

      tick = roundNumber(tick + interval, intervalPrecision);

      if (tick === ticks[ticks.length - 1]) {
        // Consider out of safe float point, e.g.,
        // -3711126.9907707 + 2e-10 === -3711126.9907707
        break;
      }

      if (ticks.length > safeLimit) {
        return [];
      }
    } // Consider this case: the last item of ticks is smaller
    // than niceTickExtent[1] and niceTickExtent[1] === extent[1].


    var lastNiceTick = ticks.length ? ticks[ticks.length - 1] : niceTickExtent[1];

    if (extent[1] > lastNiceTick) {
      if (expandToNicedExtent) {
        ticks.push(roundNumber(lastNiceTick + interval, intervalPrecision));
      } else {
        ticks.push(extent[1]);
      }
    }

    return ticks;
  },

  /**
   * @param {number} [splitNumber=5]
   * @return {Array.<Array.<number>>}
   */
  getMinorTicks: function (splitNumber) {
    var ticks = this.getTicks(true);
    var minorTicks = [];
    var extent = this.getExtent();

    for (var i = 1; i < ticks.length; i++) {
      var nextTick = ticks[i];
      var prevTick = ticks[i - 1];
      var count = 0;
      var minorTicksGroup = [];
      var interval = nextTick - prevTick;
      var minorInterval = interval / splitNumber;

      while (count < splitNumber - 1) {
        var minorTick = numberUtil.round(prevTick + (count + 1) * minorInterval); // For the first and last interval. The count may be less than splitNumber.

        if (minorTick > extent[0] && minorTick < extent[1]) {
          minorTicksGroup.push(minorTick);
        }

        count++;
      }

      minorTicks.push(minorTicksGroup);
    }

    return minorTicks;
  },

  /**
   * @param {number} data
   * @param {Object} [opt]
   * @param {number|string} [opt.precision] If 'auto', use nice presision.
   * @param {boolean} [opt.pad] returns 1.50 but not 1.5 if precision is 2.
   * @return {string}
   */
  getLabel: function (data, opt) {
    if (data == null) {
      return '';
    }

    var precision = opt && opt.precision;

    if (precision == null) {
      precision = numberUtil.getPrecisionSafe(data) || 0;
    } else if (precision === 'auto') {
      // Should be more precise then tick.
      precision = this._intervalPrecision;
    } // (1) If `precision` is set, 12.005 should be display as '12.00500'.
    // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.


    data = roundNumber(data, precision, true);
    return formatUtil.addCommas(data);
  },

  /**
   * Update interval and extent of intervals for nice ticks
   *
   * @param {number} [splitNumber = 5] Desired number of ticks
   * @param {number} [minInterval]
   * @param {number} [maxInterval]
   */
  niceTicks: function (splitNumber, minInterval, maxInterval) {
    splitNumber = splitNumber || 5;
    var extent = this._extent;
    var span = extent[1] - extent[0];

    if (!isFinite(span)) {
      return;
    } // User may set axis min 0 and data are all negative
    // FIXME If it needs to reverse ?


    if (span < 0) {
      span = -span;
      extent.reverse();
    }

    var result = helper.intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval);
    this._intervalPrecision = result.intervalPrecision;
    this._interval = result.interval;
    this._niceExtent = result.niceTickExtent;
  },

  /**
   * Nice extent.
   * @param {Object} opt
   * @param {number} [opt.splitNumber = 5] Given approx tick number
   * @param {boolean} [opt.fixMin=false]
   * @param {boolean} [opt.fixMax=false]
   * @param {boolean} [opt.minInterval]
   * @param {boolean} [opt.maxInterval]
   */
  niceExtent: function (opt) {
    var extent = this._extent; // If extent start and end are same, expand them

    if (extent[0] === extent[1]) {
      if (extent[0] !== 0) {
        // Expand extent
        var expandSize = extent[0]; // In the fowllowing case
        //      Axis has been fixed max 100
        //      Plus data are all 100 and axis extent are [100, 100].
        // Extend to the both side will cause expanded max is larger than fixed max.
        // So only expand to the smaller side.

        if (!opt.fixMax) {
          extent[1] += expandSize / 2;
          extent[0] -= expandSize / 2;
        } else {
          extent[0] -= expandSize / 2;
        }
      } else {
        extent[1] = 1;
      }
    }

    var span = extent[1] - extent[0]; // If there are no data and extent are [Infinity, -Infinity]

    if (!isFinite(span)) {
      extent[0] = 0;
      extent[1] = 1;
    }

    this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;

    var interval = this._interval;

    if (!opt.fixMin) {
      extent[0] = roundNumber(Math.floor(extent[0] / interval) * interval);
    }

    if (!opt.fixMax) {
      extent[1] = roundNumber(Math.ceil(extent[1] / interval) * interval);
    }
  }
});
/**
 * @return {module:echarts/scale/Time}
 */

IntervalScale.create = function () {
  return new IntervalScale();
};

var _default = IntervalScale;
module.exports = _default;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var _number = __webpack_require__(37);

var parsePercent = _number.parsePercent;

var _dataStackHelper = __webpack_require__(124);

var isDimensionStacked = _dataStackHelper.isDimensionStacked;

var createRenderPlanner = __webpack_require__(206);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/* global Float32Array */
var STACK_PREFIX = '__ec_stack_';
var LARGE_BAR_MIN_WIDTH = 0.5;
var LargeArr = typeof Float32Array !== 'undefined' ? Float32Array : Array;

function getSeriesStackId(seriesModel) {
  return seriesModel.get('stack') || STACK_PREFIX + seriesModel.seriesIndex;
}

function getAxisKey(axis) {
  return axis.dim + axis.index;
}
/**
 * @param {Object} opt
 * @param {module:echarts/coord/Axis} opt.axis Only support category axis currently.
 * @param {number} opt.count Positive interger.
 * @param {number} [opt.barWidth]
 * @param {number} [opt.barMaxWidth]
 * @param {number} [opt.barMinWidth]
 * @param {number} [opt.barGap]
 * @param {number} [opt.barCategoryGap]
 * @return {Object} {width, offset, offsetCenter} If axis.type is not 'category', return undefined.
 */


function getLayoutOnAxis(opt) {
  var params = [];
  var baseAxis = opt.axis;
  var axisKey = 'axis0';

  if (baseAxis.type !== 'category') {
    return;
  }

  var bandWidth = baseAxis.getBandWidth();

  for (var i = 0; i < opt.count || 0; i++) {
    params.push(zrUtil.defaults({
      bandWidth: bandWidth,
      axisKey: axisKey,
      stackId: STACK_PREFIX + i
    }, opt));
  }

  var widthAndOffsets = doCalBarWidthAndOffset(params);
  var result = [];

  for (var i = 0; i < opt.count; i++) {
    var item = widthAndOffsets[axisKey][STACK_PREFIX + i];
    item.offsetCenter = item.offset + item.width / 2;
    result.push(item);
  }

  return result;
}

function prepareLayoutBarSeries(seriesType, ecModel) {
  var seriesModels = [];
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    // Check series coordinate, do layout for cartesian2d only
    if (isOnCartesian(seriesModel) && !isInLargeMode(seriesModel)) {
      seriesModels.push(seriesModel);
    }
  });
  return seriesModels;
}
/**
 * Map from (baseAxis.dim + '_' + baseAxis.index) to min gap of two adjacent
 * values.
 * This works for time axes, value axes, and log axes.
 * For a single time axis, return value is in the form like
 * {'x_0': [1000000]}.
 * The value of 1000000 is in milliseconds.
 */


function getValueAxesMinGaps(barSeries) {
  /**
   * Map from axis.index to values.
   * For a single time axis, axisValues is in the form like
   * {'x_0': [1495555200000, 1495641600000, 1495728000000]}.
   * Items in axisValues[x], e.g. 1495555200000, are time values of all
   * series.
   */
  var axisValues = {};
  zrUtil.each(barSeries, function (seriesModel) {
    var cartesian = seriesModel.coordinateSystem;
    var baseAxis = cartesian.getBaseAxis();

    if (baseAxis.type !== 'time' && baseAxis.type !== 'value') {
      return;
    }

    var data = seriesModel.getData();
    var key = baseAxis.dim + '_' + baseAxis.index;
    var dim = data.mapDimension(baseAxis.dim);

    for (var i = 0, cnt = data.count(); i < cnt; ++i) {
      var value = data.get(dim, i);

      if (!axisValues[key]) {
        // No previous data for the axis
        axisValues[key] = [value];
      } else {
        // No value in previous series
        axisValues[key].push(value);
      } // Ignore duplicated time values in the same axis

    }
  });
  var axisMinGaps = [];

  for (var key in axisValues) {
    if (axisValues.hasOwnProperty(key)) {
      var valuesInAxis = axisValues[key];

      if (valuesInAxis) {
        // Sort axis values into ascending order to calculate gaps
        valuesInAxis.sort(function (a, b) {
          return a - b;
        });
        var min = null;

        for (var j = 1; j < valuesInAxis.length; ++j) {
          var delta = valuesInAxis[j] - valuesInAxis[j - 1];

          if (delta > 0) {
            // Ignore 0 delta because they are of the same axis value
            min = min === null ? delta : Math.min(min, delta);
          }
        } // Set to null if only have one data


        axisMinGaps[key] = min;
      }
    }
  }

  return axisMinGaps;
}

function makeColumnLayout(barSeries) {
  var axisMinGaps = getValueAxesMinGaps(barSeries);
  var seriesInfoList = [];
  zrUtil.each(barSeries, function (seriesModel) {
    var cartesian = seriesModel.coordinateSystem;
    var baseAxis = cartesian.getBaseAxis();
    var axisExtent = baseAxis.getExtent();
    var bandWidth;

    if (baseAxis.type === 'category') {
      bandWidth = baseAxis.getBandWidth();
    } else if (baseAxis.type === 'value' || baseAxis.type === 'time') {
      var key = baseAxis.dim + '_' + baseAxis.index;
      var minGap = axisMinGaps[key];
      var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
      var scale = baseAxis.scale.getExtent();
      var scaleSpan = Math.abs(scale[1] - scale[0]);
      bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan; // When there is only one data value
    } else {
      var data = seriesModel.getData();
      bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
    }

    var barWidth = parsePercent(seriesModel.get('barWidth'), bandWidth);
    var barMaxWidth = parsePercent(seriesModel.get('barMaxWidth'), bandWidth);
    var barMinWidth = parsePercent( // barMinWidth by default is 1 in cartesian. Because in value axis,
    // the auto-calculated bar width might be less than 1.
    seriesModel.get('barMinWidth') || 1, bandWidth);
    var barGap = seriesModel.get('barGap');
    var barCategoryGap = seriesModel.get('barCategoryGap');
    seriesInfoList.push({
      bandWidth: bandWidth,
      barWidth: barWidth,
      barMaxWidth: barMaxWidth,
      barMinWidth: barMinWidth,
      barGap: barGap,
      barCategoryGap: barCategoryGap,
      axisKey: getAxisKey(baseAxis),
      stackId: getSeriesStackId(seriesModel)
    });
  });
  return doCalBarWidthAndOffset(seriesInfoList);
}

function doCalBarWidthAndOffset(seriesInfoList) {
  // Columns info on each category axis. Key is cartesian name
  var columnsMap = {};
  zrUtil.each(seriesInfoList, function (seriesInfo, idx) {
    var axisKey = seriesInfo.axisKey;
    var bandWidth = seriesInfo.bandWidth;
    var columnsOnAxis = columnsMap[axisKey] || {
      bandWidth: bandWidth,
      remainedWidth: bandWidth,
      autoWidthCount: 0,
      categoryGap: '20%',
      gap: '30%',
      stacks: {}
    };
    var stacks = columnsOnAxis.stacks;
    columnsMap[axisKey] = columnsOnAxis;
    var stackId = seriesInfo.stackId;

    if (!stacks[stackId]) {
      columnsOnAxis.autoWidthCount++;
    }

    stacks[stackId] = stacks[stackId] || {
      width: 0,
      maxWidth: 0
    }; // Caution: In a single coordinate system, these barGrid attributes
    // will be shared by series. Consider that they have default values,
    // only the attributes set on the last series will work.
    // Do not change this fact unless there will be a break change.

    var barWidth = seriesInfo.barWidth;

    if (barWidth && !stacks[stackId].width) {
      // See #6312, do not restrict width.
      stacks[stackId].width = barWidth;
      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
      columnsOnAxis.remainedWidth -= barWidth;
    }

    var barMaxWidth = seriesInfo.barMaxWidth;
    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
    var barMinWidth = seriesInfo.barMinWidth;
    barMinWidth && (stacks[stackId].minWidth = barMinWidth);
    var barGap = seriesInfo.barGap;
    barGap != null && (columnsOnAxis.gap = barGap);
    var barCategoryGap = seriesInfo.barCategoryGap;
    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
  });
  var result = {};
  zrUtil.each(columnsMap, function (columnsOnAxis, coordSysName) {
    result[coordSysName] = {};
    var stacks = columnsOnAxis.stacks;
    var bandWidth = columnsOnAxis.bandWidth;
    var categoryGap = parsePercent(columnsOnAxis.categoryGap, bandWidth);
    var barGapPercent = parsePercent(columnsOnAxis.gap, 1);
    var remainedWidth = columnsOnAxis.remainedWidth;
    var autoWidthCount = columnsOnAxis.autoWidthCount;
    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth

    zrUtil.each(stacks, function (column) {
      var maxWidth = column.maxWidth;
      var minWidth = column.minWidth;

      if (!column.width) {
        var finalWidth = autoWidth;

        if (maxWidth && maxWidth < finalWidth) {
          finalWidth = Math.min(maxWidth, remainedWidth);
        } // `minWidth` has higher priority. `minWidth` decide that wheter the
        // bar is able to be visible. So `minWidth` should not be restricted
        // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
        // the extreme cases for `value` axis, bars are allowed to overlap
        // with each other if `minWidth` specified.


        if (minWidth && minWidth > finalWidth) {
          finalWidth = minWidth;
        }

        if (finalWidth !== autoWidth) {
          column.width = finalWidth;
          remainedWidth -= finalWidth + barGapPercent * finalWidth;
          autoWidthCount--;
        }
      } else {
        // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
        // CSS does. Becuase barWidth can be a percent value, where
        // `barMaxWidth` can be used to restrict the final width.
        var finalWidth = column.width;

        if (maxWidth) {
          finalWidth = Math.min(finalWidth, maxWidth);
        } // `minWidth` has higher priority, as described above


        if (minWidth) {
          finalWidth = Math.max(finalWidth, minWidth);
        }

        column.width = finalWidth;
        remainedWidth -= finalWidth + barGapPercent * finalWidth;
        autoWidthCount--;
      }
    }); // Recalculate width again

    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = Math.max(autoWidth, 0);
    var widthSum = 0;
    var lastColumn;
    zrUtil.each(stacks, function (column, idx) {
      if (!column.width) {
        column.width = autoWidth;
      }

      lastColumn = column;
      widthSum += column.width * (1 + barGapPercent);
    });

    if (lastColumn) {
      widthSum -= lastColumn.width * barGapPercent;
    }

    var offset = -widthSum / 2;
    zrUtil.each(stacks, function (column, stackId) {
      result[coordSysName][stackId] = result[coordSysName][stackId] || {
        bandWidth: bandWidth,
        offset: offset,
        width: column.width
      };
      offset += column.width * (1 + barGapPercent);
    });
  });
  return result;
}
/**
 * @param {Object} barWidthAndOffset The result of makeColumnLayout
 * @param {module:echarts/coord/Axis} axis
 * @param {module:echarts/model/Series} [seriesModel] If not provided, return all.
 * @return {Object} {stackId: {offset, width}} or {offset, width} if seriesModel provided.
 */


function retrieveColumnLayout(barWidthAndOffset, axis, seriesModel) {
  if (barWidthAndOffset && axis) {
    var result = barWidthAndOffset[getAxisKey(axis)];

    if (result != null && seriesModel != null) {
      result = result[getSeriesStackId(seriesModel)];
    }

    return result;
  }
}
/**
 * @param {string} seriesType
 * @param {module:echarts/model/Global} ecModel
 */


function layout(seriesType, ecModel) {
  var seriesModels = prepareLayoutBarSeries(seriesType, ecModel);
  var barWidthAndOffset = makeColumnLayout(seriesModels);
  var lastStackCoords = {};
  var lastStackCoordsOrigin = {};
  zrUtil.each(seriesModels, function (seriesModel) {
    var data = seriesModel.getData();
    var cartesian = seriesModel.coordinateSystem;
    var baseAxis = cartesian.getBaseAxis();
    var stackId = getSeriesStackId(seriesModel);
    var columnLayoutInfo = barWidthAndOffset[getAxisKey(baseAxis)][stackId];
    var columnOffset = columnLayoutInfo.offset;
    var columnWidth = columnLayoutInfo.width;
    var valueAxis = cartesian.getOtherAxis(baseAxis);
    var barMinHeight = seriesModel.get('barMinHeight') || 0;
    lastStackCoords[stackId] = lastStackCoords[stackId] || [];
    lastStackCoordsOrigin[stackId] = lastStackCoordsOrigin[stackId] || []; // Fix #4243

    data.setLayout({
      bandWidth: columnLayoutInfo.bandWidth,
      offset: columnOffset,
      size: columnWidth
    });
    var valueDim = data.mapDimension(valueAxis.dim);
    var baseDim = data.mapDimension(baseAxis.dim);
    var stacked = isDimensionStacked(data, valueDim
    /*, baseDim*/
    );
    var isValueAxisH = valueAxis.isHorizontal();
    var valueAxisStart = getValueAxisStart(baseAxis, valueAxis, stacked);

    for (var idx = 0, len = data.count(); idx < len; idx++) {
      var value = data.get(valueDim, idx);
      var baseValue = data.get(baseDim, idx);
      var sign = value >= 0 ? 'p' : 'n';
      var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
      // stackResultDimension directly.

      if (stacked) {
        // Only ordinal axis can be stacked.
        if (!lastStackCoords[stackId][baseValue]) {
          lastStackCoords[stackId][baseValue] = {
            p: valueAxisStart,
            // Positive stack
            n: valueAxisStart // Negative stack

          };
        } // Should also consider #4243


        baseCoord = lastStackCoords[stackId][baseValue][sign];
      }

      var x;
      var y;
      var width;
      var height;

      if (isValueAxisH) {
        var coord = cartesian.dataToPoint([value, baseValue]);
        x = baseCoord;
        y = coord[1] + columnOffset;
        width = coord[0] - valueAxisStart;
        height = columnWidth;

        if (Math.abs(width) < barMinHeight) {
          width = (width < 0 ? -1 : 1) * barMinHeight;
        } // Ignore stack from NaN value


        if (!isNaN(width)) {
          stacked && (lastStackCoords[stackId][baseValue][sign] += width);
        }
      } else {
        var coord = cartesian.dataToPoint([baseValue, value]);
        x = coord[0] + columnOffset;
        y = baseCoord;
        width = columnWidth;
        height = coord[1] - valueAxisStart;

        if (Math.abs(height) < barMinHeight) {
          // Include zero to has a positive bar
          height = (height <= 0 ? -1 : 1) * barMinHeight;
        } // Ignore stack from NaN value


        if (!isNaN(height)) {
          stacked && (lastStackCoords[stackId][baseValue][sign] += height);
        }
      }

      data.setItemLayout(idx, {
        x: x,
        y: y,
        width: width,
        height: height
      });
    }
  }, this);
} // TODO: Do not support stack in large mode yet.


var largeLayout = {
  seriesType: 'bar',
  plan: createRenderPlanner(),
  reset: function (seriesModel) {
    if (!isOnCartesian(seriesModel) || !isInLargeMode(seriesModel)) {
      return;
    }

    var data = seriesModel.getData();
    var cartesian = seriesModel.coordinateSystem;
    var coordLayout = cartesian.grid.getRect();
    var baseAxis = cartesian.getBaseAxis();
    var valueAxis = cartesian.getOtherAxis(baseAxis);
    var valueDim = data.mapDimension(valueAxis.dim);
    var baseDim = data.mapDimension(baseAxis.dim);
    var valueAxisHorizontal = valueAxis.isHorizontal();
    var valueDimIdx = valueAxisHorizontal ? 0 : 1;
    var barWidth = retrieveColumnLayout(makeColumnLayout([seriesModel]), baseAxis, seriesModel).width;

    if (!(barWidth > LARGE_BAR_MIN_WIDTH)) {
      // jshint ignore:line
      barWidth = LARGE_BAR_MIN_WIDTH;
    }

    return {
      progress: progress
    };

    function progress(params, data) {
      var count = params.count;
      var largePoints = new LargeArr(count * 2);
      var largeBackgroundPoints = new LargeArr(count * 2);
      var largeDataIndices = new LargeArr(count);
      var dataIndex;
      var coord = [];
      var valuePair = [];
      var pointsOffset = 0;
      var idxOffset = 0;

      while ((dataIndex = params.next()) != null) {
        valuePair[valueDimIdx] = data.get(valueDim, dataIndex);
        valuePair[1 - valueDimIdx] = data.get(baseDim, dataIndex);
        coord = cartesian.dataToPoint(valuePair, null, coord); // Data index might not be in order, depends on `progressiveChunkMode`.

        largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coordLayout.x + coordLayout.width : coord[0];
        largePoints[pointsOffset++] = coord[0];
        largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coord[1] : coordLayout.y + coordLayout.height;
        largePoints[pointsOffset++] = coord[1];
        largeDataIndices[idxOffset++] = dataIndex;
      }

      data.setLayout({
        largePoints: largePoints,
        largeDataIndices: largeDataIndices,
        largeBackgroundPoints: largeBackgroundPoints,
        barWidth: barWidth,
        valueAxisStart: getValueAxisStart(baseAxis, valueAxis, false),
        backgroundStart: valueAxisHorizontal ? coordLayout.x : coordLayout.y,
        valueAxisHorizontal: valueAxisHorizontal
      });
    }
  }
};

function isOnCartesian(seriesModel) {
  return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
}

function isInLargeMode(seriesModel) {
  return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
} // See cases in `test/bar-start.html` and `#7412`, `#8747`.


function getValueAxisStart(baseAxis, valueAxis, stacked) {
  return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === 'log' ? 1 : 0));
}

exports.getLayoutOnAxis = getLayoutOnAxis;
exports.prepareLayoutBarSeries = prepareLayoutBarSeries;
exports.makeColumnLayout = makeColumnLayout;
exports.retrieveColumnLayout = retrieveColumnLayout;
exports.layout = layout;
exports.largeLayout = largeLayout;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var _symbol = __webpack_require__(99);

var createSymbol = _symbol.createSymbol;

var graphic = __webpack_require__(27);

var _number = __webpack_require__(37);

var parsePercent = _number.parsePercent;

var _labelHelper = __webpack_require__(414);

var getDefaultLabel = _labelHelper.getDefaultLabel;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @module echarts/chart/helper/Symbol
 */

/**
 * @constructor
 * @alias {module:echarts/chart/helper/Symbol}
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @extends {module:zrender/graphic/Group}
 */
function SymbolClz(data, idx, seriesScope) {
  graphic.Group.call(this);
  this.updateData(data, idx, seriesScope);
}

var symbolProto = SymbolClz.prototype;
/**
 * @public
 * @static
 * @param {module:echarts/data/List} data
 * @param {number} dataIndex
 * @return {Array.<number>} [width, height]
 */

var getSymbolSize = SymbolClz.getSymbolSize = function (data, idx) {
  var symbolSize = data.getItemVisual(idx, 'symbolSize');
  return symbolSize instanceof Array ? symbolSize.slice() : [+symbolSize, +symbolSize];
};

function getScale(symbolSize) {
  return [symbolSize[0] / 2, symbolSize[1] / 2];
}

function driftSymbol(dx, dy) {
  this.parent.drift(dx, dy);
}

symbolProto._createSymbol = function (symbolType, data, idx, symbolSize, keepAspect) {
  // Remove paths created before
  this.removeAll();
  var color = data.getItemVisual(idx, 'color'); // var symbolPath = createSymbol(
  //     symbolType, -0.5, -0.5, 1, 1, color
  // );
  // If width/height are set too small (e.g., set to 1) on ios10
  // and macOS Sierra, a circle stroke become a rect, no matter what
  // the scale is set. So we set width/height as 2. See #4150.

  var symbolPath = createSymbol(symbolType, -1, -1, 2, 2, color, keepAspect);
  symbolPath.attr({
    z2: 100,
    culling: true,
    scale: getScale(symbolSize)
  }); // Rewrite drift method

  symbolPath.drift = driftSymbol;
  this._symbolType = symbolType;
  this.add(symbolPath);
};
/**
 * Stop animation
 * @param {boolean} toLastFrame
 */


symbolProto.stopSymbolAnimation = function (toLastFrame) {
  this.childAt(0).stopAnimation(toLastFrame);
};
/**
 * FIXME:
 * Caution: This method breaks the encapsulation of this module,
 * but it indeed brings convenience. So do not use the method
 * unless you detailedly know all the implements of `Symbol`,
 * especially animation.
 *
 * Get symbol path element.
 */


symbolProto.getSymbolPath = function () {
  return this.childAt(0);
};
/**
 * Get scale(aka, current symbol size).
 * Including the change caused by animation
 */


symbolProto.getScale = function () {
  return this.childAt(0).scale;
};
/**
 * Highlight symbol
 */


symbolProto.highlight = function () {
  this.childAt(0).trigger('emphasis');
};
/**
 * Downplay symbol
 */


symbolProto.downplay = function () {
  this.childAt(0).trigger('normal');
};
/**
 * @param {number} zlevel
 * @param {number} z
 */


symbolProto.setZ = function (zlevel, z) {
  var symbolPath = this.childAt(0);
  symbolPath.zlevel = zlevel;
  symbolPath.z = z;
};

symbolProto.setDraggable = function (draggable) {
  var symbolPath = this.childAt(0);
  symbolPath.draggable = draggable;
  symbolPath.cursor = draggable ? 'move' : symbolPath.cursor;
};
/**
 * Update symbol properties
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @param {Object} [seriesScope]
 * @param {Object} [seriesScope.itemStyle]
 * @param {Object} [seriesScope.hoverItemStyle]
 * @param {Object} [seriesScope.symbolRotate]
 * @param {Object} [seriesScope.symbolOffset]
 * @param {module:echarts/model/Model} [seriesScope.labelModel]
 * @param {module:echarts/model/Model} [seriesScope.hoverLabelModel]
 * @param {boolean} [seriesScope.hoverAnimation]
 * @param {Object} [seriesScope.cursorStyle]
 * @param {module:echarts/model/Model} [seriesScope.itemModel]
 * @param {string} [seriesScope.symbolInnerColor]
 * @param {Object} [seriesScope.fadeIn=false]
 */


symbolProto.updateData = function (data, idx, seriesScope) {
  this.silent = false;
  var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
  var seriesModel = data.hostModel;
  var symbolSize = getSymbolSize(data, idx);
  var isInit = symbolType !== this._symbolType;

  if (isInit) {
    var keepAspect = data.getItemVisual(idx, 'symbolKeepAspect');

    this._createSymbol(symbolType, data, idx, symbolSize, keepAspect);
  } else {
    var symbolPath = this.childAt(0);
    symbolPath.silent = false;
    graphic.updateProps(symbolPath, {
      scale: getScale(symbolSize)
    }, seriesModel, idx);
  }

  this._updateCommon(data, idx, symbolSize, seriesScope);

  if (isInit) {
    var symbolPath = this.childAt(0);
    var fadeIn = seriesScope && seriesScope.fadeIn;
    var target = {
      scale: symbolPath.scale.slice()
    };
    fadeIn && (target.style = {
      opacity: symbolPath.style.opacity
    });
    symbolPath.scale = [0, 0];
    fadeIn && (symbolPath.style.opacity = 0);
    graphic.initProps(symbolPath, target, seriesModel, idx);
  }

  this._seriesModel = seriesModel;
}; // Update common properties


var normalStyleAccessPath = ['itemStyle'];
var emphasisStyleAccessPath = ['emphasis', 'itemStyle'];
var normalLabelAccessPath = ['label'];
var emphasisLabelAccessPath = ['emphasis', 'label'];
/**
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @param {Array.<number>} symbolSize
 * @param {Object} [seriesScope]
 */

symbolProto._updateCommon = function (data, idx, symbolSize, seriesScope) {
  var symbolPath = this.childAt(0);
  var seriesModel = data.hostModel;
  var color = data.getItemVisual(idx, 'color'); // Reset style

  if (symbolPath.type !== 'image') {
    symbolPath.useStyle({
      strokeNoScale: true
    });
  } else {
    symbolPath.setStyle({
      opacity: 1,
      shadowBlur: null,
      shadowOffsetX: null,
      shadowOffsetY: null,
      shadowColor: null
    });
  }

  var itemStyle = seriesScope && seriesScope.itemStyle;
  var hoverItemStyle = seriesScope && seriesScope.hoverItemStyle;
  var symbolOffset = seriesScope && seriesScope.symbolOffset;
  var labelModel = seriesScope && seriesScope.labelModel;
  var hoverLabelModel = seriesScope && seriesScope.hoverLabelModel;
  var hoverAnimation = seriesScope && seriesScope.hoverAnimation;
  var cursorStyle = seriesScope && seriesScope.cursorStyle;

  if (!seriesScope || data.hasItemOption) {
    var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx); // Color must be excluded.
    // Because symbol provide setColor individually to set fill and stroke

    itemStyle = itemModel.getModel(normalStyleAccessPath).getItemStyle(['color']);
    hoverItemStyle = itemModel.getModel(emphasisStyleAccessPath).getItemStyle();
    symbolOffset = itemModel.getShallow('symbolOffset');
    labelModel = itemModel.getModel(normalLabelAccessPath);
    hoverLabelModel = itemModel.getModel(emphasisLabelAccessPath);
    hoverAnimation = itemModel.getShallow('hoverAnimation');
    cursorStyle = itemModel.getShallow('cursor');
  } else {
    hoverItemStyle = zrUtil.extend({}, hoverItemStyle);
  }

  var elStyle = symbolPath.style;
  var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
  symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);

  if (symbolOffset) {
    symbolPath.attr('position', [parsePercent(symbolOffset[0], symbolSize[0]), parsePercent(symbolOffset[1], symbolSize[1])]);
  }

  cursorStyle && symbolPath.attr('cursor', cursorStyle); // PENDING setColor before setStyle!!!

  symbolPath.setColor(color, seriesScope && seriesScope.symbolInnerColor);
  symbolPath.setStyle(itemStyle);
  var opacity = data.getItemVisual(idx, 'opacity');

  if (opacity != null) {
    elStyle.opacity = opacity;
  }

  var liftZ = data.getItemVisual(idx, 'liftZ');
  var z2Origin = symbolPath.__z2Origin;

  if (liftZ != null) {
    if (z2Origin == null) {
      symbolPath.__z2Origin = symbolPath.z2;
      symbolPath.z2 += liftZ;
    }
  } else if (z2Origin != null) {
    symbolPath.z2 = z2Origin;
    symbolPath.__z2Origin = null;
  }

  var useNameLabel = seriesScope && seriesScope.useNameLabel;
  graphic.setLabelStyle(elStyle, hoverItemStyle, labelModel, hoverLabelModel, {
    labelFetcher: seriesModel,
    labelDataIndex: idx,
    defaultText: getLabelDefaultText,
    isRectText: true,
    autoColor: color
  }); // Do not execute util needed.

  function getLabelDefaultText(idx, opt) {
    return useNameLabel ? data.getName(idx) : getDefaultLabel(data, idx);
  }

  symbolPath.__symbolOriginalScale = getScale(symbolSize);
  symbolPath.hoverStyle = hoverItemStyle;
  symbolPath.highDownOnUpdate = hoverAnimation && seriesModel.isAnimationEnabled() ? highDownOnUpdate : null;
  graphic.setHoverStyle(symbolPath);
};

function highDownOnUpdate(fromState, toState) {
  // Do not support this hover animation util some scenario required.
  // Animation can only be supported in hover layer when using `el.incremetal`.
  if (this.incremental || this.useHoverLayer) {
    return;
  }

  if (toState === 'emphasis') {
    var scale = this.__symbolOriginalScale;
    var ratio = scale[1] / scale[0];
    var emphasisOpt = {
      scale: [Math.max(scale[0] * 1.1, scale[0] + 3), Math.max(scale[1] * 1.1, scale[1] + 3 * ratio)]
    }; // FIXME
    // modify it after support stop specified animation.
    // toState === fromState
    //     ? (this.stopAnimation(), this.attr(emphasisOpt))

    this.animateTo(emphasisOpt, 400, 'elasticOut');
  } else if (toState === 'normal') {
    this.animateTo({
      scale: this.__symbolOriginalScale
    }, 400, 'elasticOut');
  }
}
/**
 * @param {Function} cb
 * @param {Object} [opt]
 * @param {Object} [opt.keepLabel=true]
 */


symbolProto.fadeOut = function (cb, opt) {
  var symbolPath = this.childAt(0); // Avoid mistaken hover when fading out

  this.silent = symbolPath.silent = true; // Not show text when animating

  !(opt && opt.keepLabel) && (symbolPath.style.text = null);
  graphic.updateProps(symbolPath, {
    style: {
      opacity: 0
    },
    scale: [0, 0]
  }, this._seriesModel, this.dataIndex, cb);
};

zrUtil.inherits(SymbolClz, graphic.Group);
var _default = SymbolClz;
module.exports = _default;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var axisDefault = __webpack_require__(651);

var ComponentModel = __webpack_require__(73);

var _layout = __webpack_require__(53);

var getLayoutParams = _layout.getLayoutParams;
var mergeLayoutParam = _layout.mergeLayoutParam;

var OrdinalMeta = __webpack_require__(642);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// FIXME axisType is fixed ?
var AXIS_TYPES = ['value', 'category', 'time', 'log'];
/**
 * Generate sub axis model class
 * @param {string} axisName 'x' 'y' 'radius' 'angle' 'parallel'
 * @param {module:echarts/model/Component} BaseAxisModelClass
 * @param {Function} axisTypeDefaulter
 * @param {Object} [extraDefaultOption]
 */

function _default(axisName, BaseAxisModelClass, axisTypeDefaulter, extraDefaultOption) {
  zrUtil.each(AXIS_TYPES, function (axisType) {
    BaseAxisModelClass.extend({
      /**
       * @readOnly
       */
      type: axisName + 'Axis.' + axisType,
      mergeDefaultAndTheme: function (option, ecModel) {
        var layoutMode = this.layoutMode;
        var inputPositionParams = layoutMode ? getLayoutParams(option) : {};
        var themeModel = ecModel.getTheme();
        zrUtil.merge(option, themeModel.get(axisType + 'Axis'));
        zrUtil.merge(option, this.getDefaultOption());
        option.type = axisTypeDefaulter(axisName, option);

        if (layoutMode) {
          mergeLayoutParam(option, inputPositionParams, layoutMode);
        }
      },

      /**
       * @override
       */
      optionUpdated: function () {
        var thisOption = this.option;

        if (thisOption.type === 'category') {
          this.__ordinalMeta = OrdinalMeta.createByAxisModel(this);
        }
      },

      /**
       * Should not be called before all of 'getInitailData' finished.
       * Because categories are collected during initializing data.
       */
      getCategories: function (rawData) {
        var option = this.option; // FIXME
        // warning if called before all of 'getInitailData' finished.

        if (option.type === 'category') {
          if (rawData) {
            return option.data;
          }

          return this.__ordinalMeta.categories;
        }
      },
      getOrdinalMeta: function () {
        return this.__ordinalMeta;
      },
      defaultOption: zrUtil.mergeAll([{}, axisDefault[axisType + 'Axis'], extraDefaultOption], true)
    });
  });
  ComponentModel.registerSubTypeDefaulter(axisName + 'Axis', zrUtil.curry(axisTypeDefaulter, axisName));
}

module.exports = _default;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var Model = __webpack_require__(68);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var each = zrUtil.each;
var curry = zrUtil.curry; // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
// allAxesInfo should be updated when setOption performed.

function collect(ecModel, api) {
  var result = {
    /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */
    axesInfo: {},
    seriesInvolved: false,

    /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */
    coordSysAxesInfo: {},
    coordSysMap: {}
  };
  collectAxesInfo(result, ecModel, api); // Check seriesInvolved for performance, in case too many series in some chart.

  result.seriesInvolved && collectSeriesInfo(result, ecModel);
  return result;
}

function collectAxesInfo(result, ecModel, api) {
  var globalTooltipModel = ecModel.getComponent('tooltip');
  var globalAxisPointerModel = ecModel.getComponent('axisPointer'); // links can only be set on global.

  var linksOption = globalAxisPointerModel.get('link', true) || [];
  var linkGroups = []; // Collect axes info.

  each(api.getCoordinateSystems(), function (coordSys) {
    // Some coordinate system do not support axes, like geo.
    if (!coordSys.axisPointerEnabled) {
      return;
    }

    var coordSysKey = makeKey(coordSys.model);
    var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
    result.coordSysMap[coordSysKey] = coordSys; // Set tooltip (like 'cross') is a convienent way to show axisPointer
    // for user. So we enable seting tooltip on coordSys model.

    var coordSysModel = coordSys.model;
    var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
    each(coordSys.getAxes(), curry(saveTooltipAxisInfo, false, null)); // If axis tooltip used, choose tooltip axis for each coordSys.
    // Notice this case: coordSys is `grid` but not `cartesian2D` here.

    if (coordSys.getTooltipAxes && globalTooltipModel // If tooltip.showContent is set as false, tooltip will not
    // show but axisPointer will show as normal.
    && baseTooltipModel.get('show')) {
      // Compatible with previous logic. But series.tooltip.trigger: 'axis'
      // or series.data[n].tooltip.trigger: 'axis' are not support any more.
      var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
      var cross = baseTooltipModel.get('axisPointer.type') === 'cross';
      var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get('axisPointer.axis'));

      if (triggerAxis || cross) {
        each(tooltipAxes.baseAxes, curry(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
      }

      if (cross) {
        each(tooltipAxes.otherAxes, curry(saveTooltipAxisInfo, 'cross', false));
      }
    } // fromTooltip: true | false | 'cross'
    // triggerTooltip: true | false | null


    function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
      var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
      var axisPointerShow = axisPointerModel.get('show');

      if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !isHandleTrigger(axisPointerModel)) {
        return;
      }

      if (triggerTooltip == null) {
        triggerTooltip = axisPointerModel.get('triggerTooltip');
      }

      axisPointerModel = fromTooltip ? makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
      var snap = axisPointerModel.get('snap');
      var key = makeKey(axis.model);
      var involveSeries = triggerTooltip || snap || axis.type === 'category'; // If result.axesInfo[key] exist, override it (tooltip has higher priority).

      var axisInfo = result.axesInfo[key] = {
        key: key,
        axis: axis,
        coordSys: coordSys,
        axisPointerModel: axisPointerModel,
        triggerTooltip: triggerTooltip,
        involveSeries: involveSeries,
        snap: snap,
        useHandle: isHandleTrigger(axisPointerModel),
        seriesModels: []
      };
      axesInfoInCoordSys[key] = axisInfo;
      result.seriesInvolved |= involveSeries;
      var groupIndex = getLinkGroupIndex(linksOption, axis);

      if (groupIndex != null) {
        var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
          axesInfo: {}
        });
        linkGroup.axesInfo[key] = axisInfo;
        linkGroup.mapper = linksOption[groupIndex].mapper;
        axisInfo.linkGroup = linkGroup;
      }
    }
  });
}

function makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
  var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
  var volatileOption = {};
  each(['type', 'snap', 'lineStyle', 'shadowStyle', 'label', 'animation', 'animationDurationUpdate', 'animationEasingUpdate', 'z'], function (field) {
    volatileOption[field] = zrUtil.clone(tooltipAxisPointerModel.get(field));
  }); // category axis do not auto snap, otherwise some tick that do not
  // has value can not be hovered. value/time/log axis default snap if
  // triggered from tooltip and trigger tooltip.

  volatileOption.snap = axis.type !== 'category' && !!triggerTooltip; // Compatibel with previous behavior, tooltip axis do not show label by default.
  // Only these properties can be overrided from tooltip to axisPointer.

  if (tooltipAxisPointerModel.get('type') === 'cross') {
    volatileOption.type = 'line';
  }

  var labelOption = volatileOption.label || (volatileOption.label = {}); // Follow the convention, do not show label when triggered by tooltip by default.

  labelOption.show == null && (labelOption.show = false);

  if (fromTooltip === 'cross') {
    // When 'cross', both axes show labels.
    var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get('label.show');
    labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true; // If triggerTooltip, this is a base axis, which should better not use cross style
    // (cross style is dashed by default)

    if (!triggerTooltip) {
      var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
      crossStyle && zrUtil.defaults(labelOption, crossStyle.textStyle);
    }
  }

  return axis.model.getModel('axisPointer', new Model(volatileOption, globalAxisPointerModel, ecModel));
}

function collectSeriesInfo(result, ecModel) {
  // Prepare data for axis trigger
  ecModel.eachSeries(function (seriesModel) {
    // Notice this case: this coordSys is `cartesian2D` but not `grid`.
    var coordSys = seriesModel.coordinateSystem;
    var seriesTooltipTrigger = seriesModel.get('tooltip.trigger', true);
    var seriesTooltipShow = seriesModel.get('tooltip.show', true);

    if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get('axisPointer.show', true) === false) {
      return;
    }

    each(result.coordSysAxesInfo[makeKey(coordSys.model)], function (axisInfo) {
      var axis = axisInfo.axis;

      if (coordSys.getAxis(axis.dim) === axis) {
        axisInfo.seriesModels.push(seriesModel);
        axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
        axisInfo.seriesDataCount += seriesModel.getData().count();
      }
    });
  }, this);
}
/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */


function getLinkGroupIndex(linksOption, axis) {
  var axisModel = axis.model;
  var dim = axis.dim;

  for (var i = 0; i < linksOption.length; i++) {
    var linkOption = linksOption[i] || {};

    if (checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) {
      return i;
    }
  }
}

function checkPropInLink(linkPropValue, axisPropValue) {
  return linkPropValue === 'all' || zrUtil.isArray(linkPropValue) && zrUtil.indexOf(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
}

function fixValue(axisModel) {
  var axisInfo = getAxisInfo(axisModel);

  if (!axisInfo) {
    return;
  }

  var axisPointerModel = axisInfo.axisPointerModel;
  var scale = axisInfo.axis.scale;
  var option = axisPointerModel.option;
  var status = axisPointerModel.get('status');
  var value = axisPointerModel.get('value'); // Parse init value for category and time axis.

  if (value != null) {
    value = scale.parse(value);
  }

  var useHandle = isHandleTrigger(axisPointerModel); // If `handle` used, `axisPointer` will always be displayed, so value
  // and status should be initialized.

  if (status == null) {
    option.status = useHandle ? 'show' : 'hide';
  }

  var extent = scale.getExtent().slice();
  extent[0] > extent[1] && extent.reverse();

  if ( // Pick a value on axis when initializing.
  value == null // If both `handle` and `dataZoom` are used, value may be out of axis extent,
  // where we should re-pick a value to keep `handle` displaying normally.
  || value > extent[1]) {
    // Make handle displayed on the end of the axis when init, which looks better.
    value = extent[1];
  }

  if (value < extent[0]) {
    value = extent[0];
  }

  option.value = value;

  if (useHandle) {
    option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
  }
}

function getAxisInfo(axisModel) {
  var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
  return coordSysAxesInfo && coordSysAxesInfo.axesInfo[makeKey(axisModel)];
}

function getAxisPointerModel(axisModel) {
  var axisInfo = getAxisInfo(axisModel);
  return axisInfo && axisInfo.axisPointerModel;
}

function isHandleTrigger(axisPointerModel) {
  return !!axisPointerModel.get('handle.show');
}
/**
 * @param {module:echarts/model/Model} model
 * @return {string} unique key
 */


function makeKey(model) {
  return model.type + '||' + model.id;
}

exports.collect = collect;
exports.fixValue = fixValue;
exports.getAxisInfo = getAxisInfo;
exports.getAxisPointerModel = getAxisPointerModel;
exports.makeKey = makeKey;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(1);

var createHashMap = _util.createHashMap;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Pick color from palette for each data item.
// Applicable for charts that require applying color palette
// in data level (like pie, funnel, chord).
function _default(seriesType) {
  return {
    getTargetSeries: function (ecModel) {
      // Pie and funnel may use diferrent scope
      var paletteScope = {};
      var seiresModelMap = createHashMap();
      ecModel.eachSeriesByType(seriesType, function (seriesModel) {
        seriesModel.__paletteScope = paletteScope;
        seiresModelMap.set(seriesModel.uid, seriesModel);
      });
      return seiresModelMap;
    },
    reset: function (seriesModel, ecModel) {
      var dataAll = seriesModel.getRawData();
      var idxMap = {};
      var data = seriesModel.getData();
      data.each(function (idx) {
        var rawIdx = data.getRawIndex(idx);
        idxMap[rawIdx] = idx;
      });
      dataAll.each(function (rawIdx) {
        var filteredIdx = idxMap[rawIdx]; // If series.itemStyle.normal.color is a function. itemVisual may be encoded

        var singleDataColor = filteredIdx != null && data.getItemVisual(filteredIdx, 'color', true);
        var singleDataBorderColor = filteredIdx != null && data.getItemVisual(filteredIdx, 'borderColor', true);
        var itemModel;

        if (!singleDataColor || !singleDataBorderColor) {
          // FIXME Performance
          itemModel = dataAll.getItemModel(rawIdx);
        }

        if (!singleDataColor) {
          var color = itemModel.get('itemStyle.color') || seriesModel.getColorFromPalette(dataAll.getName(rawIdx) || rawIdx + '', seriesModel.__paletteScope, dataAll.count()); // Data is not filtered

          if (filteredIdx != null) {
            data.setItemVisual(filteredIdx, 'color', color);
          }
        }

        if (!singleDataBorderColor) {
          var borderColor = itemModel.get('itemStyle.borderColor'); // Data is not filtered

          if (filteredIdx != null) {
            data.setItemVisual(filteredIdx, 'borderColor', borderColor);
          }
        }
      });
    }
  };
}

module.exports = _default;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var _util = __webpack_require__(1);

var each = _util.each;
var createHashMap = _util.createHashMap;

var mapDataStorage = __webpack_require__(413);

var geoJSONLoader = __webpack_require__(1609);

var geoSVGLoader = __webpack_require__(1614);

var BoundingRect = __webpack_require__(57);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var loaders = {
  geoJSON: geoJSONLoader,
  svg: geoSVGLoader
};
var _default = {
  /**
   * @param {string} mapName
   * @param {Object} nameMap
   * @param {string} nameProperty
   * @return {Object} source {regions, regionsMap, nameCoordMap, boundingRect}
   */
  load: function (mapName, nameMap, nameProperty) {
    var regions = [];
    var regionsMap = createHashMap();
    var nameCoordMap = createHashMap();
    var boundingRect;
    var mapRecords = retrieveMap(mapName);
    each(mapRecords, function (record) {
      var singleSource = loaders[record.type].load(mapName, record, nameProperty);
      each(singleSource.regions, function (region) {
        var regionName = region.name; // Try use the alias in geoNameMap

        if (nameMap && nameMap.hasOwnProperty(regionName)) {
          region = region.cloneShallow(regionName = nameMap[regionName]);
        }

        regions.push(region);
        regionsMap.set(regionName, region);
        nameCoordMap.set(regionName, region.center);
      });
      var rect = singleSource.boundingRect;

      if (rect) {
        boundingRect ? boundingRect.union(rect) : boundingRect = rect.clone();
      }
    });
    return {
      regions: regions,
      regionsMap: regionsMap,
      nameCoordMap: nameCoordMap,
      // FIXME Always return new ?
      boundingRect: boundingRect || new BoundingRect(0, 0, 0, 0)
    };
  },

  /**
   * @param {string} mapName
   * @param {string} hostKey For cache.
   * @return {Array.<module:zrender/Element>} Roots.
   */
  makeGraphic: makeInvoker('makeGraphic'),

  /**
   * @param {string} mapName
   * @param {string} hostKey For cache.
   */
  removeGraphic: makeInvoker('removeGraphic')
};

function makeInvoker(methodName) {
  return function (mapName, hostKey) {
    var mapRecords = retrieveMap(mapName);
    var results = [];
    each(mapRecords, function (record) {
      var method = loaders[record.type][methodName];
      method && results.push(method(mapName, record, hostKey));
    });
    return results;
  };
}

function mapNotExistsError(mapName) {}

function retrieveMap(mapName) {
  var mapRecords = mapDataStorage.retrieveMap(mapName) || [];
  return mapRecords;
}

module.exports = _default;

/***/ }),
/* 306 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var IRRELEVANT_EXCLUDES = {
  'axisPointer': 1,
  'tooltip': 1,
  'brush': 1
};
/**
 * Avoid that: mouse click on a elements that is over geo or graph,
 * but roam is triggered.
 */

function onIrrelevantElement(e, api, targetCoordSysModel) {
  var model = api.getComponentByElement(e.topTarget); // If model is axisModel, it works only if it is injected with coordinateSystem.

  var coordSys = model && model.coordinateSystem;
  return model && model !== targetCoordSysModel && !IRRELEVANT_EXCLUDES[model.mainType] && coordSys && coordSys.model !== targetCoordSysModel;
}

exports.onIrrelevantElement = onIrrelevantElement;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var KEY_DELIMITER = '-->';
/**
 * params handler
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @returns {*}
 */

var getAutoCurvenessParams = function (seriesModel) {
  return seriesModel.get('autoCurveness') || null;
};
/**
 * Generate a list of edge curvatures, 20 is the default
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @param {number} appendLength
 * @return  20 => [0, -0.2, 0.2, -0.4, 0.4, -0.6, 0.6, -0.8, 0.8, -1, 1, -1.2, 1.2, -1.4, 1.4, -1.6, 1.6, -1.8, 1.8, -2]
 */


var createCurveness = function (seriesModel, appendLength) {
  var autoCurvenessParmas = getAutoCurvenessParams(seriesModel);
  var length = 20;
  var curvenessList = []; // handler the function set

  if (typeof autoCurvenessParmas === 'number') {
    length = autoCurvenessParmas;
  } else if (zrUtil.isArray(autoCurvenessParmas)) {
    seriesModel.__curvenessList = autoCurvenessParmas;
    return;
  } // append length


  if (appendLength > length) {
    length = appendLength;
  } // make sure the length is even


  var len = length % 2 ? length + 2 : length + 3;
  curvenessList = [];

  for (var i = 0; i < len; i++) {
    curvenessList.push((i % 2 ? i + 1 : i) / 10 * (i % 2 ? -1 : 1));
  }

  seriesModel.__curvenessList = curvenessList;
};
/**
 * Create different cache key data in the positive and negative directions, in order to set the curvature later
 * @param {number|string|module:echarts/data/Graph.Node} n1
 * @param {number|string|module:echarts/data/Graph.Node} n2
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @returns {string} key
 */


var getKeyOfEdges = function (n1, n2, seriesModel) {
  var source = [n1.id, n1.dataIndex].join('.');
  var target = [n2.id, n2.dataIndex].join('.');
  return [seriesModel.uid, source, target].join(KEY_DELIMITER);
};
/**
 * get opposite key
 * @param {string} key
 * @returns {string}
 */


var getOppositeKey = function (key) {
  var keys = key.split(KEY_DELIMITER);
  return [keys[0], keys[2], keys[1]].join(KEY_DELIMITER);
};
/**
 * get edgeMap with key
 * @param edge
 * @param {module:echarts/model/SeriesModel} seriesModel
 */


var getEdgeFromMap = function (edge, seriesModel) {
  var key = getKeyOfEdges(edge.node1, edge.node2, seriesModel);
  return seriesModel.__edgeMap[key];
};
/**
 * calculate all cases total length
 * @param edge
 * @param seriesModel
 * @returns {number}
 */


var getTotalLengthBetweenNodes = function (edge, seriesModel) {
  var len = getEdgeMapLengthWithKey(getKeyOfEdges(edge.node1, edge.node2, seriesModel), seriesModel);
  var lenV = getEdgeMapLengthWithKey(getKeyOfEdges(edge.node2, edge.node1, seriesModel), seriesModel);
  return len + lenV;
};
/**
 *
 * @param key
 */


var getEdgeMapLengthWithKey = function (key, seriesModel) {
  var edgeMap = seriesModel.__edgeMap;
  return edgeMap[key] ? edgeMap[key].length : 0;
};
/**
 * Count the number of edges between the same two points, used to obtain the curvature table and the parity of the edge
 * @see /graph/GraphSeries.js@getInitialData
 * @param {module:echarts/model/SeriesModel} seriesModel
 */


function initCurvenessList(seriesModel) {
  if (!getAutoCurvenessParams(seriesModel)) {
    return;
  }

  seriesModel.__curvenessList = [];
  seriesModel.__edgeMap = {}; // calc the array of curveness List

  createCurveness(seriesModel);
}
/**
 * set edgeMap with key
 * @param {number|string|module:echarts/data/Graph.Node} n1
 * @param {number|string|module:echarts/data/Graph.Node} n2
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @param {number} index
 */


function createEdgeMapForCurveness(n1, n2, seriesModel, index) {
  if (!getAutoCurvenessParams(seriesModel)) {
    return;
  }

  var key = getKeyOfEdges(n1, n2, seriesModel);
  var edgeMap = seriesModel.__edgeMap;
  var oppositeEdges = edgeMap[getOppositeKey(key)]; // set direction

  if (edgeMap[key] && !oppositeEdges) {
    edgeMap[key].isForward = true;
  } else if (oppositeEdges && edgeMap[key]) {
    oppositeEdges.isForward = true;
    edgeMap[key].isForward = false;
  }

  edgeMap[key] = edgeMap[key] || [];
  edgeMap[key].push(index);
}
/**
 * get curvature for edge
 * @param edge
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @param index
 */


function getCurvenessForEdge(edge, seriesModel, index, needReverse) {
  var autoCurvenessParams = getAutoCurvenessParams(seriesModel);
  var isArrayParam = zrUtil.isArray(autoCurvenessParams);

  if (!autoCurvenessParams) {
    return null;
  }

  var edgeArray = getEdgeFromMap(edge, seriesModel);

  if (!edgeArray) {
    return null;
  }

  var edgeIndex = -1;

  for (var i = 0; i < edgeArray.length; i++) {
    if (edgeArray[i] === index) {
      edgeIndex = i;
      break;
    }
  } // if totalLen is Longer createCurveness


  var totalLen = getTotalLengthBetweenNodes(edge, seriesModel);
  createCurveness(seriesModel, totalLen);
  edge.lineStyle = edge.lineStyle || {}; // if is opposite edge, must set curvenss to opposite number

  var curKey = getKeyOfEdges(edge.node1, edge.node2, seriesModel);
  var curvenessList = seriesModel.__curvenessList; // if pass array no need parity

  var parityCorrection = isArrayParam ? 0 : totalLen % 2 ? 0 : 1;

  if (!edgeArray.isForward) {
    // the opposite edge show outside
    var oppositeKey = getOppositeKey(curKey);
    var len = getEdgeMapLengthWithKey(oppositeKey, seriesModel);
    var resValue = curvenessList[edgeIndex + len + parityCorrection]; // isNeedReverse, simple, force type need reverse the curveness in the junction of the forword and the opposite

    if (needReverse) {
      // set as array may make the parity handle with the len of opposite
      if (isArrayParam) {
        if (autoCurvenessParams && autoCurvenessParams[0] === 0) {
          return (len + parityCorrection) % 2 ? resValue : -resValue;
        } else {
          return ((len % 2 ? 0 : 1) + parityCorrection) % 2 ? resValue : -resValue;
        }
      } else {
        return (len + parityCorrection) % 2 ? resValue : -resValue;
      }
    } else {
      return curvenessList[edgeIndex + len + parityCorrection];
    }
  } else {
    return curvenessList[parityCorrection + edgeIndex];
  }
}

exports.initCurvenessList = initCurvenessList;
exports.createEdgeMapForCurveness = createEdgeMapForCurveness;
exports.getCurvenessForEdge = getCurvenessForEdge;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var graphic = __webpack_require__(27);

var textContain = __webpack_require__(93);

var formatUtil = __webpack_require__(54);

var matrix = __webpack_require__(82);

var axisHelper = __webpack_require__(109);

var AxisBuilder = __webpack_require__(151);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @param {module:echarts/model/Model} axisPointerModel
 */
function buildElStyle(axisPointerModel) {
  var axisPointerType = axisPointerModel.get('type');
  var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
  var style;

  if (axisPointerType === 'line') {
    style = styleModel.getLineStyle();
    style.fill = null;
  } else if (axisPointerType === 'shadow') {
    style = styleModel.getAreaStyle();
    style.stroke = null;
  }

  return style;
}
/**
 * @param {Function} labelPos {align, verticalAlign, position}
 */


function buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos) {
  var value = axisPointerModel.get('value');
  var text = getValueLabel(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
    precision: axisPointerModel.get('label.precision'),
    formatter: axisPointerModel.get('label.formatter')
  });
  var labelModel = axisPointerModel.getModel('label');
  var paddings = formatUtil.normalizeCssArray(labelModel.get('padding') || 0);
  var font = labelModel.getFont();
  var textRect = textContain.getBoundingRect(text, font);
  var position = labelPos.position;
  var width = textRect.width + paddings[1] + paddings[3];
  var height = textRect.height + paddings[0] + paddings[2]; // Adjust by align.

  var align = labelPos.align;
  align === 'right' && (position[0] -= width);
  align === 'center' && (position[0] -= width / 2);
  var verticalAlign = labelPos.verticalAlign;
  verticalAlign === 'bottom' && (position[1] -= height);
  verticalAlign === 'middle' && (position[1] -= height / 2); // Not overflow ec container

  confineInContainer(position, width, height, api);
  var bgColor = labelModel.get('backgroundColor');

  if (!bgColor || bgColor === 'auto') {
    bgColor = axisModel.get('axisLine.lineStyle.color');
  }

  elOption.label = {
    shape: {
      x: 0,
      y: 0,
      width: width,
      height: height,
      r: labelModel.get('borderRadius')
    },
    position: position.slice(),
    // TODO: rich
    style: {
      text: text,
      textFont: font,
      textFill: labelModel.getTextColor(),
      textPosition: 'inside',
      textPadding: paddings,
      fill: bgColor,
      stroke: labelModel.get('borderColor') || 'transparent',
      lineWidth: labelModel.get('borderWidth') || 0,
      shadowBlur: labelModel.get('shadowBlur'),
      shadowColor: labelModel.get('shadowColor'),
      shadowOffsetX: labelModel.get('shadowOffsetX'),
      shadowOffsetY: labelModel.get('shadowOffsetY')
    },
    // Lable should be over axisPointer.
    z2: 10
  };
} // Do not overflow ec container


function confineInContainer(position, width, height, api) {
  var viewWidth = api.getWidth();
  var viewHeight = api.getHeight();
  position[0] = Math.min(position[0] + width, viewWidth) - width;
  position[1] = Math.min(position[1] + height, viewHeight) - height;
  position[0] = Math.max(position[0], 0);
  position[1] = Math.max(position[1], 0);
}
/**
 * @param {number} value
 * @param {module:echarts/coord/Axis} axis
 * @param {module:echarts/model/Global} ecModel
 * @param {Object} opt
 * @param {Array.<Object>} seriesDataIndices
 * @param {number|string} opt.precision 'auto' or a number
 * @param {string|Function} opt.formatter label formatter
 */


function getValueLabel(value, axis, ecModel, seriesDataIndices, opt) {
  value = axis.scale.parse(value);
  var text = axis.scale.getLabel( // If `precision` is set, width can be fixed (like '12.00500'), which
  // helps to debounce when when moving label.
  value, {
    precision: opt.precision
  });
  var formatter = opt.formatter;

  if (formatter) {
    var params = {
      value: axisHelper.getAxisRawValue(axis, value),
      axisDimension: axis.dim,
      axisIndex: axis.index,
      seriesData: []
    };
    zrUtil.each(seriesDataIndices, function (idxItem) {
      var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
      var dataIndex = idxItem.dataIndexInside;
      var dataParams = series && series.getDataParams(dataIndex);
      dataParams && params.seriesData.push(dataParams);
    });

    if (zrUtil.isString(formatter)) {
      text = formatter.replace('{value}', text);
    } else if (zrUtil.isFunction(formatter)) {
      text = formatter(params);
    }
  }

  return text;
}
/**
 * @param {module:echarts/coord/Axis} axis
 * @param {number} value
 * @param {Object} layoutInfo {
 *  rotation, position, labelOffset, labelDirection, labelMargin
 * }
 */


function getTransformedPosition(axis, value, layoutInfo) {
  var transform = matrix.create();
  matrix.rotate(transform, transform, layoutInfo.rotation);
  matrix.translate(transform, transform, layoutInfo.position);
  return graphic.applyTransform([axis.dataToCoord(value), (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)], transform);
}

function buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
  var textLayout = AxisBuilder.innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
  layoutInfo.labelMargin = axisPointerModel.get('label.margin');
  buildLabelElOption(elOption, axisModel, axisPointerModel, api, {
    position: getTransformedPosition(axisModel.axis, value, layoutInfo),
    align: textLayout.textAlign,
    verticalAlign: textLayout.textVerticalAlign
  });
}
/**
 * @param {Array.<number>} p1
 * @param {Array.<number>} p2
 * @param {number} [xDimIndex=0] or 1
 */


function makeLineShape(p1, p2, xDimIndex) {
  xDimIndex = xDimIndex || 0;
  return {
    x1: p1[xDimIndex],
    y1: p1[1 - xDimIndex],
    x2: p2[xDimIndex],
    y2: p2[1 - xDimIndex]
  };
}
/**
 * @param {Array.<number>} xy
 * @param {Array.<number>} wh
 * @param {number} [xDimIndex=0] or 1
 */


function makeRectShape(xy, wh, xDimIndex) {
  xDimIndex = xDimIndex || 0;
  return {
    x: xy[xDimIndex],
    y: xy[1 - xDimIndex],
    width: wh[xDimIndex],
    height: wh[1 - xDimIndex]
  };
}

function makeSectorShape(cx, cy, r0, r, startAngle, endAngle) {
  return {
    cx: cx,
    cy: cy,
    r0: r0,
    r: r,
    startAngle: startAngle,
    endAngle: endAngle,
    clockwise: true
  };
}

exports.buildElStyle = buildElStyle;
exports.buildLabelElOption = buildLabelElOption;
exports.getValueLabel = getValueLabel;
exports.getTransformedPosition = getTransformedPosition;
exports.buildCartesianSingleLabelElOption = buildCartesianSingleLabelElOption;
exports.makeLineShape = makeLineShape;
exports.makeRectShape = makeRectShape;
exports.makeSectorShape = makeSectorShape;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var VisualMapping = __webpack_require__(181);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @file Visual solution, for consistent option specification.
 */
var each = zrUtil.each;

function hasKeys(obj) {
  if (obj) {
    for (var name in obj) {
      if (obj.hasOwnProperty(name)) {
        return true;
      }
    }
  }
}
/**
 * @param {Object} option
 * @param {Array.<string>} stateList
 * @param {Function} [supplementVisualOption]
 * @return {Object} visualMappings <state, <visualType, module:echarts/visual/VisualMapping>>
 */


function createVisualMappings(option, stateList, supplementVisualOption) {
  var visualMappings = {};
  each(stateList, function (state) {
    var mappings = visualMappings[state] = createMappings();
    each(option[state], function (visualData, visualType) {
      if (!VisualMapping.isValidType(visualType)) {
        return;
      }

      var mappingOption = {
        type: visualType,
        visual: visualData
      };
      supplementVisualOption && supplementVisualOption(mappingOption, state);
      mappings[visualType] = new VisualMapping(mappingOption); // Prepare a alpha for opacity, for some case that opacity
      // is not supported, such as rendering using gradient color.

      if (visualType === 'opacity') {
        mappingOption = zrUtil.clone(mappingOption);
        mappingOption.type = 'colorAlpha';
        mappings.__hidden.__alphaForOpacity = new VisualMapping(mappingOption);
      }
    });
  });
  return visualMappings;

  function createMappings() {
    var Creater = function () {}; // Make sure hidden fields will not be visited by
    // object iteration (with hasOwnProperty checking).


    Creater.prototype.__hidden = Creater.prototype;
    var obj = new Creater();
    return obj;
  }
}
/**
 * @param {Object} thisOption
 * @param {Object} newOption
 * @param {Array.<string>} keys
 */


function replaceVisualOption(thisOption, newOption, keys) {
  // Visual attributes merge is not supported, otherwise it
  // brings overcomplicated merge logic. See #2853. So if
  // newOption has anyone of these keys, all of these keys
  // will be reset. Otherwise, all keys remain.
  var has;
  zrUtil.each(keys, function (key) {
    if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
      has = true;
    }
  });
  has && zrUtil.each(keys, function (key) {
    if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
      thisOption[key] = zrUtil.clone(newOption[key]);
    } else {
      delete thisOption[key];
    }
  });
}
/**
 * @param {Array.<string>} stateList
 * @param {Object} visualMappings <state, Object.<visualType, module:echarts/visual/VisualMapping>>
 * @param {module:echarts/data/List} list
 * @param {Function} getValueState param: valueOrIndex, return: state.
 * @param {object} [scope] Scope for getValueState
 * @param {string} [dimension] Concrete dimension, if used.
 */
// ???! handle brush?


function applyVisual(stateList, visualMappings, data, getValueState, scope, dimension) {
  var visualTypesMap = {};
  zrUtil.each(stateList, function (state) {
    var visualTypes = VisualMapping.prepareVisualTypes(visualMappings[state]);
    visualTypesMap[state] = visualTypes;
  });
  var dataIndex;

  function getVisual(key) {
    return data.getItemVisual(dataIndex, key);
  }

  function setVisual(key, value) {
    data.setItemVisual(dataIndex, key, value);
  }

  if (dimension == null) {
    data.each(eachItem);
  } else {
    data.each([dimension], eachItem);
  }

  function eachItem(valueOrIndex, index) {
    dataIndex = dimension == null ? valueOrIndex : index;
    var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance

    if (rawDataItem && rawDataItem.visualMap === false) {
      return;
    }

    var valueState = getValueState.call(scope, valueOrIndex);
    var mappings = visualMappings[valueState];
    var visualTypes = visualTypesMap[valueState];

    for (var i = 0, len = visualTypes.length; i < len; i++) {
      var type = visualTypes[i];
      mappings[type] && mappings[type].applyVisual(valueOrIndex, getVisual, setVisual);
    }
  }
}
/**
 * @param {module:echarts/data/List} data
 * @param {Array.<string>} stateList
 * @param {Object} visualMappings <state, Object.<visualType, module:echarts/visual/VisualMapping>>
 * @param {Function} getValueState param: valueOrIndex, return: state.
 * @param {number} [dim] dimension or dimension index.
 */


function incrementalApplyVisual(stateList, visualMappings, getValueState, dim) {
  var visualTypesMap = {};
  zrUtil.each(stateList, function (state) {
    var visualTypes = VisualMapping.prepareVisualTypes(visualMappings[state]);
    visualTypesMap[state] = visualTypes;
  });

  function progress(params, data) {
    if (dim != null) {
      dim = data.getDimension(dim);
    }

    function getVisual(key) {
      return data.getItemVisual(dataIndex, key);
    }

    function setVisual(key, value) {
      data.setItemVisual(dataIndex, key, value);
    }

    var dataIndex;

    while ((dataIndex = params.next()) != null) {
      var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance

      if (rawDataItem && rawDataItem.visualMap === false) {
        continue;
      }

      var value = dim != null ? data.get(dim, dataIndex, true) : dataIndex;
      var valueState = getValueState(value);
      var mappings = visualMappings[valueState];
      var visualTypes = visualTypesMap[valueState];

      for (var i = 0, len = visualTypes.length; i < len; i++) {
        var type = visualTypes[i];
        mappings[type] && mappings[type].applyVisual(value, getVisual, setVisual);
      }
    }
  }

  return {
    progress: progress
  };
}

exports.createVisualMappings = createVisualMappings;
exports.replaceVisualOption = replaceVisualOption;
exports.applyVisual = applyVisual;
exports.incrementalApplyVisual = incrementalApplyVisual;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data2_4=exports.data2_4=[{name:'',name_code:"",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'',name_code:"",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'',name_code:"",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'',name_code:"",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'',name_code:"",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'Sub-Total 小计',name_code:"Sub_Total",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"}];// 22222222222222222
// 3333333333333333333333
var data4_3_6=exports.data4_3_6=[{name:'Top 20 OTA/TPI 第三方网络产量排名前二十位',name_code:"Top_20_OTA_TPI",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'Top 40 Corporate Volume协议公司产量排名前四十位',name_code:"Top_40_Corporate_Volume",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'Top 20 Government 政府单位产量排名前二十位',name_code:"Top_20_Government",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'Top 20 MICE Account 会展公司产量排名前二十位',name_code:"Top_20_MICE_Account",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'Top 20 Wholesaler Agent旅行社产量排名前二十位',name_code:"Top_20_Wholesaler_Agent",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'Top Account Total 关键客户合计',name_code:"Top_Account_Total",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'Hotel Rooms Revenue Total 酒店客房收入总计',name_code:"Hotel_Rooms_Revenue_Total",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'Top Account Contribution % 关键客户贡献率百分比',name_code:"Top_Account_Contribution",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"}];

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data3_2_1=exports.data3_2_1=[{name:'Coffee Shop',name_code:'Coffee Shop',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'Chinese Restaurant',name_code:'Chinese Restaurant',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'Banquet',name_code:'Banquet',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'Special Restaurant',name_code:'Special Restaurant',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'Lobby Bar',name_code:'Lobby Bar',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'Room Service',name_code:'Room Service',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'seasonal food',name_code:'',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'',name_code:'',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'',name_code:'',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'',name_code:'',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'',name_code:'',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'',name_code:'',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'',name_code:'',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'Total - Outlets 餐厅合计',name_code:'Total_Outlets',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'Meeting Room Rental 会议场地设施收入',name_code:'Meeting_Room_Rental',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'Service Charge/Others 服务费及其他收入',name_code:'Service_Charge/Others',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'Total 合计',name_code:'Total',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'}];

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.dataSeasonal=exports.intervalData=exports.dataDefaultYear=exports.dataDefault=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _data=__webpack_require__(247);var dataDefault=exports.dataDefault=[{name:"Rooms Revenue % 客房收入占比",interval:0,area:0,hotel:0,sort:0},{name:"F&B Revenue % 餐饮收入占比",interval:0,area:0,hotel:0,sort:1},{name:"Other Revenue % 其他部门收入占比",interval:0,area:0,hotel:0,sort:2},{name:"Rooms Dept Profit % 客房部门利润率",interval:0,area:0,hotel:0,sort:3},{name:"F&B Dept Profit % 餐饮部门利润率",interval:0,area:0,hotel:0,sort:4},{name:"F&B Cost % 餐饮成本率",interval:0,area:0,hotel:0,sort:5},{name:"Coffee Shop Revenue % 咖啡厅收入占比",interval:0,area:0,hotel:0,sort:6},{name:"Coffee Shop Cost % 咖啡厅成本率",interval:0,area:0,hotel:0,sort:7},{name:"Chinese Restaurant Revenue % 中餐厅收入占比",interval:0,area:0,hotel:0,sort:8},{name:"Chinese Restaurant Cost % 中餐厅成本率",interval:0,area:0,hotel:0,sort:9},{name:"Banquet Revenue % 宴会收入占比",interval:0,area:0,hotel:0,sort:10},{name:"Banquet Cost % 宴会成本率",interval:0,area:0,hotel:0,sort:11},{name:"Labor Cost % 人力成本率",interval:0,area:0,hotel:0,sort:12},{name:"Utility Cost % 能源成本率",interval:0,area:0,hotel:0,sort:13},{name:"Other Expense and Cost % 其他费用及成本率",interval:0,area:0,hotel:0,sort:14},{name:"Top 15 Vs. Total Purchase 前15位采购占总额比率",interval:0,area:0,hotel:0,sort:15}];var dataDefaultYear=exports.dataDefaultYear=[{name:"Rooms Revenue % 客房收入占比",industry:0.539,area:0,interval:0,hotel:0,sort:0},{name:"F&B Revenue % 餐饮收入占比",industry:0.416,area:0,interval:0,hotel:0,sort:1},{name:"Other Revenue % 其他部门收入占比",industry:0.053,area:0,interval:0,hotel:0,sort:2},{name:"Rooms Dept Profit % 客房部门利润率",industry:0.729,area:0,interval:0,hotel:0,sort:3},{name:"F&B Dept Profit % 餐饮部门利润率",industry:0.273,area:0,interval:0,hotel:0,sort:4},{name:"F&B Cost % 餐饮成本率",industry:0.384,area:0,interval:0,hotel:0,sort:5},{name:"Labor Cost % 人力成本率",industry:0.352,area:0,interval:0,hotel:0,sort:6},{name:"Utility Cost % 能源成本率",industry:0.07,area:0,interval:0,hotel:0,sort:7},{name:"Other Expense and Cost % 其他费用及成本率",industry:0.113,area:0,interval:0,hotel:0,sort:8},{name:"Top 15 Vs. Total Purchase 前15位采购占总额比率",industry:0,area:0,interval:0,hotel:0,sort:9}];var intervalData=exports.intervalData=_extends({},_data.incomeRange);var dataSeasonal=exports.dataSeasonal=[{name:"Coffee Shop Revenue % 咖啡厅收入占比",interval:0,area:0,hotel:0,sort:0},{name:"Coffee Shop Cost % 咖啡厅成本率",interval:0,area:0,hotel:0,sort:1},{name:"Chinese Restaurant Revenue % 中餐厅收入占比",interval:0,area:0,hotel:0,sort:2},{name:"Chinese Restaurant Cost % 中餐厅成本率",interval:0,area:0,hotel:0,sort:3},{name:"Banquet Revenue % 宴会收入占比",interval:0,area:0,hotel:0,sort:4},{name:"Banquet Cost % 宴会成本率",interval:0,area:0,hotel:0,sort:5}];

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var dataDefault=exports.dataDefault=[{name:"Efficiency Per Total Room Area SQM 客房可售总面积坪效",interval:0,area:0,hotel:0,sort:0},{name:"Total Conference Space SQM 会议室可售总面积坪效",interval:0,area:0,hotel:0,sort:1},{name:"Efficiency Per Seat No. of Total Restaurant 餐厅总餐位数坪效",interval:0,area:0,hotel:0,sort:2},{name:"Efficiency Per Total Restaurant Space SQM 餐厅总面积坪效",interval:0,area:0,hotel:0,sort:3},{name:"Efficiency Per Seat No. of All Day Dinning 全日餐厅位数坪效",interval:0,area:0,hotel:0,sort:4},{name:"Efficiency Per All Day Dinning Space SQM 全日餐厅面积坪效",interval:0,area:0,hotel:0,sort:5},{name:"Efficiency Per Seat No. of Chinese Restaurant 中餐大厅位数坪效",interval:0,area:0,hotel:0,sort:6},{name:"Efficiency Per Chinese Restaurant Space SQM 中餐厅面积坪效",interval:0,area:0,hotel:0,sort:7},{name:"Efficiency Per Seat No. of Lounge/Bar 大堂吧/酒吧餐位数坪效",interval:0,area:0,hotel:0,sort:8},{name:"Efficiency Per Lounge/Bar Space SQM 大堂吧面积坪效",interval:0,area:0,hotel:0,sort:9},{name:"Efficiency Per Seat No. of Special Restaurant 特色餐厅餐位数坪效",interval:0,area:0,hotel:0,sort:10},{name:"Efficiency Per Spacial Restaurant Space SQM 特色餐厅面积坪效",interval:0,area:0,hotel:0,sort:11},{name:"Efficiency Per Seat No. of Other Outlets 其他餐厅餐位数坪效",interval:0,area:0,hotel:0,sort:12},{name:"Efficiency Per Other Outlets Space SQM 其他餐厅面积坪效",interval:0,area:0,hotel:0,sort:13}];var intervalData=exports.intervalData={1:"一亿以上",2:"8000万-1亿",3:"6500万-8000万",4:"5500万-6500万",5:"4500万-5500万",6:"3500万-4500万",7:"2500万-3500万",8:"1000万-2500万",9:"小于1000万"};

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(924);

__webpack_require__(100);

/***/ }),
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(757);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(186);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 318 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 319 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 320 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(322)('keys');
var uid = __webpack_require__(256);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(88);
var global = __webpack_require__(141);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(255) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 323 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 324 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(765);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(775);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(185);
var dPs = __webpack_require__(769);
var enumBugKeys = __webpack_require__(323);
var IE_PROTO = __webpack_require__(321)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(450)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(770).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(142).f;
var has = __webpack_require__(154);
var TAG = __webpack_require__(114)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(114);


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(141);
var core = __webpack_require__(88);
var LIBRARY = __webpack_require__(255);
var wksExt = __webpack_require__(328);
var defineProperty = __webpack_require__(142).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(257);
var createDesc = __webpack_require__(216);
var toIObject = __webpack_require__(155);
var toPrimitive = __webpack_require__(317);
var has = __webpack_require__(154);
var IE8_DOM_DEFINE = __webpack_require__(449);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(143) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _en_US = _interopRequireDefault(__webpack_require__(462));

var _en_US2 = _interopRequireDefault(__webpack_require__(332));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// Merge into a locale object
var locale = {
  lang: _extends({
    placeholder: 'Select date',
    rangePlaceholder: ['Start date', 'End date']
  }, _en_US["default"]),
  timePickerLocale: _extends({}, _en_US2["default"])
}; // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

var _default = locale;
exports["default"] = _default;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var locale = {
  placeholder: 'Select time'
};
var _default = locale;
exports["default"] = _default;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeConfirmLocale = changeConfirmLocale;
exports.getConfirmLocale = getConfirmLocale;

var _default = _interopRequireDefault(__webpack_require__(219));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var runtimeLocale = _extends({}, _default["default"].Modal);

function changeConfirmLocale(newLocale) {
  if (newLocale) {
    runtimeLocale = _extends(_extends({}, runtimeLocale), newLocale);
  } else {
    runtimeLocale = _extends({}, _default["default"].Modal);
  }
}

function getConfirmLocale() {
  return runtimeLocale;
}

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactDom = __webpack_require__(46);

var _Event = _interopRequireDefault(__webpack_require__(808));

var _raf = _interopRequireDefault(__webpack_require__(335));

var _configProvider = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var styleForPesudo; // Where el is the DOM element you'd like to test for visibility

function isHidden(element) {
  if (false) {
    return false;
  }

  return !element || element.offsetParent === null;
}

function isNotGrey(color) {
  // eslint-disable-next-line no-useless-escape
  var match = (color || '').match(/rgba?\((\d*), (\d*), (\d*)(, [\.\d]*)?\)/);

  if (match && match[1] && match[2] && match[3]) {
    return !(match[1] === match[2] && match[2] === match[3]);
  }

  return true;
}

var Wave = /*#__PURE__*/function (_React$Component) {
  _inherits(Wave, _React$Component);

  var _super = _createSuper(Wave);

  function Wave() {
    var _this;

    _classCallCheck(this, Wave);

    _this = _super.apply(this, arguments);
    _this.animationStart = false;
    _this.destroy = false;

    _this.onClick = function (node, waveColor) {
      if (!node || isHidden(node) || node.className.indexOf('-leave') >= 0) {
        return;
      }

      var insertExtraNode = _this.props.insertExtraNode;
      _this.extraNode = document.createElement('div');

      var _assertThisInitialize = _assertThisInitialized(_this),
          extraNode = _assertThisInitialize.extraNode;

      extraNode.className = 'ant-click-animating-node';

      var attributeName = _this.getAttributeName();

      node.setAttribute(attributeName, 'true'); // Not white or transparnt or grey

      styleForPesudo = styleForPesudo || document.createElement('style');

      if (waveColor && waveColor !== '#ffffff' && waveColor !== 'rgb(255, 255, 255)' && isNotGrey(waveColor) && !/rgba\(\d*, \d*, \d*, 0\)/.test(waveColor) && // any transparent rgba color
      waveColor !== 'transparent') {
        // Add nonce if CSP exist
        if (_this.csp && _this.csp.nonce) {
          styleForPesudo.nonce = _this.csp.nonce;
        }

        extraNode.style.borderColor = waveColor;
        styleForPesudo.innerHTML = "\n      [ant-click-animating-without-extra-node='true']::after, .ant-click-animating-node {\n        --antd-wave-shadow-color: ".concat(waveColor, ";\n      }");

        if (!document.body.contains(styleForPesudo)) {
          document.body.appendChild(styleForPesudo);
        }
      }

      if (insertExtraNode) {
        node.appendChild(extraNode);
      }

      _Event["default"].addStartEventListener(node, _this.onTransitionStart);

      _Event["default"].addEndEventListener(node, _this.onTransitionEnd);
    };

    _this.onTransitionStart = function (e) {
      if (_this.destroy) return;
      var node = (0, _reactDom.findDOMNode)(_assertThisInitialized(_this));

      if (!e || e.target !== node) {
        return;
      }

      if (!_this.animationStart) {
        _this.resetEffect(node);
      }
    };

    _this.onTransitionEnd = function (e) {
      if (!e || e.animationName !== 'fadeEffect') {
        return;
      }

      _this.resetEffect(e.target);
    };

    _this.bindAnimationEvent = function (node) {
      if (!node || !node.getAttribute || node.getAttribute('disabled') || node.className.indexOf('disabled') >= 0) {
        return;
      }

      var onClick = function onClick(e) {
        // Fix radio button click twice
        if (e.target.tagName === 'INPUT' || isHidden(e.target)) {
          return;
        }

        _this.resetEffect(node); // Get wave color from target


        var waveColor = getComputedStyle(node).getPropertyValue('border-top-color') || // Firefox Compatible
        getComputedStyle(node).getPropertyValue('border-color') || getComputedStyle(node).getPropertyValue('background-color');
        _this.clickWaveTimeoutId = window.setTimeout(function () {
          return _this.onClick(node, waveColor);
        }, 0);

        _raf["default"].cancel(_this.animationStartId);

        _this.animationStart = true; // Render to trigger transition event cost 3 frames. Let's delay 10 frames to reset this.

        _this.animationStartId = (0, _raf["default"])(function () {
          _this.animationStart = false;
        }, 10);
      };

      node.addEventListener('click', onClick, true);
      return {
        cancel: function cancel() {
          node.removeEventListener('click', onClick, true);
        }
      };
    };

    _this.renderWave = function (_ref) {
      var csp = _ref.csp;
      var children = _this.props.children;
      _this.csp = csp;
      return children;
    };

    return _this;
  }

  _createClass(Wave, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var node = (0, _reactDom.findDOMNode)(this);

      if (!node || node.nodeType !== 1) {
        return;
      }

      this.instance = this.bindAnimationEvent(node);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.instance) {
        this.instance.cancel();
      }

      if (this.clickWaveTimeoutId) {
        clearTimeout(this.clickWaveTimeoutId);
      }

      this.destroy = true;
    }
  }, {
    key: "getAttributeName",
    value: function getAttributeName() {
      var insertExtraNode = this.props.insertExtraNode;
      return insertExtraNode ? 'ant-click-animating' : 'ant-click-animating-without-extra-node';
    }
  }, {
    key: "resetEffect",
    value: function resetEffect(node) {
      if (!node || node === this.extraNode || !(node instanceof Element)) {
        return;
      }

      var insertExtraNode = this.props.insertExtraNode;
      var attributeName = this.getAttributeName();
      node.setAttribute(attributeName, 'false'); // edge has bug on `removeAttribute` #14466

      if (styleForPesudo) {
        styleForPesudo.innerHTML = '';
      }

      if (insertExtraNode && this.extraNode && node.contains(this.extraNode)) {
        node.removeChild(this.extraNode);
      }

      _Event["default"].removeStartEventListener(node, this.onTransitionStart);

      _Event["default"].removeEndEventListener(node, this.onTransitionEnd);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderWave);
    }
  }]);

  return Wave;
}(React.Component);

exports["default"] = Wave;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = wrapperRaf;

var _raf = _interopRequireDefault(__webpack_require__(463));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var id = 0;
var ids = {}; // Support call raf with delay specified frame

function wrapperRaf(callback) {
  var delayFrames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var myId = id++;
  var restFrames = delayFrames;

  function internalCallback() {
    restFrames -= 1;

    if (restFrames <= 0) {
      callback();
      delete ids[myId];
    } else {
      ids[myId] = (0, _raf["default"])(internalCallback);
    }
  }

  ids[myId] = (0, _raf["default"])(internalCallback);
  return myId;
}

wrapperRaf.cancel = function cancel(pid) {
  if (pid === undefined) return;

  _raf["default"].cancel(ids[pid]);

  delete ids[pid];
};

wrapperRaf.ids = ids; // export this for test usage

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(258)))

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(465);
} catch (err) {
  var index = __webpack_require__(465);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;

  while (node) {
    if (node === root) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(340);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toArray;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactIs = __webpack_require__(480);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toArray(children) {
  var ret = [];

  _react.default.Children.forEach(children, function (child) {
    if (child === undefined || child === null) {
      return;
    }

    if (Array.isArray(child)) {
      ret = ret.concat(toArray(child));
    } else if ((0, _reactIs.isFragment)(child) && child.props) {
      ret = ret.concat(toArray(child.props.children));
    } else {
      ret.push(child);
    }
  });

  return ret;
}

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _configProvider = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Divider = function Divider(props) {
  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var _classNames;

    var getPrefixCls = _ref.getPrefixCls;

    var customizePrefixCls = props.prefixCls,
        _props$type = props.type,
        type = _props$type === void 0 ? 'horizontal' : _props$type,
        _props$orientation = props.orientation,
        orientation = _props$orientation === void 0 ? 'center' : _props$orientation,
        className = props.className,
        children = props.children,
        dashed = props.dashed,
        restProps = __rest(props, ["prefixCls", "type", "orientation", "className", "children", "dashed"]);

    var prefixCls = getPrefixCls('divider', customizePrefixCls);
    var orientationPrefix = orientation.length > 0 ? "-".concat(orientation) : orientation;
    var classString = (0, _classnames["default"])(className, prefixCls, "".concat(prefixCls, "-").concat(type), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-with-text").concat(orientationPrefix), children), _defineProperty(_classNames, "".concat(prefixCls, "-dashed"), !!dashed), _classNames));
    return /*#__PURE__*/React.createElement("div", _extends({
      className: classString
    }, restProps, {
      role: "separator"
    }), children && /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-inner-text")
    }, children));
  });
};

var _default = Divider;
exports["default"] = _default;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(881);

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(882);

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createReactContext = _interopRequireDefault(__webpack_require__(156));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MenuContext = (0, _createReactContext["default"])({
  inlineCollapsed: false
});
var _default = MenuContext;
exports["default"] = _default;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(31);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(32);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(46);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactLifecyclesCompat = __webpack_require__(36);

var _createChainedFunction = __webpack_require__(950);

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

var _KeyCode = __webpack_require__(194);

var _KeyCode2 = _interopRequireDefault(_KeyCode);

var _placements = __webpack_require__(951);

var _placements2 = _interopRequireDefault(_placements);

var _rcTrigger = __webpack_require__(192);

var _rcTrigger2 = _interopRequireDefault(_rcTrigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

function refFn(field, component) {
  this[field] = component;
}

var Picker = function (_React$Component) {
  (0, _inherits3['default'])(Picker, _React$Component);

  function Picker(props) {
    (0, _classCallCheck3['default'])(this, Picker);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var open = void 0;
    if ('open' in props) {
      open = props.open;
    } else {
      open = props.defaultOpen;
    }
    var value = props.value || props.defaultValue;
    _this.saveCalendarRef = refFn.bind(_this, 'calendarInstance');

    _this.state = {
      open: open,
      value: value
    };
    return _this;
  }

  Picker.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    if (!prevState.open && this.state.open) {
      // setTimeout is for making sure saveCalendarRef happen before focusCalendar
      this.focusTimeout = setTimeout(this.focusCalendar, 0, this);
    }
  };

  Picker.prototype.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.focusTimeout);
  };

  Picker.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps) {
    var newState = {};
    var value = nextProps.value,
        open = nextProps.open;

    if ('value' in nextProps) {
      newState.value = value;
    }
    if (open !== undefined) {
      newState.open = open;
    }
    return newState;
  };

  Picker.prototype.render = function render() {
    var props = this.props;
    var prefixCls = props.prefixCls,
        placement = props.placement,
        style = props.style,
        getCalendarContainer = props.getCalendarContainer,
        align = props.align,
        animation = props.animation,
        disabled = props.disabled,
        dropdownClassName = props.dropdownClassName,
        transitionName = props.transitionName,
        children = props.children;

    var state = this.state;
    return _react2['default'].createElement(
      _rcTrigger2['default'],
      {
        popup: this.getCalendarElement(),
        popupAlign: align,
        builtinPlacements: _placements2['default'],
        popupPlacement: placement,
        action: disabled && !state.open ? [] : ['click'],
        destroyPopupOnHide: true,
        getPopupContainer: getCalendarContainer,
        popupStyle: style,
        popupAnimation: animation,
        popupTransitionName: transitionName,
        popupVisible: state.open,
        onPopupVisibleChange: this.onVisibleChange,
        prefixCls: prefixCls,
        popupClassName: dropdownClassName
      },
      _react2['default'].cloneElement(children(state, props), { onKeyDown: this.onKeyDown })
    );
  };

  return Picker;
}(_react2['default'].Component);

Picker.propTypes = {
  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].string]),
  disabled: _propTypes2['default'].bool,
  transitionName: _propTypes2['default'].string,
  onChange: _propTypes2['default'].func,
  onOpenChange: _propTypes2['default'].func,
  children: _propTypes2['default'].func,
  getCalendarContainer: _propTypes2['default'].func,
  calendar: _propTypes2['default'].element,
  style: _propTypes2['default'].object,
  open: _propTypes2['default'].bool,
  defaultOpen: _propTypes2['default'].bool,
  prefixCls: _propTypes2['default'].string,
  placement: _propTypes2['default'].any,
  value: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]),
  defaultValue: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]),
  align: _propTypes2['default'].object,
  dateRender: _propTypes2['default'].func,
  onBlur: _propTypes2['default'].func
};
Picker.defaultProps = {
  prefixCls: 'rc-calendar-picker',
  style: {},
  align: {},
  placement: 'bottomLeft',
  defaultOpen: false,
  onChange: noop,
  onOpenChange: noop,
  onBlur: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onCalendarKeyDown = function (event) {
    if (event.keyCode === _KeyCode2['default'].ESC) {
      event.stopPropagation();
      _this2.close(_this2.focus);
    }
  };

  this.onCalendarSelect = function (value) {
    var cause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var props = _this2.props;
    if (!('value' in props)) {
      _this2.setState({
        value: value
      });
    }
    if (cause.source === 'keyboard' || cause.source === 'dateInputSelect' || !props.calendar.props.timePicker && cause.source !== 'dateInput' || cause.source === 'todayButton') {
      _this2.close(_this2.focus);
    }
    props.onChange(value);
  };

  this.onKeyDown = function (event) {
    if (!_this2.state.open && (event.keyCode === _KeyCode2['default'].DOWN || event.keyCode === _KeyCode2['default'].ENTER)) {
      _this2.open();
      event.preventDefault();
    }
  };

  this.onCalendarOk = function () {
    _this2.close(_this2.focus);
  };

  this.onCalendarClear = function () {
    _this2.close(_this2.focus);
  };

  this.onCalendarBlur = function () {
    _this2.setOpen(false);
  };

  this.onVisibleChange = function (open) {
    _this2.setOpen(open);
  };

  this.getCalendarElement = function () {
    var props = _this2.props;
    var state = _this2.state;
    var calendarProps = props.calendar.props;
    var value = state.value;

    var defaultValue = value;
    var extraProps = {
      ref: _this2.saveCalendarRef,
      defaultValue: defaultValue || calendarProps.defaultValue,
      selectedValue: value,
      onKeyDown: _this2.onCalendarKeyDown,
      onOk: (0, _createChainedFunction2['default'])(calendarProps.onOk, _this2.onCalendarOk),
      onSelect: (0, _createChainedFunction2['default'])(calendarProps.onSelect, _this2.onCalendarSelect),
      onClear: (0, _createChainedFunction2['default'])(calendarProps.onClear, _this2.onCalendarClear),
      onBlur: (0, _createChainedFunction2['default'])(calendarProps.onBlur, _this2.onCalendarBlur)
    };

    return _react2['default'].cloneElement(props.calendar, extraProps);
  };

  this.setOpen = function (open, callback) {
    var onOpenChange = _this2.props.onOpenChange;

    if (_this2.state.open !== open) {
      if (!('open' in _this2.props)) {
        _this2.setState({
          open: open
        }, callback);
      }
      onOpenChange(open);
    }
  };

  this.open = function (callback) {
    _this2.setOpen(true, callback);
  };

  this.close = function (callback) {
    _this2.setOpen(false, callback);
  };

  this.focus = function () {
    if (!_this2.state.open) {
      _reactDom2['default'].findDOMNode(_this2).focus();
    }
  };

  this.focusCalendar = function () {
    if (_this2.state.open && !!_this2.calendarInstance) {
      _this2.calendarInstance.focus();
    }
  };
};

(0, _reactLifecyclesCompat.polyfill)(Picker);

exports['default'] = Picker;
module.exports = exports['default'];

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.authData=undefined;var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var year=(0,_moment2.default)().format("YYYY");var authData=exports.authData=[{title:"Hotel Information <br/> 酒店信息",value:"/table/cover",key:"/table/cover",children:[{title:"查看",key:"read_cover"},{title:"编辑",key:"edit_cover"}]},{title:"Hotel Data Index <br/> 酒店数据分析",value:"/table/hoteldataindex",key:"/table/hoteldataindex",children:[{title:"Performance Analysis <br/> 酒店经营情况分析",value:"/table/performanceAnalysisAll",key:"/table/performanceAnalysisAll",children:[{title:"1.1 Performance Analysis 酒店经营情况分析",value:"/table/performanceAnalysis",key:"/table/performanceAnalysis",children:[{title:"查看",key:"read_performanceAnalysis"},{title:"编辑",key:"edit_performanceAnalysis"}]},{title:"1.2 Data Visualization 数据可视化",value:"/table/analysisChart",key:"/table/analysisChart",children:[{title:"查看",key:"read_analysisChart"},{title:"编辑",key:"edit_analysisChart"}]},{title:"1.3 Breakdown Statistics Data 统计数据归集依据",value:"/table/performancedescription",key:"/table/performancedescription",children:[{title:"查看",key:"read_performancedescription"},{title:"编辑",key:"edit_performancedescription"}]},{title:"1.4 Performance Review 2019上半年酒店经营情况回顾",value:"/table/performanceReview",key:"/table/performanceReview",children:[{title:"查看",key:"read_performanceReview"},{title:"编辑",key:"edit_performanceReview"}]}]},{title:"Efficiency Per Square Meter Analysis<br/> 酒店坪效经营情况分析",value:"/table/efficiencyAll",key:"/table/efficiencyAll",children:[{title:"1.1 Efficiency Per Square Meter Analysis 酒店坪效经营情况分析",value:"/table/efficiency",key:"/table/efficiency",children:[{title:"查看",key:"read_efficiency"},{title:"编辑",key:"edit_efficiency"}]},{title:"1.2 Meeting Room Occ 会议室需求统计",value:"/table/effect1_2",key:"/table/effect1_2",children:[{title:"查看",key:"read_effect1_2"},{title:"编辑",key:"edit_effect1_2"}]},{title:"1.3 Breakdown Statistics Data 统计数据归集依据",value:"/table/effictdescription",key:"/table/effictdescription",children:[{title:"查看",key:"read_effictdescription"},{title:"编辑",key:"edit_effictdescription"}]}]},{title:"Hotel OTA Channel Performance <br/>酒店OTA渠道表现",value:"/table/ota",key:"/table/ota",children:[{title:"1.1 Fliggy Store Rooms Nights Ranking - Current Month 集团飞猪旗舰店当月客房间夜数销售排名",value:"/table/otashow",key:"/table/otashow",children:[{title:"查看",key:"read_otashow"},{title:"编辑",key:"edit_otashow"}]},{title:"1.2 Ctrip Rooms Revenue & Nights Ranking 携程平台集团酒店本年客房收益与间夜数销售排名（不含供应商数据）",value:"/table/otashowctrip",key:"/table/otashowctrip",children:[{title:"查看",key:"read_otashowctrip"},{title:"编辑",key:"edit_otashowctrip"}]},{title:"1.3 Meituan Rooms Revenue & Nights Ranking 美团平台集团酒店本年客房收益与间夜数销售排名（不含供应商数据）",value:"/table/otashowmeituan",key:"/table/otashowmeituan",children:[{title:"查看",key:"read_otashowmeituan"},{title:"编辑",key:"edit_otashowmeituan"}]},{title:"1.4 GCH Mini Program Rooms Revenue & Nights Ranking - Current Month 集团官网小程序当月客房收益与间夜数销售排名",value:"/table/otaappletrn",key:"/table/otaappletrn",children:[{title:"查看",key:"read_otaappletrn"},{title:"编辑",key:"edit_otaappletrn"}]},{title:"1.5 GCH Mini Program Page View Ranking - Current Month 集团小程序当月访问量排名",value:"/table/otaapplet",key:"/table/otaapplet",children:[{title:"查看",key:"read_otaapplet"},{title:"编辑",key:"edit_otaapplet"}]}]},{title:"Price Repairing <br/> 官网比价",value:"/table/pricerepairing",key:"/table/pricerepairing",children:[{title:"1.1 Price Repairing 官网比价",value:"/table/price1_1",key:"/table/price1_1",children:[{title:"查看",key:"read_price1_1"},{title:"编辑",key:"edit_price1_1"}]},{title:"1.2 Price Repairing Visual Diagram 官网比价可视化",value:"/table/price1_2",key:"/table/price1_2",children:[{title:"查看",key:"read_price1_2"},{title:"编辑",key:"edit_price1_2"}]},{title:"1.3  Price Repairing File Upload 官网比价文件上传",value:"/table/price1_3",key:"/table/price1_3",children:[{title:"查看",key:"read_price1_3"},{title:"编辑",key:"edit_otashowmeituan"}]}]}]},{title:"Customer Satisfaction<br/> 客人满意度",value:"/table/guestratingAll",key:"/table/guestratingAll",children:[{title:"WynReview - Medallia 集团渠道",value:"/table/guestrating",key:"/table/guestrating",children:[{title:"查看",key:"read_guestrating"},{title:"编辑",key:"edit_guestrating"}]},{title:"Online Travel Agency 网络平台",value:"/table/groupOfChannels",key:"/table/groupOfChannels",children:[{title:"查看",key:"read_groupOfChannels"},{title:"编辑",key:"edit_groupOfChannels"}]}]},{title:"Hotel Emergency Report 酒店紧急事件报告",value:"/table/urgent",key:"/table/urgent",children:[{title:"查看",key:"read_urgent"},{title:"编辑",key:"edit_urgent"}]},{title:"Consulting Reports 第三方行业资讯报告摘要",value:"/table/consulting",key:"/table/consulting",children:[{title:"查看",key:"read_consulting"},{title:"编辑",key:"edit_consulting"}]},{title:"Meeting Flash Report <br/>会议即时报表",value:"/table/meetingflash",key:"/table/meetingflash",children:[{title:"查看",key:"read_meetingflash"},{title:"编辑",key:"edit_meetingflash"}]},{title:"KPI Follow参数",value:"/table/kpifollow",key:"/table/kpifollow",children:[{title:"查看",key:"read_kpifollow"},{title:"编辑",key:"edit_kpifollow"}]},{title:"宴会设施统计",value:"/table/banquetFacilities",key:"/table/banquetFacilities",children:[{title:"查看",key:"read_banquetFacilities"},{title:"编辑",key:"edit_banquetFacilities"}]},{title:"酒店系统统计",value:"/table/systemStatistical",key:"/table/systemStatistical",children:[{title:"查看",key:"read_systemStatistical"},{title:"编辑",key:"edit_systemStatistical"}]},{title:year+"\u5E74\u4E94\u4E00\u5047\u671F\u4E1A\u7EE9\u60C5\u51B5",value:"/table/mayday",key:"/table/mayday",children:[{title:"查看",key:"read_mayday"},{title:"编辑",key:"edit_mayday"}]},{title:year+"\u5E74\u56FD\u5E86\u5047\u671F\u4E1A\u7EE9\u60C5\u51B5",value:"/table/nationalDay",key:"/table/nationalDay",children:[{title:"查看",key:"read_nationalDay"},{title:"编辑",key:"edit_nationalDay"}]},{title:"财务月度分析报告",value:"/table/monthlyAnalysis",key:"/table/monthlyAnalysis",children:[{title:"查看",key:"read_monthlyAnalysis"},{title:"编辑",key:"edit_monthlyAnalysis"}]},{title:"财务部人员评估",value:"/table/personnelAssessment",key:"/table/personnelAssessment",children:[{title:"查看",key:"read_personnelAssessment"},{title:"编辑",key:"edit_personnelAssessment"}]},{title:"P&L Review Meeting Minutes<br/> 经营评估会议纪要",value:"/table/meetingMinutes",key:"/table/meetingMinutes",children:[{title:"查看",key:"read_meetingMinutes"},{title:"编辑",key:"edit_meetingMinutes"}]},{title:"1.0 KPI - Key Performance Indicator<br/> 关键绩效指数",value:"/table/1",key:"/table/1",children:[{title:"查看",key:"read_1"},{title:"编辑",key:"edit_1"}]},{title:"2.0 P&L Analysis<br/> 损益分析",value:"/table/2",key:"/table/2",children:[{title:"2.1 Current Year P&L Analysis (Whole Year Forecast = Actual + Forecast) 本年损益分析（全年预测 = 实际+预测）",value:"/table/2_1",key:"/table/2_1",children:[{title:"查看",key:"read_2_1"},{title:"编辑",key:"edit_2_1"}]},{title:"2.2 Current Year P&L Analysis (Whole Year Budget) 本年损益分析 （全年预算）",value:"/table/2_2",key:"/table/2_2",children:[{title:"查看",key:"read_2_2"},{title:"编辑",key:"edit_2_2"}]},,{title:"2.3 Last Year P&L Analysis (Whole Year Actual) 前一年度损益分析 （全年实际）",value:"/table/2_3",key:"/table/2_3",children:[{title:"查看",key:"read_2_3"},{title:"编辑",key:"edit_2_3"}]}]},{title:"3.0 Guest Comments & Wyndham Rewards",value:"/table/3",key:"/table/3",children:[{title:"3.1 Online Guest Comments 顾客在线评论",value:"/table/2_7",key:"/table/2_7",children:[{title:"查看",key:"read_2_7"},{title:"编辑",key:"edit_2_7"}]},{title:"3.2 Wyndham Rewards Enrollment 温德姆奖赏计划新会员加入",value:"/table/2_8",key:"/table/2_8",children:[{title:"查看",key:"read_2_8"},{title:"编辑",key:"edit_2_8"}]}]},{title:" 4.0 new Room Analysis",value:"/table/4_new",key:"/table/4_new",children:[{title:"4.2 新版市场细分表-月度",value:"/table/4_2_new",key:"/table/4_2_new",children:[{title:"4.2.1 Monthly Market Segment Report 月度市场细分表",value:"/table/4_2_1_new",key:"/table/4_2_1_new",children:[{title:"查看",key:"read_4_2_1_new"},{title:"编辑",key:"edit_4_2_1_new"}]},{title:"4.2.2 未来3个月销售策略和行动计划",value:"/table/4_2_2_new",key:"/table/4_2_2_new",children:[{title:"查看",key:"read_4_2_2_new"},{title:"编辑",key:"edit_4_2_2_new"}]}]},{title:"4.3 新版市场细分表-年度",value:"/table/4_3_new",key:"/table/4_3_new",children:[{title:"4.3.1 Market Segment by Month <br/> 市场细分明细表月度分解",value:"/table/4_3_1_new",key:"/table/4_3_1_new",children:[{title:"查看",key:"read_4_3_1_new"},{title:"编辑",key:"edit_4_3_1_new"}]},{title:"4.3.2 Key Market Segment By Month 市场细分月度汇总表",value:"/table/4_3_2_new",key:"/table/4_3_2_new",children:[{title:"查看",key:"read_4_3_2_new"},{title:"编辑",key:"edit_4_3_2_new"}]}]}]},{title:"4.0 Rooms Analysis<br/> 客房分析",value:"/table/4",key:"/table/4",children:[{title:"销售部人员评估",value:"/table/salesPersonnelAssessment",key:"/table/salesPersonnelAssessment",children:[{title:"查看",key:"read_salesPersonnelAssessment"},{title:"编辑",key:"edit_salesPersonnelAssessment"}]},{title:"4.0 集团区域报表",value:"/table/4_0_area",key:"/table/4_0_area",children:[{title:"区域报表",value:"/table/4_2_summary",key:"/table/4_2_summary",children:[{title:"查看",key:"read_4_2_summary"},{title:"编辑",key:"edit_4_2_summary"}]},{title:"春节区域报表",value:"/table/chineseNewYear",key:"/table/chineseNewYear",children:[{title:"查看",key:"read_chineseNewYear"},{title:"编辑",key:"edit_chineseNewYear"}]},{title:"五一区域报表",value:"/table/areaMayDay",key:"/table/areaMayDay",children:[{title:"查看",key:"read_areaMayDay"},{title:"编辑",key:"edit_areaMayDay"}]},{title:"十一区域报表",value:"/table/eleven",key:"/table/eleven",children:[{title:"查看",key:"read_eleven"},{title:"编辑",key:"edit_eleven"}]},{title:"年度区域报表",value:"/table/annualRegional",key:"/table/annualRegional",children:[{title:"查看",key:"read_annualRegional"},{title:"编辑",key:"edit_annualRegional"}]},{title:"节日汇总表",value:"/table/4_2/holiday/summary",key:"/table/4_2/holiday/summary",children:[{title:"查看",key:"read_4_2_holidaySummary"},{title:"编辑",key:"edit_4_2_holidaySummary"}]},{title:"区域满房报表",value:"/table/4_2/fullRoom",key:"/table/4_2/fullRoom",children:[{title:"查看",key:"read_4_2_fullRoom"},{title:"编辑",key:"edit_4_2_fullRoom"}]}]},{title:"4.1 Monthly Report月报",value:"/table/4_1",key:"/table/4_1",children:[{title:"查看",key:"read_4_1"},{title:"编辑",key:"edit_4_1"}]},{title:"4.2 Daily Report 日报",value:"/table/4_2",key:"/table/4_2",children:[{title:"4.2.1 Daily Report 日报",value:"/table/4_2_1",key:"/table/4_2_1",children:[{title:"查看",key:"read_4_2_1"},{title:"编辑",key:"edit_4_2_1"}]},{title:"4.2.2 Daily Report by Segmentation",value:"/table/4_2_2",key:"/table/4_2_2",children:[{title:"查看",key:"read_4_2_2"},{title:"编辑",key:"edit_4_2_2"}]},{title:"4.2.3 Early Bird Report",value:"/table/4_2_3",key:"/table/4_2_3",children:[{title:"查看",key:"read_4_2_3"},{title:"编辑",key:"edit_4_2_3"}]},{title:"4.2.4 Monthly Biz On-book Outlook",value:"/table/4_2_4",key:"/table/4_2_4",children:[{title:"查看",key:"read_4_2_4"},{title:"编辑",key:"edit_4_2_4"}]},{title:"4.2.5 Daily Pick up Trend",value:"/table/4_2_5",key:"/table/4_2_5",children:[{title:"查看",key:"read_4_2_5"},{title:"编辑",key:"edit_4_2_5"}]},{title:"4.2.6 Daily Pick up by Segmentation",value:"/table/4_2_6",key:"/table/4_2_6",children:[{title:"查看",key:"read_4_2_6"},{title:"编辑",key:"edit_4_2_6"}]},{title:"4.2.7 Daily On-book by Status",value:"/table/4_2_7",key:"/table/4_2_7",children:[{title:"查看",key:"read_4_2_7"},{title:"编辑",key:"edit_4_2_7"}]}]},{title:"4.3 Top Account Analysis 关键客户分析",value:"/table/4_3",key:"/table/4_3",children:[{title:"查看",key:"read_4_3"},{title:"编辑",key:"edit_4_3"}]},{title:"4.4 Geographic City(Domestic)/Country(oversea) Top 10",value:"/table/4_4",key:"/table/4_4",children:[{title:"查看",key:"read_4_4"},{title:"编辑",key:"edit_4_4"}]},{title:"4.5 Rooms Revenue Up-selling Program 客房收入增销计划",value:"/table/4_5",key:"/table/4_5",children:[{title:"查看",key:"read_4_5"},{title:"编辑",key:"edit_4_5"}]},{title:"4.6 Rooms KPI Analysis 客房关键绩效指数分析",value:"/table/3_1",key:"/table/3_1",children:[{title:"查看",key:"read_3_1"},{title:"编辑",key:"edit_3_1"}]}]},{title:"5.0 F&B Analysis<br/> 餐饮分析",value:"/table/5",key:"/table/5",children:[{title:"5.0 F&B Summary 餐饮关键绩效指数",value:"/table/5_0",key:"/table/5_0",children:[{title:"查看",key:"read_5_0"},{title:"编辑",key:"edit_5_0"}]},{title:"5.1 F&B Revenue Analysis By Outlets 餐饮收入分析-按餐厅",value:"/table/5_1",key:"/table/5_1",children:[{title:"查看",key:"read_5_1"},{title:"编辑",key:"edit_5_1"}]},{title:"5.2 Three Months Rolling Forecast 后三个月滚动预测",value:"/table/5_2",key:"/table/5_2",children:[{title:"查看",key:"read_5_2"},{title:"编辑",key:"edit_5_2"}]},{title:"5.3~5.4 F&B 3 Month Rolling Action Plan By Outlets 三个月按照餐厅细分的滚动行动计划/F&B Advertising and Marketing Plan For Next 3 Months 后三个月针对餐饮的广告投放及营销计划",value:"/table/5_3",key:"/table/5_3",children:[{title:"查看",key:"read_5_3"},{title:"编辑",key:"edit_5_3"}]},{title:"5.5 Breakfast & Club Lounge Revenue Allocation 早餐收入分配",value:"/table/5_5",key:"/table/5_5",children:[{title:"查看",key:"read_5_5"},{title:"编辑",key:"edit_5_5"}]},{title:"5.6 F&B Unit Account & Individual Analysis 餐饮单位账号消费及个人账号消费分析",value:"/table/5_6",key:"/table/5_6",children:[{title:"查看",key:"read_5_6"},{title:"编辑",key:"edit_5_6"}]},{title:" 5.7 F&B Outlets KPI Analysis 餐饮部餐厅关键绩效指数分析",value:"/table/3_2",key:"/table/3_2",children:[{title:"查看",key:"read_3_2"},{title:"编辑",key:"edit_3_2"}]},{title:" 5.8 Chinese Restaurant Top 10 Favorite & Unpopular Dish Sales Summary 中餐厅菜品销售总结盘点",value:"/table/5_8",key:"/table/5_8",children:[{title:"查看",key:"read_5_8"},{title:"编辑",key:"edit_5_8"}]},{title:"5.9 美团点评套餐销量统计 Meituan Dianping Package Sales Summary",value:"/table/5_9",key:"/table/5_9",children:[{title:"查看",key:"read_5_9"},{title:"编辑",key:"edit_5_9"}]},{title:"5.10 单店分析",value:"/table/5_10",key:"/table/5_10",children:[{title:"查看",key:"read_5_10"},{title:"编辑",key:"edit_5_10"}]}]},{title:"6.0 Catering & Events (C&E) Analysis <br/>宴会活动分析",value:"/table/6",key:"/table/6",children:[{title:"6.1 Catering & Events (C&E) Analysis By Market Segment 宴会活动分析 - 按市场细分",value:"/table/6_1",key:"/table/6_1",children:[{title:"查看",key:"read_6_1"},{title:"编辑",key:"edit_6_1"}]},{title:"6.2 F&B Catering/Banquet KPI Analysis 餐饮部宴会活动关键绩效指数分析",value:"/table/6_2",key:"/table/6_2",children:[{title:"查看",key:"read_6_2"},{title:"编辑",key:"edit_6_2"}]},{title:"6.3 C&E 3 Month Rolling Action Plan By Outlets 三个月按照餐厅细分的滚动行动计划/C&E Advertising and Marketing Plan For Next 3 Months 后三个月正对宴会活动的广告投放及营销计划",value:"/table/6_3",key:"/table/6_3",children:[{title:"查看",key:"read_6_3"},{title:"编辑",key:"edit_6_3"}]}]},{title:"7.0 Human Resources Analysis <br/>人力资源分析",value:"/table/7",key:"/table/7",children:[{title:"7.1 Total Payroll Cost Analysis 薪酬总成本分析",value:"/table/7_1",key:"/table/7_1",children:[{title:"查看",key:"read_7_1"},{title:"编辑",key:"edit_7_1"}]},{title:"7.2 Associate Movement 人员流动",value:"/table/7_2",key:"/table/7_2",children:[{title:"查看",key:"read_7_2"},{title:"编辑",key:"edit_7_2"}]},{title:"7.3 Recruitment Plan (B2 and above, Vacant Positions) & Succession Plan 空缺职位招聘(B2级以上）及接班人计划",value:"/table/7_3",key:"/table/7_3",children:[{title:"查看",key:"read_7_3"},{title:"编辑",key:"edit_7_3"}]},{title:"7.4 Training Statistics By Department 按部门培训记录统计",value:"/table/7_4",key:"/table/7_4",children:[{title:"查看",key:"read_7_4"},{title:"编辑",key:"edit_7_4"}]},{title:"7.5 Annual Leave and Overtime 年假及加班",value:"/table/7_5",key:"/table/7_5",children:[{title:"查看",key:"read_7_5"},{title:"编辑",key:"edit_7_5"}]},{title:"7.6 Training Plan For Next 1 Month 后一个月的培训计划",value:"/table/7_6",key:"/table/7_6",children:[{title:"查看",key:"read_7_6"},{title:"编辑",key:"edit_7_6"}]},{title:"7.7 Data Visualization \u4EBA\u6548\u6570\u636E\u53EF\u89C6\u5316",value:"/table/7_7",key:"/table/7_7",children:[{title:"查看",key:"read_7_7"},{title:"编辑",key:"edit_7_7"}]},{title:"7.8 Labor Cost Productivity Analysis \u4EBA\u529B\u6210\u672C\u751F\u4EA7\u7387\u5206\u6790\u8868",value:"/table/7_8",key:"/table/7_8",children:[{title:"查看",key:"read_7_8"},{title:"编辑",key:"edit_7_8"}]}]},{title:"8.0 Utility Cost Trend Analysis <br/>能源成本趋势分析",value:"/table/8",key:"/table/8",children:[{title:"8.1~8.2 Utility Item 能源项目/Utility Conservation Measures 能源控制措施",value:"/table/8_1",key:"/table/8_1",children:[{title:"查看",key:"read_8_1"},{title:"编辑",key:"edit_8_1"}]}]},{title:"9.0 Financial Analysis<br/> 财务分析",value:"/table/9",key:"/table/9",children:[{title:"9.1 Balance Sheet 资产负债表",value:"/table/9_1",key:"/table/9_1",children:[{title:"查看",key:"read_9_1"},{title:"编辑",key:"edit_9_1"}]},{title:"9.2 Accounts Receivable 应收账款",value:"/table/9_2",key:"/table/9_2",children:[{title:"查看",key:"read_9_2"},{title:"编辑",key:"edit_9_2"}]},{title:"9.3 Accounts Payable 应付账款",value:"/table/9_3",key:"/table/9_3",children:[{title:"查看",key:"read_9_3"},{title:"编辑",key:"edit_9_3"}]},{title:"9.4 Operating Equipment Stock taken Summary 营运工具盘点汇总 (at least Quarterly)",value:"/table/9_4",key:"/table/9_4",children:[{title:"查看",key:"read_9_4"},{title:"编辑",key:"edit_9_4"}]},{title:"9.5 FFE Site Inspection Summary 固定资产盘点汇总 (at least half-yearly)",value:"/table/9_5",key:"/table/9_5",children:[{title:"查看",key:"read_9_5"},{title:"编辑",key:"edit_9_5"}]},{title:"9.6 Capital Expenditure (CAPEX) and FF&E Reserve 固定资产及FF&E计提",value:"/table/9_6",key:"/table/9_6",children:[{title:"查看",key:"read_9_6"},{title:"编辑",key:"edit_9_6"}]},{title:"9.7 Department Expenses 部门费用",value:"/table/9_7",key:"/table/9_7",children:[{title:"查看",key:"read_9_7"},{title:"编辑",key:"edit_9_7"}]},{title:"9.8 Food Purchase Top 15 List 食品采购前15位清单",value:"/table/9_8",key:"/table/9_8",children:[{title:"查看",key:"read_9_8"},{title:"编辑",key:"edit_9_8"}]},{title:"9.9 Rebate Summary 收入抵减汇总",value:"/table/9_9",key:"/table/9_9",children:[{title:"查看",key:"read_9_9"},{title:"编辑",key:"edit_9_9"}]},{title:"9.10 Finance Internal Control Checklist 财务内部控制清单",value:"/table/9_10",key:"/table/9_10",children:[{title:"查看",key:"read_9_10"},{title:"编辑",key:"edit_9_10"}]}]},{title:"10.0~11.0 CSR and Community Activities <br/>企业社会责任及社区活动/Other Issues 其他事宜",value:"/table/10",key:"/table/10",children:[{title:"查看",key:"read_10"},{title:"编辑",key:"edit_10"}]},{title:"12.0 Club GCH 豪廷會",value:"/table/12",key:"/table/12",children:[{title:"查看",key:"read_12"},{title:"编辑",key:"edit_12"}]},{title:"Daily Revenue Report 每日经营报表",value:"/table/daily",key:"/table/daily",children:[{title:"查看",key:"read_daily"},{title:"编辑",key:"edit_daily"}]},{title:"PDF Version PDF 报表",value:"/table/pdf",key:"/table/pdf",children:[{title:"查看",key:"read_pdf"},{title:"编辑",key:"edit_pdf"}]},{title:"Business Plan 年度经营预算",value:"/bp",key:"/bp",children:[{title:"查看",key:"read_bp"},{title:"编辑",key:"edit_bp"}]},{title:"Human Resources 人力资源报告",value:"/hr",key:"/hr",children:[{title:"查看",key:"read_hr"},{title:"编辑",key:"edit_hr"}]},{title:"Headquarters Menu Summary<br/> 总部菜单汇总",value:"/table/headquarters",key:"/table/headquarters",children:[{title:"BI Structure - Hotel <br/>酒店数据平台",value:"/table/general",key:"/table/general",children:[{title:"查看",key:"read_general"},{title:"编辑",key:"edit_general"}]},{title:"BI Structure - Corporate Office <br/>总部数据平台",value:"/table/bi_headquarters",key:"/table/bi_headquarters",children:[{title:"查看",key:"read_bi_headquarters"},{title:"编辑",key:"edit_bi_headquarters"}]},{title:"BI Structure - DOO <br/>总部数据平台 - DOO",value:"/table/doobi",key:"/table/doobi",children:[{title:"查看",key:"read_doobi"},{title:"编辑",key:"edit_doobi"}]},{title:"月度回顾表 Monthly ES Review",value:"/table/monthlyreview",key:"/table/monthlyreview",children:[{title:"查看",key:"read_monthlyreview"},{title:"编辑",key:"edit_monthlyreview"}]},{title:"HQ Sales <br/> 总部销售部",value:"/table/Sales",key:"/table/Sales",children:[{title:"Budget Summary",value:"/table/BPBudgetSummary",key:"/table/BPBudgetSummary",children:[{title:"查看",key:"read_BPBudgetSummary"},{title:"编辑",key:"edit_BPBudgetSummary"}]},{title:"BP8.2.1 Budget By Market Segment汇总表",value:"/table/BPBudgetSummary8_2_1",key:"/table/BPBudgetSummary8_2_1",children:[{title:"查看",key:"read_BPBudgetSummary8_2_1"},{title:"编辑",key:"edit_BPBudgetSummary8_2_1"}]},{title:"Revenue monthly summary 单体酒店月度收益报表",value:"/table/headquartersmonth",key:"/table/headquartersmonth",children:[{title:"查看",key:"read_headquartersmonth"},{title:"编辑",key:"edit_headquartersmonth"}]},{title:"Monthly completion trend 单体酒店月度完成趋势",value:"/table/headquartersyear",key:"/table/headquartersyear",children:[{title:"查看",key:"read_headquartersyear"},{title:"编辑",key:"edit_headquartersyear"}]},{title:"Rooms KPI Analysis Summary 客房关键绩效指数分析汇总",value:"/table/roomsKPIAnalysisSummary",key:"/table/roomsKPIAnalysisSummary",children:[{title:"查看",key:"read_roomsKPIAnalysisSummary"},{title:"编辑",key:"edit_roomsKPIAnalysisSummary"}]},{title:"Excel data import Excel 数据导入",value:"/table/guestReviewImport",key:"/table/guestReviewImport",children:[{title:"查看",key:"read_guestReviewImport"},{title:"编辑",key:"edit_guestReviewImport"}]}]},{title:"Daily Revenue Report <br/> 每日经营报表",value:"/table/dailyM",key:"/table/dailyM",children:[{title:"1.1 每日经营报表月度汇总",value:"/table/dailyMonth",key:"/table/dailyMonth",children:[{title:"查看",key:"read_dailyMonth"},{title:"编辑",key:"edit_dailyMonth"}]},{title:"1.2 单酒店月度数据去年同比分析",value:"/table/dailyChart",key:"/table/dailyChart",children:[{title:"查看",key:"read_dailyChart"},{title:"编辑",key:"edit_dailyChart"}]},{title:"1.3 酒店月度统计汇总",value:"/table/dailyMonthAllHotels",key:"/table/dailyMonthAllHotels",children:[{title:"查看",key:"read_dailyMonthAllHotels"},{title:"编辑",key:"edit_dailyMonthAllHotels"}]},{title:"1.4 酒店月度餐饮统计汇总",value:"/table/dailyMonthAllHotels1_4",key:"/table/dailyMonthAllHotels1_4",children:[{title:"查看",key:"read_dailyMonthAllHotels1_4"},{title:"编辑",key:"edit_dailyMonthAllHotels1_4"}]},{title:"1.5 每日经营报表报警记录",value:"/table/dailyMonthAllHotels1_5",key:"/table/dailyMonthAllHotels1_5",children:[{title:"查看",key:"read_dailyMonthAllHotels1_5"},{title:"编辑",key:"edit_dailyMonthAllHotels1_5"}]},{title:"1.6 Daily Visual Diagram 日数据可视化图表",value:"/table/groupanalysisChart",key:"/table/groupanalysisChart",children:[{title:"查看",key:"read_groupanalysisChart"},{title:"编辑",key:"edit_groupanalysisChart"}]}]},{title:"情况分析利润调整",value:"/table/profit",key:"/table/profit",children:[{title:"查看",key:"read_profit"},{title:"编辑",key:"edit_profit"}]},{title:"Fliggy Store Rooms Nights Ranking - Current Month<br/> 集团飞猪旗舰店当月客房间夜数销售排名",value:"/table/otafillin",key:"/table/otafillin",children:[{title:"查看",key:"read_otafillin"},{title:"编辑",key:"edit_otafillin"}]},{title:"合同管理",value:"/table/contract_manage",key:"/table/contract_manage",children:[{title:"查看",key:"read_contract_manage"},{title:"编辑",key:"edit_contract_manage"}]}]},{title:"Simple Report<br/> 简易数据汇总表",value:"/table/charter",key:"/table/charter",children:[{title:"the first season<br/> 第一季度",value:"/table/charter/one",key:"/table/charter/one",children:[{title:"查看",key:"read_one"},{title:"编辑",key:"edit_one"}]},{title:"the second season <br/>第二季度",value:"/table/charter/two",key:"/table/charter/two",children:[{title:"查看",key:"read_two"},{title:"编辑",key:"edit_two"}]},{title:"the third season <br/>第三季度",value:"/table/charter/three",key:"/table/charter/three",children:[{title:"查看",key:"read_three"},{title:"编辑",key:"edit_three"}]},{title:"the fourth season<br/> 第四季度",value:"/table/charter/four",key:"/table/charter/four",children:[{title:"查看",key:"read_four"},{title:"编辑",key:"edit_four"}]},{title:"PL",value:"/table/charter/summary",key:"/table/charter/summary",children:[{title:"查看",key:"read_summary"},{title:"编辑",key:"edit_summary"}]}]}];exports.default=authData;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(263),
    stackClear = __webpack_require__(987),
    stackDelete = __webpack_require__(988),
    stackGet = __webpack_require__(989),
    stackHas = __webpack_require__(990),
    stackSet = __webpack_require__(991);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(158),
    root = __webpack_require__(101);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(195),
    isObject = __webpack_require__(116);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(998),
    mapCacheDelete = __webpack_require__(1005),
    mapCacheGet = __webpack_require__(1007),
    mapCacheHas = __webpack_require__(1008),
    mapCacheSet = __webpack_require__(1009);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(511);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 354 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1019),
    isObjectLike = __webpack_require__(159);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 356 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(101),
    stubFalse = __webpack_require__(1021);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(220)(module)))

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1023),
    baseUnary = __webpack_require__(1024),
    nodeUtil = __webpack_require__(1025);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 359 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 360 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(132),
    isSymbol = __webpack_require__(269);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(19));

var _rcCheckbox = _interopRequireDefault(__webpack_require__(527));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _shallowequal = _interopRequireDefault(__webpack_require__(89));

var _configProvider = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Radio = /*#__PURE__*/function (_React$Component) {
  _inherits(Radio, _React$Component);

  var _super = _createSuper(Radio);

  function Radio() {
    var _this;

    _classCallCheck(this, Radio);

    _this = _super.apply(this, arguments);

    _this.saveCheckbox = function (node) {
      _this.rcCheckbox = node;
    };

    _this.onChange = function (e) {
      if (_this.props.onChange) {
        _this.props.onChange(e);
      }

      if (_this.context.radioGroup && _this.context.radioGroup.onChange) {
        _this.context.radioGroup.onChange(e);
      }
    };

    _this.renderRadio = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props,
          context = _assertThisInitialize.context;

      var customizePrefixCls = props.prefixCls,
          className = props.className,
          children = props.children,
          style = props.style,
          restProps = __rest(props, ["prefixCls", "className", "children", "style"]);

      var radioGroup = context.radioGroup;
      var prefixCls = getPrefixCls('radio', customizePrefixCls);

      var radioProps = _extends({}, restProps);

      if (radioGroup) {
        radioProps.name = radioGroup.name;
        radioProps.onChange = _this.onChange;
        radioProps.checked = props.value === radioGroup.value;
        radioProps.disabled = props.disabled || radioGroup.disabled;
      }

      var wrapperClassString = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-wrapper"), true), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-checked"), radioProps.checked), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-disabled"), radioProps.disabled), _classNames));
      return (
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/label-has-associated-control
        React.createElement("label", {
          className: wrapperClassString,
          style: style,
          onMouseEnter: props.onMouseEnter,
          onMouseLeave: props.onMouseLeave
        }, /*#__PURE__*/React.createElement(_rcCheckbox["default"], _extends({}, radioProps, {
          prefixCls: prefixCls,
          ref: _this.saveCheckbox
        })), children !== undefined ? /*#__PURE__*/React.createElement("span", null, children) : null)
      );
    };

    return _this;
  }

  _createClass(Radio, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState) || !(0, _shallowequal["default"])(this.context.radioGroup, nextContext.radioGroup);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.rcCheckbox.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.rcCheckbox.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRadio);
    }
  }]);

  return Radio;
}(React.Component);

exports["default"] = Radio;
Radio.defaultProps = {
  type: 'radio'
};
Radio.contextTypes = {
  radioGroup: PropTypes.any
};

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Pagination = _interopRequireDefault(__webpack_require__(1078));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _Pagination["default"];
exports["default"] = _default;

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["u"] = toTitle;
/* harmony export (immutable) */ __webpack_exports__["k"] = getValuePropValue;
/* harmony export (immutable) */ __webpack_exports__["i"] = getPropValue;
/* unused harmony export isMultiple */
/* harmony export (immutable) */ __webpack_exports__["m"] = isCombobox;
/* harmony export (immutable) */ __webpack_exports__["n"] = isMultipleOrTags;
/* harmony export (immutable) */ __webpack_exports__["o"] = isMultipleOrTagsOrCombobox;
/* harmony export (immutable) */ __webpack_exports__["p"] = isSingleMode;
/* harmony export (immutable) */ __webpack_exports__["t"] = toArray;
/* harmony export (immutable) */ __webpack_exports__["h"] = getMapKey;
/* harmony export (immutable) */ __webpack_exports__["q"] = preventDefaultEvent;
/* harmony export (immutable) */ __webpack_exports__["e"] = findIndexInValueBySingleValue;
/* harmony export (immutable) */ __webpack_exports__["g"] = getLabelFromPropsValue;
/* harmony export (immutable) */ __webpack_exports__["j"] = getSelectKeys;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UNSELECTABLE_STYLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UNSELECTABLE_ATTRIBUTE; });
/* harmony export (immutable) */ __webpack_exports__["d"] = findFirstMenuItem;
/* harmony export (immutable) */ __webpack_exports__["l"] = includesSeparators;
/* harmony export (immutable) */ __webpack_exports__["s"] = splitBySeparators;
/* harmony export (immutable) */ __webpack_exports__["c"] = defaultFilterFn;
/* harmony export (immutable) */ __webpack_exports__["v"] = validateOptionValue;
/* harmony export (immutable) */ __webpack_exports__["r"] = saveRef;
/* harmony export (immutable) */ __webpack_exports__["f"] = generateUUID;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function toTitle(title) {
  if (typeof title === 'string') {
    return title;
  }

  return '';
}
function getValuePropValue(child) {
  if (!child) {
    return null;
  }

  var props = child.props;

  if ('value' in props) {
    return props.value;
  }

  if (child.key) {
    return child.key;
  }

  if (child.type && child.type.isSelectOptGroup && props.label) {
    return props.label;
  }

  throw new Error("Need at least a key or a value or a label (only for OptGroup) for ".concat(child));
}
function getPropValue(child, prop) {
  if (prop === 'value') {
    return getValuePropValue(child);
  }

  return child.props[prop];
}
function isMultiple(props) {
  return props.multiple;
}
function isCombobox(props) {
  return props.combobox;
}
function isMultipleOrTags(props) {
  return props.multiple || props.tags;
}
function isMultipleOrTagsOrCombobox(props) {
  return isMultipleOrTags(props) || isCombobox(props);
}
function isSingleMode(props) {
  return !isMultipleOrTagsOrCombobox(props);
}
function toArray(value) {
  var ret = value;

  if (value === undefined) {
    ret = [];
  } else if (!Array.isArray(value)) {
    ret = [value];
  }

  return ret;
}
function getMapKey(value) {
  return "".concat(typeof value, "-").concat(value);
}
function preventDefaultEvent(e) {
  e.preventDefault();
}
function findIndexInValueBySingleValue(value, singleValue) {
  var index = -1;

  if (value) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === singleValue) {
        index = i;
        break;
      }
    }
  }

  return index;
}
function getLabelFromPropsValue(value, key) {
  var label;
  value = toArray(value);

  if (value) {
    // tslint:disable-next-line:prefer-for-of
    for (var i = 0; i < value.length; i++) {
      if (value[i].key === key) {
        label = value[i].label;
        break;
      }
    }
  }

  return label;
}
function getSelectKeys(menuItems, value) {
  if (value === null || value === undefined) {
    return [];
  }

  var selectedKeys = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(menuItems, function (item) {
    var type = item.type;

    if (type.isMenuItemGroup) {
      selectedKeys = selectedKeys.concat(getSelectKeys(item.props.children, value));
    } else {
      var itemValue = getValuePropValue(item);
      var itemKey = item.key;

      if (findIndexInValueBySingleValue(value, itemValue) !== -1 && itemKey) {
        selectedKeys.push(itemKey);
      }
    }
  });
  return selectedKeys;
}
var UNSELECTABLE_STYLE = {
  userSelect: 'none',
  WebkitUserSelect: 'none'
};
var UNSELECTABLE_ATTRIBUTE = {
  unselectable: 'on'
};
function findFirstMenuItem(children) {
  // tslint:disable-next-line:prefer-for-of
  for (var i = 0; i < children.length; i++) {
    var child = children[i];

    if (child.type.isMenuItemGroup) {
      var found = findFirstMenuItem(child.props.children);

      if (found) {
        return found;
      }
    } else if (!child.props.disabled) {
      return child;
    }
  }

  return null;
}
function includesSeparators(str, separators) {
  // tslint:disable-next-line:prefer-for-of
  for (var i = 0; i < separators.length; ++i) {
    if (str.lastIndexOf(separators[i]) > 0) {
      return true;
    }
  }

  return false;
}
function splitBySeparators(str, separators) {
  var reg = new RegExp("[".concat(separators.join(), "]"));
  return str.split(reg).filter(function (token) {
    return token;
  });
}
function defaultFilterFn(input, child) {
  if (child.props.disabled) {
    return false;
  }

  var value = toArray(getPropValue(child, this.props.optionFilterProp)).join('');
  return value.toLowerCase().indexOf(input.toLowerCase()) > -1;
}
function validateOptionValue(value, props) {
  if (isSingleMode(props) || isMultiple(props)) {
    return;
  }

  if (typeof value !== 'string') {
    throw new Error("Invalid `value` of type `".concat(typeof value, "` supplied to Option, ") + "expected `string` when `tags/combobox` is `true`.");
  }
}
function saveRef(instance, name) {
  return function (node) {
    instance[name] = node;
  };
}
function generateUUID() {
  if (false) {
    return 'test-uuid';
  }

  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // tslint:disable-next-line:no-bitwise
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16); // tslint:disable-next-line:no-bitwise

    return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
  });
  return uuid;
}

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(1095);

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(1098);

__webpack_require__(6);

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(1100);

__webpack_require__(42);

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warnOnlyTreeNode = warnOnlyTreeNode;
exports.arrDel = arrDel;
exports.arrAdd = arrAdd;
exports.posToArr = posToArr;
exports.getPosition = getPosition;
exports.isTreeNode = isTreeNode;
exports.getNodeChildren = getNodeChildren;
exports.isCheckDisabled = isCheckDisabled;
exports.traverseTreeNodes = traverseTreeNodes;
exports.mapChildren = mapChildren;
exports.getDragNodesKeys = getDragNodesKeys;
exports.calcDropPosition = calcDropPosition;
exports.calcSelectedKeys = calcSelectedKeys;
exports.convertDataToTree = convertDataToTree;
exports.convertTreeToEntities = convertTreeToEntities;
exports.parseCheckedKeys = parseCheckedKeys;
exports.conductCheck = conductCheck;
exports.conductExpandParent = conductExpandParent;
exports.getDataAndAria = getDataAndAria;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _toArray = _interopRequireDefault(__webpack_require__(342));

var _warning = _interopRequireDefault(__webpack_require__(76));

var _TreeNode = _interopRequireDefault(__webpack_require__(1107));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DRAG_SIDE_RANGE = 0.25;
var DRAG_MIN_GAP = 2;
var onlyTreeNodeWarned = false;

function warnOnlyTreeNode() {
  if (onlyTreeNodeWarned) return;
  onlyTreeNodeWarned = true;
  (0, _warning.default)(false, 'Tree only accept TreeNode as children.');
}

function arrDel(list, value) {
  var clone = list.slice();
  var index = clone.indexOf(value);

  if (index >= 0) {
    clone.splice(index, 1);
  }

  return clone;
}

function arrAdd(list, value) {
  var clone = list.slice();

  if (clone.indexOf(value) === -1) {
    clone.push(value);
  }

  return clone;
}

function posToArr(pos) {
  return pos.split('-');
}

function getPosition(level, index) {
  return "".concat(level, "-").concat(index);
}

function isTreeNode(node) {
  return node && node.type && node.type.isTreeNode;
}

function getNodeChildren(children) {
  return (0, _toArray.default)(children).filter(isTreeNode);
}

function isCheckDisabled(node) {
  var _ref = node.props || {},
      disabled = _ref.disabled,
      disableCheckbox = _ref.disableCheckbox,
      checkable = _ref.checkable;

  return !!(disabled || disableCheckbox) || checkable === false;
}

function traverseTreeNodes(treeNodes, callback) {
  function processNode(node, index, parent) {
    var children = node ? node.props.children : treeNodes;
    var pos = node ? getPosition(parent.pos, index) : 0; // Filter children

    var childList = getNodeChildren(children); // Process node if is not root

    if (node) {
      var data = {
        node: node,
        index: index,
        pos: pos,
        key: node.key || pos,
        parentPos: parent.node ? parent.pos : null
      };
      callback(data);
    } // Process children node


    _react.Children.forEach(childList, function (subNode, subIndex) {
      processNode(subNode, subIndex, {
        node: node,
        pos: pos
      });
    });
  }

  processNode(null);
}
/**
 * Use `rc-util` `toArray` to get the children list which keeps the key.
 * And return single node if children is only one(This can avoid `key` missing check).
 */


function mapChildren(children, func) {
  var list = (0, _toArray.default)(children).map(func);

  if (list.length === 1) {
    return list[0];
  }

  return list;
}

function getDragNodesKeys(treeNodes, node) {
  var _node$props = node.props,
      eventKey = _node$props.eventKey,
      pos = _node$props.pos;
  var dragNodesKeys = [];
  traverseTreeNodes(treeNodes, function (_ref2) {
    var key = _ref2.key;
    dragNodesKeys.push(key);
  });
  dragNodesKeys.push(eventKey || pos);
  return dragNodesKeys;
} // Only used when drag, not affect SSR.


function calcDropPosition(event, treeNode) {
  var clientY = event.clientY;

  var _treeNode$selectHandl = treeNode.selectHandle.getBoundingClientRect(),
      top = _treeNode$selectHandl.top,
      bottom = _treeNode$selectHandl.bottom,
      height = _treeNode$selectHandl.height;

  var des = Math.max(height * DRAG_SIDE_RANGE, DRAG_MIN_GAP);

  if (clientY <= top + des) {
    return -1;
  }

  if (clientY >= bottom - des) {
    return 1;
  }

  return 0;
}
/**
 * Return selectedKeys according with multiple prop
 * @param selectedKeys
 * @param props
 * @returns [string]
 */


function calcSelectedKeys(selectedKeys, props) {
  if (!selectedKeys) return undefined;
  var multiple = props.multiple;

  if (multiple) {
    return selectedKeys.slice();
  }

  if (selectedKeys.length) {
    return [selectedKeys[0]];
  }

  return selectedKeys;
}
/**
 * Since React internal will convert key to string,
 * we need do this to avoid `checkStrictly` use number match
 */


function keyListToString(keyList) {
  if (!keyList) return keyList;
  return keyList.map(function (key) {
    return String(key);
  });
}

var internalProcessProps = function internalProcessProps(props) {
  return props;
};

function convertDataToTree(treeData, processor) {
  if (!treeData) return [];

  var _ref3 = processor || {},
      _ref3$processProps = _ref3.processProps,
      processProps = _ref3$processProps === void 0 ? internalProcessProps : _ref3$processProps;

  var list = Array.isArray(treeData) ? treeData : [treeData];
  return list.map(function (_ref4) {
    var children = _ref4.children,
        props = _objectWithoutProperties(_ref4, ["children"]);

    var childrenNodes = convertDataToTree(children, processor);
    return _react.default.createElement(_TreeNode.default, Object.assign({}, processProps(props)), childrenNodes);
  });
}
/**
 * Calculate treeNodes entities. `processTreeEntity` is used for `rc-tree-select`
 * @param treeNodes
 * @param processTreeEntity  User can customize the entity
 */


function convertTreeToEntities(treeNodes) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      initWrapper = _ref5.initWrapper,
      processEntity = _ref5.processEntity,
      onProcessFinished = _ref5.onProcessFinished;

  var posEntities = {};
  var keyEntities = {};
  var wrapper = {
    posEntities: posEntities,
    keyEntities: keyEntities
  };

  if (initWrapper) {
    wrapper = initWrapper(wrapper) || wrapper;
  }

  traverseTreeNodes(treeNodes, function (item) {
    var node = item.node,
        index = item.index,
        pos = item.pos,
        key = item.key,
        parentPos = item.parentPos;
    var entity = {
      node: node,
      index: index,
      key: key,
      pos: pos
    };
    posEntities[pos] = entity;
    keyEntities[key] = entity; // Fill children

    entity.parent = posEntities[parentPos];

    if (entity.parent) {
      entity.parent.children = entity.parent.children || [];
      entity.parent.children.push(entity);
    }

    if (processEntity) {
      processEntity(entity, wrapper);
    }
  });

  if (onProcessFinished) {
    onProcessFinished(wrapper);
  }

  return wrapper;
}
/**
 * Parse `checkedKeys` to { checkedKeys, halfCheckedKeys } style
 */


function parseCheckedKeys(keys) {
  if (!keys) {
    return null;
  } // Convert keys to object format


  var keyProps;

  if (Array.isArray(keys)) {
    // [Legacy] Follow the api doc
    keyProps = {
      checkedKeys: keys,
      halfCheckedKeys: undefined
    };
  } else if (_typeof(keys) === 'object') {
    keyProps = {
      checkedKeys: keys.checked || undefined,
      halfCheckedKeys: keys.halfChecked || undefined
    };
  } else {
    (0, _warning.default)(false, '`checkedKeys` is not an array or an object');
    return null;
  }

  keyProps.checkedKeys = keyListToString(keyProps.checkedKeys);
  keyProps.halfCheckedKeys = keyListToString(keyProps.halfCheckedKeys);
  return keyProps;
}
/**
 * Conduct check state by the keyList. It will conduct up & from the provided key.
 * If the conduct path reach the disabled or already checked / unchecked node will stop conduct.
 */


function conductCheck(
/** list of keys */
keyList,
/** is check the node or not */
isCheck,
/** parsed by `convertTreeToEntities` function in Tree */
keyEntities) {
  var checkStatus = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var checkedKeys = {};
  var halfCheckedKeys = {}; // Record the key has some child checked (include child half checked)

  (checkStatus.checkedKeys || []).forEach(function (key) {
    checkedKeys[key] = true;
  });
  (checkStatus.halfCheckedKeys || []).forEach(function (key) {
    halfCheckedKeys[key] = true;
  }); // Conduct up

  function conductUp(key) {
    if (checkedKeys[key] === isCheck) return;
    var entity = keyEntities[key];
    if (!entity) return;
    var children = entity.children,
        parent = entity.parent,
        node = entity.node;
    if (isCheckDisabled(node)) return; // Check child node checked status

    var everyChildChecked = true;
    var someChildChecked = false; // Child checked or half checked

    (children || []).filter(function (child) {
      return !isCheckDisabled(child.node);
    }).forEach(function (_ref6) {
      var childKey = _ref6.key;
      var childChecked = checkedKeys[childKey];
      var childHalfChecked = halfCheckedKeys[childKey];
      if (childChecked || childHalfChecked) someChildChecked = true;
      if (!childChecked) everyChildChecked = false;
    }); // Update checked status

    if (isCheck) {
      checkedKeys[key] = everyChildChecked;
    } else {
      checkedKeys[key] = false;
    }

    halfCheckedKeys[key] = someChildChecked;

    if (parent) {
      conductUp(parent.key);
    }
  } // Conduct down


  function conductDown(key) {
    if (checkedKeys[key] === isCheck) return;
    var entity = keyEntities[key];
    if (!entity) return;
    var children = entity.children,
        node = entity.node;
    if (isCheckDisabled(node)) return;
    checkedKeys[key] = isCheck;
    (children || []).forEach(function (child) {
      conductDown(child.key);
    });
  }

  function conduct(key) {
    var entity = keyEntities[key];

    if (!entity) {
      (0, _warning.default)(false, "'".concat(key, "' does not exist in the tree."));
      return;
    }

    var children = entity.children,
        parent = entity.parent,
        node = entity.node;
    checkedKeys[key] = isCheck;
    if (isCheckDisabled(node)) return; // Conduct down

    (children || []).filter(function (child) {
      return !isCheckDisabled(child.node);
    }).forEach(function (child) {
      conductDown(child.key);
    }); // Conduct up

    if (parent) {
      conductUp(parent.key);
    }
  }

  (keyList || []).forEach(function (key) {
    conduct(key);
  });
  var checkedKeyList = [];
  var halfCheckedKeyList = []; // Fill checked list

  Object.keys(checkedKeys).forEach(function (key) {
    if (checkedKeys[key]) {
      checkedKeyList.push(key);
    }
  }); // Fill half checked list

  Object.keys(halfCheckedKeys).forEach(function (key) {
    if (!checkedKeys[key] && halfCheckedKeys[key]) {
      halfCheckedKeyList.push(key);
    }
  });
  return {
    checkedKeys: checkedKeyList,
    halfCheckedKeys: halfCheckedKeyList
  };
}
/**
 * If user use `autoExpandParent` we should get the list of parent node
 * @param keyList
 * @param keyEntities
 */


function conductExpandParent(keyList, keyEntities) {
  var expandedKeys = {};

  function conductUp(key) {
    if (expandedKeys[key]) return;
    var entity = keyEntities[key];
    if (!entity) return;
    expandedKeys[key] = true;
    var parent = entity.parent,
        node = entity.node;
    if (node.props && node.props.disabled) return;

    if (parent) {
      conductUp(parent.key);
    }
  }

  (keyList || []).forEach(function (key) {
    conductUp(key);
  });
  return Object.keys(expandedKeys);
}
/**
 * Returns only the data- and aria- key/value pairs
 */


function getDataAndAria(props) {
  return Object.keys(props).reduce(function (prev, key) {
    if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-') {
      prev[key] = props[key];
    }

    return prev;
  }, {});
}

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(52);
var document = __webpack_require__(49).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(49);
var core = __webpack_require__(102);
var LIBRARY = __webpack_require__(144);
var wksExt = __webpack_require__(542);
var defineProperty = __webpack_require__(66).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(226)('keys');
var uid = __webpack_require__(161);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 372 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(49).document;
module.exports = document && document.documentElement;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(52);
var anObject = __webpack_require__(45);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(103)(Function.call, __webpack_require__(96).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(52);
var setPrototypeOf = __webpack_require__(374).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(105);
var defined = __webpack_require__(118);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 378 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 379 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(144);
var $export = __webpack_require__(15);
var redefine = __webpack_require__(91);
var hide = __webpack_require__(90);
var Iterators = __webpack_require__(201);
var $iterCreate = __webpack_require__(381);
var setToStringTag = __webpack_require__(198);
var getPrototypeOf = __webpack_require__(97);
var ITERATOR = __webpack_require__(56)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(164);
var descriptor = __webpack_require__(160);
var setToStringTag = __webpack_require__(198);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(90)(IteratorPrototype, __webpack_require__(56)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(277);
var defined = __webpack_require__(118);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(56)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(201);
var ITERATOR = __webpack_require__(56)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(66);
var createDesc = __webpack_require__(160);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(199);
var ITERATOR = __webpack_require__(56)('iterator');
var Iterators = __webpack_require__(201);
module.exports = __webpack_require__(102).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1211);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(70);
var toAbsoluteIndex = __webpack_require__(163);
var toLength = __webpack_require__(58);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(146);
var step = __webpack_require__(559);
var Iterators = __webpack_require__(201);
var toIObject = __webpack_require__(95);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(380)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(229);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(276)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(103);
var invoke = __webpack_require__(549);
var html = __webpack_require__(373);
var cel = __webpack_require__(369);
var global = __webpack_require__(49);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(104)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(49);
var macrotask = __webpack_require__(392).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(104)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(81);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(49);
var DESCRIPTORS = __webpack_require__(63);
var LIBRARY = __webpack_require__(144);
var $typed = __webpack_require__(283);
var hide = __webpack_require__(90);
var redefineAll = __webpack_require__(169);
var fails = __webpack_require__(51);
var anInstance = __webpack_require__(167);
var toInteger = __webpack_require__(105);
var toLength = __webpack_require__(58);
var toIndex = __webpack_require__(569);
var gOPN = __webpack_require__(165).f;
var dP = __webpack_require__(66).f;
var arrayFill = __webpack_require__(388);
var setToStringTag = __webpack_require__(198);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _tooltip = _interopRequireDefault(__webpack_require__(87));

var _configProvider = __webpack_require__(39);

var _warning = _interopRequireDefault(__webpack_require__(69));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Popover = /*#__PURE__*/function (_React$Component) {
  _inherits(Popover, _React$Component);

  var _super = _createSuper(Popover);

  function Popover() {
    var _this;

    _classCallCheck(this, Popover);

    _this = _super.apply(this, arguments);

    _this.saveTooltip = function (node) {
      _this.tooltip = node;
    };

    _this.renderPopover = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          props = __rest(_a, ["prefixCls"]);

      delete props.title;
      var prefixCls = getPrefixCls('popover', customizePrefixCls);
      return /*#__PURE__*/React.createElement(_tooltip["default"], _extends({}, props, {
        prefixCls: prefixCls,
        ref: _this.saveTooltip,
        overlay: _this.getOverlay(prefixCls)
      }));
    };

    return _this;
  }

  _createClass(Popover, [{
    key: "getPopupDomNode",
    value: function getPopupDomNode() {
      return this.tooltip.getPopupDomNode();
    }
  }, {
    key: "getOverlay",
    value: function getOverlay(prefixCls) {
      var _this$props = this.props,
          title = _this$props.title,
          content = _this$props.content;
      (0, _warning["default"])(!('overlay' in this.props), 'Popover', '`overlay` is removed, please use `content` instead, ' + 'see: https://u.ant.design/popover-content');
      return /*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-title")
      }, title), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-inner-content")
      }, content));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderPopover);
    }
  }]);

  return Popover;
}(React.Component);

exports["default"] = Popover;
Popover.defaultProps = {
  placement: 'top',
  transitionName: 'zoom-big',
  trigger: 'hover',
  mouseEnterDelay: 0.1,
  mouseLeaveDelay: 0.1,
  overlayStyle: {}
};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(77);
var normalizeHeaderName = __webpack_require__(1328);
var AxiosError = __webpack_require__(202);
var transitionalDefaults = __webpack_require__(579);
var toFormData = __webpack_require__(580);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(581);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(581);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: __webpack_require__(1340)
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(258)))

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.recommendColumns=exports.recommend=exports.listData=exports.columns=exports.dataDefault=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var dataDefault=exports.dataDefault=[{name:'',hotel:'',gender:'',age:'',position:'',level:'',yearsWork:'',hotelYearsWork:'',tel:'',notes:"",sort:0},{name:'',hotel:'',gender:'',age:'',position:'',level:'',yearsWork:'',hotelYearsWork:'',tel:'',sort:1,notes:""},{name:'',hotel:'',gender:'',age:'',position:'',level:'',yearsWork:'',hotelYearsWork:'',tel:'',sort:2,notes:""},{name:'',hotel:'',gender:'',age:'',position:'',level:'',yearsWork:'',hotelYearsWork:'',tel:'',sort:3,notes:""},{name:'',hotel:'',gender:'',age:'',position:'',level:'',yearsWork:'',hotelYearsWork:'',tel:'',sort:4,notes:""},{name:'',hotel:'',gender:'',age:'',position:'',level:'',yearsWork:'',hotelYearsWork:'',tel:'',sort:5,notes:""}];var columns=exports.columns=function columns(_ref){var sort=_ref.sort,name=_ref.name,onChange=_ref.onChange;return[{title:'',dataIndex:'index',key:'index',align:"center",width:30,render:function render(text,record,index){var props={text:1+sort>3?sort-2:1+sort,index:sort,type:'text',name:'index'};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'酒店名称',dataIndex:'hotel',key:'hotel',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:sort,type:'input',name:'hotel',onChange:onChange,totalIndex:[],compared:{title:["酒店名称"],record:_extends({},record,{name:name}),sqlName:"financePersonnel"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'员工姓名',dataIndex:'name',key:'name',width:100,align:"center",render:function render(text,record,index){var props={text:text,index:sort,type:'input',name:'name',onChange:onChange,totalIndex:[],compared:{title:["员工姓名"],record:_extends({},record,{name:name}),sqlName:"financePersonnel"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'性别',dataIndex:'gender',key:'gender',width:80,align:"center",render:function render(text,record,index){var props={text:text,index:sort,type:'input',name:'gender',onChange:onChange,totalIndex:[],compared:{title:["性别"],record:_extends({},record,{name:name}),sqlName:"financePersonnel"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'年龄',dataIndex:'age',key:'age',width:80,align:"center",render:function render(text,record,index){var props={text:text,index:sort,type:'input',name:'age',onChange:onChange,totalIndex:[],compared:{title:["年龄"],record:_extends({},record,{name:name}),sqlName:"financePersonnel"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'职位',dataIndex:'position',key:'position',width:100,align:"center",render:function render(text,record,index){var props={text:text,index:sort,type:'input',name:'position',onChange:onChange,totalIndex:[],compared:{title:["职位"],record:_extends({},record,{name:name}),sqlName:"financePersonnel"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'级别',dataIndex:'level',key:'level',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:sort,type:'input',name:'level',onChange:onChange,totalIndex:[],compared:{title:["级别"],record:_extends({},record,{name:name}),sqlName:"financePersonnel"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'工作年限',dataIndex:'yearsWork',key:'yearsWork',width:100,align:"center",render:function render(text,record,index){var props={text:text,index:sort,type:'input',name:'yearsWork',onChange:onChange,totalIndex:[],compared:{title:["工作年限"],record:_extends({},record,{name:name}),sqlName:"financePersonnel"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'本酒店工作年限',dataIndex:'hotelYearsWork',key:'hotelYearsWork',width:100,align:"center",render:function render(text,record,index){var props={text:text,index:sort,type:'input',name:'hotelYearsWork',onChange:onChange,totalIndex:[],compared:{title:["本酒店工作年限"],record:_extends({},record,{name:name}),sqlName:"financePersonnel"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'联系方式',dataIndex:'tel',key:'tel',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:sort,type:'input',name:'tel',onChange:onChange,totalIndex:[],compared:{title:["联系方式"],record:_extends({},record,{name:name}),sqlName:"financePersonnel"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];};var listData=exports.listData=[{name:"财务部潜力之星",children:3,placeholder:"员工评价（300字以内）"},{name:"财务部支援后备",children:3,placeholder:"是否有支援经验，如有，请写明何时何地何酒店，以及支援内容（300字以内）"}];var recommend=exports.recommend=[{name:'',hotel:'',gender:'',age:'',position:'',intention:'',area:'',tel:'',sort:0},{name:'',hotel:'',gender:'',age:'',position:'',intention:'',area:'',tel:'',sort:1},{name:'',hotel:'',gender:'',age:'',position:'',intention:'',area:'',tel:'',sort:2}];var recommendColumns=exports.recommendColumns=function recommendColumns(_ref2){var name=_ref2.name,onChange=_ref2.onChange;return[{title:'',dataIndex:'index',key:'index',align:"center",width:30,render:function render(text,record,index){var props={text:index+1,index:index,type:'text',name:'index'};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'员工姓名',dataIndex:'name',key:'name',width:100,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'input',name:'name',onChange:onChange,totalIndex:[],compared:{title:["员工姓名"],record:_extends({},record,{name:name}),sqlName:"financePersonnelRecommend"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'性别',dataIndex:'gender',key:'gender',width:80,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'input',name:'gender',onChange:onChange,totalIndex:[],compared:{title:["性别"],record:_extends({},record,{name:name}),sqlName:"financePersonnelRecommend"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'年龄',dataIndex:'age',key:'age',width:80,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'input',name:'age',onChange:onChange,totalIndex:[],compared:{title:["年龄"],record:_extends({},record,{name:name}),sqlName:"financePersonnelRecommend"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'现酒店',dataIndex:'hotel',key:'hotel',width:300,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'input',name:'hotel',onChange:onChange,totalIndex:[],compared:{title:["现酒店"],record:_extends({},record,{name:name}),sqlName:"financePersonnelRecommend"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'现职位',dataIndex:'position',key:'position',width:100,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'input',name:'position',onChange:onChange,totalIndex:[],compared:{title:["现职位"],record:_extends({},record,{name:name}),sqlName:"financePersonnelRecommend"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'意向区域',dataIndex:'area',key:'area',width:100,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'input',name:'area',onChange:onChange,totalIndex:[],compared:{title:["意向区域"],record:_extends({},record,{name:name}),sqlName:"financePersonnelRecommend"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'意向职位',dataIndex:'intention',key:'intention',width:100,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'input',name:'intention',onChange:onChange,totalIndex:[],compared:{title:["意向职位"],record:_extends({},record,{name:name}),sqlName:"financePersonnelRecommend"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'联系方式（手机）',dataIndex:'tel',key:'tel',width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'input',name:'tel',onChange:onChange,totalIndex:[],compared:{title:["联系方式（手机）"],record:_extends({},record,{name:name}),sqlName:"financePersonnelRecommend"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];};exports.default=dataDefault;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.recommendColumns=exports.recommend=exports.listData=exports.columns=exports.dataDefault=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var dataDefault=exports.dataDefault=[{name:'',hotel:'',gender:'',age:'',position:'',level:'',yearsWork:'',hotelYearsWork:'',tel:'',notes:"",sort:0},{name:'',hotel:'',gender:'',age:'',position:'',level:'',yearsWork:'',hotelYearsWork:'',tel:'',sort:1,notes:""},{name:'',hotel:'',gender:'',age:'',position:'',level:'',yearsWork:'',hotelYearsWork:'',tel:'',sort:2,notes:""},{name:'',hotel:'',gender:'',age:'',position:'',level:'',yearsWork:'',hotelYearsWork:'',tel:'',sort:3,notes:""},{name:'',hotel:'',gender:'',age:'',position:'',level:'',yearsWork:'',hotelYearsWork:'',tel:'',sort:4,notes:""},{name:'',hotel:'',gender:'',age:'',position:'',level:'',yearsWork:'',hotelYearsWork:'',tel:'',sort:5,notes:""}];var columns=exports.columns=function columns(_ref){var sort=_ref.sort,name=_ref.name,onChange=_ref.onChange;return[{title:'',dataIndex:'index',key:'index',align:"center",width:30,render:function render(text,record,index){var props={text:1+sort>3?sort-2:1+sort,index:sort,type:'text',name:'index'};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'酒店名称',dataIndex:'hotel',key:'hotel',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:sort,type:'input',name:'hotel',onChange:onChange,totalIndex:[],compared:{title:["酒店名称"],record:_extends({},record,{name:name}),sqlName:"financePersonnel"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'员工姓名',dataIndex:'name',key:'name',width:100,align:"center",render:function render(text,record,index){var props={text:text,index:sort,type:'input',name:'name',onChange:onChange,totalIndex:[],compared:{title:["员工姓名"],record:_extends({},record,{name:name}),sqlName:"financePersonnel"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'性别',dataIndex:'gender',key:'gender',width:80,align:"center",render:function render(text,record,index){var props={text:text,index:sort,type:'input',name:'gender',onChange:onChange,totalIndex:[],compared:{title:["性别"],record:_extends({},record,{name:name}),sqlName:"financePersonnel"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'年龄',dataIndex:'age',key:'age',width:80,align:"center",render:function render(text,record,index){var props={text:text,index:sort,type:'input',name:'age',onChange:onChange,totalIndex:[],compared:{title:["年龄"],record:_extends({},record,{name:name}),sqlName:"financePersonnel"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'职位',dataIndex:'position',key:'position',width:100,align:"center",render:function render(text,record,index){var props={text:text,index:sort,type:'input',name:'position',onChange:onChange,totalIndex:[],compared:{title:["职位"],record:_extends({},record,{name:name}),sqlName:"financePersonnel"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'级别',dataIndex:'level',key:'level',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:sort,type:'input',name:'level',onChange:onChange,totalIndex:[],compared:{title:["级别"],record:_extends({},record,{name:name}),sqlName:"financePersonnel"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'工作年限',dataIndex:'yearsWork',key:'yearsWork',width:100,align:"center",render:function render(text,record,index){var props={text:text,index:sort,type:'input',name:'yearsWork',onChange:onChange,totalIndex:[],compared:{title:["工作年限"],record:_extends({},record,{name:name}),sqlName:"financePersonnel"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'本酒店工作年限',dataIndex:'hotelYearsWork',key:'hotelYearsWork',width:100,align:"center",render:function render(text,record,index){var props={text:text,index:sort,type:'input',name:'hotelYearsWork',onChange:onChange,totalIndex:[],compared:{title:["本酒店工作年限"],record:_extends({},record,{name:name}),sqlName:"financePersonnel"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'联系方式',dataIndex:'tel',key:'tel',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:sort,type:'input',name:'tel',onChange:onChange,totalIndex:[],compared:{title:["联系方式"],record:_extends({},record,{name:name}),sqlName:"financePersonnel"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];};var listData=exports.listData=[{name:"销售部潜力之星",children:3,placeholder:"员工评价（300字以内）"},{name:"销售部支援后备",children:3,placeholder:"是否有支援经验，如有，请写明何时何地何酒店，以及支援内容（300字以内）"}];var recommend=exports.recommend=[{name:'',hotel:'',gender:'',age:'',position:'',intention:'',area:'',tel:'',sort:0},{name:'',hotel:'',gender:'',age:'',position:'',intention:'',area:'',tel:'',sort:1},{name:'',hotel:'',gender:'',age:'',position:'',intention:'',area:'',tel:'',sort:2}];var recommendColumns=exports.recommendColumns=function recommendColumns(_ref2){var name=_ref2.name,onChange=_ref2.onChange;return[{title:'',dataIndex:'index',key:'index',align:"center",width:30,render:function render(text,record,index){var props={text:index+1,index:index,type:'text',name:'index'};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'员工姓名',dataIndex:'name',key:'name',width:100,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'input',name:'name',onChange:onChange,totalIndex:[],compared:{title:["员工姓名"],record:_extends({},record,{name:name}),sqlName:"financePersonnelRecommend"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'性别',dataIndex:'gender',key:'gender',width:80,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'input',name:'gender',onChange:onChange,totalIndex:[],compared:{title:["性别"],record:_extends({},record,{name:name}),sqlName:"financePersonnelRecommend"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'年龄',dataIndex:'age',key:'age',width:80,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'input',name:'age',onChange:onChange,totalIndex:[],compared:{title:["年龄"],record:_extends({},record,{name:name}),sqlName:"financePersonnelRecommend"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'现酒店',dataIndex:'hotel',key:'hotel',width:300,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'input',name:'hotel',onChange:onChange,totalIndex:[],compared:{title:["现酒店"],record:_extends({},record,{name:name}),sqlName:"financePersonnelRecommend"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'现职位',dataIndex:'position',key:'position',width:100,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'input',name:'position',onChange:onChange,totalIndex:[],compared:{title:["现职位"],record:_extends({},record,{name:name}),sqlName:"financePersonnelRecommend"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'意向区域',dataIndex:'area',key:'area',width:100,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'input',name:'area',onChange:onChange,totalIndex:[],compared:{title:["意向区域"],record:_extends({},record,{name:name}),sqlName:"financePersonnelRecommend"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'意向职位',dataIndex:'intention',key:'intention',width:100,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'input',name:'intention',onChange:onChange,totalIndex:[],compared:{title:["意向职位"],record:_extends({},record,{name:name}),sqlName:"financePersonnelRecommend"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'联系方式（手机）',dataIndex:'tel',key:'tel',width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'input',name:'tel',onChange:onChange,totalIndex:[],compared:{title:["联系方式（手机）"],record:_extends({},record,{name:name}),sqlName:"financePersonnelRecommend"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];};exports.default=dataDefault;

/***/ }),
/* 400 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validProgress = validProgress;

// eslint-disable-next-line import/prefer-default-export
function validProgress(progress) {
  if (!progress || progress < 0) {
    return 0;
  }

  if (progress > 100) {
    return 100;
  }

  return progress;
}

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){var _props=this.props,date=_props.date,onChange=_props.onChange;return _react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(date,"YYYY-MM"),format:'YYYY-MM',onChange:onChange});}}]);return App;}(_react.Component);exports.default=App;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var dataDefault=exports.dataDefault=[{"name":"Jan","sort":0,"month_status":"Budget","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Jan","sort":1,"month_status":"Actual","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Jan","sort":2,"month_status":"Actual Last Year","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Feb","sort":3,"month_status":"Budget","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Feb","sort":4,"month_status":"Actual","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Feb","sort":5,"month_status":"Actual Last Year","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Mar","sort":6,"month_status":"Budget","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Mar","sort":7,"month_status":"Actual","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Mar","sort":8,"month_status":"Actual Last Year","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Apr","sort":9,"month_status":"Budget","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Apr","sort":10,"month_status":"Actual","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Apr","sort":11,"month_status":"Actual Last Year","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"May","sort":12,"month_status":"Budget","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"May","sort":13,"month_status":"Actual","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"May","sort":14,"month_status":"Actual Last Year","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Jun","sort":15,"month_status":"","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Jun","sort":16,"month_status":"Actual","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Jun","sort":17,"month_status":"Actual Last Year","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Jul","sort":18,"month_status":"","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Jul","sort":19,"month_status":"","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Jul","sort":20,"month_status":"Actual Last Year","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Aug","sort":21,"month_status":"","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Aug","sort":22,"month_status":"","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Aug","sort":23,"month_status":"Actual Last Year","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Sep","sort":24,"month_status":"","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Sep","sort":25,"month_status":"","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Sep","sort":26,"month_status":"Actual Last Year","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Oct","sort":27,"month_status":"","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Oct","sort":28,"month_status":"","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Oct","sort":29,"month_status":"Actual Last Year","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Nov","sort":30,"month_status":"","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Nov","sort":31,"month_status":"","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Nov","sort":32,"month_status":"Actual Last Year","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Dec","sort":33,"month_status":"","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Dec","sort":34,"month_status":"","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Dec","sort":35,"month_status":"Actual Last Year","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"YTD","sort":36,"month_status":"","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"YTD","sort":37,"month_status":"","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"YTD","sort":38,"month_status":"Actual Last Year","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Year End","sort":39,"month_status":"","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Year End","sort":40,"month_status":"Act/Fcst ","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Year End","sort":41,"month_status":"Actual Last Year","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"% to Budget","sort":42,"month_status":"","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"% to Budget","sort":43,"month_status":"","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"% to YTD <br/> Last Year","sort":44,"month_status":"","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Year End Mix %","sort":45,"month_status":"","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0},{"name":"Year End Mix %","sort":46,"month_status":"","best_rn":0,"best_arr":0,"best_rev":0,"corporate_rn":0,"corporate_arr":0,"corporate_rev":0,"government_rn":0,"government_arr":0,"government_rev":0,"packges_rn":0,"packges_arr":0,"packges_rev":0,"wholesale_rn":0,"wholesale_arr":0,"wholesale_rev":0,"commerce_rn":0,"commerce_arr":0,"commerce_rev":0,"discounts_rn":0,"discounts_arr":0,"discounts_rev":0,"total_rn":0,"total_arr":0,"total_rev":0,"business_rn":0,"business_arr":0,"business_rev":0,"leisure_rn":0,"leisure_arr":0,"leisure_rev":0,"group_total_rn":0,"group_total_arr":0,"group_total_rev":0,"contracts_rn":0,"contracts_arr":0,"contracts_rev":0,"others_rev":0,"grand_rn":0,"grand_arr":0,"grand_rev":0,"grand_occ":0,"grand_revpar":0,"grand_rms":0}];var data4_1_2=exports.data4_1_2=[{name:'Best Rates',comments:"",strategy:"",plans:"",target:0,total:0,first:0,second:0,third:0},{name:'Corporate Negotiated',comments:"",strategy:"",plans:"",target:0,total:0,first:0,second:0,third:0},{name:'Government',comments:"",strategy:"",plans:"",target:0,total:0,first:0,second:0,third:0},{name:'Packages',comments:"",strategy:"",plans:"",target:0,total:0,first:0,second:0,third:0},{name:'Wholesale',comments:"",strategy:"",plans:"",target:0,total:0,first:0,second:0,third:0},{name:'E-Commerce',comments:"",strategy:"",plans:"",target:0,total:0,first:0,second:0,third:0},{name:'Discounts',comments:"",strategy:"",plans:"",target:0,total:0,first:0,second:0,third:0},{name:'Group Business',comments:"",strategy:"",plans:"",target:0,total:0,first:0,second:0,third:0},{name:'Group Leisure',comments:"",strategy:"",plans:"",target:0,total:0,first:0,second:0,third:0},{name:'Group Government',comments:"",strategy:"",plans:"",target:0,total:0,first:0,second:0,third:0},{name:'Contracts',comments:"",strategy:"",plans:"",target:0,total:0,first:0,second:0,third:0},{name:'Others',comments:"",strategy:"",plans:"",target:0,total:0,first:0,second:0,third:0},{name:'Total',comments:"",strategy:"",plans:"",target:0,total:0,first:0,second:0,third:0}];

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// https://github.com/mziccard/node-timsort
var DEFAULT_MIN_MERGE = 32;
var DEFAULT_MIN_GALLOPING = 7;
var DEFAULT_TMP_STORAGE_LENGTH = 256;

function minRunLength(n) {
  var r = 0;

  while (n >= DEFAULT_MIN_MERGE) {
    r |= n & 1;
    n >>= 1;
  }

  return n + r;
}

function makeAscendingRun(array, lo, hi, compare) {
  var runHi = lo + 1;

  if (runHi === hi) {
    return 1;
  }

  if (compare(array[runHi++], array[lo]) < 0) {
    while (runHi < hi && compare(array[runHi], array[runHi - 1]) < 0) {
      runHi++;
    }

    reverseRun(array, lo, runHi);
  } else {
    while (runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0) {
      runHi++;
    }
  }

  return runHi - lo;
}

function reverseRun(array, lo, hi) {
  hi--;

  while (lo < hi) {
    var t = array[lo];
    array[lo++] = array[hi];
    array[hi--] = t;
  }
}

function binaryInsertionSort(array, lo, hi, start, compare) {
  if (start === lo) {
    start++;
  }

  for (; start < hi; start++) {
    var pivot = array[start];
    var left = lo;
    var right = start;
    var mid;

    while (left < right) {
      mid = left + right >>> 1;

      if (compare(pivot, array[mid]) < 0) {
        right = mid;
      } else {
        left = mid + 1;
      }
    }

    var n = start - left;

    switch (n) {
      case 3:
        array[left + 3] = array[left + 2];

      case 2:
        array[left + 2] = array[left + 1];

      case 1:
        array[left + 1] = array[left];
        break;

      default:
        while (n > 0) {
          array[left + n] = array[left + n - 1];
          n--;
        }

    }

    array[left] = pivot;
  }
}

function gallopLeft(value, array, start, length, hint, compare) {
  var lastOffset = 0;
  var maxOffset = 0;
  var offset = 1;

  if (compare(value, array[start + hint]) > 0) {
    maxOffset = length - hint;

    while (offset < maxOffset && compare(value, array[start + hint + offset]) > 0) {
      lastOffset = offset;
      offset = (offset << 1) + 1;

      if (offset <= 0) {
        offset = maxOffset;
      }
    }

    if (offset > maxOffset) {
      offset = maxOffset;
    }

    lastOffset += hint;
    offset += hint;
  } else {
    maxOffset = hint + 1;

    while (offset < maxOffset && compare(value, array[start + hint - offset]) <= 0) {
      lastOffset = offset;
      offset = (offset << 1) + 1;

      if (offset <= 0) {
        offset = maxOffset;
      }
    }

    if (offset > maxOffset) {
      offset = maxOffset;
    }

    var tmp = lastOffset;
    lastOffset = hint - offset;
    offset = hint - tmp;
  }

  lastOffset++;

  while (lastOffset < offset) {
    var m = lastOffset + (offset - lastOffset >>> 1);

    if (compare(value, array[start + m]) > 0) {
      lastOffset = m + 1;
    } else {
      offset = m;
    }
  }

  return offset;
}

function gallopRight(value, array, start, length, hint, compare) {
  var lastOffset = 0;
  var maxOffset = 0;
  var offset = 1;

  if (compare(value, array[start + hint]) < 0) {
    maxOffset = hint + 1;

    while (offset < maxOffset && compare(value, array[start + hint - offset]) < 0) {
      lastOffset = offset;
      offset = (offset << 1) + 1;

      if (offset <= 0) {
        offset = maxOffset;
      }
    }

    if (offset > maxOffset) {
      offset = maxOffset;
    }

    var tmp = lastOffset;
    lastOffset = hint - offset;
    offset = hint - tmp;
  } else {
    maxOffset = length - hint;

    while (offset < maxOffset && compare(value, array[start + hint + offset]) >= 0) {
      lastOffset = offset;
      offset = (offset << 1) + 1;

      if (offset <= 0) {
        offset = maxOffset;
      }
    }

    if (offset > maxOffset) {
      offset = maxOffset;
    }

    lastOffset += hint;
    offset += hint;
  }

  lastOffset++;

  while (lastOffset < offset) {
    var m = lastOffset + (offset - lastOffset >>> 1);

    if (compare(value, array[start + m]) < 0) {
      offset = m;
    } else {
      lastOffset = m + 1;
    }
  }

  return offset;
}

function TimSort(array, compare) {
  var minGallop = DEFAULT_MIN_GALLOPING;
  var length = 0;
  var tmpStorageLength = DEFAULT_TMP_STORAGE_LENGTH;
  var stackLength = 0;
  var runStart;
  var runLength;
  var stackSize = 0;
  length = array.length;

  if (length < 2 * DEFAULT_TMP_STORAGE_LENGTH) {
    tmpStorageLength = length >>> 1;
  }

  var tmp = [];
  stackLength = length < 120 ? 5 : length < 1542 ? 10 : length < 119151 ? 19 : 40;
  runStart = [];
  runLength = [];

  function pushRun(_runStart, _runLength) {
    runStart[stackSize] = _runStart;
    runLength[stackSize] = _runLength;
    stackSize += 1;
  }

  function mergeRuns() {
    while (stackSize > 1) {
      var n = stackSize - 2;

      if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
        if (runLength[n - 1] < runLength[n + 1]) {
          n--;
        }
      } else if (runLength[n] > runLength[n + 1]) {
        break;
      }

      mergeAt(n);
    }
  }

  function forceMergeRuns() {
    while (stackSize > 1) {
      var n = stackSize - 2;

      if (n > 0 && runLength[n - 1] < runLength[n + 1]) {
        n--;
      }

      mergeAt(n);
    }
  }

  function mergeAt(i) {
    var start1 = runStart[i];
    var length1 = runLength[i];
    var start2 = runStart[i + 1];
    var length2 = runLength[i + 1];
    runLength[i] = length1 + length2;

    if (i === stackSize - 3) {
      runStart[i + 1] = runStart[i + 2];
      runLength[i + 1] = runLength[i + 2];
    }

    stackSize--;
    var k = gallopRight(array[start2], array, start1, length1, 0, compare);
    start1 += k;
    length1 -= k;

    if (length1 === 0) {
      return;
    }

    length2 = gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);

    if (length2 === 0) {
      return;
    }

    if (length1 <= length2) {
      mergeLow(start1, length1, start2, length2);
    } else {
      mergeHigh(start1, length1, start2, length2);
    }
  }

  function mergeLow(start1, length1, start2, length2) {
    var i = 0;

    for (i = 0; i < length1; i++) {
      tmp[i] = array[start1 + i];
    }

    var cursor1 = 0;
    var cursor2 = start2;
    var dest = start1;
    array[dest++] = array[cursor2++];

    if (--length2 === 0) {
      for (i = 0; i < length1; i++) {
        array[dest + i] = tmp[cursor1 + i];
      }

      return;
    }

    if (length1 === 1) {
      for (i = 0; i < length2; i++) {
        array[dest + i] = array[cursor2 + i];
      }

      array[dest + length2] = tmp[cursor1];
      return;
    }

    var _minGallop = minGallop;
    var count1;
    var count2;
    var exit;

    while (1) {
      count1 = 0;
      count2 = 0;
      exit = false;

      do {
        if (compare(array[cursor2], tmp[cursor1]) < 0) {
          array[dest++] = array[cursor2++];
          count2++;
          count1 = 0;

          if (--length2 === 0) {
            exit = true;
            break;
          }
        } else {
          array[dest++] = tmp[cursor1++];
          count1++;
          count2 = 0;

          if (--length1 === 1) {
            exit = true;
            break;
          }
        }
      } while ((count1 | count2) < _minGallop);

      if (exit) {
        break;
      }

      do {
        count1 = gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);

        if (count1 !== 0) {
          for (i = 0; i < count1; i++) {
            array[dest + i] = tmp[cursor1 + i];
          }

          dest += count1;
          cursor1 += count1;
          length1 -= count1;

          if (length1 <= 1) {
            exit = true;
            break;
          }
        }

        array[dest++] = array[cursor2++];

        if (--length2 === 0) {
          exit = true;
          break;
        }

        count2 = gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);

        if (count2 !== 0) {
          for (i = 0; i < count2; i++) {
            array[dest + i] = array[cursor2 + i];
          }

          dest += count2;
          cursor2 += count2;
          length2 -= count2;

          if (length2 === 0) {
            exit = true;
            break;
          }
        }

        array[dest++] = tmp[cursor1++];

        if (--length1 === 1) {
          exit = true;
          break;
        }

        _minGallop--;
      } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);

      if (exit) {
        break;
      }

      if (_minGallop < 0) {
        _minGallop = 0;
      }

      _minGallop += 2;
    }

    minGallop = _minGallop;
    minGallop < 1 && (minGallop = 1);

    if (length1 === 1) {
      for (i = 0; i < length2; i++) {
        array[dest + i] = array[cursor2 + i];
      }

      array[dest + length2] = tmp[cursor1];
    } else if (length1 === 0) {
      throw new Error(); // throw new Error('mergeLow preconditions were not respected');
    } else {
      for (i = 0; i < length1; i++) {
        array[dest + i] = tmp[cursor1 + i];
      }
    }
  }

  function mergeHigh(start1, length1, start2, length2) {
    var i = 0;

    for (i = 0; i < length2; i++) {
      tmp[i] = array[start2 + i];
    }

    var cursor1 = start1 + length1 - 1;
    var cursor2 = length2 - 1;
    var dest = start2 + length2 - 1;
    var customCursor = 0;
    var customDest = 0;
    array[dest--] = array[cursor1--];

    if (--length1 === 0) {
      customCursor = dest - (length2 - 1);

      for (i = 0; i < length2; i++) {
        array[customCursor + i] = tmp[i];
      }

      return;
    }

    if (length2 === 1) {
      dest -= length1;
      cursor1 -= length1;
      customDest = dest + 1;
      customCursor = cursor1 + 1;

      for (i = length1 - 1; i >= 0; i--) {
        array[customDest + i] = array[customCursor + i];
      }

      array[dest] = tmp[cursor2];
      return;
    }

    var _minGallop = minGallop;

    while (true) {
      var count1 = 0;
      var count2 = 0;
      var exit = false;

      do {
        if (compare(tmp[cursor2], array[cursor1]) < 0) {
          array[dest--] = array[cursor1--];
          count1++;
          count2 = 0;

          if (--length1 === 0) {
            exit = true;
            break;
          }
        } else {
          array[dest--] = tmp[cursor2--];
          count2++;
          count1 = 0;

          if (--length2 === 1) {
            exit = true;
            break;
          }
        }
      } while ((count1 | count2) < _minGallop);

      if (exit) {
        break;
      }

      do {
        count1 = length1 - gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);

        if (count1 !== 0) {
          dest -= count1;
          cursor1 -= count1;
          length1 -= count1;
          customDest = dest + 1;
          customCursor = cursor1 + 1;

          for (i = count1 - 1; i >= 0; i--) {
            array[customDest + i] = array[customCursor + i];
          }

          if (length1 === 0) {
            exit = true;
            break;
          }
        }

        array[dest--] = tmp[cursor2--];

        if (--length2 === 1) {
          exit = true;
          break;
        }

        count2 = length2 - gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);

        if (count2 !== 0) {
          dest -= count2;
          cursor2 -= count2;
          length2 -= count2;
          customDest = dest + 1;
          customCursor = cursor2 + 1;

          for (i = 0; i < count2; i++) {
            array[customDest + i] = tmp[customCursor + i];
          }

          if (length2 <= 1) {
            exit = true;
            break;
          }
        }

        array[dest--] = array[cursor1--];

        if (--length1 === 0) {
          exit = true;
          break;
        }

        _minGallop--;
      } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);

      if (exit) {
        break;
      }

      if (_minGallop < 0) {
        _minGallop = 0;
      }

      _minGallop += 2;
    }

    minGallop = _minGallop;

    if (minGallop < 1) {
      minGallop = 1;
    }

    if (length2 === 1) {
      dest -= length1;
      cursor1 -= length1;
      customDest = dest + 1;
      customCursor = cursor1 + 1;

      for (i = length1 - 1; i >= 0; i--) {
        array[customDest + i] = array[customCursor + i];
      }

      array[dest] = tmp[cursor2];
    } else if (length2 === 0) {
      throw new Error(); // throw new Error('mergeHigh preconditions were not respected');
    } else {
      customCursor = dest - (length2 - 1);

      for (i = 0; i < length2; i++) {
        array[customCursor + i] = tmp[i];
      }
    }
  }

  this.mergeRuns = mergeRuns;
  this.forceMergeRuns = forceMergeRuns;
  this.pushRun = pushRun;
}

function sort(array, compare, lo, hi) {
  if (!lo) {
    lo = 0;
  }

  if (!hi) {
    hi = array.length;
  }

  var remaining = hi - lo;

  if (remaining < 2) {
    return;
  }

  var runLength = 0;

  if (remaining < DEFAULT_MIN_MERGE) {
    runLength = makeAscendingRun(array, lo, hi, compare);
    binaryInsertionSort(array, lo, hi, lo + runLength, compare);
    return;
  }

  var ts = new TimSort(array, compare);
  var minRun = minRunLength(remaining);

  do {
    runLength = makeAscendingRun(array, lo, hi, compare);

    if (runLength < minRun) {
      var force = remaining;

      if (force > minRun) {
        force = minRun;
      }

      binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
      runLength = force;
    }

    ts.pushRun(lo, runLength);
    ts.mergeRuns();
    remaining -= runLength;
    lo += runLength;
  } while (remaining !== 0);

  ts.forceMergeRuns();
}

module.exports = sort;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var fixShadow = __webpack_require__(618);

var _constant = __webpack_require__(294);

var ContextCachedBy = _constant.ContextCachedBy;
var STYLE_COMMON_PROPS = [['shadowBlur', 0], ['shadowOffsetX', 0], ['shadowOffsetY', 0], ['shadowColor', '#000'], ['lineCap', 'butt'], ['lineJoin', 'miter'], ['miterLimit', 10]]; // var SHADOW_PROPS = STYLE_COMMON_PROPS.slice(0, 4);
// var LINE_PROPS = STYLE_COMMON_PROPS.slice(4);

var Style = function (opts) {
  this.extendFrom(opts, false);
};

function createLinearGradient(ctx, obj, rect) {
  var x = obj.x == null ? 0 : obj.x;
  var x2 = obj.x2 == null ? 1 : obj.x2;
  var y = obj.y == null ? 0 : obj.y;
  var y2 = obj.y2 == null ? 0 : obj.y2;

  if (!obj.global) {
    x = x * rect.width + rect.x;
    x2 = x2 * rect.width + rect.x;
    y = y * rect.height + rect.y;
    y2 = y2 * rect.height + rect.y;
  } // Fix NaN when rect is Infinity


  x = isNaN(x) ? 0 : x;
  x2 = isNaN(x2) ? 1 : x2;
  y = isNaN(y) ? 0 : y;
  y2 = isNaN(y2) ? 0 : y2;
  var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
  return canvasGradient;
}

function createRadialGradient(ctx, obj, rect) {
  var width = rect.width;
  var height = rect.height;
  var min = Math.min(width, height);
  var x = obj.x == null ? 0.5 : obj.x;
  var y = obj.y == null ? 0.5 : obj.y;
  var r = obj.r == null ? 0.5 : obj.r;

  if (!obj.global) {
    x = x * width + rect.x;
    y = y * height + rect.y;
    r = r * min;
  }

  var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
  return canvasGradient;
}

Style.prototype = {
  constructor: Style,

  /**
   * @type {string}
   */
  fill: '#000',

  /**
   * @type {string}
   */
  stroke: null,

  /**
   * @type {number}
   */
  opacity: 1,

  /**
   * @type {number}
   */
  fillOpacity: null,

  /**
   * @type {number}
   */
  strokeOpacity: null,

  /**
   * `true` is not supported.
   * `false`/`null`/`undefined` are the same.
   * `false` is used to remove lineDash in some
   * case that `null`/`undefined` can not be set.
   * (e.g., emphasis.lineStyle in echarts)
   * @type {Array.<number>|boolean}
   */
  lineDash: null,

  /**
   * @type {number}
   */
  lineDashOffset: 0,

  /**
   * @type {number}
   */
  shadowBlur: 0,

  /**
   * @type {number}
   */
  shadowOffsetX: 0,

  /**
   * @type {number}
   */
  shadowOffsetY: 0,

  /**
   * @type {number}
   */
  lineWidth: 1,

  /**
   * If stroke ignore scale
   * @type {Boolean}
   */
  strokeNoScale: false,
  // Bounding rect text configuration
  // Not affected by element transform

  /**
   * @type {string}
   */
  text: null,

  /**
   * If `fontSize` or `fontFamily` exists, `font` will be reset by
   * `fontSize`, `fontStyle`, `fontWeight`, `fontFamily`.
   * So do not visit it directly in upper application (like echarts),
   * but use `contain/text#makeFont` instead.
   * @type {string}
   */
  font: null,

  /**
   * The same as font. Use font please.
   * @deprecated
   * @type {string}
   */
  textFont: null,

  /**
   * It helps merging respectively, rather than parsing an entire font string.
   * @type {string}
   */
  fontStyle: null,

  /**
   * It helps merging respectively, rather than parsing an entire font string.
   * @type {string}
   */
  fontWeight: null,

  /**
   * It helps merging respectively, rather than parsing an entire font string.
   * Should be 12 but not '12px'.
   * @type {number}
   */
  fontSize: null,

  /**
   * It helps merging respectively, rather than parsing an entire font string.
   * @type {string}
   */
  fontFamily: null,

  /**
   * Reserved for special functinality, like 'hr'.
   * @type {string}
   */
  textTag: null,

  /**
   * @type {string}
   */
  textFill: '#000',

  /**
   * @type {string}
   */
  textStroke: null,

  /**
   * @type {number}
   */
  textWidth: null,

  /**
   * Only for textBackground.
   * @type {number}
   */
  textHeight: null,

  /**
   * textStroke may be set as some color as a default
   * value in upper applicaion, where the default value
   * of textStrokeWidth should be 0 to make sure that
   * user can choose to do not use text stroke.
   * @type {number}
   */
  textStrokeWidth: 0,

  /**
   * @type {number}
   */
  textLineHeight: null,

  /**
   * 'inside', 'left', 'right', 'top', 'bottom'
   * [x, y]
   * Based on x, y of rect.
   * @type {string|Array.<number>}
   * @default 'inside'
   */
  textPosition: 'inside',

  /**
   * If not specified, use the boundingRect of a `displayable`.
   * @type {Object}
   */
  textRect: null,

  /**
   * [x, y]
   * @type {Array.<number>}
   */
  textOffset: null,

  /**
   * @type {string}
   */
  textAlign: null,

  /**
   * @type {string}
   */
  textVerticalAlign: null,

  /**
   * @type {number}
   */
  textDistance: 5,

  /**
   * @type {string}
   */
  textShadowColor: 'transparent',

  /**
   * @type {number}
   */
  textShadowBlur: 0,

  /**
   * @type {number}
   */
  textShadowOffsetX: 0,

  /**
   * @type {number}
   */
  textShadowOffsetY: 0,

  /**
   * @type {string}
   */
  textBoxShadowColor: 'transparent',

  /**
   * @type {number}
   */
  textBoxShadowBlur: 0,

  /**
   * @type {number}
   */
  textBoxShadowOffsetX: 0,

  /**
   * @type {number}
   */
  textBoxShadowOffsetY: 0,

  /**
   * Whether transform text.
   * Only available in Path and Image element,
   * where the text is called as `RectText`.
   * @type {boolean}
   */
  transformText: false,

  /**
   * Text rotate around position of Path or Image.
   * The origin of the rotation can be specified by `textOrigin`.
   * Only available in Path and Image element,
   * where the text is called as `RectText`.
   */
  textRotation: 0,

  /**
   * Text origin of text rotation.
   * Useful in the case like label rotation of circular symbol.
   * Only available in Path and Image element, where the text is called
   * as `RectText` and the element is called as "host element".
   * The value can be:
   * + If specified as a coordinate like `[10, 40]`, it is the `[x, y]`
   * base on the left-top corner of the rect of its host element.
   * + If specified as a string `center`, it is the center of the rect of
   * its host element.
   * + By default, this origin is the `textPosition`.
   * @type {string|Array.<number>}
   */
  textOrigin: null,

  /**
   * @type {string}
   */
  textBackgroundColor: null,

  /**
   * @type {string}
   */
  textBorderColor: null,

  /**
   * @type {number}
   */
  textBorderWidth: 0,

  /**
   * @type {number}
   */
  textBorderRadius: 0,

  /**
   * Can be `2` or `[2, 4]` or `[2, 3, 4, 5]`
   * @type {number|Array.<number>}
   */
  textPadding: null,

  /**
   * Text styles for rich text.
   * @type {Object}
   */
  rich: null,

  /**
   * {outerWidth, outerHeight, ellipsis, placeholder}
   * @type {Object}
   */
  truncate: null,

  /**
   * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
   * @type {string}
   */
  blend: null,

  /**
   * @param {CanvasRenderingContext2D} ctx
   */
  bind: function (ctx, el, prevEl) {
    var style = this;
    var prevStyle = prevEl && prevEl.style; // If no prevStyle, it means first draw.
    // Only apply cache if the last time cachced by this function.

    var notCheckCache = !prevStyle || ctx.__attrCachedBy !== ContextCachedBy.STYLE_BIND;
    ctx.__attrCachedBy = ContextCachedBy.STYLE_BIND;

    for (var i = 0; i < STYLE_COMMON_PROPS.length; i++) {
      var prop = STYLE_COMMON_PROPS[i];
      var styleName = prop[0];

      if (notCheckCache || style[styleName] !== prevStyle[styleName]) {
        // FIXME Invalid property value will cause style leak from previous element.
        ctx[styleName] = fixShadow(ctx, styleName, style[styleName] || prop[1]);
      }
    }

    if (notCheckCache || style.fill !== prevStyle.fill) {
      ctx.fillStyle = style.fill;
    }

    if (notCheckCache || style.stroke !== prevStyle.stroke) {
      ctx.strokeStyle = style.stroke;
    }

    if (notCheckCache || style.opacity !== prevStyle.opacity) {
      ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
    }

    if (notCheckCache || style.blend !== prevStyle.blend) {
      ctx.globalCompositeOperation = style.blend || 'source-over';
    }

    if (this.hasStroke()) {
      var lineWidth = style.lineWidth;
      ctx.lineWidth = lineWidth / (this.strokeNoScale && el && el.getLineScale ? el.getLineScale() : 1);
    }
  },
  hasFill: function () {
    var fill = this.fill;
    return fill != null && fill !== 'none';
  },
  hasStroke: function () {
    var stroke = this.stroke;
    return stroke != null && stroke !== 'none' && this.lineWidth > 0;
  },

  /**
   * Extend from other style
   * @param {zrender/graphic/Style} otherStyle
   * @param {boolean} overwrite true: overwrirte any way.
   *                            false: overwrite only when !target.hasOwnProperty
   *                            others: overwrite when property is not null/undefined.
   */
  extendFrom: function (otherStyle, overwrite) {
    if (otherStyle) {
      for (var name in otherStyle) {
        if (otherStyle.hasOwnProperty(name) && (overwrite === true || (overwrite === false ? !this.hasOwnProperty(name) : otherStyle[name] != null))) {
          this[name] = otherStyle[name];
        }
      }
    }
  },

  /**
   * Batch setting style with a given object
   * @param {Object|string} obj
   * @param {*} [obj]
   */
  set: function (obj, value) {
    if (typeof obj === 'string') {
      this[obj] = value;
    } else {
      this.extendFrom(obj, true);
    }
  },

  /**
   * Clone
   * @return {zrender/graphic/Style} [description]
   */
  clone: function () {
    var newStyle = new this.constructor();
    newStyle.extendFrom(this, true);
    return newStyle;
  },
  getGradient: function (ctx, obj, rect) {
    var method = obj.type === 'radial' ? createRadialGradient : createLinearGradient;
    var canvasGradient = method(ctx, obj, rect);
    var colorStops = obj.colorStops;

    for (var i = 0; i < colorStops.length; i++) {
      canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
    }

    return canvasGradient;
  }
};
var styleProto = Style.prototype;

for (var i = 0; i < STYLE_COMMON_PROPS.length; i++) {
  var prop = STYLE_COMMON_PROPS[i];

  if (!(prop[0] in styleProto)) {
    styleProto[prop[0]] = prop[1];
  }
} // Provide for others


Style.getGradient = styleProto.getGradient;
var _default = Style;
module.exports = _default;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var LRU = __webpack_require__(617);

var globalImageCache = new LRU(50);
/**
 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
 */

function findExistImage(newImageOrSrc) {
  if (typeof newImageOrSrc === 'string') {
    var cachedImgObj = globalImageCache.get(newImageOrSrc);
    return cachedImgObj && cachedImgObj.image;
  } else {
    return newImageOrSrc;
  }
}
/**
 * Caution: User should cache loaded images, but not just count on LRU.
 * Consider if required images more than LRU size, will dead loop occur?
 *
 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
 * @param {HTMLImageElement|HTMLCanvasElement|Canvas} image Existent image.
 * @param {module:zrender/Element} [hostEl] For calling `dirty`.
 * @param {Function} [cb] params: (image, cbPayload)
 * @param {Object} [cbPayload] Payload on cb calling.
 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
 */


function createOrUpdateImage(newImageOrSrc, image, hostEl, cb, cbPayload) {
  if (!newImageOrSrc) {
    return image;
  } else if (typeof newImageOrSrc === 'string') {
    // Image should not be loaded repeatly.
    if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) {
      return image;
    } // Only when there is no existent image or existent image src
    // is different, this method is responsible for load.


    var cachedImgObj = globalImageCache.get(newImageOrSrc);
    var pendingWrap = {
      hostEl: hostEl,
      cb: cb,
      cbPayload: cbPayload
    };

    if (cachedImgObj) {
      image = cachedImgObj.image;
      !isImageReady(image) && cachedImgObj.pending.push(pendingWrap);
    } else {
      image = new Image();
      image.onload = image.onerror = imageOnLoad;
      globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
        image: image,
        pending: [pendingWrap]
      });
      image.src = image.__zrImageSrc = newImageOrSrc;
    }

    return image;
  } // newImageOrSrc is an HTMLImageElement or HTMLCanvasElement or Canvas
  else {
      return newImageOrSrc;
    }
}

function imageOnLoad() {
  var cachedImgObj = this.__cachedImgObj;
  this.onload = this.onerror = this.__cachedImgObj = null;

  for (var i = 0; i < cachedImgObj.pending.length; i++) {
    var pendingWrap = cachedImgObj.pending[i];
    var cb = pendingWrap.cb;
    cb && cb(this, pendingWrap.cbPayload);
    pendingWrap.hostEl.dirty();
  }

  cachedImgObj.pending.length = 0;
}

function isImageReady(image) {
  return image && image.width && image.height;
}

exports.findExistImage = findExistImage;
exports.createOrUpdateImage = createOrUpdateImage;
exports.isImageReady = isImageReady;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(65);

var roundRectHelper = __webpack_require__(622);

var _subPixelOptimize = __webpack_require__(408);

var subPixelOptimizeRect = _subPixelOptimize.subPixelOptimizeRect;

/**
 * 矩形
 * @module zrender/graphic/shape/Rect
 */
// Avoid create repeatly.
var subPixelOptimizeOutputShape = {};

var _default = Path.extend({
  type: 'rect',
  shape: {
    // 左上、右上、右下、左下角的半径依次为r1、r2、r3、r4
    // r缩写为1         相当于 [1, 1, 1, 1]
    // r缩写为[1]       相当于 [1, 1, 1, 1]
    // r缩写为[1, 2]    相当于 [1, 2, 1, 2]
    // r缩写为[1, 2, 3] 相当于 [1, 2, 3, 2]
    r: 0,
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  buildPath: function (ctx, shape) {
    var x;
    var y;
    var width;
    var height;

    if (this.subPixelOptimize) {
      subPixelOptimizeRect(subPixelOptimizeOutputShape, shape, this.style);
      x = subPixelOptimizeOutputShape.x;
      y = subPixelOptimizeOutputShape.y;
      width = subPixelOptimizeOutputShape.width;
      height = subPixelOptimizeOutputShape.height;
      subPixelOptimizeOutputShape.r = shape.r;
      shape = subPixelOptimizeOutputShape;
    } else {
      x = shape.x;
      y = shape.y;
      width = shape.width;
      height = shape.height;
    }

    if (!shape.r) {
      ctx.rect(x, y, width, height);
    } else {
      roundRectHelper.buildPath(ctx, shape);
    }

    ctx.closePath();
    return;
  }
});

module.exports = _default;

/***/ }),
/* 408 */
/***/ (function(module, exports) {

/**
 * Sub-pixel optimize for canvas rendering, prevent from blur
 * when rendering a thin vertical/horizontal line.
 */
var round = Math.round;
/**
 * Sub pixel optimize line for canvas
 *
 * @param {Object} outputShape The modification will be performed on `outputShape`.
 *                 `outputShape` and `inputShape` can be the same object.
 *                 `outputShape` object can be used repeatly, because all of
 *                 the `x1`, `x2`, `y1`, `y2` will be assigned in this method.
 * @param {Object} [inputShape]
 * @param {number} [inputShape.x1]
 * @param {number} [inputShape.y1]
 * @param {number} [inputShape.x2]
 * @param {number} [inputShape.y2]
 * @param {Object} [style]
 * @param {number} [style.lineWidth] If `null`/`undefined`/`0`, do not optimize.
 */

function subPixelOptimizeLine(outputShape, inputShape, style) {
  if (!inputShape) {
    return;
  }

  var x1 = inputShape.x1;
  var x2 = inputShape.x2;
  var y1 = inputShape.y1;
  var y2 = inputShape.y2;
  outputShape.x1 = x1;
  outputShape.x2 = x2;
  outputShape.y1 = y1;
  outputShape.y2 = y2;
  var lineWidth = style && style.lineWidth;

  if (!lineWidth) {
    return;
  }

  if (round(x1 * 2) === round(x2 * 2)) {
    outputShape.x1 = outputShape.x2 = subPixelOptimize(x1, lineWidth, true);
  }

  if (round(y1 * 2) === round(y2 * 2)) {
    outputShape.y1 = outputShape.y2 = subPixelOptimize(y1, lineWidth, true);
  }
}
/**
 * Sub pixel optimize rect for canvas
 *
 * @param {Object} outputShape The modification will be performed on `outputShape`.
 *                 `outputShape` and `inputShape` can be the same object.
 *                 `outputShape` object can be used repeatly, because all of
 *                 the `x`, `y`, `width`, `height` will be assigned in this method.
 * @param {Object} [inputShape]
 * @param {number} [inputShape.x]
 * @param {number} [inputShape.y]
 * @param {number} [inputShape.width]
 * @param {number} [inputShape.height]
 * @param {Object} [style]
 * @param {number} [style.lineWidth] If `null`/`undefined`/`0`, do not optimize.
 */


function subPixelOptimizeRect(outputShape, inputShape, style) {
  if (!inputShape) {
    return;
  }

  var originX = inputShape.x;
  var originY = inputShape.y;
  var originWidth = inputShape.width;
  var originHeight = inputShape.height;
  outputShape.x = originX;
  outputShape.y = originY;
  outputShape.width = originWidth;
  outputShape.height = originHeight;
  var lineWidth = style && style.lineWidth;

  if (!lineWidth) {
    return;
  }

  outputShape.x = subPixelOptimize(originX, lineWidth, true);
  outputShape.y = subPixelOptimize(originY, lineWidth, true);
  outputShape.width = Math.max(subPixelOptimize(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
  outputShape.height = Math.max(subPixelOptimize(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
}
/**
 * Sub pixel optimize for canvas
 *
 * @param {number} position Coordinate, such as x, y
 * @param {number} lineWidth If `null`/`undefined`/`0`, do not optimize.
 * @param {boolean=} positiveOrNegative Default false (negative).
 * @return {number} Optimized position.
 */


function subPixelOptimize(position, lineWidth, positiveOrNegative) {
  if (!lineWidth) {
    return position;
  } // Assure that (position + lineWidth / 2) is near integer edge,
  // otherwise line will be fuzzy in canvas.


  var doubledPosition = round(position * 2);
  return (doubledPosition + round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
}

exports.subPixelOptimizeLine = subPixelOptimizeLine;
exports.subPixelOptimizeRect = subPixelOptimizeRect;
exports.subPixelOptimize = subPixelOptimize;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(1);

var Gradient = __webpack_require__(296);

/**
 * x, y, x2, y2 are all percent from 0 to 1
 * @param {number} [x=0]
 * @param {number} [y=0]
 * @param {number} [x2=1]
 * @param {number} [y2=0]
 * @param {Array.<Object>} colorStops
 * @param {boolean} [globalCoord=false]
 */
var LinearGradient = function (x, y, x2, y2, colorStops, globalCoord) {
  // Should do nothing more in this constructor. Because gradient can be
  // declard by `color: {type: 'linear', colorStops: ...}`, where
  // this constructor will not be called.
  this.x = x == null ? 0 : x;
  this.y = y == null ? 0 : y;
  this.x2 = x2 == null ? 1 : x2;
  this.y2 = y2 == null ? 0 : y2; // Can be cloned

  this.type = 'linear'; // If use global coord

  this.global = globalCoord || false;
  Gradient.call(this, colorStops);
};

LinearGradient.prototype = {
  constructor: LinearGradient
};
zrUtil.inherits(LinearGradient, Gradient);
var _default = LinearGradient;
module.exports = _default;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var _util = __webpack_require__(1);

var inherits = _util.inherits;

var Displayble = __webpack_require__(233);

var BoundingRect = __webpack_require__(57);

/**
 * Displayable for incremental rendering. It will be rendered in a separate layer
 * IncrementalDisplay have two main methods. `clearDisplayables` and `addDisplayables`
 * addDisplayables will render the added displayables incremetally.
 *
 * It use a not clearFlag to tell the painter don't clear the layer if it's the first element.
 */
// TODO Style override ?
function IncrementalDisplayble(opts) {
  Displayble.call(this, opts);
  this._displayables = [];
  this._temporaryDisplayables = [];
  this._cursor = 0;
  this.notClear = true;
}

IncrementalDisplayble.prototype.incremental = true;

IncrementalDisplayble.prototype.clearDisplaybles = function () {
  this._displayables = [];
  this._temporaryDisplayables = [];
  this._cursor = 0;
  this.dirty();
  this.notClear = false;
};

IncrementalDisplayble.prototype.addDisplayable = function (displayable, notPersistent) {
  if (notPersistent) {
    this._temporaryDisplayables.push(displayable);
  } else {
    this._displayables.push(displayable);
  }

  this.dirty();
};

IncrementalDisplayble.prototype.addDisplayables = function (displayables, notPersistent) {
  notPersistent = notPersistent || false;

  for (var i = 0; i < displayables.length; i++) {
    this.addDisplayable(displayables[i], notPersistent);
  }
};

IncrementalDisplayble.prototype.eachPendingDisplayable = function (cb) {
  for (var i = this._cursor; i < this._displayables.length; i++) {
    cb && cb(this._displayables[i]);
  }

  for (var i = 0; i < this._temporaryDisplayables.length; i++) {
    cb && cb(this._temporaryDisplayables[i]);
  }
};

IncrementalDisplayble.prototype.update = function () {
  this.updateTransform();

  for (var i = this._cursor; i < this._displayables.length; i++) {
    var displayable = this._displayables[i]; // PENDING

    displayable.parent = this;
    displayable.update();
    displayable.parent = null;
  }

  for (var i = 0; i < this._temporaryDisplayables.length; i++) {
    var displayable = this._temporaryDisplayables[i]; // PENDING

    displayable.parent = this;
    displayable.update();
    displayable.parent = null;
  }
};

IncrementalDisplayble.prototype.brush = function (ctx, prevEl) {
  // Render persistant displayables.
  for (var i = this._cursor; i < this._displayables.length; i++) {
    var displayable = this._displayables[i];
    displayable.beforeBrush && displayable.beforeBrush(ctx);
    displayable.brush(ctx, i === this._cursor ? null : this._displayables[i - 1]);
    displayable.afterBrush && displayable.afterBrush(ctx);
  }

  this._cursor = i; // Render temporary displayables.

  for (var i = 0; i < this._temporaryDisplayables.length; i++) {
    var displayable = this._temporaryDisplayables[i];
    displayable.beforeBrush && displayable.beforeBrush(ctx);
    displayable.brush(ctx, i === 0 ? null : this._temporaryDisplayables[i - 1]);
    displayable.afterBrush && displayable.afterBrush(ctx);
  }

  this._temporaryDisplayables = [];
  this.notClear = true;
};

var m = [];

IncrementalDisplayble.prototype.getBoundingRect = function () {
  if (!this._rect) {
    var rect = new BoundingRect(Infinity, Infinity, -Infinity, -Infinity);

    for (var i = 0; i < this._displayables.length; i++) {
      var displayable = this._displayables[i];
      var childRect = displayable.getBoundingRect().clone();

      if (displayable.needLocalTransform()) {
        childRect.applyTransform(displayable.getLocalTransform(m));
      }

      rect.union(childRect);
    }

    this._rect = rect;
  }

  return this._rect;
};

IncrementalDisplayble.prototype.contain = function (x, y) {
  var localPos = this.transformCoordToLocal(x, y);
  var rect = this.getBoundingRect();

  if (rect.contain(localPos[0], localPos[1])) {
    for (var i = 0; i < this._displayables.length; i++) {
      var displayable = this._displayables[i];

      if (displayable.contain(x, y)) {
        return true;
      }
    }
  }

  return false;
};

inherits(IncrementalDisplayble, Displayble);
var _default = IncrementalDisplayble;
module.exports = _default;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _dataProvider = __webpack_require__(176);

var retrieveRawValue = _dataProvider.retrieveRawValue;

var _format = __webpack_require__(54);

var getTooltipMarker = _format.getTooltipMarker;
var formatTpl = _format.formatTpl;

var _model = __webpack_require__(44);

var getTooltipRenderMode = _model.getTooltipRenderMode;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var DIMENSION_LABEL_REG = /\{@(.+?)\}/g; // PENDING A little ugly

var _default = {
  /**
   * Get params for formatter
   * @param {number} dataIndex
   * @param {string} [dataType]
   * @return {Object}
   */
  getDataParams: function (dataIndex, dataType) {
    var data = this.getData(dataType);
    var rawValue = this.getRawValue(dataIndex, dataType);
    var rawDataIndex = data.getRawIndex(dataIndex);
    var name = data.getName(dataIndex);
    var itemOpt = data.getRawDataItem(dataIndex);
    var color = data.getItemVisual(dataIndex, 'color');
    var borderColor = data.getItemVisual(dataIndex, 'borderColor');
    var tooltipModel = this.ecModel.getComponent('tooltip');
    var renderModeOption = tooltipModel && tooltipModel.get('renderMode');
    var renderMode = getTooltipRenderMode(renderModeOption);
    var mainType = this.mainType;
    var isSeries = mainType === 'series';
    var userOutput = data.userOutput;
    return {
      componentType: mainType,
      componentSubType: this.subType,
      componentIndex: this.componentIndex,
      seriesType: isSeries ? this.subType : null,
      seriesIndex: this.seriesIndex,
      seriesId: isSeries ? this.id : null,
      seriesName: isSeries ? this.name : null,
      name: name,
      dataIndex: rawDataIndex,
      data: itemOpt,
      dataType: dataType,
      value: rawValue,
      color: color,
      borderColor: borderColor,
      dimensionNames: userOutput ? userOutput.dimensionNames : null,
      encode: userOutput ? userOutput.encode : null,
      marker: getTooltipMarker({
        color: color,
        renderMode: renderMode
      }),
      // Param name list for mapping `a`, `b`, `c`, `d`, `e`
      $vars: ['seriesName', 'name', 'value']
    };
  },

  /**
   * Format label
   * @param {number} dataIndex
   * @param {string} [status='normal'] 'normal' or 'emphasis'
   * @param {string} [dataType]
   * @param {number} [dimIndex] Only used in some chart that
   *        use formatter in different dimensions, like radar.
   * @param {string} [labelProp='label']
   * @return {string} If not formatter, return null/undefined
   */
  getFormattedLabel: function (dataIndex, status, dataType, dimIndex, labelProp) {
    status = status || 'normal';
    var data = this.getData(dataType);
    var itemModel = data.getItemModel(dataIndex);
    var params = this.getDataParams(dataIndex, dataType);

    if (dimIndex != null && params.value instanceof Array) {
      params.value = params.value[dimIndex];
    }

    var formatter = itemModel.get(status === 'normal' ? [labelProp || 'label', 'formatter'] : [status, labelProp || 'label', 'formatter']);

    if (typeof formatter === 'function') {
      params.status = status;
      params.dimensionIndex = dimIndex;
      return formatter(params);
    } else if (typeof formatter === 'string') {
      var str = formatTpl(formatter, params); // Support 'aaa{@[3]}bbb{@product}ccc'.
      // Do not support '}' in dim name util have to.

      return str.replace(DIMENSION_LABEL_REG, function (origin, dim) {
        var len = dim.length;

        if (dim.charAt(0) === '[' && dim.charAt(len - 1) === ']') {
          dim = +dim.slice(1, len - 1); // Also: '[]' => 0
        }

        return retrieveRawValue(data, dataIndex, dim);
      });
    }
  },

  /**
   * Get raw value in option
   * @param {number} idx
   * @param {string} [dataType]
   * @return {Array|number|string}
   */
  getRawValue: function (idx, dataType) {
    return retrieveRawValue(this.getData(dataType), idx);
  },

  /**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {number} [dataType]
   * @return {string} tooltip string
   */
  formatTooltip: function () {// Empty function
  }
};
module.exports = _default;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(1);

var assert = _util.assert;
var isArray = _util.isArray;

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @param {Object} define
 * @return See the return of `createTask`.
 */
function createTask(define) {
  return new Task(define);
}
/**
 * @constructor
 * @param {Object} define
 * @param {Function} define.reset Custom reset
 * @param {Function} [define.plan] Returns 'reset' indicate reset immediately.
 * @param {Function} [define.count] count is used to determin data task.
 * @param {Function} [define.onDirty] count is used to determin data task.
 */


function Task(define) {
  define = define || {};
  this._reset = define.reset;
  this._plan = define.plan;
  this._count = define.count;
  this._onDirty = define.onDirty;
  this._dirty = true; // Context must be specified implicitly, to
  // avoid miss update context when model changed.

  this.context;
}

var taskProto = Task.prototype;
/**
 * @param {Object} performArgs
 * @param {number} [performArgs.step] Specified step.
 * @param {number} [performArgs.skip] Skip customer perform call.
 * @param {number} [performArgs.modBy] Sampling window size.
 * @param {number} [performArgs.modDataCount] Sampling count.
 */

taskProto.perform = function (performArgs) {
  var upTask = this._upstream;
  var skip = performArgs && performArgs.skip; // TODO some refactor.
  // Pull data. Must pull data each time, because context.data
  // may be updated by Series.setData.

  if (this._dirty && upTask) {
    var context = this.context;
    context.data = context.outputData = upTask.context.outputData;
  }

  if (this.__pipeline) {
    this.__pipeline.currentTask = this;
  }

  var planResult;

  if (this._plan && !skip) {
    planResult = this._plan(this.context);
  } // Support sharding by mod, which changes the render sequence and makes the rendered graphic
  // elements uniformed distributed when progress, especially when moving or zooming.


  var lastModBy = normalizeModBy(this._modBy);
  var lastModDataCount = this._modDataCount || 0;
  var modBy = normalizeModBy(performArgs && performArgs.modBy);
  var modDataCount = performArgs && performArgs.modDataCount || 0;

  if (lastModBy !== modBy || lastModDataCount !== modDataCount) {
    planResult = 'reset';
  }

  function normalizeModBy(val) {
    !(val >= 1) && (val = 1); // jshint ignore:line

    return val;
  }

  var forceFirstProgress;

  if (this._dirty || planResult === 'reset') {
    this._dirty = false;
    forceFirstProgress = reset(this, skip);
  }

  this._modBy = modBy;
  this._modDataCount = modDataCount;
  var step = performArgs && performArgs.step;

  if (upTask) {
    this._dueEnd = upTask._outputDueEnd;
  } // DataTask or overallTask
  else {
      this._dueEnd = this._count ? this._count(this.context) : Infinity;
    } // Note: Stubs, that its host overall task let it has progress, has progress.
  // If no progress, pass index from upstream to downstream each time plan called.


  if (this._progress) {
    var start = this._dueIndex;
    var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);

    if (!skip && (forceFirstProgress || start < end)) {
      var progress = this._progress;

      if (isArray(progress)) {
        for (var i = 0; i < progress.length; i++) {
          doProgress(this, progress[i], start, end, modBy, modDataCount);
        }
      } else {
        doProgress(this, progress, start, end, modBy, modDataCount);
      }
    }

    this._dueIndex = end; // If no `outputDueEnd`, assume that output data and
    // input data is the same, so use `dueIndex` as `outputDueEnd`.

    var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
    this._outputDueEnd = outputDueEnd;
  } else {
    // (1) Some overall task has no progress.
    // (2) Stubs, that its host overall task do not let it has progress, has no progress.
    // This should always be performed so it can be passed to downstream.
    this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
  }

  return this.unfinished();
};

var iterator = function () {
  var end;
  var current;
  var modBy;
  var modDataCount;
  var winCount;
  var it = {
    reset: function (s, e, sStep, sCount) {
      current = s;
      end = e;
      modBy = sStep;
      modDataCount = sCount;
      winCount = Math.ceil(modDataCount / modBy);
      it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
    }
  };
  return it;

  function sequentialNext() {
    return current < end ? current++ : null;
  }

  function modNext() {
    var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
    var result = current >= end ? null : dataIndex < modDataCount ? dataIndex // If modDataCount is smaller than data.count() (consider `appendData` case),
    // Use normal linear rendering mode.
    : current;
    current++;
    return result;
  }
}();

taskProto.dirty = function () {
  this._dirty = true;
  this._onDirty && this._onDirty(this.context);
};

function doProgress(taskIns, progress, start, end, modBy, modDataCount) {
  iterator.reset(start, end, modBy, modDataCount);
  taskIns._callingProgress = progress;

  taskIns._callingProgress({
    start: start,
    end: end,
    count: end - start,
    next: iterator.next
  }, taskIns.context);
}

function reset(taskIns, skip) {
  taskIns._dueIndex = taskIns._outputDueEnd = taskIns._dueEnd = 0;
  taskIns._settedOutputEnd = null;
  var progress;
  var forceFirstProgress;

  if (!skip && taskIns._reset) {
    progress = taskIns._reset(taskIns.context);

    if (progress && progress.progress) {
      forceFirstProgress = progress.forceFirstProgress;
      progress = progress.progress;
    } // To simplify no progress checking, array must has item.


    if (isArray(progress) && !progress.length) {
      progress = null;
    }
  }

  taskIns._progress = progress;
  taskIns._modBy = taskIns._modDataCount = null;
  var downstream = taskIns._downstream;
  downstream && downstream.dirty();
  return forceFirstProgress;
}
/**
 * @return {boolean}
 */


taskProto.unfinished = function () {
  return this._progress && this._dueIndex < this._dueEnd;
};
/**
 * @param {Object} downTask The downstream task.
 * @return {Object} The downstream task.
 */


taskProto.pipe = function (downTask) {
  // If already downstream, do not dirty downTask.
  if (this._downstream !== downTask || this._dirty) {
    this._downstream = downTask;
    downTask._upstream = this;
    downTask.dirty();
  }
};

taskProto.dispose = function () {
  if (this._disposed) {
    return;
  }

  this._upstream && (this._upstream._downstream = null);
  this._downstream && (this._downstream._upstream = null);
  this._dirty = false;
  this._disposed = true;
};

taskProto.getUpstream = function () {
  return this._upstream;
};

taskProto.getDownstream = function () {
  return this._downstream;
};

taskProto.setOutputEnd = function (end) {
  // This only happend in dataTask, dataZoom, map, currently.
  // where dataZoom do not set end each time, but only set
  // when reset. So we should record the setted end, in case
  // that the stub of dataZoom perform again and earse the
  // setted end by upstream.
  this._outputDueEnd = this._settedOutputEnd = end;
}; ///////////////////////////////////////////////////////////
// For stream debug (Should be commented out after used!)
// Usage: printTask(this, 'begin');
// Usage: printTask(this, null, {someExtraProp});
// function printTask(task, prefix, extra) {
//     window.ecTaskUID == null && (window.ecTaskUID = 0);
//     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
//     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
//     var props = [];
//     if (task.__pipeline) {
//         var val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
//         props.push({text: 'idx', value: val});
//     } else {
//         var stubCount = 0;
//         task.agentStubMap.each(() => stubCount++);
//         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
//     }
//     props.push({text: 'uid', value: task.uidDebug});
//     if (task.__pipeline) {
//         props.push({text: 'pid', value: task.__pipeline.id});
//         task.agent && props.push(
//             {text: 'stubFor', value: task.agent.uidDebug}
//         );
//     }
//     props.push(
//         {text: 'dirty', value: task._dirty},
//         {text: 'dueIndex', value: task._dueIndex},
//         {text: 'dueEnd', value: task._dueEnd},
//         {text: 'outputDueEnd', value: task._outputDueEnd}
//     );
//     if (extra) {
//         Object.keys(extra).forEach(key => {
//             props.push({text: key, value: extra[key]});
//         });
//     }
//     var args = ['color: blue'];
//     var msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
//         args.push('color: black', 'color: red'),
//         `${item.text}: %c${item.value}`
//     )).join('%c, ');
//     console.log.apply(console, [msg].concat(args));
//     // console.log(this);
// }


exports.createTask = createTask;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var _util = __webpack_require__(1);

var createHashMap = _util.createHashMap;
var isString = _util.isString;
var isArray = _util.isArray;
var each = _util.each;
var assert = _util.assert;

var _parseSVG = __webpack_require__(638);

var parseXML = _parseSVG.parseXML;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var storage = createHashMap(); // For minimize the code size of common echarts package,
// do not put too much logic in this module.

var _default = {
  // The format of record: see `echarts.registerMap`.
  // Compatible with previous `echarts.registerMap`.
  registerMap: function (mapName, rawGeoJson, rawSpecialAreas) {
    var records;

    if (isArray(rawGeoJson)) {
      records = rawGeoJson;
    } else if (rawGeoJson.svg) {
      records = [{
        type: 'svg',
        source: rawGeoJson.svg,
        specialAreas: rawGeoJson.specialAreas
      }];
    } else {
      // Backward compatibility.
      if (rawGeoJson.geoJson && !rawGeoJson.features) {
        rawSpecialAreas = rawGeoJson.specialAreas;
        rawGeoJson = rawGeoJson.geoJson;
      }

      records = [{
        type: 'geoJSON',
        source: rawGeoJson,
        specialAreas: rawSpecialAreas
      }];
    }

    each(records, function (record) {
      var type = record.type;
      type === 'geoJson' && (type = record.type = 'geoJSON');
      var parse = parsers[type];
      parse(record);
    });
    return storage.set(mapName, records);
  },
  retrieveMap: function (mapName) {
    return storage.get(mapName);
  }
};
var parsers = {
  geoJSON: function (record) {
    var source = record.source;
    record.geoJSON = !isString(source) ? source : typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(source) : new Function('return (' + source + ');')();
  },
  // Only perform parse to XML object here, which might be time
  // consiming for large SVG.
  // Although convert XML to zrender element is also time consiming,
  // if we do it here, the clone of zrender elements has to be
  // required. So we do it once for each geo instance, util real
  // performance issues call for optimizing it.
  svg: function (record) {
    record.svgXML = parseXML(record.source);
  }
};
module.exports = _default;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _dataProvider = __webpack_require__(176);

var retrieveRawValue = _dataProvider.retrieveRawValue;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @param {module:echarts/data/List} data
 * @param {number} dataIndex
 * @return {string} label string. Not null/undefined
 */
function getDefaultLabel(data, dataIndex) {
  var labelDims = data.mapDimension('defaultedLabel', true);
  var len = labelDims.length; // Simple optimization (in lots of cases, label dims length is 1)

  if (len === 1) {
    return retrieveRawValue(data, dataIndex, labelDims[0]);
  } else if (len) {
    var vals = [];

    for (var i = 0; i < labelDims.length; i++) {
      var val = retrieveRawValue(data, dataIndex, labelDims[i]);
      vals.push(val);
    }

    return vals.join(' ');
  }
}

exports.getDefaultLabel = getDefaultLabel;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var _util = __webpack_require__(1);

var isObject = _util.isObject;
var each = _util.each;
var map = _util.map;
var indexOf = _util.indexOf;
var retrieve = _util.retrieve;

var _layout = __webpack_require__(53);

var getLayoutRect = _layout.getLayoutRect;

var _axisHelper = __webpack_require__(109);

var createScaleByModel = _axisHelper.createScaleByModel;
var ifAxisCrossZero = _axisHelper.ifAxisCrossZero;
var niceScaleExtent = _axisHelper.niceScaleExtent;
var estimateLabelUnionRect = _axisHelper.estimateLabelUnionRect;

var Cartesian2D = __webpack_require__(1577);

var Axis2D = __webpack_require__(1579);

var CoordinateSystem = __webpack_require__(108);

var _dataStackHelper = __webpack_require__(124);

var getStackedDimension = _dataStackHelper.getStackedDimension;

__webpack_require__(1580);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Grid is a region which contains at most 4 cartesian systems
 *
 * TODO Default cartesian
 */
// Depends on GridModel, AxisModel, which performs preprocess.

/**
 * Check if the axis is used in the specified grid
 * @inner
 */
function isAxisUsedInTheGrid(axisModel, gridModel, ecModel) {
  return axisModel.getCoordSysModel() === gridModel;
}

function Grid(gridModel, ecModel, api) {
  /**
   * @type {Object.<string, module:echarts/coord/cartesian/Cartesian2D>}
   * @private
   */
  this._coordsMap = {};
  /**
   * @type {Array.<module:echarts/coord/cartesian/Cartesian>}
   * @private
   */

  this._coordsList = [];
  /**
   * @type {Object.<string, Array.<module:echarts/coord/cartesian/Axis2D>>}
   * @private
   */

  this._axesMap = {};
  /**
   * @type {Array.<module:echarts/coord/cartesian/Axis2D>}
   * @private
   */

  this._axesList = [];

  this._initCartesian(gridModel, ecModel, api);

  this.model = gridModel;
}

var gridProto = Grid.prototype;
gridProto.type = 'grid';
gridProto.axisPointerEnabled = true;

gridProto.getRect = function () {
  return this._rect;
};

gridProto.update = function (ecModel, api) {
  var axesMap = this._axesMap;

  this._updateScale(ecModel, this.model);

  each(axesMap.x, function (xAxis) {
    niceScaleExtent(xAxis.scale, xAxis.model);
  });
  each(axesMap.y, function (yAxis) {
    niceScaleExtent(yAxis.scale, yAxis.model);
  }); // Key: axisDim_axisIndex, value: boolean, whether onZero target.

  var onZeroRecords = {};
  each(axesMap.x, function (xAxis) {
    fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
  });
  each(axesMap.y, function (yAxis) {
    fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
  }); // Resize again if containLabel is enabled
  // FIXME It may cause getting wrong grid size in data processing stage

  this.resize(this.model, api);
};

function fixAxisOnZero(axesMap, otherAxisDim, axis, onZeroRecords) {
  axis.getAxesOnZeroOf = function () {
    // TODO: onZero of multiple axes.
    return otherAxisOnZeroOf ? [otherAxisOnZeroOf] : [];
  }; // onZero can not be enabled in these two situations:
  // 1. When any other axis is a category axis.
  // 2. When no axis is cross 0 point.


  var otherAxes = axesMap[otherAxisDim];
  var otherAxisOnZeroOf;
  var axisModel = axis.model;
  var onZero = axisModel.get('axisLine.onZero');
  var onZeroAxisIndex = axisModel.get('axisLine.onZeroAxisIndex');

  if (!onZero) {
    return;
  } // If target axis is specified.


  if (onZeroAxisIndex != null) {
    if (canOnZeroToAxis(otherAxes[onZeroAxisIndex])) {
      otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
    }
  } else {
    // Find the first available other axis.
    for (var idx in otherAxes) {
      if (otherAxes.hasOwnProperty(idx) && canOnZeroToAxis(otherAxes[idx]) // Consider that two Y axes on one value axis,
      // if both onZero, the two Y axes overlap.
      && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
        otherAxisOnZeroOf = otherAxes[idx];
        break;
      }
    }
  }

  if (otherAxisOnZeroOf) {
    onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
  }

  function getOnZeroRecordKey(axis) {
    return axis.dim + '_' + axis.index;
  }
}

function canOnZeroToAxis(axis) {
  return axis && axis.type !== 'category' && axis.type !== 'time' && ifAxisCrossZero(axis);
}
/**
 * Resize the grid
 * @param {module:echarts/coord/cartesian/GridModel} gridModel
 * @param {module:echarts/ExtensionAPI} api
 */


gridProto.resize = function (gridModel, api, ignoreContainLabel) {
  var gridRect = getLayoutRect(gridModel.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  });
  this._rect = gridRect;
  var axesList = this._axesList;
  adjustAxes(); // Minus label size

  if (!ignoreContainLabel && gridModel.get('containLabel')) {
    each(axesList, function (axis) {
      if (!axis.model.get('axisLabel.inside')) {
        var labelUnionRect = estimateLabelUnionRect(axis);

        if (labelUnionRect) {
          var dim = axis.isHorizontal() ? 'height' : 'width';
          var margin = axis.model.get('axisLabel.margin');
          gridRect[dim] -= labelUnionRect[dim] + margin;

          if (axis.position === 'top') {
            gridRect.y += labelUnionRect.height + margin;
          } else if (axis.position === 'left') {
            gridRect.x += labelUnionRect.width + margin;
          }
        }
      }
    });
    adjustAxes();
  }

  function adjustAxes() {
    each(axesList, function (axis) {
      var isHorizontal = axis.isHorizontal();
      var extent = isHorizontal ? [0, gridRect.width] : [0, gridRect.height];
      var idx = axis.inverse ? 1 : 0;
      axis.setExtent(extent[idx], extent[1 - idx]);
      updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
    });
  }
};
/**
 * @param {string} axisType
 * @param {number} [axisIndex]
 */


gridProto.getAxis = function (axisType, axisIndex) {
  var axesMapOnDim = this._axesMap[axisType];

  if (axesMapOnDim != null) {
    if (axisIndex == null) {
      // Find first axis
      for (var name in axesMapOnDim) {
        if (axesMapOnDim.hasOwnProperty(name)) {
          return axesMapOnDim[name];
        }
      }
    }

    return axesMapOnDim[axisIndex];
  }
};
/**
 * @return {Array.<module:echarts/coord/Axis>}
 */


gridProto.getAxes = function () {
  return this._axesList.slice();
};
/**
 * Usage:
 *      grid.getCartesian(xAxisIndex, yAxisIndex);
 *      grid.getCartesian(xAxisIndex);
 *      grid.getCartesian(null, yAxisIndex);
 *      grid.getCartesian({xAxisIndex: ..., yAxisIndex: ...});
 *
 * @param {number|Object} [xAxisIndex]
 * @param {number} [yAxisIndex]
 */


gridProto.getCartesian = function (xAxisIndex, yAxisIndex) {
  if (xAxisIndex != null && yAxisIndex != null) {
    var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
    return this._coordsMap[key];
  }

  if (isObject(xAxisIndex)) {
    yAxisIndex = xAxisIndex.yAxisIndex;
    xAxisIndex = xAxisIndex.xAxisIndex;
  } // When only xAxisIndex or yAxisIndex given, find its first cartesian.


  for (var i = 0, coordList = this._coordsList; i < coordList.length; i++) {
    if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) {
      return coordList[i];
    }
  }
};

gridProto.getCartesians = function () {
  return this._coordsList.slice();
};
/**
 * @implements
 * see {module:echarts/CoodinateSystem}
 */


gridProto.convertToPixel = function (ecModel, finder, value) {
  var target = this._findConvertTarget(ecModel, finder);

  return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
};
/**
 * @implements
 * see {module:echarts/CoodinateSystem}
 */


gridProto.convertFromPixel = function (ecModel, finder, value) {
  var target = this._findConvertTarget(ecModel, finder);

  return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
};
/**
 * @inner
 */


gridProto._findConvertTarget = function (ecModel, finder) {
  var seriesModel = finder.seriesModel;
  var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis')[0];
  var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis')[0];
  var gridModel = finder.gridModel;
  var coordsList = this._coordsList;
  var cartesian;
  var axis;

  if (seriesModel) {
    cartesian = seriesModel.coordinateSystem;
    indexOf(coordsList, cartesian) < 0 && (cartesian = null);
  } else if (xAxisModel && yAxisModel) {
    cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
  } else if (xAxisModel) {
    axis = this.getAxis('x', xAxisModel.componentIndex);
  } else if (yAxisModel) {
    axis = this.getAxis('y', yAxisModel.componentIndex);
  } // Lowest priority.
  else if (gridModel) {
      var grid = gridModel.coordinateSystem;

      if (grid === this) {
        cartesian = this._coordsList[0];
      }
    }

  return {
    cartesian: cartesian,
    axis: axis
  };
};
/**
 * @implements
 * see {module:echarts/CoodinateSystem}
 */


gridProto.containPoint = function (point) {
  var coord = this._coordsList[0];

  if (coord) {
    return coord.containPoint(point);
  }
};
/**
 * Initialize cartesian coordinate systems
 * @private
 */


gridProto._initCartesian = function (gridModel, ecModel, api) {
  var axisPositionUsed = {
    left: false,
    right: false,
    top: false,
    bottom: false
  };
  var axesMap = {
    x: {},
    y: {}
  };
  var axesCount = {
    x: 0,
    y: 0
  }; /// Create axis

  ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
  ecModel.eachComponent('yAxis', createAxisCreator('y'), this);

  if (!axesCount.x || !axesCount.y) {
    // Roll back when there no either x or y axis
    this._axesMap = {};
    this._axesList = [];
    return;
  }

  this._axesMap = axesMap; /// Create cartesian2d

  each(axesMap.x, function (xAxis, xAxisIndex) {
    each(axesMap.y, function (yAxis, yAxisIndex) {
      var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
      var cartesian = new Cartesian2D(key);
      cartesian.grid = this;
      cartesian.model = gridModel;
      this._coordsMap[key] = cartesian;

      this._coordsList.push(cartesian);

      cartesian.addAxis(xAxis);
      cartesian.addAxis(yAxis);
    }, this);
  }, this);

  function createAxisCreator(axisType) {
    return function (axisModel, idx) {
      if (!isAxisUsedInTheGrid(axisModel, gridModel, ecModel)) {
        return;
      }

      var axisPosition = axisModel.get('position');

      if (axisType === 'x') {
        // Fix position
        if (axisPosition !== 'top' && axisPosition !== 'bottom') {
          // Default bottom of X
          axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
        }
      } else {
        // Fix position
        if (axisPosition !== 'left' && axisPosition !== 'right') {
          // Default left of Y
          axisPosition = axisPositionUsed.left ? 'right' : 'left';
        }
      }

      axisPositionUsed[axisPosition] = true;
      var axis = new Axis2D(axisType, createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisPosition);
      var isCategory = axis.type === 'category';
      axis.onBand = isCategory && axisModel.get('boundaryGap');
      axis.inverse = axisModel.get('inverse'); // Inject axis into axisModel

      axisModel.axis = axis; // Inject axisModel into axis

      axis.model = axisModel; // Inject grid info axis

      axis.grid = this; // Index of axis, can be used as key

      axis.index = idx;

      this._axesList.push(axis);

      axesMap[axisType][idx] = axis;
      axesCount[axisType]++;
    };
  }
};
/**
 * Update cartesian properties from series
 * @param  {module:echarts/model/Option} option
 * @private
 */


gridProto._updateScale = function (ecModel, gridModel) {
  // Reset scale
  each(this._axesList, function (axis) {
    axis.scale.setExtent(Infinity, -Infinity);
  });
  ecModel.eachSeries(function (seriesModel) {
    if (isCartesian2D(seriesModel)) {
      var axesModels = findAxesModels(seriesModel, ecModel);
      var xAxisModel = axesModels[0];
      var yAxisModel = axesModels[1];

      if (!isAxisUsedInTheGrid(xAxisModel, gridModel, ecModel) || !isAxisUsedInTheGrid(yAxisModel, gridModel, ecModel)) {
        return;
      }

      var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
      var data = seriesModel.getData();
      var xAxis = cartesian.getAxis('x');
      var yAxis = cartesian.getAxis('y');

      if (data.type === 'list') {
        unionExtent(data, xAxis, seriesModel);
        unionExtent(data, yAxis, seriesModel);
      }
    }
  }, this);

  function unionExtent(data, axis, seriesModel) {
    each(data.mapDimension(axis.dim, true), function (dim) {
      axis.scale.unionExtentFromData( // For example, the extent of the orginal dimension
      // is [0.1, 0.5], the extent of the `stackResultDimension`
      // is [7, 9], the final extent should not include [0.1, 0.5].
      data, getStackedDimension(data, dim));
    });
  }
};
/**
 * @param {string} [dim] 'x' or 'y' or 'auto' or null/undefined
 * @return {Object} {baseAxes: [], otherAxes: []}
 */


gridProto.getTooltipAxes = function (dim) {
  var baseAxes = [];
  var otherAxes = [];
  each(this.getCartesians(), function (cartesian) {
    var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
    var otherAxis = cartesian.getOtherAxis(baseAxis);
    indexOf(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
    indexOf(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
  });
  return {
    baseAxes: baseAxes,
    otherAxes: otherAxes
  };
};
/**
 * @inner
 */


function updateAxisTransform(axis, coordBase) {
  var axisExtent = axis.getExtent();
  var axisExtentSum = axisExtent[0] + axisExtent[1]; // Fast transform

  axis.toGlobalCoord = axis.dim === 'x' ? function (coord) {
    return coord + coordBase;
  } : function (coord) {
    return axisExtentSum - coord + coordBase;
  };
  axis.toLocalCoord = axis.dim === 'x' ? function (coord) {
    return coord - coordBase;
  } : function (coord) {
    return axisExtentSum - coord + coordBase;
  };
}

var axesTypes = ['xAxis', 'yAxis'];
/**
 * @inner
 */

function findAxesModels(seriesModel, ecModel) {
  return map(axesTypes, function (axisType) {
    var axisModel = seriesModel.getReferringComponents(axisType)[0];
    return axisModel;
  });
}
/**
 * @inner
 */


function isCartesian2D(seriesModel) {
  return seriesModel.get('coordinateSystem') === 'cartesian2d';
}

Grid.create = function (ecModel, api) {
  var grids = [];
  ecModel.eachComponent('grid', function (gridModel, idx) {
    var grid = new Grid(gridModel, ecModel, api);
    grid.name = 'grid_' + idx; // dataSampling requires axis extent, so resize
    // should be performed in create stage.

    grid.resize(gridModel, api, true);
    gridModel.coordinateSystem = grid;
    grids.push(grid);
  }); // Inject the coordinateSystems into seriesModel

  ecModel.eachSeries(function (seriesModel) {
    if (!isCartesian2D(seriesModel)) {
      return;
    }

    var axesModels = findAxesModels(seriesModel, ecModel);
    var xAxisModel = axesModels[0];
    var yAxisModel = axesModels[1];
    var gridModel = xAxisModel.getCoordSysModel();
    var grid = gridModel.coordinateSystem;
    seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
  });
  return grids;
}; // For deciding which dimensions to use when creating list data


Grid.dimensions = Grid.prototype.dimensions = Cartesian2D.prototype.dimensions;
CoordinateSystem.register('cartesian2d', Grid);
var _default = Grid;
module.exports = _default;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Data selectable mixin for chart series.
 * To eanble data select, option of series must have `selectedMode`.
 * And each data item will use `selected` to toggle itself selected status
 */
var _default = {
  /**
   * @param {Array.<Object>} targetList [{name, value, selected}, ...]
   *        If targetList is an array, it should like [{name: ..., value: ...}, ...].
   *        If targetList is a "List", it must have coordDim: 'value' dimension and name.
   */
  updateSelectedMap: function (targetList) {
    this._targetList = zrUtil.isArray(targetList) ? targetList.slice() : [];
    this._selectTargetMap = zrUtil.reduce(targetList || [], function (targetMap, target) {
      targetMap.set(target.name, target);
      return targetMap;
    }, zrUtil.createHashMap());
  },

  /**
   * Either name or id should be passed as input here.
   * If both of them are defined, id is used.
   *
   * @param {string|undefined} name name of data
   * @param {number|undefined} id dataIndex of data
   */
  // PENGING If selectedMode is null ?
  select: function (name, id) {
    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
    var selectedMode = this.get('selectedMode');

    if (selectedMode === 'single') {
      this._selectTargetMap.each(function (target) {
        target.selected = false;
      });
    }

    target && (target.selected = true);
  },

  /**
   * Either name or id should be passed as input here.
   * If both of them are defined, id is used.
   *
   * @param {string|undefined} name name of data
   * @param {number|undefined} id dataIndex of data
   */
  unSelect: function (name, id) {
    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name); // var selectedMode = this.get('selectedMode');
    // selectedMode !== 'single' && target && (target.selected = false);

    target && (target.selected = false);
  },

  /**
   * Either name or id should be passed as input here.
   * If both of them are defined, id is used.
   *
   * @param {string|undefined} name name of data
   * @param {number|undefined} id dataIndex of data
   */
  toggleSelected: function (name, id) {
    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);

    if (target != null) {
      this[target.selected ? 'unSelect' : 'select'](name, id);
      return target.selected;
    }
  },

  /**
   * Either name or id should be passed as input here.
   * If both of them are defined, id is used.
   *
   * @param {string|undefined} name name of data
   * @param {number|undefined} id dataIndex of data
   */
  isSelected: function (name, id) {
    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
    return target && target.selected;
  }
};
module.exports = _default;

/***/ }),
/* 417 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * For geo and graph.
 *
 * @param {Object} controllerHost
 * @param {module:zrender/Element} controllerHost.target
 */
function updateViewOnPan(controllerHost, dx, dy) {
  var target = controllerHost.target;
  var pos = target.position;
  pos[0] += dx;
  pos[1] += dy;
  target.dirty();
}
/**
 * For geo and graph.
 *
 * @param {Object} controllerHost
 * @param {module:zrender/Element} controllerHost.target
 * @param {number} controllerHost.zoom
 * @param {number} controllerHost.zoomLimit like: {min: 1, max: 2}
 */


function updateViewOnZoom(controllerHost, zoomDelta, zoomX, zoomY) {
  var target = controllerHost.target;
  var zoomLimit = controllerHost.zoomLimit;
  var pos = target.position;
  var scale = target.scale;
  var newZoom = controllerHost.zoom = controllerHost.zoom || 1;
  newZoom *= zoomDelta;

  if (zoomLimit) {
    var zoomMin = zoomLimit.min || 0;
    var zoomMax = zoomLimit.max || Infinity;
    newZoom = Math.max(Math.min(zoomMax, newZoom), zoomMin);
  }

  var zoomScale = newZoom / controllerHost.zoom;
  controllerHost.zoom = newZoom; // Keep the mouse center when scaling

  pos[0] -= (zoomX - pos[0]) * (zoomScale - 1);
  pos[1] -= (zoomY - pos[1]) * (zoomScale - 1);
  scale[0] *= zoomScale;
  scale[1] *= zoomScale;
  target.dirty();
}

exports.updateViewOnPan = updateViewOnPan;
exports.updateViewOnZoom = updateViewOnZoom;

/***/ }),
/* 418 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @param {module:echarts/coord/View} view
 * @param {Object} payload
 * @param {Object} [zoomLimit]
 */
function updateCenterAndZoom(view, payload, zoomLimit) {
  var previousZoom = view.getZoom();
  var center = view.getCenter();
  var zoom = payload.zoom;
  var point = view.dataToPoint(center);

  if (payload.dx != null && payload.dy != null) {
    point[0] -= payload.dx;
    point[1] -= payload.dy;
    var center = view.pointToData(point);
    view.setCenter(center);
  }

  if (zoom != null) {
    if (zoomLimit) {
      var zoomMin = zoomLimit.min || 0;
      var zoomMax = zoomLimit.max || Infinity;
      zoom = Math.max(Math.min(previousZoom * zoom, zoomMax), zoomMin) / previousZoom;
    } // Zoom on given point(originX, originY)


    view.scale[0] *= zoom;
    view.scale[1] *= zoom;
    var position = view.position;
    var fixX = (payload.originX - position[0]) * (zoom - 1);
    var fixY = (payload.originY - position[1]) * (zoom - 1);
    position[0] -= fixX;
    position[1] -= fixY;
    view.updateTransform(); // Get the new center

    var center = view.pointToData(point);
    view.setCenter(center);
    view.setZoom(zoom * previousZoom);
  }

  return {
    center: view.getCenter(),
    zoom: view.getZoom()
  };
}

exports.updateCenterAndZoom = updateCenterAndZoom;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var Geo = __webpack_require__(1616);

var layout = __webpack_require__(53);

var numberUtil = __webpack_require__(37);

var geoSourceManager = __webpack_require__(305);

var mapDataStorage = __webpack_require__(413);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Resize method bound to the geo
 * @param {module:echarts/coord/geo/GeoModel|module:echarts/chart/map/MapModel} geoModel
 * @param {module:echarts/ExtensionAPI} api
 */
function resizeGeo(geoModel, api) {
  var boundingCoords = geoModel.get('boundingCoords');

  if (boundingCoords != null) {
    var leftTop = boundingCoords[0];
    var rightBottom = boundingCoords[1];

    if (isNaN(leftTop[0]) || isNaN(leftTop[1]) || isNaN(rightBottom[0]) || isNaN(rightBottom[1])) {} else {
      this.setBoundingRect(leftTop[0], leftTop[1], rightBottom[0] - leftTop[0], rightBottom[1] - leftTop[1]);
    }
  }

  var rect = this.getBoundingRect();
  var boxLayoutOption;
  var center = geoModel.get('layoutCenter');
  var size = geoModel.get('layoutSize');
  var viewWidth = api.getWidth();
  var viewHeight = api.getHeight();
  var aspect = rect.width / rect.height * this.aspectScale;
  var useCenterAndSize = false;

  if (center && size) {
    center = [numberUtil.parsePercent(center[0], viewWidth), numberUtil.parsePercent(center[1], viewHeight)];
    size = numberUtil.parsePercent(size, Math.min(viewWidth, viewHeight));

    if (!isNaN(center[0]) && !isNaN(center[1]) && !isNaN(size)) {
      useCenterAndSize = true;
    } else {}
  }

  var viewRect;

  if (useCenterAndSize) {
    var viewRect = {};

    if (aspect > 1) {
      // Width is same with size
      viewRect.width = size;
      viewRect.height = size / aspect;
    } else {
      viewRect.height = size;
      viewRect.width = size * aspect;
    }

    viewRect.y = center[1] - viewRect.height / 2;
    viewRect.x = center[0] - viewRect.width / 2;
  } else {
    // Use left/top/width/height
    boxLayoutOption = geoModel.getBoxLayoutParams(); // 0.75 rate

    boxLayoutOption.aspect = aspect;
    viewRect = layout.getLayoutRect(boxLayoutOption, {
      width: viewWidth,
      height: viewHeight
    });
  }

  this.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
  this.setCenter(geoModel.get('center'));
  this.setZoom(geoModel.get('zoom'));
}
/**
 * @param {module:echarts/coord/Geo} geo
 * @param {module:echarts/model/Model} model
 * @inner
 */


function setGeoCoords(geo, model) {
  zrUtil.each(model.get('geoCoord'), function (geoCoord, name) {
    geo.addGeoCoord(name, geoCoord);
  });
}

var geoCreator = {
  // For deciding which dimensions to use when creating list data
  dimensions: Geo.prototype.dimensions,
  create: function (ecModel, api) {
    var geoList = []; // FIXME Create each time may be slow

    ecModel.eachComponent('geo', function (geoModel, idx) {
      var name = geoModel.get('map');
      var aspectScale = geoModel.get('aspectScale');
      var invertLongitute = true;
      var mapRecords = mapDataStorage.retrieveMap(name);

      if (mapRecords && mapRecords[0] && mapRecords[0].type === 'svg') {
        aspectScale == null && (aspectScale = 1);
        invertLongitute = false;
      } else {
        aspectScale == null && (aspectScale = 0.75);
      }

      var geo = new Geo(name + idx, name, geoModel.get('nameMap'), invertLongitute);
      geo.aspectScale = aspectScale;
      geo.zoomLimit = geoModel.get('scaleLimit');
      geoList.push(geo);
      setGeoCoords(geo, geoModel);
      geoModel.coordinateSystem = geo;
      geo.model = geoModel; // Inject resize method

      geo.resize = resizeGeo;
      geo.resize(geoModel, api);
    });
    ecModel.eachSeries(function (seriesModel) {
      var coordSys = seriesModel.get('coordinateSystem');

      if (coordSys === 'geo') {
        var geoIndex = seriesModel.get('geoIndex') || 0;
        seriesModel.coordinateSystem = geoList[geoIndex];
      }
    }); // If has map series

    var mapModelGroupBySeries = {};
    ecModel.eachSeriesByType('map', function (seriesModel) {
      if (!seriesModel.getHostGeoModel()) {
        var mapType = seriesModel.getMapType();
        mapModelGroupBySeries[mapType] = mapModelGroupBySeries[mapType] || [];
        mapModelGroupBySeries[mapType].push(seriesModel);
      }
    });
    zrUtil.each(mapModelGroupBySeries, function (mapSeries, mapType) {
      var nameMapList = zrUtil.map(mapSeries, function (singleMapSeries) {
        return singleMapSeries.get('nameMap');
      });
      var geo = new Geo(mapType, mapType, zrUtil.mergeAll(nameMapList));
      geo.zoomLimit = zrUtil.retrieve.apply(null, zrUtil.map(mapSeries, function (singleMapSeries) {
        return singleMapSeries.get('scaleLimit');
      }));
      geoList.push(geo); // Inject resize method

      geo.resize = resizeGeo;
      geo.aspectScale = mapSeries[0].get('aspectScale');
      geo.resize(mapSeries[0], api);
      zrUtil.each(mapSeries, function (singleMapSeries) {
        singleMapSeries.coordinateSystem = geo;
        setGeoCoords(geo, singleMapSeries);
      });
    });
    return geoList;
  },

  /**
   * Fill given regions array
   * @param  {Array.<Object>} originRegionArr
   * @param  {string} mapName
   * @param  {Object} [nameMap]
   * @return {Array}
   */
  getFilledRegions: function (originRegionArr, mapName, nameMap) {
    // Not use the original
    var regionsArr = (originRegionArr || []).slice();
    var dataNameMap = zrUtil.createHashMap();

    for (var i = 0; i < regionsArr.length; i++) {
      dataNameMap.set(regionsArr[i].name, regionsArr[i]);
    }

    var source = geoSourceManager.load(mapName, nameMap);
    zrUtil.each(source.regions, function (region) {
      var name = region.name;
      !dataNameMap.get(name) && regionsArr.push({
        name: name
      });
    });
    return regionsArr;
  }
};
echarts.registerCoordinateSystem('geo', geoCreator);
var _default = geoCreator;
module.exports = _default;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var vector = __webpack_require__(55);

var matrix = __webpack_require__(82);

var BoundingRect = __webpack_require__(57);

var Transformable = __webpack_require__(292);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Simple view coordinate system
 * Mapping given x, y to transformd view x, y
 */
var v2ApplyTransform = vector.applyTransform; // Dummy transform node

function TransformDummy() {
  Transformable.call(this);
}

zrUtil.mixin(TransformDummy, Transformable);

function View(name) {
  /**
   * @type {string}
   */
  this.name = name;
  /**
   * @type {Object}
   */

  this.zoomLimit;
  Transformable.call(this);
  this._roamTransformable = new TransformDummy();
  this._rawTransformable = new TransformDummy();
  this._center;
  this._zoom;
}

View.prototype = {
  constructor: View,
  type: 'view',

  /**
   * @param {Array.<string>}
   * @readOnly
   */
  dimensions: ['x', 'y'],

  /**
   * Set bounding rect
   * @param {number} x
   * @param {number} y
   * @param {number} width
   * @param {number} height
   */
  // PENDING to getRect
  setBoundingRect: function (x, y, width, height) {
    this._rect = new BoundingRect(x, y, width, height);
    return this._rect;
  },

  /**
   * @return {module:zrender/core/BoundingRect}
   */
  // PENDING to getRect
  getBoundingRect: function () {
    return this._rect;
  },

  /**
   * @param {number} x
   * @param {number} y
   * @param {number} width
   * @param {number} height
   */
  setViewRect: function (x, y, width, height) {
    this.transformTo(x, y, width, height);
    this._viewRect = new BoundingRect(x, y, width, height);
  },

  /**
   * Transformed to particular position and size
   * @param {number} x
   * @param {number} y
   * @param {number} width
   * @param {number} height
   */
  transformTo: function (x, y, width, height) {
    var rect = this.getBoundingRect();
    var rawTransform = this._rawTransformable;
    rawTransform.transform = rect.calculateTransform(new BoundingRect(x, y, width, height));
    rawTransform.decomposeTransform();

    this._updateTransform();
  },

  /**
   * Set center of view
   * @param {Array.<number>} [centerCoord]
   */
  setCenter: function (centerCoord) {
    if (!centerCoord) {
      return;
    }

    this._center = centerCoord;

    this._updateCenterAndZoom();
  },

  /**
   * @param {number} zoom
   */
  setZoom: function (zoom) {
    zoom = zoom || 1;
    var zoomLimit = this.zoomLimit;

    if (zoomLimit) {
      if (zoomLimit.max != null) {
        zoom = Math.min(zoomLimit.max, zoom);
      }

      if (zoomLimit.min != null) {
        zoom = Math.max(zoomLimit.min, zoom);
      }
    }

    this._zoom = zoom;

    this._updateCenterAndZoom();
  },

  /**
   * Get default center without roam
   */
  getDefaultCenter: function () {
    // Rect before any transform
    var rawRect = this.getBoundingRect();
    var cx = rawRect.x + rawRect.width / 2;
    var cy = rawRect.y + rawRect.height / 2;
    return [cx, cy];
  },
  getCenter: function () {
    return this._center || this.getDefaultCenter();
  },
  getZoom: function () {
    return this._zoom || 1;
  },

  /**
   * @return {Array.<number}
   */
  getRoamTransform: function () {
    return this._roamTransformable.getLocalTransform();
  },

  /**
   * Remove roam
   */
  _updateCenterAndZoom: function () {
    // Must update after view transform updated
    var rawTransformMatrix = this._rawTransformable.getLocalTransform();

    var roamTransform = this._roamTransformable;
    var defaultCenter = this.getDefaultCenter();
    var center = this.getCenter();
    var zoom = this.getZoom();
    center = vector.applyTransform([], center, rawTransformMatrix);
    defaultCenter = vector.applyTransform([], defaultCenter, rawTransformMatrix);
    roamTransform.origin = center;
    roamTransform.position = [defaultCenter[0] - center[0], defaultCenter[1] - center[1]];
    roamTransform.scale = [zoom, zoom];

    this._updateTransform();
  },

  /**
   * Update transform from roam and mapLocation
   * @private
   */
  _updateTransform: function () {
    var roamTransformable = this._roamTransformable;
    var rawTransformable = this._rawTransformable;
    rawTransformable.parent = roamTransformable;
    roamTransformable.updateTransform();
    rawTransformable.updateTransform();
    matrix.copy(this.transform || (this.transform = []), rawTransformable.transform || matrix.create());
    this._rawTransform = rawTransformable.getLocalTransform();
    this.invTransform = this.invTransform || [];
    matrix.invert(this.invTransform, this.transform);
    this.decomposeTransform();
  },
  getTransformInfo: function () {
    var roamTransform = this._roamTransformable.transform;
    var rawTransformable = this._rawTransformable;
    return {
      roamTransform: roamTransform ? zrUtil.slice(roamTransform) : matrix.create(),
      rawScale: zrUtil.slice(rawTransformable.scale),
      rawPosition: zrUtil.slice(rawTransformable.position)
    };
  },

  /**
   * @return {module:zrender/core/BoundingRect}
   */
  getViewRect: function () {
    return this._viewRect;
  },

  /**
   * Get view rect after roam transform
   * @return {module:zrender/core/BoundingRect}
   */
  getViewRectAfterRoam: function () {
    var rect = this.getBoundingRect().clone();
    rect.applyTransform(this.transform);
    return rect;
  },

  /**
   * Convert a single (lon, lat) data item to (x, y) point.
   * @param {Array.<number>} data
   * @param {boolean} noRoam
   * @param {Array.<number>} [out]
   * @return {Array.<number>}
   */
  dataToPoint: function (data, noRoam, out) {
    var transform = noRoam ? this._rawTransform : this.transform;
    out = out || [];
    return transform ? v2ApplyTransform(out, data, transform) : vector.copy(out, data);
  },

  /**
   * Convert a (x, y) point to (lon, lat) data
   * @param {Array.<number>} point
   * @return {Array.<number>}
   */
  pointToData: function (point) {
    var invTransform = this.invTransform;
    return invTransform ? v2ApplyTransform([], point, invTransform) : [point[0], point[1]];
  },

  /**
   * @implements
   * see {module:echarts/CoodinateSystem}
   */
  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),

  /**
   * @implements
   * see {module:echarts/CoodinateSystem}
   */
  convertFromPixel: zrUtil.curry(doConvert, 'pointToData'),

  /**
   * @implements
   * see {module:echarts/CoodinateSystem}
   */
  containPoint: function (point) {
    return this.getViewRectAfterRoam().contain(point[0], point[1]);
  }
  /**
   * @return {number}
   */
  // getScalarScale: function () {
  //     // Use determinant square root of transform to mutiply scalar
  //     var m = this.transform;
  //     var det = Math.sqrt(Math.abs(m[0] * m[3] - m[2] * m[1]));
  //     return det;
  // }

};
zrUtil.mixin(View, Transformable);

function doConvert(methodName, ecModel, finder, value) {
  var seriesModel = finder.seriesModel;
  var coordSys = seriesModel ? seriesModel.coordinateSystem : null; // e.g., graph.

  return coordSys === this ? coordSys[methodName](value) : null;
}

var _default = View;
module.exports = _default;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var linkList = __webpack_require__(660);

var List = __webpack_require__(98);

var createDimensions = __webpack_require__(207);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Tree data structure
 *
 * @module echarts/data/Tree
 */

/**
 * @constructor module:echarts/data/Tree~TreeNode
 * @param {string} name
 * @param {module:echarts/data/Tree} hostTree
 */
var TreeNode = function (name, hostTree) {
  /**
   * @type {string}
   */
  this.name = name || '';
  /**
   * Depth of node
   *
   * @type {number}
   * @readOnly
   */

  this.depth = 0;
  /**
   * Height of the subtree rooted at this node.
   * @type {number}
   * @readOnly
   */

  this.height = 0;
  /**
   * @type {module:echarts/data/Tree~TreeNode}
   * @readOnly
   */

  this.parentNode = null;
  /**
   * Reference to list item.
   * Do not persistent dataIndex outside,
   * besause it may be changed by list.
   * If dataIndex -1,
   * this node is logical deleted (filtered) in list.
   *
   * @type {Object}
   * @readOnly
   */

  this.dataIndex = -1;
  /**
   * @type {Array.<module:echarts/data/Tree~TreeNode>}
   * @readOnly
   */

  this.children = [];
  /**
   * @type {Array.<module:echarts/data/Tree~TreeNode>}
   * @pubilc
   */

  this.viewChildren = [];
  /**
   * @type {moduel:echarts/data/Tree}
   * @readOnly
   */

  this.hostTree = hostTree;
};

TreeNode.prototype = {
  constructor: TreeNode,

  /**
   * The node is removed.
   * @return {boolean} is removed.
   */
  isRemoved: function () {
    return this.dataIndex < 0;
  },

  /**
   * Travel this subtree (include this node).
   * Usage:
   *    node.eachNode(function () { ... }); // preorder
   *    node.eachNode('preorder', function () { ... }); // preorder
   *    node.eachNode('postorder', function () { ... }); // postorder
   *    node.eachNode(
   *        {order: 'postorder', attr: 'viewChildren'},
   *        function () { ... }
   *    ); // postorder
   *
   * @param {(Object|string)} options If string, means order.
   * @param {string=} options.order 'preorder' or 'postorder'
   * @param {string=} options.attr 'children' or 'viewChildren'
   * @param {Function} cb If in preorder and return false,
   *                      its subtree will not be visited.
   * @param {Object} [context]
   */
  eachNode: function (options, cb, context) {
    if (typeof options === 'function') {
      context = cb;
      cb = options;
      options = null;
    }

    options = options || {};

    if (zrUtil.isString(options)) {
      options = {
        order: options
      };
    }

    var order = options.order || 'preorder';
    var children = this[options.attr || 'children'];
    var suppressVisitSub;
    order === 'preorder' && (suppressVisitSub = cb.call(context, this));

    for (var i = 0; !suppressVisitSub && i < children.length; i++) {
      children[i].eachNode(options, cb, context);
    }

    order === 'postorder' && cb.call(context, this);
  },

  /**
   * Update depth and height of this subtree.
   *
   * @param  {number} depth
   */
  updateDepthAndHeight: function (depth) {
    var height = 0;
    this.depth = depth;

    for (var i = 0; i < this.children.length; i++) {
      var child = this.children[i];
      child.updateDepthAndHeight(depth + 1);

      if (child.height > height) {
        height = child.height;
      }
    }

    this.height = height + 1;
  },

  /**
   * @param  {string} id
   * @return {module:echarts/data/Tree~TreeNode}
   */
  getNodeById: function (id) {
    if (this.getId() === id) {
      return this;
    }

    for (var i = 0, children = this.children, len = children.length; i < len; i++) {
      var res = children[i].getNodeById(id);

      if (res) {
        return res;
      }
    }
  },

  /**
   * @param {module:echarts/data/Tree~TreeNode} node
   * @return {boolean}
   */
  contains: function (node) {
    if (node === this) {
      return true;
    }

    for (var i = 0, children = this.children, len = children.length; i < len; i++) {
      var res = children[i].contains(node);

      if (res) {
        return res;
      }
    }
  },

  /**
   * @param {boolean} includeSelf Default false.
   * @return {Array.<module:echarts/data/Tree~TreeNode>} order: [root, child, grandchild, ...]
   */
  getAncestors: function (includeSelf) {
    var ancestors = [];
    var node = includeSelf ? this : this.parentNode;

    while (node) {
      ancestors.push(node);
      node = node.parentNode;
    }

    ancestors.reverse();
    return ancestors;
  },

  /**
   * @param {string|Array=} [dimension='value'] Default 'value'. can be 0, 1, 2, 3
   * @return {number} Value.
   */
  getValue: function (dimension) {
    var data = this.hostTree.data;
    return data.get(data.getDimension(dimension || 'value'), this.dataIndex);
  },

  /**
   * @param {Object} layout
   * @param {boolean=} [merge=false]
   */
  setLayout: function (layout, merge) {
    this.dataIndex >= 0 && this.hostTree.data.setItemLayout(this.dataIndex, layout, merge);
  },

  /**
   * @return {Object} layout
   */
  getLayout: function () {
    return this.hostTree.data.getItemLayout(this.dataIndex);
  },

  /**
   * @param {string} [path]
   * @return {module:echarts/model/Model}
   */
  getModel: function (path) {
    if (this.dataIndex < 0) {
      return;
    }

    var hostTree = this.hostTree;
    var itemModel = hostTree.data.getItemModel(this.dataIndex);
    return itemModel.getModel(path);
  },

  /**
   * @example
   *  setItemVisual('color', color);
   *  setItemVisual({
   *      'color': color
   *  });
   */
  setVisual: function (key, value) {
    this.dataIndex >= 0 && this.hostTree.data.setItemVisual(this.dataIndex, key, value);
  },

  /**
   * Get item visual
   */
  getVisual: function (key, ignoreParent) {
    return this.hostTree.data.getItemVisual(this.dataIndex, key, ignoreParent);
  },

  /**
   * @public
   * @return {number}
   */
  getRawIndex: function () {
    return this.hostTree.data.getRawIndex(this.dataIndex);
  },

  /**
   * @public
   * @return {string}
   */
  getId: function () {
    return this.hostTree.data.getId(this.dataIndex);
  },

  /**
   * if this is an ancestor of another node
   *
   * @public
   * @param {TreeNode} node another node
   * @return {boolean} if is ancestor
   */
  isAncestorOf: function (node) {
    var parent = node.parentNode;

    while (parent) {
      if (parent === this) {
        return true;
      }

      parent = parent.parentNode;
    }

    return false;
  },

  /**
   * if this is an descendant of another node
   *
   * @public
   * @param {TreeNode} node another node
   * @return {boolean} if is descendant
   */
  isDescendantOf: function (node) {
    return node !== this && node.isAncestorOf(this);
  }
};
/**
 * @constructor
 * @alias module:echarts/data/Tree
 * @param {module:echarts/model/Model} hostModel
 */

function Tree(hostModel) {
  /**
   * @type {module:echarts/data/Tree~TreeNode}
   * @readOnly
   */
  this.root;
  /**
   * @type {module:echarts/data/List}
   * @readOnly
   */

  this.data;
  /**
   * Index of each item is the same as the raw index of coresponding list item.
   * @private
   * @type {Array.<module:echarts/data/Tree~TreeNode}
   */

  this._nodes = [];
  /**
   * @private
   * @readOnly
   * @type {module:echarts/model/Model}
   */

  this.hostModel = hostModel;
}

Tree.prototype = {
  constructor: Tree,
  type: 'tree',

  /**
   * Travel this subtree (include this node).
   * Usage:
   *    node.eachNode(function () { ... }); // preorder
   *    node.eachNode('preorder', function () { ... }); // preorder
   *    node.eachNode('postorder', function () { ... }); // postorder
   *    node.eachNode(
   *        {order: 'postorder', attr: 'viewChildren'},
   *        function () { ... }
   *    ); // postorder
   *
   * @param {(Object|string)} options If string, means order.
   * @param {string=} options.order 'preorder' or 'postorder'
   * @param {string=} options.attr 'children' or 'viewChildren'
   * @param {Function} cb
   * @param {Object}   [context]
   */
  eachNode: function (options, cb, context) {
    this.root.eachNode(options, cb, context);
  },

  /**
   * @param {number} dataIndex
   * @return {module:echarts/data/Tree~TreeNode}
   */
  getNodeByDataIndex: function (dataIndex) {
    var rawIndex = this.data.getRawIndex(dataIndex);
    return this._nodes[rawIndex];
  },

  /**
   * @param {string} name
   * @return {module:echarts/data/Tree~TreeNode}
   */
  getNodeByName: function (name) {
    return this.root.getNodeByName(name);
  },

  /**
   * Update item available by list,
   * when list has been performed options like 'filterSelf' or 'map'.
   */
  update: function () {
    var data = this.data;
    var nodes = this._nodes;

    for (var i = 0, len = nodes.length; i < len; i++) {
      nodes[i].dataIndex = -1;
    }

    for (var i = 0, len = data.count(); i < len; i++) {
      nodes[data.getRawIndex(i)].dataIndex = i;
    }
  },

  /**
   * Clear all layouts
   */
  clearLayouts: function () {
    this.data.clearItemLayouts();
  }
};
/**
 * data node format:
 * {
 *     name: ...
 *     value: ...
 *     children: [
 *         {
 *             name: ...
 *             value: ...
 *             children: ...
 *         },
 *         ...
 *     ]
 * }
 *
 * @static
 * @param {Object} dataRoot Root node.
 * @param {module:echarts/model/Model} hostModel
 * @return module:echarts/data/Tree
 */

Tree.createTree = function (dataRoot, hostModel, beforeLink) {
  var tree = new Tree(hostModel);
  var listData = [];
  var dimMax = 1;
  buildHierarchy(dataRoot);

  function buildHierarchy(dataNode, parentNode) {
    var value = dataNode.value;
    dimMax = Math.max(dimMax, zrUtil.isArray(value) ? value.length : 1);
    listData.push(dataNode);
    var node = new TreeNode(dataNode.name, tree);
    parentNode ? addChild(node, parentNode) : tree.root = node;

    tree._nodes.push(node);

    var children = dataNode.children;

    if (children) {
      for (var i = 0; i < children.length; i++) {
        buildHierarchy(children[i], node);
      }
    }
  }

  tree.root.updateDepthAndHeight(0);
  var dimensionsInfo = createDimensions(listData, {
    coordDimensions: ['value'],
    dimensionsCount: dimMax
  });
  var list = new List(dimensionsInfo, hostModel);
  list.initData(listData);
  beforeLink && beforeLink(list);
  linkList({
    mainData: list,
    struct: tree,
    structAttr: 'tree'
  });
  tree.update();
  return tree;
};
/**
 * It is needed to consider the mess of 'list', 'hostModel' when creating a TreeNote,
 * so this function is not ready and not necessary to be public.
 *
 * @param {(module:echarts/data/Tree~TreeNode|Object)} child
 */


function addChild(child, node) {
  var children = node.children;

  if (child.parentNode === node) {
    return;
  }

  children.push(child);
  child.parentNode = node;
}

var _default = Tree;
module.exports = _default;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var graphic = __webpack_require__(27);

var LineGroup = __webpack_require__(423);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @module echarts/chart/helper/LineDraw
 */
// import IncrementalDisplayable from 'zrender/src/graphic/IncrementalDisplayable';

/**
 * @alias module:echarts/component/marker/LineDraw
 * @constructor
 */
function LineDraw(ctor) {
  this._ctor = ctor || LineGroup;
  this.group = new graphic.Group();
}

var lineDrawProto = LineDraw.prototype;

lineDrawProto.isPersistent = function () {
  return true;
};
/**
 * @param {module:echarts/data/List} lineData
 */


lineDrawProto.updateData = function (lineData) {
  var lineDraw = this;
  var group = lineDraw.group;
  var oldLineData = lineDraw._lineData;
  lineDraw._lineData = lineData; // There is no oldLineData only when first rendering or switching from
  // stream mode to normal mode, where previous elements should be removed.

  if (!oldLineData) {
    group.removeAll();
  }

  var seriesScope = makeSeriesScope(lineData);
  lineData.diff(oldLineData).add(function (idx) {
    doAdd(lineDraw, lineData, idx, seriesScope);
  }).update(function (newIdx, oldIdx) {
    doUpdate(lineDraw, oldLineData, lineData, oldIdx, newIdx, seriesScope);
  }).remove(function (idx) {
    group.remove(oldLineData.getItemGraphicEl(idx));
  }).execute();
};

function doAdd(lineDraw, lineData, idx, seriesScope) {
  var itemLayout = lineData.getItemLayout(idx);

  if (!lineNeedsDraw(itemLayout)) {
    return;
  }

  var el = new lineDraw._ctor(lineData, idx, seriesScope);
  lineData.setItemGraphicEl(idx, el);
  lineDraw.group.add(el);
}

function doUpdate(lineDraw, oldLineData, newLineData, oldIdx, newIdx, seriesScope) {
  var itemEl = oldLineData.getItemGraphicEl(oldIdx);

  if (!lineNeedsDraw(newLineData.getItemLayout(newIdx))) {
    lineDraw.group.remove(itemEl);
    return;
  }

  if (!itemEl) {
    itemEl = new lineDraw._ctor(newLineData, newIdx, seriesScope);
  } else {
    itemEl.updateData(newLineData, newIdx, seriesScope);
  }

  newLineData.setItemGraphicEl(newIdx, itemEl);
  lineDraw.group.add(itemEl);
}

lineDrawProto.updateLayout = function () {
  var lineData = this._lineData; // Do not support update layout in incremental mode.

  if (!lineData) {
    return;
  }

  lineData.eachItemGraphicEl(function (el, idx) {
    el.updateLayout(lineData, idx);
  }, this);
};

lineDrawProto.incrementalPrepareUpdate = function (lineData) {
  this._seriesScope = makeSeriesScope(lineData);
  this._lineData = null;
  this.group.removeAll();
};

function isEffectObject(el) {
  return el.animators && el.animators.length > 0;
}

lineDrawProto.incrementalUpdate = function (taskParams, lineData) {
  function updateIncrementalAndHover(el) {
    if (!el.isGroup && !isEffectObject(el)) {
      el.incremental = el.useHoverLayer = true;
    }
  }

  for (var idx = taskParams.start; idx < taskParams.end; idx++) {
    var itemLayout = lineData.getItemLayout(idx);

    if (lineNeedsDraw(itemLayout)) {
      var el = new this._ctor(lineData, idx, this._seriesScope);
      el.traverse(updateIncrementalAndHover);
      this.group.add(el);
      lineData.setItemGraphicEl(idx, el);
    }
  }
};

function makeSeriesScope(lineData) {
  var hostModel = lineData.hostModel;
  return {
    lineStyle: hostModel.getModel('lineStyle').getLineStyle(),
    hoverLineStyle: hostModel.getModel('emphasis.lineStyle').getLineStyle(),
    labelModel: hostModel.getModel('label'),
    hoverLabelModel: hostModel.getModel('emphasis.label')
  };
}

lineDrawProto.remove = function () {
  this._clearIncremental();

  this._incremental = null;
  this.group.removeAll();
};

lineDrawProto._clearIncremental = function () {
  var incremental = this._incremental;

  if (incremental) {
    incremental.clearDisplaybles();
  }
};

function isPointNaN(pt) {
  return isNaN(pt[0]) || isNaN(pt[1]);
}

function lineNeedsDraw(pts) {
  return !isPointNaN(pts[0]) && !isPointNaN(pts[1]);
}

var _default = LineDraw;
module.exports = _default;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var vector = __webpack_require__(55);

var symbolUtil = __webpack_require__(99);

var LinePath = __webpack_require__(1639);

var graphic = __webpack_require__(27);

var _number = __webpack_require__(37);

var round = _number.round;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @module echarts/chart/helper/Line
 */
var SYMBOL_CATEGORIES = ['fromSymbol', 'toSymbol'];

function makeSymbolTypeKey(symbolCategory) {
  return '_' + symbolCategory + 'Type';
}
/**
 * @inner
 */


function createSymbol(name, lineData, idx) {
  var symbolType = lineData.getItemVisual(idx, name);

  if (!symbolType || symbolType === 'none') {
    return;
  }

  var color = lineData.getItemVisual(idx, 'color');
  var symbolSize = lineData.getItemVisual(idx, name + 'Size');
  var symbolRotate = lineData.getItemVisual(idx, name + 'Rotate');

  if (!zrUtil.isArray(symbolSize)) {
    symbolSize = [symbolSize, symbolSize];
  }

  var symbolPath = symbolUtil.createSymbol(symbolType, -symbolSize[0] / 2, -symbolSize[1] / 2, symbolSize[0], symbolSize[1], color); // rotate by default if symbolRotate is not specified or NaN

  symbolPath.__specifiedRotation = symbolRotate == null || isNaN(symbolRotate) ? void 0 : +symbolRotate * Math.PI / 180 || 0;
  symbolPath.name = name;
  return symbolPath;
}

function createLine(points) {
  var line = new LinePath({
    name: 'line',
    subPixelOptimize: true
  });
  setLinePoints(line.shape, points);
  return line;
}

function setLinePoints(targetShape, points) {
  targetShape.x1 = points[0][0];
  targetShape.y1 = points[0][1];
  targetShape.x2 = points[1][0];
  targetShape.y2 = points[1][1];
  targetShape.percent = 1;
  var cp1 = points[2];

  if (cp1) {
    targetShape.cpx1 = cp1[0];
    targetShape.cpy1 = cp1[1];
  } else {
    targetShape.cpx1 = NaN;
    targetShape.cpy1 = NaN;
  }
}

function updateSymbolAndLabelBeforeLineUpdate() {
  var lineGroup = this;
  var symbolFrom = lineGroup.childOfName('fromSymbol');
  var symbolTo = lineGroup.childOfName('toSymbol');
  var label = lineGroup.childOfName('label'); // Quick reject

  if (!symbolFrom && !symbolTo && label.ignore) {
    return;
  }

  var invScale = 1;
  var parentNode = this.parent;

  while (parentNode) {
    if (parentNode.scale) {
      invScale /= parentNode.scale[0];
    }

    parentNode = parentNode.parent;
  }

  var line = lineGroup.childOfName('line'); // If line not changed
  // FIXME Parent scale changed

  if (!this.__dirty && !line.__dirty) {
    return;
  }

  var percent = line.shape.percent;
  var fromPos = line.pointAt(0);
  var toPos = line.pointAt(percent);
  var d = vector.sub([], toPos, fromPos);
  vector.normalize(d, d);

  if (symbolFrom) {
    symbolFrom.attr('position', fromPos); // Fix #12388
    // when symbol is set to be 'arrow' in markLine,
    // symbolRotate value will be ignored, and compulsively use tangent angle.
    // rotate by default if symbol rotation is not specified

    var specifiedRotation = symbolFrom.__specifiedRotation;

    if (specifiedRotation == null) {
      var tangent = line.tangentAt(0);
      symbolFrom.attr('rotation', Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
    } else {
      symbolFrom.attr('rotation', specifiedRotation);
    }

    symbolFrom.attr('scale', [invScale * percent, invScale * percent]);
  }

  if (symbolTo) {
    symbolTo.attr('position', toPos); // Fix #12388
    // when symbol is set to be 'arrow' in markLine,
    // symbolRotate value will be ignored, and compulsively use tangent angle.
    // rotate by default if symbol rotation is not specified

    var specifiedRotation = symbolTo.__specifiedRotation;

    if (specifiedRotation == null) {
      var tangent = line.tangentAt(1);
      symbolTo.attr('rotation', -Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
    } else {
      symbolTo.attr('rotation', specifiedRotation);
    }

    symbolTo.attr('scale', [invScale * percent, invScale * percent]);
  }

  if (!label.ignore) {
    label.attr('position', toPos);
    var textPosition;
    var textAlign;
    var textVerticalAlign;
    var textOrigin;
    var distance = label.__labelDistance;
    var distanceX = distance[0] * invScale;
    var distanceY = distance[1] * invScale;
    var halfPercent = percent / 2;
    var tangent = line.tangentAt(halfPercent);
    var n = [tangent[1], -tangent[0]];
    var cp = line.pointAt(halfPercent);

    if (n[1] > 0) {
      n[0] = -n[0];
      n[1] = -n[1];
    }

    var dir = tangent[0] < 0 ? -1 : 1;

    if (label.__position !== 'start' && label.__position !== 'end') {
      var rotation = -Math.atan2(tangent[1], tangent[0]);

      if (toPos[0] < fromPos[0]) {
        rotation = Math.PI + rotation;
      }

      label.attr('rotation', rotation);
    }

    var dy;

    switch (label.__position) {
      case 'insideStartTop':
      case 'insideMiddleTop':
      case 'insideEndTop':
      case 'middle':
        dy = -distanceY;
        textVerticalAlign = 'bottom';
        break;

      case 'insideStartBottom':
      case 'insideMiddleBottom':
      case 'insideEndBottom':
        dy = distanceY;
        textVerticalAlign = 'top';
        break;

      default:
        dy = 0;
        textVerticalAlign = 'middle';
    }

    switch (label.__position) {
      case 'end':
        textPosition = [d[0] * distanceX + toPos[0], d[1] * distanceY + toPos[1]];
        textAlign = d[0] > 0.8 ? 'left' : d[0] < -0.8 ? 'right' : 'center';
        textVerticalAlign = d[1] > 0.8 ? 'top' : d[1] < -0.8 ? 'bottom' : 'middle';
        break;

      case 'start':
        textPosition = [-d[0] * distanceX + fromPos[0], -d[1] * distanceY + fromPos[1]];
        textAlign = d[0] > 0.8 ? 'right' : d[0] < -0.8 ? 'left' : 'center';
        textVerticalAlign = d[1] > 0.8 ? 'bottom' : d[1] < -0.8 ? 'top' : 'middle';
        break;

      case 'insideStartTop':
      case 'insideStart':
      case 'insideStartBottom':
        textPosition = [distanceX * dir + fromPos[0], fromPos[1] + dy];
        textAlign = tangent[0] < 0 ? 'right' : 'left';
        textOrigin = [-distanceX * dir, -dy];
        break;

      case 'insideMiddleTop':
      case 'insideMiddle':
      case 'insideMiddleBottom':
      case 'middle':
        textPosition = [cp[0], cp[1] + dy];
        textAlign = 'center';
        textOrigin = [0, -dy];
        break;

      case 'insideEndTop':
      case 'insideEnd':
      case 'insideEndBottom':
        textPosition = [-distanceX * dir + toPos[0], toPos[1] + dy];
        textAlign = tangent[0] >= 0 ? 'right' : 'left';
        textOrigin = [distanceX * dir, -dy];
        break;
    }

    label.attr({
      style: {
        // Use the user specified text align and baseline first
        textVerticalAlign: label.__verticalAlign || textVerticalAlign,
        textAlign: label.__textAlign || textAlign
      },
      position: textPosition,
      scale: [invScale, invScale],
      origin: textOrigin
    });
  }
}
/**
 * @constructor
 * @extends {module:zrender/graphic/Group}
 * @alias {module:echarts/chart/helper/Line}
 */


function Line(lineData, idx, seriesScope) {
  graphic.Group.call(this);

  this._createLine(lineData, idx, seriesScope);
}

var lineProto = Line.prototype; // Update symbol position and rotation

lineProto.beforeUpdate = updateSymbolAndLabelBeforeLineUpdate;

lineProto._createLine = function (lineData, idx, seriesScope) {
  var seriesModel = lineData.hostModel;
  var linePoints = lineData.getItemLayout(idx);
  var line = createLine(linePoints);
  line.shape.percent = 0;
  graphic.initProps(line, {
    shape: {
      percent: 1
    }
  }, seriesModel, idx);
  this.add(line);
  var label = new graphic.Text({
    name: 'label',
    // FIXME
    // Temporary solution for `focusNodeAdjacency`.
    // line label do not use the opacity of lineStyle.
    lineLabelOriginalOpacity: 1
  });
  this.add(label);
  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
    var symbol = createSymbol(symbolCategory, lineData, idx); // symbols must added after line to make sure
    // it will be updated after line#update.
    // Or symbol position and rotation update in line#beforeUpdate will be one frame slow

    this.add(symbol);
    this[makeSymbolTypeKey(symbolCategory)] = lineData.getItemVisual(idx, symbolCategory);
  }, this);

  this._updateCommonStl(lineData, idx, seriesScope);
};

lineProto.updateData = function (lineData, idx, seriesScope) {
  var seriesModel = lineData.hostModel;
  var line = this.childOfName('line');
  var linePoints = lineData.getItemLayout(idx);
  var target = {
    shape: {}
  };
  setLinePoints(target.shape, linePoints);
  graphic.updateProps(line, target, seriesModel, idx);
  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
    var symbolType = lineData.getItemVisual(idx, symbolCategory);
    var key = makeSymbolTypeKey(symbolCategory); // Symbol changed

    if (this[key] !== symbolType) {
      this.remove(this.childOfName(symbolCategory));
      var symbol = createSymbol(symbolCategory, lineData, idx);
      this.add(symbol);
    }

    this[key] = symbolType;
  }, this);

  this._updateCommonStl(lineData, idx, seriesScope);
};

lineProto._updateCommonStl = function (lineData, idx, seriesScope) {
  var seriesModel = lineData.hostModel;
  var line = this.childOfName('line');
  var lineStyle = seriesScope && seriesScope.lineStyle;
  var hoverLineStyle = seriesScope && seriesScope.hoverLineStyle;
  var labelModel = seriesScope && seriesScope.labelModel;
  var hoverLabelModel = seriesScope && seriesScope.hoverLabelModel; // Optimization for large dataset

  if (!seriesScope || lineData.hasItemOption) {
    var itemModel = lineData.getItemModel(idx);
    lineStyle = itemModel.getModel('lineStyle').getLineStyle();
    hoverLineStyle = itemModel.getModel('emphasis.lineStyle').getLineStyle();
    labelModel = itemModel.getModel('label');
    hoverLabelModel = itemModel.getModel('emphasis.label');
  }

  var visualColor = lineData.getItemVisual(idx, 'color');
  var visualOpacity = zrUtil.retrieve3(lineData.getItemVisual(idx, 'opacity'), lineStyle.opacity, 1);
  line.useStyle(zrUtil.defaults({
    strokeNoScale: true,
    fill: 'none',
    stroke: visualColor,
    opacity: visualOpacity
  }, lineStyle));
  line.hoverStyle = hoverLineStyle; // Update symbol

  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
    var symbol = this.childOfName(symbolCategory);

    if (symbol) {
      symbol.setColor(visualColor);
      symbol.setStyle({
        opacity: visualOpacity
      });
    }
  }, this);
  var showLabel = labelModel.getShallow('show');
  var hoverShowLabel = hoverLabelModel.getShallow('show');
  var label = this.childOfName('label');
  var defaultLabelColor;
  var baseText; // FIXME: the logic below probably should be merged to `graphic.setLabelStyle`.

  if (showLabel || hoverShowLabel) {
    defaultLabelColor = visualColor || '#000';
    baseText = seriesModel.getFormattedLabel(idx, 'normal', lineData.dataType);

    if (baseText == null) {
      var rawVal = seriesModel.getRawValue(idx);
      baseText = rawVal == null ? lineData.getName(idx) : isFinite(rawVal) ? round(rawVal) : rawVal;
    }
  }

  var normalText = showLabel ? baseText : null;
  var emphasisText = hoverShowLabel ? zrUtil.retrieve2(seriesModel.getFormattedLabel(idx, 'emphasis', lineData.dataType), baseText) : null;
  var labelStyle = label.style; // Always set `textStyle` even if `normalStyle.text` is null, because default
  // values have to be set on `normalStyle`.

  if (normalText != null || emphasisText != null) {
    graphic.setTextStyle(label.style, labelModel, {
      text: normalText
    }, {
      autoColor: defaultLabelColor
    });
    label.__textAlign = labelStyle.textAlign;
    label.__verticalAlign = labelStyle.textVerticalAlign; // 'start', 'middle', 'end'

    label.__position = labelModel.get('position') || 'middle';
    var distance = labelModel.get('distance');

    if (!zrUtil.isArray(distance)) {
      distance = [distance, distance];
    }

    label.__labelDistance = distance;
  }

  if (emphasisText != null) {
    // Only these properties supported in this emphasis style here.
    label.hoverStyle = {
      text: emphasisText,
      textFill: hoverLabelModel.getTextColor(true),
      // For merging hover style to normal style, do not use
      // `hoverLabelModel.getFont()` here.
      fontStyle: hoverLabelModel.getShallow('fontStyle'),
      fontWeight: hoverLabelModel.getShallow('fontWeight'),
      fontSize: hoverLabelModel.getShallow('fontSize'),
      fontFamily: hoverLabelModel.getShallow('fontFamily')
    };
  } else {
    label.hoverStyle = {
      text: null
    };
  }

  label.ignore = !showLabel && !hoverShowLabel;
  graphic.setHoverStyle(this);
};

lineProto.highlight = function () {
  this.trigger('emphasis');
};

lineProto.downplay = function () {
  this.trigger('normal');
};

lineProto.updateLayout = function (lineData, idx) {
  this.setLinePoints(lineData.getItemLayout(idx));
};

lineProto.setLinePoints = function (points) {
  var linePath = this.childOfName('line');
  setLinePoints(linePath.shape, points);
  linePath.dirty();
};

zrUtil.inherits(Line, graphic.Group);
var _default = Line;
module.exports = _default;

/***/ }),
/* 424 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function getNodeGlobalScale(seriesModel) {
  var coordSys = seriesModel.coordinateSystem;

  if (coordSys.type !== 'view') {
    return 1;
  }

  var nodeScaleRatio = seriesModel.option.nodeScaleRatio;
  var groupScale = coordSys.scale;
  var groupZoom = groupScale && groupScale[0] || 1; // Scale node when zoom changes

  var roamZoom = coordSys.getZoom();
  var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
  return nodeScale / groupZoom;
}

function getSymbolSize(node) {
  var symbolSize = node.getVisual('symbolSize');

  if (symbolSize instanceof Array) {
    symbolSize = (symbolSize[0] + symbolSize[1]) / 2;
  }

  return +symbolSize;
}

exports.getNodeGlobalScale = getNodeGlobalScale;
exports.getSymbolSize = getSymbolSize;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(1);

var Eventful = __webpack_require__(173);

var graphic = __webpack_require__(27);

var interactionMutex = __webpack_require__(658);

var DataDiffer = __webpack_require__(177);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var curry = zrUtil.curry;
var each = zrUtil.each;
var map = zrUtil.map;
var mathMin = Math.min;
var mathMax = Math.max;
var mathPow = Math.pow;
var COVER_Z = 10000;
var UNSELECT_THRESHOLD = 6;
var MIN_RESIZE_LINE_WIDTH = 6;
var MUTEX_RESOURCE_KEY = 'globalPan';
var DIRECTION_MAP = {
  w: [0, 0],
  e: [0, 1],
  n: [1, 0],
  s: [1, 1]
};
var CURSOR_MAP = {
  w: 'ew',
  e: 'ew',
  n: 'ns',
  s: 'ns',
  ne: 'nesw',
  sw: 'nesw',
  nw: 'nwse',
  se: 'nwse'
};
var DEFAULT_BRUSH_OPT = {
  brushStyle: {
    lineWidth: 2,
    stroke: 'rgba(0,0,0,0.3)',
    fill: 'rgba(0,0,0,0.1)'
  },
  transformable: true,
  brushMode: 'single',
  removeOnClick: false
};
var baseUID = 0;
/**
 * @alias module:echarts/component/helper/BrushController
 * @constructor
 * @mixin {module:zrender/mixin/Eventful}
 * @event module:echarts/component/helper/BrushController#brush
 *        params:
 *            areas: Array.<Array>, coord relates to container group,
 *                                    If no container specified, to global.
 *            opt {
 *                isEnd: boolean,
 *                removeOnClick: boolean
 *            }
 *
 * @param {module:zrender/zrender~ZRender} zr
 */

function BrushController(zr) {
  Eventful.call(this);
  /**
   * @type {module:zrender/zrender~ZRender}
   * @private
   */

  this._zr = zr;
  /**
   * @type {module:zrender/container/Group}
   * @readOnly
   */

  this.group = new graphic.Group();
  /**
   * Only for drawing (after enabledBrush).
   *     'line', 'rect', 'polygon' or false
   *     If passing false/null/undefined, disable brush.
   *     If passing 'auto', determined by panel.defaultBrushType
   * @private
   * @type {string}
   */

  this._brushType;
  /**
   * Only for drawing (after enabledBrush).
   *
   * @private
   * @type {Object}
   */

  this._brushOption;
  /**
   * @private
   * @type {Object}
   */

  this._panels;
  /**
   * @private
   * @type {Array.<nubmer>}
   */

  this._track = [];
  /**
   * @private
   * @type {boolean}
   */

  this._dragging;
  /**
   * @private
   * @type {Array}
   */

  this._covers = [];
  /**
   * @private
   * @type {moudule:zrender/container/Group}
   */

  this._creatingCover;
  /**
   * `true` means global panel
   * @private
   * @type {module:zrender/container/Group|boolean}
   */

  this._creatingPanel;
  /**
   * @private
   * @type {boolean}
   */

  this._enableGlobalPan;
  /**
   * @private
   * @type {boolean}
   */

  /**
   * @private
   * @type {string}
   */
  this._uid = 'brushController_' + baseUID++;
  /**
   * @private
   * @type {Object}
   */

  this._handlers = {};
  each(pointerHandlers, function (handler, eventName) {
    this._handlers[eventName] = zrUtil.bind(handler, this);
  }, this);
}

BrushController.prototype = {
  constructor: BrushController,

  /**
   * If set to null/undefined/false, select disabled.
   * @param {Object} brushOption
   * @param {string|boolean} brushOption.brushType 'line', 'rect', 'polygon' or false
   *                          If passing false/null/undefined, disable brush.
   *                          If passing 'auto', determined by panel.defaultBrushType.
   *                              ('auto' can not be used in global panel)
   * @param {number} [brushOption.brushMode='single'] 'single' or 'multiple'
   * @param {boolean} [brushOption.transformable=true]
   * @param {boolean} [brushOption.removeOnClick=false]
   * @param {Object} [brushOption.brushStyle]
   * @param {number} [brushOption.brushStyle.width]
   * @param {number} [brushOption.brushStyle.lineWidth]
   * @param {string} [brushOption.brushStyle.stroke]
   * @param {string} [brushOption.brushStyle.fill]
   * @param {number} [brushOption.z]
   */
  enableBrush: function (brushOption) {
    this._brushType && doDisableBrush(this);
    brushOption.brushType && doEnableBrush(this, brushOption);
    return this;
  },

  /**
   * @param {Array.<Object>} panelOpts If not pass, it is global brush.
   *        Each items: {
   *            panelId, // mandatory.
   *            clipPath, // mandatory. function.
   *            isTargetByCursor, // mandatory. function.
   *            defaultBrushType, // optional, only used when brushType is 'auto'.
   *            getLinearBrushOtherExtent, // optional. function.
   *        }
   */
  setPanels: function (panelOpts) {
    if (panelOpts && panelOpts.length) {
      var panels = this._panels = {};
      zrUtil.each(panelOpts, function (panelOpts) {
        panels[panelOpts.panelId] = zrUtil.clone(panelOpts);
      });
    } else {
      this._panels = null;
    }

    return this;
  },

  /**
   * @param {Object} [opt]
   * @return {boolean} [opt.enableGlobalPan=false]
   */
  mount: function (opt) {
    opt = opt || {};
    this._enableGlobalPan = opt.enableGlobalPan;
    var thisGroup = this.group;

    this._zr.add(thisGroup);

    thisGroup.attr({
      position: opt.position || [0, 0],
      rotation: opt.rotation || 0,
      scale: opt.scale || [1, 1]
    });
    this._transform = thisGroup.getLocalTransform();
    return this;
  },
  eachCover: function (cb, context) {
    each(this._covers, cb, context);
  },

  /**
   * Update covers.
   * @param {Array.<Object>} brushOptionList Like:
   *        [
   *            {id: 'xx', brushType: 'line', range: [23, 44], brushStyle, transformable},
   *            {id: 'yy', brushType: 'rect', range: [[23, 44], [23, 54]]},
   *            ...
   *        ]
   *        `brushType` is required in each cover info. (can not be 'auto')
   *        `id` is not mandatory.
   *        `brushStyle`, `transformable` is not mandatory, use DEFAULT_BRUSH_OPT by default.
   *        If brushOptionList is null/undefined, all covers removed.
   */
  updateCovers: function (brushOptionList) {
    brushOptionList = zrUtil.map(brushOptionList, function (brushOption) {
      return zrUtil.merge(zrUtil.clone(DEFAULT_BRUSH_OPT), brushOption, true);
    });
    var tmpIdPrefix = '\0-brush-index-';
    var oldCovers = this._covers;
    var newCovers = this._covers = [];
    var controller = this;
    var creatingCover = this._creatingCover;
    new DataDiffer(oldCovers, brushOptionList, oldGetKey, getKey).add(addOrUpdate).update(addOrUpdate).remove(remove).execute();
    return this;

    function getKey(brushOption, index) {
      return (brushOption.id != null ? brushOption.id : tmpIdPrefix + index) + '-' + brushOption.brushType;
    }

    function oldGetKey(cover, index) {
      return getKey(cover.__brushOption, index);
    }

    function addOrUpdate(newIndex, oldIndex) {
      var newBrushOption = brushOptionList[newIndex]; // Consider setOption in event listener of brushSelect,
      // where updating cover when creating should be forbiden.

      if (oldIndex != null && oldCovers[oldIndex] === creatingCover) {
        newCovers[newIndex] = oldCovers[oldIndex];
      } else {
        var cover = newCovers[newIndex] = oldIndex != null ? (oldCovers[oldIndex].__brushOption = newBrushOption, oldCovers[oldIndex]) : endCreating(controller, createCover(controller, newBrushOption));
        updateCoverAfterCreation(controller, cover);
      }
    }

    function remove(oldIndex) {
      if (oldCovers[oldIndex] !== creatingCover) {
        controller.group.remove(oldCovers[oldIndex]);
      }
    }
  },
  unmount: function () {
    this.enableBrush(false); // container may 'removeAll' outside.

    clearCovers(this);

    this._zr.remove(this.group);

    return this;
  },
  dispose: function () {
    this.unmount();
    this.off();
  }
};
zrUtil.mixin(BrushController, Eventful);

function doEnableBrush(controller, brushOption) {
  var zr = controller._zr; // Consider roam, which takes globalPan too.

  if (!controller._enableGlobalPan) {
    interactionMutex.take(zr, MUTEX_RESOURCE_KEY, controller._uid);
  }

  mountHandlers(zr, controller._handlers);
  controller._brushType = brushOption.brushType;
  controller._brushOption = zrUtil.merge(zrUtil.clone(DEFAULT_BRUSH_OPT), brushOption, true);
}

function doDisableBrush(controller) {
  var zr = controller._zr;
  interactionMutex.release(zr, MUTEX_RESOURCE_KEY, controller._uid);
  unmountHandlers(zr, controller._handlers);
  controller._brushType = controller._brushOption = null;
}

function mountHandlers(zr, handlers) {
  each(handlers, function (handler, eventName) {
    zr.on(eventName, handler);
  });
}

function unmountHandlers(zr, handlers) {
  each(handlers, function (handler, eventName) {
    zr.off(eventName, handler);
  });
}

function createCover(controller, brushOption) {
  var cover = coverRenderers[brushOption.brushType].createCover(controller, brushOption);
  cover.__brushOption = brushOption;
  updateZ(cover, brushOption);
  controller.group.add(cover);
  return cover;
}

function endCreating(controller, creatingCover) {
  var coverRenderer = getCoverRenderer(creatingCover);

  if (coverRenderer.endCreating) {
    coverRenderer.endCreating(controller, creatingCover);
    updateZ(creatingCover, creatingCover.__brushOption);
  }

  return creatingCover;
}

function updateCoverShape(controller, cover) {
  var brushOption = cover.__brushOption;
  getCoverRenderer(cover).updateCoverShape(controller, cover, brushOption.range, brushOption);
}

function updateZ(cover, brushOption) {
  var z = brushOption.z;
  z == null && (z = COVER_Z);
  cover.traverse(function (el) {
    el.z = z;
    el.z2 = z; // Consider in given container.
  });
}

function updateCoverAfterCreation(controller, cover) {
  getCoverRenderer(cover).updateCommon(controller, cover);
  updateCoverShape(controller, cover);
}

function getCoverRenderer(cover) {
  return coverRenderers[cover.__brushOption.brushType];
} // return target panel or `true` (means global panel)


function getPanelByPoint(controller, e, localCursorPoint) {
  var panels = controller._panels;

  if (!panels) {
    return true; // Global panel
  }

  var panel;
  var transform = controller._transform;
  each(panels, function (pn) {
    pn.isTargetByCursor(e, localCursorPoint, transform) && (panel = pn);
  });
  return panel;
} // Return a panel or true


function getPanelByCover(controller, cover) {
  var panels = controller._panels;

  if (!panels) {
    return true; // Global panel
  }

  var panelId = cover.__brushOption.panelId; // User may give cover without coord sys info,
  // which is then treated as global panel.

  return panelId != null ? panels[panelId] : true;
}

function clearCovers(controller) {
  var covers = controller._covers;
  var originalLength = covers.length;
  each(covers, function (cover) {
    controller.group.remove(cover);
  }, controller);
  covers.length = 0;
  return !!originalLength;
}

function trigger(controller, opt) {
  var areas = map(controller._covers, function (cover) {
    var brushOption = cover.__brushOption;
    var range = zrUtil.clone(brushOption.range);
    return {
      brushType: brushOption.brushType,
      panelId: brushOption.panelId,
      range: range
    };
  });
  controller.trigger('brush', areas, {
    isEnd: !!opt.isEnd,
    removeOnClick: !!opt.removeOnClick
  });
}

function shouldShowCover(controller) {
  var track = controller._track;

  if (!track.length) {
    return false;
  }

  var p2 = track[track.length - 1];
  var p1 = track[0];
  var dx = p2[0] - p1[0];
  var dy = p2[1] - p1[1];
  var dist = mathPow(dx * dx + dy * dy, 0.5);
  return dist > UNSELECT_THRESHOLD;
}

function getTrackEnds(track) {
  var tail = track.length - 1;
  tail < 0 && (tail = 0);
  return [track[0], track[tail]];
}

function createBaseRectCover(doDrift, controller, brushOption, edgeNames) {
  var cover = new graphic.Group();
  cover.add(new graphic.Rect({
    name: 'main',
    style: makeStyle(brushOption),
    silent: true,
    draggable: true,
    cursor: 'move',
    drift: curry(doDrift, controller, cover, 'nswe'),
    ondragend: curry(trigger, controller, {
      isEnd: true
    })
  }));
  each(edgeNames, function (name) {
    cover.add(new graphic.Rect({
      name: name,
      style: {
        opacity: 0
      },
      draggable: true,
      silent: true,
      invisible: true,
      drift: curry(doDrift, controller, cover, name),
      ondragend: curry(trigger, controller, {
        isEnd: true
      })
    }));
  });
  return cover;
}

function updateBaseRect(controller, cover, localRange, brushOption) {
  var lineWidth = brushOption.brushStyle.lineWidth || 0;
  var handleSize = mathMax(lineWidth, MIN_RESIZE_LINE_WIDTH);
  var x = localRange[0][0];
  var y = localRange[1][0];
  var xa = x - lineWidth / 2;
  var ya = y - lineWidth / 2;
  var x2 = localRange[0][1];
  var y2 = localRange[1][1];
  var x2a = x2 - handleSize + lineWidth / 2;
  var y2a = y2 - handleSize + lineWidth / 2;
  var width = x2 - x;
  var height = y2 - y;
  var widtha = width + lineWidth;
  var heighta = height + lineWidth;
  updateRectShape(controller, cover, 'main', x, y, width, height);

  if (brushOption.transformable) {
    updateRectShape(controller, cover, 'w', xa, ya, handleSize, heighta);
    updateRectShape(controller, cover, 'e', x2a, ya, handleSize, heighta);
    updateRectShape(controller, cover, 'n', xa, ya, widtha, handleSize);
    updateRectShape(controller, cover, 's', xa, y2a, widtha, handleSize);
    updateRectShape(controller, cover, 'nw', xa, ya, handleSize, handleSize);
    updateRectShape(controller, cover, 'ne', x2a, ya, handleSize, handleSize);
    updateRectShape(controller, cover, 'sw', xa, y2a, handleSize, handleSize);
    updateRectShape(controller, cover, 'se', x2a, y2a, handleSize, handleSize);
  }
}

function updateCommon(controller, cover) {
  var brushOption = cover.__brushOption;
  var transformable = brushOption.transformable;
  var mainEl = cover.childAt(0);
  mainEl.useStyle(makeStyle(brushOption));
  mainEl.attr({
    silent: !transformable,
    cursor: transformable ? 'move' : 'default'
  });
  each(['w', 'e', 'n', 's', 'se', 'sw', 'ne', 'nw'], function (name) {
    var el = cover.childOfName(name);
    var globalDir = getGlobalDirection(controller, name);
    el && el.attr({
      silent: !transformable,
      invisible: !transformable,
      cursor: transformable ? CURSOR_MAP[globalDir] + '-resize' : null
    });
  });
}

function updateRectShape(controller, cover, name, x, y, w, h) {
  var el = cover.childOfName(name);
  el && el.setShape(pointsToRect(clipByPanel(controller, cover, [[x, y], [x + w, y + h]])));
}

function makeStyle(brushOption) {
  return zrUtil.defaults({
    strokeNoScale: true
  }, brushOption.brushStyle);
}

function formatRectRange(x, y, x2, y2) {
  var min = [mathMin(x, x2), mathMin(y, y2)];
  var max = [mathMax(x, x2), mathMax(y, y2)];
  return [[min[0], max[0]], // x range
  [min[1], max[1]] // y range
  ];
}

function getTransform(controller) {
  return graphic.getTransform(controller.group);
}

function getGlobalDirection(controller, localDirection) {
  if (localDirection.length > 1) {
    localDirection = localDirection.split('');
    var globalDir = [getGlobalDirection(controller, localDirection[0]), getGlobalDirection(controller, localDirection[1])];
    (globalDir[0] === 'e' || globalDir[0] === 'w') && globalDir.reverse();
    return globalDir.join('');
  } else {
    var map = {
      w: 'left',
      e: 'right',
      n: 'top',
      s: 'bottom'
    };
    var inverseMap = {
      left: 'w',
      right: 'e',
      top: 'n',
      bottom: 's'
    };
    var globalDir = graphic.transformDirection(map[localDirection], getTransform(controller));
    return inverseMap[globalDir];
  }
}

function driftRect(toRectRange, fromRectRange, controller, cover, name, dx, dy, e) {
  var brushOption = cover.__brushOption;
  var rectRange = toRectRange(brushOption.range);
  var localDelta = toLocalDelta(controller, dx, dy);
  each(name.split(''), function (namePart) {
    var ind = DIRECTION_MAP[namePart];
    rectRange[ind[0]][ind[1]] += localDelta[ind[0]];
  });
  brushOption.range = fromRectRange(formatRectRange(rectRange[0][0], rectRange[1][0], rectRange[0][1], rectRange[1][1]));
  updateCoverAfterCreation(controller, cover);
  trigger(controller, {
    isEnd: false
  });
}

function driftPolygon(controller, cover, dx, dy, e) {
  var range = cover.__brushOption.range;
  var localDelta = toLocalDelta(controller, dx, dy);
  each(range, function (point) {
    point[0] += localDelta[0];
    point[1] += localDelta[1];
  });
  updateCoverAfterCreation(controller, cover);
  trigger(controller, {
    isEnd: false
  });
}

function toLocalDelta(controller, dx, dy) {
  var thisGroup = controller.group;
  var localD = thisGroup.transformCoordToLocal(dx, dy);
  var localZero = thisGroup.transformCoordToLocal(0, 0);
  return [localD[0] - localZero[0], localD[1] - localZero[1]];
}

function clipByPanel(controller, cover, data) {
  var panel = getPanelByCover(controller, cover);
  return panel && panel !== true ? panel.clipPath(data, controller._transform) : zrUtil.clone(data);
}

function pointsToRect(points) {
  var xmin = mathMin(points[0][0], points[1][0]);
  var ymin = mathMin(points[0][1], points[1][1]);
  var xmax = mathMax(points[0][0], points[1][0]);
  var ymax = mathMax(points[0][1], points[1][1]);
  return {
    x: xmin,
    y: ymin,
    width: xmax - xmin,
    height: ymax - ymin
  };
}

function resetCursor(controller, e, localCursorPoint) {
  if ( // Check active
  !controller._brushType // resetCursor should be always called when mouse is in zr area,
  // but not called when mouse is out of zr area to avoid bad influence
  // if `mousemove`, `mouseup` are triggered from `document` event.
  || isOutsideZrArea(controller, e)) {
    return;
  }

  var zr = controller._zr;
  var covers = controller._covers;
  var currPanel = getPanelByPoint(controller, e, localCursorPoint); // Check whether in covers.

  if (!controller._dragging) {
    for (var i = 0; i < covers.length; i++) {
      var brushOption = covers[i].__brushOption;

      if (currPanel && (currPanel === true || brushOption.panelId === currPanel.panelId) && coverRenderers[brushOption.brushType].contain(covers[i], localCursorPoint[0], localCursorPoint[1])) {
        // Use cursor style set on cover.
        return;
      }
    }
  }

  currPanel && zr.setCursorStyle('crosshair');
}

function preventDefault(e) {
  var rawE = e.event;
  rawE.preventDefault && rawE.preventDefault();
}

function mainShapeContain(cover, x, y) {
  return cover.childOfName('main').contain(x, y);
}

function updateCoverByMouse(controller, e, localCursorPoint, isEnd) {
  var creatingCover = controller._creatingCover;
  var panel = controller._creatingPanel;
  var thisBrushOption = controller._brushOption;
  var eventParams;

  controller._track.push(localCursorPoint.slice());

  if (shouldShowCover(controller) || creatingCover) {
    if (panel && !creatingCover) {
      thisBrushOption.brushMode === 'single' && clearCovers(controller);
      var brushOption = zrUtil.clone(thisBrushOption);
      brushOption.brushType = determineBrushType(brushOption.brushType, panel);
      brushOption.panelId = panel === true ? null : panel.panelId;
      creatingCover = controller._creatingCover = createCover(controller, brushOption);

      controller._covers.push(creatingCover);
    }

    if (creatingCover) {
      var coverRenderer = coverRenderers[determineBrushType(controller._brushType, panel)];
      var coverBrushOption = creatingCover.__brushOption;
      coverBrushOption.range = coverRenderer.getCreatingRange(clipByPanel(controller, creatingCover, controller._track));

      if (isEnd) {
        endCreating(controller, creatingCover);
        coverRenderer.updateCommon(controller, creatingCover);
      }

      updateCoverShape(controller, creatingCover);
      eventParams = {
        isEnd: isEnd
      };
    }
  } else if (isEnd && thisBrushOption.brushMode === 'single' && thisBrushOption.removeOnClick) {
    // Help user to remove covers easily, only by a tiny drag, in 'single' mode.
    // But a single click do not clear covers, because user may have casual
    // clicks (for example, click on other component and do not expect covers
    // disappear).
    // Only some cover removed, trigger action, but not every click trigger action.
    if (getPanelByPoint(controller, e, localCursorPoint) && clearCovers(controller)) {
      eventParams = {
        isEnd: isEnd,
        removeOnClick: true
      };
    }
  }

  return eventParams;
}

function determineBrushType(brushType, panel) {
  if (brushType === 'auto') {
    return panel.defaultBrushType;
  }

  return brushType;
}

var pointerHandlers = {
  mousedown: function (e) {
    if (this._dragging) {
      // In case some browser do not support globalOut,
      // and release mose out side the browser.
      handleDragEnd(this, e);
    } else if (!e.target || !e.target.draggable) {
      preventDefault(e);
      var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
      this._creatingCover = null;
      var panel = this._creatingPanel = getPanelByPoint(this, e, localCursorPoint);

      if (panel) {
        this._dragging = true;
        this._track = [localCursorPoint.slice()];
      }
    }
  },
  mousemove: function (e) {
    var x = e.offsetX;
    var y = e.offsetY;
    var localCursorPoint = this.group.transformCoordToLocal(x, y);
    resetCursor(this, e, localCursorPoint);

    if (this._dragging) {
      preventDefault(e);
      var eventParams = updateCoverByMouse(this, e, localCursorPoint, false);
      eventParams && trigger(this, eventParams);
    }
  },
  mouseup: function (e) {
    handleDragEnd(this, e);
  }
};

function handleDragEnd(controller, e) {
  if (controller._dragging) {
    preventDefault(e);
    var x = e.offsetX;
    var y = e.offsetY;
    var localCursorPoint = controller.group.transformCoordToLocal(x, y);
    var eventParams = updateCoverByMouse(controller, e, localCursorPoint, true);
    controller._dragging = false;
    controller._track = [];
    controller._creatingCover = null; // trigger event shoule be at final, after procedure will be nested.

    eventParams && trigger(controller, eventParams);
  }
}

function isOutsideZrArea(controller, x, y) {
  var zr = controller._zr;
  return x < 0 || x > zr.getWidth() || y < 0 || y > zr.getHeight();
}
/**
 * key: brushType
 * @type {Object}
 */


var coverRenderers = {
  lineX: getLineRenderer(0),
  lineY: getLineRenderer(1),
  rect: {
    createCover: function (controller, brushOption) {
      return createBaseRectCover(curry(driftRect, function (range) {
        return range;
      }, function (range) {
        return range;
      }), controller, brushOption, ['w', 'e', 'n', 's', 'se', 'sw', 'ne', 'nw']);
    },
    getCreatingRange: function (localTrack) {
      var ends = getTrackEnds(localTrack);
      return formatRectRange(ends[1][0], ends[1][1], ends[0][0], ends[0][1]);
    },
    updateCoverShape: function (controller, cover, localRange, brushOption) {
      updateBaseRect(controller, cover, localRange, brushOption);
    },
    updateCommon: updateCommon,
    contain: mainShapeContain
  },
  polygon: {
    createCover: function (controller, brushOption) {
      var cover = new graphic.Group(); // Do not use graphic.Polygon because graphic.Polyline do not close the
      // border of the shape when drawing, which is a better experience for user.

      cover.add(new graphic.Polyline({
        name: 'main',
        style: makeStyle(brushOption),
        silent: true
      }));
      return cover;
    },
    getCreatingRange: function (localTrack) {
      return localTrack;
    },
    endCreating: function (controller, cover) {
      cover.remove(cover.childAt(0)); // Use graphic.Polygon close the shape.

      cover.add(new graphic.Polygon({
        name: 'main',
        draggable: true,
        drift: curry(driftPolygon, controller, cover),
        ondragend: curry(trigger, controller, {
          isEnd: true
        })
      }));
    },
    updateCoverShape: function (controller, cover, localRange, brushOption) {
      cover.childAt(0).setShape({
        points: clipByPanel(controller, cover, localRange)
      });
    },
    updateCommon: updateCommon,
    contain: mainShapeContain
  }
};

function getLineRenderer(xyIndex) {
  return {
    createCover: function (controller, brushOption) {
      return createBaseRectCover(curry(driftRect, function (range) {
        var rectRange = [range, [0, 100]];
        xyIndex && rectRange.reverse();
        return rectRange;
      }, function (rectRange) {
        return rectRange[xyIndex];
      }), controller, brushOption, [['w', 'e'], ['n', 's']][xyIndex]);
    },
    getCreatingRange: function (localTrack) {
      var ends = getTrackEnds(localTrack);
      var min = mathMin(ends[0][xyIndex], ends[1][xyIndex]);
      var max = mathMax(ends[0][xyIndex], ends[1][xyIndex]);
      return [min, max];
    },
    updateCoverShape: function (controller, cover, localRange, brushOption) {
      var otherExtent; // If brushWidth not specified, fit the panel.

      var panel = getPanelByCover(controller, cover);

      if (panel !== true && panel.getLinearBrushOtherExtent) {
        otherExtent = panel.getLinearBrushOtherExtent(xyIndex, controller._transform);
      } else {
        var zr = controller._zr;
        otherExtent = [0, [zr.getWidth(), zr.getHeight()][1 - xyIndex]];
      }

      var rectRange = [localRange, otherExtent];
      xyIndex && rectRange.reverse();
      updateBaseRect(controller, cover, rectRange, brushOption);
    },
    updateCommon: updateCommon,
    contain: mainShapeContain
  };
}

var _default = BrushController;
module.exports = _default;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var clazzUtil = __webpack_require__(135);

var graphic = __webpack_require__(27);

var axisPointerModelHelper = __webpack_require__(303);

var eventTool = __webpack_require__(121);

var throttleUtil = __webpack_require__(148);

var _model = __webpack_require__(44);

var makeInner = _model.makeInner;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var inner = makeInner();
var clone = zrUtil.clone;
var bind = zrUtil.bind;
/**
 * Base axis pointer class in 2D.
 * Implemenents {module:echarts/component/axis/IAxisPointer}.
 */

function BaseAxisPointer() {}

BaseAxisPointer.prototype = {
  /**
   * @private
   */
  _group: null,

  /**
   * @private
   */
  _lastGraphicKey: null,

  /**
   * @private
   */
  _handle: null,

  /**
   * @private
   */
  _dragging: false,

  /**
   * @private
   */
  _lastValue: null,

  /**
   * @private
   */
  _lastStatus: null,

  /**
   * @private
   */
  _payloadInfo: null,

  /**
   * In px, arbitrary value. Do not set too small,
   * no animation is ok for most cases.
   * @protected
   */
  animationThreshold: 15,

  /**
   * @implement
   */
  render: function (axisModel, axisPointerModel, api, forceRender) {
    var value = axisPointerModel.get('value');
    var status = axisPointerModel.get('status'); // Bind them to `this`, not in closure, otherwise they will not
    // be replaced when user calling setOption in not merge mode.

    this._axisModel = axisModel;
    this._axisPointerModel = axisPointerModel;
    this._api = api; // Optimize: `render` will be called repeatly during mouse move.
    // So it is power consuming if performing `render` each time,
    // especially on mobile device.

    if (!forceRender && this._lastValue === value && this._lastStatus === status) {
      return;
    }

    this._lastValue = value;
    this._lastStatus = status;
    var group = this._group;
    var handle = this._handle;

    if (!status || status === 'hide') {
      // Do not clear here, for animation better.
      group && group.hide();
      handle && handle.hide();
      return;
    }

    group && group.show();
    handle && handle.show(); // Otherwise status is 'show'

    var elOption = {};
    this.makeElOption(elOption, value, axisModel, axisPointerModel, api); // Enable change axis pointer type.

    var graphicKey = elOption.graphicKey;

    if (graphicKey !== this._lastGraphicKey) {
      this.clear(api);
    }

    this._lastGraphicKey = graphicKey;
    var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);

    if (!group) {
      group = this._group = new graphic.Group();
      this.createPointerEl(group, elOption, axisModel, axisPointerModel);
      this.createLabelEl(group, elOption, axisModel, axisPointerModel);
      api.getZr().add(group);
    } else {
      var doUpdateProps = zrUtil.curry(updateProps, axisPointerModel, moveAnimation);
      this.updatePointerEl(group, elOption, doUpdateProps, axisPointerModel);
      this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
    }

    updateMandatoryProps(group, axisPointerModel, true);

    this._renderHandle(value);
  },

  /**
   * @implement
   */
  remove: function (api) {
    this.clear(api);
  },

  /**
   * @implement
   */
  dispose: function (api) {
    this.clear(api);
  },

  /**
   * @protected
   */
  determineAnimation: function (axisModel, axisPointerModel) {
    var animation = axisPointerModel.get('animation');
    var axis = axisModel.axis;
    var isCategoryAxis = axis.type === 'category';
    var useSnap = axisPointerModel.get('snap'); // Value axis without snap always do not snap.

    if (!useSnap && !isCategoryAxis) {
      return false;
    }

    if (animation === 'auto' || animation == null) {
      var animationThreshold = this.animationThreshold;

      if (isCategoryAxis && axis.getBandWidth() > animationThreshold) {
        return true;
      } // It is important to auto animation when snap used. Consider if there is
      // a dataZoom, animation will be disabled when too many points exist, while
      // it will be enabled for better visual effect when little points exist.


      if (useSnap) {
        var seriesDataCount = axisPointerModelHelper.getAxisInfo(axisModel).seriesDataCount;
        var axisExtent = axis.getExtent(); // Approximate band width

        return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
      }

      return false;
    }

    return animation === true;
  },

  /**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */
  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {// Shoule be implemenented by sub-class.
  },

  /**
   * @protected
   */
  createPointerEl: function (group, elOption, axisModel, axisPointerModel) {
    var pointerOption = elOption.pointer;

    if (pointerOption) {
      var pointerEl = inner(group).pointerEl = new graphic[pointerOption.type](clone(elOption.pointer));
      group.add(pointerEl);
    }
  },

  /**
   * @protected
   */
  createLabelEl: function (group, elOption, axisModel, axisPointerModel) {
    if (elOption.label) {
      var labelEl = inner(group).labelEl = new graphic.Rect(clone(elOption.label));
      group.add(labelEl);
      updateLabelShowHide(labelEl, axisPointerModel);
    }
  },

  /**
   * @protected
   */
  updatePointerEl: function (group, elOption, updateProps) {
    var pointerEl = inner(group).pointerEl;

    if (pointerEl && elOption.pointer) {
      pointerEl.setStyle(elOption.pointer.style);
      updateProps(pointerEl, {
        shape: elOption.pointer.shape
      });
    }
  },

  /**
   * @protected
   */
  updateLabelEl: function (group, elOption, updateProps, axisPointerModel) {
    var labelEl = inner(group).labelEl;

    if (labelEl) {
      labelEl.setStyle(elOption.label.style);
      updateProps(labelEl, {
        // Consider text length change in vertical axis, animation should
        // be used on shape, otherwise the effect will be weird.
        shape: elOption.label.shape,
        position: elOption.label.position
      });
      updateLabelShowHide(labelEl, axisPointerModel);
    }
  },

  /**
   * @private
   */
  _renderHandle: function (value) {
    if (this._dragging || !this.updateHandleTransform) {
      return;
    }

    var axisPointerModel = this._axisPointerModel;

    var zr = this._api.getZr();

    var handle = this._handle;
    var handleModel = axisPointerModel.getModel('handle');
    var status = axisPointerModel.get('status');

    if (!handleModel.get('show') || !status || status === 'hide') {
      handle && zr.remove(handle);
      this._handle = null;
      return;
    }

    var isInit;

    if (!this._handle) {
      isInit = true;
      handle = this._handle = graphic.createIcon(handleModel.get('icon'), {
        cursor: 'move',
        draggable: true,
        onmousemove: function (e) {
          // Fot mobile devicem, prevent screen slider on the button.
          eventTool.stop(e.event);
        },
        onmousedown: bind(this._onHandleDragMove, this, 0, 0),
        drift: bind(this._onHandleDragMove, this),
        ondragend: bind(this._onHandleDragEnd, this)
      });
      zr.add(handle);
    }

    updateMandatoryProps(handle, axisPointerModel, false); // update style

    var includeStyles = ['color', 'borderColor', 'borderWidth', 'opacity', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY'];
    handle.setStyle(handleModel.getItemStyle(null, includeStyles)); // update position

    var handleSize = handleModel.get('size');

    if (!zrUtil.isArray(handleSize)) {
      handleSize = [handleSize, handleSize];
    }

    handle.attr('scale', [handleSize[0] / 2, handleSize[1] / 2]);
    throttleUtil.createOrUpdate(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');

    this._moveHandleToValue(value, isInit);
  },

  /**
   * @private
   */
  _moveHandleToValue: function (value, isInit) {
    updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
  },

  /**
   * @private
   */
  _onHandleDragMove: function (dx, dy) {
    var handle = this._handle;

    if (!handle) {
      return;
    }

    this._dragging = true; // Persistent for throttle.

    var trans = this.updateHandleTransform(getHandleTransProps(handle), [dx, dy], this._axisModel, this._axisPointerModel);
    this._payloadInfo = trans;
    handle.stopAnimation();
    handle.attr(getHandleTransProps(trans));
    inner(handle).lastProp = null;

    this._doDispatchAxisPointer();
  },

  /**
   * Throttled method.
   * @private
   */
  _doDispatchAxisPointer: function () {
    var handle = this._handle;

    if (!handle) {
      return;
    }

    var payloadInfo = this._payloadInfo;
    var axisModel = this._axisModel;

    this._api.dispatchAction({
      type: 'updateAxisPointer',
      x: payloadInfo.cursorPoint[0],
      y: payloadInfo.cursorPoint[1],
      tooltipOption: payloadInfo.tooltipOption,
      axesInfo: [{
        axisDim: axisModel.axis.dim,
        axisIndex: axisModel.componentIndex
      }]
    });
  },

  /**
   * @private
   */
  _onHandleDragEnd: function (moveAnimation) {
    this._dragging = false;
    var handle = this._handle;

    if (!handle) {
      return;
    }

    var value = this._axisPointerModel.get('value'); // Consider snap or categroy axis, handle may be not consistent with
    // axisPointer. So move handle to align the exact value position when
    // drag ended.


    this._moveHandleToValue(value); // For the effect: tooltip will be shown when finger holding on handle
    // button, and will be hidden after finger left handle button.


    this._api.dispatchAction({
      type: 'hideTip'
    });
  },

  /**
   * Should be implemenented by sub-class if support `handle`.
   * @protected
   * @param {number} value
   * @param {module:echarts/model/Model} axisModel
   * @param {module:echarts/model/Model} axisPointerModel
   * @return {Object} {position: [x, y], rotation: 0}
   */
  getHandleTransform: null,

  /**
   * * Should be implemenented by sub-class if support `handle`.
   * @protected
   * @param {Object} transform {position, rotation}
   * @param {Array.<number>} delta [dx, dy]
   * @param {module:echarts/model/Model} axisModel
   * @param {module:echarts/model/Model} axisPointerModel
   * @return {Object} {position: [x, y], rotation: 0, cursorPoint: [x, y]}
   */
  updateHandleTransform: null,

  /**
   * @private
   */
  clear: function (api) {
    this._lastValue = null;
    this._lastStatus = null;
    var zr = api.getZr();
    var group = this._group;
    var handle = this._handle;

    if (zr && group) {
      this._lastGraphicKey = null;
      group && zr.remove(group);
      handle && zr.remove(handle);
      this._group = null;
      this._handle = null;
      this._payloadInfo = null;
    }
  },

  /**
   * @protected
   */
  doClear: function () {// Implemented by sub-class if necessary.
  },

  /**
   * @protected
   * @param {Array.<number>} xy
   * @param {Array.<number>} wh
   * @param {number} [xDimIndex=0] or 1
   */
  buildLabel: function (xy, wh, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
      x: xy[xDimIndex],
      y: xy[1 - xDimIndex],
      width: wh[xDimIndex],
      height: wh[1 - xDimIndex]
    };
  }
};
BaseAxisPointer.prototype.constructor = BaseAxisPointer;

function updateProps(animationModel, moveAnimation, el, props) {
  // Animation optimize.
  if (!propsEqual(inner(el).lastProp, props)) {
    inner(el).lastProp = props;
    moveAnimation ? graphic.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
  }
}

function propsEqual(lastProps, newProps) {
  if (zrUtil.isObject(lastProps) && zrUtil.isObject(newProps)) {
    var equals = true;
    zrUtil.each(newProps, function (item, key) {
      equals = equals && propsEqual(lastProps[key], item);
    });
    return !!equals;
  } else {
    return lastProps === newProps;
  }
}

function updateLabelShowHide(labelEl, axisPointerModel) {
  labelEl[axisPointerModel.get('label.show') ? 'show' : 'hide']();
}

function getHandleTransProps(trans) {
  return {
    position: trans.position.slice(),
    rotation: trans.rotation || 0
  };
}

function updateMandatoryProps(group, axisPointerModel, silent) {
  var z = axisPointerModel.get('z');
  var zlevel = axisPointerModel.get('zlevel');
  group && group.traverse(function (el) {
    if (el.type !== 'group') {
      z != null && (el.z = z);
      zlevel != null && (el.zlevel = zlevel);
      el.silent = silent;
    }
  });
}

clazzUtil.enableClassExtend(BaseAxisPointer);
var _default = BaseAxisPointer;
module.exports = _default;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(1);

var Polar = __webpack_require__(1733);

var _number = __webpack_require__(37);

var parsePercent = _number.parsePercent;

var _axisHelper = __webpack_require__(109);

var createScaleByModel = _axisHelper.createScaleByModel;
var niceScaleExtent = _axisHelper.niceScaleExtent;

var CoordinateSystem = __webpack_require__(108);

var _dataStackHelper = __webpack_require__(124);

var getStackedDimension = _dataStackHelper.getStackedDimension;

__webpack_require__(1736);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// TODO Axis scale

/**
 * Resize method bound to the polar
 * @param {module:echarts/coord/polar/PolarModel} polarModel
 * @param {module:echarts/ExtensionAPI} api
 */
function resizePolar(polar, polarModel, api) {
  var center = polarModel.get('center');
  var width = api.getWidth();
  var height = api.getHeight();
  polar.cx = parsePercent(center[0], width);
  polar.cy = parsePercent(center[1], height);
  var radiusAxis = polar.getRadiusAxis();
  var size = Math.min(width, height) / 2;
  var radius = polarModel.get('radius');

  if (radius == null) {
    radius = [0, '100%'];
  } else if (!zrUtil.isArray(radius)) {
    // r0 = 0
    radius = [0, radius];
  }

  radius = [parsePercent(radius[0], size), parsePercent(radius[1], size)];
  radiusAxis.inverse ? radiusAxis.setExtent(radius[1], radius[0]) : radiusAxis.setExtent(radius[0], radius[1]);
}
/**
 * Update polar
 */


function updatePolarScale(ecModel, api) {
  var polar = this;
  var angleAxis = polar.getAngleAxis();
  var radiusAxis = polar.getRadiusAxis(); // Reset scale

  angleAxis.scale.setExtent(Infinity, -Infinity);
  radiusAxis.scale.setExtent(Infinity, -Infinity);
  ecModel.eachSeries(function (seriesModel) {
    if (seriesModel.coordinateSystem === polar) {
      var data = seriesModel.getData();
      zrUtil.each(data.mapDimension('radius', true), function (dim) {
        radiusAxis.scale.unionExtentFromData(data, getStackedDimension(data, dim));
      });
      zrUtil.each(data.mapDimension('angle', true), function (dim) {
        angleAxis.scale.unionExtentFromData(data, getStackedDimension(data, dim));
      });
    }
  });
  niceScaleExtent(angleAxis.scale, angleAxis.model);
  niceScaleExtent(radiusAxis.scale, radiusAxis.model); // Fix extent of category angle axis

  if (angleAxis.type === 'category' && !angleAxis.onBand) {
    var extent = angleAxis.getExtent();
    var diff = 360 / angleAxis.scale.count();
    angleAxis.inverse ? extent[1] += diff : extent[1] -= diff;
    angleAxis.setExtent(extent[0], extent[1]);
  }
}
/**
 * Set common axis properties
 * @param {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
 * @param {module:echarts/coord/polar/AxisModel}
 * @inner
 */


function setAxis(axis, axisModel) {
  axis.type = axisModel.get('type');
  axis.scale = createScaleByModel(axisModel);
  axis.onBand = axisModel.get('boundaryGap') && axis.type === 'category';
  axis.inverse = axisModel.get('inverse');

  if (axisModel.mainType === 'angleAxis') {
    axis.inverse ^= axisModel.get('clockwise');
    var startAngle = axisModel.get('startAngle');
    axis.setExtent(startAngle, startAngle + (axis.inverse ? -360 : 360));
  } // Inject axis instance


  axisModel.axis = axis;
  axis.model = axisModel;
}

var polarCreator = {
  dimensions: Polar.prototype.dimensions,
  create: function (ecModel, api) {
    var polarList = [];
    ecModel.eachComponent('polar', function (polarModel, idx) {
      var polar = new Polar(idx); // Inject resize and update method

      polar.update = updatePolarScale;
      var radiusAxis = polar.getRadiusAxis();
      var angleAxis = polar.getAngleAxis();
      var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
      var angleAxisModel = polarModel.findAxisModel('angleAxis');
      setAxis(radiusAxis, radiusAxisModel);
      setAxis(angleAxis, angleAxisModel);
      resizePolar(polar, polarModel, api);
      polarList.push(polar);
      polarModel.coordinateSystem = polar;
      polar.model = polarModel;
    }); // Inject coordinateSystem to series

    ecModel.eachSeries(function (seriesModel) {
      if (seriesModel.get('coordinateSystem') === 'polar') {
        var polarModel = ecModel.queryComponents({
          mainType: 'polar',
          index: seriesModel.get('polarIndex'),
          id: seriesModel.get('polarId')
        })[0];
        seriesModel.coordinateSystem = polarModel.coordinateSystem;
      }
    });
    return polarList;
  }
};
CoordinateSystem.register('polar', polarCreator);

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var Component = __webpack_require__(73);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
Component.registerSubTypeDefaulter('dataZoom', function () {
  // Default 'slider' when no type specified.
  return 'slider';
});

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var formatUtil = __webpack_require__(54);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var AXIS_DIMS = ['x', 'y', 'z', 'radius', 'angle', 'single']; // Supported coords.

var COORDS = ['cartesian2d', 'polar', 'singleAxis'];
/**
 * @param {string} coordType
 * @return {boolean}
 */

function isCoordSupported(coordType) {
  return zrUtil.indexOf(COORDS, coordType) >= 0;
}
/**
 * Create "each" method to iterate names.
 *
 * @pubilc
 * @param  {Array.<string>} names
 * @param  {Array.<string>=} attrs
 * @return {Function}
 */


function createNameEach(names, attrs) {
  names = names.slice();
  var capitalNames = zrUtil.map(names, formatUtil.capitalFirst);
  attrs = (attrs || []).slice();
  var capitalAttrs = zrUtil.map(attrs, formatUtil.capitalFirst);
  return function (callback, context) {
    zrUtil.each(names, function (name, index) {
      var nameObj = {
        name: name,
        capital: capitalNames[index]
      };

      for (var j = 0; j < attrs.length; j++) {
        nameObj[attrs[j]] = name + capitalAttrs[j];
      }

      callback.call(context, nameObj);
    });
  };
}
/**
 * Iterate each dimension name.
 *
 * @public
 * @param {Function} callback The parameter is like:
 *                            {
 *                                name: 'angle',
 *                                capital: 'Angle',
 *                                axis: 'angleAxis',
 *                                axisIndex: 'angleAixs',
 *                                index: 'angleIndex'
 *                            }
 * @param {Object} context
 */


var eachAxisDim = createNameEach(AXIS_DIMS, ['axisIndex', 'axis', 'index', 'id']);
/**
 * If tow dataZoomModels has the same axis controlled, we say that they are 'linked'.
 * dataZoomModels and 'links' make up one or more graphics.
 * This function finds the graphic where the source dataZoomModel is in.
 *
 * @public
 * @param {Function} forEachNode Node iterator.
 * @param {Function} forEachEdgeType edgeType iterator
 * @param {Function} edgeIdGetter Giving node and edgeType, return an array of edge id.
 * @return {Function} Input: sourceNode, Output: Like {nodes: [], dims: {}}
 */

function createLinkedNodesFinder(forEachNode, forEachEdgeType, edgeIdGetter) {
  return function (sourceNode) {
    var result = {
      nodes: [],
      records: {} // key: edgeType.name, value: Object (key: edge id, value: boolean).

    };
    forEachEdgeType(function (edgeType) {
      result.records[edgeType.name] = {};
    });

    if (!sourceNode) {
      return result;
    }

    absorb(sourceNode, result);
    var existsLink;

    do {
      existsLink = false;
      forEachNode(processSingleNode);
    } while (existsLink);

    function processSingleNode(node) {
      if (!isNodeAbsorded(node, result) && isLinked(node, result)) {
        absorb(node, result);
        existsLink = true;
      }
    }

    return result;
  };

  function isNodeAbsorded(node, result) {
    return zrUtil.indexOf(result.nodes, node) >= 0;
  }

  function isLinked(node, result) {
    var hasLink = false;
    forEachEdgeType(function (edgeType) {
      zrUtil.each(edgeIdGetter(node, edgeType) || [], function (edgeId) {
        result.records[edgeType.name][edgeId] && (hasLink = true);
      });
    });
    return hasLink;
  }

  function absorb(node, result) {
    result.nodes.push(node);
    forEachEdgeType(function (edgeType) {
      zrUtil.each(edgeIdGetter(node, edgeType) || [], function (edgeId) {
        result.records[edgeType.name][edgeId] = true;
      });
    });
  }
}

exports.isCoordSupported = isCoordSupported;
exports.createNameEach = createNameEach;
exports.eachAxisDim = eachAxisDim;
exports.createLinkedNodesFinder = createLinkedNodesFinder;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var _util = __webpack_require__(1);

var createHashMap = _util.createHashMap;
var each = _util.each;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.registerProcessor({
  // `dataZoomProcessor` will only be performed in needed series. Consider if
  // there is a line series and a pie series, it is better not to update the
  // line series if only pie series is needed to be updated.
  getTargetSeries: function (ecModel) {
    var seriesModelMap = createHashMap();
    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
      dataZoomModel.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel) {
        var axisProxy = dataZoomModel.getAxisProxy(dimNames.name, axisIndex);
        each(axisProxy.getTargetSeriesModels(), function (seriesModel) {
          seriesModelMap.set(seriesModel.uid, seriesModel);
        });
      });
    });
    return seriesModelMap;
  },
  modifyOutputEnd: true,
  // Consider appendData, where filter should be performed. Because data process is
  // in block mode currently, it is not need to worry about that the overallProgress
  // execute every frame.
  overallReset: function (ecModel, api) {
    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
      // We calculate window and reset axis here but not in model
      // init stage and not after action dispatch handler, because
      // reset should be called after seriesData.restoreData.
      dataZoomModel.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel) {
        dataZoomModel.getAxisProxy(dimNames.name, axisIndex).reset(dataZoomModel, api);
      }); // Caution: data zoom filtering is order sensitive when using
      // percent range and no min/max/scale set on axis.
      // For example, we have dataZoom definition:
      // [
      //      {xAxisIndex: 0, start: 30, end: 70},
      //      {yAxisIndex: 0, start: 20, end: 80}
      // ]
      // In this case, [20, 80] of y-dataZoom should be based on data
      // that have filtered by x-dataZoom using range of [30, 70],
      // but should not be based on full raw data. Thus sliding
      // x-dataZoom will change both ranges of xAxis and yAxis,
      // while sliding y-dataZoom will only change the range of yAxis.
      // So we should filter x-axis after reset x-axis immediately,
      // and then reset y-axis and filter y-axis.

      dataZoomModel.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel) {
        dataZoomModel.getAxisProxy(dimNames.name, axisIndex).filterData(dataZoomModel, api);
      });
    });
    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
      // Fullfill all of the range props so that user
      // is able to get them from chart.getOption().
      var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
      var percentRange = axisProxy.getDataPercentWindow();
      var valueRange = axisProxy.getDataValueWindow();
      dataZoomModel.setCalculatedRange({
        start: percentRange[0],
        end: percentRange[1],
        startValue: valueRange[0],
        endValue: valueRange[1]
      });
    });
  }
});

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var helper = __webpack_require__(429);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.registerAction('dataZoom', function (payload, ecModel) {
  var linkedNodesFinder = helper.createLinkedNodesFinder(zrUtil.bind(ecModel.eachComponent, ecModel, 'dataZoom'), helper.eachAxisDim, function (model, dimNames) {
    return model.get(dimNames.axisIndex);
  });
  var effectedModels = [];
  ecModel.eachComponent({
    mainType: 'dataZoom',
    query: payload
  }, function (model, index) {
    effectedModels.push.apply(effectedModels, linkedNodesFinder(model).nodes);
  });
  zrUtil.each(effectedModels, function (dataZoomModel, index) {
    dataZoomModel.setRawRange({
      start: payload.start,
      end: payload.end,
      startValue: payload.startValue,
      endValue: payload.endValue
    });
  });
});

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var env = __webpack_require__(67);

var modelUtil = __webpack_require__(44);

var formatUtil = __webpack_require__(54);

var dataFormatMixin = __webpack_require__(411);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var addCommas = formatUtil.addCommas;
var encodeHTML = formatUtil.encodeHTML;

function fillLabel(opt) {
  modelUtil.defaultEmphasis(opt, 'label', ['show']);
}

var MarkerModel = echarts.extendComponentModel({
  type: 'marker',
  dependencies: ['series', 'grid', 'polar', 'geo'],

  /**
   * @overrite
   */
  init: function (option, parentModel, ecModel) {
    this.mergeDefaultAndTheme(option, ecModel);

    this._mergeOption(option, ecModel, false, true);
  },

  /**
   * @return {boolean}
   */
  isAnimationEnabled: function () {
    if (env.node) {
      return false;
    }

    var hostSeries = this.__hostSeries;
    return this.getShallow('animation') && hostSeries && hostSeries.isAnimationEnabled();
  },

  /**
   * @overrite
   */
  mergeOption: function (newOpt, ecModel) {
    this._mergeOption(newOpt, ecModel, false, false);
  },
  _mergeOption: function (newOpt, ecModel, createdBySelf, isInit) {
    var MarkerModel = this.constructor;
    var modelPropName = this.mainType + 'Model';

    if (!createdBySelf) {
      ecModel.eachSeries(function (seriesModel) {
        var markerOpt = seriesModel.get(this.mainType, true);
        var markerModel = seriesModel[modelPropName];

        if (!markerOpt || !markerOpt.data) {
          seriesModel[modelPropName] = null;
          return;
        }

        if (!markerModel) {
          if (isInit) {
            // Default label emphasis `position` and `show`
            fillLabel(markerOpt);
          }

          zrUtil.each(markerOpt.data, function (item) {
            // FIXME Overwrite fillLabel method ?
            if (item instanceof Array) {
              fillLabel(item[0]);
              fillLabel(item[1]);
            } else {
              fillLabel(item);
            }
          });
          markerModel = new MarkerModel(markerOpt, this, ecModel);
          zrUtil.extend(markerModel, {
            mainType: this.mainType,
            // Use the same series index and name
            seriesIndex: seriesModel.seriesIndex,
            name: seriesModel.name,
            createdBySelf: true
          });
          markerModel.__hostSeries = seriesModel;
        } else {
          markerModel._mergeOption(markerOpt, ecModel, true);
        }

        seriesModel[modelPropName] = markerModel;
      }, this);
    }
  },
  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
    var data = this.getData();
    var value = this.getRawValue(dataIndex);
    var formattedValue = zrUtil.isArray(value) ? zrUtil.map(value, addCommas).join(', ') : addCommas(value);
    var name = data.getName(dataIndex);
    var html = encodeHTML(this.name);
    var newLine = renderMode === 'html' ? '<br/>' : '\n';

    if (value != null || name) {
      html += newLine;
    }

    if (name) {
      html += encodeHTML(name);

      if (value != null) {
        html += ' : ';
      }
    }

    if (value != null) {
      html += encodeHTML(formattedValue);
    }

    return html;
  },
  getData: function () {
    return this._data;
  },
  setData: function (data) {
    this._data = data;
  }
});
zrUtil.mixin(MarkerModel, dataFormatMixin);
var _default = MarkerModel;
module.exports = _default;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var numberUtil = __webpack_require__(37);

var _dataStackHelper = __webpack_require__(124);

var isDimensionStacked = _dataStackHelper.isDimensionStacked;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var indexOf = zrUtil.indexOf;

function hasXOrY(item) {
  return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
}

function hasXAndY(item) {
  return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
} // Make it simple, do not visit all stacked value to count precision.
// function getPrecision(data, valueAxisDim, dataIndex) {
//     var precision = -1;
//     var stackedDim = data.mapDimension(valueAxisDim);
//     do {
//         precision = Math.max(
//             numberUtil.getPrecision(data.get(stackedDim, dataIndex)),
//             precision
//         );
//         var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
//         if (stackedOnSeries) {
//             var byValue = data.get(data.getCalculationInfo('stackedByDimension'), dataIndex);
//             data = stackedOnSeries.getData();
//             dataIndex = data.indexOf(data.getCalculationInfo('stackedByDimension'), byValue);
//             stackedDim = data.getCalculationInfo('stackedDimension');
//         }
//         else {
//             data = null;
//         }
//     } while (data);
//     return precision;
// }


function markerTypeCalculatorWithExtent(mlType, data, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
  var coordArr = [];
  var stacked = isDimensionStacked(data, targetDataDim
  /*, otherDataDim*/
  );
  var calcDataDim = stacked ? data.getCalculationInfo('stackResultDimension') : targetDataDim;
  var value = numCalculate(data, calcDataDim, mlType);
  var dataIndex = data.indicesOfNearest(calcDataDim, value)[0];
  coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex);
  coordArr[targetCoordIndex] = data.get(calcDataDim, dataIndex);
  var coordArrValue = data.get(targetDataDim, dataIndex); // Make it simple, do not visit all stacked value to count precision.

  var precision = numberUtil.getPrecision(data.get(targetDataDim, dataIndex));
  precision = Math.min(precision, 20);

  if (precision >= 0) {
    coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
  }

  return [coordArr, coordArrValue];
}

var curry = zrUtil.curry; // TODO Specified percent

var markerTypeCalculator = {
  /**
   * @method
   * @param {module:echarts/data/List} data
   * @param {string} baseAxisDim
   * @param {string} valueAxisDim
   */
  min: curry(markerTypeCalculatorWithExtent, 'min'),

  /**
   * @method
   * @param {module:echarts/data/List} data
   * @param {string} baseAxisDim
   * @param {string} valueAxisDim
   */
  max: curry(markerTypeCalculatorWithExtent, 'max'),

  /**
   * @method
   * @param {module:echarts/data/List} data
   * @param {string} baseAxisDim
   * @param {string} valueAxisDim
   */
  average: curry(markerTypeCalculatorWithExtent, 'average')
};
/**
 * Transform markPoint data item to format used in List by do the following
 * 1. Calculate statistic like `max`, `min`, `average`
 * 2. Convert `item.xAxis`, `item.yAxis` to `item.coord` array
 * @param  {module:echarts/model/Series} seriesModel
 * @param  {module:echarts/coord/*} [coordSys]
 * @param  {Object} item
 * @return {Object}
 */

function dataTransform(seriesModel, item) {
  var data = seriesModel.getData();
  var coordSys = seriesModel.coordinateSystem; // 1. If not specify the position with pixel directly
  // 2. If `coord` is not a data array. Which uses `xAxis`,
  // `yAxis` to specify the coord on each dimension
  // parseFloat first because item.x and item.y can be percent string like '20%'

  if (item && !hasXAndY(item) && !zrUtil.isArray(item.coord) && coordSys) {
    var dims = coordSys.dimensions;
    var axisInfo = getAxisInfo(item, data, coordSys, seriesModel); // Clone the option
    // Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value

    item = zrUtil.clone(item);

    if (item.type && markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
      var otherCoordIndex = indexOf(dims, axisInfo.baseAxis.dim);
      var targetCoordIndex = indexOf(dims, axisInfo.valueAxis.dim);
      var coordInfo = markerTypeCalculator[item.type](data, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex);
      item.coord = coordInfo[0]; // Force to use the value of calculated value.
      // let item use the value without stack.

      item.value = coordInfo[1];
    } else {
      // FIXME Only has one of xAxis and yAxis.
      var coord = [item.xAxis != null ? item.xAxis : item.radiusAxis, item.yAxis != null ? item.yAxis : item.angleAxis]; // Each coord support max, min, average

      for (var i = 0; i < 2; i++) {
        if (markerTypeCalculator[coord[i]]) {
          coord[i] = numCalculate(data, data.mapDimension(dims[i]), coord[i]);
        }
      }

      item.coord = coord;
    }
  }

  return item;
}

function getAxisInfo(item, data, coordSys, seriesModel) {
  var ret = {};

  if (item.valueIndex != null || item.valueDim != null) {
    ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
    ret.valueAxis = coordSys.getAxis(dataDimToCoordDim(seriesModel, ret.valueDataDim));
    ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
    ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
  } else {
    ret.baseAxis = seriesModel.getBaseAxis();
    ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
    ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
    ret.valueDataDim = data.mapDimension(ret.valueAxis.dim);
  }

  return ret;
}

function dataDimToCoordDim(seriesModel, dataDim) {
  var data = seriesModel.getData();
  var dimensions = data.dimensions;
  dataDim = data.getDimension(dataDim);

  for (var i = 0; i < dimensions.length; i++) {
    var dimItem = data.getDimensionInfo(dimensions[i]);

    if (dimItem.name === dataDim) {
      return dimItem.coordDim;
    }
  }
}
/**
 * Filter data which is out of coordinateSystem range
 * [dataFilter description]
 * @param  {module:echarts/coord/*} [coordSys]
 * @param  {Object} item
 * @return {boolean}
 */


function dataFilter(coordSys, item) {
  // Alwalys return true if there is no coordSys
  return coordSys && coordSys.containData && item.coord && !hasXOrY(item) ? coordSys.containData(item.coord) : true;
}

function dimValueGetter(item, dimName, dataIndex, dimIndex) {
  // x, y, radius, angle
  if (dimIndex < 2) {
    return item.coord && item.coord[dimIndex];
  }

  return item.value;
}

function numCalculate(data, valueDataDim, type) {
  if (type === 'average') {
    var sum = 0;
    var count = 0;
    data.each(valueDataDim, function (val, idx) {
      if (!isNaN(val)) {
        sum += val;
        count++;
      }
    });
    return sum / count;
  } else if (type === 'median') {
    return data.getMedian(valueDataDim);
  } else {
    // max & min
    return data.getDataExtent(valueDataDim, true)[type === 'max' ? 1 : 0];
  }
}

exports.dataTransform = dataTransform;
exports.getAxisInfo = getAxisInfo;
exports.dataFilter = dataFilter;
exports.dimValueGetter = dimValueGetter;
exports.numCalculate = numCalculate;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = echarts.extendComponentView({
  type: 'marker',
  init: function () {
    /**
     * Markline grouped by series
     * @private
     * @type {module:zrender/core/util.HashMap}
     */
    this.markerGroupMap = zrUtil.createHashMap();
  },
  render: function (markerModel, ecModel, api) {
    var markerGroupMap = this.markerGroupMap;
    markerGroupMap.each(function (item) {
      item.__keep = false;
    });
    var markerModelKey = this.type + 'Model';
    ecModel.eachSeries(function (seriesModel) {
      var markerModel = seriesModel[markerModelKey];
      markerModel && this.renderSeries(seriesModel, markerModel, ecModel, api);
    }, this);
    markerGroupMap.each(function (item) {
      !item.__keep && this.group.remove(item.group);
    }, this);
  },
  renderSeries: function () {}
});

module.exports = _default;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var _core = __webpack_require__(436);

var createElement = _core.createElement;

var PathProxy = __webpack_require__(205);

var BoundingRect = __webpack_require__(57);

var matrix = __webpack_require__(82);

var textContain = __webpack_require__(93);

var textHelper = __webpack_require__(295);

var Text = __webpack_require__(175);

// TODO
// 1. shadow
// 2. Image: sx, sy, sw, sh
var CMD = PathProxy.CMD;
var arrayJoin = Array.prototype.join;
var NONE = 'none';
var mathRound = Math.round;
var mathSin = Math.sin;
var mathCos = Math.cos;
var PI = Math.PI;
var PI2 = Math.PI * 2;
var degree = 180 / PI;
var EPSILON = 1e-4;

function round4(val) {
  return mathRound(val * 1e4) / 1e4;
}

function isAroundZero(val) {
  return val < EPSILON && val > -EPSILON;
}

function pathHasFill(style, isText) {
  var fill = isText ? style.textFill : style.fill;
  return fill != null && fill !== NONE;
}

function pathHasStroke(style, isText) {
  var stroke = isText ? style.textStroke : style.stroke;
  return stroke != null && stroke !== NONE;
}

function setTransform(svgEl, m) {
  if (m) {
    attr(svgEl, 'transform', 'matrix(' + arrayJoin.call(m, ',') + ')');
  }
}

function attr(el, key, val) {
  if (!val || val.type !== 'linear' && val.type !== 'radial') {
    // Don't set attribute for gradient, since it need new dom nodes
    el.setAttribute(key, val);
  }
}

function attrXLink(el, key, val) {
  el.setAttributeNS('http://www.w3.org/1999/xlink', key, val);
}

function bindStyle(svgEl, style, isText, el) {
  if (pathHasFill(style, isText)) {
    var fill = isText ? style.textFill : style.fill;
    fill = fill === 'transparent' ? NONE : fill;
    attr(svgEl, 'fill', fill);
    attr(svgEl, 'fill-opacity', style.fillOpacity != null ? style.fillOpacity * style.opacity : style.opacity);
  } else {
    attr(svgEl, 'fill', NONE);
  }

  if (pathHasStroke(style, isText)) {
    var stroke = isText ? style.textStroke : style.stroke;
    stroke = stroke === 'transparent' ? NONE : stroke;
    attr(svgEl, 'stroke', stroke);
    var strokeWidth = isText ? style.textStrokeWidth : style.lineWidth;
    var strokeScale = !isText && style.strokeNoScale ? el.getLineScale() : 1;
    attr(svgEl, 'stroke-width', strokeWidth / strokeScale); // stroke then fill for text; fill then stroke for others

    attr(svgEl, 'paint-order', isText ? 'stroke' : 'fill');
    attr(svgEl, 'stroke-opacity', style.strokeOpacity != null ? style.strokeOpacity : style.opacity);
    var lineDash = style.lineDash;

    if (lineDash) {
      attr(svgEl, 'stroke-dasharray', style.lineDash.join(','));
      attr(svgEl, 'stroke-dashoffset', mathRound(style.lineDashOffset || 0));
    } else {
      attr(svgEl, 'stroke-dasharray', '');
    } // PENDING


    style.lineCap && attr(svgEl, 'stroke-linecap', style.lineCap);
    style.lineJoin && attr(svgEl, 'stroke-linejoin', style.lineJoin);
    style.miterLimit && attr(svgEl, 'stroke-miterlimit', style.miterLimit);
  } else {
    attr(svgEl, 'stroke', NONE);
  }
}
/***************************************************
 * PATH
 **************************************************/


function pathDataToString(path) {
  var str = [];
  var data = path.data;
  var dataLength = path.len();

  for (var i = 0; i < dataLength;) {
    var cmd = data[i++];
    var cmdStr = '';
    var nData = 0;

    switch (cmd) {
      case CMD.M:
        cmdStr = 'M';
        nData = 2;
        break;

      case CMD.L:
        cmdStr = 'L';
        nData = 2;
        break;

      case CMD.Q:
        cmdStr = 'Q';
        nData = 4;
        break;

      case CMD.C:
        cmdStr = 'C';
        nData = 6;
        break;

      case CMD.A:
        var cx = data[i++];
        var cy = data[i++];
        var rx = data[i++];
        var ry = data[i++];
        var theta = data[i++];
        var dTheta = data[i++];
        var psi = data[i++];
        var clockwise = data[i++];
        var dThetaPositive = Math.abs(dTheta);
        var isCircle = isAroundZero(dThetaPositive - PI2) || (clockwise ? dTheta >= PI2 : -dTheta >= PI2); // Mapping to 0~2PI

        var unifiedTheta = dTheta > 0 ? dTheta % PI2 : dTheta % PI2 + PI2;
        var large = false;

        if (isCircle) {
          large = true;
        } else if (isAroundZero(dThetaPositive)) {
          large = false;
        } else {
          large = unifiedTheta >= PI === !!clockwise;
        }

        var x0 = round4(cx + rx * mathCos(theta));
        var y0 = round4(cy + ry * mathSin(theta)); // It will not draw if start point and end point are exactly the same
        // We need to shift the end point with a small value
        // FIXME A better way to draw circle ?

        if (isCircle) {
          if (clockwise) {
            dTheta = PI2 - 1e-4;
          } else {
            dTheta = -PI2 + 1e-4;
          }

          large = true;

          if (i === 9) {
            // Move to (x0, y0) only when CMD.A comes at the
            // first position of a shape.
            // For instance, when drawing a ring, CMD.A comes
            // after CMD.M, so it's unnecessary to move to
            // (x0, y0).
            str.push('M', x0, y0);
          }
        }

        var x = round4(cx + rx * mathCos(theta + dTheta));
        var y = round4(cy + ry * mathSin(theta + dTheta)); // FIXME Ellipse

        str.push('A', round4(rx), round4(ry), mathRound(psi * degree), +large, +clockwise, x, y);
        break;

      case CMD.Z:
        cmdStr = 'Z';
        break;

      case CMD.R:
        var x = round4(data[i++]);
        var y = round4(data[i++]);
        var w = round4(data[i++]);
        var h = round4(data[i++]);
        str.push('M', x, y, 'L', x + w, y, 'L', x + w, y + h, 'L', x, y + h, 'L', x, y);
        break;
    }

    cmdStr && str.push(cmdStr);

    for (var j = 0; j < nData; j++) {
      // PENDING With scale
      str.push(round4(data[i++]));
    }
  }

  return str.join(' ');
}

var svgPath = {};

svgPath.brush = function (el) {
  var style = el.style;
  var svgEl = el.__svgEl;

  if (!svgEl) {
    svgEl = createElement('path');
    el.__svgEl = svgEl;
  }

  if (!el.path) {
    el.createPathProxy();
  }

  var path = el.path;

  if (el.__dirtyPath) {
    path.beginPath();
    path.subPixelOptimize = false;
    el.buildPath(path, el.shape);
    el.__dirtyPath = false;
    var pathStr = pathDataToString(path);

    if (pathStr.indexOf('NaN') < 0) {
      // Ignore illegal path, which may happen such in out-of-range
      // data in Calendar series.
      attr(svgEl, 'd', pathStr);
    }
  }

  bindStyle(svgEl, style, false, el);
  setTransform(svgEl, el.transform);

  if (style.text != null) {
    svgTextDrawRectText(el, el.getBoundingRect());
  } else {
    removeOldTextNode(el);
  }
};
/***************************************************
 * IMAGE
 **************************************************/


var svgImage = {};

svgImage.brush = function (el) {
  var style = el.style;
  var image = style.image;

  if (image instanceof HTMLImageElement) {
    var src = image.src;
    image = src;
  }

  if (!image) {
    return;
  }

  var x = style.x || 0;
  var y = style.y || 0;
  var dw = style.width;
  var dh = style.height;
  var svgEl = el.__svgEl;

  if (!svgEl) {
    svgEl = createElement('image');
    el.__svgEl = svgEl;
  }

  if (image !== el.__imageSrc) {
    attrXLink(svgEl, 'href', image); // Caching image src

    el.__imageSrc = image;
  }

  attr(svgEl, 'width', dw);
  attr(svgEl, 'height', dh);
  attr(svgEl, 'x', x);
  attr(svgEl, 'y', y);
  setTransform(svgEl, el.transform);

  if (style.text != null) {
    svgTextDrawRectText(el, el.getBoundingRect());
  } else {
    removeOldTextNode(el);
  }
};
/***************************************************
 * TEXT
 **************************************************/


var svgText = {};

var _tmpTextHostRect = new BoundingRect();

var _tmpTextBoxPos = {};
var _tmpTextTransform = [];
var TEXT_ALIGN_TO_ANCHRO = {
  left: 'start',
  right: 'end',
  center: 'middle',
  middle: 'middle'
};
/**
 * @param {module:zrender/Element} el
 * @param {Object|boolean} [hostRect] {x, y, width, height}
 *        If set false, rect text is not used.
 */

var svgTextDrawRectText = function (el, hostRect) {
  var style = el.style;
  var elTransform = el.transform;
  var needTransformTextByHostEl = el instanceof Text || style.transformText;
  el.__dirty && textHelper.normalizeTextStyle(style, true);
  var text = style.text; // Convert to string

  text != null && (text += '');

  if (!textHelper.needDrawText(text, style)) {
    return;
  } // render empty text for svg if no text but need draw text.


  text == null && (text = ''); // Follow the setting in the canvas renderer, if not transform the
  // text, transform the hostRect, by which the text is located.

  if (!needTransformTextByHostEl && elTransform) {
    _tmpTextHostRect.copy(hostRect);

    _tmpTextHostRect.applyTransform(elTransform);

    hostRect = _tmpTextHostRect;
  }

  var textSvgEl = el.__textSvgEl;

  if (!textSvgEl) {
    textSvgEl = createElement('text');
    el.__textSvgEl = textSvgEl;
  } // style.font has been normalized by `normalizeTextStyle`.


  var textSvgElStyle = textSvgEl.style;
  var font = style.font || textContain.DEFAULT_FONT;
  var computedFont = textSvgEl.__computedFont;

  if (font !== textSvgEl.__styleFont) {
    textSvgElStyle.font = textSvgEl.__styleFont = font; // The computedFont might not be the orginal font if it is illegal font.

    computedFont = textSvgEl.__computedFont = textSvgElStyle.font;
  }

  var textPadding = style.textPadding;
  var textLineHeight = style.textLineHeight;
  var contentBlock = el.__textCotentBlock;

  if (!contentBlock || el.__dirtyText) {
    contentBlock = el.__textCotentBlock = textContain.parsePlainText(text, computedFont, textPadding, textLineHeight, style.truncate);
  }

  var outerHeight = contentBlock.outerHeight;
  var lineHeight = contentBlock.lineHeight;
  textHelper.getBoxPosition(_tmpTextBoxPos, el, style, hostRect);
  var baseX = _tmpTextBoxPos.baseX;
  var baseY = _tmpTextBoxPos.baseY;
  var textAlign = _tmpTextBoxPos.textAlign || 'left';
  var textVerticalAlign = _tmpTextBoxPos.textVerticalAlign;
  setTextTransform(textSvgEl, needTransformTextByHostEl, elTransform, style, hostRect, baseX, baseY);
  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
  var textX = baseX;
  var textY = boxY; // TODO needDrawBg

  if (textPadding) {
    textX = getTextXForPadding(baseX, textAlign, textPadding);
    textY += textPadding[0];
  } // `textBaseline` is set as 'middle'.


  textY += lineHeight / 2;
  bindStyle(textSvgEl, style, true, el); // FIXME
  // Add a <style> to reset all of the text font as inherit?
  // otherwise the outer <style> may set the unexpected style.
  // Font may affect position of each tspan elements

  var canCacheByTextString = contentBlock.canCacheByTextString;
  var tspanList = el.__tspanList || (el.__tspanList = []);
  var tspanOriginLen = tspanList.length; // Optimize for most cases, just compare text string to determine change.

  if (canCacheByTextString && el.__canCacheByTextString && el.__text === text) {
    if (el.__dirtyText && tspanOriginLen) {
      for (var idx = 0; idx < tspanOriginLen; ++idx) {
        updateTextLocation(tspanList[idx], textAlign, textX, textY + idx * lineHeight);
      }
    }
  } else {
    el.__text = text;
    el.__canCacheByTextString = canCacheByTextString;
    var textLines = contentBlock.lines;
    var nTextLines = textLines.length;
    var idx = 0;

    for (; idx < nTextLines; idx++) {
      // Using cached tspan elements
      var tspan = tspanList[idx];
      var singleLineText = textLines[idx];

      if (!tspan) {
        tspan = tspanList[idx] = createElement('tspan');
        textSvgEl.appendChild(tspan);
        tspan.appendChild(document.createTextNode(singleLineText));
      } else if (tspan.__zrText !== singleLineText) {
        tspan.innerHTML = '';
        tspan.appendChild(document.createTextNode(singleLineText));
      }

      updateTextLocation(tspan, textAlign, textX, textY + idx * lineHeight);
    } // Remove unused tspan elements


    if (tspanOriginLen > nTextLines) {
      for (; idx < tspanOriginLen; idx++) {
        textSvgEl.removeChild(tspanList[idx]);
      }

      tspanList.length = nTextLines;
    }
  }
};

function setTextTransform(textSvgEl, needTransformTextByHostEl, elTransform, style, hostRect, baseX, baseY) {
  matrix.identity(_tmpTextTransform);

  if (needTransformTextByHostEl && elTransform) {
    matrix.copy(_tmpTextTransform, elTransform);
  } // textRotation only apply in RectText.


  var textRotation = style.textRotation;

  if (hostRect && textRotation) {
    var origin = style.textOrigin;

    if (origin === 'center') {
      baseX = hostRect.width / 2 + hostRect.x;
      baseY = hostRect.height / 2 + hostRect.y;
    } else if (origin) {
      baseX = origin[0] + hostRect.x;
      baseY = origin[1] + hostRect.y;
    }

    _tmpTextTransform[4] -= baseX;
    _tmpTextTransform[5] -= baseY; // Positive: anticlockwise

    matrix.rotate(_tmpTextTransform, _tmpTextTransform, textRotation);
    _tmpTextTransform[4] += baseX;
    _tmpTextTransform[5] += baseY;
  } // See the definition in `Style.js#textOrigin`, the default
  // origin is from the result of `getBoxPosition`.


  setTransform(textSvgEl, _tmpTextTransform);
} // FIXME merge the same code with `helper/text.js#getTextXForPadding`;


function getTextXForPadding(x, textAlign, textPadding) {
  return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
}

function updateTextLocation(tspan, textAlign, x, y) {
  // Consider different font display differently in vertial align, we always
  // set vertialAlign as 'middle', and use 'y' to locate text vertically.
  attr(tspan, 'dominant-baseline', 'middle');
  attr(tspan, 'text-anchor', TEXT_ALIGN_TO_ANCHRO[textAlign]);
  attr(tspan, 'x', x);
  attr(tspan, 'y', y);
}

function removeOldTextNode(el) {
  if (el && el.__textSvgEl) {
    // textSvgEl may has no parentNode if el has been removed temporary.
    if (el.__textSvgEl.parentNode) {
      el.__textSvgEl.parentNode.removeChild(el.__textSvgEl);
    }

    el.__textSvgEl = null;
    el.__tspanList = [];
    el.__text = null;
  }
}

svgText.drawRectText = svgTextDrawRectText;

svgText.brush = function (el) {
  var style = el.style;

  if (style.text != null) {
    svgTextDrawRectText(el, false);
  } else {
    removeOldTextNode(el);
  }
};

exports.path = svgPath;
exports.image = svgImage;
exports.text = svgText;

/***/ }),
/* 436 */
/***/ (function(module, exports) {

var svgURI = 'http://www.w3.org/2000/svg';

function createElement(name) {
  return document.createElementNS(svgURI, name);
}

exports.createElement = createElement;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var _core = __webpack_require__(436);

var createElement = _core.createElement;

var zrUtil = __webpack_require__(1);

var Path = __webpack_require__(65);

var ZImage = __webpack_require__(203);

var ZText = __webpack_require__(175);

var _graphic = __webpack_require__(435);

var svgPath = _graphic.path;
var svgImage = _graphic.image;
var svgText = _graphic.text;

/**
 * @file Manages elements that can be defined in <defs> in SVG,
 *       e.g., gradients, clip path, etc.
 * @author Zhang Wenli
 */
var MARK_UNUSED = '0';
var MARK_USED = '1';
/**
 * Manages elements that can be defined in <defs> in SVG,
 * e.g., gradients, clip path, etc.
 *
 * @class
 * @param {number}          zrId      zrender instance id
 * @param {SVGElement}      svgRoot   root of SVG document
 * @param {string|string[]} tagNames  possible tag names
 * @param {string}          markLabel label name to make if the element
 *                                    is used
 */

function Definable(zrId, svgRoot, tagNames, markLabel, domName) {
  this._zrId = zrId;
  this._svgRoot = svgRoot;
  this._tagNames = typeof tagNames === 'string' ? [tagNames] : tagNames;
  this._markLabel = markLabel;
  this._domName = domName || '_dom';
  this.nextId = 0;
}

Definable.prototype.createElement = createElement;
/**
 * Get the <defs> tag for svgRoot; optionally creates one if not exists.
 *
 * @param {boolean} isForceCreating if need to create when not exists
 * @return {SVGDefsElement} SVG <defs> element, null if it doesn't
 * exist and isForceCreating is false
 */

Definable.prototype.getDefs = function (isForceCreating) {
  var svgRoot = this._svgRoot;

  var defs = this._svgRoot.getElementsByTagName('defs');

  if (defs.length === 0) {
    // Not exist
    if (isForceCreating) {
      defs = svgRoot.insertBefore(this.createElement('defs'), // Create new tag
      svgRoot.firstChild // Insert in the front of svg
      );

      if (!defs.contains) {
        // IE doesn't support contains method
        defs.contains = function (el) {
          var children = defs.children;

          if (!children) {
            return false;
          }

          for (var i = children.length - 1; i >= 0; --i) {
            if (children[i] === el) {
              return true;
            }
          }

          return false;
        };
      }

      return defs;
    } else {
      return null;
    }
  } else {
    return defs[0];
  }
};
/**
 * Update DOM element if necessary.
 *
 * @param {Object|string} element style element. e.g., for gradient,
 *                                it may be '#ccc' or {type: 'linear', ...}
 * @param {Function|undefined} onUpdate update callback
 */


Definable.prototype.update = function (element, onUpdate) {
  if (!element) {
    return;
  }

  var defs = this.getDefs(false);

  if (element[this._domName] && defs.contains(element[this._domName])) {
    // Update DOM
    if (typeof onUpdate === 'function') {
      onUpdate(element);
    }
  } else {
    // No previous dom, create new
    var dom = this.add(element);

    if (dom) {
      element[this._domName] = dom;
    }
  }
};
/**
 * Add gradient dom to defs
 *
 * @param {SVGElement} dom DOM to be added to <defs>
 */


Definable.prototype.addDom = function (dom) {
  var defs = this.getDefs(true);
  defs.appendChild(dom);
};
/**
 * Remove DOM of a given element.
 *
 * @param {SVGElement} element element to remove dom
 */


Definable.prototype.removeDom = function (element) {
  var defs = this.getDefs(false);

  if (defs && element[this._domName]) {
    defs.removeChild(element[this._domName]);
    element[this._domName] = null;
  }
};
/**
 * Get DOMs of this element.
 *
 * @return {HTMLDomElement} doms of this defineable elements in <defs>
 */


Definable.prototype.getDoms = function () {
  var defs = this.getDefs(false);

  if (!defs) {
    // No dom when defs is not defined
    return [];
  }

  var doms = [];
  zrUtil.each(this._tagNames, function (tagName) {
    var tags = defs.getElementsByTagName(tagName); // Note that tags is HTMLCollection, which is array-like
    // rather than real array.
    // So `doms.concat(tags)` add tags as one object.

    doms = doms.concat([].slice.call(tags));
  });
  return doms;
};
/**
 * Mark DOMs to be unused before painting, and clear unused ones at the end
 * of the painting.
 */


Definable.prototype.markAllUnused = function () {
  var doms = this.getDoms();
  var that = this;
  zrUtil.each(doms, function (dom) {
    dom[that._markLabel] = MARK_UNUSED;
  });
};
/**
 * Mark a single DOM to be used.
 *
 * @param {SVGElement} dom DOM to mark
 */


Definable.prototype.markUsed = function (dom) {
  if (dom) {
    dom[this._markLabel] = MARK_USED;
  }
};
/**
 * Remove unused DOMs defined in <defs>
 */


Definable.prototype.removeUnused = function () {
  var defs = this.getDefs(false);

  if (!defs) {
    // Nothing to remove
    return;
  }

  var doms = this.getDoms();
  var that = this;
  zrUtil.each(doms, function (dom) {
    if (dom[that._markLabel] !== MARK_USED) {
      // Remove gradient
      defs.removeChild(dom);
    }
  });
};
/**
 * Get SVG proxy.
 *
 * @param {Displayable} displayable displayable element
 * @return {Path|Image|Text} svg proxy of given element
 */


Definable.prototype.getSvgProxy = function (displayable) {
  if (displayable instanceof Path) {
    return svgPath;
  } else if (displayable instanceof ZImage) {
    return svgImage;
  } else if (displayable instanceof ZText) {
    return svgText;
  } else {
    return svgPath;
  }
};
/**
 * Get text SVG element.
 *
 * @param {Displayable} displayable displayable element
 * @return {SVGElement} SVG element of text
 */


Definable.prototype.getTextSvgElement = function (displayable) {
  return displayable.__textSvgEl;
};
/**
 * Get SVG element.
 *
 * @param {Displayable} displayable displayable element
 * @return {SVGElement} SVG element
 */


Definable.prototype.getSvgElement = function (displayable) {
  return displayable.__svgEl;
};

var _default = Definable;
module.exports = _default;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setKarte=exports.SPR=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.compute=compute;exports.computeYear=computeYear;var _method=__webpack_require__(20);var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(247);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var color=['#4c9bf2','#4AC18E','#D9534F','#67A8E4'];// 春节日期维护
var SPR=exports.SPR=_extends({},_data.chineseNewYear);function compute(data,lastYearData,date){var sprData=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];var listName=['ava','sold','revpar','rev','total'];listName.forEach(function(name){data[32][name]=data.reduce(function(a,b,i){return a+=i<31?(0,_method.numConvert)(b[name]):0;},0).toFixed(4);});data.forEach(function(item,i){data[i].revper=(0,_method.calculation)(item.rev,item.total,4);data[i].occ=(0,_method.calculation)(item.sold,item.ava,4);data[i].adr=(0,_method.calculation)(item.rev,item.sold,2);data[i].revpar=(0,_method.calculation)(item.rev,item.ava,2);});setKarte({data:[data.map(function(x){return(x.occ*100).toFixed(2);}).slice(0,31),lastYearData.map(function(x){return(x.occ*100).toFixed(2);}).slice(0,31)],name:"Occ%",id:'chartOcc'});setKarte({data:[data.map(function(x){return x.adr;}).slice(0,31),lastYearData.map(function(x){return(0,_method.numConvert)(x.adr).toFixed(2);}).slice(0,31)],name:"ADR",id:'chartAdr'});setKarte({data:[data.map(function(x){return x.revpar;}).slice(0,31),lastYearData.map(function(x){return(0,_method.numConvert)(x.revpar).toFixed(2);}).slice(0,31)],name:"RevPAR",id:'chartRevpar'});setKarte({data:[data.map(function(x){return(0,_method.numConvert)(x.rev).toFixed(2);}).slice(0,31),lastYearData.map(function(x){return(0,_method.numConvert)(x.rev).toFixed(2);}).slice(0,31)],name:"Room Revenue",id:'chartRoomRev'});if((0,_moment2.default)(date).format('M')==5||(0,_moment2.default)(date).format('M')==10){// 五一
setKarte({data:[data.map(function(x){return(x.occ*100).toFixed(2);}).slice(0,7),lastYearData.map(function(x){return(x.occ*100).toFixed(2);}).slice(0,7)],name:"Occ%",dataY:data.slice(0,7).map(function(x){return x.name;}),id:'chartHolidayOcc'});setKarte({data:[data.map(function(x){return x.adr;}).slice(0,7),lastYearData.map(function(x){return(0,_method.numConvert)(x.adr).toFixed(2);}).slice(0,7)],name:"ADR",dataY:data.slice(0,7).map(function(x){return x.name;}),id:'chartHolidayAdr'});setKarte({data:[data.map(function(x){return x.revpar;}).slice(0,7),lastYearData.map(function(x){return(0,_method.numConvert)(x.revpar).toFixed(2);}).slice(0,7)],name:"RevPAR",dataY:data.slice(0,7).map(function(x){return x.name;}),id:'chartHolidayRevpar'});setKarte({data:[data.map(function(x){return(0,_method.numConvert)(x.rev).toFixed(2);}).slice(0,7),lastYearData.map(function(x){return(0,_method.numConvert)(x.rev).toFixed(2);}).slice(0,7)],name:"Room Revenue",dataY:data.slice(0,7).map(function(x){return x.name;}),id:'chartHolidayRoomRev'});}if(SPR[(0,_moment2.default)(date).format('Y')].m==(0,_moment2.default)(date).format('M')){// 春节
var index=SPR[(0,_moment2.default)(date).format('Y')].d-1;var lastIndex=SPR[(0,_moment2.default)(date).subtract(1,'year').format('Y')].d-1;setKarte({data:[data.map(function(x){return(x.occ*100).toFixed(2);}).slice(index,index+7),sprData.map(function(x){return(x.occ*100).toFixed(2);}).slice(lastIndex,lastIndex+7)],name:"Occ%",dataY:['除夕','初一','初二','初三','初四','初五','初六'],id:'chartHolidayOcc'});setKarte({data:[data.map(function(x){return x.adr;}).slice(index,index+7),sprData.map(function(x){return(0,_method.numConvert)(x.adr).toFixed(2);}).slice(lastIndex,lastIndex+7)],name:"ADR",dataY:['除夕','初一','初二','初三','初四','初五','初六'],id:'chartHolidayAdr'});setKarte({data:[data.map(function(x){return x.revpar;}).slice(index,index+7),sprData.map(function(x){return(0,_method.numConvert)(x.revpar).toFixed(2);}).slice(lastIndex,lastIndex+7)],name:"RevPAR",dataY:['除夕','初一','初二','初三','初四','初五','初六'],id:'chartHolidayRevpar'});setKarte({data:[data.map(function(x){return(0,_method.numConvert)(x.rev).toFixed(2);}).slice(index,index+7),sprData.map(function(x){return(0,_method.numConvert)(x.rev).toFixed(2);}).slice(lastIndex,lastIndex+7)],name:"Room Revenue",dataY:['除夕','初一','初二','初三','初四','初五','初六'],id:'chartHolidayRoomRev'});}return data;}var setKarte=exports.setKarte=function setKarte(_ref,isOnResize){var data=_ref.data,name=_ref.name,dataY=_ref.dataY,id=_ref.id,dataX=_ref.dataX;var myChart=_echarts2.default.init(document.getElementById(id));myChart.resize();if(isOnResize){return;}var option={title:{text:name,textStyle:{align:'left',color:'#333',fontSize:20},top:'5%',left:'left'},legend:{top:'30',data:['this year','last year']},color:color,xAxis:{splitLine:{lineStyle:{show:true}},"axisLabel":{textStyle:{fontSize:12,color:'#000'}},data:dataY||new Array(31).fill(1).map(function(x,i){return i+1;})},yAxis:{name:name=='Occ%'?'%':'',type:'value'},tooltip:{trigger:'axis'// formatter: `{b}日<br/>{a} : {c}${name == 'Occ%' ? '%' : ''}` 
},toolbox:{id:id,right:20,feature:{saveAsImage:{type:'png',//	设置图片格式 png或者'jpeg
name:name,backgroundColor:'#FFF',excludeComponents:['toolbox'],show:true,title:'保存图片'// icon: ...,
}}},series:[{name:"this year",type:'line',data:data[0]},{name:"last year",type:'line',data:data[1]}]};myChart.setOption(option);};function computeYear(data,lastYearData){data=data.map(function(x){return _extends({},x);});lastYearData=lastYearData.map(function(x){return _extends({},x);});var listName=['ava','sold','revpar','rev','total'];listName.forEach(function(name){data[12][name]=data.reduce(function(a,b,i){return a+=i<12?(0,_method.numConvert)(b[name]):0;},0).toFixed(4);});data.forEach(function(item,i){if(i<12){data[i].name=i+1+"\u6708";}data[i].revper=(0,_method.calculation)(item.rev,item.total,4);data[i].occ=(0,_method.calculation)(item.sold,item.ava,4);data[i].adr=(0,_method.calculation)(item.rev,item.sold,2);data[i].revpar=(0,_method.calculation)(item.rev,item.ava,2);});var dataX=new Array(12).fill(1).map(function(x,i){return i+1+"\u6708";});setKarte({data:[data.map(function(x){return(x.occ*100).toFixed(2);}).slice(0,12),lastYearData.map(function(x){return(x.occ*100).toFixed(2);}).slice(0,12)],dataY:dataX,name:"Occ%",id:'chartOcc'});setKarte({data:[data.map(function(x){return x.adr;}).slice(0,12),lastYearData.map(function(x){return(0,_method.numConvert)(x.adr).toFixed(2);}).slice(0,12)],name:"ADR",dataY:dataX,id:'chartAdr'});setKarte({data:[data.map(function(x){return x.revpar;}).slice(0,12),lastYearData.map(function(x){return(0,_method.numConvert)(x.revpar).toFixed(2);}).slice(0,12)],name:"RevPAR",dataY:dataX,id:'chartRevpar'});setKarte({data:[data.map(function(x){return(0,_method.numConvert)(x.rev).toFixed(2);}).slice(0,12),lastYearData.map(function(x){return(0,_method.numConvert)(x.rev).toFixed(2);}).slice(0,12)],name:"Room Revenue",id:'chartRoomRev',dataY:dataX});return data;}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.defaultData=exports.data3=exports.data2=exports.data1=exports.columns3=exports.columns2=exports.columns1=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var columns1=exports.columns1=function columns1(_ref){var onChange=_ref.onChange,t_type=_ref.t_type;return[{title:"",dataIndex:'sort',key:'sort',align:"center",width:50,render:function render(text,record,index){var props={text:text+1,index:index,type:'text',name:"sort",onChange:onChange};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"榜单名称",dataIndex:'name',key:'name',align:"center",width:300,render:function render(text,record,index){var props={text:text,index:index,type:'input',name:"name",onChange:onChange,compared:{title:['西餐厅','榜单上榜情况'],record:_extends({},record,{name:'榜单名称'}),sqlName:"_5_9_2",t_type:t_type}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"榜单类型",dataIndex:'type',key:'type',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'input',name:"type",onChange:onChange,compared:{title:['西餐厅','榜单上榜情况'],record:_extends({},record,{name:'榜单类型'}),sqlName:"_5_9_2",t_type:t_type}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"评分",dataIndex:'rate',key:'rate',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"rate",onChange:onChange,compared:{title:['西餐厅','榜单上榜情况'],record:_extends({},record,{name:'评分'}),sqlName:"_5_9_2",t_type:t_type}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"高于全城同品类%的商户",dataIndex:'above',key:'above',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'inputPercent',name:"above",onChange:onChange,compared:{title:['西餐厅','榜单上榜情况'],record:_extends({},record,{name:'高于全城同品类%的商户'}),sqlName:"_5_9_2",t_type:t_type}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"名次",dataIndex:'rank',key:'rank',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"rank",onChange:onChange,compared:{title:['西餐厅','榜单上榜情况'],record:_extends({},record,{name:'名次'}),sqlName:"_5_9_2",t_type:t_type}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"备注",dataIndex:'note',key:'note',align:"center",width:300,render:function render(text,record,index){var props={text:text,index:index,type:'input',name:"note",onChange:onChange};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];};var columns2=exports.columns2=function columns2(_ref2){var onChange=_ref2.onChange,t_type=_ref2.t_type;return[{title:"",dataIndex:'sort',key:'sort',align:"center",width:50,render:function render(text,record,index){var props={text:text+1,index:index,type:'text',name:"sort",onChange:onChange};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"名称",dataIndex:'name',key:'name',align:"center",width:300,render:function render(text,record,index){var props={text:text,index:index,type:'input',name:"name",onChange:onChange,compared:{title:['西餐厅','套餐情况'],record:_extends({},record,{name:'名次'}),sqlName:"_5_9_3",t_type:t_type}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"消费时间",dataIndex:'time',key:'time',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'input',name:"time",onChange:onChange,compared:{title:['西餐厅','套餐情况'],record:_extends({},record,{name:'消费时间'}),sqlName:"_5_9_3",t_type:t_type}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"价格",dataIndex:'price',key:'price',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"price",onChange:onChange,compared:{title:['西餐厅','套餐情况'],record:_extends({},record,{name:'价格'}),sqlName:"_5_9_3",t_type:t_type}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"折扣",dataIndex:'discount',key:'discount',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputPercent',name:"discount",onChange:onChange,compared:{title:['西餐厅','套餐情况'],record:_extends({},record,{name:'折扣'}),sqlName:"_5_9_3",t_type:t_type}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"半年售",dataIndex:'num',key:'num',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"num",onChange:onChange,compared:{title:['西餐厅','套餐情况'],record:_extends({},record,{name:'半年售'}),sqlName:"_5_9_3",t_type:t_type}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];};var columns3=exports.columns3=function columns3(_ref3){var onChange=_ref3.onChange,t_type=_ref3.t_type;return[{title:"",dataIndex:'sort',key:'sort',align:"center",width:50,render:function render(text,record,index){var props={text:text+1,index:index,type:'text',name:"sort",onChange:onChange};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"名称",dataIndex:'name',key:'name',align:"center",width:300,render:function render(text,record,index){var props={text:text,index:index,type:'input',name:"name",onChange:onChange,compared:{title:['西餐厅','推荐菜品 TOP3'],record:_extends({},record,{name:'名称'}),sqlName:"_5_9_4",t_type:t_type}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"价格（如有）",dataIndex:'price',key:'price',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"price",onChange:onChange,compared:{title:['西餐厅',"\u63A8\u8350\u83DC\u54C1 No."+record.sort],record:_extends({},record,{name:'价格'}),sqlName:"_5_9_4",t_type:t_type}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];};var data1=exports.data1=[{sort:0,name:"",type:"",rate:0,above:0,rank:0,note:""},{sort:1,name:"",type:"",rate:0,above:0,rank:0,note:""},{sort:2,name:"",type:"",rate:0,above:0,rank:0,note:""},{sort:3,name:"",type:"",rate:0,above:0,rank:0,note:""},{sort:4,name:"",type:"",rate:0,above:0,rank:0,note:""},{sort:5,name:"",type:"",rate:0,above:0,rank:0,note:""},{sort:6,name:"",type:"",rate:0,above:0,rank:0,note:""},{sort:7,name:"",type:"",rate:0,above:0,rank:0,note:""}];var data2=exports.data2=[{sort:0,name:"",time:"",price:0,discount:0,num:0},{sort:1,name:"",time:"",price:0,discount:0,num:0},{sort:2,name:"",time:"",price:0,discount:0,num:0},{sort:3,name:"",time:"",price:0,discount:0,num:0},{sort:4,name:"",time:"",price:0,discount:0,num:0},{sort:5,name:"",time:"",price:0,discount:0,num:0},{sort:6,name:"",time:"",price:0,discount:0,num:0},{sort:7,name:"",time:"",price:0,discount:0,num:0}];var data3=exports.data3=[{sort:0,name:"",price:0},{sort:1,name:"",price:0},{sort:2,name:"",price:0}];var defaultData=exports.defaultData={rate:0,taste:"",environment:"",service:"",varieties:"",num:0,price:0};

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(25);__webpack_require__(35);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Title=function(_Component){_inherits(Title,_Component);function Title(){_classCallCheck(this,Title);return _possibleConstructorReturn(this,(Title.__proto__||Object.getPrototypeOf(Title)).apply(this,arguments));}_createClass(Title,[{key:'render',value:function render(){var _props=this.props,onChange=_props.onChange,data=_props.data,t_type=_props.t_type,name=_props.name;return _react2.default.createElement('div',{className:'components-title'},_react2.default.createElement('div',{className:'title-input'},_react2.default.createElement('div',{className:'desc'},'\u622A\u6B62\u5F53\u6708'),_react2.default.createElement('div',{className:'name'},_react2.default.createElement('div',null,'\u603B\u8BC4\u5206'),_react2.default.createElement('div',null,'\u53E3\u5473'),_react2.default.createElement('div',null,'\u73AF\u5883'),_react2.default.createElement('div',null,'\u670D\u52A1'),_react2.default.createElement('div',null,'\u54C1\u79CD')),_react2.default.createElement('div',{className:'value'},_react2.default.createElement(_Compared2.default,{data:{index:0,key:'rate',title:[name],sqlName:"_5_9_1",name:'总评分',t_type:t_type,type:"number"}},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(data.rate||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));console.log(value);onChange('rate',value||0);}})),_react2.default.createElement(_Compared2.default,{data:{index:0,key:'taste',title:[name],sqlName:"_5_9_1",name:'口味',t_type:t_type,type:"text"}},_react2.default.createElement(_input2.default,{defaultValue:data.taste,onBlur:function onBlur(e){return onChange('taste',e.target.value||"");}})),_react2.default.createElement(_Compared2.default,{data:{index:0,key:'environment',title:[name],sqlName:"_5_9_1",name:'环境',t_type:t_type,type:"text"}},_react2.default.createElement(_input2.default,{defaultValue:data.environment,onBlur:function onBlur(e){return onChange('environment',e.target.value||"");}})),_react2.default.createElement(_Compared2.default,{data:{index:0,key:'service',title:[name],sqlName:"_5_9_1",name:'服务',t_type:t_type,type:"text"}},_react2.default.createElement(_input2.default,{defaultValue:data.service,onBlur:function onBlur(e){return onChange('service',e.target.value||"");}})),_react2.default.createElement(_Compared2.default,{data:{index:0,key:'varieties',title:[name],sqlName:"_5_9_1",name:'品种',t_type:t_type,type:"text"}},_react2.default.createElement(_input2.default,{defaultValue:data.varieties,onBlur:function onBlur(e){return onChange('varieties',e.target.value||"");}})))),_react2.default.createElement('div',{className:'num'},_react2.default.createElement('div',{className:'item'},_react2.default.createElement('span',{className:'name'},'\u70B9\u8BC4\u6570\u91CF'),_react2.default.createElement(_Compared2.default,{data:{index:0,key:'num',title:[name],sqlName:"_5_9_1",name:'点评数量',t_type:t_type,type:"number"}},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(data.num||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));onChange('num',value);}}))),_react2.default.createElement('div',{className:'item'},_react2.default.createElement('span',{className:'name'},'\u4EBA\u5747\u6D88\u8D39\u989D'),_react2.default.createElement(_Compared2.default,{data:{index:0,key:'price',title:[name],sqlName:"_5_9_1",name:'人均消费额',t_type:t_type,type:"number"}},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(data.price||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));onChange('price',value);}})))));}}]);return Title;}(_react.Component);exports.default=Title;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var X=['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'];var getChartLine=function getChartLine(data,update,isOnResize){var title=data.title,_data$dataX=data.dataX,dataX=_data$dataX===undefined?X:_data$dataX,dataY=data.dataY,id=data.id;// 基于准备好的dom，初始化echarts实例
var myChart=_echarts2.default.init(document.getElementById(id));myChart.resize();if(isOnResize){return;}if(update){// 填入数据
myChart.setOption({legend:{data:dataY.map(function(x){return x.title;})},xAxis:{data:dataX},series:dataY.map(function(x){return{name:x.title,data:x.data,type:'line',symbol:'circle',itemStyle:{normal:{lineStyle:{width:1.2}}}};})});return;}var option={color:['#327AB7','#4AC18E','#D9534F','#67A8E4'],tooltip:{trigger:'axis'//formatter: "{b} <br> 合格率: {c}%"
},legend:{data:[title],align:'left',textStyle:{color:'rgba(102, 102, 102, 1)',padding:[0,0,0,16]}},grid:{top:'12%',bottom:'6%',left:'3%',right:'6%',containLabel:true},xAxis:{type:'category',name:'',boundaryGap:false,axisLine:{show:false,lineStyle:{color:'#525252'}},axisTick:{show:false},axisLabel:{color:'#525252'},data:dataX},yAxis:{type:'value',name:'',axisLine:{show:false},axisTick:{show:false},axisLabel:{color:'#525252'},splitLine:{lineStyle:{type:'dotted',color:'#AAA'//F3F3F3	
}}},series:dataY.map(function(x){return{name:title,type:'line',symbol:'circle',itemStyle:{normal:{lineStyle:{width:1.2// 0.1的线条是非常细的了
}}},data:x.data};})};// 使用刚指定的配置项和数据显示图表。
myChart.setOption(option);};exports.default=getChartLine;

/***/ }),
/* 442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(723);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.isEventFromHandle = isEventFromHandle;
exports.isValueOutOfRange = isValueOutOfRange;
exports.isNotTouchEvent = isNotTouchEvent;
exports.getClosestPoint = getClosestPoint;
exports.getPrecision = getPrecision;
exports.getMousePosition = getMousePosition;
exports.getTouchPosition = getTouchPosition;
exports.getHandleCenterPosition = getHandleCenterPosition;
exports.ensureValueInRange = ensureValueInRange;
exports.ensureValuePrecision = ensureValuePrecision;
exports.pauseEvent = pauseEvent;
exports.calculateNextValue = calculateNextValue;
exports.getKeyboardValueMutator = getKeyboardValueMutator;

var _reactDom = __webpack_require__(46);

var _KeyCode = __webpack_require__(194);

var _KeyCode2 = _interopRequireDefault(_KeyCode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isEventFromHandle(e, handles) {
  try {
    return Object.keys(handles).some(function (key) {
      return e.target === (0, _reactDom.findDOMNode)(handles[key]);
    });
  } catch (error) {
    return false;
  }
}

function isValueOutOfRange(value, _ref) {
  var min = _ref.min,
      max = _ref.max;

  return value < min || value > max;
}

function isNotTouchEvent(e) {
  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
}

function getClosestPoint(val, _ref2) {
  var marks = _ref2.marks,
      step = _ref2.step,
      min = _ref2.min,
      max = _ref2.max;

  var points = Object.keys(marks).map(parseFloat);
  if (step !== null) {
    var maxSteps = Math.floor((max - min) / step);
    var steps = Math.min((val - min) / step, maxSteps);
    var closestStep = Math.round(steps) * step + min;
    points.push(closestStep);
  }
  var diffs = points.map(function (point) {
    return Math.abs(val - point);
  });
  return points[diffs.indexOf(Math.min.apply(Math, (0, _toConsumableArray3['default'])(diffs)))];
}

function getPrecision(step) {
  var stepString = step.toString();
  var precision = 0;
  if (stepString.indexOf('.') >= 0) {
    precision = stepString.length - stepString.indexOf('.') - 1;
  }
  return precision;
}

function getMousePosition(vertical, e) {
  return vertical ? e.clientY : e.pageX;
}

function getTouchPosition(vertical, e) {
  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}

function getHandleCenterPosition(vertical, handle) {
  var coords = handle.getBoundingClientRect();
  return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
}

function ensureValueInRange(val, _ref3) {
  var max = _ref3.max,
      min = _ref3.min;

  if (val <= min) {
    return min;
  }
  if (val >= max) {
    return max;
  }
  return val;
}

function ensureValuePrecision(val, props) {
  var step = props.step;

  var closestPoint = isFinite(getClosestPoint(val, props)) ? getClosestPoint(val, props) : 0; // eslint-disable-line
  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
}

function pauseEvent(e) {
  e.stopPropagation();
  e.preventDefault();
}

function calculateNextValue(func, value, props) {
  var operations = {
    increase: function increase(a, b) {
      return a + b;
    },
    decrease: function decrease(a, b) {
      return a - b;
    }
  };

  var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
  var keyToGet = Object.keys(props.marks)[indexToGet];

  if (props.step) {
    return operations[func](value, props.step);
  } else if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) {
    return props.marks[keyToGet];
  }
  return value;
}

function getKeyboardValueMutator(e, vertical, reverse) {
  var increase = 'increase';
  var decrease = 'decrease';
  var method = increase;
  switch (e.keyCode) {
    case _KeyCode2['default'].UP:
      method = vertical && reverse ? decrease : increase;break;
    case _KeyCode2['default'].RIGHT:
      method = !vertical && reverse ? decrease : increase;break;
    case _KeyCode2['default'].DOWN:
      method = vertical && reverse ? increase : decrease;break;
    case _KeyCode2['default'].LEFT:
      method = !vertical && reverse ? increase : decrease;break;

    case _KeyCode2['default'].END:
      return function (value, props) {
        return props.max;
      };
    case _KeyCode2['default'].HOME:
      return function (value, props) {
        return props.min;
      };
    case _KeyCode2['default'].PAGE_UP:
      return function (value, props) {
        return value + props.step * 2;
      };
    case _KeyCode2['default'].PAGE_DOWN:
      return function (value, props) {
        return value - props.step * 2;
      };

    default:
      return undefined;
  }
  return function (value, props) {
    return calculateNextValue(method, value, props);
  };
}

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _tooltip=__webpack_require__(87);var _tooltip2=_interopRequireDefault(_tooltip);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(62);__webpack_require__(8);__webpack_require__(4);__webpack_require__(25);__webpack_require__(100);__webpack_require__(6);__webpack_require__(10);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);__webpack_require__(315);__webpack_require__(197);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ExportPdf=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(ExportPdf,_Component);function ExportPdf(props){_classCallCheck(this,ExportPdf);var _this=_possibleConstructorReturn(this,(ExportPdf.__proto__||Object.getPrototypeOf(ExportPdf)).call(this,props));_this.onExportPdf=function(){var user=JSON.parse(sessionStorage.getItem('user'))||{};_this.setState({visible:true,selectedRowKeys:[Number(user.comid||"0")]});};_this.handleOk=function(){_this.setState({loadingSave:true});fetch("/chooseHotels?comid="+_this.state.selectedRowKeys.toString(),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this.setState({loadingSave:false});if(x.status==1){sessionStorage.setItem('user',JSON.stringify(x.data));_message3.default.info('设置成功！');_this.setState({visible:false});window.location.reload();}else{_message3.default.error(x.msg);}}).catch(function(err){_this.setState({loadingSave:false});_message3.default.info('设置错误！');console.error(err);});};_this.handleCancel=function(){_this.setState({visible:false});};_this.onSearch=function(){var hotelTotal=_this.state.hotelTotal;var name=_this.state.name;// 去除所有空格不区分大小写
var hotel=hotelTotal.filter(function(x){return x.name.toUpperCase().replace(/\s+/g,"").includes(name.toUpperCase().replace(/\s+/g,""));});_this.setState({hotel:hotel});};_this.state={visible:false,loading:false,value:'',hotel:[],hotelTotal:[],loadingSave:false,selectedRowKeys:[]};return _this;}_createClass(ExportPdf,[{key:"componentDidMount",value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var hotel;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return this.props.store.menu.getHeadquartersHotels();case 3:hotel=_context.sent;_context.next=6;return this.setState({hotel:hotel||[],hotelTotal:hotel||[],loading:false});case 6:_context.next=12;break;case 8:_context.prev=8;_context.t0=_context["catch"](0);this.setState({loading:false});console.error(_context.t0);case 12:case"end":return _context.stop();}}},_callee,this,[[0,8]]);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:"render",value:function render(){var _this2=this;if(!(this.props.user.email||'').includes('admin')){return null;}// 酒店列表
var columnsHotel=[{title:'key',dataIndex:'id',key:'id'},{title:'酒店名称',dataIndex:'name',key:'name'},{title:'联系人',dataIndex:'contacts',key:'contacts'},{title:'地址',dataIndex:'address',key:'address'},{title:'联系电话',key:'tel',dataIndex:'tel'}];var rowSelection={selectedRowKeys:this.state.selectedRowKeys,onChange:function onChange(key,selectedRows){_this2.setState({selectedRowKeys:key});},type:'radio'};var user=JSON.parse(sessionStorage.getItem('user'))||{};var index=this.state.hotelTotal.findIndex(function(x){return x.id==user.comid;});var hotelName=this.state.hotelTotal.length>0?index>=0?this.state.hotelTotal[index].name||"":'':'';sessionStorage.setItem('hotelName',hotelName);var display=this.props.display;return _react2.default.createElement("div",null,_react2.default.createElement(_tooltip2.default,{title:"\u5207\u6362\u9152\u5E97"},!display?_react2.default.createElement(_button2.default,{type:"primary",icon:hotelName?'swap':'plus',onClick:this.onExportPdf,className:"menu_select_none"}):null),display?_react2.default.createElement("div",{className:"hotel_name"},_react2.default.createElement(_button2.default,{type:"primary",className:"select_btn",onClick:this.onExportPdf},"\u9009\u62E9\u9152\u5E97"),_react2.default.createElement("div",{className:"select_hotel_name"}," ",hotelName?_react2.default.createElement("div",null,hotelName.replace(/[^\u4E00-\u9FA5]/g,""),_react2.default.createElement("br",null),hotelName.replace(/[^a-zA-Z0-9\s]/g,'')):'')):null,_react2.default.createElement(_modal2.default,{title:'酒店选择',visible:this.state.visible,onOk:this.handleOk,onCancel:function onCancel(){return _this2.setState({visible:false});},className:"compared-modal",footer:[_react2.default.createElement(_button2.default,{key:"back",onClick:function onClick(){return _this2.setState({visible:false});}},"\u53D6\u6D88"),_react2.default.createElement(_button2.default,{key:"submit",type:"primary",loading:this.state.loadingSave,onClick:this.handleOk},"\u786E\u5B9A")]},_react2.default.createElement(_row2.default,null,_react2.default.createElement("span",null,"\u9152\u5E97\u540D\u79F0\uFF1A"),_react2.default.createElement(_input2.default,{style:{width:200,marginRight:10},value:this.state.name,onChange:function onChange(e){_this2.setState({name:(e.target.value||"").trim()});},onPressEnter:this.onSearch}),_react2.default.createElement(_button2.default,{type:"primary",onClick:this.onSearch},"\u641C\u7D22")),_react2.default.createElement(_table2.default,{style:{marginTop:10},columns:columnsHotel,dataSource:this.state.hotel,bordered:true,className:"hotelModal",rowSelection:rowSelection,rowKey:function rowKey(item){return item.id;}})));}}]);return ExportPdf;}(_react.Component))||_class)||_class);exports.default=ExportPdf;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.commonMixinWrapper = exports.defaultProp = exports.propType = undefined;

var _classCallCheck2 = __webpack_require__(31);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(32);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _en_US = __webpack_require__(462);

var _en_US2 = _interopRequireDefault(_en_US);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

var propType = exports.propType = {
  className: _propTypes2['default'].string,
  locale: _propTypes2['default'].object,
  style: _propTypes2['default'].object,
  visible: _propTypes2['default'].bool,
  onSelect: _propTypes2['default'].func,
  prefixCls: _propTypes2['default'].string,
  onChange: _propTypes2['default'].func,
  onOk: _propTypes2['default'].func
};

var defaultProp = exports.defaultProp = {
  locale: _en_US2['default'],
  style: {},
  visible: true,
  prefixCls: 'rc-calendar',
  className: '',
  onSelect: noop,
  onChange: noop,
  onClear: noop,
  renderFooter: function renderFooter() {
    return null;
  },
  renderSidebar: function renderSidebar() {
    return null;
  }
};

var commonMixinWrapper = exports.commonMixinWrapper = function commonMixinWrapper(ComposeComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_ComposeComponent) {
    (0, _inherits3['default'])(_class, _ComposeComponent);

    function _class() {
      var _temp, _this, _ret;

      (0, _classCallCheck3['default'])(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _ComposeComponent.call.apply(_ComposeComponent, [this].concat(args))), _this), _this.getFormat = function () {
        var format = _this.props.format;
        var _this$props = _this.props,
            locale = _this$props.locale,
            timePicker = _this$props.timePicker;

        if (!format) {
          if (timePicker) {
            format = locale.dateTimeFormat;
          } else {
            format = locale.dateFormat;
          }
        }
        return format;
      }, _this.focus = function () {
        if (_this.focusElement) {
          _this.focusElement.focus();
        } else if (_this.rootInstance) {
          _this.rootInstance.focus();
        }
      }, _this.saveFocusElement = function (focusElement) {
        _this.focusElement = focusElement;
      }, _this.saveRoot = function (root) {
        _this.rootInstance = root;
      }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
    }

    _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
      return this.props.visible || nextProps.visible;
    };

    return _class;
  }(ComposeComponent), _class.displayName = 'CommonMixinWrapper', _class.defaultProps = ComposeComponent.defaultProps, _class.getDerivedStateFromProps = ComposeComponent.getDerivedStateFromProps, _temp2;
};

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.authData=undefined;var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var authData=exports.authData=[{title:'1.0 Hotel Managers Situation Report <br/>\u9152\u5E97B2\u7EA7\u4EE5\u4E0A\u7BA1\u7406\u5C42\u60C5\u51B5\u62A5\u544A',value:'/hr/1',key:'/hr/1',children:[{title:'查看',key:'read_1'},{title:'编辑',key:'edit_1'}]},{title:'2.0 Hotel Manning Level Report<br/> \u9152\u5E97\u4EBA\u5458\u914D\u7F6E\u53CA\u6D41\u52A8\u60C5\u51B5\u62A5\u544A',value:'/hr/2',key:'/hr/2',children:[{title:'查看',key:'read_2'},{title:'编辑',key:'edit_2'}]},{title:'3.0 Hotel Post Vacancy Report <br/>\u9152\u5E97B2\u7EA7\u4EE5\u4E0A\u7A7A\u7F3A\u804C\u4F4D\u62A5\u544A',value:'/hr/3',key:'/hr/3',children:[{title:'查看',key:'read_3'},{title:'编辑',key:'edit_3'}]},{title:'4.0 Hotel Training Report <br/>\u9152\u5E97\u57F9\u8BAD\u62A5\u544A',value:'/hr/4',key:'/hr/4',children:[{title:'4.1 Hotel Training Report \u9152\u5E97\u57F9\u8BAD\u62A5\u544A',value:'/hr/4_1',key:'/hr/4_1',children:[{title:'查看',key:'read_4_1'},{title:'编辑',key:'edit_4_1'}]},{title:"4.2 Dept. Training Records<br/> 部门培训记录汇总",value:"/hr/4_2",key:"/hr/4_2",children:[{title:'4.2.1 ADMIN & EO \u884C\u653F\u90E8',value:'/hr/4_2_11',key:'/hr/4_2_11',children:[{title:'查看',key:'read_4_2_11'},{title:'编辑',key:'edit_4_2_11'}]},{title:'4.2.2 HR \u90E8\u95E8',value:'/hr/4_2_1',key:'/hr/4_2_1',children:[{title:'查看',key:'read_4_2_1'},{title:'编辑',key:'edit_4_2_1'}]},{title:'4.2.3 FIN \u90E8\u95E8',value:'/hr/4_2_2',key:'/hr/4_2_2',children:[{title:'查看',key:'read_4_2_2'},{title:'编辑',key:'edit_4_2_2'}]},{title:'4.2.4 ENG \u90E8\u95E8',value:'/hr/4_2_3',key:'/hr/4_2_3',children:[{title:'查看',key:'read_4_2_3'},{title:'编辑',key:'edit_4_2_3'}]},{title:'4.2.5 SEC \u90E8\u95E8',value:'/hr/4_2_4',key:'/hr/4_2_4',children:[{title:'查看',key:'read_4_2_4'},{title:'编辑',key:'edit_4_2_4'}]},{title:'4.2.6 FO \u90E8\u95E8 ',value:'/hr/4_2_5',key:'/hr/4_2_5',children:[{title:'查看',key:'read_4_2_5'},{title:'编辑',key:'edit_4_2_5'}]},{title:'4.2.7 HSKP \u90E8\u95E8',value:'/hr/4_2_6',key:'/hr/4_2_6',children:[{title:'查看',key:'read_4_2_6'},{title:'编辑',key:'edit_4_2_6'}]},{title:'4.2.8 F&B \u90E8\u95E8',value:'/hr/4_2_7',key:'/hr/4_2_7',children:[{title:'查看',key:'read_4_2_7'},{title:'编辑',key:'edit_4_2_7'}]},{title:'4.2.9 S&M \u90E8\u95E8',value:'/hr/4_2_8',key:'/hr/4_2_8',children:[{title:'查看',key:'read_4_2_8'},{title:'编辑',key:'edit_4_2_8'}]}]},{title:'4.3 Core Training Programs Records '+(0,_moment2.default)().format('YYYY')+' '+(0,_moment2.default)().format('YYYY')+' \u6838\u5FC3\u8BFE\u7A0B\u57F9\u8BAD\u8BB0\u5F55',value:'/hr/4_3_1',key:'/hr/4_3_1',children:[{title:'查看',key:'read_4_3_1'},{title:'编辑',key:'edit_4_3_1'}]// children: [{
//     title: `4.3.1 HR 部门`,
//     value: '/hr/4_3_1',
//     key: '/hr/4_3_1',
//     children: [{
//         title: '查看',
//         key: 'read_4_3_1',
//     }, {
//         title: '编辑',
//         key: 'edit_4_3_1',
//     }]
// }, {
//     title: `4.3.2 FIN 部门`,
//     value: '/hr/4_3_2',
//     key: '/hr/4_3_2',
//     children: [{
//         title: '查看',
//         key: 'read_4_3_2',
//     }, {
//         title: '编辑',
//         key: 'edit_4_3_2',
//     }]
// }, {
//     title: `4.3.3 ENG 部门`,
//     value: '/hr/4_3_3',
//     key: '/hr/4_3_3',
//     children: [{
//         title: '查看',
//         key: 'read_4_3_3',
//     }, {
//         title: '编辑',
//         key: 'edit_4_3_3',
//     }]
// }, {
//     title: `4.3.4 SEC 部门`,
//     value: '/hr/4_3_4',
//     key: '/hr/4_3_4',
//     children: [{
//         title: '查看',
//         key: 'read_4_3_4',
//     }, {
//         title: '编辑',
//         key: 'edit_4_3_4',
//     }]
// }, {
//     title: `4.3.5 FO 部门 `,
//     value: '/hr/4_3_5',
//     key: '/hr/4_3_5',
//     children: [{
//         title: '查看',
//         key: 'read_4_3_5',
//     }, {
//         title: '编辑',
//         key: 'edit_4_3_5',
//     }]
// }, {
//     title: `4.3.6 HSKP 部门`,
//     value: '/hr/4_3_6',
//     key: '/hr/4_3_6',
//     children: [{
//         title: '查看',
//         key: 'read_4_3_6',
//     }, {
//         title: '编辑',
//         key: 'edit_4_3_6',
//     }]
// }, {
//     title: `4.3.7 F&B 部门`,
//     value: '/hr/4_3_7',
//     key: '/hr/4_3_7',
//     children: [{
//         title: '查看',
//         key: 'read_4_3_7',
//     }, {
//         title: '编辑',
//         key: 'edit_4_3_7',
//     }]
// }, {
//     title: `4.3.8 S&M 部门`,
//     value: '/hr/4_3_8',
//     key: '/hr/4_3_8',
//     children: [{
//         title: '查看',
//         key: 'read_4_3_8',
//     }, {
//         title: '编辑',
//         key: 'edit_4_3_8',
//     }]
// }]
}]},{title:'5.0 Hotel AL&OT Summary Report<br/> \u9152\u5E97\u5E74\u5047\u53CA\u52A0\u73ED\u7EDF\u8BA1\u62A5\u544A',value:'/hr/5',key:'/hr/5',children:[{title:'查看',key:'read_5'},{title:'编辑',key:'edit_5'}]},{title:'6.0 Hotel PM Report <br/>\u9152\u5E97\u79EF\u6781\u6D41\u52A8\u7387\u62A5\u544A',value:'/hr/6',key:'/hr/6',children:[{title:'查看',key:'read_6'},{title:'编辑',key:'edit_6'}]},{title:'7.0 Dept.  Training Calendar<br/> \u90E8\u95E8\u57F9\u8BAD\u65E5\u5386',value:'/hr/7',key:'/hr/7',children:[{title:'7.1 Training Calendar Dept - HOJO <br/>HR\u7EC4\u7EC7\u7684\u9152\u5E97\u516C\u5171\u8BFE',value:'/hr/7_1',key:'/hr/7_1',children:[{title:'7.1.1 HR \u90E8\u95E8',value:'/hr/7_1/HR',key:'/hr/7_1/HR',children:[{title:'查看',key:'read_7_1_1'},{title:'编辑',key:'edit_7_1_1'}]},,{title:'7.1.2 FIN \u90E8\u95E8',value:'/hr/7_1/FIN',key:'/hr/7_1/FIN',children:[{title:'查看',key:'read_7_1_2'},{title:'编辑',key:'edit_7_1_2'}]},{title:'7.1.3 ENG \u90E8\u95E8',value:'/hr/7_1/ENG',key:'/hr/7_1/ENG',children:[{title:'查看',key:'read_7_1_3'},{title:'编辑',key:'edit_7_1_3'}]},{title:'7.1.4 SEC \u90E8\u95E8',value:'/hr/7_1/SEC',key:'/hr/7_1/SEC',children:[{title:'查看',key:'read_7_1_4'},{title:'编辑',key:'edit_7_1_4'}]},{title:'7.1.5 FO \u90E8\u95E8',value:'/hr/7_1/FO',key:'/hr/7_1/FO',children:[{title:'查看',key:'read_7_1_5'},{title:'编辑',key:'edit_7_1_5'}]},{title:'7.1.6 HSKP \u90E8\u95E8',value:'/hr/7_1/HSKP',key:'/hr/7_1/HSKP',children:[{title:'查看',key:'read_7_1_6'},{title:'编辑',key:'edit_7_1_6'}]},{title:'7.1.7 F&B \u90E8\u95E8',value:'/hr/7_1/F&B',key:'/hr/7_1/F&B',children:[{title:'查看',key:'read_7_1_7'},{title:'编辑',key:'edit_7_1_7'}]},{title:'7.1.8 S&M \u90E8\u95E8',value:'/hr/7_1/S&M',key:'/hr/7_1/S&M',children:[{title:'查看',key:'read_7_1_8'},{title:'编辑',key:'edit_7_1_8'}]},{title:'7.1.9 HR \u7EC4\u7EC7\u7684\u9152\u5E97\u516C\u5171\u8BFE',value:'/hr/7_1/HRPC',key:'/hr/7_1/HRPC',children:[{title:'查看',key:'read_7_1_9'},{title:'编辑',key:'edit_7_1_9'}]}]},{title:'7.2 Training Calendar Dept - WGPR <br/>HR\u7EC4\u7EC7\u7684\u9152\u5E97\u516C\u5171\u8BFE',value:'/hr/7_2',key:'/hr/7_2',children:[{title:'7.2.1 HR \u90E8\u95E8',value:'/hr/7_2/HR',key:'/hr/7_2/HR',children:[{title:'查看',key:'read_7_2_1'},{title:'编辑',key:'edit_7_2_1'}]},,{title:'7.2.2 FIN \u90E8\u95E8',value:'/hr/7_2/FIN',key:'/hr/7_2/FIN',children:[{title:'查看',key:'read_7_2_2'},{title:'编辑',key:'edit_7_2_2'}]},{title:'7.2.3 ENG \u90E8\u95E8',value:'/hr/7_2/ENG',key:'/hr/7_2/ENG',children:[{title:'查看',key:'read_7_2_3'},{title:'编辑',key:'edit_7_2_3'}]},{title:'7.2.4 SEC \u90E8\u95E8',value:'/hr/7_2/SEC',key:'/hr/7_2/SEC',children:[{title:'查看',key:'read_7_2_4'},{title:'编辑',key:'edit_7_2_4'}]},{title:'7.2.5 FO \u90E8\u95E8',value:'/hr/7_2/FO',key:'/hr/7_2/FO',children:[{title:'查看',key:'read_7_2_5'},{title:'编辑',key:'edit_7_2_5'}]},{title:'7.2.6 HSKP \u90E8\u95E8',value:'/hr/7_2/HSKP',key:'/hr/7_2/HSKP',children:[{title:'查看',key:'read_7_2_6'},{title:'编辑',key:'edit_7_2_6'}]},{title:'7.2.7 F&B \u90E8\u95E8',value:'/hr/7_2/F&B',key:'/hr/7_2/F&B',children:[{title:'查看',key:'read_7_2_7'},{title:'编辑',key:'edit_7_2_7'}]},{title:'7.2.8 S&M \u90E8\u95E8',value:'/hr/7_2/S&M',key:'/hr/7_2/S&M',children:[{title:'查看',key:'read_7_2_8'},{title:'编辑',key:'edit_7_2_8'}]},{title:'7.2.9 HR \u7EC4\u7EC7\u7684\u9152\u5E97\u516C\u5171\u8BFE',value:'/hr/7_2/HRPC',key:'/hr/7_2/HRPC',children:[{title:'查看',key:'read_7_2_9'},{title:'编辑',key:'edit_7_2_9'}]}]}]},{title:'8.0 Case Studies <br/>\u6848\u4F8B\u5206\u6790',value:'/hr/8',key:'/hr/8',children:[{title:'查看',key:'read_8'},{title:'编辑',key:'edit_8'}]},// {
//     title: `9.0 Labor Cost and Productivity 人力成本及生产效率对比分析`,
//     value: '/hr/9',
//     key: '/hr/9',
//     children: [{
//         title: '查看',
//         key: 'read_9',
//     }, {
//         title: '编辑',
//         key: 'edit_9',
//     }]
// },
// 迁移至ES7.7
{title:'HR-\u5DF2\u6DFB\u52A0PDF\u5217\u8868',value:'/hr/pdf',key:'/hr/pdf',children:[{title:'查看',key:'read_pdf'},{title:'编辑',key:'edit_pdf'}]},{title:'Business Plan 年度经营计划',value:'/bp',key:'/bp',children:[{title:'查看',key:'read_bp'},{title:'编辑',key:'edit_bp'}]},{title:'Executive Summary Report 月度经营报告',value:'/table',key:'/table',children:[{title:'查看',key:'read_table'},{title:'编辑',key:'edit_table'}]}];exports.default=authData;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.authData=undefined;var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var authData=exports.authData=[{title:'BUSINESS PLAN 2024 TIMELINE',value:'/bp/time',key:'/bp/time',children:[{title:'查看',key:'read_time'},{title:'编辑',key:'edit_time'}]},{title:'Business Plan '+(0,_moment2.default)().add(1,'y').format('YYYY')+' Review Meeting Schedule',value:'/bp/meeting',key:'/bp/meeting',children:[{title:'查看',key:'read_meeting'},{title:'编辑',key:'edit_meeting'}]},{title:'Hotel Information <br />\u9152\u5E97\u4FE1\u606F',value:'/bp/cover',key:'/bp/cover',children:[{title:'查看',key:'read_cover'},{title:'编辑',key:'edit_cover'}]},{title:'Corporate Office Target <br />\u96C6\u56E2\u6307\u6807',value:'/bp/target',key:'/bp/target',children:[{title:'查看',key:'read_target'},{title:'编辑',key:'edit_target'}]},{title:'Corporate Office Strategic Target<br/> \u96C6\u56E2\u4E09\u5E74\u6218\u7565\u89C4\u5212',value:'/bp/strategic',key:'/bp/strategic',children:[{title:'查看',key:'read_strategic'},{title:'编辑',key:'edit_strategic'}]},{title:'\u8D22\u52A1\u603B\u76D1\u9610\u8FF0',value:'/bp/elaborate_DOF',key:'/bp/elaborate_DOF',children:[{title:'查看',key:'read_elaborate_DOF'},{title:'编辑',key:'edit_elaborate_DOF'}]},{title:'\u9500\u552E\u603B\u76D1\u9610\u8FF0',value:'/bp/elaborate_DOSM',key:'/bp/elaborate_DOSM',children:[{title:'查看',key:'read_elaborate_DOSM'},{title:'编辑',key:'edit_elaborate_DOSM'}]},{title:'1.0 DATA INPUT <br/> 数据导入',value:'/bp/1',key:'/bp/1',children:[{title:'1.1 DATA INPUT '+(Number((0,_moment2.default)().format('YYYY'))-1)+' and '+(0,_moment2.default)().format('YYYY')+' \u6570\u636E\u8F93\u5165 '+(Number((0,_moment2.default)().format('YYYY'))-1)+' and '+(0,_moment2.default)().format('YYYY'),value:'/bp/1_1',key:'/bp/1_1',children:[{title:'查看',key:'read_1_1'},{title:'编辑',key:'edit_1_1'}]},{title:'1.2 DATA INPUT '+(0,_moment2.default)().add(1,'y').format('YYYY')+' \u6570\u636E\u8F93\u5165 '+(0,_moment2.default)().add(1,'y').format('YYYY'),value:'/bp/1_2',key:'/bp/1_2',children:[{title:'查看',key:'read_1_2'},{title:'编辑',key:'edit_1_2'}]}]},{title:'2.0 Executive Summary <br />\u7ECF\u8425\u7EFC\u5408\u62A5\u544A',value:'/bp/2',key:'/bp/2',children:[{title:'查看',key:'read_2'},{title:'编辑',key:'edit_2'}]},{title:'3.0 Market Planning<br/> 市场计划',value:'/bp/3',key:'/bp/3',children:[{title:'3.1 External Factors and Possible Impacts \u5916\u90E8\u56E0\u7D20\u53CA\u53EF\u80FD\u5E26\u6765\u7684\u5F71\u54CD',value:'/bp/3_1',key:'/bp/3_1',children:[{title:'查看',key:'read_3_1'},{title:'编辑',key:'edit_3_1'}]},{title:'3.2 Internal Factors \u5185\u90E8\u56E0\u7D20',value:'/bp/3_2',key:'/bp/3_2',children:[{title:'查看',key:'read_3_2'},{title:'编辑',key:'edit_3_2'}]}]},{title:'4.0 Internal Analysis (SWOT)<br /> \u5185\u90E8 (S \u4F18\u52BF W \u52A3\u52BF O \u673A\u4F1A T \u5A01\u80C1 \u5206\u6790',value:'/bp/4',key:'/bp/4',children:[{title:'查看',key:'read_4'},{title:'编辑',key:'edit_4'}]},{title:'5.0 Competitive Landscape<br/> 竞争势态',value:'/bp/5',key:'/bp/5',children:[{title:'5.1 Competitive Information \u7ADE\u4E89\u5BF9\u624B\u4FE1\u606F',value:'/bp/5_1',key:'/bp/5_1',children:[{title:'查看',key:'read_5_1'},{title:'编辑',key:'edit_5_1'}]},{title:'5.2 Competitive SWOT Analysis \u7ADE\u4E89\u5BF9\u624BSWOT\u5206\u6790',value:'/bp/5_2',key:'/bp/5_2',children:[{title:'查看',key:'read_5_2'},{title:'编辑',key:'edit_5_2'}]},{title:'5.3 KPI Trend Analysis \u5173\u952E\u7EE9\u6548\u6307\u6570\u8D8B\u52BF\u5206\u6790',value:'/bp/5_3',key:'/bp/5_3',children:[{title:'查看',key:'read_5_3'},{title:'编辑',key:'edit_5_3'}]}]},{title:'6.0 Rates<br/> 价格体系',value:'/bp/6_all',key:'/bp/6_all',children:[{title:'6.1 Rate Structure \u4EF7\u683C\u4F53\u7CFB\u6A21\u677F',value:'/bp/7',key:'/bp/7',children:[{title:'查看',key:'read_7'},{title:'编辑',key:'edit_7'}]}]},{title:'7.0 Rooms Statistic<br /> \u5BA2\u623F\u7EDF\u8BA1',value:'/bp/7_1',key:'/bp/7_1',children:[{title:'查看',key:'read_7_1'},{title:'编辑',key:'edit_7_1'}]},{title:'8.0 Room Revenue Budget <br/>客房收益预算',value:'/bp/8_all',key:'/bp/8_all',children:[{title:'8.1 Definitions of Key Market Segments \u4E3B\u8981\u7EC6\u5206\u5E02\u573A\u7684\u5B9A\u4E49',value:'/bp/8_4',key:'/bp/8_4',children:[{title:'查看',key:'read_8_4'},{title:'编辑',key:'edit_8_4'}]},{title:'8.2 Budget By Market Segment \u5E02\u573A\u7EC6\u5206\u9884\u7B97',value:'/bp/8',key:'/bp/8',children:[{title:'查看',key:'read_8'},{title:'编辑',key:'edit_8'}]},// {
//     title: `8.2 Three Years Market Segment 三年市场细分`,
//     value: '/bp/8_1',
//     key: '/bp/8_1',
//     children: [{
//         title: '查看',
//         key: 'read_8_1',
//     }, {
//         title: '编辑',
//         key: 'edit_8_1',
//     }]
// },
{title:'8.3 Market Segment Strategy \u7EC6\u5206\u5E02\u573A\u6218\u7565',value:'/bp/8_3',key:'/bp/8_3',children:[{title:'查看',key:'read_8_3'},{title:'编辑',key:'edit_8_3'}]}]},{title:'8.0 new',value:'/bp/8_new',key:'/bp/8_new',children:[{title:'8.1 Definitions of Key Market Segments \u4E3B\u8981\u7EC6\u5206\u5E02\u573A\u7684\u5B9A\u4E49',value:'/bp/8_4',key:'/bp/8_4',children:[{title:'查看',key:'read_8_4'},{title:'编辑',key:'edit_8_4'}]},{title:'8.2',value:'/bp/8_2new',key:'/bp/8_2new',children:[{title:'8.2.1 Budget By Market Segment 市场细分预算',value:'/bp/8new_2_1',key:'/bp/8new_2_1',children:[{title:'查看',key:'read_8new_2_1'},{title:'编辑',key:'edit_8new_2_1'}]},{title:'8.2.2 Yearly Budget By Market Segment 年度预算市场细分数据分析 ',value:'/bp/8new_2_2',key:'/bp/8new_2_2',children:[{title:'查看',key:'read_8new_2_2'},{title:'编辑',key:'edit_8new_2_2'}]},{title:'8.2.3 Budget Summary',value:'/bp/8_0_budget',key:'/bp/8_0_budget',children:[{title:'查看',key:'read_8_0_budget'},{title:'编辑',key:'edit_8_0_budget'}]}]},{title:'8.3',value:'/bp/8_3new',key:'/bp/8_3new',children:[{title:'8.3.1 Market Segment Strategy 细分市场战略',value:'/bp/8new_3_1',key:'/bp/8new_3_1',children:[{title:'查看',key:'read_8new_3_1'},{title:'编辑',key:'edit_8new_3_1'}]}]}]},{title:'9.0 Account Management<br /> 客户管理',value:'/bp/9_3',key:'/bp/9_3',children:[{title:'查看',key:'read_9_3'},{title:'编辑',key:'edit_9_3'}]},// {
//     title: `10.0 Budget by Top Accounts 关键客户预算分析`,
//     value: '/bp/10',
//     key: '/bp/10',
//     children: [{
//         title: '查看',
//         key: 'read_10',
//     }, {
//         title: '编辑',
//         key: 'edit_10',
//     }]
// },
{title:'11.0 Marketing Communications <br/>公关营销',value:'/bp/11',key:'/bp/11',children:[{title:'11.1 Hotel Key Action Plan by Category \u9152\u5E97\u4E3B\u8981\u884C\u52A8\u8BA1\u5212\u5206\u7C7B',value:'/bp/14',key:'/bp/14',children:[{title:'查看',key:'read_14'},{title:'编辑',key:'edit_14'}]},{title:'11.2 Advertising & Business Promotion \u5E7F\u544A\u53CA\u4FC3\u9500\u63A8\u5E7F\u8BA1\u5212',value:'/bp/11_2',key:'/bp/11_2',children:[{title:'查看',key:'read_11_2'},{title:'编辑',key:'edit_11_2'}]},{title:'11.3 Media Planning \u5A92\u4F53\u8BA1\u5212',value:'/bp/11_3',key:'/bp/11_3',children:[{title:'查看',key:'read_11_3'},{title:'编辑',key:'edit_11_3'}]},{title:'11.4 Hotel Event Summary \u9152\u5E97\u6D3B\u52A8\u6982\u89C8',value:'/bp/11_4',key:'/bp/11_4',children:[{title:'查看',key:'read_11_4'},{title:'编辑',key:'edit_11_4'}]}]},{title:'12.0 F&B Budget<br/> 餐饮预算',value:'/bp/12_all',key:'/bp/12_all',children:[{title:'12.0 Food & Beverage Revenue Analysis \u9910\u996E\u6536\u76CA\u5206\u6790',value:'/bp/12',key:'/bp/12',children:[{title:'查看',key:'read_12'},{title:'编辑',key:'edit_12'}]},{title:'12.1 Food & Beverage Profit Analysis \u9910\u996E\u90E8\u76C8\u5229\u5206\u6790',value:'/bp/12_1',key:'/bp/12_1',children:[{title:'查看',key:'read_12_1'},{title:'编辑',key:'edit_12_1'}]},{title:'12.2 F&B by outlet by month',value:'/bp/table12_12_2',key:'/bp/table12_12_2',children:[{title:'查看',key:'read_table12_12_2'},{title:'编辑',key:'edit_table12_12_2'}]}]},{title:'13.0 Catering Analysis <br/>宴会预算',value:'/bp/12_2_all',key:'/bp/12_2_all',children:[{title:'13.0 Total Catering/Banquet \u5BB4\u4F1A',value:'/bp/12_2',key:'/bp/12_2',children:[{title:'查看',key:'read_12_2'},{title:'编辑',key:'edit_12_2'}]},{title:'13.1 Local Catering \u672C\u5730\u5BB4\u4F1A',value:'/bp/12_2_1',key:'/bp/12_2_1',children:[{title:'查看',key:'read_12_2_1'},{title:'编辑',key:'edit_12_2_1'}]},{title:'13.2 Group & Conventions \u56E2\u961F&\u4F1A\u8BAE\u56E2',value:'/bp/12_2_2',key:'/bp/12_2_2',children:[{title:'查看',key:'read_12_2_2'},{title:'编辑',key:'edit_12_2_2'}]},{title:'13.3 Catering and Events (C&E) Segmentation \u5BB4\u4F1A\u53CA\u6D3B\u52A8\u5E02\u573A\u7EC6\u5206\u5B9A\u4E49',value:'/bp/12_2_3',key:'/bp/12_2_3',children:[{title:'查看',key:'read_12_2_3'},{title:'编辑',key:'edit_12_2_3'}]},{title:'13.4 Yearly Catering and Events (C&E) Analysis\u5E74\u5EA6\u5BB4\u4F1A\u53CA\u6D3B\u52A8\u5206\u6790',value:'/bp/13_4',key:'/bp/13_4',children:[{title:'查看',key:'read_13_4'},{title:'编辑',key:'edit_13_4'}]}]},{title:'14.0 Manning Budget<br /> \u5458\u5DE5\u7F16\u5236\u9884\u7B97\u660E\u7EC6\u8868',value:'/bp/19',key:'/bp/19',children:[{title:'查看',key:'read_19'},{title:'编辑',key:'edit_19'}]},{title:'15.0 Manning Level Report<br /> \u4EBA\u5458\u6D41\u52A8\u62A5\u544A',value:'/bp/19_1',key:'/bp/19_1',children:[{title:'查看',key:'read_19_1'},{title:'编辑',key:'edit_19_1'}]},{title:'16.0 Labor Cost Management<br/> 人力成本管理',value:'/bp/20_all',key:'/bp/20_all',children:[{title:'16.1 Labor Cost by Levels and Departments \u6309\u7167\u7EA7\u522B\u548C\u90E8\u95E8\u5212\u5206\u7684\u4EBA\u5458\u6210\u672C',value:'/bp/20',key:'/bp/20',children:[{title:'查看',key:'read_20'},{title:'编辑',key:'edit_20'}]},{title:'16.2 Labor Cost Management Action Plans \u4EBA\u529B\u6210\u672C\u7BA1\u7406\u884C\u52A8\u8BA1\u5212',value:'/bp/20_1',key:'/bp/20_1',children:[{title:'查看',key:'read_20_1'},{title:'编辑',key:'edit_20_1'}]},{title:'16.3 Casual labor and HR Departmental Expenses \u4E34\u65F6\u5E2E\u5DE5\u548C\u5916\u5305\u53CA\u4EBA\u529B\u8D44\u6E90\u90E8\u8D39\u7528',value:'/bp/20_2',key:'/bp/20_2',children:[{title:'查看',key:'read_20_2'},{title:'编辑',key:'edit_20_2'}]}]},{title:'17.0 ENG Report<br/> 工程部门报告',value:'/bp/17_all',key:'/bp/17_all',children:[{title:'17.1 Rooms, F&B and Conference Feature Infomation \u5BA2\u623F\u3001\u9910\u996E\u53CA\u5BB4\u4F1A\u8BBE\u65BD\u60C5\u51B5',value:'/bp/17_1',key:'/bp/17_1',children:[{title:'查看',key:'read_17_1'},{title:'编辑',key:'edit_17_1'}]},{title:'17.2 Utility Cost Trend Report \u80FD\u6E90\u6210\u672C\u8868',value:'/bp/17_2',key:'/bp/17_2',children:[{title:'查看',key:'read_17_2'},{title:'编辑',key:'edit_17_2'}]},{title:'17.3 Utility Cost Trend Analysis \u80FD\u6E90\u6210\u672C\u8D8B\u52BF\u5206\u6790',value:'/bp/17_3',key:'/bp/17_3',children:[{title:'查看',key:'read_17_3'},{title:'编辑',key:'edit_17_3'}]},{title:'17.4 Maintenance Expenses \u7EF4\u4FEE\u8D39\u7528',value:'/bp/17_4',key:'/bp/17_4',children:[{title:'查看',key:'read_17_4'},{title:'编辑',key:'edit_17_4'}]}]},{title:'18.0 Profit and Loss Summary <br />\u5229\u6DA6\u8868\u6C47\u603B',value:'/bp/22',key:'/bp/22',children:[{title:'查看',key:'read_22'},{title:'编辑',key:'edit_22'}]},{title:'19.0 Breakeven Point Analysis<br /> \u76C8\u4E8F\u5E73\u8861\u70B9\u5206\u6790',value:'/bp/23',key:'/bp/23',children:[{title:'查看',key:'read_23'},{title:'编辑',key:'edit_23'}]},{title:'20.0 Flow Thru Analysis <br />\u8FB9\u9645\u5229\u6DA6\u5206\u6790',value:'/bp/24',key:'/bp/24',children:[{title:'查看',key:'read_24'},{title:'编辑',key:'edit_24'}]},{title:'21.0 Financial Model<br /> \u8D22\u52A1\u5206\u6790\u6A21\u578B',value:'/bp/26',key:'/bp/26',children:[{title:'查看',key:'read_26'},{title:'编辑',key:'edit_26'}]},{title:'22.0 CAPEX Plan<br/> 资本支出计划',value:'/bp/30_all',key:'/bp/30_all',children:[{title:'22.1 Capital Expenditure Plan - Summary  \u8D44\u672C\u652F\u51FA\u8BA1\u5212 - \u6C47\u603B\u8868',value:'/bp/30',key:'/bp/30',children:[{title:'查看',key:'read_30'},{title:'编辑',key:'edit_30'}]},{title:'22.2 Capital Expenditure Plan - Detail List \u8D44\u672C\u652F\u51FA\u8BA1\u5212 \uFF0D \u660E\u7EC6\u8868',value:'/bp/30_1',key:'/bp/30_1',children:[{title:'查看',key:'read_30_1'},{title:'编辑',key:'edit_30_1'}]}]},{title:'23.0 2020 Forecast Updates 2020\u5E74\u9884\u6D4B\u66F4\u65B0',value:'/bp/forecastupdate',key:'/bp/forecastupdate',children:[{title:'查看',key:'read_forecastupdate'},{title:'编辑',key:'edit_forecastupdate'}]},{title:'Business Plan \u5DF2\u6DFB\u52A0PDF\u5217\u8868',value:'/bp/pdf',key:'/bp/pdf',children:[{title:'查看',key:'read_pdf'},{title:'编辑',key:'edit_pdf'}]},{title:'Executive Summary Report 月度经营报告',value:'/table',key:'/table',children:[{title:'查看',key:'read_table'},{title:'编辑',key:'edit_table'}]},{title:'Human Resources 人力资源报告',value:'/hr',key:'/hr',children:[{title:'查看',key:'read_hr'},{title:'编辑',key:'edit_hr'}]}];exports.default=authData;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(742);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(143) && !__webpack_require__(187)(function () {
  return Object.defineProperty(__webpack_require__(450)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(186);
var document = __webpack_require__(141).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(154);
var toIObject = __webpack_require__(155);
var arrayIndexOf = __webpack_require__(759)(false);
var IE_PROTO = __webpack_require__(321)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(318);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(320);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(762);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Icon__["a"]; });


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(763), __esModule: true };

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(767)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(457)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(255);
var $export = __webpack_require__(140);
var redefine = __webpack_require__(458);
var hide = __webpack_require__(184);
var Iterators = __webpack_require__(218);
var $iterCreate = __webpack_require__(768);
var setToStringTag = __webpack_require__(327);
var getPrototypeOf = __webpack_require__(459);
var ITERATOR = __webpack_require__(114)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(184);


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(154);
var toObject = __webpack_require__(217);
var IE_PROTO = __webpack_require__(321)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(451);
var hiddenKeys = __webpack_require__(323).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = {
  // Options.jsx
  items_per_page: '/ page',
  jump_to: 'Go to',
  jump_to_confirm: 'confirm',
  page: '',

  // Pagination.jsx
  prev_page: 'Previous Page',
  next_page: 'Next Page',
  prev_5: 'Previous 5 Pages',
  next_5: 'Next 5 Pages',
  prev_3: 'Previous 3 Pages',
  next_3: 'Next 3 Pages'
};
module.exports = exports['default'];

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  today: 'Today',
  now: 'Now',
  backToToday: 'Back to today',
  ok: 'Ok',
  clear: 'Clear',
  month: 'Month',
  year: 'Year',
  timeSelect: 'select time',
  dateSelect: 'select date',
  weekSelect: 'Choose a week',
  monthSelect: 'Choose a month',
  yearSelect: 'Choose a year',
  decadeSelect: 'Choose a decade',
  yearFormat: 'YYYY',
  dateFormat: 'M/D/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Previous month (PageUp)',
  nextMonth: 'Next month (PageDown)',
  previousYear: 'Last year (Control + left)',
  nextYear: 'Next year (Control + right)',
  previousDecade: 'Last decade',
  nextDecade: 'Next decade',
  previousCentury: 'Last century',
  nextCentury: 'Next century'
};
module.exports = exports['default'];

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(336)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Notification__ = __webpack_require__(812);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Notification__["a" /* default */]);

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createChainedFunction;
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
  var args = [].slice.call(arguments, 0);

  if (args.length === 1) {
    return args[0];
  }

  return function chainedFunction() {
    for (var i = 0; i < args.length; i++) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.destroyFns = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcDialog = _interopRequireDefault(__webpack_require__(820));

var PropTypes = _interopRequireWildcard(__webpack_require__(19));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _addEventListener = _interopRequireDefault(__webpack_require__(260));

var _locale = __webpack_require__(333);

var _icon = _interopRequireDefault(__webpack_require__(38));

var _button = _interopRequireDefault(__webpack_require__(5));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(113));

var _configProvider = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var mousePosition;
var destroyFns = []; // ref: https://github.com/ant-design/ant-design/issues/15795

exports.destroyFns = destroyFns;

var getClickPosition = function getClickPosition(e) {
  mousePosition = {
    x: e.pageX,
    y: e.pageY
  }; // 100ms 内发生过点击事件，则从点击位置动画展示
  // 否则直接 zoom 展示
  // 这样可以兼容非点击方式展开

  setTimeout(function () {
    return mousePosition = null;
  }, 100);
}; // 只有点击事件支持从鼠标位置动画展开


if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
  (0, _addEventListener["default"])(document.documentElement, 'click', getClickPosition);
}

var Modal = /*#__PURE__*/function (_React$Component) {
  _inherits(Modal, _React$Component);

  var _super = _createSuper(Modal);

  function Modal() {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.apply(this, arguments);

    _this.handleCancel = function (e) {
      var onCancel = _this.props.onCancel;

      if (onCancel) {
        onCancel(e);
      }
    };

    _this.handleOk = function (e) {
      var onOk = _this.props.onOk;

      if (onOk) {
        onOk(e);
      }
    };

    _this.renderFooter = function (locale) {
      var _this$props = _this.props,
          okText = _this$props.okText,
          okType = _this$props.okType,
          cancelText = _this$props.cancelText,
          confirmLoading = _this$props.confirmLoading;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_button["default"], _extends({
        onClick: _this.handleCancel
      }, _this.props.cancelButtonProps), cancelText || locale.cancelText), /*#__PURE__*/React.createElement(_button["default"], _extends({
        type: okType,
        loading: confirmLoading,
        onClick: _this.handleOk
      }, _this.props.okButtonProps), okText || locale.okText));
    };

    _this.renderModal = function (_ref) {
      var getContextPopupContainer = _ref.getPopupContainer,
          getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          footer = _a.footer,
          visible = _a.visible,
          wrapClassName = _a.wrapClassName,
          centered = _a.centered,
          getContainer = _a.getContainer,
          closeIcon = _a.closeIcon,
          restProps = __rest(_a, ["prefixCls", "footer", "visible", "wrapClassName", "centered", "getContainer", "closeIcon"]);

      var prefixCls = getPrefixCls('modal', customizePrefixCls);
      var defaultFooter = /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
        componentName: "Modal",
        defaultLocale: (0, _locale.getConfirmLocale)()
      }, _this.renderFooter);
      var closeIconToRender = /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-close-x")
      }, closeIcon || /*#__PURE__*/React.createElement(_icon["default"], {
        className: "".concat(prefixCls, "-close-icon"),
        type: "close"
      }));
      return /*#__PURE__*/React.createElement(_rcDialog["default"], _extends({}, restProps, {
        getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
        prefixCls: prefixCls,
        wrapClassName: (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-centered"), !!centered), wrapClassName),
        footer: footer === undefined ? defaultFooter : footer,
        visible: visible,
        mousePosition: mousePosition,
        onClose: _this.handleCancel,
        closeIcon: closeIconToRender
      }));
    };

    return _this;
  }

  _createClass(Modal, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderModal);
    }
  }]);

  return Modal;
}(React.Component);

exports["default"] = Modal;
Modal.defaultProps = {
  width: 520,
  transitionName: 'zoom',
  maskTransitionName: 'fade',
  confirmLoading: false,
  visible: false,
  okType: 'primary'
};
Modal.propTypes = {
  prefixCls: PropTypes.string,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  okText: PropTypes.node,
  cancelText: PropTypes.node,
  centered: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  confirmLoading: PropTypes.bool,
  visible: PropTypes.bool,
  footer: PropTypes.node,
  title: PropTypes.node,
  closable: PropTypes.bool,
  closeIcon: PropTypes.node
};

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContainerRender; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





var ContainerRender = /*#__PURE__*/function (_React$Component) {
  _inherits(ContainerRender, _React$Component);

  var _super = _createSuper(ContainerRender);

  function ContainerRender() {
    var _this;

    _classCallCheck(this, ContainerRender);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.removeContainer = function () {
      if (_this.container) {
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(_this.container);

        _this.container.parentNode.removeChild(_this.container);

        _this.container = null;
      }
    };

    _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }

        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    };

    return _this;
  }

  _createClass(ContainerRender, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContainerRender.propTypes = {
  autoMount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  autoDestroy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  parent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  getComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Portal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





var Portal = /*#__PURE__*/function (_React$Component) {
  _inherits(Portal, _React$Component);

  var _super = _createSuper(Portal);

  function Portal() {
    _classCallCheck(this, Portal);

    return _super.apply(this, arguments);
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: "removeContainer",
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this._container) {
        return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(this.props.children, this._container);
      }

      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = {
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  didUpdate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Easy to set element style, return previous style
 * IE browser compatible(IE browser doesn't merge overflow style, need to set it separately)
 * https://github.com/ant-design/ant-design/issues/19393
 *
 */
function setStyle(style) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$element = options.element,
      element = _options$element === void 0 ? document.body : _options$element;
  var oldStyle = {};
  var styleKeys = Object.keys(style); // IE browser compatible

  styleKeys.forEach(function (key) {
    oldStyle[key] = element.style[key];
  });
  styleKeys.forEach(function (key) {
    element.style[key] = style[key];
  });
  return oldStyle;
}

/* harmony default export */ __webpack_exports__["a"] = (setStyle);

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = addEventListener;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventObject = __webpack_require__(826);

var _EventObject2 = _interopRequireDefault(_EventObject);

function addEventListener(target, eventType, callback, option) {
  function wrapCallback(e) {
    var ne = new _EventObject2['default'](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    var _ret = (function () {
      var useCapture = false;
      if (typeof option === 'object') {
        useCapture = option.capture || false;
      } else if (typeof option === 'boolean') {
        useCapture = option;
      }

      target.addEventListener(eventType, wrapCallback, option || false);

      return {
        v: {
          remove: function remove() {
            target.removeEventListener(eventType, wrapCallback, useCapture);
          }
        }
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}

module.exports = exports['default'];

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(189);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(475);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(341);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(846)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = prefix || defaultDelimiter
    var pattern = capture || group
    var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '')

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : restrictBacktrack(delimiter, prevText))
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

function restrictBacktrack(delimiter, prevText) {
  if (!prevText || prevText.indexOf(delimiter) > -1) {
    return '[^' + escapeString(delimiter) + ']+?'
  }

  return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?'
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasPrefixSuffix = hasPrefixSuffix;
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(36);

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _type = __webpack_require__(130);

var _Input = __webpack_require__(221);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ClearableInputType = (0, _type.tuple)('text', 'input');

function hasPrefixSuffix(props) {
  return !!(props.prefix || props.suffix || props.allowClear);
}

var ClearableLabeledInput = /*#__PURE__*/function (_React$Component) {
  _inherits(ClearableLabeledInput, _React$Component);

  var _super = _createSuper(ClearableLabeledInput);

  function ClearableLabeledInput() {
    _classCallCheck(this, ClearableLabeledInput);

    return _super.apply(this, arguments);
  }

  _createClass(ClearableLabeledInput, [{
    key: "renderClearIcon",
    value: function renderClearIcon(prefixCls) {
      var _this$props = this.props,
          allowClear = _this$props.allowClear,
          value = _this$props.value,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          inputType = _this$props.inputType,
          handleReset = _this$props.handleReset;

      if (!allowClear || disabled || readOnly || value === undefined || value === null || value === '') {
        return null;
      }

      var className = inputType === ClearableInputType[0] ? "".concat(prefixCls, "-textarea-clear-icon") : "".concat(prefixCls, "-clear-icon");
      return /*#__PURE__*/React.createElement(_icon["default"], {
        type: "close-circle",
        theme: "filled",
        onClick: handleReset,
        className: className,
        role: "button"
      });
    }
  }, {
    key: "renderSuffix",
    value: function renderSuffix(prefixCls) {
      var _this$props2 = this.props,
          suffix = _this$props2.suffix,
          allowClear = _this$props2.allowClear;

      if (suffix || allowClear) {
        return /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefixCls, "-suffix")
        }, this.renderClearIcon(prefixCls), suffix);
      }

      return null;
    }
  }, {
    key: "renderLabeledIcon",
    value: function renderLabeledIcon(prefixCls, element) {
      var _classNames;

      var props = this.props;
      var suffix = this.renderSuffix(prefixCls);

      if (!hasPrefixSuffix(props)) {
        return /*#__PURE__*/React.cloneElement(element, {
          value: props.value
        });
      }

      var prefix = props.prefix ? /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-prefix")
      }, props.prefix) : null;
      var affixWrapperCls = (0, _classnames["default"])(props.className, "".concat(prefixCls, "-affix-wrapper"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-sm"), props.size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-lg"), props.size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-input-with-clear-btn"), props.suffix && props.allowClear && this.props.value), _classNames));
      return /*#__PURE__*/React.createElement("span", {
        className: affixWrapperCls,
        style: props.style
      }, prefix, /*#__PURE__*/React.cloneElement(element, {
        style: null,
        value: props.value,
        className: (0, _Input.getInputClassName)(prefixCls, props.size, props.disabled)
      }), suffix);
    }
  }, {
    key: "renderInputWithLabel",
    value: function renderInputWithLabel(prefixCls, labeledElement) {
      var _classNames3;

      var _this$props3 = this.props,
          addonBefore = _this$props3.addonBefore,
          addonAfter = _this$props3.addonAfter,
          style = _this$props3.style,
          size = _this$props3.size,
          className = _this$props3.className; // Not wrap when there is not addons

      if (!addonBefore && !addonAfter) {
        return labeledElement;
      }

      var wrapperClassName = "".concat(prefixCls, "-group");
      var addonClassName = "".concat(wrapperClassName, "-addon");
      var addonBeforeNode = addonBefore ? /*#__PURE__*/React.createElement("span", {
        className: addonClassName
      }, addonBefore) : null;
      var addonAfterNode = addonAfter ? /*#__PURE__*/React.createElement("span", {
        className: addonClassName
      }, addonAfter) : null;
      var mergedWrapperClassName = (0, _classnames["default"])("".concat(prefixCls, "-wrapper"), _defineProperty({}, wrapperClassName, addonBefore || addonAfter));
      var mergedGroupClassName = (0, _classnames["default"])(className, "".concat(prefixCls, "-group-wrapper"), (_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-group-wrapper-sm"), size === 'small'), _defineProperty(_classNames3, "".concat(prefixCls, "-group-wrapper-lg"), size === 'large'), _classNames3)); // Need another wrapper for changing display:table to display:inline-block
      // and put style prop in wrapper

      return /*#__PURE__*/React.createElement("span", {
        className: mergedGroupClassName,
        style: style
      }, /*#__PURE__*/React.createElement("span", {
        className: mergedWrapperClassName
      }, addonBeforeNode, /*#__PURE__*/React.cloneElement(labeledElement, {
        style: null
      }), addonAfterNode));
    }
  }, {
    key: "renderTextAreaWithClearIcon",
    value: function renderTextAreaWithClearIcon(prefixCls, element) {
      var _this$props4 = this.props,
          value = _this$props4.value,
          allowClear = _this$props4.allowClear,
          className = _this$props4.className,
          style = _this$props4.style;

      if (!allowClear) {
        return /*#__PURE__*/React.cloneElement(element, {
          value: value
        });
      }

      var affixWrapperCls = (0, _classnames["default"])(className, "".concat(prefixCls, "-affix-wrapper"), "".concat(prefixCls, "-affix-wrapper-textarea-with-clear-btn"));
      return /*#__PURE__*/React.createElement("span", {
        className: affixWrapperCls,
        style: style
      }, /*#__PURE__*/React.cloneElement(element, {
        style: null,
        value: value
      }), this.renderClearIcon(prefixCls));
    }
  }, {
    key: "renderClearableLabeledInput",
    value: function renderClearableLabeledInput() {
      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          inputType = _this$props5.inputType,
          element = _this$props5.element;

      if (inputType === ClearableInputType[0]) {
        return this.renderTextAreaWithClearIcon(prefixCls, element);
      }

      return this.renderInputWithLabel(prefixCls, this.renderLabeledIcon(prefixCls, element));
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderClearableLabeledInput();
    }
  }]);

  return ClearableLabeledInput;
}(React.Component);

(0, _reactLifecyclesCompat.polyfill)(ClearableLabeledInput);
var _default = ClearableLabeledInput;
exports["default"] = _default;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findDOMNode;

var _reactDom = _interopRequireDefault(__webpack_require__(46));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Return if a node is a DOM node. Else will return by `findDOMNode`
 */
function findDOMNode(node) {
  if (node instanceof HTMLElement) {
    return node;
  }

  return _reactDom.default.findDOMNode(node);
}

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(867);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(80)))

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createReactContext = _interopRequireDefault(__webpack_require__(156));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var RowContext = (0, _createReactContext["default"])({});
var _default = RowContext;
exports["default"] = _default;

/***/ }),
/* 483 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeShape = undefined;

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storeShape = exports.storeShape = _propTypes2.default.shape({
  subscribe: _propTypes2.default.func.isRequired,
  setState: _propTypes2.default.func.isRequired,
  getState: _propTypes2.default.func.isRequired
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getActiveKey;
/* unused harmony export saveRef */
/* unused harmony export SubPopupMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mini_store__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_createChainedFunction__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shallowequal__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DOMWrap__ = __webpack_require__(896);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










function allDisabled(arr) {
  if (!arr.length) {
    return true;
  }

  return arr.every(function (c) {
    return !!c.props.disabled;
  });
}

function updateActiveKey(store, menuId, activeKey) {
  var state = store.getState();
  store.setState({
    activeKey: _objectSpread({}, state.activeKey, _defineProperty({}, menuId, activeKey))
  });
}

function getEventKey(props) {
  // when eventKey not available ,it's menu and return menu id '0-menu-'
  return props.eventKey || '0-menu-';
}

function getActiveKey(props, originalActiveKey) {
  var activeKey = originalActiveKey;
  var children = props.children,
      eventKey = props.eventKey;

  if (activeKey) {
    var found;
    Object(__WEBPACK_IMPORTED_MODULE_6__util__["e" /* loopMenuItem */])(children, function (c, i) {
      if (c && c.props && !c.props.disabled && activeKey === Object(__WEBPACK_IMPORTED_MODULE_6__util__["a" /* getKeyFromChildrenIndex */])(c, eventKey, i)) {
        found = true;
      }
    });

    if (found) {
      return activeKey;
    }
  }

  activeKey = null;

  if (props.defaultActiveFirst) {
    Object(__WEBPACK_IMPORTED_MODULE_6__util__["e" /* loopMenuItem */])(children, function (c, i) {
      if (!activeKey && c && !c.props.disabled) {
        activeKey = Object(__WEBPACK_IMPORTED_MODULE_6__util__["a" /* getKeyFromChildrenIndex */])(c, eventKey, i);
      }
    });
    return activeKey;
  }

  return activeKey;
}
function saveRef(c) {
  if (c) {
    var index = this.instanceArray.indexOf(c);

    if (index !== -1) {
      // update component if it's already inside instanceArray
      this.instanceArray[index] = c;
    } else {
      // add component if it's not in instanceArray yet;
      this.instanceArray.push(c);
    }
  }
}
var SubPopupMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SubPopupMenu, _React$Component);

  function SubPopupMenu(props) {
    var _this;

    _classCallCheck(this, SubPopupMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SubPopupMenu).call(this, props));
    /**
     * all keyboard events callbacks run from here at first
     *
     * note:
     *  This legacy code that `onKeyDown` is called by parent instead of dom self.
     *  which need return code to check if this event is handled
     */

    _this.onKeyDown = function (e, callback) {
      var keyCode = e.keyCode;
      var handled;

      _this.getFlatInstanceArray().forEach(function (obj) {
        if (obj && obj.props.active && obj.onKeyDown) {
          handled = obj.onKeyDown(e);
        }
      });

      if (handled) {
        return 1;
      }

      var activeItem = null;

      if (keyCode === __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].UP || keyCode === __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].DOWN) {
        activeItem = _this.step(keyCode === __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].UP ? -1 : 1);
      }

      if (activeItem) {
        e.preventDefault();
        updateActiveKey(_this.props.store, getEventKey(_this.props), activeItem.props.eventKey);

        if (typeof callback === 'function') {
          callback(activeItem);
        }

        return 1;
      }

      return undefined;
    };

    _this.onItemHover = function (e) {
      var key = e.key,
          hover = e.hover;
      updateActiveKey(_this.props.store, getEventKey(_this.props), hover ? key : null);
    };

    _this.onDeselect = function (selectInfo) {
      _this.props.onDeselect(selectInfo);
    };

    _this.onSelect = function (selectInfo) {
      _this.props.onSelect(selectInfo);
    };

    _this.onClick = function (e) {
      _this.props.onClick(e);
    };

    _this.onOpenChange = function (e) {
      _this.props.onOpenChange(e);
    };

    _this.onDestroy = function (key) {
      /* istanbul ignore next */
      _this.props.onDestroy(key);
    };

    _this.getFlatInstanceArray = function () {
      return _this.instanceArray;
    };

    _this.step = function (direction) {
      var children = _this.getFlatInstanceArray();

      var activeKey = _this.props.store.getState().activeKey[getEventKey(_this.props)];

      var len = children.length;

      if (!len) {
        return null;
      }

      if (direction < 0) {
        children = children.concat().reverse();
      } // find current activeIndex


      var activeIndex = -1;
      children.every(function (c, ci) {
        if (c && c.props.eventKey === activeKey) {
          activeIndex = ci;
          return false;
        }

        return true;
      });

      if (!_this.props.defaultActiveFirst && activeIndex !== -1 && allDisabled(children.slice(activeIndex, len - 1))) {
        return undefined;
      }

      var start = (activeIndex + 1) % len;
      var i = start;

      do {
        var child = children[i];

        if (!child || child.props.disabled) {
          i = (i + 1) % len;
        } else {
          return child;
        }
      } while (i !== start);

      return null;
    };

    _this.renderCommonMenuItem = function (child, i, extraProps) {
      var state = _this.props.store.getState();

      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      var key = Object(__WEBPACK_IMPORTED_MODULE_6__util__["a" /* getKeyFromChildrenIndex */])(child, props.eventKey, i);
      var childProps = child.props; // https://github.com/ant-design/ant-design/issues/11517#issuecomment-477403055

      if (!childProps || typeof child.type === 'string') {
        return child;
      }

      var isActive = key === state.activeKey;

      var newChildProps = _objectSpread({
        mode: childProps.mode || props.mode,
        level: props.level,
        inlineIndent: props.inlineIndent,
        renderMenuItem: _this.renderMenuItem,
        rootPrefixCls: props.prefixCls,
        index: i,
        parentMenu: props.parentMenu,
        // customized ref function, need to be invoked manually in child's componentDidMount
        manualRef: childProps.disabled ? undefined : Object(__WEBPACK_IMPORTED_MODULE_3_rc_util_es_createChainedFunction__["a" /* default */])(child.ref, saveRef.bind(_assertThisInitialized(_this))),
        eventKey: key,
        active: !childProps.disabled && isActive,
        multiple: props.multiple,
        onClick: function onClick(e) {
          (childProps.onClick || __WEBPACK_IMPORTED_MODULE_6__util__["h" /* noop */])(e);

          _this.onClick(e);
        },
        onItemHover: _this.onItemHover,
        motion: props.motion,
        subMenuOpenDelay: props.subMenuOpenDelay,
        subMenuCloseDelay: props.subMenuCloseDelay,
        forceSubMenuRender: props.forceSubMenuRender,
        onOpenChange: _this.onOpenChange,
        onDeselect: _this.onDeselect,
        onSelect: _this.onSelect,
        builtinPlacements: props.builtinPlacements,
        itemIcon: childProps.itemIcon || _this.props.itemIcon,
        expandIcon: childProps.expandIcon || _this.props.expandIcon
      }, extraProps); // ref: https://github.com/ant-design/ant-design/issues/13943


      if (props.mode === 'inline' || Object(__WEBPACK_IMPORTED_MODULE_6__util__["d" /* isMobileDevice */])()) {
        newChildProps.triggerSubMenuAction = 'click';
      }

      return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](child, newChildProps);
    };

    _this.renderMenuItem = function (c, i, subMenuKey) {
      /* istanbul ignore if */
      if (!c) {
        return null;
      }

      var state = _this.props.store.getState();

      var extraProps = {
        openKeys: state.openKeys,
        selectedKeys: state.selectedKeys,
        triggerSubMenuAction: _this.props.triggerSubMenuAction,
        subMenuKey: subMenuKey
      };
      return _this.renderCommonMenuItem(c, i, extraProps);
    };

    props.store.setState({
      activeKey: _objectSpread({}, props.store.getState().activeKey, _defineProperty({}, props.eventKey, getActiveKey(props, props.activeKey)))
    });
    _this.instanceArray = [];
    return _this;
  }

  _createClass(SubPopupMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // invoke customized ref to expose component to mixin
      if (this.props.manualRef) {
        this.props.manualRef(this);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.visible || nextProps.visible || this.props.className !== nextProps.className || !__WEBPACK_IMPORTED_MODULE_4_shallowequal___default()(this.props.style, nextProps.style);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var props = this.props;
      var originalActiveKey = 'activeKey' in props ? props.activeKey : props.store.getState().activeKey[getEventKey(props)];
      var activeKey = getActiveKey(props, originalActiveKey);

      if (activeKey !== originalActiveKey) {
        updateActiveKey(props.store, getEventKey(props), activeKey);
      } else if ('activeKey' in prevProps) {
        // If prev activeKey is not same as current activeKey,
        // we should set it.
        var prevActiveKey = getActiveKey(prevProps, prevProps.activeKey);

        if (activeKey !== prevActiveKey) {
          updateActiveKey(props.store, getEventKey(props), activeKey);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = _extends({}, this.props);

      this.instanceArray = [];
      var className = __WEBPACK_IMPORTED_MODULE_5_classnames___default()(props.prefixCls, props.className, "".concat(props.prefixCls, "-").concat(props.mode));
      var domProps = {
        className: className,
        // role could be 'select' and by default set to menu
        role: props.role || 'menu'
      };

      if (props.id) {
        domProps.id = props.id;
      }

      if (props.focusable) {
        domProps.tabIndex = 0;
        domProps.onKeyDown = this.onKeyDown;
      }

      var prefixCls = props.prefixCls,
          eventKey = props.eventKey,
          visible = props.visible,
          level = props.level,
          mode = props.mode,
          overflowedIndicator = props.overflowedIndicator,
          theme = props.theme;
      __WEBPACK_IMPORTED_MODULE_6__util__["g" /* menuAllProps */].forEach(function (key) {
        return delete props[key];
      }); // Otherwise, the propagated click event will trigger another onClick

      delete props.onClick;
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__DOMWrap__["a" /* default */], Object.assign({}, props, {
        prefixCls: prefixCls,
        mode: mode,
        tag: "ul",
        level: level,
        theme: theme,
        visible: visible,
        overflowedIndicator: overflowedIndicator
      }, domProps), __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(props.children, function (c, i) {
        return _this2.renderMenuItem(c, i, eventKey || '0-menu-');
      }));
    }
  }]);

  return SubPopupMenu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
SubPopupMenu.defaultProps = {
  prefixCls: 'rc-menu',
  className: '',
  mode: 'vertical',
  level: 1,
  inlineIndent: 24,
  visible: true,
  focusable: true,
  style: {},
  manualRef: __WEBPACK_IMPORTED_MODULE_6__util__["h" /* noop */]
};
var connected = Object(__WEBPACK_IMPORTED_MODULE_1_mini_store__["connect"])()(SubPopupMenu);
/* harmony default export */ __webpack_exports__["a"] = (connected);

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SubMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_trigger__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_KeyCode__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_animate_es_CSSMotion__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mini_store__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SubPopupMenu__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__placements__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(191);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




 // import Animate from 'rc-animate';







var guid = 0;
var popupPlacementMap = {
  horizontal: 'bottomLeft',
  vertical: 'rightTop',
  'vertical-left': 'rightTop',
  'vertical-right': 'leftTop'
};

var updateDefaultActiveFirst = function updateDefaultActiveFirst(store, eventKey, defaultActiveFirst) {
  var menuId = Object(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* getMenuIdFromSubMenuEventKey */])(eventKey);
  var state = store.getState();
  store.setState({
    defaultActiveFirst: _objectSpread({}, state.defaultActiveFirst, _defineProperty({}, menuId, defaultActiveFirst))
  });
};

var SubMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SubMenu, _React$Component);

  function SubMenu(props) {
    var _this;

    _classCallCheck(this, SubMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SubMenu).call(this, props));

    _this.onDestroy = function (key) {
      _this.props.onDestroy(key);
    };
    /**
     * note:
     *  This legacy code that `onKeyDown` is called by parent instead of dom self.
     *  which need return code to check if this event is handled
     */


    _this.onKeyDown = function (e) {
      var keyCode = e.keyCode;
      var menu = _this.menuInstance;
      var _this$props = _this.props,
          isOpen = _this$props.isOpen,
          store = _this$props.store;

      if (keyCode === __WEBPACK_IMPORTED_MODULE_3_rc_util_es_KeyCode__["a" /* default */].ENTER) {
        _this.onTitleClick(e);

        updateDefaultActiveFirst(store, _this.props.eventKey, true);
        return true;
      }

      if (keyCode === __WEBPACK_IMPORTED_MODULE_3_rc_util_es_KeyCode__["a" /* default */].RIGHT) {
        if (isOpen) {
          menu.onKeyDown(e);
        } else {
          _this.triggerOpenChange(true); // need to update current menu's defaultActiveFirst value


          updateDefaultActiveFirst(store, _this.props.eventKey, true);
        }

        return true;
      }

      if (keyCode === __WEBPACK_IMPORTED_MODULE_3_rc_util_es_KeyCode__["a" /* default */].LEFT) {
        var handled;

        if (isOpen) {
          handled = menu.onKeyDown(e);
        } else {
          return undefined;
        }

        if (!handled) {
          _this.triggerOpenChange(false);

          handled = true;
        }

        return handled;
      }

      if (isOpen && (keyCode === __WEBPACK_IMPORTED_MODULE_3_rc_util_es_KeyCode__["a" /* default */].UP || keyCode === __WEBPACK_IMPORTED_MODULE_3_rc_util_es_KeyCode__["a" /* default */].DOWN)) {
        return menu.onKeyDown(e);
      }

      return undefined;
    };

    _this.onOpenChange = function (e) {
      _this.props.onOpenChange(e);
    };

    _this.onPopupVisibleChange = function (visible) {
      _this.triggerOpenChange(visible, visible ? 'mouseenter' : 'mouseleave');
    };

    _this.onMouseEnter = function (e) {
      var _this$props2 = _this.props,
          key = _this$props2.eventKey,
          onMouseEnter = _this$props2.onMouseEnter,
          store = _this$props2.store;
      updateDefaultActiveFirst(store, _this.props.eventKey, false);
      onMouseEnter({
        key: key,
        domEvent: e
      });
    };

    _this.onMouseLeave = function (e) {
      var _this$props3 = _this.props,
          parentMenu = _this$props3.parentMenu,
          eventKey = _this$props3.eventKey,
          onMouseLeave = _this$props3.onMouseLeave;
      parentMenu.subMenuInstance = _assertThisInitialized(_this);
      onMouseLeave({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onTitleMouseEnter = function (domEvent) {
      var _this$props4 = _this.props,
          key = _this$props4.eventKey,
          onItemHover = _this$props4.onItemHover,
          onTitleMouseEnter = _this$props4.onTitleMouseEnter;
      onItemHover({
        key: key,
        hover: true
      });
      onTitleMouseEnter({
        key: key,
        domEvent: domEvent
      });
    };

    _this.onTitleMouseLeave = function (e) {
      var _this$props5 = _this.props,
          parentMenu = _this$props5.parentMenu,
          eventKey = _this$props5.eventKey,
          onItemHover = _this$props5.onItemHover,
          onTitleMouseLeave = _this$props5.onTitleMouseLeave;
      parentMenu.subMenuInstance = _assertThisInitialized(_this);
      onItemHover({
        key: eventKey,
        hover: false
      });
      onTitleMouseLeave({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onTitleClick = function (e) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      props.onTitleClick({
        key: props.eventKey,
        domEvent: e
      });

      if (props.triggerSubMenuAction === 'hover') {
        return;
      }

      _this.triggerOpenChange(!props.isOpen, 'click');

      updateDefaultActiveFirst(props.store, _this.props.eventKey, false);
    };

    _this.onSubMenuClick = function (info) {
      // in the case of overflowed submenu
      // onClick is not copied over
      if (typeof _this.props.onClick === 'function') {
        _this.props.onClick(_this.addKeyPath(info));
      }
    };

    _this.onSelect = function (info) {
      _this.props.onSelect(info);
    };

    _this.onDeselect = function (info) {
      _this.props.onDeselect(info);
    };

    _this.getPrefixCls = function () {
      return "".concat(_this.props.rootPrefixCls, "-submenu");
    };

    _this.getActiveClassName = function () {
      return "".concat(_this.getPrefixCls(), "-active");
    };

    _this.getDisabledClassName = function () {
      return "".concat(_this.getPrefixCls(), "-disabled");
    };

    _this.getSelectedClassName = function () {
      return "".concat(_this.getPrefixCls(), "-selected");
    };

    _this.getOpenClassName = function () {
      return "".concat(_this.props.rootPrefixCls, "-submenu-open");
    };

    _this.saveMenuInstance = function (c) {
      // children menu instance
      _this.menuInstance = c;
    };

    _this.addKeyPath = function (info) {
      return _objectSpread({}, info, {
        keyPath: (info.keyPath || []).concat(_this.props.eventKey)
      });
    };

    _this.triggerOpenChange = function (open, type) {
      var key = _this.props.eventKey;

      var openChange = function openChange() {
        _this.onOpenChange({
          key: key,
          item: _assertThisInitialized(_this),
          trigger: type,
          open: open
        });
      };

      if (type === 'mouseenter') {
        // make sure mouseenter happen after other menu item's mouseleave
        _this.mouseenterTimeout = setTimeout(function () {
          openChange();
        }, 0);
      } else {
        openChange();
      }
    };

    _this.isChildrenSelected = function () {
      var ret = {
        find: false
      };
      Object(__WEBPACK_IMPORTED_MODULE_9__util__["f" /* loopMenuItemRecursively */])(_this.props.children, _this.props.selectedKeys, ret);
      return ret.find;
    };

    _this.isOpen = function () {
      return _this.props.openKeys.indexOf(_this.props.eventKey) !== -1;
    };

    _this.adjustWidth = function () {
      /* istanbul ignore if */
      if (!_this.subMenuTitle || !_this.menuInstance) {
        return;
      }

      var popupMenu = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](_this.menuInstance);

      if (popupMenu.offsetWidth >= _this.subMenuTitle.offsetWidth) {
        return;
      }
      /* istanbul ignore next */


      popupMenu.style.minWidth = "".concat(_this.subMenuTitle.offsetWidth, "px");
    };

    _this.saveSubMenuTitle = function (subMenuTitle) {
      _this.subMenuTitle = subMenuTitle;
    };

    var store = props.store,
        eventKey = props.eventKey;

    var _store$getState = store.getState(),
        defaultActiveFirst = _store$getState.defaultActiveFirst;

    _this.isRootMenu = false;
    var value = false;

    if (defaultActiveFirst) {
      value = defaultActiveFirst[eventKey];
    }

    updateDefaultActiveFirst(store, eventKey, value);
    return _this;
  }

  _createClass(SubMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.componentDidUpdate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      var _this$props6 = this.props,
          mode = _this$props6.mode,
          parentMenu = _this$props6.parentMenu,
          manualRef = _this$props6.manualRef; // invoke customized ref to expose component to mixin

      if (manualRef) {
        manualRef(this);
      }

      if (mode !== 'horizontal' || !parentMenu.isRootMenu || !this.props.isOpen) {
        return;
      }

      this.minWidthTimeout = setTimeout(function () {
        return _this2.adjustWidth();
      }, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props7 = this.props,
          onDestroy = _this$props7.onDestroy,
          eventKey = _this$props7.eventKey;

      if (onDestroy) {
        onDestroy(eventKey);
      }
      /* istanbul ignore if */


      if (this.minWidthTimeout) {
        clearTimeout(this.minWidthTimeout);
      }
      /* istanbul ignore if */


      if (this.mouseenterTimeout) {
        clearTimeout(this.mouseenterTimeout);
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(children) {
      var _this3 = this;

      var props = this.props;
      var baseProps = {
        mode: props.mode === 'horizontal' ? 'vertical' : props.mode,
        visible: this.props.isOpen,
        level: props.level + 1,
        inlineIndent: props.inlineIndent,
        focusable: false,
        onClick: this.onSubMenuClick,
        onSelect: this.onSelect,
        onDeselect: this.onDeselect,
        onDestroy: this.onDestroy,
        selectedKeys: props.selectedKeys,
        eventKey: "".concat(props.eventKey, "-menu-"),
        openKeys: props.openKeys,
        motion: props.motion,
        onOpenChange: this.onOpenChange,
        subMenuOpenDelay: props.subMenuOpenDelay,
        parentMenu: this,
        subMenuCloseDelay: props.subMenuCloseDelay,
        forceSubMenuRender: props.forceSubMenuRender,
        triggerSubMenuAction: props.triggerSubMenuAction,
        builtinPlacements: props.builtinPlacements,
        defaultActiveFirst: props.store.getState().defaultActiveFirst[Object(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* getMenuIdFromSubMenuEventKey */])(props.eventKey)],
        multiple: props.multiple,
        prefixCls: props.rootPrefixCls,
        id: this.internalMenuId,
        manualRef: this.saveMenuInstance,
        itemIcon: props.itemIcon,
        expandIcon: props.expandIcon
      };
      var haveRendered = this.haveRendered;
      this.haveRendered = true;
      this.haveOpened = this.haveOpened || baseProps.visible || baseProps.forceSubMenuRender; // never rendered not planning to, don't render

      if (!this.haveOpened) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null);
      } // ================== Motion ==================
      // don't show transition on first rendering (no animation for opened menu)
      // show appear transition if it's not visible (not sure why)
      // show appear transition if it's not inline mode


      var mergedMotion = _objectSpread({}, props.motion, {
        leavedClassName: "".concat(props.rootPrefixCls, "-hidden"),
        removeOnLeave: false,
        motionAppear: haveRendered || !baseProps.visible || baseProps.mode !== 'inline'
      });

      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_rc_animate_es_CSSMotion__["a" /* default */], Object.assign({
        visible: baseProps.visible
      }, mergedMotion), function (_ref) {
        var className = _ref.className,
            style = _ref.style;
        var mergedClassName = __WEBPACK_IMPORTED_MODULE_5_classnames___default()("".concat(baseProps.prefixCls, "-sub"), className);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__SubPopupMenu__["a" /* default */], Object.assign({}, baseProps, {
          id: _this3.internalMenuId,
          className: mergedClassName,
          style: style
        }), children);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var props = _objectSpread({}, this.props);

      var isOpen = props.isOpen;
      var prefixCls = this.getPrefixCls();
      var isInlineMode = props.mode === 'inline';
      var className = __WEBPACK_IMPORTED_MODULE_5_classnames___default()(prefixCls, "".concat(prefixCls, "-").concat(props.mode), (_classNames = {}, _defineProperty(_classNames, props.className, !!props.className), _defineProperty(_classNames, this.getOpenClassName(), isOpen), _defineProperty(_classNames, this.getActiveClassName(), props.active || isOpen && !isInlineMode), _defineProperty(_classNames, this.getDisabledClassName(), props.disabled), _defineProperty(_classNames, this.getSelectedClassName(), this.isChildrenSelected()), _classNames));

      if (!this.internalMenuId) {
        if (props.eventKey) {
          this.internalMenuId = "".concat(props.eventKey, "$Menu");
        } else {
          guid += 1;
          this.internalMenuId = "$__$".concat(guid, "$Menu");
        }
      }

      var mouseEvents = {};
      var titleClickEvents = {};
      var titleMouseEvents = {};

      if (!props.disabled) {
        mouseEvents = {
          onMouseLeave: this.onMouseLeave,
          onMouseEnter: this.onMouseEnter
        }; // only works in title, not outer li

        titleClickEvents = {
          onClick: this.onTitleClick
        };
        titleMouseEvents = {
          onMouseEnter: this.onTitleMouseEnter,
          onMouseLeave: this.onTitleMouseLeave
        };
      }

      var style = {};

      if (isInlineMode) {
        style.paddingLeft = props.inlineIndent * props.level;
      }

      var ariaOwns = {}; // only set aria-owns when menu is open
      // otherwise it would be an invalid aria-owns value
      // since corresponding node cannot be found

      if (this.props.isOpen) {
        ariaOwns = {
          'aria-owns': this.internalMenuId
        };
      } // expand custom icon should NOT be displayed in menu with horizontal mode.


      var icon = null;

      if (props.mode !== 'horizontal') {
        icon = this.props.expandIcon; // ReactNode

        if (typeof this.props.expandIcon === 'function') {
          icon = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](this.props.expandIcon, _objectSpread({}, this.props));
        }
      }

      var title = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", Object.assign({
        ref: this.saveSubMenuTitle,
        style: style,
        className: "".concat(prefixCls, "-title")
      }, titleMouseEvents, titleClickEvents, {
        "aria-expanded": isOpen
      }, ariaOwns, {
        "aria-haspopup": "true",
        title: typeof props.title === 'string' ? props.title : undefined
      }), props.title, icon || __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", {
        className: "".concat(prefixCls, "-arrow")
      }));
      var children = this.renderChildren(props.children);
      var getPopupContainer = props.parentMenu.isRootMenu ? props.parentMenu.props.getPopupContainer : function (triggerNode) {
        return triggerNode.parentNode;
      };
      var popupPlacement = popupPlacementMap[props.mode];
      var popupAlign = props.popupOffset ? {
        offset: props.popupOffset
      } : {};
      var popupClassName = props.mode === 'inline' ? '' : props.popupClassName;
      var disabled = props.disabled,
          triggerSubMenuAction = props.triggerSubMenuAction,
          subMenuOpenDelay = props.subMenuOpenDelay,
          forceSubMenuRender = props.forceSubMenuRender,
          subMenuCloseDelay = props.subMenuCloseDelay,
          builtinPlacements = props.builtinPlacements;
      __WEBPACK_IMPORTED_MODULE_9__util__["g" /* menuAllProps */].forEach(function (key) {
        return delete props[key];
      }); // Set onClick to null, to ignore propagated onClick event

      delete props.onClick;
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", Object.assign({}, props, mouseEvents, {
        className: className,
        role: "menuitem"
      }), isInlineMode && title, isInlineMode && children, !isInlineMode && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_rc_trigger__["default"], {
        prefixCls: prefixCls,
        popupClassName: "".concat(prefixCls, "-popup ").concat(popupClassName),
        getPopupContainer: getPopupContainer,
        builtinPlacements: Object.assign({}, __WEBPACK_IMPORTED_MODULE_8__placements__["a" /* default */], builtinPlacements),
        popupPlacement: popupPlacement,
        popupVisible: isOpen,
        popupAlign: popupAlign,
        popup: children,
        action: disabled ? [] : [triggerSubMenuAction],
        mouseEnterDelay: subMenuOpenDelay,
        mouseLeaveDelay: subMenuCloseDelay,
        onPopupVisibleChange: this.onPopupVisibleChange,
        forceRender: forceSubMenuRender
      }, title));
    }
  }]);

  return SubMenu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
SubMenu.defaultProps = {
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_9__util__["h" /* noop */],
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_9__util__["h" /* noop */],
  onTitleMouseEnter: __WEBPACK_IMPORTED_MODULE_9__util__["h" /* noop */],
  onTitleMouseLeave: __WEBPACK_IMPORTED_MODULE_9__util__["h" /* noop */],
  onTitleClick: __WEBPACK_IMPORTED_MODULE_9__util__["h" /* noop */],
  manualRef: __WEBPACK_IMPORTED_MODULE_9__util__["h" /* noop */],
  mode: 'vertical',
  title: ''
};
var connected = Object(__WEBPACK_IMPORTED_MODULE_6_mini_store__["connect"])(function (_ref2, _ref3) {
  var openKeys = _ref2.openKeys,
      activeKey = _ref2.activeKey,
      selectedKeys = _ref2.selectedKeys;
  var eventKey = _ref3.eventKey,
      subMenuKey = _ref3.subMenuKey;
  return {
    isOpen: openKeys.indexOf(eventKey) > -1,
    active: activeKey[subMenuKey] === eventKey,
    selectedKeys: selectedKeys
  };
})(SubMenu);
connected.isSubMenu = true;
/* harmony default export */ __webpack_exports__["a"] = (connected);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);


function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback, option);
}

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlignPopupClassName;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

    if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(props.children) > 1) {
      if (!visible && hiddenClassName) {
        props.className += ' ' + hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', props);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(props.children);
  };

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MotionPropTypes */
/* unused harmony export genCSSMotion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_findDOMNode__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_raf__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_motion__ = __webpack_require__(904);






/* eslint-disable react/default-props-match-prop-types, react/no-multi-comp */








var STATUS_NONE = 'none';
var STATUS_APPEAR = 'appear';
var STATUS_ENTER = 'enter';
var STATUS_LEAVE = 'leave';

var MotionPropTypes = {
  eventProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object, // Internal usage. Only pass by CSSMotionList
  visible: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  motionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  motionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  motionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  motionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  motionLeaveImmediately: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, // Trigger leave motion immediately
  motionDeadline: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  removeOnLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  leavedClassName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  onAppearStart: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppearActive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppearEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnterStart: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnterActive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnterEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeaveStart: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeaveActive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeaveEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

/**
 * `transitionSupport` is used for none transition test case.
 * Default we use browser transition event support check.
 */
function genCSSMotion(config) {
  var transitionSupport = config;
  var forwardRef = !!__WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef;

  if (typeof config === 'object') {
    transitionSupport = config.transitionSupport;
    forwardRef = 'forwardRef' in config ? config.forwardRef : forwardRef;
  }

  function isSupportTransition(props) {
    return !!(props.motionName && transitionSupport);
  }

  var CSSMotion = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CSSMotion, _React$Component);

    function CSSMotion() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CSSMotion);

      var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CSSMotion.__proto__ || Object.getPrototypeOf(CSSMotion)).call(this));

      _this.onDomUpdate = function () {
        var _this$state = _this.state,
            status = _this$state.status,
            newStatus = _this$state.newStatus;
        var _this$props = _this.props,
            onAppearStart = _this$props.onAppearStart,
            onEnterStart = _this$props.onEnterStart,
            onLeaveStart = _this$props.onLeaveStart,
            onAppearActive = _this$props.onAppearActive,
            onEnterActive = _this$props.onEnterActive,
            onLeaveActive = _this$props.onLeaveActive,
            motionAppear = _this$props.motionAppear,
            motionEnter = _this$props.motionEnter,
            motionLeave = _this$props.motionLeave;


        if (!isSupportTransition(_this.props)) {
          return;
        }

        // Event injection
        var $ele = _this.getElement();
        if (_this.$cacheEle !== $ele) {
          _this.removeEventListener(_this.$cacheEle);
          _this.addEventListener($ele);
          _this.$cacheEle = $ele;
        }

        // Init status
        if (newStatus && status === STATUS_APPEAR && motionAppear) {
          _this.updateStatus(onAppearStart, null, null, function () {
            _this.updateActiveStatus(onAppearActive, STATUS_APPEAR);
          });
        } else if (newStatus && status === STATUS_ENTER && motionEnter) {
          _this.updateStatus(onEnterStart, null, null, function () {
            _this.updateActiveStatus(onEnterActive, STATUS_ENTER);
          });
        } else if (newStatus && status === STATUS_LEAVE && motionLeave) {
          _this.updateStatus(onLeaveStart, null, null, function () {
            _this.updateActiveStatus(onLeaveActive, STATUS_LEAVE);
          });
        }
      };

      _this.onMotionEnd = function (event) {
        var _this$state2 = _this.state,
            status = _this$state2.status,
            statusActive = _this$state2.statusActive;
        var _this$props2 = _this.props,
            onAppearEnd = _this$props2.onAppearEnd,
            onEnterEnd = _this$props2.onEnterEnd,
            onLeaveEnd = _this$props2.onLeaveEnd;

        if (status === STATUS_APPEAR && statusActive) {
          _this.updateStatus(onAppearEnd, { status: STATUS_NONE }, event);
        } else if (status === STATUS_ENTER && statusActive) {
          _this.updateStatus(onEnterEnd, { status: STATUS_NONE }, event);
        } else if (status === STATUS_LEAVE && statusActive) {
          _this.updateStatus(onLeaveEnd, { status: STATUS_NONE }, event);
        }
      };

      _this.setNodeRef = function (node) {
        var internalRef = _this.props.internalRef;

        _this.node = node;

        if (typeof internalRef === 'function') {
          internalRef(node);
        } else if (internalRef && 'current' in internalRef) {
          internalRef.current = node;
        }
      };

      _this.getElement = function () {
        try {
          return Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_findDOMNode__["a" /* default */])(_this.node || _this);
        } catch (e) {
          /**
           * Fallback to cache element.
           * This is only happen when `motionDeadline` trigger but element removed.
           */
          return _this.$cacheEle;
        }
      };

      _this.addEventListener = function ($ele) {
        if (!$ele) return;

        $ele.addEventListener(__WEBPACK_IMPORTED_MODULE_12__util_motion__["d" /* transitionEndName */], _this.onMotionEnd);
        $ele.addEventListener(__WEBPACK_IMPORTED_MODULE_12__util_motion__["a" /* animationEndName */], _this.onMotionEnd);
      };

      _this.removeEventListener = function ($ele) {
        if (!$ele) return;

        $ele.removeEventListener(__WEBPACK_IMPORTED_MODULE_12__util_motion__["d" /* transitionEndName */], _this.onMotionEnd);
        $ele.removeEventListener(__WEBPACK_IMPORTED_MODULE_12__util_motion__["a" /* animationEndName */], _this.onMotionEnd);
      };

      _this.updateStatus = function (styleFunc, additionalState, event, callback) {
        var statusStyle = styleFunc ? styleFunc(_this.getElement(), event) : null;

        if (statusStyle === false || _this._destroyed) return;

        var nextStep = void 0;
        if (callback) {
          nextStep = function nextStep() {
            _this.nextFrame(callback);
          };
        }

        _this.setState(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          statusStyle: typeof statusStyle === 'object' ? statusStyle : null,
          newStatus: false
        }, additionalState), nextStep); // Trigger before next frame & after `componentDidMount`
      };

      _this.updateActiveStatus = function (styleFunc, currentStatus) {
        // `setState` use `postMessage` to trigger at the end of frame.
        // Let's use requestAnimationFrame to update new state in next frame.
        _this.nextFrame(function () {
          var status = _this.state.status;

          if (status !== currentStatus) return;

          var motionDeadline = _this.props.motionDeadline;


          _this.updateStatus(styleFunc, { statusActive: true });

          if (motionDeadline > 0) {
            setTimeout(function () {
              _this.onMotionEnd({
                deadline: true
              });
            }, motionDeadline);
          }
        });
      };

      _this.nextFrame = function (func) {
        _this.cancelNextFrame();
        _this.raf = __WEBPACK_IMPORTED_MODULE_11_raf___default()(func);
      };

      _this.cancelNextFrame = function () {
        if (_this.raf) {
          __WEBPACK_IMPORTED_MODULE_11_raf___default.a.cancel(_this.raf);
          _this.raf = null;
        }
      };

      _this.state = {
        status: STATUS_NONE,
        statusActive: false,
        newStatus: false,
        statusStyle: null
      };
      _this.$cacheEle = null;
      _this.node = null;
      _this.raf = null;
      return _this;
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CSSMotion, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.onDomUpdate();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        this.onDomUpdate();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this._destroyed = true;
        this.removeEventListener(this.$cacheEle);
        this.cancelNextFrame();
      }
    }, {
      key: 'render',
      value: function render() {
        var _classNames;

        var _state = this.state,
            status = _state.status,
            statusActive = _state.statusActive,
            statusStyle = _state.statusStyle;
        var _props = this.props,
            children = _props.children,
            motionName = _props.motionName,
            visible = _props.visible,
            removeOnLeave = _props.removeOnLeave,
            leavedClassName = _props.leavedClassName,
            eventProps = _props.eventProps;


        if (!children) return null;

        if (status === STATUS_NONE || !isSupportTransition(this.props)) {
          if (visible) {
            return children(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, eventProps), this.setNodeRef);
          } else if (!removeOnLeave) {
            return children(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, eventProps, { className: leavedClassName }), this.setNodeRef);
          }

          return null;
        }

        return children(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, eventProps, {
          className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, Object(__WEBPACK_IMPORTED_MODULE_12__util_motion__["b" /* getTransitionName */])(motionName, status), status !== STATUS_NONE), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, Object(__WEBPACK_IMPORTED_MODULE_12__util_motion__["b" /* getTransitionName */])(motionName, status + '-active'), status !== STATUS_NONE && statusActive), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, motionName, typeof motionName === 'string'), _classNames)),
          style: statusStyle
        }), this.setNodeRef);
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(props, _ref) {
        var prevProps = _ref.prevProps,
            prevStatus = _ref.status;

        if (!isSupportTransition(props)) return {};

        var visible = props.visible,
            motionAppear = props.motionAppear,
            motionEnter = props.motionEnter,
            motionLeave = props.motionLeave,
            motionLeaveImmediately = props.motionLeaveImmediately;

        var newState = {
          prevProps: props
        };

        // Clean up status if prop set to false
        if (prevStatus === STATUS_APPEAR && !motionAppear || prevStatus === STATUS_ENTER && !motionEnter || prevStatus === STATUS_LEAVE && !motionLeave) {
          newState.status = STATUS_NONE;
          newState.statusActive = false;
          newState.newStatus = false;
        }

        // Appear
        if (!prevProps && visible && motionAppear) {
          newState.status = STATUS_APPEAR;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        // Enter
        if (prevProps && !prevProps.visible && visible && motionEnter) {
          newState.status = STATUS_ENTER;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        // Leave
        if (prevProps && prevProps.visible && !visible && motionLeave || !prevProps && motionLeaveImmediately && !visible && motionLeave) {
          newState.status = STATUS_LEAVE;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        return newState;
      }
    }]);

    return CSSMotion;
  }(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

  CSSMotion.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, MotionPropTypes, {

    internalRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func])
  });
  CSSMotion.defaultProps = {
    visible: true,
    motionEnter: true,
    motionAppear: true,
    motionLeave: true,
    removeOnLeave: true
  };


  Object(__WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__["polyfill"])(CSSMotion);

  if (!forwardRef) {
    return CSSMotion;
  }

  return __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CSSMotion, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ internalRef: ref }, props));
  });
}

/* harmony default export */ __webpack_exports__["a"] = (genCSSMotion(__WEBPACK_IMPORTED_MODULE_12__util_motion__["c" /* supportTransition */]));

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(910);

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SiderContext = void 0;

var _createReactContext = _interopRequireDefault(__webpack_require__(156));

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(36);

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _omit = _interopRequireDefault(__webpack_require__(71));

var _layout = __webpack_require__(922);

var _configProvider = __webpack_require__(39);

var _icon = _interopRequireDefault(__webpack_require__(38));

var _isNumeric = _interopRequireDefault(__webpack_require__(923));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

// matchMedia polyfill for
// https://github.com/WickyNilliams/enquire.js/issues/82
// TODO: Will be removed in antd 4.0 because we will no longer support ie9
if (typeof window !== 'undefined') {
  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
    return {
      media: mediaQuery,
      matches: false,
      addListener: function addListener() {},
      removeListener: function removeListener() {}
    };
  }; // ref: https://github.com/ant-design/ant-design/issues/18774


  if (!window.matchMedia) window.matchMedia = matchMediaPolyfill;
}

var dimensionMaxMap = {
  xs: '479.98px',
  sm: '575.98px',
  md: '767.98px',
  lg: '991.98px',
  xl: '1199.98px',
  xxl: '1599.98px'
};
var SiderContext = (0, _createReactContext["default"])({});
exports.SiderContext = SiderContext;

var generateId = function () {
  var i = 0;
  return function () {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    i += 1;
    return "".concat(prefix).concat(i);
  };
}();

var InternalSider = /*#__PURE__*/function (_React$Component) {
  _inherits(InternalSider, _React$Component);

  var _super = _createSuper(InternalSider);

  function InternalSider(props) {
    var _this;

    _classCallCheck(this, InternalSider);

    _this = _super.call(this, props);

    _this.responsiveHandler = function (mql) {
      _this.setState({
        below: mql.matches
      });

      var onBreakpoint = _this.props.onBreakpoint;

      if (onBreakpoint) {
        onBreakpoint(mql.matches);
      }

      if (_this.state.collapsed !== mql.matches) {
        _this.setCollapsed(mql.matches, 'responsive');
      }
    };

    _this.setCollapsed = function (collapsed, type) {
      if (!('collapsed' in _this.props)) {
        _this.setState({
          collapsed: collapsed
        });
      }

      var onCollapse = _this.props.onCollapse;

      if (onCollapse) {
        onCollapse(collapsed, type);
      }
    };

    _this.toggle = function () {
      var collapsed = !_this.state.collapsed;

      _this.setCollapsed(collapsed, 'clickTrigger');
    };

    _this.belowShowChange = function () {
      _this.setState(function (_ref) {
        var belowShow = _ref.belowShow;
        return {
          belowShow: !belowShow
        };
      });
    };

    _this.renderSider = function (_ref2) {
      var _classNames;

      var getPrefixCls = _ref2.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          className = _a.className,
          theme = _a.theme,
          collapsible = _a.collapsible,
          reverseArrow = _a.reverseArrow,
          trigger = _a.trigger,
          style = _a.style,
          width = _a.width,
          collapsedWidth = _a.collapsedWidth,
          zeroWidthTriggerStyle = _a.zeroWidthTriggerStyle,
          others = __rest(_a, ["prefixCls", "className", "theme", "collapsible", "reverseArrow", "trigger", "style", "width", "collapsedWidth", "zeroWidthTriggerStyle"]);

      var prefixCls = getPrefixCls('layout-sider', customizePrefixCls);
      var divProps = (0, _omit["default"])(others, ['collapsed', 'defaultCollapsed', 'onCollapse', 'breakpoint', 'onBreakpoint', 'siderHook', 'zeroWidthTriggerStyle']);
      var rawWidth = _this.state.collapsed ? collapsedWidth : width; // use "px" as fallback unit for width

      var siderWidth = (0, _isNumeric["default"])(rawWidth) ? "".concat(rawWidth, "px") : String(rawWidth); // special trigger when collapsedWidth == 0

      var zeroWidthTrigger = parseFloat(String(collapsedWidth || 0)) === 0 ? /*#__PURE__*/React.createElement("span", {
        onClick: _this.toggle,
        className: "".concat(prefixCls, "-zero-width-trigger ").concat(prefixCls, "-zero-width-trigger-").concat(reverseArrow ? 'right' : 'left'),
        style: zeroWidthTriggerStyle
      }, /*#__PURE__*/React.createElement(_icon["default"], {
        type: "bars"
      })) : null;
      var iconObj = {
        expanded: reverseArrow ? /*#__PURE__*/React.createElement(_icon["default"], {
          type: "right"
        }) : /*#__PURE__*/React.createElement(_icon["default"], {
          type: "left"
        }),
        collapsed: reverseArrow ? /*#__PURE__*/React.createElement(_icon["default"], {
          type: "left"
        }) : /*#__PURE__*/React.createElement(_icon["default"], {
          type: "right"
        })
      };
      var status = _this.state.collapsed ? 'collapsed' : 'expanded';
      var defaultTrigger = iconObj[status];
      var triggerDom = trigger !== null ? zeroWidthTrigger || /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-trigger"),
        onClick: _this.toggle,
        style: {
          width: siderWidth
        }
      }, trigger || defaultTrigger) : null;

      var divStyle = _extends(_extends({}, style), {
        flex: "0 0 ".concat(siderWidth),
        maxWidth: siderWidth,
        minWidth: siderWidth,
        width: siderWidth
      });

      var siderCls = (0, _classnames["default"])(className, prefixCls, "".concat(prefixCls, "-").concat(theme), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-collapsed"), !!_this.state.collapsed), _defineProperty(_classNames, "".concat(prefixCls, "-has-trigger"), collapsible && trigger !== null && !zeroWidthTrigger), _defineProperty(_classNames, "".concat(prefixCls, "-below"), !!_this.state.below), _defineProperty(_classNames, "".concat(prefixCls, "-zero-width"), parseFloat(siderWidth) === 0), _classNames));
      return /*#__PURE__*/React.createElement("aside", _extends({
        className: siderCls
      }, divProps, {
        style: divStyle
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-children")
      }, _this.props.children), collapsible || _this.state.below && zeroWidthTrigger ? triggerDom : null);
    };

    _this.uniqueId = generateId('ant-sider-');
    var matchMedia;

    if (typeof window !== 'undefined') {
      matchMedia = window.matchMedia;
    }

    if (matchMedia && props.breakpoint && props.breakpoint in dimensionMaxMap) {
      _this.mql = matchMedia("(max-width: ".concat(dimensionMaxMap[props.breakpoint], ")"));
    }

    var collapsed;

    if ('collapsed' in props) {
      collapsed = props.collapsed;
    } else {
      collapsed = props.defaultCollapsed;
    }

    _this.state = {
      collapsed: collapsed,
      below: false
    };
    return _this;
  }

  _createClass(InternalSider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.mql) {
        this.mql.addListener(this.responsiveHandler);
        this.responsiveHandler(this.mql);
      }

      if (this.props.siderHook) {
        this.props.siderHook.addSider(this.uniqueId);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.mql) {
        this.mql.removeListener(this.responsiveHandler);
      }

      if (this.props.siderHook) {
        this.props.siderHook.removeSider(this.uniqueId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var collapsed = this.state.collapsed;
      var collapsedWidth = this.props.collapsedWidth;
      return /*#__PURE__*/React.createElement(SiderContext.Provider, {
        value: {
          siderCollapsed: collapsed,
          collapsedWidth: collapsedWidth
        }
      }, /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSider));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('collapsed' in nextProps) {
        return {
          collapsed: nextProps.collapsed
        };
      }

      return null;
    }
  }]);

  return InternalSider;
}(React.Component);

InternalSider.defaultProps = {
  collapsible: false,
  defaultCollapsed: false,
  reverseArrow: false,
  width: 200,
  collapsedWidth: 80,
  style: {},
  theme: 'dark'
};
(0, _reactLifecyclesCompat.polyfill)(InternalSider); // eslint-disable-next-line react/prefer-stateless-function

var Sider = /*#__PURE__*/function (_React$Component2) {
  _inherits(Sider, _React$Component2);

  var _super2 = _createSuper(Sider);

  function Sider() {
    _classCallCheck(this, Sider);

    return _super2.apply(this, arguments);
  }

  _createClass(Sider, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(_layout.LayoutContext.Consumer, null, function (context) {
        return /*#__PURE__*/React.createElement(InternalSider, _extends({}, context, _this2.props));
      });
    }
  }]);

  return Sider;
}(React.Component);

exports["default"] = Sider;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// ================== Collapse Motion ==================
var getCollapsedHeight = function getCollapsedHeight() {
  return {
    height: 0,
    opacity: 0
  };
};

var getRealHeight = function getRealHeight(node) {
  return {
    height: node.scrollHeight,
    opacity: 1
  };
};

var getCurrentHeight = function getCurrentHeight(node) {
  return {
    height: node.offsetHeight
  };
};

var collapseMotion = {
  motionName: 'ant-motion-collapse',
  onAppearStart: getCollapsedHeight,
  onEnterStart: getCollapsedHeight,
  onAppearActive: getRealHeight,
  onEnterActive: getRealHeight,
  onLeaveStart: getCurrentHeight,
  onLeaveActive: getCollapsedHeight
};
var _default = collapseMotion;
exports["default"] = _default;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getDataOrAriaProps;

function getDataOrAriaProps(props) {
  return Object.keys(props).reduce(function (prev, key) {
    if ((key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') && key.substr(0, 7) !== 'data-__') {
      prev[key] = props[key];
    }

    return prev;
  }, {});
}

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Calendar__ = __webpack_require__(927);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Calendar__["a" /* default */]);

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  DATE_ROW_COUNT: 6,
  DATE_COL_COUNT: 7
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapSelf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function mirror(o) {
  return o;
}

function mapSelf(children) {
  // return ReactFragment
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, mirror);
}

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(48);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(31);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(32);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _KeyCode = __webpack_require__(194);

var _KeyCode2 = _interopRequireDefault(_KeyCode);

var _reactLifecyclesCompat = __webpack_require__(36);

var _CalendarHeader = __webpack_require__(499);

var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);

var _CalendarFooter = __webpack_require__(948);

var _CalendarFooter2 = _interopRequireDefault(_CalendarFooter);

var _CalendarMixin = __webpack_require__(733);

var _CommonMixin = __webpack_require__(445);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var MonthCalendar = function (_React$Component) {
  (0, _inherits3['default'])(MonthCalendar, _React$Component);

  function MonthCalendar(props) {
    (0, _classCallCheck3['default'])(this, MonthCalendar);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _this.onKeyDown = function (event) {
      var keyCode = event.keyCode;
      var ctrlKey = event.ctrlKey || event.metaKey;
      var stateValue = _this.state.value;
      var disabledDate = _this.props.disabledDate;

      var value = stateValue;
      switch (keyCode) {
        case _KeyCode2['default'].DOWN:
          value = stateValue.clone();
          value.add(3, 'months');
          break;
        case _KeyCode2['default'].UP:
          value = stateValue.clone();
          value.add(-3, 'months');
          break;
        case _KeyCode2['default'].LEFT:
          value = stateValue.clone();
          if (ctrlKey) {
            value.add(-1, 'years');
          } else {
            value.add(-1, 'months');
          }
          break;
        case _KeyCode2['default'].RIGHT:
          value = stateValue.clone();
          if (ctrlKey) {
            value.add(1, 'years');
          } else {
            value.add(1, 'months');
          }
          break;
        case _KeyCode2['default'].ENTER:
          if (!disabledDate || !disabledDate(stateValue)) {
            _this.onSelect(stateValue);
          }
          event.preventDefault();
          return 1;
        default:
          return undefined;
      }
      if (value !== stateValue) {
        _this.setValue(value);
        event.preventDefault();
        return 1;
      }
    };

    _this.handlePanelChange = function (_, mode) {
      if (mode !== 'date') {
        _this.setState({ mode: mode });
      }
    };

    _this.state = {
      mode: 'month',
      value: props.value || props.defaultValue || (0, _moment2['default'])(),
      selectedValue: props.selectedValue || props.defaultSelectedValue
    };
    return _this;
  }

  MonthCalendar.prototype.render = function render() {
    var props = this.props,
        state = this.state;
    var mode = state.mode,
        value = state.value;

    var children = _react2['default'].createElement(
      'div',
      { className: props.prefixCls + '-month-calendar-content' },
      _react2['default'].createElement(
        'div',
        { className: props.prefixCls + '-month-header-wrap' },
        _react2['default'].createElement(_CalendarHeader2['default'], {
          prefixCls: props.prefixCls,
          mode: mode,
          value: value,
          locale: props.locale,
          disabledMonth: props.disabledDate,
          monthCellRender: props.monthCellRender,
          monthCellContentRender: props.monthCellContentRender,
          onMonthSelect: this.onSelect,
          onValueChange: this.setValue,
          onPanelChange: this.handlePanelChange
        })
      ),
      _react2['default'].createElement(_CalendarFooter2['default'], {
        prefixCls: props.prefixCls,
        renderFooter: props.renderFooter
      })
    );
    return this.renderRoot({
      className: props.prefixCls + '-month-calendar',
      children: children
    });
  };

  return MonthCalendar;
}(_react2['default'].Component);

MonthCalendar.propTypes = (0, _extends3['default'])({}, _CalendarMixin.calendarMixinPropTypes, _CommonMixin.propType, {
  monthCellRender: _propTypes2['default'].func,
  value: _propTypes2['default'].object,
  defaultValue: _propTypes2['default'].object,
  selectedValue: _propTypes2['default'].object,
  defaultSelectedValue: _propTypes2['default'].object,
  disabledDate: _propTypes2['default'].func
});
MonthCalendar.defaultProps = (0, _extends3['default'])({}, _CommonMixin.defaultProp, _CalendarMixin.calendarMixinDefaultProps);
exports['default'] = (0, _reactLifecyclesCompat.polyfill)((0, _CalendarMixin.calendarMixinWrapper)((0, _CommonMixin.commonMixinWrapper)(MonthCalendar)));
module.exports = exports['default'];

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(31);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(32);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mapSelf = __webpack_require__(500);

var _mapSelf2 = _interopRequireDefault(_mapSelf);

var _MonthPanel = __webpack_require__(945);

var _MonthPanel2 = _interopRequireDefault(_MonthPanel);

var _YearPanel = __webpack_require__(946);

var _YearPanel2 = _interopRequireDefault(_YearPanel);

var _DecadePanel = __webpack_require__(947);

var _DecadePanel2 = _interopRequireDefault(_DecadePanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function goMonth(direction) {
  var next = this.props.value.clone();
  next.add(direction, 'months');
  this.props.onValueChange(next);
}

function goYear(direction) {
  var next = this.props.value.clone();
  next.add(direction, 'years');
  this.props.onValueChange(next);
}

function showIf(condition, el) {
  return condition ? el : null;
}

var CalendarHeader = function (_React$Component) {
  (0, _inherits3['default'])(CalendarHeader, _React$Component);

  function CalendarHeader(props) {
    (0, _classCallCheck3['default'])(this, CalendarHeader);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    _this.nextMonth = goMonth.bind(_this, 1);
    _this.previousMonth = goMonth.bind(_this, -1);
    _this.nextYear = goYear.bind(_this, 1);
    _this.previousYear = goYear.bind(_this, -1);

    _this.state = { yearPanelReferer: null };
    return _this;
  }

  CalendarHeader.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var prefixCls = props.prefixCls,
        locale = props.locale,
        mode = props.mode,
        value = props.value,
        showTimePicker = props.showTimePicker,
        enableNext = props.enableNext,
        enablePrev = props.enablePrev,
        disabledMonth = props.disabledMonth,
        renderFooter = props.renderFooter;


    var panel = null;
    if (mode === 'month') {
      panel = _react2['default'].createElement(_MonthPanel2['default'], {
        locale: locale,
        value: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onMonthSelect,
        onYearPanelShow: function onYearPanelShow() {
          return _this2.showYearPanel('month');
        },
        disabledDate: disabledMonth,
        cellRender: props.monthCellRender,
        contentRender: props.monthCellContentRender,
        renderFooter: renderFooter,
        changeYear: this.changeYear
      });
    }
    if (mode === 'year') {
      panel = _react2['default'].createElement(_YearPanel2['default'], {
        locale: locale,
        defaultValue: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onYearSelect,
        onDecadePanelShow: this.showDecadePanel,
        renderFooter: renderFooter
      });
    }
    if (mode === 'decade') {
      panel = _react2['default'].createElement(_DecadePanel2['default'], {
        locale: locale,
        defaultValue: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onDecadeSelect,
        renderFooter: renderFooter
      });
    }

    return _react2['default'].createElement(
      'div',
      { className: prefixCls + '-header' },
      _react2['default'].createElement(
        'div',
        { style: { position: 'relative' } },
        showIf(enablePrev && !showTimePicker, _react2['default'].createElement('a', {
          className: prefixCls + '-prev-year-btn',
          role: 'button',
          onClick: this.previousYear,
          title: locale.previousYear
        })),
        showIf(enablePrev && !showTimePicker, _react2['default'].createElement('a', {
          className: prefixCls + '-prev-month-btn',
          role: 'button',
          onClick: this.previousMonth,
          title: locale.previousMonth
        })),
        this.monthYearElement(showTimePicker),
        showIf(enableNext && !showTimePicker, _react2['default'].createElement('a', {
          className: prefixCls + '-next-month-btn',
          onClick: this.nextMonth,
          title: locale.nextMonth
        })),
        showIf(enableNext && !showTimePicker, _react2['default'].createElement('a', {
          className: prefixCls + '-next-year-btn',
          onClick: this.nextYear,
          title: locale.nextYear
        }))
      ),
      panel
    );
  };

  return CalendarHeader;
}(_react2['default'].Component);

CalendarHeader.propTypes = {
  prefixCls: _propTypes2['default'].string,
  value: _propTypes2['default'].object,
  onValueChange: _propTypes2['default'].func,
  showTimePicker: _propTypes2['default'].bool,
  onPanelChange: _propTypes2['default'].func,
  locale: _propTypes2['default'].object,
  enablePrev: _propTypes2['default'].any,
  enableNext: _propTypes2['default'].any,
  disabledMonth: _propTypes2['default'].func,
  renderFooter: _propTypes2['default'].func,
  onMonthSelect: _propTypes2['default'].func
};
CalendarHeader.defaultProps = {
  enableNext: 1,
  enablePrev: 1,
  onPanelChange: function onPanelChange() {},
  onValueChange: function onValueChange() {}
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onMonthSelect = function (value) {
    _this3.props.onPanelChange(value, 'date');
    if (_this3.props.onMonthSelect) {
      _this3.props.onMonthSelect(value);
    } else {
      _this3.props.onValueChange(value);
    }
  };

  this.onYearSelect = function (value) {
    var referer = _this3.state.yearPanelReferer;
    _this3.setState({ yearPanelReferer: null });
    _this3.props.onPanelChange(value, referer);
    _this3.props.onValueChange(value);
  };

  this.onDecadeSelect = function (value) {
    _this3.props.onPanelChange(value, 'year');
    _this3.props.onValueChange(value);
  };

  this.changeYear = function (direction) {
    if (direction > 0) {
      _this3.nextYear();
    } else {
      _this3.previousYear();
    }
  };

  this.monthYearElement = function (showTimePicker) {
    var props = _this3.props;
    var prefixCls = props.prefixCls;
    var locale = props.locale;
    var value = props.value;
    var localeData = value.localeData();
    var monthBeforeYear = locale.monthBeforeYear;
    var selectClassName = prefixCls + '-' + (monthBeforeYear ? 'my-select' : 'ym-select');
    var timeClassName = showTimePicker ? ' ' + prefixCls + '-time-status' : '';
    var year = _react2['default'].createElement(
      'a',
      {
        className: prefixCls + '-year-select' + timeClassName,
        role: 'button',
        onClick: showTimePicker ? null : function () {
          return _this3.showYearPanel('date');
        },
        title: showTimePicker ? null : locale.yearSelect
      },
      value.format(locale.yearFormat)
    );
    var month = _react2['default'].createElement(
      'a',
      {
        className: prefixCls + '-month-select' + timeClassName,
        role: 'button',
        onClick: showTimePicker ? null : _this3.showMonthPanel,
        title: showTimePicker ? null : locale.monthSelect
      },
      locale.monthFormat ? value.format(locale.monthFormat) : localeData.monthsShort(value)
    );
    var day = void 0;
    if (showTimePicker) {
      day = _react2['default'].createElement(
        'a',
        {
          className: prefixCls + '-day-select' + timeClassName,
          role: 'button'
        },
        value.format(locale.dayFormat)
      );
    }
    var my = [];
    if (monthBeforeYear) {
      my = [month, day, year];
    } else {
      my = [year, month, day];
    }
    return _react2['default'].createElement(
      'span',
      { className: selectClassName },
      (0, _mapSelf2['default'])(my)
    );
  };

  this.showMonthPanel = function () {
    // null means that users' interaction doesn't change value
    _this3.props.onPanelChange(null, 'month');
  };

  this.showYearPanel = function (referer) {
    _this3.setState({ yearPanelReferer: referer });
    _this3.props.onPanelChange(null, 'year');
  };

  this.showDecadePanel = function () {
    _this3.props.onPanelChange(null, 'decade');
  };
};

exports['default'] = CalendarHeader;
module.exports = exports['default'];

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mapSelf;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mirror(o) {
  return o;
}

function mapSelf(children) {
  // return ReactFragment
  return _react.default.Children.map(children, mirror);
}

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = TodayButton;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _util = __webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function TodayButton(_ref) {
  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      value = _ref.value,
      timePicker = _ref.timePicker,
      disabled = _ref.disabled,
      disabledDate = _ref.disabledDate,
      onToday = _ref.onToday,
      text = _ref.text;

  var localeNow = (!text && timePicker ? locale.now : text) || locale.today;
  var disabledToday = disabledDate && !(0, _util.isAllowedDate)((0, _util.getTodayTime)(value), disabledDate);
  var isDisabled = disabledToday || disabled;
  var disabledTodayClass = isDisabled ? prefixCls + '-today-btn-disabled' : '';
  return _react2['default'].createElement(
    'a',
    {
      className: prefixCls + '-today-btn ' + disabledTodayClass,
      role: 'button',
      onClick: isDisabled ? null : onToday,
      title: (0, _util.getTodayTimeStr)(value)
    },
    localeNow
  );
}
module.exports = exports['default'];

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = OkButton;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function OkButton(_ref) {
  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      okDisabled = _ref.okDisabled,
      onOk = _ref.onOk;

  var className = prefixCls + "-ok-btn";
  if (okDisabled) {
    className += " " + prefixCls + "-ok-btn-disabled";
  }
  return _react2["default"].createElement(
    "a",
    {
      className: className,
      role: "button",
      onClick: okDisabled ? null : onOk
    },
    locale.ok
  );
}
module.exports = exports['default'];

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = TimePickerButton;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(22);

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function TimePickerButton(_ref) {
  var _classnames;

  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      showTimePicker = _ref.showTimePicker,
      onOpenTimePicker = _ref.onOpenTimePicker,
      onCloseTimePicker = _ref.onCloseTimePicker,
      timePickerDisabled = _ref.timePickerDisabled;

  var className = (0, _classnames3['default'])((_classnames = {}, _classnames[prefixCls + '-time-picker-btn'] = true, _classnames[prefixCls + '-time-picker-btn-disabled'] = timePickerDisabled, _classnames));
  var onClick = null;
  if (!timePickerDisabled) {
    onClick = showTimePicker ? onCloseTimePicker : onOpenTimePicker;
  }
  return _react2['default'].createElement(
    'a',
    {
      className: className,
      role: 'button',
      onClick: onClick
    },
    showTimePicker ? locale.dateSelect : locale.timeSelect
  );
}
module.exports = exports['default'];

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDate = formatDate;

// eslint-disable-next-line import/prefer-default-export
function formatDate(value, format) {
  if (!value) {
    return '';
  }

  if (Array.isArray(format)) {
    format = format[0];
  }

  return value.format(format);
}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(19));

var _moment = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _reactLifecyclesCompat = __webpack_require__(36);

var _Header = _interopRequireDefault(__webpack_require__(953));

var _Combobox = _interopRequireDefault(__webpack_require__(954));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function noop() {}

function generateOptions(length, disabledOptions, hideDisabledOptions) {
  var step = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var arr = [];

  for (var value = 0; value < length; value += step) {
    if (!disabledOptions || disabledOptions.indexOf(value) < 0 || !hideDisabledOptions) {
      arr.push(value);
    }
  }

  return arr;
}

function toNearestValidTime(time, hourOptions, minuteOptions, secondOptions) {
  var hour = hourOptions.slice().sort(function (a, b) {
    return Math.abs(time.hour() - a) - Math.abs(time.hour() - b);
  })[0];
  var minute = minuteOptions.slice().sort(function (a, b) {
    return Math.abs(time.minute() - a) - Math.abs(time.minute() - b);
  })[0];
  var second = secondOptions.slice().sort(function (a, b) {
    return Math.abs(time.second() - a) - Math.abs(time.second() - b);
  })[0];
  return (0, _moment["default"])("".concat(hour, ":").concat(minute, ":").concat(second), 'HH:mm:ss');
}

var Panel =
/*#__PURE__*/
function (_Component) {
  _inherits(Panel, _Component);

  function Panel() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Panel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Panel)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "onChange", function (newValue) {
      var onChange = _this.props.onChange;

      _this.setState({
        value: newValue
      });

      onChange(newValue);
    });

    _defineProperty(_assertThisInitialized(_this), "onAmPmChange", function (ampm) {
      var onAmPmChange = _this.props.onAmPmChange;
      onAmPmChange(ampm);
    });

    _defineProperty(_assertThisInitialized(_this), "onCurrentSelectPanelChange", function (currentSelectPanel) {
      _this.setState({
        currentSelectPanel: currentSelectPanel
      });
    });

    _defineProperty(_assertThisInitialized(_this), "disabledHours", function () {
      var _this$props = _this.props,
          use12Hours = _this$props.use12Hours,
          disabledHours = _this$props.disabledHours;
      var disabledOptions = disabledHours();

      if (use12Hours && Array.isArray(disabledOptions)) {
        if (_this.isAM()) {
          disabledOptions = disabledOptions.filter(function (h) {
            return h < 12;
          }).map(function (h) {
            return h === 0 ? 12 : h;
          });
        } else {
          disabledOptions = disabledOptions.map(function (h) {
            return h === 12 ? 12 : h - 12;
          });
        }
      }

      return disabledOptions;
    });

    return _this;
  }

  _createClass(Panel, [{
    key: "close",
    // https://github.com/ant-design/ant-design/issues/5829
    value: function close() {
      var onEsc = this.props.onEsc;
      onEsc();
    }
  }, {
    key: "isAM",
    value: function isAM() {
      var defaultOpenValue = this.props.defaultOpenValue;
      var value = this.state.value;
      var realValue = value || defaultOpenValue;
      return realValue.hour() >= 0 && realValue.hour() < 12;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          placeholder = _this$props2.placeholder,
          disabledMinutes = _this$props2.disabledMinutes,
          disabledSeconds = _this$props2.disabledSeconds,
          hideDisabledOptions = _this$props2.hideDisabledOptions,
          showHour = _this$props2.showHour,
          showMinute = _this$props2.showMinute,
          showSecond = _this$props2.showSecond,
          format = _this$props2.format,
          defaultOpenValue = _this$props2.defaultOpenValue,
          clearText = _this$props2.clearText,
          onEsc = _this$props2.onEsc,
          addon = _this$props2.addon,
          use12Hours = _this$props2.use12Hours,
          focusOnOpen = _this$props2.focusOnOpen,
          onKeyDown = _this$props2.onKeyDown,
          hourStep = _this$props2.hourStep,
          minuteStep = _this$props2.minuteStep,
          secondStep = _this$props2.secondStep,
          inputReadOnly = _this$props2.inputReadOnly,
          clearIcon = _this$props2.clearIcon;
      var _this$state = this.state,
          value = _this$state.value,
          currentSelectPanel = _this$state.currentSelectPanel;
      var disabledHourOptions = this.disabledHours();
      var disabledMinuteOptions = disabledMinutes(value ? value.hour() : null);
      var disabledSecondOptions = disabledSeconds(value ? value.hour() : null, value ? value.minute() : null);
      var hourOptions = generateOptions(24, disabledHourOptions, hideDisabledOptions, hourStep);
      var minuteOptions = generateOptions(60, disabledMinuteOptions, hideDisabledOptions, minuteStep);
      var secondOptions = generateOptions(60, disabledSecondOptions, hideDisabledOptions, secondStep);
      var validDefaultOpenValue = toNearestValidTime(defaultOpenValue, hourOptions, minuteOptions, secondOptions);
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(className, "".concat(prefixCls, "-inner"))
      }, _react["default"].createElement(_Header["default"], {
        clearText: clearText,
        prefixCls: prefixCls,
        defaultOpenValue: validDefaultOpenValue,
        value: value,
        currentSelectPanel: currentSelectPanel,
        onEsc: onEsc,
        format: format,
        placeholder: placeholder,
        hourOptions: hourOptions,
        minuteOptions: minuteOptions,
        secondOptions: secondOptions,
        disabledHours: this.disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds,
        onChange: this.onChange,
        focusOnOpen: focusOnOpen,
        onKeyDown: onKeyDown,
        inputReadOnly: inputReadOnly,
        clearIcon: clearIcon
      }), _react["default"].createElement(_Combobox["default"], {
        prefixCls: prefixCls,
        value: value,
        defaultOpenValue: validDefaultOpenValue,
        format: format,
        onChange: this.onChange,
        onAmPmChange: this.onAmPmChange,
        showHour: showHour,
        showMinute: showMinute,
        showSecond: showSecond,
        hourOptions: hourOptions,
        minuteOptions: minuteOptions,
        secondOptions: secondOptions,
        disabledHours: this.disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds,
        onCurrentSelectPanelChange: this.onCurrentSelectPanelChange,
        use12Hours: use12Hours,
        onEsc: onEsc,
        isAM: this.isAM()
      }), addon(this));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if ('value' in props) {
        return _objectSpread({}, state, {
          value: props.value
        });
      }

      return null;
    }
  }]);

  return Panel;
}(_react.Component);

_defineProperty(Panel, "propTypes", {
  clearText: _propTypes["default"].string,
  prefixCls: _propTypes["default"].string,
  className: _propTypes["default"].string,
  defaultOpenValue: _propTypes["default"].object,
  value: _propTypes["default"].object,
  placeholder: _propTypes["default"].string,
  format: _propTypes["default"].string,
  inputReadOnly: _propTypes["default"].bool,
  disabledHours: _propTypes["default"].func,
  disabledMinutes: _propTypes["default"].func,
  disabledSeconds: _propTypes["default"].func,
  hideDisabledOptions: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onAmPmChange: _propTypes["default"].func,
  onEsc: _propTypes["default"].func,
  showHour: _propTypes["default"].bool,
  showMinute: _propTypes["default"].bool,
  showSecond: _propTypes["default"].bool,
  use12Hours: _propTypes["default"].bool,
  hourStep: _propTypes["default"].number,
  minuteStep: _propTypes["default"].number,
  secondStep: _propTypes["default"].number,
  addon: _propTypes["default"].func,
  focusOnOpen: _propTypes["default"].bool,
  onKeyDown: _propTypes["default"].func,
  clearIcon: _propTypes["default"].node
});

_defineProperty(Panel, "defaultProps", {
  prefixCls: 'rc-time-picker-panel',
  onChange: noop,
  disabledHours: noop,
  disabledMinutes: noop,
  disabledSeconds: noop,
  defaultOpenValue: (0, _moment["default"])(),
  use12Hours: false,
  addon: noop,
  onKeyDown: noop,
  onAmPmChange: noop,
  inputReadOnly: false
});

(0, _reactLifecyclesCompat.polyfill)(Panel);
var _default = Panel;
exports["default"] = _default;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  DATE_ROW_COUNT: 6,
  DATE_COL_COUNT: 7
};
module.exports = exports['default'];

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = InputIcon;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _icon = _interopRequireDefault(__webpack_require__(38));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function InputIcon(props) {
  var _classNames;

  var suffixIcon = props.suffixIcon,
      prefixCls = props.prefixCls;
  return suffixIcon && ( /*#__PURE__*/React.isValidElement(suffixIcon) ? /*#__PURE__*/React.cloneElement(suffixIcon, {
    className: (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, suffixIcon.props.className, suffixIcon.props.className), _defineProperty(_classNames, "".concat(prefixCls, "-picker-icon"), true), _classNames))
  }) : /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-picker-icon")
  }, suffixIcon)) || /*#__PURE__*/React.createElement(_icon["default"], {
    type: "calendar",
    className: "".concat(prefixCls, "-picker-icon")
  });
}

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 509 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(353),
    eq = __webpack_require__(222);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(158);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(101);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(514);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 514 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 515 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(517),
    baseKeysIn = __webpack_require__(1030),
    isArrayLike = __webpack_require__(268);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1029),
    isArguments = __webpack_require__(355),
    isArray = __webpack_require__(132),
    isBuffer = __webpack_require__(357),
    isIndex = __webpack_require__(359),
    isTypedArray = __webpack_require__(358);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var PropTypes = __importStar(__webpack_require__(19));

var mini_store_1 = __webpack_require__(115);

var classnames_1 = __importDefault(__webpack_require__(22));

var ColGroup_1 = __importDefault(__webpack_require__(1043));

var TableHeader_1 = __importDefault(__webpack_require__(1044));

var TableRow_1 = __importDefault(__webpack_require__(519));

var ExpandableRow_1 = __importDefault(__webpack_require__(1053));

var BaseTable = /*#__PURE__*/function (_React$Component) {
  _inherits(BaseTable, _React$Component);

  var _super = _createSuper(BaseTable);

  function BaseTable() {
    var _this;

    _classCallCheck(this, BaseTable);

    _this = _super.apply(this, arguments);

    _this.handleRowHover = function (isHover, key) {
      _this.props.store.setState({
        currentHoverKey: isHover ? key : null
      });
    };

    _this.renderRows = function (renderData, indent) {
      var ancestorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var table = _this.context.table;
      var columnManager = table.columnManager,
          components = table.components;
      var _table$props = table.props,
          prefixCls = _table$props.prefixCls,
          childrenColumnName = _table$props.childrenColumnName,
          rowClassName = _table$props.rowClassName,
          rowRef = _table$props.rowRef,
          onRowClick = _table$props.onRowClick,
          onRowDoubleClick = _table$props.onRowDoubleClick,
          onRowContextMenu = _table$props.onRowContextMenu,
          onRowMouseEnter = _table$props.onRowMouseEnter,
          onRowMouseLeave = _table$props.onRowMouseLeave,
          onRow = _table$props.onRow;
      var _this$props = _this.props,
          getRowKey = _this$props.getRowKey,
          fixed = _this$props.fixed,
          expander = _this$props.expander,
          isAnyColumnsFixed = _this$props.isAnyColumnsFixed;
      var rows = [];

      var _loop = function _loop(i) {
        var record = renderData[i];
        var key = getRowKey(record, i);
        var className = typeof rowClassName === 'string' ? rowClassName : rowClassName(record, i, indent);
        var onHoverProps = {};

        if (columnManager.isAnyColumnsFixed()) {
          onHoverProps.onHover = _this.handleRowHover;
        }

        var leafColumns = void 0;

        if (fixed === 'left') {
          leafColumns = columnManager.leftLeafColumns();
        } else if (fixed === 'right') {
          leafColumns = columnManager.rightLeafColumns();
        } else {
          leafColumns = _this.getColumns(columnManager.leafColumns());
        }

        var rowPrefixCls = "".concat(prefixCls, "-row");
        var row = React.createElement(ExpandableRow_1.default, Object.assign({}, expander.props, {
          fixed: fixed,
          index: i,
          prefixCls: rowPrefixCls,
          record: record,
          key: key,
          rowKey: key,
          onRowClick: onRowClick,
          needIndentSpaced: expander.needIndentSpaced,
          onExpandedChange: expander.handleExpandChange
        }), function (expandableRow) {
          return React.createElement(TableRow_1.default, Object.assign({
            fixed: fixed,
            indent: indent,
            className: className,
            record: record,
            index: i,
            prefixCls: rowPrefixCls,
            childrenColumnName: childrenColumnName,
            columns: leafColumns,
            onRow: onRow,
            onRowDoubleClick: onRowDoubleClick,
            onRowContextMenu: onRowContextMenu,
            onRowMouseEnter: onRowMouseEnter,
            onRowMouseLeave: onRowMouseLeave
          }, onHoverProps, {
            rowKey: key,
            ancestorKeys: ancestorKeys,
            ref: rowRef(record, i, indent),
            components: components,
            isAnyColumnsFixed: isAnyColumnsFixed
          }, expandableRow));
        });
        rows.push(row);
        expander.renderRows(_this.renderRows, rows, record, i, indent, fixed, key, ancestorKeys);
      };

      for (var i = 0; i < renderData.length; i += 1) {
        _loop(i);
      }

      return rows;
    };

    return _this;
  }

  _createClass(BaseTable, [{
    key: "getColumns",
    value: function getColumns(cols) {
      var _this$props2 = this.props,
          _this$props2$columns = _this$props2.columns,
          columns = _this$props2$columns === void 0 ? [] : _this$props2$columns,
          fixed = _this$props2.fixed;
      var table = this.context.table;
      var prefixCls = table.props.prefixCls;
      return (cols || columns).map(function (column) {
        return _objectSpread({}, column, {
          className: !!column.fixed && !fixed ? classnames_1.default("".concat(prefixCls, "-fixed-columns-in-body"), column.className) : column.className
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var table = this.context.table;
      var components = table.components;
      var _table$props2 = table.props,
          prefixCls = _table$props2.prefixCls,
          scroll = _table$props2.scroll,
          data = _table$props2.data,
          getBodyWrapper = _table$props2.getBodyWrapper;
      var _this$props3 = this.props,
          expander = _this$props3.expander,
          tableClassName = _this$props3.tableClassName,
          hasHead = _this$props3.hasHead,
          hasBody = _this$props3.hasBody,
          fixed = _this$props3.fixed,
          isAnyColumnsFixed = _this$props3.isAnyColumnsFixed;
      var tableStyle = {};

      if (!fixed && scroll.x) {
        // 当有固定列时，width auto 会导致 body table 的宽度撑不开，从而固定列无法对齐
        // 详情见：https://github.com/ant-design/ant-design/issues/22160
        var tableWidthScrollX = isAnyColumnsFixed ? 'max-content' : 'auto'; // not set width, then use content fixed width

        tableStyle.width = scroll.x === true ? tableWidthScrollX : scroll.x;
      }

      var Table = hasBody ? components.table : 'table';
      var BodyWrapper = components.body.wrapper;
      var body;

      if (hasBody) {
        body = React.createElement(BodyWrapper, {
          className: "".concat(prefixCls, "-tbody")
        }, this.renderRows(data, 0));

        if (getBodyWrapper) {
          body = getBodyWrapper(body);
        }
      }

      var columns = this.getColumns();
      return React.createElement(Table, {
        className: tableClassName,
        style: tableStyle,
        key: "table"
      }, React.createElement(ColGroup_1.default, {
        columns: columns,
        fixed: fixed
      }), hasHead && React.createElement(TableHeader_1.default, {
        expander: expander,
        columns: columns,
        fixed: fixed
      }), body);
    }
  }]);

  return BaseTable;
}(React.Component);

BaseTable.contextTypes = {
  table: PropTypes.any
};
exports.default = mini_store_1.connect()(BaseTable);

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var react_dom_1 = __importDefault(__webpack_require__(46));

var warning_1 = __importDefault(__webpack_require__(259));

var mini_store_1 = __webpack_require__(115);

var react_lifecycles_compat_1 = __webpack_require__(36);

var classnames_1 = __importDefault(__webpack_require__(22));

var TableCell_1 = __importDefault(__webpack_require__(1046));

var TableRow = /*#__PURE__*/function (_React$Component) {
  _inherits(TableRow, _React$Component);

  var _super = _createSuper(TableRow);

  function TableRow() {
    var _this;

    _classCallCheck(this, TableRow);

    _this = _super.apply(this, arguments);
    _this.state = {};

    _this.onTriggerEvent = function (rowPropFunc, legacyFunc, additionalFunc) {
      var _this$props = _this.props,
          record = _this$props.record,
          index = _this$props.index;
      return function () {
        // Additional function like trigger `this.onHover` to handle self logic
        if (additionalFunc) {
          additionalFunc();
        } // [Legacy] Some legacy function like `onRowClick`.


        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var event = args[0];

        if (legacyFunc) {
          legacyFunc(record, index, event);
        } // Pass to the function from `onRow`


        if (rowPropFunc) {
          rowPropFunc.apply(void 0, args);
        }
      };
    };

    _this.onMouseEnter = function () {
      var _this$props2 = _this.props,
          onHover = _this$props2.onHover,
          rowKey = _this$props2.rowKey;
      onHover(true, rowKey);
    };

    _this.onMouseLeave = function () {
      var _this$props3 = _this.props,
          onHover = _this$props3.onHover,
          rowKey = _this$props3.rowKey;
      onHover(false, rowKey);
    };

    return _this;
  }

  _createClass(TableRow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.shouldRender) {
        this.saveRowRef();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !!(this.props.visible || nextProps.visible);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.state.shouldRender && !this.rowRef) {
        this.saveRowRef();
      }
    }
  }, {
    key: "setExpandedRowHeight",
    value: function setExpandedRowHeight() {
      var _this$props4 = this.props,
          store = _this$props4.store,
          rowKey = _this$props4.rowKey;

      var _store$getState = store.getState(),
          expandedRowsHeight = _store$getState.expandedRowsHeight;

      var _this$rowRef$getBound = this.rowRef.getBoundingClientRect(),
          height = _this$rowRef$getBound.height;

      expandedRowsHeight = _objectSpread({}, expandedRowsHeight, _defineProperty({}, rowKey, height));
      store.setState({
        expandedRowsHeight: expandedRowsHeight
      });
    }
  }, {
    key: "setRowHeight",
    value: function setRowHeight() {
      var _this$props5 = this.props,
          store = _this$props5.store,
          rowKey = _this$props5.rowKey;

      var _store$getState2 = store.getState(),
          fixedColumnsBodyRowsHeight = _store$getState2.fixedColumnsBodyRowsHeight;

      var _this$rowRef$getBound2 = this.rowRef.getBoundingClientRect(),
          height = _this$rowRef$getBound2.height;

      store.setState({
        fixedColumnsBodyRowsHeight: _objectSpread({}, fixedColumnsBodyRowsHeight, _defineProperty({}, rowKey, height))
      });
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      var _this$props6 = this.props,
          height = _this$props6.height,
          visible = _this$props6.visible;

      if (height && height !== this.style.height) {
        this.style = _objectSpread({}, this.style, {
          height: height
        });
      }

      if (!visible && !this.style.display) {
        this.style = _objectSpread({}, this.style, {
          display: 'none'
        });
      }

      return this.style;
    }
  }, {
    key: "saveRowRef",
    value: function saveRowRef() {
      this.rowRef = react_dom_1.default.findDOMNode(this);
      var _this$props7 = this.props,
          isAnyColumnsFixed = _this$props7.isAnyColumnsFixed,
          fixed = _this$props7.fixed,
          expandedRow = _this$props7.expandedRow,
          ancestorKeys = _this$props7.ancestorKeys;

      if (!isAnyColumnsFixed || !this.rowRef) {
        return;
      }

      if (!fixed && expandedRow) {
        this.setExpandedRowHeight();
      }

      if (!fixed && ancestorKeys.length >= 0) {
        this.setRowHeight();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.shouldRender) {
        return null;
      }

      var _this$props8 = this.props,
          prefixCls = _this$props8.prefixCls,
          columns = _this$props8.columns,
          record = _this$props8.record,
          rowKey = _this$props8.rowKey,
          index = _this$props8.index,
          onRow = _this$props8.onRow,
          indent = _this$props8.indent,
          indentSize = _this$props8.indentSize,
          hovered = _this$props8.hovered,
          height = _this$props8.height,
          visible = _this$props8.visible,
          components = _this$props8.components,
          hasExpandIcon = _this$props8.hasExpandIcon,
          renderExpandIcon = _this$props8.renderExpandIcon,
          renderExpandIconCell = _this$props8.renderExpandIconCell,
          onRowClick = _this$props8.onRowClick,
          onRowDoubleClick = _this$props8.onRowDoubleClick,
          onRowMouseEnter = _this$props8.onRowMouseEnter,
          onRowMouseLeave = _this$props8.onRowMouseLeave,
          onRowContextMenu = _this$props8.onRowContextMenu;
      var BodyRow = components.body.row;
      var BodyCell = components.body.cell;
      var className = this.props.className;

      if (hovered) {
        className += " ".concat(prefixCls, "-hover");
      }

      var cells = [];
      renderExpandIconCell(cells);

      for (var i = 0; i < columns.length; i += 1) {
        var column = columns[i];
        warning_1.default(column.onCellClick === undefined, 'column[onCellClick] is deprecated, please use column[onCell] instead.');
        cells.push(React.createElement(TableCell_1.default, {
          prefixCls: prefixCls,
          record: record,
          indentSize: indentSize,
          indent: indent,
          index: index,
          column: column,
          key: column.key || column.dataIndex,
          expandIcon: hasExpandIcon(i) && renderExpandIcon(),
          component: BodyCell
        }));
      }

      var _ref = onRow(record, index) || {},
          customClassName = _ref.className,
          customStyle = _ref.style,
          rowProps = _objectWithoutProperties(_ref, ["className", "style"]);

      var style = {
        height: height
      };

      if (!visible) {
        style.display = 'none';
      }

      style = _objectSpread({}, style, {}, customStyle);
      var rowClassName = classnames_1.default(prefixCls, className, "".concat(prefixCls, "-level-").concat(indent), customClassName);
      return React.createElement(BodyRow, Object.assign({}, rowProps, {
        onClick: this.onTriggerEvent(rowProps.onClick, onRowClick),
        onDoubleClick: this.onTriggerEvent(rowProps.onDoubleClick, onRowDoubleClick),
        onMouseEnter: this.onTriggerEvent(rowProps.onMouseEnter, onRowMouseEnter, this.onMouseEnter),
        onMouseLeave: this.onTriggerEvent(rowProps.onMouseLeave, onRowMouseLeave, this.onMouseLeave),
        onContextMenu: this.onTriggerEvent(rowProps.onContextMenu, onRowContextMenu),
        className: rowClassName,
        style: style,
        "data-row-key": rowKey
      }), cells);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (prevState.visible || !prevState.visible && nextProps.visible) {
        return {
          shouldRender: true,
          visible: nextProps.visible
        };
      }

      return {
        visible: nextProps.visible
      };
    }
  }]);

  return TableRow;
}(React.Component);

TableRow.defaultProps = {
  onRow: function onRow() {},
  onHover: function onHover() {},
  hasExpandIcon: function hasExpandIcon() {},
  renderExpandIcon: function renderExpandIcon() {},
  renderExpandIconCell: function renderExpandIconCell() {}
};

function getRowHeight(state, props) {
  var expandedRowsHeight = state.expandedRowsHeight,
      fixedColumnsBodyRowsHeight = state.fixedColumnsBodyRowsHeight;
  var fixed = props.fixed,
      rowKey = props.rowKey;

  if (!fixed) {
    return null;
  }

  if (expandedRowsHeight[rowKey]) {
    return expandedRowsHeight[rowKey];
  }

  if (fixedColumnsBodyRowsHeight[rowKey]) {
    return fixedColumnsBodyRowsHeight[rowKey];
  }

  return null;
}

react_lifecycles_compat_1.polyfill(TableRow);
exports.default = mini_store_1.connect(function (state, props) {
  var currentHoverKey = state.currentHoverKey,
      _state$expandedRowKey = state.expandedRowKeys,
      expandedRowKeys = _state$expandedRowKey === void 0 ? [] : _state$expandedRowKey;
  var rowKey = props.rowKey,
      ancestorKeys = props.ancestorKeys;
  var visible = ancestorKeys.length === 0 || ancestorKeys.every(function (k) {
    return expandedRowKeys.includes(k);
  });
  return {
    visible: visible,
    hovered: currentHoverKey === rowKey,
    height: getRowHeight(state, props)
  };
})(TableRow);

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(521);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(522),
    toKey = __webpack_require__(270);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(132),
    isKey = __webpack_require__(361),
    stringToPath = __webpack_require__(1047),
    toString = __webpack_require__(1050);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var Column = function Column() {
  return null;
};

exports.default = Column;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var ColumnGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(ColumnGroup, _React$Component);

  var _super = _createSuper(ColumnGroup);

  function ColumnGroup() {
    _classCallCheck(this, ColumnGroup);

    return _super.apply(this, arguments);
  }

  return ColumnGroup;
}(React.Component);

exports.default = ColumnGroup;
ColumnGroup.isTableColumnGroup = true;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcDropdown = _interopRequireDefault(__webpack_require__(1060));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _configProvider = __webpack_require__(39);

var _warning = _interopRequireDefault(__webpack_require__(69));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _type = __webpack_require__(130);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Placements = (0, _type.tuple)('topLeft', 'topCenter', 'topRight', 'bottomLeft', 'bottomCenter', 'bottomRight');

var Dropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  var _super = _createSuper(Dropdown);

  function Dropdown() {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _super.apply(this, arguments);

    _this.renderOverlay = function (prefixCls) {
      // rc-dropdown already can process the function of overlay, but we have check logic here.
      // So we need render the element to check and pass back to rc-dropdown.
      var overlay = _this.props.overlay;
      var overlayNode;

      if (typeof overlay === 'function') {
        overlayNode = overlay();
      } else {
        overlayNode = overlay;
      }

      overlayNode = React.Children.only(overlayNode);
      var overlayProps = overlayNode.props; // Warning if use other mode

      (0, _warning["default"])(!overlayProps.mode || overlayProps.mode === 'vertical', 'Dropdown', "mode=\"".concat(overlayProps.mode, "\" is not supported for Dropdown's Menu.")); // menu cannot be selectable in dropdown defaultly
      // menu should be focusable in dropdown defaultly

      var _overlayProps$selecta = overlayProps.selectable,
          selectable = _overlayProps$selecta === void 0 ? false : _overlayProps$selecta,
          _overlayProps$focusab = overlayProps.focusable,
          focusable = _overlayProps$focusab === void 0 ? true : _overlayProps$focusab;
      var expandIcon = /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-menu-submenu-arrow")
      }, /*#__PURE__*/React.createElement(_icon["default"], {
        type: "right",
        className: "".concat(prefixCls, "-menu-submenu-arrow-icon")
      }));
      var fixedModeOverlay = typeof overlayNode.type === 'string' ? overlay : /*#__PURE__*/React.cloneElement(overlayNode, {
        mode: 'vertical',
        selectable: selectable,
        focusable: focusable,
        expandIcon: expandIcon
      });
      return fixedModeOverlay;
    };

    _this.renderDropDown = function (_ref) {
      var getContextPopupContainer = _ref.getPopupContainer,
          getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          children = _this$props.children,
          trigger = _this$props.trigger,
          disabled = _this$props.disabled,
          getPopupContainer = _this$props.getPopupContainer;
      var prefixCls = getPrefixCls('dropdown', customizePrefixCls);
      var child = React.Children.only(children);
      var dropdownTrigger = /*#__PURE__*/React.cloneElement(child, {
        className: (0, _classnames["default"])(child.props.className, "".concat(prefixCls, "-trigger")),
        disabled: disabled
      });
      var triggerActions = disabled ? [] : trigger;
      var alignPoint;

      if (triggerActions && triggerActions.indexOf('contextMenu') !== -1) {
        alignPoint = true;
      }

      return /*#__PURE__*/React.createElement(_rcDropdown["default"], _extends({
        alignPoint: alignPoint
      }, _this.props, {
        prefixCls: prefixCls,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        transitionName: _this.getTransitionName(),
        trigger: triggerActions,
        overlay: function overlay() {
          return _this.renderOverlay(prefixCls);
        }
      }), dropdownTrigger);
    };

    return _this;
  }

  _createClass(Dropdown, [{
    key: "getTransitionName",
    value: function getTransitionName() {
      var _this$props2 = this.props,
          _this$props2$placemen = _this$props2.placement,
          placement = _this$props2$placemen === void 0 ? '' : _this$props2$placemen,
          transitionName = _this$props2.transitionName;

      if (transitionName !== undefined) {
        return transitionName;
      }

      if (placement.indexOf('top') >= 0) {
        return 'slide-down';
      }

      return 'slide-up';
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderDropDown);
    }
  }]);

  return Dropdown;
}(React.Component);

exports["default"] = Dropdown;
Dropdown.defaultProps = {
  mouseEnterDelay: 0.15,
  mouseLeaveDelay: 0.1,
  placement: 'bottomLeft'
};

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(19));

var _reactLifecyclesCompat = __webpack_require__(36);

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _rcCheckbox = _interopRequireDefault(__webpack_require__(527));

var _shallowequal = _interopRequireDefault(__webpack_require__(89));

var _configProvider = __webpack_require__(39);

var _warning = _interopRequireDefault(__webpack_require__(69));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Checkbox = /*#__PURE__*/function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  var _super = _createSuper(Checkbox);

  function Checkbox() {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _super.apply(this, arguments);

    _this.saveCheckbox = function (node) {
      _this.rcCheckbox = node;
    };

    _this.renderCheckbox = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props,
          context = _assertThisInitialize.context;

      var customizePrefixCls = props.prefixCls,
          className = props.className,
          children = props.children,
          indeterminate = props.indeterminate,
          style = props.style,
          onMouseEnter = props.onMouseEnter,
          onMouseLeave = props.onMouseLeave,
          restProps = __rest(props, ["prefixCls", "className", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave"]);

      var checkboxGroup = context.checkboxGroup;
      var prefixCls = getPrefixCls('checkbox', customizePrefixCls);

      var checkboxProps = _extends({}, restProps);

      if (checkboxGroup) {
        checkboxProps.onChange = function () {
          if (restProps.onChange) {
            restProps.onChange.apply(restProps, arguments);
          }

          checkboxGroup.toggleOption({
            label: children,
            value: props.value
          });
        };

        checkboxProps.name = checkboxGroup.name;
        checkboxProps.checked = checkboxGroup.value.indexOf(props.value) !== -1;
        checkboxProps.disabled = props.disabled || checkboxGroup.disabled;
      }

      var classString = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-wrapper"), true), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-checked"), checkboxProps.checked), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-disabled"), checkboxProps.disabled), _classNames));
      var checkboxClass = (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-indeterminate"), indeterminate));
      return (
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/label-has-associated-control
        React.createElement("label", {
          className: classString,
          style: style,
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave
        }, /*#__PURE__*/React.createElement(_rcCheckbox["default"], _extends({}, checkboxProps, {
          prefixCls: prefixCls,
          className: checkboxClass,
          ref: _this.saveCheckbox
        })), children !== undefined && /*#__PURE__*/React.createElement("span", null, children))
      );
    };

    return _this;
  }

  _createClass(Checkbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var value = this.props.value;

      var _ref2 = this.context || {},
          _ref2$checkboxGroup = _ref2.checkboxGroup,
          checkboxGroup = _ref2$checkboxGroup === void 0 ? {} : _ref2$checkboxGroup;

      if (checkboxGroup.registerValue) {
        checkboxGroup.registerValue(value);
      }

      (0, _warning["default"])('checked' in this.props || (this.context || {}).checkboxGroup || !('value' in this.props), 'Checkbox', '`value` is not validate prop, do you mean `checked`?');
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState) || !(0, _shallowequal["default"])(this.context.checkboxGroup, nextContext.checkboxGroup);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref3) {
      var prevValue = _ref3.value;
      var value = this.props.value;

      var _ref4 = this.context || {},
          _ref4$checkboxGroup = _ref4.checkboxGroup,
          checkboxGroup = _ref4$checkboxGroup === void 0 ? {} : _ref4$checkboxGroup;

      if (value !== prevValue && checkboxGroup.registerValue && checkboxGroup.cancelValue) {
        checkboxGroup.cancelValue(prevValue);
        checkboxGroup.registerValue(value);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var value = this.props.value;

      var _ref5 = this.context || {},
          _ref5$checkboxGroup = _ref5.checkboxGroup,
          checkboxGroup = _ref5$checkboxGroup === void 0 ? {} : _ref5$checkboxGroup;

      if (checkboxGroup.cancelValue) {
        checkboxGroup.cancelValue(value);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.rcCheckbox.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.rcCheckbox.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCheckbox);
    }
  }]);

  return Checkbox;
}(React.Component);

Checkbox.__ANT_CHECKBOX = true;
Checkbox.defaultProps = {
  indeterminate: false
};
Checkbox.contextTypes = {
  checkboxGroup: PropTypes.any
};
(0, _reactLifecyclesCompat.polyfill)(Checkbox);
var _default = Checkbox;
exports["default"] = _default;

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Checkbox__ = __webpack_require__(1064);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Checkbox__["a" /* default */]);

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flatArray = flatArray;
exports.treeMap = treeMap;
exports.flatFilter = flatFilter;
exports.normalizeColumns = normalizeColumns;
exports.generateValueMaps = generateValueMaps;

var React = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function flatArray() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var childrenName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'children';
  var result = [];

  var loop = function loop(array) {
    array.forEach(function (item) {
      if (item[childrenName]) {
        var newItem = _extends({}, item);

        delete newItem[childrenName];
        result.push(newItem);

        if (item[childrenName].length > 0) {
          loop(item[childrenName]);
        }
      } else {
        result.push(item);
      }
    });
  };

  loop(data);
  return result;
}

function treeMap(tree, mapper) {
  var childrenName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';
  return tree.map(function (node, index) {
    var extra = {};

    if (node[childrenName]) {
      extra[childrenName] = treeMap(node[childrenName], mapper, childrenName);
    }

    return _extends(_extends({}, mapper(node, index)), extra);
  });
}

function flatFilter(tree, callback) {
  return tree.reduce(function (acc, node) {
    if (callback(node)) {
      acc.push(node);
    }

    if (node.children) {
      var children = flatFilter(node.children, callback);
      acc.push.apply(acc, _toConsumableArray(children));
    }

    return acc;
  }, []);
}

function normalizeColumns(elements) {
  var columns = [];
  React.Children.forEach(elements, function (element) {
    if (! /*#__PURE__*/React.isValidElement(element)) {
      return;
    }

    var column = _extends({}, element.props);

    if (element.key) {
      column.key = element.key;
    }

    if (element.type && element.type.__ANT_TABLE_COLUMN_GROUP) {
      column.children = normalizeColumns(column.children);
    }

    columns.push(column);
  });
  return columns;
}

function generateValueMaps(items) {
  var maps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (items || []).forEach(function (_ref) {
    var value = _ref.value,
        children = _ref.children;
    maps[value.toString()] = value;
    generateValueMaps(children, maps);
  });
  return maps;
}

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ZERO: 48,
  NINE: 57,

  NUMPAD_ZERO: 96,
  NUMPAD_NINE: 105,

  BACKSPACE: 8,
  DELETE: 46,
  ENTER: 13,

  ARROW_UP: 38,
  ARROW_DOWN: 40
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Option; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }




var Option =
/*#__PURE__*/
function (_Component) {
  _inherits(Option, _Component);

  function Option() {
    _classCallCheck(this, Option);

    return _possibleConstructorReturn(this, _getPrototypeOf(Option).apply(this, arguments));
  }

  return Option;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);


Option.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"]])
};
Option.isSelectOption = true;

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }



function propsValueType() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var props = args[0],
      propName = args[1],
      componentName = args[2],
      rest = args.slice(3);
  var basicType = __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"]]);
  var labelInValueShape = __WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"]({
    key: basicType.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_0_prop_types__["node"]
  });

  if (props.labelInValue) {
    var validate = __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"](labelInValueShape), labelInValueShape]);
    var error = validate.apply(void 0, [props, propName, componentName].concat(_toConsumableArray(rest)));

    if (error) {
      return new Error("Invalid prop `".concat(propName, "` supplied to `").concat(componentName, "`, ") + "when you set `labelInValue` to `true`, `".concat(propName, "` should in ") + "shape of `{ key: string | number, label?: ReactNode }`.");
    }
  } else if ((props.mode === 'multiple' || props.mode === 'tags' || props.multiple || props.tags) && props[propName] === '') {
    return new Error("Invalid prop `".concat(propName, "` of type `string` supplied to `").concat(componentName, "`, ") + "expected `array` when `multiple` or `tags` is `true`.");
  } else {
    var _validate = __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"](basicType), basicType]);

    return _validate.apply(void 0, [props, propName, componentName].concat(_toConsumableArray(rest)));
  }

  return null;
}

var SelectPropTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  defaultActiveFirstOption: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  multiple: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  filterOption: __WEBPACK_IMPORTED_MODULE_0_prop_types__["any"],
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types__["any"],
  showSearch: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  disabled: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  allowClear: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  showArrow: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  tags: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  prefixCls: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  transitionName: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  optionLabelProp: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  optionFilterProp: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  animation: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  choiceTransitionName: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  open: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  defaultOpen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onBlur: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onFocus: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onSelect: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onSearch: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onPopupScroll: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onInputKeyDown: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  placeholder: __WEBPACK_IMPORTED_MODULE_0_prop_types__["any"],
  onDeselect: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  labelInValue: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  loading: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  value: propsValueType,
  defaultValue: propsValueType,
  dropdownStyle: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  maxTagTextLength: __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
  maxTagCount: __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
  maxTagPlaceholder: __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["node"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"]]),
  tokenSeparators: __WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"](__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]),
  getInputElement: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  showAction: __WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"](__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]),
  clearIcon: __WEBPACK_IMPORTED_MODULE_0_prop_types__["node"],
  inputIcon: __WEBPACK_IMPORTED_MODULE_0_prop_types__["node"],
  removeIcon: __WEBPACK_IMPORTED_MODULE_0_prop_types__["node"],
  menuItemSelectedIcon: __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["node"]]),
  dropdownRender: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"]
};
/* harmony default export */ __webpack_exports__["a"] = (SelectPropTypes);

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(116),
    now = __webpack_require__(1090),
    toNumber = __webpack_require__(533);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(1091),
    isObject = __webpack_require__(116),
    isSymbol = __webpack_require__(269);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(1097);

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IsAuth=function(_Component){_inherits(IsAuth,_Component);function IsAuth(){_classCallCheck(this,IsAuth);return _possibleConstructorReturn(this,(IsAuth.__proto__||Object.getPrototypeOf(IsAuth)).apply(this,arguments));}_createClass(IsAuth,[{key:'render',value:function render(){if(this.props.isView){return this.props.children;}return this.props.defaultComponent;}}]);return IsAuth;}(_react.Component);exports.default=IsAuth;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcTree = _interopRequireWildcard(__webpack_require__(1104));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _DirectoryTree = _interopRequireDefault(__webpack_require__(1106));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _configProvider = __webpack_require__(39);

var _motion = _interopRequireDefault(__webpack_require__(493));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Tree = /*#__PURE__*/function (_React$Component) {
  _inherits(Tree, _React$Component);

  var _super = _createSuper(Tree);

  function Tree() {
    var _this;

    _classCallCheck(this, Tree);

    _this = _super.apply(this, arguments);

    _this.renderSwitcherIcon = function (prefixCls, switcherIcon, _ref) {
      var isLeaf = _ref.isLeaf,
          expanded = _ref.expanded,
          loading = _ref.loading;
      var showLine = _this.props.showLine;

      if (loading) {
        return /*#__PURE__*/React.createElement(_icon["default"], {
          type: "loading",
          className: "".concat(prefixCls, "-switcher-loading-icon")
        });
      }

      if (isLeaf) {
        return showLine ? /*#__PURE__*/React.createElement(_icon["default"], {
          type: "file",
          className: "".concat(prefixCls, "-switcher-line-icon")
        }) : null;
      }

      var switcherCls = "".concat(prefixCls, "-switcher-icon");

      if (switcherIcon) {
        return /*#__PURE__*/React.cloneElement(switcherIcon, {
          className: (0, _classnames["default"])(switcherIcon.props.className || '', switcherCls)
        });
      }

      return showLine ? /*#__PURE__*/React.createElement(_icon["default"], {
        type: expanded ? 'minus-square' : 'plus-square',
        className: "".concat(prefixCls, "-switcher-line-icon"),
        theme: "outlined"
      }) : /*#__PURE__*/React.createElement(_icon["default"], {
        type: "caret-down",
        className: switcherCls,
        theme: "filled"
      });
    };

    _this.setTreeRef = function (node) {
      _this.tree = node;
    };

    _this.renderTree = function (_ref2) {
      var _classNames;

      var getPrefixCls = _ref2.getPrefixCls;

      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      var customizePrefixCls = props.prefixCls,
          className = props.className,
          showIcon = props.showIcon,
          _switcherIcon = props.switcherIcon,
          blockNode = props.blockNode,
          children = props.children;
      var checkable = props.checkable;
      var prefixCls = getPrefixCls('tree', customizePrefixCls);
      return /*#__PURE__*/React.createElement(_rcTree["default"], _extends({
        ref: _this.setTreeRef
      }, props, {
        prefixCls: prefixCls,
        className: (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-icon-hide"), !showIcon), _defineProperty(_classNames, "".concat(prefixCls, "-block-node"), blockNode), _classNames)),
        checkable: checkable ? /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefixCls, "-checkbox-inner")
        }) : checkable,
        switcherIcon: function switcherIcon(nodeProps) {
          return _this.renderSwitcherIcon(prefixCls, _switcherIcon, nodeProps);
        }
      }), children);
    };

    return _this;
  }

  _createClass(Tree, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTree);
    }
  }]);

  return Tree;
}(React.Component);

exports["default"] = Tree;
Tree.TreeNode = _rcTree.TreeNode;
Tree.DirectoryTree = _DirectoryTree["default"];
Tree.defaultProps = {
  checkable: false,
  showIcon: false,
  motion: _extends(_extends({}, _motion["default"]), {
    motionAppear: false
  }),
  blockNode: false
};

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TreeContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ant_design_create_react_context__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ant_design_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ant_design_create_react_context__);

var TreeContext = __WEBPACK_IMPORTED_MODULE_0__ant_design_create_react_context___default()(null);

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["p"] = warnOnlyTreeNode;
/* harmony export (immutable) */ __webpack_exports__["b"] = arrDel;
/* harmony export (immutable) */ __webpack_exports__["a"] = arrAdd;
/* harmony export (immutable) */ __webpack_exports__["o"] = posToArr;
/* harmony export (immutable) */ __webpack_exports__["l"] = getPosition;
/* unused harmony export isTreeNode */
/* harmony export (immutable) */ __webpack_exports__["k"] = getNodeChildren;
/* unused harmony export isCheckDisabled */
/* unused harmony export traverseTreeNodes */
/* harmony export (immutable) */ __webpack_exports__["m"] = mapChildren;
/* harmony export (immutable) */ __webpack_exports__["j"] = getDragNodesKeys;
/* harmony export (immutable) */ __webpack_exports__["c"] = calcDropPosition;
/* harmony export (immutable) */ __webpack_exports__["d"] = calcSelectedKeys;
/* harmony export (immutable) */ __webpack_exports__["g"] = convertDataToTree;
/* harmony export (immutable) */ __webpack_exports__["h"] = convertTreeToEntities;
/* harmony export (immutable) */ __webpack_exports__["n"] = parseCheckedKeys;
/* harmony export (immutable) */ __webpack_exports__["e"] = conductCheck;
/* harmony export (immutable) */ __webpack_exports__["f"] = conductExpandParent;
/* harmony export (immutable) */ __webpack_exports__["i"] = getDataAndAria;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_util_es_Children_toArray__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TreeNode__ = __webpack_require__(539);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var DRAG_SIDE_RANGE = 0.25;
var DRAG_MIN_GAP = 2;
var onlyTreeNodeWarned = false;
function warnOnlyTreeNode() {
  if (onlyTreeNodeWarned) return;
  onlyTreeNodeWarned = true;
  __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'Tree only accept TreeNode as children.');
}
function arrDel(list, value) {
  var clone = list.slice();
  var index = clone.indexOf(value);

  if (index >= 0) {
    clone.splice(index, 1);
  }

  return clone;
}
function arrAdd(list, value) {
  var clone = list.slice();

  if (clone.indexOf(value) === -1) {
    clone.push(value);
  }

  return clone;
}
function posToArr(pos) {
  return pos.split('-');
}
function getPosition(level, index) {
  return "".concat(level, "-").concat(index);
}
function isTreeNode(node) {
  return node && node.type && node.type.isTreeNode;
}
function getNodeChildren(children) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_rc_util_es_Children_toArray__["a" /* default */])(children).filter(isTreeNode);
}
function isCheckDisabled(node) {
  var _ref = node.props || {},
      disabled = _ref.disabled,
      disableCheckbox = _ref.disableCheckbox,
      checkable = _ref.checkable;

  return !!(disabled || disableCheckbox) || checkable === false;
}
function traverseTreeNodes(treeNodes, callback) {
  function processNode(node, index, parent) {
    var children = node ? node.props.children : treeNodes;
    var pos = node ? getPosition(parent.pos, index) : 0; // Filter children

    var childList = getNodeChildren(children); // Process node if is not root

    if (node) {
      var data = {
        node: node,
        index: index,
        pos: pos,
        key: node.key || pos,
        parentPos: parent.node ? parent.pos : null
      };
      callback(data);
    } // Process children node


    __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(childList, function (subNode, subIndex) {
      processNode(subNode, subIndex, {
        node: node,
        pos: pos
      });
    });
  }

  processNode(null);
}
/**
 * Use `rc-util` `toArray` to get the children list which keeps the key.
 * And return single node if children is only one(This can avoid `key` missing check).
 */

function mapChildren(children, func) {
  var list = Object(__WEBPACK_IMPORTED_MODULE_1_rc_util_es_Children_toArray__["a" /* default */])(children).map(func);

  if (list.length === 1) {
    return list[0];
  }

  return list;
}
function getDragNodesKeys(treeNodes, node) {
  var _node$props = node.props,
      eventKey = _node$props.eventKey,
      pos = _node$props.pos;
  var dragNodesKeys = [];
  traverseTreeNodes(treeNodes, function (_ref2) {
    var key = _ref2.key;
    dragNodesKeys.push(key);
  });
  dragNodesKeys.push(eventKey || pos);
  return dragNodesKeys;
} // Only used when drag, not affect SSR.

function calcDropPosition(event, treeNode) {
  var clientY = event.clientY;

  var _treeNode$selectHandl = treeNode.selectHandle.getBoundingClientRect(),
      top = _treeNode$selectHandl.top,
      bottom = _treeNode$selectHandl.bottom,
      height = _treeNode$selectHandl.height;

  var des = Math.max(height * DRAG_SIDE_RANGE, DRAG_MIN_GAP);

  if (clientY <= top + des) {
    return -1;
  }

  if (clientY >= bottom - des) {
    return 1;
  }

  return 0;
}
/**
 * Return selectedKeys according with multiple prop
 * @param selectedKeys
 * @param props
 * @returns [string]
 */

function calcSelectedKeys(selectedKeys, props) {
  if (!selectedKeys) return undefined;
  var multiple = props.multiple;

  if (multiple) {
    return selectedKeys.slice();
  }

  if (selectedKeys.length) {
    return [selectedKeys[0]];
  }

  return selectedKeys;
}
/**
 * Since React internal will convert key to string,
 * we need do this to avoid `checkStrictly` use number match
 */

function keyListToString(keyList) {
  if (!keyList) return keyList;
  return keyList.map(function (key) {
    return String(key);
  });
}

var internalProcessProps = function internalProcessProps(props) {
  return props;
};

function convertDataToTree(treeData, processor) {
  if (!treeData) return [];

  var _ref3 = processor || {},
      _ref3$processProps = _ref3.processProps,
      processProps = _ref3$processProps === void 0 ? internalProcessProps : _ref3$processProps;

  var list = Array.isArray(treeData) ? treeData : [treeData];
  return list.map(function (_ref4) {
    var children = _ref4.children,
        props = _objectWithoutProperties(_ref4, ["children"]);

    var childrenNodes = convertDataToTree(children, processor);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TreeNode__["a" /* default */], Object.assign({}, processProps(props)), childrenNodes);
  });
}
/**
 * Calculate treeNodes entities. `processTreeEntity` is used for `rc-tree-select`
 * @param treeNodes
 * @param processTreeEntity  User can customize the entity
 */

function convertTreeToEntities(treeNodes) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      initWrapper = _ref5.initWrapper,
      processEntity = _ref5.processEntity,
      onProcessFinished = _ref5.onProcessFinished;

  var posEntities = {};
  var keyEntities = {};
  var wrapper = {
    posEntities: posEntities,
    keyEntities: keyEntities
  };

  if (initWrapper) {
    wrapper = initWrapper(wrapper) || wrapper;
  }

  traverseTreeNodes(treeNodes, function (item) {
    var node = item.node,
        index = item.index,
        pos = item.pos,
        key = item.key,
        parentPos = item.parentPos;
    var entity = {
      node: node,
      index: index,
      key: key,
      pos: pos
    };
    posEntities[pos] = entity;
    keyEntities[key] = entity; // Fill children

    entity.parent = posEntities[parentPos];

    if (entity.parent) {
      entity.parent.children = entity.parent.children || [];
      entity.parent.children.push(entity);
    }

    if (processEntity) {
      processEntity(entity, wrapper);
    }
  });

  if (onProcessFinished) {
    onProcessFinished(wrapper);
  }

  return wrapper;
}
/**
 * Parse `checkedKeys` to { checkedKeys, halfCheckedKeys } style
 */

function parseCheckedKeys(keys) {
  if (!keys) {
    return null;
  } // Convert keys to object format


  var keyProps;

  if (Array.isArray(keys)) {
    // [Legacy] Follow the api doc
    keyProps = {
      checkedKeys: keys,
      halfCheckedKeys: undefined
    };
  } else if (_typeof(keys) === 'object') {
    keyProps = {
      checkedKeys: keys.checked || undefined,
      halfCheckedKeys: keys.halfChecked || undefined
    };
  } else {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, '`checkedKeys` is not an array or an object');
    return null;
  }

  keyProps.checkedKeys = keyListToString(keyProps.checkedKeys);
  keyProps.halfCheckedKeys = keyListToString(keyProps.halfCheckedKeys);
  return keyProps;
}
/**
 * Conduct check state by the keyList. It will conduct up & from the provided key.
 * If the conduct path reach the disabled or already checked / unchecked node will stop conduct.
 */

function conductCheck(
/** list of keys */
keyList,
/** is check the node or not */
isCheck,
/** parsed by `convertTreeToEntities` function in Tree */
keyEntities) {
  var checkStatus = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var checkedKeys = {};
  var halfCheckedKeys = {}; // Record the key has some child checked (include child half checked)

  (checkStatus.checkedKeys || []).forEach(function (key) {
    checkedKeys[key] = true;
  });
  (checkStatus.halfCheckedKeys || []).forEach(function (key) {
    halfCheckedKeys[key] = true;
  }); // Conduct up

  function conductUp(key) {
    if (checkedKeys[key] === isCheck) return;
    var entity = keyEntities[key];
    if (!entity) return;
    var children = entity.children,
        parent = entity.parent,
        node = entity.node;
    if (isCheckDisabled(node)) return; // Check child node checked status

    var everyChildChecked = true;
    var someChildChecked = false; // Child checked or half checked

    (children || []).filter(function (child) {
      return !isCheckDisabled(child.node);
    }).forEach(function (_ref6) {
      var childKey = _ref6.key;
      var childChecked = checkedKeys[childKey];
      var childHalfChecked = halfCheckedKeys[childKey];
      if (childChecked || childHalfChecked) someChildChecked = true;
      if (!childChecked) everyChildChecked = false;
    }); // Update checked status

    if (isCheck) {
      checkedKeys[key] = everyChildChecked;
    } else {
      checkedKeys[key] = false;
    }

    halfCheckedKeys[key] = someChildChecked;

    if (parent) {
      conductUp(parent.key);
    }
  } // Conduct down


  function conductDown(key) {
    if (checkedKeys[key] === isCheck) return;
    var entity = keyEntities[key];
    if (!entity) return;
    var children = entity.children,
        node = entity.node;
    if (isCheckDisabled(node)) return;
    checkedKeys[key] = isCheck;
    (children || []).forEach(function (child) {
      conductDown(child.key);
    });
  }

  function conduct(key) {
    var entity = keyEntities[key];

    if (!entity) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "'".concat(key, "' does not exist in the tree."));
      return;
    }

    var children = entity.children,
        parent = entity.parent,
        node = entity.node;
    checkedKeys[key] = isCheck;
    if (isCheckDisabled(node)) return; // Conduct down

    (children || []).filter(function (child) {
      return !isCheckDisabled(child.node);
    }).forEach(function (child) {
      conductDown(child.key);
    }); // Conduct up

    if (parent) {
      conductUp(parent.key);
    }
  }

  (keyList || []).forEach(function (key) {
    conduct(key);
  });
  var checkedKeyList = [];
  var halfCheckedKeyList = []; // Fill checked list

  Object.keys(checkedKeys).forEach(function (key) {
    if (checkedKeys[key]) {
      checkedKeyList.push(key);
    }
  }); // Fill half checked list

  Object.keys(halfCheckedKeys).forEach(function (key) {
    if (!checkedKeys[key] && halfCheckedKeys[key]) {
      halfCheckedKeyList.push(key);
    }
  });
  return {
    checkedKeys: checkedKeyList,
    halfCheckedKeys: halfCheckedKeyList
  };
}
/**
 * If user use `autoExpandParent` we should get the list of parent node
 * @param keyList
 * @param keyEntities
 */

function conductExpandParent(keyList, keyEntities) {
  var expandedKeys = {};

  function conductUp(key) {
    if (expandedKeys[key]) return;
    var entity = keyEntities[key];
    if (!entity) return;
    expandedKeys[key] = true;
    var parent = entity.parent,
        node = entity.node;
    if (node.props && node.props.disabled) return;

    if (parent) {
      conductUp(parent.key);
    }
  }

  (keyList || []).forEach(function (key) {
    conductUp(key);
  });
  return Object.keys(expandedKeys);
}
/**
 * Returns only the data- and aria- key/value pairs
 */

function getDataAndAria(props) {
  return Object.keys(props).reduce(function (prev, key) {
    if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-') {
      prev[key] = props[key];
    }

    return prev;
  }, {});
}

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InternalTreeNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_animate_es_CSSMotion__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_util_es_Children_toArray__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lifecycles_compat__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__contextTypes__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(538);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }



 // @ts-ignore






var ICON_OPEN = 'open';
var ICON_CLOSE = 'close';
var defaultTitle = '---';

var TreeNode = /*#__PURE__*/function (_React$Component) {
  _inherits(TreeNode, _React$Component);

  var _super = _createSuper(TreeNode);

  function TreeNode() {
    var _this;

    _classCallCheck(this, TreeNode);

    _this = _super.apply(this, arguments);
    _this.state = {
      dragNodeHighlight: false
    };

    _this.onSelectorClick = function (e) {
      // Click trigger before select/check operation
      var onNodeClick = _this.props.context.onNodeClick;
      onNodeClick(e, _assertThisInitialized(_this));

      if (_this.isSelectable()) {
        _this.onSelect(e);
      } else {
        _this.onCheck(e);
      }
    };

    _this.onSelectorDoubleClick = function (e) {
      var onNodeDoubleClick = _this.props.context.onNodeDoubleClick;
      onNodeDoubleClick(e, _assertThisInitialized(_this));
    };

    _this.onSelect = function (e) {
      if (_this.isDisabled()) return;
      var onNodeSelect = _this.props.context.onNodeSelect;
      e.preventDefault();
      onNodeSelect(e, _assertThisInitialized(_this));
    };

    _this.onCheck = function (e) {
      if (_this.isDisabled()) return;
      var _this$props = _this.props,
          disableCheckbox = _this$props.disableCheckbox,
          checked = _this$props.checked;
      var onNodeCheck = _this.props.context.onNodeCheck;
      if (!_this.isCheckable() || disableCheckbox) return;
      e.preventDefault();
      var targetChecked = !checked;
      onNodeCheck(e, _assertThisInitialized(_this), targetChecked);
    };

    _this.onMouseEnter = function (e) {
      var onNodeMouseEnter = _this.props.context.onNodeMouseEnter;
      onNodeMouseEnter(e, _assertThisInitialized(_this));
    };

    _this.onMouseLeave = function (e) {
      var onNodeMouseLeave = _this.props.context.onNodeMouseLeave;
      onNodeMouseLeave(e, _assertThisInitialized(_this));
    };

    _this.onContextMenu = function (e) {
      var onNodeContextMenu = _this.props.context.onNodeContextMenu;
      onNodeContextMenu(e, _assertThisInitialized(_this));
    };

    _this.onDragStart = function (e) {
      var onNodeDragStart = _this.props.context.onNodeDragStart;
      e.stopPropagation();

      _this.setState({
        dragNodeHighlight: true
      });

      onNodeDragStart(e, _assertThisInitialized(_this));

      try {
        // ie throw error
        // firefox-need-it
        e.dataTransfer.setData('text/plain', '');
      } catch (error) {// empty
      }
    };

    _this.onDragEnter = function (e) {
      var onNodeDragEnter = _this.props.context.onNodeDragEnter;
      e.preventDefault();
      e.stopPropagation();
      onNodeDragEnter(e, _assertThisInitialized(_this));
    };

    _this.onDragOver = function (e) {
      var onNodeDragOver = _this.props.context.onNodeDragOver;
      e.preventDefault();
      e.stopPropagation();
      onNodeDragOver(e, _assertThisInitialized(_this));
    };

    _this.onDragLeave = function (e) {
      var onNodeDragLeave = _this.props.context.onNodeDragLeave;
      e.stopPropagation();
      onNodeDragLeave(e, _assertThisInitialized(_this));
    };

    _this.onDragEnd = function (e) {
      var onNodeDragEnd = _this.props.context.onNodeDragEnd;
      e.stopPropagation();

      _this.setState({
        dragNodeHighlight: false
      });

      onNodeDragEnd(e, _assertThisInitialized(_this));
    };

    _this.onDrop = function (e) {
      var onNodeDrop = _this.props.context.onNodeDrop;
      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        dragNodeHighlight: false
      });

      onNodeDrop(e, _assertThisInitialized(_this));
    }; // Disabled item still can be switch


    _this.onExpand = function (e) {
      var onNodeExpand = _this.props.context.onNodeExpand;
      onNodeExpand(e, _assertThisInitialized(_this));
    }; // Drag usage


    _this.setSelectHandle = function (node) {
      _this.selectHandle = node;
    };

    _this.getNodeChildren = function () {
      var children = _this.props.children;
      var originList = Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_Children_toArray__["a" /* default */])(children).filter(function (node) {
        return node;
      });
      var targetList = Object(__WEBPACK_IMPORTED_MODULE_7__util__["k" /* getNodeChildren */])(originList);

      if (originList.length !== targetList.length) {
        Object(__WEBPACK_IMPORTED_MODULE_7__util__["p" /* warnOnlyTreeNode */])();
      }

      return targetList;
    };

    _this.getNodeState = function () {
      var expanded = _this.props.expanded;

      if (_this.isLeaf()) {
        return null;
      }

      return expanded ? ICON_OPEN : ICON_CLOSE;
    };

    _this.isLeaf = function () {
      var _this$props2 = _this.props,
          isLeaf = _this$props2.isLeaf,
          loaded = _this$props2.loaded;
      var loadData = _this.props.context.loadData;
      var hasChildren = _this.getNodeChildren().length !== 0;

      if (isLeaf === false) {
        return false;
      }

      return isLeaf || !loadData && !hasChildren || loadData && loaded && !hasChildren;
    };

    _this.isDisabled = function () {
      var disabled = _this.props.disabled;
      var treeDisabled = _this.props.context.disabled; // Follow the logic of Selectable

      if (disabled === false) {
        return false;
      }

      return !!(treeDisabled || disabled);
    };

    _this.isCheckable = function () {
      var checkable = _this.props.checkable;
      var treeCheckable = _this.props.context.checkable; // Return false if tree or treeNode is not checkable

      if (!treeCheckable || checkable === false) return false;
      return treeCheckable;
    }; // Load data to avoid default expanded tree without data


    _this.syncLoadData = function (props) {
      var expanded = props.expanded,
          loading = props.loading,
          loaded = props.loaded;
      var _this$props$context = _this.props.context,
          loadData = _this$props$context.loadData,
          onNodeLoad = _this$props$context.onNodeLoad;
      if (loading) return; // read from state to avoid loadData at same time

      if (loadData && expanded && !_this.isLeaf()) {
        // We needn't reload data when has children in sync logic
        // It's only needed in node expanded
        var hasChildren = _this.getNodeChildren().length !== 0;

        if (!hasChildren && !loaded) {
          onNodeLoad(_assertThisInitialized(_this));
        }
      }
    }; // Switcher


    _this.renderSwitcher = function () {
      var _this$props3 = _this.props,
          expanded = _this$props3.expanded,
          switcherIconFromProps = _this$props3.switcherIcon;
      var _this$props$context2 = _this.props.context,
          prefixCls = _this$props$context2.prefixCls,
          switcherIconFromCtx = _this$props$context2.switcherIcon;
      var switcherIcon = switcherIconFromProps || switcherIconFromCtx;

      if (_this.isLeaf()) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("".concat(prefixCls, "-switcher"), "".concat(prefixCls, "-switcher-noop"))
        }, typeof switcherIcon === 'function' ? switcherIcon(_objectSpread({}, _this.props, {
          isLeaf: true
        })) : switcherIcon);
      }

      var switcherCls = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("".concat(prefixCls, "-switcher"), "".concat(prefixCls, "-switcher_").concat(expanded ? ICON_OPEN : ICON_CLOSE));
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
        onClick: _this.onExpand,
        className: switcherCls
      }, typeof switcherIcon === 'function' ? switcherIcon(_objectSpread({}, _this.props, {
        isLeaf: false
      })) : switcherIcon);
    }; // Checkbox


    _this.renderCheckbox = function () {
      var _this$props4 = _this.props,
          checked = _this$props4.checked,
          halfChecked = _this$props4.halfChecked,
          disableCheckbox = _this$props4.disableCheckbox;
      var prefixCls = _this.props.context.prefixCls;

      var disabled = _this.isDisabled();

      var checkable = _this.isCheckable();

      if (!checkable) return null; // [Legacy] Custom element should be separate with `checkable` in future

      var $custom = typeof checkable !== 'boolean' ? checkable : null;
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("".concat(prefixCls, "-checkbox"), checked && "".concat(prefixCls, "-checkbox-checked"), !checked && halfChecked && "".concat(prefixCls, "-checkbox-indeterminate"), (disabled || disableCheckbox) && "".concat(prefixCls, "-checkbox-disabled")),
        onClick: _this.onCheck
      }, $custom);
    };

    _this.renderIcon = function () {
      var loading = _this.props.loading;
      var prefixCls = _this.props.context.prefixCls;
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("".concat(prefixCls, "-iconEle"), "".concat(prefixCls, "-icon__").concat(_this.getNodeState() || 'docu'), loading && "".concat(prefixCls, "-icon_loading"))
      });
    }; // Icon + Title


    _this.renderSelector = function () {
      var dragNodeHighlight = _this.state.dragNodeHighlight;
      var _this$props5 = _this.props,
          title = _this$props5.title,
          selected = _this$props5.selected,
          icon = _this$props5.icon,
          loading = _this$props5.loading;
      var _this$props$context3 = _this.props.context,
          prefixCls = _this$props$context3.prefixCls,
          showIcon = _this$props$context3.showIcon,
          treeIcon = _this$props$context3.icon,
          draggable = _this$props$context3.draggable,
          loadData = _this$props$context3.loadData;

      var disabled = _this.isDisabled();

      var wrapClass = "".concat(prefixCls, "-node-content-wrapper"); // Icon - Still show loading icon when loading without showIcon

      var $icon;

      if (showIcon) {
        var currentIcon = icon || treeIcon;
        $icon = currentIcon ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("".concat(prefixCls, "-iconEle"), "".concat(prefixCls, "-icon__customize"))
        }, typeof currentIcon === 'function' ? currentIcon(_this.props) : currentIcon) : _this.renderIcon();
      } else if (loadData && loading) {
        $icon = _this.renderIcon();
      } // Title


      var $title = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
        className: "".concat(prefixCls, "-title")
      }, title);
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
        ref: _this.setSelectHandle,
        title: typeof title === 'string' ? title : '',
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("".concat(wrapClass), "".concat(wrapClass, "-").concat(_this.getNodeState() || 'normal'), !disabled && (selected || dragNodeHighlight) && "".concat(prefixCls, "-node-selected"), !disabled && draggable && 'draggable'),
        draggable: !disabled && draggable || undefined,
        "aria-grabbed": !disabled && draggable || undefined,
        onMouseEnter: _this.onMouseEnter,
        onMouseLeave: _this.onMouseLeave,
        onContextMenu: _this.onContextMenu,
        onClick: _this.onSelectorClick,
        onDoubleClick: _this.onSelectorDoubleClick,
        onDragStart: draggable ? _this.onDragStart : undefined
      }, $icon, $title);
    }; // Children list wrapped with `Animation`


    _this.renderChildren = function () {
      var _this$props6 = _this.props,
          expanded = _this$props6.expanded,
          pos = _this$props6.pos;
      var _this$props$context4 = _this.props.context,
          prefixCls = _this$props$context4.prefixCls,
          motion = _this$props$context4.motion,
          renderTreeNode = _this$props$context4.renderTreeNode; // Children TreeNode

      var nodeList = _this.getNodeChildren();

      if (nodeList.length === 0) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_animate_es_CSSMotion__["a" /* default */], Object.assign({
        visible: expanded
      }, motion), function (_ref) {
        var style = _ref.style,
            className = _ref.className;
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, "".concat(prefixCls, "-child-tree"), expanded && "".concat(prefixCls, "-child-tree-open")),
          style: style,
          "data-expanded": expanded,
          role: "group"
        }, Object(__WEBPACK_IMPORTED_MODULE_7__util__["m" /* mapChildren */])(nodeList, function (node, index) {
          return renderTreeNode(node, index, pos);
        }));
      });
    };

    return _this;
  } // Isomorphic needn't load data in server side


  _createClass(TreeNode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props7 = this.props,
          eventKey = _this$props7.eventKey,
          registerTreeNode = _this$props7.context.registerTreeNode;
      this.syncLoadData(this.props);
      registerTreeNode(eventKey, this);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.syncLoadData(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props8 = this.props,
          eventKey = _this$props8.eventKey,
          registerTreeNode = _this$props8.context.registerTreeNode;
      registerTreeNode(eventKey, null);
    }
  }, {
    key: "isSelectable",
    value: function isSelectable() {
      var selectable = this.props.selectable;
      var treeSelectable = this.props.context.selectable; // Ignore when selectable is undefined or null

      if (typeof selectable === 'boolean') {
        return selectable;
      }

      return treeSelectable;
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var loading = this.props.loading;

      var _this$props9 = this.props,
          className = _this$props9.className,
          style = _this$props9.style,
          dragOver = _this$props9.dragOver,
          dragOverGapTop = _this$props9.dragOverGapTop,
          dragOverGapBottom = _this$props9.dragOverGapBottom,
          isLeaf = _this$props9.isLeaf,
          expanded = _this$props9.expanded,
          selected = _this$props9.selected,
          checked = _this$props9.checked,
          halfChecked = _this$props9.halfChecked,
          otherProps = _objectWithoutProperties(_this$props9, ["className", "style", "dragOver", "dragOverGapTop", "dragOverGapBottom", "isLeaf", "expanded", "selected", "checked", "halfChecked"]);

      var _this$props$context5 = this.props.context,
          prefixCls = _this$props$context5.prefixCls,
          filterTreeNode = _this$props$context5.filterTreeNode,
          draggable = _this$props$context5.draggable;
      var disabled = this.isDisabled();
      var dataOrAriaAttributeProps = Object(__WEBPACK_IMPORTED_MODULE_7__util__["i" /* getDataAndAria */])(otherProps);
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", Object.assign({
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-treenode-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-treenode-switcher-").concat(expanded ? 'open' : 'close'), !isLeaf), _defineProperty(_classNames, "".concat(prefixCls, "-treenode-checkbox-checked"), checked), _defineProperty(_classNames, "".concat(prefixCls, "-treenode-checkbox-indeterminate"), halfChecked), _defineProperty(_classNames, "".concat(prefixCls, "-treenode-selected"), selected), _defineProperty(_classNames, "".concat(prefixCls, "-treenode-loading"), loading), _defineProperty(_classNames, 'drag-over', !disabled && dragOver), _defineProperty(_classNames, 'drag-over-gap-top', !disabled && dragOverGapTop), _defineProperty(_classNames, 'drag-over-gap-bottom', !disabled && dragOverGapBottom), _defineProperty(_classNames, 'filter-node', filterTreeNode && filterTreeNode(this)), _classNames)),
        style: style,
        role: "treeitem",
        onDragEnter: draggable ? this.onDragEnter : undefined,
        onDragOver: draggable ? this.onDragOver : undefined,
        onDragLeave: draggable ? this.onDragLeave : undefined,
        onDrop: draggable ? this.onDrop : undefined,
        onDragEnd: draggable ? this.onDragEnd : undefined
      }, dataOrAriaAttributeProps), this.renderSwitcher(), this.renderCheckbox(), this.renderSelector(), this.renderChildren());
    }
  }]);

  return TreeNode;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TreeNode.propTypes = {
  eventKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // By parent
  expanded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  checked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  loaded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  halfChecked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  pos: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dragOverGapTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dragOverGapBottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // By user
  isLeaf: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  checkable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disableCheckbox: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  switcherIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Object(__WEBPACK_IMPORTED_MODULE_5_react_lifecycles_compat__["polyfill"])(TreeNode);

var ContextTreeNode = function ContextTreeNode(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__contextTypes__["a" /* TreeContext */].Consumer, null, function (context) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TreeNode, Object.assign({}, props, {
      context: context
    }));
  });
};

ContextTreeNode.defaultProps = {
  title: defaultTitle
};
ContextTreeNode.isTreeNode = 1;

/* harmony default export */ __webpack_exports__["a"] = (ContextTreeNode);

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.html2canvas = factory());
}(this, (function () { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }

    var Bounds = /** @class */ (function () {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function (x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function (context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function (context, domRectList) {
            var domRect = Array.from(domRectList).find(function (rect) { return rect.width !== 0; });
            return domRect
                ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height)
                : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }());
    var parseBounds = function (context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function (document) {
        var body = document.body;
        var documentElement = document.documentElement;
        if (!body || !documentElement) {
            throw new Error("Unable to get document size");
        }
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };

    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var toCodePoints$1 = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint$1 = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$2 = 0; i$2 < chars$2.length; i$2++) {
        lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    }

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++) {
        lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    }
    var decode$1 = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1$1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function (base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16$1(view16, (headerLength + view32[4]) / 2)
            : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2$1) & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$3 = 0; i$3 < chars$3.length; i$3++) {
        lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    }

    var base64$1 = 'KwAAAAAAAAAACA4AUD0AADAgAAACAAAAAAAIABAAGABAAEgAUABYAGAAaABgAGgAYgBqAF8AZwBgAGgAcQB5AHUAfQCFAI0AlQCdAKIAqgCyALoAYABoAGAAaABgAGgAwgDKAGAAaADGAM4A0wDbAOEA6QDxAPkAAQEJAQ8BFwF1AH0AHAEkASwBNAE6AUIBQQFJAVEBWQFhAWgBcAF4ATAAgAGGAY4BlQGXAZ8BpwGvAbUBvQHFAc0B0wHbAeMB6wHxAfkBAQIJAvEBEQIZAiECKQIxAjgCQAJGAk4CVgJeAmQCbAJ0AnwCgQKJApECmQKgAqgCsAK4ArwCxAIwAMwC0wLbAjAA4wLrAvMC+AIAAwcDDwMwABcDHQMlAy0DNQN1AD0DQQNJA0kDSQNRA1EDVwNZA1kDdQB1AGEDdQBpA20DdQN1AHsDdQCBA4kDkQN1AHUAmQOhA3UAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AKYDrgN1AHUAtgO+A8YDzgPWAxcD3gPjA+sD8wN1AHUA+wMDBAkEdQANBBUEHQQlBCoEFwMyBDgEYABABBcDSARQBFgEYARoBDAAcAQzAXgEgASIBJAEdQCXBHUAnwSnBK4EtgS6BMIEyAR1AHUAdQB1AHUAdQCVANAEYABgAGAAYABgAGAAYABgANgEYADcBOQEYADsBPQE/AQEBQwFFAUcBSQFLAU0BWQEPAVEBUsFUwVbBWAAYgVgAGoFcgV6BYIFigWRBWAAmQWfBaYFYABgAGAAYABgAKoFYACxBbAFuQW6BcEFwQXHBcEFwQXPBdMF2wXjBeoF8gX6BQIGCgYSBhoGIgYqBjIGOgZgAD4GRgZMBmAAUwZaBmAAYABgAGAAYABgAGAAYABgAGAAYABgAGIGYABpBnAGYABgAGAAYABgAGAAYABgAGAAYAB4Bn8GhQZgAGAAYAB1AHcDFQSLBmAAYABgAJMGdQA9A3UAmwajBqsGqwaVALMGuwbDBjAAywbSBtIG1QbSBtIG0gbSBtIG0gbdBuMG6wbzBvsGAwcLBxMHAwcbByMHJwcsBywHMQcsB9IGOAdAB0gHTgfSBkgHVgfSBtIG0gbSBtIG0gbSBtIG0gbSBiwHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAdgAGAALAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAdbB2MHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsB2kH0gZwB64EdQB1AHUAdQB1AHUAdQB1AHUHfQdgAIUHjQd1AHUAlQedB2AAYAClB6sHYACzB7YHvgfGB3UAzgfWBzMB3gfmB1EB7gf1B/0HlQENAQUIDQh1ABUIHQglCBcDLQg1CD0IRQhNCEEDUwh1AHUAdQBbCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIcAh3CHoIMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIgggwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAALAcsBywHLAcsBywHLAcsBywHLAcsB4oILAcsB44I0gaWCJ4Ipgh1AHUAqgiyCHUAdQB1AHUAdQB1AHUAdQB1AHUAtwh8AXUAvwh1AMUIyQjRCNkI4AjoCHUAdQB1AO4I9gj+CAYJDgkTCS0HGwkjCYIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiAAIAAAAFAAYABgAGIAXwBgAHEAdQBFAJUAogCyAKAAYABgAEIA4ABGANMA4QDxAMEBDwE1AFwBLAE6AQEBUQF4QkhCmEKoQrhCgAHIQsAB0MLAAcABwAHAAeDC6ABoAHDCwMMAAcABwAHAAdDDGMMAAcAB6MM4wwjDWMNow3jDaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAEjDqABWw6bDqABpg6gAaABoAHcDvwOPA+gAaABfA/8DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DpcPAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcAB9cPKwkyCToJMAB1AHUAdQBCCUoJTQl1AFUJXAljCWcJawkwADAAMAAwAHMJdQB2CX4JdQCECYoJjgmWCXUAngkwAGAAYABxAHUApgn3A64JtAl1ALkJdQDACTAAMAAwADAAdQB1AHUAdQB1AHUAdQB1AHUAowYNBMUIMAAwADAAMADICcsJ0wnZCRUE4QkwAOkJ8An4CTAAMAB1AAAKvwh1AAgKDwoXCh8KdQAwACcKLgp1ADYKqAmICT4KRgowADAAdQB1AE4KMAB1AFYKdQBeCnUAZQowADAAMAAwADAAMAAwADAAMAAVBHUAbQowADAAdQC5CXUKMAAwAHwBxAijBogEMgF9CoQKiASMCpQKmgqIBKIKqgquCogEDQG2Cr4KxgrLCjAAMADTCtsKCgHjCusK8Qr5CgELMAAwADAAMAB1AIsECQsRC3UANAEZCzAAMAAwADAAMAB1ACELKQswAHUANAExCzkLdQBBC0kLMABRC1kLMAAwADAAMAAwADAAdQBhCzAAMAAwAGAAYABpC3ELdwt/CzAAMACHC4sLkwubC58Lpwt1AK4Ltgt1APsDMAAwADAAMAAwADAAMAAwAL4LwwvLC9IL1wvdCzAAMADlC+kL8Qv5C/8LSQswADAAMAAwADAAMAAwADAAMAAHDDAAMAAwADAAMAAODBYMHgx1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1ACYMMAAwADAAdQB1AHUALgx1AHUAdQB1AHUAdQA2DDAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AD4MdQBGDHUAdQB1AHUAdQB1AEkMdQB1AHUAdQB1AFAMMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQBYDHUAdQB1AF8MMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUA+wMVBGcMMAAwAHwBbwx1AHcMfwyHDI8MMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAYABgAJcMMAAwADAAdQB1AJ8MlQClDDAAMACtDCwHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsB7UMLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AA0EMAC9DDAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAsBywHLAcsBywHLAcsBywHLQcwAMEMyAwsBywHLAcsBywHLAcsBywHLAcsBywHzAwwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAHUAdQB1ANQM2QzhDDAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMABgAGAAYABgAGAAYABgAOkMYADxDGAA+AwADQYNYABhCWAAYAAODTAAMAAwADAAFg1gAGAAHg37AzAAMAAwADAAYABgACYNYAAsDTQNPA1gAEMNPg1LDWAAYABgAGAAYABgAGAAYABgAGAAUg1aDYsGVglhDV0NcQBnDW0NdQ15DWAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAlQCBDZUAiA2PDZcNMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAnw2nDTAAMAAwADAAMAAwAHUArw23DTAAMAAwADAAMAAwADAAMAAwADAAMAB1AL8NMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAB1AHUAdQB1AHUAdQDHDTAAYABgAM8NMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAA1w11ANwNMAAwAD0B5A0wADAAMAAwADAAMADsDfQN/A0EDgwOFA4wABsOMAAwADAAMAAwADAAMAAwANIG0gbSBtIG0gbSBtIG0gYjDigOwQUuDsEFMw7SBjoO0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGQg5KDlIOVg7SBtIGXg5lDm0OdQ7SBtIGfQ6EDooOjQ6UDtIGmg6hDtIG0gaoDqwO0ga0DrwO0gZgAGAAYADEDmAAYAAkBtIGzA5gANIOYADaDokO0gbSBt8O5w7SBu8O0gb1DvwO0gZgAGAAxA7SBtIG0gbSBtIGYABgAGAAYAAED2AAsAUMD9IG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGFA8sBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAccD9IGLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHJA8sBywHLAcsBywHLAccDywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywPLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAc0D9IG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAccD9IG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGFA8sBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHPA/SBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gYUD0QPlQCVAJUAMAAwADAAMACVAJUAlQCVAJUAlQCVAEwPMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAA//8EAAQABAAEAAQABAAEAAQABAANAAMAAQABAAIABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQACgATABcAHgAbABoAHgAXABYAEgAeABsAGAAPABgAHABLAEsASwBLAEsASwBLAEsASwBLABgAGAAeAB4AHgATAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQABYAGwASAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAWAA0AEQAeAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAFAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAJABYAGgAbABsAGwAeAB0AHQAeAE8AFwAeAA0AHgAeABoAGwBPAE8ADgBQAB0AHQAdAE8ATwAXAE8ATwBPABYAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAFAAUABQAFAAUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AHgAeAFAATwBAAE8ATwBPAEAATwBQAFAATwBQAB4AHgAeAB4AHgAeAB0AHQAdAB0AHgAdAB4ADgBQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgBQAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAJAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAkACQAJAAkACQAJAAkABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgAeAFAAHgAeAB4AKwArAFAAUABQAFAAGABQACsAKwArACsAHgAeAFAAHgBQAFAAUAArAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAUAAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAYAA0AKwArAB4AHgAbACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQADQAEAB4ABAAEAB4ABAAEABMABAArACsAKwArACsAKwArACsAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAKwArACsAKwBWAFYAVgBWAB4AHgArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AGgAaABoAGAAYAB4AHgAEAAQABAAEAAQABAAEAAQABAAEAAQAEwAEACsAEwATAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABLAEsASwBLAEsASwBLAEsASwBLABoAGQAZAB4AUABQAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQABMAUAAEAAQABAAEAAQABAAEAB4AHgAEAAQABAAEAAQABABQAFAABAAEAB4ABAAEAAQABABQAFAASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUAAeAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAFAABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQAUABQAB4AHgAYABMAUAArACsABAAbABsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAFAABAAEAAQABAAEAFAABAAEAAQAUAAEAAQABAAEAAQAKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAArACsAHgArAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAUAAEAAQABAAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAABAAEAA0ADQBLAEsASwBLAEsASwBLAEsASwBLAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAArAFAAUABQAFAAUABQAFAAUAArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUAArACsAKwBQAFAAUABQACsAKwAEAFAABAAEAAQABAAEAAQABAArACsABAAEACsAKwAEAAQABABQACsAKwArACsAKwArACsAKwAEACsAKwArACsAUABQACsAUABQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAFAAUAAaABoAUABQAFAAUABQAEwAHgAbAFAAHgAEACsAKwAEAAQABAArAFAAUABQAFAAUABQACsAKwArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQACsAUABQACsAKwAEACsABAAEAAQABAAEACsAKwArACsABAAEACsAKwAEAAQABAArACsAKwAEACsAKwArACsAKwArACsAUABQAFAAUAArAFAAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLAAQABABQAFAAUAAEAB4AKwArACsAKwArACsAKwArACsAKwAEAAQABAArAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQAFAAUABQACsAKwAEAFAABAAEAAQABAAEAAQABAAEACsABAAEAAQAKwAEAAQABAArACsAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAB4AGwArACsAKwArACsAKwArAFAABAAEAAQABAAEAAQAKwAEAAQABAArAFAAUABQAFAAUABQAFAAUAArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAArACsABAAEACsAKwAEAAQABAArACsAKwArACsAKwArAAQABAAEACsAKwArACsAUABQACsAUABQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAB4AUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArAAQAUAArAFAAUABQAFAAUABQACsAKwArAFAAUABQACsAUABQAFAAUAArACsAKwBQAFAAKwBQACsAUABQACsAKwArAFAAUAArACsAKwBQAFAAUAArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArAAQABAAEAAQABAArACsAKwAEAAQABAArAAQABAAEAAQAKwArAFAAKwArACsAKwArACsABAArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAHgAeAB4AHgAeAB4AGwAeACsAKwArACsAKwAEAAQABAAEAAQAUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAUAAEAAQABAAEAAQABAAEACsABAAEAAQAKwAEAAQABAAEACsAKwArACsAKwArACsABAAEACsAUABQAFAAKwArACsAKwArAFAAUAAEAAQAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAKwAOAFAAUABQAFAAUABQAFAAHgBQAAQABAAEAA4AUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAKwArAAQAUAAEAAQABAAEAAQABAAEACsABAAEAAQAKwAEAAQABAAEACsAKwArACsAKwArACsABAAEACsAKwArACsAKwArACsAUAArAFAAUAAEAAQAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwBQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAFAABAAEAAQABAAEAAQABAArAAQABAAEACsABAAEAAQABABQAB4AKwArACsAKwBQAFAAUAAEAFAAUABQAFAAUABQAFAAUABQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAFAAUABQAFAAUABQAFAAUABQABoAUABQAFAAUABQAFAAKwAEAAQABAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQACsAUAArACsAUABQAFAAUABQAFAAUAArACsAKwAEACsAKwArACsABAAEAAQABAAEAAQAKwAEACsABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArAAQABAAeACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAAqAFwAXAAqACoAKgAqACoAKgAqACsAKwArACsAGwBcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAeAEsASwBLAEsASwBLAEsASwBLAEsADQANACsAKwArACsAKwBcAFwAKwBcACsAXABcAFwAXABcACsAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACsAXAArAFwAXABcAFwAXABcAFwAXABcAFwAKgBcAFwAKgAqACoAKgAqACoAKgAqACoAXAArACsAXABcAFwAXABcACsAXAArACoAKgAqACoAKgAqACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwBcAFwAXABcAFAADgAOAA4ADgAeAA4ADgAJAA4ADgANAAkAEwATABMAEwATAAkAHgATAB4AHgAeAAQABAAeAB4AHgAeAB4AHgBLAEsASwBLAEsASwBLAEsASwBLAFAAUABQAFAAUABQAFAAUABQAFAADQAEAB4ABAAeAAQAFgARABYAEQAEAAQAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQADQAEAAQABAAEAAQADQAEAAQAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArAA0ADQAeAB4AHgAeAB4AHgAEAB4AHgAeAB4AHgAeACsAHgAeAA4ADgANAA4AHgAeAB4AHgAeAAkACQArACsAKwArACsAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgBcAEsASwBLAEsASwBLAEsASwBLAEsADQANAB4AHgAeAB4AXABcAFwAXABcAFwAKgAqACoAKgBcAFwAXABcACoAKgAqAFwAKgAqACoAXABcACoAKgAqACoAKgAqACoAXABcAFwAKgAqACoAKgBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAqACoAKgAqAFwAKgBLAEsASwBLAEsASwBLAEsASwBLACoAKgAqACoAKgAqAFAAUABQAFAAUABQACsAUAArACsAKwArACsAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgBQAFAAUABQAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUAArACsAUABQAFAAUABQAFAAUAArAFAAKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAKwBQACsAUABQAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsABAAEAAQAHgANAB4AHgAeAB4AHgAeAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUAArACsADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAANAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAWABEAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAA0ADQANAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAANAA0AKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUAArAAQABAArACsAKwArACsAKwArACsAKwArACsAKwBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqAA0ADQAVAFwADQAeAA0AGwBcACoAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwAeAB4AEwATAA0ADQAOAB4AEwATAB4ABAAEAAQACQArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUAAEAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAHgArACsAKwATABMASwBLAEsASwBLAEsASwBLAEsASwBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAArACsAXABcAFwAXABcACsAKwArACsAKwArACsAKwArACsAKwBcAFwAXABcAFwAXABcAFwAXABcAFwAXAArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAXAArACsAKwAqACoAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAArACsAHgAeAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAqACoAKwAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKwArAAQASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArACoAKgAqACoAKgAqACoAXAAqACoAKgAqACoAKgArACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABABQAFAAUABQAFAAUABQACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwANAA0AHgANAA0ADQANAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAEAAQAHgAeAB4AHgAeAB4AHgAeAB4AKwArACsABAAEAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwAeAB4AHgAeAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArAA0ADQANAA0ADQBLAEsASwBLAEsASwBLAEsASwBLACsAKwArAFAAUABQAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAA0ADQBQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUAAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArAAQABAAEAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAAQAUABQAFAAUABQAFAABABQAFAABAAEAAQAUAArACsAKwArACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsABAAEAAQABAAEAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAKwBQACsAUAArAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAB4AHgAeAB4AHgAeAB4AHgBQAB4AHgAeAFAAUABQACsAHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQACsAKwAeAB4AHgAeAB4AHgArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAFAAUABQACsAHgAeAB4AHgAeAB4AHgAOAB4AKwANAA0ADQANAA0ADQANAAkADQANAA0ACAAEAAsABAAEAA0ACQANAA0ADAAdAB0AHgAXABcAFgAXABcAFwAWABcAHQAdAB4AHgAUABQAFAANAAEAAQAEAAQABAAEAAQACQAaABoAGgAaABoAGgAaABoAHgAXABcAHQAVABUAHgAeAB4AHgAeAB4AGAAWABEAFQAVABUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ADQAeAA0ADQANAA0AHgANAA0ADQAHAB4AHgAeAB4AKwAEAAQABAAEAAQABAAEAAQABAAEAFAAUAArACsATwBQAFAAUABQAFAAHgAeAB4AFgARAE8AUABPAE8ATwBPAFAAUABQAFAAUAAeAB4AHgAWABEAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArABsAGwAbABsAGwAbABsAGgAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGgAbABsAGwAbABoAGwAbABoAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAHgAeAFAAGgAeAB0AHgBQAB4AGgAeAB4AHgAeAB4AHgAeAB4AHgBPAB4AUAAbAB4AHgBQAFAAUABQAFAAHgAeAB4AHQAdAB4AUAAeAFAAHgBQAB4AUABPAFAAUAAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAHgBQAFAAUABQAE8ATwBQAFAAUABQAFAATwBQAFAATwBQAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAFAAUABQAFAATwBPAE8ATwBPAE8ATwBPAE8ATwBQAFAAUABQAFAAUABQAFAAUAAeAB4AUABQAFAAUABPAB4AHgArACsAKwArAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHQAdAB4AHgAeAB0AHQAeAB4AHQAeAB4AHgAdAB4AHQAbABsAHgAdAB4AHgAeAB4AHQAeAB4AHQAdAB0AHQAeAB4AHQAeAB0AHgAdAB0AHQAdAB0AHQAeAB0AHgAeAB4AHgAeAB0AHQAdAB0AHgAeAB4AHgAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHgAeAB0AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHgAeAB0AHQAdAB0AHgAeAB0AHQAeAB4AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHQAeAB4AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAeAB4AHgAdAB4AHgAeAB4AHgAeAB4AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABYAEQAWABEAHgAeAB4AHgAeAB4AHQAeAB4AHgAeAB4AHgAeACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAWABEAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAFAAHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB4AHgAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAeAB4AHQAdAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHQAeAB0AHQAdAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB0AHQAeAB4AHQAdAB4AHgAeAB4AHQAdAB4AHgAeAB4AHQAdAB0AHgAeAB0AHgAeAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlAB4AHQAdAB4AHgAdAB4AHgAeAB4AHQAdAB4AHgAeAB4AJQAlAB0AHQAlAB4AJQAlACUAIAAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAeAB4AHgAeAB0AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHgAdAB0AHQAeAB0AJQAdAB0AHgAdAB0AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAdAB0AHQAdACUAHgAlACUAJQAdACUAJQAdAB0AHQAlACUAHQAdACUAHQAdACUAJQAlAB4AHQAeAB4AHgAeAB0AHQAlAB0AHQAdAB0AHQAdACUAJQAlACUAJQAdACUAJQAgACUAHQAdACUAJQAlACUAJQAlACUAJQAeAB4AHgAlACUAIAAgACAAIAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AFwAXABcAFwAXABcAHgATABMAJQAeAB4AHgAWABEAFgARABYAEQAWABEAFgARABYAEQAWABEATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABYAEQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAWABEAFgARABYAEQAWABEAFgARAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFgARABYAEQAWABEAFgARABYAEQAWABEAFgARABYAEQAWABEAFgARABYAEQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAWABEAFgARAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFgARAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAEAAQABAAeAB4AKwArACsAKwArABMADQANAA0AUAATAA0AUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAUAANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAA0ADQANAA0ADQANAA0ADQAeAA0AFgANAB4AHgAXABcAHgAeABcAFwAWABEAFgARABYAEQAWABEADQANAA0ADQATAFAADQANAB4ADQANAB4AHgAeAB4AHgAMAAwADQANAA0AHgANAA0AFgANAA0ADQANAA0ADQANAA0AHgANAB4ADQANAB4AHgAeACsAKwArACsAKwArACsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAKwArACsAKwArACsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArAA0AEQARACUAJQBHAFcAVwAWABEAFgARABYAEQAWABEAFgARACUAJQAWABEAFgARABYAEQAWABEAFQAWABEAEQAlAFcAVwBXAFcAVwBXAFcAVwBXAAQABAAEAAQABAAEACUAVwBXAFcAVwA2ACUAJQBXAFcAVwBHAEcAJQAlACUAKwBRAFcAUQBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFEAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBRAFcAUQBXAFEAVwBXAFcAVwBXAFcAUQBXAFcAVwBXAFcAVwBRAFEAKwArAAQABAAVABUARwBHAFcAFQBRAFcAUQBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBRAFcAVwBXAFcAVwBXAFEAUQBXAFcAVwBXABUAUQBHAEcAVwArACsAKwArACsAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwAlACUAVwBXAFcAVwAlACUAJQAlACUAJQAlACUAJQAlACsAKwArACsAKwArACsAKwArACsAKwArAFEAUQBRAFEAUQBRAFEAUQBRAFEAUQBRAFEAUQBRAFEAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBPAE8ATwBPAE8ATwBPAE8AJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAEcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAADQATAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABLAEsASwBLAEsASwBLAEsASwBLAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAABAAEAAQABAAeAAQABAAEAAQABAAEAAQABAAEAAQAHgBQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUABQAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAeAA0ADQANAA0ADQArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAB4AHgAeAB4AHgAeAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AUABQAFAAUABQAFAAUABQAFAAUABQAAQAUABQAFAABABQAFAAUABQAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAeAB4AHgAeAAQAKwArACsAUABQAFAAUABQAFAAHgAeABoAHgArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAADgAOABMAEwArACsAKwArACsAKwArACsABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwANAA0ASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAFAAUAAeAB4AHgBQAA4AUABQAAQAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAA0ADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArAB4AWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYACsAKwArAAQAHgAeAB4AHgAeAB4ADQANAA0AHgAeAB4AHgArAFAASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArAB4AHgBcAFwAXABcAFwAKgBcAFwAXABcAFwAXABcAFwAXABcAEsASwBLAEsASwBLAEsASwBLAEsAXABcAFwAXABcACsAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArAFAAUABQAAQAUABQAFAAUABQAFAAUABQAAQABAArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAHgANAA0ADQBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAXAAqACoAKgBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAAqAFwAKgAqACoAXABcACoAKgBcAFwAXABcAFwAKgAqAFwAKgBcACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcACoAKgBQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAA0ADQBQAFAAUAAEAAQAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUAArACsAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQADQAEAAQAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAVABVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBUAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVACsAKwArACsAKwArACsAKwArACsAKwArAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAKwArACsAKwBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAKwArACsAKwAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAKwArACsAKwArAFYABABWAFYAVgBWAFYAVgBWAFYAVgBWAB4AVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgArAFYAVgBWAFYAVgArAFYAKwBWAFYAKwBWAFYAKwBWAFYAVgBWAFYAVgBWAFYAVgBWAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAEQAWAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUAAaAB4AKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAGAARABEAGAAYABMAEwAWABEAFAArACsAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACUAJQAlACUAJQAWABEAFgARABYAEQAWABEAFgARABYAEQAlACUAFgARACUAJQAlACUAJQAlACUAEQAlABEAKwAVABUAEwATACUAFgARABYAEQAWABEAJQAlACUAJQAlACUAJQAlACsAJQAbABoAJQArACsAKwArAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAcAKwATACUAJQAbABoAJQAlABYAEQAlACUAEQAlABEAJQBXAFcAVwBXAFcAVwBXAFcAVwBXABUAFQAlACUAJQATACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXABYAJQARACUAJQAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwAWACUAEQAlABYAEQARABYAEQARABUAVwBRAFEAUQBRAFEAUQBRAFEAUQBRAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAEcARwArACsAVwBXAFcAVwBXAFcAKwArAFcAVwBXAFcAVwBXACsAKwBXAFcAVwBXAFcAVwArACsAVwBXAFcAKwArACsAGgAbACUAJQAlABsAGwArAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwAEAAQABAAQAB0AKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsADQANAA0AKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAAQAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAA0AUABQAFAAUAArACsAKwArAFAAUABQAFAAUABQAFAAUAANAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwAeACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAKwArAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUAArACsAKwBQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwANAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAUABQAFAAUABQAAQABAAEACsABAAEACsAKwArACsAKwAEAAQABAAEAFAAUABQAFAAKwBQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEACsAKwArACsABABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAA0ADQANAA0ADQANAA0ADQAeACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAArACsAKwArAFAAUABQAFAAUAANAA0ADQANAA0ADQAUACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsADQANAA0ADQANAA0ADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAAQABAAEAAQAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUAArAAQABAANACsAKwBQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAB4AHgAeAB4AHgArACsAKwArACsAKwAEAAQABAAEAAQABAAEAA0ADQAeAB4AHgAeAB4AKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwAeACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsASwBLAEsASwBLAEsASwBLAEsASwANAA0ADQANAFAABAAEAFAAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAeAA4AUAArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAADQANAB4ADQAEAAQABAAEAB4ABAAEAEsASwBLAEsASwBLAEsASwBLAEsAUAAOAFAADQANAA0AKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAANAA0AHgANAA0AHgAEACsAUABQAFAAUABQAFAAUAArAFAAKwBQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAA0AKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsABAAEAAQABAArAFAAUABQAFAAUABQAFAAUAArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQAFAAUABQACsABAAEAFAABAAEAAQABAAEAAQABAArACsABAAEACsAKwAEAAQABAArACsAUAArACsAKwArACsAKwAEACsAKwArACsAKwBQAFAAUABQAFAABAAEACsAKwAEAAQABAAEAAQABAAEACsAKwArAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAAQABABQAFAAUABQAA0ADQANAA0AHgBLAEsASwBLAEsASwBLAEsASwBLAA0ADQArAB4ABABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAAQABAAEAFAAUAAeAFAAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAArACsABAAEAAQABAAEAAQABAAEAAQADgANAA0AEwATAB4AHgAeAA0ADQANAA0ADQANAA0ADQANAA0ADQANAA0ADQANAFAAUABQAFAABAAEACsAKwAEAA0ADQAeAFAAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAFAAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKwArACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBcAFwADQANAA0AKgBQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAKwArAFAAKwArAFAAUABQAFAAUABQAFAAUAArAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQAKwAEAAQAKwArAAQABAAEAAQAUAAEAFAABAAEAA0ADQANACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAArACsABAAEAAQABAAEAAQABABQAA4AUAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAFAABAAEAAQABAAOAB4ADQANAA0ADQAOAB4ABAArACsAKwArACsAKwArACsAUAAEAAQABAAEAAQABAAEAAQABAAEAAQAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAA0ADQANAFAADgAOAA4ADQANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEACsABAAEAAQABAAEAAQABAAEAFAADQANAA0ADQANACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwAOABMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAArACsAKwAEACsABAAEACsABAAEAAQABAAEAAQABABQAAQAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAKwBQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQAKwAEAAQAKwAEAAQABAAEAAQAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAaABoAGgAaAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsADQANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAASABIAEgAQwBDAEMAUABQAFAAUABDAFAAUABQAEgAQwBIAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAASABDAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwAJAAkACQAJAAkACQAJABYAEQArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABIAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwANAA0AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEAAQABAANACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAA0ADQANAB4AHgAeAB4AHgAeAFAAUABQAFAADQAeACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAANAA0AHgAeACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwAEAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAARwBHABUARwAJACsAKwArACsAKwArACsAKwArACsAKwAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACsAKwArACsAKwArACsAKwBXAFcAVwBXAFcAVwBXAFcAVwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUQBRAFEAKwArACsAKwArACsAKwArACsAKwArACsAKwBRAFEAUQBRACsAKwArACsAKwArACsAKwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUAArACsAHgAEAAQADQAEAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArAB4AHgAeAB4AHgAeAB4AKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAAQABAAEAAQABAAeAB4AHgAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAB4AHgAEAAQABAAEAAQABAAEAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQAHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwBQAFAAKwArAFAAKwArAFAAUAArACsAUABQAFAAUAArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAUAArAFAAUABQAFAAUABQAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAHgAeAFAAUABQAFAAUAArAFAAKwArACsAUABQAFAAUABQAFAAUAArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeACsAKwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgAeAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgAeAB4AHgAeAB4ABAAeAB4AHgAeAB4AHgAeAB4AHgAeAAQAHgAeAA0ADQANAA0AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAAQABAAEAAQAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAEAAQAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArAAQABAAEAAQABAAEAAQAKwAEAAQAKwAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwAEAAQABAAEAAQABAAEAFAAUABQAFAAUABQAFAAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwBQAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArABsAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArAB4AHgAeAB4ABAAEAAQABAAEAAQABABQACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArABYAFgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAGgBQAFAAUAAaAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAKwBQACsAKwBQACsAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAKwBQACsAUAArACsAKwArACsAKwBQACsAKwArACsAUAArAFAAKwBQACsAUABQAFAAKwBQAFAAKwBQACsAKwBQACsAUAArAFAAKwBQACsAUAArAFAAUAArAFAAKwArAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUAArAFAAUABQAFAAKwBQACsAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAUABQAFAAKwBQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8AJQAlACUAHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB4AHgAeACUAJQAlAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAJQAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAlACUAJQAlACUAHgAlACUAJQAlACUAIAAgACAAJQAlACAAJQAlACAAIAAgACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACEAIQAhACEAIQAlACUAIAAgACUAJQAgACAAIAAgACAAIAAgACAAIAAgACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAJQAlACUAIAAlACUAJQAlACAAIAAgACUAIAAgACAAJQAlACUAJQAlACUAJQAgACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAlAB4AJQAeACUAJQAlACUAJQAgACUAJQAlACUAHgAlAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAJQAlACUAJQAgACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACAAIAAgACUAJQAlACAAIAAgACAAIAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABcAFwAXABUAFQAVAB4AHgAeAB4AJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAgACUAJQAlACUAJQAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAgACUAJQAgACUAJQAlACUAJQAlACUAJQAgACAAIAAgACAAIAAgACAAJQAlACUAJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAgACAAIAAgACAAIAAgACAAIAAgACUAJQAgACAAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAgACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAlACAAIAAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAgACAAIAAlACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAJQAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAKwArAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwAlACUAJQAlACUAJQAlACUAJQAlACUAVwBXACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAKwAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAA==';

    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [0x2329, 0xff08];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = '×';
    var BREAK_ALLOWED$1 = '÷';
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [AL, HL];
    var HARD_LINE_BREAKS = [BK, CR$1, LF$1, NL];
    var SPACE$1 = [SP, ZW];
    var PREFIX_POSTFIX = [PR, PO];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
    var HYPHEN = [HY, BA];
    var codePointsToCharacterClasses = function (codePoints, lineBreak) {
        if (lineBreak === void 0) { lineBreak = 'strict'; }
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function (codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            }
            else {
                categories.push(false);
            }
            if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
                // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
                if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) {
                return types.push(lineBreak === 'strict' ? NS : ID);
            }
            if (classType === SA) {
                return types.push(AL);
            }
            if (classType === AI) {
                return types.push(AL);
            }
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if ((codePoint >= 0x20000 && codePoint <= 0x2fffd) || (codePoint >= 0x30000 && codePoint <= 0x3fffd)) {
                    return types.push(ID);
                }
                else {
                    return types.push(AL);
                }
            }
            types.push(classType);
        });
        return [indices, types, categories];
    };
    var isAdjacentWithSpaceIgnored = function (a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while (i <= classTypes.length) {
                i++;
                var next = classTypes[i];
                if (next === b) {
                    return true;
                }
                if (next !== SP) {
                    break;
                }
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while (i > 0) {
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while (n <= classTypes.length) {
                        n++;
                        var next = classTypes[n];
                        if (next === b) {
                            return true;
                        }
                        if (next !== SP) {
                            break;
                        }
                    }
                }
                if (prev !== SP) {
                    break;
                }
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function (currentIndex, classTypes) {
        var i = currentIndex;
        while (i >= 0) {
            var type = classTypes[i];
            if (type === SP) {
                i--;
            }
            else {
                return type;
            }
        }
        return 0;
    };
    var _lineBreakAtIndex = function (codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) {
            return BREAK_NOT_ALLOWED$1;
        }
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
            return BREAK_NOT_ALLOWED$1;
        }
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
            return BREAK_MANDATORY;
        }
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
            return BREAK_ALLOWED$1;
        }
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB18 Break after spaces.
        if (current === SP) {
            return BREAK_ALLOWED$1;
        }
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) {
            return BREAK_ALLOWED$1;
        }
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB22 Do not break before ellipsis.
        if (next === IN) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23 Do not break between digits and letters.
        if ((ALPHABETICS.indexOf(next) !== -1 && current === NU) || (ALPHABETICS.indexOf(current) !== -1 && next === NU)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if ((current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
            ([ID, EB, EM].indexOf(current) !== -1 && next === PO)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if ((ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1) ||
            (PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (
        // (PR | PO) × ( OP | HY )? NU
        ([PR, PO].indexOf(current) !== -1 &&
            (next === NU || ([OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU))) ||
            // ( OP | HY ) × NU
            ([OP, HY].indexOf(current) !== -1 && next === NU) ||
            // NU ×	(NU | SY | IS)
            (current === NU && [NU, SY, IS].indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([PR, PO].indexOf(next) !== -1) {
            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // LB26 Do not break a Korean syllable.
        if ((JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
            ([JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1) ||
            ([JT, H3].indexOf(current) !== -1 && next === JT)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB27 Treat a Korean Syllable Block the same as ID.
        if ((KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1) ||
            (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if ((ALPHABETICS.concat(NU).indexOf(current) !== -1 &&
            next === OP &&
            ea_OP.indexOf(codePoints[afterIndex]) === -1) ||
            (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while (i > 0) {
                i--;
                if (classTypes[i] === RI$1) {
                    count++;
                }
                else {
                    break;
                }
            }
            if (count % 2 !== 0) {
                return BREAK_NOT_ALLOWED$1;
            }
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) {
            return BREAK_NOT_ALLOWED$1;
        }
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function (codePoints, options) {
        if (!options) {
            options = { lineBreak: 'normal', wordBreak: 'normal' };
        }
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
            classTypes = classTypes.map(function (type) { return ([NU, AL, SA].indexOf(type) !== -1 ? ID : type); });
        }
        var forbiddenBreakpoints = options.wordBreak === 'keep-all'
            ? isLetterNumber.map(function (letterNumber, i) {
                return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
            })
            : undefined;
        return [indicies, classTypes, forbiddenBreakpoints];
    };
    var Break = /** @class */ (function () {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function () {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }());
    var LineBreaker = function (str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function () {
                if (nextIndex >= length) {
                    return { done: true, value: null };
                }
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while (nextIndex < length &&
                    (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) ===
                        BREAK_NOT_ALLOWED$1) { }
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };

    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1 << 0;
    var FLAG_ID = 1 << 1;
    var FLAG_INTEGER = 1 << 2;
    var FLAG_NUMBER = 1 << 3;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function (codePoint) { return codePoint >= ZERO && codePoint <= 0x0039; };
    var isSurrogateCodePoint = function (codePoint) { return codePoint >= 0xd800 && codePoint <= 0xdfff; };
    var isHex = function (codePoint) {
        return isDigit(codePoint) || (codePoint >= A && codePoint <= F) || (codePoint >= a && codePoint <= f);
    };
    var isLowerCaseLetter = function (codePoint) { return codePoint >= a && codePoint <= z; };
    var isUpperCaseLetter = function (codePoint) { return codePoint >= A && codePoint <= Z; };
    var isLetter = function (codePoint) { return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint); };
    var isNonASCIICodePoint = function (codePoint) { return codePoint >= CONTROL; };
    var isWhiteSpace = function (codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function (codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function (codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function (codePoint) {
        return ((codePoint >= NULL && codePoint <= BACKSPACE) ||
            codePoint === LINE_TABULATION ||
            (codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE) ||
            codePoint === DELETE);
    };
    var isValidEscape = function (c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) {
            return false;
        }
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function (c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) {
            return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        }
        else if (isNameStartCodePoint(c1)) {
            return true;
        }
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
            return true;
        }
        return false;
    };
    var isNumberStart = function (c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) {
                return true;
            }
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) {
            return isDigit(c2);
        }
        return isDigit(c1);
    };
    var stringToNumber = function (codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                sign = -1;
            }
            c++;
        }
        var integers = [];
        while (isDigit(codePoints[c])) {
            integers.push(codePoints[c++]);
        }
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) {
            c++;
        }
        var fraction = [];
        while (isDigit(codePoints[c])) {
            fraction.push(codePoints[c++]);
        }
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) {
            c++;
        }
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                expsign = -1;
            }
            c++;
        }
        var exponent = [];
        while (isDigit(codePoints[c])) {
            exponent.push(codePoints[c++]);
        }
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */
    };
    var COMMA_TOKEN = { type: 4 /* COMMA_TOKEN */ };
    var SUFFIX_MATCH_TOKEN = { type: 13 /* SUFFIX_MATCH_TOKEN */ };
    var PREFIX_MATCH_TOKEN = { type: 8 /* PREFIX_MATCH_TOKEN */ };
    var COLUMN_TOKEN = { type: 21 /* COLUMN_TOKEN */ };
    var DASH_MATCH_TOKEN = { type: 9 /* DASH_MATCH_TOKEN */ };
    var INCLUDE_MATCH_TOKEN = { type: 10 /* INCLUDE_MATCH_TOKEN */ };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */
    };
    var SUBSTRING_MATCH_TOKEN = { type: 14 /* SUBSTRING_MATCH_TOKEN */ };
    var BAD_URL_TOKEN = { type: 23 /* BAD_URL_TOKEN */ };
    var BAD_STRING_TOKEN = { type: 1 /* BAD_STRING_TOKEN */ };
    var CDO_TOKEN = { type: 25 /* CDO_TOKEN */ };
    var CDC_TOKEN = { type: 24 /* CDC_TOKEN */ };
    var COLON_TOKEN = { type: 26 /* COLON_TOKEN */ };
    var SEMICOLON_TOKEN = { type: 27 /* SEMICOLON_TOKEN */ };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */
    };
    var WHITESPACE_TOKEN = { type: 31 /* WHITESPACE_TOKEN */ };
    var EOF_TOKEN = { type: 32 /* EOF_TOKEN */ };
    var Tokenizer = /** @class */ (function () {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function (chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function () {
            var tokens = [];
            var token = this.consumeToken();
            while (token !== EOF_TOKEN) {
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function () {
            var codePoint = this.consumeCodePoint();
            switch (codePoint) {
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return { type: 5 /* HASH_TOKEN */, value: value, flags: flags };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while (true) {
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) {
                                    return this.consumeToken();
                                }
                            }
                            if (c === EOF) {
                                return this.consumeToken();
                            }
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK &&
                        this.peekCodePoint(1) === HYPHEN_MINUS &&
                        this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return { type: 7 /* AT_KEYWORD_TOKEN */, value: value };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return { type: 6 /* DELIM_TOKEN */, value: fromCodePoint$1(codePoint) };
        };
        Tokenizer.prototype.consumeCodePoint = function () {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function (delta) {
            if (delta >= this._value.length) {
                return -1;
            }
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function () {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while (isHex(codePoint) && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while (codePoint === QUESTION_MARK && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? ZERO : digit); })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? F : digit); })), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start_1, end: end };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while (isHex(codePoint) && endDigits.length < 6) {
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: end };
            }
            else {
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: start };
            }
        };
        Tokenizer.prototype.consumeIdentLikeToken = function () {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            }
            else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return { type: 19 /* FUNCTION_TOKEN */, value: value };
            }
            return { type: 20 /* IDENT_TOKEN */, value: value };
        };
        Tokenizer.prototype.consumeUrlToken = function () {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) {
                return { type: 22 /* URL_TOKEN */, value: '' };
            }
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: stringToken.value };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                    return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                }
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === QUOTATION_MARK ||
                    codePoint === APOSTROPHE ||
                    codePoint === LEFT_PARENTHESIS ||
                    isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        value.push(this.consumeEscapedCodePoint());
                    }
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                }
                else {
                    value.push(codePoint);
                }
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function () {
            while (isWhiteSpace(this.peekCodePoint(0))) {
                this.consumeCodePoint();
            }
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function () {
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                    return;
                }
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    this.consumeEscapedCodePoint();
                }
            }
        };
        Tokenizer.prototype.consumeStringSlice = function (count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while (count > 0) {
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function (endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return { type: 0 /* STRING_TOKEN */, value: value };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        }
                        else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            } while (true);
        };
        Tokenizer.prototype.consumeNumber = function () {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
                repr.push(this.consumeCodePoint());
            }
            while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3)) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            return [stringToNumber(repr), type];
        };
        Tokenizer.prototype.consumeNumericToken = function () {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return { type: 15 /* DIMENSION_TOKEN */, number: number, flags: flags, unit: unit };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return { type: 16 /* PERCENTAGE_TOKEN */, number: number, flags: flags };
            }
            return { type: 17 /* NUMBER_TOKEN */, number: number, flags: flags };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function () {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
                    hex += fromCodePoint$1(this.consumeCodePoint());
                }
                if (isWhiteSpace(this.peekCodePoint(0))) {
                    this.consumeCodePoint();
                }
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
                    return REPLACEMENT_CHARACTER;
                }
                return hexCodePoint;
            }
            if (codePoint === EOF) {
                return REPLACEMENT_CHARACTER;
            }
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function () {
            var result = '';
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) {
                    result += fromCodePoint$1(codePoint);
                }
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    result += fromCodePoint$1(this.consumeEscapedCodePoint());
                }
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }());

    var Parser = /** @class */ (function () {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function (value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function (value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function (value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function () {
            var token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */) {
                token = this.consumeToken();
            }
            if (token.type === 32 /* EOF_TOKEN */) {
                throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            }
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do {
                token = this.consumeToken();
            } while (token.type === 31 /* WHITESPACE_TOKEN */);
            if (token.type === 32 /* EOF_TOKEN */) {
                return value;
            }
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function () {
            var values = [];
            while (true) {
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */) {
                    return values;
                }
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function () {
            var token = this.consumeToken();
            switch (token.type) {
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */:
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */:
                case 2 /* LEFT_PARENTHESIS_TOKEN */:
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */:
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function (type) {
            var block = { type: type, values: [] };
            var token = this.consumeToken();
            while (true) {
                if (token.type === 32 /* EOF_TOKEN */ || isEndingTokenFor(token, type)) {
                    return block;
                }
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function (functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */
            };
            while (true) {
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */ || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */) {
                    return cssFunction;
                }
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function () {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function (token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }());
    var isDimensionToken = function (token) { return token.type === 15 /* DIMENSION_TOKEN */; };
    var isNumberToken = function (token) { return token.type === 17 /* NUMBER_TOKEN */; };
    var isIdentToken = function (token) { return token.type === 20 /* IDENT_TOKEN */; };
    var isStringToken = function (token) { return token.type === 0 /* STRING_TOKEN */; };
    var isIdentWithValue = function (token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function (token) { return token.type !== 31 /* WHITESPACE_TOKEN */; };
    var nonFunctionArgSeparator = function (token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ && token.type !== 4 /* COMMA_TOKEN */;
    };
    var parseFunctionArgs = function (tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function (token) {
            if (token.type === 4 /* COMMA_TOKEN */) {
                if (arg.length === 0) {
                    throw new Error("Error parsing function args, zero tokens for arg");
                }
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */) {
                arg.push(token);
            }
        });
        if (arg.length) {
            args.push(arg);
        }
        return args;
    };
    var isEndingTokenFor = function (token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */ && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */) {
            return true;
        }
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */ && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */) {
            return true;
        }
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */ && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */;
    };

    var isLength = function (token) {
        return token.type === 17 /* NUMBER_TOKEN */ || token.type === 15 /* DIMENSION_TOKEN */;
    };

    var isLengthPercentage = function (token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */ || isLength(token);
    };
    var parseLengthPercentageTuple = function (tokens) {
        return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function (tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)];
    };
    var getAbsoluteValue = function (token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            return (token.number / 100) * parent;
        }
        if (isDimensionToken(token)) {
            switch (token.unit) {
                case 'rem':
                case 'em':
                    return 16 * token.number; // TODO use correct font-size
                case 'px':
                default:
                    return token.number;
            }
        }
        return token.number;
    };

    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit) {
                    case DEG:
                        return (Math.PI * value.number) / 180;
                    case GRAD:
                        return (Math.PI / 200) * value.number;
                    case RAD:
                        return value.number;
                    case TURN:
                        return Math.PI * 2 * value.number;
                }
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function (value) {
        if (value.type === 15 /* DIMENSION_TOKEN */) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
                return true;
            }
        }
        return false;
    };
    var parseNamedSide = function (tokens) {
        var sideOrCorner = tokens
            .filter(isIdentToken)
            .map(function (ident) { return ident.value; })
            .join(' ');
        switch (sideOrCorner) {
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [ZERO_LENGTH, ZERO_LENGTH];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [ZERO_LENGTH, HUNDRED_PERCENT];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [HUNDRED_PERCENT, HUNDRED_PERCENT];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [HUNDRED_PERCENT, ZERO_LENGTH];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function (deg) { return (Math.PI * deg) / 180; };

    var color$1 = {
        name: 'color',
        parse: function (context, value) {
            if (value.type === 18 /* FUNCTION */) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                }
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') {
                    return namedColor;
                }
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function (color) { return (0xff & color) === 0; };
    var asString = function (color) {
        var alpha = 0xff & color;
        var blue = 0xff & (color >> 8);
        var green = 0xff & (color >> 16);
        var red = 0xff & (color >> 24);
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function (r, g, b, a) {
        return ((r << 24) | (g << 16) | (b << 8) | (Math.round(a * 255) << 0)) >>> 0;
    };
    var getTokenColorValue = function (token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */) {
            return token.number;
        }
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? (token.number / 100) * max : Math.round((token.number / 100) * max);
        }
        return 0;
    };
    var rgb = function (_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) {
            hue += 1;
        }
        if (hue >= 1) {
            hue -= 1;
        }
        if (hue < 1 / 6) {
            return (t2 - t1) * hue * 6 + t1;
        }
        else if (hue < 1 / 2) {
            return t2;
        }
        else if (hue < 2 / 3) {
            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        }
        else {
            return t1;
        }
    }
    var hsl = function (context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */ ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) {
            return pack(l * 255, l * 255, l * 255, 1);
        }
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function (context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };

    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var parseColorStop = function (context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? { color: color, stop: stop } : { color: color, stop: null };
    };
    var processColorStops = function (stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) {
            first.stop = ZERO_LENGTH;
        }
        if (last.stop === null) {
            last.stop = HUNDRED_PERCENT;
        }
        var processStops = [];
        var previous = 0;
        for (var i = 0; i < stops.length; i++) {
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) {
                    processStops.push(absoluteValue);
                }
                else {
                    processStops.push(previous);
                }
                previous = absoluteValue;
            }
            else {
                processStops.push(null);
            }
        }
        var gapBegin = null;
        for (var i = 0; i < processStops.length; i++) {
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) {
                    gapBegin = i;
                }
            }
            else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for (var g = 1; g <= gapLength; g++) {
                    processStops[gapBegin + g - 1] = gapValue * g;
                }
                gapBegin = null;
            }
        }
        return stops.map(function (_a, i) {
            var color = _a.color;
            return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) };
        });
    };
    var getAngleFromCorner = function (corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function (angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
    };
    var distance = function (a, b) { return Math.sqrt(a * a + b * b); };
    var findCorner = function (width, height, x, y, closest) {
        var corners = [
            [0, 0],
            [0, height],
            [width, 0],
            [width, height]
        ];
        return corners.reduce(function (stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
                return {
                    optimumCorner: corner,
                    optimumDistance: d
                };
            }
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function (gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch (gradient.size) {
            case 0 /* CLOSEST_SIDE */:
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */:
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */:
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */:
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [rx, ry];
    };

    var linearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return { angle: angle$1, stops: stops, type: 1 /* LINEAR_GRADIENT */ };
    };

    var prefixLinearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ &&
                    ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */
        };
    };

    var webkitGradient = function (context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */;
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */;
                    return;
                }
                else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: ZERO_LENGTH, color: color });
                }
                else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: HUNDRED_PERCENT, color: color });
                }
                else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) {
                            stops.push({
                                stop: { type: 16 /* PERCENTAGE_TOKEN */, number: stop_1.number * 100, flags: stop_1.flags },
                                color: color
                            });
                        }
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */
            ? {
                angle: (angle + deg(180)) % deg(360),
                stops: stops,
                type: type
            }
            : { size: size, shape: shape, stops: stops, position: position, type: type };
    };

    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function (acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) {
                            switch (token.value) {
                                case 'center':
                                    position.push(FIFTY_PERCENT);
                                    return acc;
                                case 'top':
                                case 'left':
                                    position.push(ZERO_LENGTH);
                                    return acc;
                                case 'right':
                                case 'bottom':
                                    position.push(HUNDRED_PERCENT);
                                    return acc;
                            }
                        }
                        else if (isLengthPercentage(token) || isLength(token)) {
                            position.push(token);
                        }
                    }
                    else if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case 'at':
                                isAtPosition_1 = true;
                                return false;
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case COVER:
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var prefixRadialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return false;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return false;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return false;
                        }
                    }
                    else if (isLengthPercentage(token) || isLength(token)) {
                        position.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            else if (i === 1) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case COVER:
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var isLinearGradient = function (background) {
        return background.type === 1 /* LINEAR_GRADIENT */;
    };
    var isRadialGradient = function (background) {
        return background.type === 2 /* RADIAL_GRADIENT */;
    };
    var image = {
        name: 'image',
        parse: function (context, value) {
            if (value.type === 22 /* URL_TOKEN */) {
                var image_1 = { url: value.value, type: 0 /* URL */ };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                }
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return (!(value.type === 20 /* IDENT_TOKEN */ && value.value === 'none') &&
            (value.type !== 18 /* FUNCTION */ || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]));
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };

    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens
                .filter(function (value) { return nonFunctionArgSeparator(value) && isSupportedImage(value); })
                .map(function (value) { return image.parse(context, value); });
        }
    };

    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) { return values.filter(isLengthPercentage); })
                .map(parseLengthPercentageTuple);
        }
    };

    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) {
                return values
                    .filter(isIdentToken)
                    .map(function (token) { return token.value; })
                    .join(' ');
            })
                .map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function (value) {
        switch (value) {
            case 'no-repeat':
                return 1 /* NO_REPEAT */;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */;
            case 'repeat':
            default:
                return 0 /* REPEAT */;
        }
    };

    var BACKGROUND_SIZE;
    (function (BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens).map(function (values) { return values.filter(isBackgroundSizeInfoToken); });
        }
    };
    var isBackgroundSizeInfoToken = function (value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };

    var borderColorForSide = function (side) { return ({
        name: "border-" + side + "-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    }); };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');

    var borderRadiusForSide = function (side) { return ({
        name: "border-radius-" + side,
        initialValue: '0 0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
        }
    }); };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');

    var borderStyleForSide = function (side) { return ({
        name: "border-" + side + "-style",
        initialValue: 'solid',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, style) {
            switch (style) {
                case 'none':
                    return 0 /* NONE */;
                case 'dashed':
                    return 2 /* DASHED */;
                case 'dotted':
                    return 3 /* DOTTED */;
                case 'double':
                    return 4 /* DOUBLE */;
            }
            return 1 /* SOLID */;
        }
    }); };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');

    var borderWidthForSide = function (side) { return ({
        name: "border-" + side + "-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    }); };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');

    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, direction) {
            switch (direction) {
                case 'rtl':
                    return 1 /* RTL */;
                case 'ltr':
                default:
                    return 0 /* LTR */;
            }
        }
    };

    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function (bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */);
        }
    };
    var parseDisplayValue = function (display) {
        switch (display) {
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */;
            case 'inline':
                return 4 /* INLINE */;
            case 'run-in':
                return 8 /* RUN_IN */;
            case 'flow':
                return 16 /* FLOW */;
            case 'flow-root':
                return 32 /* FLOW_ROOT */;
            case 'table':
                return 64 /* TABLE */;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */;
            case 'ruby':
                return 512 /* RUBY */;
            case 'subgrid':
                return 1024 /* SUBGRID */;
            case 'list-item':
                return 2048 /* LIST_ITEM */;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */;
            case 'table-row':
                return 32768 /* TABLE_ROW */;
            case 'table-cell':
                return 65536 /* TABLE_CELL */;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */;
            case 'contents':
                return 16777216 /* CONTENTS */;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */;
        }
        return 0 /* NONE */;
    };

    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, float) {
            switch (float) {
                case 'left':
                    return 1 /* LEFT */;
                case 'right':
                    return 2 /* RIGHT */;
                case 'inline-start':
                    return 3 /* INLINE_START */;
                case 'inline-end':
                    return 4 /* INLINE_END */;
            }
            return 0 /* NONE */;
        }
    };

    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'normal') {
                return 0;
            }
            if (token.type === 17 /* NUMBER_TOKEN */) {
                return token.number;
            }
            if (token.type === 15 /* DIMENSION_TOKEN */) {
                return token.number;
            }
            return 0;
        }
    };

    var LINE_BREAK;
    (function (LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, lineBreak) {
            switch (lineBreak) {
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };

    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    };
    var computeLineHeight = function (token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') {
            return 1.2 * fontSize;
        }
        else if (token.type === 17 /* NUMBER_TOKEN */) {
            return fontSize * token.number;
        }
        else if (isLengthPercentage(token)) {
            return getAbsoluteValue(token, fontSize);
        }
        return fontSize;
    };

    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            return image.parse(context, token);
        }
    };

    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'inside':
                    return 0 /* INSIDE */;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */;
            }
        }
    };

    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, type) {
            switch (type) {
                case 'disc':
                    return 0 /* DISC */;
                case 'circle':
                    return 1 /* CIRCLE */;
                case 'square':
                    return 2 /* SQUARE */;
                case 'decimal':
                    return 3 /* DECIMAL */;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */;
                case 'armenian':
                    return 12 /* ARMENIAN */;
                case 'bengali':
                    return 13 /* BENGALI */;
                case 'cambodian':
                    return 14 /* CAMBODIAN */;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */;
                case 'devanagari':
                    return 18 /* DEVANAGARI */;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */;
                case 'georgian':
                    return 20 /* GEORGIAN */;
                case 'gujarati':
                    return 21 /* GUJARATI */;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */;
                case 'hebrew':
                    return 22 /* HEBREW */;
                case 'hiragana':
                    return 23 /* HIRAGANA */;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */;
                case 'kannada':
                    return 27 /* KANNADA */;
                case 'katakana':
                    return 28 /* KATAKANA */;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */;
                case 'khmer':
                    return 30 /* KHMER */;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */;
                case 'lao':
                    return 34 /* LAO */;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */;
                case 'malayalam':
                    return 36 /* MALAYALAM */;
                case 'mongolian':
                    return 37 /* MONGOLIAN */;
                case 'myanmar':
                    return 38 /* MYANMAR */;
                case 'oriya':
                    return 39 /* ORIYA */;
                case 'persian':
                    return 40 /* PERSIAN */;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */;
                case 'tamil':
                    return 43 /* TAMIL */;
                case 'telugu':
                    return 44 /* TELUGU */;
                case 'thai':
                    return 45 /* THAI */;
                case 'tibetan':
                    return 46 /* TIBETAN */;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */;
                case 'none':
                default:
                    return -1 /* NONE */;
            }
        }
    };

    var marginForSide = function (side) { return ({
        name: "margin-" + side,
        initialValue: '0',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    }); };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');

    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (overflow) {
                switch (overflow.value) {
                    case 'hidden':
                        return 1 /* HIDDEN */;
                    case 'scroll':
                        return 2 /* SCROLL */;
                    case 'clip':
                        return 3 /* CLIP */;
                    case 'auto':
                        return 4 /* AUTO */;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */;
                }
            });
        }
    };

    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'break-word':
                    return "break-word" /* BREAK_WORD */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var paddingForSide = function (side) { return ({
        name: "padding-" + side,
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length-percentage'
    }); };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');

    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textAlign) {
            switch (textAlign) {
                case 'right':
                    return 2 /* RIGHT */;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */;
                case 'left':
                default:
                    return 0 /* LEFT */;
            }
        }
    };

    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'relative':
                    return 1 /* RELATIVE */;
                case 'absolute':
                    return 2 /* ABSOLUTE */;
                case 'fixed':
                    return 3 /* FIXED */;
                case 'sticky':
                    return 4 /* STICKY */;
            }
            return 0 /* STATIC */;
        }
    };

    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else {
                            shadow.blur = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textTransform) {
            switch (textTransform) {
                case 'uppercase':
                    return 2 /* UPPERCASE */;
                case 'lowercase':
                    return 1 /* LOWERCASE */;
                case 'capitalize':
                    return 3 /* CAPITALIZE */;
            }
            return 0 /* NONE */;
        }
    };

    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            if (token.type === 18 /* FUNCTION */) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                }
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        var a1 = values[0], b1 = values[1]; values[2]; values[3]; var a2 = values[4], b2 = values[5]; values[6]; values[7]; values[8]; values[9]; values[10]; values[11]; var a4 = values[12], b4 = values[13]; values[14]; values[15];
        return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };

    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) {
                return DEFAULT;
            }
            return [origins[0], origins[1]];
        }
    };

    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, visibility) {
            switch (visibility) {
                case 'hidden':
                    return 1 /* HIDDEN */;
                case 'collapse':
                    return 2 /* COLLAPSE */;
                case 'visible':
                default:
                    return 0 /* VISIBLE */;
            }
        }
    };

    var WORD_BREAK;
    (function (WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, wordBreak) {
            switch (wordBreak) {
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };

    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */) {
                return { auto: true, order: 0 };
            }
            if (isNumberToken(token)) {
                return { auto: false, order: token.number };
            }
            throw new Error("Invalid z-index number parsed");
        }
    };

    var time = {
        name: 'time',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit.toLowerCase()) {
                    case 's':
                        return 1000 * value.number;
                    case 'ms':
                        return value.number;
                }
            }
            throw new Error("Unsupported time type");
        }
    };

    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            return 1;
        }
    };

    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens
                .filter(isIdentToken)
                .map(function (token) {
                switch (token.value) {
                    case 'underline':
                        return 1 /* UNDERLINE */;
                    case 'overline':
                        return 2 /* OVERLINE */;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */;
                    case 'none':
                        return 4 /* BLINK */;
                }
                return 0 /* NONE */;
            })
                .filter(function (line) { return line !== 0 /* NONE */; });
        }
    };

    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function (token) {
                switch (token.type) {
                    case 20 /* IDENT_TOKEN */:
                    case 0 /* STRING_TOKEN */:
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */:
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */:
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) {
                results.push(accumulator.join(' '));
            }
            return results.map(function (result) { return (result.indexOf(' ') === -1 ? result : "'" + result + "'"); });
        }
    };

    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length'
    };

    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            if (isIdentToken(token)) {
                switch (token.value) {
                    case 'bold':
                        return 700;
                    case 'normal':
                    default:
                        return 400;
                }
            }
            return 400;
        }
    };

    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (token) { return token.value; });
        }
    };

    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'oblique':
                    return "oblique" /* OBLIQUE */;
                case 'italic':
                    return "italic" /* ITALIC */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var contains = function (bit, value) { return (bit & value) !== 0; };

    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens;
        }
    };

    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({ counter: counter.value, increment: increment });
                }
            }
            return increments;
        }
    };

    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({ counter: counter.value, reset: reset });
                }
            }
            return resets;
        }
    };

    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (context, tokens) {
            return tokens.filter(isDimensionToken).map(function (token) { return time.parse(context, token); });
        }
    };

    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) {
                return null;
            }
            for (var i = 0; i < filtered.length; i += 2) {
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({ open: open_1, close: close_1 });
            }
            return quotes;
        }
    };
    var getQuote = function (quotes, depth, open) {
        if (!quotes) {
            return '';
        }
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) {
            return '';
        }
        return open ? quote.open : quote.close;
    };

    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) {
                        shadow.inset = true;
                    }
                    else if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else if (c === 2) {
                            shadow.blur = token;
                        }
                        else {
                            shadow.spread = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var DEFAULT_VALUE = [0 /* FILL */, 1 /* STROKE */, 2 /* MARKERS */];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function (token) {
                switch (token.value) {
                    case 'stroke':
                        layers.push(1 /* STROKE */);
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */);
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */);
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function (value) {
                if (layers.indexOf(value) === -1) {
                    layers.push(value);
                }
            });
            return layers;
        }
    };

    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    };

    var CSSParsedDeclaration = /** @class */ (function () {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function () {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */;
        };
        CSSParsedDeclaration.prototype.isTransparent = function () {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function () {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function () {
            return this.position !== 0 /* STATIC */;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function () {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function () {
            return this.float !== 0 /* NONE */;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function () {
            return (contains(this.display, 4 /* INLINE */) ||
                contains(this.display, 33554432 /* INLINE_BLOCK */) ||
                contains(this.display, 268435456 /* INLINE_FLEX */) ||
                contains(this.display, 536870912 /* INLINE_GRID */) ||
                contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
                contains(this.display, 134217728 /* INLINE_TABLE */));
        };
        return CSSParsedDeclaration;
    }());
    var CSSParsedPseudoDeclaration = /** @class */ (function () {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }());
    var CSSParsedCounterDeclaration = /** @class */ (function () {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function (context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch (descriptor.type) {
            case 2 /* IDENT_VALUE */:
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */:
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */:
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */:
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */:
                switch (descriptor.format) {
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };

    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function (element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch (attribute) {
            case 'all':
                return 1 /* ALL */;
            case 'clone':
                return 2 /* CLONE */;
            case 'parse':
                return 3 /* PARSE */;
            case 'render':
                return 4 /* RENDER */;
            default:
                return 0 /* NONE */;
        }
    };
    var isDebugging = function (element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */ || type === elementType;
    };

    var ElementContainer = /** @class */ (function () {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */)) {
                debugger;
            }
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function (duration) { return duration > 0; })) {
                    element.style.animationDuration = '0s';
                }
                if (this.styles.transform !== null) {
                    // getBoundingClientRect takes transforms into account
                    element.style.transform = 'none';
                }
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */)) {
                this.flags |= 16 /* DEBUG_RENDER */;
            }
        }
        return ElementContainer;
    }());

    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var base64 = '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';

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1 = 0; i$1 < chars$1.length; i$1++) {
        lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    }
    var decode = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function (base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16(view16, (headerLength + view32[4]) / 2)
            : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i = 0; i < chars.length; i++) {
        lookup[chars.charCodeAt(i)] = i;
    }

    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = '×';
    var BREAK_ALLOWED = '÷';
    var codePointToClass = function (codePoint) { return UnicodeTrie.get(codePoint); };
    var _graphemeBreakAtIndex = function (_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) {
            return BREAK_NOT_ALLOWED;
        }
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) {
            return BREAK_ALLOWED;
        }
        // GB5
        if (next === CR || next === LF || next === Control) {
            return BREAK_ALLOWED;
        }
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [L, V, LV, LVT].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) {
            return BREAK_NOT_ALLOWED;
        }
        // GB8
        if ((current === LVT || current === T) && next === T) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) {
            return BREAK_NOT_ALLOWED;
        }
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9a
        if (current === Prepend) {
            return BREAK_NOT_ALLOWED;
        }
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while (prev === Extend) {
                prev = classTypes[--prevIndex];
            }
            if (prev === Extended_Pictographic) {
                return BREAK_NOT_ALLOWED;
            }
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while (prev === RI) {
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) {
                return BREAK_NOT_ALLOWED;
            }
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function (str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function () {
                if (index >= length) {
                    return { done: true, value: null };
                }
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while (index < length &&
                    (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED) { }
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };
    var splitGraphemes = function (str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while (!(bk = breaker.next()).done) {
            if (bk.value) {
                graphemes.push(bk.value.slice());
            }
        }
        return graphemes;
    };

    var testRangeBounds = function (document) {
        var TEST_HEIGHT = 123;
        if (document.createRange) {
            var range = document.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) {
                    return true;
                }
            }
        }
        return false;
    };
    var testIOSLineBreak = function (document) {
        var testElement = document.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document.body.appendChild(testElement);
        var range = document.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function (i) { return fromCodePoint$1(i); });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function (text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) {
                return true;
            }
            return boundAhead;
        });
        document.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function () { return typeof new Image().crossOrigin !== 'undefined'; };
    var testResponseType = function () { return typeof new XMLHttpRequest().responseType === 'string'; };
    var testSVG = function (document) {
        var img = new Image();
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return false;
        }
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        }
        catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function (data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function (document) {
        var canvas = document.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return Promise.reject(false);
        }
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg)
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data)
                ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node))
                : Promise.reject(false);
        })
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        })
            .catch(function () { return false; });
    };
    var createForeignObjectSVG = function (width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () { return resolve(img); };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS() {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
            return value;
        },
        get SUPPORT_WORD_BREAKING() {
            var value = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', { value: value });
            return value;
        },
        get SUPPORT_SVG_DRAWING() {
            var value = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING() {
            var value = typeof Array.from === 'function' && typeof window.fetch === 'function'
                ? testForeignObject(document)
                : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_CORS_IMAGES() {
            var value = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
            return value;
        },
        get SUPPORT_RESPONSE_TYPE() {
            var value = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
            return value;
        },
        get SUPPORT_CORS_XHR() {
            var value = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
            return value;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', { value: value });
            return value;
        }
    };

    var TextBounds = /** @class */ (function () {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }());
    var parseTextBounds = function (context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function (text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function (subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    }
                    else {
                        textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                    }
                }
                else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            }
            else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
                node = node.splitText(text.length);
            }
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function (context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) {
                    parentNode.replaceChild(wrapper.firstChild, wrapper);
                }
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function (node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) {
            throw new Error('Node has no owner document');
        }
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function (value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, { granularity: 'grapheme' });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function (value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return breakWords(value, styles);
    };
    var breakText = function (value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [0x0020, 0x00a0, 0x1361, 0x10100, 0x10101, 0x1039, 0x1091];
    var breakWords = function (str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */ ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function () {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function (codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) {
                        word_1 += fromCodePoint$1(codePoint);
                    }
                    else {
                        if (word_1.length) {
                            words.push(word_1);
                        }
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) {
                    words.push(word_1);
                }
            }
        };
        while (!(bk = breaker.next()).done) {
            _loop_1();
        }
        return words;
    };

    var TextContainer = /** @class */ (function () {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }());
    var transform = function (text, transform) {
        switch (transform) {
            case 1 /* LOWERCASE */:
                return text.toLowerCase();
            case 3 /* CAPITALIZE */:
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */:
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function (m, p1, p2) {
        if (m.length > 0) {
            return p1 + p2.toUpperCase();
        }
        return m;
    };

    var ImageElementContainer = /** @class */ (function (_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer));

    var CanvasElementContainer = /** @class */ (function (_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer));

    var SVGElementContainer = /** @class */ (function (_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer));

    var LIElementContainer = /** @class */ (function (_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer));

    var OLElementContainer = /** @class */ (function (_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer));

    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function (bounds) {
        if (bounds.width > bounds.height) {
            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        }
        else if (bounds.width < bounds.height) {
            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        }
        return bounds;
    };
    var getInputValue = function (node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ (function (_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor =
                    _this.styles.borderRightColor =
                        _this.styles.borderBottomColor =
                            _this.styles.borderLeftColor =
                                0xa5a5a5ff;
                _this.styles.borderTopWidth =
                    _this.styles.borderRightWidth =
                        _this.styles.borderBottomWidth =
                            _this.styles.borderLeftWidth =
                                1;
                _this.styles.borderTopStyle =
                    _this.styles.borderRightStyle =
                        _this.styles.borderBottomStyle =
                            _this.styles.borderLeftStyle =
                                1 /* SOLID */;
                _this.styles.backgroundClip = [0 /* BORDER_BOX */];
                _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch (_this.type) {
                case CHECKBOX:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer));

    var SelectElementContainer = /** @class */ (function (_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer));

    var TextareaElementContainer = /** @class */ (function (_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer));

    var IFrameElementContainer = /** @class */ (function (_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow &&
                    iframe.contentWindow.document &&
                    iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor)
                        : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor)
                        ? isTransparent(bodyBackgroundColor)
                            ? _this.styles.backgroundColor
                            : bodyBackgroundColor
                        : documentBackgroundColor;
                }
            }
            catch (e) { }
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer));

    var LIST_OWNERS = ['OL', 'UL', 'MENU'];
    var parseNodeTree = function (context, node, parent, root) {
        for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
                parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            }
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) {
                    childNode.assignedNodes().forEach(function (childNode) { return parseNodeTree(context, childNode, parent, root); });
                }
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) {
                            container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
                        }
                        else if (createsStackingContext(container.styles)) {
                            container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
                        }
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                            container.flags |= 8 /* IS_LIST_OWNER */;
                        }
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) {
                            parseNodeTree(context, childNode.shadowRoot, container, root);
                        }
                        else if (!isTextareaElement(childNode) &&
                            !isSVGElement(childNode) &&
                            !isSelectElement(childNode)) {
                            parseNodeTree(context, childNode, container, root);
                        }
                    }
                }
            }
        }
    };
    var createContainer = function (context, element) {
        if (isImageElement(element)) {
            return new ImageElementContainer(context, element);
        }
        if (isCanvasElement(element)) {
            return new CanvasElementContainer(context, element);
        }
        if (isSVGElement(element)) {
            return new SVGElementContainer(context, element);
        }
        if (isLIElement(element)) {
            return new LIElementContainer(context, element);
        }
        if (isOLElement(element)) {
            return new OLElementContainer(context, element);
        }
        if (isInputElement(element)) {
            return new InputElementContainer(context, element);
        }
        if (isSelectElement(element)) {
            return new SelectElementContainer(context, element);
        }
        if (isTextareaElement(element)) {
            return new TextareaElementContainer(context, element);
        }
        if (isIFrameElement(element)) {
            return new IFrameElementContainer(context, element);
        }
        return new ElementContainer(context, element);
    };
    var parseTree = function (context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function (node, container, root) {
        return (container.styles.isPositionedWithZIndex() ||
            container.styles.opacity < 1 ||
            container.styles.isTransformed() ||
            (isBodyElement(node) && root.styles.isTransparent()));
    };
    var createsStackingContext = function (styles) { return styles.isPositioned() || styles.isFloating(); };
    var isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
    var isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    var isHTMLElementNode = function (node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function (element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function (node) { return node.tagName === 'LI'; };
    var isOLElement = function (node) { return node.tagName === 'OL'; };
    var isInputElement = function (node) { return node.tagName === 'INPUT'; };
    var isHTMLElement = function (node) { return node.tagName === 'HTML'; };
    var isSVGElement = function (node) { return node.tagName === 'svg'; };
    var isBodyElement = function (node) { return node.tagName === 'BODY'; };
    var isCanvasElement = function (node) { return node.tagName === 'CANVAS'; };
    var isVideoElement = function (node) { return node.tagName === 'VIDEO'; };
    var isImageElement = function (node) { return node.tagName === 'IMG'; };
    var isIFrameElement = function (node) { return node.tagName === 'IFRAME'; };
    var isStyleElement = function (node) { return node.tagName === 'STYLE'; };
    var isScriptElement = function (node) { return node.tagName === 'SCRIPT'; };
    var isTextareaElement = function (node) { return node.tagName === 'TEXTAREA'; };
    var isSelectElement = function (node) { return node.tagName === 'SELECT'; };
    var isSlotElement = function (node) { return node.tagName === 'SLOT'; };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function (node) { return node.tagName.indexOf('-') > 0; };

    var CounterState = /** @class */ (function () {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function (name) {
            var counter = this.counters[name];
            if (counter && counter.length) {
                return counter[counter.length - 1];
            }
            return 1;
        };
        CounterState.prototype.getCounterValues = function (name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function (counters) {
            var _this = this;
            counters.forEach(function (counter) { return _this.counters[counter].pop(); });
        };
        CounterState.prototype.parse = function (style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) {
                counterIncrement.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    if (counter && entry.increment !== 0) {
                        canReset = false;
                        if (!counter.length) {
                            counter.push(1);
                        }
                        counter[Math.max(0, counter.length - 1)] += entry.increment;
                    }
                });
            }
            var counterNames = [];
            if (canReset) {
                counterReset.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    counterNames.push(entry.counter);
                    if (!counter) {
                        counter = _this.counters[entry.counter] = [];
                    }
                    counter.push(entry.reset);
                });
            }
            return counterNames;
        };
        return CounterState;
    }());
    var ROMAN_UPPER = {
        integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
        values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
    };
    var ARMENIAN = {
        integers: [
            9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70,
            60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'Ք',
            'Փ',
            'Ւ',
            'Ց',
            'Ր',
            'Տ',
            'Վ',
            'Ս',
            'Ռ',
            'Ջ',
            'Պ',
            'Չ',
            'Ո',
            'Շ',
            'Ն',
            'Յ',
            'Մ',
            'Ճ',
            'Ղ',
            'Ձ',
            'Հ',
            'Կ',
            'Ծ',
            'Խ',
            'Լ',
            'Ի',
            'Ժ',
            'Թ',
            'Ը',
            'Է',
            'Զ',
            'Ե',
            'Դ',
            'Գ',
            'Բ',
            'Ա'
        ]
    };
    var HEBREW = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20,
            19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'י׳',
            'ט׳',
            'ח׳',
            'ז׳',
            'ו׳',
            'ה׳',
            'ד׳',
            'ג׳',
            'ב׳',
            'א׳',
            'ת',
            'ש',
            'ר',
            'ק',
            'צ',
            'פ',
            'ע',
            'ס',
            'נ',
            'מ',
            'ל',
            'כ',
            'יט',
            'יח',
            'יז',
            'טז',
            'טו',
            'י',
            'ט',
            'ח',
            'ז',
            'ו',
            'ה',
            'ד',
            'ג',
            'ב',
            'א'
        ]
    };
    var GEORGIAN = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90,
            80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'ჵ',
            'ჰ',
            'ჯ',
            'ჴ',
            'ხ',
            'ჭ',
            'წ',
            'ძ',
            'ც',
            'ჩ',
            'შ',
            'ყ',
            'ღ',
            'ქ',
            'ფ',
            'ჳ',
            'ტ',
            'ს',
            'რ',
            'ჟ',
            'პ',
            'ო',
            'ჲ',
            'ნ',
            'მ',
            'ლ',
            'კ',
            'ი',
            'თ',
            'ჱ',
            'ზ',
            'ვ',
            'ე',
            'დ',
            'გ',
            'ბ',
            'ა'
        ]
    };
    var createAdditiveCounter = function (value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) {
            return createCounterText(value, fallback, suffix.length > 0);
        }
        return (symbols.integers.reduce(function (string, integer, index) {
            while (value >= integer) {
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix);
    };
    var createCounterStyleWithSymbolResolver = function (value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) {
                value--;
            }
            string = resolver(value) + string;
            value /= codePointRangeLength;
        } while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function (value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return ((value < 0 ? '-' : '') +
            (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
                return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
            }) +
                suffix));
    };
    var createCounterStyleFromSymbols = function (value, symbols, suffix) {
        if (suffix === void 0) { suffix = '. '; }
        var codePointRangeLength = symbols.length;
        return (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) { return symbols[Math.floor(codePoint % codePointRangeLength)]; }) + suffix);
    };
    var CJK_ZEROS = 1 << 0;
    var CJK_TEN_COEFFICIENTS = 1 << 1;
    var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
    var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
    var createCJKCounter = function (value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) {
            return createCounterText(value, 4 /* CJK_DECIMAL */, suffix.length > 0);
        }
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) {
            return numbers[0] + string;
        }
        for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
                string = numbers[coefficient] + string;
            }
            else if (coefficient > 1 ||
                (coefficient === 1 && digit === 0) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS)) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100) ||
                (coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS))) {
                string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            }
            else if (coefficient === 1 && digit > 0) {
                string = multipliers[digit - 1] + string;
            }
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
    var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
    var JAPANESE_NEGATIVE = 'マイナス';
    var KOREAN_NEGATIVE = '마이너스';
    var createCounterText = function (value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? '、' : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch (type) {
            case 0 /* DISC */:
                return '•' + spaceSuffix;
            case 1 /* CIRCLE */:
                return '◦' + spaceSuffix;
            case 2 /* SQUARE */:
                return '◾' + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */:
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */:
                return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
            case 6 /* LOWER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix);
            case 8 /* LOWER_GREEK */:
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */:
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */:
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */:
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */:
            case 49 /* UPPER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix);
            case 35 /* LOWER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 13 /* BENGALI */:
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */:
            case 30 /* KHMER */:
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */:
                return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */:
                return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */:
            case 48 /* TRAD_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */:
                return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */:
                return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */:
                return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */:
                return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */:
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */:
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */, defaultSuffix);
            case 21 /* GUJARATI */:
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */:
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */:
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */, defaultSuffix);
            case 23 /* HIRAGANA */:
                return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
            case 24 /* HIRAGANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
            case 27 /* KANNADA */:
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */:
                return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
            case 29 /* KATAKANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
            case 34 /* LAO */:
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */:
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */:
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */:
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */:
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */:
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */:
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */:
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */:
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */:
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };

    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ (function () {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) {
                throw new Error('Cloned element does not have an owner document');
            }
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function (ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) {
                return Promise.reject("Unable to find iframe window");
            }
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */
            var iframeLoad = iframeLoader(iframe).then(function () { return __awaiter(_this, void 0, void 0, function () {
                var onclone, referenceElement;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.scrolledElements.forEach(restoreNodeScroll);
                            if (cloneWindow) {
                                cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) &&
                                    (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                    this.context.logger.warn('Unable to restore scroll position for cloned document');
                                    this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                }
                            }
                            onclone = this.options.onclone;
                            referenceElement = this.clonedReferenceElement;
                            if (typeof referenceElement === 'undefined') {
                                return [2 /*return*/, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                            }
                            if (!(documentClone.fonts && documentClone.fonts.ready)) return [3 /*break*/, 2];
                            return [4 /*yield*/, documentClone.fonts.ready];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [3 /*break*/, 4];
                            return [4 /*yield*/, imagesReady(documentClone)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            if (typeof onclone === 'function') {
                                return [2 /*return*/, Promise.resolve()
                                        .then(function () { return onclone(documentClone, referenceElement); })
                                        .then(function () { return iframe; })];
                            }
                            return [2 /*return*/, iframe];
                    }
                });
            }); });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function (node) {
            if (isDebugging(node, 2 /* CLONE */)) {
                debugger;
            }
            if (isCanvasElement(node)) {
                return this.createCanvasClone(node);
            }
            if (isVideoElement(node)) {
                return this.createVideoClone(node);
            }
            if (isStyleElement(node)) {
                return this.createStyleClone(node);
            }
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') {
                    clone.loading = 'eager';
                }
            }
            if (isCustomElement(clone)) {
                return this.createCustomElementClone(clone);
            }
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function (node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function (node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function (css, rule) {
                        if (rule && typeof rule.cssText === 'string') {
                            return css + rule.cssText;
                        }
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            }
            catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') {
                    throw e;
                }
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function (canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                }
                catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) {
                        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    }
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) {
                                this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                            }
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function (video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) {
                        ctx.getImageData(0, 0, canvas.width, canvas.height);
                    }
                }
                return canvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function (clone, child, copyStyles) {
            if (!isElementNode(child) ||
                (!isScriptElement(child) &&
                    !child.hasAttribute(IGNORE_ATTRIBUTE) &&
                    (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child)))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
                    clone.appendChild(this.cloneNode(child, copyStyles));
                }
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function (node, clone, copyStyles) {
            var _this = this;
            for (var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling) {
                if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                    var assignedNodes = child.assignedNodes();
                    if (assignedNodes.length) {
                        assignedNodes.forEach(function (assignedNode) { return _this.appendChildNode(clone, assignedNode, copyStyles); });
                    }
                }
                else {
                    this.appendChildNode(clone, child, copyStyles);
                }
            }
        };
        DocumentCloner.prototype.cloneNode = function (node, copyStyles) {
            if (isTextNode(node)) {
                return document.createTextNode(node.data);
            }
            if (!node.ownerDocument) {
                return node.cloneNode(false);
            }
            var window = node.ownerDocument.defaultView;
            if (window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window.getComputedStyle(node);
                var styleBefore = window.getComputedStyle(node, ':before');
                var styleAfter = window.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) {
                    this.clonedReferenceElement = clone;
                }
                if (isBodyElement(clone)) {
                    createPseudoHideStyles(clone);
                }
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) {
                    copyStyles = true;
                }
                if (!isVideoElement(node)) {
                    this.cloneChildNodes(node, clone, copyStyles);
                }
                if (before) {
                    clone.insertBefore(before, clone.firstChild);
                }
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) {
                    clone.appendChild(after);
                }
                this.counters.pop(counters);
                if ((style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node)) ||
                    copyStyles) {
                    copyCSSStyles(style, clone);
                }
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                if ((isTextareaElement(node) || isSelectElement(node)) &&
                    (isTextareaElement(clone) || isSelectElement(clone))) {
                    clone.value = node.value;
                }
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function (node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) {
                return;
            }
            var value = style.content;
            var document = clone.ownerDocument;
            if (!document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') {
                return;
            }
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function (token) {
                if (token.type === 0 /* STRING_TOKEN */) {
                    anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                }
                else if (token.type === 22 /* URL_TOKEN */) {
                    var img = document.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                }
                else if (token.type === 18 /* FUNCTION */) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) {
                            anonymousReplacedElement.appendChild(document.createTextNode(node.getAttribute(attr[0].value) || ''));
                        }
                    }
                    else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            anonymousReplacedElement.appendChild(document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    }
                    else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */ ? delim.value : '';
                            var text = counterStates
                                .map(function (value) { return createCounterText(value, counterType_1, false); })
                                .join(separator);
                            anonymousReplacedElement.appendChild(document.createTextNode(text));
                        }
                    }
                    else ;
                }
                else if (token.type === 20 /* IDENT_TOKEN */) {
                    switch (token.value) {
                        case 'open-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                            break;
                        case 'close-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                            break;
                        default:
                            // safari doesn't parse string tokens correctly because of lack of quotes
                            anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                    }
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE
                ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
                : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) {
                clone.className.baseValue += newClassName;
            }
            else {
                clone.className += newClassName;
            }
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function (container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }());
    var PseudoElementType;
    (function (PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function (ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function (img) {
        return new Promise(function (resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function (document) {
        return Promise.all([].slice.call(document.images, 0).map(imageReady));
    };
    var iframeLoader = function (iframe) {
        return new Promise(function (resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) {
                return reject("No window assigned for iframe");
            }
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function () {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function () {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function (style, target) {
        // Edge does not provide value for cssText
        for (var i = style.length - 1; i >= 0; i--) {
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) {
                target.style.setProperty(property, style.getPropertyValue(property));
            }
        }
        return target;
    };
    var serializeDoctype = function (doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) {
                str += doctype.name;
            }
            if (doctype.internalSubset) {
                str += doctype.internalSubset;
            }
            if (doctype.publicId) {
                str += "\"" + doctype.publicId + "\"";
            }
            if (doctype.systemId) {
                str += "\"" + doctype.systemId + "\"";
            }
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function (ownerDocument, x, y) {
        if (ownerDocument &&
            ownerDocument.defaultView &&
            (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x, y);
        }
    };
    var restoreNodeScroll = function (_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function (body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function (body, styles) {
        var document = body.ownerDocument;
        if (document) {
            var style = document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };

    var CacheStorage = /** @class */ (function () {
        function CacheStorage() {
        }
        CacheStorage.getOrigin = function (url) {
            var link = CacheStorage._link;
            if (!link) {
                return 'about:blank';
            }
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function (src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function (window) {
            CacheStorage._link = window.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }());
    var Cache = /** @class */ (function () {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function (src) {
            var result = Promise.resolve();
            if (this.has(src)) {
                return result;
            }
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function () {
                    // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function (src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) &&
                                !isSameOrigin &&
                                !isBlobImage(key) &&
                                typeof this._options.proxy === 'string' &&
                                FEATURES.SUPPORT_CORS_XHR &&
                                !useCORS;
                            if (!isSameOrigin &&
                                this._options.allowTaint === false &&
                                !isInlineImage(key) &&
                                !isBlobImage(key) &&
                                !useProxy &&
                                !useCORS) {
                                return [2 /*return*/];
                            }
                            src = key;
                            if (!useProxy) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.proxy(src)];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    var img = new Image();
                                    img.onload = function () { return resolve(img); };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) {
                                        img.crossOrigin = 'anonymous';
                                    }
                                    img.src = src;
                                    if (img.complete === true) {
                                        // Inline XML images may fail to parse, throwing an Error later on
                                        setTimeout(function () { return resolve(img); }, 500);
                                    }
                                    if (_this._options.imageTimeout > 0) {
                                        setTimeout(function () { return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image"); }, _this._options.imageTimeout);
                                    }
                                })];
                        case 3: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        Cache.prototype.has = function (key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function () {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function (src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) {
                throw new Error('No proxy defined');
            }
            var key = src.substring(0, 256);
            return new Promise(function (resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        if (responseType === 'text') {
                            resolve(xhr.response);
                        }
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function () { return resolve(reader_1.result); }, false);
                            reader_1.addEventListener('error', function (e) { return reject(e); }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    }
                    else {
                        reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                    }
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
                    xhr.responseType = responseType;
                }
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function () { return reject("Timed out (" + timeout_1 + "ms) proxying " + key); };
                }
                xhr.send();
            });
        };
        return Cache;
    }());
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function (src) { return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src); };
    var isInlineImage = function (src) { return INLINE_IMG.test(src); };
    var isInlineBase64Image = function (src) { return INLINE_BASE64.test(src); };
    var isBlobImage = function (src) { return src.substr(0, 4) === 'blob'; };
    var isSVG = function (src) { return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src); };

    var Vector = /** @class */ (function () {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function (deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }());

    var lerp = function (a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ (function () {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function (t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function (deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function () {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }());
    var isBezierCurve = function (path) { return path.type === 1 /* BEZIER_CURVE */; };

    var BoundCurves = /** @class */ (function () {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3, tlh - (borderLeftWidth * 2) / 3, tlv - (borderTopWidth * 2) / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.topRightBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + (borderTopWidth * 2) / 3, trh - (borderRightWidth * 2) / 3, trv - (borderTopWidth * 2) / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.bottomRightBorderDoubleInnerBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - (borderRightWidth * 2) / 3, brv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.bottomLeftBorderDoubleInnerBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + leftHeight, blh - (borderLeftWidth * 2) / 3, blv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.topLeftBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT)
                    : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }());
    var CORNER;
    (function (CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function (x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch (position) {
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function (curves) {
        return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
    };
    var calculateContentBoxPath = function (curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function (curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };

    var TransformEffect = /** @class */ (function () {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return TransformEffect;
    }());
    var ClipEffect = /** @class */ (function () {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */;
        }
        return ClipEffect;
    }());
    var OpacityEffect = /** @class */ (function () {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return OpacityEffect;
    }());
    var isTransformEffect = function (effect) {
        return effect.type === 0 /* TRANSFORM */;
    };
    var isClipEffect = function (effect) { return effect.type === 1 /* CLIP */; };
    var isOpacityEffect = function (effect) { return effect.type === 2 /* OPACITY */; };

    var equalPath = function (a, b) {
        if (a.length === b.length) {
            return a.some(function (v, i) { return v === b[i]; });
        }
        return false;
    };
    var transformPath = function (path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function (point, index) {
            switch (index) {
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };

    var StackingContext = /** @class */ (function () {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }());
    var ElementPaint = /** @class */ (function () {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) {
                this.effects.push(new OpacityEffect(this.container.styles.opacity));
            }
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */));
                }
            }
        }
        ElementPaint.prototype.getEffects = function (target) {
            var inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while (parent) {
                var croplessEffects = parent.effects.filter(function (effect) { return !isClipEffect(effect); });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */ || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) {
                            effects.unshift(new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                        }
                    }
                }
                else {
                    effects.unshift.apply(effects, croplessEffects);
                }
                parent = parent.parent;
            }
            return effects.filter(function (effect) { return contains(effect.target, target); });
        };
        return ElementPaint;
    }());
    var parseStackTree = function (parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function (child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */);
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */);
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
                listItems.push(paintContainer);
            }
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function (current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            }
                            else if (index_1 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    }
                    else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function (current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            }
                            else if (index_2 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    }
                    else {
                        parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                    }
                }
                else {
                    if (child.styles.isFloating()) {
                        parentStack.nonPositionedFloats.push(stack);
                    }
                    else {
                        parentStack.nonPositionedInlineLevel.push(stack);
                    }
                }
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            }
            else {
                if (child.styles.isInlineLevel()) {
                    stackingContext.inlineLevel.push(paintContainer);
                }
                else {
                    stackingContext.nonInlineLevel.push(paintContainer);
                }
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
                processListItems(child, listOwnerItems);
            }
        });
    };
    var processListItems = function (owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for (var i = 0; i < elements.length; i++) {
            var item = elements[i];
            if (item.container instanceof LIElementContainer &&
                typeof item.container.value === 'number' &&
                item.container.value !== 0) {
                numbering = item.container.value;
            }
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function (container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };

    var parsePathForBorder = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function (outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        return path;
    };
    var createPathFromCurves = function (outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        if (isBezierCurve(inner2)) {
            path.push(inner2.subdivide(0.5, true).reverse());
        }
        else {
            path.push(inner2);
        }
        if (isBezierCurve(inner1)) {
            path.push(inner1.subdivide(0.5, false).reverse());
        }
        else {
            path.push(inner1);
        }
        return path;
    };

    var paddingBox = function (element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function (element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };

    var calculateBackgroundPositioningArea = function (backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundOrigin === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function (backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundClip === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function (container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [path, offsetX, offsetY, sizeWidth, sizeHeight];
    };
    var isAuto = function (token) { return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO; };
    var hasIntrinsicValue = function (value) { return typeof value === 'number'; };
    var calculateBackgroundSize = function (size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) {
            return [0, 0];
        }
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
        }
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER)
                    ? [bounds.width, bounds.width / intrinsicProportion]
                    : [bounds.height * intrinsicProportion, bounds.height];
            }
            return [bounds.width, bounds.height];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) {
                return [intrinsicWidth, intrinsicHeight];
            }
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
                return [bounds.width, bounds.height];
            }
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth
                    ? intrinsicWidth
                    : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight
                    ? intrinsicHeight
                    : intrinsicWidth / intrinsicProportion;
                return [width_1, height_1];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [width_2, height_2];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) {
                width_3 = getAbsoluteValue(first, bounds.width);
            }
            else if (isLengthPercentage(second)) {
                height_3 = getAbsoluteValue(second, bounds.height);
            }
            if (isAuto(first)) {
                width_3 = height_3 * intrinsicProportion;
            }
            else if (!second || isAuto(second)) {
                height_3 = width_3 / intrinsicProportion;
            }
            return [width_3, height_3];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) {
            width = getAbsoluteValue(first, bounds.width);
        }
        else if (second && isLengthPercentage(second)) {
            height = getAbsoluteValue(second, bounds.height);
        }
        if (width !== null && (!second || isAuto(second))) {
            height =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (width / intrinsicWidth) * intrinsicHeight
                    : bounds.height;
        }
        if (height !== null && isAuto(first)) {
            width =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (height / intrinsicHeight) * intrinsicWidth
                    : bounds.width;
        }
        if (width !== null && height !== null) {
            return [width, height];
        }
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function (values, index) {
        var value = values[index];
        if (typeof value === 'undefined') {
            return values[0];
        }
        return value;
    };
    var calculateBackgroundRepeatPath = function (repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch (repeat) {
            case 2 /* REPEAT_X */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };

    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ (function () {
        function FontMetrics(document) {
            this._data = {};
            this._document = document;
        }
        FontMetrics.prototype.parseMetrics = function (fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return { baseline: baseline, middle: middle };
        };
        FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') {
                this._data[key] = this.parseMetrics(fontFamily, fontSize);
            }
            return this._data[key];
        };
        return FontMetrics;
    }());

    var Renderer = /** @class */ (function () {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }());

    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ (function (_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function (effects) {
            var _this = this;
            while (this._activeEffects.length) {
                this.popEffect();
            }
            effects.forEach(function (effect) { return _this.applyEffect(effect); });
        };
        CanvasRenderer.prototype.applyEffect = function (effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) {
                this.ctx.globalAlpha = effect.opacity;
            }
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function () {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var styles;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderStackContent(stack)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            if (!paint.container.styles.isVisible()) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.renderNodeContent(paint)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function (text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) {
                this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            }
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function (left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function (styles) {
            var fontVariant = styles.fontVariant
                .filter(function (variant) { return variant === 'normal' || variant === 'small-caps'; })
                .join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize)
                ? "" + styles.fontSize.number + styles.fontSize.unit
                : styles.fontSize.number + "px";
            return [
                [styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function (text, styles) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function (_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */ ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function (text) {
                        paintOrder.forEach(function (paintOrderLayer) {
                            switch (paintOrderLayer) {
                                case 0 /* FILL */:
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows
                                            .slice(0)
                                            .reverse()
                                            .forEach(function (textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function (textDecorationLine) {
                                            switch (textDecorationLine) {
                                                case 1 /* UNDERLINE */:
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */:
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */:
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */:
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function (container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderTextNode(child, styles)];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, this.context.cache.match(container.src)];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 8];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [3 /*break*/, 8];
                        case 8:
                            if (container instanceof CanvasElementContainer) {
                                this.renderReplacedElement(container, curves, container.canvas);
                            }
                            if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([9, 11, , 12]);
                            return [4 /*yield*/, this.context.cache.match(container.svg)];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 12];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [3 /*break*/, 12];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [3 /*break*/, 14];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [4 /*yield*/, iframeRenderer.render(container.tree)];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) {
                                this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            }
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                                else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch (container.styles.textAlign) {
                                    case 1 /* CENTER */:
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */:
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */)) return [3 /*break*/, 20];
                            if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */)) return [3 /*break*/, 18];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([15, 17, , 18]);
                            return [4 /*yield*/, this.context.cache.match(url)];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [3 /*break*/, 18];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [3 /*break*/, 18];
                        case 18: return [3 /*break*/, 20];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function (_p) {
                    switch (_p.label) {
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element)];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3 /*break*/, 5];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [3 /*break*/, 2];
                        case 5: 
                        // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                        return [4 /*yield*/, this.renderNodeContent(stack.element)];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [3 /*break*/, 10];
                            child = _c[_b];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [3 /*break*/, 7];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [3 /*break*/, 14];
                            child = _e[_d];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [3 /*break*/, 11];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [3 /*break*/, 18];
                            child = _g[_f];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [3 /*break*/, 15];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [3 /*break*/, 22];
                            child = _j[_h];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [3 /*break*/, 19];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [3 /*break*/, 26];
                            child = _l[_k];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [3 /*break*/, 23];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [3 /*break*/, 30];
                            child = _o[_m];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [3 /*break*/, 27];
                        case 30: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function (paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function (paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function (paths) {
            var _this = this;
            paths.forEach(function (point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) {
                    _this.ctx.moveTo(start.x, start.y);
                }
                else {
                    _this.ctx.lineTo(start.x, start.y);
                }
                if (isBezierCurve(point)) {
                    _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                }
            });
        };
        CanvasRenderer.prototype.renderRepeat = function (path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function (image, width, height) {
            var _a;
            if (image.width === width && image.height === height) {
                return image;
            }
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function (container) {
            return __awaiter(this, void 0, void 0, function () {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function (backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function (_h) {
                                    switch (_h.label) {
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */)) return [3 /*break*/, 5];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this_1.context.cache.match(url)];
                                        case 2:
                                            image = _h.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [3 /*break*/, 4];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [3 /*break*/, 6];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [null, null, null]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function (colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            }
                                            else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function (colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    }
                                                    else {
                                                        this_1.ctx.fill();
                                                    }
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            backgroundImage = _a[_i];
                            return [5 /*yield**/, _loop_1(backgroundImage)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function (color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function (color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                var outerPaths, innerPaths;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(width < 3)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderSolidBorder(color, side, curvePoints)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                { style: styles.borderTopStyle, color: styles.borderTopColor, width: styles.borderTopWidth },
                                { style: styles.borderRightStyle, color: styles.borderRightColor, width: styles.borderRightWidth },
                                { style: styles.borderBottomStyle, color: styles.borderBottomColor, width: styles.borderBottomWidth },
                                { style: styles.borderLeftStyle, color: styles.borderLeftColor, width: styles.borderLeftWidth }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [4 /*yield*/, this.renderBackgroundImage(paint.container)];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow
                                .slice(0)
                                .reverse()
                                .forEach(function (shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                }
                                else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [3 /*break*/, 13];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */ && !isTransparent(border.color) && border.width > 0)) return [3 /*break*/, 11];
                            if (!(border.style === 2 /* DASHED */)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */)];
                        case 4:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */)) return [3 /*break*/, 7];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */)];
                        case 6:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */)) return [3 /*break*/, 9];
                            return [4 /*yield*/, this.renderDoubleBorder(border.color, border.width, side, paint.curves)];
                        case 8:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 9: return [4 /*yield*/, this.renderSolidBorder(border.color, side, paint.curves)];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [3 /*break*/, 3];
                        case 13: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function (color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function () {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function (_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    }
                    else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    }
                    else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) {
                        length = Math.abs(startX - endX);
                    }
                    else {
                        length = Math.abs(startY - endY);
                    }
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */) {
                        this.formatPath(strokePaths);
                    }
                    else {
                        this.formatPath(boxPaths.slice(0, 2));
                    }
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) {
                        useLineDash = false;
                    }
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    }
                    else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength =
                            maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace)
                                ? minSpace
                                : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */) {
                            this.ctx.setLineDash([0, dashLength + spaceLength]);
                        }
                        else {
                            this.ctx.setLineDash([dashLength, spaceLength]);
                        }
                    }
                    if (style === 3 /* DOTTED */) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    }
                    else {
                        this.ctx.lineWidth = width * 2 + 1.1;
                    }
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var stack;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [4 /*yield*/, this.renderStack(stack)];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer));
    var isTextInputElement = function (container) {
        if (container instanceof TextareaElementContainer) {
            return true;
        }
        else if (container instanceof SelectElementContainer) {
            return true;
        }
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
            return true;
        }
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function (clip, curves) {
        switch (clip) {
            case 0 /* BORDER_BOX */:
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */:
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */:
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function (textAlign) {
        switch (textAlign) {
            case 1 /* CENTER */:
                return 'center';
            case 2 /* RIGHT */:
                return 'right';
            case 0 /* LEFT */:
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = ['-apple-system', 'system-ui'];
    var fixIOSSystemFonts = function (fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent)
            ? fontFamilies.filter(function (fontFamily) { return iOSBrokenFonts.indexOf(fontFamily) === -1; })
            : fontFamilies;
    };

    var ForeignObjectRenderer = /** @class */ (function (_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var svg, img;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [4 /*yield*/, loadSerializedSVG(svg)];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer));
    var loadSerializedSVG = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };

    var Logger = /** @class */ (function () {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') {
                    // eslint-disable-next-line no-console
                    console.debug.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.prototype.getTime = function () {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
                    // eslint-disable-next-line no-console
                    console.info.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') {
                    // eslint-disable-next-line no-console
                    console.warn.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') {
                    // eslint-disable-next-line no-console
                    console.error.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.instances = {};
        return Logger;
    }());

    var Context = /** @class */ (function () {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({ id: this.instanceName, enabled: options.logging });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }());

    var html2canvas = function (element, options) {
        if (options === void 0) { options = {}; }
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') {
        CacheStorage.setContext(window);
    }
    var renderElement = function (element, opts) { return __awaiter(void 0, void 0, void 0, function () {
        var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        return __generator(this, function (_u) {
            switch (_u.label) {
                case 0:
                    if (!element || typeof element !== 'object') {
                        return [2 /*return*/, Promise.reject('Invalid element provided as first argument')];
                    }
                    ownerDocument = element.ownerDocument;
                    if (!ownerDocument) {
                        throw new Error("Element is not attached to a Document");
                    }
                    defaultView = ownerDocument.defaultView;
                    if (!defaultView) {
                        throw new Error("Document is not attached to a Window");
                    }
                    resourceOptions = {
                        allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                        imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                        proxy: opts.proxy,
                        useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                    };
                    contextOptions = __assign({ logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true, cache: opts.cache }, resourceOptions);
                    windowOptions = {
                        windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                        windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                        scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                        scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                    };
                    windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                    context = new Context(contextOptions, windowBounds);
                    foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                    cloneOptions = {
                        allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                        onclone: opts.onclone,
                        ignoreElements: opts.ignoreElements,
                        inlineImages: foreignObjectRendering,
                        copyStyles: foreignObjectRendering
                    };
                    context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                    documentCloner = new DocumentCloner(context, element, cloneOptions);
                    clonedElement = documentCloner.clonedReferenceElement;
                    if (!clonedElement) {
                        return [2 /*return*/, Promise.reject("Unable to find element in cloned iframe")];
                    }
                    return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)];
                case 1:
                    container = _u.sent();
                    _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement)
                        ? parseDocumentSize(clonedElement.ownerDocument)
                        : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                    backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                    renderOptions = {
                        canvas: opts.canvas,
                        backgroundColor: backgroundColor,
                        scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                        x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                        y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                        width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                        height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                    };
                    if (!foreignObjectRendering) return [3 /*break*/, 3];
                    context.logger.debug("Document cloned, using foreign object rendering");
                    renderer = new ForeignObjectRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(clonedElement)];
                case 2:
                    canvas = _u.sent();
                    return [3 /*break*/, 5];
                case 3:
                    context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                    context.logger.debug("Starting DOM parsing");
                    root = parseTree(context, clonedElement);
                    if (backgroundColor === root.styles.backgroundColor) {
                        root.styles.backgroundColor = COLORS.TRANSPARENT;
                    }
                    context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                    renderer = new CanvasRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(root)];
                case 4:
                    canvas = _u.sent();
                    _u.label = 5;
                case 5:
                    if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                        if (!DocumentCloner.destroy(container)) {
                            context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                    }
                    context.logger.debug("Finished rendering");
                    return [2 /*return*/, canvas];
            }
        });
    }); };
    var parseBackgroundColor = function (context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement
            ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor)
            : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body
            ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor)
            : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string'
            ? parseColor(context, backgroundColorOverride)
            : backgroundColorOverride === null
                ? COLORS.TRANSPARENT
                : 0xffffffff;
        return element === ownerDocument.documentElement
            ? isTransparent(documentBackgroundColor)
                ? isTransparent(bodyBackgroundColor)
                    ? defaultBackgroundColor
                    : bodyBackgroundColor
                : documentBackgroundColor
            : defaultBackgroundColor;
    };

    return html2canvas;

})));
//# sourceMappingURL=html2canvas.js.map


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(63) && !__webpack_require__(51)(function () {
  return Object.defineProperty(__webpack_require__(369)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(56);


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(94);
var toIObject = __webpack_require__(95);
var arrayIndexOf = __webpack_require__(273)(false);
var IE_PROTO = __webpack_require__(371)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(66);
var anObject = __webpack_require__(45);
var getKeys = __webpack_require__(162);

module.exports = __webpack_require__(63) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(95);
var gOPN = __webpack_require__(165).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(63);
var getKeys = __webpack_require__(162);
var gOPS = __webpack_require__(274);
var pIE = __webpack_require__(228);
var toObject = __webpack_require__(70);
var IObject = __webpack_require__(227);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(51)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 547 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(81);
var isObject = __webpack_require__(52);
var invoke = __webpack_require__(549);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 549 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(49).parseInt;
var $trim = __webpack_require__(200).trim;
var ws = __webpack_require__(375);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(49).parseFloat;
var $trim = __webpack_require__(200).trim;

module.exports = 1 / $parseFloat(__webpack_require__(375) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(104);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(52);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 554 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(378);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(45);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(81);
var toObject = __webpack_require__(70);
var IObject = __webpack_require__(227);
var toLength = __webpack_require__(58);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(70);
var toAbsoluteIndex = __webpack_require__(163);
var toLength = __webpack_require__(58);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(390);
__webpack_require__(15)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(63) && /./g.flags != 'g') __webpack_require__(66).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(229)
});


/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(45);
var isObject = __webpack_require__(52);
var newPromiseCapability = __webpack_require__(394);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(565);
var validate = __webpack_require__(170);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(282)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(66).f;
var create = __webpack_require__(164);
var redefineAll = __webpack_require__(169);
var ctx = __webpack_require__(103);
var anInstance = __webpack_require__(167);
var forOf = __webpack_require__(168);
var $iterDefine = __webpack_require__(380);
var step = __webpack_require__(559);
var setSpecies = __webpack_require__(166);
var DESCRIPTORS = __webpack_require__(63);
var fastKey = __webpack_require__(145).fastKey;
var validate = __webpack_require__(170);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(565);
var validate = __webpack_require__(170);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(282)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(49);
var each = __webpack_require__(120)(0);
var redefine = __webpack_require__(91);
var meta = __webpack_require__(145);
var assign = __webpack_require__(546);
var weak = __webpack_require__(568);
var isObject = __webpack_require__(52);
var validate = __webpack_require__(170);
var NATIVE_WEAK_MAP = __webpack_require__(170);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(282)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(169);
var getWeak = __webpack_require__(145).getWeak;
var anObject = __webpack_require__(45);
var isObject = __webpack_require__(52);
var anInstance = __webpack_require__(167);
var forOf = __webpack_require__(168);
var createArrayMethod = __webpack_require__(120);
var $has = __webpack_require__(94);
var validate = __webpack_require__(170);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(105);
var toLength = __webpack_require__(58);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(165);
var gOPS = __webpack_require__(274);
var anObject = __webpack_require__(45);
var Reflect = __webpack_require__(49).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(275);
var isObject = __webpack_require__(52);
var toLength = __webpack_require__(58);
var ctx = __webpack_require__(103);
var IS_CONCAT_SPREADABLE = __webpack_require__(56)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(58);
var repeat = __webpack_require__(377);
var defined = __webpack_require__(118);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(63);
var getKeys = __webpack_require__(162);
var toIObject = __webpack_require__(95);
var isEnum = __webpack_require__(228).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(199);
var from = __webpack_require__(575);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(168);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 576 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

var utils = __webpack_require__(77);

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils.isPlainObject(data) || utils.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils.forEach(data, function each(value, key) {
        if (utils.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

module.exports = toFormData;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1329).Buffer))

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);
var settle = __webpack_require__(1333);
var cookies = __webpack_require__(1334);
var buildURL = __webpack_require__(578);
var buildFullPath = __webpack_require__(582);
var parseHeaders = __webpack_require__(1337);
var isURLSameOrigin = __webpack_require__(1338);
var transitionalDefaults = __webpack_require__(579);
var AxiosError = __webpack_require__(202);
var CanceledError = __webpack_require__(288);
var parseProtocol = __webpack_require__(1339);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(1335);
var combineURLs = __webpack_require__(1336);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports = {
  "version": "0.27.2"
};

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(19));

var _rcRate = _interopRequireDefault(__webpack_require__(1386));

var _omit = _interopRequireDefault(__webpack_require__(71));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _tooltip = _interopRequireDefault(__webpack_require__(87));

var _configProvider = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Rate = /*#__PURE__*/function (_React$Component) {
  _inherits(Rate, _React$Component);

  var _super = _createSuper(Rate);

  function Rate() {
    var _this;

    _classCallCheck(this, Rate);

    _this = _super.apply(this, arguments);

    _this.saveRate = function (node) {
      _this.rcRate = node;
    };

    _this.characterRender = function (node, _ref) {
      var index = _ref.index;
      var tooltips = _this.props.tooltips;
      if (!tooltips) return node;
      return /*#__PURE__*/React.createElement(_tooltip["default"], {
        title: tooltips[index]
      }, node);
    };

    _this.renderRate = function (_ref2) {
      var getPrefixCls = _ref2.getPrefixCls;

      var _a = _this.props,
          prefixCls = _a.prefixCls,
          restProps = __rest(_a, ["prefixCls"]);

      var rateProps = (0, _omit["default"])(restProps, ['tooltips']);
      return /*#__PURE__*/React.createElement(_rcRate["default"], _extends({
        ref: _this.saveRate,
        characterRender: _this.characterRender
      }, rateProps, {
        prefixCls: getPrefixCls('rate', prefixCls)
      }));
    };

    return _this;
  }

  _createClass(Rate, [{
    key: "focus",
    value: function focus() {
      this.rcRate.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.rcRate.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRate);
    }
  }]);

  return Rate;
}(React.Component);

exports["default"] = Rate;
Rate.propTypes = {
  prefixCls: PropTypes.string,
  character: PropTypes.node
};
Rate.defaultProps = {
  character: /*#__PURE__*/React.createElement(_icon["default"], {
    type: "star",
    theme: "filled"
  })
};

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(1390);

__webpack_require__(100);

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var customersData=exports.customersData=[{name:"官网渠道间夜数",mtd:0,date:"",occ:0,sold:0,sort:0},{name:"协议客户间夜数",mtd:0,date:"",occ:0,sold:0,sort:1},{name:"OTA间夜数",mtd:0,date:"",occ:0,sold:0,sort:2},{name:"Wholesale间夜数",mtd:0,date:"",occ:0,sold:0,sort:3},{name:"Package间夜数",mtd:0,date:"",occ:0,sold:0,sort:4},{name:"公司团队间夜数",mtd:0,date:"",occ:0,sold:0,sort:5},{name:"旅行团队间夜数",mtd:0,date:"",occ:0,sold:0,sort:6},{name:"其他间夜数",mtd:0,date:"",occ:0,sold:0,sort:7},{name:"当月维修房数",mtd:0,date:"",occ:0,sold:0,sort:8}];var foodData=exports.foodData=[{name:"餐饮部",project:"餐饮部总收入",act:0,bud:0,cop:0,af:0,f:0,sort:0},{name:"餐饮部",project:"宴会总收入",act:0,bud:0,cop:0,af:0,f:0,sort:1},{name:"餐饮部",project:"中餐厅收入",act:0,bud:0,cop:0,af:0,f:0,sort:2},{name:"餐饮部",project:"全日制餐厅收入",act:0,bud:0,cop:0,af:0,f:0,sort:3},{name:"餐饮部",project:"特色餐厅收入",act:0,bud:0,cop:0,af:0,f:0,sort:4},{name:"餐饮部",project:"客房送餐收入",act:0,bud:0,cop:0,af:0,f:0,sort:5}];var commentsData=exports.commentsData=[{name:"官网",order:0,comment:0,fraction:0,total:0,sort:0},{name:"携程",order:0,comment:0,fraction:0,total:0,sort:1},{name:"美团",order:0,comment:0,fraction:0,total:0,sort:2},{name:"飞猪",order:0,comment:0,fraction:0,total:0,sort:3},{name:"当月Medallia分数",order:0,comment:0,fraction:0,total:0,sort:4}];var platformData=exports.platformData=[{name:"美团大众点评（中餐厅）",order:"",comment:0,fraction:0,total:4.6,sort:0},{name:"美团大众点评（西餐厅）",order:"",comment:0,fraction:0,total:4.6,sort:1},{name:"美团大众点评（宴会厅）",order:"",comment:0,fraction:0,total:4.6,sort:2}];var submarketData=exports.submarketData=[{name1:"预订订单排名",value1:0,name2:"入住间夜排名",value2:0,name3:"新签协议份数MTD",value3:0,sort:0},{name1:"携程APP访客排名",value1:0,name2:"曝光人数排名",value2:0,name3:"协议订单量MTD",value3:0,sort:1},{name1:"携程APP转化率排名",value1:0,name2:"浏览器转化率排名",value2:0,name3:"本地协议单位",value3:0,sort:2},{name1:"PSI分排名",value1:0,name2:"支付转化率排名",value2:0,name3:"新签协议份数MTD",value3:0,sort:3},{name1:"点评分排名",value1:0,name2:"HOS排名",value2:0,name3:"协议订单量MTD",value3:0,sort:4}];

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(36);

var _rcUpload = _interopRequireDefault(__webpack_require__(1415));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _uniqBy = _interopRequireDefault(__webpack_require__(1422));

var _findIndex = _interopRequireDefault(__webpack_require__(1460));

var _UploadList = _interopRequireDefault(__webpack_require__(1463));

var _utils = __webpack_require__(601);

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(113));

var _default2 = _interopRequireDefault(__webpack_require__(219));

var _configProvider = __webpack_require__(39);

var _warning = _interopRequireDefault(__webpack_require__(69));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Upload = /*#__PURE__*/function (_React$Component) {
  _inherits(Upload, _React$Component);

  var _super = _createSuper(Upload);

  function Upload(props) {
    var _this;

    _classCallCheck(this, Upload);

    _this = _super.call(this, props);

    _this.saveUpload = function (node) {
      _this.upload = node;
    };

    _this.onStart = function (file) {
      var fileList = _this.state.fileList;
      var targetItem = (0, _utils.fileToObject)(file);
      targetItem.status = 'uploading';
      var nextFileList = fileList.concat();
      var fileIndex = (0, _findIndex["default"])(nextFileList, function (_ref) {
        var uid = _ref.uid;
        return uid === targetItem.uid;
      });

      if (fileIndex === -1) {
        nextFileList.push(targetItem);
      } else {
        nextFileList[fileIndex] = targetItem;
      }

      _this.onChange({
        file: targetItem,
        fileList: nextFileList
      }); // fix ie progress


      if (!window.File || Object({"NODE_ENV":"production","PUBLIC_URL":""}).TEST_IE) {
        _this.autoUpdateProgress(0, targetItem);
      }
    };

    _this.onSuccess = function (response, file, xhr) {
      _this.clearProgressTimer();

      try {
        if (typeof response === 'string') {
          response = JSON.parse(response);
        }
      } catch (e) {
        /* do nothing */
      }

      var fileList = _this.state.fileList;
      var targetItem = (0, _utils.getFileItem)(file, fileList); // removed

      if (!targetItem) {
        return;
      }

      targetItem.status = 'done';
      targetItem.response = response;
      targetItem.xhr = xhr;

      _this.onChange({
        file: _extends({}, targetItem),
        fileList: fileList
      });
    };

    _this.onProgress = function (e, file) {
      var fileList = _this.state.fileList;
      var targetItem = (0, _utils.getFileItem)(file, fileList); // removed

      if (!targetItem) {
        return;
      }

      targetItem.percent = e.percent;

      _this.onChange({
        event: e,
        file: _extends({}, targetItem),
        fileList: fileList
      });
    };

    _this.onError = function (error, response, file) {
      _this.clearProgressTimer();

      var fileList = _this.state.fileList;
      var targetItem = (0, _utils.getFileItem)(file, fileList); // removed

      if (!targetItem) {
        return;
      }

      targetItem.error = error;
      targetItem.response = response;
      targetItem.status = 'error';

      _this.onChange({
        file: _extends({}, targetItem),
        fileList: fileList
      });
    };

    _this.handleRemove = function (file) {
      var onRemove = _this.props.onRemove;
      var fileList = _this.state.fileList;
      Promise.resolve(typeof onRemove === 'function' ? onRemove(file) : onRemove).then(function (ret) {
        // Prevent removing file
        if (ret === false) {
          return;
        }

        var removedFileList = (0, _utils.removeFileItem)(file, fileList);

        if (removedFileList) {
          file.status = 'removed'; // eslint-disable-line

          if (_this.upload) {
            _this.upload.abort(file);
          }

          _this.onChange({
            file: file,
            fileList: removedFileList
          });
        }
      });
    };

    _this.onChange = function (info) {
      if (!('fileList' in _this.props)) {
        _this.setState({
          fileList: info.fileList
        });
      }

      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(info);
      }
    };

    _this.onFileDrop = function (e) {
      _this.setState({
        dragState: e.type
      });
    };

    _this.beforeUpload = function (file, fileList) {
      var beforeUpload = _this.props.beforeUpload;
      var stateFileList = _this.state.fileList;

      if (!beforeUpload) {
        return true;
      }

      var result = beforeUpload(file, fileList);

      if (result === false) {
        _this.onChange({
          file: file,
          fileList: (0, _uniqBy["default"])(stateFileList.concat(fileList.map(_utils.fileToObject)), function (item) {
            return item.uid;
          })
        });

        return false;
      }

      if (result && result.then) {
        return result;
      }

      return true;
    };

    _this.renderUploadList = function (locale) {
      var _this$props = _this.props,
          showUploadList = _this$props.showUploadList,
          listType = _this$props.listType,
          onPreview = _this$props.onPreview,
          onDownload = _this$props.onDownload,
          previewFile = _this$props.previewFile,
          disabled = _this$props.disabled,
          propLocale = _this$props.locale;
      var showRemoveIcon = showUploadList.showRemoveIcon,
          showPreviewIcon = showUploadList.showPreviewIcon,
          showDownloadIcon = showUploadList.showDownloadIcon;
      var fileList = _this.state.fileList;
      return /*#__PURE__*/React.createElement(_UploadList["default"], {
        listType: listType,
        items: fileList,
        previewFile: previewFile,
        onPreview: onPreview,
        onDownload: onDownload,
        onRemove: _this.handleRemove,
        showRemoveIcon: !disabled && showRemoveIcon,
        showPreviewIcon: showPreviewIcon,
        showDownloadIcon: showDownloadIcon,
        locale: _extends(_extends({}, locale), propLocale)
      });
    };

    _this.renderUpload = function (_ref2) {
      var _classNames2;

      var getPrefixCls = _ref2.getPrefixCls;
      var _this$props2 = _this.props,
          customizePrefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          showUploadList = _this$props2.showUploadList,
          listType = _this$props2.listType,
          type = _this$props2.type,
          disabled = _this$props2.disabled,
          children = _this$props2.children,
          style = _this$props2.style;
      var _this$state = _this.state,
          fileList = _this$state.fileList,
          dragState = _this$state.dragState;
      var prefixCls = getPrefixCls('upload', customizePrefixCls);

      var rcUploadProps = _extends(_extends({
        onStart: _this.onStart,
        onError: _this.onError,
        onProgress: _this.onProgress,
        onSuccess: _this.onSuccess
      }, _this.props), {
        prefixCls: prefixCls,
        beforeUpload: _this.beforeUpload
      });

      delete rcUploadProps.className;
      delete rcUploadProps.style; // Remove id to avoid open by label when trigger is hidden
      // !children: https://github.com/ant-design/ant-design/issues/14298
      // disabled: https://github.com/ant-design/ant-design/issues/16478
      //           https://github.com/ant-design/ant-design/issues/24197

      if (!children || disabled) {
        delete rcUploadProps.id;
      }

      var uploadList = showUploadList ? /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
        componentName: "Upload",
        defaultLocale: _default2["default"].Upload
      }, _this.renderUploadList) : null;

      if (type === 'drag') {
        var _classNames;

        var dragCls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-drag"), true), _defineProperty(_classNames, "".concat(prefixCls, "-drag-uploading"), fileList.some(function (file) {
          return file.status === 'uploading';
        })), _defineProperty(_classNames, "".concat(prefixCls, "-drag-hover"), dragState === 'dragover'), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames), className);
        return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
          className: dragCls,
          onDrop: _this.onFileDrop,
          onDragOver: _this.onFileDrop,
          onDragLeave: _this.onFileDrop,
          style: style
        }, /*#__PURE__*/React.createElement(_rcUpload["default"], _extends({}, rcUploadProps, {
          ref: _this.saveUpload,
          className: "".concat(prefixCls, "-btn")
        }), /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-drag-container")
        }, children))), uploadList);
      }

      var uploadButtonCls = (0, _classnames["default"])(prefixCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-select"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-select-").concat(listType), true), _defineProperty(_classNames2, "".concat(prefixCls, "-disabled"), disabled), _classNames2));
      var uploadButton = /*#__PURE__*/React.createElement("div", {
        className: uploadButtonCls,
        style: children ? undefined : {
          display: 'none'
        }
      }, /*#__PURE__*/React.createElement(_rcUpload["default"], _extends({}, rcUploadProps, {
        ref: _this.saveUpload
      })));

      if (listType === 'picture-card') {
        return /*#__PURE__*/React.createElement("span", {
          className: (0, _classnames["default"])(className, "".concat(prefixCls, "-picture-card-wrapper"))
        }, uploadList, uploadButton);
      }

      return /*#__PURE__*/React.createElement("span", {
        className: className
      }, uploadButton, uploadList);
    };

    _this.state = {
      fileList: props.fileList || props.defaultFileList || [],
      dragState: 'drop'
    };
    (0, _warning["default"])('fileList' in props || !('value' in props), 'Upload', '`value` is not validate prop, do you mean `fileList`?');
    return _this;
  }

  _createClass(Upload, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearProgressTimer();
    }
  }, {
    key: "clearProgressTimer",
    value: function clearProgressTimer() {
      clearInterval(this.progressTimer);
    }
  }, {
    key: "autoUpdateProgress",
    value: function autoUpdateProgress(_, file) {
      var _this2 = this;

      var getPercent = (0, _utils.genPercentAdd)();
      var curPercent = 0;
      this.clearProgressTimer();
      this.progressTimer = setInterval(function () {
        curPercent = getPercent(curPercent);

        _this2.onProgress({
          percent: curPercent * 100
        }, file);
      }, 200);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderUpload);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('fileList' in nextProps) {
        return {
          fileList: nextProps.fileList || []
        };
      }

      return null;
    }
  }]);

  return Upload;
}(React.Component);

Upload.defaultProps = {
  type: 'select',
  multiple: false,
  action: '',
  data: {},
  accept: '',
  beforeUpload: _utils.T,
  showUploadList: true,
  listType: 'text',
  className: '',
  disabled: false,
  supportServerRender: true
};
(0, _reactLifecyclesCompat.polyfill)(Upload);
var _default = Upload;
exports["default"] = _default;

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uid;
var now = +new Date();
var index = 0;

function uid() {
  return "rc-upload-" + now + "-" + ++index;
}

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1423),
    baseMatchesProperty = __webpack_require__(1445),
    identity = __webpack_require__(360),
    isArray = __webpack_require__(132),
    property = __webpack_require__(1449);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1425),
    isObjectLike = __webpack_require__(159);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(594),
    arraySome = __webpack_require__(1428),
    cacheHas = __webpack_require__(595);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(352),
    setCacheAdd = __webpack_require__(1426),
    setCacheHas = __webpack_require__(1427);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 595 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(517),
    baseKeys = __webpack_require__(1438),
    isArrayLike = __webpack_require__(268);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(158),
    root = __webpack_require__(101);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(116);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 599 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 600 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.T = T;
exports.fileToObject = fileToObject;
exports.genPercentAdd = genPercentAdd;
exports.getFileItem = getFileItem;
exports.removeFileItem = removeFileItem;
exports.previewImage = previewImage;
exports.isImageUrl = void 0;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function T() {
  return true;
} // Fix IE file.status problem
// via coping a new Object


function fileToObject(file) {
  return _extends(_extends({}, file), {
    lastModified: file.lastModified,
    lastModifiedDate: file.lastModifiedDate,
    name: file.name,
    size: file.size,
    type: file.type,
    uid: file.uid,
    percent: 0,
    originFileObj: file
  });
}
/**
 * 生成Progress percent: 0.1 -> 0.98
 *   - for ie
 */


function genPercentAdd() {
  var k = 0.1;
  var i = 0.01;
  var end = 0.98;
  return function (s) {
    var start = s;

    if (start >= end) {
      return start;
    }

    start += k;
    k -= i;

    if (k < 0.001) {
      k = 0.001;
    }

    return start;
  };
}

function getFileItem(file, fileList) {
  var matchKey = file.uid !== undefined ? 'uid' : 'name';
  return fileList.filter(function (item) {
    return item[matchKey] === file[matchKey];
  })[0];
}

function removeFileItem(file, fileList) {
  var matchKey = file.uid !== undefined ? 'uid' : 'name';
  var removed = fileList.filter(function (item) {
    return item[matchKey] !== file[matchKey];
  });

  if (removed.length === fileList.length) {
    return null;
  }

  return removed;
} // ==================== Default Image Preview ====================


var extname = function extname() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var temp = url.split('/');
  var filename = temp[temp.length - 1];
  var filenameWithoutSuffix = filename.split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [''])[0];
};

var isImageFileType = function isImageFileType(type) {
  return !!type && type.indexOf('image/') === 0;
};

var isImageUrl = function isImageUrl(file) {
  if (isImageFileType(file.type)) {
    return true;
  }

  var url = file.thumbUrl || file.url;
  var extension = extname(url);

  if (/^data:image\//.test(url) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico)$/i.test(extension)) {
    return true;
  }

  if (/^data:/.test(url)) {
    // other file types of base64
    return false;
  }

  if (extension) {
    // other file types which have extension
    return false;
  }

  return true;
};

exports.isImageUrl = isImageUrl;
var MEASURE_SIZE = 200;

function previewImage(file) {
  return new Promise(function (resolve) {
    if (!isImageFileType(file.type)) {
      resolve('');
      return;
    }

    var canvas = document.createElement('canvas');
    canvas.width = MEASURE_SIZE;
    canvas.height = MEASURE_SIZE;
    canvas.style.cssText = "position: fixed; left: 0; top: 0; width: ".concat(MEASURE_SIZE, "px; height: ").concat(MEASURE_SIZE, "px; z-index: 9999; display: none;");
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var img = new Image();

    img.onload = function () {
      var width = img.width,
          height = img.height;
      var drawWidth = MEASURE_SIZE;
      var drawHeight = MEASURE_SIZE;
      var offsetX = 0;
      var offsetY = 0;

      if (width < height) {
        drawHeight = height * (MEASURE_SIZE / width);
        offsetY = -(drawHeight - drawWidth) / 2;
      } else {
        drawWidth = width * (MEASURE_SIZE / height);
        offsetX = -(drawWidth - drawHeight) / 2;
      }

      ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
      var dataURL = canvas.toDataURL();
      document.body.removeChild(canvas);
      resolve(dataURL);
    };

    img.src = window.URL.createObjectURL(file);
  });
}

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _progress = _interopRequireDefault(__webpack_require__(1464));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _progress["default"];
exports["default"] = _default;

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var enhancer = function enhancer(WrappedComponent) {
  return /*#__PURE__*/function (_WrappedComponent) {
    _inherits(Progress, _WrappedComponent);

    var _super = _createSuper(Progress);

    function Progress() {
      _classCallCheck(this, Progress);

      return _super.apply(this, arguments);
    }

    _createClass(Progress, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var _this = this;

        var now = Date.now();
        var updated = false;
        Object.keys(this.paths).forEach(function (key) {
          var path = _this.paths[key];

          if (!path) {
            return;
          }

          updated = true;
          var pathStyle = path.style;
          pathStyle.transitionDuration = '.3s, .3s, .3s, .06s';

          if (_this.prevTimeStamp && now - _this.prevTimeStamp < 100) {
            pathStyle.transitionDuration = '0s, 0s';
          }
        });

        if (updated) {
          this.prevTimeStamp = Date.now();
        }
      }
    }, {
      key: "render",
      value: function render() {
        return _get(_getPrototypeOf(Progress.prototype), "render", this).call(this);
      }
    }]);

    return Progress;
  }(WrappedComponent);
};

/* harmony default export */ __webpack_exports__["a"] = (enhancer);

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return propTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var defaultProps = {
  className: '',
  percent: 0,
  prefixCls: 'rc-progress',
  strokeColor: '#2db7f5',
  strokeLinecap: 'round',
  strokeWidth: 1,
  style: {},
  trailColor: '#D9D9D9',
  trailWidth: 1
};
var mixedType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]);
var propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  percent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([mixedType, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(mixedType)]),
  prefixCls: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  strokeColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object])), __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object]),
  strokeLinecap: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['butt', 'round', 'square']),
  strokeWidth: mixedType,
  style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  trailColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  trailWidth: mixedType
};

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(1472);

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data1_3_default=exports.data1_3_default=[{name:'Rooms Revenue (+/-5%) <br />\u5BA2\u623F\u6536\u5165(\u6B63\u8D1F\u767E\u5206\u4E4B\u4E94\u8303\u56F4\u5185, \u5426\u5219\u9700\u8981\u505A\u51FA\u89E3\u91CA\uFF09',name_code:"Rooms_Revenue",mtd_percent:0,//月累计百分比
mtd_note:'',//月累计备注
ytd_percent:0,//年累计百分比
ytd_note:'',//年累计备注
threemonth_percent:0,//后三个月滚动预测
threemonth_note:'',//后三个月滚动预测备注
wholeyear_budget_percent:0,//整年预测对比预算百分比
wholeyear_budget_note:'',//整年预测对比预算备注
wholeyear_lastyear_percent:0,//整年预测对比去年百分比
wholeyear_lastyear_note:''//整年预测对比去年备注  
},{name:'F&B Revenue (+/-5%) <br />\u9910\u996E\u6536\u5165(\u6B63\u8D1F\u767E\u5206\u4E4B\u4E94\u8303\u56F4\u5185, \u5426\u5219\u9700\u8981\u505A\u51FA\u89E3\u91CA\uFF09',name_code:"FB_Revenue",mtd_percent:0,//月累计百分比
mtd_note:'',//月累计备注
ytd_percent:0,//年累计百分比
ytd_note:'',//年累计备注
threemonth_percent:0,//后三个月滚动预测
threemonth_note:'',//后三个月滚动预测备注
wholeyear_budget_percent:0,//整年预测对比预算百分比
wholeyear_budget_note:'',//整年预测对比预算备注
wholeyear_lastyear_percent:0,//整年预测对比去年百分比
wholeyear_lastyear_note:''//整年预测对比去年备注  
},{name:'Others Revenue (+/-5%) <br />\u5176\u4ED6\u6536\u5165(\u6B63\u8D1F\u767E\u5206\u4E4B\u4E94\u8303\u56F4\u5185, \u5426\u5219\u9700\u8981\u505A\u51FA\u89E3\u91CA\uFF09',name_code:"Others_Revenue",mtd_percent:0,//月累计百分比
mtd_note:'',//月累计备注
ytd_percent:0,//年累计百分比
ytd_note:'',//年累计备注
threemonth_percent:0,//后三个月滚动预测
threemonth_note:'',//后三个月滚动预测备注
wholeyear_budget_percent:0,//整年预测对比预算百分比
wholeyear_budget_note:'',//整年预测对比预算备注
wholeyear_lastyear_percent:0,//整年预测对比去年百分比
wholeyear_lastyear_note:''//整年预测对比去年备注  
},{name:'Total Revenue (+/-5%)<br />\u603B\u6536\u5165(\u6B63\u8D1F\u767E\u5206\u4E4B\u4E94\u8303\u56F4\u5185\uFF09(\u6B63\u8D1F\u767E\u5206\u4E4B\u4E94\u8303\u56F4\u5185, \u5426\u5219\u9700\u8981\u505A\u51FA\u89E3\u91CA',name_code:"Total_Revenue",mtd_percent:0,//月累计百分比
mtd_note:'',//月累计备注
ytd_percent:0,//年累计百分比
ytd_note:'',//年累计备注
threemonth_percent:0,//后三个月滚动预测
threemonth_note:'',//后三个月滚动预测备注
wholeyear_budget_percent:0,//整年预测对比预算百分比
wholeyear_budget_note:'',//整年预测对比预算备注
wholeyear_lastyear_percent:0,//整年预测对比去年百分比
wholeyear_lastyear_note:''//整年预测对比去年备注  
},{name:'Rooms Dep\'t Profit % <br />\u5BA2\u623F\u90E8\u95E8\u5229\u6DA6\u7387(\u5C0F\u4E8E\u767E\u5206\u4E4B\u4E03\u5341\u9700\u8981\u505A\u51FA\u89E3\u91CA\uFF09',name_code:"Rooms_Dept_Profit",mtd_percent:0,//月累计百分比
mtd_note:'',//月累计备注
ytd_percent:0,//年累计百分比
ytd_note:'',//年累计备注
threemonth_percent:0,//后三个月滚动预测
threemonth_note:'',//后三个月滚动预测备注
wholeyear_budget_percent:0,//整年预测对比预算百分比
wholeyear_budget_note:'',//整年预测对比预算备注
wholeyear_lastyear_percent:0,//整年预测对比去年百分比
wholeyear_lastyear_note:''//整年预测对比去年备注  
},{name:'F&B Dep\'t Profit %  <br />\u9910\u996E\u90E8\u95E8\u5229\u6DA6\u7387\uFF08\u5C0F\u4E8E\u767E\u5206\u4E4B\u4E09\u5341\u9700\u8981\u505A\u51FA\u89E3\u91CA\uFF09',name_code:"FB_Dept_Profit",mtd_percent:0,//月累计百分比
mtd_note:'',//月累计备注
ytd_percent:0,//年累计百分比
ytd_note:'',//年累计备注
threemonth_percent:0,//后三个月滚动预测
threemonth_note:'',//后三个月滚动预测备注
wholeyear_budget_percent:0,//整年预测对比预算百分比
wholeyear_budget_note:'',//整年预测对比预算备注
wholeyear_lastyear_percent:0,//整年预测对比去年百分比
wholeyear_lastyear_note:''//整年预测对比去年备注  
},{name:'F&B Total Cost % <br />\u98DF\u54C1\u53CA\u996E\u54C1\u6210\u672C\u7387\uFF08\u5927\u4E8E\u767E\u5206\u4E4B\u4E09\u5341\u4E94\u9700\u8981\u505A\u51FA\u89E3\u91CA\uFF09',name_code:"Revenue",mtd_percent:0,//月累计百分比
mtd_note:'',//月累计备注
ytd_percent:0,//年累计百分比
ytd_note:'',//年累计备注
threemonth_percent:0,//后三个月滚动预测
threemonth_note:'',//后三个月滚动预测备注
wholeyear_budget_percent:0,//整年预测对比预算百分比
wholeyear_budget_note:'',//整年预测对比预算备注
wholeyear_lastyear_percent:0,//整年预测对比去年百分比
wholeyear_lastyear_note:''//整年预测对比去年备注  
},{name:'Total Payroll Cost % <br />\u4EBA\u529B\u8D44\u6E90\u603B\u6210\u672C\u7387\uFF08\u5927\u4E8E\u767E\u5206\u4E4B\u4E09\u5341\u9700\u8981\u505A\u51FA\u89E3\u91CA\uFF09',name_code:"Total_Payroll_Cost",mtd_percent:0,//月累计百分比
mtd_note:'',//月累计备注
ytd_percent:0,//年累计百分比
ytd_note:'',//年累计备注
threemonth_percent:0,//后三个月滚动预测
threemonth_note:'',//后三个月滚动预测备注
wholeyear_budget_percent:0,//整年预测对比预算百分比
wholeyear_budget_note:'',//整年预测对比预算备注
wholeyear_lastyear_percent:0,//整年预测对比去年百分比
wholeyear_lastyear_note:''//整年预测对比去年备注  
},{name:'Utility Cost %  (>10%, Act>Fcst or LY) <br />\u80FD\u6E90\u6210\u672C\u7387\uFF08\u5927\u4E8E\u767E\u5206\u4E4B\u5341\u9700\u8981\u505A\u51FA\u89E3\u91CA\uFF09',name_code:"Utility_Cost",mtd_percent:0,//月累计百分比
mtd_note:'',//月累计备注
ytd_percent:0,//年累计百分比
ytd_note:'',//年累计备注
threemonth_percent:0,//后三个月滚动预测
threemonth_note:'',//后三个月滚动预测备注
wholeyear_budget_percent:0,//整年预测对比预算百分比
wholeyear_budget_note:'',//整年预测对比预算备注
wholeyear_lastyear_percent:0,//整年预测对比去年百分比
wholeyear_lastyear_note:''//整年预测对比去年备注  
},{name:'Other Expense and Cost  (+/-5%) <br />\u5176\u4ED6\u8D39\u7528\u53CA\u6210\u672C(\u6B63\u8D1F\u767E\u5206\u4E4B\u4E94\u8303\u56F4\u5185\uFF09',name_code:"Other_Expense_Cost",mtd_percent:0,//月累计百分比
mtd_note:'',//月累计备注
ytd_percent:0,//年累计百分比
ytd_note:'',//年累计备注
threemonth_percent:0,//后三个月滚动预测
threemonth_note:'',//后三个月滚动预测备注
wholeyear_budget_percent:0,//整年预测对比预算百分比
wholeyear_budget_note:'',//整年预测对比预算备注
wholeyear_lastyear_percent:0,//整年预测对比去年百分比
wholeyear_lastyear_note:''//整年预测对比去年备注  
},{name:'GOP % <br />\u7ECF\u8425\u6BDB\u5229\u7387\uFF08\u82E5\u662F\u5B9E\u9645\u4E0D\u80FD\u8FBE\u5230\u6807\u51C6\u8FB9\u9645\u5229\u6DA6\u7387\u5219\u9700\u51FA\u89E3\u91CA\uFF09',name_code:"GOP",mtd_percent:0,//月累计百分比
mtd_note:'',//月累计备注
ytd_percent:0,//年累计百分比
ytd_note:'',//年累计备注
threemonth_percent:0,//后三个月滚动预测
threemonth_note:'',//后三个月滚动预测备注
wholeyear_budget_percent:0,//整年预测对比预算百分比
wholeyear_budget_note:'',//整年预测对比预算备注
wholeyear_lastyear_percent:0,//整年预测对比去年百分比
wholeyear_lastyear_note:''//整年预测对比去年备注  
},{name:'Standard Flow Thru',name_code:"Standard_Flow_Thru",mtd_percent:0,//月累计百分比
mtd_note:'',//月累计备注
ytd_percent:0,//年累计百分比
ytd_note:'',//年累计备注
threemonth_percent:0,//后三个月滚动预测
threemonth_note:'',//后三个月滚动预测备注
wholeyear_budget_percent:0,//整年预测对比预算百分比
wholeyear_budget_note:'',//整年预测对比预算备注
wholeyear_lastyear_percent:0,//整年预测对比去年百分比
wholeyear_lastyear_note:''//整年预测对比去年备注  
}];

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data1_1=exports.data1_1=[{name:'Total Rooms Available 可供出租客房数',name_code:"Rooms_Available",actual:0,//实际
prediction:0,//预测
budget:0,//预算
last_year:0,//去年
actual_prediction:0,//实际对比预测
actual_budget:0,//实际对比预算
actual_last_year:0,//实际对比去年
year_actual:0,//年累计 实际
year_budget:0,//年累计 预算
year_last_year:0,//年累计 去年
year_actual_budget:0,//年累计 实际对比预算
year_actual_last_year:0,//年累计 实际对比去年
three_actual:0,//三个月滚动预测 实际
three_budget:0,//三个月滚动预测 预算
three_last_year:0,//三个月滚动预测 去年
three_actual_budget:0,//三个月滚动预测 实际对比预算
three_actual_last_year:0,//三个月滚动预测 实际对比去年
whole_actual:0,//整年预测 实际
whole_budget:0,//整年预测 预算
whole_last_year:0,//整年预测 去年
whole_actual_budget:0,//整年预测 实际对比预算
whole_actual_last_year:0//整年预测 实际对比去年
},{name:'Rooms Occupied 实际入住客房数',name_code:"Rooms_Occupied",actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:'Occupancy % 平均出租率',name_code:"Occupancy",actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:'Average Room Rate 平均房价',name_code:"Average_Room_Rate",actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:'RevPAR 每间可供出租客房收入',name_code:"RevPAR",actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:'Rooms Revenue 客房收入',name_code:"Rooms_Revenue",actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:'F&B Revenue 餐饮收入',name_code:"F&B_Revenue",actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:'Other Operated Departments 其它营运部门收入',name_code:"Other_Revenue",actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:'Total Dept. Revenue 总收入',name_code:"Total_Revenue",actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"Rooms Dept. Profit (Loss) 客房部门盈利（亏损）",name_code:'Rooms_Dep\'t_Profit',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"Rooms Dept. Profit % of Dept. Rev. 客房部门盈利（亏损）占部门收入百分比",name_code:'Rooms_Dep\'t_Profit_%',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"F&B Dept. Profit (Loss) 餐饮部门盈利（亏损）",name_code:'F&B_Dep\'t_Profit',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"F&B Dept. Profit % of Dept. Rev. 餐饮部门盈利（亏损）占部门收入百分比",name_code:'F&B_Dep\'t_Profit_%',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"Total Cost of Food and Beverage Sales 餐饮成本",name_code:'F&B_Total_Cost',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"Total Cost of Food and Beverage Sales % of Dept. Rev. 餐饮成本占部门收入百分比",name_code:'F&B_Total_Cost_%',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"Total Dept. Labor Costs and Related Expenses 所有部门总工资福利",name_code:'Total_Payroll_Expense',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"Total Dept. Labor Costs and Related Expenses % of Total Dept. Rev. 所有部门总工资福利占总收入百分比",name_code:'Total_Payroll_Expense_%',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"Utility Cost 能源成本",name_code:'Utility_Cost',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"Utility Cost % of Total Dept. Rev. 能源成本占总收入百分比",name_code:'Utility_Cost_%',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"Other Expense and Cost 其他费用及成本",name_code:'Other_Expense_and_Cost',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"Other Expense and Cost % 其他费用及成本率",name_code:'Other_Expense_and_Cost_%',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"Gross Operating Profit (Loss) 总毛利润(亏损)",name_code:'GOP',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"GOP % of Total Rev. 总毛利润（亏损）占总收入百分比",name_code:'GOP_%',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"Breakeven Point 盈亏平衡点",name_code:'Breakeven_Point/Total_Exp',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"Flow Thru 边际盈利率",name_code:'Flow_Thru',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"Base Fee 基本管理费",name_code:'Base_Fee',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"Brand Service Fee 品牌服务费",name_code:'Brand_Service_Fee',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"Incentive Fee 奖励管理费",name_code:'Incentive_Fee',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"Total Fee 总收费",name_code:'Total_Fee',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"Complimentary Room 免费房",name_code:'Complimentary_Room',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"House Use 自用用房",name_code:'House_Use',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"O-O-O Rooms 坏房",name_code:'O-O-O_Rooms',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0},{name:"O-O-S Rooms 维护房",name_code:'O-O-S_Rooms',actual:0,prediction:0,budget:0,last_year:0,actual_prediction:0,actual_budget:0,actual_last_year:0,year_actual:0,year_budget:0,year_last_year:0,year_actual_budget:0,year_actual_last_year:0,three_actual:0,three_budget:0,three_last_year:0,three_actual_budget:0,three_actual_last_year:0,whole_actual:0,whole_budget:0,whole_last_year:0,whole_actual_budget:0,whole_actual_last_year:0}];

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data2_1=exports.data2_1=[{"name":"","name_code":"","Jan":"1","Feb":"1","Mar":"1","Apr":"1","May":"1","Jun":"1","Jul":"1","Aug":"1","Sep":"1","Oct":"1","Nov":"1","Dec":"1","whole":"1","nextJan":"1","nextFeb":"1","nextMar":"1","nextQ1":"1","sort":0},{"name":"Total Rooms Available 可供出租客房数","name_code":"Rooms_Available","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":1},{"name":"Total Rooms Occupied 实际入住客房数","name_code":"Rooms_Occupied","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":2},{"name":"Occupancy 平均出租率","name_code":"Occupancy%","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":3},{"name":"Average Room Rate 平均房价","name_code":"Average_Room_Rate","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":4},{"name":"RevPAR 每间可供出租客房收入","name_code":"RevPAR","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":5},{"name":"Rooms Revenue 客房收入","name_code":"Rooms_Revenue","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":6},{"name":"F&B Revenue 餐饮收入","name_code":"F&B_Revenue","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":7},{"name":"Other Operated Departments 其它营运部门收入","name_code":"Others_Revenue","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":8},{"name":"Total Dept. Revenue 总收入","name_code":"Total_Revenue","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":9},{"name":"Rooms Dept. Profit (Loss) 客房部门盈利（亏损）","name_code":"Rooms_Dep't_Income","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":10},{"name":"Rooms Dept. Profit % of Dept. Rev.<br/>客房部门盈利（亏损）占部门收入百分比","name_code":"Rooms_Dep't_Income_% ","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":11},{"name":"F&B Dept. Profit (Loss) 餐饮部门盈利（亏损）","name_code":"F&B_Dep't_Income","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":12},{"name":"F&B Dept. Profit % of Dept. Rev.<br/>餐饮部门盈利（亏损）占部门收入百分比","name_code":"F&B_Dep't_Income_% ","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":13},{"name":"Total Cost of Food and Beverage Sales 餐饮成本","name_code":"F&B_Total_Cost","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":14},{"name":"Total Cost of Food and Beverage Sales % of Dept. Rev. <br/>餐饮成本占部门收入百分比","name_code":"F&B_Total_Cost_%","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":15},{"name":"Total Dept. Labor Costs and Related Expenses <br/>所有部门总工资福利","name_code":"Total_Payroll_Cost","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":16},{"name":"Total Dept. Labor Costs and Related Expenses % of Total Dept. Rev.<br/>所有部门总工资福利占总收入百分比","name_code":"Total_Payroll_Cost_% ","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":17},{"name":"Utility Cost 能源成本","name_code":"Utility_Cost","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":18},{"name":"Utility Cost % of Total Dept. Rev. 能源成本占总收入百分比","name_code":"Utility_Cost_% ","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":19},{"name":"Other Expense and Cost 其他费用及成本","name_code":"Other_Expense_and_Cost","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":20},{"name":"Other Expense and Cost % 其他费用及成本率","name_code":"Other_Expense_and_Cost_%","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":21},{"name":"Gross Operating Profit (Loss) 总毛利润(亏损)","name_code":"GOP","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":22},{"name":"GOP % of Total Rev. 总毛利润（亏损）占总收入百分比","name_code":"GOP_% ","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":23},{"name":"Breakeven Point 盈亏平衡点","name_code":"Breakeven_Point/Total_Exp","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":24},{"name":"Base Fee 基本管理费","name_code":"Base_Fee","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":25},{"name":"Brand Service Fee 品牌服务费","name_code":"Brand_Service_Fee","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":26},{"name":"Incentive Fee 奖励管理费","name_code":"Incentive_Fee","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":27},{"name":"Total Fee 总收费","name_code":"Total_Fee","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":28},{"name":"Complimentary Room 免费房","name_code":"Complimentary_Room","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":29},{"name":"House Use 自用用房","name_code":"House_Use","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":30},{"name":"O-O-O Rooms 坏房","name_code":"O-O-O_Rooms","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":31},{"name":"O-O-S Rooms 维护房","name_code":"O-O-S_Rooms","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":32},{"name":"Cost of Sales 销售成本","name_code":"Cost of Sales 销售成本","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":33},{"name":"Cost of Other Operated Dept. Sales 其它营运部门成本","name_code":"Cost of Other Operated Dept. Sales 其它营运部门成本","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":34},{"name":"Total Cost of Sales 总成本","name_code":"Total Cost of Sales 总成本","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":35},{"name":"Operated Dept. Labor Costs and Related Expenses<br/>营运部门工资福利","name_code":"Operated Dept. Labor Costs and Related Expenses 营运部门工资福利","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":36},{"name":"Rooms Dept. 客房部门","name_code":"Rooms Dept. 客房部门","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":37},{"name":"F&B Dept. 餐饮部门","name_code":"F&B Dept. 餐饮部门","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":38},{"name":"Other Operated Dept. 其它营运部门","name_code":"Other Operated Dept. 其它营运部门","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":39},{"name":"Total Operated Dept. Labor Costs and Related Expenses<br/>营运部门总工资福利","name_code":"Total Operated Dept. Labor Costs and Related Expenses 营运部门总工资福利","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":40},{"name":"Provision for O.E. 营运工具預提","name_code":"Provision for O.E. 营运工具預提","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":41},{"name":"Rooms 客房","name_code":"Rooms 客房","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":42},{"name":"Food & Beverage 餐饮","name_code":"Food & Beverage 餐饮","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":43},{"name":"Other Operated Departments 其它营运部门","name_code":"Other Operated Departments 其它营运部门","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":44},{"name":"Total Provision for O.E. 总营运工具預提","name_code":"Total Provision for O.E. 总营运工具預提","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":45},{"name":"Other Expenses 其它费用","name_code":"Other Expenses 其它费用","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":46},{"name":"Rooms 客房","name_code":"Rooms 客房","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":47},{"name":"Food & Beverage 餐饮","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":48},{"name":"Other Operated Departments 其它营运部门","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":49},{"name":"Total Other Expenses 总其它费用","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":50},{"name":"Total Department Cost/Expenses 部门总成本和费用","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":51},{"name":"Dept. Profit (Loss) 部门盈利（亏损）","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":52},{"name":"Other Operated Dept. Profit (Loss) 其它部门盈利（亏损）","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":53},{"name":"Total Departmental Profit 总部门利润","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":54},{"name":"Undistributed Operating Expenses 后台部门费用","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":55},{"name":"Undistributed Operating Dept. <br/>Labor Costs and Related Expenses后台部门工资福利","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":56},{"name":"Administration & General 行政办","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":57},{"name":"Human Resources 人力资源部","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":58},{"name":"Sales & Marketing 市场销售部","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":59},{"name":"Property Operation & Maintenance 工程部","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":60},{"name":"Total Undistributed Operating Dept. Labor Costs and Related Expenses<br/>后台部门总工资福利","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":61},{"name":"Other Expenses 其它费用","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":62},{"name":"Administration & General 行政办","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":63},{"name":"Human Resources 人力资源部","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":64},{"name":"Sales & Marketing 市场销售部","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":65},{"name":"Property Operation & Maintenance 工程部","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":66},{"name":"Total Other Expenses 总其它费用","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":67},{"name":"Total Undistributed Operating Expenses 后台部门费用总计","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":68},{"name":"Profit After Undistributed Operating Expenses<br/>扣除后台部门费用总计后利润","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":69},{"name":"Insurance 保险","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":70},{"name":"Other Deductions 其它扣除","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":71},{"name":"Reserve for Capital Expenditure 固定资产备用","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":72},{"name":"Others 其它","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":73},{"name":"Total Other Deductions 其它扣除总计","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":74},{"name":"Owner's Profit(Loss) 业主利润(亏损)","name_code":"","Jan":"0","Feb":"0","Mar":"0","Apr":"0","May":"0","Jun":"0","Jul":"0","Aug":"0","Sep":"0","Oct":"0","Nov":"0","Dec":"0","whole":"0","nextJan":"0","nextFeb":"0","nextMar":"0","nextQ1":"0","sort":75}];

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data2_2=exports.data2_2=[{name:'',name_code:"",Jan:"1",Feb:"1",Mar:"1",Apr:"1",May:"1",Jun:"1",Jul:"1",Aug:'1',Sep:"1",Oct:"1",Nov:"1",Dec:"1",whole:"1",nextJan:"1",nextFeb:"1",nextMar:"1",nextQ1:"1"},{name:'Total Rooms Available 可供出租客房数',name_code:"Rooms_Available",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Total Rooms Occupied 实际入住客房数',name_code:"Rooms_Occupied",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Occupancy 平均出租率',name_code:"Occupancy%",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Average Room Rate 平均房价',name_code:"Average_Room_Rate",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'RevPAR 每间可供出租客房收入',name_code:"RevPAR",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Rooms Revenue 客房收入',name_code:"Rooms_Revenue",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'F&B Revenue 餐饮收入',name_code:"F&B_Revenue",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Other Operated Departments 其它营运部门收入',name_code:"Others_Revenue",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Total Dept. Revenue 总收入',name_code:"Total_Revenue",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:"Rooms Dept. Profit (Loss) 客房部门盈利（亏损）",name_code:"Rooms_Dep't_Income",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:"Rooms Dept. Profit % of Dept. Rev.<br/>客房部门盈利（亏损）占部门收入百分比 ",name_code:"Rooms_Dep't_Income_% ",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:"F&B Dept. Profit (Loss) 餐饮部门盈利（亏损）",name_code:"F&B_Dep't_Income",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:"F&B Dept. Profit % of Dept. Rev.<br/>餐饮部门盈利（亏损）占部门收入百分比",name_code:"F&B_Dep't_Income_% ",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Total Cost of Food and Beverage Sales 餐饮成本',name_code:"F&B_Total_Cost",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Total Cost of Food and Beverage Sales % of Dept. Rev. <br/>餐饮成本占部门收入百分比',name_code:"F&B_Total_Cost_%",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Total Dept. Labor Costs and Related Expenses <br/>所有部门总工资福利',name_code:"Total_Payroll_Cost",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Total Dept. Labor Costs and Related Expenses % of Total Dept. Rev.<br/>所有部门总工资福利占总收入百分比',name_code:"Total_Payroll_Cost_% ",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Utility Cost 能源成本',name_code:"Utility_Cost",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Utility Cost % of Total Dept. Rev. 能源成本占总收入百分比',name_code:"Utility_Cost_% ",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Other Expense and Cost 其他费用及成本',name_code:"Other_Expense_and_Cost",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Other Expense and Cost % 其他费用及成本率',name_code:"Other_Expense_and_Cost_%",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Gross Operating Profit (Loss) 总毛利润(亏损)',name_code:"GOP",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'GOP % of Total Rev. 总毛利润（亏损）占总收入百分比 ',name_code:"GOP_% ",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Breakeven Point 盈亏平衡点',name_code:"Breakeven_Point/Total_Exp",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Base Fee 基本管理费',name_code:"Base_Fee",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Brand Service Fee 品牌服务费',name_code:"Brand_Service_Fee",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Incentive Fee 奖励管理费',name_code:"Incentive_Fee",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Total Fee 总收费',name_code:"Total_Fee",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Complimentary Room 免费房',name_code:"Complimentary_Room",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'House Use 自用用房',name_code:"House_Use",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'O-O-O Rooms 坏房',name_code:"O-O-O_Rooms",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'O-O-S Rooms 维护房',name_code:"O-O-S_Rooms",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"}];

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data2_3=exports.data2_3=[{name:'',name_code:"",Jan:"1",Feb:"1",Mar:"1",Apr:"1",May:"1",Jun:"1",Jul:"1",Aug:'1',Sep:"1",Oct:"1",Nov:"1",Dec:"1",whole:"1",nextJan:"1",nextFeb:"1",nextMar:"1",nextQ1:"1"},{name:'Total Rooms Available 可供出租客房数',name_code:"Rooms_Available",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Total Rooms Occupied 实际入住客房数',name_code:"Rooms_Occupied",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Occupancy 平均出租率',name_code:"Occupancy%",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Average Room Rate 平均房价',name_code:"Average_Room_Rate",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'RevPAR 每间可供出租客房收入',name_code:"RevPAR",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Rooms Revenue 客房收入',name_code:"Rooms_Revenue",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'F&B Revenue 餐饮收入',name_code:"F&B_Revenue",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Other Operated Departments 其它营运部门收入',name_code:"Others_Revenue",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Total Dept. Revenue 总收入',name_code:"Total_Revenue",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:"Rooms Dept. Profit (Loss) 客房部门盈利（亏损）",name_code:"Rooms_Dep't_Income",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:"Rooms Dept. Profit % of Dept. Rev.<br/>客房部门盈利（亏损）占部门收入百分比 ",name_code:"Rooms_Dep't_Income_% ",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:"F&B Dept. Profit (Loss) 餐饮部门盈利（亏损）",name_code:"F&B_Dep't_Income",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:"F&B Dept. Profit % of Dept. Rev.<br/>餐饮部门盈利（亏损）占部门收入百分比",name_code:"F&B_Dep't_Income_% ",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Total Cost of Food and Beverage Sales 餐饮成本',name_code:"F&B_Total_Cost",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Total Cost of Food and Beverage Sales % of Dept. Rev. <br/>餐饮成本占部门收入百分比 ',name_code:"F&B_Total_Cost_%",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Total Dept. Labor Costs and Related Expenses <br/>所有部门总工资福利',name_code:"Total_Payroll_Cost",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Total Dept. Labor Costs and Related Expenses % of Total Dept. Rev.<br/>所有部门总工资福利占总收入百分比',name_code:"Total_Payroll_Cost_% ",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Utility Cost 能源成本',name_code:"Utility_Cost",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Utility Cost % of Total Dept. Rev. 能源成本占总收入百分比',name_code:"Utility_Cost_% ",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Other Expense and Cost 其他费用及成本',name_code:"Other_Expense_and_Cost",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Other Expense and Cost % 其他费用及成本率',name_code:"Other_Expense_and_Cost_%",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Gross Operating Profit (Loss) 总毛利润(亏损)',name_code:"GOP",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'GOP % of Total Rev. 总毛利润（亏损）占总收入百分比',name_code:"GOP_% ",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Breakeven Point 盈亏平衡点',name_code:"Breakeven_Point/Total_Exp",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Base Fee 基本管理费',name_code:"Base_Fee",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Brand Service Fee 品牌服务费',name_code:"Brand_Service_Fee",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Incentive Fee 奖励管理费',name_code:"Incentive_Fee",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Total Fee 总收费',name_code:"Total_Fee",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'Complimentary Room 免费房',name_code:"Complimentary_Room",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'House Use 自用用房',name_code:"House_Use",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'O-O-O Rooms 坏房',name_code:"O-O-O_Rooms",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"},{name:'O-O-S Rooms 维护房',name_code:"O-O-S_Rooms",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:"0",Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",nextJan:"0",nextFeb:"0",nextMar:"0",nextQ1:"0"}];

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data3_2_1=exports.data3_2_1=[{name:'',name_code:'',outlets:'0',seats:'0',available:'0',covers:'0',turn_over:'0',revenue:'0',AC:'0',revpas:'0',toi:'0',toi_ranking:'0',ACI:'0',ACI_ranking:'0',RGI:'0',RGI_ranking:'0'},{name:'',name_code:'',outlets:'0',seats:'0',available:'0',covers:'0',turn_over:'0',revenue:'0',AC:'0',revpas:'0',toi:'0',toi_ranking:'0',ACI:'0',ACI_ranking:'0',RGI:'0',RGI_ranking:'0'},{name:'',name_code:'',outlets:'0',seats:'0',available:'0',covers:'0',turn_over:'0',revenue:'0',AC:'0',revpas:'0',toi:'0',toi_ranking:'0',ACI:'0',ACI_ranking:'0',RGI:'0',RGI_ranking:'0'},{name:'',name_code:'',outlets:'0',seats:'0',available:'0',covers:'0',turn_over:'0',revenue:'0',AC:'0',revpas:'0',toi:'0',toi_ranking:'0',ACI:'0',ACI_ranking:'0',RGI:'0',RGI_ranking:'0'},{name:'',name_code:'',outlets:'0',seats:'0',available:'0',covers:'0',turn_over:'0',revenue:'0',AC:'0',revpas:'0',toi:'0',toi_ranking:'0',ACI:'0',ACI_ranking:'0',RGI:'0',RGI_ranking:'0'},{name:'Total',name_code:'Total',outlets:'0',seats:'0',available:'0',covers:'0',turn_over:'0',revenue:'0',AC:'0',revpas:'0',toi:'0',toi_ranking:'0',ACI:'0',ACI_ranking:'0',RGI:'0',RGI_ranking:'0'}];

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data3_2_1=exports.data3_2_1=[{name:'',name_code:'',outlets:'0',seats:'0',available:'0',covers:'0',turn_over:'0',revenue:'0',AC:'0',revpas:'0',toi:'0',toi_ranking:'0',ACI:'0',ACI_ranking:'0',RGI:'0',RGI_ranking:'0'},{name:'',name_code:'',outlets:'0',seats:'0',available:'0',covers:'0',turn_over:'0',revenue:'0',AC:'0',revpas:'0',toi:'0',toi_ranking:'0',ACI:'0',ACI_ranking:'0',RGI:'0',RGI_ranking:'0'},{name:'',name_code:'',outlets:'0',seats:'0',available:'0',covers:'0',turn_over:'0',revenue:'0',AC:'0',revpas:'0',toi:'0',toi_ranking:'0',ACI:'0',ACI_ranking:'0',RGI:'0',RGI_ranking:'0'},{name:'',name_code:'',outlets:'0',seats:'0',available:'0',covers:'0',turn_over:'0',revenue:'0',AC:'0',revpas:'0',toi:'0',toi_ranking:'0',ACI:'0',ACI_ranking:'0',RGI:'0',RGI_ranking:'0'},{name:'',name_code:'',outlets:'0',seats:'0',available:'0',covers:'0',turn_over:'0',revenue:'0',AC:'0',revpas:'0',toi:'0',toi_ranking:'0',ACI:'0',ACI_ranking:'0',RGI:'0',RGI_ranking:'0'},{name:'Total',name_code:'Total',outlets:'0',seats:'0',available:'0',covers:'0',turn_over:'0',revenue:'0',AC:'0',revpas:'0',toi:'0',toi_ranking:'0',ACI:'0',ACI_ranking:'0',RGI:'0',RGI_ranking:'0'}];

/***/ }),
/* 613 */
/***/ (function(module, exports) {

/**
 * zrender: 生成唯一id
 *
 * @author errorrik (errorrik@gmail.com)
 */
var idStart = 0x0907;

function _default() {
  return idStart++;
}

module.exports = _default;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

var env = __webpack_require__(67);

var _fourPointsTransform = __webpack_require__(1528);

var buildTransformer = _fourPointsTransform.buildTransformer;
var EVENT_SAVED_PROP = '___zrEVENTSAVED';
var _calcOut = [];
/**
 * Transform "local coord" from `elFrom` to `elTarget`.
 * "local coord": the coord based on the input `el`. The origin point is at
 *     the position of "left: 0; top: 0;" in the `el`.
 *
 * Support when CSS transform is used.
 *
 * Having the `out` (that is, `[outX, outY]`), we can create an DOM element
 * and set the CSS style as "left: outX; top: outY;" and append it to `elTarge`
 * to locate the element.
 *
 * For example, this code below positions a child of `document.body` on the event
 * point, no matter whether `body` has `margin`/`paddin`/`transfrom`/... :
 * ```js
 * transformLocalCoord(out, container, document.body, event.offsetX, event.offsetY);
 * if (!eqNaN(out[0])) {
 *     // Then locate the tip element on the event point.
 *     var tipEl = document.createElement('div');
 *     tipEl.style.cssText = 'position: absolute; left:' + out[0] + ';top:' + out[1] + ';';
 *     document.body.appendChild(tipEl);
 * }
 * ```
 *
 * Notice: In some env this method is not supported. If called, `out` will be `[NaN, NaN]`.
 *
 * @param {Array.<number>} out [inX: number, inY: number] The output..
 *        If can not transform, `out` will not be modified but return `false`.
 * @param {HTMLElement} elFrom The `[inX, inY]` is based on elFrom.
 * @param {HTMLElement} elTarget The `out` is based on elTarget.
 * @param {number} inX
 * @param {number} inY
 * @return {boolean} Whether transform successfully.
 */

function transformLocalCoord(out, elFrom, elTarget, inX, inY) {
  return transformCoordWithViewport(_calcOut, elFrom, inX, inY, true) && transformCoordWithViewport(out, elTarget, _calcOut[0], _calcOut[1]);
}
/**
 * Transform between a "viewport coord" and a "local coord".
 * "viewport coord": the coord based on the left-top corner of the viewport
 *     of the browser.
 * "local coord": the coord based on the input `el`. The origin point is at
 *     the position of "left: 0; top: 0;" in the `el`.
 *
 * Support the case when CSS transform is used on el.
 *
 * @param {Array.<number>} out [inX: number, inY: number] The output. If `inverse: false`,
 *        it represents "local coord", otherwise "vireport coord".
 *        If can not transform, `out` will not be modified but return `false`.
 * @param {HTMLElement} el The "local coord" is based on the `el`, see comment above.
 * @param {number} inX If `inverse: false`,
 *        it represents "vireport coord", otherwise "local coord".
 * @param {number} inY If `inverse: false`,
 *        it represents "vireport coord", otherwise "local coord".
 * @param {boolean} [inverse=false]
 *        `true`: from "viewport coord" to "local coord".
 *        `false`: from "local coord" to "viewport coord".
 * @return {boolean} Whether transform successfully.
 */


function transformCoordWithViewport(out, el, inX, inY, inverse) {
  if (el.getBoundingClientRect && env.domSupported && !isCanvasEl(el)) {
    var saved = el[EVENT_SAVED_PROP] || (el[EVENT_SAVED_PROP] = {});
    var markers = prepareCoordMarkers(el, saved);
    var transformer = preparePointerTransformer(markers, saved, inverse);

    if (transformer) {
      transformer(out, inX, inY);
      return true;
    }
  }

  return false;
}

function prepareCoordMarkers(el, saved) {
  var markers = saved.markers;

  if (markers) {
    return markers;
  }

  markers = saved.markers = [];
  var propLR = ['left', 'right'];
  var propTB = ['top', 'bottom'];

  for (var i = 0; i < 4; i++) {
    var marker = document.createElement('div');
    var stl = marker.style;
    var idxLR = i % 2;
    var idxTB = (i >> 1) % 2;
    stl.cssText = ['position: absolute', 'visibility: hidden', 'padding: 0', 'margin: 0', 'border-width: 0', 'user-select: none', 'width:0', 'height:0', // 'width: 5px',
    // 'height: 5px',
    propLR[idxLR] + ':0', propTB[idxTB] + ':0', propLR[1 - idxLR] + ':auto', propTB[1 - idxTB] + ':auto', ''].join('!important;');
    el.appendChild(marker);
    markers.push(marker);
  }

  return markers;
}

function preparePointerTransformer(markers, saved, inverse) {
  var transformerName = inverse ? 'invTrans' : 'trans';
  var transformer = saved[transformerName];
  var oldSrcCoords = saved.srcCoords;
  var oldCoordTheSame = true;
  var srcCoords = [];
  var destCoords = [];

  for (var i = 0; i < 4; i++) {
    var rect = markers[i].getBoundingClientRect();
    var ii = 2 * i;
    var x = rect.left;
    var y = rect.top;
    srcCoords.push(x, y);
    oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
    destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
  } // Cache to avoid time consuming of `buildTransformer`.


  return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? buildTransformer(destCoords, srcCoords) : buildTransformer(srcCoords, destCoords));
}

function isCanvasEl(el) {
  return el.nodeName.toUpperCase() === 'CANVAS';
}

exports.transformLocalCoord = transformLocalCoord;
exports.transformCoordWithViewport = transformCoordWithViewport;
exports.isCanvasEl = isCanvasEl;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var guid = __webpack_require__(613);

var Eventful = __webpack_require__(173);

var Transformable = __webpack_require__(292);

var Animatable = __webpack_require__(1531);

var zrUtil = __webpack_require__(1);

/**
 * @alias module:zrender/Element
 * @constructor
 * @extends {module:zrender/mixin/Animatable}
 * @extends {module:zrender/mixin/Transformable}
 * @extends {module:zrender/mixin/Eventful}
 */
var Element = function (opts) {
  // jshint ignore:line
  Transformable.call(this, opts);
  Eventful.call(this, opts);
  Animatable.call(this, opts);
  /**
   * 画布元素ID
   * @type {string}
   */

  this.id = opts.id || guid();
};

Element.prototype = {
  /**
   * 元素类型
   * Element type
   * @type {string}
   */
  type: 'element',

  /**
   * 元素名字
   * Element name
   * @type {string}
   */
  name: '',

  /**
   * ZRender 实例对象，会在 element 添加到 zrender 实例中后自动赋值
   * ZRender instance will be assigned when element is associated with zrender
   * @name module:/zrender/Element#__zr
   * @type {module:zrender/ZRender}
   */
  __zr: null,

  /**
   * 图形是否忽略，为true时忽略图形的绘制以及事件触发
   * If ignore drawing and events of the element object
   * @name module:/zrender/Element#ignore
   * @type {boolean}
   * @default false
   */
  ignore: false,

  /**
   * 用于裁剪的路径(shape)，所有 Group 内的路径在绘制时都会被这个路径裁剪
   * 该路径会继承被裁减对象的变换
   * @type {module:zrender/graphic/Path}
   * @see http://www.w3.org/TR/2dcontext/#clipping-region
   * @readOnly
   */
  clipPath: null,

  /**
   * 是否是 Group
   * @type {boolean}
   */
  isGroup: false,

  /**
   * Drift element
   * @param  {number} dx dx on the global space
   * @param  {number} dy dy on the global space
   */
  drift: function (dx, dy) {
    switch (this.draggable) {
      case 'horizontal':
        dy = 0;
        break;

      case 'vertical':
        dx = 0;
        break;
    }

    var m = this.transform;

    if (!m) {
      m = this.transform = [1, 0, 0, 1, 0, 0];
    }

    m[4] += dx;
    m[5] += dy;
    this.decomposeTransform();
    this.dirty(false);
  },

  /**
   * Hook before update
   */
  beforeUpdate: function () {},

  /**
   * Hook after update
   */
  afterUpdate: function () {},

  /**
   * Update each frame
   */
  update: function () {
    this.updateTransform();
  },

  /**
   * @param  {Function} cb
   * @param  {}   context
   */
  traverse: function (cb, context) {},

  /**
   * @protected
   */
  attrKV: function (key, value) {
    if (key === 'position' || key === 'scale' || key === 'origin') {
      // Copy the array
      if (value) {
        var target = this[key];

        if (!target) {
          target = this[key] = [];
        }

        target[0] = value[0];
        target[1] = value[1];
      }
    } else {
      this[key] = value;
    }
  },

  /**
   * Hide the element
   */
  hide: function () {
    this.ignore = true;
    this.__zr && this.__zr.refresh();
  },

  /**
   * Show the element
   */
  show: function () {
    this.ignore = false;
    this.__zr && this.__zr.refresh();
  },

  /**
   * @param {string|Object} key
   * @param {*} value
   */
  attr: function (key, value) {
    if (typeof key === 'string') {
      this.attrKV(key, value);
    } else if (zrUtil.isObject(key)) {
      for (var name in key) {
        if (key.hasOwnProperty(name)) {
          this.attrKV(name, key[name]);
        }
      }
    }

    this.dirty(false);
    return this;
  },

  /**
   * @param {module:zrender/graphic/Path} clipPath
   */
  setClipPath: function (clipPath) {
    var zr = this.__zr;

    if (zr) {
      clipPath.addSelfToZr(zr);
    } // Remove previous clip path


    if (this.clipPath && this.clipPath !== clipPath) {
      this.removeClipPath();
    }

    this.clipPath = clipPath;
    clipPath.__zr = zr;
    clipPath.__clipTarget = this;
    this.dirty(false);
  },

  /**
   */
  removeClipPath: function () {
    var clipPath = this.clipPath;

    if (clipPath) {
      if (clipPath.__zr) {
        clipPath.removeSelfFromZr(clipPath.__zr);
      }

      clipPath.__zr = null;
      clipPath.__clipTarget = null;
      this.clipPath = null;
      this.dirty(false);
    }
  },

  /**
   * Add self from zrender instance.
   * Not recursively because it will be invoked when element added to storage.
   * @param {module:zrender/ZRender} zr
   */
  addSelfToZr: function (zr) {
    this.__zr = zr; // 添加动画

    var animators = this.animators;

    if (animators) {
      for (var i = 0; i < animators.length; i++) {
        zr.animation.addAnimator(animators[i]);
      }
    }

    if (this.clipPath) {
      this.clipPath.addSelfToZr(zr);
    }
  },

  /**
   * Remove self from zrender instance.
   * Not recursively because it will be invoked when element added to storage.
   * @param {module:zrender/ZRender} zr
   */
  removeSelfFromZr: function (zr) {
    this.__zr = null; // 移除动画

    var animators = this.animators;

    if (animators) {
      for (var i = 0; i < animators.length; i++) {
        zr.animation.removeAnimator(animators[i]);
      }
    }

    if (this.clipPath) {
      this.clipPath.removeSelfFromZr(zr);
    }
  }
};
zrUtil.mixin(Element, Animatable);
zrUtil.mixin(Element, Transformable);
zrUtil.mixin(Element, Eventful);
var _default = Element;
module.exports = _default;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var Clip = __webpack_require__(1532);

var color = __webpack_require__(122);

var _util = __webpack_require__(1);

var isArrayLike = _util.isArrayLike;

/**
 * @module echarts/animation/Animator
 */
var arraySlice = Array.prototype.slice;

function defaultGetter(target, key) {
  return target[key];
}

function defaultSetter(target, key, value) {
  target[key] = value;
}
/**
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} percent
 * @return {number}
 */


function interpolateNumber(p0, p1, percent) {
  return (p1 - p0) * percent + p0;
}
/**
 * @param  {string} p0
 * @param  {string} p1
 * @param  {number} percent
 * @return {string}
 */


function interpolateString(p0, p1, percent) {
  return percent > 0.5 ? p1 : p0;
}
/**
 * @param  {Array} p0
 * @param  {Array} p1
 * @param  {number} percent
 * @param  {Array} out
 * @param  {number} arrDim
 */


function interpolateArray(p0, p1, percent, out, arrDim) {
  var len = p0.length;

  if (arrDim === 1) {
    for (var i = 0; i < len; i++) {
      out[i] = interpolateNumber(p0[i], p1[i], percent);
    }
  } else {
    var len2 = len && p0[0].length;

    for (var i = 0; i < len; i++) {
      for (var j = 0; j < len2; j++) {
        out[i][j] = interpolateNumber(p0[i][j], p1[i][j], percent);
      }
    }
  }
} // arr0 is source array, arr1 is target array.
// Do some preprocess to avoid error happened when interpolating from arr0 to arr1


function fillArr(arr0, arr1, arrDim) {
  var arr0Len = arr0.length;
  var arr1Len = arr1.length;

  if (arr0Len !== arr1Len) {
    // FIXME Not work for TypedArray
    var isPreviousLarger = arr0Len > arr1Len;

    if (isPreviousLarger) {
      // Cut the previous
      arr0.length = arr1Len;
    } else {
      // Fill the previous
      for (var i = arr0Len; i < arr1Len; i++) {
        arr0.push(arrDim === 1 ? arr1[i] : arraySlice.call(arr1[i]));
      }
    }
  } // Handling NaN value


  var len2 = arr0[0] && arr0[0].length;

  for (var i = 0; i < arr0.length; i++) {
    if (arrDim === 1) {
      if (isNaN(arr0[i])) {
        arr0[i] = arr1[i];
      }
    } else {
      for (var j = 0; j < len2; j++) {
        if (isNaN(arr0[i][j])) {
          arr0[i][j] = arr1[i][j];
        }
      }
    }
  }
}
/**
 * @param  {Array} arr0
 * @param  {Array} arr1
 * @param  {number} arrDim
 * @return {boolean}
 */


function isArraySame(arr0, arr1, arrDim) {
  if (arr0 === arr1) {
    return true;
  }

  var len = arr0.length;

  if (len !== arr1.length) {
    return false;
  }

  if (arrDim === 1) {
    for (var i = 0; i < len; i++) {
      if (arr0[i] !== arr1[i]) {
        return false;
      }
    }
  } else {
    var len2 = arr0[0].length;

    for (var i = 0; i < len; i++) {
      for (var j = 0; j < len2; j++) {
        if (arr0[i][j] !== arr1[i][j]) {
          return false;
        }
      }
    }
  }

  return true;
}
/**
 * Catmull Rom interpolate array
 * @param  {Array} p0
 * @param  {Array} p1
 * @param  {Array} p2
 * @param  {Array} p3
 * @param  {number} t
 * @param  {number} t2
 * @param  {number} t3
 * @param  {Array} out
 * @param  {number} arrDim
 */


function catmullRomInterpolateArray(p0, p1, p2, p3, t, t2, t3, out, arrDim) {
  var len = p0.length;

  if (arrDim === 1) {
    for (var i = 0; i < len; i++) {
      out[i] = catmullRomInterpolate(p0[i], p1[i], p2[i], p3[i], t, t2, t3);
    }
  } else {
    var len2 = p0[0].length;

    for (var i = 0; i < len; i++) {
      for (var j = 0; j < len2; j++) {
        out[i][j] = catmullRomInterpolate(p0[i][j], p1[i][j], p2[i][j], p3[i][j], t, t2, t3);
      }
    }
  }
}
/**
 * Catmull Rom interpolate number
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @param  {number} t2
 * @param  {number} t3
 * @return {number}
 */


function catmullRomInterpolate(p0, p1, p2, p3, t, t2, t3) {
  var v0 = (p2 - p0) * 0.5;
  var v1 = (p3 - p1) * 0.5;
  return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
}

function cloneValue(value) {
  if (isArrayLike(value)) {
    var len = value.length;

    if (isArrayLike(value[0])) {
      var ret = [];

      for (var i = 0; i < len; i++) {
        ret.push(arraySlice.call(value[i]));
      }

      return ret;
    }

    return arraySlice.call(value);
  }

  return value;
}

function rgba2String(rgba) {
  rgba[0] = Math.floor(rgba[0]);
  rgba[1] = Math.floor(rgba[1]);
  rgba[2] = Math.floor(rgba[2]);
  return 'rgba(' + rgba.join(',') + ')';
}

function getArrayDim(keyframes) {
  var lastValue = keyframes[keyframes.length - 1].value;
  return isArrayLike(lastValue && lastValue[0]) ? 2 : 1;
}

function createTrackClip(animator, easing, oneTrackDone, keyframes, propName, forceAnimate) {
  var getter = animator._getter;
  var setter = animator._setter;
  var useSpline = easing === 'spline';
  var trackLen = keyframes.length;

  if (!trackLen) {
    return;
  } // Guess data type


  var firstVal = keyframes[0].value;
  var isValueArray = isArrayLike(firstVal);
  var isValueColor = false;
  var isValueString = false; // For vertices morphing

  var arrDim = isValueArray ? getArrayDim(keyframes) : 0;
  var trackMaxTime; // Sort keyframe as ascending

  keyframes.sort(function (a, b) {
    return a.time - b.time;
  });
  trackMaxTime = keyframes[trackLen - 1].time; // Percents of each keyframe

  var kfPercents = []; // Value of each keyframe

  var kfValues = [];
  var prevValue = keyframes[0].value;
  var isAllValueEqual = true;

  for (var i = 0; i < trackLen; i++) {
    kfPercents.push(keyframes[i].time / trackMaxTime); // Assume value is a color when it is a string

    var value = keyframes[i].value; // Check if value is equal, deep check if value is array

    if (!(isValueArray && isArraySame(value, prevValue, arrDim) || !isValueArray && value === prevValue)) {
      isAllValueEqual = false;
    }

    prevValue = value; // Try converting a string to a color array

    if (typeof value === 'string') {
      var colorArray = color.parse(value);

      if (colorArray) {
        value = colorArray;
        isValueColor = true;
      } else {
        isValueString = true;
      }
    }

    kfValues.push(value);
  }

  if (!forceAnimate && isAllValueEqual) {
    return;
  }

  var lastValue = kfValues[trackLen - 1]; // Polyfill array and NaN value

  for (var i = 0; i < trackLen - 1; i++) {
    if (isValueArray) {
      fillArr(kfValues[i], lastValue, arrDim);
    } else {
      if (isNaN(kfValues[i]) && !isNaN(lastValue) && !isValueString && !isValueColor) {
        kfValues[i] = lastValue;
      }
    }
  }

  isValueArray && fillArr(getter(animator._target, propName), lastValue, arrDim); // Cache the key of last frame to speed up when
  // animation playback is sequency

  var lastFrame = 0;
  var lastFramePercent = 0;
  var start;
  var w;
  var p0;
  var p1;
  var p2;
  var p3;

  if (isValueColor) {
    var rgba = [0, 0, 0, 0];
  }

  var onframe = function (target, percent) {
    // Find the range keyframes
    // kf1-----kf2---------current--------kf3
    // find kf2 and kf3 and do interpolation
    var frame; // In the easing function like elasticOut, percent may less than 0

    if (percent < 0) {
      frame = 0;
    } else if (percent < lastFramePercent) {
      // Start from next key
      // PENDING start from lastFrame ?
      start = Math.min(lastFrame + 1, trackLen - 1);

      for (frame = start; frame >= 0; frame--) {
        if (kfPercents[frame] <= percent) {
          break;
        }
      } // PENDING really need to do this ?


      frame = Math.min(frame, trackLen - 2);
    } else {
      for (frame = lastFrame; frame < trackLen; frame++) {
        if (kfPercents[frame] > percent) {
          break;
        }
      }

      frame = Math.min(frame - 1, trackLen - 2);
    }

    lastFrame = frame;
    lastFramePercent = percent;
    var range = kfPercents[frame + 1] - kfPercents[frame];

    if (range === 0) {
      return;
    } else {
      w = (percent - kfPercents[frame]) / range;
    }

    if (useSpline) {
      p1 = kfValues[frame];
      p0 = kfValues[frame === 0 ? frame : frame - 1];
      p2 = kfValues[frame > trackLen - 2 ? trackLen - 1 : frame + 1];
      p3 = kfValues[frame > trackLen - 3 ? trackLen - 1 : frame + 2];

      if (isValueArray) {
        catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, getter(target, propName), arrDim);
      } else {
        var value;

        if (isValueColor) {
          value = catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, rgba, 1);
          value = rgba2String(rgba);
        } else if (isValueString) {
          // String is step(0.5)
          return interpolateString(p1, p2, w);
        } else {
          value = catmullRomInterpolate(p0, p1, p2, p3, w, w * w, w * w * w);
        }

        setter(target, propName, value);
      }
    } else {
      if (isValueArray) {
        interpolateArray(kfValues[frame], kfValues[frame + 1], w, getter(target, propName), arrDim);
      } else {
        var value;

        if (isValueColor) {
          interpolateArray(kfValues[frame], kfValues[frame + 1], w, rgba, 1);
          value = rgba2String(rgba);
        } else if (isValueString) {
          // String is step(0.5)
          return interpolateString(kfValues[frame], kfValues[frame + 1], w);
        } else {
          value = interpolateNumber(kfValues[frame], kfValues[frame + 1], w);
        }

        setter(target, propName, value);
      }
    }
  };

  var clip = new Clip({
    target: animator._target,
    life: trackMaxTime,
    loop: animator._loop,
    delay: animator._delay,
    onframe: onframe,
    ondestroy: oneTrackDone
  });

  if (easing && easing !== 'spline') {
    clip.easing = easing;
  }

  return clip;
}
/**
 * @alias module:zrender/animation/Animator
 * @constructor
 * @param {Object} target
 * @param {boolean} loop
 * @param {Function} getter
 * @param {Function} setter
 */


var Animator = function (target, loop, getter, setter) {
  this._tracks = {};
  this._target = target;
  this._loop = loop || false;
  this._getter = getter || defaultGetter;
  this._setter = setter || defaultSetter;
  this._clipCount = 0;
  this._delay = 0;
  this._doneList = [];
  this._onframeList = [];
  this._clipList = [];
};

Animator.prototype = {
  /**
   * Set Animation keyframe
   * @param  {number} time 关键帧时间，单位是ms
   * @param  {Object} props 关键帧的属性值，key-value表示
   * @return {module:zrender/animation/Animator}
   */
  when: function (time
  /* ms */
  , props) {
    var tracks = this._tracks;

    for (var propName in props) {
      if (!props.hasOwnProperty(propName)) {
        continue;
      }

      if (!tracks[propName]) {
        tracks[propName] = []; // Invalid value

        var value = this._getter(this._target, propName);

        if (value == null) {
          // zrLog('Invalid property ' + propName);
          continue;
        } // If time is 0
        //  Then props is given initialize value
        // Else
        //  Initialize value from current prop value


        if (time !== 0) {
          tracks[propName].push({
            time: 0,
            value: cloneValue(value)
          });
        }
      }

      tracks[propName].push({
        time: time,
        value: props[propName]
      });
    }

    return this;
  },

  /**
   * 添加动画每一帧的回调函数
   * @param  {Function} callback
   * @return {module:zrender/animation/Animator}
   */
  during: function (callback) {
    this._onframeList.push(callback);

    return this;
  },
  pause: function () {
    for (var i = 0; i < this._clipList.length; i++) {
      this._clipList[i].pause();
    }

    this._paused = true;
  },
  resume: function () {
    for (var i = 0; i < this._clipList.length; i++) {
      this._clipList[i].resume();
    }

    this._paused = false;
  },
  isPaused: function () {
    return !!this._paused;
  },
  _doneCallback: function () {
    // Clear all tracks
    this._tracks = {}; // Clear all clips

    this._clipList.length = 0;
    var doneList = this._doneList;
    var len = doneList.length;

    for (var i = 0; i < len; i++) {
      doneList[i].call(this);
    }
  },

  /**
   * Start the animation
   * @param  {string|Function} [easing]
   *         动画缓动函数，详见{@link module:zrender/animation/easing}
   * @param  {boolean} forceAnimate
   * @return {module:zrender/animation/Animator}
   */
  start: function (easing, forceAnimate) {
    var self = this;
    var clipCount = 0;

    var oneTrackDone = function () {
      clipCount--;

      if (!clipCount) {
        self._doneCallback();
      }
    };

    var lastClip;

    for (var propName in this._tracks) {
      if (!this._tracks.hasOwnProperty(propName)) {
        continue;
      }

      var clip = createTrackClip(this, easing, oneTrackDone, this._tracks[propName], propName, forceAnimate);

      if (clip) {
        this._clipList.push(clip);

        clipCount++; // If start after added to animation

        if (this.animation) {
          this.animation.addClip(clip);
        }

        lastClip = clip;
      }
    } // Add during callback on the last clip


    if (lastClip) {
      var oldOnFrame = lastClip.onframe;

      lastClip.onframe = function (target, percent) {
        oldOnFrame(target, percent);

        for (var i = 0; i < self._onframeList.length; i++) {
          self._onframeList[i](target, percent);
        }
      };
    } // This optimization will help the case that in the upper application
    // the view may be refreshed frequently, where animation will be
    // called repeatly but nothing changed.


    if (!clipCount) {
      this._doneCallback();
    }

    return this;
  },

  /**
   * Stop animation
   * @param {boolean} forwardToLast If move to last frame before stop
   */
  stop: function (forwardToLast) {
    var clipList = this._clipList;
    var animation = this.animation;

    for (var i = 0; i < clipList.length; i++) {
      var clip = clipList[i];

      if (forwardToLast) {
        // Move to last frame before stop
        clip.onframe(this._target, 1);
      }

      animation && animation.removeClip(clip);
    }

    clipList.length = 0;
  },

  /**
   * Set when animation delay starts
   * @param  {number} time 单位ms
   * @return {module:zrender/animation/Animator}
   */
  delay: function (time) {
    this._delay = time;
    return this;
  },

  /**
   * Add callback for animation end
   * @param  {Function} cb
   * @return {module:zrender/animation/Animator}
   */
  done: function (cb) {
    if (cb) {
      this._doneList.push(cb);
    }

    return this;
  },

  /**
   * @return {Array.<module:zrender/animation/Clip>}
   */
  getClips: function () {
    return this._clipList;
  }
};
var _default = Animator;
module.exports = _default;

/***/ }),
/* 617 */
/***/ (function(module, exports) {

// Simple LRU cache use doubly linked list
// @module zrender/core/LRU

/**
 * Simple double linked list. Compared with array, it has O(1) remove operation.
 * @constructor
 */
var LinkedList = function () {
  /**
   * @type {module:zrender/core/LRU~Entry}
   */
  this.head = null;
  /**
   * @type {module:zrender/core/LRU~Entry}
   */

  this.tail = null;
  this._len = 0;
};

var linkedListProto = LinkedList.prototype;
/**
 * Insert a new value at the tail
 * @param  {} val
 * @return {module:zrender/core/LRU~Entry}
 */

linkedListProto.insert = function (val) {
  var entry = new Entry(val);
  this.insertEntry(entry);
  return entry;
};
/**
 * Insert an entry at the tail
 * @param  {module:zrender/core/LRU~Entry} entry
 */


linkedListProto.insertEntry = function (entry) {
  if (!this.head) {
    this.head = this.tail = entry;
  } else {
    this.tail.next = entry;
    entry.prev = this.tail;
    entry.next = null;
    this.tail = entry;
  }

  this._len++;
};
/**
 * Remove entry.
 * @param  {module:zrender/core/LRU~Entry} entry
 */


linkedListProto.remove = function (entry) {
  var prev = entry.prev;
  var next = entry.next;

  if (prev) {
    prev.next = next;
  } else {
    // Is head
    this.head = next;
  }

  if (next) {
    next.prev = prev;
  } else {
    // Is tail
    this.tail = prev;
  }

  entry.next = entry.prev = null;
  this._len--;
};
/**
 * @return {number}
 */


linkedListProto.len = function () {
  return this._len;
};
/**
 * Clear list
 */


linkedListProto.clear = function () {
  this.head = this.tail = null;
  this._len = 0;
};
/**
 * @constructor
 * @param {} val
 */


var Entry = function (val) {
  /**
   * @type {}
   */
  this.value = val;
  /**
   * @type {module:zrender/core/LRU~Entry}
   */

  this.next;
  /**
   * @type {module:zrender/core/LRU~Entry}
   */

  this.prev;
};
/**
 * LRU Cache
 * @constructor
 * @alias module:zrender/core/LRU
 */


var LRU = function (maxSize) {
  this._list = new LinkedList();
  this._map = {};
  this._maxSize = maxSize || 10;
  this._lastRemovedEntry = null;
};

var LRUProto = LRU.prototype;
/**
 * @param  {string} key
 * @param  {} value
 * @return {} Removed value
 */

LRUProto.put = function (key, value) {
  var list = this._list;
  var map = this._map;
  var removed = null;

  if (map[key] == null) {
    var len = list.len(); // Reuse last removed entry

    var entry = this._lastRemovedEntry;

    if (len >= this._maxSize && len > 0) {
      // Remove the least recently used
      var leastUsedEntry = list.head;
      list.remove(leastUsedEntry);
      delete map[leastUsedEntry.key];
      removed = leastUsedEntry.value;
      this._lastRemovedEntry = leastUsedEntry;
    }

    if (entry) {
      entry.value = value;
    } else {
      entry = new Entry(value);
    }

    entry.key = key;
    list.insertEntry(entry);
    map[key] = entry;
  }

  return removed;
};
/**
 * @param  {string} key
 * @return {}
 */


LRUProto.get = function (key) {
  var entry = this._map[key];
  var list = this._list;

  if (entry != null) {
    // Put the latest used entry in the tail
    if (entry !== list.tail) {
      list.remove(entry);
      list.insertEntry(entry);
    }

    return entry.value;
  }
};
/**
 * Clear the cache
 */


LRUProto.clear = function () {
  this._list.clear();

  this._map = {};
};

var _default = LRU;
module.exports = _default;

/***/ }),
/* 618 */
/***/ (function(module, exports) {

var SHADOW_PROPS = {
  'shadowBlur': 1,
  'shadowOffsetX': 1,
  'shadowOffsetY': 1,
  'textShadowBlur': 1,
  'textShadowOffsetX': 1,
  'textShadowOffsetY': 1,
  'textBoxShadowBlur': 1,
  'textBoxShadowOffsetX': 1,
  'textBoxShadowOffsetY': 1
};

function _default(ctx, propName, value) {
  if (SHADOW_PROPS.hasOwnProperty(propName)) {
    return value *= ctx.dpr;
  }

  return value;
}

module.exports = _default;

/***/ }),
/* 619 */
/***/ (function(module, exports) {

var Pattern = function (image, repeat) {
  // Should do nothing more in this constructor. Because gradient can be
  // declard by `color: {image: ...}`, where this constructor will not be called.
  this.image = image;
  this.repeat = repeat; // Can be cloned

  this.type = 'pattern';
};

Pattern.prototype.getCanvasPattern = function (ctx) {
  return ctx.createPattern(this.image, this.repeat || 'repeat');
};

var _default = Pattern;
module.exports = _default;

/***/ }),
/* 620 */
/***/ (function(module, exports) {

var _default = typeof window !== 'undefined' && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || // https://github.com/ecomfe/zrender/issues/189#issuecomment-224919809
window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function (func) {
  setTimeout(func, 16);
};

module.exports = _default;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

var textHelper = __webpack_require__(295);

var BoundingRect = __webpack_require__(57);

var _constant = __webpack_require__(294);

var WILL_BE_RESTORED = _constant.WILL_BE_RESTORED;

/**
 * Mixin for drawing text in a element bounding rect
 * @module zrender/mixin/RectText
 */
var tmpRect = new BoundingRect();

var RectText = function () {};

RectText.prototype = {
  constructor: RectText,

  /**
   * Draw text in a rect with specified position.
   * @param  {CanvasRenderingContext2D} ctx
   * @param  {Object} rect Displayable rect
   */
  drawRectText: function (ctx, rect) {
    var style = this.style;
    rect = style.textRect || rect; // Optimize, avoid normalize every time.

    this.__dirty && textHelper.normalizeTextStyle(style, true);
    var text = style.text; // Convert to string

    text != null && (text += '');

    if (!textHelper.needDrawText(text, style)) {
      return;
    } // FIXME
    // Do not provide prevEl to `textHelper.renderText` for ctx prop cache,
    // but use `ctx.save()` and `ctx.restore()`. Because the cache for rect
    // text propably break the cache for its host elements.


    ctx.save(); // Transform rect to view space

    var transform = this.transform;

    if (!style.transformText) {
      if (transform) {
        tmpRect.copy(rect);
        tmpRect.applyTransform(transform);
        rect = tmpRect;
      }
    } else {
      this.setTransform(ctx);
    } // transformText and textRotation can not be used at the same time.


    textHelper.renderText(this, ctx, text, style, rect, WILL_BE_RESTORED);
    ctx.restore();
  }
};
var _default = RectText;
module.exports = _default;

/***/ }),
/* 622 */
/***/ (function(module, exports) {

/**
 * @param {Object} ctx
 * @param {Object} shape
 * @param {number} shape.x
 * @param {number} shape.y
 * @param {number} shape.width
 * @param {number} shape.height
 * @param {number} shape.r
 */
function buildPath(ctx, shape) {
  var x = shape.x;
  var y = shape.y;
  var width = shape.width;
  var height = shape.height;
  var r = shape.r;
  var r1;
  var r2;
  var r3;
  var r4; // Convert width and height to positive for better borderRadius

  if (width < 0) {
    x = x + width;
    width = -width;
  }

  if (height < 0) {
    y = y + height;
    height = -height;
  }

  if (typeof r === 'number') {
    r1 = r2 = r3 = r4 = r;
  } else if (r instanceof Array) {
    if (r.length === 1) {
      r1 = r2 = r3 = r4 = r[0];
    } else if (r.length === 2) {
      r1 = r3 = r[0];
      r2 = r4 = r[1];
    } else if (r.length === 3) {
      r1 = r[0];
      r2 = r4 = r[1];
      r3 = r[2];
    } else {
      r1 = r[0];
      r2 = r[1];
      r3 = r[2];
      r4 = r[3];
    }
  } else {
    r1 = r2 = r3 = r4 = 0;
  }

  var total;

  if (r1 + r2 > width) {
    total = r1 + r2;
    r1 *= width / total;
    r2 *= width / total;
  }

  if (r3 + r4 > width) {
    total = r3 + r4;
    r3 *= width / total;
    r4 *= width / total;
  }

  if (r2 + r3 > height) {
    total = r2 + r3;
    r2 *= height / total;
    r3 *= height / total;
  }

  if (r1 + r4 > height) {
    total = r1 + r4;
    r1 *= height / total;
    r4 *= height / total;
  }

  ctx.moveTo(x + r1, y);
  ctx.lineTo(x + width - r2, y);
  r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
  ctx.lineTo(x + width, y + height - r3);
  r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
  ctx.lineTo(x + r4, y + height);
  r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
  ctx.lineTo(x, y + r1);
  r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
}

exports.buildPath = buildPath;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var _util = __webpack_require__(1);

var each = _util.each;
var filter = _util.filter;
var map = _util.map;
var isArray = _util.isArray;
var indexOf = _util.indexOf;
var isObject = _util.isObject;
var isString = _util.isString;
var createHashMap = _util.createHashMap;
var assert = _util.assert;
var clone = _util.clone;
var merge = _util.merge;
var extend = _util.extend;
var mixin = _util.mixin;

var modelUtil = __webpack_require__(44);

var Model = __webpack_require__(68);

var ComponentModel = __webpack_require__(73);

var globalDefault = __webpack_require__(1555);

var colorPaletteMixin = __webpack_require__(635);

var _sourceHelper = __webpack_require__(136);

var resetSourceDefaulter = _sourceHelper.resetSourceDefaulter;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * ECharts global model
 *
 * @module {echarts/model/Global}
 */

/**
 * Caution: If the mechanism should be changed some day, these cases
 * should be considered:
 *
 * (1) In `merge option` mode, if using the same option to call `setOption`
 * many times, the result should be the same (try our best to ensure that).
 * (2) In `merge option` mode, if a component has no id/name specified, it
 * will be merged by index, and the result sequence of the components is
 * consistent to the original sequence.
 * (3) `reset` feature (in toolbox). Find detailed info in comments about
 * `mergeOption` in module:echarts/model/OptionManager.
 */
var OPTION_INNER_KEY = '\0_ec_inner';
/**
 * @alias module:echarts/model/Global
 *
 * @param {Object} option
 * @param {module:echarts/model/Model} parentModel
 * @param {Object} theme
 */

var GlobalModel = Model.extend({
  init: function (option, parentModel, theme, optionManager) {
    theme = theme || {};
    this.option = null; // Mark as not initialized.

    /**
     * @type {module:echarts/model/Model}
     * @private
     */

    this._theme = new Model(theme);
    /**
     * @type {module:echarts/model/OptionManager}
     */

    this._optionManager = optionManager;
  },
  setOption: function (option, optionPreprocessorFuncs) {
    assert(!(OPTION_INNER_KEY in option), 'please use chart.getOption()');

    this._optionManager.setOption(option, optionPreprocessorFuncs);

    this.resetOption(null);
  },

  /**
   * @param {string} type null/undefined: reset all.
   *                      'recreate': force recreate all.
   *                      'timeline': only reset timeline option
   *                      'media': only reset media query option
   * @return {boolean} Whether option changed.
   */
  resetOption: function (type) {
    var optionChanged = false;
    var optionManager = this._optionManager;

    if (!type || type === 'recreate') {
      var baseOption = optionManager.mountOption(type === 'recreate');

      if (!this.option || type === 'recreate') {
        initBase.call(this, baseOption);
      } else {
        this.restoreData();
        this.mergeOption(baseOption);
      }

      optionChanged = true;
    }

    if (type === 'timeline' || type === 'media') {
      this.restoreData();
    }

    if (!type || type === 'recreate' || type === 'timeline') {
      var timelineOption = optionManager.getTimelineOption(this);
      timelineOption && (this.mergeOption(timelineOption), optionChanged = true);
    }

    if (!type || type === 'recreate' || type === 'media') {
      var mediaOptions = optionManager.getMediaOption(this, this._api);

      if (mediaOptions.length) {
        each(mediaOptions, function (mediaOption) {
          this.mergeOption(mediaOption, optionChanged = true);
        }, this);
      }
    }

    return optionChanged;
  },

  /**
   * @protected
   */
  mergeOption: function (newOption) {
    var option = this.option;
    var componentsMap = this._componentsMap;
    var newCptTypes = [];
    resetSourceDefaulter(this); // If no component class, merge directly.
    // For example: color, animaiton options, etc.

    each(newOption, function (componentOption, mainType) {
      if (componentOption == null) {
        return;
      }

      if (!ComponentModel.hasClass(mainType)) {
        // globalSettingTask.dirty();
        option[mainType] = option[mainType] == null ? clone(componentOption) : merge(option[mainType], componentOption, true);
      } else if (mainType) {
        newCptTypes.push(mainType);
      }
    });
    ComponentModel.topologicalTravel(newCptTypes, ComponentModel.getAllClassMainTypes(), visitComponent, this);

    function visitComponent(mainType, dependencies) {
      var newCptOptionList = modelUtil.normalizeToArray(newOption[mainType]);
      var mapResult = modelUtil.mappingToExists(componentsMap.get(mainType), newCptOptionList);
      modelUtil.makeIdAndName(mapResult); // Set mainType and complete subType.

      each(mapResult, function (item, index) {
        var opt = item.option;

        if (isObject(opt)) {
          item.keyInfo.mainType = mainType;
          item.keyInfo.subType = determineSubType(mainType, opt, item.exist);
        }
      });
      var dependentModels = getComponentsByTypes(componentsMap, dependencies);
      option[mainType] = [];
      componentsMap.set(mainType, []);
      each(mapResult, function (resultItem, index) {
        var componentModel = resultItem.exist;
        var newCptOption = resultItem.option;
        assert(isObject(newCptOption) || componentModel, 'Empty component definition'); // Consider where is no new option and should be merged using {},
        // see removeEdgeAndAdd in topologicalTravel and
        // ComponentModel.getAllClassMainTypes.

        if (!newCptOption) {
          componentModel.mergeOption({}, this);
          componentModel.optionUpdated({}, false);
        } else {
          var ComponentModelClass = ComponentModel.getClass(mainType, resultItem.keyInfo.subType, true);

          if (componentModel && componentModel.constructor === ComponentModelClass) {
            componentModel.name = resultItem.keyInfo.name; // componentModel.settingTask && componentModel.settingTask.dirty();

            componentModel.mergeOption(newCptOption, this);
            componentModel.optionUpdated(newCptOption, false);
          } else {
            // PENDING Global as parent ?
            var extraOpt = extend({
              dependentModels: dependentModels,
              componentIndex: index
            }, resultItem.keyInfo);
            componentModel = new ComponentModelClass(newCptOption, this, this, extraOpt);
            extend(componentModel, extraOpt);
            componentModel.init(newCptOption, this, this, extraOpt); // Call optionUpdated after init.
            // newCptOption has been used as componentModel.option
            // and may be merged with theme and default, so pass null
            // to avoid confusion.

            componentModel.optionUpdated(null, true);
          }
        }

        componentsMap.get(mainType)[index] = componentModel;
        option[mainType][index] = componentModel.option;
      }, this); // Backup series for filtering.

      if (mainType === 'series') {
        createSeriesIndices(this, componentsMap.get('series'));
      }
    }

    this._seriesIndicesMap = createHashMap(this._seriesIndices = this._seriesIndices || []);
  },

  /**
   * Get option for output (cloned option and inner info removed)
   * @public
   * @return {Object}
   */
  getOption: function () {
    var option = clone(this.option);
    each(option, function (opts, mainType) {
      if (ComponentModel.hasClass(mainType)) {
        var opts = modelUtil.normalizeToArray(opts);

        for (var i = opts.length - 1; i >= 0; i--) {
          // Remove options with inner id.
          if (modelUtil.isIdInner(opts[i])) {
            opts.splice(i, 1);
          }
        }

        option[mainType] = opts;
      }
    });
    delete option[OPTION_INNER_KEY];
    return option;
  },

  /**
   * @return {module:echarts/model/Model}
   */
  getTheme: function () {
    return this._theme;
  },

  /**
   * @param {string} mainType
   * @param {number} [idx=0]
   * @return {module:echarts/model/Component}
   */
  getComponent: function (mainType, idx) {
    var list = this._componentsMap.get(mainType);

    if (list) {
      return list[idx || 0];
    }
  },

  /**
   * If none of index and id and name used, return all components with mainType.
   * @param {Object} condition
   * @param {string} condition.mainType
   * @param {string} [condition.subType] If ignore, only query by mainType
   * @param {number|Array.<number>} [condition.index] Either input index or id or name.
   * @param {string|Array.<string>} [condition.id] Either input index or id or name.
   * @param {string|Array.<string>} [condition.name] Either input index or id or name.
   * @return {Array.<module:echarts/model/Component>}
   */
  queryComponents: function (condition) {
    var mainType = condition.mainType;

    if (!mainType) {
      return [];
    }

    var index = condition.index;
    var id = condition.id;
    var name = condition.name;

    var cpts = this._componentsMap.get(mainType);

    if (!cpts || !cpts.length) {
      return [];
    }

    var result;

    if (index != null) {
      if (!isArray(index)) {
        index = [index];
      }

      result = filter(map(index, function (idx) {
        return cpts[idx];
      }), function (val) {
        return !!val;
      });
    } else if (id != null) {
      var isIdArray = isArray(id);
      result = filter(cpts, function (cpt) {
        return isIdArray && indexOf(id, cpt.id) >= 0 || !isIdArray && cpt.id === id;
      });
    } else if (name != null) {
      var isNameArray = isArray(name);
      result = filter(cpts, function (cpt) {
        return isNameArray && indexOf(name, cpt.name) >= 0 || !isNameArray && cpt.name === name;
      });
    } else {
      // Return all components with mainType
      result = cpts.slice();
    }

    return filterBySubType(result, condition);
  },

  /**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * var result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * var result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * var result = findComponents(
   *     {mainType: 'series',
   *     filter: function (model, index) {...}}
   * );
   * // result like [component0, componnet1, ...]
   *
   * @param {Object} condition
   * @param {string} condition.mainType Mandatory.
   * @param {string} [condition.subType] Optional.
   * @param {Object} [condition.query] like {xxxIndex, xxxId, xxxName},
   *        where xxx is mainType.
   *        If query attribute is null/undefined or has no index/id/name,
   *        do not filtering by query conditions, which is convenient for
   *        no-payload situations or when target of action is global.
   * @param {Function} [condition.filter] parameter: component, return boolean.
   * @return {Array.<module:echarts/model/Component>}
   */
  findComponents: function (condition) {
    var query = condition.query;
    var mainType = condition.mainType;
    var queryCond = getQueryCond(query);
    var result = queryCond ? this.queryComponents(queryCond) : this._componentsMap.get(mainType);
    return doFilter(filterBySubType(result, condition));

    function getQueryCond(q) {
      var indexAttr = mainType + 'Index';
      var idAttr = mainType + 'Id';
      var nameAttr = mainType + 'Name';
      return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
        mainType: mainType,
        // subType will be filtered finally.
        index: q[indexAttr],
        id: q[idAttr],
        name: q[nameAttr]
      } : null;
    }

    function doFilter(res) {
      return condition.filter ? filter(res, condition.filter) : res;
    }
  },

  /**
   * @usage
   * eachComponent('legend', function (legendModel, index) {
   *     ...
   * });
   * eachComponent(function (componentType, model, index) {
   *     // componentType does not include subType
   *     // (componentType is 'xxx' but not 'xxx.aa')
   * });
   * eachComponent(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}},
   *     function (model, index) {...}
   * );
   * eachComponent(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}},
   *     function (model, index) {...}
   * );
   *
   * @param {string|Object=} mainType When mainType is object, the definition
   *                                  is the same as the method 'findComponents'.
   * @param {Function} cb
   * @param {*} context
   */
  eachComponent: function (mainType, cb, context) {
    var componentsMap = this._componentsMap;

    if (typeof mainType === 'function') {
      context = cb;
      cb = mainType;
      componentsMap.each(function (components, componentType) {
        each(components, function (component, index) {
          cb.call(context, componentType, component, index);
        });
      });
    } else if (isString(mainType)) {
      each(componentsMap.get(mainType), cb, context);
    } else if (isObject(mainType)) {
      var queryResult = this.findComponents(mainType);
      each(queryResult, cb, context);
    }
  },

  /**
   * @param {string} name
   * @return {Array.<module:echarts/model/Series>}
   */
  getSeriesByName: function (name) {
    var series = this._componentsMap.get('series');

    return filter(series, function (oneSeries) {
      return oneSeries.name === name;
    });
  },

  /**
   * @param {number} seriesIndex
   * @return {module:echarts/model/Series}
   */
  getSeriesByIndex: function (seriesIndex) {
    return this._componentsMap.get('series')[seriesIndex];
  },

  /**
   * Get series list before filtered by type.
   * FIXME: rename to getRawSeriesByType?
   *
   * @param {string} subType
   * @return {Array.<module:echarts/model/Series>}
   */
  getSeriesByType: function (subType) {
    var series = this._componentsMap.get('series');

    return filter(series, function (oneSeries) {
      return oneSeries.subType === subType;
    });
  },

  /**
   * @return {Array.<module:echarts/model/Series>}
   */
  getSeries: function () {
    return this._componentsMap.get('series').slice();
  },

  /**
   * @return {number}
   */
  getSeriesCount: function () {
    return this._componentsMap.get('series').length;
  },

  /**
   * After filtering, series may be different
   * frome raw series.
   *
   * @param {Function} cb
   * @param {*} context
   */
  eachSeries: function (cb, context) {
    assertSeriesInitialized(this);
    each(this._seriesIndices, function (rawSeriesIndex) {
      var series = this._componentsMap.get('series')[rawSeriesIndex];

      cb.call(context, series, rawSeriesIndex);
    }, this);
  },

  /**
   * Iterate raw series before filtered.
   *
   * @param {Function} cb
   * @param {*} context
   */
  eachRawSeries: function (cb, context) {
    each(this._componentsMap.get('series'), cb, context);
  },

  /**
   * After filtering, series may be different.
   * frome raw series.
   *
   * @param {string} subType.
   * @param {Function} cb
   * @param {*} context
   */
  eachSeriesByType: function (subType, cb, context) {
    assertSeriesInitialized(this);
    each(this._seriesIndices, function (rawSeriesIndex) {
      var series = this._componentsMap.get('series')[rawSeriesIndex];

      if (series.subType === subType) {
        cb.call(context, series, rawSeriesIndex);
      }
    }, this);
  },

  /**
   * Iterate raw series before filtered of given type.
   *
   * @parma {string} subType
   * @param {Function} cb
   * @param {*} context
   */
  eachRawSeriesByType: function (subType, cb, context) {
    return each(this.getSeriesByType(subType), cb, context);
  },

  /**
   * @param {module:echarts/model/Series} seriesModel
   */
  isSeriesFiltered: function (seriesModel) {
    assertSeriesInitialized(this);
    return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
  },

  /**
   * @return {Array.<number>}
   */
  getCurrentSeriesIndices: function () {
    return (this._seriesIndices || []).slice();
  },

  /**
   * @param {Function} cb
   * @param {*} context
   */
  filterSeries: function (cb, context) {
    assertSeriesInitialized(this);
    var filteredSeries = filter(this._componentsMap.get('series'), cb, context);
    createSeriesIndices(this, filteredSeries);
  },
  restoreData: function (payload) {
    var componentsMap = this._componentsMap;
    createSeriesIndices(this, componentsMap.get('series'));
    var componentTypes = [];
    componentsMap.each(function (components, componentType) {
      componentTypes.push(componentType);
    });
    ComponentModel.topologicalTravel(componentTypes, ComponentModel.getAllClassMainTypes(), function (componentType, dependencies) {
      each(componentsMap.get(componentType), function (component) {
        (componentType !== 'series' || !isNotTargetSeries(component, payload)) && component.restoreData();
      });
    });
  }
});

function isNotTargetSeries(seriesModel, payload) {
  if (payload) {
    var index = payload.seiresIndex;
    var id = payload.seriesId;
    var name = payload.seriesName;
    return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name != null && seriesModel.name !== name;
  }
}
/**
 * @inner
 */


function mergeTheme(option, theme) {
  // PENDING
  // NOT use `colorLayer` in theme if option has `color`
  var notMergeColorLayer = option.color && !option.colorLayer;
  each(theme, function (themeItem, name) {
    if (name === 'colorLayer' && notMergeColorLayer) {
      return;
    } // 如果有 component model 则把具体的 merge 逻辑交给该 model 处理


    if (!ComponentModel.hasClass(name)) {
      if (typeof themeItem === 'object') {
        option[name] = !option[name] ? clone(themeItem) : merge(option[name], themeItem, false);
      } else {
        if (option[name] == null) {
          option[name] = themeItem;
        }
      }
    }
  });
}

function initBase(baseOption) {
  baseOption = baseOption; // Using OPTION_INNER_KEY to mark that this option can not be used outside,
  // i.e. `chart.setOption(chart.getModel().option);` is forbiden.

  this.option = {};
  this.option[OPTION_INNER_KEY] = 1;
  /**
   * Init with series: [], in case of calling findSeries method
   * before series initialized.
   * @type {Object.<string, Array.<module:echarts/model/Model>>}
   * @private
   */

  this._componentsMap = createHashMap({
    series: []
  });
  /**
   * Mapping between filtered series list and raw series list.
   * key: filtered series indices, value: raw series indices.
   * @type {Array.<nubmer>}
   * @private
   */

  this._seriesIndices;
  this._seriesIndicesMap;
  mergeTheme(baseOption, this._theme.option); // TODO Needs clone when merging to the unexisted property

  merge(baseOption, globalDefault, false);
  this.mergeOption(baseOption);
}
/**
 * @inner
 * @param {Array.<string>|string} types model types
 * @return {Object} key: {string} type, value: {Array.<Object>} models
 */


function getComponentsByTypes(componentsMap, types) {
  if (!isArray(types)) {
    types = types ? [types] : [];
  }

  var ret = {};
  each(types, function (type) {
    ret[type] = (componentsMap.get(type) || []).slice();
  });
  return ret;
}
/**
 * @inner
 */


function determineSubType(mainType, newCptOption, existComponent) {
  var subType = newCptOption.type ? newCptOption.type : existComponent ? existComponent.subType // Use determineSubType only when there is no existComponent.
  : ComponentModel.determineSubType(mainType, newCptOption); // tooltip, markline, markpoint may always has no subType

  return subType;
}
/**
 * @inner
 */


function createSeriesIndices(ecModel, seriesModels) {
  ecModel._seriesIndicesMap = createHashMap(ecModel._seriesIndices = map(seriesModels, function (series) {
    return series.componentIndex;
  }) || []);
}
/**
 * @inner
 */


function filterBySubType(components, condition) {
  // Using hasOwnProperty for restrict. Consider
  // subType is undefined in user payload.
  return condition.hasOwnProperty('subType') ? filter(components, function (cpt) {
    return cpt.subType === condition.subType;
  }) : components;
}
/**
 * @inner
 */


function assertSeriesInitialized(ecModel) {}

mixin(GlobalModel, colorPaletteMixin);
var _default = GlobalModel;
module.exports = _default;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(65);

var PathProxy = __webpack_require__(205);

var transformPath = __webpack_require__(1544);

// command chars
// var cc = [
//     'm', 'M', 'l', 'L', 'v', 'V', 'h', 'H', 'z', 'Z',
//     'c', 'C', 'q', 'Q', 't', 'T', 's', 'S', 'a', 'A'
// ];
var mathSqrt = Math.sqrt;
var mathSin = Math.sin;
var mathCos = Math.cos;
var PI = Math.PI;

var vMag = function (v) {
  return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
};

var vRatio = function (u, v) {
  return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
};

var vAngle = function (u, v) {
  return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
};

function processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
  var psi = psiDeg * (PI / 180.0);
  var xp = mathCos(psi) * (x1 - x2) / 2.0 + mathSin(psi) * (y1 - y2) / 2.0;
  var yp = -1 * mathSin(psi) * (x1 - x2) / 2.0 + mathCos(psi) * (y1 - y2) / 2.0;
  var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);

  if (lambda > 1) {
    rx *= mathSqrt(lambda);
    ry *= mathSqrt(lambda);
  }

  var f = (fa === fs ? -1 : 1) * mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
  var cxp = f * rx * yp / ry;
  var cyp = f * -ry * xp / rx;
  var cx = (x1 + x2) / 2.0 + mathCos(psi) * cxp - mathSin(psi) * cyp;
  var cy = (y1 + y2) / 2.0 + mathSin(psi) * cxp + mathCos(psi) * cyp;
  var theta = vAngle([1, 0], [(xp - cxp) / rx, (yp - cyp) / ry]);
  var u = [(xp - cxp) / rx, (yp - cyp) / ry];
  var v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
  var dTheta = vAngle(u, v);

  if (vRatio(u, v) <= -1) {
    dTheta = PI;
  }

  if (vRatio(u, v) >= 1) {
    dTheta = 0;
  }

  if (fs === 0 && dTheta > 0) {
    dTheta = dTheta - 2 * PI;
  }

  if (fs === 1 && dTheta < 0) {
    dTheta = dTheta + 2 * PI;
  }

  path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
}

var commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig; // Consider case:
// (1) delimiter can be comma or space, where continuous commas
// or spaces should be seen as one comma.
// (2) value can be like:
// '2e-4', 'l.5.9' (ignore 0), 'M-10-10', 'l-2.43e-1,34.9983',
// 'l-.5E1,54', '121-23-44-11' (no delimiter)

var numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g; // var valueSplitReg = /[\s,]+/;

function createPathProxyFromString(data) {
  if (!data) {
    return new PathProxy();
  } // var data = data.replace(/-/g, ' -')
  //     .replace(/  /g, ' ')
  //     .replace(/ /g, ',')
  //     .replace(/,,/g, ',');
  // var n;
  // create pipes so that we can split the data
  // for (n = 0; n < cc.length; n++) {
  //     cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
  // }
  // data = data.replace(/-/g, ',-');
  // create array
  // var arr = cs.split('|');
  // init context point


  var cpx = 0;
  var cpy = 0;
  var subpathX = cpx;
  var subpathY = cpy;
  var prevCmd;
  var path = new PathProxy();
  var CMD = PathProxy.CMD; // commandReg.lastIndex = 0;
  // var cmdResult;
  // while ((cmdResult = commandReg.exec(data)) != null) {
  //     var cmdStr = cmdResult[1];
  //     var cmdContent = cmdResult[2];

  var cmdList = data.match(commandReg);

  for (var l = 0; l < cmdList.length; l++) {
    var cmdText = cmdList[l];
    var cmdStr = cmdText.charAt(0);
    var cmd; // String#split is faster a little bit than String#replace or RegExp#exec.
    // var p = cmdContent.split(valueSplitReg);
    // var pLen = 0;
    // for (var i = 0; i < p.length; i++) {
    //     // '' and other invalid str => NaN
    //     var val = parseFloat(p[i]);
    //     !isNaN(val) && (p[pLen++] = val);
    // }

    var p = cmdText.match(numberReg) || [];
    var pLen = p.length;

    for (var i = 0; i < pLen; i++) {
      p[i] = parseFloat(p[i]);
    }

    var off = 0;

    while (off < pLen) {
      var ctlPtx;
      var ctlPty;
      var rx;
      var ry;
      var psi;
      var fa;
      var fs;
      var x1 = cpx;
      var y1 = cpy; // convert l, H, h, V, and v to L

      switch (cmdStr) {
        case 'l':
          cpx += p[off++];
          cpy += p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'L':
          cpx = p[off++];
          cpy = p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'm':
          cpx += p[off++];
          cpy += p[off++];
          cmd = CMD.M;
          path.addData(cmd, cpx, cpy);
          subpathX = cpx;
          subpathY = cpy;
          cmdStr = 'l';
          break;

        case 'M':
          cpx = p[off++];
          cpy = p[off++];
          cmd = CMD.M;
          path.addData(cmd, cpx, cpy);
          subpathX = cpx;
          subpathY = cpy;
          cmdStr = 'L';
          break;

        case 'h':
          cpx += p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'H':
          cpx = p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'v':
          cpy += p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'V':
          cpy = p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'C':
          cmd = CMD.C;
          path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
          cpx = p[off - 2];
          cpy = p[off - 1];
          break;

        case 'c':
          cmd = CMD.C;
          path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
          cpx += p[off - 2];
          cpy += p[off - 1];
          break;

        case 'S':
          ctlPtx = cpx;
          ctlPty = cpy;
          var len = path.len();
          var pathData = path.data;

          if (prevCmd === CMD.C) {
            ctlPtx += cpx - pathData[len - 4];
            ctlPty += cpy - pathData[len - 3];
          }

          cmd = CMD.C;
          x1 = p[off++];
          y1 = p[off++];
          cpx = p[off++];
          cpy = p[off++];
          path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
          break;

        case 's':
          ctlPtx = cpx;
          ctlPty = cpy;
          var len = path.len();
          var pathData = path.data;

          if (prevCmd === CMD.C) {
            ctlPtx += cpx - pathData[len - 4];
            ctlPty += cpy - pathData[len - 3];
          }

          cmd = CMD.C;
          x1 = cpx + p[off++];
          y1 = cpy + p[off++];
          cpx += p[off++];
          cpy += p[off++];
          path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
          break;

        case 'Q':
          x1 = p[off++];
          y1 = p[off++];
          cpx = p[off++];
          cpy = p[off++];
          cmd = CMD.Q;
          path.addData(cmd, x1, y1, cpx, cpy);
          break;

        case 'q':
          x1 = p[off++] + cpx;
          y1 = p[off++] + cpy;
          cpx += p[off++];
          cpy += p[off++];
          cmd = CMD.Q;
          path.addData(cmd, x1, y1, cpx, cpy);
          break;

        case 'T':
          ctlPtx = cpx;
          ctlPty = cpy;
          var len = path.len();
          var pathData = path.data;

          if (prevCmd === CMD.Q) {
            ctlPtx += cpx - pathData[len - 4];
            ctlPty += cpy - pathData[len - 3];
          }

          cpx = p[off++];
          cpy = p[off++];
          cmd = CMD.Q;
          path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
          break;

        case 't':
          ctlPtx = cpx;
          ctlPty = cpy;
          var len = path.len();
          var pathData = path.data;

          if (prevCmd === CMD.Q) {
            ctlPtx += cpx - pathData[len - 4];
            ctlPty += cpy - pathData[len - 3];
          }

          cpx += p[off++];
          cpy += p[off++];
          cmd = CMD.Q;
          path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
          break;

        case 'A':
          rx = p[off++];
          ry = p[off++];
          psi = p[off++];
          fa = p[off++];
          fs = p[off++];
          x1 = cpx, y1 = cpy;
          cpx = p[off++];
          cpy = p[off++];
          cmd = CMD.A;
          processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
          break;

        case 'a':
          rx = p[off++];
          ry = p[off++];
          psi = p[off++];
          fa = p[off++];
          fs = p[off++];
          x1 = cpx, y1 = cpy;
          cpx += p[off++];
          cpy += p[off++];
          cmd = CMD.A;
          processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
          break;
      }
    }

    if (cmdStr === 'z' || cmdStr === 'Z') {
      cmd = CMD.Z;
      path.addData(cmd); // z may be in the middle of the path.

      cpx = subpathX;
      cpy = subpathY;
    }

    prevCmd = cmd;
  }

  path.toStatic();
  return path;
} // TODO Optimize double memory cost problem


function createPathOptions(str, opts) {
  var pathProxy = createPathProxyFromString(str);
  opts = opts || {};

  opts.buildPath = function (path) {
    if (path.setData) {
      path.setData(pathProxy.data); // Svg and vml renderer don't have context

      var ctx = path.getContext();

      if (ctx) {
        path.rebuildPath(ctx);
      }
    } else {
      var ctx = path;
      pathProxy.rebuildPath(ctx);
    }
  };

  opts.applyTransform = function (m) {
    transformPath(pathProxy, m);
    this.dirty(true);
  };

  return opts;
}
/**
 * Create a Path object from path string data
 * http://www.w3.org/TR/SVG/paths.html#PathData
 * @param  {Object} opts Other options
 */


function createFromString(str, opts) {
  return new Path(createPathOptions(str, opts));
}
/**
 * Create a Path class from path string data
 * @param  {string} str
 * @param  {Object} opts Other options
 */


function extendFromString(str, opts) {
  return Path.extend(createPathOptions(str, opts));
}
/**
 * Merge multiple paths
 */
// TODO Apply transform
// TODO stroke dash
// TODO Optimize double memory cost problem


function mergePath(pathEls, opts) {
  var pathList = [];
  var len = pathEls.length;

  for (var i = 0; i < len; i++) {
    var pathEl = pathEls[i];

    if (!pathEl.path) {
      pathEl.createPathProxy();
    }

    if (pathEl.__dirtyPath) {
      pathEl.buildPath(pathEl.path, pathEl.shape, true);
    }

    pathList.push(pathEl.path);
  }

  var pathBundle = new Path(opts); // Need path proxy.

  pathBundle.createPathProxy();

  pathBundle.buildPath = function (path) {
    path.appendPath(pathList); // Svg and vml renderer don't have context

    var ctx = path.getContext();

    if (ctx) {
      path.rebuildPath(ctx);
    }
  };

  return pathBundle;
}

exports.createFromString = createFromString;
exports.extendFromString = extendFromString;
exports.mergePath = mergePath;

/***/ }),
/* 625 */
/***/ (function(module, exports) {

/**
 * 线段包含判断
 * @param  {number}  x0
 * @param  {number}  y0
 * @param  {number}  x1
 * @param  {number}  y1
 * @param  {number}  lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {boolean}
 */
function containStroke(x0, y0, x1, y1, lineWidth, x, y) {
  if (lineWidth === 0) {
    return false;
  }

  var _l = lineWidth;
  var _a = 0;
  var _b = x0; // Quick reject

  if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) {
    return false;
  }

  if (x0 !== x1) {
    _a = (y0 - y1) / (x0 - x1);
    _b = (x0 * y1 - x1 * y0) / (x0 - x1);
  } else {
    return Math.abs(x - x0) <= _l / 2;
  }

  var tmp = _a * x - y + _b;

  var _s = tmp * tmp / (_a * _a + 1);

  return _s <= _l / 2 * _l / 2;
}

exports.containStroke = containStroke;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var _curve = __webpack_require__(147);

var quadraticProjectPoint = _curve.quadraticProjectPoint;

/**
 * 二次贝塞尔曲线描边包含判断
 * @param  {number}  x0
 * @param  {number}  y0
 * @param  {number}  x1
 * @param  {number}  y1
 * @param  {number}  x2
 * @param  {number}  y2
 * @param  {number}  lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {boolean}
 */
function containStroke(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
  if (lineWidth === 0) {
    return false;
  }

  var _l = lineWidth; // Quick reject

  if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) {
    return false;
  }

  var d = quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, null);
  return d <= _l / 2;
}

exports.containStroke = containStroke;

/***/ }),
/* 627 */
/***/ (function(module, exports) {

var PI2 = Math.PI * 2;

function normalizeRadian(angle) {
  angle %= PI2;

  if (angle < 0) {
    angle += PI2;
  }

  return angle;
}

exports.normalizeRadian = normalizeRadian;

/***/ }),
/* 628 */
/***/ (function(module, exports) {

function windingLine(x0, y0, x1, y1, x, y) {
  if (y > y0 && y > y1 || y < y0 && y < y1) {
    return 0;
  } // Ignore horizontal line


  if (y1 === y0) {
    return 0;
  }

  var dir = y1 < y0 ? 1 : -1;
  var t = (y - y0) / (y1 - y0); // Avoid winding error when intersection point is the connect point of two line of polygon

  if (t === 1 || t === 0) {
    dir = y1 < y0 ? 0.5 : -0.5;
  }

  var x_ = t * (x1 - x0) + x0; // If (x, y) on the line, considered as "contain".

  return x_ === x ? Infinity : x_ > x ? dir : 0;
}

module.exports = windingLine;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(65);

/**
 * 圆形
 * @module zrender/shape/Circle
 */
var _default = Path.extend({
  type: 'circle',
  shape: {
    cx: 0,
    cy: 0,
    r: 0
  },
  buildPath: function (ctx, shape, inBundle) {
    // Better stroking in ShapeBundle
    // Always do it may have performence issue ( fill may be 2x more cost)
    if (inBundle) {
      ctx.moveTo(shape.cx + shape.r, shape.cy);
    } // else {
    //     if (ctx.allocate && !ctx.data.length) {
    //         ctx.allocate(ctx.CMD_MEM_SIZE.A);
    //     }
    // }
    // Better stroking in ShapeBundle
    // ctx.moveTo(shape.cx + shape.r, shape.cy);


    ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2, true);
  }
});

module.exports = _default;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var env = __webpack_require__(67);

// Fix weird bug in some version of IE11 (like 11.0.9600.178**),
// where exception "unexpected call to method or property access"
// might be thrown when calling ctx.fill or ctx.stroke after a path
// whose area size is zero is drawn and ctx.clip() is called and
// shadowBlur is set. See #4572, #3112, #5777.
// (e.g.,
//  ctx.moveTo(10, 10);
//  ctx.lineTo(20, 10);
//  ctx.closePath();
//  ctx.clip();
//  ctx.shadowBlur = 10;
//  ...
//  ctx.fill();
// )
var shadowTemp = [['shadowBlur', 0], ['shadowColor', '#000'], ['shadowOffsetX', 0], ['shadowOffsetY', 0]];

function _default(orignalBrush) {
  // version string can be: '11.0'
  return env.browser.ie && env.browser.version >= 11 ? function () {
    var clipPaths = this.__clipPaths;
    var style = this.style;
    var modified;

    if (clipPaths) {
      for (var i = 0; i < clipPaths.length; i++) {
        var clipPath = clipPaths[i];
        var shape = clipPath && clipPath.shape;
        var type = clipPath && clipPath.type;

        if (shape && (type === 'sector' && shape.startAngle === shape.endAngle || type === 'rect' && (!shape.width || !shape.height))) {
          for (var j = 0; j < shadowTemp.length; j++) {
            // It is save to put shadowTemp static, because shadowTemp
            // will be all modified each item brush called.
            shadowTemp[j][2] = style[shadowTemp[j][0]];
            style[shadowTemp[j][0]] = shadowTemp[j][1];
          }

          modified = true;
          break;
        }
      }
    }

    orignalBrush.apply(this, arguments);

    if (modified) {
      for (var j = 0; j < shadowTemp.length; j++) {
        style[shadowTemp[j][0]] = shadowTemp[j][2];
      }
    }
  } : orignalBrush;
}

module.exports = _default;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(65);

var polyHelper = __webpack_require__(632);

/**
 * 多边形
 * @module zrender/shape/Polygon
 */
var _default = Path.extend({
  type: 'polygon',
  shape: {
    points: null,
    smooth: false,
    smoothConstraint: null
  },
  buildPath: function (ctx, shape) {
    polyHelper.buildPath(ctx, shape, true);
  }
});

module.exports = _default;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var smoothSpline = __webpack_require__(1547);

var smoothBezier = __webpack_require__(1548);

function buildPath(ctx, shape, closePath) {
  var points = shape.points;
  var smooth = shape.smooth;

  if (points && points.length >= 2) {
    if (smooth && smooth !== 'spline') {
      var controlPoints = smoothBezier(points, smooth, closePath, shape.smoothConstraint);
      ctx.moveTo(points[0][0], points[0][1]);
      var len = points.length;

      for (var i = 0; i < (closePath ? len : len - 1); i++) {
        var cp1 = controlPoints[i * 2];
        var cp2 = controlPoints[i * 2 + 1];
        var p = points[(i + 1) % len];
        ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
      }
    } else {
      if (smooth === 'spline') {
        points = smoothSpline(points, closePath);
      }

      ctx.moveTo(points[0][0], points[0][1]);

      for (var i = 1, l = points.length; i < l; i++) {
        ctx.lineTo(points[i][0], points[i][1]);
      }
    }

    closePath && ctx.closePath();
  }
}

exports.buildPath = buildPath;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(65);

var polyHelper = __webpack_require__(632);

/**
 * @module zrender/graphic/shape/Polyline
 */
var _default = Path.extend({
  type: 'polyline',
  shape: {
    points: null,
    smooth: false,
    smoothConstraint: null
  },
  style: {
    stroke: '#000',
    fill: null
  },
  buildPath: function (ctx, shape) {
    polyHelper.buildPath(ctx, shape, false);
  }
});

module.exports = _default;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(65);

var _subPixelOptimize = __webpack_require__(408);

var subPixelOptimizeLine = _subPixelOptimize.subPixelOptimizeLine;

/**
 * 直线
 * @module zrender/graphic/shape/Line
 */
// Avoid create repeatly.
var subPixelOptimizeOutputShape = {};

var _default = Path.extend({
  type: 'line',
  shape: {
    // Start point
    x1: 0,
    y1: 0,
    // End point
    x2: 0,
    y2: 0,
    percent: 1
  },
  style: {
    stroke: '#000',
    fill: null
  },
  buildPath: function (ctx, shape) {
    var x1;
    var y1;
    var x2;
    var y2;

    if (this.subPixelOptimize) {
      subPixelOptimizeLine(subPixelOptimizeOutputShape, shape, this.style);
      x1 = subPixelOptimizeOutputShape.x1;
      y1 = subPixelOptimizeOutputShape.y1;
      x2 = subPixelOptimizeOutputShape.x2;
      y2 = subPixelOptimizeOutputShape.y2;
    } else {
      x1 = shape.x1;
      y1 = shape.y1;
      x2 = shape.x2;
      y2 = shape.y2;
    }

    var percent = shape.percent;

    if (percent === 0) {
      return;
    }

    ctx.moveTo(x1, y1);

    if (percent < 1) {
      x2 = x1 * (1 - percent) + x2 * percent;
      y2 = y1 * (1 - percent) + y2 * percent;
    }

    ctx.lineTo(x2, y2);
  },

  /**
   * Get point at percent
   * @param  {number} percent
   * @return {Array.<number>}
   */
  pointAt: function (p) {
    var shape = this.shape;
    return [shape.x1 * (1 - p) + shape.x2 * p, shape.y1 * (1 - p) + shape.y2 * p];
  }
});

module.exports = _default;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _model = __webpack_require__(44);

var makeInner = _model.makeInner;
var normalizeToArray = _model.normalizeToArray;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var inner = makeInner();

function getNearestColorPalette(colors, requestColorNum) {
  var paletteNum = colors.length; // TODO colors must be in order

  for (var i = 0; i < paletteNum; i++) {
    if (colors[i].length > requestColorNum) {
      return colors[i];
    }
  }

  return colors[paletteNum - 1];
}

var _default = {
  clearColorPalette: function () {
    inner(this).colorIdx = 0;
    inner(this).colorNameMap = {};
  },

  /**
   * @param {string} name MUST NOT be null/undefined. Otherwise call this function
   *                 twise with the same parameters will get different result.
   * @param {Object} [scope=this]
   * @param {Object} [requestColorNum]
   * @return {string} color string.
   */
  getColorFromPalette: function (name, scope, requestColorNum) {
    scope = scope || this;
    var scopeFields = inner(scope);
    var colorIdx = scopeFields.colorIdx || 0;
    var colorNameMap = scopeFields.colorNameMap = scopeFields.colorNameMap || {}; // Use `hasOwnProperty` to avoid conflict with Object.prototype.

    if (colorNameMap.hasOwnProperty(name)) {
      return colorNameMap[name];
    }

    var defaultColorPalette = normalizeToArray(this.get('color', true));
    var layeredColorPalette = this.get('colorLayer', true);
    var colorPalette = requestColorNum == null || !layeredColorPalette ? defaultColorPalette : getNearestColorPalette(layeredColorPalette, requestColorNum); // In case can't find in layered color palette.

    colorPalette = colorPalette || defaultColorPalette;

    if (!colorPalette || !colorPalette.length) {
      return;
    }

    var color = colorPalette[colorIdx];

    if (name) {
      colorNameMap[name] = color;
    }

    scopeFields.colorIdx = (colorIdx + 1) % colorPalette.length;
    return color;
  }
};
module.exports = _default;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var echartsAPIList = ['getDom', 'getZr', 'getWidth', 'getHeight', 'getDevicePixelRatio', 'dispatchAction', 'isDisposed', 'on', 'off', 'getDataURL', 'getConnectedDataURL', 'getModel', 'getOption', 'getViewOfComponentModel', 'getViewOfSeriesModel']; // And `getCoordinateSystems` and `getComponentByElement` will be injected in echarts.js

function ExtensionAPI(chartInstance) {
  zrUtil.each(echartsAPIList, function (name) {
    this[name] = zrUtil.bind(chartInstance[name], chartInstance);
  }, this);
}

var _default = ExtensionAPI;
module.exports = _default;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var ComponentModel = __webpack_require__(73);

var ComponentView = __webpack_require__(297);

var _sourceHelper = __webpack_require__(136);

var detectSourceFormat = _sourceHelper.detectSourceFormat;

var _sourceType = __webpack_require__(237);

var SERIES_LAYOUT_BY_COLUMN = _sourceType.SERIES_LAYOUT_BY_COLUMN;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * This module is imported by echarts directly.
 *
 * Notice:
 * Always keep this file exists for backward compatibility.
 * Because before 4.1.0, dataset is an optional component,
 * some users may import this module manually.
 */
ComponentModel.extend({
  type: 'dataset',

  /**
   * @protected
   */
  defaultOption: {
    // 'row', 'column'
    seriesLayoutBy: SERIES_LAYOUT_BY_COLUMN,
    // null/'auto': auto detect header, see "module:echarts/data/helper/sourceHelper"
    sourceHeader: null,
    dimensions: null,
    source: null
  },
  optionUpdated: function () {
    detectSourceFormat(this);
  }
});
ComponentView.extend({
  type: 'dataset'
});

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var Group = __webpack_require__(174);

var ZImage = __webpack_require__(203);

var Text = __webpack_require__(175);

var Circle = __webpack_require__(629);

var Rect = __webpack_require__(407);

var Ellipse = __webpack_require__(1566);

var Line = __webpack_require__(634);

var Path = __webpack_require__(65);

var Polygon = __webpack_require__(631);

var Polyline = __webpack_require__(633);

var LinearGradient = __webpack_require__(409);

var Style = __webpack_require__(405);

var matrix = __webpack_require__(82);

var _path = __webpack_require__(624);

var createFromString = _path.createFromString;

var _util = __webpack_require__(1);

var isString = _util.isString;
var extend = _util.extend;
var defaults = _util.defaults;
var trim = _util.trim;
var each = _util.each;
// import RadialGradient from '../graphic/RadialGradient';
// import Pattern from '../graphic/Pattern';
// import * as vector from '../core/vector';
// Most of the values can be separated by comma and/or white space.
var DILIMITER_REG = /[\s,]+/;
/**
 * For big svg string, this method might be time consuming.
 *
 * @param {string} svg xml string
 * @return {Object} xml root.
 */

function parseXML(svg) {
  if (isString(svg)) {
    var parser = new DOMParser();
    svg = parser.parseFromString(svg, 'text/xml');
  } // Document node. If using $.get, doc node may be input.


  if (svg.nodeType === 9) {
    svg = svg.firstChild;
  } // nodeName of <!DOCTYPE svg> is also 'svg'.


  while (svg.nodeName.toLowerCase() !== 'svg' || svg.nodeType !== 1) {
    svg = svg.nextSibling;
  }

  return svg;
}

function SVGParser() {
  this._defs = {};
  this._root = null;
  this._isDefine = false;
  this._isText = false;
}

SVGParser.prototype.parse = function (xml, opt) {
  opt = opt || {};
  var svg = parseXML(xml);

  if (!svg) {
    throw new Error('Illegal svg');
  }

  var root = new Group();
  this._root = root; // parse view port

  var viewBox = svg.getAttribute('viewBox') || ''; // If width/height not specified, means "100%" of `opt.width/height`.
  // TODO: Other percent value not supported yet.

  var width = parseFloat(svg.getAttribute('width') || opt.width);
  var height = parseFloat(svg.getAttribute('height') || opt.height); // If width/height not specified, set as null for output.

  isNaN(width) && (width = null);
  isNaN(height) && (height = null); // Apply inline style on svg element.

  parseAttributes(svg, root, null, true);
  var child = svg.firstChild;

  while (child) {
    this._parseNode(child, root);

    child = child.nextSibling;
  }

  var viewBoxRect;
  var viewBoxTransform;

  if (viewBox) {
    var viewBoxArr = trim(viewBox).split(DILIMITER_REG); // Some invalid case like viewBox: 'none'.

    if (viewBoxArr.length >= 4) {
      viewBoxRect = {
        x: parseFloat(viewBoxArr[0] || 0),
        y: parseFloat(viewBoxArr[1] || 0),
        width: parseFloat(viewBoxArr[2]),
        height: parseFloat(viewBoxArr[3])
      };
    }
  }

  if (viewBoxRect && width != null && height != null) {
    viewBoxTransform = makeViewBoxTransform(viewBoxRect, width, height);

    if (!opt.ignoreViewBox) {
      // If set transform on the output group, it probably bring trouble when
      // some users only intend to show the clipped content inside the viewBox,
      // but not intend to transform the output group. So we keep the output
      // group no transform. If the user intend to use the viewBox as a
      // camera, just set `opt.ignoreViewBox` as `true` and set transfrom
      // manually according to the viewBox info in the output of this method.
      var elRoot = root;
      root = new Group();
      root.add(elRoot);
      elRoot.scale = viewBoxTransform.scale.slice();
      elRoot.position = viewBoxTransform.position.slice();
    }
  } // Some shapes might be overflow the viewport, which should be
  // clipped despite whether the viewBox is used, as the SVG does.


  if (!opt.ignoreRootClip && width != null && height != null) {
    root.setClipPath(new Rect({
      shape: {
        x: 0,
        y: 0,
        width: width,
        height: height
      }
    }));
  } // Set width/height on group just for output the viewport size.


  return {
    root: root,
    width: width,
    height: height,
    viewBoxRect: viewBoxRect,
    viewBoxTransform: viewBoxTransform
  };
};

SVGParser.prototype._parseNode = function (xmlNode, parentGroup) {
  var nodeName = xmlNode.nodeName.toLowerCase(); // TODO
  // support <style>...</style> in svg, where nodeName is 'style',
  // CSS classes is defined globally wherever the style tags are declared.

  if (nodeName === 'defs') {
    // define flag
    this._isDefine = true;
  } else if (nodeName === 'text') {
    this._isText = true;
  }

  var el;

  if (this._isDefine) {
    var parser = defineParsers[nodeName];

    if (parser) {
      var def = parser.call(this, xmlNode);
      var id = xmlNode.getAttribute('id');

      if (id) {
        this._defs[id] = def;
      }
    }
  } else {
    var parser = nodeParsers[nodeName];

    if (parser) {
      el = parser.call(this, xmlNode, parentGroup);
      parentGroup.add(el);
    }
  }

  var child = xmlNode.firstChild;

  while (child) {
    if (child.nodeType === 1) {
      this._parseNode(child, el);
    } // Is text


    if (child.nodeType === 3 && this._isText) {
      this._parseText(child, el);
    }

    child = child.nextSibling;
  } // Quit define


  if (nodeName === 'defs') {
    this._isDefine = false;
  } else if (nodeName === 'text') {
    this._isText = false;
  }
};

SVGParser.prototype._parseText = function (xmlNode, parentGroup) {
  if (xmlNode.nodeType === 1) {
    var dx = xmlNode.getAttribute('dx') || 0;
    var dy = xmlNode.getAttribute('dy') || 0;
    this._textX += parseFloat(dx);
    this._textY += parseFloat(dy);
  }

  var text = new Text({
    style: {
      text: xmlNode.textContent,
      transformText: true
    },
    position: [this._textX || 0, this._textY || 0]
  });
  inheritStyle(parentGroup, text);
  parseAttributes(xmlNode, text, this._defs);
  var fontSize = text.style.fontSize;

  if (fontSize && fontSize < 9) {
    // PENDING
    text.style.fontSize = 9;
    text.scale = text.scale || [1, 1];
    text.scale[0] *= fontSize / 9;
    text.scale[1] *= fontSize / 9;
  }

  var rect = text.getBoundingRect();
  this._textX += rect.width;
  parentGroup.add(text);
  return text;
};

var nodeParsers = {
  'g': function (xmlNode, parentGroup) {
    var g = new Group();
    inheritStyle(parentGroup, g);
    parseAttributes(xmlNode, g, this._defs);
    return g;
  },
  'rect': function (xmlNode, parentGroup) {
    var rect = new Rect();
    inheritStyle(parentGroup, rect);
    parseAttributes(xmlNode, rect, this._defs);
    rect.setShape({
      x: parseFloat(xmlNode.getAttribute('x') || 0),
      y: parseFloat(xmlNode.getAttribute('y') || 0),
      width: parseFloat(xmlNode.getAttribute('width') || 0),
      height: parseFloat(xmlNode.getAttribute('height') || 0)
    }); // console.log(xmlNode.getAttribute('transform'));
    // console.log(rect.transform);

    return rect;
  },
  'circle': function (xmlNode, parentGroup) {
    var circle = new Circle();
    inheritStyle(parentGroup, circle);
    parseAttributes(xmlNode, circle, this._defs);
    circle.setShape({
      cx: parseFloat(xmlNode.getAttribute('cx') || 0),
      cy: parseFloat(xmlNode.getAttribute('cy') || 0),
      r: parseFloat(xmlNode.getAttribute('r') || 0)
    });
    return circle;
  },
  'line': function (xmlNode, parentGroup) {
    var line = new Line();
    inheritStyle(parentGroup, line);
    parseAttributes(xmlNode, line, this._defs);
    line.setShape({
      x1: parseFloat(xmlNode.getAttribute('x1') || 0),
      y1: parseFloat(xmlNode.getAttribute('y1') || 0),
      x2: parseFloat(xmlNode.getAttribute('x2') || 0),
      y2: parseFloat(xmlNode.getAttribute('y2') || 0)
    });
    return line;
  },
  'ellipse': function (xmlNode, parentGroup) {
    var ellipse = new Ellipse();
    inheritStyle(parentGroup, ellipse);
    parseAttributes(xmlNode, ellipse, this._defs);
    ellipse.setShape({
      cx: parseFloat(xmlNode.getAttribute('cx') || 0),
      cy: parseFloat(xmlNode.getAttribute('cy') || 0),
      rx: parseFloat(xmlNode.getAttribute('rx') || 0),
      ry: parseFloat(xmlNode.getAttribute('ry') || 0)
    });
    return ellipse;
  },
  'polygon': function (xmlNode, parentGroup) {
    var points = xmlNode.getAttribute('points');

    if (points) {
      points = parsePoints(points);
    }

    var polygon = new Polygon({
      shape: {
        points: points || []
      }
    });
    inheritStyle(parentGroup, polygon);
    parseAttributes(xmlNode, polygon, this._defs);
    return polygon;
  },
  'polyline': function (xmlNode, parentGroup) {
    var path = new Path();
    inheritStyle(parentGroup, path);
    parseAttributes(xmlNode, path, this._defs);
    var points = xmlNode.getAttribute('points');

    if (points) {
      points = parsePoints(points);
    }

    var polyline = new Polyline({
      shape: {
        points: points || []
      }
    });
    return polyline;
  },
  'image': function (xmlNode, parentGroup) {
    var img = new ZImage();
    inheritStyle(parentGroup, img);
    parseAttributes(xmlNode, img, this._defs);
    img.setStyle({
      image: xmlNode.getAttribute('xlink:href'),
      x: xmlNode.getAttribute('x'),
      y: xmlNode.getAttribute('y'),
      width: xmlNode.getAttribute('width'),
      height: xmlNode.getAttribute('height')
    });
    return img;
  },
  'text': function (xmlNode, parentGroup) {
    var x = xmlNode.getAttribute('x') || 0;
    var y = xmlNode.getAttribute('y') || 0;
    var dx = xmlNode.getAttribute('dx') || 0;
    var dy = xmlNode.getAttribute('dy') || 0;
    this._textX = parseFloat(x) + parseFloat(dx);
    this._textY = parseFloat(y) + parseFloat(dy);
    var g = new Group();
    inheritStyle(parentGroup, g);
    parseAttributes(xmlNode, g, this._defs);
    return g;
  },
  'tspan': function (xmlNode, parentGroup) {
    var x = xmlNode.getAttribute('x');
    var y = xmlNode.getAttribute('y');

    if (x != null) {
      // new offset x
      this._textX = parseFloat(x);
    }

    if (y != null) {
      // new offset y
      this._textY = parseFloat(y);
    }

    var dx = xmlNode.getAttribute('dx') || 0;
    var dy = xmlNode.getAttribute('dy') || 0;
    var g = new Group();
    inheritStyle(parentGroup, g);
    parseAttributes(xmlNode, g, this._defs);
    this._textX += dx;
    this._textY += dy;
    return g;
  },
  'path': function (xmlNode, parentGroup) {
    // TODO svg fill rule
    // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/fill-rule
    // path.style.globalCompositeOperation = 'xor';
    var d = xmlNode.getAttribute('d') || ''; // Performance sensitive.

    var path = createFromString(d);
    inheritStyle(parentGroup, path);
    parseAttributes(xmlNode, path, this._defs);
    return path;
  }
};
var defineParsers = {
  'lineargradient': function (xmlNode) {
    var x1 = parseInt(xmlNode.getAttribute('x1') || 0, 10);
    var y1 = parseInt(xmlNode.getAttribute('y1') || 0, 10);
    var x2 = parseInt(xmlNode.getAttribute('x2') || 10, 10);
    var y2 = parseInt(xmlNode.getAttribute('y2') || 0, 10);
    var gradient = new LinearGradient(x1, y1, x2, y2);

    _parseGradientColorStops(xmlNode, gradient);

    return gradient;
  },
  'radialgradient': function (xmlNode) {}
};

function _parseGradientColorStops(xmlNode, gradient) {
  var stop = xmlNode.firstChild;

  while (stop) {
    if (stop.nodeType === 1) {
      var offset = stop.getAttribute('offset');

      if (offset.indexOf('%') > 0) {
        // percentage
        offset = parseInt(offset, 10) / 100;
      } else if (offset) {
        // number from 0 to 1
        offset = parseFloat(offset);
      } else {
        offset = 0;
      }

      var stopColor = stop.getAttribute('stop-color') || '#000000';
      gradient.addColorStop(offset, stopColor);
    }

    stop = stop.nextSibling;
  }
}

function inheritStyle(parent, child) {
  if (parent && parent.__inheritedStyle) {
    if (!child.__inheritedStyle) {
      child.__inheritedStyle = {};
    }

    defaults(child.__inheritedStyle, parent.__inheritedStyle);
  }
}

function parsePoints(pointsString) {
  var list = trim(pointsString).split(DILIMITER_REG);
  var points = [];

  for (var i = 0; i < list.length; i += 2) {
    var x = parseFloat(list[i]);
    var y = parseFloat(list[i + 1]);
    points.push([x, y]);
  }

  return points;
}

var attributesMap = {
  'fill': 'fill',
  'stroke': 'stroke',
  'stroke-width': 'lineWidth',
  'opacity': 'opacity',
  'fill-opacity': 'fillOpacity',
  'stroke-opacity': 'strokeOpacity',
  'stroke-dasharray': 'lineDash',
  'stroke-dashoffset': 'lineDashOffset',
  'stroke-linecap': 'lineCap',
  'stroke-linejoin': 'lineJoin',
  'stroke-miterlimit': 'miterLimit',
  'font-family': 'fontFamily',
  'font-size': 'fontSize',
  'font-style': 'fontStyle',
  'font-weight': 'fontWeight',
  'text-align': 'textAlign',
  'alignment-baseline': 'textBaseline'
};

function parseAttributes(xmlNode, el, defs, onlyInlineStyle) {
  var zrStyle = el.__inheritedStyle || {};
  var isTextEl = el.type === 'text'; // TODO Shadow

  if (xmlNode.nodeType === 1) {
    parseTransformAttribute(xmlNode, el);
    extend(zrStyle, parseStyleAttribute(xmlNode));

    if (!onlyInlineStyle) {
      for (var svgAttrName in attributesMap) {
        if (attributesMap.hasOwnProperty(svgAttrName)) {
          var attrValue = xmlNode.getAttribute(svgAttrName);

          if (attrValue != null) {
            zrStyle[attributesMap[svgAttrName]] = attrValue;
          }
        }
      }
    }
  }

  var elFillProp = isTextEl ? 'textFill' : 'fill';
  var elStrokeProp = isTextEl ? 'textStroke' : 'stroke';
  el.style = el.style || new Style();
  var elStyle = el.style;
  zrStyle.fill != null && elStyle.set(elFillProp, getPaint(zrStyle.fill, defs));
  zrStyle.stroke != null && elStyle.set(elStrokeProp, getPaint(zrStyle.stroke, defs));
  each(['lineWidth', 'opacity', 'fillOpacity', 'strokeOpacity', 'miterLimit', 'fontSize'], function (propName) {
    var elPropName = propName === 'lineWidth' && isTextEl ? 'textStrokeWidth' : propName;
    zrStyle[propName] != null && elStyle.set(elPropName, parseFloat(zrStyle[propName]));
  });

  if (!zrStyle.textBaseline || zrStyle.textBaseline === 'auto') {
    zrStyle.textBaseline = 'alphabetic';
  }

  if (zrStyle.textBaseline === 'alphabetic') {
    zrStyle.textBaseline = 'bottom';
  }

  if (zrStyle.textAlign === 'start') {
    zrStyle.textAlign = 'left';
  }

  if (zrStyle.textAlign === 'end') {
    zrStyle.textAlign = 'right';
  }

  each(['lineDashOffset', 'lineCap', 'lineJoin', 'fontWeight', 'fontFamily', 'fontStyle', 'textAlign', 'textBaseline'], function (propName) {
    zrStyle[propName] != null && elStyle.set(propName, zrStyle[propName]);
  });

  if (zrStyle.lineDash) {
    el.style.lineDash = trim(zrStyle.lineDash).split(DILIMITER_REG);
  }

  if (elStyle[elStrokeProp] && elStyle[elStrokeProp] !== 'none') {
    // enable stroke
    el[elStrokeProp] = true;
  }

  el.__inheritedStyle = zrStyle;
}

var urlRegex = /url\(\s*#(.*?)\)/;

function getPaint(str, defs) {
  // if (str === 'none') {
  //     return;
  // }
  var urlMatch = defs && str && str.match(urlRegex);

  if (urlMatch) {
    var url = trim(urlMatch[1]);
    var def = defs[url];
    return def;
  }

  return str;
}

var transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.e,]*)\)/g;

function parseTransformAttribute(xmlNode, node) {
  var transform = xmlNode.getAttribute('transform');

  if (transform) {
    transform = transform.replace(/,/g, ' ');
    var m = null;
    var transformOps = [];
    transform.replace(transformRegex, function (str, type, value) {
      transformOps.push(type, value);
    });

    for (var i = transformOps.length - 1; i > 0; i -= 2) {
      var value = transformOps[i];
      var type = transformOps[i - 1];
      m = m || matrix.create();

      switch (type) {
        case 'translate':
          value = trim(value).split(DILIMITER_REG);
          matrix.translate(m, m, [parseFloat(value[0]), parseFloat(value[1] || 0)]);
          break;

        case 'scale':
          value = trim(value).split(DILIMITER_REG);
          matrix.scale(m, m, [parseFloat(value[0]), parseFloat(value[1] || value[0])]);
          break;

        case 'rotate':
          value = trim(value).split(DILIMITER_REG);
          matrix.rotate(m, m, parseFloat(value[0]));
          break;

        case 'skew':
          value = trim(value).split(DILIMITER_REG);
          console.warn('Skew transform is not supported yet');
          break;

        case 'matrix':
          var value = trim(value).split(DILIMITER_REG);
          m[0] = parseFloat(value[0]);
          m[1] = parseFloat(value[1]);
          m[2] = parseFloat(value[2]);
          m[3] = parseFloat(value[3]);
          m[4] = parseFloat(value[4]);
          m[5] = parseFloat(value[5]);
          break;
      }
    }

    node.setLocalTransform(m);
  }
} // Value may contain space.


var styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;

function parseStyleAttribute(xmlNode) {
  var style = xmlNode.getAttribute('style');
  var result = {};

  if (!style) {
    return result;
  }

  var styleList = {};
  styleRegex.lastIndex = 0;
  var styleRegResult;

  while ((styleRegResult = styleRegex.exec(style)) != null) {
    styleList[styleRegResult[1]] = styleRegResult[2];
  }

  for (var svgAttrName in attributesMap) {
    if (attributesMap.hasOwnProperty(svgAttrName) && styleList[svgAttrName] != null) {
      result[attributesMap[svgAttrName]] = styleList[svgAttrName];
    }
  }

  return result;
}
/**
 * @param {Array.<number>} viewBoxRect
 * @param {number} width
 * @param {number} height
 * @return {Object} {scale, position}
 */


function makeViewBoxTransform(viewBoxRect, width, height) {
  var scaleX = width / viewBoxRect.width;
  var scaleY = height / viewBoxRect.height;
  var scale = Math.min(scaleX, scaleY); // preserveAspectRatio 'xMidYMid'

  var viewBoxScale = [scale, scale];
  var viewBoxPosition = [-(viewBoxRect.x + viewBoxRect.width / 2) * scale + width / 2, -(viewBoxRect.y + viewBoxRect.height / 2) * scale + height / 2];
  return {
    scale: viewBoxScale,
    position: viewBoxPosition
  };
}
/**
 * @param {string|XMLElement} xml
 * @param {Object} [opt]
 * @param {number} [opt.width] Default width if svg width not specified or is a percent value.
 * @param {number} [opt.height] Default height if svg height not specified or is a percent value.
 * @param {boolean} [opt.ignoreViewBox]
 * @param {boolean} [opt.ignoreRootClip]
 * @return {Object} result:
 * {
 *     root: Group, The root of the the result tree of zrender shapes,
 *     width: number, the viewport width of the SVG,
 *     height: number, the viewport height of the SVG,
 *     viewBoxRect: {x, y, width, height}, the declared viewBox rect of the SVG, if exists,
 *     viewBoxTransform: the {scale, position} calculated by viewBox and viewport, is exists.
 * }
 */


function parseSVG(xml, opt) {
  var parser = new SVGParser();
  return parser.parse(xml, opt);
}

exports.parseXML = parseXML;
exports.makeViewBoxTransform = makeViewBoxTransform;
exports.parseSVG = parseSVG;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrender = __webpack_require__(291);

exports.zrender = zrender;

var matrix = __webpack_require__(82);

exports.matrix = matrix;

var vector = __webpack_require__(55);

exports.vector = vector;

var zrUtil = __webpack_require__(1);

var colorTool = __webpack_require__(122);

exports.color = colorTool;

var graphicUtil = __webpack_require__(27);

var numberUtil = __webpack_require__(37);

exports.number = numberUtil;

var formatUtil = __webpack_require__(54);

exports.format = formatUtil;

var _throttle = __webpack_require__(148);

var throttle = _throttle.throttle;
exports.throttle = _throttle.throttle;

var ecHelper = __webpack_require__(1567);

exports.helper = ecHelper;

var parseGeoJSON = __webpack_require__(645);

exports.parseGeoJSON = parseGeoJSON;

var _List = __webpack_require__(98);

exports.List = _List;

var _Model = __webpack_require__(68);

exports.Model = _Model;

var _Axis = __webpack_require__(150);

exports.Axis = _Axis;

var _env = __webpack_require__(67);

exports.env = _env;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Do not mount those modules on 'src/echarts' for better tree shaking.
 */
var parseGeoJson = parseGeoJSON;
var ecUtil = {};
zrUtil.each(['map', 'each', 'filter', 'indexOf', 'inherits', 'reduce', 'filter', 'bind', 'curry', 'isArray', 'isString', 'isObject', 'isFunction', 'extend', 'defaults', 'clone', 'merge'], function (name) {
  ecUtil[name] = zrUtil[name];
});
var graphic = {};
zrUtil.each(['extendShape', 'extendPath', 'makePath', 'makeImage', 'mergePath', 'resizePath', 'createIcon', 'setHoverStyle', 'setLabelStyle', 'setTextStyle', 'setText', 'getFont', 'updateProps', 'initProps', 'getTransform', 'clipPointsByRect', 'clipRectByRect', 'registerShape', 'getShapeClass', 'Group', 'Image', 'Text', 'Circle', 'Sector', 'Ring', 'Polygon', 'Polyline', 'Rect', 'Line', 'BezierCurve', 'Arc', 'IncrementalDisplayable', 'CompoundPath', 'LinearGradient', 'RadialGradient', 'BoundingRect'], function (name) {
  graphic[name] = graphicUtil[name];
});
exports.parseGeoJson = parseGeoJson;
exports.util = ecUtil;
exports.graphic = graphic;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @class
 * @param {Object|DataDimensionInfo} [opt] All of the fields will be shallow copied.
 */
function DataDimensionInfo(opt) {
  if (opt != null) {
    zrUtil.extend(this, opt);
  }
  /**
   * Dimension name.
   * Mandatory.
   * @type {string}
   */
  // this.name;

  /**
   * The origin name in dimsDef, see source helper.
   * If displayName given, the tooltip will displayed vertically.
   * Optional.
   * @type {string}
   */
  // this.displayName;

  /**
   * Which coordSys dimension this dimension mapped to.
   * A `coordDim` can be a "coordSysDim" that the coordSys required
   * (for example, an item in `coordSysDims` of `model/referHelper#CoordSysInfo`),
   * or an generated "extra coord name" if does not mapped to any "coordSysDim"
   * (That is determined by whether `isExtraCoord` is `true`).
   * Mandatory.
   * @type {string}
   */
  // this.coordDim;

  /**
   * The index of this dimension in `series.encode[coordDim]`.
   * Mandatory.
   * @type {number}
   */
  // this.coordDimIndex;

  /**
   * Dimension type. The enumerable values are the key of
   * `dataCtors` of `data/List`.
   * Optional.
   * @type {string}
   */
  // this.type;

  /**
   * This index of this dimension info in `data/List#_dimensionInfos`.
   * Mandatory after added to `data/List`.
   * @type {number}
   */
  // this.index;

  /**
   * The format of `otherDims` is:
   * ```js
   * {
   *     tooltip: number optional,
   *     label: number optional,
   *     itemName: number optional,
   *     seriesName: number optional,
   * }
   * ```
   *
   * A `series.encode` can specified these fields:
   * ```js
   * encode: {
   *     // "3, 1, 5" is the index of data dimension.
   *     tooltip: [3, 1, 5],
   *     label: [0, 3],
   *     ...
   * }
   * ```
   * `otherDims` is the parse result of the `series.encode` above, like:
   * ```js
   * // Suppose the index of this data dimension is `3`.
   * this.otherDims = {
   *     // `3` is at the index `0` of the `encode.tooltip`
   *     tooltip: 0,
   *     // `3` is at the index `1` of the `encode.tooltip`
   *     label: 1
   * };
   * ```
   *
   * This prop should never be `null`/`undefined` after initialized.
   * @type {Object}
   */


  this.otherDims = {};
  /**
   * Be `true` if this dimension is not mapped to any "coordSysDim" that the
   * "coordSys" required.
   * Mandatory.
   * @type {boolean}
   */
  // this.isExtraCoord;

  /**
   * @type {module:data/OrdinalMeta}
   */
  // this.ordinalMeta;

  /**
   * Whether to create inverted indices.
   * @type {boolean}
   */
  // this.createInvertedIndices;
}

;
var _default = DataDimensionInfo;
module.exports = _default;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(1);

var createHashMap = _util.createHashMap;
var each = _util.each;
var isString = _util.isString;
var defaults = _util.defaults;
var extend = _util.extend;
var isObject = _util.isObject;
var clone = _util.clone;

var _model = __webpack_require__(44);

var normalizeToArray = _model.normalizeToArray;

var _sourceHelper = __webpack_require__(136);

var guessOrdinal = _sourceHelper.guessOrdinal;
var BE_ORDINAL = _sourceHelper.BE_ORDINAL;

var Source = __webpack_require__(236);

var _dimensionHelper = __webpack_require__(238);

var OTHER_DIMENSIONS = _dimensionHelper.OTHER_DIMENSIONS;

var DataDimensionInfo = __webpack_require__(640);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @deprecated
 * Use `echarts/data/helper/createDimensions` instead.
 */

/**
 * @see {module:echarts/test/ut/spec/data/completeDimensions}
 *
 * This method builds the relationship between:
 * + "what the coord sys or series requires (see `sysDims`)",
 * + "what the user defines (in `encode` and `dimensions`, see `opt.dimsDef` and `opt.encodeDef`)"
 * + "what the data source provids (see `source`)".
 *
 * Some guess strategy will be adapted if user does not define something.
 * If no 'value' dimension specified, the first no-named dimension will be
 * named as 'value'.
 *
 * @param {Array.<string>} sysDims Necessary dimensions, like ['x', 'y'], which
 *      provides not only dim template, but also default order.
 *      properties: 'name', 'type', 'displayName'.
 *      `name` of each item provides default coord name.
 *      [{dimsDef: [string|Object, ...]}, ...] dimsDef of sysDim item provides default dim name, and
 *                                    provide dims count that the sysDim required.
 *      [{ordinalMeta}] can be specified.
 * @param {module:echarts/data/Source|Array|Object} source or data (for compatibal with pervious)
 * @param {Object} [opt]
 * @param {Array.<Object|string>} [opt.dimsDef] option.series.dimensions User defined dimensions
 *      For example: ['asdf', {name, type}, ...].
 * @param {Object|HashMap} [opt.encodeDef] option.series.encode {x: 2, y: [3, 1], tooltip: [1, 2], label: 3}
 * @param {Function} [opt.encodeDefaulter] Called if no `opt.encodeDef` exists.
 *      If not specified, auto find the next available data dim.
 *      param source {module:data/Source}
 *      param dimCount {number}
 *      return {Object} encode Never be `null/undefined`.
 * @param {string} [opt.generateCoord] Generate coord dim with the given name.
 *      If not specified, extra dim names will be:
 *      'value', 'value0', 'value1', ...
 * @param {number} [opt.generateCoordCount] By default, the generated dim name is `generateCoord`.
 *      If `generateCoordCount` specified, the generated dim names will be:
 *      `generateCoord` + 0, `generateCoord` + 1, ...
 *      can be Infinity, indicate that use all of the remain columns.
 * @param {number} [opt.dimCount] If not specified, guess by the first data item.
 * @return {Array.<module:data/DataDimensionInfo>}
 */
function completeDimensions(sysDims, source, opt) {
  if (!Source.isInstance(source)) {
    source = Source.seriesDataToSource(source);
  }

  opt = opt || {};
  sysDims = (sysDims || []).slice();
  var dimsDef = (opt.dimsDef || []).slice();
  var dataDimNameMap = createHashMap();
  var coordDimNameMap = createHashMap(); // var valueCandidate;

  var result = [];
  var dimCount = getDimCount(source, sysDims, dimsDef, opt.dimCount); // Apply user defined dims (`name` and `type`) and init result.

  for (var i = 0; i < dimCount; i++) {
    var dimDefItem = dimsDef[i] = extend({}, isObject(dimsDef[i]) ? dimsDef[i] : {
      name: dimsDef[i]
    });
    var userDimName = dimDefItem.name;
    var resultItem = result[i] = new DataDimensionInfo(); // Name will be applied later for avoiding duplication.

    if (userDimName != null && dataDimNameMap.get(userDimName) == null) {
      // Only if `series.dimensions` is defined in option
      // displayName, will be set, and dimension will be diplayed vertically in
      // tooltip by default.
      resultItem.name = resultItem.displayName = userDimName;
      dataDimNameMap.set(userDimName, i);
    }

    dimDefItem.type != null && (resultItem.type = dimDefItem.type);
    dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
  }

  var encodeDef = opt.encodeDef;

  if (!encodeDef && opt.encodeDefaulter) {
    encodeDef = opt.encodeDefaulter(source, dimCount);
  }

  encodeDef = createHashMap(encodeDef); // Set `coordDim` and `coordDimIndex` by `encodeDef` and normalize `encodeDef`.

  encodeDef.each(function (dataDims, coordDim) {
    dataDims = normalizeToArray(dataDims).slice(); // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
    // `{encode: {x: -1, y: 1}}`. Should not filter anything in
    // this case.

    if (dataDims.length === 1 && !isString(dataDims[0]) && dataDims[0] < 0) {
      encodeDef.set(coordDim, false);
      return;
    }

    var validDataDims = encodeDef.set(coordDim, []);
    each(dataDims, function (resultDimIdx, idx) {
      // The input resultDimIdx can be dim name or index.
      isString(resultDimIdx) && (resultDimIdx = dataDimNameMap.get(resultDimIdx));

      if (resultDimIdx != null && resultDimIdx < dimCount) {
        validDataDims[idx] = resultDimIdx;
        applyDim(result[resultDimIdx], coordDim, idx);
      }
    });
  }); // Apply templetes and default order from `sysDims`.

  var availDimIdx = 0;
  each(sysDims, function (sysDimItem, sysDimIndex) {
    var coordDim;
    var sysDimItem;
    var sysDimItemDimsDef;
    var sysDimItemOtherDims;

    if (isString(sysDimItem)) {
      coordDim = sysDimItem;
      sysDimItem = {};
    } else {
      coordDim = sysDimItem.name;
      var ordinalMeta = sysDimItem.ordinalMeta;
      sysDimItem.ordinalMeta = null;
      sysDimItem = clone(sysDimItem);
      sysDimItem.ordinalMeta = ordinalMeta; // `coordDimIndex` should not be set directly.

      sysDimItemDimsDef = sysDimItem.dimsDef;
      sysDimItemOtherDims = sysDimItem.otherDims;
      sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
    }

    var dataDims = encodeDef.get(coordDim); // negative resultDimIdx means no need to mapping.

    if (dataDims === false) {
      return;
    }

    var dataDims = normalizeToArray(dataDims); // dimensions provides default dim sequences.

    if (!dataDims.length) {
      for (var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++) {
        while (availDimIdx < result.length && result[availDimIdx].coordDim != null) {
          availDimIdx++;
        }

        availDimIdx < result.length && dataDims.push(availDimIdx++);
      }
    } // Apply templates.


    each(dataDims, function (resultDimIdx, coordDimIndex) {
      var resultItem = result[resultDimIdx];
      applyDim(defaults(resultItem, sysDimItem), coordDim, coordDimIndex);

      if (resultItem.name == null && sysDimItemDimsDef) {
        var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
        !isObject(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
          name: sysDimItemDimsDefItem
        });
        resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
        resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
      } // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}


      sysDimItemOtherDims && defaults(resultItem.otherDims, sysDimItemOtherDims);
    });
  });

  function applyDim(resultItem, coordDim, coordDimIndex) {
    if (OTHER_DIMENSIONS.get(coordDim) != null) {
      resultItem.otherDims[coordDim] = coordDimIndex;
    } else {
      resultItem.coordDim = coordDim;
      resultItem.coordDimIndex = coordDimIndex;
      coordDimNameMap.set(coordDim, true);
    }
  } // Make sure the first extra dim is 'value'.


  var generateCoord = opt.generateCoord;
  var generateCoordCount = opt.generateCoordCount;
  var fromZero = generateCoordCount != null;
  generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
  var extra = generateCoord || 'value'; // Set dim `name` and other `coordDim` and other props.

  for (var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++) {
    var resultItem = result[resultDimIdx] = result[resultDimIdx] || new DataDimensionInfo();
    var coordDim = resultItem.coordDim;

    if (coordDim == null) {
      resultItem.coordDim = genName(extra, coordDimNameMap, fromZero);
      resultItem.coordDimIndex = 0;

      if (!generateCoord || generateCoordCount <= 0) {
        resultItem.isExtraCoord = true;
      }

      generateCoordCount--;
    }

    resultItem.name == null && (resultItem.name = genName(resultItem.coordDim, dataDimNameMap));

    if (resultItem.type == null && (guessOrdinal(source, resultDimIdx, resultItem.name) === BE_ORDINAL.Must // Consider the case:
    // {
    //    dataset: {source: [
    //        ['2001', 123],
    //        ['2002', 456],
    //        ...
    //        ['The others', 987],
    //    ]},
    //    series: {type: 'pie'}
    // }
    // The first colum should better be treated as a "ordinal" although it
    // might not able to be detected as an "ordinal" by `guessOrdinal`.
    || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) {
      resultItem.type = 'ordinal';
    }
  }

  return result;
} // ??? TODO
// Originally detect dimCount by data[0]. Should we
// optimize it to only by sysDims and dimensions and encode.
// So only necessary dims will be initialized.
// But
// (1) custom series should be considered. where other dims
// may be visited.
// (2) sometimes user need to calcualte bubble size or use visualMap
// on other dimensions besides coordSys needed.
// So, dims that is not used by system, should be shared in storage?


function getDimCount(source, sysDims, dimsDef, optDimCount) {
  // Note that the result dimCount should not small than columns count
  // of data, otherwise `dataDimNameMap` checking will be incorrect.
  var dimCount = Math.max(source.dimensionsDetectCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
  each(sysDims, function (sysDimItem) {
    var sysDimItemDimsDef = sysDimItem.dimsDef;
    sysDimItemDimsDef && (dimCount = Math.max(dimCount, sysDimItemDimsDef.length));
  });
  return dimCount;
}

function genName(name, map, fromZero) {
  if (fromZero || map.get(name) != null) {
    var i = 0;

    while (map.get(name + i) != null) {
      i++;
    }

    name += i;
  }

  map.set(name, true);
  return name;
}

var _default = completeDimensions;
module.exports = _default;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(1);

var createHashMap = _util.createHashMap;
var isObject = _util.isObject;
var map = _util.map;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @constructor
 * @param {Object} [opt]
 * @param {Object} [opt.categories=[]]
 * @param {Object} [opt.needCollect=false]
 * @param {Object} [opt.deduplication=false]
 */
function OrdinalMeta(opt) {
  /**
   * @readOnly
   * @type {Array.<string>}
   */
  this.categories = opt.categories || [];
  /**
   * @private
   * @type {boolean}
   */

  this._needCollect = opt.needCollect;
  /**
   * @private
   * @type {boolean}
   */

  this._deduplication = opt.deduplication;
  /**
   * @private
   * @type {boolean}
   */

  this._map;
}
/**
 * @param {module:echarts/model/Model} axisModel
 * @return {module:echarts/data/OrdinalMeta}
 */


OrdinalMeta.createByAxisModel = function (axisModel) {
  var option = axisModel.option;
  var data = option.data;
  var categories = data && map(data, getName);
  return new OrdinalMeta({
    categories: categories,
    needCollect: !categories,
    // deduplication is default in axis.
    deduplication: option.dedplication !== false
  });
};

var proto = OrdinalMeta.prototype;
/**
 * @param {string} category
 * @return {number} ordinal
 */

proto.getOrdinal = function (category) {
  return getOrCreateMap(this).get(category);
};
/**
 * @param {*} category
 * @return {number} The ordinal. If not found, return NaN.
 */


proto.parseAndCollect = function (category) {
  var index;
  var needCollect = this._needCollect; // The value of category dim can be the index of the given category set.
  // This feature is only supported when !needCollect, because we should
  // consider a common case: a value is 2017, which is a number but is
  // expected to be tread as a category. This case usually happen in dataset,
  // where it happent to be no need of the index feature.

  if (typeof category !== 'string' && !needCollect) {
    return category;
  } // Optimize for the scenario:
  // category is ['2012-01-01', '2012-01-02', ...], where the input
  // data has been ensured not duplicate and is large data.
  // Notice, if a dataset dimension provide categroies, usually echarts
  // should remove duplication except user tell echarts dont do that
  // (set axis.deduplication = false), because echarts do not know whether
  // the values in the category dimension has duplication (consider the
  // parallel-aqi example)


  if (needCollect && !this._deduplication) {
    index = this.categories.length;
    this.categories[index] = category;
    return index;
  }

  var map = getOrCreateMap(this);
  index = map.get(category);

  if (index == null) {
    if (needCollect) {
      index = this.categories.length;
      this.categories[index] = category;
      map.set(category, index);
    } else {
      index = NaN;
    }
  }

  return index;
}; // Consider big data, do not create map until needed.


function getOrCreateMap(ordinalMeta) {
  return ordinalMeta._map || (ordinalMeta._map = createHashMap(ordinalMeta.categories));
}

function getName(obj) {
  if (isObject(obj) && obj.value != null) {
    return obj.value;
  } else {
    return obj + '';
  }
}

var _default = OrdinalMeta;
module.exports = _default;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var numberUtil = __webpack_require__(37);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * For testable.
 */
var roundNumber = numberUtil.round;
/**
 * @param {Array.<number>} extent Both extent[0] and extent[1] should be valid number.
 *                                Should be extent[0] < extent[1].
 * @param {number} splitNumber splitNumber should be >= 1.
 * @param {number} [minInterval]
 * @param {number} [maxInterval]
 * @return {Object} {interval, intervalPrecision, niceTickExtent}
 */

function intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval) {
  var result = {};
  var span = extent[1] - extent[0];
  var interval = result.interval = numberUtil.nice(span / splitNumber, true);

  if (minInterval != null && interval < minInterval) {
    interval = result.interval = minInterval;
  }

  if (maxInterval != null && interval > maxInterval) {
    interval = result.interval = maxInterval;
  } // Tow more digital for tick.


  var precision = result.intervalPrecision = getIntervalPrecision(interval); // Niced extent inside original extent

  var niceTickExtent = result.niceTickExtent = [roundNumber(Math.ceil(extent[0] / interval) * interval, precision), roundNumber(Math.floor(extent[1] / interval) * interval, precision)];
  fixExtent(niceTickExtent, extent);
  return result;
}
/**
 * @param {number} interval
 * @return {number} interval precision
 */


function getIntervalPrecision(interval) {
  // Tow more digital for tick.
  return numberUtil.getPrecisionSafe(interval) + 2;
}

function clamp(niceTickExtent, idx, extent) {
  niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
} // In some cases (e.g., splitNumber is 1), niceTickExtent may be out of extent.


function fixExtent(niceTickExtent, extent) {
  !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
  !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
  clamp(niceTickExtent, 0, extent);
  clamp(niceTickExtent, 1, extent);

  if (niceTickExtent[0] > niceTickExtent[1]) {
    niceTickExtent[0] = niceTickExtent[1];
  }
}

exports.intervalScaleNiceTicks = intervalScaleNiceTicks;
exports.getIntervalPrecision = getIntervalPrecision;
exports.fixExtent = fixExtent;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var Scale = __webpack_require__(298);

var numberUtil = __webpack_require__(37);

var IntervalScale = __webpack_require__(299);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Log scale
 * @module echarts/scale/Log
 */
// Use some method of IntervalScale
var scaleProto = Scale.prototype;
var intervalScaleProto = IntervalScale.prototype;
var getPrecisionSafe = numberUtil.getPrecisionSafe;
var roundingErrorFix = numberUtil.round;
var mathFloor = Math.floor;
var mathCeil = Math.ceil;
var mathPow = Math.pow;
var mathLog = Math.log;
var LogScale = Scale.extend({
  type: 'log',
  base: 10,
  $constructor: function () {
    Scale.apply(this, arguments);
    this._originalScale = new IntervalScale();
  },

  /**
   * @param {boolean} [expandToNicedExtent=false] If expand the ticks to niced extent.
   * @return {Array.<number>}
   */
  getTicks: function (expandToNicedExtent) {
    var originalScale = this._originalScale;
    var extent = this._extent;
    var originalExtent = originalScale.getExtent();
    return zrUtil.map(intervalScaleProto.getTicks.call(this, expandToNicedExtent), function (val) {
      var powVal = numberUtil.round(mathPow(this.base, val)); // Fix #4158

      powVal = val === extent[0] && originalScale.__fixMin ? fixRoundingError(powVal, originalExtent[0]) : powVal;
      powVal = val === extent[1] && originalScale.__fixMax ? fixRoundingError(powVal, originalExtent[1]) : powVal;
      return powVal;
    }, this);
  },

  /**
   * @param {number} splitNumber
   * @return {Array.<Array.<number>>}
   */
  getMinorTicks: intervalScaleProto.getMinorTicks,

  /**
   * @param {number} val
   * @return {string}
   */
  getLabel: intervalScaleProto.getLabel,

  /**
   * @param  {number} val
   * @return {number}
   */
  scale: function (val) {
    val = scaleProto.scale.call(this, val);
    return mathPow(this.base, val);
  },

  /**
   * @param {number} start
   * @param {number} end
   */
  setExtent: function (start, end) {
    var base = this.base;
    start = mathLog(start) / mathLog(base);
    end = mathLog(end) / mathLog(base);
    intervalScaleProto.setExtent.call(this, start, end);
  },

  /**
   * @return {number} end
   */
  getExtent: function () {
    var base = this.base;
    var extent = scaleProto.getExtent.call(this);
    extent[0] = mathPow(base, extent[0]);
    extent[1] = mathPow(base, extent[1]); // Fix #4158

    var originalScale = this._originalScale;
    var originalExtent = originalScale.getExtent();
    originalScale.__fixMin && (extent[0] = fixRoundingError(extent[0], originalExtent[0]));
    originalScale.__fixMax && (extent[1] = fixRoundingError(extent[1], originalExtent[1]));
    return extent;
  },

  /**
   * @param  {Array.<number>} extent
   */
  unionExtent: function (extent) {
    this._originalScale.unionExtent(extent);

    var base = this.base;
    extent[0] = mathLog(extent[0]) / mathLog(base);
    extent[1] = mathLog(extent[1]) / mathLog(base);
    scaleProto.unionExtent.call(this, extent);
  },

  /**
   * @override
   */
  unionExtentFromData: function (data, dim) {
    // TODO
    // filter value that <= 0
    this.unionExtent(data.getApproximateExtent(dim));
  },

  /**
   * Update interval and extent of intervals for nice ticks
   * @param  {number} [approxTickNum = 10] Given approx tick number
   */
  niceTicks: function (approxTickNum) {
    approxTickNum = approxTickNum || 10;
    var extent = this._extent;
    var span = extent[1] - extent[0];

    if (span === Infinity || span <= 0) {
      return;
    }

    var interval = numberUtil.quantity(span);
    var err = approxTickNum / span * interval; // Filter ticks to get closer to the desired count.

    if (err <= 0.5) {
      interval *= 10;
    } // Interval should be integer


    while (!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0) {
      interval *= 10;
    }

    var niceExtent = [numberUtil.round(mathCeil(extent[0] / interval) * interval), numberUtil.round(mathFloor(extent[1] / interval) * interval)];
    this._interval = interval;
    this._niceExtent = niceExtent;
  },

  /**
   * Nice extent.
   * @override
   */
  niceExtent: function (opt) {
    intervalScaleProto.niceExtent.call(this, opt);
    var originalScale = this._originalScale;
    originalScale.__fixMin = opt.fixMin;
    originalScale.__fixMax = opt.fixMax;
  }
});
zrUtil.each(['contain', 'normalize'], function (methodName) {
  LogScale.prototype[methodName] = function (val) {
    val = mathLog(val) / mathLog(this.base);
    return scaleProto[methodName].call(this, val);
  };
});

LogScale.create = function () {
  return new LogScale();
};

function fixRoundingError(val, originalVal) {
  return roundingErrorFix(val, getPrecisionSafe(originalVal));
}

var _default = LogScale;
module.exports = _default;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var Region = __webpack_require__(646);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Parse and decode geo json
 * @module echarts/coord/geo/parseGeoJson
 */
function decode(json) {
  if (!json.UTF8Encoding) {
    return json;
  }

  var encodeScale = json.UTF8Scale;

  if (encodeScale == null) {
    encodeScale = 1024;
  }

  var features = json.features;

  for (var f = 0; f < features.length; f++) {
    var feature = features[f];
    var geometry = feature.geometry;
    var coordinates = geometry.coordinates;
    var encodeOffsets = geometry.encodeOffsets;

    for (var c = 0; c < coordinates.length; c++) {
      var coordinate = coordinates[c];

      if (geometry.type === 'Polygon') {
        coordinates[c] = decodePolygon(coordinate, encodeOffsets[c], encodeScale);
      } else if (geometry.type === 'MultiPolygon') {
        for (var c2 = 0; c2 < coordinate.length; c2++) {
          var polygon = coordinate[c2];
          coordinate[c2] = decodePolygon(polygon, encodeOffsets[c][c2], encodeScale);
        }
      }
    }
  } // Has been decoded


  json.UTF8Encoding = false;
  return json;
}

function decodePolygon(coordinate, encodeOffsets, encodeScale) {
  var result = [];
  var prevX = encodeOffsets[0];
  var prevY = encodeOffsets[1];

  for (var i = 0; i < coordinate.length; i += 2) {
    var x = coordinate.charCodeAt(i) - 64;
    var y = coordinate.charCodeAt(i + 1) - 64; // ZigZag decoding

    x = x >> 1 ^ -(x & 1);
    y = y >> 1 ^ -(y & 1); // Delta deocding

    x += prevX;
    y += prevY;
    prevX = x;
    prevY = y; // Dequantize

    result.push([x / encodeScale, y / encodeScale]);
  }

  return result;
}
/**
 * @alias module:echarts/coord/geo/parseGeoJson
 * @param {Object} geoJson
 * @param {string} nameProperty
 * @return {module:zrender/container/Group}
 */


function _default(geoJson, nameProperty) {
  decode(geoJson);
  return zrUtil.map(zrUtil.filter(geoJson.features, function (featureObj) {
    // Output of mapshaper may have geometry null
    return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
  }), function (featureObj) {
    var properties = featureObj.properties;
    var geo = featureObj.geometry;
    var coordinates = geo.coordinates;
    var geometries = [];

    if (geo.type === 'Polygon') {
      geometries.push({
        type: 'polygon',
        // According to the GeoJSON specification.
        // First must be exterior, and the rest are all interior(holes).
        exterior: coordinates[0],
        interiors: coordinates.slice(1)
      });
    }

    if (geo.type === 'MultiPolygon') {
      zrUtil.each(coordinates, function (item) {
        if (item[0]) {
          geometries.push({
            type: 'polygon',
            exterior: item[0],
            interiors: item.slice(1)
          });
        }
      });
    }

    var region = new Region(properties[nameProperty || 'name'], geometries, properties.cp);
    region.properties = properties;
    return region;
  });
}

module.exports = _default;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var BoundingRect = __webpack_require__(57);

var bbox = __webpack_require__(234);

var vec2 = __webpack_require__(55);

var polygonContain = __webpack_require__(647);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @module echarts/coord/geo/Region
 */

/**
 * @param {string|Region} name
 * @param {Array} geometries
 * @param {Array.<number>} cp
 */
function Region(name, geometries, cp) {
  /**
   * @type {string}
   * @readOnly
   */
  this.name = name;
  /**
   * @type {Array.<Array>}
   * @readOnly
   */

  this.geometries = geometries;

  if (!cp) {
    var rect = this.getBoundingRect();
    cp = [rect.x + rect.width / 2, rect.y + rect.height / 2];
  } else {
    cp = [cp[0], cp[1]];
  }
  /**
   * @type {Array.<number>}
   */


  this.center = cp;
}

Region.prototype = {
  constructor: Region,
  properties: null,

  /**
   * @return {module:zrender/core/BoundingRect}
   */
  getBoundingRect: function () {
    var rect = this._rect;

    if (rect) {
      return rect;
    }

    var MAX_NUMBER = Number.MAX_VALUE;
    var min = [MAX_NUMBER, MAX_NUMBER];
    var max = [-MAX_NUMBER, -MAX_NUMBER];
    var min2 = [];
    var max2 = [];
    var geometries = this.geometries;

    for (var i = 0; i < geometries.length; i++) {
      // Only support polygon
      if (geometries[i].type !== 'polygon') {
        continue;
      } // Doesn't consider hole


      var exterior = geometries[i].exterior;
      bbox.fromPoints(exterior, min2, max2);
      vec2.min(min, min, min2);
      vec2.max(max, max, max2);
    } // No data


    if (i === 0) {
      min[0] = min[1] = max[0] = max[1] = 0;
    }

    return this._rect = new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
  },

  /**
   * @param {<Array.<number>} coord
   * @return {boolean}
   */
  contain: function (coord) {
    var rect = this.getBoundingRect();
    var geometries = this.geometries;

    if (!rect.contain(coord[0], coord[1])) {
      return false;
    }

    loopGeo: for (var i = 0, len = geometries.length; i < len; i++) {
      // Only support polygon.
      if (geometries[i].type !== 'polygon') {
        continue;
      }

      var exterior = geometries[i].exterior;
      var interiors = geometries[i].interiors;

      if (polygonContain.contain(exterior, coord[0], coord[1])) {
        // Not in the region if point is in the hole.
        for (var k = 0; k < (interiors ? interiors.length : 0); k++) {
          if (polygonContain.contain(interiors[k])) {
            continue loopGeo;
          }
        }

        return true;
      }
    }

    return false;
  },
  transformTo: function (x, y, width, height) {
    var rect = this.getBoundingRect();
    var aspect = rect.width / rect.height;

    if (!width) {
      width = aspect * height;
    } else if (!height) {
      height = width / aspect;
    }

    var target = new BoundingRect(x, y, width, height);
    var transform = rect.calculateTransform(target);
    var geometries = this.geometries;

    for (var i = 0; i < geometries.length; i++) {
      // Only support polygon.
      if (geometries[i].type !== 'polygon') {
        continue;
      }

      var exterior = geometries[i].exterior;
      var interiors = geometries[i].interiors;

      for (var p = 0; p < exterior.length; p++) {
        vec2.applyTransform(exterior[p], exterior[p], transform);
      }

      for (var h = 0; h < (interiors ? interiors.length : 0); h++) {
        for (var p = 0; p < interiors[h].length; p++) {
          vec2.applyTransform(interiors[h][p], interiors[h][p], transform);
        }
      }
    }

    rect = this._rect;
    rect.copy(target); // Update center

    this.center = [rect.x + rect.width / 2, rect.y + rect.height / 2];
  },
  cloneShallow: function (name) {
    name == null && (name = this.name);
    var newRegion = new Region(name, this.geometries, this.center);
    newRegion._rect = this._rect;
    newRegion.transformTo = null; // Simply avoid to be called.

    return newRegion;
  }
};
var _default = Region;
module.exports = _default;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var windingLine = __webpack_require__(628);

var EPSILON = 1e-8;

function isAroundEqual(a, b) {
  return Math.abs(a - b) < EPSILON;
}

function contain(points, x, y) {
  var w = 0;
  var p = points[0];

  if (!p) {
    return false;
  }

  for (var i = 1; i < points.length; i++) {
    var p2 = points[i];
    w += windingLine(p[0], p[1], p2[0], p2[1], x, y);
    p = p2;
  } // Close polygon


  var p0 = points[0];

  if (!isAroundEqual(p[0], p0[0]) || !isAroundEqual(p[1], p0[1])) {
    w += windingLine(p[0], p[1], p0[0], p0[1], x, y);
  }

  return w !== 0;
}

exports.contain = contain;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _dataStackHelper = __webpack_require__(124);

var isDimensionStacked = _dataStackHelper.isDimensionStacked;

var _util = __webpack_require__(1);

var map = _util.map;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @param {Object} coordSys
 * @param {module:echarts/data/List} data
 * @param {string} valueOrigin lineSeries.option.areaStyle.origin
 */
function prepareDataCoordInfo(coordSys, data, valueOrigin) {
  var baseAxis = coordSys.getBaseAxis();
  var valueAxis = coordSys.getOtherAxis(baseAxis);
  var valueStart = getValueStart(valueAxis, valueOrigin);
  var baseAxisDim = baseAxis.dim;
  var valueAxisDim = valueAxis.dim;
  var valueDim = data.mapDimension(valueAxisDim);
  var baseDim = data.mapDimension(baseAxisDim);
  var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
  var dims = map(coordSys.dimensions, function (coordDim) {
    return data.mapDimension(coordDim);
  });
  var stacked;
  var stackResultDim = data.getCalculationInfo('stackResultDimension');

  if (stacked |= isDimensionStacked(data, dims[0]
  /*, dims[1]*/
  )) {
    // jshint ignore:line
    dims[0] = stackResultDim;
  }

  if (stacked |= isDimensionStacked(data, dims[1]
  /*, dims[0]*/
  )) {
    // jshint ignore:line
    dims[1] = stackResultDim;
  }

  return {
    dataDimsForPoint: dims,
    valueStart: valueStart,
    valueAxisDim: valueAxisDim,
    baseAxisDim: baseAxisDim,
    stacked: !!stacked,
    valueDim: valueDim,
    baseDim: baseDim,
    baseDataOffset: baseDataOffset,
    stackedOverDimension: data.getCalculationInfo('stackedOverDimension')
  };
}

function getValueStart(valueAxis, valueOrigin) {
  var valueStart = 0;
  var extent = valueAxis.scale.getExtent();

  if (valueOrigin === 'start') {
    valueStart = extent[0];
  } else if (valueOrigin === 'end') {
    valueStart = extent[1];
  } // auto
  else {
      // Both positive
      if (extent[0] > 0) {
        valueStart = extent[0];
      } // Both negative
      else if (extent[1] < 0) {
          valueStart = extent[1];
        } // If is one positive, and one negative, onZero shall be true

    }

  return valueStart;
}

function getStackedOnPoint(dataCoordInfo, coordSys, data, idx) {
  var value = NaN;

  if (dataCoordInfo.stacked) {
    value = data.get(data.getCalculationInfo('stackedOverDimension'), idx);
  }

  if (isNaN(value)) {
    value = dataCoordInfo.valueStart;
  }

  var baseDataOffset = dataCoordInfo.baseDataOffset;
  var stackedData = [];
  stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
  stackedData[1 - baseDataOffset] = value;
  return coordSys.dataToPoint(stackedData);
}

exports.prepareDataCoordInfo = prepareDataCoordInfo;
exports.getStackedOnPoint = getStackedOnPoint;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var Path = __webpack_require__(65);

var vec2 = __webpack_require__(55);

var fixClipWithShadow = __webpack_require__(630);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Poly path support NaN point
var vec2Min = vec2.min;
var vec2Max = vec2.max;
var scaleAndAdd = vec2.scaleAndAdd;
var v2Copy = vec2.copy; // Temporary variable

var v = [];
var cp0 = [];
var cp1 = [];

function isPointNull(p) {
  return isNaN(p[0]) || isNaN(p[1]);
}

function drawSegment(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
  // if (smoothMonotone == null) {
  //     if (isMono(points, 'x')) {
  //         return drawMono(ctx, points, start, segLen, allLen,
  //             dir, smoothMin, smoothMax, smooth, 'x', connectNulls);
  //     }
  //     else if (isMono(points, 'y')) {
  //         return drawMono(ctx, points, start, segLen, allLen,
  //             dir, smoothMin, smoothMax, smooth, 'y', connectNulls);
  //     }
  //     else {
  //         return drawNonMono.apply(this, arguments);
  //     }
  // }
  // else if (smoothMonotone !== 'none' && isMono(points, smoothMonotone)) {
  //     return drawMono.apply(this, arguments);
  // }
  // else {
  //     return drawNonMono.apply(this, arguments);
  // }
  if (smoothMonotone === 'none' || !smoothMonotone) {
    return drawNonMono.apply(this, arguments);
  } else {
    return drawMono.apply(this, arguments);
  }
}
/**
 * Check if points is in monotone.
 *
 * @param {number[][]} points         Array of points which is in [x, y] form
 * @param {string}     smoothMonotone 'x', 'y', or 'none', stating for which
 *                                    dimension that is checking.
 *                                    If is 'none', `drawNonMono` should be
 *                                    called.
 *                                    If is undefined, either being monotone
 *                                    in 'x' or 'y' will call `drawMono`.
 */
// function isMono(points, smoothMonotone) {
//     if (points.length <= 1) {
//         return true;
//     }
//     var dim = smoothMonotone === 'x' ? 0 : 1;
//     var last = points[0][dim];
//     var lastDiff = 0;
//     for (var i = 1; i < points.length; ++i) {
//         var diff = points[i][dim] - last;
//         if (!isNaN(diff) && !isNaN(lastDiff)
//             && diff !== 0 && lastDiff !== 0
//             && ((diff >= 0) !== (lastDiff >= 0))
//         ) {
//             return false;
//         }
//         if (!isNaN(diff) && diff !== 0) {
//             lastDiff = diff;
//             last = points[i][dim];
//         }
//     }
//     return true;
// }

/**
 * Draw smoothed line in monotone, in which only vertical or horizontal bezier
 * control points will be used. This should be used when points are monotone
 * either in x or y dimension.
 */


function drawMono(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
  var prevIdx = 0;
  var idx = start;

  for (var k = 0; k < segLen; k++) {
    var p = points[idx];

    if (idx >= allLen || idx < 0) {
      break;
    }

    if (isPointNull(p)) {
      if (connectNulls) {
        idx += dir;
        continue;
      }

      break;
    }

    if (idx === start) {
      ctx[dir > 0 ? 'moveTo' : 'lineTo'](p[0], p[1]);
    } else {
      if (smooth > 0) {
        var prevP = points[prevIdx];
        var dim = smoothMonotone === 'y' ? 1 : 0; // Length of control point to p, either in x or y, but not both

        var ctrlLen = (p[dim] - prevP[dim]) * smooth;
        v2Copy(cp0, prevP);
        cp0[dim] = prevP[dim] + ctrlLen;
        v2Copy(cp1, p);
        cp1[dim] = p[dim] - ctrlLen;
        ctx.bezierCurveTo(cp0[0], cp0[1], cp1[0], cp1[1], p[0], p[1]);
      } else {
        ctx.lineTo(p[0], p[1]);
      }
    }

    prevIdx = idx;
    idx += dir;
  }

  return k;
}
/**
 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
 * situations. This should be used when points are non-monotone neither in x or
 * y dimension.
 */


function drawNonMono(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
  var prevIdx = 0;
  var idx = start;

  for (var k = 0; k < segLen; k++) {
    var p = points[idx];

    if (idx >= allLen || idx < 0) {
      break;
    }

    if (isPointNull(p)) {
      if (connectNulls) {
        idx += dir;
        continue;
      }

      break;
    }

    if (idx === start) {
      ctx[dir > 0 ? 'moveTo' : 'lineTo'](p[0], p[1]);
      v2Copy(cp0, p);
    } else {
      if (smooth > 0) {
        var nextIdx = idx + dir;
        var nextP = points[nextIdx];

        if (connectNulls) {
          // Find next point not null
          while (nextP && isPointNull(points[nextIdx])) {
            nextIdx += dir;
            nextP = points[nextIdx];
          }
        }

        var ratioNextSeg = 0.5;
        var prevP = points[prevIdx];
        var nextP = points[nextIdx]; // Last point

        if (!nextP || isPointNull(nextP)) {
          v2Copy(cp1, p);
        } else {
          // If next data is null in not connect case
          if (isPointNull(nextP) && !connectNulls) {
            nextP = p;
          }

          vec2.sub(v, nextP, prevP);
          var lenPrevSeg;
          var lenNextSeg;

          if (smoothMonotone === 'x' || smoothMonotone === 'y') {
            var dim = smoothMonotone === 'x' ? 0 : 1;
            lenPrevSeg = Math.abs(p[dim] - prevP[dim]);
            lenNextSeg = Math.abs(p[dim] - nextP[dim]);
          } else {
            lenPrevSeg = vec2.dist(p, prevP);
            lenNextSeg = vec2.dist(p, nextP);
          } // Use ratio of seg length


          ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
          scaleAndAdd(cp1, p, v, -smooth * (1 - ratioNextSeg));
        } // Smooth constraint


        vec2Min(cp0, cp0, smoothMax);
        vec2Max(cp0, cp0, smoothMin);
        vec2Min(cp1, cp1, smoothMax);
        vec2Max(cp1, cp1, smoothMin);
        ctx.bezierCurveTo(cp0[0], cp0[1], cp1[0], cp1[1], p[0], p[1]); // cp0 of next segment

        scaleAndAdd(cp0, p, v, smooth * ratioNextSeg);
      } else {
        ctx.lineTo(p[0], p[1]);
      }
    }

    prevIdx = idx;
    idx += dir;
  }

  return k;
}

function getBoundingBox(points, smoothConstraint) {
  var ptMin = [Infinity, Infinity];
  var ptMax = [-Infinity, -Infinity];

  if (smoothConstraint) {
    for (var i = 0; i < points.length; i++) {
      var pt = points[i];

      if (pt[0] < ptMin[0]) {
        ptMin[0] = pt[0];
      }

      if (pt[1] < ptMin[1]) {
        ptMin[1] = pt[1];
      }

      if (pt[0] > ptMax[0]) {
        ptMax[0] = pt[0];
      }

      if (pt[1] > ptMax[1]) {
        ptMax[1] = pt[1];
      }
    }
  }

  return {
    min: smoothConstraint ? ptMin : ptMax,
    max: smoothConstraint ? ptMax : ptMin
  };
}

var Polyline = Path.extend({
  type: 'ec-polyline',
  shape: {
    points: [],
    smooth: 0,
    smoothConstraint: true,
    smoothMonotone: null,
    connectNulls: false
  },
  style: {
    fill: null,
    stroke: '#000'
  },
  brush: fixClipWithShadow(Path.prototype.brush),
  buildPath: function (ctx, shape) {
    var points = shape.points;
    var i = 0;
    var len = points.length;
    var result = getBoundingBox(points, shape.smoothConstraint);

    if (shape.connectNulls) {
      // Must remove first and last null values avoid draw error in polygon
      for (; len > 0; len--) {
        if (!isPointNull(points[len - 1])) {
          break;
        }
      }

      for (; i < len; i++) {
        if (!isPointNull(points[i])) {
          break;
        }
      }
    }

    while (i < len) {
      i += drawSegment(ctx, points, i, len, len, 1, result.min, result.max, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
    }
  }
});
var Polygon = Path.extend({
  type: 'ec-polygon',
  shape: {
    points: [],
    // Offset between stacked base points and points
    stackedOnPoints: [],
    smooth: 0,
    stackedOnSmooth: 0,
    smoothConstraint: true,
    smoothMonotone: null,
    connectNulls: false
  },
  brush: fixClipWithShadow(Path.prototype.brush),
  buildPath: function (ctx, shape) {
    var points = shape.points;
    var stackedOnPoints = shape.stackedOnPoints;
    var i = 0;
    var len = points.length;
    var smoothMonotone = shape.smoothMonotone;
    var bbox = getBoundingBox(points, shape.smoothConstraint);
    var stackedOnBBox = getBoundingBox(stackedOnPoints, shape.smoothConstraint);

    if (shape.connectNulls) {
      // Must remove first and last null values avoid draw error in polygon
      for (; len > 0; len--) {
        if (!isPointNull(points[len - 1])) {
          break;
        }
      }

      for (; i < len; i++) {
        if (!isPointNull(points[i])) {
          break;
        }
      }
    }

    while (i < len) {
      var k = drawSegment(ctx, points, i, len, len, 1, bbox.min, bbox.max, shape.smooth, smoothMonotone, shape.connectNulls);
      drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, stackedOnBBox.min, stackedOnBBox.max, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
      i += k + 1;
      ctx.closePath();
    }
  }
});
exports.Polyline = Polyline;
exports.Polygon = Polygon;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var ComponentModel = __webpack_require__(73);

var axisModelCreator = __webpack_require__(302);

var axisModelCommonMixin = __webpack_require__(208);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var AxisModel = ComponentModel.extend({
  type: 'cartesian2dAxis',

  /**
   * @type {module:echarts/coord/cartesian/Axis2D}
   */
  axis: null,

  /**
   * @override
   */
  init: function () {
    AxisModel.superApply(this, 'init', arguments);
    this.resetRange();
  },

  /**
   * @override
   */
  mergeOption: function () {
    AxisModel.superApply(this, 'mergeOption', arguments);
    this.resetRange();
  },

  /**
   * @override
   */
  restoreData: function () {
    AxisModel.superApply(this, 'restoreData', arguments);
    this.resetRange();
  },

  /**
   * @override
   * @return {module:echarts/model/Component}
   */
  getCoordSysModel: function () {
    return this.ecModel.queryComponents({
      mainType: 'grid',
      index: this.option.gridIndex,
      id: this.option.gridId
    })[0];
  }
});

function getAxisType(axisDim, option) {
  // Default axis with data is category axis
  return option.type || (option.data ? 'category' : 'value');
}

zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
var extraOption = {
  // gridIndex: 0,
  // gridId: '',
  // Offset is for multiple axis on the same position
  offset: 0
};
axisModelCreator('x', AxisModel, getAxisType, extraOption);
axisModelCreator('y', AxisModel, getAxisType, extraOption);
var _default = AxisModel;
module.exports = _default;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var defaultOption = {
  show: true,
  zlevel: 0,
  z: 0,
  // Inverse the axis.
  inverse: false,
  // Axis name displayed.
  name: '',
  // 'start' | 'middle' | 'end'
  nameLocation: 'end',
  // By degree. By default auto rotate by nameLocation.
  nameRotate: null,
  nameTruncate: {
    maxWidth: null,
    ellipsis: '...',
    placeholder: '.'
  },
  // Use global text style by default.
  nameTextStyle: {},
  // The gap between axisName and axisLine.
  nameGap: 15,
  // Default `false` to support tooltip.
  silent: false,
  // Default `false` to avoid legacy user event listener fail.
  triggerEvent: false,
  tooltip: {
    show: false
  },
  axisPointer: {},
  axisLine: {
    show: true,
    onZero: true,
    onZeroAxisIndex: null,
    lineStyle: {
      color: '#333',
      width: 1,
      type: 'solid'
    },
    // The arrow at both ends the the axis.
    symbol: ['none', 'none'],
    symbolSize: [10, 15]
  },
  axisTick: {
    show: true,
    // Whether axisTick is inside the grid or outside the grid.
    inside: false,
    // The length of axisTick.
    length: 5,
    lineStyle: {
      width: 1
    }
  },
  axisLabel: {
    show: true,
    // Whether axisLabel is inside the grid or outside the grid.
    inside: false,
    rotate: 0,
    // true | false | null/undefined (auto)
    showMinLabel: null,
    // true | false | null/undefined (auto)
    showMaxLabel: null,
    margin: 8,
    // formatter: null,
    fontSize: 12
  },
  splitLine: {
    show: true,
    lineStyle: {
      color: ['#ccc'],
      width: 1,
      type: 'solid'
    }
  },
  splitArea: {
    show: false,
    areaStyle: {
      color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
    }
  }
};
var axisDefault = {};
axisDefault.categoryAxis = zrUtil.merge({
  // The gap at both ends of the axis. For categoryAxis, boolean.
  boundaryGap: true,
  // Set false to faster category collection.
  // Only usefull in the case like: category is
  // ['2012-01-01', '2012-01-02', ...], where the input
  // data has been ensured not duplicate and is large data.
  // null means "auto":
  // if axis.data provided, do not deduplication,
  // else do deduplication.
  deduplication: null,
  // splitArea: {
  // show: false
  // },
  splitLine: {
    show: false
  },
  axisTick: {
    // If tick is align with label when boundaryGap is true
    alignWithLabel: false,
    interval: 'auto'
  },
  axisLabel: {
    interval: 'auto'
  }
}, defaultOption);
axisDefault.valueAxis = zrUtil.merge({
  // The gap at both ends of the axis. For value axis, [GAP, GAP], where
  // `GAP` can be an absolute pixel number (like `35`), or percent (like `'30%'`)
  boundaryGap: [0, 0],
  // TODO
  // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
  // Min value of the axis. can be:
  // + a number
  // + 'dataMin': use the min value in data.
  // + null/undefined: auto decide min value (consider pretty look and boundaryGap).
  // min: null,
  // Max value of the axis. can be:
  // + a number
  // + 'dataMax': use the max value in data.
  // + null/undefined: auto decide max value (consider pretty look and boundaryGap).
  // max: null,
  // Readonly prop, specifies start value of the range when using data zoom.
  // rangeStart: null
  // Readonly prop, specifies end value of the range when using data zoom.
  // rangeEnd: null
  // Optional value can be:
  // + `false`: always include value 0.
  // + `true`: the extent do not consider value 0.
  // scale: false,
  // AxisTick and axisLabel and splitLine are caculated based on splitNumber.
  splitNumber: 5,
  // Interval specifies the span of the ticks is mandatorily.
  // interval: null
  // Specify min interval when auto calculate tick interval.
  // minInterval: null
  // Specify max interval when auto calculate tick interval.
  // maxInterval: null
  minorTick: {
    // Minor tick, not available for cateogry axis.
    show: false,
    // Split number of minor ticks. The value should be in range of (0, 100)
    splitNumber: 5,
    // Lenght of minor tick
    length: 3,
    // Same inside with axisTick
    // Line style
    lineStyle: {// Default to be same with axisTick
    }
  },
  minorSplitLine: {
    show: false,
    lineStyle: {
      color: '#eee',
      width: 1
    }
  }
}, defaultOption);
axisDefault.timeAxis = zrUtil.defaults({
  scale: true,
  min: 'dataMin',
  max: 'dataMax'
}, axisDefault.valueAxis);
axisDefault.logAxis = zrUtil.defaults({
  scale: true,
  logBase: 10
}, axisDefault.valueAxis);
var _default = axisDefault;
module.exports = _default;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Can only be called after coordinate system creation stage.
 * (Can be called before coordinate system update stage).
 *
 * @param {Object} opt {labelInside}
 * @return {Object} {
 *  position, rotation, labelDirection, labelOffset,
 *  tickDirection, labelRotate, z2
 * }
 */
function layout(gridModel, axisModel, opt) {
  opt = opt || {};
  var grid = gridModel.coordinateSystem;
  var axis = axisModel.axis;
  var layout = {};
  var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
  var rawAxisPosition = axis.position;
  var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
  var axisDim = axis.dim;
  var rect = grid.getRect();
  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
  var idx = {
    left: 0,
    right: 1,
    top: 0,
    bottom: 1,
    onZero: 2
  };
  var axisOffset = axisModel.get('offset') || 0;
  var posBound = axisDim === 'x' ? [rectBound[2] - axisOffset, rectBound[3] + axisOffset] : [rectBound[0] - axisOffset, rectBound[1] + axisOffset];

  if (otherAxisOnZeroOf) {
    var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
    posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
  } // Axis position


  layout.position = [axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0], axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]]; // Axis rotation

  layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1); // Tick and label direction, x y is axisDim

  var dirMap = {
    top: -1,
    bottom: 1,
    left: -1,
    right: 1
  };
  layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
  layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;

  if (axisModel.get('axisTick.inside')) {
    layout.tickDirection = -layout.tickDirection;
  }

  if (zrUtil.retrieve(opt.labelInside, axisModel.get('axisLabel.inside'))) {
    layout.labelDirection = -layout.labelDirection;
  } // Special label rotation


  var labelRotate = axisModel.get('axisLabel.rotate');
  layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate; // Over splitLine and splitArea

  layout.z2 = 1;
  return layout;
}

exports.layout = layout;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var graphic = __webpack_require__(27);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function rectCoordAxisBuildSplitArea(axisView, axisGroup, axisModel, gridModel) {
  var axis = axisModel.axis;

  if (axis.scale.isBlank()) {
    return;
  }

  var splitAreaModel = axisModel.getModel('splitArea');
  var areaStyleModel = splitAreaModel.getModel('areaStyle');
  var areaColors = areaStyleModel.get('color');
  var gridRect = gridModel.coordinateSystem.getRect();
  var ticksCoords = axis.getTicksCoords({
    tickModel: splitAreaModel,
    clamp: true
  });

  if (!ticksCoords.length) {
    return;
  } // For Making appropriate splitArea animation, the color and anid
  // should be corresponding to previous one if possible.


  var areaColorsLen = areaColors.length;
  var lastSplitAreaColors = axisView.__splitAreaColors;
  var newSplitAreaColors = zrUtil.createHashMap();
  var colorIndex = 0;

  if (lastSplitAreaColors) {
    for (var i = 0; i < ticksCoords.length; i++) {
      var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);

      if (cIndex != null) {
        colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
        break;
      }
    }
  }

  var prev = axis.toGlobalCoord(ticksCoords[0].coord);
  var areaStyle = areaStyleModel.getAreaStyle();
  areaColors = zrUtil.isArray(areaColors) ? areaColors : [areaColors];

  for (var i = 1; i < ticksCoords.length; i++) {
    var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
    var x;
    var y;
    var width;
    var height;

    if (axis.isHorizontal()) {
      x = prev;
      y = gridRect.y;
      width = tickCoord - x;
      height = gridRect.height;
      prev = x + width;
    } else {
      x = gridRect.x;
      y = prev;
      width = gridRect.width;
      height = tickCoord - y;
      prev = y + height;
    }

    var tickValue = ticksCoords[i - 1].tickValue;
    tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
    axisGroup.add(new graphic.Rect({
      anid: tickValue != null ? 'area_' + tickValue : null,
      shape: {
        x: x,
        y: y,
        width: width,
        height: height
      },
      style: zrUtil.defaults({
        fill: areaColors[colorIndex]
      }, areaStyle),
      silent: true
    }));
    colorIndex = (colorIndex + 1) % areaColorsLen;
  }

  axisView.__splitAreaColors = newSplitAreaColors;
}

function rectCoordAxisHandleRemove(axisView) {
  axisView.__splitAreaColors = null;
}

exports.rectCoordAxisBuildSplitArea = rectCoordAxisBuildSplitArea;
exports.rectCoordAxisHandleRemove = rectCoordAxisHandleRemove;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var SeriesModel = __webpack_require__(74);

var createListFromArray = __webpack_require__(137);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = SeriesModel.extend({
  type: 'series.__base_bar__',
  getInitialData: function (option, ecModel) {
    return createListFromArray(this.getSource(), this, {
      useEncodeDefaulter: true
    });
  },
  getMarkerPosition: function (value) {
    var coordSys = this.coordinateSystem;

    if (coordSys) {
      // PENDING if clamp ?
      var pt = coordSys.dataToPoint(coordSys.clampData(value));
      var data = this.getData();
      var offset = data.getLayout('offset');
      var size = data.getLayout('size');
      var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
      pt[offsetIndex] += offset + size / 2;
      return pt;
    }

    return [NaN, NaN];
  },
  defaultOption: {
    zlevel: 0,
    // 一级层叠
    z: 2,
    // 二级层叠
    coordinateSystem: 'cartesian2d',
    legendHoverLink: true,
    // stack: null
    // Cartesian coordinate system
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // 最小高度改为0
    barMinHeight: 0,
    // 最小角度为0，仅对极坐标系下的柱状图有效
    barMinAngle: 0,
    // cursor: null,
    large: false,
    largeThreshold: 400,
    progressive: 3e3,
    progressiveChunkMode: 'mod',
    // barMaxWidth: null,
    // In cartesian, the default value is 1. Otherwise null.
    // barMinWidth: null,
    // 默认自适应
    // barWidth: null,
    // 柱间距离，默认为柱形宽度的30%，可设固定值
    // barGap: '30%',
    // 类目间柱形距离，默认为类目间距的20%，可设固定值
    // barCategoryGap: '20%',
    // label: {
    //      show: false
    // },
    itemStyle: {},
    emphasis: {}
  }
});

module.exports = _default;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var graphic = __webpack_require__(27);

var _labelHelper = __webpack_require__(414);

var getDefaultLabel = _labelHelper.getDefaultLabel;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function setLabel(normalStyle, hoverStyle, itemModel, color, seriesModel, dataIndex, labelPositionOutside) {
  var labelModel = itemModel.getModel('label');
  var hoverLabelModel = itemModel.getModel('emphasis.label');
  graphic.setLabelStyle(normalStyle, hoverStyle, labelModel, hoverLabelModel, {
    labelFetcher: seriesModel,
    labelDataIndex: dataIndex,
    defaultText: getDefaultLabel(seriesModel.getData(), dataIndex),
    isRectText: true,
    autoColor: color
  });
  fixPosition(normalStyle);
  fixPosition(hoverStyle);
}

function fixPosition(style, labelPositionOutside) {
  if (style.textPosition === 'outside') {
    style.textPosition = labelPositionOutside;
  }
}

exports.setLabel = setLabel;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(seriesType, actionInfos) {
  zrUtil.each(actionInfos, function (actionInfo) {
    actionInfo.update = 'updateView';
    /**
     * @payload
     * @property {string} seriesName
     * @property {string} name
     */

    echarts.registerAction(actionInfo, function (payload, ecModel) {
      var selected = {};
      ecModel.eachComponent({
        mainType: 'series',
        subType: seriesType,
        query: payload
      }, function (seriesModel) {
        if (seriesModel[actionInfo.method]) {
          seriesModel[actionInfo.method](payload.name, payload.dataIndex);
        }

        var data = seriesModel.getData(); // Create selected map

        data.each(function (idx) {
          var name = data.getName(idx);
          selected[name] = seriesModel.isSelected(name) || false;
        });
      });
      return {
        name: payload.name,
        selected: selected,
        seriesId: payload.seriesId
      };
    });
  });
}

module.exports = _default;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var RoamController = __webpack_require__(245);

var roamHelper = __webpack_require__(417);

var _cursorHelper = __webpack_require__(306);

var onIrrelevantElement = _cursorHelper.onIrrelevantElement;

var graphic = __webpack_require__(27);

var geoSourceManager = __webpack_require__(305);

var _component = __webpack_require__(235);

var getUID = _component.getUID;

var Transformable = __webpack_require__(292);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function getFixedItemStyle(model) {
  var itemStyle = model.getItemStyle();
  var areaColor = model.get('areaColor'); // If user want the color not to be changed when hover,
  // they should both set areaColor and color to be null.

  if (areaColor != null) {
    itemStyle.fill = areaColor;
  }

  return itemStyle;
}

function updateMapSelectHandler(mapDraw, mapOrGeoModel, regionsGroup, api, fromView) {
  regionsGroup.off('click');
  regionsGroup.off('mousedown');

  if (mapOrGeoModel.get('selectedMode')) {
    regionsGroup.on('mousedown', function () {
      mapDraw._mouseDownFlag = true;
    });
    regionsGroup.on('click', function (e) {
      if (!mapDraw._mouseDownFlag) {
        return;
      }

      mapDraw._mouseDownFlag = false;
      var el = e.target;

      while (!el.__regions) {
        el = el.parent;
      }

      if (!el) {
        return;
      }

      var action = {
        type: (mapOrGeoModel.mainType === 'geo' ? 'geo' : 'map') + 'ToggleSelect',
        batch: zrUtil.map(el.__regions, function (region) {
          return {
            name: region.name,
            from: fromView.uid
          };
        })
      };
      action[mapOrGeoModel.mainType + 'Id'] = mapOrGeoModel.id;
      api.dispatchAction(action);
      updateMapSelected(mapOrGeoModel, regionsGroup);
    });
  }
}

function updateMapSelected(mapOrGeoModel, regionsGroup) {
  // FIXME
  regionsGroup.eachChild(function (otherRegionEl) {
    zrUtil.each(otherRegionEl.__regions, function (region) {
      otherRegionEl.trigger(mapOrGeoModel.isSelected(region.name) ? 'emphasis' : 'normal');
    });
  });
}
/**
 * @alias module:echarts/component/helper/MapDraw
 * @param {module:echarts/ExtensionAPI} api
 * @param {boolean} updateGroup
 */


function MapDraw(api, updateGroup) {
  var group = new graphic.Group();
  /**
   * @type {string}
   * @private
   */

  this.uid = getUID('ec_map_draw');
  /**
   * @type {module:echarts/component/helper/RoamController}
   * @private
   */

  this._controller = new RoamController(api.getZr());
  /**
   * @type {Object} {target, zoom, zoomLimit}
   * @private
   */

  this._controllerHost = {
    target: updateGroup ? group : null
  };
  /**
   * @type {module:zrender/container/Group}
   * @readOnly
   */

  this.group = group;
  /**
   * @type {boolean}
   * @private
   */

  this._updateGroup = updateGroup;
  /**
   * This flag is used to make sure that only one among
   * `pan`, `zoom`, `click` can occurs, otherwise 'selected'
   * action may be triggered when `pan`, which is unexpected.
   * @type {booelan}
   */

  this._mouseDownFlag;
  /**
   * @type {string}
   */

  this._mapName;
  /**
   * @type {boolean}
   */

  this._initialized;
  /**
   * @type {module:zrender/container/Group}
   */

  group.add(this._regionsGroup = new graphic.Group());
  /**
   * @type {module:zrender/container/Group}
   */

  group.add(this._backgroundGroup = new graphic.Group());
}

MapDraw.prototype = {
  constructor: MapDraw,
  draw: function (mapOrGeoModel, ecModel, api, fromView, payload) {
    var isGeo = mapOrGeoModel.mainType === 'geo'; // Map series has data. GEO model that controlled by map series
    // will be assigned with map data. Other GEO model has no data.

    var data = mapOrGeoModel.getData && mapOrGeoModel.getData();
    isGeo && ecModel.eachComponent({
      mainType: 'series',
      subType: 'map'
    }, function (mapSeries) {
      if (!data && mapSeries.getHostGeoModel() === mapOrGeoModel) {
        data = mapSeries.getData();
      }
    });
    var geo = mapOrGeoModel.coordinateSystem;

    this._updateBackground(geo);

    var regionsGroup = this._regionsGroup;
    var group = this.group;
    var transformInfo = geo.getTransformInfo(); // No animation when first draw or in action

    var isFirstDraw = !regionsGroup.childAt(0) || payload;
    var targetScale;

    if (isFirstDraw) {
      group.transform = transformInfo.roamTransform;
      group.decomposeTransform();
      group.dirty();
    } else {
      var target = new Transformable();
      target.transform = transformInfo.roamTransform;
      target.decomposeTransform();
      var props = {
        scale: target.scale,
        position: target.position
      };
      targetScale = target.scale;
      graphic.updateProps(group, props, mapOrGeoModel);
    }

    var scale = transformInfo.rawScale;
    var position = transformInfo.rawPosition;
    regionsGroup.removeAll();
    var itemStyleAccessPath = ['itemStyle'];
    var hoverItemStyleAccessPath = ['emphasis', 'itemStyle'];
    var labelAccessPath = ['label'];
    var hoverLabelAccessPath = ['emphasis', 'label'];
    var nameMap = zrUtil.createHashMap();
    zrUtil.each(geo.regions, function (region) {
      // Consider in GeoJson properties.name may be duplicated, for example,
      // there is multiple region named "United Kindom" or "France" (so many
      // colonies). And it is not appropriate to merge them in geo, which
      // will make them share the same label and bring trouble in label
      // location calculation.
      var regionGroup = nameMap.get(region.name) || nameMap.set(region.name, new graphic.Group());
      var compoundPath = new graphic.CompoundPath({
        segmentIgnoreThreshold: 1,
        shape: {
          paths: []
        }
      });
      regionGroup.add(compoundPath);
      var regionModel = mapOrGeoModel.getRegionModel(region.name) || mapOrGeoModel;
      var itemStyleModel = regionModel.getModel(itemStyleAccessPath);
      var hoverItemStyleModel = regionModel.getModel(hoverItemStyleAccessPath);
      var itemStyle = getFixedItemStyle(itemStyleModel);
      var hoverItemStyle = getFixedItemStyle(hoverItemStyleModel);
      var labelModel = regionModel.getModel(labelAccessPath);
      var hoverLabelModel = regionModel.getModel(hoverLabelAccessPath);
      var dataIdx; // Use the itemStyle in data if has data

      if (data) {
        dataIdx = data.indexOfName(region.name); // Only visual color of each item will be used. It can be encoded by dataRange
        // But visual color of series is used in symbol drawing
        //
        // Visual color for each series is for the symbol draw

        var visualColor = data.getItemVisual(dataIdx, 'color', true);

        if (visualColor) {
          itemStyle.fill = visualColor;
        }
      }

      var transformPoint = function (point) {
        return [point[0] * scale[0] + position[0], point[1] * scale[1] + position[1]];
      };

      zrUtil.each(region.geometries, function (geometry) {
        if (geometry.type !== 'polygon') {
          return;
        }

        var points = [];

        for (var i = 0; i < geometry.exterior.length; ++i) {
          points.push(transformPoint(geometry.exterior[i]));
        }

        compoundPath.shape.paths.push(new graphic.Polygon({
          segmentIgnoreThreshold: 1,
          shape: {
            points: points
          }
        }));

        for (var i = 0; i < (geometry.interiors ? geometry.interiors.length : 0); ++i) {
          var interior = geometry.interiors[i];
          var points = [];

          for (var j = 0; j < interior.length; ++j) {
            points.push(transformPoint(interior[j]));
          }

          compoundPath.shape.paths.push(new graphic.Polygon({
            segmentIgnoreThreshold: 1,
            shape: {
              points: points
            }
          }));
        }
      });
      compoundPath.setStyle(itemStyle);
      compoundPath.style.strokeNoScale = true;
      compoundPath.culling = true; // Label

      var showLabel = labelModel.get('show');
      var hoverShowLabel = hoverLabelModel.get('show');
      var isDataNaN = data && isNaN(data.get(data.mapDimension('value'), dataIdx));
      var itemLayout = data && data.getItemLayout(dataIdx); // In the following cases label will be drawn
      // 1. In map series and data value is NaN
      // 2. In geo component
      // 4. Region has no series legendSymbol, which will be add a showLabel flag in mapSymbolLayout

      if (isGeo || isDataNaN && (showLabel || hoverShowLabel) || itemLayout && itemLayout.showLabel) {
        var query = !isGeo ? dataIdx : region.name;
        var labelFetcher; // Consider dataIdx not found.

        if (!data || dataIdx >= 0) {
          labelFetcher = mapOrGeoModel;
        }

        var textEl = new graphic.Text({
          position: transformPoint(region.center.slice()),
          // FIXME
          // label rotation is not support yet in geo or regions of series-map
          // that has no data. The rotation will be effected by this `scale`.
          // So needed to change to RectText?
          scale: [1 / group.scale[0], 1 / group.scale[1]],
          z2: 10,
          silent: true
        });
        graphic.setLabelStyle(textEl.style, textEl.hoverStyle = {}, labelModel, hoverLabelModel, {
          labelFetcher: labelFetcher,
          labelDataIndex: query,
          defaultText: region.name,
          useInsideStyle: false
        }, {
          textAlign: 'center',
          textVerticalAlign: 'middle'
        });

        if (!isFirstDraw) {
          // Text animation
          var textScale = [1 / targetScale[0], 1 / targetScale[1]];
          graphic.updateProps(textEl, {
            scale: textScale
          }, mapOrGeoModel);
        }

        regionGroup.add(textEl);
      } // setItemGraphicEl, setHoverStyle after all polygons and labels
      // are added to the rigionGroup


      if (data) {
        data.setItemGraphicEl(dataIdx, regionGroup);
      } else {
        var regionModel = mapOrGeoModel.getRegionModel(region.name); // Package custom mouse event for geo component

        compoundPath.eventData = {
          componentType: 'geo',
          componentIndex: mapOrGeoModel.componentIndex,
          geoIndex: mapOrGeoModel.componentIndex,
          name: region.name,
          region: regionModel && regionModel.option || {}
        };
      }

      var groupRegions = regionGroup.__regions || (regionGroup.__regions = []);
      groupRegions.push(region);
      regionGroup.highDownSilentOnTouch = !!mapOrGeoModel.get('selectedMode');
      graphic.setHoverStyle(regionGroup, hoverItemStyle);
      regionsGroup.add(regionGroup);
    });

    this._updateController(mapOrGeoModel, ecModel, api);

    updateMapSelectHandler(this, mapOrGeoModel, regionsGroup, api, fromView);
    updateMapSelected(mapOrGeoModel, regionsGroup);
  },
  remove: function () {
    this._regionsGroup.removeAll();

    this._backgroundGroup.removeAll();

    this._controller.dispose();

    this._mapName && geoSourceManager.removeGraphic(this._mapName, this.uid);
    this._mapName = null;
    this._controllerHost = {};
  },
  _updateBackground: function (geo) {
    var mapName = geo.map;

    if (this._mapName !== mapName) {
      zrUtil.each(geoSourceManager.makeGraphic(mapName, this.uid), function (root) {
        this._backgroundGroup.add(root);
      }, this);
    }

    this._mapName = mapName;
  },
  _updateController: function (mapOrGeoModel, ecModel, api) {
    var geo = mapOrGeoModel.coordinateSystem;
    var controller = this._controller;
    var controllerHost = this._controllerHost;
    controllerHost.zoomLimit = mapOrGeoModel.get('scaleLimit');
    controllerHost.zoom = geo.getZoom(); // roamType is will be set default true if it is null

    controller.enable(mapOrGeoModel.get('roam') || false);
    var mainType = mapOrGeoModel.mainType;

    function makeActionBase() {
      var action = {
        type: 'geoRoam',
        componentType: mainType
      };
      action[mainType + 'Id'] = mapOrGeoModel.id;
      return action;
    }

    controller.off('pan').on('pan', function (e) {
      this._mouseDownFlag = false;
      roamHelper.updateViewOnPan(controllerHost, e.dx, e.dy);
      api.dispatchAction(zrUtil.extend(makeActionBase(), {
        dx: e.dx,
        dy: e.dy
      }));
    }, this);
    controller.off('zoom').on('zoom', function (e) {
      this._mouseDownFlag = false;
      roamHelper.updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
      api.dispatchAction(zrUtil.extend(makeActionBase(), {
        zoom: e.scale,
        originX: e.originX,
        originY: e.originY
      }));

      if (this._updateGroup) {
        var scale = this.group.scale;

        this._regionsGroup.traverse(function (el) {
          if (el.type === 'text') {
            el.attr('scale', [1 / scale[0], 1 / scale[1]]);
          }
        });
      }
    }, this);
    controller.setPointerChecker(function (e, x, y) {
      return geo.getViewRectAfterRoam().contain(x, y) && !onIrrelevantElement(e, api, mapOrGeoModel);
    });
  }
};
var _default = MapDraw;
module.exports = _default;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var ATTR = '\0_ec_interaction_mutex';

function take(zr, resourceKey, userKey) {
  var store = getStore(zr);
  store[resourceKey] = userKey;
}

function release(zr, resourceKey, userKey) {
  var store = getStore(zr);
  var uKey = store[resourceKey];

  if (uKey === userKey) {
    store[resourceKey] = null;
  }
}

function isTaken(zr, resourceKey) {
  return !!getStore(zr)[resourceKey];
}

function getStore(zr) {
  return zr[ATTR] || (zr[ATTR] = {});
}
/**
 * payload: {
 *     type: 'takeGlobalCursor',
 *     key: 'dataZoomSelect', or 'brush', or ...,
 *         If no userKey, release global cursor.
 * }
 */


echarts.registerAction({
  type: 'takeGlobalCursor',
  event: 'globalCursorTaken',
  update: 'update'
}, function () {});
exports.take = take;
exports.release = release;
exports.isTaken = isTaken;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var _roamHelper = __webpack_require__(418);

var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @payload
 * @property {string} [componentType=series]
 * @property {number} [dx]
 * @property {number} [dy]
 * @property {number} [zoom]
 * @property {number} [originX]
 * @property {number} [originY]
 */
echarts.registerAction({
  type: 'geoRoam',
  event: 'geoRoam',
  update: 'updateTransform'
}, function (payload, ecModel) {
  var componentType = payload.componentType || 'series';
  ecModel.eachComponent({
    mainType: componentType,
    query: payload
  }, function (componentModel) {
    var geo = componentModel.coordinateSystem;

    if (geo.type !== 'geo') {
      return;
    }

    var res = updateCenterAndZoom(geo, payload, componentModel.get('scaleLimit'));
    componentModel.setCenter && componentModel.setCenter(res.center);
    componentModel.setZoom && componentModel.setZoom(res.zoom); // All map series with same `map` use the same geo coordinate system
    // So the center and zoom must be in sync. Include the series not selected by legend

    if (componentType === 'series') {
      zrUtil.each(componentModel.seriesGroup, function (seriesModel) {
        seriesModel.setCenter(res.center);
        seriesModel.setZoom(res.zoom);
      });
    }
  });
});

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Link lists and struct (graph or tree)
 */
var each = zrUtil.each;
var DATAS = '\0__link_datas';
var MAIN_DATA = '\0__link_mainData'; // Caution:
// In most case, either list or its shallow clones (see list.cloneShallow)
// is active in echarts process. So considering heap memory consumption,
// we do not clone tree or graph, but share them among list and its shallow clones.
// But in some rare case, we have to keep old list (like do animation in chart). So
// please take care that both the old list and the new list share the same tree/graph.

/**
 * @param {Object} opt
 * @param {module:echarts/data/List} opt.mainData
 * @param {Object} [opt.struct] For example, instance of Graph or Tree.
 * @param {string} [opt.structAttr] designation: list[structAttr] = struct;
 * @param {Object} [opt.datas] {dataType: data},
 *                 like: {node: nodeList, edge: edgeList}.
 *                 Should contain mainData.
 * @param {Object} [opt.datasAttr] {dataType: attr},
 *                 designation: struct[datasAttr[dataType]] = list;
 */

function linkList(opt) {
  var mainData = opt.mainData;
  var datas = opt.datas;

  if (!datas) {
    datas = {
      main: mainData
    };
    opt.datasAttr = {
      main: 'data'
    };
  }

  opt.datas = opt.mainData = null;
  linkAll(mainData, datas, opt); // Porxy data original methods.

  each(datas, function (data) {
    each(mainData.TRANSFERABLE_METHODS, function (methodName) {
      data.wrapMethod(methodName, zrUtil.curry(transferInjection, opt));
    });
  }); // Beyond transfer, additional features should be added to `cloneShallow`.

  mainData.wrapMethod('cloneShallow', zrUtil.curry(cloneShallowInjection, opt)); // Only mainData trigger change, because struct.update may trigger
  // another changable methods, which may bring about dead lock.

  each(mainData.CHANGABLE_METHODS, function (methodName) {
    mainData.wrapMethod(methodName, zrUtil.curry(changeInjection, opt));
  }); // Make sure datas contains mainData.

  zrUtil.assert(datas[mainData.dataType] === mainData);
}

function transferInjection(opt, res) {
  if (isMainData(this)) {
    // Transfer datas to new main data.
    var datas = zrUtil.extend({}, this[DATAS]);
    datas[this.dataType] = res;
    linkAll(res, datas, opt);
  } else {
    // Modify the reference in main data to point newData.
    linkSingle(res, this.dataType, this[MAIN_DATA], opt);
  }

  return res;
}

function changeInjection(opt, res) {
  opt.struct && opt.struct.update(this);
  return res;
}

function cloneShallowInjection(opt, res) {
  // cloneShallow, which brings about some fragilities, may be inappropriate
  // to be exposed as an API. So for implementation simplicity we can make
  // the restriction that cloneShallow of not-mainData should not be invoked
  // outside, but only be invoked here.
  each(res[DATAS], function (data, dataType) {
    data !== res && linkSingle(data.cloneShallow(), dataType, res, opt);
  });
  return res;
}
/**
 * Supplement method to List.
 *
 * @public
 * @param {string} [dataType] If not specified, return mainData.
 * @return {module:echarts/data/List}
 */


function getLinkedData(dataType) {
  var mainData = this[MAIN_DATA];
  return dataType == null || mainData == null ? mainData : mainData[DATAS][dataType];
}

function isMainData(data) {
  return data[MAIN_DATA] === data;
}

function linkAll(mainData, datas, opt) {
  mainData[DATAS] = {};
  each(datas, function (data, dataType) {
    linkSingle(data, dataType, mainData, opt);
  });
}

function linkSingle(data, dataType, mainData, opt) {
  mainData[DATAS][dataType] = data;
  data[MAIN_DATA] = mainData;
  data.dataType = dataType;

  if (opt.struct) {
    data[opt.structAttr] = opt.struct;
    opt.struct[opt.datasAttr[dataType]] = data;
  } // Supplement method.


  data.getLinkedData = getLinkedData;
}

var _default = linkList;
module.exports = _default;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var layout = __webpack_require__(53);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* A third-party license is embeded for some of the code in this file:
* The tree layoutHelper implementation was originally copied from
* "d3.js"(https://github.com/d3/d3-hierarchy) with
* some modifications made for this project.
* (see more details in the comment of the specific method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the licence of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/

/**
 * @file The layout algorithm of node-link tree diagrams. Here we using Reingold-Tilford algorithm to drawing
 *       the tree.
 */

/**
 * Initialize all computational message for following algorithm.
 *
 * @param  {module:echarts/data/Tree~TreeNode} root   The virtual root of the tree.
 */
function init(root) {
  root.hierNode = {
    defaultAncestor: null,
    ancestor: root,
    prelim: 0,
    modifier: 0,
    change: 0,
    shift: 0,
    i: 0,
    thread: null
  };
  var nodes = [root];
  var node;
  var children;

  while (node = nodes.pop()) {
    // jshint ignore:line
    children = node.children;

    if (node.isExpand && children.length) {
      var n = children.length;

      for (var i = n - 1; i >= 0; i--) {
        var child = children[i];
        child.hierNode = {
          defaultAncestor: null,
          ancestor: child,
          prelim: 0,
          modifier: 0,
          change: 0,
          shift: 0,
          i: i,
          thread: null
        };
        nodes.push(child);
      }
    }
  }
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * Computes a preliminary x coordinate for node. Before that, this function is
 * applied recursively to the children of node, as well as the function
 * apportion(). After spacing out the children by calling executeShifts(), the
 * node is placed to the midpoint of its outermost children.
 *
 * @param  {module:echarts/data/Tree~TreeNode} node
 * @param {Function} separation
 */


function firstWalk(node, separation) {
  var children = node.isExpand ? node.children : [];
  var siblings = node.parentNode.children;
  var subtreeW = node.hierNode.i ? siblings[node.hierNode.i - 1] : null;

  if (children.length) {
    executeShifts(node);
    var midPoint = (children[0].hierNode.prelim + children[children.length - 1].hierNode.prelim) / 2;

    if (subtreeW) {
      node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
      node.hierNode.modifier = node.hierNode.prelim - midPoint;
    } else {
      node.hierNode.prelim = midPoint;
    }
  } else if (subtreeW) {
    node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
  }

  node.parentNode.hierNode.defaultAncestor = apportion(node, subtreeW, node.parentNode.hierNode.defaultAncestor || siblings[0], separation);
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * Computes all real x-coordinates by summing up the modifiers recursively.
 *
 * @param  {module:echarts/data/Tree~TreeNode} node
 */


function secondWalk(node) {
  var nodeX = node.hierNode.prelim + node.parentNode.hierNode.modifier;
  node.setLayout({
    x: nodeX
  }, true);
  node.hierNode.modifier += node.parentNode.hierNode.modifier;
}

function separation(cb) {
  return arguments.length ? cb : defaultSeparation;
}
/**
 * Transform the common coordinate to radial coordinate.
 *
 * @param  {number} x
 * @param  {number} y
 * @return {Object}
 */


function radialCoordinate(x, y) {
  var radialCoor = {};
  x -= Math.PI / 2;
  radialCoor.x = y * Math.cos(x);
  radialCoor.y = y * Math.sin(x);
  return radialCoor;
}
/**
 * Get the layout position of the whole view.
 *
 * @param {module:echarts/model/Series} seriesModel  the model object of sankey series
 * @param {module:echarts/ExtensionAPI} api  provide the API list that the developer can call
 * @return {module:zrender/core/BoundingRect}  size of rect to draw the sankey view
 */


function getViewRect(seriesModel, api) {
  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  });
}
/**
 * All other shifts, applied to the smaller subtrees between w- and w+, are
 * performed by this function.
 *
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * @param  {module:echarts/data/Tree~TreeNode} node
 */


function executeShifts(node) {
  var children = node.children;
  var n = children.length;
  var shift = 0;
  var change = 0;

  while (--n >= 0) {
    var child = children[n];
    child.hierNode.prelim += shift;
    child.hierNode.modifier += shift;
    change += child.hierNode.change;
    shift += child.hierNode.shift + change;
  }
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * The core of the algorithm. Here, a new subtree is combined with the
 * previous subtrees. Threads are used to traverse the inside and outside
 * contours of the left and right subtree up to the highest common level.
 * Whenever two nodes of the inside contours conflict, we compute the left
 * one of the greatest uncommon ancestors using the function nextAncestor()
 * and call moveSubtree() to shift the subtree and prepare the shifts of
 * smaller subtrees. Finally, we add a new thread (if necessary).
 *
 * @param  {module:echarts/data/Tree~TreeNode} subtreeV
 * @param  {module:echarts/data/Tree~TreeNode} subtreeW
 * @param  {module:echarts/data/Tree~TreeNode} ancestor
 * @param  {Function} separation
 * @return {module:echarts/data/Tree~TreeNode}
 */


function apportion(subtreeV, subtreeW, ancestor, separation) {
  if (subtreeW) {
    var nodeOutRight = subtreeV;
    var nodeInRight = subtreeV;
    var nodeOutLeft = nodeInRight.parentNode.children[0];
    var nodeInLeft = subtreeW;
    var sumOutRight = nodeOutRight.hierNode.modifier;
    var sumInRight = nodeInRight.hierNode.modifier;
    var sumOutLeft = nodeOutLeft.hierNode.modifier;
    var sumInLeft = nodeInLeft.hierNode.modifier;

    while (nodeInLeft = nextRight(nodeInLeft), nodeInRight = nextLeft(nodeInRight), nodeInLeft && nodeInRight) {
      nodeOutRight = nextRight(nodeOutRight);
      nodeOutLeft = nextLeft(nodeOutLeft);
      nodeOutRight.hierNode.ancestor = subtreeV;
      var shift = nodeInLeft.hierNode.prelim + sumInLeft - nodeInRight.hierNode.prelim - sumInRight + separation(nodeInLeft, nodeInRight);

      if (shift > 0) {
        moveSubtree(nextAncestor(nodeInLeft, subtreeV, ancestor), subtreeV, shift);
        sumInRight += shift;
        sumOutRight += shift;
      }

      sumInLeft += nodeInLeft.hierNode.modifier;
      sumInRight += nodeInRight.hierNode.modifier;
      sumOutRight += nodeOutRight.hierNode.modifier;
      sumOutLeft += nodeOutLeft.hierNode.modifier;
    }

    if (nodeInLeft && !nextRight(nodeOutRight)) {
      nodeOutRight.hierNode.thread = nodeInLeft;
      nodeOutRight.hierNode.modifier += sumInLeft - sumOutRight;
    }

    if (nodeInRight && !nextLeft(nodeOutLeft)) {
      nodeOutLeft.hierNode.thread = nodeInRight;
      nodeOutLeft.hierNode.modifier += sumInRight - sumOutLeft;
      ancestor = subtreeV;
    }
  }

  return ancestor;
}
/**
 * This function is used to traverse the right contour of a subtree.
 * It returns the rightmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 *
 * @param  {module:echarts/data/Tree~TreeNode} node
 * @return {module:echarts/data/Tree~TreeNode}
 */


function nextRight(node) {
  var children = node.children;
  return children.length && node.isExpand ? children[children.length - 1] : node.hierNode.thread;
}
/**
 * This function is used to traverse the left contour of a subtree (or a subforest).
 * It returns the leftmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 *
 * @param  {module:echarts/data/Tree~TreeNode} node
 * @return {module:echarts/data/Tree~TreeNode}
 */


function nextLeft(node) {
  var children = node.children;
  return children.length && node.isExpand ? children[0] : node.hierNode.thread;
}
/**
 * If nodeInLeft’s ancestor is a sibling of node, returns nodeInLeft’s ancestor.
 * Otherwise, returns the specified ancestor.
 *
 * @param  {module:echarts/data/Tree~TreeNode} nodeInLeft
 * @param  {module:echarts/data/Tree~TreeNode} node
 * @param  {module:echarts/data/Tree~TreeNode} ancestor
 * @return {module:echarts/data/Tree~TreeNode}
 */


function nextAncestor(nodeInLeft, node, ancestor) {
  return nodeInLeft.hierNode.ancestor.parentNode === node.parentNode ? nodeInLeft.hierNode.ancestor : ancestor;
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * Shifts the current subtree rooted at wr.
 * This is done by increasing prelim(w+) and modifier(w+) by shift.
 *
 * @param  {module:echarts/data/Tree~TreeNode} wl
 * @param  {module:echarts/data/Tree~TreeNode} wr
 * @param  {number} shift [description]
 */


function moveSubtree(wl, wr, shift) {
  var change = shift / (wr.hierNode.i - wl.hierNode.i);
  wr.hierNode.change -= change;
  wr.hierNode.shift += shift;
  wr.hierNode.modifier += shift;
  wr.hierNode.prelim += shift;
  wl.hierNode.change += change;
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */


function defaultSeparation(node1, node2) {
  return node1.parentNode === node2.parentNode ? 1 : 2;
}

exports.init = init;
exports.firstWalk = firstWalk;
exports.secondWalk = secondWalk;
exports.separation = separation;
exports.radialCoordinate = radialCoordinate;
exports.getViewRect = getViewRect;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var List = __webpack_require__(98);

var Graph = __webpack_require__(1637);

var linkList = __webpack_require__(660);

var createDimensions = __webpack_require__(207);

var CoordinateSystem = __webpack_require__(108);

var createListFromArray = __webpack_require__(137);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(nodes, edges, seriesModel, directed, beforeLink) {
  // ??? TODO
  // support dataset?
  var graph = new Graph(directed);

  for (var i = 0; i < nodes.length; i++) {
    graph.addNode(zrUtil.retrieve( // Id, name, dataIndex
    nodes[i].id, nodes[i].name, i), i);
  }

  var linkNameList = [];
  var validEdges = [];
  var linkCount = 0;

  for (var i = 0; i < edges.length; i++) {
    var link = edges[i];
    var source = link.source;
    var target = link.target; // addEdge may fail when source or target not exists

    if (graph.addEdge(source, target, linkCount)) {
      validEdges.push(link);
      linkNameList.push(zrUtil.retrieve(link.id, source + ' > ' + target));
      linkCount++;
    }
  }

  var coordSys = seriesModel.get('coordinateSystem');
  var nodeData;

  if (coordSys === 'cartesian2d' || coordSys === 'polar') {
    nodeData = createListFromArray(nodes, seriesModel);
  } else {
    var coordSysCtor = CoordinateSystem.get(coordSys);
    var coordDimensions = coordSysCtor && coordSysCtor.type !== 'view' ? coordSysCtor.dimensions || [] : []; // FIXME: Some geo do not need `value` dimenson, whereas `calendar` needs
    // `value` dimension, but graph need `value` dimension. It's better to
    // uniform this behavior.

    if (zrUtil.indexOf(coordDimensions, 'value') < 0) {
      coordDimensions.concat(['value']);
    }

    var dimensionNames = createDimensions(nodes, {
      coordDimensions: coordDimensions
    });
    nodeData = new List(dimensionNames, seriesModel);
    nodeData.initData(nodes);
  }

  var edgeData = new List(['value'], seriesModel);
  edgeData.initData(validEdges, linkNameList);
  beforeLink && beforeLink(nodeData, edgeData);
  linkList({
    mainData: nodeData,
    struct: graph,
    structAttr: 'graph',
    datas: {
      node: nodeData,
      edge: edgeData
    },
    datasAttr: {
      node: 'data',
      edge: 'edgeData'
    }
  }); // Update dataIndex of nodes and edges because invalid edge may be removed

  graph.update();
  return graph;
}

module.exports = _default;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @payload
 * @property {number} [seriesIndex]
 * @property {string} [seriesId]
 * @property {string} [seriesName]
 * @property {number} [dataIndex]
 */
echarts.registerAction({
  type: 'focusNodeAdjacency',
  event: 'focusNodeAdjacency',
  update: 'series:focusNodeAdjacency'
}, function () {});
/**
 * @payload
 * @property {number} [seriesIndex]
 * @property {string} [seriesId]
 * @property {string} [seriesName]
 */

echarts.registerAction({
  type: 'unfocusNodeAdjacency',
  event: 'unfocusNodeAdjacency',
  update: 'series:unfocusNodeAdjacency'
}, function () {});

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var vec2 = __webpack_require__(55);

var zrUtil = __webpack_require__(1);

var _multipleGraphEdgeHelper = __webpack_require__(307);

var getCurvenessForEdge = _multipleGraphEdgeHelper.getCurvenessForEdge;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function simpleLayout(seriesModel) {
  var coordSys = seriesModel.coordinateSystem;

  if (coordSys && coordSys.type !== 'view') {
    return;
  }

  var graph = seriesModel.getGraph();
  graph.eachNode(function (node) {
    var model = node.getModel();
    node.setLayout([+model.get('x'), +model.get('y')]);
  });
  simpleLayoutEdge(graph, seriesModel);
}

function simpleLayoutEdge(graph, seriesModel) {
  graph.eachEdge(function (edge, index) {
    var curveness = zrUtil.retrieve3(edge.getModel().get('lineStyle.curveness'), -getCurvenessForEdge(edge, seriesModel, index, true), 0);
    var p1 = vec2.clone(edge.node1.getLayout());
    var p2 = vec2.clone(edge.node2.getLayout());
    var points = [p1, p2];

    if (+curveness) {
      points.push([(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * curveness]);
    }

    edge.setLayout(points);
  });
}

exports.simpleLayout = simpleLayout;
exports.simpleLayoutEdge = simpleLayoutEdge;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var vec2 = __webpack_require__(55);

var _graphHelper = __webpack_require__(424);

var getSymbolSize = _graphHelper.getSymbolSize;
var getNodeGlobalScale = _graphHelper.getNodeGlobalScale;

var zrUtil = __webpack_require__(1);

var _multipleGraphEdgeHelper = __webpack_require__(307);

var getCurvenessForEdge = _multipleGraphEdgeHelper.getCurvenessForEdge;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var PI = Math.PI;
var _symbolRadiansHalf = [];
/**
 * `basedOn` can be:
 * 'value':
 *     This layout is not accurate and have same bad case. For example,
 *     if the min value is very smaller than the max value, the nodes
 *     with the min value probably overlap even though there is enough
 *     space to layout them. So we only use this approach in the as the
 *     init layout of the force layout.
 *     FIXME
 *     Probably we do not need this method any more but use
 *     `basedOn: 'symbolSize'` in force layout if
 *     delay its init operations to GraphView.
 * 'symbolSize':
 *     This approach work only if all of the symbol size calculated.
 *     That is, the progressive rendering is not applied to graph.
 *     FIXME
 *     If progressive rendering is applied to graph some day,
 *     probably we have to use `basedOn: 'value'`.
 *
 * @param {module:echarts/src/model/Series} seriesModel
 * @param {string} basedOn 'value' or 'symbolSize'
 */

function circularLayout(seriesModel, basedOn) {
  var coordSys = seriesModel.coordinateSystem;

  if (coordSys && coordSys.type !== 'view') {
    return;
  }

  var rect = coordSys.getBoundingRect();
  var nodeData = seriesModel.getData();
  var graph = nodeData.graph;
  var cx = rect.width / 2 + rect.x;
  var cy = rect.height / 2 + rect.y;
  var r = Math.min(rect.width, rect.height) / 2;
  var count = nodeData.count();
  nodeData.setLayout({
    cx: cx,
    cy: cy
  });

  if (!count) {
    return;
  }

  _layoutNodesBasedOn[basedOn](seriesModel, coordSys, graph, nodeData, r, cx, cy, count);

  graph.eachEdge(function (edge, index) {
    var curveness = zrUtil.retrieve3(edge.getModel().get('lineStyle.curveness'), getCurvenessForEdge(edge, seriesModel, index), 0);
    var p1 = vec2.clone(edge.node1.getLayout());
    var p2 = vec2.clone(edge.node2.getLayout());
    var cp1;
    var x12 = (p1[0] + p2[0]) / 2;
    var y12 = (p1[1] + p2[1]) / 2;

    if (+curveness) {
      curveness *= 3;
      cp1 = [cx * curveness + x12 * (1 - curveness), cy * curveness + y12 * (1 - curveness)];
    }

    edge.setLayout([p1, p2, cp1]);
  });
}

var _layoutNodesBasedOn = {
  value: function (seriesModel, coordSys, graph, nodeData, r, cx, cy, count) {
    var angle = 0;
    var sum = nodeData.getSum('value');
    var unitAngle = Math.PI * 2 / (sum || count);
    graph.eachNode(function (node) {
      var value = node.getValue('value');
      var radianHalf = unitAngle * (sum ? value : 1) / 2;
      angle += radianHalf;
      node.setLayout([r * Math.cos(angle) + cx, r * Math.sin(angle) + cy]);
      angle += radianHalf;
    });
  },
  symbolSize: function (seriesModel, coordSys, graph, nodeData, r, cx, cy, count) {
    var sumRadian = 0;
    _symbolRadiansHalf.length = count;
    var nodeScale = getNodeGlobalScale(seriesModel);
    graph.eachNode(function (node) {
      var symbolSize = getSymbolSize(node); // Normally this case will not happen, but we still add
      // some the defensive code (2px is an arbitrary value).

      isNaN(symbolSize) && (symbolSize = 2);
      symbolSize < 0 && (symbolSize = 0);
      symbolSize *= nodeScale;
      var symbolRadianHalf = Math.asin(symbolSize / 2 / r); // when `symbolSize / 2` is bigger than `r`.

      isNaN(symbolRadianHalf) && (symbolRadianHalf = PI / 2);
      _symbolRadiansHalf[node.dataIndex] = symbolRadianHalf;
      sumRadian += symbolRadianHalf * 2;
    });
    var halfRemainRadian = (2 * PI - sumRadian) / count / 2;
    var angle = 0;
    graph.eachNode(function (node) {
      var radianHalf = halfRemainRadian + _symbolRadiansHalf[node.dataIndex];
      angle += radianHalf;
      node.setLayout([r * Math.cos(angle) + cx, r * Math.sin(angle) + cy]);
      angle += radianHalf;
    });
  }
};
exports.circularLayout = circularLayout;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var throttleUtil = __webpack_require__(148);

var parallelPreprocessor = __webpack_require__(1659);

__webpack_require__(667);

__webpack_require__(1662);

__webpack_require__(1664);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var CLICK_THRESHOLD = 5; // > 4
// Parallel view

echarts.extendComponentView({
  type: 'parallel',
  render: function (parallelModel, ecModel, api) {
    this._model = parallelModel;
    this._api = api;

    if (!this._handlers) {
      this._handlers = {};
      zrUtil.each(handlers, function (handler, eventName) {
        api.getZr().on(eventName, this._handlers[eventName] = zrUtil.bind(handler, this));
      }, this);
    }

    throttleUtil.createOrUpdate(this, '_throttledDispatchExpand', parallelModel.get('axisExpandRate'), 'fixRate');
  },
  dispose: function (ecModel, api) {
    zrUtil.each(this._handlers, function (handler, eventName) {
      api.getZr().off(eventName, handler);
    });
    this._handlers = null;
  },

  /**
   * @param {Object} [opt] If null, cancle the last action triggering for debounce.
   */
  _throttledDispatchExpand: function (opt) {
    this._dispatchExpand(opt);
  },
  _dispatchExpand: function (opt) {
    opt && this._api.dispatchAction(zrUtil.extend({
      type: 'parallelAxisExpand'
    }, opt));
  }
});
var handlers = {
  mousedown: function (e) {
    if (checkTrigger(this, 'click')) {
      this._mouseDownPoint = [e.offsetX, e.offsetY];
    }
  },
  mouseup: function (e) {
    var mouseDownPoint = this._mouseDownPoint;

    if (checkTrigger(this, 'click') && mouseDownPoint) {
      var point = [e.offsetX, e.offsetY];
      var dist = Math.pow(mouseDownPoint[0] - point[0], 2) + Math.pow(mouseDownPoint[1] - point[1], 2);

      if (dist > CLICK_THRESHOLD) {
        return;
      }

      var result = this._model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);

      result.behavior !== 'none' && this._dispatchExpand({
        axisExpandWindow: result.axisExpandWindow
      });
    }

    this._mouseDownPoint = null;
  },
  mousemove: function (e) {
    // Should do nothing when brushing.
    if (this._mouseDownPoint || !checkTrigger(this, 'mousemove')) {
      return;
    }

    var model = this._model;
    var result = model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);
    var behavior = result.behavior;
    behavior === 'jump' && this._throttledDispatchExpand.debounceNextCall(model.get('axisExpandDebounce'));

    this._throttledDispatchExpand(behavior === 'none' ? null // Cancle the last trigger, in case that mouse slide out of the area quickly.
    : {
      axisExpandWindow: result.axisExpandWindow,
      // Jumping uses animation, and sliding suppresses animation.
      animation: behavior === 'jump' ? null : false
    });
  }
};

function checkTrigger(view, triggerOn) {
  var model = view._model;
  return model.get('axisExpandable') && model.get('axisExpandTriggerOn') === triggerOn;
}

echarts.registerPreprocessor(parallelPreprocessor);

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var Parallel = __webpack_require__(1660);

var CoordinateSystem = __webpack_require__(108);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Parallel coordinate system creater.
 */
function create(ecModel, api) {
  var coordSysList = [];
  ecModel.eachComponent('parallel', function (parallelModel, idx) {
    var coordSys = new Parallel(parallelModel, ecModel, api);
    coordSys.name = 'parallel_' + idx;
    coordSys.resize(parallelModel, api);
    parallelModel.coordinateSystem = coordSys;
    coordSys.model = parallelModel;
    coordSysList.push(coordSys);
  }); // Inject the coordinateSystems into seriesModel

  ecModel.eachSeries(function (seriesModel) {
    if (seriesModel.get('coordinateSystem') === 'parallel') {
      var parallelModel = ecModel.queryComponents({
        mainType: 'parallel',
        index: seriesModel.get('parallelIndex'),
        id: seriesModel.get('parallelId')
      })[0];
      seriesModel.coordinateSystem = parallelModel.coordinateSystem;
    }
  });
  return coordSysList;
}

CoordinateSystem.register('parallel', {
  create: create
});

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var BoundingRect = __webpack_require__(57);

var _cursorHelper = __webpack_require__(306);

var onIrrelevantElement = _cursorHelper.onIrrelevantElement;

var graphicUtil = __webpack_require__(27);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function makeRectPanelClipPath(rect) {
  rect = normalizeRect(rect);
  return function (localPoints, transform) {
    return graphicUtil.clipPointsByRect(localPoints, rect);
  };
}

function makeLinearBrushOtherExtent(rect, specifiedXYIndex) {
  rect = normalizeRect(rect);
  return function (xyIndex) {
    var idx = specifiedXYIndex != null ? specifiedXYIndex : xyIndex;
    var brushWidth = idx ? rect.width : rect.height;
    var base = idx ? rect.x : rect.y;
    return [base, base + (brushWidth || 0)];
  };
}

function makeRectIsTargetByCursor(rect, api, targetModel) {
  rect = normalizeRect(rect);
  return function (e, localCursorPoint, transform) {
    return rect.contain(localCursorPoint[0], localCursorPoint[1]) && !onIrrelevantElement(e, api, targetModel);
  };
} // Consider width/height is negative.


function normalizeRect(rect) {
  return BoundingRect.create(rect);
}

exports.makeRectPanelClipPath = makeRectPanelClipPath;
exports.makeLinearBrushOtherExtent = makeLinearBrushOtherExtent;
exports.makeRectIsTargetByCursor = makeRectIsTargetByCursor;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var createListSimply = __webpack_require__(209);

var zrUtil = __webpack_require__(1);

var _dimensionHelper = __webpack_require__(238);

var getDimensionTypeByAxis = _dimensionHelper.getDimensionTypeByAxis;

var _sourceHelper = __webpack_require__(136);

var makeSeriesEncodeForAxisCoordSys = _sourceHelper.makeSeriesEncodeForAxisCoordSys;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var seriesModelMixin = {
  /**
   * @private
   * @type {string}
   */
  _baseAxisDim: null,

  /**
   * @override
   */
  getInitialData: function (option, ecModel) {
    // When both types of xAxis and yAxis are 'value', layout is
    // needed to be specified by user. Otherwise, layout can be
    // judged by which axis is category.
    var ordinalMeta;
    var xAxisModel = ecModel.getComponent('xAxis', this.get('xAxisIndex'));
    var yAxisModel = ecModel.getComponent('yAxis', this.get('yAxisIndex'));
    var xAxisType = xAxisModel.get('type');
    var yAxisType = yAxisModel.get('type');
    var addOrdinal; // FIXME
    // Consider time axis.

    if (xAxisType === 'category') {
      option.layout = 'horizontal';
      ordinalMeta = xAxisModel.getOrdinalMeta();
      addOrdinal = true;
    } else if (yAxisType === 'category') {
      option.layout = 'vertical';
      ordinalMeta = yAxisModel.getOrdinalMeta();
      addOrdinal = true;
    } else {
      option.layout = option.layout || 'horizontal';
    }

    var coordDims = ['x', 'y'];
    var baseAxisDimIndex = option.layout === 'horizontal' ? 0 : 1;
    var baseAxisDim = this._baseAxisDim = coordDims[baseAxisDimIndex];
    var otherAxisDim = coordDims[1 - baseAxisDimIndex];
    var axisModels = [xAxisModel, yAxisModel];
    var baseAxisType = axisModels[baseAxisDimIndex].get('type');
    var otherAxisType = axisModels[1 - baseAxisDimIndex].get('type');
    var data = option.data; // ??? FIXME make a stage to perform data transfrom.
    // MUST create a new data, consider setOption({}) again.

    if (data && addOrdinal) {
      var newOptionData = [];
      zrUtil.each(data, function (item, index) {
        var newItem;

        if (item.value && zrUtil.isArray(item.value)) {
          newItem = item.value.slice();
          item.value.unshift(index);
        } else if (zrUtil.isArray(item)) {
          newItem = item.slice();
          item.unshift(index);
        } else {
          newItem = item;
        }

        newOptionData.push(newItem);
      });
      option.data = newOptionData;
    }

    var defaultValueDimensions = this.defaultValueDimensions;
    var coordDimensions = [{
      name: baseAxisDim,
      type: getDimensionTypeByAxis(baseAxisType),
      ordinalMeta: ordinalMeta,
      otherDims: {
        tooltip: false,
        itemName: 0
      },
      dimsDef: ['base']
    }, {
      name: otherAxisDim,
      type: getDimensionTypeByAxis(otherAxisType),
      dimsDef: defaultValueDimensions.slice()
    }];
    return createListSimply(this, {
      coordDimensions: coordDimensions,
      dimensionsCount: defaultValueDimensions.length + 1,
      encodeDefaulter: zrUtil.curry(makeSeriesEncodeForAxisCoordSys, coordDimensions, this)
    });
  },

  /**
   * If horizontal, base axis is x, otherwise y.
   * @override
   */
  getBaseAxis: function () {
    var dim = this._baseAxisDim;
    return this.ecModel.getComponent(dim + 'Axis', this.get(dim + 'AxisIndex')).axis;
  }
};
exports.seriesModelMixin = seriesModelMixin;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var graphic = __webpack_require__(27);

var Line = __webpack_require__(423);

var zrUtil = __webpack_require__(1);

var _symbol = __webpack_require__(99);

var createSymbol = _symbol.createSymbol;

var vec2 = __webpack_require__(55);

var curveUtil = __webpack_require__(147);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Provide effect for line
 * @module echarts/chart/helper/EffectLine
 */

/**
 * @constructor
 * @extends {module:zrender/graphic/Group}
 * @alias {module:echarts/chart/helper/Line}
 */
function EffectLine(lineData, idx, seriesScope) {
  graphic.Group.call(this);
  this.add(this.createLine(lineData, idx, seriesScope));

  this._updateEffectSymbol(lineData, idx);
}

var effectLineProto = EffectLine.prototype;

effectLineProto.createLine = function (lineData, idx, seriesScope) {
  return new Line(lineData, idx, seriesScope);
};

effectLineProto._updateEffectSymbol = function (lineData, idx) {
  var itemModel = lineData.getItemModel(idx);
  var effectModel = itemModel.getModel('effect');
  var size = effectModel.get('symbolSize');
  var symbolType = effectModel.get('symbol');

  if (!zrUtil.isArray(size)) {
    size = [size, size];
  }

  var color = effectModel.get('color') || lineData.getItemVisual(idx, 'color');
  var symbol = this.childAt(1);

  if (this._symbolType !== symbolType) {
    // Remove previous
    this.remove(symbol);
    symbol = createSymbol(symbolType, -0.5, -0.5, 1, 1, color);
    symbol.z2 = 100;
    symbol.culling = true;
    this.add(symbol);
  } // Symbol may be removed if loop is false


  if (!symbol) {
    return;
  } // Shadow color is same with color in default


  symbol.setStyle('shadowColor', color);
  symbol.setStyle(effectModel.getItemStyle(['color']));
  symbol.attr('scale', size);
  symbol.setColor(color);
  symbol.attr('scale', size);
  this._symbolType = symbolType;
  this._symbolScale = size;

  this._updateEffectAnimation(lineData, effectModel, idx);
};

effectLineProto._updateEffectAnimation = function (lineData, effectModel, idx) {
  var symbol = this.childAt(1);

  if (!symbol) {
    return;
  }

  var self = this;
  var points = lineData.getItemLayout(idx);
  var period = effectModel.get('period') * 1000;
  var loop = effectModel.get('loop');
  var constantSpeed = effectModel.get('constantSpeed');
  var delayExpr = zrUtil.retrieve(effectModel.get('delay'), function (idx) {
    return idx / lineData.count() * period / 3;
  });
  var isDelayFunc = typeof delayExpr === 'function'; // Ignore when updating

  symbol.ignore = true;
  this.updateAnimationPoints(symbol, points);

  if (constantSpeed > 0) {
    period = this.getLineLength(symbol) / constantSpeed * 1000;
  }

  if (period !== this._period || loop !== this._loop) {
    symbol.stopAnimation();
    var delay = delayExpr;

    if (isDelayFunc) {
      delay = delayExpr(idx);
    }

    if (symbol.__t > 0) {
      delay = -period * symbol.__t;
    }

    symbol.__t = 0;
    var animator = symbol.animate('', loop).when(period, {
      __t: 1
    }).delay(delay).during(function () {
      self.updateSymbolPosition(symbol);
    });

    if (!loop) {
      animator.done(function () {
        self.remove(symbol);
      });
    }

    animator.start();
  }

  this._period = period;
  this._loop = loop;
};

effectLineProto.getLineLength = function (symbol) {
  // Not so accurate
  return vec2.dist(symbol.__p1, symbol.__cp1) + vec2.dist(symbol.__cp1, symbol.__p2);
};

effectLineProto.updateAnimationPoints = function (symbol, points) {
  symbol.__p1 = points[0];
  symbol.__p2 = points[1];
  symbol.__cp1 = points[2] || [(points[0][0] + points[1][0]) / 2, (points[0][1] + points[1][1]) / 2];
};

effectLineProto.updateData = function (lineData, idx, seriesScope) {
  this.childAt(0).updateData(lineData, idx, seriesScope);

  this._updateEffectSymbol(lineData, idx);
};

effectLineProto.updateSymbolPosition = function (symbol) {
  var p1 = symbol.__p1;
  var p2 = symbol.__p2;
  var cp1 = symbol.__cp1;
  var t = symbol.__t;
  var pos = symbol.position;
  var lastPos = [pos[0], pos[1]];
  var quadraticAt = curveUtil.quadraticAt;
  var quadraticDerivativeAt = curveUtil.quadraticDerivativeAt;
  pos[0] = quadraticAt(p1[0], cp1[0], p2[0], t);
  pos[1] = quadraticAt(p1[1], cp1[1], p2[1], t); // Tangent

  var tx = quadraticDerivativeAt(p1[0], cp1[0], p2[0], t);
  var ty = quadraticDerivativeAt(p1[1], cp1[1], p2[1], t);
  symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2; // enable continuity trail for 'line', 'rect', 'roundRect' symbolType

  if (this._symbolType === 'line' || this._symbolType === 'rect' || this._symbolType === 'roundRect') {
    if (symbol.__lastT !== undefined && symbol.__lastT < symbol.__t) {
      var scaleY = vec2.dist(lastPos, pos) * 1.05;
      symbol.attr('scale', [symbol.scale[0], scaleY]); // make sure the last segment render within endPoint

      if (t === 1) {
        pos[0] = lastPos[0] + (pos[0] - lastPos[0]) / 2;
        pos[1] = lastPos[1] + (pos[1] - lastPos[1]) / 2;
      }
    } else if (symbol.__lastT === 1) {
      // After first loop, symbol.__t does NOT start with 0, so connect p1 to pos directly.
      var scaleY = 2 * vec2.dist(p1, pos);
      symbol.attr('scale', [symbol.scale[0], scaleY]);
    } else {
      symbol.attr('scale', this._symbolScale);
    }
  }

  symbol.__lastT = symbol.__t;
  symbol.ignore = false;
};

effectLineProto.updateLayout = function (lineData, idx) {
  this.childAt(0).updateLayout(lineData, idx);
  var effectModel = lineData.getItemModel(idx).getModel('effect');

  this._updateEffectAnimation(lineData, effectModel, idx);
};

zrUtil.inherits(EffectLine, graphic.Group);
var _default = EffectLine;
module.exports = _default;

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var graphic = __webpack_require__(27);

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @module echarts/chart/helper/Line
 */

/**
 * @constructor
 * @extends {module:zrender/graphic/Group}
 * @alias {module:echarts/chart/helper/Polyline}
 */
function Polyline(lineData, idx, seriesScope) {
  graphic.Group.call(this);

  this._createPolyline(lineData, idx, seriesScope);
}

var polylineProto = Polyline.prototype;

polylineProto._createPolyline = function (lineData, idx, seriesScope) {
  // var seriesModel = lineData.hostModel;
  var points = lineData.getItemLayout(idx);
  var line = new graphic.Polyline({
    shape: {
      points: points
    }
  });
  this.add(line);

  this._updateCommonStl(lineData, idx, seriesScope);
};

polylineProto.updateData = function (lineData, idx, seriesScope) {
  var seriesModel = lineData.hostModel;
  var line = this.childAt(0);
  var target = {
    shape: {
      points: lineData.getItemLayout(idx)
    }
  };
  graphic.updateProps(line, target, seriesModel, idx);

  this._updateCommonStl(lineData, idx, seriesScope);
};

polylineProto._updateCommonStl = function (lineData, idx, seriesScope) {
  var line = this.childAt(0);
  var itemModel = lineData.getItemModel(idx);
  var visualColor = lineData.getItemVisual(idx, 'color');
  var lineStyle = seriesScope && seriesScope.lineStyle;
  var hoverLineStyle = seriesScope && seriesScope.hoverLineStyle;

  if (!seriesScope || lineData.hasItemOption) {
    lineStyle = itemModel.getModel('lineStyle').getLineStyle();
    hoverLineStyle = itemModel.getModel('emphasis.lineStyle').getLineStyle();
  }

  line.useStyle(zrUtil.defaults({
    strokeNoScale: true,
    fill: 'none',
    stroke: visualColor
  }, lineStyle));
  line.hoverStyle = hoverLineStyle;
  graphic.setHoverStyle(this);
};

polylineProto.updateLayout = function (lineData, idx) {
  var polyline = this.childAt(0);
  polyline.setShape('points', lineData.getItemLayout(idx));
};

zrUtil.inherits(Polyline, graphic.Group);
var _default = Polyline;
module.exports = _default;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var createRenderPlanner = __webpack_require__(206);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/* global Float32Array */
var _default = {
  seriesType: 'lines',
  plan: createRenderPlanner(),
  reset: function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    var isPolyline = seriesModel.get('polyline');
    var isLarge = seriesModel.pipelineContext.large;

    function progress(params, lineData) {
      var lineCoords = [];

      if (isLarge) {
        var points;
        var segCount = params.end - params.start;

        if (isPolyline) {
          var totalCoordsCount = 0;

          for (var i = params.start; i < params.end; i++) {
            totalCoordsCount += seriesModel.getLineCoordsCount(i);
          }

          points = new Float32Array(segCount + totalCoordsCount * 2);
        } else {
          points = new Float32Array(segCount * 4);
        }

        var offset = 0;
        var pt = [];

        for (var i = params.start; i < params.end; i++) {
          var len = seriesModel.getLineCoords(i, lineCoords);

          if (isPolyline) {
            points[offset++] = len;
          }

          for (var k = 0; k < len; k++) {
            pt = coordSys.dataToPoint(lineCoords[k], false, pt);
            points[offset++] = pt[0];
            points[offset++] = pt[1];
          }
        }

        lineData.setLayout('linesPoints', points);
      } else {
        for (var i = params.start; i < params.end; i++) {
          var itemModel = lineData.getItemModel(i);
          var len = seriesModel.getLineCoords(i, lineCoords);
          var pts = [];

          if (isPolyline) {
            for (var j = 0; j < len; j++) {
              pts.push(coordSys.dataToPoint(lineCoords[j]));
            }
          } else {
            pts[0] = coordSys.dataToPoint(lineCoords[0]);
            pts[1] = coordSys.dataToPoint(lineCoords[1]);
            var curveness = itemModel.get('lineStyle.curveness');

            if (+curveness) {
              pts[2] = [(pts[0][0] + pts[1][0]) / 2 - (pts[0][1] - pts[1][1]) * curveness, (pts[0][1] + pts[1][1]) / 2 - (pts[1][0] - pts[0][0]) * curveness];
            }
          }

          lineData.setItemLayout(i, pts);
        }
      }
    }

    return {
      progress: progress
    };
  }
};
module.exports = _default;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(1705);

__webpack_require__(1708);

__webpack_require__(1709);

__webpack_require__(246);

__webpack_require__(1713);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.extendComponentView({
  type: 'single'
});

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @param {Object} opt {labelInside}
 * @return {Object} {
 *  position, rotation, labelDirection, labelOffset,
 *  tickDirection, labelRotate, z2
 * }
 */
function layout(axisModel, opt) {
  opt = opt || {};
  var single = axisModel.coordinateSystem;
  var axis = axisModel.axis;
  var layout = {};
  var axisPosition = axis.position;
  var orient = axis.orient;
  var rect = single.getRect();
  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
  var positionMap = {
    horizontal: {
      top: rectBound[2],
      bottom: rectBound[3]
    },
    vertical: {
      left: rectBound[0],
      right: rectBound[1]
    }
  };
  layout.position = [orient === 'vertical' ? positionMap.vertical[axisPosition] : rectBound[0], orient === 'horizontal' ? positionMap.horizontal[axisPosition] : rectBound[3]];
  var r = {
    horizontal: 0,
    vertical: 1
  };
  layout.rotation = Math.PI / 2 * r[orient];
  var directionMap = {
    top: -1,
    bottom: 1,
    right: 1,
    left: -1
  };
  layout.labelDirection = layout.tickDirection = layout.nameDirection = directionMap[axisPosition];

  if (axisModel.get('axisTick.inside')) {
    layout.tickDirection = -layout.tickDirection;
  }

  if (zrUtil.retrieve(opt.labelInside, axisModel.get('axisLabel.inside'))) {
    layout.labelDirection = -layout.labelDirection;
  }

  var labelRotation = opt.rotate;
  labelRotation == null && (labelRotation = axisModel.get('axisLabel.rotate'));
  layout.labelRotation = axisPosition === 'top' ? -labelRotation : labelRotation;
  layout.z2 = 1;
  return layout;
}

exports.layout = layout;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var modelUtil = __webpack_require__(44);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @param {Object} finder contains {seriesIndex, dataIndex, dataIndexInside}
 * @param {module:echarts/model/Global} ecModel
 * @return {Object} {point: [x, y], el: ...} point Will not be null.
 */
function _default(finder, ecModel) {
  var point = [];
  var seriesIndex = finder.seriesIndex;
  var seriesModel;

  if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) {
    return {
      point: []
    };
  }

  var data = seriesModel.getData();
  var dataIndex = modelUtil.queryDataIndex(data, finder);

  if (dataIndex == null || dataIndex < 0 || zrUtil.isArray(dataIndex)) {
    return {
      point: []
    };
  }

  var el = data.getItemGraphicEl(dataIndex);
  var coordSys = seriesModel.coordinateSystem;

  if (seriesModel.getTooltipPosition) {
    point = seriesModel.getTooltipPosition(dataIndex) || [];
  } else if (coordSys && coordSys.dataToPoint) {
    point = coordSys.dataToPoint(data.getValues(zrUtil.map(coordSys.dimensions, function (dim) {
      return data.mapDimension(dim);
    }), dataIndex, true)) || [];
  } else if (el) {
    // Use graphic bounding rect
    var rect = el.getBoundingRect().clone();
    rect.applyTransform(el.transform);
    point = [rect.x + rect.width / 2, rect.y + rect.height / 2];
  }

  return {
    point: point,
    el: el
  };
}

module.exports = _default;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var env = __webpack_require__(67);

var _model = __webpack_require__(44);

var makeInner = _model.makeInner;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var inner = makeInner();
var each = zrUtil.each;
/**
 * @param {string} key
 * @param {module:echarts/ExtensionAPI} api
 * @param {Function} handler
 *      param: {string} currTrigger
 *      param: {Array.<number>} point
 */

function register(key, api, handler) {
  if (env.node) {
    return;
  }

  var zr = api.getZr();
  inner(zr).records || (inner(zr).records = {});
  initGlobalListeners(zr, api);
  var record = inner(zr).records[key] || (inner(zr).records[key] = {});
  record.handler = handler;
}

function initGlobalListeners(zr, api) {
  if (inner(zr).initialized) {
    return;
  }

  inner(zr).initialized = true;
  useHandler('click', zrUtil.curry(doEnter, 'click'));
  useHandler('mousemove', zrUtil.curry(doEnter, 'mousemove')); // useHandler('mouseout', onLeave);

  useHandler('globalout', onLeave);

  function useHandler(eventType, cb) {
    zr.on(eventType, function (e) {
      var dis = makeDispatchAction(api);
      each(inner(zr).records, function (record) {
        record && cb(record, e, dis.dispatchAction);
      });
      dispatchTooltipFinally(dis.pendings, api);
    });
  }
}

function dispatchTooltipFinally(pendings, api) {
  var showLen = pendings.showTip.length;
  var hideLen = pendings.hideTip.length;
  var actuallyPayload;

  if (showLen) {
    actuallyPayload = pendings.showTip[showLen - 1];
  } else if (hideLen) {
    actuallyPayload = pendings.hideTip[hideLen - 1];
  }

  if (actuallyPayload) {
    actuallyPayload.dispatchAction = null;
    api.dispatchAction(actuallyPayload);
  }
}

function onLeave(record, e, dispatchAction) {
  record.handler('leave', null, dispatchAction);
}

function doEnter(currTrigger, record, e, dispatchAction) {
  record.handler(currTrigger, e, dispatchAction);
}

function makeDispatchAction(api) {
  var pendings = {
    showTip: [],
    hideTip: []
  }; // FIXME
  // better approach?
  // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
  // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
  // So we have to add "final stage" to merge those dispatched actions.

  var dispatchAction = function (payload) {
    var pendingList = pendings[payload.type];

    if (pendingList) {
      pendingList.push(payload);
    } else {
      payload.dispatchAction = dispatchAction;
      api.dispatchAction(payload);
    }
  };

  return {
    dispatchAction: dispatchAction,
    pendings: pendings
  };
}
/**
 * @param {string} key
 * @param {module:echarts/ExtensionAPI} api
 */


function unregister(key, api) {
  if (env.node) {
    return;
  }

  var zr = api.getZr();
  var record = (inner(zr).records || {})[key];

  if (record) {
    inner(zr).records[key] = null;
  }
}

exports.register = register;
exports.unregister = unregister;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var BaseAxisPointer = __webpack_require__(426);

var viewHelper = __webpack_require__(308);

var cartesianAxisHelper = __webpack_require__(652);

var AxisView = __webpack_require__(179);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var CartesianAxisPointer = BaseAxisPointer.extend({
  /**
   * @override
   */
  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
    var axis = axisModel.axis;
    var grid = axis.grid;
    var axisPointerType = axisPointerModel.get('type');
    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
    var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));

    if (axisPointerType && axisPointerType !== 'none') {
      var elStyle = viewHelper.buildElStyle(axisPointerModel);
      var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
      pointerOption.style = elStyle;
      elOption.graphicKey = pointerOption.type;
      elOption.pointer = pointerOption;
    }

    var layoutInfo = cartesianAxisHelper.layout(grid.model, axisModel);
    viewHelper.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
  },

  /**
   * @override
   */
  getHandleTransform: function (value, axisModel, axisPointerModel) {
    var layoutInfo = cartesianAxisHelper.layout(axisModel.axis.grid.model, axisModel, {
      labelInside: false
    });
    layoutInfo.labelMargin = axisPointerModel.get('handle.margin');
    return {
      position: viewHelper.getTransformedPosition(axisModel.axis, value, layoutInfo),
      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
    };
  },

  /**
   * @override
   */
  updateHandleTransform: function (transform, delta, axisModel, axisPointerModel) {
    var axis = axisModel.axis;
    var grid = axis.grid;
    var axisExtent = axis.getGlobalExtent(true);
    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
    var dimIndex = axis.dim === 'x' ? 0 : 1;
    var currPosition = transform.position;
    currPosition[dimIndex] += delta[dimIndex];
    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
    var cursorPoint = [cursorOtherValue, cursorOtherValue];
    cursorPoint[dimIndex] = currPosition[dimIndex]; // Make tooltip do not overlap axisPointer and in the middle of the grid.

    var tooltipOptions = [{
      verticalAlign: 'middle'
    }, {
      align: 'center'
    }];
    return {
      position: currPosition,
      rotation: transform.rotation,
      cursorPoint: cursorPoint,
      tooltipOption: tooltipOptions[dimIndex]
    };
  }
});

function getCartesian(grid, axis) {
  var opt = {};
  opt[axis.dim + 'AxisIndex'] = axis.index;
  return grid.getCartesian(opt);
}

var pointerShapeBuilder = {
  line: function (axis, pixelValue, otherExtent) {
    var targetShape = viewHelper.makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getAxisDimIndex(axis));
    return {
      type: 'Line',
      subPixelOptimize: true,
      shape: targetShape
    };
  },
  shadow: function (axis, pixelValue, otherExtent) {
    var bandWidth = Math.max(1, axis.getBandWidth());
    var span = otherExtent[1] - otherExtent[0];
    return {
      type: 'Rect',
      shape: viewHelper.makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getAxisDimIndex(axis))
    };
  }
};

function getAxisDimIndex(axis) {
  return axis.dim === 'x' ? 0 : 1;
}

AxisView.registerAxisPointerClass('CartesianAxisPointer', CartesianAxisPointer);
var _default = CartesianAxisPointer;
module.exports = _default;

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _layout = __webpack_require__(53);

var getLayoutRect = _layout.getLayoutRect;
var layoutBox = _layout.box;
var positionElement = _layout.positionElement;

var formatUtil = __webpack_require__(54);

var graphic = __webpack_require__(27);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Layout list like component.
 * It will box layout each items in group of component and then position the whole group in the viewport
 * @param {module:zrender/group/Group} group
 * @param {module:echarts/model/Component} componentModel
 * @param {module:echarts/ExtensionAPI}
 */
function layout(group, componentModel, api) {
  var boxLayoutParams = componentModel.getBoxLayoutParams();
  var padding = componentModel.get('padding');
  var viewportSize = {
    width: api.getWidth(),
    height: api.getHeight()
  };
  var rect = getLayoutRect(boxLayoutParams, viewportSize, padding);
  layoutBox(componentModel.get('orient'), group, componentModel.get('itemGap'), rect.width, rect.height);
  positionElement(group, boxLayoutParams, viewportSize, padding);
}

function makeBackground(rect, componentModel) {
  var padding = formatUtil.normalizeCssArray(componentModel.get('padding'));
  var style = componentModel.getItemStyle(['color', 'opacity']);
  style.fill = componentModel.get('backgroundColor');
  var rect = new graphic.Rect({
    shape: {
      x: rect.x - padding[3],
      y: rect.y - padding[0],
      width: rect.width + padding[1] + padding[3],
      height: rect.height + padding[0] + padding[2],
      r: componentModel.get('borderRadius')
    },
    style: style,
    silent: true,
    z2: -1
  }); // FIXME
  // `subPixelOptimizeRect` may bring some gap between edge of viewpart
  // and background rect when setting like `left: 0`, `top: 0`.
  // graphic.subPixelOptimizeRect(rect);

  return rect;
}

exports.layout = layout;
exports.makeBackground = makeBackground;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(1);

var graphic = __webpack_require__(27);

var modelUtil = __webpack_require__(44);

var brushHelper = __webpack_require__(668);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var each = zrUtil.each;
var indexOf = zrUtil.indexOf;
var curry = zrUtil.curry;
var COORD_CONVERTS = ['dataToPoint', 'pointToData']; // FIXME
// how to genarialize to more coordinate systems.

var INCLUDE_FINDER_MAIN_TYPES = ['grid', 'xAxis', 'yAxis', 'geo', 'graph', 'polar', 'radiusAxis', 'angleAxis', 'bmap'];
/**
 * [option in constructor]:
 * {
 *     Index/Id/Name of geo, xAxis, yAxis, grid: See util/model#parseFinder.
 * }
 *
 *
 * [targetInfo]:
 *
 * There can be multiple axes in a single targetInfo. Consider the case
 * of `grid` component, a targetInfo represents a grid which contains one or more
 * cartesian and one or more axes. And consider the case of parallel system,
 * which has multiple axes in a coordinate system.
 * Can be {
 *     panelId: ...,
 *     coordSys: <a representitive cartesian in grid (first cartesian by default)>,
 *     coordSyses: all cartesians.
 *     gridModel: <grid component>
 *     xAxes: correspond to coordSyses on index
 *     yAxes: correspond to coordSyses on index
 * }
 * or {
 *     panelId: ...,
 *     coordSys: <geo coord sys>
 *     coordSyses: [<geo coord sys>]
 *     geoModel: <geo component>
 * }
 *
 *
 * [panelOpt]:
 *
 * Make from targetInfo. Input to BrushController.
 * {
 *     panelId: ...,
 *     rect: ...
 * }
 *
 *
 * [area]:
 *
 * Generated by BrushController or user input.
 * {
 *     panelId: Used to locate coordInfo directly. If user inpput, no panelId.
 *     brushType: determine how to convert to/from coord('rect' or 'polygon' or 'lineX/Y').
 *     Index/Id/Name of geo, xAxis, yAxis, grid: See util/model#parseFinder.
 *     range: pixel range.
 *     coordRange: representitive coord range (the first one of coordRanges).
 *     coordRanges: <Array> coord ranges, used in multiple cartesian in one grid.
 * }
 */

/**
 * @param {Object} option contains Index/Id/Name of xAxis/yAxis/geo/grid
 *        Each can be {number|Array.<number>}. like: {xAxisIndex: [3, 4]}
 * @param {module:echarts/model/Global} ecModel
 * @param {Object} [opt]
 * @param {Array.<string>} [opt.include] include coordinate system types.
 */

function BrushTargetManager(option, ecModel, opt) {
  /**
   * @private
   * @type {Array.<Object>}
   */
  var targetInfoList = this._targetInfoList = [];
  var info = {};
  var foundCpts = parseFinder(ecModel, option);
  each(targetInfoBuilders, function (builder, type) {
    if (!opt || !opt.include || indexOf(opt.include, type) >= 0) {
      builder(foundCpts, targetInfoList, info);
    }
  });
}

var proto = BrushTargetManager.prototype;

proto.setOutputRanges = function (areas, ecModel) {
  this.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
    (area.coordRanges || (area.coordRanges = [])).push(coordRange); // area.coordRange is the first of area.coordRanges

    if (!area.coordRange) {
      area.coordRange = coordRange; // In 'category' axis, coord to pixel is not reversible, so we can not
      // rebuild range by coordRange accrately, which may bring trouble when
      // brushing only one item. So we use __rangeOffset to rebuilding range
      // by coordRange. And this it only used in brush component so it is no
      // need to be adapted to coordRanges.

      var result = coordConvert[area.brushType](0, coordSys, coordRange);
      area.__rangeOffset = {
        offset: diffProcessor[area.brushType](result.values, area.range, [1, 1]),
        xyMinMax: result.xyMinMax
      };
    }
  });
};

proto.matchOutputRanges = function (areas, ecModel, cb) {
  each(areas, function (area) {
    var targetInfo = this.findTargetInfo(area, ecModel);

    if (targetInfo && targetInfo !== true) {
      zrUtil.each(targetInfo.coordSyses, function (coordSys) {
        var result = coordConvert[area.brushType](1, coordSys, area.range);
        cb(area, result.values, coordSys, ecModel);
      });
    }
  }, this);
};

proto.setInputRanges = function (areas, ecModel) {
  each(areas, function (area) {
    var targetInfo = this.findTargetInfo(area, ecModel);
    area.range = area.range || []; // convert coordRange to global range and set panelId.

    if (targetInfo && targetInfo !== true) {
      area.panelId = targetInfo.panelId; // (1) area.range shoule always be calculate from coordRange but does
      // not keep its original value, for the sake of the dataZoom scenario,
      // where area.coordRange remains unchanged but area.range may be changed.
      // (2) Only support converting one coordRange to pixel range in brush
      // component. So do not consider `coordRanges`.
      // (3) About __rangeOffset, see comment above.

      var result = coordConvert[area.brushType](0, targetInfo.coordSys, area.coordRange);
      var rangeOffset = area.__rangeOffset;
      area.range = rangeOffset ? diffProcessor[area.brushType](result.values, rangeOffset.offset, getScales(result.xyMinMax, rangeOffset.xyMinMax)) : result.values;
    }
  }, this);
};

proto.makePanelOpts = function (api, getDefaultBrushType) {
  return zrUtil.map(this._targetInfoList, function (targetInfo) {
    var rect = targetInfo.getPanelRect();
    return {
      panelId: targetInfo.panelId,
      defaultBrushType: getDefaultBrushType && getDefaultBrushType(targetInfo),
      clipPath: brushHelper.makeRectPanelClipPath(rect),
      isTargetByCursor: brushHelper.makeRectIsTargetByCursor(rect, api, targetInfo.coordSysModel),
      getLinearBrushOtherExtent: brushHelper.makeLinearBrushOtherExtent(rect)
    };
  });
};

proto.controlSeries = function (area, seriesModel, ecModel) {
  // Check whether area is bound in coord, and series do not belong to that coord.
  // If do not do this check, some brush (like lineX) will controll all axes.
  var targetInfo = this.findTargetInfo(area, ecModel);
  return targetInfo === true || targetInfo && indexOf(targetInfo.coordSyses, seriesModel.coordinateSystem) >= 0;
};
/**
 * If return Object, a coord found.
 * If reutrn true, global found.
 * Otherwise nothing found.
 *
 * @param {Object} area
 * @param {Array} targetInfoList
 * @return {Object|boolean}
 */


proto.findTargetInfo = function (area, ecModel) {
  var targetInfoList = this._targetInfoList;
  var foundCpts = parseFinder(ecModel, area);

  for (var i = 0; i < targetInfoList.length; i++) {
    var targetInfo = targetInfoList[i];
    var areaPanelId = area.panelId;

    if (areaPanelId) {
      if (targetInfo.panelId === areaPanelId) {
        return targetInfo;
      }
    } else {
      for (var i = 0; i < targetInfoMatchers.length; i++) {
        if (targetInfoMatchers[i](foundCpts, targetInfo)) {
          return targetInfo;
        }
      }
    }
  }

  return true;
};

function formatMinMax(minMax) {
  minMax[0] > minMax[1] && minMax.reverse();
  return minMax;
}

function parseFinder(ecModel, option) {
  return modelUtil.parseFinder(ecModel, option, {
    includeMainTypes: INCLUDE_FINDER_MAIN_TYPES
  });
}

var targetInfoBuilders = {
  grid: function (foundCpts, targetInfoList) {
    var xAxisModels = foundCpts.xAxisModels;
    var yAxisModels = foundCpts.yAxisModels;
    var gridModels = foundCpts.gridModels; // Remove duplicated.

    var gridModelMap = zrUtil.createHashMap();
    var xAxesHas = {};
    var yAxesHas = {};

    if (!xAxisModels && !yAxisModels && !gridModels) {
      return;
    }

    each(xAxisModels, function (axisModel) {
      var gridModel = axisModel.axis.grid.model;
      gridModelMap.set(gridModel.id, gridModel);
      xAxesHas[gridModel.id] = true;
    });
    each(yAxisModels, function (axisModel) {
      var gridModel = axisModel.axis.grid.model;
      gridModelMap.set(gridModel.id, gridModel);
      yAxesHas[gridModel.id] = true;
    });
    each(gridModels, function (gridModel) {
      gridModelMap.set(gridModel.id, gridModel);
      xAxesHas[gridModel.id] = true;
      yAxesHas[gridModel.id] = true;
    });
    gridModelMap.each(function (gridModel) {
      var grid = gridModel.coordinateSystem;
      var cartesians = [];
      each(grid.getCartesians(), function (cartesian, index) {
        if (indexOf(xAxisModels, cartesian.getAxis('x').model) >= 0 || indexOf(yAxisModels, cartesian.getAxis('y').model) >= 0) {
          cartesians.push(cartesian);
        }
      });
      targetInfoList.push({
        panelId: 'grid--' + gridModel.id,
        gridModel: gridModel,
        coordSysModel: gridModel,
        // Use the first one as the representitive coordSys.
        coordSys: cartesians[0],
        coordSyses: cartesians,
        getPanelRect: panelRectBuilder.grid,
        xAxisDeclared: xAxesHas[gridModel.id],
        yAxisDeclared: yAxesHas[gridModel.id]
      });
    });
  },
  geo: function (foundCpts, targetInfoList) {
    each(foundCpts.geoModels, function (geoModel) {
      var coordSys = geoModel.coordinateSystem;
      targetInfoList.push({
        panelId: 'geo--' + geoModel.id,
        geoModel: geoModel,
        coordSysModel: geoModel,
        coordSys: coordSys,
        coordSyses: [coordSys],
        getPanelRect: panelRectBuilder.geo
      });
    });
  }
};
var targetInfoMatchers = [// grid
function (foundCpts, targetInfo) {
  var xAxisModel = foundCpts.xAxisModel;
  var yAxisModel = foundCpts.yAxisModel;
  var gridModel = foundCpts.gridModel;
  !gridModel && xAxisModel && (gridModel = xAxisModel.axis.grid.model);
  !gridModel && yAxisModel && (gridModel = yAxisModel.axis.grid.model);
  return gridModel && gridModel === targetInfo.gridModel;
}, // geo
function (foundCpts, targetInfo) {
  var geoModel = foundCpts.geoModel;
  return geoModel && geoModel === targetInfo.geoModel;
}];
var panelRectBuilder = {
  grid: function () {
    // grid is not Transformable.
    return this.coordSys.grid.getRect().clone();
  },
  geo: function () {
    var coordSys = this.coordSys;
    var rect = coordSys.getBoundingRect().clone(); // geo roam and zoom transform

    rect.applyTransform(graphic.getTransform(coordSys));
    return rect;
  }
};
var coordConvert = {
  lineX: curry(axisConvert, 0),
  lineY: curry(axisConvert, 1),
  rect: function (to, coordSys, rangeOrCoordRange) {
    var xminymin = coordSys[COORD_CONVERTS[to]]([rangeOrCoordRange[0][0], rangeOrCoordRange[1][0]]);
    var xmaxymax = coordSys[COORD_CONVERTS[to]]([rangeOrCoordRange[0][1], rangeOrCoordRange[1][1]]);
    var values = [formatMinMax([xminymin[0], xmaxymax[0]]), formatMinMax([xminymin[1], xmaxymax[1]])];
    return {
      values: values,
      xyMinMax: values
    };
  },
  polygon: function (to, coordSys, rangeOrCoordRange) {
    var xyMinMax = [[Infinity, -Infinity], [Infinity, -Infinity]];
    var values = zrUtil.map(rangeOrCoordRange, function (item) {
      var p = coordSys[COORD_CONVERTS[to]](item);
      xyMinMax[0][0] = Math.min(xyMinMax[0][0], p[0]);
      xyMinMax[1][0] = Math.min(xyMinMax[1][0], p[1]);
      xyMinMax[0][1] = Math.max(xyMinMax[0][1], p[0]);
      xyMinMax[1][1] = Math.max(xyMinMax[1][1], p[1]);
      return p;
    });
    return {
      values: values,
      xyMinMax: xyMinMax
    };
  }
};

function axisConvert(axisNameIndex, to, coordSys, rangeOrCoordRange) {
  var axis = coordSys.getAxis(['x', 'y'][axisNameIndex]);
  var values = formatMinMax(zrUtil.map([0, 1], function (i) {
    return to ? axis.coordToData(axis.toLocalCoord(rangeOrCoordRange[i])) : axis.toGlobalCoord(axis.dataToCoord(rangeOrCoordRange[i]));
  }));
  var xyMinMax = [];
  xyMinMax[axisNameIndex] = values;
  xyMinMax[1 - axisNameIndex] = [NaN, NaN];
  return {
    values: values,
    xyMinMax: xyMinMax
  };
}

var diffProcessor = {
  lineX: curry(axisDiffProcessor, 0),
  lineY: curry(axisDiffProcessor, 1),
  rect: function (values, refer, scales) {
    return [[values[0][0] - scales[0] * refer[0][0], values[0][1] - scales[0] * refer[0][1]], [values[1][0] - scales[1] * refer[1][0], values[1][1] - scales[1] * refer[1][1]]];
  },
  polygon: function (values, refer, scales) {
    return zrUtil.map(values, function (item, idx) {
      return [item[0] - scales[0] * refer[idx][0], item[1] - scales[1] * refer[idx][1]];
    });
  }
};

function axisDiffProcessor(axisNameIndex, values, refer, scales) {
  return [values[0] - scales[axisNameIndex] * refer[0], values[1] - scales[axisNameIndex] * refer[1]];
} // We have to process scale caused by dataZoom manually,
// although it might be not accurate.


function getScales(xyMinMaxCurr, xyMinMaxOrigin) {
  var sizeCurr = getSize(xyMinMaxCurr);
  var sizeOrigin = getSize(xyMinMaxOrigin);
  var scales = [sizeCurr[0] / sizeOrigin[0], sizeCurr[1] / sizeOrigin[1]];
  isNaN(scales[0]) && (scales[0] = 1);
  isNaN(scales[1]) && (scales[1] = 1);
  return scales;
}

function getSize(xyMinMax) {
  return xyMinMax ? [xyMinMax[0][1] - xyMinMax[0][0], xyMinMax[1][1] - xyMinMax[1][0]] : [NaN, NaN];
}

var _default = BrushTargetManager;
module.exports = _default;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var each = zrUtil.each;
var ATTR = '\0_ec_hist_store';
/**
 * @param {module:echarts/model/Global} ecModel
 * @param {Object} newSnapshot {dataZoomId, batch: [payloadInfo, ...]}
 */

function push(ecModel, newSnapshot) {
  var store = giveStore(ecModel); // If previous dataZoom can not be found,
  // complete an range with current range.

  each(newSnapshot, function (batchItem, dataZoomId) {
    var i = store.length - 1;

    for (; i >= 0; i--) {
      var snapshot = store[i];

      if (snapshot[dataZoomId]) {
        break;
      }
    }

    if (i < 0) {
      // No origin range set, create one by current range.
      var dataZoomModel = ecModel.queryComponents({
        mainType: 'dataZoom',
        subType: 'select',
        id: dataZoomId
      })[0];

      if (dataZoomModel) {
        var percentRange = dataZoomModel.getPercentRange();
        store[0][dataZoomId] = {
          dataZoomId: dataZoomId,
          start: percentRange[0],
          end: percentRange[1]
        };
      }
    }
  });
  store.push(newSnapshot);
}
/**
 * @param {module:echarts/model/Global} ecModel
 * @return {Object} snapshot
 */


function pop(ecModel) {
  var store = giveStore(ecModel);
  var head = store[store.length - 1];
  store.length > 1 && store.pop(); // Find top for all dataZoom.

  var snapshot = {};
  each(head, function (batchItem, dataZoomId) {
    for (var i = store.length - 1; i >= 0; i--) {
      var batchItem = store[i][dataZoomId];

      if (batchItem) {
        snapshot[dataZoomId] = batchItem;
        break;
      }
    }
  });
  return snapshot;
}
/**
 * @param {module:echarts/model/Global} ecModel
 */


function clear(ecModel) {
  ecModel[ATTR] = null;
}
/**
 * @param {module:echarts/model/Global} ecModel
 * @return {number} records. always >= 1.
 */


function count(ecModel) {
  return giveStore(ecModel).length;
}
/**
 * [{key: dataZoomId, value: {dataZoomId, range}}, ...]
 * History length of each dataZoom may be different.
 * this._history[0] is used to store origin range.
 * @type {Array.<Object>}
 */


function giveStore(ecModel) {
  var store = ecModel[ATTR];

  if (!store) {
    store = ecModel[ATTR] = [{}];
  }

  return store;
}

exports.push = push;
exports.pop = pop;
exports.clear = clear;
exports.count = count;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var BoundingRect = __webpack_require__(57);

var visualSolution = __webpack_require__(309);

var selector = __webpack_require__(1770);

var throttleUtil = __webpack_require__(148);

var BrushTargetManager = __webpack_require__(679);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var STATE_LIST = ['inBrush', 'outOfBrush'];
var DISPATCH_METHOD = '__ecBrushSelect';
var DISPATCH_FLAG = '__ecInBrushSelectEvent';
var PRIORITY_BRUSH = echarts.PRIORITY.VISUAL.BRUSH;
/**
 * Layout for visual, the priority higher than other layout, and before brush visual.
 */

echarts.registerLayout(PRIORITY_BRUSH, function (ecModel, api, payload) {
  ecModel.eachComponent({
    mainType: 'brush'
  }, function (brushModel) {
    payload && payload.type === 'takeGlobalCursor' && brushModel.setBrushOption(payload.key === 'brush' ? payload.brushOption : {
      brushType: false
    });
  });
  layoutCovers(ecModel);
});

function layoutCovers(ecModel) {
  ecModel.eachComponent({
    mainType: 'brush'
  }, function (brushModel) {
    var brushTargetManager = brushModel.brushTargetManager = new BrushTargetManager(brushModel.option, ecModel);
    brushTargetManager.setInputRanges(brushModel.areas, ecModel);
  });
}
/**
 * Register the visual encoding if this modules required.
 */


echarts.registerVisual(PRIORITY_BRUSH, function (ecModel, api, payload) {
  var brushSelected = [];
  var throttleType;
  var throttleDelay;
  ecModel.eachComponent({
    mainType: 'brush'
  }, function (brushModel, brushIndex) {
    var thisBrushSelected = {
      brushId: brushModel.id,
      brushIndex: brushIndex,
      brushName: brushModel.name,
      areas: zrUtil.clone(brushModel.areas),
      selected: []
    }; // Every brush component exists in event params, convenient
    // for user to find by index.

    brushSelected.push(thisBrushSelected);
    var brushOption = brushModel.option;
    var brushLink = brushOption.brushLink;
    var linkedSeriesMap = [];
    var selectedDataIndexForLink = [];
    var rangeInfoBySeries = [];
    var hasBrushExists = 0;

    if (!brushIndex) {
      // Only the first throttle setting works.
      throttleType = brushOption.throttleType;
      throttleDelay = brushOption.throttleDelay;
    } // Add boundingRect and selectors to range.


    var areas = zrUtil.map(brushModel.areas, function (area) {
      return bindSelector(zrUtil.defaults({
        boundingRect: boundingRectBuilders[area.brushType](area)
      }, area));
    });
    var visualMappings = visualSolution.createVisualMappings(brushModel.option, STATE_LIST, function (mappingOption) {
      mappingOption.mappingMethod = 'fixed';
    });
    zrUtil.isArray(brushLink) && zrUtil.each(brushLink, function (seriesIndex) {
      linkedSeriesMap[seriesIndex] = 1;
    });

    function linkOthers(seriesIndex) {
      return brushLink === 'all' || linkedSeriesMap[seriesIndex];
    } // If no supported brush or no brush on the series,
    // all visuals should be in original state.


    function brushed(rangeInfoList) {
      return !!rangeInfoList.length;
    }
    /**
     * Logic for each series: (If the logic has to be modified one day, do it carefully!)
     *
     * ( brushed ┬ && ┬hasBrushExist ┬ && linkOthers  ) => StepA: ┬record, ┬ StepB: ┬visualByRecord.
     *   !brushed┘    ├hasBrushExist ┤                            └nothing,┘        ├visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( !brushed  && ┬hasBrushExist ┬ && linkOthers  ) => StepA:  nothing,  StepB: ┬visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( brushed ┬ &&                     !linkOthers ) => StepA:  nothing,  StepB: ┬visualByCheck.
     *   !brushed┘                                                                  └nothing.
     * ( !brushed  &&                     !linkOthers ) => StepA:  nothing,  StepB:  nothing.
     */
    // Step A


    ecModel.eachSeries(function (seriesModel, seriesIndex) {
      var rangeInfoList = rangeInfoBySeries[seriesIndex] = [];
      seriesModel.subType === 'parallel' ? stepAParallel(seriesModel, seriesIndex, rangeInfoList) : stepAOthers(seriesModel, seriesIndex, rangeInfoList);
    });

    function stepAParallel(seriesModel, seriesIndex) {
      var coordSys = seriesModel.coordinateSystem;
      hasBrushExists |= coordSys.hasAxisBrushed();
      linkOthers(seriesIndex) && coordSys.eachActiveState(seriesModel.getData(), function (activeState, dataIndex) {
        activeState === 'active' && (selectedDataIndexForLink[dataIndex] = 1);
      });
    }

    function stepAOthers(seriesModel, seriesIndex, rangeInfoList) {
      var selectorsByBrushType = getSelectorsByBrushType(seriesModel);

      if (!selectorsByBrushType || brushModelNotControll(brushModel, seriesIndex)) {
        return;
      }

      zrUtil.each(areas, function (area) {
        selectorsByBrushType[area.brushType] && brushModel.brushTargetManager.controlSeries(area, seriesModel, ecModel) && rangeInfoList.push(area);
        hasBrushExists |= brushed(rangeInfoList);
      });

      if (linkOthers(seriesIndex) && brushed(rangeInfoList)) {
        var data = seriesModel.getData();
        data.each(function (dataIndex) {
          if (checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex)) {
            selectedDataIndexForLink[dataIndex] = 1;
          }
        });
      }
    } // Step B


    ecModel.eachSeries(function (seriesModel, seriesIndex) {
      var seriesBrushSelected = {
        seriesId: seriesModel.id,
        seriesIndex: seriesIndex,
        seriesName: seriesModel.name,
        dataIndex: []
      }; // Every series exists in event params, convenient
      // for user to find series by seriesIndex.

      thisBrushSelected.selected.push(seriesBrushSelected);
      var selectorsByBrushType = getSelectorsByBrushType(seriesModel);
      var rangeInfoList = rangeInfoBySeries[seriesIndex];
      var data = seriesModel.getData();
      var getValueState = linkOthers(seriesIndex) ? function (dataIndex) {
        return selectedDataIndexForLink[dataIndex] ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
      } : function (dataIndex) {
        return checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex) ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
      }; // If no supported brush or no brush, all visuals are in original state.

      (linkOthers(seriesIndex) ? hasBrushExists : brushed(rangeInfoList)) && visualSolution.applyVisual(STATE_LIST, visualMappings, data, getValueState);
    });
  });
  dispatchAction(api, throttleType, throttleDelay, brushSelected, payload);
});

function dispatchAction(api, throttleType, throttleDelay, brushSelected, payload) {
  // This event will not be triggered when `setOpion`, otherwise dead lock may
  // triggered when do `setOption` in event listener, which we do not find
  // satisfactory way to solve yet. Some considered resolutions:
  // (a) Diff with prevoius selected data ant only trigger event when changed.
  // But store previous data and diff precisely (i.e., not only by dataIndex, but
  // also detect value changes in selected data) might bring complexity or fragility.
  // (b) Use spectial param like `silent` to suppress event triggering.
  // But such kind of volatile param may be weird in `setOption`.
  if (!payload) {
    return;
  }

  var zr = api.getZr();

  if (zr[DISPATCH_FLAG]) {
    return;
  }

  if (!zr[DISPATCH_METHOD]) {
    zr[DISPATCH_METHOD] = doDispatch;
  }

  var fn = throttleUtil.createOrUpdate(zr, DISPATCH_METHOD, throttleDelay, throttleType);
  fn(api, brushSelected);
}

function doDispatch(api, brushSelected) {
  if (!api.isDisposed()) {
    var zr = api.getZr();
    zr[DISPATCH_FLAG] = true;
    api.dispatchAction({
      type: 'brushSelect',
      batch: brushSelected
    });
    zr[DISPATCH_FLAG] = false;
  }
}

function checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex) {
  for (var i = 0, len = rangeInfoList.length; i < len; i++) {
    var area = rangeInfoList[i];

    if (selectorsByBrushType[area.brushType](dataIndex, data, area.selectors, area)) {
      return true;
    }
  }
}

function getSelectorsByBrushType(seriesModel) {
  var brushSelector = seriesModel.brushSelector;

  if (zrUtil.isString(brushSelector)) {
    var sels = [];
    zrUtil.each(selector, function (selectorsByElementType, brushType) {
      sels[brushType] = function (dataIndex, data, selectors, area) {
        var itemLayout = data.getItemLayout(dataIndex);
        return selectorsByElementType[brushSelector](itemLayout, selectors, area);
      };
    });
    return sels;
  } else if (zrUtil.isFunction(brushSelector)) {
    var bSelector = {};
    zrUtil.each(selector, function (sel, brushType) {
      bSelector[brushType] = brushSelector;
    });
    return bSelector;
  }

  return brushSelector;
}

function brushModelNotControll(brushModel, seriesIndex) {
  var seriesIndices = brushModel.option.seriesIndex;
  return seriesIndices != null && seriesIndices !== 'all' && (zrUtil.isArray(seriesIndices) ? zrUtil.indexOf(seriesIndices, seriesIndex) < 0 : seriesIndex !== seriesIndices);
}

function bindSelector(area) {
  var selectors = area.selectors = {};
  zrUtil.each(selector[area.brushType], function (selFn, elType) {
    // Do not use function binding or curry for performance.
    selectors[elType] = function (itemLayout) {
      return selFn(itemLayout, selectors, area);
    };
  });
  return area;
}

var boundingRectBuilders = {
  lineX: zrUtil.noop,
  lineY: zrUtil.noop,
  rect: function (area) {
    return getBoundingRectFromMinMax(area.range);
  },
  polygon: function (area) {
    var minMax;
    var range = area.range;

    for (var i = 0, len = range.length; i < len; i++) {
      minMax = minMax || [[Infinity, -Infinity], [Infinity, -Infinity]];
      var rg = range[i];
      rg[0] < minMax[0][0] && (minMax[0][0] = rg[0]);
      rg[0] > minMax[0][1] && (minMax[0][1] = rg[0]);
      rg[1] < minMax[1][0] && (minMax[1][0] = rg[1]);
      rg[1] > minMax[1][1] && (minMax[1][1] = rg[1]);
    }

    return minMax && getBoundingRectFromMinMax(minMax);
  }
};

function getBoundingRectFromMinMax(minMax) {
  return new BoundingRect(minMax[0][0], minMax[1][0], minMax[0][1] - minMax[0][0], minMax[1][1] - minMax[1][0]);
}

exports.layoutCovers = layoutCovers;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(683);

__webpack_require__(1795);

__webpack_require__(684);

var legendFilter = __webpack_require__(1796);

var Component = __webpack_require__(73);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Do not contain scrollable legend, for sake of file size.
// Series Filter
echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.SERIES_FILTER, legendFilter);
Component.registerSubTypeDefaulter('legend', function () {
  // Default 'plain' when no type specified.
  return 'plain';
});

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var Model = __webpack_require__(68);

var _model = __webpack_require__(44);

var isNameSpecified = _model.isNameSpecified;

var lang = __webpack_require__(149);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var langSelector = lang.legend.selector;
var defaultSelectorOption = {
  all: {
    type: 'all',
    title: zrUtil.clone(langSelector.all)
  },
  inverse: {
    type: 'inverse',
    title: zrUtil.clone(langSelector.inverse)
  }
};
var LegendModel = echarts.extendComponentModel({
  type: 'legend.plain',
  dependencies: ['series'],
  layoutMode: {
    type: 'box',
    // legend.width/height are maxWidth/maxHeight actually,
    // whereas realy width/height is calculated by its content.
    // (Setting {left: 10, right: 10} does not make sense).
    // So consider the case:
    // `setOption({legend: {left: 10});`
    // then `setOption({legend: {right: 10});`
    // The previous `left` should be cleared by setting `ignoreSize`.
    ignoreSize: true
  },
  init: function (option, parentModel, ecModel) {
    this.mergeDefaultAndTheme(option, ecModel);
    option.selected = option.selected || {};

    this._updateSelector(option);
  },
  mergeOption: function (option) {
    LegendModel.superCall(this, 'mergeOption', option);

    this._updateSelector(option);
  },
  _updateSelector: function (option) {
    var selector = option.selector;

    if (selector === true) {
      selector = option.selector = ['all', 'inverse'];
    }

    if (zrUtil.isArray(selector)) {
      zrUtil.each(selector, function (item, index) {
        zrUtil.isString(item) && (item = {
          type: item
        });
        selector[index] = zrUtil.merge(item, defaultSelectorOption[item.type]);
      });
    }
  },
  optionUpdated: function () {
    this._updateData(this.ecModel);

    var legendData = this._data; // If selectedMode is single, try to select one

    if (legendData[0] && this.get('selectedMode') === 'single') {
      var hasSelected = false; // If has any selected in option.selected

      for (var i = 0; i < legendData.length; i++) {
        var name = legendData[i].get('name');

        if (this.isSelected(name)) {
          // Force to unselect others
          this.select(name);
          hasSelected = true;
          break;
        }
      } // Try select the first if selectedMode is single


      !hasSelected && this.select(legendData[0].get('name'));
    }
  },
  _updateData: function (ecModel) {
    var potentialData = [];
    var availableNames = [];
    ecModel.eachRawSeries(function (seriesModel) {
      var seriesName = seriesModel.name;
      availableNames.push(seriesName);
      var isPotential;

      if (seriesModel.legendVisualProvider) {
        var provider = seriesModel.legendVisualProvider;
        var names = provider.getAllNames();

        if (!ecModel.isSeriesFiltered(seriesModel)) {
          availableNames = availableNames.concat(names);
        }

        if (names.length) {
          potentialData = potentialData.concat(names);
        } else {
          isPotential = true;
        }
      } else {
        isPotential = true;
      }

      if (isPotential && isNameSpecified(seriesModel)) {
        potentialData.push(seriesModel.name);
      }
    });
    /**
     * @type {Array.<string>}
     * @private
     */

    this._availableNames = availableNames; // If legend.data not specified in option, use availableNames as data,
    // which is convinient for user preparing option.

    var rawData = this.get('data') || potentialData;
    var legendData = zrUtil.map(rawData, function (dataItem) {
      // Can be string or number
      if (typeof dataItem === 'string' || typeof dataItem === 'number') {
        dataItem = {
          name: dataItem
        };
      }

      return new Model(dataItem, this, this.ecModel);
    }, this);
    /**
     * @type {Array.<module:echarts/model/Model>}
     * @private
     */

    this._data = legendData;
  },

  /**
   * @return {Array.<module:echarts/model/Model>}
   */
  getData: function () {
    return this._data;
  },

  /**
   * @param {string} name
   */
  select: function (name) {
    var selected = this.option.selected;
    var selectedMode = this.get('selectedMode');

    if (selectedMode === 'single') {
      var data = this._data;
      zrUtil.each(data, function (dataItem) {
        selected[dataItem.get('name')] = false;
      });
    }

    selected[name] = true;
  },

  /**
   * @param {string} name
   */
  unSelect: function (name) {
    if (this.get('selectedMode') !== 'single') {
      this.option.selected[name] = false;
    }
  },

  /**
   * @param {string} name
   */
  toggleSelected: function (name) {
    var selected = this.option.selected; // Default is true

    if (!selected.hasOwnProperty(name)) {
      selected[name] = true;
    }

    this[selected[name] ? 'unSelect' : 'select'](name);
  },
  allSelect: function () {
    var data = this._data;
    var selected = this.option.selected;
    zrUtil.each(data, function (dataItem) {
      selected[dataItem.get('name', true)] = true;
    });
  },
  inverseSelect: function () {
    var data = this._data;
    var selected = this.option.selected;
    zrUtil.each(data, function (dataItem) {
      var name = dataItem.get('name', true); // Initially, default value is true

      if (!selected.hasOwnProperty(name)) {
        selected[name] = true;
      }

      selected[name] = !selected[name];
    });
  },

  /**
   * @param {string} name
   */
  isSelected: function (name) {
    var selected = this.option.selected;
    return !(selected.hasOwnProperty(name) && !selected[name]) && zrUtil.indexOf(this._availableNames, name) >= 0;
  },
  getOrient: function () {
    return this.get('orient') === 'vertical' ? {
      index: 1,
      name: 'vertical'
    } : {
      index: 0,
      name: 'horizontal'
    };
  },
  defaultOption: {
    // 一级层叠
    zlevel: 0,
    // 二级层叠
    z: 4,
    show: true,
    // 布局方式，默认为水平布局，可选为：
    // 'horizontal' | 'vertical'
    orient: 'horizontal',
    left: 'center',
    // right: 'center',
    top: 0,
    // bottom: null,
    // 水平对齐
    // 'auto' | 'left' | 'right'
    // 默认为 'auto', 根据 x 的位置判断是左对齐还是右对齐
    align: 'auto',
    backgroundColor: 'rgba(0,0,0,0)',
    // 图例边框颜色
    borderColor: '#ccc',
    borderRadius: 0,
    // 图例边框线宽，单位px，默认为0（无边框）
    borderWidth: 0,
    // 图例内边距，单位px，默认各方向内边距为5，
    // 接受数组分别设定上右下左边距，同css
    padding: 5,
    // 各个item之间的间隔，单位px，默认为10，
    // 横向布局时为水平间隔，纵向布局时为纵向间隔
    itemGap: 10,
    // the width of legend symbol
    itemWidth: 25,
    // the height of legend symbol
    itemHeight: 14,
    // the color of unselected legend symbol
    inactiveColor: '#ccc',
    // the borderColor of unselected legend symbol
    inactiveBorderColor: '#ccc',
    itemStyle: {
      // the default borderWidth of legend symbol
      borderWidth: 0
    },
    textStyle: {
      // 图例文字颜色
      color: '#333'
    },
    // formatter: '',
    // 选择模式，默认开启图例开关
    selectedMode: true,
    // 配置默认选中状态，可配合LEGEND.SELECTED事件做动态数据载入
    // selected: null,
    // 图例内容（详见legend.data，数组中每一项代表一个item
    // data: [],
    // Usage:
    // selector: [{type: 'all or inverse', title: xxx}]
    // or
    // selector: true
    // or
    // selector: ['all', 'inverse']
    selector: false,
    selectorLabel: {
      show: true,
      borderRadius: 10,
      padding: [3, 5, 3, 5],
      fontSize: 12,
      fontFamily: ' sans-serif',
      color: '#666',
      borderWidth: 1,
      borderColor: '#666'
    },
    emphasis: {
      selectorLabel: {
        show: true,
        color: '#eee',
        backgroundColor: '#666'
      }
    },
    // Value can be 'start' or 'end'
    selectorPosition: 'auto',
    selectorItemGap: 7,
    selectorButtonGap: 10,
    // Tooltip 相关配置
    tooltip: {
      show: false
    }
  }
});
var _default = LegendModel;
module.exports = _default;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var _symbol = __webpack_require__(99);

var createSymbol = _symbol.createSymbol;

var graphic = __webpack_require__(27);

var _listComponent = __webpack_require__(678);

var makeBackground = _listComponent.makeBackground;

var layoutUtil = __webpack_require__(53);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var curry = zrUtil.curry;
var each = zrUtil.each;
var Group = graphic.Group;

var _default = echarts.extendComponentView({
  type: 'legend.plain',
  newlineDisabled: false,

  /**
   * @override
   */
  init: function () {
    /**
     * @private
     * @type {module:zrender/container/Group}
     */
    this.group.add(this._contentGroup = new Group());
    /**
     * @private
     * @type {module:zrender/Element}
     */

    this._backgroundEl;
    /**
     * @private
     * @type {module:zrender/container/Group}
     */

    this.group.add(this._selectorGroup = new Group());
    /**
     * If first rendering, `contentGroup.position` is [0, 0], which
     * does not make sense and may cause unexepcted animation if adopted.
     * @private
     * @type {boolean}
     */

    this._isFirstRender = true;
  },

  /**
   * @protected
   */
  getContentGroup: function () {
    return this._contentGroup;
  },

  /**
   * @protected
   */
  getSelectorGroup: function () {
    return this._selectorGroup;
  },

  /**
   * @override
   */
  render: function (legendModel, ecModel, api) {
    var isFirstRender = this._isFirstRender;
    this._isFirstRender = false;
    this.resetInner();

    if (!legendModel.get('show', true)) {
      return;
    }

    var itemAlign = legendModel.get('align');
    var orient = legendModel.get('orient');

    if (!itemAlign || itemAlign === 'auto') {
      itemAlign = legendModel.get('left') === 'right' && orient === 'vertical' ? 'right' : 'left';
    }

    var selector = legendModel.get('selector', true);
    var selectorPosition = legendModel.get('selectorPosition', true);

    if (selector && (!selectorPosition || selectorPosition === 'auto')) {
      selectorPosition = orient === 'horizontal' ? 'end' : 'start';
    }

    this.renderInner(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition); // Perform layout.

    var positionInfo = legendModel.getBoxLayoutParams();
    var viewportSize = {
      width: api.getWidth(),
      height: api.getHeight()
    };
    var padding = legendModel.get('padding');
    var maxSize = layoutUtil.getLayoutRect(positionInfo, viewportSize, padding);
    var mainRect = this.layoutInner(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition); // Place mainGroup, based on the calculated `mainRect`.

    var layoutRect = layoutUtil.getLayoutRect(zrUtil.defaults({
      width: mainRect.width,
      height: mainRect.height
    }, positionInfo), viewportSize, padding);
    this.group.attr('position', [layoutRect.x - mainRect.x, layoutRect.y - mainRect.y]); // Render background after group is layout.

    this.group.add(this._backgroundEl = makeBackground(mainRect, legendModel));
  },

  /**
   * @protected
   */
  resetInner: function () {
    this.getContentGroup().removeAll();
    this._backgroundEl && this.group.remove(this._backgroundEl);
    this.getSelectorGroup().removeAll();
  },

  /**
   * @protected
   */
  renderInner: function (itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
    var contentGroup = this.getContentGroup();
    var legendDrawnMap = zrUtil.createHashMap();
    var selectMode = legendModel.get('selectedMode');
    var excludeSeriesId = [];
    ecModel.eachRawSeries(function (seriesModel) {
      !seriesModel.get('legendHoverLink') && excludeSeriesId.push(seriesModel.id);
    });
    each(legendModel.getData(), function (itemModel, dataIndex) {
      var name = itemModel.get('name'); // Use empty string or \n as a newline string

      if (!this.newlineDisabled && (name === '' || name === '\n')) {
        contentGroup.add(new Group({
          newline: true
        }));
        return;
      } // Representitive series.


      var seriesModel = ecModel.getSeriesByName(name)[0];

      if (legendDrawnMap.get(name)) {
        // Have been drawed
        return;
      } // Legend to control series.


      if (seriesModel) {
        var data = seriesModel.getData();
        var color = data.getVisual('color');
        var borderColor = data.getVisual('borderColor'); // If color is a callback function

        if (typeof color === 'function') {
          // Use the first data
          color = color(seriesModel.getDataParams(0));
        } // If borderColor is a callback function


        if (typeof borderColor === 'function') {
          // Use the first data
          borderColor = borderColor(seriesModel.getDataParams(0));
        } // Using rect symbol defaultly


        var legendSymbolType = data.getVisual('legendSymbol') || 'roundRect';
        var symbolType = data.getVisual('symbol');

        var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, borderColor, selectMode);

        itemGroup.on('click', curry(dispatchSelectAction, name, null, api, excludeSeriesId)).on('mouseover', curry(dispatchHighlightAction, seriesModel.name, null, api, excludeSeriesId)).on('mouseout', curry(dispatchDownplayAction, seriesModel.name, null, api, excludeSeriesId));
        legendDrawnMap.set(name, true);
      } else {
        // Legend to control data. In pie and funnel.
        ecModel.eachRawSeries(function (seriesModel) {
          // In case multiple series has same data name
          if (legendDrawnMap.get(name)) {
            return;
          }

          if (seriesModel.legendVisualProvider) {
            var provider = seriesModel.legendVisualProvider;

            if (!provider.containName(name)) {
              return;
            }

            var idx = provider.indexOfName(name);
            var color = provider.getItemVisual(idx, 'color');
            var borderColor = provider.getItemVisual(idx, 'borderColor');
            var legendSymbolType = 'roundRect';

            var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, null, itemAlign, color, borderColor, selectMode); // FIXME: consider different series has items with the same name.


            itemGroup.on('click', curry(dispatchSelectAction, null, name, api, excludeSeriesId)) // Should not specify the series name, consider legend controls
            // more than one pie series.
            .on('mouseover', curry(dispatchHighlightAction, null, name, api, excludeSeriesId)).on('mouseout', curry(dispatchDownplayAction, null, name, api, excludeSeriesId));
            legendDrawnMap.set(name, true);
          }
        }, this);
      }
    }, this);

    if (selector) {
      this._createSelector(selector, legendModel, api, orient, selectorPosition);
    }
  },
  _createSelector: function (selector, legendModel, api, orient, selectorPosition) {
    var selectorGroup = this.getSelectorGroup();
    each(selector, function (selectorItem) {
      createSelectorButton(selectorItem);
    });

    function createSelectorButton(selectorItem) {
      var type = selectorItem.type;
      var labelText = new graphic.Text({
        style: {
          x: 0,
          y: 0,
          align: 'center',
          verticalAlign: 'middle'
        },
        onclick: function () {
          api.dispatchAction({
            type: type === 'all' ? 'legendAllSelect' : 'legendInverseSelect'
          });
        }
      });
      selectorGroup.add(labelText);
      var labelModel = legendModel.getModel('selectorLabel');
      var emphasisLabelModel = legendModel.getModel('emphasis.selectorLabel');
      graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, emphasisLabelModel, {
        defaultText: selectorItem.title,
        isRectText: false
      });
      graphic.setHoverStyle(labelText);
    }
  },
  _createItem: function (name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, borderColor, selectMode) {
    var itemWidth = legendModel.get('itemWidth');
    var itemHeight = legendModel.get('itemHeight');
    var inactiveColor = legendModel.get('inactiveColor');
    var inactiveBorderColor = legendModel.get('inactiveBorderColor');
    var symbolKeepAspect = legendModel.get('symbolKeepAspect');
    var legendModelItemStyle = legendModel.getModel('itemStyle');
    var isSelected = legendModel.isSelected(name);
    var itemGroup = new Group();
    var textStyleModel = itemModel.getModel('textStyle');
    var itemIcon = itemModel.get('icon');
    var tooltipModel = itemModel.getModel('tooltip');
    var legendGlobalTooltipModel = tooltipModel.parentModel; // Use user given icon first

    legendSymbolType = itemIcon || legendSymbolType;
    var legendSymbol = createSymbol(legendSymbolType, 0, 0, itemWidth, itemHeight, isSelected ? color : inactiveColor, // symbolKeepAspect default true for legend
    symbolKeepAspect == null ? true : symbolKeepAspect);
    itemGroup.add(setSymbolStyle(legendSymbol, legendSymbolType, legendModelItemStyle, borderColor, inactiveBorderColor, isSelected)); // Compose symbols
    // PENDING

    if (!itemIcon && symbolType // At least show one symbol, can't be all none
    && (symbolType !== legendSymbolType || symbolType === 'none')) {
      var size = itemHeight * 0.8;

      if (symbolType === 'none') {
        symbolType = 'circle';
      }

      var legendSymbolCenter = createSymbol(symbolType, (itemWidth - size) / 2, (itemHeight - size) / 2, size, size, isSelected ? color : inactiveColor, // symbolKeepAspect default true for legend
      symbolKeepAspect == null ? true : symbolKeepAspect); // Put symbol in the center

      itemGroup.add(setSymbolStyle(legendSymbolCenter, symbolType, legendModelItemStyle, borderColor, inactiveBorderColor, isSelected));
    }

    var textX = itemAlign === 'left' ? itemWidth + 5 : -5;
    var textAlign = itemAlign;
    var formatter = legendModel.get('formatter');
    var content = name;

    if (typeof formatter === 'string' && formatter) {
      content = formatter.replace('{name}', name != null ? name : '');
    } else if (typeof formatter === 'function') {
      content = formatter(name);
    }

    itemGroup.add(new graphic.Text({
      style: graphic.setTextStyle({}, textStyleModel, {
        text: content,
        x: textX,
        y: itemHeight / 2,
        textFill: isSelected ? textStyleModel.getTextColor() : inactiveColor,
        textAlign: textAlign,
        textVerticalAlign: 'middle'
      })
    })); // Add a invisible rect to increase the area of mouse hover

    var hitRect = new graphic.Rect({
      shape: itemGroup.getBoundingRect(),
      invisible: true,
      tooltip: tooltipModel.get('show') ? zrUtil.extend({
        content: name,
        // Defaul formatter
        formatter: legendGlobalTooltipModel.get('formatter', true) || function () {
          return name;
        },
        formatterParams: {
          componentType: 'legend',
          legendIndex: legendModel.componentIndex,
          name: name,
          $vars: ['name']
        }
      }, tooltipModel.option) : null
    });
    itemGroup.add(hitRect);
    itemGroup.eachChild(function (child) {
      child.silent = true;
    });
    hitRect.silent = !selectMode;
    this.getContentGroup().add(itemGroup);
    graphic.setHoverStyle(itemGroup);
    itemGroup.__legendDataIndex = dataIndex;
    return itemGroup;
  },

  /**
   * @protected
   */
  layoutInner: function (legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
    var contentGroup = this.getContentGroup();
    var selectorGroup = this.getSelectorGroup(); // Place items in contentGroup.

    layoutUtil.box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), maxSize.width, maxSize.height);
    var contentRect = contentGroup.getBoundingRect();
    var contentPos = [-contentRect.x, -contentRect.y];

    if (selector) {
      // Place buttons in selectorGroup
      layoutUtil.box( // Buttons in selectorGroup always layout horizontally
      'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
      var selectorRect = selectorGroup.getBoundingRect();
      var selectorPos = [-selectorRect.x, -selectorRect.y];
      var selectorButtonGap = legendModel.get('selectorButtonGap', true);
      var orientIdx = legendModel.getOrient().index;
      var wh = orientIdx === 0 ? 'width' : 'height';
      var hw = orientIdx === 0 ? 'height' : 'width';
      var yx = orientIdx === 0 ? 'y' : 'x';

      if (selectorPosition === 'end') {
        selectorPos[orientIdx] += contentRect[wh] + selectorButtonGap;
      } else {
        contentPos[orientIdx] += selectorRect[wh] + selectorButtonGap;
      } //Always align selector to content as 'middle'


      selectorPos[1 - orientIdx] += contentRect[hw] / 2 - selectorRect[hw] / 2;
      selectorGroup.attr('position', selectorPos);
      contentGroup.attr('position', contentPos);
      var mainRect = {
        x: 0,
        y: 0
      };
      mainRect[wh] = contentRect[wh] + selectorButtonGap + selectorRect[wh];
      mainRect[hw] = Math.max(contentRect[hw], selectorRect[hw]);
      mainRect[yx] = Math.min(0, selectorRect[yx] + selectorPos[1 - orientIdx]);
      return mainRect;
    } else {
      contentGroup.attr('position', contentPos);
      return this.group.getBoundingRect();
    }
  },

  /**
   * @protected
   */
  remove: function () {
    this.getContentGroup().removeAll();
    this._isFirstRender = true;
  }
});

function setSymbolStyle(symbol, symbolType, legendModelItemStyle, borderColor, inactiveBorderColor, isSelected) {
  var itemStyle;

  if (symbolType !== 'line' && symbolType.indexOf('empty') < 0) {
    itemStyle = legendModelItemStyle.getItemStyle();
    symbol.style.stroke = borderColor;

    if (!isSelected) {
      itemStyle.stroke = inactiveBorderColor;
    }
  } else {
    itemStyle = legendModelItemStyle.getItemStyle(['borderWidth', 'borderColor']);
  }

  return symbol.setStyle(itemStyle);
}

function dispatchSelectAction(seriesName, dataName, api, excludeSeriesId) {
  // downplay before unselect
  dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId);
  api.dispatchAction({
    type: 'legendToggleSelect',
    name: seriesName != null ? seriesName : dataName
  }); // highlight after select

  dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId);
}

function dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId) {
  // If element hover will move to a hoverLayer.
  var el = api.getZr().storage.getDisplayList()[0];

  if (!(el && el.useHoverLayer)) {
    api.dispatchAction({
      type: 'highlight',
      seriesName: seriesName,
      name: dataName,
      excludeSeriesId: excludeSeriesId
    });
  }
}

function dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId) {
  // If element hover will move to a hoverLayer.
  var el = api.getZr().storage.getDisplayList()[0];

  if (!(el && el.useHoverLayer)) {
    api.dispatchAction({
      type: 'downplay',
      seriesName: seriesName,
      name: dataName,
      excludeSeriesId: excludeSeriesId
    });
  }
}

module.exports = _default;

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

__webpack_require__(428);

__webpack_require__(211);

__webpack_require__(212);

__webpack_require__(1801);

__webpack_require__(1802);

__webpack_require__(430);

__webpack_require__(431);

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

__webpack_require__(428);

__webpack_require__(211);

__webpack_require__(212);

__webpack_require__(1803);

__webpack_require__(1804);

__webpack_require__(430);

__webpack_require__(431);

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var preprocessor = __webpack_require__(688);

__webpack_require__(689);

__webpack_require__(690);

__webpack_require__(1807);

__webpack_require__(1808);

__webpack_require__(695);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * DataZoom component entry
 */
echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var each = zrUtil.each;

function _default(option) {
  var visualMap = option && option.visualMap;

  if (!zrUtil.isArray(visualMap)) {
    visualMap = visualMap ? [visualMap] : [];
  }

  each(visualMap, function (opt) {
    if (!opt) {
      return;
    } // rename splitList to pieces


    if (has(opt, 'splitList') && !has(opt, 'pieces')) {
      opt.pieces = opt.splitList;
      delete opt.splitList;
    }

    var pieces = opt.pieces;

    if (pieces && zrUtil.isArray(pieces)) {
      each(pieces, function (piece) {
        if (zrUtil.isObject(piece)) {
          if (has(piece, 'start') && !has(piece, 'min')) {
            piece.min = piece.start;
          }

          if (has(piece, 'end') && !has(piece, 'max')) {
            piece.max = piece.end;
          }
        }
      });
    }
  });
}

function has(obj, name) {
  return obj && obj.hasOwnProperty && obj.hasOwnProperty(name);
}

module.exports = _default;

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var Component = __webpack_require__(73);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
Component.registerSubTypeDefaulter('visualMap', function (option) {
  // Compatible with ec2, when splitNumber === 0, continuous visualMap will be used.
  return !option.categories && (!(option.pieces ? option.pieces.length > 0 : option.splitNumber > 0) || option.calculable) ? 'continuous' : 'piecewise';
});

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var visualSolution = __webpack_require__(309);

var VisualMapping = __webpack_require__(181);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var VISUAL_PRIORITY = echarts.PRIORITY.VISUAL.COMPONENT;
echarts.registerVisual(VISUAL_PRIORITY, {
  createOnAllSeries: true,
  reset: function (seriesModel, ecModel) {
    var resetDefines = [];
    ecModel.eachComponent('visualMap', function (visualMapModel) {
      var pipelineContext = seriesModel.pipelineContext;

      if (!visualMapModel.isTargetSeries(seriesModel) || pipelineContext && pipelineContext.large) {
        return;
      }

      resetDefines.push(visualSolution.incrementalApplyVisual(visualMapModel.stateList, visualMapModel.targetVisuals, zrUtil.bind(visualMapModel.getValueState, visualMapModel), visualMapModel.getDataDimension(seriesModel.getData())));
    });
    return resetDefines;
  }
}); // Only support color.

echarts.registerVisual(VISUAL_PRIORITY, {
  createOnAllSeries: true,
  reset: function (seriesModel, ecModel) {
    var data = seriesModel.getData();
    var visualMetaList = [];
    ecModel.eachComponent('visualMap', function (visualMapModel) {
      if (visualMapModel.isTargetSeries(seriesModel)) {
        var visualMeta = visualMapModel.getVisualMeta(zrUtil.bind(getColorVisual, null, seriesModel, visualMapModel)) || {
          stops: [],
          outerColors: []
        };
        var concreteDim = visualMapModel.getDataDimension(data);
        var dimInfo = data.getDimensionInfo(concreteDim);

        if (dimInfo != null) {
          // visualMeta.dimension should be dimension index, but not concrete dimension.
          visualMeta.dimension = dimInfo.index;
          visualMetaList.push(visualMeta);
        }
      }
    }); // console.log(JSON.stringify(visualMetaList.map(a => a.stops)));

    seriesModel.getData().setVisual('visualMeta', visualMetaList);
  }
}); // FIXME
// performance and export for heatmap?
// value can be Infinity or -Infinity

function getColorVisual(seriesModel, visualMapModel, value, valueState) {
  var mappings = visualMapModel.targetVisuals[valueState];
  var visualTypes = VisualMapping.prepareVisualTypes(mappings);
  var resultVisual = {
    color: seriesModel.getData().getVisual('color') // default color.

  };

  for (var i = 0, len = visualTypes.length; i < len; i++) {
    var type = visualTypes[i];
    var mapping = mappings[type === 'opacity' ? '__alphaForOpacity' : type];
    mapping && mapping.applyVisual(value, getVisual, setVisual);
  }

  return resultVisual.color;

  function getVisual(key) {
    return resultVisual[key];
  }

  function setVisual(key, value) {
    resultVisual[key] = value;
  }
}

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var env = __webpack_require__(67);

var visualDefault = __webpack_require__(692);

var VisualMapping = __webpack_require__(181);

var visualSolution = __webpack_require__(309);

var modelUtil = __webpack_require__(44);

var numberUtil = __webpack_require__(37);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var mapVisual = VisualMapping.mapVisual;
var eachVisual = VisualMapping.eachVisual;
var isArray = zrUtil.isArray;
var each = zrUtil.each;
var asc = numberUtil.asc;
var linearMap = numberUtil.linearMap;
var noop = zrUtil.noop;
var VisualMapModel = echarts.extendComponentModel({
  type: 'visualMap',
  dependencies: ['series'],

  /**
   * @readOnly
   * @type {Array.<string>}
   */
  stateList: ['inRange', 'outOfRange'],

  /**
   * @readOnly
   * @type {Array.<string>}
   */
  replacableOptionKeys: ['inRange', 'outOfRange', 'target', 'controller', 'color'],

  /**
   * [lowerBound, upperBound]
   *
   * @readOnly
   * @type {Array.<number>}
   */
  dataBound: [-Infinity, Infinity],

  /**
   * @readOnly
   * @type {string|Object}
   */
  layoutMode: {
    type: 'box',
    ignoreSize: true
  },

  /**
   * @protected
   */
  defaultOption: {
    show: true,
    zlevel: 0,
    z: 4,
    seriesIndex: 'all',
    // 'all' or null/undefined: all series.
    // A number or an array of number: the specified series.
    // set min: 0, max: 200, only for campatible with ec2.
    // In fact min max should not have default value.
    min: 0,
    // min value, must specified if pieces is not specified.
    max: 200,
    // max value, must specified if pieces is not specified.
    dimension: null,
    inRange: null,
    // 'color', 'colorHue', 'colorSaturation', 'colorLightness', 'colorAlpha',
    // 'symbol', 'symbolSize'
    outOfRange: null,
    // 'color', 'colorHue', 'colorSaturation',
    // 'colorLightness', 'colorAlpha',
    // 'symbol', 'symbolSize'
    left: 0,
    // 'center' ¦ 'left' ¦ 'right' ¦ {number} (px)
    right: null,
    // The same as left.
    top: null,
    // 'top' ¦ 'bottom' ¦ 'center' ¦ {number} (px)
    bottom: 0,
    // The same as top.
    itemWidth: null,
    itemHeight: null,
    inverse: false,
    orient: 'vertical',
    // 'horizontal' ¦ 'vertical'
    backgroundColor: 'rgba(0,0,0,0)',
    borderColor: '#ccc',
    // 值域边框颜色
    contentColor: '#5793f3',
    inactiveColor: '#aaa',
    borderWidth: 0,
    // 值域边框线宽，单位px，默认为0（无边框）
    padding: 5,
    // 值域内边距，单位px，默认各方向内边距为5，
    // 接受数组分别设定上右下左边距，同css
    textGap: 10,
    //
    precision: 0,
    // 小数精度，默认为0，无小数点
    color: null,
    //颜色（deprecated，兼容ec2，顺序同pieces，不同于inRange/outOfRange）
    formatter: null,
    text: null,
    // 文本，如['高', '低']，兼容ec2，text[0]对应高值，text[1]对应低值
    textStyle: {
      color: '#333' // 值域文字颜色

    }
  },

  /**
   * @protected
   */
  init: function (option, parentModel, ecModel) {
    /**
     * @private
     * @type {Array.<number>}
     */
    this._dataExtent;
    /**
     * @readOnly
     */

    this.targetVisuals = {};
    /**
     * @readOnly
     */

    this.controllerVisuals = {};
    /**
     * @readOnly
     */

    this.textStyleModel;
    /**
     * [width, height]
     * @readOnly
     * @type {Array.<number>}
     */

    this.itemSize;
    this.mergeDefaultAndTheme(option, ecModel);
  },

  /**
   * @protected
   */
  optionUpdated: function (newOption, isInit) {
    var thisOption = this.option; // FIXME
    // necessary?
    // Disable realtime view update if canvas is not supported.

    if (!env.canvasSupported) {
      thisOption.realtime = false;
    }

    !isInit && visualSolution.replaceVisualOption(thisOption, newOption, this.replacableOptionKeys);
    this.textStyleModel = this.getModel('textStyle');
    this.resetItemSize();
    this.completeVisualOption();
  },

  /**
   * @protected
   */
  resetVisual: function (supplementVisualOption) {
    var stateList = this.stateList;
    supplementVisualOption = zrUtil.bind(supplementVisualOption, this);
    this.controllerVisuals = visualSolution.createVisualMappings(this.option.controller, stateList, supplementVisualOption);
    this.targetVisuals = visualSolution.createVisualMappings(this.option.target, stateList, supplementVisualOption);
  },

  /**
   * @protected
   * @return {Array.<number>} An array of series indices.
   */
  getTargetSeriesIndices: function () {
    var optionSeriesIndex = this.option.seriesIndex;
    var seriesIndices = [];

    if (optionSeriesIndex == null || optionSeriesIndex === 'all') {
      this.ecModel.eachSeries(function (seriesModel, index) {
        seriesIndices.push(index);
      });
    } else {
      seriesIndices = modelUtil.normalizeToArray(optionSeriesIndex);
    }

    return seriesIndices;
  },

  /**
   * @public
   */
  eachTargetSeries: function (callback, context) {
    zrUtil.each(this.getTargetSeriesIndices(), function (seriesIndex) {
      callback.call(context, this.ecModel.getSeriesByIndex(seriesIndex));
    }, this);
  },

  /**
   * @pubilc
   */
  isTargetSeries: function (seriesModel) {
    var is = false;
    this.eachTargetSeries(function (model) {
      model === seriesModel && (is = true);
    });
    return is;
  },

  /**
   * @example
   * this.formatValueText(someVal); // format single numeric value to text.
   * this.formatValueText(someVal, true); // format single category value to text.
   * this.formatValueText([min, max]); // format numeric min-max to text.
   * this.formatValueText([this.dataBound[0], max]); // using data lower bound.
   * this.formatValueText([min, this.dataBound[1]]); // using data upper bound.
   *
   * @param {number|Array.<number>} value Real value, or this.dataBound[0 or 1].
   * @param {boolean} [isCategory=false] Only available when value is number.
   * @param {Array.<string>} edgeSymbols Open-close symbol when value is interval.
   * @return {string}
   * @protected
   */
  formatValueText: function (value, isCategory, edgeSymbols) {
    var option = this.option;
    var precision = option.precision;
    var dataBound = this.dataBound;
    var formatter = option.formatter;
    var isMinMax;
    var textValue;
    edgeSymbols = edgeSymbols || ['<', '>'];

    if (zrUtil.isArray(value)) {
      value = value.slice();
      isMinMax = true;
    }

    textValue = isCategory ? value : isMinMax ? [toFixed(value[0]), toFixed(value[1])] : toFixed(value);

    if (zrUtil.isString(formatter)) {
      return formatter.replace('{value}', isMinMax ? textValue[0] : textValue).replace('{value2}', isMinMax ? textValue[1] : textValue);
    } else if (zrUtil.isFunction(formatter)) {
      return isMinMax ? formatter(value[0], value[1]) : formatter(value);
    }

    if (isMinMax) {
      if (value[0] === dataBound[0]) {
        return edgeSymbols[0] + ' ' + textValue[1];
      } else if (value[1] === dataBound[1]) {
        return edgeSymbols[1] + ' ' + textValue[0];
      } else {
        return textValue[0] + ' - ' + textValue[1];
      }
    } else {
      // Format single value (includes category case).
      return textValue;
    }

    function toFixed(val) {
      return val === dataBound[0] ? 'min' : val === dataBound[1] ? 'max' : (+val).toFixed(Math.min(precision, 20));
    }
  },

  /**
   * @protected
   */
  resetExtent: function () {
    var thisOption = this.option; // Can not calculate data extent by data here.
    // Because series and data may be modified in processing stage.
    // So we do not support the feature "auto min/max".

    var extent = asc([thisOption.min, thisOption.max]);
    this._dataExtent = extent;
  },

  /**
   * @public
   * @param {module:echarts/data/List} list
   * @return {string} Concrete dimention. If return null/undefined,
   *                  no dimension used.
   */
  getDataDimension: function (list) {
    var optDim = this.option.dimension;
    var listDimensions = list.dimensions;

    if (optDim == null && !listDimensions.length) {
      return;
    }

    if (optDim != null) {
      return list.getDimension(optDim);
    }

    var dimNames = list.dimensions;

    for (var i = dimNames.length - 1; i >= 0; i--) {
      var dimName = dimNames[i];
      var dimInfo = list.getDimensionInfo(dimName);

      if (!dimInfo.isCalculationCoord) {
        return dimName;
      }
    }
  },

  /**
   * @public
   * @override
   */
  getExtent: function () {
    return this._dataExtent.slice();
  },

  /**
   * @protected
   */
  completeVisualOption: function () {
    var ecModel = this.ecModel;
    var thisOption = this.option;
    var base = {
      inRange: thisOption.inRange,
      outOfRange: thisOption.outOfRange
    };
    var target = thisOption.target || (thisOption.target = {});
    var controller = thisOption.controller || (thisOption.controller = {});
    zrUtil.merge(target, base); // Do not override

    zrUtil.merge(controller, base); // Do not override

    var isCategory = this.isCategory();
    completeSingle.call(this, target);
    completeSingle.call(this, controller);
    completeInactive.call(this, target, 'inRange', 'outOfRange'); // completeInactive.call(this, target, 'outOfRange', 'inRange');

    completeController.call(this, controller);

    function completeSingle(base) {
      // Compatible with ec2 dataRange.color.
      // The mapping order of dataRange.color is: [high value, ..., low value]
      // whereas inRange.color and outOfRange.color is [low value, ..., high value]
      // Notice: ec2 has no inverse.
      if (isArray(thisOption.color) // If there has been inRange: {symbol: ...}, adding color is a mistake.
      // So adding color only when no inRange defined.
      && !base.inRange) {
        base.inRange = {
          color: thisOption.color.slice().reverse()
        };
      } // Compatible with previous logic, always give a defautl color, otherwise
      // simple config with no inRange and outOfRange will not work.
      // Originally we use visualMap.color as the default color, but setOption at
      // the second time the default color will be erased. So we change to use
      // constant DEFAULT_COLOR.
      // If user do not want the default color, set inRange: {color: null}.


      base.inRange = base.inRange || {
        color: ecModel.get('gradientColor')
      }; // If using shortcut like: {inRange: 'symbol'}, complete default value.

      each(this.stateList, function (state) {
        var visualType = base[state];

        if (zrUtil.isString(visualType)) {
          var defa = visualDefault.get(visualType, 'active', isCategory);

          if (defa) {
            base[state] = {};
            base[state][visualType] = defa;
          } else {
            // Mark as not specified.
            delete base[state];
          }
        }
      }, this);
    }

    function completeInactive(base, stateExist, stateAbsent) {
      var optExist = base[stateExist];
      var optAbsent = base[stateAbsent];

      if (optExist && !optAbsent) {
        optAbsent = base[stateAbsent] = {};
        each(optExist, function (visualData, visualType) {
          if (!VisualMapping.isValidType(visualType)) {
            return;
          }

          var defa = visualDefault.get(visualType, 'inactive', isCategory);

          if (defa != null) {
            optAbsent[visualType] = defa; // Compatibable with ec2:
            // Only inactive color to rgba(0,0,0,0) can not
            // make label transparent, so use opacity also.

            if (visualType === 'color' && !optAbsent.hasOwnProperty('opacity') && !optAbsent.hasOwnProperty('colorAlpha')) {
              optAbsent.opacity = [0, 0];
            }
          }
        });
      }
    }

    function completeController(controller) {
      var symbolExists = (controller.inRange || {}).symbol || (controller.outOfRange || {}).symbol;
      var symbolSizeExists = (controller.inRange || {}).symbolSize || (controller.outOfRange || {}).symbolSize;
      var inactiveColor = this.get('inactiveColor');
      each(this.stateList, function (state) {
        var itemSize = this.itemSize;
        var visuals = controller[state]; // Set inactive color for controller if no other color
        // attr (like colorAlpha) specified.

        if (!visuals) {
          visuals = controller[state] = {
            color: isCategory ? inactiveColor : [inactiveColor]
          };
        } // Consistent symbol and symbolSize if not specified.


        if (visuals.symbol == null) {
          visuals.symbol = symbolExists && zrUtil.clone(symbolExists) || (isCategory ? 'roundRect' : ['roundRect']);
        }

        if (visuals.symbolSize == null) {
          visuals.symbolSize = symbolSizeExists && zrUtil.clone(symbolSizeExists) || (isCategory ? itemSize[0] : [itemSize[0], itemSize[0]]);
        } // Filter square and none.


        visuals.symbol = mapVisual(visuals.symbol, function (symbol) {
          return symbol === 'none' || symbol === 'square' ? 'roundRect' : symbol;
        }); // Normalize symbolSize

        var symbolSize = visuals.symbolSize;

        if (symbolSize != null) {
          var max = -Infinity; // symbolSize can be object when categories defined.

          eachVisual(symbolSize, function (value) {
            value > max && (max = value);
          });
          visuals.symbolSize = mapVisual(symbolSize, function (value) {
            return linearMap(value, [0, max], [0, itemSize[0]], true);
          });
        }
      }, this);
    }
  },

  /**
   * @protected
   */
  resetItemSize: function () {
    this.itemSize = [parseFloat(this.get('itemWidth')), parseFloat(this.get('itemHeight'))];
  },

  /**
   * @public
   */
  isCategory: function () {
    return !!this.option.categories;
  },

  /**
   * @public
   * @abstract
   */
  setSelected: noop,

  /**
   * @public
   * @abstract
   * @param {*|module:echarts/data/List} valueOrData
   * @param {number} dataIndex
   * @return {string} state See this.stateList
   */
  getValueState: noop,

  /**
   * FIXME
   * Do not publish to thirt-part-dev temporarily
   * util the interface is stable. (Should it return
   * a function but not visual meta?)
   *
   * @pubilc
   * @abstract
   * @param {Function} getColorVisual
   *        params: value, valueState
   *        return: color
   * @return {Object} visualMeta
   *        should includes {stops, outerColors}
   *        outerColor means [colorBeyondMinValue, colorBeyondMaxValue]
   */
  getVisualMeta: noop
});
var _default = VisualMapModel;
module.exports = _default;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @file Visual mapping.
 */
var visualDefault = {
  /**
   * @public
   */
  get: function (visualType, key, isCategory) {
    var value = zrUtil.clone((defaultOption[visualType] || {})[key]);
    return isCategory ? zrUtil.isArray(value) ? value[value.length - 1] : value : value;
  }
};
var defaultOption = {
  color: {
    active: ['#006edd', '#e0ffff'],
    inactive: ['rgba(0,0,0,0)']
  },
  colorHue: {
    active: [0, 360],
    inactive: [0, 0]
  },
  colorSaturation: {
    active: [0.3, 1],
    inactive: [0, 0]
  },
  colorLightness: {
    active: [0.9, 0.5],
    inactive: [0, 0]
  },
  colorAlpha: {
    active: [0.3, 1],
    inactive: [0, 0]
  },
  opacity: {
    active: [0.3, 1],
    inactive: [0, 0]
  },
  symbol: {
    active: ['circle', 'roundRect', 'diamond'],
    inactive: ['none']
  },
  symbolSize: {
    active: [10, 50],
    inactive: [0, 0]
  }
};
var _default = visualDefault;
module.exports = _default;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var graphic = __webpack_require__(27);

var formatUtil = __webpack_require__(54);

var layout = __webpack_require__(53);

var VisualMapping = __webpack_require__(181);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = echarts.extendComponentView({
  type: 'visualMap',

  /**
   * @readOnly
   * @type {Object}
   */
  autoPositionValues: {
    left: 1,
    right: 1,
    top: 1,
    bottom: 1
  },
  init: function (ecModel, api) {
    /**
     * @readOnly
     * @type {module:echarts/model/Global}
     */
    this.ecModel = ecModel;
    /**
     * @readOnly
     * @type {module:echarts/ExtensionAPI}
     */

    this.api = api;
    /**
     * @readOnly
     * @type {module:echarts/component/visualMap/visualMapModel}
     */

    this.visualMapModel;
  },

  /**
   * @protected
   */
  render: function (visualMapModel, ecModel, api, payload) {
    this.visualMapModel = visualMapModel;

    if (visualMapModel.get('show') === false) {
      this.group.removeAll();
      return;
    }

    this.doRender.apply(this, arguments);
  },

  /**
   * @protected
   */
  renderBackground: function (group) {
    var visualMapModel = this.visualMapModel;
    var padding = formatUtil.normalizeCssArray(visualMapModel.get('padding') || 0);
    var rect = group.getBoundingRect();
    group.add(new graphic.Rect({
      z2: -1,
      // Lay background rect on the lowest layer.
      silent: true,
      shape: {
        x: rect.x - padding[3],
        y: rect.y - padding[0],
        width: rect.width + padding[3] + padding[1],
        height: rect.height + padding[0] + padding[2]
      },
      style: {
        fill: visualMapModel.get('backgroundColor'),
        stroke: visualMapModel.get('borderColor'),
        lineWidth: visualMapModel.get('borderWidth')
      }
    }));
  },

  /**
   * @protected
   * @param {number} targetValue can be Infinity or -Infinity
   * @param {string=} visualCluster Only can be 'color' 'opacity' 'symbol' 'symbolSize'
   * @param {Object} [opts]
   * @param {string=} [opts.forceState] Specify state, instead of using getValueState method.
   * @param {string=} [opts.convertOpacityToAlpha=false] For color gradient in controller widget.
   * @return {*} Visual value.
   */
  getControllerVisual: function (targetValue, visualCluster, opts) {
    opts = opts || {};
    var forceState = opts.forceState;
    var visualMapModel = this.visualMapModel;
    var visualObj = {}; // Default values.

    if (visualCluster === 'symbol') {
      visualObj.symbol = visualMapModel.get('itemSymbol');
    }

    if (visualCluster === 'color') {
      var defaultColor = visualMapModel.get('contentColor');
      visualObj.color = defaultColor;
    }

    function getter(key) {
      return visualObj[key];
    }

    function setter(key, value) {
      visualObj[key] = value;
    }

    var mappings = visualMapModel.controllerVisuals[forceState || visualMapModel.getValueState(targetValue)];
    var visualTypes = VisualMapping.prepareVisualTypes(mappings);
    zrUtil.each(visualTypes, function (type) {
      var visualMapping = mappings[type];

      if (opts.convertOpacityToAlpha && type === 'opacity') {
        type = 'colorAlpha';
        visualMapping = mappings.__alphaForOpacity;
      }

      if (VisualMapping.dependsOn(type, visualCluster)) {
        visualMapping && visualMapping.applyVisual(targetValue, getter, setter);
      }
    });
    return visualObj[visualCluster];
  },

  /**
   * @protected
   */
  positionGroup: function (group) {
    var model = this.visualMapModel;
    var api = this.api;
    layout.positionElement(group, model.getBoxLayoutParams(), {
      width: api.getWidth(),
      height: api.getHeight()
    });
  },

  /**
   * @protected
   * @abstract
   */
  doRender: zrUtil.noop
});

module.exports = _default;

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var _layout = __webpack_require__(53);

var getLayoutRect = _layout.getLayoutRect;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @param {module:echarts/component/visualMap/VisualMapModel} visualMapModel\
 * @param {module:echarts/ExtensionAPI} api
 * @param {Array.<number>} itemSize always [short, long]
 * @return {string} 'left' or 'right' or 'top' or 'bottom'
 */
function getItemAlign(visualMapModel, api, itemSize) {
  var modelOption = visualMapModel.option;
  var itemAlign = modelOption.align;

  if (itemAlign != null && itemAlign !== 'auto') {
    return itemAlign;
  } // Auto decision align.


  var ecSize = {
    width: api.getWidth(),
    height: api.getHeight()
  };
  var realIndex = modelOption.orient === 'horizontal' ? 1 : 0;
  var paramsSet = [['left', 'right', 'width'], ['top', 'bottom', 'height']];
  var reals = paramsSet[realIndex];
  var fakeValue = [0, null, 10];
  var layoutInput = {};

  for (var i = 0; i < 3; i++) {
    layoutInput[paramsSet[1 - realIndex][i]] = fakeValue[i];
    layoutInput[reals[i]] = i === 2 ? itemSize[0] : modelOption[reals[i]];
  }

  var rParam = [['x', 'width', 3], ['y', 'height', 0]][realIndex];
  var rect = getLayoutRect(layoutInput, ecSize, modelOption.padding);
  return reals[(rect.margin[rParam[2]] || 0) + rect[rParam[0]] + rect[rParam[1]] * 0.5 < ecSize[rParam[1]] * 0.5 ? 0 : 1];
}
/**
 * Prepare dataIndex for outside usage, where dataIndex means rawIndex, and
 * dataIndexInside means filtered index.
 */


function makeHighDownBatch(batch, visualMapModel) {
  zrUtil.each(batch || [], function (batchItem) {
    if (batchItem.dataIndex != null) {
      batchItem.dataIndexInside = batchItem.dataIndex;
      batchItem.dataIndex = null;
    }

    batchItem.highlightKey = 'visualMap' + (visualMapModel ? visualMapModel.componentIndex : '');
  });
  return batch;
}

exports.getItemAlign = getItemAlign;
exports.makeHighDownBatch = makeHighDownBatch;

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var actionInfo = {
  type: 'selectDataRange',
  event: 'dataRangeSelected',
  // FIXME use updateView appears wrong
  update: 'update'
};
echarts.registerAction(actionInfo, function (payload, ecModel) {
  ecModel.eachComponent({
    mainType: 'visualMap',
    query: payload
  }, function (model) {
    model.setSelected(payload.selected);
  });
});

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var preprocessor = __webpack_require__(688);

__webpack_require__(689);

__webpack_require__(690);

__webpack_require__(1809);

__webpack_require__(1810);

__webpack_require__(695);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * DataZoom component entry
 */
echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var env = __webpack_require__(67);

var urn = 'urn:schemas-microsoft-com:vml';
var win = typeof window === 'undefined' ? null : window;
var vmlInited = false;
var doc = win && win.document;

function createNode(tagName) {
  return doCreateNode(tagName);
} // Avoid assign to an exported variable, for transforming to cjs.


var doCreateNode;

if (doc && !env.canvasSupported) {
  try {
    !doc.namespaces.zrvml && doc.namespaces.add('zrvml', urn);

    doCreateNode = function (tagName) {
      return doc.createElement('<zrvml:' + tagName + ' class="zrvml">');
    };
  } catch (e) {
    doCreateNode = function (tagName) {
      return doc.createElement('<' + tagName + ' xmlns="' + urn + '" class="zrvml">');
    };
  }
} // From raphael


function initVML() {
  if (vmlInited || !doc) {
    return;
  }

  vmlInited = true;
  var styleSheets = doc.styleSheets;

  if (styleSheets.length < 31) {
    doc.createStyleSheet().addRule('.zrvml', 'behavior:url(#default#VML)');
  } else {
    // http://msdn.microsoft.com/en-us/library/ms531194%28VS.85%29.aspx
    styleSheets[0].addRule('.zrvml', 'behavior:url(#default#VML)');
  }
}

exports.doc = doc;
exports.createNode = createNode;
exports.initVML = initVML;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data4_3_2=exports.data4_3_2=[{name:'',name_code:"",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'',name_code:"",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'',name_code:"",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'',name_code:"",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'',name_code:"",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'',name_code:"",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'',name_code:"",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'',name_code:"",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'',name_code:"",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'',name_code:"",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"},{name:'Sub-Total 小计',name_code:"Sub_Total",m_this_RN:"0",m_this_ADR:"0",m_this_REV:"0",m_last_RN:"0",m_last_ADR:"0",m_last_REV:"0",m_ratio_RN:"0",m_RN_percent:"0",m_ratio_ADR:"0",m_ADR_percent:"0",m_ratio_REV:"0",m_REV_percent:"0",y_this_RN:"0",y_this_ADR:"0",y_this_REV:"0",y_last_RN:"0",y_last_ADR:"0",y_last_REV:"0",y_ratio_RN:"0",y_RN_percent:"0",y_ratio_ADR:"0",y_ADR_percent:"0",y_ratio_REV:"0"}];

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data3_2_1=exports.data3_2_1=[{name:'',name_code:'',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'',name_code:'',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'',name_code:'',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'',name_code:'',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'',name_code:'',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'',name_code:'',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'',name_code:'',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'',name_code:'',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'',name_code:'',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'',name_code:'',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'',name_code:'',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'',name_code:'',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'',name_code:'',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'Total - Outlets 餐厅合计',name_code:'Total_Outlets',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'Meeting Room Rental 会议场地设施收入',name_code:'Meeting_Room_Rental',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'Service Charge/Others 服务费及其他收入',name_code:'Service_Charge/Others',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'},{name:'Total 合计',name_code:'Total',covers:'0',business:'0',AC:'0',REV:'0',revenue:'0',cost:'0',cost_percent:'0',m_covers:'0',m_business:'0',m_AC:'0',m_REV:'0',m_revenue:'0',m_cost:'0',m_cost_percent:'0',b_covers:'0',b_business:'0',b_AC:'0',b_REV:'0',b_revenue:'0',b_cost:'0',b_cost_percent:'0'}];

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var dataDefault=exports.dataDefault=[{"name":"1000&lt;Conference Area<br/>1000&lt;会议厅面积","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":0},{"name":"Ballroom A<br/>多功能宴会厅A","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":1},{"name":"Ballroom B<br/>多功能宴会厅B","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":2},{"name":"500<=Conference Area<1000<br/>500<=会议厅面积<1000","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":3},{"name":"Conference A<br/>大会议室A","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":4},{"name":"Conference B<br/>大会议室B","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":5},{"name":"Conference C<br/>大会议室C","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":6},{"name":"Conference D<br/>大会议室D","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":7},{"name":"Conference E<br/>大会议室E","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":8},{"name":"Conference F<br/>大会议室F","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":9},{"name":"Conference G<br/>大会议室G","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":10},{"name":"Conference H<br/>大会议室H","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":11},{"name":"Conference I<br/>大会议室I","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":12},{"name":"Conference J<br/>大会议室J","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":13},{"name":"200<=Conference Area<500<br/>200<=会议厅面积<500","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":14},{"name":"Conference A<br/>中会议室A","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":15},{"name":"Conference B<br/>中会议室B","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":16},{"name":"Conference C<br/>中会议室C","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":17},{"name":"Conference D<br/>中会议室D","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":18},{"name":"Conference E<br/>中会议室E","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":19},{"name":"Conference F<br/>中会议室F","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":20},{"name":"Conference G<br/>中会议室G","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":21},{"name":"Conference H<br/>中会议室H","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":22},{"name":"Conference I<br/>中会议室I","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":23},{"name":"Conference J<br/>中会议室J","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":24},{"name":"Conference Area<200<br/>会议厅面积<200","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":25},{"name":"Conference A<br/>小会议室A","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":26},{"name":"Conference B<br/>小会议室B","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":27},{"name":"Conference C<br/>小会议室C","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":28},{"name":"Conference D<br/>小会议室D","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":29},{"name":"Conference E<br/>小会议室E","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":30},{"name":"Conference F<br/>小会议室F","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":31},{"name":"Conference G<br/>小会议室G","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":32},{"name":"Conference H<br/>小会议室H","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":33},{"name":"Conference I<br/>小会议室I","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":34},{"name":"Conference J<br/>小会议室J","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":35},{"name":"Conference K<br/>小会议室K","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":36},{"name":"Conference L<br/>小会议室L","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":37},{"name":"Conference M<br/>小会议室M","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":38},{"name":"Conference N<br/>小会议室N","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":39},{"name":"Conference O<br/>小会议室O","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":40},{"name":"Conference P<br/>小会议室P","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":41},{"name":"Conference Q<br/>小会议室Q","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":42},{"name":"Conference R<br/>小会议室R","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":43},{"name":"Conference S<br/>小会议室S","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":44},{"name":"Conference T<br/>小会议室T","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":45},{"name":"Total<br/>总计","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":46},{"name":"","meet":0,"space":0,"no":0,"sold":0,"occ":0,"total":0,"sc":0,"rev":0,"sort":47}];function twoPoints(arr,num){if(arr.length<=1)return arr[0]===num;var isTrue=false;var len=Math.floor(arr.length/2);if(arr[len]===num)return true;if(arr[len]>num){isTrue=twoPoints(arr.slice(0,len-1),num);}if(arr[len]<num){isTrue=twoPoints(arr.slice(len,arr.length-1),num);}return isTrue;}

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=function(data,date){var month=(0,_moment2.default)(date).daysInMonth();var totalIndex=[0,3,14,25];data.forEach(function(item,index){if(![].concat(totalIndex,[46]).includes(index)){data[index].space=((0,_method.numConvert)(data[index].meet)*month).toFixed(2);}});// total
var totalName=['meet','space','no','sold','total'];totalName.forEach(function(name){totalIndex.forEach(function(index,i){data[index][name]=data.reduce(function(a,b,j){if(totalIndex[i+1]>=0&&j>index&&j<totalIndex[i+1]){a+=(0,_method.numConvert)(b[name]);}if(!totalIndex[i+1]&&j>index&&j<=45){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);});data[46][name]=totalIndex.reduce(function(a,b){a+=(0,_method.numConvert)(data[b][name]);return a;},0).toFixed(2);});// 宴会收入、平均收入
data.forEach(function(item,i){data[i].sc=(0,_method.calculation)(item.total,item.sold,2);data[i].rev=(0,_method.calculation)(item.total,item.space,2);if(!totalIndex.includes(i)){data[i].occ=(0,_method.calculation)(item.no,(0,_method.sum)([].concat(_toConsumableArray(totalIndex.map(function(x){return data[x].no;})))),4);}});data[0].occ=(0,_method.sum)([data[1].occ,data[2].occ],4);data[3].occ=data.reduce(function(a,b,i){if(i>3&&i<14){a+=(0,_method.numConvert)(b.occ);}return a;},0).toFixed(4);data[14].occ=data.reduce(function(a,b,i){if(i>14&&i<25){a+=(0,_method.numConvert)(b.occ);}return a;},0).toFixed(4);data[25].occ=data.reduce(function(a,b,i){if(i>25&&i<46){a+=(0,_method.numConvert)(b.occ);}return a;},0).toFixed(4);return data;};var _method=__webpack_require__(20);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _tooltip=__webpack_require__(87);var _tooltip2=_interopRequireDefault(_tooltip);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(100);__webpack_require__(35);__webpack_require__(10);__webpack_require__(25);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(703);var _data=__webpack_require__(704);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _method=__webpack_require__(20);var _TableText=__webpack_require__(139);var _TableText2=_interopRequireDefault(_TableText);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TextArea=_input2.default.TextArea;var totalIndexFooter=[11,15,16,19];var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var _this$state=_this.state,date=_this$state.date,last=_this$state.last,lastYear=_this$state.lastYear,data1_1=_this$state.data1_1;var isOpenLastFill=(0,_moment2.default)(date).isBefore((0,_moment2.default)("2022-02"));// 工资合计
var totalData=['thisy_employee_num','thisy_payroll_cost','lasty_employee_num','lasty_payroll_cost','year_thisy_employee_num','year_thisy_payroll_cost','year_lasty_employee_num','year_lasty_payroll_cost'];// 填充年累计 从2022-02开始填充
if(!isOpenLastFill){//填充去年当月
for(var i=0;i<data.length;i++){data[i].lasty_employee_num=(0,_method.numConvert)(_lodash2.default.get(lastYear,i+'.thisy_employee_num',0)).toFixed(2);data[i].lasty_average_payroll=(0,_method.numConvert)(_lodash2.default.get(lastYear,i+'.thisy_average_payroll',0)).toFixed(2);data[i].lasty_payroll_cost=(0,_method.numConvert)(_lodash2.default.get(lastYear,i+'.thisy_payroll_cost',0)).toFixed(2);}for(var _i=0;_i<data.length;_i++){data[_i].year_thisy_employee_num=(0,_method.sum)([data[_i].thisy_employee_num,_lodash2.default.get(last,_i+'.year_thisy_employee_num',0)]);data[_i].year_thisy_payroll_cost=(0,_method.sum)([data[_i].thisy_payroll_cost,_lodash2.default.get(last,_i+'.year_thisy_payroll_cost',0)]);data[_i].year_lasty_employee_num=(0,_method.sum)([data[_i].lasty_employee_num,_lodash2.default.get(last,_i+'.year_lasty_employee_num',0)]);data[_i].year_lasty_payroll_cost=(0,_method.sum)([data[_i].lasty_payroll_cost,_lodash2.default.get(last,_i+'.year_lasty_payroll_cost',0)]);}}for(var _index=0;_index<totalData.length;_index++){data[11][totalData[_index]]=0;}for(var _index2=0;_index2<11;_index2++){for(var _i2=0;_i2<totalData.length;_i2++){data[11][totalData[_i2]]=(Number(data[_index2][totalData[_i2]])+Number(data[11][totalData[_i2]])).toFixed(2);data[19][totalData[_i2]]=(Number(data[18][totalData[_i2]])+Number(data[17][totalData[_i2]])).toFixed(2);}}// 五险一金 年终奖 其他费用 以及合计计算
data[15].thisy_payroll_cost=data[15].lasty_payroll_cost=data[15].year_thisy_payroll_cost=data[15].year_lasty_payroll_cost=0;for(var _index3=12;_index3<15;_index3++){data[15].thisy_payroll_cost=(Number(data[_index3].thisy_payroll_cost)+Number(data[15].thisy_payroll_cost)).toFixed(2);data[15].lasty_payroll_cost=(Number(data[_index3].lasty_payroll_cost)+Number(data[15].lasty_payroll_cost)).toFixed(2);data[15].year_thisy_payroll_cost=(Number(data[_index3].year_thisy_payroll_cost)+Number(data[15].year_thisy_payroll_cost)).toFixed(2);data[15].year_lasty_payroll_cost=(Number(data[_index3].year_lasty_payroll_cost)+Number(data[15].year_lasty_payroll_cost)).toFixed(2);}data[16].thisy_payroll_cost=(Number(data[11].thisy_payroll_cost)+Number(data[15].thisy_payroll_cost)).toFixed(2);data[16].lasty_payroll_cost=(Number(data[11].lasty_payroll_cost)+Number(data[15].lasty_payroll_cost)).toFixed(2);data[16].year_thisy_payroll_cost=(Number(data[11].year_thisy_payroll_cost)+Number(data[15].year_thisy_payroll_cost)).toFixed(2);data[16].year_lasty_payroll_cost=(Number(data[11].year_lasty_payroll_cost)+Number(data[15].year_lasty_payroll_cost)).toFixed(2);// 去除浮点 保留两位小数 
var toFixedData={11:['thisy_employee_num','thisy_payroll_cost','lasty_employee_num','lasty_payroll_cost','year_thisy_employee_num','year_thisy_payroll_cost','year_lasty_employee_num','year_lasty_payroll_cost'],15:['thisy_payroll_cost','lasty_payroll_cost','year_thisy_payroll_cost','year_lasty_payroll_cost'],16:['thisy_payroll_cost','lasty_payroll_cost','year_thisy_payroll_cost','year_lasty_payroll_cost']};for(var key in toFixedData){if(toFixedData.hasOwnProperty(key)){for(var _index4=0;_index4<toFixedData[key].length;_index4++){data[key][toFixedData[key][_index4]]=data[key][toFixedData[key][_index4]].toFixed(2);}}}// 计算百分比  **对比**
for(var _index5=0;_index5<20;_index5++){data[_index5].thisy_average_payroll=Number((Number(data[_index5].thisy_employee_num||"0")?Number(data[_index5].thisy_payroll_cost||"0")/Number(data[_index5].thisy_employee_num||"0"):0).toFixed(2));data[_index5].lasty_average_payroll=Number((Number(data[_index5].lasty_employee_num||"0")?Number(data[_index5].lasty_payroll_cost||"0")/Number(data[_index5].lasty_employee_num||"0"):0).toFixed(2));data[_index5].variance_emplyee_num=Number((data[_index5].thisy_employee_num-data[_index5].lasty_employee_num).toFixed(2));data[_index5].ven_percent=Number((Number(data[_index5].lasty_employee_num||"0")?Number(data[_index5].variance_emplyee_num||"0")/Number(data[_index5].lasty_employee_num||"0"):0).toFixed(4));data[_index5].variance_average_payroll=Number((data[_index5].thisy_average_payroll-data[_index5].lasty_average_payroll).toFixed(2));data[_index5].vap_percent=Number((Number(data[_index5].lasty_average_payroll||"0")?Number(data[_index5].variance_average_payroll||"0")/Number(data[_index5].lasty_average_payroll||"0"):0).toFixed(4));data[_index5].variance_payroll=Number((data[_index5].thisy_payroll_cost-data[_index5].lasty_payroll_cost).toFixed(2));data[_index5].vp_percent=Number((Number(data[_index5].lasty_payroll_cost||"0")?Number(data[_index5].variance_payroll||"0")/Number(data[_index5].lasty_payroll_cost||"0"):0).toFixed(4));// 年累计
data[_index5].year_thisy_average_payroll=Number((Number(data[_index5].year_thisy_employee_num||"0")?Number(data[_index5].year_thisy_payroll_cost||"0")/Number(data[_index5].year_thisy_employee_num||"0"):0).toFixed(2));data[_index5].year_lasty_average_payroll=Number((Number(data[_index5].year_lasty_employee_num||"0")?Number(data[_index5].year_lasty_payroll_cost||"0")/Number(data[_index5].year_lasty_employee_num||"0"):0).toFixed(2));data[_index5].year_variance_emplyee_num=Number((data[_index5].year_thisy_employee_num-data[_index5].year_lasty_employee_num).toFixed(2));data[_index5].year_ven_percent=Number((Number(data[_index5].year_lasty_employee_num||"0")?Number(data[_index5].year_variance_emplyee_num||"0")/Number(data[_index5].year_lasty_employee_num||"0"):0).toFixed(4));data[_index5].year_variance_average_payroll=Number((data[_index5].year_thisy_average_payroll-data[_index5].year_lasty_average_payroll).toFixed(2));data[_index5].year_vap_percent=Number((Number(data[_index5].year_lasty_average_payroll||"0")?Number(data[_index5].year_variance_average_payroll||"0")/Number(data[_index5].year_lasty_average_payroll||"0"):0).toFixed(4));data[_index5].year_variance_payroll=Number((data[_index5].year_thisy_payroll_cost-data[_index5].year_lasty_payroll_cost).toFixed(2));}data[20].thisy_payroll_cost=((0,_method.getJson)([8,'actual'],data1_1)==0?0:((0,_method.numConvert)(data[19].thisy_payroll_cost)+(0,_method.numConvert)((0,_method.getJson)([15,'actual'],data1_1)))/(0,_method.getJson)([8,'actual'],data1_1)).toFixed(4);data[20].lasty_payroll_cost=((0,_method.getJson)([8,'last_year'],data1_1)==0?0:((0,_method.numConvert)(data[19].lasty_payroll_cost)+(0,_method.numConvert)((0,_method.getJson)([15,'last_year'],data1_1)))/(0,_method.getJson)([8,'last_year'],data1_1)).toFixed(4);data[20].year_thisy_payroll_cost=((0,_method.getJson)([8,'year_actual'],data1_1)==0?0:((0,_method.numConvert)(data[19].year_thisy_payroll_cost)+(0,_method.numConvert)((0,_method.getJson)([15,'year_actual'],data1_1)))/(0,_method.getJson)([8,'year_actual'],data1_1)).toFixed(4);data[20].year_lasty_payroll_cost=((0,_method.getJson)([8,'year_last_year'],data1_1)==0?0:((0,_method.numConvert)(data[19].year_lasty_payroll_cost)+(0,_method.numConvert)((0,_method.getJson)([15,'year_last_year'],data1_1)))/(0,_method.getJson)([8,'year_last_year'],data1_1)).toFixed(4);_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data,{data1_1:_this.state.data1_1});};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data7_1_1);var data=JSON.parse(dataBegin);fetch('/_7_1_1_all?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data&&x.data.data.length>0){// 新增三行数据  进行兼容处理
if(x.data.data.length>17){data=x.data.data;}else{data=[].concat(_toConsumableArray(x.data.data),_toConsumableArray(JSON.parse(dataBegin).slice(JSON.parse(dataBegin).length-4,JSON.parse(dataBegin).length)));}}if(!data[0].id){_this.setState({loading:false,data:data,last:x.data.last||[],lastYear:x.data.lastYear||[],note:_extends({},x.data.note),data1_1:x.data.data1_1||[]},function(){_this.onSave();});return;}_this.setState({loading:false,last:x.data.last||[],lastYear:x.data.lastYear||[],note:_extends({},x.data.note),data1_1:x.data.data1_1||[]},function(){_this.computeNum(data);});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));dataFrom.append('year',year);dataFrom.append('month',month);dataFrom.append('isNew',data[0].id?1:2);var headres={method:'post',credentials:'include',headers:{},body:dataFrom};if(_this.state.note){_this.onSaveNote([_extends({},_this.state.note,{month:month,year:year})]);}fetch('/addPayrollCostByLevel',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.onSaveNote=function(data){var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_7_1_3',headres).then(function(x){return x.json();}).then(function(x){if(x.status!=1){_message3.default.error('备注保存失败：'+x.msg);}}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table7_1_1',1.5,'7.11',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],note:{note:""},loading:true,loadingSave:false,print:false,data1_1:[],lastYear:[],last:[]};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,data1_1=_state.data1_1,date=_state.date;var isOpenLastFill=(0,_moment2.default)(date).isBefore((0,_moment2.default)("2022-02"));var columns=[{title:'Level 职级',dataIndex:'name',key:'name',align:"center",fixed:"left",width:500,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this2.onChange,totalIndex:totalIndexFooter};return(// <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
//     {text}
// </div>
_react2.default.createElement(_TableText2.default,{data:props}));}},{title:'MTD 月累计',align:"center",width:1800,children:[{align:"center",title:'MTD Actual - This Year 本年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,'No. of Employee',_react2.default.createElement('br',null),'\u5458\u5DE5\u6570'),dataIndex:'thisy_employee_num',key:'thisy_employee_num',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - This Year 本年当月实际数','No. of Employee 员工数'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},'-');}if(index>=0&&index<=10){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'thisy_employee_num',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('thisy_employee_num',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'thisy_employee_num',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Average Payroll',_react2.default.createElement('br',null),'\u5E73\u5747\u5DE5\u8D44'),dataIndex:'thisy_average_payroll',key:'thisy_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - This Year 本年当月实际数','Average Payroll 平均工资'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},'-');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'thisy_average_payroll',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Payroll Cost',_react2.default.createElement('br',null),'\u5DE5\u8D44\u6210\u672C'),dataIndex:'thisy_payroll_cost',key:'thisy_payroll_cost',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - This Year 本年当月实际数','Payroll Cost 工资成本'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}if([11,15,16,19,20].includes(index)){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'thisy_payroll_cost',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement(_tooltip2.default,{title:index==16&&~~text!=~~_lodash2.default.get(data1_1,'[15].actual')?'该项设置ES 1.1的数据不一致，请检查':''},_react2.default.createElement('div',{className:' table-padding  '+([11,15,16,19].includes(index)?'table-color-footer':'')+' '+(index==16&&~~text!=~~_lodash2.default.get(data1_1,'[15].actual')?'yellowWaring':'')+' '},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','))));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'thisy_payroll_cost',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('thisy_payroll_cost',value,index);}})));}}}]},{align:"center",title:'MTD Actual - Last Year 去年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,'No. of Employee',_react2.default.createElement('br',null),'\u5458\u5DE5\u6570'),dataIndex:'lasty_employee_num',key:'lasty_employee_num',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - Last Year 去年当月实际数','No. of Employe 员工数'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},'-');}if(index>=0&&index<=10&&isOpenLastFill){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lasty_employee_num',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('lasty_employee_num',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lasty_employee_num',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Average Payroll',_react2.default.createElement('br',null),'\u5E73\u5747\u5DE5\u8D44'),dataIndex:'lasty_average_payroll',key:'lasty_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - Last Year 去年当月实际数','Average Payroll 平均工资'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},'-');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lasty_average_payroll',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Payroll Cost',_react2.default.createElement('br',null),'\u5DE5\u8D44\u6210\u672C'),dataIndex:'lasty_payroll_cost',key:'lasty_payroll_cost',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - Last Year 去年当月实际数','Payroll Cost 工资成本'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}if([11,15,16,19,20].includes(index)||!isOpenLastFill){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lasty_payroll_cost',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lasty_payroll_cost',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('lasty_payroll_cost',value,index);}})));}}}]},{align:"center",title:'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年',width:900,children:[{title:_react2.default.createElement('div',null,'No. of Employee',_react2.default.createElement('br',null),'\u5458\u5DE5\u6570'),dataIndex:'variance_emplyee_num',key:'variance_emplyee_num',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','No. of Employee 员工数'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},'-');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'variance_emplyee_num',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding  '+([11,15,16,19].includes(index)?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'ven_percent',key:'ven_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},'-');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ven_percent',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}},{title:_react2.default.createElement('div',null,'Average Payroll',_react2.default.createElement('br',null),'\u5E73\u5747\u5DE5\u8D44'),dataIndex:'variance_average_payroll',key:'variance_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','Average Payroll 平均工资'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},'-');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'variance_average_payroll',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'vap_percent',align:"center",key:'vap_percent',width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},'-');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'vap_percent',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}},{title:_react2.default.createElement('div',null,'Payroll Cost',_react2.default.createElement('br',null),'\u5DE5\u8D44\u6210\u672C'),dataIndex:'variance_payroll',key:'variance_payroll',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','Payroll Cost 工资成本'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'variance_payroll',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'vp_percent',key:'vp_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},'-');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'vp_percent',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding  '+([11,15,16,19].includes(index)?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}}]}]},{title:'YTD 年累计',align:"center",width:1650,children:[{align:"center",title:'YTD Actual - This Year 年累计实际 - 今年',width:450,children:[{title:_react2.default.createElement('div',null,'No. of Employee',_react2.default.createElement('br',null),'\u5458\u5DE5\u6570'),dataIndex:'year_thisy_employee_num',key:'year_thisy_employee_num',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - This Year 年累计实际 - 今年','No. of Employee 员工数'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},'-');}if(index>=0&&index<=10&&isOpenLastFill){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_thisy_employee_num',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('year_thisy_employee_num',value,index);},onCha:true})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_thisy_employee_num',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Average Payroll',_react2.default.createElement('br',null),'\u5E73\u5747\u5DE5\u8D44'),dataIndex:'year_thisy_average_payroll',key:'year_thisy_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - This Year 年累计实际 - 今年','Average Payroll 平均工资'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},'-');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_thisy_average_payroll',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Payroll Cost',_react2.default.createElement('br',null),'\u5DE5\u8D44\u6210\u672C'),dataIndex:'year_thisy_payroll_cost',key:'year_thisy_payroll_cost',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - This Year 年累计实际 - 今年','Payroll Cost 工资成本'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}if([11,15,16,19,20].includes(index)){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_thisy_payroll_cost',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement(_tooltip2.default,{title:index==16&&~~text!=~~_lodash2.default.get(data1_1,'[15].year_actual')?'该项设置ES 1.1的数据不一致，请检查':''},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')+' '+(index==16&&~~text!=~~_lodash2.default.get(data1_1,'[15].year_actual')?'yellowWaring':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','))));}else if(isOpenLastFill){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_thisy_payroll_cost',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('year_thisy_payroll_cost',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_thisy_payroll_cost',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}}]},{align:"center",title:'YTD Actual - Last Year 年累计实际 - 去年',width:450,children:[{title:_react2.default.createElement('div',null,'No. of Employee',_react2.default.createElement('br',null),'\u5458\u5DE5\u6570'),dataIndex:'year_lasty_employee_num',key:'year_lasty_employee_num',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - Last Year 年累计实际 - 去年','No. of Employee 员工数'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},'-');}if(index>=0&&index<=10&&isOpenLastFill){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_lasty_employee_num',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('year_lasty_employee_num',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_lasty_employee_num',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Average Payroll',_react2.default.createElement('br',null),'\u5E73\u5747\u5DE5\u8D44'),dataIndex:'year_lasty_average_payroll',key:'year_lasty_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - Last Year 年累计实际 - 去年','Average Payroll 平均工资'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},'-');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_lasty_average_payroll',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Payroll Cost',_react2.default.createElement('br',null),'\u5DE5\u8D44\u6210\u672C'),dataIndex:'year_lasty_payroll_cost',key:'year_lasty_payroll_cost',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - Last Year 年累计实际 - 去年','Payroll Cost 工资成本'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}if([11,15,16,19,20].includes(index)){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_lasty_payroll_cost',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}else if(isOpenLastFill){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_lasty_payroll_cost',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('year_lasty_payroll_cost',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_lasty_payroll_cost',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}}]},{align:"center",title:'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',width:750,children:[{title:_react2.default.createElement('div',null,'No. of Employee',_react2.default.createElement('br',null),'\u5458\u5DE5\u6570'),dataIndex:'year_variance_emplyee_num',key:'year_variance_emplyee_num',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','No. of Employee 员工数'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},'-');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_variance_emplyee_num',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding  '+([11,15,16,19].includes(index)?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'year_ven_percent',key:'year_ven_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},'-');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_ven_percent',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}},{title:_react2.default.createElement('div',null,'Average Payroll',_react2.default.createElement('br',null),'\u5E73\u5747\u5DE5\u8D44'),dataIndex:'year_variance_average_payroll',key:'year_variance_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','Average Payroll 平均工资'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_variance_average_payroll',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'year_vap_percent',align:"center",key:'year_vap_percent',width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},'-');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_vap_percent',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}},{title:_react2.default.createElement('div',null,'Payroll Cost',_react2.default.createElement('br',null),'\u5DE5\u8D44\u6210\u672C'),dataIndex:'year_variance_payroll',key:'year_variance_payroll',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','Payroll Cost 工资成本 '];if(index==20){return _react2.default.createElement('div',{className:'table-padding'},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_variance_payroll',title:title,sqlName:"payroll_cost_by_level",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+([11,15,16,19].includes(index)?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}// , {
//     title: '% 百分比',
//     dataIndex: 'year_vp_percent',
//     key: 'year_vp_percent',
//     align: "center",
//     render: (text, record, index) => {
//         return (
//             <div className={`table-padding  ${[11,15,16,19].includes(index) ? 'table-color-footer' : ''}`} >
//                 {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
//             </div>
//         )
//     }
// }
}]}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table7_1_1',style:{width:this.state.print?4150:'auto'}},_react2.default.createElement(_row2.default,null,'7.1.1 Payroll Cost By Level \u85AA\u916C\u6309\u7167\u804C\u7EA7\u5206\u6790'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],note:{note:""},loading:true});_this2.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',style:{width:this.state.print?3950:'auto'},scroll:this.state.print?{}:{x:3950,y:500},rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_row2.default,{style:{margin:"20px 0",fontSize:16}},_react2.default.createElement(_row2.default,null,'Please critique if variance above +/- 5% \u82E5\u5DEE\u5F02\u6570\u8D85\u8FC7\u4E0A\u4E0B\u767E\u5206\u4E4B\u4E94\u5219\u9700\u505A\u51FA\u4E66\u9762\u89E3\u91CA'),_react2.default.createElement(_row2.default,{style:{margin:"10px 0"}},'Remarks: To include any salary adjustment for B2 and above positions for current month \u5907\u6CE8\uFF1A\u82E5\u672C\u6708\u6709\u4EFB\u4F55B2\u7EA7\u4EE5\u4E0A\u4EBA\u5458\u85AA\u8D44\u8C03\u6574\uFF0C\u5FC5\u987B\u5728\u5982\u4E0B\u8868\u683C\u4E2D\u6CE8\u660E\u539F\u56E0'),this.state.data.length>0?_react2.default.createElement(TextArea,{rows:4,placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',defaultValue:this.state.note.note,onBlur:function onBlur(e){_this2.setState({note:_extends({},_this2.state.note,{note:e.target.value})});}}):null)),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_7_1'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data7_1_1=exports.data7_1_1=[{name:'SE',name_code:"SE",thisy_employee_num:0,//当月实际 员工数
thisy_average_payroll:0,//当月实际 平均薪酬
thisy_payroll_cost:0,//当月实际 薪酬成本
lasty_employee_num:0,//去年当月实际 员工数
lasty_average_payroll:0,//去年当月实际 平均薪酬
lasty_payroll_cost:0,//去年当月实际 薪酬成本
variance_emplyee_num:0,//今年对比去年 员工数
ven_percent:0,//今年对比去年 百分比
variance_average_payroll:0,//今年对比去年 平均薪酬
vap_percent:0,//今年对比去年 百分比
variance_payroll:0,//今年对比去年 薪酬成本
vp_percent:0,//今年对比去年 百分比
year_thisy_employee_num:0,//年累计 今年 员工数
year_thisy_average_payroll:0,//年累计 今年 平均薪酬
year_thisy_payroll_cost:0,//年累计 今年 薪酬成本
year_lasty_employee_num:0,//年累计 去年 员工数
year_lasty_average_payroll:0,//年累计 去年 平均薪酬
year_lasty_payroll_cost:0,//年累计 去年 薪酬成本
year_variance_emplyee_num:0,//年累计 今年对比去年 员工数
year_ven_percent:0,//年累计 今年对比去年 百分比
year_variance_average_payroll:0,//年累计 今年对比去年 平均薪酬
year_vap_percent:0,//年累计 今年对比去年 百分比
year_variance_payroll:0,//年累计 今年对比去年 薪酬成本
year_vp_percent:0//年累计 今年对比去年 百分比
},{name:'A1',name_code:"A1",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'A2',name_code:"A2",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'B1',name_code:"B1",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'B2',name_code:"B2",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'SS',name_code:"SS",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'S',name_code:"S",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'G1',name_code:"G1",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'G2',name_code:"G2",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'C',name_code:"C",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'T',name_code:"T",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'Payroll Total 工资合计',name_code:"Payroll_Total",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'Social Insurance and Housing Fund 五险一金',name_code:"Social_Insurance_and_Housing_Fund",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'Incentive Program/Bonus Provision 绩效考核奖金/年终奖预提',name_code:"Bonus/Incentive_Provision",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:"Other Related Expenses 其他相关福利费用<br/>(包括合同津贴，交通、住宿、通讯补贴， 加班工资，法定假期，工作餐费等)",name_code:"Other_Related_Expenses",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'Payroll Related Expenses 薪酬相关福利费用合计',name_code:"Payroll_Related_Expenses",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'Total Payroll and Expenses 薪酬及相关福利合计',name_code:"Total_Payroll_and_Expenses",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'F&B 酒店餐饮劳务费用（包括劳务外包及帮工费用）',name_code:"",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'Rooms 酒店房务劳务费用（包括劳务外包及帮工费用）',name_code:"",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'Total Labor Outsourcing Expenses 酒店劳务费用合计',name_code:"",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'酒店总人工成本及劳务费用占比 %',name_code:"",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0}];var data7_1_2=exports.data7_1_2=[{name:'Rooms 客房',name_code:"Rooms",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'Administration& General 行政办 、财务、保安',name_code:"Administration_General",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'Human Resources 人力资源部',name_code:"Human_Resources",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'Sales & Marketing 市场销售部',name_code:"Sales_Marketing",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'Property Operation & Maintenance 工程部',name_code:"Property_Operation_Maintenance",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'Other Operated Departments 其它运营部门',name_code:"Other_Operated_Departments",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'Payroll Total 工资合计',name_code:"Payroll_Total",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0}];

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(703);var _data=__webpack_require__(704);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _method=__webpack_require__(20);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var _this$state=_this.state,last=_this$state.last,lastYear=_this$state.lastYear;var isOpenLastFill=(0,_moment2.default)(_this.state.date).isBefore((0,_moment2.default)("2022-02"));// 薪酬合计
var totalData=['thisy_employee_num','thisy_payroll_cost','lasty_employee_num','lasty_payroll_cost','year_thisy_employee_num','year_thisy_payroll_cost','year_lasty_employee_num','year_lasty_payroll_cost'];// 填充年累计
if(!isOpenLastFill){//填充去年当月
for(var i=0;i<data.length;i++){data[i].lasty_employee_num=(0,_method.numConvert)(_lodash2.default.get(lastYear,i+'.thisy_employee_num',0)).toFixed(2);data[i].lasty_average_payroll=(0,_method.numConvert)(_lodash2.default.get(lastYear,i+'.thisy_average_payroll',0)).toFixed(2);data[i].lasty_payroll_cost=(0,_method.numConvert)(_lodash2.default.get(lastYear,i+'.thisy_payroll_cost',0)).toFixed(2);}for(var _i=0;_i<data.length;_i++){data[_i].year_thisy_employee_num=(0,_method.sum)([data[_i].thisy_employee_num,_lodash2.default.get(last,_i+'.year_thisy_employee_num',0)]);data[_i].year_thisy_payroll_cost=(0,_method.sum)([data[_i].thisy_payroll_cost,_lodash2.default.get(last,_i+'.year_thisy_payroll_cost',0)]);data[_i].year_lasty_employee_num=(0,_method.sum)([data[_i].lasty_employee_num,_lodash2.default.get(last,_i+'.year_lasty_employee_num',0)]);data[_i].year_lasty_payroll_cost=(0,_method.sum)([data[_i].lasty_payroll_cost,_lodash2.default.get(last,_i+'.year_lasty_payroll_cost',0)]);}}for(var _index=0;_index<totalData.length;_index++){data[7][totalData[_index]]=0;}for(var _index2=0;_index2<7;_index2++){for(var _i2=0;_i2<totalData.length;_i2++){data[7][totalData[_i2]]=Number(data[_index2][totalData[_i2]])+Number(data[7][totalData[_i2]]);}}var toFixedData={7:['thisy_employee_num','thisy_payroll_cost','lasty_employee_num','lasty_payroll_cost','year_thisy_employee_num','year_thisy_payroll_cost','year_lasty_employee_num','year_lasty_payroll_cost']};for(var key in toFixedData){if(toFixedData.hasOwnProperty(key)){for(var _index3=0;_index3<toFixedData[key].length;_index3++){data[key][toFixedData[key][_index3]]=data[key][toFixedData[key][_index3]].toFixed(2);}}}// 计算百分比  **对比**
for(var _index4=0;_index4<data.length;_index4++){data[_index4].thisy_average_payroll=Number((Number(data[_index4].thisy_employee_num||"0")?Number(data[_index4].thisy_payroll_cost||"0")/Number(data[_index4].thisy_employee_num||"0"):0).toFixed(2));data[_index4].lasty_average_payroll=Number((Number(data[_index4].lasty_employee_num||"0")?Number(data[_index4].lasty_payroll_cost||"0")/Number(data[_index4].lasty_employee_num||"0"):0).toFixed(2));data[_index4].variance_emplyee_num=Number((data[_index4].thisy_employee_num-data[_index4].lasty_employee_num).toFixed(2));data[_index4].ven_percent=Number((Number(data[_index4].lasty_employee_num||"0")?Number(data[_index4].variance_emplyee_num||"0")/Number(data[_index4].lasty_employee_num||"0"):0).toFixed(4));data[_index4].variance_average_payroll=Number((data[_index4].thisy_average_payroll-data[_index4].lasty_average_payroll).toFixed(2));data[_index4].vap_percent=Number((Number(data[_index4].lasty_average_payroll||"0")?Number(data[_index4].variance_average_payroll||"0")/Number(data[_index4].lasty_average_payroll||"0"):0).toFixed(4));data[_index4].variance_payroll=Number((data[_index4].thisy_payroll_cost-data[_index4].lasty_payroll_cost).toFixed(2));data[_index4].vp_percent=Number((Number(data[_index4].lasty_payroll_cost||"0")?Number(data[_index4].variance_payroll||"0")/Number(data[_index4].lasty_payroll_cost||"0"):0).toFixed(4));// 年累计
data[_index4].year_thisy_average_payroll=Number((Number(data[_index4].year_thisy_employee_num||"0")?Number(data[_index4].year_thisy_payroll_cost||"0")/Number(data[_index4].year_thisy_employee_num||"0"):0).toFixed(2));data[_index4].year_lasty_average_payroll=Number((Number(data[_index4].year_lasty_employee_num||"0")?Number(data[_index4].year_lasty_payroll_cost||"0")/Number(data[_index4].year_lasty_employee_num||"0"):0).toFixed(2));data[_index4].year_variance_emplyee_num=Number((data[_index4].year_thisy_employee_num-data[_index4].year_lasty_employee_num).toFixed(2));data[_index4].year_ven_percent=Number((Number(data[_index4].year_lasty_employee_num||"0")?Number(data[_index4].year_variance_emplyee_num||"0")/Number(data[_index4].year_lasty_employee_num||"0"):0).toFixed(4));data[_index4].year_variance_average_payroll=Number((data[_index4].year_thisy_average_payroll-data[_index4].year_lasty_average_payroll).toFixed(2));data[_index4].year_vap_percent=Number((Number(data[_index4].year_lasty_average_payroll||"0")?Number(data[_index4].year_variance_average_payroll||"0")/Number(data[_index4].year_lasty_average_payroll||"0"):0).toFixed(4));data[_index4].year_variance_payroll=Number((data[_index4].year_thisy_payroll_cost-data[_index4].year_lasty_payroll_cost).toFixed(2));}_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;// this.setState({
//     data
// });
_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data7_1_2);var data=JSON.parse(dataBegin);fetch('/_7_1_2_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data&&x.data.data.length>0){data=x.data.data;}if(!data[0].id){_this.setState({loading:false,data:data},function(){_this.onSave();});return;}_this.setState({loading:false,last:x.data.last||[],lastYear:x.data.lastYear||[]},function(){_this.computeNum(data);});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));dataFrom.append('year',year);dataFrom.append('month',month);dataFrom.append('isNew',data[0].id?1:2);var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_7_1_2',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table7_1_2',1.5,'7.12',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,lastYear:[],last:[]};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);// this.computeNum(this.state.data)
}},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,date=_state.date;var isOpenLastFill=(0,_moment2.default)(date).isBefore((0,_moment2.default)("2022-02"));var columns=[{title:'Department 部门',dataIndex:'name',key:'name',align:"center",fixed:"left",width:350,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':''),style:{textAlign:"left"}},text);}},{title:'Current Month 本年当月',align:"center",children:[{align:"center",title:'MTD Actual - This Year 本年当月实际数',children:[{title:_react2.default.createElement('div',null,'No. of Employee',_react2.default.createElement('br',null),'\u5458\u5DE5\u6570'),dataIndex:'thisy_employee_num',key:'thisy_employee_num',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','MTD Actual - This Year 本年当月实际数','No. of Employee 员工数'];if(index>=0&&index<=6){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'thisy_employee_num',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('thisy_employee_num',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'thisy_employee_num',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Average Payroll',_react2.default.createElement('br',null),'\u5E73\u5747\u85AA\u916C'),dataIndex:'thisy_average_payroll',key:'thisy_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','MTD Actual - This Year 本年当月实际数','Average Payroll 平均薪酬'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'thisy_average_payroll',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Payroll Cost',_react2.default.createElement('br',null),'\u85AA\u916C\u6210\u672C'),dataIndex:'thisy_payroll_cost',key:'thisy_payroll_cost',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','MTD Actual - This Year 本年当月实际数','Payroll Cost 薪酬成本'];if(index==7||index==15||index==16){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'thisy_payroll_cost',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'thisy_payroll_cost',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('thisy_payroll_cost',value,index);}})));}}}]},{align:"center",title:'MTD Actual - Last Year 去年当月实际数',children:[{title:_react2.default.createElement('div',null,'No. of Employee',_react2.default.createElement('br',null),'\u5458\u5DE5\u6570'),dataIndex:'lasty_employee_num',key:'lasty_employee_num',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','MTD Actual - Last Year 去年当月实际数','No. of Employee 员工数'];if(index>=0&&index<=6&&isOpenLastFill){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lasty_employee_num',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('lasty_employee_num',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lasty_employee_num',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Average Payroll',_react2.default.createElement('br',null),'\u5E73\u5747\u85AA\u916C'),dataIndex:'lasty_average_payroll',key:'lasty_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','MTD Actual - Last Year 去年当月实际数','Average Payroll 平均薪酬'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lasty_average_payroll',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Payroll Cost',_react2.default.createElement('br',null),'\u85AA\u916C\u6210\u672C'),dataIndex:'lasty_payroll_cost',key:'lasty_payroll_cost',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','MTD Actual - Last Year 去年当月实际数','Payroll Cost 薪酬成本'];if(index==7||index==15||index==16||!isOpenLastFill){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lasty_payroll_cost',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lasty_payroll_cost',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('lasty_payroll_cost',value,index);}})));}}}]},{align:"center",title:'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年',children:[{title:_react2.default.createElement('div',null,'No. of Employee',_react2.default.createElement('br',null),'\u5458\u5DE5\u6570'),dataIndex:'variance_emplyee_num',key:'variance_emplyee_num',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','No. of Employee 员工数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'variance_emplyee_num',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding  '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'ven_percent',key:'ven_percent',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ven_percent',title:title,sqlName:"_7_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}},{title:_react2.default.createElement('div',null,'Average Payroll',_react2.default.createElement('br',null),'\u5E73\u5747\u85AA\u916C'),dataIndex:'variance_average_payroll',key:'variance_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','Average Payroll 平均薪酬'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'variance_average_payroll',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'vap_percent',align:"center",key:'vap_percent',width:150,render:function render(text,record,index){var title=['Current Month 本年当月','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'vap_percent',title:title,sqlName:"_7_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}},{title:_react2.default.createElement('div',null,'Payroll Cost',_react2.default.createElement('br',null),'\u85AA\u916C\u6210\u672C'),dataIndex:'variance_payroll',key:'variance_payroll',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','Payroll Cost 薪酬成本'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'variance_payroll',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'vp_percent',key:'vp_percent',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'vp_percent',title:title,sqlName:"_7_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding  '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}}]}]},{title:'YTD 年累计',align:"center",children:[{align:"center",title:'YTD Actual - This Year 年累计实际 - 今年',children:[{title:_react2.default.createElement('div',null,'No. of Employee',_react2.default.createElement('br',null),'\u5458\u5DE5\u6570'),dataIndex:'year_thisy_employee_num',key:'year_thisy_employee_num',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - This Year 年累计实际 - 今年','No. of Employee 员工数'];if(index>=0&&index<=6&&isOpenLastFill){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_thisy_employee_num',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('year_thisy_employee_num',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_thisy_employee_num',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Average Payroll',_react2.default.createElement('br',null),'\u5E73\u5747\u85AA\u916C'),dataIndex:'year_thisy_average_payroll',key:'year_thisy_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - This Year 年累计实际 - 今年','Average Payroll 平均薪酬'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_thisy_average_payroll',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Payroll Cost',_react2.default.createElement('br',null),'\u85AA\u916C\u6210\u672C'),dataIndex:'year_thisy_payroll_cost',key:'year_thisy_payroll_cost',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - This Year 年累计实际 - 今年','Payroll Cost 薪酬成本'];if(index==7||index==15||index==16||!isOpenLastFill){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_thisy_payroll_cost',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_thisy_payroll_cost',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('year_thisy_payroll_cost',value,index);}})));}}}]},{align:"center",title:'YTD Actual - Last Year 年累计实际 - 去年',children:[{title:_react2.default.createElement('div',null,'No. of Employee',_react2.default.createElement('br',null),'\u5458\u5DE5\u6570'),dataIndex:'year_lasty_employee_num',key:'year_lasty_employee_num',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - Last Year 年累计实际 - 去年','No. of Employee 员工数'];if(index>=0&&index<=6&&isOpenLastFill){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_lasty_employee_num',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('year_lasty_employee_num',value,index);},onCha:true})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_lasty_employee_num',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Average Payroll',_react2.default.createElement('br',null),'\u5E73\u5747\u85AA\u916C'),dataIndex:'year_lasty_average_payroll',key:'year_lasty_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - Last Year 年累计实际 - 去年','Average Payroll 平均薪酬'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_lasty_average_payroll',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Payroll Cost',_react2.default.createElement('br',null),'\u85AA\u916C\u6210\u672C'),dataIndex:'year_lasty_payroll_cost',key:'year_lasty_payroll_cost',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - Last Year 年累计实际 - 去年','Payroll Cost 薪酬成本'];if(index==7||index==15||index==16||!isOpenLastFill){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_lasty_payroll_cost',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_lasty_payroll_cost',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('year_lasty_payroll_cost',value,index);}})));}}}]},{align:"center",title:'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',children:[{title:_react2.default.createElement('div',null,'No. of Employee',_react2.default.createElement('br',null),'\u5458\u5DE5\u6570'),dataIndex:'year_variance_emplyee_num',key:'year_variance_emplyee_num',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','No. of Employee 员工数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_variance_emplyee_num',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding  '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'year_ven_percent',key:'year_ven_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_ven_percent',title:title,sqlName:"_7_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}},{title:_react2.default.createElement('div',null,'Average Payroll',_react2.default.createElement('br',null),'\u5E73\u5747\u85AA\u916C'),dataIndex:'year_variance_average_payroll',key:'year_variance_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','Average Payroll 平均薪酬'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_variance_average_payroll',title:title,sqlName:"_7_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'year_vap_percent',align:"center",key:'year_vap_percent',width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_vap_percent',title:title,sqlName:"_7_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}},{title:_react2.default.createElement('div',null,'Payroll Cost',_react2.default.createElement('br',null),'\u85AA\u916C\u6210\u672C'),dataIndex:'year_variance_payroll',key:'year_variance_payroll',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','Payroll Cost 薪酬成本'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_variance_payroll',title:title,sqlName:"_7_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}]}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table7_1_2',style:{width:this.state.print?3800:'auto'}},_react2.default.createElement(_row2.default,null,'7.1.2 Payroll Cost By Department \u85AA\u916C\u6309\u7167\u90E8\u95E8\u5206\u6790, \u4E0D\u542B\u76F8\u5173\u798F\u5229\u53CA\u8D39\u7528'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[]});_this2.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',style:{width:this.state.print?3750:'auto'},scroll:this.state.print?{}:{x:3750},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_7_1'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data7_1_2=exports.data7_1_2=[{name:'Rooms 客房',name_code:"Rooms",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0},{name:'Administration& General 行政办 、财务、保安',name_code:"Administration_General",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0},{name:'Human Resources 人力资源部',name_code:"Human_Resources",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0},{name:'Sales & Marketing 市场销售部',name_code:"Sales_Marketing",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0},{name:'Property Operation & Maintenance 工程部',name_code:"Property_Operation_Maintenance",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0},{name:'Other Operated Departments 其它运营部门',name_code:"Other_Operated_Departments",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0},{name:'Total 合计',name_code:"Payroll_Total",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0}];

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getChart2=exports.getChart=undefined;var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _method=__webpack_require__(20);var _analysis=__webpack_require__(125);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var getChart=exports.getChart=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(year){var _ref2,_ref2$data,_ref2$data$data,data,_ref2$data$area,area,_ref2$data$last,last,dataX;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_request2.default)('/chartData7_5_1?year='+year);case 2:_ref2=_context.sent;_ref2$data=_ref2.data;_ref2$data$data=_ref2$data.data;data=_ref2$data$data===undefined?[]:_ref2$data$data;_ref2$data$area=_ref2$data.area;area=_ref2$data$area===undefined?[]:_ref2$data$area;_ref2$data$last=_ref2$data.last;last=_ref2$data$last===undefined?[]:_ref2$data$last;dataX=new Array(12).fill(1).map(function(x,i){return i+1+'\u6708';});(0,_analysis.setKarte)({id:"row1",title:"年假人均天数",color:['#00C5BD','#42585D','#FE5F5F'],dataX:dataX,dataY:[{name:"今年",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.find(function(_x){return _x.month==i+1;}),'thisy_average_payroll',0)).toFixed(2);})},{name:"去年",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.find(function(_x){return _x.month==i+1;}),'lasty_average_payroll',0)).toFixed(2);})},{name:"区域",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(area.find(function(_x){return _x.month==i+1;}),'thisy_average_payroll',0)).toFixed(2);})}]});case 12:case'end':return _context.stop();}}},_callee,undefined);}));return function getChart(_x2){return _ref.apply(this,arguments);};}();var getChart2=exports.getChart2=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(year){var _ref4,_ref4$data,_ref4$data$data,data,_ref4$data$area,area,_ref4$data$last,last,dataX;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return(0,_request2.default)('/chartData7_5_2?year='+year);case 2:_ref4=_context2.sent;_ref4$data=_ref4.data;_ref4$data$data=_ref4$data.data;data=_ref4$data$data===undefined?[]:_ref4$data$data;_ref4$data$area=_ref4$data.area;area=_ref4$data$area===undefined?[]:_ref4$data$area;_ref4$data$last=_ref4$data.last;last=_ref4$data$last===undefined?[]:_ref4$data$last;dataX=new Array(12).fill(1).map(function(x,i){return i+1+'\u6708';});console.log(data);(0,_analysis.setKarte)({id:"row2",title:"加班人均小时数",color:['#00C5BD','#42585D','#FE5F5F'],dataX:dataX,dataY:[{name:"今年",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.find(function(_x){return _x.month==i+1;}),'year_thisy_average_payroll',0)).toFixed(2);})},{name:"去年",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.find(function(_x){return _x.month==i+1;}),'year_lasty_average_payroll',0)).toFixed(2);})},{name:"区域",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(area.find(function(_x){return _x.month==i+1;}),'year_thisy_average_payroll',0)).toFixed(2);})}]});case 13:case'end':return _context2.stop();}}},_callee2,undefined);}));return function getChart2(_x3){return _ref3.apply(this,arguments);};}();

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var inputIndex=[1,2,3,4,5,6,10,13,14,15,16,17,18,22,25,26,27,28,29,30,34,37,38,39,40,41,42,46,53,54];var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var getJson=function getJson(arr,obj){var value=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;return arr.reduce(function(a,b){return a&&a[b]?a[b]:value;},obj);};var computeNum=function computeNum(data){var dataTitle=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var listName=['shop','Chinese','Thai','banquet','lounge','stewarding','others'];// total计算
inputIndex.forEach(function(i){data[i].total=listName.reduce(function(a,b){a+=numConvert(data[i][b]);return a;},0).toFixed(2);});['total'].concat(listName,['last','rooms','last_total']).forEach(function(name){data[7][name]=(numConvert(data[1][name])+numConvert(data[2][name])+numConvert(data[3][name])-numConvert(data[4][name])-numConvert(data[5][name])-numConvert(data[6][name])).toFixed(2);data[8][name]=(numConvert(data[1][name])+numConvert(data[6][name])==0?0:numConvert(data[7][name])/((numConvert(data[1][name])+numConvert(data[6][name]))/2)).toFixed(4);data[9][name]=(numConvert(data[7].total)==0?0:numConvert(data[7][name])/numConvert(data[7].total)).toFixed(4);data[11][name]=(numConvert(data[7][name])-numConvert(data[10][name])).toFixed(2);data[19][name]=(numConvert(data[13][name])+numConvert(data[14][name])+numConvert(data[15][name])-numConvert(data[16][name])-numConvert(data[17][name])-numConvert(data[18][name])).toFixed(2);data[20][name]=(numConvert(data[13][name])+numConvert(data[18][name])==0?0:numConvert(data[19][name])/((numConvert(data[13][name])+numConvert(data[18][name]))/2)).toFixed(4);data[21][name]=(numConvert(data[19].total)==0?0:numConvert(data[19][name])/numConvert(data[19].total)).toFixed(4);data[23][name]=(numConvert(data[19][name])-numConvert(data[22][name])).toFixed(2);data[31][name]=(numConvert(data[25][name])+numConvert(data[26][name])+numConvert(data[27][name])-numConvert(data[28][name])-numConvert(data[29][name])-numConvert(data[30][name])).toFixed(2);data[32][name]=(numConvert(data[25][name])+numConvert(data[30][name])==0?0:numConvert(data[31][name])/((numConvert(data[25][name])+numConvert(data[30][name]))/2)).toFixed(4);data[33][name]=(numConvert(data[31].total)==0?0:numConvert(data[31][name])/numConvert(data[31].total)).toFixed(4);data[35][name]=(numConvert(data[31][name])-numConvert(data[34][name])).toFixed(2);data[43][name]=(numConvert(data[37][name])+numConvert(data[38][name])+numConvert(data[39][name])-numConvert(data[40][name])-numConvert(data[41][name])-numConvert(data[42][name])).toFixed(2);data[44][name]=(numConvert(data[37][name])+numConvert(data[42][name])==0?0:numConvert(data[43][name])/((numConvert(data[37][name])+numConvert(data[42][name]))/2)).toFixed(4);data[45][name]=(numConvert(data[43].total)==0?0:numConvert(data[43][name])/numConvert(data[43].total)).toFixed(4);data[47][name]=(numConvert(data[43][name])-numConvert(data[46][name])).toFixed(2);data[48][name]=(numConvert(data[7][name])+numConvert(data[19][name])+numConvert(data[31][name])+numConvert(data[43][name])).toFixed(2);var Denominator=(numConvert(data[1][name])+numConvert(data[6][name]))/2+(numConvert(data[13][name])+numConvert(data[18][name]))/2+(numConvert(data[25][name])+numConvert(data[30][name]))/2+(numConvert(data[37][name])+numConvert(data[42][name]))/2;data[49][name]=(Denominator==0?0:numConvert(data[48][name])/Denominator).toFixed(4);data[50][name]=(numConvert(data[48].total)==0?0:numConvert(data[48][name])/numConvert(data[48].total)).toFixed(4);data[51][name]=(numConvert(data[10][name])+numConvert(data[22][name])+numConvert(data[34][name])+numConvert(data[46][name])).toFixed(2);data[52][name]=(numConvert(data[11][name])+numConvert(data[23][name])+numConvert(data[35][name])+numConvert(data[47][name])).toFixed(2);data[55][name]=(numConvert(data[53][name])==0?0:numConvert(data[48][name])/numConvert(data[53][name])).toFixed(2);data[55][name]=(numConvert(data[53][name])==0?0:numConvert(data[48][name])/numConvert(data[53][name])).toFixed(2);data[56][name]=(getJson([0,'day'],dataTitle)==0?0:data[48][name]/getJson([0,'day'],dataTitle)).toFixed(2);data[57][name]=(numConvert(data[54][name])==0?0:numConvert(data[51][name])/numConvert(data[54][name])).toFixed(4);data[58][name]=(numConvert(data[54][name])==0?0:numConvert(data[52][name])/numConvert(data[54][name])).toFixed(4);[7,19,31,43,48,53,54].forEach(function(i){data[i].var=(numConvert(data[i].last)==0?0:(numConvert(data[i].total)-numConvert(data[i].last))/numConvert(data[i].last)).toFixed(4);data[i].last_var=(numConvert(data[i].last_total)==0?0:(numConvert(data[i].rooms)-numConvert(data[i].last_total))/numConvert(data[i].last_total)).toFixed(4);});[8,20,32,44,49,55,56,57,58].forEach(function(i){data[i].var=(numConvert(data[i].total)-numConvert(data[i].last)).toFixed(4);data[i].last_var=(numConvert(data[i].rooms)-numConvert(data[i].last_total)).toFixed(4);});});return data;};exports.default=computeNum;

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(60);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Center=__webpack_require__(2072);var _Center2=_interopRequireDefault(_Center);var _Left=__webpack_require__(2073);var _Left2=_interopRequireDefault(_Left);var _Right=__webpack_require__(2074);var _Right2=_interopRequireDefault(_Right);__webpack_require__(2075);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"BI_title"},_react2.default.createElement(_col2.default,{span:8},_react2.default.createElement(_Left2.default,{data:this.props.data})),_react2.default.createElement(_col2.default,{span:8},_react2.default.createElement(_Center2.default,{data:this.props.data})),_react2.default.createElement(_col2.default,{span:8},_react2.default.createElement(_Right2.default,{data:this.props.data})));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(312);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);__webpack_require__(213);var _method=__webpack_require__(20);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _method2=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().format('D')<=10?(0,_moment2.default)().subtract(2,'month').format('YYYY-MM'):(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],note:{note:""},loading:true,loadingSave:false,print:false,isUpdate:false,dataAll:{}},_this.computeNum=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(data,_ref3,date){var _ref3$sum1_=_ref3.sum1_1,sum1_1=_ref3$sum1_===undefined?{}:_ref3$sum1_,_ref3$inter_sum1_=_ref3.inter_sum1_1,inter_sum1_1=_ref3$inter_sum1_===undefined?{}:_ref3$inter_sum1_,_ref3$es1_=_ref3.es1_1,es1_1=_ref3$es1_===undefined?[]:_ref3$es1_,_ref3$es5_1_=_ref3.es5_1_2,es5_1_2=_ref3$es5_1_===undefined?[]:_ref3$es5_1_,_ref3$es9_8_=_ref3.es9_8_1,es9_8_1=_ref3$es9_8_===undefined?[]:_ref3$es9_8_,_ref3$banquet=_ref3.banquet,banquet=_ref3$banquet===undefined?{}:_ref3$banquet,_ref3$outlets=_ref3.outlets,outlets=_ref3$outlets===undefined?{}:_ref3$outlets,_ref3$purchase=_ref3.purchase,purchase=_ref3$purchase===undefined?0:_ref3$purchase,_ref3$Chinese=_ref3.Chinese,Chinese=_ref3$Chinese===undefined?{}:_ref3$Chinese,_ref3$coffee=_ref3.coffee,coffee=_ref3$coffee===undefined?{}:_ref3$coffee,_ref3$inter_banquet=_ref3.inter_banquet,inter_banquet=_ref3$inter_banquet===undefined?{}:_ref3$inter_banquet,_ref3$inter_outlets=_ref3.inter_outlets,inter_outlets=_ref3$inter_outlets===undefined?{}:_ref3$inter_outlets,_ref3$inter_purchase=_ref3.inter_purchase,inter_purchase=_ref3$inter_purchase===undefined?0:_ref3$inter_purchase,_ref3$inter_Chinese=_ref3.inter_Chinese,inter_Chinese=_ref3$inter_Chinese===undefined?{}:_ref3$inter_Chinese,_ref3$inter_coffee=_ref3.inter_coffee,inter_coffee=_ref3$inter_coffee===undefined?{}:_ref3$inter_coffee;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// 区域平台数据
data[0].area=(0,_method.calculation)(sum1_1['Rooms Revenue 客房收入'],sum1_1['Total Revenue 总收入'],4).toFixed(3);data[1].area=(0,_method.calculation)(sum1_1['F&B Revenue 餐饮收入'],sum1_1['Total Revenue 总收入'],4).toFixed(3);data[2].area=(0,_method.calculation)(sum1_1['Other Revenue 其他部门收入'],sum1_1['Total Revenue 总收入'],4).toFixed(3);data[3].area=(0,_method.calculation)(sum1_1["Rooms Dep't Profit 客房部门利润"],sum1_1['Rooms Revenue 客房收入'],4).toFixed(3);data[4].area=(0,_method.calculation)(sum1_1["F&B Dep't Profit 餐饮部门利润"],sum1_1["F&B Revenue 餐饮收入"],4).toFixed(3);data[5].area=(0,_method.calculation)(sum1_1["F&B Total Cost 食品及饮品成本"],sum1_1["F&B Revenue 餐饮收入"],4).toFixed(3);data[7].area=(0,_method.calculation)(coffee['cost'],coffee['REV'],4).toFixed(3);data[6].area=(0,_method.calculation)(coffee['REV'],outlets['REV'],4).toFixed(3);data[9].area=(0,_method.calculation)(Chinese['cost'],Chinese['REV'],4).toFixed(3);data[8].area=(0,_method.calculation)(Chinese['REV'],outlets['REV'],4).toFixed(3);data[11].area=(0,_method.calculation)(banquet['cost'],banquet['REV'],4).toFixed(3);data[10].area=(0,_method.calculation)(banquet['REV'],outlets['REV'],4).toFixed(3);data[12].area=(0,_method.calculation)(sum1_1["Total Payroll Expense 人力资源总费用/薪酬及相关福利总费用"],sum1_1['Total Revenue 总收入'],4).toFixed(3);data[13].area=(0,_method.calculation)(sum1_1['Utility Cost 能源成本'],sum1_1['Total Revenue 总收入'],4).toFixed(3);data[14].area=(0,_method.calculation)(sum1_1["Other Expense and Cost 其他费用及成本"],sum1_1["Total Revenue 总收入"],4).toFixed(3);data[15].area=(0,_method.numConvert)(purchase).toFixed(3);// 收入区间平台数据
data[0].interval=(0,_method.calculation)(inter_sum1_1['Rooms Revenue 客房收入'],inter_sum1_1['Total Revenue 总收入'],4).toFixed(3);data[1].interval=(0,_method.calculation)(inter_sum1_1['F&B Revenue 餐饮收入'],inter_sum1_1['Total Revenue 总收入'],4).toFixed(3);data[2].interval=(0,_method.calculation)(inter_sum1_1['Other Revenue 其他部门收入'],inter_sum1_1['Total Revenue 总收入'],4).toFixed(3);data[3].interval=(0,_method.calculation)(inter_sum1_1["Rooms Dep't Profit 客房部门利润"],inter_sum1_1['Rooms Revenue 客房收入'],4).toFixed(3);data[4].interval=(0,_method.calculation)(inter_sum1_1["F&B Dep't Profit 餐饮部门利润"],inter_sum1_1["F&B Revenue 餐饮收入"],4).toFixed(3);data[5].interval=(0,_method.calculation)(inter_sum1_1["F&B Total Cost 食品及饮品成本"],inter_sum1_1["F&B Revenue 餐饮收入"],4).toFixed(3);data[7].interval=(0,_method.calculation)(inter_coffee['cost'],inter_coffee['REV'],4).toFixed(3);data[6].interval=(0,_method.calculation)(inter_coffee['REV'],inter_outlets['REV'],4).toFixed(3);data[9].interval=(0,_method.calculation)(inter_Chinese['cost'],inter_Chinese['REV'],4).toFixed(3);data[8].interval=(0,_method.calculation)(inter_Chinese['REV'],inter_outlets['REV'],4).toFixed(3);data[11].interval=(0,_method.calculation)(inter_banquet['cost'],inter_banquet['REV'],4).toFixed(3);data[10].interval=(0,_method.calculation)(inter_banquet['REV'],inter_outlets['REV'],4).toFixed(3);data[12].interval=(0,_method.calculation)(inter_sum1_1["Total Payroll Expense 人力资源总费用/薪酬及相关福利总费用"],inter_sum1_1['Total Revenue 总收入'],4).toFixed(3);data[13].interval=(0,_method.calculation)(inter_sum1_1['Utility Cost 能源成本'],inter_sum1_1['Total Revenue 总收入'],4).toFixed(3);data[14].interval=(0,_method.calculation)(inter_sum1_1["Other Expense and Cost 其他费用及成本"],inter_sum1_1["Total Revenue 总收入"],4).toFixed(3);data[15].interval=(0,_method.numConvert)(inter_purchase).toFixed(3);// 本酒店数据
data[0].hotel=(0,_method.calculation)((0,_method.getJson)([5,'actual'],es1_1),(0,_method.getJson)([8,'actual'],es1_1),4).toFixed(3);data[1].hotel=(0,_method.calculation)((0,_method.getJson)([6,'actual'],es1_1),(0,_method.getJson)([8,'actual'],es1_1),4).toFixed(3);data[2].hotel=(0,_method.calculation)((0,_method.getJson)([7,'actual'],es1_1),(0,_method.getJson)([8,'actual'],es1_1),4).toFixed(3);data[3].hotel=(0,_method.numConvert)((0,_method.getJson)([10,'actual'],es1_1)).toFixed(3);data[4].hotel=(0,_method.numConvert)((0,_method.getJson)([12,'actual'],es1_1)).toFixed(3);data[5].hotel=(0,_method.numConvert)((0,_method.getJson)([14,'actual'],es1_1)).toFixed(3);data[7].hotel=(0,_method.numConvert)((0,_method.getJson)([0,'cost_percent'],es5_1_2)).toFixed(3);data[6].hotel=(0,_method.numConvert)((0,_method.getJson)([0,'revenue'],es5_1_2)).toFixed(3);data[9].hotel=(0,_method.numConvert)((0,_method.getJson)([1,'cost_percent'],es5_1_2)).toFixed(3);data[8].hotel=(0,_method.numConvert)((0,_method.getJson)([1,'revenue'],es5_1_2)).toFixed(3);data[11].hotel=(0,_method.numConvert)((0,_method.getJson)([2,'cost_percent'],es5_1_2)).toFixed(3);data[10].hotel=(0,_method.numConvert)((0,_method.getJson)([2,'revenue'],es5_1_2)).toFixed(3);data[12].hotel=(0,_method.numConvert)((0,_method.getJson)([16,'actual'],es1_1)).toFixed(3);data[13].hotel=(0,_method.numConvert)((0,_method.getJson)([18,'actual'],es1_1)).toFixed(3);data[14].hotel=(0,_method.numConvert)((0,_method.getJson)([20,'actual'],es1_1)).toFixed(3);data[15].hotel=(0,_method.numConvert)((0,_method.getJson)([17,'total_amount'],es9_8_1)/100).toFixed(3);_context2.next=50;return _this.setState({data:data},_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log('保存');_context.next=3;return _this.onSave(data,date);case 3:case'end':return _context.stop();}}},_callee,_this2);})));case 50:return _context2.abrupt('return',data);case 51:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x,_x2,_x3){return _ref2.apply(this,arguments);};}(),_this.onChangeUpdate=function(data){_this.setState({isUpdate:data});},_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data,_this.state.dataAll);},_this.getData=function(date){var dataBegin=JSON.stringify(_data.dataDefault);var data=JSON.parse(dataBegin);return new Promise(function(){var _ref5=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(resovle,rej){var res,x;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;_context3.next=3;return fetch('/performanceAnalysisInfo?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'});case 3:res=_context3.sent;_context3.next=6;return res.json();case 6:x=_context3.sent;if(x.data.data.length>0){data=x.data.data.sort(function(a,b){return a.sort-b.sort;});}if(x.data.es1_1&&x.data.es1_1.length>0){x.data.es1_1[11].actual=(0,_method2.sum)([x.data.extra_profit,x.data.es1_1[11].actual]);x.data.es1_1[12].actual=(0,_method.calculation)(x.data.es1_1[11].actual,x.data.es1_1[6].actual,3);}_context3.next=11;return _this.computeNum(data,x.data||{},date);case 11:data=_context3.sent;_this.setState({loading:false,dataAll:x.data||{}});resovle('ok');_context3.next=21;break;case 16:_context3.prev=16;_context3.t0=_context3['catch'](0);console.error(_context3.t0);_this.setState({loading:false});rej(_context3.t0);case 21:case'end':return _context3.stop();}}},_callee3,_this2,[[0,16]]);}));return function(_x4,_x5){return _ref5.apply(this,arguments);};}());},_this.onSave=function(d,time){_this.setState({loadingSave:true});var date=time||_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=(d||_this.state.data).map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/performanceAnalysisAdd',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_this.setState({isUpdate:true});return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});},_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table6_2',1.5,'6.20',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});},_this.onExpoetExcel=function(){_this.setState({print:true,loading:true},function(){var name='Performance Analysis \u9152\u5E97\u7ECF\u8425\u60C5\u51B5\u5206\u6790 MTD '+_this.state.date;var innerHtml='\n              <caption>'+name+'</caption>\n              '+document.getElementById('table').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n            ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,name+'.xls');_this.setState({print:false,loading:false});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData(this.state.date);}// 获取表格5_6_1内容
},{key:'render',value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date;var columns=[{dataIndex:'name',key:'name',align:"center",width:300,render:function render(text,record,index){if(new Date('2019-07').valueOf()>new Date(date).valueOf()&&index>=5&&index<=10){return{props:{rowSpa:0,colSpan:0}};}var props={text:text,index:index,type:'text',name:"name",onChange:_this3.onChange};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Average Area Performance Data',_react2.default.createElement('br',null),' \u533A\u57DF\u5E73\u5747\u6570\u636E ',_react2.default.createElement('br',null),' ',(0,_method.getJson)(['hotel','area'],this.state.dataAll,"")),dataIndex:'area',key:'area',align:"center",width:200,render:function render(text,record,index){if(new Date('2019-07').valueOf()>new Date(date).valueOf()&&index>=5&&index<=10){return{props:{rowSpa:0,colSpan:0}};}var props={text:text,index:index,type:'percent',name:"area",onChange:_this3.onChange,compared:{title:['Average Area Performance Data<br /> 区域平均数据'],record:record,sqlName:"performance_mtd"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Revenue Range (RMB) ',_react2.default.createElement('br',null),' \u6536\u5165\u533A\u95F4 \uFF08\u5355\u4F4D\uFF1A\u5143\uFF09',_react2.default.createElement('br',null),_data.intervalData[(0,_method.getJson)(['hotel','income_interval'],this.state.dataAll,"")]),dataIndex:'interval',key:'interval',align:"center",width:200,render:function render(text,record,index){if(new Date('2019-07').valueOf()>new Date(date).valueOf()&&index>=5&&index<=10){return{props:{rowSpa:0,colSpan:0}};}var props={text:text,index:index,type:'percent',name:"interval",onChange:_this3.onChange,compared:{title:['Revenue Range (RMB) <br /> 收入区间 （单位：元）'],record:record,sqlName:"performance_mtd"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Hotel Performance Data',_react2.default.createElement('br',null),' \u672C\u9152\u5E97\u6570\u636E'),dataIndex:'hotel',key:'hotel',align:"center",width:200,render:function render(text,record,index){if(new Date('2019-07').valueOf()>new Date(date).valueOf()&&index>=5&&index<=10){return{props:{rowSpa:0,colSpan:0}};}var props={text:text,index:index,type:'percent',name:"hotel",onChange:_this3.onChange,compared:{title:['Hotel Performance Data<br /> 本酒店数据'],record:record,sqlName:"performance_mtd"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1 style-center'},_react2.default.createElement(_row2.default,{className:'first-title'},'1.1 Performance Analysis \u9152\u5E97\u7ECF\u8425\u60C5\u51B5\u5206\u6790'),_react2.default.createElement(_row2.default,{className:'first-title',style:{fontSize:18,color:"#195A95"}},'Please confirm the Data in ES1.1 and ES5.1.1 have been filled and saved.',_react2.default.createElement('br',null),'\u8BF7\u786E\u8BA4ES1.1\u4E0EES5.1.1\u4E2D\u7684\u6570\u636E\u5DF2\u586B\u5199\u5E76\u4FDD\u5B58\u3002'),_react2.default.createElement(_row2.default,{className:'first-title',style:{fontSize:18,color:"#195A95"}},'Data input period is between 1st to 10th each month, from 11th to the end of month the Perfomance Analysis is visible.',_react2.default.createElement('br',null),'\u6BCF\u67081\u81F311\u65E5\u4E3A\u6570\u636E\u586B\u5199\u7A97\u53E3\uFF0C 11\u65E5\u5230\u6700\u540E\u4E00\u65E5\u53EF\u67E5\u770B\u6B64\u5206\u6790\u62A5\u544A\u3002'),_react2.default.createElement(_row2.default,{className:'title',id:'table6_2'},_react2.default.createElement(_row2.default,null,'1.1.1 Current Month \u5F53\u6708\u6570\u636E'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true,note:{note:""}});_this3.getData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'table',pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_6_2'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this3.setState({print:true},function(){_this3.onExpoetExcel();});}},'\u5BFC\u51FAExcel')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 712 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 715 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var columns=exports.columns=function columns(date){return[{name:"",key:"name",type:"text"},{name:"Available Rooms",children:[{name:"Actual "+(date-2),type:"number",key:"availableActual"},{name:"Budget "+(date-1),type:"number",key:"availableYearBudget"},{name:"Act+ Fcst "+(date-1),type:"number",key:"availableFcst"},{name:"Budget "+date,type:"number",key:"availableBudget"}]},{name:"Rooms Sold",children:[{name:"Actual "+(date-2),type:"number",key:"roomsActual"},{name:"Budget "+(date-1),type:"number",key:"roomsYearBudget"},{name:"Act+ Fcst "+(date-1),type:"number",key:"roomsFcst"},{name:"Budget "+date,type:"number",key:"roomsBudget"}]},{name:"Occupancy %",children:[{name:"Actual "+(date-2),type:"percent",key:"occActual"},{name:"Budget "+(date-1),type:"percent",key:"occYearBudget"},{name:"Act+ Fcst "+(date-1),type:"percent",key:"occFcst"},{name:"Budget "+date,type:"percent",key:"occBudget"},{name:"Variance",type:"percent",key:"occVar"},{name:" Percent Change",type:"percent",key:"occPercent"}]},{name:"Average Room Rate",children:[{name:"Actual "+(date-2),type:"number",key:"arrActual"},{name:"Budget "+(date-1),type:"number",key:"arrYearBudget"},{name:"Act+ Fcst "+(date-1),type:"number",key:"arrFcst"},{name:"Budget "+date,type:"number",key:"arrBudget"},{name:"Variance",type:"number",key:"arrVar"},{name:" Percent Change",type:"percent",key:"arrPercent"}]},{name:"Revenue Per Available Room",children:[{name:"Actual "+(date-2),type:"number",key:"rparActual"},{name:"Budget "+(date-1),type:"number",key:"rparYearBudget"},{name:"Act+ Fcst "+(date-1),type:"number",key:"rparFcst"},{name:"Budget "+date,type:"number",key:"rparBudget"},{name:"Variance",type:"number",key:"rparVar"},{name:" Percent Change",type:"percent",key:"rparPercent"}]},{name:"Room Revenue",children:[{name:"Actual "+(date-2),type:"number",key:"revActual"},{name:"Budget "+(date-1),type:"number",key:"revYearBudget"},{name:"Act+ Fcst "+(date-1),type:"number",key:"revFcst"},{name:"Budget "+date,type:"number",key:"revBudget"},{name:"Variance",type:"number",key:"revVar"},{name:" Percent Change",type:"percent",key:"revPercent"}]}];};var columnsColumn=exports.columnsColumn=[{name:"酒店名称",key:"name",type:"text"},{name:"",key:"typename",type:"text"},{name:"R/Nts",key:"rn",type:"number"},{name:"A.R.R",key:"arr",type:"number"},{name:"Revenue",key:"rev",type:"number"},{name:"Occ %",key:"occ",type:"percent"},{name:"RevPAR",key:"revpar",type:"number"},{name:"Avai Rm",key:"ava",type:"number"}];var listName=exports.listName=[["availableActual","availableYearBudget","availableFcst","availableBudget"],["roomsActual","roomsYearBudget","roomsFcst","roomsBudget"],["occActual","occYearBudget","occFcst","occBudget","occVar","occPercent"],["arrActual","arrYearBudget","arrFcst","arrBudget","arrVar","arrPercent"],["rparActual","rparYearBudget","rparFcst","rparBudget","rparVar","rparPercent"],["revActual","revYearBudget","revFcst","revBudget","revVar","revPercent"]];

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var defaultData=exports.defaultData=[{name:"GCH官网",room_type:"房型一",day2:0,day3:0,day4:0,day5:0,day6:0,day7:0},{name:"GCH官网",room_type:"房型二",day2:0,day3:0,day4:0,day5:0,day6:0,day7:0},{name:"携程",room_type:"房型一",day2:0,day3:0,day4:0,day5:0,day6:0,day7:0},{name:"携程",room_type:"房型二",day2:0,day3:0,day4:0,day5:0,day6:0,day7:0},{name:"美团",room_type:"房型一",day2:0,day3:0,day4:0,day5:0,day6:0,day7:0},{name:"美团",room_type:"房型二",day2:0,day3:0,day4:0,day5:0,day6:0,day7:0},{name:"温德姆中文",room_type:"房型一",day2:0,day3:0,day4:0,day5:0,day6:0,day7:0},{name:"温德姆中文",room_type:"房型二",day2:0,day3:0,day4:0,day5:0,day6:0,day7:0},{name:"温德姆英文",room_type:"房型一",day2:0,day3:0,day4:0,day5:0,day6:0,day7:0},{name:"温德姆英文",room_type:"房型一",day2:0,day3:0,day4:0,day5:0,day6:0,day7:0}];

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(48);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(78);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Track = function Track(props) {
  var _ref, _ref2;

  var className = props.className,
      included = props.included,
      vertical = props.vertical,
      offset = props.offset,
      length = props.length,
      style = props.style,
      reverse = props.reverse;

  var positonStyle = vertical ? (_ref = {}, (0, _defineProperty3['default'])(_ref, reverse ? 'top' : 'bottom', offset + '%'), (0, _defineProperty3['default'])(_ref, reverse ? 'bottom' : 'top', 'auto'), (0, _defineProperty3['default'])(_ref, 'height', length + '%'), _ref) : (_ref2 = {}, (0, _defineProperty3['default'])(_ref2, reverse ? 'right' : 'left', offset + '%'), (0, _defineProperty3['default'])(_ref2, reverse ? 'left' : 'right', 'auto'), (0, _defineProperty3['default'])(_ref2, 'width', length + '%'), _ref2);

  var elStyle = (0, _extends3['default'])({}, style, positonStyle);
  return included ? _react2['default'].createElement('div', { className: className, style: elStyle }) : null;
}; /* eslint-disable react/prop-types */
exports['default'] = Track;
module.exports = exports['default'];

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(129);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(48);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(78);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(31);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(72);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(32);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(2197);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

exports['default'] = createSlider;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _addEventListener = __webpack_require__(260);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _classnames = __webpack_require__(22);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(76);

var _warning2 = _interopRequireDefault(_warning);

var _Steps = __webpack_require__(2204);

var _Steps2 = _interopRequireDefault(_Steps);

var _Marks = __webpack_require__(2205);

var _Marks2 = _interopRequireDefault(_Marks);

var _Handle = __webpack_require__(722);

var _Handle2 = _interopRequireDefault(_Handle);

var _utils = __webpack_require__(443);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

function createSlider(Component) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    (0, _inherits3['default'])(ComponentEnhancer, _Component);

    function ComponentEnhancer(props) {
      (0, _classCallCheck3['default'])(this, ComponentEnhancer);

      var _this = (0, _possibleConstructorReturn3['default'])(this, (ComponentEnhancer.__proto__ || Object.getPrototypeOf(ComponentEnhancer)).call(this, props));

      _this.onMouseDown = function (e) {
        if (e.button !== 0) {
          return;
        }

        var isVertical = _this.props.vertical;
        var position = utils.getMousePosition(isVertical, e);
        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.removeDocumentEvents();
        _this.onStart(position);
        _this.addDocumentMouseEvents();
      };

      _this.onTouchStart = function (e) {
        if (utils.isNotTouchEvent(e)) return;

        var isVertical = _this.props.vertical;
        var position = utils.getTouchPosition(isVertical, e);
        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.onStart(position);
        _this.addDocumentTouchEvents();
        utils.pauseEvent(e);
      };

      _this.onFocus = function (e) {
        var _this$props = _this.props,
            onFocus = _this$props.onFocus,
            vertical = _this$props.vertical;

        if (utils.isEventFromHandle(e, _this.handlesRefs)) {
          var handlePosition = utils.getHandleCenterPosition(vertical, e.target);
          _this.dragOffset = 0;
          _this.onStart(handlePosition);
          utils.pauseEvent(e);
          if (onFocus) {
            onFocus(e);
          }
        }
      };

      _this.onBlur = function (e) {
        var onBlur = _this.props.onBlur;

        _this.onEnd();
        if (onBlur) {
          onBlur(e);
        }
      };

      _this.onMouseUp = function () {
        if (_this.handlesRefs[_this.prevMovedHandleIndex]) {
          _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
        }
      };

      _this.onMouseMove = function (e) {
        if (!_this.sliderRef) {
          _this.onEnd();
          return;
        }
        var position = utils.getMousePosition(_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onTouchMove = function (e) {
        if (utils.isNotTouchEvent(e) || !_this.sliderRef) {
          _this.onEnd();
          return;
        }

        var position = utils.getTouchPosition(_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onKeyDown = function (e) {
        if (_this.sliderRef && utils.isEventFromHandle(e, _this.handlesRefs)) {
          _this.onKeyboard(e);
        }
      };

      _this.onClickMarkLabel = function (e, value) {
        e.stopPropagation();
        _this.onChange({ value: value });
        _this.setState({ value: value }, function () {
          return _this.onEnd(true);
        });
      };

      _this.saveSlider = function (slider) {
        _this.sliderRef = slider;
      };

      var step = props.step,
          max = props.max,
          min = props.min;

      var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true; // eslint-disable-line
      (0, _warning2['default'])(step && Math.floor(step) === step ? isPointDiffEven : true, 'Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)', max - min, step);
      _this.handlesRefs = {};
      return _this;
    }

    (0, _createClass3['default'])(ComponentEnhancer, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        // Snapshot testing cannot handle refs, so be sure to null-check this.
        this.document = this.sliderRef && this.sliderRef.ownerDocument;

        var _props = this.props,
            autoFocus = _props.autoFocus,
            disabled = _props.disabled;

        if (autoFocus && !disabled) {
          this.focus();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if ((0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this)) (0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this).call(this);
        this.removeDocumentEvents();
      }
    }, {
      key: 'getSliderStart',
      value: function getSliderStart() {
        var slider = this.sliderRef;
        var _props2 = this.props,
            vertical = _props2.vertical,
            reverse = _props2.reverse;

        var rect = slider.getBoundingClientRect();
        if (vertical) {
          return reverse ? rect.bottom : rect.top;
        }
        return window.pageXOffset + (reverse ? rect.right : rect.left);
      }
    }, {
      key: 'getSliderLength',
      value: function getSliderLength() {
        var slider = this.sliderRef;
        if (!slider) {
          return 0;
        }

        var coords = slider.getBoundingClientRect();
        return this.props.vertical ? coords.height : coords.width;
      }
    }, {
      key: 'addDocumentTouchEvents',
      value: function addDocumentTouchEvents() {
        // just work for Chrome iOS Safari and Android Browser
        this.onTouchMoveListener = (0, _addEventListener2['default'])(this.document, 'touchmove', this.onTouchMove);
        this.onTouchUpListener = (0, _addEventListener2['default'])(this.document, 'touchend', this.onEnd);
      }
    }, {
      key: 'addDocumentMouseEvents',
      value: function addDocumentMouseEvents() {
        this.onMouseMoveListener = (0, _addEventListener2['default'])(this.document, 'mousemove', this.onMouseMove);
        this.onMouseUpListener = (0, _addEventListener2['default'])(this.document, 'mouseup', this.onEnd);
      }
    }, {
      key: 'removeDocumentEvents',
      value: function removeDocumentEvents() {
        /* eslint-disable no-unused-expressions */
        this.onTouchMoveListener && this.onTouchMoveListener.remove();
        this.onTouchUpListener && this.onTouchUpListener.remove();

        this.onMouseMoveListener && this.onMouseMoveListener.remove();
        this.onMouseUpListener && this.onMouseUpListener.remove();
        /* eslint-enable no-unused-expressions */
      }
    }, {
      key: 'focus',
      value: function focus() {
        if (!this.props.disabled) {
          this.handlesRefs[0].focus();
        }
      }
    }, {
      key: 'blur',
      value: function blur() {
        var _this2 = this;

        if (!this.props.disabled) {
          Object.keys(this.handlesRefs).forEach(function (key) {
            if (_this2.handlesRefs[key] && _this2.handlesRefs[key].blur) {
              _this2.handlesRefs[key].blur();
            }
          });
        }
      }
    }, {
      key: 'calcValue',
      value: function calcValue(offset) {
        var _props3 = this.props,
            vertical = _props3.vertical,
            min = _props3.min,
            max = _props3.max;

        var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
        var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
        return value;
      }
    }, {
      key: 'calcValueByPos',
      value: function calcValueByPos(position) {
        var sign = this.props.reverse ? -1 : +1;
        var pixelOffset = sign * (position - this.getSliderStart());
        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
        return nextValue;
      }
    }, {
      key: 'calcOffset',
      value: function calcOffset(value) {
        var _props4 = this.props,
            min = _props4.min,
            max = _props4.max;

        var ratio = (value - min) / (max - min);
        return ratio * 100;
      }
    }, {
      key: 'saveHandle',
      value: function saveHandle(index, handle) {
        this.handlesRefs[index] = handle;
      }
    }, {
      key: 'render',
      value: function render() {
        var _classNames;

        var _props5 = this.props,
            prefixCls = _props5.prefixCls,
            className = _props5.className,
            marks = _props5.marks,
            dots = _props5.dots,
            step = _props5.step,
            included = _props5.included,
            disabled = _props5.disabled,
            vertical = _props5.vertical,
            reverse = _props5.reverse,
            min = _props5.min,
            max = _props5.max,
            children = _props5.children,
            maximumTrackStyle = _props5.maximumTrackStyle,
            style = _props5.style,
            railStyle = _props5.railStyle,
            dotStyle = _props5.dotStyle,
            activeDotStyle = _props5.activeDotStyle;

        var _get$call = (0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'render', this).call(this),
            tracks = _get$call.tracks,
            handles = _get$call.handles;

        var sliderClassName = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-with-marks', Object.keys(marks).length), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classNames, prefixCls + '-vertical', vertical), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
        return _react2['default'].createElement(
          'div',
          {
            ref: this.saveSlider,
            className: sliderClassName,
            onTouchStart: disabled ? noop : this.onTouchStart,
            onMouseDown: disabled ? noop : this.onMouseDown,
            onMouseUp: disabled ? noop : this.onMouseUp,
            onKeyDown: disabled ? noop : this.onKeyDown,
            onFocus: disabled ? noop : this.onFocus,
            onBlur: disabled ? noop : this.onBlur,
            style: style
          },
          _react2['default'].createElement('div', {
            className: prefixCls + '-rail',
            style: (0, _extends3['default'])({}, maximumTrackStyle, railStyle)
          }),
          tracks,
          _react2['default'].createElement(_Steps2['default'], {
            prefixCls: prefixCls,
            vertical: vertical,
            reverse: reverse,
            marks: marks,
            dots: dots,
            step: step,
            included: included,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: max,
            min: min,
            dotStyle: dotStyle,
            activeDotStyle: activeDotStyle
          }),
          handles,
          _react2['default'].createElement(_Marks2['default'], {
            className: prefixCls + '-mark',
            onClickLabel: disabled ? noop : this.onClickMarkLabel,
            vertical: vertical,
            marks: marks,
            included: included,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: max,
            min: min,
            reverse: reverse
          }),
          children
        );
      }
    }]);
    return ComponentEnhancer;
  }(Component), _class.displayName = 'ComponentEnhancer(' + Component.displayName + ')', _class.propTypes = (0, _extends3['default'])({}, Component.propTypes, {
    min: _propTypes2['default'].number,
    max: _propTypes2['default'].number,
    step: _propTypes2['default'].number,
    marks: _propTypes2['default'].object,
    included: _propTypes2['default'].bool,
    className: _propTypes2['default'].string,
    prefixCls: _propTypes2['default'].string,
    disabled: _propTypes2['default'].bool,
    children: _propTypes2['default'].any,
    onBeforeChange: _propTypes2['default'].func,
    onChange: _propTypes2['default'].func,
    onAfterChange: _propTypes2['default'].func,
    handle: _propTypes2['default'].func,
    dots: _propTypes2['default'].bool,
    vertical: _propTypes2['default'].bool,
    style: _propTypes2['default'].object,
    reverse: _propTypes2['default'].bool,
    minimumTrackStyle: _propTypes2['default'].object, // just for compatibility, will be deperecate
    maximumTrackStyle: _propTypes2['default'].object, // just for compatibility, will be deperecate
    handleStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
    trackStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
    railStyle: _propTypes2['default'].object,
    dotStyle: _propTypes2['default'].object,
    activeDotStyle: _propTypes2['default'].object,
    autoFocus: _propTypes2['default'].bool,
    onFocus: _propTypes2['default'].func,
    onBlur: _propTypes2['default'].func
  }), _class.defaultProps = (0, _extends3['default'])({}, Component.defaultProps, {
    prefixCls: 'rc-slider',
    className: '',
    min: 0,
    max: 100,
    step: 1,
    marks: {},
    handle: function handle(_ref) {
      var index = _ref.index,
          restProps = (0, _objectWithoutProperties3['default'])(_ref, ['index']);

      delete restProps.dragging;
      if (restProps.value === null) {
        return null;
      }

      return _react2['default'].createElement(_Handle2['default'], (0, _extends3['default'])({}, restProps, { key: index }));
    },

    onBeforeChange: noop,
    onChange: noop,
    onAfterChange: noop,
    included: true,
    disabled: false,
    dots: false,
    vertical: false,
    reverse: false,
    trackStyle: [{}],
    handleStyle: [{}],
    railStyle: {},
    dotStyle: {},
    activeDotStyle: {}
  }), _temp;
}
module.exports = exports['default'];

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(140);
var core = __webpack_require__(88);
var fails = __webpack_require__(187);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(48);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(78);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(129);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(31);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(72);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(32);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(22);

var _classnames2 = _interopRequireDefault(_classnames);

var _addEventListener = __webpack_require__(260);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Handle = function (_React$Component) {
  (0, _inherits3['default'])(Handle, _React$Component);

  function Handle() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3['default'])(this, Handle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Handle.__proto__ || Object.getPrototypeOf(Handle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      clickFocused: false
    }, _this.setHandleRef = function (node) {
      _this.handle = node;
    }, _this.handleMouseUp = function () {
      if (document.activeElement === _this.handle) {
        _this.setClickFocus(true);
      }
    }, _this.handleMouseDown = function () {
      // fix https://github.com/ant-design/ant-design/issues/15324
      _this.focus();
    }, _this.handleBlur = function () {
      _this.setClickFocus(false);
    }, _this.handleKeyDown = function () {
      _this.setClickFocus(false);
    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
  }

  (0, _createClass3['default'])(Handle, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // mouseup won't trigger if mouse moved out of handle,
      // so we listen on document here.
      this.onMouseUpListener = (0, _addEventListener2['default'])(document, 'mouseup', this.handleMouseUp);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.onMouseUpListener) {
        this.onMouseUpListener.remove();
      }
    }
  }, {
    key: 'setClickFocus',
    value: function setClickFocus(focused) {
      this.setState({ clickFocused: focused });
    }
  }, {
    key: 'clickFocus',
    value: function clickFocus() {
      this.setClickFocus(true);
      this.focus();
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.handle.focus();
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.handle.blur();
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref2, _ref3;

      var _props = this.props,
          prefixCls = _props.prefixCls,
          vertical = _props.vertical,
          reverse = _props.reverse,
          offset = _props.offset,
          style = _props.style,
          disabled = _props.disabled,
          min = _props.min,
          max = _props.max,
          value = _props.value,
          tabIndex = _props.tabIndex,
          restProps = (0, _objectWithoutProperties3['default'])(_props, ['prefixCls', 'vertical', 'reverse', 'offset', 'style', 'disabled', 'min', 'max', 'value', 'tabIndex']);


      var className = (0, _classnames2['default'])(this.props.className, (0, _defineProperty3['default'])({}, prefixCls + '-handle-click-focused', this.state.clickFocused));
      var positionStyle = vertical ? (_ref2 = {}, (0, _defineProperty3['default'])(_ref2, reverse ? 'top' : 'bottom', offset + '%'), (0, _defineProperty3['default'])(_ref2, reverse ? 'bottom' : 'top', 'auto'), (0, _defineProperty3['default'])(_ref2, 'transform', 'translateY(+50%)'), _ref2) : (_ref3 = {}, (0, _defineProperty3['default'])(_ref3, reverse ? 'right' : 'left', offset + '%'), (0, _defineProperty3['default'])(_ref3, reverse ? 'left' : 'right', 'auto'), (0, _defineProperty3['default'])(_ref3, 'transform', 'translateX(' + (reverse ? '+' : '-') + '50%)'), _ref3);
      var elStyle = (0, _extends3['default'])({}, style, positionStyle);

      var _tabIndex = tabIndex || 0;
      if (disabled || tabIndex === null) {
        _tabIndex = null;
      }

      return _react2['default'].createElement('div', (0, _extends3['default'])({
        ref: this.setHandleRef,
        tabIndex: _tabIndex
      }, restProps, {
        className: className,
        style: elStyle,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleMouseDown

        // aria attribute
        , role: 'slider',
        'aria-valuemin': min,
        'aria-valuemax': max,
        'aria-valuenow': value,
        'aria-disabled': !!disabled
      }));
    }
  }]);
  return Handle;
}(_react2['default'].Component);

exports['default'] = Handle;


Handle.propTypes = {
  prefixCls: _propTypes2['default'].string,
  className: _propTypes2['default'].string,
  vertical: _propTypes2['default'].bool,
  offset: _propTypes2['default'].number,
  style: _propTypes2['default'].object,
  disabled: _propTypes2['default'].bool,
  min: _propTypes2['default'].number,
  max: _propTypes2['default'].number,
  value: _propTypes2['default'].number,
  tabIndex: _propTypes2['default'].number,
  reverse: _propTypes2['default'].bool
};
module.exports = exports['default'];

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(2206);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setOption=undefined;var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);var _method=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=function(data){var id=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'chart';// 总收入
var value1=((0,_method.calculation)(_lodash2.default.get(data.find(function(x){return x.name_code=="Total_Revenue";}),'actual'),_lodash2.default.get(data.find(function(x){return x.name_code=="Total_Revenue";}),'budget'))*100).toFixed(2);setOption(value1,id+"1");// 总毛利润
var value2=((0,_method.calculation)(_lodash2.default.get(data.find(function(x){return x.name_code=="GOP";}),'actual'),_lodash2.default.get(data.find(function(x){return x.name_code=="GOP";}),'budget'))*100).toFixed(2);setOption(value2,id+"2","总毛利润");};var setOption=exports.setOption=function setOption(value,id){var name=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"总收入";var myChart=_echarts2.default.init(document.getElementById(id));var option={series:[{min:0,axisLine:{width:20,show:true,lineStyle:{width:30,shadowBlur:0,color:[[0.2,"#2DC6C8"],[0.8,"#5AB1EF"],[1,"#D87A80"]]}},name:"完成率",type:"gauge",title:{//标题
show:true,offsetCenter:[0,"30%"],// x, y，单位px
textStyle:{color:"#333",fontSize:14//表盘上的标题文字大小
}},axisTick:{splitNumber:30},detail:{formatter:"{value}%",offsetCenter:[0,"50%"],textStyle:{fontSize:25,color:"#5BB1EF"}},data:[{value:value,name:name+"\u5B8C\u6210\u7387"}]}]};myChart.setOption(option);};

/***/ }),
/* 725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _popover=__webpack_require__(396);var _popover2=_interopRequireDefault(_popover);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(287);__webpack_require__(6);__webpack_require__(10);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Compared=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Compared,_Component);function Compared(props){_classCallCheck(this,Compared);var _this=_possibleConstructorReturn(this,(Compared.__proto__||Object.getPrototypeOf(Compared)).call(this,props));_this.addCompared=function(){_this.setState({loading:true});var data=_this.props.data;data=_extends({},data,{title:data.title.toString(),add_time:(0,_moment2.default)().format('YYYY-MM-DD HH:mm:ss')});var headres={method:'post',credentials:'include',headers:{contentType:"application/json;charset=utf-8"},body:JSON.stringify(data)};fetch('/addCompared',headres).then(function(x){return x.json();}).then(function(x){if(x.status==1){_message3.default.success('添加成功');}else{_message3.default.error('添加失败！');}_this.setState({loading:false});}).catch(function(err){console.error(err);_this.setState({loading:false});});};_this.state={loading:false};return _this;}_createClass(Compared,[{key:'render',value:function render(){var content=_react2.default.createElement(_button2.default,{style:{width:"100%"},onClick:this.addCompared,loading:this.state.loading},'\u6DFB\u52A0');// return (
//     <Popover content={content} title="点击添加到对比数据">
//         {this.props.children}
//     </Popover>
// )
if(this.props.store.compared.state){return _react2.default.createElement(_popover2.default,{mouseLeaveDelay:0.2,mouseEnterDelay:0.2,content:content,title:_react2.default.createElement('div',{style:{textAlign:'center'}},'\u70B9\u51FB\u6DFB\u52A0\u5230\u5BF9\u6BD4\u6570\u636E')},this.props.children);}return this.props.children;}}]);return Compared;}(_react.Component))||_class)||_class);exports.default=Compared;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.8de7406d.png";

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _dropdown=__webpack_require__(271);var _dropdown2=_interopRequireDefault(_dropdown);var _menu=__webpack_require__(251);var _menu2=_interopRequireDefault(_menu);var _tooltip=__webpack_require__(87);var _tooltip2=_interopRequireDefault(_tooltip);var _icon=__webpack_require__(38);var _icon2=_interopRequireDefault(_icon);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(62);__webpack_require__(4);__webpack_require__(25);__webpack_require__(6);__webpack_require__(366);__webpack_require__(314);__webpack_require__(100);__webpack_require__(75);__webpack_require__(10);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);__webpack_require__(1102);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _SelectHotel=__webpack_require__(444);var _SelectHotel2=_interopRequireDefault(_SelectHotel);var _user=__webpack_require__(1103);var _user2=_interopRequireDefault(_user);var _user3=__webpack_require__(1113);var _user4=_interopRequireDefault(_user3);var _VIP=__webpack_require__(1114);var _VIP2=_interopRequireDefault(_VIP);var _VIP3=__webpack_require__(1115);var _VIP4=_interopRequireDefault(_VIP3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.handleCancel=function(){_this.setState({visible:false,data:{password:"",comfirm:""}});};_this.handleOk=function(){var data=_this.state.data;_this.setState({loadingSave:true});if(!data.password||!data.confirm||data.password!=data.confirm){_message3.default.error('输入错误，请检查密码！');_this.setState({loadingSave:false});return;}var dataFrom=new FormData();delete data.confirm;var user=_this.state.user;data={id:user.id,password:data.password};// console.log(data);
for(var key in data){if(data.hasOwnProperty(key)){dataFrom.append(key,data[key]);}}var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/addUser',headres).then(function(x){return x.json();}).then(function(x){if(x.status==1){_message3.default.info('修改成功！，请重新登录');var keys=document.cookie.match(/[^ =;]+(?=\=)/g);if(keys){for(var i=keys.length;i--;){document.cookie=keys[i]+'=0;expires='+new Date(0).toUTCString();}};sessionStorage.clear();window.location.href='/#/login';return;}_this.setState({loadingSave:false});}).catch(function(err){console.error(err);_message3.default.error('数据添加失败！');_this.setState({loadingSave:false});});};_this.onPush=function(path){_this.props.history.push(path);};_this.state={user:{},visible:false,data:{password:"",comfirm:""},loadingSave:false};return _this;}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;this.props.store.menu.getUserInfo().then(function(user){_this2.setState({user:user});}).catch(function(err){console.error(err);});}},{key:"render",value:function render(){var _this3=this;var user=this.state.user;var hotel=user.hotel||{};var _props$store$menu=this.props.store.menu,display=_props$store$menu.display,onChangeDisplay=_props$store$menu.onChangeDisplay;var isVip=new Date(hotel.expire_date||"2019-06-01").valueOf()>new Date().valueOf();return _react2.default.createElement("div",{className:"user  "},_react2.default.createElement("div",{className:"app-icon"},_react2.default.createElement(_tooltip2.default,{title:"\u83DC\u5355"},_react2.default.createElement(_icon2.default,{type:"menu-unfold",theme:"outlined",onClick:function onClick(){onChangeDisplay('none');}})),(user.email||"").includes('admin')&&!display?_react2.default.createElement(_SelectHotel2.default,{user:user,display:display}):null),[55,38].includes(hotel.id)&&_react2.default.createElement("div",{className:"prompt"},"*\u8BE5\u9152\u5E972024\u5E74\u5EA6\u7ECF\u8425\u9884\u7B97\u4E3A\u4E1A\u4E3B\u65B9\u9884\u7B97"),_react2.default.createElement("div",{className:"user-name"},_react2.default.createElement("div",{className:"expire_date",onClick:this.onPush.bind(this,'/table/personal')},_react2.default.createElement(_tooltip2.default,{title:isVip?'专业用户':'普通用户'},_react2.default.createElement("img",{src:isVip?_VIP2.default:_VIP4.default,alt:""})),_react2.default.createElement("span",null,(0,_moment2.default)(hotel.expire_date||"2019-07-01").format('YYYY-MM-DD'))),_react2.default.createElement(_dropdown2.default,{overlay:_react2.default.createElement(_menu2.default,null,_react2.default.createElement(_menu2.default.Item,null,_react2.default.createElement("div",{className:"user_expire_text"},_react2.default.createElement("span",null,"\u7CFB\u7EDF\u5230\u671F\u65F6\u95F4"),_react2.default.createElement("span",{onClick:this.onPush.bind(this,'/pay')},isVip?'续费':'升级')),isVip&&_react2.default.createElement("div",{className:"user_expire_date"},(0,_moment2.default)(hotel.expire_date||"2019-07-01").format('YYYY-MM-DD'))),_react2.default.createElement(_menu2.default.Divider,null),_react2.default.createElement(_menu2.default.Item,{onClick:function onClick(){_this3.onPush('/table/personal');}},_react2.default.createElement(_icon2.default,{type:"database"}),"\u8D26\u6237\u4FE1\u606F"),this.props.user=='hr'&&_react2.default.createElement(_menu2.default.Item,null,_react2.default.createElement(_user2.default,null)),this.props.user=='bp'&&_react2.default.createElement(_menu2.default.Item,null,_react2.default.createElement(_user4.default,null)),!this.props.user&&_react2.default.createElement(_menu2.default.Item,{onClick:function onClick(){if(_this3.state.user.email==='admin'){_this3.onPush('/table/setting');return;}_this3.setState({visible:true});}},_react2.default.createElement(_icon2.default,{type:"setting"}),this.state.user.email==='admin'?'设置':'修改密码'),_react2.default.createElement(_menu2.default.Item,{onClick:function onClick(){_this3.props.store.menu.onLogout(_this3.props);}},_react2.default.createElement(_icon2.default,{type:"logout"}),"\u9000\u51FA"))},_react2.default.createElement("div",null,user.name||"","  ",_react2.default.createElement(_icon2.default,{type:"caret-up"})))),_react2.default.createElement(_modal2.default,{title:"\u4FEE\u6539\u5BC6\u7801",visible:this.state.visible,onOk:this.handleOk,onCancel:this.handleCancel,footer:[_react2.default.createElement(_button2.default,{key:"back",onClick:this.handleCancel},"\u53D6\u6D88"),_react2.default.createElement(_button2.default,{key:"submit",type:"primary",loading:this.state.loadingSave,onClick:this.handleOk},"\u4FDD\u5B58")]},_react2.default.createElement(_row2.default,{className:"settings-modal-content"},_react2.default.createElement("span",null,"\u5BC6\u7801\uFF1A"),_react2.default.createElement(_input2.default,{placeholder:"\u8BF7\u8F93\u5165\u5BC6\u7801",style:{width:'60%',marginLeft:38},value:this.state.data.password,type:"password",name:"ppp",onChange:function onChange(e){var value=e.target.value;var data=_this3.state.data;data.password=value;_this3.setState({data:data});}})),_react2.default.createElement(_row2.default,{className:"settings-modal-content"},_react2.default.createElement("span",null,"\u786E\u8BA4\uFF1A"),_react2.default.createElement(_input2.default,{placeholder:"\u8BF7\u8F93\u5165\u5BC6\u7801",style:{width:'60%',marginLeft:38},value:this.state.data.confirm,type:"password",name:"ppp",onChange:function onChange(e){var value=e.target.value;var data=_this3.state.data;data.confirm=value;_this3.setState({data:data});}})),_react2.default.createElement(_row2.default,{className:"settings-modal-content",style:{color:"red",paddingLeft:80}},this.state.data.password&&this.state.data.confirm&&this.state.data.password!=this.state.data.confirm?'两次输入的密码不一致！':"")));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _popconfirm=__webpack_require__(110);var _popconfirm2=_interopRequireDefault(_popconfirm);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_initialiseProps;__webpack_require__(10);__webpack_require__(12);__webpack_require__(8);__webpack_require__(6);__webpack_require__(4);__webpack_require__(111);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);__webpack_require__(2062);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=(_temp=_class=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_initialiseProps.call(_this);var user=JSON.parse(sessionStorage.getItem('user')||"{}");_this.state={date:window.location.hash.includes('/bp/')||user.is_charter==1?(0,_moment2.default)().add(1,'y').format('YYYY-MM'):(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,selectedRowKeys:[],exportLoading:false};return _this;}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);}},{key:"render",value:function render(){var _this2=this;var _state=this.state,selectedRowKeys=_state.selectedRowKeys,exportLoading=_state.exportLoading;var rowSelection={selectedRowKeys:selectedRowKeys,onChange:this.onSelectChange};var columns=[{title:'表格',dataIndex:'sort',key:'sort'},{title:'图片',dataIndex:'img',key:'img',render:function render(text){return _react2.default.createElement("img",{src:text.replace('-internal',''),style:{height:40}});}},{title:'年份',dataIndex:'year',key:'year',render:function render(text,record,index){return _react2.default.createElement("span",null,text,record.month?"-"+record.month:record.month);}},{title:'添加时间',dataIndex:'add_time',key:'add_time'},{title:'操作',dataIndex:'action',key:'action',render:function render(text,record,index){return _react2.default.createElement("span",null,_react2.default.createElement(_popconfirm2.default,{title:"\u786E\u5B9A\u5220\u9664\u8FD9\u5F20pdf\u5417?",onConfirm:_this2.onDeltePdf.bind(_this2,record),okText:"\u786E\u5B9A",cancelText:"\u53D6\u6D88"},_react2.default.createElement("a",{href:"javascript:;"},"\u5220\u9664")));}}];var title=window.location.hash.includes('/bp/')?'Business Plan - ':window.location.hash.includes('/hr/')?"Human Resources":'Executive Summary Version - ';var user={};try{user=JSON.parse(sessionStorage.getItem('user')||"{}");if(user.is_charter==1)title='DATA INPUT 数据输入';}catch(error){console.error(error);}return _react2.default.createElement(_spin2.default,{tip:"\u8868\u683C\u5BFC\u51FA\u4E2D\uFF0C\u8BF7\u7A0D\u540E...",spinning:exportLoading},_react2.default.createElement("div",{className:"pdf"},_react2.default.createElement(_row2.default,{className:"title"},title," \u5DF2\u6DFB\u52A0PDF\u5217\u8868"),_react2.default.createElement(_row2.default,{style:{marginTop:20}},_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:"YYYY-MM",onChange:function onChange(date,str){_this2.getData(str);}}),_react2.default.createElement(_button2.default,{type:"primary",className:"export-pdf",onClick:this.onExport,loading:exportLoading},"\u5BFC\u51FApdf")),_react2.default.createElement(_row2.default,{className:"table-content"},_react2.default.createElement(_table2.default,{dataSource:this.state.data,columns:columns,bordered:true,rowKey:function rowKey(record){return record.id;},loading:this.state.loading,rowSelection:rowSelection}))));}}]);return index;}(_react.Component),_initialiseProps=function _initialiseProps(){var _this3=this;this.getData=function(date){var user=JSON.parse(sessionStorage.getItem('user')||"{}");_this3.setState({loading:true});var url=window.location.hash.includes('/bp/')||user.is_charter==1?"/getPdf_bp?year="+(0,_moment2.default)(date).format('YYYY')+"&sort=":"/getPdf?year="+(0,_moment2.default)(date).format('YYYY')+"&month="+(0,_moment2.default)(date).format('MM')+"&sort=";if(window.location.hash.includes('/hr/')){url="/getPdf_hr?year="+(0,_moment2.default)(date).format('YYYY')+"&month="+(0,_moment2.default)(date).format('MM')+"&sort=";}fetch(url,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this3.setState({data:(x.data||[]).sort(function(a,b){return Number(a.sort)-Number(b.sort);}),loading:false});}).catch(function(err){_this3.setState({loading:false});console.error(err);});};this.onSelectChange=function(selectedRowKeys){_this3.setState({selectedRowKeys:selectedRowKeys});};this.onExport=function(){var selectedRowKeys=_this3.state.selectedRowKeys;_this3.setState({exportLoading:true});var type=1;var hostName=window.location.hash;if(hostName.includes('/bp')){type=2;}else if(hostName.includes('/hr')){type=3;}fetch("/customizeExport?id="+selectedRowKeys.toString()+"&type="+type,{credentials:'include'}).then(function(x){return x.blob();}).then(function(x){_this3.setState({exportLoading:false});var file=new Blob([x],{type:"application/pdf"});_fileSaver2.default.saveAs(file,(0,_moment2.default)(_this3.state.date).format('YYYY-MM')+".pdf");_message3.default.info('导出成功！');}).catch(function(err){console.error(err);_this3.setState({exportLoading:false});_message3.default.info('导出失败！');});};this.onDeltePdf=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(record){var user,url,res,json;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;user=JSON.parse(sessionStorage.getItem('user')||"{}");if(!(user.id!=record.user_id&&!['admin','GM','EAM'].some(function(x){return user.email.includes(x);}))){_context.next=5;break;}_message3.default.error('非此pdf添加人员不可删除!');return _context.abrupt("return");case 5:url="/deletepdf?id="+record.id+"&name=";_context.t0=window.location.hash;_context.next=_context.t0==="#/table/pdf"?9:_context.t0==="#/hr/pdf"?11:_context.t0==="#/bp/pdf"?13:15;break;case 9:url+="es";return _context.abrupt("break",16);case 11:url+="hr";return _context.abrupt("break",16);case 13:url+="bp";return _context.abrupt("break",16);case 15:return _context.abrupt("break",16);case 16:_context.next=18;return fetch(url,{credentials:'include'});case 18:res=_context.sent;_context.next=21;return res.json();case 21:json=_context.sent;if(!(json.status==1)){_context.next=26;break;}_message3.default.success('删除成功！');_this3.getData(_this3.state.date);return _context.abrupt("return");case 26:_message3.default.error(json.msg);_context.next=33;break;case 29:_context.prev=29;_context.t1=_context["catch"](0);console.error(_context.t1);_message3.default.error('删除失败！');case 33:case"end":return _context.stop();}}},_callee,_this3,[[0,29]]);}));return function(_x){return _ref.apply(this,arguments);};}();},_temp);exports.default=index;

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _en_US = _interopRequireDefault(__webpack_require__(331));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _en_US["default"];
exports["default"] = _default;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(31);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(32);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(22);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactLifecyclesCompat = __webpack_require__(36);

var _index = __webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ROW = 4;
var COL = 3;

function noop() {}

var MonthTable = function (_Component) {
  (0, _inherits3['default'])(MonthTable, _Component);

  function MonthTable() {
    var _temp, _this, _ret;

    (0, _classCallCheck3['default'])(this, MonthTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
  }

  MonthTable.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
    if ('value' in props) {
      return { value: props.value };
    }
    return null;
  };

  MonthTable.prototype.setAndSelectValue = function setAndSelectValue(value) {
    this.setState({
      value: value
    });
    this.props.onSelect(value);
  };

  MonthTable.prototype.chooseMonth = function chooseMonth(month) {
    var next = this.state.value.clone();
    next.month(month);
    this.setAndSelectValue(next);
  };

  MonthTable.prototype.months = function months() {
    var value = this.state.value;
    var current = value.clone();
    var months = [];
    var index = 0;
    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      months[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        current.month(index);
        var content = (0, _index.getMonthName)(current);
        months[rowIndex][colIndex] = {
          value: index,
          content: content,
          title: content
        };
        index++;
      }
    }
    return months;
  };

  MonthTable.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var value = this.state.value;
    var today = (0, _index.getTodayTime)(value);
    var months = this.months();
    var currentMonth = value.month();
    var prefixCls = props.prefixCls,
        locale = props.locale,
        contentRender = props.contentRender,
        cellRender = props.cellRender;

    var monthsEls = months.map(function (month, index) {
      var tds = month.map(function (monthData) {
        var _classNameMap;

        var disabled = false;
        if (props.disabledDate) {
          var testValue = value.clone();
          testValue.month(monthData.value);
          disabled = props.disabledDate(testValue);
        }
        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-cell-disabled'] = disabled, _classNameMap[prefixCls + '-selected-cell'] = monthData.value === currentMonth, _classNameMap[prefixCls + '-current-cell'] = today.year() === value.year() && monthData.value === today.month(), _classNameMap);
        var cellEl = void 0;
        if (cellRender) {
          var currentValue = value.clone();
          currentValue.month(monthData.value);
          cellEl = cellRender(currentValue, locale);
        } else {
          var content = void 0;
          if (contentRender) {
            var _currentValue = value.clone();
            _currentValue.month(monthData.value);
            content = contentRender(_currentValue, locale);
          } else {
            content = monthData.content;
          }
          cellEl = _react2['default'].createElement(
            'a',
            { className: prefixCls + '-month' },
            content
          );
        }
        return _react2['default'].createElement(
          'td',
          {
            role: 'gridcell',
            key: monthData.value,
            onClick: disabled ? null : function () {
              return _this2.chooseMonth(monthData.value);
            },
            title: monthData.title,
            className: (0, _classnames2['default'])(classNameMap)
          },
          cellEl
        );
      });
      return _react2['default'].createElement(
        'tr',
        { key: index, role: 'row' },
        tds
      );
    });

    return _react2['default'].createElement(
      'table',
      { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
      _react2['default'].createElement(
        'tbody',
        { className: prefixCls + '-tbody' },
        monthsEls
      )
    );
  };

  return MonthTable;
}(_react.Component);

MonthTable.defaultProps = {
  onSelect: noop
};

MonthTable.propTypes = {
  onSelect: _propTypes2['default'].func,
  cellRender: _propTypes2['default'].func,
  prefixCls: _propTypes2['default'].string,
  value: _propTypes2['default'].object
};

(0, _reactLifecyclesCompat.polyfill)(MonthTable);

exports['default'] = MonthTable;
module.exports = exports['default'];

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.calendarMixinWrapper = exports.calendarMixinDefaultProps = exports.calendarMixinPropTypes = undefined;

var _classCallCheck2 = __webpack_require__(31);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(32);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.getNowByCurrentStateValue = getNowByCurrentStateValue;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(22);

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _index = __webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

function getNowByCurrentStateValue(value) {
  var ret = void 0;
  if (value) {
    ret = (0, _index.getTodayTime)(value);
  } else {
    ret = (0, _moment2['default'])();
  }
  return ret;
}

var calendarMixinPropTypes = exports.calendarMixinPropTypes = {
  value: _propTypes2['default'].object,
  defaultValue: _propTypes2['default'].object,
  onKeyDown: _propTypes2['default'].func
};

var calendarMixinDefaultProps = exports.calendarMixinDefaultProps = {
  onKeyDown: noop
};

var calendarMixinWrapper = exports.calendarMixinWrapper = function calendarMixinWrapper(ComposeComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_ComposeComponent) {
    (0, _inherits3['default'])(_class, _ComposeComponent);

    function _class() {
      var _temp, _this, _ret;

      (0, _classCallCheck3['default'])(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _ComposeComponent.call.apply(_ComposeComponent, [this].concat(args))), _this), _this.onSelect = function (value, cause) {
        if (value) {
          _this.setValue(value);
        }
        _this.setSelectedValue(value, cause);
      }, _this.renderRoot = function (newProps) {
        var _className;

        var props = _this.props;
        var prefixCls = props.prefixCls;

        var className = (_className = {}, _className[prefixCls] = 1, _className[prefixCls + '-hidden'] = !props.visible, _className[props.className] = !!props.className, _className[newProps.className] = !!newProps.className, _className);

        return _react2['default'].createElement(
          'div',
          {
            ref: _this.saveRoot,
            className: '' + (0, _classnames2['default'])(className),
            style: _this.props.style,
            tabIndex: '0',
            onKeyDown: _this.onKeyDown,
            onBlur: _this.onBlur
          },
          newProps.children
        );
      }, _this.setSelectedValue = function (selectedValue, cause) {
        // if (this.isAllowedDate(selectedValue)) {
        if (!('selectedValue' in _this.props)) {
          _this.setState({
            selectedValue: selectedValue
          });
        }
        if (_this.props.onSelect) {
          _this.props.onSelect(selectedValue, cause);
        }
        // }
      }, _this.setValue = function (value) {
        var originalValue = _this.state.value;
        if (!('value' in _this.props)) {
          _this.setState({
            value: value
          });
        }
        if (originalValue && value && !originalValue.isSame(value) || !originalValue && value || originalValue && !value) {
          _this.props.onChange(value);
        }
      }, _this.isAllowedDate = function (value) {
        var disabledDate = _this.props.disabledDate;
        var disabledTime = _this.props.disabledTime;
        return (0, _index.isAllowedDate)(value, disabledDate, disabledTime);
      }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
    }

    _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      // Use origin function if provided
      if (ComposeComponent.getDerivedStateFromProps) {
        return ComposeComponent.getDerivedStateFromProps(nextProps, prevState);
      }

      var value = nextProps.value,
          selectedValue = nextProps.selectedValue;

      var newState = {};

      if ('value' in nextProps) {
        newState.value = value || nextProps.defaultValue || getNowByCurrentStateValue(prevState.value);
      }
      if ('selectedValue' in nextProps) {
        newState.selectedValue = selectedValue;
      }

      return newState;
    };

    return _class;
  }(ComposeComponent), _class.displayName = 'CalendarMixinWrapper', _class.defaultProps = ComposeComponent.defaultProps, _temp2;
};

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(31);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(32);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _DateTHead = __webpack_require__(963);

var _DateTHead2 = _interopRequireDefault(_DateTHead);

var _DateTBody = __webpack_require__(964);

var _DateTBody2 = _interopRequireDefault(_DateTBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DateTable = function (_React$Component) {
  (0, _inherits3['default'])(DateTable, _React$Component);

  function DateTable() {
    (0, _classCallCheck3['default'])(this, DateTable);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  DateTable.prototype.render = function render() {
    var props = this.props;
    var prefixCls = props.prefixCls;
    return _react2['default'].createElement(
      'table',
      { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
      _react2['default'].createElement(_DateTHead2['default'], props),
      _react2['default'].createElement(_DateTBody2['default'], props)
    );
  };

  return DateTable;
}(_react2['default'].Component);

exports['default'] = DateTable;
module.exports = exports['default'];

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _alert=__webpack_require__(83);var _alert2=_interopRequireDefault(_alert);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(62);__webpack_require__(4);__webpack_require__(84);__webpack_require__(6);__webpack_require__(10);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _mobxReact=__webpack_require__(18);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var ExportPdf=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(ExportPdf,_Component);function ExportPdf(props){_classCallCheck(this,ExportPdf);var _this=_possibleConstructorReturn(this,(ExportPdf.__proto__||Object.getPrototypeOf(ExportPdf)).call(this,props));_this.onExportPdf=function(){_this.setState({visible:true});};_this.handleOk=function(){_this.setState({loading:true});var date=_this.state.date;fetch("/mkPdf_bp?year="+(0,_moment2.default)(date).format('YYYY'),{credentials:'include'}).then(function(x){return x.blob();}).then(function(x){var file=new Blob([x],{type:"application/pdf"});_fileSaver2.default.saveAs(file,(_this.state.hotel.name||"")+"("+date+").pdf");_this.setState({loading:false});_message3.default.info('导出成功！');}).catch(function(err){_this.setState({loading:false});_message3.default.info('导出失败！');console.error(err);});};_this.handleCancel=function(){_this.setState({visible:false});};_this.state={visible:false,date:(0,_moment2.default)().add(1,'y').format('YYYY'),loading:false,dateData:[],hotel:{}};return _this;}_createClass(ExportPdf,[{key:"componentDidMount",value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var date,dateData,len,i,hotel;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;date=Number(this.state.date||"0");dateData=[];len=date+5-2010;for(i=0;i<len;i++){dateData.push((2012+i).toString());}_context.next=7;return this.props.store.menu.getHotelInfo();case 7:hotel=_context.sent;this.setState({dateData:dateData,hotel:hotel});_context.next=14;break;case 11:_context.prev=11;_context.t0=_context["catch"](0);console.log(_context.t0);case 14:case"end":return _context.stop();}}},_callee,this,[[0,11]]);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:"render",value:function render(){var _this2=this;return _react2.default.createElement("div",{style:{color:"#1890ff",cursor:"pointer",padding:"10px 20px",textAlign:"center"}},_react2.default.createElement(_button2.default,{onClick:this.onExportPdf,type:"primary",style:{width:"100%"}},"\u4E00\u952E\u5BFC\u51FA"),_react2.default.createElement(_modal2.default,{title:"\u5BFC\u51FAPDF",visible:this.state.visible,onOk:this.handleOk,onCancel:this.handleCancel,footer:[_react2.default.createElement(_button2.default,{key:"back",onClick:this.handleCancel},"\u53D6\u6D88"),_react2.default.createElement(_button2.default,{key:"submit",type:"primary",loading:this.state.loading,onClick:this.handleOk},this.state.loading?'导出中，请稍候......':"导出")]},_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement("span",{style:{marginRight:20}},"\u8BF7\u9009\u62E9\u5E74\u4EFD\uFF1A"),_react2.default.createElement(_select2.default,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u4EFD",style:{width:120},value:this.state.date,onChange:function onChange(str){_this2.setState({date:str});}},this.state.dateData.map(function(x,i){return _react2.default.createElement(Option,{value:x,key:x},x,"\u5E74");})),_react2.default.createElement(_alert2.default,{style:{marginTop:20},message:"\u8B66\u544A",description:"\u7531\u4E8E\u5BFC\u51FA\u5185\u5BB9\u8FC7\u591A\uFF0C\u4F1A\u5BFC\u81F4\u9875\u9762\u5361\u987F\uFF0C\u5BFC\u51FA\u6210\u529F\u4F1A\u81EA\u52A8\u751F\u6210pdf\u6587\u4EF6\uFF0C\u5728\u751F\u6210\u6587\u4EF6\u4E4B\u524D\uFF0C\u8BF7\u52FF\u5173\u95ED\u6D4F\u89C8\u5668\u548C\u5F53\u524D\u9875\u9762\u6807\u7B7E\u3002\u3002\u3002",type:"error"}))));}}]);return ExportPdf;}(_react.Component))||_class)||_class);exports.default=ExportPdf;

/***/ }),
/* 736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _alert=__webpack_require__(83);var _alert2=_interopRequireDefault(_alert);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(84);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(25);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2002);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _IsLableAuth=__webpack_require__(107);var _IsLableAuth2=_interopRequireDefault(_IsLableAuth);var _Productivity=__webpack_require__(2003);var _Productivity2=_interopRequireDefault(_Productivity);var _method=__webpack_require__(20);var _compute=__webpack_require__(2004);var _compute2=_interopRequireDefault(_compute);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _Chart=__webpack_require__(2005);var _Chart2=_interopRequireDefault(_Chart);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TextArea=_input2.default.TextArea;function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var getJson=function getJson(arr,obj){var value=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;return arr.reduce(function(a,b){return a&&a[b]?a[b]:value;},obj);};var totalIndexFooter=[0,17,18,59,65];var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(data){var listName;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:listName=['now_year','last_year'];listName.forEach(function(name){data[3][name]=(numConvert(data[1][name])==0?0:numConvert(data[2][name])/numConvert(data[1][name])).toFixed(4);data[4][name]=(numConvert(data[2][name])==0?0:numConvert(data[6][name])/numConvert(data[2][name])).toFixed(2);data[5][name]=(numConvert(data[6][name])+numConvert(data[7][name])+numConvert(data[8][name])).toFixed(2);data[17][name]=[10,11,15,16].reduce(function(a,b){a+=numConvert(data[b][name]);return a;},0).toFixed(2);data[22][name]=(numConvert(data[19][name])==0?0:numConvert(data[21][name])/numConvert(data[19][name])).toFixed(2);data[23][name]=(numConvert(data[1][name])==0||numConvert(data[20][name])==0?0:numConvert(data[21][name])/numConvert(data[19][name])/(numConvert(data[1][name])/numConvert(data[20][name]))).toFixed(2);data[24][name]=(numConvert(data[5][name])==0?0:numConvert(data[17][name])/numConvert(data[5][name])).toFixed(4);data[25][name]=(numConvert(data[21][name])==0?0:numConvert(data[17][name])/numConvert(data[21][name])).toFixed(2);data[26][name]=(numConvert(data[21][name])==0?0:numConvert(data[10][name])/numConvert(data[21][name])).toFixed(2);data[30][name]=(numConvert(data[5][name])==0?0:numConvert(data[6][name])/numConvert(data[5][name])).toFixed(4);data[31][name]=(numConvert(data[17][name])==0?0:numConvert(data[28][name])/numConvert(data[17][name])).toFixed(4);data[32][name]=(numConvert(data[27][name])==0?0:numConvert(data[28][name])/numConvert(data[27][name])).toFixed(2);data[33][name]=(numConvert(data[27][name])==0?0:numConvert(data[29][name])/numConvert(data[27][name])).toFixed(2);data[34][name]=(numConvert(data[27][name])==0?0:numConvert(data[6][name])/numConvert(data[27][name])).toFixed(2);data[38][name]=(numConvert(data[5][name])==0?0:numConvert(data[7][name])/numConvert(data[5][name])).toFixed(4);data[39][name]=(numConvert(data[17][name])==0?0:numConvert(data[36][name])/numConvert(data[17][name])).toFixed(4);data[40][name]=(numConvert(data[35][name])==0?0:numConvert(data[36][name])/numConvert(data[35][name])).toFixed(2);data[41][name]=(numConvert(data[35][name])==0?0:numConvert(data[37][name])/numConvert(data[35][name])).toFixed(2);data[42][name]=(numConvert(data[35][name])==0?0:numConvert(data[7][name])/numConvert(data[35][name])).toFixed(2);data[46][name]=(numConvert(data[5][name])==0?0:numConvert(data[8][name])/numConvert(data[5][name])).toFixed(4);data[47][name]=(numConvert(data[17][name])==0?0:numConvert(data[44][name])/numConvert(data[17][name])).toFixed(4);data[48][name]=(numConvert(data[43][name])==0?0:numConvert(data[44][name])/numConvert(data[43][name])).toFixed(2);data[49][name]=(numConvert(data[43][name])==0?0:numConvert(data[45][name])/numConvert(data[43][name])).toFixed(2);data[50][name]=(numConvert(data[43][name])==0?0:numConvert(data[8][name])/numConvert(data[43][name])).toFixed(2);data[54][name]=(numConvert(data[17][name])==0?0:numConvert(data[52][name])/numConvert(data[17][name])).toFixed(4);data[55][name]=(numConvert(data[51][name])==0?0:numConvert(data[52][name])/numConvert(data[51][name])).toFixed(2);data[56][name]=(numConvert(data[51][name])==0?0:numConvert(data[53][name])/numConvert(data[51][name])).toFixed(2);data[57][name]=(numConvert(data[21][name])-numConvert(data[27][name])-numConvert(data[35][name])-numConvert(data[43][name])-numConvert(data[51][name])).toFixed(2);data[58][name]=(numConvert(data[17][name])-numConvert(data[28][name])-numConvert(data[36][name])-numConvert(data[44][name])-numConvert(data[52][name])).toFixed(2);data[61][name]=(numConvert(data[21][name])==0?0:numConvert(data[60][name])/numConvert(data[21][name])).toFixed(4);data[64][name]=(numConvert(data[60][name])==0?0:(numConvert(data[62][name])+numConvert(data[63][name]))/numConvert(data[60][name])).toFixed(2);// data[68][name] = (numConvert(data[66][name]) == 0 ? 0 : numConvert(data[67][name]) / numConvert(data[66][name])).toFixed(2);
// data[69][name] = (numConvert(data[17][name]) == 0 ? 0 : numConvert(data[67][name]) / numConvert(data[17][name])).toFixed(4);
});data.forEach(function(item,i){data[i].variance=(numConvert(data[i].last_year)==0?0:(numConvert(data[i].now_year)-numConvert(data[i].last_year))/numConvert(data[i].last_year)).toFixed(4);});data[16].variance=(0,_method.calculation)(data[16].now_year,data[17].now_year,4);console.log(data);_this.setState({data:data},function(){_this.onSave();});case 6:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x3){return _ref.apply(this,arguments);};}();_this.onChange=function(name,value,i){// 简单粗暴的深拷贝
var data=JSON.parse(JSON.stringify(_this.state.data));data[i][name]=value;_this.computeNum(data);};_this.onChangeProperty=function(name,value){var property=_this.state.property;property[name]=value;_this.setState({property:property});};_this.getDateData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(date){var dataBegin,data;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dataBegin=JSON.stringify(_data.dataDefault);data=JSON.parse(dataBegin);fetch('/_hr_9_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('MM'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.table&&x.data.table.length>0){data=x.data.table.sort(function(a,b){return numConvert(a.sort)-numConvert(b.sort);});}// 从1.1获取数据
data[1].now_year=getJson([0,'year_actual'],x.data.data1_1||[]);data[2].now_year=getJson([1,'year_actual'],x.data.data1_1||[]);data[6].now_year=getJson([5,'year_actual'],x.data.data1_1||[]);data[7].now_year=getJson([6,'year_actual'],x.data.data1_1||[]);data[8].now_year=getJson([7,'year_actual'],x.data.data1_1||[]);data[9].now_year=getJson([21,'year_actual'],x.data.data1_1||[]);data[10].now_year=getJson([11,'year_thisy_payroll_cost'],x.data.data7_1||[]);//纯工资
data[11].now_year=getJson([13,'year_thisy_payroll_cost'],x.data.data7_1||[]);//年终奖
data[15].now_year=getJson([12,'year_thisy_payroll_cost'],x.data.data7_1||[]);//五险一金
data[16].now_year=getJson([14,'year_thisy_payroll_cost'],x.data.data7_1||[]);//五险一金
data[66].now_year=getJson([17,'year_thisy_payroll_cost'],x.data.data7_1||[]);//五险一金
data[67].now_year=getJson([18,'year_thisy_payroll_cost'],x.data.data7_1||[]);//五险一金
data[68].now_year=getJson([19,'year_thisy_payroll_cost'],x.data.data7_1||[]);//五险一金
data[69].now_year=(0,_method.calculation)(getJson([19,'year_thisy_payroll_cost'],x.data.data7_1||[]),Number(getJson([16,'year_thisy_payroll_cost'],x.data.data7_1||[]))+Number(getJson([19,'year_thisy_payroll_cost'],x.data.data7_1||[])));data[1].last_year=getJson([0,'year_actual'],x.data.dataLast1_1||[]);data[2].last_year=getJson([1,'year_actual'],x.data.dataLast1_1||[]);data[6].last_year=getJson([5,'year_actual'],x.data.dataLast1_1||[]);data[7].last_year=getJson([6,'year_actual'],x.data.dataLast1_1||[]);data[8].last_year=getJson([7,'year_actual'],x.data.dataLast1_1||[]);data[9].last_year=getJson([21,'year_actual'],x.data.dataLast1_1||[]);data[10].last_year=getJson([11,'year_lasty_payroll_cost'],x.data.data7_1||[]);//纯工资
data[11].last_year=getJson([13,'year_lasty_payroll_cost'],x.data.data7_1||[]);//年终奖
data[15].last_year=getJson([12,'year_lasty_payroll_cost'],x.data.data7_1||[]);//五险一金
data[16].last_year=getJson([14,'year_lasty_payroll_cost'],x.data.data7_1||[]);//其他费用
data[66].last_year=getJson([17,'year_lasty_payroll_cost'],x.data.data7_1||[]);//五险一金
data[67].last_year=getJson([18,'year_lasty_payroll_cost'],x.data.data7_1||[]);//五险一金
data[68].last_year=getJson([19,'year_lasty_payroll_cost'],x.data.data7_1||[]);//五险一金
data[69].last_year=(0,_method.calculation)(getJson([19,'year_lasty_payroll_cost'],x.data.data7_1||[]),Number(getJson([16,'year_lasty_payroll_cost'],x.data.data7_1||[]))+Number(getJson([19,'year_lasty_payroll_cost'],x.data.data7_1||[])));data=(0,_compute2.default)({date:date,data:data,data7_7:x.data.data7_7||[]});if(!data[0].id){_this.setState({loading:false,data:data,note:x.data.note||{note:""}},function(){_this.onSave();});return;}_this.setState({loading:false,note:x.data.note||{note:""},data7_1:x.data.data7_1||[],dataIndex:x.data.dataIndex||[]},function(){_this.computeNum(data);});}).catch(function(err){_this.setState({loading:false});console.error(err);});case 3:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x4){return _ref2.apply(this,arguments);};}();_this.onSave=function(){_this.setState({loadingSave:true});var _this$state=_this.state,date=_this$state.date,note=_this$state.note,data7_1=_this$state.data7_1,dataIndex=_this$state.dataIndex;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("MM");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));dataFrom.append('dataIndex',JSON.stringify((0,_Productivity.compute)(data,data7_1,dataIndex).map(function(x){return _extends({},x,{year:year,month:month});})));dataFrom.append('note',JSON.stringify(_extends({},note,{year:year,month:month})));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/hrAdd_9',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);(0,_compute.getChart)(year);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id||!dataIndex[0]||!dataIndex[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){// 由HR9.0迁移至ES7.7
_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table3_3_2',1.5,'7.8',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+' '+(0,_moment2.default)(_this.state.date).format('YYYY')+' 7.8 Labor Cost Productivity Analysis \u4EBA\u529B\u6210\u672C\u751F\u4EA7\u7387\u5206\u6790\u8868';var innerHtml='\n          <caption>'+tableName+'</caption>\n          '+document.getElementById('table7_8').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n        ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+'.xls');_this.setState({print:false});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,update:false,note:{note:""},data7_1:[],dataIndex:[]};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,data=_state.data,note=_state.note,date=_state.date,loading=_state.loading,data7_1=_state.data7_1,dataIndex=_state.dataIndex,print=_state.print;var year=Number((0,_moment2.default)(date).format('YYYY'));var percentIndex=[3,24,30,31,38,39,46,47,54,61,69];// const inputIndex = [12, 13, 14, 19, 20, 21, 27, 28, 29, 35, 36, 37, 43, 44, 45, 52, 53, 51, 60, 62, 63];
var inputIndex=[];var noIndex=[0,18,59,65];var deleteRow=[12,13,14];var columns=[{title:'',dataIndex:'name',key:'name',align:"center",width:500,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this3.onChange,totalIndex:totalIndexFooter};if(deleteRow.includes(index)){return{porps:{colSpan:0}};}if(noIndex.includes(index)){return{children:_react2.default.createElement(_TableText2.default,{data:props}),props:{colSpan:4}};}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'\u4ECA\u5E74YTD\u5E74\u7D2F\u8BA1',dataIndex:'now_year',key:'now_year',align:"center",width:150,render:function render(text,record,index){var title=['\u4ECA\u5E74YTD\u5E74\u7D2F\u8BA1'];var props={text:text,index:index,type:inputIndex.includes(index)&&!print?'inputNumber':percentIndex.includes(index)?'percent':'number',name:"now_year",onChange:_this3.onChange,totalIndex:totalIndexFooter,compared:{title:title,record:record,sqlName:"hr_9"}};if(deleteRow.includes(index)){return{porps:{colSpan:0}};}if(noIndex.includes(index)){return{props:{colSpan:0}};}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'\u53BB\u5E74YTD\u5E74\u7D2F\u8BA1',dataIndex:'last_year',key:'last_year',align:"center",width:150,render:function render(text,record,index){var title=['\u53BB\u5E74YTD\u5E74\u7D2F\u8BA1'];var props={text:text,index:index,type:inputIndex.includes(index)&&!print?'inputNumber':percentIndex.includes(index)?'percent':'number',name:"last_year",onChange:_this3.onChange,totalIndex:totalIndexFooter,compared:{title:title,record:record,sqlName:"hr_9"}};if(deleteRow.includes(index)){return{porps:{colSpan:0}};}if(noIndex.includes(index)){return{props:{colSpan:0}};}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Variance',dataIndex:'variance',key:'variance',align:"center",width:300,render:function render(text,record,index){var title=['Variance'];var props={text:text,index:index,type:'percent',name:"variance",onChange:_this3.onChange,totalIndex:totalIndexFooter,compared:{title:title,record:record,sqlName:"hr_9"}};if(deleteRow.includes(index)){return{porps:{colSpan:0}};}if(noIndex.includes(index)){return{props:{colSpan:0}};}if(index==16){var num=numConvert(data[17].now_year)==0?0:numConvert(data[16].now_year)/numConvert(data[17].now_year);if(num<0.03){return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{text:"",type:""})});}return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{text:"此金额不应超过人力成本总金额的3%",type:"text",warn:true})});}if(index==57){if(numConvert(data[57].now_year).toFixed(2)==0){return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{text:0,type:"number"})});}return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{text:"Please explain the details. 请解释原因.",type:"text",warn:true})});}if(index==58){if(numConvert(data[58].now_year).toFixed(2)==0){return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{text:0,type:"number"})});}return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{text:"Please explain the details. 请解释原因.",type:"text"})});}return _react2.default.createElement(_TableText2.default,{data:props});}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table'},_react2.default.createElement(_row2.default,{className:'title',id:'table3_3_2'},_react2.default.createElement(_row2.default,null,'7.8 Labor Cost Productivity Analysis \u4EBA\u529B\u6210\u672C\u751F\u4EA7\u7387\u5206\u6790\u8868'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'table7_8',pagination:false,className:'content',scroll:this.state.print?{}:{y:550},rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_Productivity2.default,{data:data,data7_1:data7_1,dataSource:dataIndex,date:date}),_react2.default.createElement(_row2.default,{style:{margin:"30px 0 10px 0"}},'7.8.1 Comments \u5907\u6CE8: '),!loading&&_react2.default.createElement(TextArea,{rows:4,defaultValue:note.note,onBlur:function onBlur(e){var v=e.target.value||"";_this3.setState({note:_extends({},note,{note:v})});}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_alert2.default,{message:_react2.default.createElement('div',null,'\u8868\u683C\u5173\u8054',_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:'read_1'},this.props,{path:'/table/1'}),'1.1'),' -',_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:'read_7_1'},this.props,{path:'/table/7_1'}),'7.1'),' -',_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:'read_7_7'},this.props,{path:'/table/7_7'}),'7.7')),type:'info',showIcon:true,style:{display:"inline-block",marginRight:10}}),_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:loading,auth:'edit_7_8'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))),_react2.default.createElement(_Chart2.default,null));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(4);__webpack_require__(10);__webpack_require__(25);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _imgtopdf=__webpack_require__(128);var _jspdf=__webpack_require__(183);var _jspdf2=_interopRequireDefault(_jspdf);var _Auth=__webpack_require__(2063);var _Auth2=_interopRequireDefault(_Auth);__webpack_require__(2064);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var TextArea=_input2.default.TextArea;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getJson=function(){var arr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var obj=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return arr.reduce(function(a,b){return a&&a[b]?a[b]:'';},obj);};_this.getDateData=function(date){var data=_this.state.data;fetch('/getComments',{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this.setState({loading:false,data:x.data.comments||{},name:x.data.name||""});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(name){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var data=_defineProperty({},name,_this.state.data[name]);if(_this.state.data.id){data['id']=_this.state.data.id;}var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/addComments',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data.id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败'+JSON.stringify(err));console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_imgtopdf.imgToPdf)('table4_1_1',1.5).then(function(x){var canvas=x.canvas;var pageData=canvas.toDataURL('image/png',0.7);//方向默认横向，尺寸ponits, 按照图片大小进行输出
var pdf=new _jspdf2.default('l','pt',[canvas.width*1.5,canvas.height]);//需要dataUrl格式
pdf.addImage(pageData,'PNG',0,0,canvas.width,canvas.height);pdf.save('Corporate Office Review('+(_this.state.name||"")+').pdf');_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_message3.default.error('导出失败请重试！');_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().format('YYYY'),data:{general:"",sales:"",FB:"",labor:"",cost:"",other:"",test:""},loading:true,loadingSave:false,print:false,dateData:[],name:"",user:{}};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){var date=Number(this.state.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});this.getDateData(this.state.date);try{var user=JSON.parse(sessionStorage.getItem('user'));this.setState({user:user});}catch(error){console.error(error);this.setState({user:{}});}}// 获取深度嵌套json
},{key:'render',value:function render(){var _this2=this;var data=this.state.data;return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table',id:'table4_1_1'},_react2.default.createElement(_row2.default,{style:{margin:"24px 0 0 24px",fontSize:24,color:"#333"}},'Corporate Office Review \u96C6\u56E2\u4FE1\u606F\u6C47\u603B'),_react2.default.createElement(_row2.default,{style:{marginTop:10},className:'title'},_react2.default.createElement(_row2.default,{style:{marginTop:10}},_react2.default.createElement(_row2.default,{style:{margin:"10px 0"},className:'new-fontSize'},'\u603B\u4F53\u7B56\u7565 General Strategy'),_react2.default.createElement(TextArea,{rows:4,placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',value:data.general||"",onChange:function onChange(e){var data=_this2.state.data;data.general=e.target.value||"";_this2.setState({data:data});}}),_react2.default.createElement(_Auth2.default,{name:'OPS'},_react2.default.createElement(_button2.default,{type:'primary',style:{float:"right",marginTop:10,display:this.state.print?'none':''},onClick:function onClick(){_this2.onSave('general');}// loading={this.state.loadingSave}
},'\u4FDD\u5B58'))),_react2.default.createElement(_row2.default,{style:{marginTop:10}},_react2.default.createElement(_row2.default,{style:{margin:"10px 0"},className:'new-fontSize'},'\u5E02\u573A\u9500\u552E Sales & Marketing'),_react2.default.createElement(TextArea,{rows:4,placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',value:data.sales||"",onChange:function onChange(e){var data=_this2.state.data;data.sales=e.target.value||"";_this2.setState({data:data});}}),_react2.default.createElement(_Auth2.default,{name:'SM'},_react2.default.createElement(_button2.default,{type:'primary',style:{float:"right",marginTop:10,display:this.state.print?'none':''},onClick:function onClick(){_this2.onSave('sales');}// loading={this.state.loadingSave}
},'\u4FDD\u5B58'))),_react2.default.createElement(_row2.default,{style:{marginTop:10}},_react2.default.createElement(_row2.default,{style:{margin:"10px 0"},className:'new-fontSize'},'\u9910\u996E\u65B9\u9762 F&B'),_react2.default.createElement(TextArea,{rows:4,placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',value:data.FB||"",onChange:function onChange(e){var data=_this2.state.data;data.FB=e.target.value||"";_this2.setState({data:data});}}),_react2.default.createElement(_Auth2.default,{name:'FB'},_react2.default.createElement(_button2.default,{type:'primary',style:{float:"right",marginTop:10,display:this.state.print?'none':''},onClick:function onClick(){_this2.onSave('FB');}// loading={this.state.loadingSave}
},'\u4FDD\u5B58'))),_react2.default.createElement(_row2.default,{style:{marginTop:10}},_react2.default.createElement(_row2.default,{style:{margin:"10px 0"},className:'new-fontSize'},'\u4EBA\u529B\u6210\u672C Labor'),_react2.default.createElement(TextArea,{rows:4,placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',value:data.labor||"",onChange:function onChange(e){var data=_this2.state.data;data.labor=e.target.value||"";_this2.setState({data:data});}}),_react2.default.createElement(_Auth2.default,{name:'HR'},_react2.default.createElement(_button2.default,{type:'primary',style:{float:"right",marginTop:10,display:this.state.print?'none':''},onClick:function onClick(){_this2.onSave('labor');}// loading={this.state.loadingSave}
},'\u4FDD\u5B58'))),_react2.default.createElement(_row2.default,{style:{marginTop:10}},_react2.default.createElement(_row2.default,{style:{margin:"10px 0"},className:'new-fontSize'},'\u80FD\u6E90\u6210\u672C Utility Cost'),_react2.default.createElement(TextArea,{rows:4,placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',value:data.cost||"",onChange:function onChange(e){var data=_this2.state.data;data.cost=e.target.value||"";_this2.setState({data:data});}}),_react2.default.createElement(_Auth2.default,{name:'ENG'},_react2.default.createElement(_button2.default,{type:'primary',style:{float:"right",marginTop:10,display:this.state.print?'none':''},onClick:function onClick(){_this2.onSave('cost');}// loading={this.state.loadingSave}
},'\u4FDD\u5B58'))),_react2.default.createElement(_row2.default,{style:{marginTop:10}},_react2.default.createElement(_row2.default,{style:{margin:"10px 0"},className:'new-fontSize'},'\u5176\u4ED6\u8D39\u7528 Other Expense'),_react2.default.createElement(TextArea,{rows:4,placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',value:data.other||"",onChange:function onChange(e){var data=_this2.state.data;data.other=e.target.value||"";_this2.setState({data:data});}}),_react2.default.createElement(_Auth2.default,{name:'FIN'},_react2.default.createElement(_button2.default,{type:'primary',style:{float:"right",marginTop:10,display:this.state.print?'none':''},onClick:function onClick(){_this2.onSave('other');}// loading={this.state.loadingSave}
},'\u4FDD\u5B58'))),_react2.default.createElement(_row2.default,{style:{marginTop:10}},_react2.default.createElement(_row2.default,{style:{margin:"10px 0"},className:'new-fontSize'},'\u8003\u6838\u673A\u5236 Performance Test'),_react2.default.createElement(TextArea,{rows:4,placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',value:data.test||"",onChange:function onChange(e){var data=_this2.state.data;data.test=e.target.value||"";_this2.setState({data:data});}}),_react2.default.createElement(_Auth2.default,{name:'FIN'},_react2.default.createElement(_button2.default,{type:'primary',style:{float:"right",marginTop:10,display:this.state.print?'none':''},onClick:function onClick(){_this2.onSave('test');}// loading={this.state.loadingSave}
},'\u4FDD\u5B58'))),_react2.default.createElement(_row2.default,{style:{marginTop:10}},_react2.default.createElement(_row2.default,{style:{margin:"10px 0"},className:'new-fontSize'},'\u4E1A\u4E3B\u4FE1\u606F Owners\' Information'),_react2.default.createElement(TextArea,{rows:4,placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',value:data.owers||"",onChange:function onChange(e){var data=_this2.state.data;data.owers=e.target.value||"";_this2.setState({data:data});}}),_react2.default.createElement(_Auth2.default,{name:'OPS'},_react2.default.createElement(_button2.default,{type:'primary',style:{float:"right",marginTop:10,display:this.state.print?'none':''},onClick:function onClick(){_this2.onSave('owers');}// loading={this.state.loadingSave}
},'\u4FDD\u5B58'))))),_react2.default.createElement(_row2.default,{className:'table-footer-btn',style:{textAlign:"right",padding:24}},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u5BFC\u51FAPDF')));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(740);
module.exports = __webpack_require__(745);


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(741).enable();
  window.Promise = __webpack_require__(743);
}

// fetch() polyfill for making API calls.
__webpack_require__(744);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(253);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(448);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(448);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 744 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(46);var _reactDom2=_interopRequireDefault(_reactDom);var _Route=__webpack_require__(750);var _Route2=_interopRequireDefault(_Route);var _mobxReact=__webpack_require__(18);var _store=__webpack_require__(2235);var _store2=_interopRequireDefault(_store);__webpack_require__(2267);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}_reactDom2.default.render(_react2.default.createElement(_mobxReact.Provider,{store:_store2.default},_react2.default.createElement(_Route2.default,null)),document.getElementById('root'));

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(253),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(253),r=__webpack_require__(748);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(749);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _notification2=__webpack_require__(819);var _notification3=_interopRequireDefault(_notification2);var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(6);__webpack_require__(10);__webpack_require__(833);__webpack_require__(62);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(85);var _login=__webpack_require__(860);var _login2=_interopRequireDefault(_login);var _admin=__webpack_require__(887);var _admin2=_interopRequireDefault(_admin);var _remind=__webpack_require__(2233);var _remind2=_interopRequireDefault(_remind);var _Bundle=__webpack_require__(2234);var _Bundle2=_interopRequireDefault(_Bundle);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// 按需加载组件
var confirm=_modal2.default.confirm;function getCookie(c_name){if(document.cookie.length>0){var c_start=document.cookie.indexOf(c_name+"=");if(c_start!=-1){c_start=c_start+c_name.length+1;var c_end=document.cookie.indexOf(";",c_start);if(c_end==-1)c_end=document.cookie.length;return unescape(document.cookie.substring(c_start,c_end));}}return"";}// 按需加载配置
// 由于ES 按需加载会导致页面渲染两次，改为默认加载
// const App = (props) => (
//     <Bundle load={() => import('./components/admin')}>
//         {(Chat) => <Chat {...props} />}
//     </Bundle>
// );
var Bp=function Bp(props){return _react2.default.createElement(_Bundle2.default,{load:function load(){return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 2270));}},function(Chat){return _react2.default.createElement(Chat,props);});};var Hr=function Hr(props){return _react2.default.createElement(_Bundle2.default,{load:function load(){return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 2271));}},function(Chat){return _react2.default.createElement(Chat,props);});};var pay=function pay(props){return _react2.default.createElement(_Bundle2.default,{load:function load(){return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 2272));}},function(Chat){return _react2.default.createElement(Chat,props);});};var payres=function payres(props){return _react2.default.createElement(_Bundle2.default,{load:function load(){return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 2273));}},function(Chat){return _react2.default.createElement(Chat,props);});};var PaySelect=function PaySelect(props){return _react2.default.createElement(_Bundle2.default,{load:function load(){return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 2274));}},function(Chat){return _react2.default.createElement(Chat,props);});};var RouteComponent=function(_Component){_inherits(RouteComponent,_Component);function RouteComponent(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,RouteComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RouteComponent.__proto__||Object.getPrototypeOf(RouteComponent)).call.apply(_ref,[this].concat(args))),_this),_this.state={hotel:{},isAdmin:false,open:true},_this.onPay=function(item){_notification3.default.close(item.id);window.location.href=item.path;},_this.onNoPrompt=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(item){var data;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return(0,_request2.default)('/deleteNotice?id='+item.id);case 3:data=_context.sent;if(!(data.status==1)){_context.next=7;break;}_notification3.default.close(item.id);return _context.abrupt('return');case 7:_message3.default.error('关闭失败！');_context.next=13;break;case 10:_context.prev=10;_context.t0=_context['catch'](0);console.error(_context.t0);case 13:case'end':return _context.stop();}}},_callee,_this2,[[0,10]]);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.getExpireDate=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(){var _ret2;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;return _context3.delegateYield(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var d,_ref4,_ref4$hotel,hotel,isAdmin,isReload,_ref4$notice,notice,chargeNotice,_loop,index;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return(0,_request2.default)('/getExpireDate?v=1.200813');case 2:d=_context2.sent;_ref4=d.data||{},_ref4$hotel=_ref4.hotel,hotel=_ref4$hotel===undefined?{}:_ref4$hotel,isAdmin=_ref4.isAdmin,isReload=_ref4.isReload,_ref4$notice=_ref4.notice,notice=_ref4$notice===undefined?[]:_ref4$notice,chargeNotice=_ref4.chargeNotice;_this.setState({hotel:hotel,isAdmin:!!isAdmin});if(!(d.status==5)){_context2.next=8;break;}window.location.href='/#/login';return _context2.abrupt('return',{v:void 0});case 8:if(isReload){window.location.reload();}_loop=function _loop(index){var ishotel=(notice[index].hotels||'').split(',').some(function(x){return x==hotel.id;});var item=notice[index];var that=_this;if(ishotel&&item.modal==1){if(!item.path||'/'+window.location.hash!=item.path)confirm({title:item.title,// icon: <ExclamationCircleOutlined />,
content:_react2.default.createElement('div',{className:'home-richText',dangerouslySetInnerHTML:{__html:item.content||""}}),cancelText:item.isclose!=1?'不再提醒':"我已知晓",okText:item.button_name||"确定",onOk:function onOk(){if(item.path&&'/'+window.location.hash!=item.path){window.location.href=item.path;}},onCancel:function onCancel(){item.isclose!=1&&that.onNoPrompt(item);}});}else if(ishotel){_notification3.default[item.type]({message:item.title,duration:null,description:_react2.default.createElement('div',null,_react2.default.createElement('div',{className:'home-richText',dangerouslySetInnerHTML:{__html:item.content||""}}),item.button_name&&_react2.default.createElement('div',{style:{margin:'20px 0 10px 0',textAlign:"center"}},_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){return _this.onPay(item);}},item.button_name)),item.isclose!=1&&_react2.default.createElement('div',{style:{textAlign:'center'}},_react2.default.createElement('a',{onClick:_this.onNoPrompt.bind(_this,item)},'\u4E0D\u518D\u63D0\u9192'))),key:item.id});}};for(index=0;index<notice.length;index++){_loop(index);}case 11:case'end':return _context2.stop();}}},_callee2,_this2);})(),'t0',2);case 2:_ret2=_context3.t0;if(!((typeof _ret2==='undefined'?'undefined':_typeof(_ret2))==="object")){_context3.next=5;break;}return _context3.abrupt('return',_ret2.v);case 5:_context3.next=10;break;case 7:_context3.prev=7;_context3.t1=_context3['catch'](0);console.error(_context3.t1);case 10:case'end':return _context3.stop();}}},_callee3,_this2,[[0,7]]);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RouteComponent,[{key:'componentDidMount',value:function componentDidMount(){this.getExpireDate();}},{key:'render',value:function render(){var user=getCookie('user')||"{}";return _react2.default.createElement(_reactRouterDom.HashRouter,null,_react2.default.createElement('div',null,_react2.default.createElement(_reactRouterDom.Switch,null,_react2.default.createElement(_reactRouterDom.Route,{path:'/table',component:_admin2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/bp',component:Bp}),_react2.default.createElement(_reactRouterDom.Route,{path:'/hr',component:Hr}),_react2.default.createElement(_reactRouterDom.Route,{path:'/login',component:_login2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/pay',component:pay}),_react2.default.createElement(_reactRouterDom.Route,{path:'/payselect',component:PaySelect}),_react2.default.createElement(_reactRouterDom.Route,{path:'/payresult/:code',component:payres}),_react2.default.createElement(_reactRouterDom.Redirect,{from:'/',to:user&&!window.location.pathname.includes('table')?"/table/cover":"/login"}))));}}]);return RouteComponent;}(_react.Component);exports.default=RouteComponent;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(19));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _reactLifecyclesCompat = __webpack_require__(36);

var _omit = _interopRequireDefault(__webpack_require__(71));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _configProvider = __webpack_require__(39);

var _wave = _interopRequireDefault(__webpack_require__(334));

var _type = __webpack_require__(130);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable react/button-has-type */


var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);

function isString(str) {
  return typeof str === 'string';
} // Insert one space between two chinese characters automatically.


function insertSpace(child, needInserted) {
  // Check the child if is undefined or null.
  if (child == null) {
    return;
  }

  var SPACE = needInserted ? ' ' : ''; // strictNullChecks oops.

  if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
    return /*#__PURE__*/React.cloneElement(child, {}, child.props.children.split('').join(SPACE));
  }

  if (typeof child === 'string') {
    if (isTwoCNChar(child)) {
      child = child.split('').join(SPACE);
    }

    return /*#__PURE__*/React.createElement("span", null, child);
  }

  return child;
}

function spaceChildren(children, needInserted) {
  var isPrevChildPure = false;
  var childList = [];
  React.Children.forEach(children, function (child) {
    var type = _typeof(child);

    var isCurrentChildPure = type === 'string' || type === 'number';

    if (isPrevChildPure && isCurrentChildPure) {
      var lastIndex = childList.length - 1;
      var lastChild = childList[lastIndex];
      childList[lastIndex] = "".concat(lastChild).concat(child);
    } else {
      childList.push(child);
    }

    isPrevChildPure = isCurrentChildPure;
  }); // Pass to React.Children.map to auto fill key

  return React.Children.map(childList, function (child) {
    return insertSpace(child, needInserted);
  });
}

var ButtonTypes = (0, _type.tuple)('default', 'primary', 'ghost', 'dashed', 'danger', 'link');
var ButtonShapes = (0, _type.tuple)('circle', 'circle-outline', 'round');
var ButtonSizes = (0, _type.tuple)('large', 'default', 'small');
var ButtonHTMLTypes = (0, _type.tuple)('submit', 'button', 'reset');

var Button = /*#__PURE__*/function (_React$Component) {
  _inherits(Button, _React$Component);

  var _super = _createSuper(Button);

  function Button(props) {
    var _this;

    _classCallCheck(this, Button);

    _this = _super.call(this, props);

    _this.saveButtonRef = function (node) {
      _this.buttonNode = node;
    };

    _this.handleClick = function (e) {
      var loading = _this.state.loading;
      var onClick = _this.props.onClick;

      if (loading) {
        return;
      }

      if (onClick) {
        onClick(e);
      }
    };

    _this.renderButton = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls,
          autoInsertSpaceInButton = _ref.autoInsertSpaceInButton;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          type = _a.type,
          shape = _a.shape,
          size = _a.size,
          className = _a.className,
          children = _a.children,
          icon = _a.icon,
          ghost = _a.ghost,
          block = _a.block,
          rest = __rest(_a, ["prefixCls", "type", "shape", "size", "className", "children", "icon", "ghost", "block"]);

      var _this$state = _this.state,
          loading = _this$state.loading,
          hasTwoCNChar = _this$state.hasTwoCNChar;
      var prefixCls = getPrefixCls('btn', customizePrefixCls);
      var autoInsertSpace = autoInsertSpaceInButton !== false; // large => lg
      // small => sm

      var sizeCls = '';

      switch (size) {
        case 'large':
          sizeCls = 'lg';
          break;

        case 'small':
          sizeCls = 'sm';
          break;

        default:
          break;
      }

      var iconType = loading ? 'loading' : icon;
      var classes = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(shape), shape), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), _defineProperty(_classNames, "".concat(prefixCls, "-icon-only"), !children && children !== 0 && iconType), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), !!loading), _defineProperty(_classNames, "".concat(prefixCls, "-background-ghost"), ghost), _defineProperty(_classNames, "".concat(prefixCls, "-two-chinese-chars"), hasTwoCNChar && autoInsertSpace), _defineProperty(_classNames, "".concat(prefixCls, "-block"), block), _classNames));
      var iconNode = iconType ? /*#__PURE__*/React.createElement(_icon["default"], {
        type: iconType
      }) : null;
      var kids = children || children === 0 ? spaceChildren(children, _this.isNeedInserted() && autoInsertSpace) : null;
      var linkButtonRestProps = (0, _omit["default"])(rest, ['htmlType', 'loading']);

      if (linkButtonRestProps.href !== undefined) {
        return /*#__PURE__*/React.createElement("a", _extends({}, linkButtonRestProps, {
          className: classes,
          onClick: _this.handleClick,
          ref: _this.saveButtonRef
        }), iconNode, kids);
      } // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.


      var _b = rest,
          htmlType = _b.htmlType,
          otherProps = __rest(_b, ["htmlType"]);

      var buttonNode = /*#__PURE__*/React.createElement("button", _extends({}, (0, _omit["default"])(otherProps, ['loading']), {
        type: htmlType,
        className: classes,
        onClick: _this.handleClick,
        ref: _this.saveButtonRef
      }), iconNode, kids);

      if (type === 'link') {
        return buttonNode;
      }

      return /*#__PURE__*/React.createElement(_wave["default"], null, buttonNode);
    };

    _this.state = {
      loading: props.loading,
      hasTwoCNChar: false
    };
    return _this;
  }

  _createClass(Button, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fixTwoCNChar();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      this.fixTwoCNChar();

      if (prevProps.loading && typeof prevProps.loading !== 'boolean') {
        clearTimeout(this.delayTimeout);
      }

      var loading = this.props.loading;

      if (loading && typeof loading !== 'boolean' && loading.delay) {
        this.delayTimeout = window.setTimeout(function () {
          _this2.setState({
            loading: loading
          });
        }, loading.delay);
      } else if (prevProps.loading !== loading) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          loading: loading
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.delayTimeout) {
        clearTimeout(this.delayTimeout);
      }
    }
  }, {
    key: "fixTwoCNChar",
    value: function fixTwoCNChar() {
      // Fix for HOC usage like <FormatMessage />
      if (!this.buttonNode) {
        return;
      }

      var buttonText = this.buttonNode.textContent;

      if (this.isNeedInserted() && isTwoCNChar(buttonText)) {
        if (!this.state.hasTwoCNChar) {
          this.setState({
            hasTwoCNChar: true
          });
        }
      } else if (this.state.hasTwoCNChar) {
        this.setState({
          hasTwoCNChar: false
        });
      }
    }
  }, {
    key: "isNeedInserted",
    value: function isNeedInserted() {
      var _this$props = this.props,
          icon = _this$props.icon,
          children = _this$props.children,
          type = _this$props.type;
      return React.Children.count(children) === 1 && !icon && type !== 'link';
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderButton);
    }
  }]);

  return Button;
}(React.Component);

Button.__ANT_BUTTON = true;
Button.defaultProps = {
  loading: false,
  ghost: false,
  block: false,
  htmlType: 'button'
};
Button.propTypes = {
  type: PropTypes.string,
  shape: PropTypes.oneOf(ButtonShapes),
  size: PropTypes.oneOf(ButtonSizes),
  htmlType: PropTypes.oneOf(ButtonHTMLTypes),
  onClick: PropTypes.func,
  loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  className: PropTypes.string,
  icon: PropTypes.string,
  block: PropTypes.bool,
  title: PropTypes.string
};
(0, _reactLifecyclesCompat.polyfill)(Button);
var _default = Button;
exports["default"] = _default;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(753);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(755), __esModule: true };

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(756);
module.exports = __webpack_require__(88).Object.assign;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(140);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(758) });


/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(143);
var getKeys = __webpack_require__(254);
var gOPS = __webpack_require__(324);
var pIE = __webpack_require__(257);
var toObject = __webpack_require__(217);
var IObject = __webpack_require__(452);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(187)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(155);
var toLength = __webpack_require__(453);
var toAbsoluteIndex = __webpack_require__(760);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(320);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var normalViewBox = '0 0 1024 1024';
var newViewBox = '64 64 896 896';
var fill = 'fill';
var outline = 'outline';
var twotone = 'twotone';
function getNode(viewBox) {
    var paths = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        paths[_i - 1] = arguments[_i];
    }
    return {
        tag: 'svg',
        attrs: { viewBox: viewBox, focusable: false },
        children: paths.map(function (path) {
            if (Array.isArray(path)) {
                return {
                    tag: 'path',
                    attrs: {
                        fill: path[0],
                        d: path[1]
                    }
                };
            }
            return {
                tag: 'path',
                attrs: {
                    d: path
                }
            };
        })
    };
}
function getIcon(name, theme, icon) {
    return {
        name: name,
        theme: theme,
        icon: icon
    };
}
exports.AccountBookFill = getIcon('account-book', fill, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM648.3 426.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V752c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 0 1 8.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z'));
exports.AlertFill = getIcon('alert', fill, getNode(newViewBox, 'M512 244c176.18 0 319 142.82 319 319v233a32 32 0 0 1-32 32H225a32 32 0 0 1-32-32V563c0-176.18 142.82-319 319-319zM484 68h56a8 8 0 0 1 8 8v96a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8V76a8 8 0 0 1 8-8zM177.25 191.66a8 8 0 0 1 11.32 0l67.88 67.88a8 8 0 0 1 0 11.31l-39.6 39.6a8 8 0 0 1-11.31 0l-67.88-67.88a8 8 0 0 1 0-11.31l39.6-39.6zm669.6 0l39.6 39.6a8 8 0 0 1 0 11.3l-67.88 67.9a8 8 0 0 1-11.32 0l-39.6-39.6a8 8 0 0 1 0-11.32l67.89-67.88a8 8 0 0 1 11.31 0zM192 892h640a32 32 0 0 1 32 32v24a8 8 0 0 1-8 8H168a8 8 0 0 1-8-8v-24a32 32 0 0 1 32-32zm148-317v253h64V575h-64z'));
exports.AlipaySquareFill = getIcon('alipay-square', fill, getNode(newViewBox, 'M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm29.4 663.2S703 689.4 598.7 639.5C528.8 725.2 438.6 777.3 345 777.3c-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9 114.3 38.2 140.2 40.2 140.2 40.2v122.3z'));
exports.AliwangwangFill = getIcon('aliwangwang', fill, getNode(newViewBox, 'M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 0 0-120.5-81.2A375.65 375.65 0 0 0 519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 0 0-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0 0 29.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-325.2 79c0 20.4-16.6 37.1-37.1 37.1-20.4 0-37.1-16.7-37.1-37.1v-55.1c0-20.4 16.6-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1zm175.2 0c0 20.4-16.6 37.1-37.1 37.1S644 476.8 644 456.4v-55.1c0-20.4 16.7-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1z'));
exports.AlipayCircleFill = getIcon('alipay-circle', fill, getNode(newViewBox, 'M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 0 0 960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z'));
exports.AmazonCircleFill = getIcon('amazon-circle', fill, getNode(newViewBox, 'M485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm35.8 262.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 0 0-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9 4.7-12.2 11.8-23.9 21.4-35 9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0 1 25.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 0 1 7.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 0 1-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7z'));
exports.AndroidFill = getIcon('android', fill, getNode(newViewBox, 'M270.1 741.7c0 23.4 19.1 42.5 42.6 42.5h48.7v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h85v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h48.7c23.5 0 42.6-19.1 42.6-42.5V346.4h-486v395.3zm357.1-600.1l44.9-65c2.6-3.8 2-8.9-1.5-11.4-3.5-2.4-8.5-1.2-11.1 2.6l-46.6 67.6c-30.7-12.1-64.9-18.8-100.8-18.8-35.9 0-70.1 6.7-100.8 18.8l-46.6-67.5c-2.6-3.8-7.6-5.1-11.1-2.6-3.5 2.4-4.1 7.4-1.5 11.4l44.9 65c-71.4 33.2-121.4 96.1-127.8 169.6h486c-6.6-73.6-56.7-136.5-128-169.7zM409.5 244.1a26.9 26.9 0 1 1 26.9-26.9 26.97 26.97 0 0 1-26.9 26.9zm208.4 0a26.9 26.9 0 1 1 26.9-26.9 26.97 26.97 0 0 1-26.9 26.9zm223.4 100.7c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c.1-30.6-24.3-55.3-54.6-55.3zm-658.6 0c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c0-30.6-24.5-55.3-54.6-55.3z'));
exports.AmazonSquareFill = getIcon('amazon-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM547.8 326.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 0 0-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9s11.8-23.9 21.4-35c9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0 1 25.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 0 1 7.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 0 1-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7zM485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4z'));
exports.ApiFill = getIcon('api', fill, getNode(newViewBox, 'M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM578.9 546.7a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 68.9-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2z'));
exports.AppstoreFill = getIcon('appstore', fill, getNode(newViewBox, 'M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zM464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16z'));
exports.AudioFill = getIcon('audio', fill, getNode(newViewBox, 'M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm330-170c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z'));
exports.AppleFill = getIcon('apple', fill, getNode(newViewBox, 'M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z'));
exports.BackwardFill = getIcon('backward', fill, getNode(normalViewBox, 'M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 0 0-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z'));
exports.BankFill = getIcon('bank', fill, getNode(newViewBox, 'M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374z'));
exports.BehanceCircleFill = getIcon('behance-circle', fill, getNode(newViewBox, 'M420.3 470.3c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1a50.5 50.5 0 0 0 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm86.5 286.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7z'));
exports.BellFill = getIcon('bell', fill, getNode(newViewBox, 'M816 768h-24V428c0-141.1-104.3-257.8-240-277.2V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.8C336.3 170.2 232 286.9 232 428v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48z'));
exports.BehanceSquareFill = getIcon('behance-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z'));
exports.BookFill = getIcon('book', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM668 345.9L621.5 312 572 347.4V124h96v221.9z'));
exports.BoxPlotFill = getIcon('box-plot', fill, getNode(newViewBox, 'M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H448v432h344c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-728 80v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h152V296H232c-4.4 0-8 3.6-8 8z'));
exports.BugFill = getIcon('bug', fill, getNode(newViewBox, 'M304 280h416c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1a184.31 184.31 0 0 0-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9a184.31 184.31 0 0 0-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z', 'M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8a63 63 0 0 1-63 63H232a63 63 0 0 1-63-63c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7a273 273 0 0 0 22.7 49c24.3 41.5 59 76.2 100.5 100.5 28.9 16.9 61 28.8 95.3 34.5 4.4 0 8-3.6 8-8V484c0-4.4 3.6-8 8-8h60c4.4 0 8 3.6 8 8v464.2c0 4.4 3.6 8 8 8 34.3-5.7 66.4-17.6 95.3-34.5a281.38 281.38 0 0 0 123.2-149.5A120.4 120.4 0 0 1 836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.CalculatorFill = getIcon('calculator', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM440.2 765h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 0 1-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zm7.8-382c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48zm328 369c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-104c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-265c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48z'));
exports.BulbFill = getIcon('bulb', fill, getNode(newViewBox, 'M348 676.1C250 619.4 184 513.4 184 392c0-181.1 146.9-328 328-328s328 146.9 328 328c0 121.4-66 227.4-164 284.1V792c0 17.7-14.3 32-32 32H380c-17.7 0-32-14.3-32-32V676.1zM392 888h240c4.4 0 8 3.6 8 8v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32v-32c0-4.4 3.6-8 8-8z'));
exports.BuildFill = getIcon('build', fill, getNode(newViewBox, 'M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM612 746H412V546h200v200zm268-268H680V278h200v200z'));
exports.CalendarFill = getIcon('calendar', fill, getNode(newViewBox, 'M112 880c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V460H112v420zm768-696H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v176h800V216c0-17.7-14.3-32-32-32z'));
exports.CameraFill = getIcon('camera', fill, getNode(newViewBox, 'M864 260H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 260H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V340c0-44.2-35.8-80-80-80zM512 716c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160zm-96-160a96 96 0 1 0 192 0 96 96 0 1 0-192 0z'));
exports.CarFill = getIcon('car', fill, getNode(newViewBox, 'M959 413.4L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM220 418l72.7-199.9.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220z'));
exports.CaretDownFill = getIcon('caret-down', fill, getNode(normalViewBox, 'M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z'));
exports.CaretLeftFill = getIcon('caret-left', fill, getNode(normalViewBox, 'M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z'));
exports.CaretRightFill = getIcon('caret-right', fill, getNode(normalViewBox, 'M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z'));
exports.CarryOutFill = getIcon('carry-out', fill, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM694.5 432.7L481.9 725.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z'));
exports.CaretUpFill = getIcon('caret-up', fill, getNode(normalViewBox, 'M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z'));
exports.CheckCircleFill = getIcon('check-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z'));
exports.CheckSquareFill = getIcon('check-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM695.5 365.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L308.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H689c6.5 0 10.3 7.4 6.5 12.7z'));
exports.ChromeFill = getIcon('chrome', fill, getNode(newViewBox, 'M371.8 512c0 77.5 62.7 140.2 140.2 140.2S652.2 589.5 652.2 512 589.5 371.8 512 371.8 371.8 434.4 371.8 512zM900 362.4l-234.3 12.1c63.6 74.3 64.6 181.5 11.1 263.7l-188 289.2c78 4.2 158.4-12.9 231.2-55.2 180-104 253-322.1 180-509.8zM320.3 591.9L163.8 284.1A415.35 415.35 0 0 0 96 512c0 208 152.3 380.3 351.4 410.8l106.9-209.4c-96.6 18.2-189.9-34.8-234-121.5zm218.5-285.5l344.4 18.1C848 254.7 792.6 194 719.8 151.7 653.9 113.6 581.5 95.5 510.5 96c-122.5.5-242.2 55.2-322.1 154.5l128.2 196.9c32-91.9 124.8-146.7 222.2-141z'));
exports.CiCircleFill = getIcon('ci-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-63.6 656c-103 0-162.4-68.6-162.4-182.6v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-4-46.1-37.6-77.6-87-77.6-61.1 0-95.6 45.4-95.6 126.9v49.3c0 80.3 34.5 125.1 95.6 125.1 49.3 0 82.8-29.5 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z'));
exports.ClockCircleFill = getIcon('clock-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm176.5 585.7l-28.6 39a7.99 7.99 0 0 1-11.2 1.7L483.3 569.8a7.92 7.92 0 0 1-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z'));
exports.CloseCircleFill = getIcon('close-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 0 1-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z'));
exports.CloudFill = getIcon('cloud', fill, getNode(newViewBox, 'M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3z'));
exports.CloseSquareFill = getIcon('close-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM676.1 657.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1A7.95 7.95 0 0 1 354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9z'));
exports.CodeSandboxSquareFill = getIcon('code-sandbox-square', fill, getNode(newViewBox, 'M307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM755.7 653.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zm-223.9 83.7l97.3-56.2v-94.1l87-49.5V418.5L531.8 525zm-20-352L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8z'));
exports.CodeSandboxCircleFill = getIcon('code-sandbox-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm243.7 589.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zM307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zm203.9-151.8L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8zm20 352l97.3-56.2v-94.1l87-49.5V418.5L531.8 525z'));
exports.CodeFill = getIcon('code', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM513.1 518.1l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 0 1-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3zM716 673c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8h185c4.1 0 7.5 3.6 7.5 8v48z'));
exports.CompassFill = getIcon('compass', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM327.3 702.4c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2l98.7-225.5 132.1 132.1-225.5 98.7zm375.1-375.1l-98.7 225.5-132.1-132.1L697.1 322c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z'));
exports.CodepenCircleFill = getIcon('codepen-circle', fill, getNode(newViewBox, 'M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z'));
exports.CodepenSquareFill = getIcon('codepen-square', fill, getNode(newViewBox, 'M723.1 428L535.9 303.4v111.3l103.6 69.1zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zm23.9 154.2v111.3L723.1 597l-83.6-55.8zm-151.4-69.1L300.9 597l187.2 124.6V610.3l-103.6-69.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-90 485c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-47.8-44.6v-79.8l-59.8 39.9zm-460.4-79.8v79.8l59.8-39.9zm206.3-57.9V303.4L300.9 428l83.6 55.8z'));
exports.ContactsFill = getIcon('contacts', fill, getNode(newViewBox, 'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM661 736h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.6-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H363a8 8 0 0 1-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 0 1-29.1-75.5c0-61.9 49.9-112 111.4-112 61.5 0 111.4 50.1 111.4 112 0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zM512 474c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52c28.5 0 51.7-23.3 51.7-52s-23.2-52-51.7-52z'));
exports.ControlFill = getIcon('control', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM404 683v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99zm279.6-143.9c.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1zM616 440a36 36 0 1 0 72 0 36 36 0 1 0-72 0zM403.4 566.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 0 0-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5z'));
exports.ContainerFill = getIcon('container', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v529c0-.6.4-1 1-1h219.3l5.2 24.7C397.6 708.5 450.8 752 512 752s114.4-43.5 126.4-103.3l5.2-24.7H863c.6 0 1 .4 1 1V96c0-17.7-14.3-32-32-32zM712 493c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm0-160c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm151 354H694.1c-11.6 32.8-32 62.3-59.1 84.7-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 0 1-59.1-84.7H161c-.6 0-1-.4-1-1v242c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V686c0 .6-.4 1-1 1z'));
exports.CopyFill = getIcon('copy', fill, getNode(newViewBox, 'M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM382 896h-.2L232 746.2v-.2h150v150z'));
exports.CopyrightCircleFill = getIcon('copyright-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm5.4 670c-110 0-173.4-73.2-173.4-194.9v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.6-3.2-8-7.4-4-49.5-40-83.4-93-83.4-65.3 0-102.1 48.5-102.1 135.5v52.6c0 85.7 36.9 133.6 102.1 133.6 52.8 0 88.7-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4z'));
exports.CreditCardFill = getIcon('credit-card', fill, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v160h896V192c0-17.7-14.3-32-32-32zM64 832c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V440H64v392zm579-184c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72z'));
exports.CrownFill = getIcon('crown', fill, getNode(newViewBox, 'M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zM512 734.2c-62.1 0-112.6-50.5-112.6-112.6S449.9 509 512 509s112.6 50.5 112.6 112.6S574.1 734.2 512 734.2zm0-160.9c-26.6 0-48.2 21.6-48.2 48.3 0 26.6 21.6 48.3 48.2 48.3s48.2-21.6 48.2-48.3c0-26.6-21.6-48.3-48.2-48.3z'));
exports.CustomerServiceFill = getIcon('customer-service', fill, getNode(newViewBox, 'M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384z'));
exports.DashboardFill = getIcon('dashboard', fill, getNode(newViewBox, 'M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM482 232c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.5l-31.1 31.1a8.03 8.03 0 0 1-11.3 0L261.7 352a8.03 8.03 0 0 1 0-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.6l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 0 1-79.2 0 55.95 55.95 0 0 1 0-79.2 55.87 55.87 0 0 1 54.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.1 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 0 1 0-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 0 1-11.3 0zM846 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44z'));
exports.DeleteFill = getIcon('delete', fill, getNode(newViewBox, 'M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-200 0H360v-72h304v72z'));
exports.DiffFill = getIcon('diff', fill, getNode(newViewBox, 'M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23zM553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM568 753c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-220c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7v42z'));
exports.DingtalkCircleFill = getIcon('dingtalk-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm227 385.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z'));
exports.DatabaseFill = getIcon('database', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM288 232c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm128-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm128-168c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'));
exports.DingtalkSquareFill = getIcon('dingtalk-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM739 449.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z'));
exports.DislikeFill = getIcon('dislike', fill, getNode(newViewBox, 'M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H273v428h.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32z'));
exports.DollarCircleFill = getIcon('dollar-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm22.3 665.2l.2 31.7c0 4.4-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4C401.3 723 359.5 672.4 355 617.4c-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.7 29.8 55.4 74.1 61.3V533.9l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-72.9 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.9 46.9 125.9 109.2.5 4.7-3.2 8.8-8 8.8h-44.9c-4 0-7.4-3-7.9-6.9-4-29.2-27.4-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 108.9 116.4 0 75.3-56 117.3-134.3 124.1zM426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-36.9 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.8-.6-5.6-1.3-8.8-2.2V677c42.6-3.8 72-27.2 72-66.4 0-30.7-15.9-50.7-63.2-65.1z'));
exports.DownCircleFill = getIcon('down-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm184.5 353.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z'));
exports.DownSquareFill = getIcon('down-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM696.5 412.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z'));
exports.DribbbleCircleFill = getIcon('dribbble-circle', fill, getNode(newViewBox, 'M675.1 328.3a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6zm47.7-11.9c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 736c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm53.1-346.2c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm30.6 82.5c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4z'));
exports.DribbbleSquareFill = getIcon('dribbble-square', fill, getNode(newViewBox, 'M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z'));
exports.DropboxCircleFill = getIcon('dropbox-circle', fill, getNode(newViewBox, 'M663.8 455.5zm-151.5-93.8l-151.8 93.8 151.8 93.9 151.5-93.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm151.2 595.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1z'));
exports.DropboxSquareFill = getIcon('dropbox-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM663.2 659.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1zM512.3 361.7l-151.8 93.8 151.8 93.9 151.5-93.9zm151.5 93.8z'));
exports.EnvironmentFill = getIcon('environment', fill, getNode(newViewBox, 'M512 327c-29.9 0-58 11.6-79.2 32.8A111.6 111.6 0 0 0 400 439c0 29.9 11.7 58 32.8 79.2A111.6 111.6 0 0 0 512 551c29.9 0 58-11.7 79.2-32.8C612.4 497 624 468.9 624 439c0-29.9-11.6-58-32.8-79.2S541.9 327 512 327zm342.6-37.9a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z'));
exports.EditFill = getIcon('edit', fill, getNode(newViewBox, 'M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9z'));
exports.ExclamationCircleFill = getIcon('exclamation-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.EuroCircleFill = getIcon('euro-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm63.5 375.8c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8h-136c-.3 4.4-.3 9.1-.3 13.8v36h136.2c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H444.9c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.2 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.3 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.8.3-12.8H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.7c19.7-94.2 92-149.9 198.6-149.9 20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346h.1c0 5.1-4.6 8.8-9.6 7.8-14.7-2.9-31.8-4.4-51.7-4.4-65.4 0-110.4 33.5-127.6 90.4h128.4z'));
exports.ExperimentFill = getIcon('experiment', fill, getNode(newViewBox, 'M218.9 636.3l42.6 26.6c.1.1.3.2.4.3l12.7 8 .3.3a186.9 186.9 0 0 0 94.1 25.1c44.9 0 87.2-15.7 121-43.8a256.27 256.27 0 0 1 164.9-59.9c52.3 0 102.2 15.7 144.6 44.5l7.9 5-111.6-289V179.8h63.5c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8H264.7c-4.4 0-8 3.6-8 8v51.9c0 4.4 3.6 8 8 8h63.5v173.6L218.9 636.3zm333-203.1c22 0 39.9 17.9 39.9 39.9S573.9 513 551.9 513 512 495.1 512 473.1s17.9-39.9 39.9-39.9zM878 825.1l-29.9-77.4-85.7-53.5-.1.1c-.7-.5-1.5-1-2.2-1.5l-8.1-5-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 0 1-164.9 59.9c-53 0-103.5-16.1-146.2-45.6l-28.9-18.1L146 825.1c-2.8 7.4-4.3 15.2-4.3 23 0 35.2 28.6 63.8 63.8 63.8h612.9c7.9 0 15.7-1.5 23-4.3a63.6 63.6 0 0 0 36.6-82.5z'));
exports.EyeInvisibleFill = getIcon('eye-invisible', fill, getNode(newViewBox, 'M508 624a112 112 0 0 0 112-112c0-3.28-.15-6.53-.43-9.74L498.26 623.57c3.21.28 6.45.43 9.74.43zm370.72-458.44L836 122.88a8 8 0 0 0-11.31 0L715.37 232.23Q624.91 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.7 119.43 136.55 191.45L112.56 835a8 8 0 0 0 0 11.31L155.25 889a8 8 0 0 0 11.31 0l712.16-712.12a8 8 0 0 0 0-11.32zM332 512a176 176 0 0 1 258.88-155.28l-48.62 48.62a112.08 112.08 0 0 0-140.92 140.92l-48.62 48.62A175.09 175.09 0 0 1 332 512z', 'M942.2 486.2Q889.4 375 816.51 304.85L672.37 449A176.08 176.08 0 0 1 445 676.37L322.74 798.63Q407.82 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5z'));
exports.EyeFill = getIcon('eye', fill, getNode(newViewBox, 'M396 512a112 112 0 1 0 224 0 112 112 0 1 0-224 0zm546.2-25.8C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z'));
exports.FacebookFill = getIcon('facebook', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-92.4 233.5h-63.9c-50.1 0-59.8 23.8-59.8 58.8v77.1h119.6l-15.6 120.7h-104V912H539.2V602.2H434.9V481.4h104.3v-89c0-103.3 63.1-159.6 155.3-159.6 44.2 0 82.1 3.3 93.2 4.8v107.9z'));
exports.FastBackwardFill = getIcon('fast-backward', fill, getNode(normalViewBox, 'M517.6 273.5L230.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z'));
exports.FastForwardFill = getIcon('fast-forward', fill, getNode(normalViewBox, 'M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 0 0 0-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z'));
exports.FileAddFill = getIcon('file-add', fill, getNode(newViewBox, 'M480 580H372a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h108v108a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8V644h108a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H544V472a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v108zm374.6-291.3c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z'));
exports.FileExcelFill = getIcon('file-excel', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM575.34 477.84l-61.22 102.3L452.3 477.8a12 12 0 0 0-10.27-5.79h-38.44a12 12 0 0 0-6.4 1.85 12 12 0 0 0-3.75 16.56l82.34 130.42-83.45 132.78a12 12 0 0 0-1.84 6.39 12 12 0 0 0 12 12h34.46a12 12 0 0 0 10.21-5.7l62.7-101.47 62.3 101.45a12 12 0 0 0 10.23 5.72h37.48a12 12 0 0 0 6.48-1.9 12 12 0 0 0 3.62-16.58l-83.83-130.55 85.3-132.47a12 12 0 0 0 1.9-6.5 12 12 0 0 0-12-12h-35.7a12 12 0 0 0-10.29 5.84z'));
exports.FileExclamationFill = getIcon('file-exclamation', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 784a40 40 0 1 0 0-80 40 40 0 0 0 0 80zm32-152V448a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v184a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8z'));
exports.FileImageFill = getIcon('file-image', fill, getNode(newViewBox, 'M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM400 402c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0 1 12.6 0l41.1 52.4 77.8-99.2a8 8 0 0 1 12.6 0l136.5 174c4.3 5.2.5 12.9-6.1 12.9zm-94-370V137.8L790.2 326H602z'));
exports.FileMarkdownFill = getIcon('file-markdown', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM426.13 600.93l59.11 132.97a16 16 0 0 0 14.62 9.5h24.06a16 16 0 0 0 14.63-9.51l59.1-133.35V758a16 16 0 0 0 16.01 16H641a16 16 0 0 0 16-16V486a16 16 0 0 0-16-16h-34.75a16 16 0 0 0-14.67 9.62L512.1 662.2l-79.48-182.59a16 16 0 0 0-14.67-9.61H383a16 16 0 0 0-16 16v272a16 16 0 0 0 16 16h27.13a16 16 0 0 0 16-16V600.93z'));
exports.FilePdfFill = getIcon('file-pdf', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM633.22 637.26c-15.18-.5-31.32.67-49.65 2.96-24.3-14.99-40.66-35.58-52.28-65.83l1.07-4.38 1.24-5.18c4.3-18.13 6.61-31.36 7.3-44.7.52-10.07-.04-19.36-1.83-27.97-3.3-18.59-16.45-29.46-33.02-30.13-15.45-.63-29.65 8-33.28 21.37-5.91 21.62-2.45 50.07 10.08 98.59-15.96 38.05-37.05 82.66-51.2 107.54-18.89 9.74-33.6 18.6-45.96 28.42-16.3 12.97-26.48 26.3-29.28 40.3-1.36 6.49.69 14.97 5.36 21.92 5.3 7.88 13.28 13 22.85 13.74 24.15 1.87 53.83-23.03 86.6-79.26 3.29-1.1 6.77-2.26 11.02-3.7l11.9-4.02c7.53-2.54 12.99-4.36 18.39-6.11 23.4-7.62 41.1-12.43 57.2-15.17 27.98 14.98 60.32 24.8 82.1 24.8 17.98 0 30.13-9.32 34.52-23.99 3.85-12.88.8-27.82-7.48-36.08-8.56-8.41-24.3-12.43-45.65-13.12zM385.23 765.68v-.36l.13-.34a54.86 54.86 0 0 1 5.6-10.76c4.28-6.58 10.17-13.5 17.47-20.87 3.92-3.95 8-7.8 12.79-12.12 1.07-.96 7.91-7.05 9.19-8.25l11.17-10.4-8.12 12.93c-12.32 19.64-23.46 33.78-33 43-3.51 3.4-6.6 5.9-9.1 7.51a16.43 16.43 0 0 1-2.61 1.42c-.41.17-.77.27-1.13.3a2.2 2.2 0 0 1-1.12-.15 2.07 2.07 0 0 1-1.27-1.91zM511.17 547.4l-2.26 4-1.4-4.38c-3.1-9.83-5.38-24.64-6.01-38-.72-15.2.49-24.32 5.29-24.32 6.74 0 9.83 10.8 10.07 27.05.22 14.28-2.03 29.14-5.7 35.65zm-5.81 58.46l1.53-4.05 2.09 3.8c11.69 21.24 26.86 38.96 43.54 51.31l3.6 2.66-4.39.9c-16.33 3.38-31.54 8.46-52.34 16.85 2.17-.88-21.62 8.86-27.64 11.17l-5.25 2.01 2.8-4.88c12.35-21.5 23.76-47.32 36.05-79.77zm157.62 76.26c-7.86 3.1-24.78.33-54.57-12.39l-7.56-3.22 8.2-.6c23.3-1.73 39.8-.45 49.42 3.07 4.1 1.5 6.83 3.39 8.04 5.55a4.64 4.64 0 0 1-1.36 6.31 6.7 6.7 0 0 1-2.17 1.28z'));
exports.FilePptFill = getIcon('file-ppt', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM468.53 760v-91.54h59.27c60.57 0 100.2-39.65 100.2-98.12 0-58.22-39.58-98.34-99.98-98.34H424a12 12 0 0 0-12 12v276a12 12 0 0 0 12 12h32.53a12 12 0 0 0 12-12zm0-139.33h34.9c47.82 0 67.19-12.93 67.19-50.33 0-32.05-18.12-50.12-49.87-50.12h-52.22v100.45z'));
exports.FileTextFill = getIcon('file-text', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM320 482a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h384a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320zm0 136a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h184a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320z'));
exports.FileWordFill = getIcon('file-word', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 566.1l52.81 197a12 12 0 0 0 11.6 8.9h31.77a12 12 0 0 0 11.6-8.88l74.37-276a12 12 0 0 0 .4-3.12 12 12 0 0 0-12-12h-35.57a12 12 0 0 0-11.7 9.31l-45.78 199.1-49.76-199.32A12 12 0 0 0 528.1 472h-32.2a12 12 0 0 0-11.64 9.1L434.6 680.01 388.5 481.3a12 12 0 0 0-11.68-9.29h-35.39a12 12 0 0 0-3.11.41 12 12 0 0 0-8.47 14.7l74.17 276A12 12 0 0 0 415.6 772h31.99a12 12 0 0 0 11.59-8.9l52.81-197z'));
exports.FileUnknownFill = getIcon('file-unknown', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm110 227a32 32 0 1 0 0-64 32 32 0 0 0 0 64z'));
exports.FileZipFill = getIcon('file-zip', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM296 136v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm0 64v160h128V584H296zm48 48h32v64h-32v-64z'));
exports.FileFill = getIcon('file', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z'));
exports.FilterFill = getIcon('filter', fill, getNode(newViewBox, 'M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z'));
exports.FireFill = getIcon('fire', fill, getNode(newViewBox, 'M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9z'));
exports.FlagFill = getIcon('flag', fill, getNode(newViewBox, 'M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32z'));
exports.FolderAddFill = getIcon('folder-add', fill, getNode(newViewBox, 'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM632 577c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.2 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.8 0 7 3.2 7 7.1V528h84.5c4.1 0 7.5 3.2 7.5 7v42z'));
exports.FolderFill = getIcon('folder', fill, getNode(newViewBox, 'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z'));
exports.FolderOpenFill = getIcon('folder-open', fill, getNode(newViewBox, 'M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zm-180 0H238c-13 0-24.8 7.9-29.7 20L136 643.2V256h188.5l119.6 114.4H748V444z'));
exports.ForwardFill = getIcon('forward', fill, getNode(normalViewBox, 'M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z'));
exports.FrownFill = getIcon('frown', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 0 1-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 0 1-8 8.4zm24-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.FundFill = getIcon('fund', fill, getNode(newViewBox, 'M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-92.3 194.4l-297 297.2a8.03 8.03 0 0 1-11.3 0L410.9 541.1 238.4 713.7a8.03 8.03 0 0 1-11.3 0l-36.8-36.8a8.03 8.03 0 0 1 0-11.3l214.9-215c3.1-3.1 8.2-3.1 11.3 0L531 565l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.2 3 3.2 8.1.1 11.2z'));
exports.FunnelPlotFill = getIcon('funnel-plot', fill, getNode(newViewBox, 'M336.7 586h350.6l84.9-148H251.8zm543.4-432H143.9c-24.5 0-39.8 26.7-27.5 48L215 374h594l98.7-172c12.2-21.3-3.1-48-27.6-48zM349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V650H349v188z'));
exports.GiftFill = getIcon('gift', fill, getNode(newViewBox, 'M160 894c0 17.7 14.3 32 32 32h286V550H160v344zm386 32h286c17.7 0 32-14.3 32-32V550H546v376zm334-616H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v140h366V310h68v172h366V342c0-17.7-14.3-32-32-32zm-402-4h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm138 0h-70v-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70z'));
exports.GithubFill = getIcon('github', fill, getNode(newViewBox, 'M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0 1 38.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z'));
exports.GitlabFill = getIcon('gitlab', fill, getNode(newViewBox, 'M910.5 553.2l-109-370.8c-6.8-20.4-23.1-34.1-44.9-34.1s-39.5 12.3-46.3 32.7l-72.2 215.4H386.2L314 181.1c-6.8-20.4-24.5-32.7-46.3-32.7s-39.5 13.6-44.9 34.1L113.9 553.2c-4.1 13.6 1.4 28.6 12.3 36.8l385.4 289 386.7-289c10.8-8.1 16.3-23.1 12.2-36.8z'));
exports.GoldenFill = getIcon('golden', fill, getNode(newViewBox, 'M905.9 806.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zm-470.2-248c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8z'));
exports.GoogleCircleFill = getIcon('google-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm167 633.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9C281.5 589 272 551.6 272 512s9.5-77 26.1-110.1c40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z'));
exports.GooglePlusCircleFill = getIcon('google-plus-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm36.5 558.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z'));
exports.GooglePlusSquareFill = getIcon('google-plus-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM548.5 622.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z'));
exports.GoogleSquareFill = getIcon('google-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM679 697.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9A245.02 245.02 0 0 1 272 512c0-39.6 9.5-77 26.1-110.1 40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z'));
exports.HddFill = getIcon('hdd', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM456 216c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm576-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm96-152c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48z'));
exports.HeartFill = getIcon('heart', fill, getNode(newViewBox, 'M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z'));
exports.HighlightFill = getIcon('highlight', fill, getNode(newViewBox, 'M957.6 507.4L603.2 158.2a7.9 7.9 0 0 0-11.2 0L353.3 393.4a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2z'));
exports.HomeFill = getIcon('home', fill, getNode(newViewBox, 'M946.5 505L534.6 93.4a31.93 31.93 0 0 0-45.2 0L77.5 505c-12 12-18.8 28.3-18.8 45.3 0 35.3 28.7 64 64 64h43.4V908c0 17.7 14.3 32 32 32H448V716h112v224h265.9c17.7 0 32-14.3 32-32V614.3h43.4c17 0 33.3-6.7 45.3-18.8 24.9-25 24.9-65.5-.1-90.5z'));
exports.HourglassFill = getIcon('hourglass', fill, getNode(newViewBox, 'M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194z'));
exports.Html5Fill = getIcon('html5', fill, getNode(newViewBox, 'M145.2 96l66 746.6L512 928l299.6-85.4L878.9 96H145.2zm595 177.1l-4.8 47.2-1.7 19.5H382.3l8.2 94.2h335.1l-3.3 24.3-21.2 242.2-1.7 16.2-187 51.6v.3h-1.2l-.3.1v-.1h-.1l-188.6-52L310.8 572h91.1l6.5 73.2 102.4 27.7h.4l102-27.6 11.4-118.6H510.9v-.1H306l-22.8-253.5-1.7-24.3h460.3l-1.6 24.3z'));
exports.IdcardFill = getIcon('idcard', fill, getNode(newViewBox, 'M373 411c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52 51.7-23.3 51.7-52-23.2-52-51.7-52zm555-251H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM608 420c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm-86 253h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224a8 8 0 0 1-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 0 1-29.1-75.5c0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zm278.9-53H615.1c-3.9 0-7.1-3.6-7.1-8v-48c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48h.1c0 4.4-3.2 8-7.1 8z'));
exports.IeCircleFill = getIcon('ie-circle', fill, getNode(newViewBox, 'M693.6 284.4c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm253.9 492.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z'));
exports.IeSquareFill = getIcon('ie-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM765.9 556.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zm-72.3-272.5c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z'));
exports.InfoCircleFill = getIcon('info-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.InstagramFill = getIcon('instagram', fill, getNode(newViewBox, 'M512 378.7c-73.4 0-133.3 59.9-133.3 133.3S438.6 645.3 512 645.3 645.3 585.4 645.3 512 585.4 378.7 512 378.7zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zM512 717.1c-113.5 0-205.1-91.6-205.1-205.1S398.5 306.9 512 306.9 717.1 398.5 717.1 512 625.5 717.1 512 717.1zm213.5-370.7c-26.5 0-47.9-21.4-47.9-47.9s21.4-47.9 47.9-47.9 47.9 21.4 47.9 47.9a47.84 47.84 0 0 1-47.9 47.9z'));
exports.InsuranceFill = getIcon('insurance', fill, getNode(newViewBox, 'M519.9 358.8h97.9v41.6h-97.9zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM411.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 0 1-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 0 1-33.6 79V656zm296.5-49.2l-26.3 35.3a5.92 5.92 0 0 1-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a5.9 5.9 0 0 1-8.9-1.4L430 605.7a6 6 0 0 1 1.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5z'));
exports.InteractionFill = getIcon('interaction', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM726 585.7c0 55.3-44.7 100.1-99.7 100.1H420.6v53.4c0 5.7-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.7l109.1-85.7c4.4-3.5 10.9-.3 10.9 5.3v53.4h205.7c19.6 0 35.5-16 35.5-35.6v-78.9c0-3.7 3-6.8 6.8-6.8h50.7c3.7 0 6.8 3 6.8 6.8v79.1zm-2.6-209.9l-109.1 85.7c-4.4 3.5-10.9.3-10.9-5.3v-53.4H397.7c-19.6 0-35.5 16-35.5 35.6v78.9c0 3.7-3 6.8-6.8 6.8h-50.7c-3.7 0-6.8-3-6.8-6.8v-78.9c0-55.3 44.7-100.1 99.7-100.1h205.7v-53.4c0-5.7 6.5-8.8 10.9-5.3l109.1 85.7c3.6 2.5 3.6 7.8.1 10.5z'));
exports.InterationFill = getIcon('interation', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM726 585.7c0 55.3-44.7 100.1-99.7 100.1H420.6v53.4c0 5.7-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.7l109.1-85.7c4.4-3.5 10.9-.3 10.9 5.3v53.4h205.7c19.6 0 35.5-16 35.5-35.6v-78.9c0-3.7 3-6.8 6.8-6.8h50.7c3.7 0 6.8 3 6.8 6.8v79.1zm-2.6-209.9l-109.1 85.7c-4.4 3.5-10.9.3-10.9-5.3v-53.4H397.7c-19.6 0-35.5 16-35.5 35.6v78.9c0 3.7-3 6.8-6.8 6.8h-50.7c-3.7 0-6.8-3-6.8-6.8v-78.9c0-55.3 44.7-100.1 99.7-100.1h205.7v-53.4c0-5.7 6.5-8.8 10.9-5.3l109.1 85.7c3.6 2.5 3.6 7.8.1 10.5z'));
exports.LayoutFill = getIcon('layout', fill, getNode(newViewBox, 'M384 912h496c17.7 0 32-14.3 32-32V340H384v572zm496-800H384v164h528V144c0-17.7-14.3-32-32-32zm-768 32v736c0 17.7 14.3 32 32 32h176V112H144c-17.7 0-32 14.3-32 32z'));
exports.LeftCircleFill = getIcon('left-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm104 316.9c0 10.2-4.9 19.9-13.2 25.9L457.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178a8 8 0 0 1 12.7 6.5v46.8z'));
exports.LeftSquareFill = getIcon('left-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM624 380.9c0 10.2-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.8z'));
exports.LikeFill = getIcon('like', fill, getNode(newViewBox, 'M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311h-.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z'));
exports.LockFill = getIcon('lock', fill, getNode(newViewBox, 'M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1 1 56 0zm152-237H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224z'));
exports.LinkedinFill = getIcon('linkedin', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM349.3 793.7H230.6V411.9h118.7v381.8zm-59.3-434a68.8 68.8 0 1 1 68.8-68.8c-.1 38-30.9 68.8-68.8 68.8zm503.7 434H675.1V608c0-44.3-.8-101.2-61.7-101.2-61.7 0-71.2 48.2-71.2 98v188.9H423.7V411.9h113.8v52.2h1.6c15.8-30 54.5-61.7 112.3-61.7 120.2 0 142.3 79.1 142.3 181.9v209.4z'));
exports.MailFill = getIcon('mail', fill, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-80.8 108.9L531.7 514.4c-7.8 6.1-18.7 6.1-26.5 0L189.6 268.9A7.2 7.2 0 0 1 194 256h648.8a7.2 7.2 0 0 1 4.4 12.9z'));
exports.MedicineBoxFill = getIcon('medicine-box', fill, getNode(newViewBox, 'M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48zm4-372H360v-72h304v72z'));
exports.MediumCircleFill = getIcon('medium-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm256 253.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 0 0 7-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z'));
exports.MediumSquareFill = getIcon('medium-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM768 317.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 0 0 7-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z'));
exports.MehFill = getIcon('meh', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.MessageFill = getIcon('message', fill, getNode(newViewBox, 'M924.3 338.4a447.57 447.57 0 0 0-96.1-143.3 443.09 443.09 0 0 0-143-96.3A443.91 443.91 0 0 0 512 64h-2c-60.5.3-119 12.3-174.1 35.9a444.08 444.08 0 0 0-141.7 96.5 445 445 0 0 0-95 142.8A449.89 449.89 0 0 0 65 514.1c.3 69.4 16.9 138.3 47.9 199.9v152c0 25.4 20.6 46 45.9 46h151.8a447.72 447.72 0 0 0 199.5 48h2.1c59.8 0 117.7-11.6 172.3-34.3A443.2 443.2 0 0 0 827 830.5c41.2-40.9 73.6-88.7 96.3-142 23.5-55.2 35.5-113.9 35.8-174.5.2-60.9-11.6-120-34.8-175.6zM312.4 560c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.4 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48z'));
exports.MinusCircleFill = getIcon('minus-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z'));
exports.MinusSquareFill = getIcon('minus-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z'));
exports.MobileFill = getIcon('mobile', fill, getNode(newViewBox, 'M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z'));
exports.MoneyCollectFill = getIcon('money-collect', fill, getNode(newViewBox, 'M911.5 699.7a8 8 0 0 0-10.3-4.8L840 717.2V179c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V762c0 3.3 2.1 6.3 5.3 7.5L501 909.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zm-243.8-377L564 514.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V703c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 322.8c-2.1-3.8-.7-8.7 3.2-10.8 1.2-.7 2.5-1 3.8-1h55.7a8 8 0 0 1 7.1 4.4L511 484.2h3.3L599 315.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8z'));
exports.PauseCircleFill = getIcon('pause-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-80 600c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z'));
exports.PayCircleFill = getIcon('pay-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm166.6 246.8L567.5 515.6h62c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V603h82c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V717c0 4.4-3.6 8-8 8h-54.3c-4.4 0-8-3.6-8-8v-68.1h-81.7c-4.4 0-8-3.6-8-8V611c0-4.4 3.6-8 8-8h81.7v-41.5h-81.7c-4.4 0-8-3.6-8-8v-29.9c0-4.4 3.6-8 8-8h61.4L345.4 310.8a8.07 8.07 0 0 1 7-11.9h60.7c3 0 5.8 1.7 7.1 4.4l90.6 180h3.4l90.6-180a8 8 0 0 1 7.1-4.4h59.5c4.4 0 8 3.6 8 8 .2 1.4-.2 2.7-.8 3.9z'));
exports.NotificationFill = getIcon('notification', fill, getNode(newViewBox, 'M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.6c-3.7 11.6-5.6 23.9-5.6 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1z'));
exports.PhoneFill = getIcon('phone', fill, getNode(newViewBox, 'M885.6 230.2L779.1 123.8a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L549.8 238.4a80.83 80.83 0 0 0-23.8 57.3c0 21.7 8.5 42.1 23.8 57.4l83.8 83.8A393.82 393.82 0 0 1 553.1 553 395.34 395.34 0 0 1 437 633.8L353.2 550a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L123.8 664.5a80.89 80.89 0 0 0-23.8 57.4c0 21.7 8.5 42.1 23.8 57.4l106.3 106.3c24.4 24.5 58.1 38.4 92.7 38.4 7.3 0 14.3-.6 21.2-1.8 134.8-22.2 268.5-93.9 376.4-201.7C828.2 612.8 899.8 479.2 922.3 344c6.8-41.3-6.9-83.8-36.7-113.8z'));
exports.PictureFill = getIcon('picture', fill, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM338 304c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm513.9 437.1a8.11 8.11 0 0 1-5.2 1.9H177.2c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2l170.3-202c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l99.4 118 158.1-187.5c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l229.6 271.6c2.6 3.3 2.2 8.4-1.2 11.2z'));
exports.PieChartFill = getIcon('pie-chart', fill, getNode(newViewBox, 'M863.1 518.5H505.5V160.9c0-4.4-3.6-8-8-8h-26a398.57 398.57 0 0 0-282.5 117 397.47 397.47 0 0 0-85.6 127C82.6 446.2 72 498.5 72 552.5S82.6 658.7 103.4 708c20.1 47.5 48.9 90.3 85.6 127 36.7 36.7 79.4 65.5 127 85.6a396.64 396.64 0 0 0 155.6 31.5 398.57 398.57 0 0 0 282.5-117c36.7-36.7 65.5-79.4 85.6-127a396.64 396.64 0 0 0 31.5-155.6v-26c-.1-4.4-3.7-8-8.1-8zM951 463l-2.6-28.2c-8.5-92-49.3-178.8-115.1-244.3A398.5 398.5 0 0 0 588.4 75.6L560.1 73c-4.7-.4-8.7 3.2-8.7 7.9v383.7c0 4.4 3.6 8 8 8l383.6-1c4.7-.1 8.4-4 8-8.6z'));
exports.PlayCircleFill = getIcon('play-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm144.1 454.9L437.7 677.8a8.02 8.02 0 0 1-12.7-6.5V353.7a8 8 0 0 1 12.7-6.5L656.1 506a7.9 7.9 0 0 1 0 12.9z'));
exports.PlaySquareFill = getIcon('play-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM641.7 520.8L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 0 1 0 17.6z'));
exports.PlusCircleFill = getIcon('plus-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z'));
exports.PlusSquareFill = getIcon('plus-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z'));
exports.PoundCircleFill = getIcon('pound-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm146 658c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 0 1-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8V722z'));
exports.PrinterFill = getIcon('printer', fill, getNode(newViewBox, 'M732 120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v148h440V120zm120 212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM664 844H360V568h304v276zm164-360c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z'));
exports.ProfileFill = getIcon('profile', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM380 696c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm304 272c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48z'));
exports.ProjectFill = getIcon('project', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM368 744c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464zm192-280c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184zm192 72c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256z'));
exports.PushpinFill = getIcon('pushpin', fill, getNode(newViewBox, 'M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3-15.4 12.3-16.6 35.4-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8z'));
exports.PropertySafetyFill = getIcon('property-safety', fill, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM648.3 332.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 0 1 8.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z'));
exports.QqCircleFill = getIcon('qq-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm210.5 612.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z'));
exports.QqSquareFill = getIcon('qq-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM722.5 676.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z'));
exports.QuestionCircleFill = getIcon('question-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 708c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 0 0-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z'));
exports.ReadFill = getIcon('read', fill, getNode(newViewBox, 'M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 0 0 324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM404 553.5c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm416 140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45z'));
exports.ReconciliationFill = getIcon('reconciliation', fill, getNode(newViewBox, 'M676 623c-18.8 0-34 15.2-34 34s15.2 34 34 34 34-15.2 34-34-15.2-34-34-34zm204-455H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zM448 848H176V616h272v232zm0-296H176v-88h272v88zm20-272v-48h72v-56h64v56h72v48H468zm180 168v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8zm28 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-245c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v96zm-92 61c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z'));
exports.RedEnvelopeFill = getIcon('red-envelope', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM647 470.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4v25.1c0 4.6-3.8 8.4-8.4 8.4h-63.3v28.6h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.6-3.6 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4l-87.5-161c-2.2-4.1-.7-9.1 3.4-11.4 1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.9 141.8 71.9-141.9a8.5 8.5 0 0 1 7.5-4.6h47.8c4.6 0 8.4 3.8 8.4 8.4-.1 1.5-.5 2.9-1.1 4.1zM512.6 323L289 148h446L512.6 323z'));
exports.RedditCircleFill = getIcon('reddit-circle', fill, getNode(newViewBox, 'M584 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0zm144-108a35.9 35.9 0 0 0-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 0 0 728 440zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm245 477.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 0 1 296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 0 1 101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zm-171.3 83c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 0 0-30.1-3.6zM296 440a35.98 35.98 0 0 0-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 0 0 296 440zm72 108a36 36 0 1 0 72 0 36 36 0 1 0-72 0z'));
exports.RedditSquareFill = getIcon('reddit-square', fill, getNode(newViewBox, 'M296 440a35.98 35.98 0 0 0-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 0 0 296 440zm289.7 184.9c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 0 0-30.1-3.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM757 541.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 0 1 296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 0 1 101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zM584 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0zm144-108a35.9 35.9 0 0 0-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 0 0 728 440zM368 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0z'));
exports.RestFill = getIcon('rest', fill, getNode(newViewBox, 'M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zM508 704c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zM291 256l22.4-76h397.2l22.4 76H291zm137 304a80 80 0 1 0 160 0 80 80 0 1 0-160 0z'));
exports.RightCircleFill = getIcon('right-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm154.7 454.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z'));
exports.RocketFill = getIcon('rocket', fill, getNode(newViewBox, 'M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zM512 352a48.01 48.01 0 0 1 0 96 48.01 48.01 0 0 1 0-96zm116.1 432.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5z'));
exports.RightSquareFill = getIcon('right-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM658.7 518.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z'));
exports.SafetyCertificateFill = getIcon('safety-certificate', fill, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM694.5 340.7L481.9 633.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z'));
exports.SaveFill = getIcon('save', fill, getNode(newViewBox, 'M893.3 293.3L730.7 130.7c-12-12-28.3-18.7-45.3-18.7H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 176h256v112H384V176zm128 554c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zm0-224c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z'));
exports.ScheduleFill = getIcon('schedule', fill, getNode(newViewBox, 'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.5-91.3l-165 228.7a15.9 15.9 0 0 1-25.8 0L493.5 531.2c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.5 12.9 6.6l52.8 73.1 103.7-143.7c3-4.2 7.8-6.6 12.9-6.6H792c6.5.1 10.3 7.5 6.5 12.8z'));
exports.SecurityScanFill = getIcon('security-scan', fill, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM626.8 554c-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 0 1-11.3 0l-34-34a8.03 8.03 0 0 1 0-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0 56.3 56.3 56.3 147.5 0 203.8zm-158.54-45.27a80.1 80.1 0 1 0 113.27-113.28 80.1 80.1 0 1 0-113.27 113.28z'));
exports.SettingFill = getIcon('setting', fill, getNode(newViewBox, 'M512.5 390.6c-29.9 0-57.9 11.6-79.1 32.8-21.1 21.2-32.8 49.2-32.8 79.1 0 29.9 11.7 57.9 32.8 79.1 21.2 21.1 49.2 32.8 79.1 32.8 29.9 0 57.9-11.7 79.1-32.8 21.1-21.2 32.8-49.2 32.8-79.1 0-29.9-11.7-57.9-32.8-79.1a110.96 110.96 0 0 0-79.1-32.8zm412.3 235.5l-65.4-55.9c3.1-19 4.7-38.4 4.7-57.7s-1.6-38.8-4.7-57.7l65.4-55.9a32.03 32.03 0 0 0 9.3-35.2l-.9-2.6a442.5 442.5 0 0 0-79.6-137.7l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.2 28.9c-30-24.6-63.4-44-99.6-57.5l-15.7-84.9a32.05 32.05 0 0 0-25.8-25.7l-2.7-.5c-52-9.4-106.8-9.4-158.8 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.3a353.44 353.44 0 0 0-98.9 57.3l-81.8-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a445.93 445.93 0 0 0-79.6 137.7l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.2 56.5c-3.1 18.8-4.6 38-4.6 57 0 19.2 1.5 38.4 4.6 57l-66 56.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.3 44.8 96.8 79.6 137.7l1.8 2.1a32.12 32.12 0 0 0 35.1 9.5l81.8-29.1c29.8 24.5 63 43.9 98.9 57.3l15.8 85.3a32.05 32.05 0 0 0 25.8 25.7l2.7.5a448.27 448.27 0 0 0 158.8 0l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c4.3-12.4.6-26.3-9.5-35zm-412.3 52.2c-97.1 0-175.8-78.7-175.8-175.8s78.7-175.8 175.8-175.8 175.8 78.7 175.8 175.8-78.7 175.8-175.8 175.8z'));
exports.ShopFill = getIcon('shop', fill, getNode(newViewBox, 'M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h274V736h128v176h274c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zm-72 568H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm0-568.1H214v-88h596v88z'));
exports.ShoppingFill = getIcon('shopping', fill, getNode(newViewBox, 'M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-208 0H400v-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16z'));
exports.SketchCircleFill = getIcon('sketch-circle', fill, getNode(newViewBox, 'M582.3 625.6l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zm-274.7 36L512 684.5l114.4-225.2zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm286.7 380.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 0 1-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 0 1 0 6.6zm-190.5-20.9L512 326.1l-96.2 97.2zM420.3 301.1l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8zm-222.4 7.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3z'));
exports.SketchSquareFill = getIcon('sketch-square', fill, getNode(newViewBox, 'M608.2 423.3L512 326.1l-96.2 97.2zm-25.9 202.3l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-81.3 332.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 0 1-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 0 1 0 6.6zm-401.1 15.1L512 684.5l114.4-225.2zm-16.3-151.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3zm126.5-158.2l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8z'));
exports.SkinFill = getIcon('skin', fill, getNode(newViewBox, 'M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44z'));
exports.SlackCircleFill = getIcon('slack-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0 1 50.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm83.7-50.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM579.3 765c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134c-13.3 0-26.1-5.3-35.6-14.8S529 593.6 529 580.2c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z'));
exports.SlackSquareFill = getIcon('slack-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0 1 50.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z'));
exports.SkypeFill = getIcon('skype', fill, getNode(newViewBox, 'M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 0 0-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 0 0 335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 0 0 112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-370 162.9c-134.2 0-194.2-66-194.2-115.4 0-25.4 18.7-43.1 44.5-43.1 57.4 0 42.6 82.5 149.7 82.5 54.9 0 85.2-29.8 85.2-60.3 0-18.3-9-38.7-45.2-47.6l-119.4-29.8c-96.1-24.1-113.6-76.1-113.6-124.9 0-101.4 95.5-139.5 185.2-139.5 82.6 0 180 45.7 180 106.5 0 26.1-22.6 41.2-48.4 41.2-49 0-40-67.8-138.7-67.8-49 0-76.1 22.2-76.1 53.9s38.7 41.8 72.3 49.5l88.4 19.6c96.8 21.6 121.3 78.1 121.3 131.3 0 82.3-63.3 143.9-191 143.9z'));
exports.SlidersFill = getIcon('sliders', fill, getNode(newViewBox, 'M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-584-72h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm292 180h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8z'));
exports.SmileFill = getIcon('smile', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 0 1 8-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 0 1 8 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.SnippetsFill = getIcon('snippets', fill, getNode(newViewBox, 'M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 486H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z'));
exports.SoundFill = getIcon('sound', fill, getNode(newViewBox, 'M892.1 737.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344zm174 132H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1z'));
exports.StarFill = getIcon('star', fill, getNode(newViewBox, 'M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z'));
exports.StepBackwardFill = getIcon('step-backward', fill, getNode(normalViewBox, 'M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 0 0 0 33.9M330 864h-64a8 8 0 0 1-8-8V168a8 8 0 0 1 8-8h64a8 8 0 0 1 8 8v688a8 8 0 0 1-8 8'));
exports.StepForwardFill = getIcon('step-forward', fill, getNode(normalViewBox, 'M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 0 1 0 33.9M694 864h64a8 8 0 0 0 8-8V168a8 8 0 0 0-8-8h-64a8 8 0 0 0-8 8v688a8 8 0 0 0 8 8'));
exports.StopFill = getIcon('stop', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm234.8 736.5L223.5 277.2c16-19.7 34-37.7 53.7-53.7l523.3 523.3c-16 19.6-34 37.7-53.7 53.7z'));
exports.SwitcherFill = getIcon('switcher', fill, getNode(newViewBox, 'M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zM596 606c0 4.4-3.6 8-8 8H308c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h280c4.4 0 8 3.6 8 8v48zm284-494H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z'));
exports.TabletFill = getIcon('tablet', fill, getNode(newViewBox, 'M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z'));
exports.TagFill = getIcon('tag', fill, getNode(newViewBox, 'M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM699 387c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z'));
exports.TagsFill = getIcon('tags', fill, getNode(newViewBox, 'M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm122.7-533.4c18.7-18.7 49.1-18.7 67.9 0 18.7 18.7 18.7 49.1 0 67.9-18.7 18.7-49.1 18.7-67.9 0-18.7-18.7-18.7-49.1 0-67.9zm283.8 282.9l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z'));
exports.TaobaoCircleFill = getIcon('taobao-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z'));
exports.TaobaoSquareFill = getIcon('taobao-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z'));
exports.ToolFill = getIcon('tool', fill, getNode(newViewBox, 'M865.3 244.7c-.3-.3-61.1 59.8-182.1 180.6l-84.9-84.9 180.9-180.9c-95.2-57.3-217.5-42.6-296.8 36.7A244.42 244.42 0 0 0 419 432l1.8 6.7-283.5 283.4c-6.2 6.2-6.2 16.4 0 22.6l141.4 141.4c6.2 6.2 16.4 6.2 22.6 0l283.3-283.3 6.7 1.8c83.7 22.3 173.6-.9 236-63.3 79.4-79.3 94.1-201.6 38-296.6z'));
exports.ThunderboltFill = getIcon('thunderbolt', fill, getNode(newViewBox, 'M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7z'));
exports.TrademarkCircleFill = getIcon('trademark-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm164.7 660.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H378c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7zM523.9 357h-83.4v148H522c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z'));
exports.TwitterCircleFill = getIcon('twitter-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm215.3 337.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 0 1-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 0 1-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 0 0 229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z'));
exports.TrophyFill = getIcon('trophy', fill, getNode(newViewBox, 'M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.6 630.2 359 721.8 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.8 758.4 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM248 439.6c-37.1-11.9-64-46.7-64-87.6V232h64v207.6zM840 352c0 41-26.9 75.8-64 87.6V232h64v120z'));
exports.TwitterSquareFill = getIcon('twitter-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM727.3 401.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 0 1-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 0 1-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 0 0 229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z'));
exports.UnlockFill = getIcon('unlock', fill, getNode(newViewBox, 'M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1 1 56 0z'));
exports.UpCircleFill = getIcon('up-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm178 555h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z'));
exports.UpSquareFill = getIcon('up-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM690 624h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z'));
exports.UsbFill = getIcon('usb', fill, getNode(newViewBox, 'M408 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm352 120V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-72 0H336V184h352v248zM568 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'));
exports.WalletFill = getIcon('wallet', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 464H528V448h320v128zm-268-64a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.VideoCameraFill = getIcon('video-camera', fill, getNode(newViewBox, 'M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM328 352c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48zm560 273l-104-59.8V458.9L888 399v226z'));
exports.WarningFill = getIcon('warning', fill, getNode(newViewBox, 'M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.WeiboCircleFill = getIcon('weibo-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z'));
exports.WechatFill = getIcon('wechat', fill, getNode(newViewBox, 'M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 0 1 9.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 0 0 6.4-2.6 9 9 0 0 0 2.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 0 1-36 35.9z'));
exports.WindowsFill = getIcon('windows', fill, getNode(newViewBox, 'M523.8 191.4v288.9h382V128.1zm0 642.2l382 62.2v-352h-382zM120.1 480.2H443V201.9l-322.9 53.5zm0 290.4L443 823.2V543.8H120.1z'));
exports.YahooFill = getIcon('yahoo', fill, getNode(newViewBox, 'M937.3 231H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7zm-77.4 450.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm225.2 225.2h-65.3L458.9 559.8v65.3h84.4v56.3H318.2v-56.3h84.4v-65.3L242.9 399.9h-37v-56.3h168.5v56.3h-37l93.4 93.5 28.1-28.1V400h168.8v56.2z'));
exports.WeiboSquareFill = getIcon('weibo-square', fill, getNode(newViewBox, 'M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z'));
exports.YuqueFill = getIcon('yuque', fill, getNode(newViewBox, 'M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.9-8.1-195-3-195-3s87.4 55.6 52.4 154.7c-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6z'));
exports.YoutubeFill = getIcon('youtube', fill, getNode(newViewBox, 'M941.3 296.1a112.3 112.3 0 0 0-79.2-79.3C792.2 198 512 198 512 198s-280.2 0-350.1 18.7A112.12 112.12 0 0 0 82.7 296C64 366 64 512 64 512s0 146 18.7 215.9c10.3 38.6 40.7 69 79.2 79.3C231.8 826 512 826 512 826s280.2 0 350.1-18.8c38.6-10.3 68.9-40.7 79.2-79.3C960 658 960 512 960 512s0-146-18.7-215.9zM423 646V378l232 133-232 135z'));
exports.ZhihuSquareFill = getIcon('zhihu-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM432.3 592.8l71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7h-110l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24.1-18.1zm335.5 116h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z'));
exports.ZhihuCircleFill = getIcon('zhihu-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-90.7 477.8l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24-18.1 71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7H421.3zm346.5 167h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z'));
exports.AccountBookOutline = getIcon('account-book', outline, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 0 0-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z'));
exports.AlertOutline = getIcon('alert', outline, getNode(newViewBox, 'M193 796c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563zm-48.1-252.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 0 0-11.3 0l-39.6 39.6a8.03 8.03 0 0 0 0 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-67.9 67.9a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM832 892H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8z'));
exports.AlipayCircleOutline = getIcon('alipay-circle', outline, getNode(newViewBox, 'M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 0 0 960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z'));
exports.AliwangwangOutline = getIcon('aliwangwang', outline, getNode(newViewBox, 'M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 0 0-120.5-81.2A375.65 375.65 0 0 0 519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 0 0-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10.1 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0 0 29.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-66.4 266.5a307.08 307.08 0 0 1-65.9 98c-28.4 28.5-61.3 50.7-97.7 65.9h-.1c-38 16-78.3 24.2-119.9 24.2a306.51 306.51 0 0 1-217.5-90.2c-28.4-28.5-50.6-61.4-65.8-97.8v-.1c-16-37.8-24.1-78.2-24.1-119.9 0-55.4 14.8-109.7 42.8-157l13.2-22.1-9.5-23.9L206 192c14.9.6 35.9 2.1 59.7 5.6 43.8 6.5 82.5 17.5 114.9 32.6l19 8.9 19.9-6.8c31.5-10.8 64.8-16.2 98.9-16.2a306.51 306.51 0 0 1 217.5 90.2c28.4 28.5 50.6 61.4 65.8 97.8l.1.1.1.1c16 37.6 24.1 78 24.2 119.8-.1 41.7-8.3 82-24.3 119.8zM681.1 364.2c-20.4 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.6 37.1 37.1 37.1s37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1zm-175.2 0c-20.5 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.7 37.1 37.1 37.1 20.5 0 37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1z'));
exports.AndroidOutline = getIcon('android', outline, getNode(newViewBox, 'M448.3 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32-13.4 32-31.9.1-18.4-13.4-31.9-32-31.9zm393.9 96.4c-13.8-13.8-32.7-21.5-53.2-21.5-3.9 0-7.4.4-10.7 1v-1h-3.6c-5.5-30.6-18.6-60.5-38.1-87.4-18.7-25.7-43-47.9-70.8-64.9l25.1-35.8v-3.3c0-.8.4-2.3.7-3.8.6-2.4 1.4-5.5 1.4-8.9 0-18.5-13.5-31.9-32-31.9-9.8 0-19.5 5.7-25.9 15.4l-29.3 42.1c-30-9.8-62.4-15-93.8-15-31.3 0-63.7 5.2-93.8 15L389 79.4c-6.6-9.6-16.1-15.4-26-15.4-18.6 0-32 13.4-32 31.9 0 6.2 2.5 12.8 6.7 17.4l22.6 32.3c-28.7 17-53.5 39.4-72.2 65.1-19.4 26.9-32 56.8-36.7 87.4h-5.5v1c-3.2-.6-6.7-1-10.7-1-20.3 0-39.2 7.5-53.1 21.3-13.8 13.8-21.5 32.6-21.5 53v235c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 3.9 0 7.4-.4 10.7-1v93.5c0 29.2 23.9 53.1 53.2 53.1H331v58.3c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-58.2H544v58.1c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.4 0 39.2-7.5 53.1-21.6 13.8-13.8 21.5-32.6 21.5-53v-58.2h31.9c29.3 0 53.2-23.8 53.2-53.1v-91.4c3.2.6 6.7 1 10.7 1 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-235c-.1-20.3-7.6-39-21.4-52.9zM246 609.6c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zm131.1-396.8c37.5-27.3 85.3-42.3 135-42.3s97.5 15.1 135 42.5c32.4 23.7 54.2 54.2 62.7 87.5H314.4c8.5-33.4 30.5-64 62.7-87.7zm39.3 674.7c-.6 5.6-4.4 8.7-10.5 8.7-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1zm202.3 8.7c-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1c-.6 5.6-4.3 8.7-10.5 8.7zm95.8-132.6H309.9V364h404.6v399.6zm85.2-154c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zM576.1 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32.1-13.4 32.1-32-.1-18.6-13.4-31.8-32.1-31.8z'));
exports.ApiOutline = getIcon('api', outline, getNode(newViewBox, 'M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7 35.3 0 68.4 13.7 93.4 38.7 24.9 24.9 38.7 58.1 38.7 93.4 0 35.3-13.8 68.4-38.7 93.4zm-190.2 105a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 69-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 0 1-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7a131.32 131.32 0 0 1-38.7-93.4c0-35.3 13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4z'));
exports.AppstoreOutline = getIcon('appstore', outline, getNode(newViewBox, 'M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z'));
exports.AudioOutline = getIcon('audio', outline, getNode(newViewBox, 'M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1zM512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-94-392c0-50.6 41.9-92 94-92s94 41.4 94 92v224c0 50.6-41.9 92-94 92s-94-41.4-94-92V232z'));
exports.AppleOutline = getIcon('apple', outline, getNode(newViewBox, 'M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-10.6 267c-14.3 19.9-28.7 35.6-41.9 45.7-10.5 8-18.6 11.4-24 11.6-9-.1-17.7-2.3-34.7-8.8-1.2-.5-2.5-1-4.2-1.6l-4.4-1.7c-17.4-6.7-27.8-10.3-41.1-13.8-18.6-4.8-37.1-7.4-56.9-7.4-20.2 0-39.2 2.5-58.1 7.2-13.9 3.5-25.6 7.4-42.7 13.8-.7.3-8.1 3.1-10.2 3.9-3.5 1.3-6.2 2.3-8.7 3.2-10.4 3.6-17 5.1-22.9 5.2-.7 0-1.3-.1-1.8-.2-1.1-.2-2.5-.6-4.1-1.3-4.5-1.8-9.9-5.1-16-9.8-14-10.9-29.4-28-45.1-49.9-27.5-38.6-53.5-89.8-66-125.7-15.4-44.8-23-87.7-23-128.6 0-60.2 17.8-106 48.4-137.1 26.3-26.6 61.7-41.5 97.8-42.3 5.9.1 14.5 1.5 25.4 4.5 8.6 2.3 18 5.4 30.7 9.9 3.8 1.4 16.9 6.1 18.5 6.7 7.7 2.8 13.5 4.8 19.2 6.6 18.2 5.8 32.3 9 47.6 9 15.5 0 28.8-3.3 47.7-9.8 7.1-2.4 32.9-12 37.5-13.6 25.6-9.1 44.5-14 60.8-15.2 4.8-.4 9.1-.4 13.2-.1 22.7 1.8 42.1 6.3 58.6 13.8-37.6 43.4-57 96.5-56.9 158.4-.3 14.7.9 31.7 5.1 51.8 6.4 30.5 18.6 60.7 37.9 89 14.7 21.5 32.9 40.9 54.7 57.8-11.5 23.7-25.6 48.2-40.4 68.8zm-94.5-572c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z'));
exports.BackwardOutline = getIcon('backward', outline, getNode(normalViewBox, 'M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 0 0-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z'));
exports.BankOutline = getIcon('bank', outline, getNode(newViewBox, 'M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM512 196.7l271.1 197.2H240.9L512 196.7zM264 462h117v374H264V462zm189 0h117v374H453V462zm307 374H642V462h118v374z'));
exports.BellOutline = getIcon('bell', outline, getNode(newViewBox, 'M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zM304 768V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340H304z'));
exports.BehanceSquareOutline = getIcon('behance-square', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z'));
exports.BookOutline = getIcon('book', outline, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zm220 752H232V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0 0 22.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752z'));
exports.BoxPlotOutline = getIcon('box-plot', outline, getNode(newViewBox, 'M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM296 368h88v288h-88V368zm432 288H448V368h280v288z'));
exports.BulbOutline = getIcon('bulb', outline, getNode(newViewBox, 'M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z'));
exports.BugOutline = getIcon('bug', outline, getNode(newViewBox, 'M304 280h56c4.4 0 8-3.6 8-8 0-28.3 5.9-53.2 17.1-73.5 10.6-19.4 26-34.8 45.4-45.4C450.9 142 475.7 136 504 136h16c28.3 0 53.2 5.9 73.5 17.1 19.4 10.6 34.8 26 45.4 45.4C650 218.9 656 243.7 656 272c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1a184.31 184.31 0 0 0-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9a184.31 184.31 0 0 0-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z', 'M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8a63 63 0 0 1-63 63H232a63 63 0 0 1-63-63c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7a273 273 0 0 0 22.7 49c24.3 41.5 59 76.2 100.5 100.5S460.5 960 512 960s99.8-13.9 141.3-38.2a281.38 281.38 0 0 0 123.2-149.5A120 120 0 0 1 836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM716 680c0 36.8-9.7 72-27.8 102.9-17.7 30.3-43 55.6-73.3 73.3C584 874.3 548.8 884 512 884s-72-9.7-102.9-27.8c-30.3-17.7-55.6-43-73.3-73.3A202.75 202.75 0 0 1 308 680V412h408v268z'));
exports.CalculatorOutline = getIcon('calculator', outline, getNode(newViewBox, 'M251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 0h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm-195.7-81l61.2-74.9c4.3-5.2.7-13.1-5.9-13.1H388c-2.3 0-4.5 1-5.9 2.9l-34 41.6-34-41.6a7.85 7.85 0 0 0-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.5-1 5.9-2.9l35.5-43.5 35.5 43.5c1.5 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 5.9-13.1L383.5 675zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-36 732H180V180h664v664z'));
exports.BuildOutline = getIcon('build', outline, getNode(newViewBox, 'M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zm-504 68h200v200H412V278zm-68 468H144V546h200v200zm268 0H412V546h200v200zm268-268H680V278h200v200z'));
exports.CalendarOutline = getIcon('calendar', outline, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z'));
exports.CameraOutline = getIcon('camera', outline, getNode(newViewBox, 'M864 248H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456zM512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z'));
exports.CarOutline = getIcon('car', outline, getNode(newViewBox, 'M380 704h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8zm340-123a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm239-167.6L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM840 517v237H184V517l15.6-43h624.8l15.6 43zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM224 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.CaretDownOutline = getIcon('caret-down', outline, getNode(normalViewBox, 'M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z'));
exports.CaretLeftOutline = getIcon('caret-left', outline, getNode(normalViewBox, 'M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z'));
exports.CaretRightOutline = getIcon('caret-right', outline, getNode(normalViewBox, 'M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z'));
exports.CarryOutOutline = getIcon('carry-out', outline, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z'));
exports.CheckCircleOutline = getIcon('check-circle', outline, getNode(newViewBox, 'M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0 0 51.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.CaretUpOutline = getIcon('caret-up', outline, getNode(normalViewBox, 'M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z'));
exports.CheckSquareOutline = getIcon('check-square', outline, getNode(newViewBox, 'M433.1 657.7a31.8 31.8 0 0 0 51.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7H642c-10.2 0-19.9 4.9-25.9 13.3L459 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H315c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.ChromeOutline = getIcon('chrome', outline, getNode(newViewBox, 'M928 512.3v-.3c0-229.8-186.2-416-416-416S96 282.2 96 512v.4c0 229.8 186.2 416 416 416s416-186.2 416-416v-.3.2zm-6.7-74.6l.6 3.3-.6-3.3zM676.7 638.2c53.5-82.2 52.5-189.4-11.1-263.7l162.4-8.4c20.5 44.4 32 93.8 32 145.9 0 185.2-144.6 336.6-327.1 347.4l143.8-221.2zM512 652.3c-77.5 0-140.2-62.7-140.2-140.2 0-77.7 62.7-140.2 140.2-140.2S652.2 434.5 652.2 512 589.5 652.3 512 652.3zm369.2-331.7l-3-5.7 3 5.7zM512 164c121.3 0 228.2 62.1 290.4 156.2l-263.6-13.9c-97.5-5.7-190.2 49.2-222.3 141.1L227.8 311c63.1-88.9 166.9-147 284.2-147zM102.5 585.8c26 145 127.1 264 261.6 315.1C229.6 850 128.5 731 102.5 585.8zM164 512c0-55.9 13.2-108.7 36.6-155.5l119.7 235.4c44.1 86.7 137.4 139.7 234 121.6l-74 145.1C302.9 842.5 164 693.5 164 512zm324.7 415.4c4 .2 8 .4 12 .5-4-.2-8-.3-12-.5z'));
exports.ClockCircleOutline = getIcon('clock-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z'));
exports.CloseCircleOutline = getIcon('close-circle', outline, getNode(newViewBox, 'M685.4 354.8c0-4.4-3.6-8-8-8l-66 .3L512 465.6l-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155L340.5 670a8.32 8.32 0 0 0-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3L512 564.4l99.3 118.4 66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.5 515l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z', 'M512 65C264.6 65 64 265.6 64 513s200.6 448 448 448 448-200.6 448-448S759.4 65 512 65zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.CloudOutline = getIcon('cloud', outline, getNode(newViewBox, 'M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 0 1-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 0 1 140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0 1 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z'));
exports.CloseSquareOutline = getIcon('close-square', outline, getNode(newViewBox, 'M354 671h58.9c4.7 0 9.2-2.1 12.3-5.7L512 561.8l86.8 103.5c3 3.6 7.5 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.4-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.7 0-9.2 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3-3.6-7.5-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 0 0 354 671z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.CodeOutline = getIcon('code', outline, getNode(newViewBox, 'M516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48zm-194.9 6.1l192-161c3.8-3.2 3.8-9.1 0-12.3l-192-160.9A7.95 7.95 0 0 0 308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 0 0-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.CodepenCircleOutline = getIcon('codepen-circle', outline, getNode(newViewBox, 'M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z'));
exports.CompassOutline = getIcon('compass', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm198.4-588.1a32 32 0 0 0-24.5.5L414.9 415 296.4 686c-3.6 8.2-3.6 17.5 0 25.7 3.4 7.8 9.7 13.9 17.7 17 3.8 1.5 7.7 2.2 11.7 2.2 4.4 0 8.7-.9 12.8-2.7l271-118.6 118.5-271a32.06 32.06 0 0 0-17.7-42.7zM576.8 534.4l26.2 26.2-42.4 42.4-26.2-26.2L380 644.4 447.5 490 422 464.4l42.4-42.4 25.5 25.5L644.4 380l-67.6 154.4zM464.4 422L422 464.4l25.5 25.6 86.9 86.8 26.2 26.2 42.4-42.4-26.2-26.2-86.8-86.9z'));
exports.ContactsOutline = getIcon('contacts', outline, getNode(newViewBox, 'M594.3 601.5a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1 8 8 0 0 0 8 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52zm416-354H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z'));
exports.ContainerOutline = getIcon('container', outline, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v-63H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v752zM320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 160h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'));
exports.ControlOutline = getIcon('control', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8s0 .1.1.1a36.18 36.18 0 0 1 5.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8 0 0 0 .1-.1.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7zM620 539v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8v.1a36.18 36.18 0 0 1 5.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8v.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7z'));
exports.CopyOutline = getIcon('copy', outline, getNode(newViewBox, 'M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z'));
exports.CreditCardOutline = getIcon('credit-card', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-792 72h752v120H136V232zm752 560H136V440h752v352zm-237-64h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z'));
exports.CrownOutline = getIcon('crown', outline, getNode(newViewBox, 'M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zm-126 534.1H250.3l-53.8-409.4 139.8 86.1L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4zM512 509c-62.1 0-112.6 50.5-112.6 112.6S449.9 734.2 512 734.2s112.6-50.5 112.6-112.6S574.1 509 512 509zm0 160.9c-26.6 0-48.2-21.6-48.2-48.3 0-26.6 21.6-48.3 48.2-48.3s48.2 21.6 48.2 48.3c0 26.6-21.6 48.3-48.2 48.3z'));
exports.CustomerServiceOutline = getIcon('customer-service', outline, getNode(newViewBox, 'M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z'));
exports.DashboardOutline = getIcon('dashboard', outline, getNode(newViewBox, 'M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 0 1 140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276zM623.5 421.5a8.03 8.03 0 0 0-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 0 0 0 79.2 55.95 55.95 0 0 0 79.2 0 55.87 55.87 0 0 0 14.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8zm260 218v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zm12.7-197.2l-31.1-31.1a8.03 8.03 0 0 0-11.3 0l-56.6 56.6a8.03 8.03 0 0 0 0 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zm-458.6-31.1a8.03 8.03 0 0 0-11.3 0l-31.1 31.1a8.03 8.03 0 0 0 0 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z'));
exports.DeleteOutline = getIcon('delete', outline, getNode(newViewBox, 'M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z'));
exports.DiffOutline = getIcon('diff', outline, getNode(newViewBox, 'M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7zm-7.1-502.6c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888zm190.2-581.4L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z'));
exports.DatabaseOutline = getIcon('database', outline, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM304 240a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.DislikeOutline = getIcon('dislike', outline, getNode(newViewBox, 'M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h129.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM184 456V172h81v284h-81zm627.2 160.4H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 0 1-42.2-32.3L329 459.2V172h415.4a56.85 56.85 0 0 1 33.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0 1 19.6 43c0 19.1-11 37.5-28.8 48.4z'));
exports.DownCircleOutline = getIcon('down-circle', outline, getNode(newViewBox, 'M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.DownSquareOutline = getIcon('down-square', outline, getNode(newViewBox, 'M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.8-5.3 0-12.7-6.5-12.7H643c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.DribbbleSquareOutline = getIcon('dribbble-square', outline, getNode(newViewBox, 'M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z'));
exports.EnvironmentOutline = getIcon('environment', outline, getNode(newViewBox, 'M854.6 289.1a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1zm0-617.2c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z'));
exports.EditOutline = getIcon('edit', outline, getNode(newViewBox, 'M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z'));
exports.ExclamationCircleOutline = getIcon('exclamation-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z'));
exports.ExperimentOutline = getIcon('experiment', outline, getNode(newViewBox, 'M512 472a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm367 352.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 0 1-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.7-107.8c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1L813.5 844h-603z'));
exports.EyeInvisibleOutline = getIcon('eye-invisible', outline, getNode(newViewBox, 'M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5zm-63.57-320.64L836 122.88a8 8 0 0 0-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 0 0 0 11.31L155.17 889a8 8 0 0 0 11.31 0l712.15-712.12a8 8 0 0 0 0-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 0 0-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 0 1 146.2-106.69L401.31 546.2A112 112 0 0 1 396 512z', 'M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 0 0 227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 0 1-112 112z'));
exports.EyeOutline = getIcon('eye', outline, getNode(newViewBox, 'M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z'));
exports.FacebookOutline = getIcon('facebook', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 736H663.9V602.2h104l15.6-120.7H663.9v-77.1c0-35 9.7-58.8 59.8-58.8h63.9v-108c-11.1-1.5-49-4.8-93.2-4.8-92.2 0-155.3 56.3-155.3 159.6v89H434.9v120.7h104.3V848H176V176h672v672z'));
exports.FastBackwardOutline = getIcon('fast-backward', outline, getNode(normalViewBox, 'M517.6 273.5L230.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z'));
exports.FastForwardOutline = getIcon('fast-forward', outline, getNode(normalViewBox, 'M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 0 0 0-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z'));
exports.FileAddOutline = getIcon('file-add', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z'));
exports.FileExcelOutline = getIcon('file-excel', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z'));
exports.FileExclamationOutline = getIcon('file-exclamation', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM472 744a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm16-104h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8z'));
exports.FileImageOutline = getIcon('file-image', outline, getNode(newViewBox, 'M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 0 0-12.6 0l-99.8 127.2a7.98 7.98 0 0 0 6.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 0 0-12.7 0zM360 442a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm494.6-153.4L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'));
exports.FileMarkdownOutline = getIcon('file-markdown', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0 0 11 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z'));
exports.FilePptOutline = getIcon('file-ppt', outline, getNode(newViewBox, 'M424 476c-4.4 0-8 3.6-8 8v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.3c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1zm280-281.7L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'));
exports.FileTextOutline = getIcon('file-text', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM504 618H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8z'));
exports.FilePdfOutline = getIcon('file-pdf', outline, getNode(newViewBox, 'M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'));
exports.FileZipOutline = getIcon('file-zip', outline, getNode(newViewBox, 'M296 392h64v64h-64zm0 190v160h128V582h-64v-62h-64v62zm80 48v64h-32v-64h32zm-16-302h64v64h-64zm-64-64h64v64h-64zm64 192h64v64h-64zm0-256h64v64h-64zm494.6 88.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h64v64h64v-64h174v216a42 42 0 0 0 42 42h216v494z'));
exports.FileOutline = getIcon('file', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'));
exports.FilterOutline = getIcon('filter', outline, getNode(newViewBox, 'M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V642h182.9v156zm9.6-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z'));
exports.FileWordOutline = getIcon('file-word', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 0 0-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 0 0-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z'));
exports.FireOutline = getIcon('fire', outline, getNode(newViewBox, 'M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0 0 58.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0 0 12.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0 0 24.4 59.8 73.36 73.36 0 0 0 53.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z'));
exports.FileUnknownOutline = getIcon('file-unknown', outline, getNode(newViewBox, 'M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm78 195a32 32 0 1 0 64 0 32 32 0 1 0-64 0z'));
exports.FlagOutline = getIcon('flag', outline, getNode(newViewBox, 'M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z'));
exports.FolderAddOutline = getIcon('folder-add', outline, getNode(newViewBox, 'M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1zm396-144.7H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'));
exports.FolderOutline = getIcon('folder', outline, getNode(newViewBox, 'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'));
exports.FolderOpenOutline = getIcon('folder-open', outline, getNode(newViewBox, 'M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z'));
exports.ForwardOutline = getIcon('forward', outline, getNode(normalViewBox, 'M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z'));
exports.FrownOutline = getIcon('frown', outline, getNode(newViewBox, 'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM512 533c-85.5 0-155.6 67.3-160 151.6a8 8 0 0 0 8 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4C420 636.1 461.5 597 512 597s92.1 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 0 0 8-8.4C667.6 600.3 597.5 533 512 533z'));
exports.FundOutline = getIcon('fund', outline, getNode(newViewBox, 'M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-40 632H134V236h752v560zm-658.9-82.3c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 0 0-11.3 0L531 565 416.6 450.5a8.03 8.03 0 0 0-11.3 0l-214.9 215a8.03 8.03 0 0 0 0 11.3l36.7 36.9z'));
exports.FunnelPlotOutline = getIcon('funnel-plot', outline, getNode(newViewBox, 'M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V650h182.9v148zm9.6-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z'));
exports.GiftOutline = getIcon('gift', outline, getNode(newViewBox, 'M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zm-334-74c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm-138-70c38.6 0 70 31.4 70 70v70h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70zM180 482V378h298v104H180zm48 68h250v308H228V550zm568 308H546V550h250v308zm48-376H546V378h298v104z'));
exports.GithubOutline = getIcon('github', outline, getNode(newViewBox, 'M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0 1 38.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z'));
exports.GitlabOutline = getIcon('gitlab', outline, getNode(newViewBox, 'M913.9 552.2L805 181.4v-.1c-7.6-22.9-25.7-36.5-48.3-36.5-23.4 0-42.5 13.5-49.7 35.2l-71.4 213H388.8l-71.4-213c-7.2-21.7-26.3-35.2-49.7-35.2-23.1 0-42.5 14.8-48.4 36.6L110.5 552.2c-4.4 14.7 1.2 31.4 13.5 40.7l368.5 276.4c2.6 3.6 6.2 6.3 10.4 7.8l8.6 6.4 8.5-6.4c4.9-1.7 9-4.7 11.9-8.9l368.4-275.4c12.4-9.2 18-25.9 13.6-40.6zM751.7 193.4c1-1.8 2.9-1.9 3.5-1.9 1.1 0 2.5.3 3.4 3L818 394.3H684.5l67.2-200.9zm-487.4 1c.9-2.6 2.3-2.9 3.4-2.9 2.7 0 2.9.1 3.4 1.7l67.3 201.2H206.5l57.8-200zM158.8 558.7l28.2-97.3 202.4 270.2-230.6-172.9zm73.9-116.4h122.1l90.8 284.3-212.9-284.3zM512.9 776L405.7 442.3H620L512.9 776zm157.9-333.7h119.5L580 723.1l90.8-280.8zm-40.7 293.9l207.3-276.7 29.5 99.2-236.8 177.5z'));
exports.HeartOutline = getIcon('heart', outline, getNode(newViewBox, 'M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z'));
exports.HddOutline = getIcon('hdd', outline, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM496 208H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 244a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.HighlightOutline = getIcon('highlight', outline, getNode(newViewBox, 'M957.6 507.4L603.2 158.2a7.9 7.9 0 0 0-11.2 0L353.3 393.4a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.2H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.2l68.6-67.6 171.4 168.9-68.6 67.6zM713.1 658L450.3 399.1 597.6 254l262.8 259-147.3 145z'));
exports.HomeOutline = getIcon('home', outline, getNode(newViewBox, 'M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 0 0-44.4 0L77.5 505a63.9 63.9 0 0 0-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0 0 18.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z'));
exports.HourglassOutline = getIcon('hourglass', outline, getNode(newViewBox, 'M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 0 1 354 318V184h316v134z'));
exports.Html5Outline = getIcon('html5', outline, getNode(newViewBox, 'M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2zM281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z'));
exports.IdcardOutline = getIcon('idcard', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560zM610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z'));
exports.InfoCircleOutline = getIcon('info-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z'));
exports.InstagramOutline = getIcon('instagram', outline, getNode(newViewBox, 'M512 306.9c-113.5 0-205.1 91.6-205.1 205.1S398.5 717.1 512 717.1 717.1 625.5 717.1 512 625.5 306.9 512 306.9zm0 338.4c-73.4 0-133.3-59.9-133.3-133.3S438.6 378.7 512 378.7 645.3 438.6 645.3 512 585.4 645.3 512 645.3zm213.5-394.6c-26.5 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9 47.9-21.3 47.9-47.9a47.84 47.84 0 0 0-47.9-47.9zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zm-88 235.8c-7.3 18.2-16.1 31.8-30.2 45.8-14.1 14.1-27.6 22.9-45.8 30.2C695.2 844.7 570.3 840 512 840c-58.3 0-183.3 4.7-235.9-16.1-18.2-7.3-31.8-16.1-45.8-30.2-14.1-14.1-22.9-27.6-30.2-45.8C179.3 695.2 184 570.3 184 512c0-58.3-4.7-183.3 16.1-235.9 7.3-18.2 16.1-31.8 30.2-45.8s27.6-22.9 45.8-30.2C328.7 179.3 453.7 184 512 184s183.3-4.7 235.9 16.1c18.2 7.3 31.8 16.1 45.8 30.2 14.1 14.1 22.9 27.6 30.2 45.8C844.7 328.7 840 453.7 840 512c0 58.3 4.7 183.2-16.2 235.8z'));
exports.InsuranceOutline = getIcon('insurance', outline, getNode(newViewBox, 'M441.6 306.8L403 288.6a6.1 6.1 0 0 0-8.4 3.7c-17.5 58.5-45.2 110.1-82.2 153.6a6.05 6.05 0 0 0-1.2 5.6l13.2 43.5c1.3 4.4 7 5.7 10.2 2.4 7.7-8.1 15.4-16.9 23.1-26V656c0 4.4 3.6 8 8 8H403c4.4 0 8-3.6 8-8V393.1a429.2 429.2 0 0 0 33.6-79c1-2.9-.3-6-3-7.3zm26.8 9.2v127.2c0 4.4 3.6 8 8 8h65.9v18.6h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 0 0-1.6 8.1l22.8 36.5c1.9 3.1 6.2 3.8 8.9 1.4 31.6-26.8 58.7-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V536c21.3 41.7 47.5 77.5 78.1 106.9 2.6 2.5 6.8 2.1 8.9-.7l26.3-35.3c2-2.7 1.4-6.5-1.2-8.4-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8V478c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H476.4c-4.4 0-8 3.6-8 8zm51.5 42.8h97.9v41.6h-97.9v-41.6zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'));
exports.InteractionOutline = getIcon('interaction', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z'));
exports.InterationOutline = getIcon('interation', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z'));
exports.LayoutOutline = getIcon('layout', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-696 72h136v656H184V184zm656 656H384V384h456v456zM384 320V184h456v136H384z'));
exports.LeftCircleOutline = getIcon('left-circle', outline, getNode(newViewBox, 'M603.3 327.5l-246 178a7.95 7.95 0 0 0 0 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.LeftSquareOutline = getIcon('left-square', outline, getNode(newViewBox, 'M365.3 518.5l246 178c5.3 3.8 12.7 0 12.7-6.5v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a8.05 8.05 0 0 0 0 13z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.LikeOutline = getIcon('like', outline, getNode(newViewBox, 'M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h601.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM184 852V568h81v284h-81zm636.4-353l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 22.4-13.2 42.6-33.6 51.8H329V564.8l99.5-360.5a44.1 44.1 0 0 1 42.2-32.3c7.6 0 15.1 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.2 32.1-19.6 43z'));
exports.LinkedinOutline = getIcon('linkedin', outline, getNode(newViewBox, 'M847.7 112H176.3c-35.5 0-64.3 28.8-64.3 64.3v671.4c0 35.5 28.8 64.3 64.3 64.3h671.4c35.5 0 64.3-28.8 64.3-64.3V176.3c0-35.5-28.8-64.3-64.3-64.3zm0 736c-447.8-.1-671.7-.2-671.7-.3.1-447.8.2-671.7.3-671.7 447.8.1 671.7.2 671.7.3-.1 447.8-.2 671.7-.3 671.7zM230.6 411.9h118.7v381.8H230.6zm59.4-52.2c37.9 0 68.8-30.8 68.8-68.8a68.8 68.8 0 1 0-137.6 0c-.1 38 30.7 68.8 68.8 68.8zm252.3 245.1c0-49.8 9.5-98 71.2-98 60.8 0 61.7 56.9 61.7 101.2v185.7h118.6V584.3c0-102.8-22.2-181.9-142.3-181.9-57.7 0-96.4 31.7-112.3 61.7h-1.6v-52.2H423.7v381.8h118.6V604.8z'));
exports.LockOutline = getIcon('lock', outline, getNode(newViewBox, 'M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z'));
exports.MedicineBoxOutline = getIcon('medicine-box', outline, getNode(newViewBox, 'M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840zM652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
exports.MehOutline = getIcon('meh', outline, getNode(newViewBox, 'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM664 565H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
exports.MailOutline = getIcon('mail', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 110.8V792H136V270.8l-27.6-21.5 39.3-50.5 42.8 33.3h643.1l42.8-33.3 39.3 50.5-27.7 21.5zM833.6 232L512 482 190.4 232l-42.8-33.3-39.3 50.5 27.6 21.5 341.6 265.6a55.99 55.99 0 0 0 68.7 0L888 270.8l27.6-21.5-39.3-50.5-42.7 33.2z'));
exports.MessageOutline = getIcon('message', outline, getNode(newViewBox, 'M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm200 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z'));
exports.MinusCircleOutline = getIcon('minus-circle', outline, getNode(newViewBox, 'M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.MinusSquareOutline = getIcon('minus-square', outline, getNode(newViewBox, 'M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.MobileOutline = getIcon('mobile', outline, getNode(newViewBox, 'M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zm-8 824H288V134h448v752zM472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.MoneyCollectOutline = getIcon('money-collect', outline, getNode(newViewBox, 'M911.5 700.7a8 8 0 0 0-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM512 837.5l-256-93.1V184h512v560.4l-256 93.1zM660.6 312h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9z'));
exports.PauseCircleOutline = getIcon('pause-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm-88-532h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z'));
exports.PayCircleOutline = getIcon('pay-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm159.6-585h-59.5c-3 0-5.8 1.7-7.1 4.4l-90.6 180H511l-90.6-180a8 8 0 0 0-7.1-4.4h-60.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9L457 515.7h-61.4c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V603h-81.7c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V717c0 4.4 3.6 8 8 8h54.3c4.4 0 8-3.6 8-8v-68.1h82c4.4 0 8-3.6 8-8V611c0-4.4-3.6-8-8-8h-82v-41.5h82c4.4 0 8-3.6 8-8v-29.9c0-4.4-3.6-8-8-8h-62l111.1-204.8c.6-1.2 1-2.5 1-3.8-.1-4.4-3.7-8-8.1-8z'));
exports.NotificationOutline = getIcon('notification', outline, getNode(newViewBox, 'M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z'));
exports.PhoneOutline = getIcon('phone', outline, getNode(newViewBox, 'M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 0 1-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 0 0-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 0 0 285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z'));
exports.PictureOutline = getIcon('picture', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2zM304 456a88 88 0 1 0 0-176 88 88 0 0 0 0 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z'));
exports.PieChartOutline = getIcon('pie-chart', outline, getNode(newViewBox, 'M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 0 0-282.8 117.1 398.19 398.19 0 0 0-85.7 127.1A397.61 397.61 0 0 0 72 552a398.46 398.46 0 0 0 117.1 282.8c36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 0 0 472 952a398.46 398.46 0 0 0 282.8-117.1c36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 0 0 872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 0 1 470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552c0-88.7 34.5-172.1 97.2-234.8 54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8zM952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 0 0 589 74.6L560.7 72c-4.7-.4-8.7 3.2-8.7 7.9V464c0 4.4 3.6 8 8 8l384-1c4.7 0 8.4-4 8-8.6zm-332.2-58.2V147.6a332.24 332.24 0 0 1 166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z'));
exports.PlaySquareOutline = getIcon('play-square', outline, getNode(newViewBox, 'M442.3 677.6l199.4-156.7a11.3 11.3 0 0 0 0-17.7L442.3 346.4c-7.4-5.8-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.7 18.3 8.9z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.PlayCircleOutline = getIcon('play-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M719.4 499.1l-296.1-215A15.9 15.9 0 0 0 398 297v430c0 13.1 14.8 20.5 25.3 12.9l296.1-215a15.9 15.9 0 0 0 0-25.8zm-257.6 134V390.9L628.5 512 461.8 633.1z'));
exports.PlusCircleOutline = getIcon('plus-circle', outline, getNode(newViewBox, 'M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.PrinterOutline = getIcon('printer', outline, getNode(newViewBox, 'M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8zm32-104H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z'));
exports.PlusSquareOutline = getIcon('plus-square', outline, getNode(newViewBox, 'M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.ProfileOutline = getIcon('profile', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM492 400h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM340 368a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 144a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.ProjectOutline = getIcon('project', outline, getNode(newViewBox, 'M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8zm216-432H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.PushpinOutline = getIcon('pushpin', outline, getNode(newViewBox, 'M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 0 0-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 0 1-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z'));
exports.PropertySafetyOutline = getIcon('property-safety', outline, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM430.5 318h-46c-1.7 0-3.3.4-4.8 1.2a10.1 10.1 0 0 0-4 13.6l88 161.1h-45.2c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7h-63.1c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1a10.05 10.05 0 0 0-8.8-14.8h-45c-3.8 0-7.2 2.1-8.9 5.5l-73.2 144.3-72.9-144.3c-1.7-3.4-5.2-5.5-9-5.5z'));
exports.QuestionCircleOutline = getIcon('question-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.ReadOutline = getIcon('read', outline, getNode(newViewBox, 'M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 0 0 324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM324.8 721H136V233h188.8c35.4 0 69.8 10.1 99.5 29.2l48.8 31.3 6.9 4.5v462c-47.6-25.6-100.8-39-155.2-39zm563.2 0H699.2c-54.4 0-107.6 13.4-155.2 39V298l6.9-4.5 48.8-31.3c29.7-19.1 64.1-29.2 99.5-29.2H888v488zM396.9 361H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm223.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c0-4.1-3.2-7.5-7.1-7.5H627.1c-3.9 0-7.1 3.4-7.1 7.5zM396.9 501H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm416 0H627.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5z'));
exports.ReconciliationOutline = getIcon('reconciliation', outline, getNode(newViewBox, 'M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34zm204-523H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552zM704 408v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zM592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
exports.RedEnvelopeOutline = getIcon('red-envelope', outline, getNode(newViewBox, 'M440.6 462.6a8.38 8.38 0 0 0-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 0 0-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 0 0-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142zM832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z'));
exports.RestOutline = getIcon('rest', outline, getNode(newViewBox, 'M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z', 'M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z'));
exports.RightCircleOutline = getIcon('right-circle', outline, getNode(newViewBox, 'M666.7 505.5l-246-178A8 8 0 0 0 408 334v46.9c0 10.2 4.9 19.9 13.2 25.9L566.6 512 421.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.8 0-13z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.RocketOutline = getIcon('rocket', outline, getNode(newViewBox, 'M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8H864zM762.3 621.4c9.4 14.6 17 30.3 22.5 46.6H700V558.7a211.6 211.6 0 0 1 62.3 62.7zM388 483.1V318.8l124-147 124 147V668H388V483.1zM239.2 668c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668h-84.8zm388.9 116.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5-38.3 0-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM464 400a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'));
exports.RightSquareOutline = getIcon('right-square', outline, getNode(newViewBox, 'M412.7 696.5l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5V381c0 10.2 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.SafetyCertificateOutline = getIcon('safety-certificate', outline, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zm-405.8-201c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z'));
exports.ScheduleOutline = getIcon('schedule', outline, getNode(newViewBox, 'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 136H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm308.2-177.4L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0 0 25.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5z'));
exports.SaveOutline = getIcon('save', outline, getNode(newViewBox, 'M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z'));
exports.SecurityScanOutline = getIcon('security-scan', outline, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM402.9 528.8l-77.5 77.5a8.03 8.03 0 0 0 0 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.7 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 123-20.1 178.6zm65.4-133.3c31.3-31.3 82-31.3 113.2 0 31.3 31.3 31.3 82 0 113.2-31.3 31.3-82 31.3-113.2 0s-31.3-81.9 0-113.2z'));
exports.SettingOutline = getIcon('setting', outline, getNode(newViewBox, 'M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 0 0 9.3-35.2l-.9-2.6a443.74 443.74 0 0 0-79.7-137.9l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 0 0-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.4a351.86 351.86 0 0 0-99 57.4l-81.9-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a446.02 446.02 0 0 0-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0 0 35.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0 0 25.8 25.7l2.7.5a449.4 449.4 0 0 0 159 0l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-85a350 350 0 0 0 99.7-57.6l81.3 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 0 1-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 0 1-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 0 1 624 502c0 29.9-11.7 58-32.8 79.2z'));
exports.ShoppingOutline = getIcon('shopping', outline, getNode(newViewBox, 'M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z'));
exports.SkinOutline = getIcon('skin', outline, getNode(newViewBox, 'M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z'));
exports.SkypeOutline = getIcon('skype', outline, getNode(newViewBox, 'M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 0 0-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 0 0 335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 0 0 112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-88.1 216C766.9 823.4 729 839 688.4 839c-26.1 0-51.8-6.8-74.6-19.7l-22.5-12.7-25.5 4.5c-17.8 3.2-35.8 4.8-53.6 4.8-41.4 0-81.3-8.1-119.1-24.1-36.3-15.3-69-37.3-97.2-65.5a304.29 304.29 0 0 1-65.5-97.1c-16-37.7-24-77.6-24-119 0-17.4 1.6-35.2 4.6-52.8l4.4-25.1L203 410a151.02 151.02 0 0 1-19.1-73.4c0-40.6 15.7-78.5 44.4-107.2C257.1 200.7 295 185 335.6 185a153 153 0 0 1 71.4 17.9l22.4 11.8 24.8-4.8c18.9-3.6 38.4-5.5 58-5.5 41.4 0 81.3 8.1 119 24 36.5 15.4 69.1 37.4 97.2 65.5 28.2 28.1 50.2 60.8 65.6 97.2 16 37.7 24 77.6 24 119 0 18.4-1.7 37-5.1 55.5l-4.7 25.5 12.6 22.6c12.6 22.5 19.2 48 19.2 73.7 0 40.7-15.7 78.5-44.4 107.2zM583.4 466.2L495 446.6c-33.6-7.7-72.3-17.8-72.3-49.5s27.1-53.9 76.1-53.9c98.7 0 89.7 67.8 138.7 67.8 25.8 0 48.4-15.2 48.4-41.2 0-60.8-97.4-106.5-180-106.5-89.7 0-185.2 38.1-185.2 139.5 0 48.8 17.4 100.8 113.6 124.9l119.4 29.8c36.1 8.9 45.2 29.2 45.2 47.6 0 30.5-30.3 60.3-85.2 60.3-107.2 0-92.3-82.5-149.7-82.5-25.8 0-44.5 17.8-44.5 43.1 0 49.4 60 115.4 194.2 115.4 127.7 0 191-61.5 191-144 0-53.1-24.5-109.6-121.3-131.2z'));
exports.SlackSquareOutline = getIcon('slack-square', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0 1 50.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z'));
exports.SlidersOutline = getIcon('sliders', outline, getNode(newViewBox, 'M320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440zm644-436h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 0 1-3 3h-74a3 3 0 0 1-3-3v-74a3 3 0 0 1 3-3h74a3 3 0 0 1 3 3v74z'));
exports.SmileOutline = getIcon('smile', outline, getNode(newViewBox, 'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM664 533h-48.1c-4.2 0-7.8 3.2-8.1 7.4C604 589.9 562.5 629 512 629s-92.1-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 0 0-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 0 0-8-8.4z'));
exports.SnippetsOutline = getIcon('snippets', outline, getNode(newViewBox, 'M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z'));
exports.SoundOutline = getIcon('sound', outline, getNode(newViewBox, 'M625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582zm348-327H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm-41.9 261.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344z'));
exports.StarOutline = getIcon('star', outline, getNode(newViewBox, 'M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z'));
exports.StepBackwardOutline = getIcon('step-backward', outline, getNode(normalViewBox, 'M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 0 0 0 33.9M330 864h-64a8 8 0 0 1-8-8V168a8 8 0 0 1 8-8h64a8 8 0 0 1 8 8v688a8 8 0 0 1-8 8'));
exports.StepForwardOutline = getIcon('step-forward', outline, getNode(normalViewBox, 'M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 0 1 0 33.9M694 864h64a8 8 0 0 0 8-8V168a8 8 0 0 0-8-8h-64a8 8 0 0 0-8 8v688a8 8 0 0 0 8 8'));
exports.StopOutline = getIcon('stop', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372 0-89 31.3-170.8 83.5-234.8l523.3 523.3C682.8 852.7 601 884 512 884zm288.5-137.2L277.2 223.5C341.2 171.3 423 140 512 140c205.4 0 372 166.6 372 372 0 89-31.3 170.8-83.5 234.8z'));
exports.SwitcherOutline = getIcon('switcher', outline, getNode(newViewBox, 'M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528zm168-728H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM300 550h296v64H300z'));
exports.TagOutline = getIcon('tag', outline, getNode(newViewBox, 'M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7zM680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z'));
exports.TabletOutline = getIcon('tablet', outline, getNode(newViewBox, 'M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752zM472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.ShopOutline = getIcon('shop', outline, getNode(newViewBox, 'M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm30-404.4c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 0 1 512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 0 1-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z'));
exports.TagsOutline = getIcon('tags', outline, getNode(newViewBox, 'M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm62.6-651.7l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9zm60.16 186.23a48 48 0 1 0 67.88-67.89 48 48 0 1 0-67.88 67.89zM889.7 539.8l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z'));
exports.TaobaoCircleOutline = getIcon('taobao-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z'));
exports.ToolOutline = getIcon('tool', outline, getNode(newViewBox, 'M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 0 1 144-53.5L537 318.9a32.05 32.05 0 0 0 0 45.3l124.5 124.5a32.05 32.05 0 0 0 45.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z'));
exports.ThunderboltOutline = getIcon('thunderbolt', outline, getNode(newViewBox, 'M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.2 732.5l60.3-241H281.1l189.6-327.4h224.6L487 427.4h211L378.2 732.5z'));
exports.TrophyOutline = getIcon('trophy', outline, getNode(newViewBox, 'M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM184 352V232h64v207.6a91.99 91.99 0 0 1-64-87.6zm520 128c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z'));
exports.UnlockOutline = getIcon('unlock', outline, getNode(newViewBox, 'M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z'));
exports.UpCircleOutline = getIcon('up-circle', outline, getNode(newViewBox, 'M518.5 360.3a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7H381c10.2 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.UpSquareOutline = getIcon('up-square', outline, getNode(newViewBox, 'M334 624h46.9c10.2 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246a7.95 7.95 0 0 0-12.9 0l-178 246A7.96 7.96 0 0 0 334 624z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.UsbOutline = getIcon('usb', outline, getNode(newViewBox, 'M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-424 0V184h352v248H336zm120-184h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
exports.VideoCameraOutline = getIcon('video-camera', outline, getNode(newViewBox, 'M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226zM208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'));
exports.WalletOutline = getIcon('wallet', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0 264H184V184h656v200H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200zM580 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.WarningOutline = getIcon('warning', outline, getNode(newViewBox, 'M464 720a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z'));
exports.WechatOutline = getIcon('wechat', outline, getNode(newViewBox, 'M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 0 1 9.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 0 0 6.4-2.6 9 9 0 0 0 2.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 0 1-36 35.9z'));
exports.WeiboCircleOutline = getIcon('weibo-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z'));
exports.WindowsOutline = getIcon('windows', outline, getNode(newViewBox, 'M120.1 770.6L443 823.2V543.8H120.1v226.8zm63.4-163.5h196.2v141.6l-196.2-31.9V607.1zm340.3 226.5l382 62.2v-352h-382v289.8zm63.4-226.5h255.3v214.4l-255.3-41.6V607.1zm-63.4-415.7v288.8h382V128.1l-382 63.3zm318.7 225.5H587.3V245l255.3-42.3v214.2zm-722.4 63.3H443V201.9l-322.9 53.5v224.8zM183.5 309l196.2-32.5v140.4H183.5V309z'));
exports.YahooOutline = getIcon('yahoo', outline, getNode(newViewBox, 'M859.9 681.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm0 507C245.1 738 121 634.6 121 512.5c0-62.3 32.3-119.7 84.9-161v48.4h37l159.8 159.9v65.3h-84.4v56.3h225.1v-56.3H459v-65.3l103.5-103.6h65.3v-56.3H459v65.3l-28.1 28.1-93.4-93.5h37v-56.3H216.4c49.4-35 114.3-56.6 186.2-56.6 157.6 0 281.6 103.4 281.6 225.5S560.2 738 402.6 738zm534.7-507H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7z'));
exports.WeiboSquareOutline = getIcon('weibo-square', outline, getNode(newViewBox, 'M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z'));
exports.YuqueOutline = getIcon('yuque', outline, getNode(newViewBox, 'M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.8-8.1-194.9-3-195-3 .1 0 87.4 55.6 52.4 154.7-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6zm-204.1 334c-10.6 0-26.2.1-46.8.3l-23.6.2-17.8 15.5c-47.1 41-104.4 71.5-171.4 87.6-52.5 12.6-110 16.2-172.7 9.6 18-20.5 36.5-41.6 55.4-63.1 92-104.6 173.8-197.5 236.9-268.5l1.4-1.4 1.3-1.5c4.1-4.6 20.6-23.3 24.7-28.1 9.7-11.1 17.3-19.9 24.5-28.6 30.7-36.7 52.2-67.8 69-102.2l1.6-3.3 1.2-3.4c13.7-38.8 15.4-76.9 6.2-112.8 22.5.7 46.5 1.9 71.7 3.6 33.3 2.3 55.5 12.9 71.1 29.2 5.8 6 10.2 12.5 13.4 18.7 1 2 1.7 3.6 2.3 5l5 17.7c-15.7 34.5-19.9 73.3-11.4 107.2 3 11.8 6.9 22.4 12.3 34.4 2.1 4.7 9.5 20.1 11 23.3 10.3 22.7 15.4 43 16.7 78.7 3.3 94.6-82.7 181.9-182 181.9z'));
exports.YoutubeOutline = getIcon('youtube', outline, getNode(newViewBox, 'M960 509.2c0-2.2 0-4.7-.1-7.6-.1-8.1-.3-17.2-.5-26.9-.8-27.9-2.2-55.7-4.4-81.9-3-36.1-7.4-66.2-13.4-88.8a139.52 139.52 0 0 0-98.3-98.5c-28.3-7.6-83.7-12.3-161.7-15.2-37.1-1.4-76.8-2.3-116.5-2.8-13.9-.2-26.8-.3-38.4-.4h-29.4c-11.6.1-24.5.2-38.4.4-39.7.5-79.4 1.4-116.5 2.8-78 3-133.5 7.7-161.7 15.2A139.35 139.35 0 0 0 82.4 304C76.3 326.6 72 356.7 69 392.8c-2.2 26.2-3.6 54-4.4 81.9-.3 9.7-.4 18.8-.5 26.9 0 2.9-.1 5.4-.1 7.6v5.6c0 2.2 0 4.7.1 7.6.1 8.1.3 17.2.5 26.9.8 27.9 2.2 55.7 4.4 81.9 3 36.1 7.4 66.2 13.4 88.8 12.8 47.9 50.4 85.7 98.3 98.5 28.2 7.6 83.7 12.3 161.7 15.2 37.1 1.4 76.8 2.3 116.5 2.8 13.9.2 26.8.3 38.4.4h29.4c11.6-.1 24.5-.2 38.4-.4 39.7-.5 79.4-1.4 116.5-2.8 78-3 133.5-7.7 161.7-15.2 47.9-12.8 85.5-50.5 98.3-98.5 6.1-22.6 10.4-52.7 13.4-88.8 2.2-26.2 3.6-54 4.4-81.9.3-9.7.4-18.8.5-26.9 0-2.9.1-5.4.1-7.6v-5.6zm-72 5.2c0 2.1 0 4.4-.1 7.1-.1 7.8-.3 16.4-.5 25.7-.7 26.6-2.1 53.2-4.2 77.9-2.7 32.2-6.5 58.6-11.2 76.3-6.2 23.1-24.4 41.4-47.4 47.5-21 5.6-73.9 10.1-145.8 12.8-36.4 1.4-75.6 2.3-114.7 2.8-13.7.2-26.4.3-37.8.3h-28.6l-37.8-.3c-39.1-.5-78.2-1.4-114.7-2.8-71.9-2.8-124.9-7.2-145.8-12.8-23-6.2-41.2-24.4-47.4-47.5-4.7-17.7-8.5-44.1-11.2-76.3-2.1-24.7-3.4-51.3-4.2-77.9-.3-9.3-.4-18-.5-25.7 0-2.7-.1-5.1-.1-7.1v-4.8c0-2.1 0-4.4.1-7.1.1-7.8.3-16.4.5-25.7.7-26.6 2.1-53.2 4.2-77.9 2.7-32.2 6.5-58.6 11.2-76.3 6.2-23.1 24.4-41.4 47.4-47.5 21-5.6 73.9-10.1 145.8-12.8 36.4-1.4 75.6-2.3 114.7-2.8 13.7-.2 26.4-.3 37.8-.3h28.6l37.8.3c39.1.5 78.2 1.4 114.7 2.8 71.9 2.8 124.9 7.2 145.8 12.8 23 6.2 41.2 24.4 47.4 47.5 4.7 17.7 8.5 44.1 11.2 76.3 2.1 24.7 3.4 51.3 4.2 77.9.3 9.3.4 18 .5 25.7 0 2.7.1 5.1.1 7.1v4.8zM423 646l232-135-232-133z'));
exports.AlibabaOutline = getIcon('alibaba', outline, getNode(newViewBox, 'M602.9 669.8c-37.2 2.6-33.6-17.3-11.5-46.2 50.4-67.2 143.7-158.5 147.9-225.2 5.8-86.6-81.3-113.4-171-113.4-62.4 1.6-127 18.9-171 34.6-151.6 53.5-246.6 137.5-306.9 232-62.4 93.4-43 183.2 91.8 185.8 101.8-4.2 170.5-32.5 239.7-68.2.5 0-192.5 55.1-263.9 14.7-7.9-4.2-15.7-10-17.8-26.2 0-33.1 54.6-67.7 86.6-78.7v-56.7c64.5 22.6 140.6 16.3 205.7-32 2.1 5.8 4.2 13.1 3.7 21h11c2.6-22.6-12.6-44.6-37.8-46.2 7.3 5.8 12.6 10.5 15.2 14.7l-1 1-.5.5c-83.9 58.8-165.3 31.5-173.1 29.9l46.7-45.7-13.1-33.1c92.9-32.5 169.5-56.2 296.9-78.7l-28.5-23 14.7-8.9c75.5 21 126.4 36.7 123.8 76.6-1 6.8-3.7 14.7-7.9 23.1C660.1 466.1 594 538 567.2 569c-17.3 20.5-34.6 39.4-46.7 58.3-13.6 19.4-20.5 37.3-21 53.5 2.6 131.8 391.4-61.9 468-112.9-111.7 47.8-232.9 93.5-364.6 101.9zm85-302.9c2.8 5.2 4.1 11.6 4.1 19.1-.1-6.8-1.4-13.3-4.1-19.1z'));
exports.AlignCenterOutline = getIcon('align-center', outline, getNode(newViewBox, 'M264 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm496 424c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496zm144 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.AlignLeftOutline = getIcon('align-left', outline, getNode(newViewBox, 'M120 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 424h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm784 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.AlignRightOutline = getIcon('align-right', outline, getNode(newViewBox, 'M904 158H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 424H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 212H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.AlipayOutline = getIcon('alipay', outline, getNode(newViewBox, 'M789 610.3c-38.7-12.9-90.7-32.7-148.5-53.6 34.8-60.3 62.5-129 80.7-203.6H530.5v-68.6h233.6v-38.3H530.5V132h-95.4c-16.7 0-16.7 16.5-16.7 16.5v97.8H182.2v38.3h236.3v68.6H223.4v38.3h378.4a667.18 667.18 0 0 1-54.5 132.9c-122.8-40.4-253.8-73.2-336.1-53-52.6 13-86.5 36.1-106.5 60.3-91.4 111-25.9 279.6 167.2 279.6C386 811.2 496 747.6 581.2 643 708.3 704 960 808.7 960 808.7V659.4s-31.6-2.5-171-49.1zM253.9 746.6c-150.5 0-195-118.3-120.6-183.1 24.8-21.9 70.2-32.6 94.4-35 89.4-8.8 172.2 25.2 269.9 72.8-68.8 89.5-156.3 145.3-243.7 145.3z'));
exports.AliyunOutline = getIcon('aliyun', outline, getNode(newViewBox, 'M959.2 383.9c-.3-82.1-66.9-148.6-149.1-148.6H575.9l21.6 85.2 201 43.7a42.58 42.58 0 0 1 32.9 39.7c.1.5.1 216.1 0 216.6a42.58 42.58 0 0 1-32.9 39.7l-201 43.7-21.6 85.3h234.2c82.1 0 148.8-66.5 149.1-148.6V383.9zM225.5 660.4a42.58 42.58 0 0 1-32.9-39.7c-.1-.6-.1-216.1 0-216.6.8-19.4 14.6-35.5 32.9-39.7l201-43.7 21.6-85.2H213.8c-82.1 0-148.8 66.4-149.1 148.6V641c.3 82.1 67 148.6 149.1 148.6H448l-21.6-85.3-200.9-43.9zm200.9-158.8h171v21.3h-171z'));
exports.AmazonOutline = getIcon('amazon', outline, getNode(newViewBox, 'M825 768.9c-3.3-.9-7.3-.4-11.9 1.3-61.6 28.2-121.5 48.3-179.7 60.2C507.7 856 385.2 842.6 266 790.3c-33.1-14.6-79.1-39.2-138-74a9.36 9.36 0 0 0-5.3-2c-2-.1-3.7.1-5.3.9-1.6.8-2.8 1.8-3.7 3.1-.9 1.3-1.1 3.1-.4 5.4.6 2.2 2.1 4.7 4.6 7.4 10.4 12.2 23.3 25.2 38.6 39s35.6 29.4 60.9 46.8c25.3 17.4 51.8 32.9 79.3 46.4 27.6 13.5 59.6 24.9 96.1 34.1s73 13.8 109.4 13.8c36.2 0 71.4-3.7 105.5-10.9 34.2-7.3 63-15.9 86.5-25.9 23.4-9.9 45-21 64.8-33 19.8-12 34.4-22.2 43.9-30.3 9.5-8.2 16.3-14.6 20.2-19.4 4.6-5.7 6.9-10.6 6.9-14.9.1-4.5-1.7-7.1-5-7.9zM527.4 348.1c-15.2 1.3-33.5 4.1-55 8.3-21.5 4.1-41.4 9.3-59.8 15.4s-37.2 14.6-56.3 25.4c-19.2 10.8-35.5 23.2-49 37s-24.5 31.1-33.1 52c-8.6 20.8-12.9 43.7-12.9 68.7 0 27.1 4.7 51.2 14.3 72.5 9.5 21.3 22.2 38 38.2 50.4 15.9 12.4 34 22.1 54 29.2 20 7.1 41.2 10.3 63.2 9.4 22-.9 43.5-4.3 64.4-10.3 20.8-5.9 40.4-15.4 58.6-28.3 18.2-12.9 33.1-28.2 44.8-45.7 4.3 6.6 8.1 11.5 11.5 14.7l8.7 8.9c5.8 5.9 14.7 14.6 26.7 26.1 11.9 11.5 24.1 22.7 36.3 33.7l104.4-99.9-6-4.9c-4.3-3.3-9.4-8-15.2-14.3-5.8-6.2-11.6-13.1-17.2-20.5-5.7-7.4-10.6-16.1-14.7-25.9-4.1-9.8-6.2-19.3-6.2-28.5V258.7c0-10.1-1.9-21-5.7-32.8-3.9-11.7-10.7-24.5-20.7-38.3-10-13.8-22.4-26.2-37.2-37-14.9-10.8-34.7-20-59.6-27.4-24.8-7.4-52.6-11.1-83.2-11.1-31.3 0-60.4 3.7-87.6 10.9-27.1 7.3-50.3 17-69.7 29.2-19.3 12.2-35.9 26.3-49.7 42.4-13.8 16.1-24.1 32.9-30.8 50.4-6.7 17.5-10.1 35.2-10.1 53.1L408 310c5.5-16.4 12.9-30.6 22-42.8 9.2-12.2 17.9-21 25.8-26.5 8-5.5 16.6-9.9 25.7-13.2 9.2-3.3 15.4-5 18.6-5.4 3.2-.3 5.7-.4 7.6-.4 26.7 0 45.2 7.9 55.6 23.6 6.5 9.5 9.7 23.9 9.7 43.3v56.6c-15.2.6-30.4 1.6-45.6 2.9zM573.1 500c0 16.6-2.2 31.7-6.5 45-9.2 29.1-26.7 47.4-52.4 54.8-22.4 6.6-43.7 3.3-63.9-9.8-21.5-14-32.2-33.8-32.2-59.3 0-19.9 5-36.9 15-51.1 10-14.1 23.3-24.7 40-31.7s33-12 49-14.9c15.9-3 33-4.8 51-5.4V500zm335.2 218.9c-4.3-5.4-15.9-8.9-34.9-10.7-19-1.8-35.5-1.7-49.7.4-15.3 1.8-31.1 6.2-47.3 13.4-16.3 7.1-23.4 13.1-21.6 17.8l.7 1.3.9.7 1.4.2h4.6c.8 0 1.8-.1 3.2-.2 1.4-.1 2.7-.3 3.9-.4 1.2-.1 2.9-.3 5.1-.4 2.1-.1 4.1-.4 6-.7.3 0 3.7-.3 10.3-.9 6.6-.6 11.4-1 14.3-1.3 2.9-.3 7.8-.6 14.5-.9 6.7-.3 12.1-.3 16.1 0 4 .3 8.5.7 13.6 1.1 5.1.4 9.2 1.3 12.4 2.7 3.2 1.3 5.6 3 7.1 5.1 5.2 6.6 4.2 21.2-3 43.9s-14 40.8-20.4 54.2c-2.8 5.7-2.8 9.2 0 10.7s6.7.1 11.9-4c15.6-12.2 28.6-30.6 39.1-55.3 6.1-14.6 10.5-29.8 13.1-45.7 2.4-15.9 2-26.2-1.3-31z'));
exports.AntCloudOutline = getIcon('ant-cloud', outline, getNode(newViewBox, 'M378.9 738c-3.1 0-6.1-.5-8.8-1.5l4.4 30.7h26.3l-15.5-29.9c-2.1.5-4.2.7-6.4.7zm421-291.2c-12.6 0-24.8 1.5-36.5 4.2-21.4-38.4-62.3-64.3-109.3-64.3-6.9 0-13.6.6-20.2 1.6-35.4-77.4-113.4-131.1-203.9-131.1-112.3 0-205.3 82.6-221.6 190.4C127.3 455.5 64 523.8 64 607c0 88.4 71.6 160.1 160 160.2h50l13.2-27.6c-26.2-8.3-43.3-29-39.1-48.8 4.6-21.6 32.8-33.9 63.1-27.5 22.9 4.9 40.4 19.1 45.5 35.1a26.1 26.1 0 0 1 22.1-12.4h.2c-.8-3.2-1.2-6.5-1.2-9.9 0-20.1 14.8-36.7 34.1-39.6v-25.4c0-4.4 3.6-8 8-8s8 3.6 8 8v26.3c4.6 1.2 8.8 3.2 12.6 5.8l19.5-21.4c3-3.3 8-3.5 11.3-.5 3.3 3 3.5 8 .5 11.3l-20 22-.2.2a40 40 0 0 1-46.9 59.2c-.4 5.6-2.6 10.7-6 14.8l20 38.4H804v-.1c86.5-2.2 156-73 156-160.1 0-88.5-71.7-160.2-160.1-160.2zM338.2 737.2l-4.3 30h24.4l-5.9-41.5c-3.5 4.6-8.3 8.5-14.2 11.5zM797.5 305a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-65.7 61.3a24 24 0 1 0 48 0 24 24 0 1 0-48 0zM303.4 742.9l-11.6 24.3h26l3.5-24.7c-5.7.8-11.7 1-17.9.4z'));
exports.ApartmentOutline = getIcon('apartment', outline, getNode(newViewBox, 'M908 640H804V488c0-4.4-3.6-8-8-8H548v-96h108c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h108v96H228c-4.4 0-8 3.6-8 8v152H116c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16H292v-88h440v88H620c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16zm-564 76v168H176V716h168zm84-408V140h168v168H428zm420 576H680V716h168v168z'));
exports.AntDesignOutline = getIcon('ant-design', outline, getNode(newViewBox, 'M716.3 313.8c19-18.9 19-49.7 0-68.6l-69.9-69.9.1.1c-18.5-18.5-50.3-50.3-95.3-95.2-21.2-20.7-55.5-20.5-76.5.5L80.9 474.2a53.84 53.84 0 0 0 0 76.4L474.6 944a54.14 54.14 0 0 0 76.5 0l165.1-165c19-18.9 19-49.7 0-68.6a48.7 48.7 0 0 0-68.7 0l-125 125.2c-5.2 5.2-13.3 5.2-18.5 0L189.5 521.4c-5.2-5.2-5.2-13.3 0-18.5l314.4-314.2c.4-.4.9-.7 1.3-1.1 5.2-4.1 12.4-3.7 17.2 1.1l125.2 125.1c19 19 49.8 19 68.7 0zM408.6 514.4a106.3 106.2 0 1 0 212.6 0 106.3 106.2 0 1 0-212.6 0zm536.2-38.6L821.9 353.5c-19-18.9-49.8-18.9-68.7.1a48.4 48.4 0 0 0 0 68.6l83 82.9c5.2 5.2 5.2 13.3 0 18.5l-81.8 81.7a48.4 48.4 0 0 0 0 68.6 48.7 48.7 0 0 0 68.7 0l121.8-121.7a53.93 53.93 0 0 0-.1-76.4z'));
exports.AreaChartOutline = getIcon('area-chart', outline, getNode(newViewBox, 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-616-64h536c4.4 0 8-3.6 8-8V284c0-7.2-8.7-10.7-13.7-5.7L592 488.6l-125.4-124a8.03 8.03 0 0 0-11.3 0l-189 189.6a7.87 7.87 0 0 0-2.3 5.6V720c0 4.4 3.6 8 8 8z'));
exports.ArrowLeftOutline = getIcon('arrow-left', outline, getNode(newViewBox, 'M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 0 0 0 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
exports.ArrowDownOutline = getIcon('arrow-down', outline, getNode(newViewBox, 'M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0 0 48.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z'));
exports.ArrowUpOutline = getIcon('arrow-up', outline, getNode(newViewBox, 'M868 545.5L536.1 163a31.96 31.96 0 0 0-48.3 0L156 545.5a7.97 7.97 0 0 0 6 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z'));
exports.ArrowsAltOutline = getIcon('arrows-alt', outline, getNode(newViewBox, 'M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 0 0 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0 0 13.5-4.7L863.9 169a7.9 7.9 0 0 0-8.9-8.9zM416.6 562.3a8.03 8.03 0 0 0-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 0 0-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z'));
exports.ArrowRightOutline = getIcon('arrow-right', outline, getNode(newViewBox, 'M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z'));
exports.AuditOutline = getIcon('audit', outline, getNode(newViewBox, 'M296 250c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 144H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 458H208V148h560v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm440-88H728v-36.6c46.3-13.8 80-56.6 80-107.4 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 50.7 33.7 93.6 80 107.4V764H520c-8.8 0-16 7.2-16 16v152c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V780c0-8.8-7.2-16-16-16zM646 620c0-27.6 22.4-50 50-50s50 22.4 50 50-22.4 50-50 50-50-22.4-50-50zm180 266H566v-60h260v60z'));
exports.BarChartOutline = getIcon('bar-chart', outline, getNode(newViewBox, 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-600-80h56c4.4 0 8-3.6 8-8V560c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V384c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v320c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V462c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v242c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v400c0 4.4 3.6 8 8 8z'));
exports.BarcodeOutline = getIcon('barcode', outline, getNode(newViewBox, 'M120 160H72c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm833 0h-48c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zM200 736h112c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm321 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm126 0h178c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H647c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-255 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-79 64H201c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm257 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm256 0H648c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h178c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-385 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
exports.BarsOutline = getIcon('bars', outline, getNode(normalViewBox, 'M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
exports.BgColorsOutline = getIcon('bg-colors', outline, getNode(newViewBox, 'M766.4 744.3c43.7 0 79.4-36.2 79.4-80.5 0-53.5-79.4-140.8-79.4-140.8S687 610.3 687 663.8c0 44.3 35.7 80.5 79.4 80.5zm-377.1-44.1c7.1 7.1 18.6 7.1 25.6 0l256.1-256c7.1-7.1 7.1-18.6 0-25.6l-256-256c-.6-.6-1.3-1.2-2-1.7l-78.2-78.2a9.11 9.11 0 0 0-12.8 0l-48 48a9.11 9.11 0 0 0 0 12.8l67.2 67.2-207.8 207.9c-7.1 7.1-7.1 18.6 0 25.6l255.9 256zm12.9-448.6l178.9 178.9H223.4l178.8-178.9zM904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z'));
exports.BehanceOutline = getIcon('behance', outline, getNode(newViewBox, 'M634 294.3h199.5v48.4H634zM434.1 485.8c44.1-21.1 67.2-53.2 67.2-102.8 0-98.1-73-121.9-157.3-121.9H112v492.4h238.5c89.4 0 173.3-43 173.3-143 0-61.8-29.2-107.5-89.7-124.7zM220.2 345.1h101.5c39.1 0 74.2 10.9 74.2 56.3 0 41.8-27.3 58.6-66 58.6H220.2V345.1zm115.5 324.8H220.1V534.3H338c47.6 0 77.7 19.9 77.7 70.3 0 49.6-35.9 65.3-80 65.3zm575.8-89.5c0-105.5-61.7-193.4-173.3-193.4-108.5 0-182.3 81.7-182.3 188.8 0 111 69.9 187.2 182.3 187.2 85.1 0 140.2-38.3 166.7-120h-86.3c-9.4 30.5-47.6 46.5-77.3 46.5-57.4 0-87.4-33.6-87.4-90.7h256.9c.3-5.9.7-12.1.7-18.4zM653.9 537c3.1-46.9 34.4-76.2 81.2-76.2 49.2 0 73.8 28.9 78.1 76.2H653.9z'));
exports.BlockOutline = getIcon('block', outline, getNode(newViewBox, 'M856 376H648V168c0-8.8-7.2-16-16-16H168c-8.8 0-16 7.2-16 16v464c0 8.8 7.2 16 16 16h208v208c0 8.8 7.2 16 16 16h464c8.8 0 16-7.2 16-16V392c0-8.8-7.2-16-16-16zm-480 16v188H220V220h360v156H392c-8.8 0-16 7.2-16 16zm204 52v136H444V444h136zm224 360H444V648h188c8.8 0 16-7.2 16-16V444h156v360z'));
exports.BoldOutline = getIcon('bold', outline, getNode(newViewBox, 'M697.8 481.4c33.6-35 54.2-82.3 54.2-134.3v-10.2C752 229.3 663.9 142 555.3 142H259.4c-15.1 0-27.4 12.3-27.4 27.4v679.1c0 16.3 13.2 29.5 29.5 29.5h318.7c117 0 211.8-94.2 211.8-210.5v-11c0-73-37.4-137.3-94.2-175.1zM328 238h224.7c57.1 0 103.3 44.4 103.3 99.3v9.5c0 54.8-46.3 99.3-103.3 99.3H328V238zm366.6 429.4c0 62.9-51.7 113.9-115.5 113.9H328V542.7h251.1c63.8 0 115.5 51 115.5 113.9v10.8z'));
exports.BorderBottomOutline = getIcon('border-bottom', outline, getNode(newViewBox, 'M872 808H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-720-94h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-498h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm166 166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm222-72h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388 426h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
exports.BorderLeftOutline = getIcon('border-left', outline, getNode(newViewBox, 'M208 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM540 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.BorderOuterOutline = getIcon('border-outer', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM484 366h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM302 548h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm364 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-182 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 182h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
exports.BorderInnerOutline = getIcon('border-inner', outline, getNode(newViewBox, 'M872 476H548V144h-72v332H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h324v332h72V548h324c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-426h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 260h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.BorderRightOutline = getIcon('border-right', outline, getNode(newViewBox, 'M872 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.BorderHorizontalOutline = getIcon('border-horizontal', outline, getNode(newViewBox, 'M540 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.BorderTopOutline = getIcon('border-top', outline, getNode(newViewBox, 'M872 144H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332-498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.BorderVerticleOutline = getIcon('border-verticle', outline, getNode(newViewBox, 'M872 476H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM152 382h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 642h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.BorderOutline = getIcon('border', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.BranchesOutline = getIcon('branches', outline, getNode(newViewBox, 'M740 161c-61.8 0-112 50.2-112 112 0 50.1 33.1 92.6 78.5 106.9v95.9L320 602.4V318.1c44.2-15 76-56.9 76-106.1 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-27.8l423.5-138.7a50.52 50.52 0 0 0 34.9-48.2V378.2c42.9-15.8 73.6-57 73.6-105.2 0-61.8-50.2-112-112-112zm-504 51a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm96 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm408-491a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.CheckOutline = getIcon('check', outline, getNode(newViewBox, 'M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z'));
exports.CiOutline = getIcon('ci', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm218-572.1h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z'));
exports.CloseOutline = getIcon('close', outline, getNode(newViewBox, 'M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z'));
exports.CloudDownloadOutline = getIcon('cloud-download', outline, getNode(newViewBox, 'M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9z', 'M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z'));
exports.CloudServerOutline = getIcon('cloud-server', outline, getNode(newViewBox, 'M704 446H320c-4.4 0-8 3.6-8 8v402c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8V454c0-4.4-3.6-8-8-8zm-328 64h272v117H376V510zm272 290H376V683h272v117z', 'M424 748a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm0-178a32 32 0 1 0 64 0 32 32 0 1 0-64 0z', 'M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z'));
exports.CloudSyncOutline = getIcon('cloud-sync', outline, getNode(newViewBox, 'M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z', 'M376.9 656.4c1.8-33.5 15.7-64.7 39.5-88.6 25.4-25.5 60-39.8 96-39.8 36.2 0 70.3 14.1 96 39.8 1.4 1.4 2.7 2.8 4.1 4.3l-25 19.6a8 8 0 0 0 3 14.1l98.2 24c5 1.2 9.9-2.6 9.9-7.7l.5-101.3c0-6.7-7.6-10.5-12.9-6.3L663 532.7c-36.6-42-90.4-68.6-150.5-68.6-107.4 0-195 85.1-199.4 191.7-.2 4.5 3.4 8.3 8 8.3H369c4.2-.1 7.7-3.4 7.9-7.7zM703 664h-47.9c-4.2 0-7.7 3.3-8 7.6-1.8 33.5-15.7 64.7-39.5 88.6-25.4 25.5-60 39.8-96 39.8-36.2 0-70.3-14.1-96-39.8-1.4-1.4-2.7-2.8-4.1-4.3l25-19.6a8 8 0 0 0-3-14.1l-98.2-24c-5-1.2-9.9 2.6-9.9 7.7l-.4 101.4c0 6.7 7.6 10.5 12.9 6.3l23.2-18.2c36.6 42 90.4 68.6 150.5 68.6 107.4 0 195-85.1 199.4-191.7.2-4.5-3.4-8.3-8-8.3z'));
exports.CloudUploadOutline = getIcon('cloud-upload', outline, getNode(newViewBox, 'M518.3 459a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z', 'M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z'));
exports.ClusterOutline = getIcon('cluster', outline, getNode(newViewBox, 'M888 680h-54V540H546v-92h238c8.8 0 16-7.2 16-16V168c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h238v92H190v140h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8zM256 805.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zm288 0c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM288 384V216h448v168H288zm544 421.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM360 300a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.CodepenOutline = getIcon('codepen', outline, getNode(newViewBox, 'M911.7 385.3l-.3-1.5c-.2-1-.3-1.9-.6-2.9-.2-.6-.4-1.1-.5-1.7-.3-.8-.5-1.7-.9-2.5-.2-.6-.5-1.1-.8-1.7-.4-.8-.8-1.5-1.2-2.3-.3-.5-.6-1.1-1-1.6-.8-1.2-1.7-2.4-2.6-3.6-.5-.6-1.1-1.3-1.7-1.9-.4-.5-.9-.9-1.4-1.3-.6-.6-1.3-1.1-1.9-1.6-.5-.4-1-.8-1.6-1.2-.2-.1-.4-.3-.6-.4L531.1 117.8a34.3 34.3 0 0 0-38.1 0L127.3 361.3c-.2.1-.4.3-.6.4-.5.4-1 .8-1.6 1.2-.7.5-1.3 1.1-1.9 1.6-.5.4-.9.9-1.4 1.3-.6.6-1.2 1.2-1.7 1.9-1 1.1-1.8 2.3-2.6 3.6-.3.5-.7 1-1 1.6-.4.7-.8 1.5-1.2 2.3-.3.5-.5 1.1-.8 1.7-.3.8-.6 1.7-.9 2.5-.2.6-.4 1.1-.5 1.7-.2.9-.4 1.9-.6 2.9l-.3 1.5c-.2 1.5-.3 3-.3 4.5v243.5c0 1.5.1 3 .3 4.5l.3 1.5.6 2.9c.2.6.3 1.1.5 1.7.3.9.6 1.7.9 2.5.2.6.5 1.1.8 1.7.4.8.7 1.5 1.2 2.3.3.5.6 1.1 1 1.6.5.7.9 1.4 1.5 2.1l1.2 1.5c.5.6 1.1 1.3 1.7 1.9.4.5.9.9 1.4 1.3.6.6 1.3 1.1 1.9 1.6.5.4 1 .8 1.6 1.2.2.1.4.3.6.4L493 905.7c5.6 3.8 12.3 5.8 19.1 5.8 6.6 0 13.3-1.9 19.1-5.8l365.6-243.5c.2-.1.4-.3.6-.4.5-.4 1-.8 1.6-1.2.7-.5 1.3-1.1 1.9-1.6.5-.4.9-.9 1.4-1.3.6-.6 1.2-1.2 1.7-1.9l1.2-1.5 1.5-2.1c.3-.5.7-1 1-1.6.4-.8.8-1.5 1.2-2.3.3-.5.5-1.1.8-1.7.3-.8.6-1.7.9-2.5.2-.5.4-1.1.5-1.7.3-.9.4-1.9.6-2.9l.3-1.5c.2-1.5.3-3 .3-4.5V389.8c-.3-1.5-.4-3-.6-4.5zM546.4 210.5l269.4 179.4-120.3 80.4-149-99.6V210.5zm-68.8 0v160.2l-149 99.6-120.3-80.4 269.3-179.4zM180.7 454.1l86 57.5-86 57.5v-115zm296.9 358.5L208.3 633.2l120.3-80.4 149 99.6v160.2zM512 592.8l-121.6-81.2L512 430.3l121.6 81.2L512 592.8zm34.4 219.8V652.4l149-99.6 120.3 80.4-269.3 179.4zM843.3 569l-86-57.5 86-57.5v115z'));
exports.CodeSandboxOutline = getIcon('code-sandbox', outline, getNode(newViewBox, 'M709.6 210l.4-.2h.2L512 96 313.9 209.8h-.2l.7.3L151.5 304v416L512 928l360.5-208V304l-162.9-94zM482.7 843.6L339.6 761V621.4L210 547.8V372.9l272.7 157.3v313.4zM238.2 321.5l134.7-77.8 138.9 79.7 139.1-79.9 135.2 78-273.9 158-274-158zM814 548.3l-128.8 73.1v139.1l-143.9 83V530.4L814 373.1v175.2z'));
exports.ColumHeightOutline = getIcon('colum-height', outline, getNode(newViewBox, 'M840 836H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm0-724H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM610.8 378c6 0 9.4-7 5.7-11.7L515.7 238.7a7.14 7.14 0 0 0-11.3 0L403.6 366.3a7.23 7.23 0 0 0 5.7 11.7H476v268h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V378h62.8z'));
exports.ColumnWidthOutline = getIcon('column-width', outline, getNode(newViewBox, 'M180 176h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zm724 0h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zM785.3 504.3L657.7 403.6a7.23 7.23 0 0 0-11.7 5.7V476H378v-62.8c0-6-7-9.4-11.7-5.7L238.7 508.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h268v62.8c0 6 7 9.4 11.7 5.7l127.5-100.8c3.8-2.9 3.8-8.5.2-11.4z'));
exports.ColumnHeightOutline = getIcon('column-height', outline, getNode(newViewBox, 'M840 836H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm0-724H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM610.8 378c6 0 9.4-7 5.7-11.7L515.7 238.7a7.14 7.14 0 0 0-11.3 0L403.6 366.3a7.23 7.23 0 0 0 5.7 11.7H476v268h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V378h62.8z'));
exports.CoffeeOutline = getIcon('coffee', outline, getNode(normalViewBox, 'M275 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm613 144H768c0-39.8-32.2-72-72-72H200c-39.8 0-72 32.2-72 72v248c0 3.4.2 6.7.7 9.9-.5 7-.7 14-.7 21.1 0 176.7 143.3 320 320 320 160.1 0 292.7-117.5 316.3-271H888c39.8 0 72-32.2 72-72V497c0-39.8-32.2-72-72-72zM696 681h-1.1c.7 7.6 1.1 15.2 1.1 23 0 137-111 248-248 248S200 841 200 704c0-7.8.4-15.4 1.1-23H200V425h496v256zm192-8H776V497h112v176zM613 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm-170 0c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36z'));
exports.CopyrightOutline = getIcon('copyright', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z'));
exports.DashOutline = getIcon('dash', outline, getNode(newViewBox, 'M112 476h160v72H112zm320 0h160v72H432zm320 0h160v72H752z'));
exports.DeploymentUnitOutline = getIcon('deployment-unit', outline, getNode(newViewBox, 'M888.3 693.2c-42.5-24.6-94.3-18-129.2 12.8l-53-30.7V523.6c0-15.7-8.4-30.3-22-38.1l-136-78.3v-67.1c44.2-15 76-56.8 76-106.1 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 49.3 31.8 91.1 76 106.1v67.1l-136 78.3c-13.6 7.8-22 22.4-22 38.1v151.6l-53 30.7c-34.9-30.8-86.8-37.4-129.2-12.8-53.5 31-71.7 99.4-41 152.9 30.8 53.5 98.9 71.9 152.2 41 42.5-24.6 62.7-73 53.6-118.8l48.7-28.3 140.6 81c6.8 3.9 14.4 5.9 22 5.9s15.2-2 22-5.9L674.5 740l48.7 28.3c-9.1 45.7 11.2 94.2 53.6 118.8 53.3 30.9 121.5 12.6 152.2-41 30.8-53.6 12.6-122-40.7-152.9zm-673 138.4a47.6 47.6 0 0 1-65.2-17.6c-13.2-22.9-5.4-52.3 17.5-65.5a47.6 47.6 0 0 1 65.2 17.6c13.2 22.9 5.4 52.3-17.5 65.5zM522 463.8zM464 234a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm170 446.2l-122 70.3-122-70.3V539.8l122-70.3 122 70.3v140.4zm239.9 133.9c-13.2 22.9-42.4 30.8-65.2 17.6-22.8-13.2-30.7-42.6-17.5-65.5s42.4-30.8 65.2-17.6c22.9 13.2 30.7 42.5 17.5 65.5z'));
exports.DesktopOutline = getIcon('desktop', outline, getNode(newViewBox, 'M928 140H96c-17.7 0-32 14.3-32 32v496c0 17.7 14.3 32 32 32h380v112H304c-8.8 0-16 7.2-16 16v48c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-48c0-8.8-7.2-16-16-16H548V700h380c17.7 0 32-14.3 32-32V172c0-17.7-14.3-32-32-32zm-40 488H136V212h752v416z'));
exports.DingdingOutline = getIcon('dingding', outline, getNode(newViewBox, 'M573.7 252.5C422.5 197.4 201.3 96.7 201.3 96.7c-15.7-4.1-17.9 11.1-17.9 11.1-5 61.1 33.6 160.5 53.6 182.8 19.9 22.3 319.1 113.7 319.1 113.7S326 357.9 270.5 341.9c-55.6-16-37.9 17.8-37.9 17.8 11.4 61.7 64.9 131.8 107.2 138.4 42.2 6.6 220.1 4 220.1 4s-35.5 4.1-93.2 11.9c-42.7 5.8-97 12.5-111.1 17.8-33.1 12.5 24 62.6 24 62.6 84.7 76.8 129.7 50.5 129.7 50.5 33.3-10.7 61.4-18.5 85.2-24.2L565 743.1h84.6L603 928l205.3-271.9H700.8l22.3-38.7c.3.5.4.8.4.8S799.8 496.1 829 433.8l.6-1h-.1c5-10.8 8.6-19.7 10-25.8 17-71.3-114.5-99.4-265.8-154.5z'));
exports.DisconnectOutline = getIcon('disconnect', outline, getNode(newViewBox, 'M832.6 191.4c-84.6-84.6-221.5-84.6-306 0l-96.9 96.9 51 51 96.9-96.9c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204l-96.9 96.9 51.1 51.1 96.9-96.9c84.4-84.6 84.4-221.5-.1-306.1zM446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l96.9-96.9-51.1-51.1-96.9 96.9c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l96.9-96.9-51-51-96.8 97zM260.3 209.4a8.03 8.03 0 0 0-11.3 0L209.4 249a8.03 8.03 0 0 0 0 11.3l554.4 554.4c3.1 3.1 8.2 3.1 11.3 0l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3L260.3 209.4z'));
exports.DollarOutline = getIcon('dollar', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z'));
exports.DoubleRightOutline = getIcon('double-right', outline, getNode(newViewBox, 'M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 0 0 188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 0 0 492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z'));
exports.DotChartOutline = getIcon('dot-chart', outline, getNode(newViewBox, 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm118-224a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm158 228a96 96 0 1 0 192 0 96 96 0 1 0-192 0zm148-314a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
exports.DoubleLeftOutline = getIcon('double-left', outline, getNode(newViewBox, 'M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 0 0 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 0 0 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z'));
exports.DownloadOutline = getIcon('download', outline, getNode(newViewBox, 'M505.7 661a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z'));
exports.DribbbleOutline = getIcon('dribbble', outline, getNode(newViewBox, 'M512 96C282.6 96 96 282.6 96 512s186.6 416 416 416 416-186.6 416-416S741.4 96 512 96zm275.1 191.8c49.5 60.5 79.5 137.5 80.2 221.4-11.7-2.5-129.2-26.3-247.4-11.4-2.5-6.1-5-12.2-7.6-18.3-7.4-17.3-15.3-34.6-23.6-51.5C720 374.3 779.6 298 787.1 287.8zM512 157.2c90.3 0 172.8 33.9 235.5 89.5-6.4 9.1-59.9 81-186.2 128.4-58.2-107-122.7-194.8-132.6-208 27.3-6.6 55.2-9.9 83.3-9.9zM360.9 191c9.4 12.8 72.9 100.9 131.7 205.5C326.4 440.6 180 440 164.1 439.8c23.1-110.3 97.4-201.9 196.8-248.8zM156.7 512.5c0-3.6.1-7.3.2-10.9 15.5.3 187.7 2.5 365.2-50.6 10.2 19.9 19.9 40.1 28.8 60.3-4.7 1.3-9.4 2.7-14 4.2C353.6 574.9 256.1 736.4 248 750.1c-56.7-63-91.3-146.3-91.3-237.6zM512 867.8c-82.2 0-157.9-28-218.1-75 6.4-13.1 78.3-152 278.7-221.9l2.3-.8c49.9 129.6 70.5 238.3 75.8 269.5A350.46 350.46 0 0 1 512 867.8zm198.5-60.7c-3.6-21.6-22.5-125.6-69-253.3C752.9 536 850.7 565.2 862.8 569c-15.8 98.8-72.5 184.2-152.3 238.1z'));
exports.DropboxOutline = getIcon('dropbox', outline, getNode(newViewBox, 'M64 556.9l264.2 173.5L512.5 577 246.8 412.7zm896-290.3zm0 0L696.8 95 512.5 248.5l265.2 164.2L512.5 577l184.3 153.4L960 558.8 777.7 412.7zM513 609.8L328.2 763.3l-79.4-51.5v57.8L513 928l263.7-158.4v-57.8l-78.9 51.5zM328.2 95L64 265.1l182.8 147.6 265.7-164.2zM64 556.9z'));
exports.EllipsisOutline = getIcon('ellipsis', outline, getNode(newViewBox, 'M176 511a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
exports.EnterOutline = getIcon('enter', outline, getNode(newViewBox, 'M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 0 0 0 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z'));
exports.EuroOutline = getIcon('euro', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm117.7-588.6c-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H344c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H344c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H439.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H447.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8z'));
exports.ExceptionOutline = getIcon('exception', outline, getNode(newViewBox, 'M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM640 812a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm12-64h40c4.4 0 8-3.6 8-8V628c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.ExclamationOutline = getIcon('exclamation', outline, getNode(newViewBox, 'M448 804a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm32-168h64c4.4 0 8-3.6 8-8V164c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z'));
exports.ExportOutline = getIcon('export', outline, getNode(newViewBox, 'M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7zm18.6-251.7L765 393.7c-5.3-4.2-13-.4-13 6.3v76H438c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6z'));
exports.FallOutline = getIcon('fall', outline, getNode(newViewBox, 'M925.9 804l-24-199.2c-.8-6.6-8.9-9.4-13.6-4.7L829 659.5 557.7 388.3c-6.3-6.2-16.4-6.2-22.6 0L433.3 490 156.6 213.3a8.03 8.03 0 0 0-11.3 0l-45 45.2a8.03 8.03 0 0 0 0 11.3L422 591.7c6.2 6.3 16.4 6.3 22.6 0L546.4 490l226.1 226-59.3 59.3a8.01 8.01 0 0 0 4.7 13.6l199.2 24c5.1.7 9.5-3.7 8.8-8.9z'));
exports.FileDoneOutline = getIcon('file-done', outline, getNode(newViewBox, 'M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM761 656h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-23.1-31.9a7.92 7.92 0 0 0-6.5-3.3H573c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.9-5.3.1-12.7-6.4-12.7zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.FileSyncOutline = getIcon('file-sync', outline, getNode(newViewBox, 'M296 256c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm192 200v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8zm-48 396H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm104.1-115.6c1.8-34.5 16.2-66.8 40.8-91.4 26.2-26.2 62-41 99.1-41 37.4 0 72.6 14.6 99.1 41 3.2 3.2 6.3 6.6 9.2 10.1L769.2 673a8 8 0 0 0 3 14.1l93.3 22.5c5 1.2 9.8-2.6 9.9-7.7l.6-95.4a8 8 0 0 0-12.9-6.4l-20.3 15.8C805.4 569.6 748.1 540 684 540c-109.9 0-199.6 86.9-204 195.7-.2 4.5 3.5 8.3 8 8.3h48.1c4.3 0 7.8-3.3 8-7.6zM880 744h-48.1c-4.3 0-7.8 3.3-8 7.6-1.8 34.5-16.2 66.8-40.8 91.4-26.2 26.2-62 41-99.1 41-37.4 0-72.6-14.6-99.1-41-3.2-3.2-6.3-6.6-9.2-10.1l23.1-17.9a8 8 0 0 0-3-14.1l-93.3-22.5c-5-1.2-9.8 2.6-9.9 7.7l-.6 95.4a8 8 0 0 0 12.9 6.4l20.3-15.8C562.6 918.4 619.9 948 684 948c109.9 0 199.6-86.9 204-195.7.2-4.5-3.5-8.3-8-8.3z'));
exports.FileProtectOutline = getIcon('file-protect', outline, getNode(newViewBox, 'M644.7 669.2a7.92 7.92 0 0 0-6.5-3.3H594c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.8-5.3 0-12.7-6.5-12.7h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-22.9-31.9zM688 306v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 458H208V148h560v296c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h312c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm402.6-320.8l-192-66.7c-.9-.3-1.7-.4-2.6-.4s-1.8.1-2.6.4l-192 66.7a7.96 7.96 0 0 0-5.4 7.5v251.1c0 2.5 1.1 4.8 3.1 6.3l192 150.2c1.4 1.1 3.2 1.7 4.9 1.7s3.5-.6 4.9-1.7l192-150.2c1.9-1.5 3.1-3.8 3.1-6.3V538.7c0-3.4-2.2-6.4-5.4-7.5zM826 763.7L688 871.6 550 763.7V577l138-48 138 48v186.7z'));
exports.FileSearchOutline = getIcon('file-search', outline, getNode(newViewBox, 'M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm144 452H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm445.7 51.5l-93.3-93.3C814.7 780.7 828 743.9 828 704c0-97.2-78.8-176-176-176s-176 78.8-176 176 78.8 176 176 176c35.8 0 69-10.7 96.8-29l94.7 94.7c1.6 1.6 3.6 2.3 5.6 2.3s4.1-.8 5.6-2.3l31-31a7.9 7.9 0 0 0 0-11.2zM652 816c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z'));
exports.FileJpgOutline = getIcon('file-jpg', outline, getNode(normalViewBox, 'M874.6 301.8L596.8 21.3c-4.5-4.5-9.4-8.3-14.7-11.5-1.4-.8-2.8-1.6-4.3-2.3-.9-.5-1.9-.9-2.8-1.3-9-4-18.9-6.2-29-6.2H201c-39.8 0-73 32.2-73 72v880c0 39.8 33.2 72 73 72h623c39.8 0 71-32.2 71-72V352.5c0-19-7-37.2-20.4-50.7zM583 110.4L783.8 312H583V110.4zM823 952H200V72h311v240c0 39.8 33.2 72 73 72h239v568zM350 696.5c0 24.2-7.5 31.4-21.9 31.4-9 0-18.4-5.8-24.8-18.5L272.9 732c13.4 22.9 32.3 34.2 61.3 34.2 41.6 0 60.8-29.9 60.8-66.2V577h-45v119.5zM501.3 577H437v186h44v-62h21.6c39.1 0 73.1-19.6 73.1-63.6 0-45.8-33.5-60.4-74.4-60.4zm-.8 89H481v-53h18.2c21.5 0 33.4 6.2 33.4 24.9 0 18.1-10.5 28.1-32.1 28.1zm182.5-9v36h30v30.1c-4 2.9-11 4.7-17.7 4.7-34.3 0-50.7-21.4-50.7-58.2 0-36.1 19.7-57.4 47.1-57.4 15.3 0 25 6.2 34 14.4l23.7-28.3c-12.7-12.8-32.1-24.2-59.2-24.2-49.6 0-91.1 35.3-91.1 97 0 62.7 40 95.1 91.5 95.1 25.9 0 49.2-10.2 61.5-22.6V657H683z'));
exports.FontColorsOutline = getIcon('font-colors', outline, getNode(newViewBox, 'M904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zm-650.3-80h85c4.2 0 8-2.7 9.3-6.8l53.7-166h219.2l53.2 166c1.3 4 5 6.8 9.3 6.8h89.1c1.1 0 2.2-.2 3.2-.5a9.7 9.7 0 0 0 6-12.4L573.6 118.6a9.9 9.9 0 0 0-9.2-6.6H462.1c-4.2 0-7.9 2.6-9.2 6.6L244.5 723.1c-.4 1-.5 2.1-.5 3.2-.1 5.3 4.3 9.7 9.7 9.7zm255.9-516.1h4.1l83.8 263.8H424.9l84.7-263.8z'));
exports.FontSizeOutline = getIcon('font-size', outline, getNode(newViewBox, 'M920 416H616c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h60v320h-46c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h164c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-46V480h60v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V424c0-4.4-3.6-8-8-8zM656 296V168c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8z'));
exports.ForkOutline = getIcon('fork', outline, getNode(newViewBox, 'M752 100c-61.8 0-112 50.2-112 112 0 47.7 29.9 88.5 72 104.6v27.6L512 601.4 312 344.2v-27.6c42.1-16.1 72-56.9 72-104.6 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 50.6 33.8 93.5 80 107.3v34.4c0 9.7 3.3 19.3 9.3 27L476 672.3v33.6c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-33.6l226.7-291.6c6-7.7 9.3-17.3 9.3-27v-34.4c46.2-13.8 80-56.7 80-107.3 0-61.8-50.2-112-112-112zM224 212a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm336 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm192-552a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.FormOutline = getIcon('form', outline, getNode(newViewBox, 'M904 512h-56c-4.4 0-8 3.6-8 8v320H184V184h320c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V520c0-4.4-3.6-8-8-8z', 'M355.9 534.9L354 653.8c-.1 8.9 7.1 16.2 16 16.2h.4l118-2.9c2-.1 4-.9 5.4-2.3l415.9-415c3.1-3.1 3.1-8.2 0-11.3L785.4 114.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-415.8 415a8.3 8.3 0 0 0-2.3 5.6zm63.5 23.6L779.7 199l45.2 45.1-360.5 359.7-45.7 1.1.7-46.4z'));
exports.FullscreenExitOutline = getIcon('fullscreen-exit', outline, getNode(newViewBox, 'M391 240.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L200 146.3a8.03 8.03 0 0 0-11.3 0l-42.4 42.3a8.03 8.03 0 0 0 0 11.3L280 333.6l-43.9 43.9a8.01 8.01 0 0 0 4.7 13.6L401 410c5.1.6 9.5-3.7 8.9-8.9L391 240.9zm10.1 373.2L240.8 633c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L146.3 824a8.03 8.03 0 0 0 0 11.3l42.4 42.3c3.1 3.1 8.2 3.1 11.3 0L333.7 744l43.7 43.7A8.01 8.01 0 0 0 391 783l18.9-160.1c.6-5.1-3.7-9.4-8.8-8.8zm221.8-204.2L783.2 391c6.6-.8 9.4-8.9 4.7-13.6L744 333.6 877.7 200c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.3a8.03 8.03 0 0 0-11.3 0L690.3 279.9l-43.7-43.7a8.01 8.01 0 0 0-13.6 4.7L614.1 401c-.6 5.2 3.7 9.5 8.8 8.9zM744 690.4l43.9-43.9a8.01 8.01 0 0 0-4.7-13.6L623 614c-5.1-.6-9.5 3.7-8.9 8.9L633 783.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L824 877.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L744 690.4z'));
exports.FullscreenOutline = getIcon('fullscreen', outline, getNode(newViewBox, 'M290 236.4l43.9-43.9a8.01 8.01 0 0 0-4.7-13.6L169 160c-5.1-.6-9.5 3.7-8.9 8.9L179 329.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L370 423.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L290 236.4zm352.7 187.3c3.1 3.1 8.2 3.1 11.3 0l133.7-133.6 43.7 43.7a8.01 8.01 0 0 0 13.6-4.7L863.9 169c.6-5.1-3.7-9.5-8.9-8.9L694.8 179c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L600.3 370a8.03 8.03 0 0 0 0 11.3l42.4 42.4zM845 694.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L654 600.3a8.03 8.03 0 0 0-11.3 0l-42.4 42.3a8.03 8.03 0 0 0 0 11.3L734 787.6l-43.9 43.9a8.01 8.01 0 0 0 4.7 13.6L855 864c5.1.6 9.5-3.7 8.9-8.9L845 694.9zm-463.7-94.6a8.03 8.03 0 0 0-11.3 0L236.3 733.9l-43.7-43.7a8.01 8.01 0 0 0-13.6 4.7L160.1 855c-.6 5.1 3.7 9.5 8.9 8.9L329.2 845c6.6-.8 9.4-8.9 4.7-13.6L290 787.6 423.7 654c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.4z'));
exports.GatewayOutline = getIcon('gateway', outline, getNode(newViewBox, 'M928 392c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H744c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h56v240H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16V648c0-8.8-7.2-16-16-16h-56V392h56zM792 240h88v88h-88v-88zm-648 88v-88h88v88h-88zm88 456h-88v-88h88v88zm648-88v88h-88v-88h88zm-80-64h-56c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16h-56V392h56c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h56v240z'));
exports.DownOutline = getIcon('down', outline, getNode(newViewBox, 'M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z'));
exports.DragOutline = getIcon('drag', outline, getNode(newViewBox, 'M909.3 506.3L781.7 405.6a7.23 7.23 0 0 0-11.7 5.7V476H548V254h64.8c6 0 9.4-7 5.7-11.7L517.7 114.7a7.14 7.14 0 0 0-11.3 0L405.6 242.3a7.23 7.23 0 0 0 5.7 11.7H476v222H254v-64.8c0-6-7-9.4-11.7-5.7L114.7 506.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h222v222h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V548h222v64.8c0 6 7 9.4 11.7 5.7l127.5-100.8a7.3 7.3 0 0 0 .1-11.4z'));
exports.GlobalOutline = getIcon('global', outline, getNode(newViewBox, 'M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0 0 10-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 0 0 3.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 0 0-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 0 1 887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 0 1-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 0 1 115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 0 1 540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 0 0 540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 0 1-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 0 0-81.5 55.9A373.86 373.86 0 0 1 137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 0 1-107.6 69.2z'));
exports.GooglePlusOutline = getIcon('google-plus', outline, getNode(newViewBox, 'M879.5 470.4c-.3-27-.4-54.2-.5-81.3h-80.8c-.3 27-.5 54.1-.7 81.3-27.2.1-54.2.3-81.2.6v80.9c27 .3 54.2.5 81.2.8.3 27 .3 54.1.5 81.1h80.9c.1-27 .3-54.1.5-81.3 27.2-.3 54.2-.4 81.2-.7v-80.9c-26.9-.2-54.1-.2-81.1-.5zm-530 .4c-.1 32.3 0 64.7.1 97 54.2 1.8 108.5 1 162.7 1.8-23.9 120.3-187.4 159.3-273.9 80.7-89-68.9-84.8-220 7.7-284 64.7-51.6 156.6-38.9 221.3 5.8 25.4-23.5 49.2-48.7 72.1-74.7-53.8-42.9-119.8-73.5-190-70.3-146.6-4.9-281.3 123.5-283.7 270.2-9.4 119.9 69.4 237.4 180.6 279.8 110.8 42.7 252.9 13.6 323.7-86 46.7-62.9 56.8-143.9 51.3-220-90.7-.7-181.3-.6-271.9-.3z'));
exports.GoogleOutline = getIcon('google', outline, getNode(newViewBox, 'M881 442.4H519.7v148.5h206.4c-8.9 48-35.9 88.6-76.6 115.8-34.4 23-78.3 36.6-129.9 36.6-99.9 0-184.4-67.5-214.6-158.2-7.6-23-12-47.6-12-72.9s4.4-49.9 12-72.9c30.3-90.6 114.8-158.1 214.7-158.1 56.3 0 106.8 19.4 146.6 57.4l110-110.1c-66.5-62-153.2-100-256.6-100-149.9 0-279.6 86-342.7 211.4-26 51.8-40.8 110.4-40.8 172.4S151 632.8 177 684.6C240.1 810 369.8 896 519.7 896c103.6 0 190.4-34.4 253.8-93 72.5-66.8 114.4-165.2 114.4-282.1 0-27.2-2.4-53.3-6.9-78.5z'));
exports.HeatMapOutline = getIcon('heat-map', outline, getNode(newViewBox, 'M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-790.4-23.9L512 231.9 858.7 832H165.3zm319-474.1l-228 394c-12.3 21.3 3.1 48 27.7 48h455.8c24.7 0 40.1-26.7 27.7-48L539.7 358c-6.2-10.7-17-16-27.7-16-10.8 0-21.6 5.3-27.7 16zm214 386H325.7L512 422l186.3 322zm-214-194.1l-57 98.4C415 669.5 430.4 696 455 696h114c24.6 0 39.9-26.5 27.7-47.7l-57-98.4c-6.1-10.6-16.9-15.9-27.7-15.9s-21.5 5.3-27.7 15.9zm57.1 98.4h-58.7l29.4-50.7 29.3 50.7z'));
exports.GoldOutline = getIcon('gold', outline, getNode(newViewBox, 'M342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128zm2.5 282.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5z'));
exports.HistoryOutline = getIcon('history', outline, getNode(newViewBox, 'M536.1 273H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.3 120.7c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.7-3.7 1.9-8.7-1.7-11.2L544.1 528.5V281c0-4.4-3.6-8-8-8zm219.8 75.2l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3L752.9 334.1a8 8 0 0 0 3 14.1zm167.7 301.1l-56.7-19.5a8 8 0 0 0-10.1 4.8c-1.9 5.1-3.9 10.1-6 15.1-17.8 42.1-43.3 80-75.9 112.5a353 353 0 0 1-112.5 75.9 352.18 352.18 0 0 1-137.7 27.8c-47.8 0-94.1-9.3-137.7-27.8a353 353 0 0 1-112.5-75.9c-32.5-32.5-58-70.4-75.9-112.5A353.44 353.44 0 0 1 171 512c0-47.8 9.3-94.2 27.8-137.8 17.8-42.1 43.3-80 75.9-112.5a353 353 0 0 1 112.5-75.9C430.6 167.3 477 158 524.8 158s94.1 9.3 137.7 27.8A353 353 0 0 1 775 261.7c10.2 10.3 19.8 21 28.6 32.3l59.8-46.8C784.7 146.6 662.2 81.9 524.6 82 285 82.1 92.6 276.7 95 516.4 97.4 751.9 288.9 942 524.8 942c185.5 0 343.5-117.6 403.7-282.3 1.5-4.2-.7-8.9-4.9-10.4z'));
exports.IeOutline = getIcon('ie', outline, getNode(newViewBox, 'M852.6 367.6c16.3-36.9 32.1-90.7 32.1-131.8 0-109.1-119.5-147.6-314.5-57.9-161.4-10.8-316.8 110.5-355.6 279.7 46.3-52.3 117.4-123.4 183-151.7C316.1 378.3 246.7 470 194 565.6c-31.1 56.9-66 148.8-66 217.5 0 147.9 139.3 129.8 270.4 63 47.1 23.1 99.8 23.4 152.5 23.4 145.7 0 276.4-81.4 325.2-219H694.9c-78.8 132.9-295.2 79.5-295.2-71.2h493.2c9.6-65.4-2.5-143.6-40.3-211.7zM224.8 648.3c26.6 76.7 80.6 143.8 150.4 185-133.1 73.4-259.9 43.6-150.4-185zm174-163.3c3-82.7 75.4-142.3 156-142.3 80.1 0 153 59.6 156 142.3h-312zm276.8-281.4c32.1-15.4 72.8-33 108.8-33 47.1 0 81.4 32.6 81.4 80.6 0 30-11.1 73.5-21.9 101.8-39.3-63.5-98.9-122.4-168.3-149.4z'));
exports.InboxOutline = getIcon('inbox', outline, getNode(normalViewBox, 'M885.2 446.3l-.2-.8-112.2-285.1c-5-16.1-19.9-27.2-36.8-27.2H281.2c-17 0-32.1 11.3-36.9 27.6L139.4 443l-.3.7-.2.8c-1.3 4.9-1.7 9.9-1 14.8-.1 1.6-.2 3.2-.2 4.8V830a60.9 60.9 0 0 0 60.8 60.8h627.2c33.5 0 60.8-27.3 60.9-60.8V464.1c0-1.3 0-2.6-.1-3.7.4-4.9 0-9.6-1.3-14.1zm-295.8-43l-.3 15.7c-.8 44.9-31.8 75.1-77.1 75.1-22.1 0-41.1-7.1-54.8-20.6S436 441.2 435.6 419l-.3-15.7H229.5L309 210h399.2l81.7 193.3H589.4zm-375 76.8h157.3c24.3 57.1 76 90.8 140.4 90.8 33.7 0 65-9.4 90.3-27.2 22.2-15.6 39.5-37.4 50.7-63.6h156.5V814H214.4V480.1z'));
exports.ImportOutline = getIcon('import', outline, getNode(newViewBox, 'M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7zM902 476H588v-76c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 0 0 0 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-76h314c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.InfoOutline = getIcon('info', outline, getNode(newViewBox, 'M448 224a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm96 168h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V400c0-4.4-3.6-8-8-8z'));
exports.ItalicOutline = getIcon('italic', outline, getNode(newViewBox, 'M798 160H366c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h181.2l-156 544H229c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8H474.4l156-544H798c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z'));
exports.IssuesCloseOutline = getIcon('issues-close', outline, getNode(newViewBox, 'M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72-112c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48zm400-188h-59.3c-2.6 0-5 1.2-6.5 3.3L763.7 538.1l-49.9-68.8a7.92 7.92 0 0 0-6.5-3.3H648c-6.5 0-10.3 7.4-6.5 12.7l109.2 150.7a16.1 16.1 0 0 0 26 0l165.8-228.7c3.8-5.3 0-12.7-6.5-12.7zm-44 306h-64.2c-5.5 0-10.6 2.9-13.6 7.5a352.2 352.2 0 0 1-49.8 62.2A355.92 355.92 0 0 1 651.1 840a355 355 0 0 1-138.7 27.9c-48.1 0-94.8-9.4-138.7-27.9a355.92 355.92 0 0 1-113.3-76.3A353.06 353.06 0 0 1 184 650.5c-18.6-43.8-28-90.5-28-138.5s9.4-94.7 28-138.5c17.9-42.4 43.6-80.5 76.4-113.2 32.8-32.7 70.9-58.4 113.3-76.3a355 355 0 0 1 138.7-27.9c48.1 0 94.8 9.4 138.7 27.9 42.4 17.9 80.5 43.6 113.3 76.3 19 19 35.6 39.8 49.8 62.2 2.9 4.7 8.1 7.5 13.6 7.5H892c6 0 9.8-6.3 7.2-11.6C828.8 178.5 684.7 82 517.7 80 278.9 77.2 80.5 272.5 80 511.2 79.5 750.1 273.3 944 512.4 944c169.2 0 315.6-97 386.7-238.4A8 8 0 0 0 892 694z'));
exports.KeyOutline = getIcon('key', outline, getNode(newViewBox, 'M608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5l-41.1 41.1-62.3-62.3a8.15 8.15 0 0 0-11.4 0l-39.8 39.8a8.15 8.15 0 0 0 0 11.4l62.3 62.3-44.9 44.9-62.3-62.3a8.15 8.15 0 0 0-11.4 0l-39.8 39.8a8.15 8.15 0 0 0 0 11.4l62.3 62.3-65.3 65.3a8.03 8.03 0 0 0 0 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6A304.06 304.06 0 0 0 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644c-60.9 0-118.2-23.7-161.2-66.8-43.1-43-66.8-100.3-66.8-161.2 0-60.9 23.7-118.2 66.8-161.2 43-43.1 100.3-66.8 161.2-66.8 60.9 0 118.2 23.7 161.2 66.8 43.1 43 66.8 100.3 66.8 161.2 0 60.9-23.7 118.2-66.8 161.2z'));
exports.LaptopOutline = getIcon('laptop', outline, getNode(newViewBox, 'M956.9 845.1L896.4 632V168c0-17.7-14.3-32-32-32h-704c-17.7 0-32 14.3-32 32v464L67.9 845.1C60.4 866 75.8 888 98 888h828.8c22.2 0 37.6-22 30.1-42.9zM200.4 208h624v395h-624V208zm228.3 608l8.1-37h150.3l8.1 37H428.7zm224 0l-19.1-86.7c-.8-3.7-4.1-6.3-7.8-6.3H398.2c-3.8 0-7 2.6-7.8 6.3L371.3 816H151l42.3-149h638.2l42.3 149H652.7z'));
exports.LeftOutline = getIcon('left', outline, getNode(newViewBox, 'M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 0 0 0 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z'));
exports.LinkOutline = getIcon('link', outline, getNode(newViewBox, 'M574 665.4a8.03 8.03 0 0 0-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 0 0-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 0 0 0 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 0 0 0 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 0 0-11.3 0L372.3 598.7a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z'));
exports.LineChartOutline = getIcon('line-chart', outline, getNode(newViewBox, 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM305.8 637.7c3.1 3.1 8.1 3.1 11.3 0l138.3-137.6L583 628.5c3.1 3.1 8.2 3.1 11.3 0l275.4-275.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-230 229.9L461.4 404a8.03 8.03 0 0 0-11.3 0L266.3 586.7a8.03 8.03 0 0 0 0 11.3l39.5 39.7z'));
exports.LineHeightOutline = getIcon('line-height', outline, getNode(newViewBox, 'M648 160H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm272.8 546H856V318h64.8c6 0 9.4-7 5.7-11.7L825.7 178.7a7.14 7.14 0 0 0-11.3 0L713.6 306.3a7.23 7.23 0 0 0 5.7 11.7H784v388h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5a7.2 7.2 0 0 0-5.6-11.7z'));
exports.LineOutline = getIcon('line', outline, getNode(newViewBox, 'M904 476H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.Loading3QuartersOutline = getIcon('loading-3-quarters', outline, getNode(normalViewBox, 'M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z'));
exports.LoadingOutline = getIcon('loading', outline, getNode(normalViewBox, 'M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z'));
exports.LoginOutline = getIcon('login', outline, getNode(newViewBox, 'M521.7 82c-152.5-.4-286.7 78.5-363.4 197.7-3.4 5.3.4 12.3 6.7 12.3h70.3c4.8 0 9.3-2.1 12.3-5.8 7-8.5 14.5-16.7 22.4-24.5 32.6-32.5 70.5-58.1 112.7-75.9 43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 32.6 32.5 58.1 70.4 76 112.5C865.7 417.8 875 464.1 875 512c0 47.9-9.4 94.2-27.8 137.8-17.8 42.1-43.4 80-76 112.5s-70.5 58.1-112.7 75.9A352.8 352.8 0 0 1 520.6 866c-47.9 0-94.3-9.4-137.9-27.8A353.84 353.84 0 0 1 270 762.3c-7.9-7.9-15.3-16.1-22.4-24.5-3-3.7-7.6-5.8-12.3-5.8H165c-6.3 0-10.2 7-6.7 12.3C234.9 863.2 368.5 942 520.6 942c236.2 0 428-190.1 430.4-425.6C953.4 277.1 761.3 82.6 521.7 82zM395.02 624v-76h-314c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h314v-76c0-6.7 7.8-10.5 13-6.3l141.9 112a8 8 0 0 1 0 12.6l-141.9 112c-5.2 4.1-13 .4-13-6.3z'));
exports.LogoutOutline = getIcon('logout', outline, getNode(newViewBox, 'M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8-7 8.5-14.5 16.7-22.4 24.5a353.84 353.84 0 0 1-112.7 75.9A352.8 352.8 0 0 1 512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.84 353.84 0 0 1-112.7-75.9 353.28 353.28 0 0 1-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 7.9 7.9 15.3 16.1 22.4 24.5 3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82 271.7 82.6 79.6 277.1 82 516.4 84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7 3.4-5.3-.4-12.3-6.7-12.3zm88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6z'));
exports.ManOutline = getIcon('man', outline, getNode(newViewBox, 'M874 120H622c-3.3 0-6 2.7-6 6v56c0 3.3 2.7 6 6 6h160.4L583.1 387.3c-50-38.5-111-59.3-175.1-59.3-76.9 0-149.3 30-203.6 84.4S120 539.1 120 616s30 149.3 84.4 203.6C258.7 874 331.1 904 408 904s149.3-30 203.6-84.4C666 765.3 696 692.9 696 616c0-64.1-20.8-124.9-59.2-174.9L836 241.9V402c0 3.3 2.7 6 6 6h56c3.3 0 6-2.7 6-6V150c0-16.5-13.5-30-30-30zM408 828c-116.9 0-212-95.1-212-212s95.1-212 212-212 212 95.1 212 212-95.1 212-212 212z'));
exports.MediumOutline = getIcon('medium', outline, getNode(newViewBox, 'M834.7 279.8l61.3-58.9V208H683.7L532.4 586.4 360.3 208H137.7v12.9l71.6 86.6c7 6.4 10.6 15.8 9.7 25.2V673c2.2 12.3-1.7 24.8-10.3 33.7L128 805v12.7h228.6v-12.9l-80.6-98a39.99 39.99 0 0 1-11.1-33.7V378.7l200.7 439.2h23.3l172.6-439.2v349.9c0 9.2 0 11.1-6 17.2l-62.1 60.3V819h301.2v-12.9l-59.9-58.9c-5.2-4-7.9-10.7-6.8-17.2V297a18.1 18.1 0 0 1 6.8-17.2z'));
exports.MediumWorkmarkOutline = getIcon('medium-workmark', outline, getNode(normalViewBox, 'M517.2 590.55c0 3.55 0 4.36 2.4 6.55l13.43 13.25v.57h-59.57v-25.47a41.44 41.44 0 0 1-39.5 27.65c-30.61 0-52.84-24.25-52.84-68.87 0-41.8 23.99-69.69 57.65-69.69a35.15 35.15 0 0 1 34.61 21.67v-56.19a6.99 6.99 0 0 0-2.71-6.79l-12.8-12.45v-.56l59.33-7.04v177.37zm-43.74-8.09v-83.83a22.2 22.2 0 0 0-17.74-8.4c-14.48 0-28.47 13.25-28.47 52.62 0 36.86 12.07 49.88 27.1 49.88a23.91 23.91 0 0 0 19.11-10.27zm83.23 28.46V497.74a7.65 7.65 0 0 0-2.4-6.79l-13.19-13.74v-.57h59.56v114.8c0 3.55 0 4.36 2.4 6.54l13.12 12.45v.57l-59.49-.08zm-2.16-175.67c0-13.4 10.74-24.25 23.99-24.25 13.25 0 23.98 10.86 23.98 24.25 0 13.4-10.73 24.25-23.98 24.25s-23.99-10.85-23.99-24.25zm206.83 155.06c0 3.55 0 4.6 2.4 6.79l13.43 13.25v.57h-59.88V581.9a43.4 43.4 0 0 1-41.01 31.2c-26.55 0-40.78-19.56-40.78-56.59 0-17.86 0-37.43.56-59.41a6.91 6.91 0 0 0-2.4-6.55L620.5 477.2v-.57h59.09v73.81c0 24.25 3.51 40.42 18.54 40.42a23.96 23.96 0 0 0 19.35-12.2v-80.85a7.65 7.65 0 0 0-2.4-6.79l-13.27-13.82v-.57h59.56V590.3zm202.76 20.6c0-4.36.8-59.97.8-72.75 0-24.25-3.76-40.98-20.63-40.98a26.7 26.7 0 0 0-21.19 11.64 99.68 99.68 0 0 1 2.4 23.04c0 16.81-.56 38.23-.8 59.66a6.91 6.91 0 0 0 2.4 6.55l13.43 12.45v.56h-60.12c0-4.04.8-59.98.8-72.76 0-24.65-3.76-40.98-20.39-40.98-8.2.3-15.68 4.8-19.83 11.96v82.46c0 3.56 0 4.37 2.4 6.55l13.11 12.45v.56h-59.48V498.15a7.65 7.65 0 0 0-2.4-6.8l-13.19-14.14v-.57H841v28.78c5.53-19 23.13-31.76 42.7-30.96 19.82 0 33.26 11.16 38.93 32.34a46.41 46.41 0 0 1 44.77-32.34c26.55 0 41.58 19.8 41.58 57.23 0 17.87-.56 38.24-.8 59.66a6.5 6.5 0 0 0 2.72 6.55l13.11 12.45v.57h-59.88zM215.87 593.3l17.66 17.05v.57h-89.62v-.57l17.99-17.05a6.91 6.91 0 0 0 2.4-6.55V477.69c0-4.6 0-10.83.8-16.16L104.66 613.1h-.72l-62.6-139.45c-1.37-3.47-1.77-3.72-2.65-6.06v91.43a32.08 32.08 0 0 0 2.96 17.87l25.19 33.46v.57H0v-.57l25.18-33.55a32.16 32.16 0 0 0 2.96-17.78V457.97A19.71 19.71 0 0 0 24 444.15L6.16 420.78v-.56h63.96l53.56 118.1 47.17-118.1h62.6v.56l-17.58 19.8a6.99 6.99 0 0 0-2.72 6.8v139.37a6.5 6.5 0 0 0 2.72 6.55zm70.11-54.65v.56c0 34.6 17.67 48.5 38.38 48.5a43.5 43.5 0 0 0 40.77-24.97h.56c-7.2 34.2-28.14 50.36-59.48 50.36-33.82 0-65.72-20.61-65.72-68.39 0-50.2 31.98-70.25 67.32-70.25 28.46 0 58.76 13.58 58.76 57.24v6.95h-80.59zm0-6.95h39.42v-7.04c0-35.57-7.28-45.03-18.23-45.03-13.27 0-21.35 14.15-21.35 52.07h.16z'));
exports.MenuUnfoldOutline = getIcon('menu-unfold', outline, getNode(newViewBox, 'M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z'));
exports.MenuFoldOutline = getIcon('menu-fold', outline, getNode(newViewBox, 'M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM115.4 518.9L271.7 642c5.8 4.6 14.4.5 14.4-6.9V388.9c0-7.4-8.5-11.5-14.4-6.9L115.4 505.1a8.74 8.74 0 0 0 0 13.8z'));
exports.MenuOutline = getIcon('menu', outline, getNode(newViewBox, 'M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z'));
exports.MinusOutline = getIcon('minus', outline, getNode(newViewBox, 'M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
exports.MonitorOutline = getIcon('monitor', outline, getNode(newViewBox, 'M692.8 412.7l.2-.2-34.6-44.3a7.97 7.97 0 0 0-11.2-1.4l-50.4 39.3-70.5-90.1a7.97 7.97 0 0 0-11.2-1.4l-37.9 29.7a7.97 7.97 0 0 0-1.4 11.2l70.5 90.2-.2.1 34.6 44.3c2.7 3.5 7.7 4.1 11.2 1.4l50.4-39.3 64.1 82c2.7 3.5 7.7 4.1 11.2 1.4l37.9-29.6c3.5-2.7 4.1-7.7 1.4-11.2l-64.1-82.1zM608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5L114.3 856.1a8.03 8.03 0 0 0 0 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6C473 696.1 537.7 720 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644s-118.2-23.7-161.2-66.8C403.7 534.2 380 476.9 380 416s23.7-118.2 66.8-161.2c43-43.1 100.3-66.8 161.2-66.8s118.2 23.7 161.2 66.8c43.1 43 66.8 100.3 66.8 161.2s-23.7 118.2-66.8 161.2z'));
exports.MoreOutline = getIcon('more', outline, getNode(newViewBox, 'M456 231a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 280a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 280a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
exports.OrderedListOutline = getIcon('ordered-list', outline, getNode(newViewBox, 'M920 760H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-568H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM216 712H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h72.4v20.5h-35.7c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h35.7V838H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4V716c0-2.2-1.8-4-4-4zM100 188h38v120c0 2.2 1.8 4 4 4h40c2.2 0 4-1.8 4-4V152c0-4.4-3.6-8-8-8h-78c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4zm116 240H100c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4h68.4l-70.3 77.7a8.3 8.3 0 0 0-2.1 5.4V592c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4v-36c0-2.2-1.8-4-4-4h-68.4l70.3-77.7a8.3 8.3 0 0 0 2.1-5.4V432c0-2.2-1.8-4-4-4z'));
exports.NumberOutline = getIcon('number', outline, getNode(newViewBox, 'M872 394c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H400V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v236H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h228v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h164c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V394h164zM628 630H400V394h228v236z'));
exports.PauseOutline = getIcon('pause', outline, getNode(newViewBox, 'M304 176h80v672h-80zm408 0h-64c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8z'));
exports.PercentageOutline = getIcon('percentage', outline, getNode(newViewBox, 'M855.7 210.8l-42.4-42.4a8.03 8.03 0 0 0-11.3 0L168.3 801.9a8.03 8.03 0 0 0 0 11.3l42.4 42.4c3.1 3.1 8.2 3.1 11.3 0L855.6 222c3.2-3 3.2-8.1.1-11.2zM304 448c79.4 0 144-64.6 144-144s-64.6-144-144-144-144 64.6-144 144 64.6 144 144 144zm0-216c39.7 0 72 32.3 72 72s-32.3 72-72 72-72-32.3-72-72 32.3-72 72-72zm416 344c-79.4 0-144 64.6-144 144s64.6 144 144 144 144-64.6 144-144-64.6-144-144-144zm0 216c-39.7 0-72-32.3-72-72s32.3-72 72-72 72 32.3 72 72-32.3 72-72 72z'));
exports.PaperClipOutline = getIcon('paper-clip', outline, getNode(newViewBox, 'M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 0 0 174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z'));
exports.PicCenterOutline = getIcon('pic-center', outline, getNode(newViewBox, 'M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM848 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h672zM232 436h560v152H232V436z'));
exports.PicLeftOutline = getIcon('pic-left', outline, getNode(newViewBox, 'M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM608 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM152 436h400v152H152V436zm552 210c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
exports.PlusOutline = getIcon('plus', outline, getNode(newViewBox, 'M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z', 'M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z'));
exports.PicRightOutline = getIcon('pic-right', outline, getNode(newViewBox, 'M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-24 500c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM472 436h400v152H472V436zM80 646c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
exports.PoundOutline = getIcon('pound', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm138-209.8H469.8v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.9-5.3-41H607c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8H495c-7.2-22.6-13.4-45.7-13.4-70.5 0-43.5 34-70.2 87.3-70.2 21.5 0 42.5 4.1 60.4 10.5 5.2 1.9 10.6-2 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.8-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.3 6.9 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.1c3.4 14.7 5.9 29.4 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8V722c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z'));
exports.PoweroffOutline = getIcon('poweroff', outline, getNode(newViewBox, 'M705.6 124.9a8 8 0 0 0-11.6 7.2v64.2c0 5.5 2.9 10.6 7.5 13.6a352.2 352.2 0 0 1 62.2 49.8c32.7 32.8 58.4 70.9 76.3 113.3a355 355 0 0 1 27.9 138.7c0 48.1-9.4 94.8-27.9 138.7a355.92 355.92 0 0 1-76.3 113.3 353.06 353.06 0 0 1-113.2 76.4c-43.8 18.6-90.5 28-138.5 28s-94.7-9.4-138.5-28a353.06 353.06 0 0 1-113.2-76.4A355.92 355.92 0 0 1 184 650.4a355 355 0 0 1-27.9-138.7c0-48.1 9.4-94.8 27.9-138.7 17.9-42.4 43.6-80.5 76.3-113.3 19-19 39.8-35.6 62.2-49.8 4.7-2.9 7.5-8.1 7.5-13.6V132c0-6-6.3-9.8-11.6-7.2C178.5 195.2 82 339.3 80 506.3 77.2 745.1 272.5 943.5 511.2 944c239 .5 432.8-193.3 432.8-432.4 0-169.2-97-315.7-238.4-386.7zM480 560h64c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z'));
exports.PullRequestOutline = getIcon('pull-request', outline, getNode(newViewBox, 'M788 705.9V192c0-8.8-7.2-16-16-16H602v-68.8c0-6-7-9.4-11.7-5.7L462.7 202.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V240h114v465.9c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c.1-49.2-31.7-91-75.9-106.1zM752 860a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zM384 212c0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1V318.1c44.2-15.1 76-56.9 76-106.1zm-160 0a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm96 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0z'));
exports.QqOutline = getIcon('qq', outline, getNode(newViewBox, 'M824.8 613.2c-16-51.4-34.4-94.6-62.7-165.3C766.5 262.2 689.3 112 511.5 112 331.7 112 256.2 265.2 261 447.9c-28.4 70.8-46.7 113.7-62.7 165.3-34 109.5-23 154.8-14.6 155.8 18 2.2 70.1-82.4 70.1-82.4 0 49 25.2 112.9 79.8 159-26.4 8.1-85.7 29.9-71.6 53.8 11.4 19.3 196.2 12.3 249.5 6.3 53.3 6 238.1 13 249.5-6.3 14.1-23.8-45.3-45.7-71.6-53.8 54.6-46.2 79.8-110.1 79.8-159 0 0 52.1 84.6 70.1 82.4 8.5-1.1 19.5-46.4-14.5-155.8z'));
exports.QuestionOutline = getIcon('question', outline, getNode(newViewBox, 'M764 280.9c-14-30.6-33.9-58.1-59.3-81.6C653.1 151.4 584.6 125 512 125s-141.1 26.4-192.7 74.2c-25.4 23.6-45.3 51-59.3 81.7-14.6 32-22 65.9-22 100.9v27c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-27c0-99.5 88.6-180.4 197.6-180.4s197.6 80.9 197.6 180.4c0 40.8-14.5 79.2-42 111.2-27.2 31.7-65.6 54.4-108.1 64-24.3 5.5-46.2 19.2-61.7 38.8a110.85 110.85 0 0 0-23.9 68.6v31.4c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-31.4c0-15.7 10.9-29.5 26-32.9 58.4-13.2 111.4-44.7 149.3-88.7 19.1-22.3 34-47.1 44.3-74 10.7-27.9 16.1-57.2 16.1-87 0-35-7.4-69-22-100.9zM512 787c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56-25.1-56-56-56z'));
exports.RadarChartOutline = getIcon('radar-chart', outline, getNode(newViewBox, 'M926.8 397.1l-396-288a31.81 31.81 0 0 0-37.6 0l-396 288a31.99 31.99 0 0 0-11.6 35.8l151.3 466a32 32 0 0 0 30.4 22.1h489.5c13.9 0 26.1-8.9 30.4-22.1l151.3-466c4.2-13.2-.5-27.6-11.7-35.8zM838.6 417l-98.5 32-200-144.7V199.9L838.6 417zM466 567.2l-89.1 122.3-55.2-169.2L466 567.2zm-116.3-96.8L484 373.3v140.8l-134.3-43.7zM512 599.2l93.9 128.9H418.1L512 599.2zm28.1-225.9l134.2 97.1L540.1 514V373.3zM558 567.2l144.3-46.9-55.2 169.2L558 567.2zm-74-367.3v104.4L283.9 449l-98.5-32L484 199.9zM169.3 470.8l86.5 28.1 80.4 246.4-53.8 73.9-113.1-348.4zM327.1 853l50.3-69h269.3l50.3 69H327.1zm414.5-33.8l-53.8-73.9 80.4-246.4 86.5-28.1-113.1 348.4z'));
exports.QrcodeOutline = getIcon('qrcode', outline, getNode(newViewBox, 'M468 128H160c-17.7 0-32 14.3-32 32v308c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8zm-56 284H192V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210H136c-4.4 0-8 3.6-8 8v308c0 17.7 14.3 32 32 32h308c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zm-56 284H192V612h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm590-630H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V160c0-17.7-14.3-32-32-32zm-32 284H612V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210h-48c-4.4 0-8 3.6-8 8v134h-78V556c0-4.4-3.6-8-8-8H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h78v102c0 4.4 3.6 8 8 8h190c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zM746 832h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm142 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
exports.RadiusBottomleftOutline = getIcon('radius-bottomleft', outline, getNode(newViewBox, 'M712 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm2-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM136 374h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-174h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm752 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-230 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 624H358c-87.3 0-158-70.7-158-158V484c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v182c0 127 103 230 230 230h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.RadiusBottomrightOutline = getIcon('radius-bottomright', outline, getNode(newViewBox, 'M368 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-58-624h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm578 102h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm292 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm174 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 276h-56c-4.4 0-8 3.6-8 8v182c0 87.3-70.7 158-158 158H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c127 0 230-103 230-230V484c0-4.4-3.6-8-8-8z'));
exports.RadiusUpleftOutline = getIcon('radius-upleft', outline, getNode(newViewBox, 'M656 200h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm58 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 650h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm696-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174-696H358c-127 0-230 103-230 230v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-87.3 70.7-158 158-158h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.RadiusUprightOutline = getIcon('radius-upright', outline, getNode(newViewBox, 'M368 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-2 696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm522-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-48-696H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c87.3 0 158 70.7 158 158v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-127-103-230-230-230z'));
exports.RadiusSettingOutline = getIcon('radius-setting', outline, getNode(newViewBox, 'M396 140h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-44 684h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm524-204h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 344h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm320 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm160 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm140-284c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V370c0-127-103-230-230-230H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h170c87.3 0 158 70.7 158 158v170zM236 96H92c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2zM920 780H776c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V788c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2z'));
exports.RedditOutline = getIcon('reddit', outline, getNode(newViewBox, 'M288 568a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm338.7 119.7c-23.1 18.2-68.9 37.8-114.7 37.8s-91.6-19.6-114.7-37.8c-14.4-11.3-35.3-8.9-46.7 5.5s-8.9 35.3 5.5 46.7C396.3 771.6 457.5 792 512 792s115.7-20.4 155.9-52.1a33.25 33.25 0 1 0-41.2-52.2zM960 456c0-61.9-50.1-112-112-112-42.1 0-78.7 23.2-97.9 57.6-57.6-31.5-127.7-51.8-204.1-56.5L612.9 195l127.9 36.9c11.5 32.6 42.6 56.1 79.2 56.1 46.4 0 84-37.6 84-84s-37.6-84-84-84c-32 0-59.8 17.9-74 44.2L603.5 123a33.2 33.2 0 0 0-39.6 18.4l-90.8 203.9c-74.5 5.2-142.9 25.4-199.2 56.2A111.94 111.94 0 0 0 176 344c-61.9 0-112 50.1-112 112 0 45.8 27.5 85.1 66.8 102.5-7.1 21-10.8 43-10.8 65.5 0 154.6 175.5 280 392 280s392-125.4 392-280c0-22.6-3.8-44.5-10.8-65.5C932.5 541.1 960 501.8 960 456zM820 172.5a31.5 31.5 0 1 1 0 63 31.5 31.5 0 0 1 0-63zM120 456c0-30.9 25.1-56 56-56a56 56 0 0 1 50.6 32.1c-29.3 22.2-53.5 47.8-71.5 75.9a56.23 56.23 0 0 1-35.1-52zm392 381.5c-179.8 0-325.5-95.6-325.5-213.5S332.2 410.5 512 410.5 837.5 506.1 837.5 624 691.8 837.5 512 837.5zM868.8 508c-17.9-28.1-42.2-53.7-71.5-75.9 9-18.9 28.3-32.1 50.6-32.1 30.9 0 56 25.1 56 56 .1 23.5-14.5 43.7-35.1 52zM624 568a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
exports.RedoOutline = getIcon('redo', outline, getNode(newViewBox, 'M758.2 839.1C851.8 765.9 912 651.9 912 523.9 912 303 733.5 124.3 512.6 124 291.4 123.7 112 302.8 112 523.9c0 125.2 57.5 236.9 147.6 310.2 3.5 2.8 8.6 2.2 11.4-1.3l39.4-50.5c2.7-3.4 2.1-8.3-1.2-11.1-8.1-6.6-15.9-13.7-23.4-21.2a318.64 318.64 0 0 1-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 0 1-68.6 101.7c-9.3 9.3-19.1 18-29.3 26L668.2 724a8 8 0 0 0-14.1 3l-39.6 162.2c-1.2 5 2.6 9.9 7.7 9.9l167 .8c6.7 0 10.5-7.7 6.3-12.9l-37.3-47.9z'));
exports.ReloadOutline = getIcon('reload', outline, getNode(newViewBox, 'M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 0 0-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 0 1 655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 0 1 279 755.2a342.16 342.16 0 0 1-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 0 1 109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z'));
exports.RetweetOutline = getIcon('retweet', outline, getNode(normalViewBox, 'M136 552h63.6c4.4 0 8-3.6 8-8V288.7h528.6v72.6c0 1.9.6 3.7 1.8 5.2a8.3 8.3 0 0 0 11.7 1.4L893 255.4c4.3-5 3.6-10.3 0-13.2L749.7 129.8a8.22 8.22 0 0 0-5.2-1.8c-4.6 0-8.4 3.8-8.4 8.4V209H199.7c-39.5 0-71.7 32.2-71.7 71.8V544c0 4.4 3.6 8 8 8zm752-80h-63.6c-4.4 0-8 3.6-8 8v255.3H287.8v-72.6c0-1.9-.6-3.7-1.8-5.2a8.3 8.3 0 0 0-11.7-1.4L131 768.6c-4.3 5-3.6 10.3 0 13.2l143.3 112.4c1.5 1.2 3.3 1.8 5.2 1.8 4.6 0 8.4-3.8 8.4-8.4V815h536.6c39.5 0 71.7-32.2 71.7-71.8V480c-.2-4.4-3.8-8-8.2-8z'));
exports.RightOutline = getIcon('right', outline, getNode(newViewBox, 'M765.7 486.8L314.9 134.7A7.97 7.97 0 0 0 302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 0 0 0-50.4z'));
exports.RiseOutline = getIcon('rise', outline, getNode(newViewBox, 'M917 211.1l-199.2 24c-6.6.8-9.4 8.9-4.7 13.6l59.3 59.3-226 226-101.8-101.7c-6.3-6.3-16.4-6.2-22.6 0L100.3 754.1a8.03 8.03 0 0 0 0 11.3l45 45.2c3.1 3.1 8.2 3.1 11.3 0L433.3 534 535 635.7c6.3 6.2 16.4 6.2 22.6 0L829 364.5l59.3 59.3a8.01 8.01 0 0 0 13.6-4.7l24-199.2c.7-5.1-3.7-9.5-8.9-8.8z'));
exports.RollbackOutline = getIcon('rollback', outline, getNode(newViewBox, 'M793 242H366v-74c0-6.7-7.7-10.4-12.9-6.3l-142 112a8 8 0 0 0 0 12.6l142 112c5.2 4.1 12.9.4 12.9-6.3v-74h415v470H175c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h618c35.3 0 64-28.7 64-64V306c0-35.3-28.7-64-64-64z'));
exports.SafetyOutline = getIcon('safety', outline, getNode(normalViewBox, 'M512 64L128 192v384c0 212.1 171.9 384 384 384s384-171.9 384-384V192L512 64zm312 512c0 172.3-139.7 312-312 312S200 748.3 200 576V246l312-110 312 110v330z', 'M378.4 475.1a35.91 35.91 0 0 0-50.9 0 35.91 35.91 0 0 0 0 50.9l129.4 129.4 2.1 2.1a33.98 33.98 0 0 0 48.1 0L730.6 434a33.98 33.98 0 0 0 0-48.1l-2.8-2.8a33.98 33.98 0 0 0-48.1 0L483 579.7 378.4 475.1z'));
exports.RobotOutline = getIcon('robot', outline, getNode(newViewBox, 'M300 328a60 60 0 1 0 120 0 60 60 0 1 0-120 0zM852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-32 660H204V128h616v596zM604 328a60 60 0 1 0 120 0 60 60 0 1 0-120 0zm250.2 556H169.8c-16.5 0-29.8 14.3-29.8 32v36c0 4.4 3.3 8 7.4 8h729.1c4.1 0 7.4-3.6 7.4-8v-36c.1-17.7-13.2-32-29.7-32zM664 508H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
exports.SearchOutline = getIcon('search', outline, getNode(newViewBox, 'M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z'));
exports.ScanOutline = getIcon('scan', outline, getNode(newViewBox, 'M136 384h56c4.4 0 8-3.6 8-8V200h176c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-37.6 0-68 30.4-68 68v180c0 4.4 3.6 8 8 8zm512-184h176v176c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V196c0-37.6-30.4-68-68-68H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM376 824H200V648c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v180c0 37.6 30.4 68 68 68h180c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm512-184h-56c-4.4 0-8 3.6-8 8v176H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h180c37.6 0 68-30.4 68-68V648c0-4.4-3.6-8-8-8zm16-164H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.ScissorOutline = getIcon('scissor', outline, getNode(newViewBox, 'M567.1 512l318.5-319.3c5-5 1.5-13.7-5.6-13.7h-90.5c-2.1 0-4.2.8-5.6 2.3l-273.3 274-90.2-90.5c12.5-22.1 19.7-47.6 19.7-74.8 0-83.9-68.1-152-152-152s-152 68.1-152 152 68.1 152 152 152c27.7 0 53.6-7.4 75.9-20.3l90 90.3-90.1 90.3A151.04 151.04 0 0 0 288 582c-83.9 0-152 68.1-152 152s68.1 152 152 152 152-68.1 152-152c0-27.2-7.2-52.7-19.7-74.8l90.2-90.5 273.3 274c1.5 1.5 3.5 2.3 5.6 2.3H880c7.1 0 10.7-8.6 5.6-13.7L567.1 512zM288 370c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm0 444c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z'));
exports.SelectOutline = getIcon('select', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h360c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H184V184h656v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM653.3 599.4l52.2-52.2a8.01 8.01 0 0 0-4.7-13.6l-179.4-21c-5.1-.6-9.5 3.7-8.9 8.9l21 179.4c.8 6.6 8.9 9.4 13.6 4.7l52.4-52.4 256.2 256.2c3.1 3.1 8.2 3.1 11.3 0l42.4-42.4c3.1-3.1 3.1-8.2 0-11.3L653.3 599.4z'));
exports.ShakeOutline = getIcon('shake', outline, getNode(newViewBox, 'M324 666a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm616.7-309.6L667.6 83.2C655.2 70.9 638.7 64 621.1 64s-34.1 6.8-46.5 19.2L83.3 574.5a65.85 65.85 0 0 0 0 93.1l273.2 273.2c12.3 12.3 28.9 19.2 46.5 19.2s34.1-6.8 46.5-19.2l491.3-491.3c25.6-25.7 25.6-67.5-.1-93.1zM403 880.1L143.9 621l477.2-477.2 259 259.2L403 880.1zM152.8 373.7a7.9 7.9 0 0 0 11.2 0L373.7 164a7.9 7.9 0 0 0 0-11.2l-38.4-38.4a7.9 7.9 0 0 0-11.2 0L114.3 323.9a7.9 7.9 0 0 0 0 11.2l38.5 38.6zm718.6 276.6a7.9 7.9 0 0 0-11.2 0L650.3 860.1a7.9 7.9 0 0 0 0 11.2l38.4 38.4a7.9 7.9 0 0 0 11.2 0L909.7 700a7.9 7.9 0 0 0 0-11.2l-38.3-38.5z'));
exports.ShareAltOutline = getIcon('share-alt', outline, getNode(newViewBox, 'M752 664c-28.5 0-54.8 10-75.4 26.7L469.4 540.8a160.68 160.68 0 0 0 0-57.6l207.2-149.9C697.2 350 723.5 360 752 360c66.2 0 120-53.8 120-120s-53.8-120-120-120-120 53.8-120 120c0 11.6 1.6 22.7 4.7 33.3L439.9 415.8C410.7 377.1 364.3 352 312 352c-88.4 0-160 71.6-160 160s71.6 160 160 160c52.3 0 98.7-25.1 127.9-63.8l196.8 142.5c-3.1 10.6-4.7 21.8-4.7 33.3 0 66.2 53.8 120 120 120s120-53.8 120-120-53.8-120-120-120zm0-476c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52zM312 600c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88zm440 236c-28.7 0-52-23.3-52-52s23.3-52 52-52 52 23.3 52 52-23.3 52-52 52z'));
exports.ShoppingCartOutline = getIcon('shopping-cart', outline, getNode(normalViewBox, 'M922.9 701.9H327.4l29.9-60.9 496.8-.9c16.8 0 31.2-12 34.2-28.6l68.8-385.1c1.8-10.1-.9-20.5-7.5-28.4a34.99 34.99 0 0 0-26.6-12.5l-632-2.1-5.4-25.4c-3.4-16.2-18-28-34.6-28H96.5a35.3 35.3 0 1 0 0 70.6h125.9L246 312.8l58.1 281.3-74.8 122.1a34.96 34.96 0 0 0-3 36.8c6 11.9 18.1 19.4 31.5 19.4h62.8a102.43 102.43 0 0 0-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7h161.1a102.43 102.43 0 0 0-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7H923c19.4 0 35.3-15.8 35.3-35.3a35.42 35.42 0 0 0-35.4-35.2zM305.7 253l575.8 1.9-56.4 315.8-452.3.8L305.7 253zm96.9 612.7c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 0 1-31.6 31.6zm325.1 0c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 0 1-31.6 31.6z'));
exports.ShrinkOutline = getIcon('shrink', outline, getNode(newViewBox, 'M881.7 187.4l-45.1-45.1a8.03 8.03 0 0 0-11.3 0L667.8 299.9l-54.7-54.7a7.94 7.94 0 0 0-13.5 4.7L576.1 439c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 157.6-157.6c3-3 3-8.1-.1-11.2zM439 576.1l-189.2 23.5c-6.6.8-9.3 8.9-4.7 13.5l54.7 54.7-157.5 157.5a8.03 8.03 0 0 0 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l157.6-157.6 54.7 54.7a7.94 7.94 0 0 0 13.5-4.7L447.9 585a7.9 7.9 0 0 0-8.9-8.9z'));
exports.SlackOutline = getIcon('slack', outline, getNode(newViewBox, 'M409.4 128c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0 0 54.3 22.5h76.7v-76.8c0-42.3-34.3-76.7-76.7-76.8zm0 204.8H204.7c-42.4 0-76.7 34.4-76.7 76.8s34.4 76.8 76.7 76.8h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.8-76.6-76.8zM614 486.4c42.4 0 76.8-34.4 76.7-76.8V204.8c0-42.4-34.3-76.8-76.7-76.8-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.5 34.3 76.8 76.7 76.8zm281.4-76.8c0-42.4-34.4-76.8-76.7-76.8S742 367.2 742 409.6v76.8h76.7c42.3 0 76.7-34.4 76.7-76.8zm-76.8 128H614c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0 0 54.3 22.5h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM614 742.4h-76.7v76.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM409.4 537.6c-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8V614.4c0-20.3-8.1-39.9-22.4-54.3a76.92 76.92 0 0 0-54.3-22.5zM128 614.4c0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0 0 54.3 22.5c42.4 0 76.8-34.4 76.7-76.8v-76.8h-76.7c-42.3 0-76.7 34.4-76.7 76.8z'));
exports.SmallDashOutline = getIcon('small-dash', outline, getNode(newViewBox, 'M112 476h72v72h-72zm182 0h72v72h-72zm364 0h72v72h-72zm182 0h72v72h-72zm-364 0h72v72h-72z'));
exports.SolutionOutline = getIcon('solution', outline, getNode(newViewBox, 'M688 264c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48zm-8 136H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM480 544H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 308H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm356.8-74.4c29-26.3 47.2-64.3 47.2-106.6 0-79.5-64.5-144-144-144s-144 64.5-144 144c0 42.3 18.2 80.3 47.2 106.6-57 32.5-96.2 92.7-99.2 162.1-.2 4.5 3.5 8.3 8 8.3h48.1c4.2 0 7.7-3.3 8-7.6C564 871.2 621.7 816 692 816s128 55.2 131.9 124.4c.2 4.2 3.7 7.6 8 7.6H880c4.6 0 8.2-3.8 8-8.3-2.9-69.5-42.2-129.6-99.2-162.1zM692 591c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z'));
exports.SketchOutline = getIcon('sketch', outline, getNode(newViewBox, 'M925.6 405.1l-203-253.7a6.5 6.5 0 0 0-5-2.4H306.4c-1.9 0-3.8.9-5 2.4l-203 253.7a6.5 6.5 0 0 0 .2 8.3l408.6 459.5c1.2 1.4 3 2.1 4.8 2.1 1.8 0 3.5-.8 4.8-2.1l408.6-459.5a6.5 6.5 0 0 0 .2-8.3zM645.2 206.4l34.4 133.9-132.5-133.9h98.1zm8.2 178.5H370.6L512 242l141.4 142.9zM378.8 206.4h98.1L344.3 340.3l34.5-133.9zm-53.4 7l-44.1 171.5h-93.1l137.2-171.5zM194.6 434.9H289l125.8 247.7-220.2-247.7zM512 763.4L345.1 434.9h333.7L512 763.4zm97.1-80.8L735 434.9h94.4L609.1 682.6zm133.6-297.7l-44.1-171.5 137.2 171.5h-93.1z'));
exports.SortDescendingOutline = getIcon('sort-descending', outline, getNode(newViewBox, 'M839.6 433.8L749 150.5a9.24 9.24 0 0 0-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 0 0-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 0 0-9.2-9.3zM310.3 167.1a8 8 0 0 0-12.6 0L185.7 309c-4.2 5.3-.4 13 6.3 13h76v530c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V322h76c6.7 0 10.5-7.8 6.3-13l-112-141.9z'));
exports.SortAscendingOutline = getIcon('sort-ascending', outline, getNode(newViewBox, 'M839.6 433.8L749 150.5a9.24 9.24 0 0 0-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 0 0-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 0 0-9.2-9.3zM416 702h-76V172c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v530h-76c-6.7 0-10.5 7.8-6.3 13l112 141.9a8 8 0 0 0 12.6 0l112-141.9c4.1-5.2.4-13-6.3-13z'));
exports.StockOutline = getIcon('stock', outline, getNode(newViewBox, 'M904 747H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM165.7 621.8l39.7 39.5c3.1 3.1 8.2 3.1 11.3 0l234.7-233.9 97.6 97.3a32.11 32.11 0 0 0 45.2 0l264.2-263.2c3.1-3.1 3.1-8.2 0-11.3l-39.7-39.6a8.03 8.03 0 0 0-11.3 0l-235.7 235-97.7-97.3a32.11 32.11 0 0 0-45.2 0L165.7 610.5a7.94 7.94 0 0 0 0 11.3z'));
exports.SwapLeftOutline = getIcon('swap-left', outline, getNode(normalViewBox, 'M872 572H266.8l144.3-183c4.1-5.2.4-13-6.3-13H340c-9.8 0-19.1 4.5-25.1 12.2l-164 208c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
exports.SwapRightOutline = getIcon('swap-right', outline, getNode(normalViewBox, 'M873.1 596.2l-164-208A32 32 0 0 0 684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z'));
exports.StrikethroughOutline = getIcon('strikethrough', outline, getNode(newViewBox, 'M952 474H569.9c-10-2-20.5-4-31.6-6-15.9-2.9-22.2-4.1-30.8-5.8-51.3-10-82.2-20-106.8-34.2-35.1-20.5-52.2-48.3-52.2-85.1 0-37 15.2-67.7 44-89 28.4-21 68.8-32.1 116.8-32.1 54.8 0 97.1 14.4 125.8 42.8 14.6 14.4 25.3 32.1 31.8 52.6 1.3 4.1 2.8 10 4.3 17.8.9 4.8 5.2 8.2 9.9 8.2h72.8c5.6 0 10.1-4.6 10.1-10.1v-1c-.7-6.8-1.3-12.1-2-16-7.3-43.5-28-81.7-59.7-110.3-44.4-40.5-109.7-61.8-188.7-61.8-72.3 0-137.4 18.1-183.3 50.9-25.6 18.4-45.4 41.2-58.6 67.7-13.5 27.1-20.3 58.4-20.3 92.9 0 29.5 5.7 54.5 17.3 76.5 8.3 15.7 19.6 29.5 34.1 42H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h433.2c2.1.4 3.9.8 5.9 1.2 30.9 6.2 49.5 10.4 66.6 15.2 23 6.5 40.6 13.3 55.2 21.5 35.8 20.2 53.3 49.2 53.3 89 0 35.3-15.5 66.8-43.6 88.8-30.5 23.9-75.6 36.4-130.5 36.4-43.7 0-80.7-8.5-110.2-25-29.1-16.3-49.1-39.8-59.7-69.5-.8-2.2-1.7-5.2-2.7-9-1.2-4.4-5.3-7.5-9.7-7.5h-79.7c-5.6 0-10.1 4.6-10.1 10.1v1c.2 2.3.4 4.2.6 5.7 6.5 48.8 30.3 88.8 70.7 118.8 47.1 34.8 113.4 53.2 191.8 53.2 84.2 0 154.8-19.8 204.2-57.3 25-18.9 44.2-42.2 57.1-69 13-27.1 19.7-57.9 19.7-91.5 0-31.8-5.8-58.4-17.8-81.4-5.8-11.2-13.1-21.5-21.8-30.8H952c4.4 0 8-3.6 8-8v-60a8 8 0 0 0-8-7.9z'));
exports.SwapOutline = getIcon('swap', outline, getNode(newViewBox, 'M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
exports.SyncOutline = getIcon('sync', outline, getNode(newViewBox, 'M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27A341.5 341.5 0 0 1 755 268.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8zm756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4A342.45 342.45 0 0 1 512.1 856a342.24 342.24 0 0 1-243.2-100.8c-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47a8 8 0 0 0-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8a8 8 0 0 0-8-8.2z'));
exports.TableOutline = getIcon('table', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 208H676V232h212v136zm0 224H676V432h212v160zM412 432h200v160H412V432zm200-64H412V232h200v136zm-476 64h212v160H136V432zm0-200h212v136H136V232zm0 424h212v136H136V656zm276 0h200v136H412V656zm476 136H676V656h212v136z'));
exports.TeamOutline = getIcon('team', outline, getNode(newViewBox, 'M824.2 699.9a301.55 301.55 0 0 0-86.4-60.4C783.1 602.8 812 546.8 812 484c0-110.8-92.4-201.7-203.2-200-109.1 1.7-197 90.6-197 200 0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C345 754.6 314 826.8 312 903.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5A226.62 226.62 0 0 1 612 684c60.9 0 118.2 23.7 161.3 66.8C814.5 792 838 846.3 840 904.3c.1 4.3 3.7 7.7 8 7.7h56a8 8 0 0 0 8-8.2c-2-77-33-149.2-87.8-203.9zM612 612c-34.2 0-66.4-13.3-90.5-37.5a126.86 126.86 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4 0 34.2-13.3 66.3-37.5 90.5A127.3 127.3 0 0 1 612 612zM361.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7z'));
exports.TaobaoOutline = getIcon('taobao', outline, getNode(newViewBox, 'M168.5 273.7a68.7 68.7 0 1 0 137.4 0 68.7 68.7 0 1 0-137.4 0zm730 79.2s-23.7-184.4-426.9-70.1c17.3-30 25.6-49.5 25.6-49.5L396.4 205s-40.6 132.6-113 194.4c0 0 70.1 40.6 69.4 39.4 20.1-20.1 38.2-40.6 53.7-60.4 16.1-7 31.5-13.6 46.7-19.8-18.6 33.5-48.7 83.8-78.8 115.6l42.4 37s28.8-27.7 60.4-61.2h36v61.8H372.9v49.5h140.3v118.5c-1.7 0-3.6 0-5.4-.2-15.4-.7-39.5-3.3-49-18.2-11.5-18.1-3-51.5-2.4-71.9h-97l-3.4 1.8s-35.5 159.1 102.3 155.5c129.1 3.6 203-36 238.6-63.1l14.2 52.6 79.6-33.2-53.9-131.9-64.6 20.1 12.1 45.2c-16.6 12.4-35.6 21.7-56.2 28.4V561.3h137.1v-49.5H628.1V450h137.6v-49.5H521.3c17.6-21.4 31.5-41.1 35-53.6l-42.5-11.6c182.8-65.5 284.5-54.2 283.6 53.2v282.8s10.8 97.1-100.4 90.1l-60.2-12.9-14.2 57.1S882.5 880 903.7 680.2c21.3-200-5.2-327.3-5.2-327.3zm-707.4 18.3l-45.4 69.7 83.6 52.1s56 28.5 29.4 81.9C233.8 625.5 112 736.3 112 736.3l109 68.1c75.4-163.7 70.5-142 89.5-200.7 19.5-60.1 23.7-105.9-9.4-139.1-42.4-42.6-47-46.6-110-93.4z'));
exports.ToTopOutline = getIcon('to-top', outline, getNode(newViewBox, 'M885 780H165c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM400 325.7h73.9V664c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V325.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 171a8 8 0 0 0-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13z'));
exports.TrademarkOutline = getIcon('trademark', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm87.5-334.7c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.5-131.1-144.2-131.1H378c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.5c4.4 0 8-3.6 8-8V561.2h88.7l74.6 159.2c1.3 2.8 4.1 4.6 7.2 4.6h62a7.9 7.9 0 0 0 7.1-11.5l-80.6-164.2zM522 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.5 0 46.9-29.8 72.5-82.8 72.5z'));
exports.TransactionOutline = getIcon('transaction', outline, getNode(newViewBox, 'M668.6 320c0-4.4-3.6-8-8-8h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.5-1.1.9-2.4.9-3.7zM157.9 504.2a352.7 352.7 0 0 1 103.5-242.4c32.5-32.5 70.3-58.1 112.4-75.9 43.6-18.4 89.9-27.8 137.6-27.8 47.8 0 94.1 9.3 137.6 27.8 42.1 17.8 79.9 43.4 112.4 75.9 10 10 19.3 20.5 27.9 31.4l-50 39.1a8 8 0 0 0 3 14.1l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3l-47.8 37.4C770.7 146.3 648.6 82 511.5 82 277 82 86.3 270.1 82 503.8a8 8 0 0 0 8 8.2h60c4.3 0 7.8-3.5 7.9-7.8zM934 512h-60c-4.3 0-7.9 3.5-8 7.8a352.7 352.7 0 0 1-103.5 242.4 352.57 352.57 0 0 1-112.4 75.9c-43.6 18.4-89.9 27.8-137.6 27.8s-94.1-9.3-137.6-27.8a352.57 352.57 0 0 1-112.4-75.9c-10-10-19.3-20.5-27.9-31.4l49.9-39.1a8 8 0 0 0-3-14.1l-156.8-38.3c-5-1.2-9.9 2.6-9.9 7.7l-.8 161.7c0 6.7 7.7 10.5 12.9 6.3l47.8-37.4C253.3 877.7 375.4 942 512.5 942 747 942 937.7 753.9 942 520.2a8 8 0 0 0-8-8.2z'));
exports.TwitterOutline = getIcon('twitter', outline, getNode(newViewBox, 'M928 254.3c-30.6 13.2-63.9 22.7-98.2 26.4a170.1 170.1 0 0 0 75-94 336.64 336.64 0 0 1-108.2 41.2A170.1 170.1 0 0 0 672 174c-94.5 0-170.5 76.6-170.5 170.6 0 13.2 1.6 26.4 4.2 39.1-141.5-7.4-267.7-75-351.6-178.5a169.32 169.32 0 0 0-23.2 86.1c0 59.2 30.1 111.4 76 142.1a172 172 0 0 1-77.1-21.7v2.1c0 82.9 58.6 151.6 136.7 167.4a180.6 180.6 0 0 1-44.9 5.8c-11.1 0-21.6-1.1-32.2-2.6C211 652 273.9 701.1 348.8 702.7c-58.6 45.9-132 72.9-211.7 72.9-14.3 0-27.5-.5-41.2-2.1C171.5 822 261.2 850 357.8 850 671.4 850 843 590.2 843 364.7c0-7.4 0-14.8-.5-22.2 33.2-24.3 62.3-54.4 85.5-88.2z'));
exports.UnderlineOutline = getIcon('underline', outline, getNode(newViewBox, 'M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1 183.8-76.2C745 602.7 772 537.4 772 468V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 97-79 176-176 176s-176-79-176-176V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 69.4 27.1 134.6 76.2 183.8C377.3 701 442.6 728 512 728z'));
exports.UndoOutline = getIcon('undo', outline, getNode(newViewBox, 'M511.4 124C290.5 124.3 112 303 112 523.9c0 128 60.2 242 153.8 315.2l-37.5 48c-4.1 5.3-.3 13 6.3 12.9l167-.8c5.2 0 9-4.9 7.7-9.9L369.8 727a8 8 0 0 0-14.1-3L315 776.1c-10.2-8-20-16.7-29.3-26a318.64 318.64 0 0 1-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 0 1-68.6 101.7c-7.5 7.5-15.3 14.5-23.4 21.2a7.93 7.93 0 0 0-1.2 11.1l39.4 50.5c2.8 3.5 7.9 4.1 11.4 1.3C854.5 760.8 912 649.1 912 523.9c0-221.1-179.4-400.2-400.6-399.9z'));
exports.UnorderedListOutline = getIcon('unordered-list', outline, getNode(newViewBox, 'M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
exports.UpOutline = getIcon('up', outline, getNode(newViewBox, 'M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 0 0 140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z'));
exports.UploadOutline = getIcon('upload', outline, getNode(newViewBox, 'M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 0 0-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z'));
exports.UserAddOutline = getIcon('user-add', outline, getNode(newViewBox, 'M678.3 642.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 0 0-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 505 759.6 431.7 759.6 349c0-137-110.8-248-247.5-248S264.7 212 264.7 349c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 0 0-80.4 119.5A373.6 373.6 0 0 0 137 888.8a8 8 0 0 0 8 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 628.2 432.2 597 512.2 597c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 0 0 8.1.3zM512.2 521c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 0 1 340.5 349c0-45.9 17.9-89.1 50.3-121.6S466.3 177 512.2 177s88.9 17.9 121.4 50.4A171.2 171.2 0 0 1 683.9 349c0 45.9-17.9 89.1-50.3 121.6C601.1 503.1 558 521 512.2 521zM880 759h-84v-84c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v84h-84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h84v84c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-84h84c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.UsergroupAddOutline = getIcon('usergroup-add', outline, getNode(newViewBox, 'M892 772h-80v-80c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v80h-80c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h80v80c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-80h80c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 498.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.8-1.7-203.2 89.2-203.2 200 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.8-1.1 6.4-4.8 5.9-8.8zM824 472c0-109.4-87.9-198.3-196.9-200C516.3 270.3 424 361.2 424 472c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C357 742.6 326 814.8 324 891.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 695.7 563 672 624 672c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 586.7 658.2 600 624 600s-66.3-13.3-90.5-37.5a127.26 127.26 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z'));
exports.UserOutline = getIcon('user', outline, getNode(newViewBox, 'M858.5 763.6a374 374 0 0 0-80.6-119.5 375.63 375.63 0 0 0-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 0 0-80.6 119.5A371.7 371.7 0 0 0 136 901.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 0 0 8-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z'));
exports.UserDeleteOutline = getIcon('user-delete', outline, getNode(newViewBox, 'M678.3 655.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 0 0-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 518 759.6 444.7 759.6 362c0-137-110.8-248-247.5-248S264.7 225 264.7 362c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 0 0-80.4 119.5A373.6 373.6 0 0 0 137 901.8a8 8 0 0 0 8 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 641.2 432.2 610 512.2 610c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 0 0 8.1.3zM512.2 534c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 0 1 340.5 362c0-45.9 17.9-89.1 50.3-121.6S466.3 190 512.2 190s88.9 17.9 121.4 50.4A171.2 171.2 0 0 1 683.9 362c0 45.9-17.9 89.1-50.3 121.6C601.1 516.1 558 534 512.2 534zM880 772H640c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.UsergroupDeleteOutline = getIcon('usergroup-delete', outline, getNode(newViewBox, 'M888 784H664c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7zM824 484c0-109.4-87.9-198.3-196.9-200C516.3 282.3 424 373.2 424 484c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C357 754.6 326 826.8 324 903.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 707.7 563 684 624 684c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 598.7 658.2 612 624 612s-66.3-13.3-90.5-37.5a127.26 127.26 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z'));
exports.VerticalAlignBottomOutline = getIcon('vertical-align-bottom', outline, getNode(newViewBox, 'M859.9 780H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM505.7 669a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V176c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8z'));
exports.VerticalAlignMiddleOutline = getIcon('vertical-align-middle', outline, getNode(newViewBox, 'M859.9 474H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zm-353.6-74.7c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H550V104c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v156h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.6zm11.4 225.4a7.14 7.14 0 0 0-11.3 0L405.6 752.3a7.23 7.23 0 0 0 5.7 11.7H474v156c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V764h62.8c6 0 9.4-7 5.7-11.7L517.7 624.7z'));
exports.VerticalAlignTopOutline = getIcon('vertical-align-top', outline, getNode(newViewBox, 'M859.9 168H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM518.3 355a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V848c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V509.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 355z'));
exports.VerticalRightOutline = getIcon('vertical-right', outline, getNode(newViewBox, 'M326 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm444 72.4V164c0-6.8-7.9-10.5-13.1-6.1L335 512l421.9 354.1c5.2 4.4 13.1.7 13.1-6.1v-72.4c0-9.4-4.2-18.4-11.4-24.5L459.4 512l299.2-251.1c7.2-6.1 11.4-15.1 11.4-24.5z'));
exports.VerticalLeftOutline = getIcon('vertical-left', outline, getNode(newViewBox, 'M762 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm-508 0v72.4c0 9.5 4.2 18.4 11.4 24.5L564.6 512 265.4 763.1c-7.2 6.1-11.4 15-11.4 24.5V860c0 6.8 7.9 10.5 13.1 6.1L689 512 267.1 157.9A7.95 7.95 0 0 0 254 164z'));
exports.WifiOutline = getIcon('wifi', outline, getNode(newViewBox, 'M723 620.5C666.8 571.6 593.4 542 513 542s-153.8 29.6-210.1 78.6a8.1 8.1 0 0 0-.8 11.2l36 42.9c2.9 3.4 8 3.8 11.4.9C393.1 637.2 450.3 614 513 614s119.9 23.2 163.5 61.5c3.4 2.9 8.5 2.5 11.4-.9l36-42.9c2.8-3.3 2.4-8.3-.9-11.2zm117.4-140.1C751.7 406.5 637.6 362 513 362s-238.7 44.5-327.5 118.4a8.05 8.05 0 0 0-1 11.3l36 42.9c2.8 3.4 7.9 3.8 11.2 1C308 472.2 406.1 434 513 434s205 38.2 281.2 101.6c3.4 2.8 8.4 2.4 11.2-1l36-42.9c2.8-3.4 2.4-8.5-1-11.3zm116.7-139C835.7 241.8 680.3 182 511 182c-168.2 0-322.6 59-443.7 157.4a8 8 0 0 0-1.1 11.4l36 42.9c2.8 3.3 7.8 3.8 11.1 1.1C222 306.7 360.3 254 511 254c151.8 0 291 53.5 400 142.7 3.4 2.8 8.4 2.3 11.2-1.1l36-42.9c2.9-3.4 2.4-8.5-1.1-11.3zM448 778a64 64 0 1 0 128 0 64 64 0 1 0-128 0z'));
exports.ZhihuOutline = getIcon('zhihu', outline, getNode(newViewBox, 'M564.7 230.1V803h60l25.2 71.4L756.3 803h131.5V230.1H564.7zm247.7 497h-59.9l-75.1 50.4-17.8-50.4h-18V308.3h170.7v418.8zM526.1 486.9H393.3c2.1-44.9 4.3-104.3 6.6-172.9h130.9l-.1-8.1c0-.6-.2-14.7-2.3-29.1-2.1-15-6.6-34.9-21-34.9H287.8c4.4-20.6 15.7-69.7 29.4-93.8l6.4-11.2-12.9-.7c-.8 0-19.6-.9-41.4 10.6-35.7 19-51.7 56.4-58.7 84.4-18.4 73.1-44.6 123.9-55.7 145.6-3.3 6.4-5.3 10.2-6.2 12.8-1.8 4.9-.8 9.8 2.8 13 10.5 9.5 38.2-2.9 38.5-3 .6-.3 1.3-.6 2.2-1 13.9-6.3 55.1-25 69.8-84.5h56.7c.7 32.2 3.1 138.4 2.9 172.9h-141l-2.1 1.5c-23.1 16.9-30.5 63.2-30.8 65.2l-1.4 9.2h167c-12.3 78.3-26.5 113.4-34 127.4-3.7 7-7.3 14-10.7 20.8-21.3 42.2-43.4 85.8-126.3 153.6-3.6 2.8-7 8-4.8 13.7 2.4 6.3 9.3 9.1 24.6 9.1 5.4 0 11.8-.3 19.4-1 49.9-4.4 100.8-18 135.1-87.6 17-35.1 31.7-71.7 43.9-108.9L497 850l5-12c.8-1.9 19-46.3 5.1-95.9l-.5-1.8-108.1-123-22 16.6c6.4-26.1 10.6-49.9 12.5-71.1h158.7v-8c0-40.1-18.5-63.9-19.2-64.9l-2.4-3z'));
exports.WeiboOutline = getIcon('weibo', outline, getNode(newViewBox, 'M457.3 543c-68.1-17.7-145 16.2-174.6 76.2-30.1 61.2-1 129.1 67.8 151.3 71.2 23 155.2-12.2 184.4-78.3 28.7-64.6-7.2-131-77.6-149.2zm-52 156.2c-13.8 22.1-43.5 31.7-65.8 21.6-22-10-28.5-35.7-14.6-57.2 13.7-21.4 42.3-31 64.4-21.7 22.4 9.5 29.6 35 16 57.3zm45.5-58.5c-5 8.6-16.1 12.7-24.7 9.1-8.5-3.5-11.2-13.1-6.4-21.5 5-8.4 15.6-12.4 24.1-9.1 8.7 3.2 11.8 12.9 7 21.5zm334.5-197.2c15 4.8 31-3.4 35.9-18.3 11.8-36.6 4.4-78.4-23.2-109a111.39 111.39 0 0 0-106-34.3 28.45 28.45 0 0 0-21.9 33.8 28.39 28.39 0 0 0 33.8 21.8c18.4-3.9 38.3 1.8 51.9 16.7a54.2 54.2 0 0 1 11.3 53.3 28.45 28.45 0 0 0 18.2 36zm99.8-206c-56.7-62.9-140.4-86.9-217.7-70.5a32.98 32.98 0 0 0-25.4 39.3 33.12 33.12 0 0 0 39.3 25.5c55-11.7 114.4 5.4 154.8 50.1 40.3 44.7 51.2 105.7 34 159.1-5.6 17.4 3.9 36 21.3 41.7 17.4 5.6 36-3.9 41.6-21.2v-.1c24.1-75.4 8.9-161.1-47.9-223.9zM729 499c-12.2-3.6-20.5-6.1-14.1-22.1 13.8-34.7 15.2-64.7.3-86-28-40.1-104.8-37.9-192.8-1.1 0 0-27.6 12.1-20.6-9.8 13.5-43.5 11.5-79.9-9.6-101-47.7-47.8-174.6 1.8-283.5 110.6C127.3 471.1 80 557.5 80 632.2 80 775.1 263.2 862 442.5 862c235 0 391.3-136.5 391.3-245 0-65.5-55.2-102.6-104.8-118zM443 810.8c-143 14.1-266.5-50.5-275.8-144.5-9.3-93.9 99.2-181.5 242.2-195.6 143-14.2 266.5 50.5 275.8 144.4C694.4 709 586 796.6 443 810.8z'));
exports.WomanOutline = getIcon('woman', outline, getNode(newViewBox, 'M712.8 548.8c53.6-53.6 83.2-125 83.2-200.8 0-75.9-29.5-147.2-83.2-200.8C659.2 93.6 587.8 64 512 64s-147.2 29.5-200.8 83.2C257.6 200.9 228 272.1 228 348c0 63.8 20.9 124.4 59.4 173.9 7.3 9.4 15.2 18.3 23.7 26.9 8.5 8.5 17.5 16.4 26.8 23.7 39.6 30.8 86.3 50.4 136.1 57V736H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h114v140c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V812h114c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H550V629.5c61.5-8.2 118.2-36.1 162.8-80.7zM512 556c-55.6 0-107.7-21.6-147.1-60.9C325.6 455.8 304 403.6 304 348s21.6-107.7 60.9-147.1C404.2 161.5 456.4 140 512 140s107.7 21.6 147.1 60.9C698.4 240.2 720 292.4 720 348s-21.6 107.7-60.9 147.1C619.7 534.4 567.6 556 512 556z'));
exports.ZoomInOutline = getIcon('zoom-in', outline, getNode(newViewBox, 'M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z'));
exports.AccountBookTwoTone = getIcon('account-book', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-65.6 121.8l-89.3 164.1h49.1c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4v33.7h65.4c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4V752c0 4.4-3.6 8-8 8h-41.3c-4.4 0-8-3.6-8-8v-53.8h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8h65.1v-33.7h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8H467l-89.3-164c-2.1-3.9-.7-8.8 3.2-10.9 1.1-.7 2.5-1 3.8-1h46a8 8 0 0 1 7.1 4.4l73.4 145.4h2.8l73.4-145.4c1.3-2.7 4.1-4.4 7.1-4.4h45c4.5 0 8 3.6 7.9 8 0 1.3-.4 2.6-1 3.8z'
    ], [
        primaryColor,
        'M639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 0 0-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z'
    ], [
        primaryColor,
        'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z'
    ]);
});
exports.ZoomOutOutline = getIcon('zoom-out', outline, getNode(newViewBox, 'M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z'));
exports.AlertTwoTone = getIcon('alert', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M340 585c0-5.5 4.5-10 10-10h44c5.5 0 10 4.5 10 10v171h355V563c0-136.4-110.6-247-247-247S265 426.6 265 563v193h75V585z'
    ], [
        primaryColor,
        'M216.9 310.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 0 0-11.3 0l-39.6 39.6a8.03 8.03 0 0 0 0 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-67.9 67.9a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8zm348 712H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zm-639-96c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563z'
    ]);
});
exports.ApiTwoTone = getIcon('api', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M148.2 674.6zm106.7-92.3c-25 25-38.7 58.1-38.7 93.4s13.8 68.5 38.7 93.4c25 25 58.1 38.7 93.4 38.7 35.3 0 68.5-13.8 93.4-38.7l59.4-59.4-186.8-186.8-59.4 59.4zm420.8-366.1c-35.3 0-68.5 13.8-93.4 38.7l-59.4 59.4 186.8 186.8 59.4-59.4c24.9-25 38.7-58.1 38.7-93.4s-13.8-68.5-38.7-93.4c-25-25-58.1-38.7-93.4-38.7z'
    ], [
        primaryColor,
        'M578.9 546.7a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2a199.45 199.45 0 0 0-58.6 140.4c-.2 39.5 11.2 79.1 34.3 113.1l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 0 1-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7-24.9-24.9-38.7-58.1-38.7-93.4s13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4zm476-620.3l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7s68.4 13.7 93.4 38.7c24.9 24.9 38.7 58.1 38.7 93.4s-13.8 68.4-38.7 93.4z'
    ]);
});
exports.AppstoreTwoTone = getIcon('appstore', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm52-668H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452 132H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z'
    ], [
        secondaryColor,
        'M212 212h200v200H212zm400 0h200v200H612zM212 612h200v200H212zm400 0h200v200H612z'
    ]);
});
exports.BankTwoTone = getIcon('bank', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M240.9 393.9h542.2L512 196.7z'], [
        primaryColor,
        'M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374zM240.9 393.9L512 196.7l271.1 197.2H240.9z'
    ]);
});
exports.AudioTwoTone = getIcon('audio', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 552c54.3 0 98-43.2 98-96V232c0-52.8-43.7-96-98-96s-98 43.2-98 96v224c0 52.8 43.7 96 98 96z'
    ], [
        primaryColor,
        'M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z'
    ], [
        primaryColor,
        'M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-98-392c0-52.8 43.7-96 98-96s98 43.2 98 96v224c0 52.8-43.7 96-98 96s-98-43.2-98-96V232z'
    ]);
});
exports.BellTwoTone = getIcon('bell', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 220c-55.6 0-107.8 21.6-147.1 60.9S304 372.4 304 428v340h416V428c0-55.6-21.6-107.8-60.9-147.1S567.6 220 512 220zm280 208c0-141.1-104.3-257.8-240-277.2v.1c135.7 19.4 240 136 240 277.1zM472 150.9v-.1C336.3 170.2 232 286.9 232 428c0-141.1 104.3-257.7 240-277.1z'
    ], [
        primaryColor,
        'M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zm208-120H304V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340z'
    ]);
});
exports.BookTwoTone = getIcon('book', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zM232 888V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0 0 22.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752H232z'
    ], [secondaryColor, 'M668 345.9V136h-96v211.4l49.5-35.4z'], [
        secondaryColor,
        'M727.9 136v296.5c0 8.8-7.2 16-16 16-3.4 0-6.7-1.1-9.4-3.1L621.1 386l-83.8 59.9a15.9 15.9 0 0 1-22.3-3.7c-2-2.7-3-6-3-9.3V136H232v752h559.9V136h-64z'
    ]);
});
exports.BoxPlotTwoTone = getIcon('box-plot', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M296 368h88v288h-88zm152 0h280v288H448z'], [
        primaryColor,
        'M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM384 656h-88V368h88v288zm344 0H448V368h280v288z'
    ]);
});
exports.BugTwoTone = getIcon('bug', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M308 412v268c0 36.78 9.68 71.96 27.8 102.9a205.39 205.39 0 0 0 73.3 73.3A202.68 202.68 0 0 0 512 884c36.78 0 71.96-9.68 102.9-27.8a205.39 205.39 0 0 0 73.3-73.3A202.68 202.68 0 0 0 716 680V412H308zm484 172v96c0 6.5-.22 12.95-.66 19.35C859.94 728.64 908 796.7 908 876a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-44.24-23.94-82.89-59.57-103.7a278.63 278.63 0 0 1-22.66 49.02 281.39 281.39 0 0 1-100.45 100.45C611.84 946.07 563.55 960 512 960s-99.84-13.93-141.32-38.23a281.39 281.39 0 0 1-100.45-100.45 278.63 278.63 0 0 1-22.66-49.02A119.95 119.95 0 0 0 188 876a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-79.3 48.07-147.36 116.66-176.65A284.12 284.12 0 0 1 232 680v-96H84a8 8 0 0 1-8-8v-56a8 8 0 0 1 8-8h148V412c-76.77 0-139-62.23-139-139a8 8 0 0 1 8-8h60a8 8 0 0 1 8 8 63 63 0 0 0 63 63h560a63 63 0 0 0 63-63 8 8 0 0 1 8-8h60a8 8 0 0 1 8 8c0 76.77-62.23 139-139 139v100h148a8 8 0 0 1 8 8v56a8 8 0 0 1-8 8H792zM368 272a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-40.04 8.78-76.75 25.9-108.07a184.57 184.57 0 0 1 74.03-74.03C427.25 72.78 463.96 64 504 64h16c40.04 0 76.75 8.78 108.07 25.9a184.57 184.57 0 0 1 74.03 74.03C719.22 195.25 728 231.96 728 272a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-28.33-5.94-53.15-17.08-73.53a112.56 112.56 0 0 0-45.39-45.4C573.15 141.95 548.33 136 520 136h-16c-28.33 0-53.15 5.94-73.53 17.08a112.56 112.56 0 0 0-45.4 45.39C373.95 218.85 368 243.67 368 272z'
    ], [
        secondaryColor,
        'M308 412v268c0 36.78 9.68 71.96 27.8 102.9a205.39 205.39 0 0 0 73.3 73.3A202.68 202.68 0 0 0 512 884c36.78 0 71.96-9.68 102.9-27.8a205.39 205.39 0 0 0 73.3-73.3A202.68 202.68 0 0 0 716 680V412H308z'
    ]);
});
exports.BulbTwoTone = getIcon('bulb', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 136c-141.4 0-256 114.6-256 256 0 92.5 49.4 176.3 128.1 221.8l35.9 20.8V752h184V634.6l35.9-20.8C718.6 568.3 768 484.5 768 392c0-141.4-114.6-256-256-256z'
    ], [
        primaryColor,
        'M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z'
    ]);
});
exports.CalculatorTwoTone = getIcon('calculator', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm256.2-75h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 0 1-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zM576 335c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 265c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 104c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zM248 335c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48z'
    ], [
        primaryColor,
        'M383.5 675l61.3-74.8c4.3-5.2.7-13.1-5.9-13.1h-50.8c-2.3 0-4.4 1-5.9 2.9l-34 41.6-34-41.6a7.69 7.69 0 0 0-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.4-1 5.9-2.9l35.5-43.5 35.5 43.5c1.4 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 6-13.2L383.5 675zM251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 369h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4z'
    ]);
});
exports.BuildTwoTone = getIcon('build', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M144 546h200v200H144zm268-268h200v200H412z'], [
        primaryColor,
        'M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM344 746H144V546h200v200zm268 0H412V546h200v200zm0-268H412V278h200v200zm268 0H680V278h200v200z'
    ]);
});
exports.CalendarTwoTone = getIcon('calendar', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v136h656V256H712v48z'
    ], [
        primaryColor,
        'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zm0-448H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z'
    ]);
});
exports.CameraTwoTone = getIcon('camera', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M864 320H677.2l-17.1-47.8-22.9-64.2H386.7l-22.9 64.2-17.1 47.8H160c-4.4 0-8 3.6-8 8v456c0 4.4 3.6 8 8 8h704c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8zM512 704c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160z'
    ], [
        primaryColor,
        'M512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z'
    ], [
        primaryColor,
        'M864 248H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456z'
    ]);
});
exports.CarTwoTone = getIcon('car', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M199.6 474L184 517v237h656V517l-15.6-43H199.6zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z'
    ], [primaryColor, 'M720 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'], [
        primaryColor,
        'M959 413.4L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM840 754H184V517l15.6-43h624.8l15.6 43v237z'
    ], [
        primaryColor,
        'M224 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm420 23h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8z'
    ]);
});
exports.CarryOutTwoTone = getIcon('carry-out', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z'
    ], [
        secondaryColor,
        'M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-17.5 128.8L481.9 725.5a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.9-6.6 13-6.6H688c6.5 0 10.3 7.4 6.5 12.8z'
    ], [
        primaryColor,
        'M688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z'
    ]);
});
exports.CheckCircleTwoTone = getIcon('check-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm193.4 225.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 5 25.9 13.3l71.2 98.8 157.2-218c6-8.4 15.7-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.4 12.7z'
    ], [
        primaryColor,
        'M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0 0 51.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z'
    ]);
});
exports.CheckSquareTwoTone = getIcon('check-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm130-367.8h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H688c6.5 0 10.3 7.4 6.5 12.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L307.5 484.9c-3.8-5.3 0-12.7 6.5-12.7z'
    ], [
        primaryColor,
        'M432.2 657.7a31.8 31.8 0 0 0 51.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7h-46.9c-10.3 0-19.9 5-25.9 13.3L458 584.3l-71.2-98.8c-6-8.4-15.7-13.3-25.9-13.3H314c-6.5 0-10.3 7.4-6.5 12.7l124.7 172.8z'
    ]);
});
exports.ClockCircleTwoTone = getIcon('clock-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm176.5 509.7l-28.6 39a7.99 7.99 0 0 1-11.2 1.7L483.3 569.8a7.92 7.92 0 0 1-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z'
    ], [
        primaryColor,
        'M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.6-3.6 1.8-8.6-1.8-11.1z'
    ]);
});
exports.CloseCircleTwoTone = getIcon('close-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm171.8 527.1c1.2 1.5 1.9 3.3 1.9 5.2 0 4.5-3.6 8-8 8l-66-.3-99.3-118.4-99.3 118.5-66.1.3c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2L471 512.3l-130.1-155a8.32 8.32 0 0 1-1.9-5.2c0-4.5 3.6-8 8-8l66.1.3 99.3 118.4 99.4-118.5 66-.3c4.4 0 8 3.6 8 8 0 1.9-.6 3.8-1.8 5.2l-130.1 155 129.9 154.9z'
    ], [
        primaryColor,
        'M685.8 352c0-4.4-3.6-8-8-8l-66 .3-99.4 118.5-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155-130.1 154.9a8.32 8.32 0 0 0-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3 99.3-118.5L611.7 680l66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.9 512.2l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z'
    ]);
});
exports.CloudTwoTone = getIcon('cloud', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M791.9 492l-37.8-10-13.8-36.5c-8.6-22.7-20.6-44.1-35.7-63.4a245.73 245.73 0 0 0-52.4-49.9c-41.1-28.9-89.5-44.2-140-44.2s-98.9 15.3-140 44.2a245.6 245.6 0 0 0-52.4 49.9 240.47 240.47 0 0 0-35.7 63.4l-13.9 36.6-37.9 9.9a125.7 125.7 0 0 0-66.1 43.7A123.1 123.1 0 0 0 140 612c0 33.1 12.9 64.3 36.3 87.7 23.4 23.4 54.5 36.3 87.6 36.3h496.2c33.1 0 64.2-12.9 87.6-36.3A123.3 123.3 0 0 0 884 612c0-56.2-37.8-105.5-92.1-120z'
    ], [
        primaryColor,
        'M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 0 1-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 0 1 140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0 1 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z'
    ]);
});
exports.CloseSquareTwoTone = getIcon('close-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm163.9-473.9A7.95 7.95 0 0 1 354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1z'
    ], [
        primaryColor,
        'M354 671h58.9c4.8 0 9.3-2.1 12.3-5.7L512 561.8l86.8 103.5c3.1 3.6 7.6 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.3-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.8 0-9.3 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3.1-3.6-7.6-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 0 0 354 671z'
    ]);
});
exports.CodeTwoTone = getIcon('code', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm339.5-223h185c4.1 0 7.5 3.6 7.5 8v48c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8zM308 610.3c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 0 1-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7z'
    ], [
        primaryColor,
        'M321.1 679.1l192-161c3.9-3.2 3.9-9.1 0-12.3l-192-160.9A7.95 7.95 0 0 0 308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 0 0-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48z'
    ]);
});
exports.CompassTwoTone = getIcon('compass', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM327.6 701.7c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2L421 470.9 553.1 603l-225.5 98.7zm375.1-375.1L604 552.1 471.9 420l225.5-98.7c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z'
    ], [
        primaryColor,
        'M322.3 696.4c-.4 1-.4 2.2 0 3.2.9 2.1 3.3 3 5.3 2.1L553.1 603 421 470.9l-98.7 225.5zm375.1-375.1L471.9 420 604 552.1l98.7-225.5c.4-1.1.4-2.2 0-3.2-.9-2.1-3.3-3-5.3-2.1z'
    ], [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ]);
});
exports.ContactsTwoTone = getIcon('contacts', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M460.3 526a51.7 52 0 1 0 103.4 0 51.7 52 0 1 0-103.4 0z'
    ], [
        secondaryColor,
        'M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM661 736h-43.8c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 39.9-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5h-43.9a8 8 0 0 1-8-8.4c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.7 26.4 71.9 72.8 74.7 126.1a8 8 0 0 1-8 8.4z'
    ], [
        primaryColor,
        'M594.3 601.5a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1 8 8 0 0 0 8 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52z'
    ], [
        primaryColor,
        'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z'
    ]);
});
exports.ContainerTwoTone = getIcon('container', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M635 771.7c-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 0 1-59.1-84.7H232v201h560V687h-97.9c-11.6 32.8-32 62.3-59.1 84.7z'
    ], [
        primaryColor,
        'M320 501h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
    ], [
        primaryColor,
        'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v201zm0-264H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v488z'
    ], [
        primaryColor,
        'M320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
    ]);
});
exports.ControlTwoTone = getIcon('control', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M616 440a36 36 0 1 0 72 0 36 36 0 1 0-72 0zM340.4 601.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 0 0-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm436.4-499.1c-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1zM340 485V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99z'
    ], [
        primaryColor,
        'M340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c41.7-13.5 72-52.8 72-99s-30.3-85.4-72-99V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c-41.7 13.5-72 52.8-72 99s30.3 85.4 72 99zm.1-116c.1-.2.2-.3.3-.5l1.5-2.4c0-.1.1-.1.1-.2l.9-1.2c0-.1.1-.2.2-.3 1-1.2 2.1-2.5 3.2-3.6l.2-.2c.4-.4.8-.7 1.2-1.1.8-.7 1.7-1.4 2.6-2.1h.1l1.2-.9c.1-.1.3-.2.4-.3 1.3-.8 2.6-1.5 3.9-2.2.2-.2.5-.3.7-.4.4-.2.7-.3 1.1-.5.3-.1.7-.3 1-.4.5-.1 1-.3 1.5-.5.4-.1.9-.3 1.3-.4l.9-.3 1.4-.3c.2-.1.5-.1.7-.2.7-.2 1.4-.3 2.1-.4.2-.1.4-.1.6-.1.5-.1 1.1-.2 1.7-.2.3-.1.5-.1.7-.1.8-.1 1.5-.1 2.3-.1s1.5.1 2.3.1c.3.1.5.1.7.1.6.1 1.1.1 1.7.2.2.1.4.1.6.1.7.1 1.4.3 2.1.4.2.1.5.1.7.2l1.4.3.9.3c.4.1.9.3 1.3.4.5.1 1 .3 1.5.5.3.1.7.3 1 .4.4.2.7.3 1.1.5.2.2.5.3.7.4 1.4.6 2.7 1.4 3.9 2.2.1.1.3.2.4.3l1.2.9h.1c.9.6 1.8 1.3 2.6 2.1.4.3.8.7 1.2 1.1l.2.2c1.2 1.1 2.2 2.3 3.2 3.6 0 .1.1.2.2.3l.9 1.2c0 .1.1.1.1.2l1.5 2.4A36.03 36.03 0 0 1 408 584c0 6.1-1.6 11.9-4.3 17-.1.2-.2.3-.3.5l-1.5 2.4c0 .1-.1.1-.1.2l-.9 1.2c0 .1-.1.2-.2.3-1 1.2-2.1 2.5-3.2 3.6l-.2.2c-.4.4-.8.7-1.2 1.1-.8.7-1.7 1.4-2.6 2.1h-.1l-1.2.9c-.1.1-.3.2-.4.3-1.3.8-2.6 1.5-3.9 2.2-.2.2-.5.3-.7.4-.4.2-.7.3-1.1.5-.3.1-.7.3-1 .4-.5.1-1 .3-1.5.5-.4.1-.9.3-1.3.4l-.9.3-1.4.3c-.2.1-.5.1-.7.2-.7.2-1.4.3-2.1.4-.2.1-.4.1-.6.1-.5.1-1.1.2-1.7.2-.3.1-.5.1-.7.1-.8.1-1.5.1-2.3.1s-1.5-.1-2.3-.1c-.3-.1-.5-.1-.7-.1-.6-.1-1.1-.1-1.7-.2-.2-.1-.4-.1-.6-.1-.7-.1-1.4-.3-2.1-.4-.2-.1-.5-.1-.7-.2l-1.4-.3-.9-.3c-.4-.1-.9-.3-1.3-.4-.5-.1-1-.3-1.5-.5-.3-.1-.7-.3-1-.4-.4-.2-.7-.3-1.1-.5-.2-.2-.5-.3-.7-.4-1.4-.6-2.7-1.4-3.9-2.2-.1-.1-.3-.2-.4-.3l-1.2-.9h-.1c-.9-.6-1.8-1.3-2.6-2.1-.4-.3-.8-.7-1.2-1.1l-.2-.2c-1.2-1.1-2.2-2.3-3.2-3.6 0-.1-.1-.2-.2-.3l-.9-1.2c0-.1-.1-.1-.1-.2l-1.5-2.4c-.1-.2-.2-.3-.3-.5-2.7-5-4.3-10.9-4.3-17s1.6-11.9 4.3-17zm280.3-27.9c-.1 0-.2-.1-.4-.1v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-.1 0-.2.1-.4.1 42-13.4 72.4-52.7 72.4-99.1 0-46.4-30.4-85.7-72.4-99.1.1 0 .2.1.4.1v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c.1 0 .2-.1.4-.1-42 13.4-72.4 52.7-72.4 99.1 0 46.4 30.4 85.7 72.4 99.1zM652 404c19.9 0 36 16.1 36 36s-16.1 36-36 36-36-16.1-36-36 16.1-36 36-36z'
    ]);
});
exports.CopyTwoTone = getIcon('copy', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M232 706h142c22.1 0 40 17.9 40 40v142h250V264H232v442z'], [
        primaryColor,
        'M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32z'
    ], [
        primaryColor,
        'M704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z'
    ]);
});
exports.CreditCardTwoTone = getIcon('credit-card', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M136 792h752V440H136v352zm507-144c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72zM136 232h752v120H136z'
    ], [
        primaryColor,
        'M651 728h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z'
    ], [
        primaryColor,
        'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V440h752v352zm0-440H136V232h752v120z'
    ]);
});
exports.CrownTwoTone = getIcon('crown', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M911.9 283.9v.5L835.5 865c-1 8-7.9 14-15.9 14H204.5c-8.1 0-14.9-6.1-16-14l-76.4-580.6v-.6 1.6L188.5 866c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.1-.5.1-1 0-1.5z'
    ], [
        secondaryColor,
        'M773.6 810.6l53.9-409.4-139.8 86.1L512 252.9 336.3 487.3l-139.8-86.1 53.8 409.4h523.3zm-374.2-189c0-62.1 50.5-112.6 112.6-112.6s112.6 50.5 112.6 112.6v1c0 62.1-50.5 112.6-112.6 112.6s-112.6-50.5-112.6-112.6v-1z'
    ], [
        primaryColor,
        'M512 734.2c61.9 0 112.3-50.2 112.6-112.1v-.5c0-62.1-50.5-112.6-112.6-112.6s-112.6 50.5-112.6 112.6v.5c.3 61.9 50.7 112.1 112.6 112.1zm0-160.9c26.6 0 48.2 21.6 48.2 48.3 0 26.6-21.6 48.3-48.2 48.3s-48.2-21.6-48.2-48.3c0-26.6 21.6-48.3 48.2-48.3z'
    ], [
        primaryColor,
        'M188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6v-.5c.3-6.4-6.7-10.8-12.3-7.4L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.5-3.4-12.6.9-12.2 7.3v.6L188.5 865zm147.8-377.7L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4H250.3l-53.8-409.4 139.8 86.1z'
    ]);
});
exports.CustomerServiceTwoTone = getIcon('customer-service', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M696 632h128v192H696zm-496 0h128v192H200z'], [
        primaryColor,
        'M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z'
    ]);
});
exports.DashboardTwoTone = getIcon('dashboard', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 188c-99.3 0-192.7 38.7-263 109-70.3 70.2-109 163.6-109 263 0 105.6 44.5 205.5 122.6 276h498.8A371.12 371.12 0 0 0 884 560c0-99.3-38.7-192.7-109-263-70.2-70.3-163.6-109-263-109zm-30 44c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.4l-31.1 31.1a8.03 8.03 0 0 1-11.3 0l-56.6-56.6a8.03 8.03 0 0 1 0-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.5l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 0 1-79.2 0 55.95 55.95 0 0 1 0-79.2 55.87 55.87 0 0 1 54.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.2 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 0 1 0-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 0 1-11.3 0zM846 538v44c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8z'
    ], [
        primaryColor,
        'M623.5 421.5a8.03 8.03 0 0 0-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 0 0 0 79.2 55.95 55.95 0 0 0 79.2 0 55.87 55.87 0 0 0 14.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8z'
    ], [
        primaryColor,
        'M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 0 1 140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276z'
    ], [
        primaryColor,
        'M762.7 340.8l-31.1-31.1a8.03 8.03 0 0 0-11.3 0l-56.6 56.6a8.03 8.03 0 0 0 0 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zM750 538v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zM304.1 309.7a8.03 8.03 0 0 0-11.3 0l-31.1 31.1a8.03 8.03 0 0 0 0 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z'
    ]);
});
exports.DeleteTwoTone = getIcon('delete', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M292.7 840h438.6l24.2-512h-487z'], [
        primaryColor,
        'M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-504-72h304v72H360v-72zm371.3 656H292.7l-24.2-512h487l-24.2 512z'
    ]);
});
exports.DiffTwoTone = getIcon('diff', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M232 264v624h432V413.8L514.2 264H232zm336 489c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-262v42c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7z'
    ], [
        primaryColor,
        'M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z'
    ], [
        primaryColor,
        'M553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888z'
    ], [
        primaryColor,
        'M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7z'
    ]);
});
exports.DatabaseTwoTone = getIcon('database', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M232 616h560V408H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 888h560V680H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 344h560V136H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
    ], [
        primaryColor,
        'M304 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-544a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'
    ], [
        primaryColor,
        'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z'
    ]);
});
exports.DislikeTwoTone = getIcon('dislike', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M273 100.1v428h.3l-.3-428zM820.4 525l-21.9-19 14-25.5a56.2 56.2 0 0 0 6.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 0 0 6.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 0 0 6.9-27.3c0-22.4-13.2-42.6-33.6-51.8H345v345.2c18.6 67.2 46.4 168 83.5 302.5a44.28 44.28 0 0 0 42.2 32.3c7.5.1 15-2.2 21.1-6.7 9.9-7.4 15.2-18.6 14.6-30.5l-9.6-198.4h314.4C829 605.5 840 587.1 840 568c0-16.5-7.1-32.2-19.6-43z'
    ], [
        primaryColor,
        'M112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32zm773.9 358.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H273l.3 428 85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zm-74.7 126.1H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 0 1-42.2-32.3c-37.1-134.4-64.9-235.2-83.5-302.5V172h399.4a56.85 56.85 0 0 1 33.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0 1 19.6 43c0 19.1-11 37.5-28.8 48.4z'
    ]);
});
exports.DownCircleTwoTone = getIcon('down-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm184.4 277.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7z'
    ], [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        primaryColor,
        'M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z'
    ]);
});
exports.DownSquareTwoTone = getIcon('down-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm150-440h46.9c10.3 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7z'
    ], [
        primaryColor,
        'M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z'
    ]);
});
exports.EnvironmentTwoTone = getIcon('environment', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M724.4 224.9C667.7 169.5 592.3 139 512 139s-155.7 30.5-212.4 85.8C243.1 280 212 353.2 212 431.1c0 241.3 234.1 407.2 300 449.1 65.9-41.9 300-207.8 300-449.1 0-77.9-31.1-151.1-87.6-206.2zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z'
    ], [
        primaryColor,
        'M512 263c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8S624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z'
    ], [
        primaryColor,
        'M854.6 289.1a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1z'
    ]);
});
exports.EditTwoTone = getIcon('edit', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M761.1 288.3L687.8 215 325.1 577.6l-15.6 89 88.9-15.7z'], [
        primaryColor,
        'M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89z'
    ]);
});
exports.ExclamationCircleTwoTone = getIcon('exclamation-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-32 156c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
    ], [
        primaryColor,
        'M488 576h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8zm-24 112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'
    ]);
});
exports.ExperimentTwoTone = getIcon('experiment', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M551.9 513c19.6 0 35.9-14.2 39.3-32.8A40.02 40.02 0 0 1 552 512a40 40 0 0 1-40-39.4v.5c0 22 17.9 39.9 39.9 39.9zM752 687.8l-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 0 1-164.9 59.9c-41.2 0-81-9.8-116.7-28L210.5 844h603l-59.9-155.2-1.6-1z'
    ], [
        primaryColor,
        'M879 824.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 0 1-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.6-107.6.1-.2c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1l.6 1.6L813.5 844h-603z'
    ], [
        primaryColor,
        'M552 512c19.3 0 35.4-13.6 39.2-31.8.6-2.7.8-5.4.8-8.2 0-22.1-17.9-40-40-40s-40 17.9-40 40v.6a40 40 0 0 0 40 39.4z'
    ]);
});
exports.EyeInvisibleTwoTone = getIcon('eye-invisible', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M254.89 758.85l125.57-125.57a176 176 0 0 1 248.82-248.82L757 256.72Q651.69 186.07 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q69.27 145.91 173.09 221.05zM942.2 486.2Q889.46 375.11 816.7 305L672.48 449.27a176.09 176.09 0 0 1-227.22 227.21L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5z'
    ], [
        primaryColor,
        'M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5zM878.63 165.56L836 122.88a8 8 0 0 0-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 0 0 0 11.31L155.17 889a8 8 0 0 0 11.31 0l712.15-712.12a8 8 0 0 0 0-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 0 0-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 0 1 146.2-106.69L401.31 546.2A112 112 0 0 1 396 512z'
    ], [
        primaryColor,
        'M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 0 0 227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 0 1-112 112z'
    ]);
});
exports.EyeTwoTone = getIcon('eye', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M81.8 537.8a60.3 60.3 0 0 1 0-51.5C176.6 286.5 319.8 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c-192.1 0-335.4-100.5-430.2-300.2z'
    ], [
        secondaryColor,
        'M512 258c-161.3 0-279.4 81.8-362.7 254C232.6 684.2 350.7 766 512 766c161.4 0 279.5-81.8 362.7-254C791.4 339.8 673.3 258 512 258zm-4 430c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z'
    ], [
        primaryColor,
        'M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258s279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766z'
    ], [
        primaryColor,
        'M508 336c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z'
    ]);
});
exports.FileAddTwoTone = getIcon('file-add', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm126 236v48c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V644H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V472c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z'
    ]);
});
exports.FileExclamationTwoTone = getIcon('file-exclamation', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-54 96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V448zm32 336c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M488 640h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm-16 104a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'
    ]);
});
exports.FileImageTwoTone = getIcon('file-image', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-134 50c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328.1c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0 1 12.6 0l41.1 52.4 77.8-99.2a8.1 8.1 0 0 1 12.7 0l136.5 174c4.1 5.2.4 12.9-6.3 12.9z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 0 0-12.6 0l-99.8 127.2a7.98 7.98 0 0 0 6.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 0 0-12.7 0zM360 442a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'
    ]);
});
exports.FileExcelTwoTone = getIcon('file-excel', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm51.6 120h35.7a12.04 12.04 0 0 1 10.1 18.5L546.1 623l84 130.4c3.6 5.6 2 13-3.6 16.6-2 1.2-4.2 1.9-6.5 1.9h-37.5c-4.1 0-8-2.1-10.2-5.7L510 664.8l-62.7 101.5c-2.2 3.5-6 5.7-10.2 5.7h-34.5a12.04 12.04 0 0 1-10.2-18.4l83.4-132.8-82.3-130.4c-3.6-5.7-1.9-13.1 3.7-16.6 1.9-1.3 4.1-1.9 6.4-1.9H442c4.2 0 8.1 2.2 10.3 5.8l61.8 102.4 61.2-102.3c2.2-3.6 6.1-5.8 10.3-5.8z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z'
    ]);
});
exports.FileMarkdownTwoTone = getIcon('file-markdown', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm72.3 122H641c6.6 0 12 5.4 12 12v272c0 6.6-5.4 12-12 12h-27.2c-6.6 0-12-5.4-12-12V581.7L535 732.3c-2 4.3-6.3 7.1-11 7.1h-24.1a12 12 0 0 1-11-7.1l-66.8-150.2V758c0 6.6-5.4 12-12 12H383c-6.6 0-12-5.4-12-12V486c0-6.6 5.4-12 12-12h35c4.8 0 9.1 2.8 11 7.2l83.2 191 83.1-191c1.9-4.4 6.2-7.2 11-7.2z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0 0 11 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z'
    ]);
});
exports.FilePdfTwoTone = getIcon('file-pdf', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M509.2 490.8c-.7-1.3-1.4-1.9-2.2-2-2.9 3.3-2.2 31.5 2.7 51.4 4-13.6 4.7-40.5-.5-49.4zm-1.6 120.5c-7.7 20-18.8 47.3-32.1 71.4 4-1.6 8.1-3.3 12.3-5 17.6-7.2 37.3-15.3 58.9-20.2-14.9-11.8-28.4-27.7-39.1-46.2z'
    ], [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm55 287.6c16.1-1.9 30.6-2.8 44.3-2.3 12.8.4 23.6 2 32 5.1.2.1.3.1.5.2.4.2.8.3 1.2.5.5.2 1.1.4 1.6.7.1.1.3.1.4.2 4.1 1.8 7.5 4 10.1 6.6 9.1 9.1 11.8 26.1 6.2 39.6-3.2 7.7-11.7 20.5-33.3 20.5-21.8 0-53.9-9.7-82.1-24.8-25.5 4.3-53.7 13.9-80.9 23.1-5.8 2-11.8 4-17.6 5.9-38 65.2-66.5 79.4-84.1 79.4-4.2 0-7.8-.9-10.8-2-6.9-2.6-12.8-8-16.5-15-.9-1.7-1.6-3.4-2.2-5.2-1.6-4.8-2.1-9.6-1.3-13.6l.6-2.7c.1-.2.1-.4.2-.6.2-.7.4-1.4.7-2.1 0-.1.1-.2.1-.3 4.1-11.9 13.6-23.4 27.7-34.6 12.3-9.8 27.1-18.7 45.9-28.4 15.9-28 37.6-75.1 51.2-107.4-10.8-41.8-16.7-74.6-10.1-98.6.9-3.3 2.5-6.4 4.6-9.1.2-.2.3-.4.5-.6.1-.1.1-.2.2-.2 6.3-7.5 16.9-11.9 28.1-11.5 16.6.7 29.7 11.5 33 30.1 1.7 8 2.2 16.5 1.9 25.7v.7c0 .5 0 1-.1 1.5-.7 13.3-3 26.6-7.3 44.7-.4 1.6-.8 3.2-1.2 5.2l-1 4.1-.1.3c.1.2.1.3.2.5l1.8 4.5c.1.3.3.7.4 1 .7 1.6 1.4 3.3 2.1 4.8v.1c8.7 18.8 19.7 33.4 33.9 45.1 4.3 3.5 8.9 6.7 13.9 9.8 1.8-.5 3.5-.7 5.3-.9z'
    ], [
        secondaryColor,
        'M391.5 761c5.7-4.4 16.2-14.5 30.1-34.7-10.3 9.4-23.4 22.4-30.1 34.7zm270.9-83l.2-.3h.2c.6-.4.5-.7.4-.9-.1-.1-4.5-9.3-45.1-7.4 35.3 13.9 43.5 9.1 44.3 8.6z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M535.9 585.3c-.8-1.7-1.5-3.3-2.2-4.9-.1-.3-.3-.7-.4-1l-1.8-4.5c-.1-.2-.1-.3-.2-.5l.1-.3.2-1.1c4-16.3 8.6-35.3 9.4-54.4v-.7c.3-8.6-.2-17.2-2-25.6-3.8-21.3-19.5-29.6-32.9-30.2-11.3-.5-21.8 4-28.1 11.4-.1.1-.1.2-.2.2-.2.2-.4.4-.5.6-2.1 2.7-3.7 5.8-4.6 9.1-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.4-51.2 107.4v.1c-27.7 14.3-64.1 35.8-73.6 62.9 0 .1-.1.2-.1.3-.2.7-.5 1.4-.7 2.1-.1.2-.1.4-.2.6-.2.9-.5 1.8-.6 2.7-.9 4-.4 8.8 1.3 13.6.6 1.8 1.3 3.5 2.2 5.2 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-2.6-2.6-6-4.8-10.1-6.6-.1-.1-.3-.1-.4-.2-.5-.2-1.1-.4-1.6-.7-.4-.2-.8-.3-1.2-.5-.2-.1-.3-.1-.5-.2-16.2-5.8-41.7-6.7-76.3-2.8l-5.3.6c-5-3-9.6-6.3-13.9-9.8-14.2-11.3-25.1-25.8-33.8-44.7zM391.5 761c6.7-12.3 19.8-25.3 30.1-34.7-13.9 20.2-24.4 30.3-30.1 34.7zM507 488.8c.8.1 1.5.7 2.2 2 5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4zm-19.2 188.9c-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4 10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2zm175.4-.9c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4z'
    ]);
});
exports.FilePptTwoTone = getIcon('file-ppt', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M464.5 516.2v108.4h38.9c44.7 0 71.2-10.9 71.2-54.3 0-34.4-20.1-54.1-53.9-54.1h-56.2z'
    ], [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm90 218.4c0 55.2-36.8 94.1-96.2 94.1h-63.3V760c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V484c0-4.4 3.6-8 8-8v.1h104c59.7 0 96 39.8 96 94.3z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M424 476.1c-4.4-.1-8 3.5-8 7.9v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.2c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1z'
    ]);
});
exports.FileTextTwoTone = getIcon('file-text', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-22 322c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm200-184v48c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8zm192 128H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
    ]);
});
exports.FileUnknownTwoTone = getIcon('file-unknown', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-22 424c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm110-228.4c.7 44.9-29.7 84.5-74.3 98.9-5.7 1.8-9.7 7.3-9.7 13.3V672c0 5.5-4.5 10-10 10h-32c-5.5 0-10-4.5-10-10v-32c.2-19.8 15.4-37.3 34.7-40.1C549 596.2 570 574.3 570 549c0-28.1-25.8-51.5-58-51.5s-58 23.4-58 51.6c0 5.2-4.4 9.4-9.8 9.4h-32.4c-5.4 0-9.8-4.1-9.8-9.5 0-57.4 50.1-103.7 111.5-103 59.3.8 107.7 46.1 108.5 101.6z'
    ], [
        primaryColor,
        'M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M480 744a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-78-195c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103z'
    ]);
});
exports.FileZipTwoTone = getIcon('file-zip', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M344 630h32v2h-32z'], [
        secondaryColor,
        'M534 352V136H360v64h64v64h-64v64h64v64h-64v64h64v64h-64v62h64v160H296V520h64v-64h-64v-64h64v-64h-64v-64h64v-64h-64v-64h-64v752h560V394H576a42 42 0 0 1-42-42z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h64v64h64v-64h174v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M296 392h64v64h-64zm0-128h64v64h-64zm0 318v160h128V582h-64v-62h-64v62zm48 50v-2h32v64h-32v-62zm16-432h64v64h-64zm0 256h64v64h-64zm0-128h64v64h-64z'
    ]);
});
exports.FileWordTwoTone = getIcon('file-word', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm101.3 129.3c1.3-5.4 6.1-9.3 11.7-9.3h35.6a12.04 12.04 0 0 1 11.6 15.1l-74.4 276c-1.4 5.3-6.2 8.9-11.6 8.9h-31.8c-5.4 0-10.2-3.7-11.6-8.9l-52.8-197-52.8 197c-1.4 5.3-6.2 8.9-11.6 8.9h-32c-5.4 0-10.2-3.7-11.6-8.9l-74.2-276a12.02 12.02 0 0 1 11.6-15.1h35.4c5.6 0 10.4 3.9 11.7 9.3L434.6 680l49.7-198.9c1.3-5.4 6.1-9.1 11.6-9.1h32.2c5.5 0 10.3 3.7 11.6 9.1l49.8 199.3 45.8-199.1z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 0 0-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 0 0-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z'
    ]);
});
exports.FileTwoTone = getIcon('file', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42z'], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ]);
});
exports.FilterTwoTone = getIcon('filter', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M420.6 798h182.9V642H420.6zM411 561.4l9.5 16.6h183l9.5-16.6L811.3 226H212.7z'
    ], [
        primaryColor,
        'M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V642h182.9v156zm9.5-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z'
    ]);
});
exports.FireTwoTone = getIcon('fire', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M737 438.6c-9.6 15.5-21.1 30.7-34.4 45.6a73.1 73.1 0 0 1-51 24.4 73.36 73.36 0 0 1-53.4-18.8 74.01 74.01 0 0 1-24.4-59.8c3-47.4-12.4-103.1-45.8-165.7-16.9-31.4-37.1-58.2-61.2-80.4a240 240 0 0 1-12.1 46.5 354.26 354.26 0 0 1-58.2 101 349.6 349.6 0 0 1-58.6 56.8c-34 26.1-62 60-80.8 97.9a275.96 275.96 0 0 0-29.1 124c0 74.9 29.5 145.3 83 198.4 53.7 53.2 125 82.4 201 82.4s147.3-29.2 201-82.4c53.5-53 83-123.5 83-198.4 0-39.2-8.1-77.3-24-113.1-9.3-21-21-40.5-35-58.4z'
    ], [
        primaryColor,
        'M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0 0 58.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0 0 12.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0 0 24.4 59.8 73.36 73.36 0 0 0 53.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z'
    ]);
});
exports.FolderAddTwoTone = getIcon('folder-add', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M372.5 256H184v512h656V370.4H492.1L372.5 256zM540 443.1V528h84.5c4.1 0 7.5 3.1 7.5 7v42c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1z'
    ], [
        primaryColor,
        'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'
    ], [
        primaryColor,
        'M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1z'
    ]);
});
exports.FlagTwoTone = getIcon('flag', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M184 232h368v336H184z'], [secondaryColor, 'M624 632c0 4.4-3.6 8-8 8H504v73h336V377H624v255z'], [
        primaryColor,
        'M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z'
    ]);
});
exports.FolderTwoTone = getIcon('folder', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'
    ], [secondaryColor, 'M372.5 256H184v512h656V370.4H492.1z']);
});
exports.FolderOpenTwoTone = getIcon('folder-open', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M159 768h612.3l103.4-256H262.3z'], [
        primaryColor,
        'M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z'
    ]);
});
exports.FrownTwoTone = getIcon('frown', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 0 1-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 0 1-8 8.4zm24-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
    ], [
        primaryColor,
        'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm224 112c-85.5 0-155.6 67.3-160 151.6a8 8 0 0 0 8 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4 3.7-49.5 45.3-88.6 95.8-88.6s92 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 0 0 8-8.4C667.6 600.3 597.5 533 512 533zm128-112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'
    ]);
});
exports.FundTwoTone = getIcon('fund', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z'
    ], [
        secondaryColor,
        'M136 792h752V232H136v560zm56.4-130.5l214.9-215c3.1-3.1 8.2-3.1 11.3 0L533 561l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.1 3.1 3.1 8.2 0 11.3l-297 297.2a8.03 8.03 0 0 1-11.3 0L412.9 537.2 240.4 709.7a8.03 8.03 0 0 1-11.3 0l-36.7-36.9a8.03 8.03 0 0 1 0-11.3z'
    ], [
        primaryColor,
        'M229.1 709.7c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 0 0-11.3 0L533 561 418.6 446.5a8.03 8.03 0 0 0-11.3 0l-214.9 215a8.03 8.03 0 0 0 0 11.3l36.7 36.9z'
    ]);
});
exports.FunnelPlotTwoTone = getIcon('funnel-plot', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M420.6 798h182.9V650H420.6zM297.7 374h428.6l85-148H212.7zm113.2 197.4l8.4 14.6h185.3l8.4-14.6L689.6 438H334.4z'
    ], [
        primaryColor,
        'M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V650h182.9v148zm9.5-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z'
    ]);
});
exports.GiftTwoTone = getIcon('gift', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M546 378h298v104H546zM228 550h250v308H228zm-48-172h298v104H180zm366 172h250v308H546z'
    ], [
        primaryColor,
        'M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zM478 858H228V550h250v308zm0-376H180V378h298v104zm0-176h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm68-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm250 622H546V550h250v308zm48-376H546V378h298v104z'
    ]);
});
exports.HddTwoTone = getIcon('hdd', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M232 888h560V680H232v208zm448-140c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 616h560V408H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48zm-72-144h560V136H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48z'
    ], [
        primaryColor,
        'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z'
    ], [
        primaryColor,
        'M312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-272h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 516a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'
    ]);
});
exports.HeartTwoTone = getIcon('heart', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z'
    ], [
        secondaryColor,
        'M679.7 201c-73.1 0-136.5 40.8-167.7 100.4C480.8 241.8 417.4 201 344.3 201c-104 0-188.3 82.6-188.3 184.5 0 201.2 356 429.3 356 429.3s356-228.1 356-429.3C868 283.6 783.7 201 679.7 201z'
    ]);
});
exports.HighlightTwoTone = getIcon('highlight', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M229.6 796.3h160.2l54.3-54.1-80.1-78.9zm220.7-397.1l262.8 258.9 147.3-145-262.8-259zm-77.1 166.1l171.4 168.9 68.6-67.6-171.4-168.9z'
    ], [
        primaryColor,
        'M957.6 507.5L603.2 158.3a7.9 7.9 0 0 0-11.2 0L353.3 393.5a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8v55.2c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6L539 830a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.3H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.3l68.6-67.6 171.4 168.9-68.6 67.6zm168.5-76.1L450.3 399.2l147.3-145.1 262.8 259-147.3 145z'
    ]);
});
exports.HomeTwoTone = getIcon('home', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512.1 172.6l-370 369.7h96V868H392V640c0-22.1 17.9-40 40-40h160c22.1 0 40 17.9 40 40v228h153.9V542.3H882L535.2 195.7l-23.1-23.1zm434.5 422.9c-6 6-13.1 10.8-20.8 13.9 7.7-3.2 14.8-7.9 20.8-13.9zm-887-34.7c5 30.3 31.4 53.5 63.1 53.5h.9c-31.9 0-58.9-23-64-53.5zm-.9-10.5v-1.9 1.9zm.1-2.6c.1-3.1.5-6.1 1-9.1-.6 2.9-.9 6-1 9.1z'
    ], [
        primaryColor,
        'M951 510c0-.1-.1-.1-.1-.2l-1.8-2.1c-.1-.1-.2-.3-.4-.4-.7-.8-1.5-1.6-2.2-2.4L560.1 118.8l-25.9-25.9a31.5 31.5 0 0 0-44.4 0L77.5 505a63.6 63.6 0 0 0-16 26.6l-.6 2.1-.3 1.1-.3 1.2c-.2.7-.3 1.4-.4 2.1 0 .1 0 .3-.1.4-.6 3-.9 6-1 9.1v3.3c0 .5 0 1 .1 1.5 0 .5 0 .9.1 1.4 0 .5.1 1 .1 1.5 0 .6.1 1.2.2 1.8 0 .3.1.6.1.9l.3 2.5v.1c5.1 30.5 32.2 53.5 64 53.5h42.5V940h691.7V614.3h43.4c8.6 0 16.9-1.7 24.5-4.9s14.7-7.9 20.8-13.9a63.6 63.6 0 0 0 18.7-45.3c0-14.7-5-28.8-14.3-40.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z'
    ]);
});
exports.HourglassTwoTone = getIcon('hourglass', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 548c-42.2 0-81.9 16.4-111.7 46.3A156.63 156.63 0 0 0 354 706v134h316V706c0-42.2-16.4-81.9-46.3-111.7A156.63 156.63 0 0 0 512 548zM354 318c0 42.2 16.4 81.9 46.3 111.7C430.1 459.6 469.8 476 512 476s81.9-16.4 111.7-46.3C653.6 399.9 670 360.2 670 318V184H354v134z'
    ], [
        primaryColor,
        'M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 0 1 354 318V184h316v134z'
    ]);
});
exports.Html5TwoTone = getIcon('html5', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2z'
    ], [
        secondaryColor,
        'M209.9 155.4l56.7 641.2 245.2 69.6 244.1-69.6 57.8-641.2H209.9zm530.4 117.9l-4.8 47.2-1.7 19.5H381.7l8.2 94.2H511v-.2h214.7l-3.2 24.3-21.2 242.2-1.7 16.3-187.7 51.7v.4h-1.7l-188.6-52-11.3-144.7h91l6.5 73.2 102.4 27.7h.8v-.2l102.4-27.7 11.4-118.5H511.9v.1H305.4l-22.7-253.5L281 249h461l-1.7 24.3z'
    ], [
        primaryColor,
        'M281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z'
    ]);
});
exports.IdcardTwoTone = getIcon('idcard', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z'
    ], [
        secondaryColor,
        'M136 792h752V232H136v560zm472-372c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm0 144c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48c0 4.4-3.2 8-7.1 8H615.1c-3.9 0-7.1-3.6-7.1-8v-48zM216.2 664.6c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.6 26.4 71.8 72.8 74.6 126.1a8 8 0 0 1-8 8.4h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224c-4.6 0-8.2-3.8-7.8-8.4z'
    ], [
        secondaryColor,
        'M321.3 463a51.7 52 0 1 0 103.4 0 51.7 52 0 1 0-103.4 0z'
    ], [
        primaryColor,
        'M610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z'
    ]);
});
exports.InfoCircleTwoTone = getIcon('info-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm32 588c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
    ], [
        primaryColor,
        'M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z'
    ]);
});
exports.InsuranceTwoTone = getIcon('insurance', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'
    ], [secondaryColor, 'M521.9 358.8h97.9v41.6h-97.9z'], [
        secondaryColor,
        'M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM413.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 0 1-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 0 1-33.6 79V656zm257.9-340v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5l-26.3 35.3a5.92 5.92 0 0 1-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a6.38 6.38 0 0 1-4.8 1.4c-1.7-.3-3.2-1.3-4.1-2.8L432 605.7a6 6 0 0 1 1.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8z'
    ], [
        primaryColor,
        'M443.7 306.9l-38.6-18.3c-3.4-1.6-7.3.2-8.4 3.7-17.5 58.5-45.2 110.2-82.2 153.6a5.7 5.7 0 0 0-1.2 5.6l13.2 43.5c1.4 4.5 7 5.8 10.2 2.4 7.7-8.1 15.4-16.8 23.1-26V656c0 4.4 3.6 8 8 8h37.3c4.4 0 8-3.6 8-8h.2V393.1a429.2 429.2 0 0 0 33.6-79c.9-2.8-.5-5.9-3.2-7.2zm26.8 9.1v127.4c0 4.4 3.6 8 8 8h65.9V470h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 0 0-1.6 8.1l22.8 36.5c.9 1.5 2.4 2.5 4.1 2.8 1.7.3 3.5-.2 4.8-1.4 31.6-26.8 58.6-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V535.9c21.3 41.7 47.5 77.6 78.1 106.9 2.6 2.5 6.7 2.2 8.9-.7l26.3-35.3c2-2.6 1.4-6.4-1.2-8.5-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8v-35.6c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H478.5c-4.4 0-8 3.6-8 8zm51.4 42.8h97.9v41.6h-97.9v-41.6z'
    ]);
});
exports.InteractionTwoTone = getIcon('interaction', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm114-401.9c0-55.3 44.6-100.1 99.7-100.1h205.8v-53.4c0-5.6 6.5-8.8 10.9-5.3L723.5 365c3.5 2.7 3.5 8 0 10.7l-109.1 85.7c-4.4 3.5-10.9.4-10.9-5.3v-53.4H397.8c-19.6 0-35.5 15.9-35.5 35.6v78.9c0 3.8-3.1 6.8-6.8 6.8h-50.7c-3.8 0-6.8-3-6.8-7v-78.9zm2.6 210.3l109.1-85.7c4.4-3.5 10.9-.4 10.9 5.3v53.4h205.6c19.6 0 35.5-15.9 35.5-35.6v-78.9c0-3.8 3.1-6.8 6.8-6.8h50.7c3.8 0 6.8 3.1 6.8 6.8v78.9c0 55.3-44.6 100.1-99.7 100.1H420.6v53.4c0 5.6-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.5z'
    ], [
        primaryColor,
        'M304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z'
    ]);
});
exports.InterationTwoTone = getIcon('interation', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm114-401.9c0-55.3 44.6-100.1 99.7-100.1h205.8v-53.4c0-5.6 6.5-8.8 10.9-5.3L723.5 365c3.5 2.7 3.5 8 0 10.7l-109.1 85.7c-4.4 3.5-10.9.4-10.9-5.3v-53.4H397.8c-19.6 0-35.5 15.9-35.5 35.6v78.9c0 3.8-3.1 6.8-6.8 6.8h-50.7c-3.8 0-6.8-3-6.8-7v-78.9zm2.6 210.3l109.1-85.7c4.4-3.5 10.9-.4 10.9 5.3v53.4h205.6c19.6 0 35.5-15.9 35.5-35.6v-78.9c0-3.8 3.1-6.8 6.8-6.8h50.7c3.8 0 6.8 3.1 6.8 6.8v78.9c0 55.3-44.6 100.1-99.7 100.1H420.6v53.4c0 5.6-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.5z'
    ], [
        primaryColor,
        'M304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z'
    ]);
});
exports.LayoutTwoTone = getIcon('layout', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M384 185h456v136H384zm-200 0h136v656H184zm696-73H144c-17.7 0-32 14.3-32 32v1c0-17.7 14.3-32 32-32h736c17.7 0 32 14.3 32 32v-1c0-17.7-14.3-32-32-32zM384 385h456v456H384z'
    ], [
        primaryColor,
        'M880 113H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V145c0-17.7-14.3-32-32-32zM320 841H184V185h136v656zm520 0H384V385h456v456zm0-520H384V185h456v136z'
    ]);
});
exports.LeftCircleTwoTone = getIcon('left-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm104 240.9c0 10.3-4.9 19.9-13.2 25.9L457.4 512l145.4 105.1c8.3 6 13.2 15.7 13.2 25.9v46.9c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9z'
    ], [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        primaryColor,
        'M603.3 327.5l-246 178a7.95 7.95 0 0 0 0 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z'
    ]);
});
exports.LeftSquareTwoTone = getIcon('left-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm181.3-334.5l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9c0 10.3-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.7 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.4l-246-178a7.95 7.95 0 0 1 0-12.9z'
    ], [
        primaryColor,
        'M365.3 518.4l246 178c5.3 3.9 12.7.1 12.7-6.4v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a7.95 7.95 0 0 0 0 12.9z'
    ]);
});
exports.LikeTwoTone = getIcon('like', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M273 495.9v428l.3-428zm538.2-88.3H496.8l9.6-198.4c.6-11.9-4.7-23.1-14.6-30.5-6.1-4.5-13.6-6.8-21.1-6.7-19.6.1-36.9 13.4-42.2 32.3-37.1 134.4-64.9 235.2-83.5 302.5V852h399.4a56.85 56.85 0 0 0 33.6-51.8c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0 0 19.6-43c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0 0 19.6-43c0-9.7-2.3-18.9-6.9-27.3l-14-25.5 21.9-19a56.76 56.76 0 0 0 19.6-43c0-19.1-11-37.5-28.8-48.4z'
    ], [
        primaryColor,
        'M112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32zm773.9 5.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.5-65.5-111a67.67 67.67 0 0 0-34.3-9.3H572.3l6-122.9c1.5-29.7-9-57.9-29.5-79.4a106.4 106.4 0 0 0-77.9-33.4c-52 0-98 35-111.8 85.1l-85.8 310.8-.3 428h472.1c9.3 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37zM820.4 499l-21.9 19 14 25.5a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 22.4-13.2 42.6-33.6 51.8H345V506.8c18.6-67.2 46.4-168 83.5-302.5a44.28 44.28 0 0 1 42.2-32.3c7.5-.1 15 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.1 32.2-19.6 43z'
    ]);
});
exports.LockTwoTone = getIcon('lock', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304z'
    ], [
        secondaryColor,
        'M232 840h560V536H232v304zm280-226a48.01 48.01 0 0 1 28 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0 1 28-87z'
    ], [
        primaryColor,
        'M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z'
    ]);
});
exports.MailTwoTone = getIcon('mail', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M477.5 536.3L135.9 270.7l-27.5-21.4 27.6 21.5V792h752V270.8L546.2 536.3a55.99 55.99 0 0 1-68.7 0z'
    ], [secondaryColor, 'M876.3 198.8l39.3 50.5-27.6 21.5 27.7-21.5-39.3-50.5z'], [
        primaryColor,
        'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-94.5 72.1L512 482 190.5 232.1h643zm54.5 38.7V792H136V270.8l-27.6-21.5 27.5 21.4 341.6 265.6a55.99 55.99 0 0 0 68.7 0L888 270.8l27.6-21.5-39.3-50.5h.1l39.3 50.5-27.7 21.5z'
    ]);
});
exports.MedicineBoxTwoTone = getIcon('medicine-box', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M244.3 328L184 513.4V840h656V513.4L779.7 328H244.3zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48z'
    ], [
        primaryColor,
        'M652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
    ], [
        primaryColor,
        'M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840z'
    ]);
});
exports.MehTwoTone = getIcon('meh', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
    ], [
        primaryColor,
        'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm376 144H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-24-144a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'
    ]);
});
exports.MessageTwoTone = getIcon('message', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M775.3 248.9a369.62 369.62 0 0 0-119-80A370.2 370.2 0 0 0 512.1 140h-1.7c-99.7.4-193 39.4-262.8 109.9-69.9 70.5-108 164.1-107.6 263.8.3 60.3 15.3 120.2 43.5 173.1l4.5 8.4V836h140.8l8.4 4.5c52.9 28.2 112.8 43.2 173.1 43.5h1.7c99 0 192-38.2 262.1-107.6 70.4-69.8 109.5-163.1 110.1-262.7.2-50.6-9.5-99.6-28.9-145.8a370.15 370.15 0 0 0-80-119zM312 560a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zm200 0a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zm200 0a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
    ], [
        primaryColor,
        'M664 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'
    ], [
        primaryColor,
        'M925.2 338.4c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z'
    ], [primaryColor, 'M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0z']);
});
exports.MinusCircleTwoTone = getIcon('minus-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z'
    ], [
        primaryColor,
        'M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
    ]);
});
exports.MinusSquareTwoTone = getIcon('minus-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48z'
    ], [
        primaryColor,
        'M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
    ]);
});
exports.MobileTwoTone = getIcon('mobile', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M744 64H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H288V136h448v752z'
    ], [
        secondaryColor,
        'M288 888h448V136H288v752zm224-142c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
    ], [primaryColor, 'M472 786a40 40 0 1 0 80 0 40 40 0 1 0-80 0z']);
});
exports.PauseCircleTwoTone = getIcon('pause-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-80 524c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z'
    ], [
        primaryColor,
        'M424 352h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z'
    ]);
});
exports.MoneyCollectTwoTone = getIcon('money-collect', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M256 744.4l256 93.1 256-93.1V184H256v560.4zM359.7 313c1.2-.7 2.5-1 3.8-1h55.7a8 8 0 0 1 7.1 4.4L511 485.2h3.3L599 316.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8L564 515.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V704c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 323.8c-2.1-3.8-.7-8.7 3.2-10.8z'
    ], [
        primaryColor,
        'M911.5 700.7a8 8 0 0 0-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM768 744.4l-256 93.1-256-93.1V184h512v560.4z'
    ], [
        primaryColor,
        'M460.4 515.4h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6z'
    ]);
});
exports.NotificationTwoTone = getIcon('notification', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M229.6 678.1c-3.7 11.6-5.6 23.9-5.6 36.4 0-12.5 2-24.8 5.7-36.4h-.1zm76.3-260.2H184v188.2h121.9l12.9 5.2L840 820.7V203.3L318.8 412.7z'
    ], [
        primaryColor,
        'M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z'
    ]);
});
exports.PhoneTwoTone = getIcon('phone', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M721.7 184.9L610.9 295.8l120.8 120.7-8 21.6A481.29 481.29 0 0 1 438 723.9l-21.6 8-.9-.9-119.8-120-110.8 110.9 104.5 104.5c10.8 10.7 26 15.7 40.8 13.2 117.9-19.5 235.4-82.9 330.9-178.4s158.9-213.1 178.4-331c2.5-14.8-2.5-30-13.3-40.8L721.7 184.9z'
    ], [
        primaryColor,
        'M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 0 1-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 0 0-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 0 0 285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z'
    ]);
});
exports.PictureTwoTone = getIcon('picture', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z'
    ], [
        secondaryColor,
        'M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z'
    ], [
        secondaryColor,
        'M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 1 1 0 176 88 88 0 0 1 0-176z'
    ], [secondaryColor, 'M276 368a28 28 0 1 0 56 0 28 28 0 1 0-56 0z'], [
        primaryColor,
        'M304 456a88 88 0 1 0 0-176 88 88 0 0 0 0 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z'
    ]);
});
exports.PlayCircleTwoTone = getIcon('play-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm164.1 378.2L457.7 677.1a8.02 8.02 0 0 1-12.7-6.5V353a8 8 0 0 1 12.7-6.5l218.4 158.8a7.9 7.9 0 0 1 0 12.9z'
    ], [
        primaryColor,
        'M676.1 505.3L457.7 346.5A8 8 0 0 0 445 353v317.6a8.02 8.02 0 0 0 12.7 6.5l218.4-158.9a7.9 7.9 0 0 0 0-12.9z'
    ]);
});
exports.PlaySquareTwoTone = getIcon('play-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm240-484.7c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 0 1 0 17.6L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3z'
    ], [
        primaryColor,
        'M442.3 677.6l199.4-156.8a11.2 11.2 0 0 0 0-17.6L442.3 346.5c-7.4-5.9-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.6 18.3 8.8z'
    ]);
});
exports.PieChartTwoTone = getIcon('pie-chart', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M316.2 920.5c-47.6-20.1-90.4-49-127.1-85.7a398.19 398.19 0 0 1-85.7-127.1A397.12 397.12 0 0 1 72 552.2v.2a398.57 398.57 0 0 0 117 282.5c36.7 36.7 79.4 65.5 127 85.6A396.64 396.64 0 0 0 471.6 952c27 0 53.6-2.7 79.7-7.9-25.9 5.2-52.4 7.8-79.3 7.8-54 .1-106.4-10.5-155.8-31.4zM560 472c-4.4 0-8-3.6-8-8V79.9c0-1.3.3-2.5.9-3.6-.9 1.3-1.5 2.9-1.5 4.6v383.7c0 4.4 3.6 8 8 8l383.6-1c1.6 0 3.1-.5 4.4-1.3-1 .5-2.2.7-3.4.7l-384 1z'
    ], [
        secondaryColor,
        'M619.8 147.6v256.6l256.4-.7c-13-62.5-44.3-120.5-90-166.1a332.24 332.24 0 0 0-166.4-89.8z'
    ], [
        secondaryColor,
        'M438 221.7c-75.9 7.6-146.2 40.9-200.8 95.5C174.5 379.9 140 463.3 140 552s34.5 172.1 97.2 234.8c62.3 62.3 145.1 96.8 233.2 97.2 88.2.4 172.7-34.1 235.3-96.2C761 733 794.6 662.3 802.3 586H438V221.7z'
    ], [
        primaryColor,
        'M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 0 0-282.8 117.1 398.19 398.19 0 0 0-85.7 127.1A397.61 397.61 0 0 0 72 552v.2c0 53.9 10.6 106.2 31.4 155.5 20.1 47.6 49 90.4 85.7 127.1 36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 0 0 472 952c26.9 0 53.4-2.6 79.3-7.8 26.1-5.3 51.7-13.1 76.4-23.6 47.6-20.1 90.4-49 127.1-85.7 36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 0 0 872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 0 1 470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552s34.5-172.1 97.2-234.8c54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8z'
    ], [
        primaryColor,
        'M952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 0 0 589 74.6L560.7 72c-3.4-.3-6.4 1.5-7.8 4.3a8.7 8.7 0 0 0-.9 3.6V464c0 4.4 3.6 8 8 8l384-1c1.2 0 2.3-.3 3.4-.7a8.1 8.1 0 0 0 4.6-7.9zm-332.2-58.2V147.6a332.24 332.24 0 0 1 166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z'
    ]);
});
exports.PlusCircleTwoTone = getIcon('plus-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z'
    ], [
        primaryColor,
        'M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
    ]);
});
exports.PlusSquareTwoTone = getIcon('plus-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48z'
    ], [
        primaryColor,
        'M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
    ]);
});
exports.PoundCircleTwoTone = getIcon('pound-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm146 582.1c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 0 1-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8v39.8z'
    ], [
        primaryColor,
        'M650 674.3H470v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.8-5.3-41h98.6c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8h-112c-7.2-22.6-13.4-45.8-13.4-70.5 0-43.6 34-70.2 87.3-70.2 21.4 0 42.5 4.1 60.4 10.5a8 8 0 0 0 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.9-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.4 6.8 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.2c3.4 14.8 5.9 29.5 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8v38.5c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z'
    ]);
});
exports.PrinterTwoTone = getIcon('printer', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M360 180h304v152H360zm492 220H172c-6.6 0-12 5.4-12 12v292h132V500h440v204h132V412c0-6.6-5.4-12-12-12zm-24 84c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z'
    ], [
        primaryColor,
        'M852 332H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z'
    ], [
        primaryColor,
        'M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8z'
    ]);
});
exports.ProfileTwoTone = getIcon('profile', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm300-496c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zM380 328c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
    ], [
        primaryColor,
        'M340 656a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm152 320h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
    ]);
});
exports.ProjectTwoTone = getIcon('project', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm472-560c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280z'
    ], [
        primaryColor,
        'M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8z'
    ]);
});
exports.PushpinTwoTone = getIcon('pushpin', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M474.8 357.7l-24.5 24.5-34.4-3.8c-9.6-1.1-19.3-1.6-28.9-1.6-29 0-57.5 4.7-84.7 14.1-14 4.8-27.4 10.8-40.3 17.9l353.1 353.3a259.92 259.92 0 0 0 30.4-153.9l-3.8-34.4 24.5-24.5L800 415.5 608.5 224 474.8 357.7z'
    ], [
        primaryColor,
        'M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 0 0-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 0 1-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z'
    ]);
});
exports.PropertySafetyTwoTone = getIcon('property-safety', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'
    ], [
        secondaryColor,
        'M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM593.9 318h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3L585 323.5a10 10 0 0 1 8.9-5.5z'
    ], [
        primaryColor,
        'M438.9 323.5a9.88 9.88 0 0 0-8.9-5.5h-46c-1.7 0-3.3.4-4.8 1.2-4.9 2.7-6.6 8.8-4 13.6l88 161.1H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1c.8-1.5 1.2-3.1 1.1-4.8 0-5.5-4.5-10-10-10h-45a10 10 0 0 0-8.9 5.5l-73.2 144.3-72.9-144.3z'
    ]);
});
exports.QuestionCircleTwoTone = getIcon('question-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm0 632c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 0 0-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z'
    ], [
        primaryColor,
        'M472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm151.6-415.3C593.6 290.5 554 276 512 276s-81.6 14.4-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.2 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5 0-39.3-17.2-76-48.4-103.3z'
    ]);
});
exports.ReconciliationTwoTone = getIcon('reconciliation', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M740 344H404V240H304v160h176c17.7 0 32 14.3 32 32v360h328V240H740v104zM584 448c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56zm92 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-341v96c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z'
    ], [secondaryColor, 'M642 657a34 34 0 1 0 68 0 34 34 0 1 0-68 0z'], [
        primaryColor,
        'M592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm112-104v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z'
    ], [
        primaryColor,
        'M880 168H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552z'
    ], [
        primaryColor,
        'M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z'
    ]);
});
exports.RedEnvelopeTwoTone = getIcon('red-envelope', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z'
    ], [
        secondaryColor,
        'M492.3 397.2L232 193.1V888h560V193.1L531.8 397.2a31.99 31.99 0 0 1-39.5 0zm99.4 60.9h47.8a8.45 8.45 0 0 1 7.4 12.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4V665c0 4.6-3.8 8.4-8.4 8.4h-63.3V702h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.7-3.5 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4L377 470.4a8.4 8.4 0 0 1 3.4-11.4c1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.7 142 71.9-141.9a8.6 8.6 0 0 1 7.5-4.6z'
    ], [secondaryColor, 'M232 136.7h31.7L512 331.3l248.3-194.6H792v-.7H232z'], [
        primaryColor,
        'M440.6 462.6a8.38 8.38 0 0 0-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 0 0-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 0 0-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142z'
    ]);
});
exports.RestTwoTone = getIcon('rest', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M326.4 844h363.2l44.3-520H282l44.4 520zM508 416c79.5 0 144 64.5 144 144s-64.5 144-144 144-144-64.5-144-144 64.5-144 144-144z'
    ], [
        primaryColor,
        'M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z'
    ], [
        primaryColor,
        'M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z'
    ]);
});
exports.RightCircleTwoTone = getIcon('right-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm154.7 378.4l-246 178c-5.3 3.8-12.7 0-12.7-6.5V643c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9z'
    ], [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        primaryColor,
        'M666.7 505.5l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L566.6 512 421.2 617.1c-8.3 6-13.2 15.7-13.2 25.9v46.9c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.7 0-12.9z'
    ]);
});
exports.RocketTwoTone = getIcon('rocket', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M261.7 621.4c-9.4 14.6-17 30.3-22.5 46.6H324V558.7c-24.8 16.2-46 37.5-62.3 62.7zM700 558.7V668h84.8c-5.5-16.3-13.1-32-22.5-46.6a211.6 211.6 0 0 0-62.3-62.7zm-64-239.9l-124-147-124 147V668h248V318.8zM512 448a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
    ], [
        primaryColor,
        'M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zm-540-68h-84.8c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668zm64-184.9V318.8l124-147 124 147V668H388V483.1zm240.1 301.1c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM700 668V558.7a211.6 211.6 0 0 1 62.3 62.7c9.4 14.6 17 30.3 22.5 46.6H700z'
    ], [primaryColor, 'M464 400a48 48 0 1 0 96 0 48 48 0 1 0-96 0z']);
});
exports.RightSquareTwoTone = getIcon('right-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm216-196.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9l-246 178c-5.3 3.9-12.7.1-12.7-6.4v-46.9z'
    ], [
        primaryColor,
        'M412.7 696.4l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.7-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.4z'
    ]);
});
exports.SafetyCertificateTwoTone = getIcon('safety-certificate', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'
    ], [
        secondaryColor,
        'M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM632.8 328H688c6.5 0 10.3 7.4 6.5 12.7L481.9 633.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89.1 150.9-207.8c3-4.1 7.9-6.6 13-6.6z'
    ], [
        primaryColor,
        'M404.2 453.3c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z'
    ]);
});
exports.SaveTwoTone = getIcon('save', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M704 320c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V184H184v656h656V341.8l-136-136V320zM512 730c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144z'
    ], [
        primaryColor,
        'M512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z'
    ], [
        primaryColor,
        'M893.3 293.3L730.7 130.7c-.7-.7-1.4-1.3-2.1-2-.1-.1-.3-.2-.4-.3-.7-.7-1.5-1.3-2.2-1.9a64 64 0 0 0-22-11.7V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840z'
    ]);
});
exports.ScheduleTwoTone = getIcon('schedule', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.4-91.2l-165 228.7a15.9 15.9 0 0 1-25.8 0L493.5 531.3c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.4 12.9 6.6l52.8 73.1 103.6-143.7c3-4.1 7.8-6.6 12.8-6.5h54.9c6.5 0 10.3 7.4 6.5 12.7z'
    ], [
        primaryColor,
        'M724.2 454.6L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0 0 25.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
    ], [
        primaryColor,
        'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z'
    ], [
        primaryColor,
        'M416 632H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
    ]);
});
exports.SecurityScanTwoTone = getIcon('security-scan', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'
    ], [
        secondaryColor,
        'M460.7 451.1a80.1 80.1 0 1 0 160.2 0 80.1 80.1 0 1 0-160.2 0z'
    ], [
        secondaryColor,
        'M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zm428.7 122.5c56.3 56.3 56.3 147.5 0 203.8-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 0 1-11.3 0l-34-34a8.03 8.03 0 0 1 0-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0z'
    ], [
        primaryColor,
        'M418.8 527.8l-77.5 77.5a8.03 8.03 0 0 0 0 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.6 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 122.9-20.1 178.6zm65.4-133.3a80.1 80.1 0 0 1 113.3 0 80.1 80.1 0 0 1 0 113.3c-31.3 31.3-82 31.3-113.3 0s-31.3-82 0-113.3z'
    ]);
});
exports.SettingTwoTone = getIcon('setting', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M859.3 569.7l.2.1c3.1-18.9 4.6-38.2 4.6-57.3 0-17.1-1.3-34.3-3.7-51.1 2.4 16.7 3.6 33.6 3.6 50.5 0 19.4-1.6 38.8-4.7 57.8zM99 398.1c-.5-.4-.9-.8-1.4-1.3.7.7 1.4 1.4 2.2 2.1l65.5 55.9v-.1L99 398.1zm536.6-216h.1l-15.5-83.8c-.2-1-.4-1.9-.7-2.8.1.5.3 1.1.4 1.6l15.7 85zm54 546.5l31.4-25.8 92.8 32.9c17-22.9 31.3-47.5 42.6-73.6l-74.7-63.9 6.6-40.1c2.5-15.1 3.8-30.6 3.8-46.1s-1.3-31-3.8-46.1l-6.5-39.9 74.7-63.9c-11.4-26-25.6-50.7-42.6-73.6l-92.8 32.9-31.4-25.8c-23.9-19.6-50.6-35-79.3-45.8l-38.1-14.3-17.9-97a377.5 377.5 0 0 0-85 0l-17.9 97.2-37.9 14.3c-28.5 10.8-55 26.2-78.7 45.7l-31.4 25.9-93.4-33.2c-17 22.9-31.3 47.5-42.6 73.6l75.5 64.5-6.5 40c-2.5 14.9-3.7 30.2-3.7 45.5 0 15.2 1.3 30.6 3.7 45.5l6.5 40-75.5 64.5c11.4 26 25.6 50.7 42.6 73.6l93.4-33.2 31.4 25.9c23.7 19.5 50.2 34.9 78.7 45.7l37.8 14.5 17.9 97.2c28.2 3.2 56.9 3.2 85 0l17.9-97 38.1-14.3c28.8-10.8 55.4-26.2 79.3-45.8zm-177.1-50.3c-30.5 0-59.2-7.8-84.3-21.5C373.3 627 336 568.9 336 502c0-97.2 78.8-176 176-176 66.9 0 125 37.3 154.8 92.2 13.7 25 21.5 53.7 21.5 84.3 0 97.1-78.7 175.8-175.8 175.8zM207.2 812.8c-5.5 1.9-11.2 2.3-16.6 1.2 5.7 1.2 11.7 1 17.5-1l81.4-29c-.1-.1-.3-.2-.4-.3l-81.9 29.1zm717.6-414.7l-65.5 56c0 .2.1.5.1.7l65.4-55.9c7.1-6.1 11.1-14.9 11.2-24-.3 8.8-4.3 17.3-11.2 23.2z'
    ], [
        secondaryColor,
        'M935.8 646.6c.5 4.7 0 9.5-1.7 14.1l-.9 2.6a446.02 446.02 0 0 1-79.7 137.9l-1.8 2.1a32 32 0 0 1-35.1 9.5l-81.3-28.9a350 350 0 0 1-99.7 57.6l-15.7 85a32.05 32.05 0 0 1-25.8 25.7l-2.7.5a445.2 445.2 0 0 1-79.2 7.1h.3c26.7 0 53.4-2.4 79.4-7.1l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c1.6-4.7 2.1-9.7 1.5-14.5z'
    ], [
        primaryColor,
        'M688 502c0-30.3-7.7-58.9-21.2-83.8C637 363.3 578.9 326 512 326c-97.2 0-176 78.8-176 176 0 66.9 37.3 125 92.2 154.8 24.9 13.5 53.4 21.2 83.8 21.2 97.2 0 176-78.8 176-176zm-288 0c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 0 1 624 502c0 29.9-11.7 58-32.8 79.2A111.6 111.6 0 0 1 512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 502z'
    ], [
        primaryColor,
        'M594.1 952.2a32.05 32.05 0 0 0 25.8-25.7l15.7-85a350 350 0 0 0 99.7-57.6l81.3 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c1.7-4.6 2.2-9.4 1.7-14.1-.9-7.9-4.7-15.4-11-20.9l-65.3-55.9-.2-.1c3.1-19 4.7-38.4 4.7-57.8 0-16.9-1.2-33.9-3.6-50.5-.3-2.2-.7-4.4-1-6.6 0-.2-.1-.5-.1-.7l65.5-56c6.9-5.9 10.9-14.4 11.2-23.2.1-4-.5-8.1-1.9-12l-.9-2.6a443.74 443.74 0 0 0-79.7-137.9l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.3 28.9c-30-24.6-63.4-44-99.6-57.6h-.1l-15.7-85c-.1-.5-.2-1.1-.4-1.6a32.08 32.08 0 0 0-25.4-24.1l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.4a351.86 351.86 0 0 0-99 57.4l-81.9-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a446.02 446.02 0 0 0-79.7 137.9l-.9 2.6a32.09 32.09 0 0 0 7.9 33.9c.5.4.9.9 1.4 1.3l66.3 56.6v.1c-3.1 18.8-4.6 37.9-4.6 57 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1c4.9 5.7 11.4 9.4 18.5 10.7 5.4 1 11.1.7 16.6-1.2l81.9-29.1c.1.1.3.2.4.3 29.7 24.3 62.8 43.6 98.6 57.1l15.8 85.4a32.05 32.05 0 0 0 25.8 25.7l2.7.5c26.1 4.7 52.8 7.1 79.5 7.1h.3c26.6 0 53.3-2.4 79.2-7.1l2.7-.5zm-39.8-66.5a377.5 377.5 0 0 1-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 0 1-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97z'
    ]);
});
exports.ShopTwoTone = getIcon('shop', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M839.5 344h-655c-.3 0-.5.2-.5.5v91.2c0 59.8 49 108.3 109.3 108.3 40.7 0 76.2-22 95.1-54.7 2.9-5.1 8.4-8.3 14.3-8.3s11.3 3.2 14.3 8.3c18.8 32.7 54.3 54.7 95 54.7 40.8 0 76.4-22.1 95.1-54.9 2.9-5 8.2-8.1 13.9-8.1h.6c5.8 0 11 3.1 13.9 8.1 18.8 32.8 54.4 54.9 95.2 54.9C791 544 840 495.5 840 435.7v-91.2c0-.3-.2-.5-.5-.5z'
    ], [
        primaryColor,
        'M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234.4 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c3-1.3 6-2.6 9-4v242.2zM840 435.7c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 0 1 512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 0 1-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z'
    ]);
});
exports.ShoppingTwoTone = getIcon('shopping', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M696 472c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88H400v88c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88h-96v456h560V384h-96v88z'
    ], [
        primaryColor,
        'M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z'
    ]);
});
exports.SkinTwoTone = getIcon('skin', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 318c-79.2 0-148.5-48.8-176.7-120H182v196h119v432h422V394h119V198H688.7c-28.2 71.2-97.5 120-176.7 120z'
    ], [
        primaryColor,
        'M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z'
    ]);
});
exports.SlidersTwoTone = getIcon('sliders', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M180 292h80v440h-80zm369 180h-74a3 3 0 0 0-3 3v74a3 3 0 0 0 3 3h74a3 3 0 0 0 3-3v-74a3 3 0 0 0-3-3zm215-108h80v296h-80z'
    ], [
        primaryColor,
        'M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 0 1-3 3h-74a3 3 0 0 1-3-3v-74a3 3 0 0 1 3-3h74a3 3 0 0 1 3 3v74zM320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440z'
    ]);
});
exports.SmileTwoTone = getIcon('smile', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 0 1 8-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 0 1 8 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
    ], [
        primaryColor,
        'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm376 112h-48.1c-4.2 0-7.8 3.2-8.1 7.4-3.7 49.5-45.3 88.6-95.8 88.6s-92-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 0 0-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 0 0-8-8.4zm-24-112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'
    ]);
});
exports.SnippetsTwoTone = getIcon('snippets', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M450 510V336H232v552h432V550H490c-22.1 0-40-17.9-40-40z'
    ], [
        primaryColor,
        'M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z'
    ]);
});
exports.SoundTwoTone = getIcon('sound', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M275.4 424H146v176h129.4l18 11.7L586 803V221L293.3 412.3z'
    ], [
        primaryColor,
        'M892.1 737.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM934 476H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582z'
    ]);
});
exports.StarTwoTone = getIcon('star', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512.5 190.4l-94.4 191.3-211.2 30.7 152.8 149-36.1 210.3 188.9-99.3 188.9 99.2-36.1-210.3 152.8-148.9-211.2-30.7z'
    ], [
        primaryColor,
        'M908.6 352.8l-253.9-36.9L541.2 85.8c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L370.3 315.9l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1L239 839.4a31.95 31.95 0 0 0 46.4 33.7l227.1-119.4 227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM665.3 561.3l36.1 210.3-188.9-99.2-188.9 99.3 36.1-210.3-152.8-149 211.2-30.7 94.4-191.3 94.4 191.3 211.2 30.7-152.8 148.9z'
    ]);
});
exports.StopTwoTone = getIcon('stop', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm288.5 682.8L277.7 224C258 240 240 258 224 277.7l522.8 522.8C682.8 852.7 601 884 512 884c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372c0 89-31.3 170.8-83.5 234.8z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372c89 0 170.8-31.3 234.8-83.5L224 277.7c16-19.7 34-37.7 53.7-53.7l522.8 522.8C852.7 682.8 884 601 884 512c0-205.4-166.6-372-372-372z'
    ]);
});
exports.SwitcherTwoTone = getIcon('switcher', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M184 840h528V312H184v528zm116-290h296v64H300v-64z'], [
        primaryColor,
        'M880 112H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z'
    ], [
        primaryColor,
        'M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528z'
    ], [primaryColor, 'M300 550h296v64H300z']);
});
exports.TabletTwoTone = getIcon('tablet', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752z'
    ], [
        secondaryColor,
        'M232 888h560V136H232v752zm280-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
    ], [primaryColor, 'M472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z']);
});
exports.TagTwoTone = getIcon('tag', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M589 164.6L189.3 564.3l270.4 270.4L859.4 435 836 188l-247-23.4zM680 432c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88z'
    ], [
        primaryColor,
        'M680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z'
    ], [
        primaryColor,
        'M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8a9.9 9.9 0 0 0 7.1 2.9c2.7 0 5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7z'
    ]);
});
exports.TagsTwoTone = getIcon('tags', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M477.5 694l311.9-311.8-19-224.6-224.6-19-311.9 311.9L477.5 694zm116-415.5a47.81 47.81 0 0 1 33.9-33.9c16.6-4.4 34.2.3 46.4 12.4a47.93 47.93 0 0 1 12.4 46.4 47.81 47.81 0 0 1-33.9 33.9c-16.6 4.4-34.2-.3-46.4-12.4a48.3 48.3 0 0 1-12.4-46.4z'
    ], [
        secondaryColor,
        'M476.6 792.6c-1.7-.2-3.4-1-4.7-2.3L137.7 456.1a8.03 8.03 0 0 1 0-11.3L515.9 66.6c1.2-1.3 2.9-2.1 4.7-2.3h-.4c-2.3-.2-4.7.6-6.3 2.3L135.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c1.8 1.9 4.3 2.6 6.7 2.3z'
    ], [
        primaryColor,
        'M889.7 539.8l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3zM652.3 337.3a47.81 47.81 0 0 0 33.9-33.9c4.4-16.6-.3-34.2-12.4-46.4a47.93 47.93 0 0 0-46.4-12.4 47.81 47.81 0 0 0-33.9 33.9c-4.4 16.6.3 34.2 12.4 46.4a48.3 48.3 0 0 0 46.4 12.4z'
    ], [
        primaryColor,
        'M137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c1.3 1.3 2.9 2.1 4.7 2.3 2.4.3 4.8-.5 6.6-2.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3h-1.6c-1.8.2-3.4 1-4.7 2.3L137.7 444.8zm408.1-306.2l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9z'
    ]);
});
exports.ToolTwoTone = getIcon('tool', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M706.8 488.7a32.05 32.05 0 0 1-45.3 0L537 364.2a32.05 32.05 0 0 1 0-45.3l132.9-132.8a184.2 184.2 0 0 0-144 53.5c-58.1 58.1-69.3 145.3-33.6 214.6L439.5 507c-.1 0-.1-.1-.1-.1L209.3 737l79.2 79.2 274-274.1.1.1 8.8-8.8c69.3 35.7 156.5 24.5 214.6-33.6 39.2-39.1 57.3-92.1 53.6-143.9L706.8 488.7z'
    ], [
        primaryColor,
        'M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 0 1 144-53.5L537 318.9a32.05 32.05 0 0 0 0 45.3l124.5 124.5a32.05 32.05 0 0 0 45.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z'
    ]);
});
exports.TrademarkCircleTwoTone = getIcon('trademark-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm170.7 584.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H384c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7z'
    ], [
        secondaryColor,
        'M529.9 357h-83.4v148H528c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z'
    ], [
        primaryColor,
        'M605.4 549.3c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.4-131.1-144.2-131.1H384c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.7c4.4 0 8-3.6 8-8V561.2h88.7L610 720.4c1.3 2.8 4.1 4.6 7.2 4.6h62c1.2 0 2.4-.3 3.5-.8 3.9-2 5.6-6.8 3.5-10.7l-80.8-164.2zM528 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.6 0 46.8-29.8 72.4-82.8 72.4z'
    ]);
});
exports.UnlockTwoTone = getIcon('unlock', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M232 840h560V536H232v304zm280-226a48.01 48.01 0 0 1 28 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0 1 28-87z'
    ], [
        primaryColor,
        'M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z'
    ], [
        primaryColor,
        'M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304z'
    ]);
});
exports.TrophyTwoTone = getIcon('trophy', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M320 480c0 49.1 19.1 95.3 53.9 130.1 34.7 34.8 81 53.9 130.1 53.9h16c49.1 0 95.3-19.1 130.1-53.9 34.8-34.7 53.9-81 53.9-130.1V184H320v296zM184 352c0 41 26.9 75.8 64 87.6-37.1-11.9-64-46.7-64-87.6zm364 382.5C665 721.8 758.4 630.2 773.8 514 758.3 630.2 665 721.7 548 734.5zM250.2 514C265.6 630.2 359 721.8 476 734.5 359 721.7 265.7 630.2 250.2 514z'
    ], [
        primaryColor,
        'M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM248 439.6a91.99 91.99 0 0 1-64-87.6V232h64v207.6zM704 480c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z'
    ]);
});
exports.UpCircleTwoTone = getIcon('up-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm178 479h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z'
    ], [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        primaryColor,
        'M518.4 360.3a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7h46.9c10.3 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246z'
    ]);
});
exports.ThunderboltTwoTone = getIcon('thunderbolt', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M695.4 164.1H470.8L281.2 491.5h157.4l-60.3 241 319.8-305.1h-211z'
    ], [
        primaryColor,
        'M848.1 359.3H627.8L825.9 109c4.1-5.3.4-13-6.3-13H436.1c-2.8 0-5.5 1.5-6.9 4L170.1 547.5c-3.1 5.3.7 12 6.9 12h174.4L262 917.1c-1.9 7.8 7.5 13.3 13.3 7.7L853.6 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.3 732.5l60.3-241H281.2l189.6-327.4h224.6L487.1 427.4h211L378.3 732.5z'
    ]);
});
exports.UpSquareTwoTone = getIcon('up-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm143.5-228.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7z'
    ], [
        primaryColor,
        'M334 624h46.9c10.3 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7z'
    ]);
});
exports.UsbTwoTone = getIcon('usb', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M759.9 504H264.1c-26.5 0-48.1 19.7-48.1 44v292h592V548c0-24.3-21.6-44-48.1-44z'
    ], [
        primaryColor,
        'M456 248h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
    ], [
        primaryColor,
        'M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zM336 184h352v248H336V184zm472 656H216V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v292z'
    ]);
});
exports.VideoCameraTwoTone = getIcon('video-camera', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M136 792h576V232H136v560zm64-488c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48z'
    ], [
        primaryColor,
        'M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226z'
    ], [
        primaryColor,
        'M208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
    ]);
});
exports.WalletTwoTone = getIcon('wallet', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0-192H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200H184V184h656v200z'
    ], [
        secondaryColor,
        'M528 576h312V448H528v128zm92-104c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
    ], [primaryColor, 'M580 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'], [
        secondaryColor,
        'M184 840h656V640H496c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32h344V184H184v656z'
    ]);
});
exports.WarningTwoTone = getIcon('warning', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z'
    ], [
        secondaryColor,
        'M172.2 828.1h679.6L512 239.9 172.2 828.1zM560 720a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm-16-304v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z'
    ], [
        primaryColor,
        'M464 720a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z'
    ]);
});
exports.CiTwoTone = getIcon('ci', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-63.5 522.8c49.3 0 82.8-29.4 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5C345.4 720 286 651.4 286 537.4v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-3.9-46.1-37.5-77.6-87-77.6-61.1 0-95.6 45.4-95.7 126.8v49.3c0 80.3 34.5 125.2 95.6 125.2zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z'
    ], [
        primaryColor,
        'M730 311.9h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z'
    ]);
});
exports.CopyrightTwoTone = getIcon('copyright', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm5.5 533c52.9 0 88.8-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4C407.4 734 344 660.8 344 539.1v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.7-3.2-8-7.4-4-49.6-40-83.4-93-83.4-65.2 0-102.1 48.5-102.2 135.5v52.6c0 85.7 36.8 133.6 102.1 133.6z'
    ], [
        primaryColor,
        'M517.6 351.3c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z'
    ]);
});
exports.DollarTwoTone = getIcon('dollar', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-37 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.9-.6-5.7-1.3-8.8-2.2V677c42.6-3.8 72-27.3 72-66.4 0-30.7-15.9-50.7-63.2-65.1z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm22.4 589.2l.2 31.7c0 4.5-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4c-89-6.5-130.7-57.1-135.2-112.1-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.8 29.9 55.4 74.1 61.3V534l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-73 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.8 46.9 125.9 109.2a8.1 8.1 0 0 1-8 8.8h-44.9c-4 0-7.4-2.9-7.9-6.9-4-29.2-27.5-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 109 116.4 0 75.2-56 117.1-134.3 124z'
    ], [
        primaryColor,
        'M559.7 488.8l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z'
    ]);
});
exports.EuroTwoTone = getIcon('euro', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm117.1 581.1c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.4 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.7.3-12.8H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.8C388.5 345.7 460.7 290 567.4 290c20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346a8 8 0 0 1-9.6 7.8c-14.6-2.9-31.8-4.4-51.7-4.4-65.3 0-110.4 33.5-127.6 90.4h128.3c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8H432.5c-.3 4.4-.3 9.1-.3 13.8v36h136.4c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H438c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.3 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8z'
    ], [
        primaryColor,
        'M619.6 670.5c-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H432.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H440.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H337c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H337c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8z'
    ]);
});
exports.GoldTwoTone = getIcon('gold', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M435.7 558.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128z'
    ], [
        secondaryColor,
        'M592.7 276H433.2l-20.8 128h201zM217.2 620l-20.7 128h200.9l-20.7-128zm430 0l-20.7 128h200.9l-20.7-128z'
    ]);
});
exports.CanlendarTwoTone = getIcon('canlendar', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v136h656V256H712v48z'
    ], [
        primaryColor,
        'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zm0-448H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z'
    ]);
});


/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(792);









var twoToneColorPalette = {
    primaryColor: '#333',
    secondaryColor: '#E6E6E6'
};

var Icon = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Icon, _React$Component);

    function Icon() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Icon);

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Icon, [{
        key: 'render',
        value: function render() {
            var _extends2;

            var _props = this.props,
                type = _props.type,
                className = _props.className,
                onClick = _props.onClick,
                style = _props.style,
                primaryColor = _props.primaryColor,
                secondaryColor = _props.secondaryColor,
                rest = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['type', 'className', 'onClick', 'style', 'primaryColor', 'secondaryColor']);

            var target = void 0;
            var colors = twoToneColorPalette;
            if (primaryColor) {
                colors = {
                    primaryColor: primaryColor,
                    secondaryColor: secondaryColor || Object(__WEBPACK_IMPORTED_MODULE_8__utils__["c" /* getSecondaryColor */])(primaryColor)
                };
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_8__utils__["d" /* isIconDefinition */])(type)) {
                target = type;
            } else if (typeof type === 'string') {
                target = Icon.get(type, colors);
                if (!target) {
                    // log(`Could not find icon: ${type}`);
                    return null;
                }
            }
            if (!target) {
                Object(__WEBPACK_IMPORTED_MODULE_8__utils__["e" /* log */])('type should be string or icon definiton, but got ' + type);
                return null;
            }
            if (target && typeof target.icon === 'function') {
                target = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, target, {
                    icon: target.icon(colors.primaryColor, colors.secondaryColor)
                });
            }
            return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* generate */])(target.icon, 'svg-' + target.name, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()((_extends2 = {
                className: className,
                onClick: onClick,
                style: style
            }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'data-icon', target.name), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'width', '1em'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'height', '1em'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'fill', 'currentColor'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'aria-hidden', 'true'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'focusable', 'false'), _extends2), rest));
        }
    }], [{
        key: 'add',
        value: function add() {
            var _this2 = this;

            for (var _len = arguments.length, icons = Array(_len), _key = 0; _key < _len; _key++) {
                icons[_key] = arguments[_key];
            }

            icons.forEach(function (icon) {
                _this2.definitions.set(Object(__WEBPACK_IMPORTED_MODULE_8__utils__["f" /* withSuffix */])(icon.name, icon.theme), icon);
            });
        }
    }, {
        key: 'clear',
        value: function clear() {
            this.definitions.clear();
        }
    }, {
        key: 'get',
        value: function get(key) {
            var colors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : twoToneColorPalette;

            if (key) {
                var target = this.definitions.get(key);
                if (target && typeof target.icon === 'function') {
                    target = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, target, {
                        icon: target.icon(colors.primaryColor, colors.secondaryColor)
                    });
                }
                return target;
            }
        }
    }, {
        key: 'setTwoToneColors',
        value: function setTwoToneColors(_ref) {
            var primaryColor = _ref.primaryColor,
                secondaryColor = _ref.secondaryColor;

            twoToneColorPalette.primaryColor = primaryColor;
            twoToneColorPalette.secondaryColor = secondaryColor || Object(__WEBPACK_IMPORTED_MODULE_8__utils__["c" /* getSecondaryColor */])(primaryColor);
        }
    }, {
        key: 'getTwoToneColors',
        value: function getTwoToneColors() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, twoToneColorPalette);
        }
    }]);

    return Icon;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Icon.displayName = 'IconReact';
Icon.definitions = new __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* MiniMap */]();
/* harmony default export */ __webpack_exports__["a"] = (Icon);

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(764);
var $Object = __webpack_require__(88).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(140);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(143), 'Object', { defineProperty: __webpack_require__(142).f });


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(766), __esModule: true };

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(456);
__webpack_require__(771);
module.exports = __webpack_require__(328).f('iterator');


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(320);
var defined = __webpack_require__(319);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(326);
var descriptor = __webpack_require__(216);
var setToStringTag = __webpack_require__(327);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(184)(IteratorPrototype, __webpack_require__(114)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(142);
var anObject = __webpack_require__(185);
var getKeys = __webpack_require__(254);

module.exports = __webpack_require__(143) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(141).document;
module.exports = document && document.documentElement;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(772);
var global = __webpack_require__(141);
var hide = __webpack_require__(184);
var Iterators = __webpack_require__(218);
var TO_STRING_TAG = __webpack_require__(114)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(773);
var step = __webpack_require__(774);
var Iterators = __webpack_require__(218);
var toIObject = __webpack_require__(155);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(457)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(776), __esModule: true };

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(777);
__webpack_require__(782);
__webpack_require__(783);
__webpack_require__(784);
module.exports = __webpack_require__(88).Symbol;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(141);
var has = __webpack_require__(154);
var DESCRIPTORS = __webpack_require__(143);
var $export = __webpack_require__(140);
var redefine = __webpack_require__(458);
var META = __webpack_require__(778).KEY;
var $fails = __webpack_require__(187);
var shared = __webpack_require__(322);
var setToStringTag = __webpack_require__(327);
var uid = __webpack_require__(256);
var wks = __webpack_require__(114);
var wksExt = __webpack_require__(328);
var wksDefine = __webpack_require__(329);
var enumKeys = __webpack_require__(779);
var isArray = __webpack_require__(780);
var anObject = __webpack_require__(185);
var isObject = __webpack_require__(186);
var toObject = __webpack_require__(217);
var toIObject = __webpack_require__(155);
var toPrimitive = __webpack_require__(317);
var createDesc = __webpack_require__(216);
var _create = __webpack_require__(326);
var gOPNExt = __webpack_require__(781);
var $GOPD = __webpack_require__(330);
var $GOPS = __webpack_require__(324);
var $DP = __webpack_require__(142);
var $keys = __webpack_require__(254);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(460).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(257).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(255)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(184)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(256)('meta');
var isObject = __webpack_require__(186);
var has = __webpack_require__(154);
var setDesc = __webpack_require__(142).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(187)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(254);
var gOPS = __webpack_require__(324);
var pIE = __webpack_require__(257);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(318);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(155);
var gOPN = __webpack_require__(460).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 782 */
/***/ (function(module, exports) {



/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(329)('asyncIterator');


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(329)('observable');


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(786), __esModule: true };

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(787);
module.exports = __webpack_require__(88).Object.setPrototypeOf;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(140);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(788).set });


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(186);
var anObject = __webpack_require__(185);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(316)(Function.call, __webpack_require__(330).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(790), __esModule: true };

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(791);
var $Object = __webpack_require__(88).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(140);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(326) });


/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (immutable) */ __webpack_exports__["e"] = log;
/* harmony export (immutable) */ __webpack_exports__["d"] = isIconDefinition;
/* unused harmony export normalizeAttrs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MiniMap; });
/* harmony export (immutable) */ __webpack_exports__["b"] = generate;
/* harmony export (immutable) */ __webpack_exports__["c"] = getSecondaryColor;
/* harmony export (immutable) */ __webpack_exports__["f"] = withSuffix;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ant_design_colors__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ant_design_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ant_design_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);





function log(message) {
    if (!(process && Object({"NODE_ENV":"production","PUBLIC_URL":""}) && "production" === 'production')) {
        console.error('[@ant-design/icons-react]: ' + message + '.');
    }
}
function isIconDefinition(target) {
    return typeof target === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && (typeof target.icon === 'object' || typeof target.icon === 'function');
}
function normalizeAttrs() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return Object.keys(attrs).reduce(function (acc, key) {
        var val = attrs[key];
        switch (key) {
            case 'class':
                acc.className = val;
                delete acc['class'];
                break;
            default:
                acc[key] = val;
        }
        return acc;
    }, {});
}
var MiniMap = function () {
    function MiniMap() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MiniMap);

        this.collection = {};
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MiniMap, [{
        key: 'clear',
        value: function clear() {
            this.collection = {};
        }
    }, {
        key: 'delete',
        value: function _delete(key) {
            return delete this.collection[key];
        }
    }, {
        key: 'get',
        value: function get(key) {
            return this.collection[key];
        }
    }, {
        key: 'has',
        value: function has(key) {
            return Boolean(this.collection[key]);
        }
    }, {
        key: 'set',
        value: function set(key, value) {
            this.collection[key] = value;
            return this;
        }
    }, {
        key: 'size',
        get: function get() {
            return Object.keys(this.collection).length;
        }
    }]);

    return MiniMap;
}();
function generate(node, key, rootProps) {
    if (!rootProps) {
        return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](node.tag, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, normalizeAttrs(node.attrs)), (node.children || []).map(function (child, index) {
            return generate(child, key + '-' + node.tag + '-' + index);
        }));
    }
    return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](node.tag, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        key: key
    }, normalizeAttrs(node.attrs), rootProps), (node.children || []).map(function (child, index) {
        return generate(child, key + '-' + node.tag + '-' + index);
    }));
}
function getSecondaryColor(primaryColor) {
    // choose the second color
    return Object(__WEBPACK_IMPORTED_MODULE_3__ant_design_colors__["generate"])(primaryColor)[0];
}
function withSuffix(name, theme) {
    switch (theme) {
        case 'fill':
            return name + '-fill';
        case 'outline':
            return name + '-o';
        case 'twotone':
            return name + '-twotone';
        default:
            throw new TypeError('Unknown theme type: ' + theme + ', name: ' + name);
    }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(258)))

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var generate_1 = __importDefault(__webpack_require__(794));
exports.generate = generate_1.default;
var presetPrimaryColors = {
    red: '#F5222D',
    volcano: '#FA541C',
    orange: '#FA8C16',
    gold: '#FAAD14',
    yellow: '#FADB14',
    lime: '#A0D911',
    green: '#52C41A',
    cyan: '#13C2C2',
    blue: '#1890FF',
    geekblue: '#2F54EB',
    purple: '#722ED1',
    magenta: '#EB2F96',
    grey: '#666666',
};
exports.presetPrimaryColors = presetPrimaryColors;
var presetPalettes = {};
exports.presetPalettes = presetPalettes;
Object.keys(presetPrimaryColors).forEach(function (key) {
    presetPalettes[key] = generate_1.default(presetPrimaryColors[key]);
    presetPalettes[key].primary = presetPalettes[key][5];
});
var red = presetPalettes.red;
exports.red = red;
var volcano = presetPalettes.volcano;
exports.volcano = volcano;
var gold = presetPalettes.gold;
exports.gold = gold;
var orange = presetPalettes.orange;
exports.orange = orange;
var yellow = presetPalettes.yellow;
exports.yellow = yellow;
var lime = presetPalettes.lime;
exports.lime = lime;
var green = presetPalettes.green;
exports.green = green;
var cyan = presetPalettes.cyan;
exports.cyan = cyan;
var blue = presetPalettes.blue;
exports.blue = blue;
var geekblue = presetPalettes.geekblue;
exports.geekblue = geekblue;
var purple = presetPalettes.purple;
exports.purple = purple;
var magenta = presetPalettes.magenta;
exports.magenta = magenta;
var grey = presetPalettes.grey;
exports.grey = grey;


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tinycolor2_1 = __importDefault(__webpack_require__(795));
var hueStep = 2; // 色相阶梯
var saturationStep = 16; // 饱和度阶梯，浅色部分
var saturationStep2 = 5; // 饱和度阶梯，深色部分
var brightnessStep1 = 5; // 亮度阶梯，浅色部分
var brightnessStep2 = 15; // 亮度阶梯，深色部分
var lightColorCount = 5; // 浅色数量，主色上
var darkColorCount = 4; // 深色数量，主色下
function getHue(hsv, i, light) {
    var hue;
    // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
        hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
    }
    else {
        hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
    }
    if (hue < 0) {
        hue += 360;
    }
    else if (hue >= 360) {
        hue -= 360;
    }
    return hue;
}
function getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) {
        return hsv.s;
    }
    var saturation;
    if (light) {
        saturation = Math.round(hsv.s * 100) - saturationStep * i;
    }
    else if (i === darkColorCount) {
        saturation = Math.round(hsv.s * 100) + saturationStep;
    }
    else {
        saturation = Math.round(hsv.s * 100) + saturationStep2 * i;
    }
    // 边界值修正
    if (saturation > 100) {
        saturation = 100;
    }
    // 第一格的 s 限制在 6-10 之间
    if (light && i === lightColorCount && saturation > 10) {
        saturation = 10;
    }
    if (saturation < 6) {
        saturation = 6;
    }
    return saturation;
}
function getValue(hsv, i, light) {
    if (light) {
        return Math.round(hsv.v * 100) + brightnessStep1 * i;
    }
    return Math.round(hsv.v * 100) - brightnessStep2 * i;
}
function generate(color) {
    var patterns = [];
    var pColor = tinycolor2_1.default(color);
    for (var i = lightColorCount; i > 0; i -= 1) {
        var hsv = pColor.toHsv();
        var colorString = tinycolor2_1.default({
            h: getHue(hsv, i, true),
            s: getSaturation(hsv, i, true),
            v: getValue(hsv, i, true),
        }).toHexString();
        patterns.push(colorString);
    }
    patterns.push(pColor.toHexString());
    for (var i = 1; i <= darkColorCount; i += 1) {
        var hsv = pColor.toHsv();
        var colorString = tinycolor2_1.default({
            h: getHue(hsv, i),
            s: getSaturation(hsv, i),
            v: getValue(hsv, i),
        }).toHexString();
        patterns.push(colorString);
    }
    return patterns;
}
exports.default = generate;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

// This file is autogenerated. It's used to publish CJS to npm.
(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.tinycolor = factory());
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  // https://github.com/bgrins/TinyColor
  // Brian Grinstead, MIT License

  var trimLeft = /^\s+/;
  var trimRight = /\s+$/;
  function tinycolor(color, opts) {
    color = color ? color : "";
    opts = opts || {};

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
      return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
      return new tinycolor(color, opts);
    }
    var rgb = inputToRGB(color);
    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) this._r = Math.round(this._r);
    if (this._g < 1) this._g = Math.round(this._g);
    if (this._b < 1) this._b = Math.round(this._b);
    this._ok = rgb.ok;
  }
  tinycolor.prototype = {
    isDark: function isDark() {
      return this.getBrightness() < 128;
    },
    isLight: function isLight() {
      return !this.isDark();
    },
    isValid: function isValid() {
      return this._ok;
    },
    getOriginalInput: function getOriginalInput() {
      return this._originalInput;
    },
    getFormat: function getFormat() {
      return this._format;
    },
    getAlpha: function getAlpha() {
      return this._a;
    },
    getBrightness: function getBrightness() {
      //http://www.w3.org/TR/AERT#color-contrast
      var rgb = this.toRgb();
      return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function getLuminance() {
      //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
      var rgb = this.toRgb();
      var RsRGB, GsRGB, BsRGB, R, G, B;
      RsRGB = rgb.r / 255;
      GsRGB = rgb.g / 255;
      BsRGB = rgb.b / 255;
      if (RsRGB <= 0.03928) R = RsRGB / 12.92;else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
      if (GsRGB <= 0.03928) G = GsRGB / 12.92;else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
      if (BsRGB <= 0.03928) B = BsRGB / 12.92;else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
      return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    },
    setAlpha: function setAlpha(value) {
      this._a = boundAlpha(value);
      this._roundA = Math.round(100 * this._a) / 100;
      return this;
    },
    toHsv: function toHsv() {
      var hsv = rgbToHsv(this._r, this._g, this._b);
      return {
        h: hsv.h * 360,
        s: hsv.s,
        v: hsv.v,
        a: this._a
      };
    },
    toHsvString: function toHsvString() {
      var hsv = rgbToHsv(this._r, this._g, this._b);
      var h = Math.round(hsv.h * 360),
        s = Math.round(hsv.s * 100),
        v = Math.round(hsv.v * 100);
      return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
    },
    toHsl: function toHsl() {
      var hsl = rgbToHsl(this._r, this._g, this._b);
      return {
        h: hsl.h * 360,
        s: hsl.s,
        l: hsl.l,
        a: this._a
      };
    },
    toHslString: function toHslString() {
      var hsl = rgbToHsl(this._r, this._g, this._b);
      var h = Math.round(hsl.h * 360),
        s = Math.round(hsl.s * 100),
        l = Math.round(hsl.l * 100);
      return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
    },
    toHex: function toHex(allow3Char) {
      return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function toHexString(allow3Char) {
      return "#" + this.toHex(allow3Char);
    },
    toHex8: function toHex8(allow4Char) {
      return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function toHex8String(allow4Char) {
      return "#" + this.toHex8(allow4Char);
    },
    toRgb: function toRgb() {
      return {
        r: Math.round(this._r),
        g: Math.round(this._g),
        b: Math.round(this._b),
        a: this._a
      };
    },
    toRgbString: function toRgbString() {
      return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function toPercentageRgb() {
      return {
        r: Math.round(bound01(this._r, 255) * 100) + "%",
        g: Math.round(bound01(this._g, 255) * 100) + "%",
        b: Math.round(bound01(this._b, 255) * 100) + "%",
        a: this._a
      };
    },
    toPercentageRgbString: function toPercentageRgbString() {
      return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function toName() {
      if (this._a === 0) {
        return "transparent";
      }
      if (this._a < 1) {
        return false;
      }
      return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function toFilter(secondColor) {
      var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
      var secondHex8String = hex8String;
      var gradientType = this._gradientType ? "GradientType = 1, " : "";
      if (secondColor) {
        var s = tinycolor(secondColor);
        secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
      }
      return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
    },
    toString: function toString(format) {
      var formatSet = !!format;
      format = format || this._format;
      var formattedString = false;
      var hasAlpha = this._a < 1 && this._a >= 0;
      var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
      if (needsAlphaFormat) {
        // Special case for "transparent", all other non-alpha formats
        // will return rgba when there is transparency.
        if (format === "name" && this._a === 0) {
          return this.toName();
        }
        return this.toRgbString();
      }
      if (format === "rgb") {
        formattedString = this.toRgbString();
      }
      if (format === "prgb") {
        formattedString = this.toPercentageRgbString();
      }
      if (format === "hex" || format === "hex6") {
        formattedString = this.toHexString();
      }
      if (format === "hex3") {
        formattedString = this.toHexString(true);
      }
      if (format === "hex4") {
        formattedString = this.toHex8String(true);
      }
      if (format === "hex8") {
        formattedString = this.toHex8String();
      }
      if (format === "name") {
        formattedString = this.toName();
      }
      if (format === "hsl") {
        formattedString = this.toHslString();
      }
      if (format === "hsv") {
        formattedString = this.toHsvString();
      }
      return formattedString || this.toHexString();
    },
    clone: function clone() {
      return tinycolor(this.toString());
    },
    _applyModification: function _applyModification(fn, args) {
      var color = fn.apply(null, [this].concat([].slice.call(args)));
      this._r = color._r;
      this._g = color._g;
      this._b = color._b;
      this.setAlpha(color._a);
      return this;
    },
    lighten: function lighten() {
      return this._applyModification(_lighten, arguments);
    },
    brighten: function brighten() {
      return this._applyModification(_brighten, arguments);
    },
    darken: function darken() {
      return this._applyModification(_darken, arguments);
    },
    desaturate: function desaturate() {
      return this._applyModification(_desaturate, arguments);
    },
    saturate: function saturate() {
      return this._applyModification(_saturate, arguments);
    },
    greyscale: function greyscale() {
      return this._applyModification(_greyscale, arguments);
    },
    spin: function spin() {
      return this._applyModification(_spin, arguments);
    },
    _applyCombination: function _applyCombination(fn, args) {
      return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function analogous() {
      return this._applyCombination(_analogous, arguments);
    },
    complement: function complement() {
      return this._applyCombination(_complement, arguments);
    },
    monochromatic: function monochromatic() {
      return this._applyCombination(_monochromatic, arguments);
    },
    splitcomplement: function splitcomplement() {
      return this._applyCombination(_splitcomplement, arguments);
    },
    // Disabled until https://github.com/bgrins/TinyColor/issues/254
    // polyad: function (number) {
    //   return this._applyCombination(polyad, [number]);
    // },
    triad: function triad() {
      return this._applyCombination(polyad, [3]);
    },
    tetrad: function tetrad() {
      return this._applyCombination(polyad, [4]);
    }
  };

  // If input is an object, force 1 into "1.0" to handle ratios properly
  // String input requires "1.0" as input, so 1 will be treated as 1
  tinycolor.fromRatio = function (color, opts) {
    if (_typeof(color) == "object") {
      var newColor = {};
      for (var i in color) {
        if (color.hasOwnProperty(i)) {
          if (i === "a") {
            newColor[i] = color[i];
          } else {
            newColor[i] = convertToPercentage(color[i]);
          }
        }
      }
      color = newColor;
    }
    return tinycolor(color, opts);
  };

  // Given a string or object, convert that input to RGB
  // Possible string inputs:
  //
  //     "red"
  //     "#f00" or "f00"
  //     "#ff0000" or "ff0000"
  //     "#ff000000" or "ff000000"
  //     "rgb 255 0 0" or "rgb (255, 0, 0)"
  //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
  //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
  //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
  //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
  //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
  //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
  //
  function inputToRGB(color) {
    var rgb = {
      r: 0,
      g: 0,
      b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color == "string") {
      color = stringInputToObject(color);
    }
    if (_typeof(color) == "object") {
      if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
        rgb = rgbToRgb(color.r, color.g, color.b);
        ok = true;
        format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
        s = convertToPercentage(color.s);
        v = convertToPercentage(color.v);
        rgb = hsvToRgb(color.h, s, v);
        ok = true;
        format = "hsv";
      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
        s = convertToPercentage(color.s);
        l = convertToPercentage(color.l);
        rgb = hslToRgb(color.h, s, l);
        ok = true;
        format = "hsl";
      }
      if (color.hasOwnProperty("a")) {
        a = color.a;
      }
    }
    a = boundAlpha(a);
    return {
      ok: ok,
      format: color.format || format,
      r: Math.min(255, Math.max(rgb.r, 0)),
      g: Math.min(255, Math.max(rgb.g, 0)),
      b: Math.min(255, Math.max(rgb.b, 0)),
      a: a
    };
  }

  // Conversion Functions
  // --------------------

  // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
  // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

  // `rgbToRgb`
  // Handle bounds / percentage checking to conform to CSS color spec
  // <http://www.w3.org/TR/css3-color/>
  // *Assumes:* r, g, b in [0, 255] or [0, 1]
  // *Returns:* { r, g, b } in [0, 255]
  function rgbToRgb(r, g, b) {
    return {
      r: bound01(r, 255) * 255,
      g: bound01(g, 255) * 255,
      b: bound01(b, 255) * 255
    };
  }

  // `rgbToHsl`
  // Converts an RGB color value to HSL.
  // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
  // *Returns:* { h, s, l } in [0,1]
  function rgbToHsl(r, g, b) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);
    var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    var h,
      s,
      l = (max + min) / 2;
    if (max == min) {
      h = s = 0; // achromatic
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return {
      h: h,
      s: s,
      l: l
    };
  }

  // `hslToRgb`
  // Converts an HSL color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
  function hslToRgb(h, s, l) {
    var r, g, b;
    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);
    function hue2rgb(p, q, t) {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    }
    if (s === 0) {
      r = g = b = l; // achromatic
    } else {
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
      r: r * 255,
      g: g * 255,
      b: b * 255
    };
  }

  // `rgbToHsv`
  // Converts an RGB color value to HSV
  // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
  // *Returns:* { h, s, v } in [0,1]
  function rgbToHsv(r, g, b) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);
    var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    var h,
      s,
      v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max == min) {
      h = 0; // achromatic
    } else {
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return {
      h: h,
      s: s,
      v: v
    };
  }

  // `hsvToRgb`
  // Converts an HSV color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
  function hsvToRgb(h, s, v) {
    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);
    var i = Math.floor(h),
      f = h - i,
      p = v * (1 - s),
      q = v * (1 - f * s),
      t = v * (1 - (1 - f) * s),
      mod = i % 6,
      r = [v, q, p, p, t, v][mod],
      g = [t, v, v, q, p, p][mod],
      b = [p, p, t, v, v, q][mod];
    return {
      r: r * 255,
      g: g * 255,
      b: b * 255
    };
  }

  // `rgbToHex`
  // Converts an RGB color to hex
  // Assumes r, g, and b are contained in the set [0, 255]
  // Returns a 3 or 6 character hex
  function rgbToHex(r, g, b, allow3Char) {
    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }
    return hex.join("");
  }

  // `rgbaToHex`
  // Converts an RGBA color plus alpha transparency to hex
  // Assumes r, g, b are contained in the set [0, 255] and
  // a in [0, 1]. Returns a 4 or 8 character rgba hex
  function rgbaToHex(r, g, b, a, allow4Char) {
    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }
    return hex.join("");
  }

  // `rgbaToArgbHex`
  // Converts an RGBA color to an ARGB Hex8 string
  // Rarely used, but required for "toFilter()"
  function rgbaToArgbHex(r, g, b, a) {
    var hex = [pad2(convertDecimalToHex(a)), pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
    return hex.join("");
  }

  // `equals`
  // Can be called with any tinycolor input
  tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) return false;
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
  };
  tinycolor.random = function () {
    return tinycolor.fromRatio({
      r: Math.random(),
      g: Math.random(),
      b: Math.random()
    });
  };

  // Modification Functions
  // ----------------------
  // Thanks to less.js for some of the basics here
  // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

  function _desaturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
  }
  function _saturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
  }
  function _greyscale(color) {
    return tinycolor(color).desaturate(100);
  }
  function _lighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
  }
  function _brighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var rgb = tinycolor(color).toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return tinycolor(rgb);
  }
  function _darken(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
  }

  // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
  // Values outside of this range will be wrapped into this range.
  function _spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
  }

  // Combination Functions
  // ---------------------
  // Thanks to jQuery xColor for some of the ideas behind these
  // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

  function _complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
  }
  function polyad(color, number) {
    if (isNaN(number) || number <= 0) {
      throw new Error("Argument to polyad must be a positive number");
    }
    var hsl = tinycolor(color).toHsl();
    var result = [tinycolor(color)];
    var step = 360 / number;
    for (var i = 1; i < number; i++) {
      result.push(tinycolor({
        h: (hsl.h + i * step) % 360,
        s: hsl.s,
        l: hsl.l
      }));
    }
    return result;
  }
  function _splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [tinycolor(color), tinycolor({
      h: (h + 72) % 360,
      s: hsl.s,
      l: hsl.l
    }), tinycolor({
      h: (h + 216) % 360,
      s: hsl.s,
      l: hsl.l
    })];
  }
  function _analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;
    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];
    for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
      hsl.h = (hsl.h + part) % 360;
      ret.push(tinycolor(hsl));
    }
    return ret;
  }
  function _monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h,
      s = hsv.s,
      v = hsv.v;
    var ret = [];
    var modification = 1 / results;
    while (results--) {
      ret.push(tinycolor({
        h: h,
        s: s,
        v: v
      }));
      v = (v + modification) % 1;
    }
    return ret;
  }

  // Utility Functions
  // ---------------------

  tinycolor.mix = function (color1, color2, amount) {
    amount = amount === 0 ? 0 : amount || 50;
    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();
    var p = amount / 100;
    var rgba = {
      r: (rgb2.r - rgb1.r) * p + rgb1.r,
      g: (rgb2.g - rgb1.g) * p + rgb1.g,
      b: (rgb2.b - rgb1.b) * p + rgb1.b,
      a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return tinycolor(rgba);
  };

  // Readability Functions
  // ---------------------
  // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

  // `contrast`
  // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
  tinycolor.readability = function (color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
  };

  // `isReadable`
  // Ensure that foreground and background color combinations meet WCAG2 guidelines.
  // The third argument is an optional Object.
  //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
  //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
  // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

  // *Example*
  //    tinycolor.isReadable("#000", "#111") => false
  //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
  tinycolor.isReadable = function (color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;
    out = false;
    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
      case "AAsmall":
      case "AAAlarge":
        out = readability >= 4.5;
        break;
      case "AAlarge":
        out = readability >= 3;
        break;
      case "AAAsmall":
        out = readability >= 7;
        break;
    }
    return out;
  };

  // `mostReadable`
  // Given a base color and a list of possible foreground or background
  // colors for that base, returns the most readable color.
  // Optionally returns Black or White if the most readable color is unreadable.
  // *Example*
  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
  tinycolor.mostReadable = function (baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors;
    level = args.level;
    size = args.size;
    for (var i = 0; i < colorList.length; i++) {
      readability = tinycolor.readability(baseColor, colorList[i]);
      if (readability > bestScore) {
        bestScore = readability;
        bestColor = tinycolor(colorList[i]);
      }
    }
    if (tinycolor.isReadable(baseColor, bestColor, {
      level: level,
      size: size
    }) || !includeFallbackColors) {
      return bestColor;
    } else {
      args.includeFallbackColors = false;
      return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
    }
  };

  // Big List of Colors
  // ------------------
  // <https://www.w3.org/TR/css-color-4/#named-colors>
  var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
  };

  // Make it easy to access colors via `hexNames[hex]`
  var hexNames = tinycolor.hexNames = flip(names);

  // Utilities
  // ---------

  // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
  function flip(o) {
    var flipped = {};
    for (var i in o) {
      if (o.hasOwnProperty(i)) {
        flipped[o[i]] = i;
      }
    }
    return flipped;
  }

  // Return a valid alpha value [0,1] with all invalid values being set to 1
  function boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) {
      a = 1;
    }
    return a;
  }

  // Take input from [0, n] and return it as [0, 1]
  function bound01(n, max) {
    if (isOnePointZero(n)) n = "100%";
    var processPercent = isPercentage(n);
    n = Math.min(max, Math.max(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
      n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) {
      return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return n % max / parseFloat(max);
  }

  // Force a number between 0 and 1
  function clamp01(val) {
    return Math.min(1, Math.max(0, val));
  }

  // Parse a base-16 hex value into a base-10 integer
  function parseIntFromHex(val) {
    return parseInt(val, 16);
  }

  // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
  // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
  function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
  }

  // Check to see if string passed in is a percentage
  function isPercentage(n) {
    return typeof n === "string" && n.indexOf("%") != -1;
  }

  // Force a hex value to have 2 characters
  function pad2(c) {
    return c.length == 1 ? "0" + c : "" + c;
  }

  // Replace a decimal with it's percentage value
  function convertToPercentage(n) {
    if (n <= 1) {
      n = n * 100 + "%";
    }
    return n;
  }

  // Converts a decimal to a hex value
  function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
  }
  // Converts a hex value to a decimal
  function convertHexToDecimal(h) {
    return parseIntFromHex(h) / 255;
  }
  var matchers = function () {
    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    return {
      CSS_UNIT: new RegExp(CSS_UNIT),
      rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
      rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
      hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
      hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
      hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
      hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
      hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
      hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
  }();

  // `isValidCSSUnit`
  // Take in a single string / number and check to see if it looks like a CSS unit
  // (see `matchers` above for definition).
  function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
  }

  // `stringInputToObject`
  // Permissive string parsing.  Take in a number of formats, and output an object
  // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
  function stringInputToObject(color) {
    color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
    var named = false;
    if (names[color]) {
      color = names[color];
      named = true;
    } else if (color == "transparent") {
      return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
      };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if (match = matchers.rgb.exec(color)) {
      return {
        r: match[1],
        g: match[2],
        b: match[3]
      };
    }
    if (match = matchers.rgba.exec(color)) {
      return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hsl.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        l: match[3]
      };
    }
    if (match = matchers.hsla.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hsv.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        v: match[3]
      };
    }
    if (match = matchers.hsva.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hex8.exec(color)) {
      return {
        r: parseIntFromHex(match[1]),
        g: parseIntFromHex(match[2]),
        b: parseIntFromHex(match[3]),
        a: convertHexToDecimal(match[4]),
        format: named ? "name" : "hex8"
      };
    }
    if (match = matchers.hex6.exec(color)) {
      return {
        r: parseIntFromHex(match[1]),
        g: parseIntFromHex(match[2]),
        b: parseIntFromHex(match[3]),
        format: named ? "name" : "hex"
      };
    }
    if (match = matchers.hex4.exec(color)) {
      return {
        r: parseIntFromHex(match[1] + "" + match[1]),
        g: parseIntFromHex(match[2] + "" + match[2]),
        b: parseIntFromHex(match[3] + "" + match[3]),
        a: convertHexToDecimal(match[4] + "" + match[4]),
        format: named ? "name" : "hex8"
      };
    }
    if (match = matchers.hex3.exec(color)) {
      return {
        r: parseIntFromHex(match[1] + "" + match[1]),
        g: parseIntFromHex(match[2] + "" + match[2]),
        b: parseIntFromHex(match[3] + "" + match[3]),
        format: named ? "name" : "hex"
      };
    }
    return false;
  }
  function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {
      level: "AA",
      size: "small"
    };
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
      level = "AA";
    }
    if (size !== "small" && size !== "large") {
      size = "small";
    }
    return {
      level: level,
      size: size
    };
  }

  return tinycolor;

}));


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = create;

var React = _interopRequireWildcard(__webpack_require__(0));

var _index = _interopRequireDefault(__webpack_require__(38));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var customCache = new Set();

function create() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var scriptUrl = options.scriptUrl,
      _options$extraCommonP = options.extraCommonProps,
      extraCommonProps = _options$extraCommonP === void 0 ? {} : _options$extraCommonP;
  /**
   * DOM API required.
   * Make sure in browser environment.
   * The Custom Icon will create a <script/>
   * that loads SVG symbols and insert the SVG Element into the document body.
   */

  if (typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function' && typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl)) {
    var script = document.createElement('script');
    script.setAttribute('src', scriptUrl);
    script.setAttribute('data-namespace', scriptUrl);
    customCache.add(scriptUrl);
    document.body.appendChild(script);
  }

  var Iconfont = function Iconfont(props) {
    var type = props.type,
        children = props.children,
        restProps = __rest(props, ["type", "children"]); // component > children > type


    var content = null;

    if (props.type) {
      content = /*#__PURE__*/React.createElement("use", {
        xlinkHref: "#".concat(type)
      });
    }

    if (children) {
      content = children;
    }

    return /*#__PURE__*/React.createElement(_index["default"], _extends({}, extraCommonProps, restProps), content);
  };

  Iconfont.displayName = 'Iconfont';
  return Iconfont;
}

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThemeFromTypeName = getThemeFromTypeName;
exports.removeTypeTheme = removeTypeTheme;
exports.withThemeSuffix = withThemeSuffix;
exports.alias = alias;
exports.svgBaseProps = void 0;

var _warning = _interopRequireDefault(__webpack_require__(69));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// These props make sure that the SVG behaviours like general text.
// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
var svgBaseProps = {
  width: '1em',
  height: '1em',
  fill: 'currentColor',
  'aria-hidden': true,
  focusable: 'false'
};
exports.svgBaseProps = svgBaseProps;
var fillTester = /-fill$/;
var outlineTester = /-o$/;
var twoToneTester = /-twotone$/;

function getThemeFromTypeName(type) {
  var result = null;

  if (fillTester.test(type)) {
    result = 'filled';
  } else if (outlineTester.test(type)) {
    result = 'outlined';
  } else if (twoToneTester.test(type)) {
    result = 'twoTone';
  }

  return result;
}

function removeTypeTheme(type) {
  return type.replace(fillTester, '').replace(outlineTester, '').replace(twoToneTester, '');
}

function withThemeSuffix(type, theme) {
  var result = type;

  if (theme === 'filled') {
    result += '-fill';
  } else if (theme === 'outlined') {
    result += '-o';
  } else if (theme === 'twoTone') {
    result += '-twotone';
  } else {
    (0, _warning["default"])(false, 'Icon', "This icon '".concat(type, "' has unknown theme '").concat(theme, "'"));
  }

  return result;
} // For alias or compatibility


function alias(type) {
  var newType = type;

  switch (type) {
    case 'cross':
      newType = 'close';
      break;
    // https://github.com/ant-design/ant-design/issues/13007

    case 'interation':
      newType = 'interaction';
      break;
    // https://github.com/ant-design/ant-design/issues/16810

    case 'canlendar':
      newType = 'calendar';
      break;
    // https://github.com/ant-design/ant-design/issues/17448

    case 'colum-height':
      newType = 'column-height';
      break;

    default:
  }

  (0, _warning["default"])(newType === type, 'Icon', "Icon '".concat(type, "' was a typo and is now deprecated, please use '").concat(newType, "' instead."));
  return newType;
}

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default2 = _interopRequireDefault(__webpack_require__(219));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _default2["default"];
exports["default"] = _default;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTwoToneColor = setTwoToneColor;
exports.getTwoToneColor = getTwoToneColor;

var _iconsReact = _interopRequireDefault(__webpack_require__(454));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function setTwoToneColor(primaryColor) {
  return _iconsReact["default"].setTwoToneColors({
    primaryColor: primaryColor
  });
}

function getTwoToneColor() {
  var colors = _iconsReact["default"].getTwoToneColors();

  return colors.primaryColor;
}

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ANT_MARK = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(19));

var moment = _interopRequireWildcard(__webpack_require__(2));

var _interopDefault = _interopRequireDefault(__webpack_require__(182));

var _locale = __webpack_require__(333);

var _warning = _interopRequireDefault(__webpack_require__(69));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ANT_MARK = 'internalMark';
exports.ANT_MARK = ANT_MARK;

function setMomentLocale(locale) {
  if (locale && locale.locale) {
    (0, _interopDefault["default"])(moment).locale(locale.locale);
  } else {
    (0, _interopDefault["default"])(moment).locale('en');
  }
}

var LocaleProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(LocaleProvider, _React$Component);

  var _super = _createSuper(LocaleProvider);

  function LocaleProvider(props) {
    var _this;

    _classCallCheck(this, LocaleProvider);

    _this = _super.call(this, props);
    setMomentLocale(props.locale);
    (0, _locale.changeConfirmLocale)(props.locale && props.locale.Modal);
    (0, _warning["default"])(props._ANT_MARK__ === ANT_MARK, 'LocaleProvider', '`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale');
    return _this;
  }

  _createClass(LocaleProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        antLocale: _extends(_extends({}, this.props.locale), {
          exist: true
        })
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var locale = this.props.locale;

      if (prevProps.locale !== locale) {
        setMomentLocale(locale);
        (0, _locale.changeConfirmLocale)(locale && locale.Modal);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _locale.changeConfirmLocale)();
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return LocaleProvider;
}(React.Component);

exports["default"] = LocaleProvider;
LocaleProvider.propTypes = {
  locale: PropTypes.object
};
LocaleProvider.defaultProps = {
  locale: {}
};
LocaleProvider.childContextTypes = {
  antLocale: PropTypes.object
};

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withConfigConsumer = withConfigConsumer;
exports.ConfigConsumer = exports.ConfigContext = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _createReactContext = _interopRequireDefault(__webpack_require__(156));

var _renderEmpty = _interopRequireDefault(__webpack_require__(804));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ConfigContext = (0, _createReactContext["default"])({
  // We provide a default function for Context without provider
  getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
    if (customizePrefixCls) return customizePrefixCls;
    return "ant-".concat(suffixCls);
  },
  renderEmpty: _renderEmpty["default"]
});
exports.ConfigContext = ConfigContext;
var ConfigConsumer = ConfigContext.Consumer;
exports.ConfigConsumer = ConfigConsumer;

function withConfigConsumer(config) {
  return function withConfigConsumerFunc(Component) {
    // Wrap with ConfigConsumer. Since we need compatible with react 15, be care when using ref methods
    var SFC = function SFC(props) {
      return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (configProps) {
        var basicPrefixCls = config.prefixCls;
        var getPrefixCls = configProps.getPrefixCls;
        var customizePrefixCls = props.prefixCls;
        var prefixCls = getPrefixCls(basicPrefixCls, customizePrefixCls);
        return /*#__PURE__*/React.createElement(Component, _extends({}, configProps, props, {
          prefixCls: prefixCls
        }));
      });
    };

    var cons = Component.constructor;
    var name = cons && cons.displayName || Component.name || 'Component';
    SFC.displayName = "withConfigConsumer(".concat(name, ")");
    return SFC;
  };
}

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(803);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(76);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _empty = _interopRequireDefault(__webpack_require__(805));

var _ = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var renderEmpty = function renderEmpty(componentName) {
  return /*#__PURE__*/React.createElement(_.ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var prefix = getPrefixCls('empty');

    switch (componentName) {
      case 'Table':
      case 'List':
        return /*#__PURE__*/React.createElement(_empty["default"], {
          image: _empty["default"].PRESENTED_IMAGE_SIMPLE
        });

      case 'Select':
      case 'TreeSelect':
      case 'Cascader':
      case 'Transfer':
      case 'Mentions':
        return /*#__PURE__*/React.createElement(_empty["default"], {
          image: _empty["default"].PRESENTED_IMAGE_SIMPLE,
          className: "".concat(prefix, "-small")
        });

      default:
        return /*#__PURE__*/React.createElement(_empty["default"], null);
    }
  });
};

var _default = renderEmpty;
exports["default"] = _default;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _configProvider = __webpack_require__(39);

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(113));

var _empty = _interopRequireDefault(__webpack_require__(806));

var _simple = _interopRequireDefault(__webpack_require__(807));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var defaultEmptyImg = /*#__PURE__*/React.createElement(_empty["default"], null);
var simpleEmptyImg = /*#__PURE__*/React.createElement(_simple["default"], null);

var Empty = function Empty(props) {
  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;

    var className = props.className,
        customizePrefixCls = props.prefixCls,
        _props$image = props.image,
        image = _props$image === void 0 ? defaultEmptyImg : _props$image,
        description = props.description,
        children = props.children,
        imageStyle = props.imageStyle,
        restProps = __rest(props, ["className", "prefixCls", "image", "description", "children", "imageStyle"]);

    return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
      componentName: "Empty"
    }, function (locale) {
      var prefixCls = getPrefixCls('empty', customizePrefixCls);
      var des = typeof description !== 'undefined' ? description : locale.description;
      var alt = typeof des === 'string' ? des : 'empty';
      var imageNode = null;

      if (typeof image === 'string') {
        imageNode = /*#__PURE__*/React.createElement("img", {
          alt: alt,
          src: image
        });
      } else {
        imageNode = image;
      }

      return /*#__PURE__*/React.createElement("div", _extends({
        className: (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-normal"), image === simpleEmptyImg), className)
      }, restProps), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-image"),
        style: imageStyle
      }, imageNode), des && /*#__PURE__*/React.createElement("p", {
        className: "".concat(prefixCls, "-description")
      }, des), children && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-footer")
      }, children));
    });
  });
};

Empty.PRESENTED_IMAGE_DEFAULT = defaultEmptyImg;
Empty.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
var _default = Empty;
exports["default"] = _default;

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Empty = function Empty() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "184",
    height: "152",
    viewBox: "0 0 184 152",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 31.67)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fillOpacity: ".8",
    fill: "#F5F5F7",
    cx: "67.797",
    cy: "106.89",
    rx: "67.797",
    ry: "12.668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
    fill: "#AEB8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    fill: "url(#linearGradient-1)",
    transform: "translate(13.56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    fill: "#F5F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
    fill: "#DCE0E6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
    fill: "#DCE0E6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.65 15.383)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: "20.654",
    cy: "3.167",
    rx: "2.849",
    ry: "2.815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }))));
};

var _default = Empty;
exports["default"] = _default;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Simple = function Simple() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "64",
    height: "41",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F5F5F5",
    cx: "32",
    cy: "33",
    rx: "32",
    ry: "7"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#D9D9D9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    fill: "#FAFAFA"
  }))));
};

var _default = Simple;
exports["default"] = _default;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

exports['default'] = TransitionEvents;
module.exports = exports['default'];

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _configProvider = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var ButtonGroup = function ButtonGroup(props) {
  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;

    var customizePrefixCls = props.prefixCls,
        size = props.size,
        className = props.className,
        others = __rest(props, ["prefixCls", "size", "className"]);

    var prefixCls = getPrefixCls('btn-group', customizePrefixCls); // large => lg
    // small => sm

    var sizeCls = '';

    switch (size) {
      case 'large':
        sizeCls = 'lg';
        break;

      case 'small':
        sizeCls = 'sm';
        break;

      default:
        break;
    }

    var classes = (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), className);
    return /*#__PURE__*/React.createElement("div", _extends({}, others, {
      className: classes
    }));
  });
};

var _default = ButtonGroup;
exports["default"] = _default;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(811);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 811 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_animate__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_createChainedFunction__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Notice__ = __webpack_require__(818);















var seed = 0;
var now = Date.now();

function getUuid() {
  return 'rcNotification_' + now + '_' + seed++;
}

var Notification = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Notification, _Component);

  function Notification() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Notification);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Notification.__proto__ || Object.getPrototypeOf(Notification)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      notices: []
    }, _this.add = function (notice) {
      var key = notice.key = notice.key || getUuid();
      var maxCount = _this.props.maxCount;

      _this.setState(function (previousState) {
        var notices = previousState.notices;
        var noticeIndex = notices.map(function (v) {
          return v.key;
        }).indexOf(key);
        var updatedNotices = notices.concat();
        if (noticeIndex !== -1) {
          updatedNotices.splice(noticeIndex, 1, notice);
        } else {
          if (maxCount && notices.length >= maxCount) {
                                                notice.updateKey = updatedNotices[0].updateKey || updatedNotices[0].key;
            updatedNotices.shift();
          }
          updatedNotices.push(notice);
        }
        return {
          notices: updatedNotices
        };
      });
    }, _this.remove = function (key) {
      _this.setState(function (previousState) {
        return {
          notices: previousState.notices.filter(function (notice) {
            return notice.key !== key;
          })
        };
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Notification, [{
    key: 'getTransitionName',
    value: function getTransitionName() {
      var props = this.props;
      var transitionName = props.transitionName;
      if (!transitionName && props.animation) {
        transitionName = props.prefixCls + '-' + props.animation;
      }
      return transitionName;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _className;

      var props = this.props;
      var notices = this.state.notices;

      var noticeNodes = notices.map(function (notice, index) {
        var update = Boolean(index === notices.length - 1 && notice.updateKey);
        var key = notice.updateKey ? notice.updateKey : notice.key;
        var onClose = Object(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_createChainedFunction__["a" /* default */])(_this2.remove.bind(_this2, notice.key), notice.onClose);
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__Notice__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
            prefixCls: props.prefixCls
          }, notice, {
            key: key,
            update: update,
            onClose: onClose,
            onClick: notice.onClick,
            closeIcon: props.closeIcon
          }),
          notice.content
        );
      });
      var className = (_className = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_className, props.prefixCls, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_className, props.className, !!props.className), _className);
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_12_classnames___default()(className), style: props.style },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_rc_animate__["default"],
          { transitionName: this.getTransitionName() },
          noticeNodes
        )
      );
    }
  }]);

  return Notification;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Notification.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  animation: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object]),
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  maxCount: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  closeIcon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node
};
Notification.defaultProps = {
  prefixCls: 'rc-notification',
  animation: 'fade',
  style: {
    top: 65,
    left: '50%'
  }
};


Notification.newInstance = function newNotificationInstance(properties, callback) {
  var _ref2 = properties || {},
      getContainer = _ref2.getContainer,
      props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['getContainer']);

  var div = document.createElement('div');
  if (getContainer) {
    var root = getContainer();
    root.appendChild(div);
  } else {
    document.body.appendChild(div);
  }
  var called = false;
  function ref(notification) {
    if (called) {
      return;
    }
    called = true;
    callback({
      notice: function notice(noticeProps) {
        notification.add(noticeProps);
      },
      removeNotice: function removeNotice(key) {
        notification.remove(key);
      },

      component: notification,
      destroy: function destroy() {
        __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.unmountComponentAtNode(div);
        div.parentNode.removeChild(div);
      }
    });
  }
  __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Notification, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, props, { ref: ref })), div);
};

/* harmony default export */ __webpack_exports__["a"] = (Notification);

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

/* harmony default export */ __webpack_exports__["a"] = (unsafeLifecyclesPolyfill);

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(466);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);









var Notice = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Notice, _Component);

  function Notice() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Notice);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Notice.__proto__ || Object.getPrototypeOf(Notice)).call.apply(_ref, [this].concat(args))), _this), _this.close = function (e) {
      if (e) {
        e.stopPropagation();
      }
      _this.clearCloseTimer();
      _this.props.onClose();
    }, _this.startCloseTimer = function () {
      if (_this.props.duration) {
        _this.closeTimer = setTimeout(function () {
          _this.close();
        }, _this.props.duration * 1000);
      }
    }, _this.clearCloseTimer = function () {
      if (_this.closeTimer) {
        clearTimeout(_this.closeTimer);
        _this.closeTimer = null;
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Notice, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startCloseTimer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.duration !== prevProps.duration || this.props.update) {
        this.restartCloseTimer();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearCloseTimer();
    }
  }, {
    key: 'restartCloseTimer',
    value: function restartCloseTimer() {
      this.clearCloseTimer();
      this.startCloseTimer();
    }
  }, {
    key: 'render',
    value: function render() {
      var _className;

      var props = this.props;
      var componentClass = props.prefixCls + '-notice';
      var className = (_className = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_className, '' + componentClass, 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_className, componentClass + '-closable', props.closable), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_className, props.className, !!props.className), _className);
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className),
          style: props.style,
          onMouseEnter: this.clearCloseTimer,
          onMouseLeave: this.startCloseTimer,
          onClick: props.onClick
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: componentClass + '-content' },
          props.children
        ),
        props.closable ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'a',
          { tabIndex: '0', onClick: this.close, className: componentClass + '-close' },
          props.closeIcon || __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: componentClass + '-close-x' })
        ) : null
      );
    }
  }]);

  return Notice;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Notice.propTypes = {
  duration: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  onClose: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  update: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  closeIcon: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Notice.defaultProps = {
  onEnd: function onEnd() {},
  onClose: function onClose() {},

  duration: 1.5,
  style: {
    right: '50%'
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Notice);

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcNotification = _interopRequireDefault(__webpack_require__(464));

var _icon = _interopRequireDefault(__webpack_require__(38));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var notificationInstance = {};
var defaultDuration = 4.5;
var defaultTop = 24;
var defaultBottom = 24;
var defaultPlacement = 'topRight';
var defaultGetContainer;
var defaultCloseIcon;

function setNotificationConfig(options) {
  var duration = options.duration,
      placement = options.placement,
      bottom = options.bottom,
      top = options.top,
      getContainer = options.getContainer,
      closeIcon = options.closeIcon;

  if (duration !== undefined) {
    defaultDuration = duration;
  }

  if (placement !== undefined) {
    defaultPlacement = placement;
  }

  if (bottom !== undefined) {
    defaultBottom = bottom;
  }

  if (top !== undefined) {
    defaultTop = top;
  }

  if (getContainer !== undefined) {
    defaultGetContainer = getContainer;
  }

  if (closeIcon !== undefined) {
    defaultCloseIcon = closeIcon;
  }
}

function getPlacementStyle(placement) {
  var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultTop;
  var bottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultBottom;
  var style;

  switch (placement) {
    case 'topLeft':
      style = {
        left: 0,
        top: top,
        bottom: 'auto'
      };
      break;

    case 'topRight':
      style = {
        right: 0,
        top: top,
        bottom: 'auto'
      };
      break;

    case 'bottomLeft':
      style = {
        left: 0,
        top: 'auto',
        bottom: bottom
      };
      break;

    default:
      style = {
        right: 0,
        top: 'auto',
        bottom: bottom
      };
      break;
  }

  return style;
}

function getNotificationInstance(_ref, callback) {
  var prefixCls = _ref.prefixCls,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? defaultPlacement : _ref$placement,
      _ref$getContainer = _ref.getContainer,
      getContainer = _ref$getContainer === void 0 ? defaultGetContainer : _ref$getContainer,
      top = _ref.top,
      bottom = _ref.bottom,
      _ref$closeIcon = _ref.closeIcon,
      closeIcon = _ref$closeIcon === void 0 ? defaultCloseIcon : _ref$closeIcon;
  var cacheKey = "".concat(prefixCls, "-").concat(placement);

  if (notificationInstance[cacheKey]) {
    callback(notificationInstance[cacheKey]);
    return;
  }

  var closeIconToRender = /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-close-x")
  }, closeIcon || /*#__PURE__*/React.createElement(_icon["default"], {
    className: "".concat(prefixCls, "-close-icon"),
    type: "close"
  }));

  _rcNotification["default"].newInstance({
    prefixCls: prefixCls,
    className: "".concat(prefixCls, "-").concat(placement),
    style: getPlacementStyle(placement, top, bottom),
    getContainer: getContainer,
    closeIcon: closeIconToRender
  }, function (notification) {
    notificationInstance[cacheKey] = notification;
    callback(notification);
  });
}

var typeToIcon = {
  success: 'check-circle-o',
  info: 'info-circle-o',
  error: 'close-circle-o',
  warning: 'exclamation-circle-o'
};

function notice(args) {
  var outerPrefixCls = args.prefixCls || 'ant-notification';
  var prefixCls = "".concat(outerPrefixCls, "-notice");
  var duration = args.duration === undefined ? defaultDuration : args.duration;
  var iconNode = null;

  if (args.icon) {
    iconNode = /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-icon")
    }, args.icon);
  } else if (args.type) {
    var iconType = typeToIcon[args.type];
    iconNode = /*#__PURE__*/React.createElement(_icon["default"], {
      className: "".concat(prefixCls, "-icon ").concat(prefixCls, "-icon-").concat(args.type),
      type: iconType
    });
  }

  var autoMarginTag = !args.description && iconNode ? /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-message-single-line-auto-margin")
  }) : null;
  var placement = args.placement,
      top = args.top,
      bottom = args.bottom,
      getContainer = args.getContainer,
      closeIcon = args.closeIcon;
  getNotificationInstance({
    prefixCls: outerPrefixCls,
    placement: placement,
    top: top,
    bottom: bottom,
    getContainer: getContainer,
    closeIcon: closeIcon
  }, function (notification) {
    notification.notice({
      content: /*#__PURE__*/React.createElement("div", {
        className: iconNode ? "".concat(prefixCls, "-with-icon") : ''
      }, iconNode, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-message")
      }, autoMarginTag, args.message), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-description")
      }, args.description), args.btn ? /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-btn")
      }, args.btn) : null),
      duration: duration,
      closable: true,
      onClose: args.onClose,
      onClick: args.onClick,
      key: args.key,
      style: args.style || {},
      className: args.className
    });
  });
}

var api = {
  open: notice,
  close: function close(key) {
    Object.keys(notificationInstance).forEach(function (cacheKey) {
      return notificationInstance[cacheKey].removeNotice(key);
    });
  },
  config: setNotificationConfig,
  destroy: function destroy() {
    Object.keys(notificationInstance).forEach(function (cacheKey) {
      notificationInstance[cacheKey].destroy();
      delete notificationInstance[cacheKey];
    });
  }
};
['success', 'info', 'warning', 'error'].forEach(function (type) {
  api[type] = function (args) {
    return api.open(_extends(_extends({}, args), {
      type: type
    }));
  };
});
api.warn = api.warning;
var _default = api;
exports["default"] = _default;

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dialog__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_PortalWrapper__ = __webpack_require__(823);




// fix issue #10656
/*
* getContainer remarks
* Custom container should not be return, because in the Portal component, it will remove the
* return container element here, if the custom container is the only child of it's component,
* like issue #10656, It will has a conflict with removeChild method in react-dom.
* So here should add a child (div element) to custom container.
* */
/* harmony default export */ __webpack_exports__["default"] = (function (props) {
    var visible = props.visible,
        getContainer = props.getContainer,
        forceRender = props.forceRender;
    // 渲染在当前 dom 里；

    if (getContainer === false) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Dialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { getOpenCount: function getOpenCount() {
                return 2;
            } }));
    }
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_util_es_PortalWrapper__["a" /* default */], { visible: visible, forceRender: forceRender, getContainer: getContainer }, function (childProps) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Dialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, childProps));
    });
});

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LazyRenderBox__ = __webpack_require__(822);










var uuid = 0;
/* eslint react/no-is-mounted:0 */
function getScroll(w, top) {
    var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
    var method = 'scroll' + (top ? 'Top' : 'Left');
    if (typeof ret !== 'number') {
        var d = w.document;
        ret = d.documentElement[method];
        if (typeof ret !== 'number') {
            ret = d.body[method];
        }
    }
    return ret;
}
function setTransformOrigin(node, value) {
    var style = node.style;
    ['Webkit', 'Moz', 'Ms', 'ms'].forEach(function (prefix) {
        style[prefix + 'TransformOrigin'] = value;
    });
    style['transformOrigin'] = value;
}
function offset(el) {
    var rect = el.getBoundingClientRect();
    var pos = {
        left: rect.left,
        top: rect.top
    };
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += getScroll(w);
    pos.top += getScroll(w, true);
    return pos;
}

var Dialog = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Dialog, _React$Component);

    function Dialog(props) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Dialog);

        var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

        _this.inTransition = false;
        _this.onAnimateLeave = function () {
            var afterClose = _this.props.afterClose;
            // need demo?
            // https://github.com/react-component/dialog/pull/28

            if (_this.wrap) {
                _this.wrap.style.display = 'none';
            }
            _this.inTransition = false;
            _this.switchScrollingEffect();
            if (afterClose) {
                afterClose();
            }
        };
        _this.onDialogMouseDown = function () {
            _this.dialogMouseDown = true;
        };
        _this.onMaskMouseUp = function () {
            if (_this.dialogMouseDown) {
                _this.timeoutId = setTimeout(function () {
                    _this.dialogMouseDown = false;
                }, 0);
            }
        };
        _this.onMaskClick = function (e) {
            // android trigger click on open (fastclick??)
            if (Date.now() - _this.openTime < 300) {
                return;
            }
            if (e.target === e.currentTarget && !_this.dialogMouseDown) {
                _this.close(e);
            }
        };
        _this.onKeyDown = function (e) {
            var props = _this.props;
            if (props.keyboard && e.keyCode === __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__["a" /* default */].ESC) {
                e.stopPropagation();
                _this.close(e);
                return;
            }
            // keep focus inside dialog
            if (props.visible) {
                if (e.keyCode === __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__["a" /* default */].TAB) {
                    var activeElement = document.activeElement;
                    var sentinelStart = _this.sentinelStart;
                    if (e.shiftKey) {
                        if (activeElement === sentinelStart) {
                            _this.sentinelEnd.focus();
                        }
                    } else if (activeElement === _this.sentinelEnd) {
                        sentinelStart.focus();
                    }
                }
            }
        };
        _this.getDialogElement = function () {
            var props = _this.props;
            var closable = props.closable;
            var prefixCls = props.prefixCls;
            var dest = {};
            if (props.width !== undefined) {
                dest.width = props.width;
            }
            if (props.height !== undefined) {
                dest.height = props.height;
            }
            var footer = void 0;
            if (props.footer) {
                footer = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: prefixCls + '-footer', ref: _this.saveRef('footer') }, props.footer);
            }
            var header = void 0;
            if (props.title) {
                header = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: prefixCls + '-header', ref: _this.saveRef('header') }, __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: prefixCls + '-title', id: _this.titleId }, props.title));
            }
            var closer = void 0;
            if (closable) {
                closer = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("button", { type: "button", onClick: _this.close, "aria-label": "Close", className: prefixCls + '-close' }, props.closeIcon || __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("span", { className: prefixCls + '-close-x' }));
            }
            var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props.style, dest);
            var sentinelStyle = { width: 0, height: 0, overflow: 'hidden', outline: 'none' };
            var transitionName = _this.getTransitionName();
            var dialogElement = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__LazyRenderBox__["a" /* default */], { key: "dialog-element", role: "document", ref: _this.saveRef('dialog'), style: style, className: prefixCls + ' ' + (props.className || ''), visible: props.visible, forceRender: props.forceRender, onMouseDown: _this.onDialogMouseDown }, __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { tabIndex: 0, ref: _this.saveRef('sentinelStart'), style: sentinelStyle, "aria-hidden": "true" }), __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: prefixCls + '-content' }, closer, header, __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: prefixCls + '-body', style: props.bodyStyle, ref: _this.saveRef('body') }, props.bodyProps), props.children), footer), __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { tabIndex: 0, ref: _this.saveRef('sentinelEnd'), style: sentinelStyle, "aria-hidden": "true" }));
            return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_rc_animate__["default"], { key: "dialog", showProp: "visible", onLeave: _this.onAnimateLeave, transitionName: transitionName, component: "", transitionAppear: true }, props.visible || !props.destroyOnClose ? dialogElement : null);
        };
        _this.getZIndexStyle = function () {
            var style = {};
            var props = _this.props;
            if (props.zIndex !== undefined) {
                style.zIndex = props.zIndex;
            }
            return style;
        };
        _this.getWrapStyle = function () {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.getZIndexStyle(), _this.props.wrapStyle);
        };
        _this.getMaskStyle = function () {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.getZIndexStyle(), _this.props.maskStyle);
        };
        _this.getMaskElement = function () {
            var props = _this.props;
            var maskElement = void 0;
            if (props.mask) {
                var maskTransition = _this.getMaskTransitionName();
                maskElement = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__LazyRenderBox__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ style: _this.getMaskStyle(), key: "mask", className: props.prefixCls + '-mask', hiddenClassName: props.prefixCls + '-mask-hidden', visible: props.visible }, props.maskProps));
                if (maskTransition) {
                    maskElement = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_rc_animate__["default"], { key: "mask", showProp: "visible", transitionAppear: true, component: "", transitionName: maskTransition }, maskElement);
                }
            }
            return maskElement;
        };
        _this.getMaskTransitionName = function () {
            var props = _this.props;
            var transitionName = props.maskTransitionName;
            var animation = props.maskAnimation;
            if (!transitionName && animation) {
                transitionName = props.prefixCls + '-' + animation;
            }
            return transitionName;
        };
        _this.getTransitionName = function () {
            var props = _this.props;
            var transitionName = props.transitionName;
            var animation = props.animation;
            if (!transitionName && animation) {
                transitionName = props.prefixCls + '-' + animation;
            }
            return transitionName;
        };
        _this.close = function (e) {
            var onClose = _this.props.onClose;

            if (onClose) {
                onClose(e);
            }
        };
        _this.saveRef = function (name) {
            return function (node) {
                _this[name] = node;
            };
        };
        _this.titleId = 'rcDialogTitle' + uuid++;
        _this.switchScrollingEffect = props.switchScrollingEffect || function () {};
        return _this;
    }

    Dialog.prototype.componentDidMount = function componentDidMount() {
        this.componentDidUpdate({});
        // if forceRender is true, set element style display to be none;
        if ((this.props.forceRender || this.props.getContainer === false && !this.props.visible) && this.wrap) {
            this.wrap.style.display = 'none';
        }
    };

    Dialog.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _props = this.props,
            visible = _props.visible,
            mask = _props.mask,
            focusTriggerAfterClose = _props.focusTriggerAfterClose;

        var mousePosition = this.props.mousePosition;
        if (visible) {
            // first show
            if (!prevProps.visible) {
                this.openTime = Date.now();
                this.switchScrollingEffect();
                this.tryFocus();
                var dialogNode = __WEBPACK_IMPORTED_MODULE_5_react_dom__["findDOMNode"](this.dialog);
                if (mousePosition) {
                    var elOffset = offset(dialogNode);
                    setTransformOrigin(dialogNode, mousePosition.x - elOffset.left + 'px ' + (mousePosition.y - elOffset.top) + 'px');
                } else {
                    setTransformOrigin(dialogNode, '');
                }
            }
        } else if (prevProps.visible) {
            this.inTransition = true;
            if (mask && this.lastOutSideFocusNode && focusTriggerAfterClose) {
                try {
                    this.lastOutSideFocusNode.focus();
                } catch (e) {
                    this.lastOutSideFocusNode = null;
                }
                this.lastOutSideFocusNode = null;
            }
        }
    };

    Dialog.prototype.componentWillUnmount = function componentWillUnmount() {
        var _props2 = this.props,
            visible = _props2.visible,
            getOpenCount = _props2.getOpenCount;

        if ((visible || this.inTransition) && !getOpenCount()) {
            this.switchScrollingEffect();
        }
        clearTimeout(this.timeoutId);
    };

    Dialog.prototype.tryFocus = function tryFocus() {
        if (!Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__["a" /* default */])(this.wrap, document.activeElement)) {
            this.lastOutSideFocusNode = document.activeElement;
            this.sentinelStart.focus();
        }
    };

    Dialog.prototype.render = function render() {
        var props = this.props;
        var prefixCls = props.prefixCls,
            maskClosable = props.maskClosable;

        var style = this.getWrapStyle();
        // clear hide display
        // and only set display after async anim, not here for hide
        if (props.visible) {
            style.display = null;
        }
        return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: prefixCls + '-root' }, this.getMaskElement(), __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ tabIndex: -1, onKeyDown: this.onKeyDown, className: prefixCls + '-wrap ' + (props.wrapClassName || ''), ref: this.saveRef('wrap'), onClick: maskClosable ? this.onMaskClick : null, onMouseUp: maskClosable ? this.onMaskMouseUp : null, role: "dialog", "aria-labelledby": props.title ? this.titleId : null, style: style }, props.wrapProps), this.getDialogElement()));
    };

    return Dialog;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Dialog);

Dialog.defaultProps = {
    className: '',
    mask: true,
    visible: false,
    keyboard: true,
    closable: true,
    maskClosable: true,
    destroyOnClose: false,
    prefixCls: 'rc-dialog',
    focusTriggerAfterClose: true
};

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);




var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};


var LazyRenderBox = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _React$Component);

    function LazyRenderBox() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
    }

    LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        if (nextProps.forceRender) {
            return true;
        }
        return !!nextProps.hiddenClassName || !!nextProps.visible;
    };

    LazyRenderBox.prototype.render = function render() {
        var _a = this.props,
            className = _a.className,
            hiddenClassName = _a.hiddenClassName,
            visible = _a.visible,
            forceRender = _a.forceRender,
            restProps = __rest(_a, ["className", "hiddenClassName", "visible", "forceRender"]);
        var useClassName = className;
        if (!!hiddenClassName && !visible) {
            useClassName += " " + hiddenClassName;
        }
        return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restProps, { className: useClassName }));
    };

    return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContainerRender__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Portal__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__switchScrollingEffect__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__setStyle__ = __webpack_require__(471);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable no-underscore-dangle,react/require-default-props */








var openCount = 0;
var windowIsUndefined = !(typeof window !== 'undefined' && window.document && window.document.createElement);
var IS_REACT_16 = ('createPortal' in __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a); // https://github.com/ant-design/ant-design/issues/19340
// https://github.com/ant-design/ant-design/issues/19332

var cacheOverflow = {};

var PortalWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(PortalWrapper, _React$Component);

  var _super = _createSuper(PortalWrapper);

  function PortalWrapper(props) {
    var _this;

    _classCallCheck(this, PortalWrapper);

    _this = _super.call(this, props);

    _this.getParent = function () {
      var getContainer = _this.props.getContainer;

      if (getContainer) {
        if (typeof getContainer === 'string') {
          return document.querySelectorAll(getContainer)[0];
        }

        if (typeof getContainer === 'function') {
          return getContainer();
        }

        if (_typeof(getContainer) === 'object' && getContainer instanceof window.HTMLElement) {
          return getContainer;
        }
      }

      return document.body;
    };

    _this.getContainer = function () {
      if (windowIsUndefined) {
        return null;
      }

      if (!_this.container) {
        _this.container = document.createElement('div');

        var parent = _this.getParent();

        if (parent) {
          parent.appendChild(_this.container);
        }
      }

      _this.setWrapperClassName();

      return _this.container;
    };

    _this.setWrapperClassName = function () {
      var wrapperClassName = _this.props.wrapperClassName;

      if (_this.container && wrapperClassName && wrapperClassName !== _this.container.className) {
        _this.container.className = wrapperClassName;
      }
    };

    _this.savePortal = function (c) {
      // Warning: don't rename _component
      // https://github.com/react-component/util/pull/65#discussion_r352407916
      _this._component = c;
    };

    _this.removeCurrentContainer = function (visible) {
      _this.container = null;
      _this._component = null;

      if (!IS_REACT_16) {
        if (visible) {
          _this.renderComponent({
            afterClose: _this.removeContainer,
            onClose: function onClose() {},
            visible: false
          });
        } else {
          _this.removeContainer();
        }
      }
    };

    _this.switchScrollingEffect = function () {
      if (openCount === 1 && !Object.keys(cacheOverflow).length) {
        Object(__WEBPACK_IMPORTED_MODULE_6__switchScrollingEffect__["a" /* default */])(); // Must be set after switchScrollingEffect

        cacheOverflow = Object(__WEBPACK_IMPORTED_MODULE_7__setStyle__["a" /* default */])({
          overflow: 'hidden',
          overflowX: 'hidden',
          overflowY: 'hidden'
        });
      } else if (!openCount) {
        Object(__WEBPACK_IMPORTED_MODULE_7__setStyle__["a" /* default */])(cacheOverflow);
        cacheOverflow = {};
        Object(__WEBPACK_IMPORTED_MODULE_6__switchScrollingEffect__["a" /* default */])(true);
      }
    };

    var _visible = props.visible;
    openCount = _visible ? openCount + 1 : openCount;
    _this.state = {
      _self: _assertThisInitialized(_this)
    };
    return _this;
  }

  _createClass(PortalWrapper, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setWrapperClassName();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var visible = this.props.visible; // 离开时不会 render， 导到离开时数值不变，改用 func 。。

      openCount = visible && openCount ? openCount - 1 : openCount;
      this.removeCurrentContainer(visible);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          forceRender = _this$props.forceRender,
          visible = _this$props.visible;
      var portal = null;
      var childProps = {
        getOpenCount: function getOpenCount() {
          return openCount;
        },
        getContainer: this.getContainer,
        switchScrollingEffect: this.switchScrollingEffect
      }; // suppport react15

      if (!IS_REACT_16) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ContainerRender__["a" /* default */], {
          parent: this,
          visible: visible,
          autoDestroy: false,
          getComponent: function getComponent() {
            var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return children(_objectSpread(_objectSpread(_objectSpread({}, extra), childProps), {}, {
              ref: _this2.savePortal
            }));
          },
          getContainer: this.getContainer,
          forceRender: forceRender
        }, function (_ref) {
          var renderComponent = _ref.renderComponent,
              removeContainer = _ref.removeContainer;
          _this2.renderComponent = renderComponent;
          _this2.removeContainer = removeContainer;
          return null;
        });
      }

      if (forceRender || visible || this._component) {
        portal = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Portal__["a" /* default */], {
          getContainer: this.getContainer,
          ref: this.savePortal
        }, children(childProps));
      }

      return portal;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, _ref2) {
      var prevProps = _ref2.prevProps,
          _self = _ref2._self;
      var visible = props.visible,
          getContainer = props.getContainer;

      if (prevProps) {
        var prevVisible = prevProps.visible,
            prevGetContainer = prevProps.getContainer;

        if (visible !== prevVisible) {
          openCount = visible && !prevVisible ? openCount + 1 : openCount - 1;
        }

        var getContainerIsFunc = typeof getContainer === 'function' && typeof prevGetContainer === 'function';

        if (getContainerIsFunc ? getContainer.toString() !== prevGetContainer.toString() : getContainer !== prevGetContainer) {
          _self.removeCurrentContainer(false);
        }
      }

      return {
        prevProps: props
      };
    }
  }]);

  return PortalWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PortalWrapper.propTypes = {
  wrapperClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  visible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__["polyfill"])(PortalWrapper));

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getScrollBarSize__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setStyle__ = __webpack_require__(471);



function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}

var cacheStyle = {};
/* harmony default export */ __webpack_exports__["a"] = (function (close) {
  if (!isBodyOverflowing() && !close) {
    return;
  } // https://github.com/ant-design/ant-design/issues/19729


  var scrollingEffectClassName = 'ant-scrolling-effect';
  var scrollingEffectClassNameReg = new RegExp("".concat(scrollingEffectClassName), 'g');
  var bodyClassName = document.body.className;

  if (close) {
    if (!scrollingEffectClassNameReg.test(bodyClassName)) return;
    Object(__WEBPACK_IMPORTED_MODULE_1__setStyle__["a" /* default */])(cacheStyle);
    cacheStyle = {};
    document.body.className = bodyClassName.replace(scrollingEffectClassNameReg, '').trim();
    return;
  }

  var scrollBarSize = Object(__WEBPACK_IMPORTED_MODULE_0__getScrollBarSize__["a" /* default */])();

  if (scrollBarSize) {
    cacheStyle = Object(__WEBPACK_IMPORTED_MODULE_1__setStyle__["a" /* default */])({
      position: 'relative',
      width: "calc(100% - ".concat(scrollBarSize, "px)")
    });

    if (!scrollingEffectClassNameReg.test(bodyClassName)) {
      var addClassName = "".concat(bodyClassName, " ").concat(scrollingEffectClassName);
      document.body.className = addClassName.trim();
    }
  }
});

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getScrollBarSize;
var cached;
function getScrollBarSize(fresh) {
  if (typeof document === 'undefined') {
    return 0;
  }

  if (fresh || cached === undefined) {
    var inner = document.createElement('div');
    inner.style.width = '100%';
    inner.style.height = '200px';
    var outer = document.createElement('div');
    var outerStyle = outer.style;
    outerStyle.position = 'absolute';
    outerStyle.top = 0;
    outerStyle.left = 0;
    outerStyle.pointerEvents = 'none';
    outerStyle.visibility = 'hidden';
    outerStyle.width = '200px';
    outerStyle.height = '150px';
    outerStyle.overflow = 'hidden';
    outer.appendChild(inner);
    document.body.appendChild(outer);
    var widthContained = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var widthScroll = inner.offsetWidth;

    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }

    document.body.removeChild(outer);
    cached = widthContained - widthScroll;
  }

  return cached;
}

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventBaseObject = __webpack_require__(827);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(253);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = undefined;
    var deltaY = undefined;
    var delta = undefined;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = undefined;
    var doc = undefined;
    var body = undefined;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2['default'].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = undefined;
  var l = undefined;
  var prop = undefined;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2['default'].prototype;

(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },

  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports['default'] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },

  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },

  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },

  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports["default"];

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = confirm;

var React = _interopRequireWildcard(__webpack_require__(0));

var ReactDOM = _interopRequireWildcard(__webpack_require__(46));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _Modal = _interopRequireWildcard(__webpack_require__(468));

var _ActionButton = _interopRequireDefault(__webpack_require__(829));

var _locale = __webpack_require__(333);

var _warning = _interopRequireDefault(__webpack_require__(69));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IS_REACT_16 = !!ReactDOM.createPortal;

var ConfirmDialog = function ConfirmDialog(props) {
  var onCancel = props.onCancel,
      onOk = props.onOk,
      close = props.close,
      zIndex = props.zIndex,
      afterClose = props.afterClose,
      visible = props.visible,
      keyboard = props.keyboard,
      centered = props.centered,
      getContainer = props.getContainer,
      maskStyle = props.maskStyle,
      okButtonProps = props.okButtonProps,
      cancelButtonProps = props.cancelButtonProps,
      _props$iconType = props.iconType,
      iconType = _props$iconType === void 0 ? 'question-circle' : _props$iconType;
  (0, _warning["default"])(!('iconType' in props), 'Modal', "The property 'iconType' is deprecated. Use the property 'icon' instead."); // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon

  var icon = props.icon === undefined ? iconType : props.icon;
  var okType = props.okType || 'primary';
  var prefixCls = props.prefixCls || 'ant-modal';
  var contentPrefixCls = "".concat(prefixCls, "-confirm"); // 默认为 true，保持向下兼容

  var okCancel = 'okCancel' in props ? props.okCancel : true;
  var width = props.width || 416;
  var style = props.style || {};
  var mask = props.mask === undefined ? true : props.mask; // 默认为 false，保持旧版默认行为

  var maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
  var runtimeLocale = (0, _locale.getConfirmLocale)();
  var okText = props.okText || (okCancel ? runtimeLocale.okText : runtimeLocale.justOkText);
  var cancelText = props.cancelText || runtimeLocale.cancelText;
  var autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
  var transitionName = props.transitionName || 'zoom';
  var maskTransitionName = props.maskTransitionName || 'fade';
  var classString = (0, _classnames["default"])(contentPrefixCls, "".concat(contentPrefixCls, "-").concat(props.type), props.className);
  var cancelButton = okCancel && /*#__PURE__*/React.createElement(_ActionButton["default"], {
    actionFn: onCancel,
    closeModal: close,
    autoFocus: autoFocusButton === 'cancel',
    buttonProps: cancelButtonProps
  }, cancelText);
  var iconNode = typeof icon === 'string' ? /*#__PURE__*/React.createElement(_icon["default"], {
    type: icon
  }) : icon;
  return /*#__PURE__*/React.createElement(_Modal["default"], {
    prefixCls: prefixCls,
    className: classString,
    wrapClassName: (0, _classnames["default"])(_defineProperty({}, "".concat(contentPrefixCls, "-centered"), !!props.centered)),
    onCancel: function onCancel() {
      return close({
        triggerCancel: true
      });
    },
    visible: visible,
    title: "",
    transitionName: transitionName,
    footer: "",
    maskTransitionName: maskTransitionName,
    mask: mask,
    maskClosable: maskClosable,
    maskStyle: maskStyle,
    style: style,
    width: width,
    zIndex: zIndex,
    afterClose: afterClose,
    keyboard: keyboard,
    centered: centered,
    getContainer: getContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(contentPrefixCls, "-body-wrapper")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(contentPrefixCls, "-body")
  }, iconNode, props.title === undefined ? null : /*#__PURE__*/React.createElement("span", {
    className: "".concat(contentPrefixCls, "-title")
  }, props.title), /*#__PURE__*/React.createElement("div", {
    className: "".concat(contentPrefixCls, "-content")
  }, props.content)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(contentPrefixCls, "-btns")
  }, cancelButton, /*#__PURE__*/React.createElement(_ActionButton["default"], {
    type: okType,
    actionFn: onOk,
    closeModal: close,
    autoFocus: autoFocusButton === 'ok',
    buttonProps: okButtonProps
  }, okText))));
};

function confirm(config) {
  var div = document.createElement('div');
  document.body.appendChild(div); // eslint-disable-next-line no-use-before-define

  var currentConfig = _extends(_extends({}, config), {
    close: close,
    visible: true
  });

  function destroy() {
    var unmountResult = ReactDOM.unmountComponentAtNode(div);

    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var triggerCancel = args.some(function (param) {
      return param && param.triggerCancel;
    });

    if (config.onCancel && triggerCancel) {
      config.onCancel.apply(config, args);
    }

    for (var i = 0; i < _Modal.destroyFns.length; i++) {
      var fn = _Modal.destroyFns[i]; // eslint-disable-next-line no-use-before-define

      if (fn === close) {
        _Modal.destroyFns.splice(i, 1);

        break;
      }
    }
  }

  function render(props) {
    ReactDOM.render( /*#__PURE__*/React.createElement(ConfirmDialog, props), div);
  }

  function close() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    currentConfig = _extends(_extends({}, currentConfig), {
      visible: false,
      afterClose: destroy.bind.apply(destroy, [this].concat(args))
    });

    if (IS_REACT_16) {
      render(currentConfig);
    } else {
      destroy.apply(void 0, args);
    }
  }

  function update(newConfig) {
    currentConfig = _extends(_extends({}, currentConfig), newConfig);
    render(currentConfig);
  }

  render(currentConfig);

  _Modal.destroyFns.push(close);

  return {
    destroy: close,
    update: update
  };
}

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var ReactDOM = _interopRequireWildcard(__webpack_require__(46));

var _button = _interopRequireDefault(__webpack_require__(5));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ActionButton = /*#__PURE__*/function (_React$Component) {
  _inherits(ActionButton, _React$Component);

  var _super = _createSuper(ActionButton);

  function ActionButton(props) {
    var _this;

    _classCallCheck(this, ActionButton);

    _this = _super.call(this, props);

    _this.onClick = function () {
      var _this$props = _this.props,
          actionFn = _this$props.actionFn,
          closeModal = _this$props.closeModal;

      if (actionFn) {
        var ret;

        if (actionFn.length) {
          ret = actionFn(closeModal);
        } else {
          ret = actionFn();

          if (!ret) {
            closeModal();
          }
        }

        if (ret && ret.then) {
          _this.setState({
            loading: true
          });

          ret.then(function () {
            // It's unnecessary to set loading=false, for the Modal will be unmounted after close.
            // this.setState({ loading: false });
            closeModal.apply(void 0, arguments);
          }, function (e) {
            // Emit error when catch promise reject
            // eslint-disable-next-line no-console
            console.error(e); // See: https://github.com/ant-design/ant-design/issues/6183

            _this.setState({
              loading: false
            });
          });
        }
      } else {
        closeModal();
      }
    };

    _this.state = {
      loading: false
    };
    return _this;
  }

  _createClass(ActionButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocus) {
        var $this = ReactDOM.findDOMNode(this);
        this.timeoutId = setTimeout(function () {
          return $this.focus();
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeoutId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          type = _this$props2.type,
          children = _this$props2.children,
          buttonProps = _this$props2.buttonProps;
      var loading = this.state.loading;
      return /*#__PURE__*/React.createElement(_button["default"], _extends({
        type: type,
        onClick: this.onClick,
        loading: loading
      }, buttonProps), children);
    }
  }]);

  return ActionButton;
}(React.Component);

exports["default"] = ActionButton;

/***/ }),
/* 830 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(834);

/***/ }),
/* 834 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 835 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(339);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _extends; });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}




/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(339);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(844);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(340);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(473);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(848);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(850);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(477);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(852);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(340);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(854);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(341);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(477);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(341);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(858);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(475);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _icon=__webpack_require__(38);var _icon2=_interopRequireDefault(_icon);var _divider=__webpack_require__(343);var _divider2=_interopRequireDefault(_divider);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(6);__webpack_require__(25);__webpack_require__(75);__webpack_require__(344);__webpack_require__(4);__webpack_require__(10);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(883);var _logo=__webpack_require__(884);var _logo2=_interopRequireDefault(_logo);var _logo3=__webpack_require__(885);var _logo4=_interopRequireDefault(_logo3);var _logo5=__webpack_require__(886);var _logo6=_interopRequireDefault(_logo5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoginSales=function(_Component){_inherits(LoginSales,_Component);function LoginSales(props){_classCallCheck(this,LoginSales);var _this=_possibleConstructorReturn(this,(LoginSales.__proto__||Object.getPrototypeOf(LoginSales)).call(this,props));_this.submit=function(){var _this$state=_this.state,name=_this$state.name,password=_this$state.password,submit=_this$state.submit;var that=_this;var text=/^1[34578]\d{9}$|[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;if(!name){_this.setState({submit:_extends({},submit,{name:1})});_message3.default.error("请输入正确帐号！");return;}if(!password){_this.setState({submit:_extends({},submit,{password:1})});_message3.default.error("请输入密码！");return;}_this.setState({loading:true});var url='/auth/login';fetch(url,{method:'post',credentials:'include',headers:{"Content-type":"application/x-www-form-urlencoded; charset=UTF-8"},body:'email='+name+'&password='+password}).then(function(response){return response.json();}).then(function(data){if(data&&data.status===1){sessionStorage.user=JSON.stringify(data.data);_message3.default.success('登录成功');window.location.href='/';}else{that.setState({loading:false});_message3.default.error(data.msg);return;}}).catch(function(err){that.setState({loading:false});_message3.default.error("登录失败！");console.error(err);});};_this.state={name:"",password:"",submit:{name:0,password:0},loading:false};return _this;}_createClass(LoginSales,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;//注册键盘事件  
document.onkeydown=function(e){if(e.keyCode==13&&window.location.hash==='#/login'){_this2.submit();}};}},{key:'render',value:function render(){var _this3=this;return _react2.default.createElement('div',{className:'sales_login'},_react2.default.createElement(_row2.default,{className:'login-img'},_react2.default.createElement('div',null,_react2.default.createElement('img',{src:_logo6.default,alt:''})),_react2.default.createElement('div',null,_react2.default.createElement('img',{src:_logo2.default,alt:''})),_react2.default.createElement('div',null,_react2.default.createElement('img',{src:_logo4.default,alt:''}))),_react2.default.createElement(_row2.default,{style:{marginTop:"16vh",position:"relative"},className:'ant-form-item-control-wrapper'},_react2.default.createElement('div',{className:'login-divider'},_react2.default.createElement(_divider2.default,{style:{color:"#fff"}},'\u767B\u5F55')),_react2.default.createElement(_input2.default,{type:'text',placeholder:'\u8BF7\u8F93\u5165\u5E10\u53F7',value:this.state.name,className:'login_input',prefix:_react2.default.createElement(_icon2.default,{type:'user',style:{color:'rgba(0,0,0,.25)',fontSize:18}}),style:{boxShadow:!this.state.submit.name?"":"0 0 4px 2px red"},onChange:function onChange(e){if(e.target.value){_this3.setState({submit:_extends({},_this3.state.submit,{name:0})});}else{_this3.setState({submit:_extends({},_this3.state.submit,{name:1})});}_this3.setState({name:e.target.value});}})),_react2.default.createElement(_row2.default,{style:{marginTop:20,position:"relative"}},_react2.default.createElement(_input2.default,{type:'password',placeholder:'\u8BF7\u8F93\u5165\u5BC6\u7801',className:'login_input',value:this.state.password,prefix:_react2.default.createElement(_icon2.default,{type:'lock',style:{color:'rgba(0,0,0,.25)',fontSize:18}}),style:{boxShadow:!this.state.submit.password?"":"0 0 4px 2px red"},onChange:function onChange(e){if(e.target.value){_this3.setState({submit:_extends({},_this3.state.submit,{password:0})});}else{_this3.setState({submit:_extends({},_this3.state.submit,{password:1})});}_this3.setState({password:e.target.value});}})),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.submit,loading:this.state.loading,style:{width:'420px',height:50,marginTop:40,borderRadius:'30px',maxWidth:'100%'}},'\u767B\u5F55'));}}]);return LoginSales;}(_react.Component);exports.default=LoginSales;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _configProvider = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Group = function Group(props) {
  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var _classNames;

    var getPrefixCls = _ref.getPrefixCls;
    var customizePrefixCls = props.prefixCls,
        _props$className = props.className,
        className = _props$className === void 0 ? '' : _props$className;
    var prefixCls = getPrefixCls('input-group', customizePrefixCls);
    var cls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), props.size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), props.size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-compact"), props.compact), _classNames), className);
    return /*#__PURE__*/React.createElement("span", {
      className: cls,
      style: props.style,
      onMouseEnter: props.onMouseEnter,
      onMouseLeave: props.onMouseLeave,
      onFocus: props.onFocus,
      onBlur: props.onBlur
    }, props.children);
  });
};

var _default = Group;
exports["default"] = _default;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _isMobile = __webpack_require__(863);

var _Input = _interopRequireDefault(__webpack_require__(221));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _button = _interopRequireDefault(__webpack_require__(5));

var _configProvider = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Search = /*#__PURE__*/function (_React$Component) {
  _inherits(Search, _React$Component);

  var _super = _createSuper(Search);

  function Search() {
    var _this;

    _classCallCheck(this, Search);

    _this = _super.apply(this, arguments);

    _this.saveInput = function (node) {
      _this.input = node;
    };

    _this.onChange = function (e) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onSearch = _this$props.onSearch;

      if (e && e.target && e.type === 'click' && onSearch) {
        onSearch(e.target.value, e);
      }

      if (onChange) {
        onChange(e);
      }
    };

    _this.onSearch = function (e) {
      var _this$props2 = _this.props,
          onSearch = _this$props2.onSearch,
          loading = _this$props2.loading,
          disabled = _this$props2.disabled;

      if (loading || disabled) {
        return;
      }

      if (onSearch) {
        onSearch(_this.input.input.value, e);
      }

      if (!(0, _isMobile.isMobile)({
        tablet: true
      })) {
        _this.input.focus();
      }
    };

    _this.renderLoading = function (prefixCls) {
      var _this$props3 = _this.props,
          enterButton = _this$props3.enterButton,
          size = _this$props3.size;

      if (enterButton) {
        return /*#__PURE__*/React.createElement(_button["default"], {
          className: "".concat(prefixCls, "-button"),
          type: "primary",
          size: size,
          key: "enterButton"
        }, /*#__PURE__*/React.createElement(_icon["default"], {
          type: "loading"
        }));
      }

      return /*#__PURE__*/React.createElement(_icon["default"], {
        className: "".concat(prefixCls, "-icon"),
        type: "loading",
        key: "loadingIcon"
      });
    };

    _this.renderSuffix = function (prefixCls) {
      var _this$props4 = _this.props,
          suffix = _this$props4.suffix,
          enterButton = _this$props4.enterButton,
          loading = _this$props4.loading;

      if (loading && !enterButton) {
        return [suffix, _this.renderLoading(prefixCls)];
      }

      if (enterButton) return suffix;
      var icon = /*#__PURE__*/React.createElement(_icon["default"], {
        className: "".concat(prefixCls, "-icon"),
        type: "search",
        key: "searchIcon",
        onClick: _this.onSearch
      });

      if (suffix) {
        return [/*#__PURE__*/React.isValidElement(suffix) ? /*#__PURE__*/React.cloneElement(suffix, {
          key: 'suffix'
        }) : null, icon];
      }

      return icon;
    };

    _this.renderAddonAfter = function (prefixCls) {
      var _this$props5 = _this.props,
          enterButton = _this$props5.enterButton,
          size = _this$props5.size,
          disabled = _this$props5.disabled,
          addonAfter = _this$props5.addonAfter,
          loading = _this$props5.loading;
      var btnClassName = "".concat(prefixCls, "-button");

      if (loading && enterButton) {
        return [_this.renderLoading(prefixCls), addonAfter];
      }

      if (!enterButton) return addonAfter;
      var button;
      var enterButtonAsElement = enterButton;
      var isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;

      if (isAntdButton || enterButtonAsElement.type === 'button') {
        button = /*#__PURE__*/React.cloneElement(enterButtonAsElement, _extends({
          onClick: _this.onSearch,
          key: 'enterButton'
        }, isAntdButton ? {
          className: btnClassName,
          size: size
        } : {}));
      } else {
        button = /*#__PURE__*/React.createElement(_button["default"], {
          className: btnClassName,
          type: "primary",
          size: size,
          disabled: disabled,
          key: "enterButton",
          onClick: _this.onSearch
        }, enterButton === true ? /*#__PURE__*/React.createElement(_icon["default"], {
          type: "search"
        }) : enterButton);
      }

      if (addonAfter) {
        return [button, /*#__PURE__*/React.isValidElement(addonAfter) ? /*#__PURE__*/React.cloneElement(addonAfter, {
          key: 'addonAfter'
        }) : null];
      }

      return button;
    };

    _this.renderSearch = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          customizeInputPrefixCls = _a.inputPrefixCls,
          size = _a.size,
          enterButton = _a.enterButton,
          className = _a.className,
          restProps = __rest(_a, ["prefixCls", "inputPrefixCls", "size", "enterButton", "className"]);

      delete restProps.onSearch;
      delete restProps.loading;
      var prefixCls = getPrefixCls('input-search', customizePrefixCls);
      var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
      var inputClassName;

      if (enterButton) {
        var _classNames;

        inputClassName = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-enter-button"), !!enterButton), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), !!size), _classNames));
      } else {
        inputClassName = (0, _classnames["default"])(prefixCls, className);
      }

      return /*#__PURE__*/React.createElement(_Input["default"], _extends({
        onPressEnter: _this.onSearch
      }, restProps, {
        size: size,
        prefixCls: inputPrefixCls,
        addonAfter: _this.renderAddonAfter(prefixCls),
        suffix: _this.renderSuffix(prefixCls),
        onChange: _this.onChange,
        ref: _this.saveInput,
        className: inputClassName
      }));
    };

    return _this;
  }

  _createClass(Search, [{
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSearch);
    }
  }]);

  return Search;
}(React.Component);

exports["default"] = Search;
Search.defaultProps = {
  enterButton: false
};

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = isMobile
module.exports.isMobile = isMobile
module.exports.default = isMobile

var mobileRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i

var tabletRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i

function isMobile (opts) {
  if (!opts) opts = {}
  var ua = opts.ua
  if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent
  if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') {
    ua = ua.headers['user-agent']
  }
  if (typeof ua !== 'string') return false

  var result = opts.tablet ? tabletRE.test(ua) : mobileRE.test(ua)

  if (
    !result &&
    opts.tablet &&
    opts.featureDetect &&
    navigator &&
    navigator.maxTouchPoints > 1 &&
    ua.indexOf('Macintosh') !== -1 &&
    ua.indexOf('Safari') !== -1
  ) {
    result = true
  }

  return result
}


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(36);

var _ClearableLabeledInput = _interopRequireDefault(__webpack_require__(478));

var _ResizableTextArea = _interopRequireDefault(__webpack_require__(865));

var _configProvider = __webpack_require__(39);

var _Input = __webpack_require__(221);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var TextArea = /*#__PURE__*/function (_React$Component) {
  _inherits(TextArea, _React$Component);

  var _super = _createSuper(TextArea);

  function TextArea(props) {
    var _this;

    _classCallCheck(this, TextArea);

    _this = _super.call(this, props);

    _this.saveTextArea = function (resizableTextArea) {
      _this.resizableTextArea = resizableTextArea;
    };

    _this.saveClearableInput = function (clearableInput) {
      _this.clearableInput = clearableInput;
    };

    _this.handleChange = function (e) {
      _this.setValue(e.target.value, function () {
        _this.resizableTextArea.resizeTextarea();
      });

      (0, _Input.resolveOnChange)(_this.resizableTextArea.textArea, e, _this.props.onChange);
    };

    _this.handleKeyDown = function (e) {
      var _this$props = _this.props,
          onPressEnter = _this$props.onPressEnter,
          onKeyDown = _this$props.onKeyDown;

      if (e.keyCode === 13 && onPressEnter) {
        onPressEnter(e);
      }

      if (onKeyDown) {
        onKeyDown(e);
      }
    };

    _this.handleReset = function (e) {
      _this.setValue('', function () {
        _this.resizableTextArea.renderTextArea();

        _this.focus();
      });

      (0, _Input.resolveOnChange)(_this.resizableTextArea.textArea, e, _this.props.onChange);
    };

    _this.renderTextArea = function (prefixCls) {
      return /*#__PURE__*/React.createElement(_ResizableTextArea["default"], _extends({}, _this.props, {
        prefixCls: prefixCls,
        onKeyDown: _this.handleKeyDown,
        onChange: _this.handleChange,
        ref: _this.saveTextArea
      }));
    };

    _this.renderComponent = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var value = _this.state.value;
      var customizePrefixCls = _this.props.prefixCls;
      var prefixCls = getPrefixCls('input', customizePrefixCls);
      return /*#__PURE__*/React.createElement(_ClearableLabeledInput["default"], _extends({}, _this.props, {
        prefixCls: prefixCls,
        inputType: "text",
        value: (0, _Input.fixControlledValue)(value),
        element: _this.renderTextArea(prefixCls),
        handleReset: _this.handleReset,
        ref: _this.saveClearableInput
      }));
    };

    var value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
    _this.state = {
      value: value
    };
    return _this;
  }

  _createClass(TextArea, [{
    key: "setValue",
    value: function setValue(value, callback) {
      if (!('value' in this.props)) {
        this.setState({
          value: value
        }, callback);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.resizableTextArea.textArea.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.resizableTextArea.textArea.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: nextProps.value
        };
      }

      return null;
    }
  }]);

  return TextArea;
}(React.Component);

(0, _reactLifecyclesCompat.polyfill)(TextArea);
var _default = TextArea;
exports["default"] = _default;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(36);

var _rcResizeObserver = _interopRequireDefault(__webpack_require__(866));

var _omit = _interopRequireDefault(__webpack_require__(71));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _calculateNodeHeight = _interopRequireDefault(__webpack_require__(870));

var _raf = _interopRequireDefault(__webpack_require__(335));

var _warning = _interopRequireDefault(__webpack_require__(69));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ResizableTextArea = /*#__PURE__*/function (_React$Component) {
  _inherits(ResizableTextArea, _React$Component);

  var _super = _createSuper(ResizableTextArea);

  function ResizableTextArea(props) {
    var _this;

    _classCallCheck(this, ResizableTextArea);

    _this = _super.call(this, props);

    _this.saveTextArea = function (textArea) {
      _this.textArea = textArea;
    };

    _this.resizeOnNextFrame = function () {
      _raf["default"].cancel(_this.nextFrameActionId);

      _this.nextFrameActionId = (0, _raf["default"])(_this.resizeTextarea);
    };

    _this.resizeTextarea = function () {
      var autoSize = _this.props.autoSize || _this.props.autosize;

      if (!autoSize || !_this.textArea) {
        return;
      }

      var minRows = autoSize.minRows,
          maxRows = autoSize.maxRows;
      var textareaStyles = (0, _calculateNodeHeight["default"])(_this.textArea, false, minRows, maxRows);

      _this.setState({
        textareaStyles: textareaStyles,
        resizing: true
      }, function () {
        _raf["default"].cancel(_this.resizeFrameId);

        _this.resizeFrameId = (0, _raf["default"])(function () {
          _this.setState({
            resizing: false
          });

          _this.fixFirefoxAutoScroll();
        });
      });
    };

    _this.renderTextArea = function () {
      var _this$props = _this.props,
          prefixCls = _this$props.prefixCls,
          autoSize = _this$props.autoSize,
          autosize = _this$props.autosize,
          className = _this$props.className,
          disabled = _this$props.disabled;
      var _this$state = _this.state,
          textareaStyles = _this$state.textareaStyles,
          resizing = _this$state.resizing;
      (0, _warning["default"])(autosize === undefined, 'Input.TextArea', 'autosize is deprecated, please use autoSize instead.');
      var otherProps = (0, _omit["default"])(_this.props, ['prefixCls', 'onPressEnter', 'autoSize', 'autosize', 'defaultValue', 'allowClear']);
      var cls = (0, _classnames["default"])(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-disabled"), disabled)); // Fix https://github.com/ant-design/ant-design/issues/6776
      // Make sure it could be reset when using form.getFieldDecorator

      if ('value' in otherProps) {
        otherProps.value = otherProps.value || '';
      }

      var style = _extends(_extends(_extends({}, _this.props.style), textareaStyles), resizing ? {
        overflowX: 'hidden',
        overflowY: 'hidden'
      } : null);

      return /*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
        onResize: _this.resizeOnNextFrame,
        disabled: !(autoSize || autosize)
      }, /*#__PURE__*/React.createElement("textarea", _extends({}, otherProps, {
        className: cls,
        style: style,
        ref: _this.saveTextArea
      })));
    };

    _this.state = {
      textareaStyles: {},
      resizing: false
    };
    return _this;
  }

  _createClass(ResizableTextArea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resizeTextarea();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Re-render with the new content then recalculate the height as required.
      if (prevProps.value !== this.props.value) {
        this.resizeTextarea();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _raf["default"].cancel(this.nextFrameActionId);

      _raf["default"].cancel(this.resizeFrameId);
    } // https://github.com/ant-design/ant-design/issues/21870

  }, {
    key: "fixFirefoxAutoScroll",
    value: function fixFirefoxAutoScroll() {
      try {
        if (document.activeElement === this.textArea) {
          var currentStart = this.textArea.selectionStart;
          var currentEnd = this.textArea.selectionEnd;
          this.textArea.setSelectionRange(currentStart, currentEnd);
        }
      } catch (e) {// Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderTextArea();
    }
  }]);

  return ResizableTextArea;
}(React.Component);

(0, _reactLifecyclesCompat.polyfill)(ResizableTextArea);
var _default = ResizableTextArea;
exports["default"] = _default;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var findDOMNode_1 = __importDefault(__webpack_require__(479));

var toArray_1 = __importDefault(__webpack_require__(342));

var warning_1 = __importDefault(__webpack_require__(259));

var ref_1 = __webpack_require__(868);

var resize_observer_polyfill_1 = __importDefault(__webpack_require__(481));

var util_1 = __webpack_require__(869);

var INTERNAL_PREFIX_KEY = 'rc-observer-key'; // Still need to be compatible with React 15, we use class component here

var ReactResizeObserver =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ReactResizeObserver, _React$Component);

  function ReactResizeObserver() {
    var _this;

    _classCallCheck(this, ReactResizeObserver);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactResizeObserver).apply(this, arguments));
    _this.resizeObserver = null;
    _this.childNode = null;
    _this.currentElement = null;
    _this.state = {
      width: 0,
      height: 0
    };

    _this.onResize = function (entries) {
      var onResize = _this.props.onResize;
      var target = entries[0].target;

      var _target$getBoundingCl = target.getBoundingClientRect(),
          width = _target$getBoundingCl.width,
          height = _target$getBoundingCl.height;
      /**
       * Resize observer trigger when content size changed.
       * In most case we just care about element size,
       * let's use `boundary` instead of `contentRect` here to avoid shaking.
       */


      var fixedWidth = Math.floor(width);
      var fixedHeight = Math.floor(height);

      if (_this.state.width !== fixedWidth || _this.state.height !== fixedHeight) {
        var size = {
          width: fixedWidth,
          height: fixedHeight
        };

        _this.setState(size);

        if (onResize) {
          onResize(size);
        }
      }
    };

    _this.setChildNode = function (node) {
      _this.childNode = node;
    };

    return _this;
  }

  _createClass(ReactResizeObserver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onComponentUpdated();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.onComponentUpdated();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyObserver();
    }
  }, {
    key: "onComponentUpdated",
    value: function onComponentUpdated() {
      var disabled = this.props.disabled; // Unregister if disabled

      if (disabled) {
        this.destroyObserver();
        return;
      } // Unregister if element changed


      var element = findDOMNode_1.default(this.childNode || this);
      var elementChanged = element !== this.currentElement;

      if (elementChanged) {
        this.destroyObserver();
        this.currentElement = element;
      }

      if (!this.resizeObserver && element) {
        this.resizeObserver = new resize_observer_polyfill_1.default(this.onResize);
        this.resizeObserver.observe(element);
      }
    }
  }, {
    key: "destroyObserver",
    value: function destroyObserver() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var childNodes = toArray_1.default(children);

      if (childNodes.length > 1) {
        warning_1.default(false, 'Find more than one child node with `children` in ResizeObserver. Will only observe first one.');
      } else if (childNodes.length === 0) {
        warning_1.default(false, '`children` of ResizeObserver is empty. Nothing is in observe.');
        return null;
      }

      var childNode = childNodes[0];

      if (React.isValidElement(childNode) && util_1.supportRef(childNode)) {
        var ref = childNode.ref;
        childNodes[0] = React.cloneElement(childNode, {
          ref: ref_1.composeRef(ref, this.setChildNode)
        });
      }

      return childNodes.length === 1 ? childNodes[0] : childNodes.map(function (node, index) {
        if (!React.isValidElement(node) || 'key' in node && node.key !== null) {
          return node;
        }

        return React.cloneElement(node, {
          key: "".concat(INTERNAL_PREFIX_KEY, "-").concat(index)
        });
      });
    }
  }]);

  return ReactResizeObserver;
}(React.Component);

ReactResizeObserver.displayName = 'ResizeObserver';
exports.default = ReactResizeObserver;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fillRef = fillRef;
exports.composeRef = composeRef;
exports.supportRef = supportRef;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function fillRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else if (_typeof(ref) === 'object' && ref && 'current' in ref) {
    ref.current = node;
  }
}
/**
 * Merge refs into one ref function to support ref passing.
 */


function composeRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (node) {
    refs.forEach(function (ref) {
      fillRef(ref, node);
    });
  };
}

function supportRef(nodeOrComponent) {
  // Function component node
  if (nodeOrComponent.type && nodeOrComponent.type.prototype && !nodeOrComponent.type.prototype.render) {
    return false;
  } // Class component


  if (typeof nodeOrComponent === 'function' && nodeOrComponent.prototype && !nodeOrComponent.prototype.render) {
    return false;
  }

  return true;
}
/* eslint-enable */

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function supportRef(node) {
  // Function component
  if (node.type && node.type.prototype && !node.type.prototype.render) {
    return false;
  }

  return true;
}

exports.supportRef = supportRef;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateNodeStyling = calculateNodeStyling;
exports["default"] = calculateNodeHeight;
// Thanks to https://github.com/andreypopp/react-textarea-autosize/

/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */
var HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n";
var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'font-variant', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
var computedStyleCache = {};
var hiddenTextarea;

function calculateNodeStyling(node) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');

  if (useCache && computedStyleCache[nodeRef]) {
    return computedStyleCache[nodeRef];
  }

  var style = window.getComputedStyle(node);
  var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
  var sizingStyle = SIZING_STYLE.map(function (name) {
    return "".concat(name, ":").concat(style.getPropertyValue(name));
  }).join(';');
  var nodeInfo = {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize,
    boxSizing: boxSizing
  };

  if (useCache && nodeRef) {
    computedStyleCache[nodeRef] = nodeInfo;
  }

  return nodeInfo;
}

function calculateNodeHeight(uiTextNode) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    document.body.appendChild(hiddenTextarea);
  } // Fix wrap="off" issue
  // https://github.com/ant-design/ant-design/issues/6577


  if (uiTextNode.getAttribute('wrap')) {
    hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
  } else {
    hiddenTextarea.removeAttribute('wrap');
  } // Copy all CSS properties that have an impact on the height of the content in
  // the textbox


  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
      paddingSize = _calculateNodeStyling.paddingSize,
      borderSize = _calculateNodeStyling.borderSize,
      boxSizing = _calculateNodeStyling.boxSizing,
      sizingStyle = _calculateNodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
  // text-lines will not calculated properly as the shadow will technically be
  // narrower for content


  hiddenTextarea.setAttribute('style', "".concat(sizingStyle, ";").concat(HIDDEN_TEXTAREA_STYLE));
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
  var minHeight = Number.MIN_SAFE_INTEGER;
  var maxHeight = Number.MAX_SAFE_INTEGER;
  var height = hiddenTextarea.scrollHeight;
  var overflowY;

  if (boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    height += borderSize;
  } else if (boxSizing === 'content-box') {
    // remove padding, since height = content
    height -= paddingSize;
  }

  if (minRows !== null || maxRows !== null) {
    // measure height of a textarea with a single row
    hiddenTextarea.value = ' ';
    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

    if (minRows !== null) {
      minHeight = singleRowHeight * minRows;

      if (boxSizing === 'border-box') {
        minHeight = minHeight + paddingSize + borderSize;
      }

      height = Math.max(minHeight, height);
    }

    if (maxRows !== null) {
      maxHeight = singleRowHeight * maxRows;

      if (boxSizing === 'border-box') {
        maxHeight = maxHeight + paddingSize + borderSize;
      }

      overflowY = height > maxHeight ? '' : 'hidden';
      height = Math.min(maxHeight, height);
    }
  }

  return {
    height: height,
    minHeight: minHeight,
    maxHeight: maxHeight,
    overflowY: overflowY
  };
}

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _omit = _interopRequireDefault(__webpack_require__(71));

var _Input = _interopRequireDefault(__webpack_require__(221));

var _icon = _interopRequireDefault(__webpack_require__(38));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var ActionMap = {
  click: 'onClick',
  hover: 'onMouseOver'
};

var Password = /*#__PURE__*/function (_React$Component) {
  _inherits(Password, _React$Component);

  var _super = _createSuper(Password);

  function Password() {
    var _this;

    _classCallCheck(this, Password);

    _this = _super.apply(this, arguments);
    _this.state = {
      visible: false
    };

    _this.onVisibleChange = function () {
      var disabled = _this.props.disabled;

      if (disabled) {
        return;
      }

      _this.setState(function (_ref) {
        var visible = _ref.visible;
        return {
          visible: !visible
        };
      });
    };

    _this.saveInput = function (instance) {
      if (instance && instance.input) {
        _this.input = instance.input;
      }
    };

    return _this;
  }

  _createClass(Password, [{
    key: "getIcon",
    value: function getIcon() {
      var _iconProps;

      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          action = _this$props.action;
      var iconTrigger = ActionMap[action] || '';
      var iconProps = (_iconProps = {}, _defineProperty(_iconProps, iconTrigger, this.onVisibleChange), _defineProperty(_iconProps, "className", "".concat(prefixCls, "-icon")), _defineProperty(_iconProps, "type", this.state.visible ? 'eye' : 'eye-invisible'), _defineProperty(_iconProps, "key", 'passwordIcon'), _defineProperty(_iconProps, "onMouseDown", function onMouseDown(e) {
        // Prevent focused state lost
        // https://github.com/ant-design/ant-design/issues/15173
        e.preventDefault();
      }), _iconProps);
      return /*#__PURE__*/React.createElement(_icon["default"], iconProps);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "select",
    value: function select() {
      this.input.select();
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          className = _a.className,
          prefixCls = _a.prefixCls,
          inputPrefixCls = _a.inputPrefixCls,
          size = _a.size,
          visibilityToggle = _a.visibilityToggle,
          restProps = __rest(_a, ["className", "prefixCls", "inputPrefixCls", "size", "visibilityToggle"]);

      var suffixIcon = visibilityToggle && this.getIcon();
      var inputClassName = (0, _classnames["default"])(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-").concat(size), !!size));
      return /*#__PURE__*/React.createElement(_Input["default"], _extends({}, (0, _omit["default"])(restProps, ['suffix']), {
        type: this.state.visible ? 'text' : 'password',
        size: size,
        className: inputClassName,
        prefixCls: inputPrefixCls,
        suffix: suffixIcon,
        ref: this.saveInput
      }));
    }
  }]);

  return Password;
}(React.Component);

exports["default"] = Password;
Password.defaultProps = {
  inputPrefixCls: 'ant-input',
  prefixCls: 'ant-input-password',
  action: 'click',
  visibilityToggle: true
};

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var PropTypes = _interopRequireWildcard(__webpack_require__(19));

var _configProvider = __webpack_require__(39);

var _RowContext = _interopRequireDefault(__webpack_require__(482));

var _type = __webpack_require__(130);

var _responsiveObserve = _interopRequireWildcard(__webpack_require__(873));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var RowAligns = (0, _type.tuple)('top', 'middle', 'bottom', 'stretch');
var RowJustify = (0, _type.tuple)('start', 'end', 'center', 'space-around', 'space-between');

var Row = /*#__PURE__*/function (_React$Component) {
  _inherits(Row, _React$Component);

  var _super = _createSuper(Row);

  function Row() {
    var _this;

    _classCallCheck(this, Row);

    _this = _super.apply(this, arguments);
    _this.state = {
      screens: {}
    };

    _this.renderRow = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          type = _a.type,
          justify = _a.justify,
          align = _a.align,
          className = _a.className,
          style = _a.style,
          children = _a.children,
          others = __rest(_a, ["prefixCls", "type", "justify", "align", "className", "style", "children"]);

      var prefixCls = getPrefixCls('row', customizePrefixCls);

      var gutter = _this.getGutter();

      var classes = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, prefixCls, !type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type, "-").concat(justify), type && justify), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type, "-").concat(align), type && align), _classNames), className);

      var rowStyle = _extends(_extends(_extends({}, gutter[0] > 0 ? {
        marginLeft: gutter[0] / -2,
        marginRight: gutter[0] / -2
      } : {}), gutter[1] > 0 ? {
        marginTop: gutter[1] / -2,
        marginBottom: gutter[1] / -2
      } : {}), style);

      var otherProps = _extends({}, others);

      delete otherProps.gutter;
      return /*#__PURE__*/React.createElement(_RowContext["default"].Provider, {
        value: {
          gutter: gutter
        }
      }, /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
        className: classes,
        style: rowStyle
      }), children));
    };

    return _this;
  }

  _createClass(Row, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.token = _responsiveObserve["default"].subscribe(function (screens) {
        var gutter = _this2.props.gutter;

        if (_typeof(gutter) === 'object' || Array.isArray(gutter) && (_typeof(gutter[0]) === 'object' || _typeof(gutter[1]) === 'object')) {
          _this2.setState({
            screens: screens
          });
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _responsiveObserve["default"].unsubscribe(this.token);
    }
  }, {
    key: "getGutter",
    value: function getGutter() {
      var results = [0, 0];
      var gutter = this.props.gutter;
      var screens = this.state.screens;
      var normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
      normalizedGutter.forEach(function (g, index) {
        if (_typeof(g) === 'object') {
          for (var i = 0; i < _responsiveObserve.responsiveArray.length; i++) {
            var breakpoint = _responsiveObserve.responsiveArray[i];

            if (screens[breakpoint] && g[breakpoint] !== undefined) {
              results[index] = g[breakpoint];
              break;
            }
          }
        } else {
          results[index] = g || 0;
        }
      });
      return results;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRow);
    }
  }]);

  return Row;
}(React.Component);

exports["default"] = Row;
Row.defaultProps = {
  gutter: 0
};
Row.propTypes = {
  type: PropTypes.oneOf(['flex']),
  align: PropTypes.oneOf(RowAligns),
  justify: PropTypes.oneOf(RowJustify),
  className: PropTypes.string,
  children: PropTypes.node,
  gutter: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.array]),
  prefixCls: PropTypes.string
};

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.responsiveMap = exports.responsiveArray = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// matchMedia polyfill for
// https://github.com/WickyNilliams/enquire.js/issues/82
var enquire; // TODO: Will be removed in antd 4.0 because we will no longer support ie9

if (typeof window !== 'undefined') {
  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
    return {
      media: mediaQuery,
      matches: false,
      addListener: function addListener() {},
      removeListener: function removeListener() {}
    };
  }; // ref: https://github.com/ant-design/ant-design/issues/18774


  if (!window.matchMedia) window.matchMedia = matchMediaPolyfill; // eslint-disable-next-line global-require

  enquire = __webpack_require__(874);
}

var responsiveArray = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
exports.responsiveArray = responsiveArray;
var responsiveMap = {
  xs: '(max-width: 575px)',
  sm: '(min-width: 576px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
  xl: '(min-width: 1200px)',
  xxl: '(min-width: 1600px)'
};
exports.responsiveMap = responsiveMap;
var subscribers = [];
var subUid = -1;
var screens = {};
var responsiveObserve = {
  dispatch: function dispatch(pointMap) {
    screens = pointMap;

    if (subscribers.length < 1) {
      return false;
    }

    subscribers.forEach(function (item) {
      item.func(screens);
    });
    return true;
  },
  subscribe: function subscribe(func) {
    if (subscribers.length === 0) {
      this.register();
    }

    var token = (++subUid).toString();
    subscribers.push({
      token: token,
      func: func
    });
    func(screens);
    return token;
  },
  unsubscribe: function unsubscribe(token) {
    subscribers = subscribers.filter(function (item) {
      return item.token !== token;
    });

    if (subscribers.length === 0) {
      this.unregister();
    }
  },
  unregister: function unregister() {
    Object.keys(responsiveMap).map(function (screen) {
      return enquire.unregister(responsiveMap[screen]);
    });
  },
  register: function register() {
    var _this = this;

    Object.keys(responsiveMap).map(function (screen) {
      return enquire.register(responsiveMap[screen], {
        match: function match() {
          var pointMap = _extends(_extends({}, screens), _defineProperty({}, screen, true));

          _this.dispatch(pointMap);
        },
        unmatch: function unmatch() {
          var pointMap = _extends(_extends({}, screens), _defineProperty({}, screen, false));

          _this.dispatch(pointMap);
        },
        // Keep a empty destory to avoid triggering unmatch when unregister
        destroy: function destroy() {}
      });
    });
  }
};
var _default = responsiveObserve;
exports["default"] = _default;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(875);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(876);
var Util = __webpack_require__(483);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(877);
var each = __webpack_require__(483).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 877 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(19));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _RowContext = _interopRequireDefault(__webpack_require__(482));

var _configProvider = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var objectOrNumber = PropTypes.oneOfType([PropTypes.object, PropTypes.number]);

var Col = /*#__PURE__*/function (_React$Component) {
  _inherits(Col, _React$Component);

  var _super = _createSuper(Col);

  function Col() {
    var _this;

    _classCallCheck(this, Col);

    _this = _super.apply(this, arguments);

    _this.renderCol = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      var customizePrefixCls = props.prefixCls,
          span = props.span,
          order = props.order,
          offset = props.offset,
          push = props.push,
          pull = props.pull,
          className = props.className,
          children = props.children,
          others = __rest(props, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children"]);

      var prefixCls = getPrefixCls('col', customizePrefixCls);
      var sizeClassObj = {};
      ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'].forEach(function (size) {
        var _extends2;

        var sizeProps = {};
        var propSize = props[size];

        if (typeof propSize === 'number') {
          sizeProps.span = propSize;
        } else if (_typeof(propSize) === 'object') {
          sizeProps = propSize || {};
        }

        delete others[size];
        sizeClassObj = _extends(_extends({}, sizeClassObj), (_extends2 = {}, _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-").concat(sizeProps.span), sizeProps.span !== undefined), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-order-").concat(sizeProps.order), sizeProps.order || sizeProps.order === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-offset-").concat(sizeProps.offset), sizeProps.offset || sizeProps.offset === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-push-").concat(sizeProps.push), sizeProps.push || sizeProps.push === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-pull-").concat(sizeProps.pull), sizeProps.pull || sizeProps.pull === 0), _extends2));
      });
      var classes = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(span), span !== undefined), _defineProperty(_classNames, "".concat(prefixCls, "-order-").concat(order), order), _defineProperty(_classNames, "".concat(prefixCls, "-offset-").concat(offset), offset), _defineProperty(_classNames, "".concat(prefixCls, "-push-").concat(push), push), _defineProperty(_classNames, "".concat(prefixCls, "-pull-").concat(pull), pull), _classNames), className, sizeClassObj);
      return /*#__PURE__*/React.createElement(_RowContext["default"].Consumer, null, function (_ref2) {
        var gutter = _ref2.gutter;
        var style = others.style;

        if (gutter) {
          style = _extends(_extends(_extends({}, gutter[0] > 0 ? {
            paddingLeft: gutter[0] / 2,
            paddingRight: gutter[0] / 2
          } : {}), gutter[1] > 0 ? {
            paddingTop: gutter[1] / 2,
            paddingBottom: gutter[1] / 2
          } : {}), style);
        }

        return /*#__PURE__*/React.createElement("div", _extends({}, others, {
          style: style,
          className: classes
        }), children);
      });
    };

    return _this;
  }

  _createClass(Col, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCol);
    }
  }]);

  return Col;
}(React.Component);

exports["default"] = Col;
Col.propTypes = {
  span: PropTypes.number,
  order: PropTypes.number,
  offset: PropTypes.number,
  push: PropTypes.number,
  pull: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.node,
  xs: objectOrNumber,
  sm: objectOrNumber,
  md: objectOrNumber,
  lg: objectOrNumber,
  xl: objectOrNumber,
  xxl: objectOrNumber
};

/***/ }),
/* 879 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 880 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 881 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 882 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 883 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 885 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 886 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(85);var _app=__webpack_require__(888);var _app2=_interopRequireDefault(_app);__webpack_require__(2232);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function getCookie(c_name){if(document.cookie.length>0){var c_start=document.cookie.indexOf(c_name+"=");if(c_start!=-1){c_start=c_start+c_name.length+1;var c_end=document.cookie.indexOf(";",c_start);if(c_end==-1)c_end=document.cookie.length;return unescape(document.cookie.substring(c_start,c_end));}}return"";}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'componentWillMount',value:function componentWillMount(){var user=getCookie('user');if(!user){window.location.href="/#/login";}else{sessionStorage.setItem("user",user);}}},{key:'render',value:function render(){return _react2.default.createElement(_reactRouterDom.Route,{path:'/table',component:_app2.default});}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;// import WeekMeeting from '../table/meetingFlash/Week';
// 合同管理
// 月度会议记录
// 表格1-?、
// import table1_1 from '../table/1-KPI/1-1KeyPerformanceIndicator';
// import table1_2 from '../table/1-KPI/1-2FlowThruAnalysis';
// import table1_3 from '../table/1-KPI/1-3';
// 表格2-?、
// import table2_4 from '../table/2-Analysis/2-4';
// import table2_5 from '../table/2-Analysis/2-5';
// import table2_6 from '../table/2-Analysis/2-6';
// import table2_9 from '../table/2-Analysis/2-9';
// 表格3-?、
// 表格4-?、
// 区域报表 图表
// 4.0新表
// 表格5-?、
// 表格6-?、
// import table6_4 from '../table/6.0/6-4';
// import table6_5 from '../table/6.0/6-5';
// 表格7-?、
// HR迁移过来的7.7 
// 表格8-?、
// 表格9-?、
// 表格10-11、
// 设置、用户
// 特许酒店
// 总部表格
// 坪效
// 官网比价
// 临时新增五一表格
// 宴会设施统计
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(85);var _Menu=__webpack_require__(889);var _Menu2=_interopRequireDefault(_Menu);__webpack_require__(315);var _mobxReact=__webpack_require__(18);var _user=__webpack_require__(728);var _user2=_interopRequireDefault(_user);var _IsAuth=__webpack_require__(535);var _IsAuth2=_interopRequireDefault(_IsAuth);var _cover=__webpack_require__(1116);var _cover2=_interopRequireDefault(_cover);var _BpSave=__webpack_require__(1345);var _BpSave2=_interopRequireDefault(_BpSave);var _compared=__webpack_require__(1347);var _compared2=_interopRequireDefault(_compared);var _Detail=__webpack_require__(1353);var _Detail2=_interopRequireDefault(_Detail);var _Headquarters=__webpack_require__(1354);var _Headquarters2=_interopRequireDefault(_Headquarters);var _personal=__webpack_require__(1355);var _personal2=_interopRequireDefault(_personal);var _meetingFlash=__webpack_require__(1369);var _meetingFlash2=_interopRequireDefault(_meetingFlash);var _LabelManagement=__webpack_require__(1378);var _LabelManagement2=_interopRequireDefault(_LabelManagement);var _guestRating=__webpack_require__(1379);var _guestRating2=_interopRequireDefault(_guestRating);var _channels=__webpack_require__(1382);var _channels2=_interopRequireDefault(_channels);var _criticism=__webpack_require__(1391);var _criticism2=_interopRequireDefault(_criticism);var _monthlyAnalysis=__webpack_require__(1392);var _monthlyAnalysis2=_interopRequireDefault(_monthlyAnalysis);var _personnel=__webpack_require__(1399);var _personnel2=_interopRequireDefault(_personnel);var _kpifollow=__webpack_require__(1403);var _kpifollow2=_interopRequireDefault(_kpifollow);var _salesPersonnelAssessment=__webpack_require__(1410);var _salesPersonnelAssessment2=_interopRequireDefault(_salesPersonnelAssessment);var _contract=__webpack_require__(1414);var _contract2=_interopRequireDefault(_contract);var _meetingMinutes=__webpack_require__(1475);var _meetingMinutes2=_interopRequireDefault(_meetingMinutes);var _KPI=__webpack_require__(1479);var _KPI2=_interopRequireDefault(_KPI);var _=__webpack_require__(1485);var _2=_interopRequireDefault(_);var _3=__webpack_require__(1488);var _4=_interopRequireDefault(_3);var _5=__webpack_require__(1491);var _6=_interopRequireDefault(_5);var _7=__webpack_require__(1494);var _8=_interopRequireDefault(_7);var _9=__webpack_require__(1496);var _10=_interopRequireDefault(_9);var _11=__webpack_require__(1498);var _12=_interopRequireDefault(_11);var _13=__webpack_require__(1508);var _14=_interopRequireDefault(_13);var _15=__webpack_require__(1511);var _16=_interopRequireDefault(_15);var _17=__webpack_require__(1515);var _18=_interopRequireDefault(_17);var _daily=__webpack_require__(1828);var _daily2=_interopRequireDefault(_daily);var _19=__webpack_require__(1832);var _20=_interopRequireDefault(_19);var _21=__webpack_require__(1835);var _22=_interopRequireDefault(_21);var _23=__webpack_require__(1838);var _24=_interopRequireDefault(_23);var _25=__webpack_require__(1841);var _26=_interopRequireDefault(_25);var _27=__webpack_require__(1844);var _28=_interopRequireDefault(_27);var _29=__webpack_require__(1847);var _30=_interopRequireDefault(_29);var _summary=__webpack_require__(1850);var _summary2=_interopRequireDefault(_summary);var _fullRoom=__webpack_require__(1853);var _fullRoom2=_interopRequireDefault(_fullRoom);var _holidaySummary=__webpack_require__(1856);var _holidaySummary2=_interopRequireDefault(_holidaySummary);var _31=__webpack_require__(1858);var _32=_interopRequireDefault(_31);var _33=__webpack_require__(1866);var _34=_interopRequireDefault(_33);var _35=__webpack_require__(1869);var _36=_interopRequireDefault(_35);var _chineseNewYear=__webpack_require__(1875);var _chineseNewYear2=_interopRequireDefault(_chineseNewYear);var _mayDay=__webpack_require__(1878);var _mayDay2=_interopRequireDefault(_mayDay);var _eleven=__webpack_require__(1881);var _eleven2=_interopRequireDefault(_eleven);var _year=__webpack_require__(1884);var _year2=_interopRequireDefault(_year);var _37=__webpack_require__(1887);var _38=_interopRequireDefault(_37);var _39=__webpack_require__(1895);var _40=_interopRequireDefault(_39);var _41=__webpack_require__(1898);var _42=_interopRequireDefault(_41);var _43=__webpack_require__(1905);var _44=_interopRequireDefault(_43);var _45=__webpack_require__(1908);var _46=_interopRequireDefault(_45);var _47=__webpack_require__(1911);var _48=_interopRequireDefault(_47);var _49=__webpack_require__(1917);var _50=_interopRequireDefault(_49);var _51=__webpack_require__(1921);var _52=_interopRequireDefault(_51);var _53=__webpack_require__(1924);var _54=_interopRequireDefault(_53);var _55=__webpack_require__(1927);var _56=_interopRequireDefault(_55);var _57=__webpack_require__(1932);var _58=_interopRequireDefault(_57);var _59=__webpack_require__(1938);var _60=_interopRequireDefault(_59);var _61=__webpack_require__(1943);var _62=_interopRequireDefault(_61);var _63=__webpack_require__(1954);var _64=_interopRequireDefault(_63);var _65=__webpack_require__(1963);var _66=_interopRequireDefault(_65);var _new=__webpack_require__(1966);var _new2=_interopRequireDefault(_new);var _TotalPayrollCostAnalysis=__webpack_require__(1968);var _TotalPayrollCostAnalysis2=_interopRequireDefault(_TotalPayrollCostAnalysis);var _PayrollCostByLevel=__webpack_require__(702);var _PayrollCostByLevel2=_interopRequireDefault(_PayrollCostByLevel);var _PayrollCostByDepartment=__webpack_require__(705);var _PayrollCostByDepartment2=_interopRequireDefault(_PayrollCostByDepartment);var _67=__webpack_require__(1974);var _68=_interopRequireDefault(_67);var _69=__webpack_require__(1979);var _70=_interopRequireDefault(_69);var _71=__webpack_require__(1982);var _72=_interopRequireDefault(_71);var _73=__webpack_require__(1988);var _74=_interopRequireDefault(_73);var _75=__webpack_require__(1993);var _76=_interopRequireDefault(_75);var _77=__webpack_require__(1997);var _78=_interopRequireDefault(_77);var _79=__webpack_require__(737);var _80=_interopRequireDefault(_79);var _81=__webpack_require__(2007);var _82=_interopRequireDefault(_81);var _83=__webpack_require__(2012);var _84=_interopRequireDefault(_83);var _85=__webpack_require__(2014);var _86=_interopRequireDefault(_85);var _87=__webpack_require__(2017);var _88=_interopRequireDefault(_87);var _89=__webpack_require__(2020);var _90=_interopRequireDefault(_89);var _91=__webpack_require__(2023);var _92=_interopRequireDefault(_91);var _93=__webpack_require__(2025);var _94=_interopRequireDefault(_93);var _95=__webpack_require__(2027);var _96=_interopRequireDefault(_95);var _97=__webpack_require__(2029);var _98=_interopRequireDefault(_97);var _99=__webpack_require__(2038);var _100=_interopRequireDefault(_99);var _101=__webpack_require__(2041);var _102=_interopRequireDefault(_101);var _103=__webpack_require__(2047);var _104=_interopRequireDefault(_103);var _105=__webpack_require__(2048);var _106=_interopRequireDefault(_105);var _hotel=__webpack_require__(2053);var _hotel2=_interopRequireDefault(_hotel);var _user3=__webpack_require__(2054);var _user4=_interopRequireDefault(_user3);var _setting=__webpack_require__(2055);var _setting2=_interopRequireDefault(_setting);var _daily3=__webpack_require__(2057);var _daily4=_interopRequireDefault(_daily3);var _pdf=__webpack_require__(730);var _pdf2=_interopRequireDefault(_pdf);var _comments=__webpack_require__(738);var _comments2=_interopRequireDefault(_comments);var _home=__webpack_require__(2065);var _home2=_interopRequireDefault(_home);var _General=__webpack_require__(2077);var _General2=_interopRequireDefault(_General);var _headquarters=__webpack_require__(2086);var _headquarters2=_interopRequireDefault(_headquarters);var _profit=__webpack_require__(2093);var _profit2=_interopRequireDefault(_profit);var _first=__webpack_require__(2095);var _first2=_interopRequireDefault(_first);var _second=__webpack_require__(2098);var _second2=_interopRequireDefault(_second);var _third=__webpack_require__(2101);var _third2=_interopRequireDefault(_third);var _fourth=__webpack_require__(2104);var _fourth2=_interopRequireDefault(_fourth);var _summary3=__webpack_require__(2107);var _summary4=_interopRequireDefault(_summary3);var _2Month=__webpack_require__(2110);var _2Month2=_interopRequireDefault(_2Month);var _2Year=__webpack_require__(2113);var _2Year2=_interopRequireDefault(_2Year);var _roomsKPIAnalysisSummary=__webpack_require__(2116);var _roomsKPIAnalysisSummary2=_interopRequireDefault(_roomsKPIAnalysisSummary);var _guestReviewImport=__webpack_require__(2118);var _guestReviewImport2=_interopRequireDefault(_guestReviewImport);var _performanceReview=__webpack_require__(2122);var _performanceReview2=_interopRequireDefault(_performanceReview);var _performanceAnalysis=__webpack_require__(2126);var _performanceAnalysis2=_interopRequireDefault(_performanceAnalysis);var _description=__webpack_require__(2130);var _description2=_interopRequireDefault(_description);var _analysisChart=__webpack_require__(2131);var _analysisChart2=_interopRequireDefault(_analysisChart);var _groupanalysisChart=__webpack_require__(2145);var _groupanalysisChart2=_interopRequireDefault(_groupanalysisChart);var _fillIn=__webpack_require__(2148);var _fillIn2=_interopRequireDefault(_fillIn);var _show=__webpack_require__(2155);var _show2=_interopRequireDefault(_show);var _107=__webpack_require__(2156);var _108=_interopRequireDefault(_107);var _109=__webpack_require__(2158);var _110=_interopRequireDefault(_109);var _111=__webpack_require__(2160);var _112=_interopRequireDefault(_111);var _113=__webpack_require__(2162);var _114=_interopRequireDefault(_113);var _115=__webpack_require__(2164);var _116=_interopRequireDefault(_115);var _117=__webpack_require__(2169);var _118=_interopRequireDefault(_117);var _119=__webpack_require__(2173);var _120=_interopRequireDefault(_119);var _121=__webpack_require__(2175);var _122=_interopRequireDefault(_121);var _123=__webpack_require__(2177);var _124=_interopRequireDefault(_123);var _BPBudgetSummary=__webpack_require__(2179);var _BPBudgetSummary2=_interopRequireDefault(_BPBudgetSummary);var _BP8_2_=__webpack_require__(2180);var _BP8_2_2=_interopRequireDefault(_BP8_2_);var _effect=__webpack_require__(2181);var _effect2=_interopRequireDefault(_effect);var _description3=__webpack_require__(2185);var _description4=_interopRequireDefault(_description3);var _125=__webpack_require__(2186);var _126=_interopRequireDefault(_125);var _127=__webpack_require__(2189);var _128=_interopRequireDefault(_127);var _129=__webpack_require__(2191);var _130=_interopRequireDefault(_129);var _131=__webpack_require__(2193);var _132=_interopRequireDefault(_131);var _consulting=__webpack_require__(2194);var _consulting2=_interopRequireDefault(_consulting);var _mayDay3=__webpack_require__(2219);var _mayDay4=_interopRequireDefault(_mayDay3);var _nationalDay=__webpack_require__(2221);var _nationalDay2=_interopRequireDefault(_nationalDay);var _banquetFacilities=__webpack_require__(2223);var _banquetFacilities2=_interopRequireDefault(_banquetFacilities);var _systemStatistical=__webpack_require__(2224);var _systemStatistical2=_interopRequireDefault(_systemStatistical);var _DooBi=__webpack_require__(2225);var _DooBi2=_interopRequireDefault(_DooBi);var _urgent=__webpack_require__(2227);var _urgent2=_interopRequireDefault(_urgent);var _monthlyReview=__webpack_require__(2229);var _monthlyReview2=_interopRequireDefault(_monthlyReview);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.state={user:{}};return _this;}_createClass(index,[{key:'componentWillMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var user;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!this.props.store.tableSwitch.data.id){this.props.store.tableSwitch.getData();}try{user=JSON.parse(sessionStorage.getItem('user'));this.setState({user:user});}catch(error){console.error(error);}case 2:case'end':return _context.stop();}}},_callee,this);}));function componentWillMount(){return _ref.apply(this,arguments);}return componentWillMount;}()},{key:'render',value:function render(){var _this2=this;var user=this.state.user||{};var data=this.props.store.tableSwitch.data;var isView=this.props.store.auth.isView;// 关闭表格只允许总部人员查看 
var isClose=!(user.email||"").includes('admin')&&!Number(data.es||"0");return _react2.default.createElement('div',{className:'menu_flex'},_react2.default.createElement(_Menu2.default,this.props),isClose&&_react2.default.createElement('div',{className:'menu_flex'},_react2.default.createElement(_Menu2.default,this.props),_react2.default.createElement('div',{style:{padding:"0 10px",flex:1,overflow:'hidden',textAlign:"center",marginTop:100,fontSize:26},onClick:function onClick(){_this2.props.store.menu.onChangeDisplay('');}},'\u8868\u683C\u5173\u95ED\u4E2D\u6682\u65F6\u65E0\u6CD5\u67E5\u770B!')),!isClose&&_react2.default.createElement('div',{className:'menu-top-content'},_react2.default.createElement(_user2.default,this.props),_react2.default.createElement('div',{id:'table-parent',style:{padding:"0 10px",flex:1,overflowY:'auto'},onClick:function onClick(){_this2.props.store.menu.onChangeDisplay('');}},_react2.default.createElement(_reactRouterDom.Switch,null,_react2.default.createElement(_reactRouterDom.Route,{path:'/table/compared/detail/:id',component:_Detail2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/compared/daydetail/:id',component:_Detail2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/contract_manage',component:_contract2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/BpSave',component:_BpSave2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/banquetFacilities',component:_banquetFacilities2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/systemStatistical',component:_systemStatistical2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/meetingMinutes',component:_meetingMinutes2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/doobi',component:_DooBi2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/urgent',component:_urgent2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/monthlyreview',component:_monthlyReview2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/compared',component:_compared2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/headquarters',component:_Headquarters2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/labelmanagement',component:_LabelManagement2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/comments',component:_comments2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/personal',component:_personal2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/performanceReview',component:_performanceReview2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/monthlyAnalysis',component:_monthlyAnalysis2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/personnelAssessment',component:_personnel2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/kpifollow',component:_kpifollow2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/salesPersonnelAssessment',component:_salesPersonnelAssessment2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/mayday',component:_mayDay4.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/nationalday',component:_nationalDay2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/efficiency',component:_effect2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/effictdescription',component:_description4.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/effect1_2',component:_126.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/headquartersmonth',component:_2Month2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/headquartersyear',component:_2Year2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/roomsKPIAnalysisSummary',component:_roomsKPIAnalysisSummary2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/guestReviewImport',component:_guestReviewImport2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/dailyMonth',component:_116.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/dailyChart',component:_118.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/dailyMonthAllHotels',component:_120.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/dailyMonthAllHotels1_4',component:_122.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/dailyMonthAllHotels1_5',component:_124.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/BPBudgetSummary8_2_1',component:_BP8_2_2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/BPBudgetSummary',component:_BPBudgetSummary2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/charter/one',component:_first2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/charter/two',component:_second2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/charter/three',component:_third2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/charter/four',component:_fourth2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/charter/summary',component:_summary4.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/hotel/:id',component:_hotel2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/user',component:_user4.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/setting',component:_setting2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/daily',component:_daily4.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/cover',component:_cover2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/pdf',component:_pdf2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/meetingflash',component:_meetingFlash2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/criticism/:id/:name',component:_criticism2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/1',component:_KPI2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/2_1',component:_2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/2_2',component:_4.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/2_3',component:_6.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/2_7',component:_8.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/2_8',component:_10.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/3_1',component:_12.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/3_2',component:_14.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/3_3',component:_16.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/4_2/holiday/summary',component:_holidaySummary2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/4_1',component:_18.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/4_2_1',component:_daily2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/4_2/fullRoom',component:_fullRoom2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/4_2_summary',component:_summary2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/4_2_2',component:_20.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/4_2_3',component:_22.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/4_2_4',component:_24.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/4_2_5',component:_26.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/4_2_6',component:_28.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/4_2_7',component:_30.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/4_3_1_new',component:_38.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/4_3_2_new',component:_40.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/4_2_1_new',component:_42.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/4_2_2_new',component:_44.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/chineseNewYear',component:_chineseNewYear2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/areaMayDay',component:_mayDay2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/eleven',component:_eleven2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/annualRegional',component:_year2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/4_3',component:_32.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/4_4',component:_34.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/4_5',component:_36.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/5_10',component:_62.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/5_1',component:_48.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/5_0',component:_46.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/5_2',component:_50.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/5_3',component:_52.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/5_5',component:_54.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/5_6',component:_56.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/5_8',component:_58.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/5_9',component:_60.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/6_1',component:_64.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/6_2',component:_66.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/6_3',component:_new2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/7_1',component:_TotalPayrollCostAnalysis2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/7_1_1',component:_PayrollCostByLevel2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/7_1_2',component:_PayrollCostByDepartment2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/7_2',component:_68.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/7_3',component:_70.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/7_4',component:_72.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/7_5',component:_74.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/7_6',component:_76.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/7_7',component:_78.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/7_8',component:_80.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/8_1',component:_82.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/9_1',component:_84.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/9_2',component:_86.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/9_3',component:_88.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/9_4',component:_90.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/9_5',component:_92.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/9_6',component:_94.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/9_7',component:_96.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/9_9',component:_100.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/9_10',component:_102.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/10',component:_104.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/12',component:_106.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/bi_home',component:_home2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/general',component:_General2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/bi_headquarters',component:_headquarters2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/profit',component:_profit2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/9_8',component:_98.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/guestrating',component:_guestRating2.default}),_react2.default.createElement(_IsAuth2.default,{isView:isView,defaultComponent:null},_react2.default.createElement(_reactRouterDom.Route,{path:'/table/otafillin',component:_fillIn2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/otashow',component:_show2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/otashowctrip',component:_108.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/otashowmeituan',component:_110.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/otaapplet',component:_112.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/otaappletrn',component:_114.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/groupOfChannels',component:_channels2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/performanceAnalysis',component:_performanceAnalysis2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/performancedescription',component:_description2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/analysisChart',component:_analysisChart2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/groupanalysisChart',component:_groupanalysisChart2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/price1_1',component:_128.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/price1_2',component:_130.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/price1_3',component:_132.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/table/consulting',component:_consulting2.default})),_react2.default.createElement(_reactRouterDom.Redirect,{from:'/table',to:'/table/cover'})))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _icon=__webpack_require__(38);var _icon2=_interopRequireDefault(_icon);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _menu=__webpack_require__(251);var _menu2=_interopRequireDefault(_menu);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(75);__webpack_require__(314);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ExportPdf=__webpack_require__(926);var _ExportPdf2=_interopRequireDefault(_ExportPdf);var _data=__webpack_require__(348);var _SelectHotel=__webpack_require__(444);var _SelectHotel2=_interopRequireDefault(_SelectHotel);var _logo=__webpack_require__(727);var _logo2=_interopRequireDefault(_logo);var _mobxReact=__webpack_require__(18);var _IsAuth=__webpack_require__(535);var _IsAuth2=_interopRequireDefault(_IsAuth);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubMenu=_menu2.default.SubMenu;var routeData={'/table/2_1':'sub2','/table/2_2':'sub2','/table/2_3':'sub2','/table/2_4':'sub3','/table/2_5':'sub3','/table/2_6':'sub3','/table/2_7':'sub3','/table/2_8':'sub3','/table/2_9':'sub3','/table/3_1':'sub4','/table/3_2':'sub5','/table/3_3':'sub6','/table/4_1':'sub4','/table/4_2':'sub4','/table/4_3':'sub4','/table/4_4':'sub4','/table/4_5':'sub4','/table/5_1':'sub5','/table/5_2':'sub5','/table/5_3':'sub5','/table/5_5':'sub5','/table/5_6':'sub5','/table/5_7':'sub5','/table/6_1':'sub6','/table/6_2':'sub6','/table/6_3':'sub6','/table/6_4':'sub6','/table/6_5':'sub6','/table/7_1':'sub7','/table/7_2':'sub7','/table/7_3':'sub7','/table/7_4':'sub7','/table/7_5':'sub7','/table/7_6':'sub7','/table/8_1':'sub8','/table/8_2':'sub8','/table/9_1':'sub9','/table/9_2':'sub9','/table/9_3':'sub9','/table/9_4':'sub9','/table/9_5':'sub9','/table/9_6':'sub9','/table/9_7':'sub9','/table/10':'sub10','/table/9_8':'sub9','/table/cover':'Executive Summary Version','/table/meetingflash':'Executive Summary Version','/table/1':'Executive Summary Version','/table/performancedescription':'hoteldataindex','/table/performanceAnalysis':'hoteldataindex','/table/analysisChart':'hoteldataindex','/table/guestrating':'guestratingAll','/table/groupOfChannels':'guestratingAll','/table/profit':'headquarters_menu','/table/efficiency':'hoteldataindex','/table/effictdescription':'hoteldataindex'};var MenuApp=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(MenuApp,_Component);function MenuApp(props){_classCallCheck(this,MenuApp);var _this=_possibleConstructorReturn(this,(MenuApp.__proto__||Object.getPrototypeOf(MenuApp)).call(this,props));_this.rootSubmenuKeys=['sub1','sub2','sub3','sub4','sub5','sub6','sub7','sub8','sub9','Executive Summary Version','/bp','/hr','/table/comments','/table/compared','/table/pdf'];_this.onOpenChange=function(openKeys){var latestOpenKey=openKeys.find(function(key){return _this.state.openKeys.indexOf(key)===-1;});if(_this.rootSubmenuKeys.indexOf(latestOpenKey)===-1){_this.setState({openKeys:openKeys});}else{_this.setState({openKeys:latestOpenKey?['Executive Summary Version',latestOpenKey]:[]});}};_this.onPush=function(path){_this.props.history.push(path);};_this.state={display:"",openKeys:['sub1'],selectedKeys:[''],user:{},data:JSON.parse(sessionStorage.getItem('esTD')||"[]")||[]};return _this;}_createClass(MenuApp,[{key:"componentDidMount",value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var auth,data,getAuth,path;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;auth=[],data=[];if(!(!this.props.store.auth.ES||this.props.store.auth.ES.length<=0)){_context.next=5;break;}_context.next=5;return this.props.store.auth.getESAuth();case 5:auth=this.props.store.auth.ES;getAuth=this.props.store.auth.getAuth;_data.authData.forEach(function(item){var children=[];if(item.children[0].title==='查看'&&getAuth('ES',item.children[0].key)){data.push(_extends({},item));}else if(item.children&&item.children[0].title!='查看'){item.children.forEach(function(x){var _item=x;if(x.children[0].title==='查看'&&getAuth('ES',x.children[0].key)){children.push(_item);}else if(x.children&&x.children[0].title!='查看'){var _children=[];x.children.forEach(function(y){if(y.children&&y.children[0].title==='查看'&&getAuth('ES',y.children[0].key)){_children.push(y);}});if(_children.length)children.push(_extends({},_item,{children:_children}));}});if(children.length>0){data.push(_extends({},item,{children:children}));}}});sessionStorage.setItem('esTD',JSON.stringify(data));path=window.location.href.split('#')[1];this.setState({selectedKeys:[path],openKeys:routeData[path]?['Executive Summary Version',routeData[path]]:[],user:this.props.store.auth.user||{},data:data});_context.next=16;break;case 13:_context.prev=13;_context.t0=_context["catch"](0);console.error(_context.t0);case 16:case"end":return _context.stop();}}},_callee,this,[[0,13]]);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:"render",value:function render(){var _this2=this;var _props$store$menu=this.props.store.menu,display=_props$store$menu.display,onChangeDisplay=_props$store$menu.onChangeDisplay;var isView=this.props.store.auth.isView;var noListMenu=['/table/pdf',"/bp","/hr","/table/week",'/table/headquarters','/table/charter','/table/daily',"/table/guestrating","/table/guestratingAll","/table/guestrating","/table/profit","/table/hoteldataindex","/table/Consulting",'/table/consulting','/table/urgent'];var width=document.getElementsByClassName('app-content')[0]&&document.getElementsByClassName('app-content')[0].offsetWidth-300<=0;var user={};try{user=JSON.parse(sessionStorage.getItem('user'))||{};}catch(error){console.error(error);}if(display){return _react2.default.createElement("div",{className:"app-menu "},_react2.default.createElement("div",{className:"app-content "+(display&&width?'Expand':'shrink')},_react2.default.createElement("div",{className:"menu-select-export "+(display&&width?'Expand':'shrink')},_react2.default.createElement("div",{style:{display:"flex",alignItems:'center',justifyContent:"space-between"}},_react2.default.createElement("img",{src:_logo2.default,alt:"",style:{width:"calc(100% - 50px)"}}),_react2.default.createElement(_icon2.default,{type:"menu-fold",theme:"outlined",style:{float:"right",fontSize:24},onClick:function onClick(){onChangeDisplay('');}}))),_react2.default.createElement("div",{className:"menu-list"},(this.state.user.email||"").includes('admin')?_react2.default.createElement(_SelectHotel2.default,{user:this.state.user,display:display}):null,_react2.default.createElement(_menu2.default,{mode:"inline",openKeys:this.state.openKeys,selectedKeys:this.state.selectedKeys,onOpenChange:this.onOpenChange,style:{width:340,marginLeft:-20}// className={`${display ? 'animation' : ''}`}
,onSelect:function onSelect(item,key){_this2.setState({selectedKeys:[item.key]});}},isView&&(this.state.data||[]).some(function(x){return x.key==="/table/guestratingAll";})?_react2.default.createElement(SubMenu,{key:"guestratingAll",title:_react2.default.createElement("span",null,"Customer Satisfaction ",_react2.default.createElement("br",null)," \u5BA2\u4EBA\u6EE1\u610F\u5EA6")},((this.state.data||[]).find(function(x){return x.key==="/table/guestratingAll";})||[]).children.map(function(item){return _react2.default.createElement(_menu2.default.Item,{key:item.key},_react2.default.createElement("div",{className:"menu_click",onClick:_this2.onPush.bind(_this2,item.key)},item.title));})):null,isView&&(this.state.data||[]).some(function(x){return x.key==="/table/urgent";})?_react2.default.createElement(_menu2.default.Item,{key:"/table/urgent"},_react2.default.createElement("div",{className:"menu_click",onClick:this.onPush.bind(this,"/table/urgent")},"Hotel Emergency Report ",_react2.default.createElement("br",null)," \u9152\u5E97\u7D27\u6025\u4E8B\u4EF6\u62A5\u544A")):null,isView&&_react2.default.createElement(SubMenu,{key:"hoteldataindex",title:_react2.default.createElement("span",null,"Hotel Data Index ",_react2.default.createElement("br",null)," \u9152\u5E97\u6570\u636E\u5206\u6790")},(((this.state.data||[]).find(function(x){return x.key==="/table/hoteldataindex";})||[]).children||[]).map(function(x){return _react2.default.createElement(SubMenu,{key:"sub"+x.title.split('.')[0],title:_react2.default.createElement("span",{dangerouslySetInnerHTML:{__html:x.title}})},(x.children||[]).map(function(item){return _react2.default.createElement(_menu2.default.Item,{key:item.key},_react2.default.createElement("div",{className:"menu_click",onClick:_this2.onPush.bind(_this2,item.key),dangerouslySetInnerHTML:{__html:item.title}}));}));})),isView&&(this.state.data||[]).some(function(x){return x.key==="/table/consulting";})?_react2.default.createElement(_menu2.default.Item,{key:"/table/consulting"},_react2.default.createElement("div",{className:"menu_click",onClick:this.onPush.bind(this,"/table/consulting")},"Consulting Reports ",_react2.default.createElement("br",null)," \u7B2C\u4E09\u65B9\u884C\u4E1A\u8D44\u8BAF\u62A5\u544A\u6458\u8981")):null,(this.state.data||[]).some(function(x){return x.key==="/table/daily";})?_react2.default.createElement(_menu2.default.Item,{key:"/table/daily"},_react2.default.createElement("div",{className:"menu_click",onClick:this.onPush.bind(this,'/table/daily')},"Daily Revenue Report",_react2.default.createElement("br",null)," \u6BCF\u65E5\u7ECF\u8425\u62A5\u8868")):null,isView&&(this.state.data||[]).some(function(x){return x.key==="/table/week";})?_react2.default.createElement(_menu2.default.Item,{key:"/table/week"},_react2.default.createElement("div",{className:"menu_click",onClick:this.onPush.bind(this,'/table/week')},"Weekly Flash Report",_react2.default.createElement("br",null),"  \u5468\u5EA6\u5373\u65F6\u62A5\u8868")):null,_react2.default.createElement(SubMenu,{key:"Executive Summary Version",title:_react2.default.createElement("span",null,"Executive Summary Report ",_react2.default.createElement("br",null)," \u6708\u5EA6\u7ECF\u8425\u62A5\u544A")},this.state.data.map(function(x,i){if(noListMenu.includes(x.key)){return;}if(x.children[0].title==='查看'){return _react2.default.createElement(_menu2.default.Item,{key:x.key},_react2.default.createElement("div",{className:"menu_click",onClick:_this2.onPush.bind(_this2,x.key),dangerouslySetInnerHTML:{__html:x.title}}));}else{return _react2.default.createElement(SubMenu,{key:"sub"+x.title.split('.')[0],title:_react2.default.createElement("span",{dangerouslySetInnerHTML:{__html:x.title}})},(x.children||[]).map(function(item){if(item.children[0].title==='查看'){return _react2.default.createElement(_menu2.default.Item,{key:item.key},_react2.default.createElement("div",{className:"menu_click",onClick:_this2.onPush.bind(_this2,item.key),dangerouslySetInnerHTML:{__html:item.title}}));}return _react2.default.createElement(SubMenu,{key:"sub"+item.title,title:_react2.default.createElement("span",{dangerouslySetInnerHTML:{__html:item.title}})},(item.children||[]).map(function(_item){if(_item.children[0].title==='查看'){return _react2.default.createElement(_menu2.default.Item,{key:_item.key},_react2.default.createElement("div",{className:"menu_click",onClick:_this2.onPush.bind(_this2,_item.key),dangerouslySetInnerHTML:{__html:_item.title}}));}return;}));}));}})),isView&&user.is_charter&&user.is_charter==1&&(this.state.data||[]).some(function(x){return x.key==="/table/charter";})?_react2.default.createElement(SubMenu,{key:"subcharter",title:_react2.default.createElement("span",null,"Simple Report ",_react2.default.createElement("br",null)," \u7B80\u6613\u6570\u636E\u6C47\u603B\u8868")},((this.state.data||[]).find(function(x){return x.key==="/table/charter";})||[]).children.map(function(item){return _react2.default.createElement(_menu2.default.Item,{key:item.key},_react2.default.createElement("div",{className:"menu_click",onClick:_this2.onPush.bind(_this2,item.key),dangerouslySetInnerHTML:{__html:item.title}}));})):null,(this.state.data||[]).some(function(x){return x.key==="/bp";})?_react2.default.createElement(_menu2.default.Item,{key:"/bp"},_react2.default.createElement("div",{className:"menu_click",onClick:this.onPush.bind(this,'/bp')},"Business Plan",_react2.default.createElement("br",null),"  \u5E74\u5EA6\u7ECF\u8425\u9884\u7B97")):null,(this.state.data||[]).some(function(x){return x.key==="/hr";})?_react2.default.createElement(_menu2.default.Item,{key:"hr"},_react2.default.createElement("div",{className:"menu_click",onClick:this.onPush.bind(this,'/hr')},"Human Resources ",_react2.default.createElement("br",null)," \u4EBA\u529B\u8D44\u6E90\u62A5\u544A")):null,isView&&(this.state.user.email||'').includes('admin')?_react2.default.createElement(_menu2.default.Item,{key:"/table/comments"},_react2.default.createElement("div",{className:"menu_click",onClick:this.onPush.bind(this,'/table/comments')},"Corporate Office Review",_react2.default.createElement("br",null),"  \u96C6\u56E2\u4FE1\u606F\u6C47\u603B")):null,(this.state.user.email||'').includes('admin')?_react2.default.createElement(_menu2.default.Item,{key:"/table/compared"},_react2.default.createElement("div",{className:"menu_click",onClick:this.onPush.bind(this,'/table/compared')},"Custom Table ",_react2.default.createElement("br",null)," \u81EA\u5B9A\u4E49\u8868\u683C")):null,isView&&(this.state.data||[]).some(function(x){return x.key==="/table/pdf";})?_react2.default.createElement(_menu2.default.Item,{key:"/table/pdf"},_react2.default.createElement("div",{className:"menu_click",onClick:this.onPush.bind(this,'/table/pdf')},"PDF Version PDF",_react2.default.createElement("br",null),"  \u62A5\u8868")):null,(this.state.user.email||"").includes('admin')?_react2.default.createElement(SubMenu,{key:"headquarters_menu",title:_react2.default.createElement("span",null,"Headquarters Menu Summary ",_react2.default.createElement("br",null),"\u603B\u90E8\u83DC\u5355\u6C47\u603B")},(((this.state.data||[]).find(function(x){return x.key==="/table/headquarters";})||[]).children||[]).map(function(x){if(x.children[0].title==='查看'){return _react2.default.createElement(_menu2.default.Item,{key:x.key},_react2.default.createElement("div",{className:"menu_click",onClick:_this2.onPush.bind(_this2,x.key),dangerouslySetInnerHTML:{__html:x.title}}));}else{return _react2.default.createElement(SubMenu,{key:"sub"+x.title.split('.')[0],title:_react2.default.createElement("span",{dangerouslySetInnerHTML:{__html:x.title}})},(x.children||[]).map(function(item){return _react2.default.createElement(_menu2.default.Item,{key:item.key},_react2.default.createElement("div",{className:"menu_click",onClick:_this2.onPush.bind(_this2,item.key)},item.title));}));}})):null)),_react2.default.createElement(_ExportPdf2.default,null)));}return null;}}]);return MenuApp;}(_react.Component))||_class)||_class);exports.default=MenuApp;

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mini_store__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubPopupMenu__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_legacyUtil__ = __webpack_require__(907);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }







var Menu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Menu, _React$Component);

  function Menu(props) {
    var _this;

    _classCallCheck(this, Menu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Menu).call(this, props));

    _this.onSelect = function (selectInfo) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      if (props.selectable) {
        // root menu
        var _this$store$getState = _this.store.getState(),
            _selectedKeys = _this$store$getState.selectedKeys;

        var selectedKey = selectInfo.key;

        if (props.multiple) {
          _selectedKeys = _selectedKeys.concat([selectedKey]);
        } else {
          _selectedKeys = [selectedKey];
        }

        if (!('selectedKeys' in props)) {
          _this.store.setState({
            selectedKeys: _selectedKeys
          });
        }

        props.onSelect(_objectSpread({}, selectInfo, {
          selectedKeys: _selectedKeys
        }));
      }
    };

    _this.onClick = function (e) {
      _this.props.onClick(e);
    }; // onKeyDown needs to be exposed as a instance method
    // e.g., in rc-select, we need to navigate menu item while
    // current active item is rc-select input box rather than the menu itself


    _this.onKeyDown = function (e, callback) {
      _this.innerMenu.getWrappedInstance().onKeyDown(e, callback);
    };

    _this.onOpenChange = function (event) {
      var _assertThisInitialize2 = _assertThisInitialized(_this),
          props = _assertThisInitialize2.props;

      var openKeys = _this.store.getState().openKeys.concat();

      var changed = false;

      var processSingle = function processSingle(e) {
        var oneChanged = false;

        if (e.open) {
          oneChanged = openKeys.indexOf(e.key) === -1;

          if (oneChanged) {
            openKeys.push(e.key);
          }
        } else {
          var index = openKeys.indexOf(e.key);
          oneChanged = index !== -1;

          if (oneChanged) {
            openKeys.splice(index, 1);
          }
        }

        changed = changed || oneChanged;
      };

      if (Array.isArray(event)) {
        // batch change call
        event.forEach(processSingle);
      } else {
        processSingle(event);
      }

      if (changed) {
        if (!('openKeys' in _this.props)) {
          _this.store.setState({
            openKeys: openKeys
          });
        }

        props.onOpenChange(openKeys);
      }
    };

    _this.onDeselect = function (selectInfo) {
      var _assertThisInitialize3 = _assertThisInitialized(_this),
          props = _assertThisInitialize3.props;

      if (props.selectable) {
        var _selectedKeys2 = _this.store.getState().selectedKeys.concat();

        var selectedKey = selectInfo.key;

        var index = _selectedKeys2.indexOf(selectedKey);

        if (index !== -1) {
          _selectedKeys2.splice(index, 1);
        }

        if (!('selectedKeys' in props)) {
          _this.store.setState({
            selectedKeys: _selectedKeys2
          });
        }

        props.onDeselect(_objectSpread({}, selectInfo, {
          selectedKeys: _selectedKeys2
        }));
      }
    };

    _this.getOpenTransitionName = function () {
      var _assertThisInitialize4 = _assertThisInitialized(_this),
          props = _assertThisInitialize4.props;

      var transitionName = props.openTransitionName;
      var animationName = props.openAnimation;

      if (!transitionName && typeof animationName === 'string') {
        transitionName = "".concat(props.prefixCls, "-open-").concat(animationName);
      }

      return transitionName;
    };

    _this.setInnerMenu = function (node) {
      _this.innerMenu = node;
    };

    _this.isRootMenu = true;
    var selectedKeys = props.defaultSelectedKeys;
    var openKeys = props.defaultOpenKeys;

    if ('selectedKeys' in props) {
      selectedKeys = props.selectedKeys || [];
    }

    if ('openKeys' in props) {
      openKeys = props.openKeys || [];
    }

    _this.store = Object(__WEBPACK_IMPORTED_MODULE_1_mini_store__["create"])({
      selectedKeys: selectedKeys,
      openKeys: openKeys,
      activeKey: {
        '0-menu-': Object(__WEBPACK_IMPORTED_MODULE_2__SubPopupMenu__["b" /* getActiveKey */])(props, props.activeKey)
      }
    });
    return _this;
  }

  _createClass(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateMiniStore();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateMiniStore();
    }
  }, {
    key: "updateMiniStore",
    value: function updateMiniStore() {
      if ('selectedKeys' in this.props) {
        this.store.setState({
          selectedKeys: this.props.selectedKeys || []
        });
      }

      if ('openKeys' in this.props) {
        this.store.setState({
          openKeys: this.props.openKeys || []
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = _objectSpread({}, this.props);

      props.className += " ".concat(props.prefixCls, "-root");
      props = _objectSpread({}, props, {
        onClick: this.onClick,
        onOpenChange: this.onOpenChange,
        onDeselect: this.onDeselect,
        onSelect: this.onSelect,
        parentMenu: this,
        motion: Object(__WEBPACK_IMPORTED_MODULE_4__utils_legacyUtil__["a" /* getMotion */])(this.props)
      });
      delete props.openAnimation;
      delete props.openTransitionName;
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_mini_store__["Provider"], {
        store: this.store
      }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__SubPopupMenu__["a" /* default */], Object.assign({}, props, {
        ref: this.setInnerMenu
      }), this.props.children));
    }
  }]);

  return Menu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Menu.defaultProps = {
  selectable: true,
  onClick: __WEBPACK_IMPORTED_MODULE_3__util__["h" /* noop */],
  onSelect: __WEBPACK_IMPORTED_MODULE_3__util__["h" /* noop */],
  onOpenChange: __WEBPACK_IMPORTED_MODULE_3__util__["h" /* noop */],
  onDeselect: __WEBPACK_IMPORTED_MODULE_3__util__["h" /* noop */],
  defaultSelectedKeys: [],
  defaultOpenKeys: [],
  subMenuOpenDelay: 0.1,
  subMenuCloseDelay: 0.1,
  triggerSubMenuAction: 'hover',
  prefixCls: 'rc-menu',
  className: '',
  mode: 'vertical',
  style: {},
  builtinPlacements: {},
  overflowedIndicator: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "\xB7\xB7\xB7")
};
/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(484);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  function Provider() {
    _classCallCheck(this, Provider);

    return _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
  }

  _createClass(Provider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        miniStore: this.props.store
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);

  return Provider;
}(_react.Component);

Provider.propTypes = {
  store: _PropTypes.storeShape.isRequired
};
Provider.childContextTypes = {
  miniStore: _PropTypes.storeShape.isRequired
};
exports.default = Provider;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = connect;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _shallowequal = __webpack_require__(89);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _hoistNonReactStatics = __webpack_require__(893);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _reactLifecyclesCompat = __webpack_require__(36);

var _PropTypes = __webpack_require__(484);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function isStateless(Component) {
  return !Component.prototype.render;
}

var defaultMapStateToProps = function defaultMapStateToProps() {
  return {};
};

function connect(mapStateToProps) {
  var shouldSubscribe = !!mapStateToProps;
  var finnalMapStateToProps = mapStateToProps || defaultMapStateToProps;

  return function wrapWithConnect(WrappedComponent) {
    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      _createClass(Connect, null, [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(props, prevState) {
          // using ownProps
          if (mapStateToProps && mapStateToProps.length === 2 && props !== prevState.props) {
            return {
              subscribed: finnalMapStateToProps(prevState.store.getState(), props),
              props: props
            };
          }
          return { props: props };
        }
      }]);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, (Connect.__proto__ || Object.getPrototypeOf(Connect)).call(this, props, context));

        _this.handleChange = function () {
          if (!_this.unsubscribe) {
            return;
          }
          var nextState = finnalMapStateToProps(_this.store.getState(), _this.props);
          _this.setState({ subscribed: nextState });
        };

        _this.store = context.miniStore;
        _this.state = {
          subscribed: finnalMapStateToProps(_this.store.getState(), props),
          store: _this.store,
          props: props
        };
        return _this;
      }

      _createClass(Connect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.trySubscribe();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.tryUnsubscribe();
        }
      }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
          return !(0, _shallowequal2.default)(this.props, nextProps) || !(0, _shallowequal2.default)(this.state.subscribed, nextState.subscribed);
        }
      }, {
        key: 'trySubscribe',
        value: function trySubscribe() {
          if (shouldSubscribe) {
            this.unsubscribe = this.store.subscribe(this.handleChange);
            this.handleChange();
          }
        }
      }, {
        key: 'tryUnsubscribe',
        value: function tryUnsubscribe() {
          if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
          }
        }
      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          return this.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          var props = _extends({}, this.props, this.state.subscribed, {
            store: this.store
          });

          if (!isStateless(WrappedComponent)) {
            props = _extends({}, props, {
              ref: function ref(c) {
                return _this2.wrappedInstance = c;
              }
            });
          }

          return _react2.default.createElement(WrappedComponent, props);
        }
      }]);

      return Connect;
    }(_react.Component);

    Connect.displayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
    Connect.contextTypes = {
      miniStore: _PropTypes.storeShape.isRequired
    };


    (0, _reactLifecyclesCompat.polyfill)(Connect);

    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
  };
}

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = create;
function create(initialState) {
  var state = initialState;
  var listeners = [];

  function setState(partial) {
    state = _extends({}, state, partial);
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }
  }

  function getState() {
    return state;
  }

  function subscribe(listener) {
    listeners.push(listener);

    return function unsubscribe() {
      var index = listeners.indexOf(listener);
      listeners.splice(index, 1);
    };
  }

  return {
    setState: setState,
    getState: getState,
    subscribe: subscribe
  };
}

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// MIT License from https://github.com/kaimallea/isMobile
var applePhone = /iPhone/i;
var appleIpod = /iPod/i;
var appleTablet = /iPad/i;
var androidPhone = /\bAndroid(?:.+)Mobile\b/i; // Match 'Android' AND 'Mobile'

var androidTablet = /Android/i;
var amazonPhone = /\bAndroid(?:.+)SD4930UR\b/i;
var amazonTablet = /\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i;
var windowsPhone = /Windows Phone/i;
var windowsTablet = /\bWindows(?:.+)ARM\b/i; // Match 'Windows' AND 'ARM'

var otherBlackberry = /BlackBerry/i;
var otherBlackberry10 = /BB10/i;
var otherOpera = /Opera Mini/i;
var otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
var otherFirefox = /Mobile(?:.+)Firefox\b/i; // Match 'Mobile' AND 'Firefox'

function match(regex, userAgent) {
  return regex.test(userAgent);
}

function isMobile(userAgent) {
  var ua = userAgent || (typeof navigator !== 'undefined' ? navigator.userAgent : ''); // Facebook mobile app's integrated browser adds a bunch of strings that
  // match everything. Strip it out if it exists.

  var tmp = ua.split('[FBAN');

  if (typeof tmp[1] !== 'undefined') {
    var _tmp = tmp;

    var _tmp2 = _slicedToArray(_tmp, 1);

    ua = _tmp2[0];
  } // Twitter mobile app's integrated browser on iPad adds a "Twitter for
  // iPhone" string. Same probably happens on other tablet platforms.
  // This will confuse detection so strip it out if it exists.


  tmp = ua.split('Twitter');

  if (typeof tmp[1] !== 'undefined') {
    var _tmp3 = tmp;

    var _tmp4 = _slicedToArray(_tmp3, 1);

    ua = _tmp4[0];
  }

  var result = {
    apple: {
      phone: match(applePhone, ua) && !match(windowsPhone, ua),
      ipod: match(appleIpod, ua),
      tablet: !match(applePhone, ua) && match(appleTablet, ua) && !match(windowsPhone, ua),
      device: (match(applePhone, ua) || match(appleIpod, ua) || match(appleTablet, ua)) && !match(windowsPhone, ua)
    },
    amazon: {
      phone: match(amazonPhone, ua),
      tablet: !match(amazonPhone, ua) && match(amazonTablet, ua),
      device: match(amazonPhone, ua) || match(amazonTablet, ua)
    },
    android: {
      phone: !match(windowsPhone, ua) && match(amazonPhone, ua) || !match(windowsPhone, ua) && match(androidPhone, ua),
      tablet: !match(windowsPhone, ua) && !match(amazonPhone, ua) && !match(androidPhone, ua) && (match(amazonTablet, ua) || match(androidTablet, ua)),
      device: !match(windowsPhone, ua) && (match(amazonPhone, ua) || match(amazonTablet, ua) || match(androidPhone, ua) || match(androidTablet, ua)) || match(/\bokhttp\b/i, ua)
    },
    windows: {
      phone: match(windowsPhone, ua),
      tablet: match(windowsTablet, ua),
      device: match(windowsPhone, ua) || match(windowsTablet, ua)
    },
    other: {
      blackberry: match(otherBlackberry, ua),
      blackberry10: match(otherBlackberry10, ua),
      opera: match(otherOpera, ua),
      firefox: match(otherFirefox, ua),
      chrome: match(otherChrome, ua),
      device: match(otherBlackberry, ua) || match(otherBlackberry10, ua) || match(otherOpera, ua) || match(otherFirefox, ua) || match(otherChrome, ua)
    },
    // Additional
    any: null,
    phone: null,
    tablet: null
  };
  result.any = result.apple.device || result.android.device || result.windows.device || result.other.device; // excludes 'other' devices and ipods, targeting touchscreen phones

  result.phone = result.apple.phone || result.android.phone || result.windows.phone;
  result.tablet = result.apple.tablet || result.android.tablet || result.windows.tablet;
  return result;
}

var defaultResult = _objectSpread({}, isMobile(), {
  isMobile: isMobile
});

/* harmony default export */ __webpack_exports__["a"] = (defaultResult);

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_resize_observer_polyfill__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubMenu__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(191);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }






var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var MENUITEM_OVERFLOWED_CLASSNAME = 'menuitem-overflowed';
var FLOAT_PRECISION_ADJUST = 0.5; // Fix ssr

if (canUseDOM) {
  // eslint-disable-next-line global-require
  __webpack_require__(906);
}

var DOMWrap =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DOMWrap, _React$Component);

  function DOMWrap() {
    var _this;

    _classCallCheck(this, DOMWrap);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DOMWrap).apply(this, arguments));
    _this.resizeObserver = null;
    _this.mutationObserver = null; // original scroll size of the list

    _this.originalTotalWidth = 0; // copy of overflowed items

    _this.overflowedItems = []; // cache item of the original items (so we can track the size and order)

    _this.menuItemSizes = [];
    _this.state = {
      lastVisibleIndex: undefined
    }; // get all valid menuItem nodes

    _this.getMenuItemNodes = function () {
      var prefixCls = _this.props.prefixCls;
      var ul = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](_assertThisInitialized(_this));

      if (!ul) {
        return [];
      } // filter out all overflowed indicator placeholder


      return [].slice.call(ul.children).filter(function (node) {
        return node.className.split(' ').indexOf("".concat(prefixCls, "-overflowed-submenu")) < 0;
      });
    };

    _this.getOverflowedSubMenuItem = function (keyPrefix, overflowedItems, renderPlaceholder) {
      var _this$props = _this.props,
          overflowedIndicator = _this$props.overflowedIndicator,
          level = _this$props.level,
          mode = _this$props.mode,
          prefixCls = _this$props.prefixCls,
          theme = _this$props.theme;

      if (level !== 1 || mode !== 'horizontal') {
        return null;
      } // put all the overflowed item inside a submenu
      // with a title of overflow indicator ('...')


      var copy = _this.props.children[0];

      var _copy$props = copy.props,
          throwAway = _copy$props.children,
          title = _copy$props.title,
          propStyle = _copy$props.style,
          rest = _objectWithoutProperties(_copy$props, ["children", "title", "style"]);

      var style = _objectSpread({}, propStyle);

      var key = "".concat(keyPrefix, "-overflowed-indicator");
      var eventKey = "".concat(keyPrefix, "-overflowed-indicator");

      if (overflowedItems.length === 0 && renderPlaceholder !== true) {
        style = _objectSpread({}, style, {
          display: 'none'
        });
      } else if (renderPlaceholder) {
        style = _objectSpread({}, style, {
          visibility: 'hidden',
          // prevent from taking normal dom space
          position: 'absolute'
        });
        key = "".concat(key, "-placeholder");
        eventKey = "".concat(eventKey, "-placeholder");
      }

      var popupClassName = theme ? "".concat(prefixCls, "-").concat(theme) : '';
      var props = {};
      __WEBPACK_IMPORTED_MODULE_4__util__["g" /* menuAllProps */].forEach(function (k) {
        if (rest[k] !== undefined) {
          props[k] = rest[k];
        }
      });
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__SubMenu__["a" /* default */], Object.assign({
        title: overflowedIndicator,
        className: "".concat(prefixCls, "-overflowed-submenu"),
        popupClassName: popupClassName
      }, props, {
        key: key,
        eventKey: eventKey,
        disabled: false,
        style: style
      }), overflowedItems);
    }; // memorize rendered menuSize


    _this.setChildrenWidthAndResize = function () {
      if (_this.props.mode !== 'horizontal') {
        return;
      }

      var ul = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](_assertThisInitialized(_this));

      if (!ul) {
        return;
      }

      var ulChildrenNodes = ul.children;

      if (!ulChildrenNodes || ulChildrenNodes.length === 0) {
        return;
      }

      var lastOverflowedIndicatorPlaceholder = ul.children[ulChildrenNodes.length - 1]; // need last overflowed indicator for calculating length;

      Object(__WEBPACK_IMPORTED_MODULE_4__util__["i" /* setStyle */])(lastOverflowedIndicatorPlaceholder, 'display', 'inline-block');

      var menuItemNodes = _this.getMenuItemNodes(); // reset display attribute for all hidden elements caused by overflow to calculate updated width
      // and then reset to original state after width calculation


      var overflowedItems = menuItemNodes.filter(function (c) {
        return c.className.split(' ').indexOf(MENUITEM_OVERFLOWED_CLASSNAME) >= 0;
      });
      overflowedItems.forEach(function (c) {
        Object(__WEBPACK_IMPORTED_MODULE_4__util__["i" /* setStyle */])(c, 'display', 'inline-block');
      });
      _this.menuItemSizes = menuItemNodes.map(function (c) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__util__["c" /* getWidth */])(c);
      });
      overflowedItems.forEach(function (c) {
        Object(__WEBPACK_IMPORTED_MODULE_4__util__["i" /* setStyle */])(c, 'display', 'none');
      });
      _this.overflowedIndicatorWidth = Object(__WEBPACK_IMPORTED_MODULE_4__util__["c" /* getWidth */])(ul.children[ul.children.length - 1]);
      _this.originalTotalWidth = _this.menuItemSizes.reduce(function (acc, cur) {
        return acc + cur;
      }, 0);

      _this.handleResize(); // prevent the overflowed indicator from taking space;


      Object(__WEBPACK_IMPORTED_MODULE_4__util__["i" /* setStyle */])(lastOverflowedIndicatorPlaceholder, 'display', 'none');
    };

    _this.handleResize = function () {
      if (_this.props.mode !== 'horizontal') {
        return;
      }

      var ul = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](_assertThisInitialized(_this));

      if (!ul) {
        return;
      }

      var width = Object(__WEBPACK_IMPORTED_MODULE_4__util__["c" /* getWidth */])(ul);
      _this.overflowedItems = [];
      var currentSumWidth = 0; // index for last visible child in horizontal mode

      var lastVisibleIndex; // float number comparison could be problematic
      // e.g. 0.1 + 0.2 > 0.3 =====> true
      // thus using FLOAT_PRECISION_ADJUST as buffer to help the situation

      if (_this.originalTotalWidth > width + FLOAT_PRECISION_ADJUST) {
        lastVisibleIndex = -1;

        _this.menuItemSizes.forEach(function (liWidth) {
          currentSumWidth += liWidth;

          if (currentSumWidth + _this.overflowedIndicatorWidth <= width) {
            lastVisibleIndex += 1;
          }
        });
      }

      _this.setState({
        lastVisibleIndex: lastVisibleIndex
      });
    };

    return _this;
  }

  _createClass(DOMWrap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setChildrenWidthAndResize();

      if (this.props.level === 1 && this.props.mode === 'horizontal') {
        var menuUl = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](this);

        if (!menuUl) {
          return;
        }

        this.resizeObserver = new __WEBPACK_IMPORTED_MODULE_2_resize_observer_polyfill__["default"](function (entries) {
          entries.forEach(_this2.setChildrenWidthAndResize);
        });
        [].slice.call(menuUl.children).concat(menuUl).forEach(function (el) {
          _this2.resizeObserver.observe(el);
        });

        if (typeof MutationObserver !== 'undefined') {
          this.mutationObserver = new MutationObserver(function () {
            _this2.resizeObserver.disconnect();

            [].slice.call(menuUl.children).concat(menuUl).forEach(function (el) {
              _this2.resizeObserver.observe(el);
            });

            _this2.setChildrenWidthAndResize();
          });
          this.mutationObserver.observe(menuUl, {
            attributes: false,
            childList: true,
            subTree: false
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(children) {
      var _this3 = this;

      // need to take care of overflowed items in horizontal mode
      var lastVisibleIndex = this.state.lastVisibleIndex;
      return (children || []).reduce(function (acc, childNode, index) {
        var item = childNode;

        if (_this3.props.mode === 'horizontal') {
          var overflowed = _this3.getOverflowedSubMenuItem(childNode.props.eventKey, []);

          if (lastVisibleIndex !== undefined && _this3.props.className.indexOf("".concat(_this3.props.prefixCls, "-root")) !== -1) {
            if (index > lastVisibleIndex) {
              item = __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](childNode, // 这里修改 eventKey 是为了防止隐藏状态下还会触发 openkeys 事件
              {
                style: {
                  display: 'none'
                },
                eventKey: "".concat(childNode.props.eventKey, "-hidden"),

                /**
                 * Legacy code. Here `className` never used:
                 * https://github.com/react-component/menu/commit/4cd6b49fce9d116726f4ea00dda85325d6f26500#diff-e2fa48f75c2dd2318295cde428556a76R240
                 */
                className: "".concat(MENUITEM_OVERFLOWED_CLASSNAME)
              });
            }

            if (index === lastVisibleIndex + 1) {
              _this3.overflowedItems = children.slice(lastVisibleIndex + 1).map(function (c) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](c, // children[index].key will become '.$key' in clone by default,
                // we have to overwrite with the correct key explicitly
                {
                  key: c.props.eventKey,
                  mode: 'vertical-left'
                });
              });
              overflowed = _this3.getOverflowedSubMenuItem(childNode.props.eventKey, _this3.overflowedItems);
            }
          }

          var ret = [].concat(_toConsumableArray(acc), [overflowed, item]);

          if (index === children.length - 1) {
            // need a placeholder for calculating overflowed indicator width
            ret.push(_this3.getOverflowedSubMenuItem(childNode.props.eventKey, [], true));
          }

          return ret;
        }

        return [].concat(_toConsumableArray(acc), [item]);
      }, []);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          visible = _this$props2.visible,
          prefixCls = _this$props2.prefixCls,
          overflowedIndicator = _this$props2.overflowedIndicator,
          mode = _this$props2.mode,
          level = _this$props2.level,
          tag = _this$props2.tag,
          children = _this$props2.children,
          theme = _this$props2.theme,
          rest = _objectWithoutProperties(_this$props2, ["visible", "prefixCls", "overflowedIndicator", "mode", "level", "tag", "children", "theme"]);

      var Tag = tag;
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Tag, Object.assign({}, rest), this.renderChildren(children));
    }
  }]);

  return DOMWrap;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DOMWrap.defaultProps = {
  tag: 'div',
  className: ''
};
/* harmony default export */ __webpack_exports__["a"] = (DOMWrap);

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_align__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopupInner__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(488);













var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      // Used for stretch
      stretchChecked: false,
      targetWidth: undefined,
      targetHeight: undefined
    };

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    this.rootNode = this.getPopupDomNode();
    this.setStretchSize();
  };

  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
    this.setStretchSize();
  };

  // Record size if stretch needed


  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.popupInstance);
  };

  // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align


  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
    var props = this.props;
    var transitionName = props.maskTransitionName;
    var animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = props.prefixCls + '-' + animation;
    }
    return transitionName;
  };

  Popup.prototype.getTransitionName = function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  };

  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
  };

  Popup.prototype.getPopupElement = function getPopupElement() {
    var _this2 = this;

    var savePopupRef = this.savePopupRef;
    var _state = this.state,
        stretchChecked = _state.stretchChecked,
        targetHeight = _state.targetHeight,
        targetWidth = _state.targetWidth;
    var _props = this.props,
        align = _props.align,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        style = _props.style,
        getClassNameFromAlign = _props.getClassNameFromAlign,
        destroyPopupOnHide = _props.destroyPopupOnHide,
        stretch = _props.stretch,
        children = _props.children,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        onMouseDown = _props.onMouseDown,
        onTouchStart = _props.onTouchStart;

    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
    var hiddenClassName = prefixCls + '-hidden';

    if (!visible) {
      this.currentAlignClassName = null;
    }

    var sizeStyle = {};
    if (stretch) {
      // Stretch with target
      if (stretch.indexOf('height') !== -1) {
        sizeStyle.height = targetHeight;
      } else if (stretch.indexOf('minHeight') !== -1) {
        sizeStyle.minHeight = targetHeight;
      }
      if (stretch.indexOf('width') !== -1) {
        sizeStyle.width = targetWidth;
      } else if (stretch.indexOf('minWidth') !== -1) {
        sizeStyle.minWidth = targetWidth;
      }

      // Delay force align to makes ui smooth
      if (!stretchChecked) {
        sizeStyle.visibility = 'hidden';
        setTimeout(function () {
          if (_this2.alignInstance) {
            _this2.alignInstance.forceAlign();
          }
        }, 0);
      }
    }

    var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sizeStyle, style, this.getZIndexStyle());

    var popupInnerProps = {
      className: className,
      prefixCls: prefixCls,
      ref: savePopupRef,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseDown: onMouseDown,
      onTouchStart: onTouchStart,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_rc_animate__["default"],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName()
        },
        visible ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
          {
            target: this.getAlignTarget(),
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              visible: true
            }, popupInnerProps),
            children
          )
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_rc_animate__["default"],
      {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName(),
        showProp: 'xVisible'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
        {
          target: this.getAlignTarget(),
          key: 'popup',
          ref: this.saveAlignRef,
          monitorWindowResize: true,
          xVisible: visible,
          childrenProps: { visible: 'xVisible' },
          disabled: !visible,
          align: align,
          onAlign: this.onAlign
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            hiddenClassName: hiddenClassName
          }, popupInnerProps),
          children
        )
      )
    );
  };

  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
    var style = {};
    var props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  };

  Popup.prototype.getMaskElement = function getMaskElement() {
    var props = this.props;
    var maskElement = void 0;
    if (props.mask) {
      var maskTransition = this.getMaskTransitionName();
      maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__["a" /* default */], {
        style: this.getZIndexStyle(),
        key: 'mask',
        className: props.prefixCls + '-mask',
        hiddenClassName: props.prefixCls + '-mask-hidden',
        visible: props.visible
      });
      if (maskTransition) {
        maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_animate__["default"],
          {
            key: 'mask',
            showProp: 'visible',
            transitionAppear: true,
            component: '',
            transitionName: maskTransition
          },
          maskElement
        );
      }
    }
    return maskElement;
  };

  Popup.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      null,
      this.getMaskElement(),
      this.getPopupElement()
    );
  };

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  point: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this3.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this3.currentAlignClassName !== currentAlignClassName) {
      _this3.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this3.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.setStretchSize = function () {
    var _props2 = _this3.props,
        stretch = _props2.stretch,
        getRootDomNode = _props2.getRootDomNode,
        visible = _props2.visible;
    var _state2 = _this3.state,
        stretchChecked = _state2.stretchChecked,
        targetHeight = _state2.targetHeight,
        targetWidth = _state2.targetWidth;


    if (!stretch || !visible) {
      if (stretchChecked) {
        _this3.setState({ stretchChecked: false });
      }
      return;
    }

    var $ele = getRootDomNode();
    if (!$ele) return;

    var height = $ele.offsetHeight;
    var width = $ele.offsetWidth;

    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
      _this3.setState({
        stretchChecked: true,
        targetHeight: height,
        targetWidth: width
      });
    }
  };

  this.getTargetElement = function () {
    return _this3.props.getRootDomNode();
  };

  this.getAlignTarget = function () {
    var point = _this3.props.point;

    if (point) {
      return point;
    }
    return _this3.getTargetElement;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(899);
// export this package's api


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_align__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(901);












function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        // IE lose focus after element realign
        // We should record activeElement and restore later
        var activeElement = document.activeElement;

        if (element) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["a" /* alignElement */])(source, element, align);
        } else if (point) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["b" /* alignPoint */])(source, point, align);
        }

        Object(__WEBPACK_IMPORTED_MODULE_9__util__["e" /* restoreFocus */])(activeElement, source);

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Align, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      // if parent ref not attached .... use document.getElementById
      this.forceAlign();
      if (!props.disabled && props.monitorWindowResize) {
        this.startMonitorWindowResize();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var reAlign = false;
      var props = this.props;

      if (!props.disabled) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
        var sourceRect = source ? source.getBoundingClientRect() : null;

        if (prevProps.disabled) {
          reAlign = true;
        } else {
          var lastElement = getElement(prevProps.target);
          var currentElement = getElement(props.target);
          var lastPoint = getPoint(prevProps.target);
          var currentPoint = getPoint(props.target);

          if (Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(lastElement) && Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(currentElement)) {
            // Skip if is window
            reAlign = false;
          } else if (lastElement !== currentElement || // Element change
          lastElement && !currentElement && currentPoint || // Change from element to point
          lastPoint && currentPoint && currentElement || // Change from point to element
          currentPoint && !Object(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* isSamePoint */])(lastPoint, currentPoint)) {
            reAlign = true;
          }

          // If source element size changed
          var preRect = this.sourceRect || {};
          if (!reAlign && source && (!Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.width, sourceRect.width) || !Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.height, sourceRect.height))) {
            reAlign = true;
          }
        }

        this.sourceRect = sourceRect;
      }

      if (reAlign) {
        this.forceAlign();
      }

      if (props.monitorWindowResize && !props.disabled) {
        this.startMonitorWindowResize();
      } else {
        this.stopMonitorWindowResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopMonitorWindowResize();
    }
  }, {
    key: 'startMonitorWindowResize',
    value: function startMonitorWindowResize() {
      if (!this.resizeHandler) {
        this.bufferMonitor = Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* buffer */])(this.forceAlign, this.props.monitorBufferTime);
        this.resizeHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
      }
    }
  }, {
    key: 'stopMonitorWindowResize',
    value: function stopMonitorWindowResize() {
      if (this.resizeHandler) {
        this.bufferMonitor.clear();
        this.resizeHandler.remove();
        this.resizeHandler = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          childrenProps = _props.childrenProps,
          children = _props.children;

      var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
      if (childrenProps) {
        var newProps = {};
        var propList = Object.keys(childrenProps);
        propList.forEach(function (prop) {
          newProps[prop] = _this2.props[childrenProps[prop]];
        });

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newProps);
      }
      return child;
    }
  }]);

  return Align;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    clientX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    clientY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })]),
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alignElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alignPoint; });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var vendorPrefix;
var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};
function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }
  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';
  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }
  return vendorPrefix;
}
function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}
function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
  var name = getTransitionName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}
function setTransform(node, value) {
  var name = getTransformName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}
function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}
function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var arr;
    var match2d = transform.match(matrix2d);
    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(','), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX;

// https://stackoverflow.com/a/3485654/3040605
function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line
  elem.style.display = originalStyle;
}
function css(el, name, v) {
  var value = v;
  if (_typeof(name) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = "".concat(value, "px");
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}
function getClientPosition(elem) {
  var box;
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = Math.floor(box.left);
  y = Math.floor(box.top);

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}
function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}
function getScrollLeft(w) {
  return getScroll(w);
}
function getScrollTop(w) {
  return getScroll(w, true);
}
function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}
function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }
  if (node.nodeType === 9) {
    return node;
  }
  return node.ownerDocument;
}
function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }
  return val;
}
var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';
function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}
if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}
function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }
  return option.useCssBottom ? 'bottom' : dir;
}
function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
}

// 设置 elem 相对 elem.ownerDocument 的坐标
function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }
  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
  if (horizontalProperty !== 'left') {
    presetH = 999;
  }
  if (verticalProperty !== 'top') {
    presetV = 999;
  }
  var originalTransition = '';
  var originalOffset = getOffset(elem);
  if ('left' in offset || 'top' in offset) {
    originalTransition = getTransitionProperty(elem) || '';
    setTransitionProperty(elem, 'none');
  }
  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }
  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = "".concat(presetV, "px");
  }
  // force relayout
  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};
  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];
      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }
  css(elem, originalStyle);
  // force relayout
  forceRelayout(elem);
  if ('left' in offset || 'top' in offset) {
    setTransitionProperty(elem, originalTransition);
  }
  var ret = {};
  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);
      var _off = offset[_key] - originalOffset[_key];
      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }
  css(elem, ret);
}
function setTransform$1(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };
  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }
  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }
  setTransformXY(elem, resultXY);
}
function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);
    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }
  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset);
  } else {
    setLeftTop(elem, offset, option);
  }
}
function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}
function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}
var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;
function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }
  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}
function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j;
  var i;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;
        if (prop === 'border') {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}
var domUtils = {
  getParent: function getParent(element) {
    var parent = element;
    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
    return parent;
  }
};
each(['Width', 'Height'], function (name) {
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement["scroll".concat(name)],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
  };
  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, ex) {
  var extra = ex;
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;
  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which);
    }
    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }
    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}
var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var val;
  var elem = args[0];
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}
each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils["outer".concat(first)] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  domUtils[name] = function (elem, v) {
    var val = v;
    if (val !== undefined) {
      if (elem) {
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});
function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }
  return to;
}
var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i;
    var ret = {};
    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },
  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};
    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }
    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);

/**
 * 得到会导致元素显示不全的祖先元素
 */
var getParent = utils.getParent;
function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  }
  // ie 这个也不是完全可行
  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
  }
  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
    positionStyle = utils.css(parent, 'position');
    if (positionStyle !== 'static') {
      return parent;
    }
  }
  return null;
}

var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;
  for (parent = getParent$1(element);
  // 修复元素位于 document.documentElement 下导致崩溃问题
  parent && parent !== body && parent !== doc; parent = getParent$1(parent)) {
    var positionStyle = utils.css(parent, 'position');
    if (positionStyle === 'fixed') {
      return true;
    }
  }
  return false;
}

/**
 * 获得元素的显示部分的区域
 */
function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement;

  // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.
  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
    // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
      var pos = utils.offset(el);
      // add border
      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right,
      // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }
    el = getOffsetParent(el);
  }

  // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601
  var originalPosition = null;
  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, 'position');
    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight;

  // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.
  var bodyStyle = window.getComputedStyle(body);
  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }
  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  }

  // Reset element position after calculate the visible area
  if (element.style) {
    element.style.position = originalPosition;
  }
  if (alwaysByViewport || isAncestorFixed(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }
  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };
  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  }

  // Left edge inside and right edge outside viewport, try to resize it.
  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  }

  // Right edge outside viewport, try to move it.
  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  }

  // Top edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  }

  // Top edge inside and bottom edge outside viewport, try to resize it.
  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  }

  // Bottom edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }
  return utils.mix(pos, size);
}

function getRegion(node) {
  var offset;
  var w;
  var h;
  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset = utils.offset(node);
    w = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }
  offset.width = w;
  offset.height = h;
  return offset;
}

/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */

function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = region.left;
  var y = region.top;
  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }
  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }
  return {
    left: x,
    top: y
  };
}

function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
  };
}

/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */

// http://yiminghe.iteye.com/blog/1124720

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}
function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}
function convertOffset(str, offsetLen) {
  var n;
  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }
  return n || 0;
}
function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}

/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */
function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
  // 当前节点可以被放置的显示区域
  var visibleRect = getVisibleRectForElement(source, alwaysByViewport);
  // 当前节点所占的区域, left/top/width/height
  var elRegion = getRegion(source);
  // 将 offset 转换成数值，支持百分比
  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion);
  // 当前节点将要被放置的位置
  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
  // 当前节点将要所处的区域
  var newElRegion = utils.merge(elRegion, elFuturePos);

  // 如果可视区域不能完全放置当前节点时允许调整
  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
        // 偏移量也反下
        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }
    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
        // 偏移量也反下
        var _newOffset = flipOffset(offset, 1);
        var _newTargetOffset = flipOffset(targetOffset, 1);
        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    }

    // 如果失败，重新计算当前节点将要被放置的位置
    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
      utils.mix(newElRegion, elFuturePos);
    }
    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
    // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数
    if (isStillFailX || isStillFailY) {
      var _newPoints2 = points;

      // 重置对应部分的翻转逻辑
      if (isStillFailX) {
        _newPoints2 = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
      }
      if (isStillFailY) {
        _newPoints2 = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
      }
      points = _newPoints2;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    }
    // 2. 只有指定了可以调整当前方向才调整
    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;

    // 确实要调整，甚至可能会调整高度宽度
    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  }

  // need judge to in case set fixed with in css on height auto element
  if (newElRegion.width !== elRegion.width) {
    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
  }
  if (newElRegion.height !== elRegion.height) {
    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
  }

  // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>
  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;

/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }
  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }
  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;

  // Provide default target point
  var points = [align.points[0], 'cc'];
  return doAlign(el, tgtRegion, _objectSpread2(_objectSpread2({}, align), {}, {
    points: points
  }), pointInView);
}

/* unused harmony default export */ var _unused_webpack_default_export = (alignElement);

//# sourceMappingURL=index.js.map


/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buffer;
/* harmony export (immutable) */ __webpack_exports__["b"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["d"] = isWindow;
/* harmony export (immutable) */ __webpack_exports__["c"] = isSimilarValue;
/* harmony export (immutable) */ __webpack_exports__["e"] = restoreFocus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__ = __webpack_require__(338);


function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

function isSimilarValue(val1, val2) {
  var int1 = Math.floor(val1);
  var int2 = Math.floor(val2);
  return Math.abs(int1 - int2) <= 1;
}

function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && Object(__WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__["a" /* default */])(container, activeElement)) {
    activeElement.focus();
  }
}

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__ = __webpack_require__(489);







var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  PopupInner.prototype.render = function render() {
    var props = this.props;
    var className = props.className;
    if (!props.visible) {
      className += ' ' + props.hiddenClassName;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: className,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseDown: props.onMouseDown,
        onTouchStart: props.onTouchStart,
        style: props.style
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__["a" /* default */],
        { className: props.prefixCls + '-content', visible: props.visible },
        props.children
      )
    );
  };

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findDOMNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);

/**
 * Return if a node is a DOM node. Else will return by `findDOMNode`
 */

function findDOMNode(node) {
  if (node instanceof HTMLElement) {
    return node;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.findDOMNode(node);
}

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getVendorPrefixes */
/* unused harmony export getVendorPrefixedEventName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return animationEndName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return transitionEndName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return supportTransition; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getTransitionName;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// ================= Transition =================
// Event wrapper. Copy from react source code
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

function getVendorPrefixes(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap('Animation', 'AnimationEnd'),
    transitionend: makePrefixMap('Transition', 'TransitionEnd')
  };

  if (domSupport) {
    if (!('AnimationEvent' in win)) {
      delete prefixes.animationend.animation;
    }

    if (!('TransitionEvent' in win)) {
      delete prefixes.transitionend.transition;
    }
  }

  return prefixes;
}

var vendorPrefixes = getVendorPrefixes(canUseDOM, typeof window !== 'undefined' ? window : {});

var style = {};

if (canUseDOM) {
  style = document.createElement('div').style;
}

var prefixedEventNames = {};

function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }

  var prefixMap = vendorPrefixes[eventName];

  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;
    for (var i = 0; i < len; i += 1) {
      var styleProp = stylePropList[i];
      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }

  return '';
}

var animationEndName = getVendorPrefixedEventName('animationend');
var transitionEndName = getVendorPrefixedEventName('transitionend');
var supportTransition = !!(animationEndName && transitionEndName);

function getTransitionName(transitionName, transitionType) {
  if (!transitionName) return null;

  if (typeof transitionName === 'object') {
    var type = transitionType.replace(/-\w/g, function (match) {
      return match[1].toUpperCase();
    });
    return transitionName[type];
  }

  return transitionName + '-' + transitionType;
}

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export placements */
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var placements = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 7]
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0]
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0]
  }
};
/* harmony default export */ __webpack_exports__["a"] = (placements);

/***/ }),
/* 906 */
/***/ (function(module, exports) {

// mutationobserver-shim v0.3.3 (github.com/megawac/MutationObserver.js)
// Authors: Graeme Yeates (github.com/megawac) 
/*
 Shim for MutationObserver interface
 Author: Graeme Yeates (github.com/megawac)
 Repository: https://github.com/megawac/MutationObserver.js
 License: WTFPL V2, 2004 (wtfpl.net).
 Though credit and staring the repo will make me feel pretty, you can modify and redistribute as you please.
 Attempts to follow spec (https://www.w3.org/TR/dom/#mutation-observers) as closely as possible for native javascript
 See https://github.com/WebKit/webkit/blob/master/Source/WebCore/dom/MutationObserver.cpp for current webkit source c++ implementation
*/
window.MutationObserver||(window.MutationObserver=function(y){function z(a){this.i=[];this.m=a}function K(a){(function c(){var d=a.takeRecords();d.length&&a.m(d,a);a.h=setTimeout(c,z._period)})()}function r(a){var b={type:null,target:null,addedNodes:[],removedNodes:[],previousSibling:null,nextSibling:null,attributeName:null,attributeNamespace:null,oldValue:null},c;for(c in a)b[c]!==y&&a[c]!==y&&(b[c]=a[c]);return b}function L(a,b){var c=E(a,b);return function(d){var f=d.length;b.a&&3===a.nodeType&&
a.nodeValue!==c.a&&d.push(new r({type:"characterData",target:a,oldValue:c.a}));b.b&&c.b&&C(d,a,c.b,b.f);if(b.c||b.g)var m=M(d,a,c,b);if(m||d.length!==f)c=E(a,b)}}function N(a,b){return b.value}function O(a,b){return"style"!==b.name?b.value:a.style.cssText}function C(a,b,c,d){for(var f={},m=b.attributes,k,g,p=m.length;p--;)k=m[p],g=k.name,d&&d[g]===y||(F(b,k)!==c[g]&&a.push(r({type:"attributes",target:b,attributeName:g,oldValue:c[g],attributeNamespace:k.namespaceURI})),f[g]=!0);for(g in c)f[g]||a.push(r({target:b,
type:"attributes",attributeName:g,oldValue:c[g]}))}function M(a,b,c,d){function f(g,p,t,q,x){var A=g.length-1;x=-~((A-x)/2);for(var h,l,e;e=g.pop();)h=t[e.j],l=q[e.l],d.c&&x&&Math.abs(e.j-e.l)>=A&&(a.push(r({type:"childList",target:p,addedNodes:[h],removedNodes:[h],nextSibling:h.nextSibling,previousSibling:h.previousSibling})),x--),d.b&&l.b&&C(a,h,l.b,d.f),d.a&&3===h.nodeType&&h.nodeValue!==l.a&&a.push(r({type:"characterData",target:h,oldValue:l.a})),d.g&&m(h,l)}function m(g,p){for(var t=g.childNodes,
q=p.c,x=t.length,A=q?q.length:0,h,l,e,n,v,B=0,w=0,u=0;w<x||u<A;)n=t[w],v=(e=q[u])&&e.node,n===v?(d.b&&e.b&&C(a,n,e.b,d.f),d.a&&e.a!==y&&n.nodeValue!==e.a&&a.push(r({type:"characterData",target:n,oldValue:e.a})),l&&f(l,g,t,q,B),d.g&&(n.childNodes.length||e.c&&e.c.length)&&m(n,e),w++,u++):(k=!0,h||(h={},l=[]),n&&(h[e=G(n)]||(h[e]=!0,-1===(e=H(q,n,u,"node"))?d.c&&(a.push(r({type:"childList",target:g,addedNodes:[n],nextSibling:n.nextSibling,previousSibling:n.previousSibling})),B++):l.push({j:w,l:e})),
w++),v&&v!==t[w]&&(h[e=G(v)]||(h[e]=!0,-1===(e=H(t,v,w))?d.c&&(a.push(r({type:"childList",target:p.node,removedNodes:[v],nextSibling:q[u+1],previousSibling:q[u-1]})),B--):l.push({j:e,l:u})),u++));l&&f(l,g,t,q,B)}var k;m(b,c);return k}function E(a,b){var c=!0;return function m(f){var k={node:f};!b.a||3!==f.nodeType&&8!==f.nodeType?(b.b&&c&&1===f.nodeType&&(k.b=I(f.attributes,function(g,p){if(!b.f||b.f[p.name])g[p.name]=F(f,p);return g},{})),c&&(b.c||b.a||b.b&&b.g)&&(k.c=P(f.childNodes,m)),c=b.g):k.a=
f.nodeValue;return k}(a)}function G(a){try{return a.id||(a.mo_id=a.mo_id||J++)}catch(b){try{return a.nodeValue}catch(c){return J++}}}function P(a,b){for(var c=[],d=0;d<a.length;d++)c[d]=b(a[d],d,a);return c}function I(a,b,c){for(var d=0;d<a.length;d++)c=b(c,a[d],d,a);return c}function H(a,b,c,d){for(;c<a.length;c++)if((d?a[c][d]:a[c])===b)return c;return-1}z._period=30;z.prototype={observe:function(a,b){for(var c={b:!!(b.attributes||b.attributeFilter||b.attributeOldValue),c:!!b.childList,g:!!b.subtree,
a:!(!b.characterData&&!b.characterDataOldValue)},d=this.i,f=0;f<d.length;f++)d[f].s===a&&d.splice(f,1);b.attributeFilter&&(c.f=I(b.attributeFilter,function(m,k){m[k]=!0;return m},{}));d.push({s:a,o:L(a,c)});this.h||K(this)},takeRecords:function(){for(var a=[],b=this.i,c=0;c<b.length;c++)b[c].o(a);return a},disconnect:function(){this.i=[];clearTimeout(this.h);this.h=null}};var D=document.createElement("i");D.style.top=0;var F=(D="null"!=D.attributes.style.value)?N:O,J=1;return z}(void 0));
//# sourceMappingURL=mutationobserver.map


/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMotion;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_util_es_warning__ = __webpack_require__(908);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


function getMotion(_ref) {
  var prefixCls = _ref.prefixCls,
      motion = _ref.motion,
      openAnimation = _ref.openAnimation,
      openTransitionName = _ref.openTransitionName;

  if (motion) {
    return motion;
  }

  if (_typeof(openAnimation) === 'object' && openAnimation) {
    Object(__WEBPACK_IMPORTED_MODULE_0_rc_util_es_warning__["a" /* default */])(false, 'Object type of `openAnimation` is removed. Please use `motion` instead.');
  } else if (typeof openAnimation === 'string') {
    return {
      motionName: "".concat(prefixCls, "-open-").concat(openAnimation)
    };
  }

  if (openTransitionName) {
    return {
      motionName: openTransitionName
    };
  }

  return null;
}

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export warning */
/* unused harmony export note */
/* unused harmony export resetWarned */
/* unused harmony export call */
/* unused harmony export warningOnce */
/* unused harmony export noteOnce */
/* eslint-disable no-console */
var warned = {};
function warning(valid, message) {
  // Support uglify
  if (false) {
    console.error("Warning: ".concat(message));
  }
}
function note(valid, message) {
  // Support uglify
  if (false) {
    console.warn("Note: ".concat(message));
  }
}
function resetWarned() {
  warned = {};
}
function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}
function warningOnce(valid, message) {
  call(warning, valid, message);
}
function noteOnce(valid, message) {
  call(note, valid, message);
}
/* harmony default export */ __webpack_exports__["a"] = (warningOnce);
/* eslint-enable */

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MenuItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_scroll_into_view__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_scroll_into_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_dom_scroll_into_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mini_store__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(191);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }








var MenuItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MenuItem, _React$Component);

  function MenuItem() {
    var _this;

    _classCallCheck(this, MenuItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MenuItem).apply(this, arguments));

    _this.onKeyDown = function (e) {
      var keyCode = e.keyCode;

      if (keyCode === __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].ENTER) {
        _this.onClick(e);

        return true;
      }

      return undefined;
    };

    _this.onMouseLeave = function (e) {
      var _this$props = _this.props,
          eventKey = _this$props.eventKey,
          onItemHover = _this$props.onItemHover,
          onMouseLeave = _this$props.onMouseLeave;
      onItemHover({
        key: eventKey,
        hover: false
      });
      onMouseLeave({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onMouseEnter = function (e) {
      var _this$props2 = _this.props,
          eventKey = _this$props2.eventKey,
          onItemHover = _this$props2.onItemHover,
          onMouseEnter = _this$props2.onMouseEnter;
      onItemHover({
        key: eventKey,
        hover: true
      });
      onMouseEnter({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onClick = function (e) {
      var _this$props3 = _this.props,
          eventKey = _this$props3.eventKey,
          multiple = _this$props3.multiple,
          onClick = _this$props3.onClick,
          onSelect = _this$props3.onSelect,
          onDeselect = _this$props3.onDeselect,
          isSelected = _this$props3.isSelected;
      var info = {
        key: eventKey,
        keyPath: [eventKey],
        item: _assertThisInitialized(_this),
        domEvent: e
      };
      onClick(info);

      if (multiple) {
        if (isSelected) {
          onDeselect(info);
        } else {
          onSelect(info);
        }
      } else if (!isSelected) {
        onSelect(info);
      }
    };

    _this.saveNode = function (node) {
      _this.node = node;
    };

    return _this;
  }

  _createClass(MenuItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // invoke customized ref to expose component to mixin
      this.callRef();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props4 = this.props,
          active = _this$props4.active,
          parentMenu = _this$props4.parentMenu,
          eventKey = _this$props4.eventKey; // 在 parentMenu 上层保存滚动状态，避免重复的 MenuItem key 导致滚动跳动
      // https://github.com/ant-design/ant-design/issues/16181

      if (!prevProps.active && active && (!parentMenu || !parentMenu["scrolled-".concat(eventKey)])) {
        if (this.node) {
          __WEBPACK_IMPORTED_MODULE_4_dom_scroll_into_view___default()(this.node, __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](parentMenu), {
            onlyScrollIfNeeded: true
          });
          parentMenu["scrolled-".concat(eventKey)] = true;
        }
      } else if (parentMenu && parentMenu["scrolled-".concat(eventKey)]) {
        delete parentMenu["scrolled-".concat(eventKey)];
      }

      this.callRef();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var props = this.props;

      if (props.onDestroy) {
        props.onDestroy(props.eventKey);
      }
    }
  }, {
    key: "getPrefixCls",
    value: function getPrefixCls() {
      return "".concat(this.props.rootPrefixCls, "-item");
    }
  }, {
    key: "getActiveClassName",
    value: function getActiveClassName() {
      return "".concat(this.getPrefixCls(), "-active");
    }
  }, {
    key: "getSelectedClassName",
    value: function getSelectedClassName() {
      return "".concat(this.getPrefixCls(), "-selected");
    }
  }, {
    key: "getDisabledClassName",
    value: function getDisabledClassName() {
      return "".concat(this.getPrefixCls(), "-disabled");
    }
  }, {
    key: "callRef",
    value: function callRef() {
      if (this.props.manualRef) {
        this.props.manualRef(this);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var props = _objectSpread({}, this.props);

      var className = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(this.getPrefixCls(), props.className, (_classNames = {}, _defineProperty(_classNames, this.getActiveClassName(), !props.disabled && props.active), _defineProperty(_classNames, this.getSelectedClassName(), props.isSelected), _defineProperty(_classNames, this.getDisabledClassName(), props.disabled), _classNames));

      var attrs = _objectSpread({}, props.attribute, {
        title: props.title,
        className: className,
        // set to menuitem by default
        role: props.role || 'menuitem',
        'aria-disabled': props.disabled
      });

      if (props.role === 'option') {
        // overwrite to option
        attrs = _objectSpread({}, attrs, {
          role: 'option',
          'aria-selected': props.isSelected
        });
      } else if (props.role === null || props.role === 'none') {
        // sometimes we want to specify role inside <li/> element
        // <li><a role='menuitem'>Link</a></li> would be a good example
        // in this case the role on <li/> should be "none" to
        // remove the implied listitem role.
        // https://www.w3.org/TR/wai-aria-practices-1.1/examples/menubar/menubar-1/menubar-1.html
        attrs.role = 'none';
      } // In case that onClick/onMouseLeave/onMouseEnter is passed down from owner


      var mouseEvent = {
        onClick: props.disabled ? null : this.onClick,
        onMouseLeave: props.disabled ? null : this.onMouseLeave,
        onMouseEnter: props.disabled ? null : this.onMouseEnter
      };

      var style = _objectSpread({}, props.style);

      if (props.mode === 'inline') {
        style.paddingLeft = props.inlineIndent * props.level;
      }

      __WEBPACK_IMPORTED_MODULE_6__util__["g" /* menuAllProps */].forEach(function (key) {
        return delete props[key];
      });
      var icon = this.props.itemIcon;

      if (typeof this.props.itemIcon === 'function') {
        // TODO: This is a bug which should fixed after TS refactor
        icon = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](this.props.itemIcon, this.props);
      }

      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", Object.assign({}, props, attrs, mouseEvent, {
        style: style,
        ref: this.saveNode
      }), props.children, icon);
    }
  }]);

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
MenuItem.isMenuItem = true;
MenuItem.defaultProps = {
  onSelect: __WEBPACK_IMPORTED_MODULE_6__util__["h" /* noop */],
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_6__util__["h" /* noop */],
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_6__util__["h" /* noop */],
  manualRef: __WEBPACK_IMPORTED_MODULE_6__util__["h" /* noop */]
};
var connected = Object(__WEBPACK_IMPORTED_MODULE_5_mini_store__["connect"])(function (_ref, _ref2) {
  var activeKey = _ref.activeKey,
      selectedKeys = _ref.selectedKeys;
  var eventKey = _ref2.eventKey,
      subMenuKey = _ref2.subMenuKey;
  return {
    active: activeKey[subMenuKey] === eventKey,
    isSelected: selectedKeys.indexOf(eventKey) !== -1
  };
})(MenuItem);
/* harmony default export */ __webpack_exports__["a"] = (connected);

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(911);

function scrollIntoView(elem, container, config) {
  config = config || {};
  // document 归一化到 window
  if (container.nodeType === 9) {
    container = util.getWindow(container);
  }

  var allowHorizontalScroll = config.allowHorizontalScroll;
  var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
  var alignWithTop = config.alignWithTop;
  var alignWithLeft = config.alignWithLeft;
  var offsetTop = config.offsetTop || 0;
  var offsetLeft = config.offsetLeft || 0;
  var offsetBottom = config.offsetBottom || 0;
  var offsetRight = config.offsetRight || 0;

  allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;

  var isWin = util.isWindow(container);
  var elemOffset = util.offset(elem);
  var eh = util.outerHeight(elem);
  var ew = util.outerWidth(elem);
  var containerOffset = undefined;
  var ch = undefined;
  var cw = undefined;
  var containerScroll = undefined;
  var diffTop = undefined;
  var diffBottom = undefined;
  var win = undefined;
  var winScroll = undefined;
  var ww = undefined;
  var wh = undefined;

  if (isWin) {
    win = container;
    wh = util.height(win);
    ww = util.width(win);
    winScroll = {
      left: util.scrollLeft(win),
      top: util.scrollTop(win)
    };
    // elem 相对 container 可视视窗的距离
    diffTop = {
      left: elemOffset.left - winScroll.left - offsetLeft,
      top: elemOffset.top - winScroll.top - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (winScroll.left + ww) + offsetRight,
      top: elemOffset.top + eh - (winScroll.top + wh) + offsetBottom
    };
    containerScroll = winScroll;
  } else {
    containerOffset = util.offset(container);
    ch = container.clientHeight;
    cw = container.clientWidth;
    containerScroll = {
      left: container.scrollLeft,
      top: container.scrollTop
    };
    // elem 相对 container 可视视窗的距离
    // 注意边框, offset 是边框到根节点
    diffTop = {
      left: elemOffset.left - (containerOffset.left + (parseFloat(util.css(container, 'borderLeftWidth')) || 0)) - offsetLeft,
      top: elemOffset.top - (containerOffset.top + (parseFloat(util.css(container, 'borderTopWidth')) || 0)) - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (containerOffset.left + cw + (parseFloat(util.css(container, 'borderRightWidth')) || 0)) + offsetRight,
      top: elemOffset.top + eh - (containerOffset.top + ch + (parseFloat(util.css(container, 'borderBottomWidth')) || 0)) + offsetBottom
    };
  }

  if (diffTop.top < 0 || diffBottom.top > 0) {
    // 强制向上
    if (alignWithTop === true) {
      util.scrollTop(container, containerScroll.top + diffTop.top);
    } else if (alignWithTop === false) {
      util.scrollTop(container, containerScroll.top + diffBottom.top);
    } else {
      // 自动调整
      if (diffTop.top < 0) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  } else {
    if (!onlyScrollIfNeeded) {
      alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
      if (alignWithTop) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  }

  if (allowHorizontalScroll) {
    if (diffTop.left < 0 || diffBottom.left > 0) {
      // 强制向上
      if (alignWithLeft === true) {
        util.scrollLeft(container, containerScroll.left + diffTop.left);
      } else if (alignWithLeft === false) {
        util.scrollLeft(container, containerScroll.left + diffBottom.left);
      } else {
        // 自动调整
        if (diffTop.left < 0) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    } else {
      if (!onlyScrollIfNeeded) {
        alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
        if (alignWithLeft) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    }
  }
}

module.exports = scrollIntoView;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

function getClientPosition(elem) {
  var box = undefined;
  var x = undefined;
  var y = undefined;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top;

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
function _getComputedStyle(elem, name, computedStyle_) {
  var val = '';
  var d = elem.ownerDocument;
  var computedStyle = computedStyle_ || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;

    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}

var getComputedStyleX = undefined;
if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name = undefined;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop = undefined;
  var j = undefined;
  var i = undefined;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = undefined;
        if (prop === 'border') {
          cssProp = prop + which[i] + 'Width';
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj != null && obj == obj.window;
}

var domUtils = {};

each(['Width', 'Height'], function (name) {
  domUtils['doc' + name] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement['scroll' + name],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body['scroll' + name], domUtils['viewport' + name](d));
  };

  domUtils['viewport' + name] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = 'client' + name;
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, extra) {
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem, computedStyle);
  var cssBoxValue = 0;
  if (borderBoxValue == null || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue == null || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
    }
    return cssBoxValue;
  }
  if (borderBoxValueOrIsBorderBox) {
    var padding = extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle);
    return val + (extra === BORDER_INDEX ? 0 : padding);
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay(elem) {
  var val = undefined;
  var args = arguments;
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

function css(el, name, v) {
  var value = v;
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value += 'px';
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils['outer' + first] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, val) {
    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

// 设置 elem 相对 elem.ownerDocument 的坐标
function setOffset(elem, offset) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var old = getOffset(elem);
  var ret = {};
  var current = undefined;
  var key = undefined;

  for (key in offset) {
    if (offset.hasOwnProperty(key)) {
      current = parseFloat(css(elem, key)) || 0;
      ret[key] = current + offset[key] - old[key];
    }
  }
  css(elem, ret);
}

module.exports = _extends({
  getWindow: function getWindow(node) {
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  offset: function offset(el, value) {
    if (typeof value !== 'undefined') {
      setOffset(el, value);
    } else {
      return getOffset(el);
    }
  },

  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var ret = {};
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },
  scrollLeft: function scrollLeft(w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollLeft(w);
      }
      window.scrollTo(v, getScrollTop(w));
    } else {
      if (v === undefined) {
        return w.scrollLeft;
      }
      w.scrollLeft = v;
    }
  },
  scrollTop: function scrollTop(w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollTop(w);
      }
      window.scrollTo(getScrollLeft(w), v);
    } else {
      if (v === undefined) {
        return w.scrollTop;
      }
      w.scrollTop = v;
    }
  },

  viewportWidth: 0,
  viewportHeight: 0
}, domUtils);

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(191);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }




var MenuItemGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MenuItemGroup, _React$Component);

  function MenuItemGroup() {
    var _this;

    _classCallCheck(this, MenuItemGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MenuItemGroup).apply(this, arguments));

    _this.renderInnerMenuItem = function (item) {
      var _this$props = _this.props,
          renderMenuItem = _this$props.renderMenuItem,
          index = _this$props.index;
      return renderMenuItem(item, index, _this.props.subMenuKey);
    };

    return _this;
  }

  _createClass(MenuItemGroup, [{
    key: "render",
    value: function render() {
      var props = _extends({}, this.props);

      var _props$className = props.className,
          className = _props$className === void 0 ? '' : _props$className,
          rootPrefixCls = props.rootPrefixCls;
      var titleClassName = "".concat(rootPrefixCls, "-item-group-title");
      var listClassName = "".concat(rootPrefixCls, "-item-group-list");
      var title = props.title,
          children = props.children;
      __WEBPACK_IMPORTED_MODULE_1__util__["g" /* menuAllProps */].forEach(function (key) {
        return delete props[key];
      }); // Set onClick to null, to ignore propagated onClick event

      delete props.onClick;
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", Object.assign({}, props, {
        className: "".concat(className, " ").concat(rootPrefixCls, "-item-group")
      }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
        className: titleClassName,
        title: typeof title === 'string' ? title : undefined
      }, title), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", {
        className: listClassName
      }, __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, this.renderInnerMenuItem)));
    }
  }]);

  return MenuItemGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MenuItemGroup.isMenuItemGroup = true;
MenuItemGroup.defaultProps = {
  disabled: true
};
/* harmony default export */ __webpack_exports__["a"] = (MenuItemGroup);

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var Divider = function Divider(_ref) {
  var className = _ref.className,
      rootPrefixCls = _ref.rootPrefixCls,
      style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", {
    className: "".concat(className, " ").concat(rootPrefixCls, "-item-divider"),
    style: style
  });
};

Divider.defaultProps = {
  // To fix keyboard UX.
  disabled: true,
  className: '',
  style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (Divider);

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(19));

var _rcMenu = __webpack_require__(190);

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _MenuContext = _interopRequireDefault(__webpack_require__(346));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SubMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(SubMenu, _React$Component);

  var _super = _createSuper(SubMenu);

  function SubMenu() {
    var _this;

    _classCallCheck(this, SubMenu);

    _this = _super.apply(this, arguments);

    _this.onKeyDown = function (e) {
      _this.subMenu.onKeyDown(e);
    };

    _this.saveSubMenu = function (subMenu) {
      _this.subMenu = subMenu;
    };

    return _this;
  }

  _createClass(SubMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          rootPrefixCls = _this$props.rootPrefixCls,
          popupClassName = _this$props.popupClassName;
      return /*#__PURE__*/React.createElement(_MenuContext["default"].Consumer, null, function (_ref) {
        var antdMenuTheme = _ref.antdMenuTheme;
        return /*#__PURE__*/React.createElement(_rcMenu.SubMenu, _extends({}, _this2.props, {
          ref: _this2.saveSubMenu,
          popupClassName: (0, _classnames["default"])("".concat(rootPrefixCls, "-").concat(antdMenuTheme), popupClassName)
        }));
      });
    }
  }]);

  return SubMenu;
}(React.Component);

SubMenu.contextTypes = {
  antdMenuTheme: PropTypes.string
}; // fix issue:https://github.com/ant-design/ant-design/issues/8666

SubMenu.isSubMenu = 1;
var _default = SubMenu;
exports["default"] = _default;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcMenu = __webpack_require__(190);

var _MenuContext = _interopRequireDefault(__webpack_require__(346));

var _tooltip = _interopRequireDefault(__webpack_require__(87));

var _Sider = __webpack_require__(492);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var MenuItem = /*#__PURE__*/function (_React$Component) {
  _inherits(MenuItem, _React$Component);

  var _super = _createSuper(MenuItem);

  function MenuItem() {
    var _this;

    _classCallCheck(this, MenuItem);

    _this = _super.apply(this, arguments);

    _this.onKeyDown = function (e) {
      _this.menuItem.onKeyDown(e);
    };

    _this.saveMenuItem = function (menuItem) {
      _this.menuItem = menuItem;
    };

    _this.renderItem = function (_ref) {
      var siderCollapsed = _ref.siderCollapsed;
      var _this$props = _this.props,
          level = _this$props.level,
          children = _this$props.children,
          rootPrefixCls = _this$props.rootPrefixCls;

      var _a = _this.props,
          title = _a.title,
          rest = __rest(_a, ["title"]);

      return /*#__PURE__*/React.createElement(_MenuContext["default"].Consumer, null, function (_ref2) {
        var inlineCollapsed = _ref2.inlineCollapsed;
        var tooltipProps = {
          title: title || (level === 1 ? children : '')
        };

        if (!siderCollapsed && !inlineCollapsed) {
          tooltipProps.title = null; // Reset `visible` to fix control mode tooltip display not correct
          // ref: https://github.com/ant-design/ant-design/issues/16742

          tooltipProps.visible = false;
        }

        return /*#__PURE__*/React.createElement(_tooltip["default"], _extends({}, tooltipProps, {
          placement: "right",
          overlayClassName: "".concat(rootPrefixCls, "-inline-collapsed-tooltip")
        }), /*#__PURE__*/React.createElement(_rcMenu.Item, _extends({}, rest, {
          title: title,
          ref: _this.saveMenuItem
        })));
      });
    };

    return _this;
  }

  _createClass(MenuItem, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_Sider.SiderContext.Consumer, null, this.renderItem);
    }
  }]);

  return MenuItem;
}(React.Component);

exports["default"] = MenuItem;
MenuItem.isMenuItem = true;

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(917);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Tooltip__["a" /* default */]);

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_trigger__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__placements__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Content__ = __webpack_require__(919);











var Tooltip = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tooltip, _Component);

  function Tooltip() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
      var _this$props = _this.props,
          arrowContent = _this$props.arrowContent,
          overlay = _this$props.overlay,
          prefixCls = _this$props.prefixCls,
          id = _this$props.id;

      return [__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-arrow', key: 'arrow' },
        arrowContent
      ), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Content__["a" /* default */], {
        key: 'content',
        trigger: _this.trigger,
        prefixCls: prefixCls,
        id: id,
        overlay: overlay
      })];
    }, _this.saveTrigger = function (node) {
      _this.trigger = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
    return this.trigger.getPopupDomNode();
  };

  Tooltip.prototype.render = function render() {
    var _props = this.props,
        overlayClassName = _props.overlayClassName,
        trigger = _props.trigger,
        mouseEnterDelay = _props.mouseEnterDelay,
        mouseLeaveDelay = _props.mouseLeaveDelay,
        overlayStyle = _props.overlayStyle,
        prefixCls = _props.prefixCls,
        children = _props.children,
        onVisibleChange = _props.onVisibleChange,
        afterVisibleChange = _props.afterVisibleChange,
        transitionName = _props.transitionName,
        animation = _props.animation,
        placement = _props.placement,
        align = _props.align,
        destroyTooltipOnHide = _props.destroyTooltipOnHide,
        defaultVisible = _props.defaultVisible,
        getTooltipContainer = _props.getTooltipContainer,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);

    var extraProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restProps);
    if ('visible' in this.props) {
      extraProps.popupVisible = this.props.visible;
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_rc_trigger__["default"],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        popupClassName: overlayClassName,
        ref: this.saveTrigger,
        prefixCls: prefixCls,
        popup: this.getPopupElement,
        action: trigger,
        builtinPlacements: __WEBPACK_IMPORTED_MODULE_8__placements__["a" /* placements */],
        popupPlacement: placement,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
      }, extraProps),
      children
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Tooltip.propTypes = {
  trigger: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  defaultVisible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  placement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  onVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  afterVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  overlay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]).isRequired,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  overlayClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  getTooltipContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  destroyTooltipOnHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  align: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  arrowContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
Tooltip.defaultProps = {
  prefixCls: 'rc-tooltip',
  mouseEnterDelay: 0,
  destroyTooltipOnHide: false,
  mouseLeaveDelay: 0.1,
  align: {},
  placement: 'right',
  trigger: ['hover'],
  arrowContent: null
};


/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placements; });
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (placements);

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var Content = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Content, _React$Component);

  function Content() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Content);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Content.prototype.componentDidUpdate = function componentDidUpdate() {
    var trigger = this.props.trigger;

    if (trigger) {
      trigger.forcePopupAlign();
    }
  };

  Content.prototype.render = function render() {
    var _props = this.props,
        overlay = _props.overlay,
        prefixCls = _props.prefixCls,
        id = _props.id;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls + '-inner', id: id, role: 'tooltip' },
      typeof overlay === 'function' ? overlay() : overlay
    );
  };

  return Content;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Content.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  overlay: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]).isRequired,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  trigger: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOverflowOptions = getOverflowOptions;
exports["default"] = getPlacements;

var _placements = __webpack_require__(921);

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var autoAdjustOverflowEnabled = {
  adjustX: 1,
  adjustY: 1
};
var autoAdjustOverflowDisabled = {
  adjustX: 0,
  adjustY: 0
};
var targetOffset = [0, 0];

function getOverflowOptions(autoAdjustOverflow) {
  if (typeof autoAdjustOverflow === 'boolean') {
    return autoAdjustOverflow ? autoAdjustOverflowEnabled : autoAdjustOverflowDisabled;
  }

  return _extends(_extends({}, autoAdjustOverflowDisabled), autoAdjustOverflow);
}

function getPlacements() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$arrowWidth = config.arrowWidth,
      arrowWidth = _config$arrowWidth === void 0 ? 5 : _config$arrowWidth,
      _config$horizontalArr = config.horizontalArrowShift,
      horizontalArrowShift = _config$horizontalArr === void 0 ? 16 : _config$horizontalArr,
      _config$verticalArrow = config.verticalArrowShift,
      verticalArrowShift = _config$verticalArrow === void 0 ? 12 : _config$verticalArrow,
      _config$autoAdjustOve = config.autoAdjustOverflow,
      autoAdjustOverflow = _config$autoAdjustOve === void 0 ? true : _config$autoAdjustOve;
  var placementMap = {
    left: {
      points: ['cr', 'cl'],
      offset: [-4, 0]
    },
    right: {
      points: ['cl', 'cr'],
      offset: [4, 0]
    },
    top: {
      points: ['bc', 'tc'],
      offset: [0, -4]
    },
    bottom: {
      points: ['tc', 'bc'],
      offset: [0, 4]
    },
    topLeft: {
      points: ['bl', 'tc'],
      offset: [-(horizontalArrowShift + arrowWidth), -4]
    },
    leftTop: {
      points: ['tr', 'cl'],
      offset: [-4, -(verticalArrowShift + arrowWidth)]
    },
    topRight: {
      points: ['br', 'tc'],
      offset: [horizontalArrowShift + arrowWidth, -4]
    },
    rightTop: {
      points: ['tl', 'cr'],
      offset: [4, -(verticalArrowShift + arrowWidth)]
    },
    bottomRight: {
      points: ['tr', 'bc'],
      offset: [horizontalArrowShift + arrowWidth, 4]
    },
    rightBottom: {
      points: ['bl', 'cr'],
      offset: [4, verticalArrowShift + arrowWidth]
    },
    bottomLeft: {
      points: ['tl', 'bc'],
      offset: [-(horizontalArrowShift + arrowWidth), 4]
    },
    leftBottom: {
      points: ['br', 'cl'],
      offset: [-4, verticalArrowShift + arrowWidth]
    }
  };
  Object.keys(placementMap).forEach(function (key) {
    placementMap[key] = config.arrowPointAtCenter ? _extends(_extends({}, placementMap[key]), {
      overflow: getOverflowOptions(autoAdjustOverflow),
      targetOffset: targetOffset
    }) : _extends(_extends({}, _placements.placements[key]), {
      overflow: getOverflowOptions(autoAdjustOverflow)
    });
    placementMap[key].ignoreShake = true;
  });
  return placementMap;
}

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = exports.placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

exports['default'] = placements;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LayoutContext = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _createReactContext = _interopRequireDefault(__webpack_require__(156));

var _configProvider = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var LayoutContext = (0, _createReactContext["default"])({
  siderHook: {
    addSider: function addSider() {
      return null;
    },
    removeSider: function removeSider() {
      return null;
    }
  }
});
exports.LayoutContext = LayoutContext;

function generator(_ref) {
  var suffixCls = _ref.suffixCls,
      tagName = _ref.tagName,
      displayName = _ref.displayName;
  return function (BasicComponent) {
    var _a;

    return _a = /*#__PURE__*/function (_React$Component) {
      _inherits(Adapter, _React$Component);

      var _super = _createSuper(Adapter);

      function Adapter() {
        var _this;

        _classCallCheck(this, Adapter);

        _this = _super.apply(this, arguments);

        _this.renderComponent = function (_ref2) {
          var getPrefixCls = _ref2.getPrefixCls;
          var customizePrefixCls = _this.props.prefixCls;
          var prefixCls = getPrefixCls(suffixCls, customizePrefixCls);
          return /*#__PURE__*/React.createElement(BasicComponent, _extends({
            prefixCls: prefixCls,
            tagName: tagName
          }, _this.props));
        };

        return _this;
      }

      _createClass(Adapter, [{
        key: "render",
        value: function render() {
          return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent);
        }
      }]);

      return Adapter;
    }(React.Component), _a.displayName = displayName, _a;
  };
}

var Basic = function Basic(props) {
  var prefixCls = props.prefixCls,
      className = props.className,
      children = props.children,
      tagName = props.tagName,
      others = __rest(props, ["prefixCls", "className", "children", "tagName"]);

  var classString = (0, _classnames["default"])(className, prefixCls);
  return /*#__PURE__*/React.createElement(tagName, _extends({
    className: classString
  }, others), children);
};

var BasicLayout = /*#__PURE__*/function (_React$Component2) {
  _inherits(BasicLayout, _React$Component2);

  var _super2 = _createSuper(BasicLayout);

  function BasicLayout() {
    var _this2;

    _classCallCheck(this, BasicLayout);

    _this2 = _super2.apply(this, arguments);
    _this2.state = {
      siders: []
    };
    return _this2;
  }

  _createClass(BasicLayout, [{
    key: "getSiderHook",
    value: function getSiderHook() {
      var _this3 = this;

      return {
        addSider: function addSider(id) {
          _this3.setState(function (state) {
            return {
              siders: [].concat(_toConsumableArray(state.siders), [id])
            };
          });
        },
        removeSider: function removeSider(id) {
          _this3.setState(function (state) {
            return {
              siders: state.siders.filter(function (currentId) {
                return currentId !== id;
              })
            };
          });
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          prefixCls = _a.prefixCls,
          className = _a.className,
          children = _a.children,
          hasSider = _a.hasSider,
          Tag = _a.tagName,
          others = __rest(_a, ["prefixCls", "className", "children", "hasSider", "tagName"]);

      var classString = (0, _classnames["default"])(className, prefixCls, _defineProperty({}, "".concat(prefixCls, "-has-sider"), typeof hasSider === 'boolean' ? hasSider : this.state.siders.length > 0));
      return /*#__PURE__*/React.createElement(LayoutContext.Provider, {
        value: {
          siderHook: this.getSiderHook()
        }
      }, /*#__PURE__*/React.createElement(Tag, _extends({
        className: classString
      }, others), children));
    }
  }]);

  return BasicLayout;
}(React.Component);

var Layout = generator({
  suffixCls: 'layout',
  tagName: 'section',
  displayName: 'Layout'
})(BasicLayout);
var Header = generator({
  suffixCls: 'layout-header',
  tagName: 'header',
  displayName: 'Header'
})(Basic);
var Footer = generator({
  suffixCls: 'layout-footer',
  tagName: 'footer',
  displayName: 'Footer'
})(Basic);
var Content = generator({
  suffixCls: 'layout-content',
  tagName: 'main',
  displayName: 'Content'
})(Basic);
Layout.Header = Header;
Layout.Footer = Footer;
Layout.Content = Content;
var _default = Layout;
exports["default"] = _default;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isNumeric = function isNumeric(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
};

var _default = isNumeric;
exports["default"] = _default;

/***/ }),
/* 924 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 925 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _alert=__webpack_require__(83);var _alert2=_interopRequireDefault(_alert);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(62);__webpack_require__(4);__webpack_require__(84);__webpack_require__(6);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _mobxReact=__webpack_require__(18);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var ExportPdf=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(ExportPdf,_Component);function ExportPdf(props){_classCallCheck(this,ExportPdf);var _this=_possibleConstructorReturn(this,(ExportPdf.__proto__||Object.getPrototypeOf(ExportPdf)).call(this,props));_this.onExportPdf=function(){_this.setState({visible:true});};_this.handleOk=function(){_this.setState({loading:true});var date=_this.state.date;fetch("/mkPdf?year="+(0,_moment2.default)(date).format('YYYY')+"&month="+(0,_moment2.default)(date).format('MM'),{credentials:'include'}).then(function(x){return x.blob();}).then(function(x){var file=new Blob([x],{type:"application/pdf"});_fileSaver2.default.saveAs(file,(_this.state.hotel.name||"")+"("+(0,_moment2.default)(date).format('YYYY-MM')+").pdf");_this.setState({loading:false});_message3.default.info('导出成功！');}).catch(function(err){_this.setState({loading:false});_message3.default.info('导出失败！');console.error(err);});};_this.handleCancel=function(){_this.setState({visible:false});};_this.state={visible:false,date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),loading:false,hotel:{}};return _this;}_createClass(ExportPdf,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;this.props.store.menu.getHotelInfo().then(function(hotel){_this2.setState({hotel:hotel});}).catch(function(err){console.error(err);});}},{key:"render",value:function render(){var _this3=this;return _react2.default.createElement("div",{style:{color:"#1890ff",cursor:"pointer",padding:"10px 20px",textAlign:"center"}},_react2.default.createElement(_button2.default,{onClick:this.onExportPdf,type:"primary",style:{width:'100%'}},"\u4E00\u952E\u5BFC\u51FA"),_react2.default.createElement(_modal2.default,{title:"\u5BFC\u51FAPDF",visible:this.state.visible,onOk:this.handleOk,onCancel:this.handleCancel,footer:[_react2.default.createElement(_button2.default,{key:"back",onClick:this.handleCancel},"\u53D6\u6D88"),_react2.default.createElement(_button2.default,{key:"submit",type:"primary",loading:this.state.loading,onClick:this.handleOk},this.state.loading?'导出中，请稍候......':"导出")]},_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement("span",{style:{marginRight:20}},"\u8BF7\u9009\u62E9\u65F6\u95F4\uFF1A"),_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,'YYYY-MM'),format:"YYYY-MM",onChange:function onChange(date,str){_this3.setState({date:str});}}),_react2.default.createElement(_alert2.default,{style:{marginTop:20},message:"\u8B66\u544A",description:"\u7531\u4E8E\u5BFC\u51FA\u5185\u5BB9\u8FC7\u591A\uFF0C\u4F1A\u5BFC\u81F4\u9875\u9762\u5361\u987F\uFF0C\u5BFC\u51FA\u6210\u529F\u4F1A\u81EA\u52A8\u751F\u6210pdf\u6587\u4EF6\uFF0C\u5728\u751F\u6210\u6587\u4EF6\u4E4B\u524D\uFF0C\u8BF7\u52FF\u5173\u95ED\u6D4F\u89C8\u5668\u548C\u5F53\u524D\u9875\u9762\u6807\u7B7E\u3002\u3002\u3002",type:"error"}))));}}]);return ExportPdf;}(_react.Component))||_class)||_class);exports.default=ExportPdf;

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__date_DateTable__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__calendar_CalendarHeader__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__calendar_CalendarFooter__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixin_CalendarMixin__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixin_CommonMixin__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__date_DateInput__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_toTime__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_moment__);



















function noop() {}

var getMomentObjectIfValid = function getMomentObjectIfValid(date) {
  if (__WEBPACK_IMPORTED_MODULE_17_moment___default.a.isMoment(date) && date.isValid()) {
    return date;
  }
  return false;
};

var Calendar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Calendar, _React$Component);

  function Calendar(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Calendar);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      mode: _this.props.mode || 'date',
      value: getMomentObjectIfValid(props.value) || getMomentObjectIfValid(props.defaultValue) || __WEBPACK_IMPORTED_MODULE_17_moment___default()(),
      selectedValue: props.selectedValue || props.defaultSelectedValue
    };
    return _this;
  }

  Calendar.prototype.componentDidMount = function componentDidMount() {
    if (this.props.showDateInput) {
      this.saveFocusElement(__WEBPACK_IMPORTED_MODULE_14__date_DateInput__["a" /* default */].getInstance());
    }
  };

  Calendar.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, state) {
    var value = nextProps.value,
        selectedValue = nextProps.selectedValue;

    var newState = {};

    if ('mode' in nextProps && state.mode !== nextProps.mode) {
      newState = { mode: nextProps.mode };
    }
    if ('value' in nextProps) {
      newState.value = getMomentObjectIfValid(value) || getMomentObjectIfValid(nextProps.defaultValue) || Object(__WEBPACK_IMPORTED_MODULE_12__mixin_CalendarMixin__["d" /* getNowByCurrentStateValue */])(state.value);
    }
    if ('selectedValue' in nextProps) {
      newState.selectedValue = selectedValue;
    }

    return newState;
  };

  Calendar.prototype.render = function render() {
    var props = this.props,
        state = this.state;
    var locale = props.locale,
        prefixCls = props.prefixCls,
        disabledDate = props.disabledDate,
        dateInputPlaceholder = props.dateInputPlaceholder,
        timePicker = props.timePicker,
        disabledTime = props.disabledTime,
        clearIcon = props.clearIcon,
        renderFooter = props.renderFooter,
        inputMode = props.inputMode,
        monthCellRender = props.monthCellRender,
        monthCellContentRender = props.monthCellContentRender;
    var value = state.value,
        selectedValue = state.selectedValue,
        mode = state.mode;

    var showTimePicker = mode === 'time';
    var disabledTimeConfig = showTimePicker && disabledTime && timePicker ? Object(__WEBPACK_IMPORTED_MODULE_15__util__["c" /* getTimeConfig */])(selectedValue, disabledTime) : null;

    var timePickerEle = null;

    if (timePicker && showTimePicker) {
      var timePickerProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        showHour: true,
        showSecond: true,
        showMinute: true
      }, timePicker.props, disabledTimeConfig, {
        onChange: this.onDateInputChange,
        value: selectedValue,
        disabledTime: disabledTime
      });

      if (timePicker.props.defaultValue !== undefined) {
        timePickerProps.defaultOpenValue = timePicker.props.defaultValue;
      }

      timePickerEle = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(timePicker, timePickerProps);
    }

    var dateInputElement = props.showDateInput ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__date_DateInput__["a" /* default */], {
      format: this.getFormat(),
      key: 'date-input',
      value: value,
      locale: locale,
      placeholder: dateInputPlaceholder,
      showClear: true,
      disabledTime: disabledTime,
      disabledDate: disabledDate,
      onClear: this.onClear,
      prefixCls: prefixCls,
      selectedValue: selectedValue,
      onChange: this.onDateInputChange,
      onSelect: this.onDateInputSelect,
      clearIcon: clearIcon,
      inputMode: inputMode
    }) : null;

    var children = [];
    if (props.renderSidebar) {
      children.push(props.renderSidebar());
    }
    children.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      { className: prefixCls + '-panel', key: 'panel' },
      dateInputElement,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'div',
        {
          tabIndex: this.props.focusablePanel ? 0 : undefined,
          className: prefixCls + '-date-panel'
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__calendar_CalendarHeader__["a" /* default */], {
          locale: locale,
          mode: mode,
          value: value,
          onValueChange: this.setValue,
          onPanelChange: this.onPanelChange,
          renderFooter: renderFooter,
          showTimePicker: showTimePicker,
          prefixCls: prefixCls,
          monthCellRender: monthCellRender,
          monthCellContentRender: monthCellContentRender
        }),
        timePicker && showTimePicker ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'div',
          { className: prefixCls + '-time-picker' },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'div',
            { className: prefixCls + '-time-picker-panel' },
            timePickerEle
          )
        ) : null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'div',
          { className: prefixCls + '-body' },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__date_DateTable__["a" /* default */], {
            locale: locale,
            value: value,
            selectedValue: selectedValue,
            prefixCls: prefixCls,
            dateRender: props.dateRender,
            onSelect: this.onDateTableSelect,
            disabledDate: disabledDate,
            showWeekNumber: props.showWeekNumber
          })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__calendar_CalendarFooter__["a" /* default */], {
          showOk: props.showOk,
          mode: mode,
          renderFooter: props.renderFooter,
          locale: locale,
          prefixCls: prefixCls,
          showToday: props.showToday,
          disabledTime: disabledTime,
          showTimePicker: showTimePicker,
          showDateInput: props.showDateInput,
          timePicker: timePicker,
          selectedValue: selectedValue,
          timePickerDisabled: !selectedValue,
          value: value,
          disabledDate: disabledDate,
          okDisabled: props.showOk !== false && (!selectedValue || !this.isAllowedDate(selectedValue)),
          onOk: this.onOk,
          onSelect: this.onSelect,
          onToday: this.onToday,
          onOpenTimePicker: this.openTimePicker,
          onCloseTimePicker: this.closeTimePicker
        })
      )
    ));

    return this.renderRoot({
      children: children,
      className: props.showWeekNumber ? prefixCls + '-week-number' : ''
    });
  };

  return Calendar;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Calendar.propTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_12__mixin_CalendarMixin__["b" /* calendarMixinPropTypes */], __WEBPACK_IMPORTED_MODULE_13__mixin_CommonMixin__["c" /* propType */], {
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  defaultValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  selectedValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  defaultSelectedValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  mode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['time', 'date', 'month', 'year', 'decade']),
  locale: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  showDateInput: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  showWeekNumber: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  showToday: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  showOk: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onOk: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  timePicker: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.element,
  dateInputPlaceholder: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  onClear: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onPanelChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  disabledDate: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  disabledTime: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  dateRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  renderFooter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  renderSidebar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  clearIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  focusablePanel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  inputMode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onBlur: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
});
Calendar.defaultProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_12__mixin_CalendarMixin__["a" /* calendarMixinDefaultProps */], __WEBPACK_IMPORTED_MODULE_13__mixin_CommonMixin__["b" /* defaultProp */], {
  showToday: true,
  showDateInput: true,
  timePicker: null,
  onOk: noop,
  onPanelChange: noop,
  focusablePanel: true
});

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onPanelChange = function (value, mode) {
    var props = _this2.props,
        state = _this2.state;

    if (!('mode' in props)) {
      _this2.setState({ mode: mode });
    }
    props.onPanelChange(value || state.value, mode);
  };

  this.onKeyDown = function (event) {
    if (event.target.nodeName.toLowerCase() === 'input') {
      return undefined;
    }
    var keyCode = event.keyCode;
    // mac
    var ctrlKey = event.ctrlKey || event.metaKey;
    var disabledDate = _this2.props.disabledDate;
    var value = _this2.state.value;

    switch (keyCode) {
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].DOWN:
        _this2.goTime(1, 'weeks');
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].UP:
        _this2.goTime(-1, 'weeks');
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].LEFT:
        if (ctrlKey) {
          _this2.goTime(-1, 'years');
        } else {
          _this2.goTime(-1, 'days');
        }
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].RIGHT:
        if (ctrlKey) {
          _this2.goTime(1, 'years');
        } else {
          _this2.goTime(1, 'days');
        }
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].HOME:
        _this2.setValue(Object(__WEBPACK_IMPORTED_MODULE_16__util_toTime__["b" /* goStartMonth */])(_this2.state.value));
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].END:
        _this2.setValue(Object(__WEBPACK_IMPORTED_MODULE_16__util_toTime__["a" /* goEndMonth */])(_this2.state.value));
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].PAGE_DOWN:
        _this2.goTime(1, 'month');
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].PAGE_UP:
        _this2.goTime(-1, 'month');
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].ENTER:
        if (!disabledDate || !disabledDate(value)) {
          _this2.onSelect(value, {
            source: 'keyboard'
          });
        }
        event.preventDefault();
        return 1;
      default:
        _this2.props.onKeyDown(event);
        return 1;
    }
  };

  this.onClear = function () {
    _this2.onSelect(null);
    _this2.props.onClear();
  };

  this.onOk = function () {
    var selectedValue = _this2.state.selectedValue;

    if (_this2.isAllowedDate(selectedValue)) {
      _this2.props.onOk(selectedValue);
    }
  };

  this.onDateInputChange = function (value) {
    _this2.onSelect(value, {
      source: 'dateInput'
    });
  };

  this.onDateInputSelect = function (value) {
    _this2.onSelect(value, {
      source: 'dateInputSelect'
    });
  };

  this.onDateTableSelect = function (value) {
    var timePicker = _this2.props.timePicker;
    var selectedValue = _this2.state.selectedValue;

    if (!selectedValue && timePicker) {
      var timePickerDefaultValue = timePicker.props.defaultValue;
      if (timePickerDefaultValue) {
        Object(__WEBPACK_IMPORTED_MODULE_15__util__["h" /* syncTime */])(timePickerDefaultValue, value);
      }
    }
    _this2.onSelect(value);
  };

  this.onToday = function () {
    var value = _this2.state.value;

    var now = Object(__WEBPACK_IMPORTED_MODULE_15__util__["e" /* getTodayTime */])(value);
    _this2.onSelect(now, {
      source: 'todayButton'
    });
  };

  this.onBlur = function (event) {
    setTimeout(function () {
      var dateInput = __WEBPACK_IMPORTED_MODULE_14__date_DateInput__["a" /* default */].getInstance();
      var rootInstance = _this2.rootInstance;

      if (!rootInstance || rootInstance.contains(document.activeElement) || dateInput && dateInput.contains(document.activeElement)) {
        // focused element is still part of Calendar
        return;
      }

      if (_this2.props.onBlur) {
        _this2.props.onBlur(event);
      }
    }, 0);
  };

  this.getRootDOMNode = function () {
    return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(_this2);
  };

  this.openTimePicker = function () {
    _this2.onPanelChange(null, 'time');
  };

  this.closeTimePicker = function () {
    _this2.onPanelChange(null, 'date');
  };

  this.goTime = function (direction, unit) {
    _this2.setValue(Object(__WEBPACK_IMPORTED_MODULE_16__util_toTime__["c" /* goTime */])(_this2.state.value, direction, unit));
  };
};

Object(__WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__["polyfill"])(Calendar);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__mixin_CalendarMixin__["c" /* calendarMixinWrapper */])(Object(__WEBPACK_IMPORTED_MODULE_13__mixin_CommonMixin__["a" /* commonMixinWrapper */])(Calendar)));

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DateTHead__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DateTBody__ = __webpack_require__(930);








var DateTable = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DateTable, _React$Component);

  function DateTable() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DateTable);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DateTable.prototype.render = function render() {
    var props = this.props;
    var prefixCls = props.prefixCls;
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'table',
      { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DateTHead__["a" /* default */], props),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DateTBody__["a" /* default */], props)
    );
  };

  return DateTable;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (DateTable);

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DateConstants__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);







var DateTHead = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DateTHead, _React$Component);

  function DateTHead() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DateTHead);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DateTHead.prototype.render = function render() {
    var props = this.props;
    var value = props.value;
    var localeData = value.localeData();
    var prefixCls = props.prefixCls;
    var veryShortWeekdays = [];
    var weekDays = [];
    var firstDayOfWeek = localeData.firstDayOfWeek();
    var showWeekNumberEl = void 0;
    var now = __WEBPACK_IMPORTED_MODULE_5_moment___default()();
    for (var dateColIndex = 0; dateColIndex < __WEBPACK_IMPORTED_MODULE_4__DateConstants__["a" /* default */].DATE_COL_COUNT; dateColIndex++) {
      var index = (firstDayOfWeek + dateColIndex) % __WEBPACK_IMPORTED_MODULE_4__DateConstants__["a" /* default */].DATE_COL_COUNT;
      now.day(index);
      veryShortWeekdays[dateColIndex] = localeData.weekdaysMin(now);
      weekDays[dateColIndex] = localeData.weekdaysShort(now);
    }

    if (props.showWeekNumber) {
      showWeekNumberEl = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'th',
        {
          role: 'columnheader',
          className: prefixCls + '-column-header ' + prefixCls + '-week-number-header'
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'span',
          { className: prefixCls + '-column-header-inner' },
          'x'
        )
      );
    }
    var weekDaysEls = weekDays.map(function (day, xindex) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'th',
        {
          key: xindex,
          role: 'columnheader',
          title: day,
          className: prefixCls + '-column-header'
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'span',
          { className: prefixCls + '-column-header-inner' },
          veryShortWeekdays[xindex]
        )
      );
    });
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'thead',
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tr',
        { role: 'row' },
        showWeekNumberEl,
        weekDaysEls
      )
    );
  };

  return DateTHead;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (DateTHead);

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DateConstants__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util___ = __webpack_require__(193);









function isSameDay(one, two) {
  return one && two && one.isSame(two, 'day');
}

function beforeCurrentMonthYear(current, today) {
  if (current.year() < today.year()) {
    return 1;
  }
  return current.year() === today.year() && current.month() < today.month();
}

function afterCurrentMonthYear(current, today) {
  if (current.year() > today.year()) {
    return 1;
  }
  return current.year() === today.year() && current.month() > today.month();
}

function getIdFromDate(date) {
  return 'rc-calendar-' + date.year() + '-' + date.month() + '-' + date.date();
}

var DateTBody = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DateTBody, _React$Component);

  function DateTBody() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DateTBody);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DateTBody.prototype.render = function render() {
    var props = this.props;
    var contentRender = props.contentRender,
        prefixCls = props.prefixCls,
        selectedValue = props.selectedValue,
        value = props.value,
        showWeekNumber = props.showWeekNumber,
        dateRender = props.dateRender,
        disabledDate = props.disabledDate,
        hoverValue = props.hoverValue;

    var iIndex = void 0;
    var jIndex = void 0;
    var current = void 0;
    var dateTable = [];
    var today = Object(__WEBPACK_IMPORTED_MODULE_7__util___["e" /* getTodayTime */])(value);
    var cellClass = prefixCls + '-cell';
    var weekNumberCellClass = prefixCls + '-week-number-cell';
    var dateClass = prefixCls + '-date';
    var todayClass = prefixCls + '-today';
    var selectedClass = prefixCls + '-selected-day';
    var selectedDateClass = prefixCls + '-selected-date'; // do not move with mouse operation
    var selectedStartDateClass = prefixCls + '-selected-start-date';
    var selectedEndDateClass = prefixCls + '-selected-end-date';
    var inRangeClass = prefixCls + '-in-range-cell';
    var lastMonthDayClass = prefixCls + '-last-month-cell';
    var nextMonthDayClass = prefixCls + '-next-month-btn-day';
    var disabledClass = prefixCls + '-disabled-cell';
    var firstDisableClass = prefixCls + '-disabled-cell-first-of-row';
    var lastDisableClass = prefixCls + '-disabled-cell-last-of-row';
    var lastDayOfMonthClass = prefixCls + '-last-day-of-month';
    var month1 = value.clone();
    month1.date(1);
    var day = month1.day();
    var lastMonthDiffDay = (day + 7 - value.localeData().firstDayOfWeek()) % 7;
    // calculate last month
    var lastMonth1 = month1.clone();
    lastMonth1.add(0 - lastMonthDiffDay, 'days');
    var passed = 0;

    for (iIndex = 0; iIndex < __WEBPACK_IMPORTED_MODULE_6__DateConstants__["a" /* default */].DATE_ROW_COUNT; iIndex++) {
      for (jIndex = 0; jIndex < __WEBPACK_IMPORTED_MODULE_6__DateConstants__["a" /* default */].DATE_COL_COUNT; jIndex++) {
        current = lastMonth1;
        if (passed) {
          current = current.clone();
          current.add(passed, 'days');
        }
        dateTable.push(current);
        passed++;
      }
    }
    var tableHtml = [];
    passed = 0;

    for (iIndex = 0; iIndex < __WEBPACK_IMPORTED_MODULE_6__DateConstants__["a" /* default */].DATE_ROW_COUNT; iIndex++) {
      var _cx;

      var isCurrentWeek = void 0;
      var weekNumberCell = void 0;
      var isActiveWeek = false;
      var dateCells = [];
      if (showWeekNumber) {
        weekNumberCell = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'td',
          {
            key: dateTable[passed].week(),
            role: 'gridcell',
            className: weekNumberCellClass
          },
          dateTable[passed].week()
        );
      }
      for (jIndex = 0; jIndex < __WEBPACK_IMPORTED_MODULE_6__DateConstants__["a" /* default */].DATE_COL_COUNT; jIndex++) {
        var next = null;
        var last = null;
        current = dateTable[passed];
        if (jIndex < __WEBPACK_IMPORTED_MODULE_6__DateConstants__["a" /* default */].DATE_COL_COUNT - 1) {
          next = dateTable[passed + 1];
        }
        if (jIndex > 0) {
          last = dateTable[passed - 1];
        }
        var cls = cellClass;
        var disabled = false;
        var selected = false;

        if (isSameDay(current, today)) {
          cls += ' ' + todayClass;
          isCurrentWeek = true;
        }

        var isBeforeCurrentMonthYear = beforeCurrentMonthYear(current, value);
        var isAfterCurrentMonthYear = afterCurrentMonthYear(current, value);

        if (selectedValue && Array.isArray(selectedValue)) {
          var rangeValue = hoverValue.length ? hoverValue : selectedValue;
          if (!isBeforeCurrentMonthYear && !isAfterCurrentMonthYear) {
            var startValue = rangeValue[0];
            var endValue = rangeValue[1];
            if (startValue) {
              if (isSameDay(current, startValue)) {
                selected = true;
                isActiveWeek = true;
                cls += ' ' + selectedStartDateClass;
              }
            }
            if (startValue || endValue) {
              if (isSameDay(current, endValue)) {
                selected = true;
                isActiveWeek = true;
                cls += ' ' + selectedEndDateClass;
              } else if ((startValue === null || startValue === undefined) && current.isBefore(endValue, 'day')) {
                cls += ' ' + inRangeClass;
              } else if ((endValue === null || endValue === undefined) && current.isAfter(startValue, 'day')) {
                cls += ' ' + inRangeClass;
              } else if (current.isAfter(startValue, 'day') && current.isBefore(endValue, 'day')) {
                cls += ' ' + inRangeClass;
              }
            }
          }
        } else if (isSameDay(current, value)) {
          // keyboard change value, highlight works
          selected = true;
          isActiveWeek = true;
        }

        if (isSameDay(current, selectedValue)) {
          cls += ' ' + selectedDateClass;
        }

        if (isBeforeCurrentMonthYear) {
          cls += ' ' + lastMonthDayClass;
        }

        if (isAfterCurrentMonthYear) {
          cls += ' ' + nextMonthDayClass;
        }

        if (current.clone().endOf('month').date() === current.date()) {
          cls += ' ' + lastDayOfMonthClass;
        }

        if (disabledDate) {
          if (disabledDate(current, value)) {
            disabled = true;

            if (!last || !disabledDate(last, value)) {
              cls += ' ' + firstDisableClass;
            }

            if (!next || !disabledDate(next, value)) {
              cls += ' ' + lastDisableClass;
            }
          }
        }

        if (selected) {
          cls += ' ' + selectedClass;
        }

        if (disabled) {
          cls += ' ' + disabledClass;
        }

        var dateHtml = void 0;
        if (dateRender) {
          dateHtml = dateRender(current, value);
        } else {
          var content = contentRender ? contentRender(current, value) : current.date();
          dateHtml = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'div',
            {
              key: getIdFromDate(current),
              className: dateClass,
              'aria-selected': selected,
              'aria-disabled': disabled
            },
            content
          );
        }

        dateCells.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'td',
          {
            key: passed,
            onClick: disabled ? undefined : props.onSelect.bind(null, current),
            onMouseEnter: disabled ? undefined : props.onDayHover && props.onDayHover.bind(null, current) || undefined,
            role: 'gridcell',
            title: Object(__WEBPACK_IMPORTED_MODULE_7__util___["d" /* getTitleString */])(current),
            className: cls
          },
          dateHtml
        ));

        passed++;
      }

      tableHtml.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tr',
        {
          key: iIndex,
          role: 'row',
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()((_cx = {}, _cx[prefixCls + '-current-week'] = isCurrentWeek, _cx[prefixCls + '-active-week'] = isActiveWeek, _cx))
        },
        weekNumberCell,
        dateCells
      ));
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'tbody',
      { className: prefixCls + '-tbody' },
      tableHtml
    );
  };

  return DateTBody;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DateTBody.propTypes = {
  contentRender: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  dateRender: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  disabledDate: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  selectedValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object)]),
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  hoverValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  showWeekNumber: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};
DateTBody.defaultProps = {
  hoverValue: []
};
/* harmony default export */ __webpack_exports__["a"] = (DateTBody);

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_Children_mapSelf__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__month_MonthPanel__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__year_YearPanel__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__decade_DecadePanel__ = __webpack_require__(935);










function goMonth(direction) {
  var next = this.props.value.clone();
  next.add(direction, 'months');
  this.props.onValueChange(next);
}

function goYear(direction) {
  var next = this.props.value.clone();
  next.add(direction, 'years');
  this.props.onValueChange(next);
}

function showIf(condition, el) {
  return condition ? el : null;
}

var CalendarHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(CalendarHeader, _React$Component);

  function CalendarHeader(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CalendarHeader);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    _this.nextMonth = goMonth.bind(_this, 1);
    _this.previousMonth = goMonth.bind(_this, -1);
    _this.nextYear = goYear.bind(_this, 1);
    _this.previousYear = goYear.bind(_this, -1);

    _this.state = { yearPanelReferer: null };
    return _this;
  }

  CalendarHeader.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var prefixCls = props.prefixCls,
        locale = props.locale,
        mode = props.mode,
        value = props.value,
        showTimePicker = props.showTimePicker,
        enableNext = props.enableNext,
        enablePrev = props.enablePrev,
        disabledMonth = props.disabledMonth,
        renderFooter = props.renderFooter;


    var panel = null;
    if (mode === 'month') {
      panel = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__month_MonthPanel__["a" /* default */], {
        locale: locale,
        value: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onMonthSelect,
        onYearPanelShow: function onYearPanelShow() {
          return _this2.showYearPanel('month');
        },
        disabledDate: disabledMonth,
        cellRender: props.monthCellRender,
        contentRender: props.monthCellContentRender,
        renderFooter: renderFooter,
        changeYear: this.changeYear
      });
    }
    if (mode === 'year') {
      panel = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__year_YearPanel__["a" /* default */], {
        locale: locale,
        defaultValue: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onYearSelect,
        onDecadePanelShow: this.showDecadePanel,
        renderFooter: renderFooter
      });
    }
    if (mode === 'decade') {
      panel = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__decade_DecadePanel__["a" /* default */], {
        locale: locale,
        defaultValue: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onDecadeSelect,
        renderFooter: renderFooter
      });
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls + '-header' },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { style: { position: 'relative' } },
        showIf(enablePrev && !showTimePicker, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
          className: prefixCls + '-prev-year-btn',
          role: 'button',
          onClick: this.previousYear,
          title: locale.previousYear
        })),
        showIf(enablePrev && !showTimePicker, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
          className: prefixCls + '-prev-month-btn',
          role: 'button',
          onClick: this.previousMonth,
          title: locale.previousMonth
        })),
        this.monthYearElement(showTimePicker),
        showIf(enableNext && !showTimePicker, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
          className: prefixCls + '-next-month-btn',
          onClick: this.nextMonth,
          title: locale.nextMonth
        })),
        showIf(enableNext && !showTimePicker, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
          className: prefixCls + '-next-year-btn',
          onClick: this.nextYear,
          title: locale.nextYear
        }))
      ),
      panel
    );
  };

  return CalendarHeader;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

CalendarHeader.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  onValueChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  showTimePicker: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  onPanelChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  locale: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  enablePrev: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  enableNext: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  disabledMonth: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  renderFooter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMonthSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};
CalendarHeader.defaultProps = {
  enableNext: 1,
  enablePrev: 1,
  onPanelChange: function onPanelChange() {},
  onValueChange: function onValueChange() {}
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onMonthSelect = function (value) {
    _this3.props.onPanelChange(value, 'date');
    if (_this3.props.onMonthSelect) {
      _this3.props.onMonthSelect(value);
    } else {
      _this3.props.onValueChange(value);
    }
  };

  this.onYearSelect = function (value) {
    var referer = _this3.state.yearPanelReferer;
    _this3.setState({ yearPanelReferer: null });
    _this3.props.onPanelChange(value, referer);
    _this3.props.onValueChange(value);
  };

  this.onDecadeSelect = function (value) {
    _this3.props.onPanelChange(value, 'year');
    _this3.props.onValueChange(value);
  };

  this.changeYear = function (direction) {
    if (direction > 0) {
      _this3.nextYear();
    } else {
      _this3.previousYear();
    }
  };

  this.monthYearElement = function (showTimePicker) {
    var props = _this3.props;
    var prefixCls = props.prefixCls;
    var locale = props.locale;
    var value = props.value;
    var localeData = value.localeData();
    var monthBeforeYear = locale.monthBeforeYear;
    var selectClassName = prefixCls + '-' + (monthBeforeYear ? 'my-select' : 'ym-select');
    var timeClassName = showTimePicker ? ' ' + prefixCls + '-time-status' : '';
    var year = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'a',
      {
        className: prefixCls + '-year-select' + timeClassName,
        role: 'button',
        onClick: showTimePicker ? null : function () {
          return _this3.showYearPanel('date');
        },
        title: showTimePicker ? null : locale.yearSelect
      },
      value.format(locale.yearFormat)
    );
    var month = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'a',
      {
        className: prefixCls + '-month-select' + timeClassName,
        role: 'button',
        onClick: showTimePicker ? null : _this3.showMonthPanel,
        title: showTimePicker ? null : locale.monthSelect
      },
      locale.monthFormat ? value.format(locale.monthFormat) : localeData.monthsShort(value)
    );
    var day = void 0;
    if (showTimePicker) {
      day = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'a',
        {
          className: prefixCls + '-day-select' + timeClassName,
          role: 'button'
        },
        value.format(locale.dayFormat)
      );
    }
    var my = [];
    if (monthBeforeYear) {
      my = [month, day, year];
    } else {
      my = [year, month, day];
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'span',
      { className: selectClassName },
      Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_Children_mapSelf__["a" /* default */])(my)
    );
  };

  this.showMonthPanel = function () {
    // null means that users' interaction doesn't change value
    _this3.props.onPanelChange(null, 'month');
  };

  this.showYearPanel = function (referer) {
    _this3.setState({ yearPanelReferer: referer });
    _this3.props.onPanelChange(null, 'year');
  };

  this.showDecadePanel = function () {
    _this3.props.onPanelChange(null, 'decade');
  };
};

/* harmony default export */ __webpack_exports__["a"] = (CalendarHeader);

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lifecycles_compat__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MonthTable__ = __webpack_require__(933);








function goYear(direction) {
  this.props.changeYear(direction);
}

function noop() {}

var MonthPanel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(MonthPanel, _React$Component);

  function MonthPanel(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MonthPanel);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.setAndSelectValue = function (value) {
      _this.setValue(value);
      _this.props.onSelect(value);
    };

    _this.setValue = function (value) {
      if ('value' in _this.props) {
        _this.setState({
          value: value
        });
      }
    };

    _this.nextYear = goYear.bind(_this, 1);
    _this.previousYear = goYear.bind(_this, -1);
    _this.prefixCls = props.rootPrefixCls + '-month-panel';

    _this.state = {
      value: props.value || props.defaultValue
    };
    return _this;
  }

  MonthPanel.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
    var newState = {};

    if ('value' in props) {
      newState = {
        value: props.value
      };
    }

    return newState;
  };

  MonthPanel.prototype.render = function render() {
    var props = this.props;
    var value = this.state.value;
    var locale = props.locale,
        cellRender = props.cellRender,
        contentRender = props.contentRender,
        renderFooter = props.renderFooter;

    var year = value.year();
    var prefixCls = this.prefixCls;

    var footer = renderFooter && renderFooter('month');

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls, style: props.style },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-header' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
            className: prefixCls + '-prev-year-btn',
            role: 'button',
            onClick: this.previousYear,
            title: locale.previousYear
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'a',
            {
              className: prefixCls + '-year-select',
              role: 'button',
              onClick: props.onYearPanelShow,
              title: locale.yearSelect
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'span',
              { className: prefixCls + '-year-select-content' },
              year
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'span',
              { className: prefixCls + '-year-select-arrow' },
              'x'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
            className: prefixCls + '-next-year-btn',
            role: 'button',
            onClick: this.nextYear,
            title: locale.nextYear
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-body' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__MonthTable__["a" /* default */], {
            disabledDate: props.disabledDate,
            onSelect: this.setAndSelectValue,
            locale: locale,
            value: value,
            cellRender: cellRender,
            contentRender: contentRender,
            prefixCls: prefixCls
          })
        ),
        footer && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-footer' },
          footer
        )
      )
    );
  };

  return MonthPanel;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

MonthPanel.propTypes = {
  onChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  disabledDate: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  renderFooter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  defaultValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
};
MonthPanel.defaultProps = {
  onChange: noop,
  onSelect: noop
};


Object(__WEBPACK_IMPORTED_MODULE_5_react_lifecycles_compat__["polyfill"])(MonthPanel);

/* harmony default export */ __webpack_exports__["a"] = (MonthPanel);

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_index__ = __webpack_require__(193);









var ROW = 4;
var COL = 3;

function noop() {}

var MonthTable = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(MonthTable, _Component);

  function MonthTable() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MonthTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  MonthTable.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
    if ('value' in props) {
      return { value: props.value };
    }
    return null;
  };

  MonthTable.prototype.setAndSelectValue = function setAndSelectValue(value) {
    this.setState({
      value: value
    });
    this.props.onSelect(value);
  };

  MonthTable.prototype.chooseMonth = function chooseMonth(month) {
    var next = this.state.value.clone();
    next.month(month);
    this.setAndSelectValue(next);
  };

  MonthTable.prototype.months = function months() {
    var value = this.state.value;
    var current = value.clone();
    var months = [];
    var index = 0;
    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      months[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        current.month(index);
        var content = Object(__WEBPACK_IMPORTED_MODULE_7__util_index__["b" /* getMonthName */])(current);
        months[rowIndex][colIndex] = {
          value: index,
          content: content,
          title: content
        };
        index++;
      }
    }
    return months;
  };

  MonthTable.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var value = this.state.value;
    var today = Object(__WEBPACK_IMPORTED_MODULE_7__util_index__["e" /* getTodayTime */])(value);
    var months = this.months();
    var currentMonth = value.month();
    var prefixCls = props.prefixCls,
        locale = props.locale,
        contentRender = props.contentRender,
        cellRender = props.cellRender;

    var monthsEls = months.map(function (month, index) {
      var tds = month.map(function (monthData) {
        var _classNameMap;

        var disabled = false;
        if (props.disabledDate) {
          var testValue = value.clone();
          testValue.month(monthData.value);
          disabled = props.disabledDate(testValue);
        }
        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-cell-disabled'] = disabled, _classNameMap[prefixCls + '-selected-cell'] = monthData.value === currentMonth, _classNameMap[prefixCls + '-current-cell'] = today.year() === value.year() && monthData.value === today.month(), _classNameMap);
        var cellEl = void 0;
        if (cellRender) {
          var currentValue = value.clone();
          currentValue.month(monthData.value);
          cellEl = cellRender(currentValue, locale);
        } else {
          var content = void 0;
          if (contentRender) {
            var _currentValue = value.clone();
            _currentValue.month(monthData.value);
            content = contentRender(_currentValue, locale);
          } else {
            content = monthData.content;
          }
          cellEl = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'a',
            { className: prefixCls + '-month' },
            content
          );
        }
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'td',
          {
            role: 'gridcell',
            key: monthData.value,
            onClick: disabled ? null : function () {
              return _this2.chooseMonth(monthData.value);
            },
            title: monthData.title,
            className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classNameMap)
          },
          cellEl
        );
      });
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tr',
        { key: index, role: 'row' },
        tds
      );
    });

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'table',
      { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tbody',
        { className: prefixCls + '-tbody' },
        monthsEls
      )
    );
  };

  return MonthTable;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

MonthTable.defaultProps = {
  onSelect: noop
};

MonthTable.propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  cellRender: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
};

Object(__WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__["polyfill"])(MonthTable);

/* harmony default export */ __webpack_exports__["a"] = (MonthTable);

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);






var ROW = 4;
var COL = 3;

function goYear(direction) {
  var value = this.state.value.clone();
  value.add(direction, 'year');
  this.setState({
    value: value
  });
}

function chooseYear(year) {
  var value = this.state.value.clone();
  value.year(year);
  value.month(this.state.value.month());
  this.setState({
    value: value
  });
  this.props.onSelect(value);
}

var YearPanel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(YearPanel, _React$Component);

  function YearPanel(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, YearPanel);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.prefixCls = props.rootPrefixCls + '-year-panel';
    _this.state = {
      value: props.value || props.defaultValue
    };
    _this.nextDecade = goYear.bind(_this, 10);
    _this.previousDecade = goYear.bind(_this, -10);
    return _this;
  }

  YearPanel.prototype.years = function years() {
    var value = this.state.value;
    var currentYear = value.year();
    var startYear = parseInt(currentYear / 10, 10) * 10;
    var previousYear = startYear - 1;
    var years = [];
    var index = 0;
    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      years[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        var year = previousYear + index;
        var content = String(year);
        years[rowIndex][colIndex] = {
          content: content,
          year: year,
          title: content
        };
        index++;
      }
    }
    return years;
  };

  YearPanel.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var value = this.state.value;
    var locale = props.locale,
        renderFooter = props.renderFooter;

    var years = this.years();
    var currentYear = value.year();
    var startYear = parseInt(currentYear / 10, 10) * 10;
    var endYear = startYear + 9;
    var prefixCls = this.prefixCls;

    var yeasEls = years.map(function (row, index) {
      var tds = row.map(function (yearData) {
        var _classNameMap;

        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = yearData.year === currentYear, _classNameMap[prefixCls + '-last-decade-cell'] = yearData.year < startYear, _classNameMap[prefixCls + '-next-decade-cell'] = yearData.year > endYear, _classNameMap);
        var clickHandler = void 0;
        if (yearData.year < startYear) {
          clickHandler = _this2.previousDecade;
        } else if (yearData.year > endYear) {
          clickHandler = _this2.nextDecade;
        } else {
          clickHandler = chooseYear.bind(_this2, yearData.year);
        }
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'td',
          {
            role: 'gridcell',
            title: yearData.title,
            key: yearData.content,
            onClick: clickHandler,
            className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classNameMap)
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'a',
            {
              className: prefixCls + '-year'
            },
            yearData.content
          )
        );
      });
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tr',
        { key: index, role: 'row' },
        tds
      );
    });

    var footer = renderFooter && renderFooter('year');

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: this.prefixCls },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-header' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
            className: prefixCls + '-prev-decade-btn',
            role: 'button',
            onClick: this.previousDecade,
            title: locale.previousDecade
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'a',
            {
              className: prefixCls + '-decade-select',
              role: 'button',
              onClick: props.onDecadePanelShow,
              title: locale.decadeSelect
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'span',
              { className: prefixCls + '-decade-select-content' },
              startYear,
              '-',
              endYear
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'span',
              { className: prefixCls + '-decade-select-arrow' },
              'x'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
            className: prefixCls + '-next-decade-btn',
            role: 'button',
            onClick: this.nextDecade,
            title: locale.nextDecade
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-body' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'table',
            { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'tbody',
              { className: prefixCls + '-tbody' },
              yeasEls
            )
          )
        ),
        footer && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-footer' },
          footer
        )
      )
    );
  };

  return YearPanel;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (YearPanel);


YearPanel.propTypes = {
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  defaultValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  renderFooter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};

YearPanel.defaultProps = {
  onSelect: function onSelect() {}
};

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);





var ROW = 4;
var COL = 3;


function goYear(direction) {
  var next = this.state.value.clone();
  next.add(direction, 'years');
  this.setState({
    value: next
  });
}

function chooseDecade(year, event) {
  var next = this.state.value.clone();
  next.year(year);
  next.month(this.state.value.month());
  this.props.onSelect(next);
  event.preventDefault();
}

var DecadePanel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DecadePanel, _React$Component);

  function DecadePanel(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DecadePanel);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      value: props.value || props.defaultValue
    };

    // bind methods
    _this.prefixCls = props.rootPrefixCls + '-decade-panel';
    _this.nextCentury = goYear.bind(_this, 100);
    _this.previousCentury = goYear.bind(_this, -100);
    return _this;
  }

  DecadePanel.prototype.render = function render() {
    var _this2 = this;

    var value = this.state.value;
    var _props = this.props,
        locale = _props.locale,
        renderFooter = _props.renderFooter;

    var currentYear = value.year();
    var startYear = parseInt(currentYear / 100, 10) * 100;
    var preYear = startYear - 10;
    var endYear = startYear + 99;
    var decades = [];
    var index = 0;
    var prefixCls = this.prefixCls;

    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      decades[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        var startDecade = preYear + index * 10;
        var endDecade = preYear + index * 10 + 9;
        decades[rowIndex][colIndex] = {
          startDecade: startDecade,
          endDecade: endDecade
        };
        index++;
      }
    }

    var footer = renderFooter && renderFooter('decade');

    var decadesEls = decades.map(function (row, decadeIndex) {
      var tds = row.map(function (decadeData) {
        var _classNameMap;

        var dStartDecade = decadeData.startDecade;
        var dEndDecade = decadeData.endDecade;
        var isLast = dStartDecade < startYear;
        var isNext = dEndDecade > endYear;
        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = dStartDecade <= currentYear && currentYear <= dEndDecade, _classNameMap[prefixCls + '-last-century-cell'] = isLast, _classNameMap[prefixCls + '-next-century-cell'] = isNext, _classNameMap);
        var content = dStartDecade + '-' + dEndDecade;
        var clickHandler = void 0;
        if (isLast) {
          clickHandler = _this2.previousCentury;
        } else if (isNext) {
          clickHandler = _this2.nextCentury;
        } else {
          clickHandler = chooseDecade.bind(_this2, dStartDecade);
        }
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'td',
          {
            key: dStartDecade,
            onClick: clickHandler,
            role: 'gridcell',
            className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classNameMap)
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'a',
            {
              className: prefixCls + '-decade'
            },
            content
          )
        );
      });
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tr',
        { key: decadeIndex, role: 'row' },
        tds
      );
    });

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: this.prefixCls },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: prefixCls + '-header' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
          className: prefixCls + '-prev-century-btn',
          role: 'button',
          onClick: this.previousCentury,
          title: locale.previousCentury
        }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-century' },
          startYear,
          '-',
          endYear
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
          className: prefixCls + '-next-century-btn',
          role: 'button',
          onClick: this.nextCentury,
          title: locale.nextCentury
        })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: prefixCls + '-body' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'table',
          { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'tbody',
            { className: prefixCls + '-tbody' },
            decadesEls
          )
        )
      ),
      footer && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: prefixCls + '-footer' },
        footer
      )
    );
  };

  return DecadePanel;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (DecadePanel);


DecadePanel.propTypes = {
  locale: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  defaultValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  renderFooter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};

DecadePanel.defaultProps = {
  onSelect: function onSelect() {}
};

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Children_mapSelf__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__calendar_TodayButton__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__calendar_OkButton__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__calendar_TimePickerButton__ = __webpack_require__(939);













var CalendarFooter = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(CalendarFooter, _React$Component);

  function CalendarFooter() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CalendarFooter);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  CalendarFooter.prototype.onSelect = function onSelect(value) {
    this.props.onSelect(value);
  };

  CalendarFooter.prototype.getRootDOMNode = function getRootDOMNode() {
    return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
  };

  CalendarFooter.prototype.render = function render() {
    var props = this.props;
    var value = props.value,
        prefixCls = props.prefixCls,
        showOk = props.showOk,
        timePicker = props.timePicker,
        renderFooter = props.renderFooter,
        mode = props.mode;

    var footerEl = null;
    var extraFooter = renderFooter && renderFooter(mode);
    if (props.showToday || timePicker || extraFooter) {
      var _cx;

      var nowEl = void 0;
      if (props.showToday) {
        nowEl = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__calendar_TodayButton__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { value: value }));
      }
      var okBtn = void 0;
      if (showOk === true || showOk !== false && !!props.timePicker) {
        okBtn = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__calendar_OkButton__["a" /* default */], props);
      }
      var timePickerBtn = void 0;
      if (!!props.timePicker) {
        timePickerBtn = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__calendar_TimePickerButton__["a" /* default */], props);
      }

      var footerBtn = void 0;
      if (nowEl || timePickerBtn || okBtn || extraFooter) {
        footerBtn = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'span',
          { className: prefixCls + '-footer-btn' },
          extraFooter,
          Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Children_mapSelf__["a" /* default */])([nowEl, timePickerBtn, okBtn])
        );
      }
      var cls = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(prefixCls + '-footer', (_cx = {}, _cx[prefixCls + '-footer-show-ok'] = okBtn, _cx));
      footerEl = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'div',
        { className: cls },
        footerBtn
      );
    }
    return footerEl;
  };

  return CalendarFooter;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

CalendarFooter.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  showDateInput: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  disabledTime: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  timePicker: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.element,
  selectedValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  showOk: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  renderFooter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  defaultValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  mode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (CalendarFooter);

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TodayButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___ = __webpack_require__(193);



function TodayButton(_ref) {
  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      value = _ref.value,
      timePicker = _ref.timePicker,
      disabled = _ref.disabled,
      disabledDate = _ref.disabledDate,
      onToday = _ref.onToday,
      text = _ref.text;

  var localeNow = (!text && timePicker ? locale.now : text) || locale.today;
  var disabledToday = disabledDate && !Object(__WEBPACK_IMPORTED_MODULE_1__util___["g" /* isAllowedDate */])(Object(__WEBPACK_IMPORTED_MODULE_1__util___["e" /* getTodayTime */])(value), disabledDate);
  var isDisabled = disabledToday || disabled;
  var disabledTodayClass = isDisabled ? prefixCls + '-today-btn-disabled' : '';
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      className: prefixCls + '-today-btn ' + disabledTodayClass,
      role: 'button',
      onClick: isDisabled ? null : onToday,
      title: Object(__WEBPACK_IMPORTED_MODULE_1__util___["f" /* getTodayTimeStr */])(value)
    },
    localeNow
  );
}

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = OkButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function OkButton(_ref) {
  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      okDisabled = _ref.okDisabled,
      onOk = _ref.onOk;

  var className = prefixCls + "-ok-btn";
  if (okDisabled) {
    className += " " + prefixCls + "-ok-btn-disabled";
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "a",
    {
      className: className,
      role: "button",
      onClick: okDisabled ? null : onOk
    },
    locale.ok
  );
}

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TimePickerButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);



function TimePickerButton(_ref) {
  var _classnames;

  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      showTimePicker = _ref.showTimePicker,
      onOpenTimePicker = _ref.onOpenTimePicker,
      onCloseTimePicker = _ref.onCloseTimePicker,
      timePickerDisabled = _ref.timePickerDisabled;

  var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[prefixCls + '-time-picker-btn'] = true, _classnames[prefixCls + '-time-picker-btn-disabled'] = timePickerDisabled, _classnames));
  var onClick = null;
  if (!timePickerDisabled) {
    onClick = showTimePicker ? onCloseTimePicker : onOpenTimePicker;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      className: className,
      role: 'button',
      onClick: onClick
    },
    showTimePicker ? locale.dateSelect : locale.timeSelect
  );
}

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getNowByCurrentStateValue;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calendarMixinPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calendarMixinDefaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return calendarMixinWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_index__ = __webpack_require__(193);









function noop() {}

function getNowByCurrentStateValue(value) {
  var ret = void 0;
  if (value) {
    ret = Object(__WEBPACK_IMPORTED_MODULE_7__util_index__["e" /* getTodayTime */])(value);
  } else {
    ret = __WEBPACK_IMPORTED_MODULE_6_moment___default()();
  }
  return ret;
}

var calendarMixinPropTypes = {
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  defaultValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};

var calendarMixinDefaultProps = {
  onKeyDown: noop
};

var calendarMixinWrapper = function calendarMixinWrapper(ComposeComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_ComposeComponent) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(_class, _ComposeComponent);

    function _class() {
      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ComposeComponent.call.apply(_ComposeComponent, [this].concat(args))), _this), _this.onSelect = function (value, cause) {
        if (value) {
          _this.setValue(value);
        }
        _this.setSelectedValue(value, cause);
      }, _this.renderRoot = function (newProps) {
        var _className;

        var props = _this.props;
        var prefixCls = props.prefixCls;

        var className = (_className = {}, _className[prefixCls] = 1, _className[prefixCls + '-hidden'] = !props.visible, _className[props.className] = !!props.className, _className[newProps.className] = !!newProps.className, _className);

        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          {
            ref: _this.saveRoot,
            className: '' + __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className),
            style: _this.props.style,
            tabIndex: '0',
            onKeyDown: _this.onKeyDown,
            onBlur: _this.onBlur
          },
          newProps.children
        );
      }, _this.setSelectedValue = function (selectedValue, cause) {
        // if (this.isAllowedDate(selectedValue)) {
        if (!('selectedValue' in _this.props)) {
          _this.setState({
            selectedValue: selectedValue
          });
        }
        if (_this.props.onSelect) {
          _this.props.onSelect(selectedValue, cause);
        }
        // }
      }, _this.setValue = function (value) {
        var originalValue = _this.state.value;
        if (!('value' in _this.props)) {
          _this.setState({
            value: value
          });
        }
        if (originalValue && value && !originalValue.isSame(value) || !originalValue && value || originalValue && !value) {
          _this.props.onChange(value);
        }
      }, _this.isAllowedDate = function (value) {
        var disabledDate = _this.props.disabledDate;
        var disabledTime = _this.props.disabledTime;
        return Object(__WEBPACK_IMPORTED_MODULE_7__util_index__["g" /* isAllowedDate */])(value, disabledDate, disabledTime);
      }, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      // Use origin function if provided
      if (ComposeComponent.getDerivedStateFromProps) {
        return ComposeComponent.getDerivedStateFromProps(nextProps, prevState);
      }

      var value = nextProps.value,
          selectedValue = nextProps.selectedValue;

      var newState = {};

      if ('value' in nextProps) {
        newState.value = value || nextProps.defaultValue || getNowByCurrentStateValue(prevState.value);
      }
      if ('selectedValue' in nextProps) {
        newState.selectedValue = selectedValue;
      }

      return newState;
    };

    return _class;
  }(ComposeComponent), _class.displayName = 'CalendarMixinWrapper', _class.defaultProps = ComposeComponent.defaultProps, _temp2;
};

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return propType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return commonMixinWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__locale_en_US__ = __webpack_require__(942);






function noop() {}

var propType = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  locale: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  visible: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  onSelect: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  prefixCls: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onOk: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

var defaultProp = {
  locale: __WEBPACK_IMPORTED_MODULE_4__locale_en_US__["a" /* default */],
  style: {},
  visible: true,
  prefixCls: 'rc-calendar',
  className: '',
  onSelect: noop,
  onChange: noop,
  onClear: noop,
  renderFooter: function renderFooter() {
    return null;
  },
  renderSidebar: function renderSidebar() {
    return null;
  }
};

var commonMixinWrapper = function commonMixinWrapper(ComposeComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_ComposeComponent) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(_class, _ComposeComponent);

    function _class() {
      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ComposeComponent.call.apply(_ComposeComponent, [this].concat(args))), _this), _this.getFormat = function () {
        var format = _this.props.format;
        var _this$props = _this.props,
            locale = _this$props.locale,
            timePicker = _this$props.timePicker;

        if (!format) {
          if (timePicker) {
            format = locale.dateTimeFormat;
          } else {
            format = locale.dateFormat;
          }
        }
        return format;
      }, _this.focus = function () {
        if (_this.focusElement) {
          _this.focusElement.focus();
        } else if (_this.rootInstance) {
          _this.rootInstance.focus();
        }
      }, _this.saveFocusElement = function (focusElement) {
        _this.focusElement = focusElement;
      }, _this.saveRoot = function (root) {
        _this.rootInstance = root;
      }, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
      return this.props.visible || nextProps.visible;
    };

    return _class;
  }(ComposeComponent), _class.displayName = 'CommonMixinWrapper', _class.defaultProps = ComposeComponent.defaultProps, _class.getDerivedStateFromProps = ComposeComponent.getDerivedStateFromProps, _temp2;
};

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  today: 'Today',
  now: 'Now',
  backToToday: 'Back to today',
  ok: 'Ok',
  clear: 'Clear',
  month: 'Month',
  year: 'Year',
  timeSelect: 'select time',
  dateSelect: 'select date',
  weekSelect: 'Choose a week',
  monthSelect: 'Choose a month',
  yearSelect: 'Choose a year',
  decadeSelect: 'Choose a decade',
  yearFormat: 'YYYY',
  dateFormat: 'M/D/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Previous month (PageUp)',
  nextMonth: 'Next month (PageDown)',
  previousYear: 'Last year (Control + left)',
  nextYear: 'Next year (Control + right)',
  previousDecade: 'Last decade',
  nextDecade: 'Next decade',
  previousCentury: 'Last century',
  nextCentury: 'Next century'
});

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(193);











var cachedSelectionStart = void 0;
var cachedSelectionEnd = void 0;
var dateInputInstance = void 0;

var DateInput = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DateInput, _React$Component);

  function DateInput(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DateInput);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var selectedValue = props.selectedValue;

    _this.state = {
      str: Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* formatDate */])(selectedValue, _this.props.format),
      invalid: false,
      hasFocus: false
    };
    return _this;
  }

  DateInput.prototype.componentDidUpdate = function componentDidUpdate() {
    if (dateInputInstance && this.state.hasFocus && !this.state.invalid && !(cachedSelectionStart === 0 && cachedSelectionEnd === 0)) {
      dateInputInstance.setSelectionRange(cachedSelectionStart, cachedSelectionEnd);
    }
  };

  DateInput.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, state) {
    var newState = {};

    if (dateInputInstance) {
      cachedSelectionStart = dateInputInstance.selectionStart;
      cachedSelectionEnd = dateInputInstance.selectionEnd;
    }
    // when popup show, click body will call this, bug!
    var selectedValue = nextProps.selectedValue;
    if (!state.hasFocus) {
      newState = {
        str: Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* formatDate */])(selectedValue, nextProps.format),
        invalid: false
      };
    }

    return newState;
  };

  DateInput.getInstance = function getInstance() {
    return dateInputInstance;
  };

  DateInput.prototype.render = function render() {
    var props = this.props;
    var _state = this.state,
        invalid = _state.invalid,
        str = _state.str;
    var locale = props.locale,
        prefixCls = props.prefixCls,
        placeholder = props.placeholder,
        clearIcon = props.clearIcon,
        inputMode = props.inputMode;

    var invalidClass = invalid ? prefixCls + '-input-invalid' : '';
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls + '-input-wrap' },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: prefixCls + '-date-input-wrap' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
          ref: this.saveDateInput,
          className: prefixCls + '-input ' + invalidClass,
          value: str,
          disabled: props.disabled,
          placeholder: placeholder,
          onChange: this.onInputChange,
          onKeyDown: this.onKeyDown,
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          inputMode: inputMode
        })
      ),
      props.showClear ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'a',
        {
          role: 'button',
          title: locale.clear,
          onClick: this.onClear
        },
        clearIcon || __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: prefixCls + '-clear-btn' })
      ) : null
    );
  };

  return DateInput;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DateInput.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  timePicker: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  disabledTime: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  format: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  locale: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  disabledDate: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onClear: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  placeholder: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onSelect: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  selectedValue: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  clearIcon: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  inputMode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onClear = function () {
    _this2.setState({
      str: ''
    });
    _this2.props.onClear(null);
  };

  this.onInputChange = function (event) {
    var str = event.target.value;
    var _props = _this2.props,
        disabledDate = _props.disabledDate,
        format = _props.format,
        onChange = _props.onChange,
        selectedValue = _props.selectedValue;

    // 没有内容，合法并直接退出

    if (!str) {
      onChange(null);
      _this2.setState({
        invalid: false,
        str: str
      });
      return;
    }

    // 不合法直接退出
    var parsed = __WEBPACK_IMPORTED_MODULE_8_moment___default()(str, format, true);
    if (!parsed.isValid()) {
      _this2.setState({
        invalid: true,
        str: str
      });
      return;
    }

    var value = _this2.props.value.clone();
    value.year(parsed.year()).month(parsed.month()).date(parsed.date()).hour(parsed.hour()).minute(parsed.minute()).second(parsed.second());

    if (!value || disabledDate && disabledDate(value)) {
      _this2.setState({
        invalid: true,
        str: str
      });
      return;
    }

    if (selectedValue !== value || selectedValue && value && !selectedValue.isSame(value)) {
      _this2.setState({
        invalid: false,
        str: str
      });
      onChange(value);
    }
  };

  this.onFocus = function () {
    _this2.setState({ hasFocus: true });
  };

  this.onBlur = function () {
    _this2.setState(function (prevState, prevProps) {
      return {
        hasFocus: false,
        str: Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* formatDate */])(prevProps.value, prevProps.format)
      };
    });
  };

  this.onKeyDown = function (event) {
    var keyCode = event.keyCode;
    var _props2 = _this2.props,
        onSelect = _props2.onSelect,
        value = _props2.value,
        disabledDate = _props2.disabledDate;

    if (keyCode === __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__["a" /* default */].ENTER && onSelect) {
      var validateDate = !disabledDate || !disabledDate(value);
      if (validateDate) {
        onSelect(value.clone());
      }
      event.preventDefault();
    }
  };

  this.getRootDOMNode = function () {
    return __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(_this2);
  };

  this.focus = function () {
    if (dateInputInstance) {
      dateInputInstance.focus();
    }
  };

  this.saveDateInput = function (dateInput) {
    dateInputInstance = dateInput;
  };
};

Object(__WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__["polyfill"])(DateInput);

/* harmony default export */ __webpack_exports__["a"] = (DateInput);

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = goStartMonth;
/* harmony export (immutable) */ __webpack_exports__["a"] = goEndMonth;
/* harmony export (immutable) */ __webpack_exports__["c"] = goTime;
/* unused harmony export includesTime */
function goStartMonth(time) {
  return time.clone().startOf('month');
}

function goEndMonth(time) {
  return time.clone().endOf('month');
}

function goTime(time, direction, unit) {
  return time.clone().add(direction, unit);
}

function includesTime() {
  var timeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var time = arguments[1];
  var unit = arguments[2];

  return timeList.some(function (t) {
    return t.isSame(time, unit);
  });
}

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(31);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(32);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactLifecyclesCompat = __webpack_require__(36);

var _MonthTable = __webpack_require__(732);

var _MonthTable2 = _interopRequireDefault(_MonthTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function goYear(direction) {
  this.props.changeYear(direction);
}

function noop() {}

var MonthPanel = function (_React$Component) {
  (0, _inherits3['default'])(MonthPanel, _React$Component);

  function MonthPanel(props) {
    (0, _classCallCheck3['default'])(this, MonthPanel);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _this.setAndSelectValue = function (value) {
      _this.setValue(value);
      _this.props.onSelect(value);
    };

    _this.setValue = function (value) {
      if ('value' in _this.props) {
        _this.setState({
          value: value
        });
      }
    };

    _this.nextYear = goYear.bind(_this, 1);
    _this.previousYear = goYear.bind(_this, -1);
    _this.prefixCls = props.rootPrefixCls + '-month-panel';

    _this.state = {
      value: props.value || props.defaultValue
    };
    return _this;
  }

  MonthPanel.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
    var newState = {};

    if ('value' in props) {
      newState = {
        value: props.value
      };
    }

    return newState;
  };

  MonthPanel.prototype.render = function render() {
    var props = this.props;
    var value = this.state.value;
    var locale = props.locale,
        cellRender = props.cellRender,
        contentRender = props.contentRender,
        renderFooter = props.renderFooter;

    var year = value.year();
    var prefixCls = this.prefixCls;

    var footer = renderFooter && renderFooter('month');

    return _react2['default'].createElement(
      'div',
      { className: prefixCls, style: props.style },
      _react2['default'].createElement(
        'div',
        null,
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-header' },
          _react2['default'].createElement('a', {
            className: prefixCls + '-prev-year-btn',
            role: 'button',
            onClick: this.previousYear,
            title: locale.previousYear
          }),
          _react2['default'].createElement(
            'a',
            {
              className: prefixCls + '-year-select',
              role: 'button',
              onClick: props.onYearPanelShow,
              title: locale.yearSelect
            },
            _react2['default'].createElement(
              'span',
              { className: prefixCls + '-year-select-content' },
              year
            ),
            _react2['default'].createElement(
              'span',
              { className: prefixCls + '-year-select-arrow' },
              'x'
            )
          ),
          _react2['default'].createElement('a', {
            className: prefixCls + '-next-year-btn',
            role: 'button',
            onClick: this.nextYear,
            title: locale.nextYear
          })
        ),
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-body' },
          _react2['default'].createElement(_MonthTable2['default'], {
            disabledDate: props.disabledDate,
            onSelect: this.setAndSelectValue,
            locale: locale,
            value: value,
            cellRender: cellRender,
            contentRender: contentRender,
            prefixCls: prefixCls
          })
        ),
        footer && _react2['default'].createElement(
          'div',
          { className: prefixCls + '-footer' },
          footer
        )
      )
    );
  };

  return MonthPanel;
}(_react2['default'].Component);

MonthPanel.propTypes = {
  onChange: _propTypes2['default'].func,
  disabledDate: _propTypes2['default'].func,
  onSelect: _propTypes2['default'].func,
  renderFooter: _propTypes2['default'].func,
  rootPrefixCls: _propTypes2['default'].string,
  value: _propTypes2['default'].object,
  defaultValue: _propTypes2['default'].object
};
MonthPanel.defaultProps = {
  onChange: noop,
  onSelect: noop
};


(0, _reactLifecyclesCompat.polyfill)(MonthPanel);

exports['default'] = MonthPanel;
module.exports = exports['default'];

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(31);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(32);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(22);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ROW = 4;
var COL = 3;

function goYear(direction) {
  var value = this.state.value.clone();
  value.add(direction, 'year');
  this.setState({
    value: value
  });
}

function chooseYear(year) {
  var value = this.state.value.clone();
  value.year(year);
  value.month(this.state.value.month());
  this.setState({
    value: value
  });
  this.props.onSelect(value);
}

var YearPanel = function (_React$Component) {
  (0, _inherits3['default'])(YearPanel, _React$Component);

  function YearPanel(props) {
    (0, _classCallCheck3['default'])(this, YearPanel);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _this.prefixCls = props.rootPrefixCls + '-year-panel';
    _this.state = {
      value: props.value || props.defaultValue
    };
    _this.nextDecade = goYear.bind(_this, 10);
    _this.previousDecade = goYear.bind(_this, -10);
    return _this;
  }

  YearPanel.prototype.years = function years() {
    var value = this.state.value;
    var currentYear = value.year();
    var startYear = parseInt(currentYear / 10, 10) * 10;
    var previousYear = startYear - 1;
    var years = [];
    var index = 0;
    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      years[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        var year = previousYear + index;
        var content = String(year);
        years[rowIndex][colIndex] = {
          content: content,
          year: year,
          title: content
        };
        index++;
      }
    }
    return years;
  };

  YearPanel.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var value = this.state.value;
    var locale = props.locale,
        renderFooter = props.renderFooter;

    var years = this.years();
    var currentYear = value.year();
    var startYear = parseInt(currentYear / 10, 10) * 10;
    var endYear = startYear + 9;
    var prefixCls = this.prefixCls;

    var yeasEls = years.map(function (row, index) {
      var tds = row.map(function (yearData) {
        var _classNameMap;

        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = yearData.year === currentYear, _classNameMap[prefixCls + '-last-decade-cell'] = yearData.year < startYear, _classNameMap[prefixCls + '-next-decade-cell'] = yearData.year > endYear, _classNameMap);
        var clickHandler = void 0;
        if (yearData.year < startYear) {
          clickHandler = _this2.previousDecade;
        } else if (yearData.year > endYear) {
          clickHandler = _this2.nextDecade;
        } else {
          clickHandler = chooseYear.bind(_this2, yearData.year);
        }
        return _react2['default'].createElement(
          'td',
          {
            role: 'gridcell',
            title: yearData.title,
            key: yearData.content,
            onClick: clickHandler,
            className: (0, _classnames2['default'])(classNameMap)
          },
          _react2['default'].createElement(
            'a',
            {
              className: prefixCls + '-year'
            },
            yearData.content
          )
        );
      });
      return _react2['default'].createElement(
        'tr',
        { key: index, role: 'row' },
        tds
      );
    });

    var footer = renderFooter && renderFooter('year');

    return _react2['default'].createElement(
      'div',
      { className: this.prefixCls },
      _react2['default'].createElement(
        'div',
        null,
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-header' },
          _react2['default'].createElement('a', {
            className: prefixCls + '-prev-decade-btn',
            role: 'button',
            onClick: this.previousDecade,
            title: locale.previousDecade
          }),
          _react2['default'].createElement(
            'a',
            {
              className: prefixCls + '-decade-select',
              role: 'button',
              onClick: props.onDecadePanelShow,
              title: locale.decadeSelect
            },
            _react2['default'].createElement(
              'span',
              { className: prefixCls + '-decade-select-content' },
              startYear,
              '-',
              endYear
            ),
            _react2['default'].createElement(
              'span',
              { className: prefixCls + '-decade-select-arrow' },
              'x'
            )
          ),
          _react2['default'].createElement('a', {
            className: prefixCls + '-next-decade-btn',
            role: 'button',
            onClick: this.nextDecade,
            title: locale.nextDecade
          })
        ),
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-body' },
          _react2['default'].createElement(
            'table',
            { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
            _react2['default'].createElement(
              'tbody',
              { className: prefixCls + '-tbody' },
              yeasEls
            )
          )
        ),
        footer && _react2['default'].createElement(
          'div',
          { className: prefixCls + '-footer' },
          footer
        )
      )
    );
  };

  return YearPanel;
}(_react2['default'].Component);

exports['default'] = YearPanel;


YearPanel.propTypes = {
  rootPrefixCls: _propTypes2['default'].string,
  value: _propTypes2['default'].object,
  defaultValue: _propTypes2['default'].object,
  renderFooter: _propTypes2['default'].func
};

YearPanel.defaultProps = {
  onSelect: function onSelect() {}
};
module.exports = exports['default'];

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(31);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(32);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(22);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ROW = 4;
var COL = 3;


function goYear(direction) {
  var next = this.state.value.clone();
  next.add(direction, 'years');
  this.setState({
    value: next
  });
}

function chooseDecade(year, event) {
  var next = this.state.value.clone();
  next.year(year);
  next.month(this.state.value.month());
  this.props.onSelect(next);
  event.preventDefault();
}

var DecadePanel = function (_React$Component) {
  (0, _inherits3['default'])(DecadePanel, _React$Component);

  function DecadePanel(props) {
    (0, _classCallCheck3['default'])(this, DecadePanel);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _this.state = {
      value: props.value || props.defaultValue
    };

    // bind methods
    _this.prefixCls = props.rootPrefixCls + '-decade-panel';
    _this.nextCentury = goYear.bind(_this, 100);
    _this.previousCentury = goYear.bind(_this, -100);
    return _this;
  }

  DecadePanel.prototype.render = function render() {
    var _this2 = this;

    var value = this.state.value;
    var _props = this.props,
        locale = _props.locale,
        renderFooter = _props.renderFooter;

    var currentYear = value.year();
    var startYear = parseInt(currentYear / 100, 10) * 100;
    var preYear = startYear - 10;
    var endYear = startYear + 99;
    var decades = [];
    var index = 0;
    var prefixCls = this.prefixCls;

    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      decades[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        var startDecade = preYear + index * 10;
        var endDecade = preYear + index * 10 + 9;
        decades[rowIndex][colIndex] = {
          startDecade: startDecade,
          endDecade: endDecade
        };
        index++;
      }
    }

    var footer = renderFooter && renderFooter('decade');

    var decadesEls = decades.map(function (row, decadeIndex) {
      var tds = row.map(function (decadeData) {
        var _classNameMap;

        var dStartDecade = decadeData.startDecade;
        var dEndDecade = decadeData.endDecade;
        var isLast = dStartDecade < startYear;
        var isNext = dEndDecade > endYear;
        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = dStartDecade <= currentYear && currentYear <= dEndDecade, _classNameMap[prefixCls + '-last-century-cell'] = isLast, _classNameMap[prefixCls + '-next-century-cell'] = isNext, _classNameMap);
        var content = dStartDecade + '-' + dEndDecade;
        var clickHandler = void 0;
        if (isLast) {
          clickHandler = _this2.previousCentury;
        } else if (isNext) {
          clickHandler = _this2.nextCentury;
        } else {
          clickHandler = chooseDecade.bind(_this2, dStartDecade);
        }
        return _react2['default'].createElement(
          'td',
          {
            key: dStartDecade,
            onClick: clickHandler,
            role: 'gridcell',
            className: (0, _classnames2['default'])(classNameMap)
          },
          _react2['default'].createElement(
            'a',
            {
              className: prefixCls + '-decade'
            },
            content
          )
        );
      });
      return _react2['default'].createElement(
        'tr',
        { key: decadeIndex, role: 'row' },
        tds
      );
    });

    return _react2['default'].createElement(
      'div',
      { className: this.prefixCls },
      _react2['default'].createElement(
        'div',
        { className: prefixCls + '-header' },
        _react2['default'].createElement('a', {
          className: prefixCls + '-prev-century-btn',
          role: 'button',
          onClick: this.previousCentury,
          title: locale.previousCentury
        }),
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-century' },
          startYear,
          '-',
          endYear
        ),
        _react2['default'].createElement('a', {
          className: prefixCls + '-next-century-btn',
          role: 'button',
          onClick: this.nextCentury,
          title: locale.nextCentury
        })
      ),
      _react2['default'].createElement(
        'div',
        { className: prefixCls + '-body' },
        _react2['default'].createElement(
          'table',
          { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
          _react2['default'].createElement(
            'tbody',
            { className: prefixCls + '-tbody' },
            decadesEls
          )
        )
      ),
      footer && _react2['default'].createElement(
        'div',
        { className: prefixCls + '-footer' },
        footer
      )
    );
  };

  return DecadePanel;
}(_react2['default'].Component);

exports['default'] = DecadePanel;


DecadePanel.propTypes = {
  locale: _propTypes2['default'].object,
  value: _propTypes2['default'].object,
  defaultValue: _propTypes2['default'].object,
  rootPrefixCls: _propTypes2['default'].string,
  renderFooter: _propTypes2['default'].func
};

DecadePanel.defaultProps = {
  onSelect: function onSelect() {}
};
module.exports = exports['default'];

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(48);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(31);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(32);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(46);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mapSelf = __webpack_require__(500);

var _mapSelf2 = _interopRequireDefault(_mapSelf);

var _classnames = __webpack_require__(22);

var _classnames2 = _interopRequireDefault(_classnames);

var _TodayButton = __webpack_require__(501);

var _TodayButton2 = _interopRequireDefault(_TodayButton);

var _OkButton = __webpack_require__(502);

var _OkButton2 = _interopRequireDefault(_OkButton);

var _TimePickerButton = __webpack_require__(503);

var _TimePickerButton2 = _interopRequireDefault(_TimePickerButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CalendarFooter = function (_React$Component) {
  (0, _inherits3['default'])(CalendarFooter, _React$Component);

  function CalendarFooter() {
    (0, _classCallCheck3['default'])(this, CalendarFooter);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  CalendarFooter.prototype.onSelect = function onSelect(value) {
    this.props.onSelect(value);
  };

  CalendarFooter.prototype.getRootDOMNode = function getRootDOMNode() {
    return _reactDom2['default'].findDOMNode(this);
  };

  CalendarFooter.prototype.render = function render() {
    var props = this.props;
    var value = props.value,
        prefixCls = props.prefixCls,
        showOk = props.showOk,
        timePicker = props.timePicker,
        renderFooter = props.renderFooter,
        mode = props.mode;

    var footerEl = null;
    var extraFooter = renderFooter && renderFooter(mode);
    if (props.showToday || timePicker || extraFooter) {
      var _cx;

      var nowEl = void 0;
      if (props.showToday) {
        nowEl = _react2['default'].createElement(_TodayButton2['default'], (0, _extends3['default'])({}, props, { value: value }));
      }
      var okBtn = void 0;
      if (showOk === true || showOk !== false && !!props.timePicker) {
        okBtn = _react2['default'].createElement(_OkButton2['default'], props);
      }
      var timePickerBtn = void 0;
      if (!!props.timePicker) {
        timePickerBtn = _react2['default'].createElement(_TimePickerButton2['default'], props);
      }

      var footerBtn = void 0;
      if (nowEl || timePickerBtn || okBtn || extraFooter) {
        footerBtn = _react2['default'].createElement(
          'span',
          { className: prefixCls + '-footer-btn' },
          extraFooter,
          (0, _mapSelf2['default'])([nowEl, timePickerBtn, okBtn])
        );
      }
      var cls = (0, _classnames2['default'])(prefixCls + '-footer', (_cx = {}, _cx[prefixCls + '-footer-show-ok'] = okBtn, _cx));
      footerEl = _react2['default'].createElement(
        'div',
        { className: cls },
        footerBtn
      );
    }
    return footerEl;
  };

  return CalendarFooter;
}(_react2['default'].Component);

CalendarFooter.propTypes = {
  prefixCls: _propTypes2['default'].string,
  showDateInput: _propTypes2['default'].bool,
  disabledTime: _propTypes2['default'].any,
  timePicker: _propTypes2['default'].element,
  selectedValue: _propTypes2['default'].any,
  showOk: _propTypes2['default'].bool,
  onSelect: _propTypes2['default'].func,
  value: _propTypes2['default'].object,
  renderFooter: _propTypes2['default'].func,
  defaultValue: _propTypes2['default'].object,
  mode: _propTypes2['default'].string
};
exports['default'] = CalendarFooter;
module.exports = exports['default'];

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createPicker;

var React = _interopRequireWildcard(__webpack_require__(0));

var moment = _interopRequireWildcard(__webpack_require__(2));

var _reactLifecyclesCompat = __webpack_require__(36);

var _MonthCalendar = _interopRequireDefault(__webpack_require__(498));

var _Picker = _interopRequireDefault(__webpack_require__(347));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _omit = _interopRequireDefault(__webpack_require__(71));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _configProvider = __webpack_require__(39);

var _warning = _interopRequireDefault(__webpack_require__(69));

var _interopDefault = _interopRequireDefault(__webpack_require__(182));

var _getDataOrAriaProps = _interopRequireDefault(__webpack_require__(494));

var _utils = __webpack_require__(504);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function createPicker(TheCalendar) {
  var CalenderWrapper = /*#__PURE__*/function (_React$Component) {
    _inherits(CalenderWrapper, _React$Component);

    var _super = _createSuper(CalenderWrapper);

    function CalenderWrapper(props) {
      var _this;

      _classCallCheck(this, CalenderWrapper);

      _this = _super.call(this, props);

      _this.saveInput = function (node) {
        _this.input = node;
      };

      _this.clearSelection = function (e) {
        e.preventDefault();
        e.stopPropagation();

        _this.handleChange(null);
      };

      _this.handleChange = function (value) {
        var _assertThisInitialize = _assertThisInitialized(_this),
            props = _assertThisInitialize.props;

        if (!('value' in props)) {
          _this.setState({
            value: value,
            showDate: value
          });
        }

        props.onChange(value, (0, _utils.formatDate)(value, props.format));
      };

      _this.handleCalendarChange = function (value) {
        _this.setState({
          showDate: value
        });
      };

      _this.handleOpenChange = function (open) {
        var onOpenChange = _this.props.onOpenChange;

        if (!('open' in _this.props)) {
          _this.setState({
            open: open
          });
        }

        if (onOpenChange) {
          onOpenChange(open);
        }
      };

      _this.renderFooter = function () {
        var renderExtraFooter = _this.props.renderExtraFooter;

        var _assertThisInitialize2 = _assertThisInitialized(_this),
            prefixCls = _assertThisInitialize2.prefixCls;

        return renderExtraFooter ? /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-footer-extra")
        }, renderExtraFooter.apply(void 0, arguments)) : null;
      };

      _this.renderPicker = function (_ref) {
        var _classNames, _classNames2;

        var getPrefixCls = _ref.getPrefixCls;
        var _this$state = _this.state,
            value = _this$state.value,
            showDate = _this$state.showDate,
            open = _this$state.open;
        var props = (0, _omit["default"])(_this.props, ['onChange']);
        var customizePrefixCls = props.prefixCls,
            locale = props.locale,
            localeCode = props.localeCode,
            suffixIcon = props.suffixIcon;
        var prefixCls = getPrefixCls('calendar', customizePrefixCls); // To support old version react.
        // Have to add prefixCls on the instance.
        // https://github.com/facebook/react/issues/12397

        _this.prefixCls = prefixCls;
        var placeholder = 'placeholder' in props ? props.placeholder : locale.lang.placeholder;
        var disabledTime = props.showTime ? props.disabledTime : null;
        var calendarClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-time"), props.showTime), _defineProperty(_classNames, "".concat(prefixCls, "-month"), _MonthCalendar["default"] === TheCalendar), _classNames));

        if (value && localeCode) {
          value.locale(localeCode);
        }

        var pickerProps = {};
        var calendarProps = {};
        var pickerStyle = {};

        if (props.showTime) {
          calendarProps = {
            // fix https://github.com/ant-design/ant-design/issues/1902
            onSelect: _this.handleChange
          };
          pickerStyle.minWidth = 195;
        } else {
          pickerProps = {
            onChange: _this.handleChange
          };
        }

        if ('mode' in props) {
          calendarProps.mode = props.mode;
        }

        (0, _warning["default"])(!('onOK' in props), 'DatePicker', 'It should be `DatePicker[onOk]` or `MonthPicker[onOk]`, instead of `onOK`!');
        var calendar = /*#__PURE__*/React.createElement(TheCalendar, _extends({}, calendarProps, {
          disabledDate: props.disabledDate,
          disabledTime: disabledTime,
          locale: locale.lang,
          timePicker: props.timePicker,
          defaultValue: props.defaultPickerValue || (0, _interopDefault["default"])(moment)(),
          dateInputPlaceholder: placeholder,
          prefixCls: prefixCls,
          className: calendarClassName,
          onOk: props.onOk,
          dateRender: props.dateRender,
          format: props.format,
          showToday: props.showToday,
          monthCellContentRender: props.monthCellContentRender,
          renderFooter: _this.renderFooter,
          onPanelChange: props.onPanelChange,
          onChange: _this.handleCalendarChange,
          value: showDate
        }));
        var clearIcon = !props.disabled && props.allowClear && value ? /*#__PURE__*/React.createElement(_icon["default"], {
          type: "close-circle",
          className: "".concat(prefixCls, "-picker-clear"),
          onClick: _this.clearSelection,
          theme: "filled"
        }) : null;
        var inputIcon = suffixIcon && ( /*#__PURE__*/React.isValidElement(suffixIcon) ? /*#__PURE__*/React.cloneElement(suffixIcon, {
          className: (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, suffixIcon.props.className, suffixIcon.props.className), _defineProperty(_classNames2, "".concat(prefixCls, "-picker-icon"), true), _classNames2))
        }) : /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefixCls, "-picker-icon")
        }, suffixIcon)) || /*#__PURE__*/React.createElement(_icon["default"], {
          type: "calendar",
          className: "".concat(prefixCls, "-picker-icon")
        });
        var dataOrAriaProps = (0, _getDataOrAriaProps["default"])(props);

        var input = function input(_ref2) {
          var inputValue = _ref2.value;
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({
            ref: _this.saveInput,
            disabled: props.disabled,
            readOnly: true,
            value: (0, _utils.formatDate)(inputValue, props.format),
            placeholder: placeholder,
            className: props.pickerInputClass,
            tabIndex: props.tabIndex,
            name: props.name
          }, dataOrAriaProps)), clearIcon, inputIcon);
        };

        return /*#__PURE__*/React.createElement("span", {
          id: props.id,
          className: (0, _classnames["default"])(props.className, props.pickerClass),
          style: _extends(_extends({}, pickerStyle), props.style),
          onFocus: props.onFocus,
          onBlur: props.onBlur,
          onMouseEnter: props.onMouseEnter,
          onMouseLeave: props.onMouseLeave
        }, /*#__PURE__*/React.createElement(_Picker["default"], _extends({}, props, pickerProps, {
          calendar: calendar,
          value: value,
          prefixCls: "".concat(prefixCls, "-picker-container"),
          style: props.popupStyle,
          open: open,
          onOpenChange: _this.handleOpenChange
        }), input));
      };

      var value = props.value || props.defaultValue;

      if (value && !(0, _interopDefault["default"])(moment).isMoment(value)) {
        throw new Error('The value/defaultValue of DatePicker or MonthPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
      }

      _this.state = {
        value: value,
        showDate: value,
        open: false
      };
      return _this;
    }

    _createClass(CalenderWrapper, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(_, prevState) {
        if (!('open' in this.props) && prevState.open && !this.state.open) {
          this.focus();
        }
      }
    }, {
      key: "focus",
      value: function focus() {
        this.input.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.input.blur();
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderPicker);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(nextProps, prevState) {
        var state = {};
        var open = prevState.open;

        if ('open' in nextProps) {
          state.open = nextProps.open;
          open = nextProps.open || false;
        }

        if ('value' in nextProps) {
          state.value = nextProps.value;

          if (nextProps.value !== prevState.value || !open && nextProps.value !== prevState.showDate) {
            state.showDate = nextProps.value;
          }
        }

        return Object.keys(state).length > 0 ? state : null;
      }
    }]);

    return CalenderWrapper;
  }(React.Component);

  CalenderWrapper.defaultProps = {
    allowClear: true,
    showToday: true
  };
  (0, _reactLifecyclesCompat.polyfill)(CalenderWrapper);
  return CalenderWrapper;
}

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainedFunction;

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
  var args = [].slice.call(arguments, 0);

  if (args.length === 1) {
    return args[0];
  }

  return function chainedFunction() {
    for (var i = 0; i < args.length; i++) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  bottomLeft: {
    points: ['tl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  }
};

exports['default'] = placements;
module.exports = exports['default'];

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = wrapPicker;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(36);

var _Panel = _interopRequireDefault(__webpack_require__(505));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var moment = _interopRequireWildcard(__webpack_require__(2));

var _en_US = _interopRequireDefault(__webpack_require__(331));

var _interopDefault = _interopRequireDefault(__webpack_require__(182));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(113));

var _timePicker = __webpack_require__(957);

var _configProvider = __webpack_require__(39);

var _warning = _interopRequireDefault(__webpack_require__(69));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var DEFAULT_FORMAT = {
  date: 'YYYY-MM-DD',
  dateTime: 'YYYY-MM-DD HH:mm:ss',
  week: 'gggg-wo',
  month: 'YYYY-MM'
};
var LOCALE_FORMAT_MAPPING = {
  date: 'dateFormat',
  dateTime: 'dateTimeFormat',
  week: 'weekFormat',
  month: 'monthFormat'
};

function getColumns(_ref) {
  var showHour = _ref.showHour,
      showMinute = _ref.showMinute,
      showSecond = _ref.showSecond,
      use12Hours = _ref.use12Hours;
  var column = 0;

  if (showHour) {
    column += 1;
  }

  if (showMinute) {
    column += 1;
  }

  if (showSecond) {
    column += 1;
  }

  if (use12Hours) {
    column += 1;
  }

  return column;
}

function checkValidate(value, propName) {
  var values = Array.isArray(value) ? value : [value];
  values.forEach(function (val) {
    if (!val) return;
    (0, _warning["default"])(!(0, _interopDefault["default"])(moment).isMoment(val) || val.isValid(), 'DatePicker', "`".concat(propName, "` provides invalidate moment time. If you want to set empty value, use `null` instead."));
  });
}

function wrapPicker(Picker, pickerType) {
  var PickerWrapper = /*#__PURE__*/function (_React$Component) {
    _inherits(PickerWrapper, _React$Component);

    var _super = _createSuper(PickerWrapper);

    function PickerWrapper() {
      var _this;

      _classCallCheck(this, PickerWrapper);

      _this = _super.apply(this, arguments); // Since we need call `getDerivedStateFromProps` for check. Need leave an empty `state` here.

      _this.state = {};

      _this.savePicker = function (node) {
        _this.picker = node;
      };

      _this.getDefaultLocale = function () {
        var result = _extends(_extends({}, _en_US["default"]), _this.props.locale);

        result.lang = _extends(_extends({}, result.lang), (_this.props.locale || {}).lang);
        return result;
      };

      _this.handleOpenChange = function (open) {
        var onOpenChange = _this.props.onOpenChange;
        onOpenChange(open);
      };

      _this.handleFocus = function (e) {
        var onFocus = _this.props.onFocus;

        if (onFocus) {
          onFocus(e);
        }
      };

      _this.handleBlur = function (e) {
        var onBlur = _this.props.onBlur;

        if (onBlur) {
          onBlur(e);
        }
      };

      _this.handleMouseEnter = function (e) {
        var onMouseEnter = _this.props.onMouseEnter;

        if (onMouseEnter) {
          onMouseEnter(e);
        }
      };

      _this.handleMouseLeave = function (e) {
        var onMouseLeave = _this.props.onMouseLeave;

        if (onMouseLeave) {
          onMouseLeave(e);
        }
      };

      _this.renderPicker = function (locale, localeCode) {
        var _this$props = _this.props,
            format = _this$props.format,
            showTime = _this$props.showTime;
        var mergedPickerType = showTime ? "".concat(pickerType, "Time") : pickerType;
        var mergedFormat = format || locale[LOCALE_FORMAT_MAPPING[mergedPickerType]] || DEFAULT_FORMAT[mergedPickerType];
        return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
          var _classNames2;

          var getPrefixCls = _ref2.getPrefixCls,
              getContextPopupContainer = _ref2.getPopupContainer;
          var _this$props2 = _this.props,
              customizePrefixCls = _this$props2.prefixCls,
              customizeInputPrefixCls = _this$props2.inputPrefixCls,
              getCalendarContainer = _this$props2.getCalendarContainer,
              size = _this$props2.size,
              disabled = _this$props2.disabled;
          var getPopupContainer = getCalendarContainer || getContextPopupContainer;
          var prefixCls = getPrefixCls('calendar', customizePrefixCls);
          var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
          var pickerClass = (0, _classnames["default"])("".concat(prefixCls, "-picker"), _defineProperty({}, "".concat(prefixCls, "-picker-").concat(size), !!size));
          var pickerInputClass = (0, _classnames["default"])("".concat(prefixCls, "-picker-input"), inputPrefixCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(inputPrefixCls, "-lg"), size === 'large'), _defineProperty(_classNames2, "".concat(inputPrefixCls, "-sm"), size === 'small'), _defineProperty(_classNames2, "".concat(inputPrefixCls, "-disabled"), disabled), _classNames2));
          var timeFormat = showTime && showTime.format || 'HH:mm:ss';

          var rcTimePickerProps = _extends(_extends({}, (0, _timePicker.generateShowHourMinuteSecond)(timeFormat)), {
            format: timeFormat,
            use12Hours: showTime && showTime.use12Hours
          });

          var columns = getColumns(rcTimePickerProps);
          var timePickerCls = "".concat(prefixCls, "-time-picker-column-").concat(columns);
          var timePicker = showTime ? /*#__PURE__*/React.createElement(_Panel["default"], _extends({}, rcTimePickerProps, showTime, {
            prefixCls: "".concat(prefixCls, "-time-picker"),
            className: timePickerCls,
            placeholder: locale.timePickerLocale.placeholder,
            transitionName: "slide-up",
            onEsc: function onEsc() {}
          })) : null;
          return /*#__PURE__*/React.createElement(Picker, _extends({}, _this.props, {
            getCalendarContainer: getPopupContainer,
            format: mergedFormat,
            ref: _this.savePicker,
            pickerClass: pickerClass,
            pickerInputClass: pickerInputClass,
            locale: locale,
            localeCode: localeCode,
            timePicker: timePicker,
            onOpenChange: _this.handleOpenChange,
            onFocus: _this.handleFocus,
            onBlur: _this.handleBlur,
            onMouseEnter: _this.handleMouseEnter,
            onMouseLeave: _this.handleMouseLeave
          }));
        });
      };

      return _this;
    }

    _createClass(PickerWrapper, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$props3 = this.props,
            autoFocus = _this$props3.autoFocus,
            disabled = _this$props3.disabled;

        if (autoFocus && !disabled) {
          this.focus();
        }
      }
    }, {
      key: "focus",
      value: function focus() {
        this.picker.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.picker.blur();
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
          componentName: "DatePicker",
          defaultLocale: this.getDefaultLocale
        }, this.renderPicker);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref3) {
        var value = _ref3.value,
            defaultValue = _ref3.defaultValue;
        checkValidate(defaultValue, 'defaultValue');
        checkValidate(value, 'value');
        return {};
      }
    }]);

    return PickerWrapper;
  }(React.Component);

  PickerWrapper.defaultProps = {
    transitionName: 'slide-up',
    popupStyle: {},
    onChange: function onChange() {},
    onOk: function onOk() {},
    onOpenChange: function onOpenChange() {},
    locale: {}
  };
  (0, _reactLifecyclesCompat.polyfill)(PickerWrapper);
  return PickerWrapper;
}

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(19));

var _moment = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(22));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Header =
/*#__PURE__*/
function (_Component) {
  _inherits(Header, _Component);

  function Header(props) {
    var _this;

    _classCallCheck(this, Header);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Header).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (event) {
      var str = event.target.value;

      _this.setState({
        str: str
      });

      var _this$props = _this.props,
          format = _this$props.format,
          hourOptions = _this$props.hourOptions,
          minuteOptions = _this$props.minuteOptions,
          secondOptions = _this$props.secondOptions,
          disabledHours = _this$props.disabledHours,
          disabledMinutes = _this$props.disabledMinutes,
          disabledSeconds = _this$props.disabledSeconds,
          onChange = _this$props.onChange;

      if (str) {
        var originalValue = _this.props.value;

        var value = _this.getProtoValue().clone();

        var parsed = (0, _moment["default"])(str, format, true);

        if (!parsed.isValid()) {
          _this.setState({
            invalid: true
          });

          return;
        }

        value.hour(parsed.hour()).minute(parsed.minute()).second(parsed.second()); // if time value not allowed, response warning.

        if (hourOptions.indexOf(value.hour()) < 0 || minuteOptions.indexOf(value.minute()) < 0 || secondOptions.indexOf(value.second()) < 0) {
          _this.setState({
            invalid: true
          });

          return;
        } // if time value is disabled, response warning.


        var disabledHourOptions = disabledHours();
        var disabledMinuteOptions = disabledMinutes(value.hour());
        var disabledSecondOptions = disabledSeconds(value.hour(), value.minute());

        if (disabledHourOptions && disabledHourOptions.indexOf(value.hour()) >= 0 || disabledMinuteOptions && disabledMinuteOptions.indexOf(value.minute()) >= 0 || disabledSecondOptions && disabledSecondOptions.indexOf(value.second()) >= 0) {
          _this.setState({
            invalid: true
          });

          return;
        }

        if (originalValue) {
          if (originalValue.hour() !== value.hour() || originalValue.minute() !== value.minute() || originalValue.second() !== value.second()) {
            // keep other fields for rc-calendar
            var changedValue = originalValue.clone();
            changedValue.hour(value.hour());
            changedValue.minute(value.minute());
            changedValue.second(value.second());
            onChange(changedValue);
          }
        } else if (originalValue !== value) {
          onChange(value);
        }
      } else {
        onChange(null);
      }

      _this.setState({
        invalid: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
      var _this$props2 = _this.props,
          onEsc = _this$props2.onEsc,
          onKeyDown = _this$props2.onKeyDown;

      if (e.keyCode === 27) {
        onEsc();
      }

      onKeyDown(e);
    });

    var _value = props.value,
        _format = props.format;
    _this.state = {
      str: _value && _value.format(_format) || '',
      invalid: false
    };
    return _this;
  }

  _createClass(Header, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var focusOnOpen = this.props.focusOnOpen;

      if (focusOnOpen) {
        // Wait one frame for the panel to be positioned before focusing
        var requestAnimationFrame = window.requestAnimationFrame || window.setTimeout;
        requestAnimationFrame(function () {
          _this2.refInput.focus();

          _this2.refInput.select();
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          value = _this$props3.value,
          format = _this$props3.format;

      if (value !== prevProps.value) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          str: value && value.format(format) || '',
          invalid: false
        });
      }
    }
  }, {
    key: "getProtoValue",
    value: function getProtoValue() {
      var _this$props4 = this.props,
          value = _this$props4.value,
          defaultOpenValue = _this$props4.defaultOpenValue;
      return value || defaultOpenValue;
    }
  }, {
    key: "getInput",
    value: function getInput() {
      var _this3 = this;

      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          placeholder = _this$props5.placeholder,
          inputReadOnly = _this$props5.inputReadOnly;
      var _this$state = this.state,
          invalid = _this$state.invalid,
          str = _this$state.str;
      var invalidClass = invalid ? "".concat(prefixCls, "-input-invalid") : '';
      return _react["default"].createElement("input", {
        className: (0, _classnames["default"])("".concat(prefixCls, "-input"), invalidClass),
        ref: function ref(_ref) {
          _this3.refInput = _ref;
        },
        onKeyDown: this.onKeyDown,
        value: str,
        placeholder: placeholder,
        onChange: this.onInputChange,
        readOnly: !!inputReadOnly
      });
    }
  }, {
    key: "render",
    value: function render() {
      var prefixCls = this.props.prefixCls;
      return _react["default"].createElement("div", {
        className: "".concat(prefixCls, "-input-wrap")
      }, this.getInput());
    }
  }]);

  return Header;
}(_react.Component);

_defineProperty(Header, "propTypes", {
  format: _propTypes["default"].string,
  prefixCls: _propTypes["default"].string,
  disabledDate: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  clearText: _propTypes["default"].string,
  value: _propTypes["default"].object,
  inputReadOnly: _propTypes["default"].bool,
  hourOptions: _propTypes["default"].array,
  minuteOptions: _propTypes["default"].array,
  secondOptions: _propTypes["default"].array,
  disabledHours: _propTypes["default"].func,
  disabledMinutes: _propTypes["default"].func,
  disabledSeconds: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onEsc: _propTypes["default"].func,
  defaultOpenValue: _propTypes["default"].object,
  currentSelectPanel: _propTypes["default"].string,
  focusOnOpen: _propTypes["default"].bool,
  onKeyDown: _propTypes["default"].func,
  clearIcon: _propTypes["default"].node
});

_defineProperty(Header, "defaultProps", {
  inputReadOnly: false
});

var _default = Header;
exports["default"] = _default;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(19));

var _Select = _interopRequireDefault(__webpack_require__(955));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var formatOption = function formatOption(option, disabledOptions) {
  var value = "".concat(option);

  if (option < 10) {
    value = "0".concat(option);
  }

  var disabled = false;

  if (disabledOptions && disabledOptions.indexOf(option) >= 0) {
    disabled = true;
  }

  return {
    value: value,
    disabled: disabled
  };
};

var Combobox =
/*#__PURE__*/
function (_Component) {
  _inherits(Combobox, _Component);

  function Combobox() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Combobox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Combobox)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onItemChange", function (type, itemValue) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          defaultOpenValue = _this$props.defaultOpenValue,
          use12Hours = _this$props.use12Hours,
          propValue = _this$props.value,
          isAM = _this$props.isAM,
          onAmPmChange = _this$props.onAmPmChange;
      var value = (propValue || defaultOpenValue).clone();

      if (type === 'hour') {
        if (use12Hours) {
          if (isAM) {
            value.hour(+itemValue % 12);
          } else {
            value.hour(+itemValue % 12 + 12);
          }
        } else {
          value.hour(+itemValue);
        }
      } else if (type === 'minute') {
        value.minute(+itemValue);
      } else if (type === 'ampm') {
        var ampm = itemValue.toUpperCase();

        if (use12Hours) {
          if (ampm === 'PM' && value.hour() < 12) {
            value.hour(value.hour() % 12 + 12);
          }

          if (ampm === 'AM') {
            if (value.hour() >= 12) {
              value.hour(value.hour() - 12);
            }
          }
        }

        onAmPmChange(ampm);
      } else {
        value.second(+itemValue);
      }

      onChange(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnterSelectPanel", function (range) {
      var onCurrentSelectPanelChange = _this.props.onCurrentSelectPanelChange;
      onCurrentSelectPanelChange(range);
    });

    return _this;
  }

  _createClass(Combobox, [{
    key: "getHourSelect",
    value: function getHourSelect(hour) {
      var _this2 = this;

      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          hourOptions = _this$props2.hourOptions,
          disabledHours = _this$props2.disabledHours,
          showHour = _this$props2.showHour,
          use12Hours = _this$props2.use12Hours,
          onEsc = _this$props2.onEsc;

      if (!showHour) {
        return null;
      }

      var disabledOptions = disabledHours();
      var hourOptionsAdj;
      var hourAdj;

      if (use12Hours) {
        hourOptionsAdj = [12].concat(hourOptions.filter(function (h) {
          return h < 12 && h > 0;
        }));
        hourAdj = hour % 12 || 12;
      } else {
        hourOptionsAdj = hourOptions;
        hourAdj = hour;
      }

      return _react["default"].createElement(_Select["default"], {
        prefixCls: prefixCls,
        options: hourOptionsAdj.map(function (option) {
          return formatOption(option, disabledOptions);
        }),
        selectedIndex: hourOptionsAdj.indexOf(hourAdj),
        type: "hour",
        onSelect: this.onItemChange,
        onMouseEnter: function onMouseEnter() {
          return _this2.onEnterSelectPanel('hour');
        },
        onEsc: onEsc
      });
    }
  }, {
    key: "getMinuteSelect",
    value: function getMinuteSelect(minute) {
      var _this3 = this;

      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          minuteOptions = _this$props3.minuteOptions,
          disabledMinutes = _this$props3.disabledMinutes,
          defaultOpenValue = _this$props3.defaultOpenValue,
          showMinute = _this$props3.showMinute,
          propValue = _this$props3.value,
          onEsc = _this$props3.onEsc;

      if (!showMinute) {
        return null;
      }

      var value = propValue || defaultOpenValue;
      var disabledOptions = disabledMinutes(value.hour());
      return _react["default"].createElement(_Select["default"], {
        prefixCls: prefixCls,
        options: minuteOptions.map(function (option) {
          return formatOption(option, disabledOptions);
        }),
        selectedIndex: minuteOptions.indexOf(minute),
        type: "minute",
        onSelect: this.onItemChange,
        onMouseEnter: function onMouseEnter() {
          return _this3.onEnterSelectPanel('minute');
        },
        onEsc: onEsc
      });
    }
  }, {
    key: "getSecondSelect",
    value: function getSecondSelect(second) {
      var _this4 = this;

      var _this$props4 = this.props,
          prefixCls = _this$props4.prefixCls,
          secondOptions = _this$props4.secondOptions,
          disabledSeconds = _this$props4.disabledSeconds,
          showSecond = _this$props4.showSecond,
          defaultOpenValue = _this$props4.defaultOpenValue,
          propValue = _this$props4.value,
          onEsc = _this$props4.onEsc;

      if (!showSecond) {
        return null;
      }

      var value = propValue || defaultOpenValue;
      var disabledOptions = disabledSeconds(value.hour(), value.minute());
      return _react["default"].createElement(_Select["default"], {
        prefixCls: prefixCls,
        options: secondOptions.map(function (option) {
          return formatOption(option, disabledOptions);
        }),
        selectedIndex: secondOptions.indexOf(second),
        type: "second",
        onSelect: this.onItemChange,
        onMouseEnter: function onMouseEnter() {
          return _this4.onEnterSelectPanel('second');
        },
        onEsc: onEsc
      });
    }
  }, {
    key: "getAMPMSelect",
    value: function getAMPMSelect() {
      var _this5 = this;

      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          use12Hours = _this$props5.use12Hours,
          format = _this$props5.format,
          isAM = _this$props5.isAM,
          onEsc = _this$props5.onEsc;

      if (!use12Hours) {
        return null;
      }

      var AMPMOptions = ['am', 'pm'] // If format has A char, then we should uppercase AM/PM
      .map(function (c) {
        return format.match(/\sA/) ? c.toUpperCase() : c;
      }).map(function (c) {
        return {
          value: c
        };
      });
      var selected = isAM ? 0 : 1;
      return _react["default"].createElement(_Select["default"], {
        prefixCls: prefixCls,
        options: AMPMOptions,
        selectedIndex: selected,
        type: "ampm",
        onSelect: this.onItemChange,
        onMouseEnter: function onMouseEnter() {
          return _this5.onEnterSelectPanel('ampm');
        },
        onEsc: onEsc
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          prefixCls = _this$props6.prefixCls,
          defaultOpenValue = _this$props6.defaultOpenValue,
          propValue = _this$props6.value;
      var value = propValue || defaultOpenValue;
      return _react["default"].createElement("div", {
        className: "".concat(prefixCls, "-combobox")
      }, this.getHourSelect(value.hour()), this.getMinuteSelect(value.minute()), this.getSecondSelect(value.second()), this.getAMPMSelect(value.hour()));
    }
  }]);

  return Combobox;
}(_react.Component);

_defineProperty(Combobox, "propTypes", {
  format: _propTypes["default"].string,
  defaultOpenValue: _propTypes["default"].object,
  prefixCls: _propTypes["default"].string,
  value: _propTypes["default"].object,
  onChange: _propTypes["default"].func,
  onAmPmChange: _propTypes["default"].func,
  showHour: _propTypes["default"].bool,
  showMinute: _propTypes["default"].bool,
  showSecond: _propTypes["default"].bool,
  hourOptions: _propTypes["default"].array,
  minuteOptions: _propTypes["default"].array,
  secondOptions: _propTypes["default"].array,
  disabledHours: _propTypes["default"].func,
  disabledMinutes: _propTypes["default"].func,
  disabledSeconds: _propTypes["default"].func,
  onCurrentSelectPanelChange: _propTypes["default"].func,
  use12Hours: _propTypes["default"].bool,
  onEsc: _propTypes["default"].func,
  isAM: _propTypes["default"].bool
});

var _default = Combobox;
exports["default"] = _default;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(19));

var _reactDom = _interopRequireDefault(__webpack_require__(46));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _raf = _interopRequireDefault(__webpack_require__(956));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var scrollTo = function scrollTo(element, to, duration) {
  // jump to target if duration zero
  if (duration <= 0) {
    (0, _raf["default"])(function () {
      element.scrollTop = to;
    });
    return;
  }

  var difference = to - element.scrollTop;
  var perTick = difference / duration * 10;
  (0, _raf["default"])(function () {
    element.scrollTop += perTick;
    if (element.scrollTop === to) return;
    scrollTo(element, to, duration - 10);
  });
};

var Select =
/*#__PURE__*/
function (_Component) {
  _inherits(Select, _Component);

  function Select() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Select);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Select)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      active: false
    });

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (value) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          type = _this$props.type;
      onSelect(type, value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function (e) {
      var onMouseEnter = _this.props.onMouseEnter;

      _this.setState({
        active: true
      });

      onMouseEnter(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      _this.setState({
        active: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "saveList", function (node) {
      _this.list = node;
    });

    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // jump to selected option
      this.scrollToSelected(0);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var selectedIndex = this.props.selectedIndex; // smooth scroll to selected option

      if (prevProps.selectedIndex !== selectedIndex) {
        this.scrollToSelected(120);
      }
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var _this2 = this;

      var _this$props2 = this.props,
          options = _this$props2.options,
          selectedIndex = _this$props2.selectedIndex,
          prefixCls = _this$props2.prefixCls,
          onEsc = _this$props2.onEsc;
      return options.map(function (item, index) {
        var _classNames;

        var cls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-select-option-selected"), selectedIndex === index), _defineProperty(_classNames, "".concat(prefixCls, "-select-option-disabled"), item.disabled), _classNames));
        var onClick = item.disabled ? undefined : function () {
          _this2.onSelect(item.value);
        };

        var onKeyDown = function onKeyDown(e) {
          if (e.keyCode === 13) onClick();else if (e.keyCode === 27) onEsc();
        };

        return _react["default"].createElement("li", {
          role: "button",
          onClick: onClick,
          className: cls,
          key: index,
          disabled: item.disabled,
          tabIndex: "0",
          onKeyDown: onKeyDown
        }, item.value);
      });
    }
  }, {
    key: "scrollToSelected",
    value: function scrollToSelected(duration) {
      // move to selected item
      var selectedIndex = this.props.selectedIndex;

      var select = _reactDom["default"].findDOMNode(this);

      var list = _reactDom["default"].findDOMNode(this.list);

      if (!list) {
        return;
      }

      var index = selectedIndex;

      if (index < 0) {
        index = 0;
      }

      var topOption = list.children[index];
      var to = topOption.offsetTop;
      scrollTo(select, to, duration);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          options = _this$props3.options;
      var active = this.state.active;

      if (options.length === 0) {
        return null;
      }

      var cls = (0, _classnames["default"])("".concat(prefixCls, "-select"), _defineProperty({}, "".concat(prefixCls, "-select-active"), active));
      return _react["default"].createElement("div", {
        className: cls,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, _react["default"].createElement("ul", {
        ref: this.saveList
      }, this.getOptions()));
    }
  }]);

  return Select;
}(_react.Component);

_defineProperty(Select, "propTypes", {
  prefixCls: _propTypes["default"].string,
  options: _propTypes["default"].array,
  selectedIndex: _propTypes["default"].number,
  type: _propTypes["default"].string,
  onSelect: _propTypes["default"].func,
  onMouseEnter: _propTypes["default"].func,
  onEsc: _propTypes["default"].func
});

var _default = Select;
exports["default"] = _default;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(336)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateShowHourMinuteSecond = generateShowHourMinuteSecond;
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var moment = _interopRequireWildcard(__webpack_require__(2));

var _omit = _interopRequireDefault(__webpack_require__(71));

var _reactLifecyclesCompat = __webpack_require__(36);

var _TimePicker = _interopRequireDefault(__webpack_require__(958));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _warning = _interopRequireDefault(__webpack_require__(69));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(113));

var _configProvider = __webpack_require__(39);

var _en_US = _interopRequireDefault(__webpack_require__(332));

var _interopDefault = _interopRequireDefault(__webpack_require__(182));

var _icon = _interopRequireDefault(__webpack_require__(38));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

function generateShowHourMinuteSecond(format) {
  // Ref: http://momentjs.com/docs/#/parsing/string-format/
  return {
    showHour: format.indexOf('H') > -1 || format.indexOf('h') > -1 || format.indexOf('k') > -1,
    showMinute: format.indexOf('m') > -1,
    showSecond: format.indexOf('s') > -1
  };
}

var TimePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(TimePicker, _React$Component);

  var _super = _createSuper(TimePicker);

  function TimePicker(props) {
    var _this;

    _classCallCheck(this, TimePicker);

    _this = _super.call(this, props);

    _this.getDefaultLocale = function () {
      var defaultLocale = _extends(_extends({}, _en_US["default"]), _this.props.locale);

      return defaultLocale;
    };

    _this.handleOpenClose = function (_ref) {
      var open = _ref.open;
      var onOpenChange = _this.props.onOpenChange;

      if (onOpenChange) {
        onOpenChange(open);
      }
    };

    _this.saveTimePicker = function (timePickerRef) {
      _this.timePickerRef = timePickerRef;
    };

    _this.handleChange = function (value) {
      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }

      var _this$props = _this.props,
          onChange = _this$props.onChange,
          _this$props$format = _this$props.format,
          format = _this$props$format === void 0 ? 'HH:mm:ss' : _this$props$format;

      if (onChange) {
        onChange(value, value && value.format(format) || '');
      }
    };

    _this.renderTimePicker = function (locale) {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
        var getContextPopupContainer = _ref2.getPopupContainer,
            getPrefixCls = _ref2.getPrefixCls;

        var _a = _this.props,
            getPopupContainer = _a.getPopupContainer,
            customizePrefixCls = _a.prefixCls,
            className = _a.className,
            addon = _a.addon,
            placeholder = _a.placeholder,
            props = __rest(_a, ["getPopupContainer", "prefixCls", "className", "addon", "placeholder"]);

        var size = props.size;
        var pickerProps = (0, _omit["default"])(props, ['defaultValue', 'suffixIcon', 'allowEmpty', 'allowClear']);

        var format = _this.getDefaultFormat();

        var prefixCls = getPrefixCls('time-picker', customizePrefixCls);
        var pickerClassName = (0, _classnames["default"])(className, _defineProperty({}, "".concat(prefixCls, "-").concat(size), !!size));

        var pickerAddon = function pickerAddon(panel) {
          return addon ? /*#__PURE__*/React.createElement("div", {
            className: "".concat(prefixCls, "-panel-addon")
          }, addon(panel)) : null;
        };

        return /*#__PURE__*/React.createElement(_TimePicker["default"], _extends({}, generateShowHourMinuteSecond(format), pickerProps, {
          allowEmpty: _this.getAllowClear(),
          prefixCls: prefixCls,
          getPopupContainer: getPopupContainer || getContextPopupContainer,
          ref: _this.saveTimePicker,
          format: format,
          className: pickerClassName,
          value: _this.state.value,
          placeholder: placeholder === undefined ? locale.placeholder : placeholder,
          onChange: _this.handleChange,
          onOpen: _this.handleOpenClose,
          onClose: _this.handleOpenClose,
          addon: pickerAddon,
          inputIcon: _this.renderInputIcon(prefixCls),
          clearIcon: _this.renderClearIcon(prefixCls)
        }));
      });
    };

    var value = props.value || props.defaultValue;

    if (value && !(0, _interopDefault["default"])(moment).isMoment(value)) {
      throw new Error('The value/defaultValue of TimePicker must be a moment object after `antd@2.0`, ' + 'see: https://u.ant.design/time-picker-value');
    }

    _this.state = {
      value: value
    };
    (0, _warning["default"])(!('allowEmpty' in props), 'TimePicker', '`allowEmpty` is deprecated. Please use `allowClear` instead.');
    return _this;
  }

  _createClass(TimePicker, [{
    key: "getDefaultFormat",
    value: function getDefaultFormat() {
      var _this$props2 = this.props,
          format = _this$props2.format,
          use12Hours = _this$props2.use12Hours;

      if (format) {
        return format;
      }

      if (use12Hours) {
        return 'h:mm:ss a';
      }

      return 'HH:mm:ss';
    }
  }, {
    key: "getAllowClear",
    value: function getAllowClear() {
      var _this$props3 = this.props,
          allowClear = _this$props3.allowClear,
          allowEmpty = _this$props3.allowEmpty;

      if ('allowClear' in this.props) {
        return allowClear;
      }

      return allowEmpty;
    }
  }, {
    key: "focus",
    value: function focus() {
      this.timePickerRef.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.timePickerRef.blur();
    }
  }, {
    key: "renderInputIcon",
    value: function renderInputIcon(prefixCls) {
      var suffixIcon = this.props.suffixIcon;
      var clockIcon = suffixIcon && /*#__PURE__*/React.isValidElement(suffixIcon) && /*#__PURE__*/React.cloneElement(suffixIcon, {
        className: (0, _classnames["default"])(suffixIcon.props.className, "".concat(prefixCls, "-clock-icon"))
      }) || /*#__PURE__*/React.createElement(_icon["default"], {
        type: "clock-circle",
        className: "".concat(prefixCls, "-clock-icon")
      });
      return /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-icon")
      }, clockIcon);
    }
  }, {
    key: "renderClearIcon",
    value: function renderClearIcon(prefixCls) {
      var clearIcon = this.props.clearIcon;
      var clearIconPrefixCls = "".concat(prefixCls, "-clear");

      if (clearIcon && /*#__PURE__*/React.isValidElement(clearIcon)) {
        return /*#__PURE__*/React.cloneElement(clearIcon, {
          className: (0, _classnames["default"])(clearIcon.props.className, clearIconPrefixCls)
        });
      }

      return /*#__PURE__*/React.createElement(_icon["default"], {
        type: "close-circle",
        className: clearIconPrefixCls,
        theme: "filled"
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
        componentName: "TimePicker",
        defaultLocale: this.getDefaultLocale()
      }, this.renderTimePicker);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: nextProps.value
        };
      }

      return null;
    }
  }]);

  return TimePicker;
}(React.Component);

TimePicker.defaultProps = {
  align: {
    offset: [0, -2]
  },
  disabledHours: undefined,
  disabledMinutes: undefined,
  disabledSeconds: undefined,
  hideDisabledOptions: false,
  placement: 'bottomLeft',
  transitionName: 'slide-up',
  focusOnOpen: true
};
(0, _reactLifecyclesCompat.polyfill)(TimePicker);
var _default = TimePicker;
exports["default"] = _default;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(19));

var _rcTrigger = _interopRequireDefault(__webpack_require__(192));

var _moment = _interopRequireDefault(__webpack_require__(2));

var _reactLifecyclesCompat = __webpack_require__(36);

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _Panel = _interopRequireDefault(__webpack_require__(505));

var _placements = _interopRequireDefault(__webpack_require__(959));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function noop() {}

function refFn(field, component) {
  this[field] = component;
}

var Picker =
/*#__PURE__*/
function (_Component) {
  _inherits(Picker, _Component);

  function Picker(props) {
    var _this;

    _classCallCheck(this, Picker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Picker).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onPanelChange", function (value) {
      _this.setValue(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onAmPmChange", function (ampm) {
      var onAmPmChange = _this.props.onAmPmChange;
      onAmPmChange(ampm);
    });

    _defineProperty(_assertThisInitialized(_this), "onClear", function (event) {
      event.stopPropagation();

      _this.setValue(null);

      _this.setOpen(false);
    });

    _defineProperty(_assertThisInitialized(_this), "onVisibleChange", function (open) {
      _this.setOpen(open);
    });

    _defineProperty(_assertThisInitialized(_this), "onEsc", function () {
      _this.setOpen(false);

      _this.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
      if (e.keyCode === 40) {
        _this.setOpen(true);
      }
    });

    _this.saveInputRef = refFn.bind(_assertThisInitialized(_this), 'picker');
    _this.savePanelRef = refFn.bind(_assertThisInitialized(_this), 'panelInstance');

    var defaultOpen = props.defaultOpen,
        defaultValue = props.defaultValue,
        _props$open = props.open,
        _open = _props$open === void 0 ? defaultOpen : _props$open,
        _props$value = props.value,
        _value = _props$value === void 0 ? defaultValue : _props$value;

    _this.state = {
      open: _open,
      value: _value
    };
    return _this;
  }

  _createClass(Picker, [{
    key: "setValue",
    value: function setValue(value) {
      var onChange = this.props.onChange;

      if (!('value' in this.props)) {
        this.setState({
          value: value
        });
      }

      onChange(value);
    }
  }, {
    key: "getFormat",
    value: function getFormat() {
      var _this$props = this.props,
          format = _this$props.format,
          showHour = _this$props.showHour,
          showMinute = _this$props.showMinute,
          showSecond = _this$props.showSecond,
          use12Hours = _this$props.use12Hours;

      if (format) {
        return format;
      }

      if (use12Hours) {
        var fmtString = [showHour ? 'h' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
          return !!item;
        }).join(':');
        return fmtString.concat(' a');
      }

      return [showHour ? 'HH' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
        return !!item;
      }).join(':');
    }
  }, {
    key: "getPanelElement",
    value: function getPanelElement() {
      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          placeholder = _this$props2.placeholder,
          disabledHours = _this$props2.disabledHours,
          disabledMinutes = _this$props2.disabledMinutes,
          disabledSeconds = _this$props2.disabledSeconds,
          hideDisabledOptions = _this$props2.hideDisabledOptions,
          inputReadOnly = _this$props2.inputReadOnly,
          showHour = _this$props2.showHour,
          showMinute = _this$props2.showMinute,
          showSecond = _this$props2.showSecond,
          defaultOpenValue = _this$props2.defaultOpenValue,
          clearText = _this$props2.clearText,
          addon = _this$props2.addon,
          use12Hours = _this$props2.use12Hours,
          focusOnOpen = _this$props2.focusOnOpen,
          onKeyDown = _this$props2.onKeyDown,
          hourStep = _this$props2.hourStep,
          minuteStep = _this$props2.minuteStep,
          secondStep = _this$props2.secondStep,
          clearIcon = _this$props2.clearIcon;
      var value = this.state.value;
      return _react["default"].createElement(_Panel["default"], {
        clearText: clearText,
        prefixCls: "".concat(prefixCls, "-panel"),
        ref: this.savePanelRef,
        value: value,
        inputReadOnly: inputReadOnly,
        onChange: this.onPanelChange,
        onAmPmChange: this.onAmPmChange,
        defaultOpenValue: defaultOpenValue,
        showHour: showHour,
        showMinute: showMinute,
        showSecond: showSecond,
        onEsc: this.onEsc,
        format: this.getFormat(),
        placeholder: placeholder,
        disabledHours: disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds,
        hideDisabledOptions: hideDisabledOptions,
        use12Hours: use12Hours,
        hourStep: hourStep,
        minuteStep: minuteStep,
        secondStep: secondStep,
        addon: addon,
        focusOnOpen: focusOnOpen,
        onKeyDown: onKeyDown,
        clearIcon: clearIcon
      });
    }
  }, {
    key: "getPopupClassName",
    value: function getPopupClassName() {
      var _this$props3 = this.props,
          showHour = _this$props3.showHour,
          showMinute = _this$props3.showMinute,
          showSecond = _this$props3.showSecond,
          use12Hours = _this$props3.use12Hours,
          prefixCls = _this$props3.prefixCls,
          popupClassName = _this$props3.popupClassName;
      var selectColumnCount = 0;

      if (showHour) {
        selectColumnCount += 1;
      }

      if (showMinute) {
        selectColumnCount += 1;
      }

      if (showSecond) {
        selectColumnCount += 1;
      }

      if (use12Hours) {
        selectColumnCount += 1;
      } // Keep it for old compatibility


      return (0, _classnames["default"])(popupClassName, _defineProperty({}, "".concat(prefixCls, "-panel-narrow"), (!showHour || !showMinute || !showSecond) && !use12Hours), "".concat(prefixCls, "-panel-column-").concat(selectColumnCount));
    }
  }, {
    key: "setOpen",
    value: function setOpen(open) {
      var _this$props4 = this.props,
          onOpen = _this$props4.onOpen,
          onClose = _this$props4.onClose;
      var currentOpen = this.state.open;

      if (currentOpen !== open) {
        if (!('open' in this.props)) {
          this.setState({
            open: open
          });
        }

        if (open) {
          onOpen({
            open: open
          });
        } else {
          onClose({
            open: open
          });
        }
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.picker.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.picker.blur();
    }
  }, {
    key: "renderClearButton",
    value: function renderClearButton() {
      var _this2 = this;

      var value = this.state.value;
      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          allowEmpty = _this$props5.allowEmpty,
          clearIcon = _this$props5.clearIcon,
          clearText = _this$props5.clearText,
          disabled = _this$props5.disabled;

      if (!allowEmpty || !value || disabled) {
        return null;
      }

      if (_react["default"].isValidElement(clearIcon)) {
        var _ref = clearIcon.props || {},
            _onClick = _ref.onClick;

        return _react["default"].cloneElement(clearIcon, {
          onClick: function onClick() {
            if (_onClick) _onClick.apply(void 0, arguments);

            _this2.onClear.apply(_this2, arguments);
          }
        });
      }

      return _react["default"].createElement("a", {
        role: "button",
        className: "".concat(prefixCls, "-clear"),
        title: clearText,
        onClick: this.onClear,
        tabIndex: 0
      }, clearIcon || _react["default"].createElement("i", {
        className: "".concat(prefixCls, "-clear-icon")
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          prefixCls = _this$props6.prefixCls,
          placeholder = _this$props6.placeholder,
          placement = _this$props6.placement,
          align = _this$props6.align,
          id = _this$props6.id,
          disabled = _this$props6.disabled,
          transitionName = _this$props6.transitionName,
          style = _this$props6.style,
          className = _this$props6.className,
          getPopupContainer = _this$props6.getPopupContainer,
          name = _this$props6.name,
          autoComplete = _this$props6.autoComplete,
          onFocus = _this$props6.onFocus,
          onBlur = _this$props6.onBlur,
          autoFocus = _this$props6.autoFocus,
          inputReadOnly = _this$props6.inputReadOnly,
          inputIcon = _this$props6.inputIcon,
          popupStyle = _this$props6.popupStyle;
      var _this$state = this.state,
          open = _this$state.open,
          value = _this$state.value;
      var popupClassName = this.getPopupClassName();
      return _react["default"].createElement(_rcTrigger["default"], {
        prefixCls: "".concat(prefixCls, "-panel"),
        popupClassName: popupClassName,
        popupStyle: popupStyle,
        popup: this.getPanelElement(),
        popupAlign: align,
        builtinPlacements: _placements["default"],
        popupPlacement: placement,
        action: disabled ? [] : ['click'],
        destroyPopupOnHide: true,
        getPopupContainer: getPopupContainer,
        popupTransitionName: transitionName,
        popupVisible: open,
        onPopupVisibleChange: this.onVisibleChange
      }, _react["default"].createElement("span", {
        className: (0, _classnames["default"])(prefixCls, className),
        style: style
      }, _react["default"].createElement("input", {
        className: "".concat(prefixCls, "-input"),
        ref: this.saveInputRef,
        type: "text",
        placeholder: placeholder,
        name: name,
        onKeyDown: this.onKeyDown,
        disabled: disabled,
        value: value && value.format(this.getFormat()) || '',
        autoComplete: autoComplete,
        onFocus: onFocus,
        onBlur: onBlur,
        autoFocus: autoFocus,
        onChange: noop,
        readOnly: !!inputReadOnly,
        id: id
      }), inputIcon || _react["default"].createElement("span", {
        className: "".concat(prefixCls, "-icon")
      }), this.renderClearButton()));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var newState = {};

      if ('value' in props) {
        newState.value = props.value;
      }

      if (props.open !== undefined) {
        newState.open = props.open;
      }

      return Object.keys(newState).length > 0 ? _objectSpread({}, state, {}, newState) : null;
    }
  }]);

  return Picker;
}(_react.Component);

_defineProperty(Picker, "propTypes", {
  prefixCls: _propTypes["default"].string,
  clearText: _propTypes["default"].string,
  value: _propTypes["default"].object,
  defaultOpenValue: _propTypes["default"].object,
  inputReadOnly: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  allowEmpty: _propTypes["default"].bool,
  defaultValue: _propTypes["default"].object,
  open: _propTypes["default"].bool,
  defaultOpen: _propTypes["default"].bool,
  align: _propTypes["default"].object,
  placement: _propTypes["default"].any,
  transitionName: _propTypes["default"].string,
  getPopupContainer: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  format: _propTypes["default"].string,
  showHour: _propTypes["default"].bool,
  showMinute: _propTypes["default"].bool,
  showSecond: _propTypes["default"].bool,
  style: _propTypes["default"].object,
  className: _propTypes["default"].string,
  popupClassName: _propTypes["default"].string,
  popupStyle: _propTypes["default"].object,
  disabledHours: _propTypes["default"].func,
  disabledMinutes: _propTypes["default"].func,
  disabledSeconds: _propTypes["default"].func,
  hideDisabledOptions: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onAmPmChange: _propTypes["default"].func,
  onOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  addon: _propTypes["default"].func,
  name: _propTypes["default"].string,
  autoComplete: _propTypes["default"].string,
  use12Hours: _propTypes["default"].bool,
  hourStep: _propTypes["default"].number,
  minuteStep: _propTypes["default"].number,
  secondStep: _propTypes["default"].number,
  focusOnOpen: _propTypes["default"].bool,
  onKeyDown: _propTypes["default"].func,
  autoFocus: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  inputIcon: _propTypes["default"].node,
  clearIcon: _propTypes["default"].node
});

_defineProperty(Picker, "defaultProps", {
  clearText: 'clear',
  prefixCls: 'rc-time-picker',
  defaultOpen: false,
  inputReadOnly: false,
  style: {},
  className: '',
  popupClassName: '',
  popupStyle: {},
  align: {},
  defaultOpenValue: (0, _moment["default"])(),
  allowEmpty: true,
  showHour: true,
  showMinute: true,
  showSecond: true,
  disabledHours: noop,
  disabledMinutes: noop,
  disabledSeconds: noop,
  hideDisabledOptions: false,
  placement: 'bottomLeft',
  onChange: noop,
  onAmPmChange: noop,
  onOpen: noop,
  onClose: noop,
  onFocus: noop,
  onBlur: noop,
  addon: noop,
  use12Hours: false,
  focusOnOpen: false,
  onKeyDown: noop
});

(0, _reactLifecyclesCompat.polyfill)(Picker);
var _default = Picker;
exports["default"] = _default;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset = [0, 0];
var placements = {
  bottomLeft: {
    points: ['tl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  }
};
var _default = placements;
exports["default"] = _default;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var moment = _interopRequireWildcard(__webpack_require__(2));

var _reactLifecyclesCompat = __webpack_require__(36);

var _RangeCalendar = _interopRequireDefault(__webpack_require__(961));

var _Picker = _interopRequireDefault(__webpack_require__(347));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _shallowequal = _interopRequireDefault(__webpack_require__(89));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _tag = _interopRequireDefault(__webpack_require__(967));

var _configProvider = __webpack_require__(39);

var _warning = _interopRequireDefault(__webpack_require__(69));

var _interopDefault = _interopRequireDefault(__webpack_require__(182));

var _utils = __webpack_require__(504);

var _InputIcon = _interopRequireDefault(__webpack_require__(507));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function getShowDateFromValue(value, mode) {
  var _value = _slicedToArray(value, 2),
      start = _value[0],
      end = _value[1]; // value could be an empty array, then we should not reset showDate


  if (!start && !end) {
    return;
  }

  if (mode && mode[0] === 'month') {
    return [start, end];
  }

  var newEnd = end && end.isSame(start, 'month') ? end.clone().add(1, 'month') : end;
  return [start, newEnd];
}

function pickerValueAdapter(value) {
  if (!value) {
    return;
  }

  if (Array.isArray(value)) {
    return value;
  }

  return [value, value.clone().add(1, 'month')];
}

function isEmptyArray(arr) {
  if (Array.isArray(arr)) {
    return arr.length === 0 || arr.every(function (i) {
      return !i;
    });
  }

  return false;
}

function fixLocale(value, localeCode) {
  if (!localeCode) {
    return;
  }

  if (!value || value.length === 0) {
    return;
  }

  var _value2 = _slicedToArray(value, 2),
      start = _value2[0],
      end = _value2[1];

  if (start) {
    start.locale(localeCode);
  }

  if (end) {
    end.locale(localeCode);
  }
}

var RangePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(RangePicker, _React$Component);

  var _super = _createSuper(RangePicker);

  function RangePicker(props) {
    var _this;

    _classCallCheck(this, RangePicker);

    _this = _super.call(this, props);

    _this.savePicker = function (node) {
      _this.picker = node;
    };

    _this.clearSelection = function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        value: []
      });

      _this.handleChange([]);
    };

    _this.clearHoverValue = function () {
      return _this.setState({
        hoverValue: []
      });
    };

    _this.handleChange = function (value) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      if (!('value' in props)) {
        _this.setState(function (_ref) {
          var showDate = _ref.showDate;
          return {
            value: value,
            showDate: getShowDateFromValue(value) || showDate
          };
        });
      }

      if (value[0] && value[1] && value[0].diff(value[1]) > 0) {
        value[1] = undefined;
      }

      var _value3 = _slicedToArray(value, 2),
          start = _value3[0],
          end = _value3[1];

      if (typeof props.onChange === 'function') {
        props.onChange(value, [(0, _utils.formatDate)(start, props.format), (0, _utils.formatDate)(end, props.format)]);
      }
    };

    _this.handleOpenChange = function (open) {
      if (!('open' in _this.props)) {
        _this.setState({
          open: open
        });
      }

      if (open === false) {
        _this.clearHoverValue();
      }

      var onOpenChange = _this.props.onOpenChange;

      if (onOpenChange) {
        onOpenChange(open);
      }
    };

    _this.handleShowDateChange = function (showDate) {
      return _this.setState({
        showDate: showDate
      });
    };

    _this.handleHoverChange = function (hoverValue) {
      return _this.setState({
        hoverValue: hoverValue
      });
    };

    _this.handleRangeMouseLeave = function () {
      if (_this.state.open) {
        _this.clearHoverValue();
      }
    };

    _this.handleCalendarInputSelect = function (value) {
      var _value4 = _slicedToArray(value, 1),
          start = _value4[0];

      if (!start) {
        return;
      }

      _this.setState(function (_ref2) {
        var showDate = _ref2.showDate;
        return {
          value: value,
          showDate: getShowDateFromValue(value) || showDate
        };
      });
    };

    _this.handleRangeClick = function (value) {
      if (typeof value === 'function') {
        value = value();
      }

      _this.setValue(value, true);

      var _this$props = _this.props,
          onOk = _this$props.onOk,
          onOpenChange = _this$props.onOpenChange;

      if (onOk) {
        onOk(value);
      }

      if (onOpenChange) {
        onOpenChange(false);
      }
    };

    _this.renderFooter = function () {
      var _this$props2 = _this.props,
          ranges = _this$props2.ranges,
          renderExtraFooter = _this$props2.renderExtraFooter;

      var _assertThisInitialize2 = _assertThisInitialized(_this),
          prefixCls = _assertThisInitialize2.prefixCls,
          tagPrefixCls = _assertThisInitialize2.tagPrefixCls;

      if (!ranges && !renderExtraFooter) {
        return null;
      }

      var customFooter = renderExtraFooter ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-footer-extra"),
        key: "extra"
      }, renderExtraFooter()) : null;
      var operations = ranges && Object.keys(ranges).map(function (range) {
        var value = ranges[range];
        var hoverValue = typeof value === 'function' ? value.call(_assertThisInitialized(_this)) : value;
        return /*#__PURE__*/React.createElement(_tag["default"], {
          key: range,
          prefixCls: tagPrefixCls,
          color: "blue",
          onClick: function onClick() {
            return _this.handleRangeClick(value);
          },
          onMouseEnter: function onMouseEnter() {
            return _this.setState({
              hoverValue: hoverValue
            });
          },
          onMouseLeave: _this.handleRangeMouseLeave
        }, range);
      });
      var rangeNode = operations && operations.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-footer-extra ").concat(prefixCls, "-range-quick-selector"),
        key: "range"
      }, operations) : null;
      return [rangeNode, customFooter];
    };

    _this.renderRangePicker = function (_ref3) {
      var _classNames;

      var getPrefixCls = _ref3.getPrefixCls;

      var _assertThisInitialize3 = _assertThisInitialized(_this),
          state = _assertThisInitialize3.state,
          props = _assertThisInitialize3.props;

      var value = state.value,
          showDate = state.showDate,
          hoverValue = state.hoverValue,
          open = state.open;
      var customizePrefixCls = props.prefixCls,
          customizeTagPrefixCls = props.tagPrefixCls,
          popupStyle = props.popupStyle,
          style = props.style,
          disabledDate = props.disabledDate,
          disabledTime = props.disabledTime,
          showTime = props.showTime,
          showToday = props.showToday,
          ranges = props.ranges,
          onOk = props.onOk,
          locale = props.locale,
          localeCode = props.localeCode,
          format = props.format,
          dateRender = props.dateRender,
          onCalendarChange = props.onCalendarChange,
          suffixIcon = props.suffixIcon,
          separator = props.separator;
      var prefixCls = getPrefixCls('calendar', customizePrefixCls);
      var tagPrefixCls = getPrefixCls('tag', customizeTagPrefixCls); // To support old version react.
      // Have to add prefixCls on the instance.
      // https://github.com/facebook/react/issues/12397

      _this.prefixCls = prefixCls;
      _this.tagPrefixCls = tagPrefixCls;
      fixLocale(value, localeCode);
      fixLocale(showDate, localeCode);
      (0, _warning["default"])(!('onOK' in props), 'RangePicker', 'It should be `RangePicker[onOk]`, instead of `onOK`!');
      var calendarClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-time"), showTime), _defineProperty(_classNames, "".concat(prefixCls, "-range-with-ranges"), ranges), _classNames)); // 需要选择时间时，点击 ok 时才触发 onChange

      var pickerChangeHandler = {
        onChange: _this.handleChange
      };
      var calendarProps = {
        onOk: _this.handleChange
      };

      if (props.timePicker) {
        pickerChangeHandler.onChange = function (changedValue) {
          return _this.handleChange(changedValue);
        };
      } else {
        calendarProps = {};
      }

      if ('mode' in props) {
        calendarProps.mode = props.mode;
      }

      var startPlaceholder = Array.isArray(props.placeholder) ? props.placeholder[0] : locale.lang.rangePlaceholder[0];
      var endPlaceholder = Array.isArray(props.placeholder) ? props.placeholder[1] : locale.lang.rangePlaceholder[1];
      var calendar = /*#__PURE__*/React.createElement(_RangeCalendar["default"], _extends({}, calendarProps, {
        seperator: separator,
        onChange: onCalendarChange,
        format: format,
        prefixCls: prefixCls,
        className: calendarClassName,
        renderFooter: _this.renderFooter,
        timePicker: props.timePicker,
        disabledDate: disabledDate,
        disabledTime: disabledTime,
        dateInputPlaceholder: [startPlaceholder, endPlaceholder],
        locale: locale.lang,
        onOk: onOk,
        dateRender: dateRender,
        value: showDate,
        onValueChange: _this.handleShowDateChange,
        hoverValue: hoverValue,
        onHoverChange: _this.handleHoverChange,
        onPanelChange: props.onPanelChange,
        showToday: showToday,
        onInputSelect: _this.handleCalendarInputSelect
      })); // default width for showTime

      var pickerStyle = {};

      if (props.showTime) {
        pickerStyle.width = style && style.width || 350;
      }

      var _value5 = _slicedToArray(value, 2),
          startValue = _value5[0],
          endValue = _value5[1];

      var clearIcon = !props.disabled && props.allowClear && value && (startValue || endValue) ? /*#__PURE__*/React.createElement(_icon["default"], {
        type: "close-circle",
        className: "".concat(prefixCls, "-picker-clear"),
        onClick: _this.clearSelection,
        theme: "filled"
      }) : null;
      var inputIcon = /*#__PURE__*/React.createElement(_InputIcon["default"], {
        suffixIcon: suffixIcon,
        prefixCls: prefixCls
      });

      var input = function input(_ref4) {
        var inputValue = _ref4.value;

        var _inputValue = _slicedToArray(inputValue, 2),
            start = _inputValue[0],
            end = _inputValue[1];

        return /*#__PURE__*/React.createElement("span", {
          className: props.pickerInputClass
        }, /*#__PURE__*/React.createElement("input", {
          disabled: props.disabled,
          readOnly: true,
          value: (0, _utils.formatDate)(start, props.format),
          placeholder: startPlaceholder,
          className: "".concat(prefixCls, "-range-picker-input"),
          tabIndex: -1
        }), /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefixCls, "-range-picker-separator")
        }, " ", separator, " "), /*#__PURE__*/React.createElement("input", {
          disabled: props.disabled,
          readOnly: true,
          value: (0, _utils.formatDate)(end, props.format),
          placeholder: endPlaceholder,
          className: "".concat(prefixCls, "-range-picker-input"),
          tabIndex: -1
        }), clearIcon, inputIcon);
      };

      return /*#__PURE__*/React.createElement("span", {
        ref: _this.savePicker,
        id: typeof props.id === 'number' ? props.id.toString() : props.id,
        className: (0, _classnames["default"])(props.className, props.pickerClass),
        style: _extends(_extends({}, style), pickerStyle),
        tabIndex: props.disabled ? -1 : 0,
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave
      }, /*#__PURE__*/React.createElement(_Picker["default"], _extends({}, props, pickerChangeHandler, {
        calendar: calendar,
        value: value,
        open: open,
        onOpenChange: _this.handleOpenChange,
        prefixCls: "".concat(prefixCls, "-picker-container"),
        style: popupStyle
      }), input));
    };

    var value = props.value || props.defaultValue || [];

    var _value6 = _slicedToArray(value, 2),
        start = _value6[0],
        end = _value6[1];

    if (start && !(0, _interopDefault["default"])(moment).isMoment(start) || end && !(0, _interopDefault["default"])(moment).isMoment(end)) {
      throw new Error('The value/defaultValue of RangePicker must be a moment object array after `antd@2.0`, ' + 'see: https://u.ant.design/date-picker-value');
    }

    var pickerValue = !value || isEmptyArray(value) ? props.defaultPickerValue : value;
    _this.state = {
      value: value,
      showDate: pickerValueAdapter(pickerValue || (0, _interopDefault["default"])(moment)()),
      open: props.open,
      hoverValue: []
    };
    return _this;
  }

  _createClass(RangePicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      if (!('open' in this.props) && prevState.open && !this.state.open) {
        this.focus();
      }
    }
  }, {
    key: "setValue",
    value: function setValue(value, hidePanel) {
      this.handleChange(value);

      if ((hidePanel || !this.props.showTime) && !('open' in this.props)) {
        this.setState({
          open: false
        });
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.picker.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.picker.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRangePicker);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var state = null;

      if ('value' in nextProps) {
        var value = nextProps.value || [];
        state = {
          value: value
        };

        if (!(0, _shallowequal["default"])(nextProps.value, prevState.value)) {
          state = _extends(_extends({}, state), {
            showDate: getShowDateFromValue(value, nextProps.mode) || prevState.showDate
          });
        }
      }

      if ('open' in nextProps && prevState.open !== nextProps.open) {
        state = _extends(_extends({}, state), {
          open: nextProps.open
        });
      }

      return state;
    }
  }]);

  return RangePicker;
}(React.Component);

RangePicker.defaultProps = {
  allowClear: true,
  showToday: false,
  separator: '~'
};
(0, _reactLifecyclesCompat.polyfill)(RangePicker);
var _default = RangePicker;
exports["default"] = _default;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(48);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(31);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(32);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _classnames2 = __webpack_require__(22);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactLifecyclesCompat = __webpack_require__(36);

var _KeyCode = __webpack_require__(194);

var _KeyCode2 = _interopRequireDefault(_KeyCode);

var _CalendarPart = __webpack_require__(962);

var _CalendarPart2 = _interopRequireDefault(_CalendarPart);

var _TodayButton = __webpack_require__(501);

var _TodayButton2 = _interopRequireDefault(_TodayButton);

var _OkButton = __webpack_require__(502);

var _OkButton2 = _interopRequireDefault(_OkButton);

var _TimePickerButton = __webpack_require__(503);

var _TimePickerButton2 = _interopRequireDefault(_TimePickerButton);

var _CommonMixin = __webpack_require__(445);

var _util = __webpack_require__(153);

var _toTime = __webpack_require__(966);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

function isEmptyArray(arr) {
  return Array.isArray(arr) && (arr.length === 0 || arr.every(function (i) {
    return !i;
  }));
}

function isArraysEqual(a, b) {
  if (a === b) return true;
  if (a === null || typeof a === 'undefined' || b === null || typeof b === 'undefined') {
    return false;
  }
  if (a.length !== b.length) return false;

  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}

function getValueFromSelectedValue(selectedValue) {
  var start = selectedValue[0],
      end = selectedValue[1];

  if (end && (start === undefined || start === null)) {
    start = end.clone().subtract(1, 'month');
  }

  if (start && (end === undefined || end === null)) {
    end = start.clone().add(1, 'month');
  }
  return [start, end];
}

function normalizeAnchor(props, init) {
  var selectedValue = props.selectedValue || init && props.defaultSelectedValue;
  var value = props.value || init && props.defaultValue;
  var normalizedValue = value ? getValueFromSelectedValue(value) : getValueFromSelectedValue(selectedValue);
  return !isEmptyArray(normalizedValue) ? normalizedValue : init && [(0, _moment2['default'])(), (0, _moment2['default'])().add(1, 'months')];
}

function generateOptions(length, extraOptionGen) {
  var arr = extraOptionGen ? extraOptionGen().concat() : [];
  for (var value = 0; value < length; value++) {
    if (arr.indexOf(value) === -1) {
      arr.push(value);
    }
  }
  return arr;
}

function onInputSelect(direction, value, cause) {
  if (!value) {
    return;
  }
  var originalValue = this.state.selectedValue;
  var selectedValue = originalValue.concat();
  var index = direction === 'left' ? 0 : 1;
  selectedValue[index] = value;
  if (selectedValue[0] && this.compare(selectedValue[0], selectedValue[1]) > 0) {
    selectedValue[1 - index] = this.state.showTimePicker ? selectedValue[index] : undefined;
  }
  this.props.onInputSelect(selectedValue);
  this.fireSelectValueChange(selectedValue, null, cause || { source: 'dateInput' });
}

var RangeCalendar = function (_React$Component) {
  (0, _inherits3['default'])(RangeCalendar, _React$Component);

  function RangeCalendar(props) {
    (0, _classCallCheck3['default'])(this, RangeCalendar);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var selectedValue = props.selectedValue || props.defaultSelectedValue;
    var value = normalizeAnchor(props, 1);
    _this.state = {
      selectedValue: selectedValue,
      prevSelectedValue: selectedValue,
      firstSelectedValue: null,
      hoverValue: props.hoverValue || [],
      value: value,
      showTimePicker: false,
      mode: props.mode || ['date', 'date'],
      panelTriggerSource: '' // Trigger by which picker panel: 'start' & 'end'
    };
    return _this;
  }

  RangeCalendar.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, state) {
    var newState = {};
    if ('value' in nextProps) {
      newState.value = normalizeAnchor(nextProps, 0);
    }
    if ('hoverValue' in nextProps && !isArraysEqual(state.hoverValue, nextProps.hoverValue)) {
      newState.hoverValue = nextProps.hoverValue;
    }
    if ('selectedValue' in nextProps) {
      newState.selectedValue = nextProps.selectedValue;
      newState.prevSelectedValue = nextProps.selectedValue;
    }
    if ('mode' in nextProps && !isArraysEqual(state.mode, nextProps.mode)) {
      newState.mode = nextProps.mode;
    }
    return newState;
  };

  // get disabled hours for second picker


  RangeCalendar.prototype.render = function render() {
    var _className, _classnames;

    var props = this.props,
        state = this.state;
    var prefixCls = props.prefixCls,
        dateInputPlaceholder = props.dateInputPlaceholder,
        seperator = props.seperator,
        timePicker = props.timePicker,
        showOk = props.showOk,
        locale = props.locale,
        showClear = props.showClear,
        showToday = props.showToday,
        type = props.type,
        clearIcon = props.clearIcon;
    var hoverValue = state.hoverValue,
        selectedValue = state.selectedValue,
        mode = state.mode,
        showTimePicker = state.showTimePicker;

    var className = (_className = {}, _className[props.className] = !!props.className, _className[prefixCls] = 1, _className[prefixCls + '-hidden'] = !props.visible, _className[prefixCls + '-range'] = 1, _className[prefixCls + '-show-time-picker'] = showTimePicker, _className[prefixCls + '-week-number'] = props.showWeekNumber, _className);
    var classes = (0, _classnames3['default'])(className);
    var newProps = {
      selectedValue: state.selectedValue,
      onSelect: this.onSelect,
      onDayHover: type === 'start' && selectedValue[1] || type === 'end' && selectedValue[0] || !!hoverValue.length ? this.onDayHover : undefined
    };

    var placeholder1 = void 0;
    var placeholder2 = void 0;

    if (dateInputPlaceholder) {
      if (Array.isArray(dateInputPlaceholder)) {
        placeholder1 = dateInputPlaceholder[0];
        placeholder2 = dateInputPlaceholder[1];
      } else {
        placeholder1 = placeholder2 = dateInputPlaceholder;
      }
    }
    var showOkButton = showOk === true || showOk !== false && !!timePicker;
    var cls = (0, _classnames3['default'])((_classnames = {}, _classnames[prefixCls + '-footer'] = true, _classnames[prefixCls + '-range-bottom'] = true, _classnames[prefixCls + '-footer-show-ok'] = showOkButton, _classnames));

    var startValue = this.getStartValue();
    var endValue = this.getEndValue();
    var todayTime = (0, _util.getTodayTime)(startValue);
    var thisMonth = todayTime.month();
    var thisYear = todayTime.year();
    var isTodayInView = startValue.year() === thisYear && startValue.month() === thisMonth || endValue.year() === thisYear && endValue.month() === thisMonth;
    var nextMonthOfStart = startValue.clone().add(1, 'months');
    var isClosestMonths = nextMonthOfStart.year() === endValue.year() && nextMonthOfStart.month() === endValue.month();

    var extraFooter = props.renderFooter();

    return _react2['default'].createElement(
      'div',
      {
        ref: this.saveRoot,
        className: classes,
        style: props.style,
        tabIndex: '0',
        onKeyDown: this.onKeyDown
      },
      props.renderSidebar(),
      _react2['default'].createElement(
        'div',
        { className: prefixCls + '-panel' },
        showClear && selectedValue[0] && selectedValue[1] ? _react2['default'].createElement(
          'a',
          {
            role: 'button',
            title: locale.clear,
            onClick: this.clear
          },
          clearIcon || _react2['default'].createElement('span', { className: prefixCls + '-clear-btn' })
        ) : null,
        _react2['default'].createElement(
          'div',
          {
            className: prefixCls + '-date-panel',
            onMouseLeave: type !== 'both' ? this.onDatePanelLeave : undefined,
            onMouseEnter: type !== 'both' ? this.onDatePanelEnter : undefined
          },
          _react2['default'].createElement(_CalendarPart2['default'], (0, _extends3['default'])({}, props, newProps, {
            hoverValue: hoverValue,
            direction: 'left',
            disabledTime: this.disabledStartTime,
            disabledMonth: this.disabledStartMonth,
            format: this.getFormat(),
            value: startValue,
            mode: mode[0],
            placeholder: placeholder1,
            onInputChange: this.onStartInputChange,
            onInputSelect: this.onStartInputSelect,
            onValueChange: this.onStartValueChange,
            onPanelChange: this.onStartPanelChange,
            showDateInput: this.props.showDateInput,
            timePicker: timePicker,
            showTimePicker: showTimePicker || mode[0] === 'time',
            enablePrev: true,
            enableNext: !isClosestMonths || this.isMonthYearPanelShow(mode[1]),
            clearIcon: clearIcon
          })),
          _react2['default'].createElement(
            'span',
            { className: prefixCls + '-range-middle' },
            seperator
          ),
          _react2['default'].createElement(_CalendarPart2['default'], (0, _extends3['default'])({}, props, newProps, {
            hoverValue: hoverValue,
            direction: 'right',
            format: this.getFormat(),
            timePickerDisabledTime: this.getEndDisableTime(),
            placeholder: placeholder2,
            value: endValue,
            mode: mode[1],
            onInputChange: this.onEndInputChange,
            onInputSelect: this.onEndInputSelect,
            onValueChange: this.onEndValueChange,
            onPanelChange: this.onEndPanelChange,
            showDateInput: this.props.showDateInput,
            timePicker: timePicker,
            showTimePicker: showTimePicker || mode[1] === 'time',
            disabledTime: this.disabledEndTime,
            disabledMonth: this.disabledEndMonth,
            enablePrev: !isClosestMonths || this.isMonthYearPanelShow(mode[0]),
            enableNext: true,
            clearIcon: clearIcon
          }))
        ),
        _react2['default'].createElement(
          'div',
          { className: cls },
          showToday || props.timePicker || showOkButton || extraFooter ? _react2['default'].createElement(
            'div',
            { className: prefixCls + '-footer-btn' },
            extraFooter,
            showToday ? _react2['default'].createElement(_TodayButton2['default'], (0, _extends3['default'])({}, props, {
              disabled: isTodayInView,
              value: state.value[0],
              onToday: this.onToday,
              text: locale.backToToday
            })) : null,
            props.timePicker ? _react2['default'].createElement(_TimePickerButton2['default'], (0, _extends3['default'])({}, props, {
              showTimePicker: showTimePicker || mode[0] === 'time' && mode[1] === 'time',
              onOpenTimePicker: this.onOpenTimePicker,
              onCloseTimePicker: this.onCloseTimePicker,
              timePickerDisabled: !this.hasSelectedValue() || hoverValue.length
            })) : null,
            showOkButton ? _react2['default'].createElement(_OkButton2['default'], (0, _extends3['default'])({}, props, {
              onOk: this.onOk,
              okDisabled: !this.isAllowedDateAndTime(selectedValue) || !this.hasSelectedValue() || hoverValue.length
            })) : null
          ) : null
        )
      )
    );
  };

  return RangeCalendar;
}(_react2['default'].Component);

RangeCalendar.propTypes = (0, _extends3['default'])({}, _CommonMixin.propType, {
  prefixCls: _propTypes2['default'].string,
  dateInputPlaceholder: _propTypes2['default'].any,
  seperator: _propTypes2['default'].string,
  defaultValue: _propTypes2['default'].any,
  value: _propTypes2['default'].any,
  hoverValue: _propTypes2['default'].any,
  mode: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOf(['time', 'date', 'month', 'year', 'decade'])),
  showDateInput: _propTypes2['default'].bool,
  timePicker: _propTypes2['default'].any,
  showOk: _propTypes2['default'].bool,
  showToday: _propTypes2['default'].bool,
  defaultSelectedValue: _propTypes2['default'].array,
  selectedValue: _propTypes2['default'].array,
  onOk: _propTypes2['default'].func,
  showClear: _propTypes2['default'].bool,
  locale: _propTypes2['default'].object,
  onChange: _propTypes2['default'].func,
  onSelect: _propTypes2['default'].func,
  onValueChange: _propTypes2['default'].func,
  onHoverChange: _propTypes2['default'].func,
  onPanelChange: _propTypes2['default'].func,
  format: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].arrayOf(_propTypes2['default'].string)]),
  onClear: _propTypes2['default'].func,
  type: _propTypes2['default'].any,
  disabledDate: _propTypes2['default'].func,
  disabledTime: _propTypes2['default'].func,
  clearIcon: _propTypes2['default'].node,
  onKeyDown: _propTypes2['default'].func
});
RangeCalendar.defaultProps = (0, _extends3['default'])({}, _CommonMixin.defaultProp, {
  type: 'both',
  seperator: '~',
  defaultSelectedValue: [],
  onValueChange: noop,
  onHoverChange: noop,
  onPanelChange: noop,
  disabledTime: noop,
  onInputSelect: noop,
  showToday: true,
  showDateInput: true
});

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onDatePanelEnter = function () {
    if (_this2.hasSelectedValue()) {
      _this2.fireHoverValueChange(_this2.state.selectedValue.concat());
    }
  };

  this.onDatePanelLeave = function () {
    if (_this2.hasSelectedValue()) {
      _this2.fireHoverValueChange([]);
    }
  };

  this.onSelect = function (value) {
    var type = _this2.props.type;
    var _state = _this2.state,
        selectedValue = _state.selectedValue,
        prevSelectedValue = _state.prevSelectedValue,
        firstSelectedValue = _state.firstSelectedValue;

    var nextSelectedValue = void 0;
    if (type === 'both') {
      if (!firstSelectedValue) {
        (0, _util.syncTime)(prevSelectedValue[0], value);
        nextSelectedValue = [value];
      } else if (_this2.compare(firstSelectedValue, value) < 0) {
        (0, _util.syncTime)(prevSelectedValue[1], value);
        nextSelectedValue = [firstSelectedValue, value];
      } else {
        (0, _util.syncTime)(prevSelectedValue[0], value);
        (0, _util.syncTime)(prevSelectedValue[1], firstSelectedValue);
        nextSelectedValue = [value, firstSelectedValue];
      }
    } else if (type === 'start') {
      (0, _util.syncTime)(prevSelectedValue[0], value);
      var endValue = selectedValue[1];
      nextSelectedValue = endValue && _this2.compare(endValue, value) > 0 ? [value, endValue] : [value];
    } else {
      // type === 'end'
      var startValue = selectedValue[0];
      if (startValue && _this2.compare(startValue, value) <= 0) {
        (0, _util.syncTime)(prevSelectedValue[1], value);
        nextSelectedValue = [startValue, value];
      } else {
        (0, _util.syncTime)(prevSelectedValue[0], value);
        nextSelectedValue = [value];
      }
    }

    _this2.fireSelectValueChange(nextSelectedValue);
  };

  this.onKeyDown = function (event) {
    if (event.target.nodeName.toLowerCase() === 'input') {
      return;
    }

    var keyCode = event.keyCode;

    var ctrlKey = event.ctrlKey || event.metaKey;

    var _state2 = _this2.state,
        selectedValue = _state2.selectedValue,
        hoverValue = _state2.hoverValue,
        firstSelectedValue = _state2.firstSelectedValue,
        value = _state2.value;
    var _props = _this2.props,
        onKeyDown = _props.onKeyDown,
        disabledDate = _props.disabledDate;

    // Update last time of the picker

    var updateHoverPoint = function updateHoverPoint(func) {
      // Change hover to make focus in UI
      var currentHoverTime = void 0;
      var nextHoverTime = void 0;
      var nextHoverValue = void 0;

      if (!firstSelectedValue) {
        currentHoverTime = hoverValue[0] || selectedValue[0] || value[0] || (0, _moment2['default'])();
        nextHoverTime = func(currentHoverTime);
        nextHoverValue = [nextHoverTime];
        _this2.fireHoverValueChange(nextHoverValue);
      } else {
        if (hoverValue.length === 1) {
          currentHoverTime = hoverValue[0].clone();
          nextHoverTime = func(currentHoverTime);
          nextHoverValue = _this2.onDayHover(nextHoverTime);
        } else {
          currentHoverTime = hoverValue[0].isSame(firstSelectedValue, 'day') ? hoverValue[1] : hoverValue[0];
          nextHoverTime = func(currentHoverTime);
          nextHoverValue = _this2.onDayHover(nextHoverTime);
        }
      }

      // Find origin hover time on value index
      if (nextHoverValue.length >= 2) {
        var miss = nextHoverValue.some(function (ht) {
          return !(0, _toTime.includesTime)(value, ht, 'month');
        });
        if (miss) {
          var newValue = nextHoverValue.slice().sort(function (t1, t2) {
            return t1.valueOf() - t2.valueOf();
          });
          if (newValue[0].isSame(newValue[1], 'month')) {
            newValue[1] = newValue[0].clone().add(1, 'month');
          }
          _this2.fireValueChange(newValue);
        }
      } else if (nextHoverValue.length === 1) {
        // If only one value, let's keep the origin panel
        var oriValueIndex = value.findIndex(function (time) {
          return time.isSame(currentHoverTime, 'month');
        });
        if (oriValueIndex === -1) oriValueIndex = 0;

        if (value.every(function (time) {
          return !time.isSame(nextHoverTime, 'month');
        })) {
          var _newValue = value.slice();
          _newValue[oriValueIndex] = nextHoverTime.clone();
          _this2.fireValueChange(_newValue);
        }
      }

      event.preventDefault();

      return nextHoverTime;
    };

    switch (keyCode) {
      case _KeyCode2['default'].DOWN:
        updateHoverPoint(function (time) {
          return (0, _toTime.goTime)(time, 1, 'weeks');
        });
        return;
      case _KeyCode2['default'].UP:
        updateHoverPoint(function (time) {
          return (0, _toTime.goTime)(time, -1, 'weeks');
        });
        return;
      case _KeyCode2['default'].LEFT:
        if (ctrlKey) {
          updateHoverPoint(function (time) {
            return (0, _toTime.goTime)(time, -1, 'years');
          });
        } else {
          updateHoverPoint(function (time) {
            return (0, _toTime.goTime)(time, -1, 'days');
          });
        }
        return;
      case _KeyCode2['default'].RIGHT:
        if (ctrlKey) {
          updateHoverPoint(function (time) {
            return (0, _toTime.goTime)(time, 1, 'years');
          });
        } else {
          updateHoverPoint(function (time) {
            return (0, _toTime.goTime)(time, 1, 'days');
          });
        }
        return;
      case _KeyCode2['default'].HOME:
        updateHoverPoint(function (time) {
          return (0, _toTime.goStartMonth)(time);
        });
        return;
      case _KeyCode2['default'].END:
        updateHoverPoint(function (time) {
          return (0, _toTime.goEndMonth)(time);
        });
        return;
      case _KeyCode2['default'].PAGE_DOWN:
        updateHoverPoint(function (time) {
          return (0, _toTime.goTime)(time, 1, 'month');
        });
        return;
      case _KeyCode2['default'].PAGE_UP:
        updateHoverPoint(function (time) {
          return (0, _toTime.goTime)(time, -1, 'month');
        });
        return;
      case _KeyCode2['default'].ENTER:
        {
          var lastValue = void 0;
          if (hoverValue.length === 0) {
            lastValue = updateHoverPoint(function (time) {
              return time;
            });
          } else if (hoverValue.length === 1) {
            lastValue = hoverValue[0];
          } else {
            lastValue = hoverValue[0].isSame(firstSelectedValue, 'day') ? hoverValue[1] : hoverValue[0];
          }
          if (lastValue && (!disabledDate || !disabledDate(lastValue))) {
            _this2.onSelect(lastValue);
          }
          event.preventDefault();
          return;
        }
      default:
        if (onKeyDown) {
          onKeyDown(event);
        }
    }
  };

  this.onDayHover = function (value) {
    var hoverValue = [];
    var _state3 = _this2.state,
        selectedValue = _state3.selectedValue,
        firstSelectedValue = _state3.firstSelectedValue;
    var type = _this2.props.type;

    if (type === 'start' && selectedValue[1]) {
      hoverValue = _this2.compare(value, selectedValue[1]) < 0 ? [value, selectedValue[1]] : [value];
    } else if (type === 'end' && selectedValue[0]) {
      hoverValue = _this2.compare(value, selectedValue[0]) > 0 ? [selectedValue[0], value] : [];
    } else {
      if (!firstSelectedValue) {
        if (_this2.state.hoverValue.length) {
          _this2.setState({ hoverValue: [] });
        }
        return hoverValue;
      }
      hoverValue = _this2.compare(value, firstSelectedValue) < 0 ? [value, firstSelectedValue] : [firstSelectedValue, value];
    }
    _this2.fireHoverValueChange(hoverValue);

    return hoverValue;
  };

  this.onToday = function () {
    var startValue = (0, _util.getTodayTime)(_this2.state.value[0]);
    var endValue = startValue.clone().add(1, 'months');
    _this2.setState({ value: [startValue, endValue] });
  };

  this.onOpenTimePicker = function () {
    _this2.setState({
      showTimePicker: true
    });
  };

  this.onCloseTimePicker = function () {
    _this2.setState({
      showTimePicker: false
    });
  };

  this.onOk = function () {
    var selectedValue = _this2.state.selectedValue;

    if (_this2.isAllowedDateAndTime(selectedValue)) {
      _this2.props.onOk(_this2.state.selectedValue);
    }
  };

  this.onStartInputChange = function () {
    for (var _len = arguments.length, oargs = Array(_len), _key = 0; _key < _len; _key++) {
      oargs[_key] = arguments[_key];
    }

    var args = ['left'].concat(oargs);
    return onInputSelect.apply(_this2, args);
  };

  this.onEndInputChange = function () {
    for (var _len2 = arguments.length, oargs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      oargs[_key2] = arguments[_key2];
    }

    var args = ['right'].concat(oargs);
    return onInputSelect.apply(_this2, args);
  };

  this.onStartInputSelect = function (value) {
    var args = ['left', value, { source: 'dateInputSelect' }];
    return onInputSelect.apply(_this2, args);
  };

  this.onEndInputSelect = function (value) {
    var args = ['right', value, { source: 'dateInputSelect' }];
    return onInputSelect.apply(_this2, args);
  };

  this.onStartValueChange = function (leftValue) {
    var value = [].concat(_this2.state.value);
    value[0] = leftValue;
    return _this2.fireValueChange(value);
  };

  this.onEndValueChange = function (rightValue) {
    var value = [].concat(_this2.state.value);
    value[1] = rightValue;
    return _this2.fireValueChange(value);
  };

  this.onStartPanelChange = function (value, mode) {
    var props = _this2.props,
        state = _this2.state;

    var newMode = [mode, state.mode[1]];
    var newState = {
      panelTriggerSource: 'start'
    };
    if (!('mode' in props)) {
      newState.mode = newMode;
    }
    _this2.setState(newState);
    var newValue = [value || state.value[0], state.value[1]];
    props.onPanelChange(newValue, newMode);
  };

  this.onEndPanelChange = function (value, mode) {
    var props = _this2.props,
        state = _this2.state;

    var newMode = [state.mode[0], mode];
    var newState = {
      panelTriggerSource: 'end'
    };
    if (!('mode' in props)) {
      newState.mode = newMode;
    }
    _this2.setState(newState);
    var newValue = [state.value[0], value || state.value[1]];
    props.onPanelChange(newValue, newMode);
  };

  this.getStartValue = function () {
    var _state4 = _this2.state,
        selectedValue = _state4.selectedValue,
        showTimePicker = _state4.showTimePicker,
        value = _state4.value,
        mode = _state4.mode,
        panelTriggerSource = _state4.panelTriggerSource;

    var startValue = value[0];
    // keep selectedTime when select date
    if (selectedValue[0] && _this2.props.timePicker) {
      startValue = startValue.clone();
      (0, _util.syncTime)(selectedValue[0], startValue);
    }
    if (showTimePicker && selectedValue[0]) {
      startValue = selectedValue[0];
    }

    // Adjust month if date not align
    if (panelTriggerSource === 'end' && mode[0] === 'date' && mode[1] === 'date' && startValue.isSame(value[1], 'month')) {
      startValue = startValue.clone().subtract(1, 'month');
    }

    return startValue;
  };

  this.getEndValue = function () {
    var _state5 = _this2.state,
        value = _state5.value,
        selectedValue = _state5.selectedValue,
        showTimePicker = _state5.showTimePicker,
        mode = _state5.mode,
        panelTriggerSource = _state5.panelTriggerSource;

    var endValue = value[1] ? value[1].clone() : value[0].clone().add(1, 'month');
    // keep selectedTime when select date
    if (selectedValue[1] && _this2.props.timePicker) {
      (0, _util.syncTime)(selectedValue[1], endValue);
    }
    if (showTimePicker) {
      endValue = selectedValue[1] ? selectedValue[1] : _this2.getStartValue();
    }

    // Adjust month if date not align
    if (!showTimePicker && panelTriggerSource !== 'end' && mode[0] === 'date' && mode[1] === 'date' && endValue.isSame(value[0], 'month')) {
      endValue = endValue.clone().add(1, 'month');
    }

    return endValue;
  };

  this.getEndDisableTime = function () {
    var _state6 = _this2.state,
        selectedValue = _state6.selectedValue,
        value = _state6.value;
    var disabledTime = _this2.props.disabledTime;

    var userSettingDisabledTime = disabledTime(selectedValue, 'end') || {};
    var startValue = selectedValue && selectedValue[0] || value[0].clone();
    // if startTime and endTime is same day..
    // the second time picker will not able to pick time before first time picker
    if (!selectedValue[1] || startValue.isSame(selectedValue[1], 'day')) {
      var hours = startValue.hour();
      var minutes = startValue.minute();
      var second = startValue.second();
      var _disabledHours = userSettingDisabledTime.disabledHours,
          _disabledMinutes = userSettingDisabledTime.disabledMinutes,
          _disabledSeconds = userSettingDisabledTime.disabledSeconds;

      var oldDisabledMinutes = _disabledMinutes ? _disabledMinutes() : [];
      var olddisabledSeconds = _disabledSeconds ? _disabledSeconds() : [];
      _disabledHours = generateOptions(hours, _disabledHours);
      _disabledMinutes = generateOptions(minutes, _disabledMinutes);
      _disabledSeconds = generateOptions(second, _disabledSeconds);
      return {
        disabledHours: function disabledHours() {
          return _disabledHours;
        },
        disabledMinutes: function disabledMinutes(hour) {
          if (hour === hours) {
            return _disabledMinutes;
          }
          return oldDisabledMinutes;
        },
        disabledSeconds: function disabledSeconds(hour, minute) {
          if (hour === hours && minute === minutes) {
            return _disabledSeconds;
          }
          return olddisabledSeconds;
        }
      };
    }
    return userSettingDisabledTime;
  };

  this.isAllowedDateAndTime = function (selectedValue) {
    return (0, _util.isAllowedDate)(selectedValue[0], _this2.props.disabledDate, _this2.disabledStartTime) && (0, _util.isAllowedDate)(selectedValue[1], _this2.props.disabledDate, _this2.disabledEndTime);
  };

  this.isMonthYearPanelShow = function (mode) {
    return ['month', 'year', 'decade'].indexOf(mode) > -1;
  };

  this.hasSelectedValue = function () {
    var selectedValue = _this2.state.selectedValue;

    return !!selectedValue[1] && !!selectedValue[0];
  };

  this.compare = function (v1, v2) {
    if (_this2.props.timePicker) {
      return v1.diff(v2);
    }
    return v1.diff(v2, 'days');
  };

  this.fireSelectValueChange = function (selectedValue, direct, cause) {
    var timePicker = _this2.props.timePicker;
    var prevSelectedValue = _this2.state.prevSelectedValue;

    if (timePicker && timePicker.props.defaultValue) {
      var timePickerDefaultValue = timePicker.props.defaultValue;
      if (!prevSelectedValue[0] && selectedValue[0]) {
        (0, _util.syncTime)(timePickerDefaultValue[0], selectedValue[0]);
      }
      if (!prevSelectedValue[1] && selectedValue[1]) {
        (0, _util.syncTime)(timePickerDefaultValue[1], selectedValue[1]);
      }
    }

    if (!('selectedValue' in _this2.props)) {
      _this2.setState({
        selectedValue: selectedValue
      });
    }

    // 尚未选择过时间，直接输入的话
    if (!_this2.state.selectedValue[0] || !_this2.state.selectedValue[1]) {
      var startValue = selectedValue[0] || (0, _moment2['default'])();
      var endValue = selectedValue[1] || startValue.clone().add(1, 'months');
      _this2.setState({
        selectedValue: selectedValue,
        value: getValueFromSelectedValue([startValue, endValue])
      });
    }

    if (selectedValue[0] && !selectedValue[1]) {
      _this2.setState({ firstSelectedValue: selectedValue[0] });
      _this2.fireHoverValueChange(selectedValue.concat());
    }
    _this2.props.onChange(selectedValue);
    if (direct || selectedValue[0] && selectedValue[1]) {
      _this2.setState({
        prevSelectedValue: selectedValue,
        firstSelectedValue: null
      });
      _this2.fireHoverValueChange([]);
      _this2.props.onSelect(selectedValue, cause);
    }
  };

  this.fireValueChange = function (value) {
    var props = _this2.props;
    if (!('value' in props)) {
      _this2.setState({
        value: value
      });
    }
    props.onValueChange(value);
  };

  this.fireHoverValueChange = function (hoverValue) {
    var props = _this2.props;
    if (!('hoverValue' in props)) {
      _this2.setState({ hoverValue: hoverValue });
    }
    props.onHoverChange(hoverValue);
  };

  this.clear = function () {
    _this2.fireSelectValueChange([], true);
    _this2.props.onClear();
  };

  this.disabledStartTime = function (time) {
    return _this2.props.disabledTime(time, 'start');
  };

  this.disabledEndTime = function (time) {
    return _this2.props.disabledTime(time, 'end');
  };

  this.disabledStartMonth = function (month) {
    var value = _this2.state.value;

    return month.isAfter(value[1], 'month');
  };

  this.disabledEndMonth = function (month) {
    var value = _this2.state.value;

    return month.isBefore(value[0], 'month');
  };
};

(0, _reactLifecyclesCompat.polyfill)(RangeCalendar);

exports['default'] = (0, _CommonMixin.commonMixinWrapper)(RangeCalendar);
module.exports = exports['default'];

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(48);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(31);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(32);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CalendarHeader = __webpack_require__(499);

var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);

var _DateTable = __webpack_require__(734);

var _DateTable2 = _interopRequireDefault(_DateTable);

var _DateInput = __webpack_require__(965);

var _DateInput2 = _interopRequireDefault(_DateInput);

var _index = __webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CalendarPart = function (_React$Component) {
  (0, _inherits3['default'])(CalendarPart, _React$Component);

  function CalendarPart() {
    (0, _classCallCheck3['default'])(this, CalendarPart);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  CalendarPart.prototype.render = function render() {
    var props = this.props;
    var prefixCls = props.prefixCls,
        value = props.value,
        hoverValue = props.hoverValue,
        selectedValue = props.selectedValue,
        mode = props.mode,
        direction = props.direction,
        locale = props.locale,
        format = props.format,
        placeholder = props.placeholder,
        disabledDate = props.disabledDate,
        timePicker = props.timePicker,
        disabledTime = props.disabledTime,
        timePickerDisabledTime = props.timePickerDisabledTime,
        showTimePicker = props.showTimePicker,
        onInputChange = props.onInputChange,
        onInputSelect = props.onInputSelect,
        enablePrev = props.enablePrev,
        enableNext = props.enableNext,
        clearIcon = props.clearIcon,
        showClear = props.showClear,
        inputMode = props.inputMode;

    var shouldShowTimePicker = showTimePicker && timePicker;
    var disabledTimeConfig = shouldShowTimePicker && disabledTime ? (0, _index.getTimeConfig)(selectedValue, disabledTime) : null;
    var rangeClassName = prefixCls + '-range';
    var newProps = {
      locale: locale,
      value: value,
      prefixCls: prefixCls,
      showTimePicker: showTimePicker
    };
    var index = direction === 'left' ? 0 : 1;
    var timePickerEle = shouldShowTimePicker && _react2['default'].cloneElement(timePicker, (0, _extends3['default'])({
      showHour: true,
      showMinute: true,
      showSecond: true
    }, timePicker.props, disabledTimeConfig, timePickerDisabledTime, {
      onChange: onInputChange,
      defaultOpenValue: value,
      value: selectedValue[index]
    }));

    var dateInputElement = props.showDateInput && _react2['default'].createElement(_DateInput2['default'], {
      format: format,
      locale: locale,
      prefixCls: prefixCls,
      timePicker: timePicker,
      disabledDate: disabledDate,
      placeholder: placeholder,
      disabledTime: disabledTime,
      value: value,
      showClear: showClear || false,
      selectedValue: selectedValue[index],
      onChange: onInputChange,
      onSelect: onInputSelect,
      clearIcon: clearIcon,
      inputMode: inputMode
    });

    return _react2['default'].createElement(
      'div',
      {
        className: rangeClassName + '-part ' + rangeClassName + '-' + direction
      },
      dateInputElement,
      _react2['default'].createElement(
        'div',
        { style: { outline: 'none' } },
        _react2['default'].createElement(_CalendarHeader2['default'], (0, _extends3['default'])({}, newProps, {
          mode: mode,
          enableNext: enableNext,
          enablePrev: enablePrev,
          onValueChange: props.onValueChange,
          onPanelChange: props.onPanelChange,
          disabledMonth: props.disabledMonth
        })),
        showTimePicker ? _react2['default'].createElement(
          'div',
          { className: prefixCls + '-time-picker' },
          _react2['default'].createElement(
            'div',
            { className: prefixCls + '-time-picker-panel' },
            timePickerEle
          )
        ) : null,
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-body' },
          _react2['default'].createElement(_DateTable2['default'], (0, _extends3['default'])({}, newProps, {
            hoverValue: hoverValue,
            selectedValue: selectedValue,
            dateRender: props.dateRender,
            onSelect: props.onSelect,
            onDayHover: props.onDayHover,
            disabledDate: disabledDate,
            showWeekNumber: props.showWeekNumber
          }))
        )
      )
    );
  };

  return CalendarPart;
}(_react2['default'].Component);

CalendarPart.propTypes = {
  prefixCls: _propTypes2['default'].string,
  value: _propTypes2['default'].any,
  hoverValue: _propTypes2['default'].any,
  selectedValue: _propTypes2['default'].any,
  direction: _propTypes2['default'].any,
  locale: _propTypes2['default'].any,
  showDateInput: _propTypes2['default'].bool,
  showTimePicker: _propTypes2['default'].bool,
  format: _propTypes2['default'].any,
  placeholder: _propTypes2['default'].any,
  disabledDate: _propTypes2['default'].any,
  timePicker: _propTypes2['default'].any,
  disabledTime: _propTypes2['default'].any,
  onInputChange: _propTypes2['default'].func,
  onInputSelect: _propTypes2['default'].func,
  timePickerDisabledTime: _propTypes2['default'].object,
  enableNext: _propTypes2['default'].any,
  enablePrev: _propTypes2['default'].any,
  clearIcon: _propTypes2['default'].node,
  dateRender: _propTypes2['default'].func,
  inputMode: _propTypes2['default'].string
};
exports['default'] = CalendarPart;
module.exports = exports['default'];

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(31);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(32);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _DateConstants = __webpack_require__(506);

var _DateConstants2 = _interopRequireDefault(_DateConstants);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DateTHead = function (_React$Component) {
  (0, _inherits3['default'])(DateTHead, _React$Component);

  function DateTHead() {
    (0, _classCallCheck3['default'])(this, DateTHead);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  DateTHead.prototype.render = function render() {
    var props = this.props;
    var value = props.value;
    var localeData = value.localeData();
    var prefixCls = props.prefixCls;
    var veryShortWeekdays = [];
    var weekDays = [];
    var firstDayOfWeek = localeData.firstDayOfWeek();
    var showWeekNumberEl = void 0;
    var now = (0, _moment2['default'])();
    for (var dateColIndex = 0; dateColIndex < _DateConstants2['default'].DATE_COL_COUNT; dateColIndex++) {
      var index = (firstDayOfWeek + dateColIndex) % _DateConstants2['default'].DATE_COL_COUNT;
      now.day(index);
      veryShortWeekdays[dateColIndex] = localeData.weekdaysMin(now);
      weekDays[dateColIndex] = localeData.weekdaysShort(now);
    }

    if (props.showWeekNumber) {
      showWeekNumberEl = _react2['default'].createElement(
        'th',
        {
          role: 'columnheader',
          className: prefixCls + '-column-header ' + prefixCls + '-week-number-header'
        },
        _react2['default'].createElement(
          'span',
          { className: prefixCls + '-column-header-inner' },
          'x'
        )
      );
    }
    var weekDaysEls = weekDays.map(function (day, xindex) {
      return _react2['default'].createElement(
        'th',
        {
          key: xindex,
          role: 'columnheader',
          title: day,
          className: prefixCls + '-column-header'
        },
        _react2['default'].createElement(
          'span',
          { className: prefixCls + '-column-header-inner' },
          veryShortWeekdays[xindex]
        )
      );
    });
    return _react2['default'].createElement(
      'thead',
      null,
      _react2['default'].createElement(
        'tr',
        { role: 'row' },
        showWeekNumberEl,
        weekDaysEls
      )
    );
  };

  return DateTHead;
}(_react2['default'].Component);

exports['default'] = DateTHead;
module.exports = exports['default'];

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(31);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(32);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(22);

var _classnames2 = _interopRequireDefault(_classnames);

var _DateConstants = __webpack_require__(506);

var _DateConstants2 = _interopRequireDefault(_DateConstants);

var _util = __webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isSameDay(one, two) {
  return one && two && one.isSame(two, 'day');
}

function beforeCurrentMonthYear(current, today) {
  if (current.year() < today.year()) {
    return 1;
  }
  return current.year() === today.year() && current.month() < today.month();
}

function afterCurrentMonthYear(current, today) {
  if (current.year() > today.year()) {
    return 1;
  }
  return current.year() === today.year() && current.month() > today.month();
}

function getIdFromDate(date) {
  return 'rc-calendar-' + date.year() + '-' + date.month() + '-' + date.date();
}

var DateTBody = function (_React$Component) {
  (0, _inherits3['default'])(DateTBody, _React$Component);

  function DateTBody() {
    (0, _classCallCheck3['default'])(this, DateTBody);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  DateTBody.prototype.render = function render() {
    var props = this.props;
    var contentRender = props.contentRender,
        prefixCls = props.prefixCls,
        selectedValue = props.selectedValue,
        value = props.value,
        showWeekNumber = props.showWeekNumber,
        dateRender = props.dateRender,
        disabledDate = props.disabledDate,
        hoverValue = props.hoverValue;

    var iIndex = void 0;
    var jIndex = void 0;
    var current = void 0;
    var dateTable = [];
    var today = (0, _util.getTodayTime)(value);
    var cellClass = prefixCls + '-cell';
    var weekNumberCellClass = prefixCls + '-week-number-cell';
    var dateClass = prefixCls + '-date';
    var todayClass = prefixCls + '-today';
    var selectedClass = prefixCls + '-selected-day';
    var selectedDateClass = prefixCls + '-selected-date'; // do not move with mouse operation
    var selectedStartDateClass = prefixCls + '-selected-start-date';
    var selectedEndDateClass = prefixCls + '-selected-end-date';
    var inRangeClass = prefixCls + '-in-range-cell';
    var lastMonthDayClass = prefixCls + '-last-month-cell';
    var nextMonthDayClass = prefixCls + '-next-month-btn-day';
    var disabledClass = prefixCls + '-disabled-cell';
    var firstDisableClass = prefixCls + '-disabled-cell-first-of-row';
    var lastDisableClass = prefixCls + '-disabled-cell-last-of-row';
    var lastDayOfMonthClass = prefixCls + '-last-day-of-month';
    var month1 = value.clone();
    month1.date(1);
    var day = month1.day();
    var lastMonthDiffDay = (day + 7 - value.localeData().firstDayOfWeek()) % 7;
    // calculate last month
    var lastMonth1 = month1.clone();
    lastMonth1.add(0 - lastMonthDiffDay, 'days');
    var passed = 0;

    for (iIndex = 0; iIndex < _DateConstants2['default'].DATE_ROW_COUNT; iIndex++) {
      for (jIndex = 0; jIndex < _DateConstants2['default'].DATE_COL_COUNT; jIndex++) {
        current = lastMonth1;
        if (passed) {
          current = current.clone();
          current.add(passed, 'days');
        }
        dateTable.push(current);
        passed++;
      }
    }
    var tableHtml = [];
    passed = 0;

    for (iIndex = 0; iIndex < _DateConstants2['default'].DATE_ROW_COUNT; iIndex++) {
      var _cx;

      var isCurrentWeek = void 0;
      var weekNumberCell = void 0;
      var isActiveWeek = false;
      var dateCells = [];
      if (showWeekNumber) {
        weekNumberCell = _react2['default'].createElement(
          'td',
          {
            key: dateTable[passed].week(),
            role: 'gridcell',
            className: weekNumberCellClass
          },
          dateTable[passed].week()
        );
      }
      for (jIndex = 0; jIndex < _DateConstants2['default'].DATE_COL_COUNT; jIndex++) {
        var next = null;
        var last = null;
        current = dateTable[passed];
        if (jIndex < _DateConstants2['default'].DATE_COL_COUNT - 1) {
          next = dateTable[passed + 1];
        }
        if (jIndex > 0) {
          last = dateTable[passed - 1];
        }
        var cls = cellClass;
        var disabled = false;
        var selected = false;

        if (isSameDay(current, today)) {
          cls += ' ' + todayClass;
          isCurrentWeek = true;
        }

        var isBeforeCurrentMonthYear = beforeCurrentMonthYear(current, value);
        var isAfterCurrentMonthYear = afterCurrentMonthYear(current, value);

        if (selectedValue && Array.isArray(selectedValue)) {
          var rangeValue = hoverValue.length ? hoverValue : selectedValue;
          if (!isBeforeCurrentMonthYear && !isAfterCurrentMonthYear) {
            var startValue = rangeValue[0];
            var endValue = rangeValue[1];
            if (startValue) {
              if (isSameDay(current, startValue)) {
                selected = true;
                isActiveWeek = true;
                cls += ' ' + selectedStartDateClass;
              }
            }
            if (startValue || endValue) {
              if (isSameDay(current, endValue)) {
                selected = true;
                isActiveWeek = true;
                cls += ' ' + selectedEndDateClass;
              } else if ((startValue === null || startValue === undefined) && current.isBefore(endValue, 'day')) {
                cls += ' ' + inRangeClass;
              } else if ((endValue === null || endValue === undefined) && current.isAfter(startValue, 'day')) {
                cls += ' ' + inRangeClass;
              } else if (current.isAfter(startValue, 'day') && current.isBefore(endValue, 'day')) {
                cls += ' ' + inRangeClass;
              }
            }
          }
        } else if (isSameDay(current, value)) {
          // keyboard change value, highlight works
          selected = true;
          isActiveWeek = true;
        }

        if (isSameDay(current, selectedValue)) {
          cls += ' ' + selectedDateClass;
        }

        if (isBeforeCurrentMonthYear) {
          cls += ' ' + lastMonthDayClass;
        }

        if (isAfterCurrentMonthYear) {
          cls += ' ' + nextMonthDayClass;
        }

        if (current.clone().endOf('month').date() === current.date()) {
          cls += ' ' + lastDayOfMonthClass;
        }

        if (disabledDate) {
          if (disabledDate(current, value)) {
            disabled = true;

            if (!last || !disabledDate(last, value)) {
              cls += ' ' + firstDisableClass;
            }

            if (!next || !disabledDate(next, value)) {
              cls += ' ' + lastDisableClass;
            }
          }
        }

        if (selected) {
          cls += ' ' + selectedClass;
        }

        if (disabled) {
          cls += ' ' + disabledClass;
        }

        var dateHtml = void 0;
        if (dateRender) {
          dateHtml = dateRender(current, value);
        } else {
          var content = contentRender ? contentRender(current, value) : current.date();
          dateHtml = _react2['default'].createElement(
            'div',
            {
              key: getIdFromDate(current),
              className: dateClass,
              'aria-selected': selected,
              'aria-disabled': disabled
            },
            content
          );
        }

        dateCells.push(_react2['default'].createElement(
          'td',
          {
            key: passed,
            onClick: disabled ? undefined : props.onSelect.bind(null, current),
            onMouseEnter: disabled ? undefined : props.onDayHover && props.onDayHover.bind(null, current) || undefined,
            role: 'gridcell',
            title: (0, _util.getTitleString)(current),
            className: cls
          },
          dateHtml
        ));

        passed++;
      }

      tableHtml.push(_react2['default'].createElement(
        'tr',
        {
          key: iIndex,
          role: 'row',
          className: (0, _classnames2['default'])((_cx = {}, _cx[prefixCls + '-current-week'] = isCurrentWeek, _cx[prefixCls + '-active-week'] = isActiveWeek, _cx))
        },
        weekNumberCell,
        dateCells
      ));
    }
    return _react2['default'].createElement(
      'tbody',
      { className: prefixCls + '-tbody' },
      tableHtml
    );
  };

  return DateTBody;
}(_react2['default'].Component);

DateTBody.propTypes = {
  contentRender: _propTypes2['default'].func,
  dateRender: _propTypes2['default'].func,
  disabledDate: _propTypes2['default'].func,
  prefixCls: _propTypes2['default'].string,
  selectedValue: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
  value: _propTypes2['default'].object,
  hoverValue: _propTypes2['default'].any,
  showWeekNumber: _propTypes2['default'].bool
};
DateTBody.defaultProps = {
  hoverValue: []
};
exports['default'] = DateTBody;
module.exports = exports['default'];

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(31);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(32);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(46);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _KeyCode = __webpack_require__(194);

var _KeyCode2 = _interopRequireDefault(_KeyCode);

var _reactLifecyclesCompat = __webpack_require__(36);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _util = __webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var cachedSelectionStart = void 0;
var cachedSelectionEnd = void 0;
var dateInputInstance = void 0;

var DateInput = function (_React$Component) {
  (0, _inherits3['default'])(DateInput, _React$Component);

  function DateInput(props) {
    (0, _classCallCheck3['default'])(this, DateInput);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var selectedValue = props.selectedValue;

    _this.state = {
      str: (0, _util.formatDate)(selectedValue, _this.props.format),
      invalid: false,
      hasFocus: false
    };
    return _this;
  }

  DateInput.prototype.componentDidUpdate = function componentDidUpdate() {
    if (dateInputInstance && this.state.hasFocus && !this.state.invalid && !(cachedSelectionStart === 0 && cachedSelectionEnd === 0)) {
      dateInputInstance.setSelectionRange(cachedSelectionStart, cachedSelectionEnd);
    }
  };

  DateInput.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, state) {
    var newState = {};

    if (dateInputInstance) {
      cachedSelectionStart = dateInputInstance.selectionStart;
      cachedSelectionEnd = dateInputInstance.selectionEnd;
    }
    // when popup show, click body will call this, bug!
    var selectedValue = nextProps.selectedValue;
    if (!state.hasFocus) {
      newState = {
        str: (0, _util.formatDate)(selectedValue, nextProps.format),
        invalid: false
      };
    }

    return newState;
  };

  DateInput.getInstance = function getInstance() {
    return dateInputInstance;
  };

  DateInput.prototype.render = function render() {
    var props = this.props;
    var _state = this.state,
        invalid = _state.invalid,
        str = _state.str;
    var locale = props.locale,
        prefixCls = props.prefixCls,
        placeholder = props.placeholder,
        clearIcon = props.clearIcon,
        inputMode = props.inputMode;

    var invalidClass = invalid ? prefixCls + '-input-invalid' : '';
    return _react2['default'].createElement(
      'div',
      { className: prefixCls + '-input-wrap' },
      _react2['default'].createElement(
        'div',
        { className: prefixCls + '-date-input-wrap' },
        _react2['default'].createElement('input', {
          ref: this.saveDateInput,
          className: prefixCls + '-input ' + invalidClass,
          value: str,
          disabled: props.disabled,
          placeholder: placeholder,
          onChange: this.onInputChange,
          onKeyDown: this.onKeyDown,
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          inputMode: inputMode
        })
      ),
      props.showClear ? _react2['default'].createElement(
        'a',
        {
          role: 'button',
          title: locale.clear,
          onClick: this.onClear
        },
        clearIcon || _react2['default'].createElement('span', { className: prefixCls + '-clear-btn' })
      ) : null
    );
  };

  return DateInput;
}(_react2['default'].Component);

DateInput.propTypes = {
  prefixCls: _propTypes2['default'].string,
  timePicker: _propTypes2['default'].object,
  value: _propTypes2['default'].object,
  disabledTime: _propTypes2['default'].any,
  format: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].arrayOf(_propTypes2['default'].string)]),
  locale: _propTypes2['default'].object,
  disabledDate: _propTypes2['default'].func,
  onChange: _propTypes2['default'].func,
  onClear: _propTypes2['default'].func,
  placeholder: _propTypes2['default'].string,
  onSelect: _propTypes2['default'].func,
  selectedValue: _propTypes2['default'].object,
  clearIcon: _propTypes2['default'].node,
  inputMode: _propTypes2['default'].string
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onClear = function () {
    _this2.setState({
      str: ''
    });
    _this2.props.onClear(null);
  };

  this.onInputChange = function (event) {
    var str = event.target.value;
    var _props = _this2.props,
        disabledDate = _props.disabledDate,
        format = _props.format,
        onChange = _props.onChange,
        selectedValue = _props.selectedValue;

    // 没有内容，合法并直接退出

    if (!str) {
      onChange(null);
      _this2.setState({
        invalid: false,
        str: str
      });
      return;
    }

    // 不合法直接退出
    var parsed = (0, _moment2['default'])(str, format, true);
    if (!parsed.isValid()) {
      _this2.setState({
        invalid: true,
        str: str
      });
      return;
    }

    var value = _this2.props.value.clone();
    value.year(parsed.year()).month(parsed.month()).date(parsed.date()).hour(parsed.hour()).minute(parsed.minute()).second(parsed.second());

    if (!value || disabledDate && disabledDate(value)) {
      _this2.setState({
        invalid: true,
        str: str
      });
      return;
    }

    if (selectedValue !== value || selectedValue && value && !selectedValue.isSame(value)) {
      _this2.setState({
        invalid: false,
        str: str
      });
      onChange(value);
    }
  };

  this.onFocus = function () {
    _this2.setState({ hasFocus: true });
  };

  this.onBlur = function () {
    _this2.setState(function (prevState, prevProps) {
      return {
        hasFocus: false,
        str: (0, _util.formatDate)(prevProps.value, prevProps.format)
      };
    });
  };

  this.onKeyDown = function (event) {
    var keyCode = event.keyCode;
    var _props2 = _this2.props,
        onSelect = _props2.onSelect,
        value = _props2.value,
        disabledDate = _props2.disabledDate;

    if (keyCode === _KeyCode2['default'].ENTER && onSelect) {
      var validateDate = !disabledDate || !disabledDate(value);
      if (validateDate) {
        onSelect(value.clone());
      }
      event.preventDefault();
    }
  };

  this.getRootDOMNode = function () {
    return _reactDom2['default'].findDOMNode(_this2);
  };

  this.focus = function () {
    if (dateInputInstance) {
      dateInputInstance.focus();
    }
  };

  this.saveDateInput = function (dateInput) {
    dateInputInstance = dateInput;
  };
};

(0, _reactLifecyclesCompat.polyfill)(DateInput);

exports['default'] = DateInput;
module.exports = exports['default'];

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.goStartMonth = goStartMonth;
exports.goEndMonth = goEndMonth;
exports.goTime = goTime;
exports.includesTime = includesTime;
function goStartMonth(time) {
  return time.clone().startOf('month');
}

function goEndMonth(time) {
  return time.clone().endOf('month');
}

function goTime(time, direction, unit) {
  return time.clone().add(direction, unit);
}

function includesTime() {
  var timeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var time = arguments[1];
  var unit = arguments[2];

  return timeList.some(function (t) {
    return t.isSame(time, unit);
  });
}

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _omit = _interopRequireDefault(__webpack_require__(71));

var _reactLifecyclesCompat = __webpack_require__(36);

var _icon = _interopRequireDefault(__webpack_require__(38));

var _CheckableTag = _interopRequireDefault(__webpack_require__(968));

var _configProvider = __webpack_require__(39);

var _colors = __webpack_require__(969);

var _warning = _interopRequireDefault(__webpack_require__(69));

var _wave = _interopRequireDefault(__webpack_require__(334));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var PresetColorRegex = new RegExp("^(".concat(_colors.PresetColorTypes.join('|'), ")(-inverse)?$"));

var Tag = /*#__PURE__*/function (_React$Component) {
  _inherits(Tag, _React$Component);

  var _super = _createSuper(Tag);

  function Tag(props) {
    var _this;

    _classCallCheck(this, Tag);

    _this = _super.call(this, props);
    _this.state = {
      visible: true
    };

    _this.handleIconClick = function (e) {
      e.stopPropagation();

      _this.setVisible(false, e);
    };

    _this.renderTag = function (configProps) {
      var _a = _this.props,
          children = _a.children,
          otherProps = __rest(_a, ["children"]);

      var isNeedWave = 'onClick' in otherProps || children && children.type === 'a';
      var tagProps = (0, _omit["default"])(otherProps, ['onClose', 'afterClose', 'color', 'visible', 'closable', 'prefixCls']);
      return isNeedWave ? /*#__PURE__*/React.createElement(_wave["default"], null, /*#__PURE__*/React.createElement("span", _extends({}, tagProps, {
        className: _this.getTagClassName(configProps),
        style: _this.getTagStyle()
      }), children, _this.renderCloseIcon())) : /*#__PURE__*/React.createElement("span", _extends({}, tagProps, {
        className: _this.getTagClassName(configProps),
        style: _this.getTagStyle()
      }), children, _this.renderCloseIcon());
    };

    (0, _warning["default"])(!('afterClose' in props), 'Tag', "'afterClose' will be deprecated, please use 'onClose', we will remove this in the next version.");
    return _this;
  }

  _createClass(Tag, [{
    key: "getTagStyle",
    value: function getTagStyle() {
      var _this$props = this.props,
          color = _this$props.color,
          style = _this$props.style;
      var isPresetColor = this.isPresetColor();
      return _extends({
        backgroundColor: color && !isPresetColor ? color : undefined
      }, style);
    }
  }, {
    key: "getTagClassName",
    value: function getTagClassName(_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;
      var _this$props2 = this.props,
          customizePrefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          color = _this$props2.color;
      var visible = this.state.visible;
      var isPresetColor = this.isPresetColor();
      var prefixCls = getPrefixCls('tag', customizePrefixCls);
      return (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(color), isPresetColor), _defineProperty(_classNames, "".concat(prefixCls, "-has-color"), color && !isPresetColor), _defineProperty(_classNames, "".concat(prefixCls, "-hidden"), !visible), _classNames), className);
    }
  }, {
    key: "setVisible",
    value: function setVisible(visible, e) {
      var _this$props3 = this.props,
          onClose = _this$props3.onClose,
          afterClose = _this$props3.afterClose;

      if (onClose) {
        onClose(e);
      }

      if (afterClose && !onClose) {
        // next version remove.
        afterClose();
      }

      if (e.defaultPrevented) {
        return;
      }

      if (!('visible' in this.props)) {
        this.setState({
          visible: visible
        });
      }
    }
  }, {
    key: "isPresetColor",
    value: function isPresetColor() {
      var color = this.props.color;

      if (!color) {
        return false;
      }

      return PresetColorRegex.test(color);
    }
  }, {
    key: "renderCloseIcon",
    value: function renderCloseIcon() {
      var closable = this.props.closable;
      return closable ? /*#__PURE__*/React.createElement(_icon["default"], {
        type: "close",
        onClick: this.handleIconClick
      }) : null;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTag);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('visible' in nextProps) {
        return {
          visible: nextProps.visible
        };
      }

      return null;
    }
  }]);

  return Tag;
}(React.Component);

Tag.CheckableTag = _CheckableTag["default"];
Tag.defaultProps = {
  closable: false
};
(0, _reactLifecyclesCompat.polyfill)(Tag);
var _default = Tag;
exports["default"] = _default;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _configProvider = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var CheckableTag = /*#__PURE__*/function (_React$Component) {
  _inherits(CheckableTag, _React$Component);

  var _super = _createSuper(CheckableTag);

  function CheckableTag() {
    var _this;

    _classCallCheck(this, CheckableTag);

    _this = _super.apply(this, arguments);

    _this.handleClick = function () {
      var _this$props = _this.props,
          checked = _this$props.checked,
          onChange = _this$props.onChange;

      if (onChange) {
        onChange(!checked);
      }
    };

    _this.renderCheckableTag = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          className = _a.className,
          checked = _a.checked,
          restProps = __rest(_a, ["prefixCls", "className", "checked"]);

      var prefixCls = getPrefixCls('tag', customizePrefixCls);
      var cls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-checkable"), true), _defineProperty(_classNames, "".concat(prefixCls, "-checkable-checked"), checked), _classNames), className);
      delete restProps.onChange; // TypeScript cannot check delete now.

      return /*#__PURE__*/React.createElement("span", _extends({}, restProps, {
        className: cls,
        onClick: _this.handleClick
      }));
    };

    return _this;
  }

  _createClass(CheckableTag, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCheckableTag);
    }
  }]);

  return CheckableTag;
}(React.Component);

exports["default"] = CheckableTag;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PresetColorTypes = void 0;

var _type = __webpack_require__(130);

// eslint-disable-next-line import/prefer-default-export
var PresetColorTypes = (0, _type.tuple)('pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'volcano', 'gold', 'lime');
exports.PresetColorTypes = PresetColorTypes;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var moment = _interopRequireWildcard(__webpack_require__(2));

var _reactLifecyclesCompat = __webpack_require__(36);

var _rcCalendar = _interopRequireDefault(__webpack_require__(495));

var _Picker = _interopRequireDefault(__webpack_require__(347));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _configProvider = __webpack_require__(39);

var _interopDefault = _interopRequireDefault(__webpack_require__(182));

var _InputIcon = _interopRequireDefault(__webpack_require__(507));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function formatValue(value, format) {
  return value && value.format(format) || '';
}

var WeekPicker = /*#__PURE__*/function (_React$Component) {
  _inherits(WeekPicker, _React$Component);

  var _super = _createSuper(WeekPicker);

  function WeekPicker(props) {
    var _this;

    _classCallCheck(this, WeekPicker);

    _this = _super.call(this, props);

    _this.saveInput = function (node) {
      _this.input = node;
    };

    _this.weekDateRender = function (current) {
      var selectedValue = _this.state.value;

      var _assertThisInitialize = _assertThisInitialized(_this),
          prefixCls = _assertThisInitialize.prefixCls;

      var dateRender = _this.props.dateRender;
      var dateNode = dateRender ? dateRender(current) : current.date();

      if (selectedValue && current.year() === selectedValue.year() && current.week() === selectedValue.week()) {
        return /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-selected-day")
        }, /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-date")
        }, dateNode));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-date")
      }, dateNode);
    };

    _this.handleChange = function (value) {
      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }

      _this.props.onChange(value, formatValue(value, _this.props.format));
    };

    _this.handleOpenChange = function (open) {
      var onOpenChange = _this.props.onOpenChange;

      if (!('open' in _this.props)) {
        _this.setState({
          open: open
        });
      }

      if (onOpenChange) {
        onOpenChange(open);
      }
    };

    _this.clearSelection = function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.handleChange(null);
    };

    _this.renderFooter = function () {
      var _this$props = _this.props,
          prefixCls = _this$props.prefixCls,
          renderExtraFooter = _this$props.renderExtraFooter;
      return renderExtraFooter ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-footer-extra")
      }, renderExtraFooter.apply(void 0, arguments)) : null;
    };

    _this.renderWeekPicker = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var _this$props2 = _this.props,
          customizePrefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          pickerClass = _this$props2.pickerClass,
          popupStyle = _this$props2.popupStyle,
          pickerInputClass = _this$props2.pickerInputClass,
          format = _this$props2.format,
          allowClear = _this$props2.allowClear,
          locale = _this$props2.locale,
          localeCode = _this$props2.localeCode,
          disabledDate = _this$props2.disabledDate,
          style = _this$props2.style,
          onFocus = _this$props2.onFocus,
          onBlur = _this$props2.onBlur,
          id = _this$props2.id,
          suffixIcon = _this$props2.suffixIcon,
          defaultPickerValue = _this$props2.defaultPickerValue;
      var prefixCls = getPrefixCls('calendar', customizePrefixCls); // To support old version react.
      // Have to add prefixCls on the instance.
      // https://github.com/facebook/react/issues/12397

      _this.prefixCls = prefixCls;
      var _this$state = _this.state,
          open = _this$state.open,
          pickerValue = _this$state.value;

      if (pickerValue && localeCode) {
        pickerValue.locale(localeCode);
      }

      var placeholder = 'placeholder' in _this.props ? _this.props.placeholder : locale.lang.placeholder;
      var calendar = /*#__PURE__*/React.createElement(_rcCalendar["default"], {
        showWeekNumber: true,
        dateRender: _this.weekDateRender,
        prefixCls: prefixCls,
        format: format,
        locale: locale.lang,
        showDateInput: false,
        showToday: false,
        disabledDate: disabledDate,
        renderFooter: _this.renderFooter,
        defaultValue: defaultPickerValue
      });
      var clearIcon = !disabled && allowClear && _this.state.value ? /*#__PURE__*/React.createElement(_icon["default"], {
        type: "close-circle",
        className: "".concat(prefixCls, "-picker-clear"),
        onClick: _this.clearSelection,
        theme: "filled"
      }) : null;
      var inputIcon = /*#__PURE__*/React.createElement(_InputIcon["default"], {
        suffixIcon: suffixIcon,
        prefixCls: prefixCls
      });

      var input = function input(_ref2) {
        var value = _ref2.value;
        return /*#__PURE__*/React.createElement("span", {
          style: {
            display: 'inline-block',
            width: '100%'
          }
        }, /*#__PURE__*/React.createElement("input", {
          ref: _this.saveInput,
          disabled: disabled,
          readOnly: true,
          value: value && value.format(format) || '',
          placeholder: placeholder,
          className: pickerInputClass,
          onFocus: onFocus,
          onBlur: onBlur
        }), clearIcon, inputIcon);
      };

      return /*#__PURE__*/React.createElement("span", {
        className: (0, _classnames["default"])(className, pickerClass),
        style: style,
        id: id
      }, /*#__PURE__*/React.createElement(_Picker["default"], _extends({}, _this.props, {
        calendar: calendar,
        prefixCls: "".concat(prefixCls, "-picker-container"),
        value: pickerValue,
        onChange: _this.handleChange,
        open: open,
        onOpenChange: _this.handleOpenChange,
        style: popupStyle
      }), input));
    };

    var value = props.value || props.defaultValue;

    if (value && !(0, _interopDefault["default"])(moment).isMoment(value)) {
      throw new Error('The value/defaultValue of WeekPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
    }

    _this.state = {
      value: value,
      open: props.open
    };
    return _this;
  }

  _createClass(WeekPicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      if (!('open' in this.props) && prevState.open && !this.state.open) {
        this.focus();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderWeekPicker);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps || 'open' in nextProps) {
        var state = {};

        if ('value' in nextProps) {
          state.value = nextProps.value;
        }

        if ('open' in nextProps) {
          state.open = nextProps.open;
        }

        return state;
      }

      return null;
    }
  }]);

  return WeekPicker;
}(React.Component);

WeekPicker.defaultProps = {
  format: 'gggg-wo',
  allowClear: true
};
(0, _reactLifecyclesCompat.polyfill)(WeekPicker);
var _default = WeekPicker;
exports["default"] = _default;

/***/ }),
/* 971 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 972 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(974);

/***/ }),
/* 974 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(976);

/***/ }),
/* 976 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _omit = _interopRequireDefault(__webpack_require__(71));

var _rcTable = _interopRequireWildcard(__webpack_require__(978));

var PropTypes = _interopRequireWildcard(__webpack_require__(19));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _shallowequal = _interopRequireDefault(__webpack_require__(89));

var _reactLifecyclesCompat = __webpack_require__(36);

var _filterDropdown = _interopRequireDefault(__webpack_require__(1057));

var _createStore = _interopRequireDefault(__webpack_require__(1069));

var _SelectionBox = _interopRequireDefault(__webpack_require__(1070));

var _SelectionCheckboxAll = _interopRequireDefault(__webpack_require__(1071));

var _Column = _interopRequireDefault(__webpack_require__(1072));

var _ColumnGroup = _interopRequireDefault(__webpack_require__(1073));

var _createBodyRow = _interopRequireDefault(__webpack_require__(1074));

var _util = __webpack_require__(528);

var _scrollTo = _interopRequireDefault(__webpack_require__(1075));

var _pagination = _interopRequireDefault(__webpack_require__(363));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _spin = _interopRequireDefault(__webpack_require__(11));

var _transButton = _interopRequireDefault(__webpack_require__(1093));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(113));

var _default2 = _interopRequireDefault(__webpack_require__(219));

var _configProvider = __webpack_require__(39);

var _warning = _interopRequireDefault(__webpack_require__(69));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable prefer-spread */


function noop() {}

function stopPropagation(e) {
  e.stopPropagation();
}

function getRowSelection(props) {
  return props.rowSelection || {};
}

function getColumnKey(column, index) {
  return column.key || column.dataIndex || index;
}

function isSameColumn(a, b) {
  if (a && b && a.key && a.key === b.key) {
    return true;
  }

  return a === b || (0, _shallowequal["default"])(a, b, function (value, other) {
    // https://github.com/ant-design/ant-design/issues/12737
    if (typeof value === 'function' && typeof other === 'function') {
      return value === other || value.toString() === other.toString();
    } // https://github.com/ant-design/ant-design/issues/19398


    if (Array.isArray(value) && Array.isArray(other)) {
      return value === other || (0, _shallowequal["default"])(value, other);
    }
  });
}

var defaultPagination = {
  onChange: noop,
  onShowSizeChange: noop
};
/**
 * Avoid creating new object, so that parent component's shouldComponentUpdate
 * can works appropriately。
 */

var emptyObject = {};

var createComponents = function createComponents() {
  var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var bodyRow = components && components.body && components.body.row;
  return _extends(_extends({}, components), {
    body: _extends(_extends({}, components.body), {
      row: (0, _createBodyRow["default"])(bodyRow)
    })
  });
};

function isTheSameComponents() {
  var components1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var components2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return components1 === components2 || ['table', 'header', 'body'].every(function (key) {
    return (0, _shallowequal["default"])(components1[key], components2[key]);
  });
}

function getFilteredValueColumns(state, columns) {
  return (0, _util.flatFilter)(columns || (state || {}).columns || [], function (column) {
    return typeof column.filteredValue !== 'undefined';
  });
}

function getFiltersFromColumns() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var columns = arguments.length > 1 ? arguments[1] : undefined;
  var filters = {};
  getFilteredValueColumns(state, columns).forEach(function (col) {
    var colKey = getColumnKey(col);
    filters[colKey] = col.filteredValue;
  });
  return filters;
}

function isFiltersChanged(state, filters) {
  if (Object.keys(filters).length !== Object.keys(state.filters).length) {
    return true;
  }

  return Object.keys(filters).some(function (columnKey) {
    return filters[columnKey] !== state.filters[columnKey];
  });
}

var Table = /*#__PURE__*/function (_React$Component) {
  _inherits(Table, _React$Component);

  var _super = _createSuper(Table);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _super.call(this, props);

    _this.setTableRef = function (table) {
      _this.rcTable = table;
    };

    _this.getCheckboxPropsByItem = function (item, index) {
      var rowSelection = getRowSelection(_this.props);

      if (!rowSelection.getCheckboxProps) {
        return {};
      }

      var key = _this.getRecordKey(item, index); // Cache checkboxProps


      if (!_this.props.checkboxPropsCache[key]) {
        _this.props.checkboxPropsCache[key] = rowSelection.getCheckboxProps(item) || {};
        var checkboxProps = _this.props.checkboxPropsCache[key];
        (0, _warning["default"])(!('checked' in checkboxProps) && !('defaultChecked' in checkboxProps), 'Table', 'Do not set `checked` or `defaultChecked` in `getCheckboxProps`. Please use `selectedRowKeys` instead.');
      }

      return _this.props.checkboxPropsCache[key];
    };

    _this.getRecordKey = function (record, index) {
      var rowKey = _this.props.rowKey;
      var recordKey = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
      (0, _warning["default"])(recordKey !== undefined, 'Table', 'Each record in dataSource of table should have a unique `key` prop, ' + 'or set `rowKey` of Table to an unique primary key, ' + 'see https://u.ant.design/table-row-key');
      return recordKey === undefined ? index : recordKey;
    };

    _this.onRow = function (prefixCls, record, index) {
      var onRow = _this.props.onRow;
      var custom = onRow ? onRow(record, index) : {};
      return _extends(_extends({}, custom), {
        prefixCls: prefixCls,
        store: _this.props.store,
        rowKey: _this.getRecordKey(record, index)
      });
    };

    _this.generatePopupContainerFunc = function (getPopupContainer) {
      var scroll = _this.props.scroll;
      var table = _this.rcTable;

      if (getPopupContainer) {
        return getPopupContainer;
      } // Use undefined to let rc component use default logic.


      return scroll && table ? function () {
        return table.tableNode;
      } : undefined;
    };

    _this.scrollToFirstRow = function () {
      var scroll = _this.props.scroll;

      if (scroll && scroll.scrollToFirstRowOnChange !== false) {
        (0, _scrollTo["default"])(0, {
          getContainer: function getContainer() {
            return _this.rcTable.bodyTable;
          }
        });
      }
    };

    _this.handleFilter = function (column, nextFilters) {
      var props = _this.props;

      var pagination = _extends({}, _this.state.pagination);

      var filters = _extends(_extends({}, _this.state.filters), _defineProperty({}, getColumnKey(column), nextFilters)); // Remove filters not in current columns


      var currentColumnKeys = [];
      (0, _util.treeMap)(_this.state.columns, function (c) {
        if (!c.children) {
          currentColumnKeys.push(getColumnKey(c));
        }
      });
      Object.keys(filters).forEach(function (columnKey) {
        if (currentColumnKeys.indexOf(columnKey) < 0) {
          delete filters[columnKey];
        }
      });

      if (props.pagination) {
        // Reset current prop
        pagination.current = 1;
        pagination.onChange(pagination.current);
      }

      var newState = {
        pagination: pagination,
        filters: {}
      };

      var filtersToSetState = _extends({}, filters); // Remove filters which is controlled


      getFilteredValueColumns(_this.state).forEach(function (col) {
        var columnKey = getColumnKey(col);

        if (columnKey) {
          delete filtersToSetState[columnKey];
        }
      });

      if (Object.keys(filtersToSetState).length > 0) {
        newState.filters = filtersToSetState;
      } // Controlled current prop will not respond user interaction


      if (_typeof(props.pagination) === 'object' && 'current' in props.pagination) {
        newState.pagination = _extends(_extends({}, pagination), {
          current: _this.state.pagination.current
        });
      }

      _this.setState(newState, function () {
        _this.scrollToFirstRow();

        _this.props.store.setState({
          selectionDirty: false
        });

        var onChange = _this.props.onChange;

        if (onChange) {
          onChange.apply(null, _this.prepareParamsArguments(_extends(_extends({}, _this.state), {
            selectionDirty: false,
            filters: filters,
            pagination: pagination
          })));
        }
      });
    };

    _this.handleSelect = function (record, rowIndex, e) {
      var checked = e.target.checked;
      var nativeEvent = e.nativeEvent;
      var defaultSelection = _this.props.store.getState().selectionDirty ? [] : _this.getDefaultSelection();

      var selectedRowKeys = _this.props.store.getState().selectedRowKeys.concat(defaultSelection);

      var key = _this.getRecordKey(record, rowIndex);

      var pivot = _this.state.pivot;

      var rows = _this.getFlatCurrentPageData();

      var realIndex = rowIndex;

      if (_this.props.expandedRowRender) {
        realIndex = rows.findIndex(function (row) {
          return _this.getRecordKey(row, rowIndex) === key;
        });
      }

      if (nativeEvent.shiftKey && pivot !== undefined && realIndex !== pivot) {
        var changeRowKeys = [];
        var direction = Math.sign(pivot - realIndex);
        var dist = Math.abs(pivot - realIndex);
        var step = 0;

        var _loop = function _loop() {
          var i = realIndex + step * direction;
          step += 1;
          var row = rows[i];

          var rowKey = _this.getRecordKey(row, i);

          var checkboxProps = _this.getCheckboxPropsByItem(row, i);

          if (!checkboxProps.disabled) {
            if (selectedRowKeys.includes(rowKey)) {
              if (!checked) {
                selectedRowKeys = selectedRowKeys.filter(function (j) {
                  return rowKey !== j;
                });
                changeRowKeys.push(rowKey);
              }
            } else if (checked) {
              selectedRowKeys.push(rowKey);
              changeRowKeys.push(rowKey);
            }
          }
        };

        while (step <= dist) {
          _loop();
        }

        _this.setState({
          pivot: realIndex
        });

        _this.props.store.setState({
          selectionDirty: true
        });

        _this.setSelectedRowKeys(selectedRowKeys, {
          selectWay: 'onSelectMultiple',
          record: record,
          checked: checked,
          changeRowKeys: changeRowKeys,
          nativeEvent: nativeEvent
        });
      } else {
        if (checked) {
          selectedRowKeys.push(_this.getRecordKey(record, realIndex));
        } else {
          selectedRowKeys = selectedRowKeys.filter(function (i) {
            return key !== i;
          });
        }

        _this.setState({
          pivot: realIndex
        });

        _this.props.store.setState({
          selectionDirty: true
        });

        _this.setSelectedRowKeys(selectedRowKeys, {
          selectWay: 'onSelect',
          record: record,
          checked: checked,
          changeRowKeys: undefined,
          nativeEvent: nativeEvent
        });
      }
    };

    _this.handleRadioSelect = function (record, rowIndex, e) {
      var checked = e.target.checked;
      var nativeEvent = e.nativeEvent;

      var key = _this.getRecordKey(record, rowIndex);

      var selectedRowKeys = [key];

      _this.props.store.setState({
        selectionDirty: true
      });

      _this.setSelectedRowKeys(selectedRowKeys, {
        selectWay: 'onSelect',
        record: record,
        checked: checked,
        changeRowKeys: undefined,
        nativeEvent: nativeEvent
      });
    };

    _this.handleSelectRow = function (selectionKey, index, onSelectFunc) {
      var data = _this.getFlatCurrentPageData();

      var defaultSelection = _this.props.store.getState().selectionDirty ? [] : _this.getDefaultSelection();

      var selectedRowKeys = _this.props.store.getState().selectedRowKeys.concat(defaultSelection);

      var changeableRowKeys = data.filter(function (item, i) {
        return !_this.getCheckboxPropsByItem(item, i).disabled;
      }).map(function (item, i) {
        return _this.getRecordKey(item, i);
      });
      var changeRowKeys = [];
      var selectWay = 'onSelectAll';
      var checked; // handle default selection

      switch (selectionKey) {
        case 'all':
          changeableRowKeys.forEach(function (key) {
            if (selectedRowKeys.indexOf(key) < 0) {
              selectedRowKeys.push(key);
              changeRowKeys.push(key);
            }
          });
          selectWay = 'onSelectAll';
          checked = true;
          break;

        case 'removeAll':
          changeableRowKeys.forEach(function (key) {
            if (selectedRowKeys.indexOf(key) >= 0) {
              selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
              changeRowKeys.push(key);
            }
          });
          selectWay = 'onSelectAll';
          checked = false;
          break;

        case 'invert':
          changeableRowKeys.forEach(function (key) {
            if (selectedRowKeys.indexOf(key) < 0) {
              selectedRowKeys.push(key);
            } else {
              selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
            }

            changeRowKeys.push(key);
            selectWay = 'onSelectInvert';
          });
          break;

        default:
          break;
      }

      _this.props.store.setState({
        selectionDirty: true
      }); // when select custom selection, callback selections[n].onSelect


      var rowSelection = _this.props.rowSelection;
      var customSelectionStartIndex = 2;

      if (rowSelection && rowSelection.hideDefaultSelections) {
        customSelectionStartIndex = 0;
      }

      if (index >= customSelectionStartIndex && typeof onSelectFunc === 'function') {
        return onSelectFunc(changeableRowKeys);
      }

      _this.setSelectedRowKeys(selectedRowKeys, {
        selectWay: selectWay,
        checked: checked,
        changeRowKeys: changeRowKeys
      });
    };

    _this.handlePageChange = function (current) {
      var props = _this.props;

      var pagination = _extends({}, _this.state.pagination);

      if (current) {
        pagination.current = current;
      } else {
        pagination.current = pagination.current || 1;
      }

      for (var _len = arguments.length, otherArguments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        otherArguments[_key - 1] = arguments[_key];
      }

      pagination.onChange.apply(pagination, [pagination.current].concat(otherArguments));
      var newState = {
        pagination: pagination
      }; // Controlled current prop will not respond user interaction

      if (props.pagination && _typeof(props.pagination) === 'object' && 'current' in props.pagination) {
        newState.pagination = _extends(_extends({}, pagination), {
          current: _this.state.pagination.current
        });
      }

      _this.setState(newState, _this.scrollToFirstRow);

      _this.props.store.setState({
        selectionDirty: false
      });

      var onChange = _this.props.onChange;

      if (onChange) {
        onChange.apply(null, _this.prepareParamsArguments(_extends(_extends({}, _this.state), {
          selectionDirty: false,
          pagination: pagination
        })));
      }
    };

    _this.handleShowSizeChange = function (current, pageSize) {
      var pagination = _this.state.pagination;
      pagination.onShowSizeChange(current, pageSize);

      var nextPagination = _extends(_extends({}, pagination), {
        pageSize: pageSize,
        current: current
      });

      _this.setState({
        pagination: nextPagination
      }, _this.scrollToFirstRow);

      var onChange = _this.props.onChange;

      if (onChange) {
        onChange.apply(null, _this.prepareParamsArguments(_extends(_extends({}, _this.state), {
          pagination: nextPagination
        })));
      }
    };

    _this.renderExpandIcon = function (prefixCls) {
      return function (_ref) {
        var expandable = _ref.expandable,
            expanded = _ref.expanded,
            needIndentSpaced = _ref.needIndentSpaced,
            record = _ref.record,
            onExpand = _ref.onExpand;

        if (expandable) {
          return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
            componentName: "Table",
            defaultLocale: _default2["default"].Table
          }, function (locale) {
            var _classNames;

            return /*#__PURE__*/React.createElement(_transButton["default"], {
              className: (0, _classnames["default"])("".concat(prefixCls, "-row-expand-icon"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-row-collapsed"), !expanded), _defineProperty(_classNames, "".concat(prefixCls, "-row-expanded"), expanded), _classNames)),
              onClick: function onClick(event) {
                onExpand(record, event);
              },
              "aria-label": expanded ? locale.collapse : locale.expand,
              noStyle: true
            });
          });
        }

        if (needIndentSpaced) {
          return /*#__PURE__*/React.createElement("span", {
            className: "".concat(prefixCls, "-row-expand-icon ").concat(prefixCls, "-row-spaced")
          });
        }

        return null;
      };
    };

    _this.renderSelectionBox = function (type) {
      return function (_, record, index) {
        var rowKey = _this.getRecordKey(record, index);

        var props = _this.getCheckboxPropsByItem(record, index);

        var handleChange = function handleChange(e) {
          return type === 'radio' ? _this.handleRadioSelect(record, index, e) : _this.handleSelect(record, index, e);
        };

        return /*#__PURE__*/React.createElement("span", {
          onClick: stopPropagation
        }, /*#__PURE__*/React.createElement(_SelectionBox["default"], _extends({
          type: type,
          store: _this.props.store,
          rowIndex: rowKey,
          onChange: handleChange,
          defaultSelection: _this.getDefaultSelection()
        }, props)));
      };
    };

    _this.renderTable = function (_ref2) {
      var _classNames2;

      var prefixCls = _ref2.prefixCls,
          renderEmpty = _ref2.renderEmpty,
          dropdownPrefixCls = _ref2.dropdownPrefixCls,
          contextLocale = _ref2.contextLocale,
          contextGetPopupContainer = _ref2.getPopupContainer;

      var _a = _this.props,
          showHeader = _a.showHeader,
          locale = _a.locale,
          getPopupContainer = _a.getPopupContainer,
          restTableProps = __rest(_a, ["showHeader", "locale", "getPopupContainer"]); // do not pass prop.style to rc-table, since already apply it to container div


      var restProps = (0, _omit["default"])(restTableProps, ['style']);

      var data = _this.getCurrentPageData();

      var expandIconAsCell = _this.props.expandedRowRender && _this.props.expandIconAsCell !== false; // use props.getPopupContainer first

      var realGetPopupContainer = getPopupContainer || contextGetPopupContainer; // Merge too locales

      var mergedLocale = _extends(_extends({}, contextLocale), locale);

      if (!locale || !locale.emptyText) {
        mergedLocale.emptyText = renderEmpty('Table');
      }

      var classString = (0, _classnames["default"])("".concat(prefixCls, "-").concat(_this.props.size), (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-bordered"), _this.props.bordered), _defineProperty(_classNames2, "".concat(prefixCls, "-empty"), !data.length), _defineProperty(_classNames2, "".concat(prefixCls, "-without-column-header"), !showHeader), _classNames2));

      var columnsWithRowSelection = _this.renderRowSelection({
        prefixCls: prefixCls,
        locale: mergedLocale,
        getPopupContainer: realGetPopupContainer
      });

      var columns = _this.renderColumnsDropdown({
        columns: columnsWithRowSelection,
        prefixCls: prefixCls,
        dropdownPrefixCls: dropdownPrefixCls,
        locale: mergedLocale,
        getPopupContainer: realGetPopupContainer
      }).map(function (column, i) {
        var newColumn = _extends({}, column);

        newColumn.key = getColumnKey(newColumn, i);
        return newColumn;
      });

      var expandIconColumnIndex = columns[0] && columns[0].key === 'selection-column' ? 1 : 0;

      if ('expandIconColumnIndex' in restProps) {
        expandIconColumnIndex = restProps.expandIconColumnIndex;
      }

      return /*#__PURE__*/React.createElement(_rcTable["default"], _extends({
        ref: _this.setTableRef,
        key: "table",
        expandIcon: _this.renderExpandIcon(prefixCls)
      }, restProps, {
        onRow: function onRow(record, index) {
          return _this.onRow(prefixCls, record, index);
        },
        components: _this.state.components,
        prefixCls: prefixCls,
        data: data,
        columns: columns,
        showHeader: showHeader,
        className: classString,
        expandIconColumnIndex: expandIconColumnIndex,
        expandIconAsCell: expandIconAsCell,
        emptyText: mergedLocale.emptyText
      }));
    };

    _this.renderComponent = function (_ref3) {
      var getPrefixCls = _ref3.getPrefixCls,
          renderEmpty = _ref3.renderEmpty,
          getPopupContainer = _ref3.getPopupContainer;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          customizeDropdownPrefixCls = _this$props.dropdownPrefixCls,
          style = _this$props.style,
          className = _this$props.className;

      var data = _this.getCurrentPageData();

      var loading = _this.props.loading;

      if (typeof loading === 'boolean') {
        loading = {
          spinning: loading
        };
      }

      var prefixCls = getPrefixCls('table', customizePrefixCls);
      var dropdownPrefixCls = getPrefixCls('dropdown', customizeDropdownPrefixCls);
      var table = /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
        componentName: "Table",
        defaultLocale: _default2["default"].Table
      }, function (locale) {
        return _this.renderTable({
          prefixCls: prefixCls,
          renderEmpty: renderEmpty,
          dropdownPrefixCls: dropdownPrefixCls,
          contextLocale: locale,
          getPopupContainer: getPopupContainer
        });
      }); // if there is no pagination or no data,
      // the height of spin should decrease by half of pagination

      var paginationPatchClass = _this.hasPagination() && data && data.length !== 0 ? "".concat(prefixCls, "-with-pagination") : "".concat(prefixCls, "-without-pagination");
      return /*#__PURE__*/React.createElement("div", {
        className: (0, _classnames["default"])("".concat(prefixCls, "-wrapper"), className),
        style: style
      }, /*#__PURE__*/React.createElement(_spin["default"], _extends({}, loading, {
        className: loading.spinning ? "".concat(paginationPatchClass, " ").concat(prefixCls, "-spin-holder") : ''
      }), _this.renderPagination(prefixCls, 'top'), table, _this.renderPagination(prefixCls, 'bottom')));
    };

    var expandedRowRender = props.expandedRowRender,
        columnsProp = props.columns;
    (0, _warning["default"])(!('columnsPageRange' in props || 'columnsPageSize' in props), 'Table', '`columnsPageRange` and `columnsPageSize` are removed, please use ' + 'fixed columns instead, see: https://u.ant.design/fixed-columns.');

    if (expandedRowRender && (columnsProp || []).some(function (_ref4) {
      var fixed = _ref4.fixed;
      return !!fixed;
    })) {
      (0, _warning["default"])(false, 'Table', '`expandedRowRender` and `Column.fixed` are not compatible. Please use one of them at one time.');
    }

    var columns = columnsProp || (0, _util.normalizeColumns)(props.children);
    _this.state = _extends(_extends({}, _this.getDefaultSortOrder(columns || [])), {
      // 减少状态
      filters: _this.getDefaultFilters(columns),
      pagination: _this.getDefaultPagination(props),
      pivot: undefined,
      prevProps: props,
      components: createComponents(props.components),
      columns: columns
    });
    return _this;
  }

  _createClass(Table, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$state = this.state,
          columns = _this$state.columns,
          sortColumn = _this$state.sortColumn,
          sortOrder = _this$state.sortOrder;

      if (this.getSortOrderColumns(columns).length > 0) {
        var sortState = this.getSortStateFromColumns(columns);

        if (!isSameColumn(sortState.sortColumn, sortColumn) || sortState.sortOrder !== sortOrder) {
          this.setState(sortState);
        }
      }
    }
  }, {
    key: "getDefaultSelection",
    value: function getDefaultSelection() {
      var _this2 = this;

      var rowSelection = getRowSelection(this.props);

      if (!rowSelection.getCheckboxProps) {
        return [];
      }

      return this.getFlatData().filter(function (item, rowIndex) {
        return _this2.getCheckboxPropsByItem(item, rowIndex).defaultChecked;
      }).map(function (record, rowIndex) {
        return _this2.getRecordKey(record, rowIndex);
      });
    }
  }, {
    key: "getDefaultPagination",
    value: function getDefaultPagination(props) {
      var pagination = _typeof(props.pagination) === 'object' ? props.pagination : {};
      var current;

      if ('current' in pagination) {
        current = pagination.current;
      } else if ('defaultCurrent' in pagination) {
        current = pagination.defaultCurrent;
      }

      var pageSize;

      if ('pageSize' in pagination) {
        pageSize = pagination.pageSize;
      } else if ('defaultPageSize' in pagination) {
        pageSize = pagination.defaultPageSize;
      }

      return this.hasPagination(props) ? _extends(_extends(_extends({}, defaultPagination), pagination), {
        current: current || 1,
        pageSize: pageSize || 10
      }) : {};
    }
  }, {
    key: "getSortOrderColumns",
    value: function getSortOrderColumns(columns) {
      return (0, _util.flatFilter)(columns || (this.state || {}).columns || [], function (column) {
        return 'sortOrder' in column;
      });
    }
  }, {
    key: "getDefaultFilters",
    value: function getDefaultFilters(columns) {
      var definedFilters = getFiltersFromColumns(this.state, columns);
      var defaultFilteredValueColumns = (0, _util.flatFilter)(columns || [], function (column) {
        return typeof column.defaultFilteredValue !== 'undefined';
      });
      var defaultFilters = defaultFilteredValueColumns.reduce(function (soFar, col) {
        var colKey = getColumnKey(col);
        soFar[colKey] = col.defaultFilteredValue;
        return soFar;
      }, {});
      return _extends(_extends({}, defaultFilters), definedFilters);
    }
  }, {
    key: "getDefaultSortOrder",
    value: function getDefaultSortOrder(columns) {
      var definedSortState = this.getSortStateFromColumns(columns);
      var defaultSortedColumn = (0, _util.flatFilter)(columns || [], function (column) {
        return column.defaultSortOrder != null;
      })[0];

      if (defaultSortedColumn && !definedSortState.sortColumn) {
        return {
          sortColumn: defaultSortedColumn,
          sortOrder: defaultSortedColumn.defaultSortOrder
        };
      }

      return definedSortState;
    }
  }, {
    key: "getSortStateFromColumns",
    value: function getSortStateFromColumns(columns) {
      // return first column which sortOrder is not falsy
      var sortedColumn = this.getSortOrderColumns(columns).filter(function (col) {
        return col.sortOrder;
      })[0];

      if (sortedColumn) {
        return {
          sortColumn: sortedColumn,
          sortOrder: sortedColumn.sortOrder
        };
      }

      return {
        sortColumn: null,
        sortOrder: null
      };
    }
  }, {
    key: "getMaxCurrent",
    value: function getMaxCurrent(total) {
      var _this$state$paginatio = this.state.pagination,
          current = _this$state$paginatio.current,
          pageSize = _this$state$paginatio.pageSize;

      if ((current - 1) * pageSize >= total) {
        return Math.floor((total - 1) / pageSize) + 1;
      }

      return current;
    }
  }, {
    key: "getSorterFn",
    value: function getSorterFn(state) {
      var _ref5 = state || this.state,
          sortOrder = _ref5.sortOrder,
          sortColumn = _ref5.sortColumn;

      if (!sortOrder || !sortColumn || typeof sortColumn.sorter !== 'function') {
        return;
      }

      return function (a, b) {
        var result = sortColumn.sorter(a, b, sortOrder);

        if (result !== 0) {
          return sortOrder === 'descend' ? -result : result;
        }

        return 0;
      };
    }
  }, {
    key: "getCurrentPageData",
    value: function getCurrentPageData() {
      var data = this.getLocalData();
      var current;
      var pageSize;
      var state = this.state; // 如果没有分页的话，默认全部展示

      if (!this.hasPagination()) {
        pageSize = Number.MAX_VALUE;
        current = 1;
      } else {
        pageSize = state.pagination.pageSize;
        current = this.getMaxCurrent(state.pagination.total || data.length);
      } // 分页
      // ---
      // 当数据量少于等于每页数量时，直接设置数据
      // 否则进行读取分页数据


      if (data.length > pageSize || pageSize === Number.MAX_VALUE) {
        data = data.slice((current - 1) * pageSize, current * pageSize);
      }

      return data;
    }
  }, {
    key: "getFlatData",
    value: function getFlatData() {
      var childrenColumnName = this.props.childrenColumnName;
      return (0, _util.flatArray)(this.getLocalData(null, false), childrenColumnName);
    }
  }, {
    key: "getFlatCurrentPageData",
    value: function getFlatCurrentPageData() {
      var childrenColumnName = this.props.childrenColumnName;
      return (0, _util.flatArray)(this.getCurrentPageData(), childrenColumnName);
    }
  }, {
    key: "getLocalData",
    value: function getLocalData(state) {
      var _this3 = this;

      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var currentState = state || this.state;
      var dataSource = this.props.dataSource;
      var data = dataSource || []; // 优化本地排序

      data = data.slice(0);
      var sorterFn = this.getSorterFn(currentState);

      if (sorterFn) {
        data = this.recursiveSort(data, sorterFn);
      } // 筛选


      if (filter && currentState.filters) {
        Object.keys(currentState.filters).forEach(function (columnKey) {
          var col = _this3.findColumn(columnKey);

          if (!col) {
            return;
          }

          var values = currentState.filters[columnKey] || [];

          if (values.length === 0) {
            return;
          }

          var onFilter = col.onFilter;
          data = onFilter ? data.filter(function (record) {
            return values.some(function (v) {
              return onFilter(v, record);
            });
          }) : data;
        });
      }

      return data;
    }
  }, {
    key: "setSelectedRowKeys",
    value: function setSelectedRowKeys(selectedRowKeys, selectionInfo) {
      var _this4 = this;

      var selectWay = selectionInfo.selectWay,
          record = selectionInfo.record,
          checked = selectionInfo.checked,
          changeRowKeys = selectionInfo.changeRowKeys,
          nativeEvent = selectionInfo.nativeEvent;
      var rowSelection = getRowSelection(this.props);

      if (rowSelection && !('selectedRowKeys' in rowSelection)) {
        this.props.store.setState({
          selectedRowKeys: selectedRowKeys
        });
      }

      var data = this.getFlatData();

      if (!rowSelection.onChange && !rowSelection[selectWay]) {
        return;
      }

      var selectedRows = data.filter(function (row, i) {
        return selectedRowKeys.indexOf(_this4.getRecordKey(row, i)) >= 0;
      });

      if (rowSelection.onChange) {
        rowSelection.onChange(selectedRowKeys, selectedRows);
      }

      if (selectWay === 'onSelect' && rowSelection.onSelect) {
        rowSelection.onSelect(record, checked, selectedRows, nativeEvent);
      } else if (selectWay === 'onSelectMultiple' && rowSelection.onSelectMultiple) {
        var changeRows = data.filter(function (row, i) {
          return changeRowKeys.indexOf(_this4.getRecordKey(row, i)) >= 0;
        });
        rowSelection.onSelectMultiple(checked, selectedRows, changeRows);
      } else if (selectWay === 'onSelectAll' && rowSelection.onSelectAll) {
        var _changeRows = data.filter(function (row, i) {
          return changeRowKeys.indexOf(_this4.getRecordKey(row, i)) >= 0;
        });

        rowSelection.onSelectAll(checked, selectedRows, _changeRows);
      } else if (selectWay === 'onSelectInvert' && rowSelection.onSelectInvert) {
        rowSelection.onSelectInvert(selectedRowKeys);
      }
    }
  }, {
    key: "toggleSortOrder",
    value: function toggleSortOrder(column) {
      var sortDirections = column.sortDirections || this.props.sortDirections;
      var _this$state2 = this.state,
          sortOrder = _this$state2.sortOrder,
          sortColumn = _this$state2.sortColumn; // 只同时允许一列进行排序，否则会导致排序顺序的逻辑问题

      var newSortOrder; // 切换另一列时，丢弃 sortOrder 的状态

      if (isSameColumn(sortColumn, column) && sortOrder !== undefined) {
        // 按照sortDirections的内容依次切换排序状态
        var methodIndex = sortDirections.indexOf(sortOrder) + 1;
        newSortOrder = methodIndex === sortDirections.length ? undefined : sortDirections[methodIndex];
      } else {
        newSortOrder = sortDirections[0];
      }

      var newState = {
        sortOrder: newSortOrder,
        sortColumn: newSortOrder ? column : null
      }; // Controlled

      if (this.getSortOrderColumns().length === 0) {
        this.setState(newState, this.scrollToFirstRow);
      }

      var onChange = this.props.onChange;

      if (onChange) {
        onChange.apply(null, this.prepareParamsArguments(_extends(_extends({}, this.state), newState), column));
      }
    }
  }, {
    key: "hasPagination",
    value: function hasPagination(props) {
      return (props || this.props).pagination !== false;
    }
  }, {
    key: "isSortColumn",
    value: function isSortColumn(column) {
      var sortColumn = this.state.sortColumn;

      if (!column || !sortColumn) {
        return false;
      }

      return getColumnKey(sortColumn) === getColumnKey(column);
    } // Get pagination, filters, sorter

  }, {
    key: "prepareParamsArguments",
    value: function prepareParamsArguments(state, column) {
      var pagination = _extends({}, state.pagination); // remove useless handle function in Table.onChange


      delete pagination.onChange;
      delete pagination.onShowSizeChange;
      var filters = state.filters;
      var sorter = {};
      var currentColumn = column;

      if (state.sortColumn && state.sortOrder) {
        currentColumn = state.sortColumn;
        sorter.column = state.sortColumn;
        sorter.order = state.sortOrder;
      }

      if (currentColumn) {
        sorter.field = currentColumn.dataIndex;
        sorter.columnKey = getColumnKey(currentColumn);
      }

      var extra = {
        currentDataSource: this.getLocalData(state)
      };
      return [pagination, filters, sorter, extra];
    }
  }, {
    key: "findColumn",
    value: function findColumn(myKey) {
      var column;
      (0, _util.treeMap)(this.state.columns, function (c) {
        if (getColumnKey(c) === myKey) {
          column = c;
        }
      });
      return column;
    }
  }, {
    key: "recursiveSort",
    value: function recursiveSort(data, sorterFn) {
      var _this5 = this;

      var _this$props$childrenC = this.props.childrenColumnName,
          childrenColumnName = _this$props$childrenC === void 0 ? 'children' : _this$props$childrenC;
      return data.sort(sorterFn).map(function (item) {
        return item[childrenColumnName] ? _extends(_extends({}, item), _defineProperty({}, childrenColumnName, _this5.recursiveSort(item[childrenColumnName], sorterFn))) : item;
      });
    }
  }, {
    key: "renderPagination",
    value: function renderPagination(prefixCls, paginationPosition) {
      // 强制不需要分页
      if (!this.hasPagination()) {
        return null;
      }

      var size = 'default';
      var pagination = this.state.pagination;

      if (pagination.size) {
        size = pagination.size;
      } else if (this.props.size === 'middle' || this.props.size === 'small') {
        size = 'small';
      }

      var position = pagination.position || 'bottom';
      var total = pagination.total || this.getLocalData().length;
      return total > 0 && (position === paginationPosition || position === 'both') ? /*#__PURE__*/React.createElement(_pagination["default"], _extends({
        key: "pagination-".concat(paginationPosition)
      }, pagination, {
        className: (0, _classnames["default"])(pagination.className, "".concat(prefixCls, "-pagination")),
        onChange: this.handlePageChange,
        total: total,
        size: size,
        current: this.getMaxCurrent(total),
        onShowSizeChange: this.handleShowSizeChange
      })) : null;
    }
  }, {
    key: "renderRowSelection",
    value: function renderRowSelection(_ref6) {
      var _this6 = this;

      var prefixCls = _ref6.prefixCls,
          locale = _ref6.locale,
          getPopupContainer = _ref6.getPopupContainer;
      var rowSelection = this.props.rowSelection;
      var columns = this.state.columns.concat();

      if (rowSelection) {
        var data = this.getFlatCurrentPageData().filter(function (item, index) {
          if (rowSelection.getCheckboxProps) {
            return !_this6.getCheckboxPropsByItem(item, index).disabled;
          }

          return true;
        });
        var selectionColumnClass = (0, _classnames["default"])("".concat(prefixCls, "-selection-column"), _defineProperty({}, "".concat(prefixCls, "-selection-column-custom"), rowSelection.selections));

        var selectionColumn = _defineProperty({
          key: 'selection-column',
          render: this.renderSelectionBox(rowSelection.type),
          className: selectionColumnClass,
          fixed: rowSelection.fixed,
          width: rowSelection.columnWidth,
          title: rowSelection.columnTitle
        }, _rcTable.INTERNAL_COL_DEFINE, {
          className: "".concat(prefixCls, "-selection-col")
        });

        if (rowSelection.type !== 'radio') {
          var checkboxAllDisabled = data.every(function (item, index) {
            return _this6.getCheckboxPropsByItem(item, index).disabled;
          });
          selectionColumn.title = selectionColumn.title || /*#__PURE__*/React.createElement(_SelectionCheckboxAll["default"], {
            store: this.props.store,
            locale: locale,
            data: data,
            getCheckboxPropsByItem: this.getCheckboxPropsByItem,
            getRecordKey: this.getRecordKey,
            disabled: checkboxAllDisabled,
            prefixCls: prefixCls,
            onSelect: this.handleSelectRow,
            selections: rowSelection.selections,
            hideDefaultSelections: rowSelection.hideDefaultSelections,
            getPopupContainer: this.generatePopupContainerFunc(getPopupContainer)
          });
        }

        if ('fixed' in rowSelection) {
          selectionColumn.fixed = rowSelection.fixed;
        } else if (columns.some(function (column) {
          return column.fixed === 'left' || column.fixed === true;
        })) {
          selectionColumn.fixed = 'left';
        }

        if (columns[0] && columns[0].key === 'selection-column') {
          columns[0] = selectionColumn;
        } else {
          columns.unshift(selectionColumn);
        }
      }

      return columns;
    }
  }, {
    key: "renderColumnsDropdown",
    value: function renderColumnsDropdown(_ref7) {
      var _this7 = this;

      var prefixCls = _ref7.prefixCls,
          dropdownPrefixCls = _ref7.dropdownPrefixCls,
          columns = _ref7.columns,
          locale = _ref7.locale,
          getPopupContainer = _ref7.getPopupContainer;
      var _this$state3 = this.state,
          sortOrder = _this$state3.sortOrder,
          filters = _this$state3.filters;
      return (0, _util.treeMap)(columns, function (column, i) {
        var _classNames4;

        var key = getColumnKey(column, i);
        var filterDropdown;
        var sortButton;
        var onHeaderCell = column.onHeaderCell;

        var isSortColumn = _this7.isSortColumn(column);

        if (column.filters && column.filters.length > 0 || column.filterDropdown) {
          var colFilters = key in filters ? filters[key] : [];
          filterDropdown = /*#__PURE__*/React.createElement(_filterDropdown["default"], {
            locale: locale,
            column: column,
            selectedKeys: colFilters,
            confirmFilter: _this7.handleFilter,
            prefixCls: "".concat(prefixCls, "-filter"),
            dropdownPrefixCls: dropdownPrefixCls || 'ant-dropdown',
            getPopupContainer: _this7.generatePopupContainerFunc(getPopupContainer),
            key: "filter-dropdown"
          });
        }

        if (column.sorter) {
          var sortDirections = column.sortDirections || _this7.props.sortDirections;
          var isAscend = isSortColumn && sortOrder === 'ascend';
          var isDescend = isSortColumn && sortOrder === 'descend';
          var ascend = sortDirections.indexOf('ascend') !== -1 && /*#__PURE__*/React.createElement(_icon["default"], {
            className: "".concat(prefixCls, "-column-sorter-up ").concat(isAscend ? 'on' : 'off'),
            type: "caret-up",
            theme: "filled"
          });
          var descend = sortDirections.indexOf('descend') !== -1 && /*#__PURE__*/React.createElement(_icon["default"], {
            className: "".concat(prefixCls, "-column-sorter-down ").concat(isDescend ? 'on' : 'off'),
            type: "caret-down",
            theme: "filled"
          });
          sortButton = /*#__PURE__*/React.createElement("div", {
            title: locale.sortTitle,
            className: (0, _classnames["default"])("".concat(prefixCls, "-column-sorter-inner"), ascend && descend && "".concat(prefixCls, "-column-sorter-inner-full")),
            key: "sorter"
          }, ascend, descend);

          onHeaderCell = function onHeaderCell(col) {
            var colProps = {}; // Get original first

            if (column.onHeaderCell) {
              colProps = _extends({}, column.onHeaderCell(col));
            } // Add sorter logic


            var onHeaderCellClick = colProps.onClick;

            colProps.onClick = function () {
              _this7.toggleSortOrder(column);

              if (onHeaderCellClick) {
                onHeaderCellClick.apply(void 0, arguments);
              }
            };

            return colProps;
          };
        }

        return _extends(_extends({}, column), {
          className: (0, _classnames["default"])(column.className, (_classNames4 = {}, _defineProperty(_classNames4, "".concat(prefixCls, "-column-has-actions"), sortButton || filterDropdown), _defineProperty(_classNames4, "".concat(prefixCls, "-column-has-filters"), filterDropdown), _defineProperty(_classNames4, "".concat(prefixCls, "-column-has-sorters"), sortButton), _defineProperty(_classNames4, "".concat(prefixCls, "-column-sort"), isSortColumn && sortOrder), _classNames4)),
          title: [/*#__PURE__*/React.createElement("span", {
            key: "title",
            className: "".concat(prefixCls, "-header-column")
          }, /*#__PURE__*/React.createElement("div", {
            className: sortButton ? "".concat(prefixCls, "-column-sorters") : undefined
          }, /*#__PURE__*/React.createElement("span", {
            className: "".concat(prefixCls, "-column-title")
          }, _this7.renderColumnTitle(column.title)), /*#__PURE__*/React.createElement("span", {
            className: "".concat(prefixCls, "-column-sorter")
          }, sortButton))), filterDropdown],
          onHeaderCell: onHeaderCell
        });
      });
    }
  }, {
    key: "renderColumnTitle",
    value: function renderColumnTitle(title) {
      var _this$state4 = this.state,
          filters = _this$state4.filters,
          sortOrder = _this$state4.sortOrder,
          sortColumn = _this$state4.sortColumn; // https://github.com/ant-design/ant-design/issues/11246#issuecomment-405009167

      if (title instanceof Function) {
        return title({
          filters: filters,
          sortOrder: sortOrder,
          sortColumn: sortColumn
        });
      }

      return title;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var prevProps = prevState.prevProps;
      var columns = nextProps.columns || (0, _util.normalizeColumns)(nextProps.children);

      var nextState = _extends(_extends({}, prevState), {
        prevProps: nextProps,
        columns: columns
      });

      if ('pagination' in nextProps || 'pagination' in prevProps) {
        var newPagination = _extends(_extends(_extends({}, defaultPagination), prevState.pagination), nextProps.pagination);

        newPagination.current = newPagination.current || 1;
        newPagination.pageSize = newPagination.pageSize || 10;
        nextState = _extends(_extends({}, nextState), {
          pagination: nextProps.pagination !== false ? newPagination : emptyObject
        });
      }

      if (nextProps.rowSelection && 'selectedRowKeys' in nextProps.rowSelection) {
        nextProps.store.setState({
          selectedRowKeys: nextProps.rowSelection.selectedRowKeys || []
        });
      } else if (prevProps.rowSelection && !nextProps.rowSelection) {
        nextProps.store.setState({
          selectedRowKeys: []
        });
      }

      if ('dataSource' in nextProps && nextProps.dataSource !== prevProps.dataSource) {
        nextProps.store.setState({
          selectionDirty: false
        });
      } // https://github.com/ant-design/ant-design/issues/10133


      nextProps.setCheckboxPropsCache({}); // Update filters

      var filteredValueColumns = getFilteredValueColumns(nextState, nextState.columns);

      if (filteredValueColumns.length > 0) {
        var filtersFromColumns = getFiltersFromColumns(nextState, nextState.columns);

        var newFilters = _extends({}, nextState.filters);

        Object.keys(filtersFromColumns).forEach(function (key) {
          newFilters[key] = filtersFromColumns[key];
        });

        if (isFiltersChanged(nextState, newFilters)) {
          nextState = _extends(_extends({}, nextState), {
            filters: newFilters
          });
        }
      }

      if (!isTheSameComponents(nextProps.components, prevProps.components)) {
        var components = createComponents(nextProps.components);
        nextState = _extends(_extends({}, nextState), {
          components: components
        });
      }

      return nextState;
    }
  }]);

  return Table;
}(React.Component);

Table.propTypes = {
  dataSource: PropTypes.array,
  columns: PropTypes.array,
  prefixCls: PropTypes.string,
  useFixedHeader: PropTypes.bool,
  rowSelection: PropTypes.object,
  className: PropTypes.string,
  size: PropTypes.string,
  loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  bordered: PropTypes.bool,
  onChange: PropTypes.func,
  locale: PropTypes.object,
  dropdownPrefixCls: PropTypes.string,
  sortDirections: PropTypes.array,
  getPopupContainer: PropTypes.func
};
Table.defaultProps = {
  dataSource: [],
  useFixedHeader: false,
  className: '',
  size: 'default',
  loading: false,
  bordered: false,
  indentSize: 20,
  locale: {},
  rowKey: 'key',
  showHeader: true,
  sortDirections: ['ascend', 'descend'],
  childrenColumnName: 'children'
};
(0, _reactLifecyclesCompat.polyfill)(Table);

var StoreTable = /*#__PURE__*/function (_React$Component2) {
  _inherits(StoreTable, _React$Component2);

  var _super2 = _createSuper(StoreTable);

  function StoreTable(props) {
    var _this8;

    _classCallCheck(this, StoreTable);

    _this8 = _super2.call(this, props);

    _this8.setCheckboxPropsCache = function (cache) {
      return _this8.CheckboxPropsCache = cache;
    };

    _this8.CheckboxPropsCache = {};
    _this8.store = (0, _createStore["default"])({
      selectedRowKeys: getRowSelection(props).selectedRowKeys || [],
      selectionDirty: false
    });
    return _this8;
  }

  _createClass(StoreTable, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Table, _extends({}, this.props, {
        store: this.store,
        checkboxPropsCache: this.CheckboxPropsCache,
        setCheckboxPropsCache: this.setCheckboxPropsCache
      }));
    }
  }]);

  return StoreTable;
}(React.Component);

StoreTable.displayName = 'withStore(Table)';
StoreTable.Column = _Column["default"];
StoreTable.ColumnGroup = _ColumnGroup["default"];
var _default = StoreTable;
exports["default"] = _default;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Table_1 = __importDefault(__webpack_require__(979));

var Column_1 = __importDefault(__webpack_require__(523));

exports.Column = Column_1.default;

var ColumnGroup_1 = __importDefault(__webpack_require__(524));

exports.ColumnGroup = ColumnGroup_1.default;

var utils_1 = __webpack_require__(196);

exports.INTERNAL_COL_DEFINE = utils_1.INTERNAL_COL_DEFINE;
exports.default = Table_1.default;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var PropTypes = __importStar(__webpack_require__(19));

var shallowequal_1 = __importDefault(__webpack_require__(89));

var addEventListener_1 = __importDefault(__webpack_require__(260));

var warning_1 = __importDefault(__webpack_require__(259));

var mini_store_1 = __webpack_require__(115);

var merge_1 = __importDefault(__webpack_require__(980));

var component_classes_1 = __importDefault(__webpack_require__(337));

var classnames_1 = __importDefault(__webpack_require__(22));

var react_lifecycles_compat_1 = __webpack_require__(36);

var utils_1 = __webpack_require__(196);

var ColumnManager_1 = __importDefault(__webpack_require__(1041));

var HeadTable_1 = __importDefault(__webpack_require__(1042));

var BodyTable_1 = __importDefault(__webpack_require__(1055));

var Column_1 = __importDefault(__webpack_require__(523));

var ColumnGroup_1 = __importDefault(__webpack_require__(524));

var ExpandableTable_1 = __importDefault(__webpack_require__(1056));

var Table = /*#__PURE__*/function (_React$Component) {
  _inherits(Table, _React$Component);

  var _super = _createSuper(Table);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _super.call(this, props);
    _this.state = {};

    _this.getRowKey = function (record, index) {
      var rowKey = _this.props.rowKey;
      var key = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
      warning_1.default(key !== undefined, 'Each record in table should have a unique `key` prop,' + 'or set `rowKey` to an unique primary key.');
      return key === undefined ? index : key;
    };

    _this.handleWindowResize = function () {
      _this.syncFixedTableRowHeight();

      _this.setScrollPositionClassName();
    };

    _this.syncFixedTableRowHeight = function () {
      var tableRect = _this.tableNode.getBoundingClientRect(); // If tableNode's height less than 0, suppose it is hidden and don't recalculate rowHeight.
      // see: https://github.com/ant-design/ant-design/issues/4836


      if (tableRect.height !== undefined && tableRect.height <= 0) {
        return;
      }

      var prefixCls = _this.props.prefixCls;
      var headRows = _this.headTable ? _this.headTable.querySelectorAll('thead') : _this.bodyTable.querySelectorAll('thead');
      var bodyRows = _this.bodyTable.querySelectorAll(".".concat(prefixCls, "-row")) || [];
      var fixedColumnsHeadRowsHeight = [].map.call(headRows, function (row) {
        return row.getBoundingClientRect().height || 'auto';
      });

      var state = _this.store.getState();

      var fixedColumnsBodyRowsHeight = [].reduce.call(bodyRows, function (acc, row) {
        var rowKey = row.getAttribute('data-row-key');
        var height = row.getBoundingClientRect().height || state.fixedColumnsBodyRowsHeight[rowKey] || 'auto';
        acc[rowKey] = height;
        return acc;
      }, {});

      if (shallowequal_1.default(state.fixedColumnsHeadRowsHeight, fixedColumnsHeadRowsHeight) && shallowequal_1.default(state.fixedColumnsBodyRowsHeight, fixedColumnsBodyRowsHeight)) {
        return;
      }

      _this.store.setState({
        fixedColumnsHeadRowsHeight: fixedColumnsHeadRowsHeight,
        fixedColumnsBodyRowsHeight: fixedColumnsBodyRowsHeight
      });
    };

    _this.handleBodyScrollLeft = function (e) {
      // Fix https://github.com/ant-design/ant-design/issues/7635
      if (e.currentTarget !== e.target) {
        return;
      }

      var target = e.target;
      var _this$props$scroll = _this.props.scroll,
          scroll = _this$props$scroll === void 0 ? {} : _this$props$scroll;

      var _assertThisInitialize = _assertThisInitialized(_this),
          headTable = _assertThisInitialize.headTable,
          bodyTable = _assertThisInitialize.bodyTable;

      if (target.scrollLeft !== _this.lastScrollLeft && scroll.x) {
        if (target === bodyTable && headTable) {
          headTable.scrollLeft = target.scrollLeft;
        } else if (target === headTable && bodyTable) {
          bodyTable.scrollLeft = target.scrollLeft;
        }

        _this.setScrollPositionClassName();
      } // Remember last scrollLeft for scroll direction detecting.


      _this.lastScrollLeft = target.scrollLeft;
    };

    _this.handleBodyScrollTop = function (e) {
      var target = e.target; // Fix https://github.com/ant-design/ant-design/issues/9033

      if (e.currentTarget !== target) {
        return;
      }

      var _this$props$scroll2 = _this.props.scroll,
          scroll = _this$props$scroll2 === void 0 ? {} : _this$props$scroll2;

      var _assertThisInitialize2 = _assertThisInitialized(_this),
          headTable = _assertThisInitialize2.headTable,
          bodyTable = _assertThisInitialize2.bodyTable,
          fixedColumnsBodyLeft = _assertThisInitialize2.fixedColumnsBodyLeft,
          fixedColumnsBodyRight = _assertThisInitialize2.fixedColumnsBodyRight;

      if (target.scrollTop !== _this.lastScrollTop && scroll.y && target !== headTable) {
        var scrollTop = target.scrollTop;

        if (fixedColumnsBodyLeft && target !== fixedColumnsBodyLeft) {
          fixedColumnsBodyLeft.scrollTop = scrollTop;
        }

        if (fixedColumnsBodyRight && target !== fixedColumnsBodyRight) {
          fixedColumnsBodyRight.scrollTop = scrollTop;
        }

        if (bodyTable && target !== bodyTable) {
          bodyTable.scrollTop = scrollTop;
        }
      } // Remember last scrollTop for scroll direction detecting.


      _this.lastScrollTop = target.scrollTop;
    };

    _this.handleBodyScroll = function (e) {
      _this.handleBodyScrollLeft(e);

      _this.handleBodyScrollTop(e);
    };

    _this.handleWheel = function (event) {
      var _this$props$scroll3 = _this.props.scroll,
          scroll = _this$props$scroll3 === void 0 ? {} : _this$props$scroll3;

      if (window.navigator.userAgent.match(/Trident\/7\./) && scroll.y) {
        var wd = event.deltaY;
        var target = event.target;

        var _assertThisInitialize3 = _assertThisInitialized(_this),
            bodyTable = _assertThisInitialize3.bodyTable,
            fixedColumnsBodyLeft = _assertThisInitialize3.fixedColumnsBodyLeft,
            fixedColumnsBodyRight = _assertThisInitialize3.fixedColumnsBodyRight;

        var scrollTop = 0;

        if (_this.lastScrollTop) {
          scrollTop = _this.lastScrollTop + wd;
        } else {
          scrollTop = wd;
        }

        if (fixedColumnsBodyLeft && target !== fixedColumnsBodyLeft) {
          event.preventDefault();
          fixedColumnsBodyLeft.scrollTop = scrollTop;
        }

        if (fixedColumnsBodyRight && target !== fixedColumnsBodyRight) {
          event.preventDefault();
          fixedColumnsBodyRight.scrollTop = scrollTop;
        }

        if (bodyTable && target !== bodyTable) {
          // https://github.com/ant-design/ant-design/issues/22341
          event.preventDefault();
          bodyTable.scrollTop = scrollTop;
        }
      }
    };

    _this.saveRef = function (name) {
      return function (node) {
        _this[name] = node;
      };
    };

    _this.saveTableNodeRef = function (node) {
      _this.tableNode = node;
    };

    ['onRowClick', 'onRowDoubleClick', 'onRowContextMenu', 'onRowMouseEnter', 'onRowMouseLeave'].forEach(function (name) {
      warning_1.default(props[name] === undefined, "".concat(name, " is deprecated, please use onRow instead."));
    });
    warning_1.default(props.getBodyWrapper === undefined, 'getBodyWrapper is deprecated, please use custom components instead.');
    _this.columnManager = new ColumnManager_1.default(props.columns, props.children);
    _this.store = mini_store_1.create({
      currentHoverKey: null,
      fixedColumnsHeadRowsHeight: [],
      fixedColumnsBodyRowsHeight: {}
    });

    _this.setScrollPosition('left');

    _this.debouncedWindowResize = utils_1.debounce(_this.handleWindowResize, 150);
    return _this;
  }

  _createClass(Table, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        table: {
          props: this.props,
          columnManager: this.columnManager,
          saveRef: this.saveRef,
          components: merge_1.default({
            table: 'table',
            header: {
              wrapper: 'thead',
              row: 'tr',
              cell: 'th'
            },
            body: {
              wrapper: 'tbody',
              row: 'tr',
              cell: 'td'
            }
          }, this.props.components)
        }
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.columnManager.isAnyColumnsFixed()) {
        this.handleWindowResize();
        this.resizeEvent = addEventListener_1.default(window, 'resize', this.debouncedWindowResize);
      } // https://github.com/ant-design/ant-design/issues/11635


      if (this.headTable) {
        this.headTable.scrollLeft = 0;
      }

      if (this.bodyTable) {
        this.bodyTable.scrollLeft = 0;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.columnManager.isAnyColumnsFixed()) {
        this.handleWindowResize();

        if (!this.resizeEvent) {
          this.resizeEvent = addEventListener_1.default(window, 'resize', this.debouncedWindowResize);
        }
      } // when table changes to empty, reset scrollLeft


      if (prevProps.data.length > 0 && this.props.data.length === 0 && this.hasScrollX()) {
        this.resetScrollX();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.resizeEvent) {
        this.resizeEvent.remove();
      }

      if (this.debouncedWindowResize) {
        this.debouncedWindowResize.cancel();
      }
    }
  }, {
    key: "setScrollPosition",
    value: function setScrollPosition(position) {
      this.scrollPosition = position;

      if (this.tableNode) {
        var prefixCls = this.props.prefixCls;

        if (position === 'both') {
          component_classes_1.default(this.tableNode).remove(new RegExp("^".concat(prefixCls, "-scroll-position-.+$"))).add("".concat(prefixCls, "-scroll-position-left")).add("".concat(prefixCls, "-scroll-position-right"));
        } else {
          component_classes_1.default(this.tableNode).remove(new RegExp("^".concat(prefixCls, "-scroll-position-.+$"))).add("".concat(prefixCls, "-scroll-position-").concat(position));
        }
      }
    }
  }, {
    key: "setScrollPositionClassName",
    value: function setScrollPositionClassName() {
      var node = this.bodyTable;
      var scrollToLeft = node.scrollLeft === 0;
      var scrollToRight = node.scrollLeft + 1 >= node.children[0].getBoundingClientRect().width - node.getBoundingClientRect().width;

      if (scrollToLeft && scrollToRight) {
        this.setScrollPosition('both');
      } else if (scrollToLeft) {
        this.setScrollPosition('left');
      } else if (scrollToRight) {
        this.setScrollPosition('right');
      } else if (this.scrollPosition !== 'middle') {
        this.setScrollPosition('middle');
      }
    }
  }, {
    key: "isTableLayoutFixed",
    value: function isTableLayoutFixed() {
      var _this$props = this.props,
          tableLayout = _this$props.tableLayout,
          _this$props$columns = _this$props.columns,
          columns = _this$props$columns === void 0 ? [] : _this$props$columns,
          useFixedHeader = _this$props.useFixedHeader,
          _this$props$scroll4 = _this$props.scroll,
          scroll = _this$props$scroll4 === void 0 ? {} : _this$props$scroll4;

      if (typeof tableLayout !== 'undefined') {
        return tableLayout === 'fixed';
      } // if one column is ellipsis, use fixed table layout to fix align issue


      if (columns.some(function (_ref) {
        var ellipsis = _ref.ellipsis;
        return !!ellipsis;
      })) {
        return true;
      } // if header fixed, use fixed table layout to fix align issue


      if (useFixedHeader || scroll.y) {
        return true;
      } // if scroll.x is number/px/% width value, we should fixed table layout
      // to avoid long word layout broken issue


      if (scroll.x && scroll.x !== true && scroll.x !== 'max-content') {
        return true;
      }

      return false;
    }
  }, {
    key: "resetScrollX",
    value: function resetScrollX() {
      if (this.headTable) {
        this.headTable.scrollLeft = 0;
      }

      if (this.bodyTable) {
        this.bodyTable.scrollLeft = 0;
      }
    }
  }, {
    key: "hasScrollX",
    value: function hasScrollX() {
      var _this$props$scroll5 = this.props.scroll,
          scroll = _this$props$scroll5 === void 0 ? {} : _this$props$scroll5;
      return 'x' in scroll;
    }
  }, {
    key: "renderMainTable",
    value: function renderMainTable() {
      var _this$props2 = this.props,
          scroll = _this$props2.scroll,
          prefixCls = _this$props2.prefixCls;
      var isAnyColumnsFixed = this.columnManager.isAnyColumnsFixed();
      var scrollable = isAnyColumnsFixed || scroll.x || scroll.y;
      var table = [this.renderTable({
        columns: this.columnManager.groupedColumns(),
        isAnyColumnsFixed: isAnyColumnsFixed
      }), this.renderEmptyText(), this.renderFooter()];
      return scrollable ? React.createElement("div", {
        className: "".concat(prefixCls, "-scroll")
      }, table) : table;
    }
  }, {
    key: "renderLeftFixedTable",
    value: function renderLeftFixedTable() {
      var prefixCls = this.props.prefixCls;
      return React.createElement("div", {
        className: "".concat(prefixCls, "-fixed-left")
      }, this.renderTable({
        columns: this.columnManager.leftColumns(),
        fixed: 'left'
      }));
    }
  }, {
    key: "renderRightFixedTable",
    value: function renderRightFixedTable() {
      var prefixCls = this.props.prefixCls;
      return React.createElement("div", {
        className: "".concat(prefixCls, "-fixed-right")
      }, this.renderTable({
        columns: this.columnManager.rightColumns(),
        fixed: 'right'
      }));
    }
  }, {
    key: "renderTable",
    value: function renderTable(options) {
      var columns = options.columns,
          fixed = options.fixed,
          isAnyColumnsFixed = options.isAnyColumnsFixed;
      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          _this$props3$scroll = _this$props3.scroll,
          scroll = _this$props3$scroll === void 0 ? {} : _this$props3$scroll;
      var tableClassName = scroll.x || fixed ? "".concat(prefixCls, "-fixed") : '';
      var headTable = React.createElement(HeadTable_1.default, {
        key: "head",
        columns: columns,
        fixed: fixed,
        tableClassName: tableClassName,
        handleBodyScrollLeft: this.handleBodyScrollLeft,
        expander: this.expander
      });
      var bodyTable = React.createElement(BodyTable_1.default, {
        key: "body",
        columns: columns,
        fixed: fixed,
        tableClassName: tableClassName,
        getRowKey: this.getRowKey,
        handleWheel: this.handleWheel,
        handleBodyScroll: this.handleBodyScroll,
        expander: this.expander,
        isAnyColumnsFixed: isAnyColumnsFixed
      });
      return [headTable, bodyTable];
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var _this$props4 = this.props,
          title = _this$props4.title,
          prefixCls = _this$props4.prefixCls;
      return title ? React.createElement("div", {
        className: "".concat(prefixCls, "-title"),
        key: "title"
      }, title(this.props.data)) : null;
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      var _this$props5 = this.props,
          footer = _this$props5.footer,
          prefixCls = _this$props5.prefixCls;
      return footer ? React.createElement("div", {
        className: "".concat(prefixCls, "-footer"),
        key: "footer"
      }, footer(this.props.data)) : null;
    }
  }, {
    key: "renderEmptyText",
    value: function renderEmptyText() {
      var _this$props6 = this.props,
          emptyText = _this$props6.emptyText,
          prefixCls = _this$props6.prefixCls,
          data = _this$props6.data;

      if (data.length) {
        return null;
      }

      var emptyClassName = "".concat(prefixCls, "-placeholder");
      return React.createElement("div", {
        className: emptyClassName,
        key: "emptyText"
      }, typeof emptyText === 'function' ? emptyText() : emptyText);
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames_1$default,
          _this2 = this;

      var props = this.props;
      var prefixCls = props.prefixCls;

      if (this.state.columns) {
        this.columnManager.reset(props.columns);
      } else if (this.state.children) {
        this.columnManager.reset(null, props.children);
      }

      var tableClassName = classnames_1.default(props.prefixCls, props.className, (_classnames_1$default = {}, _defineProperty(_classnames_1$default, "".concat(prefixCls, "-fixed-header"), props.useFixedHeader || props.scroll && props.scroll.y), _defineProperty(_classnames_1$default, "".concat(prefixCls, "-scroll-position-left ").concat(prefixCls, "-scroll-position-right"), this.scrollPosition === 'both'), _defineProperty(_classnames_1$default, "".concat(prefixCls, "-scroll-position-").concat(this.scrollPosition), this.scrollPosition !== 'both'), _defineProperty(_classnames_1$default, "".concat(prefixCls, "-layout-fixed"), this.isTableLayoutFixed()), _classnames_1$default));
      var hasLeftFixed = this.columnManager.isAnyColumnsLeftFixed();
      var hasRightFixed = this.columnManager.isAnyColumnsRightFixed();
      var dataAndAriaProps = utils_1.getDataAndAriaProps(props);
      return React.createElement(mini_store_1.Provider, {
        store: this.store
      }, React.createElement(ExpandableTable_1.default, Object.assign({}, props, {
        columnManager: this.columnManager,
        getRowKey: this.getRowKey
      }), function (expander) {
        _this2.expander = expander;
        return React.createElement("div", Object.assign({
          ref: _this2.saveTableNodeRef,
          className: tableClassName,
          style: props.style,
          id: props.id
        }, dataAndAriaProps), _this2.renderTitle(), React.createElement("div", {
          className: "".concat(prefixCls, "-content")
        }, _this2.renderMainTable(), hasLeftFixed && _this2.renderLeftFixedTable(), hasRightFixed && _this2.renderRightFixedTable()));
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.columns && nextProps.columns !== prevState.columns) {
        return {
          columns: nextProps.columns,
          children: null
        };
      }

      if (nextProps.children !== prevState.children) {
        return {
          columns: null,
          children: nextProps.children
        };
      }

      return null;
    }
  }]);

  return Table;
}(React.Component);

Table.childContextTypes = {
  table: PropTypes.any,
  components: PropTypes.any
};
Table.Column = Column_1.default;
Table.ColumnGroup = ColumnGroup_1.default;
Table.defaultProps = {
  data: [],
  useFixedHeader: false,
  rowKey: 'key',
  rowClassName: function rowClassName() {
    return '';
  },
  onRow: function onRow() {},
  onHeaderRow: function onHeaderRow() {},
  prefixCls: 'rc-table',
  bodyStyle: {},
  style: {},
  showHeader: true,
  scroll: {},
  rowRef: function rowRef() {
    return null;
  },
  emptyText: function emptyText() {
    return 'No Data';
  }
};
react_lifecycles_compat_1.polyfill(Table);
exports.default = Table;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(981),
    createAssigner = __webpack_require__(1032);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(349),
    assignMergeValue = __webpack_require__(510),
    baseFor = __webpack_require__(1010),
    baseMergeDeep = __webpack_require__(1012),
    isObject = __webpack_require__(116),
    keysIn = __webpack_require__(516),
    safeGet = __webpack_require__(515);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 982 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(264);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(264);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(264);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(264);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(263);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 988 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 989 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 990 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(263),
    Map = __webpack_require__(350),
    MapCache = __webpack_require__(352);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(351),
    isMasked = __webpack_require__(995),
    isObject = __webpack_require__(116),
    toSource = __webpack_require__(509);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(265);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 994 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(996);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(101);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 997 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(999),
    ListCache = __webpack_require__(263),
    Map = __webpack_require__(350);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1000),
    hashDelete = __webpack_require__(1001),
    hashGet = __webpack_require__(1002),
    hashHas = __webpack_require__(1003),
    hashSet = __webpack_require__(1004);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(266);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1001 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(266);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(266);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(266);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(267);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1006 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(267);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(267);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(267);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1011);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 1011 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(510),
    cloneBuffer = __webpack_require__(1013),
    cloneTypedArray = __webpack_require__(1014),
    copyArray = __webpack_require__(1016),
    initCloneObject = __webpack_require__(1017),
    isArguments = __webpack_require__(355),
    isArray = __webpack_require__(132),
    isArrayLikeObject = __webpack_require__(1020),
    isBuffer = __webpack_require__(357),
    isFunction = __webpack_require__(351),
    isObject = __webpack_require__(116),
    isPlainObject = __webpack_require__(1022),
    isTypedArray = __webpack_require__(358),
    safeGet = __webpack_require__(515),
    toPlainObject = __webpack_require__(1026);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(101);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(220)(module)))

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(1015);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(512);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 1016 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(1018),
    getPrototype = __webpack_require__(513),
    isPrototype = __webpack_require__(354);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(116);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(195),
    isObjectLike = __webpack_require__(159);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(268),
    isObjectLike = __webpack_require__(159);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 1021 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(195),
    getPrototype = __webpack_require__(513),
    isObjectLike = __webpack_require__(159);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(195),
    isLength = __webpack_require__(356),
    isObjectLike = __webpack_require__(159);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1024 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(508);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(220)(module)))

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(1027),
    keysIn = __webpack_require__(516);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(1028),
    baseAssignValue = __webpack_require__(353);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(353),
    eq = __webpack_require__(222);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 1029 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(116),
    isPrototype = __webpack_require__(354),
    nativeKeysIn = __webpack_require__(1031);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 1031 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(1033),
    isIterateeCall = __webpack_require__(1040);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(360),
    overRest = __webpack_require__(1034),
    setToString = __webpack_require__(1036);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(1035);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 1035 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1037),
    shortOut = __webpack_require__(1039);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1038),
    defineProperty = __webpack_require__(511),
    identity = __webpack_require__(360);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1038 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1039 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(222),
    isArrayLike = __webpack_require__(268),
    isIndex = __webpack_require__(359),
    isObject = __webpack_require__(116);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable no-underscore-dangle */

var React = __importStar(__webpack_require__(0));

var ColumnManager = /*#__PURE__*/function () {
  function ColumnManager(columns, elements) {
    _classCallCheck(this, ColumnManager);

    this._cached = {};
    this.columns = columns || this.normalize(elements);
  }

  _createClass(ColumnManager, [{
    key: "isAnyColumnsFixed",
    value: function isAnyColumnsFixed() {
      var _this = this;

      return this._cache('isAnyColumnsFixed', function () {
        return _this.columns.some(function (column) {
          return !!column.fixed;
        });
      });
    }
  }, {
    key: "isAnyColumnsLeftFixed",
    value: function isAnyColumnsLeftFixed() {
      var _this2 = this;

      return this._cache('isAnyColumnsLeftFixed', function () {
        return _this2.columns.some(function (column) {
          return column.fixed === 'left' || column.fixed === true;
        });
      });
    }
  }, {
    key: "isAnyColumnsRightFixed",
    value: function isAnyColumnsRightFixed() {
      var _this3 = this;

      return this._cache('isAnyColumnsRightFixed', function () {
        return _this3.columns.some(function (column) {
          return column.fixed === 'right';
        });
      });
    }
  }, {
    key: "leftColumns",
    value: function leftColumns() {
      var _this4 = this;

      return this._cache('leftColumns', function () {
        return _this4.groupedColumns().filter(function (column) {
          return column.fixed === 'left' || column.fixed === true;
        });
      });
    }
  }, {
    key: "rightColumns",
    value: function rightColumns() {
      var _this5 = this;

      return this._cache('rightColumns', function () {
        return _this5.groupedColumns().filter(function (column) {
          return column.fixed === 'right';
        });
      });
    }
  }, {
    key: "leafColumns",
    value: function leafColumns() {
      var _this6 = this;

      return this._cache('leafColumns', function () {
        return _this6._leafColumns(_this6.columns);
      });
    }
  }, {
    key: "leftLeafColumns",
    value: function leftLeafColumns() {
      var _this7 = this;

      return this._cache('leftLeafColumns', function () {
        return _this7._leafColumns(_this7.leftColumns());
      });
    }
  }, {
    key: "rightLeafColumns",
    value: function rightLeafColumns() {
      var _this8 = this;

      return this._cache('rightLeafColumns', function () {
        return _this8._leafColumns(_this8.rightColumns());
      });
    } // add appropriate rowspan and colspan to column

  }, {
    key: "groupedColumns",
    value: function groupedColumns() {
      var _this9 = this;

      return this._cache('groupedColumns', function () {
        var _groupColumns = function _groupColumns(columns) {
          var currentRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          var parentColumn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var rows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

          /* eslint-disable no-param-reassign */
          // track how many rows we got
          rows[currentRow] = rows[currentRow] || [];
          var grouped = [];

          var setRowSpan = function setRowSpan(column) {
            var rowSpan = rows.length - currentRow;

            if (column && !column.children && // parent columns are supposed to be one row
            rowSpan > 1 && (!column.rowSpan || column.rowSpan < rowSpan)) {
              column.rowSpan = rowSpan;
            }
          };

          columns.forEach(function (column, index) {
            var newColumn = _objectSpread({}, column);

            rows[currentRow].push(newColumn);
            parentColumn.colSpan = parentColumn.colSpan || 0;

            if (newColumn.children && newColumn.children.length > 0) {
              newColumn.children = _groupColumns(newColumn.children, currentRow + 1, newColumn, rows);
              parentColumn.colSpan += newColumn.colSpan;
            } else {
              parentColumn.colSpan += 1;
            } // update rowspan to all same row columns


            for (var i = 0; i < rows[currentRow].length - 1; i += 1) {
              setRowSpan(rows[currentRow][i]);
            } // last column, update rowspan immediately


            if (index + 1 === columns.length) {
              setRowSpan(newColumn);
            }

            grouped.push(newColumn);
          });
          return grouped;
          /* eslint-enable no-param-reassign */
        };

        return _groupColumns(_this9.columns);
      });
    }
  }, {
    key: "normalize",
    value: function normalize(elements) {
      var _this10 = this;

      var columns = [];
      React.Children.forEach(elements, function (element) {
        if (!React.isValidElement(element)) {
          return;
        }

        var column = _objectSpread({}, element.props);

        if (element.key) {
          column.key = element.key;
        }

        if (element.type.isTableColumnGroup) {
          column.children = _this10.normalize(column.children);
        }

        columns.push(column);
      });
      return columns;
    }
  }, {
    key: "reset",
    value: function reset(columns, elements) {
      this.columns = columns || this.normalize(elements);
      this._cached = {};
    }
  }, {
    key: "_cache",
    value: function _cache(name, fn) {
      if (name in this._cached) {
        return this._cached[name];
      }

      this._cached[name] = fn();
      return this._cached[name];
    }
  }, {
    key: "_leafColumns",
    value: function _leafColumns(columns) {
      var _this11 = this;

      var leafColumns = [];
      columns.forEach(function (column) {
        if (!column.children) {
          leafColumns.push(column);
        } else {
          leafColumns.push.apply(leafColumns, _toConsumableArray(_this11._leafColumns(column.children)));
        }
      });
      return leafColumns;
    }
  }]);

  return ColumnManager;
}();

exports.default = ColumnManager;
/* eslint-enable */

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var PropTypes = __importStar(__webpack_require__(19));

var classnames_1 = __importDefault(__webpack_require__(22));

var utils_1 = __webpack_require__(196);

var BaseTable_1 = __importDefault(__webpack_require__(518));

function HeadTable(props, _ref) {
  var table = _ref.table;
  var _table$props = table.props,
      prefixCls = _table$props.prefixCls,
      scroll = _table$props.scroll,
      showHeader = _table$props.showHeader;
  var columns = props.columns,
      fixed = props.fixed,
      tableClassName = props.tableClassName,
      handleBodyScrollLeft = props.handleBodyScrollLeft,
      expander = props.expander;
  var saveRef = table.saveRef;
  var useFixedHeader = table.props.useFixedHeader;
  var headStyle = {};
  var scrollbarWidth = utils_1.measureScrollbar({
    direction: 'vertical'
  });

  if (scroll.y) {
    useFixedHeader = true; // https://github.com/ant-design/ant-design/issues/17051

    var scrollbarWidthOfHeader = utils_1.measureScrollbar({
      direction: 'horizontal',
      prefixCls: prefixCls
    }); // Add negative margin bottom for scroll bar overflow bug

    if (scrollbarWidthOfHeader > 0 && !fixed) {
      headStyle.marginBottom = "-".concat(scrollbarWidthOfHeader, "px");
      headStyle.paddingBottom = '0px'; // https://github.com/ant-design/ant-design/pull/19986

      headStyle.minWidth = "".concat(scrollbarWidth, "px"); // https://github.com/ant-design/ant-design/issues/17051

      headStyle.overflowX = 'scroll';
      headStyle.overflowY = scrollbarWidth === 0 ? 'hidden' : 'scroll';
    }
  }

  if (!useFixedHeader || !showHeader) {
    return null;
  }

  return React.createElement("div", {
    key: "headTable",
    ref: fixed ? null : saveRef('headTable'),
    className: classnames_1.default("".concat(prefixCls, "-header"), _defineProperty({}, "".concat(prefixCls, "-hide-scrollbar"), scrollbarWidth > 0)),
    style: headStyle,
    onScroll: handleBodyScrollLeft
  }, React.createElement(BaseTable_1.default, {
    tableClassName: tableClassName,
    hasHead: true,
    hasBody: false,
    fixed: fixed,
    columns: columns,
    expander: expander
  }));
}

exports.default = HeadTable;
HeadTable.contextTypes = {
  table: PropTypes.any
};

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var PropTypes = __importStar(__webpack_require__(19));

var utils_1 = __webpack_require__(196);

var ColGroup = function ColGroup(props, _ref) {
  var table = _ref.table;
  var _table$props = table.props,
      prefixCls = _table$props.prefixCls,
      expandIconAsCell = _table$props.expandIconAsCell;
  var fixed = props.fixed;
  var cols = [];

  if (expandIconAsCell && fixed !== 'right') {
    cols.push(React.createElement("col", {
      className: "".concat(prefixCls, "-expand-icon-col"),
      key: "rc-table-expand-icon-col"
    }));
  }

  var leafColumns;

  if (fixed === 'left') {
    leafColumns = table.columnManager.leftLeafColumns();
  } else if (fixed === 'right') {
    leafColumns = table.columnManager.rightLeafColumns();
  } else {
    leafColumns = table.columnManager.leafColumns();
  }

  cols = cols.concat(leafColumns.map(function (_ref2) {
    var key = _ref2.key,
        dataIndex = _ref2.dataIndex,
        width = _ref2.width,
        additionalProps = _ref2[utils_1.INTERNAL_COL_DEFINE];
    var mergedKey = key !== undefined ? key : dataIndex;
    return React.createElement("col", Object.assign({
      key: mergedKey,
      style: {
        width: width,
        minWidth: width
      }
    }, additionalProps));
  }));
  return React.createElement("colgroup", null, cols);
};

ColGroup.contextTypes = {
  table: PropTypes.any
};
exports.default = ColGroup;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var PropTypes = __importStar(__webpack_require__(19));

var TableHeaderRow_1 = __importDefault(__webpack_require__(1045));

function getHeaderRows(_ref) {
  var _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      _ref$currentRow = _ref.currentRow,
      currentRow = _ref$currentRow === void 0 ? 0 : _ref$currentRow,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? [] : _ref$rows,
      _ref$isLast = _ref.isLast,
      isLast = _ref$isLast === void 0 ? true : _ref$isLast;
  // eslint-disable-next-line no-param-reassign
  rows[currentRow] = rows[currentRow] || [];
  columns.forEach(function (column, i) {
    if (column.rowSpan && rows.length < column.rowSpan) {
      while (rows.length < column.rowSpan) {
        rows.push([]);
      }
    }

    var cellIsLast = isLast && i === columns.length - 1;
    var cell = {
      key: column.key,
      className: column.className || '',
      children: column.title,
      isLast: cellIsLast,
      column: column
    };

    if (column.children) {
      getHeaderRows({
        columns: column.children,
        currentRow: currentRow + 1,
        rows: rows,
        isLast: cellIsLast
      });
    }

    if ('colSpan' in column) {
      cell.colSpan = column.colSpan;
    }

    if ('rowSpan' in column) {
      cell.rowSpan = column.rowSpan;
    }

    if (cell.colSpan !== 0) {
      rows[currentRow].push(cell);
    }
  });
  return rows.filter(function (row) {
    return row.length > 0;
  });
}

var TableHeader = function TableHeader(props, _ref2) {
  var table = _ref2.table;
  var components = table.components;
  var _table$props = table.props,
      prefixCls = _table$props.prefixCls,
      showHeader = _table$props.showHeader,
      onHeaderRow = _table$props.onHeaderRow;
  var expander = props.expander,
      columns = props.columns,
      fixed = props.fixed;

  if (!showHeader) {
    return null;
  }

  var rows = getHeaderRows({
    columns: columns
  });
  expander.renderExpandIndentCell(rows, fixed);
  var HeaderWrapper = components.header.wrapper;
  return React.createElement(HeaderWrapper, {
    className: "".concat(prefixCls, "-thead")
  }, rows.map(function (row, index) {
    return React.createElement(TableHeaderRow_1.default, {
      prefixCls: prefixCls,
      key: index,
      index: index,
      fixed: fixed,
      columns: columns,
      rows: rows,
      row: row,
      components: components,
      onHeaderRow: onHeaderRow
    });
  }));
};

TableHeader.contextTypes = {
  table: PropTypes.any
};
exports.default = TableHeader;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var mini_store_1 = __webpack_require__(115);

var classnames_1 = __importDefault(__webpack_require__(22));

function TableHeaderRow(_ref) {
  var row = _ref.row,
      index = _ref.index,
      height = _ref.height,
      components = _ref.components,
      onHeaderRow = _ref.onHeaderRow,
      prefixCls = _ref.prefixCls;
  var HeaderRow = components.header.row;
  var HeaderCell = components.header.cell;
  var rowProps = onHeaderRow(row.map(function (cell) {
    return cell.column;
  }), index);
  var customStyle = rowProps ? rowProps.style : {};

  var style = _objectSpread({
    // https://github.com/ant-design/ant-design/issues/20126
    // https://github.com/ant-design/ant-design/issues/20269
    // https://github.com/ant-design/ant-design/issues/20495
    height: row.length > 1 && index === 0 && height && height !== 'auto' ? parseInt(height.toString(), 10) : height
  }, customStyle);

  return React.createElement(HeaderRow, Object.assign({}, rowProps, {
    style: style
  }), row.map(function (cell, i) {
    var _classnames_1$default;

    var column = cell.column,
        isLast = cell.isLast,
        cellProps = _objectWithoutProperties(cell, ["column", "isLast"]);

    var customProps = column.onHeaderCell ? column.onHeaderCell(column) : {};

    if (column.align) {
      customProps.style = _objectSpread({}, customProps.style, {
        textAlign: column.align
      });
    }

    customProps.className = classnames_1.default(customProps.className, column.className, (_classnames_1$default = {}, _defineProperty(_classnames_1$default, "".concat(prefixCls, "-align-").concat(column.align), !!column.align), _defineProperty(_classnames_1$default, "".concat(prefixCls, "-row-cell-ellipsis"), !!column.ellipsis), _defineProperty(_classnames_1$default, "".concat(prefixCls, "-row-cell-break-word"), !!column.width), _defineProperty(_classnames_1$default, "".concat(prefixCls, "-row-cell-last"), isLast), _classnames_1$default));
    return React.createElement(HeaderCell, Object.assign({}, cellProps, customProps, {
      key: column.key || column.dataIndex || i
    }));
  }));
}

function getRowHeight(state, props) {
  var fixedColumnsHeadRowsHeight = state.fixedColumnsHeadRowsHeight;
  var columns = props.columns,
      rows = props.rows,
      fixed = props.fixed;
  var headerHeight = fixedColumnsHeadRowsHeight[0];

  if (!fixed) {
    return null;
  }

  if (headerHeight && columns) {
    if (headerHeight === 'auto') {
      return 'auto';
    }

    return headerHeight / rows.length;
  }

  return null;
}

exports.default = mini_store_1.connect(function (state, props) {
  return {
    height: getRowHeight(state, props)
  };
})(TableHeaderRow);

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var classnames_1 = __importDefault(__webpack_require__(22));

var get_1 = __importDefault(__webpack_require__(520));

function isInvalidRenderCellText(text) {
  return text && !React.isValidElement(text) && Object.prototype.toString.call(text) === '[object Object]';
}

var TableCell = /*#__PURE__*/function (_React$Component) {
  _inherits(TableCell, _React$Component);

  var _super = _createSuper(TableCell);

  function TableCell() {
    var _this;

    _classCallCheck(this, TableCell);

    _this = _super.apply(this, arguments);

    _this.handleClick = function (e) {
      var _this$props = _this.props,
          record = _this$props.record,
          onCellClick = _this$props.column.onCellClick;

      if (onCellClick) {
        onCellClick(record, e);
      }
    };

    return _this;
  }

  _createClass(TableCell, [{
    key: "render",
    value: function render() {
      var _classnames_1$default;

      var _this$props2 = this.props,
          record = _this$props2.record,
          indentSize = _this$props2.indentSize,
          prefixCls = _this$props2.prefixCls,
          indent = _this$props2.indent,
          index = _this$props2.index,
          expandIcon = _this$props2.expandIcon,
          column = _this$props2.column,
          BodyCell = _this$props2.component;
      var dataIndex = column.dataIndex,
          render = column.render,
          _column$className = column.className,
          className = _column$className === void 0 ? '' : _column$className; // We should return undefined if no dataIndex is specified, but in order to
      // be compatible with object-path's behavior, we return the record object instead.

      var text;

      if (typeof dataIndex === 'number') {
        text = get_1.default(record, dataIndex);
      } else if (!dataIndex || dataIndex.length === 0) {
        text = record;
      } else {
        text = get_1.default(record, dataIndex);
      }

      var tdProps = {};
      var colSpan;
      var rowSpan;

      if (render) {
        text = render(text, record, index); // `render` support cell with additional config like `props`

        if (isInvalidRenderCellText(text)) {
          tdProps = text.props || tdProps;
          var _tdProps = tdProps;
          colSpan = _tdProps.colSpan;
          rowSpan = _tdProps.rowSpan;
          text = text.children;
        }
      }

      if (column.onCell) {
        tdProps = _objectSpread({}, tdProps, {}, column.onCell(record, index));
      } // Fix https://github.com/ant-design/ant-design/issues/1202


      if (isInvalidRenderCellText(text)) {
        text = null;
      }

      var indentText = expandIcon ? React.createElement("span", {
        style: {
          paddingLeft: "".concat(indentSize * indent, "px")
        },
        className: "".concat(prefixCls, "-indent indent-level-").concat(indent)
      }) : null;

      if (rowSpan === 0 || colSpan === 0) {
        return null;
      }

      if (column.align) {
        tdProps.style = _objectSpread({
          textAlign: column.align
        }, tdProps.style);
      }

      var cellClassName = classnames_1.default(className, (_classnames_1$default = {}, _defineProperty(_classnames_1$default, "".concat(prefixCls, "-cell-ellipsis"), !!column.ellipsis), _defineProperty(_classnames_1$default, "".concat(prefixCls, "-cell-break-word"), !!column.width), _classnames_1$default));

      if (column.ellipsis) {
        if (typeof text === 'string') {
          tdProps.title = text;
        } else if (text) {
          var _text = text,
              textProps = _text.props;

          if (textProps && textProps.children && typeof textProps.children === 'string') {
            tdProps.title = textProps.children;
          }
        }
      }

      return React.createElement(BodyCell, Object.assign({
        className: cellClassName,
        onClick: this.handleClick
      }, tdProps), indentText, expandIcon, text);
    }
  }]);

  return TableCell;
}(React.Component);

exports.default = TableCell;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1048);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1049);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(352);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1051);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(265),
    arrayMap = __webpack_require__(1052),
    isArray = __webpack_require__(132),
    isSymbol = __webpack_require__(269);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1052 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var mini_store_1 = __webpack_require__(115);

var ExpandIcon_1 = __importDefault(__webpack_require__(1054));

var ExpandableRow = /*#__PURE__*/function (_React$Component) {
  _inherits(ExpandableRow, _React$Component);

  var _super = _createSuper(ExpandableRow);

  function ExpandableRow() {
    var _this;

    _classCallCheck(this, ExpandableRow);

    _this = _super.apply(this, arguments); // Show icon within first column

    _this.hasExpandIcon = function (columnIndex) {
      var _this$props = _this.props,
          expandRowByClick = _this$props.expandRowByClick,
          expandIcon = _this$props.expandIcon;

      if (_this.expandIconAsCell || columnIndex !== _this.expandIconColumnIndex) {
        return false;
      }

      return !!expandIcon || !expandRowByClick;
    };

    _this.handleExpandChange = function (record, event) {
      var _this$props2 = _this.props,
          onExpandedChange = _this$props2.onExpandedChange,
          expanded = _this$props2.expanded,
          rowKey = _this$props2.rowKey;

      if (_this.expandable) {
        onExpandedChange(!expanded, record, event, rowKey);
      }
    };

    _this.handleRowClick = function (record, index, event) {
      var _this$props3 = _this.props,
          expandRowByClick = _this$props3.expandRowByClick,
          onRowClick = _this$props3.onRowClick;

      if (expandRowByClick) {
        _this.handleExpandChange(record, event);
      }

      if (onRowClick) {
        onRowClick(record, index, event);
      }
    };

    _this.renderExpandIcon = function () {
      var _this$props4 = _this.props,
          prefixCls = _this$props4.prefixCls,
          expanded = _this$props4.expanded,
          record = _this$props4.record,
          needIndentSpaced = _this$props4.needIndentSpaced,
          expandIcon = _this$props4.expandIcon;

      if (expandIcon) {
        return expandIcon({
          prefixCls: prefixCls,
          expanded: expanded,
          record: record,
          needIndentSpaced: needIndentSpaced,
          expandable: _this.expandable,
          onExpand: _this.handleExpandChange
        });
      }

      return React.createElement(ExpandIcon_1.default, {
        expandable: _this.expandable,
        prefixCls: prefixCls,
        onExpand: _this.handleExpandChange,
        needIndentSpaced: needIndentSpaced,
        expanded: expanded,
        record: record
      });
    };

    _this.renderExpandIconCell = function (cells) {
      if (!_this.expandIconAsCell) {
        return;
      }

      var prefixCls = _this.props.prefixCls;
      cells.push(React.createElement("td", {
        className: "".concat(prefixCls, "-expand-icon-cell"),
        key: "rc-table-expand-icon-cell"
      }, _this.renderExpandIcon()));
    };

    return _this;
  }

  _createClass(ExpandableRow, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleDestroy();
    }
  }, {
    key: "handleDestroy",
    value: function handleDestroy() {
      var _this$props5 = this.props,
          onExpandedChange = _this$props5.onExpandedChange,
          rowKey = _this$props5.rowKey,
          record = _this$props5.record;

      if (this.expandable) {
        onExpandedChange(false, record, null, rowKey, true);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          childrenColumnName = _this$props6.childrenColumnName,
          expandedRowRender = _this$props6.expandedRowRender,
          indentSize = _this$props6.indentSize,
          record = _this$props6.record,
          fixed = _this$props6.fixed,
          expanded = _this$props6.expanded;
      this.expandIconAsCell = fixed !== 'right' ? this.props.expandIconAsCell : false;
      this.expandIconColumnIndex = fixed !== 'right' ? this.props.expandIconColumnIndex : -1;
      var childrenData = record[childrenColumnName];
      this.expandable = !!(childrenData || expandedRowRender);
      var expandableRowProps = {
        indentSize: indentSize,
        // not used in TableRow, but it's required to re-render TableRow when `expanded` changes
        expanded: expanded,
        onRowClick: this.handleRowClick,
        hasExpandIcon: this.hasExpandIcon,
        renderExpandIcon: this.renderExpandIcon,
        renderExpandIconCell: this.renderExpandIconCell
      };
      return this.props.children(expandableRowProps);
    }
  }]);

  return ExpandableRow;
}(React.Component);

exports.default = mini_store_1.connect(function (_ref, _ref2) {
  var _ref$expandedRowKeys = _ref.expandedRowKeys,
      expandedRowKeys = _ref$expandedRowKeys === void 0 ? [] : _ref$expandedRowKeys;
  var rowKey = _ref2.rowKey;
  return {
    expanded: expandedRowKeys.includes(rowKey)
  };
})(ExpandableRow);

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var shallowequal_1 = __importDefault(__webpack_require__(89));

var ExpandIcon = /*#__PURE__*/function (_React$Component) {
  _inherits(ExpandIcon, _React$Component);

  var _super = _createSuper(ExpandIcon);

  function ExpandIcon() {
    _classCallCheck(this, ExpandIcon);

    return _super.apply(this, arguments);
  }

  _createClass(ExpandIcon, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !shallowequal_1.default(nextProps, this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          expandable = _this$props.expandable,
          prefixCls = _this$props.prefixCls,
          onExpand = _this$props.onExpand,
          needIndentSpaced = _this$props.needIndentSpaced,
          expanded = _this$props.expanded,
          record = _this$props.record;

      if (expandable) {
        var expandClassName = expanded ? 'expanded' : 'collapsed';
        return React.createElement("span", {
          className: "".concat(prefixCls, "-expand-icon ").concat(prefixCls, "-").concat(expandClassName),
          onClick: function onClick(e) {
            return onExpand(record, e);
          }
        });
      }

      if (needIndentSpaced) {
        return React.createElement("span", {
          className: "".concat(prefixCls, "-expand-icon ").concat(prefixCls, "-spaced")
        });
      }

      return null;
    }
  }]);

  return ExpandIcon;
}(React.Component);

exports.default = ExpandIcon;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var PropTypes = __importStar(__webpack_require__(19));

var utils_1 = __webpack_require__(196);

var BaseTable_1 = __importDefault(__webpack_require__(518));

function BodyTable(props, _ref) {
  var table = _ref.table;
  var _table$props = table.props,
      prefixCls = _table$props.prefixCls,
      scroll = _table$props.scroll;
  var columns = props.columns,
      fixed = props.fixed,
      tableClassName = props.tableClassName,
      getRowKey = props.getRowKey,
      handleBodyScroll = props.handleBodyScroll,
      handleWheel = props.handleWheel,
      expander = props.expander,
      isAnyColumnsFixed = props.isAnyColumnsFixed;
  var saveRef = table.saveRef;
  var useFixedHeader = table.props.useFixedHeader;

  var bodyStyle = _objectSpread({}, table.props.bodyStyle);

  var innerBodyStyle = {};

  if (scroll.x || fixed) {
    bodyStyle.overflowX = bodyStyle.overflowX || 'scroll'; // Fix weird webkit render bug
    // https://github.com/ant-design/ant-design/issues/7783

    bodyStyle.WebkitTransform = 'translate3d (0, 0, 0)';
  }

  if (scroll.y) {
    // maxHeight will make fixed-Table scrolling not working
    // so we only set maxHeight to body-Table here
    if (fixed) {
      innerBodyStyle.maxHeight = bodyStyle.maxHeight || scroll.y;
      innerBodyStyle.overflowY = bodyStyle.overflowY || 'scroll';
    } else {
      bodyStyle.maxHeight = bodyStyle.maxHeight || scroll.y;
    }

    bodyStyle.overflowY = bodyStyle.overflowY || 'scroll';
    useFixedHeader = true; // Add negative margin bottom for scroll bar overflow bug

    var scrollbarWidth = utils_1.measureScrollbar({
      direction: 'vertical'
    });

    if (scrollbarWidth > 0 && fixed) {
      bodyStyle.marginBottom = "-".concat(scrollbarWidth, "px");
      bodyStyle.paddingBottom = '0px';
    }
  }

  var baseTable = React.createElement(BaseTable_1.default, {
    tableClassName: tableClassName,
    hasHead: !useFixedHeader,
    hasBody: true,
    fixed: fixed,
    columns: columns,
    expander: expander,
    getRowKey: getRowKey,
    isAnyColumnsFixed: isAnyColumnsFixed
  });

  if (fixed && columns.length) {
    var refName;

    if (columns[0].fixed === 'left' || columns[0].fixed === true) {
      refName = 'fixedColumnsBodyLeft';
    } else if (columns[0].fixed === 'right') {
      refName = 'fixedColumnsBodyRight';
    }

    delete bodyStyle.overflowX;
    delete bodyStyle.overflowY;
    return React.createElement("div", {
      key: "bodyTable",
      className: "".concat(prefixCls, "-body-outer"),
      style: _objectSpread({}, bodyStyle)
    }, React.createElement("div", {
      className: "".concat(prefixCls, "-body-inner"),
      style: innerBodyStyle,
      ref: saveRef(refName),
      onWheel: handleWheel,
      onScroll: handleBodyScroll
    }, baseTable));
  } // Should provides `tabIndex` if use scroll to enable keyboard scroll


  var useTabIndex = scroll && (scroll.x || scroll.y);
  return React.createElement("div", {
    tabIndex: useTabIndex ? -1 : undefined,
    key: "bodyTable",
    className: "".concat(prefixCls, "-body"),
    style: bodyStyle,
    ref: saveRef('bodyTable'),
    onWheel: handleWheel,
    onScroll: handleBodyScroll
  }, baseTable);
}

exports.default = BodyTable;
BodyTable.contextTypes = {
  table: PropTypes.any
};

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var mini_store_1 = __webpack_require__(115);

var react_lifecycles_compat_1 = __webpack_require__(36);

var shallowequal_1 = __importDefault(__webpack_require__(89));

var TableRow_1 = __importDefault(__webpack_require__(519));

var utils_1 = __webpack_require__(196);

var ExpandableTable = /*#__PURE__*/function (_React$Component) {
  _inherits(ExpandableTable, _React$Component);

  var _super = _createSuper(ExpandableTable);

  function ExpandableTable(props) {
    var _this;

    _classCallCheck(this, ExpandableTable);

    _this = _super.call(this, props);

    _this.handleExpandChange = function (expanded, record, event, rowKey) {
      var destroy = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      if (event) {
        event.stopPropagation();
      }

      var _this$props = _this.props,
          onExpandedRowsChange = _this$props.onExpandedRowsChange,
          onExpand = _this$props.onExpand;

      var _this$store$getState = _this.store.getState(),
          expandedRowKeys = _this$store$getState.expandedRowKeys;

      if (expanded) {
        // row was expanded
        expandedRowKeys = [].concat(_toConsumableArray(expandedRowKeys), [rowKey]);
      } else {
        // row was collapse
        var expandedRowIndex = expandedRowKeys.indexOf(rowKey);

        if (expandedRowIndex !== -1) {
          expandedRowKeys = utils_1.remove(expandedRowKeys, rowKey);
        }
      }

      if (!_this.props.expandedRowKeys) {
        _this.store.setState({
          expandedRowKeys: expandedRowKeys
        });
      } // De-dup of repeat call


      if (!_this.latestExpandedRows || !shallowequal_1.default(_this.latestExpandedRows, expandedRowKeys)) {
        _this.latestExpandedRows = expandedRowKeys;
        onExpandedRowsChange(expandedRowKeys);
      }

      if (!destroy) {
        onExpand(expanded, record);
      }
    };

    _this.renderExpandIndentCell = function (rows, fixed) {
      var _this$props2 = _this.props,
          prefixCls = _this$props2.prefixCls,
          expandIconAsCell = _this$props2.expandIconAsCell;

      if (!expandIconAsCell || fixed === 'right' || !rows.length) {
        return;
      }

      var iconColumn = {
        key: 'rc-table-expand-icon-cell',
        className: "".concat(prefixCls, "-expand-icon-th"),
        title: '',
        rowSpan: rows.length
      };
      rows[0].unshift(_objectSpread({}, iconColumn, {
        column: iconColumn
      }));
    };

    _this.renderRows = function (renderRows, rows, record, index, indent, fixed, parentKey, ancestorKeys) {
      var _this$props3 = _this.props,
          expandedRowClassName = _this$props3.expandedRowClassName,
          expandedRowRender = _this$props3.expandedRowRender,
          childrenColumnName = _this$props3.childrenColumnName;
      var childrenData = record[childrenColumnName];
      var nextAncestorKeys = [].concat(_toConsumableArray(ancestorKeys), [parentKey]);
      var nextIndent = indent + 1;

      if (expandedRowRender) {
        rows.push(_this.renderExpandedRow(record, index, expandedRowRender, expandedRowClassName(record, index, indent), nextAncestorKeys, nextIndent, fixed));
      }

      if (childrenData) {
        rows.push.apply(rows, _toConsumableArray(renderRows(childrenData, nextIndent, nextAncestorKeys)));
      }
    };

    var data = props.data,
        childrenColumnName = props.childrenColumnName,
        defaultExpandAllRows = props.defaultExpandAllRows,
        expandedRowKeys = props.expandedRowKeys,
        defaultExpandedRowKeys = props.defaultExpandedRowKeys,
        getRowKey = props.getRowKey;
    var finalExpandedRowKeys = [];

    var rows = _toConsumableArray(data);

    if (defaultExpandAllRows) {
      for (var i = 0; i < rows.length; i += 1) {
        var row = rows[i];
        finalExpandedRowKeys.push(getRowKey(row, i));
        rows = rows.concat(row[childrenColumnName] || []);
      }
    } else {
      finalExpandedRowKeys = expandedRowKeys || defaultExpandedRowKeys;
    }

    _this.columnManager = props.columnManager;
    _this.store = props.store;

    _this.store.setState({
      expandedRowsHeight: {},
      expandedRowKeys: finalExpandedRowKeys
    });

    return _this;
  }

  _createClass(ExpandableTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleUpdated();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if ('expandedRowKeys' in this.props) {
        this.store.setState({
          expandedRowKeys: this.props.expandedRowKeys
        });
      }

      this.handleUpdated();
    }
  }, {
    key: "handleUpdated",
    value: function handleUpdated() {
      /**
       * We should record latest expanded rows to avoid
       * multiple rows remove cause `onExpandedRowsChange` trigger many times
       */
      this.latestExpandedRows = null;
    }
  }, {
    key: "renderExpandedRow",
    value: function renderExpandedRow(record, index, _render, className, ancestorKeys, indent, fixed) {
      var _this2 = this;

      var _this$props4 = this.props,
          prefixCls = _this$props4.prefixCls,
          expandIconAsCell = _this$props4.expandIconAsCell,
          indentSize = _this$props4.indentSize;
      var parentKey = ancestorKeys[ancestorKeys.length - 1];
      var rowKey = "".concat(parentKey, "-extra-row");
      var components = {
        body: {
          row: 'tr',
          cell: 'td'
        }
      };
      var colCount;

      if (fixed === 'left') {
        colCount = this.columnManager.leftLeafColumns().length;
      } else if (fixed === 'right') {
        colCount = this.columnManager.rightLeafColumns().length;
      } else {
        colCount = this.columnManager.leafColumns().length;
      }

      var columns = [{
        key: 'extra-row',
        render: function render() {
          var _this2$store$getState = _this2.store.getState(),
              _this2$store$getState2 = _this2$store$getState.expandedRowKeys,
              expandedRowKeys = _this2$store$getState2 === void 0 ? [] : _this2$store$getState2;

          var expanded = expandedRowKeys.includes(parentKey);
          return {
            props: {
              colSpan: colCount
            },
            children: fixed !== 'right' ? _render(record, index, indent, expanded) : '&nbsp;'
          };
        }
      }];

      if (expandIconAsCell && fixed !== 'right') {
        columns.unshift({
          key: 'expand-icon-placeholder',
          render: function render() {
            return null;
          }
        });
      }

      return React.createElement(TableRow_1.default, {
        key: rowKey,
        columns: columns,
        className: className,
        rowKey: rowKey,
        ancestorKeys: ancestorKeys,
        prefixCls: "".concat(prefixCls, "-expanded-row"),
        indentSize: indentSize,
        indent: indent,
        fixed: fixed,
        components: components,
        expandedRow: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          data = _this$props5.data,
          childrenColumnName = _this$props5.childrenColumnName,
          children = _this$props5.children;
      var needIndentSpaced = data.some(function (record) {
        return record[childrenColumnName];
      });
      return children({
        props: this.props,
        needIndentSpaced: needIndentSpaced,
        renderRows: this.renderRows,
        handleExpandChange: this.handleExpandChange,
        renderExpandIndentCell: this.renderExpandIndentCell
      });
    }
  }]);

  return ExpandableTable;
}(React.Component);

ExpandableTable.defaultProps = {
  expandIconAsCell: false,
  expandedRowClassName: function expandedRowClassName() {
    return '';
  },
  expandIconColumnIndex: 0,
  defaultExpandAllRows: false,
  defaultExpandedRowKeys: [],
  childrenColumnName: 'children',
  indentSize: 15,
  onExpand: function onExpand() {},
  onExpandedRowsChange: function onExpandedRowsChange() {}
};
react_lifecycles_compat_1.polyfill(ExpandableTable);
exports.default = mini_store_1.connect()(ExpandableTable);

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var ReactDOM = _interopRequireWildcard(__webpack_require__(46));

var _reactLifecyclesCompat = __webpack_require__(36);

var _rcMenu = _interopRequireWildcard(__webpack_require__(190));

var _domClosest = _interopRequireDefault(__webpack_require__(1058));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _shallowequal = _interopRequireDefault(__webpack_require__(89));

var _dropdown = _interopRequireDefault(__webpack_require__(271));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _checkbox = _interopRequireDefault(__webpack_require__(272));

var _radio = _interopRequireDefault(__webpack_require__(112));

var _FilterDropdownMenuWrapper = _interopRequireDefault(__webpack_require__(1068));

var _util = __webpack_require__(528);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function stopPropagation(e) {
  e.stopPropagation();

  if (e.nativeEvent.stopImmediatePropagation) {
    e.nativeEvent.stopImmediatePropagation();
  }
}

var FilterMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(FilterMenu, _React$Component);

  var _super = _createSuper(FilterMenu);

  function FilterMenu(props) {
    var _this;

    _classCallCheck(this, FilterMenu);

    _this = _super.call(this, props);

    _this.setNeverShown = function (column) {
      var rootNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));
      var filterBelongToScrollBody = !!(0, _domClosest["default"])(rootNode, ".ant-table-scroll");

      if (filterBelongToScrollBody) {
        // When fixed column have filters, there will be two dropdown menus
        // Filter dropdown menu inside scroll body should never be shown
        // To fix https://github.com/ant-design/ant-design/issues/5010 and
        // https://github.com/ant-design/ant-design/issues/7909
        _this.neverShown = !!column.fixed;
      }
    };

    _this.setSelectedKeys = function (_ref) {
      var selectedKeys = _ref.selectedKeys;

      _this.setState({
        selectedKeys: selectedKeys
      });
    };

    _this.handleClearFilters = function () {
      _this.setState({
        selectedKeys: []
      }, _this.handleConfirm);
    };

    _this.handleConfirm = function () {
      _this.setVisible(false); // Call `setSelectedKeys` & `confirm` in the same time will make filter data not up to date
      // https://github.com/ant-design/ant-design/issues/12284


      _this.setState({}, _this.confirmFilter);
    };

    _this.onVisibleChange = function (visible) {
      _this.setVisible(visible);

      var column = _this.props.column; // https://github.com/ant-design/ant-design/issues/17833

      if (!visible && !(column.filterDropdown instanceof Function)) {
        _this.confirmFilter();
      }
    };

    _this.handleMenuItemClick = function (info) {
      var selectedKeys = _this.state.selectedKeys;

      if (!info.keyPath || info.keyPath.length <= 1) {
        return;
      }

      var keyPathOfSelectedItem = _this.state.keyPathOfSelectedItem;

      if (selectedKeys && selectedKeys.indexOf(info.key) >= 0) {
        // deselect SubMenu child
        delete keyPathOfSelectedItem[info.key];
      } else {
        // select SubMenu child
        keyPathOfSelectedItem[info.key] = info.keyPath;
      }

      _this.setState({
        keyPathOfSelectedItem: keyPathOfSelectedItem
      });
    };

    _this.renderFilterIcon = function () {
      var _classNames;

      var _this$props = _this.props,
          column = _this$props.column,
          locale = _this$props.locale,
          prefixCls = _this$props.prefixCls,
          selectedKeys = _this$props.selectedKeys;
      var filtered = selectedKeys && selectedKeys.length > 0;
      var filterIcon = column.filterIcon;

      if (typeof filterIcon === 'function') {
        filterIcon = filterIcon(filtered);
      }

      var dropdownIconClass = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-selected"), 'filtered' in column ? column.filtered : filtered), _defineProperty(_classNames, "".concat(prefixCls, "-open"), _this.getDropdownVisible()), _classNames));

      if (!filterIcon) {
        return /*#__PURE__*/React.createElement(_icon["default"], {
          title: locale.filterTitle,
          type: "filter",
          theme: "filled",
          className: dropdownIconClass,
          onClick: stopPropagation
        });
      }

      if ( /*#__PURE__*/React.isValidElement(filterIcon)) {
        return /*#__PURE__*/React.cloneElement(filterIcon, {
          title: filterIcon.props.title || locale.filterTitle,
          className: (0, _classnames["default"])("".concat(prefixCls, "-icon"), dropdownIconClass, filterIcon.props.className),
          onClick: stopPropagation
        });
      }

      return /*#__PURE__*/React.createElement("span", {
        className: (0, _classnames["default"])("".concat(prefixCls, "-icon"), dropdownIconClass)
      }, filterIcon);
    };

    var visible = 'filterDropdownVisible' in props.column ? props.column.filterDropdownVisible : false;
    _this.state = {
      selectedKeys: props.selectedKeys,
      valueKeys: (0, _util.generateValueMaps)(props.column.filters),
      keyPathOfSelectedItem: {},
      visible: visible,
      prevProps: props
    };
    return _this;
  }

  _createClass(FilterMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var column = this.props.column;
      this.setNeverShown(column);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var column = this.props.column;
      this.setNeverShown(column);
    }
  }, {
    key: "getDropdownVisible",
    value: function getDropdownVisible() {
      return this.neverShown ? false : this.state.visible;
    }
  }, {
    key: "setVisible",
    value: function setVisible(visible) {
      var column = this.props.column;

      if (!('filterDropdownVisible' in column)) {
        this.setState({
          visible: visible
        });
      }

      if (column.onFilterDropdownVisibleChange) {
        column.onFilterDropdownVisibleChange(visible);
      }
    }
  }, {
    key: "hasSubMenu",
    value: function hasSubMenu() {
      var _this$props$column$fi = this.props.column.filters,
          filters = _this$props$column$fi === void 0 ? [] : _this$props$column$fi;
      return filters.some(function (item) {
        return !!(item.children && item.children.length > 0);
      });
    }
  }, {
    key: "confirmFilter",
    value: function confirmFilter() {
      var _this$props2 = this.props,
          column = _this$props2.column,
          propSelectedKeys = _this$props2.selectedKeys,
          confirmFilter = _this$props2.confirmFilter;
      var _this$state = this.state,
          selectedKeys = _this$state.selectedKeys,
          valueKeys = _this$state.valueKeys;
      var filterDropdown = column.filterDropdown;

      if (!(0, _shallowequal["default"])(selectedKeys, propSelectedKeys)) {
        confirmFilter(column, filterDropdown ? selectedKeys : selectedKeys.map(function (key) {
          return valueKeys[key];
        }).filter(function (key) {
          return key !== undefined;
        }));
      }
    }
  }, {
    key: "renderMenus",
    value: function renderMenus(items) {
      var _this2 = this;

      var _this$props3 = this.props,
          dropdownPrefixCls = _this$props3.dropdownPrefixCls,
          prefixCls = _this$props3.prefixCls;
      return items.map(function (item) {
        if (item.children && item.children.length > 0) {
          var keyPathOfSelectedItem = _this2.state.keyPathOfSelectedItem;
          var containSelected = Object.keys(keyPathOfSelectedItem).some(function (key) {
            return keyPathOfSelectedItem[key].indexOf(item.value) >= 0;
          });
          var subMenuCls = (0, _classnames["default"])("".concat(prefixCls, "-dropdown-submenu"), _defineProperty({}, "".concat(dropdownPrefixCls, "-submenu-contain-selected"), containSelected));
          return /*#__PURE__*/React.createElement(_rcMenu.SubMenu, {
            title: item.text,
            popupClassName: subMenuCls,
            key: item.value.toString()
          }, _this2.renderMenus(item.children));
        }

        return _this2.renderMenuItem(item);
      });
    }
  }, {
    key: "renderMenuItem",
    value: function renderMenuItem(item) {
      var column = this.props.column;
      var selectedKeys = this.state.selectedKeys;
      var multiple = 'filterMultiple' in column ? column.filterMultiple : true; // We still need trade key as string since Menu render need string

      var internalSelectedKeys = (selectedKeys || []).map(function (key) {
        return key.toString();
      });
      var input = multiple ? /*#__PURE__*/React.createElement(_checkbox["default"], {
        checked: internalSelectedKeys.indexOf(item.value.toString()) >= 0
      }) : /*#__PURE__*/React.createElement(_radio["default"], {
        checked: internalSelectedKeys.indexOf(item.value.toString()) >= 0
      });
      return /*#__PURE__*/React.createElement(_rcMenu.Item, {
        key: item.value
      }, input, /*#__PURE__*/React.createElement("span", null, item.text));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var originSelectedKeys = this.state.selectedKeys;
      var _this$props4 = this.props,
          column = _this$props4.column,
          locale = _this$props4.locale,
          prefixCls = _this$props4.prefixCls,
          dropdownPrefixCls = _this$props4.dropdownPrefixCls,
          getPopupContainer = _this$props4.getPopupContainer; // default multiple selection in filter dropdown

      var multiple = 'filterMultiple' in column ? column.filterMultiple : true;
      var dropdownMenuClass = (0, _classnames["default"])(_defineProperty({}, "".concat(dropdownPrefixCls, "-menu-without-submenu"), !this.hasSubMenu()));
      var filterDropdown = column.filterDropdown;

      if (filterDropdown instanceof Function) {
        filterDropdown = filterDropdown({
          prefixCls: "".concat(dropdownPrefixCls, "-custom"),
          setSelectedKeys: function setSelectedKeys(selectedKeys) {
            return _this3.setSelectedKeys({
              selectedKeys: selectedKeys
            });
          },
          selectedKeys: originSelectedKeys,
          confirm: this.handleConfirm,
          clearFilters: this.handleClearFilters,
          filters: column.filters,
          visible: this.getDropdownVisible()
        });
      }

      var menus = filterDropdown ? /*#__PURE__*/React.createElement(_FilterDropdownMenuWrapper["default"], {
        className: "".concat(prefixCls, "-dropdown")
      }, filterDropdown) : /*#__PURE__*/React.createElement(_FilterDropdownMenuWrapper["default"], {
        className: "".concat(prefixCls, "-dropdown")
      }, /*#__PURE__*/React.createElement(_rcMenu["default"], {
        multiple: multiple,
        onClick: this.handleMenuItemClick,
        prefixCls: "".concat(dropdownPrefixCls, "-menu"),
        className: dropdownMenuClass,
        onSelect: this.setSelectedKeys,
        onDeselect: this.setSelectedKeys,
        selectedKeys: originSelectedKeys && originSelectedKeys.map(function (val) {
          return val.toString();
        }),
        getPopupContainer: getPopupContainer
      }, this.renderMenus(column.filters)), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-dropdown-btns")
      }, /*#__PURE__*/React.createElement("a", {
        className: "".concat(prefixCls, "-dropdown-link confirm"),
        onClick: this.handleConfirm
      }, locale.filterConfirm), /*#__PURE__*/React.createElement("a", {
        className: "".concat(prefixCls, "-dropdown-link clear"),
        onClick: this.handleClearFilters
      }, locale.filterReset)));
      return /*#__PURE__*/React.createElement(_dropdown["default"], {
        trigger: ['click'],
        placement: "bottomRight",
        overlay: menus,
        visible: this.getDropdownVisible(),
        onVisibleChange: this.onVisibleChange,
        getPopupContainer: getPopupContainer,
        forceRender: true
      }, this.renderFilterIcon());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var column = nextProps.column;
      var prevProps = prevState.prevProps;
      var newState = {
        prevProps: nextProps
      };
      /**
       * if the state is visible the component should ignore updates on selectedKeys prop to avoid
       * that the user selection is lost
       * this happens frequently when a table is connected on some sort of realtime data
       * Fixes https://github.com/ant-design/ant-design/issues/10289 and
       * https://github.com/ant-design/ant-design/issues/10209
       */

      if ('selectedKeys' in nextProps && !(0, _shallowequal["default"])(prevProps.selectedKeys, nextProps.selectedKeys)) {
        newState.selectedKeys = nextProps.selectedKeys;
      }

      if (!(0, _shallowequal["default"])((prevProps.column || {}).filters, (nextProps.column || {}).filters)) {
        newState.valueKeys = (0, _util.generateValueMaps)(nextProps.column.filters);
      }

      if ('filterDropdownVisible' in column) {
        newState.visible = column.filterDropdownVisible;
      }

      return newState;
    }
  }]);

  return FilterMenu;
}(React.Component);

FilterMenu.defaultProps = {
  column: {}
};
(0, _reactLifecyclesCompat.polyfill)(FilterMenu);
var _default = FilterMenu;
exports["default"] = _default;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var matches = __webpack_require__(1059);

/**
 * @param element {Element}
 * @param selector {String}
 * @param context {Element}
 * @return {Element}
 */
module.exports = function (element, selector, context) {
  context = context || document;
  // guard against orphans
  element = { parentNode: element };

  while ((element = element.parentNode) && element !== context) {
    if (matches(element, selector)) {
      return element;
    }
  }
};


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determine if a DOM element matches a CSS selector
 *
 * @param {Element} elem
 * @param {String} selector
 * @return {Boolean}
 * @api public
 */

function matches(elem, selector) {
  // Vendor-specific implementations of `Element.prototype.matches()`.
  var proto = window.Element.prototype;
  var nativeMatches = proto.matches ||
      proto.mozMatchesSelector ||
      proto.msMatchesSelector ||
      proto.oMatchesSelector ||
      proto.webkitMatchesSelector;

  if (!elem || elem.nodeType !== 1) {
    return false;
  }

  var parentElem = elem.parentNode;

  // use native 'matches'
  if (nativeMatches) {
    return nativeMatches.call(elem, selector);
  }

  // native support for `matches` is missing and a fallback is required
  var nodes = parentElem.querySelectorAll(selector);
  var len = nodes.length;

  for (var i = 0; i < len; i++) {
    if (nodes[i] === elem) {
      return true;
    }
  }

  return false;
}

/**
 * Expose `matches`
 */

module.exports = matches;


/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dropdown__ = __webpack_require__(1061);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Dropdown__["a" /* default */]);

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_trigger__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__placements__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__ = __webpack_require__(36);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Dropdown = function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown(props) {
    _classCallCheck(this, Dropdown);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    if ('visible' in props) {
      _this.state = {
        visible: props.visible
      };
    } else {
      _this.state = {
        visible: props.defaultVisible
      };
    }
    return _this;
  }

  Dropdown.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps) {
    if ('visible' in nextProps) {
      return {
        visible: nextProps.visible
      };
    }
    return null;
  };

  Dropdown.prototype.getOverlayElement = function getOverlayElement() {
    var overlay = this.props.overlay;

    var overlayElement = void 0;
    if (typeof overlay === 'function') {
      overlayElement = overlay();
    } else {
      overlayElement = overlay;
    }
    return overlayElement;
  };

  Dropdown.prototype.getMenuElementOrLambda = function getMenuElementOrLambda() {
    var overlay = this.props.overlay;

    if (typeof overlay === 'function') {
      return this.getMenuElement;
    }
    return this.getMenuElement();
  };

  Dropdown.prototype.getPopupDomNode = function getPopupDomNode() {
    return this.trigger.getPopupDomNode();
  };

  Dropdown.prototype.getOpenClassName = function getOpenClassName() {
    var _props = this.props,
        openClassName = _props.openClassName,
        prefixCls = _props.prefixCls;

    if (openClassName !== undefined) {
      return openClassName;
    }
    return prefixCls + '-open';
  };

  Dropdown.prototype.renderChildren = function renderChildren() {
    var children = this.props.children;
    var visible = this.state.visible;

    var childrenProps = children.props ? children.props : {};
    var childClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(childrenProps.className, this.getOpenClassName());
    return visible && children ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(children, { className: childClassName }) : children;
  };

  Dropdown.prototype.render = function render() {
    var _props2 = this.props,
        prefixCls = _props2.prefixCls,
        transitionName = _props2.transitionName,
        animation = _props2.animation,
        align = _props2.align,
        placement = _props2.placement,
        getPopupContainer = _props2.getPopupContainer,
        showAction = _props2.showAction,
        hideAction = _props2.hideAction,
        overlayClassName = _props2.overlayClassName,
        overlayStyle = _props2.overlayStyle,
        trigger = _props2.trigger,
        otherProps = _objectWithoutProperties(_props2, ['prefixCls', 'transitionName', 'animation', 'align', 'placement', 'getPopupContainer', 'showAction', 'hideAction', 'overlayClassName', 'overlayStyle', 'trigger']);

    var triggerHideAction = hideAction;
    if (!triggerHideAction && trigger.indexOf('contextMenu') !== -1) {
      triggerHideAction = ['click'];
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_rc_trigger__["default"],
      _extends({}, otherProps, {
        prefixCls: prefixCls,
        ref: this.saveTrigger,
        popupClassName: overlayClassName,
        popupStyle: overlayStyle,
        builtinPlacements: __WEBPACK_IMPORTED_MODULE_5__placements__["a" /* default */],
        action: trigger,
        showAction: showAction,
        hideAction: triggerHideAction || [],
        popupPlacement: placement,
        popupAlign: align,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupVisible: this.state.visible,
        afterPopupVisibleChange: this.afterVisibleChange,
        popup: this.getMenuElementOrLambda(),
        onPopupVisibleChange: this.onVisibleChange,
        getPopupContainer: getPopupContainer
      }),
      this.renderChildren()
    );
  };

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Dropdown.propTypes = {
  minOverlayWidthMatchTrigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onVisibleChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onOverlayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  overlayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  openClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  animation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  overlay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  trigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  alignPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showAction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  hideAction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  defaultVisible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
Dropdown.defaultProps = {
  prefixCls: 'rc-dropdown',
  trigger: ['hover'],
  showAction: [],
  overlayClassName: '',
  overlayStyle: {},
  defaultVisible: false,
  onVisibleChange: function onVisibleChange() {},

  placement: 'bottomLeft'
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onClick = function (e) {
    var props = _this2.props;
    var overlayProps = _this2.getOverlayElement().props;
    // do no call onVisibleChange, if you need click to hide, use onClick and control visible
    if (!('visible' in props)) {
      _this2.setState({
        visible: false
      });
    }
    if (props.onOverlayClick) {
      props.onOverlayClick(e);
    }
    if (overlayProps.onClick) {
      overlayProps.onClick(e);
    }
  };

  this.onVisibleChange = function (visible) {
    var props = _this2.props;
    if (!('visible' in props)) {
      _this2.setState({
        visible: visible
      });
    }
    props.onVisibleChange(visible);
  };

  this.getMinOverlayWidthMatchTrigger = function () {
    var _props3 = _this2.props,
        minOverlayWidthMatchTrigger = _props3.minOverlayWidthMatchTrigger,
        alignPoint = _props3.alignPoint;

    if ('minOverlayWidthMatchTrigger' in _this2.props) {
      return minOverlayWidthMatchTrigger;
    }

    return !alignPoint;
  };

  this.getMenuElement = function () {
    var prefixCls = _this2.props.prefixCls;

    var overlayElement = _this2.getOverlayElement();
    var extraOverlayProps = {
      prefixCls: prefixCls + '-menu',
      onClick: _this2.onClick
    };
    if (typeof overlayElement.type === 'string') {
      delete extraOverlayProps.prefixCls;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(overlayElement, extraOverlayProps);
  };

  this.afterVisibleChange = function (visible) {
    if (visible && _this2.getMinOverlayWidthMatchTrigger()) {
      var overlayNode = _this2.getPopupDomNode();
      var rootNode = __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(_this2);
      if (rootNode && overlayNode && rootNode.offsetWidth > overlayNode.offsetWidth) {
        overlayNode.style.minWidth = rootNode.offsetWidth + 'px';
        if (_this2.trigger && _this2.trigger._component && _this2.trigger._component.alignInstance) {
          _this2.trigger._component.alignInstance.forceAlign();
        }
      }
    }
  };

  this.saveTrigger = function (node) {
    _this2.trigger = node;
  };
};

Object(__WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__["polyfill"])(Dropdown);

/* harmony default export */ __webpack_exports__["a"] = (Dropdown);

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export placements */
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  topCenter: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  bottomCenter: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  }
};

/* harmony default export */ __webpack_exports__["a"] = (placements);

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _button = _interopRequireDefault(__webpack_require__(5));

var _configProvider = __webpack_require__(39);

var _dropdown = _interopRequireDefault(__webpack_require__(525));

var _icon = _interopRequireDefault(__webpack_require__(38));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var ButtonGroup = _button["default"].Group;

var DropdownButton = /*#__PURE__*/function (_React$Component) {
  _inherits(DropdownButton, _React$Component);

  var _super = _createSuper(DropdownButton);

  function DropdownButton() {
    var _this;

    _classCallCheck(this, DropdownButton);

    _this = _super.apply(this, arguments);

    _this.renderButton = function (_ref) {
      var getContextPopupContainer = _ref.getPopupContainer,
          getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          type = _a.type,
          disabled = _a.disabled,
          onClick = _a.onClick,
          htmlType = _a.htmlType,
          children = _a.children,
          className = _a.className,
          overlay = _a.overlay,
          trigger = _a.trigger,
          align = _a.align,
          visible = _a.visible,
          onVisibleChange = _a.onVisibleChange,
          placement = _a.placement,
          getPopupContainer = _a.getPopupContainer,
          href = _a.href,
          _a$icon = _a.icon,
          icon = _a$icon === void 0 ? /*#__PURE__*/React.createElement(_icon["default"], {
        type: "ellipsis"
      }) : _a$icon,
          title = _a.title,
          restProps = __rest(_a, ["prefixCls", "type", "disabled", "onClick", "htmlType", "children", "className", "overlay", "trigger", "align", "visible", "onVisibleChange", "placement", "getPopupContainer", "href", "icon", "title"]);

      var prefixCls = getPrefixCls('dropdown-button', customizePrefixCls);
      var dropdownProps = {
        align: align,
        overlay: overlay,
        disabled: disabled,
        trigger: disabled ? [] : trigger,
        onVisibleChange: onVisibleChange,
        placement: placement,
        getPopupContainer: getPopupContainer || getContextPopupContainer
      };

      if ('visible' in _this.props) {
        dropdownProps.visible = visible;
      }

      return /*#__PURE__*/React.createElement(ButtonGroup, _extends({}, restProps, {
        className: (0, _classnames["default"])(prefixCls, className)
      }), /*#__PURE__*/React.createElement(_button["default"], {
        type: type,
        disabled: disabled,
        onClick: onClick,
        htmlType: htmlType,
        href: href,
        title: title
      }, children), /*#__PURE__*/React.createElement(_dropdown["default"], dropdownProps, /*#__PURE__*/React.createElement(_button["default"], {
        type: type
      }, icon)));
    };

    return _this;
  }

  _createClass(DropdownButton, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderButton);
    }
  }]);

  return DropdownButton;
}(React.Component);

exports["default"] = DropdownButton;
DropdownButton.defaultProps = {
  placement: 'bottomRight',
  type: 'default'
};

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__ = __webpack_require__(36);










var Checkbox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Checkbox, _Component);

  function Checkbox(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Checkbox);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _this.handleChange = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onChange = _this$props.onChange;

      if (disabled) {
        return;
      }
      if (!('checked' in _this.props)) {
        _this.setState({
          checked: e.target.checked
        });
      }
      if (onChange) {
        onChange({
          target: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.props, {
            checked: e.target.checked
          }),
          stopPropagation: function stopPropagation() {
            e.stopPropagation();
          },
          preventDefault: function preventDefault() {
            e.preventDefault();
          },

          nativeEvent: e.nativeEvent
        });
      }
    };

    _this.saveInput = function (node) {
      _this.input = node;
    };

    var checked = 'checked' in props ? props.checked : props.defaultChecked;

    _this.state = {
      checked: checked
    };
    return _this;
  }

  Checkbox.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if ('checked' in props) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, {
        checked: props.checked
      });
    }
    return null;
  };

  Checkbox.prototype.focus = function focus() {
    this.input.focus();
  };

  Checkbox.prototype.blur = function blur() {
    this.input.blur();
  };

  Checkbox.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        prefixCls = _props.prefixCls,
        className = _props.className,
        style = _props.style,
        name = _props.name,
        id = _props.id,
        type = _props.type,
        disabled = _props.disabled,
        readOnly = _props.readOnly,
        tabIndex = _props.tabIndex,
        onClick = _props.onClick,
        onFocus = _props.onFocus,
        onBlur = _props.onBlur,
        autoFocus = _props.autoFocus,
        value = _props.value,
        others = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['prefixCls', 'className', 'style', 'name', 'id', 'type', 'disabled', 'readOnly', 'tabIndex', 'onClick', 'onFocus', 'onBlur', 'autoFocus', 'value']);

    var globalProps = Object.keys(others).reduce(function (prev, key) {
      if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
        prev[key] = others[key];
      }
      return prev;
    }, {});

    var checked = this.state.checked;

    var classString = __WEBPACK_IMPORTED_MODULE_7_classnames___default()(prefixCls, className, (_classNames = {}, _classNames[prefixCls + '-checked'] = checked, _classNames[prefixCls + '-disabled'] = disabled, _classNames));

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'span',
      { className: classString, style: style },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        name: name,
        id: id,
        type: type,
        readOnly: readOnly,
        disabled: disabled,
        tabIndex: tabIndex,
        className: prefixCls + '-input',
        checked: !!checked,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onChange: this.handleChange,
        autoFocus: autoFocus,
        ref: this.saveInput,
        value: value
      }, globalProps)),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: prefixCls + '-inner' })
    );
  };

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Checkbox.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  name: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  defaultChecked: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool]),
  checked: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool]),
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  tabIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
  readOnly: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
Checkbox.defaultProps = {
  prefixCls: 'rc-checkbox',
  className: '',
  style: {},
  type: 'checkbox',
  defaultChecked: false,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {}
};


Object(__WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__["polyfill"])(Checkbox);

/* harmony default export */ __webpack_exports__["a"] = (Checkbox);

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(19));

var _reactLifecyclesCompat = __webpack_require__(36);

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _shallowequal = _interopRequireDefault(__webpack_require__(89));

var _omit = _interopRequireDefault(__webpack_require__(71));

var _Checkbox = _interopRequireDefault(__webpack_require__(526));

var _configProvider = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var CheckboxGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(CheckboxGroup, _React$Component);

  var _super = _createSuper(CheckboxGroup);

  function CheckboxGroup(props) {
    var _this;

    _classCallCheck(this, CheckboxGroup);

    _this = _super.call(this, props);

    _this.cancelValue = function (value) {
      _this.setState(function (_ref) {
        var registeredValues = _ref.registeredValues;
        return {
          registeredValues: registeredValues.filter(function (val) {
            return val !== value;
          })
        };
      });
    };

    _this.registerValue = function (value) {
      _this.setState(function (_ref2) {
        var registeredValues = _ref2.registeredValues;
        return {
          registeredValues: [].concat(_toConsumableArray(registeredValues), [value])
        };
      });
    };

    _this.toggleOption = function (option) {
      var registeredValues = _this.state.registeredValues;

      var optionIndex = _this.state.value.indexOf(option.value);

      var value = _toConsumableArray(_this.state.value);

      if (optionIndex === -1) {
        value.push(option.value);
      } else {
        value.splice(optionIndex, 1);
      }

      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }

      var onChange = _this.props.onChange;

      if (onChange) {
        var options = _this.getOptions();

        onChange(value.filter(function (val) {
          return registeredValues.indexOf(val) !== -1;
        }).sort(function (a, b) {
          var indexA = options.findIndex(function (opt) {
            return opt.value === a;
          });
          var indexB = options.findIndex(function (opt) {
            return opt.value === b;
          });
          return indexA - indexB;
        }));
      }
    };

    _this.renderGroup = function (_ref3) {
      var getPrefixCls = _ref3.getPrefixCls;

      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props,
          state = _assertThisInitialize.state;

      var customizePrefixCls = props.prefixCls,
          className = props.className,
          style = props.style,
          options = props.options,
          restProps = __rest(props, ["prefixCls", "className", "style", "options"]);

      var prefixCls = getPrefixCls('checkbox', customizePrefixCls);
      var groupPrefixCls = "".concat(prefixCls, "-group");
      var domProps = (0, _omit["default"])(restProps, ['children', 'defaultValue', 'value', 'onChange', 'disabled']);
      var children = props.children;

      if (options && options.length > 0) {
        children = _this.getOptions().map(function (option) {
          return /*#__PURE__*/React.createElement(_Checkbox["default"], {
            prefixCls: prefixCls,
            key: option.value.toString(),
            disabled: 'disabled' in option ? option.disabled : props.disabled,
            value: option.value,
            checked: state.value.indexOf(option.value) !== -1,
            onChange: option.onChange,
            className: "".concat(groupPrefixCls, "-item")
          }, option.label);
        });
      }

      var classString = (0, _classnames["default"])(groupPrefixCls, className);
      return /*#__PURE__*/React.createElement("div", _extends({
        className: classString,
        style: style
      }, domProps), children);
    };

    _this.state = {
      value: props.value || props.defaultValue || [],
      registeredValues: []
    };
    return _this;
  }

  _createClass(CheckboxGroup, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        checkboxGroup: {
          toggleOption: this.toggleOption,
          value: this.state.value,
          disabled: this.props.disabled,
          name: this.props.name,
          // https://github.com/ant-design/ant-design/issues/16376
          registerValue: this.registerValue,
          cancelValue: this.cancelValue
        }
      };
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState);
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var options = this.props.options; // https://github.com/Microsoft/TypeScript/issues/7960

      return options.map(function (option) {
        if (typeof option === 'string') {
          return {
            label: option,
            value: option
          };
        }

        return option;
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderGroup);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: nextProps.value || []
        };
      }

      return null;
    }
  }]);

  return CheckboxGroup;
}(React.Component);

CheckboxGroup.defaultProps = {
  options: []
};
CheckboxGroup.propTypes = {
  defaultValue: PropTypes.array,
  value: PropTypes.array,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func
};
CheckboxGroup.childContextTypes = {
  checkboxGroup: PropTypes.any
};
(0, _reactLifecyclesCompat.polyfill)(CheckboxGroup);
var _default = CheckboxGroup;
exports["default"] = _default;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(19));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _shallowequal = _interopRequireDefault(__webpack_require__(89));

var _reactLifecyclesCompat = __webpack_require__(36);

var _radio = _interopRequireDefault(__webpack_require__(362));

var _configProvider = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function getCheckedValue(children) {
  var value = null;
  var matched = false;
  React.Children.forEach(children, function (radio) {
    if (radio && radio.props && radio.props.checked) {
      value = radio.props.value;
      matched = true;
    }
  });
  return matched ? {
    value: value
  } : undefined;
}

var RadioGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(RadioGroup, _React$Component);

  var _super = _createSuper(RadioGroup);

  function RadioGroup(props) {
    var _this;

    _classCallCheck(this, RadioGroup);

    _this = _super.call(this, props);

    _this.onRadioChange = function (ev) {
      var lastValue = _this.state.value;
      var value = ev.target.value;

      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }

      var onChange = _this.props.onChange;

      if (onChange && value !== lastValue) {
        onChange(ev);
      }
    };

    _this.renderGroup = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;

      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      var customizePrefixCls = props.prefixCls,
          _props$className = props.className,
          className = _props$className === void 0 ? '' : _props$className,
          options = props.options,
          buttonStyle = props.buttonStyle;
      var prefixCls = getPrefixCls('radio', customizePrefixCls);
      var groupPrefixCls = "".concat(prefixCls, "-group");
      var classString = (0, _classnames["default"])(groupPrefixCls, "".concat(groupPrefixCls, "-").concat(buttonStyle), _defineProperty({}, "".concat(groupPrefixCls, "-").concat(props.size), props.size), className);
      var children = props.children; // 如果存在 options, 优先使用

      if (options && options.length > 0) {
        children = options.map(function (option) {
          if (typeof option === 'string') {
            // 此处类型自动推导为 string
            return /*#__PURE__*/React.createElement(_radio["default"], {
              key: option,
              prefixCls: prefixCls,
              disabled: _this.props.disabled,
              value: option,
              checked: _this.state.value === option
            }, option);
          } // 此处类型自动推导为 { label: string value: string }


          return /*#__PURE__*/React.createElement(_radio["default"], {
            key: "radio-group-value-options-".concat(option.value),
            prefixCls: prefixCls,
            disabled: option.disabled || _this.props.disabled,
            value: option.value,
            checked: _this.state.value === option.value
          }, option.label);
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: classString,
        style: props.style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        id: props.id
      }, children);
    };

    var value;

    if ('value' in props) {
      value = props.value;
    } else if ('defaultValue' in props) {
      value = props.defaultValue;
    } else {
      var checkedValue = getCheckedValue(props.children);
      value = checkedValue && checkedValue.value;
    }

    _this.state = {
      value: value
    };
    return _this;
  }

  _createClass(RadioGroup, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        radioGroup: {
          onChange: this.onRadioChange,
          value: this.state.value,
          disabled: this.props.disabled,
          name: this.props.name
        }
      };
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderGroup);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: nextProps.value
        };
      }

      var checkedValue = getCheckedValue(nextProps.children);

      if (checkedValue) {
        return {
          value: checkedValue.value
        };
      }

      return null;
    }
  }]);

  return RadioGroup;
}(React.Component);

RadioGroup.defaultProps = {
  buttonStyle: 'outline'
};
RadioGroup.childContextTypes = {
  radioGroup: PropTypes.any
};
(0, _reactLifecyclesCompat.polyfill)(RadioGroup);
var _default = RadioGroup;
exports["default"] = _default;

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(19));

var _radio = _interopRequireDefault(__webpack_require__(362));

var _configProvider = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var RadioButton = /*#__PURE__*/function (_React$Component) {
  _inherits(RadioButton, _React$Component);

  var _super = _createSuper(RadioButton);

  function RadioButton() {
    var _this;

    _classCallCheck(this, RadioButton);

    _this = _super.apply(this, arguments);

    _this.renderRadioButton = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          radioProps = __rest(_a, ["prefixCls"]);

      var prefixCls = getPrefixCls('radio-button', customizePrefixCls);

      if (_this.context.radioGroup) {
        radioProps.checked = _this.props.value === _this.context.radioGroup.value;
        radioProps.disabled = _this.props.disabled || _this.context.radioGroup.disabled;
      }

      return /*#__PURE__*/React.createElement(_radio["default"], _extends({
        prefixCls: prefixCls
      }, radioProps));
    };

    return _this;
  }

  _createClass(RadioButton, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRadioButton);
    }
  }]);

  return RadioButton;
}(React.Component);

exports["default"] = RadioButton;
RadioButton.contextTypes = {
  radioGroup: PropTypes.any
};

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FilterDropdownMenuWrapper = function FilterDropdownMenuWrapper(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, props.children);
};

var _default = FilterDropdownMenuWrapper;
exports["default"] = _default;

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createStore;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function createStore(initialState) {
  var state = initialState;
  var listeners = [];

  function setState(partial) {
    state = _extends(_extends({}, state), partial);

    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }
  }

  function getState() {
    return state;
  }

  function subscribe(listener) {
    listeners.push(listener);
    return function unsubscribe() {
      var index = listeners.indexOf(listener);
      listeners.splice(index, 1);
    };
  }

  return {
    setState: setState,
    getState: getState,
    subscribe: subscribe
  };
}

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _checkbox = _interopRequireDefault(__webpack_require__(272));

var _radio = _interopRequireDefault(__webpack_require__(112));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var SelectionBox = /*#__PURE__*/function (_React$Component) {
  _inherits(SelectionBox, _React$Component);

  var _super = _createSuper(SelectionBox);

  function SelectionBox(props) {
    var _this;

    _classCallCheck(this, SelectionBox);

    _this = _super.call(this, props);
    _this.state = {
      checked: _this.getCheckState(props)
    };
    return _this;
  }

  _createClass(SelectionBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.subscribe();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.unsubscribe) {
        this.unsubscribe();
      }
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "getCheckState",
    value: function getCheckState(props) {
      var store = props.store,
          defaultSelection = props.defaultSelection,
          rowIndex = props.rowIndex;
      var checked = false;

      if (store.getState().selectionDirty) {
        checked = store.getState().selectedRowKeys.indexOf(rowIndex) >= 0;
      } else {
        checked = store.getState().selectedRowKeys.indexOf(rowIndex) >= 0 || defaultSelection.indexOf(rowIndex) >= 0;
      }

      return checked;
    }
  }, {
    key: "subscribe",
    value: function subscribe() {
      var _this2 = this;

      var store = this.props.store;
      this.unsubscribe = store.subscribe(function () {
        var checked = _this2.getCheckState(_this2.props);

        _this2.setState({
          checked: checked
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          type = _a.type,
          rowIndex = _a.rowIndex,
          rest = __rest(_a, ["type", "rowIndex"]);

      var checked = this.state.checked;

      if (type === 'radio') {
        return /*#__PURE__*/React.createElement(_radio["default"], _extends({
          checked: checked,
          value: rowIndex
        }, rest));
      }

      return /*#__PURE__*/React.createElement(_checkbox["default"], _extends({
        checked: checked
      }, rest));
    }
  }]);

  return SelectionBox;
}(React.Component);

exports["default"] = SelectionBox;

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _reactLifecyclesCompat = __webpack_require__(36);

var _checkbox = _interopRequireDefault(__webpack_require__(272));

var _dropdown = _interopRequireDefault(__webpack_require__(271));

var _menu = _interopRequireDefault(__webpack_require__(251));

var _icon = _interopRequireDefault(__webpack_require__(38));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function checkSelection(_ref) {
  var store = _ref.store,
      getCheckboxPropsByItem = _ref.getCheckboxPropsByItem,
      getRecordKey = _ref.getRecordKey,
      data = _ref.data,
      type = _ref.type,
      byDefaultChecked = _ref.byDefaultChecked;
  return byDefaultChecked ? data[type](function (item, i) {
    return getCheckboxPropsByItem(item, i).defaultChecked;
  }) : data[type](function (item, i) {
    return store.getState().selectedRowKeys.indexOf(getRecordKey(item, i)) >= 0;
  });
}

function getIndeterminateState(props) {
  var store = props.store,
      data = props.data;

  if (!data.length) {
    return false;
  }

  var someCheckedNotByDefaultChecked = checkSelection(_extends(_extends({}, props), {
    data: data,
    type: 'some',
    byDefaultChecked: false
  })) && !checkSelection(_extends(_extends({}, props), {
    data: data,
    type: 'every',
    byDefaultChecked: false
  }));
  var someCheckedByDefaultChecked = checkSelection(_extends(_extends({}, props), {
    data: data,
    type: 'some',
    byDefaultChecked: true
  })) && !checkSelection(_extends(_extends({}, props), {
    data: data,
    type: 'every',
    byDefaultChecked: true
  }));

  if (store.getState().selectionDirty) {
    return someCheckedNotByDefaultChecked;
  }

  return someCheckedNotByDefaultChecked || someCheckedByDefaultChecked;
}

function getCheckState(props) {
  var store = props.store,
      data = props.data;

  if (!data.length) {
    return false;
  }

  if (store.getState().selectionDirty) {
    return checkSelection(_extends(_extends({}, props), {
      data: data,
      type: 'every',
      byDefaultChecked: false
    }));
  }

  return checkSelection(_extends(_extends({}, props), {
    data: data,
    type: 'every',
    byDefaultChecked: false
  })) || checkSelection(_extends(_extends({}, props), {
    data: data,
    type: 'every',
    byDefaultChecked: true
  }));
}

var SelectionCheckboxAll = /*#__PURE__*/function (_React$Component) {
  _inherits(SelectionCheckboxAll, _React$Component);

  var _super = _createSuper(SelectionCheckboxAll);

  function SelectionCheckboxAll(props) {
    var _this;

    _classCallCheck(this, SelectionCheckboxAll);

    _this = _super.call(this, props);
    _this.state = {
      checked: false,
      indeterminate: false
    };

    _this.handleSelectAllChange = function (e) {
      var checked = e.target.checked;

      _this.props.onSelect(checked ? 'all' : 'removeAll', 0, null);
    };

    _this.defaultSelections = props.hideDefaultSelections ? [] : [{
      key: 'all',
      text: props.locale.selectAll
    }, {
      key: 'invert',
      text: props.locale.selectInvert
    }];
    return _this;
  }

  _createClass(SelectionCheckboxAll, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.subscribe();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.unsubscribe) {
        this.unsubscribe();
      }
    }
  }, {
    key: "setCheckState",
    value: function setCheckState(props) {
      var checked = getCheckState(props);
      var indeterminate = getIndeterminateState(props);
      this.setState(function (prevState) {
        var newState = {};

        if (indeterminate !== prevState.indeterminate) {
          newState.indeterminate = indeterminate;
        }

        if (checked !== prevState.checked) {
          newState.checked = checked;
        }

        return newState;
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe() {
      var _this2 = this;

      var store = this.props.store;
      this.unsubscribe = store.subscribe(function () {
        _this2.setCheckState(_this2.props);
      });
    }
  }, {
    key: "renderMenus",
    value: function renderMenus(selections) {
      var _this3 = this;

      return selections.map(function (selection, index) {
        return /*#__PURE__*/React.createElement(_menu["default"].Item, {
          key: selection.key || index
        }, /*#__PURE__*/React.createElement("div", {
          onClick: function onClick() {
            _this3.props.onSelect(selection.key, index, selection.onSelect);
          }
        }, selection.text));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          prefixCls = _this$props.prefixCls,
          selections = _this$props.selections,
          getPopupContainer = _this$props.getPopupContainer;
      var _this$state = this.state,
          checked = _this$state.checked,
          indeterminate = _this$state.indeterminate;
      var selectionPrefixCls = "".concat(prefixCls, "-selection");
      var customSelections = null;

      if (selections) {
        var newSelections = Array.isArray(selections) ? this.defaultSelections.concat(selections) : this.defaultSelections;
        var menu = /*#__PURE__*/React.createElement(_menu["default"], {
          className: "".concat(selectionPrefixCls, "-menu"),
          selectedKeys: []
        }, this.renderMenus(newSelections));
        customSelections = newSelections.length > 0 ? /*#__PURE__*/React.createElement(_dropdown["default"], {
          overlay: menu,
          getPopupContainer: getPopupContainer
        }, /*#__PURE__*/React.createElement("div", {
          className: "".concat(selectionPrefixCls, "-down")
        }, /*#__PURE__*/React.createElement(_icon["default"], {
          type: "down"
        }))) : null;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: selectionPrefixCls
      }, /*#__PURE__*/React.createElement(_checkbox["default"], {
        className: (0, _classnames["default"])(_defineProperty({}, "".concat(selectionPrefixCls, "-select-all-custom"), customSelections)),
        checked: checked,
        indeterminate: indeterminate,
        disabled: disabled,
        onChange: this.handleSelectAllChange
      }), customSelections);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var checked = getCheckState(props);
      var indeterminate = getIndeterminateState(props);
      var newState = {};

      if (indeterminate !== state.indeterminate) {
        newState.indeterminate = indeterminate;
      }

      if (checked !== state.checked) {
        newState.checked = checked;
      }

      return newState;
    }
  }]);

  return SelectionCheckboxAll;
}(React.Component);

(0, _reactLifecyclesCompat.polyfill)(SelectionCheckboxAll);
var _default = SelectionCheckboxAll;
exports["default"] = _default;

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable react/prefer-stateless-function */
var Column = /*#__PURE__*/function (_React$Component) {
  _inherits(Column, _React$Component);

  var _super = _createSuper(Column);

  function Column() {
    _classCallCheck(this, Column);

    return _super.apply(this, arguments);
  }

  return Column;
}(React.Component);

exports["default"] = Column;

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ColumnGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(ColumnGroup, _React$Component);

  var _super = _createSuper(ColumnGroup);

  function ColumnGroup() {
    _classCallCheck(this, ColumnGroup);

    return _super.apply(this, arguments);
  }

  return ColumnGroup;
}(React.Component);

exports["default"] = ColumnGroup;
ColumnGroup.__ANT_TABLE_COLUMN_GROUP = true;

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createBodyRow;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames2 = _interopRequireDefault(__webpack_require__(22));

var _omit = _interopRequireDefault(__webpack_require__(71));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function createBodyRow() {
  var Component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'tr';

  var BodyRow = /*#__PURE__*/function (_React$Component) {
    _inherits(BodyRow, _React$Component);

    var _super = _createSuper(BodyRow);

    function BodyRow(props) {
      var _this;

      _classCallCheck(this, BodyRow);

      _this = _super.call(this, props);
      _this.store = props.store;

      var _this$store$getState = _this.store.getState(),
          selectedRowKeys = _this$store$getState.selectedRowKeys;

      _this.state = {
        selected: selectedRowKeys.indexOf(props.rowKey) >= 0
      };
      return _this;
    }

    _createClass(BodyRow, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.subscribe();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.unsubscribe) {
          this.unsubscribe();
        }
      }
    }, {
      key: "subscribe",
      value: function subscribe() {
        var _this2 = this;

        var _this$props = this.props,
            store = _this$props.store,
            rowKey = _this$props.rowKey;
        this.unsubscribe = store.subscribe(function () {
          var _this2$store$getState = _this2.store.getState(),
              selectedRowKeys = _this2$store$getState.selectedRowKeys;

          var selected = selectedRowKeys.indexOf(rowKey) >= 0;

          if (selected !== _this2.state.selected) {
            _this2.setState({
              selected: selected
            });
          }
        });
      }
    }, {
      key: "render",
      value: function render() {
        var rowProps = (0, _omit["default"])(this.props, ['prefixCls', 'rowKey', 'store']);
        var className = (0, _classnames2["default"])(this.props.className, _defineProperty({}, "".concat(this.props.prefixCls, "-row-selected"), this.state.selected));
        return /*#__PURE__*/React.createElement(Component, _extends(_extends({}, rowProps), {
          className: className
        }), this.props.children);
      }
    }]);

    return BodyRow;
  }(React.Component);

  return BodyRow;
}

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = scrollTo;

var _raf = _interopRequireDefault(__webpack_require__(463));

var _getScroll = _interopRequireDefault(__webpack_require__(1076));

var _easings = __webpack_require__(1077);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function scrollTo(y) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$getContainer = options.getContainer,
      getContainer = _options$getContainer === void 0 ? function () {
    return window;
  } : _options$getContainer,
      callback = options.callback,
      _options$duration = options.duration,
      duration = _options$duration === void 0 ? 450 : _options$duration;
  var container = getContainer();
  var scrollTop = (0, _getScroll["default"])(container, true);
  var startTime = Date.now();

  var frameFunc = function frameFunc() {
    var timestamp = Date.now();
    var time = timestamp - startTime;
    var nextScrollTop = (0, _easings.easeInOutCubic)(time > duration ? duration : time, scrollTop, y, duration);

    if (container === window) {
      window.scrollTo(window.pageXOffset, nextScrollTop);
    } else {
      container.scrollTop = nextScrollTop;
    }

    if (time < duration) {
      (0, _raf["default"])(frameFunc);
    } else if (typeof callback === 'function') {
      callback();
    }
  };

  (0, _raf["default"])(frameFunc);
}

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getScroll;

function getScroll(target, top) {
  if (typeof window === 'undefined') {
    return 0;
  }

  var prop = top ? 'pageYOffset' : 'pageXOffset';
  var method = top ? 'scrollTop' : 'scrollLeft';
  var isWindow = target === window;
  var ret = isWindow ? target[prop] : target[method]; // ie6,7,8 standard mode

  if (isWindow && typeof ret !== 'number') {
    ret = document.documentElement[method];
  }

  return ret;
}

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.easeInOutCubic = easeInOutCubic;

// eslint-disable-next-line import/prefer-default-export
function easeInOutCubic(t, b, c, d) {
  var cc = c - b;
  t /= d / 2;

  if (t < 1) {
    return cc / 2 * t * t * t + b;
  }

  return cc / 2 * ((t -= 2) * t * t + 2) + b;
}

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcPagination = _interopRequireDefault(__webpack_require__(1079));

var _en_US = _interopRequireDefault(__webpack_require__(461));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _MiniSelect = _interopRequireDefault(__webpack_require__(1084));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _select = _interopRequireDefault(__webpack_require__(41));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(113));

var _configProvider = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Pagination = /*#__PURE__*/function (_React$Component) {
  _inherits(Pagination, _React$Component);

  var _super = _createSuper(Pagination);

  function Pagination() {
    var _this;

    _classCallCheck(this, Pagination);

    _this = _super.apply(this, arguments);

    _this.getIconsProps = function (prefixCls) {
      var prevIcon = /*#__PURE__*/React.createElement("a", {
        className: "".concat(prefixCls, "-item-link")
      }, /*#__PURE__*/React.createElement(_icon["default"], {
        type: "left"
      }));
      var nextIcon = /*#__PURE__*/React.createElement("a", {
        className: "".concat(prefixCls, "-item-link")
      }, /*#__PURE__*/React.createElement(_icon["default"], {
        type: "right"
      }));
      var jumpPrevIcon = /*#__PURE__*/React.createElement("a", {
        className: "".concat(prefixCls, "-item-link")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-item-container")
      }, /*#__PURE__*/React.createElement(_icon["default"], {
        className: "".concat(prefixCls, "-item-link-icon"),
        type: "double-left"
      }), /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-item-ellipsis")
      }, "\u2022\u2022\u2022")));
      var jumpNextIcon = /*#__PURE__*/React.createElement("a", {
        className: "".concat(prefixCls, "-item-link")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-item-container")
      }, /*#__PURE__*/React.createElement(_icon["default"], {
        className: "".concat(prefixCls, "-item-link-icon"),
        type: "double-right"
      }), /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-item-ellipsis")
      }, "\u2022\u2022\u2022")));
      return {
        prevIcon: prevIcon,
        nextIcon: nextIcon,
        jumpPrevIcon: jumpPrevIcon,
        jumpNextIcon: jumpNextIcon
      };
    };

    _this.renderPagination = function (contextLocale) {
      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          customizeSelectPrefixCls = _a.selectPrefixCls,
          className = _a.className,
          size = _a.size,
          customLocale = _a.locale,
          restProps = __rest(_a, ["prefixCls", "selectPrefixCls", "className", "size", "locale"]);

      var locale = _extends(_extends({}, contextLocale), customLocale);

      var isSmall = size === 'small';
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
        var getPrefixCls = _ref.getPrefixCls;
        var prefixCls = getPrefixCls('pagination', customizePrefixCls);
        var selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
        return /*#__PURE__*/React.createElement(_rcPagination["default"], _extends({}, restProps, {
          prefixCls: prefixCls,
          selectPrefixCls: selectPrefixCls
        }, _this.getIconsProps(prefixCls), {
          className: (0, _classnames["default"])(className, {
            mini: isSmall
          }),
          selectComponentClass: isSmall ? _MiniSelect["default"] : _select["default"],
          locale: locale
        }));
      });
    };

    return _this;
  }

  _createClass(Pagination, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
        componentName: "Pagination",
        defaultLocale: _en_US["default"]
      }, this.renderPagination);
    }
  }]);

  return Pagination;
}(React.Component);

exports["default"] = Pagination;

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination__ = __webpack_require__(1080);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__Pagination__["a"]; });


/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Pager__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Options__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__KeyCode__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__locale_zh_CN__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_lifecycles_compat__ = __webpack_require__(36);















function noop() {}

function isInteger(value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

function defaultItemRender(page, type, element) {
  return element;
}

function calculatePage(p, state, props) {
  var pageSize = p;
  if (typeof pageSize === 'undefined') {
    pageSize = state.pageSize;
  }
  return Math.floor((props.total - 1) / pageSize) + 1;
}

var Pagination = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Pagination, _React$Component);

  function Pagination(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Pagination);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));

    _initialiseProps.call(_this);

    var hasOnChange = props.onChange !== noop;
    var hasCurrent = 'current' in props;
    if (hasCurrent && !hasOnChange) {
      console.warn('Warning: You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.'); // eslint-disable-line
    }

    var current = props.defaultCurrent;
    if ('current' in props) {
      current = props.current;
    }

    var pageSize = props.defaultPageSize;
    if ('pageSize' in props) {
      pageSize = props.pageSize;
    }

    current = Math.min(current, calculatePage(pageSize, undefined, props));

    _this.state = {
      current: current,
      currentInputValue: current,
      pageSize: pageSize
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Pagination, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // When current page change, fix focused style of prev item
      // A hacky solution of https://github.com/ant-design/ant-design/issues/8948
      var prefixCls = this.props.prefixCls;

      if (prevState.current !== this.state.current && this.paginationNode) {
        var lastCurrentNode = this.paginationNode.querySelector('.' + prefixCls + '-item-' + prevState.current);
        if (lastCurrentNode && document.activeElement === lastCurrentNode) {
          lastCurrentNode.blur();
        }
      }
    }
  }, {
    key: 'getValidValue',
    value: function getValidValue(e) {
      var inputValue = e.target.value;
      var allPages = calculatePage(undefined, this.state, this.props);
      var currentInputValue = this.state.currentInputValue;

      var value = void 0;
      if (inputValue === '') {
        value = inputValue;
      } else if (isNaN(Number(inputValue))) {
        value = currentInputValue;
      } else if (inputValue >= allPages) {
        value = allPages;
      } else {
        value = Number(inputValue);
      }
      return value;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          prefixCls = _props.prefixCls,
          className = _props.className,
          disabled = _props.disabled;

      // When hideOnSinglePage is true and there is only 1 page, hide the pager

      if (this.props.hideOnSinglePage === true && this.props.total <= this.state.pageSize) {
        return null;
      }

      var props = this.props;
      var locale = props.locale;

      var allPages = calculatePage(undefined, this.state, this.props);
      var pagerList = [];
      var jumpPrev = null;
      var jumpNext = null;
      var firstPager = null;
      var lastPager = null;
      var gotoButton = null;

      var goButton = props.showQuickJumper && props.showQuickJumper.goButton;
      var pageBufferSize = props.showLessItems ? 1 : 2;
      var _state = this.state,
          current = _state.current,
          pageSize = _state.pageSize;


      var prevPage = current - 1 > 0 ? current - 1 : 0;
      var nextPage = current + 1 < allPages ? current + 1 : allPages;

      var dataOrAriaAttributeProps = Object.keys(props).reduce(function (prev, key) {
        if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') {
          prev[key] = props[key];
        }
        return prev;
      }, {});

      if (props.simple) {
        if (goButton) {
          if (typeof goButton === 'boolean') {
            gotoButton = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              'button',
              {
                type: 'button',
                onClick: this.handleGoTO,
                onKeyUp: this.handleGoTO
              },
              locale.jump_to_confirm
            );
          } else {
            gotoButton = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              'span',
              {
                onClick: this.handleGoTO,
                onKeyUp: this.handleGoTO
              },
              goButton
            );
          }
          gotoButton = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? '' + locale.jump_to + this.state.current + '/' + allPages : null,
              className: prefixCls + '-simple-pager'
            },
            gotoButton
          );
        }

        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'ul',
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
            className: prefixCls + ' ' + prefixCls + '-simple ' + props.className,
            style: props.style,
            ref: this.savePaginationNode
          }, dataOrAriaAttributeProps),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? locale.prev_page : null,
              onClick: this.prev,
              tabIndex: this.hasPrev() ? 0 : null,
              onKeyPress: this.runIfEnterPrev,
              className: (this.hasPrev() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
              'aria-disabled': !this.hasPrev()
            },
            props.itemRender(prevPage, 'prev', this.getItemIcon(props.prevIcon))
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? this.state.current + '/' + allPages : null,
              className: prefixCls + '-simple-pager'
            },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', {
              type: 'text',
              value: this.state.currentInputValue,
              onKeyDown: this.handleKeyDown,
              onKeyUp: this.handleKeyUp,
              onChange: this.handleKeyUp,
              size: '3'
            }),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              'span',
              { className: prefixCls + '-slash' },
              '/'
            ),
            allPages
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? locale.next_page : null,
              onClick: this.next,
              tabIndex: this.hasPrev() ? 0 : null,
              onKeyPress: this.runIfEnterNext,
              className: (this.hasNext() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
              'aria-disabled': !this.hasNext()
            },
            props.itemRender(nextPage, 'next', this.getItemIcon(props.nextIcon))
          ),
          gotoButton
        );
      }

      if (allPages <= 5 + pageBufferSize * 2) {
        var pagerProps = {
          locale: locale,
          rootPrefixCls: prefixCls,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          showTitle: props.showTitle,
          itemRender: props.itemRender
        };
        if (!allPages) {
          pagerList.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Pager__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, pagerProps, {
            key: 'noPager',
            page: allPages,
            className: prefixCls + '-disabled'
          })));
        }
        for (var i = 1; i <= allPages; i++) {
          var active = this.state.current === i;
          pagerList.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Pager__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, pagerProps, {
            key: i,
            page: i,
            active: active
          })));
        }
      } else {
        var prevItemTitle = props.showLessItems ? locale.prev_3 : locale.prev_5;
        var nextItemTitle = props.showLessItems ? locale.next_3 : locale.next_5;
        if (props.showPrevNextJumpers) {
          var jumpPrevClassString = prefixCls + '-jump-prev';
          if (props.jumpPrevIcon) {
            jumpPrevClassString += ' ' + prefixCls + '-jump-prev-custom-icon';
          }
          jumpPrev = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? prevItemTitle : null,
              key: 'prev',
              onClick: this.jumpPrev,
              tabIndex: '0',
              onKeyPress: this.runIfEnterJumpPrev,
              className: jumpPrevClassString
            },
            props.itemRender(this.getJumpPrevPage(), 'jump-prev', this.getItemIcon(props.jumpPrevIcon))
          );
          var jumpNextClassString = prefixCls + '-jump-next';
          if (props.jumpNextIcon) {
            jumpNextClassString += ' ' + prefixCls + '-jump-next-custom-icon';
          }
          jumpNext = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? nextItemTitle : null,
              key: 'next',
              tabIndex: '0',
              onClick: this.jumpNext,
              onKeyPress: this.runIfEnterJumpNext,
              className: jumpNextClassString
            },
            props.itemRender(this.getJumpNextPage(), 'jump-next', this.getItemIcon(props.jumpNextIcon))
          );
        }
        lastPager = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Pager__["a" /* default */], {
          locale: props.locale,
          last: true,
          rootPrefixCls: prefixCls,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          key: allPages,
          page: allPages,
          active: false,
          showTitle: props.showTitle,
          itemRender: props.itemRender
        });
        firstPager = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Pager__["a" /* default */], {
          locale: props.locale,
          rootPrefixCls: prefixCls,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          key: 1,
          page: 1,
          active: false,
          showTitle: props.showTitle,
          itemRender: props.itemRender
        });

        var left = Math.max(1, current - pageBufferSize);
        var right = Math.min(current + pageBufferSize, allPages);

        if (current - 1 <= pageBufferSize) {
          right = 1 + pageBufferSize * 2;
        }

        if (allPages - current <= pageBufferSize) {
          left = allPages - pageBufferSize * 2;
        }

        for (var _i = left; _i <= right; _i++) {
          var _active = current === _i;
          pagerList.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Pager__["a" /* default */], {
            locale: props.locale,
            rootPrefixCls: prefixCls,
            onClick: this.handleChange,
            onKeyPress: this.runIfEnter,
            key: _i,
            page: _i,
            active: _active,
            showTitle: props.showTitle,
            itemRender: props.itemRender
          }));
        }

        if (current - 1 >= pageBufferSize * 2 && current !== 1 + 2) {
          pagerList[0] = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(pagerList[0], {
            className: prefixCls + '-item-after-jump-prev'
          });
          pagerList.unshift(jumpPrev);
        }
        if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
          pagerList[pagerList.length - 1] = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(pagerList[pagerList.length - 1], {
            className: prefixCls + '-item-before-jump-next'
          });
          pagerList.push(jumpNext);
        }

        if (left !== 1) {
          pagerList.unshift(firstPager);
        }
        if (right !== allPages) {
          pagerList.push(lastPager);
        }
      }

      var totalText = null;

      if (props.showTotal) {
        totalText = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'li',
          { className: prefixCls + '-total-text' },
          props.showTotal(props.total, [props.total === 0 ? 0 : (current - 1) * pageSize + 1, current * pageSize > props.total ? props.total : current * pageSize])
        );
      }
      var prevDisabled = !this.hasPrev() || !allPages;
      var nextDisabled = !this.hasNext() || !allPages;
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'ul',
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()(prefixCls, className, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, prefixCls + '-disabled', disabled)),
          style: props.style,
          unselectable: 'unselectable',
          ref: this.savePaginationNode
        }, dataOrAriaAttributeProps),
        totalText,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'li',
          {
            title: props.showTitle ? locale.prev_page : null,
            onClick: this.prev,
            tabIndex: prevDisabled ? null : 0,
            onKeyPress: this.runIfEnterPrev,
            className: (!prevDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
            'aria-disabled': prevDisabled
          },
          props.itemRender(prevPage, 'prev', this.getItemIcon(props.prevIcon))
        ),
        pagerList,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'li',
          {
            title: props.showTitle ? locale.next_page : null,
            onClick: this.next,
            tabIndex: nextDisabled ? null : 0,
            onKeyPress: this.runIfEnterNext,
            className: (!nextDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
            'aria-disabled': nextDisabled
          },
          props.itemRender(nextPage, 'next', this.getItemIcon(props.nextIcon))
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Options__["a" /* default */], {
          disabled: disabled,
          locale: props.locale,
          rootPrefixCls: prefixCls,
          selectComponentClass: props.selectComponentClass,
          selectPrefixCls: props.selectPrefixCls,
          changeSize: this.props.showSizeChanger ? this.changePageSize : null,
          current: this.state.current,
          pageSize: this.state.pageSize,
          pageSizeOptions: this.props.pageSizeOptions,
          quickGo: this.shouldDisplayQuickJumper() ? this.handleChange : null,
          goButton: goButton
        })
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, prevState) {
      var newState = {};

      if ('current' in props) {
        newState.current = props.current;

        if (props.current !== prevState.current) {
          newState.currentInputValue = newState.current;
        }
      }

      if ('pageSize' in props && props.pageSize !== prevState.pageSize) {
        var current = prevState.current;
        var newCurrent = calculatePage(props.pageSize, prevState, props);
        current = current > newCurrent ? newCurrent : current;

        if (!('current' in props)) {
          newState.current = current;
          newState.currentInputValue = current;
        }
        newState.pageSize = props.pageSize;
      }

      return newState;
    }

    /**
     * computed icon node that need to be rendered.
     * @param {React.ReactNode | React.ComponentType<PaginationProps>} icon received icon.
     * @returns {React.ReactNode}
     */

  }]);

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Pagination.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  current: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  defaultCurrent: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  total: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  pageSize: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  defaultPageSize: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  hideOnSinglePage: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  showSizeChanger: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  showLessItems: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onShowSizeChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  selectComponentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  showPrevNextJumpers: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  showQuickJumper: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object]),
  showTitle: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  pageSizeOptions: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string),
  showTotal: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  locale: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  itemRender: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  prevIcon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node]),
  nextIcon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node]),
  jumpPrevIcon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node]),
  jumpNextIcon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node])
};
Pagination.defaultProps = {
  defaultCurrent: 1,
  total: 0,
  defaultPageSize: 10,
  onChange: noop,
  className: '',
  selectPrefixCls: 'rc-select',
  prefixCls: 'rc-pagination',
  selectComponentClass: null,
  hideOnSinglePage: false,
  showPrevNextJumpers: true,
  showQuickJumper: false,
  showSizeChanger: false,
  showLessItems: false,
  showTitle: true,
  onShowSizeChange: noop,
  locale: __WEBPACK_IMPORTED_MODULE_12__locale_zh_CN__["a" /* default */],
  style: {},
  itemRender: defaultItemRender
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getJumpPrevPage = function () {
    return Math.max(1, _this2.state.current - (_this2.props.showLessItems ? 3 : 5));
  };

  this.getJumpNextPage = function () {
    return Math.min(calculatePage(undefined, _this2.state, _this2.props), _this2.state.current + (_this2.props.showLessItems ? 3 : 5));
  };

  this.getItemIcon = function (icon) {
    var prefixCls = _this2.props.prefixCls;

    var iconNode = icon || __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a', { className: prefixCls + '-item-link' });
    if (typeof icon === 'function') {
      iconNode = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(icon, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this2.props));
    }
    return iconNode;
  };

  this.savePaginationNode = function (node) {
    _this2.paginationNode = node;
  };

  this.isValid = function (page) {
    return isInteger(page) && page !== _this2.state.current;
  };

  this.shouldDisplayQuickJumper = function () {
    var _props2 = _this2.props,
        showQuickJumper = _props2.showQuickJumper,
        pageSize = _props2.pageSize,
        total = _props2.total;

    if (total <= pageSize) {
      return false;
    }
    return showQuickJumper;
  };

  this.handleKeyDown = function (e) {
    if (e.keyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].ARROW_UP || e.keyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].ARROW_DOWN) {
      e.preventDefault();
    }
  };

  this.handleKeyUp = function (e) {
    var value = _this2.getValidValue(e);
    var currentInputValue = _this2.state.currentInputValue;

    if (value !== currentInputValue) {
      _this2.setState({
        currentInputValue: value
      });
    }
    if (e.keyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].ENTER) {
      _this2.handleChange(value);
    } else if (e.keyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].ARROW_UP) {
      _this2.handleChange(value - 1);
    } else if (e.keyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].ARROW_DOWN) {
      _this2.handleChange(value + 1);
    }
  };

  this.changePageSize = function (size) {
    var current = _this2.state.current;
    var newCurrent = calculatePage(size, _this2.state, _this2.props);
    current = current > newCurrent ? newCurrent : current;
    // fix the issue:
    // Once 'total' is 0, 'current' in 'onShowSizeChange' is 0, which is not correct.
    if (newCurrent === 0) {
      current = _this2.state.current;
    }

    if (typeof size === 'number') {
      if (!('pageSize' in _this2.props)) {
        _this2.setState({
          pageSize: size
        });
      }
      if (!('current' in _this2.props)) {
        _this2.setState({
          current: current,
          currentInputValue: current
        });
      }
    }
    _this2.props.onShowSizeChange(current, size);
  };

  this.handleChange = function (p) {
    var disabled = _this2.props.disabled;


    var page = p;
    if (_this2.isValid(page) && !disabled) {
      var currentPage = calculatePage(undefined, _this2.state, _this2.props);
      if (page > currentPage) {
        page = currentPage;
      } else if (page < 1) {
        page = 1;
      }

      if (!('current' in _this2.props)) {
        _this2.setState({
          current: page,
          currentInputValue: page
        });
      }

      var pageSize = _this2.state.pageSize;
      _this2.props.onChange(page, pageSize);

      return page;
    }

    return _this2.state.current;
  };

  this.prev = function () {
    if (_this2.hasPrev()) {
      _this2.handleChange(_this2.state.current - 1);
    }
  };

  this.next = function () {
    if (_this2.hasNext()) {
      _this2.handleChange(_this2.state.current + 1);
    }
  };

  this.jumpPrev = function () {
    _this2.handleChange(_this2.getJumpPrevPage());
  };

  this.jumpNext = function () {
    _this2.handleChange(_this2.getJumpNextPage());
  };

  this.hasPrev = function () {
    return _this2.state.current > 1;
  };

  this.hasNext = function () {
    return _this2.state.current < calculatePage(undefined, _this2.state, _this2.props);
  };

  this.runIfEnter = function (event, callback) {
    for (var _len = arguments.length, restParams = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      restParams[_key - 2] = arguments[_key];
    }

    if (event.key === 'Enter' || event.charCode === 13) {
      callback.apply(undefined, restParams);
    }
  };

  this.runIfEnterPrev = function (e) {
    _this2.runIfEnter(e, _this2.prev);
  };

  this.runIfEnterNext = function (e) {
    _this2.runIfEnter(e, _this2.next);
  };

  this.runIfEnterJumpPrev = function (e) {
    _this2.runIfEnter(e, _this2.jumpPrev);
  };

  this.runIfEnterJumpNext = function (e) {
    _this2.runIfEnter(e, _this2.jumpNext);
  };

  this.handleGoTO = function (e) {
    if (e.keyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].ENTER || e.type === 'click') {
      _this2.handleChange(_this2.state.currentInputValue);
    }
  };
};

Object(__WEBPACK_IMPORTED_MODULE_13_react_lifecycles_compat__["polyfill"])(Pagination);

/* harmony default export */ __webpack_exports__["a"] = (Pagination);

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);





var Pager = function Pager(props) {
  var _classNames;

  var prefixCls = props.rootPrefixCls + '-item';
  var cls = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(prefixCls, prefixCls + '-' + props.page, (_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-active', props.active), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, props.className, !!props.className), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-disabled', !props.page), _classNames));

  var handleClick = function handleClick() {
    props.onClick(props.page);
  };

  var handleKeyPress = function handleKeyPress(e) {
    props.onKeyPress(e, props.onClick, props.page);
  };

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'li',
    {
      title: props.showTitle ? props.page : null,
      className: cls,
      onClick: handleClick,
      onKeyPress: handleKeyPress,
      tabIndex: '0'
    },
    props.itemRender(props.page, 'page', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'a',
      null,
      props.page
    ))
  );
};

Pager.propTypes = {
  page: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  active: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  last: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  locale: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  showTitle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onKeyPress: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  itemRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (Pager);

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__KeyCode__ = __webpack_require__(529);








var Options = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Options, _React$Component);

  function Options() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Options);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Options.__proto__ || Object.getPrototypeOf(Options)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      goInputText: ''
    }, _this.buildOptionText = function (value) {
      return value + ' ' + _this.props.locale.items_per_page;
    }, _this.changeSize = function (value) {
      _this.props.changeSize(Number(value));
    }, _this.handleChange = function (e) {
      _this.setState({
        goInputText: e.target.value
      });
    }, _this.handleBlur = function (e) {
      var _this$props = _this.props,
          goButton = _this$props.goButton,
          quickGo = _this$props.quickGo,
          rootPrefixCls = _this$props.rootPrefixCls;

      if (goButton) {
        return;
      }
      if (e.relatedTarget && (e.relatedTarget.className.indexOf(rootPrefixCls + '-prev') >= 0 || e.relatedTarget.className.indexOf(rootPrefixCls + '-next') >= 0)) {
        return;
      }
      quickGo(_this.getValidValue());
    }, _this.go = function (e) {
      var goInputText = _this.state.goInputText;

      if (goInputText === '') {
        return;
      }
      if (e.keyCode === __WEBPACK_IMPORTED_MODULE_6__KeyCode__["a" /* default */].ENTER || e.type === 'click') {
        _this.setState({
          goInputText: ''
        });
        _this.props.quickGo(_this.getValidValue());
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Options, [{
    key: 'getValidValue',
    value: function getValidValue() {
      var _state = this.state,
          goInputText = _state.goInputText,
          current = _state.current;

      return !goInputText || isNaN(goInputText) ? current : Number(goInputText);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          pageSize = _props.pageSize,
          pageSizeOptions = _props.pageSizeOptions,
          locale = _props.locale,
          rootPrefixCls = _props.rootPrefixCls,
          changeSize = _props.changeSize,
          quickGo = _props.quickGo,
          goButton = _props.goButton,
          selectComponentClass = _props.selectComponentClass,
          buildOptionText = _props.buildOptionText,
          selectPrefixCls = _props.selectPrefixCls,
          disabled = _props.disabled;
      var goInputText = this.state.goInputText;

      var prefixCls = rootPrefixCls + '-options';
      var Select = selectComponentClass;
      var changeSelect = null;
      var goInput = null;
      var gotoButton = null;

      if (!changeSize && !quickGo) {
        return null;
      }

      if (changeSize && Select) {
        var options = pageSizeOptions.map(function (opt, i) {
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            Select.Option,
            { key: i, value: opt },
            (buildOptionText || _this2.buildOptionText)(opt)
          );
        });

        changeSelect = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          Select,
          {
            disabled: disabled,
            prefixCls: selectPrefixCls,
            showSearch: false,
            className: prefixCls + '-size-changer',
            optionLabelProp: 'children',
            dropdownMatchSelectWidth: false,
            value: (pageSize || pageSizeOptions[0]).toString(),
            onChange: this.changeSize,
            getPopupContainer: function getPopupContainer(triggerNode) {
              return triggerNode.parentNode;
            }
          },
          options
        );
      }

      if (quickGo) {
        if (goButton) {
          gotoButton = typeof goButton === 'boolean' ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'button',
            {
              type: 'button',
              onClick: this.go,
              onKeyUp: this.go,
              disabled: disabled
            },
            locale.jump_to_confirm
          ) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'span',
            {
              onClick: this.go,
              onKeyUp: this.go
            },
            goButton
          );
        }
        goInput = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'div',
          { className: prefixCls + '-quick-jumper' },
          locale.jump_to,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input', {
            disabled: disabled,
            type: 'text',
            value: goInputText,
            onChange: this.handleChange,
            onKeyUp: this.go,
            onBlur: this.handleBlur
          }),
          locale.page,
          gotoButton
        );
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'li',
        { className: '' + prefixCls },
        changeSelect,
        goInput
      );
    }
  }]);

  return Options;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Options.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  changeSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  quickGo: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  selectComponentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  current: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  pageSizeOptions: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string),
  pageSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  buildOptionText: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  locale: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  selectPrefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  goButton: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node])
};
Options.defaultProps = {
  pageSizeOptions: ['10', '20', '30', '40']
};


/* harmony default export */ __webpack_exports__["a"] = (Options);

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  // Options.jsx
  items_per_page: '条/页',
  jump_to: '跳至',
  jump_to_confirm: '确定',
  page: '页',

  // Pagination.jsx
  prev_page: '上一页',
  next_page: '下一页',
  prev_5: '向前 5 页',
  next_5: '向后 5 页',
  prev_3: '向前 3 页',
  next_3: '向后 3 页'
});

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _select = _interopRequireDefault(__webpack_require__(41));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var MiniSelect = /*#__PURE__*/function (_React$Component) {
  _inherits(MiniSelect, _React$Component);

  var _super = _createSuper(MiniSelect);

  function MiniSelect() {
    _classCallCheck(this, MiniSelect);

    return _super.apply(this, arguments);
  }

  _createClass(MiniSelect, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_select["default"], _extends({
        size: "small"
      }, this.props));
    }
  }]);

  return MiniSelect;
}(React.Component);

exports["default"] = MiniSelect;
MiniSelect.Option = _select["default"].Option;

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OptGroup__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Option__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PropTypes__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Select__ = __webpack_require__(1087);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Option", function() { return __WEBPACK_IMPORTED_MODULE_1__Option__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "OptGroup", function() { return __WEBPACK_IMPORTED_MODULE_0__OptGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SelectPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_2__PropTypes__["a"]; });




__WEBPACK_IMPORTED_MODULE_3__Select__["a" /* default */].Option = __WEBPACK_IMPORTED_MODULE_1__Option__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_3__Select__["a" /* default */].OptGroup = __WEBPACK_IMPORTED_MODULE_0__OptGroup__["a" /* default */];

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_3__Select__["a" /* default */]);

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OptGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }



var OptGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(OptGroup, _Component);

  function OptGroup() {
    _classCallCheck(this, OptGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(OptGroup).apply(this, arguments));
  }

  return OptGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


OptGroup.isSelectOptGroup = true;

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_component_classes__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_component_classes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_animate__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_menu__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_util_es_Children_toArray__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Option__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PropTypes__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SelectTrigger__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util__ = __webpack_require__(364);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }











 // Where el is the DOM element you'd like to test for visibility

function isHidden(node) {
  return !node || node.offsetParent === null;
}




var SELECT_EMPTY_VALUE_KEY = 'RC_SELECT_EMPTY_VALUE_KEY';

var noop = function noop() {
  return null;
};

function chaining() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    // tslint:disable-next-line:prefer-for-of
    for (var i = 0; i < fns.length; i++) {
      if (fns[i] && typeof fns[i] === 'function') {
        fns[i].apply(chaining, args);
      }
    }
  };
}

var Select =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Select, _React$Component);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, props));
    _this.inputRef = null;
    _this.inputMirrorRef = null;
    _this.topCtrlRef = null;
    _this.selectTriggerRef = null;
    _this.rootRef = null;
    _this.selectionRef = null;
    _this.dropdownContainer = null;
    _this.blurTimer = null;
    _this.focusTimer = null;
    _this.comboboxTimer = null; // tslint:disable-next-line:variable-name

    _this._focused = false; // tslint:disable-next-line:variable-name

    _this._mouseDown = false; // tslint:disable-next-line:variable-name

    _this._options = []; // tslint:disable-next-line:variable-name

    _this._empty = false;

    _this.onInputChange = function (event) {
      var tokenSeparators = _this.props.tokenSeparators;
      var val = event.target.value;

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(_this.props) && tokenSeparators.length && Object(__WEBPACK_IMPORTED_MODULE_13__util__["l" /* includesSeparators */])(val, tokenSeparators)) {
        var nextValue = _this.getValueByInput(val);

        if (nextValue !== undefined) {
          _this.fireChange(nextValue);
        }

        _this.setOpenState(false, {
          needFocus: true
        });

        _this.setInputValue('', false);

        return;
      }

      _this.setInputValue(val);

      _this.setState({
        open: true
      });

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(_this.props)) {
        _this.fireChange([val]);
      }
    };

    _this.onDropdownVisibleChange = function (open) {
      if (open && !_this._focused) {
        _this.clearBlurTime();

        _this.timeoutFocus();

        _this._focused = true;

        _this.updateFocusClassName();
      }

      _this.setOpenState(open);
    }; // combobox ignore


    _this.onKeyDown = function (event) {
      var open = _this.state.open;
      var disabled = _this.props.disabled;

      if (disabled) {
        return;
      }

      var keyCode = event.keyCode;

      if (open && !_this.getInputDOMNode()) {
        _this.onInputKeyDown(event);
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].ENTER || keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].DOWN) {
        if (!open) {
          _this.setOpenState(true);
        }

        event.preventDefault();
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].SPACE) {
        // Not block space if popup is shown
        if (!open) {
          _this.setOpenState(true);

          event.preventDefault();
        }
      }
    };

    _this.onInputKeyDown = function (event) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          combobox = _this$props.combobox,
          defaultActiveFirstOption = _this$props.defaultActiveFirstOption;

      if (disabled) {
        return;
      }

      var state = _this.state;

      var isRealOpen = _this.getRealOpenState(state); // magic code


      var keyCode = event.keyCode;

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(_this.props) && !event.target.value && keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].BACKSPACE) {
        event.preventDefault();
        var value = state.value;

        if (value.length) {
          _this.removeSelected(value[value.length - 1]);
        }

        return;
      }

      if (keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].DOWN) {
        if (!state.open) {
          _this.openIfHasChildren();

          event.preventDefault();
          event.stopPropagation();
          return;
        }
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].ENTER && state.open) {
        // Aviod trigger form submit when select item
        // https://github.com/ant-design/ant-design/issues/10861
        // https://github.com/ant-design/ant-design/issues/14544
        if (isRealOpen || !combobox) {
          event.preventDefault();
        } // Hard close popup to avoid lock of non option in combobox mode


        if (isRealOpen && combobox && defaultActiveFirstOption === false) {
          _this.comboboxTimer = setTimeout(function () {
            _this.setOpenState(false);
          });
        }
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].ESC) {
        if (state.open) {
          _this.setOpenState(false);

          event.preventDefault();
          event.stopPropagation();
        }

        return;
      }

      if (isRealOpen && _this.selectTriggerRef) {
        var menu = _this.selectTriggerRef.getInnerMenu();

        if (menu && menu.onKeyDown(event, _this.handleBackfill)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }
    };

    _this.onMenuSelect = function (_ref) {
      var item = _ref.item;

      if (!item) {
        return;
      }

      var value = _this.state.value;
      var props = _this.props;
      var selectedValue = Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(item);
      var lastValue = value[value.length - 1];
      var skipTrigger = false;

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props)) {
        if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["e" /* findIndexInValueBySingleValue */])(value, selectedValue) !== -1) {
          skipTrigger = true;
        } else {
          value = value.concat([selectedValue]);
        }
      } else {
        if (!Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(props) && lastValue !== undefined && lastValue === selectedValue && selectedValue !== _this.state.backfillValue) {
          _this.setOpenState(false, {
            needFocus: true,
            fireSearch: false
          });

          skipTrigger = true;
        } else {
          value = [selectedValue];

          _this.setOpenState(false, {
            needFocus: true,
            fireSearch: false
          });
        }
      }

      if (!skipTrigger) {
        _this.fireChange(value);
      }

      _this.fireSelect(selectedValue);

      if (!skipTrigger) {
        var inputValue = Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(props) ? Object(__WEBPACK_IMPORTED_MODULE_13__util__["i" /* getPropValue */])(item, props.optionLabelProp) : '';

        if (props.autoClearSearchValue) {
          _this.setInputValue(inputValue, false);
        }
      }
    };

    _this.onMenuDeselect = function (_ref2) {
      var item = _ref2.item,
          domEvent = _ref2.domEvent;

      if (domEvent.type === 'keydown' && domEvent.keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].ENTER) {
        var menuItemDomNode = __WEBPACK_IMPORTED_MODULE_7_react_dom__["findDOMNode"](item); // https://github.com/ant-design/ant-design/issues/20465#issuecomment-569033796

        if (!isHidden(menuItemDomNode)) {
          _this.removeSelected(Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(item));
        }

        return;
      }

      if (domEvent.type === 'click') {
        _this.removeSelected(Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(item));
      }

      var props = _this.props;

      if (props.autoClearSearchValue) {
        _this.setInputValue('');
      }
    };

    _this.onArrowClick = function (e) {
      e.stopPropagation();
      e.preventDefault();

      if (!_this.props.disabled) {
        _this.setOpenState(!_this.state.open, {
          needFocus: !_this.state.open
        });
      }
    };

    _this.onPlaceholderClick = function () {
      if (_this.getInputDOMNode && _this.getInputDOMNode()) {
        _this.getInputDOMNode().focus();
      }
    };

    _this.onOuterFocus = function (e) {
      if (_this.props.disabled) {
        e.preventDefault();
        return;
      }

      _this.clearBlurTime(); // In IE11, onOuterFocus will be trigger twice when focus input
      // First one: e.target is div
      // Second one: e.target is input
      // other browser only trigger second one
      // https://github.com/ant-design/ant-design/issues/15942
      // Here we ignore the first one when e.target is div


      var inputNode = _this.getInputDOMNode();

      if (inputNode && e.target === _this.rootRef) {
        return;
      }

      if (!Object(__WEBPACK_IMPORTED_MODULE_13__util__["o" /* isMultipleOrTagsOrCombobox */])(_this.props) && e.target === inputNode) {
        return;
      }

      if (_this._focused) {
        return;
      }

      _this._focused = true;

      _this.updateFocusClassName(); // only effect multiple or tag mode


      if (!Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(_this.props) || !_this._mouseDown) {
        _this.timeoutFocus();
      }
    };

    _this.onPopupFocus = function () {
      // fix ie scrollbar, focus element again
      _this.maybeFocus(true, true);
    };

    _this.onOuterBlur = function (e) {
      if (_this.props.disabled) {
        e.preventDefault();
        return;
      }

      _this.blurTimer = window.setTimeout(function () {
        _this._focused = false;

        _this.updateFocusClassName();

        var props = _this.props;
        var value = _this.state.value;
        var inputValue = _this.state.inputValue;

        if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* isSingleMode */])(props) && props.showSearch && inputValue && props.defaultActiveFirstOption) {
          var options = _this._options || [];

          if (options.length) {
            var firstOption = Object(__WEBPACK_IMPORTED_MODULE_13__util__["d" /* findFirstMenuItem */])(options);

            if (firstOption) {
              value = [Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(firstOption)];

              _this.fireChange(value);
            }
          }
        } else if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props) && inputValue) {
          if (_this._mouseDown) {
            // need update dropmenu when not blur
            _this.setInputValue('');
          } else {
            // why not use setState?
            // https://github.com/ant-design/ant-design/issues/14262
            _this.state.inputValue = '';

            if (_this.getInputDOMNode && _this.getInputDOMNode()) {
              _this.getInputDOMNode().value = '';
            }
          }

          var tmpValue = _this.getValueByInput(inputValue);

          if (tmpValue !== undefined) {
            value = tmpValue;

            _this.fireChange(value);
          }
        } // if click the rest space of Select in multiple mode


        if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props) && _this._mouseDown) {
          _this.maybeFocus(true, true);

          _this._mouseDown = false;
          return;
        }

        _this.setOpenState(false);

        if (props.onBlur) {
          props.onBlur(_this.getVLForOnChange(value));
        }
      }, 10);
    };

    _this.onClearSelection = function (event) {
      var props = _this.props;
      var state = _this.state;

      if (props.disabled) {
        return;
      }

      var inputValue = state.inputValue;
      var value = state.value;
      event.stopPropagation();

      if (inputValue || value.length) {
        if (value.length) {
          _this.fireChange([]);
        }

        _this.setOpenState(false, {
          needFocus: true
        });

        if (inputValue) {
          _this.setInputValue('');
        }
      }
    };

    _this.onChoiceAnimationLeave = function () {
      _this.forcePopupAlign();
    };

    _this.getOptionInfoBySingleValue = function (value, optionsInfo) {
      var info;
      optionsInfo = optionsInfo || _this.state.optionsInfo;

      if (optionsInfo[Object(__WEBPACK_IMPORTED_MODULE_13__util__["h" /* getMapKey */])(value)]) {
        info = optionsInfo[Object(__WEBPACK_IMPORTED_MODULE_13__util__["h" /* getMapKey */])(value)];
      }

      if (info) {
        return info;
      }

      var defaultLabel = value;

      if (_this.props.labelInValue) {
        var valueLabel = Object(__WEBPACK_IMPORTED_MODULE_13__util__["g" /* getLabelFromPropsValue */])(_this.props.value, value);
        var defaultValueLabel = Object(__WEBPACK_IMPORTED_MODULE_13__util__["g" /* getLabelFromPropsValue */])(_this.props.defaultValue, value);

        if (valueLabel !== undefined) {
          defaultLabel = valueLabel;
        } else if (defaultValueLabel !== undefined) {
          defaultLabel = defaultValueLabel;
        }
      }

      var defaultInfo = {
        option: __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Option__["a" /* default */], {
          value: value,
          key: value
        }, value),
        value: value,
        label: defaultLabel
      };
      return defaultInfo;
    };

    _this.getOptionBySingleValue = function (value) {
      var _this$getOptionInfoBy = _this.getOptionInfoBySingleValue(value),
          option = _this$getOptionInfoBy.option;

      return option;
    };

    _this.getOptionsBySingleValue = function (values) {
      return values.map(function (value) {
        return _this.getOptionBySingleValue(value);
      });
    };

    _this.getValueByLabel = function (label) {
      if (label === undefined) {
        return null;
      }

      var value = null;
      Object.keys(_this.state.optionsInfo).forEach(function (key) {
        var info = _this.state.optionsInfo[key];
        var disabled = info.disabled;

        if (disabled) {
          return;
        }

        var oldLable = Object(__WEBPACK_IMPORTED_MODULE_13__util__["t" /* toArray */])(info.label);

        if (oldLable && oldLable.join('') === label) {
          value = info.value;
        }
      });
      return value;
    };

    _this.getVLBySingleValue = function (value) {
      if (_this.props.labelInValue) {
        return {
          key: value,
          label: _this.getLabelBySingleValue(value)
        };
      }

      return value;
    };

    _this.getVLForOnChange = function (vlsS) {
      var vls = vlsS;

      if (vls !== undefined) {
        if (!_this.props.labelInValue) {
          vls = vls.map(function (v) {
            return v;
          });
        } else {
          vls = vls.map(function (vl) {
            return {
              key: vl,
              label: _this.getLabelBySingleValue(vl)
            };
          });
        }

        return Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(_this.props) ? vls : vls[0];
      }

      return vls;
    };

    _this.getLabelBySingleValue = function (value, optionsInfo) {
      var _this$getOptionInfoBy2 = _this.getOptionInfoBySingleValue(value, optionsInfo),
          label = _this$getOptionInfoBy2.label;

      return label;
    };

    _this.getDropdownContainer = function () {
      if (!_this.dropdownContainer) {
        _this.dropdownContainer = document.createElement('div');
        document.body.appendChild(_this.dropdownContainer);
      }

      return _this.dropdownContainer;
    };

    _this.getPlaceholderElement = function () {
      var props = _this.props;
      var state = _this.state;
      var hidden = false;

      if (state.inputValue) {
        hidden = true;
      }

      var value = state.value;

      if (value.length) {
        hidden = true;
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(props) && value.length === 1 && state.value && !state.value[0]) {
        hidden = false;
      }

      var placeholder = props.placeholder;

      if (placeholder) {
        return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", _extends({
          onMouseDown: __WEBPACK_IMPORTED_MODULE_13__util__["q" /* preventDefaultEvent */],
          style: _extends({
            display: hidden ? 'none' : 'block'
          }, __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */])
        }, __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */], {
          onClick: _this.onPlaceholderClick,
          className: "".concat(props.prefixCls, "-selection__placeholder")
        }), placeholder);
      }

      return null;
    };

    _this.getInputElement = function () {
      var props = _this.props;
      var defaultInput = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("input", {
        id: props.id,
        autoComplete: "off"
      }); // tslint:disable-next-line:typedef-whitespace

      var inputElement = props.getInputElement ? props.getInputElement() : defaultInput;
      var inputCls = __WEBPACK_IMPORTED_MODULE_0_classnames___default()(inputElement.props.className, _defineProperty({}, "".concat(props.prefixCls, "-search__field"), true)); // https://github.com/ant-design/ant-design/issues/4992#issuecomment-281542159
      // Add space to the end of the inputValue as the width measurement tolerance

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        className: "".concat(props.prefixCls, "-search__field__wrap")
      }, __WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"](inputElement, {
        ref: _this.saveInputRef,
        onChange: _this.onInputChange,
        onKeyDown: chaining(_this.onInputKeyDown, inputElement.props.onKeyDown, _this.props.onInputKeyDown),
        value: _this.state.inputValue,
        disabled: props.disabled,
        className: inputCls
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", {
        ref: _this.saveInputMirrorRef,
        className: "".concat(props.prefixCls, "-search__field__mirror")
      }, _this.state.inputValue, "\xA0"));
    };

    _this.getInputDOMNode = function () {
      return _this.topCtrlRef ? _this.topCtrlRef.querySelector('input,textarea,div[contentEditable]') : _this.inputRef;
    };

    _this.getInputMirrorDOMNode = function () {
      return _this.inputMirrorRef;
    };

    _this.getPopupDOMNode = function () {
      if (_this.selectTriggerRef) {
        return _this.selectTriggerRef.getPopupDOMNode();
      }
    };

    _this.getPopupMenuComponent = function () {
      if (_this.selectTriggerRef) {
        return _this.selectTriggerRef.getInnerMenu();
      }
    };

    _this.setOpenState = function (open) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var needFocus = config.needFocus,
          fireSearch = config.fireSearch;
      var props = _this.props;
      var state = _this.state;

      if (state.open === open) {
        _this.maybeFocus(open, !!needFocus);

        return;
      }

      if (_this.props.onDropdownVisibleChange) {
        _this.props.onDropdownVisibleChange(open);
      }

      var nextState = {
        open: open,
        backfillValue: ''
      }; // clear search input value when open is false in singleMode.
      // https://github.com/ant-design/ant-design/issues/16572

      if (!open && Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* isSingleMode */])(props) && props.showSearch) {
        _this.setInputValue('', fireSearch);
      }

      if (!open) {
        _this.maybeFocus(open, !!needFocus);
      }

      _this.setState(_extends({
        open: open
      }, nextState), function () {
        if (open) {
          _this.maybeFocus(open, !!needFocus);
        }
      });
    };

    _this.setInputValue = function (inputValue) {
      var fireSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var onSearch = _this.props.onSearch;

      if (inputValue !== _this.state.inputValue) {
        _this.setState(function (prevState) {
          // Additional check if `inputValue` changed in latest state.
          if (fireSearch && inputValue !== prevState.inputValue && onSearch) {
            onSearch(inputValue);
          }

          return {
            inputValue: inputValue
          };
        }, _this.forcePopupAlign);
      }
    };

    _this.getValueByInput = function (str) {
      var _this$props2 = _this.props,
          multiple = _this$props2.multiple,
          tokenSeparators = _this$props2.tokenSeparators;
      var nextValue = _this.state.value;
      var hasNewValue = false;
      Object(__WEBPACK_IMPORTED_MODULE_13__util__["s" /* splitBySeparators */])(str, tokenSeparators).forEach(function (label) {
        var selectedValue = [label];

        if (multiple) {
          var value = _this.getValueByLabel(label);

          if (value && Object(__WEBPACK_IMPORTED_MODULE_13__util__["e" /* findIndexInValueBySingleValue */])(nextValue, value) === -1) {
            nextValue = nextValue.concat(value);
            hasNewValue = true;

            _this.fireSelect(value);
          }
        } else if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["e" /* findIndexInValueBySingleValue */])(nextValue, label) === -1) {
          nextValue = nextValue.concat(selectedValue);
          hasNewValue = true;

          _this.fireSelect(label);
        }
      });
      return hasNewValue ? nextValue : undefined;
    };

    _this.getRealOpenState = function (state) {
      // tslint:disable-next-line:variable-name
      var _open = _this.props.open;

      if (typeof _open === 'boolean') {
        return _open;
      }

      var open = (state || _this.state).open;
      var options = _this._options || [];

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["o" /* isMultipleOrTagsOrCombobox */])(_this.props) || !_this.props.showSearch) {
        if (open && !options.length) {
          open = false;
        }
      }

      return open;
    };

    _this.markMouseDown = function () {
      _this._mouseDown = true;
    };

    _this.markMouseLeave = function () {
      _this._mouseDown = false;
    };

    _this.handleBackfill = function (item) {
      if (!_this.props.backfill || !(Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* isSingleMode */])(_this.props) || Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(_this.props))) {
        return;
      }

      var key = Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(item);

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(_this.props)) {
        _this.setInputValue(key, false);
      }

      _this.setState({
        value: [key],
        backfillValue: key
      });
    };

    _this.filterOption = function (input, child) {
      var defaultFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_13__util__["c" /* defaultFilterFn */];
      var value = _this.state.value;
      var lastValue = value[value.length - 1];

      if (!input || lastValue && lastValue === _this.state.backfillValue) {
        return true;
      }

      var filterFn = _this.props.filterOption;

      if ('filterOption' in _this.props) {
        if (filterFn === true) {
          filterFn = defaultFilter.bind(_assertThisInitialized(_this));
        }
      } else {
        filterFn = defaultFilter.bind(_assertThisInitialized(_this));
      }

      if (!filterFn) {
        return true;
      } else if (typeof filterFn === 'function') {
        return filterFn.call(_assertThisInitialized(_this), input, child);
      } else if (child.props.disabled) {
        return false;
      }

      return true;
    };

    _this.timeoutFocus = function () {
      var onFocus = _this.props.onFocus;

      if (_this.focusTimer) {
        _this.clearFocusTime();
      }

      _this.focusTimer = window.setTimeout(function () {
        if (onFocus) {
          onFocus();
        }
      }, 10);
    };

    _this.clearFocusTime = function () {
      if (_this.focusTimer) {
        clearTimeout(_this.focusTimer);
        _this.focusTimer = null;
      }
    };

    _this.clearBlurTime = function () {
      if (_this.blurTimer) {
        clearTimeout(_this.blurTimer);
        _this.blurTimer = null;
      }
    };

    _this.clearComboboxTime = function () {
      if (_this.comboboxTimer) {
        clearTimeout(_this.comboboxTimer);
        _this.comboboxTimer = null;
      }
    };

    _this.updateFocusClassName = function () {
      var rootRef = _this.rootRef;
      var props = _this.props; // avoid setState and its side effect

      if (_this._focused) {
        __WEBPACK_IMPORTED_MODULE_1_component_classes___default()(rootRef).add("".concat(props.prefixCls, "-focused"));
      } else {
        __WEBPACK_IMPORTED_MODULE_1_component_classes___default()(rootRef).remove("".concat(props.prefixCls, "-focused"));
      }
    };

    _this.maybeFocus = function (open, needFocus) {
      if (needFocus || open) {
        var input = _this.getInputDOMNode();

        var _document = document,
            activeElement = _document.activeElement;

        if (input && (open || Object(__WEBPACK_IMPORTED_MODULE_13__util__["o" /* isMultipleOrTagsOrCombobox */])(_this.props))) {
          if (activeElement !== input) {
            input.focus();
            _this._focused = true;
          }
        } else if (activeElement !== _this.selectionRef && _this.selectionRef) {
          _this.selectionRef.focus();

          _this._focused = true;
        }
      }
    };

    _this.removeSelected = function (selectedKey, e) {
      var props = _this.props;

      if (props.disabled || _this.isChildDisabled(selectedKey)) {
        return;
      } // Do not trigger Trigger popup


      if (e && e.stopPropagation) {
        e.stopPropagation();
      }

      var oldValue = _this.state.value;
      var value = oldValue.filter(function (singleValue) {
        return singleValue !== selectedKey;
      });
      var canMultiple = Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props);

      if (canMultiple) {
        var event = selectedKey;

        if (props.labelInValue) {
          event = {
            key: selectedKey,
            label: _this.getLabelBySingleValue(selectedKey)
          };
        }

        if (props.onDeselect) {
          props.onDeselect(event, _this.getOptionBySingleValue(selectedKey));
        }
      }

      _this.fireChange(value);
    };

    _this.openIfHasChildren = function () {
      var props = _this.props;

      if (__WEBPACK_IMPORTED_MODULE_6_react__["Children"].count(props.children) || Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* isSingleMode */])(props)) {
        _this.setOpenState(true);
      }
    };

    _this.fireSelect = function (value) {
      if (_this.props.onSelect) {
        _this.props.onSelect(_this.getVLBySingleValue(value), _this.getOptionBySingleValue(value));
      }
    };

    _this.fireChange = function (value) {
      var props = _this.props;

      if (!('value' in props)) {
        _this.setState({
          value: value
        }, _this.forcePopupAlign);
      }

      var vls = _this.getVLForOnChange(value);

      var options = _this.getOptionsBySingleValue(value);

      if (props.onChange) {
        props.onChange(vls, Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(_this.props) ? options : options[0]);
      }
    };

    _this.isChildDisabled = function (key) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_Children_toArray__["a" /* default */])(_this.props.children).some(function (child) {
        var childValue = Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(child);
        return childValue === key && child.props && child.props.disabled;
      });
    };

    _this.forcePopupAlign = function () {
      if (!_this.state.open) {
        return;
      }

      if (_this.selectTriggerRef && _this.selectTriggerRef.triggerRef) {
        _this.selectTriggerRef.triggerRef.forcePopupAlign();
      }
    };

    _this.renderFilterOptions = function () {
      var inputValue = _this.state.inputValue;
      var _this$props3 = _this.props,
          children = _this$props3.children,
          tags = _this$props3.tags,
          notFoundContent = _this$props3.notFoundContent;
      var menuItems = [];
      var childrenKeys = [];
      var empty = false;

      var options = _this.renderFilterOptionsFromChildren(children, childrenKeys, menuItems);

      if (tags) {
        // tags value must be string
        var value = _this.state.value;
        value = value.filter(function (singleValue) {
          return childrenKeys.indexOf(singleValue) === -1 && (!inputValue || String(singleValue).indexOf(String(inputValue)) > -1);
        }); // sort by length

        value.sort(function (val1, val2) {
          return val1.length - val2.length;
        });
        value.forEach(function (singleValue) {
          var key = singleValue;
          var menuItem = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["Item"], {
            style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */],
            role: "option",
            attribute: __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */],
            value: key,
            key: key
          }, key);
          options.push(menuItem);
          menuItems.push(menuItem);
        }); // ref: https://github.com/ant-design/ant-design/issues/14090

        if (inputValue && menuItems.every(function (option) {
          return Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(option) !== inputValue;
        })) {
          options.unshift(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["Item"], {
            style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */],
            role: "option",
            attribute: __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */],
            value: inputValue,
            key: inputValue
          }, inputValue));
        }
      }

      if (!options.length && notFoundContent) {
        empty = true;
        options = [__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["Item"], {
          style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */],
          attribute: __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */],
          disabled: true,
          role: "option",
          value: "NOT_FOUND",
          key: "NOT_FOUND"
        }, notFoundContent)];
      }

      return {
        empty: empty,
        options: options
      };
    };

    _this.renderFilterOptionsFromChildren = function (children, childrenKeys, menuItems) {
      var sel = [];
      var props = _this.props;
      var inputValue = _this.state.inputValue;
      var tags = props.tags;
      __WEBPACK_IMPORTED_MODULE_6_react__["Children"].forEach(children, function (child) {
        if (!child) {
          return;
        }

        var type = child.type;

        if (type.isSelectOptGroup) {
          var label = child.props.label;
          var key = child.key;

          if (!key && typeof label === 'string') {
            key = label;
          } else if (!label && key) {
            label = key;
          } // Match option group label


          if (inputValue && _this.filterOption(inputValue, child)) {
            var innerItems = Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_Children_toArray__["a" /* default */])(child.props.children).map(function (subChild) {
              var childValueSub = Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(subChild) || subChild.key;
              return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["Item"], _extends({
                key: childValueSub,
                value: childValueSub
              }, subChild.props));
            });
            sel.push(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["ItemGroup"], {
              key: key,
              title: label
            }, innerItems)); // Not match
          } else {
            var _innerItems = _this.renderFilterOptionsFromChildren(child.props.children, childrenKeys, menuItems);

            if (_innerItems.length) {
              sel.push(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["ItemGroup"], {
                key: key,
                title: label
              }, _innerItems));
            }
          }

          return;
        }

        __WEBPACK_IMPORTED_MODULE_9_warning___default()(type.isSelectOption, 'the children of `Select` should be `Select.Option` or `Select.OptGroup`, ' + "instead of `".concat(type.name || type.displayName || child.type, "`."));
        var childValue = Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(child);
        Object(__WEBPACK_IMPORTED_MODULE_13__util__["v" /* validateOptionValue */])(childValue, _this.props);

        if (_this.filterOption(inputValue, child)) {
          var menuItem = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["Item"], _extends({
            style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */],
            attribute: __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */],
            value: childValue,
            key: childValue,
            role: "option"
          }, child.props));
          sel.push(menuItem);
          menuItems.push(menuItem);
        }

        if (tags) {
          childrenKeys.push(childValue);
        }
      });
      return sel;
    };

    _this.renderTopControlNode = function () {
      var _this$state = _this.state,
          open = _this$state.open,
          inputValue = _this$state.inputValue;
      var value = _this.state.value;
      var props = _this.props;
      var choiceTransitionName = props.choiceTransitionName,
          prefixCls = props.prefixCls,
          maxTagTextLength = props.maxTagTextLength,
          maxTagCount = props.maxTagCount,
          showSearch = props.showSearch,
          removeIcon = props.removeIcon;
      var maxTagPlaceholder = props.maxTagPlaceholder;
      var className = "".concat(prefixCls, "-selection__rendered"); // search input is inside topControlNode in single, multiple & combobox. 2016/04/13

      var innerNode = null;

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* isSingleMode */])(props)) {
        var selectedValue = null;

        if (value.length) {
          var showSelectedValue = false;
          var opacity = 1;

          if (!showSearch) {
            showSelectedValue = true;
          } else if (open) {
            showSelectedValue = !inputValue;

            if (showSelectedValue) {
              opacity = 0.4;
            }
          } else {
            showSelectedValue = true;
          }

          var singleValue = value[0];

          var _this$getOptionInfoBy3 = _this.getOptionInfoBySingleValue(singleValue),
              label = _this$getOptionInfoBy3.label,
              title = _this$getOptionInfoBy3.title;

          selectedValue = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
            key: "value",
            className: "".concat(prefixCls, "-selection-selected-value"),
            title: Object(__WEBPACK_IMPORTED_MODULE_13__util__["u" /* toTitle */])(title || label),
            style: {
              display: showSelectedValue ? 'block' : 'none',
              opacity: opacity
            }
          }, label);
        }

        if (!showSearch) {
          innerNode = [selectedValue];
        } else {
          innerNode = [selectedValue, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
            className: "".concat(prefixCls, "-search ").concat(prefixCls, "-search--inline"),
            key: "input",
            style: {
              display: open ? 'block' : 'none'
            }
          }, _this.getInputElement())];
        }
      } else {
        var selectedValueNodes = [];
        var limitedCountValue = value;
        var maxTagPlaceholderEl;

        if (maxTagCount !== undefined && value.length > maxTagCount) {
          limitedCountValue = limitedCountValue.slice(0, maxTagCount);

          var omittedValues = _this.getVLForOnChange(value.slice(maxTagCount, value.length));

          var content = "+ ".concat(value.length - maxTagCount, " ...");

          if (maxTagPlaceholder) {
            content = typeof maxTagPlaceholder === 'function' ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
          }

          maxTagPlaceholderEl = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("li", _extends({
            style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */]
          }, __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */], {
            role: "presentation",
            onMouseDown: __WEBPACK_IMPORTED_MODULE_13__util__["q" /* preventDefaultEvent */],
            className: "".concat(prefixCls, "-selection__choice ").concat(prefixCls, "-selection__choice__disabled"),
            key: "maxTagPlaceholder",
            title: Object(__WEBPACK_IMPORTED_MODULE_13__util__["u" /* toTitle */])(content)
          }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
            className: "".concat(prefixCls, "-selection__choice__content")
          }, content));
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props)) {
          selectedValueNodes = limitedCountValue.map(function (singleValue) {
            var info = _this.getOptionInfoBySingleValue(singleValue);

            var content = info.label;
            var title = info.title || content;

            if (maxTagTextLength && typeof content === 'string' && content.length > maxTagTextLength) {
              content = "".concat(content.slice(0, maxTagTextLength), "...");
            }

            var disabled = _this.isChildDisabled(singleValue);

            var choiceClassName = disabled ? "".concat(prefixCls, "-selection__choice ").concat(prefixCls, "-selection__choice__disabled") : "".concat(prefixCls, "-selection__choice");
            return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("li", _extends({
              style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */]
            }, __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */], {
              onMouseDown: __WEBPACK_IMPORTED_MODULE_13__util__["q" /* preventDefaultEvent */],
              className: choiceClassName,
              role: "presentation",
              key: singleValue || SELECT_EMPTY_VALUE_KEY,
              title: Object(__WEBPACK_IMPORTED_MODULE_13__util__["u" /* toTitle */])(title)
            }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
              className: "".concat(prefixCls, "-selection__choice__content")
            }, content), disabled ? null : __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", {
              onClick: function onClick(event) {
                _this.removeSelected(singleValue, event);
              },
              className: "".concat(prefixCls, "-selection__choice__remove")
            }, removeIcon || __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("i", {
              className: "".concat(prefixCls, "-selection__choice__remove-icon")
            }, "\xD7")));
          });
        }

        if (maxTagPlaceholderEl) {
          selectedValueNodes.push(maxTagPlaceholderEl);
        }

        selectedValueNodes.push(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("li", {
          className: "".concat(prefixCls, "-search ").concat(prefixCls, "-search--inline"),
          key: "__input"
        }, _this.getInputElement()));

        if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props) && choiceTransitionName) {
          innerNode = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_rc_animate__["default"], {
            onLeave: _this.onChoiceAnimationLeave,
            component: "ul",
            transitionName: choiceTransitionName
          }, selectedValueNodes);
        } else {
          innerNode = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("ul", null, selectedValueNodes);
        }
      }

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        className: className,
        ref: _this.saveTopCtrlRef
      }, _this.getPlaceholderElement(), innerNode);
    };

    var optionsInfo = Select.getOptionsInfoFromProps(props);

    if (props.tags && typeof props.filterOption !== 'function') {
      var isDisabledExist = Object.keys(optionsInfo).some(function (key) {
        return optionsInfo[key].disabled;
      });
      __WEBPACK_IMPORTED_MODULE_9_warning___default()(!isDisabledExist, 'Please avoid setting option to disabled in tags mode since user can always type text as tag.');
    }

    _this.state = {
      value: Select.getValueFromProps(props, true),
      inputValue: props.combobox ? Select.getInputValueForCombobox(props, optionsInfo, true) : '',
      open: props.defaultOpen,
      optionsInfo: optionsInfo,
      backfillValue: '',
      // a flag for aviod redundant getOptionsInfoFromProps call
      skipBuildOptionsInfo: true,
      ariaId: ''
    };
    _this.saveInputRef = Object(__WEBPACK_IMPORTED_MODULE_13__util__["r" /* saveRef */])(_assertThisInitialized(_this), 'inputRef');
    _this.saveInputMirrorRef = Object(__WEBPACK_IMPORTED_MODULE_13__util__["r" /* saveRef */])(_assertThisInitialized(_this), 'inputMirrorRef');
    _this.saveTopCtrlRef = Object(__WEBPACK_IMPORTED_MODULE_13__util__["r" /* saveRef */])(_assertThisInitialized(_this), 'topCtrlRef');
    _this.saveSelectTriggerRef = Object(__WEBPACK_IMPORTED_MODULE_13__util__["r" /* saveRef */])(_assertThisInitialized(_this), 'selectTriggerRef');
    _this.saveRootRef = Object(__WEBPACK_IMPORTED_MODULE_13__util__["r" /* saveRef */])(_assertThisInitialized(_this), 'rootRef');
    _this.saveSelectionRef = Object(__WEBPACK_IMPORTED_MODULE_13__util__["r" /* saveRef */])(_assertThisInitialized(_this), 'selectionRef');
    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // when defaultOpen is true, we should auto focus search input
      // https://github.com/ant-design/ant-design/issues/14254
      if (this.props.autoFocus || this.state.open) {
        this.focus();
      }

      this.setState({
        ariaId: Object(__WEBPACK_IMPORTED_MODULE_13__util__["f" /* generateUUID */])()
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(this.props)) {
        var inputNode = this.getInputDOMNode();
        var mirrorNode = this.getInputMirrorDOMNode();

        if (inputNode && inputNode.value && mirrorNode) {
          inputNode.style.width = '';
          inputNode.style.width = "".concat(mirrorNode.clientWidth, "px");
        } else if (inputNode) {
          inputNode.style.width = '';
        }
      }

      this.forcePopupAlign();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearFocusTime();
      this.clearBlurTime();
      this.clearComboboxTime();

      if (this.dropdownContainer) {
        __WEBPACK_IMPORTED_MODULE_7_react_dom__["unmountComponentAtNode"](this.dropdownContainer);
        document.body.removeChild(this.dropdownContainer);
        this.dropdownContainer = null;
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* isSingleMode */])(this.props) && this.selectionRef) {
        this.selectionRef.focus();
      } else if (this.getInputDOMNode()) {
        this.getInputDOMNode().focus();
      }
    }
  }, {
    key: "blur",
    value: function blur() {
      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* isSingleMode */])(this.props) && this.selectionRef) {
        this.selectionRef.blur();
      } else if (this.getInputDOMNode()) {
        this.getInputDOMNode().blur();
      }
    }
  }, {
    key: "renderArrow",
    value: function renderArrow(multiple) {
      // showArrow : Set to true if not multiple by default but keep set value.
      var _this$props4 = this.props,
          _this$props4$showArro = _this$props4.showArrow,
          showArrow = _this$props4$showArro === void 0 ? !multiple : _this$props4$showArro,
          loading = _this$props4.loading,
          inputIcon = _this$props4.inputIcon,
          prefixCls = _this$props4.prefixCls;

      if (!showArrow && !loading) {
        return null;
      } // if loading  have loading icon


      var defaultIcon = loading ? __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("i", {
        className: "".concat(prefixCls, "-arrow-loading")
      }) : __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("i", {
        className: "".concat(prefixCls, "-arrow-icon")
      });
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", _extends({
        key: "arrow",
        className: "".concat(prefixCls, "-arrow"),
        style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */]
      }, __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */], {
        onClick: this.onArrowClick
      }), inputIcon || defaultIcon);
    }
  }, {
    key: "renderClear",
    value: function renderClear() {
      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          allowClear = _this$props5.allowClear,
          clearIcon = _this$props5.clearIcon;
      var inputValue = this.state.inputValue;
      var value = this.state.value;
      var clear = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", _extends({
        key: "clear",
        className: "".concat(prefixCls, "-selection__clear"),
        onMouseDown: __WEBPACK_IMPORTED_MODULE_13__util__["q" /* preventDefaultEvent */],
        style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */]
      }, __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */], {
        onClick: this.onClearSelection
      }), clearIcon || __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("i", {
        className: "".concat(prefixCls, "-selection__clear-icon")
      }, "\xD7"));

      if (!allowClear) {
        return null;
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(this.props)) {
        if (inputValue) {
          return clear;
        }

        return null;
      }

      if (inputValue || value.length) {
        return clear;
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _rootCls;

      var props = this.props;
      var multiple = Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props); // Default set showArrow to true if not set (not set directly in defaultProps to handle multiple case)

      var _props$showArrow = props.showArrow,
          showArrow = _props$showArrow === void 0 ? true : _props$showArrow;
      var state = this.state;
      var className = props.className,
          disabled = props.disabled,
          prefixCls = props.prefixCls,
          loading = props.loading;
      var ctrlNode = this.renderTopControlNode();
      var _this$state2 = this.state,
          open = _this$state2.open,
          ariaId = _this$state2.ariaId;

      if (open) {
        var filterOptions = this.renderFilterOptions();
        this._empty = filterOptions.empty;
        this._options = filterOptions.options;
      }

      var realOpen = this.getRealOpenState();
      var empty = this._empty;
      var options = this._options || [];
      var dataOrAriaAttributeProps = {};
      Object.keys(props).forEach(function (key) {
        if (Object.prototype.hasOwnProperty.call(props, key) && (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role')) {
          dataOrAriaAttributeProps[key] = props[key];
        }
      }); // for (const key in props) {
      //   if (
      //     Object.prototype.hasOwnProperty.call(props, key) &&
      //     (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role')
      //   ) {
      //     dataOrAriaAttributeProps[key] = props[key];
      //   }
      // }

      var extraSelectionProps = _extends({}, dataOrAriaAttributeProps);

      if (!Object(__WEBPACK_IMPORTED_MODULE_13__util__["o" /* isMultipleOrTagsOrCombobox */])(props)) {
        extraSelectionProps = _extends(_extends({}, extraSelectionProps), {
          onKeyDown: this.onKeyDown,
          tabIndex: props.disabled ? -1 : props.tabIndex
        });
      }

      var rootCls = (_rootCls = {}, _defineProperty(_rootCls, className, !!className), _defineProperty(_rootCls, prefixCls, 1), _defineProperty(_rootCls, "".concat(prefixCls, "-open"), open), _defineProperty(_rootCls, "".concat(prefixCls, "-focused"), open || !!this._focused), _defineProperty(_rootCls, "".concat(prefixCls, "-combobox"), Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(props)), _defineProperty(_rootCls, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_rootCls, "".concat(prefixCls, "-enabled"), !disabled), _defineProperty(_rootCls, "".concat(prefixCls, "-allow-clear"), !!props.allowClear), _defineProperty(_rootCls, "".concat(prefixCls, "-no-arrow"), !showArrow), _defineProperty(_rootCls, "".concat(prefixCls, "-loading"), !!loading), _rootCls);
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__SelectTrigger__["a" /* default */], {
        onPopupFocus: this.onPopupFocus,
        onMouseEnter: this.props.onMouseEnter,
        onMouseLeave: this.props.onMouseLeave,
        dropdownAlign: props.dropdownAlign,
        dropdownClassName: props.dropdownClassName,
        dropdownMatchSelectWidth: props.dropdownMatchSelectWidth,
        defaultActiveFirstOption: props.defaultActiveFirstOption,
        dropdownMenuStyle: props.dropdownMenuStyle,
        transitionName: props.transitionName,
        animation: props.animation,
        prefixCls: props.prefixCls,
        dropdownStyle: props.dropdownStyle,
        combobox: props.combobox,
        showSearch: props.showSearch,
        options: options,
        empty: empty,
        multiple: multiple,
        disabled: disabled,
        visible: realOpen,
        inputValue: state.inputValue,
        value: state.value,
        backfillValue: state.backfillValue,
        firstActiveValue: props.firstActiveValue,
        onDropdownVisibleChange: this.onDropdownVisibleChange,
        getPopupContainer: props.getPopupContainer,
        onMenuSelect: this.onMenuSelect,
        onMenuDeselect: this.onMenuDeselect,
        onPopupScroll: props.onPopupScroll,
        showAction: props.showAction,
        ref: this.saveSelectTriggerRef,
        menuItemSelectedIcon: props.menuItemSelectedIcon,
        dropdownRender: props.dropdownRender,
        ariaId: ariaId
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        id: props.id,
        style: props.style,
        ref: this.saveRootRef,
        onBlur: this.onOuterBlur,
        onFocus: this.onOuterFocus,
        className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(rootCls),
        onMouseDown: this.markMouseDown,
        onMouseUp: this.markMouseLeave,
        onMouseOut: this.markMouseLeave
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", _extends({
        ref: this.saveSelectionRef,
        key: "selection",
        className: "".concat(prefixCls, "-selection\n            ").concat(prefixCls, "-selection--").concat(multiple ? 'multiple' : 'single'),
        role: "combobox",
        "aria-autocomplete": "list",
        "aria-haspopup": "true",
        "aria-controls": ariaId,
        "aria-expanded": realOpen
      }, extraSelectionProps), ctrlNode, this.renderClear(), this.renderArrow(!!multiple))));
    }
  }]);

  return Select;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

Select.propTypes = __WEBPACK_IMPORTED_MODULE_11__PropTypes__["a" /* default */];
Select.defaultProps = {
  prefixCls: 'rc-select',
  defaultOpen: false,
  labelInValue: false,
  defaultActiveFirstOption: true,
  showSearch: true,
  allowClear: false,
  placeholder: '',
  onChange: noop,
  onFocus: noop,
  onBlur: noop,
  onSelect: noop,
  onSearch: noop,
  onDeselect: noop,
  onInputKeyDown: noop,
  dropdownMatchSelectWidth: true,
  dropdownStyle: {},
  dropdownMenuStyle: {},
  optionFilterProp: 'value',
  optionLabelProp: 'value',
  notFoundContent: 'Not Found',
  backfill: false,
  showAction: ['click'],
  tokenSeparators: [],
  autoClearSearchValue: true,
  tabIndex: 0,
  dropdownRender: function dropdownRender(menu) {
    return menu;
  }
};

Select.getDerivedStateFromProps = function (nextProps, prevState) {
  var optionsInfo = prevState.skipBuildOptionsInfo ? prevState.optionsInfo : Select.getOptionsInfoFromProps(nextProps, prevState);
  var newState = {
    optionsInfo: optionsInfo,
    skipBuildOptionsInfo: false
  };

  if ('open' in nextProps) {
    newState.open = nextProps.open;
  }

  if (nextProps.disabled && prevState.open) {
    newState.open = false;
  }

  if ('value' in nextProps) {
    var value = Select.getValueFromProps(nextProps);
    newState.value = value;

    if (nextProps.combobox) {
      newState.inputValue = Select.getInputValueForCombobox(nextProps, optionsInfo);
    }
  }

  return newState;
};

Select.getOptionsFromChildren = function (children) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  __WEBPACK_IMPORTED_MODULE_6_react__["Children"].forEach(children, function (child) {
    if (!child) {
      return;
    }

    var type = child.type;

    if (type.isSelectOptGroup) {
      Select.getOptionsFromChildren(child.props.children, options);
    } else {
      options.push(child);
    }
  });
  return options;
};

Select.getInputValueForCombobox = function (props, optionsInfo, useDefaultValue) {
  var value = [];

  if ('value' in props && !useDefaultValue) {
    value = Object(__WEBPACK_IMPORTED_MODULE_13__util__["t" /* toArray */])(props.value);
  }

  if ('defaultValue' in props && useDefaultValue) {
    value = Object(__WEBPACK_IMPORTED_MODULE_13__util__["t" /* toArray */])(props.defaultValue);
  }

  if (value.length) {
    value = value[0];
  } else {
    return '';
  }

  var label = value;

  if (props.labelInValue) {
    label = value.label;
  } else if (optionsInfo[Object(__WEBPACK_IMPORTED_MODULE_13__util__["h" /* getMapKey */])(value)]) {
    label = optionsInfo[Object(__WEBPACK_IMPORTED_MODULE_13__util__["h" /* getMapKey */])(value)].label;
  }

  if (label === undefined) {
    label = '';
  }

  return label;
};

Select.getLabelFromOption = function (props, option) {
  return Object(__WEBPACK_IMPORTED_MODULE_13__util__["i" /* getPropValue */])(option, props.optionLabelProp);
};

Select.getOptionsInfoFromProps = function (props, preState) {
  var options = Select.getOptionsFromChildren(props.children);
  var optionsInfo = {};
  options.forEach(function (option) {
    var singleValue = Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(option);
    optionsInfo[Object(__WEBPACK_IMPORTED_MODULE_13__util__["h" /* getMapKey */])(singleValue)] = {
      option: option,
      value: singleValue,
      label: Select.getLabelFromOption(props, option),
      title: option.props.title,
      disabled: option.props.disabled
    };
  });

  if (preState) {
    // keep option info in pre state value.
    var oldOptionsInfo = preState.optionsInfo;
    var value = preState.value;

    if (value) {
      value.forEach(function (v) {
        var key = Object(__WEBPACK_IMPORTED_MODULE_13__util__["h" /* getMapKey */])(v);

        if (!optionsInfo[key] && oldOptionsInfo[key] !== undefined) {
          optionsInfo[key] = oldOptionsInfo[key];
        }
      });
    }
  }

  return optionsInfo;
};

Select.getValueFromProps = function (props, useDefaultValue) {
  var value = [];

  if ('value' in props && !useDefaultValue) {
    value = Object(__WEBPACK_IMPORTED_MODULE_13__util__["t" /* toArray */])(props.value);
  }

  if ('defaultValue' in props && useDefaultValue) {
    value = Object(__WEBPACK_IMPORTED_MODULE_13__util__["t" /* toArray */])(props.defaultValue);
  }

  if (props.labelInValue) {
    value = value.map(function (v) {
      return v.key;
    });
  }

  return value;
};

Select.displayName = 'Select';
Object(__WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__["polyfill"])(Select);
/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectTrigger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_trigger__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DropdownMenu__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(364);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};









__WEBPACK_IMPORTED_MODULE_3_rc_trigger__["default"].displayName = 'Trigger';
var BUILT_IN_PLACEMENTS = {
  bottomLeft: {
    points: ['tl', 'bl'],
    offset: [0, 4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topLeft: {
    points: ['bl', 'tl'],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  }
};

var SelectTrigger =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectTrigger, _React$Component);

  function SelectTrigger(props) {
    var _this;

    _classCallCheck(this, SelectTrigger);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectTrigger).call(this, props));
    _this.dropdownMenuRef = null;
    _this.rafInstance = null;

    _this.setDropdownWidth = function () {
      _this.cancelRafInstance();

      _this.rafInstance = __WEBPACK_IMPORTED_MODULE_2_raf___default()(function () {
        var dom = __WEBPACK_IMPORTED_MODULE_5_react_dom__["findDOMNode"](_assertThisInitialized(_this));
        var width = dom.offsetWidth;

        if (width !== _this.state.dropdownWidth) {
          _this.setState({
            dropdownWidth: width
          });
        }
      });
    };

    _this.cancelRafInstance = function () {
      if (_this.rafInstance) {
        __WEBPACK_IMPORTED_MODULE_2_raf___default.a.cancel(_this.rafInstance);
      }
    };

    _this.getInnerMenu = function () {
      return _this.dropdownMenuRef && _this.dropdownMenuRef.menuRef;
    };

    _this.getPopupDOMNode = function () {
      return _this.triggerRef.getPopupDomNode();
    };

    _this.getDropdownElement = function (newProps) {
      var props = _this.props;
      var dropdownRender = props.dropdownRender,
          ariaId = props.ariaId;
      var menuNode = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__DropdownMenu__["a" /* default */], _extends({
        ref: _this.saveDropdownMenuRef
      }, newProps, {
        ariaId: ariaId,
        prefixCls: _this.getDropdownPrefixCls(),
        onMenuSelect: props.onMenuSelect,
        onMenuDeselect: props.onMenuDeselect,
        onPopupScroll: props.onPopupScroll,
        value: props.value,
        backfillValue: props.backfillValue,
        firstActiveValue: props.firstActiveValue,
        defaultActiveFirstOption: props.defaultActiveFirstOption,
        dropdownMenuStyle: props.dropdownMenuStyle,
        menuItemSelectedIcon: props.menuItemSelectedIcon
      }));

      if (dropdownRender) {
        return dropdownRender(menuNode, props);
      }

      return null;
    };

    _this.getDropdownTransitionName = function () {
      var props = _this.props;
      var transitionName = props.transitionName;

      if (!transitionName && props.animation) {
        transitionName = "".concat(_this.getDropdownPrefixCls(), "-").concat(props.animation);
      }

      return transitionName;
    };

    _this.getDropdownPrefixCls = function () {
      return "".concat(_this.props.prefixCls, "-dropdown");
    };

    _this.saveDropdownMenuRef = Object(__WEBPACK_IMPORTED_MODULE_7__util__["r" /* saveRef */])(_assertThisInitialized(_this), 'dropdownMenuRef');
    _this.saveTriggerRef = Object(__WEBPACK_IMPORTED_MODULE_7__util__["r" /* saveRef */])(_assertThisInitialized(_this), 'triggerRef');
    _this.state = {
      dropdownWidth: 0
    };
    return _this;
  }

  _createClass(SelectTrigger, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setDropdownWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setDropdownWidth();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelRafInstance();
    }
  }, {
    key: "render",
    value: function render() {
      var _popupClassName;

      var _a = this.props,
          onPopupFocus = _a.onPopupFocus,
          empty = _a.empty,
          props = __rest(_a, ["onPopupFocus", "empty"]);

      var multiple = props.multiple,
          visible = props.visible,
          inputValue = props.inputValue,
          dropdownAlign = props.dropdownAlign,
          disabled = props.disabled,
          showSearch = props.showSearch,
          dropdownClassName = props.dropdownClassName,
          dropdownStyle = props.dropdownStyle,
          dropdownMatchSelectWidth = props.dropdownMatchSelectWidth;
      var dropdownPrefixCls = this.getDropdownPrefixCls();
      var popupClassName = (_popupClassName = {}, _defineProperty(_popupClassName, dropdownClassName, !!dropdownClassName), _defineProperty(_popupClassName, "".concat(dropdownPrefixCls, "--").concat(multiple ? 'multiple' : 'single'), 1), _defineProperty(_popupClassName, "".concat(dropdownPrefixCls, "--empty"), empty), _popupClassName);
      var popupElement = this.getDropdownElement({
        menuItems: props.options,
        onPopupFocus: onPopupFocus,
        multiple: multiple,
        inputValue: inputValue,
        visible: visible
      });
      var hideAction;

      if (disabled) {
        hideAction = [];
      } else if (Object(__WEBPACK_IMPORTED_MODULE_7__util__["p" /* isSingleMode */])(props) && !showSearch) {
        hideAction = ['click'];
      } else {
        hideAction = ['blur'];
      }

      var popupStyle = _extends({}, dropdownStyle);

      var widthProp = dropdownMatchSelectWidth ? 'width' : 'minWidth';

      if (this.state.dropdownWidth) {
        popupStyle[widthProp] = "".concat(this.state.dropdownWidth, "px");
      }

      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_trigger__["default"], _extends({}, props, {
        showAction: disabled ? [] : this.props.showAction,
        hideAction: hideAction,
        ref: this.saveTriggerRef,
        popupPlacement: "bottomLeft",
        builtinPlacements: BUILT_IN_PLACEMENTS,
        prefixCls: dropdownPrefixCls,
        popupTransitionName: this.getDropdownTransitionName(),
        onPopupVisibleChange: props.onDropdownVisibleChange,
        popup: popupElement,
        popupAlign: dropdownAlign,
        popupVisible: visible,
        getPopupContainer: props.getPopupContainer,
        popupClassName: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(popupClassName),
        popupStyle: popupStyle
      }), props.children);
    }
  }]);

  return SelectTrigger;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);


SelectTrigger.defaultProps = {
  dropdownRender: function dropdownRender(menu) {
    return menu;
  }
};
SelectTrigger.propTypes = {
  onPopupFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
  onPopupScroll: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
  dropdownMatchSelectWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  dropdownAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  showSearch: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  dropdownClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  inputValue: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  filterOption: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  popupClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
  showAction: __WEBPACK_IMPORTED_MODULE_1_prop_types__["arrayOf"](__WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]),
  menuItemSelectedIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["node"]]),
  dropdownRender: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
  ariaId: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]
};
SelectTrigger.displayName = 'SelectTrigger';

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropdownMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dom_scroll_into_view__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dom_scroll_into_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dom_scroll_into_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_menu__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_util_es_Children_toArray__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(364);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }










var DropdownMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DropdownMenu, _React$Component);

  function DropdownMenu(props) {
    var _this;

    _classCallCheck(this, DropdownMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropdownMenu).call(this, props));
    _this.rafInstance = null;
    _this.lastVisible = false;

    _this.scrollActiveItemToView = function () {
      // scroll into view
      var itemComponent = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this.firstActiveItem);
      var _this$props = _this.props,
          visible = _this$props.visible,
          firstActiveValue = _this$props.firstActiveValue;
      var value = _this.props.value;

      if (!itemComponent || !visible) {
        return;
      }

      var scrollIntoViewOpts = {
        onlyScrollIfNeeded: true
      };

      if ((!value || value.length === 0) && firstActiveValue) {
        scrollIntoViewOpts.alignWithTop = true;
      } // Delay to scroll since current frame item position is not ready when pre view is by filter
      // https://github.com/ant-design/ant-design/issues/11268#issuecomment-406634462


      _this.rafInstance = __WEBPACK_IMPORTED_MODULE_2_raf___default()(function () {
        __WEBPACK_IMPORTED_MODULE_0_dom_scroll_into_view___default()(itemComponent, Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this.menuRef), scrollIntoViewOpts);
      });
    };

    _this.renderMenu = function () {
      var _this$props2 = _this.props,
          menuItems = _this$props2.menuItems,
          menuItemSelectedIcon = _this$props2.menuItemSelectedIcon,
          defaultActiveFirstOption = _this$props2.defaultActiveFirstOption,
          prefixCls = _this$props2.prefixCls,
          multiple = _this$props2.multiple,
          onMenuSelect = _this$props2.onMenuSelect,
          inputValue = _this$props2.inputValue,
          backfillValue = _this$props2.backfillValue,
          onMenuDeselect = _this$props2.onMenuDeselect,
          visible = _this$props2.visible;
      var firstActiveValue = _this.props.firstActiveValue;

      if (menuItems && menuItems.length) {
        var menuProps = {};

        if (multiple) {
          menuProps.onDeselect = onMenuDeselect;
          menuProps.onSelect = onMenuSelect;
        } else {
          menuProps.onClick = onMenuSelect;
        }

        var value = _this.props.value;
        var selectedKeys = Object(__WEBPACK_IMPORTED_MODULE_7__util__["j" /* getSelectKeys */])(menuItems, value);
        var activeKeyProps = {};
        var defaultActiveFirst = defaultActiveFirstOption;
        var clonedMenuItems = menuItems;

        if (selectedKeys.length || firstActiveValue) {
          if (visible && !_this.lastVisible) {
            activeKeyProps.activeKey = selectedKeys[0] || firstActiveValue;
          } else if (!visible) {
            // Do not trigger auto active since we already have selectedKeys
            if (selectedKeys[0]) {
              defaultActiveFirst = false;
            }

            activeKeyProps.activeKey = undefined;
          }

          var foundFirst = false; // set firstActiveItem via cloning menus
          // for scroll into view

          var clone = function clone(item) {
            var key = item.key;

            if (!foundFirst && selectedKeys.indexOf(key) !== -1 || !foundFirst && !selectedKeys.length && firstActiveValue.indexOf(item.key) !== -1) {
              foundFirst = true;
              return __WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"](item, {
                ref: function ref(_ref) {
                  _this.firstActiveItem = _ref;
                }
              });
            }

            return item;
          };

          clonedMenuItems = menuItems.map(function (item) {
            if (item.type.isMenuItemGroup) {
              var children = Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_Children_toArray__["a" /* default */])(item.props.children).map(clone);
              return __WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"](item, {}, children);
            }

            return clone(item);
          });
        } else {
          // Clear firstActiveItem when dropdown menu items was empty
          // Avoid `Unable to find node on an unmounted component`
          // https://github.com/ant-design/ant-design/issues/10774
          _this.firstActiveItem = null;
        } // clear activeKey when inputValue change


        var lastValue = value && value[value.length - 1];

        if (inputValue !== _this.lastInputValue && (!lastValue || lastValue !== backfillValue)) {
          activeKeyProps.activeKey = '';
        }

        return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["default"], _extends({
          ref: _this.saveMenuRef,
          style: _this.props.dropdownMenuStyle,
          defaultActiveFirst: defaultActiveFirst,
          role: "listbox",
          itemIcon: multiple ? menuItemSelectedIcon : null
        }, activeKeyProps, {
          multiple: multiple
        }, menuProps, {
          selectedKeys: selectedKeys,
          prefixCls: "".concat(prefixCls, "-menu")
        }), clonedMenuItems);
      }

      return null;
    };

    _this.lastInputValue = props.inputValue;
    _this.saveMenuRef = Object(__WEBPACK_IMPORTED_MODULE_7__util__["r" /* saveRef */])(_assertThisInitialized(_this), 'menuRef');
    return _this;
  }

  _createClass(DropdownMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scrollActiveItemToView();
      this.lastVisible = this.props.visible;
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (!nextProps.visible) {
        this.lastVisible = false;
      } // freeze when hide


      return this.props.visible && !nextProps.visible || nextProps.visible || nextProps.inputValue !== this.props.inputValue;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var props = this.props;

      if (!prevProps.visible && props.visible) {
        this.scrollActiveItemToView();
      }

      this.lastVisible = props.visible;
      this.lastInputValue = props.inputValue;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.rafInstance) {
        __WEBPACK_IMPORTED_MODULE_2_raf___default.a.cancel(this.rafInstance);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var renderMenu = this.renderMenu();
      return renderMenu ? __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", {
        style: {
          overflow: 'auto',
          transform: 'translateZ(0)'
        },
        id: this.props.ariaId,
        onFocus: this.props.onPopupFocus,
        onMouseDown: __WEBPACK_IMPORTED_MODULE_7__util__["q" /* preventDefaultEvent */],
        onScroll: this.props.onPopupScroll
      }, renderMenu) : null;
    }
  }]);

  return DropdownMenu;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);


DropdownMenu.displayName = 'DropdownMenu';
DropdownMenu.propTypes = {
  ariaId: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  defaultActiveFirstOption: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
  dropdownMenuStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  onPopupFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
  onPopupScroll: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
  onMenuDeSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
  onMenuSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  menuItems: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
  inputValue: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  firstActiveValue: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  menuItemSelectedIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["node"]])
};

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(101);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(1092);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 1092 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _KeyCode = _interopRequireDefault(__webpack_require__(194));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/**
 * Wrap of sub component which need use as Button capacity (like Icon component).
 * This helps accessibility reader to tread as a interactive button to operation.
 */


var inlineStyle = {
  border: 0,
  background: 'transparent',
  padding: 0,
  lineHeight: 'inherit',
  display: 'inline-block'
};

var TransButton = /*#__PURE__*/function (_React$Component) {
  _inherits(TransButton, _React$Component);

  var _super = _createSuper(TransButton);

  function TransButton() {
    var _this;

    _classCallCheck(this, TransButton);

    _this = _super.apply(this, arguments);

    _this.onKeyDown = function (event) {
      var keyCode = event.keyCode;

      if (keyCode === _KeyCode["default"].ENTER) {
        event.preventDefault();
      }
    };

    _this.onKeyUp = function (event) {
      var keyCode = event.keyCode;
      var onClick = _this.props.onClick;

      if (keyCode === _KeyCode["default"].ENTER && onClick) {
        onClick();
      }
    };

    _this.setRef = function (btn) {
      _this.div = btn;
    };

    return _this;
  }

  _createClass(TransButton, [{
    key: "focus",
    value: function focus() {
      if (this.div) {
        this.div.focus();
      }
    }
  }, {
    key: "blur",
    value: function blur() {
      if (this.div) {
        this.div.blur();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          style = _a.style,
          noStyle = _a.noStyle,
          restProps = __rest(_a, ["style", "noStyle"]);

      return /*#__PURE__*/React.createElement("div", _extends({
        role: "button",
        tabIndex: 0,
        ref: this.setRef
      }, restProps, {
        onKeyDown: this.onKeyDown,
        onKeyUp: this.onKeyUp,
        style: _extends(_extends({}, !noStyle ? inlineStyle : null), style)
      }));
    }
  }]);

  return TransButton;
}(React.Component);

var _default = TransButton;
exports["default"] = _default;

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _icon=__webpack_require__(38);var _icon2=_interopRequireDefault(_icon);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _tree=__webpack_require__(224);var _tree2=_interopRequireDefault(_tree);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(62);__webpack_require__(12);__webpack_require__(4);__webpack_require__(6);__webpack_require__(75);__webpack_require__(10);__webpack_require__(225);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _data=__webpack_require__(446);var _mobxReact=__webpack_require__(18);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var TreeNode=_tree2.default.TreeNode;var authName=[{name:"GM/HM 总经理/酒店经理",value:"GM"},{name:"RM/EAM 驻店经理/行政助理经理",value:"EAM"},{name:"DOF 财务总监",value:"DOF"},{name:"FM 财务经理",value:"FIN"},{name:"Income Audit",value:"IA"},{name:"DHR 人力资源总监",value:"HR"},{name:"DOSM 市场营销总监",value:"SM"},{name:"DFB 餐饮总监",value:"FB"},{name:"DOC 宴会统筹总监",value:"BQT"},{name:"DOR 房务总监/EHK 行政管家/FOM 前厅经理",value:"Rooms"},{name:"DOE 工程总监",value:"ENG"},{name:"REVM 收益经理",value:"REV"},{name:"Training",value:"Training"}];var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getAuthData=function(){fetch('/getHrAuth?user='+_this.state.hotelAuthName,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){var checkedKeys=x.data[0].data.split(',');_this.setState({auth:x.data[0],checkedKeys:checkedKeys,authLoading:false});}else{_this.setState({auth:{},checkedKeys:[],authLoading:false});}}).catch(function(err){console.error(err);_this.setState({authLoading:false});});};_this.authshowModal=function(){if(_this.state.user.email!='admin'){_message3.default.error('权限不足！');return;}_this.setState({authVisible:true,authLoading:true});_this.getAuthData();};_this.authhandleOk=function(e){if(_this.state.user.email!='admin'){_message3.default.error('权限不足！');return;}_this.setState({loadingAuth:true});var checkedKeys=_this.state.checkedKeys;var hotelAuthName=_this.state.hotelAuthName;// console.log(checkedKeys)
var data=_extends({},_this.state.auth,{user:hotelAuthName,data:checkedKeys.toString()});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/addHrAuth',headres).then(function(x){return x.json();}).then(function(x){_this.setState({loadingAuth:false});if(x.status==1){_message3.default.success('保存成功');return;}_message3.default.error('保存失败！');}).catch(function(err){console.error(err);_this.setState({loadingAuth:false});});};_this.authhandleCancel=function(e){_this.setState({authVisible:false});};_this.onChange=function(value,lable,extra){// console.log('onchange', value, lable, extra)
_this.setState({selectAuth:value});};_this.onExpand=function(expandedKeys){// if not set autoExpandParent to false, if children expanded, parent can not collapse.
// or, you can remove all expanded children keys.
_this.setState({expandedKeys:expandedKeys,autoExpandParent:false});};_this.onCheck=function(checkedKeys,checkedNodes){_this.setState({checkedKeys:checkedKeys});};_this.onSelect=function(selectedKeys,info){// console.log(selectedKeys, info);
_this.setState({selectedKeys:selectedKeys});};_this.renderTreeNodes=function(data){return data.map(function(item){if(item.children){return _react2.default.createElement(TreeNode,{title:item.title,key:item.key,dataRef:item},_this.renderTreeNodes(item.children));}return _react2.default.createElement(TreeNode,item);});};_this.state={user:{},data:[],visible:false,loadingSave:false,loading:true,hotel:{name:"",tel:"",address:"",contacts:""},loadingAuth:false,authVisible:false,hotelAuthName:"FIN",expandedKeys:[],autoExpandParent:true,checkedKeys:[],selectedKeys:[],auth:{},authLoading:false,dataTotal:[]};return _this;}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;this.props.store.menu.getUserInfo().then(function(user){_this2.setState({user:user});}).catch(function(err){console.error(err);});}// 权限
},{key:"render",value:function render(){var _this3=this;return _react2.default.createElement("div",null,_react2.default.createElement("div",{onClick:this.authshowModal,style:{height:"100%",width:"100%"}},_react2.default.createElement(_icon2.default,{type:"setting",style:{marginRight:8}}),"\u6743\u9650\u8BBE\u7F6E"),_react2.default.createElement(_modal2.default,{title:"\u6743\u9650\u8BBE\u7F6E",visible:this.state.authVisible,onOk:this.authhandleOk,onCancel:this.authhandleCancel,footer:[_react2.default.createElement(_button2.default,{key:"back",onClick:this.authhandleCancel},"\u53D6\u6D88"),_react2.default.createElement(_button2.default,{key:"submit",type:"primary",loading:this.state.loadingAuth,onClick:this.authhandleOk},"\u4FDD\u5B58")]},_react2.default.createElement(_spin2.default,{spinning:this.state.authLoading},_react2.default.createElement(_row2.default,{className:"modal"},_react2.default.createElement(_row2.default,null,_react2.default.createElement("span",null,"\u9009\u62E9\u4EBA\u5458\uFF1A"),_react2.default.createElement(_select2.default,{value:this.state.hotelAuthName,style:{width:300},onChange:function onChange(value){_this3.setState({hotelAuthName:value,authLoading:true},function(){_this3.getAuthData();});}},authName.map(function(x,i){return _react2.default.createElement(Option,{key:x.value},x.name);}))),_react2.default.createElement(_row2.default,{className:"authCotent"},_react2.default.createElement(_row2.default,null,"\u6743\u9650\u914D\u7F6E"),_react2.default.createElement(_tree2.default,{checkable:true// checkStrictly={true}
,onExpand:this.onExpand,expandedKeys:this.state.expandedKeys,autoExpandParent:this.state.autoExpandParent,onCheck:this.onCheck,checkedKeys:this.state.checkedKeys,onSelect:this.onSelect,selectedKeys:this.state.selectedKeys},this.renderTreeNodes([].concat(_toConsumableArray(_data.authData)))))))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tree__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TreeNode__ = __webpack_require__(539);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TreeNode", function() { return __WEBPACK_IMPORTED_MODULE_1__TreeNode__["a"]; });


var Tree = __WEBPACK_IMPORTED_MODULE_0__Tree__["a" /* default */];
Tree.TreeNode = __WEBPACK_IMPORTED_MODULE_1__TreeNode__["a" /* default */];

/* harmony default export */ __webpack_exports__["default"] = (Tree);

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_warning__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_util_es_Children_toArray__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lifecycles_compat__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__contextTypes__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(538);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }










var Tree = /*#__PURE__*/function (_React$Component) {
  _inherits(Tree, _React$Component);

  var _super = _createSuper(Tree);

  function Tree() {
    var _this;

    _classCallCheck(this, Tree);

    _this = _super.apply(this, arguments);
    /** Internal usage for `rc-tree-select`, we don't promise it will not change. */

    _this.domTreeNodes = {};
    _this.state = {
      keyEntities: {},
      selectedKeys: [],
      checkedKeys: [],
      halfCheckedKeys: [],
      loadedKeys: [],
      loadingKeys: [],
      expandedKeys: [],
      dragNodesKeys: [],
      dragOverNodeKey: null,
      dropPosition: null,
      treeNode: [],
      prevProps: null
    };

    _this.onNodeDragStart = function (event, node) {
      var expandedKeys = _this.state.expandedKeys;
      var onDragStart = _this.props.onDragStart;
      var _node$props = node.props,
          eventKey = _node$props.eventKey,
          children = _node$props.children;
      _this.dragNode = node;

      _this.setState({
        dragNodesKeys: Object(__WEBPACK_IMPORTED_MODULE_7__util__["j" /* getDragNodesKeys */])(children, node),
        expandedKeys: Object(__WEBPACK_IMPORTED_MODULE_7__util__["b" /* arrDel */])(expandedKeys, eventKey)
      });

      if (onDragStart) {
        onDragStart({
          event: event,
          node: node
        });
      }
    };
    /**
     * [Legacy] Select handler is less small than node,
     * so that this will trigger when drag enter node or select handler.
     * This is a little tricky if customize css without padding.
     * Better for use mouse move event to refresh drag state.
     * But let's just keep it to avoid event trigger logic change.
     */


    _this.onNodeDragEnter = function (event, node) {
      var _this$state = _this.state,
          expandedKeys = _this$state.expandedKeys,
          dragNodesKeys = _this$state.dragNodesKeys;
      var onDragEnter = _this.props.onDragEnter;
      var _node$props2 = node.props,
          pos = _node$props2.pos,
          eventKey = _node$props2.eventKey;
      if (!_this.dragNode || dragNodesKeys.indexOf(eventKey) !== -1) return;
      var dropPosition = Object(__WEBPACK_IMPORTED_MODULE_7__util__["c" /* calcDropPosition */])(event, node); // Skip if drag node is self

      if (_this.dragNode.props.eventKey === eventKey && dropPosition === 0) {
        _this.setState({
          dragOverNodeKey: '',
          dropPosition: null
        });

        return;
      } // Ref: https://github.com/react-component/tree/issues/132
      // Add timeout to let onDragLevel fire before onDragEnter,
      // so that we can clean drag props for onDragLeave node.
      // Macro task for this:
      // https://html.spec.whatwg.org/multipage/webappapis.html#clean-up-after-running-script


      setTimeout(function () {
        // Update drag over node
        _this.setState({
          dragOverNodeKey: eventKey,
          dropPosition: dropPosition
        }); // Side effect for delay drag


        if (!_this.delayedDragEnterLogic) {
          _this.delayedDragEnterLogic = {};
        }

        Object.keys(_this.delayedDragEnterLogic).forEach(function (key) {
          clearTimeout(_this.delayedDragEnterLogic[key]);
        });
        _this.delayedDragEnterLogic[pos] = window.setTimeout(function () {
          var newExpandedKeys = Object(__WEBPACK_IMPORTED_MODULE_7__util__["a" /* arrAdd */])(expandedKeys, eventKey);

          if (!('expandedKeys' in _this.props)) {
            _this.setState({
              expandedKeys: newExpandedKeys
            });
          }

          if (onDragEnter) {
            onDragEnter({
              event: event,
              node: node,
              expandedKeys: newExpandedKeys
            });
          }
        }, 400);
      }, 0);
    };

    _this.onNodeDragOver = function (event, node) {
      var dragNodesKeys = _this.state.dragNodesKeys;
      var onDragOver = _this.props.onDragOver;
      var eventKey = node.props.eventKey;

      if (dragNodesKeys.indexOf(eventKey) !== -1) {
        return;
      } // Update drag position


      if (_this.dragNode && eventKey === _this.state.dragOverNodeKey) {
        var dropPosition = Object(__WEBPACK_IMPORTED_MODULE_7__util__["c" /* calcDropPosition */])(event, node);
        if (dropPosition === _this.state.dropPosition) return;

        _this.setState({
          dropPosition: dropPosition
        });
      }

      if (onDragOver) {
        onDragOver({
          event: event,
          node: node
        });
      }
    };

    _this.onNodeDragLeave = function (event, node) {
      var onDragLeave = _this.props.onDragLeave;

      _this.setState({
        dragOverNodeKey: ''
      });

      if (onDragLeave) {
        onDragLeave({
          event: event,
          node: node
        });
      }
    };

    _this.onNodeDragEnd = function (event, node) {
      var onDragEnd = _this.props.onDragEnd;

      _this.setState({
        dragOverNodeKey: ''
      });

      if (onDragEnd) {
        onDragEnd({
          event: event,
          node: node
        });
      }

      _this.dragNode = null;
    };

    _this.onNodeDrop = function (event, node) {
      var _this$state2 = _this.state,
          _this$state2$dragNode = _this$state2.dragNodesKeys,
          dragNodesKeys = _this$state2$dragNode === void 0 ? [] : _this$state2$dragNode,
          dropPosition = _this$state2.dropPosition;
      var onDrop = _this.props.onDrop;
      var _node$props3 = node.props,
          eventKey = _node$props3.eventKey,
          pos = _node$props3.pos;

      _this.setState({
        dragOverNodeKey: ''
      });

      if (dragNodesKeys.indexOf(eventKey) !== -1) {
        __WEBPACK_IMPORTED_MODULE_3_warning___default()(false, "Can not drop to dragNode(include it's children node)");
        return;
      }

      var posArr = Object(__WEBPACK_IMPORTED_MODULE_7__util__["o" /* posToArr */])(pos);
      var dropResult = {
        event: event,
        node: node,
        dragNode: _this.dragNode,
        dragNodesKeys: dragNodesKeys.slice(),
        dropPosition: dropPosition + Number(posArr[posArr.length - 1]),
        dropToGap: false
      };

      if (dropPosition !== 0) {
        dropResult.dropToGap = true;
      }

      if (onDrop) {
        onDrop(dropResult);
      }

      _this.dragNode = null;
    };

    _this.onNodeClick = function (e, treeNode) {
      var onClick = _this.props.onClick;

      if (onClick) {
        onClick(e, treeNode);
      }
    };

    _this.onNodeDoubleClick = function (e, treeNode) {
      var onDoubleClick = _this.props.onDoubleClick;

      if (onDoubleClick) {
        onDoubleClick(e, treeNode);
      }
    };

    _this.onNodeSelect = function (e, treeNode) {
      var selectedKeys = _this.state.selectedKeys;
      var keyEntities = _this.state.keyEntities;
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          multiple = _this$props.multiple;
      var _treeNode$props = treeNode.props,
          selected = _treeNode$props.selected,
          eventKey = _treeNode$props.eventKey;
      var targetSelected = !selected; // Update selected keys

      if (!targetSelected) {
        selectedKeys = Object(__WEBPACK_IMPORTED_MODULE_7__util__["b" /* arrDel */])(selectedKeys, eventKey);
      } else if (!multiple) {
        selectedKeys = [eventKey];
      } else {
        selectedKeys = Object(__WEBPACK_IMPORTED_MODULE_7__util__["a" /* arrAdd */])(selectedKeys, eventKey);
      } // [Legacy] Not found related usage in doc or upper libs


      var selectedNodes = selectedKeys.map(function (key) {
        var entity = keyEntities[key];
        if (!entity) return null;
        return entity.node;
      }).filter(function (node) {
        return node;
      });

      _this.setUncontrolledState({
        selectedKeys: selectedKeys
      });

      if (onSelect) {
        onSelect(selectedKeys, {
          event: 'select',
          selected: targetSelected,
          node: treeNode,
          selectedNodes: selectedNodes,
          nativeEvent: e.nativeEvent
        });
      }
    };

    _this.onNodeCheck = function (e, treeNode, checked) {
      var _this$state3 = _this.state,
          keyEntities = _this$state3.keyEntities,
          oriCheckedKeys = _this$state3.checkedKeys,
          oriHalfCheckedKeys = _this$state3.halfCheckedKeys;
      var _this$props2 = _this.props,
          checkStrictly = _this$props2.checkStrictly,
          onCheck = _this$props2.onCheck;
      var eventKey = treeNode.props.eventKey; // Prepare trigger arguments

      var checkedObj;
      var eventObj = {
        event: 'check',
        node: treeNode,
        checked: checked,
        nativeEvent: e.nativeEvent
      };

      if (checkStrictly) {
        var checkedKeys = checked ? Object(__WEBPACK_IMPORTED_MODULE_7__util__["a" /* arrAdd */])(oriCheckedKeys, eventKey) : Object(__WEBPACK_IMPORTED_MODULE_7__util__["b" /* arrDel */])(oriCheckedKeys, eventKey);
        var halfCheckedKeys = Object(__WEBPACK_IMPORTED_MODULE_7__util__["b" /* arrDel */])(oriHalfCheckedKeys, eventKey);
        checkedObj = {
          checked: checkedKeys,
          halfChecked: halfCheckedKeys
        };
        eventObj.checkedNodes = checkedKeys.map(function (key) {
          return keyEntities[key];
        }).filter(function (entity) {
          return entity;
        }).map(function (entity) {
          return entity.node;
        });

        _this.setUncontrolledState({
          checkedKeys: checkedKeys
        });
      } else {
        var _conductCheck = Object(__WEBPACK_IMPORTED_MODULE_7__util__["e" /* conductCheck */])([eventKey], checked, keyEntities, {
          checkedKeys: oriCheckedKeys,
          halfCheckedKeys: oriHalfCheckedKeys
        }),
            _checkedKeys = _conductCheck.checkedKeys,
            _halfCheckedKeys = _conductCheck.halfCheckedKeys;

        checkedObj = _checkedKeys; // [Legacy] This is used for `rc-tree-select`

        eventObj.checkedNodes = [];
        eventObj.checkedNodesPositions = [];
        eventObj.halfCheckedKeys = _halfCheckedKeys;

        _checkedKeys.forEach(function (key) {
          var entity = keyEntities[key];
          if (!entity) return;
          var node = entity.node,
              pos = entity.pos;
          eventObj.checkedNodes.push(node);
          eventObj.checkedNodesPositions.push({
            node: node,
            pos: pos
          });
        });

        _this.setUncontrolledState({
          checkedKeys: _checkedKeys,
          halfCheckedKeys: _halfCheckedKeys
        });
      }

      if (onCheck) {
        onCheck(checkedObj, eventObj);
      }
    };

    _this.onNodeLoad = function (treeNode) {
      return new Promise(function (resolve) {
        // We need to get the latest state of loading/loaded keys
        _this.setState(function (_ref) {
          var _ref$loadedKeys = _ref.loadedKeys,
              loadedKeys = _ref$loadedKeys === void 0 ? [] : _ref$loadedKeys,
              _ref$loadingKeys = _ref.loadingKeys,
              loadingKeys = _ref$loadingKeys === void 0 ? [] : _ref$loadingKeys;
          var _this$props3 = _this.props,
              loadData = _this$props3.loadData,
              onLoad = _this$props3.onLoad;
          var eventKey = treeNode.props.eventKey;

          if (!loadData || loadedKeys.indexOf(eventKey) !== -1 || loadingKeys.indexOf(eventKey) !== -1) {
            // react 15 will warn if return null
            return {};
          } // Process load data


          var promise = loadData(treeNode);
          promise.then(function () {
            var _this$state4 = _this.state,
                currentLoadedKeys = _this$state4.loadedKeys,
                currentLoadingKeys = _this$state4.loadingKeys;
            var newLoadedKeys = Object(__WEBPACK_IMPORTED_MODULE_7__util__["a" /* arrAdd */])(currentLoadedKeys, eventKey);
            var newLoadingKeys = Object(__WEBPACK_IMPORTED_MODULE_7__util__["b" /* arrDel */])(currentLoadingKeys, eventKey); // onLoad should trigger before internal setState to avoid `loadData` trigger twice.
            // https://github.com/ant-design/ant-design/issues/12464

            if (onLoad) {
              onLoad(newLoadedKeys, {
                event: 'load',
                node: treeNode
              });
            }

            _this.setUncontrolledState({
              loadedKeys: newLoadedKeys
            });

            _this.setState({
              loadingKeys: newLoadingKeys
            });

            resolve();
          });
          return {
            loadingKeys: Object(__WEBPACK_IMPORTED_MODULE_7__util__["a" /* arrAdd */])(loadingKeys, eventKey)
          };
        });
      });
    };

    _this.onNodeExpand = function (e, treeNode) {
      var expandedKeys = _this.state.expandedKeys;
      var _this$props4 = _this.props,
          onExpand = _this$props4.onExpand,
          loadData = _this$props4.loadData;
      var _treeNode$props2 = treeNode.props,
          eventKey = _treeNode$props2.eventKey,
          expanded = _treeNode$props2.expanded; // Update selected keys

      var index = expandedKeys.indexOf(eventKey);
      var targetExpanded = !expanded;
      __WEBPACK_IMPORTED_MODULE_3_warning___default()(expanded && index !== -1 || !expanded && index === -1, 'Expand state not sync with index check');

      if (targetExpanded) {
        expandedKeys = Object(__WEBPACK_IMPORTED_MODULE_7__util__["a" /* arrAdd */])(expandedKeys, eventKey);
      } else {
        expandedKeys = Object(__WEBPACK_IMPORTED_MODULE_7__util__["b" /* arrDel */])(expandedKeys, eventKey);
      }

      _this.setUncontrolledState({
        expandedKeys: expandedKeys
      });

      if (onExpand) {
        onExpand(expandedKeys, {
          node: treeNode,
          expanded: targetExpanded,
          nativeEvent: e.nativeEvent
        });
      } // Async Load data


      if (targetExpanded && loadData) {
        var loadPromise = _this.onNodeLoad(treeNode);

        return loadPromise ? loadPromise.then(function () {
          // [Legacy] Refresh logic
          _this.setUncontrolledState({
            expandedKeys: expandedKeys
          });
        }) : null;
      }

      return null;
    };

    _this.onNodeMouseEnter = function (event, node) {
      var onMouseEnter = _this.props.onMouseEnter;

      if (onMouseEnter) {
        onMouseEnter({
          event: event,
          node: node
        });
      }
    };

    _this.onNodeMouseLeave = function (event, node) {
      var onMouseLeave = _this.props.onMouseLeave;

      if (onMouseLeave) {
        onMouseLeave({
          event: event,
          node: node
        });
      }
    };

    _this.onNodeContextMenu = function (event, node) {
      var onRightClick = _this.props.onRightClick;

      if (onRightClick) {
        event.preventDefault();
        onRightClick({
          event: event,
          node: node
        });
      }
    };
    /**
     * Only update the value which is not in props
     */


    _this.setUncontrolledState = function (state) {
      var needSync = false;
      var newState = {};
      Object.keys(state).forEach(function (name) {
        if (name in _this.props) return;
        needSync = true;
        newState[name] = state[name];
      });

      if (needSync) {
        _this.setState(newState);
      }
    };

    _this.registerTreeNode = function (key, node) {
      if (node) {
        _this.domTreeNodes[key] = node;
      } else {
        delete _this.domTreeNodes[key];
      }
    };

    _this.isKeyChecked = function (key) {
      var _this$state$checkedKe = _this.state.checkedKeys,
          checkedKeys = _this$state$checkedKe === void 0 ? [] : _this$state$checkedKe;
      return checkedKeys.indexOf(key) !== -1;
    };
    /**
     * [Legacy] Original logic use `key` as tracking clue.
     * We have to use `cloneElement` to pass `key`.
     */


    _this.renderTreeNode = function (child, index) {
      var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var _this$state5 = _this.state,
          keyEntities = _this$state5.keyEntities,
          _this$state5$expanded = _this$state5.expandedKeys,
          expandedKeys = _this$state5$expanded === void 0 ? [] : _this$state5$expanded,
          _this$state5$selected = _this$state5.selectedKeys,
          selectedKeys = _this$state5$selected === void 0 ? [] : _this$state5$selected,
          _this$state5$halfChec = _this$state5.halfCheckedKeys,
          halfCheckedKeys = _this$state5$halfChec === void 0 ? [] : _this$state5$halfChec,
          _this$state5$loadedKe = _this$state5.loadedKeys,
          loadedKeys = _this$state5$loadedKe === void 0 ? [] : _this$state5$loadedKe,
          _this$state5$loadingK = _this$state5.loadingKeys,
          loadingKeys = _this$state5$loadingK === void 0 ? [] : _this$state5$loadingK,
          dragOverNodeKey = _this$state5.dragOverNodeKey,
          dropPosition = _this$state5.dropPosition;
      var pos = Object(__WEBPACK_IMPORTED_MODULE_7__util__["l" /* getPosition */])(level, index);
      var key = child.key || pos;

      if (!keyEntities[key]) {
        Object(__WEBPACK_IMPORTED_MODULE_7__util__["p" /* warnOnlyTreeNode */])();
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](child, {
        key: key,
        eventKey: key,
        expanded: expandedKeys.indexOf(key) !== -1,
        selected: selectedKeys.indexOf(key) !== -1,
        loaded: loadedKeys.indexOf(key) !== -1,
        loading: loadingKeys.indexOf(key) !== -1,
        checked: _this.isKeyChecked(key),
        halfChecked: halfCheckedKeys.indexOf(key) !== -1,
        pos: pos,
        // [Legacy] Drag props
        dragOver: dragOverNodeKey === key && dropPosition === 0,
        dragOverGapTop: dragOverNodeKey === key && dropPosition === -1,
        dragOverGapBottom: dragOverNodeKey === key && dropPosition === 1
      });
    };

    return _this;
  }

  _createClass(Tree, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var treeNode = this.state.treeNode;
      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          className = _this$props5.className,
          focusable = _this$props5.focusable,
          style = _this$props5.style,
          showLine = _this$props5.showLine,
          _this$props5$tabIndex = _this$props5.tabIndex,
          tabIndex = _this$props5$tabIndex === void 0 ? 0 : _this$props5$tabIndex,
          selectable = _this$props5.selectable,
          showIcon = _this$props5.showIcon,
          icon = _this$props5.icon,
          switcherIcon = _this$props5.switcherIcon,
          draggable = _this$props5.draggable,
          checkable = _this$props5.checkable,
          checkStrictly = _this$props5.checkStrictly,
          disabled = _this$props5.disabled,
          motion = _this$props5.motion,
          loadData = _this$props5.loadData,
          filterTreeNode = _this$props5.filterTreeNode;
      var domProps = Object(__WEBPACK_IMPORTED_MODULE_7__util__["i" /* getDataAndAria */])(this.props);

      if (focusable) {
        domProps.tabIndex = tabIndex;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__contextTypes__["a" /* TreeContext */].Provider, {
        value: {
          prefixCls: prefixCls,
          selectable: selectable,
          showIcon: showIcon,
          icon: icon,
          switcherIcon: switcherIcon,
          draggable: draggable,
          checkable: checkable,
          checkStrictly: checkStrictly,
          disabled: disabled,
          motion: motion,
          loadData: loadData,
          filterTreeNode: filterTreeNode,
          renderTreeNode: this.renderTreeNode,
          isKeyChecked: this.isKeyChecked,
          onNodeClick: this.onNodeClick,
          onNodeDoubleClick: this.onNodeDoubleClick,
          onNodeExpand: this.onNodeExpand,
          onNodeSelect: this.onNodeSelect,
          onNodeCheck: this.onNodeCheck,
          onNodeLoad: this.onNodeLoad,
          onNodeMouseEnter: this.onNodeMouseEnter,
          onNodeMouseLeave: this.onNodeMouseLeave,
          onNodeContextMenu: this.onNodeContextMenu,
          onNodeDragStart: this.onNodeDragStart,
          onNodeDragEnter: this.onNodeDragEnter,
          onNodeDragOver: this.onNodeDragOver,
          onNodeDragLeave: this.onNodeDragLeave,
          onNodeDragEnd: this.onNodeDragEnd,
          onNodeDrop: this.onNodeDrop,
          registerTreeNode: this.registerTreeNode
        }
      }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", Object.assign({}, domProps, {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-show-line"), showLine)),
        style: style,
        role: "tree",
        unselectable: "on"
      }), Object(__WEBPACK_IMPORTED_MODULE_7__util__["m" /* mapChildren */])(treeNode, function (node, index) {
        return _this2.renderTreeNode(node, index);
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, prevState) {
      var prevProps = prevState.prevProps;
      var newState = {
        prevProps: props
      };

      function needSync(name) {
        return !prevProps && name in props || prevProps && prevProps[name] !== props[name];
      } // ================== Tree Node ==================


      var treeNode = null; // Check if `treeData` or `children` changed and save into the state.

      if (needSync('treeData')) {
        treeNode = Object(__WEBPACK_IMPORTED_MODULE_7__util__["g" /* convertDataToTree */])(props.treeData);
      } else if (needSync('children')) {
        treeNode = Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_Children_toArray__["a" /* default */])(props.children);
      } // Tree support filter function which will break the tree structure in the vdm.
      // We cache the treeNodes in state so that we can return the treeNode in event trigger.


      if (treeNode) {
        newState.treeNode = treeNode; // Calculate the entities data for quick match

        var entitiesMap = Object(__WEBPACK_IMPORTED_MODULE_7__util__["h" /* convertTreeToEntities */])(treeNode);
        newState.keyEntities = entitiesMap.keyEntities;
      }

      var keyEntities = newState.keyEntities || prevState.keyEntities; // ================ expandedKeys =================

      if (needSync('expandedKeys') || prevProps && needSync('autoExpandParent')) {
        newState.expandedKeys = props.autoExpandParent || !prevProps && props.defaultExpandParent ? Object(__WEBPACK_IMPORTED_MODULE_7__util__["f" /* conductExpandParent */])(props.expandedKeys, keyEntities) : props.expandedKeys;
      } else if (!prevProps && props.defaultExpandAll) {
        newState.expandedKeys = Object.keys(keyEntities);
      } else if (!prevProps && props.defaultExpandedKeys) {
        newState.expandedKeys = props.autoExpandParent || props.defaultExpandParent ? Object(__WEBPACK_IMPORTED_MODULE_7__util__["f" /* conductExpandParent */])(props.defaultExpandedKeys, keyEntities) : props.defaultExpandedKeys;
      } // ================ selectedKeys =================


      if (props.selectable) {
        if (needSync('selectedKeys')) {
          newState.selectedKeys = Object(__WEBPACK_IMPORTED_MODULE_7__util__["d" /* calcSelectedKeys */])(props.selectedKeys, props);
        } else if (!prevProps && props.defaultSelectedKeys) {
          newState.selectedKeys = Object(__WEBPACK_IMPORTED_MODULE_7__util__["d" /* calcSelectedKeys */])(props.defaultSelectedKeys, props);
        }
      } // ================= checkedKeys =================


      if (props.checkable) {
        var checkedKeyEntity;

        if (needSync('checkedKeys')) {
          checkedKeyEntity = Object(__WEBPACK_IMPORTED_MODULE_7__util__["n" /* parseCheckedKeys */])(props.checkedKeys) || {};
        } else if (!prevProps && props.defaultCheckedKeys) {
          checkedKeyEntity = Object(__WEBPACK_IMPORTED_MODULE_7__util__["n" /* parseCheckedKeys */])(props.defaultCheckedKeys) || {};
        } else if (treeNode) {
          // If treeNode changed, we also need check it
          checkedKeyEntity = Object(__WEBPACK_IMPORTED_MODULE_7__util__["n" /* parseCheckedKeys */])(props.checkedKeys) || {
            checkedKeys: prevState.checkedKeys,
            halfCheckedKeys: prevState.halfCheckedKeys
          };
        }

        if (checkedKeyEntity) {
          var _checkedKeyEntity = checkedKeyEntity,
              _checkedKeyEntity$che = _checkedKeyEntity.checkedKeys,
              checkedKeys = _checkedKeyEntity$che === void 0 ? [] : _checkedKeyEntity$che,
              _checkedKeyEntity$hal = _checkedKeyEntity.halfCheckedKeys,
              halfCheckedKeys = _checkedKeyEntity$hal === void 0 ? [] : _checkedKeyEntity$hal;

          if (!props.checkStrictly) {
            var conductKeys = Object(__WEBPACK_IMPORTED_MODULE_7__util__["e" /* conductCheck */])(checkedKeys, true, keyEntities);
            checkedKeys = conductKeys.checkedKeys;
            halfCheckedKeys = conductKeys.halfCheckedKeys;
          }

          newState.checkedKeys = checkedKeys;
          newState.halfCheckedKeys = halfCheckedKeys;
        }
      } // ================= loadedKeys ==================


      if (needSync('loadedKeys')) {
        newState.loadedKeys = props.loadedKeys;
      }

      return newState;
    }
  }]);

  return Tree;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Tree.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  tabIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  treeData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  showLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  focusable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  checkable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  checkStrictly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  draggable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  defaultExpandParent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoExpandParent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  defaultExpandAll: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  defaultExpandedKeys: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  expandedKeys: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  defaultCheckedKeys: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  checkedKeys: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  defaultSelectedKeys: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  selectedKeys: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDoubleClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onExpand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onCheck: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onLoad: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  loadData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  loadedKeys: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onRightClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDragStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDragEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  filterTreeNode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  motion: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  switcherIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Tree.defaultProps = {
  prefixCls: 'rc-tree',
  showLine: false,
  showIcon: true,
  selectable: true,
  multiple: false,
  checkable: false,
  disabled: false,
  checkStrictly: false,
  draggable: false,
  defaultExpandParent: true,
  autoExpandParent: false,
  defaultExpandAll: false,
  defaultExpandedKeys: [],
  defaultCheckedKeys: [],
  defaultSelectedKeys: []
};
Object(__WEBPACK_IMPORTED_MODULE_5_react_lifecycles_compat__["polyfill"])(Tree);
/* harmony default export */ __webpack_exports__["a"] = (Tree);

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _omit = _interopRequireDefault(__webpack_require__(71));

var _debounce = _interopRequireDefault(__webpack_require__(532));

var _util = __webpack_require__(368);

var _reactLifecyclesCompat = __webpack_require__(36);

var _configProvider = __webpack_require__(39);

var _Tree = _interopRequireDefault(__webpack_require__(536));

var _util2 = __webpack_require__(1111);

var _icon = _interopRequireDefault(__webpack_require__(38));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

function getIcon(props) {
  var isLeaf = props.isLeaf,
      expanded = props.expanded;

  if (isLeaf) {
    return /*#__PURE__*/React.createElement(_icon["default"], {
      type: "file"
    });
  }

  return /*#__PURE__*/React.createElement(_icon["default"], {
    type: expanded ? 'folder-open' : 'folder'
  });
}

var DirectoryTree = /*#__PURE__*/function (_React$Component) {
  _inherits(DirectoryTree, _React$Component);

  var _super = _createSuper(DirectoryTree);

  function DirectoryTree(props) {
    var _this;

    _classCallCheck(this, DirectoryTree);

    _this = _super.call(this, props);

    _this.onExpand = function (expandedKeys, info) {
      var onExpand = _this.props.onExpand;

      _this.setUncontrolledState({
        expandedKeys: expandedKeys
      }); // Call origin function


      if (onExpand) {
        return onExpand(expandedKeys, info);
      }

      return undefined;
    };

    _this.onClick = function (event, node) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          expandAction = _this$props.expandAction; // Expand the tree

      if (expandAction === 'click') {
        _this.onDebounceExpand(event, node);
      }

      if (onClick) {
        onClick(event, node);
      }
    };

    _this.onDoubleClick = function (event, node) {
      var _this$props2 = _this.props,
          onDoubleClick = _this$props2.onDoubleClick,
          expandAction = _this$props2.expandAction; // Expand the tree

      if (expandAction === 'doubleClick') {
        _this.onDebounceExpand(event, node);
      }

      if (onDoubleClick) {
        onDoubleClick(event, node);
      }
    };

    _this.onSelect = function (keys, event) {
      var _this$props3 = _this.props,
          onSelect = _this$props3.onSelect,
          multiple = _this$props3.multiple,
          children = _this$props3.children;
      var _this$state$expandedK = _this.state.expandedKeys,
          expandedKeys = _this$state$expandedK === void 0 ? [] : _this$state$expandedK;
      var node = event.node,
          nativeEvent = event.nativeEvent;
      var _node$props$eventKey = node.props.eventKey,
          eventKey = _node$props$eventKey === void 0 ? '' : _node$props$eventKey;
      var newState = {}; // We need wrap this event since some value is not same

      var newEvent = _extends(_extends({}, event), {
        selected: true
      }); // Windows / Mac single pick


      var ctrlPick = nativeEvent.ctrlKey || nativeEvent.metaKey;
      var shiftPick = nativeEvent.shiftKey; // Generate new selected keys

      var newSelectedKeys;

      if (multiple && ctrlPick) {
        // Control click
        newSelectedKeys = keys;
        _this.lastSelectedKey = eventKey;
        _this.cachedSelectedKeys = newSelectedKeys;
        newEvent.selectedNodes = (0, _util2.convertDirectoryKeysToNodes)(children, newSelectedKeys);
      } else if (multiple && shiftPick) {
        // Shift click
        newSelectedKeys = Array.from(new Set([].concat(_toConsumableArray(_this.cachedSelectedKeys || []), _toConsumableArray((0, _util2.calcRangeKeys)(children, expandedKeys, eventKey, _this.lastSelectedKey)))));
        newEvent.selectedNodes = (0, _util2.convertDirectoryKeysToNodes)(children, newSelectedKeys);
      } else {
        // Single click
        newSelectedKeys = [eventKey];
        _this.lastSelectedKey = eventKey;
        _this.cachedSelectedKeys = newSelectedKeys;
        newEvent.selectedNodes = [event.node];
      }

      newState.selectedKeys = newSelectedKeys;

      if (onSelect) {
        onSelect(newSelectedKeys, newEvent);
      }

      _this.setUncontrolledState(newState);
    };

    _this.setTreeRef = function (node) {
      _this.tree = node;
    };

    _this.expandFolderNode = function (event, node) {
      var isLeaf = node.props.isLeaf;

      if (isLeaf || event.shiftKey || event.metaKey || event.ctrlKey) {
        return;
      } // Get internal rc-tree


      var internalTree = _this.tree.tree; // Call internal rc-tree expand function
      // https://github.com/ant-design/ant-design/issues/12567

      internalTree.onNodeExpand(event, node);
    };

    _this.setUncontrolledState = function (state) {
      var newState = (0, _omit["default"])(state, Object.keys(_this.props));

      if (Object.keys(newState).length) {
        _this.setState(newState);
      }
    };

    _this.renderDirectoryTree = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          className = _a.className,
          props = __rest(_a, ["prefixCls", "className"]);

      var _this$state = _this.state,
          expandedKeys = _this$state.expandedKeys,
          selectedKeys = _this$state.selectedKeys;
      var prefixCls = getPrefixCls('tree', customizePrefixCls);
      var connectClassName = (0, _classnames["default"])("".concat(prefixCls, "-directory"), className);
      return /*#__PURE__*/React.createElement(_Tree["default"], _extends({
        icon: getIcon,
        ref: _this.setTreeRef
      }, props, {
        prefixCls: prefixCls,
        className: connectClassName,
        expandedKeys: expandedKeys,
        selectedKeys: selectedKeys,
        onSelect: _this.onSelect,
        onClick: _this.onClick,
        onDoubleClick: _this.onDoubleClick,
        onExpand: _this.onExpand
      }));
    };

    var defaultExpandAll = props.defaultExpandAll,
        defaultExpandParent = props.defaultExpandParent,
        expandedKeys = props.expandedKeys,
        defaultExpandedKeys = props.defaultExpandedKeys,
        children = props.children;

    var _convertTreeToEntitie = (0, _util.convertTreeToEntities)(children),
        keyEntities = _convertTreeToEntitie.keyEntities; // Selected keys


    _this.state = {
      selectedKeys: props.selectedKeys || props.defaultSelectedKeys || []
    }; // Expanded keys

    if (defaultExpandAll) {
      if (props.treeData) {
        _this.state.expandedKeys = (0, _util2.getFullKeyListByTreeData)(props.treeData);
      } else {
        _this.state.expandedKeys = (0, _util2.getFullKeyList)(props.children);
      }
    } else if (defaultExpandParent) {
      _this.state.expandedKeys = (0, _util.conductExpandParent)(expandedKeys || defaultExpandedKeys, keyEntities);
    } else {
      _this.state.expandedKeys = expandedKeys || defaultExpandedKeys;
    }

    _this.onDebounceExpand = (0, _debounce["default"])(_this.expandFolderNode, 200, {
      leading: true
    });
    return _this;
  }

  _createClass(DirectoryTree, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderDirectoryTree);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      var newState = {};

      if ('expandedKeys' in nextProps) {
        newState.expandedKeys = nextProps.expandedKeys;
      }

      if ('selectedKeys' in nextProps) {
        newState.selectedKeys = nextProps.selectedKeys;
      }

      return newState;
    }
  }]);

  return DirectoryTree;
}(React.Component);

DirectoryTree.defaultProps = {
  showIcon: true,
  expandAction: 'click'
};
(0, _reactLifecyclesCompat.polyfill)(DirectoryTree);
var _default = DirectoryTree;
exports["default"] = _default;

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InternalTreeNode = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(19));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _CSSMotion = _interopRequireDefault(__webpack_require__(1108));

var _toArray = _interopRequireDefault(__webpack_require__(342));

var _reactLifecyclesCompat = __webpack_require__(36);

var _contextTypes = __webpack_require__(1110);

var _util = __webpack_require__(368);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ICON_OPEN = 'open';
var ICON_CLOSE = 'close';
var defaultTitle = '---';

var TreeNode = /*#__PURE__*/function (_React$Component) {
  _inherits(TreeNode, _React$Component);

  var _super = _createSuper(TreeNode);

  function TreeNode() {
    var _this;

    _classCallCheck(this, TreeNode);

    _this = _super.apply(this, arguments);
    _this.state = {
      dragNodeHighlight: false
    };

    _this.onSelectorClick = function (e) {
      // Click trigger before select/check operation
      var onNodeClick = _this.props.context.onNodeClick;
      onNodeClick(e, _assertThisInitialized(_this));

      if (_this.isSelectable()) {
        _this.onSelect(e);
      } else {
        _this.onCheck(e);
      }
    };

    _this.onSelectorDoubleClick = function (e) {
      var onNodeDoubleClick = _this.props.context.onNodeDoubleClick;
      onNodeDoubleClick(e, _assertThisInitialized(_this));
    };

    _this.onSelect = function (e) {
      if (_this.isDisabled()) return;
      var onNodeSelect = _this.props.context.onNodeSelect;
      e.preventDefault();
      onNodeSelect(e, _assertThisInitialized(_this));
    };

    _this.onCheck = function (e) {
      if (_this.isDisabled()) return;
      var _this$props = _this.props,
          disableCheckbox = _this$props.disableCheckbox,
          checked = _this$props.checked;
      var onNodeCheck = _this.props.context.onNodeCheck;
      if (!_this.isCheckable() || disableCheckbox) return;
      e.preventDefault();
      var targetChecked = !checked;
      onNodeCheck(e, _assertThisInitialized(_this), targetChecked);
    };

    _this.onMouseEnter = function (e) {
      var onNodeMouseEnter = _this.props.context.onNodeMouseEnter;
      onNodeMouseEnter(e, _assertThisInitialized(_this));
    };

    _this.onMouseLeave = function (e) {
      var onNodeMouseLeave = _this.props.context.onNodeMouseLeave;
      onNodeMouseLeave(e, _assertThisInitialized(_this));
    };

    _this.onContextMenu = function (e) {
      var onNodeContextMenu = _this.props.context.onNodeContextMenu;
      onNodeContextMenu(e, _assertThisInitialized(_this));
    };

    _this.onDragStart = function (e) {
      var onNodeDragStart = _this.props.context.onNodeDragStart;
      e.stopPropagation();

      _this.setState({
        dragNodeHighlight: true
      });

      onNodeDragStart(e, _assertThisInitialized(_this));

      try {
        // ie throw error
        // firefox-need-it
        e.dataTransfer.setData('text/plain', '');
      } catch (error) {// empty
      }
    };

    _this.onDragEnter = function (e) {
      var onNodeDragEnter = _this.props.context.onNodeDragEnter;
      e.preventDefault();
      e.stopPropagation();
      onNodeDragEnter(e, _assertThisInitialized(_this));
    };

    _this.onDragOver = function (e) {
      var onNodeDragOver = _this.props.context.onNodeDragOver;
      e.preventDefault();
      e.stopPropagation();
      onNodeDragOver(e, _assertThisInitialized(_this));
    };

    _this.onDragLeave = function (e) {
      var onNodeDragLeave = _this.props.context.onNodeDragLeave;
      e.stopPropagation();
      onNodeDragLeave(e, _assertThisInitialized(_this));
    };

    _this.onDragEnd = function (e) {
      var onNodeDragEnd = _this.props.context.onNodeDragEnd;
      e.stopPropagation();

      _this.setState({
        dragNodeHighlight: false
      });

      onNodeDragEnd(e, _assertThisInitialized(_this));
    };

    _this.onDrop = function (e) {
      var onNodeDrop = _this.props.context.onNodeDrop;
      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        dragNodeHighlight: false
      });

      onNodeDrop(e, _assertThisInitialized(_this));
    }; // Disabled item still can be switch


    _this.onExpand = function (e) {
      var onNodeExpand = _this.props.context.onNodeExpand;
      onNodeExpand(e, _assertThisInitialized(_this));
    }; // Drag usage


    _this.setSelectHandle = function (node) {
      _this.selectHandle = node;
    };

    _this.getNodeChildren = function () {
      var children = _this.props.children;
      var originList = (0, _toArray.default)(children).filter(function (node) {
        return node;
      });
      var targetList = (0, _util.getNodeChildren)(originList);

      if (originList.length !== targetList.length) {
        (0, _util.warnOnlyTreeNode)();
      }

      return targetList;
    };

    _this.getNodeState = function () {
      var expanded = _this.props.expanded;

      if (_this.isLeaf()) {
        return null;
      }

      return expanded ? ICON_OPEN : ICON_CLOSE;
    };

    _this.isLeaf = function () {
      var _this$props2 = _this.props,
          isLeaf = _this$props2.isLeaf,
          loaded = _this$props2.loaded;
      var loadData = _this.props.context.loadData;
      var hasChildren = _this.getNodeChildren().length !== 0;

      if (isLeaf === false) {
        return false;
      }

      return isLeaf || !loadData && !hasChildren || loadData && loaded && !hasChildren;
    };

    _this.isDisabled = function () {
      var disabled = _this.props.disabled;
      var treeDisabled = _this.props.context.disabled; // Follow the logic of Selectable

      if (disabled === false) {
        return false;
      }

      return !!(treeDisabled || disabled);
    };

    _this.isCheckable = function () {
      var checkable = _this.props.checkable;
      var treeCheckable = _this.props.context.checkable; // Return false if tree or treeNode is not checkable

      if (!treeCheckable || checkable === false) return false;
      return treeCheckable;
    }; // Load data to avoid default expanded tree without data


    _this.syncLoadData = function (props) {
      var expanded = props.expanded,
          loading = props.loading,
          loaded = props.loaded;
      var _this$props$context = _this.props.context,
          loadData = _this$props$context.loadData,
          onNodeLoad = _this$props$context.onNodeLoad;
      if (loading) return; // read from state to avoid loadData at same time

      if (loadData && expanded && !_this.isLeaf()) {
        // We needn't reload data when has children in sync logic
        // It's only needed in node expanded
        var hasChildren = _this.getNodeChildren().length !== 0;

        if (!hasChildren && !loaded) {
          onNodeLoad(_assertThisInitialized(_this));
        }
      }
    }; // Switcher


    _this.renderSwitcher = function () {
      var _this$props3 = _this.props,
          expanded = _this$props3.expanded,
          switcherIconFromProps = _this$props3.switcherIcon;
      var _this$props$context2 = _this.props.context,
          prefixCls = _this$props$context2.prefixCls,
          switcherIconFromCtx = _this$props$context2.switcherIcon;
      var switcherIcon = switcherIconFromProps || switcherIconFromCtx;

      if (_this.isLeaf()) {
        return React.createElement("span", {
          className: (0, _classnames.default)("".concat(prefixCls, "-switcher"), "".concat(prefixCls, "-switcher-noop"))
        }, typeof switcherIcon === 'function' ? switcherIcon(_objectSpread({}, _this.props, {
          isLeaf: true
        })) : switcherIcon);
      }

      var switcherCls = (0, _classnames.default)("".concat(prefixCls, "-switcher"), "".concat(prefixCls, "-switcher_").concat(expanded ? ICON_OPEN : ICON_CLOSE));
      return React.createElement("span", {
        onClick: _this.onExpand,
        className: switcherCls
      }, typeof switcherIcon === 'function' ? switcherIcon(_objectSpread({}, _this.props, {
        isLeaf: false
      })) : switcherIcon);
    }; // Checkbox


    _this.renderCheckbox = function () {
      var _this$props4 = _this.props,
          checked = _this$props4.checked,
          halfChecked = _this$props4.halfChecked,
          disableCheckbox = _this$props4.disableCheckbox;
      var prefixCls = _this.props.context.prefixCls;

      var disabled = _this.isDisabled();

      var checkable = _this.isCheckable();

      if (!checkable) return null; // [Legacy] Custom element should be separate with `checkable` in future

      var $custom = typeof checkable !== 'boolean' ? checkable : null;
      return React.createElement("span", {
        className: (0, _classnames.default)("".concat(prefixCls, "-checkbox"), checked && "".concat(prefixCls, "-checkbox-checked"), !checked && halfChecked && "".concat(prefixCls, "-checkbox-indeterminate"), (disabled || disableCheckbox) && "".concat(prefixCls, "-checkbox-disabled")),
        onClick: _this.onCheck
      }, $custom);
    };

    _this.renderIcon = function () {
      var loading = _this.props.loading;
      var prefixCls = _this.props.context.prefixCls;
      return React.createElement("span", {
        className: (0, _classnames.default)("".concat(prefixCls, "-iconEle"), "".concat(prefixCls, "-icon__").concat(_this.getNodeState() || 'docu'), loading && "".concat(prefixCls, "-icon_loading"))
      });
    }; // Icon + Title


    _this.renderSelector = function () {
      var dragNodeHighlight = _this.state.dragNodeHighlight;
      var _this$props5 = _this.props,
          title = _this$props5.title,
          selected = _this$props5.selected,
          icon = _this$props5.icon,
          loading = _this$props5.loading;
      var _this$props$context3 = _this.props.context,
          prefixCls = _this$props$context3.prefixCls,
          showIcon = _this$props$context3.showIcon,
          treeIcon = _this$props$context3.icon,
          draggable = _this$props$context3.draggable,
          loadData = _this$props$context3.loadData;

      var disabled = _this.isDisabled();

      var wrapClass = "".concat(prefixCls, "-node-content-wrapper"); // Icon - Still show loading icon when loading without showIcon

      var $icon;

      if (showIcon) {
        var currentIcon = icon || treeIcon;
        $icon = currentIcon ? React.createElement("span", {
          className: (0, _classnames.default)("".concat(prefixCls, "-iconEle"), "".concat(prefixCls, "-icon__customize"))
        }, typeof currentIcon === 'function' ? currentIcon(_this.props) : currentIcon) : _this.renderIcon();
      } else if (loadData && loading) {
        $icon = _this.renderIcon();
      } // Title


      var $title = React.createElement("span", {
        className: "".concat(prefixCls, "-title")
      }, title);
      return React.createElement("span", {
        ref: _this.setSelectHandle,
        title: typeof title === 'string' ? title : '',
        className: (0, _classnames.default)("".concat(wrapClass), "".concat(wrapClass, "-").concat(_this.getNodeState() || 'normal'), !disabled && (selected || dragNodeHighlight) && "".concat(prefixCls, "-node-selected"), !disabled && draggable && 'draggable'),
        draggable: !disabled && draggable || undefined,
        "aria-grabbed": !disabled && draggable || undefined,
        onMouseEnter: _this.onMouseEnter,
        onMouseLeave: _this.onMouseLeave,
        onContextMenu: _this.onContextMenu,
        onClick: _this.onSelectorClick,
        onDoubleClick: _this.onSelectorDoubleClick,
        onDragStart: draggable ? _this.onDragStart : undefined
      }, $icon, $title);
    }; // Children list wrapped with `Animation`


    _this.renderChildren = function () {
      var _this$props6 = _this.props,
          expanded = _this$props6.expanded,
          pos = _this$props6.pos;
      var _this$props$context4 = _this.props.context,
          prefixCls = _this$props$context4.prefixCls,
          motion = _this$props$context4.motion,
          renderTreeNode = _this$props$context4.renderTreeNode; // Children TreeNode

      var nodeList = _this.getNodeChildren();

      if (nodeList.length === 0) {
        return null;
      }

      return React.createElement(_CSSMotion.default, Object.assign({
        visible: expanded
      }, motion), function (_ref) {
        var style = _ref.style,
            className = _ref.className;
        return React.createElement("ul", {
          className: (0, _classnames.default)(className, "".concat(prefixCls, "-child-tree"), expanded && "".concat(prefixCls, "-child-tree-open")),
          style: style,
          "data-expanded": expanded,
          role: "group"
        }, (0, _util.mapChildren)(nodeList, function (node, index) {
          return renderTreeNode(node, index, pos);
        }));
      });
    };

    return _this;
  } // Isomorphic needn't load data in server side


  _createClass(TreeNode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props7 = this.props,
          eventKey = _this$props7.eventKey,
          registerTreeNode = _this$props7.context.registerTreeNode;
      this.syncLoadData(this.props);
      registerTreeNode(eventKey, this);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.syncLoadData(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props8 = this.props,
          eventKey = _this$props8.eventKey,
          registerTreeNode = _this$props8.context.registerTreeNode;
      registerTreeNode(eventKey, null);
    }
  }, {
    key: "isSelectable",
    value: function isSelectable() {
      var selectable = this.props.selectable;
      var treeSelectable = this.props.context.selectable; // Ignore when selectable is undefined or null

      if (typeof selectable === 'boolean') {
        return selectable;
      }

      return treeSelectable;
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var loading = this.props.loading;

      var _this$props9 = this.props,
          className = _this$props9.className,
          style = _this$props9.style,
          dragOver = _this$props9.dragOver,
          dragOverGapTop = _this$props9.dragOverGapTop,
          dragOverGapBottom = _this$props9.dragOverGapBottom,
          isLeaf = _this$props9.isLeaf,
          expanded = _this$props9.expanded,
          selected = _this$props9.selected,
          checked = _this$props9.checked,
          halfChecked = _this$props9.halfChecked,
          otherProps = _objectWithoutProperties(_this$props9, ["className", "style", "dragOver", "dragOverGapTop", "dragOverGapBottom", "isLeaf", "expanded", "selected", "checked", "halfChecked"]);

      var _this$props$context5 = this.props.context,
          prefixCls = _this$props$context5.prefixCls,
          filterTreeNode = _this$props$context5.filterTreeNode,
          draggable = _this$props$context5.draggable;
      var disabled = this.isDisabled();
      var dataOrAriaAttributeProps = (0, _util.getDataAndAria)(otherProps);
      return React.createElement("li", Object.assign({
        className: (0, _classnames.default)(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-treenode-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-treenode-switcher-").concat(expanded ? 'open' : 'close'), !isLeaf), _defineProperty(_classNames, "".concat(prefixCls, "-treenode-checkbox-checked"), checked), _defineProperty(_classNames, "".concat(prefixCls, "-treenode-checkbox-indeterminate"), halfChecked), _defineProperty(_classNames, "".concat(prefixCls, "-treenode-selected"), selected), _defineProperty(_classNames, "".concat(prefixCls, "-treenode-loading"), loading), _defineProperty(_classNames, 'drag-over', !disabled && dragOver), _defineProperty(_classNames, 'drag-over-gap-top', !disabled && dragOverGapTop), _defineProperty(_classNames, 'drag-over-gap-bottom', !disabled && dragOverGapBottom), _defineProperty(_classNames, 'filter-node', filterTreeNode && filterTreeNode(this)), _classNames)),
        style: style,
        role: "treeitem",
        onDragEnter: draggable ? this.onDragEnter : undefined,
        onDragOver: draggable ? this.onDragOver : undefined,
        onDragLeave: draggable ? this.onDragLeave : undefined,
        onDrop: draggable ? this.onDrop : undefined,
        onDragEnd: draggable ? this.onDragEnd : undefined
      }, dataOrAriaAttributeProps), this.renderSwitcher(), this.renderCheckbox(), this.renderSelector(), this.renderChildren());
    }
  }]);

  return TreeNode;
}(React.Component);

exports.InternalTreeNode = TreeNode;
TreeNode.propTypes = {
  eventKey: _propTypes.default.string,
  prefixCls: _propTypes.default.string,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  onSelect: _propTypes.default.func,
  // By parent
  expanded: _propTypes.default.bool,
  selected: _propTypes.default.bool,
  checked: _propTypes.default.bool,
  loaded: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  halfChecked: _propTypes.default.bool,
  children: _propTypes.default.node,
  title: _propTypes.default.node,
  pos: _propTypes.default.string,
  dragOver: _propTypes.default.bool,
  dragOverGapTop: _propTypes.default.bool,
  dragOverGapBottom: _propTypes.default.bool,
  // By user
  isLeaf: _propTypes.default.bool,
  checkable: _propTypes.default.bool,
  selectable: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  disableCheckbox: _propTypes.default.bool,
  icon: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  switcherIcon: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func])
};
(0, _reactLifecyclesCompat.polyfill)(TreeNode);

var ContextTreeNode = function ContextTreeNode(props) {
  return React.createElement(_contextTypes.TreeContext.Consumer, null, function (context) {
    return React.createElement(TreeNode, Object.assign({}, props, {
      context: context
    }));
  });
};

ContextTreeNode.defaultProps = {
  title: defaultTitle
};
ContextTreeNode.isTreeNode = 1;
var _default = ContextTreeNode;
exports.default = _default;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MotionPropTypes = undefined;

var _defineProperty2 = __webpack_require__(78);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(48);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(31);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(72);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(32);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.genCSSMotion = genCSSMotion;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactLifecyclesCompat = __webpack_require__(36);

var _findDOMNode = __webpack_require__(479);

var _findDOMNode2 = _interopRequireDefault(_findDOMNode);

var _classnames = __webpack_require__(22);

var _classnames2 = _interopRequireDefault(_classnames);

var _raf = __webpack_require__(262);

var _raf2 = _interopRequireDefault(_raf);

var _motion = __webpack_require__(1109);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var STATUS_NONE = 'none'; /* eslint-disable react/default-props-match-prop-types, react/no-multi-comp */

var STATUS_APPEAR = 'appear';
var STATUS_ENTER = 'enter';
var STATUS_LEAVE = 'leave';

var MotionPropTypes = exports.MotionPropTypes = {
  eventProps: _propTypes2['default'].object, // Internal usage. Only pass by CSSMotionList
  visible: _propTypes2['default'].bool,
  children: _propTypes2['default'].func,
  motionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
  motionAppear: _propTypes2['default'].bool,
  motionEnter: _propTypes2['default'].bool,
  motionLeave: _propTypes2['default'].bool,
  motionLeaveImmediately: _propTypes2['default'].bool, // Trigger leave motion immediately
  motionDeadline: _propTypes2['default'].number,
  removeOnLeave: _propTypes2['default'].bool,
  leavedClassName: _propTypes2['default'].string,
  onAppearStart: _propTypes2['default'].func,
  onAppearActive: _propTypes2['default'].func,
  onAppearEnd: _propTypes2['default'].func,
  onEnterStart: _propTypes2['default'].func,
  onEnterActive: _propTypes2['default'].func,
  onEnterEnd: _propTypes2['default'].func,
  onLeaveStart: _propTypes2['default'].func,
  onLeaveActive: _propTypes2['default'].func,
  onLeaveEnd: _propTypes2['default'].func
};

/**
 * `transitionSupport` is used for none transition test case.
 * Default we use browser transition event support check.
 */
function genCSSMotion(config) {
  var transitionSupport = config;
  var forwardRef = !!_react2['default'].forwardRef;

  if (typeof config === 'object') {
    transitionSupport = config.transitionSupport;
    forwardRef = 'forwardRef' in config ? config.forwardRef : forwardRef;
  }

  function isSupportTransition(props) {
    return !!(props.motionName && transitionSupport);
  }

  var CSSMotion = function (_React$Component) {
    (0, _inherits3['default'])(CSSMotion, _React$Component);

    function CSSMotion() {
      (0, _classCallCheck3['default'])(this, CSSMotion);

      var _this = (0, _possibleConstructorReturn3['default'])(this, (CSSMotion.__proto__ || Object.getPrototypeOf(CSSMotion)).call(this));

      _this.onDomUpdate = function () {
        var _this$state = _this.state,
            status = _this$state.status,
            newStatus = _this$state.newStatus;
        var _this$props = _this.props,
            onAppearStart = _this$props.onAppearStart,
            onEnterStart = _this$props.onEnterStart,
            onLeaveStart = _this$props.onLeaveStart,
            onAppearActive = _this$props.onAppearActive,
            onEnterActive = _this$props.onEnterActive,
            onLeaveActive = _this$props.onLeaveActive,
            motionAppear = _this$props.motionAppear,
            motionEnter = _this$props.motionEnter,
            motionLeave = _this$props.motionLeave;


        if (!isSupportTransition(_this.props)) {
          return;
        }

        // Event injection
        var $ele = _this.getElement();
        if (_this.$cacheEle !== $ele) {
          _this.removeEventListener(_this.$cacheEle);
          _this.addEventListener($ele);
          _this.$cacheEle = $ele;
        }

        // Init status
        if (newStatus && status === STATUS_APPEAR && motionAppear) {
          _this.updateStatus(onAppearStart, null, null, function () {
            _this.updateActiveStatus(onAppearActive, STATUS_APPEAR);
          });
        } else if (newStatus && status === STATUS_ENTER && motionEnter) {
          _this.updateStatus(onEnterStart, null, null, function () {
            _this.updateActiveStatus(onEnterActive, STATUS_ENTER);
          });
        } else if (newStatus && status === STATUS_LEAVE && motionLeave) {
          _this.updateStatus(onLeaveStart, null, null, function () {
            _this.updateActiveStatus(onLeaveActive, STATUS_LEAVE);
          });
        }
      };

      _this.onMotionEnd = function (event) {
        var _this$state2 = _this.state,
            status = _this$state2.status,
            statusActive = _this$state2.statusActive;
        var _this$props2 = _this.props,
            onAppearEnd = _this$props2.onAppearEnd,
            onEnterEnd = _this$props2.onEnterEnd,
            onLeaveEnd = _this$props2.onLeaveEnd;

        if (status === STATUS_APPEAR && statusActive) {
          _this.updateStatus(onAppearEnd, { status: STATUS_NONE }, event);
        } else if (status === STATUS_ENTER && statusActive) {
          _this.updateStatus(onEnterEnd, { status: STATUS_NONE }, event);
        } else if (status === STATUS_LEAVE && statusActive) {
          _this.updateStatus(onLeaveEnd, { status: STATUS_NONE }, event);
        }
      };

      _this.setNodeRef = function (node) {
        var internalRef = _this.props.internalRef;

        _this.node = node;

        if (typeof internalRef === 'function') {
          internalRef(node);
        } else if (internalRef && 'current' in internalRef) {
          internalRef.current = node;
        }
      };

      _this.getElement = function () {
        try {
          return (0, _findDOMNode2['default'])(_this.node || _this);
        } catch (e) {
          /**
           * Fallback to cache element.
           * This is only happen when `motionDeadline` trigger but element removed.
           */
          return _this.$cacheEle;
        }
      };

      _this.addEventListener = function ($ele) {
        if (!$ele) return;

        $ele.addEventListener(_motion.transitionEndName, _this.onMotionEnd);
        $ele.addEventListener(_motion.animationEndName, _this.onMotionEnd);
      };

      _this.removeEventListener = function ($ele) {
        if (!$ele) return;

        $ele.removeEventListener(_motion.transitionEndName, _this.onMotionEnd);
        $ele.removeEventListener(_motion.animationEndName, _this.onMotionEnd);
      };

      _this.updateStatus = function (styleFunc, additionalState, event, callback) {
        var statusStyle = styleFunc ? styleFunc(_this.getElement(), event) : null;

        if (statusStyle === false || _this._destroyed) return;

        var nextStep = void 0;
        if (callback) {
          nextStep = function nextStep() {
            _this.nextFrame(callback);
          };
        }

        _this.setState((0, _extends3['default'])({
          statusStyle: typeof statusStyle === 'object' ? statusStyle : null,
          newStatus: false
        }, additionalState), nextStep); // Trigger before next frame & after `componentDidMount`
      };

      _this.updateActiveStatus = function (styleFunc, currentStatus) {
        // `setState` use `postMessage` to trigger at the end of frame.
        // Let's use requestAnimationFrame to update new state in next frame.
        _this.nextFrame(function () {
          var status = _this.state.status;

          if (status !== currentStatus) return;

          var motionDeadline = _this.props.motionDeadline;


          _this.updateStatus(styleFunc, { statusActive: true });

          if (motionDeadline > 0) {
            setTimeout(function () {
              _this.onMotionEnd({
                deadline: true
              });
            }, motionDeadline);
          }
        });
      };

      _this.nextFrame = function (func) {
        _this.cancelNextFrame();
        _this.raf = (0, _raf2['default'])(func);
      };

      _this.cancelNextFrame = function () {
        if (_this.raf) {
          _raf2['default'].cancel(_this.raf);
          _this.raf = null;
        }
      };

      _this.state = {
        status: STATUS_NONE,
        statusActive: false,
        newStatus: false,
        statusStyle: null
      };
      _this.$cacheEle = null;
      _this.node = null;
      _this.raf = null;
      return _this;
    }

    (0, _createClass3['default'])(CSSMotion, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.onDomUpdate();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        this.onDomUpdate();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this._destroyed = true;
        this.removeEventListener(this.$cacheEle);
        this.cancelNextFrame();
      }
    }, {
      key: 'render',
      value: function render() {
        var _classNames;

        var _state = this.state,
            status = _state.status,
            statusActive = _state.statusActive,
            statusStyle = _state.statusStyle;
        var _props = this.props,
            children = _props.children,
            motionName = _props.motionName,
            visible = _props.visible,
            removeOnLeave = _props.removeOnLeave,
            leavedClassName = _props.leavedClassName,
            eventProps = _props.eventProps;


        if (!children) return null;

        if (status === STATUS_NONE || !isSupportTransition(this.props)) {
          if (visible) {
            return children((0, _extends3['default'])({}, eventProps), this.setNodeRef);
          } else if (!removeOnLeave) {
            return children((0, _extends3['default'])({}, eventProps, { className: leavedClassName }), this.setNodeRef);
          }

          return null;
        }

        return children((0, _extends3['default'])({}, eventProps, {
          className: (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, (0, _motion.getTransitionName)(motionName, status), status !== STATUS_NONE), (0, _defineProperty3['default'])(_classNames, (0, _motion.getTransitionName)(motionName, status + '-active'), status !== STATUS_NONE && statusActive), (0, _defineProperty3['default'])(_classNames, motionName, typeof motionName === 'string'), _classNames)),
          style: statusStyle
        }), this.setNodeRef);
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(props, _ref) {
        var prevProps = _ref.prevProps,
            prevStatus = _ref.status;

        if (!isSupportTransition(props)) return {};

        var visible = props.visible,
            motionAppear = props.motionAppear,
            motionEnter = props.motionEnter,
            motionLeave = props.motionLeave,
            motionLeaveImmediately = props.motionLeaveImmediately;

        var newState = {
          prevProps: props
        };

        // Clean up status if prop set to false
        if (prevStatus === STATUS_APPEAR && !motionAppear || prevStatus === STATUS_ENTER && !motionEnter || prevStatus === STATUS_LEAVE && !motionLeave) {
          newState.status = STATUS_NONE;
          newState.statusActive = false;
          newState.newStatus = false;
        }

        // Appear
        if (!prevProps && visible && motionAppear) {
          newState.status = STATUS_APPEAR;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        // Enter
        if (prevProps && !prevProps.visible && visible && motionEnter) {
          newState.status = STATUS_ENTER;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        // Leave
        if (prevProps && prevProps.visible && !visible && motionLeave || !prevProps && motionLeaveImmediately && !visible && motionLeave) {
          newState.status = STATUS_LEAVE;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        return newState;
      }
    }]);
    return CSSMotion;
  }(_react2['default'].Component);

  CSSMotion.propTypes = (0, _extends3['default'])({}, MotionPropTypes, {

    internalRef: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].func])
  });
  CSSMotion.defaultProps = {
    visible: true,
    motionEnter: true,
    motionAppear: true,
    motionLeave: true,
    removeOnLeave: true
  };


  (0, _reactLifecyclesCompat.polyfill)(CSSMotion);

  if (!forwardRef) {
    return CSSMotion;
  }

  return _react2['default'].forwardRef(function (props, ref) {
    return _react2['default'].createElement(CSSMotion, (0, _extends3['default'])({ internalRef: ref }, props));
  });
}

exports['default'] = genCSSMotion(_motion.supportTransition);

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVendorPrefixes = getVendorPrefixes;
exports.getVendorPrefixedEventName = getVendorPrefixedEventName;
exports.getTransitionName = getTransitionName;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// ================= Transition =================
// Event wrapper. Copy from react source code
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

function getVendorPrefixes(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap('Animation', 'AnimationEnd'),
    transitionend: makePrefixMap('Transition', 'TransitionEnd')
  };

  if (domSupport) {
    if (!('AnimationEvent' in win)) {
      delete prefixes.animationend.animation;
    }

    if (!('TransitionEvent' in win)) {
      delete prefixes.transitionend.transition;
    }
  }

  return prefixes;
}

var vendorPrefixes = getVendorPrefixes(canUseDOM, typeof window !== 'undefined' ? window : {});

var style = {};

if (canUseDOM) {
  style = document.createElement('div').style;
}

var prefixedEventNames = {};

function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }

  var prefixMap = vendorPrefixes[eventName];

  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;
    for (var i = 0; i < len; i += 1) {
      var styleProp = stylePropList[i];
      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }

  return '';
}

var animationEndName = exports.animationEndName = getVendorPrefixedEventName('animationend');
var transitionEndName = exports.transitionEndName = getVendorPrefixedEventName('transitionend');
var supportTransition = exports.supportTransition = !!(animationEndName && transitionEndName);

function getTransitionName(transitionName, transitionType) {
  if (!transitionName) return null;

  if (typeof transitionName === 'object') {
    var type = transitionType.replace(/-\w/g, function (match) {
      return match[1].toUpperCase();
    });
    return transitionName[type];
  }

  return transitionName + '-' + transitionType;
}

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeContext = void 0;

var _createReactContext = _interopRequireDefault(__webpack_require__(156));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TreeContext = (0, _createReactContext.default)(null);
exports.TreeContext = TreeContext;

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFullKeyList = getFullKeyList;
exports.calcRangeKeys = calcRangeKeys;
exports.convertDirectoryKeysToNodes = convertDirectoryKeysToNodes;
exports.getFullKeyListByTreeData = getFullKeyListByTreeData;

var _util = __webpack_require__(368);

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Record;

(function (Record) {
  Record[Record["None"] = 0] = "None";
  Record[Record["Start"] = 1] = "Start";
  Record[Record["End"] = 2] = "End";
})(Record || (Record = {})); // TODO: Move this logic into `rc-tree`


function traverseNodesKey(rootChildren, callback) {
  var nodeList = (0, _util.getNodeChildren)(rootChildren) || [];

  function processNode(node) {
    var key = node.key,
        children = node.props.children;

    if (callback(key, node) !== false) {
      traverseNodesKey(children, callback);
    }
  }

  nodeList.forEach(processNode);
}

function getFullKeyList(children) {
  var _convertTreeToEntitie = (0, _util.convertTreeToEntities)(children),
      keyEntities = _convertTreeToEntitie.keyEntities;

  return Object.keys(keyEntities);
}
/** 计算选中范围，只考虑expanded情况以优化性能 */


function calcRangeKeys(rootChildren, expandedKeys, startKey, endKey) {
  var keys = [];
  var record = Record.None;

  if (startKey && startKey === endKey) {
    return [startKey];
  }

  if (!startKey || !endKey) {
    return [];
  }

  function matchKey(key) {
    return key === startKey || key === endKey;
  }

  traverseNodesKey(rootChildren, function (key) {
    if (record === Record.End) {
      return false;
    }

    if (matchKey(key)) {
      // Match test
      keys.push(key);

      if (record === Record.None) {
        record = Record.Start;
      } else if (record === Record.Start) {
        record = Record.End;
        return false;
      }
    } else if (record === Record.Start) {
      // Append selection
      keys.push(key);
    }

    if (expandedKeys.indexOf(key) === -1) {
      return false;
    }

    return true;
  });
  return keys;
}

function convertDirectoryKeysToNodes(rootChildren, keys) {
  var restKeys = _toConsumableArray(keys);

  var nodes = [];
  traverseNodesKey(rootChildren, function (key, node) {
    var index = restKeys.indexOf(key);

    if (index !== -1) {
      nodes.push(node);
      restKeys.splice(index, 1);
    }

    return !!restKeys.length;
  });
  return nodes;
}

function getFullKeyListByTreeData(treeData) {
  var keys = [];
  (treeData || []).forEach(function (item) {
    keys.push(item.key);

    if (item.children) {
      keys = [].concat(_toConsumableArray(keys), _toConsumableArray(getFullKeyListByTreeData(item.children)));
    }
  });
  return keys;
}

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _icon=__webpack_require__(38);var _icon2=_interopRequireDefault(_icon);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _tree=__webpack_require__(224);var _tree2=_interopRequireDefault(_tree);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(62);__webpack_require__(12);__webpack_require__(4);__webpack_require__(6);__webpack_require__(75);__webpack_require__(10);__webpack_require__(225);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _data=__webpack_require__(447);var _mobxReact=__webpack_require__(18);var _ExportPdf=__webpack_require__(735);var _ExportPdf2=_interopRequireDefault(_ExportPdf);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var TreeNode=_tree2.default.TreeNode;var authName=[{name:"GM/HM 总经理/酒店经理",value:"GM"},{name:"RM/EAM 驻店经理/行政助理经理",value:"EAM"},{name:"DOF 财务总监",value:"DOF"},{name:"FM 财务经理",value:"FIN"},{name:"Income Audit",value:"IA"},{name:"DHR 人力资源总监",value:"HR"},{name:"DOSM 市场营销总监",value:"SM"},{name:"DFB 餐饮总监",value:"FB"},{name:"DOC 宴会统筹总监",value:"BQT"},{name:"DOR 房务总监/EHK 行政管家/FOM 前厅经理",value:"Rooms"},{name:"DOE 工程总监",value:"ENG"},{name:"REVM 收益经理",value:"REV"},{name:"Training",value:"Training"}];var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getAuthData=function(){fetch('/getBpAuth?user='+_this.state.hotelAuthName,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){var checkedKeys=x.data[0].data.split(',');_this.setState({auth:x.data[0],checkedKeys:checkedKeys,authLoading:false});}else{_this.setState({auth:{},checkedKeys:[],authLoading:false});}}).catch(function(err){console.error(err);_this.setState({authLoading:false});});};_this.authshowModal=function(){if(_this.state.user.email!='admin'){_message3.default.error('权限不足！');return;}_this.setState({authVisible:true,authLoading:true});_this.getAuthData();};_this.authhandleOk=function(e){if(_this.state.user.email!='admin'){_message3.default.error('权限不足！');return;}_this.setState({loadingAuth:true});var checkedKeys=_this.state.checkedKeys;var hotelAuthName=_this.state.hotelAuthName;console.log(checkedKeys);var data=_extends({},_this.state.auth,{user:hotelAuthName,data:checkedKeys.toString()});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/addBpAuth',headres).then(function(x){return x.json();}).then(function(x){_this.setState({loadingAuth:false});if(x.status==1){_message3.default.success('保存成功');return;}_message3.default.error('保存失败！');}).catch(function(err){console.error(err);_this.setState({loadingAuth:false});});};_this.authhandleCancel=function(e){_this.setState({authVisible:false});};_this.onChange=function(value,lable,extra){// console.log('onchange', value, lable, extra)
_this.setState({selectAuth:value});};_this.onExpand=function(expandedKeys){// if not set autoExpandParent to false, if children expanded, parent can not collapse.
// or, you can remove all expanded children keys.
_this.setState({expandedKeys:expandedKeys,autoExpandParent:false});};_this.onCheck=function(checkedKeys,checkedNodes){_this.setState({checkedKeys:checkedKeys});};_this.onSelect=function(selectedKeys,info){_this.setState({selectedKeys:selectedKeys});};_this.renderTreeNodes=function(data){return data.map(function(item){if(item.children){return _react2.default.createElement(TreeNode,{title:item.title,key:item.key,dataRef:item},_this.renderTreeNodes(item.children));}return _react2.default.createElement(TreeNode,item);});};_this.state={user:{},data:[],visible:false,loadingSave:false,loading:true,hotel:{name:"",tel:"",address:"",contacts:""},loadingAuth:false,authData:[],authVisible:false,hotelAuthName:"FIN",expandedKeys:[],autoExpandParent:true,checkedKeys:[],selectedKeys:[],auth:{},authLoading:false,dataTotal:[]};return _this;}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;this.props.store.menu.getUserInfo().then(function(user){_this2.setState({user:user});}).catch(function(err){console.error(err);});}// 权限
},{key:"render",value:function render(){var _this3=this;return _react2.default.createElement("div",null,_react2.default.createElement("div",{onClick:this.authshowModal,style:{height:"100%",width:"100%"}},_react2.default.createElement(_icon2.default,{type:"setting",style:{marginRight:8}}),"\u6743\u9650\u8BBE\u7F6E"),_react2.default.createElement(_modal2.default,{title:"\u6743\u9650\u8BBE\u7F6E",visible:this.state.authVisible,onOk:this.authhandleOk,onCancel:this.authhandleCancel,footer:[_react2.default.createElement(_button2.default,{key:"back",onClick:this.authhandleCancel},"\u53D6\u6D88"),_react2.default.createElement(_button2.default,{key:"submit",type:"primary",loading:this.state.loadingAuth,onClick:this.authhandleOk},"\u4FDD\u5B58")]},_react2.default.createElement(_spin2.default,{spinning:this.state.authLoading},_react2.default.createElement(_row2.default,{className:"modal"},_react2.default.createElement(_row2.default,null,_react2.default.createElement("span",null,"\u9009\u62E9\u4EBA\u5458\uFF1A"),_react2.default.createElement(_select2.default,{value:this.state.hotelAuthName,style:{width:300},onChange:function onChange(value){_this3.setState({hotelAuthName:value,authLoading:true,checkedKeys:[]},function(){_this3.getAuthData();});}},authName.map(function(x,i){return _react2.default.createElement(Option,{key:x.value},x.name);}))),_react2.default.createElement(_row2.default,{className:"authCotent"},_react2.default.createElement(_row2.default,null,"\u6743\u9650\u914D\u7F6E"),_react2.default.createElement(_tree2.default,{checkable:true// checkStrictly={true}
,onExpand:this.onExpand,expandedKeys:this.state.expandedKeys,autoExpandParent:this.state.autoExpandParent,onCheck:this.onCheck,checkedKeys:this.state.checkedKeys,onSelect:this.onSelect,selectedKeys:this.state.selectedKeys},this.renderTreeNodes(_data.authData)))))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAq1BMVEUAAAD/41r/3lL/4FX/2k7/10j/zjv/yjT/0T//2Un/1EP/30z/5V7/10f/zjv/0Dz/1Uf/1kj/2Uv/5V7/zTn/10f/0kD/00L/zzz/2En/0UH/1EP/yzb/10v/2k3/yDL/2En/zzz/20//zzz/zTz/0T7/6WL/0kP/0D7/2Uz/0kD/1UX/00L/207/3FD/3lL/zjv/2En/1kf/31T/4ln/4Fb/zDj/yzX/yTJg1bXNAAAAKHRSTlMAoKCgoKCgoJ9/FQsEcPPt49qonopnLyL48eXcysiYmIV/fm9RQjk58XikuAAAANJJREFUGNNlz+cSgjAQBOATLDR7710TIYKg4Ps/mbcBcRz2V/LlZidHZc4nqsTtzpwKtkU0Ki/OhBBvIUQnH504tJE7j0/j202IPV5H7y3VpVxPyVsGjF2Xpqvs3SJDSTkf234AtY6dNMtylI/Y9wMURFGaAu+K8U+BWuNYF0AZzbDQXg+zwCZjCJR91+1jlpUxgSppE9l5LWPtleiCNm9a1DI+E60DokHxBeALqtTB/n7BAhaqd8As8MmzIRQ75DgEQn+bWXQZ1jimaRh1TgO5fgDpXS03awfKAwAAAABJRU5ErkJggg=="

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAUVBMVEUAAADR0dHQ0NDR0dHR0dHU1NTy8vLR0dHR0dHS0tLR0dHR0dHR0dHQ0NDS0tLV1dXT09PQ0NDQ0NDR0dHS0tLQ0NDS0tLT09PR0dHW1tbQ0NCv7DUhAAAAGnRSTlMAoH7ycAsE24kU7eOomDkvIuXKyIBoZlFCGWgVVQAAAABrSURBVBjTnc43FgJBEANRTY9fjwfd/6DQ8NhE2Vb4lQh7zwekPMSXYCIb/vUVXjmRscNbO2a2AuDOT+Zr44xAXjaU6jhkbGcyODLervwWUuQPpUM4joo15ypogAkmIAlOwCRIs4M/FZcgLW+BKxkxuwvPRgAAAABJRU5ErkJggg=="

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(25);__webpack_require__(60);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1117);var _data=__webpack_require__(1118);var _data2=_interopRequireDefault(_data);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _axios=__webpack_require__(86);var _axios2=_interopRequireDefault(_axios);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getDateData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var dataBegin,data,x;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;dataBegin=JSON.stringify(_data2.default);data=JSON.parse(dataBegin);_context.next=5;return _axios2.default.get('/api/cover?year='+(0,_moment2.default)(date).format('YYYY'));case 5:x=_context.sent;if(x.data&&x.data.length>0){if(x.data.length!=16&&(0,_moment2.default)(date).format('YYYY')>=2019){data=data.map(function(item,i){return _extends({},x.data[i],item);});}else{data=x.data;}}_this.setState({loading:false,data:data});_context.next=13;break;case 10:_context.prev=10;_context.t0=_context['catch'](0);_this.setState({loading:false});case 13:case'end':return _context.stop();}}},_callee,_this2,[[0,10]]);}));return function(_x){return _ref.apply(this,arguments);};}();_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var date,timer,year,data,res;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this.setState({loadingSave:true});date=_this.state.date;if(date){_context2.next=6;break;}_message3.default.error('请选择年份月份');timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return _context2.abrupt('return');case 6:year=(0,_moment2.default)(date).format("YYYY");data=_this.state.data.map(function(x){return _extends({},x,{year:year});});_context2.next=10;return _axios2.default.post('/api/coverSave',{data:data,year:year});case 10:res=_context2.sent;_this.setState({loadingSave:false});if(res.code==200){_message3.default.success('保存成功！');if(data[0]&&!data[0].id){_this.getDateData(_this.state.date);}}case 13:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table10',1.5,'0.00',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this3=this;return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table_cover table7_1_1'},_react2.default.createElement('div',{id:'table10',style:{paddingBottom:10}},_react2.default.createElement(_row2.default,{className:'title'},'Hotel Information \u9152\u5E97\u4FE1\u606F'),_react2.default.createElement(_row2.default,{className:'cover_month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY"),format:'YYYY',onChange:function onChange(date,str){_this3.setState({date:str,loading:true,data:[]});_this3.getDateData(str);}})),_react2.default.createElement(_row2.default,{className:'content'},_react2.default.createElement(_row2.default,{className:'row'},_react2.default.createElement(_col2.default,{span:6,className:'col_border col_border_input'},'\u540D\u79F0'),_react2.default.createElement(_col2.default,{span:6,className:'col_border col_border_input'},'\u5185\u5BB9'),_react2.default.createElement(_col2.default,{span:6,className:'col_border col_border_input'},'\u7535\u8BDD'),_react2.default.createElement(_col2.default,{span:6,className:'col_border col_border_input'},'\u90AE\u7BB1')),this.state.data.map(function(x,i){var _reTimeReg=/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/;return _react2.default.createElement(_row2.default,{className:'row',key:i},_react2.default.createElement(_col2.default,{span:6,className:'col_border'},x.name),_react2.default.createElement(_col2.default,{span:6,className:'col_border col_border_input'},_react2.default.createElement(_Compared2.default,{data:{index:i,key:'value',title:"",sqlName:"_cover",name:x.name,type:'text'}},i===4?_react2.default.createElement(_datePicker2.default,{value:_reTimeReg.test(x.value)?(0,_moment2.default)(x.value,'YYYY-MM-DD'):(0,_moment2.default)(new Date(),'YYYY-MM-DD'),placeholder:'\u8BF7\u9009\u62E9\u65F6\u95F4\uFF01',style:{width:"100%"},onChange:function onChange(date,str){var data=_this3.state.data;data[i].value=str;_this3.setState({data:data});}}):_react2.default.createElement(_input2.default,{value:x.value,placeholder:'\u8BF7\u8F93\u5165\uFF01',onChange:function onChange(e){var value=e.target.value||"";var data=_this3.state.data;data[i].value=value;_this3.setState({data:data});}}))),_react2.default.createElement(_col2.default,{span:6,className:'col_border col_border_input'},i>4&&_react2.default.createElement(_Compared2.default,{data:{index:i,key:'tel',title:"",sqlName:"_cover",name:x.name,type:'text'}},_react2.default.createElement(_input2.default,{value:x.tel,placeholder:'\u8BF7\u8F93\u5165\u7535\u8BDD\uFF01',onChange:function onChange(e){var value=e.target.value||"";var data=_this3.state.data;data[i].tel=value;_this3.setState({data:data});}}))),_react2.default.createElement(_col2.default,{span:6,className:'col_border col_border_input'},i>4&&_react2.default.createElement(_Compared2.default,{data:{index:i,key:'email',title:"",sqlName:"_cover",name:x.name,type:'text'}},_react2.default.createElement(_input2.default,{value:x.email,placeholder:'\u8BF7\u8F93\u5165\u90AE\u7BB1\uFF01',onChange:function onChange(e){var value=e.target.value||"";var data=_this3.state.data;data[i].email=value;_this3.setState({data:data});}}))));}))),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_cover'},_react2.default.createElement(_row2.default,{className:'table-footer-btn',style:{paddingRight:24}},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var dataDefault=[{name:"Hotel Name 酒店名称:",value:"",tel:"",email:""},{tel:"",email:"",name:"Brand Tier 品牌体系:",value:""},{name:"Site Number 酒店编号:",tel:"",email:"",value:""},{name:"Available Rooms 客房数:",tel:"",email:"",value:""},{name:"Date of Open 开业日期: ",tel:"",email:"",value:""},{name:"GM/HM 总经理/酒店经理: ",tel:"",email:"",value:""},{name:"RM/EAM 驻店经理/行政助理经理: ",tel:"",email:"",value:""},{name:"DOF/FM 财务总监/财务经理: ",tel:"",email:"",value:""},{name:"DHR 人力资源总监: ",tel:"",email:"",value:""},{name:"DOSM 市场营销总监: ",tel:"",email:"",value:""},{name:"DFB 餐饮总监: ",tel:"",email:"",value:""},{name:"DOC 宴会统筹总监: ",tel:"",email:"",value:""},{name:"DOR 房务总监/EHK 行政管家: ",tel:"",email:"",value:""},{name:"FOM 前厅经理: ",tel:"",email:"",value:""},{name:"DOE 工程总监:",tel:"",email:"",value:""},{name:"REVM 收益经理: ",tel:"",email:"",value:""}];exports.default=dataDefault;

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(1120);

__webpack_require__(1317);

__webpack_require__(1318);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1121);
__webpack_require__(1124);
__webpack_require__(1125);
__webpack_require__(1126);
__webpack_require__(1127);
__webpack_require__(1128);
__webpack_require__(1129);
__webpack_require__(1130);
__webpack_require__(1131);
__webpack_require__(1132);
__webpack_require__(1133);
__webpack_require__(1134);
__webpack_require__(1135);
__webpack_require__(1136);
__webpack_require__(1137);
__webpack_require__(1138);
__webpack_require__(1139);
__webpack_require__(1140);
__webpack_require__(1141);
__webpack_require__(1142);
__webpack_require__(1143);
__webpack_require__(1144);
__webpack_require__(1145);
__webpack_require__(1146);
__webpack_require__(1147);
__webpack_require__(1148);
__webpack_require__(1149);
__webpack_require__(1150);
__webpack_require__(1151);
__webpack_require__(1152);
__webpack_require__(1153);
__webpack_require__(1154);
__webpack_require__(1155);
__webpack_require__(1156);
__webpack_require__(1157);
__webpack_require__(1158);
__webpack_require__(1159);
__webpack_require__(1160);
__webpack_require__(1161);
__webpack_require__(1162);
__webpack_require__(1163);
__webpack_require__(1164);
__webpack_require__(1165);
__webpack_require__(1166);
__webpack_require__(1167);
__webpack_require__(1168);
__webpack_require__(1169);
__webpack_require__(1170);
__webpack_require__(1171);
__webpack_require__(1172);
__webpack_require__(1173);
__webpack_require__(1174);
__webpack_require__(1175);
__webpack_require__(1176);
__webpack_require__(1177);
__webpack_require__(1178);
__webpack_require__(1179);
__webpack_require__(1180);
__webpack_require__(1181);
__webpack_require__(1182);
__webpack_require__(1183);
__webpack_require__(1184);
__webpack_require__(1185);
__webpack_require__(1186);
__webpack_require__(1187);
__webpack_require__(1188);
__webpack_require__(1189);
__webpack_require__(1190);
__webpack_require__(1191);
__webpack_require__(1192);
__webpack_require__(1193);
__webpack_require__(1194);
__webpack_require__(1195);
__webpack_require__(1196);
__webpack_require__(1197);
__webpack_require__(1198);
__webpack_require__(1199);
__webpack_require__(1201);
__webpack_require__(1202);
__webpack_require__(1204);
__webpack_require__(1205);
__webpack_require__(1206);
__webpack_require__(1207);
__webpack_require__(1208);
__webpack_require__(1209);
__webpack_require__(1210);
__webpack_require__(1212);
__webpack_require__(1213);
__webpack_require__(1214);
__webpack_require__(1215);
__webpack_require__(1216);
__webpack_require__(1217);
__webpack_require__(1218);
__webpack_require__(1219);
__webpack_require__(1220);
__webpack_require__(1221);
__webpack_require__(1222);
__webpack_require__(1223);
__webpack_require__(1224);
__webpack_require__(389);
__webpack_require__(1225);
__webpack_require__(560);
__webpack_require__(1226);
__webpack_require__(561);
__webpack_require__(1227);
__webpack_require__(1228);
__webpack_require__(1229);
__webpack_require__(1230);
__webpack_require__(1231);
__webpack_require__(564);
__webpack_require__(566);
__webpack_require__(567);
__webpack_require__(1232);
__webpack_require__(1233);
__webpack_require__(1234);
__webpack_require__(1235);
__webpack_require__(1236);
__webpack_require__(1237);
__webpack_require__(1238);
__webpack_require__(1239);
__webpack_require__(1240);
__webpack_require__(1241);
__webpack_require__(1242);
__webpack_require__(1243);
__webpack_require__(1244);
__webpack_require__(1245);
__webpack_require__(1246);
__webpack_require__(1247);
__webpack_require__(1248);
__webpack_require__(1249);
__webpack_require__(1250);
__webpack_require__(1251);
__webpack_require__(1252);
__webpack_require__(1253);
__webpack_require__(1254);
__webpack_require__(1255);
__webpack_require__(1256);
__webpack_require__(1257);
__webpack_require__(1258);
__webpack_require__(1259);
__webpack_require__(1260);
__webpack_require__(1261);
__webpack_require__(1262);
__webpack_require__(1263);
__webpack_require__(1264);
__webpack_require__(1265);
__webpack_require__(1266);
__webpack_require__(1267);
__webpack_require__(1268);
__webpack_require__(1269);
__webpack_require__(1270);
__webpack_require__(1271);
__webpack_require__(1272);
__webpack_require__(1273);
__webpack_require__(1274);
__webpack_require__(1275);
__webpack_require__(1276);
__webpack_require__(1277);
__webpack_require__(1278);
__webpack_require__(1279);
__webpack_require__(1280);
__webpack_require__(1281);
__webpack_require__(1282);
__webpack_require__(1283);
__webpack_require__(1284);
__webpack_require__(1285);
__webpack_require__(1286);
__webpack_require__(1287);
__webpack_require__(1288);
__webpack_require__(1289);
__webpack_require__(1290);
__webpack_require__(1291);
__webpack_require__(1292);
__webpack_require__(1293);
__webpack_require__(1294);
__webpack_require__(1295);
__webpack_require__(1296);
__webpack_require__(1297);
__webpack_require__(1298);
__webpack_require__(1299);
__webpack_require__(1300);
__webpack_require__(1301);
__webpack_require__(1302);
__webpack_require__(1303);
__webpack_require__(1304);
__webpack_require__(1305);
__webpack_require__(1306);
__webpack_require__(1307);
__webpack_require__(1308);
__webpack_require__(1309);
__webpack_require__(1310);
__webpack_require__(1311);
__webpack_require__(1312);
__webpack_require__(1313);
__webpack_require__(1314);
__webpack_require__(1315);
__webpack_require__(1316);
module.exports = __webpack_require__(102);


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(49);
var has = __webpack_require__(94);
var DESCRIPTORS = __webpack_require__(63);
var $export = __webpack_require__(15);
var redefine = __webpack_require__(91);
var META = __webpack_require__(145).KEY;
var $fails = __webpack_require__(51);
var shared = __webpack_require__(226);
var setToStringTag = __webpack_require__(198);
var uid = __webpack_require__(161);
var wks = __webpack_require__(56);
var wksExt = __webpack_require__(542);
var wksDefine = __webpack_require__(370);
var enumKeys = __webpack_require__(1123);
var isArray = __webpack_require__(275);
var anObject = __webpack_require__(45);
var isObject = __webpack_require__(52);
var toObject = __webpack_require__(70);
var toIObject = __webpack_require__(95);
var toPrimitive = __webpack_require__(117);
var createDesc = __webpack_require__(160);
var _create = __webpack_require__(164);
var gOPNExt = __webpack_require__(545);
var $GOPD = __webpack_require__(96);
var $GOPS = __webpack_require__(274);
var $DP = __webpack_require__(66);
var $keys = __webpack_require__(162);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(165).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(228).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(144)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(90)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(226)('native-function-to-string', Function.toString);


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(162);
var gOPS = __webpack_require__(274);
var pIE = __webpack_require__(228);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(15);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(164) });


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(15);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(63), 'Object', { defineProperty: __webpack_require__(66).f });


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(15);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(63), 'Object', { defineProperties: __webpack_require__(544) });


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(95);
var $getOwnPropertyDescriptor = __webpack_require__(96).f;

__webpack_require__(119)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(70);
var $getPrototypeOf = __webpack_require__(97);

__webpack_require__(119)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(70);
var $keys = __webpack_require__(162);

__webpack_require__(119)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(119)('getOwnPropertyNames', function () {
  return __webpack_require__(545).f;
});


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(52);
var meta = __webpack_require__(145).onFreeze;

__webpack_require__(119)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(52);
var meta = __webpack_require__(145).onFreeze;

__webpack_require__(119)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(52);
var meta = __webpack_require__(145).onFreeze;

__webpack_require__(119)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(52);

__webpack_require__(119)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(52);

__webpack_require__(119)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(52);

__webpack_require__(119)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(15);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(546) });


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(15);
$export($export.S, 'Object', { is: __webpack_require__(547) });


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(15);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(374).set });


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(199);
var test = {};
test[__webpack_require__(56)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(91)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(15);

$export($export.P, 'Function', { bind: __webpack_require__(548) });


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(66).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(63) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(52);
var getPrototypeOf = __webpack_require__(97);
var HAS_INSTANCE = __webpack_require__(56)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(66).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(15);
var $parseInt = __webpack_require__(550);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(15);
var $parseFloat = __webpack_require__(551);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(49);
var has = __webpack_require__(94);
var cof = __webpack_require__(104);
var inheritIfRequired = __webpack_require__(376);
var toPrimitive = __webpack_require__(117);
var fails = __webpack_require__(51);
var gOPN = __webpack_require__(165).f;
var gOPD = __webpack_require__(96).f;
var dP = __webpack_require__(66).f;
var $trim = __webpack_require__(200).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(164)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(63) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(91)(global, NUMBER, $Number);
}


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(15);
var toInteger = __webpack_require__(105);
var aNumberValue = __webpack_require__(552);
var repeat = __webpack_require__(377);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(51)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(15);
var $fails = __webpack_require__(51);
var aNumberValue = __webpack_require__(552);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(15);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(15);
var _isFinite = __webpack_require__(49).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(15);

$export($export.S, 'Number', { isInteger: __webpack_require__(553) });


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(15);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(15);
var isInteger = __webpack_require__(553);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(15);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(15);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(15);
var $parseFloat = __webpack_require__(551);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(15);
var $parseInt = __webpack_require__(550);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(15);
var log1p = __webpack_require__(554);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(15);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(15);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(15);
var sign = __webpack_require__(378);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(15);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(15);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(15);
var $expm1 = __webpack_require__(379);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(15);

$export($export.S, 'Math', { fround: __webpack_require__(555) });


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(15);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(15);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(51)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(15);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(15);

$export($export.S, 'Math', { log1p: __webpack_require__(554) });


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(15);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(15);

$export($export.S, 'Math', { sign: __webpack_require__(378) });


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(15);
var expm1 = __webpack_require__(379);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(51)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(15);
var expm1 = __webpack_require__(379);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(15);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(15);
var toAbsoluteIndex = __webpack_require__(163);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(15);
var toIObject = __webpack_require__(95);
var toLength = __webpack_require__(58);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(200)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(276)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(380)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(15);
var $at = __webpack_require__(276)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(15);
var toLength = __webpack_require__(58);
var context = __webpack_require__(382);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(383)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(15);
var context = __webpack_require__(382);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(383)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(15);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(377)
});


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(15);
var toLength = __webpack_require__(58);
var context = __webpack_require__(382);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(383)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(92)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(92)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(92)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(92)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(92)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(92)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(92)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(92)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(92)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(92)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(92)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(92)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(92)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(15);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(15);
var toObject = __webpack_require__(70);
var toPrimitive = __webpack_require__(117);

$export($export.P + $export.F * __webpack_require__(51)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(15);
var toISOString = __webpack_require__(1200);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(51);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(91)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(56)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(90)(proto, TO_PRIMITIVE, __webpack_require__(1203));


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(45);
var toPrimitive = __webpack_require__(117);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(15);

$export($export.S, 'Array', { isArray: __webpack_require__(275) });


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(103);
var $export = __webpack_require__(15);
var toObject = __webpack_require__(70);
var call = __webpack_require__(556);
var isArrayIter = __webpack_require__(384);
var toLength = __webpack_require__(58);
var createProperty = __webpack_require__(385);
var getIterFn = __webpack_require__(386);

$export($export.S + $export.F * !__webpack_require__(278)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(15);
var createProperty = __webpack_require__(385);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(51)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(15);
var toIObject = __webpack_require__(95);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(227) != Object || !__webpack_require__(106)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(15);
var html = __webpack_require__(373);
var cof = __webpack_require__(104);
var toAbsoluteIndex = __webpack_require__(163);
var toLength = __webpack_require__(58);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(51)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(15);
var aFunction = __webpack_require__(81);
var toObject = __webpack_require__(70);
var fails = __webpack_require__(51);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(106)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(15);
var $forEach = __webpack_require__(120)(0);
var STRICT = __webpack_require__(106)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(52);
var isArray = __webpack_require__(275);
var SPECIES = __webpack_require__(56)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(15);
var $map = __webpack_require__(120)(1);

$export($export.P + $export.F * !__webpack_require__(106)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(15);
var $filter = __webpack_require__(120)(2);

$export($export.P + $export.F * !__webpack_require__(106)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(15);
var $some = __webpack_require__(120)(3);

$export($export.P + $export.F * !__webpack_require__(106)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(15);
var $every = __webpack_require__(120)(4);

$export($export.P + $export.F * !__webpack_require__(106)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(15);
var $reduce = __webpack_require__(557);

$export($export.P + $export.F * !__webpack_require__(106)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(15);
var $reduce = __webpack_require__(557);

$export($export.P + $export.F * !__webpack_require__(106)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(15);
var $indexOf = __webpack_require__(273)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(106)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(15);
var toIObject = __webpack_require__(95);
var toInteger = __webpack_require__(105);
var toLength = __webpack_require__(58);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(106)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(15);

$export($export.P, 'Array', { copyWithin: __webpack_require__(558) });

__webpack_require__(146)('copyWithin');


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(15);

$export($export.P, 'Array', { fill: __webpack_require__(388) });

__webpack_require__(146)('fill');


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(15);
var $find = __webpack_require__(120)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(146)(KEY);


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(15);
var $find = __webpack_require__(120)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(146)(KEY);


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(166)('Array');


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(49);
var inheritIfRequired = __webpack_require__(376);
var dP = __webpack_require__(66).f;
var gOPN = __webpack_require__(165).f;
var isRegExp = __webpack_require__(277);
var $flags = __webpack_require__(229);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(63) && (!CORRECT_NEW || __webpack_require__(51)(function () {
  re2[__webpack_require__(56)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(91)(global, 'RegExp', $RegExp);
}

__webpack_require__(166)('RegExp');


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(561);
var anObject = __webpack_require__(45);
var $flags = __webpack_require__(229);
var DESCRIPTORS = __webpack_require__(63);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(91)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(51)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(45);
var toLength = __webpack_require__(58);
var advanceStringIndex = __webpack_require__(391);
var regExpExec = __webpack_require__(279);

// @@match logic
__webpack_require__(280)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(45);
var toObject = __webpack_require__(70);
var toLength = __webpack_require__(58);
var toInteger = __webpack_require__(105);
var advanceStringIndex = __webpack_require__(391);
var regExpExec = __webpack_require__(279);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(280)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(45);
var sameValue = __webpack_require__(547);
var regExpExec = __webpack_require__(279);

// @@search logic
__webpack_require__(280)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(277);
var anObject = __webpack_require__(45);
var speciesConstructor = __webpack_require__(230);
var advanceStringIndex = __webpack_require__(391);
var toLength = __webpack_require__(58);
var callRegExpExec = __webpack_require__(279);
var regexpExec = __webpack_require__(390);
var fails = __webpack_require__(51);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(280)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(144);
var global = __webpack_require__(49);
var ctx = __webpack_require__(103);
var classof = __webpack_require__(199);
var $export = __webpack_require__(15);
var isObject = __webpack_require__(52);
var aFunction = __webpack_require__(81);
var anInstance = __webpack_require__(167);
var forOf = __webpack_require__(168);
var speciesConstructor = __webpack_require__(230);
var task = __webpack_require__(392).set;
var microtask = __webpack_require__(393)();
var newPromiseCapabilityModule = __webpack_require__(394);
var perform = __webpack_require__(562);
var userAgent = __webpack_require__(281);
var promiseResolve = __webpack_require__(563);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(56)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(169)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(198)($Promise, PROMISE);
__webpack_require__(166)(PROMISE);
Wrapper = __webpack_require__(102)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(278)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(568);
var validate = __webpack_require__(170);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(282)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(15);
var $typed = __webpack_require__(283);
var buffer = __webpack_require__(395);
var anObject = __webpack_require__(45);
var toAbsoluteIndex = __webpack_require__(163);
var toLength = __webpack_require__(58);
var isObject = __webpack_require__(52);
var ArrayBuffer = __webpack_require__(49).ArrayBuffer;
var speciesConstructor = __webpack_require__(230);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(51)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(166)(ARRAY_BUFFER);


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(15);
$export($export.G + $export.W + $export.F * !__webpack_require__(283).ABV, {
  DataView: __webpack_require__(395).DataView
});


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(15);
var aFunction = __webpack_require__(81);
var anObject = __webpack_require__(45);
var rApply = (__webpack_require__(49).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(51)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(15);
var create = __webpack_require__(164);
var aFunction = __webpack_require__(81);
var anObject = __webpack_require__(45);
var isObject = __webpack_require__(52);
var fails = __webpack_require__(51);
var bind = __webpack_require__(548);
var rConstruct = (__webpack_require__(49).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(66);
var $export = __webpack_require__(15);
var anObject = __webpack_require__(45);
var toPrimitive = __webpack_require__(117);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(51)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(15);
var gOPD = __webpack_require__(96).f;
var anObject = __webpack_require__(45);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(15);
var anObject = __webpack_require__(45);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(381)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(96);
var getPrototypeOf = __webpack_require__(97);
var has = __webpack_require__(94);
var $export = __webpack_require__(15);
var isObject = __webpack_require__(52);
var anObject = __webpack_require__(45);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(96);
var $export = __webpack_require__(15);
var anObject = __webpack_require__(45);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(15);
var getProto = __webpack_require__(97);
var anObject = __webpack_require__(45);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(15);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(15);
var anObject = __webpack_require__(45);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(15);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(570) });


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(15);
var anObject = __webpack_require__(45);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(66);
var gOPD = __webpack_require__(96);
var getPrototypeOf = __webpack_require__(97);
var has = __webpack_require__(94);
var $export = __webpack_require__(15);
var createDesc = __webpack_require__(160);
var anObject = __webpack_require__(45);
var isObject = __webpack_require__(52);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(15);
var setProto = __webpack_require__(374);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(15);
var $includes = __webpack_require__(273)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(146)('includes');


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(15);
var flattenIntoArray = __webpack_require__(571);
var toObject = __webpack_require__(70);
var toLength = __webpack_require__(58);
var aFunction = __webpack_require__(81);
var arraySpeciesCreate = __webpack_require__(387);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(146)('flatMap');


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(15);
var flattenIntoArray = __webpack_require__(571);
var toObject = __webpack_require__(70);
var toLength = __webpack_require__(58);
var toInteger = __webpack_require__(105);
var arraySpeciesCreate = __webpack_require__(387);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(146)('flatten');


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(15);
var $at = __webpack_require__(276)(true);
var $fails = __webpack_require__(51);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(15);
var $pad = __webpack_require__(572);
var userAgent = __webpack_require__(281);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(15);
var $pad = __webpack_require__(572);
var userAgent = __webpack_require__(281);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(200)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(200)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(15);
var defined = __webpack_require__(118);
var toLength = __webpack_require__(58);
var isRegExp = __webpack_require__(277);
var getFlags = __webpack_require__(229);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(381)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(370)('asyncIterator');


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(370)('observable');


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(15);
var ownKeys = __webpack_require__(570);
var toIObject = __webpack_require__(95);
var gOPD = __webpack_require__(96);
var createProperty = __webpack_require__(385);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(15);
var $values = __webpack_require__(573)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(15);
var $entries = __webpack_require__(573)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(15);
var toObject = __webpack_require__(70);
var aFunction = __webpack_require__(81);
var $defineProperty = __webpack_require__(66);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(63) && $export($export.P + __webpack_require__(284), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(15);
var toObject = __webpack_require__(70);
var aFunction = __webpack_require__(81);
var $defineProperty = __webpack_require__(66);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(63) && $export($export.P + __webpack_require__(284), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(15);
var toObject = __webpack_require__(70);
var toPrimitive = __webpack_require__(117);
var getPrototypeOf = __webpack_require__(97);
var getOwnPropertyDescriptor = __webpack_require__(96).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(63) && $export($export.P + __webpack_require__(284), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(15);
var toObject = __webpack_require__(70);
var toPrimitive = __webpack_require__(117);
var getPrototypeOf = __webpack_require__(97);
var getOwnPropertyDescriptor = __webpack_require__(96).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(63) && $export($export.P + __webpack_require__(284), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(15);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(574)('Map') });


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(15);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(574)('Set') });


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(285)('Map');


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(285)('Set');


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(285)('WeakMap');


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(285)('WeakSet');


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(286)('Map');


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(286)('Set');


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(286)('WeakMap');


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(286)('WeakSet');


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(15);

$export($export.G, { global: __webpack_require__(49) });


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(15);

$export($export.S, 'System', { global: __webpack_require__(49) });


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(15);
var cof = __webpack_require__(104);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(15);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(15);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(15);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(15);
var scale = __webpack_require__(576);
var fround = __webpack_require__(555);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(15);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(15);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(15);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(15);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(15);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(15);

$export($export.S, 'Math', { scale: __webpack_require__(576) });


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(15);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(15);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(15);
var core = __webpack_require__(102);
var global = __webpack_require__(49);
var speciesConstructor = __webpack_require__(230);
var promiseResolve = __webpack_require__(563);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(15);
var newPromiseCapability = __webpack_require__(394);
var perform = __webpack_require__(562);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(134);
var anObject = __webpack_require__(45);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(134);
var anObject = __webpack_require__(45);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(134);
var anObject = __webpack_require__(45);
var getPrototypeOf = __webpack_require__(97);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(566);
var from = __webpack_require__(575);
var metadata = __webpack_require__(134);
var anObject = __webpack_require__(45);
var getPrototypeOf = __webpack_require__(97);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(134);
var anObject = __webpack_require__(45);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(134);
var anObject = __webpack_require__(45);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(134);
var anObject = __webpack_require__(45);
var getPrototypeOf = __webpack_require__(97);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(134);
var anObject = __webpack_require__(45);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(134);
var anObject = __webpack_require__(45);
var aFunction = __webpack_require__(81);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(15);
var microtask = __webpack_require__(393)();
var process = __webpack_require__(49).process;
var isNode = __webpack_require__(104)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(15);
var global = __webpack_require__(49);
var core = __webpack_require__(102);
var microtask = __webpack_require__(393)();
var OBSERVABLE = __webpack_require__(56)('observable');
var aFunction = __webpack_require__(81);
var anObject = __webpack_require__(45);
var anInstance = __webpack_require__(167);
var redefineAll = __webpack_require__(169);
var hide = __webpack_require__(90);
var forOf = __webpack_require__(168);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(166)('Observable');


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(49);
var $export = __webpack_require__(15);
var userAgent = __webpack_require__(281);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(15);
var $task = __webpack_require__(392);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(389);
var getKeys = __webpack_require__(162);
var redefine = __webpack_require__(91);
var global = __webpack_require__(49);
var hide = __webpack_require__(90);
var Iterators = __webpack_require__(201);
var wks = __webpack_require__(56);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1319);
module.exports = __webpack_require__(102).RegExp.escape;


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(15);
var $re = __webpack_require__(1320)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 1320 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 1321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1323);

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);
var bind = __webpack_require__(577);
var Axios = __webpack_require__(1324);
var mergeConfig = __webpack_require__(584);
var defaults = __webpack_require__(397);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(288);
axios.CancelToken = __webpack_require__(1342);
axios.isCancel = __webpack_require__(583);
axios.VERSION = __webpack_require__(585).version;
axios.toFormData = __webpack_require__(580);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(202);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(1343);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(1344);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);
var buildURL = __webpack_require__(578);
var InterceptorManager = __webpack_require__(1325);
var dispatchRequest = __webpack_require__(1326);
var mergeConfig = __webpack_require__(584);
var buildFullPath = __webpack_require__(582);
var validator = __webpack_require__(1341);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);
var transformData = __webpack_require__(1327);
var isCancel = __webpack_require__(583);
var defaults = __webpack_require__(397);
var CanceledError = __webpack_require__(288);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);
var defaults = __webpack_require__(397);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1330)
var ieee754 = __webpack_require__(1331)
var isArray = __webpack_require__(1332)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 1331 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1332 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(202);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),
/* 1340 */
/***/ (function(module, exports) {

// eslint-disable-next-line strict
module.exports = null;


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var VERSION = __webpack_require__(585).version;
var AxiosError = __webpack_require__(202);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var CanceledError = __webpack_require__(288);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(8);__webpack_require__(6);__webpack_require__(25);__webpack_require__(10);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);__webpack_require__(1346);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={data:[],dataAll:[],name:"",selectedRowKeys:[],id:''},_this.getData=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var res,saveRes;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return(0,_request2.default)('/getHotels');case 3:res=_context.sent;_context.next=6;return(0,_request2.default)('/api/getBpSave');case 6:saveRes=_context.sent;_this.setState({id:saveRes.data.id,data:res.data.hotels||[],dataAll:res.data.hotels||[],selectedRowKeys:(saveRes.data.hotels||'').split(',').map(function(x){return~~x;})});_context.next=14;break;case 10:_context.prev=10;_context.t0=_context['catch'](0);_message3.default.error('获取列表失败！');console.error(_context.t0);case 14:case'end':return _context.stop();}}},_callee,_this2,[[0,10]]);})),_this.onSearch=function(){var _this$state=_this.state,name=_this$state.name,dataAll=_this$state.dataAll;var names=(name||"").split(" ").filter(function(x){return x;});var data=dataAll.filter(function(x){var _name=(x.name||"").trim().toUpperCase();var code=(x.code||"").trim().toUpperCase();var area=(x.area||"").trim().toUpperCase();return names.some(function(v){return _name.includes(v.toUpperCase())||code.includes(v.toUpperCase())||area.includes(v.toUpperCase());});});_this.setState({data:data});},_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var headres,res;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;headres={method:'post',credentials:'include',headers:{'Content-Type':'application/json;charset=utf-8'},body:JSON.stringify({data:{id:_this.state.id,hotels:_this.state.selectedRowKeys.join()}})};_context2.next=4;return(0,_request2.default)('/api/saveBpSave',headres);case 4:res=_context2.sent;if(res.status==1)_message3.default.info('保存成功！');_context2.next=12;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](0);_message3.default.error('获取列表失败！');console.error(_context2.t0);case 12:case'end':return _context2.stop();}}},_callee2,_this2,[[0,8]]);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData();}},{key:'render',value:function render(){var _this3=this;var _state=this.state,data=_state.data,selectedRowKeys=_state.selectedRowKeys,name=_state.name,dataAll=_state.dataAll;var columns=[{title:'序号',dataIndex:'id',key:'id'},{title:'酒店名称',dataIndex:'name',key:'name'},{title:'千乘code',dataIndex:'code',key:'code'}];return _react2.default.createElement('div',{className:'bp-save'},_react2.default.createElement('div',{className:'top-search'},_react2.default.createElement('div',{className:'item'},_react2.default.createElement('span',{className:'name'},'\u5173\u8054\u5B57'),_react2.default.createElement(_input2.default,{value:name,onPressEnter:this.onSearch,onChange:function onChange(e){_this3.setState({name:e.target.value});},placeholder:'\u8BF7\u8F93\u5165\u5173\u952E\u5B57,\u591A\u4E2A\u5173\u8054\u5B57\u7528\u7A7A\u683C\u5206\u5F00'})),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSearch},'\u641C\u7D22')),_react2.default.createElement('div',{className:'row'},_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){_this3.setState({selectedRowKeys:dataAll.map(function(x){return x.id;})});}},'\u5168\u9009'),_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){_this3.setState({selectedRowKeys:dataAll.filter(function(x){return!selectedRowKeys.includes(x.id);}).map(function(x){return x.id;})});}},'\u53CD\u9009')),_react2.default.createElement(_table2.default,{rowSelection:{selectedRowKeys:selectedRowKeys,type:"checkbox",onChange:function onChange(selectedRowKeys,selectedRows){_this3.setState({selectedRowKeys:selectedRowKeys});}},rowKey:function rowKey(r){return r.id;},columns:columns,dataSource:data}),_react2.default.createElement('div',{className:'bottom-btn'},_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave},'\u4FDD\u5B58')));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _switch=__webpack_require__(249);var _switch2=_interopRequireDefault(_switch);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _popconfirm=__webpack_require__(110);var _popconfirm2=_interopRequireDefault(_popconfirm);var _icon=__webpack_require__(38);var _icon2=_interopRequireDefault(_icon);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(60);__webpack_require__(25);__webpack_require__(8);__webpack_require__(6);__webpack_require__(250);__webpack_require__(4);__webpack_require__(111);__webpack_require__(75);__webpack_require__(10);__webpack_require__(62);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(1351);var _Auth=__webpack_require__(1352);var _Auth2=_interopRequireDefault(_Auth);var _mobxReact=__webpack_require__(18);var _method=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var confirm=_modal2.default.confirm;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getData=function(){_this.setState({loading:true});fetch('/getEComGroup',{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this.setState({loading:false});if(x.status==1){_this.setState({data:(x.data.group||[]).reverse(),compared:x.data.compared||[]});return;}_message3.default.error('数据获取失败！'+JSON.stringify(x.msg));}).catch(function(err){_this.setState({loading:false});console.error(err);_message3.default.error('数据获取失败！'+JSON.stringify(err));});};_this.onDelete=function(id){fetch('/deleteEGroup?id='+id,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.status==1){_message3.default.info('删除成功！');_this.getData();return;}_message3.default.error(x.msg);}).catch(function(err){console.error(err);});};_this.showModal=function(){_this.setState({visible:true});};_this.handleOk=function(){_this.setState({loadingSave:true});var that=_this;var _this$state=_this.state,compared=_this$state.compared,dataCompared=_this$state.dataCompared,selectedRowKeys=_this$state.selectedRowKeys;var data=dataCompared;data.hotels=selectedRowKeys.toString();// 筛选是否全是同一类型，m_为每日经营报表月度汇总  内容包含daily
var isAllDay=compared.every(function(x){return x.sqlName.includes('daily')&&!x.sqlName.includes('m_');});if(!data.name){_message3.default.error('请输入表格标题！');that.setState({loadingSave:false});return;}if(data.hotels.length<=0){_message3.default.error('请选择酒店！');that.setState({loadingSave:false});return;}if(compared.length<=0&&!data.id){_message3.default.error('已添加数据为零，无法保存！');that.setState({loadingSave:false});return;}if(isAllDay){confirm({title:'请选择保存月度还是每日报表?',content:'选中的表格中包括每日报表，与月度报表冲突，请选择保存！',okText:"保存月度报表",cancelText:"保存每日报表",onOk:function onOk(){save('month');},onCancel:function onCancel(){save('day');}});}else{save('month');}function save(){var type=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"month";data.add_time=(0,_moment2.default)().format('YYYY-MM-DD HH:mm:ss');data.type=type;var headres={method:'post',credentials:'include',headers:{},body:JSON.stringify(data)};fetch('/addEGroup',headres).then(function(x){return x.json();}).then(function(x){that.setState({loadingSave:false});if(x.status==1){_message3.default.info('保存成功！');that.setState({visible:false,selectedRowKeys:[],compared:{name:"",note:""}});that.getData();return;}_message3.default.error('保存失败！');}).catch(function(err){that.setState({loadingSave:false});console.error(err);});}};_this.state={data:[],loading:true,visible:false,dataCompared:{name:"",note:""},compared:[],loadingSave:false,hotel:[],hotelTotal:[],name:"",selectedRowKeys:[],dataGroup:[]};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.getData();fetch('/getHeadquartersHotels',{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.status==1){_this2.setState({hotel:x.data.hotels||[],hotelTotal:x.data.hotels||[],dataGroup:x.data.group||[]});return;}_message3.default.error('数据获取失败！'+JSON.stringify(x.msg));}).catch(function(err){console.error(err);_message3.default.error('数据获取失败！'+JSON.stringify(err));});}},{key:'render',value:function render(){var _this3=this;var columns=[{title:'名称',dataIndex:'name',key:'name'},{title:'备注',dataIndex:'note',key:'note'},{title:'添加时间',dataIndex:'add_time',key:'add_time'},{title:'操作',key:'操作',render:function render(record){return _react2.default.createElement('div',null,_react2.default.createElement('span',{style:{color:"#1890ff",cursor:"pointer"},onClick:function onClick(){_this3.setState({dataCompared:_extends({},record),visible:true,selectedRowKeys:record.hotels.split(',').map(function(x){return(0,_method.numConvert)(x);})});}},'\u7F16\u8F91'),_react2.default.createElement(_icon2.default,{type:'minus'}),_react2.default.createElement('span',{style:{color:"#1890ff",cursor:"pointer"},onClick:function onClick(){if(record.type&&record.type=='day'){_this3.props.history.push('/table/compared/daydetail/'+record.id);return;}_this3.props.history.push('/table/compared/detail/'+record.id);}},'\u67E5\u770B'),_react2.default.createElement(_icon2.default,{type:'minus'}),_react2.default.createElement(_popconfirm2.default,{title:'\u786E\u5B9A\u8981\u5220\u9664\u8FD9\u4E2A\u8868\u683C?',onConfirm:function onConfirm(){_this3.onDelete(record.id);},onCancel:function onCancel(){},okText:'\u662F',cancelText:'\u5426'},_react2.default.createElement('span',{style:{color:"#1890ff",cursor:"pointer"}},'\u5220\u9664')));}}];// 酒店列表
var columnsHotel=[{title:'酒店名称',dataIndex:'name',key:'name'},{title:'联系人',dataIndex:'contacts',key:'contacts'},{title:'地址',dataIndex:'address',key:'address'},{title:'联系电话',key:'tel',dataIndex:'tel'}];var rowSelection={selectedRowKeys:this.state.selectedRowKeys,onChange:function onChange(key,selectedRows){_this3.setState({selectedRowKeys:key});}};var data=this.state.data;var dataCompared=this.state.dataCompared;return _react2.default.createElement(_Auth2.default,null,_react2.default.createElement('div',{className:'compared'},_react2.default.createElement(_row2.default,{style:{fontSize:18,color:"#333"}},'Executive Summary Report \u6708\u5EA6\u7ECF\u8425\u62A5\u544A'),_react2.default.createElement(_row2.default,{style:{margin:'20px 0'}},_react2.default.createElement('span',null,'\u8868\u683C\u81EA\u5B9A\u4E49\u5F00\u5173 \uFF1A',_react2.default.createElement(_switch2.default,{checkedChildren:'\u5F00',unCheckedChildren:'\u5173',checked:this.props.store.compared.state,onChange:function onChange(checked){_this3.props.store.compared.onChange(checked);}})),_react2.default.createElement(_button2.default,{type:'primary',style:{float:"right"},onClick:function onClick(){_this3.props.history.push('/bp/hotelgroup');}},'\u9152\u5E97\u5206\u7EC4\u7BA1\u7406')),_react2.default.createElement(_table2.default,{style:{marginTop:20},columns:columns,dataSource:data,bordered:true,loading:this.state.loading,rowKey:function rowKey(item){return item.id;}}),_react2.default.createElement(_row2.default,{style:{textAlign:"right",marginTop:20}},_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){_this3.props.history.goBack();}},'\u8FD4\u56DE'),_react2.default.createElement(_button2.default,{type:'primary',style:{marginLeft:10},onClick:function onClick(){_this3.showModal();}},'\u4FDD\u5B58')),_react2.default.createElement(_modal2.default,{title:'\u81EA\u5B9A\u4E49\u8868\u683C',visible:this.state.visible,onOk:this.handleOk,onCancel:function onCancel(){return _this3.setState({visible:false,dataCompared:{}});},className:'compared-modal',footer:[_react2.default.createElement(_button2.default,{key:'back',onClick:function onClick(){return _this3.setState({visible:false});}},'\u53D6\u6D88'),_react2.default.createElement(_button2.default,{key:'submit',type:'primary',loading:this.state.loadingSave,onClick:this.handleOk},'\u4FDD\u5B58')]},_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement('span',null,'\u8868\u683C\u6807\u9898\uFF1A'),_react2.default.createElement(_input2.default,{value:dataCompared.name,className:'compared-input',onChange:function onChange(e){var data=_this3.state.dataCompared;data.name=e.target.value||"";_this3.setState({dataCompared:data});}})),_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement('span',null,'\u5907\u6CE8\uFF1A'),_react2.default.createElement(_input2.default,{value:dataCompared.note,className:'compared-input',style:{marginLeft:28},onChange:function onChange(e){var data=_this3.state.dataCompared;data.note=e.target.value||"";_this3.setState({dataCompared:data});}}))),_react2.default.createElement(_row2.default,{style:{marginTop:20}},_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement('span',null,'\u9152\u5E97\u540D\u79F0\uFF1A'),_react2.default.createElement(_input2.default,{style:{width:200,marginRight:10},value:this.state.name,onChange:function onChange(e){_this3.setState({name:(e.target.value||"").trim()});}}),_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){var hotelTotal=_this3.state.hotelTotal;var name=_this3.state.name;var hotel=hotelTotal.filter(function(x){return x.name.includes(name);});_this3.setState({hotel:hotel});}},'\u641C\u7D22')),_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement('span',null,'\u5FEB\u6377\u9009\u62E9\u9152\u5E97\uFF1A'),_react2.default.createElement(_select2.default,{showSearch:true,allowClear:true,style:{width:200},placeholder:'\u9009\u62E9\u9152\u5E97\u5206\u7EC4',optionFilterProp:'children',onChange:function onChange(value){var selectedRowKeys=value?value.split(',').map(function(x){return Number(x);}):[];_this3.setState({selectedRowKeys:selectedRowKeys});},filterOption:function filterOption(input,option){return option.props.children.toLowerCase().indexOf(input.toLowerCase())>=0;}},(this.state.dataGroup||[]).map(function(x){return _react2.default.createElement(Option,{key:x.hotels},x.name);})))),_react2.default.createElement(_row2.default,{style:{marginTop:20}},'\u5DF2\u9009\u9152\u5E97',this.state.selectedRowKeys.length||"0",'\u5BB6\uFF0C\u5DF2\u6DFB\u52A0\u6570\u636E',this.state.compared.length||"0",'\u6761'),_react2.default.createElement(_table2.default,{style:{marginTop:10},columns:columnsHotel,dataSource:this.state.hotel,bordered:true,className:'hotelModal',rowSelection:rowSelection,rowKey:function rowKey(item){return item.id;}}))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1349);

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_lifecycles_compat__ = __webpack_require__(36);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var classNames = __webpack_require__(22);

var Switch = /*#__PURE__*/function (_Component) {
  _inherits(Switch, _Component);

  var _super = _createSuper(Switch);

  function Switch(props) {
    var _this;

    _classCallCheck(this, Switch);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      var checked = _this.state.checked;
      var onClick = _this.props.onClick;
      var newChecked = !checked;

      _this.setChecked(newChecked, e);

      if (onClick) {
        onClick(newChecked, e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      if (e.keyCode === 37) {
        // Left
        _this.setChecked(false, e);
      } else if (e.keyCode === 39) {
        // Right
        _this.setChecked(true, e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseUp", function (e) {
      var onMouseUp = _this.props.onMouseUp;

      if (_this.node) {
        _this.node.blur();
      }

      if (onMouseUp) {
        onMouseUp(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "saveNode", function (node) {
      _this.node = node;
    });

    var _checked = false;

    if ('checked' in props) {
      _checked = !!props.checked;
    } else {
      _checked = !!props.defaultChecked;
    }

    _this.state = {
      checked: _checked
    };
    return _this;
  }

  _createClass(Switch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          autoFocus = _this$props.autoFocus,
          disabled = _this$props.disabled;

      if (autoFocus && !disabled) {
        this.focus();
      }
    }
  }, {
    key: "setChecked",
    value: function setChecked(checked, e) {
      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          onChange = _this$props2.onChange;

      if (disabled) {
        return;
      }

      if (!('checked' in this.props)) {
        this.setState({
          checked: checked
        });
      }

      if (onChange) {
        onChange(checked, e);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.node.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.node.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props3 = this.props,
          className = _this$props3.className,
          prefixCls = _this$props3.prefixCls,
          disabled = _this$props3.disabled,
          loadingIcon = _this$props3.loadingIcon,
          checkedChildren = _this$props3.checkedChildren,
          unCheckedChildren = _this$props3.unCheckedChildren,
          restProps = _objectWithoutProperties(_this$props3, ["className", "prefixCls", "disabled", "loadingIcon", "checkedChildren", "unCheckedChildren"]);

      var checked = this.state.checked;
      var switchClassName = classNames((_classNames = {}, _defineProperty(_classNames, className, !!className), _defineProperty(_classNames, prefixCls, true), _defineProperty(_classNames, "".concat(prefixCls, "-checked"), checked), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", _extends({}, restProps, {
        type: "button",
        role: "switch",
        "aria-checked": checked,
        disabled: disabled,
        className: switchClassName,
        ref: this.saveNode,
        onKeyDown: this.handleKeyDown,
        onClick: this.handleClick,
        onMouseUp: this.handleMouseUp
      }), loadingIcon, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "".concat(prefixCls, "-inner")
      }, checked ? checkedChildren : unCheckedChildren));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      var newState = {};
      var checked = nextProps.checked;

      if ('checked' in nextProps) {
        newState.checked = !!checked;
      }

      return newState;
    }
  }]);

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Switch.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  checkedChildren: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  unCheckedChildren: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseUp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  tabIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  checked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  defaultChecked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  loadingIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
Switch.defaultProps = {
  prefixCls: 'rc-switch',
  checkedChildren: null,
  unCheckedChildren: null,
  className: '',
  defaultChecked: false
};
Object(__WEBPACK_IMPORTED_MODULE_2_react_lifecycles_compat__["polyfill"])(Switch);
/* harmony default export */ __webpack_exports__["default"] = (Switch);

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Auth=function(_Component){_inherits(Auth,_Component);function Auth(props){_classCallCheck(this,Auth);var _this=_possibleConstructorReturn(this,(Auth.__proto__||Object.getPrototypeOf(Auth)).call(this,props));_this.getJson=function(){var arr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var obj=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return arr.reduce(function(a,b){return a&&a[b]?a[b]:'';},obj);};_this.state={user:{}};return _this;}_createClass(Auth,[{key:'componentDidMount',value:function componentDidMount(){try{var user=JSON.parse(sessionStorage.getItem('user'));this.setState({user:user});}catch(error){console.error(error);this.setState({user:{}});}}// 获取深度嵌套json
},{key:'render',value:function render(){var user=this.state.user;// 判断是否有管理员权限
if(!this.getJson(['email'],user)=='admin'){return null;}return this.props.children;}}]);return Auth;}(_react.Component);exports.default=Auth;

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var Detail=function(_Component){_inherits(Detail,_Component);function Detail(props){_classCallCheck(this,Detail);var _this=_possibleConstructorReturn(this,(Detail.__proto__||Object.getPrototypeOf(Detail)).call(this,props));_this.getData=function(date){_this.setState({loading:true});var day=(0,_moment2.default)(date).format('D');var url="/getECompared?id="+_this.props.match.params.id+"&day="+day+"&year="+(0,_moment2.default)(date).format('YYYY')+"&month="+(0,_moment2.default)(date).format('MM')+"&week="+(0,_moment2.default)(date).format('w');fetch(url,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){var data=x.data.table||[];var obj={name:'总计',id:'--'};(x.data.compared||[]).forEach(function(item){obj[item.dataIndex]=data.reduce(function(a,b){a+=Number(b[item.dataIndex]||"0")||0;return a;},0).toFixed(3)||"";});data.push(_extends({},obj));_this.setState({data:data,dataTitle:x.data.compared||[],loading:false,group:x.data.group||{}});}).catch(function(err){console.error(err);});};_this.getText=function(text,index,type,totalIndex){switch(type){case'number':return _react2.default.createElement("div",{className:"table-padding "+(totalIndex.includes(index)?'table-color-footer':'')},Number(text||'0')<0?_react2.default.createElement("span",{style:{color:"red"}},"(",Math.abs(Number(text||"0")).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),")"):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));break;case'percent':return _react2.default.createElement("div",{className:"table-padding "+(totalIndex.includes(index)?'table-color-footer':'')+" "},Number(text)<0?_react2.default.createElement("span",{style:{color:"red"}},"(",(Math.abs(text)*100).toFixed(1)+'%',")"):(text*100).toFixed(1)+'%');break;case'text':return _react2.default.createElement("div",{className:"table-padding "+(totalIndex.includes(index)?'table-color-footer':''),style:{textAlign:"left",whiteSpace:"inherit"}},text==0?'':text);break;default:return _react2.default.createElement("div",{className:"table-padding "+(totalIndex.includes(index)?'table-color-footer':''),style:{textAlign:"left",whiteSpace:"inherit"}},text==0?'-':text);break;}};_this.downloadSG=function(){var innerHtml="\n          <caption>"+(_this.state.group.name||"")+"</caption>\n          "+document.getElementById('table').innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,(_this.state.group.name||"")+_this.state.date+".xls");_this.setState({print:false});};_this.state={data:[],dataTitle:[],isDay:window.location.hash.includes('day'),date:window.location.hash.includes('day')?(0,_moment2.default)().format('YYYY-MM-DD'):(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),loading:true,dateData:[],group:{}};return _this;}_createClass(Detail,[{key:"componentDidMount",value:function componentDidMount(){var date=Number(this.state.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});this.getData(this.state.date);}},{key:"render",value:function render(){var _this2=this;var _state=this.state,data=_state.data,dataTitle=_state.dataTitle,isDay=_state.isDay;var totalIndex=[data.length-1];var columns=dataTitle.map(function(x){var title=x.title.split(',');var dataCloumns={};switch(title.length){case 1:dataCloumns={title:_react2.default.createElement("span",{dangerouslySetInnerHTML:{__html:x.name}}),children:[{title:_react2.default.createElement("span",{dangerouslySetInnerHTML:{__html:title[0]}}),dataIndex:x.dataIndex,key:x.dataIndex,align:"center",width:150,sorter:function sorter(a,b){return a[x.dataIndex]-b[x.dataIndex];},render:function render(text,record,index){return _this2.getText(text,index,x.type,totalIndex);}}]};break;case 2:dataCloumns={title:x.name,children:[{title:_react2.default.createElement("span",{dangerouslySetInnerHTML:{__html:title[0]}}),children:[{title:_react2.default.createElement("span",{dangerouslySetInnerHTML:{__html:title[1]}}),dataIndex:x.dataIndex,key:x.dataIndex,align:"center",width:150,sorter:function sorter(a,b){return a[x.dataIndex]-b[x.dataIndex];},render:function render(text,record,index){return _this2.getText(text,index,x.type,totalIndex);}}]}]};break;case 3:dataCloumns={title:x.name,children:[{title:_react2.default.createElement("span",{dangerouslySetInnerHTML:{__html:title[0]}}),children:[{title:_react2.default.createElement("span",{dangerouslySetInnerHTML:{__html:title[1]}}),children:[{title:_react2.default.createElement("span",{dangerouslySetInnerHTML:{__html:title[2]}}),dataIndex:x.dataIndex,key:x.dataIndex,align:"center",width:150,sorter:function sorter(a,b){return a[x.dataIndex]-b[x.dataIndex];},render:function render(text,record,index){return _this2.getText(text,index,x.type,totalIndex);}}]}]}]};break;case 4:dataCloumns={title:x.name,children:[{title:_react2.default.createElement("span",{dangerouslySetInnerHTML:{__html:title[0]}}),children:[{title:_react2.default.createElement("span",{dangerouslySetInnerHTML:{__html:title[1]}}),children:[{title:_react2.default.createElement("span",{dangerouslySetInnerHTML:{__html:title[2]}}),children:[{title:_react2.default.createElement("span",{dangerouslySetInnerHTML:{__html:title[3]}}),dataIndex:x.dataIndex,key:x.dataIndex,align:"center",width:150,sorter:function sorter(a,b){return a[x.dataIndex]-b[x.dataIndex];},render:function render(text,record,index){return _this2.getText(text,index,x.type,totalIndex);}}]}]}]}]};break;default:break;}return dataCloumns;});var width=document.body.offsetWidth-dataTitle.length*150>350?document.body.offsetWidth-dataTitle.length*150:350;columns.unshift({title:'酒店名称',dataIndex:'name',align:"center",width:dataTitle.length<=6?350:width,fixed:dataTitle.length<=6?'':this.state.print?"":"left",render:function render(text,record,index){return _this2.getText(text,index,'',totalIndex);}});return _react2.default.createElement("div",{className:"table7_1_1 table12"},_react2.default.createElement(_row2.default,{className:"title",id:"table3_3_3",style:{width:this.state.print?2040:'auto'}},_react2.default.createElement(_row2.default,null,"Executive Summary Report \u6708\u5EA6\u7ECF\u8425\u62A5\u544A  ",_react2.default.createElement("br",null)," ",_react2.default.createElement("span",{style:{fontSize:22}},this.state.group.name||"")),_react2.default.createElement(_row2.default,{className:"table-month"},!isDay&&_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:"YYYY-MM",onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getData(str);}}),isDay&&_react2.default.createElement(_datePicker2.default,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM-DD"),format:"YYYY-MM-DD",onChange:function onChange(date,str){var d=(0,_moment2.default)(date).format('YYYY-MM-DD');_this2.setState({date:d,data:[],loading:true});_this2.getData(d);}})),_react2.default.createElement(_table2.default,{id:"table",columns:columns,dataSource:data,bordered:true,size:"middle",className:"content",pagination:false,scroll:this.state.print?{}:{y:520,x:dataTitle.length*150+(dataTitle.length<=6?350:width)},loading:this.state.loading,rowKey:function rowKey(item){return item.id;}})),_react2.default.createElement(_row2.default,{className:"table-footer-btn"},_react2.default.createElement(_button2.default,{type:"primary",style:{marginRight:15},onClick:function onClick(){_this2.props.history.goBack();}},"\u8FD4\u56DE"),_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this2.setState({print:true},function(){_this2.downloadSG();});},loading:this.state.print},"\u5BFC\u51FAExcel")));}}]);return Detail;}(_react.Component);exports.default=Detail;

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _popconfirm=__webpack_require__(110);var _popconfirm2=_interopRequireDefault(_popconfirm);var _divider=__webpack_require__(343);var _divider2=_interopRequireDefault(_divider);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _tree=__webpack_require__(224);var _tree2=_interopRequireDefault(_tree);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(62);__webpack_require__(12);__webpack_require__(8);__webpack_require__(4);__webpack_require__(60);__webpack_require__(6);__webpack_require__(25);__webpack_require__(111);__webpack_require__(344);__webpack_require__(10);__webpack_require__(42);__webpack_require__(225);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(197);var _data=__webpack_require__(348);var _data2=_interopRequireDefault(_data);var _data3=__webpack_require__(447);var _data4=_interopRequireDefault(_data3);var _data5=__webpack_require__(446);var _data6=_interopRequireDefault(_data5);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var authData={1:_data2.default,2:_data4.default,3:_data6.default};var TreeNode=_tree2.default.TreeNode;var Option=_select2.default.Option;var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this,_this$state;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getData=function(){fetch('/getHeadquarters',{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this.setState({loading:false});if(x.status==1){_this.setState({data:x.data.data||[],dataTotal:x.data.data||[],hotel:x.data.hotels||[],hotelTotal:x.data.hotels||[]});return;}_message3.default.error('数据获取失败！'+JSON.stringify(x.msg));}).catch(function(err){_this.setState({loading:false});console.error(err);_message3.default.error('数据获取失败！'+JSON.stringify(err));});};_this.showModal=function(){_this.setState({visible:true,dataSubmit:{name:"",account:"",password:"",hotels:'',comid:888}});};_this.handleHotelsOk=function(){_this.setState({loadingSave:true});var data=_extends({},_this.state.dataSubmit);if(!data.name||!data.account){_message3.default.error('信息不能为空！');_this.setState({loadingSave:false});return;}data.account=data.account+'_admin';var selectedRowKeys=_this.state.selectedRowKeys;if(selectedRowKeys.length<=0){_message3.default.error('请至少选择一家酒店！');_this.setState({loadingSave:false});return;}data.hotels=selectedRowKeys.toString();var headres={method:'post',credentials:'include',headers:{},body:JSON.stringify(data)};var url=data.id?'/editHeadquarters':'/addHeadquarters';fetch(url,headres).then(function(x){return x.json();}).then(function(x){_this.setState({loadingSave:false});if(x.status==1){_message3.default.info('添加成功！');_this.setState({visible:false,dataSubmit:{name:"",account:"",password:"",hotels:'',comid:888}});_this.getData();return;}_message3.default.error('添加失败！');}).catch(function(err){_message3.default.error('添加失败！');_this.setState({loadingSave:false});console.error(err);});};_this.renderTreeNodes=function(data){return data.map(function(item){if(item.children){return _react2.default.createElement(TreeNode,{title:item.title,key:item.key,dataRef:item},_this.renderTreeNodes(item.children));}return _react2.default.createElement(TreeNode,item);});};_this.handleCancel=function(){_this.setState({pwdvisible:false,pwdData:{password:"",comfirm:"",id:""}});};_this.handleOk=function(){var data=_this.state.pwdData;_this.setState({loadingSave:true});if(!data.password||!data.confirm||data.password!=data.confirm){_message3.default.error('输入错误，请检查密码！');_this.setState({loadingSave:false});return;}var dataFrom=new FormData();delete data.confirm;data={id:data.id,password:data.password};// console.log(data);
for(var key in data){if(data.hasOwnProperty(key)){dataFrom.append(key,data[key]);}}var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/addUser',headres).then(function(x){return x.json();}).then(function(x){_this.setState({loadingSave:false,pwdvisible:false});if(x.status==1){_message3.default.info('修改成功!');return;}}).catch(function(err){console.error(err);_message3.default.error('数据添加失败！');_this.setState({loadingSave:false,pwdvisible:false});});};_this.getAuthData=function(record){fetch('/getAllAuth?name='+record.account+'&type='+_this.state.hotelAuthName,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.data){var checkedKeys=x.data.data.split(',');_this.setState({auth:x,checkedKeys:checkedKeys,authLoading:false});}else{_this.setState({auth:{data:""},checkedKeys:[],authLoading:false});}}).catch(function(err){console.error(err);_this.setState({authLoading:false});});};_this.authshowModal=function(record){if(_this.state.info.email!='admin'){_message3.default.error('权限不足！');return;}_this.setState({authVisible:true,authLoading:true,record:record});_this.getAuthData(record);};_this.authhandleOk=function(e){if(_this.state.info.email!='admin'){_message3.default.error('权限不足！');return;}_this.setState({loadingAuth:true});var checkedKeys=_this.state.checkedKeys;var hotelAuthName=_this.state.hotelAuthName;var record=_this.state.record;var data=_extends({},_this.state.auth,{user:record.account,data:checkedKeys.toString(),type:hotelAuthName});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/saveAllAuth',headres).then(function(x){return x.json();}).then(function(x){_this.setState({loadingAuth:false});if(x.status==1){_message3.default.success('保存成功');return;}_message3.default.error('保存失败！');}).catch(function(err){console.error(err);_this.setState({loadingAuth:false});});};_this.authhandleCancel=function(e){_this.setState({authVisible:false});};_this.onChange=function(value,lable,extra){_this.setState({selectAuth:value});};_this.onExpand=function(expandedKeys){// if not set autoExpandParent to false, if children expanded, parent can not collapse.
// or, you can remove all expanded children keys.
_this.setState({expandedKeys:expandedKeys,autoExpandParent:false});};_this.onCheck=function(checkedKeys,checkedNodes){_this.setState({checkedKeys:checkedKeys});};_this.onSelect=function(selectedKeys,info){_this.setState({selectedKeys:selectedKeys});};_this.onDel=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(id){var res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_request2.default)('/headquarters/del?id='+id);case 2:res=_context.sent;if(res.status==1)_this.setState({data:_this.state.data.filter(function(x){return x.id!=id;})});case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.state=(_this$state={pwdvisible:false,data:[],visible:false,loadingSave:false,loading:true,dataTotal:[],selectedRowKeys:[],hotel:[],hotelTotal:[],pwdData:{id:"",password:"",comfirm:""},dataSubmit:{name:"",account:"",password:"",hotels:'',comid:888},authData:[],authVisible:false,expandedKeys:[],autoExpandParent:true,checkedKeys:[],selectedKeys:[],auth:{},authLoading:false,hotelAuthName:'1',info:sessionStorage.getItem('user')?JSON.parse(sessionStorage.getItem('user')):{}},_defineProperty(_this$state,'dataTotal',[]),_defineProperty(_this$state,'record',{}),_this$state);return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData();}// 权限
},{key:'render',value:function render(){var _this3=this;var columns=[{title:'名称',dataIndex:'name',key:'name'},{title:'帐号',dataIndex:'account',key:'account'},{title:'创建时间',dataIndex:'add_time',key:'add_time'},{title:'操作',key:'action',render:function render(record){return _react2.default.createElement('div',null,_react2.default.createElement('span',{style:{color:"#1890ff",cursor:"pointer"},onClick:function onClick(){var dataSubmit=_extends({},record);var selectedRowKeys=record.hotels.split(',').map(function(x){return Number(x);});_this3.setState({dataSubmit:dataSubmit,visible:true,selectedRowKeys:selectedRowKeys});}},'\u7F16\u8F91\u9152\u5E97\u6743\u9650'),_react2.default.createElement(_divider2.default,{type:'vertical'}),_react2.default.createElement('span',{style:{color:"#1890ff",cursor:"pointer"},onClick:function onClick(){_this3.authshowModal(record);}},'\u7F16\u8F91\u83DC\u5355\u6743\u9650'),_react2.default.createElement(_divider2.default,{type:'vertical'}),_react2.default.createElement('span',{style:{color:"#1890ff",cursor:"pointer"},onClick:function onClick(){_this3.setState({pwdvisible:true,pwdData:_extends({},_this3.state.pwdData,{id:record.user_id})});}},'\u4FEE\u6539\u5BC6\u7801'),_react2.default.createElement(_divider2.default,{type:'vertical'}),_react2.default.createElement(_popconfirm2.default,{title:'\u786E\u5B9A\u8981\u5220\u9664\u5417\uFF0C\u4E00\u65E6\u5220\u9664\u5C06\u65E0\u6CD5\u6062\u590D?',onConfirm:function onConfirm(){return _this3.onDel(record.id);},okText:'\u786E\u5B9A',cancelText:'\u53D6\u6D88'},_react2.default.createElement('span',{style:{color:"#F5222D",cursor:"pointer"}},'\u5220\u9664')));}}];var data=this.state.data;// 酒店列表
var columnsHotel=[{title:'酒店名称',dataIndex:'name',key:'name'},{title:'联系人',dataIndex:'contacts',key:'contacts'},{title:'地址',dataIndex:'address',key:'address'},{title:'联系电话',key:'tel',dataIndex:'tel'}];var rowSelection={selectedRowKeys:this.state.selectedRowKeys,onChange:function onChange(key,selectedRows){_this3.setState({selectedRowKeys:key});}};return _react2.default.createElement('div',{className:'settings'},_react2.default.createElement(_row2.default,{style:{margin:'20px 0'}},_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement('span',null,'\u540D\u79F0\uFF1A'),_react2.default.createElement(_input2.default,{style:{width:200,marginRight:10},value:this.state.hotelName,onChange:function onChange(e){_this3.setState({hotelName:e.target.value||""});}}),_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){var dataTotal=_this3.state.dataTotal;var hotelName=_this3.state.hotelName.trim();var data=dataTotal.filter(function(x){return x.name.includes(hotelName);});_this3.setState({data:data});}},'\u641C\u7D22')),_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement(_row2.default,{type:'flex',justify:'end'},_react2.default.createElement(_button2.default,{type:'primary',onClick:this.showModal},'\u6DFB\u52A0\u4EBA\u5458')))),_react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement(_table2.default,{style:{marginTop:20},columns:columns,dataSource:data,bordered:true,rowKey:function rowKey(item,index){return index;}})),_react2.default.createElement(_row2.default,{style:{textAlign:"right",marginTop:20}},_react2.default.createElement(_button2.default,{key:'submit',type:'primary',onClick:function onClick(){_this3.props.history.goBack();}},'\u8FD4\u56DE')),_react2.default.createElement(_modal2.default,{title:this.state.dataSubmit.id?'人员编辑':'人员添加',visible:this.state.visible,onOk:this.handleHotelsOk,onCancel:function onCancel(){return _this3.setState({visible:false});},className:'compared-modal',footer:[_react2.default.createElement(_button2.default,{key:'back',onClick:function onClick(){return _this3.setState({visible:false});}},'\u53D6\u6D88'),_react2.default.createElement(_button2.default,{key:'submit',type:'primary',loading:this.state.loadingSave,onClick:this.handleHotelsOk},'\u4FDD\u5B58')]},_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:8},_react2.default.createElement(_col2.default,{span:4,style:{paddingTop:5}},_react2.default.createElement('span',null,'\u540D\u79F0\uFF1A')),_react2.default.createElement(_col2.default,{span:20},_react2.default.createElement(_input2.default,{onChange:function onChange(e){var value=(e.target.value||"").trim();var dataSubmit=_this3.state.dataSubmit;dataSubmit.name=value;_this3.setState({dataSubmit:dataSubmit});},value:this.state.dataSubmit.name,disabled:this.state.dataSubmit.id||false}))),_react2.default.createElement(_col2.default,{span:8},_react2.default.createElement(_col2.default,{span:6,style:{paddingTop:5,paddingLeft:20}},_react2.default.createElement('span',null,'\u5E10\u53F7\uFF1A')),_react2.default.createElement(_col2.default,{span:18},_react2.default.createElement(_input2.default,{onChange:function onChange(e){var value=(e.target.value||"").trim();var dataSubmit=_this3.state.dataSubmit;dataSubmit.account=value;_this3.setState({dataSubmit:dataSubmit});},value:this.state.dataSubmit.account,disabled:this.state.dataSubmit.id,addonAfter:'_admin'}))),_react2.default.createElement(_col2.default,{span:8,style:{display:this.state.dataSubmit.id?'none':""}},_react2.default.createElement(_col2.default,{span:6,style:{paddingTop:5,paddingLeft:20}},_react2.default.createElement('span',null,'\u5BC6\u7801\uFF1A')),_react2.default.createElement(_col2.default,{span:18},_react2.default.createElement(_input2.default,{type:'password',onChange:function onChange(e){var value=(e.target.value||"").trim();var dataSubmit=_this3.state.dataSubmit;dataSubmit.password=value;_this3.setState({dataSubmit:dataSubmit});},value:this.state.dataSubmit.password})))),_react2.default.createElement(_row2.default,{style:{marginTop:20}},_react2.default.createElement('span',null,'\u9152\u5E97\u540D\u79F0\uFF1A'),_react2.default.createElement(_input2.default,{style:{width:200,marginRight:10},value:this.state.name,onChange:function onChange(e){_this3.setState({name:(e.target.value||"").trim()});}}),_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){var hotelTotal=_this3.state.hotelTotal;var name=_this3.state.name;var hotel=hotelTotal.filter(function(x){return x.name.includes(name);});_this3.setState({hotel:hotel});}},'\u641C\u7D22')),_react2.default.createElement(_row2.default,{style:{marginTop:20}},'\u5DF2\u9009\u9152\u5E97',this.state.selectedRowKeys.length||"0",'\u5BB6'),_react2.default.createElement(_table2.default,{style:{marginTop:10},columns:columnsHotel,dataSource:this.state.hotel,bordered:true,className:'hotelModal',rowSelection:rowSelection,rowKey:function rowKey(item){return item.id;}})),_react2.default.createElement(_modal2.default,{title:'\u6743\u9650\u8BBE\u7F6E',visible:this.state.authVisible,onOk:this.authhandleOk,onCancel:this.authhandleCancel,footer:[_react2.default.createElement(_button2.default,{key:'back',onClick:this.authhandleCancel},'\u53D6\u6D88'),_react2.default.createElement(_button2.default,{key:'submit',type:'primary',loading:this.state.loadingAuth,onClick:this.authhandleOk},'\u4FDD\u5B58')]},_react2.default.createElement(_spin2.default,{spinning:this.state.authLoading},_react2.default.createElement(_row2.default,{className:'modal'},_react2.default.createElement(_row2.default,null,_react2.default.createElement('span',null,'\u9009\u62E9\u4EBA\u5458\uFF1A'),_react2.default.createElement(_select2.default,{value:this.state.hotelAuthName,style:{width:300},onChange:function onChange(value){_this3.setState({hotelAuthName:value,authLoading:true,checkedKeys:[]},function(){_this3.getAuthData(_this3.state.record);});}},_react2.default.createElement(Option,{key:'1'},'Executive Summary Report \u6708\u5EA6\u7ECF\u8425\u62A5\u544A'),_react2.default.createElement(Option,{key:'2'},'Business Plan \u5E74\u5EA6\u7ECF\u8425\u8BA1\u5212'),_react2.default.createElement(Option,{key:'3'},'Human Resources \u4EBA\u529B\u8D44\u6E90\u62A5\u544A'))),_react2.default.createElement(_row2.default,{className:'authCotent'},_react2.default.createElement(_row2.default,null,'\u6743\u9650\u914D\u7F6E'),_react2.default.createElement(_tree2.default,{checkable:true,onExpand:this.onExpand,expandedKeys:this.state.expandedKeys,autoExpandParent:this.state.autoExpandParent,onCheck:this.onCheck,checkedKeys:this.state.checkedKeys,onSelect:this.onSelect,selectedKeys:this.state.selectedKeys},this.renderTreeNodes(authData[this.state.hotelAuthName])))))),_react2.default.createElement(_modal2.default,{title:'\u4FEE\u6539\u5BC6\u7801',visible:this.state.pwdvisible,onOk:this.handleOk,onCancel:this.handleCancel,footer:[_react2.default.createElement(_button2.default,{key:'back',onClick:this.handleCancel},'\u53D6\u6D88'),_react2.default.createElement(_button2.default,{key:'submit',type:'primary',loading:this.state.loadingSave,onClick:this.handleOk},'\u4FDD\u5B58')]},_react2.default.createElement(_row2.default,{className:'settings-modal-content'},_react2.default.createElement('span',null,'\u5BC6\u7801\uFF1A'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u5BC6\u7801',style:{width:'60%',marginLeft:38},value:this.state.pwdData.password,type:'password',name:'ppp',onChange:function onChange(e){var value=e.target.value;var data=_this3.state.pwdData;data.password=value;_this3.setState({pwdData:data});}})),_react2.default.createElement(_row2.default,{className:'settings-modal-content'},_react2.default.createElement('span',null,'\u786E\u8BA4\uFF1A'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u5BC6\u7801',style:{width:'60%',marginLeft:38},value:this.state.pwdData.confirm,type:'password',name:'ppp',onChange:function onChange(e){var value=e.target.value;var data=_this3.state.pwdData;data.confirm=value;_this3.setState({pwdData:data});}})),_react2.default.createElement(_row2.default,{className:'settings-modal-content',style:{color:"red",paddingLeft:80}},this.state.pwdData.password&&this.state.pwdData.confirm&&this.state.pwdData.password!=this.state.pwdData.confirm?'两次输入的密码不一致！':"")));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _dropdown=__webpack_require__(271);var _dropdown2=_interopRequireDefault(_dropdown);var _menu=__webpack_require__(251);var _menu2=_interopRequireDefault(_menu);var _popconfirm=__webpack_require__(110);var _popconfirm2=_interopRequireDefault(_popconfirm);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(4);__webpack_require__(60);__webpack_require__(366);__webpack_require__(314);__webpack_require__(111);__webpack_require__(10);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);__webpack_require__(736);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _ApplyBilling=__webpack_require__(1356);var _ApplyBilling2=_interopRequireDefault(_ApplyBilling);var _Logistics=__webpack_require__(1358);var _Logistics2=_interopRequireDefault(_Logistics);var _ApplicationContract=__webpack_require__(1360);var _ApplicationContract2=_interopRequireDefault(_ApplicationContract);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _=__webpack_require__(1364);var _2=_interopRequireDefault(_);var _3=__webpack_require__(1365);var _4=_interopRequireDefault(_3);var _copy=__webpack_require__(1366);var _copy2=_interopRequireDefault(_copy);var _5=__webpack_require__(1367);var _6=_interopRequireDefault(_5);var _number=__webpack_require__(1368);var _number2=_interopRequireDefault(_number);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var code={1:"等待客户支付！",2:"支付成功！",3:"支付失败！",4:"支付结果异常!"};var personal=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(personal,_Component);function personal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,personal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=personal.__proto__||Object.getPrototypeOf(personal)).call.apply(_ref,[this].concat(args))),_this),_this.state={user:{},logs:[],hotel:{},expressData:{}},_this.getData=function(){fetch('/getHotelPay',{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this.setState({user:x.data.user||{},logs:(x.data.logs||[]).reverse(),hotel:x.data.hotel||{}});}).catch(function(err){console.error(err);});},_this.getBilling=function(item){if(item.status!=2)return;if(item.is_billing!=1){return _react2.default.createElement("span",{className:"apply"},_react2.default.createElement("span",{onClick:function onClick(){return _this.props.store.applybilling.onShow(item);}},"\u7533\u8BF7\u5F00\u7968"));};if(item.is_billing==1&&item.express_no){return _react2.default.createElement("span",{className:"invoiced"},"\u5DF2\u5F00\u7968");}if(item.is_billing==1&&item.url){return _react2.default.createElement("span",{className:"apply"},_react2.default.createElement("span",{onClick:function onClick(){_fileSaver2.default.saveAs(item.url);}},"\u4E0B\u8F7D\u53D1\u7968"));}if(item.is_billing==1&&!item.express_no){return _react2.default.createElement("span",{className:"invoiced"},"\u53D1\u7968\u5DF2\u7533\u8BF7");}},_this.getExpress=function(item){if(item.status!=2||item.is_billing!=1||!item.express_no)return;return _react2.default.createElement("span",{onClick:function onClick(){_this.setState({expressData:item});_this.props.store.applyexpress.onShow();}},"\u67E5\u770B\u7269\u6D41");},_this.getContract=function(item){if(item.status==2)return;return _react2.default.createElement("span",{className:"apply"},_react2.default.createElement("span",{onClick:function onClick(){return _this.props.store.applycontract.onShow(item,_this.state.hotel);}},"\u7533\u8BF7\u5408\u540C"));},_this.onDeleteApply=function(item){if(item.status==2){_message3.default.error('已完成的订单不支持删除');return;}fetch('/onDeleteApply?id='+item.id,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.status==1){_message3.default.info('删除成功！');_this.getData();return;}_message3.default.error(x.msg);}).catch(function(err){console.error(err);});},_this.onMore=function(item){var menu=_react2.default.createElement(_menu2.default,null,_react2.default.createElement(_menu2.default.Item,null,_react2.default.createElement(_popconfirm2.default,{title:"\u8BF7\u786E\u8BA4\u672A\u4F7F\u7528\u6B64\u8BA2\u5355\u4ED8\u6B3E?",onConfirm:_this.onDeleteApply.bind(_this,item),okText:"\u786E\u5B9A",cancelText:"\u53D6\u6D88"},_react2.default.createElement("span",null,"\u5220\u9664"))));return _react2.default.createElement(_dropdown2.default,{overlay:menu},_react2.default.createElement("a",{className:"ant-dropdown-link"},"\u66F4\u591A\u64CD\u4F5C"));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(personal,[{key:"componentDidMount",value:function componentDidMount(){this.getData();}},{key:"render",value:function render(){var _this2=this;var _state=this.state,_state$user=_state.user,user=_state$user===undefined?{}:_state$user,_state$logs=_state.logs,logs=_state$logs===undefined?[]:_state$logs,_state$hotel=_state.hotel,hotel=_state$hotel===undefined?{}:_state$hotel,_state$expressData=_state.expressData,expressData=_state$expressData===undefined?{}:_state$expressData;console.log("hotel:",logs);return _react2.default.createElement("div",{className:"personal"},_react2.default.createElement("div",{className:"basic"},_react2.default.createElement("div",null,"\u57FA\u672C\u4FE1\u606F")),_react2.default.createElement(_row2.default,{type:"flex",justify:"space-between"},_react2.default.createElement(_col2.default,{span:8,className:"detail-list"},_react2.default.createElement("div",null,_react2.default.createElement("img",{src:_2.default,alt:""}),_react2.default.createElement("span",null,"\u9152\u5E97\u540D\u79F0")),_react2.default.createElement("div",null,hotel.name||"")),_react2.default.createElement(_col2.default,{span:8,className:"detail-list"},_react2.default.createElement("div",null,_react2.default.createElement("img",{src:_number2.default,alt:""}),_react2.default.createElement("span",null,"\u6E29\u5FB7\u59C6\u7F16\u7801")),_react2.default.createElement("div",null,hotel.wdm_number||"")),_react2.default.createElement(_col2.default,{span:8,className:"detail-list"},_react2.default.createElement("div",null,_react2.default.createElement("img",{src:_number2.default,alt:""}),_react2.default.createElement("span",null,"\u5343\u4E58\u7F16\u7801")),_react2.default.createElement("div",null,hotel.code||""))),_react2.default.createElement("div",{className:"detail-list"},_react2.default.createElement("div",null,_react2.default.createElement("img",{src:_4.default,alt:""}),_react2.default.createElement("span",null,"\u767B\u5F55\u8D26\u53F7")),_react2.default.createElement("div",null,_react2.default.createElement("span",null,user.name),((user.email||"").includes('admin')||(user.email||"").includes('GM'))&&_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this2.props.history.push("/table/hotel/"+hotel.id);}},"\u67E5\u770B\u9152\u5E97\u8D26\u53F7"))),_react2.default.createElement("div",{className:"detail-list"},_react2.default.createElement("div",null,_react2.default.createElement("img",{src:_copy2.default,alt:""}),_react2.default.createElement("span",null,"\u4ED8\u8D39\u8FC7\u671F\u65F6\u95F4")),_react2.default.createElement("div",null,_react2.default.createElement("span",null,(0,_moment2.default)(hotel.expire_date||"2019-07-01").format('YYYY-MM-DD')),_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this2.props.history.push('/pay');}},"\u7EED\u8D39"))),_react2.default.createElement("div",{className:"basic logs"},_react2.default.createElement("div",null,"\u652F\u4ED8\u8BB0\u5F55")),logs.map(function(item,i){return _react2.default.createElement("div",{className:"log-list",key:item.id},_react2.default.createElement("div",{className:i==0?"first":""},i!=logs.length-1?_react2.default.createElement("div",{style:{top:i==0?22:20}}):""),_react2.default.createElement("span",null,(0,_moment2.default)(item.add_time).format('YYYY-MM-DD')),_react2.default.createElement("span",null,item.out_trade_no),_react2.default.createElement("span",null,code[item.status]),_this2.getBilling(item),_this2.getExpress(item),_this2.getContract(item),_this2.onMore(item));}),_react2.default.createElement(_ApplyBilling2.default,{getData:this.getData}),_react2.default.createElement(_Logistics2.default,{data:expressData}),_react2.default.createElement(_ApplicationContract2.default,null));}}]);return personal;}(_react.Component))||_class)||_class);exports.default=personal;

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(62);__webpack_require__(6);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);__webpack_require__(1357);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextArea=_input2.default.TextArea;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){var _this2=this;var _props$store$applybil=this.props.store.applybilling,visible=_props$store$applybil.visible,onOk=_props$store$applybil.onOk,onCancel=_props$store$applybil.onCancel,data=_props$store$applybil.data,_onChange=_props$store$applybil.onChange,loading=_props$store$applybil.loading;return _react2.default.createElement(_modal2.default,{maskClosable:false,title:'\u7533\u8BF7\u5F00\u7968',visible:visible,onCancel:onCancel,cancelText:'\u53D6\u6D88',okText:'\u63D0\u4EA4',className:'apply-billing',footer:[_react2.default.createElement(_button2.default,{key:'back',onClick:onCancel},'\u53D6\u6D88'),_react2.default.createElement(_button2.default,{type:'primary',loading:loading,onClick:function onClick(){return onOk(_this2.props.getData);}},'\u63D0\u4EA4')]},_react2.default.createElement('p',{className:'order-no'},'\u8BA2\u5355\u7F16\u53F7\uFF1A',data.out_trade_no),_react2.default.createElement('p',null,'\u8BF7\u586B\u5199\u53D1\u7968\u63A5\u6536\u4FE1\u606F'),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u53D1\u7968\u62AC\u5934:'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u53D1\u7968\u62AC\u5934',value:data.billing_invoice,onChange:function onChange(e){return _onChange('billing_invoice',e.target.value);}})),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7:'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7',value:data.billing_bank_account,onChange:function onChange(e){return _onChange('billing_bank_account',e.target.value);}})),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u5F00\u6237\u884C:'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u5F00\u6237\u884C',value:data.billing_bank,onChange:function onChange(e){return _onChange('billing_bank',e.target.value);}})),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u5F00\u6237\u8D26\u53F7:'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u5F00\u6237\u8D26\u53F7',value:data.billing_number,onChange:function onChange(e){return _onChange('billing_number',e.target.value);}})),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u516C\u53F8\u7535\u8BDD:'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u516C\u53F8\u7535\u8BDD',value:data.company_phone,onChange:function onChange(e){return _onChange('company_phone',e.target.value);}})),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u5F00\u7968\u5730\u5740:'),_react2.default.createElement(TextArea,{placeholder:'\u8BF7\u8F93\u5165\u63A5\u6536\u5730\u5740',rows:2,value:data.company_addr,onChange:function onChange(e){return _onChange('company_addr',e.target.value);}})),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u90AE\u7BB1:'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u53D1\u7968\u63A5\u6536\u90AE\u7BB1',value:data.email,onChange:function onChange(e){return _onChange('email',e.target.value);}})));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(62);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);__webpack_require__(1359);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextArea=_input2.default.TextArea;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){var _props$store$applyexp=this.props.store.applyexpress,visible=_props$store$applyexp.visible,onCancel=_props$store$applyexp.onCancel;var data=this.props.data;return _react2.default.createElement(_modal2.default,{title:'\u67E5\u770B\u7269\u6D41',visible:visible,onCancel:onCancel,cancelText:'\u53D6\u6D88',okText:'\u63D0\u4EA4',className:'apply-express'},_react2.default.createElement('p',{className:'order-no'},'\u8BA2\u5355\u7F16\u53F7\uFF1A',data.out_trade_no),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u7269\u6D41\u516C\u53F8:'),_react2.default.createElement('span',{className:'billing-value'},data.express)),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u7269\u6D41\u5355\u53F7:'),_react2.default.createElement('span',{className:'billing-value'},data.express_no)));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _switch=__webpack_require__(249);var _switch2=_interopRequireDefault(_switch);var _radio=__webpack_require__(112);var _radio2=_interopRequireDefault(_radio);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(62);__webpack_require__(12);__webpack_require__(250);__webpack_require__(127);__webpack_require__(6);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _Contract=__webpack_require__(1361);var _Contract2=_interopRequireDefault(_Contract);__webpack_require__(1363);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextArea=_input2.default.TextArea;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={isSeal:1},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'render',value:function render(){var _this2=this;var _props$store$applycon=this.props.store.applycontract,visible=_props$store$applycon.visible,onOk=_props$store$applycon.onOk,onCancel=_props$store$applycon.onCancel,data=_props$store$applycon.data,_onChange=_props$store$applycon.onChange,loading=_props$store$applycon.loading;var isSeal=this.state.isSeal;var isAdmin=JSON.parse(sessionStorage.getItem('user')||"{}")['email']==='admin';return _react2.default.createElement(_modal2.default,{title:'\u7533\u8BF7\u5408\u540C',visible:visible,onCancel:onCancel,className:'apply-billing',footer:[_react2.default.createElement(_button2.default,{key:'back',onClick:onCancel},'\u53D6\u6D88'),_react2.default.createElement(_button2.default,{type:'primary',loading:loading,onClick:function onClick(){return onOk(isSeal);}},'\u7533\u8BF7\u5408\u540C')]},_react2.default.createElement(_spin2.default,{tip:'\u5408\u540C\u7533\u8BF7\u53D1\u9001\u4E2D\uFF0C\u8BF7\u7A0D\u540E...',spinning:loading},!loading&&_react2.default.createElement('div',null,_react2.default.createElement('p',{className:'order-no'},'\u8BA2\u5355\u7F16\u53F7\uFF1A',data.out_trade_no),_react2.default.createElement('p',null,'\u8BF7\u586B\u5199\u5408\u540C\u63A5\u6536\u4FE1\u606F'),_react2.default.createElement(_radio2.default.Group,{className:'select-type',size:'large',value:isSeal,buttonStyle:'solid',onChange:function onChange(e){_this2.setState({isSeal:e.target.value});}},_react2.default.createElement(_radio2.default.Button,{value:1},'\u7535\u5B50\u5408\u540C'),_react2.default.createElement(_radio2.default.Button,{value:2},'\u7EB8\u8D28\u5408\u540C')),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u5408\u540C\u7532\u65B9:'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u5355\u4F4D\u540D\u79F0',value:data.hotel_name,onChange:function onChange(e){return _onChange('hotel_name',e.target.value);}})),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u516C\u53F8\u8054\u7CFB\u4EBA:'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u8054\u7CFB\u4EBA\u59D3\u540D',value:data.billing_name,onChange:function onChange(e){return _onChange('billing_name',e.target.value);}})),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u516C\u53F8\u7535\u8BDD:'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u8054\u7CFB\u4EBA\u7535\u8BDD',value:data.billing_tel,onChange:function onChange(e){return _onChange('billing_tel',e.target.value);}})),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u516C\u53F8\u5730\u5740:'),_react2.default.createElement(TextArea,{placeholder:'\u8BF7\u8F93\u5165\u5730\u5740',rows:2,value:data.billing_addr,onChange:function onChange(e){return _onChange('billing_addr',e.target.value);}})),isAdmin&&_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u5408\u540C\u91D1\u989D:'),_react2.default.createElement(_input2.default,{placeholder:'\u5408\u540C\u91D1\u989D',value:data.money,onChange:function onChange(e){return _onChange('money',e.target.value);}})),isAdmin&&_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u5408\u540C\u65E5\u671F:'),_react2.default.createElement(_input2.default,{placeholder:'\u5408\u540C\u65E5\u671F',value:data.add_time,onChange:function onChange(e){return _onChange('add_time',e.target.value);}})),isAdmin&&_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u5F00\u59CB\u65F6\u95F4:'),_react2.default.createElement(_input2.default,{placeholder:'\u5F00\u59CB\u65F6\u95F4',value:data.current_time,onChange:function onChange(e){return _onChange('current_time',e.target.value);}})),isAdmin&&_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u7ED3\u675F\u65F6\u95F4:'),_react2.default.createElement(_input2.default,{placeholder:'\u7ED3\u675F\u65F6\u95F4',value:data.expire_date,onChange:function onChange(e){return _onChange('expire_date',e.target.value);}})),isSeal==2&&_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u6536\u4EF6\u4EBA\u59D3\u540D:'),_react2.default.createElement(_input2.default,{placeholder:'\u6536\u4EF6\u4EBA\u59D3\u540D',value:data.name,onChange:function onChange(e){return _onChange('name',e.target.value);}})),isSeal==2&&_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u6536\u4EF6\u4EBA\u7535\u8BDD:'),_react2.default.createElement(_input2.default,{placeholder:'\u6536\u4EF6\u4EBA\u7535\u8BDD',value:data.tel,onChange:function onChange(e){return _onChange('tel',e.target.value);}})),isSeal==2&&_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u6536\u4EF6\u5730\u5740:'),_react2.default.createElement(TextArea,{placeholder:'\u6536\u4EF6\u5730\u5740',rows:2,value:data.addr,onChange:function onChange(e){return _onChange('addr',e.target.value);}})),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u90AE\u7BB1:'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u5408\u540C\u63A5\u6536\u90AE\u7BB1',value:data.email,onChange:function onChange(e){return _onChange('email',e.target.value);}})),isAdmin&&_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'billing-name'},'\u5370\u7AE0:'),_react2.default.createElement(_switch2.default,{checkedChildren:'\u662F',unCheckedChildren:'\u5426',checked:this.state.isSeal==1,onChange:function onChange(checked){_this2.setState({isSeal:checked?1:2});},style:{marginLeft:20,marginTop:5}}))),loading&&_react2.default.createElement(_Contract2.default,{data:data,isSeal:this.state.isSeal==1})));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _=__webpack_require__(1362);var _2=_interopRequireDefault(_);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Contract=function(_Component){_inherits(Contract,_Component);function Contract(){_classCallCheck(this,Contract);return _possibleConstructorReturn(this,(Contract.__proto__||Object.getPrototypeOf(Contract)).apply(this,arguments));}_createClass(Contract,[{key:"render",value:function render(){var _props=this.props,data=_props.data,isSeal=_props.isSeal;return _react2.default.createElement("div",{id:"contract"},_react2.default.createElement("div",{className:"title"},"\u670D\u52A1\u534F\u8BAE"),_react2.default.createElement("div",{className:"module"},_react2.default.createElement("div",null,"\u7532\u65B9 : ",data.hotel_name),_react2.default.createElement("div",null,"\u5730\u5740 : ",data.billing_addr),_react2.default.createElement("div",null,"\u8054\u7CFB\u4EBA : ",data.billing_name),_react2.default.createElement("div",null,"\u8054\u7CFB\u7535\u8BDD : ",data.billing_tel)),_react2.default.createElement("div",{className:"module"},_react2.default.createElement("div",null,"\u4E59\u65B9 : \u6D59\u6C5F\u4E7E\u864E\u79D1\u6280\u6709\u9650\u516C\u53F8\uFF08\u6216\u7B80\u79F0\u201C\u4E7E\u864E\u79D1\u6280\u201D\uFF09"),_react2.default.createElement("div",null,"\u5730\u5740 : \u6D59\u6C5F\u7701\u5B81\u6CE2\u5E02\u911E\u5DDE\u533A\u5929\u7AE5\u5357\u8DEF575\u53F7304\u5BA4"),_react2.default.createElement("div",null,"\u8054\u7CFB\u4EBA : \u97E9\u8D1D"),_react2.default.createElement("div",null,"\u8054\u7CFB\u7535\u8BDD : 17682358008")),_react2.default.createElement("div",{className:"module"},_react2.default.createElement("div",null,"\u4E00\u3001\u60A8\u901A\u8FC7 \u8D26\u53F7:  ",data.account,"\u8BA2\u8D2D\u4E7E\u864E\u79D1\u6280\u63D0\u4F9B\u7684\u5982\u4E0B\u4EA7\u54C1/\u670D\u52A1\uFF1A"),_react2.default.createElement("div",null,"\u8BA2\u5355\u7F16\u53F7 : ",data.out_trade_no||""),_react2.default.createElement("div",null,"\u8BA2\u5355\u65F6\u95F4 :  ",data.add_time?(0,_moment2.default)(data.add_time).format('YYYY年 MM月 DD日'):_react2.default.createElement("span",null,"\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\u5E74\xA0\xA0\xA0\xA0\xA0\u6708\xA0\xA0\xA0\xA0\xA0\u65E5")),_react2.default.createElement("div",null,"\u8BA2\u5355\u540D\u79F0 : \u5343\u4E58\u8D22\u52A1\u7BA1\u7406\u7CFB\u7EDF\uFF08GCH\u96C6\u56E2\u5B9A\u5236\u7248\uFF09"),_react2.default.createElement("div",null,"\u8BA2\u5355\u91D1\u989D : ",/[\u4e00-\u9fa5]/.test(data.money)?data.money:"￥"+(data.money||"9600.00")),_react2.default.createElement("div",null,"\u8D2D\u4E70\u5185\u5BB9 : \u5343\u4E58\u8D22\u52A1\u7BA1\u7406\u7CFB\u7EDF\uFF08GCH\u96C6\u56E2\u5B9A\u5236\u7248\uFF09\u4E00\u5E74\u4F7F\u7528\u6743"),_react2.default.createElement("div",null,"\u670D\u52A1\u6709\u6548\u65F6\u95F4 : ",(0,_moment2.default)(data.current_time||"2019-07-01").format('YYYY-MM-DD')," \u81F3 ",(0,_moment2.default)(data.expire_date).format('YYYY-MM-DD'))),_react2.default.createElement("div",{className:"module"},"\u4E8C\u3001\u60A8\u548C\u4E7E\u864E\u79D1\u6280\u5C31\u4E0A\u8FF0\u670D\u52A1\u7684\u5176\u5B83\u6743\u5229\u4E49\u52A1\uFF0C\u5E94\u4EE5\u53CC\u65B9\u5171\u540C\u786E\u8BA4\u7684\u670D\u52A1\u6761\u6B3E\u4E3A\u51C6\uFF08\u786E\u8BA4\u5F62\u5F0F\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u53CC\u65B9\u76D6\u7AE0\u3001\u6216\u60A8\u5728\u8BA2\u8D2D\u670D\u52A1\u65F6\u4E88\u4EE5\u7EBF\u4E0A\u70B9\u51FB\u786E\u8BA4\uFF09\u3002"),_react2.default.createElement("div",{className:"module"},"\u4E09\u3001\u60A8\u5E94\u6309\u65F6\u4ED8\u6B3E\u3002\u60A8\u8BA2\u8D2D\u7684\u5343\u4E58\u8D22\u52A1\u7BA1\u7406\u7CFB\u7EDF\uFF08GCH\u96C6\u56E2\u5B9A\u5236\u7248\uFF09\u4E3A\u9884\u4ED8\u8D39\u670D\u52A1\uFF0C\u5728\u6536\u5230\u60A8\u652F\u4ED8\u7684\u6B3E\u9879\u4E4B\u540E\uFF0C\u4E7E\u864E\u79D1\u6280\u624D\u5F00\u59CB\u4E3A\u60A8\u63D0\u4F9B\u5BF9\u5E94\u65F6\u957F\u7684\u670D\u52A1\u3002"),_react2.default.createElement("div",{className:"module"},"\u56DB\u3001\u4E7E\u864E\u79D1\u6280\u4FDD\u7559\u5728\u60A8\u672A\u6309\u7167\u7EA6\u5B9A\u652F\u4ED8\u5168\u90E8\u8D39\u7528\u4E4B\u524D\u4E0D\u5411\u60A8\u63D0\u4F9B\u670D\u52A1\u548C/\u6216\u6280\u672F\u652F\u6301\uFF0C\u6216\u8005\u7EC8\u6B62\u670D\u52A1\u548C/\u6216\u6280\u672F\u652F\u6301\u7684\u6743\u5229\u3002\u540C\u65F6\uFF0C\u4E7E\u864E\u79D1\u6280\u4FDD\u7559\u5BF9\u540E\u4ED8\u8D39\u670D\u52A1\u4E2D\u7684\u6B20\u8D39\u884C\u4E3A\u8FFD\u7A76\u6CD5\u5F8B\u8D23\u4EFB\u7684\u6743\u5229\u3002"),_react2.default.createElement("div",{className:"module"},_react2.default.createElement("div",null,"\u4E94\u3001\u60A8\u5E94\u5C06\u6B3E\u9879\u652F\u4ED8\u81F3\u4E7E\u864E\u79D1\u6280\u6307\u5B9A\u7684\u5982\u4E0B\u8D26\u53F7"),_react2.default.createElement("div",null,"\u5F00\u6237\u540D\u79F0\uFF1A\u6D59\u6C5F\u4E7E\u864E\u79D1\u6280\u6709\u9650\u516C\u53F8"),_react2.default.createElement("div",null,"\u5F00\u6237\u884C\uFF1A\u4E2D\u4FE1\u94F6\u884C\u80A1\u4EFD\u6709\u9650\u516C\u53F8\u5B81\u6CE2\u660E\u5DDE\u652F\u884C"),_react2.default.createElement("div",null,"\u8D26\u53F7\uFF1A8114701014600234364")),_react2.default.createElement("div",{className:"module"},"\u516D\u3001\u53D1\u7968\uFF1A\u652F\u4ED8\u6210\u529F\u540E\uFF0C\u60A8\u53EF\u767B\u9646",_react2.default.createElement("a",{href:"#"},"\u5343\u4E58\u8D22\u52A1\u7BA1\u7406\u7CFB\u7EDF\uFF08GCH\u96C6\u56E2\u5B9A\u5236\u7248\uFF09"),"\uFF0C\u5728\u7CFB\u7EDF\u540E\u53F0\u7533\u8BF7\u53D1\u7968\uFF0C\u4E7E\u864E\u79D1\u6280\u5C06\u5411\u60A8\u5F00\u5177\u7B49\u989D\u53D1\u7968\u5E76\u90AE\u5BC4\u7ED9\u60A8\u3002"),_react2.default.createElement("div",{className:"footer"},_react2.default.createElement("div",{className:"left"},_react2.default.createElement("div",null,"\u7532\u65B9 : ",data.hotel_name),_react2.default.createElement("div",null,"\uFF08\u76D6\u7AE0\u5904\uFF09"),_react2.default.createElement("div",null,"\u65E5\u671F : ",data.add_time?(0,_moment2.default)(data.add_time).format('YYYY年 MM月 DD日'):_react2.default.createElement("span",null,"\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\u5E74\xA0\xA0\xA0\xA0\xA0\u6708\xA0\xA0\xA0\xA0\xA0\u65E5"))),_react2.default.createElement("div",{className:"right"},isSeal&&_react2.default.createElement("img",{src:_2.default,alt:""}),_react2.default.createElement("div",null,"\u4E59\u65B9 : \u6D59\u6C5F\u4E7E\u864E\u79D1\u6280\u6709\u9650\u516C\u53F8"),_react2.default.createElement("div",null,"\uFF08\u76D6\u7AE0\u5904\uFF09"),_react2.default.createElement("div",null,"\u65E5\u671F : ",data.add_time?(0,_moment2.default)(data.add_time).format('YYYY年 MM月 DD日'):_react2.default.createElement("span",null,"\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\u5E74\xA0\xA0\xA0\xA0\xA0\u6708\xA0\xA0\xA0\xA0\xA0\u65E5")))));}}]);return Contract;}(_react.Component);exports.default=Contract;

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/印章.46806257.png";

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAM1BMVEX29vZMm/K92PWFufPj6/Xv8vbZ5vXP4fSgyPNlqPJTnvLg6vXE2/SqzfSPv/N7tPNyr/M51O3YAAAAUElEQVQY06WNWwqAMAwEd9OmtfV5/9MqsUgM+OX8LAxMAqydxq646bONHssQHJvkEVqQsxdlgoiJryQLakXixeaFAMqYMB5lfOuSP6LxRTsB5CQBZaOs3WIAAAAASUVORK5CYII="

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAATlBMVEX29vZZovLp8PWpzfTm7fXe6fXb6PVepfLR4vXv8vbW5fXI3fSUwfNMm/LP4fSGuvOFuvO91/S81/Sex/S/2POtz/OszvOIu/NrrPJSnvKtI5y0AAAAdElEQVQY03WMSRaEIAxEE8AQkFba2ftf1ERxWGgtPtR/FPCeKiPm6tG9Ncb627RWadtLoFEa/Ba5TL4/dfNPMruzd5iYiBP+S/cRwjgGiH43DiMADQMBRNRVnwRNXTdypF6wsIAPwYtgDbqbJn0dVjhDVC4bdk8DvG1PcPYAAAAASUVORK5CYII="

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAANlBMVEX29vaSwPPy8/bd6fXZ5vXh6/XE2/SWw/Nxr/NoqvJUn/JSnvLG3PSu0PN4svPq8PXN4PS71vPbrYmGAAAAbklEQVQY02WPWQ7AIAhEQVTcqu39L1tZmjTxfWgcHBhAiFxbqxzBCNgxE+V9BX3PkkBJZYqCRc57Sa3g9netX6R/egRGcEFAhpr/Qq7QyIRnjLGA2ifE4YJYHLd4UwdZxyo+1oIJFuyIfi53rP8CyPgDPOfqAR4AAAAASUVORK5CYII="

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAANlBMVEUAAABwr/dwrfJxrvJxrvNwr/9xrvJwrfFwrvFxrfFwr/JxrfFxrvJwrfJwr/RxrvJwr/NxrvJhZEcUAAAAEXRSTlMAIGDQkBCggHDgT/CwrzDAQHVJgkMAAAB/SURBVBjTTY4BDsUgCEMB0SFON+9/2d+I219jUlvJQ1qSNGcSenWeg2ic/clawouGc810935TbhwAJW7uSBqY48B5DTIl7yA7qW0GeCmBXHlvNbS4W6FQThK/y/RvvpmtoEEuxmuy6sAM3odWQTE3+llI0tR5Jdcmm3FN6FqMH7i7A1/6T93YAAAAAElFTkSuQmCC"

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAElBMVEUAAABwr/NxrvJwr/RwrvFxrvKO6aAVAAAABXRSTlMAQMAwb8qbgvYAAAAuSURBVAjXY8AGmAyYFcAMVgHGABSGaigQBAEZhqKOIoHCmGrgUnDFmGoQVmACAGrJCKOhhKnUAAAAAElFTkSuQmCC"

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(1370);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _Note=__webpack_require__(1376);var _Note2=_interopRequireDefault(_Note);var _getJson=__webpack_require__(252);var _getJson2=_interopRequireDefault(_getJson);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var listName=['actual','budget','lastYear'];listName.forEach(function(name){data[2][name]=(data[1][name]*data[0][name]).toFixed(2);data[6][name]=(numConvert(data[5][name])+numConvert(data[4][name])+numConvert(data[3][name])).toFixed(2);});_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.dataDefault);var data=JSON.parse(dataBegin);fetch('/mettingInfo?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/addMeeting',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table9_1',1.5,'0.10',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var numIndex=[2,6];var columns=_data.columnsData.map(function(item){if(item.children){return{title:item.title,children:item.children.map(function(v){return{title:v.title,dataIndex:v.key,key:v.key,width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:index==0?'inputPercent':numIndex.includes(index)?'number':v.type,name:v.key,onChange:_this2.onChange,totalIndex:[6]};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}};})};}return{title:item.title,dataIndex:item.key,key:item.key,width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:item.type,name:item.key,onChange:_this2.onChange,totalIndex:[6]};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}};});return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1 tableHeight'},_react2.default.createElement(_row2.default,{className:'title',id:'table9_1'},_react2.default.createElement(_row2.default,null,'Meeting Flash Report \u4F1A\u8BAE\u5373\u65F6\u62A5\u8868'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}}),_react2.default.createElement('span',{className:'deadline'},_react2.default.createElement('span',null,'\u622A\u6B62\u65E5\u671F:'),_react2.default.createElement(_datePicker2.default,{placeholder:'\u8BF7\u9009\u62E9\u622A\u6B62\u65E5\u671F',value:(0,_moment2.default)((0,_getJson2.default)([0,'deadline'],data,new Date()),"YYYY-MM-DD"),format:'YYYY-MM-DD',onChange:function onChange(date,str){var d=[].concat(_toConsumableArray(data));d[0].deadline=str;_this2.setState({data:d});}}))),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_Note2.default,{c:'\u6CE8\uFF1A\u622A\u6B62\u65E5\u671F\u4E3AES\u4F1A\u8BAE\u524D\u4E00\u5929\u6216\u8005\u4E24\u5929\u7684\u6570\u636E\u3002',e:'Note\uFF1AThe date should be one or two days before ES meeting.'})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_9_1'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165PDF'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var dataDefault=exports.dataDefault=[{name:'Occupancy% 出租率',actual:'0',budget:'0',lastYear:'0',score:""},{name:'Average RM Rate 平均房价',actual:'0',budget:'0',lastYear:'0',score:""},{name:'Revpar',actual:'0',budget:'0',lastYear:'0',score:""},{name:'Rooms Revenue 客房收入',actual:'0',budget:'0',lastYear:'0',score:""},{name:'Food & Beverage 餐饮收入',actual:'0',budget:'0',lastYear:'0',score:""},{name:'Other Revenue 其他收入',actual:'0',budget:'0',lastYear:'0',score:""},{name:'Grand Total 总计',actual:'0',budget:'0',lastYear:'0',score:""}];var columnsData=exports.columnsData=[{title:"-",key:"name",type:"text"},{title:"M.T.D. 本月累计",children:[{title:"Actual 实际",key:"actual",type:"inputNumber"},{title:"Budget 预算",key:"budget",type:"inputNumber"},{title:"Last Year 去年同期",key:"lastYear",type:"inputNumber"}]}];var WeekColumnsData=exports.WeekColumnsData=[{title:"-",key:"name",type:"text"},{title:"Current Week 本周",children:[{title:"Actual 实际",key:"week_actual",type:"inputNumber"},{title:"Budget 预算",key:"week_budget",type:"inputNumber"},{title:"Last Year 去年同期",key:"week_lastYear",type:"inputNumber"}]},{title:"M.T.D. 本月累计",children:[{title:"Actual 实际",key:"actual",type:"inputNumber"},{title:"Budget 预算",key:"budget",type:"inputNumber"},{title:"Last Year 去年同期",key:"lastYear",type:"inputNumber"}]}];

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__InputHandler__ = __webpack_require__(1372);











function noop() {}

function preventDefault(e) {
  e.preventDefault();
}

function defaultParser(input) {
  return input.replace(/[^\w\.-]+/g, '');
}

/**
 * When click and hold on a button - the speed of auto changin the value.
 */
var SPEED = 200;

/**
 * When click and hold on a button - the delay before auto changin the value.
 */
var DELAY = 600;

/**
 * Max Safe Integer -- on IE this is not available, so manually set the number in that case.
 * The reason this is used, instead of Infinity is because numbers above the MSI are unstable
 */
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;

var isValidProps = function isValidProps(value) {
  return value !== undefined && value !== null;
};

var isEqual = function isEqual(oldValue, newValue) {
  return newValue === oldValue || typeof newValue === 'number' && typeof oldValue === 'number' && isNaN(newValue) && isNaN(oldValue);
};

var InputNumber = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputNumber, _React$Component);

  function InputNumber(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputNumber);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var value = void 0;
    if ('value' in props) {
      value = props.value;
    } else {
      value = props.defaultValue;
    }
    _this.state = {
      focused: props.autoFocus
    };
    var validValue = _this.getValidValue(_this.toNumber(value));
    _this.state = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.state, {
      inputValue: _this.toPrecisionAsStep(validValue),
      value: validValue
    });
    return _this;
  }

  InputNumber.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate();
  };

  InputNumber.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _props = this.props,
        value = _props.value,
        onChange = _props.onChange,
        max = _props.max,
        min = _props.min;
    var focused = this.state.focused;

    // Don't trigger in componentDidMount

    if (prevProps) {
      if (!isEqual(prevProps.value, value) || !isEqual(prevProps.max, max) || !isEqual(prevProps.min, min)) {
        var validValue = focused ? value : this.getValidValue(value);
        var nextInputValue = void 0;
        if (this.pressingUpOrDown) {
          nextInputValue = validValue;
        } else if (this.inputting) {
          nextInputValue = this.rawInput;
        } else {
          nextInputValue = this.toPrecisionAsStep(validValue);
        }
        this.setState({ // eslint-disable-line
          value: validValue,
          inputValue: nextInputValue
        });
      }

      // Trigger onChange when max or min change
      // https://github.com/ant-design/ant-design/issues/11574
      var nextValue = 'value' in this.props ? value : this.state.value;
      // ref: null < 20 === true
      // https://github.com/ant-design/ant-design/issues/14277
      if ('max' in this.props && prevProps.max !== max && typeof nextValue === 'number' && nextValue > max && onChange) {
        onChange(max);
      }
      if ('min' in this.props && prevProps.min !== min && typeof nextValue === 'number' && nextValue < min && onChange) {
        onChange(min);
      }
    }

    // Restore cursor
    try {
      // Firefox set the input cursor after it get focused.
      // This caused that if an input didn't init with the selection,
      // set will cause cursor not correct when first focus.
      // Safari will focus input if set selection. We need skip this.
      if (this.cursorStart !== undefined && this.state.focused) {
        // In most cases, the string after cursor is stable.
        // We can move the cursor before it

        if (
        // If not match full str, try to match part of str
        !this.partRestoreByAfter(this.cursorAfter) && this.state.value !== this.props.value) {
          // If not match any of then, let's just keep the position
          // TODO: Logic should not reach here, need check if happens
          var pos = this.cursorStart + 1;

          // If not have last string, just position to the end
          if (!this.cursorAfter) {
            pos = this.input.value.length;
          } else if (this.lastKeyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].BACKSPACE) {
            pos = this.cursorStart - 1;
          } else if (this.lastKeyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].DELETE) {
            pos = this.cursorStart;
          }
          this.fixCaret(pos, pos);
        } else if (this.currentValue === this.input.value) {
          // Handle some special key code
          switch (this.lastKeyCode) {
            case __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].BACKSPACE:
              this.fixCaret(this.cursorStart - 1, this.cursorStart - 1);
              break;
            case __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].DELETE:
              this.fixCaret(this.cursorStart + 1, this.cursorStart + 1);
              break;
            default:
            // Do nothing
          }
        }
      }
    } catch (e) {}
    // Do nothing


    // Reset last key
    this.lastKeyCode = null;

    // pressingUpOrDown is true means that someone just click up or down button
    if (!this.pressingUpOrDown) {
      return;
    }
    if (this.props.focusOnUpDown && this.state.focused) {
      if (document.activeElement !== this.input) {
        this.focus();
      }
    }

    this.pressingUpOrDown = false;
  };

  InputNumber.prototype.componentWillUnmount = function componentWillUnmount() {
    this.stop();
  };

  InputNumber.prototype.getCurrentValidValue = function getCurrentValidValue(value) {
    var val = value;
    if (val === '') {
      val = '';
    } else if (!this.isNotCompleteNumber(parseFloat(val, 10))) {
      val = this.getValidValue(val);
    } else {
      val = this.state.value;
    }
    return this.toNumber(val);
  };

  InputNumber.prototype.getRatio = function getRatio(e) {
    var ratio = 1;
    if (e.metaKey || e.ctrlKey) {
      ratio = 0.1;
    } else if (e.shiftKey) {
      ratio = 10;
    }
    return ratio;
  };

  InputNumber.prototype.getValueFromEvent = function getValueFromEvent(e) {
    // optimize for chinese input expierence
    // https://github.com/ant-design/ant-design/issues/8196
    var value = e.target.value.trim().replace(/。/g, '.');

    if (isValidProps(this.props.decimalSeparator)) {
      value = value.replace(this.props.decimalSeparator, '.');
    }

    return value;
  };

  InputNumber.prototype.getValidValue = function getValidValue(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.min;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props.max;

    var val = parseFloat(value, 10);
    // https://github.com/ant-design/ant-design/issues/7358
    if (isNaN(val)) {
      return value;
    }
    if (val < min) {
      val = min;
    }
    if (val > max) {
      val = max;
    }
    return val;
  };

  InputNumber.prototype.setValue = function setValue(v, callback) {
    // trigger onChange
    var precision = this.props.precision;

    var newValue = this.isNotCompleteNumber(parseFloat(v, 10)) ? null : parseFloat(v, 10);
    var _state = this.state,
        _state$value = _state.value,
        value = _state$value === undefined ? null : _state$value,
        _state$inputValue = _state.inputValue,
        inputValue = _state$inputValue === undefined ? null : _state$inputValue;
    // https://github.com/ant-design/ant-design/issues/7363
    // https://github.com/ant-design/ant-design/issues/16622

    var newValueInString = typeof newValue === 'number' ? newValue.toFixed(precision) : '' + newValue;
    var changed = newValue !== value || newValueInString !== '' + inputValue;
    if (!('value' in this.props)) {
      this.setState({
        value: newValue,
        inputValue: this.toPrecisionAsStep(v)
      }, callback);
    } else {
      // always set input value same as value
      this.setState({
        inputValue: this.toPrecisionAsStep(this.state.value)
      }, callback);
    }
    if (changed) {
      this.props.onChange(newValue);
    }

    return newValue;
  };

  InputNumber.prototype.getPrecision = function getPrecision(value) {
    if (isValidProps(this.props.precision)) {
      return this.props.precision;
    }
    var valueString = value.toString();
    if (valueString.indexOf('e-') >= 0) {
      return parseInt(valueString.slice(valueString.indexOf('e-') + 2), 10);
    }
    var precision = 0;
    if (valueString.indexOf('.') >= 0) {
      precision = valueString.length - valueString.indexOf('.') - 1;
    }
    return precision;
  };

  // step={1.0} value={1.51}
  // press +
  // then value should be 2.51, rather than 2.5
  // if this.props.precision is undefined
  // https://github.com/react-component/input-number/issues/39


  InputNumber.prototype.getMaxPrecision = function getMaxPrecision(currentValue) {
    var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var _props2 = this.props,
        precision = _props2.precision,
        step = _props2.step;

    if (isValidProps(precision)) {
      return precision;
    }
    var ratioPrecision = this.getPrecision(ratio);
    var stepPrecision = this.getPrecision(step);
    var currentValuePrecision = this.getPrecision(currentValue);
    if (!currentValue) {
      return ratioPrecision + stepPrecision;
    }
    return Math.max(currentValuePrecision, ratioPrecision + stepPrecision);
  };

  InputNumber.prototype.getPrecisionFactor = function getPrecisionFactor(currentValue) {
    var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var precision = this.getMaxPrecision(currentValue, ratio);
    return Math.pow(10, precision);
  };

  InputNumber.prototype.fixCaret = function fixCaret(start, end) {
    if (start === undefined || end === undefined || !this.input || !this.input.value) {
      return;
    }

    try {
      var currentStart = this.input.selectionStart;
      var currentEnd = this.input.selectionEnd;

      if (start !== currentStart || end !== currentEnd) {
        this.input.setSelectionRange(start, end);
      }
    } catch (e) {
      // Fix error in Chrome:
      // Failed to read the 'selectionStart' property from 'HTMLInputElement'
      // http://stackoverflow.com/q/21177489/3040605
    }
  };

  InputNumber.prototype.focus = function focus() {
    this.input.focus();
    this.recordCursorPosition();
  };

  InputNumber.prototype.blur = function blur() {
    this.input.blur();
  };

  InputNumber.prototype.select = function select() {
    this.input.select();
  };

  InputNumber.prototype.formatWrapper = function formatWrapper(num) {
    // http://2ality.com/2012/03/signedzero.html
    // https://github.com/ant-design/ant-design/issues/9439
    if (this.props.formatter) {
      return this.props.formatter(num);
    }
    return num;
  };

  InputNumber.prototype.toPrecisionAsStep = function toPrecisionAsStep(num) {
    if (this.isNotCompleteNumber(num) || num === '') {
      return num;
    }
    var precision = Math.abs(this.getMaxPrecision(num));
    if (!isNaN(precision)) {
      return Number(num).toFixed(precision);
    }
    return num.toString();
  };

  // '1.' '1x' 'xx' '' => are not complete numbers


  InputNumber.prototype.isNotCompleteNumber = function isNotCompleteNumber(num) {
    return isNaN(num) || num === '' || num === null || num && num.toString().indexOf('.') === num.toString().length - 1;
  };

  InputNumber.prototype.toNumber = function toNumber(num) {
    var precision = this.props.precision;
    var focused = this.state.focused;
    // num.length > 16 => This is to prevent input of large numbers

    var numberIsTooLarge = num && num.length > 16 && focused;
    if (this.isNotCompleteNumber(num) || numberIsTooLarge) {
      return num;
    }
    if (isValidProps(precision)) {
      return Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision);
    }
    return Number(num);
  };

  InputNumber.prototype.upStep = function upStep(val, rat) {
    var step = this.props.step;

    var precisionFactor = this.getPrecisionFactor(val, rat);
    var precision = Math.abs(this.getMaxPrecision(val, rat));
    var result = ((precisionFactor * val + precisionFactor * step * rat) / precisionFactor).toFixed(precision);
    return this.toNumber(result);
  };

  InputNumber.prototype.downStep = function downStep(val, rat) {
    var step = this.props.step;

    var precisionFactor = this.getPrecisionFactor(val, rat);
    var precision = Math.abs(this.getMaxPrecision(val, rat));
    var result = ((precisionFactor * val - precisionFactor * step * rat) / precisionFactor).toFixed(precision);
    return this.toNumber(result);
  };

  InputNumber.prototype.step = function step(type, e) {
    var _this2 = this;

    var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var recursive = arguments[3];

    this.stop();
    if (e) {
      e.persist();
      e.preventDefault();
    }
    var props = this.props;
    if (props.disabled) {
      return;
    }
    var value = this.getCurrentValidValue(this.state.inputValue) || 0;
    if (this.isNotCompleteNumber(value)) {
      return;
    }
    var val = this[type + 'Step'](value, ratio);
    var outOfRange = val > props.max || val < props.min;
    if (val > props.max) {
      val = props.max;
    } else if (val < props.min) {
      val = props.min;
    }
    this.setValue(val);
    this.setState({
      focused: true
    });
    if (outOfRange) {
      return;
    }
    this.autoStepTimer = setTimeout(function () {
      _this2[type](e, ratio, true);
    }, recursive ? SPEED : DELAY);
  };

  InputNumber.prototype.render = function render() {
    var _classNames;

    var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props);

    var prefixCls = props.prefixCls,
        disabled = props.disabled,
        readOnly = props.readOnly,
        useTouch = props.useTouch,
        autoComplete = props.autoComplete,
        upHandler = props.upHandler,
        downHandler = props.downHandler,
        rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(props, ['prefixCls', 'disabled', 'readOnly', 'useTouch', 'autoComplete', 'upHandler', 'downHandler']);

    var classes = __WEBPACK_IMPORTED_MODULE_7_classnames___default()((_classNames = {}, _classNames[prefixCls] = true, _classNames[props.className] = !!props.className, _classNames[prefixCls + '-disabled'] = disabled, _classNames[prefixCls + '-focused'] = this.state.focused, _classNames));
    var upDisabledClass = '';
    var downDisabledClass = '';
    var _state2 = this.state,
        value = _state2.value,
        inputValue = _state2.inputValue;

    if (value || value === 0) {
      if (!isNaN(value)) {
        var val = Number(value);
        if (val >= props.max) {
          upDisabledClass = prefixCls + '-handler-up-disabled';
        }
        if (val <= props.min) {
          downDisabledClass = prefixCls + '-handler-down-disabled';
        }
      } else {
        upDisabledClass = prefixCls + '-handler-up-disabled';
        downDisabledClass = prefixCls + '-handler-down-disabled';
      }
    }

    var dataOrAriaAttributeProps = {};
    for (var key in props) {
      if (props.hasOwnProperty(key) && (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role')) {
        dataOrAriaAttributeProps[key] = props[key];
      }
    }

    var editable = !props.readOnly && !props.disabled;

    // focus state, show input value
    // unfocus state, show valid value
    var inputDisplayValue = this.composing ? inputValue : this.getInputDisplayValue();

    var upEvents = void 0;
    var downEvents = void 0;
    if (useTouch) {
      upEvents = {
        onTouchStart: editable && !upDisabledClass ? this.up : noop,
        onTouchEnd: this.stop
      };
      downEvents = {
        onTouchStart: editable && !downDisabledClass ? this.down : noop,
        onTouchEnd: this.stop
      };
    } else {
      upEvents = {
        onMouseDown: editable && !upDisabledClass ? this.up : noop,
        onMouseUp: this.stop,
        onMouseLeave: this.stop
      };
      downEvents = {
        onMouseDown: editable && !downDisabledClass ? this.down : noop,
        onMouseUp: this.stop,
        onMouseLeave: this.stop
      };
    }

    var isUpDisabled = !!upDisabledClass || disabled || readOnly;
    var isDownDisabled = !!downDisabledClass || disabled || readOnly;
    // ref for test
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'div',
      {
        className: classes,
        style: props.style,
        title: props.title,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseOver: props.onMouseOver,
        onMouseOut: props.onMouseOut,
        onCompositionStart: this.onComposition,
        onCompositionEnd: this.onComposition
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-handler-wrap' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__InputHandler__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
            ref: this.saveUp,
            disabled: isUpDisabled,
            prefixCls: prefixCls,
            unselectable: 'unselectable'
          }, upEvents, {
            role: 'button',
            'aria-label': 'Increase Value',
            'aria-disabled': !!isUpDisabled,
            className: prefixCls + '-handler ' + prefixCls + '-handler-up ' + upDisabledClass
          }),
          upHandler || __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', {
            unselectable: 'unselectable',
            className: prefixCls + '-handler-up-inner',
            onClick: preventDefault
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__InputHandler__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
            ref: this.saveDown,
            disabled: isDownDisabled,
            prefixCls: prefixCls,
            unselectable: 'unselectable'
          }, downEvents, {
            role: 'button',
            'aria-label': 'Decrease Value',
            'aria-disabled': !!isDownDisabled,
            className: prefixCls + '-handler ' + prefixCls + '-handler-down ' + downDisabledClass
          }),
          downHandler || __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', {
            unselectable: 'unselectable',
            className: prefixCls + '-handler-down-inner',
            onClick: preventDefault
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        {
          className: prefixCls + '-input-wrap'
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          role: 'spinbutton',
          'aria-valuemin': props.min,
          'aria-valuemax': props.max,
          'aria-valuenow': value,
          required: props.required,
          type: props.type,
          placeholder: props.placeholder,
          onClick: props.onClick,
          onMouseUp: this.onMouseUp,
          className: prefixCls + '-input',
          tabIndex: props.tabIndex,
          autoComplete: autoComplete,
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          onKeyDown: editable ? this.onKeyDown : noop,
          onKeyUp: editable ? this.onKeyUp : noop,
          autoFocus: props.autoFocus,
          maxLength: props.maxLength,
          readOnly: props.readOnly,
          disabled: props.disabled,
          max: props.max,
          min: props.min,
          step: props.step,
          name: props.name,
          title: props.title,
          id: props.id,
          onChange: this.onChange,
          ref: this.saveInput,
          value: inputDisplayValue,
          pattern: props.pattern,
          inputMode: props.inputMode
        }, dataOrAriaAttributeProps))
      )
    );
  };

  return InputNumber;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

InputNumber.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  defaultValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  focusOnUpDown: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onPressEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onKeyUp: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  tabIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  readOnly: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  max: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  min: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  step: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  upHandler: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  downHandler: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  useTouch: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  formatter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  parser: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseOver: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseOut: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseUp: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  precision: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  required: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  pattern: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  decimalSeparator: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  inputMode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
InputNumber.defaultProps = {
  focusOnUpDown: true,
  useTouch: false,
  prefixCls: 'rc-input-number',
  min: -MAX_SAFE_INTEGER,
  step: 1,
  style: {},
  onChange: noop,
  onKeyDown: noop,
  onPressEnter: noop,
  onFocus: noop,
  onBlur: noop,
  parser: defaultParser,
  required: false,
  autoComplete: 'off'
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onKeyDown = function (e) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var _props3 = _this3.props,
        onKeyDown = _props3.onKeyDown,
        onPressEnter = _props3.onPressEnter;


    if (e.keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].UP) {
      var ratio = _this3.getRatio(e);
      _this3.up(e, ratio);
      _this3.stop();
    } else if (e.keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].DOWN) {
      var _ratio = _this3.getRatio(e);
      _this3.down(e, _ratio);
      _this3.stop();
    } else if (e.keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].ENTER && onPressEnter) {
      onPressEnter(e);
    }

    // Trigger user key down
    _this3.recordCursorPosition();
    _this3.lastKeyCode = e.keyCode;
    if (onKeyDown) {
      onKeyDown.apply(undefined, [e].concat(args));
    }
  };

  this.onKeyUp = function (e) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    var onKeyUp = _this3.props.onKeyUp;


    _this3.stop();

    _this3.recordCursorPosition();

    // Trigger user key up
    if (onKeyUp) {
      onKeyUp.apply(undefined, [e].concat(args));
    }
  };

  this.onChange = function (e) {
    var onChange = _this3.props.onChange;

    if (_this3.state.focused) {
      _this3.inputting = true;
    }
    _this3.rawInput = _this3.props.parser(_this3.getValueFromEvent(e));
    if (_this3.composing) {
      _this3.setState({ inputValue: _this3.getValueFromEvent(e) });
    } else {
      _this3.setState({ inputValue: _this3.rawInput });
      onChange(_this3.toNumber(_this3.rawInput)); // valid number or invalid string
    }
  };

  this.onMouseUp = function () {
    var onMouseUp = _this3.props.onMouseUp;


    _this3.recordCursorPosition();

    if (onMouseUp) {
      onMouseUp.apply(undefined, arguments);
    }
  };

  this.onFocus = function () {
    var _props4;

    _this3.setState({
      focused: true
    });
    (_props4 = _this3.props).onFocus.apply(_props4, arguments);
  };

  this.onBlur = function () {
    var onBlur = _this3.props.onBlur;

    _this3.inputting = false;
    _this3.setState({
      focused: false
    });
    var value = _this3.getCurrentValidValue(_this3.state.inputValue);
    var newValue = _this3.setValue(value);

    if (onBlur) {
      var originValue = _this3.input.value;
      var inputValue = _this3.getInputDisplayValue({ focus: false, value: newValue });
      _this3.input.value = inputValue;
      onBlur.apply(undefined, arguments);
      _this3.input.value = originValue;
    }
  };

  this.onComposition = function (e) {
    if (e.type === 'compositionstart') {
      _this3.composing = true;
    } else if (e.type === 'compositionend') {
      _this3.composing = false;
      _this3.onChange(e);
    }
  };

  this.getInputDisplayValue = function (state) {
    var _ref = state || _this3.state,
        focused = _ref.focused,
        inputValue = _ref.inputValue,
        value = _ref.value;

    var inputDisplayValue = void 0;
    if (focused) {
      inputDisplayValue = inputValue;
    } else {
      inputDisplayValue = _this3.toPrecisionAsStep(value);
    }

    if (inputDisplayValue === undefined || inputDisplayValue === null) {
      inputDisplayValue = '';
    }

    var inputDisplayValueFormat = _this3.formatWrapper(inputDisplayValue);
    if (isValidProps(_this3.props.decimalSeparator)) {
      inputDisplayValueFormat = inputDisplayValueFormat.toString().replace('.', _this3.props.decimalSeparator);
    }

    return inputDisplayValueFormat;
  };

  this.recordCursorPosition = function () {
    // Record position
    try {
      _this3.cursorStart = _this3.input.selectionStart;
      _this3.cursorEnd = _this3.input.selectionEnd;
      _this3.currentValue = _this3.input.value;
      _this3.cursorBefore = _this3.input.value.substring(0, _this3.cursorStart);
      _this3.cursorAfter = _this3.input.value.substring(_this3.cursorEnd);
    } catch (e) {
      // Fix error in Chrome:
      // Failed to read the 'selectionStart' property from 'HTMLInputElement'
      // http://stackoverflow.com/q/21177489/3040605
    }
  };

  this.restoreByAfter = function (str) {
    if (str === undefined) return false;

    var fullStr = _this3.input.value;
    var index = fullStr.lastIndexOf(str);

    if (index === -1) return false;

    var prevCursorPos = _this3.cursorBefore.length;
    if (_this3.lastKeyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].DELETE && _this3.cursorBefore.charAt(prevCursorPos - 1) === str[0]) {
      _this3.fixCaret(prevCursorPos, prevCursorPos);
      return true;
    }

    if (index + str.length === fullStr.length) {
      _this3.fixCaret(index, index);

      return true;
    }
    return false;
  };

  this.partRestoreByAfter = function (str) {
    if (str === undefined) return false;

    // For loop from full str to the str with last char to map. e.g. 123
    // -> 123
    // -> 23
    // -> 3
    return Array.prototype.some.call(str, function (_, start) {
      var partStr = str.substring(start);

      return _this3.restoreByAfter(partStr);
    });
  };

  this.stop = function () {
    if (_this3.autoStepTimer) {
      clearTimeout(_this3.autoStepTimer);
    }
  };

  this.down = function (e, ratio, recursive) {
    _this3.pressingUpOrDown = true;
    _this3.step('down', e, ratio, recursive);
  };

  this.up = function (e, ratio, recursive) {
    _this3.pressingUpOrDown = true;
    _this3.step('up', e, ratio, recursive);
  };

  this.saveUp = function (node) {
    _this3.upHandler = node;
  };

  this.saveDown = function (node) {
    _this3.downHandler = node;
  };

  this.saveInput = function (node) {
    _this3.input = node;
  };
};

/* harmony default export */ __webpack_exports__["default"] = (InputNumber);

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rmc_feedback__ = __webpack_require__(1373);








var InputHandler = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(InputHandler, _Component);

  function InputHandler() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, InputHandler);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  InputHandler.prototype.render = function render() {
    var _props = this.props,
        prefixCls = _props.prefixCls,
        disabled = _props.disabled,
        otherProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['prefixCls', 'disabled']);

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_rmc_feedback__["a" /* default */],
      {
        disabled: disabled,
        activeClassName: prefixCls + '-handler-active'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', otherProps)
    );
  };

  return InputHandler;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

InputHandler.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onTouchEnd: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseUp: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (InputHandler);

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TouchFeedback__ = __webpack_require__(1374);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TouchFeedback__["a"]; });


/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);








var TouchFeedback = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TouchFeedback, _React$Component);

    function TouchFeedback() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TouchFeedback);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TouchFeedback.__proto__ || Object.getPrototypeOf(TouchFeedback)).apply(this, arguments));

        _this.state = {
            active: false
        };
        _this.onTouchStart = function (e) {
            _this.triggerEvent('TouchStart', true, e);
        };
        _this.onTouchMove = function (e) {
            _this.triggerEvent('TouchMove', false, e);
        };
        _this.onTouchEnd = function (e) {
            _this.triggerEvent('TouchEnd', false, e);
        };
        _this.onTouchCancel = function (e) {
            _this.triggerEvent('TouchCancel', false, e);
        };
        _this.onMouseDown = function (e) {
            // pc simulate mobile
            _this.triggerEvent('MouseDown', true, e);
        };
        _this.onMouseUp = function (e) {
            _this.triggerEvent('MouseUp', false, e);
        };
        _this.onMouseLeave = function (e) {
            _this.triggerEvent('MouseLeave', false, e);
        };
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TouchFeedback, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.disabled && this.state.active) {
                this.setState({
                    active: false
                });
            }
        }
    }, {
        key: 'triggerEvent',
        value: function triggerEvent(type, isActive, ev) {
            var eventType = 'on' + type;
            var children = this.props.children;

            if (children.props[eventType]) {
                children.props[eventType](ev);
            }
            if (isActive !== this.state.active) {
                this.setState({
                    active: isActive
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                disabled = _props.disabled,
                activeClassName = _props.activeClassName,
                activeStyle = _props.activeStyle;

            var events = disabled ? undefined : {
                onTouchStart: this.onTouchStart,
                onTouchMove: this.onTouchMove,
                onTouchEnd: this.onTouchEnd,
                onTouchCancel: this.onTouchCancel,
                onMouseDown: this.onMouseDown,
                onMouseUp: this.onMouseUp,
                onMouseLeave: this.onMouseLeave
            };
            var child = __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.only(children);
            if (!disabled && this.state.active) {
                var _child$props = child.props,
                    style = _child$props.style,
                    className = _child$props.className;

                if (activeStyle !== false) {
                    if (activeStyle) {
                        style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, activeStyle);
                    }
                    className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, activeClassName);
                }
                return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(child, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: className,
                    style: style }, events));
            }
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(child, events);
        }
    }]);

    return TouchFeedback;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (TouchFeedback);

TouchFeedback.defaultProps = {
    disabled: false
};

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1377);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var App=function App(props){if(props.note){return props.note;}return _react2.default.createElement("div",{className:"meeting-note"},props.e,_react2.default.createElement("br",null),props.c,_react2.default.createElement("br",null),_react2.default.createElement("br",null),props.note_e||"",_react2.default.createElement("br",null),props.note_c||"");};exports.default=App;

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _popconfirm=__webpack_require__(110);var _popconfirm2=_interopRequireDefault(_popconfirm);var _divider=__webpack_require__(343);var _divider2=_interopRequireDefault(_divider);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _tree=__webpack_require__(224);var _tree2=_interopRequireDefault(_tree);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(62);__webpack_require__(12);__webpack_require__(8);__webpack_require__(4);__webpack_require__(60);__webpack_require__(6);__webpack_require__(25);__webpack_require__(111);__webpack_require__(344);__webpack_require__(10);__webpack_require__(42);__webpack_require__(225);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(197);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TreeNode=_tree2.default.TreeNode;var Option=_select2.default.Option;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getData=function(){fetch('/typelst',{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this.setState({loading:false});if(x.status==1){_this.setState({data:x.data||[],dataTotal:x.data||[]});console.log(x.data);return;}_message3.default.error('数据获取失败！'+JSON.stringify(x.msg));}).catch(function(err){_this.setState({loading:false});console.error(err);_message3.default.error('数据获取失败！'+JSON.stringify(err));});};_this.onChange=function(value,lable,extra){_this.setState({});};_this.handleOk=function(e){_this.setState({loadingSave:true});var name=_this.state.editname;var id=_this.state.thisId;var dataFrom=new FormData();dataFrom.append('name',name);!id?'':dataFrom.append('id',id);var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/actionType',headres).then(function(x){return x.json();}).then(function(x){if(x.status==1){_message3.default.info('保存成功！');_this.getData();_this.setState({visible:false,loadingSave:false,loading:true});return;}_message3.default.error(x.msg);_this.setState({loadingSave:false});}).catch(function(err){console.error(err);_message3.default.error('数据添加失败！');_this.setState({loadingSave:false});});};_this.handleCancel=function(e){_this.setState({visible:false});};_this.showModal=function(){_this.setState({visible:true});};_this.delType=function(id){fetch('/deleteType?id='+id,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.status==1){_message3.default.info('删除成功！');_this.getData();return;}_message3.default.error(x.msg);}).catch(function(err){console.error(err);_message3.default.error('数据删除失败！');});};_this.state={data:[],visible:false,loading:true,loadingSave:false,editname:'',thisId:'',searchname:'',dataTotal:[]};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData();}},{key:'render',value:function render(){var _this2=this;var columns=[{title:'序号',dataIndex:'id',key:'id'},{title:'标签名称',dataIndex:'name',key:'name'},{title:'操作',key:'action',render:function render(record){return _react2.default.createElement('div',null,_react2.default.createElement('span',{style:{color:"#1890ff",cursor:"pointer"},onClick:function onClick(){_this2.setState({thisId:record.id,editname:record.name},_this2.showModal);}},'\u7F16\u8F91'),_react2.default.createElement(_divider2.default,{type:'vertical'}),_react2.default.createElement(_popconfirm2.default,{title:'\u786E\u5B9A\u8981\u5220\u9664\u5417?',onConfirm:function onConfirm(){_this2.delType(record.id);},okText:'\u786E\u5B9A',cancelText:'\u53D6\u6D88'},_react2.default.createElement('span',{style:{color:"#1890ff",cursor:"pointer"}},'\u5220\u9664')));}}];var data=this.state.data;return _react2.default.createElement('div',{className:'settings'},_react2.default.createElement(_row2.default,{style:{margin:'20px 0'}},_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement('span',null,'\u540D\u79F0\uFF1A'),_react2.default.createElement(_input2.default,{style:{width:200,marginRight:10},value:this.state.searchname,onChange:function onChange(e){_this2.setState({searchname:e.target.value});}}),_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){var newdata=(_this2.state.dataTotal||[]).filter(function(item){return(item.name||"").includes(_this2.state.searchname);});_this2.setState({data:newdata});}},'\u641C\u7D22')),_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement(_row2.default,{type:'flex',justify:'end'},_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){_this2.setState({thisId:'',editname:''},_this2.showModal);},style:{marginRight:10}},'\u65B0\u589E')))),_react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement(_table2.default,{style:{marginTop:20},columns:columns,dataSource:data,bordered:true,rowKey:function rowKey(item,index){return index;}})),_react2.default.createElement(_row2.default,{style:{textAlign:"right",marginTop:20}},_react2.default.createElement(_button2.default,{key:'submit',type:'primary',onClick:function onClick(){_this2.props.history.goBack();}},'\u8FD4\u56DE')),_react2.default.createElement(_modal2.default,{title:!this.state.thisId?"标签添加":"编辑标签",visible:this.state.visible,onOk:this.handleOk,onCancel:this.handleCancel,footer:[_react2.default.createElement(_button2.default,{key:'back',onClick:this.handleCancel},'\u53D6\u6D88'),_react2.default.createElement(_button2.default,{key:'submit',type:'primary',loading:this.state.loadingSave,onClick:this.handleOk},'\u4FDD\u5B58')]},_react2.default.createElement(_row2.default,{className:'modal'},_react2.default.createElement(_row2.default,null,_react2.default.createElement('span',null,'\u6807\u7B7E\u540D\u79F0\uFF1A'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u6807\u7B7E\u540D\u79F0',style:{width:'60%',marginLeft:10},value:this.state.editname,onChange:function onChange(e){_this2.setState({editname:e.target.value||""});}})))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(8);__webpack_require__(4);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _data=__webpack_require__(1380);__webpack_require__(1381);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data_guest);var data=JSON.parse(dataBegin);var lastTen=[];var topTen=[];var year=(0,_moment2.default)(date).format('YYYY');var month=(0,_moment2.default)(date).format('M');fetch('/getguestrating?year='+year+'&month='+month,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){data=[_extends({},x.data.table)];lastTen=x.data.lastTen||[];topTen=x.data.topTen||[];_this.setState({data:data,lastTen:lastTen,topTen:topTen,loading:false});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),loading:true,data:[],lastTen:[],topTen:[]};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);this.setState({loading:false});}},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,lastTen=_state.lastTen,topTen=_state.topTen;var columns=[{title:data[0]&&data[0].hotel_name,children:[{title:_react2.default.createElement('div',null,'Current Month',_react2.default.createElement('br',null),'\u672C\u6708'),key:'mtd',dataIndex:'mtd',align:'center',render:function render(text,record){return _react2.default.createElement('div',{className:'table-guestrating'},record.mtd||"-");}}]},{children:[{title:_react2.default.createElement('div',null,'Ranking',_react2.default.createElement('br',null),'\u6392\u5E8F'),key:'sort',dataIndex:'sort',align:'center',render:function render(text,record){return _react2.default.createElement('div',{className:'table-guestrating'},text||"NA");}}]},{title:'',children:[{title:_react2.default.createElement('div',null,'Total No. of Review',_react2.default.createElement('br',null),'\u8BC4\u8BBA\u6570'),key:'total',dataIndex:'total',align:'center',render:function render(text,record){return _react2.default.createElement('div',{className:'table-guestrating'},text||"-");}}]},{title:'',children:[{title:_react2.default.createElement('div',null,'Cleanliness',_react2.default.createElement('br',null),'\u6D01\u51C0\u5EA6'),key:'cleanliness',dataIndex:'cleanliness',align:'center',render:function render(text,record){return _react2.default.createElement('div',{className:'table-guestrating'},text||"-");}}]},{title:'',children:[{title:_react2.default.createElement('div',null,'Service',_react2.default.createElement('br',null),'\u670D\u52A1'),key:'service',dataIndex:'service',align:'center',render:function render(text,record){return _react2.default.createElement('div',{className:'table-guestrating'},text||"-");}}]},{title:'',children:[{title:_react2.default.createElement('div',null,'YTD',_react2.default.createElement('br',null),'\u5E74\u7D2F\u8BA1'),key:'ytd',dataIndex:'ytd',align:'center',render:function render(text,record){return _react2.default.createElement('div',{className:'table-guestrating'},text||"-");}}]},{title:'',children:[{title:_react2.default.createElement('div',null,'Ranking',_react2.default.createElement('br',null),'\u6392\u5E8F'),key:'ytd_sort',dataIndex:'ytd_sort',align:'center',render:function render(text,record){return _react2.default.createElement('div',{className:'table-guestrating'},text||"NA");}}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1 table-gust-rating'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_1_1',style:{width:this.state.print?2600:'auto'}},_react2.default.createElement(_row2.default,null,'WynReview - Medallia \u5BA2\u4EBA\u8BC4\u5206'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}}),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',id:'table',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return record.hotel_name;}}),_react2.default.createElement('div',{className:'remarks'},'*\u6708\u8BC4\u8BBA\u6570\u8FBE\u523030\u6761\u4E3A\u6709\u6548\u5BA2\u8BC4\u5206\u6570\uFF0C\u53EF\u7EB3\u5165\u96C6\u56E2\u6392\u540D\uFF1B\u672A\u8FBE30\u6761\u4E3A\u65E0\u6548\u3002'),_react2.default.createElement('div',{style:{marginTop:50}},_react2.default.createElement('div',{className:'list-l'},_react2.default.createElement('div',{className:'list-title'},'\u672C\u6708\u7EA2\u699C',_react2.default.createElement('span',{className:'list-title-s'},'\uFF08\u6392\u540D\u524D\u5341\u9152\u5E97 TOP 10\uFF09')),_react2.default.createElement('div',{className:'p-l-r-24'},(topTen||[]).map(function(item,i){return _react2.default.createElement('div',{className:'list-item'},_react2.default.createElement('span',{className:'list-item-no'},i+1),_react2.default.createElement('span',null,item.hotel_name));}))),_react2.default.createElement('div',{className:'list-r'},_react2.default.createElement('div',{className:'list-title'},_react2.default.createElement('span',{className:'list-title-s'},'\u672C\u6708\u9ED1\u699C\uFF08\u6392\u540D\u540E\u5341\u540D\u9152\u5E97 BOTTOM 10\uFF09')),_react2.default.createElement('div',{className:'p-l-r-24'},(lastTen||[]).map(function(item,i){return _react2.default.createElement('div',{className:'list-item'},_react2.default.createElement('span',{className:'list-item-no'},i+1),_react2.default.createElement('span',null,item.hotel_name));})))))),_react2.default.createElement('div',{className:'footer-notes'},'Notes\uFF1A',_react2.default.createElement('br',null),'1. \u6BCF\u6708\u9152\u5E97\u5BA2\u8BC4\u603B\u5206\u57FA\u4E8E\u8BE5\u9152\u5E97\u5728Medallia\u5E73\u53F0\u6DFB\u52A0\u7684\u6240\u6709\u6E20\u9053\u7684\u6708\u5EA6\u603B\u5206overall score;',_react2.default.createElement('br',null),'2. Total No. of Review\u662F\u9152\u5E97\u5728Medallia\u5E73\u53F0\u6240\u6709\u6DFB\u52A0\u6E20\u9053\u7684\u603B\u70B9\u8BC4\u6570\uFF1B',_react2.default.createElement('br',null),'3. Cleanliness\u548CService\u7684\u5206\u6570\u53D6\u81EA\u8BE5\u9152\u5E97\u5728\u643A\u7A0B\u4E0A\u76F8\u5E94\u7684\u6708\u5EA6\u5206\u6570\uFF08\u5982\u9152\u5E97\u672A\u6DFB\u52A0\u643A\u7A0B\u6E20\u9053\uFF0C\u5219\u6293\u53D6TripAdvisor\u4E0A\u76F8\u5E94\u7684\u5206\u503C\uFF09\uFF1B',_react2.default.createElement('br',null),'4. YTD\u7684\u8BC4\u5206\u53D6\u81EAMedallia\u5E73\u53F0\u6293\u53D6\u9152\u5E97\u6240\u6709\u6DFB\u52A0\u6E20\u9053\u7684\u5F53\u5E74\u5EA6\u622A\u6B62\u81F3\u4ECA\u7684\u603B\u8BC4\u5206\u3002')));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data_guest=exports.data_guest=[{currentMonth:'N/A',currentMonthNo:'N/A',totalNoOfReview:'N/A',Cleanliness:'N/A',Service:'N/A',YTD:'N/A',YTDNo:'N/A'}];

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(4);__webpack_require__(60);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);__webpack_require__(231);var _rank=__webpack_require__(1383);var _rank2=_interopRequireDefault(_rank);var _chart=__webpack_require__(1384);var _chart2=_interopRequireDefault(_chart);var _comments=__webpack_require__(1385);var _comments2=_interopRequireDefault(_comments);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){var _this2=this;var loading=this.props.store.criticism.loading;var _props$store$groupCha=this.props.store.groupChannels,rivalData=_props$store$groupCha.rivalData,rival=_props$store$groupCha.rival;return _react2.default.createElement('div',{className:'groupOfChannels'},_react2.default.createElement('div',{className:'title'},'Online Travel Agency \u7F51\u7EDC\u5E73\u53F0'),rivalData.length>0&&_react2.default.createElement('div',{className:'rival'},_react2.default.createElement('span',{className:'name'},'\u7ADE\u4E89\u5BF9\u624B'),_react2.default.createElement(_select2.default,{showSearch:true,style:{width:200},placeholder:'\u8BF7\u9009\u62E9\u7ADE\u4E89\u5BF9\u624B',value:rival||undefined,onChange:function onChange(v){(0,_mobx.runInAction)(function(){_this2.props.store.groupChannels.rival=v;});_this2.props.store.groupChannels.getDataCount(v);_this2.props.store.groupChannels.getData('5.0','','',1,'1',v);_this2.props.store.criticism.getData(v);}},rivalData.map(function(x){return _react2.default.createElement(Option,{key:x.name},x.name);}))),_react2.default.createElement(_spin2.default,{spinning:loading,tip:'\u52A0\u8F7D\u4E2D\u3002\u3002\u3002'},_react2.default.createElement(_row2.default,{gutter:40},_react2.default.createElement(_col2.default,{span:7},_react2.default.createElement(_rank2.default,{history:this.props.history})),_react2.default.createElement(_col2.default,{span:17},_react2.default.createElement(_chart2.default,null)))),_react2.default.createElement(_comments2.default,null));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);__webpack_require__(231);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.props.store.criticism.getData(this.props.store.groupChannels.rival);}},{key:'render',value:function render(){var _this2=this;var _props$store$criticis=this.props.store.criticism,data=_props$store$criticis.data,loading=_props$store$criticis.loading;var listName={'早餐':"Breakfast",'周边环境':"Environment",'位置':"Location",'交通':"Transportation",'卫生':"Clean",'房间环境':"Rooms",'服务':"Service"};return _react2.default.createElement('div',{className:'groupOfChannels_rank'},_react2.default.createElement('div',{className:'rank_title'},'\u6279\u8BC4\u6700\u591A TOP 7 Negative Comments'),data.map(function(item,index){return _react2.default.createElement('div',{className:'list',key:index,style:{cursor:'pointer'},onClick:function onClick(){_this2.props.history.push('/table/criticism/'+item.name+'/'+_this2.props.store.groupChannels.rival);}},_react2.default.createElement('div',null,_react2.default.createElement('span',{className:index==0?"rankNum rankNum1":index==1?"rankNum rankNum2":index==2?"rankNum rankNum3":"rankNum"},index+1),_react2.default.createElement('span',null,item.name,' ',listName[item.name],' ')),_react2.default.createElement('div',null,_react2.default.createElement('span',{className:'rising'},item.num)));}));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);__webpack_require__(231);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;window.addEventListener('resize',function(){if(window.location.hash==='#/table/groupOfChannels'){_this2.props.store.criticism.setChart([],true);}});}},{key:'render',value:function render(){return _react2.default.createElement('div',{id:'chart',style:{height:500,width:'100%',background:'#fff'}});}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _pagination=__webpack_require__(363);var _pagination2=_interopRequireDefault(_pagination);var _rate=__webpack_require__(586);var _rate2=_interopRequireDefault(_rate);var _checkbox=__webpack_require__(272);var _checkbox2=_interopRequireDefault(_checkbox);var _radio=__webpack_require__(112);var _radio2=_interopRequireDefault(_radio);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(367);__webpack_require__(587);__webpack_require__(534);__webpack_require__(127);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _method=__webpack_require__(20);__webpack_require__(231);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var listName={'all':"全部 Total",'ctrip':"携程 Ctrip",'feizhu':'飞猪 Fliggy','meituan':'美团点评 Meituan & Dianping','yilong':"同城艺龙 Tongcheng & Yilong",'qunar':'去哪儿 Qunar','lvmama':'驴妈妈'};var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getRateScore=function(){var score=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;return(score/10).toFixed(1);};_this.getTime=function(x){var time='';switch(x.platform){case'ctrip':time=x.createTime.slice(10,20);break;case'qunar':time=x.createTime.slice(20,-18).replace(/\D/gm,'-');break;case'yilong':time=x.createTime;break;case'meituan':time=x.createTime.slice(33,-19);break;case'feizhu':time=x.createTime.slice(0,10);break;default:break;}return time;};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),area_obj:{'ctrip':{name:'携程',bg:'#4C9BF2'},'feizhu':{name:'飞猪',bg:'#F6C50E'},'meituan':{name:'美团<br/>点评',bg:'#ffc301'},'yilong':{name:'同城<br/>艺龙',bg:'#24BC81'},'qunar':{name:'去哪儿',bg:'#10A8BC'},'lvmama':{name:'驴妈妈',bg:'#d60d7f'}}};return _this;}_createClass(index,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.props.store.groupChannels.getDataCount(this.props.store.groupChannels.rival);this.props.store.groupChannels.getData('5.0','','',1,'1',this.props.store.groupChannels.rival);this.props.store.groupChannels.getRival();case 3:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var _this2=this;var _props$store$groupCha=this.props.store.groupChannels,radioChange=_props$store$groupCha.radioChange,checkVal=_props$store$groupCha.checkVal,checkChange=_props$store$groupCha.checkChange,onChangePage=_props$store$groupCha.onChangePage,data=_props$store$groupCha.data,_props$store$groupCha2=_props$store$groupCha.list_count,list_count=_props$store$groupCha2===undefined?[]:_props$store$groupCha2,comments_loading=_props$store$groupCha.comments_loading,page=_props$store$groupCha.page,total=_props$store$groupCha.total,area=_props$store$groupCha.area;return _react2.default.createElement('div',{className:'groupOfChannels_comments'},_react2.default.createElement(_spin2.default,{spinning:comments_loading},_react2.default.createElement('div',{className:'select_area',id:'select_area'},_react2.default.createElement(_radio2.default.Group,{defaultValue:'all',buttonStyle:'solid',className:'radio_platform',onChange:radioChange},(list_count||[]).map(function(item){return _react2.default.createElement(_radio2.default.Button,{value:item.name},_react2.default.createElement('div',{className:'f-center'},listName[item.name],_react2.default.createElement('span',{className:'f_s_16'},'\uFF08',item.num,'\uFF09')));})),_react2.default.createElement(_checkbox2.default.Group,{style:{width:'100%'},value:checkVal,onChange:checkChange,className:'check_conditions'},_react2.default.createElement('div',{style:{marginRight:30}},_react2.default.createElement(_checkbox2.default,{value:'bad'},_react2.default.createElement('span',{className:'text'},'\u5DEE\u8BC4\u5185\u5BB9 Negative Comments',_react2.default.createElement('span',null,'\uFF08',(list_count.find(function(x){return x.name==area;})||{}).bad,'\uFF09')))),_react2.default.createElement('div',null,_react2.default.createElement(_checkbox2.default,{value:'no_response'},_react2.default.createElement('span',{className:'text'},'\u672A\u56DE\u590D\u70B9\u8BC4 No Reply',_react2.default.createElement('span',null,'\uFF08',(list_count.find(function(x){return x.name==area;})||{}).unanswered,'\uFF09')))))),_react2.default.createElement('div',{className:'comments'},(data||[]).map(function(x,i){return _react2.default.createElement('div',{className:'each_list'},_react2.default.createElement('div',{className:'left'},_react2.default.createElement('div',{style:{background:''+(0,_method.getJson)([x.platform,'bg'],_this2.state.area_obj,"rgb(211, 208, 208)")},className:'area',dangerouslySetInnerHTML:{__html:(0,_method.getJson)([x.platform,'name'],_this2.state.area_obj,"其他")}}),_react2.default.createElement('div',{className:'left_text'},_react2.default.createElement('div',{className:'score'},(x.score/10).toFixed(1)||"0",'\u5206',_react2.default.createElement(_rate2.default,{disabled:true,allowHalf:true,className:'star',value:_this2.getRateScore(x.score||'0')})),_react2.default.createElement('div',{className:'time'},x.add_time?(0,_moment2.default)(x.add_time).format('YYYY-MM-DD'):""))),_react2.default.createElement('div',{className:'content'},x.content));})),_react2.default.createElement('div',{className:'pagination'},_react2.default.createElement(_pagination2.default,{showQuickJumper:true,defaultCurrent:1,current:page,total:total,onChange:onChangePage,pageSize:10}))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rate__ = __webpack_require__(1387);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Rate__["a" /* default */]);

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_lifecycles_compat__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Star__ = __webpack_require__(1389);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










function noop() {}

var Rate =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Rate, _React$Component);

  function Rate(props) {
    var _this;

    _classCallCheck(this, Rate);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Rate).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onHover", function (event, index) {
      var onHoverChange = _this.props.onHoverChange;

      var hoverValue = _this.getStarValue(index, event.pageX);

      var cleanedValue = _this.state.cleanedValue;

      if (hoverValue !== cleanedValue) {
        _this.setState({
          hoverValue: hoverValue,
          cleanedValue: null
        });
      }

      onHoverChange(hoverValue);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      var onHoverChange = _this.props.onHoverChange;

      _this.setState({
        hoverValue: undefined,
        cleanedValue: null
      });

      onHoverChange(undefined);
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event, index) {
      var allowClear = _this.props.allowClear;
      var value = _this.state.value;

      var newValue = _this.getStarValue(index, event.pageX);

      var isReset = false;

      if (allowClear) {
        isReset = newValue === value;
      }

      _this.onMouseLeave(true);

      _this.changeValue(isReset ? 0 : newValue);

      _this.setState({
        cleanedValue: isReset ? newValue : null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFocus", function () {
      var onFocus = _this.props.onFocus;

      _this.setState({
        focused: true
      });

      if (onFocus) {
        onFocus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
      var onBlur = _this.props.onBlur;

      _this.setState({
        focused: false
      });

      if (onBlur) {
        onBlur();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      var keyCode = event.keyCode;
      var _this$props = _this.props,
          count = _this$props.count,
          allowHalf = _this$props.allowHalf,
          onKeyDown = _this$props.onKeyDown;
      var value = _this.state.value;

      if (keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].RIGHT && value < count) {
        if (allowHalf) {
          value += 0.5;
        } else {
          value += 1;
        }

        _this.changeValue(value);

        event.preventDefault();
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].LEFT && value > 0) {
        if (allowHalf) {
          value -= 0.5;
        } else {
          value -= 1;
        }

        _this.changeValue(value);

        event.preventDefault();
      }

      if (onKeyDown) {
        onKeyDown(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "saveRef", function (index) {
      return function (node) {
        _this.stars[index] = node;
      };
    });

    _defineProperty(_assertThisInitialized(_this), "saveRate", function (node) {
      _this.rate = node;
    });

    var _value = props.value;

    if (_value === undefined) {
      _value = props.defaultValue;
    }

    _this.stars = {};
    _this.state = {
      value: _value,
      focused: false,
      cleanedValue: null
    };
    return _this;
  }

  _createClass(Rate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          autoFocus = _this$props2.autoFocus,
          disabled = _this$props2.disabled;

      if (autoFocus && !disabled) {
        this.focus();
      }
    }
  }, {
    key: "getStarDOM",
    value: function getStarDOM(index) {
      return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.stars[index]);
    }
  }, {
    key: "getStarValue",
    value: function getStarValue(index, x) {
      var allowHalf = this.props.allowHalf;
      var value = index + 1;

      if (allowHalf) {
        var starEle = this.getStarDOM(index);
        var leftDis = Object(__WEBPACK_IMPORTED_MODULE_6__util__["a" /* getOffsetLeft */])(starEle);
        var width = starEle.clientWidth;

        if (x - leftDis < width / 2) {
          value -= 0.5;
        }
      }

      return value;
    }
  }, {
    key: "focus",
    value: function focus() {
      var disabled = this.props.disabled;

      if (!disabled) {
        this.rate.focus();
      }
    }
  }, {
    key: "blur",
    value: function blur() {
      var disabled = this.props.disabled;

      if (!disabled) {
        this.rate.blur();
      }
    }
  }, {
    key: "changeValue",
    value: function changeValue(value) {
      var onChange = this.props.onChange;

      if (!('value' in this.props)) {
        this.setState({
          value: value
        });
      }

      onChange(value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          count = _this$props3.count,
          allowHalf = _this$props3.allowHalf,
          style = _this$props3.style,
          prefixCls = _this$props3.prefixCls,
          disabled = _this$props3.disabled,
          className = _this$props3.className,
          character = _this$props3.character,
          characterRender = _this$props3.characterRender,
          tabIndex = _this$props3.tabIndex;
      var _this$state = this.state,
          value = _this$state.value,
          hoverValue = _this$state.hoverValue,
          focused = _this$state.focused;
      var stars = [];
      var disabledClass = disabled ? "".concat(prefixCls, "-disabled") : '';

      for (var index = 0; index < count; index++) {
        stars.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Star__["a" /* default */], {
          ref: this.saveRef(index),
          index: index,
          count: count,
          disabled: disabled,
          prefixCls: "".concat(prefixCls, "-star"),
          allowHalf: allowHalf,
          value: hoverValue === undefined ? value : hoverValue,
          onClick: this.onClick,
          onHover: this.onHover,
          key: index,
          character: character,
          characterRender: characterRender,
          focused: focused
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(prefixCls, disabledClass, className),
        style: style,
        onMouseLeave: disabled ? null : this.onMouseLeave,
        tabIndex: disabled ? -1 : tabIndex,
        onFocus: disabled ? null : this.onFocus,
        onBlur: disabled ? null : this.onBlur,
        onKeyDown: disabled ? null : this.onKeyDown,
        ref: this.saveRate,
        role: "radiogroup"
      }, stars);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      if ('value' in nextProps && nextProps.value !== undefined) {
        return _objectSpread({}, state, {
          value: nextProps.value
        });
      }

      return state;
    }
  }]);

  return Rate;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

_defineProperty(Rate, "propTypes", {
  disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  defaultValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  count: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  allowHalf: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  allowClear: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onHoverChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  character: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
  characterRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  tabIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
});

_defineProperty(Rate, "defaultProps", {
  defaultValue: 0,
  count: 5,
  allowHalf: false,
  allowClear: true,
  style: {},
  prefixCls: 'rc-rate',
  onChange: noop,
  character: '★',
  onHoverChange: noop,
  tabIndex: 0
});

Object(__WEBPACK_IMPORTED_MODULE_4_react_lifecycles_compat__["polyfill"])(Rate);
/* harmony default export */ __webpack_exports__["a"] = (Rate);

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOffsetLeft;
/* eslint-disable import/prefer-default-export */
function getScroll(w, top) {
  var ret = top ? w.pageYOffset : w.pageXOffset;
  var method = top ? 'scrollTop' : 'scrollLeft';

  if (typeof ret !== 'number') {
    var d = w.document; // ie6,7,8 standard mode

    ret = d.documentElement[method];

    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }

  return ret;
}

function getClientPosition(elem) {
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  var box = elem.getBoundingClientRect();
  x = box.left;
  y = box.top;
  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}

function getOffsetLeft(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScroll(w);
  return pos.left;
}

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Star; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var Star =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Star, _React$Component);

  function Star() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Star);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Star)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onHover", function (e) {
      var _this$props = _this.props,
          onHover = _this$props.onHover,
          index = _this$props.index;
      onHover(e, index);
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      var _this$props2 = _this.props,
          onClick = _this$props2.onClick,
          index = _this$props2.index;
      onClick(e, index);
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
      var _this$props3 = _this.props,
          onClick = _this$props3.onClick,
          index = _this$props3.index;

      if (e.keyCode === 13) {
        onClick(e, index);
      }
    });

    return _this;
  }

  _createClass(Star, [{
    key: "getClassName",
    value: function getClassName() {
      var _this$props4 = this.props,
          prefixCls = _this$props4.prefixCls,
          index = _this$props4.index,
          value = _this$props4.value,
          allowHalf = _this$props4.allowHalf,
          focused = _this$props4.focused;
      var starValue = index + 1;
      var className = prefixCls;

      if (value === 0 && index === 0 && focused) {
        className += " ".concat(prefixCls, "-focused");
      } else if (allowHalf && value + 0.5 === starValue) {
        className += " ".concat(prefixCls, "-half ").concat(prefixCls, "-active");

        if (focused) {
          className += " ".concat(prefixCls, "-focused");
        }
      } else {
        className += starValue <= value ? " ".concat(prefixCls, "-full") : " ".concat(prefixCls, "-zero");

        if (starValue === value && focused) {
          className += " ".concat(prefixCls, "-focused");
        }
      }

      return className;
    }
  }, {
    key: "render",
    value: function render() {
      var onHover = this.onHover,
          onClick = this.onClick,
          onKeyDown = this.onKeyDown;
      var _this$props5 = this.props,
          disabled = _this$props5.disabled,
          prefixCls = _this$props5.prefixCls,
          character = _this$props5.character,
          characterRender = _this$props5.characterRender,
          index = _this$props5.index,
          count = _this$props5.count,
          value = _this$props5.value;
      var start = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: this.getClassName()
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        onClick: disabled ? null : onClick,
        onKeyDown: disabled ? null : onKeyDown,
        onMouseMove: disabled ? null : onHover,
        role: "radio",
        "aria-checked": value > index ? 'true' : 'false',
        "aria-posinset": index + 1,
        "aria-setsize": count,
        tabIndex: 0
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "".concat(prefixCls, "-first")
      }, character), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "".concat(prefixCls, "-second")
      }, character)));

      if (characterRender) {
        start = characterRender(start, this.props);
      }

      return start;
    }
  }]);

  return Star;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

_defineProperty(Star, "propTypes", {
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  allowHalf: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onHover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  character: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  characterRender: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  focused: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  count: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
});



/***/ }),
/* 1390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _rate=__webpack_require__(586);var _rate2=_interopRequireDefault(_rate);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(587);__webpack_require__(6);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _method=__webpack_require__(20);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(231);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var area_obj={'ctrip':{name:'携程',bg:'#4C9BF2'},'feizhu':{name:'飞猪',bg:'#F6C50E'},'meituan':{name:'美团<br/>点评',bg:'#ffc301'},'yilong':{name:'同城<br/>艺龙',bg:'#24BC81'},'qunar':{name:'去哪儿',bg:'#10A8BC'}};var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.highlight=function(word){var key=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'早餐环境';var text=word.replace(eval("/("+key+")+/gm"),'<span style="color: #4C9BF2">'+key+'</span>');return _react2.default.createElement('div',{className:'content',dangerouslySetInnerHTML:{__html:text}});},_this.getRateScore=function(score){return(score/10).toFixed(1);},_this.getTime=function(x){var time='';switch(x.platform){case'ctrip':time=x.createTime.slice(10,20);break;case'qunar':time=x.createTime.slice(20,-18).replace(/\D/gm,'-');break;case'yilong':time=x.createTime;break;case'meituan':time=x.createTime.slice(33,-19);break;default:break;}return time;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){var id=this.props.match.params.id;var name=this.props.match.params.name;this.props.store.criticism.getCriticism(id,name);}},{key:'render',value:function render(){var _this2=this;var _props$store$criticis=this.props.store.criticism,data=_props$store$criticis.criticismData,loading=_props$store$criticis.loading;return _react2.default.createElement(_spin2.default,{spinning:loading,tip:'\u52A0\u8F7D\u4E2D\u3002\u3002\u3002'},_react2.default.createElement('div',{className:'criticism'},_react2.default.createElement('div',{className:'top'},_react2.default.createElement('div',{className:'title'},'\u5171\u68C0\u7D22\u5230\u5305\u542B',_react2.default.createElement('span',{className:'c_b'},'\u201C',this.props.match.params.id||"",'\u201D'),'\u7684\u5DEE\u8BC4 ',_react2.default.createElement('span',{className:'c_b'},data.length),' \u6761'),_react2.default.createElement(_button2.default,{type:'primary',className:'returnBtn',onClick:function onClick(){_this2.props.history.go(-1);}},'\u8FD4\u56DE')),_react2.default.createElement('div',{className:'comments'},(data||[]).map(function(x,i){return _react2.default.createElement('div',{className:'each_list',key:x.id},_react2.default.createElement('div',{className:'left'},_react2.default.createElement('div',{style:{background:''+(0,_method.getJson)([x.platform,'bg'],area_obj,"rgb(211, 208, 208)")},className:'area',dangerouslySetInnerHTML:{__html:(0,_method.getJson)([x.platform,'name'],area_obj,"其他")}}),_react2.default.createElement('div',{className:'left_text'},_react2.default.createElement('div',{className:'score'},_this2.getRateScore(x.score),'\u5206',_react2.default.createElement(_rate2.default,{disabled:true,className:'star',allowHalf:true,defaultValue:_this2.getRateScore(x.score)})),_react2.default.createElement('div',{className:'time'},x.add_time?(0,_moment2.default)(x.add_time).format('YYYY-MM-DD'):""))),_this2.highlight(x.content,_this2.props.match.params.id));}))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(14);__webpack_require__(25);__webpack_require__(4);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);__webpack_require__(1393);var _cashFlow=__webpack_require__(1394);var _cashFlow2=_interopRequireDefault(_cashFlow);var _operationalCapability=__webpack_require__(1395);var _operationalCapability2=_interopRequireDefault(_operationalCapability);var _profitability=__webpack_require__(1396);var _profitability2=_interopRequireDefault(_profitability);var _businessForecast=__webpack_require__(1397);var _businessForecast2=_interopRequireDefault(_businessForecast);var _CostAnalysis=__webpack_require__(1398);var _CostAnalysis2=_interopRequireDefault(_CostAnalysis);var _mobx=__webpack_require__(30);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var App=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_this.state={dateData:[]},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){var date=Number(this.props.store.monthlyAnalysis.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});this.props.store.monthlyAnalysis.getData(this.props.store.monthlyAnalysis.date);}},{key:'render',value:function render(){var _this2=this;var _props$store$monthlyA=this.props.store.monthlyAnalysis,loading=_props$store$monthlyA.loading,date=_props$store$monthlyA.date,getData=_props$store$monthlyA.getData,onSave=_props$store$monthlyA.onSave,saving=_props$store$monthlyA.saving,notes=_props$store$monthlyA.notes;return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'table7_1_1 monthlyAnalysis'},_react2.default.createElement(_row2.default,{className:'title',id:'table11'},_react2.default.createElement(_row2.default,null,'\u8D22\u52A1\u6708\u5EA6\u5206\u6790\u62A5\u544A'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(_select2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u4EFD',style:{width:120},value:date,onChange:function onChange(str){(0,_mobx.runInAction)(function(){_this2.props.store.monthlyAnalysis.date=str;});getData(str);}},this.state.dateData.map(function(x,i){return _react2.default.createElement(Option,{key:x},x,'\u5E74');}))),_react2.default.createElement(_cashFlow2.default,null),_react2.default.createElement(_operationalCapability2.default,null),_react2.default.createElement(_profitability2.default,null),_react2.default.createElement(_CostAnalysis2.default,null),_react2.default.createElement(_businessForecast2.default,null),_react2.default.createElement('div',{className:'fillInThe'},_react2.default.createElement('span',null,'\u586B\u5199\u4EBA'),!loading&&_react2.default.createElement(_input2.default,{defaultValue:notes.name,onBlur:function onBlur(e){(0,_mobx.runInAction)(function(){_this2.props.store.monthlyAnalysis.notes.name=e.target.value||"";});},placeholder:'\u8BF7\u8F93\u5165\u586B\u5199\u4EBA\u59D3\u540D'}),_react2.default.createElement('span',null,'\u586B\u5199\u65E5\u671F'),!loading&&_react2.default.createElement(_datePicker2.default,{defaultValue:notes.date&&(0,_moment2.default)(notes.date),onChange:function onChange(__,str){(0,_mobx.runInAction)(function(){_this2.props.store.monthlyAnalysis.notes.date=str||"";});}})),_react2.default.createElement(_button2.default,{className:'footer-btn',type:'primary',onClick:onSave,loading:saving},'\u4FDD\u5B58'))));}}]);return App;}(_react.Component))||_class)||_class);exports.default=App;

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor;__webpack_require__(8);__webpack_require__(4);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TextArea=_input2.default.TextArea;var App=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=(_class2=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'onChange',_descriptor,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'render',value:function render(){var _this2=this;var _props$store$monthlyA=this.props.store.monthlyAnalysis,data=_props$store$monthlyA.data,notes=_props$store$monthlyA.notes,loading=_props$store$monthlyA.loading,deposit=_props$store$monthlyA.deposit;var width=document.body.offsetWidth>2100?document.body.offsetWidth-1800:300;var columns=function columns(type){return[{title:'项目',dataIndex:'name',key:'name',fixed:'left',width:width,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:'name',onChange:_this2.onChange,totalIndex:[],compared:type?null:{title:["Jan"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Jan',dataIndex:'Jan',key:'Jan',render:function render(text,record,index){var props={text:text,index:index,type:'number',name:'Jan',width:150,onChange:_this2.onChange,totalIndex:[],compared:type?null:{title:["Jan"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Feb',dataIndex:'Feb',key:'Feb',render:function render(text,record,index){var props={text:text,index:index,type:'number',name:'Feb',width:150,onChange:_this2.onChange,totalIndex:[],compared:type?null:{title:["Feb"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Mar',dataIndex:'Mar',key:'Mar',render:function render(text,record,index){var props={text:text,index:index,type:'number',name:'Mar',width:150,onChange:_this2.onChange,totalIndex:[],compared:type?null:{title:["Mar"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Apr',dataIndex:'Apr',key:'Apr',render:function render(text,record,index){var props={text:text,index:index,type:'number',name:'Apr',width:150,onChange:_this2.onChange,totalIndex:[],compared:type?null:{title:["Apr"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'May',dataIndex:'May',key:'May',render:function render(text,record,index){var props={text:text,index:index,type:'number',name:'May',width:150,onChange:_this2.onChange,totalIndex:[],compared:type?null:{title:["May"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Jun',dataIndex:'Jun',key:'Jun',render:function render(text,record,index){var props={text:text,index:index,type:'number',name:'Jun',width:150,onChange:_this2.onChange,totalIndex:[],compared:type?null:{title:["Jun"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Jul',dataIndex:'Jul',key:'Jul',render:function render(text,record,index){var props={text:text,index:index,type:'number',name:'Jul',width:150,onChange:_this2.onChange,totalIndex:[],compared:type?null:{title:["Jul"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Aug',dataIndex:'Aug',key:'Aug',render:function render(text,record,index){var props={text:text,index:index,type:'number',name:'Aug',width:150,onChange:_this2.onChange,totalIndex:[],compared:type?null:{title:["Aug"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Sep',dataIndex:'Sep',key:'Sep',render:function render(text,record,index){var props={text:text,index:index,type:'number',name:'Sep',width:150,onChange:_this2.onChange,totalIndex:[],compared:type?null:{title:["Sep"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Oct',dataIndex:'Oct',key:'Oct',render:function render(text,record,index){var props={text:text,index:index,type:'number',name:'Oct',width:150,onChange:_this2.onChange,totalIndex:[],compared:type?null:{title:["Oct"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Nov',dataIndex:'Nov',key:'Nov',render:function render(text,record,index){var props={text:text,index:index,type:'number',name:'Nov',width:150,onChange:_this2.onChange,totalIndex:[],compared:type?null:{title:["Nov"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Dec',dataIndex:'Dec',key:'Dec',render:function render(text,record,index){var props={text:text,index:index,type:'number',name:'Dec',width:150,onChange:_this2.onChange,totalIndex:[],compared:type?null:{title:["Dec"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];};return _react2.default.createElement('div',{className:''},_react2.default.createElement(_row2.default,{className:'secondary_title'},'\u4E00\uFF0E\u73B0\u91D1\u6D41\u91CF\u5206\u6790'),_react2.default.createElement(_table2.default,{columns:columns(),dataSource:data.slice(0,4),size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return index;},scroll:{x:2100}}),_react2.default.createElement(_table2.default,{columns:columns(true),dataSource:deposit,size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return index;},scroll:{x:2100}}),_react2.default.createElement(_row2.default,{className:'note_title'},'\u9152\u5E97\u7684\u73B0\u91D1\u6D41\u91CF\u8D8B\u52BF\u5206\u6790'),!loading&&_react2.default.createElement(TextArea,{className:'note m_b_80',autosize:{minRows:8},placeholder:'\u793A\u4F8B\uFF1A\n\u5F53\u671F\u7684\u73B0\u91D1\u57FA\u672C\u60C5\u51B5\uFF0C\u6BD4\u5982\u73B0\u91D1\u6536\u652F\u662F\u5426\u5305\u542B\u4E1A\u4E3B\u5F80\u6765\u6B3E\u7B49\u975E\u65E5\u5E38\u73B0\u91D1\u6536\u652F\u60C5\u51B5\uFF1F\u672A\u6765\u73B0\u91D1\u662F\u5426\u5145\u88D5\uFF1F\u662F\u5426\u6709\u5927\u989D\u73B0\u91D1\u6536\u652F\uFF1F',defaultValue:notes.cashFlow,onBlur:function onBlur(e){(0,_mobx.runInAction)(function(){_this2.props.store.monthlyAnalysis.notes.cashFlow=e.target.value||"";});}}));}}]);return App;}(_react.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'onChange',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(name,value,i){var data=(0,_mobx.toJS)(_this3.props.store.monthlyAnalysis.data);data[i][name]=value;_this3.props.store.monthlyAnalysis.data=data;};}})),_class2))||_class)||_class);exports.default=App;

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor;__webpack_require__(8);__webpack_require__(4);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TextArea=_input2.default.TextArea;var App=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=(_class2=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'onChange',_descriptor,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'render',value:function render(){var _this2=this;var _props$store$monthlyA=this.props.store.monthlyAnalysis,data=_props$store$monthlyA.data,notes=_props$store$monthlyA.notes,loading=_props$store$monthlyA.loading;var width=document.body.offsetWidth>2100?document.body.offsetWidth-1800:300;var columns=function columns(dataIndex,onChange){return[{title:'项目',dataIndex:'name',key:'name',fixed:'left',width:width,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:'name',onChange:onChange,totalIndex:[],compared:{title:["Jan"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Jan',dataIndex:'Jan',key:'Jan',width:150,render:function render(text,record,index){var props={text:text,index:dataIndex,type:'number',name:'Jan',onChange:onChange,totalIndex:[],compared:{title:["Jan"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Feb',dataIndex:'Feb',key:'Feb',width:150,render:function render(text,record,index){var props={text:text,index:dataIndex,type:'number',name:'Feb',onChange:onChange,totalIndex:[],compared:{title:["Feb"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Mar',dataIndex:'Mar',key:'Mar',width:150,render:function render(text,record,index){var props={text:text,index:dataIndex,type:'number',name:'Mar',onChange:onChange,totalIndex:[],compared:{title:["Mar"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Apr',dataIndex:'Apr',key:'Apr',width:150,render:function render(text,record,index){var props={text:text,index:dataIndex,type:'number',name:'Apr',onChange:onChange,totalIndex:[],compared:{title:["Apr"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'May',dataIndex:'May',key:'May',width:150,render:function render(text,record,index){var props={text:text,index:dataIndex,type:'number',name:'May',onChange:onChange,totalIndex:[],compared:{title:["May"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Jun',dataIndex:'Jun',key:'Jun',width:150,render:function render(text,record,index){var props={text:text,index:dataIndex,type:'number',name:'Jun',onChange:onChange,totalIndex:[],compared:{title:["Jun"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Jul',dataIndex:'Jul',key:'Jul',width:150,render:function render(text,record,index){var props={text:text,index:dataIndex,type:'number',name:'Jul',onChange:onChange,totalIndex:[],compared:{title:["Jul"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Aug',dataIndex:'Aug',key:'Aug',width:150,render:function render(text,record,index){var props={text:text,index:dataIndex,type:'number',name:'Aug',onChange:onChange,totalIndex:[],compared:{title:["Aug"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Sep',dataIndex:'Sep',key:'Sep',width:150,render:function render(text,record,index){var props={text:text,index:dataIndex,type:'number',name:'Sep',onChange:onChange,totalIndex:[],compared:{title:["Sep"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Oct',dataIndex:'Oct',key:'Oct',width:150,render:function render(text,record,index){var props={text:text,index:dataIndex,type:'number',name:'Oct',onChange:onChange,totalIndex:[],compared:{title:["Oct"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Nov',dataIndex:'Nov',key:'Nov',width:150,render:function render(text,record,index){var props={text:text,index:dataIndex,type:'number',name:'Nov',onChange:onChange,totalIndex:[],compared:{title:["Nov"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Dec',dataIndex:'Dec',key:'Dec',width:150,render:function render(text,record,index){var props={text:text,index:dataIndex,type:'number',name:'Dec',onChange:onChange,totalIndex:[],compared:{title:["Dec"],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];};return _react2.default.createElement('div',{className:''},_react2.default.createElement(_row2.default,{className:'secondary_title'},'\u4E8C\uFF0E\u8425\u8FD0\u80FD\u529B\u5206\u6790'),_react2.default.createElement(_row2.default,{className:'text_c'},'\u5E94\u6536\u8D26\u6B3E\u5468\u8F6C\u5929\u6570= 30/[\u5F53\u6708\u9500\u552E\u6536\u5165/\uFF08(\u6708\u521D\u5E94\u6536\u8D26\u6B3E+\u6708\u672B\u5E94\u6536\u8D26\u6B3E)/2\uFF09]'),_react2.default.createElement(_row2.default,{className:'text_c'},'\u5E94\u6536\u8D26\u6B3E\u5468\u8F6C\u5929\u6570\u662F\u6307\u9152\u5E97\u4ECE\u53D6\u5F97\u5E94\u6536\u8D26\u6B3E\u7684\u6743\u5229\u5230\u6536\u56DE\u6B3E\u9879\u7684\u65F6\u95F4\u3002\u5468\u8F6C\u5929\u6570\u8D8A\u77ED\uFF0C\u8BF4\u660E\u6D41\u52A8\u8D44\u91D1\u4F7F\u7528\u6548\u7387\u8D8A\u597D\u3002\uFF08\u5927\u4E8E30\u5929\u4EE5\u4E0A\u9700\u8981\u4F5C\u51FA\u89E3\u91CA\uFF09'),_react2.default.createElement(_table2.default,{columns:columns(4,this.onChange),dataSource:data[4]?[data[4]]:[],size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return index;},scroll:{x:2100}}),_react2.default.createElement(_row2.default,{className:'note_title'},'\u5E94\u6536\u8D26\u6B3E\u5468\u8F6C\u5929\u6570\u5206\u6790'),!loading&&_react2.default.createElement(TextArea,{className:'note m_b_40',autosize:{minRows:8},defaultValue:notes.accountsReceivable,onBlur:function onBlur(e){(0,_mobx.runInAction)(function(){_this2.props.store.monthlyAnalysis.notes.accountsReceivable=e.target.value||"";});},placeholder:'\u793A\u4F8B\uFF1A\n\uFF081\uFF09\u5E94\u6536\u8D26\u6B3E\u4E3B\u8981\u6784\u6210\u60C5\u51B5\uFF0C\u6BD4\u5982\u67D0\u516C\u53F8\u8D26\u671F120\u5929\u91D1\u989D\u591A\u5C11\uFF0C\u5360\u6574\u4E2A\u5E94\u6536\u8D26\u6BD4\u7387\u591A\u5C11?\u50AC\u8BA8\u8BA1\u5212\uFF1F\u9884\u8BA1\u4F55\u65F6\u6536\u56DE\uFF1F'}),_react2.default.createElement(_row2.default,{className:'text_c'},'\u5B58\u8D27\u5468\u8F6C\u5929\u6570=30/[\u5F53\u6708\u8425\u4E1A\u6210\u672C/\uFF08(\u6708\u521D\u5B58\u8D27\u4F59\u989D+\u6708\u672B\u5B58\u8D27\u4F59\u989D)/2\uFF09]'),_react2.default.createElement(_row2.default,{className:'text_c'},'\u5B58\u8D27\u5468\u8F6C\u5929\u6570\u662F\u6307\u9152\u5E97\u4ECE\u53D6\u5F97\u5B58\u8D27\u5F00\u59CB\uFF0C\u81F3\u7528\u5B8C\u4E3A\u6B62\u6240\u9700\u8981\u7684\u5929\u6570\u3002\u5468\u8F6C\u5929\u6570\u8D8A\u5C11\uFF0C\u8BF4\u660E\u5B58\u8D27\u53D8\u73B0\u7684\u901F\u5EA6\u8D8A\u5FEB'),_react2.default.createElement(_table2.default,{columns:columns(5,this.onChange),dataSource:data[5]?[data[5]]:[],size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return index;},scroll:{x:2100}}),_react2.default.createElement(_row2.default,{className:'note_title'},'\u5B58\u8D27\u5468\u8F6C\u5929\u6570\u5206\u6790'),!loading&&_react2.default.createElement(TextArea,{className:'note m_b_80',autosize:{minRows:8},defaultValue:notes.inventory,onBlur:function onBlur(e){(0,_mobx.runInAction)(function(){_this2.props.store.monthlyAnalysis.notes.inventory=e.target.value||"";});},placeholder:'\u793A\u4F8B\uFF1A\n\uFF081\uFF09\u5B58\u8D27\u5468\u8F6C\u5929\u6570\u5F62\u6210\u7684\u539F\u56E0\uFF0C\u6BD4\u5982slow moving\u5360\u6BD4\u591A\u5C11\uFF0C\u5468\u8F6C\u5929\u6570\u591A\u5C11\uFF0C\u5F71\u54CD\u6574\u4E2A\u5468\u8F6C\u5929\u6570\u591A\u5C11\uFF1F\u5982\u4F55\u52A0\u5FEB\u5468\u8F6C\u5929\u6570\u7684\u8BA1\u5212\uFF1F'}));}}]);return App;}(_react.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'onChange',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(name,value,i){var data=(0,_mobx.toJS)(_this3.props.store.monthlyAnalysis.data);data[i][name]=value;_this3.props.store.monthlyAnalysis.data=data;};}})),_class2))||_class)||_class);exports.default=App;

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor;__webpack_require__(8);__webpack_require__(4);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _data=__webpack_require__(289);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TextArea=_input2.default.TextArea;var App=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=(_class2=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'onChange',_descriptor,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'render',value:function render(){var _this2=this;var _props$store$monthlyA=this.props.store.monthlyAnalysis,data=_props$store$monthlyA.data,notes=_props$store$monthlyA.notes,loading=_props$store$monthlyA.loading;var width=document.body.offsetWidth>2100?document.body.offsetWidth-1800:300;var columns=_data.columnsData.map(function(item){if(item.key=='name'){return{title:item.title,dataIndex:item.key,key:item.key,fixed:'left',width:width,render:function render(text,record,index){var props={text:text,index:index,type:item.type,name:item.key,onChange:_this2.onChange,totalIndex:[]};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}};}return{title:item.title,dataIndex:item.key,key:item.key,width:150,render:function render(text,record,index){var props={text:text,index:index+6,type:item.type,name:item.key,onChange:_this2.onChange,totalIndex:[],compared:{title:[item.title],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}};});return _react2.default.createElement('div',{className:''},_react2.default.createElement(_row2.default,{className:'secondary_title'},'\u4E09\uFF0E\u76C8\u5229\u80FD\u529B\u5206\u6790'),_react2.default.createElement('div',{className:'text_c'},_react2.default.createElement('span',{className:'span_41'},'\uFF081\uFF09'),'\u5BA2\u623F\u5229\u6DA6\u7387=\uFF08\u5BA2\u623F\u6536\u5165-\u5BA2\u623F\u6210\u672C-\u5BA2\u623F\u8D39\u7528\uFF09/\u5BA2\u623F\u6536\u5165'),_react2.default.createElement('div',{className:'text_c text_indent m_b_10'},'\u5BA2\u623F\u90E8\u95E8\u5229\u6DA6\u7387(\u5C0F\u4E8E\u767E\u5206\u4E4B\u4E03\u5341\u4E94\u9700\u8981\u505A\u51FA\u89E3\u91CA\uFF09'),_react2.default.createElement('div',{className:'text_c'},_react2.default.createElement('span',{className:'span_41'},'\uFF082\uFF09'),'\u9910\u996E\u5229\u6DA6\u7387=\uFF08\u9910\u996E\u6536\u5165-\u9910\u996E\u6210\u672C-\u9910\u996E\u8D39\u7528\uFF09/\u9910\u996E\u6536\u5165'),_react2.default.createElement('div',{className:'text_c text_indent m_b_10'},'\u9910\u996E\u90E8\u95E8\u5229\u6DA6\u7387\uFF08\u5C0F\u4E8E\u767E\u5206\u4E4B\u4E09\u5341\u9700\u8981\u505A\u51FA\u89E3\u91CA\uFF09'),_react2.default.createElement('div',{className:'text_c'},_react2.default.createElement('span',{className:'span_41'},'\uFF083\uFF09'),'\u7ECF\u8425\u6BDB\u5229\u7387=\u7ECF\u8425\u6BDB\u5229\u6DA6/\u603B\u6536\u5165'),_react2.default.createElement('div',{className:'text_c text_indent'},'\u6839\u636E\u9884\u7B97\u6BD4\u7387\u505A\u51FA\u89E3\u91CA'),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data.slice(6,9),size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return index;},scroll:{x:2100}}),_react2.default.createElement(_row2.default,{className:'note_title'},'\u9152\u5E97\u7684\u76C8\u5229\u80FD\u529B\u8D8B\u52BF\u5206\u6790'),!loading&&_react2.default.createElement(TextArea,{className:'note m_b_80',autosize:{minRows:8},defaultValue:notes.profit,onBlur:function onBlur(e){(0,_mobx.runInAction)(function(){_this2.props.store.monthlyAnalysis.notes.profit=e.target.value||"";});},placeholder:'\u793A\u4F8B\uFF1A\n\uFF081\uFF09\u5BA2\u623F\u5229\u6DA6\u7387\u591A\u5C11\uFF0C\u4E3B\u8981\u662F\u56E0\u4E3A\u5BA2\u623F\u7387\u591A\u5C11\uFF0C\u623F\u4EF7\u591A\u5C11\uFF0C\u6240\u4EE5\u5F71\u54CD\u5BA2\u623F\u5229\u6DA6\u7387\u591A\u5C11\uFF0C\u672A\u6765\u6539\u5584\u8BA1\u5212\u3002\n\uFF082\uFF09\u9910\u996E\u90E8\u95E8\u5229\u6DA6\u7387\u591A\u5C11\uFF0C\u4E3B\u8981\u662F\u56E0\u4E3A\u5BB4\u4F1A\u6536\u5165\u8FBE\u5230\u591A\u5C11\u91D1\u989D\uFF0C\u5F71\u54CD\u9910\u996E\u5229\u6DA6\u7387\u591A\u5C11\uFF0C\u672A\u6765\u6539\u5584\u8BA1\u5212\u3002\n\uFF083\uFF09\u7ECF\u8425\u6BDB\u5229\u7387\u6839\u636E\u9884\u7B97\u6BD4\u7387\u505A\u51FA\u89E3\u91CA\uFF0C\u672A\u6765\u6539\u5584\u8BA1\u5212\u3002'}));}}]);return App;}(_react.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'onChange',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(name,value,i){var data=(0,_mobx.toJS)(_this3.props.store.monthlyAnalysis.data);data[i][name]=value;_this3.props.store.monthlyAnalysis.data=data;};}})),_class2))||_class)||_class);exports.default=App;

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor;__webpack_require__(8);__webpack_require__(4);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _data=__webpack_require__(289);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TextArea=_input2.default.TextArea;var App=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=(_class2=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'onChange',_descriptor,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'render',value:function render(){var _this2=this;var _props$store$monthlyA=this.props.store.monthlyAnalysis,data=_props$store$monthlyA.data,notes=_props$store$monthlyA.notes,loading=_props$store$monthlyA.loading;var width=document.body.offsetWidth>2100?document.body.offsetWidth-1800:300;var columns=_data.columnsData.map(function(item){if(item.key=='name'){return{title:item.title,dataIndex:item.key,key:item.key,fixed:'left',width:width,render:function render(text,record,index){var props={text:text,index:9+index,type:item.type,name:item.key,onChange:_this2.onChange,totalIndex:[]};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}};}return{title:item.title,dataIndex:item.key,key:item.key,width:150,render:function render(text,record,index){var props={text:record[item.key+'minus']?"扭亏为盈":text,index:9+index,type:record[item.key+'minus']?"text":item.type,name:item.key,onChange:_this2.onChange,totalIndex:[],compared:{title:[item.title],record:record,sqlName:"monthlyAnalysis"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}};});return _react2.default.createElement('div',{className:''},_react2.default.createElement(_row2.default,{className:'secondary_title'},'\u4E94\uFF0E\u7ECF\u8425\u9884\u6D4B\u5206\u6790'),_react2.default.createElement('div',{className:'text_c'},_react2.default.createElement('span',{className:'span_41'},'\uFF081\uFF09'),'\u9500\u552E\u6536\u5165\u589E\u957F\u7387=\uFF08\u672C\u671F\u9500\u552E\u6536\u5165-\u4E0A\u671F\u9500\u552E\u6536\u5165\uFF09/\u4E0A\u671F\u9500\u552E\u6536\u5165*100%'),_react2.default.createElement('div',{className:'text_c text_indent m_b_10'},'\u4E00\u822C\u9500\u552E\u6536\u5165\u589E\u957F\u7387\u8D8A\u9AD8\u8D8A\u597D'),_react2.default.createElement('div',{className:'text_c'},_react2.default.createElement('span',{className:'span_41'},'\uFF082\uFF09'),'\u7ECF\u8425\u6BDB\u5229\u6DA6\u589E\u957F\u7387=\uFF08\u672C\u671F\u7ECF\u8425\u6BDB\u5229\u6DA6-\u4E0A\u671F\u7ECF\u8425\u6BDB\u5229\u6DA6\uFF09/\u4E0A\u671F\u7ECF\u8425\u6BDB\u5229\u6DA6*100%'),_react2.default.createElement('div',{className:'text_c text_indent m_b_10'},'\u4E00\u822C\u7ECF\u8425\u6BDB\u5229\u6DA6\u589E\u957F\u7387\u8D8A\u9AD8\u8D8A\u597D'),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data.slice(9,11),size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return index;},scroll:{x:2100}}),_react2.default.createElement(_row2.default,{className:'note_title'},'\u9152\u5E97\u7684\u7ECF\u8425\u9884\u6D4B\u8D8B\u52BF\u5206\u6790'),!loading&&_react2.default.createElement(TextArea,{className:'note m_b_80',autosize:{minRows:8},defaultValue:notes.business,onBlur:function onBlur(e){(0,_mobx.runInAction)(function(){_this2.props.store.monthlyAnalysis.notes.business=e.target.value||"";});},placeholder:'\u793A\u4F8B\uFF1A\n\uFF081\uFF09\u5BF9\u6BD4\u4E0A\u671F\u9500\u552E\u6536\u5165\u589E\u52A0\u6216\u51CF\u5C11\u7684\u539F\u56E0\uFF1F\n\uFF082\uFF09\u5BF9\u6BD4\u4E0A\u671F\u7ECF\u8425\u6BDB\u5229\u6DA6\u589E\u52A0\u6216\u51CF\u5C11\u7684\u539F\u56E0\uFF1F'}));}}]);return App;}(_react.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'onChange',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(name,value,i){var data=(0,_mobx.toJS)(_this3.props.store.monthlyAnalysis.data);data[i][name]=value;_this3.props.store.monthlyAnalysis.data=data;};}})),_class2))||_class)||_class);exports.default=App;

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(8);__webpack_require__(4);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _data=__webpack_require__(289);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextArea=_input2.default.TextArea;var App=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){var _this2=this;var _props$store$monthlyA=this.props.store.monthlyAnalysis,cost=_props$store$monthlyA.cost,notes=_props$store$monthlyA.notes,loading=_props$store$monthlyA.loading;var width=document.body.offsetWidth>2100?document.body.offsetWidth-1800:300;var columns=_data.columnsData.map(function(item){if(item.key=='name'){return{title:item.title,dataIndex:item.key,key:item.key,fixed:'left',width:width,render:function render(text,record,index){var props={text:text,index:index,type:item.type,name:item.key,onChange:_this2.onChange,totalIndex:[]};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}};}return{title:item.title,dataIndex:item.key,key:item.key,width:150,render:function render(text,record,index){var props={text:text,index:index,type:"percent",name:item.key,onChange:_this2.onChange,totalIndex:[],compared:{title:[item.title],record:record,sqlName:"monthlyAnalysis_cost"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}};});return _react2.default.createElement('div',{className:''},_react2.default.createElement(_row2.default,{className:'secondary_title'},'\u56DB\uFF0E\u4E3B\u8981\u6210\u672C\u5206\u6790'),_react2.default.createElement('div',{className:'text_c'},_react2.default.createElement('span',{className:'span_41'},'\uFF081\uFF09'),'\u98DF\u54C1\u6210\u672C\u7387=\u98DF\u54C1\u53CA\u996E\u54C1\u6210\u672C/\u9910\u996E\u6536\u5165'),_react2.default.createElement('div',{className:'text_c text_indent m_b_10'},'\u98DF\u54C1\u6210\u672C\u7387\uFF08\u5927\u4E8E\u767E\u5206\u4E4B\u4E09\u5341\u4E94\u9700\u8981\u505A\u51FA\u89E3\u91CA\uFF09'),_react2.default.createElement('div',{className:'text_c'},_react2.default.createElement('span',{className:'span_41'},'\uFF082\uFF09'),'\u4EBA\u529B\u6210\u672C\u7387=\u4EBA\u529B\u6210\u672C/\u603B\u6536\u5165'),_react2.default.createElement('div',{className:'text_c text_indent m_b_10'},'\u4EBA\u529B\u6210\u672C\u7387\uFF08\u5927\u4E8E\u767E\u5206\u4E4B\u4E09\u5341\u9700\u8981\u505A\u51FA\u89E3\u91CA\uFF09'),_react2.default.createElement('div',{className:'text_c'},_react2.default.createElement('span',{className:'span_41'},'\uFF083\uFF09'),'\u80FD\u6E90\u6210\u672C\u7387=\u80FD\u6E90\u6210\u672C/\u603B\u6536\u5165'),_react2.default.createElement('div',{className:'text_c text_indent m_b_10'},'\u80FD\u6E90\u6210\u672C\u7387\uFF08\u5927\u4E8E\u767E\u5206\u4E4B\u5341\u9700\u8981\u505A\u51FA\u89E3\u91CA\uFF09'),_react2.default.createElement('div',{className:'text_c'},_react2.default.createElement('span',{className:'span_41'},'\uFF084\uFF09'),'\u5176\u4ED6\u8D39\u7528\u53CA\u6210\u672C\u7387=\u5176\u4ED6\u8D39\u7528\u53CA\u6210\u672C/\u603B\u6536\u5165'),_react2.default.createElement('div',{className:'text_c text_indent m_b_10'},'\u5176\u4ED6\u8D39\u7528\u53CA\u6210\u672C\u7387\uFF08\u76F8\u6BD4\u9884\u7B97\u6B63\u8D1F\u767E\u5206\u4E4B\u4E94\u8303\u56F4\u5185\uFF09'),_react2.default.createElement(_table2.default,{columns:columns,dataSource:cost,size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return index;},scroll:{x:2100}}),_react2.default.createElement(_row2.default,{className:'note_title'},'\u9152\u5E97\u7684\u4E3B\u8981\u6210\u672C\u8D8B\u52BF\u5206\u6790'),!loading&&_react2.default.createElement(TextArea,{className:'note m_b_80',autosize:{minRows:8},defaultValue:notes.cost,onBlur:function onBlur(e){(0,_mobx.runInAction)(function(){_this2.props.store.monthlyAnalysis.notes.cost=e.target.value||"";});},placeholder:'\u793A\u4F8B\uFF1A\n\uFF081\uFF09\u98DF\u54C1\u6210\u672C\u7387\u591A\u5C11\uFF0C\u4E3B\u8981\u662F\u56E0\u4E3A\u9152\u5E97\u81EA\u52A9\u9910\u7684\u4FC3\u9500\u6D3B\u52A8\uFF0C\u6240\u4EE5\u5F71\u54CD\u897F\u9910\u5385\u98DF\u54C1\u6210\u672C\u7387\u591A\u5C11\uFF0C\u672A\u6765\u6539\u5584\u8BA1\u5212\u3002 \n\uFF082\uFF09\u4EBA\u529B\u6210\u672C\u7387\u591A\u5C11\uFF0C\u6309\u7167\u9152\u5E97\u7684\u5BA2\u60C5\u60C5\u51B5\uFF0C\u5404\u90E8\u95E8\u662F\u5426\u505A\u5230\u5408\u7406\u6392\u7248\uFF0C\u6309\u7167\u672A\u6765\u9884\u6D4B\u7684\u60C5\u51B5\u662F\u5426\u9700\u8981\u6539\u8FDB\u3002\n\uFF083\uFF09\u80FD\u6E90\u6210\u672C\u7387\u591A\u5C11\uFF0C\u6309\u7167\u9152\u5E97\u5B9E\u9645\u7684\u5165\u4F4F\u7387\u4EE5\u53CA\u5929\u6C14\u53D8\u5316\u60C5\u51B5\uFF0C\u5F71\u54CD\u5230\u5F53\u6708\u7684\u80FD\u6E90\u652F\u51FA\u591A\u5C11\uFF0C\u672A\u6765\u4ECE\u54EA\u65B9\u9762\u8FDB\u884C\u6539\u5584 \n\uFF084\uFF09\u5176\u4ED6\u8D39\u7528\u53CA\u6210\u672C\u7387\u6839\u636E\u9884\u7B97\u6BD4\u7387\u505A\u51FA\u89E3\u91CA\uFF0C\u672A\u6765\u6539\u5584\u8BA1\u5212\u3002'}));}}]);return App;}(_react.Component))||_class)||_class);exports.default=App;

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(4);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(1400);var _Potential=__webpack_require__(1401);var _Potential2=_interopRequireDefault(_Potential);var _Recommend=__webpack_require__(1402);var _Recommend2=_interopRequireDefault(_Recommend);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var App=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_this.state={dateData:[]},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){var date=Number(this.props.store.financePersonnel.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});this.props.store.financePersonnel.getData(this.props.store.financePersonnel.date);}},{key:'render',value:function render(){var _this2=this;var _props$store$financeP=this.props.store.financePersonnel,loading=_props$store$financeP.loading,date=_props$store$financeP.date,getData=_props$store$financeP.getData,onSave=_props$store$financeP.onSave,saving=_props$store$financeP.saving,notes=_props$store$financeP.notes;var month=(0,_moment2.default)().format("M");var day=(0,_moment2.default)().format("D");var isSave=month==2?true:month==3&&day<=10?true:false;return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'table7_1_1 financePersonnel'},_react2.default.createElement(_row2.default,{className:'title',id:'table11'},_react2.default.createElement(_row2.default,null,'\u8D22\u52A1\u90E8\u4EBA\u5458\u8BC4\u4F30'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(_select2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u4EFD',style:{width:120},value:date,onChange:function onChange(str){(0,_mobx.runInAction)(function(){_this2.props.store.financePersonnel.date=str;});getData(str);}},this.state.dateData.map(function(x,i){return _react2.default.createElement(Option,{key:x},x,'\u5E74');})),_react2.default.createElement('span',{className:'note'},'\u6CE8\uFF1A\u6B64\u8868\u6BCF\u5E742\u67081\u65E5-3\u670810\u65E5\u671F\u95F4\u586B\u5199\u3002')),_react2.default.createElement(_Potential2.default,null),_react2.default.createElement(_Recommend2.default,null),!isSave?null:_react2.default.createElement(_button2.default,{className:'footer-btn',type:'primary',onClick:onSave,loading:saving},'\u4FDD\u5B58'))));}}]);return App;}(_react.Component))||_class)||_class);exports.default=App;

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor;__webpack_require__(8);__webpack_require__(4);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _mobx=__webpack_require__(30);var _data2=__webpack_require__(398);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TextArea=_input2.default.TextArea;var App=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=(_class2=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'onChange',_descriptor,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'render',value:function render(){var _this2=this;var _props$store$financeP=this.props.store.financePersonnel,data=_props$store$financeP.data,loading=_props$store$financeP.loading;console.log(JSON.stringify(data));return _react2.default.createElement('div',{className:''},_data2.listData.map(function(x,i){return _react2.default.createElement('div',null,_react2.default.createElement(_row2.default,{className:'secondary_title'},x.name),[1,2,3].map(function(_,index){var _data=data.slice(i*3+index,i*3+index+1)[0]||{};console.log(_data);return _react2.default.createElement('div',null,_react2.default.createElement(_table2.default,{columns:(0,_data2.columns)({sort:i*3+index,name:x.name,onChange:_this2.onChange}),dataSource:loading?[]:[_data],size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return i*3+index;}}),_react2.default.createElement(_row2.default,{className:'note_title'},x.placeholder),!loading&&_react2.default.createElement(TextArea,{className:'note m_b_80',autosize:{minRows:4},defaultValue:_data.notes,onBlur:function onBlur(e){(0,_mobx.runInAction)(function(){_this2.props.store.financePersonnel.data[i*3+index].notes=e.target.value||"";});}}));}));}));}}]);return App;}(_react.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'onChange',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(name,value,i){var data=(0,_mobx.toJS)(_this3.props.store.financePersonnel.data);data[i][name]=value;_this3.props.store.financePersonnel.data=data;};}})),_class2))||_class)||_class);exports.default=App;

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor;__webpack_require__(8);__webpack_require__(4);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _mobx=__webpack_require__(30);var _data=__webpack_require__(398);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TextArea=_input2.default.TextArea;var App=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=(_class2=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'onChange',_descriptor,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'render',value:function render(){var _props$store$financeP=this.props.store.financePersonnel,recommend=_props$store$financeP.recommend,loading=_props$store$financeP.loading;return _react2.default.createElement('div',{className:''},_react2.default.createElement(_row2.default,{className:'secondary_title'},'\u8D22\u52A1\u90E8\u5458\u5DE5\u63A8\u8350'),_react2.default.createElement(_table2.default,{columns:(0,_data.recommendColumns)({name:"财务部员工推荐",onChange:this.onChange}),dataSource:loading?[]:recommend,size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}}));}}]);return App;}(_react.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'onChange',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(name,value,i){var data=(0,_mobx.toJS)(_this2.props.store.financePersonnel.recommend);data[i][name]=value;_this2.props.store.financePersonnel.recommend=data;};}})),_class2))||_class)||_class);exports.default=App;

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(35);__webpack_require__(4);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(1404);var _Table=__webpack_require__(1405);var _Table2=_interopRequireDefault(_Table);var _Table3=__webpack_require__(1406);var _Table4=_interopRequireDefault(_Table3);var _Table5=__webpack_require__(1407);var _Table6=_interopRequireDefault(_Table5);var _Table7=__webpack_require__(1408);var _Table8=_interopRequireDefault(_Table7);var _Table9=__webpack_require__(1409);var _Table10=_interopRequireDefault(_Table9);var _mobx=__webpack_require__(30);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WeekPicker=_datePicker2.default.WeekPicker;var App=(_dec=(0,_mobxReact.inject)("store"),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:"componentDidMount",value:function componentDidMount(){this.props.store.kpifollow.getData(this.props.store.kpifollow.date);}},{key:"render",value:function render(){var _this2=this;var _props$store$kpifollo=this.props.store.kpifollow,loading=_props$store$kpifollo.loading,date=_props$store$kpifollo.date,getData=_props$store$kpifollo.getData,onSave=_props$store$kpifollo.onSave,room=_props$store$kpifollo.room,saving=_props$store$kpifollo.saving;return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement("div",{className:"table7_1_1 kpifollow"},_react2.default.createElement(_row2.default,{className:"title",id:"table11"},_react2.default.createElement(_row2.default,null,"KPI Follow\u53C2\u6570"),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(WeekPicker,{placeholder:"\u8BF7\u9009\u62E9\u65E5\u671F",style:{width:150},value:(0,_moment2.default)(date,"YYYY-W"),format:"YYYY-W",onChange:function onChange(str,r){getData(r);}}),_react2.default.createElement("span",{className:"note"},"\u9152\u5E97\u623F\u95F4\u603B\u6570:",_react2.default.createElement(_inputNumber2.default,{value:room,style:{width:200,marginLeft:10},min:0,onChange:function onChange(e){(0,_mobx.runInAction)(function(){_this2.props.store.kpifollow.room=e;});}}))),_react2.default.createElement(_Table2.default,null),_react2.default.createElement(_Table4.default,null),_react2.default.createElement(_Table6.default,null),_react2.default.createElement(_Table8.default,null),_react2.default.createElement(_Table10.default,null),_react2.default.createElement(_Auth2.default,{loading:loading,auth:"edit_kpifollow"},_react2.default.createElement(_button2.default,{className:"footer-btn",type:"primary",onClick:onSave,loading:saving},"\u4FDD\u5B58")))));}}]);return App;}(_react.Component))||_class)||_class);exports.default=App;

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor;__webpack_require__(8);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _mobx=__webpack_require__(30);var _data=__webpack_require__(588);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var totalIndex=[];var App=(_dec=(0,_mobxReact.inject)("store"),_dec(_class=(0,_mobxReact.observer)(_class=(_class2=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,"onChange",_descriptor,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:"render",value:function render(){var _this2=this;var _props$store$kpifollo=this.props.store.kpifollow,data=_props$store$kpifollo.data,loading=_props$store$kpifollo.loading,customers=_props$store$kpifollo.customers;var columns=[{title:"客源情况MTD",align:"center",children:[{title:"",dataIndex:"name",key:"name",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"text",name:"name",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"MTD",dataIndex:"mtd",key:"mtd",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"inputNumber",name:"mtd",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"未来7天远期房态",align:"center",children:[{title:"日期",dataIndex:"date",key:"date",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"input",name:"date",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"出租率",dataIndex:"occ",key:"occ",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"inputPercent",name:"occ",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"已售房",dataIndex:"sold",key:"sold",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"inputNumber",name:"sold",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]}];return _react2.default.createElement("div",{className:""},_react2.default.createElement("div",null,_react2.default.createElement(_table2.default,{columns:columns,dataSource:(0,_mobx.toJS)(customers),size:"middle",bordered:true,pagination:false,className:"content",rowKey:"r.name"})));}}]);return App;}(_react.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,"onChange",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(name,value,i){var data=(0,_mobx.toJS)(_this3.props.store.kpifollow.customers);data[i][name]=value;_this3.props.store.kpifollow.customers=data;};}})),_class2))||_class)||_class);exports.default=App;

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor;__webpack_require__(8);__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _mobx=__webpack_require__(30);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var totalIndex=[];var App=(_dec=(0,_mobxReact.inject)("store"),_dec(_class=(0,_mobxReact.observer)(_class=(_class2=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,"onChange",_descriptor,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:"render",value:function render(){var _this2=this;var _props$store$kpifollo=this.props.store.kpifollow,data=_props$store$kpifollo.data,loading=_props$store$kpifollo.loading,food=_props$store$kpifollo.food;var columns=[{title:"餐厅",align:"center",children:[{title:"",dataIndex:"name",key:"name",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"text",name:"name",onChange:_this2.onChange,totalIndex:totalIndex};if(index==0)return{props:{rowSpan:6},children:_react2.default.createElement(_TableText2.default,{data:props})};return{props:{rowSpan:0}};}},{title:"项目",dataIndex:"project",key:"project",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"text",name:"project",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"MTD",align:"center",children:[{title:"ACT实际",dataIndex:"act",key:"act",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"inputNumber",name:"act",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"BUD预算",dataIndex:"bud",key:"bud",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"inputNumber",name:"bud",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"完成率(%)",dataIndex:"cop",key:"cop",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"percent",name:"cop",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"本周A+F(周一-周日)",align:"center",children:[{title:"实际+预计收入",dataIndex:"af",key:"af",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"inputNumber",name:"af",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"下周预测(周一-周日)",align:"center",children:[{title:"预测收入",dataIndex:"f",key:"f",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"inputNumber",name:"f",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]}];return _react2.default.createElement("div",{className:"",style:{marginTop:50}},_react2.default.createElement("div",null,_react2.default.createElement(_row2.default,{className:"secondary_title"},"\u9152\u5E97\u9910\u996E"),_react2.default.createElement(_table2.default,{columns:columns,dataSource:(0,_mobx.toJS)(food),size:"middle",bordered:true,pagination:false,className:"content",rowKey:"r.project"})));}}]);return App;}(_react.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,"onChange",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(name,value,i){var data=(0,_mobx.toJS)(_this3.props.store.kpifollow.food);data[i][name]=value;for(var _i=0;_i<data.length;_i++){data[_i].cop=(0,_method.calculation)(data[_i].act,data[_i].bud,4);}_this3.props.store.kpifollow.food=data;};}})),_class2))||_class)||_class);exports.default=App;

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor;__webpack_require__(8);__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _mobx=__webpack_require__(30);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var totalIndex=[];var App=(_dec=(0,_mobxReact.inject)("store"),_dec(_class=(0,_mobxReact.observer)(_class=(_class2=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,"onChange",_descriptor,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:"render",value:function render(){var _this2=this;var _props$store$kpifollo=this.props.store.kpifollow,data=_props$store$kpifollo.data,loading=_props$store$kpifollo.loading,comments=_props$store$kpifollo.comments;var columns=[{title:"客房预订平台",dataIndex:"name",key:"name",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"text",name:"name",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"MTD订单数",dataIndex:"order",key:"order",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"inputNumber",name:"order",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"MTD点评数",dataIndex:"comment",key:"comment",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"inputNumber",name:"comment",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"MTD分数",dataIndex:"fraction",key:"fraction",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"inputNumber",name:"fraction",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"点评总分",dataIndex:"total",key:"total",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"inputNumber",name:"total",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}];return _react2.default.createElement("div",{className:"",style:{marginTop:50}},_react2.default.createElement("div",null,_react2.default.createElement(_row2.default,{className:"secondary_title"},"\u7F51\u8BC4\u6570\u636E"),_react2.default.createElement(_table2.default,{columns:columns,dataSource:(0,_mobx.toJS)(comments),size:"middle",bordered:true,pagination:false,className:"content",rowKey:"r.name"})));}}]);return App;}(_react.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,"onChange",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(name,value,i){var data=(0,_mobx.toJS)(_this3.props.store.kpifollow.comments);data[i][name]=value;_this3.props.store.kpifollow.comments=data;};}})),_class2))||_class)||_class);exports.default=App;

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor;__webpack_require__(8);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _mobx=__webpack_require__(30);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var totalIndex=[];var App=(_dec=(0,_mobxReact.inject)("store"),_dec(_class=(0,_mobxReact.observer)(_class=(_class2=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_this.state={user:{}},_initDefineProp(_this,"onChange",_descriptor,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;this.props.store.menu.getUserInfo().then(function(user){_this2.setState({user:user});}).catch(function(err){console.error(err);});}},{key:"render",value:function render(){var _this3=this;var _props$store$kpifollo=this.props.store.kpifollow,data=_props$store$kpifollo.data,loading=_props$store$kpifollo.loading,platform=_props$store$kpifollo.platform;var columns=[{title:"餐饮预订平台",dataIndex:"name",key:"name",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"text",name:"name",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"差评关键词",dataIndex:"order",key:"order",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"input",name:"order",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"MTD点评数量",dataIndex:"comment",key:"comment",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"inputNumber",name:"comment",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"MTD分数",dataIndex:"fraction",key:"fraction",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"inputNumber",name:"fraction",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"YTD目标",dataIndex:"total",key:"total",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:(_this3.state.user.email||"").includes("admin")?"inputNumber":"number",name:"total",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}];return _react2.default.createElement(_table2.default,{columns:columns,dataSource:(0,_mobx.toJS)(platform),size:"middle",bordered:true,pagination:false,className:"content",rowKey:"r.name"});}}]);return App;}(_react.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,"onChange",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return function(name,value,i){var data=(0,_mobx.toJS)(_this4.props.store.kpifollow.platform);data[i][name]=value;_this4.props.store.kpifollow.platform=data;};}})),_class2))||_class)||_class);exports.default=App;

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor;__webpack_require__(8);__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _mobx=__webpack_require__(30);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var totalIndex=[];var App=(_dec=(0,_mobxReact.inject)("store"),_dec(_class=(0,_mobxReact.observer)(_class=(_class2=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,"onChange",_descriptor,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:"render",value:function render(){var _this2=this;var _props$store$kpifollo=this.props.store.kpifollow,data=_props$store$kpifollo.data,loading=_props$store$kpifollo.loading,submarket=_props$store$kpifollo.submarket;var columns=[{title:"携程",align:"center",children:[{dataIndex:"name1",key:"name1",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"text",name:"name1",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{dataIndex:"value1",key:"value1",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"inputNumber",name:"value1",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"美团",align:"center",children:[{dataIndex:"name2",key:"name2",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"text",name:"name2",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{dataIndex:"value2",key:"value2",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"inputNumber",name:"value2",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"RFP协议单位",align:"center",children:[{dataIndex:"name3",key:"name3",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"text",name:"name3",onChange:_this2.onChange,totalIndex:[2]};if(index==2)return{props:{colSpan:2},children:_react2.default.createElement(_TableText2.default,{data:props})};return _react2.default.createElement(_TableText2.default,{data:props});}},{dataIndex:"value3",key:"value3",width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"inputNumber",name:"value3",onChange:_this2.onChange,totalIndex:[2]};if(index==2)return{props:{colSpan:0}};return _react2.default.createElement(_TableText2.default,{data:props});}}]}];return _react2.default.createElement("div",{className:"",style:{marginTop:50}},_react2.default.createElement("div",null,_react2.default.createElement(_row2.default,{className:"secondary_title"},"\u5546\u5708\u6570\u636E\u5448\u73B0"),_react2.default.createElement(_table2.default,{columns:columns,dataSource:(0,_mobx.toJS)(submarket),size:"middle",bordered:true,pagination:false,className:"content",rowKey:"r.name"})));}}]);return App;}(_react.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,"onChange",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(name,value,i){var data=(0,_mobx.toJS)(_this3.props.store.kpifollow.submarket);data[i][name]=value;_this3.props.store.kpifollow.submarket=data;};}})),_class2))||_class)||_class);exports.default=App;

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(4);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(1411);var _Potential=__webpack_require__(1412);var _Potential2=_interopRequireDefault(_Potential);var _Recommend=__webpack_require__(1413);var _Recommend2=_interopRequireDefault(_Recommend);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var App=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_this.state={dateData:[]},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){var date=Number(this.props.store.salesPersonnel.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});this.props.store.salesPersonnel.getData(this.props.store.salesPersonnel.date);}},{key:'render',value:function render(){var _this2=this;var _props$store$salesPer=this.props.store.salesPersonnel,loading=_props$store$salesPer.loading,date=_props$store$salesPer.date,getData=_props$store$salesPer.getData,onSave=_props$store$salesPer.onSave,saving=_props$store$salesPer.saving,notes=_props$store$salesPer.notes;return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'table7_1_1 salesPersonnel'},_react2.default.createElement(_row2.default,{className:'title',id:'table11'},_react2.default.createElement(_row2.default,null,'\u9500\u552E\u90E8\u4EBA\u5458\u8BC4\u4F30'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(_select2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u4EFD',style:{width:120},value:date,onChange:function onChange(str){(0,_mobx.runInAction)(function(){_this2.props.store.salesPersonnel.date=str;});getData(str);}},this.state.dateData.map(function(x,i){return _react2.default.createElement(Option,{key:x},x,'\u5E74');})),_react2.default.createElement('span',{className:'note'},'\u6CE8\uFF1A\u6B64\u8868\u6BCF\u5E742\u67081\u65E5-3\u670810\u65E5\u671F\u95F4\u586B\u5199\u3002')),_react2.default.createElement(_Potential2.default,null),_react2.default.createElement(_Recommend2.default,null),_react2.default.createElement(_button2.default,{className:'footer-btn',type:'primary',onClick:onSave,loading:saving},'\u4FDD\u5B58'))));}}]);return App;}(_react.Component))||_class)||_class);exports.default=App;

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor;__webpack_require__(8);__webpack_require__(4);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _mobx=__webpack_require__(30);var _data2=__webpack_require__(399);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TextArea=_input2.default.TextArea;var App=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=(_class2=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'onChange',_descriptor,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'render',value:function render(){var _this2=this;var _props$store$salesPer=this.props.store.salesPersonnel,data=_props$store$salesPer.data,loading=_props$store$salesPer.loading;console.log(JSON.stringify(data));return _react2.default.createElement('div',{className:''},_data2.listData.map(function(x,i){return _react2.default.createElement('div',null,_react2.default.createElement(_row2.default,{className:'secondary_title'},x.name),[1,2,3].map(function(_,index){var _data=data.slice(i*3+index,i*3+index+1)[0]||{};console.log(_data);return _react2.default.createElement('div',null,_react2.default.createElement(_table2.default,{columns:(0,_data2.columns)({sort:i*3+index,name:x.name,onChange:_this2.onChange}),dataSource:loading?[]:[_data],size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return i*3+index;}}),_react2.default.createElement(_row2.default,{className:'note_title'},x.placeholder),!loading&&_react2.default.createElement(TextArea,{className:'note m_b_80',autosize:{minRows:4},defaultValue:_data.notes,onBlur:function onBlur(e){(0,_mobx.runInAction)(function(){_this2.props.store.salesPersonnel.data[i*3+index].notes=e.target.value||"";});}}));}));}));}}]);return App;}(_react.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'onChange',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(name,value,i){var data=(0,_mobx.toJS)(_this3.props.store.salesPersonnel.data);data[i][name]=value;_this3.props.store.salesPersonnel.data=data;};}})),_class2))||_class)||_class);exports.default=App;

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor;__webpack_require__(8);__webpack_require__(4);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _mobx=__webpack_require__(30);var _data=__webpack_require__(399);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TextArea=_input2.default.TextArea;var App=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=(_class2=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'onChange',_descriptor,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'render',value:function render(){var _props$store$salesPer=this.props.store.salesPersonnel,recommend=_props$store$salesPer.recommend,loading=_props$store$salesPer.loading;return _react2.default.createElement('div',{className:''},_react2.default.createElement(_row2.default,{className:'secondary_title'},'\u9500\u552E\u90E8\u5458\u5DE5\u63A8\u8350'),_react2.default.createElement(_table2.default,{columns:(0,_data.recommendColumns)({name:"销售部员工推荐",onChange:this.onChange}),dataSource:loading?[]:recommend,size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}}));}}]);return App;}(_react.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'onChange',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(name,value,i){var data=(0,_mobx.toJS)(_this2.props.store.salesPersonnel.recommend);data[i][name]=value;_this2.props.store.salesPersonnel.recommend=data;};}})),_class2))||_class)||_class);exports.default=App;

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _alert=__webpack_require__(83);var _alert2=_interopRequireDefault(_alert);var _upload=__webpack_require__(171);var _upload2=_interopRequireDefault(_upload);var _icon=__webpack_require__(38);var _icon2=_interopRequireDefault(_icon);var _switch=__webpack_require__(249);var _switch2=_interopRequireDefault(_switch);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _popconfirm=__webpack_require__(110);var _popconfirm2=_interopRequireDefault(_popconfirm);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(62);__webpack_require__(84);__webpack_require__(172);__webpack_require__(75);__webpack_require__(250);__webpack_require__(14);__webpack_require__(8);__webpack_require__(6);__webpack_require__(111);__webpack_require__(10);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _data=__webpack_require__(1473);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);__webpack_require__(1474);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextArea=_input2.default.TextArea;var index=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={data:[],visible:false,actionData:{},loading:false,value:"",print:false},_this.onCancel=function(){_this.setState({actionData:{},visible:false});},_this.onShow=function(item){_this.setState({visible:true,actionData:_extends({},_data.defaultData,item)});},_this.onChange=function(name,v){_this.setState({actionData:_extends({},_this.state.actionData,_defineProperty({},name,v||""))});},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var value=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return(0,_request2.default)("/contract/lst?value="+value);case 3:res=_context.sent;_this.setState({data:[].concat(_toConsumableArray(res.data)).map(function(x,i){return _extends({},x,{index:i+1});})});_context.next=10;break;case 7:_context.prev=7;_context.t0=_context["catch"](0);console.log(_context.t0);case 10:case"end":return _context.stop();}}},_callee,_this2,[[0,7]]);}));return function(){return _ref2.apply(this,arguments);};}(),_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var data,reg,dataFrom,headres,res;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;data=_this.state.actionData;reg=/^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;if(!data.email.some(function(x){return!reg.test(x);})){_context2.next=5;break;}return _context2.abrupt("return",_message3.default.error("请输入正确的邮箱！"));case 5:delete data.index;_this.setState({loading:true});dataFrom=new FormData();if(!data.trial)data.trial=null;if(!data.end_time)data.end_time=null;if(!data.start_time)data.start_time=null;dataFrom.append("data",JSON.stringify(_extends({},data,{email:JSON.stringify(data.email||[])})));headres={method:"post",credentials:"include",headers:{},body:dataFrom};_context2.next=15;return(0,_request2.default)("/contract/save",headres);case 15:res=_context2.sent;_this.setState({loading:false});if(res.status==1){_message3.default.success("保存成功！");_this.setState({actionData:{},visible:false});_this.getData();}_context2.next=24;break;case 20:_context2.prev=20;_context2.t0=_context2["catch"](0);_this.setState({loading:false});console.log(_context2.t0);case 24:case"end":return _context2.stop();}}},_callee2,_this2,[[0,20]]);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData();}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,visible=_state.visible,actionData=_state.actionData,loading=_state.loading,value=_state.value,print=_state.print;var _columns=[].concat(_toConsumableArray(_data.columns));if(!print)_columns.push({title:"操作",key:"action",render:function render(v,a,i){return _react2.default.createElement("div",{className:"action-btn"},a.file&&_react2.default.createElement("span",{onClick:_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(){return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:window.open(a.file);case 1:case"end":return _context3.stop();}}},_callee3,_this3);}))},"\u67E5\u770B\u9644\u4EF6"),_react2.default.createElement("span",{onClick:function onClick(){_this3.onShow(_extends({},a,{email:JSON.parse(a.email||"[]")}));}},"\u7F16\u8F91"),_react2.default.createElement(_popconfirm2.default,{title:"\u786E\u5B9A\u8981\u5220\u9664"+a.hotel_name+"\u5408\u540C\u5417?",onConfirm:_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee4(){var res;return _regenerator2.default.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;_context4.next=3;return(0,_request2.default)("/contract/delete?id="+a.id);case 3:res=_context4.sent;if(res.status!=1)_message3.default.error(res.msg);else{_message3.default.success("删除成功！");_this3.setState({data:data.filter(function(x){return x.id!=a.id;})});}_context4.next=10;break;case 7:_context4.prev=7;_context4.t0=_context4["catch"](0);console.log(_context4.t0);case 10:case"end":return _context4.stop();}}},_callee4,_this3,[[0,7]]);})),okText:"\u786E\u5B9A",cancelText:"\u53D6\u6D88"},_react2.default.createElement("span",null,"\u5220\u9664")));}});return _react2.default.createElement("div",{className:"contract-management"},_react2.default.createElement("div",{className:"title"},"\u5408\u540C\u7BA1\u7406"),_react2.default.createElement("div",{className:"action"},_react2.default.createElement("div",{className:"search"},_react2.default.createElement(_input2.default,{placeholder:"\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u67E5\u8BE2",value:value,onChange:function onChange(e){return _this3.setState({value:e.target.value||""});}}),_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){return _this3.getData(value);}},"\u641C\u7D22")),_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){return _this3.onShow();}},"\u65B0\u5EFA\u5408\u540C")),_react2.default.createElement(_table2.default,{columns:_columns,dataSource:data,rowKey:function rowKey(r){return r.id;},id:"table",pagination:print?false:undefined}),_react2.default.createElement(_modal2.default,{title:actionData.id?"编辑合同":"新建合同",visible:visible,onOk:this.onSave,okText:"\u4FDD\u5B58",cancelText:"\u53D6\u6D88",confirmLoading:loading,onCancel:this.onCancel,className:"apply-billing"},_react2.default.createElement("p",null,"\u8BF7\u586B\u5199\u5408\u540C\u63A5\u6536\u4FE1\u606F"),_react2.default.createElement("p",null,_react2.default.createElement("span",{className:"billing-name"},"\u9152\u5E97\u540D\u79F0:"),_react2.default.createElement(_input2.default,{placeholder:"\u8BF7\u8F93\u5165\u9152\u5E97\u540D\u79F0",value:actionData.hotel_name,onChange:function onChange(e){return _this3.onChange("hotel_name",e.target.value);}})),_react2.default.createElement("p",null,_react2.default.createElement("span",{className:"billing-name"},"\u59D3\u540D:"),_react2.default.createElement(_input2.default,{placeholder:"\u8BF7\u8F93\u5165\u8054\u7CFB\u4EBA\u59D3\u540D",value:actionData.name,onChange:function onChange(e){return _this3.onChange("name",e.target.value);}})),_react2.default.createElement("p",null,_react2.default.createElement("span",{className:"billing-name"},"\u804C\u4F4D:"),_react2.default.createElement(_input2.default,{placeholder:"\u8BF7\u8F93\u5165\u804C\u4F4D",value:actionData.position,onChange:function onChange(e){return _this3.onChange("position",e.target.value);}})),_react2.default.createElement("p",null,_react2.default.createElement("span",{className:"billing-name"},"\u5408\u540C\u5F00\u59CB\u65F6\u95F4:"),_react2.default.createElement(_datePicker2.default,{value:actionData.start_time&&(0,_moment2.default)(actionData.start_time),onChange:function onChange(date,str){return _this3.onChange("start_time",str);}})),_react2.default.createElement("p",null,_react2.default.createElement("span",{className:"billing-name"},"\u5408\u540C\u622A\u6B62\u65F6\u95F4:"),_react2.default.createElement(_datePicker2.default,{value:actionData.end_time&&(0,_moment2.default)(actionData.end_time),onChange:function onChange(date,str){return _this3.onChange("end_time",str);}})),_react2.default.createElement("p",null,_react2.default.createElement("span",{className:"billing-name"},"\u8BD5\u7528\u5230\u671F\u65F6\u95F4:"),_react2.default.createElement(_datePicker2.default,{value:actionData.trial&&(0,_moment2.default)(actionData.trial),onChange:function onChange(date,str){return _this3.onChange("trial",str);}})),_react2.default.createElement("p",{style:{alignItems:"center"}},_react2.default.createElement("span",{className:"billing-name"},"\u662F\u5426\u63D0\u9192:"),_react2.default.createElement(_switch2.default,{style:{marginLeft:20},checkedChildren:"\u5F00\u542F\u63D0\u9192",unCheckedChildren:"\u5173\u95ED\u63D0\u9192",value:actionData.is_remind,onChange:function onChange(v){return _this3.onChange("is_remind",v?1:0);}})),_react2.default.createElement("p",null,_react2.default.createElement("span",{className:"billing-name"},"\u5907\u6CE8:"),_react2.default.createElement(TextArea,{placeholder:"\u8BF7\u8F93\u5165\u5907\u6CE8",value:actionData.note,rows:3,onChange:function onChange(e){return _this3.onChange("note",e.target.value);}})),_react2.default.createElement("p",null,_react2.default.createElement("span",{className:"billing-name"},"\u9644\u4EF6"),_react2.default.createElement(_upload2.default,{action:"/api/upload",disabled:loading,onChange:function onChange(_ref6){var file=_ref6.file;if(file.status=="removed"){_this3.setState({actionData:_extends({},actionData,{file:""})});return;}if(file.status=="uploading"){_this3.setState({loading:true});}if(file.status=="done")_this3.setState({actionData:_extends({},actionData,{file:file.response.data||""}),loading:false});else _this3.setState({actionData:_extends({},actionData,{file:file.uid})});},fileList:actionData.file?[{uid:actionData.file,url:actionData.file,name:actionData.file}]:[]},_react2.default.createElement(_button2.default,{style:{marginLeft:20}},_react2.default.createElement(_icon2.default,{type:"upload"})," ",loading?"上传数据中...":"上传附件"))),_react2.default.createElement("p",null,_react2.default.createElement(_alert2.default,{message:"\u9ED8\u8BA4\u901A\u77E5\u521B\u5EFA\u8005,\u53EF\u6DFB\u52A0\u591A\u4E2A\u63A5\u6536\u8005",type:"success"})),_react2.default.createElement("p",null,_react2.default.createElement(_button2.default,{type:"primary",block:true,onClick:function onClick(){var email=actionData.email;if(!email)email=[""];else email.push("");_this3.onChange("email",email);}},"\u589E\u52A0\u63A5\u6536\u90AE\u7BB1")),(actionData.email||[]).map(function(x,i){return _react2.default.createElement("p",{key:i,className:"list-item"},_react2.default.createElement("span",{className:"billing-name"},"\u90AE\u4EF6\u63A5\u6536\u5730\u5740",i+1,":"),_react2.default.createElement(_input2.default,{placeholder:"\u8BF7\u8F93\u5165\u90AE\u7BB1",value:x,onChange:function onChange(e){var value=e.target.value||"";var email=[].concat(_toConsumableArray(actionData.email));email[i]=value;_this3.onChange("email",email);}}),_react2.default.createElement(_icon2.default,{onClick:function onClick(){var email=[].concat(_toConsumableArray(actionData.email));email.splice(i,1);_this3.onChange("email",email);},type:"delete",className:"del-icon"}));})),_react2.default.createElement("div",{className:"export-excel"},_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this3.setState({print:true},function(){var innerHtml=" \n                            "+document.getElementById("table").innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n                            ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,"\u5408\u540C\u7BA1\u7406.xls");_this3.setState({print:false});});}},"\u5BFC\u51FAExcel")));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Upload__ = __webpack_require__(1416);
// export this package's api


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Upload__["a" /* default */]);

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AjaxUploader__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__IframeUploader__ = __webpack_require__(1421);










function empty() {}

var Upload = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Upload, _Component);

  function Upload() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Upload);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Upload.__proto__ || Object.getPrototypeOf(Upload)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      Component: null
    }, _this.saveUploader = function (node) {
      _this.uploader = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Upload, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.supportServerRender) {
        /* eslint react/no-did-mount-set-state:0 */
        this.setState({
          Component: this.getComponent()
        }, this.props.onReady);
      }
    }
  }, {
    key: 'getComponent',
    value: function getComponent() {
      return typeof File !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_7__AjaxUploader__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_8__IframeUploader__["a" /* default */];
    }
  }, {
    key: 'abort',
    value: function abort(file) {
      this.uploader.abort(file);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.supportServerRender) {
        var _ComponentUploader = this.state.Component;
        if (_ComponentUploader) {
          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(_ComponentUploader, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, { ref: this.saveUploader }));
        }
        return null;
      }
      var ComponentUploader = this.getComponent();
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ComponentUploader, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, { ref: this.saveUploader }));
    }
  }]);

  return Upload;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Upload.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  action: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
  name: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  multipart: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  directory: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onError: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSuccess: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onProgress: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onStart: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  data: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
  headers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  accept: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  beforeUpload: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  customRequest: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onReady: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  withCredentials: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  supportServerRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  openFileDialogOnClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
Upload.defaultProps = {
  component: 'span',
  prefixCls: 'rc-upload',
  data: {},
  headers: {},
  name: 'file',
  multipart: false,
  onReady: empty,
  onStart: empty,
  onError: empty,
  onSuccess: empty,
  supportServerRender: false,
  multiple: false,
  beforeUpload: null,
  customRequest: null,
  withCredentials: false,
  openFileDialogOnClick: true
};


/* harmony default export */ __webpack_exports__["a"] = (Upload);

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__request__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__uid__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__attr_accept__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__traverseFileTree__ = __webpack_require__(1420);






/* eslint react/no-is-mounted:0 react/sort-comp:0 */









var AjaxUploader = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AjaxUploader, _Component);

  function AjaxUploader() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AjaxUploader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AjaxUploader.__proto__ || Object.getPrototypeOf(AjaxUploader)).call.apply(_ref, [this].concat(args))), _this), _this.state = { uid: Object(__WEBPACK_IMPORTED_MODULE_10__uid__["a" /* default */])() }, _this.reqs = {}, _this.onChange = function (e) {
      var files = e.target.files;
      _this.uploadFiles(files);
      _this.reset();
    }, _this.onClick = function () {
      var el = _this.fileInput;
      if (!el) {
        return;
      }
      el.click();
    }, _this.onKeyDown = function (e) {
      if (e.key === 'Enter') {
        _this.onClick();
      }
    }, _this.onFileDrop = function (e) {
      var multiple = _this.props.multiple;


      e.preventDefault();

      if (e.type === 'dragover') {
        return;
      }

      if (_this.props.directory) {
        Object(__WEBPACK_IMPORTED_MODULE_12__traverseFileTree__["a" /* default */])(e.dataTransfer.items, _this.uploadFiles, function (_file) {
          return Object(__WEBPACK_IMPORTED_MODULE_11__attr_accept__["a" /* default */])(_file, _this.props.accept);
        });
      } else {
        var files = Array.prototype.slice.call(e.dataTransfer.files).filter(function (file) {
          return Object(__WEBPACK_IMPORTED_MODULE_11__attr_accept__["a" /* default */])(file, _this.props.accept);
        });

        if (multiple === false) {
          files = files.slice(0, 1);
        }

        _this.uploadFiles(files);
      }
    }, _this.uploadFiles = function (files) {
      var postFiles = Array.prototype.slice.call(files);
      postFiles.map(function (file) {
        file.uid = Object(__WEBPACK_IMPORTED_MODULE_10__uid__["a" /* default */])();
        return file;
      }).forEach(function (file) {
        _this.upload(file, postFiles);
      });
    }, _this.saveFileInput = function (node) {
      _this.fileInput = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AjaxUploader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
      this.abort();
    }
  }, {
    key: 'upload',
    value: function upload(file, fileList) {
      var _this2 = this;

      var props = this.props;

      if (!props.beforeUpload) {
        // always async in case use react state to keep fileList
        return setTimeout(function () {
          return _this2.post(file);
        }, 0);
      }

      var before = props.beforeUpload(file, fileList);
      if (before && before.then) {
        before.then(function (processedFile) {
          var processedFileType = Object.prototype.toString.call(processedFile);
          if (processedFileType === '[object File]' || processedFileType === '[object Blob]') {
            return _this2.post(processedFile);
          }
          return _this2.post(file);
        })['catch'](function (e) {
          console && console.log(e); // eslint-disable-line
        });
      } else if (before !== false) {
        setTimeout(function () {
          return _this2.post(file);
        }, 0);
      }
    }
  }, {
    key: 'post',
    value: function post(file) {
      var _this3 = this;

      if (!this._isMounted) {
        return;
      }
      var props = this.props;
      var data = props.data;
      var onStart = props.onStart,
          onProgress = props.onProgress,
          _props$transformFile = props.transformFile,
          transformFile = _props$transformFile === undefined ? function (originFile) {
        return originFile;
      } : _props$transformFile;


      new Promise(function (resolve) {
        var action = props.action;

        if (typeof action === 'function') {
          return resolve(action(file));
        }
        resolve(action);
      }).then(function (action) {
        var uid = file.uid;

        var request = props.customRequest || __WEBPACK_IMPORTED_MODULE_9__request__["a" /* default */];
        var transform = Promise.resolve(transformFile(file))['catch'](function (e) {
          console.error(e); // eslint-disable-line no-console
        });

        transform.then(function (transformedFile) {
          if (typeof data === 'function') {
            data = data(file);
          }

          var requestOption = {
            action: action,
            filename: props.name,
            data: data,
            file: transformedFile,
            headers: props.headers,
            withCredentials: props.withCredentials,
            method: props.method || 'post',
            onProgress: onProgress ? function (e) {
              onProgress(e, file);
            } : null,
            onSuccess: function onSuccess(ret, xhr) {
              delete _this3.reqs[uid];
              props.onSuccess(ret, file, xhr);
            },
            onError: function onError(err, ret) {
              delete _this3.reqs[uid];
              props.onError(err, ret, file);
            }
          };
          _this3.reqs[uid] = request(requestOption);
          onStart(file);
        });
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.setState({
        uid: Object(__WEBPACK_IMPORTED_MODULE_10__uid__["a" /* default */])()
      });
    }
  }, {
    key: 'abort',
    value: function abort(file) {
      var reqs = this.reqs;

      if (file) {
        var uid = file;
        if (file && file.uid) {
          uid = file.uid;
        }
        if (reqs[uid] && reqs[uid].abort) {
          reqs[uid].abort();
        }
        delete reqs[uid];
      } else {
        Object.keys(reqs).forEach(function (uid) {
          if (reqs[uid] && reqs[uid].abort) {
            reqs[uid].abort();
          }
          delete reqs[uid];
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          Tag = _props.component,
          prefixCls = _props.prefixCls,
          className = _props.className,
          disabled = _props.disabled,
          id = _props.id,
          style = _props.style,
          multiple = _props.multiple,
          accept = _props.accept,
          children = _props.children,
          directory = _props.directory,
          openFileDialogOnClick = _props.openFileDialogOnClick;

      var cls = __WEBPACK_IMPORTED_MODULE_8_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls, true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-disabled', disabled), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, className, className), _classNames));
      var events = disabled ? {} : {
        onClick: openFileDialogOnClick ? this.onClick : function () {},
        onKeyDown: openFileDialogOnClick ? this.onKeyDown : function () {},
        onDrop: this.onFileDrop,
        onDragOver: this.onFileDrop,
        tabIndex: '0'
      };
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        Tag,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, events, {
          className: cls,
          role: 'button',
          style: style
        }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', {
          id: id,
          type: 'file',
          ref: this.saveFileInput,
          onClick: function onClick(e) {
            return e.stopPropagation();
          } // https://github.com/ant-design/ant-design/issues/19948
          , key: this.state.uid,
          style: { display: 'none' },
          accept: accept,
          directory: directory ? 'directory' : null,
          webkitdirectory: directory ? 'webkitdirectory' : null,
          multiple: multiple,
          onChange: this.onChange
        }),
        children
      );
    }
  }]);

  return AjaxUploader;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

AjaxUploader.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  multiple: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  directory: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  accept: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  onStart: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  data: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),
  action: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),
  headers: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  beforeUpload: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  customRequest: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onProgress: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  withCredentials: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  openFileDialogOnClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transformFile: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};


/* harmony default export */ __webpack_exports__["a"] = (AjaxUploader);

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = upload;
function getError(option, xhr) {
  var msg = 'cannot ' + option.method + ' ' + option.action + ' ' + xhr.status + '\'';
  var err = new Error(msg);
  err.status = xhr.status;
  err.method = option.method;
  err.url = option.action;
  return err;
}

function getBody(xhr) {
  var text = xhr.responseText || xhr.response;
  if (!text) {
    return text;
  }

  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
}

// option {
//  onProgress: (event: { percent: number }): void,
//  onError: (event: Error, body?: Object): void,
//  onSuccess: (body: Object): void,
//  data: Object,
//  filename: String,
//  file: File,
//  withCredentials: Boolean,
//  action: String,
//  headers: Object,
// }
function upload(option) {
  var xhr = new XMLHttpRequest();

  if (option.onProgress && xhr.upload) {
    xhr.upload.onprogress = function progress(e) {
      if (e.total > 0) {
        e.percent = e.loaded / e.total * 100;
      }
      option.onProgress(e);
    };
  }

  var formData = new FormData();

  if (option.data) {
    Object.keys(option.data).forEach(function (key) {
      var value = option.data[key];
      // support key-value array data
      if (Array.isArray(value)) {
        value.forEach(function (item) {
          // { list: [ 11, 22 ] }
          // formData.append('list[]', 11);
          formData.append(key + '[]', item);
        });
        return;
      }

      formData.append(key, option.data[key]);
    });
  }

  formData.append(option.filename, option.file);

  xhr.onerror = function error(e) {
    option.onError(e);
  };

  xhr.onload = function onload() {
    // allow success when 2xx status
    // see https://github.com/react-component/upload/issues/34
    if (xhr.status < 200 || xhr.status >= 300) {
      return option.onError(getError(option, xhr), getBody(xhr));
    }

    option.onSuccess(getBody(xhr), xhr);
  };

  xhr.open(option.method, option.action, true);

  // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
  if (option.withCredentials && 'withCredentials' in xhr) {
    xhr.withCredentials = true;
  }

  var headers = option.headers || {};

  // when set headers['X-Requested-With'] = null , can close default XHR header
  // see https://github.com/react-component/upload/issues/33
  if (headers['X-Requested-With'] !== null) {
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  }

  for (var h in headers) {
    if (headers.hasOwnProperty(h) && headers[h] !== null) {
      xhr.setRequestHeader(h, headers[h]);
    }
  }
  xhr.send(formData);

  return {
    abort: function abort() {
      xhr.abort();
    }
  };
}

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function endsWith(str, suffix) {
  return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

/* harmony default export */ __webpack_exports__["a"] = (function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = file.type || '';
    var baseMimeType = mimeType.replace(/\/.*$/, '');

    return acceptedFilesArray.some(function (type) {
      var validType = type.trim();
      if (validType.charAt(0) === '.') {
        return endsWith(fileName.toLowerCase(), validType.toLowerCase());
      } else if (/\/\*$/.test(validType)) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }
      return mimeType === validType;
    });
  }
  return true;
});

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function loopFiles(item, callback) {
  var dirReader = item.createReader();
  var fileList = [];

  function sequence() {
    dirReader.readEntries(function (entries) {
      var entryList = Array.prototype.slice.apply(entries);
      fileList = fileList.concat(entryList);

      // Check if all the file has been viewed
      var isFinished = !entryList.length;

      if (isFinished) {
        callback(fileList);
      } else {
        sequence();
      }
    });
  }

  sequence();
}

var traverseFileTree = function traverseFileTree(files, callback, isAccepted) {
  var _traverseFileTree = function _traverseFileTree(item, path) {
    path = path || '';
    if (item.isFile) {
      item.file(function (file) {
        if (isAccepted(file)) {
          // https://github.com/ant-design/ant-design/issues/16426
          if (item.fullPath && !file.webkitRelativePath) {
            Object.defineProperties(file, {
              webkitRelativePath: {
                writable: true
              }
            });
            file.webkitRelativePath = item.fullPath.replace(/^\//, '');
            Object.defineProperties(file, {
              webkitRelativePath: {
                writable: false
              }
            });
          }
          callback([file]);
        }
      });
    } else if (item.isDirectory) {
      loopFiles(item, function (entries) {
        entries.forEach(function (entryItem) {
          _traverseFileTree(entryItem, '' + path + item.name + '/');
        });
      });
    }
  };
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var file = _step.value;

      _traverseFileTree(file.webkitGetAsEntry());
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator['return']) {
        _iterator['return']();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (traverseFileTree);

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__uid__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_warning__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_warning__);






/* eslint react/sort-comp:0 */







var IFRAME_STYLE = {
  position: 'absolute',
  top: 0,
  opacity: 0,
  filter: 'alpha(opacity=0)',
  left: 0,
  zIndex: 9999
};

// diferent from AjaxUpload, can only upload on at one time, serial seriously

var IframeUploader = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(IframeUploader, _Component);

  function IframeUploader() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, IframeUploader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = IframeUploader.__proto__ || Object.getPrototypeOf(IframeUploader)).call.apply(_ref, [this].concat(args))), _this), _this.state = { uploading: false }, _this.file = {}, _this.onLoad = function () {
      if (!_this.state.uploading) {
        return;
      }
      var _this2 = _this,
          props = _this2.props,
          file = _this2.file;

      var response = void 0;
      try {
        var doc = _this.getIframeDocument();
        var script = doc.getElementsByTagName('script')[0];
        if (script && script.parentNode === doc.body) {
          doc.body.removeChild(script);
        }
        response = doc.body.innerHTML;
        props.onSuccess(response, file);
      } catch (err) {
        __WEBPACK_IMPORTED_MODULE_11_warning___default()(false, 'cross domain error for Upload. Maybe server should return document.domain script. see Note from https://github.com/react-component/upload');
        response = 'cross-domain';
        props.onError(err, null, file);
      }
      _this.endUpload();
    }, _this.onChange = function () {
      var target = _this.getFormInputNode();
      // ie8/9 don't support FileList Object
      // http://stackoverflow.com/questions/12830058/ie8-input-type-file-get-files
      var file = _this.file = {
        uid: Object(__WEBPACK_IMPORTED_MODULE_10__uid__["a" /* default */])(),
        name: target.value && target.value.substring(target.value.lastIndexOf('\\') + 1, target.value.length)
      };
      _this.startUpload();
      var _this3 = _this,
          props = _this3.props;

      if (!props.beforeUpload) {
        return _this.post(file);
      }
      var before = props.beforeUpload(file);
      if (before && before.then) {
        before.then(function () {
          _this.post(file);
        }, function () {
          _this.endUpload();
        });
      } else if (before !== false) {
        _this.post(file);
      } else {
        _this.endUpload();
      }
    }, _this.saveIframe = function (node) {
      _this.iframe = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(IframeUploader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateIframeWH();
      this.initIframe();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateIframeWH();
    }
  }, {
    key: 'getIframeNode',
    value: function getIframeNode() {
      return this.iframe;
    }
  }, {
    key: 'getIframeDocument',
    value: function getIframeDocument() {
      return this.getIframeNode().contentDocument;
    }
  }, {
    key: 'getFormNode',
    value: function getFormNode() {
      return this.getIframeDocument().getElementById('form');
    }
  }, {
    key: 'getFormInputNode',
    value: function getFormInputNode() {
      return this.getIframeDocument().getElementById('input');
    }
  }, {
    key: 'getFormDataNode',
    value: function getFormDataNode() {
      return this.getIframeDocument().getElementById('data');
    }
  }, {
    key: 'getFileForMultiple',
    value: function getFileForMultiple(file) {
      return this.props.multiple ? [file] : file;
    }
  }, {
    key: 'getIframeHTML',
    value: function getIframeHTML(domain) {
      var domainScript = '';
      var domainInput = '';
      if (domain) {
        var script = 'script';
        domainScript = '<' + script + '>document.domain="' + domain + '";</' + script + '>';
        domainInput = '<input name="_documentDomain" value="' + domain + '" />';
      }
      return '\n    <!DOCTYPE html>\n    <html>\n    <head>\n    <meta http-equiv="X-UA-Compatible" content="IE=edge" />\n    <style>\n    body,html {padding:0;margin:0;border:0;overflow:hidden;}\n    </style>\n    ' + domainScript + '\n    </head>\n    <body>\n    <form method="post"\n    encType="multipart/form-data"\n    action="" id="form"\n    style="display:block;height:9999px;position:relative;overflow:hidden;">\n    <input id="input" type="file"\n     name="' + this.props.name + '"\n     style="position:absolute;top:0;right:0;height:9999px;font-size:9999px;cursor:pointer;"/>\n    ' + domainInput + '\n    <span id="data"></span>\n    </form>\n    </body>\n    </html>\n    ';
    }
  }, {
    key: 'initIframeSrc',
    value: function initIframeSrc() {
      if (this.domain) {
        this.getIframeNode().src = 'javascript:void((function(){\n        var d = document;\n        d.open();\n        d.domain=\'' + this.domain + '\';\n        d.write(\'\');\n        d.close();\n      })())';
      }
    }
  }, {
    key: 'initIframe',
    value: function initIframe() {
      var iframeNode = this.getIframeNode();
      var win = iframeNode.contentWindow;
      var doc = void 0;
      this.domain = this.domain || '';
      this.initIframeSrc();
      try {
        doc = win.document;
      } catch (e) {
        this.domain = document.domain;
        this.initIframeSrc();
        win = iframeNode.contentWindow;
        doc = win.document;
      }
      doc.open('text/html', 'replace');
      doc.write(this.getIframeHTML(this.domain));
      doc.close();
      this.getFormInputNode().onchange = this.onChange;
    }
  }, {
    key: 'endUpload',
    value: function endUpload() {
      if (this.state.uploading) {
        this.file = {};
        // hack avoid batch
        this.state.uploading = false;
        this.setState({
          uploading: false
        });
        this.initIframe();
      }
    }
  }, {
    key: 'startUpload',
    value: function startUpload() {
      if (!this.state.uploading) {
        this.state.uploading = true;
        this.setState({
          uploading: true
        });
      }
    }
  }, {
    key: 'updateIframeWH',
    value: function updateIframeWH() {
      var rootNode = __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this);
      var iframeNode = this.getIframeNode();
      iframeNode.style.height = rootNode.offsetHeight + 'px';
      iframeNode.style.width = rootNode.offsetWidth + 'px';
    }
  }, {
    key: 'abort',
    value: function abort(file) {
      if (file) {
        var uid = file;
        if (file && file.uid) {
          uid = file.uid;
        }
        if (uid === this.file.uid) {
          this.endUpload();
        }
      } else {
        this.endUpload();
      }
    }
  }, {
    key: 'post',
    value: function post(file) {
      var _this4 = this;

      var formNode = this.getFormNode();
      var dataSpan = this.getFormDataNode();
      var data = this.props.data;
      var onStart = this.props.onStart;

      if (typeof data === 'function') {
        data = data(file);
      }
      var inputs = document.createDocumentFragment();
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          var input = document.createElement('input');
          input.setAttribute('name', key);
          input.value = data[key];
          inputs.appendChild(input);
        }
      }
      dataSpan.appendChild(inputs);
      new Promise(function (resolve) {
        var action = _this4.props.action;

        if (typeof action === 'function') {
          return resolve(action(file));
        }
        resolve(action);
      }).then(function (action) {
        formNode.setAttribute('action', action);
        formNode.submit();
        dataSpan.innerHTML = '';
        onStart(file);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          Tag = _props.component,
          disabled = _props.disabled,
          className = _props.className,
          prefixCls = _props.prefixCls,
          children = _props.children,
          style = _props.style;

      var iframeStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, IFRAME_STYLE, {
        display: this.state.uploading || disabled ? 'none' : ''
      });
      var cls = __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-disabled', disabled), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, className, className), _classNames));
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        Tag,
        {
          className: cls,
          style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ position: 'relative', zIndex: 0 }, style)
        },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('iframe', {
          ref: this.saveIframe,
          onLoad: this.onLoad,
          style: iframeStyle
        }),
        children
      );
    }
  }]);

  return IframeUploader;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

IframeUploader.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  prefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  accept: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  onStart: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  multiple: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  data: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),
  action: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),
  name: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (IframeUploader);

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(591),
    baseUniq = __webpack_require__(1452);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1424),
    getMatchData = __webpack_require__(1444),
    matchesStrictComparable = __webpack_require__(599);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(349),
    baseIsEqual = __webpack_require__(592);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(349),
    equalArrays = __webpack_require__(593),
    equalByTag = __webpack_require__(1429),
    equalObjects = __webpack_require__(1431),
    getTag = __webpack_require__(1440),
    isArray = __webpack_require__(132),
    isBuffer = __webpack_require__(357),
    isTypedArray = __webpack_require__(358);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1426 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1427 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1428 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(265),
    Uint8Array = __webpack_require__(512),
    eq = __webpack_require__(222),
    equalArrays = __webpack_require__(593),
    mapToArray = __webpack_require__(1430),
    setToArray = __webpack_require__(400);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1430 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(1432);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1433),
    getSymbols = __webpack_require__(1435),
    keys = __webpack_require__(596);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1434),
    isArray = __webpack_require__(132);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 1434 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1436),
    stubArray = __webpack_require__(1437);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 1436 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 1437 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(354),
    nativeKeys = __webpack_require__(1439);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(514);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1441),
    Map = __webpack_require__(350),
    Promise = __webpack_require__(1442),
    Set = __webpack_require__(597),
    WeakMap = __webpack_require__(1443),
    baseGetTag = __webpack_require__(195),
    toSource = __webpack_require__(509);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(158),
    root = __webpack_require__(101);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(158),
    root = __webpack_require__(101);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(158),
    root = __webpack_require__(101);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(598),
    keys = __webpack_require__(596);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(592),
    get = __webpack_require__(520),
    hasIn = __webpack_require__(1446),
    isKey = __webpack_require__(361),
    isStrictComparable = __webpack_require__(598),
    matchesStrictComparable = __webpack_require__(599),
    toKey = __webpack_require__(270);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1447),
    hasPath = __webpack_require__(1448);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1447 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(522),
    isArguments = __webpack_require__(355),
    isArray = __webpack_require__(132),
    isIndex = __webpack_require__(359),
    isLength = __webpack_require__(356),
    toKey = __webpack_require__(270);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1450),
    basePropertyDeep = __webpack_require__(1451),
    isKey = __webpack_require__(361),
    toKey = __webpack_require__(270);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1450 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(521);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(594),
    arrayIncludes = __webpack_require__(1453),
    arrayIncludesWith = __webpack_require__(1457),
    cacheHas = __webpack_require__(595),
    createSet = __webpack_require__(1458),
    setToArray = __webpack_require__(400);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(1454);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(600),
    baseIsNaN = __webpack_require__(1455),
    strictIndexOf = __webpack_require__(1456);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 1455 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1456 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1457 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(597),
    noop = __webpack_require__(1459),
    setToArray = __webpack_require__(400);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 1459 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(600),
    baseIteratee = __webpack_require__(591),
    toInteger = __webpack_require__(1461);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(1462);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(533);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcAnimate = _interopRequireDefault(__webpack_require__(188));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _utils = __webpack_require__(601);

var _icon = _interopRequireDefault(__webpack_require__(38));

var _tooltip = _interopRequireDefault(__webpack_require__(87));

var _progress = _interopRequireDefault(__webpack_require__(602));

var _configProvider = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var UploadList = /*#__PURE__*/function (_React$Component) {
  _inherits(UploadList, _React$Component);

  var _super = _createSuper(UploadList);

  function UploadList() {
    var _this;

    _classCallCheck(this, UploadList);

    _this = _super.apply(this, arguments);

    _this.handlePreview = function (file, e) {
      var onPreview = _this.props.onPreview;

      if (!onPreview) {
        return;
      }

      e.preventDefault();
      return onPreview(file);
    };

    _this.handleDownload = function (file) {
      var onDownload = _this.props.onDownload;

      if (typeof onDownload === 'function') {
        onDownload(file);
      } else if (file.url) {
        window.open(file.url);
      }
    };

    _this.handleClose = function (file) {
      var onRemove = _this.props.onRemove;

      if (onRemove) {
        onRemove(file);
      }
    };

    _this.renderUploadList = function (_ref) {
      var _classNames4;

      var getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          _this$props$items = _this$props.items,
          items = _this$props$items === void 0 ? [] : _this$props$items,
          listType = _this$props.listType,
          showPreviewIcon = _this$props.showPreviewIcon,
          showRemoveIcon = _this$props.showRemoveIcon,
          showDownloadIcon = _this$props.showDownloadIcon,
          locale = _this$props.locale,
          progressAttr = _this$props.progressAttr;
      var prefixCls = getPrefixCls('upload', customizePrefixCls);
      var list = items.map(function (file) {
        var _classNames, _classNames2;

        var progress;
        var icon = /*#__PURE__*/React.createElement(_icon["default"], {
          type: file.status === 'uploading' ? 'loading' : 'paper-clip'
        });

        if (listType === 'picture' || listType === 'picture-card') {
          if (listType === 'picture-card' && file.status === 'uploading') {
            icon = /*#__PURE__*/React.createElement("div", {
              className: "".concat(prefixCls, "-list-item-uploading-text")
            }, locale.uploading);
          } else if (!file.thumbUrl && !file.url) {
            icon = /*#__PURE__*/React.createElement(_icon["default"], {
              className: "".concat(prefixCls, "-list-item-thumbnail"),
              type: "picture",
              theme: "twoTone"
            });
          } else {
            var thumbnail = (0, _utils.isImageUrl)(file) ? /*#__PURE__*/React.createElement("img", {
              src: file.thumbUrl || file.url,
              alt: file.name,
              className: "".concat(prefixCls, "-list-item-image")
            }) : /*#__PURE__*/React.createElement(_icon["default"], {
              type: "file",
              className: "".concat(prefixCls, "-list-item-icon"),
              theme: "twoTone"
            });
            icon = /*#__PURE__*/React.createElement("a", {
              className: "".concat(prefixCls, "-list-item-thumbnail"),
              onClick: function onClick(e) {
                return _this.handlePreview(file, e);
              },
              href: file.url || file.thumbUrl,
              target: "_blank",
              rel: "noopener noreferrer"
            }, thumbnail);
          }
        }

        if (file.status === 'uploading') {
          // show loading icon if upload progress listener is disabled
          var loadingProgress = 'percent' in file ? /*#__PURE__*/React.createElement(_progress["default"], _extends({
            type: "line"
          }, progressAttr, {
            percent: file.percent
          })) : null;
          progress = /*#__PURE__*/React.createElement("div", {
            className: "".concat(prefixCls, "-list-item-progress"),
            key: "progress"
          }, loadingProgress);
        }

        var infoUploadingClass = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-list-item"), true), _defineProperty(_classNames, "".concat(prefixCls, "-list-item-").concat(file.status), true), _defineProperty(_classNames, "".concat(prefixCls, "-list-item-list-type-").concat(listType), true), _classNames));
        var linkProps = typeof file.linkProps === 'string' ? JSON.parse(file.linkProps) : file.linkProps;
        var removeIcon = showRemoveIcon ? /*#__PURE__*/React.createElement(_icon["default"], {
          type: "delete",
          title: locale.removeFile,
          onClick: function onClick() {
            return _this.handleClose(file);
          }
        }) : null;
        var downloadIcon = showDownloadIcon && file.status === 'done' ? /*#__PURE__*/React.createElement(_icon["default"], {
          type: "download",
          title: locale.downloadFile,
          onClick: function onClick() {
            return _this.handleDownload(file);
          }
        }) : null;
        var downloadOrDelete = listType !== 'picture-card' && /*#__PURE__*/React.createElement("span", {
          key: "download-delete",
          className: "".concat(prefixCls, "-list-item-card-actions ").concat(listType === 'picture' ? 'picture' : '')
        }, downloadIcon && /*#__PURE__*/React.createElement("a", {
          title: locale.downloadFile
        }, downloadIcon), removeIcon && /*#__PURE__*/React.createElement("a", {
          title: locale.removeFile
        }, removeIcon));
        var listItemNameClass = (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-list-item-name"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-list-item-name-icon-count-").concat([downloadIcon, removeIcon].filter(function (x) {
          return x;
        }).length), true), _classNames2));
        var preview = file.url ? [/*#__PURE__*/React.createElement("a", _extends({
          key: "view",
          target: "_blank",
          rel: "noopener noreferrer",
          className: listItemNameClass,
          title: file.name
        }, linkProps, {
          href: file.url,
          onClick: function onClick(e) {
            return _this.handlePreview(file, e);
          }
        }), file.name), downloadOrDelete] : [/*#__PURE__*/React.createElement("span", {
          key: "view",
          className: listItemNameClass,
          onClick: function onClick(e) {
            return _this.handlePreview(file, e);
          },
          title: file.name
        }, file.name), downloadOrDelete];
        var style = {
          pointerEvents: 'none',
          opacity: 0.5
        };
        var previewIcon = showPreviewIcon ? /*#__PURE__*/React.createElement("a", {
          href: file.url || file.thumbUrl,
          target: "_blank",
          rel: "noopener noreferrer",
          style: file.url || file.thumbUrl ? undefined : style,
          onClick: function onClick(e) {
            return _this.handlePreview(file, e);
          },
          title: locale.previewFile
        }, /*#__PURE__*/React.createElement(_icon["default"], {
          type: "eye-o"
        })) : null;
        var actions = listType === 'picture-card' && file.status !== 'uploading' && /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefixCls, "-list-item-actions")
        }, previewIcon, file.status === 'done' && downloadIcon, removeIcon);
        var message;

        if (file.response && typeof file.response === 'string') {
          message = file.response;
        } else {
          message = file.error && file.error.statusText || locale.uploadError;
        }

        var iconAndPreview = /*#__PURE__*/React.createElement("span", null, icon, preview);
        var dom = /*#__PURE__*/React.createElement("div", {
          className: infoUploadingClass
        }, /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-list-item-info")
        }, iconAndPreview), actions, /*#__PURE__*/React.createElement(_rcAnimate["default"], {
          transitionName: "fade",
          component: ""
        }, progress));
        var listContainerNameClass = (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-list-picture-card-container"), listType === 'picture-card'));
        return /*#__PURE__*/React.createElement("div", {
          key: file.uid,
          className: listContainerNameClass
        }, file.status === 'error' ? /*#__PURE__*/React.createElement(_tooltip["default"], {
          title: message
        }, dom) : /*#__PURE__*/React.createElement("span", null, dom));
      });
      var listClassNames = (0, _classnames["default"])((_classNames4 = {}, _defineProperty(_classNames4, "".concat(prefixCls, "-list"), true), _defineProperty(_classNames4, "".concat(prefixCls, "-list-").concat(listType), true), _classNames4));
      var animationDirection = listType === 'picture-card' ? 'animate-inline' : 'animate';
      return /*#__PURE__*/React.createElement(_rcAnimate["default"], {
        transitionName: "".concat(prefixCls, "-").concat(animationDirection),
        component: "div",
        className: listClassNames
      }, list);
    };

    return _this;
  }

  _createClass(UploadList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      var _this$props2 = this.props,
          listType = _this$props2.listType,
          items = _this$props2.items,
          previewFile = _this$props2.previewFile;

      if (listType !== 'picture' && listType !== 'picture-card') {
        return;
      }

      (items || []).forEach(function (file) {
        if (typeof document === 'undefined' || typeof window === 'undefined' || !window.FileReader || !window.File || !(file.originFileObj instanceof File || file.originFileObj instanceof Blob) || file.thumbUrl !== undefined) {
          return;
        }

        file.thumbUrl = '';

        if (previewFile) {
          previewFile(file.originFileObj).then(function (previewDataUrl) {
            // Need append '' to avoid dead loop
            file.thumbUrl = previewDataUrl || '';

            _this2.forceUpdate();
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderUploadList);
    }
  }]);

  return UploadList;
}(React.Component);

exports["default"] = UploadList;
UploadList.defaultProps = {
  listType: 'text',
  progressAttr: {
    strokeWidth: 2,
    showInfo: false
  },
  showRemoveIcon: true,
  showDownloadIcon: false,
  showPreviewIcon: true,
  previewFile: _utils.previewImage
};

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(19));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _omit = _interopRequireDefault(__webpack_require__(71));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _configProvider = __webpack_require__(39);

var _type = __webpack_require__(130);

var _Line = _interopRequireDefault(__webpack_require__(1465));

var _Circle = _interopRequireDefault(__webpack_require__(1466));

var _utils = __webpack_require__(401);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var ProgressTypes = (0, _type.tuple)('line', 'circle', 'dashboard');
var ProgressStatuses = (0, _type.tuple)('normal', 'exception', 'active', 'success');

var Progress = /*#__PURE__*/function (_React$Component) {
  _inherits(Progress, _React$Component);

  var _super = _createSuper(Progress);

  function Progress() {
    var _this;

    _classCallCheck(this, Progress);

    _this = _super.apply(this, arguments);

    _this.renderProgress = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      var customizePrefixCls = props.prefixCls,
          className = props.className,
          size = props.size,
          type = props.type,
          showInfo = props.showInfo,
          restProps = __rest(props, ["prefixCls", "className", "size", "type", "showInfo"]);

      var prefixCls = getPrefixCls('progress', customizePrefixCls);

      var progressStatus = _this.getProgressStatus();

      var progressInfo = _this.renderProcessInfo(prefixCls, progressStatus);

      var progress; // Render progress shape

      if (type === 'line') {
        progress = /*#__PURE__*/React.createElement(_Line["default"], _extends({}, _this.props, {
          prefixCls: prefixCls
        }), progressInfo);
      } else if (type === 'circle' || type === 'dashboard') {
        progress = /*#__PURE__*/React.createElement(_Circle["default"], _extends({}, _this.props, {
          prefixCls: prefixCls,
          progressStatus: progressStatus
        }), progressInfo);
      }

      var classString = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type === 'dashboard' && 'circle' || type), true), _defineProperty(_classNames, "".concat(prefixCls, "-status-").concat(progressStatus), true), _defineProperty(_classNames, "".concat(prefixCls, "-show-info"), showInfo), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), size), _classNames), className);
      return /*#__PURE__*/React.createElement("div", _extends({}, (0, _omit["default"])(restProps, ['status', 'format', 'trailColor', 'successPercent', 'strokeWidth', 'width', 'gapDegree', 'gapPosition', 'strokeColor', 'strokeLinecap', 'percent']), {
        className: classString
      }), progress);
    };

    return _this;
  }

  _createClass(Progress, [{
    key: "getPercentNumber",
    value: function getPercentNumber() {
      var _this$props = this.props,
          successPercent = _this$props.successPercent,
          _this$props$percent = _this$props.percent,
          percent = _this$props$percent === void 0 ? 0 : _this$props$percent;
      return parseInt(successPercent !== undefined ? successPercent.toString() : percent.toString(), 10);
    }
  }, {
    key: "getProgressStatus",
    value: function getProgressStatus() {
      var status = this.props.status;

      if (ProgressStatuses.indexOf(status) < 0 && this.getPercentNumber() >= 100) {
        return 'success';
      }

      return status || 'normal';
    }
  }, {
    key: "renderProcessInfo",
    value: function renderProcessInfo(prefixCls, progressStatus) {
      var _this$props2 = this.props,
          showInfo = _this$props2.showInfo,
          format = _this$props2.format,
          type = _this$props2.type,
          percent = _this$props2.percent,
          successPercent = _this$props2.successPercent;
      if (!showInfo) return null;
      var text;

      var textFormatter = format || function (percentNumber) {
        return "".concat(percentNumber, "%");
      };

      var iconType = type === 'circle' || type === 'dashboard' ? '' : '-circle';

      if (format || progressStatus !== 'exception' && progressStatus !== 'success') {
        text = textFormatter((0, _utils.validProgress)(percent), (0, _utils.validProgress)(successPercent));
      } else if (progressStatus === 'exception') {
        text = /*#__PURE__*/React.createElement(_icon["default"], {
          type: "close".concat(iconType),
          theme: type === 'line' ? 'filled' : 'outlined'
        });
      } else if (progressStatus === 'success') {
        text = /*#__PURE__*/React.createElement(_icon["default"], {
          type: "check".concat(iconType),
          theme: type === 'line' ? 'filled' : 'outlined'
        });
      }

      return /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-text"),
        title: typeof text === 'string' ? text : undefined
      }, text);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderProgress);
    }
  }]);

  return Progress;
}(React.Component);

exports["default"] = Progress;
Progress.defaultProps = {
  type: 'line',
  percent: 0,
  showInfo: true,
  trailColor: '#f3f3f3',
  size: 'default',
  gapDegree: 0,
  strokeLinecap: 'round'
};
Progress.propTypes = {
  status: PropTypes.oneOf(ProgressStatuses),
  type: PropTypes.oneOf(ProgressTypes),
  showInfo: PropTypes.bool,
  percent: PropTypes.number,
  width: PropTypes.number,
  strokeWidth: PropTypes.number,
  strokeLinecap: PropTypes.oneOf(['round', 'square']),
  strokeColor: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  trailColor: PropTypes.string,
  format: PropTypes.func,
  gapDegree: PropTypes.number
};

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.handleGradient = exports.sortGradient = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(401);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

/**
 * {
 *   '0%': '#afc163',
 *   '75%': '#009900',
 *   '50%': 'green',     ====>     '#afc163 0%, #66FF00 25%, #00CC00 50%, #009900 75%, #ffffff 100%'
 *   '25%': '#66FF00',
 *   '100%': '#ffffff'
 * }
 */
var sortGradient = function sortGradient(gradients) {
  var tempArr = []; // eslint-disable-next-line no-restricted-syntax

  for (var _i = 0, _Object$entries = Object.entries(gradients); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    var formatKey = parseFloat(key.replace(/%/g, ''));

    if (isNaN(formatKey)) {
      return {};
    }

    tempArr.push({
      key: formatKey,
      value: value
    });
  }

  tempArr = tempArr.sort(function (a, b) {
    return a.key - b.key;
  });
  return tempArr.map(function (_ref) {
    var key = _ref.key,
        value = _ref.value;
    return "".concat(value, " ").concat(key, "%");
  }).join(', ');
};
/**
 * {
 *   '0%': '#afc163',
 *   '25%': '#66FF00',
 *   '50%': '#00CC00',     ====>  linear-gradient(to right, #afc163 0%, #66FF00 25%,
 *   '75%': '#009900',              #00CC00 50%, #009900 75%, #ffffff 100%)
 *   '100%': '#ffffff'
 * }
 *
 * Then this man came to realize the truth:
 * Besides six pence, there is the moon.
 * Besides bread and butter, there is the bug.
 * And...
 * Besides women, there is the code.
 */


exports.sortGradient = sortGradient;

var handleGradient = function handleGradient(strokeColor) {
  var _strokeColor$from = strokeColor.from,
      from = _strokeColor$from === void 0 ? '#1890ff' : _strokeColor$from,
      _strokeColor$to = strokeColor.to,
      to = _strokeColor$to === void 0 ? '#1890ff' : _strokeColor$to,
      _strokeColor$directio = strokeColor.direction,
      direction = _strokeColor$directio === void 0 ? 'to right' : _strokeColor$directio,
      rest = __rest(strokeColor, ["from", "to", "direction"]);

  if (Object.keys(rest).length !== 0) {
    var sortedGradients = sortGradient(rest);
    return {
      backgroundImage: "linear-gradient(".concat(direction, ", ").concat(sortedGradients, ")")
    };
  }

  return {
    backgroundImage: "linear-gradient(".concat(direction, ", ").concat(from, ", ").concat(to, ")")
  };
};

exports.handleGradient = handleGradient;

var Line = function Line(props) {
  var prefixCls = props.prefixCls,
      percent = props.percent,
      successPercent = props.successPercent,
      strokeWidth = props.strokeWidth,
      size = props.size,
      strokeColor = props.strokeColor,
      strokeLinecap = props.strokeLinecap,
      children = props.children;
  var backgroundProps;

  if (strokeColor && typeof strokeColor !== 'string') {
    backgroundProps = handleGradient(strokeColor);
  } else {
    backgroundProps = {
      background: strokeColor
    };
  }

  var percentStyle = _extends({
    width: "".concat((0, _utils.validProgress)(percent), "%"),
    height: strokeWidth || (size === 'small' ? 6 : 8),
    borderRadius: strokeLinecap === 'square' ? 0 : ''
  }, backgroundProps);

  var successPercentStyle = {
    width: "".concat((0, _utils.validProgress)(successPercent), "%"),
    height: strokeWidth || (size === 'small' ? 6 : 8),
    borderRadius: strokeLinecap === 'square' ? 0 : ''
  };
  var successSegment = successPercent !== undefined ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-success-bg"),
    style: successPercentStyle
  }) : null;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-outer")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-inner")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-bg"),
    style: percentStyle
  }), successSegment)), children);
};

var _default = Line;
exports["default"] = _default;

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcProgress = __webpack_require__(1467);

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _utils = __webpack_require__(401);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var statusColorMap = {
  normal: '#108ee9',
  exception: '#ff5500',
  success: '#87d068'
};

function getPercentage(_ref) {
  var percent = _ref.percent,
      successPercent = _ref.successPercent;
  var ptg = (0, _utils.validProgress)(percent);

  if (!successPercent) {
    return ptg;
  }

  var successPtg = (0, _utils.validProgress)(successPercent);
  return [successPercent, (0, _utils.validProgress)(ptg - successPtg)];
}

function getStrokeColor(_ref2) {
  var progressStatus = _ref2.progressStatus,
      successPercent = _ref2.successPercent,
      strokeColor = _ref2.strokeColor;
  var color = strokeColor || statusColorMap[progressStatus];

  if (!successPercent) {
    return color;
  }

  return [statusColorMap.success, color];
}

var Circle = function Circle(props) {
  var prefixCls = props.prefixCls,
      width = props.width,
      strokeWidth = props.strokeWidth,
      trailColor = props.trailColor,
      strokeLinecap = props.strokeLinecap,
      gapPosition = props.gapPosition,
      gapDegree = props.gapDegree,
      type = props.type,
      children = props.children;
  var circleSize = width || 120;
  var circleStyle = {
    width: circleSize,
    height: circleSize,
    fontSize: circleSize * 0.15 + 6
  };
  var circleWidth = strokeWidth || 6;
  var gapPos = gapPosition || type === 'dashboard' && 'bottom' || 'top';
  var gapDeg = gapDegree || (type === 'dashboard' ? 75 : undefined);
  var strokeColor = getStrokeColor(props);
  var isGradient = Object.prototype.toString.call(strokeColor) === '[object Object]';
  var wrapperClassName = (0, _classnames["default"])("".concat(prefixCls, "-inner"), _defineProperty({}, "".concat(prefixCls, "-circle-gradient"), isGradient));
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName,
    style: circleStyle
  }, /*#__PURE__*/React.createElement(_rcProgress.Circle, {
    percent: getPercentage(props),
    strokeWidth: circleWidth,
    trailWidth: circleWidth,
    strokeColor: strokeColor,
    strokeLinecap: strokeLinecap,
    trailColor: trailColor,
    prefixCls: prefixCls,
    gapDegree: gapDeg,
    gapPosition: gapPos
  }), children);
};

var _default = Circle;
exports["default"] = _default;

/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Line__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Circle__ = __webpack_require__(1469);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Line", function() { return __WEBPACK_IMPORTED_MODULE_0__Line__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Circle", function() { return __WEBPACK_IMPORTED_MODULE_1__Circle__["a"]; });



/* harmony default export */ __webpack_exports__["default"] = ({
  Line: __WEBPACK_IMPORTED_MODULE_0__Line__["a" /* default */],
  Circle: __WEBPACK_IMPORTED_MODULE_1__Circle__["a" /* default */]
});

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enhancer__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(604);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var Line = /*#__PURE__*/function (_Component) {
  _inherits(Line, _Component);

  var _super = _createSuper(Line);

  function Line() {
    var _this;

    _classCallCheck(this, Line);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "paths", {});

    return _this;
  }

  _createClass(Line, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          percent = _this$props.percent,
          prefixCls = _this$props.prefixCls,
          strokeColor = _this$props.strokeColor,
          strokeLinecap = _this$props.strokeLinecap,
          strokeWidth = _this$props.strokeWidth,
          style = _this$props.style,
          trailColor = _this$props.trailColor,
          trailWidth = _this$props.trailWidth,
          transition = _this$props.transition,
          restProps = _objectWithoutProperties(_this$props, ["className", "percent", "prefixCls", "strokeColor", "strokeLinecap", "strokeWidth", "style", "trailColor", "trailWidth", "transition"]);

      delete restProps.gapPosition;
      var percentList = Array.isArray(percent) ? percent : [percent];
      var strokeColorList = Array.isArray(strokeColor) ? strokeColor : [strokeColor];
      var center = strokeWidth / 2;
      var right = 100 - strokeWidth / 2;
      var pathString = "M ".concat(strokeLinecap === 'round' ? center : 0, ",").concat(center, "\n           L ").concat(strokeLinecap === 'round' ? right : 100, ",").concat(center);
      var viewBoxString = "0 0 100 ".concat(strokeWidth);
      var stackPtg = 0;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
        className: "".concat(prefixCls, "-line ").concat(className),
        viewBox: viewBoxString,
        preserveAspectRatio: "none",
        style: style
      }, restProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        className: "".concat(prefixCls, "-line-trail"),
        d: pathString,
        strokeLinecap: strokeLinecap,
        stroke: trailColor,
        strokeWidth: trailWidth || strokeWidth,
        fillOpacity: "0"
      }), percentList.map(function (ptg, index) {
        var pathStyle = {
          strokeDasharray: "".concat(ptg, "px, 100px"),
          strokeDashoffset: "-".concat(stackPtg, "px"),
          transition: transition || 'stroke-dashoffset 0.3s ease 0s, stroke-dasharray .3s ease 0s, stroke 0.3s linear'
        };
        var color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
        stackPtg += ptg;
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          key: index,
          className: "".concat(prefixCls, "-line-path"),
          d: pathString,
          strokeLinecap: strokeLinecap,
          stroke: color,
          strokeWidth: strokeWidth,
          fillOpacity: "0",
          ref: function ref(path) {
            _this2.paths[index] = path;
          },
          style: pathStyle
        });
      }));
    }
  }]);

  return Line;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Line.propTypes = __WEBPACK_IMPORTED_MODULE_2__types__["b" /* propTypes */];
Line.defaultProps = __WEBPACK_IMPORTED_MODULE_2__types__["a" /* defaultProps */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__enhancer__["a" /* default */])(Line));

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enhancer__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(604);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint react/prop-types: 0 */




var gradientSeed = 0;

function stripPercentToNumber(percent) {
  return +percent.replace('%', '');
}

function toArray(symArray) {
  return Array.isArray(symArray) ? symArray : [symArray];
}

function getPathStyles(offset, percent, strokeColor, strokeWidth) {
  var gapDegree = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var gapPosition = arguments.length > 5 ? arguments[5] : undefined;
  var radius = 50 - strokeWidth / 2;
  var beginPositionX = 0;
  var beginPositionY = -radius;
  var endPositionX = 0;
  var endPositionY = -2 * radius;

  switch (gapPosition) {
    case 'left':
      beginPositionX = -radius;
      beginPositionY = 0;
      endPositionX = 2 * radius;
      endPositionY = 0;
      break;

    case 'right':
      beginPositionX = radius;
      beginPositionY = 0;
      endPositionX = -2 * radius;
      endPositionY = 0;
      break;

    case 'bottom':
      beginPositionY = radius;
      endPositionY = 2 * radius;
      break;

    default:
  }

  var pathString = "M 50,50 m ".concat(beginPositionX, ",").concat(beginPositionY, "\n   a ").concat(radius, ",").concat(radius, " 0 1 1 ").concat(endPositionX, ",").concat(-endPositionY, "\n   a ").concat(radius, ",").concat(radius, " 0 1 1 ").concat(-endPositionX, ",").concat(endPositionY);
  var len = Math.PI * 2 * radius;
  var pathStyle = {
    stroke: strokeColor,
    strokeDasharray: "".concat(percent / 100 * (len - gapDegree), "px ").concat(len, "px"),
    strokeDashoffset: "-".concat(gapDegree / 2 + offset / 100 * (len - gapDegree), "px"),
    transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s' // eslint-disable-line

  };
  return {
    pathString: pathString,
    pathStyle: pathStyle
  };
}

var Circle = /*#__PURE__*/function (_Component) {
  _inherits(Circle, _Component);

  var _super = _createSuper(Circle);

  function Circle() {
    var _this;

    _classCallCheck(this, Circle);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "paths", {});

    _defineProperty(_assertThisInitialized(_this), "gradientId", 0);

    _this.gradientId = gradientSeed;
    gradientSeed += 1;
    return _this;
  }

  _createClass(Circle, [{
    key: "getStokeList",
    value: function getStokeList() {
      var _this2 = this;

      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          percent = _this$props.percent,
          strokeColor = _this$props.strokeColor,
          strokeWidth = _this$props.strokeWidth,
          strokeLinecap = _this$props.strokeLinecap,
          gapDegree = _this$props.gapDegree,
          gapPosition = _this$props.gapPosition;
      var percentList = toArray(percent);
      var strokeColorList = toArray(strokeColor);
      var stackPtg = 0;
      return percentList.map(function (ptg, index) {
        var color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
        var stroke = Object.prototype.toString.call(color) === '[object Object]' ? "url(#".concat(prefixCls, "-gradient-").concat(_this2.gradientId, ")") : '';

        var _getPathStyles = getPathStyles(stackPtg, ptg, color, strokeWidth, gapDegree, gapPosition),
            pathString = _getPathStyles.pathString,
            pathStyle = _getPathStyles.pathStyle;

        stackPtg += ptg;
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          key: index,
          className: "".concat(prefixCls, "-circle-path"),
          d: pathString,
          stroke: stroke,
          strokeLinecap: strokeLinecap,
          strokeWidth: strokeWidth,
          opacity: ptg === 0 ? 0 : 1,
          fillOpacity: "0",
          style: pathStyle,
          ref: function ref(path) {
            _this2.paths[index] = path;
          }
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          strokeWidth = _this$props2.strokeWidth,
          trailWidth = _this$props2.trailWidth,
          gapDegree = _this$props2.gapDegree,
          gapPosition = _this$props2.gapPosition,
          trailColor = _this$props2.trailColor,
          strokeLinecap = _this$props2.strokeLinecap,
          style = _this$props2.style,
          className = _this$props2.className,
          strokeColor = _this$props2.strokeColor,
          restProps = _objectWithoutProperties(_this$props2, ["prefixCls", "strokeWidth", "trailWidth", "gapDegree", "gapPosition", "trailColor", "strokeLinecap", "style", "className", "strokeColor"]);

      var _getPathStyles2 = getPathStyles(0, 100, trailColor, strokeWidth, gapDegree, gapPosition),
          pathString = _getPathStyles2.pathString,
          pathStyle = _getPathStyles2.pathStyle;

      delete restProps.percent;
      var strokeColorList = toArray(strokeColor);
      var gradient = strokeColorList.find(function (color) {
        return Object.prototype.toString.call(color) === '[object Object]';
      });
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
        className: "".concat(prefixCls, "-circle ").concat(className),
        viewBox: "0 0 100 100",
        style: style
      }, restProps), gradient && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("linearGradient", {
        id: "".concat(prefixCls, "-gradient-").concat(this.gradientId),
        x1: "100%",
        y1: "0%",
        x2: "0%",
        y2: "0%"
      }, Object.keys(gradient).sort(function (a, b) {
        return stripPercentToNumber(a) - stripPercentToNumber(b);
      }).map(function (key, index) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop", {
          key: index,
          offset: key,
          stopColor: gradient[key]
        });
      }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        className: "".concat(prefixCls, "-circle-trail"),
        d: pathString,
        stroke: trailColor,
        strokeLinecap: strokeLinecap,
        strokeWidth: trailWidth || strokeWidth,
        fillOpacity: "0",
        style: pathStyle
      }), this.getStokeList().reverse());
    }
  }]);

  return Circle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Circle.propTypes = _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_3__types__["b" /* propTypes */]), {}, {
  gapPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['top', 'bottom', 'left', 'right'])
});
Circle.defaultProps = _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_3__types__["a" /* defaultProps */]), {}, {
  gapPosition: 'top'
});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__enhancer__["a" /* default */])(Circle));

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _Upload = _interopRequireDefault(__webpack_require__(589));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

// stick class comoponent to avoid React ref warning inside Form
// https://github.com/ant-design/ant-design/issues/18707
// eslint-disable-next-line react/prefer-stateless-function
var Dragger = /*#__PURE__*/function (_React$Component) {
  _inherits(Dragger, _React$Component);

  var _super = _createSuper(Dragger);

  function Dragger() {
    _classCallCheck(this, Dragger);

    return _super.apply(this, arguments);
  }

  _createClass(Dragger, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          style = _a.style,
          height = _a.height,
          restProps = __rest(_a, ["style", "height"]);

      return /*#__PURE__*/React.createElement(_Upload["default"], _extends({}, restProps, {
        type: "drag",
        style: _extends(_extends({}, style), {
          height: height
        })
      }));
    }
  }]);

  return Dragger;
}(React.Component);

exports["default"] = Dragger;

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.defaultData=exports.columns=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var columns=exports.columns=[{title:"序号",dataIndex:"index",key:"index"},{title:"酒店名称",dataIndex:"hotel_name",key:"hotel_name"},{title:"姓名",dataIndex:"name",key:"name"},{title:"职位",dataIndex:"position",key:"position"},{title:"合同起始时间",dataIndex:"start_time",key:"start_time"},{title:"合同截止时间",dataIndex:"end_time",key:"end_time",render:function render(text,record,i){if((0,_moment2.default)(text).isBefore((0,_moment2.default)().add(3,"M")))return _react2.default.createElement("span",{style:{color:"red"}},text);return text;}},{title:"试用到期时间",dataIndex:"trial",key:"trial",render:function render(text,record,i){if((0,_moment2.default)(text).isBefore((0,_moment2.default)().add(3,"M")))return _react2.default.createElement("span",{style:{color:"red"}},text);return text;}},{title:"是否开启提醒",dataIndex:"is_remind",key:"is_remind",render:function render(text,record,i){return _react2.default.createElement("span",{style:{color:record.is_remind==1?"#4C9BF2":""}},record.is_remind==1?"提醒":"不提醒");}},{title:"备注",dataIndex:"note",key:"note",render:function render(text){return _react2.default.createElement("span",{className:"note"},text||"");}}];var defaultData=exports.defaultData={hotel_name:"",name:"",position:"",start_time:"",end_time:"",trial:"",note:"",file:"",email:[]};

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _popconfirm=__webpack_require__(110);var _popconfirm2=_interopRequireDefault(_popconfirm);var _icon=__webpack_require__(38);var _icon2=_interopRequireDefault(_icon);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(111);__webpack_require__(75);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(1476);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _Title=__webpack_require__(1477);var _Title2=_interopRequireDefault(_Title);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var defaultTitle={taker:"",att1:"",att:"",office1:"",office:"",venue:"",date:(0,_moment2.default)().format('YYYY-MM-DD HH:mm:ss')};var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(data){return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({data:data});case 1:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.onChange=function(name,value,i){// 简单粗暴的深拷贝
var data=JSON.parse(JSON.stringify(_this.state.data));data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(date){var dataBegin,data;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dataBegin=JSON.stringify(_data.dataDefault);data=JSON.parse(dataBegin);fetch('/meetingMinutesInfo?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('MM'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data&&x.data.data.length>0){data=x.data.data.sort(function(a,b){return(0,_method.numConvert)(a.sort)-(0,_method.numConvert)(b.sort);});}_this.setState({loading:false,title:_extends({},defaultTitle,x.data.title)},function(){_this.computeNum(data);});}).catch(function(err){_this.setState({loading:false});console.error(err);});case 3:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref2.apply(this,arguments);};}();_this.onSave=function(){_this.setState({loadingSave:true});var _this$state=_this.state,date=_this$state.date,title=_this$state.title;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("MM");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));dataFrom.append('title',JSON.stringify(_extends({},title,{year:year,month:month})));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/meetingMinutesSave',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(data.some(function(item){return!item.id;})){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table3_3_4',1.5,'4.14',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.addRow=function(record,index){var data=_this.state.data;_this.setState({data:[],loading:true},function(){var obj={sort:index,issues:"",plan:"",by:""};data.splice(index,0,obj);data=data.map(function(item,i){return _extends({},item,{sort:i});});_this.setState({data:data,loading:false});});};_this.onClose=function(index,record){var data=_this.state.data;if(record.id){fetch('/meetingMinutesDel?id='+record.id,{credentials:'include'}).then(function(x){return x.json();}).then(function(res){if(res.status==1){_message3.default.success(res.msg);data.splice(index,1);data=data.map(function(x,i){return _extends({},x,{sort:i});});_this.setState({data:[],loading:true},function(){_this.setState({data:data,loading:false});});}else{_message3.default.success(res.msg);}}).catch(function(err){console.error(err);_message3.default.success('删除失败！');});}else{data.splice(index,1);data=data.map(function(x,i){return _extends({},x,{sort:i});});_this.setState({data:[],loading:true},function(){_this.setState({data:data,loading:false});});}};_this.onExpoetExcel=function(){_this.setState({print:true,loading:true},function(){var name='\u4F1A\u8BAE\u8BB0\u5F55'+(0,_moment2.default)(_this.state.date).format('YYYY-MM');var innerHtml='\n              <caption>'+name+'</caption>\n              '+document.getElementById('table').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n            ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,name+'.xls');_this.setState({print:false,loading:false});});};_this.state={date:(0,_moment2.default)().format('YYYY-MM'),data:[],title:_extends({},defaultTitle),loading:true,loadingSave:false,print:false,update:false,hotelName:sessionStorage.getItem('hotelName')||""};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}// 点击增加行数
// 删除行
},{key:'render',value:function render(){var _this3=this;var _state=this.state,data=_state.data,title=_state.title,date=_state.date,hotelName=_state.hotelName;var len=data.length-1;var month=(0,_moment2.default)(date).format('M');var columns=[{title:'No.',dataIndex:'sort',key:'sort',align:"center",width:50,render:function render(text,record,index){text++;var props={text:text,index:index,type:'text',name:"no",onChange:_this3.onChange,totalIndex:[len]};if(index==len){return _react2.default.createElement(_icon2.default,{type:'plus-circle',style:{color:"#1890ff",cursor:"pointer"},onClick:_this3.addRow.bind(_this3,record,index)});}if(index>4&&index<len){return record.id?_react2.default.createElement(_popconfirm2.default,{title:'\u786E\u5B9A\u5220\u9664?\u4E00\u65E6\u5220\u9664\u6570\u636E\u5C06\u4E0D\u53EF\u6062\u590D!',onConfirm:_this3.onClose.bind(_this3,index,record),onCancel:function onCancel(){},okText:'\u786E\u5B9A',cancelText:'\u53D6\u6D88'},_react2.default.createElement(_icon2.default,{type:'minus-circle',style:{color:"red",cursor:"pointer"}})):_react2.default.createElement(_icon2.default,{type:'minus-circle',style:{color:"red",cursor:"pointer"},onClick:_this3.onClose.bind(_this3,index,record)});}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"Issues",dataIndex:'issues',key:'issues',align:"center",width:300,render:function render(text,record,index){var title=['Issues'];var props={text:text,index:index,type:index<len?'textArea':'text',name:"issues",onChange:_this3.onChange,totalIndex:[len],compared:{title:title,record:record,sqlName:"meetingMinutes"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"Action Plan",dataIndex:'plan',key:'plan',align:"center",width:300,render:function render(text,record,index){var title=['Action Plan'];var props={text:text,index:index,type:index<len?'textArea':'text',name:"plan",onChange:_this3.onChange,totalIndex:[len],compared:{title:title,record:record,sqlName:"meetingMinutes"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"Followed by",dataIndex:'by',key:'by',align:"center",width:150,render:function render(text,record,index){var title=['Followed by'];var props={text:text,index:index,type:index<len?'textArea':'text',name:"by",onChange:_this3.onChange,totalIndex:[len],compared:{title:title,record:record,sqlName:"meetingMinutes"}};return _react2.default.createElement(_TableText2.default,{data:props});}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table',style:{width:1200}},_react2.default.createElement(_row2.default,{className:'title',id:'table3_3_4'},_react2.default.createElement(_row2.default,null,'P&L Review for \uFF08',month,'\uFF09\u2013\uFF08',hotelName.replace(/[^a-zA-Z]/g,''),'\uFF09Meeting Minutes \u4F1A\u8BAE\u8BB0\u5F55-\uFF08',hotelName.replace(/[^\u4E00-\u9FA5]/g,''),'\uFF09\uFF08',month,'\uFF09\u7ECF\u8425\u8BC4\u4F30\u4F1A\u8BAE'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}})),_react2.default.createElement(_Title2.default,{data:title,onChange:function onChange(name,value){return _this3.setState({title:_extends({},title,_defineProperty({},name,value))});}}),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'table',pagination:false,className:'content',scroll:this.state.print?{}:{y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this3.setState({print:true},function(){_this3.onExpoetExcel();});}},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_meetingMinutes'},_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var dataDefault=exports.dataDefault=[{sort:0,issues:"",plan:"",by:""},{sort:1,issues:"",plan:"",by:""},{sort:2,issues:"",plan:"",by:""},{sort:3,issues:"",plan:"",by:""},{sort:4,issues:"",plan:"",by:""},{sort:5,issues:"",plan:"",by:""}];

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(25);__webpack_require__(4);__webpack_require__(14);__webpack_require__(60);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1478);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Title=function(_Component){_inherits(Title,_Component);function Title(){_classCallCheck(this,Title);return _possibleConstructorReturn(this,(Title.__proto__||Object.getPrototypeOf(Title)).apply(this,arguments));}_createClass(Title,[{key:"render",value:function render(){var _props$data=this.props.data,taker=_props$data.taker,att1=_props$data.att1,att=_props$data.att,office1=_props$data.office1,office=_props$data.office,venue=_props$data.venue,date=_props$data.date;var _onChange=this.props.onChange;return _react2.default.createElement("div",{className:"metting-table1-title"},_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:6},"Date:Time"),_react2.default.createElement(_col2.default,{span:18},_react2.default.createElement(_datePicker2.default,{showTime:true,value:date?(0,_moment2.default)(date):null,onChange:function onChange(_,str){return _onChange('date',str);},locale:'zh-cn'}))),_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:6},"Venue:"),_react2.default.createElement(_col2.default,{span:18},_react2.default.createElement(_input2.default,{type:"text",className:"input",value:venue,onChange:function onChange(e){_onChange('venue',e.target.value);}}))),_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:6},"Corporate Office Attendees:"),_react2.default.createElement(_col2.default,{span:9},_react2.default.createElement(_input2.default,{type:"text",className:"input",value:office,onChange:function onChange(e){_onChange('office',e.target.value);}})),_react2.default.createElement(_col2.default,{span:9},_react2.default.createElement(_input2.default,{type:"text",className:"input",value:office1,onChange:function onChange(e){_onChange('office1',e.target.value);}}))),_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:6},"Hotel Attendees:"),_react2.default.createElement(_col2.default,{span:9},_react2.default.createElement(_input2.default,{type:"text",className:"input",value:att,onChange:function onChange(e){_onChange('att',e.target.value);}})),_react2.default.createElement(_col2.default,{span:9},_react2.default.createElement(_input2.default,{type:"text",className:"input",value:att1,onChange:function onChange(e){_onChange('att1',e.target.value);}}))),_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:6},"Minutes Taker:"),_react2.default.createElement(_col2.default,{span:18},_react2.default.createElement(_input2.default,{type:"text",className:"input",value:taker,onChange:function onChange(e){_onChange('taker',e.target.value);}}))));}}]);return Title;}(_react.Component);exports.default=Title;

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _=__webpack_require__(1480);var _2=_interopRequireDefault(_);var _KeyPerformanceIndicator=__webpack_require__(1483);var _KeyPerformanceIndicator2=_interopRequireDefault(_KeyPerformanceIndicator);var _imgtopdf=__webpack_require__(128);var _imgtopdf2=_interopRequireDefault(_imgtopdf);var _jspdf=__webpack_require__(183);var _jspdf2=_interopRequireDefault(_jspdf);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.downloadSG=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({print:true},function(){var arr=[{id:'table1_1',multiple:1.5},{id:'table1_3',multiple:1.5}];(0,_imgtopdf2.default)('table1_3',1.8).then(function(x){var dataFrom=new FormData();dataFrom.append('img',x.img);dataFrom.append('sort','1.3');dataFrom.append('height',x.canvas.height);dataFrom.append('width',x.canvas.width);dataFrom.append('year','2018');dataFrom.append('month','6');var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/addPdf',headres).then(function(x){return x.json();}).then(function(x){console.log(x);}).catch(function(err){console.error(err);});_this.setState({print:false});}).catch(function(err){console.log(err);});});case 1:case"end":return _context.stop();}}},_callee,_this2);}));_this.state={print:false};return _this;}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",null,_react2.default.createElement(_row2.default,{style:{margin:"24px 0 24px 24px",fontSize:22,color:"#333"}},"1.0 KPI - Key Performance Indicator \u5173\u952E\u7EE9\u6548\u6307\u6570"),_react2.default.createElement(_KeyPerformanceIndicator2.default,this.props),_react2.default.createElement(_2.default,this.props));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _alert=__webpack_require__(83);var _alert2=_interopRequireDefault(_alert);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(84);__webpack_require__(8);__webpack_require__(6);__webpack_require__(4);__webpack_require__(10);__webpack_require__(25);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(1481);var _data=__webpack_require__(606);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _IsLableAuth=__webpack_require__(107);var _IsLableAuth2=_interopRequireDefault(_IsLableAuth);var _compute=__webpack_require__(1482);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TextArea=_input2.default.TextArea;var index=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false},_this.getTable1_3=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var dataDefault,data,d,data1,d2,x;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;dataDefault=JSON.stringify(_data.data1_3_default);data=JSON.parse(dataDefault);_context.next=5;return fetch('/kpiInfo?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'});case 5:d=_context.sent;_context.next=8;return d.json();case 8:data1=_context.sent;_context.next=11;return fetch('/_1_3_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'});case 11:d2=_context.sent;_context.next=14;return d2.json();case 14:x=_context.sent;if(x.data&&x.data.length>0){data=x.data;}if(data1.data&&data1.data.length>0){data=(0,_compute.fillData)(data,data1.data);}_this.setState({data:data,loading:false});_context.next=24;break;case 20:_context.prev=20;_context.t0=_context['catch'](0);console.error(_context.t0);_this.setState({loading:false});case 24:case'end':return _context.stop();}}},_callee,_this2,[[0,20]]);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.setState({data:data});},_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));// console.log(data);return;
var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_1_3',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getTable1_3(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});},_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table1_3',1.5,'1.20',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getTable1_3(this.state.date);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.print!=this.state.print){this.setState({print:nextProps.print});}}// 获取表格1_3的内容
},{key:'render',value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,loading=_state.loading;var width=document.body.offsetWidth/5>=400?document.body.offsetWidth/5:400;var columns=[{title:_react2.default.createElement('div',null,'KPI Standard Range',_react2.default.createElement('br',null),'\u5173\u952E\u7EE9\u6548\u6307\u6570\u6807\u51C6\u8303\u56F4'),dataIndex:'name',key:'name',fixed:"left",width:480,render:function render(text,record,index){if(index==data.length-1){return{children:null,props:{colSpan:0}};}return _react2.default.createElement('div',{dangerouslySetInnerHTML:{__html:text},style:{padding:10,textAlign:"left"}});}},{title:_react2.default.createElement('div',null,'MTD',_react2.default.createElement('br',null),'\u6708\u7D2F\u8BA1'),width:600,children:[{title:_react2.default.createElement('div',null,'MTD This Year: Please Critique Actual vs. Forecast (Forecast Accuracy Evaluation)',_react2.default.createElement('br',null),'\u672C\u5E74\u5F53\u6708: \u8BF7\u89E3\u91CA\u5B9E\u9645\u548C\u9884\u6D4B\u5DEE\u5F02\u6570\u8D85\u51FA\u6807\u51C6\u8303\u56F4\u7684\u539F\u56E0 (\u9884\u6D4B\u7CBE\u51C6\u6027\u8861\u91CF\uFF09'),align:"center",width:600,children:[{title:'百分比',width:100,dataIndex:'mtd_percent',key:'',align:"center",render:function render(text,record,index){if(index==data.length-1){return{children:null,props:{colSpan:0}};}var html=null;html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');return _react2.default.createElement('div',null,html);}},{title:'备注',width:500,dataIndex:'mtd_note',key:'',align:"center",render:function render(text,record,index){if(index==data.length-1){return{children:null,props:{colSpan:0}};}return _react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(TextArea,{className:'input-width',autosize:{minRows:2,maxRows:8},defaultValue:text,onBlur:function onBlur(e){var value=e.target.value;_this3.onChange('mtd_note',value,index);}}));}}]}]},{title:_react2.default.createElement('div',null,'YTD',_react2.default.createElement('br',null),'\u5E74\u7D2F\u8BA1'),width:width,children:[{title:_react2.default.createElement('div',null,'YTD: Please Critique Actual vs. Last Year',_react2.default.createElement('br',null),' \u5E74\u7D2F\u8BA1: \u8BF7\u89E3\u91CA\u5B9E\u9645\u548C\u53BB\u5E74\u5DEE\u5F02\u6570\u8D85\u51FA\u6807\u51C6\u8303\u56F4\u7684\u539F\u56E0'),align:"center",children:[{title:'百分比',width:100,dataIndex:'ytd_percent',key:'',align:"center",render:function render(text,record,index){if(index==data.length-1){return{children:null,props:{colSpan:0}};}var html=null;html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');return _react2.default.createElement('div',null,html);}},{title:'备注',dataIndex:'ytd_note',key:'ytd_note',width:500,align:"center",render:function render(text,record,index){if(index==data.length-1){return{children:null,props:{colSpan:0}};}return _react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(TextArea,{className:'input-width',autosize:{minRows:2,maxRows:8},defaultValue:text,onBlur:function onBlur(e){var value=e.target.value;_this3.onChange('ytd_note',value,index);}}));}}]}]},{title:_react2.default.createElement('div',null,'3-Month-Rolling Forecast',_react2.default.createElement('br',null),'\u540E\u4E09\u4E2A\u6708\u6EDA\u52A8\u9884\u6D4B'),width:width,children:[{title:_react2.default.createElement('div',null,'3-Month-Rolling Forecast : Please Critique Forecast vs. Last Year',_react2.default.createElement('br',null),'\u540E\u4E09\u4E2A\u6708\u6EDA\u52A8\u9884\u6D4B: \u8BF7\u89E3\u91CA\u9884\u6D4B\u548C\u53BB\u5E74\u5B9E\u9645\u5DEE\u5F02\u6570\u8D85\u51FA\u6807\u51C6\u8303\u56F4\u7684\u539F\u56E0'),align:"center",children:[{title:'百分比',width:100,dataIndex:'threemonth_percent',key:'threemonth_percent',align:"center",render:function render(text,record,index){if(index==data.length-1){return{children:null,props:{colSpan:0}};}var html=null;html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');return _react2.default.createElement('div',null,html);}},{title:'备注',dataIndex:'threemonth_note',key:'threemonth_note',width:500,align:"center",render:function render(text,record,index){if(index==data.length-1){return{children:null,props:{colSpan:0}};}return _react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(TextArea,{className:'input-width',autosize:{minRows:2,maxRows:8},defaultValue:text,onBlur:function onBlur(e){var value=e.target.value;_this3.onChange('threemonth_note',value,index);}}));}}]}]},{title:_react2.default.createElement('div',null,'Whole Year Forecast Total',_react2.default.createElement('br',null),'\u6574\u5E74\u9884\u6D4B'),width:width,children:[{title:_react2.default.createElement('div',null,'Whole Year Forecast vs. Budget ',_react2.default.createElement('br',null),'\u6574\u5E74\u9884\u6D4B\u5BF9\u6BD4\u9884\u7B97'),align:"center",children:[{title:'百分比',width:100,dataIndex:'wholeyear_budget_percent',key:'',align:"center",render:function render(text,record,index){if(index==data.length-1){return{children:null,props:{colSpan:0}};}var html=null;html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');return _react2.default.createElement('div',null,html);}},{title:'备注',dataIndex:'wholeyear_budget_note',key:'wholeyear_budget_note',width:500,align:"center",render:function render(text,record,index){if(index==data.length-1){return{children:null,props:{colSpan:0}};}return _react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(TextArea,{className:'input-width',autosize:{minRows:2,maxRows:8},defaultValue:text,onBlur:function onBlur(e){var value=e.target.value;_this3.onChange('wholeyear_budget_note',value,index);}}));}}]},{title:_react2.default.createElement('div',null,'Whole Year Forecast vs. Last Year ',_react2.default.createElement('br',null),'\u6574\u5E74\u9884\u6D4B\u5BF9\u6BD4\u53BB\u5E74'),align:"center",children:[{title:'百分比',width:100,dataIndex:'wholeyear_lastyear_percent',key:'wholeyear_lastyear_percent',align:"center",render:function render(text,record,index){if(index==data.length-1){return{children:null,props:{colSpan:0}};}var html=null;html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');return _react2.default.createElement('div',null,html);}},{title:'备注',dataIndex:'wholeyear_lastyear_note',key:'wholeyear_lastyear_note',align:"center",width:500,render:function render(text,record,index){if(index==data.length-1){return{children:null,props:{colSpan:0}};}return _react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(TextArea,{className:'input-width',autosize:{minRows:2,maxRows:8},defaultValue:text,onBlur:function onBlur(e){var value=e.target.value;_this3.onChange('wholeyear_lastyear_note',value,index);}}));}}]}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1 FlowThruAnaltsis table1_3',style:{marginTop:50}},_react2.default.createElement(_row2.default,{className:'title',id:'table1_3',style:{width:this.state.print?3520:'auto'}},_react2.default.createElement(_row2.default,null,'1.2 KPI Standard Range and Critique \u5173\u952E\u7EE9\u6548\u6307\u6570\u6807\u51C6\u8303\u56F4\u53CA\u8D85\u51FA\u6807\u51C6\u8303\u56F4\u7684\u89E3\u91CA'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getTable1_3(str);}}),_react2.default.createElement(_Auth2.default,{isAdmin:true},_react2.default.createElement(_button2.default,{type:'primary',loading:loading,style:{marginLeft:10,display:this.state.print?'none':''},onClick:function onClick(){_this3.setState({loading:true},_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return(0,_compute.saveAllData)(date);case 2:_this3.setState({loading:false});case 3:case'end':return _context2.stop();}}},_callee2,_this3);})));}},'\u4FDD\u5B58\u6240\u6709\u9152\u5E97\u6570\u636E'))),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,style:{width:this.state.print?3470:'auto'},scroll:this.state.print?{}:{x:3470,y:550},pagination:false,className:'content',rowKey:function rowKey(record,index){return record.id||record.name;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn',style:{marginBottom:20}},_react2.default.createElement(_alert2.default,{message:_react2.default.createElement('div',null,'\u8868\u683C\u5173\u8054',_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:'read_1'},this.props,{path:'#table1_1'}),'1.1')),type:'info',showIcon:true,style:{display:"inline-block",marginRight:10}}),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_1'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.saveAllData=exports.fillData=undefined;var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};__webpack_require__(10);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _data2=__webpack_require__(606);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var fillData=exports.fillData=function fillData(data,data1){var index=[5,6,7,8,10,12,14,16,18,19,22];index.forEach(function(item,i){if(i>=4&&i<=8){data[i].mtd_percent=data1[item].actual;data[i].ytd_percent=data1[item].year_actual;data[i].threemonth_percent=data1[item].three_actual;data[i].wholeyear_budget_percent=data1[item].whole_actual_budget;data[i].wholeyear_lastyear_percent=data1[item].whole_actual_last_year;}else{data[i].mtd_percent=data1[item].actual_prediction;data[i].ytd_percent=data1[item].year_actual_last_year;data[i].threemonth_percent=data1[item].three_actual_last_year;data[i].wholeyear_budget_percent=data1[item].whole_actual_budget;data[i].wholeyear_lastyear_percent=data1[item].whole_actual_last_year;}});return data;};var saveAllData=exports.saveAllData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var _ref2,hotels,_loop,i;return _regenerator2.default.wrap(function _callee$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return(0,_request2.default)('/getHotels');case 2:_ref2=_context2.sent;hotels=_ref2.data.hotels;_loop=/*#__PURE__*/_regenerator2.default.mark(function _loop(i){var item,data,_ref3,x,year,month,_data,dataFrom,headres;return _regenerator2.default.wrap(function _loop$(_context){while(1){switch(_context.prev=_context.next){case 0:item=hotels[i];//  获取当前酒店数据 
data=_lodash2.default.cloneDeep(_data2.data1_3_default);_context.next=4;return(0,_request2.default)("/_1_3?year="+(0,_moment2.default)(date).format('YYYY')+"&month="+(0,_moment2.default)(date).format('M')+"&comid="+item.id);case 4:_ref3=_context.sent;x=_ref3.data;if(x.data&&x.data.length>0){data=x.data;}data=fillData(data,x.kpis);year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");_data=data.map(function(x){return _extends({},x,{year:year,month:month,comid:item.id});});dataFrom=new FormData();dataFrom.append('data',JSON.stringify(_data));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context.next=16;return(0,_request2.default)('/add_1_3',headres);case 16:case"end":return _context.stop();}}},_loop,undefined);});i=0;case 6:if(!(i<hotels.length)){_context2.next=11;break;}return _context2.delegateYield(_loop(i),"t0",8);case 8:i++;_context2.next=6;break;case 11:_message3.default.success('保存成功！');case 12:case"end":return _context2.stop();}}},_callee,undefined);}));return function saveAllData(_x){return _ref.apply(this,arguments);};}();

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _alert=__webpack_require__(83);var _alert2=_interopRequireDefault(_alert);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(84);__webpack_require__(8);__webpack_require__(6);__webpack_require__(4);__webpack_require__(10);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(729);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data2=__webpack_require__(607);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _IsLableAuth=__webpack_require__(107);var _IsLableAuth2=_interopRequireDefault(_IsLableAuth);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _reactRouterDom=__webpack_require__(85);var _MonthPicker=__webpack_require__(402);var _MonthPicker2=_interopRequireDefault(_MonthPicker);var _compute=__webpack_require__(1484);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.handleWindowClose=function(ev){var confirmationMessage='数据还未保存,确定要离开吗?';(ev||window.event).returnValue=confirmationMessage;if(_this.state.isEdit){return confirmationMessage;}};_this.computeNum=function(data){var _data=(0,_compute.compute)(data);_this.setState({data:_data},function(){_this.onSave();});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);_this.setState({isEdit:true});};_this.getDateData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var dataBegin,data;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dataBegin=JSON.stringify(_data2.data1_1);data=JSON.parse(dataBegin);fetch('/kpiInfoAll?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.kpi&&x.data.kpi.length>0){data=x.data.kpi;}data=(0,_compute.fillData)(data,_extends({},x.data,{date:date}));_this.setState({loading:false},function(){_this.computeNum(data);});}).catch(function(err){_this.setState({loading:false});console.error(err);});case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/addKpiInfo',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false,isEdit:false});clearTimeout(timer);},1000);if(x.status!=1)_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table1_1',1.5,'1.10',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.onExpoetExcel=function(){_this.setState({print:true,loading:true},function(){var name='KPI - MTD/YTD/FST \u5173\u952E\u7EE9\u6548\u6307\u6570 - \u6708\u7D2F\u8BA1/\u5E74\u7D2F\u8BA1/\u9884\u6D4B'+(0,_moment2.default)(_this.state.date).format('YYYY-MM');var innerHtml='\n              <caption>'+name+'</caption>\n              '+document.getElementById('table').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n            ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,name+'.xls');_this.setState({print:false,loading:false});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:false,loadingSave:false,print:false,isEdit:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){//在关闭页面时弹出确认提示窗口
window.addEventListener('beforeunload',this.handleWindowClose);this.setState({loading:true});this.getDateData(this.state.date);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.print!=this.state.print){this.setState({print:nextProps.print});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.state.isEdit){window.οnbefοreunlοad=function(){return"数据还未保存,确定要离开吗?";};}console.log('卸载');window.removeEventListener('beforeunload',this.handleWindowClose);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,isEdit=_state.isEdit,data=_state.data,print=_state.print,date=_state.date,loading=_state.loading;var width=document.body.offsetWidth>3470?document.body.offsetWidth-3100:425;var inputIndex=[0,1,5,6,7,9,11,13,15,17,21,25,26,27,29,30,31,32];var percentData=[2,10,12,14,16,18,20,22,24];var totalData=[8,22,23,24,28];var columns=[{align:"center",title:_react2.default.createElement('div',null,'Key Performance Indicator ',_react2.default.createElement('br',null),' \u5173\u952E\u7EE9\u6548\u6307\u6570'),dataIndex:'name',key:'name',width:width,fixed:print?false:"left",render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"left"}},text);}},{title:'MTD 月累计',align:"center",width:1050,children:[{title:_react2.default.createElement('div',null,'Actual ',_react2.default.createElement('br',null),' \u5B9E\u9645'),dataIndex:'actual',key:'actual',align:"center",width:150,render:function render(text,record,index){if(index==24)return'';var title=['MTD \u6708\u7D2F\u8BA1-Actual \u5B9E\u9645'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,((Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Number(text||"0")*100).toFixed(2).toLocaleString())+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString())+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'actual',title:title,sqlName:"kpis",name:record.name,type:percentData.includes(index)?'percent':"number"}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}},{title:_react2.default.createElement('div',null,'Forecast ',_react2.default.createElement('br',null),' \u9884\u6D4B'),dataIndex:'prediction',key:'prediction',align:"center",width:150,render:function render(text,record,index){if(index==24)return'';var title=['MTD \u6708\u7D2F\u8BA1-Forecast \u9884\u6D4B'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,((Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Number(text||"0")*100).toFixed(2).toLocaleString())+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(Number(text||"0")*100).toFixed(2)=="-0"?"0":Math.abs(Number(text||"0")*100).toFixed(2))+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'prediction',title:title,sqlName:"kpis",name:record.name,type:percentData.includes(index)?'percent':"number"}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}},{title:_react2.default.createElement('div',null,'Budget ',_react2.default.createElement('br',null),' \u9884\u7B97'),dataIndex:'budget',key:'budget',align:"center",width:150,render:function render(text,record,index){if(index==24)return'';var title=['MTD \u6708\u7D2F\u8BA1-Budget \u9884\u7B97'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,((Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Number(text||"0")*100).toFixed(2).toLocaleString())+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString())+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'budget',title:title,sqlName:"kpis",name:record.name,type:percentData.includes(index)?'percent':"number"}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}},{title:_react2.default.createElement('div',null,'Last Year ',_react2.default.createElement('br',null),' \u53BB\u5E74'),dataIndex:'last_year',key:'last_year',align:"center",width:150,render:function render(text,record,index){var title=['MTD \u6708\u7D2F\u8BA1-Last Year \u53BB\u5E74'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,((Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Number(text||"0")*100).toFixed(2).toLocaleString())+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString())+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'last_year',title:title,sqlName:"kpis",name:record.name,type:percentData.includes(index)?'percent':"number"}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}},{title:'% Change 变化百分比',align:"center",width:360,children:[{title:_react2.default.createElement('div',null,'Act vs. Fcst. ',_react2.default.createElement('br',null),' \u5B9E\u9645\u5BF9\u6BD4\u9884\u6D4B'),dataIndex:'actual_prediction',key:'actual_prediction',align:"center",width:120,render:function render(text,record,index){var title=['MTD \u6708\u7D2F\u8BA1-% Change \u53D8\u5316\u767E\u5206\u6BD4 ','Act vs. Fcst. 实际对比预测'];if(text<0){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'actual_prediction',title:title,sqlName:"kpis",name:record.name,type:"percent"}},_react2.default.createElement('div',{className:'table-color table-owe  '+(totalData.includes(index)?'table-color-footer':'')},'(',((Math.abs(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Math.abs(text||"0")*100).toFixed(2).toLocaleString())+'%',')'));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'actual_prediction',title:title,sqlName:"kpis",name:record.name,type:"percent"}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},((Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Number(text||"0")*100).toFixed(2).toLocaleString())+'%'));}},{title:_react2.default.createElement('div',null,'Act vs. Bgt. ',_react2.default.createElement('br',null),' \u5B9E\u9645\u5BF9\u6BD4\u9884\u7B97'),dataIndex:'actual_budget',key:'actual_budget',align:"center",width:120,render:function render(text,record,index){var title=['MTD \u6708\u7D2F\u8BA1-% Change \u53D8\u5316\u767E\u5206\u6BD4 ','Act vs. Bgt. 实际对比预算'];// const props = {
//     text, index, type: 'percent', name: "actual_budget", onChange: this.onChange, totalIndex: '',
//     compared: {
//         title,
//         record,
//         sqlName: "hr_4_1_3"
//     }
// };
if(text<0){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'actual_budget',title:title,sqlName:"kpis",name:record.name,type:"percent"}},_react2.default.createElement('div',{className:'table-color table-owe  '+(totalData.includes(index)?'table-color-footer':'')},'(',((Math.abs(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Math.abs(text||"0")*100).toFixed(2).toLocaleString())+'%',')'));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'actual_budget',title:title,sqlName:"kpis",name:record.name,type:"percent"}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},((Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Number(text||"0")*100).toFixed(2).toLocaleString())+'%'));}},{title:_react2.default.createElement('div',null,'Act vs. LY ',_react2.default.createElement('br',null),' \u5B9E\u9645\u5BF9\u6BD4\u53BB\u5E74'),width:120,dataIndex:'actual_last_year',key:'actual_last_year',align:"center",render:function render(text,record,index){var title=['MTD \u6708\u7D2F\u8BA1-% Change \u53D8\u5316\u767E\u5206\u6BD4 ','Act vs. LY 实际对比去年'];if(text<0){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'actual_last_year',title:title,sqlName:"kpis",name:record.name,type:"percent"}},_react2.default.createElement('div',{className:'table-color table-owe  '+(totalData.includes(index)?'table-color-footer':'')},'(',((Math.abs(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Math.abs(text||"0")*100).toFixed(2).toLocaleString())+'%',')'));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'actual_last_year',title:title,sqlName:"kpis",name:record.name,type:"percent"}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},((Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Number(text||"0")*100).toFixed(2).toLocaleString())+'%'));}}]}]},{title:'YTD 年累计',align:"center",width:750,children:[{title:_react2.default.createElement('div',null,'Actual ',_react2.default.createElement('br',null),' \u5B9E\u9645'),dataIndex:'year_actual',key:'year_actual',align:"center",width:150,render:function render(text,record,index){if(index==24)return'';var title=['YTD 年累计-Actual 实际'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,((Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Number(text||"0")*100).toFixed(2).toLocaleString())+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString())+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_actual',title:title,sqlName:"kpis",name:record.name,type:percentData.includes(index)?"percent":'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}},{title:_react2.default.createElement('div',null,'Budget ',_react2.default.createElement('br',null),' \u9884\u7B97'),dataIndex:'year_budget',key:'year_budget',align:"center",width:150,render:function render(text,record,index){if(index==24)return'';var title=['YTD 年累计-Budget 预算'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(2)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString())+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_budget',title:title,sqlName:"kpis",name:record.name,type:percentData.includes(index)?"percent":'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}},{title:_react2.default.createElement('div',null,'Last Year ',_react2.default.createElement('br',null),' \u53BB\u5E74'),dataIndex:'year_last_year',key:'year_last_year',align:"center",width:150,render:function render(text,record,index){if(index==24)return'';var title=['YTD 年累计-Last Year 去年'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(2)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString())+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_last_year',title:title,sqlName:"kpis",name:record.name,type:percentData.includes(index)?"percent":'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}},{title:'% Change 变化百分比',align:"center",width:360,children:[{title:_react2.default.createElement('div',null,'Act vs. Bgt. ',_react2.default.createElement('br',null),' \u5B9E\u9645\u5BF9\u6BD4\u9884\u7B97'),dataIndex:'year_actual_budget',key:'year_actual_budget',align:"center",width:120,render:function render(text,record,index){var title=['YTD 年累计-% Change 变化百分比','Act vs. Bgt. Act vs. Bgt. 实际对比预算'];if(text<0){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_actual_budget',title:title,sqlName:"kpis",name:record.name,type:"percent"}},_react2.default.createElement('div',{className:'table-color table-owe  '+(totalData.includes(index)?'table-color-footer':'')},'(',((Math.abs(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Math.abs(text||"0")*100).toFixed(2).toLocaleString())+'%',')'));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_actual_budget',title:title,sqlName:"kpis",name:record.name,type:"percent"}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},((Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Number(text||"0")*100).toFixed(2).toLocaleString())+'%'));}},{title:_react2.default.createElement('div',null,'Act vs. LY ',_react2.default.createElement('br',null),' \u5B9E\u9645\u5BF9\u6BD4\u53BB\u5E74'),width:120,dataIndex:'year_actual_last_year',key:'year_actual_last_year',align:"center",render:function render(text,record,index){var title=['YTD 年累计-% Change 变化百分比','Act vs. LY 实际对比去年'];if(text<0){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_actual_last_year',title:title,sqlName:"kpis",name:record.name,type:"percent"}},_react2.default.createElement('div',{className:'table-color table-owe  '+(totalData.includes(index)?'table-color-footer':'')},'(',((Math.abs(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Math.abs(text||"0")*100).toFixed(2).toLocaleString())+'%',')'));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_actual_last_year',title:title,sqlName:"kpis",name:record.name,type:"percent"}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},((Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Number(text||"0")*100).toFixed(2).toLocaleString())+'%'));}}]}]},{title:'3-Month-Rolling Forecast 后三个月滚动预测',align:"center",width:750,children:[{title:_react2.default.createElement('div',null,'Forecast  ',_react2.default.createElement('br',null),' \u9884\u6D4B'),dataIndex:'three_actual',key:'three_actual',align:"center",width:150,render:function render(text,record,index){if(index==24)return'';var title=['3-Month-Rolling Forecast 后三个月滚动预测','Forecast 预测'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,((Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Number(text||"0")*100).toFixed(2).toLocaleString())+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString())+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'three_actual',title:title,sqlName:"kpis",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}},{title:_react2.default.createElement('div',null,'Budget ',_react2.default.createElement('br',null),' \u9884\u7B97'),dataIndex:'three_budget',key:'three_budget',align:"center",width:150,render:function render(text,record,index){if(index==24)return'';var title=['3-Month-Rolling Forecast 后三个月滚动预测','Budget 预算'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,((Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Number(text||"0")*100).toFixed(2).toLocaleString())+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString())+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'three_budget',title:title,sqlName:"kpis",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}},{title:_react2.default.createElement('div',null,'Last Year ',_react2.default.createElement('br',null),' \u53BB\u5E74'),dataIndex:'three_last_year',key:'three_last_year',width:150,align:"center",render:function render(text,record,index){if(index==24)return'';var title=['3-Month-Rolling Forecast 后三个月滚动预测','Last Year 去年'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(2)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString())+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'three_last_year',title:title,sqlName:"kpis",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}},{title:'% Change 变化百分比',align:"center",width:360,children:[{title:_react2.default.createElement('div',null,'Fcst vs. Bgt. ',_react2.default.createElement('br',null),' \u9884\u6D4B\u5BF9\u6BD4\u9884\u7B97'),dataIndex:'three_actual_budget',key:'three_actual_budget',align:"center",width:120,render:function render(text,record,index){var title=['3-Month-Rolling Forecast 后三个月滚动预测','% Change 变化百分比','Fcst vs. Bgt. 预测对比预算 '];if(text<0){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'three_actual_budget',title:title,sqlName:"kpis",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color table-owe  '+(totalData.includes(index)?'table-color-footer':'')},'(',((Math.abs(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Math.abs(text||"0")*100).toFixed(2).toLocaleString())+'%',')'));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'three_actual_budget',title:title,sqlName:"kpis",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},((Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Number(text||"0")*100).toFixed(2).toLocaleString())+'%'));}},{title:_react2.default.createElement('div',null,'Fcst vs. LY ',_react2.default.createElement('br',null),' \u9884\u6D4B\u5BF9\u6BD4\u53BB\u5E74'),width:120,dataIndex:'three_actual_last_year',key:'three_actual_last_year',align:"center",render:function render(text,record,index){var title=['3-Month-Rolling Forecast 后三个月滚动预测','% Change 变化百分比','Fcst vs. LY 预测对比去年 '];if(text<0){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'three_actual_last_year',title:title,sqlName:"kpis",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color table-owe  '+(totalData.includes(index)?'table-color-footer':'')},'(',((Math.abs(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Math.abs(text||"0")*100).toFixed(2).toLocaleString())+'%',')'));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'three_actual_last_year',title:title,sqlName:"kpis",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},((Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Number(text||"0")*100).toFixed(2).toLocaleString())+'%'));}}]}]},{title:'Whole Year Forecast Total 整年预测',align:"center",width:750,children:[{title:_react2.default.createElement('div',null,'Forecast  ',_react2.default.createElement('br',null),' \u9884\u6D4B'),dataIndex:'whole_actual',key:'whole_actual',align:"center",width:150,render:function render(text,record,index){if(index==24)return'';var title=['Whole Year Forecast Total 整年预测','Forecast 预测'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,((Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Number(text||"0")*100).toFixed(2).toLocaleString())+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString())+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'whole_actual',title:title,sqlName:"kpis",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}},{title:_react2.default.createElement('div',null,'Budget ',_react2.default.createElement('br',null),' \u9884\u7B97'),dataIndex:'whole_budget',key:'whole_budget',align:"center",width:150,render:function render(text,record,index){if(index==24)return'';var title=['Whole Year Forecast Total 整年预测','Budget 预算'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(2)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString())+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'whole_budget',title:title,sqlName:"kpis",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}},{title:_react2.default.createElement('div',null,'Last Year ',_react2.default.createElement('br',null),' \u53BB\u5E74'),dataIndex:'whole_last_year',key:'whole_last_year',align:"center",width:150,render:function render(text,record,index){if(index==24)return'';var title=['Whole Year Forecast Total 整年预测','Last Year 去年'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,((Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Number(text||"0")*100).toFixed(2).toLocaleString())+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":Math.abs(Number(text||"0")*100).toFixed(2).toLocaleString())+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'whole_last_year',title:title,sqlName:"kpis",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}},{title:'% Change 变化百分比',align:"center",width:360,children:[{title:_react2.default.createElement('div',null,'Fcst vs. Bgt. ',_react2.default.createElement('br',null),' \u9884\u6D4B\u5BF9\u6BD4\u9884\u7B97'),dataIndex:'whole_actual_budget',key:'whole_actual_budget',align:"center",width:120,render:function render(text,record,index){var title=['Whole Year Forecast Total 整年预测','% Change 变化百分比','Fcst vs. Bgt. 预测对比预算'];if(text<0){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'whole_actual_budget',title:title,sqlName:"kpis",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color table-owe  '+(totalData.includes(index)?'table-color-footer':'')},'(',((Math.abs(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Math.abs(text||"0")*100).toFixed(2).toLocaleString())+'%',')'));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'whole_actual_budget',title:title,sqlName:"kpis",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},((Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Number(text||"0")*100).toFixed(2).toLocaleString())+'%'));}},{title:_react2.default.createElement('div',null,'Fcst vs. LY ',_react2.default.createElement('br',null),' \u9884\u6D4B\u5BF9\u6BD4\u53BB\u5E74'),width:120,dataIndex:'whole_actual_last_year',key:'whole_actual_last_year',align:"center",render:function render(text,record,index){var title=['Whole Year Forecast Total 整年预测','% Change 变化百分比','Fcst vs. Bgt. 预测对比预算'];if(text<0){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'whole_actual_last_year',title:title,sqlName:"kpis",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color table-owe  '+(totalData.includes(index)?'table-color-footer':'')},'(',((Math.abs(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Math.abs(text||"0")*100).toFixed(2).toLocaleString())+'%',')'));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'whole_actual_last_year',title:title,sqlName:"kpis",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},((Number(text||"0")*100).toFixed(2).toLocaleString()=="-0"?"0":(Number(text||"0")*100).toFixed(2).toLocaleString())+'%'));}}]}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table'},_react2.default.createElement(_row2.default,{className:'title',id:'table1_1',style:{width:this.state.print?3520:'auto'}},_react2.default.createElement(_row2.default,null,'1.1 KPI - MTD/YTD/FST \u5173\u952E\u7EE9\u6548\u6307\u6570 - \u6708\u7D2F\u8BA1/\u5E74\u7D2F\u8BA1/\u9884\u6D4B'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(_MonthPicker2.default,{date:this.state.date,onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}}),_react2.default.createElement(_Auth2.default,{isAdmin:true},_react2.default.createElement(_button2.default,{type:'primary',loading:loading,style:{marginLeft:10,display:this.state.print?'none':''},onClick:function onClick(){_this3.setState({loading:true},_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return(0,_compute.saveAllData)(date);case 2:_this3.setState({loading:false});case 3:case'end':return _context2.stop();}}},_callee2,_this3);})));}},'\u4FDD\u5B58\u6240\u6709\u9152\u5E97\u6570\u636E'))),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',className:'content',id:'table',bordered:true,pagination:false,style:{width:this.state.print?3470:'auto'},scroll:this.state.print?{}:{x:3470,y:550},rowKey:function rowKey(record,index){return record.id||record.name;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_alert2.default,{message:_react2.default.createElement('div',null,'\u8868\u683C\u5173\u8054',_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:'read_2_1'},this.props,{path:'/table/2_1'}),'2.1'),' -',_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:'read_2_2'},this.props,{path:'/table/2_2'}),'2.2'),' -',_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:'read_2_3'},this.props,{path:'/table/2_3'}),'2.3')),type:'info',showIcon:true,style:{display:"inline-block",marginRight:10}}),_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this3.setState({print:true},function(){_this3.onExpoetExcel();});}},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_1'},_react2.default.createElement(_button2.default,{type:'primary'// style={{ marginRight: 10 }}
,onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf')))),isEdit&&_react2.default.createElement(_reactRouterDom.Prompt,{message:'\u6570\u636E\u8FD8\u672A\u4FDD\u5B58,\u786E\u5B9A\u8981\u79BB\u5F00\u5417?'}));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.saveAllData=exports.fillData=exports.compute=undefined;var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};__webpack_require__(10);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _method=__webpack_require__(20);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _data2=__webpack_require__(607);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var compute=exports.compute=function compute(data){// 计算平均房价 平均收入 客房收入    淡定
var roomRate=["actual","prediction","budget","last_year","year_actual","year_budget","year_last_year","three_actual","three_budget","three_last_year","whole_actual","whole_budget","whole_last_year"];for(var index=0;index<roomRate.length;index++){data[2][roomRate[index]]=Number(data[0][roomRate[index]]||"0")==0?0:(data[1][roomRate[index]]/Number(data[0][roomRate[index]]||"0")).toFixed(4);//计算客房率
data[3][roomRate[index]]=Number(data[1][roomRate[index]]||"0")==0?0:(data[5][roomRate[index]]/Number(data[1][roomRate[index]]||"0")).toFixed(2);//计算平均房价
data[4][roomRate[index]]=Number(data[0][roomRate[index]]||"0")==0?0:(data[5][roomRate[index]]/Number(data[0][roomRate[index]]||"0")).toFixed(2);//计算平均收入
data[8][roomRate[index]]=Number((Number(data[5][roomRate[index]]||"0")+Number(data[6][roomRate[index]]||"0")+Number(data[7][roomRate[index]]||"0")).toFixed(2));// 客房部门利润率
data[10][roomRate[index]]=Number(data[5][roomRate[index]]||"0")==0?0:(data[9][roomRate[index]]/Number(data[5][roomRate[index]]||"0")).toFixed(4);// 餐饮部门利润率
data[12][roomRate[index]]=Number(data[6][roomRate[index]]||"0")==0?0:(data[11][roomRate[index]]/Number(data[6][roomRate[index]]||"0")).toFixed(4);// 食品成本率
data[14][roomRate[index]]=Number(data[6][roomRate[index]]||"0")==0?0:(data[13][roomRate[index]]/Number(data[6][roomRate[index]]||"0")).toFixed(4);// 人力资源总费用率/人力成本率
data[16][roomRate[index]]=Number(data[8][roomRate[index]]||"0")==0?0:(data[15][roomRate[index]]/Number(data[8][roomRate[index]]||"0")).toFixed(4);// 盈亏平衡点/总费用
data[23][roomRate[index]]=(Number(data[8][roomRate[index]]||"0")-Number(data[21][roomRate[index]]||"0")).toFixed(2);// 能源成本率
data[18][roomRate[index]]=Number(data[8][roomRate[index]]||"0")==0?0:(data[17][roomRate[index]]/Number(data[8][roomRate[index]]||"0")).toFixed(4);// 其他费用及成本
data[19][roomRate[index]]=(Number(data[23][roomRate[index]]||"0")-Number(data[17][roomRate[index]]||"0")-Number(data[15][roomRate[index]]||"0")-Number(data[13][roomRate[index]]||"0")).toFixed(2);// 其他费用及成本率
data[20][roomRate[index]]=Number(data[8][roomRate[index]]||"0")==0?0:(data[19][roomRate[index]]/Number(data[8][roomRate[index]]||"0")).toFixed(4);//  经营毛利率
data[22][roomRate[index]]=Number(data[8][roomRate[index]]||"0")==0?0:(data[21][roomRate[index]]/Number(data[8][roomRate[index]]||"0")).toFixed(4);// 总收费
data[28][roomRate[index]]=Number((Number(data[27][roomRate[index]]||"0")+Number(data[26][roomRate[index]]||"0")+Number(data[25][roomRate[index]]||"0")).toFixed(2));}// 计算百分比
for(var _index=0;_index<data.length;_index++){if([2,10,12,14,16,18,20,22].includes(_index)){// 单独计算客房率  减法
data[_index].actual_prediction=Number(data[_index].prediction||"0")==0?0:(Number(data[_index].actual||"0")-Number(data[_index].prediction||"0")).toFixed(4);//实际对比预测计算
data[_index].actual_budget=Number(data[_index].budget||"0")==0?0:(Number(data[_index].actual||"0")-Number(data[_index].budget||"0")).toFixed(4);//实际对比预算
data[_index].actual_last_year=Number(data[_index].last_year||"0")==0?0:(Number(data[_index].actual||"0")-Number(data[_index].last_year||"0")).toFixed(4);//实际对比去年
data[_index].year_actual_budget=Number(data[_index].year_budget||"0")==0?0:(Number(data[_index].year_actual||"0")-Number(data[_index].year_budget||"0")).toFixed(4);//实际对比预算
data[_index].year_actual_last_year=Number(data[_index].year_last_year||"0")==0?0:(Number(data[_index].year_actual||"0")-Number(data[_index].year_last_year||"0")).toFixed(4);//实际对比去年
data[_index].three_actual_budget=Number(data[_index].three_budget||"0")==0?0:(Number(data[_index].three_actual||"0")-Number(data[_index].three_budget||"0")).toFixed(4);//实际对比预算
data[_index].three_actual_last_year=Number(data[_index].three_last_year||"0")==0?0:(Number(data[_index].three_actual||"0")-Number(data[_index].three_last_year||"0")).toFixed(4);//实际对比去年
data[_index].whole_actual_budget=Number(data[_index].whole_budget||"0")==0?0:(Number(data[_index].whole_actual||"0")-Number(data[_index].whole_budget||"0")).toFixed(4);//实际对比预算
data[_index].whole_actual_last_year=Number(data[_index].whole_last_year||"0")==0?0:(Number(data[_index].whole_actual||"0")-Number(data[_index].whole_last_year||"0")).toFixed(4);//实际对比去年
}else if(_index==24){// 边际盈利率
data[_index].actual_prediction=computeFlowThru(Number(data[8].actual||"0"),Number(data[8].prediction||"0"),Number(data[21].actual||"0"),Number(data[21].prediction||"0")).toFixed(4);data[_index].actual_budget=computeFlowThru(Number(data[8].actual||"0"),Number(data[8].budget||"0"),Number(data[21].actual||"0"),Number(data[21].budget||"0")).toFixed(4);data[_index].actual_last_year=computeFlowThru(Number(data[8].actual||"0"),Number(data[8].last_year||"0"),Number(data[21].actual||"0"),Number(data[21].last_year||"0")).toFixed(4);data[_index].year_actual_budget=computeFlowThru(Number(data[8].year_actual||"0"),Number(data[8].year_budget||"0"),Number(data[21].year_actual||"0"),Number(data[21].year_budget||"0")).toFixed(4);data[_index].year_actual_last_year=computeFlowThru(Number(data[8].year_actual||"0"),Number(data[8].year_last_year||"0"),Number(data[21].year_actual||"0"),Number(data[21].year_last_year||"0")).toFixed(4);data[_index].three_actual_budget=computeFlowThru(Number(data[8].three_actual||"0"),Number(data[8].three_budget||"0"),Number(data[21].three_actual||"0"),Number(data[21].three_budget||"0")).toFixed(4);data[_index].three_actual_last_year=computeFlowThru(Number(data[8].three_actual||"0"),Number(data[8].three_last_year||"0"),Number(data[21].three_actual||"0"),Number(data[21].three_last_year||"0")).toFixed(4);data[_index].whole_actual_budget=computeFlowThru(Number(data[8].whole_actual||"0"),Number(data[8].whole_budget||"0"),Number(data[21].whole_actual||"0"),Number(data[21].whole_budget||"0")).toFixed(4);data[_index].whole_actual_last_year=computeFlowThru(Number(data[8].whole_actual||"0"),Number(data[8].whole_last_year||"0"),Number(data[21].whole_actual||"0"),Number(data[21].whole_last_year||"0")).toFixed(4);}else{data[_index].actual_prediction=Number(data[_index].prediction||"0")==0?0:((data[_index].actual-Number(data[_index].prediction||"0"))/Number(data[_index].prediction||"0")).toFixed(4);//实际对比预测计算
data[_index].actual_budget=Number(data[_index].budget||"0")==0?0:((data[_index].actual-Number(data[_index].budget||"0"))/Number(data[_index].budget||"0")).toFixed(4);//实际对比预算
data[_index].actual_last_year=Number(data[_index].last_year||"0")==0?0:((data[_index].actual-Number(data[_index].last_year||"0"))/Number(data[_index].last_year||"0")).toFixed(4);//实际对比去年
data[_index].year_actual_budget=Number(data[_index].year_budget||"0")==0?0:((data[_index].year_actual-Number(data[_index].year_budget||"0"))/Number(data[_index].year_budget||"0")).toFixed(4);//实际对比预算
data[_index].year_actual_last_year=Number(data[_index].year_last_year||"0")==0?0:((data[_index].year_actual-Number(data[_index].year_last_year||"0"))/Number(data[_index].year_last_year||"0")).toFixed(4);//实际对比去年
data[_index].three_actual_budget=Number(data[_index].three_budget||"0")==0?0:((data[_index].three_actual-Number(data[_index].three_budget||"0"))/Number(data[_index].three_budget||"0")).toFixed(4);//实际对比预算
data[_index].three_actual_last_year=Number(data[_index].three_last_year||"0")==0?0:((data[_index].three_actual-Number(data[_index].three_last_year||"0"))/Number(data[_index].three_last_year||"0")).toFixed(4);//实际对比去年
data[_index].whole_actual_budget=Number(data[_index].whole_budget||"0")==0?0:((data[_index].whole_actual-Number(data[_index].whole_budget||"0"))/Number(data[_index].whole_budget||"0")).toFixed(4);//实际对比预算
data[_index].whole_actual_last_year=Number(data[_index].whole_last_year||"0")==0?0:((data[_index].whole_actual-Number(data[_index].whole_last_year||"0"))/Number(data[_index].whole_last_year||"0")).toFixed(4);//实际对比去年
}}function computeFlowThru(a,b,c,d){if(a-b==0){return 0;}else{if(c-d<0){if(c-d>a-b&&a-b<0){return 1-(c-d)/(a-b);}else{if(a-b>0){return-Math.abs((c-d)/(a-b));}else{return-Math.abs((a-b-(c-d))/(a-b));}}}else{if(a-b<0){return Math.abs((a-b-(c-d))/(a-b));}else{return Math.abs((c-d)/(a-b));}}}}return data;};var fillData=exports.fillData=function fillData(data,_ref){var date=_ref.date,data2_1=_ref.data2_1,data2_2=_ref.data2_2,data2_3=_ref.data2_3,_ref$dataLast2_=_ref.dataLast2_1,dataLast2_1=_ref$dataLast2_===undefined?[]:_ref$dataLast2_;// 右侧整年数据自动填充上月已填写
// 整年预测数据从2-1 2-2 2-3 获取，所以无需使用上月数据
// if (x.data.lastData && x.data.lastData.length > 0) {
//     let lastData = x.data.lastData;
//     const listName = ['whole_actual', 'whole_budget', 'whole_last_year', 'whole_actual_budget', 'whole_actual_last_year'];
//     lastData.forEach((item, i) => {
//         listName.forEach(name => {
//             if (data[i][name] == 0) {
//                 data[i][name] = item[name];
//             }
//         });
//     });
// }
// 后三个月数据从2——1获取,后三个月预测等于2.1后面三个月的总和
dataLast2_1=_lodash2.default.get(dataLast2_1,"0.month")==(0,_moment2.default)(date).format("M")?dataLast2_1:dataLast2_1.map(function(v){return _extends({},v,{Jan:v["nextJan"]});});var month=Number((0,_moment2.default)(date).format("MM")||"0");var listName=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];var dataName=[].concat(listName).splice(month,3);var nextName=["nextJan","nextFeb","nextMar"];// 如果月份大于九月份，后三个月预测数据加上下一年预测数据
if(dataName.length<3){dataName=[].concat(_toConsumableArray(dataName),_toConsumableArray(nextName.slice(0,3-dataName.length)));}data.forEach(function(item,i){// 2-1
if(data2_1&&data2_1.length>0||dataLast2_1&&dataLast2_1.length){if(i<24){// 实际与预测 、全年实际
data[i].actual=(0,_method.getJson)([i+1,listName[month-1]],data2_1,0);if(month==1){data[i].prediction=(0,_method.getJson)([i+1,"nextJan"],dataLast2_1,0);}else data[i].prediction=(0,_method.getJson)([i+1,listName[month-1]],dataLast2_1,0);data[i].year_actual=[].concat(listName).reduce(function(a,b,index){if(index<month){a+=(0,_method.Num)((0,_method.getJson)([i+1,b],data2_1,0));}return a;},0).toFixed(2);// 后三个月预测
data[i].three_actual=dataName.reduce(function(a,b){a+=Number((0,_method.getJson)([i+1,b],data2_1));return a;},0).toFixed(2);// 整年预测
data[i].whole_actual=listName.reduce(function(a,b){a+=Number((0,_method.getJson)([i+1,b],data2_1));return a;},0).toFixed(2);}if(i>24){// 实际与预测
data[i].actual=(0,_method.getJson)([i,listName[month-1]],data2_1,0);if(month==1){data[i].prediction=(0,_method.getJson)([i,"nextJan"],dataLast2_1,0);}else data[i].prediction=(0,_method.getJson)([i,listName[month-1]],dataLast2_1,0);data[i].three_actual=dataName.reduce(function(a,b){a+=Number((0,_method.getJson)([i,b],data2_1,0));return a;},0).toFixed(2);data[i].whole_actual=listName.reduce(function(a,b){a+=Number((0,_method.getJson)([i,b],data2_1,0));return a;},0).toFixed(2);data[i].year_actual=[].concat(listName).reduce(function(a,b,index){if(index<month){a+=(0,_method.Num)((0,_method.getJson)([i,b],data2_1,0));}return a;},0).toFixed(2);}}// 2-2
if(data2_2&&data2_2.length>0){if(i<24){// MTD、YTD 预算
data[i].budget=(0,_method.getJson)([i+1,listName[month-1]],data2_2,0);data[i].year_budget=[].concat(listName).reduce(function(a,b,index){if(index<month){a+=(0,_method.Num)((0,_method.getJson)([i+1,b],data2_2,0));}return a;},0).toFixed(2);data[i].three_budget=dataName.reduce(function(a,b){a+=Number(data2_2[i+1][b]);return a;},0).toFixed(2);data[i].whole_budget=listName.reduce(function(a,b){a+=Number(data2_2[i+1][b]);return a;},0).toFixed(2);}if(i>24){// MTD、YTD 预算
data[i].budget=(0,_method.getJson)([i,listName[month-1]],data2_2,0);data[i].year_budget=[].concat(listName).reduce(function(a,b,index){if(index<month){a+=(0,_method.Num)((0,_method.getJson)([i,b],data2_2,0));}return a;},0).toFixed(2);data[i].three_budget=dataName.reduce(function(a,b){a+=Number(data2_2[i][b]);return a;},0).toFixed(2);data[i].whole_budget=listName.reduce(function(a,b){a+=Number(data2_2[i][b]);return a;},0).toFixed(2);}}// 2-3
if(data2_3&&data2_3.length>0){if(i<24){// MTD、YTD 去年实际
data[i].last_year=(0,_method.getJson)([i+1,listName[month-1]],data2_3,0);data[i].year_last_year=[].concat(listName).reduce(function(a,b,index){if(index<month){a+=(0,_method.Num)((0,_method.getJson)([i+1,b],data2_3,0));}return a;},0).toFixed(2);data[i].three_last_year=dataName.reduce(function(a,b){a+=Number(data2_3[i+1][b]);return a;},0).toFixed(2);data[i].whole_last_year=listName.reduce(function(a,b){a+=Number(data2_3[i+1][b]);return a;},0).toFixed(2);}if(i>24){// MTD、YTD 去年实际
data[i].last_year=(0,_method.getJson)([i,listName[month-1]],data2_3,0);data[i].year_last_year=[].concat(listName).reduce(function(a,b,index){if(index<month){a+=(0,_method.Num)((0,_method.getJson)([i,b],data2_3,0));}return a;},0).toFixed(2);data[i].three_last_year=dataName.reduce(function(a,b){a+=Number(data2_3[i][b]);return a;},0).toFixed(2);data[i].whole_last_year=listName.reduce(function(a,b){a+=Number(data2_3[i][b]);return a;},0).toFixed(2);}}});return data;};var saveAllData=exports.saveAllData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var _ref3,hotels,_loop,i;return _regenerator2.default.wrap(function _callee$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return(0,_request2.default)("/getHotels");case 2:_ref3=_context2.sent;hotels=_ref3.data.hotels;_loop=/*#__PURE__*/_regenerator2.default.mark(function _loop(i){var item,data,_ref4,x,year,month,_data,dataFrom,headres;return _regenerator2.default.wrap(function _loop$(_context){while(1){switch(_context.prev=_context.next){case 0:item=hotels[i];//  获取当前酒店数据
data=_lodash2.default.cloneDeep(_data2.data1_1);_context.next=4;return(0,_request2.default)("/kpiInfoAll?year="+(0,_moment2.default)(date).format("YYYY")+"&month="+(0,_moment2.default)(date).format("M")+"&comid="+item.id);case 4:_ref4=_context.sent;x=_ref4.data;if(x.kpi&&x.kpi.length>0){data=x.kpi;}data=compute(fillData(data,_extends({},x,{date:date})));year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");_data=data.map(function(x){return _extends({},x,{year:year,month:month,comid:item.id});});dataFrom=new FormData();dataFrom.append("data",JSON.stringify(_data));headres={method:"post",credentials:"include",headers:{},body:dataFrom};_context.next=16;return(0,_request2.default)("/addKpiInfo",headres);case 16:case"end":return _context.stop();}}},_loop,undefined);});i=0;case 6:if(!(i<hotels.length)){_context2.next=11;break;}return _context2.delegateYield(_loop(i),"t0",8);case 8:i++;_context2.next=6;break;case 11:_message3.default.success("保存成功！");case 12:case"end":return _context2.stop();}}},_callee,undefined);}));return function saveAllData(_x){return _ref2.apply(this,arguments);};}();

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(8);__webpack_require__(6);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(42);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(1486);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data2=__webpack_require__(608);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _compute=__webpack_require__(1487);var _compute2=_interopRequireDefault(_compute);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var Option=_select2.default.Option;var TOTALINDEX=[32,35,40,45,51,54,55,61,70];var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var date=_this.state.date;data=(0,_compute2.default)({data:data,date:date});// 计算三
_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var year=(0,_moment2.default)(date).format('YYYY');var dataDefault=year>=2022?_lodash2.default.cloneDeep(_data2.data2_1):_lodash2.default.cloneDeep(_data2.data2_1).slice(0,33);var data=dataDefault.filter(function(x,i){return i!=0;});var dataSelect=dataDefault.filter(function(x,i){return i==0;});fetch('/_2_1_all?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data2_1&&x.data.data2_1.length>0){data=x.data.data2_1.filter(function(x,i){return i!=0;});dataSelect=x.data.data2_1.filter(function(x,i){return i==0;});}else if(x.data.dataLastMonth&&x.data.dataLastMonth.length>0){(function(){// 获取当前月份之前所有的月份的实际数据
var len=Number((0,_moment2.default)(date).format('M')||"0")-1;var name=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];var newData=x.data.dataLastMonth.filter(function(x,index){return index!=0;});// 自动填充淡旺季
dataSelect=x.data.dataLastMonth.filter(function(x,i){return i==0;}).map(function(x){delete x.id;return x;});if(newData&&newData.length>0){var _loop=function _loop(i){if(i!=len){data=data.map(function(z,index){return _extends({},z,_defineProperty({},name[i],z[name[i]]!=0?z[name[i]]:_lodash2.default.get(newData,index+'.'+name[i],0)));});}};for(var i=0;i<name.length;i++){_loop(i);}}})();}_this.setState({loading:false,dataSelect:dataSelect});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=[].concat(_toConsumableArray(_this.state.dataSelect.map(function(x){return _extends({},x,{year:year,month:month});})),_toConsumableArray(_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});})));var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_2_1',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败'+JSON.stringify(err));console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table2_1',1.5,'2.10',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.onExpoetExcel=function(){_this.setState({print:true,loading:true},function(){var name='Current Year P&L Analysis (Whole Year Forecast = Actual + Forecast) \u672C\u5E74\u635F\u76CA\u5206\u6790\uFF08\u5168\u5E74\u9884\u6D4B = \u5B9E\u9645+\u9884\u6D4B\uFF09'+(0,_moment2.default)(_this.state.date).format('YYYY-MM');var innerHtml='\n              <caption>'+name+'</caption>\n              '+document.getElementById('table').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n            ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,name+'.xls');_this.setState({print:false,loading:false});});};_this.onFillLastMonth=function(){var _data=_this.state.data;var _dataSelect=_this.state.dataSelect;var date=_this.state.date;_this.setState({loading:true,data:[]});var dataBegin=JSON.stringify(_data2.data2_1);var data=JSON.parse(dataBegin).filter(function(x,i){return i!=0;});var dataSelect=JSON.parse(dataBegin).filter(function(x,i){return i==0;});fetch('/_2_1_all?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).subtract(1,'month').format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data2_1&&x.data.data2_1.length>0){data=x.data.data2_1.filter(function(x,i){return i!=0;}).map(function(v,i){delete v.id;if(v.name==_lodash2.default.get(_data,i+'.name')&&_lodash2.default.get(_data,i+'.id'))v.id=_lodash2.default.get(_data,i+'.id');return v;});dataSelect=x.data.data2_1.filter(function(x,i){return i==0;}).map(function(v,i){delete v.id;if(v.name==_lodash2.default.get(_dataSelect,i+'.name')&&_lodash2.default.get(_dataSelect,i+'.id'))v.id=_lodash2.default.get(_dataSelect,i+'.id');return v;});}console.log(data);_this.setState({loading:false,dataSelect:dataSelect});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,dataSelect:[]};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,dataSelect=_state.dataSelect,print=_state.print,date=_state.date,loading=_state.loading;var width=document.body.offsetWidth>3825?document.body.offsetWidth-3400:425;var inputIndex=[0,1,5,6,7,9,11,13,15,17,21,24,25,26,28,29,30,31,33,36,37,38,43,41,42,46,47,48,52,56,57,58,59,62,63,64,65,69,71,72];var percentData=[2,10,12,14,16,18,20,22];var totalData=[8,22,23,27];var totalWidth=3825;var columns=[// {
//     title: 'key',
//     width: 30,
//     fixed: print ? false : "left",
//     dataIndex: 'key',
//     key: 'key',
//     render: (text, record, index) => {
//         return (
//             <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
//                 {index}
//             </div>
//         )
//     }
// },
{align:"center",title:_react2.default.createElement('div',null,'P&L Index ',_react2.default.createElement('br',null),'  \u635F\u76CA\u6307\u6570'),fixed:!print&&"left",dataIndex:'name',key:'name',width:width,render:function render(text,record,index){if(TOTALINDEX.includes(index)){return{children:_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"left"},dangerouslySetInnerHTML:{__html:text||"-"}}),props:{colSpan:(0,_moment2.default)(date).format('M')==12?18:14}};}return _react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),dangerouslySetInnerHTML:{__html:text||"-"},style:{textAlign:"left"}});}},{title:'Jan 一月',align:"center",width:200,children:[{title:1<=(0,_moment2.default)(this.state.date).format('M')?"Actual实际":"Forecast预测",align:"center",width:200,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Jan||"1").toFixed(0).toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Jan=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:200,dataIndex:'Jan',key:'Jan',render:function render(text,record,index){if(TOTALINDEX.includes(index)){return{props:{colSpan:0}};}var title=['Jan \u4E00\u6708-'+(1<=(0,_moment2.default)(_this2.state.date).format('M')?"Actual实际":"Forecast预测")];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Jan',title:title,sqlName:"_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Jan',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Jan',title:title,sqlName:"_2_1",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'Feb 二月',align:"center",width:200,children:[{title:2<=(0,_moment2.default)(this.state.date).format('M')?"Actual实际":"Forecast预测",align:"center",width:200,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Feb||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Feb=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:200,dataIndex:'Feb',key:'Feb',render:function render(text,record,index){if(TOTALINDEX.includes(index)){return{props:{colSpan:0}};}var title=['Feb \u4E8C\u6708-'+(2<=(0,_moment2.default)(_this2.state.date).format('M')?"Actual实际":"Forecast预测")];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Feb',title:title,sqlName:"_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Feb',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Feb',title:title,sqlName:"_2_1",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'Mar 三月',align:"center",width:200,children:[{title:3<=(0,_moment2.default)(this.state.date).format('M')?"Actual实际":"Forecast预测",align:"center",width:200,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Mar||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Mar=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:200,dataIndex:'Mar',key:'Mar',render:function render(text,record,index){if(TOTALINDEX.includes(index)){return{props:{colSpan:0}};}var title=['Mar \u4E09\u6708-'+(3<=(0,_moment2.default)(_this2.state.date).format('M')?"Actual实际":"Forecast预测")];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Mar',title:title,sqlName:"_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Mar',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Mar',title:title,sqlName:"_2_1",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'Apr 四月',align:"center",width:200,children:[{title:4<=(0,_moment2.default)(this.state.date).format('M')?"Actual实际":"Forecast预测",align:"center",width:200,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Apr||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Apr=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:200,dataIndex:'Apr',key:'Apr',render:function render(text,record,index){if(TOTALINDEX.includes(index)){return{props:{colSpan:0}};}var title=['Apr \u56DB\u6708-'+(4<=(0,_moment2.default)(_this2.state.date).format('M')?"Actual实际":"Forecast预测")];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Apr',title:title,sqlName:"_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Apr',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Apr',title:title,sqlName:"_2_1",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'May 五月',align:"center",width:200,children:[{title:5<=(0,_moment2.default)(this.state.date).format('M')?"Actual实际":"Forecast预测",align:"center",width:200,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].May||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].May=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:200,dataIndex:'May',key:'May',render:function render(text,record,index){if(TOTALINDEX.includes(index)){return{props:{colSpan:0}};}var title=['May \u4E94\u6708-'+(5<=(0,_moment2.default)(_this2.state.date).format('M')?"Actual实际":"Forecast预测")];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'May',title:title,sqlName:"_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('May',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'May',title:title,sqlName:"_2_1",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'Jun 六月',align:"center",width:200,children:[{title:6<=(0,_moment2.default)(this.state.date).format('M')?"Actual实际":"Forecast预测",align:"center",width:200,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Jun||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Jun=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:200,dataIndex:'Jun',key:'Jun',render:function render(text,record,index){if(TOTALINDEX.includes(index)){return{props:{colSpan:0}};}var title=['Jun \u516D\u6708-'+(6<=(0,_moment2.default)(_this2.state.date).format('M')?"Actual实际":"Forecast预测")];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Jun',title:title,sqlName:"_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Jun',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Jun',title:title,sqlName:"_2_1",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'Jul 七月',align:"center",width:200,children:[{title:7<=(0,_moment2.default)(this.state.date).format('M')?"Actual实际":"Forecast预测",align:"center",width:200,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Jul||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Jul=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:200,dataIndex:'Jul',key:'Jul',render:function render(text,record,index){if(TOTALINDEX.includes(index)){return{props:{colSpan:0}};}var title=['Jul \u4E03\u6708-'+(7<=(0,_moment2.default)(_this2.state.date).format('M')?"Actual实际":"Forecast预测")];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Jul',title:title,sqlName:"_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Jul',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Jul',title:title,sqlName:"_2_1",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'Aug 八月',align:"center",width:200,children:[{title:8<=(0,_moment2.default)(this.state.date).format('M')?"Actual实际":"Forecast预测",align:"center",width:200,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Aug||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Aug=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:200,dataIndex:'Aug',key:'Aug',render:function render(text,record,index){if(TOTALINDEX.includes(index)){return{props:{colSpan:0}};}var title=['Aug \u516B\u6708-'+(8<=(0,_moment2.default)(_this2.state.date).format('M')?"Actual实际":"Forecast预测")];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Aug',title:title,sqlName:"_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Aug',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Aug',title:title,sqlName:"_2_1",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'Sep 九月',align:"center",width:200,children:[{title:9<=(0,_moment2.default)(this.state.date).format('M')?"Actual实际":"Forecast预测",align:"center",width:200,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Sep||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Sep=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:200,dataIndex:'Sep',key:'Sep',render:function render(text,record,index){if(TOTALINDEX.includes(index)){return{props:{colSpan:0}};}var title=['Sep \u4E5D\u6708-'+(9<=(0,_moment2.default)(_this2.state.date).format('M')?"Actual实际":"Forecast预测")];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Sep',title:title,sqlName:"_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Sep',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Sep',title:title,sqlName:"_2_1",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'Oct 十月',align:"center",width:200,children:[{title:10<=(0,_moment2.default)(this.state.date).format('M')?"Actual实际":"Forecast预测",align:"center",width:200,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Oct||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Oct=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:200,dataIndex:'Oct',key:'Oct',render:function render(text,record,index){if(TOTALINDEX.includes(index)){return{props:{colSpan:0}};}var title=['Oct \u5341\u6708-'+(10<=(0,_moment2.default)(_this2.state.date).format('M')?"Actual实际":"Forecast预测")];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Oct',title:title,sqlName:"_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Oct',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Oct',title:title,sqlName:"_2_1",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'Nov 十一月',align:"center",width:200,children:[{title:11<=(0,_moment2.default)(this.state.date).format('M')?"Actual实际":"Forecast预测",align:"center",width:200,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Nov||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Nov=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:200,dataIndex:'Nov',key:'Nov',render:function render(text,record,index){if(TOTALINDEX.includes(index)){return{props:{colSpan:0}};}var title=['Nov \u5341\u4E00\u6708-'+(11<=(0,_moment2.default)(_this2.state.date).format('M')?"Actual实际":"Forecast预测")];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Nov',title:title,sqlName:"_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Nov',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Nov',title:title,sqlName:"_2_1",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'Dec 十二月',align:"center",width:200,children:[{title:12<=(0,_moment2.default)(this.state.date).format('M')?"Actual实际":"Forecast预测",align:"center",width:200,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Dec||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Dec=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:200,dataIndex:'Dec',key:'Dec',render:function render(text,record,index){if(TOTALINDEX.includes(index)){return{props:{colSpan:0}};}var title=['Dec \u5341\u4E8C\u6708-'+(12<=(0,_moment2.default)(_this2.state.date).format('M')?"Actual实际":"Forecast预测")];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Dec',title:title,sqlName:"_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Dec',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Dec',title:title,sqlName:"_2_1",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:_react2.default.createElement('div',null,'Whole Year Forecast ',_react2.default.createElement('br',null),' \u5168\u5E74\u9884\u6D4B'),align:"center",width:200,dataIndex:'whole',key:'whole',render:function render(text,record,index){if(TOTALINDEX.includes(index)){return{props:{colSpan:0}};}var title=['Whole Year Forecast \u5168\u5E74\u9884\u6D4B'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'whole',title:title,sqlName:"_2_1",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}},{title:_react2.default.createElement('div',null,'Variance - Next Year Forecast Vs. Budget '),width:200,children:[{title:'Jan 一月',width:200,children:[{title:'Forecast 预测',width:200,align:"center",dataIndex:'nextJan',key:'nextJan',render:function render(text,record,index){if(TOTALINDEX.includes(index)){return{props:{colSpan:0}};}var title=['Variance - Next Year Forecast Vs. Budget','Jan 一月-Forecast 预测'];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'nextJan',title:title,sqlName:"_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('nextJan',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'nextJan',title:title,sqlName:"_2_1",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]},{title:'Feb 二月',width:200,children:[{title:'Forecast 预测',width:200,align:"center",dataIndex:'nextFeb',key:'nextFeb',render:function render(text,record,index){if(TOTALINDEX.includes(index)){return{props:{colSpan:0}};}var title=['Variance - Next Year Forecast Vs. Budget','Jan 二月-Forecast 预测'];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'nextFeb',title:title,sqlName:"_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('nextFeb',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'nextFeb',title:title,sqlName:"_2_1",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]},{title:'Mar 三月',width:200,children:[{title:'Forecast 预测',width:200,align:"center",dataIndex:'nextMar',key:'nextMar',render:function render(text,record,index){if(TOTALINDEX.includes(index)){return{props:{colSpan:0}};}var title=['Variance - Next Year Forecast Vs. Budget','Jan 三月-Forecast 预测'];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'nextMar',title:title,sqlName:"_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('nextMar',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'nextMar',title:title,sqlName:"_2_1",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]},{title:'Q1 第一季度',width:200,align:"center",dataIndex:'nextQ1',key:'nextQ1',render:function render(text,record,index){if(TOTALINDEX.includes(index)){return{props:{colSpan:0}};}var title=['Q1 第一季度'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'nextQ1',title:title,sqlName:"_2_1",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}]}];if((0,_moment2.default)(date).format("M")<10){columns=columns.slice(0,columns.length-1);totalWidth=3025;}return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table table2_1'},_react2.default.createElement(_row2.default,{className:'title',style:{width:print?3875:'auto'},id:'table2_1'},_react2.default.createElement(_row2.default,null,'2.1 Current Year P&L Analysis (Whole Year Forecast = Actual + Forecast) \u672C\u5E74\u635F\u76CA\u5206\u6790\uFF08\u5168\u5E74\u9884\u6D4B = \u5B9E\u9645+\u9884\u6D4B\uFF09'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}}),_react2.default.createElement(_button2.default,{type:'primary',style:{marginLeft:10,display:this.state.print?'none':''},onClick:this.onFillLastMonth},'\u586B\u5145\u4E0A\u6708\u6570\u636E'),_react2.default.createElement(_Auth2.default,{isAdmin:true},_react2.default.createElement(_button2.default,{type:'primary',loading:loading,style:{marginLeft:10,display:this.state.print?'none':''},onClick:function onClick(){_this2.setState({loading:true},_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_compute.saveAllData)(date);case 2:_this2.setState({loading:false});case 3:case'end':return _context.stop();}}},_callee,_this2);})));}},'\u4FDD\u5B58\u6240\u6709\u9152\u5E97\u6570\u636E'))),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',id:'table',className:'content',bordered:true,pagination:false,style:{width:print?totalWidth:'auto'},scroll:print?{}:{x:totalWidth,y:550},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.onExpoetExcel},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_2_1'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.saveAllData=undefined;var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.default=compute;__webpack_require__(10);var _method=__webpack_require__(20);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _data=__webpack_require__(608);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function compute(_ref){var data=_ref.data,date=_ref.date;var year=(0,_moment2.default)(date).format('YYYY');// 计算一
var rowNum=[0,1,5,6,7,9,11,13,15,17,21,24,25,26,28,29,30,31];if(year>=2022)rowNum=[].concat(_toConsumableArray(rowNum),[33,36,37,38,43,41,42,46,47,48,49,52,56,57,58,59,62,63,64,65,69,71,72]);var rowNameData=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];var rowNextData=['nextJan','nextFeb','nextMar'];var _loop=function _loop(index){data[rowNum[index]].whole=rowNameData.reduce(function(a,b){a+=(0,_method.numConvert)(data[rowNum[index]][b]);return a;},0).toFixed(2);data[rowNum[index]].nextQ1=rowNextData.reduce(function(a,b){a+=(0,_method.numConvert)(data[rowNum[index]][b]);return a;},0).toFixed(2);// (data[rowNum[index]].whole).toFixed(2);
// (data[rowNum[index]].nextQ1).toFixed(2);
};for(var index=0;index<rowNum.length;index++){_loop(index);}// 计算二
var nameData=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec','nextJan','nextFeb','nextMar','whole','nextQ1'];for(var index=0;index<nameData.length;index++){// 提前计算毛利润 GOP
// 总收入
data[8][nameData[index]]=((0,_method.numConvert)(data[7][nameData[index]])+(0,_method.numConvert)(data[6][nameData[index]])+(0,_method.numConvert)(data[5][nameData[index]])).toFixed(2);//  GOP
data[22][nameData[index]]=((0,_method.numConvert)(data[8][nameData[index]])==0?0:(0,_method.numConvert)(data[21][nameData[index]])/(0,_method.numConvert)(data[8][nameData[index]])).toFixed(3);//  盈亏平衡点/总费用
data[23][nameData[index]]=((0,_method.numConvert)(data[8][nameData[index]])-(0,_method.numConvert)(data[21][nameData[index]])).toFixed(2);// 客房率
data[2][nameData[index]]=((0,_method.numConvert)(data[0][nameData[index]])==0?0:(0,_method.numConvert)(data[1][nameData[index]])/(0,_method.numConvert)(data[0][nameData[index]])).toFixed(3);// 平均房价
data[3][nameData[index]]=((0,_method.numConvert)(data[1][nameData[index]])==0?0:(0,_method.numConvert)(data[5][nameData[index]])/(0,_method.numConvert)(data[1][nameData[index]])).toFixed(2);// 平均收入
data[4][nameData[index]]=((0,_method.numConvert)(data[0][nameData[index]])==0?0:(0,_method.numConvert)(data[5][nameData[index]])/(0,_method.numConvert)(data[0][nameData[index]])).toFixed(2);// 客房部门利润百分比
data[10][nameData[index]]=((0,_method.numConvert)(data[5][nameData[index]])==0?0:(0,_method.numConvert)(data[9][nameData[index]])/(0,_method.numConvert)(data[5][nameData[index]])).toFixed(3);// 餐饮部门利润百分比
data[12][nameData[index]]=((0,_method.numConvert)(data[6][nameData[index]])==0?0:(0,_method.numConvert)(data[11][nameData[index]])/(0,_method.numConvert)(data[6][nameData[index]])).toFixed(3);// 食品成本百分比
data[14][nameData[index]]=((0,_method.numConvert)(data[6][nameData[index]])==0?0:(0,_method.numConvert)(data[13][nameData[index]])/(0,_method.numConvert)(data[6][nameData[index]])).toFixed(3);// 人力资源成本
data[16][nameData[index]]=((0,_method.numConvert)(data[8][nameData[index]])==0?0:(0,_method.numConvert)(data[15][nameData[index]])/(0,_method.numConvert)(data[8][nameData[index]])).toFixed(3);// 能源成本
data[18][nameData[index]]=((0,_method.numConvert)(data[8][nameData[index]])==0?0:(0,_method.numConvert)(data[17][nameData[index]])/(0,_method.numConvert)(data[8][nameData[index]])).toFixed(3);// 其他费用成本
data[19][nameData[index]]=((0,_method.numConvert)(data[23][nameData[index]])-(0,_method.numConvert)(data[17][nameData[index]])-(0,_method.numConvert)(data[15][nameData[index]])-(0,_method.numConvert)(data[13][nameData[index]])).toFixed(2);// 其他费用成本率
data[20][nameData[index]]=((0,_method.numConvert)(data[8][nameData[index]])==0?0:(0,_method.numConvert)(data[19][nameData[index]])/(0,_method.numConvert)(data[8][nameData[index]])).toFixed(3);// 总收费
data[27][nameData[index]]=((0,_method.numConvert)(data[26][nameData[index]])+(0,_method.numConvert)(data[25][nameData[index]])+(0,_method.numConvert)(data[24][nameData[index]])).toFixed(2);}// 2022年新增行数
if(data.length>70&&year>=2022){nameData.forEach(function(name){data[34][name]=((0,_method.numConvert)(data[33][name])+(0,_method.numConvert)(data[13][name])).toFixed(2);data[39][name]=(0,_method.sum)([data[38][name],data[37][name],data[36][name]]);data[44][name]=(0,_method.sum)([data[43][name],data[42][name],data[41][name]]);data[49][name]=(0,_method.sum)([data[48][name],data[47][name],data[46][name]]);data[50][name]=(0,_method.sum)([data[49][name],data[44][name],data[39][name],data[34][name]]);data[53][name]=(0,_method.sum)([data[52][name],data[9][name],data[11][name]]);data[60][name]=(0,_method.sum)([data[59][name],data[58][name],data[57][name],data[56][name]]);data[66][name]=(0,_method.sum)([data[17][name],data[65][name],data[64][name],data[63][name],data[62][name]]);data[67][name]=(0,_method.sum)([data[66][name],data[60][name]]);data[68][name]=((0,_method.numConvert)(data[53][name])-(0,_method.numConvert)(data[67][name])).toFixed(2);data[73][name]=(0,_method.sum)([data[72][name],data[71][name],data[26][name]]);data[74][name]=((0,_method.numConvert)(data[21][name])-(0,_method.numConvert)(data[73][name])).toFixed(2);});}return data;}var saveAllData=exports.saveAllData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var _ref3,hotels,_loop2,i;return _regenerator2.default.wrap(function _callee$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return(0,_request2.default)('/getHotels');case 2:_ref3=_context2.sent;hotels=_ref3.data.hotels;_loop2=/*#__PURE__*/_regenerator2.default.mark(function _loop2(i){var item,year,dataDefault,data,dataSelect,_ref4,x,month,dataFrom,headres;return _regenerator2.default.wrap(function _loop2$(_context){while(1){switch(_context.prev=_context.next){case 0:item=hotels[i];//  获取当前酒店数据  
year=(0,_moment2.default)(date).format('YYYY');dataDefault=year>=2022?_lodash2.default.cloneDeep(_data.data2_1):_lodash2.default.cloneDeep(_data.data2_1).slice(0,33);data=dataDefault.filter(function(x,i){return i!=0;});dataSelect=dataDefault.filter(function(x,i){return i==0;});_context.next=7;return(0,_request2.default)("/_2_1_all?year="+(0,_moment2.default)(date).format('YYYY')+"&month="+(0,_moment2.default)(date).format('M')+"&comid="+item.id);case 7:_ref4=_context.sent;x=_ref4.data;if(x.data&&x.data.length>0){data=x.data2_1.filter(function(x,i){return i!=0;});dataSelect=x.data2_1.filter(function(x,i){return i==0;});}else if(x.dataLastMonth&&x.dataLastMonth.length>0){(function(){// 获取当前月份之前所有的月份的实际数据
var len=Number((0,_moment2.default)(date).format('M')||"0")-1;var name=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];var newData=x.dataLastMonth.filter(function(x,index){return index!=0;});// 自动填充淡旺季
dataSelect=x.dataLastMonth.filter(function(x,i){return i==0;}).map(function(x){delete x.id;return x;});if(newData&&newData.length>0){var _loop3=function _loop3(_i){if(_i!=len){data=data.map(function(z,index){return _extends({},z,_defineProperty({},name[_i],z[name[_i]]!=0?z[name[_i]]:_lodash2.default.get(newData,index+"."+name[_i],0)));});}};for(var _i=0;_i<name.length;_i++){_loop3(_i);}}})();}data=compute({data:data,date:date});month=(0,_moment2.default)(date).format("M");dataFrom=new FormData();dataFrom.append('data',JSON.stringify([].concat(_toConsumableArray(dataSelect),_toConsumableArray(data)).map(function(x){return _extends({},x,{year:year,month:month,comid:item.id});})));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context.next=17;return(0,_request2.default)('/add_2_1',headres);case 17:case"end":return _context.stop();}}},_loop2,undefined);});i=0;case 6:if(!(i<hotels.length)){_context2.next=11;break;}return _context2.delegateYield(_loop2(i),"t0",8);case 8:i++;_context2.next=6;break;case 11:_message3.default.success('保存成功！');case 12:case"end":return _context2.stop();}}},_callee,undefined);}));return function saveAllData(_x){return _ref2.apply(this,arguments);};}();

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(8);__webpack_require__(6);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(1489);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data2=__webpack_require__(609);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _compute=__webpack_require__(1490);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var _data=(0,_compute.compute)(data);// 计算三
_this.setState({data:_data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data2.data2_2);var data=JSON.parse(dataBegin).filter(function(x,i){return i!=0;});var dataSelect=JSON.parse(dataBegin).filter(function(x,i){return i==0;});fetch('/_2_2_info?year='+date,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data.filter(function(x,i){return i!=0;});dataSelect=x.data.filter(function(x,i){return i==0;});}else{data=(0,_compute.fillData)(data,x.msg);}_this.setState({loading:false,dataSelect:dataSelect,b12:x.msg||[]});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onFillLastMonth=function(){var data=(0,_compute.fillData)(_this.state.data,_this.state.b12);_this.setState({data:[]},function(){_this.computeNum(data);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=date;var data=[].concat(_toConsumableArray(_this.state.dataSelect.map(function(x){return _extends({},x,{year:year});})),_toConsumableArray(_this.state.data.map(function(x){return _extends({},x,{year:year});})));var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_2_2',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败'+JSON.stringify(err));console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table2_2',1.5,'2.20',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.onExpoetExcel=function(){_this.setState({print:true,loading:true},function(){var name='Current Year P&L Analysis (Whole Year Budget) \u672C\u5E74\u635F\u76CA\u5206\u6790 \uFF08\u5168\u5E74\u9884\u7B97\uFF09'+(0,_moment2.default)(_this.state.date).format('YYYY-MM');var innerHtml='\n              <caption>'+name+'</caption>\n              '+document.getElementById('table').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n            ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,name+'.xls');_this.setState({print:false,loading:false});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY'),data:[],loading:true,loadingSave:false,dateData:[],print:false,dataSelect:[]};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);var date=Number(this.state.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});}},{key:'render',value:function render(){var _ref,_this2=this;var _state=this.state,date=_state.date,data=_state.data,print=_state.print,dataSelect=_state.dataSelect,loading=_state.loading;var width=document.body.offsetWidth>3025?document.body.offsetWidth-2600:425;var inputIndex=[0,1,5,6,7,9,11,13,15,17,21,24,25,26,28,29,30,31];var percentData=[2,10,12,14,16,18,20,22,33,35,37,39,41];var totalData=[8,22,23,27];var totalWidth=3025;var columns=[(_ref={align:"center",title:_react2.default.createElement('div',null,'P&L Index ',_react2.default.createElement('br',null),'  \u635F\u76CA\u6307\u6570'),width:width,fixed:print?false:"left",dataIndex:'name',key:'name'},_defineProperty(_ref,'width',width),_defineProperty(_ref,'render',function render(text,record,index){return _react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"left"},dangerouslySetInnerHTML:{__html:text}});}),_ref),{title:'Jan 一月',align:"center",width:150,children:[{title:'Budget预算',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Jan||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Jan=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:150,dataIndex:'Jan',key:'Jan',render:function render(text,record,index){var title=['Jan \u4E00\u6708-Budget\u9884\u7B97'];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Jan',title:title,sqlName:"_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Jan',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Jan',title:title,sqlName:"_2_2",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'Feb 二月',align:"center",width:150,children:[{title:'Budget预算',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Feb||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Feb=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:150,dataIndex:'Feb',key:'Feb',render:function render(text,record,index){var title=['Feb \u4E8C\u6708-Budget\u9884\u7B97'];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Feb',title:title,sqlName:"_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Feb',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Feb',title:title,sqlName:"_2_2",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'Mar 三月',align:"center",width:150,children:[{title:'Budget预算',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Mar||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Mar=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:150,dataIndex:'Mar',key:'Mar',render:function render(text,record,index){var title=['Mar \u4E09\u6708-Budget\u9884\u7B97'];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Mar',title:title,sqlName:"_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Mar',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Mar',title:title,sqlName:"_2_2",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'Apr 四月',align:"center",width:150,children:[{title:'Budget预算',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Apr||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Apr=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:150,dataIndex:'Apr',key:'Apr',render:function render(text,record,index){var title=['Apr \u56DB\u6708-Budget\u9884\u7B97'];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Apr',title:title,sqlName:"_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Apr',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Apr',title:title,sqlName:"_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'May 五月',align:"center",width:150,children:[{title:'Budget预算',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].May||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].May=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:150,dataIndex:'May',key:'May',render:function render(text,record,index){var title=['May \u4E94\u6708-Budget\u9884\u7B97'];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'May',title:title,sqlName:"_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('May',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'May',title:title,sqlName:"_2_2",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'Jun 六月',align:"center",width:150,children:[{title:'Budget预算',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Jun||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Jun=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:150,dataIndex:'Jun',key:'Jun',render:function render(text,record,index){var title=['Jun \u516D\u6708-Budget\u9884\u7B97'];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Jun',title:title,sqlName:"_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Jun',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Jun',title:title,sqlName:"_2_2",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'Jul 七月',align:"center",width:150,children:[{title:'Budget预算',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Jul||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Jul=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:150,dataIndex:'Jul',key:'Jul',render:function render(text,record,index){var title=['Jul \u4E03\u6708-Budget\u9884\u7B97'];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Jul',title:title,sqlName:"_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Jul',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Jul',title:title,sqlName:"_2_2",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'Aug 八月',align:"center",width:150,children:[{title:'Budget预算',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Aug||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Aug=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:150,dataIndex:'Aug',key:'Aug',render:function render(text,record,index){var title=['Aug \u516B\u6708- Budget\u9884\u7B97'];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Aug',title:title,sqlName:"_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Aug',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Aug',title:title,sqlName:"_2_2",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'Sep 九月',align:"center",width:150,children:[{title:'Budget预算',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Sep||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Sep=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:150,dataIndex:'Sep',key:'Sep',render:function render(text,record,index){var title=['Sep \u4E5D\u6708-Budget\u9884\u7B97'];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Sep',title:title,sqlName:"_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Sep',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Sep',title:title,sqlName:"_2_2",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'Oct 十月',align:"center",width:150,children:[{title:'Budget预算',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Oct||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Oct=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:150,dataIndex:'Oct',key:'Oct',render:function render(text,record,index){var title=['Oct \u5341\u6708-Budget\u9884\u7B97'];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Oct',title:title,sqlName:"_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Oct',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Oct',title:title,sqlName:"_2_2",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'Nov 十一月',align:"center",width:150,children:[{title:'Budget预算',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Nov||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Nov=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:150,dataIndex:'Nov',key:'Nov',render:function render(text,record,index){var title=['Nov \u5341\u4E00\u6708-Budget\u9884\u7B97'];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Nov',title:title,sqlName:"_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Nov',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Nov',title:title,sqlName:"_2_2",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:'Dec 十二月',align:"center",width:150,children:[{title:'Budget预算',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{value:dataSelect[0]?Number(dataSelect[0].Dec||"1").toFixed(0).toString():"1",onChange:function onChange(value){var dataS=_this2.state.dataSelect;dataS[0].Dec=value||"";_this2.setState({dataSelect:dataS});}},_react2.default.createElement(Option,{value:'1'},'High\u65FA\u5B63'),_react2.default.createElement(Option,{value:'2'},'Shoulder\u5E73\u5B63'),_react2.default.createElement(Option,{value:'3'},'Low\u6DE1\u5B63')),align:"center",width:150,dataIndex:'Dec',key:'Dec',render:function render(text,record,index){var title=['Dec \u5341\u4E8C\u6708-Budget\u9884\u7B97'];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Dec',title:title,sqlName:"_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Dec',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Dec',title:title,sqlName:"_2_2",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]}]},{title:_react2.default.createElement('div',null,'Whole Year Budget ',_react2.default.createElement('br',null),' \u5168\u5E74\u9884\u7B97'),align:"center",width:200,dataIndex:'whole',key:'whole',render:function render(text,record,index){var title=['Whole Year Forecast \u5168\u5E74\u9884\u6D4B'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'whole',title:title,sqlName:"_2_2",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}},{title:_react2.default.createElement('div',null,'Variance - Next Year Forecast Vs. Budget '),width:150,children:[{title:'Jan 一月',width:150,children:[{title:'Budget预算',width:150,align:"center",dataIndex:'nextJan',key:'nextJan',render:function render(text,record,index){var title=['Variance - Next Year Forecast Vs. Budget','Jan 一月-Budget预算'];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'nextJan',title:title,sqlName:"_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('nextJan',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'nextJan',title:title,sqlName:"_2_2",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]},{title:'Feb 二月',width:150,children:[{title:'Budget预算',width:150,align:"center",dataIndex:'nextFeb',key:'nextFeb',render:function render(text,record,index){var title=['Variance - Next Year Forecast Vs. Budget','Jan 二月-Budget预算'];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'nextFeb',title:title,sqlName:"_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('nextFeb',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'nextFeb',title:title,sqlName:"_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]},{title:'Mar 三月',width:150,children:[{title:'Budget预算',width:150,align:"center",dataIndex:'nextMar',key:'nextMar',render:function render(text,record,index){var title=['Variance - Next Year Forecast Vs. Budget','Jan 三月-Budget预算'];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'nextMar',title:title,sqlName:"_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('nextMar',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'nextMar',title:title,sqlName:"_2_2",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]},{title:'Q1 第一季度',width:150,align:"center",dataIndex:'nextQ1',key:'nextQ1',render:function render(text,record,index){var title=['Q1 第一季度'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'nextQ1',title:title,sqlName:"_2_2",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table table2_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table2_2',style:{width:this.state.print?3075:'auto'}},_react2.default.createElement(_row2.default,null,'2.2 Current Year P&L Analysis (Whole Year Budget) \u672C\u5E74\u635F\u76CA\u5206\u6790 \uFF08\u5168\u5E74\u9884\u7B97\uFF09'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(_select2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u4EFD',style:{width:120},value:this.state.date,onChange:function onChange(str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}},this.state.dateData.map(function(x,i){return _react2.default.createElement(Option,{value:x,key:x},x);})),_react2.default.createElement(_button2.default,{type:'primary',style:{marginLeft:10,display:this.state.print?'none':''},onClick:this.onFillLastMonth},'\u4E00\u952E\u586B\u5145\u6570\u636E'),_react2.default.createElement(_Auth2.default,{isAdmin:true},_react2.default.createElement(_button2.default,{type:'primary',loading:loading,style:{marginLeft:10,display:this.state.print?'none':''},onClick:function onClick(){_this2.setState({loading:true},_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_compute.saveAllData)(date);case 2:_this2.setState({loading:false});case 3:case'end':return _context.stop();}}},_callee,_this2);})));}},'\u4FDD\u5B58\u6240\u6709\u9152\u5E97\u6570\u636E'))),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',id:'table',className:'content',bordered:true,pagination:false,style:{width:this.state.print?totalWidth:'auto'},scroll:this.state.print?{}:{x:totalWidth,y:550},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.onExpoetExcel},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_2_2'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.saveAllData=exports.fillData=exports.compute=undefined;var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};__webpack_require__(10);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _data=__webpack_require__(609);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var rowNameData=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];var compute=exports.compute=function compute(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};// 计算一
var rowNum=[0,1,5,6,7,9,11,13,15,17,21,24,25,26,28,29,30,31];var rowNextData=['nextJan','nextFeb','nextMar'];var _loop=function _loop(index){data[rowNum[index]].whole=rowNameData.reduce(function(a,b){a+=numConvert(data[rowNum[index]][b]);return a;},0).toFixed(2);data[rowNum[index]].nextQ1=rowNextData.reduce(function(a,b){a+=numConvert(data[rowNum[index]][b]);return a;},0).toFixed(2);data[rowNum[index]].whole.toFixed(2);data[rowNum[index]].nextQ1.toFixed(2);};for(var index=0;index<rowNum.length;index++){_loop(index);}// 计算二
var nameData=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec','nextJan','nextFeb','nextMar','whole','nextQ1'];for(var index=0;index<nameData.length;index++){// 提前计算毛利润 GOP
//  GOP
data[22][nameData[index]]=(numConvert(data[8][nameData[index]])==0?0:numConvert(data[21][nameData[index]])/numConvert(data[8][nameData[index]])).toFixed(4);//  盈亏平衡点/总费用
data[23][nameData[index]]=(numConvert(data[8][nameData[index]])-numConvert(data[21][nameData[index]])).toFixed(2);// 客房率
data[2][nameData[index]]=(numConvert(data[0][nameData[index]])==0?0:numConvert(data[1][nameData[index]])/numConvert(data[0][nameData[index]])).toFixed(4);// 平均房价
data[3][nameData[index]]=(numConvert(data[1][nameData[index]])==0?0:numConvert(data[5][nameData[index]])/numConvert(data[1][nameData[index]])).toFixed(2);// 平均收入
data[4][nameData[index]]=(numConvert(data[0][nameData[index]])==0?0:numConvert(data[5][nameData[index]])/numConvert(data[0][nameData[index]])).toFixed(2);// 总收入
data[8][nameData[index]]=(numConvert(data[7][nameData[index]])+numConvert(data[6][nameData[index]])+numConvert(data[5][nameData[index]])).toFixed(2);// 客房部门利润百分比
data[10][nameData[index]]=(numConvert(data[5][nameData[index]])==0?0:numConvert(data[9][nameData[index]])/numConvert(data[5][nameData[index]])).toFixed(4);// 餐饮部门利润百分比
data[12][nameData[index]]=(numConvert(data[6][nameData[index]])==0?0:numConvert(data[11][nameData[index]])/numConvert(data[6][nameData[index]])).toFixed(4);// 食品成本百分比
data[14][nameData[index]]=(numConvert(data[6][nameData[index]])==0?0:numConvert(data[13][nameData[index]])/numConvert(data[6][nameData[index]])).toFixed(4);// 人力资源成本
data[16][nameData[index]]=(numConvert(data[8][nameData[index]])==0?0:numConvert(data[15][nameData[index]])/numConvert(data[8][nameData[index]])).toFixed(4);// 能源成本
data[18][nameData[index]]=(numConvert(data[8][nameData[index]])==0?0:numConvert(data[17][nameData[index]])/numConvert(data[8][nameData[index]])).toFixed(4);// 其他费用成本
data[19][nameData[index]]=(numConvert(data[23][nameData[index]])-numConvert(data[17][nameData[index]])-numConvert(data[15][nameData[index]])-numConvert(data[13][nameData[index]])).toFixed(2);// 其他费用成本率
data[20][nameData[index]]=(numConvert(data[8][nameData[index]])==0?0:numConvert(data[19][nameData[index]])/numConvert(data[8][nameData[index]])).toFixed(4);// 总收费
data[27][nameData[index]]=(numConvert(data[26][nameData[index]])+numConvert(data[25][nameData[index]])+numConvert(data[24][nameData[index]])).toFixed(2);}return data;};var fillData=exports.fillData=function fillData(data,b12){rowNameData.forEach(function(name){data[0][name]=_lodash2.default.get(b12,"1."+name,0);data[1][name]=_lodash2.default.get(b12,"2."+name,0);data[2][name]=_lodash2.default.get(b12,"3."+name,0);data[3][name]=_lodash2.default.get(b12,"4."+name,0);data[4][name]=_lodash2.default.get(b12,"5."+name,0);data[5][name]=_lodash2.default.get(b12,"7."+name,0);data[6][name]=_lodash2.default.get(b12,"8."+name,0);data[7][name]=_lodash2.default.get(b12,"9."+name,0);data[8][name]=_lodash2.default.get(b12,"10."+name,0);data[9][name]=_lodash2.default.get(b12,"32."+name,0);data[10][name]=_lodash2.default.get(b12,"63."+name,0);data[11][name]=_lodash2.default.get(b12,"33."+name,0);data[12][name]=_lodash2.default.get(b12,"64."+name,0);data[13][name]=_lodash2.default.get(b12,"12."+name,0);data[14][name]=_lodash2.default.get(b12,"68."+name,0);data[15][name]=_lodash2.default.get(b12,"74."+name,0);data[16][name]=_lodash2.default.get(b12,"67."+name,0);data[17][name]=_lodash2.default.get(b12,"48."+name,0);data[18][name]=_lodash2.default.get(b12,"69."+name,0);data[21][name]=_lodash2.default.get(b12,"55."+name,0);data[24][name]=_lodash2.default.get(b12,"53."+name,0);data[25][name]=_lodash2.default.get(b12,"54."+name,0);data[26][name]=_lodash2.default.get(b12,"57."+name,0);});return data;};var saveAllData=exports.saveAllData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(year){var _ref2,hotels,_loop2,i;return _regenerator2.default.wrap(function _callee$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return(0,_request2.default)('/getHotels');case 2:_ref2=_context2.sent;hotels=_ref2.data.hotels;_loop2=/*#__PURE__*/_regenerator2.default.mark(function _loop2(i){var item,dataDefault,data,dataSelect,_ref3,x,msg,dataFrom,headres;return _regenerator2.default.wrap(function _loop2$(_context){while(1){switch(_context.prev=_context.next){case 0:item=hotels[i];//  获取当前酒店数据   
dataDefault=_lodash2.default.cloneDeep(_data.data2_2);data=dataDefault.filter(function(x,i){return i!=0;});dataSelect=dataDefault.filter(function(x,i){return i==0;});_context.next=6;return(0,_request2.default)("/_2_2_info?year="+year+"&comid="+item.id);case 6:_ref3=_context.sent;x=_ref3.data;msg=_ref3.msg;if(x.data&&x.data.length>0){data=x.data.filter(function(x,i){return i!=0;});dataSelect=x.data.filter(function(x,i){return i==0;});}else{data=fillData(data,msg);}data=compute(data);dataFrom=new FormData();dataFrom.append('data',JSON.stringify([].concat(_toConsumableArray(dataSelect),_toConsumableArray(data)).map(function(x){return _extends({},x,{year:year,comid:item.id});})));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context.next=16;return(0,_request2.default)('/add_2_2',headres);case 16:case"end":return _context.stop();}}},_loop2,undefined);});i=0;case 6:if(!(i<hotels.length)){_context2.next=11;break;}return _context2.delegateYield(_loop2(i),"t0",8);case 8:i++;_context2.next=6;break;case 11:_message3.default.success('保存成功！');case 12:case"end":return _context2.stop();}}},_callee,undefined);}));return function saveAllData(_x2){return _ref.apply(this,arguments);};}();

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _alert=__webpack_require__(83);var _alert2=_interopRequireDefault(_alert);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(84);__webpack_require__(8);__webpack_require__(6);__webpack_require__(4);__webpack_require__(10);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(1492);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(610);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _IsLableAuth=__webpack_require__(107);var _IsLableAuth2=_interopRequireDefault(_IsLableAuth);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _compute=__webpack_require__(1493);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){data=(0,_compute.compute)(data);// 计算三
_this.setState({data:data},function(){_this.onSave();});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data2_3);var data=JSON.parse(dataBegin).filter(function(x,i){return i!=0;});var dataSelect=JSON.parse(dataBegin).filter(function(x,i){return i==0;});fetch('/_2_3_info?year='+date,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data.filter(function(x,i){return i!=0;});dataSelect=x.data.filter(function(x,i){return i==0;});}if(x.msg.last&&x.msg.last.length){data=x.msg.last.filter(function(x,i){return i!=0&&i<=data.length;}).map(function(v,i){delete v.id;delete v.month;if(data[i].id)v.id=data[i].id;return _extends({},v,{'nextJan':_lodash2.default.get(x.msg.data2_1,i+1+'.Jan'),'nextFeb':_lodash2.default.get(x.msg.data2_1,i+1+'.Feb'),'nextMar':_lodash2.default.get(x.msg.data2_1,i+1+'.Mar')});});dataSelect=x.msg.last.filter(function(x,i){return i==0;}).map(function(v,i){delete v.id;delete v.month;if(dataSelect[i].id)v.id=dataSelect[i].id;return v;});}_this.setState({loading:false,dataSelect:dataSelect});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=date;var data=[].concat(_toConsumableArray(_this.state.dataSelect.map(function(x){return _extends({},x,{year:year});})),_toConsumableArray(_this.state.data.map(function(x){return _extends({},x,{year:year});})));var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_2_3',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败'+JSON.stringify(err));console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table2_3',1.5,'2.30',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.onExpoetExcel=function(){_this.setState({print:true,loading:true},function(){var name='Last Year P&L Analysis (Whole Year Actual) \u524D\u4E00\u5E74\u5EA6\u635F\u76CA\u5206\u6790 \uFF08\u53BB\u5E74\u5B9E\u9645\uFF09'+(0,_moment2.default)(_this.state.date).format('YYYY-MM');var innerHtml='\n              <caption>'+name+'</caption>\n              '+document.getElementById('table').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n            ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,name+'.xls');_this.setState({print:false,loading:false});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY'),data:[],loading:true,loadingSave:false,dateData:[],print:false,dataSelect:[]};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);var date=Number(this.state.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});}},{key:'render',value:function render(){var _ref,_this2=this;var _state=this.state,data=_state.data,loading=_state.loading,date=_state.date;var width=document.body.offsetWidth>3025?document.body.offsetWidth-2600:425;var inputIndex=[0,1,5,6,7,9,11,13,15,17,21,24,25,26,28,29,30,31];var percentData=[2,10,12,14,16,18,20,22];var totalData=[8,22,23,27];var dataSelect=this.state.dataSelect;var print=this.state.print;var columns=[(_ref={align:"center",title:_react2.default.createElement('div',null,'P&L Index ',_react2.default.createElement('br',null),'  \u635F\u76CA\u6307\u6570'),width:width,fixed:print?false:"left",dataIndex:'name',key:'name'},_defineProperty(_ref,'width',width),_defineProperty(_ref,'render',function render(text,record,index){return _react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"left"},dangerouslySetInnerHTML:{__html:text}});}),_ref),{title:'Jan 一月',align:"center",width:150,children:[{title:'Actual 实际',align:"center",width:150,children:[{title:{1:"High旺季",2:"Shoulder平季",3:"Low淡季"}[~~_lodash2.default.get(dataSelect,'0.Jan',1)],align:"center",width:150,dataIndex:'Jan',key:'Jan',render:function render(text,record,index){var title=['Jan \u4E00\u6708-Actual \u5B9E\u9645'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Jan',title:title,sqlName:"_2_3",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}]}]},{title:'Feb 二月',align:"center",width:150,children:[{title:'Actual 实际',align:"center",width:150,children:[{title:{1:"High旺季",2:"Shoulder平季",3:"Low淡季"}[~~_lodash2.default.get(dataSelect,'0.Feb',1)],align:"center",width:150,dataIndex:'Feb',key:'Feb',render:function render(text,record,index){var title=['Feb \u4E8C\u6708-Actual \u5B9E\u9645'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Feb',title:title,sqlName:"_2_3",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}]}]},{title:'Mar 三月',align:"center",width:150,children:[{title:'Actual 实际',align:"center",width:150,children:[{title:{1:"High旺季",2:"Shoulder平季",3:"Low淡季"}[~~_lodash2.default.get(dataSelect,'0.Mar',1)],align:"center",width:150,dataIndex:'Mar',key:'Mar',render:function render(text,record,index){var title=['Mar \u4E09\u6708-Actual \u5B9E\u9645'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Mar',title:title,sqlName:"_2_3",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}]}]},{title:'Apr 四月',align:"center",width:150,children:[{title:'Actual 实际',align:"center",width:150,children:[{title:{1:"High旺季",2:"Shoulder平季",3:"Low淡季"}[~~_lodash2.default.get(dataSelect,'0.Apr',1)],align:"center",width:150,dataIndex:'Apr',key:'Apr',render:function render(text,record,index){var title=['Apr \u56DB\u6708-Actual \u5B9E\u9645'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Apr',title:title,sqlName:"_2_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}]}]},{title:'May 五月',align:"center",width:150,children:[{title:'Actual 实际',align:"center",width:150,children:[{title:{1:"High旺季",2:"Shoulder平季",3:"Low淡季"}[~~_lodash2.default.get(dataSelect,'0.May',1)],align:"center",width:150,dataIndex:'May',key:'May',render:function render(text,record,index){var title=['May \u4E94\u6708-Actual \u5B9E\u9645'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'May',title:title,sqlName:"_2_3",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}]}]},{title:'Jun 六月',align:"center",width:150,children:[{title:'Actual 实际',align:"center",width:150,children:[{title:{1:"High旺季",2:"Shoulder平季",3:"Low淡季"}[~~_lodash2.default.get(dataSelect,'0.Jun',1)],align:"center",width:150,dataIndex:'Jun',key:'Jun',render:function render(text,record,index){var title=['Jun \u516D\u6708-Actual \u5B9E\u9645'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Jun',title:title,sqlName:"_2_3",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}]}]},{title:'Jul 七月',align:"center",width:150,children:[{title:'Actual 实际',align:"center",width:150,children:[{title:{1:"High旺季",2:"Shoulder平季",3:"Low淡季"}[~~_lodash2.default.get(dataSelect,'0.Jul',1)],align:"center",width:150,dataIndex:'Jul',key:'Jul',render:function render(text,record,index){var title=['Jul \u4E03\u6708-Actual \u5B9E\u9645'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Jul',title:title,sqlName:"_2_3",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}]}]},{title:'Aug 八月',align:"center",width:150,children:[{title:'Actual 实际',align:"center",width:150,children:[{title:{1:"High旺季",2:"Shoulder平季",3:"Low淡季"}[~~_lodash2.default.get(dataSelect,'0.Aug',1)],align:"center",width:150,dataIndex:'Aug',key:'Aug',render:function render(text,record,index){var title=['Aug \u516B\u6708- Actual \u5B9E\u9645'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Aug',title:title,sqlName:"_2_3",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}]}]},{title:'Sep 九月',align:"center",width:150,children:[{title:'Actual 实际',align:"center",width:150,children:[{title:{1:"High旺季",2:"Shoulder平季",3:"Low淡季"}[~~_lodash2.default.get(dataSelect,'0.Sep',1)],align:"center",width:150,dataIndex:'Sep',key:'Sep',render:function render(text,record,index){var title=['Sep \u4E5D\u6708-Actual \u5B9E\u9645'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Sep',title:title,sqlName:"_2_3",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}]}]},{title:'Oct 十月',align:"center",width:150,children:[{title:'Actual 实际',align:"center",width:150,children:[{title:{1:"High旺季",2:"Shoulder平季",3:"Low淡季"}[~~_lodash2.default.get(dataSelect,'0.Oct',1)],align:"center",width:150,dataIndex:'Oct',key:'Oct',render:function render(text,record,index){var title=['Oct \u5341\u6708-Actual \u5B9E\u9645'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Oct',title:title,sqlName:"_2_3",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}]}]},{title:'Nov 十一月',align:"center",width:150,children:[{title:'Actual 实际',align:"center",width:150,children:[{title:{1:"High旺季",2:"Shoulder平季",3:"Low淡季"}[~~_lodash2.default.get(dataSelect,'0.Nov',1)],align:"center",width:150,dataIndex:'Nov',key:'Nov',render:function render(text,record,index){var title=['Nov \u5341\u4E00\u6708-Actual \u5B9E\u9645'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Nov',title:title,sqlName:"_2_3",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}]}]},{title:'Dec 十二月',align:"center",width:150,children:[{title:'Actual 实际',align:"center",width:150,children:[{title:{1:"High旺季",2:"Shoulder平季",3:"Low淡季"}[~~_lodash2.default.get(dataSelect,'0.Dec',1)],align:"center",width:150,dataIndex:'Dec',key:'Dec',render:function render(text,record,index){var title=['Dec \u5341\u4E8C\u6708-Actual \u5B9E\u9645'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Dec',title:title,sqlName:"_2_3",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}]}]},{title:_react2.default.createElement('div',null,'Whole Year Actual ',_react2.default.createElement('br',null),' \u5168\u5E74\u5B9E\u9645'),align:"center",width:200,dataIndex:'whole',key:'whole',render:function render(text,record,index){var title=['Whole Year Actual \u5168\u5E74\u5B9E\u9645'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'whole',title:title,sqlName:"_2_3",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}},{title:_react2.default.createElement('div',null,'Variance - Next Year Forecast Vs. Budget '),width:150,children:[{title:'Jan 一月',align:"center",width:150,children:[{title:'Actual 实际',width:150,align:"center",dataIndex:'nextJan',key:'nextJan',render:function render(text,record,index){var title=['Variance - Next Year Forecast Vs. Budget','Jan 一月-Actual 实际'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'nextJan',title:title,sqlName:"_2_3",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}]},{title:'Feb 二月',align:"center",width:150,children:[{title:'Actual 实际',width:150,align:"center",dataIndex:'nextFeb',key:'nextFeb',render:function render(text,record,index){var title=['Variance - Next Year Forecast Vs. Budget','Jan 二月-Actual 实际'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'nextFeb',title:title,sqlName:"_2_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}]},{title:'Mar 三月',align:"center",width:150,children:[{title:'Actual 实际',width:150,align:"center",dataIndex:'nextMar',key:'nextMar',render:function render(text,record,index){var title=['Variance - Next Year Forecast Vs. Budget','Jan 三月-Actual 实际'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'nextMar',title:title,sqlName:"_2_3",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}]},{title:'Q1 第一季度',width:150,align:"center",dataIndex:'nextQ1',key:'nextQ1',render:function render(text,record,index){var title=['Q1 第一季度'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'nextQ1',title:title,sqlName:"_2_3",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table table2_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table2_3',style:{width:this.state.print?3075:'auto'}},_react2.default.createElement(_row2.default,null,'2.3 Last Year P&L Analysis (Whole Year Actual) \u524D\u4E00\u5E74\u5EA6\u635F\u76CA\u5206\u6790 \uFF08\u53BB\u5E74\u5B9E\u9645\uFF09'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(_select2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u4EFD',style:{width:120},value:this.state.date,onChange:function onChange(str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}},this.state.dateData.map(function(x,i){return _react2.default.createElement(Option,{value:x,key:x},x);})),_react2.default.createElement(_Auth2.default,{isAdmin:true},_react2.default.createElement(_button2.default,{type:'primary',loading:loading,style:{marginLeft:10,display:this.state.print?'none':''},onClick:function onClick(){_this2.setState({loading:true},_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_compute.saveAllData)(date);case 2:_this2.setState({loading:false});case 3:case'end':return _context.stop();}}},_callee,_this2);})));}},'\u4FDD\u5B58\u6240\u6709\u9152\u5E97\u6570\u636E'))),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',className:'content',bordered:true,id:'table',pagination:false,style:{width:this.state.print?3025:'auto'},scroll:this.state.print?{}:{x:3025,y:550},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_alert2.default,{message:_react2.default.createElement('div',null,'\u8868\u683C\u5173\u8054',_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:'read_2_1'},this.props,{path:'/table/2_1'}),'2.1')),type:'info',showIcon:true,style:{display:"inline-block",marginRight:10}}),_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.onExpoetExcel},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_2_3'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.saveAllData=exports.compute=undefined;var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};__webpack_require__(10);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _data=__webpack_require__(610);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var compute=exports.compute=function compute(data){var rowNextData=['nextJan','nextFeb','nextMar'];var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};// 计算一
var rowNum=[0,1,5,6,7,9,11,13,15,17,21,24,25,26,28,29,30,31];var rowNameData=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];var _loop=function _loop(index){data[rowNum[index]].whole=rowNameData.reduce(function(a,b){a+=numConvert(data[rowNum[index]][b]);return a;},0);data[rowNum[index]].nextQ1=rowNextData.reduce(function(a,b){a+=numConvert(data[rowNum[index]][b]);return a;},0);data[rowNum[index]].whole.toFixed(2);data[rowNum[index]].nextQ1.toFixed(2);};for(var index=0;index<rowNum.length;index++){_loop(index);}// 计算二
var nameData=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec','nextJan','nextFeb','nextMar','whole','nextQ1'];for(var index=0;index<nameData.length;index++){// 提前计算毛利润 GOP
//  GOP
data[22][nameData[index]]=(numConvert(data[8][nameData[index]])==0?0:numConvert(data[21][nameData[index]])/numConvert(data[8][nameData[index]])).toFixed(3);//  盈亏平衡点/总费用
data[23][nameData[index]]=(numConvert(data[8][nameData[index]])-numConvert(data[21][nameData[index]])).toFixed(2);// 客房率
data[2][nameData[index]]=(numConvert(data[0][nameData[index]])==0?0:numConvert(data[1][nameData[index]])/numConvert(data[0][nameData[index]])).toFixed(3);// 平均房价
data[3][nameData[index]]=(numConvert(data[1][nameData[index]])==0?0:numConvert(data[5][nameData[index]])/numConvert(data[1][nameData[index]])).toFixed(2);// 平均收入
data[4][nameData[index]]=(numConvert(data[0][nameData[index]])==0?0:numConvert(data[5][nameData[index]])/numConvert(data[0][nameData[index]])).toFixed(2);// 总收入
data[8][nameData[index]]=(numConvert(data[7][nameData[index]])+numConvert(data[6][nameData[index]])+numConvert(data[5][nameData[index]])).toFixed(2);// 客房部门利润百分比
data[10][nameData[index]]=(numConvert(data[5][nameData[index]])==0?0:numConvert(data[9][nameData[index]])/numConvert(data[5][nameData[index]])).toFixed(3);// 餐饮部门利润百分比
data[12][nameData[index]]=(numConvert(data[6][nameData[index]])==0?0:numConvert(data[11][nameData[index]])/numConvert(data[6][nameData[index]])).toFixed(3);// 食品成本百分比
data[14][nameData[index]]=(numConvert(data[6][nameData[index]])==0?0:numConvert(data[13][nameData[index]])/numConvert(data[6][nameData[index]])).toFixed(3);// 人力资源成本
data[16][nameData[index]]=(numConvert(data[8][nameData[index]])==0?0:numConvert(data[15][nameData[index]])/numConvert(data[8][nameData[index]])).toFixed(3);// 能源成本
data[18][nameData[index]]=(numConvert(data[8][nameData[index]])==0?0:numConvert(data[17][nameData[index]])/numConvert(data[8][nameData[index]])).toFixed(3);// 其他费用成本
data[19][nameData[index]]=(numConvert(data[23][nameData[index]])-numConvert(data[17][nameData[index]])-numConvert(data[15][nameData[index]])-numConvert(data[13][nameData[index]])).toFixed(2);// 其他费用成本率
data[20][nameData[index]]=(numConvert(data[8][nameData[index]])==0?0:numConvert(data[19][nameData[index]])/numConvert(data[8][nameData[index]])).toFixed(3);// 总收费
data[27][nameData[index]]=(numConvert(data[26][nameData[index]])+numConvert(data[25][nameData[index]])+numConvert(data[24][nameData[index]])).toFixed(2);}return data;};var saveAllData=exports.saveAllData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(year){var _ref2,hotels,_loop2,i;return _regenerator2.default.wrap(function _callee$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return(0,_request2.default)('/getHotels');case 2:_ref2=_context2.sent;hotels=_ref2.data.hotels;_loop2=/*#__PURE__*/_regenerator2.default.mark(function _loop2(i){var item,dataDefault,data,dataSelect,_ref3,x,msg,dataFrom,headres;return _regenerator2.default.wrap(function _loop2$(_context){while(1){switch(_context.prev=_context.next){case 0:item=hotels[i];//  获取当前酒店数据   
dataDefault=_lodash2.default.cloneDeep(_data.data2_3);data=dataDefault.filter(function(x,i){return i!=0;});dataSelect=dataDefault.filter(function(x,i){return i==0;});_context.next=6;return(0,_request2.default)("/_2_3_info?year="+year+"&comid="+item.id);case 6:_ref3=_context.sent;x=_ref3.data;msg=_ref3.msg;if(x&&x.length>0){data=x.filter(function(x,i){return i!=0;});dataSelect=x.filter(function(x,i){return i==0;});}if(msg.last&&msg.last.length){data=msg.last.filter(function(x,i){return i!=0;}).map(function(v,i){delete v.id;delete v.month;if(data[i].id)v.id=data[i].id;return _extends({},v,{'nextJan':_lodash2.default.get(msg.data2_1,i+1+".Jan"),'nextFeb':_lodash2.default.get(msg.data2_1,i+1+".Feb"),'nextMar':_lodash2.default.get(msg.data2_1,i+1+".Mar")});});dataSelect=msg.last.filter(function(x,i){return i==0;}).map(function(v,i){delete v.id;delete v.month;if(dataSelect[i].id)v.id=dataSelect[i].id;return v;});}data=compute(data);dataFrom=new FormData();dataFrom.append('data',JSON.stringify([].concat(_toConsumableArray(dataSelect),_toConsumableArray(data)).map(function(x){return _extends({},x,{year:year,comid:item.id});})));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context.next=17;return(0,_request2.default)('/add_2_3',headres);case 17:case"end":return _context.stop();}}},_loop2,undefined);});i=0;case 6:if(!(i<hotels.length)){_context2.next=11;break;}return _context2.delegateYield(_loop2(i),"t0",8);case 8:i++;_context2.next=6;break;case 11:_message3.default.success('保存成功！');case 12:case"end":return _context2.stop();}}},_callee,undefined);}));return function saveAllData(_x2){return _ref.apply(this,arguments);};}();

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(25);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(1495);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TextArea=_input2.default.TextArea;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var dataBegin,data1_1,dataBegin1,data2_2,dataBegin2,data3,dataBegin3,data4;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dataBegin=JSON.stringify(_data.data3_2_1);data1_1=JSON.parse(dataBegin);dataBegin1=JSON.stringify(_data.data1);data2_2=JSON.parse(dataBegin1);dataBegin2=JSON.stringify(_data.data1);data3=JSON.parse(dataBegin2);dataBegin3=JSON.stringify(_data.data2);data4=JSON.parse(dataBegin3);fetch('/_2_7_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data._2_7_00&&x.data._2_7_00.length>0){data1_1=x.data._2_7_00;}if(x.data._2_7_01&&x.data._2_7_01.length>0){data2_2=x.data._2_7_01;}if(x.data._2_7_02&&x.data._2_7_02.length>0){data3=x.data._2_7_02;}if(x.data._2_7_03&&x.data._2_7_03.length>0){data4=x.data._2_7_03;}_this.setState({loading:false,data3_1:x.data._3_1_1||[],data1:data1_1,data2:data2_2,data3:data3,data4:data4,data5:x.data._2_7_1||[]});}).catch(function(err){_this.setState({loading:false});console.error(err);});case 9:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x2){return _ref.apply(this,arguments);};}();_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data1=_this.state.data1.map(function(x){return _extends({},x,{year:year,month:month});});var data2=_this.state.data2.map(function(x){return _extends({},x,{year:year,month:month});});var data3=_this.state.data3.map(function(x){return _extends({},x,{year:year,month:month});});var data4=_this.state.data4.map(function(x){return _extends({},x,{year:year,month:month});});var data5=_this.state.data5.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify({_2_7_00:data1,_2_7_01:data2,_2_7_02:data3,_2_7_03:data4,_2_7_1:data5}));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_2_7',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data1[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table2_7',1.5,'3.10',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data1:[],data2:[],data3:[],data4:[],data5:[],data3_1:[],loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);// this.computeNum(this.state.data)
}},{key:'render',value:function render(){var _this3=this;var data=this.state.data;var width=document.body.offsetWidth-1250>300?document.body.offsetWidth-1250:300;var columns=[{title:'Comp Set 竞争集群',dataIndex:'name',key:'name',align:"center",width:300,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding ',style:{textAlign:"left"}},text);}},{title:_react2.default.createElement('div',null,'Score'),dataIndex:'score',key:'score',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));var data=_this3.state.data1;data[index].score=value;_this3.setState({data1:data});}}));}},{title:_react2.default.createElement('div',null,'Action Plan \u884C\u52A8\u8BA1\u5212  ',_react2.default.createElement('br',null),'(Please clarify, if the scores are less than 4.5. \u82E5\u5206\u6570\u5C0F\u4E8E4.5\uFF0C\u9700\u89E3\u91CA)'),dataIndex:'action_plan',key:'action_plan',align:"center",width:350,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";var data=_this3.state.data1;data[index].action_plan=value;_this3.setState({data1:data});}}));}}];var columns1=[{title:_react2.default.createElement('div',null,'Best Comments Top 3 \u6700\u4F73\u8BC4\u8BBA\u524D\u4E09\u4F4D'),dataIndex:'name',key:'name',align:"center",width:300,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";var data=_this3.state.data2;data[index].name=value;data[index].name_code=value;_this3.setState({data2:data});}}));}},{title:_react2.default.createElement('div',null,'Action Plan \u884C\u52A8\u8BA1\u5212'),dataIndex:'action_plan',key:'action_plan',align:"center",width:500,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";var data=_this3.state.data2;data[index].action_plan=value;_this3.setState({data2:data});}}));}}];var columns2=[{title:_react2.default.createElement('div',null,'Worst Comments Top 3 \u6700\u5DEE\u8BC4\u8BBA\u524D\u4E09\u4F4D'),dataIndex:'name',key:'name',align:"center",width:300,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";var data=_this3.state.data3;data[index].name=value;data[index].name_code=value;_this3.setState({data3:data});}}));}},{title:_react2.default.createElement('div',null,'Action Plan \u884C\u52A8\u8BA1\u5212'),dataIndex:'action_plan',key:'action_plan',align:"center",width:500,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";var data=_this3.state.data3;data[index].action_plan=value;_this3.setState({data3:data});}}));}}];var columns3=[{title:'Online Channel 在线评论渠道',dataIndex:'name',key:'name',align:"center",render:function render(text,record,index){if([1,2].includes(index)){return{props:{rowSpan:0}};}return _react2.default.createElement('div',{className:'table-padding ',style:{textAlign:"left"}},text);}},{title:'Monitor Index (Current Situation) 监督指数（当前状态）',dataIndex:'monitor_index',key:'monitor_index',align:"center",width:500,render:function render(text,record,index){if([1,2].includes(index)){return{props:{rowSpan:0}};}return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:'table-padding',style:{textAlign:"left",height:"50%",padding:"10px"}},record.monitor_index1),_react2.default.createElement('div',{className:'table-padding ',style:{textAlign:"left",height:"50%",borderTop:'1px solid #dcdcdc',padding:"10px"}},record.monitor_index2));}},{title:_react2.default.createElement('div',null,this.state.data3_1[0]?this.state.data3_1[0].name:""),dataIndex:'col1',key:'col1',align:"center",width:150,render:function render(text,record,index){if([1,2].includes(index)){return{props:{rowSpan:0}};}return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:record.col11,onBlur:function onBlur(e){var value=e.target.value||"";var data=_this3.state.data4;data[index].col11=value;_this3.setState({data4:data});}}),_react2.default.createElement('br',null),_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:record.col12,style:{marginTop:10},onBlur:function onBlur(e){var value=e.target.value||"";var data=_this3.state.data4;data[index].col12=value;_this3.setState({data4:data});}}));}},{title:_react2.default.createElement('div',null,this.state.data3_1[1]?this.state.data3_1[1].name:""),dataIndex:'col2',key:'col2',align:"center",width:150,render:function render(text,record,index){if([1,2].includes(index)){return{props:{rowSpan:0}};}return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:record.col21,onBlur:function onBlur(e){var value=e.target.value||"";var data=_this3.state.data4;data[index].col21=value;_this3.setState({data4:data});}}),_react2.default.createElement('br',null),_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:record.col22,style:{marginTop:10},onBlur:function onBlur(e){var value=e.target.value||"";var data=_this3.state.data4;data[index].col22=value;_this3.setState({data4:data});}}));}},{title:_react2.default.createElement('div',null,this.state.data3_1[2]?this.state.data3_1[2].name:""),dataIndex:'col3',key:'col3',align:"center",width:150,render:function render(text,record,index){if([1,2].includes(index)){return{props:{rowSpan:0}};}return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:record.col31,onBlur:function onBlur(e){var value=e.target.value||"";var data=_this3.state.data4;data[index].col31=value;_this3.setState({data4:data});}}),_react2.default.createElement('br',null),_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:record.col32,style:{marginTop:10},onBlur:function onBlur(e){var value=e.target.value||"";var data=_this3.state.data4;data[index].col32=value;_this3.setState({data4:data});}}));}},{title:_react2.default.createElement('div',null,this.state.data3_1[3]?this.state.data3_1[3].name:""),dataIndex:'col4',key:'col4',align:"center",width:150,render:function render(text,record,index){if([1,2].includes(index)){return{props:{rowSpan:0}};}return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:record.col41,onBlur:function onBlur(e){var value=e.target.value||"";var data=_this3.state.data4;data[index].col41=value;_this3.setState({data4:data});}}),_react2.default.createElement('br',null),_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:record.col42,style:{marginTop:10},onBlur:function onBlur(e){var value=e.target.value||"";var data=_this3.state.data4;data[index].col42=value;_this3.setState({data4:data});}}));}},{title:_react2.default.createElement('div',null,this.state.data3_1[4]?this.state.data3_1[4].name:""),dataIndex:'col5',key:'col5',align:"center",width:150,render:function render(text,record,index){if([1,2].includes(index)){return{props:{rowSpan:0}};}return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:record.col51,onBlur:function onBlur(e){var value=e.target.value||"";var data=_this3.state.data4;data[index].col51=value;_this3.setState({data4:data});}}),_react2.default.createElement('br',null),_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:record.col52,style:{marginTop:10},onBlur:function onBlur(e){var value=e.target.value||"";var data=_this3.state.data4;data[index].col52=value;_this3.setState({data4:data});}}));}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table2_7'},_react2.default.createElement(_row2.default,null,'3.1 Online Guest Comments \u987E\u5BA2\u5728\u7EBF\u8BC4\u8BBA'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data1:[],data2:[],data3:[],data4:[],data5:[],data3_1:[],loading:true});_this3.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:this.state.data1,size:'middle',bordered:true,pagination:false,className:'content',scroll:{x:false},style:{width:800},rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_table2.default,{columns:columns1,dataSource:this.state.data2,size:'middle',bordered:true,pagination:false,scroll:{x:false},style:{width:800},rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_table2.default,{columns:columns2,dataSource:this.state.data3,size:'middle',bordered:true,pagination:false,scroll:{x:false},style:{width:800},rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_table2.default,{columns:columns3,dataSource:this.state.data4,size:'middle',bordered:true,pagination:false,rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_row2.default,{style:{marginTop:20}},_react2.default.createElement(TextArea,{autosize:{minRows:4},value:this.state.data5[0]?this.state.data5[0].comments:"",placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',style:{marginTop:10},onChange:function onChange(e){_this3.setState({data5:[_extends({},_this3.state.data5[0],{comments:e.target.value})]});}}))),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_2_7'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},loading:this.state.print,onClick:this.downloadSG},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data3_2_1=exports.data3_2_1=[{name:'Overall Review Rating 总体评论分数',name_code:'Overall_Review_Rating',score:'0',action_plan:""},{name:'Total Reviews 评论总数',name_code:'Total_Reviews',score:'0',action_plan:""},{name:'Location 地点',name_code:'Location',score:'0',action_plan:""},{name:'Rooms 客房',name_code:'Rooms',score:'0',action_plan:""},{name:'Cleanliness 整洁度',name_code:'Cleanliness',score:'0',action_plan:""},{name:'Service 服务',name_code:'Service',score:'0',action_plan:""},{name:'Value 价值',name_code:'Value',score:'0',action_plan:""}];var data1=exports.data1=[{name:"",name_code:"",action_plan:""},{name:"",name_code:"",action_plan:""},{name:"",name_code:"",action_plan:""}];var data2=exports.data2=[{name:"Tripadvisor.com",name_code:"Tripadvisor.com",monitor_index2:"Stars (Example 4.0 of 5) 旅游者评星",monitor_index1:"Ranked X of XXX Hotels 城市总排名",col11:"",col12:"",col21:"",col22:"",col31:"",col32:"",col41:"",col42:"",col51:"",col52:""},{name:"Daodao.com 道道网",name_code:"Daodao.com",monitor_index2:"Stars (Example 4.0 of 5) 旅游者评分总分五分",monitor_index1:"Ranked #X of XXX Hotels 城市总排名",col11:"",col12:"",col21:"",col22:"",col31:"",col32:"",col41:"",col42:"",col51:"",col52:""},{name:"Lvping.com 驴评网",name_code:"Lvping.com",monitor_index2:"Traveler's Rating 驴评用户评星数",monitor_index1:"Ranked #X of XXX Hotels 城市总排名",col11:"",col12:"",col21:"",col22:"",col31:"",col32:"",col41:"",col42:"",col51:"",col52:""},{name:"Ctrip 携程 (Chinese Site/中文网站）",name_code:"Ctrip 携程 (Chinese Site/中文网站）",monitor_index2:"Guest Review Rating 客户评分数，总分五分",monitor_index1:"Gold/Silver Medal 金银牌",col11:"",col12:"",col21:"",col22:"",col31:"",col32:"",col41:"",col42:"",col51:"",col52:""},{name:"Elong 艺龙 (Chinese Site/中文网站）",name_code:"Elong 艺龙 (Chinese Site/中文网站）",monitor_index2:"Traveler's Rating 艺龙用户评定金牌数",monitor_index1:"Crown/Diamond 皇冠钻石",col11:"",col12:"",col21:"",col22:"",col31:"",col32:"",col41:"",col42:"",col51:"",col52:""},{name:"Booking.com",name_code:"Booking.com",monitor_index2:"Guest Review Rating 客户评分数，总分十分",monitor_index1:"Preferred Placement - 1st Page (Thumb Up) 第一页优先排名",col11:"",col12:"",col21:"",col22:"",col31:"",col32:"",col41:"",col42:"",col51:"",col52:""},{name:"Agoda.com 雅高达",name_code:"Agoda.com 雅高达",monitor_index2:"Guest Review Rating 客户评分数，总分十分",monitor_index1:"Preferred Placement - 1st Page 第一页优先排名",col11:"",col12:"",col21:"",col22:"",col31:"",col32:"",col41:"",col42:"",col51:"",col52:""},{name:"Expedia.com",name_code:"Expedia.com",monitor_index2:"Guest Review Rating 客户评分数，总分五分",monitor_index1:"Preferred Placement - 1st Page 第一页优先排名",col11:"",col12:"",col21:"",col22:"",col31:"",col32:"",col41:"",col42:"",col51:"",col52:""}];

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(1497);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var totalName=['actual','budget'];totalName.forEach(function(name){data[12][name]=data.reduce(function(a,b,i){if(i!=12){a+=numConvert(b[name]);}return a;},0).toFixed(2);});data.forEach(function(item,i){data[i].var=(numConvert(data[i].actual)-numConvert(data[i].budget)).toFixed(2);data[i].completion=numConvert(data[i].budget)==0?0:(numConvert(data[i].actual)/numConvert(data[i].budget)).toFixed(2);});console.log(data);_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var dataBegin,data;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dataBegin=JSON.stringify(_data.data3_2_1);data=JSON.parse(dataBegin);fetch('/_2_8new_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month=null',{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x2){return _ref.apply(this,arguments);};}();_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year});});// if (!data.every(x => x.name)) {
//     message.error('名称不能为空，请到3-1-1设置名称！');
//     return
// }
var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_2_8new',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table3_2_1',1.5,'3.20',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this3=this;var data=this.state.data;var columns=[{title:'Month 月份',dataIndex:'name',key:'name',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding',style:{textAlign:"left"}},text);}},{title:'Current Year Actual 本年实际',dataIndex:'actual',key:'actual',align:"center",width:150,render:function render(text,record,index){var title=['Current Year Actual 本年实际'];var props={index:index,key:'actual',title:title,sqlName:"_2_8new",name:'actual',type:index==12?'number':'inputNumber',text:text,onChange:_this3.onChange};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Current Year Target 本年预算/目标',dataIndex:'budget',key:'budget',align:"center",width:150,render:function render(text,record,index){var title=['Current Year Target 本年预算/目标'];var props={index:index,name:'budget',title:title,sqlName:"_2_8new",type:index==12?'number':'inputNumber',text:text,onChange:_this3.onChange};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Variance - Actual Vs Budget 差异',dataIndex:'var',key:'var',align:"center",width:150,render:function render(text,record,index){var title=['Variance - Actual Vs Budget 差异'];var props={index:index,name:'var',title:title,sqlName:"_2_8new",type:'number',text:text,onChange:_this3.onChange};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Completion % 完成百分比',dataIndex:'completion',key:'completion',align:"center",width:150,render:function render(text,record,index){var title=['Completion % 完成百分比'];var props={index:index,name:'completion',title:title,sqlName:"_2_8new",type:'percent',text:text,onChange:_this3.onChange};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table3_2_1'},_react2.default.createElement(_row2.default,null,'3.2 Wyndham Rewards Enrollment \u6E29\u5FB7\u59C6\u5956\u8D4F\u8BA1\u5212\u65B0\u4F1A\u5458\u52A0\u5165'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,'YYYY-MM'),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',scroll:this.state.print?{}:{y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_2_8'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data3_2_1=exports.data3_2_1=[{name:"Jan 一月",actual:0,budget:0,var:0,completion:0},{name:"Feb 二月",actual:0,budget:0,var:0,completion:0},{name:"Mar 三月",actual:0,budget:0,var:0,completion:0},{name:"Apr 四月",actual:0,budget:0,var:0,completion:0},{name:"May 五月",actual:0,budget:0,var:0,completion:0},{name:"Jun 六月",actual:0,budget:0,var:0,completion:0},{name:"Jul 七月",actual:0,budget:0,var:0,completion:0},{name:"Aug 八月",actual:0,budget:0,var:0,completion:0},{name:"Sep 九月",actual:0,budget:0,var:0,completion:0},{name:"Oct 十月",actual:0,budget:0,var:0,completion:0},{name:"Nov 十一月",actual:0,budget:0,var:0,completion:0},{name:"Dec 十二月",actual:0,budget:0,var:0,completion:0},{name:"YTD 年累计",actual:0,budget:0,var:0,completion:0}];

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.index=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _=__webpack_require__(1499);var _2=_interopRequireDefault(_);var _3=__webpack_require__(1501);var _4=_interopRequireDefault(_3);var _5=__webpack_require__(1503);var _6=_interopRequireDefault(_5);var _7=__webpack_require__(1505);var _8=_interopRequireDefault(_7);var _9=__webpack_require__(1507);var _10=_interopRequireDefault(_9);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Table3_1_3 from "./3-1-3";
// import Table3_1_6 from "./3-1-6";
var index=exports.index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",null,_react2.default.createElement(_2.default,this.props),_react2.default.createElement(_4.default,this.props),_react2.default.createElement(_6.default,this.props),_react2.default.createElement(_8.default,this.props),_react2.default.createElement(_10.default,this.props));}}]);return index;}(_react.Component);;exports.default=index;

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _tooltip=__webpack_require__(87);var _tooltip2=_interopRequireDefault(_tooltip);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(25);__webpack_require__(100);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(1500);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(290);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var len=data.length;// 计算总值 
var total={name:'Total',name_code:"Rooms_Available",rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:"-",mpi_ranking:'-',ari:"-",ari_ranking:'-',rgi:"-",rgi_ranking:'-'// year: 2018,
// month: 5
};for(var i in data){if(i<5){total['rooms']+=Number(data[i]['rooms']);total['rooms_avaliable']+=Number(data[i]['rooms_avaliable']);total['rooms_sold']+=Number(data[i]['rooms_sold']);total['revn']+=Number(data[i]['revn']);}}// console.log(total);
total['occ']=Number(total['rooms_avaliable'])==0?0:(Number(total['rooms_sold'])/Number(total['rooms_avaliable'])*100).toFixed(2)+'%';total['avg_rate']=Number(total['rooms_sold'])==0?0:(Number(total['revn'])/Number(total['rooms_sold'])).toFixed(2);total['revpar']=Number(total['rooms_avaliable'])==0?0:(Number(total['revn'])/Number(total['rooms_avaliable'])).toFixed(2);var mpi=[];var ari=[];var rgi=[];for(var _i in data){if(_i<5){//客房率
data[_i]['occ']=(Number(data[_i]['rooms_avaliable'])==0?0:Number(data[_i]['rooms_sold'])/Number(data[_i]['rooms_avaliable'])*100).toFixed(2)+'%';//平均房价
data[_i]['avg_rate']=(Number(data[_i]['rooms_sold'])==0?0:Number(data[_i]['revn'])/Number(data[_i]['rooms_sold'])).toFixed(2);//可售房平均收入
data[_i]['revpar']=(Number(data[_i]['rooms_avaliable'])==0?0:Number(data[_i]['revn'])/Number(data[_i]['rooms_avaliable'])).toFixed(2);//市场渗透率
data[_i]['mpi']=Number(total['occ'])==0?0:(parseFloat(data[_i]['occ'])/parseFloat(total['occ'])).toFixed(2);mpi.push({data:data[_i]['mpi'],key:_i});//排名
//平均房价指数
data[_i]['ari']=Number(total['avg_rate'])==0?0:(Number(data[_i]['avg_rate'])/Number(total['avg_rate'])).toFixed(2);ari.push({data:data[_i]['ari'],key:_i});//排名
//RGI收益率
data[_i]['rgi']=Number(total['revpar'])==0?0:(Number(data[_i]['revpar'])/Number(total['revpar'])).toFixed(2);rgi.push({data:data[_i]['rgi'],key:_i});}}data[5]=total;// 计算排名
mpi.sort(function(a,b){return b.data-a.data;});ari.sort(function(a,b){return b.data-a.data;});rgi.sort(function(a,b){return b.data-a.data;});mpi.forEach(function(x,i){data[x.key].mpi_ranking=i+1;});ari.forEach(function(x,i){data[x.key].ari_ranking=i+1;});rgi.forEach(function(x,i){data[x.key].rgi_ranking=i+1;});_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;// console.log(data);return;
// this.setState({
//     data
// });
_this.computeNum(data);};_this.getTable3_1_1=function(date){var dataBegin=JSON.stringify(_data.data3_1_1);var data=JSON.parse(dataBegin);fetch('/_3_1_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}else{var hotel_name=sessionStorage.getItem('hotelName');data[0].name=hotel_name||x.msg;}if(!data[0].id){_this.setState({loading:false,data:data},function(){_this.onSave();});return;}_this.setState({data:data,loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();// console.log(data)
// 删除total这列数据
data.pop();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_3_1_1',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getTable3_1_1(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){console.error(err);var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table3_1_1',1.5,'4.61',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.onExpoetExcel=function(){_this.setState({print:true,loading:true},function(){var name='MTD This Year \u672C\u5E74\u5F53\u6708 '+(0,_moment2.default)(_this.state.date).format('YYYY-MM');var innerHtml='\n              <caption>'+name+'</caption>\n              '+document.getElementById('table4_6_1').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n            ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,name+'.xls');_this.setState({print:false,loading:false});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.setState({loading:true});this.getTable3_1_1(this.state.date);}// 表格里面一些需要计算的数据
// 从后台取出表格3_1_1的数据
},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var print=this.state.print;var totalData=[5];var columns=[{align:"center",title:_react2.default.createElement('div',null,'Hotel ',_react2.default.createElement('br',null),' \u9152\u5E97'),dataIndex:'name',key:'name',className:"textLimit-td",width:300,render:function render(text,record,index){if(index==5||index==0||print){return _react2.default.createElement('div',{className:'table-color textLimit  '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"left"}},_react2.default.createElement(_tooltip2.default,{title:text},text));}return _react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer table-color table-color-number':'table-color table-color-number'),style:{textAlign:"left"}},_react2.default.createElement(_input2.default,{className:'input-width',defaultValue:text,onBlur:function onBlur(e){var value=e.target.value;_this2.onChange('name',value,index);}// onChange={(value) => {
//     this.onChange('actual', value, index)
// }}
}));}},{align:"center",title:_react2.default.createElement('div',null,'Rooms ',_react2.default.createElement('br',null),' \u5BA2\u623F\u6570'),dataIndex:'rooms',key:'rooms',width:100,render:function render(text,record,index){var title=['Rooms 客房数'];if(index==5||print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rooms',title:title,sqlName:"_3_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rooms',title:title,sqlName:"_3_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('rooms',value,index);}})));}},{align:"center",title:_react2.default.createElement('div',null,'Rms Avaliable ',_react2.default.createElement('br',null),' \u53EF\u552E\u5BA2\u623F\u6570'),dataIndex:'rooms_avaliable',key:'rooms_avaliable',width:100,render:function render(text,record,index){var title=['Rms Avaliable 可售客房数'];if(index==5||print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rooms_avaliable',title:title,sqlName:"_3_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rooms_avaliable',title:title,sqlName:"_3_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('rooms_avaliable',value,index);}// onChange={(value) => {
//     this.onChange('actual', value, index)
// }}
})));}},{align:"center",title:_react2.default.createElement('div',null,'Rms Sold ',_react2.default.createElement('br',null),' \u552E\u51FA\u623F\u6570'),dataIndex:'rooms_sold',key:'rooms_sold',width:100,render:function render(text,record,index){var title=['Rms Sold 售出房数'];if(index==5||print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rooms_sold',title:title,sqlName:"_3_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rooms_sold',title:title,sqlName:"_3_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('rooms_sold',value,index);}// onChange={(value) => {
//     this.onChange('actual', value, index)
// }}
})));}},{align:"center",title:_react2.default.createElement('div',null,'OCC ',_react2.default.createElement('br',null),' \u5BA2\u623F\u7387'),dataIndex:'occ',key:'occ',width:100,render:function render(text,record,index){var title=['OCC 客房率'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'occ',title:title,sqlName:"_3_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}},{align:"center",title:_react2.default.createElement('div',null,'Revn ',_react2.default.createElement('br',null),' \u5BA2\u623F\u6536\u5165'),dataIndex:'revn',key:'revn',width:100,render:function render(text,record,index){var title=['Revn 客房收入'];if(index==5||print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revn',title:title,sqlName:"_3_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revn',title:title,sqlName:"_3_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('revn',value,index);}// onChange={(value) => {
//     this.onChange('actual', value, index)
// }}
})));}},{align:"center",title:_react2.default.createElement('div',null,'Avg Rate ',_react2.default.createElement('br',null),' \u5E73\u5747\u623F\u4EF7'),dataIndex:'avg_rate',key:'avg_rate',width:100,render:function render(text,record,index){var title=['Avg Rate 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'avg_rate',title:title,sqlName:"_3_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{align:"center",title:_react2.default.createElement('div',null,'RevPAR ',_react2.default.createElement('br',null),' \u53EF\u552E\u623F\u5E73\u5747\u6536\u5165'),dataIndex:'revpar',key:'revpar',width:100,render:function render(text,record,index){var title=['RevPAR 可售房平均收入'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revpar',title:title,sqlName:"_3_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{align:"center",title:_react2.default.createElement('div',null,'MPI ',_react2.default.createElement('br',null),' \u5E02\u573A\u6E17\u900F\u7387\u6307\u6570'),dataIndex:'mpi',key:'mpi',width:100,render:function render(text,record,index){var title=['MPI 市场渗透率指数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'mpi',title:title,sqlName:"_3_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text||""));}},{align:"center",title:_react2.default.createElement('div',null,'Ranking ',_react2.default.createElement('br',null),' \u6392\u540D'),dataIndex:'mpi_ranking',key:'mpi_ranking',width:100,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'mpi_ranking',title:title,sqlName:"_3_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}},{align:"center",title:_react2.default.createElement('div',null,'ARI ',_react2.default.createElement('br',null),' \u5E73\u5747\u623F\u4EF7\u6307\u6570'),dataIndex:'ari',key:'ari',width:100,render:function render(text,record,index){var title=['ARI 平均房价指数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ari',title:title,sqlName:"_3_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}},{align:"center",title:_react2.default.createElement('div',null,'Ranking ',_react2.default.createElement('br',null),' \u6392\u540D'),dataIndex:'ari_ranking',key:'ari_ranking',width:100,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ari_ranking',title:title,sqlName:"_3_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}},{align:"center",title:_react2.default.createElement('div',null,'RGI ',_react2.default.createElement('br',null),' \u6536\u76CA\u7387\u6307\u6570'),dataIndex:'rgi',key:'rgi',width:100,render:function render(text,record,index){var title=['RGI 收益率指数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rgi',title:title,sqlName:"_3_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}},{align:"center",width:100,title:_react2.default.createElement('div',null,'Ranking ',_react2.default.createElement('br',null),' \u6392\u540D'),dataIndex:'rgi_ranking',key:'rgi_ranking',render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rgi_ranking',title:title,sqlName:"_3_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table'},_react2.default.createElement(_row2.default,{className:'title',id:'table3_1_1'},_react2.default.createElement(_row2.default,null,'4.6 Rooms KPI Analysis \u5BA2\u623F\u5173\u952E\u7EE9\u6548\u6307\u6570\u5206\u6790'),_react2.default.createElement(_row2.default,{className:'vice-title'},'4.6.1 MTD This Year \u672C\u5E74\u5F53\u6708'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,'YYYY-MM'),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getTable3_1_1(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',className:'content',bordered:true,id:'table4_6_1',pagination:false,rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.onExpoetExcel},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_3_1'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(290);var _data2=__webpack_require__(1502);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data,data3_1_2){// var data3_1_2 = this.state.data3_1_2;
var len=data.length;// 计算总值 
var total={name:'Total',name_code:"Rooms_Available",rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:"-",mpi_ranking:'-',ari:"-",ari_ranking:'-',rgi:"-",rgi_ranking:'-'// year: 2018,
// month: 5
};for(var i in data){if(i<5){//可售房rooms_avaliable 售出房数rooms_sold 客房收入renv 使用data3_1_2的数据
data[i]['rooms_avaliable']=data3_1_2[i]['rooms_avaliable'];data[i]['rooms_sold']=data3_1_2[i]['rooms_sold'];data[i]['revn']=data3_1_2[i]['revn'];total['rooms']+=Number(data[i]['rooms']);total['rooms_avaliable']+=Number(data[i]['rooms_avaliable']);total['rooms_sold']+=Number(data[i]['rooms_sold']);total['revn']+=Number(data[i]['revn']);}}// console.log(total);
total['occ']=Number(total['rooms_avaliable'])==0?0:(Number(total['rooms_sold'])/Number(total['rooms_avaliable'])*100).toFixed(2)+'%';total['avg_rate']=Number(total['rooms_sold'])==0?0:(Number(total['revn'])/Number(total['rooms_sold'])).toFixed(2);total['revpar']=Number(total['rooms_avaliable'])==0?0:(Number(total['revn'])/Number(total['rooms_avaliable'])).toFixed(2);var mpi=[];var ari=[];var rgi=[];for(var _i in data){if(_i<5){//客房率
data[_i]['occ']=(Number(data[_i]['rooms_avaliable'])==0?0:Number(data[_i]['rooms_sold'])/Number(data[_i]['rooms_avaliable'])*100).toFixed(2)+'%';//平均房价
data[_i]['avg_rate']=(Number(data[_i]['rooms_sold'])==0?0:Number(data[_i]['revn'])/Number(data[_i]['rooms_sold'])).toFixed(2);//可售房平均收入
data[_i]['revpar']=(Number(data[_i]['rooms_avaliable'])==0?0:Number(data[_i]['revn'])/Number(data[_i]['rooms_avaliable'])).toFixed(2);//市场渗透率
data[_i]['mpi']=Number(total['occ'])==0?0:(parseFloat(data[_i]['occ'])/parseFloat(total['occ'])).toFixed(2);mpi.push({data:data[_i]['mpi'],key:_i});//排名
//平均房价指数
data[_i]['ari']=Number(total['avg_rate'])==0?0:(Number(data[_i]['avg_rate'])/Number(total['avg_rate'])).toFixed(2);ari.push({data:data[_i]['ari'],key:_i});//排名
//RGI收益率
data[_i]['rgi']=Number(total['revpar'])==0?0:(Number(data[_i]['revpar'])/Number(total['revpar'])).toFixed(2);rgi.push({data:data[_i]['rgi'],key:_i});}}data[5]=total;// 计算排名
mpi.sort(function(a,b){return b.data-a.data;});ari.sort(function(a,b){return b.data-a.data;});rgi.sort(function(a,b){return b.data-a.data;});mpi.forEach(function(x,i){data[x.key].mpi_ranking=i+1;});ari.forEach(function(x,i){data[x.key].ari_ranking=i+1;});rgi.forEach(function(x,i){data[x.key].rgi_ranking=i+1;});if(data3_1_2[0]&&data3_1_2[0].id){data.forEach(function(item,i){if(i<=4){data[i].id=data3_1_2[i].id;}});}_this.setState({data:data});// console.log(data)
};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;// this.setState({
//     data
// });
// this.setState({data})
// console.log(data,'3333');
// return
_this.computeNum(_this.state.data3_1_1,data);};_this.getTable3_1_1=function(date){var dataBegin=JSON.stringify(_data.data3_1_1);var data=JSON.parse(dataBegin);fetch('/_3_1_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=data.map(function(item,i){if(i<=4&&x.data[i].name){return _extends({},item,{name:x.data[i].name,rooms:x.data[i].rooms});}else{return item;}});}_this.setState({data3_1_1:data},function(){_this.getTable3_1_2(date);});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.getTable3_1_2=function(date){var dataBegin=JSON.stringify(_data2.data3_1_2_default);var data3_1_2=JSON.parse(dataBegin);fetch('/_3_1_2_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data3_1_2=x.data;}_this.setState({data3_1_2:data3_1_2,loading:false});_this.computeNum(_this.state.data3_1_1,data3_1_2);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();// 删除total这列数据
data.pop();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_3_1_2',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getTable3_1_1(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败'+JSON.stringify(err));console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table3_1_2',1.5,'4.62',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.onExpoetExcel=function(){_this.setState({print:true,loading:true},function(){var name='MTD Last Year \u53BB\u5E74\u5F53\u6708 '+(0,_moment2.default)(_this.state.date).format('YYYY-MM');var innerHtml='\n              <caption>'+name+'</caption>\n              '+document.getElementById('table4_6_2').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n            ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,name+'.xls');_this.setState({print:false,loading:false});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],data3_1_2:[],data3_1_1:[],loading:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.setState({loading:true});this.getTable3_1_1(this.state.date);}// 表格里面一些需要计算的数据
// 从后台取出表格3_1_1的数据
// 从后台取出表格3_1_2的数据
},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var print=this.state.print;var totalData=[5];var columns=[{align:"center",title:_react2.default.createElement('div',null,'Hotel ',_react2.default.createElement('br',null),' \u9152\u5E97'),dataIndex:'name',key:'name',width:300,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"left"}},text);}},{align:"center",title:_react2.default.createElement('div',null,'Rooms ',_react2.default.createElement('br',null),' \u5BA2\u623F\u6570'),dataIndex:'rooms',key:'rooms',width:100,render:function render(text,record,index){var title=['Rooms 客房数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rooms',title:title,sqlName:"_3_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{align:"center",title:_react2.default.createElement('div',null,'Rms Avaliable ',_react2.default.createElement('br',null),' \u53EF\u552E\u5BA2\u623F\u6570'),dataIndex:'rooms_avaliable',key:'rooms_avaliable',width:150,render:function render(text,record,index){var title=['Rms Avaliable 可售客房数'];if(index==5||print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rooms_avaliable',title:title,sqlName:"_3_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rooms_avaliable',title:title,sqlName:"_3_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){// console.log(e.target.value,'target');
var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('rooms_avaliable',value,index);}// onChange={(value) => {
//     this.onChange('actual', value, index)
// }}
})));}},{align:"center",title:_react2.default.createElement('div',null,'Rms Sold ',_react2.default.createElement('br',null),' \u552E\u51FA\u623F\u6570'),dataIndex:'rooms_sold',key:'rooms_sold',width:100,render:function render(text,record,index){var title=['Rms Sold 售出房数'];if(index==5||print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rooms_sold',title:title,sqlName:"_3_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rooms_sold',title:title,sqlName:"_3_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('rooms_sold',value,index);}// onChange={(value) => {
//     this.onChange('actual', value, index)
// }}
})));}},{align:"center",title:_react2.default.createElement('div',null,'OCC ',_react2.default.createElement('br',null),' \u5BA2\u623F\u7387'),dataIndex:'occ',key:'occ',width:100,render:function render(text,record,index){var title=['OCC 客房率'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'occ',title:title,sqlName:"_3_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}},{align:"center",title:_react2.default.createElement('div',null,'Revn ',_react2.default.createElement('br',null),' \u5BA2\u623F\u6536\u5165'),dataIndex:'revn',key:'revn',width:100,render:function render(text,record,index){var title=['Revn 客房收入'];if(index==5||print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revn',title:title,sqlName:"_3_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revn',title:title,sqlName:"_3_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('revn',value,index);}// onChange={(value) => {
//     this.onChange('actual', value, index)
// }}
})));}},{align:"center",title:_react2.default.createElement('div',null,'Avg Rate ',_react2.default.createElement('br',null),' \u5E73\u5747\u623F\u4EF7'),dataIndex:'avg_rate',key:'avg_rate',width:100,render:function render(text,record,index){var title=['Avg Rate 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'avg_rate',title:title,sqlName:"_3_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{align:"center",title:_react2.default.createElement('div',null,'RevPAR ',_react2.default.createElement('br',null),' \u53EF\u552E\u623F\u5E73\u5747\u6536\u5165'),dataIndex:'revpar',key:'revpar',width:100,render:function render(text,record,index){var title=['RevPAR 可售房平均收入'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revpar',title:title,sqlName:"_3_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{align:"center",title:_react2.default.createElement('div',null,'MPI ',_react2.default.createElement('br',null),' \u5E02\u573A\u6E17\u900F\u7387\u6307\u6570'),dataIndex:'mpi',key:'mpi',width:100,render:function render(text,record,index){var title=['MPI 市场渗透率指数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'mpi',title:title,sqlName:"_3_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text||""));}},{align:"center",title:_react2.default.createElement('div',null,'Ranking ',_react2.default.createElement('br',null),' \u6392\u540D'),dataIndex:'mpi_ranking',key:'mpi_ranking',width:100,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'mpi_ranking',title:title,sqlName:"_3_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}},{align:"center",title:_react2.default.createElement('div',null,'ARI ',_react2.default.createElement('br',null),' \u5E73\u5747\u623F\u4EF7\u6307\u6570'),dataIndex:'ari',key:'ari',width:100,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ari',title:title,sqlName:"_3_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}},{align:"center",title:_react2.default.createElement('div',null,'Ranking ',_react2.default.createElement('br',null),' \u6392\u540D'),dataIndex:'ari_ranking',key:'ari_ranking',width:100,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ari_ranking',title:title,sqlName:"_3_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}},{align:"center",title:_react2.default.createElement('div',null,'RGI ',_react2.default.createElement('br',null),' \u6536\u76CA\u7387\u6307\u6570'),dataIndex:'rgi',key:'rgi',width:100,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rgi',title:title,sqlName:"_3_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}},{align:"center",title:_react2.default.createElement('div',null,'Ranking ',_react2.default.createElement('br',null),' \u6392\u540D'),dataIndex:'rgi_ranking',key:'rgi_ranking',width:100,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rgi_ranking',title:title,sqlName:"_3_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table'},_react2.default.createElement(_row2.default,{className:'title',id:'table3_1_2'},_react2.default.createElement(_row2.default,{className:'vice-title'},'4.6.2 MTD Last Year \u53BB\u5E74\u5F53\u6708'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,'YYYY-MM'),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getTable3_1_1(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',className:'content',id:'table4_6_2',bordered:true,pagination:false,rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.onExpoetExcel},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_3_1'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data3_1_2_default=exports.data3_1_2_default=[{name:'',name_code:"Rooms_Available",rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1},{name:'',name_code:"Rooms_Available",rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1},{name:'',name_code:"Rooms_Available",rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1},{name:'',name_code:"Rooms_Available",rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1},{name:'',name_code:"Rooms_Available",rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1},{name:'Total',name_code:"Rooms_Available",rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1}];

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(290);var _data2=__webpack_require__(1504);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data,data3_1_4){// console.log(data);
// console.log(this.state.data3_1_4)
// var data3_1_4 = this.state.data3_1_4;
var len=data.length;// 计算总值 
var total={name:'Total',name_code:"Rooms_Available",rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:"-",mpi_ranking:'-',ari:"-",ari_ranking:'-',rgi:"-",rgi_ranking:'-'// year: 2018,
// month: 5
};for(var i in data){if(i<5){//可售房rooms_avaliable 售出房数rooms_sold 客房收入renv 使用data3_1_2的数据
data[i]['rooms_avaliable']=data3_1_4[i]['rooms_avaliable'];data[i]['rooms_sold']=data3_1_4[i]['rooms_sold'];data[i]['revn']=data3_1_4[i]['revn'];total['rooms']+=Number(data[i]['rooms']);total['rooms_avaliable']+=Number(data[i]['rooms_avaliable']);total['rooms_sold']+=Number(data[i]['rooms_sold']);total['revn']+=Number(data[i]['revn']);}}// console.log(total);
total['occ']=Number(total['rooms_avaliable'])==0?0:(Number(total['rooms_sold'])/Number(total['rooms_avaliable'])*100).toFixed(2)+'%';total['avg_rate']=Number(total['rooms_sold'])==0?0:(Number(total['revn'])/Number(total['rooms_sold'])).toFixed(2);total['revpar']=Number(total['rooms_avaliable'])==0?0:(Number(total['revn'])/Number(total['rooms_avaliable'])).toFixed(2);var mpi=[];var ari=[];var rgi=[];for(var _i in data){if(_i<5){//客房率
data[_i]['occ']=(Number(data[_i]['rooms_avaliable'])==0?0:Number(data[_i]['rooms_sold'])/Number(data[_i]['rooms_avaliable'])*100).toFixed(2)+'%';//平均房价
data[_i]['avg_rate']=(Number(data[_i]['rooms_sold'])==0?0:Number(data[_i]['revn'])/Number(data[_i]['rooms_sold'])).toFixed(2);//可售房平均收入
data[_i]['revpar']=(Number(data[_i]['rooms_avaliable'])==0?0:Number(data[_i]['revn'])/Number(data[_i]['rooms_avaliable'])).toFixed(2);//市场渗透率
data[_i]['mpi']=Number(total['occ'])==0?0:(parseFloat(data[_i]['occ'])/parseFloat(total['occ'])).toFixed(2);mpi.push({data:data[_i]['mpi'],key:_i});//排名
//平均房价指数
data[_i]['ari']=Number(total['avg_rate'])==0?0:(Number(data[_i]['avg_rate'])/Number(total['avg_rate'])).toFixed(2);ari.push({data:data[_i]['ari'],key:_i});//排名
//RGI收益率
data[_i]['rgi']=Number(total['revpar'])==0?0:(Number(data[_i]['revpar'])/Number(total['revpar'])).toFixed(2);rgi.push({data:data[_i]['rgi'],key:_i});}}data[5]=total;// 计算排名
mpi.sort(function(a,b){return b.data-a.data;});ari.sort(function(a,b){return b.data-a.data;});rgi.sort(function(a,b){return b.data-a.data;});mpi.forEach(function(x,i){data[x.key].mpi_ranking=i+1;});ari.forEach(function(x,i){data[x.key].ari_ranking=i+1;});rgi.forEach(function(x,i){data[x.key].rgi_ranking=i+1;});if(data3_1_4[0]&&data3_1_4[0].id){data.forEach(function(item,i){if(i<=4){data[i].id=data3_1_4[i].id;}});}_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;// console.log(data);return;
// this.setState({
//     data
// });
// console.log(data);return;
_this.computeNum(_this.state.data3_1_1,data);};_this.getTable3_1_1=function(date){var dataBegin=JSON.stringify(_data.data3_1_1);var data=JSON.parse(dataBegin);fetch('/_3_1_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=data.map(function(item,i){if(i<=4&&x.data[i].name){return _extends({},item,{name:x.data[i].name,rooms:x.data[i].rooms});}else{return item;}});}_this.setState({data3_1_1:data});_this.getTable3_1_4(date);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.getTable3_1_4=function(date){var dataBegin=JSON.stringify(_data2.data3_1_4_default);var data3_1_4=JSON.parse(dataBegin);fetch('/_3_1_4_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data3_1_4=x.data;}_this.setState({data3_1_4:data3_1_4,loading:false});_this.computeNum(_this.state.data3_1_1,data3_1_4);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();console.log(data);// 删除total这列数据
data.pop();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_3_1_4',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getTable3_1_4(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table3_1_4',1.5,'4.63',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.onExpoetExcel=function(){_this.setState({print:true,loading:true},function(){var name='YTD This Year \u672C\u5E74\u7D2F\u8BA1 '+(0,_moment2.default)(_this.state.date).format('YYYY-MM');var innerHtml='\n              <caption>'+name+'</caption>\n              '+document.getElementById('table4_6_3').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n            ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,name+'.xls');_this.setState({print:false,loading:false});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],data3_1_4:[],data3_1_1:[],loading:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.setState({loading:true});this.getTable3_1_1(this.state.date);}// 表格里面一些需要计算的数据
// 从后台取出表格3_1_1的数据
// 从后台取出表格3_1_4的数据
},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var print=this.state.print;var totalData=[5];var columns=[{align:"center",title:_react2.default.createElement('div',null,'Hotel ',_react2.default.createElement('br',null),' \u9152\u5E97'),dataIndex:'name',key:'name',width:300,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"left"}},text);}},{align:"center",title:_react2.default.createElement('div',null,'Rooms ',_react2.default.createElement('br',null),' \u5BA2\u623F\u6570'),dataIndex:'rooms',key:'rooms',width:100,render:function render(text,record,index){var title=['Rooms 客房数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rooms',title:title,sqlName:"_3_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{align:"center",title:_react2.default.createElement('div',null,'Rms Avaliable ',_react2.default.createElement('br',null),' \u53EF\u552E\u5BA2\u623F\u6570'),dataIndex:'rooms_avaliable',key:'rooms_avaliable',width:150,render:function render(text,record,index){var title=['Rms Avaliable 可售客房数'];if(index==5||print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rooms_avaliable',title:title,sqlName:"_3_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rooms_avaliable',title:title,sqlName:"_3_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('rooms_avaliable',value,index);}// onChange={(value) => {
//     this.onChange('actual', value, index)
// }}
})));}},{align:"center",title:_react2.default.createElement('div',null,'Rms Sold ',_react2.default.createElement('br',null),' \u552E\u51FA\u623F\u6570'),dataIndex:'rooms_sold',key:'rooms_sold',width:100,render:function render(text,record,index){var title=['Rms Sold 售出房数'];if(index==5||print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rooms_sold',title:title,sqlName:"_3_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rooms_sold',title:title,sqlName:"_3_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('rooms_sold',value,index);}// onChange={(value) => {
//     this.onChange('actual', value, index)
// }}
})));}},{align:"center",title:_react2.default.createElement('div',null,'OCC ',_react2.default.createElement('br',null),' \u5BA2\u623F\u7387'),dataIndex:'occ',key:'occ',width:100,render:function render(text,record,index){var title=['OCC 客房率'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'occ',title:title,sqlName:"_3_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}},{align:"center",title:_react2.default.createElement('div',null,'Revn ',_react2.default.createElement('br',null),' \u5BA2\u623F\u6536\u5165'),dataIndex:'revn',key:'revn',width:100,render:function render(text,record,index){var title=['Revn 客房收入'];if(index==5||print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revn',title:title,sqlName:"_3_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revn',title:title,sqlName:"_3_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('revn',value,index);}// onChange={(value) => {
//     this.onChange('actual', value, index)
// }}
})));}},{align:"center",title:_react2.default.createElement('div',null,'Avg Rate ',_react2.default.createElement('br',null),' \u5E73\u5747\u623F\u4EF7'),dataIndex:'avg_rate',key:'avg_rate',width:100,render:function render(text,record,index){var title=['Avg Rate 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'avg_rate',title:title,sqlName:"_3_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{align:"center",title:_react2.default.createElement('div',null,'RevPAR ',_react2.default.createElement('br',null),' \u53EF\u552E\u623F\u5E73\u5747\u6536\u5165'),dataIndex:'revpar',key:'revpar',width:100,render:function render(text,record,index){var title=['RevPAR 可售房平均收入'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revpar',title:title,sqlName:"_3_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{align:"center",title:_react2.default.createElement('div',null,'MPI ',_react2.default.createElement('br',null),' \u5E02\u573A\u6E17\u900F\u7387\u6307\u6570'),dataIndex:'mpi',key:'mpi',width:100,render:function render(text,record,index){var title=['MPI 市场渗透率指数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'mpi',title:title,sqlName:"_3_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text||""));}},{align:"center",title:_react2.default.createElement('div',null,'Ranking ',_react2.default.createElement('br',null),' \u6392\u540D'),dataIndex:'mpi_ranking',key:'mpi_ranking',width:100,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'mpi_ranking',title:title,sqlName:"_3_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}},{align:"center",title:_react2.default.createElement('div',null,'ARI ',_react2.default.createElement('br',null),' \u5E73\u5747\u623F\u4EF7\u6307\u6570'),dataIndex:'ari',key:'ari',width:100,render:function render(text,record,index){var title=['ARI 平均房价指数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ari',title:title,sqlName:"_3_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}},{align:"center",title:_react2.default.createElement('div',null,'Ranking ',_react2.default.createElement('br',null),' \u6392\u540D'),dataIndex:'ari_ranking',key:'ari_ranking',width:100,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ari_ranking',title:title,sqlName:"_3_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}},{align:"center",title:_react2.default.createElement('div',null,'RGI ',_react2.default.createElement('br',null),' \u6536\u76CA\u7387\u6307\u6570'),dataIndex:'rgi',key:'rgi',width:100,render:function render(text,record,index){var title=['RGI 收益率指数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rgi',title:title,sqlName:"_3_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}},{align:"center",title:_react2.default.createElement('div',null,'Ranking ',_react2.default.createElement('br',null),' \u6392\u540D'),dataIndex:'rgi_ranking',key:'rgi_ranking',width:100,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rgi_ranking',title:title,sqlName:"_3_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table'},_react2.default.createElement(_row2.default,{className:'title',id:'table3_1_4'},_react2.default.createElement(_row2.default,{className:'vice-title'},'4.6.3 YTD This Year \u672C\u5E74\u7D2F\u8BA1'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,'YYYY-MM'),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getTable3_1_1(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',className:'content',bordered:true,id:'table4_6_3',pagination:false,rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.onExpoetExcel},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_3_1'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data3_1_4_default=exports.data3_1_4_default=[{name:'111',name_code:"Rooms_Available",rooms:0,rooms_avaliable:2,rooms_sold:2,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1},{name:'1111',name_code:"Rooms_Available",rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1},{name:'1111',name_code:"Rooms_Available",rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1},{name:'1111',name_code:"Rooms_Available",rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1},{name:'1111',name_code:"Rooms_Available",rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1},{name:'Total',name_code:"Rooms_Available",rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1}];

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(290);var _data2=__webpack_require__(1506);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data,data3_1_5){// console.log(this.state.data3_1_5)
// var data3_1_5 = this.state.data3_1_5;
var len=data.length;// 计算总值 
var total={name:'Total',rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:"-",mpi_ranking:'-',ari:"-",ari_ranking:'-',rgi:"-",rgi_ranking:'-'// year: 2018,
// month: 5
};for(var i in data){if(i<5){//可售房rooms_avaliable 售出房数rooms_sold 客房收入renv 使用data3_1_5的数据
data[i]['rooms_avaliable']=data3_1_5[i]['rooms_avaliable'];data[i]['rooms_sold']=data3_1_5[i]['rooms_sold'];data[i]['revn']=data3_1_5[i]['revn'];total['rooms']+=Number(data[i]['rooms']);total['rooms_avaliable']+=Number(data[i]['rooms_avaliable']);total['rooms_sold']+=Number(data[i]['rooms_sold']);total['revn']+=Number(data[i]['revn']);}}// console.log(total);
total['occ']=Number(total['rooms_avaliable'])==0?0:(Number(total['rooms_sold'])/Number(total['rooms_avaliable'])*100).toFixed(2)+'%';total['avg_rate']=Number(total['rooms_sold'])==0?0:(Number(total['revn'])/Number(total['rooms_sold'])).toFixed(2);total['revpar']=Number(total['rooms_avaliable'])==0?0:(Number(total['revn'])/Number(total['rooms_avaliable'])).toFixed(2);var mpi=[];var ari=[];var rgi=[];for(var _i in data){if(_i<5){//客房率
data[_i]['occ']=(Number(data[_i]['rooms_avaliable'])==0?0:Number(data[_i]['rooms_sold'])/Number(data[_i]['rooms_avaliable'])*100).toFixed(2)+'%';//平均房价
data[_i]['avg_rate']=(Number(data[_i]['rooms_sold'])==0?0:Number(data[_i]['revn'])/Number(data[_i]['rooms_sold'])).toFixed(2);//可售房平均收入
data[_i]['revpar']=(Number(data[_i]['rooms_avaliable'])==0?0:Number(data[_i]['revn'])/Number(data[_i]['rooms_avaliable'])).toFixed(2);//市场渗透率
data[_i]['mpi']=parseFloat(total['occ'])==0?0:(parseFloat(data[_i]['occ'])/parseFloat(total['occ'])).toFixed(2);mpi.push({data:data[_i]['mpi'],key:_i});//排名
//平均房价指数
data[_i]['ari']=Number(total['avg_rate'])==0?0:(Number(data[_i]['avg_rate'])/Number(total['avg_rate'])).toFixed(2);ari.push({data:data[_i]['ari'],key:_i});//排名
//RGI收益率
data[_i]['rgi']=Number(total['revpar'])==0?0:(Number(data[_i]['revpar'])/Number(total['revpar'])).toFixed(2);rgi.push({data:data[_i]['rgi'],key:_i});}}data[5]=total;// 计算排名
mpi.sort(function(a,b){return b.data-a.data;});ari.sort(function(a,b){return b.data-a.data;});rgi.sort(function(a,b){return b.data-a.data;});mpi.forEach(function(x,i){data[x.key].mpi_ranking=i+1;});ari.forEach(function(x,i){data[x.key].ari_ranking=i+1;});rgi.forEach(function(x,i){data[x.key].rgi_ranking=i+1;});if(data3_1_5[0]&&data3_1_5[0].id){data.forEach(function(item,i){if(i<=4){data[i].id=data3_1_5[i].id;}});}// if (this.state.data3_1_1 && this.state.data3_1_1.length > 0) {
//     data = data.map((x, i) => {
//         if (i <= 4) {
//             return { ...x, name: this.state.data[i].name }
//         } else {
//             return x
//         }
//     })
// }
_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;// console.log(data);return;
// this.setState({
//     data
// });
_this.computeNum(_this.state.data3_1_1,data);};_this.getTable3_1_1=function(date){var dataBegin=JSON.stringify(_data.data3_1_1);var data=JSON.parse(dataBegin);fetch('/_3_1_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=data.map(function(item,i){if(i<=4&&x.data[i].name){return _extends({},item,{name:x.data[i].name,rooms:x.data[i].rooms});}else{return item;}});}_this.setState({data3_1_1:data});_this.getTable3_1_5(date);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.getTable3_1_5=function(date){var dataBegin=JSON.stringify(_data2.data3_1_5_default);var data3_1_5=JSON.parse(dataBegin);fetch('/_3_1_5_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data3_1_5=x.data;}_this.setState({data3_1_5:data3_1_5,loading:false});_this.computeNum(_this.state.data3_1_1,data3_1_5);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();// 删除total这列数据
data.pop();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_3_1_5',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getTable3_1_1(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table3_1_5',1.5,'4.64',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.onExpoetExcel=function(){_this.setState({print:true,loading:true},function(){var name='YTD Last Year \u53BB\u5E74\u7D2F\u8BA1 '+(0,_moment2.default)(_this.state.date).format('YYYY-MM');var innerHtml='\n              <caption>'+name+'</caption>\n              '+document.getElementById('table4_6_4').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n            ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,name+'.xls');_this.setState({print:false,loading:false});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],data3_1_5:[],data3_1_1:[],loading:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.setState({loading:true});this.getTable3_1_1(this.state.date);}// 表格里面一些需要计算的数据
// 从后台取出表格3_1_1的数据
// 从后台取出表格3_1_5的数据
},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var print=this.state.print;var totalData=[5];var columns=[{align:"center",title:_react2.default.createElement('div',null,'Hotel ',_react2.default.createElement('br',null),' \u9152\u5E97'),dataIndex:'name',key:'name',width:300,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"left"}},text);}},{align:"center",title:_react2.default.createElement('div',null,'Rooms ',_react2.default.createElement('br',null),' \u5BA2\u623F\u6570'),dataIndex:'rooms',key:'rooms',width:100,render:function render(text,record,index){var title=['Rooms 客房数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rooms',title:title,sqlName:"_3_1_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{align:"center",title:_react2.default.createElement('div',null,'Rms Avaliable ',_react2.default.createElement('br',null),' \u53EF\u552E\u5BA2\u623F\u6570'),dataIndex:'rooms_avaliable',key:'rooms_avaliable',width:150,render:function render(text,record,index){var title=['Rms Avaliable 可售客房数'];if(index==5||print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rooms_avaliable',title:title,sqlName:"_3_1_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rooms_avaliable',title:title,sqlName:"_3_1_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('rooms_avaliable',value,index);}// onChange={(value) => {
//     this.onChange('actual', value, index)
// }}
})));}},{align:"center",title:_react2.default.createElement('div',null,'Rms Sold ',_react2.default.createElement('br',null),' \u552E\u51FA\u623F\u6570'),dataIndex:'rooms_sold',key:'rooms_sold',width:100,render:function render(text,record,index){var title=['Rms Sold 售出房数'];if(index==5||print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rooms_sold',title:title,sqlName:"_3_1_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rooms_sold',title:title,sqlName:"_3_1_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('rooms_sold',value,index);}// onChange={(value) => {
//     this.onChange('actual', value, index)
// }}
})));}},{align:"center",title:_react2.default.createElement('div',null,'OCC ',_react2.default.createElement('br',null),' \u5BA2\u623F\u7387'),dataIndex:'occ',key:'occ',width:100,render:function render(text,record,index){var title=['OCC 客房率'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'occ',title:title,sqlName:"_3_1_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}},{align:"center",title:_react2.default.createElement('div',null,'Revn ',_react2.default.createElement('br',null),' \u5BA2\u623F\u6536\u5165'),dataIndex:'revn',key:'revn',width:100,render:function render(text,record,index){var title=['Revn 客房收入'];if(index==5||print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revn',title:title,sqlName:"_3_1_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revn',title:title,sqlName:"_3_1_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('revn',value,index);}// onChange={(value) => {
//     this.onChange('actual', value, index)
// }}
})));}},{align:"center",title:_react2.default.createElement('div',null,'Avg Rate ',_react2.default.createElement('br',null),' \u5E73\u5747\u623F\u4EF7'),dataIndex:'avg_rate',key:'avg_rate',width:100,render:function render(text,record,index){var title=['Avg Rate 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'avg_rate',title:title,sqlName:"_3_1_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{align:"center",title:_react2.default.createElement('div',null,'RevPAR ',_react2.default.createElement('br',null),' \u53EF\u552E\u623F\u5E73\u5747\u6536\u5165'),dataIndex:'revpar',key:'revpar',width:100,render:function render(text,record,index){var title=['RevPAR 可售房平均收入'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revpar',title:title,sqlName:"_3_1_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{align:"center",title:_react2.default.createElement('div',null,'MPI ',_react2.default.createElement('br',null),' \u5E02\u573A\u6E17\u900F\u7387\u6307\u6570'),dataIndex:'mpi',key:'mpi',width:100,render:function render(text,record,index){var title=['MPI 市场渗透率指数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'mpi',title:title,sqlName:"_3_1_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text||""));}},{align:"center",title:_react2.default.createElement('div',null,'Ranking ',_react2.default.createElement('br',null),' \u6392\u540D'),dataIndex:'mpi_ranking',key:'mpi_ranking',width:100,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'mpi_ranking',title:title,sqlName:"_3_1_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}},{align:"center",title:_react2.default.createElement('div',null,'ARI ',_react2.default.createElement('br',null),' \u5E73\u5747\u623F\u4EF7\u6307\u6570'),dataIndex:'ari',key:'ari',width:100,render:function render(text,record,index){var title=['ARI 平均房价指数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ari',title:title,sqlName:"_3_1_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}},{align:"center",title:_react2.default.createElement('div',null,'Ranking ',_react2.default.createElement('br',null),' \u6392\u540D'),dataIndex:'ari_ranking',key:'ari_ranking',width:100,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ari_ranking',title:title,sqlName:"_3_1_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}},{align:"center",title:_react2.default.createElement('div',null,'RGI ',_react2.default.createElement('br',null),' \u6536\u76CA\u7387\u6307\u6570'),dataIndex:'rgi',key:'rgi',width:100,render:function render(text,record,index){var title=['RGI 收益率指数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rgi',title:title,sqlName:"_3_1_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}},{align:"center",title:_react2.default.createElement('div',null,'Ranking ',_react2.default.createElement('br',null),' \u6392\u540D'),dataIndex:'rgi_ranking',key:'rgi_ranking',width:100,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'rgi_ranking',title:title,sqlName:"_3_1_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},text));}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table'},_react2.default.createElement(_row2.default,{className:'title',id:'table3_1_5'},_react2.default.createElement(_row2.default,{className:'vice-title'},'4.6.4 YTD Last Year \u53BB\u5E74\u7D2F\u8BA1'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,'YYYY-MM'),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getTable3_1_1(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',className:'content',id:'table4_6_4',bordered:true,pagination:false,rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.onExpoetExcel},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_3_1'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data3_1_5_default=exports.data3_1_5_default=[{name:'111',rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1},{name:'1111',rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1},{name:'1111',rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1},{name:'1111',rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1},{name:'1111',rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1},{name:'Total',rooms:0,rooms_avaliable:0,rooms_sold:0,occ:0,revn:0,avg_rate:0,revpar:0,mpi:0,mpi_ranking:1,ari:0,ari_ranking:1,rgi:0,rgi_ranking:1}];

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(4);__webpack_require__(10);__webpack_require__(25);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TextArea=_input2.default.TextArea;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getTable3_1_7=function(date){fetch('/_3_1_7_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){_this.setState({data:x.data});}_this.setState({loading:false});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();// console.log(data)
dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_3_1_7',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getTable3_1_7(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table3_1_7',1.5,'4.65',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[{'comments':''}],loading:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.setState({loading:true});this.getTable3_1_7(this.state.date);}// 保存
},{key:'render',value:function render(){var _this2=this;var _state=this.state,loading=_state.loading,data=_state.data,date=_state.date,print=_state.print,loadingSave=_state.loadingSave;return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'table'},_react2.default.createElement(_row2.default,{className:'title',id:'table3_1_7'},_react2.default.createElement(_row2.default,{className:'vice-title'},'4.6.5 Please critique if the RGI Index is not 1, and the actions. \u82E5\u6536\u76CA\u6307\u6570\u4E0D\u4E3A1\uFF0C\u8BF7\u9610\u91CA\uFF0C\u5E76\u63D0\u4F9B\u884C\u52A8\u8BA1\u5212\u3002'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(date,'YYYY-MM'),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[{'comments':''}],loading:true});_this2.getTable3_1_7(str);}})),_react2.default.createElement(TextArea,{style:{marginTop:10},autosize:{minRows:4},value:data[0]?data[0]['comments']:'',onChange:function onChange(e){var newdata=[].concat(_toConsumableArray(data));newdata[0]['comments']=e.target.value;_this2.setState({data:newdata});}})),_react2.default.createElement(_Auth2.default,{loading:loading,auth:'edit_3_1'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _=__webpack_require__(1509);var _2=_interopRequireDefault(_);var _3=__webpack_require__(1510);var _4=_interopRequireDefault(_3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){return _react2.default.createElement('div',null,_react2.default.createElement(_row2.default,{style:{margin:"24px 0 24px 24px",fontSize:22,color:"#333"}},'5.7 F&B Outlets KPI Analysis \u9910\u996E\u90E8\u9910\u5385\u5173\u952E\u7EE9\u6548\u6307\u6570\u5206\u6790'),_react2.default.createElement(_2.default,null),_react2.default.createElement(_4.default,null));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(611);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _ExportExcel=__webpack_require__(79);var _ExportExcel2=_interopRequireDefault(_ExportExcel);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var naeData=['outlets','seats','available','covers','revenue'];var toi_ranking=[];var ACI_ranking=[];var RGI_ranking=[];var _loop=function _loop(i){data[5][naeData[i]]=naeData.reduce(function(a,b,index){a+=numConvert(data[index][naeData[i]]);return a;},0);toi_ranking.push({data:Number(data[i].toi||'0'),key:i});ACI_ranking.push({data:Number(data[i].ACI||'0'),key:i});RGI_ranking.push({data:Number(data[i].RGI||'0'),key:i});data[5][naeData[i]]=data[5][naeData[i]].toFixed(2);};for(var i=0;i<5;i++){_loop(i);}for(var i=0;i<data.length;i++){// 上座率
data[i].turn_over=(numConvert(data[i].available)==0?0:numConvert(data[i].covers)/numConvert(data[i].available)).toFixed(3);// 人均消费
data[i].AC=(numConvert(data[i].covers)==0?0:numConvert(data[i].revenue)/numConvert(data[i].covers)).toFixed(2);// 可售餐位平均收入
data[i].revpas=(numConvert(data[i].available)==0?0:numConvert(data[i].revenue)/numConvert(data[i].available)).toFixed(2);};for(var _i=0;_i<data.length-1;_i++){//  上座率指数
data[_i].toi=(numConvert(data[5].turn_over)==0?0:numConvert(data[_i].turn_over)/numConvert(data[5].turn_over)).toFixed(2);//   人均消费指数
data[_i].ACI=(numConvert(data[5].AC)==0?0:numConvert(data[_i].AC)/numConvert(data[5].AC)).toFixed(2);//   收益率指数
data[_i].RGI=(numConvert(data[5].revpas)==0?0:numConvert(data[_i].revpas)/numConvert(data[5].revpas)).toFixed(2);}// 计算排名
toi_ranking.sort(function(a,b){return b.data-a.data;});ACI_ranking.sort(function(a,b){return b.data-a.data;});RGI_ranking.sort(function(a,b){return b.data-a.data;});toi_ranking.forEach(function(x,i){data[x.key].toi_ranking=i+1;});ACI_ranking.forEach(function(x,i){data[x.key].ACI_ranking=i+1;});RGI_ranking.forEach(function(x,i){data[x.key].RGI_ranking=i+1;});_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;// this.setState({
//     data
// });
_this.computeNum(data);};_this.getDateData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var dataBegin,data,d,data3_1;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dataBegin=JSON.stringify(_data.data3_2_1);data=JSON.parse(dataBegin);_context.next=4;return fetch('/_3_1_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'});case 4:d=_context.sent;_context.next=7;return d.json();case 7:data3_1=_context.sent;fetch('/_3_2_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}if(data3_1.data&&data3_1.data.length>0){data=data.map(function(item,index){if(index!=data.length-1){return _extends({},item,{name:data3_1.data[index].name,name_code:data3_1.data[index].name_code});}return _extends({},item);});}_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});case 9:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x2){return _ref.apply(this,arguments);};}();_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});// if (!data.every(x => x.name)) {
//     message.error('名称不能为空，请到3-1-1设置名称！');
//     return
// }
var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_3_2_1  ',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table3_2_1',1.5,'5.71',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);// this.computeNum(this.state.data)
}},{key:'render',value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print;var width=document.body.offsetWidth-2100>400?document.body.offsetWidth-2100:400;var columns=[{title:'Comp Set 竞争集群',dataIndex:'name',key:'name',align:"center",fixed:!print&&"left",width:width,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':''),style:{textAlign:"left"}},text);}},{title:_react2.default.createElement('div',null,'No. of Outlets ',_react2.default.createElement('br',null),'\u9910\u5385\u6570'),dataIndex:'outlets',key:'outlets',align:"center",width:150,render:function render(text,record,index){var title=['No. of Outlets 餐厅数'];if(index!=5&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'outlets',title:title,sqlName:"_3_2_1",name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||'0')||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('outlets',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'outlets',title:title,sqlName:"_3_2_1",name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'No. of Seats ',_react2.default.createElement('br',null),'\u9910\u4F4D\u6570'),dataIndex:'seats',key:'seats',align:"center",width:150,render:function render(text,record,index){var title=['No. of Seats 餐位数'];if(index!=5&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'seats',title:title,sqlName:"_3_2_1",name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||'0')||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('seats',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'seats',title:title,sqlName:"_3_2_1",name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Seats Available ',_react2.default.createElement('br',null),'\u53EF\u552E\u9910\u4F4D'),dataIndex:'available',key:'available',align:"center",width:150,render:function render(text,record,index){var title=['Seats Available  可售餐位'];if(index!=5&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'available',title:title,sqlName:"_3_2_1",name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||'0')||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('available',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'available',title:title,sqlName:"_3_2_1",name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'No. of Covers',_react2.default.createElement('br',null),'\u7528\u9910\u4EBA\u6570'),dataIndex:'covers',key:'covers',align:"center",width:150,render:function render(text,record,index){var title=['No. of Covers  用餐人数'];if(index!=5&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'covers',title:title,sqlName:"_3_2_1",name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||'0')||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('covers',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'covers',title:title,sqlName:"_3_2_1",name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Turn Over',_react2.default.createElement('br',null),' \u4E0A\u5EA7\u7387/\u7FFB\u53F0\u7387'),dataIndex:'turn_over',key:'turn_over',align:"center",width:150,render:function render(text,record,index){var title=['Turn Over  上座率/翻台率'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'turn_over',title:title,sqlName:"_3_2_1",name:record.name,type:"percent"}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Outlets Revenue',_react2.default.createElement('br',null),' \u9910\u5385\u6536\u5165'),dataIndex:'revenue',key:'revenue',align:"center",width:150,render:function render(text,record,index){var title=['Outlets Revenue  餐厅收入'];if(index!=5&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revenue',title:title,sqlName:"_3_2_1",name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||'0')||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('revenue',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revenue',title:title,sqlName:"_3_2_1",name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'A/C \u4EBA\u5747\u6D88\u8D39'),dataIndex:'AC',key:'AC',align:"center",width:150,render:function render(text,record,index){var title=['A/C 人均消费'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'AC',title:title,sqlName:"_3_2_1",name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'RevPAS ',_react2.default.createElement('br',null),' \u53EF\u552E\u9910\u4F4D\u5E73\u5747\u6536\u5165'),dataIndex:'revpas',key:'revpas',align:"center",width:150,render:function render(text,record,index){var title=['RevPAS 可售餐位平均收入'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revpas',title:title,sqlName:"_3_2_1",name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'TOI \u4E0A\u5EA7\u7387\u6307\u6570'),dataIndex:'toi',key:'toi',align:"center",width:150,render:function render(text,record,index){var title=['TOI 上座率指数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'toi',title:title,sqlName:"_3_2_1",name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Ranking \u6392\u540D'),dataIndex:'toi_ranking',key:'toi_ranking',align:"center",width:150,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'toi_ranking',title:title,sqlName:"_3_2_1",name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'ACI \u4EBA\u5747\u6D88\u8D39\u6307\u6570'),dataIndex:'ACI',key:'ACI',align:"center",width:150,render:function render(text,record,index){var title=['ACI 人均消费指数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ACI',title:title,sqlName:"_3_2_1",name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Ranking \u6392\u540D'),dataIndex:'ACI_ranking',key:'ACI_ranking',align:"center",width:150,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ACI_ranking',title:title,sqlName:"_3_2_1",name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'RGI \u6536\u76CA\u7387\u6307\u6570'),dataIndex:'RGI',key:'RGI',align:"center",width:150,render:function render(text,record,index){var title=['RGI 收益率指数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'RGI',title:title,sqlName:"_3_2_1",name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Ranking \u6392\u540D'),dataIndex:'RGI_ranking',key:'RGI_ranking',align:"center",width:150,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'RGI_ranking',title:title,sqlName:"_3_2_1",name:record.name,type:"number"}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table3_2_1',style:{width:this.state.print?2550:'auto'}},_react2.default.createElement(_row2.default,null,'5.7.1 MTD This Year \u672C\u5E74\u5F53\u6708'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,'YYYY-MM'),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'export5_7_1',pagination:false,className:'content',style:{width:this.state.print?2500:'auto'},scroll:this.state.print?{}:{x:2500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this3.setState({print:true,loading:true},function(){(0,_ExportExcel2.default)({id:"export5_7_1",date:date,name:"5.7.1 MTD This Year 本年当月"});_this3.setState({print:false,loading:false});});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_3_2'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(611);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _ExportExcel=__webpack_require__(79);var _ExportExcel2=_interopRequireDefault(_ExportExcel);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var naeData=['outlets','seats','available','covers','revenue'];var toi_ranking=[];var ACI_ranking=[];var RGI_ranking=[];var _loop=function _loop(i){data[5][naeData[i]]=naeData.reduce(function(a,b,index){a+=numConvert(data[index][naeData[i]]);return a;},0);toi_ranking.push({data:Number(data[i].toi||'0'),key:i});ACI_ranking.push({data:Number(data[i].ACI||'0'),key:i});RGI_ranking.push({data:Number(data[i].RGI||'0'),key:i});data[5][naeData[i]]=data[5][naeData[i]].toFixed(2);};for(var i=0;i<5;i++){_loop(i);}for(var i=0;i<data.length;i++){// 上座率
data[i].turn_over=(numConvert(data[i].available)==0?0:numConvert(data[i].covers)/numConvert(data[i].available)).toFixed(3);// 人均消费
data[i].AC=(numConvert(data[i].covers)==0?0:numConvert(data[i].revenue)/numConvert(data[i].covers)).toFixed(2);// 可售餐位平均收入
data[i].revpas=(numConvert(data[i].available)==0?0:numConvert(data[i].revenue)/numConvert(data[i].available)).toFixed(2);};for(var _i=0;_i<data.length-1;_i++){//  上座率指数
data[_i].toi=(numConvert(data[5].turn_over)==0?0:numConvert(data[_i].turn_over)/numConvert(data[5].turn_over)).toFixed(2);//   人均消费指数
data[_i].ACI=(numConvert(data[5].AC)==0?0:numConvert(data[_i].AC)/numConvert(data[5].AC)).toFixed(2);//   收益率指数
data[_i].RGI=(numConvert(data[5].revpas)==0?0:numConvert(data[_i].revpas)/numConvert(data[5].revpas)).toFixed(2);}// 计算排名
toi_ranking.sort(function(a,b){return b.data-a.data;});ACI_ranking.sort(function(a,b){return b.data-a.data;});RGI_ranking.sort(function(a,b){return b.data-a.data;});toi_ranking.forEach(function(x,i){data[x.key].toi_ranking=i+1;});ACI_ranking.forEach(function(x,i){data[x.key].ACI_ranking=i+1;});RGI_ranking.forEach(function(x,i){data[x.key].RGI_ranking=i+1;});_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;// this.setState({
//     data
// });
_this.computeNum(data);};_this.getDateData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var dataBegin,data,d,data3_1;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dataBegin=JSON.stringify(_data.data3_2_1);data=JSON.parse(dataBegin);_context.next=4;return fetch('/_3_1_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'});case 4:d=_context.sent;_context.next=7;return d.json();case 7:data3_1=_context.sent;fetch('/_3_2_2_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}if(data3_1.data&&data3_1.data.length>0){data=data.map(function(item,index){if(index!=data.length-1){return _extends({},item,{name:data3_1.data[index].name,name_code:data3_1.data[index].name_code});}return _extends({},item);});}_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});case 9:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x2){return _ref.apply(this,arguments);};}();_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});// if (!data.every(x => x.name)) {
//     message.error('名称不能为空，请到3-1-1设置名称！');
//     return
// }
var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_3_2_2  ',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table3_2_2',1.5,'5.72',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print;var width=document.body.offsetWidth-2100>400?document.body.offsetWidth-2100:400;var columns=[{title:'Comp Set 竞争集群',dataIndex:'name',key:'name',align:"center",fixed:!print&&"left",width:width,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':''),style:{textAlign:"left"}},text);}},{title:_react2.default.createElement('div',null,'No. of Outlets ',_react2.default.createElement('br',null),'\u9910\u5385\u6570'),dataIndex:'outlets',key:'outlets',align:"center",width:150,render:function render(text,record,index){if(index!=5&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('outlets',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}},{title:_react2.default.createElement('div',null,'No. of Seats ',_react2.default.createElement('br',null),'\u9910\u4F4D\u6570'),dataIndex:'seats',key:'seats',align:"center",width:150,render:function render(text,record,index){if(index!=5&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('seats',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}},{title:_react2.default.createElement('div',null,'Seats Available ',_react2.default.createElement('br',null),'\u53EF\u552E\u9910\u4F4D'),dataIndex:'available',key:'available',align:"center",width:150,render:function render(text,record,index){if(index!=5&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('available',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}},{title:_react2.default.createElement('div',null,'No. of Covers',_react2.default.createElement('br',null),'\u7528\u9910\u4EBA\u6570'),dataIndex:'covers',key:'covers',align:"center",width:150,render:function render(text,record,index){if(index!=5&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('covers',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}},{title:_react2.default.createElement('div',null,'Turn Over',_react2.default.createElement('br',null),' \u4E0A\u5EA7\u7387/\u7FFB\u53F0\u7387'),dataIndex:'turn_over',key:'turn_over',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%');}},{title:_react2.default.createElement('div',null,'Outlets Revenue',_react2.default.createElement('br',null),' \u9910\u5385\u6536\u5165'),dataIndex:'revenue',key:'revenue',align:"center",width:150,render:function render(text,record,index){if(index!=5&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('revenue',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}},{title:_react2.default.createElement('div',null,'A/C \u4EBA\u5747\u6D88\u8D39'),dataIndex:'AC',key:'AC',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:_react2.default.createElement('div',null,'RevPAS ',_react2.default.createElement('br',null),' \u53EF\u552E\u9910\u4F4D\u5E73\u5747\u6536\u5165'),dataIndex:'revpas',key:'revpas',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:_react2.default.createElement('div',null,'TOI \u4E0A\u5EA7\u7387\u6307\u6570'),dataIndex:'toi',key:'toi',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:_react2.default.createElement('div',null,'Ranking \u6392\u540D'),dataIndex:'toi_ranking',key:'toi_ranking',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:_react2.default.createElement('div',null,'ACI \u4EBA\u5747\u6D88\u8D39\u6307\u6570'),dataIndex:'ACI',key:'ACI',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:_react2.default.createElement('div',null,'Ranking \u6392\u540D'),dataIndex:'ACI_ranking',key:'ACI_ranking',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:_react2.default.createElement('div',null,'RGI \u6536\u76CA\u7387\u6307\u6570'),dataIndex:'RGI',key:'RGI',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:_react2.default.createElement('div',null,'Ranking \u6392\u540D'),dataIndex:'RGI_ranking',key:'RGI_ranking',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table3_2_2',style:{width:this.state.print?2550:'auto'}},_react2.default.createElement(_row2.default,null,'5.7.2 YTD This  Year \u672C\u5E74\u7D2F\u8BA1'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,'YYYY-MM'),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'export5_7_2',pagination:false,className:'content',style:{width:this.state.print?2500:'auto'},scroll:this.state.print?{}:{x:2500,y:550},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this3.setState({print:true,loading:true},function(){(0,_ExportExcel2.default)({id:"export5_7_2",date:date,name:"5.7.2 YTD This Year 本年累计"});_this3.setState({print:false,loading:false});});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_3_2'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _=__webpack_require__(1512);var _2=_interopRequireDefault(_);var _3=__webpack_require__(1513);var _4=_interopRequireDefault(_3);var _5=__webpack_require__(1514);var _6=_interopRequireDefault(_5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){return _react2.default.createElement('div',null,_react2.default.createElement(_row2.default,{style:{margin:"24px 0 24px 24px",fontSize:22,color:"#333"}},'6.2 F&B Catering/Banquet KPI Analysis \u9910\u996E\u90E8\u5BB4\u4F1A\u6D3B\u52A8\u5173\u952E\u7EE9\u6548\u6307\u6570\u5206\u6790'),_react2.default.createElement(_2.default,null),_react2.default.createElement(_4.default,null),_react2.default.createElement(_6.default,null));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(612);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var naeData=['outlets','seats','available','covers','revenue'];var toi_ranking=[];var ACI_ranking=[];var RGI_ranking=[];var _loop=function _loop(i){data[5][naeData[i]]=naeData.reduce(function(a,b,index){a+=numConvert(data[index][naeData[i]]);return a;},0);toi_ranking.push({data:Number(data[i].toi||'0'),key:i});ACI_ranking.push({data:Number(data[i].ACI||'0'),key:i});RGI_ranking.push({data:Number(data[i].RGI||'0'),key:i});data[5][naeData[i]]=data[5][naeData[i]].toFixed(2);};for(var i=0;i<5;i++){_loop(i);}for(var i=0;i<data.length;i++){// 上座率
data[i].turn_over=(numConvert(data[i].available)==0?0:numConvert(data[i].covers)/numConvert(data[i].available)).toFixed(3);// 人均消费
data[i].AC=(numConvert(data[i].covers)==0?0:numConvert(data[i].revenue)/numConvert(data[i].covers)).toFixed(2);// 可售餐位平均收入
data[i].revpas=(numConvert(data[i].available)==0?0:numConvert(data[i].revenue)/numConvert(data[i].available)).toFixed(2);};for(var _i=0;_i<data.length-1;_i++){//  上座率指数
data[_i].toi=(numConvert(data[5].turn_over)==0?0:numConvert(data[_i].turn_over)/numConvert(data[5].turn_over)).toFixed(2);//   人均消费指数
data[_i].ACI=(numConvert(data[5].AC)==0?0:numConvert(data[_i].AC)/numConvert(data[5].AC)).toFixed(2);//   收益率指数
data[_i].RGI=(numConvert(data[5].revpas)==0?0:numConvert(data[_i].revpas)/numConvert(data[5].revpas)).toFixed(2);}// 计算排名
toi_ranking.sort(function(a,b){return b.data-a.data;});ACI_ranking.sort(function(a,b){return b.data-a.data;});RGI_ranking.sort(function(a,b){return b.data-a.data;});toi_ranking.forEach(function(x,i){data[x.key].toi_ranking=i+1;});ACI_ranking.forEach(function(x,i){data[x.key].ACI_ranking=i+1;});RGI_ranking.forEach(function(x,i){data[x.key].RGI_ranking=i+1;});_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;// this.setState({
//     data
// });
_this.computeNum(data);};_this.getDateData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var dataBegin,data,d,data3_1;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dataBegin=JSON.stringify(_data.data3_2_1);data=JSON.parse(dataBegin);_context.next=4;return fetch('/_3_1_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'});case 4:d=_context.sent;_context.next=7;return d.json();case 7:data3_1=_context.sent;fetch('/_3_3_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}if(data3_1.data&&data3_1.data.length>0){data=data.map(function(item,index){if(index!=data.length-1){return _extends({},item,{name:data3_1.data[index].name,name_code:data3_1.data[index].name_code});}return _extends({},item);});}if(!data[0].id){_this.setState({loading:false,data:data},function(){_this.onSave();});return;}_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});case 9:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x2){return _ref.apply(this,arguments);};}();_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});// if (!data.every(x => x.name)) {
//     message.error('名称不能为空，请到3-1-1设置名称！');
//     return
// }
var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_3_3_1  ',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table3_3_1',1.5,'6.21',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);// this.computeNum(this.state.data)
}},{key:'render',value:function render(){var _this3=this;var data=this.state.data;var width=document.body.offsetWidth-2150>300?document.body.offsetWidth-2150:300;var columns=[{title:'Comp Set 竞争集群',dataIndex:'name',key:'name',align:"center",fixed:"left",width:width,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':''),style:{textAlign:"left"}},text);}},{title:_react2.default.createElement('div',null,'No. of Meeting/Events',_react2.default.createElement('br',null),'\u4F1A\u8BAE\u6D3B\u52A8\u573A\u6B21'),dataIndex:'outlets',key:'outlets',align:"center",width:150,render:function render(text,record,index){var title=['No. of Meeting/Events 会议活动场次'];if(index!=5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'outlets',title:title,sqlName:"_3_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('outlets',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'outlets',title:title,sqlName:"_3_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Meeting/Banquet Space SQM',_react2.default.createElement('br',null),'\u573A\u5730\u9762\u79EF(\u5E73\u65B9\u7C73)'),dataIndex:'seats',key:'seats',align:"center",width:150,render:function render(text,record,index){var title=['Meeting/Banquet Space SQM 场地面积(平方米)'];if(index!=5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'seats',title:title,sqlName:"_3_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('seats',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'seats',title:title,sqlName:"_3_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Space Available SQM',_react2.default.createElement('br',null),'\u53EF\u552E\u603B\u9762\u79EF(\u5E73\u65B9\u7C73)'),dataIndex:'available',key:'available',align:"center",width:150,render:function render(text,record,index){var title=['Space Available SQM 可售总面积(平方米)'];if(index!=5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'available',title:title,sqlName:"_3_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('available',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'available',title:title,sqlName:"_3_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Sold Space',_react2.default.createElement('br',null),'\u51FA\u552E\u603B\u9762\u79EF\uFF08\u5E73\u65B9\u7C73\uFF09'),dataIndex:'covers',key:'covers',align:"center",width:150,render:function render(text,record,index){var title=['Sold Space 出售总面积（平方米）'];if(index!=5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'covers',title:title,sqlName:"_3_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('covers',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'covers',title:title,sqlName:"_3_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Space Occupancy',_react2.default.createElement('br',null),'\u4F1A\u8BAE\u573A\u5730\u51FA\u79DF\u7387'),dataIndex:'turn_over',key:'turn_over',align:"center",width:150,render:function render(text,record,index){var title=['Space Occupancy 会议场地出租率'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'turn_over',title:title,sqlName:"_3_3_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Total Catering Revenue',_react2.default.createElement('br',null),' \u5BB4\u4F1A\u6D3B\u52A8\u603B\u6536\u5165'),dataIndex:'revenue',key:'revenue',align:"center",width:150,render:function render(text,record,index){var title=['Total Catering Revenue 宴会活动总收入'];if(index!=5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revenue',title:title,sqlName:"_3_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('revenue',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revenue',title:title,sqlName:"_3_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'S/C\u6BCF\u5E73\u65B9\u7C73\u5E73\u5747\u6D88\u8D39'),dataIndex:'AC',key:'AC',align:"center",width:150,render:function render(text,record,index){var title=['S/C每平方米平均消费'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'AC',title:title,sqlName:"_3_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'RevPASP ',_react2.default.createElement('br',null),' \u53EF\u552E\u573A\u5730\u9762\u79EF\u5E73\u5747\u6536\u5165'),dataIndex:'revpas',key:'revpas',align:"center",width:150,render:function render(text,record,index){var title=['RevPASP 可售场地面积平均收入'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revpas',title:title,sqlName:"_3_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'SPI \u573A\u5730\u6E17\u900F\u7387\u6307\u6570'),dataIndex:'toi',key:'toi',align:"center",width:150,render:function render(text,record,index){var title=['SPI 场地渗透率指数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'toi',title:title,sqlName:"_3_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Ranking \u6392\u540D'),dataIndex:'toi_ranking',key:'toi_ranking',align:"center",width:150,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'toi_ranking',title:title,sqlName:"_3_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'SCI \u5E73\u5747\u6D88\u8D39\u6307\u6570'),dataIndex:'ACI',key:'ACI',align:"center",width:150,render:function render(text,record,index){var title=['SCI 平均消费指数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ACI',title:title,sqlName:"_3_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Ranking \u6392\u540D'),dataIndex:'ACI_ranking',key:'ACI_ranking',align:"center",width:150,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ACI_ranking',title:title,sqlName:"_3_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'RGI \u6536\u76CA\u7387\u6307\u6570'),dataIndex:'RGI',key:'RGI',align:"center",width:150,render:function render(text,record,index){var title=['RGI 收益率指数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'RGI',title:title,sqlName:"_3_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Ranking \u6392\u540D'),dataIndex:'RGI_ranking',key:'RGI_ranking',align:"center",width:150,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'RGI_ranking',title:title,sqlName:"_3_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table3_3_1',style:{width:this.state.print?2450:'auto'}},_react2.default.createElement(_row2.default,null,'6.2.1 MTD This Year \u6708\u7D2F\u8BA1 - \u672C\u5E74\u5F53\u6708'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,'YYYY-MM'),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',style:{width:this.state.print?2400:'auto'},scroll:this.state.print?{}:{x:2400},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_3_3'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(612);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var naeData=['outlets','seats','available','covers','revenue'];var toi_ranking=[];var ACI_ranking=[];var RGI_ranking=[];var _loop=function _loop(i){data[5][naeData[i]]=naeData.reduce(function(a,b,index){a+=numConvert(data[index][naeData[i]]);return a;},0);toi_ranking.push({data:Number(data[i].toi||'0'),key:i});ACI_ranking.push({data:Number(data[i].ACI||'0'),key:i});RGI_ranking.push({data:Number(data[i].RGI||'0'),key:i});data[5][naeData[i]]=data[5][naeData[i]].toFixed(2);};for(var i=0;i<5;i++){_loop(i);}for(var i=0;i<data.length;i++){// 上座率
data[i].turn_over=(numConvert(data[i].available)==0?0:numConvert(data[i].covers)/numConvert(data[i].available)).toFixed(3);// 人均消费
data[i].AC=(numConvert(data[i].covers)==0?0:numConvert(data[i].revenue)/numConvert(data[i].covers)).toFixed(2);// 可售餐位平均收入
data[i].revpas=(numConvert(data[i].available)==0?0:numConvert(data[i].revenue)/numConvert(data[i].available)).toFixed(2);};for(var _i=0;_i<data.length-1;_i++){//  上座率指数
data[_i].toi=(numConvert(data[5].turn_over)==0?0:numConvert(data[_i].turn_over)/numConvert(data[5].turn_over)).toFixed(2);//   人均消费指数
data[_i].ACI=(numConvert(data[5].AC)==0?0:numConvert(data[_i].AC)/numConvert(data[5].AC)).toFixed(2);//   收益率指数
data[_i].RGI=(numConvert(data[5].revpas)==0?0:numConvert(data[_i].revpas)/numConvert(data[5].revpas)).toFixed(2);}// 计算排名
toi_ranking.sort(function(a,b){return b.data-a.data;});ACI_ranking.sort(function(a,b){return b.data-a.data;});RGI_ranking.sort(function(a,b){return b.data-a.data;});toi_ranking.forEach(function(x,i){data[x.key].toi_ranking=i+1;});ACI_ranking.forEach(function(x,i){data[x.key].ACI_ranking=i+1;});RGI_ranking.forEach(function(x,i){data[x.key].RGI_ranking=i+1;});_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;// this.setState({
//     data
// });
_this.computeNum(data);};_this.getDateData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var dataBegin,data,d,data3_1;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dataBegin=JSON.stringify(_data.data3_2_1);data=JSON.parse(dataBegin);_context.next=4;return fetch('/_3_1_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'});case 4:d=_context.sent;_context.next=7;return d.json();case 7:data3_1=_context.sent;fetch('/_3_3_2_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}if(data3_1.data&&data3_1.data.length>0){data=data.map(function(item,index){if(index!=data.length-1){return _extends({},item,{name:data3_1.data[index].name,name_code:data3_1.data[index].name_code});}return _extends({},item);});}if(!data[0].id){_this.setState({loading:false,data:data},function(){_this.onSave();});return;}_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});case 9:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x2){return _ref.apply(this,arguments);};}();_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;};var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});// if (!data.every(x => x.name)) {
//     message.error('名称不能为空，请到3-1-1设置名称！');
//     return
// }
var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_3_3_2  ',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table3_3_2',1.5,'6.22',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);// this.computeNum(this.state.data)
}},{key:'render',value:function render(){var _this3=this;var data=this.state.data;var width=document.body.offsetWidth-2150>300?document.body.offsetWidth-2150:300;var columns=[{title:'Comp Set 竞争集群',dataIndex:'name',key:'name',align:"center",fixed:"left",width:width,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':''),style:{textAlign:"left"}},text);}},{title:_react2.default.createElement('div',null,'No. of Meeting/Events',_react2.default.createElement('br',null),'\u4F1A\u8BAE\u6D3B\u52A8\u573A\u6B21'),dataIndex:'outlets',key:'outlets',align:"center",width:150,render:function render(text,record,index){var title=['No. of Meeting/Events 会议活动场次'];if(index!=5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'outlets',title:title,sqlName:"_3_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('outlets',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'outlets',title:title,sqlName:"_3_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Meeting/Banquet Space SQM',_react2.default.createElement('br',null),'\u573A\u5730\u9762\u79EF\uFF08\u5E73\u65B9\u7C73\uFF09'),dataIndex:'seats',key:'seats',align:"center",width:150,render:function render(text,record,index){var title=['Meeting/Banquet Space SQM 场地面积（平方米）'];if(index!=5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'seats',title:title,sqlName:"_3_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('seats',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'seats',title:title,sqlName:"_3_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Space Available SQM',_react2.default.createElement('br',null),'\u53EF\u552E\u603B\u9762\u79EF(\u5E73\u65B9\u7C73)'),dataIndex:'available',key:'available',align:"center",width:150,render:function render(text,record,index){var title=['Space Available SQM 可售总面积(平方米)'];if(index!=5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'available',title:title,sqlName:"_3_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('available',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'available',title:title,sqlName:"_3_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Sold Space',_react2.default.createElement('br',null),'\u51FA\u552E\u603B\u9762\u79EF \uFF08\u5E73\u65B9\u7C73\uFF09'),dataIndex:'covers',key:'covers',align:"center",width:150,render:function render(text,record,index){var title=['Sold Space 出售总面积 （平方米）'];if(index!=5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'covers',title:title,sqlName:"_3_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('covers',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'covers',title:title,sqlName:"_3_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Space Occupancy',_react2.default.createElement('br',null),' \u4F1A\u8BAE\u573A\u5730\u51FA\u79DF\u7387'),dataIndex:'turn_over',key:'turn_over',align:"center",width:150,render:function render(text,record,index){var title=['Space Occupancy 会议场地出租率'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'turn_over',title:title,sqlName:"_3_3_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Total Catering Revenue',_react2.default.createElement('br',null),' \u5BB4\u4F1A\u6D3B\u52A8\u603B\u6536\u5165'),dataIndex:'revenue',key:'revenue',align:"center",width:150,render:function render(text,record,index){var title=['Total Catering Revenue 宴会活动总收入'];if(index!=5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revenue',title:title,sqlName:"_3_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('revenue',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revenue',title:title,sqlName:"_3_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'S/C\u6BCF\u5E73\u65B9\u7C73\u5E73\u5747\u6D88\u8D39'),dataIndex:'AC',key:'AC',align:"center",width:150,render:function render(text,record,index){var title=['S/C每平方米平均消费'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'AC',title:title,sqlName:"_3_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'RevPASP ',_react2.default.createElement('br',null),' \u53EF\u552E\u573A\u5730\u9762\u79EF\u5E73\u5747\u6536\u5165'),dataIndex:'revpas',key:'revpas',align:"center",width:150,render:function render(text,record,index){var title=['RevPASP 可售场地面积平均收入'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revpas',title:title,sqlName:"_3_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'SPI \u573A\u5730\u6E17\u900F\u7387\u6307\u6570'),dataIndex:'toi',key:'toi',align:"center",width:150,render:function render(text,record,index){var title=['SPI 场地渗透率指数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'toi',title:title,sqlName:"_3_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Ranking \u6392\u540D'),dataIndex:'toi_ranking',key:'toi_ranking',align:"center",width:150,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'toi_ranking',title:title,sqlName:"_3_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'SCI \u5E73\u5747\u6D88\u8D39\u6307\u6570'),dataIndex:'ACI',key:'ACI',align:"center",width:150,render:function render(text,record,index){var title=['SCI 平均消费指数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ACI',title:title,sqlName:"_3_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Ranking \u6392\u540D'),dataIndex:'ACI_ranking',key:'ACI_ranking',align:"center",width:150,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ACI_ranking',title:title,sqlName:"_3_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'RGI \u6536\u76CA\u7387\u6307\u6570'),dataIndex:'RGI',key:'RGI',align:"center",width:150,render:function render(text,record,index){var title=['RGI 收益率指数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'RGI',title:title,sqlName:"_3_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Ranking \u6392\u540D'),dataIndex:'RGI_ranking',key:'RGI_ranking',align:"center",width:150,render:function render(text,record,index){var title=['Ranking 排名'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'RGI_ranking',title:title,sqlName:"_3_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table3_3_2',style:{width:this.state.print?2450:'auto'}},_react2.default.createElement(_row2.default,null,'6.2.2 YTD This  Year \u5E74\u7D2F\u8BA1\u672C\u5E74'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,'YYYY-MM'),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',style:{width:this.state.print?2400:'auto'},scroll:this.state.print?{}:{x:2400},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_3_3'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(6);__webpack_require__(4);__webpack_require__(10);__webpack_require__(25);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TextArea=_input2.default.TextArea;var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.getData=function(date){fetch('/_3_3_3_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this.setState({note:_extends({},x.data[0])});}).catch(function(err){console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=[_extends({},_this.state.note,{year:year,month:month})];if(!data[0].note){_message3.default.error('备注不能为空！');var _timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer);},1000);return;}var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_3_3_3  ',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table3_3_3',1.5,'6.23',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),note:{note:""},loadingSave:false,print:false};return _this;}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){this.getData(this.state.date);}},{key:'render',value:function render(){var _this2=this;return _react2.default.createElement('div',{className:'table7_1_1',style:{margin:24}},_react2.default.createElement(_row2.default,{id:'table3_3_3',style:{padding:this.state.print?20:0}},_react2.default.createElement(_row2.default,{style:{fontSize:20,color:"#333"}},'6.2.3 Remarks \u5907\u6CE8:'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,'YYYY-MM'),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true,note:{note:""}});_this2.getData(str);}})),_react2.default.createElement(_row2.default,{style:{marginTop:20}},_react2.default.createElement(TextArea,{autosize:{minRows:4},value:this.state.note.note,placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',onChange:function onChange(e){_this2.setState({note:_extends({},_this2.state.note,{note:e.target.value})});}}))),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_3_3'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58'))));}}]);return App;}(_react.Component);exports.default=App;

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);__webpack_require__(62);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _data=__webpack_require__(403);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _=__webpack_require__(1516);var _2=_interopRequireDefault(_);var _3=__webpack_require__(1517);var _4=_interopRequireDefault(_3);var _5=__webpack_require__(1520);var _6=_interopRequireDefault(_5);var _note=__webpack_require__(1523);var _note2=_interopRequireDefault(_note);var _setOption=__webpack_require__(1525);var _setOption2=_interopRequireDefault(_setOption);var _compute=__webpack_require__(1820);var _compute2=_interopRequireDefault(_compute);var _7=__webpack_require__(1821);var _8=_interopRequireDefault(_7);var _9=__webpack_require__(1824);var _10=_interopRequireDefault(_9);__webpack_require__(1827);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var confirm=_modal2.default.confirm;var MonthPicker=_datePicker2.default.MonthPicker;var totalIndex=[3,4,5,9,10,11,,15,16,17,21,22,23,27,28,29,33,34,35];var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data,isUpdate){data=(0,_compute2.default)(data,_this.state.date);(0,_setOption2.default)({data:data,dataLast:_this.state.dataLast,date:_this.state.date});_this.setState({data:data,loading:false});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){_this.setState({loading:true});var dataBegin=JSON.stringify(_data.dataDefault);var data=JSON.parse(dataBegin);var month=(0,_moment2.default)(date).format('M');var year=(0,_moment2.default)(date).format('YYYY');fetch('/_4_1_info?year='+year+'&month='+month,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data&&x.data.data.length>0){data=x.data.data.sort(function(a,b){return a.sort-b.sort;});}// 自动填充预算数据，从BP8.2获取
if(x.data.b8_2&&x.data.b8_2.length>0&&month==1&&year>=2020){var b8_2=x.data.b8_2.sort(function(a,b){return a.sort-b.sort;});data=data.map(function(item,i){if(i%3==0&&i<36){var num=Math.ceil((i+1)/3);var _index=(num-1)*4+3;var d=b8_2[_index]||{};delete d.id;return _extends({},item,d,{sort:item.sort});}return item;});}// 自动填充上个月的数据,一月份不适用此方法
if(x.data.lastMonthData&&x.data.lastMonthData.length>0&&month>1){var lastMonthData=x.data.lastMonthData.sort(function(a,b){return a.sort-b.sort;});data=lastMonthData.map(function(item,i){delete item.id;if(data[i].id){item.id=data[i].id;}// 预测数据填写依次自动填充
if((!x.data.data||x.data.data.length<=0)&&Math.ceil((i+1)/3)>month&&i%3==1){return item;}// 本月至12月份的数据，使用当月
if(Math.ceil((i+1)/3)>month-1&&i%3==1){return _extends({},data[i]);}return item;});}if(x.data.lastYearData&&x.data.lastYearData.length>0){var allListName=["best_rn","best_arr","best_rev","corporate_rn","corporate_arr","corporate_rev","government_rn","government_arr","government_rev","packges_rn","packges_arr","packges_rev","wholesale_rn","wholesale_arr","wholesale_rev","commerce_rn","commerce_arr","commerce_rev","discounts_rn","discounts_arr","discounts_rev","total_rn","total_arr","total_rev","business_rn","business_arr","business_rev","leisure_rn","leisure_arr","leisure_rev","group_total_rn","group_total_arr","group_total_rev","contracts_rn","contracts_arr","contracts_rev","others_rev","grand_rn","grand_arr","grand_rev","grand_occ","grand_revpar","grand_rms"];var lastYearData=x.data.lastYearData.sort(function(a,b){return a.sort-b.sort;});// 去年的实际数据填充到Actual Last Year
data=data.map(function(item,i){if(i<=43&&i%3==2){allListName.forEach(function(name){item[name]=(0,_method.getJson)([i-1,name],lastYearData);});return item;}else{return item;}});}_this.setState({data1_1:x.data.data1_1||[],dataLast:x.data.lastYearData||[]});_this.computeNum(data,true);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;var that=_this;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month,sort:i});});// if (month == 1) {
//     const allListName = ["best_rn", "best_arr", "best_rev", "corporate_rn", "corporate_arr", "corporate_rev", "government_rn", "government_arr", "government_rev", "packges_rn", "packges_arr", "packges_rev", "wholesale_rn", "wholesale_arr", "wholesale_rev", "commerce_rn", "commerce_arr", "commerce_rev", "discounts_rn", "discounts_arr", "discounts_rev", "total_rn", "total_arr", "total_rev", "business_rn", "business_arr", "business_rev", "leisure_rn", "leisure_arr", "leisure_rev", "group_total_rn", "group_total_arr", "group_total_rev", "contracts_rn", "contracts_arr", "contracts_rev", "others_rev", "grand_rn", "grand_arr", "grand_rev", "grand_occ", "grand_revpar", "grand_rms"];
//     data.forEach((item, i) => {
//         if (i <= 43 && (i % 3 == 1) && i >= 3) {
//             allListName.forEach(name => {
//                 data[i][name] = data[i - 1][name];
//             })
//         }
//     });
//     this.setState({ data });
// }
var dataFrom=new FormData();dataFrom.append('data',JSON.stringify({data:data,year:year,month:month,isCover:0}));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_4_1',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}else if(x.status==3){_message3.default.error(x.msg);// 数据存在，选择是否进行强制覆盖 isCover=1进行强制覆盖
confirm({title:'数据已被保存是否进行强制覆盖?',content:'强制覆盖之后，已保存的信息将被删除，请查看是否有其他同事在操作当前表格，或者及时联系管理员！',onOk:function onOk(){that.setState({loadingSave:true});var dFrom=new FormData();dFrom.append('data',JSON.stringify({data:data,year:year,month:month,isCover:1}));headres.body=dFrom;fetch('/add_4_1',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){that.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){that.getDateData(that.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){that.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});},onCancel:function onCancel(){}});return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table4_1_1',1.5,'4.11',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+' '+(0,_moment2.default)(_this.state.date).format('YYYY')+' Property Room Budget By Segmentation';var innerHtml='\n          <caption>'+tableName+'</caption>\n          '+document.getElementById('table').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n        ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+'.xls');_this.setState({print:false});};_this.state={date:(0,_moment2.default)().subtract(1,'month').isBefore((0,_moment2.default)('2023-12-31'))?(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'):'2023-12',data:[],loading:true,loadingSave:false,print:false,data1_1:[],dataLast:{}};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this2=this;var _state=this.state,data1_1=_state.data1_1,data=_state.data,date=_state.date,print=_state.print;var year=(0,_moment2.default)(date).format('YYYY');var month=(0,_moment2.default)(date).format('M');var width=document.body.offsetWidth-6450>350?document.body.offsetWidth-6450:350;var columns=[{title:'MONTH',dataIndex:'name',key:'name',align:"center",fixed:print?false:"left",width:width*0.5,render:function render(text,record,index){var props={text:text,index:index,type:'textcenter',name:"name",onChange:_this2.onChange,totalIndex:totalIndex};if(index<42&&index%3==0){return{props:{rowSpan:3},children:_react2.default.createElement(_TableText2.default,{data:props})};}if(index===42||index===45){return{props:{rowSpan:2},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{text:index==42?'% to Budget '+year:text})})};}if(index===44){return _react2.default.createElement(_TableText2.default,{data:props});}return{props:{rowSpan:0}};}},{title:'',dataIndex:'month_status',key:'month_status',align:"center",fixed:print?false:"left",width:width*0.5,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this2.onChange,totalIndex:totalIndex};if(index<42&&index!=40){var str='';if(index%3==0)str='Budget '+year;if(index%3==1)str=(Math.ceil((index+1)/3)<=month?'Actual':"Forecast")+' '+year;if(index%3==2)str='Actual Last Year';// if (index == 34) {
//     if (index % 3 == 1) str = `${Math.ceil((index + 1) / 3) == month ? `Actual ${year}` : `Forecast ${year}`} `;
// }
if(index==37)str='Actual '+year;return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{text:str})});}var t='';if(index==46)t='Act/Fcst '+year;if(index==45)t='Budget '+year;if(index==44)t='YTD Actual '+year;if(index==43)t='Y/E Fcast '+year;if(index==42)t='YTD Actual '+year;if(index==40)t='Act/Fcst '+year;return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{text:t})});}},{title:'BEST RATES',width:450,children:[{title:'R/Nts',dataIndex:'best_rn',key:'best_rn',align:"center",width:150,render:function render(text,record,index){var title=['BEST RATES','R/Nts',record.month_status_name];var props={text:text,index:index,type:'number',name:"best_rn",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
// 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';if(index>=42)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'A.R.R',dataIndex:'best_arr',key:'best_arr',width:150,align:"center",render:function render(text,record,index){var title=['BEST RATES','A.R.R',record.month_status_name];var props={text:text,index:index,type:'number',name:"best_arr",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';if(index>=42)type='percent';if(index>=45)type='';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Revenue',dataIndex:'best_rev',key:'best_rev',align:"center",width:150,render:function render(text,record,index){var title=['BEST RATES','Revenue',record.month_status_name];var props={text:text,index:index,type:'number',name:"best_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
// 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';if(index>=42)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}}]},{title:'CORPORATE NEGOTIATED',width:450,children:[{title:'R/Nts',dataIndex:'corporate_rn',key:'corporate_rn',align:"center",width:150,render:function render(text,record,index){var title=['CORPORATE NEGOTIATED','R/Nts',record.month_status_name];var props={text:text,index:index,type:'number',name:"corporate_rn",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
// 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';if(index>=42)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'A.R.R',dataIndex:'corporate_arr',key:'corporate_arr',width:150,align:"center",render:function render(text,record,index){var title=['CORPORATE NEGOTIATED','A.R.R',record.month_status_name];var props={text:text,index:index,type:'number',name:"corporate_arr",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';if(index>=42)type='percent';if(index>=45)type='';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Revenue',dataIndex:'corporate_rev',key:'corporate_rev',align:"center",width:150,render:function render(text,record,index){var title=['CORPORATE NEGOTIATED','Revenue',record.month_status_name];var props={text:text,index:index,type:'number',name:"corporate_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
// 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';if(index>=42)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}}]},{title:'GOVERNMENT / EMBASSY',width:450,children:[{title:'R/Nts',dataIndex:'government_rn',key:'government_rn',align:"center",width:150,render:function render(text,record,index){var title=['GOVERNMENT / EMBASSY','R/Nts',record.month_status_name];var props={text:text,index:index,type:'number',name:"government_rn",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
// 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';if(index>=42)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'A.R.R',dataIndex:'government_arr',key:'government_arr',width:150,align:"center",render:function render(text,record,index){var title=['GOVERNMENT / EMBASSY','A.R.R',record.month_status_name];var props={text:text,index:index,type:'number',name:"government_arr",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';if(index>=42)type='percent';if(index>=45)type='';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Revenue',dataIndex:'government_rev',key:'government_rev',align:"center",width:150,render:function render(text,record,index){var title=['GOVERNMENT / EMBASSY','Revenue',record.month_status_name];var props={text:text,index:index,type:'number',name:"government_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
// 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';if(index>=42)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}}]},{title:'PACKAGES',width:450,children:[{title:'R/Nts',dataIndex:'packges_rn',key:'packges_rn',align:"center",width:150,render:function render(text,record,index){var title=['PACKAGES','R/Nts',record.month_status_name];var props={text:text,index:index,type:'number',name:"packges_rn",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
// 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';if(index>=42)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'A.R.R',dataIndex:'packges_arr',key:'packges_arr',width:150,align:"center",render:function render(text,record,index){var title=['PACKAGES','A.R.R',record.month_status_name];var props={text:text,index:index,type:'number',name:"packges_arr",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';if(index>=42)type='percent';if(index>=45)type='';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Revenue',dataIndex:'packges_rev',key:'packges_rev',align:"center",width:150,render:function render(text,record,index){var title=['PACKAGES','Revenue',record.month_status_name];var props={text:text,index:index,type:'number',name:"packges_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
// 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';if(index>=42)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}}]},{title:'WHOLESALE',width:450,children:[{title:'R/Nts',dataIndex:'wholesale_rn',key:'wholesale_rn',align:"center",width:150,render:function render(text,record,index){var title=['WHOLESALE','R/Nts',record.month_status_name];var props={text:text,index:index,type:'number',name:"wholesale_rn",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
// 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';if(index>=42)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'A.R.R',dataIndex:'wholesale_arr',key:'wholesale_arr',width:150,align:"center",render:function render(text,record,index){var title=['WHOLESALE','A.R.R',record.month_status_name];var props={text:text,index:index,type:'number',name:"wholesale_arr",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';if(index>=42)type='percent';if(index>=45)type='';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Revenue',dataIndex:'wholesale_rev',key:'wholesale_rev',align:"center",width:150,render:function render(text,record,index){var title=['WHOLESALE','Revenue',record.month_status_name];var props={text:text,index:index,type:'number',name:"wholesale_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
// 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';if(index>=42)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}}]},{title:'E-COMMERCE',width:450,children:[{title:'R/Nts',dataIndex:'commerce_rn',key:'commerce_rn',align:"center",width:150,render:function render(text,record,index){var title=['E-COMMERCE','R/Nts',record.month_status_name];var props={text:text,index:index,type:'number',name:"commerce_rn",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
// 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';if(index>=42)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'A.R.R',dataIndex:'commerce_arr',key:'commerce_arr',width:150,align:"center",render:function render(text,record,index){var title=['E-COMMERCE','A.R.R',record.month_status_name];var props={text:text,index:index,type:'number',name:"commerce_arr",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';if(index>=42)type='percent';if(index>=45)type='';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Revenue',dataIndex:'commerce_rev',key:'commerce_rev',align:"center",width:150,render:function render(text,record,index){var title=['E-COMMERCE','Revenue',record.month_status_name];var props={text:text,index:index,type:'number',name:"commerce_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
// 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';if(index>=42)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}}]},{title:'DISCOUNTS',width:450,children:[{title:'R/Nts',dataIndex:'discounts_rn',key:'discounts_rn',align:"center",width:150,render:function render(text,record,index){var title=['DISCOUNTS','R/Nts',record.month_status_name];var props={text:text,index:index,type:'number',name:"discounts_rn",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
// 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';if(index>=42)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'A.R.R',dataIndex:'discounts_arr',key:'discounts_arr',width:150,align:"center",render:function render(text,record,index){var title=['DISCOUNTS','A.R.R',record.month_status_name];var props={text:text,index:index,type:'number',name:"discounts_arr",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';if(index>=42)type='percent';if(index>=45)type='';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Revenue',dataIndex:'discounts_rev',key:'discounts_rev',align:"center",width:150,render:function render(text,record,index){var title=['DISCOUNTS','Revenue',record.month_status_name];var props={text:text,index:index,type:'number',name:"discounts_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
// 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';if(index>=42)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}}]},{title:'TOTAL TRANSIENT',width:450,children:[{title:'R/Nts',dataIndex:'total_rn',key:'total_rn',align:"center",width:150,render:function render(text,record,index){var title=['TOTAL TRANSIENT','R/Nts',record.month_status_name];var props={text:text,index:index,type:index>=42?"percent":'number',name:"total_rn",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'A.R.R',dataIndex:'total_arr',key:'total_arr',width:150,align:"center",render:function render(text,record,index){var title=['TOTAL TRANSIENT','A.R.R',record.month_status_name];var props={text:text,index:index,type:index>=42?"percent":'number',name:"total_arr",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};if(index>=45)props.type='';return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Revenue',dataIndex:'total_rev',key:'total_rev',align:"center",width:150,render:function render(text,record,index){var title=['TOTAL TRANSIENT','Revenue',record.month_status_name];var props={text:text,index:index,type:index>=42?"percent":'number',name:"total_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:'GROUP BUSINESS',width:450,children:[{title:'R/Nts',dataIndex:'business_rn',key:'business_rn',align:"center",width:150,render:function render(text,record,index){var title=['GROUP BUSINESS','R/Nts',record.month_status_name];var props={text:text,index:index,type:'number',name:"business_rn",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
// 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';if(index>=42)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'A.R.R',dataIndex:'business_arr',key:'business_arr',width:150,align:"center",render:function render(text,record,index){var title=['GROUP BUSINESS','A.R.R',record.month_status_name];var props={text:text,index:index,type:'number',name:"business_arr",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';if(index>=42)type='percent';if(index>=45)type='';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Revenue',dataIndex:'business_rev',key:'business_rev',align:"center",width:150,render:function render(text,record,index){var title=['GROUP BUSINESS','Revenue',record.month_status_name];var props={text:text,index:index,type:'number',name:"business_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
// 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';if(index>=42)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}}]},{title:'GROUP LEISURE',width:450,children:[{title:'R/Nts',dataIndex:'leisure_rn',key:'leisure_rn',align:"center",width:150,render:function render(text,record,index){var title=['GROUP LEISURE','R/Nts',record.month_status_name];var props={text:text,index:index,type:'number',name:"leisure_rn",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
// 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';if(index>=42)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'A.R.R',dataIndex:'leisure_arr',key:'leisure_arr',width:150,align:"center",render:function render(text,record,index){var title=['GROUP LEISURE','A.R.R',record.month_status_name];var props={text:text,index:index,type:'number',name:"leisure_arr",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';if(index>=42)type='percent';if(index>=45)props.type='';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Revenue',dataIndex:'leisure_rev',key:'leisure_rev',align:"center",width:150,render:function render(text,record,index){var title=['GROUP LEISURE','Revenue',record.month_status_name];var props={text:text,index:index,type:'number',name:"leisure_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
// 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';if(index>=42)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}}]},{title:'TOTAL GROUPS',width:450,children:[{title:'R/Nts',dataIndex:'group_total_rn',key:'group_total_rn',align:"center",width:150,render:function render(text,record,index){var title=['TOTAL GROUPS','R/Nts',record.month_status_name];var props={text:text,index:index,type:index>=42?"percent":'number',name:"group_total_rn",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'A.R.R',dataIndex:'group_total_arr',key:'group_total_arr',width:150,align:"center",render:function render(text,record,index){var title=['TOTAL GROUPS','A.R.R',record.month_status_name];var props={text:text,index:index,type:index>=42?"percent":'number',name:"group_total_arr",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};if(index>=45)props.type='';return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Revenue',dataIndex:'group_total_rev',key:'group_total_rev',align:"center",width:150,render:function render(text,record,index){var title=['TOTAL GROUPS','Revenue',record.month_status_name];var props={text:text,index:index,type:index>=42?"percent":'number',name:"group_total_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:'CONTRACTS',width:450,children:[{title:'R/Nts',dataIndex:'contracts_rn',key:'contracts_rn',align:"center",width:150,render:function render(text,record,index){var title=['CONTRACTS','R/Nts',record.month_status_name];var props={text:text,index:index,type:'number',name:"contracts_rn",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
// 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';if(index>=42)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'A.R.R',dataIndex:'contracts_arr',key:'contracts_arr',width:150,align:"center",render:function render(text,record,index){var title=['CONTRACTS','A.R.R',record.month_status_name];var props={text:text,index:index,type:'number',name:"contracts_arr",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';if(index>=42)type='percent';if(index>=45)type='';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Revenue',dataIndex:'contracts_rev',key:'contracts_rev',align:"center",width:150,render:function render(text,record,index){var title=['CONTRACTS','Revenue',record.month_status_name];var props={text:text,index:index,type:'number',name:"contracts_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
// 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';if(index>=42)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}}]},{title:'OTHERS',width:450,children:[{title:'Revenue',dataIndex:'others_rev',key:'others_rev',align:"center",width:150,render:function render(text,record,index){var title=['OTHERS','Revenue',record.month_status_name];var props={text:text,index:index,type:'number',name:"others_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type='number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';if(index>=42)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}}]},{title:'GRAND TOTAL',width:450,children:[{title:'R/Nts',dataIndex:'grand_rn',key:'grand_rn',align:"center",width:150,render:function render(text,record,index){var title=['GRAND TOTAL','R/Nts',record.month_status_name];var props={text:text,index:index,type:index>=42?"percent":'number',name:"grand_rn",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'A.R.R',dataIndex:'grand_arr',key:'grand_arr',width:150,align:"center",render:function render(text,record,index){var title=['GRAND TOTAL','A.R.R',record.month_status_name];var props={text:text,index:index,type:index>44?'-':index>=42?"percent":'number',name:"grand_arr",yellowText:index===40&&(0,_method.numConvert)(text)!=(0,_method.numConvert)((0,_method.getJson)([3,'whole_actual'],data1_1))&&"与ES1.1数据不一致，请检查！",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Revenue',dataIndex:'grand_rev',key:'grand_rev',align:"center",width:150,render:function render(text,record,index){var title=['GRAND TOTAL','Revenue',record.month_status_name];var props={text:text,index:index,type:index>=42?"percent":'number',name:"grand_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Occ %',dataIndex:'grand_occ',key:'grand_occ',align:"center",width:150,render:function render(text,record,index){var title=['GRAND TOTAL','Occ %',record.month_status_name];var props={text:text,index:index,type:index>44?'-':"percent",name:"grand_occ",yellowText:index===40&&(0,_method.numConvert)(text)!=(0,_method.numConvert)((0,_method.getJson)([2,'whole_actual'],data1_1))&&"与ES1.1数据不一致，请检查！",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'RevPAR',dataIndex:'grand_revpar',key:'grand_revpar',align:"center",width:150,render:function render(text,record,index){var title=['GRAND TOTAL','RevPAR',record.month_status_name];var props={text:text,index:index,type:index>44?'-':index>=42?"percent":'number',name:"grand_revpar",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Available Rms',dataIndex:'grand_rms',key:'grand_rms',align:"center",width:150,render:function render(text,record,index){var title=['GRAND TOTAL','Available Rms',record.month_status_name];var props={text:text,index:index,type:index>41?'-':'number',name:"grand_rms",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_rev"}};var type=index>41?'-':'number';// 取消第一行预算的填写
// if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1)type='inputNumber';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}}]}];return _react2.default.createElement('div',null,_react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1 tableHeight'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_1_1',style:{width:print?6850:'auto'}},_react2.default.createElement(_row2.default,null,'4.1.1 Monthly Market Segmentation report \u6708\u5EA6\u5E02\u573A\u7EC6\u5206\u62A5\u8868'),_react2.default.createElement(_row2.default,{style:{fontSize:14,margin:"10px 0"}},'\u82E5\u663E\u793A\u9EC4\u8272\u9884\u8B66\uFF0C\u8BF7\u6838\u5BF9\u4E0EES1.1\u7684\u6574\u5E74\u9884\u6D4B\u4E2D\u53EF\u552E\u623F\u91CF\uFF0C\u5DF2\u552E\u623F\u91CF\uFF0C\u6536\u76CA\u603B\u989D\u8FD9\u4E09\u7EC4\u6570\u636E\u662F\u5426\u4E00\u81F4\u3002'),_react2.default.createElement(_row2.default,{style:{fontSize:14,margin:"10px 0",color:"red"}},'\u6B64\u8868\u4ECE2024\u5E74\u8D77\u505C\u6B62\u4F7F\u7528'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},disabledDate:function disabledDate(v){if((0,_moment2.default)(v).isBefore((0,_moment2.default)('2023-12-31')))return false;return true;},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[]});_this2.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',id:'table',bordered:true,pagination:false,rowClassName:'protruding',className:'content',style:{width:print?6800:'auto'},scroll:print?{}:{x:6800,y:500},rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement('div',{className:'chart-4-1'},_react2.default.createElement('div',{id:'chartOcc'}),_react2.default.createElement('div',{id:'chartAdr'}),_react2.default.createElement('div',{id:'chartRevpar'}),_react2.default.createElement('div',{id:'chartRev'}))),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){_this2.setState({print:true},function(){_this2.downloadExcel();});},loading:print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_4_1'},_react2.default.createElement(_button2.default,{type:'primary',style:{margin:'0 10px'},onClick:this.downloadSG,loading:print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58'))))),_react2.default.createElement(_2.default,{key:2}),_react2.default.createElement(_4.default,null),_react2.default.createElement(_6.default,null),_react2.default.createElement(_8.default,null),_react2.default.createElement(_10.default,null),_react2.default.createElement(_note2.default,null));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(8);__webpack_require__(6);__webpack_require__(4);__webpack_require__(10);__webpack_require__(25);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _data=__webpack_require__(403);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _method2=_interopRequireDefault(_method);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var TextArea=_input2.default.TextArea;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.onChange=function(name,value,i){var data=[].concat(_toConsumableArray(_this.state.data));data[i][name]=value;data.forEach(function(item,index){if(index<data.length-1){data[index]['total']=['first','second','third'].reduce(function(a,b){return a+=(0,_method.numConvert)(data[index][b]);},0).toFixed(2);}});['target','total','first','second','third'].forEach(function(name){data[data.length-1][name]=data.reduce(function(a,b,index){return index>=data.length-1?a:a+=(0,_method.numConvert)(b[name]);},0).toFixed(2);});_this.setState({data:data});};_this.getDateData=function(date,isLastMonth){var dataBegin=JSON.stringify(_data.data4_1_2);var data=JSON.parse(dataBegin);var year=_this.state.year;if(isLastMonth){date=date-1>0?date-1:1;if(_this.state.data.some(function(x){return x.id;}))return _message3.default.error('当月数据已存在，无法填充！');_this.setState({data:[],loading:true});}fetch('/_4_1_2_info?quarter='+date+'&year='+year,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}if(isLastMonth){data=data.map(function(x){delete x.id;return x;});}_this.setState({data:data,loading:false});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;var year=_this.state.year;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var data=_this.state.data.map(function(x,i){return _extends({},x,{quarter:date,year:year});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_4_1_2',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table4_1_2',1.5,'4.12',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+' Sales Selling Strategy & Action Plan';var innerHtml='\n          <caption>'+tableName+'</caption>\n          '+document.getElementById('table4').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n        ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+'.xls');_this.setState({print:false});};_this.downloadSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var date,res,blob,file;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;date=_this.state.date;_context.next=4;return fetch('/saveExcelActionPlan?quarter='+date,{credentials:'include'});case 4:res=_context.sent;_context.next=7;return res.blob();case 7:blob=_context.sent;file=new Blob([blob],{type:""});_fileSaver2.default.saveAs(file,'Sales Selling Strategy & Action Plan \u7B2C'+date+'\u5B63\u5EA6.xls');_this.setState({loading:false});_context.next=17;break;case 13:_context.prev=13;_context.t0=_context['catch'](0);_message3.default.error('导出失败！');_this.setState({loading:false});case 17:case'end':return _context.stop();}}},_callee,_this2,[[0,13]]);}));_this.state={date:(0,_moment2.default)().subtract(1,'month').format('Q'),year:(0,_moment2.default)().subtract(1,'month').format('YYYY'),data:[],loading:true,loadingSave:false,print:false,dateData:[]};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){var year=Number(this.state.year||"0");var dateData=[];var len=year-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});this.getDateData(this.state.date);}// 导出酒店保存情况
},{key:'render',value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print,loading=_state.loading,dateData=_state.dateData,year=_state.year;var len=data.length-1;var totalData=[];var columns=[{title:_react2.default.createElement('div',null,'No.',_react2.default.createElement('br',null),'\u5E8F\u53F7'),dataIndex:'index',key:'index',align:'center',width:50,render:function render(text,record,index){if(index==data.length-1){return{props:{colSpan:4},children:_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"right"}},record.name)};}return _react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"left"}},index+1);}},{title:_react2.default.createElement('div',null,'Market Segment',_react2.default.createElement('br',null),'\u7EC6\u5206\u5E02\u573A'),dataIndex:'name',key:'name',align:'center',width:200,render:function render(text,record,index){if(index==data.length-1){return{props:{colSpan:0}};}return _react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"left"}},text);}},{title:_react2.default.createElement('div',null,'Key Strategy ',_react2.default.createElement('br',null),'\u4E3B\u8981\u7B56\u7565'),dataIndex:'strategy',key:'strategy',align:"center",width:300,render:function render(text,record,index){if(index==data.length-1){return{props:{colSpan:0}};}return _react2.default.createElement('div',{className:'table-padding table-color-number'},print?text:_react2.default.createElement(TextArea,{autosize:{minRows:4},defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this3.onChange('strategy',value,index);}}));}},{title:_react2.default.createElement('div',null,'Action Plans',_react2.default.createElement('br',null),'\u884C\u52A8\u8BA1\u5212'),dataIndex:'plans',key:'plans',align:"center",width:300,render:function render(text,record,index){if(index==data.length-1){return{props:{colSpan:0}};}return _react2.default.createElement('div',{className:'table-padding table-color-number'},print?text:_react2.default.createElement(TextArea,{autosize:{minRows:4},defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this3.onChange('plans',value,index);}}));}},{title:_react2.default.createElement('div',null,'Target Room Nts ',_react2.default.createElement('br',null),'\u76EE\u6807\u95F4\u591C ',date*3-2,'-',date*3,'\u6708\u4EFD'),dataIndex:'target',key:'target',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:print||len==index?'number':'inputNumber',name:"target",onChange:_this3.onChange,totalIndex:totalData};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:_react2.default.createElement('div',null,'Result  Room Nts ',_react2.default.createElement('br',null),'\u5B8C\u6210\u95F4\u591C'),align:"center",children:[{title:date*3-2+'\u6708',dataIndex:'first',key:'first',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:print||len==index?'number':'inputNumber',name:"first",onChange:_this3.onChange,totalIndex:totalData};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:date*3-1+'\u6708',dataIndex:'second',key:'second',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:print||len==index?'number':'inputNumber',name:"second",onChange:_this3.onChange,totalIndex:totalData};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:date*3+'\u6708',dataIndex:'third',key:'third',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:print||len==index?'number':'inputNumber',name:"third",onChange:_this3.onChange,totalIndex:totalData};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Total',dataIndex:'total',key:'total',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"total",onChange:_this3.onChange,totalIndex:totalData};return _react2.default.createElement(_TableText2.default,{data:props});}}]}];return _react2.default.createElement('div',{className:'table table2_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_1_2',style:{width:this.state.print?2475:'auto'}},_react2.default.createElement(_row2.default,null,'4.1.2 Sales Selling Strategy & Action Plan \u9500\u552E\u7B56\u7565\u548C\u884C\u52A8\u8BA1\u5212'),_react2.default.createElement(_row2.default,{style:{fontSize:14,margin:"10px 0"}},'1.  \u6BCF\u6708\u7B2C\u4E00\u5468\u5185\u63D0\u4EA4\u5305\u542B\u5F53\u6708\u7684\u5B63\u5EA6\u62A5\u8868\uFF0C\u5B63\u5EA6\u6700\u540E\u4E00\u6708\u9700\u63D0\u4EA4\u5F53\u5B63\u5EA6\u548C\u6B21\u5B63\u5EA6\u4E24\u4EFD',_react2.default.createElement('br',null),'2.  \u62A5\u8868\u4E2D\u7684\u586B\u5199\u680F\u7684\u89E3\u91CA',_react2.default.createElement('br',null),'\uFF081\uFF09\u201C\u4E3B\u8981\u7B56\u7565\u201D\u201C\u884C\u52A8\u8BA1\u5212\u201D\uFF1A\u5BF9\u4E8E\u540C\u4E00\u5B63\u5EA6\u62A5\u8868\uFF0C\u4E8E\u6BCF\u6708\u7B2C\u4E00\u5468\u5185\u63D0\u4EA4\u7684\u8FD9\u4E24\u680F\u5185\u5BB9\u57FA\u672C\u4E0D\u53D8\uFF0C\u82E5\u6709\u9700\u8981\u9152\u5E97\u4E5F\u53EF\u5728\u539F\u586B\u5199\u5185\u5BB9\u7684\u57FA\u7840\u4E0A\u65B0\u589E',_react2.default.createElement('br',null),'\uFF082\uFF09\u201C\u76EE\u6807\u95F4\u591C\u201D\uFF1A\u57FA\u4E8E\u9152\u5E97\u6BCF\u6708Budget\u76F8\u52A0\u603B\u548C\u8FDB\u884C\u5236\u5B9A\uFF0C\u4EE5\u5B8C\u6210Budget\u4E3A\u76EE\u6807\uFF0C\u5236\u5B9A\u7684\u76EE\u6807\u95F4\u591C\u53EF\u6709\u4E24\u79CD\u65B9\u5411\uFF1A\uFF08a\uFF09\u7B49\u540C\u4E8EBudget\uFF0C\u6216\uFF08b\uFF09\u7B49\u540C\u4E8EES4.1\u4E2D\u7684Forecast\u3002',_react2.default.createElement('br',null),'\uFF083\uFF09\u201C\u5B8C\u6210\u95F4\u591CResult Night\u201D\uFF1A\u6307\u7684\u662F\u6BCF\u6708\u622A\u6B62\u5230\u63D0\u4EA4\u6B64\u62A5\u8868\u65F6\u9152\u5E97PMS\u7CFB\u7EDF\u4E2D\u5BF9\u5E94\u6708\u4EFD\u7684On-Book\u95F4\u591C\u6570\u636E\u3002'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(_select2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u4EFD',style:{width:120,marginRight:10},value:year,onChange:function onChange(str){_this3.setState({year:str,data:[]},function(){_this3.getDateData(date);});}},dateData.map(function(x,i){return _react2.default.createElement(Option,{value:x,key:x},x,'\u5E74');})),_react2.default.createElement(_select2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u4EFD',style:{width:200},value:this.state.date,onChange:function onChange(str){_this3.setState({date:str,data:[]});_this3.getDateData(str);}},_react2.default.createElement(Option,{value:'1'},'Q1 \u7B2C\u4E00\u5B63\u5EA6'),_react2.default.createElement(Option,{value:'2'},'Q2 \u7B2C\u4E8C\u5B63\u5EA6'),_react2.default.createElement(Option,{value:'3'},'Q3 \u7B2C\u4E09\u5B63\u5EA6'),_react2.default.createElement(Option,{value:'4'},'Q4 \u7B2C\u56DB\u5B63\u5EA6')),_react2.default.createElement(_button2.default,{type:'primary',style:{marginLeft:10,display:this.state.print?'none':''},onClick:this.getDateData.bind(this,this.state.date,true)},'\u586B\u5145\u4E0A\u5B63\u5EA6\u6570\u636E')),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',className:'content',bordered:true,loading:loading,id:'table4',pagination:false,scroll:print?{}:{y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},(0,_method2.default)(['auth','user','email'],this.props.store,'').includes('admin')&&_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this3.setState({loading:true},function(){_this3.downloadSave();});},loading:this.state.print},'\u5BFC\u51FA\u9152\u5E97\u4FDD\u5B58\u60C5\u51B5'),_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_4_1'},_react2.default.createElement(_button2.default,{type:'primary',style:{margin:'0 10px'},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58'))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _data=__webpack_require__(1518);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _compute=__webpack_require__(1519);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var totalIndex=[7,10];var percentindex=[15];var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(data){var newData;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_compute.computeNew)(_this.state.monthDataAll,data);case 2:newData=_context.sent;_this.setState({data:newData},function(){if(_this.state.monthDataAll.data&&_this.state.monthDataAll.data.length>0){_this.onSave();}});case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data3_2_1);var data=JSON.parse(dataBegin);var year=(0,_moment2.default)(date).format('YYYY');var month=(0,_moment2.default)(date).format('M');fetch('/_4_2_info?year='+year+'&month='+month,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data&&x.data.data.length>0){data=x.data.data.sort(function(a,b){return a.sort-b.sort;});}var monthDataAll={data:(x.data.month||[]).sort(function(a,b){return a.sort-b.sort;}),lastMonthData:(x.data.lastMonthData||[]).sort(function(a,b){return a.sort-b.sort;})};_this.setState({loading:false,monthDataAll:monthDataAll},function(){_this.computeNum(data);});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format('YYYY');var month=(0,_moment2.default)(date).format('M');var data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_4_2',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table4_1_1',1.5,'4.13',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+' '+(0,_moment2.default)(_this.state.date).format('YYYY')+'REVENUE PLAN - MARKET SEGMENTATION ANALYSIS REPORT';var innerHtml='\n          <caption>'+tableName+'</caption>\n          '+document.getElementById('table4_2').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n        ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+'.xls');_this.setState({print:false});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),dateData:[],data:[],loading:true,loadingSave:false,print:false,monthDataAll:{}};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date;var year=date;var width=document.body.offsetWidth-2400>300?document.body.offsetWidth-2400:300;var columns=[{title:'YEAR TO DATE',dataIndex:'name',key:'name',align:"center",fixed:this.state.print?false:"left",width:width,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"left"}},text||"-");}},{title:'Whole Year Budget',width:750,children:[{title:_react2.default.createElement('div',null,'R/Nts'),dataIndex:'budget_r_nts',key:'budget_r_nts',align:"center",width:150,render:function render(text,record,index){var title=['Whole Year Budget','R/Nts'];if(percentindex.includes(index)){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'budget_r_nts',title:title,sqlName:"_4_2_rev",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'budget_r_nts',title:title,sqlName:"_4_2_rev",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Mix%'),dataIndex:'budget_nts_mix',key:'budget_nts_mix',align:"center",width:150,render:function render(text,record,index){var title=['Whole Year Budget','Mix%'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'budget_nts_mix',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}},{title:_react2.default.createElement('div',null,'A.R.R'),dataIndex:'budget_arr',key:'budget_arr',align:"center",width:150,render:function render(text,record,index){var title=['Whole Year Budget','A.R.R'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'budget_arr',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}},{title:_react2.default.createElement('div',null,'Rev'),dataIndex:'budget_rev',key:'budget_rev',align:"center",width:150,render:function render(text,record,index){var title=['Whole Year Budget','Rev'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'budget_rev',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}},{title:_react2.default.createElement('div',null,'Mix%'),dataIndex:'budget_rev_mix',key:'budget_rev_mix',align:"center",width:150,render:function render(text,record,index){var title=['Whole Year Budget','Mix%'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'budget_rev_mix',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}}]},{title:'Whole Year Actual + Forecast',width:750,children:[{title:_react2.default.createElement('div',null,'R/Nts'),dataIndex:'sum_r_nts',key:'sum_r_nts',align:"center",width:150,render:function render(text,record,index){var title=['Whole Year Actual + Forecast','R/Nts'];if(percentindex.includes(index)){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'sum_r_nts',title:title,sqlName:"_4_2_rev",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'sum_r_nts',title:title,sqlName:"_4_2_rev",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Mix%'),dataIndex:'sum_nts_mix',key:'sum_nts_mix',align:"center",width:150,render:function render(text,record,index){var title=['Whole Year Actual + Forecast','Mix%'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'sum_nts_mix',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}},{title:_react2.default.createElement('div',null,'A.R.R'),dataIndex:'sum_arr',key:'sum_arr',align:"center",width:150,render:function render(text,record,index){var title=['Whole Year Actual + Forecast','A.R.R'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'sum_arr',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}},{title:_react2.default.createElement('div',null,'Rev'),dataIndex:'sum_rev',key:'sum_rev',align:"center",width:150,render:function render(text,record,index){var title=['Whole Year Actual + Forecast','Rev'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'sum_rev',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}},{title:_react2.default.createElement('div',null,'Mix%'),dataIndex:'sum_rev_mix',key:'sum_rev_mix',align:"center",width:150,render:function render(text,record,index){var title=['Whole Year Actual + Forecast','Mix%'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'sum_rev_mix',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}}]},{title:'Diff%',width:750,children:[{title:_react2.default.createElement('div',null,'R/Nts'),dataIndex:'diff_r_nts',key:'diff_r_nts',align:"center",width:150,render:function render(text,record,index){var title=['Diff%','R/Nts'];if(percentindex.includes(index)){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'diff_r_nts',title:title,sqlName:"_4_2_rev",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'diff_r_nts',title:title,sqlName:"_4_2_rev",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'% Diff'),dataIndex:'diff_nts_mix',key:'diff_nts_mix',align:"center",width:150,render:function render(text,record,index){var title=['Diff%','% Diff'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'diff_nts_mix',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}},{title:_react2.default.createElement('div',null,'A.R.R'),dataIndex:'diff_arr',key:'diff_arr',align:"center",width:150,render:function render(text,record,index){var title=['Diff%','A.R.R'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'diff_arr',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}},{title:_react2.default.createElement('div',null,'% Diff'),dataIndex:'diff_arr_mix',key:'diff_arr_mix',align:"center",width:150,render:function render(text,record,index){var title=['Diff%','% Diff'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'diff_arr_mix',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}},{title:_react2.default.createElement('div',null,'Rev'),dataIndex:'diff_rev',key:'diff_rev',align:"center",width:150,render:function render(text,record,index){var title=['Diff%','Rev'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'diff_rev',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}},{title:_react2.default.createElement('div',null,'% Diff'),dataIndex:'diff_rev_mix',key:'diff_rev_mix',align:"center",width:150,render:function render(text,record,index){var title=['Diff%','% Diff'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'diff_rev_mix',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_1_1',style:{width:this.state.print?2750:'auto'}},_react2.default.createElement(_row2.default,null,'4.1.3 Yearly Market Segmentation report \u5E74\u5EA6\u5E02\u573A\u7EC6\u5206\u62A5\u8868'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',id:'table4_2',bordered:true,pagination:false,className:'content',style:{width:this.state.print?2700:'auto'},scroll:this.state.print?{}:{x:2700,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_4_1'},_react2.default.createElement(_button2.default,{type:'primary',style:{margin:'0 10px'},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data3_2_1=exports.data3_2_1=[{name:'BAR',sort:0,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'Corp Negotiated',sort:1,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'Government',sort:2,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'Packages',sort:3,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'Wholesale',sort:4,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'E-Commerce',sort:5,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'Discounts',sort:6,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'TTL TRANSIENT',sort:7,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'Group Business',sort:8,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'Group Leisure',sort:9,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'TTL GROUP',sort:10,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'CONTRACT',sort:11,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'OTHERS',sort:12,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'GRAND TOTAL',sort:13,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'Available Rms',sort:14,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'Occupancy %',sort:15,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'RevPAR',sort:16,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0}];

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.compute=compute;exports.computeNew=computeNew;var _method=__webpack_require__(20);function compute(){var monthDataAll=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var thisData=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var _monthDataAll$lastMon=monthDataAll.lastMonthData,lastMonthData=_monthDataAll$lastMon===undefined?[]:_monthDataAll$lastMon;var monthData=!monthDataAll.data||monthDataAll.data.length<=0?lastMonthData:monthDataAll.data;var data=thisData;var controlName=[{name:"best",index:0},{name:"corporate",index:1},{name:"government",index:2},{name:"packges",index:3},{name:"wholesale",index:4},{name:"commerce",index:5},{name:"discounts",index:6},{name:"business",index:8},{name:"leisure",index:9}];// 从月度表格更新数据
controlName.forEach(function(item){data[item.index].budget_r_nts=(0,_method.getNumber)([39,item.name+"_rn"],monthData).toFixed(2);data[item.index].budget_rev=(0,_method.getNumber)([39,item.name+"_rev"],monthData).toFixed(2);data[item.index].sum_r_nts=(0,_method.getNumber)([40,item.name+"_rn"],monthData).toFixed(2);data[item.index].sum_rev=(0,_method.getNumber)([40,item.name+"_rev"],monthData).toFixed(2);});data[11].budget_r_nts=(0,_method.getNumber)([39,'contracts_rn'],monthData).toFixed(2);data[11].budget_rev=((0,_method.numConvert)((0,_method.getNumber)([39,'contracts_rev'],monthData))+(0,_method.numConvert)((0,_method.getNumber)([39,'others_rev'],monthData))).toFixed(2);data[11].sum_r_nts=(0,_method.getNumber)([40,'contracts_rn'],monthData).toFixed(2);data[11].sum_rev=((0,_method.numConvert)((0,_method.getNumber)([40,'contracts_rev'],monthData))+(0,_method.numConvert)((0,_method.getNumber)([40,'others_rev'],monthData))).toFixed(2);data[13].budget_r_nts=(0,_method.getNumber)([39,'grand_rms'],monthData).toFixed(2);data[13].sum_r_nts=(0,_method.getNumber)([40,'grand_rms'],monthData).toFixed(2);// 计算其他项目结果
var totalName=['budget_r_nts','budget_rev','sum_r_nts','sum_rev'];totalName.forEach(function(name){data[7][name]=data.reduce(function(a,b,i){if(i<7){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);data[10][name]=data.reduce(function(a,b,i){if(i<10&&i>7){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);data[12][name]=[7,10,11].reduce(function(a,b){return a+(0,_method.numConvert)(data[b][name]);},0).toFixed(2);});['budget_r_nts','sum_r_nts'].forEach(function(name){var ARR=name.split('_')[0]+"_arr";data[14][name]=data[13][name]==0?0:(data[12][name]/data[13][name]).toFixed(4);data[15][name]=(data[14][name]*data[12][ARR]).toFixed(4);});// 计算DIff RN REV
['diff_r_nts','diff_rev'].forEach(function(name){var budget='budget_'+name.split('diff_')[1];var sum='sum_'+name.split('diff_')[1];data.forEach(function(item,i){data[i][name]=(item[sum]-item[budget]).toFixed(2);});});// Mix ARR  
data.forEach(function(item,i){if(i<13){data[i].budget_nts_mix=data[12].budget_r_nts==0?0:(data[i].budget_r_nts/data[12].budget_r_nts).toFixed(4);data[i].budget_arr=data[i].budget_r_nts==0?0:(data[i].budget_rev/data[i].budget_r_nts).toFixed(2);data[i].budget_rev_mix=data[12].budget_rev==0?0:(data[i].budget_rev/data[12].budget_rev).toFixed(4);data[i].sum_nts_mix=data[12].sum_r_nts==0?0:(data[i].sum_r_nts/data[12].sum_r_nts).toFixed(4);data[i].sum_arr=data[i].sum_r_nts==0?0:(data[i].sum_rev/data[i].sum_r_nts).toFixed(2);data[i].sum_rev_mix=data[12].sum_rev==0?0:(data[i].sum_rev/data[12].sum_rev).toFixed(4);// diff
data[i].diff_arr=(data[i].sum_arr-data[i].budget_arr).toFixed(2);data[i].diff_arr_mix=data[i].budget_arr==0?0:(data[i].diff_arr/data[i].budget_arr).toFixed(4);data[i].diff_rev_mix=data[i].budget_rev==0?0:(data[i].diff_rev/data[i].budget_rev).toFixed(4);}data[i].diff_nts_mix=data[i].budget_r_nts==0?0:(data[i].diff_r_nts/data[i].budget_r_nts).toFixed(4);});return data;}function computeNew(){var monthDataAll=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var thisData=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var _monthDataAll$lastMon2=monthDataAll.lastMonthData,lastMonthData=_monthDataAll$lastMon2===undefined?[]:_monthDataAll$lastMon2;var monthData=!monthDataAll.data||monthDataAll.data.length<=0?lastMonthData:monthDataAll.data;var data=thisData;if(data.length==16){data[11].name='CONTRACT';data.splice(12,0,{name:'OTHERS',sort:12,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0});data=data.map(function(x,i){return _extends({},x,{sort:i});});}var controlName=[{name:"best",index:0},{name:"corporate",index:1},{name:"government",index:2},{name:"packges",index:3},{name:"wholesale",index:4},{name:"commerce",index:5},{name:"discounts",index:6},{name:"business",index:8},{name:"leisure",index:9},{name:"contracts",index:11}];// 从月度表格更新数据
controlName.forEach(function(item){data[item.index].budget_r_nts=(0,_method.getNumber)([39,item.name+"_rn"],monthData).toFixed(2);data[item.index].budget_rev=(0,_method.getNumber)([39,item.name+"_rev"],monthData).toFixed(2);data[item.index].sum_r_nts=(0,_method.getNumber)([40,item.name+"_rn"],monthData).toFixed(2);data[item.index].sum_rev=(0,_method.getNumber)([40,item.name+"_rev"],monthData).toFixed(2);});data[12].budget_rev=(0,_method.getNumber)([39,'others_rev'],monthData);data[12].sum_rev=(0,_method.getNumber)([40,'others_rev'],monthData);data[12].budget_r_nts=0;data[12].sum_r_nts=0;data[14].budget_r_nts=(0,_method.getNumber)([39,'grand_rms'],monthData).toFixed(2);data[14].sum_r_nts=(0,_method.getNumber)([40,'grand_rms'],monthData).toFixed(2);// 计算其他项目结果
var totalName=['budget_r_nts','budget_rev','sum_r_nts','sum_rev'];totalName.forEach(function(name){data[7][name]=data.reduce(function(a,b,i){if(i<7){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);data[10][name]=data.reduce(function(a,b,i){if(i<10&&i>7){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);data[13][name]=[7,10,11,12].reduce(function(a,b){return a+(0,_method.numConvert)(data[b][name]);},0).toFixed(2);});['budget_r_nts','sum_r_nts'].forEach(function(name){var ARR=name.split('_')[0]+"_arr";data[15][name]=data[14][name]==0?0:(data[13][name]/data[14][name]).toFixed(4);data[16][name]=(data[15][name]*data[13][ARR]).toFixed(4);});// 计算DIff RN REV
['diff_r_nts','diff_rev'].forEach(function(name){var budget='budget_'+name.split('diff_')[1];var sum='sum_'+name.split('diff_')[1];data.forEach(function(item,i){data[i][name]=(item[sum]-item[budget]).toFixed(2);});});// Mix ARR  
data.forEach(function(item,i){if(i<14){data[i].budget_nts_mix=data[13].budget_r_nts==0?0:(data[i].budget_r_nts/data[13].budget_r_nts).toFixed(4);data[i].budget_arr=data[i].budget_r_nts==0?0:(data[i].budget_rev/data[i].budget_r_nts).toFixed(2);data[i].budget_rev_mix=data[13].budget_rev==0?0:(data[i].budget_rev/data[13].budget_rev).toFixed(4);data[i].sum_nts_mix=data[13].sum_r_nts==0?0:(data[i].sum_r_nts/data[13].sum_r_nts).toFixed(4);data[i].sum_arr=data[i].sum_r_nts==0?0:(data[i].sum_rev/data[i].sum_r_nts).toFixed(2);data[i].sum_rev_mix=data[13].sum_rev==0?0:(data[i].sum_rev/data[13].sum_rev).toFixed(4);// diff
data[i].diff_arr=(data[i].sum_arr-data[i].budget_arr).toFixed(2);data[i].diff_arr_mix=data[i].budget_arr==0?0:(data[i].diff_arr/data[i].budget_arr).toFixed(4);data[i].diff_rev_mix=data[i].budget_rev==0?0:(data[i].diff_rev/data[i].budget_rev).toFixed(4);}data[i].diff_nts_mix=data[i].budget_r_nts==0?0:(data[i].diff_r_nts/data[i].budget_r_nts).toFixed(4);});return data;}

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _data=__webpack_require__(1521);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _compute=__webpack_require__(1522);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var totalIndex=[7,10];var percentindex=[15];var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(data){var newData;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_compute.computeNew)(_this.state.monthDataAll,data);case 2:newData=_context.sent;_this.setState({data:newData},function(){if(_this.state.monthDataAll.data&&_this.state.monthDataAll.data.length>0){_this.onSave();}});case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data3_2_1);var data=JSON.parse(dataBegin);var year=(0,_moment2.default)(date).format('YYYY');var month=(0,_moment2.default)(date).format('M');fetch('/_4_2_1_info?year='+year+'&month='+month,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data&&x.data.data.length>0){data=x.data.data.sort(function(a,b){return a.sort-b.sort;});}var monthDataAll={data:(x.data.month||[]).sort(function(a,b){return a.sort-b.sort;}),lastMonthData:(x.data.lastMonthData||[]).sort(function(a,b){return a.sort-b.sort;})};_this.setState({loading:false,monthDataAll:monthDataAll},function(){_this.computeNum(data);});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format('YYYY');var month=(0,_moment2.default)(date).format('M');var data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_4_2_1',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table4_1_1',1.5,'4.13',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+' '+(0,_moment2.default)(_this.state.date).format('YYYY')+'REVENUE PLAN - MARKET SEGMENTATION ANALYSIS REPORT';var innerHtml='\n          <caption>'+tableName+'</caption>\n          '+document.getElementById('table4_1_3_2').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n        ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+'.xls');_this.setState({print:false});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),dateData:[],data:[],loading:true,loadingSave:false,print:false,monthDataAll:{}};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date;var year=date;var width=document.body.offsetWidth-2400>300?document.body.offsetWidth-2400:300;var columns=[{title:'YEAR TO DATE',dataIndex:'name',key:'name',align:"center",fixed:this.state.print?false:"left",width:width,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"left"}},text||"-");}},{title:'Actual Last Year',width:750,children:[{title:_react2.default.createElement('div',null,'R/Nts'),dataIndex:'budget_r_nts',key:'budget_r_nts',align:"center",width:150,render:function render(text,record,index){var title=['Actual Last Year','R/Nts'];if(percentindex.includes(index)){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'budget_r_nts',title:title,sqlName:"_4_2_rev",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'budget_r_nts',title:title,sqlName:"_4_2_rev",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Mix%'),dataIndex:'budget_nts_mix',key:'budget_nts_mix',align:"center",width:150,render:function render(text,record,index){var title=['Actual Last Year','Mix%'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'budget_nts_mix',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}},{title:_react2.default.createElement('div',null,'A.R.R'),dataIndex:'budget_arr',key:'budget_arr',align:"center",width:150,render:function render(text,record,index){var title=['Actual Last Year','A.R.R'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'budget_arr',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}},{title:_react2.default.createElement('div',null,'Rev'),dataIndex:'budget_rev',key:'budget_rev',align:"center",width:150,render:function render(text,record,index){var title=['Actual Last Year','Rev'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'budget_rev',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}},{title:_react2.default.createElement('div',null,'Mix%'),dataIndex:'budget_rev_mix',key:'budget_rev_mix',align:"center",width:150,render:function render(text,record,index){var title=['Actual Last Year','Mix%'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'budget_rev_mix',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}}]},{title:'Whole Year Actual + Forecast',width:750,children:[{title:_react2.default.createElement('div',null,'R/Nts'),dataIndex:'sum_r_nts',key:'sum_r_nts',align:"center",width:150,render:function render(text,record,index){var title=['Whole Year Actual + Forecast','R/Nts'];if(percentindex.includes(index)){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'sum_r_nts',title:title,sqlName:"_4_2_rev",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'sum_r_nts',title:title,sqlName:"_4_2_rev",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Mix%'),dataIndex:'sum_nts_mix',key:'sum_nts_mix',align:"center",width:150,render:function render(text,record,index){var title=['Whole Year Actual + Forecast','Mix%'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'sum_nts_mix',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}},{title:_react2.default.createElement('div',null,'A.R.R'),dataIndex:'sum_arr',key:'sum_arr',align:"center",width:150,render:function render(text,record,index){var title=['Whole Year Actual + Forecast','A.R.R'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'sum_arr',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}},{title:_react2.default.createElement('div',null,'Rev'),dataIndex:'sum_rev',key:'sum_rev',align:"center",width:150,render:function render(text,record,index){var title=['Whole Year Actual + Forecast','Rev'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'sum_rev',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}},{title:_react2.default.createElement('div',null,'Mix%'),dataIndex:'sum_rev_mix',key:'sum_rev_mix',align:"center",width:150,render:function render(text,record,index){var title=['Whole Year Actual + Forecast','Mix%'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'sum_rev_mix',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}}]},{title:'Diff%',width:750,children:[{title:_react2.default.createElement('div',null,'R/Nts'),dataIndex:'diff_r_nts',key:'diff_r_nts',align:"center",width:150,render:function render(text,record,index){var title=['Diff%','R/Nts'];if(percentindex.includes(index)){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'diff_r_nts',title:title,sqlName:"_4_2_rev",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'diff_r_nts',title:title,sqlName:"_4_2_rev",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'% Diff'),dataIndex:'diff_nts_mix',key:'diff_nts_mix',align:"center",width:150,render:function render(text,record,index){var title=['Diff%','% Diff'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'diff_nts_mix',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}},{title:_react2.default.createElement('div',null,'A.R.R'),dataIndex:'diff_arr',key:'diff_arr',align:"center",width:150,render:function render(text,record,index){var title=['Diff%','A.R.R'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'diff_arr',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}},{title:_react2.default.createElement('div',null,'% Diff'),dataIndex:'diff_arr_mix',key:'diff_arr_mix',align:"center",width:150,render:function render(text,record,index){var title=['Diff%','% Diff'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'diff_arr_mix',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}},{title:_react2.default.createElement('div',null,'Rev'),dataIndex:'diff_rev',key:'diff_rev',align:"center",width:150,render:function render(text,record,index){var title=['Diff%','Rev'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'diff_rev',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}},{title:_react2.default.createElement('div',null,'% Diff'),dataIndex:'diff_rev_mix',key:'diff_rev_mix',align:"center",width:150,render:function render(text,record,index){var title=['Diff%','% Diff'];if(index<14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'diff_rev_mix',title:title,sqlName:"_4_2_rev",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(2)+'%',')'):(text*100).toFixed(2)+'%'));}return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"right"}},'-');}}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_1_1',style:{width:this.state.print?2750:'auto'}},_react2.default.createElement(_row2.default,null,'4.1.3 Yearly Market Segmentation report \u5E74\u5EA6\u5E02\u573A\u7EC6\u5206\u62A5\u8868'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',id:'table4_1_3_2',bordered:true,pagination:false,className:'content',style:{width:this.state.print?2700:'auto'},scroll:this.state.print?{}:{x:2700,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_4_1'},_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave,style:{marginLeft:10}},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data3_2_1=exports.data3_2_1=[{name:'BAR',sort:0,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'Corp Negotiated',sort:1,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'Government',sort:2,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'Packages',sort:3,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'Wholesale',sort:4,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'E-Commerce',sort:5,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'Discounts',sort:6,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'TTL TRANSIENT',sort:7,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'Group Business',sort:8,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'Group Leisure',sort:9,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'TTL GROUP',sort:10,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'CONTRACT',sort:11,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'OTHERS',sort:12,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'GRAND TOTAL',sort:13,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'Available Rms',sort:14,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'Occupancy %',sort:15,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0},{name:'RevPAR',sort:16,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0}];

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.compute=compute;exports.computeNew=computeNew;var _method=__webpack_require__(20);function compute(){var monthDataAll=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var thisData=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var _monthDataAll$lastMon=monthDataAll.lastMonthData,lastMonthData=_monthDataAll$lastMon===undefined?[]:_monthDataAll$lastMon;var monthData=!monthDataAll.data||monthDataAll.data.length<=0?lastMonthData:monthDataAll.data;var data=thisData;var controlName=[{name:"best",index:0},{name:"corporate",index:1},{name:"government",index:2},{name:"packges",index:3},{name:"wholesale",index:4},{name:"commerce",index:5},{name:"discounts",index:6},{name:"business",index:8},{name:"leisure",index:9}];// 从月度表格更新数据
controlName.forEach(function(item){data[item.index].budget_r_nts=(0,_method.getNumber)([41,item.name+"_rn"],monthData).toFixed(2);data[item.index].budget_rev=(0,_method.getNumber)([41,item.name+"_rev"],monthData).toFixed(2);data[item.index].sum_r_nts=(0,_method.getNumber)([40,item.name+"_rn"],monthData).toFixed(2);data[item.index].sum_rev=(0,_method.getNumber)([40,item.name+"_rev"],monthData).toFixed(2);});data[11].budget_r_nts=(0,_method.getNumber)([41,'contracts_rn'],monthData).toFixed(2);data[11].budget_rev=((0,_method.numConvert)((0,_method.getNumber)([41,'contracts_rev'],monthData))+(0,_method.numConvert)((0,_method.getNumber)([41,'others_rev'],monthData))).toFixed(2);data[11].sum_r_nts=(0,_method.getNumber)([40,'contracts_rn'],monthData).toFixed(2);data[11].sum_rev=((0,_method.numConvert)((0,_method.getNumber)([40,'contracts_rev'],monthData))+(0,_method.numConvert)((0,_method.getNumber)([40,'others_rev'],monthData))).toFixed(2);data[13].budget_r_nts=(0,_method.getNumber)([41,'grand_rms'],monthData).toFixed(2);data[13].sum_r_nts=(0,_method.getNumber)([40,'grand_rms'],monthData).toFixed(2);// 计算其他项目结果
var totalName=['budget_r_nts','budget_rev','sum_r_nts','sum_rev'];totalName.forEach(function(name){data[7][name]=data.reduce(function(a,b,i){if(i<7){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);data[10][name]=data.reduce(function(a,b,i){if(i<10&&i>7){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);data[12][name]=[7,10,11].reduce(function(a,b){return a+(0,_method.numConvert)(data[b][name]);},0).toFixed(2);});['budget_r_nts','sum_r_nts'].forEach(function(name){var ARR=name.split('_')[0]+"_arr";data[14][name]=data[13][name]==0?0:(data[12][name]/data[13][name]).toFixed(4);data[15][name]=(data[14][name]*data[12][ARR]).toFixed(4);});// 计算DIff RN REV
['diff_r_nts','diff_rev'].forEach(function(name){var budget='budget_'+name.split('diff_')[1];var sum='sum_'+name.split('diff_')[1];data.forEach(function(item,i){data[i][name]=(item[sum]-item[budget]).toFixed(2);});});// Mix ARR  
data.forEach(function(item,i){if(i<13){data[i].budget_nts_mix=data[12].budget_r_nts==0?0:(data[i].budget_r_nts/data[12].budget_r_nts).toFixed(4);data[i].budget_arr=data[i].budget_r_nts==0?0:(data[i].budget_rev/data[i].budget_r_nts).toFixed(2);data[i].budget_rev_mix=data[12].budget_rev==0?0:(data[i].budget_rev/data[12].budget_rev).toFixed(4);data[i].sum_nts_mix=data[12].sum_r_nts==0?0:(data[i].sum_r_nts/data[12].sum_r_nts).toFixed(4);data[i].sum_arr=data[i].sum_r_nts==0?0:(data[i].sum_rev/data[i].sum_r_nts).toFixed(2);data[i].sum_rev_mix=data[12].sum_rev==0?0:(data[i].sum_rev/data[12].sum_rev).toFixed(4);// diff
data[i].diff_arr=(data[i].sum_arr-data[i].budget_arr).toFixed(2);data[i].diff_arr_mix=data[i].budget_arr==0?0:(data[i].diff_arr/data[i].budget_arr).toFixed(4);data[i].diff_rev_mix=data[i].budget_rev==0?0:(data[i].diff_rev/data[i].budget_rev).toFixed(4);}data[i].diff_nts_mix=data[i].budget_r_nts==0?0:(data[i].diff_r_nts/data[i].budget_r_nts).toFixed(4);});return data;}function computeNew(){var monthDataAll=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var thisData=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var _monthDataAll$lastMon2=monthDataAll.lastMonthData,lastMonthData=_monthDataAll$lastMon2===undefined?[]:_monthDataAll$lastMon2;var monthData=!monthDataAll.data||monthDataAll.data.length<=0?lastMonthData:monthDataAll.data;var data=thisData;if(data.length==16){data[11].name='CONTRACT';data.splice(12,0,{name:'OTHERS',sort:12,budget_r_nts:0,budget_nts_mix:0,budget_arr:0,budget_rev:0,budget_rev_mix:0,sum_r_nts:0,sum_nts_mix:0,sum_arr:0,sum_rev:0,sum_rev_mix:0,diff_r_nts:0,diff_nts_mix:0,diff_arr:0,diff_arr_mix:0,diff_rev:0,diff_rev_mix:0});data=data.map(function(x,i){return _extends({},x,{sort:i});});}var controlName=[{name:"best",index:0},{name:"corporate",index:1},{name:"government",index:2},{name:"packges",index:3},{name:"wholesale",index:4},{name:"commerce",index:5},{name:"discounts",index:6},{name:"business",index:8},{name:"leisure",index:9},{name:"contracts",index:11}];// 从月度表格更新数据
controlName.forEach(function(item){data[item.index].budget_r_nts=(0,_method.getNumber)([41,item.name+"_rn"],monthData).toFixed(2);data[item.index].budget_rev=(0,_method.getNumber)([41,item.name+"_rev"],monthData).toFixed(2);data[item.index].sum_r_nts=(0,_method.getNumber)([40,item.name+"_rn"],monthData).toFixed(2);data[item.index].sum_rev=(0,_method.getNumber)([40,item.name+"_rev"],monthData).toFixed(2);});data[12].budget_rev=(0,_method.getNumber)([41,'others_rev'],monthData);data[12].sum_rev=(0,_method.getNumber)([40,'others_rev'],monthData);data[12].budget_r_nts=0;data[12].sum_r_nts=0;data[14].budget_r_nts=(0,_method.getNumber)([41,'grand_rms'],monthData).toFixed(2);data[14].sum_r_nts=(0,_method.getNumber)([40,'grand_rms'],monthData).toFixed(2);// 计算其他项目结果
var totalName=['budget_r_nts','budget_rev','sum_r_nts','sum_rev'];totalName.forEach(function(name){data[7][name]=data.reduce(function(a,b,i){if(i<7){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);data[10][name]=data.reduce(function(a,b,i){if(i<10&&i>7){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);data[13][name]=[7,10,11,12].reduce(function(a,b){return a+(0,_method.numConvert)(data[b][name]);},0).toFixed(2);});['budget_r_nts','sum_r_nts'].forEach(function(name){var ARR=name.split('_')[0]+"_arr";data[15][name]=data[14][name]==0?0:(data[13][name]/data[14][name]).toFixed(4);data[16][name]=(data[15][name]*data[13][ARR]).toFixed(4);});// 计算DIff RN REV
['diff_r_nts','diff_rev'].forEach(function(name){var budget='budget_'+name.split('diff_')[1];var sum='sum_'+name.split('diff_')[1];data.forEach(function(item,i){data[i][name]=(item[sum]-item[budget]).toFixed(2);});});// Mix ARR  
data.forEach(function(item,i){if(i<14){data[i].budget_nts_mix=data[13].budget_r_nts==0?0:(data[i].budget_r_nts/data[13].budget_r_nts).toFixed(4);data[i].budget_arr=data[i].budget_r_nts==0?0:(data[i].budget_rev/data[i].budget_r_nts).toFixed(2);data[i].budget_rev_mix=data[13].budget_rev==0?0:(data[i].budget_rev/data[13].budget_rev).toFixed(4);data[i].sum_nts_mix=data[13].sum_r_nts==0?0:(data[i].sum_r_nts/data[13].sum_r_nts).toFixed(4);data[i].sum_arr=data[i].sum_r_nts==0?0:(data[i].sum_rev/data[i].sum_r_nts).toFixed(2);data[i].sum_rev_mix=data[13].sum_rev==0?0:(data[i].sum_rev/data[13].sum_rev).toFixed(4);// diff
data[i].diff_arr=(data[i].sum_arr-data[i].budget_arr).toFixed(2);data[i].diff_arr_mix=data[i].budget_arr==0?0:(data[i].diff_arr/data[i].budget_arr).toFixed(4);data[i].diff_rev_mix=data[i].budget_rev==0?0:(data[i].diff_rev/data[i].budget_rev).toFixed(4);}data[i].diff_nts_mix=data[i].budget_r_nts==0?0:(data[i].diff_r_nts/data[i].budget_r_nts).toFixed(4);});return data;}

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(6);__webpack_require__(10);__webpack_require__(14);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(1524);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextArea=_input2.default.TextArea;var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),loadingSave:false,data:{content:""}},_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var _this$state,date,data,_timer,year,month,dataFrom,headres,x,timer,_timer2;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_this.setState({loadingSave:true});_this$state=_this.state,date=_this$state.date,data=_this$state.data;if(date){_context.next=7;break;}_message3.default.error('请选择年份月份');_timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer);},1000);return _context.abrupt('return');case 7:year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");data=_extends({},data,{year:year,month:month});dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context.next=15;return(0,_request2.default)('/t4_1_noteAdd',headres);case 15:x=_context.sent;timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(!(x.status==1)){_context.next=21;break;}_message3.default.success(x.msg);if(!data.id){_this.getData(date);}return _context.abrupt('return');case 21:_message3.default.error(x.msg);_context.next=29;break;case 24:_context.prev=24;_context.t0=_context['catch'](0);_timer2=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer2);},1000);console.error(_context.t0);_message3.default.error('保存失败'+JSON.stringify(_context.t0));case 29:case'end':return _context.stop();}}},_callee,_this2,[[0,24]]);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData(this.state.date);}},{key:'getData',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(date){var month,year,x;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;month=(0,_moment2.default)(date).format('M');year=(0,_moment2.default)(date).format('YYYY');_context2.next=5;return(0,_request2.default)('/t4_1_note?year='+year+'&month='+month);case 5:x=_context2.sent;this.setState({data:x.data||{}});_context2.next=12;break;case 9:_context2.prev=9;_context2.t0=_context2['catch'](0);console.error(_context2.t0);case 12:case'end':return _context2.stop();}}},_callee2,this,[[0,9]]);}));function getData(_x){return _ref3.apply(this,arguments);}return getData;}()},{key:'render',value:function render(){var _this3=this;var _state=this.state,loadingSave=_state.loadingSave,data=_state.data,date=_state.date;var _JSON$parse=JSON.parse(sessionStorage.getItem('user')||"{}"),_JSON$parse$email=_JSON$parse.email,email=_JSON$parse$email===undefined?"":_JSON$parse$email;return _react2.default.createElement('div',{className:'t4_1_4_note'},_react2.default.createElement('div',{className:'title'},'\u5907\u6CE8'),_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:{content:""}});_this3.getData(str);}}),_react2.default.createElement(TextArea,{value:data.content,rows:4,onChange:function onChange(e){return _this3.setState({data:_extends({},data,{content:e.target.value||""})});}}),_react2.default.createElement('div',{className:'btn'},_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:loadingSave},'\u4FDD\u5B58')));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var color=['#4c9bf2','#4AC18E','#D9534F','#67A8E4'];var list=[{name:"Occ%",key:"grand_occ",id:"chartOcc"},{name:"ADR",key:"grand_arr",id:"chartAdr"},{name:"REVPAR",key:"grand_revpar",id:"chartRevpar"},{name:"Revenue",key:"grand_rev",id:"chartRev"}];exports.default=function(_ref,isOnResize){var data=_ref.data,name=_ref.name,dataLast=_ref.dataLast,date=_ref.date;list.forEach(function(item){var myChart=_echarts2.default.init(document.getElementById(item.id));myChart.resize();if(isOnResize){return;}var year=(0,_moment2.default)(date).format('YYYY');var listName=["Budget "+year,"Actual + Forecast "+year,"Actual "+(year-1)];var series=listName.map(function(name,index){return{name:name,type:'bar',barWidth:10,data:data.reduce(function(a,b,i){if(i>=36)return a;if(index==0&&i%3==0){a.push((b[item.key]*(item.key=='grand_occ'?100:1)).toFixed(2));}if(index==1&&i%3==1){a.push((b[item.key]*(item.key=='grand_occ'?100:1)).toFixed(2));}if(index==2&&i%3==1){a.push(dataLast[i]?(dataLast[i][item.key]*(item.key=='grand_occ'?100:1)).toFixed(2):0);}return a;},[])};});var option={title:{text:item.name,textStyle:{align:'left',color:'#333',fontSize:20},top:'5%',left:'left'},legend:{top:'30',data:listName},color:color,xAxis:{splitLine:{lineStyle:{show:true}},"axisLabel":{textStyle:{fontSize:12,color:'#000'}},data:new Array(12).fill(1).map(function(x,i){return i+1;})},yAxis:{name:item.name=='Occ%'?'%':'',type:'value'},tooltip:{trigger:'axis'},toolbox:{id:item.id,right:20,feature:{saveAsImage:{type:'png',//	设置图片格式 png或者'jpeg
name:name,backgroundColor:'#FFF',excludeComponents:['toolbox'],show:true,title:'保存图片'// icon: ...,
}}},series:series};myChart.setOption(option);});};

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(1);

var vec2 = __webpack_require__(55);

var Draggable = __webpack_require__(1527);

var Eventful = __webpack_require__(173);

var eventTool = __webpack_require__(121);

var GestureMgr = __webpack_require__(1529);

/**
 * [The interface between `Handler` and `HandlerProxy`]:
 *
 * The default `HandlerProxy` only support the common standard web environment
 * (e.g., standalone browser, headless browser, embed browser in mobild APP, ...).
 * But `HandlerProxy` can be replaced to support more non-standard environment
 * (e.g., mini app), or to support more feature that the default `HandlerProxy`
 * not provided (like echarts-gl did).
 * So the interface between `Handler` and `HandlerProxy` should be stable. Do not
 * make break changes util inevitable. The interface include the public methods
 * of `Handler` and the events listed in `handlerNames` below, by which `HandlerProxy`
 * drives `Handler`.
 */

/**
 * [Drag outside]:
 *
 * That is, triggering `mousemove` and `mouseup` event when the pointer is out of the
 * zrender area when dragging. That is important for the improvement of the user experience
 * when dragging something near the boundary without being terminated unexpectedly.
 *
 * We originally consider to introduce new events like `pagemovemove` and `pagemouseup`
 * to resolve this issue. But some drawbacks of it is described in
 * https://github.com/ecomfe/zrender/pull/536#issuecomment-560286899
 *
 * Instead, we referenced the specifications:
 * https://www.w3.org/TR/touch-events/#the-touchmove-event
 * https://www.w3.org/TR/2014/WD-DOM-Level-3-Events-20140925/#event-type-mousemove
 * where the the mousemove/touchmove can be continue to fire if the user began a drag
 * operation and the pointer has left the boundary. (for the mouse event, browsers
 * only do it on `document` and when the pointer has left the boundary of the browser.)
 *
 * So the default `HandlerProxy` supports this feature similarly: if it is in the dragging
 * state (see `pointerCapture` in `HandlerProxy`), the `mousemove` and `mouseup` continue
 * to fire until release the pointer. That is implemented by listen to those event on
 * `document`.
 * If we implement some other `HandlerProxy` only for touch device, that would be easier.
 * The touch event support this feature by default.
 *
 * Note:
 * There might be some cases that the mouse event can not be
 * received on `document`. For example,
 * (A) `useCapture` is not supported and some user defined event listeners on the ancestor
 * of zr dom throw Error .
 * (B) `useCapture` is not supported Some user defined event listeners on the ancestor of
 * zr dom call `stopPropagation`.
 * In these cases, the `mousemove` event might be keep triggered event
 * if the mouse is released. We try to reduce the side-effect in those cases.
 * That is, do nothing (especially, `findHover`) in those cases. See `isOutsideBoundary`.
 *
 * Note:
 * If `HandlerProxy` listens to `document` with `useCapture`, `HandlerProxy` needs to
 * make sure `stopPropagation` and `preventDefault` doing nothing if and only if the event
 * target is not zrender dom. Becuase it is dangerous to enable users to call them in
 * `document` capture phase to prevent the propagation to any listener of the webpage.
 * But they are needed to work when the pointer inside the zrender dom.
 */
var SILENT = 'silent';

function makeEventPacket(eveType, targetInfo, event) {
  return {
    type: eveType,
    event: event,
    // target can only be an element that is not silent.
    target: targetInfo.target,
    // topTarget can be a silent element.
    topTarget: targetInfo.topTarget,
    cancelBubble: false,
    offsetX: event.zrX,
    offsetY: event.zrY,
    gestureEvent: event.gestureEvent,
    pinchX: event.pinchX,
    pinchY: event.pinchY,
    pinchScale: event.pinchScale,
    wheelDelta: event.zrDelta,
    zrByTouch: event.zrByTouch,
    which: event.which,
    stop: stopEvent
  };
}

function stopEvent() {
  eventTool.stop(this.event);
}

function EmptyProxy() {}

EmptyProxy.prototype.dispose = function () {};

var handlerNames = ['click', 'dblclick', 'mousewheel', 'mouseout', 'mouseup', 'mousedown', 'mousemove', 'contextmenu'];
/**
 * @alias module:zrender/Handler
 * @constructor
 * @extends module:zrender/mixin/Eventful
 * @param {module:zrender/Storage} storage Storage instance.
 * @param {module:zrender/Painter} painter Painter instance.
 * @param {module:zrender/dom/HandlerProxy} proxy HandlerProxy instance.
 * @param {HTMLElement} painterRoot painter.root (not painter.getViewportRoot()).
 */

var Handler = function (storage, painter, proxy, painterRoot) {
  Eventful.call(this);
  this.storage = storage;
  this.painter = painter;
  this.painterRoot = painterRoot;
  proxy = proxy || new EmptyProxy();
  /**
   * Proxy of event. can be Dom, WebGLSurface, etc.
   */

  this.proxy = null;
  /**
   * {target, topTarget, x, y}
   * @private
   * @type {Object}
   */

  this._hovered = {};
  /**
   * @private
   * @type {Date}
   */

  this._lastTouchMoment;
  /**
   * @private
   * @type {number}
   */

  this._lastX;
  /**
   * @private
   * @type {number}
   */

  this._lastY;
  /**
   * @private
   * @type {module:zrender/core/GestureMgr}
   */

  this._gestureMgr;
  Draggable.call(this);
  this.setHandlerProxy(proxy);
};

Handler.prototype = {
  constructor: Handler,
  setHandlerProxy: function (proxy) {
    if (this.proxy) {
      this.proxy.dispose();
    }

    if (proxy) {
      util.each(handlerNames, function (name) {
        proxy.on && proxy.on(name, this[name], this);
      }, this); // Attach handler

      proxy.handler = this;
    }

    this.proxy = proxy;
  },
  mousemove: function (event) {
    var x = event.zrX;
    var y = event.zrY;
    var isOutside = isOutsideBoundary(this, x, y);
    var lastHovered = this._hovered;
    var lastHoveredTarget = lastHovered.target; // If lastHoveredTarget is removed from zr (detected by '__zr') by some API call
    // (like 'setOption' or 'dispatchAction') in event handlers, we should find
    // lastHovered again here. Otherwise 'mouseout' can not be triggered normally.
    // See #6198.

    if (lastHoveredTarget && !lastHoveredTarget.__zr) {
      lastHovered = this.findHover(lastHovered.x, lastHovered.y);
      lastHoveredTarget = lastHovered.target;
    }

    var hovered = this._hovered = isOutside ? {
      x: x,
      y: y
    } : this.findHover(x, y);
    var hoveredTarget = hovered.target;
    var proxy = this.proxy;
    proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default'); // Mouse out on previous hovered element

    if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) {
      this.dispatchToElement(lastHovered, 'mouseout', event);
    } // Mouse moving on one element


    this.dispatchToElement(hovered, 'mousemove', event); // Mouse over on a new element

    if (hoveredTarget && hoveredTarget !== lastHoveredTarget) {
      this.dispatchToElement(hovered, 'mouseover', event);
    }
  },
  mouseout: function (event) {
    var eventControl = event.zrEventControl;
    var zrIsToLocalDOM = event.zrIsToLocalDOM;

    if (eventControl !== 'only_globalout') {
      this.dispatchToElement(this._hovered, 'mouseout', event);
    }

    if (eventControl !== 'no_globalout') {
      // FIXME: if the pointer moving from the extra doms to realy "outside",
      // the `globalout` should have been triggered. But currently not.
      !zrIsToLocalDOM && this.trigger('globalout', {
        type: 'globalout',
        event: event
      });
    }
  },

  /**
   * Resize
   */
  resize: function (event) {
    this._hovered = {};
  },

  /**
   * Dispatch event
   * @param {string} eventName
   * @param {event=} eventArgs
   */
  dispatch: function (eventName, eventArgs) {
    var handler = this[eventName];
    handler && handler.call(this, eventArgs);
  },

  /**
   * Dispose
   */
  dispose: function () {
    this.proxy.dispose();
    this.storage = this.proxy = this.painter = null;
  },

  /**
   * 设置默认的cursor style
   * @param {string} [cursorStyle='default'] 例如 crosshair
   */
  setCursorStyle: function (cursorStyle) {
    var proxy = this.proxy;
    proxy.setCursor && proxy.setCursor(cursorStyle);
  },

  /**
   * 事件分发代理
   *
   * @private
   * @param {Object} targetInfo {target, topTarget} 目标图形元素
   * @param {string} eventName 事件名称
   * @param {Object} event 事件对象
   */
  dispatchToElement: function (targetInfo, eventName, event) {
    targetInfo = targetInfo || {};
    var el = targetInfo.target;

    if (el && el.silent) {
      return;
    }

    var eventHandler = 'on' + eventName;
    var eventPacket = makeEventPacket(eventName, targetInfo, event);

    while (el) {
      el[eventHandler] && (eventPacket.cancelBubble = el[eventHandler].call(el, eventPacket));
      el.trigger(eventName, eventPacket);
      el = el.parent;

      if (eventPacket.cancelBubble) {
        break;
      }
    }

    if (!eventPacket.cancelBubble) {
      // 冒泡到顶级 zrender 对象
      this.trigger(eventName, eventPacket); // 分发事件到用户自定义层
      // 用户有可能在全局 click 事件中 dispose，所以需要判断下 painter 是否存在

      this.painter && this.painter.eachOtherLayer(function (layer) {
        if (typeof layer[eventHandler] === 'function') {
          layer[eventHandler].call(layer, eventPacket);
        }

        if (layer.trigger) {
          layer.trigger(eventName, eventPacket);
        }
      });
    }
  },

  /**
   * @private
   * @param {number} x
   * @param {number} y
   * @param {module:zrender/graphic/Displayable} exclude
   * @return {model:zrender/Element}
   * @method
   */
  findHover: function (x, y, exclude) {
    var list = this.storage.getDisplayList();
    var out = {
      x: x,
      y: y
    };

    for (var i = list.length - 1; i >= 0; i--) {
      var hoverCheckResult;

      if (list[i] !== exclude // getDisplayList may include ignored item in VML mode
      && !list[i].ignore && (hoverCheckResult = isHover(list[i], x, y))) {
        !out.topTarget && (out.topTarget = list[i]);

        if (hoverCheckResult !== SILENT) {
          out.target = list[i];
          break;
        }
      }
    }

    return out;
  },
  processGesture: function (event, stage) {
    if (!this._gestureMgr) {
      this._gestureMgr = new GestureMgr();
    }

    var gestureMgr = this._gestureMgr;
    stage === 'start' && gestureMgr.clear();
    var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
    stage === 'end' && gestureMgr.clear(); // Do not do any preventDefault here. Upper application do that if necessary.

    if (gestureInfo) {
      var type = gestureInfo.type;
      event.gestureEvent = type;
      this.dispatchToElement({
        target: gestureInfo.target
      }, type, gestureInfo.event);
    }
  }
}; // Common handlers

util.each(['click', 'mousedown', 'mouseup', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
  Handler.prototype[name] = function (event) {
    var x = event.zrX;
    var y = event.zrY;
    var isOutside = isOutsideBoundary(this, x, y);
    var hovered;
    var hoveredTarget;

    if (name !== 'mouseup' || !isOutside) {
      // Find hover again to avoid click event is dispatched manually. Or click is triggered without mouseover
      hovered = this.findHover(x, y);
      hoveredTarget = hovered.target;
    }

    if (name === 'mousedown') {
      this._downEl = hoveredTarget;
      this._downPoint = [event.zrX, event.zrY]; // In case click triggered before mouseup

      this._upEl = hoveredTarget;
    } else if (name === 'mouseup') {
      this._upEl = hoveredTarget;
    } else if (name === 'click') {
      if (this._downEl !== this._upEl // Original click event is triggered on the whole canvas element,
      // including the case that `mousedown` - `mousemove` - `mouseup`,
      // which should be filtered, otherwise it will bring trouble to
      // pan and zoom.
      || !this._downPoint // Arbitrary value
      || vec2.dist(this._downPoint, [event.zrX, event.zrY]) > 4) {
        return;
      }

      this._downPoint = null;
    }

    this.dispatchToElement(hovered, name, event);
  };
});

function isHover(displayable, x, y) {
  if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
    var el = displayable;
    var isSilent;

    while (el) {
      // If clipped by ancestor.
      // FIXME: If clipPath has neither stroke nor fill,
      // el.clipPath.contain(x, y) will always return false.
      if (el.clipPath && !el.clipPath.contain(x, y)) {
        return false;
      }

      if (el.silent) {
        isSilent = true;
      }

      el = el.parent;
    }

    return isSilent ? SILENT : true;
  }

  return false;
}
/**
 * See [Drag outside].
 */


function isOutsideBoundary(handlerInstance, x, y) {
  var painter = handlerInstance.painter;
  return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
}

util.mixin(Handler, Eventful);
util.mixin(Handler, Draggable);
var _default = Handler;
module.exports = _default;

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

// TODO Draggable for group
// FIXME Draggable on element which has parent rotation or scale
function Draggable() {
  this.on('mousedown', this._dragStart, this);
  this.on('mousemove', this._drag, this);
  this.on('mouseup', this._dragEnd, this); // `mosuemove` and `mouseup` can be continue to fire when dragging.
  // See [Drag outside] in `Handler.js`. So we do not need to trigger
  // `_dragEnd` when globalout. That would brings better user experience.
  // this.on('globalout', this._dragEnd, this);
  // this._dropTarget = null;
  // this._draggingTarget = null;
  // this._x = 0;
  // this._y = 0;
}

Draggable.prototype = {
  constructor: Draggable,
  _dragStart: function (e) {
    var draggingTarget = e.target; // Find if there is draggable in the ancestor

    while (draggingTarget && !draggingTarget.draggable) {
      draggingTarget = draggingTarget.parent;
    }

    if (draggingTarget) {
      this._draggingTarget = draggingTarget;
      draggingTarget.dragging = true;
      this._x = e.offsetX;
      this._y = e.offsetY;
      this.dispatchToElement(param(draggingTarget, e), 'dragstart', e.event);
    }
  },
  _drag: function (e) {
    var draggingTarget = this._draggingTarget;

    if (draggingTarget) {
      var x = e.offsetX;
      var y = e.offsetY;
      var dx = x - this._x;
      var dy = y - this._y;
      this._x = x;
      this._y = y;
      draggingTarget.drift(dx, dy, e);
      this.dispatchToElement(param(draggingTarget, e), 'drag', e.event);
      var dropTarget = this.findHover(x, y, draggingTarget).target;
      var lastDropTarget = this._dropTarget;
      this._dropTarget = dropTarget;

      if (draggingTarget !== dropTarget) {
        if (lastDropTarget && dropTarget !== lastDropTarget) {
          this.dispatchToElement(param(lastDropTarget, e), 'dragleave', e.event);
        }

        if (dropTarget && dropTarget !== lastDropTarget) {
          this.dispatchToElement(param(dropTarget, e), 'dragenter', e.event);
        }
      }
    }
  },
  _dragEnd: function (e) {
    var draggingTarget = this._draggingTarget;

    if (draggingTarget) {
      draggingTarget.dragging = false;
    }

    this.dispatchToElement(param(draggingTarget, e), 'dragend', e.event);

    if (this._dropTarget) {
      this.dispatchToElement(param(this._dropTarget, e), 'drop', e.event);
    }

    this._draggingTarget = null;
    this._dropTarget = null;
  }
};

function param(target, e) {
  return {
    target: target,
    topTarget: e && e.topTarget
  };
}

var _default = Draggable;
module.exports = _default;

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

/**
 * The algoritm is learnt from
 * https://franklinta.com/2014/09/08/computing-css-matrix3d-transforms/
 * And we made some optimization for matrix inversion.
 * Other similar approaches:
 * "cv::getPerspectiveTransform", "Direct Linear Transformation".
 */
var LN2 = Math.log(2);

function determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
  var cacheKey = rowMask + '-' + colMask;
  var fullRank = rows.length;

  if (detCache.hasOwnProperty(cacheKey)) {
    return detCache[cacheKey];
  }

  if (rank === 1) {
    // In this case the colMask must be like: `11101111`. We can find the place of `0`.
    var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / LN2);
    return rows[rowStart][colStart];
  }

  var subRowMask = rowMask | 1 << rowStart;
  var subRowStart = rowStart + 1;

  while (rowMask & 1 << subRowStart) {
    subRowStart++;
  }

  var sum = 0;

  for (var j = 0, colLocalIdx = 0; j < fullRank; j++) {
    var colTag = 1 << j;

    if (!(colTag & colMask)) {
      sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] // det(subMatrix(0, j))
      * determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
      colLocalIdx++;
    }
  }

  detCache[cacheKey] = sum;
  return sum;
}
/**
 * Usage:
 * ```js
 * var transformer = buildTransformer(
 *     [10, 44, 100, 44, 100, 300, 10, 300],
 *     [50, 54, 130, 14, 140, 330, 14, 220]
 * );
 * var out = [];
 * transformer && transformer([11, 33], out);
 * ```
 *
 * Notice: `buildTransformer` may take more than 10ms in some Android device.
 *
 * @param {Array.<number>} src source four points, [x0, y0, x1, y1, x2, y2, x3, y3]
 * @param {Array.<number>} dest destination four points, [x0, y0, x1, y1, x2, y2, x3, y3]
 * @return {Function} transformer If fail, return null/undefined.
 */


function buildTransformer(src, dest) {
  var mA = [[src[0], src[1], 1, 0, 0, 0, -dest[0] * src[0], -dest[0] * src[1]], [0, 0, 0, src[0], src[1], 1, -dest[1] * src[0], -dest[1] * src[1]], [src[2], src[3], 1, 0, 0, 0, -dest[2] * src[2], -dest[2] * src[3]], [0, 0, 0, src[2], src[3], 1, -dest[3] * src[2], -dest[3] * src[3]], [src[4], src[5], 1, 0, 0, 0, -dest[4] * src[4], -dest[4] * src[5]], [0, 0, 0, src[4], src[5], 1, -dest[5] * src[4], -dest[5] * src[5]], [src[6], src[7], 1, 0, 0, 0, -dest[6] * src[6], -dest[6] * src[7]], [0, 0, 0, src[6], src[7], 1, -dest[7] * src[6], -dest[7] * src[7]]];
  var detCache = {};
  var det = determinant(mA, 8, 0, 0, 0, detCache);

  if (det === 0) {
    // can not make transformer when and only when
    // any three of the markers are collinear.
    return;
  } // `invert(mA) * dest`, that is, `adj(mA) / det * dest`.


  var vh = [];

  for (var i = 0; i < 8; i++) {
    for (var j = 0; j < 8; j++) {
      vh[j] == null && (vh[j] = 0);
      vh[j] += ((i + j) % 2 ? -1 : 1) * // det(subMatrix(i, j))
      determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
    }
  }

  return function (out, srcPointX, srcPointY) {
    var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
    out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
    out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
  };
}

exports.buildTransformer = buildTransformer;

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

var eventUtil = __webpack_require__(121);

/**
 * Only implements needed gestures for mobile.
 */
var GestureMgr = function () {
  /**
   * @private
   * @type {Array.<Object>}
   */
  this._track = [];
};

GestureMgr.prototype = {
  constructor: GestureMgr,
  recognize: function (event, target, root) {
    this._doTrack(event, target, root);

    return this._recognize(event);
  },
  clear: function () {
    this._track.length = 0;
    return this;
  },
  _doTrack: function (event, target, root) {
    var touches = event.touches;

    if (!touches) {
      return;
    }

    var trackItem = {
      points: [],
      touches: [],
      target: target,
      event: event
    };

    for (var i = 0, len = touches.length; i < len; i++) {
      var touch = touches[i];
      var pos = eventUtil.clientToLocal(root, touch, {});
      trackItem.points.push([pos.zrX, pos.zrY]);
      trackItem.touches.push(touch);
    }

    this._track.push(trackItem);
  },
  _recognize: function (event) {
    for (var eventName in recognizers) {
      if (recognizers.hasOwnProperty(eventName)) {
        var gestureInfo = recognizers[eventName](this._track, event);

        if (gestureInfo) {
          return gestureInfo;
        }
      }
    }
  }
};

function dist(pointPair) {
  var dx = pointPair[1][0] - pointPair[0][0];
  var dy = pointPair[1][1] - pointPair[0][1];
  return Math.sqrt(dx * dx + dy * dy);
}

function center(pointPair) {
  return [(pointPair[0][0] + pointPair[1][0]) / 2, (pointPair[0][1] + pointPair[1][1]) / 2];
}

var recognizers = {
  pinch: function (track, event) {
    var trackLen = track.length;

    if (!trackLen) {
      return;
    }

    var pinchEnd = (track[trackLen - 1] || {}).points;
    var pinchPre = (track[trackLen - 2] || {}).points || pinchEnd;

    if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
      var pinchScale = dist(pinchEnd) / dist(pinchPre);
      !isFinite(pinchScale) && (pinchScale = 1);
      event.pinchScale = pinchScale;
      var pinchCenter = center(pinchEnd);
      event.pinchX = pinchCenter[0];
      event.pinchY = pinchCenter[1];
      return {
        type: 'pinch',
        target: track[0].target,
        event: event
      };
    }
  } // Only pinch currently.

};
var _default = GestureMgr;
module.exports = _default;

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(1);

var env = __webpack_require__(67);

var Group = __webpack_require__(174);

var timsort = __webpack_require__(404);

// Use timsort because in most case elements are partially sorted
// https://jsfiddle.net/pissang/jr4x7mdm/8/
function shapeCompareFunc(a, b) {
  if (a.zlevel === b.zlevel) {
    if (a.z === b.z) {
      // if (a.z2 === b.z2) {
      //     // FIXME Slow has renderidx compare
      //     // http://stackoverflow.com/questions/20883421/sorting-in-javascript-should-every-compare-function-have-a-return-0-statement
      //     // https://github.com/v8/v8/blob/47cce544a31ed5577ffe2963f67acb4144ee0232/src/js/array.js#L1012
      //     return a.__renderidx - b.__renderidx;
      // }
      return a.z2 - b.z2;
    }

    return a.z - b.z;
  }

  return a.zlevel - b.zlevel;
}
/**
 * 内容仓库 (M)
 * @alias module:zrender/Storage
 * @constructor
 */


var Storage = function () {
  // jshint ignore:line
  this._roots = [];
  this._displayList = [];
  this._displayListLen = 0;
};

Storage.prototype = {
  constructor: Storage,

  /**
   * @param  {Function} cb
   *
   */
  traverse: function (cb, context) {
    for (var i = 0; i < this._roots.length; i++) {
      this._roots[i].traverse(cb, context);
    }
  },

  /**
   * 返回所有图形的绘制队列
   * @param {boolean} [update=false] 是否在返回前更新该数组
   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组, 在 update 为 true 的时候有效
   *
   * 详见{@link module:zrender/graphic/Displayable.prototype.updateDisplayList}
   * @return {Array.<module:zrender/graphic/Displayable>}
   */
  getDisplayList: function (update, includeIgnore) {
    includeIgnore = includeIgnore || false;

    if (update) {
      this.updateDisplayList(includeIgnore);
    }

    return this._displayList;
  },

  /**
   * 更新图形的绘制队列。
   * 每次绘制前都会调用，该方法会先深度优先遍历整个树，更新所有Group和Shape的变换并且把所有可见的Shape保存到数组中，
   * 最后根据绘制的优先级（zlevel > z > 插入顺序）排序得到绘制队列
   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组
   */
  updateDisplayList: function (includeIgnore) {
    this._displayListLen = 0;
    var roots = this._roots;
    var displayList = this._displayList;

    for (var i = 0, len = roots.length; i < len; i++) {
      this._updateAndAddDisplayable(roots[i], null, includeIgnore);
    }

    displayList.length = this._displayListLen;
    env.canvasSupported && timsort(displayList, shapeCompareFunc);
  },
  _updateAndAddDisplayable: function (el, clipPaths, includeIgnore) {
    if (el.ignore && !includeIgnore) {
      return;
    }

    el.beforeUpdate();

    if (el.__dirty) {
      el.update();
    }

    el.afterUpdate();
    var userSetClipPath = el.clipPath;

    if (userSetClipPath) {
      // FIXME 效率影响
      if (clipPaths) {
        clipPaths = clipPaths.slice();
      } else {
        clipPaths = [];
      }

      var currentClipPath = userSetClipPath;
      var parentClipPath = el; // Recursively add clip path

      while (currentClipPath) {
        // clipPath 的变换是基于使用这个 clipPath 的元素
        currentClipPath.parent = parentClipPath;
        currentClipPath.updateTransform();
        clipPaths.push(currentClipPath);
        parentClipPath = currentClipPath;
        currentClipPath = currentClipPath.clipPath;
      }
    }

    if (el.isGroup) {
      var children = el._children;

      for (var i = 0; i < children.length; i++) {
        var child = children[i]; // Force to mark as dirty if group is dirty
        // FIXME __dirtyPath ?

        if (el.__dirty) {
          child.__dirty = true;
        }

        this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
      } // Mark group clean here


      el.__dirty = false;
    } else {
      el.__clipPaths = clipPaths;
      this._displayList[this._displayListLen++] = el;
    }
  },

  /**
   * 添加图形(Shape)或者组(Group)到根节点
   * @param {module:zrender/Element} el
   */
  addRoot: function (el) {
    if (el.__storage === this) {
      return;
    }

    if (el instanceof Group) {
      el.addChildrenToStorage(this);
    }

    this.addToStorage(el);

    this._roots.push(el);
  },

  /**
   * 删除指定的图形(Shape)或者组(Group)
   * @param {string|Array.<string>} [el] 如果为空清空整个Storage
   */
  delRoot: function (el) {
    if (el == null) {
      // 不指定el清空
      for (var i = 0; i < this._roots.length; i++) {
        var root = this._roots[i];

        if (root instanceof Group) {
          root.delChildrenFromStorage(this);
        }
      }

      this._roots = [];
      this._displayList = [];
      this._displayListLen = 0;
      return;
    }

    if (el instanceof Array) {
      for (var i = 0, l = el.length; i < l; i++) {
        this.delRoot(el[i]);
      }

      return;
    }

    var idx = util.indexOf(this._roots, el);

    if (idx >= 0) {
      this.delFromStorage(el);

      this._roots.splice(idx, 1);

      if (el instanceof Group) {
        el.delChildrenFromStorage(this);
      }
    }
  },
  addToStorage: function (el) {
    if (el) {
      el.__storage = this;
      el.dirty(false);
    }

    return this;
  },
  delFromStorage: function (el) {
    if (el) {
      el.__storage = null;
    }

    return this;
  },

  /**
   * 清空并且释放Storage
   */
  dispose: function () {
    this._renderList = this._roots = null;
  },
  displayableSortFunc: shapeCompareFunc
};
var _default = Storage;
module.exports = _default;

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

var Animator = __webpack_require__(616);

var logError = __webpack_require__(232);

var _util = __webpack_require__(1);

var isString = _util.isString;
var isFunction = _util.isFunction;
var isObject = _util.isObject;
var isArrayLike = _util.isArrayLike;
var indexOf = _util.indexOf;

/**
 * @alias module:zrender/mixin/Animatable
 * @constructor
 */
var Animatable = function () {
  /**
   * @type {Array.<module:zrender/animation/Animator>}
   * @readOnly
   */
  this.animators = [];
};

Animatable.prototype = {
  constructor: Animatable,

  /**
   * 动画
   *
   * @param {string} path The path to fetch value from object, like 'a.b.c'.
   * @param {boolean} [loop] Whether to loop animation.
   * @return {module:zrender/animation/Animator}
   * @example:
   *     el.animate('style', false)
   *         .when(1000, {x: 10} )
   *         .done(function(){ // Animation done })
   *         .start()
   */
  animate: function (path, loop) {
    var target;
    var animatingShape = false;
    var el = this;
    var zr = this.__zr;

    if (path) {
      var pathSplitted = path.split('.');
      var prop = el; // If animating shape

      animatingShape = pathSplitted[0] === 'shape';

      for (var i = 0, l = pathSplitted.length; i < l; i++) {
        if (!prop) {
          continue;
        }

        prop = prop[pathSplitted[i]];
      }

      if (prop) {
        target = prop;
      }
    } else {
      target = el;
    }

    if (!target) {
      logError('Property "' + path + '" is not existed in element ' + el.id);
      return;
    }

    var animators = el.animators;
    var animator = new Animator(target, loop);
    animator.during(function (target) {
      el.dirty(animatingShape);
    }).done(function () {
      // FIXME Animator will not be removed if use `Animator#stop` to stop animation
      animators.splice(indexOf(animators, animator), 1);
    });
    animators.push(animator); // If animate after added to the zrender

    if (zr) {
      zr.animation.addAnimator(animator);
    }

    return animator;
  },

  /**
   * 停止动画
   * @param {boolean} forwardToLast If move to last frame before stop
   */
  stopAnimation: function (forwardToLast) {
    var animators = this.animators;
    var len = animators.length;

    for (var i = 0; i < len; i++) {
      animators[i].stop(forwardToLast);
    }

    animators.length = 0;
    return this;
  },

  /**
   * Caution: this method will stop previous animation.
   * So do not use this method to one element twice before
   * animation starts, unless you know what you are doing.
   * @param {Object} target
   * @param {number} [time=500] Time in ms
   * @param {string} [easing='linear']
   * @param {number} [delay=0]
   * @param {Function} [callback]
   * @param {Function} [forceAnimate] Prevent stop animation and callback
   *        immediently when target values are the same as current values.
   *
   * @example
   *  // Animate position
   *  el.animateTo({
   *      position: [10, 10]
   *  }, function () { // done })
   *
   *  // Animate shape, style and position in 100ms, delayed 100ms, with cubicOut easing
   *  el.animateTo({
   *      shape: {
   *          width: 500
   *      },
   *      style: {
   *          fill: 'red'
   *      }
   *      position: [10, 10]
   *  }, 100, 100, 'cubicOut', function () { // done })
   */
  // TODO Return animation key
  animateTo: function (target, time, delay, easing, callback, forceAnimate) {
    animateTo(this, target, time, delay, easing, callback, forceAnimate);
  },

  /**
   * Animate from the target state to current state.
   * The params and the return value are the same as `this.animateTo`.
   */
  animateFrom: function (target, time, delay, easing, callback, forceAnimate) {
    animateTo(this, target, time, delay, easing, callback, forceAnimate, true);
  }
};

function animateTo(animatable, target, time, delay, easing, callback, forceAnimate, reverse) {
  // animateTo(target, time, easing, callback);
  if (isString(delay)) {
    callback = easing;
    easing = delay;
    delay = 0;
  } // animateTo(target, time, delay, callback);
  else if (isFunction(easing)) {
      callback = easing;
      easing = 'linear';
      delay = 0;
    } // animateTo(target, time, callback);
    else if (isFunction(delay)) {
        callback = delay;
        delay = 0;
      } // animateTo(target, callback)
      else if (isFunction(time)) {
          callback = time;
          time = 500;
        } // animateTo(target)
        else if (!time) {
            time = 500;
          } // Stop all previous animations


  animatable.stopAnimation();
  animateToShallow(animatable, '', animatable, target, time, delay, reverse); // Animators may be removed immediately after start
  // if there is nothing to animate

  var animators = animatable.animators.slice();
  var count = animators.length;

  function done() {
    count--;

    if (!count) {
      callback && callback();
    }
  } // No animators. This should be checked before animators[i].start(),
  // because 'done' may be executed immediately if no need to animate.


  if (!count) {
    callback && callback();
  } // Start after all animators created
  // Incase any animator is done immediately when all animation properties are not changed


  for (var i = 0; i < animators.length; i++) {
    animators[i].done(done).start(easing, forceAnimate);
  }
}
/**
 * @param {string} path=''
 * @param {Object} source=animatable
 * @param {Object} target
 * @param {number} [time=500]
 * @param {number} [delay=0]
 * @param {boolean} [reverse] If `true`, animate
 *        from the `target` to current state.
 *
 * @example
 *  // Animate position
 *  el._animateToShallow({
 *      position: [10, 10]
 *  })
 *
 *  // Animate shape, style and position in 100ms, delayed 100ms
 *  el._animateToShallow({
 *      shape: {
 *          width: 500
 *      },
 *      style: {
 *          fill: 'red'
 *      }
 *      position: [10, 10]
 *  }, 100, 100)
 */


function animateToShallow(animatable, path, source, target, time, delay, reverse) {
  var objShallow = {};
  var propertyCount = 0;

  for (var name in target) {
    if (!target.hasOwnProperty(name)) {
      continue;
    }

    if (source[name] != null) {
      if (isObject(target[name]) && !isArrayLike(target[name])) {
        animateToShallow(animatable, path ? path + '.' + name : name, source[name], target[name], time, delay, reverse);
      } else {
        if (reverse) {
          objShallow[name] = source[name];
          setAttrByPath(animatable, path, name, target[name]);
        } else {
          objShallow[name] = target[name];
        }

        propertyCount++;
      }
    } else if (target[name] != null && !reverse) {
      setAttrByPath(animatable, path, name, target[name]);
    }
  }

  if (propertyCount > 0) {
    animatable.animate(path, false).when(time == null ? 500 : time, objShallow).delay(delay || 0);
  }
}

function setAttrByPath(el, path, name, value) {
  // Attr directly if not has property
  // FIXME, if some property not needed for element ?
  if (!path) {
    el.attr(name, value);
  } else {
    // Only support set shape or style
    var props = {};
    props[path] = {};
    props[path][name] = value;
    el.attr(props);
  }
}

var _default = Animatable;
module.exports = _default;

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

var easingFuncs = __webpack_require__(1533);

/**
 * 动画主控制器
 * @config target 动画对象，可以是数组，如果是数组的话会批量分发onframe等事件
 * @config life(1000) 动画时长
 * @config delay(0) 动画延迟时间
 * @config loop(true)
 * @config gap(0) 循环的间隔时间
 * @config onframe
 * @config easing(optional)
 * @config ondestroy(optional)
 * @config onrestart(optional)
 *
 * TODO pause
 */
function Clip(options) {
  this._target = options.target; // 生命周期

  this._life = options.life || 1000; // 延时

  this._delay = options.delay || 0; // 开始时间
  // this._startTime = new Date().getTime() + this._delay;// 单位毫秒

  this._initialized = false; // 是否循环

  this.loop = options.loop == null ? false : options.loop;
  this.gap = options.gap || 0;
  this.easing = options.easing || 'Linear';
  this.onframe = options.onframe;
  this.ondestroy = options.ondestroy;
  this.onrestart = options.onrestart;
  this._pausedTime = 0;
  this._paused = false;
}

Clip.prototype = {
  constructor: Clip,
  step: function (globalTime, deltaTime) {
    // Set startTime on first step, or _startTime may has milleseconds different between clips
    // PENDING
    if (!this._initialized) {
      this._startTime = globalTime + this._delay;
      this._initialized = true;
    }

    if (this._paused) {
      this._pausedTime += deltaTime;
      return;
    }

    var percent = (globalTime - this._startTime - this._pausedTime) / this._life; // 还没开始

    if (percent < 0) {
      return;
    }

    percent = Math.min(percent, 1);
    var easing = this.easing;
    var easingFunc = typeof easing === 'string' ? easingFuncs[easing] : easing;
    var schedule = typeof easingFunc === 'function' ? easingFunc(percent) : percent;
    this.fire('frame', schedule); // 结束

    if (percent === 1) {
      if (this.loop) {
        this.restart(globalTime); // 重新开始周期
        // 抛出而不是直接调用事件直到 stage.update 后再统一调用这些事件

        return 'restart';
      } // 动画完成将这个控制器标识为待删除
      // 在Animation.update中进行批量删除


      this._needsRemove = true;
      return 'destroy';
    }

    return null;
  },
  restart: function (globalTime) {
    var remainder = (globalTime - this._startTime - this._pausedTime) % this._life;
    this._startTime = globalTime - remainder + this.gap;
    this._pausedTime = 0;
    this._needsRemove = false;
  },
  fire: function (eventType, arg) {
    eventType = 'on' + eventType;

    if (this[eventType]) {
      this[eventType](this._target, arg);
    }
  },
  pause: function () {
    this._paused = true;
  },
  resume: function () {
    this._paused = false;
  }
};
var _default = Clip;
module.exports = _default;

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

/**
 * 缓动代码来自 https://github.com/sole/tween.js/blob/master/src/Tween.js
 * @see http://sole.github.io/tween.js/examples/03_graphs.html
 * @exports zrender/animation/easing
 */
var easing = {
  /**
  * @param {number} k
  * @return {number}
  */
  linear: function (k) {
    return k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quadraticIn: function (k) {
    return k * k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quadraticOut: function (k) {
    return k * (2 - k);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quadraticInOut: function (k) {
    if ((k *= 2) < 1) {
      return 0.5 * k * k;
    }

    return -0.5 * (--k * (k - 2) - 1);
  },
  // 三次方的缓动（t^3）

  /**
  * @param {number} k
  * @return {number}
  */
  cubicIn: function (k) {
    return k * k * k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  cubicOut: function (k) {
    return --k * k * k + 1;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  cubicInOut: function (k) {
    if ((k *= 2) < 1) {
      return 0.5 * k * k * k;
    }

    return 0.5 * ((k -= 2) * k * k + 2);
  },
  // 四次方的缓动（t^4）

  /**
  * @param {number} k
  * @return {number}
  */
  quarticIn: function (k) {
    return k * k * k * k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quarticOut: function (k) {
    return 1 - --k * k * k * k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quarticInOut: function (k) {
    if ((k *= 2) < 1) {
      return 0.5 * k * k * k * k;
    }

    return -0.5 * ((k -= 2) * k * k * k - 2);
  },
  // 五次方的缓动（t^5）

  /**
  * @param {number} k
  * @return {number}
  */
  quinticIn: function (k) {
    return k * k * k * k * k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quinticOut: function (k) {
    return --k * k * k * k * k + 1;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quinticInOut: function (k) {
    if ((k *= 2) < 1) {
      return 0.5 * k * k * k * k * k;
    }

    return 0.5 * ((k -= 2) * k * k * k * k + 2);
  },
  // 正弦曲线的缓动（sin(t)）

  /**
  * @param {number} k
  * @return {number}
  */
  sinusoidalIn: function (k) {
    return 1 - Math.cos(k * Math.PI / 2);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  sinusoidalOut: function (k) {
    return Math.sin(k * Math.PI / 2);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  sinusoidalInOut: function (k) {
    return 0.5 * (1 - Math.cos(Math.PI * k));
  },
  // 指数曲线的缓动（2^t）

  /**
  * @param {number} k
  * @return {number}
  */
  exponentialIn: function (k) {
    return k === 0 ? 0 : Math.pow(1024, k - 1);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  exponentialOut: function (k) {
    return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  exponentialInOut: function (k) {
    if (k === 0) {
      return 0;
    }

    if (k === 1) {
      return 1;
    }

    if ((k *= 2) < 1) {
      return 0.5 * Math.pow(1024, k - 1);
    }

    return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
  },
  // 圆形曲线的缓动（sqrt(1-t^2)）

  /**
  * @param {number} k
  * @return {number}
  */
  circularIn: function (k) {
    return 1 - Math.sqrt(1 - k * k);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  circularOut: function (k) {
    return Math.sqrt(1 - --k * k);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  circularInOut: function (k) {
    if ((k *= 2) < 1) {
      return -0.5 * (Math.sqrt(1 - k * k) - 1);
    }

    return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
  },
  // 创建类似于弹簧在停止前来回振荡的动画

  /**
  * @param {number} k
  * @return {number}
  */
  elasticIn: function (k) {
    var s;
    var a = 0.1;
    var p = 0.4;

    if (k === 0) {
      return 0;
    }

    if (k === 1) {
      return 1;
    }

    if (!a || a < 1) {
      a = 1;
      s = p / 4;
    } else {
      s = p * Math.asin(1 / a) / (2 * Math.PI);
    }

    return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
  },

  /**
  * @param {number} k
  * @return {number}
  */
  elasticOut: function (k) {
    var s;
    var a = 0.1;
    var p = 0.4;

    if (k === 0) {
      return 0;
    }

    if (k === 1) {
      return 1;
    }

    if (!a || a < 1) {
      a = 1;
      s = p / 4;
    } else {
      s = p * Math.asin(1 / a) / (2 * Math.PI);
    }

    return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  elasticInOut: function (k) {
    var s;
    var a = 0.1;
    var p = 0.4;

    if (k === 0) {
      return 0;
    }

    if (k === 1) {
      return 1;
    }

    if (!a || a < 1) {
      a = 1;
      s = p / 4;
    } else {
      s = p * Math.asin(1 / a) / (2 * Math.PI);
    }

    if ((k *= 2) < 1) {
      return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
    }

    return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
  },
  // 在某一动画开始沿指示的路径进行动画处理前稍稍收回该动画的移动

  /**
  * @param {number} k
  * @return {number}
  */
  backIn: function (k) {
    var s = 1.70158;
    return k * k * ((s + 1) * k - s);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  backOut: function (k) {
    var s = 1.70158;
    return --k * k * ((s + 1) * k + s) + 1;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  backInOut: function (k) {
    var s = 1.70158 * 1.525;

    if ((k *= 2) < 1) {
      return 0.5 * (k * k * ((s + 1) * k - s));
    }

    return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
  },
  // 创建弹跳效果

  /**
  * @param {number} k
  * @return {number}
  */
  bounceIn: function (k) {
    return 1 - easing.bounceOut(1 - k);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  bounceOut: function (k) {
    if (k < 1 / 2.75) {
      return 7.5625 * k * k;
    } else if (k < 2 / 2.75) {
      return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
    } else if (k < 2.5 / 2.75) {
      return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
    } else {
      return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
    }
  },

  /**
  * @param {number} k
  * @return {number}
  */
  bounceInOut: function (k) {
    if (k < 0.5) {
      return easing.bounceIn(k * 2) * 0.5;
    }

    return easing.bounceOut(k * 2 - 1) * 0.5 + 0.5;
  }
};
var _default = easing;
module.exports = _default;

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(293);

var devicePixelRatio = _config.devicePixelRatio;

var util = __webpack_require__(1);

var logError = __webpack_require__(232);

var BoundingRect = __webpack_require__(57);

var timsort = __webpack_require__(404);

var Layer = __webpack_require__(1535);

var requestAnimationFrame = __webpack_require__(620);

var Image = __webpack_require__(203);

var env = __webpack_require__(67);

var HOVER_LAYER_ZLEVEL = 1e5;
var CANVAS_ZLEVEL = 314159;
var EL_AFTER_INCREMENTAL_INC = 0.01;
var INCREMENTAL_INC = 0.001;

function parseInt10(val) {
  return parseInt(val, 10);
}

function isLayerValid(layer) {
  if (!layer) {
    return false;
  }

  if (layer.__builtin__) {
    return true;
  }

  if (typeof layer.resize !== 'function' || typeof layer.refresh !== 'function') {
    return false;
  }

  return true;
}

var tmpRect = new BoundingRect(0, 0, 0, 0);
var viewRect = new BoundingRect(0, 0, 0, 0);

function isDisplayableCulled(el, width, height) {
  tmpRect.copy(el.getBoundingRect());

  if (el.transform) {
    tmpRect.applyTransform(el.transform);
  }

  viewRect.width = width;
  viewRect.height = height;
  return !tmpRect.intersect(viewRect);
}

function isClipPathChanged(clipPaths, prevClipPaths) {
  // displayable.__clipPaths can only be `null`/`undefined` or an non-empty array.
  if (clipPaths === prevClipPaths) {
    return false;
  }

  if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) {
    return true;
  }

  for (var i = 0; i < clipPaths.length; i++) {
    if (clipPaths[i] !== prevClipPaths[i]) {
      return true;
    }
  }

  return false;
}

function doClip(clipPaths, ctx) {
  for (var i = 0; i < clipPaths.length; i++) {
    var clipPath = clipPaths[i];
    clipPath.setTransform(ctx);
    ctx.beginPath();
    clipPath.buildPath(ctx, clipPath.shape);
    ctx.clip(); // Transform back

    clipPath.restoreTransform(ctx);
  }
}

function createRoot(width, height) {
  var domRoot = document.createElement('div'); // domRoot.onselectstart = returnFalse; // Avoid page selected

  domRoot.style.cssText = ['position:relative', // IOS13 safari probably has a compositing bug (z order of the canvas and the consequent
  // dom does not act as expected) when some of the parent dom has
  // `-webkit-overflow-scrolling: touch;` and the webpage is longer than one screen and
  // the canvas is not at the top part of the page.
  // Check `https://bugs.webkit.org/show_bug.cgi?id=203681` for more details. We remove
  // this `overflow:hidden` to avoid the bug.
  // 'overflow:hidden',
  'width:' + width + 'px', 'height:' + height + 'px', 'padding:0', 'margin:0', 'border-width:0'].join(';') + ';';
  return domRoot;
}
/**
 * @alias module:zrender/Painter
 * @constructor
 * @param {HTMLElement} root 绘图容器
 * @param {module:zrender/Storage} storage
 * @param {Object} opts
 */


var Painter = function (root, storage, opts) {
  this.type = 'canvas'; // In node environment using node-canvas

  var singleCanvas = !root.nodeName // In node ?
  || root.nodeName.toUpperCase() === 'CANVAS';
  this._opts = opts = util.extend({}, opts || {});
  /**
   * @type {number}
   */

  this.dpr = opts.devicePixelRatio || devicePixelRatio;
  /**
   * @type {boolean}
   * @private
   */

  this._singleCanvas = singleCanvas;
  /**
   * 绘图容器
   * @type {HTMLElement}
   */

  this.root = root;
  var rootStyle = root.style;

  if (rootStyle) {
    rootStyle['-webkit-tap-highlight-color'] = 'transparent';
    rootStyle['-webkit-user-select'] = rootStyle['user-select'] = rootStyle['-webkit-touch-callout'] = 'none';
    root.innerHTML = '';
  }
  /**
   * @type {module:zrender/Storage}
   */


  this.storage = storage;
  /**
   * @type {Array.<number>}
   * @private
   */

  var zlevelList = this._zlevelList = [];
  /**
   * @type {Object.<string, module:zrender/Layer>}
   * @private
   */

  var layers = this._layers = {};
  /**
   * @type {Object.<string, Object>}
   * @private
   */

  this._layerConfig = {};
  /**
   * zrender will do compositing when root is a canvas and have multiple zlevels.
   */

  this._needsManuallyCompositing = false;

  if (!singleCanvas) {
    this._width = this._getSize(0);
    this._height = this._getSize(1);
    var domRoot = this._domRoot = createRoot(this._width, this._height);
    root.appendChild(domRoot);
  } else {
    var width = root.width;
    var height = root.height;

    if (opts.width != null) {
      width = opts.width;
    }

    if (opts.height != null) {
      height = opts.height;
    }

    this.dpr = opts.devicePixelRatio || 1; // Use canvas width and height directly

    root.width = width * this.dpr;
    root.height = height * this.dpr;
    this._width = width;
    this._height = height; // Create layer if only one given canvas
    // Device can be specified to create a high dpi image.

    var mainLayer = new Layer(root, this, this.dpr);
    mainLayer.__builtin__ = true;
    mainLayer.initContext(); // FIXME Use canvas width and height
    // mainLayer.resize(width, height);

    layers[CANVAS_ZLEVEL] = mainLayer;
    mainLayer.zlevel = CANVAS_ZLEVEL; // Not use common zlevel.

    zlevelList.push(CANVAS_ZLEVEL);
    this._domRoot = root;
  }
  /**
   * @type {module:zrender/Layer}
   * @private
   */


  this._hoverlayer = null;
  this._hoverElements = [];
};

Painter.prototype = {
  constructor: Painter,
  getType: function () {
    return 'canvas';
  },

  /**
   * If painter use a single canvas
   * @return {boolean}
   */
  isSingleCanvas: function () {
    return this._singleCanvas;
  },

  /**
   * @return {HTMLDivElement}
   */
  getViewportRoot: function () {
    return this._domRoot;
  },
  getViewportRootOffset: function () {
    var viewportRoot = this.getViewportRoot();

    if (viewportRoot) {
      return {
        offsetLeft: viewportRoot.offsetLeft || 0,
        offsetTop: viewportRoot.offsetTop || 0
      };
    }
  },

  /**
   * 刷新
   * @param {boolean} [paintAll=false] 强制绘制所有displayable
   */
  refresh: function (paintAll) {
    var list = this.storage.getDisplayList(true);
    var zlevelList = this._zlevelList;
    this._redrawId = Math.random();

    this._paintList(list, paintAll, this._redrawId); // Paint custum layers


    for (var i = 0; i < zlevelList.length; i++) {
      var z = zlevelList[i];
      var layer = this._layers[z];

      if (!layer.__builtin__ && layer.refresh) {
        var clearColor = i === 0 ? this._backgroundColor : null;
        layer.refresh(clearColor);
      }
    }

    this.refreshHover();
    return this;
  },
  addHover: function (el, hoverStyle) {
    if (el.__hoverMir) {
      return;
    }

    var elMirror = new el.constructor({
      style: el.style,
      shape: el.shape,
      z: el.z,
      z2: el.z2,
      silent: el.silent
    });
    elMirror.__from = el;
    el.__hoverMir = elMirror;
    hoverStyle && elMirror.setStyle(hoverStyle);

    this._hoverElements.push(elMirror);

    return elMirror;
  },
  removeHover: function (el) {
    var elMirror = el.__hoverMir;
    var hoverElements = this._hoverElements;
    var idx = util.indexOf(hoverElements, elMirror);

    if (idx >= 0) {
      hoverElements.splice(idx, 1);
    }

    el.__hoverMir = null;
  },
  clearHover: function (el) {
    var hoverElements = this._hoverElements;

    for (var i = 0; i < hoverElements.length; i++) {
      var from = hoverElements[i].__from;

      if (from) {
        from.__hoverMir = null;
      }
    }

    hoverElements.length = 0;
  },
  refreshHover: function () {
    var hoverElements = this._hoverElements;
    var len = hoverElements.length;
    var hoverLayer = this._hoverlayer;
    hoverLayer && hoverLayer.clear();

    if (!len) {
      return;
    }

    timsort(hoverElements, this.storage.displayableSortFunc); // Use a extream large zlevel
    // FIXME?

    if (!hoverLayer) {
      hoverLayer = this._hoverlayer = this.getLayer(HOVER_LAYER_ZLEVEL);
    }

    var scope = {};
    hoverLayer.ctx.save();

    for (var i = 0; i < len;) {
      var el = hoverElements[i];
      var originalEl = el.__from; // Original el is removed
      // PENDING

      if (!(originalEl && originalEl.__zr)) {
        hoverElements.splice(i, 1);
        originalEl.__hoverMir = null;
        len--;
        continue;
      }

      i++; // Use transform
      // FIXME style and shape ?

      if (!originalEl.invisible) {
        el.transform = originalEl.transform;
        el.invTransform = originalEl.invTransform;
        el.__clipPaths = originalEl.__clipPaths; // el.

        this._doPaintEl(el, hoverLayer, true, scope);
      }
    }

    hoverLayer.ctx.restore();
  },
  getHoverLayer: function () {
    return this.getLayer(HOVER_LAYER_ZLEVEL);
  },
  _paintList: function (list, paintAll, redrawId) {
    if (this._redrawId !== redrawId) {
      return;
    }

    paintAll = paintAll || false;

    this._updateLayerStatus(list);

    var finished = this._doPaintList(list, paintAll);

    if (this._needsManuallyCompositing) {
      this._compositeManually();
    }

    if (!finished) {
      var self = this;
      requestAnimationFrame(function () {
        self._paintList(list, paintAll, redrawId);
      });
    }
  },
  _compositeManually: function () {
    var ctx = this.getLayer(CANVAS_ZLEVEL).ctx;
    var width = this._domRoot.width;
    var height = this._domRoot.height;
    ctx.clearRect(0, 0, width, height); // PENDING, If only builtin layer?

    this.eachBuiltinLayer(function (layer) {
      if (layer.virtual) {
        ctx.drawImage(layer.dom, 0, 0, width, height);
      }
    });
  },
  _doPaintList: function (list, paintAll) {
    var layerList = [];

    for (var zi = 0; zi < this._zlevelList.length; zi++) {
      var zlevel = this._zlevelList[zi];
      var layer = this._layers[zlevel];

      if (layer.__builtin__ && layer !== this._hoverlayer && (layer.__dirty || paintAll)) {
        layerList.push(layer);
      }
    }

    var finished = true;

    for (var k = 0; k < layerList.length; k++) {
      var layer = layerList[k];
      var ctx = layer.ctx;
      var scope = {};
      ctx.save();
      var start = paintAll ? layer.__startIndex : layer.__drawIndex;
      var useTimer = !paintAll && layer.incremental && Date.now;
      var startTime = useTimer && Date.now();
      var clearColor = layer.zlevel === this._zlevelList[0] ? this._backgroundColor : null; // All elements in this layer are cleared.

      if (layer.__startIndex === layer.__endIndex) {
        layer.clear(false, clearColor);
      } else if (start === layer.__startIndex) {
        var firstEl = list[start];

        if (!firstEl.incremental || !firstEl.notClear || paintAll) {
          layer.clear(false, clearColor);
        }
      }

      if (start === -1) {
        console.error('For some unknown reason. drawIndex is -1');
        start = layer.__startIndex;
      }

      for (var i = start; i < layer.__endIndex; i++) {
        var el = list[i];

        this._doPaintEl(el, layer, paintAll, scope);

        el.__dirty = el.__dirtyText = false;

        if (useTimer) {
          // Date.now can be executed in 13,025,305 ops/second.
          var dTime = Date.now() - startTime; // Give 15 millisecond to draw.
          // The rest elements will be drawn in the next frame.

          if (dTime > 15) {
            break;
          }
        }
      }

      layer.__drawIndex = i;

      if (layer.__drawIndex < layer.__endIndex) {
        finished = false;
      }

      if (scope.prevElClipPaths) {
        // Needs restore the state. If last drawn element is in the clipping area.
        ctx.restore();
      }

      ctx.restore();
    }

    if (env.wxa) {
      // Flush for weixin application
      util.each(this._layers, function (layer) {
        if (layer && layer.ctx && layer.ctx.draw) {
          layer.ctx.draw();
        }
      });
    }

    return finished;
  },
  _doPaintEl: function (el, currentLayer, forcePaint, scope) {
    var ctx = currentLayer.ctx;
    var m = el.transform;

    if ((currentLayer.__dirty || forcePaint) && // Ignore invisible element
    !el.invisible // Ignore transparent element
    && el.style.opacity !== 0 // Ignore scale 0 element, in some environment like node-canvas
    // Draw a scale 0 element can cause all following draw wrong
    // And setTransform with scale 0 will cause set back transform failed.
    && !(m && !m[0] && !m[3]) // Ignore culled element
    && !(el.culling && isDisplayableCulled(el, this._width, this._height))) {
      var clipPaths = el.__clipPaths;
      var prevElClipPaths = scope.prevElClipPaths; // Optimize when clipping on group with several elements

      if (!prevElClipPaths || isClipPathChanged(clipPaths, prevElClipPaths)) {
        // If has previous clipping state, restore from it
        if (prevElClipPaths) {
          ctx.restore();
          scope.prevElClipPaths = null; // Reset prevEl since context has been restored

          scope.prevEl = null;
        } // New clipping state


        if (clipPaths) {
          ctx.save();
          doClip(clipPaths, ctx);
          scope.prevElClipPaths = clipPaths;
        }
      }

      el.beforeBrush && el.beforeBrush(ctx);
      el.brush(ctx, scope.prevEl || null);
      scope.prevEl = el;
      el.afterBrush && el.afterBrush(ctx);
    }
  },

  /**
   * 获取 zlevel 所在层，如果不存在则会创建一个新的层
   * @param {number} zlevel
   * @param {boolean} virtual Virtual layer will not be inserted into dom.
   * @return {module:zrender/Layer}
   */
  getLayer: function (zlevel, virtual) {
    if (this._singleCanvas && !this._needsManuallyCompositing) {
      zlevel = CANVAS_ZLEVEL;
    }

    var layer = this._layers[zlevel];

    if (!layer) {
      // Create a new layer
      layer = new Layer('zr_' + zlevel, this, this.dpr);
      layer.zlevel = zlevel;
      layer.__builtin__ = true;

      if (this._layerConfig[zlevel]) {
        util.merge(layer, this._layerConfig[zlevel], true);
      } // TODO Remove EL_AFTER_INCREMENTAL_INC magic number
      else if (this._layerConfig[zlevel - EL_AFTER_INCREMENTAL_INC]) {
          util.merge(layer, this._layerConfig[zlevel - EL_AFTER_INCREMENTAL_INC], true);
        }

      if (virtual) {
        layer.virtual = virtual;
      }

      this.insertLayer(zlevel, layer); // Context is created after dom inserted to document
      // Or excanvas will get 0px clientWidth and clientHeight

      layer.initContext();
    }

    return layer;
  },
  insertLayer: function (zlevel, layer) {
    var layersMap = this._layers;
    var zlevelList = this._zlevelList;
    var len = zlevelList.length;
    var prevLayer = null;
    var i = -1;
    var domRoot = this._domRoot;

    if (layersMap[zlevel]) {
      logError('ZLevel ' + zlevel + ' has been used already');
      return;
    } // Check if is a valid layer


    if (!isLayerValid(layer)) {
      logError('Layer of zlevel ' + zlevel + ' is not valid');
      return;
    }

    if (len > 0 && zlevel > zlevelList[0]) {
      for (i = 0; i < len - 1; i++) {
        if (zlevelList[i] < zlevel && zlevelList[i + 1] > zlevel) {
          break;
        }
      }

      prevLayer = layersMap[zlevelList[i]];
    }

    zlevelList.splice(i + 1, 0, zlevel);
    layersMap[zlevel] = layer; // Vitual layer will not directly show on the screen.
    // (It can be a WebGL layer and assigned to a ZImage element)
    // But it still under management of zrender.

    if (!layer.virtual) {
      if (prevLayer) {
        var prevDom = prevLayer.dom;

        if (prevDom.nextSibling) {
          domRoot.insertBefore(layer.dom, prevDom.nextSibling);
        } else {
          domRoot.appendChild(layer.dom);
        }
      } else {
        if (domRoot.firstChild) {
          domRoot.insertBefore(layer.dom, domRoot.firstChild);
        } else {
          domRoot.appendChild(layer.dom);
        }
      }
    }
  },
  // Iterate each layer
  eachLayer: function (cb, context) {
    var zlevelList = this._zlevelList;
    var z;
    var i;

    for (i = 0; i < zlevelList.length; i++) {
      z = zlevelList[i];
      cb.call(context, this._layers[z], z);
    }
  },
  // Iterate each buildin layer
  eachBuiltinLayer: function (cb, context) {
    var zlevelList = this._zlevelList;
    var layer;
    var z;
    var i;

    for (i = 0; i < zlevelList.length; i++) {
      z = zlevelList[i];
      layer = this._layers[z];

      if (layer.__builtin__) {
        cb.call(context, layer, z);
      }
    }
  },
  // Iterate each other layer except buildin layer
  eachOtherLayer: function (cb, context) {
    var zlevelList = this._zlevelList;
    var layer;
    var z;
    var i;

    for (i = 0; i < zlevelList.length; i++) {
      z = zlevelList[i];
      layer = this._layers[z];

      if (!layer.__builtin__) {
        cb.call(context, layer, z);
      }
    }
  },

  /**
   * 获取所有已创建的层
   * @param {Array.<module:zrender/Layer>} [prevLayer]
   */
  getLayers: function () {
    return this._layers;
  },
  _updateLayerStatus: function (list) {
    this.eachBuiltinLayer(function (layer, z) {
      layer.__dirty = layer.__used = false;
    });

    function updatePrevLayer(idx) {
      if (prevLayer) {
        if (prevLayer.__endIndex !== idx) {
          prevLayer.__dirty = true;
        }

        prevLayer.__endIndex = idx;
      }
    }

    if (this._singleCanvas) {
      for (var i = 1; i < list.length; i++) {
        var el = list[i];

        if (el.zlevel !== list[i - 1].zlevel || el.incremental) {
          this._needsManuallyCompositing = true;
          break;
        }
      }
    }

    var prevLayer = null;
    var incrementalLayerCount = 0;
    var prevZlevel;

    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      var zlevel = el.zlevel;
      var layer;

      if (prevZlevel !== zlevel) {
        prevZlevel = zlevel;
        incrementalLayerCount = 0;
      } // TODO Not use magic number on zlevel.
      // Each layer with increment element can be separated to 3 layers.
      //          (Other Element drawn after incremental element)
      // -----------------zlevel + EL_AFTER_INCREMENTAL_INC--------------------
      //                      (Incremental element)
      // ----------------------zlevel + INCREMENTAL_INC------------------------
      //              (Element drawn before incremental element)
      // --------------------------------zlevel--------------------------------


      if (el.incremental) {
        layer = this.getLayer(zlevel + INCREMENTAL_INC, this._needsManuallyCompositing);
        layer.incremental = true;
        incrementalLayerCount = 1;
      } else {
        layer = this.getLayer(zlevel + (incrementalLayerCount > 0 ? EL_AFTER_INCREMENTAL_INC : 0), this._needsManuallyCompositing);
      }

      if (!layer.__builtin__) {
        logError('ZLevel ' + zlevel + ' has been used by unkown layer ' + layer.id);
      }

      if (layer !== prevLayer) {
        layer.__used = true;

        if (layer.__startIndex !== i) {
          layer.__dirty = true;
        }

        layer.__startIndex = i;

        if (!layer.incremental) {
          layer.__drawIndex = i;
        } else {
          // Mark layer draw index needs to update.
          layer.__drawIndex = -1;
        }

        updatePrevLayer(i);
        prevLayer = layer;
      }

      if (el.__dirty) {
        layer.__dirty = true;

        if (layer.incremental && layer.__drawIndex < 0) {
          // Start draw from the first dirty element.
          layer.__drawIndex = i;
        }
      }
    }

    updatePrevLayer(i);
    this.eachBuiltinLayer(function (layer, z) {
      // Used in last frame but not in this frame. Needs clear
      if (!layer.__used && layer.getElementCount() > 0) {
        layer.__dirty = true;
        layer.__startIndex = layer.__endIndex = layer.__drawIndex = 0;
      } // For incremental layer. In case start index changed and no elements are dirty.


      if (layer.__dirty && layer.__drawIndex < 0) {
        layer.__drawIndex = layer.__startIndex;
      }
    });
  },

  /**
   * 清除hover层外所有内容
   */
  clear: function () {
    this.eachBuiltinLayer(this._clearLayer);
    return this;
  },
  _clearLayer: function (layer) {
    layer.clear();
  },
  setBackgroundColor: function (backgroundColor) {
    this._backgroundColor = backgroundColor;
  },

  /**
   * 修改指定zlevel的绘制参数
   *
   * @param {string} zlevel
   * @param {Object} config 配置对象
   * @param {string} [config.clearColor=0] 每次清空画布的颜色
   * @param {string} [config.motionBlur=false] 是否开启动态模糊
   * @param {number} [config.lastFrameAlpha=0.7]
   *                 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
   */
  configLayer: function (zlevel, config) {
    if (config) {
      var layerConfig = this._layerConfig;

      if (!layerConfig[zlevel]) {
        layerConfig[zlevel] = config;
      } else {
        util.merge(layerConfig[zlevel], config, true);
      }

      for (var i = 0; i < this._zlevelList.length; i++) {
        var _zlevel = this._zlevelList[i]; // TODO Remove EL_AFTER_INCREMENTAL_INC magic number

        if (_zlevel === zlevel || _zlevel === zlevel + EL_AFTER_INCREMENTAL_INC) {
          var layer = this._layers[_zlevel];
          util.merge(layer, layerConfig[zlevel], true);
        }
      }
    }
  },

  /**
   * 删除指定层
   * @param {number} zlevel 层所在的zlevel
   */
  delLayer: function (zlevel) {
    var layers = this._layers;
    var zlevelList = this._zlevelList;
    var layer = layers[zlevel];

    if (!layer) {
      return;
    }

    layer.dom.parentNode.removeChild(layer.dom);
    delete layers[zlevel];
    zlevelList.splice(util.indexOf(zlevelList, zlevel), 1);
  },

  /**
   * 区域大小变化后重绘
   */
  resize: function (width, height) {
    if (!this._domRoot.style) {
      // Maybe in node or worker
      if (width == null || height == null) {
        return;
      }

      this._width = width;
      this._height = height;
      this.getLayer(CANVAS_ZLEVEL).resize(width, height);
    } else {
      var domRoot = this._domRoot; // FIXME Why ?

      domRoot.style.display = 'none'; // Save input w/h

      var opts = this._opts;
      width != null && (opts.width = width);
      height != null && (opts.height = height);
      width = this._getSize(0);
      height = this._getSize(1);
      domRoot.style.display = ''; // 优化没有实际改变的resize

      if (this._width !== width || height !== this._height) {
        domRoot.style.width = width + 'px';
        domRoot.style.height = height + 'px';

        for (var id in this._layers) {
          if (this._layers.hasOwnProperty(id)) {
            this._layers[id].resize(width, height);
          }
        }

        util.each(this._progressiveLayers, function (layer) {
          layer.resize(width, height);
        });
        this.refresh(true);
      }

      this._width = width;
      this._height = height;
    }

    return this;
  },

  /**
   * 清除单独的一个层
   * @param {number} zlevel
   */
  clearLayer: function (zlevel) {
    var layer = this._layers[zlevel];

    if (layer) {
      layer.clear();
    }
  },

  /**
   * 释放
   */
  dispose: function () {
    this.root.innerHTML = '';
    this.root = this.storage = this._domRoot = this._layers = null;
  },

  /**
   * Get canvas which has all thing rendered
   * @param {Object} opts
   * @param {string} [opts.backgroundColor]
   * @param {number} [opts.pixelRatio]
   */
  getRenderedCanvas: function (opts) {
    opts = opts || {};

    if (this._singleCanvas && !this._compositeManually) {
      return this._layers[CANVAS_ZLEVEL].dom;
    }

    var imageLayer = new Layer('image', this, opts.pixelRatio || this.dpr);
    imageLayer.initContext();
    imageLayer.clear(false, opts.backgroundColor || this._backgroundColor);

    if (opts.pixelRatio <= this.dpr) {
      this.refresh();
      var width = imageLayer.dom.width;
      var height = imageLayer.dom.height;
      var ctx = imageLayer.ctx;
      this.eachLayer(function (layer) {
        if (layer.__builtin__) {
          ctx.drawImage(layer.dom, 0, 0, width, height);
        } else if (layer.renderToCanvas) {
          imageLayer.ctx.save();
          layer.renderToCanvas(imageLayer.ctx);
          imageLayer.ctx.restore();
        }
      });
    } else {
      // PENDING, echarts-gl and incremental rendering.
      var scope = {};
      var displayList = this.storage.getDisplayList(true);

      for (var i = 0; i < displayList.length; i++) {
        var el = displayList[i];

        this._doPaintEl(el, imageLayer, true, scope);
      }
    }

    return imageLayer.dom;
  },

  /**
   * 获取绘图区域宽度
   */
  getWidth: function () {
    return this._width;
  },

  /**
   * 获取绘图区域高度
   */
  getHeight: function () {
    return this._height;
  },
  _getSize: function (whIdx) {
    var opts = this._opts;
    var wh = ['width', 'height'][whIdx];
    var cwh = ['clientWidth', 'clientHeight'][whIdx];
    var plt = ['paddingLeft', 'paddingTop'][whIdx];
    var prb = ['paddingRight', 'paddingBottom'][whIdx];

    if (opts[wh] != null && opts[wh] !== 'auto') {
      return parseFloat(opts[wh]);
    }

    var root = this.root; // IE8 does not support getComputedStyle, but it use VML.

    var stl = document.defaultView.getComputedStyle(root);
    return (root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh])) - (parseInt10(stl[plt]) || 0) - (parseInt10(stl[prb]) || 0) | 0;
  },
  pathToImage: function (path, dpr) {
    dpr = dpr || this.dpr;
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    var rect = path.getBoundingRect();
    var style = path.style;
    var shadowBlurSize = style.shadowBlur * dpr;
    var shadowOffsetX = style.shadowOffsetX * dpr;
    var shadowOffsetY = style.shadowOffsetY * dpr;
    var lineWidth = style.hasStroke() ? style.lineWidth : 0;
    var leftMargin = Math.max(lineWidth / 2, -shadowOffsetX + shadowBlurSize);
    var rightMargin = Math.max(lineWidth / 2, shadowOffsetX + shadowBlurSize);
    var topMargin = Math.max(lineWidth / 2, -shadowOffsetY + shadowBlurSize);
    var bottomMargin = Math.max(lineWidth / 2, shadowOffsetY + shadowBlurSize);
    var width = rect.width + leftMargin + rightMargin;
    var height = rect.height + topMargin + bottomMargin;
    canvas.width = width * dpr;
    canvas.height = height * dpr;
    ctx.scale(dpr, dpr);
    ctx.clearRect(0, 0, width, height);
    ctx.dpr = dpr;
    var pathTransform = {
      position: path.position,
      rotation: path.rotation,
      scale: path.scale
    };
    path.position = [leftMargin - rect.x, topMargin - rect.y];
    path.rotation = 0;
    path.scale = [1, 1];
    path.updateTransform();

    if (path) {
      path.brush(ctx);
    }

    var ImageShape = Image;
    var imgShape = new ImageShape({
      style: {
        x: 0,
        y: 0,
        image: canvas
      }
    });

    if (pathTransform.position != null) {
      imgShape.position = path.position = pathTransform.position;
    }

    if (pathTransform.rotation != null) {
      imgShape.rotation = path.rotation = pathTransform.rotation;
    }

    if (pathTransform.scale != null) {
      imgShape.scale = path.scale = pathTransform.scale;
    }

    return imgShape;
  }
};
var _default = Painter;
module.exports = _default;

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(1);

var _config = __webpack_require__(293);

var devicePixelRatio = _config.devicePixelRatio;

var Style = __webpack_require__(405);

var Pattern = __webpack_require__(619);

/**
 * @module zrender/Layer
 * @author pissang(https://www.github.com/pissang)
 */
function returnFalse() {
  return false;
}
/**
 * 创建dom
 *
 * @inner
 * @param {string} id dom id 待用
 * @param {Painter} painter painter instance
 * @param {number} number
 */


function createDom(id, painter, dpr) {
  var newDom = util.createCanvas();
  var width = painter.getWidth();
  var height = painter.getHeight();
  var newDomStyle = newDom.style;

  if (newDomStyle) {
    // In node or some other non-browser environment
    newDomStyle.position = 'absolute';
    newDomStyle.left = 0;
    newDomStyle.top = 0;
    newDomStyle.width = width + 'px';
    newDomStyle.height = height + 'px';
    newDom.setAttribute('data-zr-dom-id', id);
  }

  newDom.width = width * dpr;
  newDom.height = height * dpr;
  return newDom;
}
/**
 * @alias module:zrender/Layer
 * @constructor
 * @extends module:zrender/mixin/Transformable
 * @param {string} id
 * @param {module:zrender/Painter} painter
 * @param {number} [dpr]
 */


var Layer = function (id, painter, dpr) {
  var dom;
  dpr = dpr || devicePixelRatio;

  if (typeof id === 'string') {
    dom = createDom(id, painter, dpr);
  } // Not using isDom because in node it will return false
  else if (util.isObject(id)) {
      dom = id;
      id = dom.id;
    }

  this.id = id;
  this.dom = dom;
  var domStyle = dom.style;

  if (domStyle) {
    // Not in node
    dom.onselectstart = returnFalse; // 避免页面选中的尴尬

    domStyle['-webkit-user-select'] = 'none';
    domStyle['user-select'] = 'none';
    domStyle['-webkit-touch-callout'] = 'none';
    domStyle['-webkit-tap-highlight-color'] = 'rgba(0,0,0,0)';
    domStyle['padding'] = 0; // eslint-disable-line dot-notation

    domStyle['margin'] = 0; // eslint-disable-line dot-notation

    domStyle['border-width'] = 0;
  }

  this.domBack = null;
  this.ctxBack = null;
  this.painter = painter;
  this.config = null; // Configs

  /**
   * 每次清空画布的颜色
   * @type {string}
   * @default 0
   */

  this.clearColor = 0;
  /**
   * 是否开启动态模糊
   * @type {boolean}
   * @default false
   */

  this.motionBlur = false;
  /**
   * 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
   * @type {number}
   * @default 0.7
   */

  this.lastFrameAlpha = 0.7;
  /**
   * Layer dpr
   * @type {number}
   */

  this.dpr = dpr;
};

Layer.prototype = {
  constructor: Layer,
  __dirty: true,
  __used: false,
  __drawIndex: 0,
  __startIndex: 0,
  __endIndex: 0,
  incremental: false,
  getElementCount: function () {
    return this.__endIndex - this.__startIndex;
  },
  initContext: function () {
    this.ctx = this.dom.getContext('2d');
    this.ctx.dpr = this.dpr;
  },
  createBackBuffer: function () {
    var dpr = this.dpr;
    this.domBack = createDom('back-' + this.id, this.painter, dpr);
    this.ctxBack = this.domBack.getContext('2d');

    if (dpr !== 1) {
      this.ctxBack.scale(dpr, dpr);
    }
  },

  /**
   * @param  {number} width
   * @param  {number} height
   */
  resize: function (width, height) {
    var dpr = this.dpr;
    var dom = this.dom;
    var domStyle = dom.style;
    var domBack = this.domBack;

    if (domStyle) {
      domStyle.width = width + 'px';
      domStyle.height = height + 'px';
    }

    dom.width = width * dpr;
    dom.height = height * dpr;

    if (domBack) {
      domBack.width = width * dpr;
      domBack.height = height * dpr;

      if (dpr !== 1) {
        this.ctxBack.scale(dpr, dpr);
      }
    }
  },

  /**
   * 清空该层画布
   * @param {boolean} [clearAll]=false Clear all with out motion blur
   * @param {Color} [clearColor]
   */
  clear: function (clearAll, clearColor) {
    var dom = this.dom;
    var ctx = this.ctx;
    var width = dom.width;
    var height = dom.height;
    var clearColor = clearColor || this.clearColor;
    var haveMotionBLur = this.motionBlur && !clearAll;
    var lastFrameAlpha = this.lastFrameAlpha;
    var dpr = this.dpr;

    if (haveMotionBLur) {
      if (!this.domBack) {
        this.createBackBuffer();
      }

      this.ctxBack.globalCompositeOperation = 'copy';
      this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
    }

    ctx.clearRect(0, 0, width, height);

    if (clearColor && clearColor !== 'transparent') {
      var clearColorGradientOrPattern; // Gradient

      if (clearColor.colorStops) {
        // Cache canvas gradient
        clearColorGradientOrPattern = clearColor.__canvasGradient || Style.getGradient(ctx, clearColor, {
          x: 0,
          y: 0,
          width: width,
          height: height
        });
        clearColor.__canvasGradient = clearColorGradientOrPattern;
      } // Pattern
      else if (clearColor.image) {
          clearColorGradientOrPattern = Pattern.prototype.getCanvasPattern.call(clearColor, ctx);
        }

      ctx.save();
      ctx.fillStyle = clearColorGradientOrPattern || clearColor;
      ctx.fillRect(0, 0, width, height);
      ctx.restore();
    }

    if (haveMotionBLur) {
      var domBack = this.domBack;
      ctx.save();
      ctx.globalAlpha = lastFrameAlpha;
      ctx.drawImage(domBack, 0, 0, width, height);
      ctx.restore();
    }
  }
};
var _default = Layer;
module.exports = _default;

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(1);

var _event = __webpack_require__(121);

var Dispatcher = _event.Dispatcher;

var requestAnimationFrame = __webpack_require__(620);

var Animator = __webpack_require__(616);

/**
 * Animation main class, dispatch and manage all animation controllers
 *
 * @module zrender/animation/Animation
 * @author pissang(https://github.com/pissang)
 */
// TODO Additive animation
// http://iosoteric.com/additive-animations-animatewithduration-in-ios-8/
// https://developer.apple.com/videos/wwdc2014/#236

/**
 * @typedef {Object} IZRenderStage
 * @property {Function} update
 */

/**
 * @alias module:zrender/animation/Animation
 * @constructor
 * @param {Object} [options]
 * @param {Function} [options.onframe]
 * @param {IZRenderStage} [options.stage]
 * @example
 *     var animation = new Animation();
 *     var obj = {
 *         x: 100,
 *         y: 100
 *     };
 *     animation.animate(node.position)
 *         .when(1000, {
 *             x: 500,
 *             y: 500
 *         })
 *         .when(2000, {
 *             x: 100,
 *             y: 100
 *         })
 *         .start('spline');
 */
var Animation = function (options) {
  options = options || {};
  this.stage = options.stage || {};

  this.onframe = options.onframe || function () {}; // private properties


  this._clips = [];
  this._running = false;
  this._time;
  this._pausedTime;
  this._pauseStart;
  this._paused = false;
  Dispatcher.call(this);
};

Animation.prototype = {
  constructor: Animation,

  /**
   * Add clip
   * @param {module:zrender/animation/Clip} clip
   */
  addClip: function (clip) {
    this._clips.push(clip);
  },

  /**
   * Add animator
   * @param {module:zrender/animation/Animator} animator
   */
  addAnimator: function (animator) {
    animator.animation = this;
    var clips = animator.getClips();

    for (var i = 0; i < clips.length; i++) {
      this.addClip(clips[i]);
    }
  },

  /**
   * Delete animation clip
   * @param {module:zrender/animation/Clip} clip
   */
  removeClip: function (clip) {
    var idx = util.indexOf(this._clips, clip);

    if (idx >= 0) {
      this._clips.splice(idx, 1);
    }
  },

  /**
   * Delete animation clip
   * @param {module:zrender/animation/Animator} animator
   */
  removeAnimator: function (animator) {
    var clips = animator.getClips();

    for (var i = 0; i < clips.length; i++) {
      this.removeClip(clips[i]);
    }

    animator.animation = null;
  },
  _update: function () {
    var time = new Date().getTime() - this._pausedTime;

    var delta = time - this._time;
    var clips = this._clips;
    var len = clips.length;
    var deferredEvents = [];
    var deferredClips = [];

    for (var i = 0; i < len; i++) {
      var clip = clips[i];
      var e = clip.step(time, delta); // Throw out the events need to be called after
      // stage.update, like destroy

      if (e) {
        deferredEvents.push(e);
        deferredClips.push(clip);
      }
    } // Remove the finished clip


    for (var i = 0; i < len;) {
      if (clips[i]._needsRemove) {
        clips[i] = clips[len - 1];
        clips.pop();
        len--;
      } else {
        i++;
      }
    }

    len = deferredEvents.length;

    for (var i = 0; i < len; i++) {
      deferredClips[i].fire(deferredEvents[i]);
    }

    this._time = time;
    this.onframe(delta); // 'frame' should be triggered before stage, because upper application
    // depends on the sequence (e.g., echarts-stream and finish
    // event judge)

    this.trigger('frame', delta);

    if (this.stage.update) {
      this.stage.update();
    }
  },
  _startLoop: function () {
    var self = this;
    this._running = true;

    function step() {
      if (self._running) {
        requestAnimationFrame(step);
        !self._paused && self._update();
      }
    }

    requestAnimationFrame(step);
  },

  /**
   * Start animation.
   */
  start: function () {
    this._time = new Date().getTime();
    this._pausedTime = 0;

    this._startLoop();
  },

  /**
   * Stop animation.
   */
  stop: function () {
    this._running = false;
  },

  /**
   * Pause animation.
   */
  pause: function () {
    if (!this._paused) {
      this._pauseStart = new Date().getTime();
      this._paused = true;
    }
  },

  /**
   * Resume animation.
   */
  resume: function () {
    if (this._paused) {
      this._pausedTime += new Date().getTime() - this._pauseStart;
      this._paused = false;
    }
  },

  /**
   * Clear animation.
   */
  clear: function () {
    this._clips = [];
  },

  /**
   * Whether animation finished.
   */
  isFinished: function () {
    return !this._clips.length;
  },

  /**
   * Creat animator for a target, whose props can be animated.
   *
   * @param  {Object} target
   * @param  {Object} options
   * @param  {boolean} [options.loop=false] Whether loop animation.
   * @param  {Function} [options.getter=null] Get value from target.
   * @param  {Function} [options.setter=null] Set value to target.
   * @return {module:zrender/animation/Animation~Animator}
   */
  // TODO Gap
  animate: function (target, options) {
    options = options || {};
    var animator = new Animator(target, options.loop, options.getter, options.setter);
    this.addAnimator(animator);
    return animator;
  }
};
util.mixin(Animation, Dispatcher);
var _default = Animation;
module.exports = _default;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

var _event = __webpack_require__(121);

var addEventListener = _event.addEventListener;
var removeEventListener = _event.removeEventListener;
var normalizeEvent = _event.normalizeEvent;
var getNativeEvent = _event.getNativeEvent;

var zrUtil = __webpack_require__(1);

var Eventful = __webpack_require__(173);

var env = __webpack_require__(67);

/* global document */
var TOUCH_CLICK_DELAY = 300;
var globalEventSupported = env.domSupported;

var localNativeListenerNames = function () {
  var mouseHandlerNames = ['click', 'dblclick', 'mousewheel', 'mouseout', 'mouseup', 'mousedown', 'mousemove', 'contextmenu'];
  var touchHandlerNames = ['touchstart', 'touchend', 'touchmove'];
  var pointerEventNameMap = {
    pointerdown: 1,
    pointerup: 1,
    pointermove: 1,
    pointerout: 1
  };
  var pointerHandlerNames = zrUtil.map(mouseHandlerNames, function (name) {
    var nm = name.replace('mouse', 'pointer');
    return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
  });
  return {
    mouse: mouseHandlerNames,
    touch: touchHandlerNames,
    pointer: pointerHandlerNames
  };
}();

var globalNativeListenerNames = {
  mouse: ['mousemove', 'mouseup'],
  pointer: ['pointermove', 'pointerup']
};

function eventNameFix(name) {
  return name === 'mousewheel' && env.browser.firefox ? 'DOMMouseScroll' : name;
}

function isPointerFromTouch(event) {
  var pointerType = event.pointerType;
  return pointerType === 'pen' || pointerType === 'touch';
} // function useMSGuesture(handlerProxy, event) {
//     return isPointerFromTouch(event) && !!handlerProxy._msGesture;
// }
// function onMSGestureChange(proxy, event) {
//     if (event.translationX || event.translationY) {
//         // mousemove is carried by MSGesture to reduce the sensitivity.
//         proxy.handler.dispatchToElement(event.target, 'mousemove', event);
//     }
//     if (event.scale !== 1) {
//         event.pinchX = event.offsetX;
//         event.pinchY = event.offsetY;
//         event.pinchScale = event.scale;
//         proxy.handler.dispatchToElement(event.target, 'pinch', event);
//     }
// }

/**
 * Prevent mouse event from being dispatched after Touch Events action
 * @see <https://github.com/deltakosh/handjs/blob/master/src/hand.base.js>
 * 1. Mobile browsers dispatch mouse events 300ms after touchend.
 * 2. Chrome for Android dispatch mousedown for long-touch about 650ms
 * Result: Blocking Mouse Events for 700ms.
 *
 * @param {DOMHandlerScope} scope
 */


function setTouchTimer(scope) {
  scope.touching = true;

  if (scope.touchTimer != null) {
    clearTimeout(scope.touchTimer);
    scope.touchTimer = null;
  }

  scope.touchTimer = setTimeout(function () {
    scope.touching = false;
    scope.touchTimer = null;
  }, 700);
} // Mark touch, which is useful in distinguish touch and
// mouse event in upper applicatoin.


function markTouch(event) {
  event && (event.zrByTouch = true);
} // function markTriggeredFromLocal(event) {
//     event && (event.__zrIsFromLocal = true);
// }
// function isTriggeredFromLocal(instance, event) {
//     return !!(event && event.__zrIsFromLocal);
// }


function normalizeGlobalEvent(instance, event) {
  // offsetX, offsetY still need to be calculated. They are necessary in the event
  // handlers of the upper applications. Set `true` to force calculate them.
  return normalizeEvent(instance.dom, new FakeGlobalEvent(instance, event), true);
}
/**
 * Detect whether the given el is in `painterRoot`.
 */


function isLocalEl(instance, el) {
  var elTmp = el;
  var isLocal = false;

  while (elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot)) {
    elTmp = elTmp.parentNode;
  }

  return isLocal;
}
/**
 * Make a fake event but not change the original event,
 * becuase the global event probably be used by other
 * listeners not belonging to zrender.
 * @class
 */


function FakeGlobalEvent(instance, event) {
  this.type = event.type;
  this.target = this.currentTarget = instance.dom;
  this.pointerType = event.pointerType; // Necessray for the force calculation of zrX, zrY

  this.clientX = event.clientX;
  this.clientY = event.clientY; // Because we do not mount global listeners to touch events,
  // we do not copy `targetTouches` and `changedTouches` here.
}

var fakeGlobalEventProto = FakeGlobalEvent.prototype; // we make the default methods on the event do nothing,
// otherwise it is dangerous. See more details in
// [Drag outside] in `Handler.js`.

fakeGlobalEventProto.stopPropagation = fakeGlobalEventProto.stopImmediatePropagation = fakeGlobalEventProto.preventDefault = zrUtil.noop;
/**
 * Local DOM Handlers
 * @this {HandlerProxy}
 */

var localDOMHandlers = {
  mousedown: function (event) {
    event = normalizeEvent(this.dom, event);
    this._mayPointerCapture = [event.zrX, event.zrY];
    this.trigger('mousedown', event);
  },
  mousemove: function (event) {
    event = normalizeEvent(this.dom, event);
    var downPoint = this._mayPointerCapture;

    if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) {
      togglePointerCapture(this, true);
    }

    this.trigger('mousemove', event);
  },
  mouseup: function (event) {
    event = normalizeEvent(this.dom, event);
    togglePointerCapture(this, false);
    this.trigger('mouseup', event);
  },
  mouseout: function (event) {
    event = normalizeEvent(this.dom, event); // Similarly to the browser did on `document` and touch event,
    // `globalout` will be delayed to final pointer cature release.

    if (this._pointerCapturing) {
      event.zrEventControl = 'no_globalout';
    } // There might be some doms created by upper layer application
    // at the same level of painter.getViewportRoot() (e.g., tooltip
    // dom created by echarts), where 'globalout' event should not
    // be triggered when mouse enters these doms. (But 'mouseout'
    // should be triggered at the original hovered element as usual).


    var element = event.toElement || event.relatedTarget;
    event.zrIsToLocalDOM = isLocalEl(this, element);
    this.trigger('mouseout', event);
  },
  touchstart: function (event) {
    // Default mouse behaviour should not be disabled here.
    // For example, page may needs to be slided.
    event = normalizeEvent(this.dom, event);
    markTouch(event);
    this._lastTouchMoment = new Date();
    this.handler.processGesture(event, 'start'); // For consistent event listener for both touch device and mouse device,
    // we simulate "mouseover-->mousedown" in touch device. So we trigger
    // `mousemove` here (to trigger `mouseover` inside), and then trigger
    // `mousedown`.

    localDOMHandlers.mousemove.call(this, event);
    localDOMHandlers.mousedown.call(this, event);
  },
  touchmove: function (event) {
    event = normalizeEvent(this.dom, event);
    markTouch(event);
    this.handler.processGesture(event, 'change'); // Mouse move should always be triggered no matter whether
    // there is gestrue event, because mouse move and pinch may
    // be used at the same time.

    localDOMHandlers.mousemove.call(this, event);
  },
  touchend: function (event) {
    event = normalizeEvent(this.dom, event);
    markTouch(event);
    this.handler.processGesture(event, 'end');
    localDOMHandlers.mouseup.call(this, event); // Do not trigger `mouseout` here, in spite of `mousemove`(`mouseover`) is
    // triggered in `touchstart`. This seems to be illogical, but by this mechanism,
    // we can conveniently implement "hover style" in both PC and touch device just
    // by listening to `mouseover` to add "hover style" and listening to `mouseout`
    // to remove "hover style" on an element, without any additional code for
    // compatibility. (`mouseout` will not be triggered in `touchend`, so "hover
    // style" will remain for user view)
    // click event should always be triggered no matter whether
    // there is gestrue event. System click can not be prevented.

    if (+new Date() - this._lastTouchMoment < TOUCH_CLICK_DELAY) {
      localDOMHandlers.click.call(this, event);
    }
  },
  pointerdown: function (event) {
    localDOMHandlers.mousedown.call(this, event); // if (useMSGuesture(this, event)) {
    //     this._msGesture.addPointer(event.pointerId);
    // }
  },
  pointermove: function (event) {
    // FIXME
    // pointermove is so sensitive that it always triggered when
    // tap(click) on touch screen, which affect some judgement in
    // upper application. So, we dont support mousemove on MS touch
    // device yet.
    if (!isPointerFromTouch(event)) {
      localDOMHandlers.mousemove.call(this, event);
    }
  },
  pointerup: function (event) {
    localDOMHandlers.mouseup.call(this, event);
  },
  pointerout: function (event) {
    // pointerout will be triggered when tap on touch screen
    // (IE11+/Edge on MS Surface) after click event triggered,
    // which is inconsistent with the mousout behavior we defined
    // in touchend. So we unify them.
    // (check localDOMHandlers.touchend for detailed explanation)
    if (!isPointerFromTouch(event)) {
      localDOMHandlers.mouseout.call(this, event);
    }
  }
};
/**
 * Othere DOM UI Event handlers for zr dom.
 * @this {HandlerProxy}
 */

zrUtil.each(['click', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
  localDOMHandlers[name] = function (event) {
    event = normalizeEvent(this.dom, event);
    this.trigger(name, event);
  };
});
/**
 * DOM UI Event handlers for global page.
 *
 * [Caution]:
 * those handlers should both support in capture phase and bubble phase!
 *
 * @this {HandlerProxy}
 */

var globalDOMHandlers = {
  pointermove: function (event) {
    // FIXME
    // pointermove is so sensitive that it always triggered when
    // tap(click) on touch screen, which affect some judgement in
    // upper application. So, we dont support mousemove on MS touch
    // device yet.
    if (!isPointerFromTouch(event)) {
      globalDOMHandlers.mousemove.call(this, event);
    }
  },
  pointerup: function (event) {
    globalDOMHandlers.mouseup.call(this, event);
  },
  mousemove: function (event) {
    this.trigger('mousemove', event);
  },
  mouseup: function (event) {
    var pointerCaptureReleasing = this._pointerCapturing;
    togglePointerCapture(this, false);
    this.trigger('mouseup', event);

    if (pointerCaptureReleasing) {
      event.zrEventControl = 'only_globalout';
      this.trigger('mouseout', event);
    }
  }
};
/**
 * @param {HandlerProxy} instance
 * @param {DOMHandlerScope} scope
 */

function mountLocalDOMEventListeners(instance, scope) {
  var domHandlers = scope.domHandlers;

  if (env.pointerEventsSupported) {
    // Only IE11+/Edge
    // 1. On devices that both enable touch and mouse (e.g., MS Surface and lenovo X240),
    // IE11+/Edge do not trigger touch event, but trigger pointer event and mouse event
    // at the same time.
    // 2. On MS Surface, it probablely only trigger mousedown but no mouseup when tap on
    // screen, which do not occurs in pointer event.
    // So we use pointer event to both detect touch gesture and mouse behavior.
    zrUtil.each(localNativeListenerNames.pointer, function (nativeEventName) {
      mountSingleDOMEventListener(scope, nativeEventName, function (event) {
        // markTriggeredFromLocal(event);
        domHandlers[nativeEventName].call(instance, event);
      });
    }); // FIXME
    // Note: MS Gesture require CSS touch-action set. But touch-action is not reliable,
    // which does not prevent defuault behavior occasionally (which may cause view port
    // zoomed in but use can not zoom it back). And event.preventDefault() does not work.
    // So we have to not to use MSGesture and not to support touchmove and pinch on MS
    // touch screen. And we only support click behavior on MS touch screen now.
    // MS Gesture Event is only supported on IE11+/Edge and on Windows 8+.
    // We dont support touch on IE on win7.
    // See <https://msdn.microsoft.com/en-us/library/dn433243(v=vs.85).aspx>
    // if (typeof MSGesture === 'function') {
    //     (this._msGesture = new MSGesture()).target = dom; // jshint ignore:line
    //     dom.addEventListener('MSGestureChange', onMSGestureChange);
    // }
  } else {
    if (env.touchEventsSupported) {
      zrUtil.each(localNativeListenerNames.touch, function (nativeEventName) {
        mountSingleDOMEventListener(scope, nativeEventName, function (event) {
          // markTriggeredFromLocal(event);
          domHandlers[nativeEventName].call(instance, event);
          setTouchTimer(scope);
        });
      }); // Handler of 'mouseout' event is needed in touch mode, which will be mounted below.
      // addEventListener(root, 'mouseout', this._mouseoutHandler);
    } // 1. Considering some devices that both enable touch and mouse event (like on MS Surface
    // and lenovo X240, @see #2350), we make mouse event be always listened, otherwise
    // mouse event can not be handle in those devices.
    // 2. On MS Surface, Chrome will trigger both touch event and mouse event. How to prevent
    // mouseevent after touch event triggered, see `setTouchTimer`.


    zrUtil.each(localNativeListenerNames.mouse, function (nativeEventName) {
      mountSingleDOMEventListener(scope, nativeEventName, function (event) {
        event = getNativeEvent(event);

        if (!scope.touching) {
          // markTriggeredFromLocal(event);
          domHandlers[nativeEventName].call(instance, event);
        }
      });
    });
  }
}
/**
 * @param {HandlerProxy} instance
 * @param {DOMHandlerScope} scope
 */


function mountGlobalDOMEventListeners(instance, scope) {
  // Only IE11+/Edge. See the comment in `mountLocalDOMEventListeners`.
  if (env.pointerEventsSupported) {
    zrUtil.each(globalNativeListenerNames.pointer, mount);
  } // Touch event has implemented "drag outside" so we do not mount global listener for touch event.
  // (see https://www.w3.org/TR/touch-events/#the-touchmove-event)
  // We do not consider "both-support-touch-and-mouse device" for this feature (see the comment of
  // `mountLocalDOMEventListeners`) to avoid bugs util some requirements come.
  else if (!env.touchEventsSupported) {
      zrUtil.each(globalNativeListenerNames.mouse, mount);
    }

  function mount(nativeEventName) {
    function nativeEventListener(event) {
      event = getNativeEvent(event); // See the reason in [Drag outside] in `Handler.js`
      // This checking supports both `useCapture` or not.
      // PENDING: if there is performance issue in some devices,
      // we probably can not use `useCapture` and change a easier
      // to judes whether local (mark).

      if (!isLocalEl(instance, event.target)) {
        event = normalizeGlobalEvent(instance, event);
        scope.domHandlers[nativeEventName].call(instance, event);
      }
    }

    mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
      capture: true
    } // See [Drag Outside] in `Handler.js`
    );
  }
}

function mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
  scope.mounted[nativeEventName] = listener;
  scope.listenerOpts[nativeEventName] = opt;
  addEventListener(scope.domTarget, eventNameFix(nativeEventName), listener, opt);
}

function unmountDOMEventListeners(scope) {
  var mounted = scope.mounted;

  for (var nativeEventName in mounted) {
    if (mounted.hasOwnProperty(nativeEventName)) {
      removeEventListener(scope.domTarget, eventNameFix(nativeEventName), mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
    }
  }

  scope.mounted = {};
}
/**
 * See [Drag Outside] in `Handler.js`.
 * @implement
 * @param {boolean} isPointerCapturing Should never be `null`/`undefined`.
 *        `true`: start to capture pointer if it is not capturing.
 *        `false`: end the capture if it is capturing.
 */


function togglePointerCapture(instance, isPointerCapturing) {
  instance._mayPointerCapture = null;

  if (globalEventSupported && instance._pointerCapturing ^ isPointerCapturing) {
    instance._pointerCapturing = isPointerCapturing;
    var globalHandlerScope = instance._globalHandlerScope;
    isPointerCapturing ? mountGlobalDOMEventListeners(instance, globalHandlerScope) : unmountDOMEventListeners(globalHandlerScope);
  }
}
/**
 * @inner
 * @class
 */


function DOMHandlerScope(domTarget, domHandlers) {
  this.domTarget = domTarget;
  this.domHandlers = domHandlers; // Key: eventName, value: mounted handler funcitons.
  // Used for unmount.

  this.mounted = {};
  this.listenerOpts = {};
  this.touchTimer = null;
  this.touching = false;
}
/**
 * @public
 * @class
 */


function HandlerDomProxy(dom, painterRoot) {
  Eventful.call(this);
  this.dom = dom;
  this.painterRoot = painterRoot;
  this._localHandlerScope = new DOMHandlerScope(dom, localDOMHandlers);

  if (globalEventSupported) {
    this._globalHandlerScope = new DOMHandlerScope(document, globalDOMHandlers);
  }
  /**
   * @type {boolean}
   */


  this._pointerCapturing = false;
  /**
   * @type {Array.<number>} [x, y] or null.
   */

  this._mayPointerCapture = null;
  mountLocalDOMEventListeners(this, this._localHandlerScope);
}

var handlerDomProxyProto = HandlerDomProxy.prototype;

handlerDomProxyProto.dispose = function () {
  unmountDOMEventListeners(this._localHandlerScope);

  if (globalEventSupported) {
    unmountDOMEventListeners(this._globalHandlerScope);
  }
};

handlerDomProxyProto.setCursor = function (cursorStyle) {
  this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
};

zrUtil.mixin(HandlerDomProxy, Eventful);
var _default = HandlerDomProxy;
module.exports = _default;

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var makeStyleMapper = __webpack_require__(204);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var getLineStyle = makeStyleMapper([['lineWidth', 'width'], ['stroke', 'color'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
var _default = {
  getLineStyle: function (excludes) {
    var style = getLineStyle(this, excludes); // Always set lineDash whether dashed, otherwise we can not
    // erase the previous style when assigning to el.style.

    style.lineDash = this.getLineDash(style.lineWidth);
    return style;
  },
  getLineDash: function (lineWidth) {
    if (lineWidth == null) {
      lineWidth = 1;
    }

    var lineType = this.get('type');
    var dotSize = Math.max(lineWidth, 2);
    var dashSize = lineWidth * 4;
    return lineType === 'solid' || lineType == null ? // Use `false` but not `null` for the solid line here, because `null` might be
    // ignored when assigning to `el.style`. e.g., when setting `lineStyle.type` as
    // `'dashed'` and `emphasis.lineStyle.type` as `'solid'` in graph series, the
    // `lineDash` gotten form the latter one is not able to erase that from the former
    // one if using `null` here according to the emhpsis strategy in `util/graphic.js`.
    false : lineType === 'dashed' ? [dashSize, dashSize] : [dotSize, dotSize];
  }
};
module.exports = _default;

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var makeStyleMapper = __webpack_require__(204);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var getAreaStyle = makeStyleMapper([['fill', 'color'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['opacity'], ['shadowColor']]);
var _default = {
  getAreaStyle: function (excludes, includes) {
    return getAreaStyle(this, excludes, includes);
  }
};
module.exports = _default;

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var textContain = __webpack_require__(93);

var graphicUtil = __webpack_require__(27);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var PATH_COLOR = ['textStyle', 'color'];
var _default = {
  /**
   * Get color property or get color from option.textStyle.color
   * @param {boolean} [isEmphasis]
   * @return {string}
   */
  getTextColor: function (isEmphasis) {
    var ecModel = this.ecModel;
    return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get(PATH_COLOR) : null);
  },

  /**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */
  getFont: function () {
    return graphicUtil.getFont({
      fontStyle: this.getShallow('fontStyle'),
      fontWeight: this.getShallow('fontWeight'),
      fontSize: this.getShallow('fontSize'),
      fontFamily: this.getShallow('fontFamily')
    }, this.ecModel);
  },
  getTextRect: function (text) {
    return textContain.getBoundingRect(text, this.getFont(), this.getShallow('align'), this.getShallow('verticalAlign') || this.getShallow('baseline'), this.getShallow('padding'), this.getShallow('lineHeight'), this.getShallow('rich'), this.getShallow('truncateText'));
  }
};
module.exports = _default;

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

var PathProxy = __webpack_require__(205);

var line = __webpack_require__(625);

var cubic = __webpack_require__(1542);

var quadratic = __webpack_require__(626);

var arc = __webpack_require__(1543);

var _util = __webpack_require__(627);

var normalizeRadian = _util.normalizeRadian;

var curve = __webpack_require__(147);

var windingLine = __webpack_require__(628);

var CMD = PathProxy.CMD;
var PI2 = Math.PI * 2;
var EPSILON = 1e-4;

function isAroundEqual(a, b) {
  return Math.abs(a - b) < EPSILON;
} // 临时数组


var roots = [-1, -1, -1];
var extrema = [-1, -1];

function swapExtrema() {
  var tmp = extrema[0];
  extrema[0] = extrema[1];
  extrema[1] = tmp;
}

function windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
  // Quick reject
  if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) {
    return 0;
  }

  var nRoots = curve.cubicRootAt(y0, y1, y2, y3, y, roots);

  if (nRoots === 0) {
    return 0;
  } else {
    var w = 0;
    var nExtrema = -1;
    var y0_;
    var y1_;

    for (var i = 0; i < nRoots; i++) {
      var t = roots[i]; // Avoid winding error when intersection point is the connect point of two line of polygon

      var unit = t === 0 || t === 1 ? 0.5 : 1;
      var x_ = curve.cubicAt(x0, x1, x2, x3, t);

      if (x_ < x) {
        // Quick reject
        continue;
      }

      if (nExtrema < 0) {
        nExtrema = curve.cubicExtrema(y0, y1, y2, y3, extrema);

        if (extrema[1] < extrema[0] && nExtrema > 1) {
          swapExtrema();
        }

        y0_ = curve.cubicAt(y0, y1, y2, y3, extrema[0]);

        if (nExtrema > 1) {
          y1_ = curve.cubicAt(y0, y1, y2, y3, extrema[1]);
        }
      }

      if (nExtrema === 2) {
        // 分成三段单调函数
        if (t < extrema[0]) {
          w += y0_ < y0 ? unit : -unit;
        } else if (t < extrema[1]) {
          w += y1_ < y0_ ? unit : -unit;
        } else {
          w += y3 < y1_ ? unit : -unit;
        }
      } else {
        // 分成两段单调函数
        if (t < extrema[0]) {
          w += y0_ < y0 ? unit : -unit;
        } else {
          w += y3 < y0_ ? unit : -unit;
        }
      }
    }

    return w;
  }
}

function windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
  // Quick reject
  if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) {
    return 0;
  }

  var nRoots = curve.quadraticRootAt(y0, y1, y2, y, roots);

  if (nRoots === 0) {
    return 0;
  } else {
    var t = curve.quadraticExtremum(y0, y1, y2);

    if (t >= 0 && t <= 1) {
      var w = 0;
      var y_ = curve.quadraticAt(y0, y1, y2, t);

      for (var i = 0; i < nRoots; i++) {
        // Remove one endpoint.
        var unit = roots[i] === 0 || roots[i] === 1 ? 0.5 : 1;
        var x_ = curve.quadraticAt(x0, x1, x2, roots[i]);

        if (x_ < x) {
          // Quick reject
          continue;
        }

        if (roots[i] < t) {
          w += y_ < y0 ? unit : -unit;
        } else {
          w += y2 < y_ ? unit : -unit;
        }
      }

      return w;
    } else {
      // Remove one endpoint.
      var unit = roots[0] === 0 || roots[0] === 1 ? 0.5 : 1;
      var x_ = curve.quadraticAt(x0, x1, x2, roots[0]);

      if (x_ < x) {
        // Quick reject
        return 0;
      }

      return y2 < y0 ? unit : -unit;
    }
  }
} // TODO
// Arc 旋转


function windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
  y -= cy;

  if (y > r || y < -r) {
    return 0;
  }

  var tmp = Math.sqrt(r * r - y * y);
  roots[0] = -tmp;
  roots[1] = tmp;
  var diff = Math.abs(startAngle - endAngle);

  if (diff < 1e-4) {
    return 0;
  }

  if (diff % PI2 < 1e-4) {
    // Is a circle
    startAngle = 0;
    endAngle = PI2;
    var dir = anticlockwise ? 1 : -1;

    if (x >= roots[0] + cx && x <= roots[1] + cx) {
      return dir;
    } else {
      return 0;
    }
  }

  if (anticlockwise) {
    var tmp = startAngle;
    startAngle = normalizeRadian(endAngle);
    endAngle = normalizeRadian(tmp);
  } else {
    startAngle = normalizeRadian(startAngle);
    endAngle = normalizeRadian(endAngle);
  }

  if (startAngle > endAngle) {
    endAngle += PI2;
  }

  var w = 0;

  for (var i = 0; i < 2; i++) {
    var x_ = roots[i];

    if (x_ + cx > x) {
      var angle = Math.atan2(y, x_);
      var dir = anticlockwise ? 1 : -1;

      if (angle < 0) {
        angle = PI2 + angle;
      }

      if (angle >= startAngle && angle <= endAngle || angle + PI2 >= startAngle && angle + PI2 <= endAngle) {
        if (angle > Math.PI / 2 && angle < Math.PI * 1.5) {
          dir = -dir;
        }

        w += dir;
      }
    }
  }

  return w;
}

function containPath(data, lineWidth, isStroke, x, y) {
  var w = 0;
  var xi = 0;
  var yi = 0;
  var x0 = 0;
  var y0 = 0;

  for (var i = 0; i < data.length;) {
    var cmd = data[i++]; // Begin a new subpath

    if (cmd === CMD.M && i > 1) {
      // Close previous subpath
      if (!isStroke) {
        w += windingLine(xi, yi, x0, y0, x, y);
      } // 如果被任何一个 subpath 包含
      // if (w !== 0) {
      //     return true;
      // }

    }

    if (i === 1) {
      // 如果第一个命令是 L, C, Q
      // 则 previous point 同绘制命令的第一个 point
      //
      // 第一个命令为 Arc 的情况下会在后面特殊处理
      xi = data[i];
      yi = data[i + 1];
      x0 = xi;
      y0 = yi;
    }

    switch (cmd) {
      case CMD.M:
        // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
        // 在 closePath 的时候使用
        x0 = data[i++];
        y0 = data[i++];
        xi = x0;
        yi = y0;
        break;

      case CMD.L:
        if (isStroke) {
          if (line.containStroke(xi, yi, data[i], data[i + 1], lineWidth, x, y)) {
            return true;
          }
        } else {
          // NOTE 在第一个命令为 L, C, Q 的时候会计算出 NaN
          w += windingLine(xi, yi, data[i], data[i + 1], x, y) || 0;
        }

        xi = data[i++];
        yi = data[i++];
        break;

      case CMD.C:
        if (isStroke) {
          if (cubic.containStroke(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
            return true;
          }
        } else {
          w += windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
        }

        xi = data[i++];
        yi = data[i++];
        break;

      case CMD.Q:
        if (isStroke) {
          if (quadratic.containStroke(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
            return true;
          }
        } else {
          w += windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
        }

        xi = data[i++];
        yi = data[i++];
        break;

      case CMD.A:
        // TODO Arc 判断的开销比较大
        var cx = data[i++];
        var cy = data[i++];
        var rx = data[i++];
        var ry = data[i++];
        var theta = data[i++];
        var dTheta = data[i++]; // TODO Arc 旋转

        i += 1;
        var anticlockwise = 1 - data[i++];
        var x1 = Math.cos(theta) * rx + cx;
        var y1 = Math.sin(theta) * ry + cy; // 不是直接使用 arc 命令

        if (i > 1) {
          w += windingLine(xi, yi, x1, y1, x, y);
        } else {
          // 第一个命令起点还未定义
          x0 = x1;
          y0 = y1;
        } // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放


        var _x = (x - cx) * ry / rx + cx;

        if (isStroke) {
          if (arc.containStroke(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) {
            return true;
          }
        } else {
          w += windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
        }

        xi = Math.cos(theta + dTheta) * rx + cx;
        yi = Math.sin(theta + dTheta) * ry + cy;
        break;

      case CMD.R:
        x0 = xi = data[i++];
        y0 = yi = data[i++];
        var width = data[i++];
        var height = data[i++];
        var x1 = x0 + width;
        var y1 = y0 + height;

        if (isStroke) {
          if (line.containStroke(x0, y0, x1, y0, lineWidth, x, y) || line.containStroke(x1, y0, x1, y1, lineWidth, x, y) || line.containStroke(x1, y1, x0, y1, lineWidth, x, y) || line.containStroke(x0, y1, x0, y0, lineWidth, x, y)) {
            return true;
          }
        } else {
          // FIXME Clockwise ?
          w += windingLine(x1, y0, x1, y1, x, y);
          w += windingLine(x0, y1, x0, y0, x, y);
        }

        break;

      case CMD.Z:
        if (isStroke) {
          if (line.containStroke(xi, yi, x0, y0, lineWidth, x, y)) {
            return true;
          }
        } else {
          // Close a subpath
          w += windingLine(xi, yi, x0, y0, x, y); // 如果被任何一个 subpath 包含
          // FIXME subpaths may overlap
          // if (w !== 0) {
          //     return true;
          // }
        }

        xi = x0;
        yi = y0;
        break;
    }
  }

  if (!isStroke && !isAroundEqual(yi, y0)) {
    w += windingLine(xi, yi, x0, y0, x, y) || 0;
  }

  return w !== 0;
}

function contain(pathData, x, y) {
  return containPath(pathData, 0, false, x, y);
}

function containStroke(pathData, lineWidth, x, y) {
  return containPath(pathData, lineWidth, true, x, y);
}

exports.contain = contain;
exports.containStroke = containStroke;

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

var curve = __webpack_require__(147);

/**
 * 三次贝塞尔曲线描边包含判断
 * @param  {number}  x0
 * @param  {number}  y0
 * @param  {number}  x1
 * @param  {number}  y1
 * @param  {number}  x2
 * @param  {number}  y2
 * @param  {number}  x3
 * @param  {number}  y3
 * @param  {number}  lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {boolean}
 */
function containStroke(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
  if (lineWidth === 0) {
    return false;
  }

  var _l = lineWidth; // Quick reject

  if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) {
    return false;
  }

  var d = curve.cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
  return d <= _l / 2;
}

exports.containStroke = containStroke;

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

var _util = __webpack_require__(627);

var normalizeRadian = _util.normalizeRadian;
var PI2 = Math.PI * 2;
/**
 * 圆弧描边包含判断
 * @param  {number}  cx
 * @param  {number}  cy
 * @param  {number}  r
 * @param  {number}  startAngle
 * @param  {number}  endAngle
 * @param  {boolean}  anticlockwise
 * @param  {number} lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {Boolean}
 */

function containStroke(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
  if (lineWidth === 0) {
    return false;
  }

  var _l = lineWidth;
  x -= cx;
  y -= cy;
  var d = Math.sqrt(x * x + y * y);

  if (d - _l > r || d + _l < r) {
    return false;
  }

  if (Math.abs(startAngle - endAngle) % PI2 < 1e-4) {
    // Is a circle
    return true;
  }

  if (anticlockwise) {
    var tmp = startAngle;
    startAngle = normalizeRadian(endAngle);
    endAngle = normalizeRadian(tmp);
  } else {
    startAngle = normalizeRadian(startAngle);
    endAngle = normalizeRadian(endAngle);
  }

  if (startAngle > endAngle) {
    endAngle += PI2;
  }

  var angle = Math.atan2(y, x);

  if (angle < 0) {
    angle += PI2;
  }

  return angle >= startAngle && angle <= endAngle || angle + PI2 >= startAngle && angle + PI2 <= endAngle;
}

exports.containStroke = containStroke;

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

var PathProxy = __webpack_require__(205);

var _vector = __webpack_require__(55);

var v2ApplyTransform = _vector.applyTransform;
var CMD = PathProxy.CMD;
var points = [[], [], []];
var mathSqrt = Math.sqrt;
var mathAtan2 = Math.atan2;

function _default(path, m) {
  var data = path.data;
  var cmd;
  var nPoint;
  var i;
  var j;
  var k;
  var p;
  var M = CMD.M;
  var C = CMD.C;
  var L = CMD.L;
  var R = CMD.R;
  var A = CMD.A;
  var Q = CMD.Q;

  for (i = 0, j = 0; i < data.length;) {
    cmd = data[i++];
    j = i;
    nPoint = 0;

    switch (cmd) {
      case M:
        nPoint = 1;
        break;

      case L:
        nPoint = 1;
        break;

      case C:
        nPoint = 3;
        break;

      case Q:
        nPoint = 2;
        break;

      case A:
        var x = m[4];
        var y = m[5];
        var sx = mathSqrt(m[0] * m[0] + m[1] * m[1]);
        var sy = mathSqrt(m[2] * m[2] + m[3] * m[3]);
        var angle = mathAtan2(-m[1] / sy, m[0] / sx); // cx

        data[i] *= sx;
        data[i++] += x; // cy

        data[i] *= sy;
        data[i++] += y; // Scale rx and ry
        // FIXME Assume psi is 0 here

        data[i++] *= sx;
        data[i++] *= sy; // Start angle

        data[i++] += angle; // end angle

        data[i++] += angle; // FIXME psi

        i += 2;
        j = i;
        break;

      case R:
        // x0, y0
        p[0] = data[i++];
        p[1] = data[i++];
        v2ApplyTransform(p, p, m);
        data[j++] = p[0];
        data[j++] = p[1]; // x1, y1

        p[0] += data[i++];
        p[1] += data[i++];
        v2ApplyTransform(p, p, m);
        data[j++] = p[0];
        data[j++] = p[1];
    }

    for (k = 0; k < nPoint; k++) {
      var p = points[k];
      p[0] = data[i++];
      p[1] = data[i++];
      v2ApplyTransform(p, p, m); // Write back

      data[j++] = p[0];
      data[j++] = p[1];
    }
  }
}

module.exports = _default;

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(65);

var fixClipWithShadow = __webpack_require__(630);

/**
 * 扇形
 * @module zrender/graphic/shape/Sector
 */
var _default = Path.extend({
  type: 'sector',
  shape: {
    cx: 0,
    cy: 0,
    r0: 0,
    r: 0,
    startAngle: 0,
    endAngle: Math.PI * 2,
    clockwise: true
  },
  brush: fixClipWithShadow(Path.prototype.brush),
  buildPath: function (ctx, shape) {
    var x = shape.cx;
    var y = shape.cy;
    var r0 = Math.max(shape.r0 || 0, 0);
    var r = Math.max(shape.r, 0);
    var startAngle = shape.startAngle;
    var endAngle = shape.endAngle;
    var clockwise = shape.clockwise;
    var unitX = Math.cos(startAngle);
    var unitY = Math.sin(startAngle);
    ctx.moveTo(unitX * r0 + x, unitY * r0 + y);
    ctx.lineTo(unitX * r + x, unitY * r + y);
    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    ctx.lineTo(Math.cos(endAngle) * r0 + x, Math.sin(endAngle) * r0 + y);

    if (r0 !== 0) {
      ctx.arc(x, y, r0, endAngle, startAngle, clockwise);
    }

    ctx.closePath();
  }
});

module.exports = _default;

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(65);

/**
 * 圆环
 * @module zrender/graphic/shape/Ring
 */
var _default = Path.extend({
  type: 'ring',
  shape: {
    cx: 0,
    cy: 0,
    r: 0,
    r0: 0
  },
  buildPath: function (ctx, shape) {
    var x = shape.cx;
    var y = shape.cy;
    var PI2 = Math.PI * 2;
    ctx.moveTo(x + shape.r, y);
    ctx.arc(x, y, shape.r, 0, PI2, false);
    ctx.moveTo(x + shape.r0, y);
    ctx.arc(x, y, shape.r0, 0, PI2, true);
  }
});

module.exports = _default;

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

var _vector = __webpack_require__(55);

var v2Distance = _vector.distance;

/**
 * Catmull-Rom spline 插值折线
 * @module zrender/shape/util/smoothSpline
 * @author pissang (https://www.github.com/pissang)
 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         errorrik (errorrik@gmail.com)
 */

/**
 * @inner
 */
function interpolate(p0, p1, p2, p3, t, t2, t3) {
  var v0 = (p2 - p0) * 0.5;
  var v1 = (p3 - p1) * 0.5;
  return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
}
/**
 * @alias module:zrender/shape/util/smoothSpline
 * @param {Array} points 线段顶点数组
 * @param {boolean} isLoop
 * @return {Array}
 */


function _default(points, isLoop) {
  var len = points.length;
  var ret = [];
  var distance = 0;

  for (var i = 1; i < len; i++) {
    distance += v2Distance(points[i - 1], points[i]);
  }

  var segs = distance / 2;
  segs = segs < len ? len : segs;

  for (var i = 0; i < segs; i++) {
    var pos = i / (segs - 1) * (isLoop ? len : len - 1);
    var idx = Math.floor(pos);
    var w = pos - idx;
    var p0;
    var p1 = points[idx % len];
    var p2;
    var p3;

    if (!isLoop) {
      p0 = points[idx === 0 ? idx : idx - 1];
      p2 = points[idx > len - 2 ? len - 1 : idx + 1];
      p3 = points[idx > len - 3 ? len - 1 : idx + 2];
    } else {
      p0 = points[(idx - 1 + len) % len];
      p2 = points[(idx + 1) % len];
      p3 = points[(idx + 2) % len];
    }

    var w2 = w * w;
    var w3 = w * w2;
    ret.push([interpolate(p0[0], p1[0], p2[0], p3[0], w, w2, w3), interpolate(p0[1], p1[1], p2[1], p3[1], w, w2, w3)]);
  }

  return ret;
}

module.exports = _default;

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

var _vector = __webpack_require__(55);

var v2Min = _vector.min;
var v2Max = _vector.max;
var v2Scale = _vector.scale;
var v2Distance = _vector.distance;
var v2Add = _vector.add;
var v2Clone = _vector.clone;
var v2Sub = _vector.sub;

/**
 * 贝塞尔平滑曲线
 * @module zrender/shape/util/smoothBezier
 * @author pissang (https://www.github.com/pissang)
 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         errorrik (errorrik@gmail.com)
 */

/**
 * 贝塞尔平滑曲线
 * @alias module:zrender/shape/util/smoothBezier
 * @param {Array} points 线段顶点数组
 * @param {number} smooth 平滑等级, 0-1
 * @param {boolean} isLoop
 * @param {Array} constraint 将计算出来的控制点约束在一个包围盒内
 *                           比如 [[0, 0], [100, 100]], 这个包围盒会与
 *                           整个折线的包围盒做一个并集用来约束控制点。
 * @param {Array} 计算出来的控制点数组
 */
function _default(points, smooth, isLoop, constraint) {
  var cps = [];
  var v = [];
  var v1 = [];
  var v2 = [];
  var prevPoint;
  var nextPoint;
  var min;
  var max;

  if (constraint) {
    min = [Infinity, Infinity];
    max = [-Infinity, -Infinity];

    for (var i = 0, len = points.length; i < len; i++) {
      v2Min(min, min, points[i]);
      v2Max(max, max, points[i]);
    } // 与指定的包围盒做并集


    v2Min(min, min, constraint[0]);
    v2Max(max, max, constraint[1]);
  }

  for (var i = 0, len = points.length; i < len; i++) {
    var point = points[i];

    if (isLoop) {
      prevPoint = points[i ? i - 1 : len - 1];
      nextPoint = points[(i + 1) % len];
    } else {
      if (i === 0 || i === len - 1) {
        cps.push(v2Clone(points[i]));
        continue;
      } else {
        prevPoint = points[i - 1];
        nextPoint = points[i + 1];
      }
    }

    v2Sub(v, nextPoint, prevPoint); // use degree to scale the handle length

    v2Scale(v, v, smooth);
    var d0 = v2Distance(point, prevPoint);
    var d1 = v2Distance(point, nextPoint);
    var sum = d0 + d1;

    if (sum !== 0) {
      d0 /= sum;
      d1 /= sum;
    }

    v2Scale(v1, v, -d0);
    v2Scale(v2, v, d1);
    var cp0 = v2Add([], point, v1);
    var cp1 = v2Add([], point, v2);

    if (constraint) {
      v2Max(cp0, cp0, min);
      v2Min(cp0, cp0, max);
      v2Max(cp1, cp1, min);
      v2Min(cp1, cp1, max);
    }

    cps.push(cp0);
    cps.push(cp1);
  }

  if (isLoop) {
    cps.push(cps.shift());
  }

  return cps;
}

module.exports = _default;

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(65);

var vec2 = __webpack_require__(55);

var _curve = __webpack_require__(147);

var quadraticSubdivide = _curve.quadraticSubdivide;
var cubicSubdivide = _curve.cubicSubdivide;
var quadraticAt = _curve.quadraticAt;
var cubicAt = _curve.cubicAt;
var quadraticDerivativeAt = _curve.quadraticDerivativeAt;
var cubicDerivativeAt = _curve.cubicDerivativeAt;

/**
 * 贝塞尔曲线
 * @module zrender/shape/BezierCurve
 */
var out = [];

function someVectorAt(shape, t, isTangent) {
  var cpx2 = shape.cpx2;
  var cpy2 = shape.cpy2;

  if (cpx2 === null || cpy2 === null) {
    return [(isTangent ? cubicDerivativeAt : cubicAt)(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t), (isTangent ? cubicDerivativeAt : cubicAt)(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)];
  } else {
    return [(isTangent ? quadraticDerivativeAt : quadraticAt)(shape.x1, shape.cpx1, shape.x2, t), (isTangent ? quadraticDerivativeAt : quadraticAt)(shape.y1, shape.cpy1, shape.y2, t)];
  }
}

var _default = Path.extend({
  type: 'bezier-curve',
  shape: {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0,
    cpx1: 0,
    cpy1: 0,
    // cpx2: 0,
    // cpy2: 0
    // Curve show percent, for animating
    percent: 1
  },
  style: {
    stroke: '#000',
    fill: null
  },
  buildPath: function (ctx, shape) {
    var x1 = shape.x1;
    var y1 = shape.y1;
    var x2 = shape.x2;
    var y2 = shape.y2;
    var cpx1 = shape.cpx1;
    var cpy1 = shape.cpy1;
    var cpx2 = shape.cpx2;
    var cpy2 = shape.cpy2;
    var percent = shape.percent;

    if (percent === 0) {
      return;
    }

    ctx.moveTo(x1, y1);

    if (cpx2 == null || cpy2 == null) {
      if (percent < 1) {
        quadraticSubdivide(x1, cpx1, x2, percent, out);
        cpx1 = out[1];
        x2 = out[2];
        quadraticSubdivide(y1, cpy1, y2, percent, out);
        cpy1 = out[1];
        y2 = out[2];
      }

      ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
    } else {
      if (percent < 1) {
        cubicSubdivide(x1, cpx1, cpx2, x2, percent, out);
        cpx1 = out[1];
        cpx2 = out[2];
        x2 = out[3];
        cubicSubdivide(y1, cpy1, cpy2, y2, percent, out);
        cpy1 = out[1];
        cpy2 = out[2];
        y2 = out[3];
      }

      ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
    }
  },

  /**
   * Get point at percent
   * @param  {number} t
   * @return {Array.<number>}
   */
  pointAt: function (t) {
    return someVectorAt(this.shape, t, false);
  },

  /**
   * Get tangent at percent
   * @param  {number} t
   * @return {Array.<number>}
   */
  tangentAt: function (t) {
    var p = someVectorAt(this.shape, t, true);
    return vec2.normalize(p, p);
  }
});

module.exports = _default;

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(65);

/**
 * 圆弧
 * @module zrender/graphic/shape/Arc
 */
var _default = Path.extend({
  type: 'arc',
  shape: {
    cx: 0,
    cy: 0,
    r: 0,
    startAngle: 0,
    endAngle: Math.PI * 2,
    clockwise: true
  },
  style: {
    stroke: '#000',
    fill: null
  },
  buildPath: function (ctx, shape) {
    var x = shape.cx;
    var y = shape.cy;
    var r = Math.max(shape.r, 0);
    var startAngle = shape.startAngle;
    var endAngle = shape.endAngle;
    var clockwise = shape.clockwise;
    var unitX = Math.cos(startAngle);
    var unitY = Math.sin(startAngle);
    ctx.moveTo(unitX * r + x, unitY * r + y);
    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
  }
});

module.exports = _default;

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(65);

// CompoundPath to improve performance
var _default = Path.extend({
  type: 'compound',
  shape: {
    paths: null
  },
  _updatePathDirty: function () {
    var dirtyPath = this.__dirtyPath;
    var paths = this.shape.paths;

    for (var i = 0; i < paths.length; i++) {
      // Mark as dirty if any subpath is dirty
      dirtyPath = dirtyPath || paths[i].__dirtyPath;
    }

    this.__dirtyPath = dirtyPath;
    this.__dirty = this.__dirty || dirtyPath;
  },
  beforeBrush: function () {
    this._updatePathDirty();

    var paths = this.shape.paths || [];
    var scale = this.getGlobalScale(); // Update path scale

    for (var i = 0; i < paths.length; i++) {
      if (!paths[i].path) {
        paths[i].createPathProxy();
      }

      paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
    }
  },
  buildPath: function (ctx, shape) {
    var paths = shape.paths || [];

    for (var i = 0; i < paths.length; i++) {
      paths[i].buildPath(ctx, paths[i].shape, true);
    }
  },
  afterBrush: function () {
    var paths = this.shape.paths || [];

    for (var i = 0; i < paths.length; i++) {
      paths[i].__dirtyPath = false;
    }
  },
  getBoundingRect: function () {
    this._updatePathDirty();

    return Path.prototype.getBoundingRect.call(this);
  }
});

module.exports = _default;

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(1);

var Gradient = __webpack_require__(296);

/**
 * x, y, r are all percent from 0 to 1
 * @param {number} [x=0.5]
 * @param {number} [y=0.5]
 * @param {number} [r=0.5]
 * @param {Array.<Object>} [colorStops]
 * @param {boolean} [globalCoord=false]
 */
var RadialGradient = function (x, y, r, colorStops, globalCoord) {
  // Should do nothing more in this constructor. Because gradient can be
  // declard by `color: {type: 'radial', colorStops: ...}`, where
  // this constructor will not be called.
  this.x = x == null ? 0.5 : x;
  this.y = y == null ? 0.5 : y;
  this.r = r == null ? 0.5 : r; // Can be cloned

  this.type = 'radial'; // If use global coord

  this.global = globalCoord || false;
  Gradient.call(this, colorStops);
};

RadialGradient.prototype = {
  constructor: RadialGradient
};
zrUtil.inherits(RadialGradient, Gradient);
var _default = RadialGradient;
module.exports = _default;

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var makeStyleMapper = __webpack_require__(204);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var getItemStyle = makeStyleMapper([['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor'], ['textPosition'], ['textAlign']]);
var _default = {
  getItemStyle: function (excludes, includes) {
    var style = getItemStyle(this, excludes, includes);
    var lineDash = this.getBorderLineDash();
    lineDash && (style.lineDash = lineDash);
    return style;
  },
  getBorderLineDash: function () {
    var lineType = this.get('borderType');
    return lineType === 'solid' || lineType == null ? null : lineType === 'dashed' ? [5, 5] : [1, 1];
  }
};
module.exports = _default;

/***/ }),
/* 1554 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = {
  getBoxLayoutParams: function () {
    return {
      left: this.get('left'),
      top: this.get('top'),
      right: this.get('right'),
      bottom: this.get('bottom'),
      width: this.get('width'),
      height: this.get('height')
    };
  }
};
module.exports = _default;

/***/ }),
/* 1555 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var platform = ''; // Navigator not exists in node

if (typeof navigator !== 'undefined') {
  platform = navigator.platform || '';
}

var _default = {
  // backgroundColor: 'rgba(0,0,0,0)',
  // https://dribbble.com/shots/1065960-Infographic-Pie-chart-visualization
  // color: ['#5793f3', '#d14a61', '#fd9c35', '#675bba', '#fec42c', '#dd4444', '#d4df5a', '#cd4870'],
  // Light colors:
  // color: ['#bcd3bb', '#e88f70', '#edc1a5', '#9dc5c8', '#e1e8c8', '#7b7c68', '#e5b5b5', '#f0b489', '#928ea8', '#bda29a'],
  // color: ['#cc5664', '#9bd6ec', '#ea946e', '#8acaaa', '#f1ec64', '#ee8686', '#a48dc1', '#5da6bc', '#b9dcae'],
  // Dark colors:
  color: ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
  gradientColor: ['#f6efa6', '#d88273', '#bf444c'],
  // If xAxis and yAxis declared, grid is created by default.
  // grid: {},
  textStyle: {
    // color: '#000',
    // decoration: 'none',
    // PENDING
    fontFamily: platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
    // fontFamily: 'Arial, Verdana, sans-serif',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 'normal'
  },
  // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
  // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
  // Default is source-over
  blendMode: null,
  animation: 'auto',
  animationDuration: 1000,
  animationDurationUpdate: 300,
  animationEasing: 'exponentialOut',
  animationEasingUpdate: 'cubicOut',
  animationThreshold: 2000,
  // Configuration for progressive/incremental rendering
  progressiveThreshold: 3000,
  progressive: 400,
  // Threshold of if use single hover layer to optimize.
  // It is recommended that `hoverLayerThreshold` is equivalent to or less than
  // `progressiveThreshold`, otherwise hover will cause restart of progressive,
  // which is unexpected.
  // see example <echarts/test/heatmap-large.html>.
  hoverLayerThreshold: 3000,
  // See: module:echarts/scale/Time
  useUTC: false
};
module.exports = _default;

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var modelUtil = __webpack_require__(44);

var ComponentModel = __webpack_require__(73);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * ECharts option manager
 *
 * @module {echarts/model/OptionManager}
 */
var each = zrUtil.each;
var clone = zrUtil.clone;
var map = zrUtil.map;
var merge = zrUtil.merge;
var QUERY_REG = /^(min|max)?(.+)$/;
/**
 * TERM EXPLANATIONS:
 *
 * [option]:
 *
 *     An object that contains definitions of components. For example:
 *     var option = {
 *         title: {...},
 *         legend: {...},
 *         visualMap: {...},
 *         series: [
 *             {data: [...]},
 *             {data: [...]},
 *             ...
 *         ]
 *     };
 *
 * [rawOption]:
 *
 *     An object input to echarts.setOption. 'rawOption' may be an
 *     'option', or may be an object contains multi-options. For example:
 *     var option = {
 *         baseOption: {
 *             title: {...},
 *             legend: {...},
 *             series: [
 *                 {data: [...]},
 *                 {data: [...]},
 *                 ...
 *             ]
 *         },
 *         timeline: {...},
 *         options: [
 *             {title: {...}, series: {data: [...]}},
 *             {title: {...}, series: {data: [...]}},
 *             ...
 *         ],
 *         media: [
 *             {
 *                 query: {maxWidth: 320},
 *                 option: {series: {x: 20}, visualMap: {show: false}}
 *             },
 *             {
 *                 query: {minWidth: 320, maxWidth: 720},
 *                 option: {series: {x: 500}, visualMap: {show: true}}
 *             },
 *             {
 *                 option: {series: {x: 1200}, visualMap: {show: true}}
 *             }
 *         ]
 *     };
 *
 * @alias module:echarts/model/OptionManager
 * @param {module:echarts/ExtensionAPI} api
 */

function OptionManager(api) {
  /**
   * @private
   * @type {module:echarts/ExtensionAPI}
   */
  this._api = api;
  /**
   * @private
   * @type {Array.<number>}
   */

  this._timelineOptions = [];
  /**
   * @private
   * @type {Array.<Object>}
   */

  this._mediaList = [];
  /**
   * @private
   * @type {Object}
   */

  this._mediaDefault;
  /**
   * -1, means default.
   * empty means no media.
   * @private
   * @type {Array.<number>}
   */

  this._currentMediaIndices = [];
  /**
   * @private
   * @type {Object}
   */

  this._optionBackup;
  /**
   * @private
   * @type {Object}
   */

  this._newBaseOption;
} // timeline.notMerge is not supported in ec3. Firstly there is rearly
// case that notMerge is needed. Secondly supporting 'notMerge' requires
// rawOption cloned and backuped when timeline changed, which does no
// good to performance. What's more, that both timeline and setOption
// method supply 'notMerge' brings complex and some problems.
// Consider this case:
// (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
// (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);


OptionManager.prototype = {
  constructor: OptionManager,

  /**
   * @public
   * @param {Object} rawOption Raw option.
   * @param {module:echarts/model/Global} ecModel
   * @param {Array.<Function>} optionPreprocessorFuncs
   * @return {Object} Init option
   */
  setOption: function (rawOption, optionPreprocessorFuncs) {
    if (rawOption) {
      // That set dat primitive is dangerous if user reuse the data when setOption again.
      zrUtil.each(modelUtil.normalizeToArray(rawOption.series), function (series) {
        series && series.data && zrUtil.isTypedArray(series.data) && zrUtil.setAsPrimitive(series.data);
      });
    } // Caution: some series modify option data, if do not clone,
    // it should ensure that the repeat modify correctly
    // (create a new object when modify itself).


    rawOption = clone(rawOption); // FIXME
    // 如果 timeline options 或者 media 中设置了某个属性，而baseOption中没有设置，则进行警告。

    var oldOptionBackup = this._optionBackup;
    var newParsedOption = parseRawOption.call(this, rawOption, optionPreprocessorFuncs, !oldOptionBackup);
    this._newBaseOption = newParsedOption.baseOption; // For setOption at second time (using merge mode);

    if (oldOptionBackup) {
      // Only baseOption can be merged.
      mergeOption(oldOptionBackup.baseOption, newParsedOption.baseOption); // For simplicity, timeline options and media options do not support merge,
      // that is, if you `setOption` twice and both has timeline options, the latter
      // timeline opitons will not be merged to the formers, but just substitude them.

      if (newParsedOption.timelineOptions.length) {
        oldOptionBackup.timelineOptions = newParsedOption.timelineOptions;
      }

      if (newParsedOption.mediaList.length) {
        oldOptionBackup.mediaList = newParsedOption.mediaList;
      }

      if (newParsedOption.mediaDefault) {
        oldOptionBackup.mediaDefault = newParsedOption.mediaDefault;
      }
    } else {
      this._optionBackup = newParsedOption;
    }
  },

  /**
   * @param {boolean} isRecreate
   * @return {Object}
   */
  mountOption: function (isRecreate) {
    var optionBackup = this._optionBackup; // TODO
    // 如果没有reset功能则不clone。

    this._timelineOptions = map(optionBackup.timelineOptions, clone);
    this._mediaList = map(optionBackup.mediaList, clone);
    this._mediaDefault = clone(optionBackup.mediaDefault);
    this._currentMediaIndices = [];
    return clone(isRecreate // this._optionBackup.baseOption, which is created at the first `setOption`
    // called, and is merged into every new option by inner method `mergeOption`
    // each time `setOption` called, can be only used in `isRecreate`, because
    // its reliability is under suspicion. In other cases option merge is
    // performed by `model.mergeOption`.
    ? optionBackup.baseOption : this._newBaseOption);
  },

  /**
   * @param {module:echarts/model/Global} ecModel
   * @return {Object}
   */
  getTimelineOption: function (ecModel) {
    var option;
    var timelineOptions = this._timelineOptions;

    if (timelineOptions.length) {
      // getTimelineOption can only be called after ecModel inited,
      // so we can get currentIndex from timelineModel.
      var timelineModel = ecModel.getComponent('timeline');

      if (timelineModel) {
        option = clone(timelineOptions[timelineModel.getCurrentIndex()], true);
      }
    }

    return option;
  },

  /**
   * @param {module:echarts/model/Global} ecModel
   * @return {Array.<Object>}
   */
  getMediaOption: function (ecModel) {
    var ecWidth = this._api.getWidth();

    var ecHeight = this._api.getHeight();

    var mediaList = this._mediaList;
    var mediaDefault = this._mediaDefault;
    var indices = [];
    var result = []; // No media defined.

    if (!mediaList.length && !mediaDefault) {
      return result;
    } // Multi media may be applied, the latter defined media has higher priority.


    for (var i = 0, len = mediaList.length; i < len; i++) {
      if (applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) {
        indices.push(i);
      }
    } // FIXME
    // 是否mediaDefault应该强制用户设置，否则可能修改不能回归。


    if (!indices.length && mediaDefault) {
      indices = [-1];
    }

    if (indices.length && !indicesEquals(indices, this._currentMediaIndices)) {
      result = map(indices, function (index) {
        return clone(index === -1 ? mediaDefault.option : mediaList[index].option);
      });
    } // Otherwise return nothing.


    this._currentMediaIndices = indices;
    return result;
  }
};

function parseRawOption(rawOption, optionPreprocessorFuncs, isNew) {
  var timelineOptions = [];
  var mediaList = [];
  var mediaDefault;
  var baseOption; // Compatible with ec2.

  var timelineOpt = rawOption.timeline;

  if (rawOption.baseOption) {
    baseOption = rawOption.baseOption;
  } // For timeline


  if (timelineOpt || rawOption.options) {
    baseOption = baseOption || {};
    timelineOptions = (rawOption.options || []).slice();
  } // For media query


  if (rawOption.media) {
    baseOption = baseOption || {};
    var media = rawOption.media;
    each(media, function (singleMedia) {
      if (singleMedia && singleMedia.option) {
        if (singleMedia.query) {
          mediaList.push(singleMedia);
        } else if (!mediaDefault) {
          // Use the first media default.
          mediaDefault = singleMedia;
        }
      }
    });
  } // For normal option


  if (!baseOption) {
    baseOption = rawOption;
  } // Set timelineOpt to baseOption in ec3,
  // which is convenient for merge option.


  if (!baseOption.timeline) {
    baseOption.timeline = timelineOpt;
  } // Preprocess.


  each([baseOption].concat(timelineOptions).concat(zrUtil.map(mediaList, function (media) {
    return media.option;
  })), function (option) {
    each(optionPreprocessorFuncs, function (preProcess) {
      preProcess(option, isNew);
    });
  });
  return {
    baseOption: baseOption,
    timelineOptions: timelineOptions,
    mediaDefault: mediaDefault,
    mediaList: mediaList
  };
}
/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */


function applyMediaQuery(query, ecWidth, ecHeight) {
  var realMap = {
    width: ecWidth,
    height: ecHeight,
    aspectratio: ecWidth / ecHeight // lowser case for convenientce.

  };
  var applicatable = true;
  zrUtil.each(query, function (value, attr) {
    var matched = attr.match(QUERY_REG);

    if (!matched || !matched[1] || !matched[2]) {
      return;
    }

    var operator = matched[1];
    var realAttr = matched[2].toLowerCase();

    if (!compare(realMap[realAttr], value, operator)) {
      applicatable = false;
    }
  });
  return applicatable;
}

function compare(real, expect, operator) {
  if (operator === 'min') {
    return real >= expect;
  } else if (operator === 'max') {
    return real <= expect;
  } else {
    // Equals
    return real === expect;
  }
}

function indicesEquals(indices1, indices2) {
  // indices is always order by asc and has only finite number.
  return indices1.join(',') === indices2.join(',');
}
/**
 * Consider case:
 * `chart.setOption(opt1);`
 * Then user do some interaction like dataZoom, dataView changing.
 * `chart.setOption(opt2);`
 * Then user press 'reset button' in toolbox.
 *
 * After doing that all of the interaction effects should be reset, the
 * chart should be the same as the result of invoke
 * `chart.setOption(opt1); chart.setOption(opt2);`.
 *
 * Although it is not able ensure that
 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
 * `chart.setOption(merge(opt1, opt2));` exactly,
 * this might be the only simple way to implement that feature.
 *
 * MEMO: We've considered some other approaches:
 * 1. Each model handle its self restoration but not uniform treatment.
 *     (Too complex in logic and error-prone)
 * 2. Use a shadow ecModel. (Performace expensive)
 */


function mergeOption(oldOption, newOption) {
  newOption = newOption || {};
  each(newOption, function (newCptOpt, mainType) {
    if (newCptOpt == null) {
      return;
    }

    var oldCptOpt = oldOption[mainType];

    if (!ComponentModel.hasClass(mainType)) {
      oldOption[mainType] = merge(oldCptOpt, newCptOpt, true);
    } else {
      newCptOpt = modelUtil.normalizeToArray(newCptOpt);
      oldCptOpt = modelUtil.normalizeToArray(oldCptOpt);
      var mapResult = modelUtil.mappingToExists(oldCptOpt, newCptOpt);
      oldOption[mainType] = map(mapResult, function (item) {
        return item.option && item.exist ? merge(item.exist, item.option, true) : item.exist || item.option;
      });
    }
  });
}

var _default = OptionManager;
module.exports = _default;

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(1);

var each = _util.each;
var isArray = _util.isArray;
var isObject = _util.isObject;

var compatStyle = __webpack_require__(1558);

var _model = __webpack_require__(44);

var normalizeToArray = _model.normalizeToArray;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Compatitable with 2.0
function get(opt, path) {
  path = path.split(',');
  var obj = opt;

  for (var i = 0; i < path.length; i++) {
    obj = obj && obj[path[i]];

    if (obj == null) {
      break;
    }
  }

  return obj;
}

function set(opt, path, val, overwrite) {
  path = path.split(',');
  var obj = opt;
  var key;

  for (var i = 0; i < path.length - 1; i++) {
    key = path[i];

    if (obj[key] == null) {
      obj[key] = {};
    }

    obj = obj[key];
  }

  if (overwrite || obj[path[i]] == null) {
    obj[path[i]] = val;
  }
}

function compatLayoutProperties(option) {
  each(LAYOUT_PROPERTIES, function (prop) {
    if (prop[0] in option && !(prop[1] in option)) {
      option[prop[1]] = option[prop[0]];
    }
  });
}

var LAYOUT_PROPERTIES = [['x', 'left'], ['y', 'top'], ['x2', 'right'], ['y2', 'bottom']];
var COMPATITABLE_COMPONENTS = ['grid', 'geo', 'parallel', 'legend', 'toolbox', 'title', 'visualMap', 'dataZoom', 'timeline'];

function _default(option, isTheme) {
  compatStyle(option, isTheme); // Make sure series array for model initialization.

  option.series = normalizeToArray(option.series);
  each(option.series, function (seriesOpt) {
    if (!isObject(seriesOpt)) {
      return;
    }

    var seriesType = seriesOpt.type;

    if (seriesType === 'line') {
      if (seriesOpt.clipOverflow != null) {
        seriesOpt.clip = seriesOpt.clipOverflow;
      }
    } else if (seriesType === 'pie' || seriesType === 'gauge') {
      if (seriesOpt.clockWise != null) {
        seriesOpt.clockwise = seriesOpt.clockWise;
      }
    } else if (seriesType === 'gauge') {
      var pointerColor = get(seriesOpt, 'pointer.color');
      pointerColor != null && set(seriesOpt, 'itemStyle.color', pointerColor);
    }

    compatLayoutProperties(seriesOpt);
  }); // dataRange has changed to visualMap

  if (option.dataRange) {
    option.visualMap = option.dataRange;
  }

  each(COMPATITABLE_COMPONENTS, function (componentName) {
    var options = option[componentName];

    if (options) {
      if (!isArray(options)) {
        options = [options];
      }

      each(options, function (option) {
        compatLayoutProperties(option);
      });
    }
  });
}

module.exports = _default;

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var modelUtil = __webpack_require__(44);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var each = zrUtil.each;
var isObject = zrUtil.isObject;
var POSSIBLE_STYLES = ['areaStyle', 'lineStyle', 'nodeStyle', 'linkStyle', 'chordStyle', 'label', 'labelLine'];

function compatEC2ItemStyle(opt) {
  var itemStyleOpt = opt && opt.itemStyle;

  if (!itemStyleOpt) {
    return;
  }

  for (var i = 0, len = POSSIBLE_STYLES.length; i < len; i++) {
    var styleName = POSSIBLE_STYLES[i];
    var normalItemStyleOpt = itemStyleOpt.normal;
    var emphasisItemStyleOpt = itemStyleOpt.emphasis;

    if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
      opt[styleName] = opt[styleName] || {};

      if (!opt[styleName].normal) {
        opt[styleName].normal = normalItemStyleOpt[styleName];
      } else {
        zrUtil.merge(opt[styleName].normal, normalItemStyleOpt[styleName]);
      }

      normalItemStyleOpt[styleName] = null;
    }

    if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
      opt[styleName] = opt[styleName] || {};

      if (!opt[styleName].emphasis) {
        opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
      } else {
        zrUtil.merge(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
      }

      emphasisItemStyleOpt[styleName] = null;
    }
  }
}

function convertNormalEmphasis(opt, optType, useExtend) {
  if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
    var normalOpt = opt[optType].normal;
    var emphasisOpt = opt[optType].emphasis;

    if (normalOpt) {
      // Timeline controlStyle has other properties besides normal and emphasis
      if (useExtend) {
        opt[optType].normal = opt[optType].emphasis = null;
        zrUtil.defaults(opt[optType], normalOpt);
      } else {
        opt[optType] = normalOpt;
      }
    }

    if (emphasisOpt) {
      opt.emphasis = opt.emphasis || {};
      opt.emphasis[optType] = emphasisOpt;
    }
  }
}

function removeEC3NormalStatus(opt) {
  convertNormalEmphasis(opt, 'itemStyle');
  convertNormalEmphasis(opt, 'lineStyle');
  convertNormalEmphasis(opt, 'areaStyle');
  convertNormalEmphasis(opt, 'label');
  convertNormalEmphasis(opt, 'labelLine'); // treemap

  convertNormalEmphasis(opt, 'upperLabel'); // graph

  convertNormalEmphasis(opt, 'edgeLabel');
}

function compatTextStyle(opt, propName) {
  // Check whether is not object (string\null\undefined ...)
  var labelOptSingle = isObject(opt) && opt[propName];
  var textStyle = isObject(labelOptSingle) && labelOptSingle.textStyle;

  if (textStyle) {
    for (var i = 0, len = modelUtil.TEXT_STYLE_OPTIONS.length; i < len; i++) {
      var propName = modelUtil.TEXT_STYLE_OPTIONS[i];

      if (textStyle.hasOwnProperty(propName)) {
        labelOptSingle[propName] = textStyle[propName];
      }
    }
  }
}

function compatEC3CommonStyles(opt) {
  if (opt) {
    removeEC3NormalStatus(opt);
    compatTextStyle(opt, 'label');
    opt.emphasis && compatTextStyle(opt.emphasis, 'label');
  }
}

function processSeries(seriesOpt) {
  if (!isObject(seriesOpt)) {
    return;
  }

  compatEC2ItemStyle(seriesOpt);
  removeEC3NormalStatus(seriesOpt);
  compatTextStyle(seriesOpt, 'label'); // treemap

  compatTextStyle(seriesOpt, 'upperLabel'); // graph

  compatTextStyle(seriesOpt, 'edgeLabel');

  if (seriesOpt.emphasis) {
    compatTextStyle(seriesOpt.emphasis, 'label'); // treemap

    compatTextStyle(seriesOpt.emphasis, 'upperLabel'); // graph

    compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
  }

  var markPoint = seriesOpt.markPoint;

  if (markPoint) {
    compatEC2ItemStyle(markPoint);
    compatEC3CommonStyles(markPoint);
  }

  var markLine = seriesOpt.markLine;

  if (markLine) {
    compatEC2ItemStyle(markLine);
    compatEC3CommonStyles(markLine);
  }

  var markArea = seriesOpt.markArea;

  if (markArea) {
    compatEC3CommonStyles(markArea);
  }

  var data = seriesOpt.data; // Break with ec3: if `setOption` again, there may be no `type` in option,
  // then the backward compat based on option type will not be performed.

  if (seriesOpt.type === 'graph') {
    data = data || seriesOpt.nodes;
    var edgeData = seriesOpt.links || seriesOpt.edges;

    if (edgeData && !zrUtil.isTypedArray(edgeData)) {
      for (var i = 0; i < edgeData.length; i++) {
        compatEC3CommonStyles(edgeData[i]);
      }
    }

    zrUtil.each(seriesOpt.categories, function (opt) {
      removeEC3NormalStatus(opt);
    });
  }

  if (data && !zrUtil.isTypedArray(data)) {
    for (var i = 0; i < data.length; i++) {
      compatEC3CommonStyles(data[i]);
    }
  } // mark point data


  var markPoint = seriesOpt.markPoint;

  if (markPoint && markPoint.data) {
    var mpData = markPoint.data;

    for (var i = 0; i < mpData.length; i++) {
      compatEC3CommonStyles(mpData[i]);
    }
  } // mark line data


  var markLine = seriesOpt.markLine;

  if (markLine && markLine.data) {
    var mlData = markLine.data;

    for (var i = 0; i < mlData.length; i++) {
      if (zrUtil.isArray(mlData[i])) {
        compatEC3CommonStyles(mlData[i][0]);
        compatEC3CommonStyles(mlData[i][1]);
      } else {
        compatEC3CommonStyles(mlData[i]);
      }
    }
  } // Series


  if (seriesOpt.type === 'gauge') {
    compatTextStyle(seriesOpt, 'axisLabel');
    compatTextStyle(seriesOpt, 'title');
    compatTextStyle(seriesOpt, 'detail');
  } else if (seriesOpt.type === 'treemap') {
    convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
    zrUtil.each(seriesOpt.levels, function (opt) {
      removeEC3NormalStatus(opt);
    });
  } else if (seriesOpt.type === 'tree') {
    removeEC3NormalStatus(seriesOpt.leaves);
  } // sunburst starts from ec4, so it does not need to compat levels.

}

function toArr(o) {
  return zrUtil.isArray(o) ? o : o ? [o] : [];
}

function toObj(o) {
  return (zrUtil.isArray(o) ? o[0] : o) || {};
}

function _default(option, isTheme) {
  each(toArr(option.series), function (seriesOpt) {
    isObject(seriesOpt) && processSeries(seriesOpt);
  });
  var axes = ['xAxis', 'yAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'parallelAxis', 'radar'];
  isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
  each(axes, function (axisName) {
    each(toArr(option[axisName]), function (axisOpt) {
      if (axisOpt) {
        compatTextStyle(axisOpt, 'axisLabel');
        compatTextStyle(axisOpt.axisPointer, 'label');
      }
    });
  });
  each(toArr(option.parallel), function (parallelOpt) {
    var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
    compatTextStyle(parallelAxisDefault, 'axisLabel');
    compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
  });
  each(toArr(option.calendar), function (calendarOpt) {
    convertNormalEmphasis(calendarOpt, 'itemStyle');
    compatTextStyle(calendarOpt, 'dayLabel');
    compatTextStyle(calendarOpt, 'monthLabel');
    compatTextStyle(calendarOpt, 'yearLabel');
  }); // radar.name.textStyle

  each(toArr(option.radar), function (radarOpt) {
    compatTextStyle(radarOpt, 'name');
  });
  each(toArr(option.geo), function (geoOpt) {
    if (isObject(geoOpt)) {
      compatEC3CommonStyles(geoOpt);
      each(toArr(geoOpt.regions), function (regionObj) {
        compatEC3CommonStyles(regionObj);
      });
    }
  });
  each(toArr(option.timeline), function (timelineOpt) {
    compatEC3CommonStyles(timelineOpt);
    convertNormalEmphasis(timelineOpt, 'label');
    convertNormalEmphasis(timelineOpt, 'itemStyle');
    convertNormalEmphasis(timelineOpt, 'controlStyle', true);
    var data = timelineOpt.data;
    zrUtil.isArray(data) && zrUtil.each(data, function (item) {
      if (zrUtil.isObject(item)) {
        convertNormalEmphasis(item, 'label');
        convertNormalEmphasis(item, 'itemStyle');
      }
    });
  });
  each(toArr(option.toolbox), function (toolboxOpt) {
    convertNormalEmphasis(toolboxOpt, 'iconStyle');
    each(toolboxOpt.feature, function (featureOpt) {
      convertNormalEmphasis(featureOpt, 'iconStyle');
    });
  });
  compatTextStyle(toObj(option.axisPointer), 'label');
  compatTextStyle(toObj(option.tooltip).axisPointer, 'label');
}

module.exports = _default;

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(1);

var createHashMap = _util.createHashMap;
var each = _util.each;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// (1) [Caution]: the logic is correct based on the premises:
//     data processing stage is blocked in stream.
//     See <module:echarts/stream/Scheduler#performDataProcessorTasks>
// (2) Only register once when import repeatly.
//     Should be executed after series filtered and before stack calculation.
function _default(ecModel) {
  var stackInfoMap = createHashMap();
  ecModel.eachSeries(function (seriesModel) {
    var stack = seriesModel.get('stack'); // Compatibal: when `stack` is set as '', do not stack.

    if (stack) {
      var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
      var data = seriesModel.getData();
      var stackInfo = {
        // Used for calculate axis extent automatically.
        stackResultDimension: data.getCalculationInfo('stackResultDimension'),
        stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
        stackedDimension: data.getCalculationInfo('stackedDimension'),
        stackedByDimension: data.getCalculationInfo('stackedByDimension'),
        isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
        data: data,
        seriesModel: seriesModel
      }; // If stacked on axis that do not support data stack.

      if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) {
        return;
      }

      stackInfoList.length && data.setCalculationInfo('stackedOnSeries', stackInfoList[stackInfoList.length - 1].seriesModel);
      stackInfoList.push(stackInfo);
    }
  });
  stackInfoMap.each(calculateStack);
}

function calculateStack(stackInfoList) {
  each(stackInfoList, function (targetStackInfo, idxInStack) {
    var resultVal = [];
    var resultNaN = [NaN, NaN];
    var dims = [targetStackInfo.stackResultDimension, targetStackInfo.stackedOverDimension];
    var targetData = targetStackInfo.data;
    var isStackedByIndex = targetStackInfo.isStackedByIndex; // Should not write on raw data, because stack series model list changes
    // depending on legend selection.

    var newData = targetData.map(dims, function (v0, v1, dataIndex) {
      var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex); // Consider `connectNulls` of line area, if value is NaN, stackedOver
      // should also be NaN, to draw a appropriate belt area.

      if (isNaN(sum)) {
        return resultNaN;
      }

      var byValue;
      var stackedDataRawIndex;

      if (isStackedByIndex) {
        stackedDataRawIndex = targetData.getRawIndex(dataIndex);
      } else {
        byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
      } // If stackOver is NaN, chart view will render point on value start.


      var stackedOver = NaN;

      for (var j = idxInStack - 1; j >= 0; j--) {
        var stackInfo = stackInfoList[j]; // Has been optimized by inverted indices on `stackedByDimension`.

        if (!isStackedByIndex) {
          stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
        }

        if (stackedDataRawIndex >= 0) {
          var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex); // Considering positive stack, negative stack and empty data

          if (sum >= 0 && val > 0 || // Positive stack
          sum <= 0 && val < 0 // Negative stack
          ) {
              sum += val;
              stackedOver = val;
              break;
            }
        }
      }

      resultVal[0] = sum;
      resultVal[1] = stackedOver;
      return resultVal;
    });
    targetData.hostModel.setData(newData); // Update for consequent calculation

    targetStackInfo.data = newData;
  });
}

module.exports = _default;

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var Gradient = __webpack_require__(296);

var _util = __webpack_require__(1);

var isFunction = _util.isFunction;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = {
  createOnAllSeries: true,
  performRawSeries: true,
  reset: function (seriesModel, ecModel) {
    var data = seriesModel.getData();
    var colorAccessPath = (seriesModel.visualColorAccessPath || 'itemStyle.color').split('.'); // Set in itemStyle

    var color = seriesModel.get(colorAccessPath);
    var colorCallback = isFunction(color) && !(color instanceof Gradient) ? color : null; // Default color

    if (!color || colorCallback) {
      color = seriesModel.getColorFromPalette( // TODO series count changed.
      seriesModel.name, null, ecModel.getSeriesCount());
    }

    data.setVisual('color', color);
    var borderColorAccessPath = (seriesModel.visualBorderColorAccessPath || 'itemStyle.borderColor').split('.');
    var borderColor = seriesModel.get(borderColorAccessPath);
    data.setVisual('borderColor', borderColor); // Only visible series has each data be visual encoded

    if (!ecModel.isSeriesFiltered(seriesModel)) {
      if (colorCallback) {
        data.each(function (idx) {
          data.setItemVisual(idx, 'color', colorCallback(seriesModel.getDataParams(idx)));
        });
      } // itemStyle in each data item


      var dataEach = function (data, idx) {
        var itemModel = data.getItemModel(idx);
        var color = itemModel.get(colorAccessPath, true);
        var borderColor = itemModel.get(borderColorAccessPath, true);

        if (color != null) {
          data.setItemVisual(idx, 'color', color);
        }

        if (borderColor != null) {
          data.setItemVisual(idx, 'borderColor', borderColor);
        }
      };

      return {
        dataEach: data.hasItemOption ? dataEach : null
      };
    }
  }
};
module.exports = _default;

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var lang = __webpack_require__(149);

var _dataProvider = __webpack_require__(176);

var retrieveRawValue = _dataProvider.retrieveRawValue;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(dom, ecModel) {
  var ariaModel = ecModel.getModel('aria');

  if (!ariaModel.get('show')) {
    return;
  } else if (ariaModel.get('description')) {
    dom.setAttribute('aria-label', ariaModel.get('description'));
    return;
  }

  var seriesCnt = 0;
  ecModel.eachSeries(function (seriesModel, idx) {
    ++seriesCnt;
  }, this);
  var maxDataCnt = ariaModel.get('data.maxCount') || 10;
  var maxSeriesCnt = ariaModel.get('series.maxCount') || 10;
  var displaySeriesCnt = Math.min(seriesCnt, maxSeriesCnt);
  var ariaLabel;

  if (seriesCnt < 1) {
    // No series, no aria label
    return;
  } else {
    var title = getTitle();

    if (title) {
      ariaLabel = replace(getConfig('general.withTitle'), {
        title: title
      });
    } else {
      ariaLabel = getConfig('general.withoutTitle');
    }

    var seriesLabels = [];
    var prefix = seriesCnt > 1 ? 'series.multiple.prefix' : 'series.single.prefix';
    ariaLabel += replace(getConfig(prefix), {
      seriesCount: seriesCnt
    });
    ecModel.eachSeries(function (seriesModel, idx) {
      if (idx < displaySeriesCnt) {
        var seriesLabel;
        var seriesName = seriesModel.get('name');
        var seriesTpl = 'series.' + (seriesCnt > 1 ? 'multiple' : 'single') + '.';
        seriesLabel = getConfig(seriesName ? seriesTpl + 'withName' : seriesTpl + 'withoutName');
        seriesLabel = replace(seriesLabel, {
          seriesId: seriesModel.seriesIndex,
          seriesName: seriesModel.get('name'),
          seriesType: getSeriesTypeName(seriesModel.subType)
        });
        var data = seriesModel.getData();
        window.data = data;

        if (data.count() > maxDataCnt) {
          // Show part of data
          seriesLabel += replace(getConfig('data.partialData'), {
            displayCnt: maxDataCnt
          });
        } else {
          seriesLabel += getConfig('data.allData');
        }

        var dataLabels = [];

        for (var i = 0; i < data.count(); i++) {
          if (i < maxDataCnt) {
            var name = data.getName(i);
            var value = retrieveRawValue(data, i);
            dataLabels.push(replace(name ? getConfig('data.withName') : getConfig('data.withoutName'), {
              name: name,
              value: value
            }));
          }
        }

        seriesLabel += dataLabels.join(getConfig('data.separator.middle')) + getConfig('data.separator.end');
        seriesLabels.push(seriesLabel);
      }
    });
    ariaLabel += seriesLabels.join(getConfig('series.multiple.separator.middle')) + getConfig('series.multiple.separator.end');
    dom.setAttribute('aria-label', ariaLabel);
  }

  function replace(str, keyValues) {
    if (typeof str !== 'string') {
      return str;
    }

    var result = str;
    zrUtil.each(keyValues, function (value, key) {
      result = result.replace(new RegExp('\\{\\s*' + key + '\\s*\\}', 'g'), value);
    });
    return result;
  }

  function getConfig(path) {
    var userConfig = ariaModel.get(path);

    if (userConfig == null) {
      var pathArr = path.split('.');
      var result = lang.aria;

      for (var i = 0; i < pathArr.length; ++i) {
        result = result[pathArr[i]];
      }

      return result;
    } else {
      return userConfig;
    }
  }

  function getTitle() {
    var title = ecModel.getModel('title').option;

    if (title && title.length) {
      title = title[0];
    }

    return title && title.text;
  }

  function getSeriesTypeName(type) {
    return lang.series.typeNames[type] || '自定义图';
  }
}

module.exports = _default;

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var graphic = __webpack_require__(27);

var textContain = __webpack_require__(93);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var PI = Math.PI;
/**
 * @param {module:echarts/ExtensionAPI} api
 * @param {Object} [opts]
 * @param {string} [opts.text]
 * @param {string} [opts.color]
 * @param {string} [opts.textColor]
 * @return {module:zrender/Element}
 */

function _default(api, opts) {
  opts = opts || {};
  zrUtil.defaults(opts, {
    text: 'loading',
    textColor: '#000',
    fontSize: '12px',
    maskColor: 'rgba(255, 255, 255, 0.8)',
    showSpinner: true,
    color: '#c23531',
    spinnerRadius: 10,
    lineWidth: 5,
    zlevel: 0
  });
  var group = new graphic.Group();
  var mask = new graphic.Rect({
    style: {
      fill: opts.maskColor
    },
    zlevel: opts.zlevel,
    z: 10000
  });
  group.add(mask);
  var font = opts.fontSize + ' sans-serif';
  var labelRect = new graphic.Rect({
    style: {
      fill: 'none',
      text: opts.text,
      font: font,
      textPosition: 'right',
      textDistance: 10,
      textFill: opts.textColor
    },
    zlevel: opts.zlevel,
    z: 10001
  });
  group.add(labelRect);

  if (opts.showSpinner) {
    var arc = new graphic.Arc({
      shape: {
        startAngle: -PI / 2,
        endAngle: -PI / 2 + 0.1,
        r: opts.spinnerRadius
      },
      style: {
        stroke: opts.color,
        lineCap: 'round',
        lineWidth: opts.lineWidth
      },
      zlevel: opts.zlevel,
      z: 10001
    });
    arc.animateShape(true).when(1000, {
      endAngle: PI * 3 / 2
    }).start('circularInOut');
    arc.animateShape(true).when(1000, {
      startAngle: PI * 3 / 2
    }).delay(300).start('circularInOut');
    group.add(arc);
  } // Inject resize


  group.resize = function () {
    var textWidth = textContain.getWidth(opts.text, font);
    var r = opts.showSpinner ? opts.spinnerRadius : 0; // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
    // textDistance needs to be calculated when both animation and text exist

    var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 // only show the text
    - (opts.showSpinner ? 0 : textWidth / 2);
    var cy = api.getHeight() / 2;
    opts.showSpinner && arc.setShape({
      cx: cx,
      cy: cy
    });
    labelRect.setShape({
      x: cx - r,
      y: cy - r,
      width: r * 2,
      height: r * 2
    });
    mask.setShape({
      x: 0,
      y: 0,
      width: api.getWidth(),
      height: api.getHeight()
    });
  };

  group.resize();
  return group;
}

module.exports = _default;

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(1);

var each = _util.each;
var map = _util.map;
var isFunction = _util.isFunction;
var createHashMap = _util.createHashMap;
var noop = _util.noop;

var _task = __webpack_require__(412);

var createTask = _task.createTask;

var _component = __webpack_require__(235);

var getUID = _component.getUID;

var GlobalModel = __webpack_require__(623);

var ExtensionAPI = __webpack_require__(636);

var _model = __webpack_require__(44);

var normalizeToArray = _model.normalizeToArray;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @module echarts/stream/Scheduler
 */

/**
 * @constructor
 */
function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
  this.ecInstance = ecInstance;
  this.api = api;
  this.unfinished; // Fix current processors in case that in some rear cases that
  // processors might be registered after echarts instance created.
  // Register processors incrementally for a echarts instance is
  // not supported by this stream architecture.

  var dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
  var visualHandlers = this._visualHandlers = visualHandlers.slice();
  this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
  /**
   * @private
   * @type {
   *     [handlerUID: string]: {
   *         seriesTaskMap?: {
   *             [seriesUID: string]: Task
   *         },
   *         overallTask?: Task
   *     }
   * }
   */

  this._stageTaskMap = createHashMap();
}

var proto = Scheduler.prototype;
/**
 * @param {module:echarts/model/Global} ecModel
 * @param {Object} payload
 */

proto.restoreData = function (ecModel, payload) {
  // TODO: Only restore needed series and components, but not all components.
  // Currently `restoreData` of all of the series and component will be called.
  // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
  // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
  // and some components like coordinate system, axes, dataZoom, visualMap only
  // need their target series refresh.
  // (1) If we are implementing this feature some day, we should consider these cases:
  // if a data processor depends on a component (e.g., dataZoomProcessor depends
  // on the settings of `dataZoom`), it should be re-performed if the component
  // is modified by `setOption`.
  // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
  // it should be re-performed when the result array of `getTargetSeries` changed.
  // We use `dependencies` to cover these issues.
  // (3) How to update target series when coordinate system related components modified.
  // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
  // and this case all of the tasks will be set as dirty.
  ecModel.restoreData(payload); // Theoretically an overall task not only depends on each of its target series, but also
  // depends on all of the series.
  // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
  // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
  // that the overall task is set as dirty and to be performed, otherwise it probably cause
  // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
  // probably cause state chaos (consider `dataZoomProcessor`).

  this._stageTaskMap.each(function (taskRecord) {
    var overallTask = taskRecord.overallTask;
    overallTask && overallTask.dirty();
  });
}; // If seriesModel provided, incremental threshold is check by series data.


proto.getPerformArgs = function (task, isBlock) {
  // For overall task
  if (!task.__pipeline) {
    return;
  }

  var pipeline = this._pipelineMap.get(task.__pipeline.id);

  var pCtx = pipeline.context;
  var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
  var step = incremental ? pipeline.step : null;
  var modDataCount = pCtx && pCtx.modDataCount;
  var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
  return {
    step: step,
    modBy: modBy,
    modDataCount: modDataCount
  };
};

proto.getPipeline = function (pipelineId) {
  return this._pipelineMap.get(pipelineId);
};
/**
 * Current, progressive rendering starts from visual and layout.
 * Always detect render mode in the same stage, avoiding that incorrect
 * detection caused by data filtering.
 * Caution:
 * `updateStreamModes` use `seriesModel.getData()`.
 */


proto.updateStreamModes = function (seriesModel, view) {
  var pipeline = this._pipelineMap.get(seriesModel.uid);

  var data = seriesModel.getData();
  var dataLen = data.count(); // `progressiveRender` means that can render progressively in each
  // animation frame. Note that some types of series do not provide
  // `view.incrementalPrepareRender` but support `chart.appendData`. We
  // use the term `incremental` but not `progressive` to describe the
  // case that `chart.appendData`.

  var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
  var large = seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold'); // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
  // see `test/candlestick-large3.html`

  var modDataCount = seriesModel.get('progressiveChunkMode') === 'mod' ? dataLen : null;
  seriesModel.pipelineContext = pipeline.context = {
    progressiveRender: progressiveRender,
    modDataCount: modDataCount,
    large: large
  };
};

proto.restorePipelines = function (ecModel) {
  var scheduler = this;
  var pipelineMap = scheduler._pipelineMap = createHashMap();
  ecModel.eachSeries(function (seriesModel) {
    var progressive = seriesModel.getProgressive();
    var pipelineId = seriesModel.uid;
    pipelineMap.set(pipelineId, {
      id: pipelineId,
      head: null,
      tail: null,
      threshold: seriesModel.getProgressiveThreshold(),
      progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
      blockIndex: -1,
      step: Math.round(progressive || 700),
      count: 0
    });
    pipe(scheduler, seriesModel, seriesModel.dataTask);
  });
};

proto.prepareStageTasks = function () {
  var stageTaskMap = this._stageTaskMap;
  var ecModel = this.ecInstance.getModel();
  var api = this.api;
  each(this._allHandlers, function (handler) {
    var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, []);
    handler.reset && createSeriesStageTask(this, handler, record, ecModel, api);
    handler.overallReset && createOverallStageTask(this, handler, record, ecModel, api);
  }, this);
};

proto.prepareView = function (view, model, ecModel, api) {
  var renderTask = view.renderTask;
  var context = renderTask.context;
  context.model = model;
  context.ecModel = ecModel;
  context.api = api;
  renderTask.__block = !view.incrementalPrepareRender;
  pipe(this, model, renderTask);
};

proto.performDataProcessorTasks = function (ecModel, payload) {
  // If we do not use `block` here, it should be considered when to update modes.
  performStageTasks(this, this._dataProcessorHandlers, ecModel, payload, {
    block: true
  });
}; // opt
// opt.visualType: 'visual' or 'layout'
// opt.setDirty


proto.performVisualTasks = function (ecModel, payload, opt) {
  performStageTasks(this, this._visualHandlers, ecModel, payload, opt);
};

function performStageTasks(scheduler, stageHandlers, ecModel, payload, opt) {
  opt = opt || {};
  var unfinished;
  each(stageHandlers, function (stageHandler, idx) {
    if (opt.visualType && opt.visualType !== stageHandler.visualType) {
      return;
    }

    var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);

    var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
    var overallTask = stageHandlerRecord.overallTask;

    if (overallTask) {
      var overallNeedDirty;
      var agentStubMap = overallTask.agentStubMap;
      agentStubMap.each(function (stub) {
        if (needSetDirty(opt, stub)) {
          stub.dirty();
          overallNeedDirty = true;
        }
      });
      overallNeedDirty && overallTask.dirty();
      updatePayload(overallTask, payload);
      var performArgs = scheduler.getPerformArgs(overallTask, opt.block); // Execute stubs firstly, which may set the overall task dirty,
      // then execute the overall task. And stub will call seriesModel.setData,
      // which ensures that in the overallTask seriesModel.getData() will not
      // return incorrect data.

      agentStubMap.each(function (stub) {
        stub.perform(performArgs);
      });
      unfinished |= overallTask.perform(performArgs);
    } else if (seriesTaskMap) {
      seriesTaskMap.each(function (task, pipelineId) {
        if (needSetDirty(opt, task)) {
          task.dirty();
        }

        var performArgs = scheduler.getPerformArgs(task, opt.block); // FIXME
        // if intending to decalare `performRawSeries` in handlers, only
        // stream-independent (specifically, data item independent) operations can be
        // performed. Because is a series is filtered, most of the tasks will not
        // be performed. A stream-dependent operation probably cause wrong biz logic.
        // Perhaps we should not provide a separate callback for this case instead
        // of providing the config `performRawSeries`. The stream-dependent operaions
        // and stream-independent operations should better not be mixed.

        performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
        updatePayload(task, payload);
        unfinished |= task.perform(performArgs);
      });
    }
  });

  function needSetDirty(opt, task) {
    return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
  }

  scheduler.unfinished |= unfinished;
}

proto.performSeriesTasks = function (ecModel) {
  var unfinished;
  ecModel.eachSeries(function (seriesModel) {
    // Progress to the end for dataInit and dataRestore.
    unfinished |= seriesModel.dataTask.perform();
  });
  this.unfinished |= unfinished;
};

proto.plan = function () {
  // Travel pipelines, check block.
  this._pipelineMap.each(function (pipeline) {
    var task = pipeline.tail;

    do {
      if (task.__block) {
        pipeline.blockIndex = task.__idxInPipeline;
        break;
      }

      task = task.getUpstream();
    } while (task);
  });
};

var updatePayload = proto.updatePayload = function (task, payload) {
  payload !== 'remain' && (task.context.payload = payload);
};

function createSeriesStageTask(scheduler, stageHandler, stageHandlerRecord, ecModel, api) {
  var seriesTaskMap = stageHandlerRecord.seriesTaskMap || (stageHandlerRecord.seriesTaskMap = createHashMap());
  var seriesType = stageHandler.seriesType;
  var getTargetSeries = stageHandler.getTargetSeries; // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
  // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
  // it works but it may cause other irrelevant charts blocked.

  if (stageHandler.createOnAllSeries) {
    ecModel.eachRawSeries(create);
  } else if (seriesType) {
    ecModel.eachRawSeriesByType(seriesType, create);
  } else if (getTargetSeries) {
    getTargetSeries(ecModel, api).each(create);
  }

  function create(seriesModel) {
    var pipelineId = seriesModel.uid; // Init tasks for each seriesModel only once.
    // Reuse original task instance.

    var task = seriesTaskMap.get(pipelineId) || seriesTaskMap.set(pipelineId, createTask({
      plan: seriesTaskPlan,
      reset: seriesTaskReset,
      count: seriesTaskCount
    }));
    task.context = {
      model: seriesModel,
      ecModel: ecModel,
      api: api,
      useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
      plan: stageHandler.plan,
      reset: stageHandler.reset,
      scheduler: scheduler
    };
    pipe(scheduler, seriesModel, task);
  } // Clear unused series tasks.


  var pipelineMap = scheduler._pipelineMap;
  seriesTaskMap.each(function (task, pipelineId) {
    if (!pipelineMap.get(pipelineId)) {
      task.dispose();
      seriesTaskMap.removeKey(pipelineId);
    }
  });
}

function createOverallStageTask(scheduler, stageHandler, stageHandlerRecord, ecModel, api) {
  var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask // For overall task, the function only be called on reset stage.
  || createTask({
    reset: overallTaskReset
  });
  overallTask.context = {
    ecModel: ecModel,
    api: api,
    overallReset: stageHandler.overallReset,
    scheduler: scheduler
  }; // Reuse orignal stubs.

  var agentStubMap = overallTask.agentStubMap = overallTask.agentStubMap || createHashMap();
  var seriesType = stageHandler.seriesType;
  var getTargetSeries = stageHandler.getTargetSeries;
  var overallProgress = true;
  var modifyOutputEnd = stageHandler.modifyOutputEnd; // An overall task with seriesType detected or has `getTargetSeries`, we add
  // stub in each pipelines, it will set the overall task dirty when the pipeline
  // progress. Moreover, to avoid call the overall task each frame (too frequent),
  // we set the pipeline block.

  if (seriesType) {
    ecModel.eachRawSeriesByType(seriesType, createStub);
  } else if (getTargetSeries) {
    getTargetSeries(ecModel, api).each(createStub);
  } // Otherwise, (usually it is legancy case), the overall task will only be
  // executed when upstream dirty. Otherwise the progressive rendering of all
  // pipelines will be disabled unexpectedly. But it still needs stubs to receive
  // dirty info from upsteam.
  else {
      overallProgress = false;
      each(ecModel.getSeries(), createStub);
    }

  function createStub(seriesModel) {
    var pipelineId = seriesModel.uid;
    var stub = agentStubMap.get(pipelineId);

    if (!stub) {
      stub = agentStubMap.set(pipelineId, createTask({
        reset: stubReset,
        onDirty: stubOnDirty
      })); // When the result of `getTargetSeries` changed, the overallTask
      // should be set as dirty and re-performed.

      overallTask.dirty();
    }

    stub.context = {
      model: seriesModel,
      overallProgress: overallProgress,
      modifyOutputEnd: modifyOutputEnd
    };
    stub.agent = overallTask;
    stub.__block = overallProgress;
    pipe(scheduler, seriesModel, stub);
  } // Clear unused stubs.


  var pipelineMap = scheduler._pipelineMap;
  agentStubMap.each(function (stub, pipelineId) {
    if (!pipelineMap.get(pipelineId)) {
      stub.dispose(); // When the result of `getTargetSeries` changed, the overallTask
      // should be set as dirty and re-performed.

      overallTask.dirty();
      agentStubMap.removeKey(pipelineId);
    }
  });
}

function overallTaskReset(context) {
  context.overallReset(context.ecModel, context.api, context.payload);
}

function stubReset(context, upstreamContext) {
  return context.overallProgress && stubProgress;
}

function stubProgress() {
  this.agent.dirty();
  this.getDownstream().dirty();
}

function stubOnDirty() {
  this.agent && this.agent.dirty();
}

function seriesTaskPlan(context) {
  return context.plan && context.plan(context.model, context.ecModel, context.api, context.payload);
}

function seriesTaskReset(context) {
  if (context.useClearVisual) {
    context.data.clearAllVisual();
  }

  var resetDefines = context.resetDefines = normalizeToArray(context.reset(context.model, context.ecModel, context.api, context.payload));
  return resetDefines.length > 1 ? map(resetDefines, function (v, idx) {
    return makeSeriesTaskProgress(idx);
  }) : singleSeriesTaskProgress;
}

var singleSeriesTaskProgress = makeSeriesTaskProgress(0);

function makeSeriesTaskProgress(resetDefineIdx) {
  return function (params, context) {
    var data = context.data;
    var resetDefine = context.resetDefines[resetDefineIdx];

    if (resetDefine && resetDefine.dataEach) {
      for (var i = params.start; i < params.end; i++) {
        resetDefine.dataEach(data, i);
      }
    } else if (resetDefine && resetDefine.progress) {
      resetDefine.progress(params, data);
    }
  };
}

function seriesTaskCount(context) {
  return context.data.count();
}

function pipe(scheduler, seriesModel, task) {
  var pipelineId = seriesModel.uid;

  var pipeline = scheduler._pipelineMap.get(pipelineId);

  !pipeline.head && (pipeline.head = task);
  pipeline.tail && pipeline.tail.pipe(task);
  pipeline.tail = task;
  task.__idxInPipeline = pipeline.count++;
  task.__pipeline = pipeline;
}

Scheduler.wrapStageHandler = function (stageHandler, visualType) {
  if (isFunction(stageHandler)) {
    stageHandler = {
      overallReset: stageHandler,
      seriesType: detectSeriseType(stageHandler)
    };
  }

  stageHandler.uid = getUID('stageHandler');
  visualType && (stageHandler.visualType = visualType);
  return stageHandler;
};
/**
 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
 * To ensure that they can work normally, they should work in block mode, that is,
 * they should not be started util the previous tasks finished. So they cause the
 * progressive rendering disabled. We try to detect the series type, to narrow down
 * the block range to only the series type they concern, but not all series.
 */


function detectSeriseType(legacyFunc) {
  seriesType = null;

  try {
    // Assume there is no async when calling `eachSeriesByType`.
    legacyFunc(ecModelMock, apiMock);
  } catch (e) {}

  return seriesType;
}

var ecModelMock = {};
var apiMock = {};
var seriesType;
mockMethods(ecModelMock, GlobalModel);
mockMethods(apiMock, ExtensionAPI);

ecModelMock.eachSeriesByType = ecModelMock.eachRawSeriesByType = function (type) {
  seriesType = type;
};

ecModelMock.eachComponent = function (cond) {
  if (cond.mainType === 'series' && cond.subType) {
    seriesType = cond.subType;
  }
};

function mockMethods(target, Clz) {
  /* eslint-disable */
  for (var name in Clz.prototype) {
    // Do not use hasOwnProperty
    target[name] = noop;
  }
  /* eslint-enable */

}

var _default = Scheduler;
module.exports = _default;

/***/ }),
/* 1564 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var colorAll = ['#37A2DA', '#32C5E9', '#67E0E3', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#E062AE', '#E690D1', '#e7bcf3', '#9d96f5', '#8378EA', '#96BFFF'];
var _default = {
  color: colorAll,
  colorLayer: [['#37A2DA', '#ffd85c', '#fd7b5f'], ['#37A2DA', '#67E0E3', '#FFDB5C', '#ff9f7f', '#E062AE', '#9d96f5'], ['#37A2DA', '#32C5E9', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#e7bcf3', '#8378EA', '#96BFFF'], colorAll]
};
module.exports = _default;

/***/ }),
/* 1565 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var contrastColor = '#eee';

var axisCommon = function () {
  return {
    axisLine: {
      lineStyle: {
        color: contrastColor
      }
    },
    axisTick: {
      lineStyle: {
        color: contrastColor
      }
    },
    axisLabel: {
      textStyle: {
        color: contrastColor
      }
    },
    splitLine: {
      lineStyle: {
        type: 'dashed',
        color: '#aaa'
      }
    },
    splitArea: {
      areaStyle: {
        color: contrastColor
      }
    }
  };
};

var colorPalette = ['#dd6b66', '#759aa0', '#e69d87', '#8dc1a9', '#ea7e53', '#eedd78', '#73a373', '#73b9bc', '#7289ab', '#91ca8c', '#f49f42'];
var theme = {
  color: colorPalette,
  backgroundColor: '#333',
  tooltip: {
    axisPointer: {
      lineStyle: {
        color: contrastColor
      },
      crossStyle: {
        color: contrastColor
      },
      label: {
        color: '#000'
      }
    }
  },
  legend: {
    textStyle: {
      color: contrastColor
    }
  },
  textStyle: {
    color: contrastColor
  },
  title: {
    textStyle: {
      color: contrastColor
    }
  },
  toolbox: {
    iconStyle: {
      normal: {
        borderColor: contrastColor
      }
    }
  },
  dataZoom: {
    textStyle: {
      color: contrastColor
    }
  },
  visualMap: {
    textStyle: {
      color: contrastColor
    }
  },
  timeline: {
    lineStyle: {
      color: contrastColor
    },
    itemStyle: {
      normal: {
        color: colorPalette[1]
      }
    },
    label: {
      normal: {
        textStyle: {
          color: contrastColor
        }
      }
    },
    controlStyle: {
      normal: {
        color: contrastColor,
        borderColor: contrastColor
      }
    }
  },
  timeAxis: axisCommon(),
  logAxis: axisCommon(),
  valueAxis: axisCommon(),
  categoryAxis: axisCommon(),
  line: {
    symbol: 'circle'
  },
  graph: {
    color: colorPalette
  },
  gauge: {
    title: {
      textStyle: {
        color: contrastColor
      }
    }
  },
  candlestick: {
    itemStyle: {
      normal: {
        color: '#FD1050',
        color0: '#0CF49B',
        borderColor: '#FD1050',
        borderColor0: '#0CF49B'
      }
    }
  }
};
theme.categoryAxis.splitLine.show = false;
var _default = theme;
module.exports = _default;

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(65);

/**
 * 椭圆形状
 * @module zrender/graphic/shape/Ellipse
 */
var _default = Path.extend({
  type: 'ellipse',
  shape: {
    cx: 0,
    cy: 0,
    rx: 0,
    ry: 0
  },
  buildPath: function (ctx, shape) {
    var k = 0.5522848;
    var x = shape.cx;
    var y = shape.cy;
    var a = shape.rx;
    var b = shape.ry;
    var ox = a * k; // 水平控制点偏移量

    var oy = b * k; // 垂直控制点偏移量
    // 从椭圆的左端点开始顺时针绘制四条三次贝塞尔曲线

    ctx.moveTo(x - a, y);
    ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
    ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
    ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
    ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
    ctx.closePath();
  }
});

module.exports = _default;

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var createListFromArray = __webpack_require__(137);

var axisHelper = __webpack_require__(109);

var axisModelCommonMixin = __webpack_require__(208);

var Model = __webpack_require__(68);

var _layout = __webpack_require__(53);

var getLayoutRect = _layout.getLayoutRect;
exports.getLayoutRect = _layout.getLayoutRect;

var _dataStackHelper = __webpack_require__(124);

var enableDataStack = _dataStackHelper.enableDataStack;
var isDimensionStacked = _dataStackHelper.isDimensionStacked;
var getStackedDimension = _dataStackHelper.getStackedDimension;

var _completeDimensions = __webpack_require__(641);

exports.completeDimensions = _completeDimensions;

var _createDimensions = __webpack_require__(207);

exports.createDimensions = _createDimensions;

var _symbol = __webpack_require__(99);

exports.createSymbol = _symbol.createSymbol;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// import createGraphFromNodeEdge from './chart/helper/createGraphFromNodeEdge';

/**
 * Create a muti dimension List structure from seriesModel.
 * @param  {module:echarts/model/Model} seriesModel
 * @return {module:echarts/data/List} list
 */
function createList(seriesModel) {
  return createListFromArray(seriesModel.getSource(), seriesModel);
} // export function createGraph(seriesModel) {
//     var nodes = seriesModel.get('data');
//     var links = seriesModel.get('links');
//     return createGraphFromNodeEdge(nodes, links, seriesModel);
// }


var dataStack = {
  isDimensionStacked: isDimensionStacked,
  enableDataStack: enableDataStack,
  getStackedDimension: getStackedDimension
};
/**
 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
 * @param {string} symbolDesc
 * @param {number} x
 * @param {number} y
 * @param {number} w
 * @param {number} h
 * @param {string} color
 */

/**
 * Create scale
 * @param {Array.<number>} dataExtent
 * @param {Object|module:echarts/Model} option
 */
function createScale(dataExtent, option) {
  var axisModel = option;

  if (!Model.isInstance(option)) {
    axisModel = new Model(option);
    zrUtil.mixin(axisModel, axisModelCommonMixin);
  }

  var scale = axisHelper.createScaleByModel(axisModel);
  scale.setExtent(dataExtent[0], dataExtent[1]);
  axisHelper.niceScaleExtent(scale, axisModel);
  return scale;
}
/**
 * Mixin common methods to axis model,
 *
 * Inlcude methods
 * `getFormattedLabels() => Array.<string>`
 * `getCategories() => Array.<string>`
 * `getMin(origin: boolean) => number`
 * `getMax(origin: boolean) => number`
 * `getNeedCrossZero() => boolean`
 * `setRange(start: number, end: number)`
 * `resetRange()`
 */


function mixinAxisModelCommonMethods(Model) {
  zrUtil.mixin(Model, axisModelCommonMixin);
}

exports.createList = createList;
exports.dataStack = dataStack;
exports.createScale = createScale;
exports.mixinAxisModelCommonMethods = mixinAxisModelCommonMethods;

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var _util = __webpack_require__(1);

var createHashMap = _util.createHashMap;
var retrieve = _util.retrieve;
var each = _util.each;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Helper for model references.
 * There are many manners to refer axis/coordSys.
 */
// TODO
// merge relevant logic to this file?
// check: "modelHelper" of tooltip and "BrushTargetManager".

/**
 * @class
 * For example:
 * {
 *     coordSysName: 'cartesian2d',
 *     coordSysDims: ['x', 'y', ...],
 *     axisMap: HashMap({
 *         x: xAxisModel,
 *         y: yAxisModel
 *     }),
 *     categoryAxisMap: HashMap({
 *         x: xAxisModel,
 *         y: undefined
 *     }),
 *     // The index of the first category axis in `coordSysDims`.
 *     // `null/undefined` means no category axis exists.
 *     firstCategoryDimIndex: 1,
 *     // To replace user specified encode.
 * }
 */
function CoordSysInfo(coordSysName) {
  /**
   * @type {string}
   */
  this.coordSysName = coordSysName;
  /**
   * @type {Array.<string>}
   */

  this.coordSysDims = [];
  /**
   * @type {module:zrender/core/util#HashMap}
   */

  this.axisMap = createHashMap();
  /**
   * @type {module:zrender/core/util#HashMap}
   */

  this.categoryAxisMap = createHashMap();
  /**
   * @type {number}
   */

  this.firstCategoryDimIndex = null;
}
/**
 * @return {module:model/referHelper#CoordSysInfo}
 */


function getCoordSysInfoBySeries(seriesModel) {
  var coordSysName = seriesModel.get('coordinateSystem');
  var result = new CoordSysInfo(coordSysName);
  var fetch = fetchers[coordSysName];

  if (fetch) {
    fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
    return result;
  }
}

var fetchers = {
  cartesian2d: function (seriesModel, result, axisMap, categoryAxisMap) {
    var xAxisModel = seriesModel.getReferringComponents('xAxis')[0];
    var yAxisModel = seriesModel.getReferringComponents('yAxis')[0];
    result.coordSysDims = ['x', 'y'];
    axisMap.set('x', xAxisModel);
    axisMap.set('y', yAxisModel);

    if (isCategory(xAxisModel)) {
      categoryAxisMap.set('x', xAxisModel);
      result.firstCategoryDimIndex = 0;
    }

    if (isCategory(yAxisModel)) {
      categoryAxisMap.set('y', yAxisModel);
      result.firstCategoryDimIndex == null & (result.firstCategoryDimIndex = 1);
    }
  },
  singleAxis: function (seriesModel, result, axisMap, categoryAxisMap) {
    var singleAxisModel = seriesModel.getReferringComponents('singleAxis')[0];
    result.coordSysDims = ['single'];
    axisMap.set('single', singleAxisModel);

    if (isCategory(singleAxisModel)) {
      categoryAxisMap.set('single', singleAxisModel);
      result.firstCategoryDimIndex = 0;
    }
  },
  polar: function (seriesModel, result, axisMap, categoryAxisMap) {
    var polarModel = seriesModel.getReferringComponents('polar')[0];
    var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
    var angleAxisModel = polarModel.findAxisModel('angleAxis');
    result.coordSysDims = ['radius', 'angle'];
    axisMap.set('radius', radiusAxisModel);
    axisMap.set('angle', angleAxisModel);

    if (isCategory(radiusAxisModel)) {
      categoryAxisMap.set('radius', radiusAxisModel);
      result.firstCategoryDimIndex = 0;
    }

    if (isCategory(angleAxisModel)) {
      categoryAxisMap.set('angle', angleAxisModel);
      result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
    }
  },
  geo: function (seriesModel, result, axisMap, categoryAxisMap) {
    result.coordSysDims = ['lng', 'lat'];
  },
  parallel: function (seriesModel, result, axisMap, categoryAxisMap) {
    var ecModel = seriesModel.ecModel;
    var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
    var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
    each(parallelModel.parallelAxisIndex, function (axisIndex, index) {
      var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
      var axisDim = coordSysDims[index];
      axisMap.set(axisDim, axisModel);

      if (isCategory(axisModel) && result.firstCategoryDimIndex == null) {
        categoryAxisMap.set(axisDim, axisModel);
        result.firstCategoryDimIndex = index;
      }
    });
  }
};

function isCategory(axisModel) {
  return axisModel.get('type') === 'category';
}

exports.getCoordSysInfoBySeries = getCoordSysInfoBySeries;

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var Scale = __webpack_require__(298);

var OrdinalMeta = __webpack_require__(642);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Linear continuous scale
 * @module echarts/coord/scale/Ordinal
 *
 * http://en.wikipedia.org/wiki/Level_of_measurement
 */
// FIXME only one data
var scaleProto = Scale.prototype;
var OrdinalScale = Scale.extend({
  type: 'ordinal',

  /**
   * @param {module:echarts/data/OrdianlMeta|Array.<string>} ordinalMeta
   */
  init: function (ordinalMeta, extent) {
    // Caution: Should not use instanceof, consider ec-extensions using
    // import approach to get OrdinalMeta class.
    if (!ordinalMeta || zrUtil.isArray(ordinalMeta)) {
      ordinalMeta = new OrdinalMeta({
        categories: ordinalMeta
      });
    }

    this._ordinalMeta = ordinalMeta;
    this._extent = extent || [0, ordinalMeta.categories.length - 1];
  },
  parse: function (val) {
    return typeof val === 'string' ? this._ordinalMeta.getOrdinal(val) // val might be float.
    : Math.round(val);
  },
  contain: function (rank) {
    rank = this.parse(rank);
    return scaleProto.contain.call(this, rank) && this._ordinalMeta.categories[rank] != null;
  },

  /**
   * Normalize given rank or name to linear [0, 1]
   * @param {number|string} [val]
   * @return {number}
   */
  normalize: function (val) {
    return scaleProto.normalize.call(this, this.parse(val));
  },
  scale: function (val) {
    return Math.round(scaleProto.scale.call(this, val));
  },

  /**
   * @return {Array}
   */
  getTicks: function () {
    var ticks = [];
    var extent = this._extent;
    var rank = extent[0];

    while (rank <= extent[1]) {
      ticks.push(rank);
      rank++;
    }

    return ticks;
  },

  /**
   * Get item on rank n
   * @param {number} n
   * @return {string}
   */
  getLabel: function (n) {
    if (!this.isBlank()) {
      // Note that if no data, ordinalMeta.categories is an empty array.
      return this._ordinalMeta.categories[n];
    }
  },

  /**
   * @return {number}
   */
  count: function () {
    return this._extent[1] - this._extent[0] + 1;
  },

  /**
   * @override
   */
  unionExtentFromData: function (data, dim) {
    this.unionExtent(data.getApproximateExtent(dim));
  },
  getOrdinalMeta: function () {
    return this._ordinalMeta;
  },
  niceTicks: zrUtil.noop,
  niceExtent: zrUtil.noop
});
/**
 * @return {module:echarts/scale/Time}
 */

OrdinalScale.create = function () {
  return new OrdinalScale();
};

var _default = OrdinalScale;
module.exports = _default;

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var numberUtil = __webpack_require__(37);

var formatUtil = __webpack_require__(54);

var scaleHelper = __webpack_require__(643);

var IntervalScale = __webpack_require__(299);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* A third-party license is embeded for some of the code in this file:
* The "scaleLevels" was originally copied from "d3.js" with some
* modifications made for this project.
* (See more details in the comment on the definition of "scaleLevels" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/
// [About UTC and local time zone]:
// In most cases, `number.parseDate` will treat input data string as local time
// (except time zone is specified in time string). And `format.formateTime` returns
// local time by default. option.useUTC is false by default. This design have
// concidered these common case:
// (1) Time that is persistent in server is in UTC, but it is needed to be diplayed
// in local time by default.
// (2) By default, the input data string (e.g., '2011-01-02') should be displayed
// as its original time, without any time difference.
var intervalScaleProto = IntervalScale.prototype;
var mathCeil = Math.ceil;
var mathFloor = Math.floor;
var ONE_SECOND = 1000;
var ONE_MINUTE = ONE_SECOND * 60;
var ONE_HOUR = ONE_MINUTE * 60;
var ONE_DAY = ONE_HOUR * 24; // FIXME 公用？

var bisect = function (a, x, lo, hi) {
  while (lo < hi) {
    var mid = lo + hi >>> 1;

    if (a[mid][1] < x) {
      lo = mid + 1;
    } else {
      hi = mid;
    }
  }

  return lo;
};
/**
 * @alias module:echarts/coord/scale/Time
 * @constructor
 */


var TimeScale = IntervalScale.extend({
  type: 'time',

  /**
   * @override
   */
  getLabel: function (val) {
    var stepLvl = this._stepLvl;
    var date = new Date(val);
    return formatUtil.formatTime(stepLvl[0], date, this.getSetting('useUTC'));
  },

  /**
   * @override
   */
  niceExtent: function (opt) {
    var extent = this._extent; // If extent start and end are same, expand them

    if (extent[0] === extent[1]) {
      // Expand extent
      extent[0] -= ONE_DAY;
      extent[1] += ONE_DAY;
    } // If there are no data and extent are [Infinity, -Infinity]


    if (extent[1] === -Infinity && extent[0] === Infinity) {
      var d = new Date();
      extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
      extent[0] = extent[1] - ONE_DAY;
    }

    this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;

    var interval = this._interval;

    if (!opt.fixMin) {
      extent[0] = numberUtil.round(mathFloor(extent[0] / interval) * interval);
    }

    if (!opt.fixMax) {
      extent[1] = numberUtil.round(mathCeil(extent[1] / interval) * interval);
    }
  },

  /**
   * @override
   */
  niceTicks: function (approxTickNum, minInterval, maxInterval) {
    approxTickNum = approxTickNum || 10;
    var extent = this._extent;
    var span = extent[1] - extent[0];
    var approxInterval = span / approxTickNum;

    if (minInterval != null && approxInterval < minInterval) {
      approxInterval = minInterval;
    }

    if (maxInterval != null && approxInterval > maxInterval) {
      approxInterval = maxInterval;
    }

    var scaleLevelsLen = scaleLevels.length;
    var idx = bisect(scaleLevels, approxInterval, 0, scaleLevelsLen);
    var level = scaleLevels[Math.min(idx, scaleLevelsLen - 1)];
    var interval = level[1]; // Same with interval scale if span is much larger than 1 year

    if (level[0] === 'year') {
      var yearSpan = span / interval; // From "Nice Numbers for Graph Labels" of Graphic Gems
      // var niceYearSpan = numberUtil.nice(yearSpan, false);

      var yearStep = numberUtil.nice(yearSpan / approxTickNum, true);
      interval *= yearStep;
    }

    var timezoneOffset = this.getSetting('useUTC') ? 0 : new Date(+extent[0] || +extent[1]).getTimezoneOffset() * 60 * 1000;
    var niceExtent = [Math.round(mathCeil((extent[0] - timezoneOffset) / interval) * interval + timezoneOffset), Math.round(mathFloor((extent[1] - timezoneOffset) / interval) * interval + timezoneOffset)];
    scaleHelper.fixExtent(niceExtent, extent);
    this._stepLvl = level; // Interval will be used in getTicks

    this._interval = interval;
    this._niceExtent = niceExtent;
  },
  parse: function (val) {
    // val might be float.
    return +numberUtil.parseDate(val);
  }
});
zrUtil.each(['contain', 'normalize'], function (methodName) {
  TimeScale.prototype[methodName] = function (val) {
    return intervalScaleProto[methodName].call(this, this.parse(val));
  };
});
/**
 * This implementation was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */

var scaleLevels = [// Format              interval
['hh:mm:ss', ONE_SECOND], // 1s
['hh:mm:ss', ONE_SECOND * 5], // 5s
['hh:mm:ss', ONE_SECOND * 10], // 10s
['hh:mm:ss', ONE_SECOND * 15], // 15s
['hh:mm:ss', ONE_SECOND * 30], // 30s
['hh:mm\nMM-dd', ONE_MINUTE], // 1m
['hh:mm\nMM-dd', ONE_MINUTE * 5], // 5m
['hh:mm\nMM-dd', ONE_MINUTE * 10], // 10m
['hh:mm\nMM-dd', ONE_MINUTE * 15], // 15m
['hh:mm\nMM-dd', ONE_MINUTE * 30], // 30m
['hh:mm\nMM-dd', ONE_HOUR], // 1h
['hh:mm\nMM-dd', ONE_HOUR * 2], // 2h
['hh:mm\nMM-dd', ONE_HOUR * 6], // 6h
['hh:mm\nMM-dd', ONE_HOUR * 12], // 12h
['MM-dd\nyyyy', ONE_DAY], // 1d
['MM-dd\nyyyy', ONE_DAY * 2], // 2d
['MM-dd\nyyyy', ONE_DAY * 3], // 3d
['MM-dd\nyyyy', ONE_DAY * 4], // 4d
['MM-dd\nyyyy', ONE_DAY * 5], // 5d
['MM-dd\nyyyy', ONE_DAY * 6], // 6d
['week', ONE_DAY * 7], // 7d
['MM-dd\nyyyy', ONE_DAY * 10], // 10d
['week', ONE_DAY * 14], // 2w
['week', ONE_DAY * 21], // 3w
['month', ONE_DAY * 31], // 1M
['week', ONE_DAY * 42], // 6w
['month', ONE_DAY * 62], // 2M
['week', ONE_DAY * 70], // 10w
['quarter', ONE_DAY * 95], // 3M
['month', ONE_DAY * 31 * 4], // 4M
['month', ONE_DAY * 31 * 5], // 5M
['half-year', ONE_DAY * 380 / 2], // 6M
['month', ONE_DAY * 31 * 8], // 8M
['month', ONE_DAY * 31 * 10], // 10M
['year', ONE_DAY * 380] // 1Y
];
/**
 * @param {module:echarts/model/Model}
 * @return {module:echarts/scale/Time}
 */

TimeScale.create = function (model) {
  return new TimeScale({
    useUTC: model.ecModel.get('useUTC')
  });
};

var _default = TimeScale;
module.exports = _default;

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var textContain = __webpack_require__(93);

var _model = __webpack_require__(44);

var makeInner = _model.makeInner;

var _axisHelper = __webpack_require__(109);

var makeLabelFormatter = _axisHelper.makeLabelFormatter;
var getOptionCategoryInterval = _axisHelper.getOptionCategoryInterval;
var shouldShowAllLabels = _axisHelper.shouldShowAllLabels;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var inner = makeInner();
/**
 * @param {module:echats/coord/Axis} axis
 * @return {Object} {
 *     labels: [{
 *         formattedLabel: string,
 *         rawLabel: string,
 *         tickValue: number
 *     }, ...],
 *     labelCategoryInterval: number
 * }
 */

function createAxisLabels(axis) {
  // Only ordinal scale support tick interval
  return axis.type === 'category' ? makeCategoryLabels(axis) : makeRealNumberLabels(axis);
}
/**
 * @param {module:echats/coord/Axis} axis
 * @param {module:echarts/model/Model} tickModel For example, can be axisTick, splitLine, splitArea.
 * @return {Object} {
 *     ticks: Array.<number>
 *     tickCategoryInterval: number
 * }
 */


function createAxisTicks(axis, tickModel) {
  // Only ordinal scale support tick interval
  return axis.type === 'category' ? makeCategoryTicks(axis, tickModel) : {
    ticks: axis.scale.getTicks()
  };
}

function makeCategoryLabels(axis) {
  var labelModel = axis.getLabelModel();
  var result = makeCategoryLabelsActually(axis, labelModel);
  return !labelModel.get('show') || axis.scale.isBlank() ? {
    labels: [],
    labelCategoryInterval: result.labelCategoryInterval
  } : result;
}

function makeCategoryLabelsActually(axis, labelModel) {
  var labelsCache = getListCache(axis, 'labels');
  var optionLabelInterval = getOptionCategoryInterval(labelModel);
  var result = listCacheGet(labelsCache, optionLabelInterval);

  if (result) {
    return result;
  }

  var labels;
  var numericLabelInterval;

  if (zrUtil.isFunction(optionLabelInterval)) {
    labels = makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
  } else {
    numericLabelInterval = optionLabelInterval === 'auto' ? makeAutoCategoryInterval(axis) : optionLabelInterval;
    labels = makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
  } // Cache to avoid calling interval function repeatly.


  return listCacheSet(labelsCache, optionLabelInterval, {
    labels: labels,
    labelCategoryInterval: numericLabelInterval
  });
}

function makeCategoryTicks(axis, tickModel) {
  var ticksCache = getListCache(axis, 'ticks');
  var optionTickInterval = getOptionCategoryInterval(tickModel);
  var result = listCacheGet(ticksCache, optionTickInterval);

  if (result) {
    return result;
  }

  var ticks;
  var tickCategoryInterval; // Optimize for the case that large category data and no label displayed,
  // we should not return all ticks.

  if (!tickModel.get('show') || axis.scale.isBlank()) {
    ticks = [];
  }

  if (zrUtil.isFunction(optionTickInterval)) {
    ticks = makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
  } // Always use label interval by default despite label show. Consider this
  // scenario, Use multiple grid with the xAxis sync, and only one xAxis shows
  // labels. `splitLine` and `axisTick` should be consistent in this case.
  else if (optionTickInterval === 'auto') {
      var labelsResult = makeCategoryLabelsActually(axis, axis.getLabelModel());
      tickCategoryInterval = labelsResult.labelCategoryInterval;
      ticks = zrUtil.map(labelsResult.labels, function (labelItem) {
        return labelItem.tickValue;
      });
    } else {
      tickCategoryInterval = optionTickInterval;
      ticks = makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
    } // Cache to avoid calling interval function repeatly.


  return listCacheSet(ticksCache, optionTickInterval, {
    ticks: ticks,
    tickCategoryInterval: tickCategoryInterval
  });
}

function makeRealNumberLabels(axis) {
  var ticks = axis.scale.getTicks();
  var labelFormatter = makeLabelFormatter(axis);
  return {
    labels: zrUtil.map(ticks, function (tickValue, idx) {
      return {
        formattedLabel: labelFormatter(tickValue, idx),
        rawLabel: axis.scale.getLabel(tickValue),
        tickValue: tickValue
      };
    })
  };
} // Large category data calculation is performence sensitive, and ticks and label
// probably be fetched by multiple times. So we cache the result.
// axis is created each time during a ec process, so we do not need to clear cache.


function getListCache(axis, prop) {
  // Because key can be funciton, and cache size always be small, we use array cache.
  return inner(axis)[prop] || (inner(axis)[prop] = []);
}

function listCacheGet(cache, key) {
  for (var i = 0; i < cache.length; i++) {
    if (cache[i].key === key) {
      return cache[i].value;
    }
  }
}

function listCacheSet(cache, key, value) {
  cache.push({
    key: key,
    value: value
  });
  return value;
}

function makeAutoCategoryInterval(axis) {
  var result = inner(axis).autoInterval;
  return result != null ? result : inner(axis).autoInterval = axis.calculateCategoryInterval();
}
/**
 * Calculate interval for category axis ticks and labels.
 * To get precise result, at least one of `getRotate` and `isHorizontal`
 * should be implemented in axis.
 */


function calculateCategoryInterval(axis) {
  var params = fetchAutoCategoryIntervalCalculationParams(axis);
  var labelFormatter = makeLabelFormatter(axis);
  var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
  var ordinalScale = axis.scale;
  var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
  // avoid generating a long array by `getTicks`
  // in large category data case.

  var tickCount = ordinalScale.count();

  if (ordinalExtent[1] - ordinalExtent[0] < 1) {
    return 0;
  }

  var step = 1; // Simple optimization. Empirical value: tick count should less than 40.

  if (tickCount > 40) {
    step = Math.max(1, Math.floor(tickCount / 40));
  }

  var tickValue = ordinalExtent[0];
  var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
  var unitW = Math.abs(unitSpan * Math.cos(rotation));
  var unitH = Math.abs(unitSpan * Math.sin(rotation));
  var maxW = 0;
  var maxH = 0; // Caution: Performance sensitive for large category data.
  // Consider dataZoom, we should make appropriate step to avoid O(n) loop.

  for (; tickValue <= ordinalExtent[1]; tickValue += step) {
    var width = 0;
    var height = 0; // Not precise, do not consider align and vertical align
    // and each distance from axis line yet.

    var rect = textContain.getBoundingRect(labelFormatter(tickValue), params.font, 'center', 'top'); // Magic number

    width = rect.width * 1.3;
    height = rect.height * 1.3; // Min size, void long loop.

    maxW = Math.max(maxW, width, 7);
    maxH = Math.max(maxH, height, 7);
  }

  var dw = maxW / unitW;
  var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.

  isNaN(dw) && (dw = Infinity);
  isNaN(dh) && (dh = Infinity);
  var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
  var cache = inner(axis.model);
  var axisExtent = axis.getExtent();
  var lastAutoInterval = cache.lastAutoInterval;
  var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
  // otherwise the calculated interval might jitter when the zoom
  // window size is close to the interval-changing size.
  // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
  // The jitter will cause that sometimes the displayed labels are
  // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).

  if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
  // point is not the same when zooming in or zooming out.
  && lastAutoInterval > interval // If the axis change is caused by chart resize, the cache should not
  // be used. Otherwise some hiden labels might not be shown again.
  && cache.axisExtend0 === axisExtent[0] && cache.axisExtend1 === axisExtent[1]) {
    interval = lastAutoInterval;
  } // Only update cache if cache not used, otherwise the
  // changing of interval is too insensitive.
  else {
      cache.lastTickCount = tickCount;
      cache.lastAutoInterval = interval;
      cache.axisExtend0 = axisExtent[0];
      cache.axisExtend1 = axisExtent[1];
    }

  return interval;
}

function fetchAutoCategoryIntervalCalculationParams(axis) {
  var labelModel = axis.getLabelModel();
  return {
    axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
    labelRotate: labelModel.get('rotate') || 0,
    font: labelModel.getFont()
  };
}

function makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
  var labelFormatter = makeLabelFormatter(axis);
  var ordinalScale = axis.scale;
  var ordinalExtent = ordinalScale.getExtent();
  var labelModel = axis.getLabelModel();
  var result = []; // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...

  var step = Math.max((categoryInterval || 0) + 1, 1);
  var startTick = ordinalExtent[0];
  var tickCount = ordinalScale.count(); // Calculate start tick based on zero if possible to keep label consistent
  // while zooming and moving while interval > 0. Otherwise the selection
  // of displayable ticks and symbols probably keep changing.
  // 3 is empirical value.

  if (startTick !== 0 && step > 1 && tickCount / step > 2) {
    startTick = Math.round(Math.ceil(startTick / step) * step);
  } // (1) Only add min max label here but leave overlap checking
  // to render stage, which also ensure the returned list
  // suitable for splitLine and splitArea rendering.
  // (2) Scales except category always contain min max label so
  // do not need to perform this process.


  var showAllLabel = shouldShowAllLabels(axis);
  var includeMinLabel = labelModel.get('showMinLabel') || showAllLabel;
  var includeMaxLabel = labelModel.get('showMaxLabel') || showAllLabel;

  if (includeMinLabel && startTick !== ordinalExtent[0]) {
    addItem(ordinalExtent[0]);
  } // Optimize: avoid generating large array by `ordinalScale.getTicks()`.


  var tickValue = startTick;

  for (; tickValue <= ordinalExtent[1]; tickValue += step) {
    addItem(tickValue);
  }

  if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) {
    addItem(ordinalExtent[1]);
  }

  function addItem(tVal) {
    result.push(onlyTick ? tVal : {
      formattedLabel: labelFormatter(tVal),
      rawLabel: ordinalScale.getLabel(tVal),
      tickValue: tVal
    });
  }

  return result;
} // When interval is function, the result `false` means ignore the tick.
// It is time consuming for large category data.


function makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
  var ordinalScale = axis.scale;
  var labelFormatter = makeLabelFormatter(axis);
  var result = [];
  zrUtil.each(ordinalScale.getTicks(), function (tickValue) {
    var rawLabel = ordinalScale.getLabel(tickValue);

    if (categoryInterval(tickValue, rawLabel)) {
      result.push(onlyTick ? tickValue : {
        formattedLabel: labelFormatter(tickValue),
        rawLabel: rawLabel,
        tickValue: tickValue
      });
    }
  });
  return result;
}

exports.createAxisLabels = createAxisLabels;
exports.createAxisTicks = createAxisTicks;
exports.calculateCategoryInterval = calculateCategoryInterval;

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(1573);

__webpack_require__(1574);

var visualSymbol = __webpack_require__(178);

var layoutPoints = __webpack_require__(241);

var dataSample = __webpack_require__(1576);

__webpack_require__(242);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// In case developer forget to include grid component
echarts.registerVisual(visualSymbol('line', 'circle', 'line'));
echarts.registerLayout(layoutPoints('line')); // Down sample after filter

echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, dataSample('line'));

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var createListFromArray = __webpack_require__(137);

var SeriesModel = __webpack_require__(74);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = SeriesModel.extend({
  type: 'series.line',
  dependencies: ['grid', 'polar'],
  getInitialData: function (option, ecModel) {
    return createListFromArray(this.getSource(), this, {
      useEncodeDefaulter: true
    });
  },
  defaultOption: {
    zlevel: 0,
    z: 2,
    coordinateSystem: 'cartesian2d',
    legendHoverLink: true,
    hoverAnimation: true,
    // stack: null
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // polarIndex: 0,
    // If clip the overflow value
    clip: true,
    // cursor: null,
    label: {
      position: 'top'
    },
    // itemStyle: {
    // },
    lineStyle: {
      width: 2,
      type: 'solid'
    },
    // areaStyle: {
    // origin of areaStyle. Valid values:
    // `'auto'/null/undefined`: from axisLine to data
    // `'start'`: from min to data
    // `'end'`: from data to max
    // origin: 'auto'
    // },
    // false, 'start', 'end', 'middle'
    step: false,
    // Disabled if step is true
    smooth: false,
    smoothMonotone: null,
    symbol: 'emptyCircle',
    symbolSize: 4,
    symbolRotate: null,
    showSymbol: true,
    // `false`: follow the label interval strategy.
    // `true`: show all symbols.
    // `'auto'`: If possible, show all symbols, otherwise
    //           follow the label interval strategy.
    showAllSymbol: 'auto',
    // Whether to connect break point.
    connectNulls: false,
    // Sampling for large data. Can be: 'average', 'max', 'min', 'sum'.
    sampling: 'none',
    animationEasing: 'linear',
    // Disable progressive
    progressive: 0,
    hoverLayerThreshold: Infinity
  }
});

module.exports = _default;

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(1);

var _bbox = __webpack_require__(234);

var fromPoints = _bbox.fromPoints;

var SymbolDraw = __webpack_require__(239);

var SymbolClz = __webpack_require__(301);

var lineAnimationDiff = __webpack_require__(1575);

var graphic = __webpack_require__(27);

var modelUtil = __webpack_require__(44);

var _poly = __webpack_require__(649);

var Polyline = _poly.Polyline;
var Polygon = _poly.Polygon;

var ChartView = __webpack_require__(123);

var _helper = __webpack_require__(648);

var prepareDataCoordInfo = _helper.prepareDataCoordInfo;
var getStackedOnPoint = _helper.getStackedOnPoint;

var _createClipPathFromCoordSys = __webpack_require__(240);

var createGridClipPath = _createClipPathFromCoordSys.createGridClipPath;
var createPolarClipPath = _createClipPathFromCoordSys.createPolarClipPath;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// FIXME step not support polar
function isPointsSame(points1, points2) {
  if (points1.length !== points2.length) {
    return;
  }

  for (var i = 0; i < points1.length; i++) {
    var p1 = points1[i];
    var p2 = points2[i];

    if (p1[0] !== p2[0] || p1[1] !== p2[1]) {
      return;
    }
  }

  return true;
}

function getBoundingDiff(points1, points2) {
  var min1 = [];
  var max1 = [];
  var min2 = [];
  var max2 = [];
  fromPoints(points1, min1, max1);
  fromPoints(points2, min2, max2); // Get a max value from each corner of two boundings.

  return Math.max(Math.abs(min1[0] - min2[0]), Math.abs(min1[1] - min2[1]), Math.abs(max1[0] - max2[0]), Math.abs(max1[1] - max2[1]));
}

function getSmooth(smooth) {
  return typeof smooth === 'number' ? smooth : smooth ? 0.5 : 0;
}
/**
 * @param {module:echarts/coord/cartesian/Cartesian2D|module:echarts/coord/polar/Polar} coordSys
 * @param {module:echarts/data/List} data
 * @param {Object} dataCoordInfo
 * @param {Array.<Array.<number>>} points
 */


function getStackedOnPoints(coordSys, data, dataCoordInfo) {
  if (!dataCoordInfo.valueDim) {
    return [];
  }

  var points = [];

  for (var idx = 0, len = data.count(); idx < len; idx++) {
    points.push(getStackedOnPoint(dataCoordInfo, coordSys, data, idx));
  }

  return points;
}

function turnPointsIntoStep(points, coordSys, stepTurnAt) {
  var baseAxis = coordSys.getBaseAxis();
  var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
  var stepPoints = [];

  for (var i = 0; i < points.length - 1; i++) {
    var nextPt = points[i + 1];
    var pt = points[i];
    stepPoints.push(pt);
    var stepPt = [];

    switch (stepTurnAt) {
      case 'end':
        stepPt[baseIndex] = nextPt[baseIndex];
        stepPt[1 - baseIndex] = pt[1 - baseIndex]; // default is start

        stepPoints.push(stepPt);
        break;

      case 'middle':
        // default is start
        var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
        var stepPt2 = [];
        stepPt[baseIndex] = stepPt2[baseIndex] = middle;
        stepPt[1 - baseIndex] = pt[1 - baseIndex];
        stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
        stepPoints.push(stepPt);
        stepPoints.push(stepPt2);
        break;

      default:
        stepPt[baseIndex] = pt[baseIndex];
        stepPt[1 - baseIndex] = nextPt[1 - baseIndex]; // default is start

        stepPoints.push(stepPt);
    }
  } // Last points


  points[i] && stepPoints.push(points[i]);
  return stepPoints;
}

function getVisualGradient(data, coordSys) {
  var visualMetaList = data.getVisual('visualMeta');

  if (!visualMetaList || !visualMetaList.length || !data.count()) {
    // When data.count() is 0, gradient range can not be calculated.
    return;
  }

  if (coordSys.type !== 'cartesian2d') {
    return;
  }

  var coordDim;
  var visualMeta;

  for (var i = visualMetaList.length - 1; i >= 0; i--) {
    var dimIndex = visualMetaList[i].dimension;
    var dimName = data.dimensions[dimIndex];
    var dimInfo = data.getDimensionInfo(dimName);
    coordDim = dimInfo && dimInfo.coordDim; // Can only be x or y

    if (coordDim === 'x' || coordDim === 'y') {
      visualMeta = visualMetaList[i];
      break;
    }
  }

  if (!visualMeta) {
    return;
  } // If the area to be rendered is bigger than area defined by LinearGradient,
  // the canvas spec prescribes that the color of the first stop and the last
  // stop should be used. But if two stops are added at offset 0, in effect
  // browsers use the color of the second stop to render area outside
  // LinearGradient. So we can only infinitesimally extend area defined in
  // LinearGradient to render `outerColors`.


  var axis = coordSys.getAxis(coordDim); // dataToCoor mapping may not be linear, but must be monotonic.

  var colorStops = zrUtil.map(visualMeta.stops, function (stop) {
    return {
      coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
      color: stop.color
    };
  });
  var stopLen = colorStops.length;
  var outerColors = visualMeta.outerColors.slice();

  if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
    colorStops.reverse();
    outerColors.reverse();
  }

  var tinyExtent = 10; // Arbitrary value: 10px

  var minCoord = colorStops[0].coord - tinyExtent;
  var maxCoord = colorStops[stopLen - 1].coord + tinyExtent;
  var coordSpan = maxCoord - minCoord;

  if (coordSpan < 1e-3) {
    return 'transparent';
  }

  zrUtil.each(colorStops, function (stop) {
    stop.offset = (stop.coord - minCoord) / coordSpan;
  });
  colorStops.push({
    offset: stopLen ? colorStops[stopLen - 1].offset : 0.5,
    color: outerColors[1] || 'transparent'
  });
  colorStops.unshift({
    // notice colorStops.length have been changed.
    offset: stopLen ? colorStops[0].offset : 0.5,
    color: outerColors[0] || 'transparent'
  }); // zrUtil.each(colorStops, function (colorStop) {
  //     // Make sure each offset has rounded px to avoid not sharp edge
  //     colorStop.offset = (Math.round(colorStop.offset * (end - start) + start) - start) / (end - start);
  // });

  var gradient = new graphic.LinearGradient(0, 0, 0, 0, colorStops, true);
  gradient[coordDim] = minCoord;
  gradient[coordDim + '2'] = maxCoord;
  return gradient;
}

function getIsIgnoreFunc(seriesModel, data, coordSys) {
  var showAllSymbol = seriesModel.get('showAllSymbol');
  var isAuto = showAllSymbol === 'auto';

  if (showAllSymbol && !isAuto) {
    return;
  }

  var categoryAxis = coordSys.getAxesByScale('ordinal')[0];

  if (!categoryAxis) {
    return;
  } // Note that category label interval strategy might bring some weird effect
  // in some scenario: users may wonder why some of the symbols are not
  // displayed. So we show all symbols as possible as we can.


  if (isAuto // Simplify the logic, do not determine label overlap here.
  && canShowAllSymbolForCategory(categoryAxis, data)) {
    return;
  } // Otherwise follow the label interval strategy on category axis.


  var categoryDataDim = data.mapDimension(categoryAxis.dim);
  var labelMap = {};
  zrUtil.each(categoryAxis.getViewLabels(), function (labelItem) {
    labelMap[labelItem.tickValue] = 1;
  });
  return function (dataIndex) {
    return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
  };
}

function canShowAllSymbolForCategory(categoryAxis, data) {
  // In mose cases, line is monotonous on category axis, and the label size
  // is close with each other. So we check the symbol size and some of the
  // label size alone with the category axis to estimate whether all symbol
  // can be shown without overlap.
  var axisExtent = categoryAxis.getExtent();
  var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
  isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
  // Sampling some points, max 5.

  var dataLen = data.count();
  var step = Math.max(1, Math.round(dataLen / 5));

  for (var dataIndex = 0; dataIndex < dataLen; dataIndex += step) {
    if (SymbolClz.getSymbolSize(data, dataIndex // Only for cartesian, where `isHorizontal` exists.
    )[categoryAxis.isHorizontal() ? 1 : 0] // Empirical number
    * 1.5 > availSize) {
      return false;
    }
  }

  return true;
}

function createLineClipPath(coordSys, hasAnimation, seriesModel) {
  if (coordSys.type === 'cartesian2d') {
    var isHorizontal = coordSys.getBaseAxis().isHorizontal();
    var clipPath = createGridClipPath(coordSys, hasAnimation, seriesModel); // Expand clip shape to avoid clipping when line value exceeds axis

    if (!seriesModel.get('clip', true)) {
      var rectShape = clipPath.shape;
      var expandSize = Math.max(rectShape.width, rectShape.height);

      if (isHorizontal) {
        rectShape.y -= expandSize;
        rectShape.height += expandSize * 2;
      } else {
        rectShape.x -= expandSize;
        rectShape.width += expandSize * 2;
      }
    }

    return clipPath;
  } else {
    return createPolarClipPath(coordSys, hasAnimation, seriesModel);
  }
}

var _default = ChartView.extend({
  type: 'line',
  init: function () {
    var lineGroup = new graphic.Group();
    var symbolDraw = new SymbolDraw();
    this.group.add(symbolDraw.group);
    this._symbolDraw = symbolDraw;
    this._lineGroup = lineGroup;
  },
  render: function (seriesModel, ecModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var group = this.group;
    var data = seriesModel.getData();
    var lineStyleModel = seriesModel.getModel('lineStyle');
    var areaStyleModel = seriesModel.getModel('areaStyle');
    var points = data.mapArray(data.getItemLayout);
    var isCoordSysPolar = coordSys.type === 'polar';
    var prevCoordSys = this._coordSys;
    var symbolDraw = this._symbolDraw;
    var polyline = this._polyline;
    var polygon = this._polygon;
    var lineGroup = this._lineGroup;
    var hasAnimation = seriesModel.get('animation');
    var isAreaChart = !areaStyleModel.isEmpty();
    var valueOrigin = areaStyleModel.get('origin');
    var dataCoordInfo = prepareDataCoordInfo(coordSys, data, valueOrigin);
    var stackedOnPoints = getStackedOnPoints(coordSys, data, dataCoordInfo);
    var showSymbol = seriesModel.get('showSymbol');
    var isIgnoreFunc = showSymbol && !isCoordSysPolar && getIsIgnoreFunc(seriesModel, data, coordSys); // Remove temporary symbols

    var oldData = this._data;
    oldData && oldData.eachItemGraphicEl(function (el, idx) {
      if (el.__temp) {
        group.remove(el);
        oldData.setItemGraphicEl(idx, null);
      }
    }); // Remove previous created symbols if showSymbol changed to false

    if (!showSymbol) {
      symbolDraw.remove();
    }

    group.add(lineGroup); // FIXME step not support polar

    var step = !isCoordSysPolar && seriesModel.get('step');
    var clipShapeForSymbol;

    if (coordSys && coordSys.getArea && seriesModel.get('clip', true)) {
      clipShapeForSymbol = coordSys.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
      // See #7913 and `test/dataZoom-clip.html`.

      if (clipShapeForSymbol.width != null) {
        clipShapeForSymbol.x -= 0.1;
        clipShapeForSymbol.y -= 0.1;
        clipShapeForSymbol.width += 0.2;
        clipShapeForSymbol.height += 0.2;
      } else if (clipShapeForSymbol.r0) {
        clipShapeForSymbol.r0 -= 0.5;
        clipShapeForSymbol.r1 += 0.5;
      }
    }

    this._clipShapeForSymbol = clipShapeForSymbol; // Initialization animation or coordinate system changed

    if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
      showSymbol && symbolDraw.updateData(data, {
        isIgnore: isIgnoreFunc,
        clipShape: clipShapeForSymbol
      });

      if (step) {
        // TODO If stacked series is not step
        points = turnPointsIntoStep(points, coordSys, step);
        stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step);
      }

      polyline = this._newPolyline(points, coordSys, hasAnimation);

      if (isAreaChart) {
        polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
      }

      lineGroup.setClipPath(createLineClipPath(coordSys, true, seriesModel));
    } else {
      if (isAreaChart && !polygon) {
        // If areaStyle is added
        polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
      } else if (polygon && !isAreaChart) {
        // If areaStyle is removed
        lineGroup.remove(polygon);
        polygon = this._polygon = null;
      } // Update clipPath


      lineGroup.setClipPath(createLineClipPath(coordSys, false, seriesModel)); // Always update, or it is wrong in the case turning on legend
      // because points are not changed

      showSymbol && symbolDraw.updateData(data, {
        isIgnore: isIgnoreFunc,
        clipShape: clipShapeForSymbol
      }); // Stop symbol animation and sync with line points
      // FIXME performance?

      data.eachItemGraphicEl(function (el) {
        el.stopAnimation(true);
      }); // In the case data zoom triggerred refreshing frequently
      // Data may not change if line has a category axis. So it should animate nothing

      if (!isPointsSame(this._stackedOnPoints, stackedOnPoints) || !isPointsSame(this._points, points)) {
        if (hasAnimation) {
          this._updateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin);
        } else {
          // Not do it in update with animation
          if (step) {
            // TODO If stacked series is not step
            points = turnPointsIntoStep(points, coordSys, step);
            stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step);
          }

          polyline.setShape({
            points: points
          });
          polygon && polygon.setShape({
            points: points,
            stackedOnPoints: stackedOnPoints
          });
        }
      }
    }

    var visualColor = getVisualGradient(data, coordSys) || data.getVisual('color');
    polyline.useStyle(zrUtil.defaults( // Use color in lineStyle first
    lineStyleModel.getLineStyle(), {
      fill: 'none',
      stroke: visualColor,
      lineJoin: 'bevel'
    }));
    var smooth = seriesModel.get('smooth');
    smooth = getSmooth(seriesModel.get('smooth'));
    polyline.setShape({
      smooth: smooth,
      smoothMonotone: seriesModel.get('smoothMonotone'),
      connectNulls: seriesModel.get('connectNulls')
    });

    if (polygon) {
      var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
      var stackedOnSmooth = 0;
      polygon.useStyle(zrUtil.defaults(areaStyleModel.getAreaStyle(), {
        fill: visualColor,
        opacity: 0.7,
        lineJoin: 'bevel'
      }));

      if (stackedOnSeries) {
        stackedOnSmooth = getSmooth(stackedOnSeries.get('smooth'));
      }

      polygon.setShape({
        smooth: smooth,
        stackedOnSmooth: stackedOnSmooth,
        smoothMonotone: seriesModel.get('smoothMonotone'),
        connectNulls: seriesModel.get('connectNulls')
      });
    }

    this._data = data; // Save the coordinate system for transition animation when data changed

    this._coordSys = coordSys;
    this._stackedOnPoints = stackedOnPoints;
    this._points = points;
    this._step = step;
    this._valueOrigin = valueOrigin;
  },
  dispose: function () {},
  highlight: function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData();
    var dataIndex = modelUtil.queryDataIndex(data, payload);

    if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
      var symbol = data.getItemGraphicEl(dataIndex);

      if (!symbol) {
        // Create a temporary symbol if it is not exists
        var pt = data.getItemLayout(dataIndex);

        if (!pt) {
          // Null data
          return;
        } // fix #11360: should't draw symbol outside clipShapeForSymbol


        if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(pt[0], pt[1])) {
          return;
        }

        symbol = new SymbolClz(data, dataIndex);
        symbol.position = pt;
        symbol.setZ(seriesModel.get('zlevel'), seriesModel.get('z'));
        symbol.ignore = isNaN(pt[0]) || isNaN(pt[1]);
        symbol.__temp = true;
        data.setItemGraphicEl(dataIndex, symbol); // Stop scale animation

        symbol.stopSymbolAnimation(true);
        this.group.add(symbol);
      }

      symbol.highlight();
    } else {
      // Highlight whole series
      ChartView.prototype.highlight.call(this, seriesModel, ecModel, api, payload);
    }
  },
  downplay: function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData();
    var dataIndex = modelUtil.queryDataIndex(data, payload);

    if (dataIndex != null && dataIndex >= 0) {
      var symbol = data.getItemGraphicEl(dataIndex);

      if (symbol) {
        if (symbol.__temp) {
          data.setItemGraphicEl(dataIndex, null);
          this.group.remove(symbol);
        } else {
          symbol.downplay();
        }
      }
    } else {
      // FIXME
      // can not downplay completely.
      // Downplay whole series
      ChartView.prototype.downplay.call(this, seriesModel, ecModel, api, payload);
    }
  },

  /**
   * @param {module:zrender/container/Group} group
   * @param {Array.<Array.<number>>} points
   * @private
   */
  _newPolyline: function (points) {
    var polyline = this._polyline; // Remove previous created polyline

    if (polyline) {
      this._lineGroup.remove(polyline);
    }

    polyline = new Polyline({
      shape: {
        points: points
      },
      silent: true,
      z2: 10
    });

    this._lineGroup.add(polyline);

    this._polyline = polyline;
    return polyline;
  },

  /**
   * @param {module:zrender/container/Group} group
   * @param {Array.<Array.<number>>} stackedOnPoints
   * @param {Array.<Array.<number>>} points
   * @private
   */
  _newPolygon: function (points, stackedOnPoints) {
    var polygon = this._polygon; // Remove previous created polygon

    if (polygon) {
      this._lineGroup.remove(polygon);
    }

    polygon = new Polygon({
      shape: {
        points: points,
        stackedOnPoints: stackedOnPoints
      },
      silent: true
    });

    this._lineGroup.add(polygon);

    this._polygon = polygon;
    return polygon;
  },

  /**
   * @private
   */
  // FIXME Two value axis
  _updateAnimation: function (data, stackedOnPoints, coordSys, api, step, valueOrigin) {
    var polyline = this._polyline;
    var polygon = this._polygon;
    var seriesModel = data.hostModel;
    var diff = lineAnimationDiff(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
    var current = diff.current;
    var stackedOnCurrent = diff.stackedOnCurrent;
    var next = diff.next;
    var stackedOnNext = diff.stackedOnNext;

    if (step) {
      // TODO If stacked series is not step
      current = turnPointsIntoStep(diff.current, coordSys, step);
      stackedOnCurrent = turnPointsIntoStep(diff.stackedOnCurrent, coordSys, step);
      next = turnPointsIntoStep(diff.next, coordSys, step);
      stackedOnNext = turnPointsIntoStep(diff.stackedOnNext, coordSys, step);
    } // Don't apply animation if diff is large.
    // For better result and avoid memory explosion problems like
    // https://github.com/apache/incubator-echarts/issues/12229


    if (getBoundingDiff(current, next) > 3000 || polygon && getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
      polyline.setShape({
        points: next
      });

      if (polygon) {
        polygon.setShape({
          points: next,
          stackedOnPoints: stackedOnNext
        });
      }

      return;
    } // `diff.current` is subset of `current` (which should be ensured by
    // turnPointsIntoStep), so points in `__points` can be updated when
    // points in `current` are update during animation.


    polyline.shape.__points = diff.current;
    polyline.shape.points = current;
    graphic.updateProps(polyline, {
      shape: {
        points: next
      }
    }, seriesModel);

    if (polygon) {
      polygon.setShape({
        points: current,
        stackedOnPoints: stackedOnCurrent
      });
      graphic.updateProps(polygon, {
        shape: {
          points: next,
          stackedOnPoints: stackedOnNext
        }
      }, seriesModel);
    }

    var updatedDataInfo = [];
    var diffStatus = diff.status;

    for (var i = 0; i < diffStatus.length; i++) {
      var cmd = diffStatus[i].cmd;

      if (cmd === '=') {
        var el = data.getItemGraphicEl(diffStatus[i].idx1);

        if (el) {
          updatedDataInfo.push({
            el: el,
            ptIdx: i // Index of points

          });
        }
      }
    }

    if (polyline.animators && polyline.animators.length) {
      polyline.animators[0].during(function () {
        for (var i = 0; i < updatedDataInfo.length; i++) {
          var el = updatedDataInfo[i].el;
          el.attr('position', polyline.shape.__points[updatedDataInfo[i].ptIdx]);
        }
      });
    }
  },
  remove: function (ecModel) {
    var group = this.group;
    var oldData = this._data;

    this._lineGroup.removeAll();

    this._symbolDraw.remove(true); // Remove temporary created elements when highlighting


    oldData && oldData.eachItemGraphicEl(function (el, idx) {
      if (el.__temp) {
        group.remove(el);
        oldData.setItemGraphicEl(idx, null);
      }
    });
    this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._data = null;
  }
});

module.exports = _default;

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _helper = __webpack_require__(648);

var prepareDataCoordInfo = _helper.prepareDataCoordInfo;
var getStackedOnPoint = _helper.getStackedOnPoint;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// var arrayDiff = require('zrender/src/core/arrayDiff');
// 'zrender/src/core/arrayDiff' has been used before, but it did
// not do well in performance when roam with fixed dataZoom window.
// function convertToIntId(newIdList, oldIdList) {
//     // Generate int id instead of string id.
//     // Compare string maybe slow in score function of arrDiff
//     // Assume id in idList are all unique
//     var idIndicesMap = {};
//     var idx = 0;
//     for (var i = 0; i < newIdList.length; i++) {
//         idIndicesMap[newIdList[i]] = idx;
//         newIdList[i] = idx++;
//     }
//     for (var i = 0; i < oldIdList.length; i++) {
//         var oldId = oldIdList[i];
//         // Same with newIdList
//         if (idIndicesMap[oldId]) {
//             oldIdList[i] = idIndicesMap[oldId];
//         }
//         else {
//             oldIdList[i] = idx++;
//         }
//     }
// }
function diffData(oldData, newData) {
  var diffResult = [];
  newData.diff(oldData).add(function (idx) {
    diffResult.push({
      cmd: '+',
      idx: idx
    });
  }).update(function (newIdx, oldIdx) {
    diffResult.push({
      cmd: '=',
      idx: oldIdx,
      idx1: newIdx
    });
  }).remove(function (idx) {
    diffResult.push({
      cmd: '-',
      idx: idx
    });
  }).execute();
  return diffResult;
}

function _default(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
  var diff = diffData(oldData, newData); // var newIdList = newData.mapArray(newData.getId);
  // var oldIdList = oldData.mapArray(oldData.getId);
  // convertToIntId(newIdList, oldIdList);
  // // FIXME One data ?
  // diff = arrayDiff(oldIdList, newIdList);

  var currPoints = [];
  var nextPoints = []; // Points for stacking base line

  var currStackedPoints = [];
  var nextStackedPoints = [];
  var status = [];
  var sortedIndices = [];
  var rawIndices = [];
  var newDataOldCoordInfo = prepareDataCoordInfo(oldCoordSys, newData, oldValueOrigin);
  var oldDataNewCoordInfo = prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);

  for (var i = 0; i < diff.length; i++) {
    var diffItem = diff[i];
    var pointAdded = true; // FIXME, animation is not so perfect when dataZoom window moves fast
    // Which is in case remvoing or add more than one data in the tail or head

    switch (diffItem.cmd) {
      case '=':
        var currentPt = oldData.getItemLayout(diffItem.idx);
        var nextPt = newData.getItemLayout(diffItem.idx1); // If previous data is NaN, use next point directly

        if (isNaN(currentPt[0]) || isNaN(currentPt[1])) {
          currentPt = nextPt.slice();
        }

        currPoints.push(currentPt);
        nextPoints.push(nextPt);
        currStackedPoints.push(oldStackedOnPoints[diffItem.idx]);
        nextStackedPoints.push(newStackedOnPoints[diffItem.idx1]);
        rawIndices.push(newData.getRawIndex(diffItem.idx1));
        break;

      case '+':
        var idx = diffItem.idx;
        currPoints.push(oldCoordSys.dataToPoint([newData.get(newDataOldCoordInfo.dataDimsForPoint[0], idx), newData.get(newDataOldCoordInfo.dataDimsForPoint[1], idx)]));
        nextPoints.push(newData.getItemLayout(idx).slice());
        currStackedPoints.push(getStackedOnPoint(newDataOldCoordInfo, oldCoordSys, newData, idx));
        nextStackedPoints.push(newStackedOnPoints[idx]);
        rawIndices.push(newData.getRawIndex(idx));
        break;

      case '-':
        var idx = diffItem.idx;
        var rawIndex = oldData.getRawIndex(idx); // Data is replaced. In the case of dynamic data queue
        // FIXME FIXME FIXME

        if (rawIndex !== idx) {
          currPoints.push(oldData.getItemLayout(idx));
          nextPoints.push(newCoordSys.dataToPoint([oldData.get(oldDataNewCoordInfo.dataDimsForPoint[0], idx), oldData.get(oldDataNewCoordInfo.dataDimsForPoint[1], idx)]));
          currStackedPoints.push(oldStackedOnPoints[idx]);
          nextStackedPoints.push(getStackedOnPoint(oldDataNewCoordInfo, newCoordSys, oldData, idx));
          rawIndices.push(rawIndex);
        } else {
          pointAdded = false;
        }

    } // Original indices


    if (pointAdded) {
      status.push(diffItem);
      sortedIndices.push(sortedIndices.length);
    }
  } // Diff result may be crossed if all items are changed
  // Sort by data index


  sortedIndices.sort(function (a, b) {
    return rawIndices[a] - rawIndices[b];
  });
  var sortedCurrPoints = [];
  var sortedNextPoints = [];
  var sortedCurrStackedPoints = [];
  var sortedNextStackedPoints = [];
  var sortedStatus = [];

  for (var i = 0; i < sortedIndices.length; i++) {
    var idx = sortedIndices[i];
    sortedCurrPoints[i] = currPoints[idx];
    sortedNextPoints[i] = nextPoints[idx];
    sortedCurrStackedPoints[i] = currStackedPoints[idx];
    sortedNextStackedPoints[i] = nextStackedPoints[idx];
    sortedStatus[i] = status[idx];
  }

  return {
    current: sortedCurrPoints,
    next: sortedNextPoints,
    stackedOnCurrent: sortedCurrStackedPoints,
    stackedOnNext: sortedNextStackedPoints,
    status: sortedStatus
  };
}

module.exports = _default;

/***/ }),
/* 1576 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var samplers = {
  average: function (frame) {
    var sum = 0;
    var count = 0;

    for (var i = 0; i < frame.length; i++) {
      if (!isNaN(frame[i])) {
        sum += frame[i];
        count++;
      }
    } // Return NaN if count is 0


    return count === 0 ? NaN : sum / count;
  },
  sum: function (frame) {
    var sum = 0;

    for (var i = 0; i < frame.length; i++) {
      // Ignore NaN
      sum += frame[i] || 0;
    }

    return sum;
  },
  max: function (frame) {
    var max = -Infinity;

    for (var i = 0; i < frame.length; i++) {
      frame[i] > max && (max = frame[i]);
    } // NaN will cause illegal axis extent.


    return isFinite(max) ? max : NaN;
  },
  min: function (frame) {
    var min = Infinity;

    for (var i = 0; i < frame.length; i++) {
      frame[i] < min && (min = frame[i]);
    } // NaN will cause illegal axis extent.


    return isFinite(min) ? min : NaN;
  },
  // TODO
  // Median
  nearest: function (frame) {
    return frame[0];
  }
};

var indexSampler = function (frame, value) {
  return Math.round(frame.length / 2);
};

function _default(seriesType) {
  return {
    seriesType: seriesType,
    modifyOutputEnd: true,
    reset: function (seriesModel, ecModel, api) {
      var data = seriesModel.getData();
      var sampling = seriesModel.get('sampling');
      var coordSys = seriesModel.coordinateSystem; // Only cartesian2d support down sampling

      if (coordSys.type === 'cartesian2d' && sampling) {
        var baseAxis = coordSys.getBaseAxis();
        var valueAxis = coordSys.getOtherAxis(baseAxis);
        var extent = baseAxis.getExtent(); // Coordinste system has been resized

        var size = Math.abs(extent[1] - extent[0]);
        var rate = Math.round(data.count() / size);

        if (rate > 1) {
          var sampler;

          if (typeof sampling === 'string') {
            sampler = samplers[sampling];
          } else if (typeof sampling === 'function') {
            sampler = sampling;
          }

          if (sampler) {
            // Only support sample the first dim mapped from value axis.
            seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, indexSampler));
          }
        }
      }
    }
  };
}

module.exports = _default;

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var BoundingRect = __webpack_require__(57);

var Cartesian = __webpack_require__(1578);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function Cartesian2D(name) {
  Cartesian.call(this, name);
}

Cartesian2D.prototype = {
  constructor: Cartesian2D,
  type: 'cartesian2d',

  /**
   * @type {Array.<string>}
   * @readOnly
   */
  dimensions: ['x', 'y'],

  /**
   * Base axis will be used on stacking.
   *
   * @return {module:echarts/coord/cartesian/Axis2D}
   */
  getBaseAxis: function () {
    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
  },

  /**
   * If contain point
   * @param {Array.<number>} point
   * @return {boolean}
   */
  containPoint: function (point) {
    var axisX = this.getAxis('x');
    var axisY = this.getAxis('y');
    return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
  },

  /**
   * If contain data
   * @param {Array.<number>} data
   * @return {boolean}
   */
  containData: function (data) {
    return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
  },

  /**
   * @param {Array.<number>} data
   * @param {Array.<number>} out
   * @return {Array.<number>}
   */
  dataToPoint: function (data, reserved, out) {
    var xAxis = this.getAxis('x');
    var yAxis = this.getAxis('y');
    out = out || [];
    out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(data[0]));
    out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(data[1]));
    return out;
  },

  /**
   * @param {Array.<number>} data
   * @param {Array.<number>} out
   * @return {Array.<number>}
   */
  clampData: function (data, out) {
    var xScale = this.getAxis('x').scale;
    var yScale = this.getAxis('y').scale;
    var xAxisExtent = xScale.getExtent();
    var yAxisExtent = yScale.getExtent();
    var x = xScale.parse(data[0]);
    var y = yScale.parse(data[1]);
    out = out || [];
    out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
    out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
    return out;
  },

  /**
   * @param {Array.<number>} point
   * @param {Array.<number>} out
   * @return {Array.<number>}
   */
  pointToData: function (point, out) {
    var xAxis = this.getAxis('x');
    var yAxis = this.getAxis('y');
    out = out || [];
    out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]));
    out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]));
    return out;
  },

  /**
   * Get other axis
   * @param {module:echarts/coord/cartesian/Axis2D} axis
   */
  getOtherAxis: function (axis) {
    return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
  },

  /**
   * Get rect area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   * @return {BoundingRect}
   */
  getArea: function () {
    var xExtent = this.getAxis('x').getGlobalExtent();
    var yExtent = this.getAxis('y').getGlobalExtent();
    var x = Math.min(xExtent[0], xExtent[1]);
    var y = Math.min(yExtent[0], yExtent[1]);
    var width = Math.max(xExtent[0], xExtent[1]) - x;
    var height = Math.max(yExtent[0], yExtent[1]) - y;
    var rect = new BoundingRect(x, y, width, height);
    return rect;
  }
};
zrUtil.inherits(Cartesian2D, Cartesian);
var _default = Cartesian2D;
module.exports = _default;

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Cartesian coordinate system
 * @module  echarts/coord/Cartesian
 *
 */
function dimAxisMapper(dim) {
  return this._axes[dim];
}
/**
 * @alias module:echarts/coord/Cartesian
 * @constructor
 */


var Cartesian = function (name) {
  this._axes = {};
  this._dimList = [];
  /**
   * @type {string}
   */

  this.name = name || '';
};

Cartesian.prototype = {
  constructor: Cartesian,
  type: 'cartesian',

  /**
   * Get axis
   * @param  {number|string} dim
   * @return {module:echarts/coord/Cartesian~Axis}
   */
  getAxis: function (dim) {
    return this._axes[dim];
  },

  /**
   * Get axes list
   * @return {Array.<module:echarts/coord/Cartesian~Axis>}
   */
  getAxes: function () {
    return zrUtil.map(this._dimList, dimAxisMapper, this);
  },

  /**
   * Get axes list by given scale type
   */
  getAxesByScale: function (scaleType) {
    scaleType = scaleType.toLowerCase();
    return zrUtil.filter(this.getAxes(), function (axis) {
      return axis.scale.type === scaleType;
    });
  },

  /**
   * Add axis
   * @param {module:echarts/coord/Cartesian.Axis}
   */
  addAxis: function (axis) {
    var dim = axis.dim;
    this._axes[dim] = axis;

    this._dimList.push(dim);
  },

  /**
   * Convert data to coord in nd space
   * @param {Array.<number>|Object.<string, number>} val
   * @return {Array.<number>|Object.<string, number>}
   */
  dataToCoord: function (val) {
    return this._dataCoordConvert(val, 'dataToCoord');
  },

  /**
   * Convert coord in nd space to data
   * @param  {Array.<number>|Object.<string, number>} val
   * @return {Array.<number>|Object.<string, number>}
   */
  coordToData: function (val) {
    return this._dataCoordConvert(val, 'coordToData');
  },
  _dataCoordConvert: function (input, method) {
    var dimList = this._dimList;
    var output = input instanceof Array ? [] : {};

    for (var i = 0; i < dimList.length; i++) {
      var dim = dimList[i];
      var axis = this._axes[dim];
      output[dim] = axis[method](input[dim]);
    }

    return output;
  }
};
var _default = Cartesian;
module.exports = _default;

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var Axis = __webpack_require__(150);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Extend axis 2d
 * @constructor module:echarts/coord/cartesian/Axis2D
 * @extends {module:echarts/coord/cartesian/Axis}
 * @param {string} dim
 * @param {*} scale
 * @param {Array.<number>} coordExtent
 * @param {string} axisType
 * @param {string} position
 */
var Axis2D = function (dim, scale, coordExtent, axisType, position) {
  Axis.call(this, dim, scale, coordExtent);
  /**
   * Axis type
   *  - 'category'
   *  - 'value'
   *  - 'time'
   *  - 'log'
   * @type {string}
   */

  this.type = axisType || 'value';
  /**
   * Axis position
   *  - 'top'
   *  - 'bottom'
   *  - 'left'
   *  - 'right'
   */

  this.position = position || 'bottom';
};

Axis2D.prototype = {
  constructor: Axis2D,

  /**
   * Index of axis, can be used as key
   */
  index: 0,

  /**
   * Implemented in <module:echarts/coord/cartesian/Grid>.
   * @return {Array.<module:echarts/coord/cartesian/Axis2D>}
   *         If not on zero of other axis, return null/undefined.
   *         If no axes, return an empty array.
   */
  getAxesOnZeroOf: null,

  /**
   * Axis model
   * @param {module:echarts/coord/cartesian/AxisModel}
   */
  model: null,
  isHorizontal: function () {
    var position = this.position;
    return position === 'top' || position === 'bottom';
  },

  /**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */
  getGlobalExtent: function (asc) {
    var ret = this.getExtent();
    ret[0] = this.toGlobalCoord(ret[0]);
    ret[1] = this.toGlobalCoord(ret[1]);
    asc && ret[0] > ret[1] && ret.reverse();
    return ret;
  },
  getOtherAxis: function () {
    this.grid.getOtherAxis();
  },

  /**
   * @override
   */
  pointToData: function (point, clamp) {
    return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
  },

  /**
   * Transform global coord to local coord,
   * i.e. var localCoord = axis.toLocalCoord(80);
   * designate by module:echarts/coord/cartesian/Grid.
   * @type {Function}
   */
  toLocalCoord: null,

  /**
   * Transform global coord to local coord,
   * i.e. var globalCoord = axis.toLocalCoord(40);
   * designate by module:echarts/coord/cartesian/Grid.
   * @type {Function}
   */
  toGlobalCoord: null
};
zrUtil.inherits(Axis2D, Axis);
var _default = Axis2D;
module.exports = _default;

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

__webpack_require__(650);

var ComponentModel = __webpack_require__(73);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Grid 是在有直角坐标系的时候必须要存在的
// 所以这里也要被 Cartesian2D 依赖
var _default = ComponentModel.extend({
  type: 'grid',
  dependencies: ['xAxis', 'yAxis'],
  layoutMode: 'box',

  /**
   * @type {module:echarts/coord/cartesian/Grid}
   */
  coordinateSystem: null,
  defaultOption: {
    show: false,
    zlevel: 0,
    z: 0,
    left: '10%',
    top: 60,
    right: '10%',
    bottom: 60,
    // If grid size contain label
    containLabel: false,
    // width: {totalWidth} - left - right,
    // height: {totalHeight} - top - bottom,
    backgroundColor: 'rgba(0,0,0,0)',
    borderWidth: 1,
    borderColor: '#ccc'
  }
});

module.exports = _default;

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

__webpack_require__(650);

__webpack_require__(1582);

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var graphic = __webpack_require__(27);

var AxisBuilder = __webpack_require__(151);

var AxisView = __webpack_require__(179);

var cartesianAxisHelper = __webpack_require__(652);

var _axisSplitHelper = __webpack_require__(653);

var rectCoordAxisBuildSplitArea = _axisSplitHelper.rectCoordAxisBuildSplitArea;
var rectCoordAxisHandleRemove = _axisSplitHelper.rectCoordAxisHandleRemove;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
var selfBuilderAttrs = ['splitArea', 'splitLine', 'minorSplitLine'];
var CartesianAxisView = AxisView.extend({
  type: 'cartesianAxis',
  axisPointerClass: 'CartesianAxisPointer',

  /**
   * @override
   */
  render: function (axisModel, ecModel, api, payload) {
    this.group.removeAll();
    var oldAxisGroup = this._axisGroup;
    this._axisGroup = new graphic.Group();
    this.group.add(this._axisGroup);

    if (!axisModel.get('show')) {
      return;
    }

    var gridModel = axisModel.getCoordSysModel();
    var layout = cartesianAxisHelper.layout(gridModel, axisModel);
    var axisBuilder = new AxisBuilder(axisModel, layout);
    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);

    this._axisGroup.add(axisBuilder.getGroup());

    zrUtil.each(selfBuilderAttrs, function (name) {
      if (axisModel.get(name + '.show')) {
        this['_' + name](axisModel, gridModel);
      }
    }, this);
    graphic.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
    CartesianAxisView.superCall(this, 'render', axisModel, ecModel, api, payload);
  },
  remove: function () {
    rectCoordAxisHandleRemove(this);
  },

  /**
   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
   * @param {module:echarts/coord/cartesian/GridModel} gridModel
   * @private
   */
  _splitLine: function (axisModel, gridModel) {
    var axis = axisModel.axis;

    if (axis.scale.isBlank()) {
      return;
    }

    var splitLineModel = axisModel.getModel('splitLine');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var lineColors = lineStyleModel.get('color');
    lineColors = zrUtil.isArray(lineColors) ? lineColors : [lineColors];
    var gridRect = gridModel.coordinateSystem.getRect();
    var isHorizontal = axis.isHorizontal();
    var lineCount = 0;
    var ticksCoords = axis.getTicksCoords({
      tickModel: splitLineModel
    });
    var p1 = [];
    var p2 = [];
    var lineStyle = lineStyleModel.getLineStyle();

    for (var i = 0; i < ticksCoords.length; i++) {
      var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);

      if (isHorizontal) {
        p1[0] = tickCoord;
        p1[1] = gridRect.y;
        p2[0] = tickCoord;
        p2[1] = gridRect.y + gridRect.height;
      } else {
        p1[0] = gridRect.x;
        p1[1] = tickCoord;
        p2[0] = gridRect.x + gridRect.width;
        p2[1] = tickCoord;
      }

      var colorIndex = lineCount++ % lineColors.length;
      var tickValue = ticksCoords[i].tickValue;

      this._axisGroup.add(new graphic.Line({
        anid: tickValue != null ? 'line_' + ticksCoords[i].tickValue : null,
        subPixelOptimize: true,
        shape: {
          x1: p1[0],
          y1: p1[1],
          x2: p2[0],
          y2: p2[1]
        },
        style: zrUtil.defaults({
          stroke: lineColors[colorIndex]
        }, lineStyle),
        silent: true
      }));
    }
  },

  /**
   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
   * @param {module:echarts/coord/cartesian/GridModel} gridModel
   * @private
   */
  _minorSplitLine: function (axisModel, gridModel) {
    var axis = axisModel.axis;
    var minorSplitLineModel = axisModel.getModel('minorSplitLine');
    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
    var gridRect = gridModel.coordinateSystem.getRect();
    var isHorizontal = axis.isHorizontal();
    var minorTicksCoords = axis.getMinorTicksCoords();

    if (!minorTicksCoords.length) {
      return;
    }

    var p1 = [];
    var p2 = [];
    var lineStyle = lineStyleModel.getLineStyle();

    for (var i = 0; i < minorTicksCoords.length; i++) {
      for (var k = 0; k < minorTicksCoords[i].length; k++) {
        var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);

        if (isHorizontal) {
          p1[0] = tickCoord;
          p1[1] = gridRect.y;
          p2[0] = tickCoord;
          p2[1] = gridRect.y + gridRect.height;
        } else {
          p1[0] = gridRect.x;
          p1[1] = tickCoord;
          p2[0] = gridRect.x + gridRect.width;
          p2[1] = tickCoord;
        }

        this._axisGroup.add(new graphic.Line({
          anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
          subPixelOptimize: true,
          shape: {
            x1: p1[0],
            y1: p1[1],
            x2: p2[0],
            y2: p2[1]
          },
          style: lineStyle,
          silent: true
        }));
      }
    }
  },

  /**
   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
   * @param {module:echarts/coord/cartesian/GridModel} gridModel
   * @private
   */
  _splitArea: function (axisModel, gridModel) {
    rectCoordAxisBuildSplitArea(this, this._axisGroup, axisModel, gridModel);
  }
});
CartesianAxisView.extend({
  type: 'xAxis'
});
CartesianAxisView.extend({
  type: 'yAxis'
});

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var _barGrid = __webpack_require__(300);

var layout = _barGrid.layout;
var largeLayout = _barGrid.largeLayout;

__webpack_require__(415);

__webpack_require__(1584);

__webpack_require__(1585);

__webpack_require__(242);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// In case developer forget to include grid component
echarts.registerLayout(echarts.PRIORITY.VISUAL.LAYOUT, zrUtil.curry(layout, 'bar')); // Use higher prority to avoid to be blocked by other overall layout, which do not
// only exist in this module, but probably also exist in other modules, like `barPolar`.

echarts.registerLayout(echarts.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, largeLayout);
echarts.registerVisual({
  seriesType: 'bar',
  reset: function (seriesModel) {
    // Visual coding for legend
    seriesModel.getData().setVisual('legendSymbol', 'roundRect');
  }
});

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var BaseBarSeries = __webpack_require__(654);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = BaseBarSeries.extend({
  type: 'series.bar',
  dependencies: ['grid', 'polar'],
  brushSelector: 'rect',

  /**
   * @override
   */
  getProgressive: function () {
    // Do not support progressive in normal mode.
    return this.get('large') ? this.get('progressive') : false;
  },

  /**
   * @override
   */
  getProgressiveThreshold: function () {
    // Do not support progressive in normal mode.
    var progressiveThreshold = this.get('progressiveThreshold');
    var largeThreshold = this.get('largeThreshold');

    if (largeThreshold > progressiveThreshold) {
      progressiveThreshold = largeThreshold;
    }

    return progressiveThreshold;
  },
  defaultOption: {
    // If clipped
    // Only available on cartesian2d
    clip: true,
    // If use caps on two sides of bars
    // Only available on tangential polar bar
    roundCap: false,
    showBackground: false,
    backgroundStyle: {
      color: 'rgba(180, 180, 180, 0.2)',
      borderColor: null,
      borderWidth: 0,
      borderType: 'solid',
      borderRadius: 0,
      shadowBlur: 0,
      shadowColor: null,
      shadowOffsetX: 0,
      shadowOffsetY: 0,
      opacity: 1
    }
  }
});

module.exports = _default;

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var graphic = __webpack_require__(27);

var _helper = __webpack_require__(655);

var setLabel = _helper.setLabel;

var Model = __webpack_require__(68);

var barItemStyle = __webpack_require__(1586);

var Path = __webpack_require__(65);

var Group = __webpack_require__(174);

var _throttle = __webpack_require__(148);

var throttle = _throttle.throttle;

var _createClipPathFromCoordSys = __webpack_require__(240);

var createClipPath = _createClipPathFromCoordSys.createClipPath;

var Sausage = __webpack_require__(1587);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var BAR_BORDER_WIDTH_QUERY = ['itemStyle', 'barBorderWidth'];
var _eventPos = [0, 0]; // FIXME
// Just for compatible with ec2.

zrUtil.extend(Model.prototype, barItemStyle);

function getClipArea(coord, data) {
  var coordSysClipArea = coord.getArea && coord.getArea();

  if (coord.type === 'cartesian2d') {
    var baseAxis = coord.getBaseAxis(); // When boundaryGap is false or using time axis. bar may exceed the grid.
    // We should not clip this part.
    // See test/bar2.html

    if (baseAxis.type !== 'category' || !baseAxis.onBand) {
      var expandWidth = data.getLayout('bandWidth');

      if (baseAxis.isHorizontal()) {
        coordSysClipArea.x -= expandWidth;
        coordSysClipArea.width += expandWidth * 2;
      } else {
        coordSysClipArea.y -= expandWidth;
        coordSysClipArea.height += expandWidth * 2;
      }
    }
  }

  return coordSysClipArea;
}

var _default = echarts.extendChartView({
  type: 'bar',
  render: function (seriesModel, ecModel, api) {
    this._updateDrawMode(seriesModel);

    var coordinateSystemType = seriesModel.get('coordinateSystem');

    if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') {
      this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api);
    } else {}

    return this.group;
  },
  incrementalPrepareRender: function (seriesModel, ecModel, api) {
    this._clear();

    this._updateDrawMode(seriesModel);
  },
  incrementalRender: function (params, seriesModel, ecModel, api) {
    // Do not support progressive in normal mode.
    this._incrementalRenderLarge(params, seriesModel);
  },
  _updateDrawMode: function (seriesModel) {
    var isLargeDraw = seriesModel.pipelineContext.large;

    if (this._isLargeDraw == null || isLargeDraw ^ this._isLargeDraw) {
      this._isLargeDraw = isLargeDraw;

      this._clear();
    }
  },
  _renderNormal: function (seriesModel, ecModel, api) {
    var group = this.group;
    var data = seriesModel.getData();
    var oldData = this._data;
    var coord = seriesModel.coordinateSystem;
    var baseAxis = coord.getBaseAxis();
    var isHorizontalOrRadial;

    if (coord.type === 'cartesian2d') {
      isHorizontalOrRadial = baseAxis.isHorizontal();
    } else if (coord.type === 'polar') {
      isHorizontalOrRadial = baseAxis.dim === 'angle';
    }

    var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
    var needsClip = seriesModel.get('clip', true);
    var coordSysClipArea = getClipArea(coord, data); // If there is clipPath created in large mode. Remove it.

    group.removeClipPath(); // We don't use clipPath in normal mode because we needs a perfect animation
    // And don't want the label are clipped.

    var roundCap = seriesModel.get('roundCap', true);
    var drawBackground = seriesModel.get('showBackground', true);
    var backgroundModel = seriesModel.getModel('backgroundStyle');
    var barBorderRadius = backgroundModel.get('barBorderRadius') || 0;
    var bgEls = [];
    var oldBgEls = this._backgroundEls || [];

    var createBackground = function (dataIndex) {
      var bgLayout = getLayout[coord.type](data, dataIndex);
      var bgEl = createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
      bgEl.useStyle(backgroundModel.getBarItemStyle()); // Only cartesian2d support borderRadius.

      if (coord.type === 'cartesian2d') {
        bgEl.setShape('r', barBorderRadius);
      }

      bgEls[dataIndex] = bgEl;
      return bgEl;
    };

    data.diff(oldData).add(function (dataIndex) {
      var itemModel = data.getItemModel(dataIndex);
      var layout = getLayout[coord.type](data, dataIndex, itemModel);

      if (drawBackground) {
        createBackground(dataIndex);
      } // If dataZoom in filteMode: 'empty', the baseValue can be set as NaN in "axisProxy".


      if (!data.hasValue(dataIndex)) {
        return;
      }

      if (needsClip) {
        // Clip will modify the layout params.
        // And return a boolean to determine if the shape are fully clipped.
        var isClipped = clip[coord.type](coordSysClipArea, layout);

        if (isClipped) {
          group.remove(el);
          return;
        }
      }

      var el = elementCreator[coord.type](dataIndex, layout, isHorizontalOrRadial, animationModel, false, roundCap);
      data.setItemGraphicEl(dataIndex, el);
      group.add(el);
      updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
    }).update(function (newIndex, oldIndex) {
      var itemModel = data.getItemModel(newIndex);
      var layout = getLayout[coord.type](data, newIndex, itemModel);

      if (drawBackground) {
        var bgEl;

        if (oldBgEls.length === 0) {
          bgEl = createBackground(oldIndex);
        } else {
          bgEl = oldBgEls[oldIndex];
          bgEl.useStyle(backgroundModel.getBarItemStyle()); // Only cartesian2d support borderRadius.

          if (coord.type === 'cartesian2d') {
            bgEl.setShape('r', barBorderRadius);
          }

          bgEls[newIndex] = bgEl;
        }

        var bgLayout = getLayout[coord.type](data, newIndex);
        var shape = createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
        graphic.updateProps(bgEl, {
          shape: shape
        }, animationModel, newIndex);
      }

      var el = oldData.getItemGraphicEl(oldIndex);

      if (!data.hasValue(newIndex)) {
        group.remove(el);
        return;
      }

      if (needsClip) {
        var isClipped = clip[coord.type](coordSysClipArea, layout);

        if (isClipped) {
          group.remove(el);
          return;
        }
      }

      if (el) {
        graphic.updateProps(el, {
          shape: layout
        }, animationModel, newIndex);
      } else {
        el = elementCreator[coord.type](newIndex, layout, isHorizontalOrRadial, animationModel, true, roundCap);
      }

      data.setItemGraphicEl(newIndex, el); // Add back

      group.add(el);
      updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
    }).remove(function (dataIndex) {
      var el = oldData.getItemGraphicEl(dataIndex);

      if (coord.type === 'cartesian2d') {
        el && removeRect(dataIndex, animationModel, el);
      } else {
        el && removeSector(dataIndex, animationModel, el);
      }
    }).execute();
    var bgGroup = this._backgroundGroup || (this._backgroundGroup = new Group());
    bgGroup.removeAll();

    for (var i = 0; i < bgEls.length; ++i) {
      bgGroup.add(bgEls[i]);
    }

    group.add(bgGroup);
    this._backgroundEls = bgEls;
    this._data = data;
  },
  _renderLarge: function (seriesModel, ecModel, api) {
    this._clear();

    createLarge(seriesModel, this.group); // Use clipPath in large mode.

    var clipPath = seriesModel.get('clip', true) ? createClipPath(seriesModel.coordinateSystem, false, seriesModel) : null;

    if (clipPath) {
      this.group.setClipPath(clipPath);
    } else {
      this.group.removeClipPath();
    }
  },
  _incrementalRenderLarge: function (params, seriesModel) {
    this._removeBackground();

    createLarge(seriesModel, this.group, true);
  },
  dispose: zrUtil.noop,
  remove: function (ecModel) {
    this._clear(ecModel);
  },
  _clear: function (ecModel) {
    var group = this.group;
    var data = this._data;

    if (ecModel && ecModel.get('animation') && data && !this._isLargeDraw) {
      this._removeBackground();

      this._backgroundEls = [];
      data.eachItemGraphicEl(function (el) {
        if (el.type === 'sector') {
          removeSector(el.dataIndex, ecModel, el);
        } else {
          removeRect(el.dataIndex, ecModel, el);
        }
      });
    } else {
      group.removeAll();
    }

    this._data = null;
  },
  _removeBackground: function () {
    this.group.remove(this._backgroundGroup);
    this._backgroundGroup = null;
  }
});

var mathMax = Math.max;
var mathMin = Math.min;
var clip = {
  cartesian2d: function (coordSysBoundingRect, layout) {
    var signWidth = layout.width < 0 ? -1 : 1;
    var signHeight = layout.height < 0 ? -1 : 1; // Needs positive width and height

    if (signWidth < 0) {
      layout.x += layout.width;
      layout.width = -layout.width;
    }

    if (signHeight < 0) {
      layout.y += layout.height;
      layout.height = -layout.height;
    }

    var x = mathMax(layout.x, coordSysBoundingRect.x);
    var x2 = mathMin(layout.x + layout.width, coordSysBoundingRect.x + coordSysBoundingRect.width);
    var y = mathMax(layout.y, coordSysBoundingRect.y);
    var y2 = mathMin(layout.y + layout.height, coordSysBoundingRect.y + coordSysBoundingRect.height);
    layout.x = x;
    layout.y = y;
    layout.width = x2 - x;
    layout.height = y2 - y;
    var clipped = layout.width < 0 || layout.height < 0; // Reverse back

    if (signWidth < 0) {
      layout.x += layout.width;
      layout.width = -layout.width;
    }

    if (signHeight < 0) {
      layout.y += layout.height;
      layout.height = -layout.height;
    }

    return clipped;
  },
  polar: function (coordSysClipArea, layout) {
    var signR = layout.r0 <= layout.r ? 1 : -1; // Make sure r is larger than r0

    if (signR < 0) {
      var r = layout.r;
      layout.r = layout.r0;
      layout.r0 = r;
    }

    var r = mathMin(layout.r, coordSysClipArea.r);
    var r0 = mathMax(layout.r0, coordSysClipArea.r0);
    layout.r = r;
    layout.r0 = r0;
    var clipped = r - r0 < 0; // Reverse back

    if (signR < 0) {
      var r = layout.r;
      layout.r = layout.r0;
      layout.r0 = r;
    }

    return clipped;
  }
};
var elementCreator = {
  cartesian2d: function (dataIndex, layout, isHorizontal, animationModel, isUpdate) {
    var rect = new graphic.Rect({
      shape: zrUtil.extend({}, layout),
      z2: 1
    });
    rect.name = 'item'; // Animation

    if (animationModel) {
      var rectShape = rect.shape;
      var animateProperty = isHorizontal ? 'height' : 'width';
      var animateTarget = {};
      rectShape[animateProperty] = 0;
      animateTarget[animateProperty] = layout[animateProperty];
      graphic[isUpdate ? 'updateProps' : 'initProps'](rect, {
        shape: animateTarget
      }, animationModel, dataIndex);
    }

    return rect;
  },
  polar: function (dataIndex, layout, isRadial, animationModel, isUpdate, roundCap) {
    // Keep the same logic with bar in catesion: use end value to control
    // direction. Notice that if clockwise is true (by default), the sector
    // will always draw clockwisely, no matter whether endAngle is greater
    // or less than startAngle.
    var clockwise = layout.startAngle < layout.endAngle;
    var ShapeClass = !isRadial && roundCap ? Sausage : graphic.Sector;
    var sector = new ShapeClass({
      shape: zrUtil.defaults({
        clockwise: clockwise
      }, layout),
      z2: 1
    });
    sector.name = 'item'; // Animation

    if (animationModel) {
      var sectorShape = sector.shape;
      var animateProperty = isRadial ? 'r' : 'endAngle';
      var animateTarget = {};
      sectorShape[animateProperty] = isRadial ? 0 : layout.startAngle;
      animateTarget[animateProperty] = layout[animateProperty];
      graphic[isUpdate ? 'updateProps' : 'initProps'](sector, {
        shape: animateTarget
      }, animationModel, dataIndex);
    }

    return sector;
  }
};

function removeRect(dataIndex, animationModel, el) {
  // Not show text when animating
  el.style.text = null;
  graphic.updateProps(el, {
    shape: {
      width: 0
    }
  }, animationModel, dataIndex, function () {
    el.parent && el.parent.remove(el);
  });
}

function removeSector(dataIndex, animationModel, el) {
  // Not show text when animating
  el.style.text = null;
  graphic.updateProps(el, {
    shape: {
      r: el.shape.r0
    }
  }, animationModel, dataIndex, function () {
    el.parent && el.parent.remove(el);
  });
}

var getLayout = {
  // itemModel is only used to get borderWidth, which is not needed
  // when calculating bar background layout.
  cartesian2d: function (data, dataIndex, itemModel) {
    var layout = data.getItemLayout(dataIndex);
    var fixedLineWidth = itemModel ? getLineWidth(itemModel, layout) : 0; // fix layout with lineWidth

    var signX = layout.width > 0 ? 1 : -1;
    var signY = layout.height > 0 ? 1 : -1;
    return {
      x: layout.x + signX * fixedLineWidth / 2,
      y: layout.y + signY * fixedLineWidth / 2,
      width: layout.width - signX * fixedLineWidth,
      height: layout.height - signY * fixedLineWidth
    };
  },
  polar: function (data, dataIndex, itemModel) {
    var layout = data.getItemLayout(dataIndex);
    return {
      cx: layout.cx,
      cy: layout.cy,
      r0: layout.r0,
      r: layout.r,
      startAngle: layout.startAngle,
      endAngle: layout.endAngle
    };
  }
};

function isZeroOnPolar(layout) {
  return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
}

function updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontal, isPolar) {
  var color = data.getItemVisual(dataIndex, 'color');
  var opacity = data.getItemVisual(dataIndex, 'opacity');
  var stroke = data.getVisual('borderColor');
  var itemStyleModel = itemModel.getModel('itemStyle');
  var hoverStyle = itemModel.getModel('emphasis.itemStyle').getBarItemStyle();

  if (!isPolar) {
    el.setShape('r', itemStyleModel.get('barBorderRadius') || 0);
  }

  el.useStyle(zrUtil.defaults({
    stroke: isZeroOnPolar(layout) ? 'none' : stroke,
    fill: isZeroOnPolar(layout) ? 'none' : color,
    opacity: opacity
  }, itemStyleModel.getBarItemStyle()));
  var cursorStyle = itemModel.getShallow('cursor');
  cursorStyle && el.attr('cursor', cursorStyle);
  var labelPositionOutside = isHorizontal ? layout.height > 0 ? 'bottom' : 'top' : layout.width > 0 ? 'left' : 'right';

  if (!isPolar) {
    setLabel(el.style, hoverStyle, itemModel, color, seriesModel, dataIndex, labelPositionOutside);
  }

  if (isZeroOnPolar(layout)) {
    hoverStyle.fill = hoverStyle.stroke = 'none';
  }

  graphic.setHoverStyle(el, hoverStyle);
} // In case width or height are too small.


function getLineWidth(itemModel, rawLayout) {
  var lineWidth = itemModel.get(BAR_BORDER_WIDTH_QUERY) || 0; // width or height may be NaN for empty data

  var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
  var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
  return Math.min(lineWidth, width, height);
}

var LargePath = Path.extend({
  type: 'largeBar',
  shape: {
    points: []
  },
  buildPath: function (ctx, shape) {
    // Drawing lines is more efficient than drawing
    // a whole line or drawing rects.
    var points = shape.points;
    var startPoint = this.__startPoint;
    var baseDimIdx = this.__baseDimIdx;

    for (var i = 0; i < points.length; i += 2) {
      startPoint[baseDimIdx] = points[i + baseDimIdx];
      ctx.moveTo(startPoint[0], startPoint[1]);
      ctx.lineTo(points[i], points[i + 1]);
    }
  }
});

function createLarge(seriesModel, group, incremental) {
  // TODO support polar
  var data = seriesModel.getData();
  var startPoint = [];
  var baseDimIdx = data.getLayout('valueAxisHorizontal') ? 1 : 0;
  startPoint[1 - baseDimIdx] = data.getLayout('valueAxisStart');
  var largeDataIndices = data.getLayout('largeDataIndices');
  var barWidth = data.getLayout('barWidth');
  var backgroundModel = seriesModel.getModel('backgroundStyle');
  var drawBackground = seriesModel.get('showBackground', true);

  if (drawBackground) {
    var points = data.getLayout('largeBackgroundPoints');
    var backgroundStartPoint = [];
    backgroundStartPoint[1 - baseDimIdx] = data.getLayout('backgroundStart');
    var bgEl = new LargePath({
      shape: {
        points: points
      },
      incremental: !!incremental,
      __startPoint: backgroundStartPoint,
      __baseDimIdx: baseDimIdx,
      __largeDataIndices: largeDataIndices,
      __barWidth: barWidth,
      silent: true,
      z2: 0
    });
    setLargeBackgroundStyle(bgEl, backgroundModel, data);
    group.add(bgEl);
  }

  var el = new LargePath({
    shape: {
      points: data.getLayout('largePoints')
    },
    incremental: !!incremental,
    __startPoint: startPoint,
    __baseDimIdx: baseDimIdx,
    __largeDataIndices: largeDataIndices,
    __barWidth: barWidth
  });
  group.add(el);
  setLargeStyle(el, seriesModel, data); // Enable tooltip and user mouse/touch event handlers.

  el.seriesIndex = seriesModel.seriesIndex;

  if (!seriesModel.get('silent')) {
    el.on('mousedown', largePathUpdateDataIndex);
    el.on('mousemove', largePathUpdateDataIndex);
  }
} // Use throttle to avoid frequently traverse to find dataIndex.


var largePathUpdateDataIndex = throttle(function (event) {
  var largePath = this;
  var dataIndex = largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
  largePath.dataIndex = dataIndex >= 0 ? dataIndex : null;
}, 30, false);

function largePathFindDataIndex(largePath, x, y) {
  var baseDimIdx = largePath.__baseDimIdx;
  var valueDimIdx = 1 - baseDimIdx;
  var points = largePath.shape.points;
  var largeDataIndices = largePath.__largeDataIndices;
  var barWidthHalf = Math.abs(largePath.__barWidth / 2);
  var startValueVal = largePath.__startPoint[valueDimIdx];
  _eventPos[0] = x;
  _eventPos[1] = y;
  var pointerBaseVal = _eventPos[baseDimIdx];
  var pointerValueVal = _eventPos[1 - baseDimIdx];
  var baseLowerBound = pointerBaseVal - barWidthHalf;
  var baseUpperBound = pointerBaseVal + barWidthHalf;

  for (var i = 0, len = points.length / 2; i < len; i++) {
    var ii = i * 2;
    var barBaseVal = points[ii + baseDimIdx];
    var barValueVal = points[ii + valueDimIdx];

    if (barBaseVal >= baseLowerBound && barBaseVal <= baseUpperBound && (startValueVal <= barValueVal ? pointerValueVal >= startValueVal && pointerValueVal <= barValueVal : pointerValueVal >= barValueVal && pointerValueVal <= startValueVal)) {
      return largeDataIndices[i];
    }
  }

  return -1;
}

function setLargeStyle(el, seriesModel, data) {
  var borderColor = data.getVisual('borderColor') || data.getVisual('color');
  var itemStyle = seriesModel.getModel('itemStyle').getItemStyle(['color', 'borderColor']);
  el.useStyle(itemStyle);
  el.style.fill = null;
  el.style.stroke = borderColor;
  el.style.lineWidth = data.getLayout('barWidth');
}

function setLargeBackgroundStyle(el, backgroundModel, data) {
  var borderColor = backgroundModel.get('borderColor') || backgroundModel.get('color');
  var itemStyle = backgroundModel.getItemStyle(['color', 'borderColor']);
  el.useStyle(itemStyle);
  el.style.fill = null;
  el.style.stroke = borderColor;
  el.style.lineWidth = data.getLayout('barWidth');
}

function createBackgroundShape(isHorizontalOrRadial, layout, coord) {
  var coordLayout;
  var isPolar = coord.type === 'polar';

  if (isPolar) {
    coordLayout = coord.getArea();
  } else {
    coordLayout = coord.grid.getRect();
  }

  if (isPolar) {
    return {
      cx: coordLayout.cx,
      cy: coordLayout.cy,
      r0: isHorizontalOrRadial ? coordLayout.r0 : layout.r0,
      r: isHorizontalOrRadial ? coordLayout.r : layout.r,
      startAngle: isHorizontalOrRadial ? layout.startAngle : 0,
      endAngle: isHorizontalOrRadial ? layout.endAngle : Math.PI * 2
    };
  } else {
    return {
      x: isHorizontalOrRadial ? layout.x : coordLayout.x,
      y: isHorizontalOrRadial ? coordLayout.y : layout.y,
      width: isHorizontalOrRadial ? layout.width : coordLayout.width,
      height: isHorizontalOrRadial ? coordLayout.height : layout.height
    };
  }
}

function createBackgroundEl(coord, isHorizontalOrRadial, layout) {
  var ElementClz = coord.type === 'polar' ? graphic.Sector : graphic.Rect;
  return new ElementClz({
    shape: createBackgroundShape(isHorizontalOrRadial, layout, coord),
    silent: true,
    z2: 0
  });
}

module.exports = _default;

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var makeStyleMapper = __webpack_require__(204);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var getBarItemStyle = makeStyleMapper([['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], // Compatitable with 2
['stroke', 'barBorderColor'], ['lineWidth', 'barBorderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
var _default = {
  getBarItemStyle: function (excludes) {
    var style = getBarItemStyle(this, excludes);

    if (this.getBorderLineDash) {
      var lineDash = this.getBorderLineDash();
      lineDash && (style.lineDash = lineDash);
    }

    return style;
  }
};
module.exports = _default;

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _graphic = __webpack_require__(27);

var extendShape = _graphic.extendShape;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Sausage: similar to sector, but have half circle on both sides
 * @public
 */
var _default = extendShape({
  type: 'sausage',
  shape: {
    cx: 0,
    cy: 0,
    r0: 0,
    r: 0,
    startAngle: 0,
    endAngle: Math.PI * 2,
    clockwise: true
  },
  buildPath: function (ctx, shape) {
    var x = shape.cx;
    var y = shape.cy;
    var r0 = Math.max(shape.r0 || 0, 0);
    var r = Math.max(shape.r, 0);
    var dr = (r - r0) * 0.5;
    var rCenter = r0 + dr;
    var startAngle = shape.startAngle;
    var endAngle = shape.endAngle;
    var clockwise = shape.clockwise;
    var unitStartX = Math.cos(startAngle);
    var unitStartY = Math.sin(startAngle);
    var unitEndX = Math.cos(endAngle);
    var unitEndY = Math.sin(endAngle);
    var lessThanCircle = clockwise ? endAngle - startAngle < Math.PI * 2 : startAngle - endAngle < Math.PI * 2;

    if (lessThanCircle) {
      ctx.moveTo(unitStartX * r0 + x, unitStartY * r0 + y);
      ctx.arc(unitStartX * rCenter + x, unitStartY * rCenter + y, dr, -Math.PI + startAngle, startAngle, !clockwise);
    }

    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    ctx.moveTo(unitEndX * r + x, unitEndY * r + y);
    ctx.arc(unitEndX * rCenter + x, unitEndY * rCenter + y, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);

    if (r0 !== 0) {
      ctx.arc(x, y, r0, endAngle, startAngle, clockwise);
      ctx.moveTo(unitStartX * r0 + x, unitEndY * r0 + y);
    }

    ctx.closePath();
  }
});

module.exports = _default;

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

__webpack_require__(1589);

__webpack_require__(1590);

var createDataSelectAction = __webpack_require__(656);

var dataColor = __webpack_require__(304);

var pieLayout = __webpack_require__(1591);

var dataFilter = __webpack_require__(244);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
createDataSelectAction('pie', [{
  type: 'pieToggleSelect',
  event: 'pieselectchanged',
  method: 'toggleSelected'
}, {
  type: 'pieSelect',
  event: 'pieselected',
  method: 'select'
}, {
  type: 'pieUnSelect',
  event: 'pieunselected',
  method: 'unSelect'
}]);
echarts.registerVisual(dataColor('pie'));
echarts.registerLayout(zrUtil.curry(pieLayout, 'pie'));
echarts.registerProcessor(dataFilter('pie'));

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var createListSimply = __webpack_require__(209);

var zrUtil = __webpack_require__(1);

var modelUtil = __webpack_require__(44);

var _number = __webpack_require__(37);

var getPercentWithPrecision = _number.getPercentWithPrecision;

var dataSelectableMixin = __webpack_require__(416);

var _dataProvider = __webpack_require__(176);

var retrieveRawAttr = _dataProvider.retrieveRawAttr;

var _sourceHelper = __webpack_require__(136);

var makeSeriesEncodeForNameBased = _sourceHelper.makeSeriesEncodeForNameBased;

var LegendVisualProvider = __webpack_require__(243);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var PieSeries = echarts.extendSeriesModel({
  type: 'series.pie',
  // Overwrite
  init: function (option) {
    PieSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
    // Use a function instead of direct access because data reference may changed

    this.legendVisualProvider = new LegendVisualProvider(zrUtil.bind(this.getData, this), zrUtil.bind(this.getRawData, this));
    this.updateSelectedMap(this._createSelectableList());

    this._defaultLabelLine(option);
  },
  // Overwrite
  mergeOption: function (newOption) {
    PieSeries.superCall(this, 'mergeOption', newOption);
    this.updateSelectedMap(this._createSelectableList());
  },
  getInitialData: function (option, ecModel) {
    return createListSimply(this, {
      coordDimensions: ['value'],
      encodeDefaulter: zrUtil.curry(makeSeriesEncodeForNameBased, this)
    });
  },
  _createSelectableList: function () {
    var data = this.getRawData();
    var valueDim = data.mapDimension('value');
    var targetList = [];

    for (var i = 0, len = data.count(); i < len; i++) {
      targetList.push({
        name: data.getName(i),
        value: data.get(valueDim, i),
        selected: retrieveRawAttr(data, i, 'selected')
      });
    }

    return targetList;
  },
  // Overwrite
  getDataParams: function (dataIndex) {
    var data = this.getData();
    var params = PieSeries.superCall(this, 'getDataParams', dataIndex); // FIXME toFixed?

    var valueList = [];
    data.each(data.mapDimension('value'), function (value) {
      valueList.push(value);
    });
    params.percent = getPercentWithPrecision(valueList, dataIndex, data.hostModel.get('percentPrecision'));
    params.$vars.push('percent');
    return params;
  },
  _defaultLabelLine: function (option) {
    // Extend labelLine emphasis
    modelUtil.defaultEmphasis(option, 'labelLine', ['show']);
    var labelLineNormalOpt = option.labelLine;
    var labelLineEmphasisOpt = option.emphasis.labelLine; // Not show label line if `label.normal.show = false`

    labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
    labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
  },
  defaultOption: {
    zlevel: 0,
    z: 2,
    legendHoverLink: true,
    hoverAnimation: true,
    // 默认全局居中
    center: ['50%', '50%'],
    radius: [0, '75%'],
    // 默认顺时针
    clockwise: true,
    startAngle: 90,
    // 最小角度改为0
    minAngle: 0,
    // If the angle of a sector less than `minShowLabelAngle`,
    // the label will not be displayed.
    minShowLabelAngle: 0,
    // 选中时扇区偏移量
    selectedOffset: 10,
    // 高亮扇区偏移量
    hoverOffset: 10,
    // If use strategy to avoid label overlapping
    avoidLabelOverlap: true,
    // 选择模式，默认关闭，可选single，multiple
    // selectedMode: false,
    // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
    // roseType: null,
    percentPrecision: 2,
    // If still show when all data zero.
    stillShowZeroSum: true,
    // cursor: null,
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    width: null,
    height: null,
    label: {
      // If rotate around circle
      rotate: false,
      show: true,
      // 'outer', 'inside', 'center'
      position: 'outer',
      // 'none', 'labelLine', 'edge'. Works only when position is 'outer'
      alignTo: 'none',
      // Closest distance between label and chart edge.
      // Works only position is 'outer' and alignTo is 'edge'.
      margin: '25%',
      // Works only position is 'outer' and alignTo is not 'edge'.
      bleedMargin: 10,
      // Distance between text and label line.
      distanceToLabelLine: 5 // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
      // 默认使用全局文本样式，详见TEXTSTYLE
      // distance: 当position为inner时有效，为label位置到圆心的距离与圆半径(环状图为内外半径和)的比例系数

    },
    // Enabled when label.normal.position is 'outer'
    labelLine: {
      show: true,
      // 引导线两段中的第一段长度
      length: 15,
      // 引导线两段中的第二段长度
      length2: 15,
      smooth: false,
      lineStyle: {
        // color: 各异,
        width: 1,
        type: 'solid'
      }
    },
    itemStyle: {
      borderWidth: 1
    },
    // Animation type. Valid values: expansion, scale
    animationType: 'expansion',
    // Animation type when update. Valid values: transition, expansion
    animationTypeUpdate: 'transition',
    animationEasing: 'cubicOut'
  }
});
zrUtil.mixin(PieSeries, dataSelectableMixin);
var _default = PieSeries;
module.exports = _default;

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var graphic = __webpack_require__(27);

var ChartView = __webpack_require__(123);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @param {module:echarts/model/Series} seriesModel
 * @param {boolean} hasAnimation
 * @inner
 */
function updateDataSelected(uid, seriesModel, hasAnimation, api) {
  var data = seriesModel.getData();
  var dataIndex = this.dataIndex;
  var name = data.getName(dataIndex);
  var selectedOffset = seriesModel.get('selectedOffset');
  api.dispatchAction({
    type: 'pieToggleSelect',
    from: uid,
    name: name,
    seriesId: seriesModel.id
  });
  data.each(function (idx) {
    toggleItemSelected(data.getItemGraphicEl(idx), data.getItemLayout(idx), seriesModel.isSelected(data.getName(idx)), selectedOffset, hasAnimation);
  });
}
/**
 * @param {module:zrender/graphic/Sector} el
 * @param {Object} layout
 * @param {boolean} isSelected
 * @param {number} selectedOffset
 * @param {boolean} hasAnimation
 * @inner
 */


function toggleItemSelected(el, layout, isSelected, selectedOffset, hasAnimation) {
  var midAngle = (layout.startAngle + layout.endAngle) / 2;
  var dx = Math.cos(midAngle);
  var dy = Math.sin(midAngle);
  var offset = isSelected ? selectedOffset : 0;
  var position = [dx * offset, dy * offset];
  hasAnimation // animateTo will stop revious animation like update transition
  ? el.animate().when(200, {
    position: position
  }).start('bounceOut') : el.attr('position', position);
}
/**
 * Piece of pie including Sector, Label, LabelLine
 * @constructor
 * @extends {module:zrender/graphic/Group}
 */


function PiePiece(data, idx) {
  graphic.Group.call(this);
  var sector = new graphic.Sector({
    z2: 2
  });
  var polyline = new graphic.Polyline();
  var text = new graphic.Text();
  this.add(sector);
  this.add(polyline);
  this.add(text);
  this.updateData(data, idx, true);
}

var piePieceProto = PiePiece.prototype;

piePieceProto.updateData = function (data, idx, firstCreate) {
  var sector = this.childAt(0);
  var labelLine = this.childAt(1);
  var labelText = this.childAt(2);
  var seriesModel = data.hostModel;
  var itemModel = data.getItemModel(idx);
  var layout = data.getItemLayout(idx);
  var sectorShape = zrUtil.extend({}, layout);
  sectorShape.label = null;
  var animationTypeUpdate = seriesModel.getShallow('animationTypeUpdate');

  if (firstCreate) {
    sector.setShape(sectorShape);
    var animationType = seriesModel.getShallow('animationType');

    if (animationType === 'scale') {
      sector.shape.r = layout.r0;
      graphic.initProps(sector, {
        shape: {
          r: layout.r
        }
      }, seriesModel, idx);
    } // Expansion
    else {
        sector.shape.endAngle = layout.startAngle;
        graphic.updateProps(sector, {
          shape: {
            endAngle: layout.endAngle
          }
        }, seriesModel, idx);
      }
  } else {
    if (animationTypeUpdate === 'expansion') {
      // Sectors are set to be target shape and an overlaying clipPath is used for animation
      sector.setShape(sectorShape);
    } else {
      // Transition animation from the old shape
      graphic.updateProps(sector, {
        shape: sectorShape
      }, seriesModel, idx);
    }
  } // Update common style


  var visualColor = data.getItemVisual(idx, 'color');
  sector.useStyle(zrUtil.defaults({
    lineJoin: 'bevel',
    fill: visualColor
  }, itemModel.getModel('itemStyle').getItemStyle()));
  sector.hoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
  var cursorStyle = itemModel.getShallow('cursor');
  cursorStyle && sector.attr('cursor', cursorStyle); // Toggle selected

  toggleItemSelected(this, data.getItemLayout(idx), seriesModel.isSelected(data.getName(idx)), seriesModel.get('selectedOffset'), seriesModel.get('animation')); // Label and text animation should be applied only for transition type animation when update

  var withAnimation = !firstCreate && animationTypeUpdate === 'transition';

  this._updateLabel(data, idx, withAnimation);

  this.highDownOnUpdate = !seriesModel.get('silent') ? function (fromState, toState) {
    var hasAnimation = seriesModel.isAnimationEnabled() && itemModel.get('hoverAnimation');

    if (toState === 'emphasis') {
      labelLine.ignore = labelLine.hoverIgnore;
      labelText.ignore = labelText.hoverIgnore; // Sector may has animation of updating data. Force to move to the last frame
      // Or it may stopped on the wrong shape

      if (hasAnimation) {
        sector.stopAnimation(true);
        sector.animateTo({
          shape: {
            r: layout.r + seriesModel.get('hoverOffset')
          }
        }, 300, 'elasticOut');
      }
    } else {
      labelLine.ignore = labelLine.normalIgnore;
      labelText.ignore = labelText.normalIgnore;

      if (hasAnimation) {
        sector.stopAnimation(true);
        sector.animateTo({
          shape: {
            r: layout.r
          }
        }, 300, 'elasticOut');
      }
    }
  } : null;
  graphic.setHoverStyle(this);
};

piePieceProto._updateLabel = function (data, idx, withAnimation) {
  var labelLine = this.childAt(1);
  var labelText = this.childAt(2);
  var seriesModel = data.hostModel;
  var itemModel = data.getItemModel(idx);
  var layout = data.getItemLayout(idx);
  var labelLayout = layout.label;
  var visualColor = data.getItemVisual(idx, 'color');

  if (!labelLayout || isNaN(labelLayout.x) || isNaN(labelLayout.y)) {
    labelText.ignore = labelText.normalIgnore = labelText.hoverIgnore = labelLine.ignore = labelLine.normalIgnore = labelLine.hoverIgnore = true;
    return;
  }

  var targetLineShape = {
    points: labelLayout.linePoints || [[labelLayout.x, labelLayout.y], [labelLayout.x, labelLayout.y], [labelLayout.x, labelLayout.y]]
  };
  var targetTextStyle = {
    x: labelLayout.x,
    y: labelLayout.y
  };

  if (withAnimation) {
    graphic.updateProps(labelLine, {
      shape: targetLineShape
    }, seriesModel, idx);
    graphic.updateProps(labelText, {
      style: targetTextStyle
    }, seriesModel, idx);
  } else {
    labelLine.attr({
      shape: targetLineShape
    });
    labelText.attr({
      style: targetTextStyle
    });
  }

  labelText.attr({
    rotation: labelLayout.rotation,
    origin: [labelLayout.x, labelLayout.y],
    z2: 10
  });
  var labelModel = itemModel.getModel('label');
  var labelHoverModel = itemModel.getModel('emphasis.label');
  var labelLineModel = itemModel.getModel('labelLine');
  var labelLineHoverModel = itemModel.getModel('emphasis.labelLine');
  var visualColor = data.getItemVisual(idx, 'color');
  graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, labelHoverModel, {
    labelFetcher: data.hostModel,
    labelDataIndex: idx,
    defaultText: labelLayout.text,
    autoColor: visualColor,
    useInsideStyle: !!labelLayout.inside
  }, {
    textAlign: labelLayout.textAlign,
    textVerticalAlign: labelLayout.verticalAlign,
    opacity: data.getItemVisual(idx, 'opacity')
  });
  labelText.ignore = labelText.normalIgnore = !labelModel.get('show');
  labelText.hoverIgnore = !labelHoverModel.get('show');
  labelLine.ignore = labelLine.normalIgnore = !labelLineModel.get('show');
  labelLine.hoverIgnore = !labelLineHoverModel.get('show'); // Default use item visual color

  labelLine.setStyle({
    stroke: visualColor,
    opacity: data.getItemVisual(idx, 'opacity')
  });
  labelLine.setStyle(labelLineModel.getModel('lineStyle').getLineStyle());
  labelLine.hoverStyle = labelLineHoverModel.getModel('lineStyle').getLineStyle();
  var smooth = labelLineModel.get('smooth');

  if (smooth && smooth === true) {
    smooth = 0.4;
  }

  labelLine.setShape({
    smooth: smooth
  });
};

zrUtil.inherits(PiePiece, graphic.Group); // Pie view

var PieView = ChartView.extend({
  type: 'pie',
  init: function () {
    var sectorGroup = new graphic.Group();
    this._sectorGroup = sectorGroup;
  },
  render: function (seriesModel, ecModel, api, payload) {
    if (payload && payload.from === this.uid) {
      return;
    }

    var data = seriesModel.getData();
    var oldData = this._data;
    var group = this.group;
    var hasAnimation = ecModel.get('animation');
    var isFirstRender = !oldData;
    var animationType = seriesModel.get('animationType');
    var animationTypeUpdate = seriesModel.get('animationTypeUpdate');
    var onSectorClick = zrUtil.curry(updateDataSelected, this.uid, seriesModel, hasAnimation, api);
    var selectedMode = seriesModel.get('selectedMode');
    data.diff(oldData).add(function (idx) {
      var piePiece = new PiePiece(data, idx); // Default expansion animation

      if (isFirstRender && animationType !== 'scale') {
        piePiece.eachChild(function (child) {
          child.stopAnimation(true);
        });
      }

      selectedMode && piePiece.on('click', onSectorClick);
      data.setItemGraphicEl(idx, piePiece);
      group.add(piePiece);
    }).update(function (newIdx, oldIdx) {
      var piePiece = oldData.getItemGraphicEl(oldIdx);

      if (!isFirstRender && animationTypeUpdate !== 'transition') {
        piePiece.eachChild(function (child) {
          child.stopAnimation(true);
        });
      }

      piePiece.updateData(data, newIdx);
      piePiece.off('click');
      selectedMode && piePiece.on('click', onSectorClick);
      group.add(piePiece);
      data.setItemGraphicEl(newIdx, piePiece);
    }).remove(function (idx) {
      var piePiece = oldData.getItemGraphicEl(idx);
      group.remove(piePiece);
    }).execute();

    if (hasAnimation && data.count() > 0 && (isFirstRender ? animationType !== 'scale' : animationTypeUpdate !== 'transition')) {
      var shape = data.getItemLayout(0);

      for (var s = 1; isNaN(shape.startAngle) && s < data.count(); ++s) {
        shape = data.getItemLayout(s);
      }

      var r = Math.max(api.getWidth(), api.getHeight()) / 2;
      var removeClipPath = zrUtil.bind(group.removeClipPath, group);
      group.setClipPath(this._createClipPath(shape.cx, shape.cy, r, shape.startAngle, shape.clockwise, removeClipPath, seriesModel, isFirstRender));
    } else {
      // clipPath is used in first-time animation, so remove it when otherwise. See: #8994
      group.removeClipPath();
    }

    this._data = data;
  },
  dispose: function () {},
  _createClipPath: function (cx, cy, r, startAngle, clockwise, cb, seriesModel, isFirstRender) {
    var clipPath = new graphic.Sector({
      shape: {
        cx: cx,
        cy: cy,
        r0: 0,
        r: r,
        startAngle: startAngle,
        endAngle: startAngle,
        clockwise: clockwise
      }
    });
    var initOrUpdate = isFirstRender ? graphic.initProps : graphic.updateProps;
    initOrUpdate(clipPath, {
      shape: {
        endAngle: startAngle + (clockwise ? 1 : -1) * Math.PI * 2
      }
    }, seriesModel, cb);
    return clipPath;
  },

  /**
   * @implement
   */
  containPoint: function (point, seriesModel) {
    var data = seriesModel.getData();
    var itemLayout = data.getItemLayout(0);

    if (itemLayout) {
      var dx = point[0] - itemLayout.cx;
      var dy = point[1] - itemLayout.cy;
      var radius = Math.sqrt(dx * dx + dy * dy);
      return radius <= itemLayout.r && radius >= itemLayout.r0;
    }
  }
});
var _default = PieView;
module.exports = _default;

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _number = __webpack_require__(37);

var parsePercent = _number.parsePercent;
var linearMap = _number.linearMap;

var layout = __webpack_require__(53);

var labelLayout = __webpack_require__(1592);

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var PI2 = Math.PI * 2;
var RADIAN = Math.PI / 180;

function getViewRect(seriesModel, api) {
  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  });
}

function _default(seriesType, ecModel, api, payload) {
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    var data = seriesModel.getData();
    var valueDim = data.mapDimension('value');
    var viewRect = getViewRect(seriesModel, api);
    var center = seriesModel.get('center');
    var radius = seriesModel.get('radius');

    if (!zrUtil.isArray(radius)) {
      radius = [0, radius];
    }

    if (!zrUtil.isArray(center)) {
      center = [center, center];
    }

    var width = parsePercent(viewRect.width, api.getWidth());
    var height = parsePercent(viewRect.height, api.getHeight());
    var size = Math.min(width, height);
    var cx = parsePercent(center[0], width) + viewRect.x;
    var cy = parsePercent(center[1], height) + viewRect.y;
    var r0 = parsePercent(radius[0], size / 2);
    var r = parsePercent(radius[1], size / 2);
    var startAngle = -seriesModel.get('startAngle') * RADIAN;
    var minAngle = seriesModel.get('minAngle') * RADIAN;
    var validDataCount = 0;
    data.each(valueDim, function (value) {
      !isNaN(value) && validDataCount++;
    });
    var sum = data.getSum(valueDim); // Sum may be 0

    var unitRadian = Math.PI / (sum || validDataCount) * 2;
    var clockwise = seriesModel.get('clockwise');
    var roseType = seriesModel.get('roseType');
    var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // [0...max]

    var extent = data.getDataExtent(valueDim);
    extent[0] = 0; // In the case some sector angle is smaller than minAngle

    var restAngle = PI2;
    var valueSumLargerThanMinAngle = 0;
    var currentAngle = startAngle;
    var dir = clockwise ? 1 : -1;
    data.each(valueDim, function (value, idx) {
      var angle;

      if (isNaN(value)) {
        data.setItemLayout(idx, {
          angle: NaN,
          startAngle: NaN,
          endAngle: NaN,
          clockwise: clockwise,
          cx: cx,
          cy: cy,
          r0: r0,
          r: roseType ? NaN : r,
          viewRect: viewRect
        });
        return;
      } // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？


      if (roseType !== 'area') {
        angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
      } else {
        angle = PI2 / validDataCount;
      }

      if (angle < minAngle) {
        angle = minAngle;
        restAngle -= minAngle;
      } else {
        valueSumLargerThanMinAngle += value;
      }

      var endAngle = currentAngle + dir * angle;
      data.setItemLayout(idx, {
        angle: angle,
        startAngle: currentAngle,
        endAngle: endAngle,
        clockwise: clockwise,
        cx: cx,
        cy: cy,
        r0: r0,
        r: roseType ? linearMap(value, extent, [r0, r]) : r,
        viewRect: viewRect
      });
      currentAngle = endAngle;
    }); // Some sector is constrained by minAngle
    // Rest sectors needs recalculate angle

    if (restAngle < PI2 && validDataCount) {
      // Average the angle if rest angle is not enough after all angles is
      // Constrained by minAngle
      if (restAngle <= 1e-3) {
        var angle = PI2 / validDataCount;
        data.each(valueDim, function (value, idx) {
          if (!isNaN(value)) {
            var layout = data.getItemLayout(idx);
            layout.angle = angle;
            layout.startAngle = startAngle + dir * idx * angle;
            layout.endAngle = startAngle + dir * (idx + 1) * angle;
          }
        });
      } else {
        unitRadian = restAngle / valueSumLargerThanMinAngle;
        currentAngle = startAngle;
        data.each(valueDim, function (value, idx) {
          if (!isNaN(value)) {
            var layout = data.getItemLayout(idx);
            var angle = layout.angle === minAngle ? minAngle : value * unitRadian;
            layout.startAngle = currentAngle;
            layout.endAngle = currentAngle + dir * angle;
            currentAngle += dir * angle;
          }
        });
      }
    }

    labelLayout(seriesModel, r, viewRect.width, viewRect.height, viewRect.x, viewRect.y);
  });
}

module.exports = _default;

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var textContain = __webpack_require__(93);

var _number = __webpack_require__(37);

var parsePercent = _number.parsePercent;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// FIXME emphasis label position is not same with normal label position
var RADIAN = Math.PI / 180;

function adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight, viewLeft, viewTop, farthestX) {
  list.sort(function (a, b) {
    return a.y - b.y;
  });

  function shiftDown(start, end, delta, dir) {
    for (var j = start; j < end; j++) {
      if (list[j].y + delta > viewTop + viewHeight) {
        break;
      }

      list[j].y += delta;

      if (j > start && j + 1 < end && list[j + 1].y > list[j].y + list[j].height) {
        shiftUp(j, delta / 2);
        return;
      }
    }

    shiftUp(end - 1, delta / 2);
  }

  function shiftUp(end, delta) {
    for (var j = end; j >= 0; j--) {
      if (list[j].y - delta < viewTop) {
        break;
      }

      list[j].y -= delta;

      if (j > 0 && list[j].y > list[j - 1].y + list[j - 1].height) {
        break;
      }
    }
  }

  function changeX(list, isDownList, cx, cy, r, dir) {
    var lastDeltaX = dir > 0 ? isDownList // right-side
    ? Number.MAX_VALUE // down
    : 0 // up
    : isDownList // left-side
    ? Number.MAX_VALUE // down
    : 0; // up

    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].labelAlignTo !== 'none') {
        continue;
      }

      var deltaY = Math.abs(list[i].y - cy);
      var length = list[i].len;
      var length2 = list[i].len2;
      var deltaX = deltaY < r + length ? Math.sqrt((r + length + length2) * (r + length + length2) - deltaY * deltaY) : Math.abs(list[i].x - cx);

      if (isDownList && deltaX >= lastDeltaX) {
        // right-down, left-down
        deltaX = lastDeltaX - 10;
      }

      if (!isDownList && deltaX <= lastDeltaX) {
        // right-up, left-up
        deltaX = lastDeltaX + 10;
      }

      list[i].x = cx + deltaX * dir;
      lastDeltaX = deltaX;
    }
  }

  var lastY = 0;
  var delta;
  var len = list.length;
  var upList = [];
  var downList = [];

  for (var i = 0; i < len; i++) {
    if (list[i].position === 'outer' && list[i].labelAlignTo === 'labelLine') {
      var dx = list[i].x - farthestX;
      list[i].linePoints[1][0] += dx;
      list[i].x = farthestX;
    }

    delta = list[i].y - lastY;

    if (delta < 0) {
      shiftDown(i, len, -delta, dir);
    }

    lastY = list[i].y + list[i].height;
  }

  if (viewHeight - lastY < 0) {
    shiftUp(len - 1, lastY - viewHeight);
  }

  for (var i = 0; i < len; i++) {
    if (list[i].y >= cy) {
      downList.push(list[i]);
    } else {
      upList.push(list[i]);
    }
  }

  changeX(upList, false, cx, cy, r, dir);
  changeX(downList, true, cx, cy, r, dir);
}

function avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop) {
  var leftList = [];
  var rightList = [];
  var leftmostX = Number.MAX_VALUE;
  var rightmostX = -Number.MAX_VALUE;

  for (var i = 0; i < labelLayoutList.length; i++) {
    if (isPositionCenter(labelLayoutList[i])) {
      continue;
    }

    if (labelLayoutList[i].x < cx) {
      leftmostX = Math.min(leftmostX, labelLayoutList[i].x);
      leftList.push(labelLayoutList[i]);
    } else {
      rightmostX = Math.max(rightmostX, labelLayoutList[i].x);
      rightList.push(labelLayoutList[i]);
    }
  }

  adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight, viewLeft, viewTop, rightmostX);
  adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight, viewLeft, viewTop, leftmostX);

  for (var i = 0; i < labelLayoutList.length; i++) {
    var layout = labelLayoutList[i];

    if (isPositionCenter(layout)) {
      continue;
    }

    var linePoints = layout.linePoints;

    if (linePoints) {
      var isAlignToEdge = layout.labelAlignTo === 'edge';
      var realTextWidth = layout.textRect.width;
      var targetTextWidth;

      if (isAlignToEdge) {
        if (layout.x < cx) {
          targetTextWidth = linePoints[2][0] - layout.labelDistance - viewLeft - layout.labelMargin;
        } else {
          targetTextWidth = viewLeft + viewWidth - layout.labelMargin - linePoints[2][0] - layout.labelDistance;
        }
      } else {
        if (layout.x < cx) {
          targetTextWidth = layout.x - viewLeft - layout.bleedMargin;
        } else {
          targetTextWidth = viewLeft + viewWidth - layout.x - layout.bleedMargin;
        }
      }

      if (targetTextWidth < layout.textRect.width) {
        layout.text = textContain.truncateText(layout.text, targetTextWidth, layout.font);

        if (layout.labelAlignTo === 'edge') {
          realTextWidth = textContain.getWidth(layout.text, layout.font);
        }
      }

      var dist = linePoints[1][0] - linePoints[2][0];

      if (isAlignToEdge) {
        if (layout.x < cx) {
          linePoints[2][0] = viewLeft + layout.labelMargin + realTextWidth + layout.labelDistance;
        } else {
          linePoints[2][0] = viewLeft + viewWidth - layout.labelMargin - realTextWidth - layout.labelDistance;
        }
      } else {
        if (layout.x < cx) {
          linePoints[2][0] = layout.x + layout.labelDistance;
        } else {
          linePoints[2][0] = layout.x - layout.labelDistance;
        }

        linePoints[1][0] = linePoints[2][0] + dist;
      }

      linePoints[1][1] = linePoints[2][1] = layout.y;
    }
  }
}

function isPositionCenter(layout) {
  // Not change x for center label
  return layout.position === 'center';
}

function _default(seriesModel, r, viewWidth, viewHeight, viewLeft, viewTop) {
  var data = seriesModel.getData();
  var labelLayoutList = [];
  var cx;
  var cy;
  var hasLabelRotate = false;
  var minShowLabelRadian = (seriesModel.get('minShowLabelAngle') || 0) * RADIAN;
  data.each(function (idx) {
    var layout = data.getItemLayout(idx);
    var itemModel = data.getItemModel(idx);
    var labelModel = itemModel.getModel('label'); // Use position in normal or emphasis

    var labelPosition = labelModel.get('position') || itemModel.get('emphasis.label.position');
    var labelDistance = labelModel.get('distanceToLabelLine');
    var labelAlignTo = labelModel.get('alignTo');
    var labelMargin = parsePercent(labelModel.get('margin'), viewWidth);
    var bleedMargin = labelModel.get('bleedMargin');
    var font = labelModel.getFont();
    var labelLineModel = itemModel.getModel('labelLine');
    var labelLineLen = labelLineModel.get('length');
    labelLineLen = parsePercent(labelLineLen, viewWidth);
    var labelLineLen2 = labelLineModel.get('length2');
    labelLineLen2 = parsePercent(labelLineLen2, viewWidth);

    if (layout.angle < minShowLabelRadian) {
      return;
    }

    var midAngle = (layout.startAngle + layout.endAngle) / 2;
    var dx = Math.cos(midAngle);
    var dy = Math.sin(midAngle);
    var textX;
    var textY;
    var linePoints;
    var textAlign;
    cx = layout.cx;
    cy = layout.cy;
    var text = seriesModel.getFormattedLabel(idx, 'normal') || data.getName(idx);
    var textRect = textContain.getBoundingRect(text, font, textAlign, 'top');
    var isLabelInside = labelPosition === 'inside' || labelPosition === 'inner';

    if (labelPosition === 'center') {
      textX = layout.cx;
      textY = layout.cy;
      textAlign = 'center';
    } else {
      var x1 = (isLabelInside ? (layout.r + layout.r0) / 2 * dx : layout.r * dx) + cx;
      var y1 = (isLabelInside ? (layout.r + layout.r0) / 2 * dy : layout.r * dy) + cy;
      textX = x1 + dx * 3;
      textY = y1 + dy * 3;

      if (!isLabelInside) {
        // For roseType
        var x2 = x1 + dx * (labelLineLen + r - layout.r);
        var y2 = y1 + dy * (labelLineLen + r - layout.r);
        var x3 = x2 + (dx < 0 ? -1 : 1) * labelLineLen2;
        var y3 = y2;

        if (labelAlignTo === 'edge') {
          // Adjust textX because text align of edge is opposite
          textX = dx < 0 ? viewLeft + labelMargin : viewLeft + viewWidth - labelMargin;
        } else {
          textX = x3 + (dx < 0 ? -labelDistance : labelDistance);
        }

        textY = y3;
        linePoints = [[x1, y1], [x2, y2], [x3, y3]];
      }

      textAlign = isLabelInside ? 'center' : labelAlignTo === 'edge' ? dx > 0 ? 'right' : 'left' : dx > 0 ? 'left' : 'right';
    }

    var labelRotate;
    var rotate = labelModel.get('rotate');

    if (typeof rotate === 'number') {
      labelRotate = rotate * (Math.PI / 180);
    } else {
      labelRotate = rotate ? dx < 0 ? -midAngle + Math.PI : -midAngle : 0;
    }

    hasLabelRotate = !!labelRotate;
    layout.label = {
      x: textX,
      y: textY,
      position: labelPosition,
      height: textRect.height,
      len: labelLineLen,
      len2: labelLineLen2,
      linePoints: linePoints,
      textAlign: textAlign,
      verticalAlign: 'middle',
      rotation: labelRotate,
      inside: isLabelInside,
      labelDistance: labelDistance,
      labelAlignTo: labelAlignTo,
      labelMargin: labelMargin,
      bleedMargin: bleedMargin,
      textRect: textRect,
      text: text,
      font: font
    }; // Not layout the inside label

    if (!isLabelInside) {
      labelLayoutList.push(layout.label);
    }
  });

  if (!hasLabelRotate && seriesModel.get('avoidLabelOverlap')) {
    avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop);
  }
}

module.exports = _default;

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(1594);

__webpack_require__(1595);

var visualSymbol = __webpack_require__(178);

var layoutPoints = __webpack_require__(241);

__webpack_require__(242);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// import * as zrUtil from 'zrender/src/core/util';
// In case developer forget to include grid component
echarts.registerVisual(visualSymbol('scatter', 'circle'));
echarts.registerLayout(layoutPoints('scatter')); // echarts.registerProcessor(function (ecModel, api) {
//     ecModel.eachSeriesByType('scatter', function (seriesModel) {
//         var data = seriesModel.getData();
//         var coordSys = seriesModel.coordinateSystem;
//         if (coordSys.type !== 'geo') {
//             return;
//         }
//         var startPt = coordSys.pointToData([0, 0]);
//         var endPt = coordSys.pointToData([api.getWidth(), api.getHeight()]);
//         var dims = zrUtil.map(coordSys.dimensions, function (dim) {
//             return data.mapDimension(dim);
//         });
//         var range = {};
//         range[dims[0]] = [Math.min(startPt[0], endPt[0]), Math.max(startPt[0], endPt[0])];
//         range[dims[1]] = [Math.min(startPt[1], endPt[1]), Math.max(startPt[1], endPt[1])];
//         data.selectRange(range);
//     });
// });

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var createListFromArray = __webpack_require__(137);

var SeriesModel = __webpack_require__(74);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = SeriesModel.extend({
  type: 'series.scatter',
  dependencies: ['grid', 'polar', 'geo', 'singleAxis', 'calendar'],
  getInitialData: function (option, ecModel) {
    return createListFromArray(this.getSource(), this, {
      useEncodeDefaulter: true
    });
  },
  brushSelector: 'point',
  getProgressive: function () {
    var progressive = this.option.progressive;

    if (progressive == null) {
      // PENDING
      return this.option.large ? 5e3 : this.get('progressive');
    }

    return progressive;
  },
  getProgressiveThreshold: function () {
    var progressiveThreshold = this.option.progressiveThreshold;

    if (progressiveThreshold == null) {
      // PENDING
      return this.option.large ? 1e4 : this.get('progressiveThreshold');
    }

    return progressiveThreshold;
  },
  defaultOption: {
    coordinateSystem: 'cartesian2d',
    zlevel: 0,
    z: 2,
    legendHoverLink: true,
    hoverAnimation: true,
    // Cartesian coordinate system
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // Polar coordinate system
    // polarIndex: 0,
    // Geo coordinate system
    // geoIndex: 0,
    // symbol: null,        // 图形类型
    symbolSize: 10,
    // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
    // symbolRotate: null,  // 图形旋转控制
    large: false,
    // Available when large is true
    largeThreshold: 2000,
    // cursor: null,
    // label: {
    // show: false
    // distance: 5,
    // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
    // position: 默认自适应，水平布局为'top'，垂直布局为'right'，可选为
    //           'inside'|'left'|'right'|'top'|'bottom'
    // 默认使用全局文本样式，详见TEXTSTYLE
    // },
    itemStyle: {
      opacity: 0.8 // color: 各异

    },
    // If clip the overflow graphics
    // Works on cartesian / polar series
    clip: true // progressive: null

  }
});

module.exports = _default;

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var SymbolDraw = __webpack_require__(239);

var LargeSymbolDraw = __webpack_require__(1596);

var pointsLayout = __webpack_require__(241);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.extendChartView({
  type: 'scatter',
  render: function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();

    var symbolDraw = this._updateSymbolDraw(data, seriesModel);

    symbolDraw.updateData(data, {
      // TODO
      // If this parameter should be a shape or a bounding volume
      // shape will be more general.
      // But bounding volume like bounding rect will be much faster in the contain calculation
      clipShape: this._getClipShape(seriesModel)
    });
    this._finished = true;
  },
  incrementalPrepareRender: function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();

    var symbolDraw = this._updateSymbolDraw(data, seriesModel);

    symbolDraw.incrementalPrepareUpdate(data);
    this._finished = false;
  },
  incrementalRender: function (taskParams, seriesModel, ecModel) {
    this._symbolDraw.incrementalUpdate(taskParams, seriesModel.getData(), {
      clipShape: this._getClipShape(seriesModel)
    });

    this._finished = taskParams.end === seriesModel.getData().count();
  },
  updateTransform: function (seriesModel, ecModel, api) {
    var data = seriesModel.getData(); // Must mark group dirty and make sure the incremental layer will be cleared
    // PENDING

    this.group.dirty();

    if (!this._finished || data.count() > 1e4 || !this._symbolDraw.isPersistent()) {
      return {
        update: true
      };
    } else {
      var res = pointsLayout().reset(seriesModel);

      if (res.progress) {
        res.progress({
          start: 0,
          end: data.count()
        }, data);
      }

      this._symbolDraw.updateLayout(data);
    }
  },
  _getClipShape: function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
    return seriesModel.get('clip', true) ? clipArea : null;
  },
  _updateSymbolDraw: function (data, seriesModel) {
    var symbolDraw = this._symbolDraw;
    var pipelineContext = seriesModel.pipelineContext;
    var isLargeDraw = pipelineContext.large;

    if (!symbolDraw || isLargeDraw !== this._isLargeDraw) {
      symbolDraw && symbolDraw.remove();
      symbolDraw = this._symbolDraw = isLargeDraw ? new LargeSymbolDraw() : new SymbolDraw();
      this._isLargeDraw = isLargeDraw;
      this.group.removeAll();
    }

    this.group.add(symbolDraw.group);
    return symbolDraw;
  },
  remove: function (ecModel, api) {
    this._symbolDraw && this._symbolDraw.remove(true);
    this._symbolDraw = null;
  },
  dispose: function () {}
});

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var graphic = __webpack_require__(27);

var _symbol = __webpack_require__(99);

var createSymbol = _symbol.createSymbol;

var IncrementalDisplayable = __webpack_require__(410);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/* global Float32Array */
// TODO Batch by color
var BOOST_SIZE_THRESHOLD = 4;
var LargeSymbolPath = graphic.extendShape({
  shape: {
    points: null
  },
  symbolProxy: null,
  softClipShape: null,
  buildPath: function (path, shape) {
    var points = shape.points;
    var size = shape.size;
    var symbolProxy = this.symbolProxy;
    var symbolProxyShape = symbolProxy.shape;
    var ctx = path.getContext ? path.getContext() : path;
    var canBoost = ctx && size[0] < BOOST_SIZE_THRESHOLD; // Do draw in afterBrush.

    if (canBoost) {
      return;
    }

    for (var i = 0; i < points.length;) {
      var x = points[i++];
      var y = points[i++];

      if (isNaN(x) || isNaN(y)) {
        continue;
      }

      if (this.softClipShape && !this.softClipShape.contain(x, y)) {
        continue;
      }

      symbolProxyShape.x = x - size[0] / 2;
      symbolProxyShape.y = y - size[1] / 2;
      symbolProxyShape.width = size[0];
      symbolProxyShape.height = size[1];
      symbolProxy.buildPath(path, symbolProxyShape, true);
    }
  },
  afterBrush: function (ctx) {
    var shape = this.shape;
    var points = shape.points;
    var size = shape.size;
    var canBoost = size[0] < BOOST_SIZE_THRESHOLD;

    if (!canBoost) {
      return;
    }

    this.setTransform(ctx); // PENDING If style or other canvas status changed?

    for (var i = 0; i < points.length;) {
      var x = points[i++];
      var y = points[i++];

      if (isNaN(x) || isNaN(y)) {
        continue;
      }

      if (this.softClipShape && !this.softClipShape.contain(x, y)) {
        continue;
      } // fillRect is faster than building a rect path and draw.
      // And it support light globalCompositeOperation.


      ctx.fillRect(x - size[0] / 2, y - size[1] / 2, size[0], size[1]);
    }

    this.restoreTransform(ctx);
  },
  findDataIndex: function (x, y) {
    // TODO ???
    // Consider transform
    var shape = this.shape;
    var points = shape.points;
    var size = shape.size;
    var w = Math.max(size[0], 4);
    var h = Math.max(size[1], 4); // Not consider transform
    // Treat each element as a rect
    // top down traverse

    for (var idx = points.length / 2 - 1; idx >= 0; idx--) {
      var i = idx * 2;
      var x0 = points[i] - w / 2;
      var y0 = points[i + 1] - h / 2;

      if (x >= x0 && y >= y0 && x <= x0 + w && y <= y0 + h) {
        return idx;
      }
    }

    return -1;
  }
});

function LargeSymbolDraw() {
  this.group = new graphic.Group();
}

var largeSymbolProto = LargeSymbolDraw.prototype;

largeSymbolProto.isPersistent = function () {
  return !this._incremental;
};
/**
 * Update symbols draw by new data
 * @param {module:echarts/data/List} data
 * @param {Object} opt
 * @param {Object} [opt.clipShape]
 */


largeSymbolProto.updateData = function (data, opt) {
  this.group.removeAll();
  var symbolEl = new LargeSymbolPath({
    rectHover: true,
    cursor: 'default'
  });
  symbolEl.setShape({
    points: data.getLayout('symbolPoints')
  });

  this._setCommon(symbolEl, data, false, opt);

  this.group.add(symbolEl);
  this._incremental = null;
};

largeSymbolProto.updateLayout = function (data) {
  if (this._incremental) {
    return;
  }

  var points = data.getLayout('symbolPoints');
  this.group.eachChild(function (child) {
    if (child.startIndex != null) {
      var len = (child.endIndex - child.startIndex) * 2;
      var byteOffset = child.startIndex * 4 * 2;
      points = new Float32Array(points.buffer, byteOffset, len);
    }

    child.setShape('points', points);
  });
};

largeSymbolProto.incrementalPrepareUpdate = function (data) {
  this.group.removeAll();

  this._clearIncremental(); // Only use incremental displayables when data amount is larger than 2 million.
  // PENDING Incremental data?


  if (data.count() > 2e6) {
    if (!this._incremental) {
      this._incremental = new IncrementalDisplayable({
        silent: true
      });
    }

    this.group.add(this._incremental);
  } else {
    this._incremental = null;
  }
};

largeSymbolProto.incrementalUpdate = function (taskParams, data, opt) {
  var symbolEl;

  if (this._incremental) {
    symbolEl = new LargeSymbolPath();

    this._incremental.addDisplayable(symbolEl, true);
  } else {
    symbolEl = new LargeSymbolPath({
      rectHover: true,
      cursor: 'default',
      startIndex: taskParams.start,
      endIndex: taskParams.end
    });
    symbolEl.incremental = true;
    this.group.add(symbolEl);
  }

  symbolEl.setShape({
    points: data.getLayout('symbolPoints')
  });

  this._setCommon(symbolEl, data, !!this._incremental, opt);
};

largeSymbolProto._setCommon = function (symbolEl, data, isIncremental, opt) {
  var hostModel = data.hostModel;
  opt = opt || {}; // TODO
  // if (data.hasItemVisual.symbolSize) {
  //     // TODO typed array?
  //     symbolEl.setShape('sizes', data.mapArray(
  //         function (idx) {
  //             var size = data.getItemVisual(idx, 'symbolSize');
  //             return (size instanceof Array) ? size : [size, size];
  //         }
  //     ));
  // }
  // else {

  var size = data.getVisual('symbolSize');
  symbolEl.setShape('size', size instanceof Array ? size : [size, size]); // }

  symbolEl.softClipShape = opt.clipShape || null; // Create symbolProxy to build path for each data

  symbolEl.symbolProxy = createSymbol(data.getVisual('symbol'), 0, 0, 0, 0); // Use symbolProxy setColor method

  symbolEl.setColor = symbolEl.symbolProxy.setColor;
  var extrudeShadow = symbolEl.shape.size[0] < BOOST_SIZE_THRESHOLD;
  symbolEl.useStyle( // Draw shadow when doing fillRect is extremely slow.
  hostModel.getModel('itemStyle').getItemStyle(extrudeShadow ? ['color', 'shadowBlur', 'shadowColor'] : ['color']));
  var visualColor = data.getVisual('color');

  if (visualColor) {
    symbolEl.setColor(visualColor);
  }

  if (!isIncremental) {
    // Enable tooltip
    // PENDING May have performance issue when path is extremely large
    symbolEl.seriesIndex = hostModel.seriesIndex;
    symbolEl.on('mousemove', function (e) {
      symbolEl.dataIndex = null;
      var dataIndex = symbolEl.findDataIndex(e.offsetX, e.offsetY);

      if (dataIndex >= 0) {
        // Provide dataIndex for tooltip
        symbolEl.dataIndex = dataIndex + (symbolEl.startIndex || 0);
      }
    });
  }
};

largeSymbolProto.remove = function () {
  this._clearIncremental();

  this._incremental = null;
  this.group.removeAll();
};

largeSymbolProto._clearIncremental = function () {
  var incremental = this._incremental;

  if (incremental) {
    incremental.clearDisplaybles();
  }
};

var _default = LargeSymbolDraw;
module.exports = _default;

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(1598);

__webpack_require__(1603);

__webpack_require__(1604);

var dataColor = __webpack_require__(304);

var visualSymbol = __webpack_require__(178);

var radarLayout = __webpack_require__(1605);

var dataFilter = __webpack_require__(244);

var backwardCompat = __webpack_require__(1606);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Must use radar component
echarts.registerVisual(dataColor('radar'));
echarts.registerVisual(visualSymbol('radar', 'circle'));
echarts.registerLayout(radarLayout);
echarts.registerProcessor(dataFilter('radar'));
echarts.registerPreprocessor(backwardCompat);

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

__webpack_require__(1599);

__webpack_require__(1601);

__webpack_require__(1602);

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var IndicatorAxis = __webpack_require__(1600);

var IntervalScale = __webpack_require__(299);

var numberUtil = __webpack_require__(37);

var _axisHelper = __webpack_require__(109);

var getScaleExtent = _axisHelper.getScaleExtent;
var niceScaleExtent = _axisHelper.niceScaleExtent;

var CoordinateSystem = __webpack_require__(108);

var LogScale = __webpack_require__(644);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// TODO clockwise
function Radar(radarModel, ecModel, api) {
  this._model = radarModel;
  /**
   * Radar dimensions
   * @type {Array.<string>}
   */

  this.dimensions = [];
  this._indicatorAxes = zrUtil.map(radarModel.getIndicatorModels(), function (indicatorModel, idx) {
    var dim = 'indicator_' + idx;
    var indicatorAxis = new IndicatorAxis(dim, indicatorModel.get('axisType') === 'log' ? new LogScale() : new IntervalScale());
    indicatorAxis.name = indicatorModel.get('name'); // Inject model and axis

    indicatorAxis.model = indicatorModel;
    indicatorModel.axis = indicatorAxis;
    this.dimensions.push(dim);
    return indicatorAxis;
  }, this);
  this.resize(radarModel, api);
  /**
   * @type {number}
   * @readOnly
   */

  this.cx;
  /**
   * @type {number}
   * @readOnly
   */

  this.cy;
  /**
   * @type {number}
   * @readOnly
   */

  this.r;
  /**
   * @type {number}
   * @readOnly
   */

  this.r0;
  /**
   * @type {number}
   * @readOnly
   */

  this.startAngle;
}

Radar.prototype.getIndicatorAxes = function () {
  return this._indicatorAxes;
};

Radar.prototype.dataToPoint = function (value, indicatorIndex) {
  var indicatorAxis = this._indicatorAxes[indicatorIndex];
  return this.coordToPoint(indicatorAxis.dataToCoord(value), indicatorIndex);
};

Radar.prototype.coordToPoint = function (coord, indicatorIndex) {
  var indicatorAxis = this._indicatorAxes[indicatorIndex];
  var angle = indicatorAxis.angle;
  var x = this.cx + coord * Math.cos(angle);
  var y = this.cy - coord * Math.sin(angle);
  return [x, y];
};

Radar.prototype.pointToData = function (pt) {
  var dx = pt[0] - this.cx;
  var dy = pt[1] - this.cy;
  var radius = Math.sqrt(dx * dx + dy * dy);
  dx /= radius;
  dy /= radius;
  var radian = Math.atan2(-dy, dx); // Find the closest angle
  // FIXME index can calculated directly

  var minRadianDiff = Infinity;
  var closestAxis;
  var closestAxisIdx = -1;

  for (var i = 0; i < this._indicatorAxes.length; i++) {
    var indicatorAxis = this._indicatorAxes[i];
    var diff = Math.abs(radian - indicatorAxis.angle);

    if (diff < minRadianDiff) {
      closestAxis = indicatorAxis;
      closestAxisIdx = i;
      minRadianDiff = diff;
    }
  }

  return [closestAxisIdx, +(closestAxis && closestAxis.coordToData(radius))];
};

Radar.prototype.resize = function (radarModel, api) {
  var center = radarModel.get('center');
  var viewWidth = api.getWidth();
  var viewHeight = api.getHeight();
  var viewSize = Math.min(viewWidth, viewHeight) / 2;
  this.cx = numberUtil.parsePercent(center[0], viewWidth);
  this.cy = numberUtil.parsePercent(center[1], viewHeight);
  this.startAngle = radarModel.get('startAngle') * Math.PI / 180; // radius may be single value like `20`, `'80%'`, or array like `[10, '80%']`

  var radius = radarModel.get('radius');

  if (typeof radius === 'string' || typeof radius === 'number') {
    radius = [0, radius];
  }

  this.r0 = numberUtil.parsePercent(radius[0], viewSize);
  this.r = numberUtil.parsePercent(radius[1], viewSize);
  zrUtil.each(this._indicatorAxes, function (indicatorAxis, idx) {
    indicatorAxis.setExtent(this.r0, this.r);
    var angle = this.startAngle + idx * Math.PI * 2 / this._indicatorAxes.length; // Normalize to [-PI, PI]

    angle = Math.atan2(Math.sin(angle), Math.cos(angle));
    indicatorAxis.angle = angle;
  }, this);
};

Radar.prototype.update = function (ecModel, api) {
  var indicatorAxes = this._indicatorAxes;
  var radarModel = this._model;
  zrUtil.each(indicatorAxes, function (indicatorAxis) {
    indicatorAxis.scale.setExtent(Infinity, -Infinity);
  });
  ecModel.eachSeriesByType('radar', function (radarSeries, idx) {
    if (radarSeries.get('coordinateSystem') !== 'radar' || ecModel.getComponent('radar', radarSeries.get('radarIndex')) !== radarModel) {
      return;
    }

    var data = radarSeries.getData();
    zrUtil.each(indicatorAxes, function (indicatorAxis) {
      indicatorAxis.scale.unionExtentFromData(data, data.mapDimension(indicatorAxis.dim));
    });
  }, this);
  var splitNumber = radarModel.get('splitNumber');

  function increaseInterval(interval) {
    var exp10 = Math.pow(10, Math.floor(Math.log(interval) / Math.LN10)); // Increase interval

    var f = interval / exp10;

    if (f === 2) {
      f = 5;
    } else {
      // f is 2 or 5
      f *= 2;
    }

    return f * exp10;
  } // Force all the axis fixing the maxSplitNumber.


  zrUtil.each(indicatorAxes, function (indicatorAxis, idx) {
    var rawExtent = getScaleExtent(indicatorAxis.scale, indicatorAxis.model).extent;
    niceScaleExtent(indicatorAxis.scale, indicatorAxis.model);
    var axisModel = indicatorAxis.model;
    var scale = indicatorAxis.scale;
    var fixedMin = axisModel.getMin();
    var fixedMax = axisModel.getMax();
    var interval = scale.getInterval();

    if (fixedMin != null && fixedMax != null) {
      // User set min, max, divide to get new interval
      scale.setExtent(+fixedMin, +fixedMax);
      scale.setInterval((fixedMax - fixedMin) / splitNumber);
    } else if (fixedMin != null) {
      var max; // User set min, expand extent on the other side

      do {
        max = fixedMin + interval * splitNumber;
        scale.setExtent(+fixedMin, max); // Interval must been set after extent
        // FIXME

        scale.setInterval(interval);
        interval = increaseInterval(interval);
      } while (max < rawExtent[1] && isFinite(max) && isFinite(rawExtent[1]));
    } else if (fixedMax != null) {
      var min; // User set min, expand extent on the other side

      do {
        min = fixedMax - interval * splitNumber;
        scale.setExtent(min, +fixedMax);
        scale.setInterval(interval);
        interval = increaseInterval(interval);
      } while (min > rawExtent[0] && isFinite(min) && isFinite(rawExtent[0]));
    } else {
      var nicedSplitNumber = scale.getTicks().length - 1;

      if (nicedSplitNumber > splitNumber) {
        interval = increaseInterval(interval);
      } // TODO


      var max = Math.ceil(rawExtent[1] / interval) * interval;
      var min = numberUtil.round(max - interval * splitNumber);
      scale.setExtent(min, max);
      scale.setInterval(interval);
    }
  });
};
/**
 * Radar dimensions is based on the data
 * @type {Array}
 */


Radar.dimensions = [];

Radar.create = function (ecModel, api) {
  var radarList = [];
  ecModel.eachComponent('radar', function (radarModel) {
    var radar = new Radar(radarModel, ecModel, api);
    radarList.push(radar);
    radarModel.coordinateSystem = radar;
  });
  ecModel.eachSeriesByType('radar', function (radarSeries) {
    if (radarSeries.get('coordinateSystem') === 'radar') {
      // Inject coordinate system
      radarSeries.coordinateSystem = radarList[radarSeries.get('radarIndex') || 0];
    }
  });
  return radarList;
};

CoordinateSystem.register('radar', Radar);
var _default = Radar;
module.exports = _default;

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var Axis = __webpack_require__(150);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function IndicatorAxis(dim, scale, radiusExtent) {
  Axis.call(this, dim, scale, radiusExtent);
  /**
   * Axis type
   *  - 'category'
   *  - 'value'
   *  - 'time'
   *  - 'log'
   * @type {string}
   */

  this.type = 'value';
  this.angle = 0;
  /**
   * Indicator name
   * @type {string}
   */

  this.name = '';
  /**
   * @type {module:echarts/model/Model}
   */

  this.model;
}

zrUtil.inherits(IndicatorAxis, Axis);
var _default = IndicatorAxis;
module.exports = _default;

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var axisDefault = __webpack_require__(651);

var Model = __webpack_require__(68);

var axisModelCommonMixin = __webpack_require__(208);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var valueAxisDefault = axisDefault.valueAxis;

function defaultsShow(opt, show) {
  return zrUtil.defaults({
    show: show
  }, opt);
}

var RadarModel = echarts.extendComponentModel({
  type: 'radar',
  optionUpdated: function () {
    var boundaryGap = this.get('boundaryGap');
    var splitNumber = this.get('splitNumber');
    var scale = this.get('scale');
    var axisLine = this.get('axisLine');
    var axisTick = this.get('axisTick');
    var axisType = this.get('axisType');
    var axisLabel = this.get('axisLabel');
    var nameTextStyle = this.get('name');
    var showName = this.get('name.show');
    var nameFormatter = this.get('name.formatter');
    var nameGap = this.get('nameGap');
    var triggerEvent = this.get('triggerEvent');
    var indicatorModels = zrUtil.map(this.get('indicator') || [], function (indicatorOpt) {
      // PENDING
      if (indicatorOpt.max != null && indicatorOpt.max > 0 && !indicatorOpt.min) {
        indicatorOpt.min = 0;
      } else if (indicatorOpt.min != null && indicatorOpt.min < 0 && !indicatorOpt.max) {
        indicatorOpt.max = 0;
      }

      var iNameTextStyle = nameTextStyle;

      if (indicatorOpt.color != null) {
        iNameTextStyle = zrUtil.defaults({
          color: indicatorOpt.color
        }, nameTextStyle);
      } // Use same configuration


      indicatorOpt = zrUtil.merge(zrUtil.clone(indicatorOpt), {
        boundaryGap: boundaryGap,
        splitNumber: splitNumber,
        scale: scale,
        axisLine: axisLine,
        axisTick: axisTick,
        axisType: axisType,
        axisLabel: axisLabel,
        // Compatible with 2 and use text
        name: indicatorOpt.text,
        nameLocation: 'end',
        nameGap: nameGap,
        // min: 0,
        nameTextStyle: iNameTextStyle,
        triggerEvent: triggerEvent
      }, false);

      if (!showName) {
        indicatorOpt.name = '';
      }

      if (typeof nameFormatter === 'string') {
        var indName = indicatorOpt.name;
        indicatorOpt.name = nameFormatter.replace('{value}', indName != null ? indName : '');
      } else if (typeof nameFormatter === 'function') {
        indicatorOpt.name = nameFormatter(indicatorOpt.name, indicatorOpt);
      }

      var model = zrUtil.extend(new Model(indicatorOpt, null, this.ecModel), axisModelCommonMixin); // For triggerEvent.

      model.mainType = 'radar';
      model.componentIndex = this.componentIndex;
      return model;
    }, this);

    this.getIndicatorModels = function () {
      return indicatorModels;
    };
  },
  defaultOption: {
    zlevel: 0,
    z: 0,
    center: ['50%', '50%'],
    radius: '75%',
    startAngle: 90,
    name: {
      show: true // formatter: null
      // textStyle: {}

    },
    boundaryGap: [0, 0],
    splitNumber: 5,
    nameGap: 15,
    scale: false,
    // Polygon or circle
    shape: 'polygon',
    axisLine: zrUtil.merge({
      lineStyle: {
        color: '#bbb'
      }
    }, valueAxisDefault.axisLine),
    axisLabel: defaultsShow(valueAxisDefault.axisLabel, false),
    axisTick: defaultsShow(valueAxisDefault.axisTick, false),
    axisType: 'interval',
    splitLine: defaultsShow(valueAxisDefault.splitLine, true),
    splitArea: defaultsShow(valueAxisDefault.splitArea, true),
    // {text, min, max}
    indicator: []
  }
});
var _default = RadarModel;
module.exports = _default;

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var AxisBuilder = __webpack_require__(151);

var graphic = __webpack_require__(27);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];

var _default = echarts.extendComponentView({
  type: 'radar',
  render: function (radarModel, ecModel, api) {
    var group = this.group;
    group.removeAll();

    this._buildAxes(radarModel);

    this._buildSplitLineAndArea(radarModel);
  },
  _buildAxes: function (radarModel) {
    var radar = radarModel.coordinateSystem;
    var indicatorAxes = radar.getIndicatorAxes();
    var axisBuilders = zrUtil.map(indicatorAxes, function (indicatorAxis) {
      var axisBuilder = new AxisBuilder(indicatorAxis.model, {
        position: [radar.cx, radar.cy],
        rotation: indicatorAxis.angle,
        labelDirection: -1,
        tickDirection: -1,
        nameDirection: 1
      });
      return axisBuilder;
    });
    zrUtil.each(axisBuilders, function (axisBuilder) {
      zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
      this.group.add(axisBuilder.getGroup());
    }, this);
  },
  _buildSplitLineAndArea: function (radarModel) {
    var radar = radarModel.coordinateSystem;
    var indicatorAxes = radar.getIndicatorAxes();

    if (!indicatorAxes.length) {
      return;
    }

    var shape = radarModel.get('shape');
    var splitLineModel = radarModel.getModel('splitLine');
    var splitAreaModel = radarModel.getModel('splitArea');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var showSplitLine = splitLineModel.get('show');
    var showSplitArea = splitAreaModel.get('show');
    var splitLineColors = lineStyleModel.get('color');
    var splitAreaColors = areaStyleModel.get('color');
    splitLineColors = zrUtil.isArray(splitLineColors) ? splitLineColors : [splitLineColors];
    splitAreaColors = zrUtil.isArray(splitAreaColors) ? splitAreaColors : [splitAreaColors];
    var splitLines = [];
    var splitAreas = [];

    function getColorIndex(areaOrLine, areaOrLineColorList, idx) {
      var colorIndex = idx % areaOrLineColorList.length;
      areaOrLine[colorIndex] = areaOrLine[colorIndex] || [];
      return colorIndex;
    }

    if (shape === 'circle') {
      var ticksRadius = indicatorAxes[0].getTicksCoords();
      var cx = radar.cx;
      var cy = radar.cy;

      for (var i = 0; i < ticksRadius.length; i++) {
        if (showSplitLine) {
          var colorIndex = getColorIndex(splitLines, splitLineColors, i);
          splitLines[colorIndex].push(new graphic.Circle({
            shape: {
              cx: cx,
              cy: cy,
              r: ticksRadius[i].coord
            }
          }));
        }

        if (showSplitArea && i < ticksRadius.length - 1) {
          var colorIndex = getColorIndex(splitAreas, splitAreaColors, i);
          splitAreas[colorIndex].push(new graphic.Ring({
            shape: {
              cx: cx,
              cy: cy,
              r0: ticksRadius[i].coord,
              r: ticksRadius[i + 1].coord
            }
          }));
        }
      }
    } // Polyyon
    else {
        var realSplitNumber;
        var axesTicksPoints = zrUtil.map(indicatorAxes, function (indicatorAxis, idx) {
          var ticksCoords = indicatorAxis.getTicksCoords();
          realSplitNumber = realSplitNumber == null ? ticksCoords.length - 1 : Math.min(ticksCoords.length - 1, realSplitNumber);
          return zrUtil.map(ticksCoords, function (tickCoord) {
            return radar.coordToPoint(tickCoord.coord, idx);
          });
        });
        var prevPoints = [];

        for (var i = 0; i <= realSplitNumber; i++) {
          var points = [];

          for (var j = 0; j < indicatorAxes.length; j++) {
            points.push(axesTicksPoints[j][i]);
          } // Close


          if (points[0]) {
            points.push(points[0].slice());
          } else {}

          if (showSplitLine) {
            var colorIndex = getColorIndex(splitLines, splitLineColors, i);
            splitLines[colorIndex].push(new graphic.Polyline({
              shape: {
                points: points
              }
            }));
          }

          if (showSplitArea && prevPoints) {
            var colorIndex = getColorIndex(splitAreas, splitAreaColors, i - 1);
            splitAreas[colorIndex].push(new graphic.Polygon({
              shape: {
                points: points.concat(prevPoints)
              }
            }));
          }

          prevPoints = points.slice().reverse();
        }
      }

    var lineStyle = lineStyleModel.getLineStyle();
    var areaStyle = areaStyleModel.getAreaStyle(); // Add splitArea before splitLine

    zrUtil.each(splitAreas, function (splitAreas, idx) {
      this.group.add(graphic.mergePath(splitAreas, {
        style: zrUtil.defaults({
          stroke: 'none',
          fill: splitAreaColors[idx % splitAreaColors.length]
        }, areaStyle),
        silent: true
      }));
    }, this);
    zrUtil.each(splitLines, function (splitLines, idx) {
      this.group.add(graphic.mergePath(splitLines, {
        style: zrUtil.defaults({
          fill: 'none',
          stroke: splitLineColors[idx % splitLineColors.length]
        }, lineStyle),
        silent: true
      }));
    }, this);
  }
});

module.exports = _default;

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var SeriesModel = __webpack_require__(74);

var createListSimply = __webpack_require__(209);

var zrUtil = __webpack_require__(1);

var _format = __webpack_require__(54);

var encodeHTML = _format.encodeHTML;

var LegendVisualProvider = __webpack_require__(243);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var RadarSeries = SeriesModel.extend({
  type: 'series.radar',
  dependencies: ['radar'],
  // Overwrite
  init: function (option) {
    RadarSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
    // Use a function instead of direct access because data reference may changed

    this.legendVisualProvider = new LegendVisualProvider(zrUtil.bind(this.getData, this), zrUtil.bind(this.getRawData, this));
  },
  getInitialData: function (option, ecModel) {
    return createListSimply(this, {
      generateCoord: 'indicator_',
      generateCoordCount: Infinity
    });
  },
  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
    var data = this.getData();
    var coordSys = this.coordinateSystem;
    var indicatorAxes = coordSys.getIndicatorAxes();
    var name = this.getData().getName(dataIndex);
    var newLine = renderMode === 'html' ? '<br/>' : '\n';
    return encodeHTML(name === '' ? this.name : name) + newLine + zrUtil.map(indicatorAxes, function (axis, idx) {
      var val = data.get(data.mapDimension(axis.dim), dataIndex);
      return encodeHTML(axis.name + ' : ' + val);
    }).join(newLine);
  },

  /**
   * @implement
   */
  getTooltipPosition: function (dataIndex) {
    if (dataIndex != null) {
      var data = this.getData();
      var coordSys = this.coordinateSystem;
      var values = data.getValues(zrUtil.map(coordSys.dimensions, function (dim) {
        return data.mapDimension(dim);
      }), dataIndex, true);

      for (var i = 0, len = values.length; i < len; i++) {
        if (!isNaN(values[i])) {
          var indicatorAxes = coordSys.getIndicatorAxes();
          return coordSys.coordToPoint(indicatorAxes[i].dataToCoord(values[i]), i);
        }
      }
    }
  },
  defaultOption: {
    zlevel: 0,
    z: 2,
    coordinateSystem: 'radar',
    legendHoverLink: true,
    radarIndex: 0,
    lineStyle: {
      width: 2,
      type: 'solid'
    },
    label: {
      position: 'top'
    },
    // areaStyle: {
    // },
    // itemStyle: {}
    symbol: 'emptyCircle',
    symbolSize: 4 // symbolRotate: null

  }
});
var _default = RadarSeries;
module.exports = _default;

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var graphic = __webpack_require__(27);

var zrUtil = __webpack_require__(1);

var symbolUtil = __webpack_require__(99);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function normalizeSymbolSize(symbolSize) {
  if (!zrUtil.isArray(symbolSize)) {
    symbolSize = [+symbolSize, +symbolSize];
  }

  return symbolSize;
}

var _default = echarts.extendChartView({
  type: 'radar',
  render: function (seriesModel, ecModel, api) {
    var polar = seriesModel.coordinateSystem;
    var group = this.group;
    var data = seriesModel.getData();
    var oldData = this._data;

    function createSymbol(data, idx) {
      var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
      var color = data.getItemVisual(idx, 'color');

      if (symbolType === 'none') {
        return;
      }

      var symbolSize = normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
      var symbolPath = symbolUtil.createSymbol(symbolType, -1, -1, 2, 2, color);
      var symbolRotate = data.getItemVisual(idx, 'symbolRotate') || 0;
      symbolPath.attr({
        style: {
          strokeNoScale: true
        },
        z2: 100,
        scale: [symbolSize[0] / 2, symbolSize[1] / 2],
        rotation: symbolRotate * Math.PI / 180 || 0
      });
      return symbolPath;
    }

    function updateSymbols(oldPoints, newPoints, symbolGroup, data, idx, isInit) {
      // Simply rerender all
      symbolGroup.removeAll();

      for (var i = 0; i < newPoints.length - 1; i++) {
        var symbolPath = createSymbol(data, idx);

        if (symbolPath) {
          symbolPath.__dimIdx = i;

          if (oldPoints[i]) {
            symbolPath.attr('position', oldPoints[i]);
            graphic[isInit ? 'initProps' : 'updateProps'](symbolPath, {
              position: newPoints[i]
            }, seriesModel, idx);
          } else {
            symbolPath.attr('position', newPoints[i]);
          }

          symbolGroup.add(symbolPath);
        }
      }
    }

    function getInitialPoints(points) {
      return zrUtil.map(points, function (pt) {
        return [polar.cx, polar.cy];
      });
    }

    data.diff(oldData).add(function (idx) {
      var points = data.getItemLayout(idx);

      if (!points) {
        return;
      }

      var polygon = new graphic.Polygon();
      var polyline = new graphic.Polyline();
      var target = {
        shape: {
          points: points
        }
      };
      polygon.shape.points = getInitialPoints(points);
      polyline.shape.points = getInitialPoints(points);
      graphic.initProps(polygon, target, seriesModel, idx);
      graphic.initProps(polyline, target, seriesModel, idx);
      var itemGroup = new graphic.Group();
      var symbolGroup = new graphic.Group();
      itemGroup.add(polyline);
      itemGroup.add(polygon);
      itemGroup.add(symbolGroup);
      updateSymbols(polyline.shape.points, points, symbolGroup, data, idx, true);
      data.setItemGraphicEl(idx, itemGroup);
    }).update(function (newIdx, oldIdx) {
      var itemGroup = oldData.getItemGraphicEl(oldIdx);
      var polyline = itemGroup.childAt(0);
      var polygon = itemGroup.childAt(1);
      var symbolGroup = itemGroup.childAt(2);
      var target = {
        shape: {
          points: data.getItemLayout(newIdx)
        }
      };

      if (!target.shape.points) {
        return;
      }

      updateSymbols(polyline.shape.points, target.shape.points, symbolGroup, data, newIdx, false);
      graphic.updateProps(polyline, target, seriesModel);
      graphic.updateProps(polygon, target, seriesModel);
      data.setItemGraphicEl(newIdx, itemGroup);
    }).remove(function (idx) {
      group.remove(oldData.getItemGraphicEl(idx));
    }).execute();
    data.eachItemGraphicEl(function (itemGroup, idx) {
      var itemModel = data.getItemModel(idx);
      var polyline = itemGroup.childAt(0);
      var polygon = itemGroup.childAt(1);
      var symbolGroup = itemGroup.childAt(2);
      var color = data.getItemVisual(idx, 'color');
      group.add(itemGroup);
      polyline.useStyle(zrUtil.defaults(itemModel.getModel('lineStyle').getLineStyle(), {
        fill: 'none',
        stroke: color
      }));
      polyline.hoverStyle = itemModel.getModel('emphasis.lineStyle').getLineStyle();
      var areaStyleModel = itemModel.getModel('areaStyle');
      var hoverAreaStyleModel = itemModel.getModel('emphasis.areaStyle');
      var polygonIgnore = areaStyleModel.isEmpty() && areaStyleModel.parentModel.isEmpty();
      var hoverPolygonIgnore = hoverAreaStyleModel.isEmpty() && hoverAreaStyleModel.parentModel.isEmpty();
      hoverPolygonIgnore = hoverPolygonIgnore && polygonIgnore;
      polygon.ignore = polygonIgnore;
      polygon.useStyle(zrUtil.defaults(areaStyleModel.getAreaStyle(), {
        fill: color,
        opacity: 0.7
      }));
      polygon.hoverStyle = hoverAreaStyleModel.getAreaStyle();
      var itemStyle = itemModel.getModel('itemStyle').getItemStyle(['color']);
      var itemHoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
      var labelModel = itemModel.getModel('label');
      var labelHoverModel = itemModel.getModel('emphasis.label');
      symbolGroup.eachChild(function (symbolPath) {
        symbolPath.setStyle(itemStyle);
        symbolPath.hoverStyle = zrUtil.clone(itemHoverStyle);
        var defaultText = data.get(data.dimensions[symbolPath.__dimIdx], idx);
        (defaultText == null || isNaN(defaultText)) && (defaultText = '');
        graphic.setLabelStyle(symbolPath.style, symbolPath.hoverStyle, labelModel, labelHoverModel, {
          labelFetcher: data.hostModel,
          labelDataIndex: idx,
          labelDimIndex: symbolPath.__dimIdx,
          defaultText: defaultText,
          autoColor: color,
          isRectText: true
        });
      });

      itemGroup.highDownOnUpdate = function (fromState, toState) {
        polygon.attr('ignore', toState === 'emphasis' ? hoverPolygonIgnore : polygonIgnore);
      };

      graphic.setHoverStyle(itemGroup);
    });
    this._data = data;
  },
  remove: function () {
    this.group.removeAll();
    this._data = null;
  },
  dispose: function () {}
});

module.exports = _default;

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(ecModel) {
  ecModel.eachSeriesByType('radar', function (seriesModel) {
    var data = seriesModel.getData();
    var points = [];
    var coordSys = seriesModel.coordinateSystem;

    if (!coordSys) {
      return;
    }

    var axes = coordSys.getIndicatorAxes();
    zrUtil.each(axes, function (axis, axisIndex) {
      data.each(data.mapDimension(axes[axisIndex].dim), function (val, dataIndex) {
        points[dataIndex] = points[dataIndex] || [];
        var point = coordSys.dataToPoint(val, axisIndex);
        points[dataIndex][axisIndex] = isValidPoint(point) ? point : getValueMissingPoint(coordSys);
      });
    }); // Close polygon

    data.each(function (idx) {
      // TODO
      // Is it appropriate to connect to the next data when some data is missing?
      // Or, should trade it like `connectNull` in line chart?
      var firstPoint = zrUtil.find(points[idx], function (point) {
        return isValidPoint(point);
      }) || getValueMissingPoint(coordSys); // Copy the first actual point to the end of the array

      points[idx].push(firstPoint.slice());
      data.setItemLayout(idx, points[idx]);
    });
  });
}

function isValidPoint(point) {
  return !isNaN(point[0]) && !isNaN(point[1]);
}

function getValueMissingPoint(coordSys) {
  // It is error-prone to input [NaN, NaN] into polygon, polygon.
  // (probably cause problem when refreshing or animating)
  return [coordSys.cx, coordSys.cy];
}

module.exports = _default;

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Backward compat for radar chart in 2
function _default(option) {
  var polarOptArr = option.polar;

  if (polarOptArr) {
    if (!zrUtil.isArray(polarOptArr)) {
      polarOptArr = [polarOptArr];
    }

    var polarNotRadar = [];
    zrUtil.each(polarOptArr, function (polarOpt, idx) {
      if (polarOpt.indicator) {
        if (polarOpt.type && !polarOpt.shape) {
          polarOpt.shape = polarOpt.type;
        }

        option.radar = option.radar || [];

        if (!zrUtil.isArray(option.radar)) {
          option.radar = [option.radar];
        }

        option.radar.push(polarOpt);
      } else {
        polarNotRadar.push(polarOpt);
      }
    });
    option.polar = polarNotRadar;
  }

  zrUtil.each(option.series, function (seriesOpt) {
    if (seriesOpt && seriesOpt.type === 'radar' && seriesOpt.polarIndex) {
      seriesOpt.radarIndex = seriesOpt.polarIndex;
    }
  });
}

module.exports = _default;

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(1608);

__webpack_require__(1615);

__webpack_require__(659);

__webpack_require__(419);

var mapSymbolLayout = __webpack_require__(1617);

var mapVisual = __webpack_require__(1618);

var mapDataStatistic = __webpack_require__(1619);

var backwardCompat = __webpack_require__(1620);

var createDataSelectAction = __webpack_require__(656);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.registerLayout(mapSymbolLayout);
echarts.registerVisual(mapVisual);
echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, mapDataStatistic);
echarts.registerPreprocessor(backwardCompat);
createDataSelectAction('map', [{
  type: 'mapToggleSelect',
  event: 'mapselectchanged',
  method: 'toggleSelected'
}, {
  type: 'mapSelect',
  event: 'mapselected',
  method: 'select'
}, {
  type: 'mapUnSelect',
  event: 'mapunselected',
  method: 'unSelect'
}]);

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var createListSimply = __webpack_require__(209);

var SeriesModel = __webpack_require__(74);

var _format = __webpack_require__(54);

var encodeHTML = _format.encodeHTML;
var addCommas = _format.addCommas;

var dataSelectableMixin = __webpack_require__(416);

var _dataProvider = __webpack_require__(176);

var retrieveRawAttr = _dataProvider.retrieveRawAttr;

var geoSourceManager = __webpack_require__(305);

var _sourceHelper = __webpack_require__(136);

var makeSeriesEncodeForNameBased = _sourceHelper.makeSeriesEncodeForNameBased;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var MapSeries = SeriesModel.extend({
  type: 'series.map',
  dependencies: ['geo'],
  layoutMode: 'box',

  /**
   * Only first map series of same mapType will drawMap
   * @type {boolean}
   */
  needsDrawMap: false,

  /**
   * Group of all map series with same mapType
   * @type {boolean}
   */
  seriesGroup: [],
  getInitialData: function (option) {
    var data = createListSimply(this, {
      coordDimensions: ['value'],
      encodeDefaulter: zrUtil.curry(makeSeriesEncodeForNameBased, this)
    });
    var valueDim = data.mapDimension('value');
    var dataNameMap = zrUtil.createHashMap();
    var selectTargetList = [];
    var toAppendNames = [];

    for (var i = 0, len = data.count(); i < len; i++) {
      var name = data.getName(i);
      dataNameMap.set(name, true);
      selectTargetList.push({
        name: name,
        value: data.get(valueDim, i),
        selected: retrieveRawAttr(data, i, 'selected')
      });
    }

    var geoSource = geoSourceManager.load(this.getMapType(), this.option.nameMap, this.option.nameProperty);
    zrUtil.each(geoSource.regions, function (region) {
      var name = region.name;

      if (!dataNameMap.get(name)) {
        selectTargetList.push({
          name: name
        });
        toAppendNames.push(name);
      }
    });
    this.updateSelectedMap(selectTargetList); // Complete data with missing regions. The consequent processes (like visual
    // map and render) can not be performed without a "full data". For example,
    // find `dataIndex` by name.

    data.appendValues([], toAppendNames);
    return data;
  },

  /**
   * If no host geo model, return null, which means using a
   * inner exclusive geo model.
   */
  getHostGeoModel: function () {
    var geoIndex = this.option.geoIndex;
    return geoIndex != null ? this.dependentModels.geo[geoIndex] : null;
  },
  getMapType: function () {
    return (this.getHostGeoModel() || this).option.map;
  },
  // _fillOption: function (option, mapName) {
  // Shallow clone
  // option = zrUtil.extend({}, option);
  // option.data = geoCreator.getFilledRegions(option.data, mapName, option.nameMap);
  // return option;
  // },
  getRawValue: function (dataIndex) {
    // Use value stored in data instead because it is calculated from multiple series
    // FIXME Provide all value of multiple series ?
    var data = this.getData();
    return data.get(data.mapDimension('value'), dataIndex);
  },

  /**
   * Get model of region
   * @param  {string} name
   * @return {module:echarts/model/Model}
   */
  getRegionModel: function (regionName) {
    var data = this.getData();
    return data.getItemModel(data.indexOfName(regionName));
  },

  /**
   * Map tooltip formatter
   *
   * @param {number} dataIndex
   */
  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
    // FIXME orignalData and data is a bit confusing
    var data = this.getData();
    var formattedValue = addCommas(this.getRawValue(dataIndex));
    var name = data.getName(dataIndex);
    var seriesGroup = this.seriesGroup;
    var seriesNames = [];

    for (var i = 0; i < seriesGroup.length; i++) {
      var otherIndex = seriesGroup[i].originalData.indexOfName(name);
      var valueDim = data.mapDimension('value');

      if (!isNaN(seriesGroup[i].originalData.get(valueDim, otherIndex))) {
        seriesNames.push(encodeHTML(seriesGroup[i].name));
      }
    }

    var newLine = renderMode === 'html' ? '<br/>' : '\n';
    return seriesNames.join(', ') + newLine + encodeHTML(name + ' : ' + formattedValue);
  },

  /**
   * @implement
   */
  getTooltipPosition: function (dataIndex) {
    if (dataIndex != null) {
      var name = this.getData().getName(dataIndex);
      var geo = this.coordinateSystem;
      var region = geo.getRegion(name);
      return region && geo.dataToPoint(region.center);
    }
  },
  setZoom: function (zoom) {
    this.option.zoom = zoom;
  },
  setCenter: function (center) {
    this.option.center = center;
  },
  defaultOption: {
    // 一级层叠
    zlevel: 0,
    // 二级层叠
    z: 2,
    coordinateSystem: 'geo',
    // map should be explicitly specified since ec3.
    map: '',
    // If `geoIndex` is not specified, a exclusive geo will be
    // created. Otherwise use the specified geo component, and
    // `map` and `mapType` are ignored.
    // geoIndex: 0,
    // 'center' | 'left' | 'right' | 'x%' | {number}
    left: 'center',
    // 'center' | 'top' | 'bottom' | 'x%' | {number}
    top: 'center',
    // right
    // bottom
    // width:
    // height
    // Aspect is width / height. Inited to be geoJson bbox aspect
    // This parameter is used for scale this aspect
    aspectScale: 0.75,
    ///// Layout with center and size
    // If you wan't to put map in a fixed size box with right aspect ratio
    // This two properties may more conveninet
    // layoutCenter: [50%, 50%]
    // layoutSize: 100
    // 数值合并方式，默认加和，可选为：
    // 'sum' | 'average' | 'max' | 'min'
    // mapValueCalculation: 'sum',
    // 地图数值计算结果小数精度
    // mapValuePrecision: 0,
    // 显示图例颜色标识（系列标识的小圆点），图例开启时有效
    showLegendSymbol: true,
    // 选择模式，默认关闭，可选single，multiple
    // selectedMode: false,
    dataRangeHoverLink: true,
    // 是否开启缩放及漫游模式
    // roam: false,
    // Define left-top, right-bottom coords to control view
    // For example, [ [180, 90], [-180, -90] ],
    // higher priority than center and zoom
    boundingCoords: null,
    // Default on center of map
    center: null,
    zoom: 1,
    scaleLimit: null,
    label: {
      show: false,
      color: '#000'
    },
    // scaleLimit: null,
    itemStyle: {
      borderWidth: 0.5,
      borderColor: '#444',
      areaColor: '#eee'
    },
    emphasis: {
      label: {
        show: true,
        color: 'rgb(100,0,0)'
      },
      itemStyle: {
        areaColor: 'rgba(255,215,0,0.8)'
      }
    },
    nameProperty: 'name'
  }
});
zrUtil.mixin(MapSeries, dataSelectableMixin);
var _default = MapSeries;
module.exports = _default;

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(1);

var each = _util.each;

var parseGeoJson = __webpack_require__(645);

var _model = __webpack_require__(44);

var makeInner = _model.makeInner;

var fixNanhai = __webpack_require__(1610);

var fixTextCoord = __webpack_require__(1611);

var fixGeoCoord = __webpack_require__(1612);

var fixDiaoyuIsland = __webpack_require__(1613);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Built-in GEO fixer.
var inner = makeInner();
var _default = {
  /**
   * @param {string} mapName
   * @param {Object} mapRecord {specialAreas, geoJSON}
   * @param {string} nameProperty
   * @return {Object} {regions, boundingRect}
   */
  load: function (mapName, mapRecord, nameProperty) {
    var parsed = inner(mapRecord).parsed;

    if (parsed) {
      return parsed;
    }

    var specialAreas = mapRecord.specialAreas || {};
    var geoJSON = mapRecord.geoJSON;
    var regions; // https://jsperf.com/try-catch-performance-overhead

    try {
      regions = geoJSON ? parseGeoJson(geoJSON, nameProperty) : [];
    } catch (e) {
      throw new Error('Invalid geoJson format\n' + e.message);
    }

    fixNanhai(mapName, regions);
    each(regions, function (region) {
      var regionName = region.name;
      fixTextCoord(mapName, region);
      fixGeoCoord(mapName, region);
      fixDiaoyuIsland(mapName, region); // Some area like Alaska in USA map needs to be tansformed
      // to look better

      var specialArea = specialAreas[regionName];

      if (specialArea) {
        region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
      }
    });
    return inner(mapRecord).parsed = {
      regions: regions,
      boundingRect: getBoundingRect(regions)
    };
  }
};

function getBoundingRect(regions) {
  var rect;

  for (var i = 0; i < regions.length; i++) {
    var regionRect = regions[i].getBoundingRect();
    rect = rect || regionRect.clone();
    rect.union(regionRect);
  }

  return rect;
}

module.exports = _default;

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var Region = __webpack_require__(646);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Fix for 南海诸岛
var geoCoord = [126, 25];
var points = [[[0, 3.5], [7, 11.2], [15, 11.9], [30, 7], [42, 0.7], [52, 0.7], [56, 7.7], [59, 0.7], [64, 0.7], [64, 0], [5, 0], [0, 3.5]], [[13, 16.1], [19, 14.7], [16, 21.7], [11, 23.1], [13, 16.1]], [[12, 32.2], [14, 38.5], [15, 38.5], [13, 32.2], [12, 32.2]], [[16, 47.6], [12, 53.2], [13, 53.2], [18, 47.6], [16, 47.6]], [[6, 64.4], [8, 70], [9, 70], [8, 64.4], [6, 64.4]], [[23, 82.6], [29, 79.8], [30, 79.8], [25, 82.6], [23, 82.6]], [[37, 70.7], [43, 62.3], [44, 62.3], [39, 70.7], [37, 70.7]], [[48, 51.1], [51, 45.5], [53, 45.5], [50, 51.1], [48, 51.1]], [[51, 35], [51, 28.7], [53, 28.7], [53, 35], [51, 35]], [[52, 22.4], [55, 17.5], [56, 17.5], [53, 22.4], [52, 22.4]], [[58, 12.6], [62, 7], [63, 7], [60, 12.6], [58, 12.6]], [[0, 3.5], [0, 93.1], [64, 93.1], [64, 0], [63, 0], [63, 92.4], [1, 92.4], [1, 3.5], [0, 3.5]]];

for (var i = 0; i < points.length; i++) {
  for (var k = 0; k < points[i].length; k++) {
    points[i][k][0] /= 10.5;
    points[i][k][1] /= -10.5 / 0.75;
    points[i][k][0] += geoCoord[0];
    points[i][k][1] += geoCoord[1];
  }
}

function _default(mapType, regions) {
  if (mapType === 'china') {
    regions.push(new Region('南海诸岛', zrUtil.map(points, function (exterior) {
      return {
        type: 'polygon',
        exterior: exterior
      };
    }), geoCoord));
  }
}

module.exports = _default;

/***/ }),
/* 1611 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var coordsOffsetMap = {
  '南海诸岛': [32, 80],
  // 全国
  '广东': [0, -10],
  '香港': [10, 5],
  '澳门': [-10, 10],
  //'北京': [-10, 0],
  '天津': [5, 5]
};

function _default(mapType, region) {
  if (mapType === 'china') {
    var coordFix = coordsOffsetMap[region.name];

    if (coordFix) {
      var cp = region.center;
      cp[0] += coordFix[0] / 10.5;
      cp[1] += -coordFix[1] / (10.5 / 0.75);
    }
  }
}

module.exports = _default;

/***/ }),
/* 1612 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var geoCoordMap = {
  'Russia': [100, 60],
  'United States': [-99, 38],
  'United States of America': [-99, 38]
};

function _default(mapType, region) {
  if (mapType === 'world') {
    var geoCoord = geoCoordMap[region.name];

    if (geoCoord) {
      var cp = region.center;
      cp[0] = geoCoord[0];
      cp[1] = geoCoord[1];
    }
  }
}

module.exports = _default;

/***/ }),
/* 1613 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Fix for 钓鱼岛
// var Region = require('../Region');
// var zrUtil = require('zrender/src/core/util');
// var geoCoord = [126, 25];
var points = [[[123.45165252685547, 25.73527164402261], [123.49731445312499, 25.73527164402261], [123.49731445312499, 25.750734064600884], [123.45165252685547, 25.750734064600884], [123.45165252685547, 25.73527164402261]]];

function _default(mapType, region) {
  if (mapType === 'china' && region.name === '台湾') {
    region.geometries.push({
      type: 'polygon',
      exterior: points[0]
    });
  }
}

module.exports = _default;

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _parseSVG = __webpack_require__(638);

var parseSVG = _parseSVG.parseSVG;
var makeViewBoxTransform = _parseSVG.makeViewBoxTransform;

var Group = __webpack_require__(174);

var Rect = __webpack_require__(407);

var _util = __webpack_require__(1);

var assert = _util.assert;
var createHashMap = _util.createHashMap;

var BoundingRect = __webpack_require__(57);

var _model = __webpack_require__(44);

var makeInner = _model.makeInner;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var inner = makeInner();
var _default = {
  /**
   * @param {string} mapName
   * @param {Object} mapRecord {specialAreas, geoJSON}
   * @return {Object} {root, boundingRect}
   */
  load: function (mapName, mapRecord) {
    var originRoot = inner(mapRecord).originRoot;

    if (originRoot) {
      return {
        root: originRoot,
        boundingRect: inner(mapRecord).boundingRect
      };
    }

    var graphic = buildGraphic(mapRecord);
    inner(mapRecord).originRoot = graphic.root;
    inner(mapRecord).boundingRect = graphic.boundingRect;
    return graphic;
  },
  makeGraphic: function (mapName, mapRecord, hostKey) {
    // For performance consideration (in large SVG), graphic only maked
    // when necessary and reuse them according to hostKey.
    var field = inner(mapRecord);
    var rootMap = field.rootMap || (field.rootMap = createHashMap());
    var root = rootMap.get(hostKey);

    if (root) {
      return root;
    }

    var originRoot = field.originRoot;
    var boundingRect = field.boundingRect; // For performance, if originRoot is not used by a view,
    // assign it to a view, but not reproduce graphic elements.

    if (!field.originRootHostKey) {
      field.originRootHostKey = hostKey;
      root = originRoot;
    } else {
      root = buildGraphic(mapRecord, boundingRect).root;
    }

    return rootMap.set(hostKey, root);
  },
  removeGraphic: function (mapName, mapRecord, hostKey) {
    var field = inner(mapRecord);
    var rootMap = field.rootMap;
    rootMap && rootMap.removeKey(hostKey);

    if (hostKey === field.originRootHostKey) {
      field.originRootHostKey = null;
    }
  }
};

function buildGraphic(mapRecord, boundingRect) {
  var svgXML = mapRecord.svgXML;
  var result;
  var root;

  try {
    result = svgXML && parseSVG(svgXML, {
      ignoreViewBox: true,
      ignoreRootClip: true
    }) || {};
    root = result.root;
    assert(root != null);
  } catch (e) {
    throw new Error('Invalid svg format\n' + e.message);
  }

  var svgWidth = result.width;
  var svgHeight = result.height;
  var viewBoxRect = result.viewBoxRect;

  if (!boundingRect) {
    boundingRect = svgWidth == null || svgHeight == null ? // If svg width / height not specified, calculate
    // bounding rect as the width / height
    root.getBoundingRect() : new BoundingRect(0, 0, 0, 0);

    if (svgWidth != null) {
      boundingRect.width = svgWidth;
    }

    if (svgHeight != null) {
      boundingRect.height = svgHeight;
    }
  }

  if (viewBoxRect) {
    var viewBoxTransform = makeViewBoxTransform(viewBoxRect, boundingRect.width, boundingRect.height);
    var elRoot = root;
    root = new Group();
    root.add(elRoot);
    elRoot.scale = viewBoxTransform.scale;
    elRoot.position = viewBoxTransform.position;
  }

  root.setClipPath(new Rect({
    shape: boundingRect.plain()
  }));
  return {
    root: root,
    boundingRect: boundingRect
  };
}

module.exports = _default;

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var graphic = __webpack_require__(27);

var MapDraw = __webpack_require__(657);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var HIGH_DOWN_PROP = '__seriesMapHighDown';
var RECORD_VERSION_PROP = '__seriesMapCallKey';

var _default = echarts.extendChartView({
  type: 'map',
  render: function (mapModel, ecModel, api, payload) {
    // Not render if it is an toggleSelect action from self
    if (payload && payload.type === 'mapToggleSelect' && payload.from === this.uid) {
      return;
    }

    var group = this.group;
    group.removeAll();

    if (mapModel.getHostGeoModel()) {
      return;
    } // Not update map if it is an roam action from self


    if (!(payload && payload.type === 'geoRoam' && payload.componentType === 'series' && payload.seriesId === mapModel.id)) {
      if (mapModel.needsDrawMap) {
        var mapDraw = this._mapDraw || new MapDraw(api, true);
        group.add(mapDraw.group);
        mapDraw.draw(mapModel, ecModel, api, this, payload);
        this._mapDraw = mapDraw;
      } else {
        // Remove drawed map
        this._mapDraw && this._mapDraw.remove();
        this._mapDraw = null;
      }
    } else {
      var mapDraw = this._mapDraw;
      mapDraw && group.add(mapDraw.group);
    }

    mapModel.get('showLegendSymbol') && ecModel.getComponent('legend') && this._renderSymbols(mapModel, ecModel, api);
  },
  remove: function () {
    this._mapDraw && this._mapDraw.remove();
    this._mapDraw = null;
    this.group.removeAll();
  },
  dispose: function () {
    this._mapDraw && this._mapDraw.remove();
    this._mapDraw = null;
  },
  _renderSymbols: function (mapModel, ecModel, api) {
    var originalData = mapModel.originalData;
    var group = this.group;
    originalData.each(originalData.mapDimension('value'), function (value, originalDataIndex) {
      if (isNaN(value)) {
        return;
      }

      var layout = originalData.getItemLayout(originalDataIndex);

      if (!layout || !layout.point) {
        // Not exists in map
        return;
      }

      var point = layout.point;
      var offset = layout.offset;
      var circle = new graphic.Circle({
        style: {
          // Because the special of map draw.
          // Which needs statistic of multiple series and draw on one map.
          // And each series also need a symbol with legend color
          //
          // Layout and visual are put one the different data
          fill: mapModel.getData().getVisual('color')
        },
        shape: {
          cx: point[0] + offset * 9,
          cy: point[1],
          r: 3
        },
        silent: true,
        // Do not overlap the first series, on which labels are displayed.
        z2: 8 + (!offset ? graphic.Z2_EMPHASIS_LIFT + 1 : 0)
      }); // Only the series that has the first value on the same region is in charge of rendering the label.
      // But consider the case:
      // series: [
      //     {id: 'X', type: 'map', map: 'm', {data: [{name: 'A', value: 11}, {name: 'B', {value: 22}]},
      //     {id: 'Y', type: 'map', map: 'm', {data: [{name: 'A', value: 21}, {name: 'C', {value: 33}]}
      // ]
      // The offset `0` of item `A` is at series `X`, but of item `C` is at series `Y`.
      // For backward compatibility, we follow the rule that render label `A` by the
      // settings on series `X` but render label `C` by the settings on series `Y`.

      if (!offset) {
        var fullData = mapModel.mainSeries.getData();
        var name = originalData.getName(originalDataIndex);
        var fullIndex = fullData.indexOfName(name);
        var itemModel = originalData.getItemModel(originalDataIndex);
        var labelModel = itemModel.getModel('label');
        var hoverLabelModel = itemModel.getModel('emphasis.label');
        var regionGroup = fullData.getItemGraphicEl(fullIndex); // `getFormattedLabel` needs to use `getData` inside. Here
        // `mapModel.getData()` is shallow cloned from `mainSeries.getData()`.
        // FIXME
        // If this is not the `mainSeries`, the item model (like label formatter)
        // set on original data item will never get. But it has been working
        // like that from the begining, and this scenario is rarely encountered.
        // So it won't be fixed until have to.

        var normalText = zrUtil.retrieve2(mapModel.getFormattedLabel(fullIndex, 'normal'), name);
        var emphasisText = zrUtil.retrieve2(mapModel.getFormattedLabel(fullIndex, 'emphasis'), normalText);
        var highDownRecord = regionGroup[HIGH_DOWN_PROP];
        var recordVersion = Math.random(); // Prevent from register listeners duplicatedly when roaming.

        if (!highDownRecord) {
          highDownRecord = regionGroup[HIGH_DOWN_PROP] = {};
          var onEmphasis = zrUtil.curry(onRegionHighDown, true);
          var onNormal = zrUtil.curry(onRegionHighDown, false);
          regionGroup.on('mouseover', onEmphasis).on('mouseout', onNormal).on('emphasis', onEmphasis).on('normal', onNormal);
        } // Prevent removed regions effect current grapics.


        regionGroup[RECORD_VERSION_PROP] = recordVersion;
        zrUtil.extend(highDownRecord, {
          recordVersion: recordVersion,
          circle: circle,
          labelModel: labelModel,
          hoverLabelModel: hoverLabelModel,
          emphasisText: emphasisText,
          normalText: normalText
        }); // FIXME
        // Consider set option when emphasis.

        enterRegionHighDown(highDownRecord, false);
      }

      group.add(circle);
    });
  }
});

function onRegionHighDown(toHighOrDown) {
  var highDownRecord = this[HIGH_DOWN_PROP];

  if (highDownRecord && highDownRecord.recordVersion === this[RECORD_VERSION_PROP]) {
    enterRegionHighDown(highDownRecord, toHighOrDown);
  }
}

function enterRegionHighDown(highDownRecord, toHighOrDown) {
  var circle = highDownRecord.circle;
  var labelModel = highDownRecord.labelModel;
  var hoverLabelModel = highDownRecord.hoverLabelModel;
  var emphasisText = highDownRecord.emphasisText;
  var normalText = highDownRecord.normalText;

  if (toHighOrDown) {
    circle.style.extendFrom(graphic.setTextStyle({}, hoverLabelModel, {
      text: hoverLabelModel.get('show') ? emphasisText : null
    }, {
      isRectText: true,
      useInsideStyle: false
    }, true)); // Make label upper than others if overlaps.

    circle.__mapOriginalZ2 = circle.z2;
    circle.z2 += graphic.Z2_EMPHASIS_LIFT;
  } else {
    graphic.setTextStyle(circle.style, labelModel, {
      text: labelModel.get('show') ? normalText : null,
      textPosition: labelModel.getShallow('position') || 'bottom'
    }, {
      isRectText: true,
      useInsideStyle: false
    }); // Trigger normalize style like padding.

    circle.dirty(false);

    if (circle.__mapOriginalZ2 != null) {
      circle.z2 = circle.__mapOriginalZ2;
      circle.__mapOriginalZ2 = null;
    }
  }
}

module.exports = _default;

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var BoundingRect = __webpack_require__(57);

var View = __webpack_require__(420);

var geoSourceManager = __webpack_require__(305);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * [Geo description]
 * For backward compatibility, the orginal interface:
 * `name, map, geoJson, specialAreas, nameMap` is kept.
 *
 * @param {string|Object} name
 * @param {string} map Map type
 *        Specify the positioned areas by left, top, width, height
 * @param {Object.<string, string>} [nameMap]
 *        Specify name alias
 * @param {boolean} [invertLongitute=true]
 */
function Geo(name, map, nameMap, invertLongitute) {
  View.call(this, name);
  /**
   * Map type
   * @type {string}
   */

  this.map = map;
  var source = geoSourceManager.load(map, nameMap);
  this._nameCoordMap = source.nameCoordMap;
  this._regionsMap = source.regionsMap;
  this._invertLongitute = invertLongitute == null ? true : invertLongitute;
  /**
   * @readOnly
   */

  this.regions = source.regions;
  /**
   * @type {module:zrender/src/core/BoundingRect}
   */

  this._rect = source.boundingRect;
}

Geo.prototype = {
  constructor: Geo,
  type: 'geo',

  /**
   * @param {Array.<string>}
   * @readOnly
   */
  dimensions: ['lng', 'lat'],

  /**
   * If contain given lng,lat coord
   * @param {Array.<number>}
   * @readOnly
   */
  containCoord: function (coord) {
    var regions = this.regions;

    for (var i = 0; i < regions.length; i++) {
      if (regions[i].contain(coord)) {
        return true;
      }
    }

    return false;
  },

  /**
   * @override
   */
  transformTo: function (x, y, width, height) {
    var rect = this.getBoundingRect();
    var invertLongitute = this._invertLongitute;
    rect = rect.clone();

    if (invertLongitute) {
      // Longitute is inverted
      rect.y = -rect.y - rect.height;
    }

    var rawTransformable = this._rawTransformable;
    rawTransformable.transform = rect.calculateTransform(new BoundingRect(x, y, width, height));
    rawTransformable.decomposeTransform();

    if (invertLongitute) {
      var scale = rawTransformable.scale;
      scale[1] = -scale[1];
    }

    rawTransformable.updateTransform();

    this._updateTransform();
  },

  /**
   * @param {string} name
   * @return {module:echarts/coord/geo/Region}
   */
  getRegion: function (name) {
    return this._regionsMap.get(name);
  },
  getRegionByCoord: function (coord) {
    var regions = this.regions;

    for (var i = 0; i < regions.length; i++) {
      if (regions[i].contain(coord)) {
        return regions[i];
      }
    }
  },

  /**
   * Add geoCoord for indexing by name
   * @param {string} name
   * @param {Array.<number>} geoCoord
   */
  addGeoCoord: function (name, geoCoord) {
    this._nameCoordMap.set(name, geoCoord);
  },

  /**
   * Get geoCoord by name
   * @param {string} name
   * @return {Array.<number>}
   */
  getGeoCoord: function (name) {
    return this._nameCoordMap.get(name);
  },

  /**
   * @override
   */
  getBoundingRect: function () {
    return this._rect;
  },

  /**
   * @param {string|Array.<number>} data
   * @param {boolean} noRoam
   * @param {Array.<number>} [out]
   * @return {Array.<number>}
   */
  dataToPoint: function (data, noRoam, out) {
    if (typeof data === 'string') {
      // Map area name to geoCoord
      data = this.getGeoCoord(data);
    }

    if (data) {
      return View.prototype.dataToPoint.call(this, data, noRoam, out);
    }
  },

  /**
   * @override
   */
  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),

  /**
   * @override
   */
  convertFromPixel: zrUtil.curry(doConvert, 'pointToData')
};
zrUtil.mixin(Geo, View);

function doConvert(methodName, ecModel, finder, value) {
  var geoModel = finder.geoModel;
  var seriesModel = finder.seriesModel;
  var coordSys = geoModel ? geoModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem // For map.
  || (seriesModel.getReferringComponents('geo')[0] || {}).coordinateSystem : null;
  return coordSys === this ? coordSys[methodName](value) : null;
}

var _default = Geo;
module.exports = _default;

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(ecModel) {
  var processedMapType = {};
  ecModel.eachSeriesByType('map', function (mapSeries) {
    var mapType = mapSeries.getMapType();

    if (mapSeries.getHostGeoModel() || processedMapType[mapType]) {
      return;
    }

    var mapSymbolOffsets = {};
    zrUtil.each(mapSeries.seriesGroup, function (subMapSeries) {
      var geo = subMapSeries.coordinateSystem;
      var data = subMapSeries.originalData;

      if (subMapSeries.get('showLegendSymbol') && ecModel.getComponent('legend')) {
        data.each(data.mapDimension('value'), function (value, idx) {
          var name = data.getName(idx);
          var region = geo.getRegion(name); // If input series.data is [11, 22, '-'/null/undefined, 44],
          // it will be filled with NaN: [11, 22, NaN, 44] and NaN will
          // not be drawn. So here must validate if value is NaN.

          if (!region || isNaN(value)) {
            return;
          }

          var offset = mapSymbolOffsets[name] || 0;
          var point = geo.dataToPoint(region.center);
          mapSymbolOffsets[name] = offset + 1;
          data.setItemLayout(idx, {
            point: point,
            offset: offset
          });
        });
      }
    }); // Show label of those region not has legendSymbol(which is offset 0)

    var data = mapSeries.getData();
    data.each(function (idx) {
      var name = data.getName(idx);
      var layout = data.getItemLayout(idx) || {};
      layout.showLabel = !mapSymbolOffsets[name];
      data.setItemLayout(idx, layout);
    });
    processedMapType[mapType] = true;
  });
}

module.exports = _default;

/***/ }),
/* 1618 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(ecModel) {
  ecModel.eachSeriesByType('map', function (seriesModel) {
    var colorList = seriesModel.get('color');
    var itemStyleModel = seriesModel.getModel('itemStyle');
    var areaColor = itemStyleModel.get('areaColor');
    var color = itemStyleModel.get('color') || colorList[seriesModel.seriesIndex % colorList.length];
    seriesModel.getData().setVisual({
      'areaColor': areaColor,
      'color': color
    });
  });
}

module.exports = _default;

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// FIXME 公用？

/**
 * @param {Array.<module:echarts/data/List>} datas
 * @param {string} statisticType 'average' 'sum'
 * @inner
 */
function dataStatistics(datas, statisticType) {
  var dataNameMap = {};
  zrUtil.each(datas, function (data) {
    data.each(data.mapDimension('value'), function (value, idx) {
      // Add prefix to avoid conflict with Object.prototype.
      var mapKey = 'ec-' + data.getName(idx);
      dataNameMap[mapKey] = dataNameMap[mapKey] || [];

      if (!isNaN(value)) {
        dataNameMap[mapKey].push(value);
      }
    });
  });
  return datas[0].map(datas[0].mapDimension('value'), function (value, idx) {
    var mapKey = 'ec-' + datas[0].getName(idx);
    var sum = 0;
    var min = Infinity;
    var max = -Infinity;
    var len = dataNameMap[mapKey].length;

    for (var i = 0; i < len; i++) {
      min = Math.min(min, dataNameMap[mapKey][i]);
      max = Math.max(max, dataNameMap[mapKey][i]);
      sum += dataNameMap[mapKey][i];
    }

    var result;

    if (statisticType === 'min') {
      result = min;
    } else if (statisticType === 'max') {
      result = max;
    } else if (statisticType === 'average') {
      result = sum / len;
    } else {
      result = sum;
    }

    return len === 0 ? NaN : result;
  });
}

function _default(ecModel) {
  var seriesGroups = {};
  ecModel.eachSeriesByType('map', function (seriesModel) {
    var hostGeoModel = seriesModel.getHostGeoModel();
    var key = hostGeoModel ? 'o' + hostGeoModel.id : 'i' + seriesModel.getMapType();
    (seriesGroups[key] = seriesGroups[key] || []).push(seriesModel);
  });
  zrUtil.each(seriesGroups, function (seriesList, key) {
    var data = dataStatistics(zrUtil.map(seriesList, function (seriesModel) {
      return seriesModel.getData();
    }), seriesList[0].get('mapValueCalculation'));

    for (var i = 0; i < seriesList.length; i++) {
      seriesList[i].originalData = seriesList[i].getData();
    } // FIXME Put where?


    for (var i = 0; i < seriesList.length; i++) {
      seriesList[i].seriesGroup = seriesList;
      seriesList[i].needsDrawMap = i === 0 && !seriesList[i].getHostGeoModel();
      seriesList[i].setData(data.cloneShallow());
      seriesList[i].mainSeries = seriesList[0];
    }
  });
}

module.exports = _default;

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(option) {
  // Save geoCoord
  var mapSeries = [];
  zrUtil.each(option.series, function (seriesOpt) {
    if (seriesOpt && seriesOpt.type === 'map') {
      mapSeries.push(seriesOpt);
      seriesOpt.map = seriesOpt.map || seriesOpt.mapType; // Put x, y, width, height, x2, y2 in the top level

      zrUtil.defaults(seriesOpt, seriesOpt.mapLocation);
    }
  });
}

module.exports = _default;

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(1622);

__webpack_require__(1623);

__webpack_require__(1624);

var visualSymbol = __webpack_require__(178);

var treeLayout = __webpack_require__(1625);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.registerVisual(visualSymbol('tree', 'circle'));
echarts.registerLayout(treeLayout);

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var SeriesModel = __webpack_require__(74);

var Tree = __webpack_require__(421);

var _format = __webpack_require__(54);

var encodeHTML = _format.encodeHTML;

var Model = __webpack_require__(68);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = SeriesModel.extend({
  type: 'series.tree',
  layoutInfo: null,
  // can support the position parameters 'left', 'top','right','bottom', 'width',
  // 'height' in the setOption() with 'merge' mode normal.
  layoutMode: 'box',

  /**
   * Init a tree data structure from data in option series
   * @param  {Object} option  the object used to config echarts view
   * @return {module:echarts/data/List} storage initial data
   */
  getInitialData: function (option) {
    //create an virtual root
    var root = {
      name: option.name,
      children: option.data
    };
    var leaves = option.leaves || {};
    var leavesModel = new Model(leaves, this, this.ecModel);
    var tree = Tree.createTree(root, this, beforeLink);

    function beforeLink(nodeData) {
      nodeData.wrapMethod('getItemModel', function (model, idx) {
        var node = tree.getNodeByDataIndex(idx);

        if (!node.children.length || !node.isExpand) {
          model.parentModel = leavesModel;
        }

        return model;
      });
    }

    var treeDepth = 0;
    tree.eachNode('preorder', function (node) {
      if (node.depth > treeDepth) {
        treeDepth = node.depth;
      }
    });
    var expandAndCollapse = option.expandAndCollapse;
    var expandTreeDepth = expandAndCollapse && option.initialTreeDepth >= 0 ? option.initialTreeDepth : treeDepth;
    tree.root.eachNode('preorder', function (node) {
      var item = node.hostTree.data.getRawDataItem(node.dataIndex); // Add item.collapsed != null, because users can collapse node original in the series.data.

      node.isExpand = item && item.collapsed != null ? !item.collapsed : node.depth <= expandTreeDepth;
    });
    return tree.data;
  },

  /**
   * Make the configuration 'orient' backward compatibly, with 'horizontal = LR', 'vertical = TB'.
   * @returns {string} orient
   */
  getOrient: function () {
    var orient = this.get('orient');

    if (orient === 'horizontal') {
      orient = 'LR';
    } else if (orient === 'vertical') {
      orient = 'TB';
    }

    return orient;
  },
  setZoom: function (zoom) {
    this.option.zoom = zoom;
  },
  setCenter: function (center) {
    this.option.center = center;
  },

  /**
   * @override
   * @param {number} dataIndex
   */
  formatTooltip: function (dataIndex) {
    var tree = this.getData().tree;
    var realRoot = tree.root.children[0];
    var node = tree.getNodeByDataIndex(dataIndex);
    var value = node.getValue();
    var name = node.name;

    while (node && node !== realRoot) {
      name = node.parentNode.name + '.' + name;
      node = node.parentNode;
    }

    return encodeHTML(name + (isNaN(value) || value == null ? '' : ' : ' + value));
  },
  defaultOption: {
    zlevel: 0,
    z: 2,
    coordinateSystem: 'view',
    // the position of the whole view
    left: '12%',
    top: '12%',
    right: '12%',
    bottom: '12%',
    // the layout of the tree, two value can be selected, 'orthogonal' or 'radial'
    layout: 'orthogonal',
    // value can be 'polyline'
    edgeShape: 'curve',
    edgeForkPosition: '50%',
    // true | false | 'move' | 'scale', see module:component/helper/RoamController.
    roam: false,
    // Symbol size scale ratio in roam
    nodeScaleRatio: 0.4,
    // Default on center of graph
    center: null,
    zoom: 1,
    // The orient of orthoginal layout, can be setted to 'LR', 'TB', 'RL', 'BT'.
    // and the backward compatibility configuration 'horizontal = LR', 'vertical = TB'.
    orient: 'LR',
    symbol: 'emptyCircle',
    symbolSize: 7,
    expandAndCollapse: true,
    initialTreeDepth: 2,
    lineStyle: {
      color: '#ccc',
      width: 1.5,
      curveness: 0.5
    },
    itemStyle: {
      color: 'lightsteelblue',
      borderColor: '#c23531',
      borderWidth: 1.5
    },
    label: {
      show: true,
      color: '#555'
    },
    leaves: {
      label: {
        show: true
      }
    },
    animationEasing: 'linear',
    animationDuration: 700,
    animationDurationUpdate: 1000
  }
});

module.exports = _default;

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var graphic = __webpack_require__(27);

var SymbolClz = __webpack_require__(301);

var _layoutHelper = __webpack_require__(661);

var radialCoordinate = _layoutHelper.radialCoordinate;

var echarts = __webpack_require__(23);

var bbox = __webpack_require__(234);

var View = __webpack_require__(420);

var roamHelper = __webpack_require__(417);

var RoamController = __webpack_require__(245);

var _cursorHelper = __webpack_require__(306);

var onIrrelevantElement = _cursorHelper.onIrrelevantElement;

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var _number = __webpack_require__(37);

var parsePercent = _number.parsePercent;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var TreeShape = graphic.extendShape({
  shape: {
    parentPoint: [],
    childPoints: [],
    orient: '',
    forkPosition: ''
  },
  style: {
    stroke: '#000',
    fill: null
  },
  buildPath: function (ctx, shape) {
    var childPoints = shape.childPoints;
    var childLen = childPoints.length;
    var parentPoint = shape.parentPoint;
    var firstChildPos = childPoints[0];
    var lastChildPos = childPoints[childLen - 1];

    if (childLen === 1) {
      ctx.moveTo(parentPoint[0], parentPoint[1]);
      ctx.lineTo(firstChildPos[0], firstChildPos[1]);
      return;
    }

    var orient = shape.orient;
    var forkDim = orient === 'TB' || orient === 'BT' ? 0 : 1;
    var otherDim = 1 - forkDim;
    var forkPosition = parsePercent(shape.forkPosition, 1);
    var tmpPoint = [];
    tmpPoint[forkDim] = parentPoint[forkDim];
    tmpPoint[otherDim] = parentPoint[otherDim] + (lastChildPos[otherDim] - parentPoint[otherDim]) * forkPosition;
    ctx.moveTo(parentPoint[0], parentPoint[1]);
    ctx.lineTo(tmpPoint[0], tmpPoint[1]);
    ctx.moveTo(firstChildPos[0], firstChildPos[1]);
    tmpPoint[forkDim] = firstChildPos[forkDim];
    ctx.lineTo(tmpPoint[0], tmpPoint[1]);
    tmpPoint[forkDim] = lastChildPos[forkDim];
    ctx.lineTo(tmpPoint[0], tmpPoint[1]);
    ctx.lineTo(lastChildPos[0], lastChildPos[1]);

    for (var i = 1; i < childLen - 1; i++) {
      var point = childPoints[i];
      ctx.moveTo(point[0], point[1]);
      tmpPoint[forkDim] = point[forkDim];
      ctx.lineTo(tmpPoint[0], tmpPoint[1]);
    }
  }
});

var _default = echarts.extendChartView({
  type: 'tree',

  /**
   * Init the chart
   * @override
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */
  init: function (ecModel, api) {
    /**
     * @private
     * @type {module:echarts/data/Tree}
     */
    this._oldTree;
    /**
     * @private
     * @type {module:zrender/container/Group}
     */

    this._mainGroup = new graphic.Group();
    /**
     * @private
     * @type {module:echarts/componet/helper/RoamController}
     */

    this._controller = new RoamController(api.getZr());
    this._controllerHost = {
      target: this.group
    };
    this.group.add(this._mainGroup);
  },
  render: function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData();
    var layoutInfo = seriesModel.layoutInfo;
    var group = this._mainGroup;
    var layout = seriesModel.get('layout');

    if (layout === 'radial') {
      group.attr('position', [layoutInfo.x + layoutInfo.width / 2, layoutInfo.y + layoutInfo.height / 2]);
    } else {
      group.attr('position', [layoutInfo.x, layoutInfo.y]);
    }

    this._updateViewCoordSys(seriesModel, layoutInfo, layout);

    this._updateController(seriesModel, ecModel, api);

    var oldData = this._data;
    var seriesScope = {
      expandAndCollapse: seriesModel.get('expandAndCollapse'),
      layout: layout,
      edgeShape: seriesModel.get('edgeShape'),
      edgeForkPosition: seriesModel.get('edgeForkPosition'),
      orient: seriesModel.getOrient(),
      curvature: seriesModel.get('lineStyle.curveness'),
      symbolRotate: seriesModel.get('symbolRotate'),
      symbolOffset: seriesModel.get('symbolOffset'),
      hoverAnimation: seriesModel.get('hoverAnimation'),
      useNameLabel: true,
      fadeIn: true
    };
    data.diff(oldData).add(function (newIdx) {
      if (symbolNeedsDraw(data, newIdx)) {
        // Create node and edge
        updateNode(data, newIdx, null, group, seriesModel, seriesScope);
      }
    }).update(function (newIdx, oldIdx) {
      var symbolEl = oldData.getItemGraphicEl(oldIdx);

      if (!symbolNeedsDraw(data, newIdx)) {
        symbolEl && removeNode(oldData, oldIdx, symbolEl, group, seriesModel, seriesScope);
        return;
      } // Update node and edge


      updateNode(data, newIdx, symbolEl, group, seriesModel, seriesScope);
    }).remove(function (oldIdx) {
      var symbolEl = oldData.getItemGraphicEl(oldIdx); // When remove a collapsed node of subtree, since the collapsed
      // node haven't been initialized with a symbol element,
      // you can't found it's symbol element through index.
      // so if we want to remove the symbol element we should insure
      // that the symbol element is not null.

      if (symbolEl) {
        removeNode(oldData, oldIdx, symbolEl, group, seriesModel, seriesScope);
      }
    }).execute();
    this._nodeScaleRatio = seriesModel.get('nodeScaleRatio');

    this._updateNodeAndLinkScale(seriesModel);

    if (seriesScope.expandAndCollapse === true) {
      data.eachItemGraphicEl(function (el, dataIndex) {
        el.off('click').on('click', function () {
          api.dispatchAction({
            type: 'treeExpandAndCollapse',
            seriesId: seriesModel.id,
            dataIndex: dataIndex
          });
        });
      });
    }

    this._data = data;
  },
  _updateViewCoordSys: function (seriesModel) {
    var data = seriesModel.getData();
    var points = [];
    data.each(function (idx) {
      var layout = data.getItemLayout(idx);

      if (layout && !isNaN(layout.x) && !isNaN(layout.y)) {
        points.push([+layout.x, +layout.y]);
      }
    });
    var min = [];
    var max = [];
    bbox.fromPoints(points, min, max); // If don't Store min max when collapse the root node after roam,
    // the root node will disappear.

    var oldMin = this._min;
    var oldMax = this._max; // If width or height is 0

    if (max[0] - min[0] === 0) {
      min[0] = oldMin ? oldMin[0] : min[0] - 1;
      max[0] = oldMax ? oldMax[0] : max[0] + 1;
    }

    if (max[1] - min[1] === 0) {
      min[1] = oldMin ? oldMin[1] : min[1] - 1;
      max[1] = oldMax ? oldMax[1] : max[1] + 1;
    }

    var viewCoordSys = seriesModel.coordinateSystem = new View();
    viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
    viewCoordSys.setBoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
    viewCoordSys.setCenter(seriesModel.get('center'));
    viewCoordSys.setZoom(seriesModel.get('zoom')); // Here we use viewCoordSys just for computing the 'position' and 'scale' of the group

    this.group.attr({
      position: viewCoordSys.position,
      scale: viewCoordSys.scale
    });
    this._viewCoordSys = viewCoordSys;
    this._min = min;
    this._max = max;
  },
  _updateController: function (seriesModel, ecModel, api) {
    var controller = this._controller;
    var controllerHost = this._controllerHost;
    var group = this.group;
    controller.setPointerChecker(function (e, x, y) {
      var rect = group.getBoundingRect();
      rect.applyTransform(group.transform);
      return rect.contain(x, y) && !onIrrelevantElement(e, api, seriesModel);
    });
    controller.enable(seriesModel.get('roam'));
    controllerHost.zoomLimit = seriesModel.get('scaleLimit');
    controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
    controller.off('pan').off('zoom').on('pan', function (e) {
      roamHelper.updateViewOnPan(controllerHost, e.dx, e.dy);
      api.dispatchAction({
        seriesId: seriesModel.id,
        type: 'treeRoam',
        dx: e.dx,
        dy: e.dy
      });
    }, this).on('zoom', function (e) {
      roamHelper.updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
      api.dispatchAction({
        seriesId: seriesModel.id,
        type: 'treeRoam',
        zoom: e.scale,
        originX: e.originX,
        originY: e.originY
      });

      this._updateNodeAndLinkScale(seriesModel);
    }, this);
  },
  _updateNodeAndLinkScale: function (seriesModel) {
    var data = seriesModel.getData();

    var nodeScale = this._getNodeGlobalScale(seriesModel);

    var invScale = [nodeScale, nodeScale];
    data.eachItemGraphicEl(function (el, idx) {
      el.attr('scale', invScale);
    });
  },
  _getNodeGlobalScale: function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys.type !== 'view') {
      return 1;
    }

    var nodeScaleRatio = this._nodeScaleRatio;
    var groupScale = coordSys.scale;
    var groupZoom = groupScale && groupScale[0] || 1; // Scale node when zoom changes

    var roamZoom = coordSys.getZoom();
    var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
    return nodeScale / groupZoom;
  },
  dispose: function () {
    this._controller && this._controller.dispose();
    this._controllerHost = {};
  },
  remove: function () {
    this._mainGroup.removeAll();

    this._data = null;
  }
});

function symbolNeedsDraw(data, dataIndex) {
  var layout = data.getItemLayout(dataIndex);
  return layout && !isNaN(layout.x) && !isNaN(layout.y) && data.getItemVisual(dataIndex, 'symbol') !== 'none';
}

function getTreeNodeStyle(node, itemModel, seriesScope) {
  seriesScope.itemModel = itemModel;
  seriesScope.itemStyle = itemModel.getModel('itemStyle').getItemStyle();
  seriesScope.hoverItemStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
  seriesScope.lineStyle = itemModel.getModel('lineStyle').getLineStyle();
  seriesScope.labelModel = itemModel.getModel('label');
  seriesScope.hoverLabelModel = itemModel.getModel('emphasis.label');

  if (node.isExpand === false && node.children.length !== 0) {
    seriesScope.symbolInnerColor = seriesScope.itemStyle.fill;
  } else {
    seriesScope.symbolInnerColor = '#fff';
  }

  return seriesScope;
}

function updateNode(data, dataIndex, symbolEl, group, seriesModel, seriesScope) {
  var isInit = !symbolEl;
  var node = data.tree.getNodeByDataIndex(dataIndex);
  var itemModel = node.getModel();
  var seriesScope = getTreeNodeStyle(node, itemModel, seriesScope);
  var virtualRoot = data.tree.root;
  var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
  var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
  var sourceLayout = source.getLayout();
  var sourceOldLayout = sourceSymbolEl ? {
    x: sourceSymbolEl.position[0],
    y: sourceSymbolEl.position[1],
    rawX: sourceSymbolEl.__radialOldRawX,
    rawY: sourceSymbolEl.__radialOldRawY
  } : sourceLayout;
  var targetLayout = node.getLayout();

  if (isInit) {
    symbolEl = new SymbolClz(data, dataIndex, seriesScope);
    symbolEl.attr('position', [sourceOldLayout.x, sourceOldLayout.y]);
  } else {
    symbolEl.updateData(data, dataIndex, seriesScope);
  }

  symbolEl.__radialOldRawX = symbolEl.__radialRawX;
  symbolEl.__radialOldRawY = symbolEl.__radialRawY;
  symbolEl.__radialRawX = targetLayout.rawX;
  symbolEl.__radialRawY = targetLayout.rawY;
  group.add(symbolEl);
  data.setItemGraphicEl(dataIndex, symbolEl);
  graphic.updateProps(symbolEl, {
    position: [targetLayout.x, targetLayout.y]
  }, seriesModel);
  var symbolPath = symbolEl.getSymbolPath();

  if (seriesScope.layout === 'radial') {
    var realRoot = virtualRoot.children[0];
    var rootLayout = realRoot.getLayout();
    var length = realRoot.children.length;
    var rad;
    var isLeft;

    if (targetLayout.x === rootLayout.x && node.isExpand === true) {
      var center = {};
      center.x = (realRoot.children[0].getLayout().x + realRoot.children[length - 1].getLayout().x) / 2;
      center.y = (realRoot.children[0].getLayout().y + realRoot.children[length - 1].getLayout().y) / 2;
      rad = Math.atan2(center.y - rootLayout.y, center.x - rootLayout.x);

      if (rad < 0) {
        rad = Math.PI * 2 + rad;
      }

      isLeft = center.x < rootLayout.x;

      if (isLeft) {
        rad = rad - Math.PI;
      }
    } else {
      rad = Math.atan2(targetLayout.y - rootLayout.y, targetLayout.x - rootLayout.x);

      if (rad < 0) {
        rad = Math.PI * 2 + rad;
      }

      if (node.children.length === 0 || node.children.length !== 0 && node.isExpand === false) {
        isLeft = targetLayout.x < rootLayout.x;

        if (isLeft) {
          rad = rad - Math.PI;
        }
      } else {
        isLeft = targetLayout.x > rootLayout.x;

        if (!isLeft) {
          rad = rad - Math.PI;
        }
      }
    }

    var textPosition = isLeft ? 'left' : 'right';
    var rotate = seriesScope.labelModel.get('rotate');
    var labelRotateRadian = rotate * (Math.PI / 180);
    symbolPath.setStyle({
      textPosition: seriesScope.labelModel.get('position') || textPosition,
      textRotation: rotate == null ? -rad : labelRotateRadian,
      textOrigin: 'center',
      verticalAlign: 'middle'
    });
  }

  drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group, seriesScope);
}

function drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group, seriesScope) {
  var edgeShape = seriesScope.edgeShape;
  var edge = symbolEl.__edge;

  if (edgeShape === 'curve') {
    if (node.parentNode && node.parentNode !== virtualRoot) {
      if (!edge) {
        edge = symbolEl.__edge = new graphic.BezierCurve({
          shape: getEdgeShape(seriesScope, sourceOldLayout, sourceOldLayout),
          style: zrUtil.defaults({
            opacity: 0,
            strokeNoScale: true
          }, seriesScope.lineStyle)
        });
      }

      graphic.updateProps(edge, {
        shape: getEdgeShape(seriesScope, sourceLayout, targetLayout),
        style: zrUtil.defaults({
          opacity: 1
        }, seriesScope.lineStyle)
      }, seriesModel);
    }
  } else if (edgeShape === 'polyline') {
    if (seriesScope.layout === 'orthogonal') {
      if (node !== virtualRoot && node.children && node.children.length !== 0 && node.isExpand === true) {
        var children = node.children;
        var childPoints = [];

        for (var i = 0; i < children.length; i++) {
          var childLayout = children[i].getLayout();
          childPoints.push([childLayout.x, childLayout.y]);
        }

        if (!edge) {
          edge = symbolEl.__edge = new TreeShape({
            shape: {
              parentPoint: [targetLayout.x, targetLayout.y],
              childPoints: [[targetLayout.x, targetLayout.y]],
              orient: seriesScope.orient,
              forkPosition: seriesScope.edgeForkPosition
            },
            style: zrUtil.defaults({
              opacity: 0,
              strokeNoScale: true
            }, seriesScope.lineStyle)
          });
        }

        graphic.updateProps(edge, {
          shape: {
            parentPoint: [targetLayout.x, targetLayout.y],
            childPoints: childPoints
          },
          style: zrUtil.defaults({
            opacity: 1
          }, seriesScope.lineStyle)
        }, seriesModel);
      }
    } else {}
  }

  group.add(edge);
}

function removeNode(data, dataIndex, symbolEl, group, seriesModel, seriesScope) {
  var node = data.tree.getNodeByDataIndex(dataIndex);
  var virtualRoot = data.tree.root;
  var itemModel = node.getModel();
  var seriesScope = getTreeNodeStyle(node, itemModel, seriesScope);
  var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
  var edgeShape = seriesScope.edgeShape;
  var sourceLayout;

  while (sourceLayout = source.getLayout(), sourceLayout == null) {
    source = source.parentNode === virtualRoot ? source : source.parentNode || source;
  }

  graphic.updateProps(symbolEl, {
    position: [sourceLayout.x + 1, sourceLayout.y + 1]
  }, seriesModel, function () {
    group.remove(symbolEl);
    data.setItemGraphicEl(dataIndex, null);
  });
  symbolEl.fadeOut(null, {
    keepLabel: true
  });
  var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
  var sourceEdge = sourceSymbolEl.__edge; // 1. when expand the sub tree, delete the children node should delete the edge of
  // the source at the same time. because the polyline edge shape is only owned by the source.
  // 2.when the node is the only children of the source, delete the node should delete the edge of
  // the source at the same time. the same reason as above.

  var edge = symbolEl.__edge || (source.isExpand === false || source.children.length === 1 ? sourceEdge : undefined);
  var edgeShape = seriesScope.edgeShape;

  if (edge) {
    if (edgeShape === 'curve') {
      graphic.updateProps(edge, {
        shape: getEdgeShape(seriesScope, sourceLayout, sourceLayout),
        style: {
          opacity: 0
        }
      }, seriesModel, function () {
        group.remove(edge);
      });
    } else if (edgeShape === 'polyline' && seriesScope.layout === 'orthogonal') {
      graphic.updateProps(edge, {
        shape: {
          parentPoint: [sourceLayout.x, sourceLayout.y],
          childPoints: [[sourceLayout.x, sourceLayout.y]]
        },
        style: {
          opacity: 0
        }
      }, seriesModel, function () {
        group.remove(edge);
      });
    }
  }
}

function getEdgeShape(seriesScope, sourceLayout, targetLayout) {
  var cpx1;
  var cpy1;
  var cpx2;
  var cpy2;
  var orient = seriesScope.orient;
  var x1;
  var x2;
  var y1;
  var y2;

  if (seriesScope.layout === 'radial') {
    x1 = sourceLayout.rawX;
    y1 = sourceLayout.rawY;
    x2 = targetLayout.rawX;
    y2 = targetLayout.rawY;
    var radialCoor1 = radialCoordinate(x1, y1);
    var radialCoor2 = radialCoordinate(x1, y1 + (y2 - y1) * seriesScope.curvature);
    var radialCoor3 = radialCoordinate(x2, y2 + (y1 - y2) * seriesScope.curvature);
    var radialCoor4 = radialCoordinate(x2, y2);
    return {
      x1: radialCoor1.x,
      y1: radialCoor1.y,
      x2: radialCoor4.x,
      y2: radialCoor4.y,
      cpx1: radialCoor2.x,
      cpy1: radialCoor2.y,
      cpx2: radialCoor3.x,
      cpy2: radialCoor3.y
    };
  } else {
    x1 = sourceLayout.x;
    y1 = sourceLayout.y;
    x2 = targetLayout.x;
    y2 = targetLayout.y;

    if (orient === 'LR' || orient === 'RL') {
      cpx1 = x1 + (x2 - x1) * seriesScope.curvature;
      cpy1 = y1;
      cpx2 = x2 + (x1 - x2) * seriesScope.curvature;
      cpy2 = y2;
    }

    if (orient === 'TB' || orient === 'BT') {
      cpx1 = x1;
      cpy1 = y1 + (y2 - y1) * seriesScope.curvature;
      cpx2 = x2;
      cpy2 = y2 + (y1 - y2) * seriesScope.curvature;
    }
  }

  return {
    x1: x1,
    y1: y1,
    x2: x2,
    y2: y2,
    cpx1: cpx1,
    cpy1: cpy1,
    cpx2: cpx2,
    cpy2: cpy2
  };
}

module.exports = _default;

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var _roamHelper = __webpack_require__(418);

var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.registerAction({
  type: 'treeExpandAndCollapse',
  event: 'treeExpandAndCollapse',
  update: 'update'
}, function (payload, ecModel) {
  ecModel.eachComponent({
    mainType: 'series',
    subType: 'tree',
    query: payload
  }, function (seriesModel) {
    var dataIndex = payload.dataIndex;
    var tree = seriesModel.getData().tree;
    var node = tree.getNodeByDataIndex(dataIndex);
    node.isExpand = !node.isExpand;
  });
});
echarts.registerAction({
  type: 'treeRoam',
  event: 'treeRoam',
  // Here we set 'none' instead of 'update', because roam action
  // just need to update the transform matrix without having to recalculate
  // the layout. So don't need to go through the whole update process, such
  // as 'dataPrcocess', 'coordSystemUpdate', 'layout' and so on.
  update: 'none'
}, function (payload, ecModel) {
  ecModel.eachComponent({
    mainType: 'series',
    subType: 'tree',
    query: payload
  }, function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    var res = updateCenterAndZoom(coordSys, payload);
    seriesModel.setCenter && seriesModel.setCenter(res.center);
    seriesModel.setZoom && seriesModel.setZoom(res.zoom);
  });
});

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _traversalHelper = __webpack_require__(1626);

var eachAfter = _traversalHelper.eachAfter;
var eachBefore = _traversalHelper.eachBefore;

var _layoutHelper = __webpack_require__(661);

var init = _layoutHelper.init;
var firstWalk = _layoutHelper.firstWalk;
var secondWalk = _layoutHelper.secondWalk;
var sep = _layoutHelper.separation;
var radialCoordinate = _layoutHelper.radialCoordinate;
var getViewRect = _layoutHelper.getViewRect;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(ecModel, api) {
  ecModel.eachSeriesByType('tree', function (seriesModel) {
    commonLayout(seriesModel, api);
  });
}

function commonLayout(seriesModel, api) {
  var layoutInfo = getViewRect(seriesModel, api);
  seriesModel.layoutInfo = layoutInfo;
  var layout = seriesModel.get('layout');
  var width = 0;
  var height = 0;
  var separation = null;

  if (layout === 'radial') {
    width = 2 * Math.PI;
    height = Math.min(layoutInfo.height, layoutInfo.width) / 2;
    separation = sep(function (node1, node2) {
      return (node1.parentNode === node2.parentNode ? 1 : 2) / node1.depth;
    });
  } else {
    width = layoutInfo.width;
    height = layoutInfo.height;
    separation = sep();
  }

  var virtualRoot = seriesModel.getData().tree.root;
  var realRoot = virtualRoot.children[0];

  if (realRoot) {
    init(virtualRoot);
    eachAfter(realRoot, firstWalk, separation);
    virtualRoot.hierNode.modifier = -realRoot.hierNode.prelim;
    eachBefore(realRoot, secondWalk);
    var left = realRoot;
    var right = realRoot;
    var bottom = realRoot;
    eachBefore(realRoot, function (node) {
      var x = node.getLayout().x;

      if (x < left.getLayout().x) {
        left = node;
      }

      if (x > right.getLayout().x) {
        right = node;
      }

      if (node.depth > bottom.depth) {
        bottom = node;
      }
    });
    var delta = left === right ? 1 : separation(left, right) / 2;
    var tx = delta - left.getLayout().x;
    var kx = 0;
    var ky = 0;
    var coorX = 0;
    var coorY = 0;

    if (layout === 'radial') {
      kx = width / (right.getLayout().x + delta + tx); // here we use (node.depth - 1), bucause the real root's depth is 1

      ky = height / (bottom.depth - 1 || 1);
      eachBefore(realRoot, function (node) {
        coorX = (node.getLayout().x + tx) * kx;
        coorY = (node.depth - 1) * ky;
        var finalCoor = radialCoordinate(coorX, coorY);
        node.setLayout({
          x: finalCoor.x,
          y: finalCoor.y,
          rawX: coorX,
          rawY: coorY
        }, true);
      });
    } else {
      var orient = seriesModel.getOrient();

      if (orient === 'RL' || orient === 'LR') {
        ky = height / (right.getLayout().x + delta + tx);
        kx = width / (bottom.depth - 1 || 1);
        eachBefore(realRoot, function (node) {
          coorY = (node.getLayout().x + tx) * ky;
          coorX = orient === 'LR' ? (node.depth - 1) * kx : width - (node.depth - 1) * kx;
          node.setLayout({
            x: coorX,
            y: coorY
          }, true);
        });
      } else if (orient === 'TB' || orient === 'BT') {
        kx = width / (right.getLayout().x + delta + tx);
        ky = height / (bottom.depth - 1 || 1);
        eachBefore(realRoot, function (node) {
          coorX = (node.getLayout().x + tx) * kx;
          coorY = orient === 'TB' ? (node.depth - 1) * ky : height - (node.depth - 1) * ky;
          node.setLayout({
            x: coorX,
            y: coorY
          }, true);
        });
      }
    }
  }
}

module.exports = _default;

/***/ }),
/* 1626 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Traverse the tree from bottom to top and do something
 * @param  {module:echarts/data/Tree~TreeNode} root  The real root of the tree
 * @param  {Function} callback
 */
function eachAfter(root, callback, separation) {
  var nodes = [root];
  var next = [];
  var node;

  while (node = nodes.pop()) {
    // jshint ignore:line
    next.push(node);

    if (node.isExpand) {
      var children = node.children;

      if (children.length) {
        for (var i = 0; i < children.length; i++) {
          nodes.push(children[i]);
        }
      }
    }
  }

  while (node = next.pop()) {
    // jshint ignore:line
    callback(node, separation);
  }
}
/**
 * Traverse the tree from top to bottom and do something
 * @param  {module:echarts/data/Tree~TreeNode} root  The real root of the tree
 * @param  {Function} callback
 */


function eachBefore(root, callback) {
  var nodes = [root];
  var node;

  while (node = nodes.pop()) {
    // jshint ignore:line
    callback(node);

    if (node.isExpand) {
      var children = node.children;

      if (children.length) {
        for (var i = children.length - 1; i >= 0; i--) {
          nodes.push(children[i]);
        }
      }
    }
  }
}

exports.eachAfter = eachAfter;
exports.eachBefore = eachBefore;

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(1628);

__webpack_require__(1629);

__webpack_require__(1632);

var treemapVisual = __webpack_require__(1633);

var treemapLayout = __webpack_require__(1634);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.registerVisual(treemapVisual);
echarts.registerLayout(treemapLayout);

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var SeriesModel = __webpack_require__(74);

var Tree = __webpack_require__(421);

var Model = __webpack_require__(68);

var _format = __webpack_require__(54);

var encodeHTML = _format.encodeHTML;
var addCommas = _format.addCommas;

var _treeHelper = __webpack_require__(180);

var wrapTreePathInfo = _treeHelper.wrapTreePathInfo;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = SeriesModel.extend({
  type: 'series.treemap',
  layoutMode: 'box',
  dependencies: ['grid', 'polar'],
  preventUsingHoverLayer: true,

  /**
   * @type {module:echarts/data/Tree~Node}
   */
  _viewRoot: null,
  defaultOption: {
    // Disable progressive rendering
    progressive: 0,
    // center: ['50%', '50%'],          // not supported in ec3.
    // size: ['80%', '80%'],            // deprecated, compatible with ec2.
    left: 'center',
    top: 'middle',
    right: null,
    bottom: null,
    width: '80%',
    height: '80%',
    sort: true,
    // Can be null or false or true
    // (order by desc default, asc not supported yet (strange effect))
    clipWindow: 'origin',
    // Size of clipped window when zooming. 'origin' or 'fullscreen'
    squareRatio: 0.5 * (1 + Math.sqrt(5)),
    // golden ratio
    leafDepth: null,
    // Nodes on depth from root are regarded as leaves.
    // Count from zero (zero represents only view root).
    drillDownIcon: '▶',
    // Use html character temporarily because it is complicated
    // to align specialized icon. ▷▶❒❐▼✚
    zoomToNodeRatio: 0.32 * 0.32,
    // Be effective when using zoomToNode. Specify the proportion of the
    // target node area in the view area.
    roam: true,
    // true, false, 'scale' or 'zoom', 'move'.
    nodeClick: 'zoomToNode',
    // Leaf node click behaviour: 'zoomToNode', 'link', false.
    // If leafDepth is set and clicking a node which has children but
    // be on left depth, the behaviour would be changing root. Otherwise
    // use behavious defined above.
    animation: true,
    animationDurationUpdate: 900,
    animationEasing: 'quinticInOut',
    breadcrumb: {
      show: true,
      height: 22,
      left: 'center',
      top: 'bottom',
      // right
      // bottom
      emptyItemWidth: 25,
      // Width of empty node.
      itemStyle: {
        color: 'rgba(0,0,0,0.7)',
        //'#5793f3',
        borderColor: 'rgba(255,255,255,0.7)',
        borderWidth: 1,
        shadowColor: 'rgba(150,150,150,1)',
        shadowBlur: 3,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        textStyle: {
          color: '#fff'
        }
      },
      emphasis: {
        textStyle: {}
      }
    },
    label: {
      show: true,
      // Do not use textDistance, for ellipsis rect just the same as treemap node rect.
      distance: 0,
      padding: 5,
      position: 'inside',
      // Can be [5, '5%'] or position stirng like 'insideTopLeft', ...
      // formatter: null,
      color: '#fff',
      ellipsis: true // align
      // verticalAlign

    },
    upperLabel: {
      // Label when node is parent.
      show: false,
      position: [0, '50%'],
      height: 20,
      // formatter: null,
      color: '#fff',
      ellipsis: true,
      // align: null,
      verticalAlign: 'middle'
    },
    itemStyle: {
      color: null,
      // Can be 'none' if not necessary.
      colorAlpha: null,
      // Can be 'none' if not necessary.
      colorSaturation: null,
      // Can be 'none' if not necessary.
      borderWidth: 0,
      gapWidth: 0,
      borderColor: '#fff',
      borderColorSaturation: null // If specified, borderColor will be ineffective, and the
      // border color is evaluated by color of current node and
      // borderColorSaturation.

    },
    emphasis: {
      upperLabel: {
        show: true,
        position: [0, '50%'],
        color: '#fff',
        ellipsis: true,
        verticalAlign: 'middle'
      }
    },
    visualDimension: 0,
    // Can be 0, 1, 2, 3.
    visualMin: null,
    visualMax: null,
    color: [],
    // + treemapSeries.color should not be modified. Please only modified
    // level[n].color (if necessary).
    // + Specify color list of each level. level[0].color would be global
    // color list if not specified. (see method `setDefault`).
    // + But set as a empty array to forbid fetch color from global palette
    // when using nodeModel.get('color'), otherwise nodes on deep level
    // will always has color palette set and are not able to inherit color
    // from parent node.
    // + TreemapSeries.color can not be set as 'none', otherwise effect
    // legend color fetching (see seriesColor.js).
    colorAlpha: null,
    // Array. Specify color alpha range of each level, like [0.2, 0.8]
    colorSaturation: null,
    // Array. Specify color saturation of each level, like [0.2, 0.5]
    colorMappingBy: 'index',
    // 'value' or 'index' or 'id'.
    visibleMin: 10,
    // If area less than this threshold (unit: pixel^2), node will not
    // be rendered. Only works when sort is 'asc' or 'desc'.
    childrenVisibleMin: null,
    // If area of a node less than this threshold (unit: pixel^2),
    // grandchildren will not show.
    // Why grandchildren? If not grandchildren but children,
    // some siblings show children and some not,
    // the appearance may be mess and not consistent,
    levels: [] // Each item: {
    //     visibleMin, itemStyle, visualDimension, label
    // }
    // data: {
    //      value: [],
    //      children: [],
    //      link: 'http://xxx.xxx.xxx',
    //      target: 'blank' or 'self'
    // }

  },

  /**
   * @override
   */
  getInitialData: function (option, ecModel) {
    // Create a virtual root.
    var root = {
      name: option.name,
      children: option.data
    };
    completeTreeValue(root);
    var levels = option.levels || []; // Used in "visual priority" in `treemapVisual.js`.
    // This way is a little tricky, must satisfy the precondition:
    //   1. There is no `treeNode.getModel('itemStyle.xxx')` used.
    //   2. The `Model.prototype.getModel()` will not use any clone-like way.

    var designatedVisualItemStyle = this.designatedVisualItemStyle = {};
    var designatedVisualModel = new Model({
      itemStyle: designatedVisualItemStyle
    }, this, ecModel);
    levels = option.levels = setDefault(levels, ecModel);
    var levelModels = zrUtil.map(levels || [], function (levelDefine) {
      return new Model(levelDefine, designatedVisualModel, ecModel);
    }, this); // Make sure always a new tree is created when setOption,
    // in TreemapView, we check whether oldTree === newTree
    // to choose mappings approach among old shapes and new shapes.

    var tree = Tree.createTree(root, this, beforeLink);

    function beforeLink(nodeData) {
      nodeData.wrapMethod('getItemModel', function (model, idx) {
        var node = tree.getNodeByDataIndex(idx);
        var levelModel = levelModels[node.depth]; // If no levelModel, we also need `designatedVisualModel`.

        model.parentModel = levelModel || designatedVisualModel;
        return model;
      });
    }

    return tree.data;
  },
  optionUpdated: function () {
    this.resetViewRoot();
  },

  /**
   * @override
   * @param {number} dataIndex
   * @param {boolean} [mutipleSeries=false]
   */
  formatTooltip: function (dataIndex) {
    var data = this.getData();
    var value = this.getRawValue(dataIndex);
    var formattedValue = zrUtil.isArray(value) ? addCommas(value[0]) : addCommas(value);
    var name = data.getName(dataIndex);
    return encodeHTML(name + ': ' + formattedValue);
  },

  /**
   * Add tree path to tooltip param
   *
   * @override
   * @param {number} dataIndex
   * @return {Object}
   */
  getDataParams: function (dataIndex) {
    var params = SeriesModel.prototype.getDataParams.apply(this, arguments);
    var node = this.getData().tree.getNodeByDataIndex(dataIndex);
    params.treePathInfo = wrapTreePathInfo(node, this);
    return params;
  },

  /**
   * @public
   * @param {Object} layoutInfo {
   *                                x: containerGroup x
   *                                y: containerGroup y
   *                                width: containerGroup width
   *                                height: containerGroup height
   *                            }
   */
  setLayoutInfo: function (layoutInfo) {
    /**
     * @readOnly
     * @type {Object}
     */
    this.layoutInfo = this.layoutInfo || {};
    zrUtil.extend(this.layoutInfo, layoutInfo);
  },

  /**
   * @param  {string} id
   * @return {number} index
   */
  mapIdToIndex: function (id) {
    // A feature is implemented:
    // index is monotone increasing with the sequence of
    // input id at the first time.
    // This feature can make sure that each data item and its
    // mapped color have the same index between data list and
    // color list at the beginning, which is useful for user
    // to adjust data-color mapping.

    /**
     * @private
     * @type {Object}
     */
    var idIndexMap = this._idIndexMap;

    if (!idIndexMap) {
      idIndexMap = this._idIndexMap = zrUtil.createHashMap();
      /**
       * @private
       * @type {number}
       */

      this._idIndexMapCount = 0;
    }

    var index = idIndexMap.get(id);

    if (index == null) {
      idIndexMap.set(id, index = this._idIndexMapCount++);
    }

    return index;
  },
  getViewRoot: function () {
    return this._viewRoot;
  },

  /**
   * @param {module:echarts/data/Tree~Node} [viewRoot]
   */
  resetViewRoot: function (viewRoot) {
    viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
    var root = this.getRawData().tree.root;

    if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) {
      this._viewRoot = root;
    }
  }
});
/**
 * @param {Object} dataNode
 */


function completeTreeValue(dataNode) {
  // Postorder travel tree.
  // If value of none-leaf node is not set,
  // calculate it by suming up the value of all children.
  var sum = 0;
  zrUtil.each(dataNode.children, function (child) {
    completeTreeValue(child);
    var childValue = child.value;
    zrUtil.isArray(childValue) && (childValue = childValue[0]);
    sum += childValue;
  });
  var thisValue = dataNode.value;

  if (zrUtil.isArray(thisValue)) {
    thisValue = thisValue[0];
  }

  if (thisValue == null || isNaN(thisValue)) {
    thisValue = sum;
  } // Value should not less than 0.


  if (thisValue < 0) {
    thisValue = 0;
  }

  zrUtil.isArray(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
}
/**
 * set default to level configuration
 */


function setDefault(levels, ecModel) {
  var globalColorList = ecModel.get('color');

  if (!globalColorList) {
    return;
  }

  levels = levels || [];
  var hasColorDefine;
  zrUtil.each(levels, function (levelDefine) {
    var model = new Model(levelDefine);
    var modelColor = model.get('color');

    if (model.get('itemStyle.color') || modelColor && modelColor !== 'none') {
      hasColorDefine = true;
    }
  });

  if (!hasColorDefine) {
    var level0 = levels[0] || (levels[0] = {});
    level0.color = globalColorList.slice();
  }

  return levels;
}

module.exports = _default;

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var graphic = __webpack_require__(27);

var DataDiffer = __webpack_require__(177);

var helper = __webpack_require__(180);

var Breadcrumb = __webpack_require__(1630);

var RoamController = __webpack_require__(245);

var BoundingRect = __webpack_require__(57);

var matrix = __webpack_require__(82);

var animationUtil = __webpack_require__(1631);

var makeStyleMapper = __webpack_require__(204);

var _format = __webpack_require__(54);

var windowOpen = _format.windowOpen;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var bind = zrUtil.bind;
var Group = graphic.Group;
var Rect = graphic.Rect;
var each = zrUtil.each;
var DRAG_THRESHOLD = 3;
var PATH_LABEL_NOAMAL = ['label'];
var PATH_LABEL_EMPHASIS = ['emphasis', 'label'];
var PATH_UPPERLABEL_NORMAL = ['upperLabel'];
var PATH_UPPERLABEL_EMPHASIS = ['emphasis', 'upperLabel'];
var Z_BASE = 10; // Should bigger than every z.

var Z_BG = 1;
var Z_CONTENT = 2;
var getItemStyleEmphasis = makeStyleMapper([['fill', 'color'], // `borderColor` and `borderWidth` has been occupied,
// so use `stroke` to indicate the stroke of the rect.
['stroke', 'strokeColor'], ['lineWidth', 'strokeWidth'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);

var getItemStyleNormal = function (model) {
  // Normal style props should include emphasis style props.
  var itemStyle = getItemStyleEmphasis(model); // Clear styles set by emphasis.

  itemStyle.stroke = itemStyle.fill = itemStyle.lineWidth = null;
  return itemStyle;
};

var _default = echarts.extendChartView({
  type: 'treemap',

  /**
   * @override
   */
  init: function (o, api) {
    /**
     * @private
     * @type {module:zrender/container/Group}
     */
    this._containerGroup;
    /**
     * @private
     * @type {Object.<string, Array.<module:zrender/container/Group>>}
     */

    this._storage = createStorage();
    /**
     * @private
     * @type {module:echarts/data/Tree}
     */

    this._oldTree;
    /**
     * @private
     * @type {module:echarts/chart/treemap/Breadcrumb}
     */

    this._breadcrumb;
    /**
     * @private
     * @type {module:echarts/component/helper/RoamController}
     */

    this._controller;
    /**
     * 'ready', 'animating'
     * @private
     */

    this._state = 'ready';
  },

  /**
   * @override
   */
  render: function (seriesModel, ecModel, api, payload) {
    var models = ecModel.findComponents({
      mainType: 'series',
      subType: 'treemap',
      query: payload
    });

    if (zrUtil.indexOf(models, seriesModel) < 0) {
      return;
    }

    this.seriesModel = seriesModel;
    this.api = api;
    this.ecModel = ecModel;
    var types = ['treemapZoomToNode', 'treemapRootToNode'];
    var targetInfo = helper.retrieveTargetInfo(payload, types, seriesModel);
    var payloadType = payload && payload.type;
    var layoutInfo = seriesModel.layoutInfo;
    var isInit = !this._oldTree;
    var thisStorage = this._storage; // Mark new root when action is treemapRootToNode.

    var reRoot = payloadType === 'treemapRootToNode' && targetInfo && thisStorage ? {
      rootNodeGroup: thisStorage.nodeGroup[targetInfo.node.getRawIndex()],
      direction: payload.direction
    } : null;

    var containerGroup = this._giveContainerGroup(layoutInfo);

    var renderResult = this._doRender(containerGroup, seriesModel, reRoot);

    !isInit && (!payloadType || payloadType === 'treemapZoomToNode' || payloadType === 'treemapRootToNode') ? this._doAnimation(containerGroup, renderResult, seriesModel, reRoot) : renderResult.renderFinally();

    this._resetController(api);

    this._renderBreadcrumb(seriesModel, api, targetInfo);
  },

  /**
   * @private
   */
  _giveContainerGroup: function (layoutInfo) {
    var containerGroup = this._containerGroup;

    if (!containerGroup) {
      // FIXME
      // 加一层containerGroup是为了clip，但是现在clip功能并没有实现。
      containerGroup = this._containerGroup = new Group();

      this._initEvents(containerGroup);

      this.group.add(containerGroup);
    }

    containerGroup.attr('position', [layoutInfo.x, layoutInfo.y]);
    return containerGroup;
  },

  /**
   * @private
   */
  _doRender: function (containerGroup, seriesModel, reRoot) {
    var thisTree = seriesModel.getData().tree;
    var oldTree = this._oldTree; // Clear last shape records.

    var lastsForAnimation = createStorage();
    var thisStorage = createStorage();
    var oldStorage = this._storage;
    var willInvisibleEls = [];
    var doRenderNode = zrUtil.curry(renderNode, seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls); // Notice: when thisTree and oldTree are the same tree (see list.cloneShallow),
    // the oldTree is actually losted, so we can not find all of the old graphic
    // elements from tree. So we use this stragegy: make element storage, move
    // from old storage to new storage, clear old storage.

    dualTravel(thisTree.root ? [thisTree.root] : [], oldTree && oldTree.root ? [oldTree.root] : [], containerGroup, thisTree === oldTree || !oldTree, 0); // Process all removing.

    var willDeleteEls = clearStorage(oldStorage);
    this._oldTree = thisTree;
    this._storage = thisStorage;
    return {
      lastsForAnimation: lastsForAnimation,
      willDeleteEls: willDeleteEls,
      renderFinally: renderFinally
    };

    function dualTravel(thisViewChildren, oldViewChildren, parentGroup, sameTree, depth) {
      // When 'render' is triggered by action,
      // 'this' and 'old' may be the same tree,
      // we use rawIndex in that case.
      if (sameTree) {
        oldViewChildren = thisViewChildren;
        each(thisViewChildren, function (child, index) {
          !child.isRemoved() && processNode(index, index);
        });
      } // Diff hierarchically (diff only in each subtree, but not whole).
      // because, consistency of view is important.
      else {
          new DataDiffer(oldViewChildren, thisViewChildren, getKey, getKey).add(processNode).update(processNode).remove(zrUtil.curry(processNode, null)).execute();
        }

      function getKey(node) {
        // Identify by name or raw index.
        return node.getId();
      }

      function processNode(newIndex, oldIndex) {
        var thisNode = newIndex != null ? thisViewChildren[newIndex] : null;
        var oldNode = oldIndex != null ? oldViewChildren[oldIndex] : null;
        var group = doRenderNode(thisNode, oldNode, parentGroup, depth);
        group && dualTravel(thisNode && thisNode.viewChildren || [], oldNode && oldNode.viewChildren || [], group, sameTree, depth + 1);
      }
    }

    function clearStorage(storage) {
      var willDeleteEls = createStorage();
      storage && each(storage, function (store, storageName) {
        var delEls = willDeleteEls[storageName];
        each(store, function (el) {
          el && (delEls.push(el), el.__tmWillDelete = 1);
        });
      });
      return willDeleteEls;
    }

    function renderFinally() {
      each(willDeleteEls, function (els) {
        each(els, function (el) {
          el.parent && el.parent.remove(el);
        });
      });
      each(willInvisibleEls, function (el) {
        el.invisible = true; // Setting invisible is for optimizing, so no need to set dirty,
        // just mark as invisible.

        el.dirty();
      });
    }
  },

  /**
   * @private
   */
  _doAnimation: function (containerGroup, renderResult, seriesModel, reRoot) {
    if (!seriesModel.get('animation')) {
      return;
    }

    var duration = seriesModel.get('animationDurationUpdate');
    var easing = seriesModel.get('animationEasing');
    var animationWrap = animationUtil.createWrap(); // Make delete animations.

    each(renderResult.willDeleteEls, function (store, storageName) {
      each(store, function (el, rawIndex) {
        if (el.invisible) {
          return;
        }

        var parent = el.parent; // Always has parent, and parent is nodeGroup.

        var target;

        if (reRoot && reRoot.direction === 'drillDown') {
          target = parent === reRoot.rootNodeGroup // This is the content element of view root.
          // Only `content` will enter this branch, because
          // `background` and `nodeGroup` will not be deleted.
          ? {
            shape: {
              x: 0,
              y: 0,
              width: parent.__tmNodeWidth,
              height: parent.__tmNodeHeight
            },
            style: {
              opacity: 0
            } // Others.

          } : {
            style: {
              opacity: 0
            }
          };
        } else {
          var targetX = 0;
          var targetY = 0;

          if (!parent.__tmWillDelete) {
            // Let node animate to right-bottom corner, cooperating with fadeout,
            // which is appropriate for user understanding.
            // Divided by 2 for reRoot rolling up effect.
            targetX = parent.__tmNodeWidth / 2;
            targetY = parent.__tmNodeHeight / 2;
          }

          target = storageName === 'nodeGroup' ? {
            position: [targetX, targetY],
            style: {
              opacity: 0
            }
          } : {
            shape: {
              x: targetX,
              y: targetY,
              width: 0,
              height: 0
            },
            style: {
              opacity: 0
            }
          };
        }

        target && animationWrap.add(el, target, duration, easing);
      });
    }); // Make other animations

    each(this._storage, function (store, storageName) {
      each(store, function (el, rawIndex) {
        var last = renderResult.lastsForAnimation[storageName][rawIndex];
        var target = {};

        if (!last) {
          return;
        }

        if (storageName === 'nodeGroup') {
          if (last.old) {
            target.position = el.position.slice();
            el.attr('position', last.old);
          }
        } else {
          if (last.old) {
            target.shape = zrUtil.extend({}, el.shape);
            el.setShape(last.old);
          }

          if (last.fadein) {
            el.setStyle('opacity', 0);
            target.style = {
              opacity: 1
            };
          } // When animation is stopped for succedent animation starting,
          // el.style.opacity might not be 1
          else if (el.style.opacity !== 1) {
              target.style = {
                opacity: 1
              };
            }
        }

        animationWrap.add(el, target, duration, easing);
      });
    }, this);
    this._state = 'animating';
    animationWrap.done(bind(function () {
      this._state = 'ready';
      renderResult.renderFinally();
    }, this)).start();
  },

  /**
   * @private
   */
  _resetController: function (api) {
    var controller = this._controller; // Init controller.

    if (!controller) {
      controller = this._controller = new RoamController(api.getZr());
      controller.enable(this.seriesModel.get('roam'));
      controller.on('pan', bind(this._onPan, this));
      controller.on('zoom', bind(this._onZoom, this));
    }

    var rect = new BoundingRect(0, 0, api.getWidth(), api.getHeight());
    controller.setPointerChecker(function (e, x, y) {
      return rect.contain(x, y);
    });
  },

  /**
   * @private
   */
  _clearController: function () {
    var controller = this._controller;

    if (controller) {
      controller.dispose();
      controller = null;
    }
  },

  /**
   * @private
   */
  _onPan: function (e) {
    if (this._state !== 'animating' && (Math.abs(e.dx) > DRAG_THRESHOLD || Math.abs(e.dy) > DRAG_THRESHOLD)) {
      // These param must not be cached.
      var root = this.seriesModel.getData().tree.root;

      if (!root) {
        return;
      }

      var rootLayout = root.getLayout();

      if (!rootLayout) {
        return;
      }

      this.api.dispatchAction({
        type: 'treemapMove',
        from: this.uid,
        seriesId: this.seriesModel.id,
        rootRect: {
          x: rootLayout.x + e.dx,
          y: rootLayout.y + e.dy,
          width: rootLayout.width,
          height: rootLayout.height
        }
      });
    }
  },

  /**
   * @private
   */
  _onZoom: function (e) {
    var mouseX = e.originX;
    var mouseY = e.originY;

    if (this._state !== 'animating') {
      // These param must not be cached.
      var root = this.seriesModel.getData().tree.root;

      if (!root) {
        return;
      }

      var rootLayout = root.getLayout();

      if (!rootLayout) {
        return;
      }

      var rect = new BoundingRect(rootLayout.x, rootLayout.y, rootLayout.width, rootLayout.height);
      var layoutInfo = this.seriesModel.layoutInfo; // Transform mouse coord from global to containerGroup.

      mouseX -= layoutInfo.x;
      mouseY -= layoutInfo.y; // Scale root bounding rect.

      var m = matrix.create();
      matrix.translate(m, m, [-mouseX, -mouseY]);
      matrix.scale(m, m, [e.scale, e.scale]);
      matrix.translate(m, m, [mouseX, mouseY]);
      rect.applyTransform(m);
      this.api.dispatchAction({
        type: 'treemapRender',
        from: this.uid,
        seriesId: this.seriesModel.id,
        rootRect: {
          x: rect.x,
          y: rect.y,
          width: rect.width,
          height: rect.height
        }
      });
    }
  },

  /**
   * @private
   */
  _initEvents: function (containerGroup) {
    containerGroup.on('click', function (e) {
      if (this._state !== 'ready') {
        return;
      }

      var nodeClick = this.seriesModel.get('nodeClick', true);

      if (!nodeClick) {
        return;
      }

      var targetInfo = this.findTarget(e.offsetX, e.offsetY);

      if (!targetInfo) {
        return;
      }

      var node = targetInfo.node;

      if (node.getLayout().isLeafRoot) {
        this._rootToNode(targetInfo);
      } else {
        if (nodeClick === 'zoomToNode') {
          this._zoomToNode(targetInfo);
        } else if (nodeClick === 'link') {
          var itemModel = node.hostTree.data.getItemModel(node.dataIndex);
          var link = itemModel.get('link', true);
          var linkTarget = itemModel.get('target', true) || 'blank';
          link && windowOpen(link, linkTarget);
        }
      }
    }, this);
  },

  /**
   * @private
   */
  _renderBreadcrumb: function (seriesModel, api, targetInfo) {
    if (!targetInfo) {
      targetInfo = seriesModel.get('leafDepth', true) != null ? {
        node: seriesModel.getViewRoot() // FIXME
        // better way?
        // Find breadcrumb tail on center of containerGroup.

      } : this.findTarget(api.getWidth() / 2, api.getHeight() / 2);

      if (!targetInfo) {
        targetInfo = {
          node: seriesModel.getData().tree.root
        };
      }
    }

    (this._breadcrumb || (this._breadcrumb = new Breadcrumb(this.group))).render(seriesModel, api, targetInfo.node, bind(onSelect, this));

    function onSelect(node) {
      if (this._state !== 'animating') {
        helper.aboveViewRoot(seriesModel.getViewRoot(), node) ? this._rootToNode({
          node: node
        }) : this._zoomToNode({
          node: node
        });
      }
    }
  },

  /**
   * @override
   */
  remove: function () {
    this._clearController();

    this._containerGroup && this._containerGroup.removeAll();
    this._storage = createStorage();
    this._state = 'ready';
    this._breadcrumb && this._breadcrumb.remove();
  },
  dispose: function () {
    this._clearController();
  },

  /**
   * @private
   */
  _zoomToNode: function (targetInfo) {
    this.api.dispatchAction({
      type: 'treemapZoomToNode',
      from: this.uid,
      seriesId: this.seriesModel.id,
      targetNode: targetInfo.node
    });
  },

  /**
   * @private
   */
  _rootToNode: function (targetInfo) {
    this.api.dispatchAction({
      type: 'treemapRootToNode',
      from: this.uid,
      seriesId: this.seriesModel.id,
      targetNode: targetInfo.node
    });
  },

  /**
   * @public
   * @param {number} x Global coord x.
   * @param {number} y Global coord y.
   * @return {Object} info If not found, return undefined;
   * @return {number} info.node Target node.
   * @return {number} info.offsetX x refer to target node.
   * @return {number} info.offsetY y refer to target node.
   */
  findTarget: function (x, y) {
    var targetInfo;
    var viewRoot = this.seriesModel.getViewRoot();
    viewRoot.eachNode({
      attr: 'viewChildren',
      order: 'preorder'
    }, function (node) {
      var bgEl = this._storage.background[node.getRawIndex()]; // If invisible, there might be no element.


      if (bgEl) {
        var point = bgEl.transformCoordToLocal(x, y);
        var shape = bgEl.shape; // For performance consideration, dont use 'getBoundingRect'.

        if (shape.x <= point[0] && point[0] <= shape.x + shape.width && shape.y <= point[1] && point[1] <= shape.y + shape.height) {
          targetInfo = {
            node: node,
            offsetX: point[0],
            offsetY: point[1]
          };
        } else {
          return false; // Suppress visit subtree.
        }
      }
    }, this);
    return targetInfo;
  }
});
/**
 * @inner
 */


function createStorage() {
  return {
    nodeGroup: [],
    background: [],
    content: []
  };
}
/**
 * @inner
 * @return Return undefined means do not travel further.
 */


function renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth) {
  // Whether under viewRoot.
  if (!thisNode) {
    // Deleting nodes will be performed finally. This method just find
    // element from old storage, or create new element, set them to new
    // storage, and set styles.
    return;
  } // -------------------------------------------------------------------
  // Start of closure variables available in "Procedures in renderNode".


  var thisLayout = thisNode.getLayout();
  var data = seriesModel.getData(); // Only for enabling highlight/downplay. Clear firstly.
  // Because some node will not be rendered.

  data.setItemGraphicEl(thisNode.dataIndex, null);

  if (!thisLayout || !thisLayout.isInView) {
    return;
  }

  var thisWidth = thisLayout.width;
  var thisHeight = thisLayout.height;
  var borderWidth = thisLayout.borderWidth;
  var thisInvisible = thisLayout.invisible;
  var thisRawIndex = thisNode.getRawIndex();
  var oldRawIndex = oldNode && oldNode.getRawIndex();
  var thisViewChildren = thisNode.viewChildren;
  var upperHeight = thisLayout.upperHeight;
  var isParent = thisViewChildren && thisViewChildren.length;
  var itemStyleNormalModel = thisNode.getModel('itemStyle');
  var itemStyleEmphasisModel = thisNode.getModel('emphasis.itemStyle'); // End of closure ariables available in "Procedures in renderNode".
  // -----------------------------------------------------------------
  // Node group

  var group = giveGraphic('nodeGroup', Group);

  if (!group) {
    return;
  }

  parentGroup.add(group); // x,y are not set when el is above view root.

  group.attr('position', [thisLayout.x || 0, thisLayout.y || 0]);
  group.__tmNodeWidth = thisWidth;
  group.__tmNodeHeight = thisHeight;

  if (thisLayout.isAboveViewRoot) {
    return group;
  }

  var nodeModel = thisNode.getModel(); // Background

  var bg = giveGraphic('background', Rect, depth, Z_BG);
  bg && renderBackground(group, bg, isParent && thisLayout.upperLabelHeight); // No children, render content.

  if (isParent) {
    // Because of the implementation about "traverse" in graphic hover style, we
    // can not set hover listener on the "group" of non-leaf node. Otherwise the
    // hover event from the descendents will be listenered.
    if (graphic.isHighDownDispatcher(group)) {
      graphic.setAsHighDownDispatcher(group, false);
    }

    if (bg) {
      graphic.setAsHighDownDispatcher(bg, true); // Only for enabling highlight/downplay.

      data.setItemGraphicEl(thisNode.dataIndex, bg);
    }
  } else {
    var content = giveGraphic('content', Rect, depth, Z_CONTENT);
    content && renderContent(group, content);

    if (bg && graphic.isHighDownDispatcher(bg)) {
      graphic.setAsHighDownDispatcher(bg, false);
    }

    graphic.setAsHighDownDispatcher(group, true); // Only for enabling highlight/downplay.

    data.setItemGraphicEl(thisNode.dataIndex, group);
  }

  return group; // ----------------------------
  // | Procedures in renderNode |
  // ----------------------------

  function renderBackground(group, bg, useUpperLabel) {
    // For tooltip.
    bg.dataIndex = thisNode.dataIndex;
    bg.seriesIndex = seriesModel.seriesIndex;
    bg.setShape({
      x: 0,
      y: 0,
      width: thisWidth,
      height: thisHeight
    });

    if (thisInvisible) {
      // If invisible, do not set visual, otherwise the element will
      // change immediately before animation. We think it is OK to
      // remain its origin color when moving out of the view window.
      processInvisible(bg);
    } else {
      bg.invisible = false;
      var visualBorderColor = thisNode.getVisual('borderColor', true);
      var emphasisBorderColor = itemStyleEmphasisModel.get('borderColor');
      var normalStyle = getItemStyleNormal(itemStyleNormalModel);
      normalStyle.fill = visualBorderColor;
      var emphasisStyle = getItemStyleEmphasis(itemStyleEmphasisModel);
      emphasisStyle.fill = emphasisBorderColor;

      if (useUpperLabel) {
        var upperLabelWidth = thisWidth - 2 * borderWidth;
        prepareText(normalStyle, emphasisStyle, visualBorderColor, upperLabelWidth, upperHeight, {
          x: borderWidth,
          y: 0,
          width: upperLabelWidth,
          height: upperHeight
        });
      } // For old bg.
      else {
          normalStyle.text = emphasisStyle.text = null;
        }

      bg.setStyle(normalStyle);
      graphic.setElementHoverStyle(bg, emphasisStyle);
    }

    group.add(bg);
  }

  function renderContent(group, content) {
    // For tooltip.
    content.dataIndex = thisNode.dataIndex;
    content.seriesIndex = seriesModel.seriesIndex;
    var contentWidth = Math.max(thisWidth - 2 * borderWidth, 0);
    var contentHeight = Math.max(thisHeight - 2 * borderWidth, 0);
    content.culling = true;
    content.setShape({
      x: borderWidth,
      y: borderWidth,
      width: contentWidth,
      height: contentHeight
    });

    if (thisInvisible) {
      // If invisible, do not set visual, otherwise the element will
      // change immediately before animation. We think it is OK to
      // remain its origin color when moving out of the view window.
      processInvisible(content);
    } else {
      content.invisible = false;
      var visualColor = thisNode.getVisual('color', true);
      var normalStyle = getItemStyleNormal(itemStyleNormalModel);
      normalStyle.fill = visualColor;
      var emphasisStyle = getItemStyleEmphasis(itemStyleEmphasisModel);
      prepareText(normalStyle, emphasisStyle, visualColor, contentWidth, contentHeight);
      content.setStyle(normalStyle);
      graphic.setElementHoverStyle(content, emphasisStyle);
    }

    group.add(content);
  }

  function processInvisible(element) {
    // Delay invisible setting utill animation finished,
    // avoid element vanish suddenly before animation.
    !element.invisible && willInvisibleEls.push(element);
  }

  function prepareText(normalStyle, emphasisStyle, visualColor, width, height, upperLabelRect) {
    var defaultText = nodeModel.get('name');
    var normalLabelModel = nodeModel.getModel(upperLabelRect ? PATH_UPPERLABEL_NORMAL : PATH_LABEL_NOAMAL);
    var emphasisLabelModel = nodeModel.getModel(upperLabelRect ? PATH_UPPERLABEL_EMPHASIS : PATH_LABEL_EMPHASIS);
    var isShow = normalLabelModel.getShallow('show');
    graphic.setLabelStyle(normalStyle, emphasisStyle, normalLabelModel, emphasisLabelModel, {
      defaultText: isShow ? defaultText : null,
      autoColor: visualColor,
      isRectText: true,
      labelFetcher: seriesModel,
      labelDataIndex: thisNode.dataIndex,
      labelProp: upperLabelRect ? 'upperLabel' : 'label'
    });
    addDrillDownIcon(normalStyle, upperLabelRect, thisLayout);
    addDrillDownIcon(emphasisStyle, upperLabelRect, thisLayout);
    upperLabelRect && (normalStyle.textRect = zrUtil.clone(upperLabelRect));
    normalStyle.truncate = isShow && normalLabelModel.get('ellipsis') ? {
      outerWidth: width,
      outerHeight: height,
      minChar: 2
    } : null;
  }

  function addDrillDownIcon(style, upperLabelRect, thisLayout) {
    var text = style.text;

    if (!upperLabelRect && thisLayout.isLeafRoot && text != null) {
      var iconChar = seriesModel.get('drillDownIcon', true);
      style.text = iconChar ? iconChar + ' ' + text : text;
    }
  }

  function giveGraphic(storageName, Ctor, depth, z) {
    var element = oldRawIndex != null && oldStorage[storageName][oldRawIndex];
    var lasts = lastsForAnimation[storageName];

    if (element) {
      // Remove from oldStorage
      oldStorage[storageName][oldRawIndex] = null;
      prepareAnimationWhenHasOld(lasts, element, storageName);
    } // If invisible and no old element, do not create new element (for optimizing).
    else if (!thisInvisible) {
        element = new Ctor({
          z: calculateZ(depth, z)
        });
        element.__tmDepth = depth;
        element.__tmStorageName = storageName;
        prepareAnimationWhenNoOld(lasts, element, storageName);
      } // Set to thisStorage


    return thisStorage[storageName][thisRawIndex] = element;
  }

  function prepareAnimationWhenHasOld(lasts, element, storageName) {
    var lastCfg = lasts[thisRawIndex] = {};
    lastCfg.old = storageName === 'nodeGroup' ? element.position.slice() : zrUtil.extend({}, element.shape);
  } // If a element is new, we need to find the animation start point carefully,
  // otherwise it will looks strange when 'zoomToNode'.


  function prepareAnimationWhenNoOld(lasts, element, storageName) {
    var lastCfg = lasts[thisRawIndex] = {};
    var parentNode = thisNode.parentNode;

    if (parentNode && (!reRoot || reRoot.direction === 'drillDown')) {
      var parentOldX = 0;
      var parentOldY = 0; // New nodes appear from right-bottom corner in 'zoomToNode' animation.
      // For convenience, get old bounding rect from background.

      var parentOldBg = lastsForAnimation.background[parentNode.getRawIndex()];

      if (!reRoot && parentOldBg && parentOldBg.old) {
        parentOldX = parentOldBg.old.width;
        parentOldY = parentOldBg.old.height;
      } // When no parent old shape found, its parent is new too,
      // so we can just use {x:0, y:0}.


      lastCfg.old = storageName === 'nodeGroup' ? [0, parentOldY] : {
        x: parentOldX,
        y: parentOldY,
        width: 0,
        height: 0
      };
    } // Fade in, user can be aware that these nodes are new.


    lastCfg.fadein = storageName !== 'nodeGroup';
  }
} // We can not set all backgroud with the same z, Because the behaviour of
// drill down and roll up differ background creation sequence from tree
// hierarchy sequence, which cause that lowser background element overlap
// upper ones. So we calculate z based on depth.
// Moreover, we try to shrink down z interval to [0, 1] to avoid that
// treemap with large z overlaps other components.


function calculateZ(depth, zInLevel) {
  var zb = depth * Z_BASE + zInLevel;
  return (zb - 1) / zb;
}

module.exports = _default;

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var graphic = __webpack_require__(27);

var layout = __webpack_require__(53);

var zrUtil = __webpack_require__(1);

var _treeHelper = __webpack_require__(180);

var wrapTreePathInfo = _treeHelper.wrapTreePathInfo;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var TEXT_PADDING = 8;
var ITEM_GAP = 8;
var ARRAY_LENGTH = 5;

function Breadcrumb(containerGroup) {
  /**
   * @private
   * @type {module:zrender/container/Group}
   */
  this.group = new graphic.Group();
  containerGroup.add(this.group);
}

Breadcrumb.prototype = {
  constructor: Breadcrumb,
  render: function (seriesModel, api, targetNode, onSelect) {
    var model = seriesModel.getModel('breadcrumb');
    var thisGroup = this.group;
    thisGroup.removeAll();

    if (!model.get('show') || !targetNode) {
      return;
    }

    var normalStyleModel = model.getModel('itemStyle'); // var emphasisStyleModel = model.getModel('emphasis.itemStyle');

    var textStyleModel = normalStyleModel.getModel('textStyle');
    var layoutParam = {
      pos: {
        left: model.get('left'),
        right: model.get('right'),
        top: model.get('top'),
        bottom: model.get('bottom')
      },
      box: {
        width: api.getWidth(),
        height: api.getHeight()
      },
      emptyItemWidth: model.get('emptyItemWidth'),
      totalWidth: 0,
      renderList: []
    };

    this._prepare(targetNode, layoutParam, textStyleModel);

    this._renderContent(seriesModel, layoutParam, normalStyleModel, textStyleModel, onSelect);

    layout.positionElement(thisGroup, layoutParam.pos, layoutParam.box);
  },

  /**
   * Prepare render list and total width
   * @private
   */
  _prepare: function (targetNode, layoutParam, textStyleModel) {
    for (var node = targetNode; node; node = node.parentNode) {
      var text = node.getModel().get('name');
      var textRect = textStyleModel.getTextRect(text);
      var itemWidth = Math.max(textRect.width + TEXT_PADDING * 2, layoutParam.emptyItemWidth);
      layoutParam.totalWidth += itemWidth + ITEM_GAP;
      layoutParam.renderList.push({
        node: node,
        text: text,
        width: itemWidth
      });
    }
  },

  /**
   * @private
   */
  _renderContent: function (seriesModel, layoutParam, normalStyleModel, textStyleModel, onSelect) {
    // Start rendering.
    var lastX = 0;
    var emptyItemWidth = layoutParam.emptyItemWidth;
    var height = seriesModel.get('breadcrumb.height');
    var availableSize = layout.getAvailableSize(layoutParam.pos, layoutParam.box);
    var totalWidth = layoutParam.totalWidth;
    var renderList = layoutParam.renderList;

    for (var i = renderList.length - 1; i >= 0; i--) {
      var item = renderList[i];
      var itemNode = item.node;
      var itemWidth = item.width;
      var text = item.text; // Hdie text and shorten width if necessary.

      if (totalWidth > availableSize.width) {
        totalWidth -= itemWidth - emptyItemWidth;
        itemWidth = emptyItemWidth;
        text = null;
      }

      var el = new graphic.Polygon({
        shape: {
          points: makeItemPoints(lastX, 0, itemWidth, height, i === renderList.length - 1, i === 0)
        },
        style: zrUtil.defaults(normalStyleModel.getItemStyle(), {
          lineJoin: 'bevel',
          text: text,
          textFill: textStyleModel.getTextColor(),
          textFont: textStyleModel.getFont()
        }),
        z: 10,
        onclick: zrUtil.curry(onSelect, itemNode)
      });
      this.group.add(el);
      packEventData(el, seriesModel, itemNode);
      lastX += itemWidth + ITEM_GAP;
    }
  },

  /**
   * @override
   */
  remove: function () {
    this.group.removeAll();
  }
};

function makeItemPoints(x, y, itemWidth, itemHeight, head, tail) {
  var points = [[head ? x : x - ARRAY_LENGTH, y], [x + itemWidth, y], [x + itemWidth, y + itemHeight], [head ? x : x - ARRAY_LENGTH, y + itemHeight]];
  !tail && points.splice(2, 0, [x + itemWidth + ARRAY_LENGTH, y + itemHeight / 2]);
  !head && points.push([x, y + itemHeight / 2]);
  return points;
} // Package custom mouse event.


function packEventData(el, seriesModel, itemNode) {
  el.eventData = {
    componentType: 'series',
    componentSubType: 'treemap',
    componentIndex: seriesModel.componentIndex,
    seriesIndex: seriesModel.componentIndex,
    seriesName: seriesModel.name,
    seriesType: 'treemap',
    selfType: 'breadcrumb',
    // Distinguish with click event on treemap node.
    nodeData: {
      dataIndex: itemNode && itemNode.dataIndex,
      name: itemNode && itemNode.name
    },
    treePathInfo: itemNode && wrapTreePathInfo(itemNode, seriesModel)
  };
}

var _default = Breadcrumb;
module.exports = _default;

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @param {number} [time=500] Time in ms
 * @param {string} [easing='linear']
 * @param {number} [delay=0]
 * @param {Function} [callback]
 *
 * @example
 *  // Animate position
 *  animation
 *      .createWrap()
 *      .add(el1, {position: [10, 10]})
 *      .add(el2, {shape: {width: 500}, style: {fill: 'red'}}, 400)
 *      .done(function () { // done })
 *      .start('cubicOut');
 */
function createWrap() {
  var storage = [];
  var elExistsMap = {};
  var doneCallback;
  return {
    /**
     * Caution: a el can only be added once, otherwise 'done'
     * might not be called. This method checks this (by el.id),
     * suppresses adding and returns false when existing el found.
     *
     * @param {modele:zrender/Element} el
     * @param {Object} target
     * @param {number} [time=500]
     * @param {number} [delay=0]
     * @param {string} [easing='linear']
     * @return {boolean} Whether adding succeeded.
     *
     * @example
     *     add(el, target, time, delay, easing);
     *     add(el, target, time, easing);
     *     add(el, target, time);
     *     add(el, target);
     */
    add: function (el, target, time, delay, easing) {
      if (zrUtil.isString(delay)) {
        easing = delay;
        delay = 0;
      }

      if (elExistsMap[el.id]) {
        return false;
      }

      elExistsMap[el.id] = 1;
      storage.push({
        el: el,
        target: target,
        time: time,
        delay: delay,
        easing: easing
      });
      return true;
    },

    /**
     * Only execute when animation finished. Will not execute when any
     * of 'stop' or 'stopAnimation' called.
     *
     * @param {Function} callback
     */
    done: function (callback) {
      doneCallback = callback;
      return this;
    },

    /**
     * Will stop exist animation firstly.
     */
    start: function () {
      var count = storage.length;

      for (var i = 0, len = storage.length; i < len; i++) {
        var item = storage[i];
        item.el.animateTo(item.target, item.time, item.delay, item.easing, done);
      }

      return this;

      function done() {
        count--;

        if (!count) {
          storage.length = 0;
          elExistsMap = {};
          doneCallback && doneCallback();
        }
      }
    }
  };
}

exports.createWrap = createWrap;

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var helper = __webpack_require__(180);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @file Treemap action
 */
var noop = function () {};

var actionTypes = ['treemapZoomToNode', 'treemapRender', 'treemapMove'];

for (var i = 0; i < actionTypes.length; i++) {
  echarts.registerAction({
    type: actionTypes[i],
    update: 'updateView'
  }, noop);
}

echarts.registerAction({
  type: 'treemapRootToNode',
  update: 'updateView'
}, function (payload, ecModel) {
  ecModel.eachComponent({
    mainType: 'series',
    subType: 'treemap',
    query: payload
  }, handleRootToNode);

  function handleRootToNode(model, index) {
    var types = ['treemapZoomToNode', 'treemapRootToNode'];
    var targetInfo = helper.retrieveTargetInfo(payload, types, model);

    if (targetInfo) {
      var originViewRoot = model.getViewRoot();

      if (originViewRoot) {
        payload.direction = helper.aboveViewRoot(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
      }

      model.resetViewRoot(targetInfo.node);
    }
  }
});

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var VisualMapping = __webpack_require__(181);

var zrColor = __webpack_require__(122);

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var isArray = zrUtil.isArray;
var ITEM_STYLE_NORMAL = 'itemStyle';
var _default = {
  seriesType: 'treemap',
  reset: function (seriesModel, ecModel, api, payload) {
    var tree = seriesModel.getData().tree;
    var root = tree.root;

    if (root.isRemoved()) {
      return;
    }

    travelTree(root, // Visual should calculate from tree root but not view root.
    {}, seriesModel.getViewRoot().getAncestors(), seriesModel);
  }
};

function travelTree(node, designatedVisual, viewRootAncestors, seriesModel) {
  var nodeModel = node.getModel();
  var nodeLayout = node.getLayout(); // Optimize

  if (!nodeLayout || nodeLayout.invisible || !nodeLayout.isInView) {
    return;
  }

  var nodeItemStyleModel = node.getModel(ITEM_STYLE_NORMAL);
  var visuals = buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel); // calculate border color

  var borderColor = nodeItemStyleModel.get('borderColor');
  var borderColorSaturation = nodeItemStyleModel.get('borderColorSaturation');
  var thisNodeColor;

  if (borderColorSaturation != null) {
    // For performance, do not always execute 'calculateColor'.
    thisNodeColor = calculateColor(visuals, node);
    borderColor = calculateBorderColor(borderColorSaturation, thisNodeColor);
  }

  node.setVisual('borderColor', borderColor);
  var viewChildren = node.viewChildren;

  if (!viewChildren || !viewChildren.length) {
    thisNodeColor = calculateColor(visuals, node); // Apply visual to this node.

    node.setVisual('color', thisNodeColor);
  } else {
    var mapping = buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren); // Designate visual to children.

    zrUtil.each(viewChildren, function (child, index) {
      // If higher than viewRoot, only ancestors of viewRoot is needed to visit.
      if (child.depth >= viewRootAncestors.length || child === viewRootAncestors[child.depth]) {
        var childVisual = mapVisual(nodeModel, visuals, child, index, mapping, seriesModel);
        travelTree(child, childVisual, viewRootAncestors, seriesModel);
      }
    });
  }
}

function buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel) {
  var visuals = zrUtil.extend({}, designatedVisual);
  var designatedVisualItemStyle = seriesModel.designatedVisualItemStyle;
  zrUtil.each(['color', 'colorAlpha', 'colorSaturation'], function (visualName) {
    // Priority: thisNode > thisLevel > parentNodeDesignated > seriesModel
    designatedVisualItemStyle[visualName] = designatedVisual[visualName];
    var val = nodeItemStyleModel.get(visualName);
    designatedVisualItemStyle[visualName] = null;
    val != null && (visuals[visualName] = val);
  });
  return visuals;
}

function calculateColor(visuals) {
  var color = getValueVisualDefine(visuals, 'color');

  if (color) {
    var colorAlpha = getValueVisualDefine(visuals, 'colorAlpha');
    var colorSaturation = getValueVisualDefine(visuals, 'colorSaturation');

    if (colorSaturation) {
      color = zrColor.modifyHSL(color, null, null, colorSaturation);
    }

    if (colorAlpha) {
      color = zrColor.modifyAlpha(color, colorAlpha);
    }

    return color;
  }
}

function calculateBorderColor(borderColorSaturation, thisNodeColor) {
  return thisNodeColor != null ? zrColor.modifyHSL(thisNodeColor, null, null, borderColorSaturation) : null;
}

function getValueVisualDefine(visuals, name) {
  var value = visuals[name];

  if (value != null && value !== 'none') {
    return value;
  }
}

function buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren) {
  if (!viewChildren || !viewChildren.length) {
    return;
  }

  var rangeVisual = getRangeVisual(nodeModel, 'color') || visuals.color != null && visuals.color !== 'none' && (getRangeVisual(nodeModel, 'colorAlpha') || getRangeVisual(nodeModel, 'colorSaturation'));

  if (!rangeVisual) {
    return;
  }

  var visualMin = nodeModel.get('visualMin');
  var visualMax = nodeModel.get('visualMax');
  var dataExtent = nodeLayout.dataExtent.slice();
  visualMin != null && visualMin < dataExtent[0] && (dataExtent[0] = visualMin);
  visualMax != null && visualMax > dataExtent[1] && (dataExtent[1] = visualMax);
  var colorMappingBy = nodeModel.get('colorMappingBy');
  var opt = {
    type: rangeVisual.name,
    dataExtent: dataExtent,
    visual: rangeVisual.range
  };

  if (opt.type === 'color' && (colorMappingBy === 'index' || colorMappingBy === 'id')) {
    opt.mappingMethod = 'category';
    opt.loop = true; // categories is ordinal, so do not set opt.categories.
  } else {
    opt.mappingMethod = 'linear';
  }

  var mapping = new VisualMapping(opt);
  mapping.__drColorMappingBy = colorMappingBy;
  return mapping;
} // Notice: If we dont have the attribute 'colorRange', but only use
// attribute 'color' to represent both concepts of 'colorRange' and 'color',
// (It means 'colorRange' when 'color' is Array, means 'color' when not array),
// this problem will be encountered:
// If a level-1 node dont have children, and its siblings has children,
// and colorRange is set on level-1, then the node can not be colored.
// So we separate 'colorRange' and 'color' to different attributes.


function getRangeVisual(nodeModel, name) {
  // 'colorRange', 'colorARange', 'colorSRange'.
  // If not exsits on this node, fetch from levels and series.
  var range = nodeModel.get(name);
  return isArray(range) && range.length ? {
    name: name,
    range: range
  } : null;
}

function mapVisual(nodeModel, visuals, child, index, mapping, seriesModel) {
  var childVisuals = zrUtil.extend({}, visuals);

  if (mapping) {
    var mappingType = mapping.type;
    var colorMappingBy = mappingType === 'color' && mapping.__drColorMappingBy;
    var value = colorMappingBy === 'index' ? index : colorMappingBy === 'id' ? seriesModel.mapIdToIndex(child.getId()) : child.getValue(nodeModel.get('visualDimension'));
    childVisuals[mappingType] = mapping.mapValueToVisual(value);
  }

  return childVisuals;
}

module.exports = _default;

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var BoundingRect = __webpack_require__(57);

var _number = __webpack_require__(37);

var parsePercent = _number.parsePercent;
var MAX_SAFE_INTEGER = _number.MAX_SAFE_INTEGER;

var layout = __webpack_require__(53);

var helper = __webpack_require__(180);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* A third-party license is embeded for some of the code in this file:
* The treemap layout implementation was originally copied from
* "d3.js" with some modifications made for this project.
* (See more details in the comment of the method "squarify" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/
var mathMax = Math.max;
var mathMin = Math.min;
var retrieveValue = zrUtil.retrieve;
var each = zrUtil.each;
var PATH_BORDER_WIDTH = ['itemStyle', 'borderWidth'];
var PATH_GAP_WIDTH = ['itemStyle', 'gapWidth'];
var PATH_UPPER_LABEL_SHOW = ['upperLabel', 'show'];
var PATH_UPPER_LABEL_HEIGHT = ['upperLabel', 'height'];
/**
 * @public
 */

var _default = {
  seriesType: 'treemap',
  reset: function (seriesModel, ecModel, api, payload) {
    // Layout result in each node:
    // {x, y, width, height, area, borderWidth}
    var ecWidth = api.getWidth();
    var ecHeight = api.getHeight();
    var seriesOption = seriesModel.option;
    var layoutInfo = layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
      width: api.getWidth(),
      height: api.getHeight()
    });
    var size = seriesOption.size || []; // Compatible with ec2.

    var containerWidth = parsePercent(retrieveValue(layoutInfo.width, size[0]), ecWidth);
    var containerHeight = parsePercent(retrieveValue(layoutInfo.height, size[1]), ecHeight); // Fetch payload info.

    var payloadType = payload && payload.type;
    var types = ['treemapZoomToNode', 'treemapRootToNode'];
    var targetInfo = helper.retrieveTargetInfo(payload, types, seriesModel);
    var rootRect = payloadType === 'treemapRender' || payloadType === 'treemapMove' ? payload.rootRect : null;
    var viewRoot = seriesModel.getViewRoot();
    var viewAbovePath = helper.getPathToRoot(viewRoot);

    if (payloadType !== 'treemapMove') {
      var rootSize = payloadType === 'treemapZoomToNode' ? estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) : rootRect ? [rootRect.width, rootRect.height] : [containerWidth, containerHeight];
      var sort = seriesOption.sort;

      if (sort && sort !== 'asc' && sort !== 'desc') {
        sort = 'desc';
      }

      var options = {
        squareRatio: seriesOption.squareRatio,
        sort: sort,
        leafDepth: seriesOption.leafDepth
      }; // layout should be cleared because using updateView but not update.

      viewRoot.hostTree.clearLayouts(); // TODO
      // optimize: if out of view clip, do not layout.
      // But take care that if do not render node out of view clip,
      // how to calculate start po

      var viewRootLayout = {
        x: 0,
        y: 0,
        width: rootSize[0],
        height: rootSize[1],
        area: rootSize[0] * rootSize[1]
      };
      viewRoot.setLayout(viewRootLayout);
      squarify(viewRoot, options, false, 0); // Supplement layout.

      var viewRootLayout = viewRoot.getLayout();
      each(viewAbovePath, function (node, index) {
        var childValue = (viewAbovePath[index + 1] || viewRoot).getValue();
        node.setLayout(zrUtil.extend({
          dataExtent: [childValue, childValue],
          borderWidth: 0,
          upperHeight: 0
        }, viewRootLayout));
      });
    }

    var treeRoot = seriesModel.getData().tree.root;
    treeRoot.setLayout(calculateRootPosition(layoutInfo, rootRect, targetInfo), true);
    seriesModel.setLayoutInfo(layoutInfo); // FIXME
    // 现在没有clip功能，暂时取ec高宽。

    prunning(treeRoot, // Transform to base element coordinate system.
    new BoundingRect(-layoutInfo.x, -layoutInfo.y, ecWidth, ecHeight), viewAbovePath, viewRoot, 0);
  }
};
/**
 * Layout treemap with squarify algorithm.
 * The original presentation of this algorithm
 * was made by Mark Bruls, Kees Huizing, and Jarke J. van Wijk
 * <https://graphics.ethz.ch/teaching/scivis_common/Literature/squarifiedTreeMaps.pdf>.
 * The implementation of this algorithm was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/layout/treemap.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * @protected
 * @param {module:echarts/data/Tree~TreeNode} node
 * @param {Object} options
 * @param {string} options.sort 'asc' or 'desc'
 * @param {number} options.squareRatio
 * @param {boolean} hideChildren
 * @param {number} depth
 */

function squarify(node, options, hideChildren, depth) {
  var width;
  var height;

  if (node.isRemoved()) {
    return;
  }

  var thisLayout = node.getLayout();
  width = thisLayout.width;
  height = thisLayout.height; // Considering border and gap

  var nodeModel = node.getModel();
  var borderWidth = nodeModel.get(PATH_BORDER_WIDTH);
  var halfGapWidth = nodeModel.get(PATH_GAP_WIDTH) / 2;
  var upperLabelHeight = getUpperLabelHeight(nodeModel);
  var upperHeight = Math.max(borderWidth, upperLabelHeight);
  var layoutOffset = borderWidth - halfGapWidth;
  var layoutOffsetUpper = upperHeight - halfGapWidth;
  var nodeModel = node.getModel();
  node.setLayout({
    borderWidth: borderWidth,
    upperHeight: upperHeight,
    upperLabelHeight: upperLabelHeight
  }, true);
  width = mathMax(width - 2 * layoutOffset, 0);
  height = mathMax(height - layoutOffset - layoutOffsetUpper, 0);
  var totalArea = width * height;
  var viewChildren = initChildren(node, nodeModel, totalArea, options, hideChildren, depth);

  if (!viewChildren.length) {
    return;
  }

  var rect = {
    x: layoutOffset,
    y: layoutOffsetUpper,
    width: width,
    height: height
  };
  var rowFixedLength = mathMin(width, height);
  var best = Infinity; // the best row score so far

  var row = [];
  row.area = 0;

  for (var i = 0, len = viewChildren.length; i < len;) {
    var child = viewChildren[i];
    row.push(child);
    row.area += child.getLayout().area;
    var score = worst(row, rowFixedLength, options.squareRatio); // continue with this orientation

    if (score <= best) {
      i++;
      best = score;
    } // abort, and try a different orientation
    else {
        row.area -= row.pop().getLayout().area;
        position(row, rowFixedLength, rect, halfGapWidth, false);
        rowFixedLength = mathMin(rect.width, rect.height);
        row.length = row.area = 0;
        best = Infinity;
      }
  }

  if (row.length) {
    position(row, rowFixedLength, rect, halfGapWidth, true);
  }

  if (!hideChildren) {
    var childrenVisibleMin = nodeModel.get('childrenVisibleMin');

    if (childrenVisibleMin != null && totalArea < childrenVisibleMin) {
      hideChildren = true;
    }
  }

  for (var i = 0, len = viewChildren.length; i < len; i++) {
    squarify(viewChildren[i], options, hideChildren, depth + 1);
  }
}
/**
 * Set area to each child, and calculate data extent for visual coding.
 */


function initChildren(node, nodeModel, totalArea, options, hideChildren, depth) {
  var viewChildren = node.children || [];
  var orderBy = options.sort;
  orderBy !== 'asc' && orderBy !== 'desc' && (orderBy = null);
  var overLeafDepth = options.leafDepth != null && options.leafDepth <= depth; // leafDepth has higher priority.

  if (hideChildren && !overLeafDepth) {
    return node.viewChildren = [];
  } // Sort children, order by desc.


  viewChildren = zrUtil.filter(viewChildren, function (child) {
    return !child.isRemoved();
  });
  sort(viewChildren, orderBy);
  var info = statistic(nodeModel, viewChildren, orderBy);

  if (info.sum === 0) {
    return node.viewChildren = [];
  }

  info.sum = filterByThreshold(nodeModel, totalArea, info.sum, orderBy, viewChildren);

  if (info.sum === 0) {
    return node.viewChildren = [];
  } // Set area to each child.


  for (var i = 0, len = viewChildren.length; i < len; i++) {
    var area = viewChildren[i].getValue() / info.sum * totalArea; // Do not use setLayout({...}, true), because it is needed to clear last layout.

    viewChildren[i].setLayout({
      area: area
    });
  }

  if (overLeafDepth) {
    viewChildren.length && node.setLayout({
      isLeafRoot: true
    }, true);
    viewChildren.length = 0;
  }

  node.viewChildren = viewChildren;
  node.setLayout({
    dataExtent: info.dataExtent
  }, true);
  return viewChildren;
}
/**
 * Consider 'visibleMin'. Modify viewChildren and get new sum.
 */


function filterByThreshold(nodeModel, totalArea, sum, orderBy, orderedChildren) {
  // visibleMin is not supported yet when no option.sort.
  if (!orderBy) {
    return sum;
  }

  var visibleMin = nodeModel.get('visibleMin');
  var len = orderedChildren.length;
  var deletePoint = len; // Always travel from little value to big value.

  for (var i = len - 1; i >= 0; i--) {
    var value = orderedChildren[orderBy === 'asc' ? len - i - 1 : i].getValue();

    if (value / sum * totalArea < visibleMin) {
      deletePoint = i;
      sum -= value;
    }
  }

  orderBy === 'asc' ? orderedChildren.splice(0, len - deletePoint) : orderedChildren.splice(deletePoint, len - deletePoint);
  return sum;
}
/**
 * Sort
 */


function sort(viewChildren, orderBy) {
  if (orderBy) {
    viewChildren.sort(function (a, b) {
      var diff = orderBy === 'asc' ? a.getValue() - b.getValue() : b.getValue() - a.getValue();
      return diff === 0 ? orderBy === 'asc' ? a.dataIndex - b.dataIndex : b.dataIndex - a.dataIndex : diff;
    });
  }

  return viewChildren;
}
/**
 * Statistic
 */


function statistic(nodeModel, children, orderBy) {
  // Calculate sum.
  var sum = 0;

  for (var i = 0, len = children.length; i < len; i++) {
    sum += children[i].getValue();
  } // Statistic data extent for latter visual coding.
  // Notice: data extent should be calculate based on raw children
  // but not filtered view children, otherwise visual mapping will not
  // be stable when zoom (where children is filtered by visibleMin).


  var dimension = nodeModel.get('visualDimension');
  var dataExtent; // The same as area dimension.

  if (!children || !children.length) {
    dataExtent = [NaN, NaN];
  } else if (dimension === 'value' && orderBy) {
    dataExtent = [children[children.length - 1].getValue(), children[0].getValue()];
    orderBy === 'asc' && dataExtent.reverse();
  } // Other dimension.
  else {
      var dataExtent = [Infinity, -Infinity];
      each(children, function (child) {
        var value = child.getValue(dimension);
        value < dataExtent[0] && (dataExtent[0] = value);
        value > dataExtent[1] && (dataExtent[1] = value);
      });
    }

  return {
    sum: sum,
    dataExtent: dataExtent
  };
}
/**
 * Computes the score for the specified row,
 * as the worst aspect ratio.
 */


function worst(row, rowFixedLength, ratio) {
  var areaMax = 0;
  var areaMin = Infinity;

  for (var i = 0, area, len = row.length; i < len; i++) {
    area = row[i].getLayout().area;

    if (area) {
      area < areaMin && (areaMin = area);
      area > areaMax && (areaMax = area);
    }
  }

  var squareArea = row.area * row.area;
  var f = rowFixedLength * rowFixedLength * ratio;
  return squareArea ? mathMax(f * areaMax / squareArea, squareArea / (f * areaMin)) : Infinity;
}
/**
 * Positions the specified row of nodes. Modifies `rect`.
 */


function position(row, rowFixedLength, rect, halfGapWidth, flush) {
  // When rowFixedLength === rect.width,
  // it is horizontal subdivision,
  // rowFixedLength is the width of the subdivision,
  // rowOtherLength is the height of the subdivision,
  // and nodes will be positioned from left to right.
  // wh[idx0WhenH] means: when horizontal,
  //      wh[idx0WhenH] => wh[0] => 'width'.
  //      xy[idx1WhenH] => xy[1] => 'y'.
  var idx0WhenH = rowFixedLength === rect.width ? 0 : 1;
  var idx1WhenH = 1 - idx0WhenH;
  var xy = ['x', 'y'];
  var wh = ['width', 'height'];
  var last = rect[xy[idx0WhenH]];
  var rowOtherLength = rowFixedLength ? row.area / rowFixedLength : 0;

  if (flush || rowOtherLength > rect[wh[idx1WhenH]]) {
    rowOtherLength = rect[wh[idx1WhenH]]; // over+underflow
  }

  for (var i = 0, rowLen = row.length; i < rowLen; i++) {
    var node = row[i];
    var nodeLayout = {};
    var step = rowOtherLength ? node.getLayout().area / rowOtherLength : 0;
    var wh1 = nodeLayout[wh[idx1WhenH]] = mathMax(rowOtherLength - 2 * halfGapWidth, 0); // We use Math.max/min to avoid negative width/height when considering gap width.

    var remain = rect[xy[idx0WhenH]] + rect[wh[idx0WhenH]] - last;
    var modWH = i === rowLen - 1 || remain < step ? remain : step;
    var wh0 = nodeLayout[wh[idx0WhenH]] = mathMax(modWH - 2 * halfGapWidth, 0);
    nodeLayout[xy[idx1WhenH]] = rect[xy[idx1WhenH]] + mathMin(halfGapWidth, wh1 / 2);
    nodeLayout[xy[idx0WhenH]] = last + mathMin(halfGapWidth, wh0 / 2);
    last += modWH;
    node.setLayout(nodeLayout, true);
  }

  rect[xy[idx1WhenH]] += rowOtherLength;
  rect[wh[idx1WhenH]] -= rowOtherLength;
} // Return [containerWidth, containerHeight] as default.


function estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) {
  // If targetInfo.node exists, we zoom to the node,
  // so estimate whold width and heigth by target node.
  var currNode = (targetInfo || {}).node;
  var defaultSize = [containerWidth, containerHeight];

  if (!currNode || currNode === viewRoot) {
    return defaultSize;
  }

  var parent;
  var viewArea = containerWidth * containerHeight;
  var area = viewArea * seriesModel.option.zoomToNodeRatio;

  while (parent = currNode.parentNode) {
    // jshint ignore:line
    var sum = 0;
    var siblings = parent.children;

    for (var i = 0, len = siblings.length; i < len; i++) {
      sum += siblings[i].getValue();
    }

    var currNodeValue = currNode.getValue();

    if (currNodeValue === 0) {
      return defaultSize;
    }

    area *= sum / currNodeValue; // Considering border, suppose aspect ratio is 1.

    var parentModel = parent.getModel();
    var borderWidth = parentModel.get(PATH_BORDER_WIDTH);
    var upperHeight = Math.max(borderWidth, getUpperLabelHeight(parentModel, borderWidth));
    area += 4 * borderWidth * borderWidth + (3 * borderWidth + upperHeight) * Math.pow(area, 0.5);
    area > MAX_SAFE_INTEGER && (area = MAX_SAFE_INTEGER);
    currNode = parent;
  }

  area < viewArea && (area = viewArea);
  var scale = Math.pow(area / viewArea, 0.5);
  return [containerWidth * scale, containerHeight * scale];
} // Root postion base on coord of containerGroup


function calculateRootPosition(layoutInfo, rootRect, targetInfo) {
  if (rootRect) {
    return {
      x: rootRect.x,
      y: rootRect.y
    };
  }

  var defaultPosition = {
    x: 0,
    y: 0
  };

  if (!targetInfo) {
    return defaultPosition;
  } // If targetInfo is fetched by 'retrieveTargetInfo',
  // old tree and new tree are the same tree,
  // so the node still exists and we can visit it.


  var targetNode = targetInfo.node;
  var layout = targetNode.getLayout();

  if (!layout) {
    return defaultPosition;
  } // Transform coord from local to container.


  var targetCenter = [layout.width / 2, layout.height / 2];
  var node = targetNode;

  while (node) {
    var nodeLayout = node.getLayout();
    targetCenter[0] += nodeLayout.x;
    targetCenter[1] += nodeLayout.y;
    node = node.parentNode;
  }

  return {
    x: layoutInfo.width / 2 - targetCenter[0],
    y: layoutInfo.height / 2 - targetCenter[1]
  };
} // Mark nodes visible for prunning when visual coding and rendering.
// Prunning depends on layout and root position, so we have to do it after layout.


function prunning(node, clipRect, viewAbovePath, viewRoot, depth) {
  var nodeLayout = node.getLayout();
  var nodeInViewAbovePath = viewAbovePath[depth];
  var isAboveViewRoot = nodeInViewAbovePath && nodeInViewAbovePath === node;

  if (nodeInViewAbovePath && !isAboveViewRoot || depth === viewAbovePath.length && node !== viewRoot) {
    return;
  }

  node.setLayout({
    // isInView means: viewRoot sub tree + viewAbovePath
    isInView: true,
    // invisible only means: outside view clip so that the node can not
    // see but still layout for animation preparation but not render.
    invisible: !isAboveViewRoot && !clipRect.intersect(nodeLayout),
    isAboveViewRoot: isAboveViewRoot
  }, true); // Transform to child coordinate.

  var childClipRect = new BoundingRect(clipRect.x - nodeLayout.x, clipRect.y - nodeLayout.y, clipRect.width, clipRect.height);
  each(node.viewChildren || [], function (child) {
    prunning(child, childClipRect, viewAbovePath, viewRoot, depth + 1);
  });
}

function getUpperLabelHeight(model) {
  return model.get(PATH_UPPER_LABEL_SHOW) ? model.get(PATH_UPPER_LABEL_HEIGHT) : 0;
}

module.exports = _default;

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(1636);

__webpack_require__(1638);

__webpack_require__(1641);

var categoryFilter = __webpack_require__(1642);

var visualSymbol = __webpack_require__(178);

var categoryVisual = __webpack_require__(1643);

var edgeVisual = __webpack_require__(1644);

var simpleLayout = __webpack_require__(1645);

var circularLayout = __webpack_require__(1646);

var forceLayout = __webpack_require__(1647);

var createView = __webpack_require__(1649);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.registerProcessor(categoryFilter);
echarts.registerVisual(visualSymbol('graph', 'circle', null));
echarts.registerVisual(categoryVisual);
echarts.registerVisual(edgeVisual);
echarts.registerLayout(simpleLayout);
echarts.registerLayout(echarts.PRIORITY.VISUAL.POST_CHART_LAYOUT, circularLayout);
echarts.registerLayout(forceLayout); // Graph view coordinate system

echarts.registerCoordinateSystem('graphView', {
  create: createView
});

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var List = __webpack_require__(98);

var zrUtil = __webpack_require__(1);

var _model = __webpack_require__(44);

var defaultEmphasis = _model.defaultEmphasis;

var Model = __webpack_require__(68);

var _format = __webpack_require__(54);

var encodeHTML = _format.encodeHTML;

var createGraphFromNodeEdge = __webpack_require__(662);

var LegendVisualProvider = __webpack_require__(243);

var _multipleGraphEdgeHelper = __webpack_require__(307);

var initCurvenessList = _multipleGraphEdgeHelper.initCurvenessList;
var createEdgeMapForCurveness = _multipleGraphEdgeHelper.createEdgeMapForCurveness;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var GraphSeries = echarts.extendSeriesModel({
  type: 'series.graph',
  init: function (option) {
    GraphSeries.superApply(this, 'init', arguments);
    var self = this;

    function getCategoriesData() {
      return self._categoriesData;
    } // Provide data for legend select


    this.legendVisualProvider = new LegendVisualProvider(getCategoriesData, getCategoriesData);
    this.fillDataTextStyle(option.edges || option.links);

    this._updateCategoriesData();
  },
  mergeOption: function (option) {
    GraphSeries.superApply(this, 'mergeOption', arguments);
    this.fillDataTextStyle(option.edges || option.links);

    this._updateCategoriesData();
  },
  mergeDefaultAndTheme: function (option) {
    GraphSeries.superApply(this, 'mergeDefaultAndTheme', arguments);
    defaultEmphasis(option, ['edgeLabel'], ['show']);
  },
  getInitialData: function (option, ecModel) {
    var edges = option.edges || option.links || [];
    var nodes = option.data || option.nodes || [];
    var self = this;

    if (nodes && edges) {
      // auto curveness
      initCurvenessList(this);
      var graph = createGraphFromNodeEdge(nodes, edges, this, true, beforeLink);
      zrUtil.each(graph.edges, function (edge) {
        createEdgeMapForCurveness(edge.node1, edge.node2, this, edge.dataIndex);
      }, this);
      return graph.data;
    }

    function beforeLink(nodeData, edgeData) {
      // Overwrite nodeData.getItemModel to
      nodeData.wrapMethod('getItemModel', function (model) {
        var categoriesModels = self._categoriesModels;
        var categoryIdx = model.getShallow('category');
        var categoryModel = categoriesModels[categoryIdx];

        if (categoryModel) {
          categoryModel.parentModel = model.parentModel;
          model.parentModel = categoryModel;
        }

        return model;
      });
      var edgeLabelModel = self.getModel('edgeLabel'); // For option `edgeLabel` can be found by label.xxx.xxx on item mode.

      var fakeSeriesModel = new Model({
        label: edgeLabelModel.option
      }, edgeLabelModel.parentModel, ecModel);
      var emphasisEdgeLabelModel = self.getModel('emphasis.edgeLabel');
      var emphasisFakeSeriesModel = new Model({
        emphasis: {
          label: emphasisEdgeLabelModel.option
        }
      }, emphasisEdgeLabelModel.parentModel, ecModel);
      edgeData.wrapMethod('getItemModel', function (model) {
        model.customizeGetParent(edgeGetParent);
        return model;
      });

      function edgeGetParent(path) {
        path = this.parsePath(path);
        return path && path[0] === 'label' ? fakeSeriesModel : path && path[0] === 'emphasis' && path[1] === 'label' ? emphasisFakeSeriesModel : this.parentModel;
      }
    }
  },

  /**
   * @return {module:echarts/data/Graph}
   */
  getGraph: function () {
    return this.getData().graph;
  },

  /**
   * @return {module:echarts/data/List}
   */
  getEdgeData: function () {
    return this.getGraph().edgeData;
  },

  /**
   * @return {module:echarts/data/List}
   */
  getCategoriesData: function () {
    return this._categoriesData;
  },

  /**
   * @override
   */
  formatTooltip: function (dataIndex, multipleSeries, dataType) {
    if (dataType === 'edge') {
      var nodeData = this.getData();
      var params = this.getDataParams(dataIndex, dataType);
      var edge = nodeData.graph.getEdgeByIndex(dataIndex);
      var sourceName = nodeData.getName(edge.node1.dataIndex);
      var targetName = nodeData.getName(edge.node2.dataIndex);
      var html = [];
      sourceName != null && html.push(sourceName);
      targetName != null && html.push(targetName);
      html = encodeHTML(html.join(' > '));

      if (params.value) {
        html += ' : ' + encodeHTML(params.value);
      }

      return html;
    } else {
      // dataType === 'node' or empty
      return GraphSeries.superApply(this, 'formatTooltip', arguments);
    }
  },
  _updateCategoriesData: function () {
    var categories = zrUtil.map(this.option.categories || [], function (category) {
      // Data must has value
      return category.value != null ? category : zrUtil.extend({
        value: 0
      }, category);
    });
    var categoriesData = new List(['value'], this);
    categoriesData.initData(categories);
    this._categoriesData = categoriesData;
    this._categoriesModels = categoriesData.mapArray(function (idx) {
      return categoriesData.getItemModel(idx, true);
    });
  },
  setZoom: function (zoom) {
    this.option.zoom = zoom;
  },
  setCenter: function (center) {
    this.option.center = center;
  },
  isAnimationEnabled: function () {
    return GraphSeries.superCall(this, 'isAnimationEnabled') // Not enable animation when do force layout
    && !(this.get('layout') === 'force' && this.get('force.layoutAnimation'));
  },
  defaultOption: {
    zlevel: 0,
    z: 2,
    coordinateSystem: 'view',
    // Default option for all coordinate systems
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // polarIndex: 0,
    // geoIndex: 0,
    legendHoverLink: true,
    hoverAnimation: true,
    layout: null,
    focusNodeAdjacency: false,
    // Configuration of circular layout
    circular: {
      rotateLabel: false
    },
    // Configuration of force directed layout
    force: {
      initLayout: null,
      // Node repulsion. Can be an array to represent range.
      repulsion: [0, 50],
      gravity: 0.1,
      // Initial friction
      friction: 0.6,
      // Edge length. Can be an array to represent range.
      edgeLength: 30,
      layoutAnimation: true
    },
    left: 'center',
    top: 'center',
    // right: null,
    // bottom: null,
    // width: '80%',
    // height: '80%',
    symbol: 'circle',
    symbolSize: 10,
    edgeSymbol: ['none', 'none'],
    edgeSymbolSize: 10,
    edgeLabel: {
      position: 'middle',
      distance: 5
    },
    draggable: false,
    roam: false,
    // Default on center of graph
    center: null,
    zoom: 1,
    // Symbol size scale ratio in roam
    nodeScaleRatio: 0.6,
    // cursor: null,
    // categories: [],
    // data: []
    // Or
    // nodes: []
    //
    // links: []
    // Or
    // edges: []
    label: {
      show: false,
      formatter: '{b}'
    },
    itemStyle: {},
    lineStyle: {
      color: '#aaa',
      width: 1,
      opacity: 0.5
    },
    emphasis: {
      label: {
        show: true
      }
    }
  }
});
var _default = GraphSeries;
module.exports = _default;

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(1);

var _clazz = __webpack_require__(135);

var enableClassCheck = _clazz.enableClassCheck;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// id may be function name of Object, add a prefix to avoid this problem.
function generateNodeKey(id) {
  return '_EC_' + id;
}
/**
 * @alias module:echarts/data/Graph
 * @constructor
 * @param {boolean} directed
 */


var Graph = function (directed) {
  /**
   * 是否是有向图
   * @type {boolean}
   * @private
   */
  this._directed = directed || false;
  /**
   * @type {Array.<module:echarts/data/Graph.Node>}
   * @readOnly
   */

  this.nodes = [];
  /**
   * @type {Array.<module:echarts/data/Graph.Edge>}
   * @readOnly
   */

  this.edges = [];
  /**
   * @type {Object.<string, module:echarts/data/Graph.Node>}
   * @private
   */

  this._nodesMap = {};
  /**
   * @type {Object.<string, module:echarts/data/Graph.Edge>}
   * @private
   */

  this._edgesMap = {};
  /**
   * @type {module:echarts/data/List}
   * @readOnly
   */

  this.data;
  /**
   * @type {module:echarts/data/List}
   * @readOnly
   */

  this.edgeData;
};

var graphProto = Graph.prototype;
/**
 * @type {string}
 */

graphProto.type = 'graph';
/**
 * If is directed graph
 * @return {boolean}
 */

graphProto.isDirected = function () {
  return this._directed;
};
/**
 * Add a new node
 * @param {string} id
 * @param {number} [dataIndex]
 */


graphProto.addNode = function (id, dataIndex) {
  id = id == null ? '' + dataIndex : '' + id;
  var nodesMap = this._nodesMap;

  if (nodesMap[generateNodeKey(id)]) {
    return;
  }

  var node = new Node(id, dataIndex);
  node.hostGraph = this;
  this.nodes.push(node);
  nodesMap[generateNodeKey(id)] = node;
  return node;
};
/**
 * Get node by data index
 * @param  {number} dataIndex
 * @return {module:echarts/data/Graph~Node}
 */


graphProto.getNodeByIndex = function (dataIndex) {
  var rawIdx = this.data.getRawIndex(dataIndex);
  return this.nodes[rawIdx];
};
/**
 * Get node by id
 * @param  {string} id
 * @return {module:echarts/data/Graph.Node}
 */


graphProto.getNodeById = function (id) {
  return this._nodesMap[generateNodeKey(id)];
};
/**
 * Add a new edge
 * @param {number|string|module:echarts/data/Graph.Node} n1
 * @param {number|string|module:echarts/data/Graph.Node} n2
 * @param {number} [dataIndex=-1]
 * @return {module:echarts/data/Graph.Edge}
 */


graphProto.addEdge = function (n1, n2, dataIndex) {
  var nodesMap = this._nodesMap;
  var edgesMap = this._edgesMap; // PNEDING

  if (typeof n1 === 'number') {
    n1 = this.nodes[n1];
  }

  if (typeof n2 === 'number') {
    n2 = this.nodes[n2];
  }

  if (!Node.isInstance(n1)) {
    n1 = nodesMap[generateNodeKey(n1)];
  }

  if (!Node.isInstance(n2)) {
    n2 = nodesMap[generateNodeKey(n2)];
  }

  if (!n1 || !n2) {
    return;
  }

  var key = n1.id + '-' + n2.id;
  var edge = new Edge(n1, n2, dataIndex);
  edge.hostGraph = this;

  if (this._directed) {
    n1.outEdges.push(edge);
    n2.inEdges.push(edge);
  }

  n1.edges.push(edge);

  if (n1 !== n2) {
    n2.edges.push(edge);
  }

  this.edges.push(edge);
  edgesMap[key] = edge;
  return edge;
};
/**
 * Get edge by data index
 * @param  {number} dataIndex
 * @return {module:echarts/data/Graph~Node}
 */


graphProto.getEdgeByIndex = function (dataIndex) {
  var rawIdx = this.edgeData.getRawIndex(dataIndex);
  return this.edges[rawIdx];
};
/**
 * Get edge by two linked nodes
 * @param  {module:echarts/data/Graph.Node|string} n1
 * @param  {module:echarts/data/Graph.Node|string} n2
 * @return {module:echarts/data/Graph.Edge}
 */


graphProto.getEdge = function (n1, n2) {
  if (Node.isInstance(n1)) {
    n1 = n1.id;
  }

  if (Node.isInstance(n2)) {
    n2 = n2.id;
  }

  var edgesMap = this._edgesMap;

  if (this._directed) {
    return edgesMap[n1 + '-' + n2];
  } else {
    return edgesMap[n1 + '-' + n2] || edgesMap[n2 + '-' + n1];
  }
};
/**
 * Iterate all nodes
 * @param  {Function} cb
 * @param  {*} [context]
 */


graphProto.eachNode = function (cb, context) {
  var nodes = this.nodes;
  var len = nodes.length;

  for (var i = 0; i < len; i++) {
    if (nodes[i].dataIndex >= 0) {
      cb.call(context, nodes[i], i);
    }
  }
};
/**
 * Iterate all edges
 * @param  {Function} cb
 * @param  {*} [context]
 */


graphProto.eachEdge = function (cb, context) {
  var edges = this.edges;
  var len = edges.length;

  for (var i = 0; i < len; i++) {
    if (edges[i].dataIndex >= 0 && edges[i].node1.dataIndex >= 0 && edges[i].node2.dataIndex >= 0) {
      cb.call(context, edges[i], i);
    }
  }
};
/**
 * Breadth first traverse
 * @param {Function} cb
 * @param {module:echarts/data/Graph.Node} startNode
 * @param {string} [direction='none'] 'none'|'in'|'out'
 * @param {*} [context]
 */


graphProto.breadthFirstTraverse = function (cb, startNode, direction, context) {
  if (!Node.isInstance(startNode)) {
    startNode = this._nodesMap[generateNodeKey(startNode)];
  }

  if (!startNode) {
    return;
  }

  var edgeType = direction === 'out' ? 'outEdges' : direction === 'in' ? 'inEdges' : 'edges';

  for (var i = 0; i < this.nodes.length; i++) {
    this.nodes[i].__visited = false;
  }

  if (cb.call(context, startNode, null)) {
    return;
  }

  var queue = [startNode];

  while (queue.length) {
    var currentNode = queue.shift();
    var edges = currentNode[edgeType];

    for (var i = 0; i < edges.length; i++) {
      var e = edges[i];
      var otherNode = e.node1 === currentNode ? e.node2 : e.node1;

      if (!otherNode.__visited) {
        if (cb.call(context, otherNode, currentNode)) {
          // Stop traversing
          return;
        }

        queue.push(otherNode);
        otherNode.__visited = true;
      }
    }
  }
}; // TODO
// graphProto.depthFirstTraverse = function (
//     cb, startNode, direction, context
// ) {
// };
// Filter update


graphProto.update = function () {
  var data = this.data;
  var edgeData = this.edgeData;
  var nodes = this.nodes;
  var edges = this.edges;

  for (var i = 0, len = nodes.length; i < len; i++) {
    nodes[i].dataIndex = -1;
  }

  for (var i = 0, len = data.count(); i < len; i++) {
    nodes[data.getRawIndex(i)].dataIndex = i;
  }

  edgeData.filterSelf(function (idx) {
    var edge = edges[edgeData.getRawIndex(idx)];
    return edge.node1.dataIndex >= 0 && edge.node2.dataIndex >= 0;
  }); // Update edge

  for (var i = 0, len = edges.length; i < len; i++) {
    edges[i].dataIndex = -1;
  }

  for (var i = 0, len = edgeData.count(); i < len; i++) {
    edges[edgeData.getRawIndex(i)].dataIndex = i;
  }
};
/**
 * @return {module:echarts/data/Graph}
 */


graphProto.clone = function () {
  var graph = new Graph(this._directed);
  var nodes = this.nodes;
  var edges = this.edges;

  for (var i = 0; i < nodes.length; i++) {
    graph.addNode(nodes[i].id, nodes[i].dataIndex);
  }

  for (var i = 0; i < edges.length; i++) {
    var e = edges[i];
    graph.addEdge(e.node1.id, e.node2.id, e.dataIndex);
  }

  return graph;
};
/**
 * @alias module:echarts/data/Graph.Node
 */


function Node(id, dataIndex) {
  /**
  * @type {string}
  */
  this.id = id == null ? '' : id;
  /**
  * @type {Array.<module:echarts/data/Graph.Edge>}
  */

  this.inEdges = [];
  /**
  * @type {Array.<module:echarts/data/Graph.Edge>}
  */

  this.outEdges = [];
  /**
  * @type {Array.<module:echarts/data/Graph.Edge>}
  */

  this.edges = [];
  /**
   * @type {module:echarts/data/Graph}
   */

  this.hostGraph;
  /**
   * @type {number}
   */

  this.dataIndex = dataIndex == null ? -1 : dataIndex;
}

Node.prototype = {
  constructor: Node,

  /**
   * @return {number}
   */
  degree: function () {
    return this.edges.length;
  },

  /**
   * @return {number}
   */
  inDegree: function () {
    return this.inEdges.length;
  },

  /**
  * @return {number}
  */
  outDegree: function () {
    return this.outEdges.length;
  },

  /**
   * @param {string} [path]
   * @return {module:echarts/model/Model}
   */
  getModel: function (path) {
    if (this.dataIndex < 0) {
      return;
    }

    var graph = this.hostGraph;
    var itemModel = graph.data.getItemModel(this.dataIndex);
    return itemModel.getModel(path);
  }
};
/**
 * 图边
 * @alias module:echarts/data/Graph.Edge
 * @param {module:echarts/data/Graph.Node} n1
 * @param {module:echarts/data/Graph.Node} n2
 * @param {number} [dataIndex=-1]
 */

function Edge(n1, n2, dataIndex) {
  /**
   * 节点1，如果是有向图则为源节点
   * @type {module:echarts/data/Graph.Node}
   */
  this.node1 = n1;
  /**
   * 节点2，如果是有向图则为目标节点
   * @type {module:echarts/data/Graph.Node}
   */

  this.node2 = n2;
  this.dataIndex = dataIndex == null ? -1 : dataIndex;
}
/**
 * @param {string} [path]
 * @return {module:echarts/model/Model}
 */


Edge.prototype.getModel = function (path) {
  if (this.dataIndex < 0) {
    return;
  }

  var graph = this.hostGraph;
  var itemModel = graph.edgeData.getItemModel(this.dataIndex);
  return itemModel.getModel(path);
};

var createGraphDataProxyMixin = function (hostName, dataName) {
  return {
    /**
     * @param {string=} [dimension='value'] Default 'value'. can be 'a', 'b', 'c', 'd', 'e'.
     * @return {number}
     */
    getValue: function (dimension) {
      var data = this[hostName][dataName];
      return data.get(data.getDimension(dimension || 'value'), this.dataIndex);
    },

    /**
     * @param {Object|string} key
     * @param {*} [value]
     */
    setVisual: function (key, value) {
      this.dataIndex >= 0 && this[hostName][dataName].setItemVisual(this.dataIndex, key, value);
    },

    /**
     * @param {string} key
     * @return {boolean}
     */
    getVisual: function (key, ignoreParent) {
      return this[hostName][dataName].getItemVisual(this.dataIndex, key, ignoreParent);
    },

    /**
     * @param {Object} layout
     * @return {boolean} [merge=false]
     */
    setLayout: function (layout, merge) {
      this.dataIndex >= 0 && this[hostName][dataName].setItemLayout(this.dataIndex, layout, merge);
    },

    /**
     * @return {Object}
     */
    getLayout: function () {
      return this[hostName][dataName].getItemLayout(this.dataIndex);
    },

    /**
     * @return {module:zrender/Element}
     */
    getGraphicEl: function () {
      return this[hostName][dataName].getItemGraphicEl(this.dataIndex);
    },

    /**
     * @return {number}
     */
    getRawIndex: function () {
      return this[hostName][dataName].getRawIndex(this.dataIndex);
    }
  };
};

zrUtil.mixin(Node, createGraphDataProxyMixin('hostGraph', 'data'));
zrUtil.mixin(Edge, createGraphDataProxyMixin('hostGraph', 'edgeData'));
Graph.Node = Node;
Graph.Edge = Edge;
enableClassCheck(Node);
enableClassCheck(Edge);
var _default = Graph;
module.exports = _default;

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var SymbolDraw = __webpack_require__(239);

var LineDraw = __webpack_require__(422);

var RoamController = __webpack_require__(245);

var roamHelper = __webpack_require__(417);

var _cursorHelper = __webpack_require__(306);

var onIrrelevantElement = _cursorHelper.onIrrelevantElement;

var graphic = __webpack_require__(27);

var adjustEdge = __webpack_require__(1640);

var _graphHelper = __webpack_require__(424);

var getNodeGlobalScale = _graphHelper.getNodeGlobalScale;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var FOCUS_ADJACENCY = '__focusNodeAdjacency';
var UNFOCUS_ADJACENCY = '__unfocusNodeAdjacency';
var nodeOpacityPath = ['itemStyle', 'opacity'];
var lineOpacityPath = ['lineStyle', 'opacity'];

function getItemOpacity(item, opacityPath) {
  var opacity = item.getVisual('opacity');
  return opacity != null ? opacity : item.getModel().get(opacityPath);
}

function fadeOutItem(item, opacityPath, opacityRatio) {
  var el = item.getGraphicEl();
  var opacity = getItemOpacity(item, opacityPath);

  if (opacityRatio != null) {
    opacity == null && (opacity = 1);
    opacity *= opacityRatio;
  }

  el.downplay && el.downplay();
  el.traverse(function (child) {
    if (!child.isGroup) {
      var opct = child.lineLabelOriginalOpacity;

      if (opct == null || opacityRatio != null) {
        opct = opacity;
      }

      child.setStyle('opacity', opct);
    }
  });
}

function fadeInItem(item, opacityPath) {
  var opacity = getItemOpacity(item, opacityPath);
  var el = item.getGraphicEl(); // Should go back to normal opacity first, consider hoverLayer,
  // where current state is copied to elMirror, and support
  // emphasis opacity here.

  el.traverse(function (child) {
    !child.isGroup && child.setStyle('opacity', opacity);
  });
  el.highlight && el.highlight();
}

var _default = echarts.extendChartView({
  type: 'graph',
  init: function (ecModel, api) {
    var symbolDraw = new SymbolDraw();
    var lineDraw = new LineDraw();
    var group = this.group;
    this._controller = new RoamController(api.getZr());
    this._controllerHost = {
      target: group
    };
    group.add(symbolDraw.group);
    group.add(lineDraw.group);
    this._symbolDraw = symbolDraw;
    this._lineDraw = lineDraw;
    this._firstRender = true;
  },
  render: function (seriesModel, ecModel, api) {
    var graphView = this;
    var coordSys = seriesModel.coordinateSystem;
    this._model = seriesModel;
    var symbolDraw = this._symbolDraw;
    var lineDraw = this._lineDraw;
    var group = this.group;

    if (coordSys.type === 'view') {
      var groupNewProp = {
        position: coordSys.position,
        scale: coordSys.scale
      };

      if (this._firstRender) {
        group.attr(groupNewProp);
      } else {
        graphic.updateProps(group, groupNewProp, seriesModel);
      }
    } // Fix edge contact point with node


    adjustEdge(seriesModel.getGraph(), getNodeGlobalScale(seriesModel));
    var data = seriesModel.getData();
    symbolDraw.updateData(data);
    var edgeData = seriesModel.getEdgeData();
    lineDraw.updateData(edgeData);

    this._updateNodeAndLinkScale();

    this._updateController(seriesModel, ecModel, api);

    clearTimeout(this._layoutTimeout);
    var forceLayout = seriesModel.forceLayout;
    var layoutAnimation = seriesModel.get('force.layoutAnimation');

    if (forceLayout) {
      this._startForceLayoutIteration(forceLayout, layoutAnimation);
    }

    data.eachItemGraphicEl(function (el, idx) {
      var itemModel = data.getItemModel(idx); // Update draggable

      el.off('drag').off('dragend');
      var draggable = itemModel.get('draggable');

      if (draggable) {
        el.on('drag', function () {
          if (forceLayout) {
            forceLayout.warmUp();
            !this._layouting && this._startForceLayoutIteration(forceLayout, layoutAnimation);
            forceLayout.setFixed(idx); // Write position back to layout

            data.setItemLayout(idx, el.position);
          }
        }, this).on('dragend', function () {
          if (forceLayout) {
            forceLayout.setUnfixed(idx);
          }
        }, this);
      }

      el.setDraggable(draggable && forceLayout);
      el[FOCUS_ADJACENCY] && el.off('mouseover', el[FOCUS_ADJACENCY]);
      el[UNFOCUS_ADJACENCY] && el.off('mouseout', el[UNFOCUS_ADJACENCY]);

      if (itemModel.get('focusNodeAdjacency')) {
        el.on('mouseover', el[FOCUS_ADJACENCY] = function () {
          graphView._clearTimer();

          api.dispatchAction({
            type: 'focusNodeAdjacency',
            seriesId: seriesModel.id,
            dataIndex: el.dataIndex
          });
        });
        el.on('mouseout', el[UNFOCUS_ADJACENCY] = function () {
          graphView._dispatchUnfocus(api);
        });
      }
    }, this);
    data.graph.eachEdge(function (edge) {
      var el = edge.getGraphicEl();
      el[FOCUS_ADJACENCY] && el.off('mouseover', el[FOCUS_ADJACENCY]);
      el[UNFOCUS_ADJACENCY] && el.off('mouseout', el[UNFOCUS_ADJACENCY]);

      if (edge.getModel().get('focusNodeAdjacency')) {
        el.on('mouseover', el[FOCUS_ADJACENCY] = function () {
          graphView._clearTimer();

          api.dispatchAction({
            type: 'focusNodeAdjacency',
            seriesId: seriesModel.id,
            edgeDataIndex: edge.dataIndex
          });
        });
        el.on('mouseout', el[UNFOCUS_ADJACENCY] = function () {
          graphView._dispatchUnfocus(api);
        });
      }
    });
    var circularRotateLabel = seriesModel.get('layout') === 'circular' && seriesModel.get('circular.rotateLabel');
    var cx = data.getLayout('cx');
    var cy = data.getLayout('cy');
    data.eachItemGraphicEl(function (el, idx) {
      var itemModel = data.getItemModel(idx);
      var labelRotate = itemModel.get('label.rotate') || 0;
      var symbolPath = el.getSymbolPath();

      if (circularRotateLabel) {
        var pos = data.getItemLayout(idx);
        var rad = Math.atan2(pos[1] - cy, pos[0] - cx);

        if (rad < 0) {
          rad = Math.PI * 2 + rad;
        }

        var isLeft = pos[0] < cx;

        if (isLeft) {
          rad = rad - Math.PI;
        }

        var textPosition = isLeft ? 'left' : 'right';
        graphic.modifyLabelStyle(symbolPath, {
          textRotation: -rad,
          textPosition: textPosition,
          textOrigin: 'center'
        }, {
          textPosition: textPosition
        });
      } else {
        graphic.modifyLabelStyle(symbolPath, {
          textRotation: labelRotate *= Math.PI / 180
        });
      }
    });
    this._firstRender = false;
  },
  dispose: function () {
    this._controller && this._controller.dispose();
    this._controllerHost = {};

    this._clearTimer();
  },
  _dispatchUnfocus: function (api, opt) {
    var self = this;

    this._clearTimer();

    this._unfocusDelayTimer = setTimeout(function () {
      self._unfocusDelayTimer = null;
      api.dispatchAction({
        type: 'unfocusNodeAdjacency',
        seriesId: self._model.id
      });
    }, 500);
  },
  _clearTimer: function () {
    if (this._unfocusDelayTimer) {
      clearTimeout(this._unfocusDelayTimer);
      this._unfocusDelayTimer = null;
    }
  },
  focusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData();
    var graph = data.graph;
    var dataIndex = payload.dataIndex;
    var edgeDataIndex = payload.edgeDataIndex;
    var node = graph.getNodeByIndex(dataIndex);
    var edge = graph.getEdgeByIndex(edgeDataIndex);

    if (!node && !edge) {
      return;
    }

    graph.eachNode(function (node) {
      fadeOutItem(node, nodeOpacityPath, 0.1);
    });
    graph.eachEdge(function (edge) {
      fadeOutItem(edge, lineOpacityPath, 0.1);
    });

    if (node) {
      fadeInItem(node, nodeOpacityPath);
      zrUtil.each(node.edges, function (adjacentEdge) {
        if (adjacentEdge.dataIndex < 0) {
          return;
        }

        fadeInItem(adjacentEdge, lineOpacityPath);
        fadeInItem(adjacentEdge.node1, nodeOpacityPath);
        fadeInItem(adjacentEdge.node2, nodeOpacityPath);
      });
    }

    if (edge) {
      fadeInItem(edge, lineOpacityPath);
      fadeInItem(edge.node1, nodeOpacityPath);
      fadeInItem(edge.node2, nodeOpacityPath);
    }
  },
  unfocusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
    var graph = seriesModel.getData().graph;
    graph.eachNode(function (node) {
      fadeOutItem(node, nodeOpacityPath);
    });
    graph.eachEdge(function (edge) {
      fadeOutItem(edge, lineOpacityPath);
    });
  },
  _startForceLayoutIteration: function (forceLayout, layoutAnimation) {
    var self = this;

    (function step() {
      forceLayout.step(function (stopped) {
        self.updateLayout(self._model);
        (self._layouting = !stopped) && (layoutAnimation ? self._layoutTimeout = setTimeout(step, 16) : step());
      });
    })();
  },
  _updateController: function (seriesModel, ecModel, api) {
    var controller = this._controller;
    var controllerHost = this._controllerHost;
    var group = this.group;
    controller.setPointerChecker(function (e, x, y) {
      var rect = group.getBoundingRect();
      rect.applyTransform(group.transform);
      return rect.contain(x, y) && !onIrrelevantElement(e, api, seriesModel);
    });

    if (seriesModel.coordinateSystem.type !== 'view') {
      controller.disable();
      return;
    }

    controller.enable(seriesModel.get('roam'));
    controllerHost.zoomLimit = seriesModel.get('scaleLimit');
    controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
    controller.off('pan').off('zoom').on('pan', function (e) {
      roamHelper.updateViewOnPan(controllerHost, e.dx, e.dy);
      api.dispatchAction({
        seriesId: seriesModel.id,
        type: 'graphRoam',
        dx: e.dx,
        dy: e.dy
      });
    }).on('zoom', function (e) {
      roamHelper.updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
      api.dispatchAction({
        seriesId: seriesModel.id,
        type: 'graphRoam',
        zoom: e.scale,
        originX: e.originX,
        originY: e.originY
      });

      this._updateNodeAndLinkScale();

      adjustEdge(seriesModel.getGraph(), getNodeGlobalScale(seriesModel));

      this._lineDraw.updateLayout();
    }, this);
  },
  _updateNodeAndLinkScale: function () {
    var seriesModel = this._model;
    var data = seriesModel.getData();
    var nodeScale = getNodeGlobalScale(seriesModel);
    var invScale = [nodeScale, nodeScale];
    data.eachItemGraphicEl(function (el, idx) {
      el.attr('scale', invScale);
    });
  },
  updateLayout: function (seriesModel) {
    adjustEdge(seriesModel.getGraph(), getNodeGlobalScale(seriesModel));

    this._symbolDraw.updateLayout();

    this._lineDraw.updateLayout();
  },
  remove: function (ecModel, api) {
    this._symbolDraw && this._symbolDraw.remove();
    this._lineDraw && this._lineDraw.remove();
  }
});

module.exports = _default;

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var graphic = __webpack_require__(27);

var vec2 = __webpack_require__(55);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Line path for bezier and straight line draw
 */
var straightLineProto = graphic.Line.prototype;
var bezierCurveProto = graphic.BezierCurve.prototype;

function isLine(shape) {
  return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
}

var _default = graphic.extendShape({
  type: 'ec-line',
  style: {
    stroke: '#000',
    fill: null
  },
  shape: {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0,
    percent: 1,
    cpx1: null,
    cpy1: null
  },
  buildPath: function (ctx, shape) {
    this[isLine(shape) ? '_buildPathLine' : '_buildPathCurve'](ctx, shape);
  },
  _buildPathLine: straightLineProto.buildPath,
  _buildPathCurve: bezierCurveProto.buildPath,
  pointAt: function (t) {
    return this[isLine(this.shape) ? '_pointAtLine' : '_pointAtCurve'](t);
  },
  _pointAtLine: straightLineProto.pointAt,
  _pointAtCurve: bezierCurveProto.pointAt,
  tangentAt: function (t) {
    var shape = this.shape;
    var p = isLine(shape) ? [shape.x2 - shape.x1, shape.y2 - shape.y1] : this._tangentAtCurve(t);
    return vec2.normalize(p, p);
  },
  _tangentAtCurve: bezierCurveProto.tangentAt
});

module.exports = _default;

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var curveTool = __webpack_require__(147);

var vec2 = __webpack_require__(55);

var _graphHelper = __webpack_require__(424);

var getSymbolSize = _graphHelper.getSymbolSize;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var v1 = [];
var v2 = [];
var v3 = [];
var quadraticAt = curveTool.quadraticAt;
var v2DistSquare = vec2.distSquare;
var mathAbs = Math.abs;

function intersectCurveCircle(curvePoints, center, radius) {
  var p0 = curvePoints[0];
  var p1 = curvePoints[1];
  var p2 = curvePoints[2];
  var d = Infinity;
  var t;
  var radiusSquare = radius * radius;
  var interval = 0.1;

  for (var _t = 0.1; _t <= 0.9; _t += 0.1) {
    v1[0] = quadraticAt(p0[0], p1[0], p2[0], _t);
    v1[1] = quadraticAt(p0[1], p1[1], p2[1], _t);
    var diff = mathAbs(v2DistSquare(v1, center) - radiusSquare);

    if (diff < d) {
      d = diff;
      t = _t;
    }
  } // Assume the segment is monotone，Find root through Bisection method
  // At most 32 iteration


  for (var i = 0; i < 32; i++) {
    // var prev = t - interval;
    var next = t + interval; // v1[0] = quadraticAt(p0[0], p1[0], p2[0], prev);
    // v1[1] = quadraticAt(p0[1], p1[1], p2[1], prev);

    v2[0] = quadraticAt(p0[0], p1[0], p2[0], t);
    v2[1] = quadraticAt(p0[1], p1[1], p2[1], t);
    v3[0] = quadraticAt(p0[0], p1[0], p2[0], next);
    v3[1] = quadraticAt(p0[1], p1[1], p2[1], next);
    var diff = v2DistSquare(v2, center) - radiusSquare;

    if (mathAbs(diff) < 1e-2) {
      break;
    } // var prevDiff = v2DistSquare(v1, center) - radiusSquare;


    var nextDiff = v2DistSquare(v3, center) - radiusSquare;
    interval /= 2;

    if (diff < 0) {
      if (nextDiff >= 0) {
        t = t + interval;
      } else {
        t = t - interval;
      }
    } else {
      if (nextDiff >= 0) {
        t = t - interval;
      } else {
        t = t + interval;
      }
    }
  }

  return t;
} // Adjust edge to avoid


function _default(graph, scale) {
  var tmp0 = [];
  var quadraticSubdivide = curveTool.quadraticSubdivide;
  var pts = [[], [], []];
  var pts2 = [[], []];
  var v = [];
  scale /= 2;
  graph.eachEdge(function (edge, idx) {
    var linePoints = edge.getLayout();
    var fromSymbol = edge.getVisual('fromSymbol');
    var toSymbol = edge.getVisual('toSymbol');

    if (!linePoints.__original) {
      linePoints.__original = [vec2.clone(linePoints[0]), vec2.clone(linePoints[1])];

      if (linePoints[2]) {
        linePoints.__original.push(vec2.clone(linePoints[2]));
      }
    }

    var originalPoints = linePoints.__original; // Quadratic curve

    if (linePoints[2] != null) {
      vec2.copy(pts[0], originalPoints[0]);
      vec2.copy(pts[1], originalPoints[2]);
      vec2.copy(pts[2], originalPoints[1]);

      if (fromSymbol && fromSymbol !== 'none') {
        var symbolSize = getSymbolSize(edge.node1);
        var t = intersectCurveCircle(pts, originalPoints[0], symbolSize * scale); // Subdivide and get the second

        quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
        pts[0][0] = tmp0[3];
        pts[1][0] = tmp0[4];
        quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
        pts[0][1] = tmp0[3];
        pts[1][1] = tmp0[4];
      }

      if (toSymbol && toSymbol !== 'none') {
        var symbolSize = getSymbolSize(edge.node2);
        var t = intersectCurveCircle(pts, originalPoints[1], symbolSize * scale); // Subdivide and get the first

        quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
        pts[1][0] = tmp0[1];
        pts[2][0] = tmp0[2];
        quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
        pts[1][1] = tmp0[1];
        pts[2][1] = tmp0[2];
      } // Copy back to layout


      vec2.copy(linePoints[0], pts[0]);
      vec2.copy(linePoints[1], pts[2]);
      vec2.copy(linePoints[2], pts[1]);
    } // Line
    else {
        vec2.copy(pts2[0], originalPoints[0]);
        vec2.copy(pts2[1], originalPoints[1]);
        vec2.sub(v, pts2[1], pts2[0]);
        vec2.normalize(v, v);

        if (fromSymbol && fromSymbol !== 'none') {
          var symbolSize = getSymbolSize(edge.node1);
          vec2.scaleAndAdd(pts2[0], pts2[0], v, symbolSize * scale);
        }

        if (toSymbol && toSymbol !== 'none') {
          var symbolSize = getSymbolSize(edge.node2);
          vec2.scaleAndAdd(pts2[1], pts2[1], v, -symbolSize * scale);
        }

        vec2.copy(linePoints[0], pts2[0]);
        vec2.copy(linePoints[1], pts2[1]);
      }
  });
}

module.exports = _default;

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var _roamHelper = __webpack_require__(418);

var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;

__webpack_require__(663);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var actionInfo = {
  type: 'graphRoam',
  event: 'graphRoam',
  update: 'none'
};
/**
 * @payload
 * @property {string} name Series name
 * @property {number} [dx]
 * @property {number} [dy]
 * @property {number} [zoom]
 * @property {number} [originX]
 * @property {number} [originY]
 */

echarts.registerAction(actionInfo, function (payload, ecModel) {
  ecModel.eachComponent({
    mainType: 'series',
    query: payload
  }, function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    var res = updateCenterAndZoom(coordSys, payload);
    seriesModel.setCenter && seriesModel.setCenter(res.center);
    seriesModel.setZoom && seriesModel.setZoom(res.zoom);
  });
});

/***/ }),
/* 1642 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(ecModel) {
  var legendModels = ecModel.findComponents({
    mainType: 'legend'
  });

  if (!legendModels || !legendModels.length) {
    return;
  }

  ecModel.eachSeriesByType('graph', function (graphSeries) {
    var categoriesData = graphSeries.getCategoriesData();
    var graph = graphSeries.getGraph();
    var data = graph.data;
    var categoryNames = categoriesData.mapArray(categoriesData.getName);
    data.filterSelf(function (idx) {
      var model = data.getItemModel(idx);
      var category = model.getShallow('category');

      if (category != null) {
        if (typeof category === 'number') {
          category = categoryNames[category];
        } // If in any legend component the status is not selected.


        for (var i = 0; i < legendModels.length; i++) {
          if (!legendModels[i].isSelected(category)) {
            return false;
          }
        }
      }

      return true;
    });
  }, this);
}

module.exports = _default;

/***/ }),
/* 1643 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(ecModel) {
  var paletteScope = {};
  ecModel.eachSeriesByType('graph', function (seriesModel) {
    var categoriesData = seriesModel.getCategoriesData();
    var data = seriesModel.getData();
    var categoryNameIdxMap = {};
    categoriesData.each(function (idx) {
      var name = categoriesData.getName(idx); // Add prefix to avoid conflict with Object.prototype.

      categoryNameIdxMap['ec-' + name] = idx;
      var itemModel = categoriesData.getItemModel(idx);
      var color = itemModel.get('itemStyle.color') || seriesModel.getColorFromPalette(name, paletteScope);
      categoriesData.setItemVisual(idx, 'color', color);
      var itemStyleList = ['opacity', 'symbol', 'symbolSize', 'symbolKeepAspect'];

      for (var i = 0; i < itemStyleList.length; i++) {
        var itemStyle = itemModel.getShallow(itemStyleList[i], true);

        if (itemStyle != null) {
          categoriesData.setItemVisual(idx, itemStyleList[i], itemStyle);
        }
      }
    }); // Assign category color to visual

    if (categoriesData.count()) {
      data.each(function (idx) {
        var model = data.getItemModel(idx);
        var category = model.getShallow('category');

        if (category != null) {
          if (typeof category === 'string') {
            category = categoryNameIdxMap['ec-' + category];
          }

          var itemStyleList = ['color', 'opacity', 'symbol', 'symbolSize', 'symbolKeepAspect'];

          for (var i = 0; i < itemStyleList.length; i++) {
            if (data.getItemVisual(idx, itemStyleList[i], true) == null) {
              data.setItemVisual(idx, itemStyleList[i], categoriesData.getItemVisual(category, itemStyleList[i]));
            }
          }
        }
      });
    }
  });
}

module.exports = _default;

/***/ }),
/* 1644 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function normalize(a) {
  if (!(a instanceof Array)) {
    a = [a, a];
  }

  return a;
}

function _default(ecModel) {
  ecModel.eachSeriesByType('graph', function (seriesModel) {
    var graph = seriesModel.getGraph();
    var edgeData = seriesModel.getEdgeData();
    var symbolType = normalize(seriesModel.get('edgeSymbol'));
    var symbolSize = normalize(seriesModel.get('edgeSymbolSize'));
    var colorQuery = 'lineStyle.color'.split('.');
    var opacityQuery = 'lineStyle.opacity'.split('.');
    edgeData.setVisual('fromSymbol', symbolType && symbolType[0]);
    edgeData.setVisual('toSymbol', symbolType && symbolType[1]);
    edgeData.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
    edgeData.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
    edgeData.setVisual('color', seriesModel.get(colorQuery));
    edgeData.setVisual('opacity', seriesModel.get(opacityQuery));
    edgeData.each(function (idx) {
      var itemModel = edgeData.getItemModel(idx);
      var edge = graph.getEdgeByIndex(idx);
      var symbolType = normalize(itemModel.getShallow('symbol', true));
      var symbolSize = normalize(itemModel.getShallow('symbolSize', true)); // Edge visual must after node visual

      var color = itemModel.get(colorQuery);
      var opacity = itemModel.get(opacityQuery);

      switch (color) {
        case 'source':
          color = edge.node1.getVisual('color');
          break;

        case 'target':
          color = edge.node2.getVisual('color');
          break;
      }

      symbolType[0] && edge.setVisual('fromSymbol', symbolType[0]);
      symbolType[1] && edge.setVisual('toSymbol', symbolType[1]);
      symbolSize[0] && edge.setVisual('fromSymbolSize', symbolSize[0]);
      symbolSize[1] && edge.setVisual('toSymbolSize', symbolSize[1]);
      edge.setVisual('color', color);
      edge.setVisual('opacity', opacity);
    });
  });
}

module.exports = _default;

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(1);

var each = _util.each;

var _simpleLayoutHelper = __webpack_require__(664);

var simpleLayout = _simpleLayoutHelper.simpleLayout;
var simpleLayoutEdge = _simpleLayoutHelper.simpleLayoutEdge;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(ecModel, api) {
  ecModel.eachSeriesByType('graph', function (seriesModel) {
    var layout = seriesModel.get('layout');
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys && coordSys.type !== 'view') {
      var data = seriesModel.getData();
      var dimensions = [];
      each(coordSys.dimensions, function (coordDim) {
        dimensions = dimensions.concat(data.mapDimension(coordDim, true));
      });

      for (var dataIndex = 0; dataIndex < data.count(); dataIndex++) {
        var value = [];
        var hasValue = false;

        for (var i = 0; i < dimensions.length; i++) {
          var val = data.get(dimensions[i], dataIndex);

          if (!isNaN(val)) {
            hasValue = true;
          }

          value.push(val);
        }

        if (hasValue) {
          data.setItemLayout(dataIndex, coordSys.dataToPoint(value));
        } else {
          // Also {Array.<number>}, not undefined to avoid if...else... statement
          data.setItemLayout(dataIndex, [NaN, NaN]);
        }
      }

      simpleLayoutEdge(data.graph, seriesModel);
    } else if (!layout || layout === 'none') {
      simpleLayout(seriesModel);
    }
  });
}

module.exports = _default;

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _circularLayoutHelper = __webpack_require__(665);

var circularLayout = _circularLayoutHelper.circularLayout;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(ecModel) {
  ecModel.eachSeriesByType('graph', function (seriesModel) {
    if (seriesModel.get('layout') === 'circular') {
      circularLayout(seriesModel, 'symbolSize');
    }
  });
}

module.exports = _default;

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _forceHelper = __webpack_require__(1648);

var forceLayout = _forceHelper.forceLayout;

var _simpleLayoutHelper = __webpack_require__(664);

var simpleLayout = _simpleLayoutHelper.simpleLayout;

var _circularLayoutHelper = __webpack_require__(665);

var circularLayout = _circularLayoutHelper.circularLayout;

var _number = __webpack_require__(37);

var linearMap = _number.linearMap;

var vec2 = __webpack_require__(55);

var zrUtil = __webpack_require__(1);

var _multipleGraphEdgeHelper = __webpack_require__(307);

var getCurvenessForEdge = _multipleGraphEdgeHelper.getCurvenessForEdge;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(ecModel) {
  ecModel.eachSeriesByType('graph', function (graphSeries) {
    var coordSys = graphSeries.coordinateSystem;

    if (coordSys && coordSys.type !== 'view') {
      return;
    }

    if (graphSeries.get('layout') === 'force') {
      var preservedPoints = graphSeries.preservedPoints || {};
      var graph = graphSeries.getGraph();
      var nodeData = graph.data;
      var edgeData = graph.edgeData;
      var forceModel = graphSeries.getModel('force');
      var initLayout = forceModel.get('initLayout');

      if (graphSeries.preservedPoints) {
        nodeData.each(function (idx) {
          var id = nodeData.getId(idx);
          nodeData.setItemLayout(idx, preservedPoints[id] || [NaN, NaN]);
        });
      } else if (!initLayout || initLayout === 'none') {
        simpleLayout(graphSeries);
      } else if (initLayout === 'circular') {
        circularLayout(graphSeries, 'value');
      }

      var nodeDataExtent = nodeData.getDataExtent('value');
      var edgeDataExtent = edgeData.getDataExtent('value'); // var edgeDataExtent = edgeData.getDataExtent('value');

      var repulsion = forceModel.get('repulsion');
      var edgeLength = forceModel.get('edgeLength');

      if (!zrUtil.isArray(repulsion)) {
        repulsion = [repulsion, repulsion];
      }

      if (!zrUtil.isArray(edgeLength)) {
        edgeLength = [edgeLength, edgeLength];
      } // Larger value has smaller length


      edgeLength = [edgeLength[1], edgeLength[0]];
      var nodes = nodeData.mapArray('value', function (value, idx) {
        var point = nodeData.getItemLayout(idx);
        var rep = linearMap(value, nodeDataExtent, repulsion);

        if (isNaN(rep)) {
          rep = (repulsion[0] + repulsion[1]) / 2;
        }

        return {
          w: rep,
          rep: rep,
          fixed: nodeData.getItemModel(idx).get('fixed'),
          p: !point || isNaN(point[0]) || isNaN(point[1]) ? null : point
        };
      });
      var edges = edgeData.mapArray('value', function (value, idx) {
        var edge = graph.getEdgeByIndex(idx);
        var d = linearMap(value, edgeDataExtent, edgeLength);

        if (isNaN(d)) {
          d = (edgeLength[0] + edgeLength[1]) / 2;
        }

        var edgeModel = edge.getModel();
        var curveness = zrUtil.retrieve3(edgeModel.get('lineStyle.curveness'), -getCurvenessForEdge(edge, graphSeries, idx, true), 0);
        return {
          n1: nodes[edge.node1.dataIndex],
          n2: nodes[edge.node2.dataIndex],
          d: d,
          curveness: curveness,
          ignoreForceLayout: edgeModel.get('ignoreForceLayout')
        };
      });
      var coordSys = graphSeries.coordinateSystem;
      var rect = coordSys.getBoundingRect();
      var forceInstance = forceLayout(nodes, edges, {
        rect: rect,
        gravity: forceModel.get('gravity'),
        friction: forceModel.get('friction')
      });
      var oldStep = forceInstance.step;

      forceInstance.step = function (cb) {
        for (var i = 0, l = nodes.length; i < l; i++) {
          if (nodes[i].fixed) {
            // Write back to layout instance
            vec2.copy(nodes[i].p, graph.getNodeByIndex(i).getLayout());
          }
        }

        oldStep(function (nodes, edges, stopped) {
          for (var i = 0, l = nodes.length; i < l; i++) {
            if (!nodes[i].fixed) {
              graph.getNodeByIndex(i).setLayout(nodes[i].p);
            }

            preservedPoints[nodeData.getId(i)] = nodes[i].p;
          }

          for (var i = 0, l = edges.length; i < l; i++) {
            var e = edges[i];
            var edge = graph.getEdgeByIndex(i);
            var p1 = e.n1.p;
            var p2 = e.n2.p;
            var points = edge.getLayout();
            points = points ? points.slice() : [];
            points[0] = points[0] || [];
            points[1] = points[1] || [];
            vec2.copy(points[0], p1);
            vec2.copy(points[1], p2);

            if (+e.curveness) {
              points[2] = [(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * e.curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * e.curveness];
            }

            edge.setLayout(points);
          } // Update layout


          cb && cb(stopped);
        });
      };

      graphSeries.forceLayout = forceInstance;
      graphSeries.preservedPoints = preservedPoints; // Step to get the layout

      forceInstance.step();
    } else {
      // Remove prev injected forceLayout instance
      graphSeries.forceLayout = null;
    }
  });
}

module.exports = _default;

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var vec2 = __webpack_require__(55);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* A third-party license is embeded for some of the code in this file:
* Some formulas were originally copied from "d3.js" with some
* modifications made for this project.
* (See more details in the comment of the method "step" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/
var scaleAndAdd = vec2.scaleAndAdd; // function adjacentNode(n, e) {
//     return e.n1 === n ? e.n2 : e.n1;
// }

function forceLayout(nodes, edges, opts) {
  var rect = opts.rect;
  var width = rect.width;
  var height = rect.height;
  var center = [rect.x + width / 2, rect.y + height / 2]; // var scale = opts.scale || 1;

  var gravity = opts.gravity == null ? 0.1 : opts.gravity; // for (var i = 0; i < edges.length; i++) {
  //     var e = edges[i];
  //     var n1 = e.n1;
  //     var n2 = e.n2;
  //     n1.edges = n1.edges || [];
  //     n2.edges = n2.edges || [];
  //     n1.edges.push(e);
  //     n2.edges.push(e);
  // }
  // Init position

  for (var i = 0; i < nodes.length; i++) {
    var n = nodes[i];

    if (!n.p) {
      n.p = vec2.create(width * (Math.random() - 0.5) + center[0], height * (Math.random() - 0.5) + center[1]);
    }

    n.pp = vec2.clone(n.p);
    n.edges = null;
  } // Formula in 'Graph Drawing by Force-directed Placement'
  // var k = scale * Math.sqrt(width * height / nodes.length);
  // var k2 = k * k;


  var initialFriction = opts.friction == null ? 0.6 : opts.friction;
  var friction = initialFriction;
  return {
    warmUp: function () {
      friction = initialFriction * 0.8;
    },
    setFixed: function (idx) {
      nodes[idx].fixed = true;
    },
    setUnfixed: function (idx) {
      nodes[idx].fixed = false;
    },

    /**
     * Some formulas were originally copied from "d3.js"
     * https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/layout/force.js
     * with some modifications made for this project.
     * See the license statement at the head of this file.
     */
    step: function (cb) {
      var v12 = [];
      var nLen = nodes.length;

      for (var i = 0; i < edges.length; i++) {
        var e = edges[i];

        if (e.ignoreForceLayout) {
          continue;
        }

        var n1 = e.n1;
        var n2 = e.n2;
        vec2.sub(v12, n2.p, n1.p);
        var d = vec2.len(v12) - e.d;
        var w = n2.w / (n1.w + n2.w);

        if (isNaN(w)) {
          w = 0;
        }

        vec2.normalize(v12, v12);
        !n1.fixed && scaleAndAdd(n1.p, n1.p, v12, w * d * friction);
        !n2.fixed && scaleAndAdd(n2.p, n2.p, v12, -(1 - w) * d * friction);
      } // Gravity


      for (var i = 0; i < nLen; i++) {
        var n = nodes[i];

        if (!n.fixed) {
          vec2.sub(v12, center, n.p); // var d = vec2.len(v12);
          // vec2.scale(v12, v12, 1 / d);
          // var gravityFactor = gravity;

          scaleAndAdd(n.p, n.p, v12, gravity * friction);
        }
      } // Repulsive
      // PENDING


      for (var i = 0; i < nLen; i++) {
        var n1 = nodes[i];

        for (var j = i + 1; j < nLen; j++) {
          var n2 = nodes[j];
          vec2.sub(v12, n2.p, n1.p);
          var d = vec2.len(v12);

          if (d === 0) {
            // Random repulse
            vec2.set(v12, Math.random() - 0.5, Math.random() - 0.5);
            d = 1;
          }

          var repFact = (n1.rep + n2.rep) / d / d;
          !n1.fixed && scaleAndAdd(n1.pp, n1.pp, v12, repFact);
          !n2.fixed && scaleAndAdd(n2.pp, n2.pp, v12, -repFact);
        }
      }

      var v = [];

      for (var i = 0; i < nLen; i++) {
        var n = nodes[i];

        if (!n.fixed) {
          vec2.sub(v, n.p, n.pp);
          scaleAndAdd(n.p, n.p, v, friction);
          vec2.copy(n.pp, n.p);
        }
      }

      friction = friction * 0.992;
      cb && cb(nodes, edges, friction < 0.01);
    }
  };
}

exports.forceLayout = forceLayout;

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var View = __webpack_require__(420);

var _layout = __webpack_require__(53);

var getLayoutRect = _layout.getLayoutRect;

var bbox = __webpack_require__(234);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// FIXME Where to create the simple view coordinate system
function getViewRect(seriesModel, api, aspect) {
  var option = seriesModel.getBoxLayoutParams();
  option.aspect = aspect;
  return getLayoutRect(option, {
    width: api.getWidth(),
    height: api.getHeight()
  });
}

function _default(ecModel, api) {
  var viewList = [];
  ecModel.eachSeriesByType('graph', function (seriesModel) {
    var coordSysType = seriesModel.get('coordinateSystem');

    if (!coordSysType || coordSysType === 'view') {
      var data = seriesModel.getData();
      var positions = data.mapArray(function (idx) {
        var itemModel = data.getItemModel(idx);
        return [+itemModel.get('x'), +itemModel.get('y')];
      });
      var min = [];
      var max = [];
      bbox.fromPoints(positions, min, max); // If width or height is 0

      if (max[0] - min[0] === 0) {
        max[0] += 1;
        min[0] -= 1;
      }

      if (max[1] - min[1] === 0) {
        max[1] += 1;
        min[1] -= 1;
      }

      var aspect = (max[0] - min[0]) / (max[1] - min[1]); // FIXME If get view rect after data processed?

      var viewRect = getViewRect(seriesModel, api, aspect); // Position may be NaN, use view rect instead

      if (isNaN(aspect)) {
        min = [viewRect.x, viewRect.y];
        max = [viewRect.x + viewRect.width, viewRect.y + viewRect.height];
      }

      var bbWidth = max[0] - min[0];
      var bbHeight = max[1] - min[1];
      var viewWidth = viewRect.width;
      var viewHeight = viewRect.height;
      var viewCoordSys = seriesModel.coordinateSystem = new View();
      viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
      viewCoordSys.setBoundingRect(min[0], min[1], bbWidth, bbHeight);
      viewCoordSys.setViewRect(viewRect.x, viewRect.y, viewWidth, viewHeight); // Update roam info

      viewCoordSys.setCenter(seriesModel.get('center'));
      viewCoordSys.setZoom(seriesModel.get('zoom'));
      viewList.push(viewCoordSys);
    }
  });
  return viewList;
}

module.exports = _default;

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

__webpack_require__(1651);

__webpack_require__(1652);

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var createListSimply = __webpack_require__(209);

var SeriesModel = __webpack_require__(74);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var GaugeSeries = SeriesModel.extend({
  type: 'series.gauge',
  getInitialData: function (option, ecModel) {
    return createListSimply(this, ['value']);
  },
  defaultOption: {
    zlevel: 0,
    z: 2,
    // 默认全局居中
    center: ['50%', '50%'],
    legendHoverLink: true,
    radius: '75%',
    startAngle: 225,
    endAngle: -45,
    clockwise: true,
    // 最小值
    min: 0,
    // 最大值
    max: 100,
    // 分割段数，默认为10
    splitNumber: 10,
    // 坐标轴线
    axisLine: {
      // 默认显示，属性show控制显示与否
      show: true,
      lineStyle: {
        // 属性lineStyle控制线条样式
        color: [[0.2, '#91c7ae'], [0.8, '#63869e'], [1, '#c23531']],
        width: 30
      }
    },
    // 分隔线
    splitLine: {
      // 默认显示，属性show控制显示与否
      show: true,
      // 属性length控制线长
      length: 30,
      // 属性lineStyle（详见lineStyle）控制线条样式
      lineStyle: {
        color: '#eee',
        width: 2,
        type: 'solid'
      }
    },
    // 坐标轴小标记
    axisTick: {
      // 属性show控制显示与否，默认不显示
      show: true,
      // 每份split细分多少段
      splitNumber: 5,
      // 属性length控制线长
      length: 8,
      // 属性lineStyle控制线条样式
      lineStyle: {
        color: '#eee',
        width: 1,
        type: 'solid'
      }
    },
    axisLabel: {
      show: true,
      distance: 5,
      // formatter: null,
      color: 'auto'
    },
    pointer: {
      show: true,
      length: '80%',
      width: 8
    },
    itemStyle: {
      color: 'auto'
    },
    title: {
      show: true,
      // x, y，单位px
      offsetCenter: [0, '-40%'],
      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
      color: '#333',
      fontSize: 15
    },
    detail: {
      show: true,
      backgroundColor: 'rgba(0,0,0,0)',
      borderWidth: 0,
      borderColor: '#ccc',
      width: 100,
      height: null,
      // self-adaption
      padding: [5, 10],
      // x, y，单位px
      offsetCenter: [0, '40%'],
      // formatter: null,
      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
      color: 'auto',
      fontSize: 30
    }
  }
});
var _default = GaugeSeries;
module.exports = _default;

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var PointerPath = __webpack_require__(1653);

var graphic = __webpack_require__(27);

var ChartView = __webpack_require__(123);

var _number = __webpack_require__(37);

var parsePercent = _number.parsePercent;
var round = _number.round;
var linearMap = _number.linearMap;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function parsePosition(seriesModel, api) {
  var center = seriesModel.get('center');
  var width = api.getWidth();
  var height = api.getHeight();
  var size = Math.min(width, height);
  var cx = parsePercent(center[0], api.getWidth());
  var cy = parsePercent(center[1], api.getHeight());
  var r = parsePercent(seriesModel.get('radius'), size / 2);
  return {
    cx: cx,
    cy: cy,
    r: r
  };
}

function formatLabel(label, labelFormatter) {
  if (labelFormatter) {
    if (typeof labelFormatter === 'string') {
      label = labelFormatter.replace('{value}', label != null ? label : '');
    } else if (typeof labelFormatter === 'function') {
      label = labelFormatter(label);
    }
  }

  return label;
}

var PI2 = Math.PI * 2;
var GaugeView = ChartView.extend({
  type: 'gauge',
  render: function (seriesModel, ecModel, api) {
    this.group.removeAll();
    var colorList = seriesModel.get('axisLine.lineStyle.color');
    var posInfo = parsePosition(seriesModel, api);

    this._renderMain(seriesModel, ecModel, api, colorList, posInfo);
  },
  dispose: function () {},
  _renderMain: function (seriesModel, ecModel, api, colorList, posInfo) {
    var group = this.group;
    var axisLineModel = seriesModel.getModel('axisLine');
    var lineStyleModel = axisLineModel.getModel('lineStyle');
    var clockwise = seriesModel.get('clockwise');
    var startAngle = -seriesModel.get('startAngle') / 180 * Math.PI;
    var endAngle = -seriesModel.get('endAngle') / 180 * Math.PI;
    var angleRangeSpan = (endAngle - startAngle) % PI2;
    var prevEndAngle = startAngle;
    var axisLineWidth = lineStyleModel.get('width');
    var showAxis = axisLineModel.get('show');

    for (var i = 0; showAxis && i < colorList.length; i++) {
      // Clamp
      var percent = Math.min(Math.max(colorList[i][0], 0), 1);
      var endAngle = startAngle + angleRangeSpan * percent;
      var sector = new graphic.Sector({
        shape: {
          startAngle: prevEndAngle,
          endAngle: endAngle,
          cx: posInfo.cx,
          cy: posInfo.cy,
          clockwise: clockwise,
          r0: posInfo.r - axisLineWidth,
          r: posInfo.r
        },
        silent: true
      });
      sector.setStyle({
        fill: colorList[i][1]
      });
      sector.setStyle(lineStyleModel.getLineStyle( // Because we use sector to simulate arc
      // so the properties for stroking are useless
      ['color', 'borderWidth', 'borderColor']));
      group.add(sector);
      prevEndAngle = endAngle;
    }

    var getColor = function (percent) {
      // Less than 0
      if (percent <= 0) {
        return colorList[0][1];
      }

      for (var i = 0; i < colorList.length; i++) {
        if (colorList[i][0] >= percent && (i === 0 ? 0 : colorList[i - 1][0]) < percent) {
          return colorList[i][1];
        }
      } // More than 1


      return colorList[i - 1][1];
    };

    if (!clockwise) {
      var tmp = startAngle;
      startAngle = endAngle;
      endAngle = tmp;
    }

    this._renderTicks(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise);

    this._renderPointer(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise);

    this._renderTitle(seriesModel, ecModel, api, getColor, posInfo);

    this._renderDetail(seriesModel, ecModel, api, getColor, posInfo);
  },
  _renderTicks: function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise) {
    var group = this.group;
    var cx = posInfo.cx;
    var cy = posInfo.cy;
    var r = posInfo.r;
    var minVal = +seriesModel.get('min');
    var maxVal = +seriesModel.get('max');
    var splitLineModel = seriesModel.getModel('splitLine');
    var tickModel = seriesModel.getModel('axisTick');
    var labelModel = seriesModel.getModel('axisLabel');
    var splitNumber = seriesModel.get('splitNumber');
    var subSplitNumber = tickModel.get('splitNumber');
    var splitLineLen = parsePercent(splitLineModel.get('length'), r);
    var tickLen = parsePercent(tickModel.get('length'), r);
    var angle = startAngle;
    var step = (endAngle - startAngle) / splitNumber;
    var subStep = step / subSplitNumber;
    var splitLineStyle = splitLineModel.getModel('lineStyle').getLineStyle();
    var tickLineStyle = tickModel.getModel('lineStyle').getLineStyle();

    for (var i = 0; i <= splitNumber; i++) {
      var unitX = Math.cos(angle);
      var unitY = Math.sin(angle); // Split line

      if (splitLineModel.get('show')) {
        var splitLine = new graphic.Line({
          shape: {
            x1: unitX * r + cx,
            y1: unitY * r + cy,
            x2: unitX * (r - splitLineLen) + cx,
            y2: unitY * (r - splitLineLen) + cy
          },
          style: splitLineStyle,
          silent: true
        });

        if (splitLineStyle.stroke === 'auto') {
          splitLine.setStyle({
            stroke: getColor(i / splitNumber)
          });
        }

        group.add(splitLine);
      } // Label


      if (labelModel.get('show')) {
        var label = formatLabel(round(i / splitNumber * (maxVal - minVal) + minVal), labelModel.get('formatter'));
        var distance = labelModel.get('distance');
        var autoColor = getColor(i / splitNumber);
        group.add(new graphic.Text({
          style: graphic.setTextStyle({}, labelModel, {
            text: label,
            x: unitX * (r - splitLineLen - distance) + cx,
            y: unitY * (r - splitLineLen - distance) + cy,
            textVerticalAlign: unitY < -0.4 ? 'top' : unitY > 0.4 ? 'bottom' : 'middle',
            textAlign: unitX < -0.4 ? 'left' : unitX > 0.4 ? 'right' : 'center'
          }, {
            autoColor: autoColor
          }),
          silent: true
        }));
      } // Axis tick


      if (tickModel.get('show') && i !== splitNumber) {
        for (var j = 0; j <= subSplitNumber; j++) {
          var unitX = Math.cos(angle);
          var unitY = Math.sin(angle);
          var tickLine = new graphic.Line({
            shape: {
              x1: unitX * r + cx,
              y1: unitY * r + cy,
              x2: unitX * (r - tickLen) + cx,
              y2: unitY * (r - tickLen) + cy
            },
            silent: true,
            style: tickLineStyle
          });

          if (tickLineStyle.stroke === 'auto') {
            tickLine.setStyle({
              stroke: getColor((i + j / subSplitNumber) / splitNumber)
            });
          }

          group.add(tickLine);
          angle += subStep;
        }

        angle -= subStep;
      } else {
        angle += step;
      }
    }
  },
  _renderPointer: function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise) {
    var group = this.group;
    var oldData = this._data;

    if (!seriesModel.get('pointer.show')) {
      // Remove old element
      oldData && oldData.eachItemGraphicEl(function (el) {
        group.remove(el);
      });
      return;
    }

    var valueExtent = [+seriesModel.get('min'), +seriesModel.get('max')];
    var angleExtent = [startAngle, endAngle];
    var data = seriesModel.getData();
    var valueDim = data.mapDimension('value');
    data.diff(oldData).add(function (idx) {
      var pointer = new PointerPath({
        shape: {
          angle: startAngle
        }
      });
      graphic.initProps(pointer, {
        shape: {
          angle: linearMap(data.get(valueDim, idx), valueExtent, angleExtent, true)
        }
      }, seriesModel);
      group.add(pointer);
      data.setItemGraphicEl(idx, pointer);
    }).update(function (newIdx, oldIdx) {
      var pointer = oldData.getItemGraphicEl(oldIdx);
      graphic.updateProps(pointer, {
        shape: {
          angle: linearMap(data.get(valueDim, newIdx), valueExtent, angleExtent, true)
        }
      }, seriesModel);
      group.add(pointer);
      data.setItemGraphicEl(newIdx, pointer);
    }).remove(function (idx) {
      var pointer = oldData.getItemGraphicEl(idx);
      group.remove(pointer);
    }).execute();
    data.eachItemGraphicEl(function (pointer, idx) {
      var itemModel = data.getItemModel(idx);
      var pointerModel = itemModel.getModel('pointer');
      pointer.setShape({
        x: posInfo.cx,
        y: posInfo.cy,
        width: parsePercent(pointerModel.get('width'), posInfo.r),
        r: parsePercent(pointerModel.get('length'), posInfo.r)
      });
      pointer.useStyle(itemModel.getModel('itemStyle').getItemStyle());

      if (pointer.style.fill === 'auto') {
        pointer.setStyle('fill', getColor(linearMap(data.get(valueDim, idx), valueExtent, [0, 1], true)));
      }

      graphic.setHoverStyle(pointer, itemModel.getModel('emphasis.itemStyle').getItemStyle());
    });
    this._data = data;
  },
  _renderTitle: function (seriesModel, ecModel, api, getColor, posInfo) {
    var data = seriesModel.getData();
    var valueDim = data.mapDimension('value');
    var titleModel = seriesModel.getModel('title');

    if (titleModel.get('show')) {
      var offsetCenter = titleModel.get('offsetCenter');
      var x = posInfo.cx + parsePercent(offsetCenter[0], posInfo.r);
      var y = posInfo.cy + parsePercent(offsetCenter[1], posInfo.r);
      var minVal = +seriesModel.get('min');
      var maxVal = +seriesModel.get('max');
      var value = seriesModel.getData().get(valueDim, 0);
      var autoColor = getColor(linearMap(value, [minVal, maxVal], [0, 1], true));
      this.group.add(new graphic.Text({
        silent: true,
        style: graphic.setTextStyle({}, titleModel, {
          x: x,
          y: y,
          // FIXME First data name ?
          text: data.getName(0),
          textAlign: 'center',
          textVerticalAlign: 'middle'
        }, {
          autoColor: autoColor,
          forceRich: true
        })
      }));
    }
  },
  _renderDetail: function (seriesModel, ecModel, api, getColor, posInfo) {
    var detailModel = seriesModel.getModel('detail');
    var minVal = +seriesModel.get('min');
    var maxVal = +seriesModel.get('max');

    if (detailModel.get('show')) {
      var offsetCenter = detailModel.get('offsetCenter');
      var x = posInfo.cx + parsePercent(offsetCenter[0], posInfo.r);
      var y = posInfo.cy + parsePercent(offsetCenter[1], posInfo.r);
      var width = parsePercent(detailModel.get('width'), posInfo.r);
      var height = parsePercent(detailModel.get('height'), posInfo.r);
      var data = seriesModel.getData();
      var value = data.get(data.mapDimension('value'), 0);
      var autoColor = getColor(linearMap(value, [minVal, maxVal], [0, 1], true));
      this.group.add(new graphic.Text({
        silent: true,
        style: graphic.setTextStyle({}, detailModel, {
          x: x,
          y: y,
          text: formatLabel( // FIXME First data name ?
          value, detailModel.get('formatter')),
          textWidth: isNaN(width) ? null : width,
          textHeight: isNaN(height) ? null : height,
          textAlign: 'center',
          textVerticalAlign: 'middle'
        }, {
          autoColor: autoColor,
          forceRich: true
        })
      }));
    }
  }
});
var _default = GaugeView;
module.exports = _default;

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var Path = __webpack_require__(65);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = Path.extend({
  type: 'echartsGaugePointer',
  shape: {
    angle: 0,
    width: 10,
    r: 10,
    x: 0,
    y: 0
  },
  buildPath: function (ctx, shape) {
    var mathCos = Math.cos;
    var mathSin = Math.sin;
    var r = shape.r;
    var width = shape.width;
    var angle = shape.angle;
    var x = shape.x - mathCos(angle) * width * (width >= r / 3 ? 1 : 2);
    var y = shape.y - mathSin(angle) * width * (width >= r / 3 ? 1 : 2);
    angle = shape.angle - Math.PI / 2;
    ctx.moveTo(x, y);
    ctx.lineTo(shape.x + mathCos(angle) * width, shape.y + mathSin(angle) * width);
    ctx.lineTo(shape.x + mathCos(shape.angle) * r, shape.y + mathSin(shape.angle) * r);
    ctx.lineTo(shape.x - mathCos(angle) * width, shape.y - mathSin(angle) * width);
    ctx.lineTo(x, y);
    return;
  }
});

module.exports = _default;

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(1655);

__webpack_require__(1656);

var dataColor = __webpack_require__(304);

var funnelLayout = __webpack_require__(1657);

var dataFilter = __webpack_require__(244);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.registerVisual(dataColor('funnel'));
echarts.registerLayout(funnelLayout);
echarts.registerProcessor(dataFilter('funnel'));

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var createListSimply = __webpack_require__(209);

var _model = __webpack_require__(44);

var defaultEmphasis = _model.defaultEmphasis;

var _sourceHelper = __webpack_require__(136);

var makeSeriesEncodeForNameBased = _sourceHelper.makeSeriesEncodeForNameBased;

var LegendVisualProvider = __webpack_require__(243);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var FunnelSeries = echarts.extendSeriesModel({
  type: 'series.funnel',
  init: function (option) {
    FunnelSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
    // Use a function instead of direct access because data reference may changed

    this.legendVisualProvider = new LegendVisualProvider(zrUtil.bind(this.getData, this), zrUtil.bind(this.getRawData, this)); // Extend labelLine emphasis

    this._defaultLabelLine(option);
  },
  getInitialData: function (option, ecModel) {
    return createListSimply(this, {
      coordDimensions: ['value'],
      encodeDefaulter: zrUtil.curry(makeSeriesEncodeForNameBased, this)
    });
  },
  _defaultLabelLine: function (option) {
    // Extend labelLine emphasis
    defaultEmphasis(option, 'labelLine', ['show']);
    var labelLineNormalOpt = option.labelLine;
    var labelLineEmphasisOpt = option.emphasis.labelLine; // Not show label line if `label.normal.show = false`

    labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
    labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
  },
  // Overwrite
  getDataParams: function (dataIndex) {
    var data = this.getData();
    var params = FunnelSeries.superCall(this, 'getDataParams', dataIndex);
    var valueDim = data.mapDimension('value');
    var sum = data.getSum(valueDim); // Percent is 0 if sum is 0

    params.percent = !sum ? 0 : +(data.get(valueDim, dataIndex) / sum * 100).toFixed(2);
    params.$vars.push('percent');
    return params;
  },
  defaultOption: {
    zlevel: 0,
    // 一级层叠
    z: 2,
    // 二级层叠
    legendHoverLink: true,
    left: 80,
    top: 60,
    right: 80,
    bottom: 60,
    // width: {totalWidth} - left - right,
    // height: {totalHeight} - top - bottom,
    // 默认取数据最小最大值
    // min: 0,
    // max: 100,
    minSize: '0%',
    maxSize: '100%',
    sort: 'descending',
    // 'ascending', 'descending'
    orient: 'vertical',
    gap: 0,
    funnelAlign: 'center',
    label: {
      show: true,
      position: 'outer' // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调

    },
    labelLine: {
      show: true,
      length: 20,
      lineStyle: {
        // color: 各异,
        width: 1,
        type: 'solid'
      }
    },
    itemStyle: {
      // color: 各异,
      borderColor: '#fff',
      borderWidth: 1
    },
    emphasis: {
      label: {
        show: true
      }
    }
  }
});
var _default = FunnelSeries;
module.exports = _default;

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var graphic = __webpack_require__(27);

var zrUtil = __webpack_require__(1);

var ChartView = __webpack_require__(123);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Piece of pie including Sector, Label, LabelLine
 * @constructor
 * @extends {module:zrender/graphic/Group}
 */
function FunnelPiece(data, idx) {
  graphic.Group.call(this);
  var polygon = new graphic.Polygon();
  var labelLine = new graphic.Polyline();
  var text = new graphic.Text();
  this.add(polygon);
  this.add(labelLine);
  this.add(text);

  this.highDownOnUpdate = function (fromState, toState) {
    if (toState === 'emphasis') {
      labelLine.ignore = labelLine.hoverIgnore;
      text.ignore = text.hoverIgnore;
    } else {
      labelLine.ignore = labelLine.normalIgnore;
      text.ignore = text.normalIgnore;
    }
  };

  this.updateData(data, idx, true);
}

var funnelPieceProto = FunnelPiece.prototype;
var opacityAccessPath = ['itemStyle', 'opacity'];

funnelPieceProto.updateData = function (data, idx, firstCreate) {
  var polygon = this.childAt(0);
  var seriesModel = data.hostModel;
  var itemModel = data.getItemModel(idx);
  var layout = data.getItemLayout(idx);
  var opacity = data.getItemModel(idx).get(opacityAccessPath);
  opacity = opacity == null ? 1 : opacity; // Reset style

  polygon.useStyle({});

  if (firstCreate) {
    polygon.setShape({
      points: layout.points
    });
    polygon.setStyle({
      opacity: 0
    });
    graphic.initProps(polygon, {
      style: {
        opacity: opacity
      }
    }, seriesModel, idx);
  } else {
    graphic.updateProps(polygon, {
      style: {
        opacity: opacity
      },
      shape: {
        points: layout.points
      }
    }, seriesModel, idx);
  } // Update common style


  var itemStyleModel = itemModel.getModel('itemStyle');
  var visualColor = data.getItemVisual(idx, 'color');
  polygon.setStyle(zrUtil.defaults({
    lineJoin: 'round',
    fill: visualColor
  }, itemStyleModel.getItemStyle(['opacity'])));
  polygon.hoverStyle = itemStyleModel.getModel('emphasis').getItemStyle();

  this._updateLabel(data, idx);

  graphic.setHoverStyle(this);
};

funnelPieceProto._updateLabel = function (data, idx) {
  var labelLine = this.childAt(1);
  var labelText = this.childAt(2);
  var seriesModel = data.hostModel;
  var itemModel = data.getItemModel(idx);
  var layout = data.getItemLayout(idx);
  var labelLayout = layout.label;
  var visualColor = data.getItemVisual(idx, 'color');
  graphic.updateProps(labelLine, {
    shape: {
      points: labelLayout.linePoints || labelLayout.linePoints
    }
  }, seriesModel, idx);
  graphic.updateProps(labelText, {
    style: {
      x: labelLayout.x,
      y: labelLayout.y
    }
  }, seriesModel, idx);
  labelText.attr({
    rotation: labelLayout.rotation,
    origin: [labelLayout.x, labelLayout.y],
    z2: 10
  });
  var labelModel = itemModel.getModel('label');
  var labelHoverModel = itemModel.getModel('emphasis.label');
  var labelLineModel = itemModel.getModel('labelLine');
  var labelLineHoverModel = itemModel.getModel('emphasis.labelLine');
  var visualColor = data.getItemVisual(idx, 'color');
  graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, labelHoverModel, {
    labelFetcher: data.hostModel,
    labelDataIndex: idx,
    defaultText: data.getName(idx),
    autoColor: visualColor,
    useInsideStyle: !!labelLayout.inside
  }, {
    textAlign: labelLayout.textAlign,
    textVerticalAlign: labelLayout.verticalAlign
  });
  labelText.ignore = labelText.normalIgnore = !labelModel.get('show');
  labelText.hoverIgnore = !labelHoverModel.get('show');
  labelLine.ignore = labelLine.normalIgnore = !labelLineModel.get('show');
  labelLine.hoverIgnore = !labelLineHoverModel.get('show'); // Default use item visual color

  labelLine.setStyle({
    stroke: visualColor
  });
  labelLine.setStyle(labelLineModel.getModel('lineStyle').getLineStyle());
  labelLine.hoverStyle = labelLineHoverModel.getModel('lineStyle').getLineStyle();
};

zrUtil.inherits(FunnelPiece, graphic.Group);
var FunnelView = ChartView.extend({
  type: 'funnel',
  render: function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var oldData = this._data;
    var group = this.group;
    data.diff(oldData).add(function (idx) {
      var funnelPiece = new FunnelPiece(data, idx);
      data.setItemGraphicEl(idx, funnelPiece);
      group.add(funnelPiece);
    }).update(function (newIdx, oldIdx) {
      var piePiece = oldData.getItemGraphicEl(oldIdx);
      piePiece.updateData(data, newIdx);
      group.add(piePiece);
      data.setItemGraphicEl(newIdx, piePiece);
    }).remove(function (idx) {
      var piePiece = oldData.getItemGraphicEl(idx);
      group.remove(piePiece);
    }).execute();
    this._data = data;
  },
  remove: function () {
    this.group.removeAll();
    this._data = null;
  },
  dispose: function () {}
});
var _default = FunnelView;
module.exports = _default;

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var layout = __webpack_require__(53);

var _number = __webpack_require__(37);

var parsePercent = _number.parsePercent;
var linearMap = _number.linearMap;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function getViewRect(seriesModel, api) {
  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  });
}

function getSortedIndices(data, sort) {
  var valueDim = data.mapDimension('value');
  var valueArr = data.mapArray(valueDim, function (val) {
    return val;
  });
  var indices = [];
  var isAscending = sort === 'ascending';

  for (var i = 0, len = data.count(); i < len; i++) {
    indices[i] = i;
  } // Add custom sortable function & none sortable opetion by "options.sort"


  if (typeof sort === 'function') {
    indices.sort(sort);
  } else if (sort !== 'none') {
    indices.sort(function (a, b) {
      return isAscending ? valueArr[a] - valueArr[b] : valueArr[b] - valueArr[a];
    });
  }

  return indices;
}

function labelLayout(data) {
  data.each(function (idx) {
    var itemModel = data.getItemModel(idx);
    var labelModel = itemModel.getModel('label');
    var labelPosition = labelModel.get('position');
    var orient = itemModel.get('orient');
    var labelLineModel = itemModel.getModel('labelLine');
    var layout = data.getItemLayout(idx);
    var points = layout.points;
    var isLabelInside = labelPosition === 'inner' || labelPosition === 'inside' || labelPosition === 'center' || labelPosition === 'insideLeft' || labelPosition === 'insideRight';
    var textAlign;
    var textX;
    var textY;
    var linePoints;

    if (isLabelInside) {
      if (labelPosition === 'insideLeft') {
        textX = (points[0][0] + points[3][0]) / 2 + 5;
        textY = (points[0][1] + points[3][1]) / 2;
        textAlign = 'left';
      } else if (labelPosition === 'insideRight') {
        textX = (points[1][0] + points[2][0]) / 2 - 5;
        textY = (points[1][1] + points[2][1]) / 2;
        textAlign = 'right';
      } else {
        textX = (points[0][0] + points[1][0] + points[2][0] + points[3][0]) / 4;
        textY = (points[0][1] + points[1][1] + points[2][1] + points[3][1]) / 4;
        textAlign = 'center';
      }

      linePoints = [[textX, textY], [textX, textY]];
    } else {
      var x1;
      var y1;
      var x2;
      var y2;
      var labelLineLen = labelLineModel.get('length');

      if (labelPosition === 'left') {
        // Left side
        x1 = (points[3][0] + points[0][0]) / 2;
        y1 = (points[3][1] + points[0][1]) / 2;
        x2 = x1 - labelLineLen;
        textX = x2 - 5;
        textAlign = 'right';
      } else if (labelPosition === 'right') {
        // Right side
        x1 = (points[1][0] + points[2][0]) / 2;
        y1 = (points[1][1] + points[2][1]) / 2;
        x2 = x1 + labelLineLen;
        textX = x2 + 5;
        textAlign = 'left';
      } else if (labelPosition === 'top') {
        // Top side
        x1 = (points[3][0] + points[0][0]) / 2;
        y1 = (points[3][1] + points[0][1]) / 2;
        y2 = y1 - labelLineLen;
        textY = y2 - 5;
        textAlign = 'center';
      } else if (labelPosition === 'bottom') {
        // Bottom side
        x1 = (points[1][0] + points[2][0]) / 2;
        y1 = (points[1][1] + points[2][1]) / 2;
        y2 = y1 + labelLineLen;
        textY = y2 + 5;
        textAlign = 'center';
      } else if (labelPosition === 'rightTop') {
        // RightTop side
        x1 = orient === 'horizontal' ? points[3][0] : points[1][0];
        y1 = orient === 'horizontal' ? points[3][1] : points[1][1];

        if (orient === 'horizontal') {
          y2 = y1 - labelLineLen;
          textY = y2 - 5;
          textAlign = 'center';
        } else {
          x2 = x1 + labelLineLen;
          textX = x2 + 5;
          textAlign = 'top';
        }
      } else if (labelPosition === 'rightBottom') {
        // RightBottom side
        x1 = points[2][0];
        y1 = points[2][1];

        if (orient === 'horizontal') {
          y2 = y1 + labelLineLen;
          textY = y2 + 5;
          textAlign = 'center';
        } else {
          x2 = x1 + labelLineLen;
          textX = x2 + 5;
          textAlign = 'bottom';
        }
      } else if (labelPosition === 'leftTop') {
        // LeftTop side
        x1 = points[0][0];
        y1 = orient === 'horizontal' ? points[0][1] : points[1][1];

        if (orient === 'horizontal') {
          y2 = y1 - labelLineLen;
          textY = y2 - 5;
          textAlign = 'center';
        } else {
          x2 = x1 - labelLineLen;
          textX = x2 - 5;
          textAlign = 'right';
        }
      } else if (labelPosition === 'leftBottom') {
        // LeftBottom side
        x1 = orient === 'horizontal' ? points[1][0] : points[3][0];
        y1 = orient === 'horizontal' ? points[1][1] : points[2][1];

        if (orient === 'horizontal') {
          y2 = y1 + labelLineLen;
          textY = y2 + 5;
          textAlign = 'center';
        } else {
          x2 = x1 - labelLineLen;
          textX = x2 - 5;
          textAlign = 'right';
        }
      } else {
        // Right side or Bottom side
        x1 = (points[1][0] + points[2][0]) / 2;
        y1 = (points[1][1] + points[2][1]) / 2;

        if (orient === 'horizontal') {
          y2 = y1 + labelLineLen;
          textY = y2 + 5;
          textAlign = 'center';
        } else {
          x2 = x1 + labelLineLen;
          textX = x2 + 5;
          textAlign = 'left';
        }
      }

      if (orient === 'horizontal') {
        x2 = x1;
        textX = x2;
      } else {
        y2 = y1;
        textY = y2;
      }

      linePoints = [[x1, y1], [x2, y2]];
    }

    layout.label = {
      linePoints: linePoints,
      x: textX,
      y: textY,
      verticalAlign: 'middle',
      textAlign: textAlign,
      inside: isLabelInside
    };
  });
}

function _default(ecModel, api, payload) {
  ecModel.eachSeriesByType('funnel', function (seriesModel) {
    var data = seriesModel.getData();
    var valueDim = data.mapDimension('value');
    var sort = seriesModel.get('sort');
    var viewRect = getViewRect(seriesModel, api);
    var indices = getSortedIndices(data, sort);
    var orient = seriesModel.get('orient');
    var viewWidth = viewRect.width;
    var viewHeight = viewRect.height;
    var x = viewRect.x;
    var y = viewRect.y;
    var sizeExtent = orient === 'horizontal' ? [parsePercent(seriesModel.get('minSize'), viewHeight), parsePercent(seriesModel.get('maxSize'), viewHeight)] : [parsePercent(seriesModel.get('minSize'), viewWidth), parsePercent(seriesModel.get('maxSize'), viewWidth)];
    var dataExtent = data.getDataExtent(valueDim);
    var min = seriesModel.get('min');
    var max = seriesModel.get('max');

    if (min == null) {
      min = Math.min(dataExtent[0], 0);
    }

    if (max == null) {
      max = dataExtent[1];
    }

    var funnelAlign = seriesModel.get('funnelAlign');
    var gap = seriesModel.get('gap');
    var viewSize = orient === 'horizontal' ? viewWidth : viewHeight;
    var itemSize = (viewSize - gap * (data.count() - 1)) / data.count();

    var getLinePoints = function (idx, offset) {
      // End point index is data.count() and we assign it 0
      if (orient === 'horizontal') {
        var val = data.get(valueDim, idx) || 0;
        var itemHeight = linearMap(val, [min, max], sizeExtent, true);
        var y0;

        switch (funnelAlign) {
          case 'top':
            y0 = y;
            break;

          case 'center':
            y0 = y + (viewHeight - itemHeight) / 2;
            break;

          case 'bottom':
            y0 = y + (viewHeight - itemHeight);
            break;
        }

        return [[offset, y0], [offset, y0 + itemHeight]];
      }

      var val = data.get(valueDim, idx) || 0;
      var itemWidth = linearMap(val, [min, max], sizeExtent, true);
      var x0;

      switch (funnelAlign) {
        case 'left':
          x0 = x;
          break;

        case 'center':
          x0 = x + (viewWidth - itemWidth) / 2;
          break;

        case 'right':
          x0 = x + viewWidth - itemWidth;
          break;
      }

      return [[x0, offset], [x0 + itemWidth, offset]];
    };

    if (sort === 'ascending') {
      // From bottom to top
      itemSize = -itemSize;
      gap = -gap;

      if (orient === 'horizontal') {
        x += viewWidth;
      } else {
        y += viewHeight;
      }

      indices = indices.reverse();
    }

    for (var i = 0; i < indices.length; i++) {
      var idx = indices[i];
      var nextIdx = indices[i + 1];
      var itemModel = data.getItemModel(idx);

      if (orient === 'horizontal') {
        var width = itemModel.get('itemStyle.width');

        if (width == null) {
          width = itemSize;
        } else {
          width = parsePercent(width, viewWidth);

          if (sort === 'ascending') {
            width = -width;
          }
        }

        var start = getLinePoints(idx, x);
        var end = getLinePoints(nextIdx, x + width);
        x += width + gap;
        data.setItemLayout(idx, {
          points: start.concat(end.slice().reverse())
        });
      } else {
        var height = itemModel.get('itemStyle.height');

        if (height == null) {
          height = itemSize;
        } else {
          height = parsePercent(height, viewHeight);

          if (sort === 'ascending') {
            height = -height;
          }
        }

        var start = orient === 'horizontal' ? getLinePoints(idx, x) : getLinePoints(idx, y);
        var end = orient === 'horizontal' ? getLinePoints(nextIdx, x + width) : getLinePoints(nextIdx, y + height);
        y += height + gap;
        data.setItemLayout(idx, {
          points: start.concat(end.slice().reverse())
        });
      }
    }

    labelLayout(data);
  });
}

module.exports = _default;

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(666);

__webpack_require__(1667);

__webpack_require__(1668);

var parallelVisual = __webpack_require__(1669);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.registerVisual(parallelVisual);

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var modelUtil = __webpack_require__(44);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(option) {
  createParallelIfNeeded(option);
  mergeAxisOptionFromParallel(option);
}
/**
 * Create a parallel coordinate if not exists.
 * @inner
 */


function createParallelIfNeeded(option) {
  if (option.parallel) {
    return;
  }

  var hasParallelSeries = false;
  zrUtil.each(option.series, function (seriesOpt) {
    if (seriesOpt && seriesOpt.type === 'parallel') {
      hasParallelSeries = true;
    }
  });

  if (hasParallelSeries) {
    option.parallel = [{}];
  }
}
/**
 * Merge aixs definition from parallel option (if exists) to axis option.
 * @inner
 */


function mergeAxisOptionFromParallel(option) {
  var axes = modelUtil.normalizeToArray(option.parallelAxis);
  zrUtil.each(axes, function (axisOption) {
    if (!zrUtil.isObject(axisOption)) {
      return;
    }

    var parallelIndex = axisOption.parallelIndex || 0;
    var parallelOption = modelUtil.normalizeToArray(option.parallel)[parallelIndex];

    if (parallelOption && parallelOption.parallelAxisDefault) {
      zrUtil.merge(axisOption, parallelOption.parallelAxisDefault, false);
    }
  });
}

module.exports = _default;

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var matrix = __webpack_require__(82);

var layoutUtil = __webpack_require__(53);

var axisHelper = __webpack_require__(109);

var ParallelAxis = __webpack_require__(1661);

var graphic = __webpack_require__(27);

var numberUtil = __webpack_require__(37);

var sliderMove = __webpack_require__(210);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Parallel Coordinates
 * <https://en.wikipedia.org/wiki/Parallel_coordinates>
 */
var each = zrUtil.each;
var mathMin = Math.min;
var mathMax = Math.max;
var mathFloor = Math.floor;
var mathCeil = Math.ceil;
var round = numberUtil.round;
var PI = Math.PI;

function Parallel(parallelModel, ecModel, api) {
  /**
   * key: dimension
   * @type {Object.<string, module:echarts/coord/parallel/Axis>}
   * @private
   */
  this._axesMap = zrUtil.createHashMap();
  /**
   * key: dimension
   * value: {position: [], rotation, }
   * @type {Object.<string, Object>}
   * @private
   */

  this._axesLayout = {};
  /**
   * Always follow axis order.
   * @type {Array.<string>}
   * @readOnly
   */

  this.dimensions = parallelModel.dimensions;
  /**
   * @type {module:zrender/core/BoundingRect}
   */

  this._rect;
  /**
   * @type {module:echarts/coord/parallel/ParallelModel}
   */

  this._model = parallelModel;

  this._init(parallelModel, ecModel, api);
}

Parallel.prototype = {
  type: 'parallel',
  constructor: Parallel,

  /**
   * Initialize cartesian coordinate systems
   * @private
   */
  _init: function (parallelModel, ecModel, api) {
    var dimensions = parallelModel.dimensions;
    var parallelAxisIndex = parallelModel.parallelAxisIndex;
    each(dimensions, function (dim, idx) {
      var axisIndex = parallelAxisIndex[idx];
      var axisModel = ecModel.getComponent('parallelAxis', axisIndex);

      var axis = this._axesMap.set(dim, new ParallelAxis(dim, axisHelper.createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisIndex));

      var isCategory = axis.type === 'category';
      axis.onBand = isCategory && axisModel.get('boundaryGap');
      axis.inverse = axisModel.get('inverse'); // Injection

      axisModel.axis = axis;
      axis.model = axisModel;
      axis.coordinateSystem = axisModel.coordinateSystem = this;
    }, this);
  },

  /**
   * Update axis scale after data processed
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */
  update: function (ecModel, api) {
    this._updateAxesFromSeries(this._model, ecModel);
  },

  /**
   * @override
   */
  containPoint: function (point) {
    var layoutInfo = this._makeLayoutInfo();

    var axisBase = layoutInfo.axisBase;
    var layoutBase = layoutInfo.layoutBase;
    var pixelDimIndex = layoutInfo.pixelDimIndex;
    var pAxis = point[1 - pixelDimIndex];
    var pLayout = point[pixelDimIndex];
    return pAxis >= axisBase && pAxis <= axisBase + layoutInfo.axisLength && pLayout >= layoutBase && pLayout <= layoutBase + layoutInfo.layoutLength;
  },
  getModel: function () {
    return this._model;
  },

  /**
   * Update properties from series
   * @private
   */
  _updateAxesFromSeries: function (parallelModel, ecModel) {
    ecModel.eachSeries(function (seriesModel) {
      if (!parallelModel.contains(seriesModel, ecModel)) {
        return;
      }

      var data = seriesModel.getData();
      each(this.dimensions, function (dim) {
        var axis = this._axesMap.get(dim);

        axis.scale.unionExtentFromData(data, data.mapDimension(dim));
        axisHelper.niceScaleExtent(axis.scale, axis.model);
      }, this);
    }, this);
  },

  /**
   * Resize the parallel coordinate system.
   * @param {module:echarts/coord/parallel/ParallelModel} parallelModel
   * @param {module:echarts/ExtensionAPI} api
   */
  resize: function (parallelModel, api) {
    this._rect = layoutUtil.getLayoutRect(parallelModel.getBoxLayoutParams(), {
      width: api.getWidth(),
      height: api.getHeight()
    });

    this._layoutAxes();
  },

  /**
   * @return {module:zrender/core/BoundingRect}
   */
  getRect: function () {
    return this._rect;
  },

  /**
   * @private
   */
  _makeLayoutInfo: function () {
    var parallelModel = this._model;
    var rect = this._rect;
    var xy = ['x', 'y'];
    var wh = ['width', 'height'];
    var layout = parallelModel.get('layout');
    var pixelDimIndex = layout === 'horizontal' ? 0 : 1;
    var layoutLength = rect[wh[pixelDimIndex]];
    var layoutExtent = [0, layoutLength];
    var axisCount = this.dimensions.length;
    var axisExpandWidth = restrict(parallelModel.get('axisExpandWidth'), layoutExtent);
    var axisExpandCount = restrict(parallelModel.get('axisExpandCount') || 0, [0, axisCount]);
    var axisExpandable = parallelModel.get('axisExpandable') && axisCount > 3 && axisCount > axisExpandCount && axisExpandCount > 1 && axisExpandWidth > 0 && layoutLength > 0; // `axisExpandWindow` is According to the coordinates of [0, axisExpandLength],
    // for sake of consider the case that axisCollapseWidth is 0 (when screen is narrow),
    // where collapsed axes should be overlapped.

    var axisExpandWindow = parallelModel.get('axisExpandWindow');
    var winSize;

    if (!axisExpandWindow) {
      winSize = restrict(axisExpandWidth * (axisExpandCount - 1), layoutExtent);
      var axisExpandCenter = parallelModel.get('axisExpandCenter') || mathFloor(axisCount / 2);
      axisExpandWindow = [axisExpandWidth * axisExpandCenter - winSize / 2];
      axisExpandWindow[1] = axisExpandWindow[0] + winSize;
    } else {
      winSize = restrict(axisExpandWindow[1] - axisExpandWindow[0], layoutExtent);
      axisExpandWindow[1] = axisExpandWindow[0] + winSize;
    }

    var axisCollapseWidth = (layoutLength - winSize) / (axisCount - axisExpandCount); // Avoid axisCollapseWidth is too small.

    axisCollapseWidth < 3 && (axisCollapseWidth = 0); // Find the first and last indices > ewin[0] and < ewin[1].

    var winInnerIndices = [mathFloor(round(axisExpandWindow[0] / axisExpandWidth, 1)) + 1, mathCeil(round(axisExpandWindow[1] / axisExpandWidth, 1)) - 1]; // Pos in ec coordinates.

    var axisExpandWindow0Pos = axisCollapseWidth / axisExpandWidth * axisExpandWindow[0];
    return {
      layout: layout,
      pixelDimIndex: pixelDimIndex,
      layoutBase: rect[xy[pixelDimIndex]],
      layoutLength: layoutLength,
      axisBase: rect[xy[1 - pixelDimIndex]],
      axisLength: rect[wh[1 - pixelDimIndex]],
      axisExpandable: axisExpandable,
      axisExpandWidth: axisExpandWidth,
      axisCollapseWidth: axisCollapseWidth,
      axisExpandWindow: axisExpandWindow,
      axisCount: axisCount,
      winInnerIndices: winInnerIndices,
      axisExpandWindow0Pos: axisExpandWindow0Pos
    };
  },

  /**
   * @private
   */
  _layoutAxes: function () {
    var rect = this._rect;
    var axes = this._axesMap;
    var dimensions = this.dimensions;

    var layoutInfo = this._makeLayoutInfo();

    var layout = layoutInfo.layout;
    axes.each(function (axis) {
      var axisExtent = [0, layoutInfo.axisLength];
      var idx = axis.inverse ? 1 : 0;
      axis.setExtent(axisExtent[idx], axisExtent[1 - idx]);
    });
    each(dimensions, function (dim, idx) {
      var posInfo = (layoutInfo.axisExpandable ? layoutAxisWithExpand : layoutAxisWithoutExpand)(idx, layoutInfo);
      var positionTable = {
        horizontal: {
          x: posInfo.position,
          y: layoutInfo.axisLength
        },
        vertical: {
          x: 0,
          y: posInfo.position
        }
      };
      var rotationTable = {
        horizontal: PI / 2,
        vertical: 0
      };
      var position = [positionTable[layout].x + rect.x, positionTable[layout].y + rect.y];
      var rotation = rotationTable[layout];
      var transform = matrix.create();
      matrix.rotate(transform, transform, rotation);
      matrix.translate(transform, transform, position); // TODO
      // tick等排布信息。
      // TODO
      // 根据axis order 更新 dimensions顺序。

      this._axesLayout[dim] = {
        position: position,
        rotation: rotation,
        transform: transform,
        axisNameAvailableWidth: posInfo.axisNameAvailableWidth,
        axisLabelShow: posInfo.axisLabelShow,
        nameTruncateMaxWidth: posInfo.nameTruncateMaxWidth,
        tickDirection: 1,
        labelDirection: 1
      };
    }, this);
  },

  /**
   * Get axis by dim.
   * @param {string} dim
   * @return {module:echarts/coord/parallel/ParallelAxis} [description]
   */
  getAxis: function (dim) {
    return this._axesMap.get(dim);
  },

  /**
   * Convert a dim value of a single item of series data to Point.
   * @param {*} value
   * @param {string} dim
   * @return {Array}
   */
  dataToPoint: function (value, dim) {
    return this.axisCoordToPoint(this._axesMap.get(dim).dataToCoord(value), dim);
  },

  /**
   * Travel data for one time, get activeState of each data item.
   * @param {module:echarts/data/List} data
   * @param {Functio} cb param: {string} activeState 'active' or 'inactive' or 'normal'
   *                            {number} dataIndex
   * @param {number} [start=0] the start dataIndex that travel from.
   * @param {number} [end=data.count()] the next dataIndex of the last dataIndex will be travel.
   */
  eachActiveState: function (data, callback, start, end) {
    start == null && (start = 0);
    end == null && (end = data.count());
    var axesMap = this._axesMap;
    var dimensions = this.dimensions;
    var dataDimensions = [];
    var axisModels = [];
    zrUtil.each(dimensions, function (axisDim) {
      dataDimensions.push(data.mapDimension(axisDim));
      axisModels.push(axesMap.get(axisDim).model);
    });
    var hasActiveSet = this.hasAxisBrushed();

    for (var dataIndex = start; dataIndex < end; dataIndex++) {
      var activeState;

      if (!hasActiveSet) {
        activeState = 'normal';
      } else {
        activeState = 'active';
        var values = data.getValues(dataDimensions, dataIndex);

        for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
          var state = axisModels[j].getActiveState(values[j]);

          if (state === 'inactive') {
            activeState = 'inactive';
            break;
          }
        }
      }

      callback(activeState, dataIndex);
    }
  },

  /**
   * Whether has any activeSet.
   * @return {boolean}
   */
  hasAxisBrushed: function () {
    var dimensions = this.dimensions;
    var axesMap = this._axesMap;
    var hasActiveSet = false;

    for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
      if (axesMap.get(dimensions[j]).model.getActiveState() !== 'normal') {
        hasActiveSet = true;
      }
    }

    return hasActiveSet;
  },

  /**
   * Convert coords of each axis to Point.
   *  Return point. For example: [10, 20]
   * @param {Array.<number>} coords
   * @param {string} dim
   * @return {Array.<number>}
   */
  axisCoordToPoint: function (coord, dim) {
    var axisLayout = this._axesLayout[dim];
    return graphic.applyTransform([coord, 0], axisLayout.transform);
  },

  /**
   * Get axis layout.
   */
  getAxisLayout: function (dim) {
    return zrUtil.clone(this._axesLayout[dim]);
  },

  /**
   * @param {Array.<number>} point
   * @return {Object} {axisExpandWindow, delta, behavior: 'jump' | 'slide' | 'none'}.
   */
  getSlidedAxisExpandWindow: function (point) {
    var layoutInfo = this._makeLayoutInfo();

    var pixelDimIndex = layoutInfo.pixelDimIndex;
    var axisExpandWindow = layoutInfo.axisExpandWindow.slice();
    var winSize = axisExpandWindow[1] - axisExpandWindow[0];
    var extent = [0, layoutInfo.axisExpandWidth * (layoutInfo.axisCount - 1)]; // Out of the area of coordinate system.

    if (!this.containPoint(point)) {
      return {
        behavior: 'none',
        axisExpandWindow: axisExpandWindow
      };
    } // Conver the point from global to expand coordinates.


    var pointCoord = point[pixelDimIndex] - layoutInfo.layoutBase - layoutInfo.axisExpandWindow0Pos; // For dragging operation convenience, the window should not be
    // slided when mouse is the center area of the window.

    var delta;
    var behavior = 'slide';
    var axisCollapseWidth = layoutInfo.axisCollapseWidth;

    var triggerArea = this._model.get('axisExpandSlideTriggerArea'); // But consider touch device, jump is necessary.


    var useJump = triggerArea[0] != null;

    if (axisCollapseWidth) {
      if (useJump && axisCollapseWidth && pointCoord < winSize * triggerArea[0]) {
        behavior = 'jump';
        delta = pointCoord - winSize * triggerArea[2];
      } else if (useJump && axisCollapseWidth && pointCoord > winSize * (1 - triggerArea[0])) {
        behavior = 'jump';
        delta = pointCoord - winSize * (1 - triggerArea[2]);
      } else {
        (delta = pointCoord - winSize * triggerArea[1]) >= 0 && (delta = pointCoord - winSize * (1 - triggerArea[1])) <= 0 && (delta = 0);
      }

      delta *= layoutInfo.axisExpandWidth / axisCollapseWidth;
      delta ? sliderMove(delta, axisExpandWindow, extent, 'all') // Avoid nonsense triger on mousemove.
      : behavior = 'none';
    } // When screen is too narrow, make it visible and slidable, although it is hard to interact.
    else {
        var winSize = axisExpandWindow[1] - axisExpandWindow[0];
        var pos = extent[1] * pointCoord / winSize;
        axisExpandWindow = [mathMax(0, pos - winSize / 2)];
        axisExpandWindow[1] = mathMin(extent[1], axisExpandWindow[0] + winSize);
        axisExpandWindow[0] = axisExpandWindow[1] - winSize;
      }

    return {
      axisExpandWindow: axisExpandWindow,
      behavior: behavior
    };
  }
};

function restrict(len, extent) {
  return mathMin(mathMax(len, extent[0]), extent[1]);
}

function layoutAxisWithoutExpand(axisIndex, layoutInfo) {
  var step = layoutInfo.layoutLength / (layoutInfo.axisCount - 1);
  return {
    position: step * axisIndex,
    axisNameAvailableWidth: step,
    axisLabelShow: true
  };
}

function layoutAxisWithExpand(axisIndex, layoutInfo) {
  var layoutLength = layoutInfo.layoutLength;
  var axisExpandWidth = layoutInfo.axisExpandWidth;
  var axisCount = layoutInfo.axisCount;
  var axisCollapseWidth = layoutInfo.axisCollapseWidth;
  var winInnerIndices = layoutInfo.winInnerIndices;
  var position;
  var axisNameAvailableWidth = axisCollapseWidth;
  var axisLabelShow = false;
  var nameTruncateMaxWidth;

  if (axisIndex < winInnerIndices[0]) {
    position = axisIndex * axisCollapseWidth;
    nameTruncateMaxWidth = axisCollapseWidth;
  } else if (axisIndex <= winInnerIndices[1]) {
    position = layoutInfo.axisExpandWindow0Pos + axisIndex * axisExpandWidth - layoutInfo.axisExpandWindow[0];
    axisNameAvailableWidth = axisExpandWidth;
    axisLabelShow = true;
  } else {
    position = layoutLength - (axisCount - 1 - axisIndex) * axisCollapseWidth;
    nameTruncateMaxWidth = axisCollapseWidth;
  }

  return {
    position: position,
    axisNameAvailableWidth: axisNameAvailableWidth,
    axisLabelShow: axisLabelShow,
    nameTruncateMaxWidth: nameTruncateMaxWidth
  };
}

var _default = Parallel;
module.exports = _default;

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var Axis = __webpack_require__(150);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @constructor module:echarts/coord/parallel/ParallelAxis
 * @extends {module:echarts/coord/Axis}
 * @param {string} dim
 * @param {*} scale
 * @param {Array.<number>} coordExtent
 * @param {string} axisType
 */
var ParallelAxis = function (dim, scale, coordExtent, axisType, axisIndex) {
  Axis.call(this, dim, scale, coordExtent);
  /**
   * Axis type
   *  - 'category'
   *  - 'value'
   *  - 'time'
   *  - 'log'
   * @type {string}
   */

  this.type = axisType || 'value';
  /**
   * @type {number}
   * @readOnly
   */

  this.axisIndex = axisIndex;
};

ParallelAxis.prototype = {
  constructor: ParallelAxis,

  /**
   * Axis model
   * @param {module:echarts/coord/parallel/AxisModel}
   */
  model: null,

  /**
   * @override
   */
  isHorizontal: function () {
    return this.coordinateSystem.getModel().get('layout') !== 'horizontal';
  }
};
zrUtil.inherits(ParallelAxis, Axis);
var _default = ParallelAxis;
module.exports = _default;

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var Component = __webpack_require__(73);

__webpack_require__(1663);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = Component.extend({
  type: 'parallel',
  dependencies: ['parallelAxis'],

  /**
   * @type {module:echarts/coord/parallel/Parallel}
   */
  coordinateSystem: null,

  /**
   * Each item like: 'dim0', 'dim1', 'dim2', ...
   * @type {Array.<string>}
   * @readOnly
   */
  dimensions: null,

  /**
   * Coresponding to dimensions.
   * @type {Array.<number>}
   * @readOnly
   */
  parallelAxisIndex: null,
  layoutMode: 'box',
  defaultOption: {
    zlevel: 0,
    z: 0,
    left: 80,
    top: 60,
    right: 80,
    bottom: 60,
    // width: {totalWidth} - left - right,
    // height: {totalHeight} - top - bottom,
    layout: 'horizontal',
    // 'horizontal' or 'vertical'
    // FIXME
    // naming?
    axisExpandable: false,
    axisExpandCenter: null,
    axisExpandCount: 0,
    axisExpandWidth: 50,
    // FIXME '10%' ?
    axisExpandRate: 17,
    axisExpandDebounce: 50,
    // [out, in, jumpTarget]. In percentage. If use [null, 0.05], null means full.
    // Do not doc to user until necessary.
    axisExpandSlideTriggerArea: [-0.15, 0.05, 0.4],
    axisExpandTriggerOn: 'click',
    // 'mousemove' or 'click'
    parallelAxisDefault: null
  },

  /**
   * @override
   */
  init: function () {
    Component.prototype.init.apply(this, arguments);
    this.mergeOption({});
  },

  /**
   * @override
   */
  mergeOption: function (newOption) {
    var thisOption = this.option;
    newOption && zrUtil.merge(thisOption, newOption, true);

    this._initDimensions();
  },

  /**
   * Whether series or axis is in this coordinate system.
   * @param {module:echarts/model/Series|module:echarts/coord/parallel/AxisModel} model
   * @param {module:echarts/model/Global} ecModel
   */
  contains: function (model, ecModel) {
    var parallelIndex = model.get('parallelIndex');
    return parallelIndex != null && ecModel.getComponent('parallel', parallelIndex) === this;
  },
  setAxisExpand: function (opt) {
    zrUtil.each(['axisExpandable', 'axisExpandCenter', 'axisExpandCount', 'axisExpandWidth', 'axisExpandWindow'], function (name) {
      if (opt.hasOwnProperty(name)) {
        this.option[name] = opt[name];
      }
    }, this);
  },

  /**
   * @private
   */
  _initDimensions: function () {
    var dimensions = this.dimensions = [];
    var parallelAxisIndex = this.parallelAxisIndex = [];
    var axisModels = zrUtil.filter(this.dependentModels.parallelAxis, function (axisModel) {
      // Can not use this.contains here, because
      // initialization has not been completed yet.
      return (axisModel.get('parallelIndex') || 0) === this.componentIndex;
    }, this);
    zrUtil.each(axisModels, function (axisModel) {
      dimensions.push('dim' + axisModel.get('dim'));
      parallelAxisIndex.push(axisModel.componentIndex);
    });
  }
});

module.exports = _default;

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var ComponentModel = __webpack_require__(73);

var makeStyleMapper = __webpack_require__(204);

var axisModelCreator = __webpack_require__(302);

var numberUtil = __webpack_require__(37);

var axisModelCommonMixin = __webpack_require__(208);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var AxisModel = ComponentModel.extend({
  type: 'baseParallelAxis',

  /**
   * @type {module:echarts/coord/parallel/Axis}
   */
  axis: null,

  /**
   * @type {Array.<Array.<number>}
   * @readOnly
   */
  activeIntervals: [],

  /**
   * @return {Object}
   */
  getAreaSelectStyle: function () {
    return makeStyleMapper([['fill', 'color'], ['lineWidth', 'borderWidth'], ['stroke', 'borderColor'], ['width', 'width'], ['opacity', 'opacity']])(this.getModel('areaSelectStyle'));
  },

  /**
   * The code of this feature is put on AxisModel but not ParallelAxis,
   * because axisModel can be alive after echarts updating but instance of
   * ParallelAxis having been disposed. this._activeInterval should be kept
   * when action dispatched (i.e. legend click).
   *
   * @param {Array.<Array<number>>} intervals interval.length === 0
   *                                          means set all active.
   * @public
   */
  setActiveIntervals: function (intervals) {
    var activeIntervals = this.activeIntervals = zrUtil.clone(intervals); // Normalize

    if (activeIntervals) {
      for (var i = activeIntervals.length - 1; i >= 0; i--) {
        numberUtil.asc(activeIntervals[i]);
      }
    }
  },

  /**
   * @param {number|string} [value] When attempting to detect 'no activeIntervals set',
   *                         value can not be input.
   * @return {string} 'normal': no activeIntervals set,
   *                  'active',
   *                  'inactive'.
   * @public
   */
  getActiveState: function (value) {
    var activeIntervals = this.activeIntervals;

    if (!activeIntervals.length) {
      return 'normal';
    }

    if (value == null || isNaN(value)) {
      return 'inactive';
    } // Simple optimization


    if (activeIntervals.length === 1) {
      var interval = activeIntervals[0];

      if (interval[0] <= value && value <= interval[1]) {
        return 'active';
      }
    } else {
      for (var i = 0, len = activeIntervals.length; i < len; i++) {
        if (activeIntervals[i][0] <= value && value <= activeIntervals[i][1]) {
          return 'active';
        }
      }
    }

    return 'inactive';
  }
});
var defaultOption = {
  type: 'value',

  /**
   * @type {Array.<number>}
   */
  dim: null,
  // 0, 1, 2, ...
  // parallelIndex: null,
  areaSelectStyle: {
    width: 20,
    borderWidth: 1,
    borderColor: 'rgba(160,197,232)',
    color: 'rgba(160,197,232)',
    opacity: 0.3
  },
  realtime: true,
  // Whether realtime update view when select.
  z: 10
};
zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);

function getAxisType(axisName, option) {
  return option.type || (option.data ? 'category' : 'value');
}

axisModelCreator('parallel', AxisModel, getAxisType, defaultOption);
var _default = AxisModel;
module.exports = _default;

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

__webpack_require__(667);

__webpack_require__(1665);

__webpack_require__(1666);

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @payload
 * @property {string} parallelAxisId
 * @property {Array.<Array.<number>>} intervals
 */
var actionInfo = {
  type: 'axisAreaSelect',
  event: 'axisAreaSelected' // update: 'updateVisual'

};
echarts.registerAction(actionInfo, function (payload, ecModel) {
  ecModel.eachComponent({
    mainType: 'parallelAxis',
    query: payload
  }, function (parallelAxisModel) {
    parallelAxisModel.axis.model.setActiveIntervals(payload.intervals);
  });
});
/**
 * @payload
 */

echarts.registerAction('parallelAxisExpand', function (payload, ecModel) {
  ecModel.eachComponent({
    mainType: 'parallel',
    query: payload
  }, function (parallelModel) {
    parallelModel.setAxisExpand(payload);
  });
});

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var AxisBuilder = __webpack_require__(151);

var BrushController = __webpack_require__(425);

var brushHelper = __webpack_require__(668);

var graphic = __webpack_require__(27);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var elementList = ['axisLine', 'axisTickLabel', 'axisName'];
var AxisView = echarts.extendComponentView({
  type: 'parallelAxis',

  /**
   * @override
   */
  init: function (ecModel, api) {
    AxisView.superApply(this, 'init', arguments);
    /**
     * @type {module:echarts/component/helper/BrushController}
     */

    (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this));
  },

  /**
   * @override
   */
  render: function (axisModel, ecModel, api, payload) {
    if (fromAxisAreaSelect(axisModel, ecModel, payload)) {
      return;
    }

    this.axisModel = axisModel;
    this.api = api;
    this.group.removeAll();
    var oldAxisGroup = this._axisGroup;
    this._axisGroup = new graphic.Group();
    this.group.add(this._axisGroup);

    if (!axisModel.get('show')) {
      return;
    }

    var coordSysModel = getCoordSysModel(axisModel, ecModel);
    var coordSys = coordSysModel.coordinateSystem;
    var areaSelectStyle = axisModel.getAreaSelectStyle();
    var areaWidth = areaSelectStyle.width;
    var dim = axisModel.axis.dim;
    var axisLayout = coordSys.getAxisLayout(dim);
    var builderOpt = zrUtil.extend({
      strokeContainThreshold: areaWidth
    }, axisLayout);
    var axisBuilder = new AxisBuilder(axisModel, builderOpt);
    zrUtil.each(elementList, axisBuilder.add, axisBuilder);

    this._axisGroup.add(axisBuilder.getGroup());

    this._refreshBrushController(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api);

    var animationModel = payload && payload.animation === false ? null : axisModel;
    graphic.groupTransition(oldAxisGroup, this._axisGroup, animationModel);
  },
  // /**
  //  * @override
  //  */
  // updateVisual: function (axisModel, ecModel, api, payload) {
  //     this._brushController && this._brushController
  //         .updateCovers(getCoverInfoList(axisModel));
  // },
  _refreshBrushController: function (builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api) {
    // After filtering, axis may change, select area needs to be update.
    var extent = axisModel.axis.getExtent();
    var extentLen = extent[1] - extent[0];
    var extra = Math.min(30, Math.abs(extentLen) * 0.1); // Arbitrary value.
    // width/height might be negative, which will be
    // normalized in BoundingRect.

    var rect = graphic.BoundingRect.create({
      x: extent[0],
      y: -areaWidth / 2,
      width: extentLen,
      height: areaWidth
    });
    rect.x -= extra;
    rect.width += 2 * extra;

    this._brushController.mount({
      enableGlobalPan: true,
      rotation: builderOpt.rotation,
      position: builderOpt.position
    }).setPanels([{
      panelId: 'pl',
      clipPath: brushHelper.makeRectPanelClipPath(rect),
      isTargetByCursor: brushHelper.makeRectIsTargetByCursor(rect, api, coordSysModel),
      getLinearBrushOtherExtent: brushHelper.makeLinearBrushOtherExtent(rect, 0)
    }]).enableBrush({
      brushType: 'lineX',
      brushStyle: areaSelectStyle,
      removeOnClick: true
    }).updateCovers(getCoverInfoList(axisModel));
  },
  _onBrush: function (coverInfoList, opt) {
    // Do not cache these object, because the mey be changed.
    var axisModel = this.axisModel;
    var axis = axisModel.axis;
    var intervals = zrUtil.map(coverInfoList, function (coverInfo) {
      return [axis.coordToData(coverInfo.range[0], true), axis.coordToData(coverInfo.range[1], true)];
    }); // If realtime is true, action is not dispatched on drag end, because
    // the drag end emits the same params with the last drag move event,
    // and may have some delay when using touch pad.

    if (!axisModel.option.realtime === opt.isEnd || opt.removeOnClick) {
      // jshint ignore:line
      this.api.dispatchAction({
        type: 'axisAreaSelect',
        parallelAxisId: axisModel.id,
        intervals: intervals
      });
    }
  },

  /**
   * @override
   */
  dispose: function () {
    this._brushController.dispose();
  }
});

function fromAxisAreaSelect(axisModel, ecModel, payload) {
  return payload && payload.type === 'axisAreaSelect' && ecModel.findComponents({
    mainType: 'parallelAxis',
    query: payload
  })[0] === axisModel;
}

function getCoverInfoList(axisModel) {
  var axis = axisModel.axis;
  return zrUtil.map(axisModel.activeIntervals, function (interval) {
    return {
      brushType: 'lineX',
      panelId: 'pl',
      range: [axis.dataToCoord(interval[0], true), axis.dataToCoord(interval[1], true)]
    };
  });
}

function getCoordSysModel(axisModel, ecModel) {
  return ecModel.getComponent('parallel', axisModel.get('parallelIndex'));
}

var _default = AxisView;
module.exports = _default;

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(1);

var each = _util.each;
var createHashMap = _util.createHashMap;

var SeriesModel = __webpack_require__(74);

var createListFromArray = __webpack_require__(137);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = SeriesModel.extend({
  type: 'series.parallel',
  dependencies: ['parallel'],
  visualColorAccessPath: 'lineStyle.color',
  getInitialData: function (option, ecModel) {
    var source = this.getSource();
    setEncodeAndDimensions(source, this);
    return createListFromArray(source, this);
  },

  /**
   * User can get data raw indices on 'axisAreaSelected' event received.
   *
   * @public
   * @param {string} activeState 'active' or 'inactive' or 'normal'
   * @return {Array.<number>} Raw indices
   */
  getRawIndicesByActiveState: function (activeState) {
    var coordSys = this.coordinateSystem;
    var data = this.getData();
    var indices = [];
    coordSys.eachActiveState(data, function (theActiveState, dataIndex) {
      if (activeState === theActiveState) {
        indices.push(data.getRawIndex(dataIndex));
      }
    });
    return indices;
  },
  defaultOption: {
    zlevel: 0,
    // 一级层叠
    z: 2,
    // 二级层叠
    coordinateSystem: 'parallel',
    parallelIndex: 0,
    label: {
      show: false
    },
    inactiveOpacity: 0.05,
    activeOpacity: 1,
    lineStyle: {
      width: 1,
      opacity: 0.45,
      type: 'solid'
    },
    emphasis: {
      label: {
        show: false
      }
    },
    progressive: 500,
    smooth: false,
    // true | false | number
    animationEasing: 'linear'
  }
});

function setEncodeAndDimensions(source, seriesModel) {
  // The mapping of parallelAxis dimension to data dimension can
  // be specified in parallelAxis.option.dim. For example, if
  // parallelAxis.option.dim is 'dim3', it mapping to the third
  // dimension of data. But `data.encode` has higher priority.
  // Moreover, parallelModel.dimension should not be regarded as data
  // dimensions. Consider dimensions = ['dim4', 'dim2', 'dim6'];
  if (source.encodeDefine) {
    return;
  }

  var parallelModel = seriesModel.ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));

  if (!parallelModel) {
    return;
  }

  var encodeDefine = source.encodeDefine = createHashMap();
  each(parallelModel.dimensions, function (axisDim) {
    var dataDimIndex = convertDimNameToNumber(axisDim);
    encodeDefine.set(axisDim, dataDimIndex);
  });
}

function convertDimNameToNumber(dimName) {
  return +dimName.replace('dim', '');
}

module.exports = _default;

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var graphic = __webpack_require__(27);

var ChartView = __webpack_require__(123);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var DEFAULT_SMOOTH = 0.3;
var ParallelView = ChartView.extend({
  type: 'parallel',
  init: function () {
    /**
     * @type {module:zrender/container/Group}
     * @private
     */
    this._dataGroup = new graphic.Group();
    this.group.add(this._dataGroup);
    /**
     * @type {module:echarts/data/List}
     */

    this._data;
    /**
     * @type {boolean}
     */

    this._initialized;
  },

  /**
   * @override
   */
  render: function (seriesModel, ecModel, api, payload) {
    var dataGroup = this._dataGroup;
    var data = seriesModel.getData();
    var oldData = this._data;
    var coordSys = seriesModel.coordinateSystem;
    var dimensions = coordSys.dimensions;
    var seriesScope = makeSeriesScope(seriesModel);
    data.diff(oldData).add(add).update(update).remove(remove).execute();

    function add(newDataIndex) {
      var line = addEl(data, dataGroup, newDataIndex, dimensions, coordSys);
      updateElCommon(line, data, newDataIndex, seriesScope);
    }

    function update(newDataIndex, oldDataIndex) {
      var line = oldData.getItemGraphicEl(oldDataIndex);
      var points = createLinePoints(data, newDataIndex, dimensions, coordSys);
      data.setItemGraphicEl(newDataIndex, line);
      var animationModel = payload && payload.animation === false ? null : seriesModel;
      graphic.updateProps(line, {
        shape: {
          points: points
        }
      }, animationModel, newDataIndex);
      updateElCommon(line, data, newDataIndex, seriesScope);
    }

    function remove(oldDataIndex) {
      var line = oldData.getItemGraphicEl(oldDataIndex);
      dataGroup.remove(line);
    } // First create


    if (!this._initialized) {
      this._initialized = true;
      var clipPath = createGridClipShape(coordSys, seriesModel, function () {
        // Callback will be invoked immediately if there is no animation
        setTimeout(function () {
          dataGroup.removeClipPath();
        });
      });
      dataGroup.setClipPath(clipPath);
    }

    this._data = data;
  },
  incrementalPrepareRender: function (seriesModel, ecModel, api) {
    this._initialized = true;
    this._data = null;

    this._dataGroup.removeAll();
  },
  incrementalRender: function (taskParams, seriesModel, ecModel) {
    var data = seriesModel.getData();
    var coordSys = seriesModel.coordinateSystem;
    var dimensions = coordSys.dimensions;
    var seriesScope = makeSeriesScope(seriesModel);

    for (var dataIndex = taskParams.start; dataIndex < taskParams.end; dataIndex++) {
      var line = addEl(data, this._dataGroup, dataIndex, dimensions, coordSys);
      line.incremental = true;
      updateElCommon(line, data, dataIndex, seriesScope);
    }
  },
  dispose: function () {},
  // _renderForProgressive: function (seriesModel) {
  //     var dataGroup = this._dataGroup;
  //     var data = seriesModel.getData();
  //     var oldData = this._data;
  //     var coordSys = seriesModel.coordinateSystem;
  //     var dimensions = coordSys.dimensions;
  //     var option = seriesModel.option;
  //     var progressive = option.progressive;
  //     var smooth = option.smooth ? SMOOTH : null;
  //     // In progressive animation is disabled, so use simple data diff,
  //     // which effects performance less.
  //     // (Typically performance for data with length 7000+ like:
  //     // simpleDiff: 60ms, addEl: 184ms,
  //     // in RMBP 2.4GHz intel i7, OSX 10.9 chrome 50.0.2661.102 (64-bit))
  //     if (simpleDiff(oldData, data, dimensions)) {
  //         dataGroup.removeAll();
  //         data.each(function (dataIndex) {
  //             addEl(data, dataGroup, dataIndex, dimensions, coordSys);
  //         });
  //     }
  //     updateElCommon(data, progressive, smooth);
  //     // Consider switch between progressive and not.
  //     data.__plProgressive = true;
  //     this._data = data;
  // },

  /**
   * @override
   */
  remove: function () {
    this._dataGroup && this._dataGroup.removeAll();
    this._data = null;
  }
});

function createGridClipShape(coordSys, seriesModel, cb) {
  var parallelModel = coordSys.model;
  var rect = coordSys.getRect();
  var rectEl = new graphic.Rect({
    shape: {
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    }
  });
  var dim = parallelModel.get('layout') === 'horizontal' ? 'width' : 'height';
  rectEl.setShape(dim, 0);
  graphic.initProps(rectEl, {
    shape: {
      width: rect.width,
      height: rect.height
    }
  }, seriesModel, cb);
  return rectEl;
}

function createLinePoints(data, dataIndex, dimensions, coordSys) {
  var points = [];

  for (var i = 0; i < dimensions.length; i++) {
    var dimName = dimensions[i];
    var value = data.get(data.mapDimension(dimName), dataIndex);

    if (!isEmptyValue(value, coordSys.getAxis(dimName).type)) {
      points.push(coordSys.dataToPoint(value, dimName));
    }
  }

  return points;
}

function addEl(data, dataGroup, dataIndex, dimensions, coordSys) {
  var points = createLinePoints(data, dataIndex, dimensions, coordSys);
  var line = new graphic.Polyline({
    shape: {
      points: points
    },
    silent: true,
    z2: 10
  });
  dataGroup.add(line);
  data.setItemGraphicEl(dataIndex, line);
  return line;
}

function makeSeriesScope(seriesModel) {
  var smooth = seriesModel.get('smooth', true);
  smooth === true && (smooth = DEFAULT_SMOOTH);
  return {
    lineStyle: seriesModel.getModel('lineStyle').getLineStyle(),
    smooth: smooth != null ? smooth : DEFAULT_SMOOTH
  };
}

function updateElCommon(el, data, dataIndex, seriesScope) {
  var lineStyle = seriesScope.lineStyle;

  if (data.hasItemOption) {
    var lineStyleModel = data.getItemModel(dataIndex).getModel('lineStyle');
    lineStyle = lineStyleModel.getLineStyle();
  }

  el.useStyle(lineStyle);
  var elStyle = el.style;
  elStyle.fill = null; // lineStyle.color have been set to itemVisual in module:echarts/visual/seriesColor.

  elStyle.stroke = data.getItemVisual(dataIndex, 'color'); // lineStyle.opacity have been set to itemVisual in parallelVisual.

  elStyle.opacity = data.getItemVisual(dataIndex, 'opacity');
  seriesScope.smooth && (el.shape.smooth = seriesScope.smooth);
} // function simpleDiff(oldData, newData, dimensions) {
//     var oldLen;
//     if (!oldData
//         || !oldData.__plProgressive
//         || (oldLen = oldData.count()) !== newData.count()
//     ) {
//         return true;
//     }
//     var dimLen = dimensions.length;
//     for (var i = 0; i < oldLen; i++) {
//         for (var j = 0; j < dimLen; j++) {
//             if (oldData.get(dimensions[j], i) !== newData.get(dimensions[j], i)) {
//                 return true;
//             }
//         }
//     }
//     return false;
// }
// FIXME
// 公用方法?


function isEmptyValue(val, axisType) {
  return axisType === 'category' ? val == null : val == null || isNaN(val); // axisType === 'value'
}

var _default = ParallelView;
module.exports = _default;

/***/ }),
/* 1669 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var opacityAccessPath = ['lineStyle', 'normal', 'opacity'];
var _default = {
  seriesType: 'parallel',
  reset: function (seriesModel, ecModel, api) {
    var itemStyleModel = seriesModel.getModel('itemStyle');
    var lineStyleModel = seriesModel.getModel('lineStyle');
    var globalColors = ecModel.get('color');
    var color = lineStyleModel.get('color') || itemStyleModel.get('color') || globalColors[seriesModel.seriesIndex % globalColors.length];
    var inactiveOpacity = seriesModel.get('inactiveOpacity');
    var activeOpacity = seriesModel.get('activeOpacity');
    var lineStyle = seriesModel.getModel('lineStyle').getLineStyle();
    var coordSys = seriesModel.coordinateSystem;
    var data = seriesModel.getData();
    var opacityMap = {
      normal: lineStyle.opacity,
      active: activeOpacity,
      inactive: inactiveOpacity
    };
    data.setVisual('color', color);

    function progress(params, data) {
      coordSys.eachActiveState(data, function (activeState, dataIndex) {
        var opacity = opacityMap[activeState];

        if (activeState === 'normal' && data.hasItemOption) {
          var itemOpacity = data.getItemModel(dataIndex).get(opacityAccessPath, true);
          itemOpacity != null && (opacity = itemOpacity);
        }

        data.setItemVisual(dataIndex, 'opacity', opacity);
      }, params.start, params.end);
    }

    return {
      progress: progress
    };
  }
};
module.exports = _default;

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(1671);

__webpack_require__(1672);

__webpack_require__(1673);

var sankeyLayout = __webpack_require__(1674);

var sankeyVisual = __webpack_require__(1675);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.registerLayout(sankeyLayout);
echarts.registerVisual(sankeyVisual);

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var SeriesModel = __webpack_require__(74);

var createGraphFromNodeEdge = __webpack_require__(662);

var _format = __webpack_require__(54);

var encodeHTML = _format.encodeHTML;

var Model = __webpack_require__(68);

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var SankeySeries = SeriesModel.extend({
  type: 'series.sankey',
  layoutInfo: null,
  levelModels: null,

  /**
   * Init a graph data structure from data in option series
   *
   * @param  {Object} option  the object used to config echarts view
   * @return {module:echarts/data/List} storage initial data
   */
  getInitialData: function (option, ecModel) {
    var links = option.edges || option.links;
    var nodes = option.data || option.nodes;
    var levels = option.levels;
    var levelModels = this.levelModels = {};

    for (var i = 0; i < levels.length; i++) {
      if (levels[i].depth != null && levels[i].depth >= 0) {
        levelModels[levels[i].depth] = new Model(levels[i], this, ecModel);
      } else {}
    }

    if (nodes && links) {
      var graph = createGraphFromNodeEdge(nodes, links, this, true, beforeLink);
      return graph.data;
    }

    function beforeLink(nodeData, edgeData) {
      nodeData.wrapMethod('getItemModel', function (model, idx) {
        model.customizeGetParent(function (path) {
          var parentModel = this.parentModel;
          var nodeDepth = parentModel.getData().getItemLayout(idx).depth;
          var levelModel = parentModel.levelModels[nodeDepth];
          return levelModel || this.parentModel;
        });
        return model;
      });
      edgeData.wrapMethod('getItemModel', function (model, idx) {
        model.customizeGetParent(function (path) {
          var parentModel = this.parentModel;
          var edge = parentModel.getGraph().getEdgeByIndex(idx);
          var depth = edge.node1.getLayout().depth;
          var levelModel = parentModel.levelModels[depth];
          return levelModel || this.parentModel;
        });
        return model;
      });
    }
  },
  setNodePosition: function (dataIndex, localPosition) {
    var dataItem = this.option.data[dataIndex];
    dataItem.localX = localPosition[0];
    dataItem.localY = localPosition[1];
  },

  /**
   * Return the graphic data structure
   *
   * @return {module:echarts/data/Graph} graphic data structure
   */
  getGraph: function () {
    return this.getData().graph;
  },

  /**
   * Get edge data of graphic data structure
   *
   * @return {module:echarts/data/List} data structure of list
   */
  getEdgeData: function () {
    return this.getGraph().edgeData;
  },

  /**
   * @override
   */
  formatTooltip: function (dataIndex, multipleSeries, dataType) {
    // dataType === 'node' or empty do not show tooltip by default
    if (dataType === 'edge') {
      var params = this.getDataParams(dataIndex, dataType);
      var rawDataOpt = params.data;
      var html = rawDataOpt.source + ' -- ' + rawDataOpt.target;

      if (params.value) {
        html += ' : ' + params.value;
      }

      return encodeHTML(html);
    } else if (dataType === 'node') {
      var node = this.getGraph().getNodeByIndex(dataIndex);
      var value = node.getLayout().value;
      var name = this.getDataParams(dataIndex, dataType).data.name;

      if (value) {
        var html = name + ' : ' + value;
      }

      return encodeHTML(html);
    }

    return SankeySeries.superCall(this, 'formatTooltip', dataIndex, multipleSeries);
  },
  optionUpdated: function () {
    var option = this.option;

    if (option.focusNodeAdjacency === true) {
      option.focusNodeAdjacency = 'allEdges';
    }
  },
  // Override Series.getDataParams()
  getDataParams: function (dataIndex, dataType) {
    var params = SankeySeries.superCall(this, 'getDataParams', dataIndex, dataType);

    if (params.value == null && dataType === 'node') {
      var node = this.getGraph().getNodeByIndex(dataIndex);
      var nodeValue = node.getLayout().value;
      params.value = nodeValue;
    }

    return params;
  },
  defaultOption: {
    zlevel: 0,
    z: 2,
    coordinateSystem: 'view',
    layout: null,
    // The position of the whole view
    left: '5%',
    top: '5%',
    right: '20%',
    bottom: '5%',
    // Value can be 'vertical'
    orient: 'horizontal',
    // The dx of the node
    nodeWidth: 20,
    // The vertical distance between two nodes
    nodeGap: 8,
    // Control if the node can move or not
    draggable: true,
    // Value can be 'inEdges', 'outEdges', 'allEdges', true (the same as 'allEdges').
    focusNodeAdjacency: false,
    // The number of iterations to change the position of the node
    layoutIterations: 32,
    label: {
      show: true,
      position: 'right',
      color: '#000',
      fontSize: 12
    },
    levels: [],
    // Value can be 'left' or 'right'
    nodeAlign: 'justify',
    itemStyle: {
      borderWidth: 1,
      borderColor: '#333'
    },
    lineStyle: {
      color: '#314656',
      opacity: 0.2,
      curveness: 0.5
    },
    emphasis: {
      label: {
        show: true
      },
      lineStyle: {
        opacity: 0.5
      }
    },
    animationEasing: 'linear',
    animationDuration: 1000
  }
});
var _default = SankeySeries;
module.exports = _default;

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var graphic = __webpack_require__(27);

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var nodeOpacityPath = ['itemStyle', 'opacity'];
var hoverNodeOpacityPath = ['emphasis', 'itemStyle', 'opacity'];
var lineOpacityPath = ['lineStyle', 'opacity'];
var hoverLineOpacityPath = ['emphasis', 'lineStyle', 'opacity'];

function getItemOpacity(item, opacityPath) {
  return item.getVisual('opacity') || item.getModel().get(opacityPath);
}

function fadeOutItem(item, opacityPath, opacityRatio) {
  var el = item.getGraphicEl();
  var opacity = getItemOpacity(item, opacityPath);

  if (opacityRatio != null) {
    opacity == null && (opacity = 1);
    opacity *= opacityRatio;
  }

  el.downplay && el.downplay();
  el.traverse(function (child) {
    if (child.type !== 'group') {
      child.setStyle('opacity', opacity);
    }
  });
}

function fadeInItem(item, opacityPath) {
  var opacity = getItemOpacity(item, opacityPath);
  var el = item.getGraphicEl();
  el.traverse(function (child) {
    if (child.type !== 'group') {
      child.setStyle('opacity', opacity);
    }
  }); // Support emphasis here.

  el.highlight && el.highlight();
}

var SankeyShape = graphic.extendShape({
  shape: {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0,
    cpx1: 0,
    cpy1: 0,
    cpx2: 0,
    cpy2: 0,
    extent: 0,
    orient: ''
  },
  buildPath: function (ctx, shape) {
    var extent = shape.extent;
    ctx.moveTo(shape.x1, shape.y1);
    ctx.bezierCurveTo(shape.cpx1, shape.cpy1, shape.cpx2, shape.cpy2, shape.x2, shape.y2);

    if (shape.orient === 'vertical') {
      ctx.lineTo(shape.x2 + extent, shape.y2);
      ctx.bezierCurveTo(shape.cpx2 + extent, shape.cpy2, shape.cpx1 + extent, shape.cpy1, shape.x1 + extent, shape.y1);
    } else {
      ctx.lineTo(shape.x2, shape.y2 + extent);
      ctx.bezierCurveTo(shape.cpx2, shape.cpy2 + extent, shape.cpx1, shape.cpy1 + extent, shape.x1, shape.y1 + extent);
    }

    ctx.closePath();
  },
  highlight: function () {
    this.trigger('emphasis');
  },
  downplay: function () {
    this.trigger('normal');
  }
});

var _default = echarts.extendChartView({
  type: 'sankey',

  /**
   * @private
   * @type {module:echarts/chart/sankey/SankeySeries}
   */
  _model: null,

  /**
   * @private
   * @type {boolean}
   */
  _focusAdjacencyDisabled: false,
  render: function (seriesModel, ecModel, api) {
    var sankeyView = this;
    var graph = seriesModel.getGraph();
    var group = this.group;
    var layoutInfo = seriesModel.layoutInfo; // view width

    var width = layoutInfo.width; // view height

    var height = layoutInfo.height;
    var nodeData = seriesModel.getData();
    var edgeData = seriesModel.getData('edge');
    var orient = seriesModel.get('orient');
    this._model = seriesModel;
    group.removeAll();
    group.attr('position', [layoutInfo.x, layoutInfo.y]); // generate a bezire Curve for each edge

    graph.eachEdge(function (edge) {
      var curve = new SankeyShape();
      curve.dataIndex = edge.dataIndex;
      curve.seriesIndex = seriesModel.seriesIndex;
      curve.dataType = 'edge';
      var lineStyleModel = edge.getModel('lineStyle');
      var curvature = lineStyleModel.get('curveness');
      var n1Layout = edge.node1.getLayout();
      var node1Model = edge.node1.getModel();
      var dragX1 = node1Model.get('localX');
      var dragY1 = node1Model.get('localY');
      var n2Layout = edge.node2.getLayout();
      var node2Model = edge.node2.getModel();
      var dragX2 = node2Model.get('localX');
      var dragY2 = node2Model.get('localY');
      var edgeLayout = edge.getLayout();
      var x1;
      var y1;
      var x2;
      var y2;
      var cpx1;
      var cpy1;
      var cpx2;
      var cpy2;
      curve.shape.extent = Math.max(1, edgeLayout.dy);
      curve.shape.orient = orient;

      if (orient === 'vertical') {
        x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + edgeLayout.sy;
        y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + n1Layout.dy;
        x2 = (dragX2 != null ? dragX2 * width : n2Layout.x) + edgeLayout.ty;
        y2 = dragY2 != null ? dragY2 * height : n2Layout.y;
        cpx1 = x1;
        cpy1 = y1 * (1 - curvature) + y2 * curvature;
        cpx2 = x2;
        cpy2 = y1 * curvature + y2 * (1 - curvature);
      } else {
        x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + n1Layout.dx;
        y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + edgeLayout.sy;
        x2 = dragX2 != null ? dragX2 * width : n2Layout.x;
        y2 = (dragY2 != null ? dragY2 * height : n2Layout.y) + edgeLayout.ty;
        cpx1 = x1 * (1 - curvature) + x2 * curvature;
        cpy1 = y1;
        cpx2 = x1 * curvature + x2 * (1 - curvature);
        cpy2 = y2;
      }

      curve.setShape({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        cpx1: cpx1,
        cpy1: cpy1,
        cpx2: cpx2,
        cpy2: cpy2
      });
      curve.setStyle(lineStyleModel.getItemStyle()); // Special color, use source node color or target node color

      switch (curve.style.fill) {
        case 'source':
          curve.style.fill = edge.node1.getVisual('color');
          break;

        case 'target':
          curve.style.fill = edge.node2.getVisual('color');
          break;
      }

      graphic.setHoverStyle(curve, edge.getModel('emphasis.lineStyle').getItemStyle());
      group.add(curve);
      edgeData.setItemGraphicEl(edge.dataIndex, curve);
    }); // Generate a rect for each node

    graph.eachNode(function (node) {
      var layout = node.getLayout();
      var itemModel = node.getModel();
      var dragX = itemModel.get('localX');
      var dragY = itemModel.get('localY');
      var labelModel = itemModel.getModel('label');
      var labelHoverModel = itemModel.getModel('emphasis.label');
      var rect = new graphic.Rect({
        shape: {
          x: dragX != null ? dragX * width : layout.x,
          y: dragY != null ? dragY * height : layout.y,
          width: layout.dx,
          height: layout.dy
        },
        style: itemModel.getModel('itemStyle').getItemStyle()
      });
      var hoverStyle = node.getModel('emphasis.itemStyle').getItemStyle();
      graphic.setLabelStyle(rect.style, hoverStyle, labelModel, labelHoverModel, {
        labelFetcher: seriesModel,
        labelDataIndex: node.dataIndex,
        defaultText: node.id,
        isRectText: true
      });
      rect.setStyle('fill', node.getVisual('color'));
      graphic.setHoverStyle(rect, hoverStyle);
      group.add(rect);
      nodeData.setItemGraphicEl(node.dataIndex, rect);
      rect.dataType = 'node';
    });
    nodeData.eachItemGraphicEl(function (el, dataIndex) {
      var itemModel = nodeData.getItemModel(dataIndex);

      if (itemModel.get('draggable')) {
        el.drift = function (dx, dy) {
          sankeyView._focusAdjacencyDisabled = true;
          this.shape.x += dx;
          this.shape.y += dy;
          this.dirty();
          api.dispatchAction({
            type: 'dragNode',
            seriesId: seriesModel.id,
            dataIndex: nodeData.getRawIndex(dataIndex),
            localX: this.shape.x / width,
            localY: this.shape.y / height
          });
        };

        el.ondragend = function () {
          sankeyView._focusAdjacencyDisabled = false;
        };

        el.draggable = true;
        el.cursor = 'move';
      }

      el.highlight = function () {
        this.trigger('emphasis');
      };

      el.downplay = function () {
        this.trigger('normal');
      };

      el.focusNodeAdjHandler && el.off('mouseover', el.focusNodeAdjHandler);
      el.unfocusNodeAdjHandler && el.off('mouseout', el.unfocusNodeAdjHandler);

      if (itemModel.get('focusNodeAdjacency')) {
        el.on('mouseover', el.focusNodeAdjHandler = function () {
          if (!sankeyView._focusAdjacencyDisabled) {
            sankeyView._clearTimer();

            api.dispatchAction({
              type: 'focusNodeAdjacency',
              seriesId: seriesModel.id,
              dataIndex: el.dataIndex
            });
          }
        });
        el.on('mouseout', el.unfocusNodeAdjHandler = function () {
          if (!sankeyView._focusAdjacencyDisabled) {
            sankeyView._dispatchUnfocus(api);
          }
        });
      }
    });
    edgeData.eachItemGraphicEl(function (el, dataIndex) {
      var edgeModel = edgeData.getItemModel(dataIndex);
      el.focusNodeAdjHandler && el.off('mouseover', el.focusNodeAdjHandler);
      el.unfocusNodeAdjHandler && el.off('mouseout', el.unfocusNodeAdjHandler);

      if (edgeModel.get('focusNodeAdjacency')) {
        el.on('mouseover', el.focusNodeAdjHandler = function () {
          if (!sankeyView._focusAdjacencyDisabled) {
            sankeyView._clearTimer();

            api.dispatchAction({
              type: 'focusNodeAdjacency',
              seriesId: seriesModel.id,
              edgeDataIndex: el.dataIndex
            });
          }
        });
        el.on('mouseout', el.unfocusNodeAdjHandler = function () {
          if (!sankeyView._focusAdjacencyDisabled) {
            sankeyView._dispatchUnfocus(api);
          }
        });
      }
    });

    if (!this._data && seriesModel.get('animation')) {
      group.setClipPath(createGridClipShape(group.getBoundingRect(), seriesModel, function () {
        group.removeClipPath();
      }));
    }

    this._data = seriesModel.getData();
  },
  dispose: function () {
    this._clearTimer();
  },
  _dispatchUnfocus: function (api) {
    var self = this;

    this._clearTimer();

    this._unfocusDelayTimer = setTimeout(function () {
      self._unfocusDelayTimer = null;
      api.dispatchAction({
        type: 'unfocusNodeAdjacency',
        seriesId: self._model.id
      });
    }, 500);
  },
  _clearTimer: function () {
    if (this._unfocusDelayTimer) {
      clearTimeout(this._unfocusDelayTimer);
      this._unfocusDelayTimer = null;
    }
  },
  focusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData();
    var graph = data.graph;
    var dataIndex = payload.dataIndex;
    var itemModel = data.getItemModel(dataIndex);
    var edgeDataIndex = payload.edgeDataIndex;

    if (dataIndex == null && edgeDataIndex == null) {
      return;
    }

    var node = graph.getNodeByIndex(dataIndex);
    var edge = graph.getEdgeByIndex(edgeDataIndex);
    graph.eachNode(function (node) {
      fadeOutItem(node, nodeOpacityPath, 0.1);
    });
    graph.eachEdge(function (edge) {
      fadeOutItem(edge, lineOpacityPath, 0.1);
    });

    if (node) {
      fadeInItem(node, hoverNodeOpacityPath);
      var focusNodeAdj = itemModel.get('focusNodeAdjacency');

      if (focusNodeAdj === 'outEdges') {
        zrUtil.each(node.outEdges, function (edge) {
          if (edge.dataIndex < 0) {
            return;
          }

          fadeInItem(edge, hoverLineOpacityPath);
          fadeInItem(edge.node2, hoverNodeOpacityPath);
        });
      } else if (focusNodeAdj === 'inEdges') {
        zrUtil.each(node.inEdges, function (edge) {
          if (edge.dataIndex < 0) {
            return;
          }

          fadeInItem(edge, hoverLineOpacityPath);
          fadeInItem(edge.node1, hoverNodeOpacityPath);
        });
      } else if (focusNodeAdj === 'allEdges') {
        zrUtil.each(node.edges, function (edge) {
          if (edge.dataIndex < 0) {
            return;
          }

          fadeInItem(edge, hoverLineOpacityPath);
          edge.node1 !== node && fadeInItem(edge.node1, hoverNodeOpacityPath);
          edge.node2 !== node && fadeInItem(edge.node2, hoverNodeOpacityPath);
        });
      }
    }

    if (edge) {
      fadeInItem(edge, hoverLineOpacityPath);
      fadeInItem(edge.node1, hoverNodeOpacityPath);
      fadeInItem(edge.node2, hoverNodeOpacityPath);
    }
  },
  unfocusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
    var graph = seriesModel.getGraph();
    graph.eachNode(function (node) {
      fadeOutItem(node, nodeOpacityPath);
    });
    graph.eachEdge(function (edge) {
      fadeOutItem(edge, lineOpacityPath);
    });
  }
}); // Add animation to the view


function createGridClipShape(rect, seriesModel, cb) {
  var rectEl = new graphic.Rect({
    shape: {
      x: rect.x - 10,
      y: rect.y - 10,
      width: 0,
      height: rect.height + 20
    }
  });
  graphic.initProps(rectEl, {
    shape: {
      width: rect.width + 20
    }
  }, seriesModel, cb);
  return rectEl;
}

module.exports = _default;

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(663);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.registerAction({
  type: 'dragNode',
  event: 'dragnode',
  // here can only use 'update' now, other value is not support in echarts.
  update: 'update'
}, function (payload, ecModel) {
  ecModel.eachComponent({
    mainType: 'series',
    subType: 'sankey',
    query: payload
  }, function (seriesModel) {
    seriesModel.setNodePosition(payload.dataIndex, [payload.localX, payload.localY]);
  });
});

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var layout = __webpack_require__(53);

var zrUtil = __webpack_require__(1);

var _model = __webpack_require__(44);

var groupData = _model.groupData;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(ecModel, api, payload) {
  ecModel.eachSeriesByType('sankey', function (seriesModel) {
    var nodeWidth = seriesModel.get('nodeWidth');
    var nodeGap = seriesModel.get('nodeGap');
    var layoutInfo = getViewRect(seriesModel, api);
    seriesModel.layoutInfo = layoutInfo;
    var width = layoutInfo.width;
    var height = layoutInfo.height;
    var graph = seriesModel.getGraph();
    var nodes = graph.nodes;
    var edges = graph.edges;
    computeNodeValues(nodes);
    var filteredNodes = zrUtil.filter(nodes, function (node) {
      return node.getLayout().value === 0;
    });
    var iterations = filteredNodes.length !== 0 ? 0 : seriesModel.get('layoutIterations');
    var orient = seriesModel.get('orient');
    var nodeAlign = seriesModel.get('nodeAlign');
    layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign);
  });
}
/**
 * Get the layout position of the whole view
 *
 * @param {module:echarts/model/Series} seriesModel  the model object of sankey series
 * @param {module:echarts/ExtensionAPI} api  provide the API list that the developer can call
 * @return {module:zrender/core/BoundingRect}  size of rect to draw the sankey view
 */


function getViewRect(seriesModel, api) {
  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  });
}

function layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign) {
  computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign);
  computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient);
  computeEdgeDepths(nodes, orient);
}
/**
 * Compute the value of each node by summing the associated edge's value
 *
 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
 */


function computeNodeValues(nodes) {
  zrUtil.each(nodes, function (node) {
    var value1 = sum(node.outEdges, getEdgeValue);
    var value2 = sum(node.inEdges, getEdgeValue);
    var nodeRawValue = node.getValue() || 0;
    var value = Math.max(value1, value2, nodeRawValue);
    node.setLayout({
      value: value
    }, true);
  });
}
/**
 * Compute the x-position for each node.
 *
 * Here we use Kahn algorithm to detect cycle when we traverse
 * the node to computer the initial x position.
 *
 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
 * @param  {number} nodeWidth  the dx of the node
 * @param  {number} width  the whole width of the area to draw the view
 */


function computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign) {
  // Used to mark whether the edge is deleted. if it is deleted,
  // the value is 0, otherwise it is 1.
  var remainEdges = []; // Storage each node's indegree.

  var indegreeArr = []; //Used to storage the node with indegree is equal to 0.

  var zeroIndegrees = [];
  var nextTargetNode = [];
  var x = 0;
  var kx = 0;

  for (var i = 0; i < edges.length; i++) {
    remainEdges[i] = 1;
  }

  for (i = 0; i < nodes.length; i++) {
    indegreeArr[i] = nodes[i].inEdges.length;

    if (indegreeArr[i] === 0) {
      zeroIndegrees.push(nodes[i]);
    }
  }

  var maxNodeDepth = -1; // Traversing nodes using topological sorting to calculate the
  // horizontal(if orient === 'horizontal') or vertical(if orient === 'vertical')
  // position of the nodes.

  while (zeroIndegrees.length) {
    for (var idx = 0; idx < zeroIndegrees.length; idx++) {
      var node = zeroIndegrees[idx];
      var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
      var isItemDepth = item.depth != null && item.depth >= 0;

      if (isItemDepth && item.depth > maxNodeDepth) {
        maxNodeDepth = item.depth;
      }

      node.setLayout({
        depth: isItemDepth ? item.depth : x
      }, true);
      orient === 'vertical' ? node.setLayout({
        dy: nodeWidth
      }, true) : node.setLayout({
        dx: nodeWidth
      }, true);

      for (var edgeIdx = 0; edgeIdx < node.outEdges.length; edgeIdx++) {
        var edge = node.outEdges[edgeIdx];
        var indexEdge = edges.indexOf(edge);
        remainEdges[indexEdge] = 0;
        var targetNode = edge.node2;
        var nodeIndex = nodes.indexOf(targetNode);

        if (--indegreeArr[nodeIndex] === 0 && nextTargetNode.indexOf(targetNode) < 0) {
          nextTargetNode.push(targetNode);
        }
      }
    }

    ++x;
    zeroIndegrees = nextTargetNode;
    nextTargetNode = [];
  }

  for (i = 0; i < remainEdges.length; i++) {
    if (remainEdges[i] === 1) {
      throw new Error('Sankey is a DAG, the original data has cycle!');
    }
  }

  var maxDepth = maxNodeDepth > x - 1 ? maxNodeDepth : x - 1;

  if (nodeAlign && nodeAlign !== 'left') {
    adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth);
  }

  var kx = orient === 'vertical' ? (height - nodeWidth) / maxDepth : (width - nodeWidth) / maxDepth;
  scaleNodeBreadths(nodes, kx, orient);
}

function isNodeDepth(node) {
  var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
  return item.depth != null && item.depth >= 0;
}

function adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth) {
  if (nodeAlign === 'right') {
    var nextSourceNode = [];
    var remainNodes = nodes;
    var nodeHeight = 0;

    while (remainNodes.length) {
      for (var i = 0; i < remainNodes.length; i++) {
        var node = remainNodes[i];
        node.setLayout({
          skNodeHeight: nodeHeight
        }, true);

        for (var j = 0; j < node.inEdges.length; j++) {
          var edge = node.inEdges[j];

          if (nextSourceNode.indexOf(edge.node1) < 0) {
            nextSourceNode.push(edge.node1);
          }
        }
      }

      remainNodes = nextSourceNode;
      nextSourceNode = [];
      ++nodeHeight;
    }

    zrUtil.each(nodes, function (node) {
      if (!isNodeDepth(node)) {
        node.setLayout({
          depth: Math.max(0, maxDepth - node.getLayout().skNodeHeight)
        }, true);
      }
    });
  } else if (nodeAlign === 'justify') {
    moveSinksRight(nodes, maxDepth);
  }
}
/**
 * All the node without outEgdes are assigned maximum x-position and
 *     be aligned in the last column.
 *
 * @param {module:echarts/data/Graph~Node} nodes.  node of sankey view.
 * @param {number} maxDepth.  use to assign to node without outEdges as x-position.
 */


function moveSinksRight(nodes, maxDepth) {
  zrUtil.each(nodes, function (node) {
    if (!isNodeDepth(node) && !node.outEdges.length) {
      node.setLayout({
        depth: maxDepth
      }, true);
    }
  });
}
/**
 * Scale node x-position to the width
 *
 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
 * @param {number} kx   multiple used to scale nodes
 */


function scaleNodeBreadths(nodes, kx, orient) {
  zrUtil.each(nodes, function (node) {
    var nodeDepth = node.getLayout().depth * kx;
    orient === 'vertical' ? node.setLayout({
      y: nodeDepth
    }, true) : node.setLayout({
      x: nodeDepth
    }, true);
  });
}
/**
 * Using Gauss-Seidel iterations method to compute the node depth(y-position)
 *
 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
 * @param {module:echarts/data/Graph~Edge} edges  edge of sankey view
 * @param {number} height  the whole height of the area to draw the view
 * @param {number} nodeGap  the vertical distance between two nodes
 *     in the same column.
 * @param {number} iterations  the number of iterations for the algorithm
 */


function computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient) {
  var nodesByBreadth = prepareNodesByBreadth(nodes, orient);
  initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient);
  resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);

  for (var alpha = 1; iterations > 0; iterations--) {
    // 0.99 is a experience parameter, ensure that each iterations of
    // changes as small as possible.
    alpha *= 0.99;
    relaxRightToLeft(nodesByBreadth, alpha, orient);
    resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
    relaxLeftToRight(nodesByBreadth, alpha, orient);
    resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
  }
}

function prepareNodesByBreadth(nodes, orient) {
  var nodesByBreadth = [];
  var keyAttr = orient === 'vertical' ? 'y' : 'x';
  var groupResult = groupData(nodes, function (node) {
    return node.getLayout()[keyAttr];
  });
  groupResult.keys.sort(function (a, b) {
    return a - b;
  });
  zrUtil.each(groupResult.keys, function (key) {
    nodesByBreadth.push(groupResult.buckets.get(key));
  });
  return nodesByBreadth;
}
/**
 * Compute the original y-position for each node
 *
 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
 *     group by the array of all sankey nodes based on the nodes x-position.
 * @param {module:echarts/data/Graph~Edge} edges  edge of sankey view
 * @param {number} height  the whole height of the area to draw the view
 * @param {number} nodeGap  the vertical distance between two nodes
 */


function initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient) {
  var minKy = Infinity;
  zrUtil.each(nodesByBreadth, function (nodes) {
    var n = nodes.length;
    var sum = 0;
    zrUtil.each(nodes, function (node) {
      sum += node.getLayout().value;
    });
    var ky = orient === 'vertical' ? (width - (n - 1) * nodeGap) / sum : (height - (n - 1) * nodeGap) / sum;

    if (ky < minKy) {
      minKy = ky;
    }
  });
  zrUtil.each(nodesByBreadth, function (nodes) {
    zrUtil.each(nodes, function (node, i) {
      var nodeDy = node.getLayout().value * minKy;

      if (orient === 'vertical') {
        node.setLayout({
          x: i
        }, true);
        node.setLayout({
          dx: nodeDy
        }, true);
      } else {
        node.setLayout({
          y: i
        }, true);
        node.setLayout({
          dy: nodeDy
        }, true);
      }
    });
  });
  zrUtil.each(edges, function (edge) {
    var edgeDy = +edge.getValue() * minKy;
    edge.setLayout({
      dy: edgeDy
    }, true);
  });
}
/**
 * Resolve the collision of initialized depth (y-position)
 *
 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
 *     group by the array of all sankey nodes based on the nodes x-position.
 * @param {number} nodeGap  the vertical distance between two nodes
 * @param {number} height  the whole height of the area to draw the view
 */


function resolveCollisions(nodesByBreadth, nodeGap, height, width, orient) {
  var keyAttr = orient === 'vertical' ? 'x' : 'y';
  zrUtil.each(nodesByBreadth, function (nodes) {
    nodes.sort(function (a, b) {
      return a.getLayout()[keyAttr] - b.getLayout()[keyAttr];
    });
    var nodeX;
    var node;
    var dy;
    var y0 = 0;
    var n = nodes.length;
    var nodeDyAttr = orient === 'vertical' ? 'dx' : 'dy';

    for (var i = 0; i < n; i++) {
      node = nodes[i];
      dy = y0 - node.getLayout()[keyAttr];

      if (dy > 0) {
        nodeX = node.getLayout()[keyAttr] + dy;
        orient === 'vertical' ? node.setLayout({
          x: nodeX
        }, true) : node.setLayout({
          y: nodeX
        }, true);
      }

      y0 = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap;
    }

    var viewWidth = orient === 'vertical' ? width : height; // If the bottommost node goes outside the bounds, push it back up

    dy = y0 - nodeGap - viewWidth;

    if (dy > 0) {
      nodeX = node.getLayout()[keyAttr] - dy;
      orient === 'vertical' ? node.setLayout({
        x: nodeX
      }, true) : node.setLayout({
        y: nodeX
      }, true);
      y0 = nodeX;

      for (i = n - 2; i >= 0; --i) {
        node = nodes[i];
        dy = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap - y0;

        if (dy > 0) {
          nodeX = node.getLayout()[keyAttr] - dy;
          orient === 'vertical' ? node.setLayout({
            x: nodeX
          }, true) : node.setLayout({
            y: nodeX
          }, true);
        }

        y0 = node.getLayout()[keyAttr];
      }
    }
  });
}
/**
 * Change the y-position of the nodes, except most the right side nodes
 *
 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
 *     group by the array of all sankey nodes based on the node x-position.
 * @param {number} alpha  parameter used to adjust the nodes y-position
 */


function relaxRightToLeft(nodesByBreadth, alpha, orient) {
  zrUtil.each(nodesByBreadth.slice().reverse(), function (nodes) {
    zrUtil.each(nodes, function (node) {
      if (node.outEdges.length) {
        var y = sum(node.outEdges, weightedTarget, orient) / sum(node.outEdges, getEdgeValue, orient);

        if (isNaN(y)) {
          var len = node.outEdges.length;
          y = len ? sum(node.outEdges, centerTarget, orient) / len : 0;
        }

        if (orient === 'vertical') {
          var nodeX = node.getLayout().x + (y - center(node, orient)) * alpha;
          node.setLayout({
            x: nodeX
          }, true);
        } else {
          var nodeY = node.getLayout().y + (y - center(node, orient)) * alpha;
          node.setLayout({
            y: nodeY
          }, true);
        }
      }
    });
  });
}

function weightedTarget(edge, orient) {
  return center(edge.node2, orient) * edge.getValue();
}

function centerTarget(edge, orient) {
  return center(edge.node2, orient);
}

function weightedSource(edge, orient) {
  return center(edge.node1, orient) * edge.getValue();
}

function centerSource(edge, orient) {
  return center(edge.node1, orient);
}

function center(node, orient) {
  return orient === 'vertical' ? node.getLayout().x + node.getLayout().dx / 2 : node.getLayout().y + node.getLayout().dy / 2;
}

function getEdgeValue(edge) {
  return edge.getValue();
}

function sum(array, cb, orient) {
  var sum = 0;
  var len = array.length;
  var i = -1;

  while (++i < len) {
    var value = +cb.call(array, array[i], orient);

    if (!isNaN(value)) {
      sum += value;
    }
  }

  return sum;
}
/**
 * Change the y-position of the nodes, except most the left side nodes
 *
 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
 *     group by the array of all sankey nodes based on the node x-position.
 * @param {number} alpha  parameter used to adjust the nodes y-position
 */


function relaxLeftToRight(nodesByBreadth, alpha, orient) {
  zrUtil.each(nodesByBreadth, function (nodes) {
    zrUtil.each(nodes, function (node) {
      if (node.inEdges.length) {
        var y = sum(node.inEdges, weightedSource, orient) / sum(node.inEdges, getEdgeValue, orient);

        if (isNaN(y)) {
          var len = node.inEdges.length;
          y = len ? sum(node.inEdges, centerSource, orient) / len : 0;
        }

        if (orient === 'vertical') {
          var nodeX = node.getLayout().x + (y - center(node, orient)) * alpha;
          node.setLayout({
            x: nodeX
          }, true);
        } else {
          var nodeY = node.getLayout().y + (y - center(node, orient)) * alpha;
          node.setLayout({
            y: nodeY
          }, true);
        }
      }
    });
  });
}
/**
 * Compute the depth(y-position) of each edge
 *
 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
 */


function computeEdgeDepths(nodes, orient) {
  var keyAttr = orient === 'vertical' ? 'x' : 'y';
  zrUtil.each(nodes, function (node) {
    node.outEdges.sort(function (a, b) {
      return a.node2.getLayout()[keyAttr] - b.node2.getLayout()[keyAttr];
    });
    node.inEdges.sort(function (a, b) {
      return a.node1.getLayout()[keyAttr] - b.node1.getLayout()[keyAttr];
    });
  });
  zrUtil.each(nodes, function (node) {
    var sy = 0;
    var ty = 0;
    zrUtil.each(node.outEdges, function (edge) {
      edge.setLayout({
        sy: sy
      }, true);
      sy += edge.getLayout().dy;
    });
    zrUtil.each(node.inEdges, function (edge) {
      edge.setLayout({
        ty: ty
      }, true);
      ty += edge.getLayout().dy;
    });
  });
}

module.exports = _default;

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var VisualMapping = __webpack_require__(181);

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(ecModel, payload) {
  ecModel.eachSeriesByType('sankey', function (seriesModel) {
    var graph = seriesModel.getGraph();
    var nodes = graph.nodes;

    if (nodes.length) {
      var minValue = Infinity;
      var maxValue = -Infinity;
      zrUtil.each(nodes, function (node) {
        var nodeValue = node.getLayout().value;

        if (nodeValue < minValue) {
          minValue = nodeValue;
        }

        if (nodeValue > maxValue) {
          maxValue = nodeValue;
        }
      });
      zrUtil.each(nodes, function (node) {
        var mapping = new VisualMapping({
          type: 'color',
          mappingMethod: 'linear',
          dataExtent: [minValue, maxValue],
          visual: seriesModel.get('color')
        });
        var mapValueToColor = mapping.mapValueToVisual(node.getLayout().value);
        var customColor = node.getModel().get('itemStyle.color');
        customColor != null ? node.setVisual('color', customColor) : node.setVisual('color', mapValueToColor);
      });
    }
  });
}

module.exports = _default;

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(1677);

__webpack_require__(1678);

var boxplotVisual = __webpack_require__(1679);

var boxplotLayout = __webpack_require__(1680);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.registerVisual(boxplotVisual);
echarts.registerLayout(boxplotLayout);

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var SeriesModel = __webpack_require__(74);

var _whiskerBoxCommon = __webpack_require__(669);

var seriesModelMixin = _whiskerBoxCommon.seriesModelMixin;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var BoxplotSeries = SeriesModel.extend({
  type: 'series.boxplot',
  dependencies: ['xAxis', 'yAxis', 'grid'],
  // TODO
  // box width represents group size, so dimension should have 'size'.

  /**
   * @see <https://en.wikipedia.org/wiki/Box_plot>
   * The meanings of 'min' and 'max' depend on user,
   * and echarts do not need to know it.
   * @readOnly
   */
  defaultValueDimensions: [{
    name: 'min',
    defaultTooltip: true
  }, {
    name: 'Q1',
    defaultTooltip: true
  }, {
    name: 'median',
    defaultTooltip: true
  }, {
    name: 'Q3',
    defaultTooltip: true
  }, {
    name: 'max',
    defaultTooltip: true
  }],

  /**
   * @type {Array.<string>}
   * @readOnly
   */
  dimensions: null,

  /**
   * @override
   */
  defaultOption: {
    zlevel: 0,
    // 一级层叠
    z: 2,
    // 二级层叠
    coordinateSystem: 'cartesian2d',
    legendHoverLink: true,
    hoverAnimation: true,
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    layout: null,
    // 'horizontal' or 'vertical'
    boxWidth: [7, 50],
    // [min, max] can be percent of band width.
    itemStyle: {
      color: '#fff',
      borderWidth: 1
    },
    emphasis: {
      itemStyle: {
        borderWidth: 2,
        shadowBlur: 5,
        shadowOffsetX: 2,
        shadowOffsetY: 2,
        shadowColor: 'rgba(0,0,0,0.4)'
      }
    },
    animationEasing: 'elasticOut',
    animationDuration: 800
  }
});
zrUtil.mixin(BoxplotSeries, seriesModelMixin, true);
var _default = BoxplotSeries;
module.exports = _default;

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var ChartView = __webpack_require__(123);

var graphic = __webpack_require__(27);

var Path = __webpack_require__(65);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Update common properties
var NORMAL_ITEM_STYLE_PATH = ['itemStyle'];
var EMPHASIS_ITEM_STYLE_PATH = ['emphasis', 'itemStyle'];
var BoxplotView = ChartView.extend({
  type: 'boxplot',
  render: function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var group = this.group;
    var oldData = this._data; // There is no old data only when first rendering or switching from
    // stream mode to normal mode, where previous elements should be removed.

    if (!this._data) {
      group.removeAll();
    }

    var constDim = seriesModel.get('layout') === 'horizontal' ? 1 : 0;
    data.diff(oldData).add(function (newIdx) {
      if (data.hasValue(newIdx)) {
        var itemLayout = data.getItemLayout(newIdx);
        var symbolEl = createNormalBox(itemLayout, data, newIdx, constDim, true);
        data.setItemGraphicEl(newIdx, symbolEl);
        group.add(symbolEl);
      }
    }).update(function (newIdx, oldIdx) {
      var symbolEl = oldData.getItemGraphicEl(oldIdx); // Empty data

      if (!data.hasValue(newIdx)) {
        group.remove(symbolEl);
        return;
      }

      var itemLayout = data.getItemLayout(newIdx);

      if (!symbolEl) {
        symbolEl = createNormalBox(itemLayout, data, newIdx, constDim);
      } else {
        updateNormalBoxData(itemLayout, symbolEl, data, newIdx);
      }

      group.add(symbolEl);
      data.setItemGraphicEl(newIdx, symbolEl);
    }).remove(function (oldIdx) {
      var el = oldData.getItemGraphicEl(oldIdx);
      el && group.remove(el);
    }).execute();
    this._data = data;
  },
  remove: function (ecModel) {
    var group = this.group;
    var data = this._data;
    this._data = null;
    data && data.eachItemGraphicEl(function (el) {
      el && group.remove(el);
    });
  },
  dispose: zrUtil.noop
});
var BoxPath = Path.extend({
  type: 'boxplotBoxPath',
  shape: {},
  buildPath: function (ctx, shape) {
    var ends = shape.points;
    var i = 0;
    ctx.moveTo(ends[i][0], ends[i][1]);
    i++;

    for (; i < 4; i++) {
      ctx.lineTo(ends[i][0], ends[i][1]);
    }

    ctx.closePath();

    for (; i < ends.length; i++) {
      ctx.moveTo(ends[i][0], ends[i][1]);
      i++;
      ctx.lineTo(ends[i][0], ends[i][1]);
    }
  }
});

function createNormalBox(itemLayout, data, dataIndex, constDim, isInit) {
  var ends = itemLayout.ends;
  var el = new BoxPath({
    shape: {
      points: isInit ? transInit(ends, constDim, itemLayout) : ends
    }
  });
  updateNormalBoxData(itemLayout, el, data, dataIndex, isInit);
  return el;
}

function updateNormalBoxData(itemLayout, el, data, dataIndex, isInit) {
  var seriesModel = data.hostModel;
  var updateMethod = graphic[isInit ? 'initProps' : 'updateProps'];
  updateMethod(el, {
    shape: {
      points: itemLayout.ends
    }
  }, seriesModel, dataIndex);
  var itemModel = data.getItemModel(dataIndex);
  var normalItemStyleModel = itemModel.getModel(NORMAL_ITEM_STYLE_PATH);
  var borderColor = data.getItemVisual(dataIndex, 'color'); // Exclude borderColor.

  var itemStyle = normalItemStyleModel.getItemStyle(['borderColor']);
  itemStyle.stroke = borderColor;
  itemStyle.strokeNoScale = true;
  el.useStyle(itemStyle);
  el.z2 = 100;
  var hoverStyle = itemModel.getModel(EMPHASIS_ITEM_STYLE_PATH).getItemStyle();
  graphic.setHoverStyle(el, hoverStyle);
}

function transInit(points, dim, itemLayout) {
  return zrUtil.map(points, function (point) {
    point = point.slice();
    point[dim] = itemLayout.initBaseline;
    return point;
  });
}

var _default = BoxplotView;
module.exports = _default;

/***/ }),
/* 1679 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var borderColorQuery = ['itemStyle', 'borderColor'];

function _default(ecModel, api) {
  var globalColors = ecModel.get('color');
  ecModel.eachRawSeriesByType('boxplot', function (seriesModel) {
    var defaulColor = globalColors[seriesModel.seriesIndex % globalColors.length];
    var data = seriesModel.getData();
    data.setVisual({
      legendSymbol: 'roundRect',
      // Use name 'color' but not 'borderColor' for legend usage and
      // visual coding from other component like dataRange.
      color: seriesModel.get(borderColorQuery) || defaulColor
    }); // Only visible series has each data be visual encoded

    if (!ecModel.isSeriesFiltered(seriesModel)) {
      data.each(function (idx) {
        var itemModel = data.getItemModel(idx);
        data.setItemVisual(idx, {
          color: itemModel.get(borderColorQuery, true)
        });
      });
    }
  });
}

module.exports = _default;

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var _number = __webpack_require__(37);

var parsePercent = _number.parsePercent;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var each = zrUtil.each;

function _default(ecModel) {
  var groupResult = groupSeriesByAxis(ecModel);
  each(groupResult, function (groupItem) {
    var seriesModels = groupItem.seriesModels;

    if (!seriesModels.length) {
      return;
    }

    calculateBase(groupItem);
    each(seriesModels, function (seriesModel, idx) {
      layoutSingleSeries(seriesModel, groupItem.boxOffsetList[idx], groupItem.boxWidthList[idx]);
    });
  });
}
/**
 * Group series by axis.
 */


function groupSeriesByAxis(ecModel) {
  var result = [];
  var axisList = [];
  ecModel.eachSeriesByType('boxplot', function (seriesModel) {
    var baseAxis = seriesModel.getBaseAxis();
    var idx = zrUtil.indexOf(axisList, baseAxis);

    if (idx < 0) {
      idx = axisList.length;
      axisList[idx] = baseAxis;
      result[idx] = {
        axis: baseAxis,
        seriesModels: []
      };
    }

    result[idx].seriesModels.push(seriesModel);
  });
  return result;
}
/**
 * Calculate offset and box width for each series.
 */


function calculateBase(groupItem) {
  var extent;
  var baseAxis = groupItem.axis;
  var seriesModels = groupItem.seriesModels;
  var seriesCount = seriesModels.length;
  var boxWidthList = groupItem.boxWidthList = [];
  var boxOffsetList = groupItem.boxOffsetList = [];
  var boundList = [];
  var bandWidth;

  if (baseAxis.type === 'category') {
    bandWidth = baseAxis.getBandWidth();
  } else {
    var maxDataCount = 0;
    each(seriesModels, function (seriesModel) {
      maxDataCount = Math.max(maxDataCount, seriesModel.getData().count());
    });
    extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / maxDataCount;
  }

  each(seriesModels, function (seriesModel) {
    var boxWidthBound = seriesModel.get('boxWidth');

    if (!zrUtil.isArray(boxWidthBound)) {
      boxWidthBound = [boxWidthBound, boxWidthBound];
    }

    boundList.push([parsePercent(boxWidthBound[0], bandWidth) || 0, parsePercent(boxWidthBound[1], bandWidth) || 0]);
  });
  var availableWidth = bandWidth * 0.8 - 2;
  var boxGap = availableWidth / seriesCount * 0.3;
  var boxWidth = (availableWidth - boxGap * (seriesCount - 1)) / seriesCount;
  var base = boxWidth / 2 - availableWidth / 2;
  each(seriesModels, function (seriesModel, idx) {
    boxOffsetList.push(base);
    base += boxGap + boxWidth;
    boxWidthList.push(Math.min(Math.max(boxWidth, boundList[idx][0]), boundList[idx][1]));
  });
}
/**
 * Calculate points location for each series.
 */


function layoutSingleSeries(seriesModel, offset, boxWidth) {
  var coordSys = seriesModel.coordinateSystem;
  var data = seriesModel.getData();
  var halfWidth = boxWidth / 2;
  var cDimIdx = seriesModel.get('layout') === 'horizontal' ? 0 : 1;
  var vDimIdx = 1 - cDimIdx;
  var coordDims = ['x', 'y'];
  var cDim = data.mapDimension(coordDims[cDimIdx]);
  var vDims = data.mapDimension(coordDims[vDimIdx], true);

  if (cDim == null || vDims.length < 5) {
    return;
  }

  for (var dataIndex = 0; dataIndex < data.count(); dataIndex++) {
    var axisDimVal = data.get(cDim, dataIndex);
    var median = getPoint(axisDimVal, vDims[2], dataIndex);
    var end1 = getPoint(axisDimVal, vDims[0], dataIndex);
    var end2 = getPoint(axisDimVal, vDims[1], dataIndex);
    var end4 = getPoint(axisDimVal, vDims[3], dataIndex);
    var end5 = getPoint(axisDimVal, vDims[4], dataIndex);
    var ends = [];
    addBodyEnd(ends, end2, 0);
    addBodyEnd(ends, end4, 1);
    ends.push(end1, end2, end5, end4);
    layEndLine(ends, end1);
    layEndLine(ends, end5);
    layEndLine(ends, median);
    data.setItemLayout(dataIndex, {
      initBaseline: median[vDimIdx],
      ends: ends
    });
  }

  function getPoint(axisDimVal, dimIdx, dataIndex) {
    var val = data.get(dimIdx, dataIndex);
    var p = [];
    p[cDimIdx] = axisDimVal;
    p[vDimIdx] = val;
    var point;

    if (isNaN(axisDimVal) || isNaN(val)) {
      point = [NaN, NaN];
    } else {
      point = coordSys.dataToPoint(p);
      point[cDimIdx] += offset;
    }

    return point;
  }

  function addBodyEnd(ends, point, start) {
    var point1 = point.slice();
    var point2 = point.slice();
    point1[cDimIdx] += halfWidth;
    point2[cDimIdx] -= halfWidth;
    start ? ends.push(point1, point2) : ends.push(point2, point1);
  }

  function layEndLine(ends, endCenter) {
    var from = endCenter.slice();
    var to = endCenter.slice();
    from[cDimIdx] -= halfWidth;
    to[cDimIdx] += halfWidth;
    ends.push(from, to);
  }
}

module.exports = _default;

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(1682);

__webpack_require__(1683);

var preprocessor = __webpack_require__(1684);

var candlestickVisual = __webpack_require__(1685);

var candlestickLayout = __webpack_require__(1686);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.registerPreprocessor(preprocessor);
echarts.registerVisual(candlestickVisual);
echarts.registerLayout(candlestickLayout);

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var SeriesModel = __webpack_require__(74);

var _whiskerBoxCommon = __webpack_require__(669);

var seriesModelMixin = _whiskerBoxCommon.seriesModelMixin;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var CandlestickSeries = SeriesModel.extend({
  type: 'series.candlestick',
  dependencies: ['xAxis', 'yAxis', 'grid'],

  /**
   * @readOnly
   */
  defaultValueDimensions: [{
    name: 'open',
    defaultTooltip: true
  }, {
    name: 'close',
    defaultTooltip: true
  }, {
    name: 'lowest',
    defaultTooltip: true
  }, {
    name: 'highest',
    defaultTooltip: true
  }],

  /**
   * @type {Array.<string>}
   * @readOnly
   */
  dimensions: null,

  /**
   * @override
   */
  defaultOption: {
    zlevel: 0,
    z: 2,
    coordinateSystem: 'cartesian2d',
    legendHoverLink: true,
    hoverAnimation: true,
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    layout: null,
    // 'horizontal' or 'vertical'
    clip: true,
    itemStyle: {
      color: '#c23531',
      // 阳线 positive
      color0: '#314656',
      // 阴线 negative     '#c23531', '#314656'
      borderWidth: 1,
      // FIXME
      // ec2中使用的是lineStyle.color 和 lineStyle.color0
      borderColor: '#c23531',
      borderColor0: '#314656'
    },
    emphasis: {
      itemStyle: {
        borderWidth: 2
      }
    },
    barMaxWidth: null,
    barMinWidth: null,
    barWidth: null,
    large: true,
    largeThreshold: 600,
    progressive: 3e3,
    progressiveThreshold: 1e4,
    progressiveChunkMode: 'mod',
    animationUpdate: false,
    animationEasing: 'linear',
    animationDuration: 300
  },

  /**
   * Get dimension for shadow in dataZoom
   * @return {string} dimension name
   */
  getShadowDim: function () {
    return 'open';
  },
  brushSelector: function (dataIndex, data, selectors) {
    var itemLayout = data.getItemLayout(dataIndex);
    return itemLayout && selectors.rect(itemLayout.brushRect);
  }
});
zrUtil.mixin(CandlestickSeries, seriesModelMixin, true);
var _default = CandlestickSeries;
module.exports = _default;

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var ChartView = __webpack_require__(123);

var graphic = __webpack_require__(27);

var Path = __webpack_require__(65);

var _createClipPathFromCoordSys = __webpack_require__(240);

var createClipPath = _createClipPathFromCoordSys.createClipPath;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var NORMAL_ITEM_STYLE_PATH = ['itemStyle'];
var EMPHASIS_ITEM_STYLE_PATH = ['emphasis', 'itemStyle'];
var SKIP_PROPS = ['color', 'color0', 'borderColor', 'borderColor0'];
var CandlestickView = ChartView.extend({
  type: 'candlestick',
  render: function (seriesModel, ecModel, api) {
    // If there is clipPath created in large mode. Remove it.
    this.group.removeClipPath();

    this._updateDrawMode(seriesModel);

    this._isLargeDraw ? this._renderLarge(seriesModel) : this._renderNormal(seriesModel);
  },
  incrementalPrepareRender: function (seriesModel, ecModel, api) {
    this._clear();

    this._updateDrawMode(seriesModel);
  },
  incrementalRender: function (params, seriesModel, ecModel, api) {
    this._isLargeDraw ? this._incrementalRenderLarge(params, seriesModel) : this._incrementalRenderNormal(params, seriesModel);
  },
  _updateDrawMode: function (seriesModel) {
    var isLargeDraw = seriesModel.pipelineContext.large;

    if (this._isLargeDraw == null || isLargeDraw ^ this._isLargeDraw) {
      this._isLargeDraw = isLargeDraw;

      this._clear();
    }
  },
  _renderNormal: function (seriesModel) {
    var data = seriesModel.getData();
    var oldData = this._data;
    var group = this.group;
    var isSimpleBox = data.getLayout('isSimpleBox');
    var needsClip = seriesModel.get('clip', true);
    var coord = seriesModel.coordinateSystem;
    var clipArea = coord.getArea && coord.getArea(); // There is no old data only when first rendering or switching from
    // stream mode to normal mode, where previous elements should be removed.

    if (!this._data) {
      group.removeAll();
    }

    data.diff(oldData).add(function (newIdx) {
      if (data.hasValue(newIdx)) {
        var el;
        var itemLayout = data.getItemLayout(newIdx);

        if (needsClip && isNormalBoxClipped(clipArea, itemLayout)) {
          return;
        }

        el = createNormalBox(itemLayout, newIdx, true);
        graphic.initProps(el, {
          shape: {
            points: itemLayout.ends
          }
        }, seriesModel, newIdx);
        setBoxCommon(el, data, newIdx, isSimpleBox);
        group.add(el);
        data.setItemGraphicEl(newIdx, el);
      }
    }).update(function (newIdx, oldIdx) {
      var el = oldData.getItemGraphicEl(oldIdx); // Empty data

      if (!data.hasValue(newIdx)) {
        group.remove(el);
        return;
      }

      var itemLayout = data.getItemLayout(newIdx);

      if (needsClip && isNormalBoxClipped(clipArea, itemLayout)) {
        group.remove(el);
        return;
      }

      if (!el) {
        el = createNormalBox(itemLayout, newIdx);
      } else {
        graphic.updateProps(el, {
          shape: {
            points: itemLayout.ends
          }
        }, seriesModel, newIdx);
      }

      setBoxCommon(el, data, newIdx, isSimpleBox);
      group.add(el);
      data.setItemGraphicEl(newIdx, el);
    }).remove(function (oldIdx) {
      var el = oldData.getItemGraphicEl(oldIdx);
      el && group.remove(el);
    }).execute();
    this._data = data;
  },
  _renderLarge: function (seriesModel) {
    this._clear();

    createLarge(seriesModel, this.group);
    var clipPath = seriesModel.get('clip', true) ? createClipPath(seriesModel.coordinateSystem, false, seriesModel) : null;

    if (clipPath) {
      this.group.setClipPath(clipPath);
    } else {
      this.group.removeClipPath();
    }
  },
  _incrementalRenderNormal: function (params, seriesModel) {
    var data = seriesModel.getData();
    var isSimpleBox = data.getLayout('isSimpleBox');
    var dataIndex;

    while ((dataIndex = params.next()) != null) {
      var el;
      var itemLayout = data.getItemLayout(dataIndex);
      el = createNormalBox(itemLayout, dataIndex);
      setBoxCommon(el, data, dataIndex, isSimpleBox);
      el.incremental = true;
      this.group.add(el);
    }
  },
  _incrementalRenderLarge: function (params, seriesModel) {
    createLarge(seriesModel, this.group, true);
  },
  remove: function (ecModel) {
    this._clear();
  },
  _clear: function () {
    this.group.removeAll();
    this._data = null;
  },
  dispose: zrUtil.noop
});
var NormalBoxPath = Path.extend({
  type: 'normalCandlestickBox',
  shape: {},
  buildPath: function (ctx, shape) {
    var ends = shape.points;

    if (this.__simpleBox) {
      ctx.moveTo(ends[4][0], ends[4][1]);
      ctx.lineTo(ends[6][0], ends[6][1]);
    } else {
      ctx.moveTo(ends[0][0], ends[0][1]);
      ctx.lineTo(ends[1][0], ends[1][1]);
      ctx.lineTo(ends[2][0], ends[2][1]);
      ctx.lineTo(ends[3][0], ends[3][1]);
      ctx.closePath();
      ctx.moveTo(ends[4][0], ends[4][1]);
      ctx.lineTo(ends[5][0], ends[5][1]);
      ctx.moveTo(ends[6][0], ends[6][1]);
      ctx.lineTo(ends[7][0], ends[7][1]);
    }
  }
});

function createNormalBox(itemLayout, dataIndex, isInit) {
  var ends = itemLayout.ends;
  return new NormalBoxPath({
    shape: {
      points: isInit ? transInit(ends, itemLayout) : ends
    },
    z2: 100
  });
}

function isNormalBoxClipped(clipArea, itemLayout) {
  var clipped = true;

  for (var i = 0; i < itemLayout.ends.length; i++) {
    // If any point are in the region.
    if (clipArea.contain(itemLayout.ends[i][0], itemLayout.ends[i][1])) {
      clipped = false;
      break;
    }
  }

  return clipped;
}

function setBoxCommon(el, data, dataIndex, isSimpleBox) {
  var itemModel = data.getItemModel(dataIndex);
  var normalItemStyleModel = itemModel.getModel(NORMAL_ITEM_STYLE_PATH);
  var color = data.getItemVisual(dataIndex, 'color');
  var borderColor = data.getItemVisual(dataIndex, 'borderColor') || color; // Color must be excluded.
  // Because symbol provide setColor individually to set fill and stroke

  var itemStyle = normalItemStyleModel.getItemStyle(SKIP_PROPS);
  el.useStyle(itemStyle);
  el.style.strokeNoScale = true;
  el.style.fill = color;
  el.style.stroke = borderColor;
  el.__simpleBox = isSimpleBox;
  var hoverStyle = itemModel.getModel(EMPHASIS_ITEM_STYLE_PATH).getItemStyle();
  graphic.setHoverStyle(el, hoverStyle);
}

function transInit(points, itemLayout) {
  return zrUtil.map(points, function (point) {
    point = point.slice();
    point[1] = itemLayout.initBaseline;
    return point;
  });
}

var LargeBoxPath = Path.extend({
  type: 'largeCandlestickBox',
  shape: {},
  buildPath: function (ctx, shape) {
    // Drawing lines is more efficient than drawing
    // a whole line or drawing rects.
    var points = shape.points;

    for (var i = 0; i < points.length;) {
      if (this.__sign === points[i++]) {
        var x = points[i++];
        ctx.moveTo(x, points[i++]);
        ctx.lineTo(x, points[i++]);
      } else {
        i += 3;
      }
    }
  }
});

function createLarge(seriesModel, group, incremental) {
  var data = seriesModel.getData();
  var largePoints = data.getLayout('largePoints');
  var elP = new LargeBoxPath({
    shape: {
      points: largePoints
    },
    __sign: 1
  });
  group.add(elP);
  var elN = new LargeBoxPath({
    shape: {
      points: largePoints
    },
    __sign: -1
  });
  group.add(elN);
  setLargeStyle(1, elP, seriesModel, data);
  setLargeStyle(-1, elN, seriesModel, data);

  if (incremental) {
    elP.incremental = true;
    elN.incremental = true;
  }
}

function setLargeStyle(sign, el, seriesModel, data) {
  var suffix = sign > 0 ? 'P' : 'N';
  var borderColor = data.getVisual('borderColor' + suffix) || data.getVisual('color' + suffix); // Color must be excluded.
  // Because symbol provide setColor individually to set fill and stroke

  var itemStyle = seriesModel.getModel(NORMAL_ITEM_STYLE_PATH).getItemStyle(SKIP_PROPS);
  el.useStyle(itemStyle);
  el.style.fill = null;
  el.style.stroke = borderColor; // No different
  // el.style.lineWidth = .5;
}

var _default = CandlestickView;
module.exports = _default;

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(option) {
  if (!option || !zrUtil.isArray(option.series)) {
    return;
  } // Translate 'k' to 'candlestick'.


  zrUtil.each(option.series, function (seriesItem) {
    if (zrUtil.isObject(seriesItem) && seriesItem.type === 'k') {
      seriesItem.type = 'candlestick';
    }
  });
}

module.exports = _default;

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var createRenderPlanner = __webpack_require__(206);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var positiveBorderColorQuery = ['itemStyle', 'borderColor'];
var negativeBorderColorQuery = ['itemStyle', 'borderColor0'];
var positiveColorQuery = ['itemStyle', 'color'];
var negativeColorQuery = ['itemStyle', 'color0'];
var _default = {
  seriesType: 'candlestick',
  plan: createRenderPlanner(),
  // For legend.
  performRawSeries: true,
  reset: function (seriesModel, ecModel) {
    var data = seriesModel.getData();
    data.setVisual({
      legendSymbol: 'roundRect',
      colorP: getColor(1, seriesModel),
      colorN: getColor(-1, seriesModel),
      borderColorP: getBorderColor(1, seriesModel),
      borderColorN: getBorderColor(-1, seriesModel)
    }); // Only visible series has each data be visual encoded

    if (ecModel.isSeriesFiltered(seriesModel)) {
      return;
    }

    var isLargeRender = seriesModel.pipelineContext.large;
    return !isLargeRender && {
      progress: progress
    };

    function progress(params, data) {
      var dataIndex;

      while ((dataIndex = params.next()) != null) {
        var itemModel = data.getItemModel(dataIndex);
        var sign = data.getItemLayout(dataIndex).sign;
        data.setItemVisual(dataIndex, {
          color: getColor(sign, itemModel),
          borderColor: getBorderColor(sign, itemModel)
        });
      }
    }

    function getColor(sign, model) {
      return model.get(sign > 0 ? positiveColorQuery : negativeColorQuery);
    }

    function getBorderColor(sign, model) {
      return model.get(sign > 0 ? positiveBorderColorQuery : negativeBorderColorQuery);
    }
  }
};
module.exports = _default;

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _graphic = __webpack_require__(27);

var subPixelOptimize = _graphic.subPixelOptimize;

var createRenderPlanner = __webpack_require__(206);

var _number = __webpack_require__(37);

var parsePercent = _number.parsePercent;

var _util = __webpack_require__(1);

var retrieve2 = _util.retrieve2;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/* global Float32Array */
var LargeArr = typeof Float32Array !== 'undefined' ? Float32Array : Array;
var _default = {
  seriesType: 'candlestick',
  plan: createRenderPlanner(),
  reset: function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    var data = seriesModel.getData();
    var candleWidth = calculateCandleWidth(seriesModel, data);
    var cDimIdx = 0;
    var vDimIdx = 1;
    var coordDims = ['x', 'y'];
    var cDim = data.mapDimension(coordDims[cDimIdx]);
    var vDims = data.mapDimension(coordDims[vDimIdx], true);
    var openDim = vDims[0];
    var closeDim = vDims[1];
    var lowestDim = vDims[2];
    var highestDim = vDims[3];
    data.setLayout({
      candleWidth: candleWidth,
      // The value is experimented visually.
      isSimpleBox: candleWidth <= 1.3
    });

    if (cDim == null || vDims.length < 4) {
      return;
    }

    return {
      progress: seriesModel.pipelineContext.large ? largeProgress : normalProgress
    };

    function normalProgress(params, data) {
      var dataIndex;

      while ((dataIndex = params.next()) != null) {
        var axisDimVal = data.get(cDim, dataIndex);
        var openVal = data.get(openDim, dataIndex);
        var closeVal = data.get(closeDim, dataIndex);
        var lowestVal = data.get(lowestDim, dataIndex);
        var highestVal = data.get(highestDim, dataIndex);
        var ocLow = Math.min(openVal, closeVal);
        var ocHigh = Math.max(openVal, closeVal);
        var ocLowPoint = getPoint(ocLow, axisDimVal);
        var ocHighPoint = getPoint(ocHigh, axisDimVal);
        var lowestPoint = getPoint(lowestVal, axisDimVal);
        var highestPoint = getPoint(highestVal, axisDimVal);
        var ends = [];
        addBodyEnd(ends, ocHighPoint, 0);
        addBodyEnd(ends, ocLowPoint, 1);
        ends.push(subPixelOptimizePoint(highestPoint), subPixelOptimizePoint(ocHighPoint), subPixelOptimizePoint(lowestPoint), subPixelOptimizePoint(ocLowPoint));
        data.setItemLayout(dataIndex, {
          sign: getSign(data, dataIndex, openVal, closeVal, closeDim),
          initBaseline: openVal > closeVal ? ocHighPoint[vDimIdx] : ocLowPoint[vDimIdx],
          // open point.
          ends: ends,
          brushRect: makeBrushRect(lowestVal, highestVal, axisDimVal)
        });
      }

      function getPoint(val, axisDimVal) {
        var p = [];
        p[cDimIdx] = axisDimVal;
        p[vDimIdx] = val;
        return isNaN(axisDimVal) || isNaN(val) ? [NaN, NaN] : coordSys.dataToPoint(p);
      }

      function addBodyEnd(ends, point, start) {
        var point1 = point.slice();
        var point2 = point.slice();
        point1[cDimIdx] = subPixelOptimize(point1[cDimIdx] + candleWidth / 2, 1, false);
        point2[cDimIdx] = subPixelOptimize(point2[cDimIdx] - candleWidth / 2, 1, true);
        start ? ends.push(point1, point2) : ends.push(point2, point1);
      }

      function makeBrushRect(lowestVal, highestVal, axisDimVal) {
        var pmin = getPoint(lowestVal, axisDimVal);
        var pmax = getPoint(highestVal, axisDimVal);
        pmin[cDimIdx] -= candleWidth / 2;
        pmax[cDimIdx] -= candleWidth / 2;
        return {
          x: pmin[0],
          y: pmin[1],
          width: vDimIdx ? candleWidth : pmax[0] - pmin[0],
          height: vDimIdx ? pmax[1] - pmin[1] : candleWidth
        };
      }

      function subPixelOptimizePoint(point) {
        point[cDimIdx] = subPixelOptimize(point[cDimIdx], 1);
        return point;
      }
    }

    function largeProgress(params, data) {
      // Structure: [sign, x, yhigh, ylow, sign, x, yhigh, ylow, ...]
      var points = new LargeArr(params.count * 4);
      var offset = 0;
      var point;
      var tmpIn = [];
      var tmpOut = [];
      var dataIndex;

      while ((dataIndex = params.next()) != null) {
        var axisDimVal = data.get(cDim, dataIndex);
        var openVal = data.get(openDim, dataIndex);
        var closeVal = data.get(closeDim, dataIndex);
        var lowestVal = data.get(lowestDim, dataIndex);
        var highestVal = data.get(highestDim, dataIndex);

        if (isNaN(axisDimVal) || isNaN(lowestVal) || isNaN(highestVal)) {
          points[offset++] = NaN;
          offset += 3;
          continue;
        }

        points[offset++] = getSign(data, dataIndex, openVal, closeVal, closeDim);
        tmpIn[cDimIdx] = axisDimVal;
        tmpIn[vDimIdx] = lowestVal;
        point = coordSys.dataToPoint(tmpIn, null, tmpOut);
        points[offset++] = point ? point[0] : NaN;
        points[offset++] = point ? point[1] : NaN;
        tmpIn[vDimIdx] = highestVal;
        point = coordSys.dataToPoint(tmpIn, null, tmpOut);
        points[offset++] = point ? point[1] : NaN;
      }

      data.setLayout('largePoints', points);
    }
  }
};

function getSign(data, dataIndex, openVal, closeVal, closeDim) {
  var sign;

  if (openVal > closeVal) {
    sign = -1;
  } else if (openVal < closeVal) {
    sign = 1;
  } else {
    sign = dataIndex > 0 // If close === open, compare with close of last record
    ? data.get(closeDim, dataIndex - 1) <= closeVal ? 1 : -1 : // No record of previous, set to be positive
    1;
  }

  return sign;
}

function calculateCandleWidth(seriesModel, data) {
  var baseAxis = seriesModel.getBaseAxis();
  var extent;
  var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : (extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / data.count());
  var barMaxWidth = parsePercent(retrieve2(seriesModel.get('barMaxWidth'), bandWidth), bandWidth);
  var barMinWidth = parsePercent(retrieve2(seriesModel.get('barMinWidth'), 1), bandWidth);
  var barWidth = seriesModel.get('barWidth');
  return barWidth != null ? parsePercent(barWidth, bandWidth) // Put max outer to ensure bar visible in spite of overlap.
  : Math.max(Math.min(bandWidth / 2, barMaxWidth), barMinWidth);
}

module.exports = _default;

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(1688);

__webpack_require__(1689);

var visualSymbol = __webpack_require__(178);

var layoutPoints = __webpack_require__(241);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.registerVisual(visualSymbol('effectScatter', 'circle'));
echarts.registerLayout(layoutPoints('effectScatter'));

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var createListFromArray = __webpack_require__(137);

var SeriesModel = __webpack_require__(74);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = SeriesModel.extend({
  type: 'series.effectScatter',
  dependencies: ['grid', 'polar'],
  getInitialData: function (option, ecModel) {
    return createListFromArray(this.getSource(), this, {
      useEncodeDefaulter: true
    });
  },
  brushSelector: 'point',
  defaultOption: {
    coordinateSystem: 'cartesian2d',
    zlevel: 0,
    z: 2,
    legendHoverLink: true,
    effectType: 'ripple',
    progressive: 0,
    // When to show the effect, option: 'render'|'emphasis'
    showEffectOn: 'render',
    // Ripple effect config
    rippleEffect: {
      period: 4,
      // Scale of ripple
      scale: 2.5,
      // Brush type can be fill or stroke
      brushType: 'fill'
    },
    // Cartesian coordinate system
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // Polar coordinate system
    // polarIndex: 0,
    // Geo coordinate system
    // geoIndex: 0,
    // symbol: null,        // 图形类型
    symbolSize: 10 // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
    // symbolRotate: null,  // 图形旋转控制
    // large: false,
    // Available when large is true
    // largeThreshold: 2000,
    // itemStyle: {
    //     opacity: 1
    // }

  }
});

module.exports = _default;

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var SymbolDraw = __webpack_require__(239);

var EffectSymbol = __webpack_require__(1690);

var matrix = __webpack_require__(82);

var pointsLayout = __webpack_require__(241);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = echarts.extendChartView({
  type: 'effectScatter',
  init: function () {
    this._symbolDraw = new SymbolDraw(EffectSymbol);
  },
  render: function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var effectSymbolDraw = this._symbolDraw;
    effectSymbolDraw.updateData(data);
    this.group.add(effectSymbolDraw.group);
  },
  updateTransform: function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    this.group.dirty();
    var res = pointsLayout().reset(seriesModel);

    if (res.progress) {
      res.progress({
        start: 0,
        end: data.count()
      }, data);
    }

    this._symbolDraw.updateLayout(data);
  },
  _updateGroupTransform: function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys && coordSys.getRoamTransform) {
      this.group.transform = matrix.clone(coordSys.getRoamTransform());
      this.group.decomposeTransform();
    }
  },
  remove: function (ecModel, api) {
    this._symbolDraw && this._symbolDraw.remove(api);
  },
  dispose: function () {}
});

module.exports = _default;

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var _symbol = __webpack_require__(99);

var createSymbol = _symbol.createSymbol;

var _graphic = __webpack_require__(27);

var Group = _graphic.Group;

var _number = __webpack_require__(37);

var parsePercent = _number.parsePercent;

var SymbolClz = __webpack_require__(301);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Symbol with ripple effect
 * @module echarts/chart/helper/EffectSymbol
 */
var EFFECT_RIPPLE_NUMBER = 3;

function normalizeSymbolSize(symbolSize) {
  if (!zrUtil.isArray(symbolSize)) {
    symbolSize = [+symbolSize, +symbolSize];
  }

  return symbolSize;
}

function updateRipplePath(rippleGroup, effectCfg) {
  var color = effectCfg.rippleEffectColor || effectCfg.color;
  rippleGroup.eachChild(function (ripplePath) {
    ripplePath.attr({
      z: effectCfg.z,
      zlevel: effectCfg.zlevel,
      style: {
        stroke: effectCfg.brushType === 'stroke' ? color : null,
        fill: effectCfg.brushType === 'fill' ? color : null
      }
    });
  });
}
/**
 * @constructor
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @extends {module:zrender/graphic/Group}
 */


function EffectSymbol(data, idx) {
  Group.call(this);
  var symbol = new SymbolClz(data, idx);
  var rippleGroup = new Group();
  this.add(symbol);
  this.add(rippleGroup);

  rippleGroup.beforeUpdate = function () {
    this.attr(symbol.getScale());
  };

  this.updateData(data, idx);
}

var effectSymbolProto = EffectSymbol.prototype;

effectSymbolProto.stopEffectAnimation = function () {
  this.childAt(1).removeAll();
};

effectSymbolProto.startEffectAnimation = function (effectCfg) {
  var symbolType = effectCfg.symbolType;
  var color = effectCfg.color;
  var rippleGroup = this.childAt(1);

  for (var i = 0; i < EFFECT_RIPPLE_NUMBER; i++) {
    // If width/height are set too small (e.g., set to 1) on ios10
    // and macOS Sierra, a circle stroke become a rect, no matter what
    // the scale is set. So we set width/height as 2. See #4136.
    var ripplePath = createSymbol(symbolType, -1, -1, 2, 2, color);
    ripplePath.attr({
      style: {
        strokeNoScale: true
      },
      z2: 99,
      silent: true,
      scale: [0.5, 0.5]
    });
    var delay = -i / EFFECT_RIPPLE_NUMBER * effectCfg.period + effectCfg.effectOffset; // TODO Configurable effectCfg.period

    ripplePath.animate('', true).when(effectCfg.period, {
      scale: [effectCfg.rippleScale / 2, effectCfg.rippleScale / 2]
    }).delay(delay).start();
    ripplePath.animateStyle(true).when(effectCfg.period, {
      opacity: 0
    }).delay(delay).start();
    rippleGroup.add(ripplePath);
  }

  updateRipplePath(rippleGroup, effectCfg);
};
/**
 * Update effect symbol
 */


effectSymbolProto.updateEffectAnimation = function (effectCfg) {
  var oldEffectCfg = this._effectCfg;
  var rippleGroup = this.childAt(1); // Must reinitialize effect if following configuration changed

  var DIFFICULT_PROPS = ['symbolType', 'period', 'rippleScale'];

  for (var i = 0; i < DIFFICULT_PROPS.length; i++) {
    var propName = DIFFICULT_PROPS[i];

    if (oldEffectCfg[propName] !== effectCfg[propName]) {
      this.stopEffectAnimation();
      this.startEffectAnimation(effectCfg);
      return;
    }
  }

  updateRipplePath(rippleGroup, effectCfg);
};
/**
 * Highlight symbol
 */


effectSymbolProto.highlight = function () {
  this.trigger('emphasis');
};
/**
 * Downplay symbol
 */


effectSymbolProto.downplay = function () {
  this.trigger('normal');
};
/**
 * Update symbol properties
 * @param  {module:echarts/data/List} data
 * @param  {number} idx
 */


effectSymbolProto.updateData = function (data, idx) {
  var seriesModel = data.hostModel;
  this.childAt(0).updateData(data, idx);
  var rippleGroup = this.childAt(1);
  var itemModel = data.getItemModel(idx);
  var symbolType = data.getItemVisual(idx, 'symbol');
  var symbolSize = normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
  var color = data.getItemVisual(idx, 'color');
  rippleGroup.attr('scale', symbolSize);
  rippleGroup.traverse(function (ripplePath) {
    ripplePath.attr({
      fill: color
    });
  });
  var symbolOffset = itemModel.getShallow('symbolOffset');

  if (symbolOffset) {
    var pos = rippleGroup.position;
    pos[0] = parsePercent(symbolOffset[0], symbolSize[0]);
    pos[1] = parsePercent(symbolOffset[1], symbolSize[1]);
  }

  var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
  rippleGroup.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
  var effectCfg = {};
  effectCfg.showEffectOn = seriesModel.get('showEffectOn');
  effectCfg.rippleScale = itemModel.get('rippleEffect.scale');
  effectCfg.brushType = itemModel.get('rippleEffect.brushType');
  effectCfg.period = itemModel.get('rippleEffect.period') * 1000;
  effectCfg.effectOffset = idx / data.count();
  effectCfg.z = itemModel.getShallow('z') || 0;
  effectCfg.zlevel = itemModel.getShallow('zlevel') || 0;
  effectCfg.symbolType = symbolType;
  effectCfg.color = color;
  effectCfg.rippleEffectColor = itemModel.get('rippleEffect.color');
  this.off('mouseover').off('mouseout').off('emphasis').off('normal');

  if (effectCfg.showEffectOn === 'render') {
    this._effectCfg ? this.updateEffectAnimation(effectCfg) : this.startEffectAnimation(effectCfg);
    this._effectCfg = effectCfg;
  } else {
    // Not keep old effect config
    this._effectCfg = null;
    this.stopEffectAnimation();
    var symbol = this.childAt(0);

    var onEmphasis = function () {
      symbol.highlight();

      if (effectCfg.showEffectOn !== 'render') {
        this.startEffectAnimation(effectCfg);
      }
    };

    var onNormal = function () {
      symbol.downplay();

      if (effectCfg.showEffectOn !== 'render') {
        this.stopEffectAnimation();
      }
    };

    this.on('mouseover', onEmphasis, this).on('mouseout', onNormal, this).on('emphasis', onEmphasis, this).on('normal', onNormal, this);
  }

  this._effectCfg = effectCfg;
};

effectSymbolProto.fadeOut = function (cb) {
  this.off('mouseover').off('mouseout').off('emphasis').off('normal');
  cb && cb();
};

zrUtil.inherits(EffectSymbol, Group);
var _default = EffectSymbol;
module.exports = _default;

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(1692);

__webpack_require__(1693);

var linesLayout = __webpack_require__(672);

var linesVisual = __webpack_require__(1696);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.registerLayout(linesLayout);
echarts.registerVisual(linesVisual);

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var SeriesModel = __webpack_require__(74);

var List = __webpack_require__(98);

var _util = __webpack_require__(1);

var concatArray = _util.concatArray;
var mergeAll = _util.mergeAll;
var map = _util.map;

var _format = __webpack_require__(54);

var encodeHTML = _format.encodeHTML;

var CoordinateSystem = __webpack_require__(108);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/* global Uint32Array, Float64Array, Float32Array */
var Uint32Arr = typeof Uint32Array === 'undefined' ? Array : Uint32Array;
var Float64Arr = typeof Float64Array === 'undefined' ? Array : Float64Array;

function compatEc2(seriesOpt) {
  var data = seriesOpt.data;

  if (data && data[0] && data[0][0] && data[0][0].coord) {
    seriesOpt.data = map(data, function (itemOpt) {
      var coords = [itemOpt[0].coord, itemOpt[1].coord];
      var target = {
        coords: coords
      };

      if (itemOpt[0].name) {
        target.fromName = itemOpt[0].name;
      }

      if (itemOpt[1].name) {
        target.toName = itemOpt[1].name;
      }

      return mergeAll([target, itemOpt[0], itemOpt[1]]);
    });
  }
}

var LinesSeries = SeriesModel.extend({
  type: 'series.lines',
  dependencies: ['grid', 'polar'],
  visualColorAccessPath: 'lineStyle.color',
  init: function (option) {
    // The input data may be null/undefined.
    option.data = option.data || []; // Not using preprocessor because mergeOption may not have series.type

    compatEc2(option);

    var result = this._processFlatCoordsArray(option.data);

    this._flatCoords = result.flatCoords;
    this._flatCoordsOffset = result.flatCoordsOffset;

    if (result.flatCoords) {
      option.data = new Float32Array(result.count);
    }

    LinesSeries.superApply(this, 'init', arguments);
  },
  mergeOption: function (option) {
    compatEc2(option);

    if (option.data) {
      // Only update when have option data to merge.
      var result = this._processFlatCoordsArray(option.data);

      this._flatCoords = result.flatCoords;
      this._flatCoordsOffset = result.flatCoordsOffset;

      if (result.flatCoords) {
        option.data = new Float32Array(result.count);
      }
    }

    LinesSeries.superApply(this, 'mergeOption', arguments);
  },
  appendData: function (params) {
    var result = this._processFlatCoordsArray(params.data);

    if (result.flatCoords) {
      if (!this._flatCoords) {
        this._flatCoords = result.flatCoords;
        this._flatCoordsOffset = result.flatCoordsOffset;
      } else {
        this._flatCoords = concatArray(this._flatCoords, result.flatCoords);
        this._flatCoordsOffset = concatArray(this._flatCoordsOffset, result.flatCoordsOffset);
      }

      params.data = new Float32Array(result.count);
    }

    this.getRawData().appendData(params.data);
  },
  _getCoordsFromItemModel: function (idx) {
    var itemModel = this.getData().getItemModel(idx);
    var coords = itemModel.option instanceof Array ? itemModel.option : itemModel.getShallow('coords');
    return coords;
  },
  getLineCoordsCount: function (idx) {
    if (this._flatCoordsOffset) {
      return this._flatCoordsOffset[idx * 2 + 1];
    } else {
      return this._getCoordsFromItemModel(idx).length;
    }
  },
  getLineCoords: function (idx, out) {
    if (this._flatCoordsOffset) {
      var offset = this._flatCoordsOffset[idx * 2];
      var len = this._flatCoordsOffset[idx * 2 + 1];

      for (var i = 0; i < len; i++) {
        out[i] = out[i] || [];
        out[i][0] = this._flatCoords[offset + i * 2];
        out[i][1] = this._flatCoords[offset + i * 2 + 1];
      }

      return len;
    } else {
      var coords = this._getCoordsFromItemModel(idx);

      for (var i = 0; i < coords.length; i++) {
        out[i] = out[i] || [];
        out[i][0] = coords[i][0];
        out[i][1] = coords[i][1];
      }

      return coords.length;
    }
  },
  _processFlatCoordsArray: function (data) {
    var startOffset = 0;

    if (this._flatCoords) {
      startOffset = this._flatCoords.length;
    } // Stored as a typed array. In format
    // Points Count(2) | x | y | x | y | Points Count(3) | x |  y | x | y | x | y |


    if (typeof data[0] === 'number') {
      var len = data.length; // Store offset and len of each segment

      var coordsOffsetAndLenStorage = new Uint32Arr(len);
      var coordsStorage = new Float64Arr(len);
      var coordsCursor = 0;
      var offsetCursor = 0;
      var dataCount = 0;

      for (var i = 0; i < len;) {
        dataCount++;
        var count = data[i++]; // Offset

        coordsOffsetAndLenStorage[offsetCursor++] = coordsCursor + startOffset; // Len

        coordsOffsetAndLenStorage[offsetCursor++] = count;

        for (var k = 0; k < count; k++) {
          var x = data[i++];
          var y = data[i++];
          coordsStorage[coordsCursor++] = x;
          coordsStorage[coordsCursor++] = y;

          if (i > len) {}
        }
      }

      return {
        flatCoordsOffset: new Uint32Array(coordsOffsetAndLenStorage.buffer, 0, offsetCursor),
        flatCoords: coordsStorage,
        count: dataCount
      };
    }

    return {
      flatCoordsOffset: null,
      flatCoords: null,
      count: data.length
    };
  },
  getInitialData: function (option, ecModel) {
    var lineData = new List(['value'], this);
    lineData.hasItemOption = false;
    lineData.initData(option.data, [], function (dataItem, dimName, dataIndex, dimIndex) {
      // dataItem is simply coords
      if (dataItem instanceof Array) {
        return NaN;
      } else {
        lineData.hasItemOption = true;
        var value = dataItem.value;

        if (value != null) {
          return value instanceof Array ? value[dimIndex] : value;
        }
      }
    });
    return lineData;
  },
  formatTooltip: function (dataIndex) {
    var data = this.getData();
    var itemModel = data.getItemModel(dataIndex);
    var name = itemModel.get('name');

    if (name) {
      return name;
    }

    var fromName = itemModel.get('fromName');
    var toName = itemModel.get('toName');
    var html = [];
    fromName != null && html.push(fromName);
    toName != null && html.push(toName);
    return encodeHTML(html.join(' > '));
  },
  preventIncremental: function () {
    return !!this.get('effect.show');
  },
  getProgressive: function () {
    var progressive = this.option.progressive;

    if (progressive == null) {
      return this.option.large ? 1e4 : this.get('progressive');
    }

    return progressive;
  },
  getProgressiveThreshold: function () {
    var progressiveThreshold = this.option.progressiveThreshold;

    if (progressiveThreshold == null) {
      return this.option.large ? 2e4 : this.get('progressiveThreshold');
    }

    return progressiveThreshold;
  },
  defaultOption: {
    coordinateSystem: 'geo',
    zlevel: 0,
    z: 2,
    legendHoverLink: true,
    hoverAnimation: true,
    // Cartesian coordinate system
    xAxisIndex: 0,
    yAxisIndex: 0,
    symbol: ['none', 'none'],
    symbolSize: [10, 10],
    // Geo coordinate system
    geoIndex: 0,
    effect: {
      show: false,
      period: 4,
      // Animation delay. support callback
      // delay: 0,
      // If move with constant speed px/sec
      // period will be ignored if this property is > 0,
      constantSpeed: 0,
      symbol: 'circle',
      symbolSize: 3,
      loop: true,
      // Length of trail, 0 - 1
      trailLength: 0.2 // Same with lineStyle.color
      // color

    },
    large: false,
    // Available when large is true
    largeThreshold: 2000,
    // If lines are polyline
    // polyline not support curveness, label, animation
    polyline: false,
    // If clip the overflow.
    // Available when coordinateSystem is cartesian or polar.
    clip: true,
    label: {
      show: false,
      position: 'end' // distance: 5,
      // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调

    },
    lineStyle: {
      opacity: 0.5
    }
  }
});
var _default = LinesSeries;
module.exports = _default;

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(23);

var LineDraw = __webpack_require__(422);

var EffectLine = __webpack_require__(670);

var Line = __webpack_require__(423);

var Polyline = __webpack_require__(671);

var EffectPolyline = __webpack_require__(1694);

var LargeLineDraw = __webpack_require__(1695);

var linesLayout = __webpack_require__(672);

var _createClipPathFromCoordSys = __webpack_require__(240);

var createClipPath = _createClipPathFromCoordSys.createClipPath;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = echarts.extendChartView({
  type: 'lines',
  init: function () {},
  render: function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();

    var lineDraw = this._updateLineDraw(data, seriesModel);

    var zlevel = seriesModel.get('zlevel');
    var trailLength = seriesModel.get('effect.trailLength');
    var zr = api.getZr(); // Avoid the drag cause ghost shadow
    // FIXME Better way ?
    // SVG doesn't support

    var isSvg = zr.painter.getType() === 'svg';

    if (!isSvg) {
      zr.painter.getLayer(zlevel).clear(true);
    } // Config layer with motion blur


    if (this._lastZlevel != null && !isSvg) {
      zr.configLayer(this._lastZlevel, {
        motionBlur: false
      });
    }

    if (this._showEffect(seriesModel) && trailLength) {
      if (!isSvg) {
        zr.configLayer(zlevel, {
          motionBlur: true,
          lastFrameAlpha: Math.max(Math.min(trailLength / 10 + 0.9, 1), 0)
        });
      }
    }

    lineDraw.updateData(data);
    var clipPath = seriesModel.get('clip', true) && createClipPath(seriesModel.coordinateSystem, false, seriesModel);

    if (clipPath) {
      this.group.setClipPath(clipPath);
    } else {
      this.group.removeClipPath();
    }

    this._lastZlevel = zlevel;
    this._finished = true;
  },
  incrementalPrepareRender: function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();

    var lineDraw = this._updateLineDraw(data, seriesModel);

    lineDraw.incrementalPrepareUpdate(data);

    this._clearLayer(api);

    this._finished = false;
  },
  incrementalRender: function (taskParams, seriesModel, ecModel) {
    this._lineDraw.incrementalUpdate(taskParams, seriesModel.getData());

    this._finished = taskParams.end === seriesModel.getData().count();
  },
  updateTransform: function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var pipelineContext = seriesModel.pipelineContext;

    if (!this._finished || pipelineContext.large || pipelineContext.progressiveRender) {
      // TODO Don't have to do update in large mode. Only do it when there are millions of data.
      return {
        update: true
      };
    } else {
      // TODO Use same logic with ScatterView.
      // Manually update layout
      var res = linesLayout.reset(seriesModel);

      if (res.progress) {
        res.progress({
          start: 0,
          end: data.count()
        }, data);
      }

      this._lineDraw.updateLayout();

      this._clearLayer(api);
    }
  },
  _updateLineDraw: function (data, seriesModel) {
    var lineDraw = this._lineDraw;

    var hasEffect = this._showEffect(seriesModel);

    var isPolyline = !!seriesModel.get('polyline');
    var pipelineContext = seriesModel.pipelineContext;
    var isLargeDraw = pipelineContext.large;

    if (!lineDraw || hasEffect !== this._hasEffet || isPolyline !== this._isPolyline || isLargeDraw !== this._isLargeDraw) {
      if (lineDraw) {
        lineDraw.remove();
      }

      lineDraw = this._lineDraw = isLargeDraw ? new LargeLineDraw() : new LineDraw(isPolyline ? hasEffect ? EffectPolyline : Polyline : hasEffect ? EffectLine : Line);
      this._hasEffet = hasEffect;
      this._isPolyline = isPolyline;
      this._isLargeDraw = isLargeDraw;
      this.group.removeAll();
    }

    this.group.add(lineDraw.group);
    return lineDraw;
  },
  _showEffect: function (seriesModel) {
    return !!seriesModel.get('effect.show');
  },
  _clearLayer: function (api) {
    // Not use motion when dragging or zooming
    var zr = api.getZr();
    var isSvg = zr.painter.getType() === 'svg';

    if (!isSvg && this._lastZlevel != null) {
      zr.painter.getLayer(this._lastZlevel).clear(true);
    }
  },
  remove: function (ecModel, api) {
    this._lineDraw && this._lineDraw.remove();
    this._lineDraw = null; // Clear motion when lineDraw is removed

    this._clearLayer(api);
  },
  dispose: function () {}
});

module.exports = _default;

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var Polyline = __webpack_require__(671);

var zrUtil = __webpack_require__(1);

var EffectLine = __webpack_require__(670);

var vec2 = __webpack_require__(55);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Provide effect for line
 * @module echarts/chart/helper/EffectLine
 */

/**
 * @constructor
 * @extends {module:echarts/chart/helper/EffectLine}
 * @alias {module:echarts/chart/helper/Polyline}
 */
function EffectPolyline(lineData, idx, seriesScope) {
  EffectLine.call(this, lineData, idx, seriesScope);
  this._lastFrame = 0;
  this._lastFramePercent = 0;
}

var effectPolylineProto = EffectPolyline.prototype; // Overwrite

effectPolylineProto.createLine = function (lineData, idx, seriesScope) {
  return new Polyline(lineData, idx, seriesScope);
}; // Overwrite


effectPolylineProto.updateAnimationPoints = function (symbol, points) {
  this._points = points;
  var accLenArr = [0];
  var len = 0;

  for (var i = 1; i < points.length; i++) {
    var p1 = points[i - 1];
    var p2 = points[i];
    len += vec2.dist(p1, p2);
    accLenArr.push(len);
  }

  if (len === 0) {
    return;
  }

  for (var i = 0; i < accLenArr.length; i++) {
    accLenArr[i] /= len;
  }

  this._offsets = accLenArr;
  this._length = len;
}; // Overwrite


effectPolylineProto.getLineLength = function (symbol) {
  return this._length;
}; // Overwrite


effectPolylineProto.updateSymbolPosition = function (symbol) {
  var t = symbol.__t;
  var points = this._points;
  var offsets = this._offsets;
  var len = points.length;

  if (!offsets) {
    // Has length 0
    return;
  }

  var lastFrame = this._lastFrame;
  var frame;

  if (t < this._lastFramePercent) {
    // Start from the next frame
    // PENDING start from lastFrame ?
    var start = Math.min(lastFrame + 1, len - 1);

    for (frame = start; frame >= 0; frame--) {
      if (offsets[frame] <= t) {
        break;
      }
    } // PENDING really need to do this ?


    frame = Math.min(frame, len - 2);
  } else {
    for (var frame = lastFrame; frame < len; frame++) {
      if (offsets[frame] > t) {
        break;
      }
    }

    frame = Math.min(frame - 1, len - 2);
  }

  vec2.lerp(symbol.position, points[frame], points[frame + 1], (t - offsets[frame]) / (offsets[frame + 1] - offsets[frame]));
  var tx = points[frame + 1][0] - points[frame][0];
  var ty = points[frame + 1][1] - points[frame][1];
  symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
  this._lastFrame = frame;
  this._lastFramePercent = t;
  symbol.ignore = false;
};

zrUtil.inherits(EffectPolyline, EffectLine);
var _default = EffectPolyline;
module.exports = _default;

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var graphic = __webpack_require__(27);

var IncrementalDisplayable = __webpack_require__(410);

var lineContain = __webpack_require__(625);

var quadraticContain = __webpack_require__(626);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// TODO Batch by color
var LargeLineShape = graphic.extendShape({
  shape: {
    polyline: false,
    curveness: 0,
    segs: []
  },
  buildPath: function (path, shape) {
    var segs = shape.segs;
    var curveness = shape.curveness;

    if (shape.polyline) {
      for (var i = 0; i < segs.length;) {
        var count = segs[i++];

        if (count > 0) {
          path.moveTo(segs[i++], segs[i++]);

          for (var k = 1; k < count; k++) {
            path.lineTo(segs[i++], segs[i++]);
          }
        }
      }
    } else {
      for (var i = 0; i < segs.length;) {
        var x0 = segs[i++];
        var y0 = segs[i++];
        var x1 = segs[i++];
        var y1 = segs[i++];
        path.moveTo(x0, y0);

        if (curveness > 0) {
          var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
          var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
          path.quadraticCurveTo(x2, y2, x1, y1);
        } else {
          path.lineTo(x1, y1);
        }
      }
    }
  },
  findDataIndex: function (x, y) {
    var shape = this.shape;
    var segs = shape.segs;
    var curveness = shape.curveness;

    if (shape.polyline) {
      var dataIndex = 0;

      for (var i = 0; i < segs.length;) {
        var count = segs[i++];

        if (count > 0) {
          var x0 = segs[i++];
          var y0 = segs[i++];

          for (var k = 1; k < count; k++) {
            var x1 = segs[i++];
            var y1 = segs[i++];

            if (lineContain.containStroke(x0, y0, x1, y1)) {
              return dataIndex;
            }
          }
        }

        dataIndex++;
      }
    } else {
      var dataIndex = 0;

      for (var i = 0; i < segs.length;) {
        var x0 = segs[i++];
        var y0 = segs[i++];
        var x1 = segs[i++];
        var y1 = segs[i++];

        if (curveness > 0) {
          var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
          var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;

          if (quadraticContain.containStroke(x0, y0, x2, y2, x1, y1)) {
            return dataIndex;
          }
        } else {
          if (lineContain.containStroke(x0, y0, x1, y1)) {
            return dataIndex;
          }
        }

        dataIndex++;
      }
    }

    return -1;
  }
});

function LargeLineDraw() {
  this.group = new graphic.Group();
}

var largeLineProto = LargeLineDraw.prototype;

largeLineProto.isPersistent = function () {
  return !this._incremental;
};
/**
 * Update symbols draw by new data
 * @param {module:echarts/data/List} data
 */


largeLineProto.updateData = function (data) {
  this.group.removeAll();
  var lineEl = new LargeLineShape({
    rectHover: true,
    cursor: 'default'
  });
  lineEl.setShape({
    segs: data.getLayout('linesPoints')
  });

  this._setCommon(lineEl, data); // Add back


  this.group.add(lineEl);
  this._incremental = null;
};
/**
 * @override
 */


largeLineProto.incrementalPrepareUpdate = function (data) {
  this.group.removeAll();

  this._clearIncremental();

  if (data.count() > 5e5) {
    if (!this._incremental) {
      this._incremental = new IncrementalDisplayable({
        silent: true
      });
    }

    this.group.add(this._incremental);
  } else {
    this._incremental = null;
  }
};
/**
 * @override
 */


largeLineProto.incrementalUpdate = function (taskParams, data) {
  var lineEl = new LargeLineShape();
  lineEl.setShape({
    segs: data.getLayout('linesPoints')
  });

  this._setCommon(lineEl, data, !!this._incremental);

  if (!this._incremental) {
    lineEl.rectHover = true;
    lineEl.cursor = 'default';
    lineEl.__startIndex = taskParams.start;
    this.group.add(lineEl);
  } else {
    this._incremental.addDisplayable(lineEl, true);
  }
};
/**
 * @override
 */


largeLineProto.remove = function () {
  this._clearIncremental();

  this._incremental = null;
  this.group.removeAll();
};

largeLineProto._setCommon = function (lineEl, data, isIncremental) {
  var hostModel = data.hostModel;
  lineEl.setShape({
    polyline: hostModel.get('polyline'),
    curveness: hostModel.get('lineStyle.curveness')
  });
  lineEl.useStyle(hostModel.getModel('lineStyle').getLineStyle());
  lineEl.style.strokeNoScale = true;
  var visualColor = data.getVisual('color');

  if (visualColor) {
    lineEl.setStyle('stroke', visualColor);
  }

  lineEl.setStyle('fill');

  if (!isIncremental) {
    // Enable tooltip
    // PENDING May have performance issue when path is extremely large
    lineEl.seriesIndex = hostModel.seriesIndex;
    lineEl.on('mousemove', function (e) {
      lineEl.dataIndex = null;
      var dataIndex = lineEl.findDataIndex(e.offsetX, e.offsetY);

      if (dataIndex > 0) {
        // Provide dataIndex for tooltip
        lineEl.dataIndex = dataIndex + lineEl.__startIndex;
      }
    });
  }
};

largeLineProto._clearIncremental = function () {
  var incremental = this._incremental;

  if (incremental) {
    incremental.clearDisplaybles();
  }
};

var _default = LargeLineDraw;
module.exports = _default;

/***/ }),
/* 1696 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function normalize(a) {
  if (!(a instanceof Array)) {
    a = [a, a];
  }

  return a;
}

var opacityQuery = 'lineStyle.opacity'.split('.');
var _default = {
  seriesType: 'lines',
  reset: function (seriesModel, ecModel, api) {
    var symbolType = normalize(seriesModel.get('symbol'));
    var symbolSize = normalize(seriesModel.get('symbolSize'));
    var data = seriesModel.getData();
    data.setVisual('fromSymbol', symbolType && symbolType[0]);
    data.setVisual('toSymbol', symbolType && symbolType[1]);
    data.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
    data.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
    data.setVisual('opacity', seriesModel.get(opacityQuery));

    function dataEach(data, idx) {
      var itemModel = data.getItemModel(idx);
      var symbolType = normalize(itemModel.getShallow('symbol', true));
      var symbolSize = normalize(itemModel.getShallow('symbolSize', true));
      var opacity = itemModel.get(opacityQuery);
      symbolType[0] && data.setItemVisual(idx, 'fromSymbol', symbolType[0]);
      symbolType[1] && data.setItemVisual(idx, 'toSymbol', symbolType[1]);
      symbolSize[0] && data.setItemVisual(idx, 'fromSymbolSize', symbolSize[0]);
      symbolSize[1] && data.setItemVisual(idx, 'toSymbolSize', symbolSize[1]);
      data.setItemVisual(idx, 'opacity', opacity);
    }

    return {
      dataEach: data.hasItemOption ? dataEach : null
    };
  }
};
module.exports = _default;

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

__webpack_require__(1698);

__webpack_require__(1699);

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var SeriesModel = __webpack_require__(74);

var createListFromArray = __webpack_require__(137);

var CoordinateSystem = __webpack_require__(108);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = SeriesModel.extend({
  type: 'series.heatmap',
  getInitialData: function (option, ecModel) {
    return createListFromArray(this.getSource(), this, {
      generateCoord: 'value'
    });
  },
  preventIncremental: function () {
    var coordSysCreator = CoordinateSystem.get(this.get('coordinateSystem'));

    if (coordSysCreator && coordSysCreator.dimensions) {
      return coordSysCreator.dimensions[0] === 'lng' && coordSysCreator.dimensions[1] === 'lat';
    }
  },
  defaultOption: {
    // Cartesian2D or geo
    coordinateSystem: 'cartesian2d',
    zlevel: 0,
    z: 2,
    // Cartesian coordinate system
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // Geo coordinate system
    geoIndex: 0,
    blurSize: 30,
    pointSize: 20,
    maxOpacity: 1,
    minOpacity: 0
  }
});

module.exports = _default;

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(23);

var graphic = __webpack_require__(27);

var HeatmapLayer = __webpack_require__(1700);

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function getIsInPiecewiseRange(dataExtent, pieceList, selected) {
  var dataSpan = dataExtent[1] - dataExtent[0];
  pieceList = zrUtil.map(pieceList, function (piece) {
    return {
      interval: [(piece.interval[0] - dataExtent[0]) / dataSpan, (piece.interval[1] - dataExtent[0]) / dataSpan]
    };
  });
  var len = pieceList.length;
  var lastIndex = 0;
  return function (val) {
    // Try to find in the location of the last found
    for (var i = lastIndex; i < len; i++) {
      var interval = pieceList[i].interval;

      if (interval[0] <= val && val <= interval[1]) {
        lastIndex = i;
        break;
      }
    }

    if (i === len) {
      // Not found, back interation
      for (var i = lastIndex - 1; i >= 0; i--) {
        var interval = pieceList[i].interval;

        if (interval[0] <= val && val <= interval[1]) {
          lastIndex = i;
          break;
        }
      }
    }

    return i >= 0 && i < len && selected[i];
  };
}

function getIsInContinuousRange(dataExtent, range) {
  var dataSpan = dataExtent[1] - dataExtent[0];
  range = [(range[0] - dataExtent[0]) / dataSpan, (range[1] - dataExtent[0]) / dataSpan];
  return function (val) {
    return val >= range[0] && val <= range[1];
  };
}

function isGeoCoordSys(coordSys) {
  var dimensions = coordSys.dimensions; // Not use coorSys.type === 'geo' because coordSys maybe extended

  return dimensions[0] === 'lng' && dimensions[1] === 'lat';
}

var _default = echarts.extendChartView({
  type: 'heatmap',
  render: function (seriesModel, ecModel, api) {
    var visualMapOfThisSeries;
    ecModel.eachComponent('visualMap', function (visualMap) {
      visualMap.eachTargetSeries(function (targetSeries) {
        if (targetSeries === seriesModel) {
          visualMapOfThisSeries = visualMap;
        }
      });
    });
    this.group.removeAll();
    this._incrementalDisplayable = null;
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys.type === 'cartesian2d' || coordSys.type === 'calendar') {
      this._renderOnCartesianAndCalendar(seriesModel, api, 0, seriesModel.getData().count());
    } else if (isGeoCoordSys(coordSys)) {
      this._renderOnGeo(coordSys, seriesModel, visualMapOfThisSeries, api);
    }
  },
  incrementalPrepareRender: function (seriesModel, ecModel, api) {
    this.group.removeAll();
  },
  incrementalRender: function (params, seriesModel, ecModel, api) {
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys) {
      this._renderOnCartesianAndCalendar(seriesModel, api, params.start, params.end, true);
    }
  },
  _renderOnCartesianAndCalendar: function (seriesModel, api, start, end, incremental) {
    var coordSys = seriesModel.coordinateSystem;
    var width;
    var height;

    if (coordSys.type === 'cartesian2d') {
      var xAxis = coordSys.getAxis('x');
      var yAxis = coordSys.getAxis('y');
      width = xAxis.getBandWidth();
      height = yAxis.getBandWidth();
    }

    var group = this.group;
    var data = seriesModel.getData();
    var itemStyleQuery = 'itemStyle';
    var hoverItemStyleQuery = 'emphasis.itemStyle';
    var labelQuery = 'label';
    var hoverLabelQuery = 'emphasis.label';
    var style = seriesModel.getModel(itemStyleQuery).getItemStyle(['color']);
    var hoverStl = seriesModel.getModel(hoverItemStyleQuery).getItemStyle();
    var labelModel = seriesModel.getModel(labelQuery);
    var hoverLabelModel = seriesModel.getModel(hoverLabelQuery);
    var coordSysType = coordSys.type;
    var dataDims = coordSysType === 'cartesian2d' ? [data.mapDimension('x'), data.mapDimension('y'), data.mapDimension('value')] : [data.mapDimension('time'), data.mapDimension('value')];

    for (var idx = start; idx < end; idx++) {
      var rect;

      if (coordSysType === 'cartesian2d') {
        // Ignore empty data
        if (isNaN(data.get(dataDims[2], idx))) {
          continue;
        }

        var point = coordSys.dataToPoint([data.get(dataDims[0], idx), data.get(dataDims[1], idx)]);
        rect = new graphic.Rect({
          shape: {
            x: Math.floor(Math.round(point[0]) - width / 2),
            y: Math.floor(Math.round(point[1]) - height / 2),
            width: Math.ceil(width),
            height: Math.ceil(height)
          },
          style: {
            fill: data.getItemVisual(idx, 'color'),
            opacity: data.getItemVisual(idx, 'opacity')
          }
        });
      } else {
        // Ignore empty data
        if (isNaN(data.get(dataDims[1], idx))) {
          continue;
        }

        rect = new graphic.Rect({
          z2: 1,
          shape: coordSys.dataToRect([data.get(dataDims[0], idx)]).contentShape,
          style: {
            fill: data.getItemVisual(idx, 'color'),
            opacity: data.getItemVisual(idx, 'opacity')
          }
        });
      }

      var itemModel = data.getItemModel(idx); // Optimization for large datset

      if (data.hasItemOption) {
        style = itemModel.getModel(itemStyleQuery).getItemStyle(['color']);
        hoverStl = itemModel.getModel(hoverItemStyleQuery).getItemStyle();
        labelModel = itemModel.getModel(labelQuery);
        hoverLabelModel = itemModel.getModel(hoverLabelQuery);
      }

      var rawValue = seriesModel.getRawValue(idx);
      var defaultText = '-';

      if (rawValue && rawValue[2] != null) {
        defaultText = rawValue[2];
      }

      graphic.setLabelStyle(style, hoverStl, labelModel, hoverLabelModel, {
        labelFetcher: seriesModel,
        labelDataIndex: idx,
        defaultText: defaultText,
        isRectText: true
      });
      rect.setStyle(style);
      graphic.setHoverStyle(rect, data.hasItemOption ? hoverStl : zrUtil.extend({}, hoverStl));
      rect.incremental = incremental; // PENDING

      if (incremental) {
        // Rect must use hover layer if it's incremental.
        rect.useHoverLayer = true;
      }

      group.add(rect);
      data.setItemGraphicEl(idx, rect);
    }
  },
  _renderOnGeo: function (geo, seriesModel, visualMapModel, api) {
    var inRangeVisuals = visualMapModel.targetVisuals.inRange;
    var outOfRangeVisuals = visualMapModel.targetVisuals.outOfRange; // if (!visualMapping) {
    //     throw new Error('Data range must have color visuals');
    // }

    var data = seriesModel.getData();
    var hmLayer = this._hmLayer || this._hmLayer || new HeatmapLayer();
    hmLayer.blurSize = seriesModel.get('blurSize');
    hmLayer.pointSize = seriesModel.get('pointSize');
    hmLayer.minOpacity = seriesModel.get('minOpacity');
    hmLayer.maxOpacity = seriesModel.get('maxOpacity');
    var rect = geo.getViewRect().clone();
    var roamTransform = geo.getRoamTransform();
    rect.applyTransform(roamTransform); // Clamp on viewport

    var x = Math.max(rect.x, 0);
    var y = Math.max(rect.y, 0);
    var x2 = Math.min(rect.width + rect.x, api.getWidth());
    var y2 = Math.min(rect.height + rect.y, api.getHeight());
    var width = x2 - x;
    var height = y2 - y;
    var dims = [data.mapDimension('lng'), data.mapDimension('lat'), data.mapDimension('value')];
    var points = data.mapArray(dims, function (lng, lat, value) {
      var pt = geo.dataToPoint([lng, lat]);
      pt[0] -= x;
      pt[1] -= y;
      pt.push(value);
      return pt;
    });
    var dataExtent = visualMapModel.getExtent();
    var isInRange = visualMapModel.type === 'visualMap.continuous' ? getIsInContinuousRange(dataExtent, visualMapModel.option.range) : getIsInPiecewiseRange(dataExtent, visualMapModel.getPieceList(), visualMapModel.option.selected);
    hmLayer.update(points, width, height, inRangeVisuals.color.getNormalizer(), {
      inRange: inRangeVisuals.color.getColorMapper(),
      outOfRange: outOfRangeVisuals.color.getColorMapper()
    }, isInRange);
    var img = new graphic.Image({
      style: {
        width: width,
        height: height,
        x: x,
        y: y,
        image: hmLayer.canvas
      },
      silent: true
    });
    this.group.add(img);
  },
  dispose: function () {}
});

module.exports = _default;

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/* global Uint8ClampedArray */
var GRADIENT_LEVELS = 256;
/**
 * Heatmap Chart
 *
 * @class
 */

function Heatmap() {
  var canvas = zrUtil.createCanvas();
  this.canvas = canvas;
  this.blurSize = 30;
  this.pointSize = 20;
  this.maxOpacity = 1;
  this.minOpacity = 0;
  this._gradientPixels = {};
}

Heatmap.prototype = {
  /**
   * Renders Heatmap and returns the rendered canvas
   * @param {Array} data array of data, each has x, y, value
   * @param {number} width canvas width
   * @param {number} height canvas height
   */
  update: function (data, width, height, normalize, colorFunc, isInRange) {
    var brush = this._getBrush();

    var gradientInRange = this._getGradient(data, colorFunc, 'inRange');

    var gradientOutOfRange = this._getGradient(data, colorFunc, 'outOfRange');

    var r = this.pointSize + this.blurSize;
    var canvas = this.canvas;
    var ctx = canvas.getContext('2d');
    var len = data.length;
    canvas.width = width;
    canvas.height = height;

    for (var i = 0; i < len; ++i) {
      var p = data[i];
      var x = p[0];
      var y = p[1];
      var value = p[2]; // calculate alpha using value

      var alpha = normalize(value); // draw with the circle brush with alpha

      ctx.globalAlpha = alpha;
      ctx.drawImage(brush, x - r, y - r);
    }

    if (!canvas.width || !canvas.height) {
      // Avoid "Uncaught DOMException: Failed to execute 'getImageData' on
      // 'CanvasRenderingContext2D': The source height is 0."
      return canvas;
    } // colorize the canvas using alpha value and set with gradient


    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var pixels = imageData.data;
    var offset = 0;
    var pixelLen = pixels.length;
    var minOpacity = this.minOpacity;
    var maxOpacity = this.maxOpacity;
    var diffOpacity = maxOpacity - minOpacity;

    while (offset < pixelLen) {
      var alpha = pixels[offset + 3] / 256;
      var gradientOffset = Math.floor(alpha * (GRADIENT_LEVELS - 1)) * 4; // Simple optimize to ignore the empty data

      if (alpha > 0) {
        var gradient = isInRange(alpha) ? gradientInRange : gradientOutOfRange; // Any alpha > 0 will be mapped to [minOpacity, maxOpacity]

        alpha > 0 && (alpha = alpha * diffOpacity + minOpacity);
        pixels[offset++] = gradient[gradientOffset];
        pixels[offset++] = gradient[gradientOffset + 1];
        pixels[offset++] = gradient[gradientOffset + 2];
        pixels[offset++] = gradient[gradientOffset + 3] * alpha * 256;
      } else {
        offset += 4;
      }
    }

    ctx.putImageData(imageData, 0, 0);
    return canvas;
  },

  /**
   * get canvas of a black circle brush used for canvas to draw later
   * @private
   * @returns {Object} circle brush canvas
   */
  _getBrush: function () {
    var brushCanvas = this._brushCanvas || (this._brushCanvas = zrUtil.createCanvas()); // set brush size

    var r = this.pointSize + this.blurSize;
    var d = r * 2;
    brushCanvas.width = d;
    brushCanvas.height = d;
    var ctx = brushCanvas.getContext('2d');
    ctx.clearRect(0, 0, d, d); // in order to render shadow without the distinct circle,
    // draw the distinct circle in an invisible place,
    // and use shadowOffset to draw shadow in the center of the canvas

    ctx.shadowOffsetX = d;
    ctx.shadowBlur = this.blurSize; // draw the shadow in black, and use alpha and shadow blur to generate
    // color in color map

    ctx.shadowColor = '#000'; // draw circle in the left to the canvas

    ctx.beginPath();
    ctx.arc(-r, r, this.pointSize, 0, Math.PI * 2, true);
    ctx.closePath();
    ctx.fill();
    return brushCanvas;
  },

  /**
   * get gradient color map
   * @private
   */
  _getGradient: function (data, colorFunc, state) {
    var gradientPixels = this._gradientPixels;
    var pixelsSingleState = gradientPixels[state] || (gradientPixels[state] = new Uint8ClampedArray(256 * 4));
    var color = [0, 0, 0, 0];
    var off = 0;

    for (var i = 0; i < 256; i++) {
      colorFunc[state](i / 255, true, color);
      pixelsSingleState[off++] = color[0];
      pixelsSingleState[off++] = color[1];
      pixelsSingleState[off++] = color[2];
      pixelsSingleState[off++] = color[3];
    }

    return pixelsSingleState;
  }
};
var _default = Heatmap;
module.exports = _default;

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

__webpack_require__(415);

__webpack_require__(1702);

__webpack_require__(1703);

var _barGrid = __webpack_require__(300);

var layout = _barGrid.layout;

var visualSymbol = __webpack_require__(178);

__webpack_require__(242);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// In case developer forget to include grid component
echarts.registerLayout(zrUtil.curry(layout, 'pictorialBar'));
echarts.registerVisual(visualSymbol('pictorialBar', 'roundRect'));

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var BaseBarSeries = __webpack_require__(654);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var PictorialBarSeries = BaseBarSeries.extend({
  type: 'series.pictorialBar',
  dependencies: ['grid'],
  defaultOption: {
    symbol: 'circle',
    // Customized bar shape
    symbolSize: null,
    // Can be ['100%', '100%'], null means auto.
    symbolRotate: null,
    symbolPosition: null,
    // 'start' or 'end' or 'center', null means auto.
    symbolOffset: null,
    symbolMargin: null,
    // start margin and end margin. Can be a number or a percent string.
    // Auto margin by default.
    symbolRepeat: false,
    // false/null/undefined, means no repeat.
    // Can be true, means auto calculate repeat times and cut by data.
    // Can be a number, specifies repeat times, and do not cut by data.
    // Can be 'fixed', means auto calculate repeat times but do not cut by data.
    symbolRepeatDirection: 'end',
    // 'end' means from 'start' to 'end'.
    symbolClip: false,
    symbolBoundingData: null,
    // Can be 60 or -40 or [-40, 60]
    symbolPatternSize: 400,
    // 400 * 400 px
    barGap: '-100%',
    // In most case, overlap is needed.
    // z can be set in data item, which is z2 actually.
    // Disable progressive
    progressive: 0,
    hoverAnimation: false // Open only when needed.

  },
  getInitialData: function (option) {
    // Disable stack.
    option.stack = null;
    return PictorialBarSeries.superApply(this, 'getInitialData', arguments);
  }
});
var _default = PictorialBarSeries;
module.exports = _default;

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var graphic = __webpack_require__(27);

var _symbol = __webpack_require__(99);

var createSymbol = _symbol.createSymbol;

var _number = __webpack_require__(37);

var parsePercent = _number.parsePercent;
var isNumeric = _number.isNumeric;

var _helper = __webpack_require__(655);

var setLabel = _helper.setLabel;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var BAR_BORDER_WIDTH_QUERY = ['itemStyle', 'borderWidth']; // index: +isHorizontal

var LAYOUT_ATTRS = [{
  xy: 'x',
  wh: 'width',
  index: 0,
  posDesc: ['left', 'right']
}, {
  xy: 'y',
  wh: 'height',
  index: 1,
  posDesc: ['top', 'bottom']
}];
var pathForLineWidth = new graphic.Circle();
var BarView = echarts.extendChartView({
  type: 'pictorialBar',
  render: function (seriesModel, ecModel, api) {
    var group = this.group;
    var data = seriesModel.getData();
    var oldData = this._data;
    var cartesian = seriesModel.coordinateSystem;
    var baseAxis = cartesian.getBaseAxis();
    var isHorizontal = !!baseAxis.isHorizontal();
    var coordSysRect = cartesian.grid.getRect();
    var opt = {
      ecSize: {
        width: api.getWidth(),
        height: api.getHeight()
      },
      seriesModel: seriesModel,
      coordSys: cartesian,
      coordSysExtent: [[coordSysRect.x, coordSysRect.x + coordSysRect.width], [coordSysRect.y, coordSysRect.y + coordSysRect.height]],
      isHorizontal: isHorizontal,
      valueDim: LAYOUT_ATTRS[+isHorizontal],
      categoryDim: LAYOUT_ATTRS[1 - isHorizontal]
    };
    data.diff(oldData).add(function (dataIndex) {
      if (!data.hasValue(dataIndex)) {
        return;
      }

      var itemModel = getItemModel(data, dataIndex);
      var symbolMeta = getSymbolMeta(data, dataIndex, itemModel, opt);
      var bar = createBar(data, opt, symbolMeta);
      data.setItemGraphicEl(dataIndex, bar);
      group.add(bar);
      updateCommon(bar, opt, symbolMeta);
    }).update(function (newIndex, oldIndex) {
      var bar = oldData.getItemGraphicEl(oldIndex);

      if (!data.hasValue(newIndex)) {
        group.remove(bar);
        return;
      }

      var itemModel = getItemModel(data, newIndex);
      var symbolMeta = getSymbolMeta(data, newIndex, itemModel, opt);
      var pictorialShapeStr = getShapeStr(data, symbolMeta);

      if (bar && pictorialShapeStr !== bar.__pictorialShapeStr) {
        group.remove(bar);
        data.setItemGraphicEl(newIndex, null);
        bar = null;
      }

      if (bar) {
        updateBar(bar, opt, symbolMeta);
      } else {
        bar = createBar(data, opt, symbolMeta, true);
      }

      data.setItemGraphicEl(newIndex, bar);
      bar.__pictorialSymbolMeta = symbolMeta; // Add back

      group.add(bar);
      updateCommon(bar, opt, symbolMeta);
    }).remove(function (dataIndex) {
      var bar = oldData.getItemGraphicEl(dataIndex);
      bar && removeBar(oldData, dataIndex, bar.__pictorialSymbolMeta.animationModel, bar);
    }).execute();
    this._data = data;
    return this.group;
  },
  dispose: zrUtil.noop,
  remove: function (ecModel, api) {
    var group = this.group;
    var data = this._data;

    if (ecModel.get('animation')) {
      if (data) {
        data.eachItemGraphicEl(function (bar) {
          removeBar(data, bar.dataIndex, ecModel, bar);
        });
      }
    } else {
      group.removeAll();
    }
  }
}); // Set or calculate default value about symbol, and calculate layout info.

function getSymbolMeta(data, dataIndex, itemModel, opt) {
  var layout = data.getItemLayout(dataIndex);
  var symbolRepeat = itemModel.get('symbolRepeat');
  var symbolClip = itemModel.get('symbolClip');
  var symbolPosition = itemModel.get('symbolPosition') || 'start';
  var symbolRotate = itemModel.get('symbolRotate');
  var rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
  var symbolPatternSize = itemModel.get('symbolPatternSize') || 2;
  var isAnimationEnabled = itemModel.isAnimationEnabled();
  var symbolMeta = {
    dataIndex: dataIndex,
    layout: layout,
    itemModel: itemModel,
    symbolType: data.getItemVisual(dataIndex, 'symbol') || 'circle',
    color: data.getItemVisual(dataIndex, 'color'),
    symbolClip: symbolClip,
    symbolRepeat: symbolRepeat,
    symbolRepeatDirection: itemModel.get('symbolRepeatDirection'),
    symbolPatternSize: symbolPatternSize,
    rotation: rotation,
    animationModel: isAnimationEnabled ? itemModel : null,
    hoverAnimation: isAnimationEnabled && itemModel.get('hoverAnimation'),
    z2: itemModel.getShallow('z', true) || 0
  };
  prepareBarLength(itemModel, symbolRepeat, layout, opt, symbolMeta);
  prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, symbolMeta.boundingLength, symbolMeta.pxSign, symbolPatternSize, opt, symbolMeta);
  prepareLineWidth(itemModel, symbolMeta.symbolScale, rotation, opt, symbolMeta);
  var symbolSize = symbolMeta.symbolSize;
  var symbolOffset = itemModel.get('symbolOffset');

  if (zrUtil.isArray(symbolOffset)) {
    symbolOffset = [parsePercent(symbolOffset[0], symbolSize[0]), parsePercent(symbolOffset[1], symbolSize[1])];
  }

  prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, symbolMeta.valueLineWidth, symbolMeta.boundingLength, symbolMeta.repeatCutLength, opt, symbolMeta);
  return symbolMeta;
} // bar length can be negative.


function prepareBarLength(itemModel, symbolRepeat, layout, opt, output) {
  var valueDim = opt.valueDim;
  var symbolBoundingData = itemModel.get('symbolBoundingData');
  var valueAxis = opt.coordSys.getOtherAxis(opt.coordSys.getBaseAxis());
  var zeroPx = valueAxis.toGlobalCoord(valueAxis.dataToCoord(0));
  var pxSignIdx = 1 - +(layout[valueDim.wh] <= 0);
  var boundingLength;

  if (zrUtil.isArray(symbolBoundingData)) {
    var symbolBoundingExtent = [convertToCoordOnAxis(valueAxis, symbolBoundingData[0]) - zeroPx, convertToCoordOnAxis(valueAxis, symbolBoundingData[1]) - zeroPx];
    symbolBoundingExtent[1] < symbolBoundingExtent[0] && symbolBoundingExtent.reverse();
    boundingLength = symbolBoundingExtent[pxSignIdx];
  } else if (symbolBoundingData != null) {
    boundingLength = convertToCoordOnAxis(valueAxis, symbolBoundingData) - zeroPx;
  } else if (symbolRepeat) {
    boundingLength = opt.coordSysExtent[valueDim.index][pxSignIdx] - zeroPx;
  } else {
    boundingLength = layout[valueDim.wh];
  }

  output.boundingLength = boundingLength;

  if (symbolRepeat) {
    output.repeatCutLength = layout[valueDim.wh];
  }

  output.pxSign = boundingLength > 0 ? 1 : boundingLength < 0 ? -1 : 0;
}

function convertToCoordOnAxis(axis, value) {
  return axis.toGlobalCoord(axis.dataToCoord(axis.scale.parse(value)));
} // Support ['100%', '100%']


function prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, boundingLength, pxSign, symbolPatternSize, opt, output) {
  var valueDim = opt.valueDim;
  var categoryDim = opt.categoryDim;
  var categorySize = Math.abs(layout[categoryDim.wh]);
  var symbolSize = data.getItemVisual(dataIndex, 'symbolSize');

  if (zrUtil.isArray(symbolSize)) {
    symbolSize = symbolSize.slice();
  } else {
    if (symbolSize == null) {
      symbolSize = '100%';
    }

    symbolSize = [symbolSize, symbolSize];
  } // Note: percentage symbolSize (like '100%') do not consider lineWidth, because it is
  // to complicated to calculate real percent value if considering scaled lineWidth.
  // So the actual size will bigger than layout size if lineWidth is bigger than zero,
  // which can be tolerated in pictorial chart.


  symbolSize[categoryDim.index] = parsePercent(symbolSize[categoryDim.index], categorySize);
  symbolSize[valueDim.index] = parsePercent(symbolSize[valueDim.index], symbolRepeat ? categorySize : Math.abs(boundingLength));
  output.symbolSize = symbolSize; // If x or y is less than zero, show reversed shape.

  var symbolScale = output.symbolScale = [symbolSize[0] / symbolPatternSize, symbolSize[1] / symbolPatternSize]; // Follow convention, 'right' and 'top' is the normal scale.

  symbolScale[valueDim.index] *= (opt.isHorizontal ? -1 : 1) * pxSign;
}

function prepareLineWidth(itemModel, symbolScale, rotation, opt, output) {
  // In symbols are drawn with scale, so do not need to care about the case that width
  // or height are too small. But symbol use strokeNoScale, where acture lineWidth should
  // be calculated.
  var valueLineWidth = itemModel.get(BAR_BORDER_WIDTH_QUERY) || 0;

  if (valueLineWidth) {
    pathForLineWidth.attr({
      scale: symbolScale.slice(),
      rotation: rotation
    });
    pathForLineWidth.updateTransform();
    valueLineWidth /= pathForLineWidth.getLineScale();
    valueLineWidth *= symbolScale[opt.valueDim.index];
  }

  output.valueLineWidth = valueLineWidth;
}

function prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, valueLineWidth, boundingLength, repeatCutLength, opt, output) {
  var categoryDim = opt.categoryDim;
  var valueDim = opt.valueDim;
  var pxSign = output.pxSign;
  var unitLength = Math.max(symbolSize[valueDim.index] + valueLineWidth, 0);
  var pathLen = unitLength; // Note: rotation will not effect the layout of symbols, because user may
  // want symbols to rotate on its center, which should not be translated
  // when rotating.

  if (symbolRepeat) {
    var absBoundingLength = Math.abs(boundingLength);
    var symbolMargin = zrUtil.retrieve(itemModel.get('symbolMargin'), '15%') + '';
    var hasEndGap = false;

    if (symbolMargin.lastIndexOf('!') === symbolMargin.length - 1) {
      hasEndGap = true;
      symbolMargin = symbolMargin.slice(0, symbolMargin.length - 1);
    }

    symbolMargin = parsePercent(symbolMargin, symbolSize[valueDim.index]);
    var uLenWithMargin = Math.max(unitLength + symbolMargin * 2, 0); // When symbol margin is less than 0, margin at both ends will be subtracted
    // to ensure that all of the symbols will not be overflow the given area.

    var endFix = hasEndGap ? 0 : symbolMargin * 2; // Both final repeatTimes and final symbolMargin area calculated based on
    // boundingLength.

    var repeatSpecified = isNumeric(symbolRepeat);
    var repeatTimes = repeatSpecified ? symbolRepeat : toIntTimes((absBoundingLength + endFix) / uLenWithMargin); // Adjust calculate margin, to ensure each symbol is displayed
    // entirely in the given layout area.

    var mDiff = absBoundingLength - repeatTimes * unitLength;
    symbolMargin = mDiff / 2 / (hasEndGap ? repeatTimes : repeatTimes - 1);
    uLenWithMargin = unitLength + symbolMargin * 2;
    endFix = hasEndGap ? 0 : symbolMargin * 2; // Update repeatTimes when not all symbol will be shown.

    if (!repeatSpecified && symbolRepeat !== 'fixed') {
      repeatTimes = repeatCutLength ? toIntTimes((Math.abs(repeatCutLength) + endFix) / uLenWithMargin) : 0;
    }

    pathLen = repeatTimes * uLenWithMargin - endFix;
    output.repeatTimes = repeatTimes;
    output.symbolMargin = symbolMargin;
  }

  var sizeFix = pxSign * (pathLen / 2);
  var pathPosition = output.pathPosition = [];
  pathPosition[categoryDim.index] = layout[categoryDim.wh] / 2;
  pathPosition[valueDim.index] = symbolPosition === 'start' ? sizeFix : symbolPosition === 'end' ? boundingLength - sizeFix : boundingLength / 2; // 'center'

  if (symbolOffset) {
    pathPosition[0] += symbolOffset[0];
    pathPosition[1] += symbolOffset[1];
  }

  var bundlePosition = output.bundlePosition = [];
  bundlePosition[categoryDim.index] = layout[categoryDim.xy];
  bundlePosition[valueDim.index] = layout[valueDim.xy];
  var barRectShape = output.barRectShape = zrUtil.extend({}, layout);
  barRectShape[valueDim.wh] = pxSign * Math.max(Math.abs(layout[valueDim.wh]), Math.abs(pathPosition[valueDim.index] + sizeFix));
  barRectShape[categoryDim.wh] = layout[categoryDim.wh];
  var clipShape = output.clipShape = {}; // Consider that symbol may be overflow layout rect.

  clipShape[categoryDim.xy] = -layout[categoryDim.xy];
  clipShape[categoryDim.wh] = opt.ecSize[categoryDim.wh];
  clipShape[valueDim.xy] = 0;
  clipShape[valueDim.wh] = layout[valueDim.wh];
}

function createPath(symbolMeta) {
  var symbolPatternSize = symbolMeta.symbolPatternSize;
  var path = createSymbol( // Consider texture img, make a big size.
  symbolMeta.symbolType, -symbolPatternSize / 2, -symbolPatternSize / 2, symbolPatternSize, symbolPatternSize, symbolMeta.color);
  path.attr({
    culling: true
  });
  path.type !== 'image' && path.setStyle({
    strokeNoScale: true
  });
  return path;
}

function createOrUpdateRepeatSymbols(bar, opt, symbolMeta, isUpdate) {
  var bundle = bar.__pictorialBundle;
  var symbolSize = symbolMeta.symbolSize;
  var valueLineWidth = symbolMeta.valueLineWidth;
  var pathPosition = symbolMeta.pathPosition;
  var valueDim = opt.valueDim;
  var repeatTimes = symbolMeta.repeatTimes || 0;
  var index = 0;
  var unit = symbolSize[opt.valueDim.index] + valueLineWidth + symbolMeta.symbolMargin * 2;
  eachPath(bar, function (path) {
    path.__pictorialAnimationIndex = index;
    path.__pictorialRepeatTimes = repeatTimes;

    if (index < repeatTimes) {
      updateAttr(path, null, makeTarget(index), symbolMeta, isUpdate);
    } else {
      updateAttr(path, null, {
        scale: [0, 0]
      }, symbolMeta, isUpdate, function () {
        bundle.remove(path);
      });
    }

    updateHoverAnimation(path, symbolMeta);
    index++;
  });

  for (; index < repeatTimes; index++) {
    var path = createPath(symbolMeta);
    path.__pictorialAnimationIndex = index;
    path.__pictorialRepeatTimes = repeatTimes;
    bundle.add(path);
    var target = makeTarget(index);
    updateAttr(path, {
      position: target.position,
      scale: [0, 0]
    }, {
      scale: target.scale,
      rotation: target.rotation
    }, symbolMeta, isUpdate); // FIXME
    // If all emphasis/normal through action.

    path.on('mouseover', onMouseOver).on('mouseout', onMouseOut);
    updateHoverAnimation(path, symbolMeta);
  }

  function makeTarget(index) {
    var position = pathPosition.slice(); // (start && pxSign > 0) || (end && pxSign < 0): i = repeatTimes - index
    // Otherwise: i = index;

    var pxSign = symbolMeta.pxSign;
    var i = index;

    if (symbolMeta.symbolRepeatDirection === 'start' ? pxSign > 0 : pxSign < 0) {
      i = repeatTimes - 1 - index;
    }

    position[valueDim.index] = unit * (i - repeatTimes / 2 + 0.5) + pathPosition[valueDim.index];
    return {
      position: position,
      scale: symbolMeta.symbolScale.slice(),
      rotation: symbolMeta.rotation
    };
  }

  function onMouseOver() {
    eachPath(bar, function (path) {
      path.trigger('emphasis');
    });
  }

  function onMouseOut() {
    eachPath(bar, function (path) {
      path.trigger('normal');
    });
  }
}

function createOrUpdateSingleSymbol(bar, opt, symbolMeta, isUpdate) {
  var bundle = bar.__pictorialBundle;
  var mainPath = bar.__pictorialMainPath;

  if (!mainPath) {
    mainPath = bar.__pictorialMainPath = createPath(symbolMeta);
    bundle.add(mainPath);
    updateAttr(mainPath, {
      position: symbolMeta.pathPosition.slice(),
      scale: [0, 0],
      rotation: symbolMeta.rotation
    }, {
      scale: symbolMeta.symbolScale.slice()
    }, symbolMeta, isUpdate);
    mainPath.on('mouseover', onMouseOver).on('mouseout', onMouseOut);
  } else {
    updateAttr(mainPath, null, {
      position: symbolMeta.pathPosition.slice(),
      scale: symbolMeta.symbolScale.slice(),
      rotation: symbolMeta.rotation
    }, symbolMeta, isUpdate);
  }

  updateHoverAnimation(mainPath, symbolMeta);

  function onMouseOver() {
    this.trigger('emphasis');
  }

  function onMouseOut() {
    this.trigger('normal');
  }
} // bar rect is used for label.


function createOrUpdateBarRect(bar, symbolMeta, isUpdate) {
  var rectShape = zrUtil.extend({}, symbolMeta.barRectShape);
  var barRect = bar.__pictorialBarRect;

  if (!barRect) {
    barRect = bar.__pictorialBarRect = new graphic.Rect({
      z2: 2,
      shape: rectShape,
      silent: true,
      style: {
        stroke: 'transparent',
        fill: 'transparent',
        lineWidth: 0
      }
    });
    bar.add(barRect);
  } else {
    updateAttr(barRect, null, {
      shape: rectShape
    }, symbolMeta, isUpdate);
  }
}

function createOrUpdateClip(bar, opt, symbolMeta, isUpdate) {
  // If not clip, symbol will be remove and rebuilt.
  if (symbolMeta.symbolClip) {
    var clipPath = bar.__pictorialClipPath;
    var clipShape = zrUtil.extend({}, symbolMeta.clipShape);
    var valueDim = opt.valueDim;
    var animationModel = symbolMeta.animationModel;
    var dataIndex = symbolMeta.dataIndex;

    if (clipPath) {
      graphic.updateProps(clipPath, {
        shape: clipShape
      }, animationModel, dataIndex);
    } else {
      clipShape[valueDim.wh] = 0;
      clipPath = new graphic.Rect({
        shape: clipShape
      });

      bar.__pictorialBundle.setClipPath(clipPath);

      bar.__pictorialClipPath = clipPath;
      var target = {};
      target[valueDim.wh] = symbolMeta.clipShape[valueDim.wh];
      graphic[isUpdate ? 'updateProps' : 'initProps'](clipPath, {
        shape: target
      }, animationModel, dataIndex);
    }
  }
}

function getItemModel(data, dataIndex) {
  var itemModel = data.getItemModel(dataIndex);
  itemModel.getAnimationDelayParams = getAnimationDelayParams;
  itemModel.isAnimationEnabled = isAnimationEnabled;
  return itemModel;
}

function getAnimationDelayParams(path) {
  // The order is the same as the z-order, see `symbolRepeatDiretion`.
  return {
    index: path.__pictorialAnimationIndex,
    count: path.__pictorialRepeatTimes
  };
}

function isAnimationEnabled() {
  // `animation` prop can be set on itemModel in pictorial bar chart.
  return this.parentModel.isAnimationEnabled() && !!this.getShallow('animation');
}

function updateHoverAnimation(path, symbolMeta) {
  path.off('emphasis').off('normal');
  var scale = symbolMeta.symbolScale.slice();
  symbolMeta.hoverAnimation && path.on('emphasis', function () {
    this.animateTo({
      scale: [scale[0] * 1.1, scale[1] * 1.1]
    }, 400, 'elasticOut');
  }).on('normal', function () {
    this.animateTo({
      scale: scale.slice()
    }, 400, 'elasticOut');
  });
}

function createBar(data, opt, symbolMeta, isUpdate) {
  // bar is the main element for each data.
  var bar = new graphic.Group(); // bundle is used for location and clip.

  var bundle = new graphic.Group();
  bar.add(bundle);
  bar.__pictorialBundle = bundle;
  bundle.attr('position', symbolMeta.bundlePosition.slice());

  if (symbolMeta.symbolRepeat) {
    createOrUpdateRepeatSymbols(bar, opt, symbolMeta);
  } else {
    createOrUpdateSingleSymbol(bar, opt, symbolMeta);
  }

  createOrUpdateBarRect(bar, symbolMeta, isUpdate);
  createOrUpdateClip(bar, opt, symbolMeta, isUpdate);
  bar.__pictorialShapeStr = getShapeStr(data, symbolMeta);
  bar.__pictorialSymbolMeta = symbolMeta;
  return bar;
}

function updateBar(bar, opt, symbolMeta) {
  var animationModel = symbolMeta.animationModel;
  var dataIndex = symbolMeta.dataIndex;
  var bundle = bar.__pictorialBundle;
  graphic.updateProps(bundle, {
    position: symbolMeta.bundlePosition.slice()
  }, animationModel, dataIndex);

  if (symbolMeta.symbolRepeat) {
    createOrUpdateRepeatSymbols(bar, opt, symbolMeta, true);
  } else {
    createOrUpdateSingleSymbol(bar, opt, symbolMeta, true);
  }

  createOrUpdateBarRect(bar, symbolMeta, true);
  createOrUpdateClip(bar, opt, symbolMeta, true);
}

function removeBar(data, dataIndex, animationModel, bar) {
  // Not show text when animating
  var labelRect = bar.__pictorialBarRect;
  labelRect && (labelRect.style.text = null);
  var pathes = [];
  eachPath(bar, function (path) {
    pathes.push(path);
  });
  bar.__pictorialMainPath && pathes.push(bar.__pictorialMainPath); // I do not find proper remove animation for clip yet.

  bar.__pictorialClipPath && (animationModel = null);
  zrUtil.each(pathes, function (path) {
    graphic.updateProps(path, {
      scale: [0, 0]
    }, animationModel, dataIndex, function () {
      bar.parent && bar.parent.remove(bar);
    });
  });
  data.setItemGraphicEl(dataIndex, null);
}

function getShapeStr(data, symbolMeta) {
  return [data.getItemVisual(symbolMeta.dataIndex, 'symbol') || 'none', !!symbolMeta.symbolRepeat, !!symbolMeta.symbolClip].join(':');
}

function eachPath(bar, cb, context) {
  // Do not use Group#eachChild, because it do not support remove.
  zrUtil.each(bar.__pictorialBundle.children(), function (el) {
    el !== bar.__pictorialBarRect && cb.call(context, el);
  });
}

function updateAttr(el, immediateAttrs, animationAttrs, symbolMeta, isUpdate, cb) {
  immediateAttrs && el.attr(immediateAttrs); // when symbolCip used, only clip path has init animation, otherwise it would be weird effect.

  if (symbolMeta.symbolClip && !isUpdate) {
    animationAttrs && el.attr(animationAttrs);
  } else {
    animationAttrs && graphic[isUpdate ? 'updateProps' : 'initProps'](el, animationAttrs, symbolMeta.animationModel, symbolMeta.dataIndex, cb);
  }
}

function updateCommon(bar, opt, symbolMeta) {
  var color = symbolMeta.color;
  var dataIndex = symbolMeta.dataIndex;
  var itemModel = symbolMeta.itemModel; // Color must be excluded.
  // Because symbol provide setColor individually to set fill and stroke

  var normalStyle = itemModel.getModel('itemStyle').getItemStyle(['color']);
  var hoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
  var cursorStyle = itemModel.getShallow('cursor');
  eachPath(bar, function (path) {
    // PENDING setColor should be before setStyle!!!
    path.setColor(color);
    path.setStyle(zrUtil.defaults({
      fill: color,
      opacity: symbolMeta.opacity
    }, normalStyle));
    graphic.setHoverStyle(path, hoverStyle);
    cursorStyle && (path.cursor = cursorStyle);
    path.z2 = symbolMeta.z2;
  });
  var barRectHoverStyle = {};
  var barPositionOutside = opt.valueDim.posDesc[+(symbolMeta.boundingLength > 0)];
  var barRect = bar.__pictorialBarRect;
  setLabel(barRect.style, barRectHoverStyle, itemModel, color, opt.seriesModel, dataIndex, barPositionOutside);
  graphic.setHoverStyle(barRect, barRectHoverStyle);
}

function toIntTimes(times) {
  var roundedTimes = Math.round(times); // Escapse accurate error

  return Math.abs(times - roundedTimes) < 1e-4 ? roundedTimes : Math.ceil(times);
}

var _default = BarView;
module.exports = _default;

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(673);

__webpack_require__(1714);

__webpack_require__(1715);

var themeRiverLayout = __webpack_require__(1716);

var themeRiverVisual = __webpack_require__(1717);

var dataFilter = __webpack_require__(244);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.registerLayout(themeRiverLayout);
echarts.registerVisual(themeRiverVisual);
echarts.registerProcessor(dataFilter('themeRiver'));

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var Single = __webpack_require__(1706);

var CoordinateSystem = __webpack_require__(108);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Single coordinate system creator.
 */

/**
 * Create single coordinate system and inject it into seriesModel.
 *
 * @param {module:echarts/model/Global} ecModel
 * @param {module:echarts/ExtensionAPI} api
 * @return {Array.<module:echarts/coord/single/Single>}
 */
function create(ecModel, api) {
  var singles = [];
  ecModel.eachComponent('singleAxis', function (axisModel, idx) {
    var single = new Single(axisModel, ecModel, api);
    single.name = 'single_' + idx;
    single.resize(axisModel, api);
    axisModel.coordinateSystem = single;
    singles.push(single);
  });
  ecModel.eachSeries(function (seriesModel) {
    if (seriesModel.get('coordinateSystem') === 'singleAxis') {
      var singleAxisModel = ecModel.queryComponents({
        mainType: 'singleAxis',
        index: seriesModel.get('singleAxisIndex'),
        id: seriesModel.get('singleAxisId')
      })[0];
      seriesModel.coordinateSystem = singleAxisModel && singleAxisModel.coordinateSystem;
    }
  });
  return singles;
}

CoordinateSystem.register('single', {
  create: create,
  dimensions: Single.prototype.dimensions
});

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var SingleAxis = __webpack_require__(1707);

var axisHelper = __webpack_require__(109);

var _layout = __webpack_require__(53);

var getLayoutRect = _layout.getLayoutRect;

var _util = __webpack_require__(1);

var each = _util.each;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Single coordinates system.
 */

/**
 * Create a single coordinates system.
 *
 * @param {module:echarts/coord/single/AxisModel} axisModel
 * @param {module:echarts/model/Global} ecModel
 * @param {module:echarts/ExtensionAPI} api
 */
function Single(axisModel, ecModel, api) {
  /**
   * @type {string}
   * @readOnly
   */
  this.dimension = 'single';
  /**
   * Add it just for draw tooltip.
   *
   * @type {Array.<string>}
   * @readOnly
   */

  this.dimensions = ['single'];
  /**
   * @private
   * @type {module:echarts/coord/single/SingleAxis}.
   */

  this._axis = null;
  /**
   * @private
   * @type {module:zrender/core/BoundingRect}
   */

  this._rect;

  this._init(axisModel, ecModel, api);
  /**
   * @type {module:echarts/coord/single/AxisModel}
   */


  this.model = axisModel;
}

Single.prototype = {
  type: 'singleAxis',
  axisPointerEnabled: true,
  constructor: Single,

  /**
   * Initialize single coordinate system.
   *
   * @param  {module:echarts/coord/single/AxisModel} axisModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @private
   */
  _init: function (axisModel, ecModel, api) {
    var dim = this.dimension;
    var axis = new SingleAxis(dim, axisHelper.createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisModel.get('position'));
    var isCategory = axis.type === 'category';
    axis.onBand = isCategory && axisModel.get('boundaryGap');
    axis.inverse = axisModel.get('inverse');
    axis.orient = axisModel.get('orient');
    axisModel.axis = axis;
    axis.model = axisModel;
    axis.coordinateSystem = this;
    this._axis = axis;
  },

  /**
   * Update axis scale after data processed
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */
  update: function (ecModel, api) {
    ecModel.eachSeries(function (seriesModel) {
      if (seriesModel.coordinateSystem === this) {
        var data = seriesModel.getData();
        each(data.mapDimension(this.dimension, true), function (dim) {
          this._axis.scale.unionExtentFromData(data, dim);
        }, this);
        axisHelper.niceScaleExtent(this._axis.scale, this._axis.model);
      }
    }, this);
  },

  /**
   * Resize the single coordinate system.
   *
   * @param  {module:echarts/coord/single/AxisModel} axisModel
   * @param  {module:echarts/ExtensionAPI} api
   */
  resize: function (axisModel, api) {
    this._rect = getLayoutRect({
      left: axisModel.get('left'),
      top: axisModel.get('top'),
      right: axisModel.get('right'),
      bottom: axisModel.get('bottom'),
      width: axisModel.get('width'),
      height: axisModel.get('height')
    }, {
      width: api.getWidth(),
      height: api.getHeight()
    });

    this._adjustAxis();
  },

  /**
   * @return {module:zrender/core/BoundingRect}
   */
  getRect: function () {
    return this._rect;
  },

  /**
   * @private
   */
  _adjustAxis: function () {
    var rect = this._rect;
    var axis = this._axis;
    var isHorizontal = axis.isHorizontal();
    var extent = isHorizontal ? [0, rect.width] : [0, rect.height];
    var idx = axis.reverse ? 1 : 0;
    axis.setExtent(extent[idx], extent[1 - idx]);

    this._updateAxisTransform(axis, isHorizontal ? rect.x : rect.y);
  },

  /**
   * @param  {module:echarts/coord/single/SingleAxis} axis
   * @param  {number} coordBase
   */
  _updateAxisTransform: function (axis, coordBase) {
    var axisExtent = axis.getExtent();
    var extentSum = axisExtent[0] + axisExtent[1];
    var isHorizontal = axis.isHorizontal();
    axis.toGlobalCoord = isHorizontal ? function (coord) {
      return coord + coordBase;
    } : function (coord) {
      return extentSum - coord + coordBase;
    };
    axis.toLocalCoord = isHorizontal ? function (coord) {
      return coord - coordBase;
    } : function (coord) {
      return extentSum - coord + coordBase;
    };
  },

  /**
   * Get axis.
   *
   * @return {module:echarts/coord/single/SingleAxis}
   */
  getAxis: function () {
    return this._axis;
  },

  /**
   * Get axis, add it just for draw tooltip.
   *
   * @return {[type]} [description]
   */
  getBaseAxis: function () {
    return this._axis;
  },

  /**
   * @return {Array.<module:echarts/coord/Axis>}
   */
  getAxes: function () {
    return [this._axis];
  },

  /**
   * @return {Object} {baseAxes: [], otherAxes: []}
   */
  getTooltipAxes: function () {
    return {
      baseAxes: [this.getAxis()]
    };
  },

  /**
   * If contain point.
   *
   * @param  {Array.<number>} point
   * @return {boolean}
   */
  containPoint: function (point) {
    var rect = this.getRect();
    var axis = this.getAxis();
    var orient = axis.orient;

    if (orient === 'horizontal') {
      return axis.contain(axis.toLocalCoord(point[0])) && point[1] >= rect.y && point[1] <= rect.y + rect.height;
    } else {
      return axis.contain(axis.toLocalCoord(point[1])) && point[0] >= rect.y && point[0] <= rect.y + rect.height;
    }
  },

  /**
   * @param {Array.<number>} point
   * @return {Array.<number>}
   */
  pointToData: function (point) {
    var axis = this.getAxis();
    return [axis.coordToData(axis.toLocalCoord(point[axis.orient === 'horizontal' ? 0 : 1]))];
  },

  /**
   * Convert the series data to concrete point.
   *
   * @param  {number|Array.<number>} val
   * @return {Array.<number>}
   */
  dataToPoint: function (val) {
    var axis = this.getAxis();
    var rect = this.getRect();
    var pt = [];
    var idx = axis.orient === 'horizontal' ? 0 : 1;

    if (val instanceof Array) {
      val = val[0];
    }

    pt[idx] = axis.toGlobalCoord(axis.dataToCoord(+val));
    pt[1 - idx] = idx === 0 ? rect.y + rect.height / 2 : rect.x + rect.width / 2;
    return pt;
  }
};
var _default = Single;
module.exports = _default;

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var Axis = __webpack_require__(150);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @constructor  module:echarts/coord/single/SingleAxis
 * @extends {module:echarts/coord/Axis}
 * @param {string} dim
 * @param {*} scale
 * @param {Array.<number>} coordExtent
 * @param {string} axisType
 * @param {string} position
 */
var SingleAxis = function (dim, scale, coordExtent, axisType, position) {
  Axis.call(this, dim, scale, coordExtent);
  /**
   * Axis type
   * - 'category'
   * - 'value'
   * - 'time'
   * - 'log'
   * @type {string}
   */

  this.type = axisType || 'value';
  /**
   * Axis position
   *  - 'top'
   *  - 'bottom'
   *  - 'left'
   *  - 'right'
   *  @type {string}
   */

  this.position = position || 'bottom';
  /**
   * Axis orient
   *  - 'horizontal'
   *  - 'vertical'
   * @type {[type]}
   */

  this.orient = null;
};

SingleAxis.prototype = {
  constructor: SingleAxis,

  /**
   * Axis model
   * @type {module:echarts/coord/single/AxisModel}
   */
  model: null,

  /**
   * Judge the orient of the axis.
   * @return {boolean}
   */
  isHorizontal: function () {
    var position = this.position;
    return position === 'top' || position === 'bottom';
  },

  /**
   * @override
   */
  pointToData: function (point, clamp) {
    return this.coordinateSystem.pointToData(point, clamp)[0];
  },

  /**
   * Convert the local coord(processed by dataToCoord())
   * to global coord(concrete pixel coord).
   * designated by module:echarts/coord/single/Single.
   * @type {Function}
   */
  toGlobalCoord: null,

  /**
   * Convert the global coord to local coord.
   * designated by module:echarts/coord/single/Single.
   * @type {Function}
   */
  toLocalCoord: null
};
zrUtil.inherits(SingleAxis, Axis);
var _default = SingleAxis;
module.exports = _default;

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var AxisBuilder = __webpack_require__(151);

var graphic = __webpack_require__(27);

var singleAxisHelper = __webpack_require__(674);

var AxisView = __webpack_require__(179);

var _axisSplitHelper = __webpack_require__(653);

var rectCoordAxisBuildSplitArea = _axisSplitHelper.rectCoordAxisBuildSplitArea;
var rectCoordAxisHandleRemove = _axisSplitHelper.rectCoordAxisHandleRemove;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
var selfBuilderAttrs = ['splitArea', 'splitLine'];
var SingleAxisView = AxisView.extend({
  type: 'singleAxis',
  axisPointerClass: 'SingleAxisPointer',
  render: function (axisModel, ecModel, api, payload) {
    var group = this.group;
    group.removeAll();
    var oldAxisGroup = this._axisGroup;
    this._axisGroup = new graphic.Group();
    var layout = singleAxisHelper.layout(axisModel);
    var axisBuilder = new AxisBuilder(axisModel, layout);
    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
    group.add(this._axisGroup);
    group.add(axisBuilder.getGroup());
    zrUtil.each(selfBuilderAttrs, function (name) {
      if (axisModel.get(name + '.show')) {
        this['_' + name](axisModel);
      }
    }, this);
    graphic.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
    SingleAxisView.superCall(this, 'render', axisModel, ecModel, api, payload);
  },
  remove: function () {
    rectCoordAxisHandleRemove(this);
  },
  _splitLine: function (axisModel) {
    var axis = axisModel.axis;

    if (axis.scale.isBlank()) {
      return;
    }

    var splitLineModel = axisModel.getModel('splitLine');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var lineWidth = lineStyleModel.get('width');
    var lineColors = lineStyleModel.get('color');
    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
    var gridRect = axisModel.coordinateSystem.getRect();
    var isHorizontal = axis.isHorizontal();
    var splitLines = [];
    var lineCount = 0;
    var ticksCoords = axis.getTicksCoords({
      tickModel: splitLineModel
    });
    var p1 = [];
    var p2 = [];

    for (var i = 0; i < ticksCoords.length; ++i) {
      var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);

      if (isHorizontal) {
        p1[0] = tickCoord;
        p1[1] = gridRect.y;
        p2[0] = tickCoord;
        p2[1] = gridRect.y + gridRect.height;
      } else {
        p1[0] = gridRect.x;
        p1[1] = tickCoord;
        p2[0] = gridRect.x + gridRect.width;
        p2[1] = tickCoord;
      }

      var colorIndex = lineCount++ % lineColors.length;
      splitLines[colorIndex] = splitLines[colorIndex] || [];
      splitLines[colorIndex].push(new graphic.Line({
        subPixelOptimize: true,
        shape: {
          x1: p1[0],
          y1: p1[1],
          x2: p2[0],
          y2: p2[1]
        },
        style: {
          lineWidth: lineWidth
        },
        silent: true
      }));
    }

    for (var i = 0; i < splitLines.length; ++i) {
      this.group.add(graphic.mergePath(splitLines[i], {
        style: {
          stroke: lineColors[i % lineColors.length],
          lineDash: lineStyleModel.getLineDash(lineWidth),
          lineWidth: lineWidth
        },
        silent: true
      }));
    }
  },
  _splitArea: function (axisModel) {
    rectCoordAxisBuildSplitArea(this, this._axisGroup, axisModel, axisModel);
  }
});
var _default = SingleAxisView;
module.exports = _default;

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var ComponentModel = __webpack_require__(73);

var axisModelCreator = __webpack_require__(302);

var axisModelCommonMixin = __webpack_require__(208);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var AxisModel = ComponentModel.extend({
  type: 'singleAxis',
  layoutMode: 'box',

  /**
   * @type {module:echarts/coord/single/SingleAxis}
   */
  axis: null,

  /**
   * @type {module:echarts/coord/single/Single}
   */
  coordinateSystem: null,

  /**
   * @override
   */
  getCoordSysModel: function () {
    return this;
  }
});
var defaultOption = {
  left: '5%',
  top: '5%',
  right: '5%',
  bottom: '5%',
  type: 'value',
  position: 'bottom',
  orient: 'horizontal',
  axisLine: {
    show: true,
    lineStyle: {
      width: 1,
      type: 'solid'
    }
  },
  // Single coordinate system and single axis is the,
  // which is used as the parent tooltip model.
  // same model, so we set default tooltip show as true.
  tooltip: {
    show: true
  },
  axisTick: {
    show: true,
    length: 6,
    lineStyle: {
      width: 1
    }
  },
  axisLabel: {
    show: true,
    interval: 'auto'
  },
  splitLine: {
    show: true,
    lineStyle: {
      type: 'dashed',
      opacity: 0.2
    }
  }
};

function getAxisType(axisName, option) {
  return option.type || (option.data ? 'category' : 'value');
}

zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
axisModelCreator('single', AxisModel, getAxisType, defaultOption);
var _default = AxisModel;
module.exports = _default;

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var _model = __webpack_require__(44);

var makeInner = _model.makeInner;

var modelHelper = __webpack_require__(303);

var findPointFromSeries = __webpack_require__(675);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var each = zrUtil.each;
var curry = zrUtil.curry;
var inner = makeInner();
/**
 * Basic logic: check all axis, if they do not demand show/highlight,
 * then hide/downplay them.
 *
 * @param {Object} coordSysAxesInfo
 * @param {Object} payload
 * @param {string} [payload.currTrigger] 'click' | 'mousemove' | 'leave'
 * @param {Array.<number>} [payload.x] x and y, which are mandatory, specify a point to
 *              trigger axisPointer and tooltip.
 * @param {Array.<number>} [payload.y] x and y, which are mandatory, specify a point to
 *              trigger axisPointer and tooltip.
 * @param {Object} [payload.seriesIndex] finder, optional, restrict target axes.
 * @param {Object} [payload.dataIndex] finder, restrict target axes.
 * @param {Object} [payload.axesInfo] finder, restrict target axes.
 *        [{
 *          axisDim: 'x'|'y'|'angle'|...,
 *          axisIndex: ...,
 *          value: ...
 *        }, ...]
 * @param {Function} [payload.dispatchAction]
 * @param {Object} [payload.tooltipOption]
 * @param {Object|Array.<number>|Function} [payload.position] Tooltip position,
 *        which can be specified in dispatchAction
 * @param {module:echarts/model/Global} ecModel
 * @param {module:echarts/ExtensionAPI} api
 * @return {Object} content of event obj for echarts.connect.
 */

function _default(payload, ecModel, api) {
  var currTrigger = payload.currTrigger;
  var point = [payload.x, payload.y];
  var finder = payload;
  var dispatchAction = payload.dispatchAction || zrUtil.bind(api.dispatchAction, api);
  var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo; // Pending
  // See #6121. But we are not able to reproduce it yet.

  if (!coordSysAxesInfo) {
    return;
  }

  if (illegalPoint(point)) {
    // Used in the default behavior of `connection`: use the sample seriesIndex
    // and dataIndex. And also used in the tooltipView trigger.
    point = findPointFromSeries({
      seriesIndex: finder.seriesIndex,
      // Do not use dataIndexInside from other ec instance.
      // FIXME: auto detect it?
      dataIndex: finder.dataIndex
    }, ecModel).point;
  }

  var isIllegalPoint = illegalPoint(point); // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
  // Notice: In this case, it is difficult to get the `point` (which is necessary to show
  // tooltip, so if point is not given, we just use the point found by sample seriesIndex
  // and dataIndex.

  var inputAxesInfo = finder.axesInfo;
  var axesInfo = coordSysAxesInfo.axesInfo;
  var shouldHide = currTrigger === 'leave' || illegalPoint(point);
  var outputFinder = {};
  var showValueMap = {};
  var dataByCoordSys = {
    list: [],
    map: {}
  };
  var updaters = {
    showPointer: curry(showPointer, showValueMap),
    showTooltip: curry(showTooltip, dataByCoordSys)
  }; // Process for triggered axes.

  each(coordSysAxesInfo.coordSysMap, function (coordSys, coordSysKey) {
    // If a point given, it must be contained by the coordinate system.
    var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
    each(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function (axisInfo, key) {
      var axis = axisInfo.axis;
      var inputAxisInfo = findInputAxisInfo(inputAxesInfo, axisInfo); // If no inputAxesInfo, no axis is restricted.

      if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
        var val = inputAxisInfo && inputAxisInfo.value;

        if (val == null && !isIllegalPoint) {
          val = axis.pointToData(point);
        }

        val != null && processOnAxis(axisInfo, val, updaters, false, outputFinder);
      }
    });
  }); // Process for linked axes.

  var linkTriggers = {};
  each(axesInfo, function (tarAxisInfo, tarKey) {
    var linkGroup = tarAxisInfo.linkGroup; // If axis has been triggered in the previous stage, it should not be triggered by link.

    if (linkGroup && !showValueMap[tarKey]) {
      each(linkGroup.axesInfo, function (srcAxisInfo, srcKey) {
        var srcValItem = showValueMap[srcKey]; // If srcValItem exist, source axis is triggered, so link to target axis.

        if (srcAxisInfo !== tarAxisInfo && srcValItem) {
          var val = srcValItem.value;
          linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, makeMapperParam(srcAxisInfo), makeMapperParam(tarAxisInfo))));
          linkTriggers[tarAxisInfo.key] = val;
        }
      });
    }
  });
  each(linkTriggers, function (val, tarKey) {
    processOnAxis(axesInfo[tarKey], val, updaters, true, outputFinder);
  });
  updateModelActually(showValueMap, axesInfo, outputFinder);
  dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
  dispatchHighDownActually(axesInfo, dispatchAction, api);
  return outputFinder;
}

function processOnAxis(axisInfo, newValue, updaters, dontSnap, outputFinder) {
  var axis = axisInfo.axis;

  if (axis.scale.isBlank() || !axis.containData(newValue)) {
    return;
  }

  if (!axisInfo.involveSeries) {
    updaters.showPointer(axisInfo, newValue);
    return;
  } // Heavy calculation. So put it after axis.containData checking.


  var payloadInfo = buildPayloadsBySeries(newValue, axisInfo);
  var payloadBatch = payloadInfo.payloadBatch;
  var snapToValue = payloadInfo.snapToValue; // Fill content of event obj for echarts.connect.
  // By default use the first involved series data as a sample to connect.

  if (payloadBatch[0] && outputFinder.seriesIndex == null) {
    zrUtil.extend(outputFinder, payloadBatch[0]);
  } // If no linkSource input, this process is for collecting link
  // target, where snap should not be accepted.


  if (!dontSnap && axisInfo.snap) {
    if (axis.containData(snapToValue) && snapToValue != null) {
      newValue = snapToValue;
    }
  }

  updaters.showPointer(axisInfo, newValue, payloadBatch, outputFinder); // Tooltip should always be snapToValue, otherwise there will be
  // incorrect "axis value ~ series value" mapping displayed in tooltip.

  updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
}

function buildPayloadsBySeries(value, axisInfo) {
  var axis = axisInfo.axis;
  var dim = axis.dim;
  var snapToValue = value;
  var payloadBatch = [];
  var minDist = Number.MAX_VALUE;
  var minDiff = -1;
  each(axisInfo.seriesModels, function (series, idx) {
    var dataDim = series.getData().mapDimension(dim, true);
    var seriesNestestValue;
    var dataIndices;

    if (series.getAxisTooltipData) {
      var result = series.getAxisTooltipData(dataDim, value, axis);
      dataIndices = result.dataIndices;
      seriesNestestValue = result.nestestValue;
    } else {
      dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
      // when data length is not same.
      // false,
      axis.type === 'category' ? 0.5 : null);

      if (!dataIndices.length) {
        return;
      }

      seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
    }

    if (seriesNestestValue == null || !isFinite(seriesNestestValue)) {
      return;
    }

    var diff = value - seriesNestestValue;
    var dist = Math.abs(diff); // Consider category case

    if (dist <= minDist) {
      if (dist < minDist || diff >= 0 && minDiff < 0) {
        minDist = dist;
        minDiff = diff;
        snapToValue = seriesNestestValue;
        payloadBatch.length = 0;
      }

      each(dataIndices, function (dataIndex) {
        payloadBatch.push({
          seriesIndex: series.seriesIndex,
          dataIndexInside: dataIndex,
          dataIndex: series.getData().getRawIndex(dataIndex)
        });
      });
    }
  });
  return {
    payloadBatch: payloadBatch,
    snapToValue: snapToValue
  };
}

function showPointer(showValueMap, axisInfo, value, payloadBatch) {
  showValueMap[axisInfo.key] = {
    value: value,
    payloadBatch: payloadBatch
  };
}

function showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
  var payloadBatch = payloadInfo.payloadBatch;
  var axis = axisInfo.axis;
  var axisModel = axis.model;
  var axisPointerModel = axisInfo.axisPointerModel; // If no data, do not create anything in dataByCoordSys,
  // whose length will be used to judge whether dispatch action.

  if (!axisInfo.triggerTooltip || !payloadBatch.length) {
    return;
  }

  var coordSysModel = axisInfo.coordSys.model;
  var coordSysKey = modelHelper.makeKey(coordSysModel);
  var coordSysItem = dataByCoordSys.map[coordSysKey];

  if (!coordSysItem) {
    coordSysItem = dataByCoordSys.map[coordSysKey] = {
      coordSysId: coordSysModel.id,
      coordSysIndex: coordSysModel.componentIndex,
      coordSysType: coordSysModel.type,
      coordSysMainType: coordSysModel.mainType,
      dataByAxis: []
    };
    dataByCoordSys.list.push(coordSysItem);
  }

  coordSysItem.dataByAxis.push({
    axisDim: axis.dim,
    axisIndex: axisModel.componentIndex,
    axisType: axisModel.type,
    axisId: axisModel.id,
    value: value,
    // Caustion: viewHelper.getValueLabel is actually on "view stage", which
    // depends that all models have been updated. So it should not be performed
    // here. Considering axisPointerModel used here is volatile, which is hard
    // to be retrieve in TooltipView, we prepare parameters here.
    valueLabelOpt: {
      precision: axisPointerModel.get('label.precision'),
      formatter: axisPointerModel.get('label.formatter')
    },
    seriesDataIndices: payloadBatch.slice()
  });
}

function updateModelActually(showValueMap, axesInfo, outputFinder) {
  var outputAxesInfo = outputFinder.axesInfo = []; // Basic logic: If no 'show' required, 'hide' this axisPointer.

  each(axesInfo, function (axisInfo, key) {
    var option = axisInfo.axisPointerModel.option;
    var valItem = showValueMap[key];

    if (valItem) {
      !axisInfo.useHandle && (option.status = 'show');
      option.value = valItem.value; // For label formatter param and highlight.

      option.seriesDataIndices = (valItem.payloadBatch || []).slice();
    } // When always show (e.g., handle used), remain
    // original value and status.
    else {
        // If hide, value still need to be set, consider
        // click legend to toggle axis blank.
        !axisInfo.useHandle && (option.status = 'hide');
      } // If status is 'hide', should be no info in payload.


    option.status === 'show' && outputAxesInfo.push({
      axisDim: axisInfo.axis.dim,
      axisIndex: axisInfo.axis.model.componentIndex,
      value: option.value
    });
  });
}

function dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
  // Basic logic: If no showTip required, hideTip will be dispatched.
  if (illegalPoint(point) || !dataByCoordSys.list.length) {
    dispatchAction({
      type: 'hideTip'
    });
    return;
  } // In most case only one axis (or event one series is used). It is
  // convinient to fetch payload.seriesIndex and payload.dataIndex
  // dirtectly. So put the first seriesIndex and dataIndex of the first
  // axis on the payload.


  var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
  dispatchAction({
    type: 'showTip',
    escapeConnect: true,
    x: point[0],
    y: point[1],
    tooltipOption: payload.tooltipOption,
    position: payload.position,
    dataIndexInside: sampleItem.dataIndexInside,
    dataIndex: sampleItem.dataIndex,
    seriesIndex: sampleItem.seriesIndex,
    dataByCoordSys: dataByCoordSys.list
  });
}

function dispatchHighDownActually(axesInfo, dispatchAction, api) {
  // FIXME
  // highlight status modification shoule be a stage of main process?
  // (Consider confilct (e.g., legend and axisPointer) and setOption)
  var zr = api.getZr();
  var highDownKey = 'axisPointerLastHighlights';
  var lastHighlights = inner(zr)[highDownKey] || {};
  var newHighlights = inner(zr)[highDownKey] = {}; // Update highlight/downplay status according to axisPointer model.
  // Build hash map and remove duplicate incidentally.

  each(axesInfo, function (axisInfo, key) {
    var option = axisInfo.axisPointerModel.option;
    option.status === 'show' && each(option.seriesDataIndices, function (batchItem) {
      var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
      newHighlights[key] = batchItem;
    });
  }); // Diff.

  var toHighlight = [];
  var toDownplay = [];
  zrUtil.each(lastHighlights, function (batchItem, key) {
    !newHighlights[key] && toDownplay.push(batchItem);
  });
  zrUtil.each(newHighlights, function (batchItem, key) {
    !lastHighlights[key] && toHighlight.push(batchItem);
  });
  toDownplay.length && api.dispatchAction({
    type: 'downplay',
    escapeConnect: true,
    batch: toDownplay
  });
  toHighlight.length && api.dispatchAction({
    type: 'highlight',
    escapeConnect: true,
    batch: toHighlight
  });
}

function findInputAxisInfo(inputAxesInfo, axisInfo) {
  for (var i = 0; i < (inputAxesInfo || []).length; i++) {
    var inputAxisInfo = inputAxesInfo[i];

    if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) {
      return inputAxisInfo;
    }
  }
}

function makeMapperParam(axisInfo) {
  var axisModel = axisInfo.axis.model;
  var item = {};
  var dim = item.axisDim = axisInfo.axis.dim;
  item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
  item.axisName = item[dim + 'AxisName'] = axisModel.name;
  item.axisId = item[dim + 'AxisId'] = axisModel.id;
  return item;
}

function illegalPoint(point) {
  return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
}

module.exports = _default;

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var AxisPointerModel = echarts.extendComponentModel({
  type: 'axisPointer',
  coordSysAxesInfo: null,
  defaultOption: {
    // 'auto' means that show when triggered by tooltip or handle.
    show: 'auto',
    // 'click' | 'mousemove' | 'none'
    triggerOn: null,
    // set default in AxisPonterView.js
    zlevel: 0,
    z: 50,
    type: 'line',
    // 'line' 'shadow' 'cross' 'none'.
    // axispointer triggered by tootip determine snap automatically,
    // see `modelHelper`.
    snap: false,
    triggerTooltip: true,
    value: null,
    status: null,
    // Init value depends on whether handle is used.
    // [group0, group1, ...]
    // Each group can be: {
    //      mapper: function () {},
    //      singleTooltip: 'multiple',  // 'multiple' or 'single'
    //      xAxisId: ...,
    //      yAxisName: ...,
    //      angleAxisIndex: ...
    // }
    // mapper: can be ignored.
    //      input: {axisInfo, value}
    //      output: {axisInfo, value}
    link: [],
    // Do not set 'auto' here, otherwise global animation: false
    // will not effect at this axispointer.
    animation: null,
    animationDurationUpdate: 200,
    lineStyle: {
      color: '#aaa',
      width: 1,
      type: 'solid'
    },
    shadowStyle: {
      color: 'rgba(150,150,150,0.3)'
    },
    label: {
      show: true,
      formatter: null,
      // string | Function
      precision: 'auto',
      // Or a number like 0, 1, 2 ...
      margin: 3,
      color: '#fff',
      padding: [5, 7, 5, 7],
      backgroundColor: 'auto',
      // default: axis line color
      borderColor: null,
      borderWidth: 0,
      shadowBlur: 3,
      shadowColor: '#aaa' // Considering applicability, common style should
      // better not have shadowOffset.
      // shadowOffsetX: 0,
      // shadowOffsetY: 2

    },
    handle: {
      show: false,

      /* eslint-disable */
      icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
      // jshint ignore:line

      /* eslint-enable */
      size: 45,
      // handle margin is from symbol center to axis, which is stable when circular move.
      margin: 50,
      // color: '#1b8bbd'
      // color: '#2f4554'
      color: '#333',
      shadowBlur: 3,
      shadowColor: '#aaa',
      shadowOffsetX: 0,
      shadowOffsetY: 2,
      // For mobile performance
      throttle: 40
    }
  }
});
var _default = AxisPointerModel;
module.exports = _default;

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var globalListener = __webpack_require__(676);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var AxisPointerView = echarts.extendComponentView({
  type: 'axisPointer',
  render: function (globalAxisPointerModel, ecModel, api) {
    var globalTooltipModel = ecModel.getComponent('tooltip');
    var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click'; // Register global listener in AxisPointerView to enable
    // AxisPointerView to be independent to Tooltip.

    globalListener.register('axisPointer', api, function (currTrigger, e, dispatchAction) {
      // If 'none', it is not controlled by mouse totally.
      if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) {
        dispatchAction({
          type: 'updateAxisPointer',
          currTrigger: currTrigger,
          x: e && e.offsetX,
          y: e && e.offsetY
        });
      }
    });
  },

  /**
   * @override
   */
  remove: function (ecModel, api) {
    globalListener.unregister(api.getZr(), 'axisPointer');
    AxisPointerView.superApply(this._model, 'remove', arguments);
  },

  /**
   * @override
   */
  dispose: function (ecModel, api) {
    globalListener.unregister('axisPointer', api);
    AxisPointerView.superApply(this._model, 'dispose', arguments);
  }
});
var _default = AxisPointerView;
module.exports = _default;

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var BaseAxisPointer = __webpack_require__(426);

var viewHelper = __webpack_require__(308);

var singleAxisHelper = __webpack_require__(674);

var AxisView = __webpack_require__(179);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var XY = ['x', 'y'];
var WH = ['width', 'height'];
var SingleAxisPointer = BaseAxisPointer.extend({
  /**
   * @override
   */
  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
    var axis = axisModel.axis;
    var coordSys = axis.coordinateSystem;
    var otherExtent = getGlobalExtent(coordSys, 1 - getPointDimIndex(axis));
    var pixelValue = coordSys.dataToPoint(value)[0];
    var axisPointerType = axisPointerModel.get('type');

    if (axisPointerType && axisPointerType !== 'none') {
      var elStyle = viewHelper.buildElStyle(axisPointerModel);
      var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
      pointerOption.style = elStyle;
      elOption.graphicKey = pointerOption.type;
      elOption.pointer = pointerOption;
    }

    var layoutInfo = singleAxisHelper.layout(axisModel);
    viewHelper.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
  },

  /**
   * @override
   */
  getHandleTransform: function (value, axisModel, axisPointerModel) {
    var layoutInfo = singleAxisHelper.layout(axisModel, {
      labelInside: false
    });
    layoutInfo.labelMargin = axisPointerModel.get('handle.margin');
    return {
      position: viewHelper.getTransformedPosition(axisModel.axis, value, layoutInfo),
      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
    };
  },

  /**
   * @override
   */
  updateHandleTransform: function (transform, delta, axisModel, axisPointerModel) {
    var axis = axisModel.axis;
    var coordSys = axis.coordinateSystem;
    var dimIndex = getPointDimIndex(axis);
    var axisExtent = getGlobalExtent(coordSys, dimIndex);
    var currPosition = transform.position;
    currPosition[dimIndex] += delta[dimIndex];
    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
    var otherExtent = getGlobalExtent(coordSys, 1 - dimIndex);
    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
    var cursorPoint = [cursorOtherValue, cursorOtherValue];
    cursorPoint[dimIndex] = currPosition[dimIndex];
    return {
      position: currPosition,
      rotation: transform.rotation,
      cursorPoint: cursorPoint,
      tooltipOption: {
        verticalAlign: 'middle'
      }
    };
  }
});
var pointerShapeBuilder = {
  line: function (axis, pixelValue, otherExtent) {
    var targetShape = viewHelper.makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getPointDimIndex(axis));
    return {
      type: 'Line',
      subPixelOptimize: true,
      shape: targetShape
    };
  },
  shadow: function (axis, pixelValue, otherExtent) {
    var bandWidth = axis.getBandWidth();
    var span = otherExtent[1] - otherExtent[0];
    return {
      type: 'Rect',
      shape: viewHelper.makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getPointDimIndex(axis))
    };
  }
};

function getPointDimIndex(axis) {
  return axis.isHorizontal() ? 0 : 1;
}

function getGlobalExtent(coordSys, dimIndex) {
  var rect = coordSys.getRect();
  return [rect[XY[dimIndex]], rect[XY[dimIndex]] + rect[WH[dimIndex]]];
}

AxisView.registerAxisPointerClass('SingleAxisPointer', SingleAxisPointer);
var _default = SingleAxisPointer;
module.exports = _default;

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var SeriesModel = __webpack_require__(74);

var createDimensions = __webpack_require__(207);

var _dimensionHelper = __webpack_require__(238);

var getDimensionTypeByAxis = _dimensionHelper.getDimensionTypeByAxis;

var List = __webpack_require__(98);

var zrUtil = __webpack_require__(1);

var _model = __webpack_require__(44);

var groupData = _model.groupData;

var _format = __webpack_require__(54);

var encodeHTML = _format.encodeHTML;

var LegendVisualProvider = __webpack_require__(243);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var DATA_NAME_INDEX = 2;
var ThemeRiverSeries = SeriesModel.extend({
  type: 'series.themeRiver',
  dependencies: ['singleAxis'],

  /**
   * @readOnly
   * @type {module:zrender/core/util#HashMap}
   */
  nameMap: null,

  /**
   * @override
   */
  init: function (option) {
    // eslint-disable-next-line
    ThemeRiverSeries.superApply(this, 'init', arguments); // Put this function here is for the sake of consistency of code style.
    // Enable legend selection for each data item
    // Use a function instead of direct access because data reference may changed

    this.legendVisualProvider = new LegendVisualProvider(zrUtil.bind(this.getData, this), zrUtil.bind(this.getRawData, this));
  },

  /**
   * If there is no value of a certain point in the time for some event,set it value to 0.
   *
   * @param {Array} data  initial data in the option
   * @return {Array}
   */
  fixData: function (data) {
    var rawDataLength = data.length;
    /**
     * Make sure every layer data get the same keys.
     * The value index tells which layer has visited.
     * {
     *  2014/01/01: -1
     * }
     */

    var timeValueKeys = {}; // grouped data by name

    var groupResult = groupData(data, function (item) {
      if (!timeValueKeys.hasOwnProperty(item[0])) {
        timeValueKeys[item[0]] = -1;
      }

      return item[2];
    });
    var layData = [];
    groupResult.buckets.each(function (items, key) {
      layData.push({
        name: key,
        dataList: items
      });
    });
    var layerNum = layData.length;

    for (var k = 0; k < layerNum; ++k) {
      var name = layData[k].name;

      for (var j = 0; j < layData[k].dataList.length; ++j) {
        var timeValue = layData[k].dataList[j][0];
        timeValueKeys[timeValue] = k;
      }

      for (var timeValue in timeValueKeys) {
        if (timeValueKeys.hasOwnProperty(timeValue) && timeValueKeys[timeValue] !== k) {
          timeValueKeys[timeValue] = k;
          data[rawDataLength] = [];
          data[rawDataLength][0] = timeValue;
          data[rawDataLength][1] = 0;
          data[rawDataLength][2] = name;
          rawDataLength++;
        }
      }
    }

    return data;
  },

  /**
   * @override
   * @param  {Object} option  the initial option that user gived
   * @param  {module:echarts/model/Model} ecModel  the model object for themeRiver option
   * @return {module:echarts/data/List}
   */
  getInitialData: function (option, ecModel) {
    var singleAxisModel = ecModel.queryComponents({
      mainType: 'singleAxis',
      index: this.get('singleAxisIndex'),
      id: this.get('singleAxisId')
    })[0];
    var axisType = singleAxisModel.get('type'); // filter the data item with the value of label is undefined

    var filterData = zrUtil.filter(option.data, function (dataItem) {
      return dataItem[2] !== undefined;
    }); // ??? TODO design a stage to transfer data for themeRiver and lines?

    var data = this.fixData(filterData || []);
    var nameList = [];
    var nameMap = this.nameMap = zrUtil.createHashMap();
    var count = 0;

    for (var i = 0; i < data.length; ++i) {
      nameList.push(data[i][DATA_NAME_INDEX]);

      if (!nameMap.get(data[i][DATA_NAME_INDEX])) {
        nameMap.set(data[i][DATA_NAME_INDEX], count);
        count++;
      }
    }

    var dimensionsInfo = createDimensions(data, {
      coordDimensions: ['single'],
      dimensionsDefine: [{
        name: 'time',
        type: getDimensionTypeByAxis(axisType)
      }, {
        name: 'value',
        type: 'float'
      }, {
        name: 'name',
        type: 'ordinal'
      }],
      encodeDefine: {
        single: 0,
        value: 1,
        itemName: 2
      }
    });
    var list = new List(dimensionsInfo, this);
    list.initData(data);
    return list;
  },

  /**
   * The raw data is divided into multiple layers and each layer
   *     has same name.
   *
   * @return {Array.<Array.<number>>}
   */
  getLayerSeries: function () {
    var data = this.getData();
    var lenCount = data.count();
    var indexArr = [];

    for (var i = 0; i < lenCount; ++i) {
      indexArr[i] = i;
    }

    var timeDim = data.mapDimension('single'); // data group by name

    var groupResult = groupData(indexArr, function (index) {
      return data.get('name', index);
    });
    var layerSeries = [];
    groupResult.buckets.each(function (items, key) {
      items.sort(function (index1, index2) {
        return data.get(timeDim, index1) - data.get(timeDim, index2);
      });
      layerSeries.push({
        name: key,
        indices: items
      });
    });
    return layerSeries;
  },

  /**
   * Get data indices for show tooltip content
    * @param {Array.<string>|string} dim  single coordinate dimension
   * @param {number} value axis value
   * @param {module:echarts/coord/single/SingleAxis} baseAxis  single Axis used
   *     the themeRiver.
   * @return {Object} {dataIndices, nestestValue}
   */
  getAxisTooltipData: function (dim, value, baseAxis) {
    if (!zrUtil.isArray(dim)) {
      dim = dim ? [dim] : [];
    }

    var data = this.getData();
    var layerSeries = this.getLayerSeries();
    var indices = [];
    var layerNum = layerSeries.length;
    var nestestValue;

    for (var i = 0; i < layerNum; ++i) {
      var minDist = Number.MAX_VALUE;
      var nearestIdx = -1;
      var pointNum = layerSeries[i].indices.length;

      for (var j = 0; j < pointNum; ++j) {
        var theValue = data.get(dim[0], layerSeries[i].indices[j]);
        var dist = Math.abs(theValue - value);

        if (dist <= minDist) {
          nestestValue = theValue;
          minDist = dist;
          nearestIdx = layerSeries[i].indices[j];
        }
      }

      indices.push(nearestIdx);
    }

    return {
      dataIndices: indices,
      nestestValue: nestestValue
    };
  },

  /**
   * @override
   * @param {number} dataIndex  index of data
   */
  formatTooltip: function (dataIndex) {
    var data = this.getData();
    var htmlName = data.getName(dataIndex);
    var htmlValue = data.get(data.mapDimension('value'), dataIndex);

    if (isNaN(htmlValue) || htmlValue == null) {
      htmlValue = '-';
    }

    return encodeHTML(htmlName + ' : ' + htmlValue);
  },
  defaultOption: {
    zlevel: 0,
    z: 2,
    coordinateSystem: 'singleAxis',
    // gap in axis's orthogonal orientation
    boundaryGap: ['10%', '10%'],
    // legendHoverLink: true,
    singleAxisIndex: 0,
    animationEasing: 'linear',
    label: {
      margin: 4,
      show: true,
      position: 'left',
      color: '#000',
      fontSize: 11
    },
    emphasis: {
      label: {
        show: true
      }
    }
  }
});
var _default = ThemeRiverSeries;
module.exports = _default;

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var _poly = __webpack_require__(649);

var Polygon = _poly.Polygon;

var graphic = __webpack_require__(27);

var _util = __webpack_require__(1);

var bind = _util.bind;
var extend = _util.extend;

var DataDiffer = __webpack_require__(177);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = echarts.extendChartView({
  type: 'themeRiver',
  init: function () {
    this._layers = [];
  },
  render: function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var group = this.group;
    var layerSeries = seriesModel.getLayerSeries();
    var layoutInfo = data.getLayout('layoutInfo');
    var rect = layoutInfo.rect;
    var boundaryGap = layoutInfo.boundaryGap;
    group.attr('position', [0, rect.y + boundaryGap[0]]);

    function keyGetter(item) {
      return item.name;
    }

    var dataDiffer = new DataDiffer(this._layersSeries || [], layerSeries, keyGetter, keyGetter);
    var newLayersGroups = {};
    dataDiffer.add(bind(process, this, 'add')).update(bind(process, this, 'update')).remove(bind(process, this, 'remove')).execute();

    function process(status, idx, oldIdx) {
      var oldLayersGroups = this._layers;

      if (status === 'remove') {
        group.remove(oldLayersGroups[idx]);
        return;
      }

      var points0 = [];
      var points1 = [];
      var color;
      var indices = layerSeries[idx].indices;

      for (var j = 0; j < indices.length; j++) {
        var layout = data.getItemLayout(indices[j]);
        var x = layout.x;
        var y0 = layout.y0;
        var y = layout.y;
        points0.push([x, y0]);
        points1.push([x, y0 + y]);
        color = data.getItemVisual(indices[j], 'color');
      }

      var polygon;
      var text;
      var textLayout = data.getItemLayout(indices[0]);
      var itemModel = data.getItemModel(indices[j - 1]);
      var labelModel = itemModel.getModel('label');
      var margin = labelModel.get('margin');

      if (status === 'add') {
        var layerGroup = newLayersGroups[idx] = new graphic.Group();
        polygon = new Polygon({
          shape: {
            points: points0,
            stackedOnPoints: points1,
            smooth: 0.4,
            stackedOnSmooth: 0.4,
            smoothConstraint: false
          },
          z2: 0
        });
        text = new graphic.Text({
          style: {
            x: textLayout.x - margin,
            y: textLayout.y0 + textLayout.y / 2
          }
        });
        layerGroup.add(polygon);
        layerGroup.add(text);
        group.add(layerGroup);
        polygon.setClipPath(createGridClipShape(polygon.getBoundingRect(), seriesModel, function () {
          polygon.removeClipPath();
        }));
      } else {
        var layerGroup = oldLayersGroups[oldIdx];
        polygon = layerGroup.childAt(0);
        text = layerGroup.childAt(1);
        group.add(layerGroup);
        newLayersGroups[idx] = layerGroup;
        graphic.updateProps(polygon, {
          shape: {
            points: points0,
            stackedOnPoints: points1
          }
        }, seriesModel);
        graphic.updateProps(text, {
          style: {
            x: textLayout.x - margin,
            y: textLayout.y0 + textLayout.y / 2
          }
        }, seriesModel);
      }

      var hoverItemStyleModel = itemModel.getModel('emphasis.itemStyle');
      var itemStyleModel = itemModel.getModel('itemStyle');
      graphic.setTextStyle(text.style, labelModel, {
        text: labelModel.get('show') ? seriesModel.getFormattedLabel(indices[j - 1], 'normal') || data.getName(indices[j - 1]) : null,
        textVerticalAlign: 'middle'
      });
      polygon.setStyle(extend({
        fill: color
      }, itemStyleModel.getItemStyle(['color'])));
      graphic.setHoverStyle(polygon, hoverItemStyleModel.getItemStyle());
    }

    this._layersSeries = layerSeries;
    this._layers = newLayersGroups;
  },
  dispose: function () {}
}); // add animation to the view


function createGridClipShape(rect, seriesModel, cb) {
  var rectEl = new graphic.Rect({
    shape: {
      x: rect.x - 10,
      y: rect.y - 10,
      width: 0,
      height: rect.height + 20
    }
  });
  graphic.initProps(rectEl, {
    shape: {
      width: rect.width + 20,
      height: rect.height + 20
    }
  }, seriesModel, cb);
  return rectEl;
}

module.exports = _default;

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var numberUtil = __webpack_require__(37);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(ecModel, api) {
  ecModel.eachSeriesByType('themeRiver', function (seriesModel) {
    var data = seriesModel.getData();
    var single = seriesModel.coordinateSystem;
    var layoutInfo = {}; // use the axis boundingRect for view

    var rect = single.getRect();
    layoutInfo.rect = rect;
    var boundaryGap = seriesModel.get('boundaryGap');
    var axis = single.getAxis();
    layoutInfo.boundaryGap = boundaryGap;

    if (axis.orient === 'horizontal') {
      boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], rect.height);
      boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], rect.height);
      var height = rect.height - boundaryGap[0] - boundaryGap[1];
      themeRiverLayout(data, seriesModel, height);
    } else {
      boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], rect.width);
      boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], rect.width);
      var width = rect.width - boundaryGap[0] - boundaryGap[1];
      themeRiverLayout(data, seriesModel, width);
    }

    data.setLayout('layoutInfo', layoutInfo);
  });
}
/**
 * The layout information about themeriver
 *
 * @param {module:echarts/data/List} data  data in the series
 * @param {module:echarts/model/Series} seriesModel  the model object of themeRiver series
 * @param {number} height  value used to compute every series height
 */


function themeRiverLayout(data, seriesModel, height) {
  if (!data.count()) {
    return;
  }

  var coordSys = seriesModel.coordinateSystem; // the data in each layer are organized into a series.

  var layerSeries = seriesModel.getLayerSeries(); // the points in each layer.

  var timeDim = data.mapDimension('single');
  var valueDim = data.mapDimension('value');
  var layerPoints = zrUtil.map(layerSeries, function (singleLayer) {
    return zrUtil.map(singleLayer.indices, function (idx) {
      var pt = coordSys.dataToPoint(data.get(timeDim, idx));
      pt[1] = data.get(valueDim, idx);
      return pt;
    });
  });
  var base = computeBaseline(layerPoints);
  var baseLine = base.y0;
  var ky = height / base.max; // set layout information for each item.

  var n = layerSeries.length;
  var m = layerSeries[0].indices.length;
  var baseY0;

  for (var j = 0; j < m; ++j) {
    baseY0 = baseLine[j] * ky;
    data.setItemLayout(layerSeries[0].indices[j], {
      layerIndex: 0,
      x: layerPoints[0][j][0],
      y0: baseY0,
      y: layerPoints[0][j][1] * ky
    });

    for (var i = 1; i < n; ++i) {
      baseY0 += layerPoints[i - 1][j][1] * ky;
      data.setItemLayout(layerSeries[i].indices[j], {
        layerIndex: i,
        x: layerPoints[i][j][0],
        y0: baseY0,
        y: layerPoints[i][j][1] * ky
      });
    }
  }
}
/**
 * Compute the baseLine of the rawdata
 * Inspired by Lee Byron's paper Stacked Graphs - Geometry & Aesthetics
 *
 * @param  {Array.<Array>} data  the points in each layer
 * @return {Object}
 */


function computeBaseline(data) {
  var layerNum = data.length;
  var pointNum = data[0].length;
  var sums = [];
  var y0 = [];
  var max = 0;
  var temp;
  var base = {};

  for (var i = 0; i < pointNum; ++i) {
    for (var j = 0, temp = 0; j < layerNum; ++j) {
      temp += data[j][i][1];
    }

    if (temp > max) {
      max = temp;
    }

    sums.push(temp);
  }

  for (var k = 0; k < pointNum; ++k) {
    y0[k] = (max - sums[k]) / 2;
  }

  max = 0;

  for (var l = 0; l < pointNum; ++l) {
    var sum = sums[l] + y0[l];

    if (sum > max) {
      max = sum;
    }
  }

  base.y0 = y0;
  base.max = max;
  return base;
}

module.exports = _default;

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(1);

var createHashMap = _util.createHashMap;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(ecModel) {
  ecModel.eachSeriesByType('themeRiver', function (seriesModel) {
    var data = seriesModel.getData();
    var rawData = seriesModel.getRawData();
    var colorList = seriesModel.get('color');
    var idxMap = createHashMap();
    data.each(function (idx) {
      idxMap.set(data.getRawIndex(idx), idx);
    });
    rawData.each(function (rawIndex) {
      var name = rawData.getName(rawIndex);
      var color = colorList[(seriesModel.nameMap.get(name) - 1) % colorList.length];
      rawData.setItemVisual(rawIndex, 'color', color);
      var idx = idxMap.get(rawIndex);

      if (idx != null) {
        data.setItemVisual(idx, 'color', color);
      }
    });
  });
}

module.exports = _default;

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

__webpack_require__(1719);

__webpack_require__(1720);

__webpack_require__(1722);

var dataColor = __webpack_require__(304);

var sunburstLayout = __webpack_require__(1723);

var dataFilter = __webpack_require__(244);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.registerVisual(zrUtil.curry(dataColor, 'sunburst'));
echarts.registerLayout(zrUtil.curry(sunburstLayout, 'sunburst'));
echarts.registerProcessor(zrUtil.curry(dataFilter, 'sunburst'));

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var SeriesModel = __webpack_require__(74);

var Tree = __webpack_require__(421);

var Model = __webpack_require__(68);

var _treeHelper = __webpack_require__(180);

var wrapTreePathInfo = _treeHelper.wrapTreePathInfo;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = SeriesModel.extend({
  type: 'series.sunburst',

  /**
   * @type {module:echarts/data/Tree~Node}
   */
  _viewRoot: null,
  getInitialData: function (option, ecModel) {
    // Create a virtual root.
    var root = {
      name: option.name,
      children: option.data
    };
    completeTreeValue(root);
    var levelModels = zrUtil.map(option.levels || [], function (levelDefine) {
      return new Model(levelDefine, this, ecModel);
    }, this); // Make sure always a new tree is created when setOption,
    // in TreemapView, we check whether oldTree === newTree
    // to choose mappings approach among old shapes and new shapes.

    var tree = Tree.createTree(root, this, beforeLink);

    function beforeLink(nodeData) {
      nodeData.wrapMethod('getItemModel', function (model, idx) {
        var node = tree.getNodeByDataIndex(idx);
        var levelModel = levelModels[node.depth];
        levelModel && (model.parentModel = levelModel);
        return model;
      });
    }

    return tree.data;
  },
  optionUpdated: function () {
    this.resetViewRoot();
  },

  /*
   * @override
   */
  getDataParams: function (dataIndex) {
    var params = SeriesModel.prototype.getDataParams.apply(this, arguments);
    var node = this.getData().tree.getNodeByDataIndex(dataIndex);
    params.treePathInfo = wrapTreePathInfo(node, this);
    return params;
  },
  defaultOption: {
    zlevel: 0,
    z: 2,
    // 默认全局居中
    center: ['50%', '50%'],
    radius: [0, '75%'],
    // 默认顺时针
    clockwise: true,
    startAngle: 90,
    // 最小角度改为0
    minAngle: 0,
    percentPrecision: 2,
    // If still show when all data zero.
    stillShowZeroSum: true,
    // Policy of highlighting pieces when hover on one
    // Valid values: 'none' (for not downplay others), 'descendant',
    // 'ancestor', 'self'
    highlightPolicy: 'descendant',
    // 'rootToNode', 'link', or false
    nodeClick: 'rootToNode',
    renderLabelForZeroData: false,
    label: {
      // could be: 'radial', 'tangential', or 'none'
      rotate: 'radial',
      show: true,
      opacity: 1,
      // 'left' is for inner side of inside, and 'right' is for outter
      // side for inside
      align: 'center',
      position: 'inside',
      distance: 5,
      silent: true
    },
    itemStyle: {
      borderWidth: 1,
      borderColor: 'white',
      borderType: 'solid',
      shadowBlur: 0,
      shadowColor: 'rgba(0, 0, 0, 0.2)',
      shadowOffsetX: 0,
      shadowOffsetY: 0,
      opacity: 1
    },
    highlight: {
      itemStyle: {
        opacity: 1
      }
    },
    downplay: {
      itemStyle: {
        opacity: 0.5
      },
      label: {
        opacity: 0.6
      }
    },
    // Animation type canbe expansion, scale
    animationType: 'expansion',
    animationDuration: 1000,
    animationDurationUpdate: 500,
    animationEasing: 'cubicOut',
    data: [],
    levels: [],

    /**
     * Sort order.
     *
     * Valid values: 'desc', 'asc', null, or callback function.
     * 'desc' and 'asc' for descend and ascendant order;
     * null for not sorting;
     * example of callback function:
     * function(nodeA, nodeB) {
     *     return nodeA.getValue() - nodeB.getValue();
     * }
     */
    sort: 'desc'
  },
  getViewRoot: function () {
    return this._viewRoot;
  },

  /**
   * @param {module:echarts/data/Tree~Node} [viewRoot]
   */
  resetViewRoot: function (viewRoot) {
    viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
    var root = this.getRawData().tree.root;

    if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) {
      this._viewRoot = root;
    }
  }
});
/**
 * @param {Object} dataNode
 */


function completeTreeValue(dataNode) {
  // Postorder travel tree.
  // If value of none-leaf node is not set,
  // calculate it by suming up the value of all children.
  var sum = 0;
  zrUtil.each(dataNode.children, function (child) {
    completeTreeValue(child);
    var childValue = child.value;
    zrUtil.isArray(childValue) && (childValue = childValue[0]);
    sum += childValue;
  });
  var thisValue = dataNode.value;

  if (zrUtil.isArray(thisValue)) {
    thisValue = thisValue[0];
  }

  if (thisValue == null || isNaN(thisValue)) {
    thisValue = sum;
  } // Value should not less than 0.


  if (thisValue < 0) {
    thisValue = 0;
  }

  zrUtil.isArray(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
}

module.exports = _default;

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var ChartView = __webpack_require__(123);

var SunburstPiece = __webpack_require__(1721);

var DataDiffer = __webpack_require__(177);

var _format = __webpack_require__(54);

var windowOpen = _format.windowOpen;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var ROOT_TO_NODE_ACTION = 'sunburstRootToNode';
var SunburstView = ChartView.extend({
  type: 'sunburst',
  init: function () {},
  render: function (seriesModel, ecModel, api, payload) {
    var that = this;
    this.seriesModel = seriesModel;
    this.api = api;
    this.ecModel = ecModel;
    var data = seriesModel.getData();
    var virtualRoot = data.tree.root;
    var newRoot = seriesModel.getViewRoot();
    var group = this.group;
    var renderLabelForZeroData = seriesModel.get('renderLabelForZeroData');
    var newChildren = [];
    newRoot.eachNode(function (node) {
      newChildren.push(node);
    });
    var oldChildren = this._oldChildren || [];
    dualTravel(newChildren, oldChildren);
    renderRollUp(virtualRoot, newRoot);

    if (payload && payload.highlight && payload.highlight.piece) {
      var highlightPolicy = seriesModel.getShallow('highlightPolicy');
      payload.highlight.piece.onEmphasis(highlightPolicy);
    } else if (payload && payload.unhighlight) {
      var piece = this.virtualPiece;

      if (!piece && virtualRoot.children.length) {
        piece = virtualRoot.children[0].piece;
      }

      if (piece) {
        piece.onNormal();
      }
    }

    this._initEvents();

    this._oldChildren = newChildren;

    function dualTravel(newChildren, oldChildren) {
      if (newChildren.length === 0 && oldChildren.length === 0) {
        return;
      }

      new DataDiffer(oldChildren, newChildren, getKey, getKey).add(processNode).update(processNode).remove(zrUtil.curry(processNode, null)).execute();

      function getKey(node) {
        return node.getId();
      }

      function processNode(newId, oldId) {
        var newNode = newId == null ? null : newChildren[newId];
        var oldNode = oldId == null ? null : oldChildren[oldId];
        doRenderNode(newNode, oldNode);
      }
    }

    function doRenderNode(newNode, oldNode) {
      if (!renderLabelForZeroData && newNode && !newNode.getValue()) {
        // Not render data with value 0
        newNode = null;
      }

      if (newNode !== virtualRoot && oldNode !== virtualRoot) {
        if (oldNode && oldNode.piece) {
          if (newNode) {
            // Update
            oldNode.piece.updateData(false, newNode, 'normal', seriesModel, ecModel); // For tooltip

            data.setItemGraphicEl(newNode.dataIndex, oldNode.piece);
          } else {
            // Remove
            removeNode(oldNode);
          }
        } else if (newNode) {
          // Add
          var piece = new SunburstPiece(newNode, seriesModel, ecModel);
          group.add(piece); // For tooltip

          data.setItemGraphicEl(newNode.dataIndex, piece);
        }
      }
    }

    function removeNode(node) {
      if (!node) {
        return;
      }

      if (node.piece) {
        group.remove(node.piece);
        node.piece = null;
      }
    }

    function renderRollUp(virtualRoot, viewRoot) {
      if (viewRoot.depth > 0) {
        // Render
        if (that.virtualPiece) {
          // Update
          that.virtualPiece.updateData(false, virtualRoot, 'normal', seriesModel, ecModel);
        } else {
          // Add
          that.virtualPiece = new SunburstPiece(virtualRoot, seriesModel, ecModel);
          group.add(that.virtualPiece);
        }

        if (viewRoot.piece._onclickEvent) {
          viewRoot.piece.off('click', viewRoot.piece._onclickEvent);
        }

        var event = function (e) {
          that._rootToNode(viewRoot.parentNode);
        };

        viewRoot.piece._onclickEvent = event;
        that.virtualPiece.on('click', event);
      } else if (that.virtualPiece) {
        // Remove
        group.remove(that.virtualPiece);
        that.virtualPiece = null;
      }
    }
  },
  dispose: function () {},

  /**
   * @private
   */
  _initEvents: function () {
    var that = this;

    var event = function (e) {
      var targetFound = false;
      var viewRoot = that.seriesModel.getViewRoot();
      viewRoot.eachNode(function (node) {
        if (!targetFound && node.piece && node.piece.childAt(0) === e.target) {
          var nodeClick = node.getModel().get('nodeClick');

          if (nodeClick === 'rootToNode') {
            that._rootToNode(node);
          } else if (nodeClick === 'link') {
            var itemModel = node.getModel();
            var link = itemModel.get('link');

            if (link) {
              var linkTarget = itemModel.get('target', true) || '_blank';
              windowOpen(link, linkTarget);
            }
          }

          targetFound = true;
        }
      });
    };

    if (this.group._onclickEvent) {
      this.group.off('click', this.group._onclickEvent);
    }

    this.group.on('click', event);
    this.group._onclickEvent = event;
  },

  /**
   * @private
   */
  _rootToNode: function (node) {
    if (node !== this.seriesModel.getViewRoot()) {
      this.api.dispatchAction({
        type: ROOT_TO_NODE_ACTION,
        from: this.uid,
        seriesId: this.seriesModel.id,
        targetNode: node
      });
    }
  },

  /**
   * @implement
   */
  containPoint: function (point, seriesModel) {
    var treeRoot = seriesModel.getData();
    var itemLayout = treeRoot.getItemLayout(0);

    if (itemLayout) {
      var dx = point[0] - itemLayout.cx;
      var dy = point[1] - itemLayout.cy;
      var radius = Math.sqrt(dx * dx + dy * dy);
      return radius <= itemLayout.r && radius >= itemLayout.r0;
    }
  }
});
var _default = SunburstView;
module.exports = _default;

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var graphic = __webpack_require__(27);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var NodeHighlightPolicy = {
  NONE: 'none',
  // not downplay others
  DESCENDANT: 'descendant',
  ANCESTOR: 'ancestor',
  SELF: 'self'
};
var DEFAULT_SECTOR_Z = 2;
var DEFAULT_TEXT_Z = 4;
/**
 * Sunburstce of Sunburst including Sector, Label, LabelLine
 * @constructor
 * @extends {module:zrender/graphic/Group}
 */

function SunburstPiece(node, seriesModel, ecModel) {
  graphic.Group.call(this);
  var sector = new graphic.Sector({
    z2: DEFAULT_SECTOR_Z
  });
  sector.seriesIndex = seriesModel.seriesIndex;
  var text = new graphic.Text({
    z2: DEFAULT_TEXT_Z,
    silent: node.getModel('label').get('silent')
  });
  this.add(sector);
  this.add(text);
  this.updateData(true, node, 'normal', seriesModel, ecModel); // Hover to change label and labelLine

  function onEmphasis() {
    text.ignore = text.hoverIgnore;
  }

  function onNormal() {
    text.ignore = text.normalIgnore;
  }

  this.on('emphasis', onEmphasis).on('normal', onNormal).on('mouseover', onEmphasis).on('mouseout', onNormal);
}

var SunburstPieceProto = SunburstPiece.prototype;

SunburstPieceProto.updateData = function (firstCreate, node, state, seriesModel, ecModel) {
  this.node = node;
  node.piece = this;
  seriesModel = seriesModel || this._seriesModel;
  ecModel = ecModel || this._ecModel;
  var sector = this.childAt(0);
  sector.dataIndex = node.dataIndex;
  var itemModel = node.getModel();
  var layout = node.getLayout(); // if (!layout) {
  //     console.log(node.getLayout());
  // }

  var sectorShape = zrUtil.extend({}, layout);
  sectorShape.label = null;
  var visualColor = getNodeColor(node, seriesModel, ecModel);
  fillDefaultColor(node, seriesModel, visualColor);
  var normalStyle = itemModel.getModel('itemStyle').getItemStyle();
  var style;

  if (state === 'normal') {
    style = normalStyle;
  } else {
    var stateStyle = itemModel.getModel(state + '.itemStyle').getItemStyle();
    style = zrUtil.merge(stateStyle, normalStyle);
  }

  style = zrUtil.defaults({
    lineJoin: 'bevel',
    fill: style.fill || visualColor
  }, style);

  if (firstCreate) {
    sector.setShape(sectorShape);
    sector.shape.r = layout.r0;
    graphic.updateProps(sector, {
      shape: {
        r: layout.r
      }
    }, seriesModel, node.dataIndex);
    sector.useStyle(style);
  } else if (typeof style.fill === 'object' && style.fill.type || typeof sector.style.fill === 'object' && sector.style.fill.type) {
    // Disable animation for gradient since no interpolation method
    // is supported for gradient
    graphic.updateProps(sector, {
      shape: sectorShape
    }, seriesModel);
    sector.useStyle(style);
  } else {
    graphic.updateProps(sector, {
      shape: sectorShape,
      style: style
    }, seriesModel);
  }

  this._updateLabel(seriesModel, visualColor, state);

  var cursorStyle = itemModel.getShallow('cursor');
  cursorStyle && sector.attr('cursor', cursorStyle);

  if (firstCreate) {
    var highlightPolicy = seriesModel.getShallow('highlightPolicy');

    this._initEvents(sector, node, seriesModel, highlightPolicy);
  }

  this._seriesModel = seriesModel || this._seriesModel;
  this._ecModel = ecModel || this._ecModel;
  graphic.setHoverStyle(this);
};

SunburstPieceProto.onEmphasis = function (highlightPolicy) {
  var that = this;
  this.node.hostTree.root.eachNode(function (n) {
    if (n.piece) {
      if (that.node === n) {
        n.piece.updateData(false, n, 'emphasis');
      } else if (isNodeHighlighted(n, that.node, highlightPolicy)) {
        n.piece.childAt(0).trigger('highlight');
      } else if (highlightPolicy !== NodeHighlightPolicy.NONE) {
        n.piece.childAt(0).trigger('downplay');
      }
    }
  });
};

SunburstPieceProto.onNormal = function () {
  this.node.hostTree.root.eachNode(function (n) {
    if (n.piece) {
      n.piece.updateData(false, n, 'normal');
    }
  });
};

SunburstPieceProto.onHighlight = function () {
  this.updateData(false, this.node, 'highlight');
};

SunburstPieceProto.onDownplay = function () {
  this.updateData(false, this.node, 'downplay');
};

SunburstPieceProto._updateLabel = function (seriesModel, visualColor, state) {
  var itemModel = this.node.getModel();
  var normalModel = itemModel.getModel('label');
  var labelModel = state === 'normal' || state === 'emphasis' ? normalModel : itemModel.getModel(state + '.label');
  var labelHoverModel = itemModel.getModel('emphasis.label');
  var labelFormatter = labelModel.get('formatter'); // Use normal formatter if no state formatter is defined

  var labelState = labelFormatter ? state : 'normal';
  var text = zrUtil.retrieve(seriesModel.getFormattedLabel(this.node.dataIndex, labelState, null, null, 'label'), this.node.name);

  if (getLabelAttr('show') === false) {
    text = '';
  }

  var layout = this.node.getLayout();
  var labelMinAngle = labelModel.get('minAngle');

  if (labelMinAngle == null) {
    labelMinAngle = normalModel.get('minAngle');
  }

  labelMinAngle = labelMinAngle / 180 * Math.PI;
  var angle = layout.endAngle - layout.startAngle;

  if (labelMinAngle != null && Math.abs(angle) < labelMinAngle) {
    // Not displaying text when angle is too small
    text = '';
  }

  var label = this.childAt(1);
  graphic.setLabelStyle(label.style, label.hoverStyle || {}, normalModel, labelHoverModel, {
    defaultText: labelModel.getShallow('show') ? text : null,
    autoColor: visualColor,
    useInsideStyle: true
  });
  var midAngle = (layout.startAngle + layout.endAngle) / 2;
  var dx = Math.cos(midAngle);
  var dy = Math.sin(midAngle);
  var r;
  var labelPosition = getLabelAttr('position');
  var labelPadding = getLabelAttr('distance') || 0;
  var textAlign = getLabelAttr('align');

  if (labelPosition === 'outside') {
    r = layout.r + labelPadding;
    textAlign = midAngle > Math.PI / 2 ? 'right' : 'left';
  } else {
    if (!textAlign || textAlign === 'center') {
      r = (layout.r + layout.r0) / 2;
      textAlign = 'center';
    } else if (textAlign === 'left') {
      r = layout.r0 + labelPadding;

      if (midAngle > Math.PI / 2) {
        textAlign = 'right';
      }
    } else if (textAlign === 'right') {
      r = layout.r - labelPadding;

      if (midAngle > Math.PI / 2) {
        textAlign = 'left';
      }
    }
  }

  label.attr('style', {
    text: text,
    textAlign: textAlign,
    textVerticalAlign: getLabelAttr('verticalAlign') || 'middle',
    opacity: getLabelAttr('opacity')
  });
  var textX = r * dx + layout.cx;
  var textY = r * dy + layout.cy;
  label.attr('position', [textX, textY]);
  var rotateType = getLabelAttr('rotate');
  var rotate = 0;

  if (rotateType === 'radial') {
    rotate = -midAngle;

    if (rotate < -Math.PI / 2) {
      rotate += Math.PI;
    }
  } else if (rotateType === 'tangential') {
    rotate = Math.PI / 2 - midAngle;

    if (rotate > Math.PI / 2) {
      rotate -= Math.PI;
    } else if (rotate < -Math.PI / 2) {
      rotate += Math.PI;
    }
  } else if (typeof rotateType === 'number') {
    rotate = rotateType * Math.PI / 180;
  }

  label.attr('rotation', rotate);

  function getLabelAttr(name) {
    var stateAttr = labelModel.get(name);

    if (stateAttr == null) {
      return normalModel.get(name);
    } else {
      return stateAttr;
    }
  }
};

SunburstPieceProto._initEvents = function (sector, node, seriesModel, highlightPolicy) {
  sector.off('mouseover').off('mouseout').off('emphasis').off('normal');
  var that = this;

  var onEmphasis = function () {
    that.onEmphasis(highlightPolicy);
  };

  var onNormal = function () {
    that.onNormal();
  };

  var onDownplay = function () {
    that.onDownplay();
  };

  var onHighlight = function () {
    that.onHighlight();
  };

  if (seriesModel.isAnimationEnabled()) {
    sector.on('mouseover', onEmphasis).on('mouseout', onNormal).on('emphasis', onEmphasis).on('normal', onNormal).on('downplay', onDownplay).on('highlight', onHighlight);
  }
};

zrUtil.inherits(SunburstPiece, graphic.Group);
var _default = SunburstPiece;
/**
 * Get node color
 *
 * @param {TreeNode} node the node to get color
 * @param {module:echarts/model/Series} seriesModel series
 * @param {module:echarts/model/Global} ecModel echarts defaults
 */

function getNodeColor(node, seriesModel, ecModel) {
  // Color from visualMap
  var visualColor = node.getVisual('color');
  var visualMetaList = node.getVisual('visualMeta');

  if (!visualMetaList || visualMetaList.length === 0) {
    // Use first-generation color if has no visualMap
    visualColor = null;
  } // Self color or level color


  var color = node.getModel('itemStyle').get('color');

  if (color) {
    return color;
  } else if (visualColor) {
    // Color mapping
    return visualColor;
  } else if (node.depth === 0) {
    // Virtual root node
    return ecModel.option.color[0];
  } else {
    // First-generation color
    var length = ecModel.option.color.length;
    color = ecModel.option.color[getRootId(node) % length];
  }

  return color;
}
/**
 * Get index of root in sorted order
 *
 * @param {TreeNode} node current node
 * @return {number} index in root
 */


function getRootId(node) {
  var ancestor = node;

  while (ancestor.depth > 1) {
    ancestor = ancestor.parentNode;
  }

  var virtualRoot = node.getAncestors()[0];
  return zrUtil.indexOf(virtualRoot.children, ancestor);
}

function isNodeHighlighted(node, activeNode, policy) {
  if (policy === NodeHighlightPolicy.NONE) {
    return false;
  } else if (policy === NodeHighlightPolicy.SELF) {
    return node === activeNode;
  } else if (policy === NodeHighlightPolicy.ANCESTOR) {
    return node === activeNode || node.isAncestorOf(activeNode);
  } else {
    return node === activeNode || node.isDescendantOf(activeNode);
  }
} // Fix tooltip callback function params.color incorrect when pick a default color


function fillDefaultColor(node, seriesModel, color) {
  var data = seriesModel.getData();
  data.setItemVisual(node.dataIndex, 'color', color);
}

module.exports = _default;

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var helper = __webpack_require__(180);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @file Sunburst action
 */
var ROOT_TO_NODE_ACTION = 'sunburstRootToNode';
echarts.registerAction({
  type: ROOT_TO_NODE_ACTION,
  update: 'updateView'
}, function (payload, ecModel) {
  ecModel.eachComponent({
    mainType: 'series',
    subType: 'sunburst',
    query: payload
  }, handleRootToNode);

  function handleRootToNode(model, index) {
    var targetInfo = helper.retrieveTargetInfo(payload, [ROOT_TO_NODE_ACTION], model);

    if (targetInfo) {
      var originViewRoot = model.getViewRoot();

      if (originViewRoot) {
        payload.direction = helper.aboveViewRoot(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
      }

      model.resetViewRoot(targetInfo.node);
    }
  }
});
var HIGHLIGHT_ACTION = 'sunburstHighlight';
echarts.registerAction({
  type: HIGHLIGHT_ACTION,
  update: 'updateView'
}, function (payload, ecModel) {
  ecModel.eachComponent({
    mainType: 'series',
    subType: 'sunburst',
    query: payload
  }, handleHighlight);

  function handleHighlight(model, index) {
    var targetInfo = helper.retrieveTargetInfo(payload, [HIGHLIGHT_ACTION], model);

    if (targetInfo) {
      payload.highlight = targetInfo.node;
    }
  }
});
var UNHIGHLIGHT_ACTION = 'sunburstUnhighlight';
echarts.registerAction({
  type: UNHIGHLIGHT_ACTION,
  update: 'updateView'
}, function (payload, ecModel) {
  ecModel.eachComponent({
    mainType: 'series',
    subType: 'sunburst',
    query: payload
  }, handleUnhighlight);

  function handleUnhighlight(model, index) {
    payload.unhighlight = true;
  }
});

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _number = __webpack_require__(37);

var parsePercent = _number.parsePercent;

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// var PI2 = Math.PI * 2;
var RADIAN = Math.PI / 180;

function _default(seriesType, ecModel, api, payload) {
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    var center = seriesModel.get('center');
    var radius = seriesModel.get('radius');

    if (!zrUtil.isArray(radius)) {
      radius = [0, radius];
    }

    if (!zrUtil.isArray(center)) {
      center = [center, center];
    }

    var width = api.getWidth();
    var height = api.getHeight();
    var size = Math.min(width, height);
    var cx = parsePercent(center[0], width);
    var cy = parsePercent(center[1], height);
    var r0 = parsePercent(radius[0], size / 2);
    var r = parsePercent(radius[1], size / 2);
    var startAngle = -seriesModel.get('startAngle') * RADIAN;
    var minAngle = seriesModel.get('minAngle') * RADIAN;
    var virtualRoot = seriesModel.getData().tree.root;
    var treeRoot = seriesModel.getViewRoot();
    var rootDepth = treeRoot.depth;
    var sort = seriesModel.get('sort');

    if (sort != null) {
      initChildren(treeRoot, sort);
    }

    var validDataCount = 0;
    zrUtil.each(treeRoot.children, function (child) {
      !isNaN(child.getValue()) && validDataCount++;
    });
    var sum = treeRoot.getValue(); // Sum may be 0

    var unitRadian = Math.PI / (sum || validDataCount) * 2;
    var renderRollupNode = treeRoot.depth > 0;
    var levels = treeRoot.height - (renderRollupNode ? -1 : 1);
    var rPerLevel = (r - r0) / (levels || 1);
    var clockwise = seriesModel.get('clockwise');
    var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // In the case some sector angle is smaller than minAngle
    // var restAngle = PI2;
    // var valueSumLargerThanMinAngle = 0;

    var dir = clockwise ? 1 : -1;
    /**
     * Render a tree
     * @return increased angle
     */

    var renderNode = function (node, startAngle) {
      if (!node) {
        return;
      }

      var endAngle = startAngle; // Render self

      if (node !== virtualRoot) {
        // Tree node is virtual, so it doesn't need to be drawn
        var value = node.getValue();
        var angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;

        if (angle < minAngle) {
          angle = minAngle; // restAngle -= minAngle;
        } // else {
        //     valueSumLargerThanMinAngle += value;
        // }


        endAngle = startAngle + dir * angle;
        var depth = node.depth - rootDepth - (renderRollupNode ? -1 : 1);
        var rStart = r0 + rPerLevel * depth;
        var rEnd = r0 + rPerLevel * (depth + 1);
        var itemModel = node.getModel();

        if (itemModel.get('r0') != null) {
          rStart = parsePercent(itemModel.get('r0'), size / 2);
        }

        if (itemModel.get('r') != null) {
          rEnd = parsePercent(itemModel.get('r'), size / 2);
        }

        node.setLayout({
          angle: angle,
          startAngle: startAngle,
          endAngle: endAngle,
          clockwise: clockwise,
          cx: cx,
          cy: cy,
          r0: rStart,
          r: rEnd
        });
      } // Render children


      if (node.children && node.children.length) {
        // currentAngle = startAngle;
        var siblingAngle = 0;
        zrUtil.each(node.children, function (node) {
          siblingAngle += renderNode(node, startAngle + siblingAngle);
        });
      }

      return endAngle - startAngle;
    }; // Virtual root node for roll up


    if (renderRollupNode) {
      var rStart = r0;
      var rEnd = r0 + rPerLevel;
      var angle = Math.PI * 2;
      virtualRoot.setLayout({
        angle: angle,
        startAngle: startAngle,
        endAngle: startAngle + angle,
        clockwise: clockwise,
        cx: cx,
        cy: cy,
        r0: rStart,
        r: rEnd
      });
    }

    renderNode(treeRoot, startAngle);
  });
}
/**
 * Init node children by order and update visual
 *
 * @param {TreeNode} node  root node
 * @param {boolean}  isAsc if is in ascendant order
 */


function initChildren(node, isAsc) {
  var children = node.children || [];
  node.children = sort(children, isAsc); // Init children recursively

  if (children.length) {
    zrUtil.each(node.children, function (child) {
      initChildren(child, isAsc);
    });
  }
}
/**
 * Sort children nodes
 *
 * @param {TreeNode[]}               children children of node to be sorted
 * @param {string | function | null} sort sort method
 *                                   See SunburstSeries.js for details.
 */


function sort(children, sortOrder) {
  if (typeof sortOrder === 'function') {
    return children.sort(sortOrder);
  } else {
    var isAsc = sortOrder === 'asc';
    return children.sort(function (a, b) {
      var diff = (a.getValue() - b.getValue()) * (isAsc ? 1 : -1);
      return diff === 0 ? (a.dataIndex - b.dataIndex) * (isAsc ? -1 : 1) : diff;
    });
  }
}

module.exports = _default;

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(1);

var graphicUtil = __webpack_require__(27);

var _labelHelper = __webpack_require__(414);

var getDefaultLabel = _labelHelper.getDefaultLabel;

var createListFromArray = __webpack_require__(137);

var _barGrid = __webpack_require__(300);

var getLayoutOnAxis = _barGrid.getLayoutOnAxis;

var DataDiffer = __webpack_require__(177);

var SeriesModel = __webpack_require__(74);

var Model = __webpack_require__(68);

var ChartView = __webpack_require__(123);

var _createClipPathFromCoordSys = __webpack_require__(240);

var createClipPath = _createClipPathFromCoordSys.createClipPath;

var prepareCartesian2d = __webpack_require__(1725);

var prepareGeo = __webpack_require__(1726);

var prepareSingleAxis = __webpack_require__(1727);

var preparePolar = __webpack_require__(1728);

var prepareCalendar = __webpack_require__(1729);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var CACHED_LABEL_STYLE_PROPERTIES = graphicUtil.CACHED_LABEL_STYLE_PROPERTIES;
var ITEM_STYLE_NORMAL_PATH = ['itemStyle'];
var ITEM_STYLE_EMPHASIS_PATH = ['emphasis', 'itemStyle'];
var LABEL_NORMAL = ['label'];
var LABEL_EMPHASIS = ['emphasis', 'label']; // Use prefix to avoid index to be the same as el.name,
// which will cause weird udpate animation.

var GROUP_DIFF_PREFIX = 'e\0\0';
/**
 * To reduce total package size of each coordinate systems, the modules `prepareCustom`
 * of each coordinate systems are not required by each coordinate systems directly, but
 * required by the module `custom`.
 *
 * prepareInfoForCustomSeries {Function}: optional
 *     @return {Object} {coordSys: {...}, api: {
 *         coord: function (data, clamp) {}, // return point in global.
 *         size: function (dataSize, dataItem) {} // return size of each axis in coordSys.
 *     }}
 */

var prepareCustoms = {
  cartesian2d: prepareCartesian2d,
  geo: prepareGeo,
  singleAxis: prepareSingleAxis,
  polar: preparePolar,
  calendar: prepareCalendar
}; // ------
// Model
// ------

SeriesModel.extend({
  type: 'series.custom',
  dependencies: ['grid', 'polar', 'geo', 'singleAxis', 'calendar'],
  defaultOption: {
    coordinateSystem: 'cartesian2d',
    // Can be set as 'none'
    zlevel: 0,
    z: 2,
    legendHoverLink: true,
    useTransform: true,
    // Custom series will not clip by default.
    // Some case will use custom series to draw label
    // For example https://echarts.apache.org/examples/en/editor.html?c=custom-gantt-flight
    // Only works on polar and cartesian2d coordinate system.
    clip: false // Cartesian coordinate system
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // Polar coordinate system
    // polarIndex: 0,
    // Geo coordinate system
    // geoIndex: 0,
    // label: {}
    // itemStyle: {}

  },

  /**
   * @override
   */
  getInitialData: function (option, ecModel) {
    return createListFromArray(this.getSource(), this);
  },

  /**
   * @override
   */
  getDataParams: function (dataIndex, dataType, el) {
    var params = SeriesModel.prototype.getDataParams.apply(this, arguments);
    el && (params.info = el.info);
    return params;
  }
}); // -----
// View
// -----

ChartView.extend({
  type: 'custom',

  /**
   * @private
   * @type {module:echarts/data/List}
   */
  _data: null,

  /**
   * @override
   */
  render: function (customSeries, ecModel, api, payload) {
    var oldData = this._data;
    var data = customSeries.getData();
    var group = this.group;
    var renderItem = makeRenderItem(customSeries, data, ecModel, api); // By default, merge mode is applied. In most cases, custom series is
    // used in the scenario that data amount is not large but graphic elements
    // is complicated, where merge mode is probably necessary for optimization.
    // For example, reuse graphic elements and only update the transform when
    // roam or data zoom according to `actionType`.

    data.diff(oldData).add(function (newIdx) {
      createOrUpdate(null, newIdx, renderItem(newIdx, payload), customSeries, group, data);
    }).update(function (newIdx, oldIdx) {
      var el = oldData.getItemGraphicEl(oldIdx);
      createOrUpdate(el, newIdx, renderItem(newIdx, payload), customSeries, group, data);
    }).remove(function (oldIdx) {
      var el = oldData.getItemGraphicEl(oldIdx);
      el && group.remove(el);
    }).execute(); // Do clipping

    var clipPath = customSeries.get('clip', true) ? createClipPath(customSeries.coordinateSystem, false, customSeries) : null;

    if (clipPath) {
      group.setClipPath(clipPath);
    } else {
      group.removeClipPath();
    }

    this._data = data;
  },
  incrementalPrepareRender: function (customSeries, ecModel, api) {
    this.group.removeAll();
    this._data = null;
  },
  incrementalRender: function (params, customSeries, ecModel, api, payload) {
    var data = customSeries.getData();
    var renderItem = makeRenderItem(customSeries, data, ecModel, api);

    function setIncrementalAndHoverLayer(el) {
      if (!el.isGroup) {
        el.incremental = true;
        el.useHoverLayer = true;
      }
    }

    for (var idx = params.start; idx < params.end; idx++) {
      var el = createOrUpdate(null, idx, renderItem(idx, payload), customSeries, this.group, data);
      el.traverse(setIncrementalAndHoverLayer);
    }
  },

  /**
   * @override
   */
  dispose: zrUtil.noop,

  /**
   * @override
   */
  filterForExposedEvent: function (eventType, query, targetEl, packedEvent) {
    var elementName = query.element;

    if (elementName == null || targetEl.name === elementName) {
      return true;
    } // Enable to give a name on a group made by `renderItem`, and listen
    // events that triggerd by its descendents.


    while ((targetEl = targetEl.parent) && targetEl !== this.group) {
      if (targetEl.name === elementName) {
        return true;
      }
    }

    return false;
  }
});

function createEl(elOption) {
  var graphicType = elOption.type;
  var el; // Those graphic elements are not shapes. They should not be
  // overwritten by users, so do them first.

  if (graphicType === 'path') {
    var shape = elOption.shape; // Using pathRect brings convenience to users sacle svg path.

    var pathRect = shape.width != null && shape.height != null ? {
      x: shape.x || 0,
      y: shape.y || 0,
      width: shape.width,
      height: shape.height
    } : null;
    var pathData = getPathData(shape); // Path is also used for icon, so layout 'center' by default.

    el = graphicUtil.makePath(pathData, null, pathRect, shape.layout || 'center');
    el.__customPathData = pathData;
  } else if (graphicType === 'image') {
    el = new graphicUtil.Image({});
    el.__customImagePath = elOption.style.image;
  } else if (graphicType === 'text') {
    el = new graphicUtil.Text({});
    el.__customText = elOption.style.text;
  } else if (graphicType === 'group') {
    el = new graphicUtil.Group();
  } else if (graphicType === 'compoundPath') {
    throw new Error('"compoundPath" is not supported yet.');
  } else {
    var Clz = graphicUtil.getShapeClass(graphicType);
    el = new Clz();
  }

  el.__customGraphicType = graphicType;
  el.name = elOption.name;
  return el;
}

function updateEl(el, dataIndex, elOption, animatableModel, data, isInit, isRoot) {
  var transitionProps = {};
  var elOptionStyle = elOption.style || {};
  elOption.shape && (transitionProps.shape = zrUtil.clone(elOption.shape));
  elOption.position && (transitionProps.position = elOption.position.slice());
  elOption.scale && (transitionProps.scale = elOption.scale.slice());
  elOption.origin && (transitionProps.origin = elOption.origin.slice());
  elOption.rotation && (transitionProps.rotation = elOption.rotation);

  if (el.type === 'image' && elOption.style) {
    var targetStyle = transitionProps.style = {};
    zrUtil.each(['x', 'y', 'width', 'height'], function (prop) {
      prepareStyleTransition(prop, targetStyle, elOptionStyle, el.style, isInit);
    });
  }

  if (el.type === 'text' && elOption.style) {
    var targetStyle = transitionProps.style = {};
    zrUtil.each(['x', 'y'], function (prop) {
      prepareStyleTransition(prop, targetStyle, elOptionStyle, el.style, isInit);
    }); // Compatible with previous: both support
    // textFill and fill, textStroke and stroke in 'text' element.

    !elOptionStyle.hasOwnProperty('textFill') && elOptionStyle.fill && (elOptionStyle.textFill = elOptionStyle.fill);
    !elOptionStyle.hasOwnProperty('textStroke') && elOptionStyle.stroke && (elOptionStyle.textStroke = elOptionStyle.stroke);
  }

  if (el.type !== 'group') {
    el.useStyle(elOptionStyle); // Init animation.

    if (isInit) {
      el.style.opacity = 0;
      var targetOpacity = elOptionStyle.opacity;
      targetOpacity == null && (targetOpacity = 1);
      graphicUtil.initProps(el, {
        style: {
          opacity: targetOpacity
        }
      }, animatableModel, dataIndex);
    }
  }

  if (isInit) {
    el.attr(transitionProps);
  } else {
    graphicUtil.updateProps(el, transitionProps, animatableModel, dataIndex);
  } // Merge by default.
  // z2 must not be null/undefined, otherwise sort error may occur.


  elOption.hasOwnProperty('z2') && el.attr('z2', elOption.z2 || 0);
  elOption.hasOwnProperty('silent') && el.attr('silent', elOption.silent);
  elOption.hasOwnProperty('invisible') && el.attr('invisible', elOption.invisible);
  elOption.hasOwnProperty('ignore') && el.attr('ignore', elOption.ignore); // `elOption.info` enables user to mount some info on
  // elements and use them in event handlers.
  // Update them only when user specified, otherwise, remain.

  elOption.hasOwnProperty('info') && el.attr('info', elOption.info); // If `elOption.styleEmphasis` is `false`, remove hover style. The
  // logic is ensured by `graphicUtil.setElementHoverStyle`.

  var styleEmphasis = elOption.styleEmphasis; // hoverStyle should always be set here, because if the hover style
  // may already be changed, where the inner cache should be reset.

  graphicUtil.setElementHoverStyle(el, styleEmphasis);

  if (isRoot) {
    graphicUtil.setAsHighDownDispatcher(el, styleEmphasis !== false);
  }
}

function prepareStyleTransition(prop, targetStyle, elOptionStyle, oldElStyle, isInit) {
  if (elOptionStyle[prop] != null && !isInit) {
    targetStyle[prop] = elOptionStyle[prop];
    elOptionStyle[prop] = oldElStyle[prop];
  }
}

function makeRenderItem(customSeries, data, ecModel, api) {
  var renderItem = customSeries.get('renderItem');
  var coordSys = customSeries.coordinateSystem;
  var prepareResult = {};

  if (coordSys) {
    prepareResult = coordSys.prepareCustoms ? coordSys.prepareCustoms() : prepareCustoms[coordSys.type](coordSys);
  }

  var userAPI = zrUtil.defaults({
    getWidth: api.getWidth,
    getHeight: api.getHeight,
    getZr: api.getZr,
    getDevicePixelRatio: api.getDevicePixelRatio,
    value: value,
    style: style,
    styleEmphasis: styleEmphasis,
    visual: visual,
    barLayout: barLayout,
    currentSeriesIndices: currentSeriesIndices,
    font: font
  }, prepareResult.api || {});
  var userParams = {
    // The life cycle of context: current round of rendering.
    // The global life cycle is probably not necessary, because
    // user can store global status by themselves.
    context: {},
    seriesId: customSeries.id,
    seriesName: customSeries.name,
    seriesIndex: customSeries.seriesIndex,
    coordSys: prepareResult.coordSys,
    dataInsideLength: data.count(),
    encode: wrapEncodeDef(customSeries.getData())
  }; // Do not support call `api` asynchronously without dataIndexInside input.

  var currDataIndexInside;
  var currDirty = true;
  var currItemModel;
  var currLabelNormalModel;
  var currLabelEmphasisModel;
  var currVisualColor;
  return function (dataIndexInside, payload) {
    currDataIndexInside = dataIndexInside;
    currDirty = true;
    return renderItem && renderItem(zrUtil.defaults({
      dataIndexInside: dataIndexInside,
      dataIndex: data.getRawIndex(dataIndexInside),
      // Can be used for optimization when zoom or roam.
      actionType: payload ? payload.type : null
    }, userParams), userAPI);
  }; // Do not update cache until api called.

  function updateCache(dataIndexInside) {
    dataIndexInside == null && (dataIndexInside = currDataIndexInside);

    if (currDirty) {
      currItemModel = data.getItemModel(dataIndexInside);
      currLabelNormalModel = currItemModel.getModel(LABEL_NORMAL);
      currLabelEmphasisModel = currItemModel.getModel(LABEL_EMPHASIS);
      currVisualColor = data.getItemVisual(dataIndexInside, 'color');
      currDirty = false;
    }
  }
  /**
   * @public
   * @param {number|string} dim
   * @param {number} [dataIndexInside=currDataIndexInside]
   * @return {number|string} value
   */


  function value(dim, dataIndexInside) {
    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
    return data.get(data.getDimension(dim || 0), dataIndexInside);
  }
  /**
   * By default, `visual` is applied to style (to support visualMap).
   * `visual.color` is applied at `fill`. If user want apply visual.color on `stroke`,
   * it can be implemented as:
   * `api.style({stroke: api.visual('color'), fill: null})`;
   * @public
   * @param {Object} [extra]
   * @param {number} [dataIndexInside=currDataIndexInside]
   */


  function style(extra, dataIndexInside) {
    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
    updateCache(dataIndexInside);
    var itemStyle = currItemModel.getModel(ITEM_STYLE_NORMAL_PATH).getItemStyle();
    currVisualColor != null && (itemStyle.fill = currVisualColor);
    var opacity = data.getItemVisual(dataIndexInside, 'opacity');
    opacity != null && (itemStyle.opacity = opacity);
    var labelModel = extra ? applyExtraBefore(extra, currLabelNormalModel) : currLabelNormalModel;
    graphicUtil.setTextStyle(itemStyle, labelModel, null, {
      autoColor: currVisualColor,
      isRectText: true
    });
    itemStyle.text = labelModel.getShallow('show') ? zrUtil.retrieve2(customSeries.getFormattedLabel(dataIndexInside, 'normal'), getDefaultLabel(data, dataIndexInside)) : null;
    extra && applyExtraAfter(itemStyle, extra);
    return itemStyle;
  }
  /**
   * @public
   * @param {Object} [extra]
   * @param {number} [dataIndexInside=currDataIndexInside]
   */


  function styleEmphasis(extra, dataIndexInside) {
    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
    updateCache(dataIndexInside);
    var itemStyle = currItemModel.getModel(ITEM_STYLE_EMPHASIS_PATH).getItemStyle();
    var labelModel = extra ? applyExtraBefore(extra, currLabelEmphasisModel) : currLabelEmphasisModel;
    graphicUtil.setTextStyle(itemStyle, labelModel, null, {
      isRectText: true
    }, true);
    itemStyle.text = labelModel.getShallow('show') ? zrUtil.retrieve3(customSeries.getFormattedLabel(dataIndexInside, 'emphasis'), customSeries.getFormattedLabel(dataIndexInside, 'normal'), getDefaultLabel(data, dataIndexInside)) : null;
    extra && applyExtraAfter(itemStyle, extra);
    return itemStyle;
  }
  /**
   * @public
   * @param {string} visualType
   * @param {number} [dataIndexInside=currDataIndexInside]
   */


  function visual(visualType, dataIndexInside) {
    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
    return data.getItemVisual(dataIndexInside, visualType);
  }
  /**
   * @public
   * @param {number} opt.count Positive interger.
   * @param {number} [opt.barWidth]
   * @param {number} [opt.barMaxWidth]
   * @param {number} [opt.barMinWidth]
   * @param {number} [opt.barGap]
   * @param {number} [opt.barCategoryGap]
   * @return {Object} {width, offset, offsetCenter} is not support, return undefined.
   */


  function barLayout(opt) {
    if (coordSys.getBaseAxis) {
      var baseAxis = coordSys.getBaseAxis();
      return getLayoutOnAxis(zrUtil.defaults({
        axis: baseAxis
      }, opt), api);
    }
  }
  /**
   * @public
   * @return {Array.<number>}
   */


  function currentSeriesIndices() {
    return ecModel.getCurrentSeriesIndices();
  }
  /**
   * @public
   * @param {Object} opt
   * @param {string} [opt.fontStyle]
   * @param {number} [opt.fontWeight]
   * @param {number} [opt.fontSize]
   * @param {string} [opt.fontFamily]
   * @return {string} font string
   */


  function font(opt) {
    return graphicUtil.getFont(opt, ecModel);
  }
}

function wrapEncodeDef(data) {
  var encodeDef = {};
  zrUtil.each(data.dimensions, function (dimName, dataDimIndex) {
    var dimInfo = data.getDimensionInfo(dimName);

    if (!dimInfo.isExtraCoord) {
      var coordDim = dimInfo.coordDim;
      var dataDims = encodeDef[coordDim] = encodeDef[coordDim] || [];
      dataDims[dimInfo.coordDimIndex] = dataDimIndex;
    }
  });
  return encodeDef;
}

function createOrUpdate(el, dataIndex, elOption, animatableModel, group, data) {
  el = doCreateOrUpdate(el, dataIndex, elOption, animatableModel, group, data, true);
  el && data.setItemGraphicEl(dataIndex, el);
  return el;
}

function doCreateOrUpdate(el, dataIndex, elOption, animatableModel, group, data, isRoot) {
  // [Rule]
  // By default, follow merge mode.
  //     (It probably brings benifit for performance in some cases of large data, where
  //     user program can be optimized to that only updated props needed to be re-calculated,
  //     or according to `actionType` some calculation can be skipped.)
  // If `renderItem` returns `null`/`undefined`/`false`, remove the previous el if existing.
  //     (It seems that violate the "merge" principle, but most of users probably intuitively
  //     regard "return;" as "show nothing element whatever", so make a exception to meet the
  //     most cases.)
  var simplyRemove = !elOption; // `null`/`undefined`/`false`

  elOption = elOption || {};
  var elOptionType = elOption.type;
  var elOptionShape = elOption.shape;
  var elOptionStyle = elOption.style;

  if (el && (simplyRemove // || elOption.$merge === false
  // If `elOptionType` is `null`, follow the merge principle.
  || elOptionType != null && elOptionType !== el.__customGraphicType || elOptionType === 'path' && hasOwnPathData(elOptionShape) && getPathData(elOptionShape) !== el.__customPathData || elOptionType === 'image' && hasOwn(elOptionStyle, 'image') && elOptionStyle.image !== el.__customImagePath // FIXME test and remove this restriction?
  || elOptionType === 'text' && hasOwn(elOptionShape, 'text') && elOptionStyle.text !== el.__customText)) {
    group.remove(el);
    el = null;
  } // `elOption.type` is undefined when `renderItem` returns nothing.


  if (simplyRemove) {
    return;
  }

  var isInit = !el;
  !el && (el = createEl(elOption));
  updateEl(el, dataIndex, elOption, animatableModel, data, isInit, isRoot);

  if (elOptionType === 'group') {
    mergeChildren(el, dataIndex, elOption, animatableModel, data);
  } // Always add whatever already added to ensure sequence.


  group.add(el);
  return el;
} // Usage:
// (1) By default, `elOption.$mergeChildren` is `'byIndex'`, which indicates that
//     the existing children will not be removed, and enables the feature that
//     update some of the props of some of the children simply by construct
//     the returned children of `renderItem` like:
//     `var children = group.children = []; children[3] = {opacity: 0.5};`
// (2) If `elOption.$mergeChildren` is `'byName'`, add/update/remove children
//     by child.name. But that might be lower performance.
// (3) If `elOption.$mergeChildren` is `false`, the existing children will be
//     replaced totally.
// (4) If `!elOption.children`, following the "merge" principle, nothing will happen.
//
// For implementation simpleness, do not provide a direct way to remove sinlge
// child (otherwise the total indicies of the children array have to be modified).
// User can remove a single child by set its `ignore` as `true` or replace
// it by another element, where its `$merge` can be set as `true` if necessary.


function mergeChildren(el, dataIndex, elOption, animatableModel, data) {
  var newChildren = elOption.children;
  var newLen = newChildren ? newChildren.length : 0;
  var mergeChildren = elOption.$mergeChildren; // `diffChildrenByName` has been deprecated.

  var byName = mergeChildren === 'byName' || elOption.diffChildrenByName;
  var notMerge = mergeChildren === false; // For better performance on roam update, only enter if necessary.

  if (!newLen && !byName && !notMerge) {
    return;
  }

  if (byName) {
    diffGroupChildren({
      oldChildren: el.children() || [],
      newChildren: newChildren || [],
      dataIndex: dataIndex,
      animatableModel: animatableModel,
      group: el,
      data: data
    });
    return;
  }

  notMerge && el.removeAll(); // Mapping children of a group simply by index, which
  // might be better performance.

  var index = 0;

  for (; index < newLen; index++) {
    newChildren[index] && doCreateOrUpdate(el.childAt(index), dataIndex, newChildren[index], animatableModel, el, data);
  }
}

function diffGroupChildren(context) {
  new DataDiffer(context.oldChildren, context.newChildren, getKey, getKey, context).add(processAddUpdate).update(processAddUpdate).remove(processRemove).execute();
}

function getKey(item, idx) {
  var name = item && item.name;
  return name != null ? name : GROUP_DIFF_PREFIX + idx;
}

function processAddUpdate(newIndex, oldIndex) {
  var context = this.context;
  var childOption = newIndex != null ? context.newChildren[newIndex] : null;
  var child = oldIndex != null ? context.oldChildren[oldIndex] : null;
  doCreateOrUpdate(child, context.dataIndex, childOption, context.animatableModel, context.group, context.data);
} // `graphic#applyDefaultTextStyle` will cache
// textFill, textStroke, textStrokeWidth.
// We have to do this trick.


function applyExtraBefore(extra, model) {
  var dummyModel = new Model({}, model);
  zrUtil.each(CACHED_LABEL_STYLE_PROPERTIES, function (stylePropName, modelPropName) {
    if (extra.hasOwnProperty(stylePropName)) {
      dummyModel.option[modelPropName] = extra[stylePropName];
    }
  });
  return dummyModel;
}

function applyExtraAfter(itemStyle, extra) {
  for (var key in extra) {
    if (extra.hasOwnProperty(key) || !CACHED_LABEL_STYLE_PROPERTIES.hasOwnProperty(key)) {
      itemStyle[key] = extra[key];
    }
  }
}

function processRemove(oldIndex) {
  var context = this.context;
  var child = context.oldChildren[oldIndex];
  child && context.group.remove(child);
}

function getPathData(shape) {
  // "d" follows the SVG convention.
  return shape && (shape.pathData || shape.d);
}

function hasOwnPathData(shape) {
  return shape && (shape.hasOwnProperty('pathData') || shape.hasOwnProperty('d'));
}

function hasOwn(host, prop) {
  return host && host.hasOwnProperty(prop);
}

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function dataToCoordSize(dataSize, dataItem) {
  // dataItem is necessary in log axis.
  dataItem = dataItem || [0, 0];
  return zrUtil.map(['x', 'y'], function (dim, dimIdx) {
    var axis = this.getAxis(dim);
    var val = dataItem[dimIdx];
    var halfSize = dataSize[dimIdx] / 2;
    return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
  }, this);
}

function _default(coordSys) {
  var rect = coordSys.grid.getRect();
  return {
    coordSys: {
      // The name exposed to user is always 'cartesian2d' but not 'grid'.
      type: 'cartesian2d',
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    },
    api: {
      coord: function (data) {
        // do not provide "out" param
        return coordSys.dataToPoint(data);
      },
      size: zrUtil.bind(dataToCoordSize, coordSys)
    }
  };
}

module.exports = _default;

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function dataToCoordSize(dataSize, dataItem) {
  dataItem = dataItem || [0, 0];
  return zrUtil.map([0, 1], function (dimIdx) {
    var val = dataItem[dimIdx];
    var halfSize = dataSize[dimIdx] / 2;
    var p1 = [];
    var p2 = [];
    p1[dimIdx] = val - halfSize;
    p2[dimIdx] = val + halfSize;
    p1[1 - dimIdx] = p2[1 - dimIdx] = dataItem[1 - dimIdx];
    return Math.abs(this.dataToPoint(p1)[dimIdx] - this.dataToPoint(p2)[dimIdx]);
  }, this);
}

function _default(coordSys) {
  var rect = coordSys.getBoundingRect();
  return {
    coordSys: {
      type: 'geo',
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height,
      zoom: coordSys.getZoom()
    },
    api: {
      coord: function (data) {
        // do not provide "out" and noRoam param,
        // Compatible with this usage:
        // echarts.util.map(item.points, api.coord)
        return coordSys.dataToPoint(data);
      },
      size: zrUtil.bind(dataToCoordSize, coordSys)
    }
  };
}

module.exports = _default;

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function dataToCoordSize(dataSize, dataItem) {
  // dataItem is necessary in log axis.
  var axis = this.getAxis();
  var val = dataItem instanceof Array ? dataItem[0] : dataItem;
  var halfSize = (dataSize instanceof Array ? dataSize[0] : dataSize) / 2;
  return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
}

function _default(coordSys) {
  var rect = coordSys.getRect();
  return {
    coordSys: {
      type: 'singleAxis',
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    },
    api: {
      coord: function (val) {
        // do not provide "out" param
        return coordSys.dataToPoint(val);
      },
      size: zrUtil.bind(dataToCoordSize, coordSys)
    }
  };
}

module.exports = _default;

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function dataToCoordSize(dataSize, dataItem) {
  // dataItem is necessary in log axis.
  return zrUtil.map(['Radius', 'Angle'], function (dim, dimIdx) {
    var axis = this['get' + dim + 'Axis']();
    var val = dataItem[dimIdx];
    var halfSize = dataSize[dimIdx] / 2;
    var method = 'dataTo' + dim;
    var result = axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis[method](val - halfSize) - axis[method](val + halfSize));

    if (dim === 'Angle') {
      result = result * Math.PI / 180;
    }

    return result;
  }, this);
}

function _default(coordSys) {
  var radiusAxis = coordSys.getRadiusAxis();
  var angleAxis = coordSys.getAngleAxis();
  var radius = radiusAxis.getExtent();
  radius[0] > radius[1] && radius.reverse();
  return {
    coordSys: {
      type: 'polar',
      cx: coordSys.cx,
      cy: coordSys.cy,
      r: radius[1],
      r0: radius[0]
    },
    api: {
      coord: zrUtil.bind(function (data) {
        var radius = radiusAxis.dataToRadius(data[0]);
        var angle = angleAxis.dataToAngle(data[1]);
        var coord = coordSys.coordToPoint([radius, angle]);
        coord.push(radius, angle * Math.PI / 180);
        return coord;
      }),
      size: zrUtil.bind(dataToCoordSize, coordSys)
    }
  };
}

module.exports = _default;

/***/ }),
/* 1729 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(coordSys) {
  var rect = coordSys.getRect();
  var rangeInfo = coordSys.getRangeInfo();
  return {
    coordSys: {
      type: 'calendar',
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height,
      cellWidth: coordSys.getCellWidth(),
      cellHeight: coordSys.getCellHeight(),
      rangeInfo: {
        start: rangeInfo.start,
        end: rangeInfo.end,
        weeks: rangeInfo.weeks,
        dayCount: rangeInfo.allDay
      }
    },
    api: {
      coord: function (data, clamp) {
        return coordSys.dataToPoint(data, clamp);
      }
    }
  };
}

module.exports = _default;

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

__webpack_require__(242);

__webpack_require__(677);

__webpack_require__(246);

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var barPolar = __webpack_require__(1732);

__webpack_require__(427);

__webpack_require__(1738);

__webpack_require__(1740);

__webpack_require__(246);

__webpack_require__(1742);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// For reducing size of echarts.min, barLayoutPolar is required by polar.
echarts.registerLayout(zrUtil.curry(barPolar, 'bar')); // Polar view

echarts.extendComponentView({
  type: 'polar'
});

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var _number = __webpack_require__(37);

var parsePercent = _number.parsePercent;

var _dataStackHelper = __webpack_require__(124);

var isDimensionStacked = _dataStackHelper.isDimensionStacked;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function getSeriesStackId(seriesModel) {
  return seriesModel.get('stack') || '__ec_stack_' + seriesModel.seriesIndex;
}

function getAxisKey(polar, axis) {
  return axis.dim + polar.model.componentIndex;
}
/**
 * @param {string} seriesType
 * @param {module:echarts/model/Global} ecModel
 * @param {module:echarts/ExtensionAPI} api
 */


function barLayoutPolar(seriesType, ecModel, api) {
  var lastStackCoords = {};
  var barWidthAndOffset = calRadialBar(zrUtil.filter(ecModel.getSeriesByType(seriesType), function (seriesModel) {
    return !ecModel.isSeriesFiltered(seriesModel) && seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'polar';
  }));
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    // Check series coordinate, do layout for polar only
    if (seriesModel.coordinateSystem.type !== 'polar') {
      return;
    }

    var data = seriesModel.getData();
    var polar = seriesModel.coordinateSystem;
    var baseAxis = polar.getBaseAxis();
    var axisKey = getAxisKey(polar, baseAxis);
    var stackId = getSeriesStackId(seriesModel);
    var columnLayoutInfo = barWidthAndOffset[axisKey][stackId];
    var columnOffset = columnLayoutInfo.offset;
    var columnWidth = columnLayoutInfo.width;
    var valueAxis = polar.getOtherAxis(baseAxis);
    var cx = seriesModel.coordinateSystem.cx;
    var cy = seriesModel.coordinateSystem.cy;
    var barMinHeight = seriesModel.get('barMinHeight') || 0;
    var barMinAngle = seriesModel.get('barMinAngle') || 0;
    lastStackCoords[stackId] = lastStackCoords[stackId] || [];
    var valueDim = data.mapDimension(valueAxis.dim);
    var baseDim = data.mapDimension(baseAxis.dim);
    var stacked = isDimensionStacked(data, valueDim
    /*, baseDim*/
    );
    var clampLayout = baseAxis.dim !== 'radius' || !seriesModel.get('roundCap', true);
    var valueAxisStart = valueAxis.dim === 'radius' ? valueAxis.dataToRadius(0) : valueAxis.dataToAngle(0);

    for (var idx = 0, len = data.count(); idx < len; idx++) {
      var value = data.get(valueDim, idx);
      var baseValue = data.get(baseDim, idx);
      var sign = value >= 0 ? 'p' : 'n';
      var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
      // stackResultDimension directly.
      // Only ordinal axis can be stacked.

      if (stacked) {
        if (!lastStackCoords[stackId][baseValue]) {
          lastStackCoords[stackId][baseValue] = {
            p: valueAxisStart,
            // Positive stack
            n: valueAxisStart // Negative stack

          };
        } // Should also consider #4243


        baseCoord = lastStackCoords[stackId][baseValue][sign];
      }

      var r0;
      var r;
      var startAngle;
      var endAngle; // radial sector

      if (valueAxis.dim === 'radius') {
        var radiusSpan = valueAxis.dataToRadius(value) - valueAxisStart;
        var angle = baseAxis.dataToAngle(baseValue);

        if (Math.abs(radiusSpan) < barMinHeight) {
          radiusSpan = (radiusSpan < 0 ? -1 : 1) * barMinHeight;
        }

        r0 = baseCoord;
        r = baseCoord + radiusSpan;
        startAngle = angle - columnOffset;
        endAngle = startAngle - columnWidth;
        stacked && (lastStackCoords[stackId][baseValue][sign] = r);
      } // tangential sector
      else {
          var angleSpan = valueAxis.dataToAngle(value, clampLayout) - valueAxisStart;
          var radius = baseAxis.dataToRadius(baseValue);

          if (Math.abs(angleSpan) < barMinAngle) {
            angleSpan = (angleSpan < 0 ? -1 : 1) * barMinAngle;
          }

          r0 = radius + columnOffset;
          r = r0 + columnWidth;
          startAngle = baseCoord;
          endAngle = baseCoord + angleSpan; // if the previous stack is at the end of the ring,
          // add a round to differentiate it from origin
          // var extent = angleAxis.getExtent();
          // var stackCoord = angle;
          // if (stackCoord === extent[0] && value > 0) {
          //     stackCoord = extent[1];
          // }
          // else if (stackCoord === extent[1] && value < 0) {
          //     stackCoord = extent[0];
          // }

          stacked && (lastStackCoords[stackId][baseValue][sign] = endAngle);
        }

      data.setItemLayout(idx, {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r,
        // Consider that positive angle is anti-clockwise,
        // while positive radian of sector is clockwise
        startAngle: -startAngle * Math.PI / 180,
        endAngle: -endAngle * Math.PI / 180
      });
    }
  }, this);
}
/**
 * Calculate bar width and offset for radial bar charts
 */


function calRadialBar(barSeries, api) {
  // Columns info on each category axis. Key is polar name
  var columnsMap = {};
  zrUtil.each(barSeries, function (seriesModel, idx) {
    var data = seriesModel.getData();
    var polar = seriesModel.coordinateSystem;
    var baseAxis = polar.getBaseAxis();
    var axisKey = getAxisKey(polar, baseAxis);
    var axisExtent = baseAxis.getExtent();
    var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
    var columnsOnAxis = columnsMap[axisKey] || {
      bandWidth: bandWidth,
      remainedWidth: bandWidth,
      autoWidthCount: 0,
      categoryGap: '20%',
      gap: '30%',
      stacks: {}
    };
    var stacks = columnsOnAxis.stacks;
    columnsMap[axisKey] = columnsOnAxis;
    var stackId = getSeriesStackId(seriesModel);

    if (!stacks[stackId]) {
      columnsOnAxis.autoWidthCount++;
    }

    stacks[stackId] = stacks[stackId] || {
      width: 0,
      maxWidth: 0
    };
    var barWidth = parsePercent(seriesModel.get('barWidth'), bandWidth);
    var barMaxWidth = parsePercent(seriesModel.get('barMaxWidth'), bandWidth);
    var barGap = seriesModel.get('barGap');
    var barCategoryGap = seriesModel.get('barCategoryGap');

    if (barWidth && !stacks[stackId].width) {
      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
      stacks[stackId].width = barWidth;
      columnsOnAxis.remainedWidth -= barWidth;
    }

    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
    barGap != null && (columnsOnAxis.gap = barGap);
    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
  });
  var result = {};
  zrUtil.each(columnsMap, function (columnsOnAxis, coordSysName) {
    result[coordSysName] = {};
    var stacks = columnsOnAxis.stacks;
    var bandWidth = columnsOnAxis.bandWidth;
    var categoryGap = parsePercent(columnsOnAxis.categoryGap, bandWidth);
    var barGapPercent = parsePercent(columnsOnAxis.gap, 1);
    var remainedWidth = columnsOnAxis.remainedWidth;
    var autoWidthCount = columnsOnAxis.autoWidthCount;
    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth

    zrUtil.each(stacks, function (column, stack) {
      var maxWidth = column.maxWidth;

      if (maxWidth && maxWidth < autoWidth) {
        maxWidth = Math.min(maxWidth, remainedWidth);

        if (column.width) {
          maxWidth = Math.min(maxWidth, column.width);
        }

        remainedWidth -= maxWidth;
        column.width = maxWidth;
        autoWidthCount--;
      }
    }); // Recalculate width again

    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = Math.max(autoWidth, 0);
    var widthSum = 0;
    var lastColumn;
    zrUtil.each(stacks, function (column, idx) {
      if (!column.width) {
        column.width = autoWidth;
      }

      lastColumn = column;
      widthSum += column.width * (1 + barGapPercent);
    });

    if (lastColumn) {
      widthSum -= lastColumn.width * barGapPercent;
    }

    var offset = -widthSum / 2;
    zrUtil.each(stacks, function (column, stackId) {
      result[coordSysName][stackId] = result[coordSysName][stackId] || {
        offset: offset,
        width: column.width
      };
      offset += column.width * (1 + barGapPercent);
    });
  });
  return result;
}

var _default = barLayoutPolar;
module.exports = _default;

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var RadiusAxis = __webpack_require__(1734);

var AngleAxis = __webpack_require__(1735);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @module echarts/coord/polar/Polar
 */

/**
 * @alias {module:echarts/coord/polar/Polar}
 * @constructor
 * @param {string} name
 */
var Polar = function (name) {
  /**
   * @type {string}
   */
  this.name = name || '';
  /**
   * x of polar center
   * @type {number}
   */

  this.cx = 0;
  /**
   * y of polar center
   * @type {number}
   */

  this.cy = 0;
  /**
   * @type {module:echarts/coord/polar/RadiusAxis}
   * @private
   */

  this._radiusAxis = new RadiusAxis();
  /**
   * @type {module:echarts/coord/polar/AngleAxis}
   * @private
   */

  this._angleAxis = new AngleAxis();
  this._radiusAxis.polar = this._angleAxis.polar = this;
};

Polar.prototype = {
  type: 'polar',
  axisPointerEnabled: true,
  constructor: Polar,

  /**
   * @param {Array.<string>}
   * @readOnly
   */
  dimensions: ['radius', 'angle'],

  /**
   * @type {module:echarts/coord/PolarModel}
   */
  model: null,

  /**
   * If contain coord
   * @param {Array.<number>} point
   * @return {boolean}
   */
  containPoint: function (point) {
    var coord = this.pointToCoord(point);
    return this._radiusAxis.contain(coord[0]) && this._angleAxis.contain(coord[1]);
  },

  /**
   * If contain data
   * @param {Array.<number>} data
   * @return {boolean}
   */
  containData: function (data) {
    return this._radiusAxis.containData(data[0]) && this._angleAxis.containData(data[1]);
  },

  /**
   * @param {string} dim
   * @return {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
   */
  getAxis: function (dim) {
    return this['_' + dim + 'Axis'];
  },

  /**
   * @return {Array.<module:echarts/coord/Axis>}
   */
  getAxes: function () {
    return [this._radiusAxis, this._angleAxis];
  },

  /**
   * Get axes by type of scale
   * @param {string} scaleType
   * @return {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
   */
  getAxesByScale: function (scaleType) {
    var axes = [];
    var angleAxis = this._angleAxis;
    var radiusAxis = this._radiusAxis;
    angleAxis.scale.type === scaleType && axes.push(angleAxis);
    radiusAxis.scale.type === scaleType && axes.push(radiusAxis);
    return axes;
  },

  /**
   * @return {module:echarts/coord/polar/AngleAxis}
   */
  getAngleAxis: function () {
    return this._angleAxis;
  },

  /**
   * @return {module:echarts/coord/polar/RadiusAxis}
   */
  getRadiusAxis: function () {
    return this._radiusAxis;
  },

  /**
   * @param {module:echarts/coord/polar/Axis}
   * @return {module:echarts/coord/polar/Axis}
   */
  getOtherAxis: function (axis) {
    var angleAxis = this._angleAxis;
    return axis === angleAxis ? this._radiusAxis : angleAxis;
  },

  /**
   * Base axis will be used on stacking.
   *
   * @return {module:echarts/coord/polar/Axis}
   */
  getBaseAxis: function () {
    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAngleAxis();
  },

  /**
   * @param {string} [dim] 'radius' or 'angle' or 'auto' or null/undefined
   * @return {Object} {baseAxes: [], otherAxes: []}
   */
  getTooltipAxes: function (dim) {
    var baseAxis = dim != null && dim !== 'auto' ? this.getAxis(dim) : this.getBaseAxis();
    return {
      baseAxes: [baseAxis],
      otherAxes: [this.getOtherAxis(baseAxis)]
    };
  },

  /**
   * Convert a single data item to (x, y) point.
   * Parameter data is an array which the first element is radius and the second is angle
   * @param {Array.<number>} data
   * @param {boolean} [clamp=false]
   * @return {Array.<number>}
   */
  dataToPoint: function (data, clamp) {
    return this.coordToPoint([this._radiusAxis.dataToRadius(data[0], clamp), this._angleAxis.dataToAngle(data[1], clamp)]);
  },

  /**
   * Convert a (x, y) point to data
   * @param {Array.<number>} point
   * @param {boolean} [clamp=false]
   * @return {Array.<number>}
   */
  pointToData: function (point, clamp) {
    var coord = this.pointToCoord(point);
    return [this._radiusAxis.radiusToData(coord[0], clamp), this._angleAxis.angleToData(coord[1], clamp)];
  },

  /**
   * Convert a (x, y) point to (radius, angle) coord
   * @param {Array.<number>} point
   * @return {Array.<number>}
   */
  pointToCoord: function (point) {
    var dx = point[0] - this.cx;
    var dy = point[1] - this.cy;
    var angleAxis = this.getAngleAxis();
    var extent = angleAxis.getExtent();
    var minAngle = Math.min(extent[0], extent[1]);
    var maxAngle = Math.max(extent[0], extent[1]); // Fix fixed extent in polarCreator
    // FIXME

    angleAxis.inverse ? minAngle = maxAngle - 360 : maxAngle = minAngle + 360;
    var radius = Math.sqrt(dx * dx + dy * dy);
    dx /= radius;
    dy /= radius;
    var radian = Math.atan2(-dy, dx) / Math.PI * 180; // move to angleExtent

    var dir = radian < minAngle ? 1 : -1;

    while (radian < minAngle || radian > maxAngle) {
      radian += dir * 360;
    }

    return [radius, radian];
  },

  /**
   * Convert a (radius, angle) coord to (x, y) point
   * @param {Array.<number>} coord
   * @return {Array.<number>}
   */
  coordToPoint: function (coord) {
    var radius = coord[0];
    var radian = coord[1] / 180 * Math.PI;
    var x = Math.cos(radian) * radius + this.cx; // Inverse the y

    var y = -Math.sin(radian) * radius + this.cy;
    return [x, y];
  },

  /**
   * Get ring area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   * @return {Ring}
   */
  getArea: function () {
    var angleAxis = this.getAngleAxis();
    var radiusAxis = this.getRadiusAxis();
    var radiusExtent = radiusAxis.getExtent().slice();
    radiusExtent[0] > radiusExtent[1] && radiusExtent.reverse();
    var angleExtent = angleAxis.getExtent();
    var RADIAN = Math.PI / 180;
    return {
      cx: this.cx,
      cy: this.cy,
      r0: radiusExtent[0],
      r: radiusExtent[1],
      startAngle: -angleExtent[0] * RADIAN,
      endAngle: -angleExtent[1] * RADIAN,
      clockwise: angleAxis.inverse,
      contain: function (x, y) {
        // It's a ring shape.
        // Start angle and end angle don't matter
        var dx = x - this.cx;
        var dy = y - this.cy;
        var d2 = dx * dx + dy * dy;
        var r = this.r;
        var r0 = this.r0;
        return d2 <= r * r && d2 >= r0 * r0;
      }
    };
  }
};
var _default = Polar;
module.exports = _default;

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var Axis = __webpack_require__(150);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function RadiusAxis(scale, radiusExtent) {
  Axis.call(this, 'radius', scale, radiusExtent);
  /**
   * Axis type
   *  - 'category'
   *  - 'value'
   *  - 'time'
   *  - 'log'
   * @type {string}
   */

  this.type = 'category';
}

RadiusAxis.prototype = {
  constructor: RadiusAxis,

  /**
   * @override
   */
  pointToData: function (point, clamp) {
    return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
  },
  dataToRadius: Axis.prototype.dataToCoord,
  radiusToData: Axis.prototype.coordToData
};
zrUtil.inherits(RadiusAxis, Axis);
var _default = RadiusAxis;
module.exports = _default;

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var textContain = __webpack_require__(93);

var Axis = __webpack_require__(150);

var _model = __webpack_require__(44);

var makeInner = _model.makeInner;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var inner = makeInner();

function AngleAxis(scale, angleExtent) {
  angleExtent = angleExtent || [0, 360];
  Axis.call(this, 'angle', scale, angleExtent);
  /**
   * Axis type
   *  - 'category'
   *  - 'value'
   *  - 'time'
   *  - 'log'
   * @type {string}
   */

  this.type = 'category';
}

AngleAxis.prototype = {
  constructor: AngleAxis,

  /**
   * @override
   */
  pointToData: function (point, clamp) {
    return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
  },
  dataToAngle: Axis.prototype.dataToCoord,
  angleToData: Axis.prototype.coordToData,

  /**
   * Only be called in category axis.
   * Angle axis uses text height to decide interval
   *
   * @override
   * @return {number} Auto interval for cateogry axis tick and label
   */
  calculateCategoryInterval: function () {
    var axis = this;
    var labelModel = axis.getLabelModel();
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
    // avoid generating a long array by `getTicks`
    // in large category data case.

    var tickCount = ordinalScale.count();

    if (ordinalExtent[1] - ordinalExtent[0] < 1) {
      return 0;
    }

    var tickValue = ordinalExtent[0];
    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
    var unitH = Math.abs(unitSpan); // Not precise, just use height as text width
    // and each distance from axis line yet.

    var rect = textContain.getBoundingRect(tickValue, labelModel.getFont(), 'center', 'top');
    var maxH = Math.max(rect.height, 7);
    var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.

    isNaN(dh) && (dh = Infinity);
    var interval = Math.max(0, Math.floor(dh));
    var cache = inner(axis.model);
    var lastAutoInterval = cache.lastAutoInterval;
    var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
    // otherwise the calculated interval might jitter when the zoom
    // window size is close to the interval-changing size.

    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
    // point is not the same when zooming in or zooming out.
    && lastAutoInterval > interval) {
      interval = lastAutoInterval;
    } // Only update cache if cache not used, otherwise the
    // changing of interval is too insensitive.
    else {
        cache.lastTickCount = tickCount;
        cache.lastAutoInterval = interval;
      }

    return interval;
  }
};
zrUtil.inherits(AngleAxis, Axis);
var _default = AngleAxis;
module.exports = _default;

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(1737);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = echarts.extendComponentModel({
  type: 'polar',
  dependencies: ['polarAxis', 'angleAxis'],

  /**
   * @type {module:echarts/coord/polar/Polar}
   */
  coordinateSystem: null,

  /**
   * @param {string} axisType
   * @return {module:echarts/coord/polar/AxisModel}
   */
  findAxisModel: function (axisType) {
    var foundAxisModel;
    var ecModel = this.ecModel;
    ecModel.eachComponent(axisType, function (axisModel) {
      if (axisModel.getCoordSysModel() === this) {
        foundAxisModel = axisModel;
      }
    }, this);
    return foundAxisModel;
  },
  defaultOption: {
    zlevel: 0,
    z: 0,
    center: ['50%', '50%'],
    radius: '80%'
  }
});

module.exports = _default;

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var ComponentModel = __webpack_require__(73);

var axisModelCreator = __webpack_require__(302);

var axisModelCommonMixin = __webpack_require__(208);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var PolarAxisModel = ComponentModel.extend({
  type: 'polarAxis',

  /**
   * @type {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
   */
  axis: null,

  /**
   * @override
   */
  getCoordSysModel: function () {
    return this.ecModel.queryComponents({
      mainType: 'polar',
      index: this.option.polarIndex,
      id: this.option.polarId
    })[0];
  }
});
zrUtil.merge(PolarAxisModel.prototype, axisModelCommonMixin);
var polarAxisDefaultExtendedOption = {
  angle: {
    // polarIndex: 0,
    // polarId: '',
    startAngle: 90,
    clockwise: true,
    splitNumber: 12,
    axisLabel: {
      rotate: false
    }
  },
  radius: {
    // polarIndex: 0,
    // polarId: '',
    splitNumber: 5
  }
};

function getAxisType(axisDim, option) {
  // Default axis with data is category axis
  return option.type || (option.data ? 'category' : 'value');
}

axisModelCreator('angle', PolarAxisModel, getAxisType, polarAxisDefaultExtendedOption.angle);
axisModelCreator('radius', PolarAxisModel, getAxisType, polarAxisDefaultExtendedOption.radius);

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

__webpack_require__(427);

__webpack_require__(1739);

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var graphic = __webpack_require__(27);

var Model = __webpack_require__(68);

var AxisView = __webpack_require__(179);

var AxisBuilder = __webpack_require__(151);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var elementList = ['axisLine', 'axisLabel', 'axisTick', 'minorTick', 'splitLine', 'minorSplitLine', 'splitArea'];

function getAxisLineShape(polar, rExtent, angle) {
  rExtent[1] > rExtent[0] && (rExtent = rExtent.slice().reverse());
  var start = polar.coordToPoint([rExtent[0], angle]);
  var end = polar.coordToPoint([rExtent[1], angle]);
  return {
    x1: start[0],
    y1: start[1],
    x2: end[0],
    y2: end[1]
  };
}

function getRadiusIdx(polar) {
  var radiusAxis = polar.getRadiusAxis();
  return radiusAxis.inverse ? 0 : 1;
} // Remove the last tick which will overlap the first tick


function fixAngleOverlap(list) {
  var firstItem = list[0];
  var lastItem = list[list.length - 1];

  if (firstItem && lastItem && Math.abs(Math.abs(firstItem.coord - lastItem.coord) - 360) < 1e-4) {
    list.pop();
  }
}

var _default = AxisView.extend({
  type: 'angleAxis',
  axisPointerClass: 'PolarAxisPointer',
  render: function (angleAxisModel, ecModel) {
    this.group.removeAll();

    if (!angleAxisModel.get('show')) {
      return;
    }

    var angleAxis = angleAxisModel.axis;
    var polar = angleAxis.polar;
    var radiusExtent = polar.getRadiusAxis().getExtent();
    var ticksAngles = angleAxis.getTicksCoords();
    var minorTickAngles = angleAxis.getMinorTicksCoords();
    var labels = zrUtil.map(angleAxis.getViewLabels(), function (labelItem) {
      var labelItem = zrUtil.clone(labelItem);
      labelItem.coord = angleAxis.dataToCoord(labelItem.tickValue);
      return labelItem;
    });
    fixAngleOverlap(labels);
    fixAngleOverlap(ticksAngles);
    zrUtil.each(elementList, function (name) {
      if (angleAxisModel.get(name + '.show') && (!angleAxis.scale.isBlank() || name === 'axisLine')) {
        this['_' + name](angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels);
      }
    }, this);
  },

  /**
   * @private
   */
  _axisLine: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
    var lineStyleModel = angleAxisModel.getModel('axisLine.lineStyle'); // extent id of the axis radius (r0 and r)

    var rId = getRadiusIdx(polar);
    var r0Id = rId ? 0 : 1;
    var shape;

    if (radiusExtent[r0Id] === 0) {
      shape = new graphic.Circle({
        shape: {
          cx: polar.cx,
          cy: polar.cy,
          r: radiusExtent[rId]
        },
        style: lineStyleModel.getLineStyle(),
        z2: 1,
        silent: true
      });
    } else {
      shape = new graphic.Ring({
        shape: {
          cx: polar.cx,
          cy: polar.cy,
          r: radiusExtent[rId],
          r0: radiusExtent[r0Id]
        },
        style: lineStyleModel.getLineStyle(),
        z2: 1,
        silent: true
      });
    }

    shape.style.fill = null;
    this.group.add(shape);
  },

  /**
   * @private
   */
  _axisTick: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
    var tickModel = angleAxisModel.getModel('axisTick');
    var tickLen = (tickModel.get('inside') ? -1 : 1) * tickModel.get('length');
    var radius = radiusExtent[getRadiusIdx(polar)];
    var lines = zrUtil.map(ticksAngles, function (tickAngleItem) {
      return new graphic.Line({
        shape: getAxisLineShape(polar, [radius, radius + tickLen], tickAngleItem.coord)
      });
    });
    this.group.add(graphic.mergePath(lines, {
      style: zrUtil.defaults(tickModel.getModel('lineStyle').getLineStyle(), {
        stroke: angleAxisModel.get('axisLine.lineStyle.color')
      })
    }));
  },

  /**
   * @private
   */
  _minorTick: function (angleAxisModel, polar, tickAngles, minorTickAngles, radiusExtent) {
    if (!minorTickAngles.length) {
      return;
    }

    var tickModel = angleAxisModel.getModel('axisTick');
    var minorTickModel = angleAxisModel.getModel('minorTick');
    var tickLen = (tickModel.get('inside') ? -1 : 1) * minorTickModel.get('length');
    var radius = radiusExtent[getRadiusIdx(polar)];
    var lines = [];

    for (var i = 0; i < minorTickAngles.length; i++) {
      for (var k = 0; k < minorTickAngles[i].length; k++) {
        lines.push(new graphic.Line({
          shape: getAxisLineShape(polar, [radius, radius + tickLen], minorTickAngles[i][k].coord)
        }));
      }
    }

    this.group.add(graphic.mergePath(lines, {
      style: zrUtil.defaults(minorTickModel.getModel('lineStyle').getLineStyle(), zrUtil.defaults(tickModel.getLineStyle(), {
        stroke: angleAxisModel.get('axisLine.lineStyle.color')
      }))
    }));
  },

  /**
   * @private
   */
  _axisLabel: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels) {
    var rawCategoryData = angleAxisModel.getCategories(true);
    var commonLabelModel = angleAxisModel.getModel('axisLabel');
    var labelMargin = commonLabelModel.get('margin');
    var triggerEvent = angleAxisModel.get('triggerEvent'); // Use length of ticksAngles because it may remove the last tick to avoid overlapping

    zrUtil.each(labels, function (labelItem, idx) {
      var labelModel = commonLabelModel;
      var tickValue = labelItem.tickValue;
      var r = radiusExtent[getRadiusIdx(polar)];
      var p = polar.coordToPoint([r + labelMargin, labelItem.coord]);
      var cx = polar.cx;
      var cy = polar.cy;
      var labelTextAlign = Math.abs(p[0] - cx) / r < 0.3 ? 'center' : p[0] > cx ? 'left' : 'right';
      var labelTextVerticalAlign = Math.abs(p[1] - cy) / r < 0.3 ? 'middle' : p[1] > cy ? 'top' : 'bottom';

      if (rawCategoryData && rawCategoryData[tickValue] && rawCategoryData[tickValue].textStyle) {
        labelModel = new Model(rawCategoryData[tickValue].textStyle, commonLabelModel, commonLabelModel.ecModel);
      }

      var textEl = new graphic.Text({
        silent: AxisBuilder.isLabelSilent(angleAxisModel)
      });
      this.group.add(textEl);
      graphic.setTextStyle(textEl.style, labelModel, {
        x: p[0],
        y: p[1],
        textFill: labelModel.getTextColor() || angleAxisModel.get('axisLine.lineStyle.color'),
        text: labelItem.formattedLabel,
        textAlign: labelTextAlign,
        textVerticalAlign: labelTextVerticalAlign
      }); // Pack data for mouse event

      if (triggerEvent) {
        textEl.eventData = AxisBuilder.makeAxisEventDataBase(angleAxisModel);
        textEl.eventData.targetType = 'axisLabel';
        textEl.eventData.value = labelItem.rawLabel;
      }
    }, this);
  },

  /**
   * @private
   */
  _splitLine: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
    var splitLineModel = angleAxisModel.getModel('splitLine');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var lineColors = lineStyleModel.get('color');
    var lineCount = 0;
    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
    var splitLines = [];

    for (var i = 0; i < ticksAngles.length; i++) {
      var colorIndex = lineCount++ % lineColors.length;
      splitLines[colorIndex] = splitLines[colorIndex] || [];
      splitLines[colorIndex].push(new graphic.Line({
        shape: getAxisLineShape(polar, radiusExtent, ticksAngles[i].coord)
      }));
    } // Simple optimization
    // Batching the lines if color are the same


    for (var i = 0; i < splitLines.length; i++) {
      this.group.add(graphic.mergePath(splitLines[i], {
        style: zrUtil.defaults({
          stroke: lineColors[i % lineColors.length]
        }, lineStyleModel.getLineStyle()),
        silent: true,
        z: angleAxisModel.get('z')
      }));
    }
  },

  /**
   * @private
   */
  _minorSplitLine: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
    if (!minorTickAngles.length) {
      return;
    }

    var minorSplitLineModel = angleAxisModel.getModel('minorSplitLine');
    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
    var lines = [];

    for (var i = 0; i < minorTickAngles.length; i++) {
      for (var k = 0; k < minorTickAngles[i].length; k++) {
        lines.push(new graphic.Line({
          shape: getAxisLineShape(polar, radiusExtent, minorTickAngles[i][k].coord)
        }));
      }
    }

    this.group.add(graphic.mergePath(lines, {
      style: lineStyleModel.getLineStyle(),
      silent: true,
      z: angleAxisModel.get('z')
    }));
  },

  /**
   * @private
   */
  _splitArea: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
    if (!ticksAngles.length) {
      return;
    }

    var splitAreaModel = angleAxisModel.getModel('splitArea');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var areaColors = areaStyleModel.get('color');
    var lineCount = 0;
    areaColors = areaColors instanceof Array ? areaColors : [areaColors];
    var splitAreas = [];
    var RADIAN = Math.PI / 180;
    var prevAngle = -ticksAngles[0].coord * RADIAN;
    var r0 = Math.min(radiusExtent[0], radiusExtent[1]);
    var r1 = Math.max(radiusExtent[0], radiusExtent[1]);
    var clockwise = angleAxisModel.get('clockwise');

    for (var i = 1; i < ticksAngles.length; i++) {
      var colorIndex = lineCount++ % areaColors.length;
      splitAreas[colorIndex] = splitAreas[colorIndex] || [];
      splitAreas[colorIndex].push(new graphic.Sector({
        shape: {
          cx: polar.cx,
          cy: polar.cy,
          r0: r0,
          r: r1,
          startAngle: prevAngle,
          endAngle: -ticksAngles[i].coord * RADIAN,
          clockwise: clockwise
        },
        silent: true
      }));
      prevAngle = -ticksAngles[i].coord * RADIAN;
    } // Simple optimization
    // Batching the lines if color are the same


    for (var i = 0; i < splitAreas.length; i++) {
      this.group.add(graphic.mergePath(splitAreas[i], {
        style: zrUtil.defaults({
          fill: areaColors[i % areaColors.length]
        }, areaStyleModel.getAreaStyle()),
        silent: true
      }));
    }
  }
});

module.exports = _default;

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

__webpack_require__(427);

__webpack_require__(1741);

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var graphic = __webpack_require__(27);

var AxisBuilder = __webpack_require__(151);

var AxisView = __webpack_require__(179);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
var selfBuilderAttrs = ['splitLine', 'splitArea', 'minorSplitLine'];

var _default = AxisView.extend({
  type: 'radiusAxis',
  axisPointerClass: 'PolarAxisPointer',
  render: function (radiusAxisModel, ecModel) {
    this.group.removeAll();

    if (!radiusAxisModel.get('show')) {
      return;
    }

    var radiusAxis = radiusAxisModel.axis;
    var polar = radiusAxis.polar;
    var angleAxis = polar.getAngleAxis();
    var ticksCoords = radiusAxis.getTicksCoords();
    var minorTicksCoords = radiusAxis.getMinorTicksCoords();
    var axisAngle = angleAxis.getExtent()[0];
    var radiusExtent = radiusAxis.getExtent();
    var layout = layoutAxis(polar, radiusAxisModel, axisAngle);
    var axisBuilder = new AxisBuilder(radiusAxisModel, layout);
    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
    this.group.add(axisBuilder.getGroup());
    zrUtil.each(selfBuilderAttrs, function (name) {
      if (radiusAxisModel.get(name + '.show') && !radiusAxis.scale.isBlank()) {
        this['_' + name](radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords);
      }
    }, this);
  },

  /**
   * @private
   */
  _splitLine: function (radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
    var splitLineModel = radiusAxisModel.getModel('splitLine');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var lineColors = lineStyleModel.get('color');
    var lineCount = 0;
    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
    var splitLines = [];

    for (var i = 0; i < ticksCoords.length; i++) {
      var colorIndex = lineCount++ % lineColors.length;
      splitLines[colorIndex] = splitLines[colorIndex] || [];
      splitLines[colorIndex].push(new graphic.Circle({
        shape: {
          cx: polar.cx,
          cy: polar.cy,
          r: ticksCoords[i].coord
        }
      }));
    } // Simple optimization
    // Batching the lines if color are the same


    for (var i = 0; i < splitLines.length; i++) {
      this.group.add(graphic.mergePath(splitLines[i], {
        style: zrUtil.defaults({
          stroke: lineColors[i % lineColors.length],
          fill: null
        }, lineStyleModel.getLineStyle()),
        silent: true
      }));
    }
  },

  /**
   * @private
   */
  _minorSplitLine: function (radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords) {
    if (!minorTicksCoords.length) {
      return;
    }

    var minorSplitLineModel = radiusAxisModel.getModel('minorSplitLine');
    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
    var lines = [];

    for (var i = 0; i < minorTicksCoords.length; i++) {
      for (var k = 0; k < minorTicksCoords[i].length; k++) {
        lines.push(new graphic.Circle({
          shape: {
            cx: polar.cx,
            cy: polar.cy,
            r: minorTicksCoords[i][k].coord
          }
        }));
      }
    }

    this.group.add(graphic.mergePath(lines, {
      style: zrUtil.defaults({
        fill: null
      }, lineStyleModel.getLineStyle()),
      silent: true
    }));
  },

  /**
   * @private
   */
  _splitArea: function (radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
    if (!ticksCoords.length) {
      return;
    }

    var splitAreaModel = radiusAxisModel.getModel('splitArea');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var areaColors = areaStyleModel.get('color');
    var lineCount = 0;
    areaColors = areaColors instanceof Array ? areaColors : [areaColors];
    var splitAreas = [];
    var prevRadius = ticksCoords[0].coord;

    for (var i = 1; i < ticksCoords.length; i++) {
      var colorIndex = lineCount++ % areaColors.length;
      splitAreas[colorIndex] = splitAreas[colorIndex] || [];
      splitAreas[colorIndex].push(new graphic.Sector({
        shape: {
          cx: polar.cx,
          cy: polar.cy,
          r0: prevRadius,
          r: ticksCoords[i].coord,
          startAngle: 0,
          endAngle: Math.PI * 2
        },
        silent: true
      }));
      prevRadius = ticksCoords[i].coord;
    } // Simple optimization
    // Batching the lines if color are the same


    for (var i = 0; i < splitAreas.length; i++) {
      this.group.add(graphic.mergePath(splitAreas[i], {
        style: zrUtil.defaults({
          fill: areaColors[i % areaColors.length]
        }, areaStyleModel.getAreaStyle()),
        silent: true
      }));
    }
  }
});
/**
 * @inner
 */


function layoutAxis(polar, radiusAxisModel, axisAngle) {
  return {
    position: [polar.cx, polar.cy],
    rotation: axisAngle / 180 * Math.PI,
    labelDirection: -1,
    tickDirection: -1,
    nameDirection: 1,
    labelRotate: radiusAxisModel.getModel('axisLabel').get('rotate'),
    // Over splitLine and splitArea
    z2: 1
  };
}

module.exports = _default;

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var formatUtil = __webpack_require__(54);

var BaseAxisPointer = __webpack_require__(426);

var graphic = __webpack_require__(27);

var viewHelper = __webpack_require__(308);

var matrix = __webpack_require__(82);

var AxisBuilder = __webpack_require__(151);

var AxisView = __webpack_require__(179);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var PolarAxisPointer = BaseAxisPointer.extend({
  /**
   * @override
   */
  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
    var axis = axisModel.axis;

    if (axis.dim === 'angle') {
      this.animationThreshold = Math.PI / 18;
    }

    var polar = axis.polar;
    var otherAxis = polar.getOtherAxis(axis);
    var otherExtent = otherAxis.getExtent();
    var coordValue;
    coordValue = axis['dataTo' + formatUtil.capitalFirst(axis.dim)](value);
    var axisPointerType = axisPointerModel.get('type');

    if (axisPointerType && axisPointerType !== 'none') {
      var elStyle = viewHelper.buildElStyle(axisPointerModel);
      var pointerOption = pointerShapeBuilder[axisPointerType](axis, polar, coordValue, otherExtent, elStyle);
      pointerOption.style = elStyle;
      elOption.graphicKey = pointerOption.type;
      elOption.pointer = pointerOption;
    }

    var labelMargin = axisPointerModel.get('label.margin');
    var labelPos = getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin);
    viewHelper.buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos);
  } // Do not support handle, utill any user requires it.

});

function getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin) {
  var axis = axisModel.axis;
  var coord = axis.dataToCoord(value);
  var axisAngle = polar.getAngleAxis().getExtent()[0];
  axisAngle = axisAngle / 180 * Math.PI;
  var radiusExtent = polar.getRadiusAxis().getExtent();
  var position;
  var align;
  var verticalAlign;

  if (axis.dim === 'radius') {
    var transform = matrix.create();
    matrix.rotate(transform, transform, axisAngle);
    matrix.translate(transform, transform, [polar.cx, polar.cy]);
    position = graphic.applyTransform([coord, -labelMargin], transform);
    var labelRotation = axisModel.getModel('axisLabel').get('rotate') || 0;
    var labelLayout = AxisBuilder.innerTextLayout(axisAngle, labelRotation * Math.PI / 180, -1);
    align = labelLayout.textAlign;
    verticalAlign = labelLayout.textVerticalAlign;
  } else {
    // angle axis
    var r = radiusExtent[1];
    position = polar.coordToPoint([r + labelMargin, coord]);
    var cx = polar.cx;
    var cy = polar.cy;
    align = Math.abs(position[0] - cx) / r < 0.3 ? 'center' : position[0] > cx ? 'left' : 'right';
    verticalAlign = Math.abs(position[1] - cy) / r < 0.3 ? 'middle' : position[1] > cy ? 'top' : 'bottom';
  }

  return {
    position: position,
    align: align,
    verticalAlign: verticalAlign
  };
}

var pointerShapeBuilder = {
  line: function (axis, polar, coordValue, otherExtent, elStyle) {
    return axis.dim === 'angle' ? {
      type: 'Line',
      shape: viewHelper.makeLineShape(polar.coordToPoint([otherExtent[0], coordValue]), polar.coordToPoint([otherExtent[1], coordValue]))
    } : {
      type: 'Circle',
      shape: {
        cx: polar.cx,
        cy: polar.cy,
        r: coordValue
      }
    };
  },
  shadow: function (axis, polar, coordValue, otherExtent, elStyle) {
    var bandWidth = Math.max(1, axis.getBandWidth());
    var radian = Math.PI / 180;
    return axis.dim === 'angle' ? {
      type: 'Sector',
      shape: viewHelper.makeSectorShape(polar.cx, polar.cy, otherExtent[0], otherExtent[1], // In ECharts y is negative if angle is positive
      (-coordValue - bandWidth / 2) * radian, (-coordValue + bandWidth / 2) * radian)
    } : {
      type: 'Sector',
      shape: viewHelper.makeSectorShape(polar.cx, polar.cy, coordValue - bandWidth / 2, coordValue + bandWidth / 2, 0, Math.PI * 2)
    };
  }
};
AxisView.registerAxisPointerClass('PolarAxisPointer', PolarAxisPointer);
var _default = PolarAxisPointer;
module.exports = _default;

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

__webpack_require__(1744);

__webpack_require__(419);

__webpack_require__(1745);

__webpack_require__(659);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function makeAction(method, actionInfo) {
  actionInfo.update = 'updateView';
  echarts.registerAction(actionInfo, function (payload, ecModel) {
    var selected = {};
    ecModel.eachComponent({
      mainType: 'geo',
      query: payload
    }, function (geoModel) {
      geoModel[method](payload.name);
      var geo = geoModel.coordinateSystem;
      zrUtil.each(geo.regions, function (region) {
        selected[region.name] = geoModel.isSelected(region.name) || false;
      });
    });
    return {
      selected: selected,
      name: payload.name
    };
  });
}

makeAction('toggleSelected', {
  type: 'geoToggleSelect',
  event: 'geoselectchanged'
});
makeAction('select', {
  type: 'geoSelect',
  event: 'geoselected'
});
makeAction('unSelect', {
  type: 'geoUnSelect',
  event: 'geounselected'
});

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var modelUtil = __webpack_require__(44);

var ComponentModel = __webpack_require__(73);

var Model = __webpack_require__(68);

var selectableMixin = __webpack_require__(416);

var geoCreator = __webpack_require__(419);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var GeoModel = ComponentModel.extend({
  type: 'geo',

  /**
   * @type {module:echarts/coord/geo/Geo}
   */
  coordinateSystem: null,
  layoutMode: 'box',
  init: function (option) {
    ComponentModel.prototype.init.apply(this, arguments); // Default label emphasis `show`

    modelUtil.defaultEmphasis(option, 'label', ['show']);
  },
  optionUpdated: function () {
    var option = this.option;
    var self = this;
    option.regions = geoCreator.getFilledRegions(option.regions, option.map, option.nameMap);
    this._optionModelMap = zrUtil.reduce(option.regions || [], function (optionModelMap, regionOpt) {
      if (regionOpt.name) {
        optionModelMap.set(regionOpt.name, new Model(regionOpt, self));
      }

      return optionModelMap;
    }, zrUtil.createHashMap());
    this.updateSelectedMap(option.regions);
  },
  defaultOption: {
    zlevel: 0,
    z: 0,
    show: true,
    left: 'center',
    top: 'center',
    // width:,
    // height:,
    // right
    // bottom
    // Aspect is width / height. Inited to be geoJson bbox aspect
    // This parameter is used for scale this aspect
    // If svg used, aspectScale is 1 by default.
    // aspectScale: 0.75,
    aspectScale: null,
    ///// Layout with center and size
    // If you wan't to put map in a fixed size box with right aspect ratio
    // This two properties may more conveninet
    // layoutCenter: [50%, 50%]
    // layoutSize: 100
    silent: false,
    // Map type
    map: '',
    // Define left-top, right-bottom coords to control view
    // For example, [ [180, 90], [-180, -90] ]
    boundingCoords: null,
    // Default on center of map
    center: null,
    zoom: 1,
    scaleLimit: null,
    // selectedMode: false
    label: {
      show: false,
      color: '#000'
    },
    itemStyle: {
      // color: 各异,
      borderWidth: 0.5,
      borderColor: '#444',
      color: '#eee'
    },
    emphasis: {
      label: {
        show: true,
        color: 'rgb(100,0,0)'
      },
      itemStyle: {
        color: 'rgba(255,215,0,0.8)'
      }
    },
    regions: []
  },

  /**
   * Get model of region
   * @param  {string} name
   * @return {module:echarts/model/Model}
   */
  getRegionModel: function (name) {
    return this._optionModelMap.get(name) || new Model(null, this, this.ecModel);
  },

  /**
   * Format label
   * @param {string} name Region name
   * @param {string} [status='normal'] 'normal' or 'emphasis'
   * @return {string}
   */
  getFormattedLabel: function (name, status) {
    status = status || 'normal';
    var regionModel = this.getRegionModel(name);
    var formatter = regionModel.get((status === 'normal' ? '' : status + '.') + 'label.formatter');
    var params = {
      name: name
    };

    if (typeof formatter === 'function') {
      params.status = status;
      return formatter(params);
    } else if (typeof formatter === 'string') {
      return formatter.replace('{a}', name != null ? name : '');
    }
  },
  setZoom: function (zoom) {
    this.option.zoom = zoom;
  },
  setCenter: function (center) {
    this.option.center = center;
  }
});
zrUtil.mixin(GeoModel, selectableMixin);
var _default = GeoModel;
module.exports = _default;

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var MapDraw = __webpack_require__(657);

var echarts = __webpack_require__(23);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = echarts.extendComponentView({
  type: 'geo',
  init: function (ecModel, api) {
    var mapDraw = new MapDraw(api, true);
    this._mapDraw = mapDraw;
    this.group.add(mapDraw.group);
  },
  render: function (geoModel, ecModel, api, payload) {
    // Not render if it is an toggleSelect action from self
    if (payload && payload.type === 'geoToggleSelect' && payload.from === this.uid) {
      return;
    }

    var mapDraw = this._mapDraw;

    if (geoModel.get('show')) {
      mapDraw.draw(geoModel, ecModel, api, this, payload);
    } else {
      this._mapDraw.group.removeAll();
    }

    this.group.silent = geoModel.get('silent');
  },
  dispose: function () {
    this._mapDraw && this._mapDraw.remove();
  }
});

module.exports = _default;

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

__webpack_require__(1747);

__webpack_require__(1748);

__webpack_require__(1749);

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var layout = __webpack_require__(53);

var numberUtil = __webpack_require__(37);

var CoordinateSystem = __webpack_require__(108);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// (24*60*60*1000)
var PROXIMATE_ONE_DAY = 86400000;
/**
 * Calendar
 *
 * @constructor
 *
 * @param {Object} calendarModel calendarModel
 * @param {Object} ecModel       ecModel
 * @param {Object} api           api
 */

function Calendar(calendarModel, ecModel, api) {
  this._model = calendarModel;
}

Calendar.prototype = {
  constructor: Calendar,
  type: 'calendar',
  dimensions: ['time', 'value'],
  // Required in createListFromData
  getDimensionsInfo: function () {
    return [{
      name: 'time',
      type: 'time'
    }, 'value'];
  },
  getRangeInfo: function () {
    return this._rangeInfo;
  },
  getModel: function () {
    return this._model;
  },
  getRect: function () {
    return this._rect;
  },
  getCellWidth: function () {
    return this._sw;
  },
  getCellHeight: function () {
    return this._sh;
  },
  getOrient: function () {
    return this._orient;
  },

  /**
   * getFirstDayOfWeek
   *
   * @example
   *     0 : start at Sunday
   *     1 : start at Monday
   *
   * @return {number}
   */
  getFirstDayOfWeek: function () {
    return this._firstDayOfWeek;
  },

  /**
   * get date info
   *
   * @param  {string|number} date date
   * @return {Object}
   * {
   *      y: string, local full year, eg., '1940',
   *      m: string, local month, from '01' ot '12',
   *      d: string, local date, from '01' to '31' (if exists),
   *      day: It is not date.getDay(). It is the location of the cell in a week, from 0 to 6,
   *      time: timestamp,
   *      formatedDate: string, yyyy-MM-dd,
   *      date: original date object.
   * }
   */
  getDateInfo: function (date) {
    date = numberUtil.parseDate(date);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    var d = date.getDate();
    d = d < 10 ? '0' + d : d;
    var day = date.getDay();
    day = Math.abs((day + 7 - this.getFirstDayOfWeek()) % 7);
    return {
      y: y,
      m: m,
      d: d,
      day: day,
      time: date.getTime(),
      formatedDate: y + '-' + m + '-' + d,
      date: date
    };
  },
  getNextNDay: function (date, n) {
    n = n || 0;

    if (n === 0) {
      return this.getDateInfo(date);
    }

    date = new Date(this.getDateInfo(date).time);
    date.setDate(date.getDate() + n);
    return this.getDateInfo(date);
  },
  update: function (ecModel, api) {
    this._firstDayOfWeek = +this._model.getModel('dayLabel').get('firstDay');
    this._orient = this._model.get('orient');
    this._lineWidth = this._model.getModel('itemStyle').getItemStyle().lineWidth || 0;
    this._rangeInfo = this._getRangeInfo(this._initRangeOption());
    var weeks = this._rangeInfo.weeks || 1;
    var whNames = ['width', 'height'];

    var cellSize = this._model.get('cellSize').slice();

    var layoutParams = this._model.getBoxLayoutParams();

    var cellNumbers = this._orient === 'horizontal' ? [weeks, 7] : [7, weeks];
    zrUtil.each([0, 1], function (idx) {
      if (cellSizeSpecified(cellSize, idx)) {
        layoutParams[whNames[idx]] = cellSize[idx] * cellNumbers[idx];
      }
    });
    var whGlobal = {
      width: api.getWidth(),
      height: api.getHeight()
    };
    var calendarRect = this._rect = layout.getLayoutRect(layoutParams, whGlobal);
    zrUtil.each([0, 1], function (idx) {
      if (!cellSizeSpecified(cellSize, idx)) {
        cellSize[idx] = calendarRect[whNames[idx]] / cellNumbers[idx];
      }
    });

    function cellSizeSpecified(cellSize, idx) {
      return cellSize[idx] != null && cellSize[idx] !== 'auto';
    }

    this._sw = cellSize[0];
    this._sh = cellSize[1];
  },

  /**
   * Convert a time data(time, value) item to (x, y) point.
   *
   * @override
   * @param  {Array|number} data data
   * @param  {boolean} [clamp=true] out of range
   * @return {Array} point
   */
  dataToPoint: function (data, clamp) {
    zrUtil.isArray(data) && (data = data[0]);
    clamp == null && (clamp = true);
    var dayInfo = this.getDateInfo(data);
    var range = this._rangeInfo;
    var date = dayInfo.formatedDate; // if not in range return [NaN, NaN]

    if (clamp && !(dayInfo.time >= range.start.time && dayInfo.time < range.end.time + PROXIMATE_ONE_DAY)) {
      return [NaN, NaN];
    }

    var week = dayInfo.day;

    var nthWeek = this._getRangeInfo([range.start.time, date]).nthWeek;

    if (this._orient === 'vertical') {
      return [this._rect.x + week * this._sw + this._sw / 2, this._rect.y + nthWeek * this._sh + this._sh / 2];
    }

    return [this._rect.x + nthWeek * this._sw + this._sw / 2, this._rect.y + week * this._sh + this._sh / 2];
  },

  /**
   * Convert a (x, y) point to time data
   *
   * @override
   * @param  {string} point point
   * @return {string}       data
   */
  pointToData: function (point) {
    var date = this.pointToDate(point);
    return date && date.time;
  },

  /**
   * Convert a time date item to (x, y) four point.
   *
   * @param  {Array} data  date[0] is date
   * @param  {boolean} [clamp=true]  out of range
   * @return {Object}       point
   */
  dataToRect: function (data, clamp) {
    var point = this.dataToPoint(data, clamp);
    return {
      contentShape: {
        x: point[0] - (this._sw - this._lineWidth) / 2,
        y: point[1] - (this._sh - this._lineWidth) / 2,
        width: this._sw - this._lineWidth,
        height: this._sh - this._lineWidth
      },
      center: point,
      tl: [point[0] - this._sw / 2, point[1] - this._sh / 2],
      tr: [point[0] + this._sw / 2, point[1] - this._sh / 2],
      br: [point[0] + this._sw / 2, point[1] + this._sh / 2],
      bl: [point[0] - this._sw / 2, point[1] + this._sh / 2]
    };
  },

  /**
   * Convert a (x, y) point to time date
   *
   * @param  {Array} point point
   * @return {Object}       date
   */
  pointToDate: function (point) {
    var nthX = Math.floor((point[0] - this._rect.x) / this._sw) + 1;
    var nthY = Math.floor((point[1] - this._rect.y) / this._sh) + 1;
    var range = this._rangeInfo.range;

    if (this._orient === 'vertical') {
      return this._getDateByWeeksAndDay(nthY, nthX - 1, range);
    }

    return this._getDateByWeeksAndDay(nthX, nthY - 1, range);
  },

  /**
   * @inheritDoc
   */
  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),

  /**
   * @inheritDoc
   */
  convertFromPixel: zrUtil.curry(doConvert, 'pointToData'),

  /**
   * initRange
   *
   * @private
   * @return {Array} [start, end]
   */
  _initRangeOption: function () {
    var range = this._model.get('range');

    var rg = range;

    if (zrUtil.isArray(rg) && rg.length === 1) {
      rg = rg[0];
    }

    if (/^\d{4}$/.test(rg)) {
      range = [rg + '-01-01', rg + '-12-31'];
    }

    if (/^\d{4}[\/|-]\d{1,2}$/.test(rg)) {
      var start = this.getDateInfo(rg);
      var firstDay = start.date;
      firstDay.setMonth(firstDay.getMonth() + 1);
      var end = this.getNextNDay(firstDay, -1);
      range = [start.formatedDate, end.formatedDate];
    }

    if (/^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(rg)) {
      range = [rg, rg];
    }

    var tmp = this._getRangeInfo(range);

    if (tmp.start.time > tmp.end.time) {
      range.reverse();
    }

    return range;
  },

  /**
   * range info
   *
   * @private
   * @param  {Array} range range ['2017-01-01', '2017-07-08']
   *  If range[0] > range[1], they will not be reversed.
   * @return {Object}       obj
   */
  _getRangeInfo: function (range) {
    range = [this.getDateInfo(range[0]), this.getDateInfo(range[1])];
    var reversed;

    if (range[0].time > range[1].time) {
      reversed = true;
      range.reverse();
    }

    var allDay = Math.floor(range[1].time / PROXIMATE_ONE_DAY) - Math.floor(range[0].time / PROXIMATE_ONE_DAY) + 1; // Consider case1 (#11677 #10430):
    // Set the system timezone as "UK", set the range to `['2016-07-01', '2016-12-31']`
    // Consider case2:
    // Firstly set system timezone as "Time Zone: America/Toronto",
    // ```
    // var first = new Date(1478412000000 - 3600 * 1000 * 2.5);
    // var second = new Date(1478412000000);
    // var allDays = Math.floor(second / ONE_DAY) - Math.floor(first / ONE_DAY) + 1;
    // ```
    // will get wrong result because of DST. So we should fix it.

    var date = new Date(range[0].time);
    var startDateNum = date.getDate();
    var endDateNum = range[1].date.getDate();
    date.setDate(startDateNum + allDay - 1); // The bias can not over a month, so just compare date.

    var dateNum = date.getDate();

    if (dateNum !== endDateNum) {
      var sign = date.getTime() - range[1].time > 0 ? 1 : -1;

      while ((dateNum = date.getDate()) !== endDateNum && (date.getTime() - range[1].time) * sign > 0) {
        allDay -= sign;
        date.setDate(dateNum - sign);
      }
    }

    var weeks = Math.floor((allDay + range[0].day + 6) / 7);
    var nthWeek = reversed ? -weeks + 1 : weeks - 1;
    reversed && range.reverse();
    return {
      range: [range[0].formatedDate, range[1].formatedDate],
      start: range[0],
      end: range[1],
      allDay: allDay,
      weeks: weeks,
      // From 0.
      nthWeek: nthWeek,
      fweek: range[0].day,
      lweek: range[1].day
    };
  },

  /**
   * get date by nthWeeks and week day in range
   *
   * @private
   * @param  {number} nthWeek the week
   * @param  {number} day   the week day
   * @param  {Array} range [d1, d2]
   * @return {Object}
   */
  _getDateByWeeksAndDay: function (nthWeek, day, range) {
    var rangeInfo = this._getRangeInfo(range);

    if (nthWeek > rangeInfo.weeks || nthWeek === 0 && day < rangeInfo.fweek || nthWeek === rangeInfo.weeks && day > rangeInfo.lweek) {
      return false;
    }

    var nthDay = (nthWeek - 1) * 7 - rangeInfo.fweek + day;
    var date = new Date(rangeInfo.start.time);
    date.setDate(rangeInfo.start.d + nthDay);
    return this.getDateInfo(date);
  }
};
Calendar.dimensions = Calendar.prototype.dimensions;
Calendar.getDimensionsInfo = Calendar.prototype.getDimensionsInfo;

Calendar.create = function (ecModel, api) {
  var calendarList = [];
  ecModel.eachComponent('calendar', function (calendarModel) {
    var calendar = new Calendar(calendarModel, ecModel, api);
    calendarList.push(calendar);
    calendarModel.coordinateSystem = calendar;
  });
  ecModel.eachSeries(function (calendarSeries) {
    if (calendarSeries.get('coordinateSystem') === 'calendar') {
      // Inject coordinate system
      calendarSeries.coordinateSystem = calendarList[calendarSeries.get('calendarIndex') || 0];
    }
  });
  return calendarList;
};

function doConvert(methodName, ecModel, finder, value) {
  var calendarModel = finder.calendarModel;
  var seriesModel = finder.seriesModel;
  var coordSys = calendarModel ? calendarModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem : null;
  return coordSys === this ? coordSys[methodName](value) : null;
}

CoordinateSystem.register('calendar', Calendar);
var _default = Calendar;
module.exports = _default;

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var ComponentModel = __webpack_require__(73);

var _layout = __webpack_require__(53);

var getLayoutParams = _layout.getLayoutParams;
var sizeCalculable = _layout.sizeCalculable;
var mergeLayoutParam = _layout.mergeLayoutParam;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var CalendarModel = ComponentModel.extend({
  type: 'calendar',

  /**
   * @type {module:echarts/coord/calendar/Calendar}
   */
  coordinateSystem: null,
  defaultOption: {
    zlevel: 0,
    z: 2,
    left: 80,
    top: 60,
    cellSize: 20,
    // horizontal vertical
    orient: 'horizontal',
    // month separate line style
    splitLine: {
      show: true,
      lineStyle: {
        color: '#000',
        width: 1,
        type: 'solid'
      }
    },
    // rect style  temporarily unused emphasis
    itemStyle: {
      color: '#fff',
      borderWidth: 1,
      borderColor: '#ccc'
    },
    // week text style
    dayLabel: {
      show: true,
      // a week first day
      firstDay: 0,
      // start end
      position: 'start',
      margin: '50%',
      // 50% of cellSize
      nameMap: 'en',
      color: '#000'
    },
    // month text style
    monthLabel: {
      show: true,
      // start end
      position: 'start',
      margin: 5,
      // center or left
      align: 'center',
      // cn en []
      nameMap: 'en',
      formatter: null,
      color: '#000'
    },
    // year text style
    yearLabel: {
      show: true,
      // top bottom left right
      position: null,
      margin: 30,
      formatter: null,
      color: '#ccc',
      fontFamily: 'sans-serif',
      fontWeight: 'bolder',
      fontSize: 20
    }
  },

  /**
   * @override
   */
  init: function (option, parentModel, ecModel, extraOpt) {
    var inputPositionParams = getLayoutParams(option);
    CalendarModel.superApply(this, 'init', arguments);
    mergeAndNormalizeLayoutParams(option, inputPositionParams);
  },

  /**
   * @override
   */
  mergeOption: function (option, extraOpt) {
    CalendarModel.superApply(this, 'mergeOption', arguments);
    mergeAndNormalizeLayoutParams(this.option, option);
  }
});

function mergeAndNormalizeLayoutParams(target, raw) {
  // Normalize cellSize
  var cellSize = target.cellSize;

  if (!zrUtil.isArray(cellSize)) {
    cellSize = target.cellSize = [cellSize, cellSize];
  } else if (cellSize.length === 1) {
    cellSize[1] = cellSize[0];
  }

  var ignoreSize = zrUtil.map([0, 1], function (hvIdx) {
    // If user have set `width` or both `left` and `right`, cellSize
    // will be automatically set to 'auto', otherwise the default
    // setting of cellSize will make `width` setting not work.
    if (sizeCalculable(raw, hvIdx)) {
      cellSize[hvIdx] = 'auto';
    }

    return cellSize[hvIdx] != null && cellSize[hvIdx] !== 'auto';
  });
  mergeLayoutParam(target, raw, {
    type: 'box',
    ignoreSize: ignoreSize
  });
}

var _default = CalendarModel;
module.exports = _default;

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var graphic = __webpack_require__(27);

var formatUtil = __webpack_require__(54);

var numberUtil = __webpack_require__(37);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var MONTH_TEXT = {
  EN: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  CN: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
};
var WEEK_TEXT = {
  EN: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  CN: ['日', '一', '二', '三', '四', '五', '六']
};

var _default = echarts.extendComponentView({
  type: 'calendar',

  /**
   * top/left line points
   *  @private
   */
  _tlpoints: null,

  /**
   * bottom/right line points
   *  @private
   */
  _blpoints: null,

  /**
   * first day of month
   *  @private
   */
  _firstDayOfMonth: null,

  /**
   * first day point of month
   *  @private
   */
  _firstDayPoints: null,
  render: function (calendarModel, ecModel, api) {
    var group = this.group;
    group.removeAll();
    var coordSys = calendarModel.coordinateSystem; // range info

    var rangeData = coordSys.getRangeInfo();
    var orient = coordSys.getOrient();

    this._renderDayRect(calendarModel, rangeData, group); // _renderLines must be called prior to following function


    this._renderLines(calendarModel, rangeData, orient, group);

    this._renderYearText(calendarModel, rangeData, orient, group);

    this._renderMonthText(calendarModel, orient, group);

    this._renderWeekText(calendarModel, rangeData, orient, group);
  },
  // render day rect
  _renderDayRect: function (calendarModel, rangeData, group) {
    var coordSys = calendarModel.coordinateSystem;
    var itemRectStyleModel = calendarModel.getModel('itemStyle').getItemStyle();
    var sw = coordSys.getCellWidth();
    var sh = coordSys.getCellHeight();

    for (var i = rangeData.start.time; i <= rangeData.end.time; i = coordSys.getNextNDay(i, 1).time) {
      var point = coordSys.dataToRect([i], false).tl; // every rect

      var rect = new graphic.Rect({
        shape: {
          x: point[0],
          y: point[1],
          width: sw,
          height: sh
        },
        cursor: 'default',
        style: itemRectStyleModel
      });
      group.add(rect);
    }
  },
  // render separate line
  _renderLines: function (calendarModel, rangeData, orient, group) {
    var self = this;
    var coordSys = calendarModel.coordinateSystem;
    var lineStyleModel = calendarModel.getModel('splitLine.lineStyle').getLineStyle();
    var show = calendarModel.get('splitLine.show');
    var lineWidth = lineStyleModel.lineWidth;
    this._tlpoints = [];
    this._blpoints = [];
    this._firstDayOfMonth = [];
    this._firstDayPoints = [];
    var firstDay = rangeData.start;

    for (var i = 0; firstDay.time <= rangeData.end.time; i++) {
      addPoints(firstDay.formatedDate);

      if (i === 0) {
        firstDay = coordSys.getDateInfo(rangeData.start.y + '-' + rangeData.start.m);
      }

      var date = firstDay.date;
      date.setMonth(date.getMonth() + 1);
      firstDay = coordSys.getDateInfo(date);
    }

    addPoints(coordSys.getNextNDay(rangeData.end.time, 1).formatedDate);

    function addPoints(date) {
      self._firstDayOfMonth.push(coordSys.getDateInfo(date));

      self._firstDayPoints.push(coordSys.dataToRect([date], false).tl);

      var points = self._getLinePointsOfOneWeek(calendarModel, date, orient);

      self._tlpoints.push(points[0]);

      self._blpoints.push(points[points.length - 1]);

      show && self._drawSplitline(points, lineStyleModel, group);
    } // render top/left line


    show && this._drawSplitline(self._getEdgesPoints(self._tlpoints, lineWidth, orient), lineStyleModel, group); // render bottom/right line

    show && this._drawSplitline(self._getEdgesPoints(self._blpoints, lineWidth, orient), lineStyleModel, group);
  },
  // get points at both ends
  _getEdgesPoints: function (points, lineWidth, orient) {
    var rs = [points[0].slice(), points[points.length - 1].slice()];
    var idx = orient === 'horizontal' ? 0 : 1; // both ends of the line are extend half lineWidth

    rs[0][idx] = rs[0][idx] - lineWidth / 2;
    rs[1][idx] = rs[1][idx] + lineWidth / 2;
    return rs;
  },
  // render split line
  _drawSplitline: function (points, lineStyleModel, group) {
    var poyline = new graphic.Polyline({
      z2: 20,
      shape: {
        points: points
      },
      style: lineStyleModel
    });
    group.add(poyline);
  },
  // render month line of one week points
  _getLinePointsOfOneWeek: function (calendarModel, date, orient) {
    var coordSys = calendarModel.coordinateSystem;
    date = coordSys.getDateInfo(date);
    var points = [];

    for (var i = 0; i < 7; i++) {
      var tmpD = coordSys.getNextNDay(date.time, i);
      var point = coordSys.dataToRect([tmpD.time], false);
      points[2 * tmpD.day] = point.tl;
      points[2 * tmpD.day + 1] = point[orient === 'horizontal' ? 'bl' : 'tr'];
    }

    return points;
  },
  _formatterLabel: function (formatter, params) {
    if (typeof formatter === 'string' && formatter) {
      return formatUtil.formatTplSimple(formatter, params);
    }

    if (typeof formatter === 'function') {
      return formatter(params);
    }

    return params.nameMap;
  },
  _yearTextPositionControl: function (textEl, point, orient, position, margin) {
    point = point.slice();
    var aligns = ['center', 'bottom'];

    if (position === 'bottom') {
      point[1] += margin;
      aligns = ['center', 'top'];
    } else if (position === 'left') {
      point[0] -= margin;
    } else if (position === 'right') {
      point[0] += margin;
      aligns = ['center', 'top'];
    } else {
      // top
      point[1] -= margin;
    }

    var rotate = 0;

    if (position === 'left' || position === 'right') {
      rotate = Math.PI / 2;
    }

    return {
      rotation: rotate,
      position: point,
      style: {
        textAlign: aligns[0],
        textVerticalAlign: aligns[1]
      }
    };
  },
  // render year
  _renderYearText: function (calendarModel, rangeData, orient, group) {
    var yearLabel = calendarModel.getModel('yearLabel');

    if (!yearLabel.get('show')) {
      return;
    }

    var margin = yearLabel.get('margin');
    var pos = yearLabel.get('position');

    if (!pos) {
      pos = orient !== 'horizontal' ? 'top' : 'left';
    }

    var points = [this._tlpoints[this._tlpoints.length - 1], this._blpoints[0]];
    var xc = (points[0][0] + points[1][0]) / 2;
    var yc = (points[0][1] + points[1][1]) / 2;
    var idx = orient === 'horizontal' ? 0 : 1;
    var posPoints = {
      top: [xc, points[idx][1]],
      bottom: [xc, points[1 - idx][1]],
      left: [points[1 - idx][0], yc],
      right: [points[idx][0], yc]
    };
    var name = rangeData.start.y;

    if (+rangeData.end.y > +rangeData.start.y) {
      name = name + '-' + rangeData.end.y;
    }

    var formatter = yearLabel.get('formatter');
    var params = {
      start: rangeData.start.y,
      end: rangeData.end.y,
      nameMap: name
    };

    var content = this._formatterLabel(formatter, params);

    var yearText = new graphic.Text({
      z2: 30
    });
    graphic.setTextStyle(yearText.style, yearLabel, {
      text: content
    }), yearText.attr(this._yearTextPositionControl(yearText, posPoints[pos], orient, pos, margin));
    group.add(yearText);
  },
  _monthTextPositionControl: function (point, isCenter, orient, position, margin) {
    var align = 'left';
    var vAlign = 'top';
    var x = point[0];
    var y = point[1];

    if (orient === 'horizontal') {
      y = y + margin;

      if (isCenter) {
        align = 'center';
      }

      if (position === 'start') {
        vAlign = 'bottom';
      }
    } else {
      x = x + margin;

      if (isCenter) {
        vAlign = 'middle';
      }

      if (position === 'start') {
        align = 'right';
      }
    }

    return {
      x: x,
      y: y,
      textAlign: align,
      textVerticalAlign: vAlign
    };
  },
  // render month and year text
  _renderMonthText: function (calendarModel, orient, group) {
    var monthLabel = calendarModel.getModel('monthLabel');

    if (!monthLabel.get('show')) {
      return;
    }

    var nameMap = monthLabel.get('nameMap');
    var margin = monthLabel.get('margin');
    var pos = monthLabel.get('position');
    var align = monthLabel.get('align');
    var termPoints = [this._tlpoints, this._blpoints];

    if (zrUtil.isString(nameMap)) {
      nameMap = MONTH_TEXT[nameMap.toUpperCase()] || [];
    }

    var idx = pos === 'start' ? 0 : 1;
    var axis = orient === 'horizontal' ? 0 : 1;
    margin = pos === 'start' ? -margin : margin;
    var isCenter = align === 'center';

    for (var i = 0; i < termPoints[idx].length - 1; i++) {
      var tmp = termPoints[idx][i].slice();
      var firstDay = this._firstDayOfMonth[i];

      if (isCenter) {
        var firstDayPoints = this._firstDayPoints[i];
        tmp[axis] = (firstDayPoints[axis] + termPoints[0][i + 1][axis]) / 2;
      }

      var formatter = monthLabel.get('formatter');
      var name = nameMap[+firstDay.m - 1];
      var params = {
        yyyy: firstDay.y,
        yy: (firstDay.y + '').slice(2),
        MM: firstDay.m,
        M: +firstDay.m,
        nameMap: name
      };

      var content = this._formatterLabel(formatter, params);

      var monthText = new graphic.Text({
        z2: 30
      });
      zrUtil.extend(graphic.setTextStyle(monthText.style, monthLabel, {
        text: content
      }), this._monthTextPositionControl(tmp, isCenter, orient, pos, margin));
      group.add(monthText);
    }
  },
  _weekTextPositionControl: function (point, orient, position, margin, cellSize) {
    var align = 'center';
    var vAlign = 'middle';
    var x = point[0];
    var y = point[1];
    var isStart = position === 'start';

    if (orient === 'horizontal') {
      x = x + margin + (isStart ? 1 : -1) * cellSize[0] / 2;
      align = isStart ? 'right' : 'left';
    } else {
      y = y + margin + (isStart ? 1 : -1) * cellSize[1] / 2;
      vAlign = isStart ? 'bottom' : 'top';
    }

    return {
      x: x,
      y: y,
      textAlign: align,
      textVerticalAlign: vAlign
    };
  },
  // render weeks
  _renderWeekText: function (calendarModel, rangeData, orient, group) {
    var dayLabel = calendarModel.getModel('dayLabel');

    if (!dayLabel.get('show')) {
      return;
    }

    var coordSys = calendarModel.coordinateSystem;
    var pos = dayLabel.get('position');
    var nameMap = dayLabel.get('nameMap');
    var margin = dayLabel.get('margin');
    var firstDayOfWeek = coordSys.getFirstDayOfWeek();

    if (zrUtil.isString(nameMap)) {
      nameMap = WEEK_TEXT[nameMap.toUpperCase()] || [];
    }

    var start = coordSys.getNextNDay(rangeData.end.time, 7 - rangeData.lweek).time;
    var cellSize = [coordSys.getCellWidth(), coordSys.getCellHeight()];
    margin = numberUtil.parsePercent(margin, cellSize[orient === 'horizontal' ? 0 : 1]);

    if (pos === 'start') {
      start = coordSys.getNextNDay(rangeData.start.time, -(7 + rangeData.fweek)).time;
      margin = -margin;
    }

    for (var i = 0; i < 7; i++) {
      var tmpD = coordSys.getNextNDay(start, i);
      var point = coordSys.dataToRect([tmpD.time], false).center;
      var day = i;
      day = Math.abs((i + firstDayOfWeek) % 7);
      var weekText = new graphic.Text({
        z2: 30
      });
      zrUtil.extend(graphic.setTextStyle(weekText.style, dayLabel, {
        text: nameMap[day]
      }), this._weekTextPositionControl(point, orient, pos, margin, cellSize));
      group.add(weekText);
    }
  }
});

module.exports = _default;

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var modelUtil = __webpack_require__(44);

var graphicUtil = __webpack_require__(27);

var layoutUtil = __webpack_require__(53);

var _number = __webpack_require__(37);

var parsePercent = _number.parsePercent;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _nonShapeGraphicElements = {
  // Reserved but not supported in graphic component.
  path: null,
  compoundPath: null,
  // Supported in graphic component.
  group: graphicUtil.Group,
  image: graphicUtil.Image,
  text: graphicUtil.Text
}; // -------------
// Preprocessor
// -------------

echarts.registerPreprocessor(function (option) {
  var graphicOption = option.graphic; // Convert
  // {graphic: [{left: 10, type: 'circle'}, ...]}
  // or
  // {graphic: {left: 10, type: 'circle'}}
  // to
  // {graphic: [{elements: [{left: 10, type: 'circle'}, ...]}]}

  if (zrUtil.isArray(graphicOption)) {
    if (!graphicOption[0] || !graphicOption[0].elements) {
      option.graphic = [{
        elements: graphicOption
      }];
    } else {
      // Only one graphic instance can be instantiated. (We dont
      // want that too many views are created in echarts._viewMap)
      option.graphic = [option.graphic[0]];
    }
  } else if (graphicOption && !graphicOption.elements) {
    option.graphic = [{
      elements: [graphicOption]
    }];
  }
}); // ------
// Model
// ------

var GraphicModel = echarts.extendComponentModel({
  type: 'graphic',
  defaultOption: {
    // Extra properties for each elements:
    //
    // left/right/top/bottom: (like 12, '22%', 'center', default undefined)
    //      If left/rigth is set, shape.x/shape.cx/position will not be used.
    //      If top/bottom is set, shape.y/shape.cy/position will not be used.
    //      This mechanism is useful when you want to position a group/element
    //      against the right side or the center of this container.
    //
    // width/height: (can only be pixel value, default 0)
    //      Only be used to specify contianer(group) size, if needed. And
    //      can not be percentage value (like '33%'). See the reason in the
    //      layout algorithm below.
    //
    // bounding: (enum: 'all' (default) | 'raw')
    //      Specify how to calculate boundingRect when locating.
    //      'all': Get uioned and transformed boundingRect
    //          from both itself and its descendants.
    //          This mode simplies confining a group of elements in the bounding
    //          of their ancester container (e.g., using 'right: 0').
    //      'raw': Only use the boundingRect of itself and before transformed.
    //          This mode is similar to css behavior, which is useful when you
    //          want an element to be able to overflow its container. (Consider
    //          a rotated circle needs to be located in a corner.)
    // info: custom info. enables user to mount some info on elements and use them
    //      in event handlers. Update them only when user specified, otherwise, remain.
    // Note: elements is always behind its ancestors in this elements array.
    elements: [],
    parentId: null
  },

  /**
   * Save el options for the sake of the performance (only update modified graphics).
   * The order is the same as those in option. (ancesters -> descendants)
   *
   * @private
   * @type {Array.<Object>}
   */
  _elOptionsToUpdate: null,

  /**
   * @override
   */
  mergeOption: function (option) {
    // Prevent default merge to elements
    var elements = this.option.elements;
    this.option.elements = null;
    GraphicModel.superApply(this, 'mergeOption', arguments);
    this.option.elements = elements;
  },

  /**
   * @override
   */
  optionUpdated: function (newOption, isInit) {
    var thisOption = this.option;
    var newList = (isInit ? thisOption : newOption).elements;
    var existList = thisOption.elements = isInit ? [] : thisOption.elements;
    var flattenedList = [];

    this._flatten(newList, flattenedList);

    var mappingResult = modelUtil.mappingToExists(existList, flattenedList);
    modelUtil.makeIdAndName(mappingResult); // Clear elOptionsToUpdate

    var elOptionsToUpdate = this._elOptionsToUpdate = [];
    zrUtil.each(mappingResult, function (resultItem, index) {
      var newElOption = resultItem.option;

      if (!newElOption) {
        return;
      }

      elOptionsToUpdate.push(newElOption);
      setKeyInfoToNewElOption(resultItem, newElOption);
      mergeNewElOptionToExist(existList, index, newElOption);
      setLayoutInfoToExist(existList[index], newElOption);
    }, this); // Clean

    for (var i = existList.length - 1; i >= 0; i--) {
      if (existList[i] == null) {
        existList.splice(i, 1);
      } else {
        // $action should be volatile, otherwise option gotten from
        // `getOption` will contain unexpected $action.
        delete existList[i].$action;
      }
    }
  },

  /**
   * Convert
   * [{
   *  type: 'group',
   *  id: 'xx',
   *  children: [{type: 'circle'}, {type: 'polygon'}]
   * }]
   * to
   * [
   *  {type: 'group', id: 'xx'},
   *  {type: 'circle', parentId: 'xx'},
   *  {type: 'polygon', parentId: 'xx'}
   * ]
   *
   * @private
   * @param {Array.<Object>} optionList option list
   * @param {Array.<Object>} result result of flatten
   * @param {Object} parentOption parent option
   */
  _flatten: function (optionList, result, parentOption) {
    zrUtil.each(optionList, function (option) {
      if (!option) {
        return;
      }

      if (parentOption) {
        option.parentOption = parentOption;
      }

      result.push(option);
      var children = option.children;

      if (option.type === 'group' && children) {
        this._flatten(children, result, option);
      } // Deleting for JSON output, and for not affecting group creation.


      delete option.children;
    }, this);
  },
  // FIXME
  // Pass to view using payload? setOption has a payload?
  useElOptionsToUpdate: function () {
    var els = this._elOptionsToUpdate; // Clear to avoid render duplicately when zooming.

    this._elOptionsToUpdate = null;
    return els;
  }
}); // -----
// View
// -----

echarts.extendComponentView({
  type: 'graphic',

  /**
   * @override
   */
  init: function (ecModel, api) {
    /**
     * @private
     * @type {module:zrender/core/util.HashMap}
     */
    this._elMap = zrUtil.createHashMap();
    /**
     * @private
     * @type {module:echarts/graphic/GraphicModel}
     */

    this._lastGraphicModel;
  },

  /**
   * @override
   */
  render: function (graphicModel, ecModel, api) {
    // Having leveraged between use cases and algorithm complexity, a very
    // simple layout mechanism is used:
    // The size(width/height) can be determined by itself or its parent (not
    // implemented yet), but can not by its children. (Top-down travel)
    // The location(x/y) can be determined by the bounding rect of itself
    // (can including its descendants or not) and the size of its parent.
    // (Bottom-up travel)
    // When `chart.clear()` or `chart.setOption({...}, true)` with the same id,
    // view will be reused.
    if (graphicModel !== this._lastGraphicModel) {
      this._clear();
    }

    this._lastGraphicModel = graphicModel;

    this._updateElements(graphicModel);

    this._relocate(graphicModel, api);
  },

  /**
   * Update graphic elements.
   *
   * @private
   * @param {Object} graphicModel graphic model
   */
  _updateElements: function (graphicModel) {
    var elOptionsToUpdate = graphicModel.useElOptionsToUpdate();

    if (!elOptionsToUpdate) {
      return;
    }

    var elMap = this._elMap;
    var rootGroup = this.group; // Top-down tranverse to assign graphic settings to each elements.

    zrUtil.each(elOptionsToUpdate, function (elOption) {
      var $action = elOption.$action;
      var id = elOption.id;
      var existEl = elMap.get(id);
      var parentId = elOption.parentId;
      var targetElParent = parentId != null ? elMap.get(parentId) : rootGroup;
      var elOptionStyle = elOption.style;

      if (elOption.type === 'text' && elOptionStyle) {
        // In top/bottom mode, textVerticalAlign should not be used, which cause
        // inaccurately locating.
        if (elOption.hv && elOption.hv[1]) {
          elOptionStyle.textVerticalAlign = elOptionStyle.textBaseline = null;
        } // Compatible with previous setting: both support fill and textFill,
        // stroke and textStroke.


        !elOptionStyle.hasOwnProperty('textFill') && elOptionStyle.fill && (elOptionStyle.textFill = elOptionStyle.fill);
        !elOptionStyle.hasOwnProperty('textStroke') && elOptionStyle.stroke && (elOptionStyle.textStroke = elOptionStyle.stroke);
      } // Remove unnecessary props to avoid potential problems.


      var elOptionCleaned = getCleanedElOption(elOption); // For simple, do not support parent change, otherwise reorder is needed.

      if (!$action || $action === 'merge') {
        existEl ? existEl.attr(elOptionCleaned) : createEl(id, targetElParent, elOptionCleaned, elMap);
      } else if ($action === 'replace') {
        removeEl(existEl, elMap);
        createEl(id, targetElParent, elOptionCleaned, elMap);
      } else if ($action === 'remove') {
        removeEl(existEl, elMap);
      }

      var el = elMap.get(id);

      if (el) {
        el.__ecGraphicWidthOption = elOption.width;
        el.__ecGraphicHeightOption = elOption.height;
        setEventData(el, graphicModel, elOption);
      }
    });
  },

  /**
   * Locate graphic elements.
   *
   * @private
   * @param {Object} graphicModel graphic model
   * @param {module:echarts/ExtensionAPI} api extension API
   */
  _relocate: function (graphicModel, api) {
    var elOptions = graphicModel.option.elements;
    var rootGroup = this.group;
    var elMap = this._elMap;
    var apiWidth = api.getWidth();
    var apiHeight = api.getHeight(); // Top-down to calculate percentage width/height of group

    for (var i = 0; i < elOptions.length; i++) {
      var elOption = elOptions[i];
      var el = elMap.get(elOption.id);

      if (!el || !el.isGroup) {
        continue;
      }

      var parentEl = el.parent;
      var isParentRoot = parentEl === rootGroup; // Like 'position:absolut' in css, default 0.

      el.__ecGraphicWidth = parsePercent(el.__ecGraphicWidthOption, isParentRoot ? apiWidth : parentEl.__ecGraphicWidth) || 0;
      el.__ecGraphicHeight = parsePercent(el.__ecGraphicHeightOption, isParentRoot ? apiHeight : parentEl.__ecGraphicHeight) || 0;
    } // Bottom-up tranvese all elements (consider ec resize) to locate elements.


    for (var i = elOptions.length - 1; i >= 0; i--) {
      var elOption = elOptions[i];
      var el = elMap.get(elOption.id);

      if (!el) {
        continue;
      }

      var parentEl = el.parent;
      var containerInfo = parentEl === rootGroup ? {
        width: apiWidth,
        height: apiHeight
      } : {
        width: parentEl.__ecGraphicWidth,
        height: parentEl.__ecGraphicHeight
      }; // PENDING
      // Currently, when `bounding: 'all'`, the union bounding rect of the group
      // does not include the rect of [0, 0, group.width, group.height], which
      // is probably weird for users. Should we make a break change for it?

      layoutUtil.positionElement(el, elOption, containerInfo, null, {
        hv: elOption.hv,
        boundingMode: elOption.bounding
      });
    }
  },

  /**
   * Clear all elements.
   *
   * @private
   */
  _clear: function () {
    var elMap = this._elMap;
    elMap.each(function (el) {
      removeEl(el, elMap);
    });
    this._elMap = zrUtil.createHashMap();
  },

  /**
   * @override
   */
  dispose: function () {
    this._clear();
  }
});

function createEl(id, targetElParent, elOption, elMap) {
  var graphicType = elOption.type;
  var Clz = _nonShapeGraphicElements.hasOwnProperty(graphicType) // Those graphic elements are not shapes. They should not be
  // overwritten by users, so do them first.
  ? _nonShapeGraphicElements[graphicType] : graphicUtil.getShapeClass(graphicType);
  var el = new Clz(elOption);
  targetElParent.add(el);
  elMap.set(id, el);
  el.__ecGraphicId = id;
}

function removeEl(existEl, elMap) {
  var existElParent = existEl && existEl.parent;

  if (existElParent) {
    existEl.type === 'group' && existEl.traverse(function (el) {
      removeEl(el, elMap);
    });
    elMap.removeKey(existEl.__ecGraphicId);
    existElParent.remove(existEl);
  }
} // Remove unnecessary props to avoid potential problems.


function getCleanedElOption(elOption) {
  elOption = zrUtil.extend({}, elOption);
  zrUtil.each(['id', 'parentId', '$action', 'hv', 'bounding'].concat(layoutUtil.LOCATION_PARAMS), function (name) {
    delete elOption[name];
  });
  return elOption;
}

function isSetLoc(obj, props) {
  var isSet;
  zrUtil.each(props, function (prop) {
    obj[prop] != null && obj[prop] !== 'auto' && (isSet = true);
  });
  return isSet;
}

function setKeyInfoToNewElOption(resultItem, newElOption) {
  var existElOption = resultItem.exist; // Set id and type after id assigned.

  newElOption.id = resultItem.keyInfo.id;
  !newElOption.type && existElOption && (newElOption.type = existElOption.type); // Set parent id if not specified

  if (newElOption.parentId == null) {
    var newElParentOption = newElOption.parentOption;

    if (newElParentOption) {
      newElOption.parentId = newElParentOption.id;
    } else if (existElOption) {
      newElOption.parentId = existElOption.parentId;
    }
  } // Clear


  newElOption.parentOption = null;
}

function mergeNewElOptionToExist(existList, index, newElOption) {
  // Update existing options, for `getOption` feature.
  var newElOptCopy = zrUtil.extend({}, newElOption);
  var existElOption = existList[index];
  var $action = newElOption.$action || 'merge';

  if ($action === 'merge') {
    if (existElOption) {
      // We can ensure that newElOptCopy and existElOption are not
      // the same object, so `merge` will not change newElOptCopy.
      zrUtil.merge(existElOption, newElOptCopy, true); // Rigid body, use ignoreSize.

      layoutUtil.mergeLayoutParam(existElOption, newElOptCopy, {
        ignoreSize: true
      }); // Will be used in render.

      layoutUtil.copyLayoutParams(newElOption, existElOption);
    } else {
      existList[index] = newElOptCopy;
    }
  } else if ($action === 'replace') {
    existList[index] = newElOptCopy;
  } else if ($action === 'remove') {
    // null will be cleaned later.
    existElOption && (existList[index] = null);
  }
}

function setLayoutInfoToExist(existItem, newElOption) {
  if (!existItem) {
    return;
  }

  existItem.hv = newElOption.hv = [// Rigid body, dont care `width`.
  isSetLoc(newElOption, ['left', 'right']), // Rigid body, dont care `height`.
  isSetLoc(newElOption, ['top', 'bottom'])]; // Give default group size. Otherwise layout error may occur.

  if (existItem.type === 'group') {
    existItem.width == null && (existItem.width = newElOption.width = 0);
    existItem.height == null && (existItem.height = newElOption.height = 0);
  }
}

function setEventData(el, graphicModel, elOption) {
  var eventData = el.eventData; // Simple optimize for large amount of elements that no need event.

  if (!el.silent && !el.ignore && !eventData) {
    eventData = el.eventData = {
      componentType: 'graphic',
      componentIndex: graphicModel.componentIndex,
      name: el.name
    };
  } // `elOption.info` enables user to mount some info on
  // elements and use them in event handlers.


  if (eventData) {
    eventData.info = el.info;
  }
}

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

__webpack_require__(1752);

__webpack_require__(1753);

__webpack_require__(1754);

__webpack_require__(1755);

__webpack_require__(1756);

__webpack_require__(1757);

__webpack_require__(1762);

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var featureManager = __webpack_require__(152);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var ToolboxModel = echarts.extendComponentModel({
  type: 'toolbox',
  layoutMode: {
    type: 'box',
    ignoreSize: true
  },
  optionUpdated: function () {
    ToolboxModel.superApply(this, 'optionUpdated', arguments);
    zrUtil.each(this.option.feature, function (featureOpt, featureName) {
      var Feature = featureManager.get(featureName);
      Feature && zrUtil.merge(featureOpt, Feature.defaultOption);
    });
  },
  defaultOption: {
    show: true,
    z: 6,
    zlevel: 0,
    orient: 'horizontal',
    left: 'right',
    top: 'top',
    // right
    // bottom
    backgroundColor: 'transparent',
    borderColor: '#ccc',
    borderRadius: 0,
    borderWidth: 0,
    padding: 5,
    itemSize: 15,
    itemGap: 8,
    showTitle: true,
    iconStyle: {
      borderColor: '#666',
      color: 'none'
    },
    emphasis: {
      iconStyle: {
        borderColor: '#3E98C5'
      }
    },
    // textStyle: {},
    // feature
    tooltip: {
      show: false
    }
  }
});
var _default = ToolboxModel;
module.exports = _default;

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var textContain = __webpack_require__(93);

var featureManager = __webpack_require__(152);

var graphic = __webpack_require__(27);

var Model = __webpack_require__(68);

var DataDiffer = __webpack_require__(177);

var listComponentHelper = __webpack_require__(678);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = echarts.extendComponentView({
  type: 'toolbox',
  render: function (toolboxModel, ecModel, api, payload) {
    var group = this.group;
    group.removeAll();

    if (!toolboxModel.get('show')) {
      return;
    }

    var itemSize = +toolboxModel.get('itemSize');
    var featureOpts = toolboxModel.get('feature') || {};
    var features = this._features || (this._features = {});
    var featureNames = [];
    zrUtil.each(featureOpts, function (opt, name) {
      featureNames.push(name);
    });
    new DataDiffer(this._featureNames || [], featureNames).add(processFeature).update(processFeature).remove(zrUtil.curry(processFeature, null)).execute(); // Keep for diff.

    this._featureNames = featureNames;

    function processFeature(newIndex, oldIndex) {
      var featureName = featureNames[newIndex];
      var oldName = featureNames[oldIndex];
      var featureOpt = featureOpts[featureName];
      var featureModel = new Model(featureOpt, toolboxModel, toolboxModel.ecModel);
      var feature; // FIX#11236, merge feature title from MagicType newOption. TODO: consider seriesIndex ?

      if (payload && payload.newTitle != null && payload.featureName === featureName) {
        featureOpt.title = payload.newTitle;
      }

      if (featureName && !oldName) {
        // Create
        if (isUserFeatureName(featureName)) {
          feature = {
            model: featureModel,
            onclick: featureModel.option.onclick,
            featureName: featureName
          };
        } else {
          var Feature = featureManager.get(featureName);

          if (!Feature) {
            return;
          }

          feature = new Feature(featureModel, ecModel, api);
        }

        features[featureName] = feature;
      } else {
        feature = features[oldName]; // If feature does not exsit.

        if (!feature) {
          return;
        }

        feature.model = featureModel;
        feature.ecModel = ecModel;
        feature.api = api;
      }

      if (!featureName && oldName) {
        feature.dispose && feature.dispose(ecModel, api);
        return;
      }

      if (!featureModel.get('show') || feature.unusable) {
        feature.remove && feature.remove(ecModel, api);
        return;
      }

      createIconPaths(featureModel, feature, featureName);

      featureModel.setIconStatus = function (iconName, status) {
        var option = this.option;
        var iconPaths = this.iconPaths;
        option.iconStatus = option.iconStatus || {};
        option.iconStatus[iconName] = status; // FIXME

        iconPaths[iconName] && iconPaths[iconName].trigger(status);
      };

      if (feature.render) {
        feature.render(featureModel, ecModel, api, payload);
      }
    }

    function createIconPaths(featureModel, feature, featureName) {
      var iconStyleModel = featureModel.getModel('iconStyle');
      var iconStyleEmphasisModel = featureModel.getModel('emphasis.iconStyle'); // If one feature has mutiple icon. they are orginaized as
      // {
      //     icon: {
      //         foo: '',
      //         bar: ''
      //     },
      //     title: {
      //         foo: '',
      //         bar: ''
      //     }
      // }

      var icons = feature.getIcons ? feature.getIcons() : featureModel.get('icon');
      var titles = featureModel.get('title') || {};

      if (typeof icons === 'string') {
        var icon = icons;
        var title = titles;
        icons = {};
        titles = {};
        icons[featureName] = icon;
        titles[featureName] = title;
      }

      var iconPaths = featureModel.iconPaths = {};
      zrUtil.each(icons, function (iconStr, iconName) {
        var path = graphic.createIcon(iconStr, {}, {
          x: -itemSize / 2,
          y: -itemSize / 2,
          width: itemSize,
          height: itemSize
        });
        path.setStyle(iconStyleModel.getItemStyle());
        path.hoverStyle = iconStyleEmphasisModel.getItemStyle(); // Text position calculation

        path.setStyle({
          text: titles[iconName],
          textAlign: iconStyleEmphasisModel.get('textAlign'),
          textBorderRadius: iconStyleEmphasisModel.get('textBorderRadius'),
          textPadding: iconStyleEmphasisModel.get('textPadding'),
          textFill: null
        });
        var tooltipModel = toolboxModel.getModel('tooltip');

        if (tooltipModel && tooltipModel.get('show')) {
          path.attr('tooltip', zrUtil.extend({
            content: titles[iconName],
            formatter: tooltipModel.get('formatter', true) || function () {
              return titles[iconName];
            },
            formatterParams: {
              componentType: 'toolbox',
              name: iconName,
              title: titles[iconName],
              $vars: ['name', 'title']
            },
            position: tooltipModel.get('position', true) || 'bottom'
          }, tooltipModel.option));
        }

        graphic.setHoverStyle(path);

        if (toolboxModel.get('showTitle')) {
          path.__title = titles[iconName];
          path.on('mouseover', function () {
            // Should not reuse above hoverStyle, which might be modified.
            var hoverStyle = iconStyleEmphasisModel.getItemStyle();
            var defaultTextPosition = toolboxModel.get('orient') === 'vertical' ? toolboxModel.get('right') == null ? 'right' : 'left' : toolboxModel.get('bottom') == null ? 'bottom' : 'top';
            path.setStyle({
              textFill: iconStyleEmphasisModel.get('textFill') || hoverStyle.fill || hoverStyle.stroke || '#000',
              textBackgroundColor: iconStyleEmphasisModel.get('textBackgroundColor'),
              textPosition: iconStyleEmphasisModel.get('textPosition') || defaultTextPosition
            });
          }).on('mouseout', function () {
            path.setStyle({
              textFill: null,
              textBackgroundColor: null
            });
          });
        }

        path.trigger(featureModel.get('iconStatus.' + iconName) || 'normal');
        group.add(path);
        path.on('click', zrUtil.bind(feature.onclick, feature, ecModel, api, iconName));
        iconPaths[iconName] = path;
      });
    }

    listComponentHelper.layout(group, toolboxModel, api); // Render background after group is layout
    // FIXME

    group.add(listComponentHelper.makeBackground(group.getBoundingRect(), toolboxModel)); // Adjust icon title positions to avoid them out of screen

    group.eachChild(function (icon) {
      var titleText = icon.__title;
      var hoverStyle = icon.hoverStyle; // May be background element

      if (hoverStyle && titleText) {
        var rect = textContain.getBoundingRect(titleText, textContain.makeFont(hoverStyle));
        var offsetX = icon.position[0] + group.position[0];
        var offsetY = icon.position[1] + group.position[1] + itemSize;
        var needPutOnTop = false;

        if (offsetY + rect.height > api.getHeight()) {
          hoverStyle.textPosition = 'top';
          needPutOnTop = true;
        }

        var topOffset = needPutOnTop ? -5 - rect.height : itemSize + 8;

        if (offsetX + rect.width / 2 > api.getWidth()) {
          hoverStyle.textPosition = ['100%', topOffset];
          hoverStyle.textAlign = 'right';
        } else if (offsetX - rect.width / 2 < 0) {
          hoverStyle.textPosition = [0, topOffset];
          hoverStyle.textAlign = 'left';
        }
      }
    });
  },
  updateView: function (toolboxModel, ecModel, api, payload) {
    zrUtil.each(this._features, function (feature) {
      feature.updateView && feature.updateView(feature.model, ecModel, api, payload);
    });
  },
  // updateLayout: function (toolboxModel, ecModel, api, payload) {
  //     zrUtil.each(this._features, function (feature) {
  //         feature.updateLayout && feature.updateLayout(feature.model, ecModel, api, payload);
  //     });
  // },
  remove: function (ecModel, api) {
    zrUtil.each(this._features, function (feature) {
      feature.remove && feature.remove(ecModel, api);
    });
    this.group.removeAll();
  },
  dispose: function (ecModel, api) {
    zrUtil.each(this._features, function (feature) {
      feature.dispose && feature.dispose(ecModel, api);
    });
  }
});

function isUserFeatureName(featureName) {
  return featureName.indexOf('my') === 0;
}

module.exports = _default;

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var env = __webpack_require__(67);

var lang = __webpack_require__(149);

var featureManager = __webpack_require__(152);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/* global Uint8Array */
var saveAsImageLang = lang.toolbox.saveAsImage;

function SaveAsImage(model) {
  this.model = model;
}

SaveAsImage.defaultOption = {
  show: true,
  icon: 'M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0',
  title: saveAsImageLang.title,
  type: 'png',
  // Default use option.backgroundColor
  // backgroundColor: '#fff',
  connectedBackgroundColor: '#fff',
  name: '',
  excludeComponents: ['toolbox'],
  pixelRatio: 1,
  lang: saveAsImageLang.lang.slice()
};
SaveAsImage.prototype.unusable = !env.canvasSupported;
var proto = SaveAsImage.prototype;

proto.onclick = function (ecModel, api) {
  var model = this.model;
  var title = model.get('name') || ecModel.get('title.0.text') || 'echarts';
  var isSvg = api.getZr().painter.getType() === 'svg';
  var type = isSvg ? 'svg' : model.get('type', true) || 'png';
  var url = api.getConnectedDataURL({
    type: type,
    backgroundColor: model.get('backgroundColor', true) || ecModel.get('backgroundColor') || '#fff',
    connectedBackgroundColor: model.get('connectedBackgroundColor'),
    excludeComponents: model.get('excludeComponents'),
    pixelRatio: model.get('pixelRatio')
  }); // Chrome and Firefox

  if (typeof MouseEvent === 'function' && !env.browser.ie && !env.browser.edge) {
    var $a = document.createElement('a');
    $a.download = title + '.' + type;
    $a.target = '_blank';
    $a.href = url;
    var evt = new MouseEvent('click', {
      // some micro front-end framework， window maybe is a Proxy
      view: document.defaultView,
      bubbles: true,
      cancelable: false
    });
    $a.dispatchEvent(evt);
  } // IE
  else {
      if (window.navigator.msSaveOrOpenBlob) {
        var bstr = atob(url.split(',')[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        var blob = new Blob([u8arr]);
        window.navigator.msSaveOrOpenBlob(blob, title + '.' + type);
      } else {
        var lang = model.get('lang');
        var html = '' + '<body style="margin:0;">' + '<img src="' + url + '" style="max-width:100%;" title="' + (lang && lang[0] || '') + '" />' + '</body>';
        var tab = window.open();
        tab.document.write(html);
      }
    }
};

featureManager.register('saveAsImage', SaveAsImage);
var _default = SaveAsImage;
module.exports = _default;

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var lang = __webpack_require__(149);

var featureManager = __webpack_require__(152);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var magicTypeLang = lang.toolbox.magicType;
var INNER_STACK_KEYWORD = '__ec_magicType_stack__';

function MagicType(model) {
  this.model = model;
}

MagicType.defaultOption = {
  show: true,
  type: [],
  // Icon group
  icon: {
    /* eslint-disable */
    line: 'M4.1,28.9h7.1l9.3-22l7.4,38l9.7-19.7l3,12.8h14.9M4.1,58h51.4',
    bar: 'M6.7,22.9h10V48h-10V22.9zM24.9,13h10v35h-10V13zM43.2,2h10v46h-10V2zM3.1,58h53.7',
    stack: 'M8.2,38.4l-8.4,4.1l30.6,15.3L60,42.5l-8.1-4.1l-21.5,11L8.2,38.4z M51.9,30l-8.1,4.2l-13.4,6.9l-13.9-6.9L8.2,30l-8.4,4.2l8.4,4.2l22.2,11l21.5-11l8.1-4.2L51.9,30z M51.9,21.7l-8.1,4.2L35.7,30l-5.3,2.8L24.9,30l-8.4-4.1l-8.3-4.2l-8.4,4.2L8.2,30l8.3,4.2l13.9,6.9l13.4-6.9l8.1-4.2l8.1-4.1L51.9,21.7zM30.4,2.2L-0.2,17.5l8.4,4.1l8.3,4.2l8.4,4.2l5.5,2.7l5.3-2.7l8.1-4.2l8.1-4.2l8.1-4.1L30.4,2.2z' // jshint ignore:line

    /* eslint-enable */

  },
  // `line`, `bar`, `stack`, `tiled`
  title: zrUtil.clone(magicTypeLang.title),
  option: {},
  seriesIndex: {}
};
var proto = MagicType.prototype;

proto.getIcons = function () {
  var model = this.model;
  var availableIcons = model.get('icon');
  var icons = {};
  zrUtil.each(model.get('type'), function (type) {
    if (availableIcons[type]) {
      icons[type] = availableIcons[type];
    }
  });
  return icons;
};

var seriesOptGenreator = {
  'line': function (seriesType, seriesId, seriesModel, model) {
    if (seriesType === 'bar') {
      return zrUtil.merge({
        id: seriesId,
        type: 'line',
        // Preserve data related option
        data: seriesModel.get('data'),
        stack: seriesModel.get('stack'),
        markPoint: seriesModel.get('markPoint'),
        markLine: seriesModel.get('markLine')
      }, model.get('option.line') || {}, true);
    }
  },
  'bar': function (seriesType, seriesId, seriesModel, model) {
    if (seriesType === 'line') {
      return zrUtil.merge({
        id: seriesId,
        type: 'bar',
        // Preserve data related option
        data: seriesModel.get('data'),
        stack: seriesModel.get('stack'),
        markPoint: seriesModel.get('markPoint'),
        markLine: seriesModel.get('markLine')
      }, model.get('option.bar') || {}, true);
    }
  },
  'stack': function (seriesType, seriesId, seriesModel, model) {
    var isStack = seriesModel.get('stack') === INNER_STACK_KEYWORD;

    if (seriesType === 'line' || seriesType === 'bar') {
      model.setIconStatus('stack', isStack ? 'normal' : 'emphasis');
      return zrUtil.merge({
        id: seriesId,
        stack: isStack ? '' : INNER_STACK_KEYWORD
      }, model.get('option.stack') || {}, true);
    }
  }
};
var radioTypes = [['line', 'bar'], ['stack']];

proto.onclick = function (ecModel, api, type) {
  var model = this.model;
  var seriesIndex = model.get('seriesIndex.' + type); // Not supported magicType

  if (!seriesOptGenreator[type]) {
    return;
  }

  var newOption = {
    series: []
  };

  var generateNewSeriesTypes = function (seriesModel) {
    var seriesType = seriesModel.subType;
    var seriesId = seriesModel.id;
    var newSeriesOpt = seriesOptGenreator[type](seriesType, seriesId, seriesModel, model);

    if (newSeriesOpt) {
      // PENDING If merge original option?
      zrUtil.defaults(newSeriesOpt, seriesModel.option);
      newOption.series.push(newSeriesOpt);
    } // Modify boundaryGap


    var coordSys = seriesModel.coordinateSystem;

    if (coordSys && coordSys.type === 'cartesian2d' && (type === 'line' || type === 'bar')) {
      var categoryAxis = coordSys.getAxesByScale('ordinal')[0];

      if (categoryAxis) {
        var axisDim = categoryAxis.dim;
        var axisType = axisDim + 'Axis';
        var axisModel = ecModel.queryComponents({
          mainType: axisType,
          index: seriesModel.get(name + 'Index'),
          id: seriesModel.get(name + 'Id')
        })[0];
        var axisIndex = axisModel.componentIndex;
        newOption[axisType] = newOption[axisType] || [];

        for (var i = 0; i <= axisIndex; i++) {
          newOption[axisType][axisIndex] = newOption[axisType][axisIndex] || {};
        }

        newOption[axisType][axisIndex].boundaryGap = type === 'bar';
      }
    }
  };

  zrUtil.each(radioTypes, function (radio) {
    if (zrUtil.indexOf(radio, type) >= 0) {
      zrUtil.each(radio, function (item) {
        model.setIconStatus(item, 'normal');
      });
    }
  });
  model.setIconStatus(type, 'emphasis');
  ecModel.eachComponent({
    mainType: 'series',
    query: seriesIndex == null ? null : {
      seriesIndex: seriesIndex
    }
  }, generateNewSeriesTypes);
  var newTitle; // Change title of stack

  if (type === 'stack') {
    var isStack = newOption.series && newOption.series[0] && newOption.series[0].stack === INNER_STACK_KEYWORD;
    newTitle = isStack ? zrUtil.merge({
      stack: magicTypeLang.title.tiled
    }, magicTypeLang.title) : zrUtil.clone(magicTypeLang.title);
  }

  api.dispatchAction({
    type: 'changeMagicType',
    currentType: type,
    newOption: newOption,
    newTitle: newTitle,
    featureName: 'magicType'
  });
};

echarts.registerAction({
  type: 'changeMagicType',
  event: 'magicTypeChanged',
  update: 'prepareAndUpdate'
}, function (payload, ecModel) {
  ecModel.mergeOption(payload.newOption);
});
featureManager.register('magicType', MagicType);
var _default = MagicType;
module.exports = _default;

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var eventTool = __webpack_require__(121);

var lang = __webpack_require__(149);

var featureManager = __webpack_require__(152);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var dataViewLang = lang.toolbox.dataView;
var BLOCK_SPLITER = new Array(60).join('-');
var ITEM_SPLITER = '\t';
/**
 * Group series into two types
 *  1. on category axis, like line, bar
 *  2. others, like scatter, pie
 * @param {module:echarts/model/Global} ecModel
 * @return {Object}
 * @inner
 */

function groupSeries(ecModel) {
  var seriesGroupByCategoryAxis = {};
  var otherSeries = [];
  var meta = [];
  ecModel.eachRawSeries(function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys && (coordSys.type === 'cartesian2d' || coordSys.type === 'polar')) {
      var baseAxis = coordSys.getBaseAxis();

      if (baseAxis.type === 'category') {
        var key = baseAxis.dim + '_' + baseAxis.index;

        if (!seriesGroupByCategoryAxis[key]) {
          seriesGroupByCategoryAxis[key] = {
            categoryAxis: baseAxis,
            valueAxis: coordSys.getOtherAxis(baseAxis),
            series: []
          };
          meta.push({
            axisDim: baseAxis.dim,
            axisIndex: baseAxis.index
          });
        }

        seriesGroupByCategoryAxis[key].series.push(seriesModel);
      } else {
        otherSeries.push(seriesModel);
      }
    } else {
      otherSeries.push(seriesModel);
    }
  });
  return {
    seriesGroupByCategoryAxis: seriesGroupByCategoryAxis,
    other: otherSeries,
    meta: meta
  };
}
/**
 * Assemble content of series on cateogory axis
 * @param {Array.<module:echarts/model/Series>} series
 * @return {string}
 * @inner
 */


function assembleSeriesWithCategoryAxis(series) {
  var tables = [];
  zrUtil.each(series, function (group, key) {
    var categoryAxis = group.categoryAxis;
    var valueAxis = group.valueAxis;
    var valueAxisDim = valueAxis.dim;
    var headers = [' '].concat(zrUtil.map(group.series, function (series) {
      return series.name;
    }));
    var columns = [categoryAxis.model.getCategories()];
    zrUtil.each(group.series, function (series) {
      var rawData = series.getRawData();
      columns.push(series.getRawData().mapArray(rawData.mapDimension(valueAxisDim), function (val) {
        return val;
      }));
    }); // Assemble table content

    var lines = [headers.join(ITEM_SPLITER)];

    for (var i = 0; i < columns[0].length; i++) {
      var items = [];

      for (var j = 0; j < columns.length; j++) {
        items.push(columns[j][i]);
      }

      lines.push(items.join(ITEM_SPLITER));
    }

    tables.push(lines.join('\n'));
  });
  return tables.join('\n\n' + BLOCK_SPLITER + '\n\n');
}
/**
 * Assemble content of other series
 * @param {Array.<module:echarts/model/Series>} series
 * @return {string}
 * @inner
 */


function assembleOtherSeries(series) {
  return zrUtil.map(series, function (series) {
    var data = series.getRawData();
    var lines = [series.name];
    var vals = [];
    data.each(data.dimensions, function () {
      var argLen = arguments.length;
      var dataIndex = arguments[argLen - 1];
      var name = data.getName(dataIndex);

      for (var i = 0; i < argLen - 1; i++) {
        vals[i] = arguments[i];
      }

      lines.push((name ? name + ITEM_SPLITER : '') + vals.join(ITEM_SPLITER));
    });
    return lines.join('\n');
  }).join('\n\n' + BLOCK_SPLITER + '\n\n');
}
/**
 * @param {module:echarts/model/Global}
 * @return {Object}
 * @inner
 */


function getContentFromModel(ecModel) {
  var result = groupSeries(ecModel);
  return {
    value: zrUtil.filter([assembleSeriesWithCategoryAxis(result.seriesGroupByCategoryAxis), assembleOtherSeries(result.other)], function (str) {
      return str.replace(/[\n\t\s]/g, '');
    }).join('\n\n' + BLOCK_SPLITER + '\n\n'),
    meta: result.meta
  };
}

function trim(str) {
  return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
}
/**
 * If a block is tsv format
 */


function isTSVFormat(block) {
  // Simple method to find out if a block is tsv format
  var firstLine = block.slice(0, block.indexOf('\n'));

  if (firstLine.indexOf(ITEM_SPLITER) >= 0) {
    return true;
  }
}

var itemSplitRegex = new RegExp('[' + ITEM_SPLITER + ']+', 'g');
/**
 * @param {string} tsv
 * @return {Object}
 */

function parseTSVContents(tsv) {
  var tsvLines = tsv.split(/\n+/g);
  var headers = trim(tsvLines.shift()).split(itemSplitRegex);
  var categories = [];
  var series = zrUtil.map(headers, function (header) {
    return {
      name: header,
      data: []
    };
  });

  for (var i = 0; i < tsvLines.length; i++) {
    var items = trim(tsvLines[i]).split(itemSplitRegex);
    categories.push(items.shift());

    for (var j = 0; j < items.length; j++) {
      series[j] && (series[j].data[i] = items[j]);
    }
  }

  return {
    series: series,
    categories: categories
  };
}
/**
 * @param {string} str
 * @return {Array.<Object>}
 * @inner
 */


function parseListContents(str) {
  var lines = str.split(/\n+/g);
  var seriesName = trim(lines.shift());
  var data = [];

  for (var i = 0; i < lines.length; i++) {
    // if line is empty, ignore it.
    // there is a case that a user forgot to delete `\n`.
    var line = trim(lines[i]);

    if (!line) {
      continue;
    }

    var items = line.split(itemSplitRegex);
    var name = '';
    var value;
    var hasName = false;

    if (isNaN(items[0])) {
      // First item is name
      hasName = true;
      name = items[0];
      items = items.slice(1);
      data[i] = {
        name: name,
        value: []
      };
      value = data[i].value;
    } else {
      value = data[i] = [];
    }

    for (var j = 0; j < items.length; j++) {
      value.push(+items[j]);
    }

    if (value.length === 1) {
      hasName ? data[i].value = value[0] : data[i] = value[0];
    }
  }

  return {
    name: seriesName,
    data: data
  };
}
/**
 * @param {string} str
 * @param {Array.<Object>} blockMetaList
 * @return {Object}
 * @inner
 */


function parseContents(str, blockMetaList) {
  var blocks = str.split(new RegExp('\n*' + BLOCK_SPLITER + '\n*', 'g'));
  var newOption = {
    series: []
  };
  zrUtil.each(blocks, function (block, idx) {
    if (isTSVFormat(block)) {
      var result = parseTSVContents(block);
      var blockMeta = blockMetaList[idx];
      var axisKey = blockMeta.axisDim + 'Axis';

      if (blockMeta) {
        newOption[axisKey] = newOption[axisKey] || [];
        newOption[axisKey][blockMeta.axisIndex] = {
          data: result.categories
        };
        newOption.series = newOption.series.concat(result.series);
      }
    } else {
      var result = parseListContents(block);
      newOption.series.push(result);
    }
  });
  return newOption;
}
/**
 * @alias {module:echarts/component/toolbox/feature/DataView}
 * @constructor
 * @param {module:echarts/model/Model} model
 */


function DataView(model) {
  this._dom = null;
  this.model = model;
}

DataView.defaultOption = {
  show: true,
  readOnly: false,
  optionToContent: null,
  contentToOption: null,
  icon: 'M17.5,17.3H33 M17.5,17.3H33 M45.4,29.5h-28 M11.5,2v56H51V14.8L38.4,2H11.5z M38.4,2.2v12.7H51 M45.4,41.7h-28',
  title: zrUtil.clone(dataViewLang.title),
  lang: zrUtil.clone(dataViewLang.lang),
  backgroundColor: '#fff',
  textColor: '#000',
  textareaColor: '#fff',
  textareaBorderColor: '#333',
  buttonColor: '#c23531',
  buttonTextColor: '#fff'
};

DataView.prototype.onclick = function (ecModel, api) {
  var container = api.getDom();
  var model = this.model;

  if (this._dom) {
    container.removeChild(this._dom);
  }

  var root = document.createElement('div');
  root.style.cssText = 'position:absolute;left:5px;top:5px;bottom:5px;right:5px;';
  root.style.backgroundColor = model.get('backgroundColor') || '#fff'; // Create elements

  var header = document.createElement('h4');
  var lang = model.get('lang') || [];
  header.innerHTML = lang[0] || model.get('title');
  header.style.cssText = 'margin: 10px 20px;';
  header.style.color = model.get('textColor');
  var viewMain = document.createElement('div');
  var textarea = document.createElement('textarea');
  viewMain.style.cssText = 'display:block;width:100%;overflow:auto;';
  var optionToContent = model.get('optionToContent');
  var contentToOption = model.get('contentToOption');
  var result = getContentFromModel(ecModel);

  if (typeof optionToContent === 'function') {
    var htmlOrDom = optionToContent(api.getOption());

    if (typeof htmlOrDom === 'string') {
      viewMain.innerHTML = htmlOrDom;
    } else if (zrUtil.isDom(htmlOrDom)) {
      viewMain.appendChild(htmlOrDom);
    }
  } else {
    // Use default textarea
    viewMain.appendChild(textarea);
    textarea.readOnly = model.get('readOnly');
    textarea.style.cssText = 'width:100%;height:100%;font-family:monospace;font-size:14px;line-height:1.6rem;';
    textarea.style.color = model.get('textColor');
    textarea.style.borderColor = model.get('textareaBorderColor');
    textarea.style.backgroundColor = model.get('textareaColor');
    textarea.value = result.value;
  }

  var blockMetaList = result.meta;
  var buttonContainer = document.createElement('div');
  buttonContainer.style.cssText = 'position:absolute;bottom:0;left:0;right:0;';
  var buttonStyle = 'float:right;margin-right:20px;border:none;' + 'cursor:pointer;padding:2px 5px;font-size:12px;border-radius:3px';
  var closeButton = document.createElement('div');
  var refreshButton = document.createElement('div');
  buttonStyle += ';background-color:' + model.get('buttonColor');
  buttonStyle += ';color:' + model.get('buttonTextColor');
  var self = this;

  function close() {
    container.removeChild(root);
    self._dom = null;
  }

  eventTool.addEventListener(closeButton, 'click', close);
  eventTool.addEventListener(refreshButton, 'click', function () {
    var newOption;

    try {
      if (typeof contentToOption === 'function') {
        newOption = contentToOption(viewMain, api.getOption());
      } else {
        newOption = parseContents(textarea.value, blockMetaList);
      }
    } catch (e) {
      close();
      throw new Error('Data view format error ' + e);
    }

    if (newOption) {
      api.dispatchAction({
        type: 'changeDataView',
        newOption: newOption
      });
    }

    close();
  });
  closeButton.innerHTML = lang[1];
  refreshButton.innerHTML = lang[2];
  refreshButton.style.cssText = buttonStyle;
  closeButton.style.cssText = buttonStyle;
  !model.get('readOnly') && buttonContainer.appendChild(refreshButton);
  buttonContainer.appendChild(closeButton);
  root.appendChild(header);
  root.appendChild(viewMain);
  root.appendChild(buttonContainer);
  viewMain.style.height = container.clientHeight - 80 + 'px';
  container.appendChild(root);
  this._dom = root;
};

DataView.prototype.remove = function (ecModel, api) {
  this._dom && api.getDom().removeChild(this._dom);
};

DataView.prototype.dispose = function (ecModel, api) {
  this.remove(ecModel, api);
};
/**
 * @inner
 */


function tryMergeDataOption(newData, originalData) {
  return zrUtil.map(newData, function (newVal, idx) {
    var original = originalData && originalData[idx];

    if (zrUtil.isObject(original) && !zrUtil.isArray(original)) {
      var newValIsObject = zrUtil.isObject(newVal) && !zrUtil.isArray(newVal);

      if (!newValIsObject) {
        newVal = {
          value: newVal
        };
      } // original data has name but new data has no name


      var shouldDeleteName = original.name != null && newVal.name == null; // Original data has option

      newVal = zrUtil.defaults(newVal, original);
      shouldDeleteName && delete newVal.name;
      return newVal;
    } else {
      return newVal;
    }
  });
}

featureManager.register('dataView', DataView);
echarts.registerAction({
  type: 'changeDataView',
  event: 'dataViewChanged',
  update: 'prepareAndUpdate'
}, function (payload, ecModel) {
  var newSeriesOptList = [];
  zrUtil.each(payload.newOption.series, function (seriesOpt) {
    var seriesModel = ecModel.getSeriesByName(seriesOpt.name)[0];

    if (!seriesModel) {
      // New created series
      // Geuss the series type
      newSeriesOptList.push(zrUtil.extend({
        // Default is scatter
        type: 'scatter'
      }, seriesOpt));
    } else {
      var originalData = seriesModel.get('data');
      newSeriesOptList.push({
        name: seriesOpt.name,
        data: tryMergeDataOption(seriesOpt.data, originalData)
      });
    }
  });
  ecModel.mergeOption(zrUtil.defaults({
    series: newSeriesOptList
  }, payload.newOption));
});
var _default = DataView;
module.exports = _default;

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var BrushController = __webpack_require__(425);

var BrushTargetManager = __webpack_require__(679);

var history = __webpack_require__(680);

var sliderMove = __webpack_require__(210);

var lang = __webpack_require__(149);

var featureManager = __webpack_require__(152);

__webpack_require__(1758);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Use dataZoomSelect
var dataZoomLang = lang.toolbox.dataZoom;
var each = zrUtil.each; // Spectial component id start with \0ec\0, see echarts/model/Global.js~hasInnerId

var DATA_ZOOM_ID_BASE = '\0_ec_\0toolbox-dataZoom_';

function DataZoom(model, ecModel, api) {
  /**
   * @private
   * @type {module:echarts/component/helper/BrushController}
   */
  (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this)).mount();
  /**
   * @private
   * @type {boolean}
   */

  this._isZoomActive;
}

DataZoom.defaultOption = {
  show: true,
  filterMode: 'filter',
  // Icon group
  icon: {
    zoom: 'M0,13.5h26.9 M13.5,26.9V0 M32.1,13.5H58V58H13.5 V32.1',
    back: 'M22,1.4L9.9,13.5l12.3,12.3 M10.3,13.5H54.9v44.6 H10.3v-26'
  },
  // `zoom`, `back`
  title: zrUtil.clone(dataZoomLang.title),
  brushStyle: {
    borderWidth: 0,
    color: 'rgba(0,0,0,0.2)'
  }
};
var proto = DataZoom.prototype;

proto.render = function (featureModel, ecModel, api, payload) {
  this.model = featureModel;
  this.ecModel = ecModel;
  this.api = api;
  updateZoomBtnStatus(featureModel, ecModel, this, payload, api);
  updateBackBtnStatus(featureModel, ecModel);
};

proto.onclick = function (ecModel, api, type) {
  handlers[type].call(this);
};

proto.remove = function (ecModel, api) {
  this._brushController.unmount();
};

proto.dispose = function (ecModel, api) {
  this._brushController.dispose();
};
/**
 * @private
 */


var handlers = {
  zoom: function () {
    var nextActive = !this._isZoomActive;
    this.api.dispatchAction({
      type: 'takeGlobalCursor',
      key: 'dataZoomSelect',
      dataZoomSelectActive: nextActive
    });
  },
  back: function () {
    this._dispatchZoomAction(history.pop(this.ecModel));
  }
};
/**
 * @private
 */

proto._onBrush = function (areas, opt) {
  if (!opt.isEnd || !areas.length) {
    return;
  }

  var snapshot = {};
  var ecModel = this.ecModel;

  this._brushController.updateCovers([]); // remove cover


  var brushTargetManager = new BrushTargetManager(retrieveAxisSetting(this.model.option), ecModel, {
    include: ['grid']
  });
  brushTargetManager.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
    if (coordSys.type !== 'cartesian2d') {
      return;
    }

    var brushType = area.brushType;

    if (brushType === 'rect') {
      setBatch('x', coordSys, coordRange[0]);
      setBatch('y', coordSys, coordRange[1]);
    } else {
      setBatch({
        lineX: 'x',
        lineY: 'y'
      }[brushType], coordSys, coordRange);
    }
  });
  history.push(ecModel, snapshot);

  this._dispatchZoomAction(snapshot);

  function setBatch(dimName, coordSys, minMax) {
    var axis = coordSys.getAxis(dimName);
    var axisModel = axis.model;
    var dataZoomModel = findDataZoom(dimName, axisModel, ecModel); // Restrict range.

    var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy(axisModel).getMinMaxSpan();

    if (minMaxSpan.minValueSpan != null || minMaxSpan.maxValueSpan != null) {
      minMax = sliderMove(0, minMax.slice(), axis.scale.getExtent(), 0, minMaxSpan.minValueSpan, minMaxSpan.maxValueSpan);
    }

    dataZoomModel && (snapshot[dataZoomModel.id] = {
      dataZoomId: dataZoomModel.id,
      startValue: minMax[0],
      endValue: minMax[1]
    });
  }

  function findDataZoom(dimName, axisModel, ecModel) {
    var found;
    ecModel.eachComponent({
      mainType: 'dataZoom',
      subType: 'select'
    }, function (dzModel) {
      var has = dzModel.getAxisModel(dimName, axisModel.componentIndex);
      has && (found = dzModel);
    });
    return found;
  }
};
/**
 * @private
 */


proto._dispatchZoomAction = function (snapshot) {
  var batch = []; // Convert from hash map to array.

  each(snapshot, function (batchItem, dataZoomId) {
    batch.push(zrUtil.clone(batchItem));
  });
  batch.length && this.api.dispatchAction({
    type: 'dataZoom',
    from: this.uid,
    batch: batch
  });
};

function retrieveAxisSetting(option) {
  var setting = {}; // Compatible with previous setting: null => all axis, false => no axis.

  zrUtil.each(['xAxisIndex', 'yAxisIndex'], function (name) {
    setting[name] = option[name];
    setting[name] == null && (setting[name] = 'all');
    (setting[name] === false || setting[name] === 'none') && (setting[name] = []);
  });
  return setting;
}

function updateBackBtnStatus(featureModel, ecModel) {
  featureModel.setIconStatus('back', history.count(ecModel) > 1 ? 'emphasis' : 'normal');
}

function updateZoomBtnStatus(featureModel, ecModel, view, payload, api) {
  var zoomActive = view._isZoomActive;

  if (payload && payload.type === 'takeGlobalCursor') {
    zoomActive = payload.key === 'dataZoomSelect' ? payload.dataZoomSelectActive : false;
  }

  view._isZoomActive = zoomActive;
  featureModel.setIconStatus('zoom', zoomActive ? 'emphasis' : 'normal');
  var brushTargetManager = new BrushTargetManager(retrieveAxisSetting(featureModel.option), ecModel, {
    include: ['grid']
  });

  view._brushController.setPanels(brushTargetManager.makePanelOpts(api, function (targetInfo) {
    return targetInfo.xAxisDeclared && !targetInfo.yAxisDeclared ? 'lineX' : !targetInfo.xAxisDeclared && targetInfo.yAxisDeclared ? 'lineY' : 'rect';
  })).enableBrush(zoomActive ? {
    brushType: 'auto',
    brushStyle: featureModel.getModel('brushStyle').getItemStyle()
  } : false);
}

featureManager.register('dataZoom', DataZoom); // Create special dataZoom option for select
// FIXME consider the case of merge option, where axes options are not exists.

echarts.registerPreprocessor(function (option) {
  if (!option) {
    return;
  }

  var dataZoomOpts = option.dataZoom || (option.dataZoom = []);

  if (!zrUtil.isArray(dataZoomOpts)) {
    option.dataZoom = dataZoomOpts = [dataZoomOpts];
  }

  var toolboxOpt = option.toolbox;

  if (toolboxOpt) {
    // Assume there is only one toolbox
    if (zrUtil.isArray(toolboxOpt)) {
      toolboxOpt = toolboxOpt[0];
    }

    if (toolboxOpt && toolboxOpt.feature) {
      var dataZoomOpt = toolboxOpt.feature.dataZoom; // FIXME: If add dataZoom when setOption in merge mode,
      // no axis info to be added. See `test/dataZoom-extreme.html`

      addForAxis('xAxis', dataZoomOpt);
      addForAxis('yAxis', dataZoomOpt);
    }
  }

  function addForAxis(axisName, dataZoomOpt) {
    if (!dataZoomOpt) {
      return;
    } // Try not to modify model, because it is not merged yet.


    var axisIndicesName = axisName + 'Index';
    var givenAxisIndices = dataZoomOpt[axisIndicesName];

    if (givenAxisIndices != null && givenAxisIndices !== 'all' && !zrUtil.isArray(givenAxisIndices)) {
      givenAxisIndices = givenAxisIndices === false || givenAxisIndices === 'none' ? [] : [givenAxisIndices];
    }

    forEachComponent(axisName, function (axisOpt, axisIndex) {
      if (givenAxisIndices != null && givenAxisIndices !== 'all' && zrUtil.indexOf(givenAxisIndices, axisIndex) === -1) {
        return;
      }

      var newOpt = {
        type: 'select',
        $fromToolbox: true,
        // Default to be filter
        filterMode: dataZoomOpt.filterMode || 'filter',
        // Id for merge mapping.
        id: DATA_ZOOM_ID_BASE + axisName + axisIndex
      }; // FIXME
      // Only support one axis now.

      newOpt[axisIndicesName] = axisIndex;
      dataZoomOpts.push(newOpt);
    });
  }

  function forEachComponent(mainType, cb) {
    var opts = option[mainType];

    if (!zrUtil.isArray(opts)) {
      opts = opts ? [opts] : [];
    }

    each(opts, cb);
  }
});
var _default = DataZoom;
module.exports = _default;

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

__webpack_require__(428);

__webpack_require__(211);

__webpack_require__(212);

__webpack_require__(1760);

__webpack_require__(1761);

__webpack_require__(430);

__webpack_require__(431);

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var numberUtil = __webpack_require__(37);

var helper = __webpack_require__(429);

var sliderMove = __webpack_require__(210);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var each = zrUtil.each;
var asc = numberUtil.asc;
/**
 * Operate single axis.
 * One axis can only operated by one axis operator.
 * Different dataZoomModels may be defined to operate the same axis.
 * (i.e. 'inside' data zoom and 'slider' data zoom components)
 * So dataZoomModels share one axisProxy in that case.
 *
 * @class
 */

var AxisProxy = function (dimName, axisIndex, dataZoomModel, ecModel) {
  /**
   * @private
   * @type {string}
   */
  this._dimName = dimName;
  /**
   * @private
   */

  this._axisIndex = axisIndex;
  /**
   * @private
   * @type {Array.<number>}
   */

  this._valueWindow;
  /**
   * @private
   * @type {Array.<number>}
   */

  this._percentWindow;
  /**
   * @private
   * @type {Array.<number>}
   */

  this._dataExtent;
  /**
   * {minSpan, maxSpan, minValueSpan, maxValueSpan}
   * @private
   * @type {Object}
   */

  this._minMaxSpan;
  /**
   * @readOnly
   * @type {module: echarts/model/Global}
   */

  this.ecModel = ecModel;
  /**
   * @private
   * @type {module: echarts/component/dataZoom/DataZoomModel}
   */

  this._dataZoomModel = dataZoomModel; // /**
  //  * @readOnly
  //  * @private
  //  */
  // this.hasSeriesStacked;
};

AxisProxy.prototype = {
  constructor: AxisProxy,

  /**
   * Whether the axisProxy is hosted by dataZoomModel.
   *
   * @public
   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
   * @return {boolean}
   */
  hostedBy: function (dataZoomModel) {
    return this._dataZoomModel === dataZoomModel;
  },

  /**
   * @return {Array.<number>} Value can only be NaN or finite value.
   */
  getDataValueWindow: function () {
    return this._valueWindow.slice();
  },

  /**
   * @return {Array.<number>}
   */
  getDataPercentWindow: function () {
    return this._percentWindow.slice();
  },

  /**
   * @public
   * @param {number} axisIndex
   * @return {Array} seriesModels
   */
  getTargetSeriesModels: function () {
    var seriesModels = [];
    var ecModel = this.ecModel;
    ecModel.eachSeries(function (seriesModel) {
      if (helper.isCoordSupported(seriesModel.get('coordinateSystem'))) {
        var dimName = this._dimName;
        var axisModel = ecModel.queryComponents({
          mainType: dimName + 'Axis',
          index: seriesModel.get(dimName + 'AxisIndex'),
          id: seriesModel.get(dimName + 'AxisId')
        })[0];

        if (this._axisIndex === (axisModel && axisModel.componentIndex)) {
          seriesModels.push(seriesModel);
        }
      }
    }, this);
    return seriesModels;
  },
  getAxisModel: function () {
    return this.ecModel.getComponent(this._dimName + 'Axis', this._axisIndex);
  },
  getOtherAxisModel: function () {
    var axisDim = this._dimName;
    var ecModel = this.ecModel;
    var axisModel = this.getAxisModel();
    var isCartesian = axisDim === 'x' || axisDim === 'y';
    var otherAxisDim;
    var coordSysIndexName;

    if (isCartesian) {
      coordSysIndexName = 'gridIndex';
      otherAxisDim = axisDim === 'x' ? 'y' : 'x';
    } else {
      coordSysIndexName = 'polarIndex';
      otherAxisDim = axisDim === 'angle' ? 'radius' : 'angle';
    }

    var foundOtherAxisModel;
    ecModel.eachComponent(otherAxisDim + 'Axis', function (otherAxisModel) {
      if ((otherAxisModel.get(coordSysIndexName) || 0) === (axisModel.get(coordSysIndexName) || 0)) {
        foundOtherAxisModel = otherAxisModel;
      }
    });
    return foundOtherAxisModel;
  },
  getMinMaxSpan: function () {
    return zrUtil.clone(this._minMaxSpan);
  },

  /**
   * Only calculate by given range and this._dataExtent, do not change anything.
   *
   * @param {Object} opt
   * @param {number} [opt.start]
   * @param {number} [opt.end]
   * @param {number} [opt.startValue]
   * @param {number} [opt.endValue]
   */
  calculateDataWindow: function (opt) {
    var dataExtent = this._dataExtent;
    var axisModel = this.getAxisModel();
    var scale = axisModel.axis.scale;

    var rangePropMode = this._dataZoomModel.getRangePropMode();

    var percentExtent = [0, 100];
    var percentWindow = [];
    var valueWindow = [];
    var hasPropModeValue;
    each(['start', 'end'], function (prop, idx) {
      var boundPercent = opt[prop];
      var boundValue = opt[prop + 'Value']; // Notice: dataZoom is based either on `percentProp` ('start', 'end') or
      // on `valueProp` ('startValue', 'endValue'). (They are based on the data extent
      // but not min/max of axis, which will be calculated by data window then).
      // The former one is suitable for cases that a dataZoom component controls multiple
      // axes with different unit or extent, and the latter one is suitable for accurate
      // zoom by pixel (e.g., in dataZoomSelect).
      // we use `getRangePropMode()` to mark which prop is used. `rangePropMode` is updated
      // only when setOption or dispatchAction, otherwise it remains its original value.
      // (Why not only record `percentProp` and always map to `valueProp`? Because
      // the map `valueProp` -> `percentProp` -> `valueProp` probably not the original
      // `valueProp`. consider two axes constrolled by one dataZoom. They have different
      // data extent. All of values that are overflow the `dataExtent` will be calculated
      // to percent '100%').

      if (rangePropMode[idx] === 'percent') {
        boundPercent == null && (boundPercent = percentExtent[idx]); // Use scale.parse to math round for category or time axis.

        boundValue = scale.parse(numberUtil.linearMap(boundPercent, percentExtent, dataExtent));
      } else {
        hasPropModeValue = true;
        boundValue = boundValue == null ? dataExtent[idx] : scale.parse(boundValue); // Calculating `percent` from `value` may be not accurate, because
        // This calculation can not be inversed, because all of values that
        // are overflow the `dataExtent` will be calculated to percent '100%'

        boundPercent = numberUtil.linearMap(boundValue, dataExtent, percentExtent);
      } // valueWindow[idx] = round(boundValue);
      // percentWindow[idx] = round(boundPercent);


      valueWindow[idx] = boundValue;
      percentWindow[idx] = boundPercent;
    });
    asc(valueWindow);
    asc(percentWindow); // The windows from user calling of `dispatchAction` might be out of the extent,
    // or do not obey the `min/maxSpan`, `min/maxValueSpan`. But we dont restrict window
    // by `zoomLock` here, because we see `zoomLock` just as a interaction constraint,
    // where API is able to initialize/modify the window size even though `zoomLock`
    // specified.

    var spans = this._minMaxSpan;
    hasPropModeValue ? restrictSet(valueWindow, percentWindow, dataExtent, percentExtent, false) : restrictSet(percentWindow, valueWindow, percentExtent, dataExtent, true);

    function restrictSet(fromWindow, toWindow, fromExtent, toExtent, toValue) {
      var suffix = toValue ? 'Span' : 'ValueSpan';
      sliderMove(0, fromWindow, fromExtent, 'all', spans['min' + suffix], spans['max' + suffix]);

      for (var i = 0; i < 2; i++) {
        toWindow[i] = numberUtil.linearMap(fromWindow[i], fromExtent, toExtent, true);
        toValue && (toWindow[i] = scale.parse(toWindow[i]));
      }
    }

    return {
      valueWindow: valueWindow,
      percentWindow: percentWindow
    };
  },

  /**
   * Notice: reset should not be called before series.restoreData() called,
   * so it is recommanded to be called in "process stage" but not "model init
   * stage".
   *
   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
   */
  reset: function (dataZoomModel) {
    if (dataZoomModel !== this._dataZoomModel) {
      return;
    }

    var targetSeries = this.getTargetSeriesModels(); // Culculate data window and data extent, and record them.

    this._dataExtent = calculateDataExtent(this, this._dimName, targetSeries); // this.hasSeriesStacked = false;
    // each(targetSeries, function (series) {
    // var data = series.getData();
    // var dataDim = data.mapDimension(this._dimName);
    // var stackedDimension = data.getCalculationInfo('stackedDimension');
    // if (stackedDimension && stackedDimension === dataDim) {
    // this.hasSeriesStacked = true;
    // }
    // }, this);
    // `calculateDataWindow` uses min/maxSpan.

    setMinMaxSpan(this);
    var dataWindow = this.calculateDataWindow(dataZoomModel.settledOption);
    this._valueWindow = dataWindow.valueWindow;
    this._percentWindow = dataWindow.percentWindow; // Update axis setting then.

    setAxisModel(this);
  },

  /**
   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
   */
  restore: function (dataZoomModel) {
    if (dataZoomModel !== this._dataZoomModel) {
      return;
    }

    this._valueWindow = this._percentWindow = null;
    setAxisModel(this, true);
  },

  /**
   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
   */
  filterData: function (dataZoomModel, api) {
    if (dataZoomModel !== this._dataZoomModel) {
      return;
    }

    var axisDim = this._dimName;
    var seriesModels = this.getTargetSeriesModels();
    var filterMode = dataZoomModel.get('filterMode');
    var valueWindow = this._valueWindow;

    if (filterMode === 'none') {
      return;
    } // FIXME
    // Toolbox may has dataZoom injected. And if there are stacked bar chart
    // with NaN data, NaN will be filtered and stack will be wrong.
    // So we need to force the mode to be set empty.
    // In fect, it is not a big deal that do not support filterMode-'filter'
    // when using toolbox#dataZoom, utill tooltip#dataZoom support "single axis
    // selection" some day, which might need "adapt to data extent on the
    // otherAxis", which is disabled by filterMode-'empty'.
    // But currently, stack has been fixed to based on value but not index,
    // so this is not an issue any more.
    // var otherAxisModel = this.getOtherAxisModel();
    // if (dataZoomModel.get('$fromToolbox')
    //     && otherAxisModel
    //     && otherAxisModel.hasSeriesStacked
    // ) {
    //     filterMode = 'empty';
    // }
    // TODO
    // filterMode 'weakFilter' and 'empty' is not optimized for huge data yet.


    each(seriesModels, function (seriesModel) {
      var seriesData = seriesModel.getData();
      var dataDims = seriesData.mapDimension(axisDim, true);

      if (!dataDims.length) {
        return;
      }

      if (filterMode === 'weakFilter') {
        seriesData.filterSelf(function (dataIndex) {
          var leftOut;
          var rightOut;
          var hasValue;

          for (var i = 0; i < dataDims.length; i++) {
            var value = seriesData.get(dataDims[i], dataIndex);
            var thisHasValue = !isNaN(value);
            var thisLeftOut = value < valueWindow[0];
            var thisRightOut = value > valueWindow[1];

            if (thisHasValue && !thisLeftOut && !thisRightOut) {
              return true;
            }

            thisHasValue && (hasValue = true);
            thisLeftOut && (leftOut = true);
            thisRightOut && (rightOut = true);
          } // If both left out and right out, do not filter.


          return hasValue && leftOut && rightOut;
        });
      } else {
        each(dataDims, function (dim) {
          if (filterMode === 'empty') {
            seriesModel.setData(seriesData = seriesData.map(dim, function (value) {
              return !isInWindow(value) ? NaN : value;
            }));
          } else {
            var range = {};
            range[dim] = valueWindow; // console.time('select');

            seriesData.selectRange(range); // console.timeEnd('select');
          }
        });
      }

      each(dataDims, function (dim) {
        seriesData.setApproximateExtent(valueWindow, dim);
      });
    });

    function isInWindow(value) {
      return value >= valueWindow[0] && value <= valueWindow[1];
    }
  }
};

function calculateDataExtent(axisProxy, axisDim, seriesModels) {
  var dataExtent = [Infinity, -Infinity];
  each(seriesModels, function (seriesModel) {
    var seriesData = seriesModel.getData();

    if (seriesData) {
      each(seriesData.mapDimension(axisDim, true), function (dim) {
        var seriesExtent = seriesData.getApproximateExtent(dim);
        seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
        seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
      });
    }
  });

  if (dataExtent[1] < dataExtent[0]) {
    dataExtent = [NaN, NaN];
  } // It is important to get "consistent" extent when more then one axes is
  // controlled by a `dataZoom`, otherwise those axes will not be synchronized
  // when zooming. But it is difficult to know what is "consistent", considering
  // axes have different type or even different meanings (For example, two
  // time axes are used to compare data of the same date in different years).
  // So basically dataZoom just obtains extent by series.data (in category axis
  // extent can be obtained from axis.data).
  // Nevertheless, user can set min/max/scale on axes to make extent of axes
  // consistent.


  fixExtentByAxis(axisProxy, dataExtent);
  return dataExtent;
}

function fixExtentByAxis(axisProxy, dataExtent) {
  var axisModel = axisProxy.getAxisModel();
  var min = axisModel.getMin(true); // For category axis, if min/max/scale are not set, extent is determined
  // by axis.data by default.

  var isCategoryAxis = axisModel.get('type') === 'category';
  var axisDataLen = isCategoryAxis && axisModel.getCategories().length;

  if (min != null && min !== 'dataMin' && typeof min !== 'function') {
    dataExtent[0] = min;
  } else if (isCategoryAxis) {
    dataExtent[0] = axisDataLen > 0 ? 0 : NaN;
  }

  var max = axisModel.getMax(true);

  if (max != null && max !== 'dataMax' && typeof max !== 'function') {
    dataExtent[1] = max;
  } else if (isCategoryAxis) {
    dataExtent[1] = axisDataLen > 0 ? axisDataLen - 1 : NaN;
  }

  if (!axisModel.get('scale', true)) {
    dataExtent[0] > 0 && (dataExtent[0] = 0);
    dataExtent[1] < 0 && (dataExtent[1] = 0);
  } // For value axis, if min/max/scale are not set, we just use the extent obtained
  // by series data, which may be a little different from the extent calculated by
  // `axisHelper.getScaleExtent`. But the different just affects the experience a
  // little when zooming. So it will not be fixed until some users require it strongly.


  return dataExtent;
}

function setAxisModel(axisProxy, isRestore) {
  var axisModel = axisProxy.getAxisModel();
  var percentWindow = axisProxy._percentWindow;
  var valueWindow = axisProxy._valueWindow;

  if (!percentWindow) {
    return;
  } // [0, 500]: arbitrary value, guess axis extent.


  var precision = numberUtil.getPixelPrecision(valueWindow, [0, 500]);
  precision = Math.min(precision, 20); // isRestore or isFull

  var useOrigin = isRestore || percentWindow[0] === 0 && percentWindow[1] === 100;
  axisModel.setRange(useOrigin ? null : +valueWindow[0].toFixed(precision), useOrigin ? null : +valueWindow[1].toFixed(precision));
}

function setMinMaxSpan(axisProxy) {
  var minMaxSpan = axisProxy._minMaxSpan = {};
  var dataZoomModel = axisProxy._dataZoomModel;
  var dataExtent = axisProxy._dataExtent;
  each(['min', 'max'], function (minMax) {
    var percentSpan = dataZoomModel.get(minMax + 'Span');
    var valueSpan = dataZoomModel.get(minMax + 'ValueSpan');
    valueSpan != null && (valueSpan = axisProxy.getAxisModel().axis.scale.parse(valueSpan)); // minValueSpan and maxValueSpan has higher priority than minSpan and maxSpan

    if (valueSpan != null) {
      percentSpan = numberUtil.linearMap(dataExtent[0] + valueSpan, dataExtent, [0, 100], true);
    } else if (percentSpan != null) {
      valueSpan = numberUtil.linearMap(percentSpan, [0, 100], dataExtent, true) - dataExtent[0];
    }

    minMaxSpan[minMax + 'Span'] = percentSpan;
    minMaxSpan[minMax + 'ValueSpan'] = valueSpan;
  });
}

var _default = AxisProxy;
module.exports = _default;

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var DataZoomModel = __webpack_require__(211);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = DataZoomModel.extend({
  type: 'dataZoom.select'
});

module.exports = _default;

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var DataZoomView = __webpack_require__(212);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = DataZoomView.extend({
  type: 'dataZoom.select'
});

module.exports = _default;

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var history = __webpack_require__(680);

var lang = __webpack_require__(149);

var featureManager = __webpack_require__(152);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var restoreLang = lang.toolbox.restore;

function Restore(model) {
  this.model = model;
}

Restore.defaultOption = {
  show: true,

  /* eslint-disable */
  icon: 'M3.8,33.4 M47,18.9h9.8V8.7 M56.3,20.1 C52.1,9,40.5,0.6,26.8,2.1C12.6,3.7,1.6,16.2,2.1,30.6 M13,41.1H3.1v10.2 M3.7,39.9c4.2,11.1,15.8,19.5,29.5,18 c14.2-1.6,25.2-14.1,24.7-28.5',

  /* eslint-enable */
  title: restoreLang.title
};
var proto = Restore.prototype;

proto.onclick = function (ecModel, api, type) {
  history.clear(ecModel);
  api.dispatchAction({
    type: 'restore',
    from: this.uid
  });
};

featureManager.register('restore', Restore);
echarts.registerAction({
  type: 'restore',
  event: 'restore',
  update: 'prepareAndUpdate'
}, function (payload, ecModel) {
  ecModel.resetOption('recreate');
});
var _default = Restore;
module.exports = _default;

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(246);

__webpack_require__(1764);

__webpack_require__(1765);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// FIXME Better way to pack data in graphic element

/**
 * @action
 * @property {string} type
 * @property {number} seriesIndex
 * @property {number} dataIndex
 * @property {number} [x]
 * @property {number} [y]
 */
echarts.registerAction({
  type: 'showTip',
  event: 'showTip',
  update: 'tooltip:manuallyShowTip'
}, // noop
function () {});
echarts.registerAction({
  type: 'hideTip',
  event: 'hideTip',
  update: 'tooltip:manuallyHideTip'
}, // noop
function () {});

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = echarts.extendComponentModel({
  type: 'tooltip',
  dependencies: ['axisPointer'],
  defaultOption: {
    zlevel: 0,
    z: 60,
    show: true,
    // tooltip主体内容
    showContent: true,
    // 'trigger' only works on coordinate system.
    // 'item' | 'axis' | 'none'
    trigger: 'item',
    // 'click' | 'mousemove' | 'none'
    triggerOn: 'mousemove|click',
    alwaysShowContent: false,
    displayMode: 'single',
    // 'single' | 'multipleByCoordSys'
    renderMode: 'auto',
    // 'auto' | 'html' | 'richText'
    // 'auto': use html by default, and use non-html if `document` is not defined
    // 'html': use html for tooltip
    // 'richText': use canvas, svg, and etc. for tooltip
    // 位置 {Array} | {Function}
    // position: null
    // Consider triggered from axisPointer handle, verticalAlign should be 'middle'
    // align: null,
    // verticalAlign: null,
    // 是否约束 content 在 viewRect 中。默认 false 是为了兼容以前版本。
    confine: false,
    // 内容格式器：{string}（Template） ¦ {Function}
    // formatter: null
    showDelay: 0,
    // 隐藏延迟，单位ms
    hideDelay: 100,
    // 动画变换时间，单位s
    transitionDuration: 0.4,
    enterable: false,
    // 提示背景颜色，默认为透明度为0.7的黑色
    backgroundColor: 'rgba(50,50,50,0.7)',
    // 提示边框颜色
    borderColor: '#333',
    // 提示边框圆角，单位px，默认为4
    borderRadius: 4,
    // 提示边框线宽，单位px，默认为0（无边框）
    borderWidth: 0,
    // 提示内边距，单位px，默认各方向内边距为5，
    // 接受数组分别设定上右下左边距，同css
    padding: 5,
    // Extra css text
    extraCssText: '',
    // 坐标轴指示器，坐标轴触发有效
    axisPointer: {
      // 默认为直线
      // 可选为：'line' | 'shadow' | 'cross'
      type: 'line',
      // type 为 line 的时候有效，指定 tooltip line 所在的轴，可选
      // 可选 'x' | 'y' | 'angle' | 'radius' | 'auto'
      // 默认 'auto'，会选择类型为 category 的轴，对于双数值轴，笛卡尔坐标系会默认选择 x 轴
      // 极坐标系会默认选择 angle 轴
      axis: 'auto',
      animation: 'auto',
      animationDurationUpdate: 200,
      animationEasingUpdate: 'exponentialOut',
      crossStyle: {
        color: '#999',
        width: 1,
        type: 'dashed',
        // TODO formatter
        textStyle: {} // lineStyle and shadowStyle should not be specified here,
        // otherwise it will always override those styles on option.axisPointer.

      }
    },
    textStyle: {
      color: '#fff',
      fontSize: 14
    }
  }
});

module.exports = _default;

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var env = __webpack_require__(67);

var TooltipContent = __webpack_require__(1766);

var TooltipRichContent = __webpack_require__(1767);

var formatUtil = __webpack_require__(54);

var numberUtil = __webpack_require__(37);

var graphic = __webpack_require__(27);

var findPointFromSeries = __webpack_require__(675);

var layoutUtil = __webpack_require__(53);

var Model = __webpack_require__(68);

var globalListener = __webpack_require__(676);

var axisHelper = __webpack_require__(109);

var axisPointerViewHelper = __webpack_require__(308);

var _model = __webpack_require__(44);

var getTooltipRenderMode = _model.getTooltipRenderMode;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var bind = zrUtil.bind;
var each = zrUtil.each;
var parsePercent = numberUtil.parsePercent;
var proxyRect = new graphic.Rect({
  shape: {
    x: -1,
    y: -1,
    width: 2,
    height: 2
  }
});

var _default = echarts.extendComponentView({
  type: 'tooltip',
  init: function (ecModel, api) {
    if (env.node) {
      return;
    }

    var tooltipModel = ecModel.getComponent('tooltip');
    var renderMode = tooltipModel.get('renderMode');
    this._renderMode = getTooltipRenderMode(renderMode);
    var tooltipContent;

    if (this._renderMode === 'html') {
      tooltipContent = new TooltipContent(api.getDom(), api, {
        appendToBody: tooltipModel.get('appendToBody', true)
      });
      this._newLine = '<br/>';
    } else {
      tooltipContent = new TooltipRichContent(api);
      this._newLine = '\n';
    }

    this._tooltipContent = tooltipContent;
  },
  render: function (tooltipModel, ecModel, api) {
    if (env.node) {
      return;
    } // Reset


    this.group.removeAll();
    /**
     * @private
     * @type {module:echarts/component/tooltip/TooltipModel}
     */

    this._tooltipModel = tooltipModel;
    /**
     * @private
     * @type {module:echarts/model/Global}
     */

    this._ecModel = ecModel;
    /**
     * @private
     * @type {module:echarts/ExtensionAPI}
     */

    this._api = api;
    /**
     * Should be cleaned when render.
     * @private
     * @type {Array.<Array.<Object>>}
     */

    this._lastDataByCoordSys = null;
    /**
     * @private
     * @type {boolean}
     */

    this._alwaysShowContent = tooltipModel.get('alwaysShowContent');
    var tooltipContent = this._tooltipContent;
    tooltipContent.update(tooltipModel);
    tooltipContent.setEnterable(tooltipModel.get('enterable'));

    this._initGlobalListener();

    this._keepShow();
  },
  _initGlobalListener: function () {
    var tooltipModel = this._tooltipModel;
    var triggerOn = tooltipModel.get('triggerOn');
    globalListener.register('itemTooltip', this._api, bind(function (currTrigger, e, dispatchAction) {
      // If 'none', it is not controlled by mouse totally.
      if (triggerOn !== 'none') {
        if (triggerOn.indexOf(currTrigger) >= 0) {
          this._tryShow(e, dispatchAction);
        } else if (currTrigger === 'leave') {
          this._hide(dispatchAction);
        }
      }
    }, this));
  },
  _keepShow: function () {
    var tooltipModel = this._tooltipModel;
    var ecModel = this._ecModel;
    var api = this._api; // Try to keep the tooltip show when refreshing

    if (this._lastX != null && this._lastY != null // When user is willing to control tooltip totally using API,
    // self.manuallyShowTip({x, y}) might cause tooltip hide,
    // which is not expected.
    && tooltipModel.get('triggerOn') !== 'none') {
      var self = this;
      clearTimeout(this._refreshUpdateTimeout);
      this._refreshUpdateTimeout = setTimeout(function () {
        // Show tip next tick after other charts are rendered
        // In case highlight action has wrong result
        // FIXME
        !api.isDisposed() && self.manuallyShowTip(tooltipModel, ecModel, api, {
          x: self._lastX,
          y: self._lastY
        });
      });
    }
  },

  /**
   * Show tip manually by
   * dispatchAction({
   *     type: 'showTip',
   *     x: 10,
   *     y: 10
   * });
   * Or
   * dispatchAction({
   *      type: 'showTip',
   *      seriesIndex: 0,
   *      dataIndex or dataIndexInside or name
   * });
   *
   *  TODO Batch
   */
  manuallyShowTip: function (tooltipModel, ecModel, api, payload) {
    if (payload.from === this.uid || env.node) {
      return;
    }

    var dispatchAction = makeDispatchAction(payload, api); // Reset ticket

    this._ticket = ''; // When triggered from axisPointer.

    var dataByCoordSys = payload.dataByCoordSys;

    if (payload.tooltip && payload.x != null && payload.y != null) {
      var el = proxyRect;
      el.position = [payload.x, payload.y];
      el.update();
      el.tooltip = payload.tooltip; // Manually show tooltip while view is not using zrender elements.

      this._tryShow({
        offsetX: payload.x,
        offsetY: payload.y,
        target: el
      }, dispatchAction);
    } else if (dataByCoordSys) {
      this._tryShow({
        offsetX: payload.x,
        offsetY: payload.y,
        position: payload.position,
        dataByCoordSys: payload.dataByCoordSys,
        tooltipOption: payload.tooltipOption
      }, dispatchAction);
    } else if (payload.seriesIndex != null) {
      if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) {
        return;
      }

      var pointInfo = findPointFromSeries(payload, ecModel);
      var cx = pointInfo.point[0];
      var cy = pointInfo.point[1];

      if (cx != null && cy != null) {
        this._tryShow({
          offsetX: cx,
          offsetY: cy,
          position: payload.position,
          target: pointInfo.el
        }, dispatchAction);
      }
    } else if (payload.x != null && payload.y != null) {
      // FIXME
      // should wrap dispatchAction like `axisPointer/globalListener` ?
      api.dispatchAction({
        type: 'updateAxisPointer',
        x: payload.x,
        y: payload.y
      });

      this._tryShow({
        offsetX: payload.x,
        offsetY: payload.y,
        position: payload.position,
        target: api.getZr().findHover(payload.x, payload.y).target
      }, dispatchAction);
    }
  },
  manuallyHideTip: function (tooltipModel, ecModel, api, payload) {
    var tooltipContent = this._tooltipContent;

    if (!this._alwaysShowContent && this._tooltipModel) {
      tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
    }

    this._lastX = this._lastY = null;

    if (payload.from !== this.uid) {
      this._hide(makeDispatchAction(payload, api));
    }
  },
  // Be compatible with previous design, that is, when tooltip.type is 'axis' and
  // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
  // and tooltip.
  _manuallyAxisShowTip: function (tooltipModel, ecModel, api, payload) {
    var seriesIndex = payload.seriesIndex;
    var dataIndex = payload.dataIndex;
    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;

    if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) {
      return;
    }

    var seriesModel = ecModel.getSeriesByIndex(seriesIndex);

    if (!seriesModel) {
      return;
    }

    var data = seriesModel.getData();
    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), seriesModel, (seriesModel.coordinateSystem || {}).model, tooltipModel]);

    if (tooltipModel.get('trigger') !== 'axis') {
      return;
    }

    api.dispatchAction({
      type: 'updateAxisPointer',
      seriesIndex: seriesIndex,
      dataIndex: dataIndex,
      position: payload.position
    });
    return true;
  },
  _tryShow: function (e, dispatchAction) {
    var el = e.target;
    var tooltipModel = this._tooltipModel;

    if (!tooltipModel) {
      return;
    } // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed


    this._lastX = e.offsetX;
    this._lastY = e.offsetY;
    var dataByCoordSys = e.dataByCoordSys;

    if (dataByCoordSys && dataByCoordSys.length) {
      this._showAxisTooltip(dataByCoordSys, e);
    } // Always show item tooltip if mouse is on the element with dataIndex
    else if (el && el.dataIndex != null) {
        this._lastDataByCoordSys = null;

        this._showSeriesItemTooltip(e, el, dispatchAction);
      } // Tooltip provided directly. Like legend.
      else if (el && el.tooltip) {
          this._lastDataByCoordSys = null;

          this._showComponentItemTooltip(e, el, dispatchAction);
        } else {
          this._lastDataByCoordSys = null;

          this._hide(dispatchAction);
        }
  },
  _showOrMove: function (tooltipModel, cb) {
    // showDelay is used in this case: tooltip.enterable is set
    // as true. User intent to move mouse into tooltip and click
    // something. `showDelay` makes it easier to enter the content
    // but tooltip do not move immediately.
    var delay = tooltipModel.get('showDelay');
    cb = zrUtil.bind(cb, this);
    clearTimeout(this._showTimout);
    delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
  },
  _showAxisTooltip: function (dataByCoordSys, e) {
    var ecModel = this._ecModel;
    var globalTooltipModel = this._tooltipModel;
    var point = [e.offsetX, e.offsetY];
    var singleDefaultHTML = [];
    var singleParamsList = [];
    var singleTooltipModel = buildTooltipModel([e.tooltipOption, globalTooltipModel]);
    var renderMode = this._renderMode;
    var newLine = this._newLine;
    var markers = {};
    each(dataByCoordSys, function (itemCoordSys) {
      // var coordParamList = [];
      // var coordDefaultHTML = [];
      // var coordTooltipModel = buildTooltipModel([
      //     e.tooltipOption,
      //     itemCoordSys.tooltipOption,
      //     ecModel.getComponent(itemCoordSys.coordSysMainType, itemCoordSys.coordSysIndex),
      //     globalTooltipModel
      // ]);
      // var displayMode = coordTooltipModel.get('displayMode');
      // var paramsList = displayMode === 'single' ? singleParamsList : [];
      each(itemCoordSys.dataByAxis, function (item) {
        var axisModel = ecModel.getComponent(item.axisDim + 'Axis', item.axisIndex);
        var axisValue = item.value;
        var seriesDefaultHTML = [];

        if (!axisModel || axisValue == null) {
          return;
        }

        var valueLabel = axisPointerViewHelper.getValueLabel(axisValue, axisModel.axis, ecModel, item.seriesDataIndices, item.valueLabelOpt);
        zrUtil.each(item.seriesDataIndices, function (idxItem) {
          var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
          var dataIndex = idxItem.dataIndexInside;
          var dataParams = series && series.getDataParams(dataIndex);
          dataParams.axisDim = item.axisDim;
          dataParams.axisIndex = item.axisIndex;
          dataParams.axisType = item.axisType;
          dataParams.axisId = item.axisId;
          dataParams.axisValue = axisHelper.getAxisRawValue(axisModel.axis, axisValue);
          dataParams.axisValueLabel = valueLabel;

          if (dataParams) {
            singleParamsList.push(dataParams);
            var seriesTooltip = series.formatTooltip(dataIndex, true, null, renderMode);
            var html;

            if (zrUtil.isObject(seriesTooltip)) {
              html = seriesTooltip.html;
              var newMarkers = seriesTooltip.markers;
              zrUtil.merge(markers, newMarkers);
            } else {
              html = seriesTooltip;
            }

            seriesDefaultHTML.push(html);
          }
        }); // Default tooltip content
        // FIXME
        // (1) should be the first data which has name?
        // (2) themeRiver, firstDataIndex is array, and first line is unnecessary.

        var firstLine = valueLabel;

        if (renderMode !== 'html') {
          singleDefaultHTML.push(seriesDefaultHTML.join(newLine));
        } else {
          singleDefaultHTML.push((firstLine ? formatUtil.encodeHTML(firstLine) + newLine : '') + seriesDefaultHTML.join(newLine));
        }
      });
    }, this); // In most case, the second axis is shown upper than the first one.

    singleDefaultHTML.reverse();
    singleDefaultHTML = singleDefaultHTML.join(this._newLine + this._newLine);
    var positionExpr = e.position;

    this._showOrMove(singleTooltipModel, function () {
      if (this._updateContentNotChangedOnAxis(dataByCoordSys)) {
        this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, singleParamsList);
      } else {
        this._showTooltipContent(singleTooltipModel, singleDefaultHTML, singleParamsList, Math.random(), point[0], point[1], positionExpr, undefined, markers);
      }
    }); // Do not trigger events here, because this branch only be entered
    // from dispatchAction.

  },
  _showSeriesItemTooltip: function (e, el, dispatchAction) {
    var ecModel = this._ecModel; // Use dataModel in element if possible
    // Used when mouseover on a element like markPoint or edge
    // In which case, the data is not main data in series.

    var seriesIndex = el.seriesIndex;
    var seriesModel = ecModel.getSeriesByIndex(seriesIndex); // For example, graph link.

    var dataModel = el.dataModel || seriesModel;
    var dataIndex = el.dataIndex;
    var dataType = el.dataType;
    var data = dataModel.getData(dataType);
    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), dataModel, seriesModel && (seriesModel.coordinateSystem || {}).model, this._tooltipModel]);
    var tooltipTrigger = tooltipModel.get('trigger');

    if (tooltipTrigger != null && tooltipTrigger !== 'item') {
      return;
    }

    var params = dataModel.getDataParams(dataIndex, dataType);
    var seriesTooltip = dataModel.formatTooltip(dataIndex, false, dataType, this._renderMode);
    var defaultHtml;
    var markers;

    if (zrUtil.isObject(seriesTooltip)) {
      defaultHtml = seriesTooltip.html;
      markers = seriesTooltip.markers;
    } else {
      defaultHtml = seriesTooltip;
      markers = null;
    }

    var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;

    this._showOrMove(tooltipModel, function () {
      this._showTooltipContent(tooltipModel, defaultHtml, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markers);
    }); // FIXME
    // duplicated showtip if manuallyShowTip is called from dispatchAction.


    dispatchAction({
      type: 'showTip',
      dataIndexInside: dataIndex,
      dataIndex: data.getRawIndex(dataIndex),
      seriesIndex: seriesIndex,
      from: this.uid
    });
  },
  _showComponentItemTooltip: function (e, el, dispatchAction) {
    var tooltipOpt = el.tooltip;

    if (typeof tooltipOpt === 'string') {
      var content = tooltipOpt;
      tooltipOpt = {
        content: content,
        // Fixed formatter
        formatter: content
      };
    }

    var subTooltipModel = new Model(tooltipOpt, this._tooltipModel, this._ecModel);
    var defaultHtml = subTooltipModel.get('content');
    var asyncTicket = Math.random(); // Do not check whether `trigger` is 'none' here, because `trigger`
    // only works on coordinate system. In fact, we have not found case
    // that requires setting `trigger` nothing on component yet.

    this._showOrMove(subTooltipModel, function () {
      this._showTooltipContent(subTooltipModel, defaultHtml, subTooltipModel.get('formatterParams') || {}, asyncTicket, e.offsetX, e.offsetY, e.position, el);
    }); // If not dispatch showTip, tip may be hide triggered by axis.


    dispatchAction({
      type: 'showTip',
      from: this.uid
    });
  },
  _showTooltipContent: function (tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markers) {
    // Reset ticket
    this._ticket = '';

    if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) {
      return;
    }

    var tooltipContent = this._tooltipContent;
    var formatter = tooltipModel.get('formatter');
    positionExpr = positionExpr || tooltipModel.get('position');
    var html = defaultHtml;

    if (formatter && typeof formatter === 'string') {
      html = formatUtil.formatTpl(formatter, params, true);
    } else if (typeof formatter === 'function') {
      var callback = bind(function (cbTicket, html) {
        if (cbTicket === this._ticket) {
          tooltipContent.setContent(html, markers, tooltipModel);

          this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
        }
      }, this);
      this._ticket = asyncTicket;
      html = formatter(params, asyncTicket, callback);
    }

    tooltipContent.setContent(html, markers, tooltipModel);
    tooltipContent.show(tooltipModel);

    this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
  },

  /**
   * @param  {string|Function|Array.<number>|Object} positionExpr
   * @param  {number} x Mouse x
   * @param  {number} y Mouse y
   * @param  {boolean} confine Whether confine tooltip content in view rect.
   * @param  {Object|<Array.<Object>} params
   * @param  {module:zrender/Element} el target element
   * @param  {module:echarts/ExtensionAPI} api
   * @return {Array.<number>}
   */
  _updatePosition: function (tooltipModel, positionExpr, x, y, content, params, el) {
    var viewWidth = this._api.getWidth();

    var viewHeight = this._api.getHeight();

    positionExpr = positionExpr || tooltipModel.get('position');
    var contentSize = content.getSize();
    var align = tooltipModel.get('align');
    var vAlign = tooltipModel.get('verticalAlign');
    var rect = el && el.getBoundingRect().clone();
    el && rect.applyTransform(el.transform);

    if (typeof positionExpr === 'function') {
      // Callback of position can be an array or a string specify the position
      positionExpr = positionExpr([x, y], params, content.el, rect, {
        viewSize: [viewWidth, viewHeight],
        contentSize: contentSize.slice()
      });
    }

    if (zrUtil.isArray(positionExpr)) {
      x = parsePercent(positionExpr[0], viewWidth);
      y = parsePercent(positionExpr[1], viewHeight);
    } else if (zrUtil.isObject(positionExpr)) {
      positionExpr.width = contentSize[0];
      positionExpr.height = contentSize[1];
      var layoutRect = layoutUtil.getLayoutRect(positionExpr, {
        width: viewWidth,
        height: viewHeight
      });
      x = layoutRect.x;
      y = layoutRect.y;
      align = null; // When positionExpr is left/top/right/bottom,
      // align and verticalAlign will not work.

      vAlign = null;
    } // Specify tooltip position by string 'top' 'bottom' 'left' 'right' around graphic element
    else if (typeof positionExpr === 'string' && el) {
        var pos = calcTooltipPosition(positionExpr, rect, contentSize);
        x = pos[0];
        y = pos[1];
      } else {
        var pos = refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
        x = pos[0];
        y = pos[1];
      }

    align && (x -= isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
    vAlign && (y -= isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);

    if (tooltipModel.get('confine')) {
      var pos = confineTooltipPosition(x, y, content, viewWidth, viewHeight);
      x = pos[0];
      y = pos[1];
    }

    content.moveTo(x, y);
  },
  // FIXME
  // Should we remove this but leave this to user?
  _updateContentNotChangedOnAxis: function (dataByCoordSys) {
    var lastCoordSys = this._lastDataByCoordSys;
    var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
    contentNotChanged && each(lastCoordSys, function (lastItemCoordSys, indexCoordSys) {
      var lastDataByAxis = lastItemCoordSys.dataByAxis || {};
      var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
      var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
      contentNotChanged &= lastDataByAxis.length === thisDataByAxis.length;
      contentNotChanged && each(lastDataByAxis, function (lastItem, indexAxis) {
        var thisItem = thisDataByAxis[indexAxis] || {};
        var lastIndices = lastItem.seriesDataIndices || [];
        var newIndices = thisItem.seriesDataIndices || [];
        contentNotChanged &= lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
        contentNotChanged && each(lastIndices, function (lastIdxItem, j) {
          var newIdxItem = newIndices[j];
          contentNotChanged &= lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
        });
      });
    });
    this._lastDataByCoordSys = dataByCoordSys;
    return !!contentNotChanged;
  },
  _hide: function (dispatchAction) {
    // Do not directly hideLater here, because this behavior may be prevented
    // in dispatchAction when showTip is dispatched.
    // FIXME
    // duplicated hideTip if manuallyHideTip is called from dispatchAction.
    this._lastDataByCoordSys = null;
    dispatchAction({
      type: 'hideTip',
      from: this.uid
    });
  },
  dispose: function (ecModel, api) {
    if (env.node) {
      return;
    }

    this._tooltipContent.dispose();

    globalListener.unregister('itemTooltip', api);
  }
});
/**
 * @param {Array.<Object|module:echarts/model/Model>} modelCascade
 * From top to bottom. (the last one should be globalTooltipModel);
 */


function buildTooltipModel(modelCascade) {
  var resultModel = modelCascade.pop();

  while (modelCascade.length) {
    var tooltipOpt = modelCascade.pop();

    if (tooltipOpt) {
      if (Model.isInstance(tooltipOpt)) {
        tooltipOpt = tooltipOpt.get('tooltip', true);
      } // In each data item tooltip can be simply write:
      // {
      //  value: 10,
      //  tooltip: 'Something you need to know'
      // }


      if (typeof tooltipOpt === 'string') {
        tooltipOpt = {
          formatter: tooltipOpt
        };
      }

      resultModel = new Model(tooltipOpt, resultModel, resultModel.ecModel);
    }
  }

  return resultModel;
}

function makeDispatchAction(payload, api) {
  return payload.dispatchAction || zrUtil.bind(api.dispatchAction, api);
}

function refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
  var size = content.getOuterSize();
  var width = size.width;
  var height = size.height;

  if (gapH != null) {
    if (x + width + gapH > viewWidth) {
      x -= width + gapH;
    } else {
      x += gapH;
    }
  }

  if (gapV != null) {
    if (y + height + gapV > viewHeight) {
      y -= height + gapV;
    } else {
      y += gapV;
    }
  }

  return [x, y];
}

function confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
  var size = content.getOuterSize();
  var width = size.width;
  var height = size.height;
  x = Math.min(x + width, viewWidth) - width;
  y = Math.min(y + height, viewHeight) - height;
  x = Math.max(x, 0);
  y = Math.max(y, 0);
  return [x, y];
}

function calcTooltipPosition(position, rect, contentSize) {
  var domWidth = contentSize[0];
  var domHeight = contentSize[1];
  var gap = 5;
  var x = 0;
  var y = 0;
  var rectWidth = rect.width;
  var rectHeight = rect.height;

  switch (position) {
    case 'inside':
      x = rect.x + rectWidth / 2 - domWidth / 2;
      y = rect.y + rectHeight / 2 - domHeight / 2;
      break;

    case 'top':
      x = rect.x + rectWidth / 2 - domWidth / 2;
      y = rect.y - domHeight - gap;
      break;

    case 'bottom':
      x = rect.x + rectWidth / 2 - domWidth / 2;
      y = rect.y + rectHeight + gap;
      break;

    case 'left':
      x = rect.x - domWidth - gap;
      y = rect.y + rectHeight / 2 - domHeight / 2;
      break;

    case 'right':
      x = rect.x + rectWidth + gap;
      y = rect.y + rectHeight / 2 - domHeight / 2;
  }

  return [x, y];
}

function isCenterAlign(align) {
  return align === 'center' || align === 'middle';
}

module.exports = _default;

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var zrColor = __webpack_require__(122);

var eventUtil = __webpack_require__(121);

var domUtil = __webpack_require__(614);

var env = __webpack_require__(67);

var formatUtil = __webpack_require__(54);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var each = zrUtil.each;
var toCamelCase = formatUtil.toCamelCase;
var vendors = ['', '-webkit-', '-moz-', '-o-'];
var gCssText = 'position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;';
/**
 * @param {number} duration
 * @return {string}
 * @inner
 */

function assembleTransition(duration) {
  var transitionCurve = 'cubic-bezier(0.23, 1, 0.32, 1)';
  var transitionText = 'left ' + duration + 's ' + transitionCurve + ',' + 'top ' + duration + 's ' + transitionCurve;
  return zrUtil.map(vendors, function (vendorPrefix) {
    return vendorPrefix + 'transition:' + transitionText;
  }).join(';');
}
/**
 * @param {Object} textStyle
 * @return {string}
 * @inner
 */


function assembleFont(textStyleModel) {
  var cssText = [];
  var fontSize = textStyleModel.get('fontSize');
  var color = textStyleModel.getTextColor();
  color && cssText.push('color:' + color);
  cssText.push('font:' + textStyleModel.getFont());
  var lineHeight = textStyleModel.get('lineHeight');

  if (lineHeight == null) {
    lineHeight = Math.round(fontSize * 3 / 2);
  }

  fontSize && cssText.push('line-height:' + lineHeight + 'px');
  var shadowColor = textStyleModel.get('textShadowColor');
  var shadowBlur = textStyleModel.get('textShadowBlur') || 0;
  var shadowOffsetX = textStyleModel.get('textShadowOffsetX') || 0;
  var shadowOffsetY = textStyleModel.get('textShadowOffsetY') || 0;
  shadowBlur && cssText.push('text-shadow:' + shadowOffsetX + 'px ' + shadowOffsetY + 'px ' + shadowBlur + 'px ' + shadowColor);
  each(['decoration', 'align'], function (name) {
    var val = textStyleModel.get(name);
    val && cssText.push('text-' + name + ':' + val);
  });
  return cssText.join(';');
}
/**
 * @param {Object} tooltipModel
 * @return {string}
 * @inner
 */


function assembleCssText(tooltipModel) {
  var cssText = [];
  var transitionDuration = tooltipModel.get('transitionDuration');
  var backgroundColor = tooltipModel.get('backgroundColor');
  var textStyleModel = tooltipModel.getModel('textStyle');
  var padding = tooltipModel.get('padding'); // Animation transition. Do not animate when transitionDuration is 0.

  transitionDuration && cssText.push(assembleTransition(transitionDuration));

  if (backgroundColor) {
    if (env.canvasSupported) {
      cssText.push('background-Color:' + backgroundColor);
    } else {
      // for ie
      cssText.push('background-Color:#' + zrColor.toHex(backgroundColor));
      cssText.push('filter:alpha(opacity=70)');
    }
  } // Border style


  each(['width', 'color', 'radius'], function (name) {
    var borderName = 'border-' + name;
    var camelCase = toCamelCase(borderName);
    var val = tooltipModel.get(camelCase);
    val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
  }); // Text style

  cssText.push(assembleFont(textStyleModel)); // Padding

  if (padding != null) {
    cssText.push('padding:' + formatUtil.normalizeCssArray(padding).join('px ') + 'px');
  }

  return cssText.join(';') + ';';
} // If not able to make, do not modify the input `out`.


function makeStyleCoord(out, zr, appendToBody, zrX, zrY) {
  var zrPainter = zr && zr.painter;

  if (appendToBody) {
    var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();

    if (zrViewportRoot) {
      // Some APPs might use scale on body, so we support CSS transform here.
      domUtil.transformLocalCoord(out, zrViewportRoot, document.body, zrX, zrY);
    }
  } else {
    out[0] = zrX;
    out[1] = zrY; // xy should be based on canvas root. But tooltipContent is
    // the sibling of canvas root. So padding of ec container
    // should be considered here.

    var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();

    if (viewportRootOffset) {
      out[0] += viewportRootOffset.offsetLeft;
      out[1] += viewportRootOffset.offsetTop;
    }
  }

  out[2] = out[0] / zr.getWidth(); // The ratio of left to width

  out[3] = out[1] / zr.getHeight(); // The ratio of top to height
}
/**
 * @alias module:echarts/component/tooltip/TooltipContent
 * @param {HTMLElement} container
 * @param {ExtensionAPI} api
 * @param {Object} [opt]
 * @param {boolean} [opt.appendToBody]
 *        `false`: the DOM element will be inside the container. Default value.
 *        `true`: the DOM element will be appended to HTML body, which avoid
 *                some overflow clip but intrude outside of the container.
 * @constructor
 */


function TooltipContent(container, api, opt) {
  if (env.wxa) {
    return null;
  }

  var el = document.createElement('div');
  el.domBelongToZr = true;
  this.el = el;
  var zr = this._zr = api.getZr();
  var appendToBody = this._appendToBody = opt && opt.appendToBody;
  this._styleCoord = [0, 0, 0, 0]; // [left, top, left/width, top/height]

  makeStyleCoord(this._styleCoord, zr, appendToBody, api.getWidth() / 2, api.getHeight() / 2);

  if (appendToBody) {
    document.body.appendChild(el);
  } else {
    container.appendChild(el);
  }

  this._container = container;
  this._show = false;
  /**
   * @private
   */

  this._hideTimeout; // FIXME
  // Is it needed to trigger zr event manually if
  // the browser do not support `pointer-events: none`.

  var self = this;

  el.onmouseenter = function () {
    // clear the timeout in hideLater and keep showing tooltip
    if (self._enterable) {
      clearTimeout(self._hideTimeout);
      self._show = true;
    }

    self._inContent = true;
  };

  el.onmousemove = function (e) {
    e = e || window.event;

    if (!self._enterable) {
      // `pointer-events: none` is set to tooltip content div
      // if `enterable` is set as `false`, and `el.onmousemove`
      // can not be triggered. But in browser that do not
      // support `pointer-events`, we need to do this:
      // Try trigger zrender event to avoid mouse
      // in and out shape too frequently
      var handler = zr.handler;
      var zrViewportRoot = zr.painter.getViewportRoot();
      eventUtil.normalizeEvent(zrViewportRoot, e, true);
      handler.dispatch('mousemove', e);
    }
  };

  el.onmouseleave = function () {
    if (self._enterable) {
      if (self._show) {
        self.hideLater(self._hideDelay);
      }
    }

    self._inContent = false;
  };
}

TooltipContent.prototype = {
  constructor: TooltipContent,

  /**
   * @private
   * @type {boolean}
   */
  _enterable: true,

  /**
   * Update when tooltip is rendered
   */
  update: function (tooltipModel) {
    // FIXME
    // Move this logic to ec main?
    var container = this._container;
    var stl = container.currentStyle || document.defaultView.getComputedStyle(container);
    var domStyle = container.style;

    if (domStyle.position !== 'absolute' && stl.position !== 'absolute') {
      domStyle.position = 'relative';
    }

    var alwaysShowContent = tooltipModel.get('alwaysShowContent');
    alwaysShowContent && this._moveTooltipIfResized(); // Hide the tooltip
    // PENDING
    // this.hide();
  },

  /**
   * when `alwaysShowContent` is true,
   * we should move the tooltip after chart resized
   */
  _moveTooltipIfResized: function () {
    var ratioX = this._styleCoord[2]; // The ratio of left to width

    var ratioY = this._styleCoord[3]; // The ratio of top to height

    var realX = ratioX * this._zr.getWidth();

    var realY = ratioY * this._zr.getHeight();

    this.moveTo(realX, realY);
  },
  show: function (tooltipModel) {
    clearTimeout(this._hideTimeout);
    var el = this.el;
    var styleCoord = this._styleCoord;
    el.style.cssText = gCssText + assembleCssText(tooltipModel) // Because of the reason described in:
    // http://stackoverflow.com/questions/21125587/css3-transition-not-working-in-chrome-anymore
    // we should set initial value to `left` and `top`.
    + ';left:' + styleCoord[0] + 'px;top:' + styleCoord[1] + 'px;' + (tooltipModel.get('extraCssText') || '');
    el.style.display = el.innerHTML ? 'block' : 'none'; // If mouse occasionally move over the tooltip, a mouseout event will be
    // triggered by canvas, and cause some unexpectable result like dragging
    // stop, "unfocusAdjacency". Here `pointer-events: none` is used to solve
    // it. Although it is not supported by IE8~IE10, fortunately it is a rare
    // scenario.

    el.style.pointerEvents = this._enterable ? 'auto' : 'none';
    this._show = true;
  },
  setContent: function (content) {
    this.el.innerHTML = content == null ? '' : content;
  },
  setEnterable: function (enterable) {
    this._enterable = enterable;
  },
  getSize: function () {
    var el = this.el;
    return [el.clientWidth, el.clientHeight];
  },
  moveTo: function (zrX, zrY) {
    var styleCoord = this._styleCoord;
    makeStyleCoord(styleCoord, this._zr, this._appendToBody, zrX, zrY);
    var style = this.el.style;
    style.left = styleCoord[0] + 'px';
    style.top = styleCoord[1] + 'px';
  },
  hide: function () {
    this.el.style.display = 'none';
    this._show = false;
  },
  hideLater: function (time) {
    if (this._show && !(this._inContent && this._enterable)) {
      if (time) {
        this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times

        this._show = false;
        this._hideTimeout = setTimeout(zrUtil.bind(this.hide, this), time);
      } else {
        this.hide();
      }
    }
  },
  isShow: function () {
    return this._show;
  },
  dispose: function () {
    this.el.parentNode.removeChild(this.el);
  },
  getOuterSize: function () {
    var width = this.el.clientWidth;
    var height = this.el.clientHeight; // Consider browser compatibility.
    // IE8 does not support getComputedStyle.

    if (document.defaultView && document.defaultView.getComputedStyle) {
      var stl = document.defaultView.getComputedStyle(this.el);

      if (stl) {
        width += parseInt(stl.borderLeftWidth, 10) + parseInt(stl.borderRightWidth, 10);
        height += parseInt(stl.borderTopWidth, 10) + parseInt(stl.borderBottomWidth, 10);
      }
    }

    return {
      width: width,
      height: height
    };
  }
};
var _default = TooltipContent;
module.exports = _default;

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var Text = __webpack_require__(175);

var graphicUtil = __webpack_require__(27);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// import Group from 'zrender/src/container/Group';
function makeStyleCoord(out, zr, zrX, zrY) {
  out[0] = zrX;
  out[1] = zrY;
  out[2] = out[0] / zr.getWidth(); // The ratio of left to width

  out[3] = out[1] / zr.getHeight(); // The ratio of top to height
}
/**
 * @alias module:echarts/component/tooltip/TooltipRichContent
 * @constructor
 */


function TooltipRichContent(api) {
  var zr = this._zr = api.getZr();
  this._styleCoord = [0, 0, 0, 0]; // [left, top, left/width, top/height]

  makeStyleCoord(this._styleCoord, zr, api.getWidth() / 2, api.getHeight() / 2);
  this._show = false;
  /**
   * @private
   */

  this._hideTimeout;
}

TooltipRichContent.prototype = {
  constructor: TooltipRichContent,

  /**
   * @private
   * @type {boolean}
   */
  _enterable: true,

  /**
   * Update when tooltip is rendered
   */
  update: function (tooltipModel) {
    var alwaysShowContent = tooltipModel.get('alwaysShowContent');
    alwaysShowContent && this._moveTooltipIfResized();
  },

  /**
   * when `alwaysShowContent` is true,
   * we should move the tooltip after chart resized
   */
  _moveTooltipIfResized: function () {
    var ratioX = this._styleCoord[2]; // The ratio of left to width

    var ratioY = this._styleCoord[3]; // The ratio of top to height

    var realX = ratioX * this._zr.getWidth();

    var realY = ratioY * this._zr.getHeight();

    this.moveTo(realX, realY);
  },
  show: function (tooltipModel) {
    if (this._hideTimeout) {
      clearTimeout(this._hideTimeout);
    }

    this.el.attr('show', true);
    this._show = true;
  },

  /**
   * Set tooltip content
   *
   * @param {string} content rich text string of content
   * @param {Object} markerRich rich text style
   * @param {Object} tooltipModel tooltip model
   */
  setContent: function (content, markerRich, tooltipModel) {
    if (this.el) {
      this._zr.remove(this.el);
    }

    var markers = {};
    var text = content;
    var prefix = '{marker';
    var suffix = '|}';
    var startId = text.indexOf(prefix);

    while (startId >= 0) {
      var endId = text.indexOf(suffix);
      var name = text.substr(startId + prefix.length, endId - startId - prefix.length);

      if (name.indexOf('sub') > -1) {
        markers['marker' + name] = {
          textWidth: 4,
          textHeight: 4,
          textBorderRadius: 2,
          textBackgroundColor: markerRich[name],
          // TODO: textOffset is not implemented for rich text
          textOffset: [3, 0]
        };
      } else {
        markers['marker' + name] = {
          textWidth: 10,
          textHeight: 10,
          textBorderRadius: 5,
          textBackgroundColor: markerRich[name]
        };
      }

      text = text.substr(endId + 1);
      startId = text.indexOf('{marker');
    }

    var textStyleModel = tooltipModel.getModel('textStyle');
    var fontSize = textStyleModel.get('fontSize');
    var lineHeight = tooltipModel.get('textLineHeight');

    if (lineHeight == null) {
      lineHeight = Math.round(fontSize * 3 / 2);
    }

    this.el = new Text({
      style: graphicUtil.setTextStyle({}, textStyleModel, {
        rich: markers,
        text: content,
        textBackgroundColor: tooltipModel.get('backgroundColor'),
        textBorderRadius: tooltipModel.get('borderRadius'),
        textFill: tooltipModel.get('textStyle.color'),
        textPadding: tooltipModel.get('padding'),
        textLineHeight: lineHeight
      }),
      z: tooltipModel.get('z')
    });

    this._zr.add(this.el);

    var self = this;
    this.el.on('mouseover', function () {
      // clear the timeout in hideLater and keep showing tooltip
      if (self._enterable) {
        clearTimeout(self._hideTimeout);
        self._show = true;
      }

      self._inContent = true;
    });
    this.el.on('mouseout', function () {
      if (self._enterable) {
        if (self._show) {
          self.hideLater(self._hideDelay);
        }
      }

      self._inContent = false;
    });
  },
  setEnterable: function (enterable) {
    this._enterable = enterable;
  },
  getSize: function () {
    var bounding = this.el.getBoundingRect();
    return [bounding.width, bounding.height];
  },
  moveTo: function (x, y) {
    if (this.el) {
      var styleCoord = this._styleCoord;
      makeStyleCoord(styleCoord, this._zr, x, y);
      this.el.attr('position', [styleCoord[0], styleCoord[1]]);
    }
  },
  hide: function () {
    if (this.el) {
      this.el.hide();
    }

    this._show = false;
  },
  hideLater: function (time) {
    if (this._show && !(this._inContent && this._enterable)) {
      if (time) {
        this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times

        this._show = false;
        this._hideTimeout = setTimeout(zrUtil.bind(this.hide, this), time);
      } else {
        this.hide();
      }
    }
  },
  isShow: function () {
    return this._show;
  },
  dispose: function () {
    clearTimeout(this._hideTimeout);

    if (this.el) {
      this._zr.remove(this.el);
    }
  },
  getOuterSize: function () {
    var size = this.getSize();
    return {
      width: size[0],
      height: size[1]
    };
  }
};
var _default = TooltipRichContent;
module.exports = _default;

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var preprocessor = __webpack_require__(1769);

__webpack_require__(681);

__webpack_require__(1771);

__webpack_require__(1772);

__webpack_require__(1773);

__webpack_require__(1774);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Brush component entry
 */
echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var DEFAULT_TOOLBOX_BTNS = ['rect', 'polygon', 'keep', 'clear'];

function _default(option, isNew) {
  var brushComponents = option && option.brush;

  if (!zrUtil.isArray(brushComponents)) {
    brushComponents = brushComponents ? [brushComponents] : [];
  }

  if (!brushComponents.length) {
    return;
  }

  var brushComponentSpecifiedBtns = [];
  zrUtil.each(brushComponents, function (brushOpt) {
    var tbs = brushOpt.hasOwnProperty('toolbox') ? brushOpt.toolbox : [];

    if (tbs instanceof Array) {
      brushComponentSpecifiedBtns = brushComponentSpecifiedBtns.concat(tbs);
    }
  });
  var toolbox = option && option.toolbox;

  if (zrUtil.isArray(toolbox)) {
    toolbox = toolbox[0];
  }

  if (!toolbox) {
    toolbox = {
      feature: {}
    };
    option.toolbox = [toolbox];
  }

  var toolboxFeature = toolbox.feature || (toolbox.feature = {});
  var toolboxBrush = toolboxFeature.brush || (toolboxFeature.brush = {});
  var brushTypes = toolboxBrush.type || (toolboxBrush.type = []);
  brushTypes.push.apply(brushTypes, brushComponentSpecifiedBtns);
  removeDuplicate(brushTypes);

  if (isNew && !brushTypes.length) {
    brushTypes.push.apply(brushTypes, DEFAULT_TOOLBOX_BTNS);
  }
}

function removeDuplicate(arr) {
  var map = {};
  zrUtil.each(arr, function (val) {
    map[val] = 1;
  });
  arr.length = 0;
  zrUtil.each(map, function (flag, val) {
    arr.push(val);
  });
}

module.exports = _default;

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var polygonContain = __webpack_require__(647);

var BoundingRect = __webpack_require__(57);

var _graphic = __webpack_require__(27);

var linePolygonIntersect = _graphic.linePolygonIntersect;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Key of the first level is brushType: `line`, `rect`, `polygon`.
// Key of the second level is chart element type: `point`, `rect`.
// See moudule:echarts/component/helper/BrushController
// function param:
//      {Object} itemLayout fetch from data.getItemLayout(dataIndex)
//      {Object} selectors {point: selector, rect: selector, ...}
//      {Object} area {range: [[], [], ..], boudingRect}
// function return:
//      {boolean} Whether in the given brush.
var selector = {
  lineX: getLineSelectors(0),
  lineY: getLineSelectors(1),
  rect: {
    point: function (itemLayout, selectors, area) {
      return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]);
    },
    rect: function (itemLayout, selectors, area) {
      return itemLayout && area.boundingRect.intersect(itemLayout);
    }
  },
  polygon: {
    point: function (itemLayout, selectors, area) {
      return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]) && polygonContain.contain(area.range, itemLayout[0], itemLayout[1]);
    },
    rect: function (itemLayout, selectors, area) {
      var points = area.range;

      if (!itemLayout || points.length <= 1) {
        return false;
      }

      var x = itemLayout.x;
      var y = itemLayout.y;
      var width = itemLayout.width;
      var height = itemLayout.height;
      var p = points[0];

      if (polygonContain.contain(points, x, y) || polygonContain.contain(points, x + width, y) || polygonContain.contain(points, x, y + height) || polygonContain.contain(points, x + width, y + height) || BoundingRect.create(itemLayout).contain(p[0], p[1]) || linePolygonIntersect(x, y, x + width, y, points) || linePolygonIntersect(x, y, x, y + height, points) || linePolygonIntersect(x + width, y, x + width, y + height, points) || linePolygonIntersect(x, y + height, x + width, y + height, points)) {
        return true;
      }
    }
  }
};

function getLineSelectors(xyIndex) {
  var xy = ['x', 'y'];
  var wh = ['width', 'height'];
  return {
    point: function (itemLayout, selectors, area) {
      if (itemLayout) {
        var range = area.range;
        var p = itemLayout[xyIndex];
        return inLineRange(p, range);
      }
    },
    rect: function (itemLayout, selectors, area) {
      if (itemLayout) {
        var range = area.range;
        var layoutRange = [itemLayout[xy[xyIndex]], itemLayout[xy[xyIndex]] + itemLayout[wh[xyIndex]]];
        layoutRange[1] < layoutRange[0] && layoutRange.reverse();
        return inLineRange(layoutRange[0], range) || inLineRange(layoutRange[1], range) || inLineRange(range[0], layoutRange) || inLineRange(range[1], layoutRange);
      }
    }
  };
}

function inLineRange(p, range) {
  return range[0] <= p && p <= range[1];
}

var _default = selector;
module.exports = _default;

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var visualSolution = __webpack_require__(309);

var Model = __webpack_require__(68);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var DEFAULT_OUT_OF_BRUSH_COLOR = ['#ddd'];
var BrushModel = echarts.extendComponentModel({
  type: 'brush',
  dependencies: ['geo', 'grid', 'xAxis', 'yAxis', 'parallel', 'series'],

  /**
   * @protected
   */
  defaultOption: {
    // inBrush: null,
    // outOfBrush: null,
    toolbox: null,
    // Default value see preprocessor.
    brushLink: null,
    // Series indices array, broadcast using dataIndex.
    // or 'all', which means all series. 'none' or null means no series.
    seriesIndex: 'all',
    // seriesIndex array, specify series controlled by this brush component.
    geoIndex: null,
    //
    xAxisIndex: null,
    yAxisIndex: null,
    brushType: 'rect',
    // Default brushType, see BrushController.
    brushMode: 'single',
    // Default brushMode, 'single' or 'multiple'
    transformable: true,
    // Default transformable.
    brushStyle: {
      // Default brushStyle
      borderWidth: 1,
      color: 'rgba(120,140,180,0.3)',
      borderColor: 'rgba(120,140,180,0.8)'
    },
    throttleType: 'fixRate',
    // Throttle in brushSelected event. 'fixRate' or 'debounce'.
    // If null, no throttle. Valid only in the first brush component
    throttleDelay: 0,
    // Unit: ms, 0 means every event will be triggered.
    // FIXME
    // 试验效果
    removeOnClick: true,
    z: 10000
  },

  /**
   * @readOnly
   * @type {Array.<Object>}
   */
  areas: [],

  /**
   * Current activated brush type.
   * If null, brush is inactived.
   * see module:echarts/component/helper/BrushController
   * @readOnly
   * @type {string}
   */
  brushType: null,

  /**
   * Current brush opt.
   * see module:echarts/component/helper/BrushController
   * @readOnly
   * @type {Object}
   */
  brushOption: {},

  /**
   * @readOnly
   * @type {Array.<Object>}
   */
  coordInfoList: [],
  optionUpdated: function (newOption, isInit) {
    var thisOption = this.option;
    !isInit && visualSolution.replaceVisualOption(thisOption, newOption, ['inBrush', 'outOfBrush']);
    var inBrush = thisOption.inBrush = thisOption.inBrush || {}; // Always give default visual, consider setOption at the second time.

    thisOption.outOfBrush = thisOption.outOfBrush || {
      color: DEFAULT_OUT_OF_BRUSH_COLOR
    };

    if (!inBrush.hasOwnProperty('liftZ')) {
      // Bigger than the highlight z lift, otherwise it will
      // be effected by the highlight z when brush.
      inBrush.liftZ = 5;
    }
  },

  /**
   * If ranges is null/undefined, range state remain.
   *
   * @param {Array.<Object>} [ranges]
   */
  setAreas: function (areas) {
    // If ranges is null/undefined, range state remain.
    // This helps user to dispatchAction({type: 'brush'}) with no areas
    // set but just want to get the current brush select info from a `brush` event.
    if (!areas) {
      return;
    }

    this.areas = zrUtil.map(areas, function (area) {
      return generateBrushOption(this.option, area);
    }, this);
  },

  /**
   * see module:echarts/component/helper/BrushController
   * @param {Object} brushOption
   */
  setBrushOption: function (brushOption) {
    this.brushOption = generateBrushOption(this.option, brushOption);
    this.brushType = this.brushOption.brushType;
  }
});

function generateBrushOption(option, brushOption) {
  return zrUtil.merge({
    brushType: option.brushType,
    brushMode: option.brushMode,
    transformable: option.transformable,
    brushStyle: new Model(option.brushStyle).getItemStyle(),
    removeOnClick: option.removeOnClick,
    z: option.z
  }, brushOption, true);
}

var _default = BrushModel;
module.exports = _default;

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

var BrushController = __webpack_require__(425);

var _visualEncoding = __webpack_require__(681);

var layoutCovers = _visualEncoding.layoutCovers;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = echarts.extendComponentView({
  type: 'brush',
  init: function (ecModel, api) {
    /**
     * @readOnly
     * @type {module:echarts/model/Global}
     */
    this.ecModel = ecModel;
    /**
     * @readOnly
     * @type {module:echarts/ExtensionAPI}
     */

    this.api = api;
    /**
     * @readOnly
     * @type {module:echarts/component/brush/BrushModel}
     */

    this.model;
    /**
     * @private
     * @type {module:echarts/component/helper/BrushController}
     */

    (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this)).mount();
  },

  /**
   * @override
   */
  render: function (brushModel) {
    this.model = brushModel;
    return updateController.apply(this, arguments);
  },

  /**
   * @override
   */
  updateTransform: function (brushModel, ecModel) {
    // PENDING: `updateTransform` is a little tricky, whose layout need
    // to be calculate mandatorily and other stages will not be performed.
    // Take care the correctness of the logic. See #11754 .
    layoutCovers(ecModel);
    return updateController.apply(this, arguments);
  },

  /**
   * @override
   */
  updateView: updateController,
  // /**
  //  * @override
  //  */
  // updateLayout: updateController,
  // /**
  //  * @override
  //  */
  // updateVisual: updateController,

  /**
   * @override
   */
  dispose: function () {
    this._brushController.dispose();
  },

  /**
   * @private
   */
  _onBrush: function (areas, opt) {
    var modelId = this.model.id;
    this.model.brushTargetManager.setOutputRanges(areas, this.ecModel); // Action is not dispatched on drag end, because the drag end
    // emits the same params with the last drag move event, and
    // may have some delay when using touch pad, which makes
    // animation not smooth (when using debounce).

    (!opt.isEnd || opt.removeOnClick) && this.api.dispatchAction({
      type: 'brush',
      brushId: modelId,
      areas: zrUtil.clone(areas),
      $from: modelId
    });
    opt.isEnd && this.api.dispatchAction({
      type: 'brushEnd',
      brushId: modelId,
      areas: zrUtil.clone(areas),
      $from: modelId
    });
  }
});

function updateController(brushModel, ecModel, api, payload) {
  // Do not update controller when drawing.
  (!payload || payload.$from !== brushModel.id) && this._brushController.setPanels(brushModel.brushTargetManager.makePanelOpts(api)).enableBrush(brushModel.brushOption).updateCovers(brushModel.areas.slice());
}

module.exports = _default;

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * payload: {
 *      brushIndex: number, or,
 *      brushId: string, or,
 *      brushName: string,
 *      globalRanges: Array
 * }
 */
echarts.registerAction({
  type: 'brush',
  event: 'brush'
  /*, update: 'updateView' */

}, function (payload, ecModel) {
  ecModel.eachComponent({
    mainType: 'brush',
    query: payload
  }, function (brushModel) {
    brushModel.setAreas(payload.areas);
  });
});
/**
 * payload: {
 *      brushComponents: [
 *          {
 *              brushId,
 *              brushIndex,
 *              brushName,
 *              series: [
 *                  {
 *                      seriesId,
 *                      seriesIndex,
 *                      seriesName,
 *                      rawIndices: [21, 34, ...]
 *                  },
 *                  ...
 *              ]
 *          },
 *          ...
 *      ]
 * }
 */

echarts.registerAction({
  type: 'brushSelect',
  event: 'brushSelected',
  update: 'none'
}, function () {});
echarts.registerAction({
  type: 'brushEnd',
  event: 'brushEnd',
  update: 'none'
}, function () {});

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var featureManager = __webpack_require__(152);

var lang = __webpack_require__(149);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var brushLang = lang.toolbox.brush;

function Brush(model, ecModel, api) {
  this.model = model;
  this.ecModel = ecModel;
  this.api = api;
  /**
   * @private
   * @type {string}
   */

  this._brushType;
  /**
   * @private
   * @type {string}
   */

  this._brushMode;
}

Brush.defaultOption = {
  show: true,
  type: ['rect', 'polygon', 'lineX', 'lineY', 'keep', 'clear'],
  icon: {
    /* eslint-disable */
    rect: 'M7.3,34.7 M0.4,10V-0.2h9.8 M89.6,10V-0.2h-9.8 M0.4,60v10.2h9.8 M89.6,60v10.2h-9.8 M12.3,22.4V10.5h13.1 M33.6,10.5h7.8 M49.1,10.5h7.8 M77.5,22.4V10.5h-13 M12.3,31.1v8.2 M77.7,31.1v8.2 M12.3,47.6v11.9h13.1 M33.6,59.5h7.6 M49.1,59.5 h7.7 M77.5,47.6v11.9h-13',
    // jshint ignore:line
    polygon: 'M55.2,34.9c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S53.5,34.9,55.2,34.9z M50.4,51c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 C47.3,52.4,48.7,51,50.4,51z M55.6,37.1l1.5-7.8 M60.1,13.5l1.6-8.7l-7.8,4 M59,19l-1,5.3 M24,16.1l6.4,4.9l6.4-3.3 M48.5,11.6 l-5.9,3.1 M19.1,12.8L9.7,5.1l1.1,7.7 M13.4,29.8l1,7.3l6.6,1.6 M11.6,18.4l1,6.1 M32.8,41.9 M26.6,40.4 M27.3,40.2l6.1,1.6 M49.9,52.1l-5.6-7.6l-4.9-1.2',
    // jshint ignore:line
    lineX: 'M15.2,30 M19.7,15.6V1.9H29 M34.8,1.9H40.4 M55.3,15.6V1.9H45.9 M19.7,44.4V58.1H29 M34.8,58.1H40.4 M55.3,44.4 V58.1H45.9 M12.5,20.3l-9.4,9.6l9.6,9.8 M3.1,29.9h16.5 M62.5,20.3l9.4,9.6L62.3,39.7 M71.9,29.9H55.4',
    // jshint ignore:line
    lineY: 'M38.8,7.7 M52.7,12h13.2v9 M65.9,26.6V32 M52.7,46.3h13.2v-9 M24.9,12H11.8v9 M11.8,26.6V32 M24.9,46.3H11.8v-9 M48.2,5.1l-9.3-9l-9.4,9.2 M38.9-3.9V12 M48.2,53.3l-9.3,9l-9.4-9.2 M38.9,62.3V46.4',
    // jshint ignore:line
    keep: 'M4,10.5V1h10.3 M20.7,1h6.1 M33,1h6.1 M55.4,10.5V1H45.2 M4,17.3v6.6 M55.6,17.3v6.6 M4,30.5V40h10.3 M20.7,40 h6.1 M33,40h6.1 M55.4,30.5V40H45.2 M21,18.9h62.9v48.6H21V18.9z',
    // jshint ignore:line
    clear: 'M22,14.7l30.9,31 M52.9,14.7L22,45.7 M4.7,16.8V4.2h13.1 M26,4.2h7.8 M41.6,4.2h7.8 M70.3,16.8V4.2H57.2 M4.7,25.9v8.6 M70.3,25.9v8.6 M4.7,43.2v12.6h13.1 M26,55.8h7.8 M41.6,55.8h7.8 M70.3,43.2v12.6H57.2' // jshint ignore:line

    /* eslint-enable */

  },
  // `rect`, `polygon`, `lineX`, `lineY`, `keep`, `clear`
  title: zrUtil.clone(brushLang.title)
};
var proto = Brush.prototype; // proto.updateLayout = function (featureModel, ecModel, api) {

/* eslint-disable */

proto.render =
/* eslint-enable */
proto.updateView = function (featureModel, ecModel, api) {
  var brushType;
  var brushMode;
  var isBrushed;
  ecModel.eachComponent({
    mainType: 'brush'
  }, function (brushModel) {
    brushType = brushModel.brushType;
    brushMode = brushModel.brushOption.brushMode || 'single';
    isBrushed |= brushModel.areas.length;
  });
  this._brushType = brushType;
  this._brushMode = brushMode;
  zrUtil.each(featureModel.get('type', true), function (type) {
    featureModel.setIconStatus(type, (type === 'keep' ? brushMode === 'multiple' : type === 'clear' ? isBrushed : type === brushType) ? 'emphasis' : 'normal');
  });
};

proto.getIcons = function () {
  var model = this.model;
  var availableIcons = model.get('icon', true);
  var icons = {};
  zrUtil.each(model.get('type', true), function (type) {
    if (availableIcons[type]) {
      icons[type] = availableIcons[type];
    }
  });
  return icons;
};

proto.onclick = function (ecModel, api, type) {
  var brushType = this._brushType;
  var brushMode = this._brushMode;

  if (type === 'clear') {
    // Trigger parallel action firstly
    api.dispatchAction({
      type: 'axisAreaSelect',
      intervals: []
    });
    api.dispatchAction({
      type: 'brush',
      command: 'clear',
      // Clear all areas of all brush components.
      areas: []
    });
  } else {
    api.dispatchAction({
      type: 'takeGlobalCursor',
      key: 'brush',
      brushOption: {
        brushType: type === 'keep' ? brushType : brushType === type ? false : type,
        brushMode: type === 'keep' ? brushMode === 'multiple' ? 'single' : 'multiple' : brushMode
      }
    });
  }
};

featureManager.register('brush', Brush);
var _default = Brush;
module.exports = _default;

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var echarts = __webpack_require__(23);

var graphic = __webpack_require__(27);

var _layout = __webpack_require__(53);

var getLayoutRect = _layout.getLayoutRect;

var _format = __webpack_require__(54);

var windowOpen = _format.windowOpen;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Model
echarts.extendComponentModel({
  type: 'title',
  layoutMode: {
    type: 'box',
    ignoreSize: true
  },
  defaultOption: {
    // 一级层叠
    zlevel: 0,
    // 二级层叠
    z: 6,
    show: true,
    text: '',
    // 超链接跳转
    // link: null,
    // 仅支持self | blank
    target: 'blank',
    subtext: '',
    // 超链接跳转
    // sublink: null,
    // 仅支持self | blank
    subtarget: 'blank',
    // 'center' ¦ 'left' ¦ 'right'
    // ¦ {number}（x坐标，单位px）
    left: 0,
    // 'top' ¦ 'bottom' ¦ 'center'
    // ¦ {number}（y坐标，单位px）
    top: 0,
    // 水平对齐
    // 'auto' | 'left' | 'right' | 'center'
    // 默认根据 left 的位置判断是左对齐还是右对齐
    // textAlign: null
    //
    // 垂直对齐
    // 'auto' | 'top' | 'bottom' | 'middle'
    // 默认根据 top 位置判断是上对齐还是下对齐
    // textVerticalAlign: null
    // textBaseline: null // The same as textVerticalAlign.
    backgroundColor: 'rgba(0,0,0,0)',
    // 标题边框颜色
    borderColor: '#ccc',
    // 标题边框线宽，单位px，默认为0（无边框）
    borderWidth: 0,
    // 标题内边距，单位px，默认各方向内边距为5，
    // 接受数组分别设定上右下左边距，同css
    padding: 5,
    // 主副标题纵向间隔，单位px，默认为10，
    itemGap: 10,
    textStyle: {
      fontSize: 18,
      fontWeight: 'bolder',
      color: '#333'
    },
    subtextStyle: {
      color: '#aaa'
    }
  }
}); // View

echarts.extendComponentView({
  type: 'title',
  render: function (titleModel, ecModel, api) {
    this.group.removeAll();

    if (!titleModel.get('show')) {
      return;
    }

    var group = this.group;
    var textStyleModel = titleModel.getModel('textStyle');
    var subtextStyleModel = titleModel.getModel('subtextStyle');
    var textAlign = titleModel.get('textAlign');
    var textVerticalAlign = zrUtil.retrieve2(titleModel.get('textBaseline'), titleModel.get('textVerticalAlign'));
    var textEl = new graphic.Text({
      style: graphic.setTextStyle({}, textStyleModel, {
        text: titleModel.get('text'),
        textFill: textStyleModel.getTextColor()
      }, {
        disableBox: true
      }),
      z2: 10
    });
    var textRect = textEl.getBoundingRect();
    var subText = titleModel.get('subtext');
    var subTextEl = new graphic.Text({
      style: graphic.setTextStyle({}, subtextStyleModel, {
        text: subText,
        textFill: subtextStyleModel.getTextColor(),
        y: textRect.height + titleModel.get('itemGap'),
        textVerticalAlign: 'top'
      }, {
        disableBox: true
      }),
      z2: 10
    });
    var link = titleModel.get('link');
    var sublink = titleModel.get('sublink');
    var triggerEvent = titleModel.get('triggerEvent', true);
    textEl.silent = !link && !triggerEvent;
    subTextEl.silent = !sublink && !triggerEvent;

    if (link) {
      textEl.on('click', function () {
        windowOpen(link, '_' + titleModel.get('target'));
      });
    }

    if (sublink) {
      subTextEl.on('click', function () {
        windowOpen(sublink, '_' + titleModel.get('subtarget'));
      });
    }

    textEl.eventData = subTextEl.eventData = triggerEvent ? {
      componentType: 'title',
      componentIndex: titleModel.componentIndex
    } : null;
    group.add(textEl);
    subText && group.add(subTextEl); // If no subText, but add subTextEl, there will be an empty line.

    var groupRect = group.getBoundingRect();
    var layoutOption = titleModel.getBoxLayoutParams();
    layoutOption.width = groupRect.width;
    layoutOption.height = groupRect.height;
    var layoutRect = getLayoutRect(layoutOption, {
      width: api.getWidth(),
      height: api.getHeight()
    }, titleModel.get('padding')); // Adjust text align based on position

    if (!textAlign) {
      // Align left if title is on the left. center and right is same
      textAlign = titleModel.get('left') || titleModel.get('right');

      if (textAlign === 'middle') {
        textAlign = 'center';
      } // Adjust layout by text align


      if (textAlign === 'right') {
        layoutRect.x += layoutRect.width;
      } else if (textAlign === 'center') {
        layoutRect.x += layoutRect.width / 2;
      }
    }

    if (!textVerticalAlign) {
      textVerticalAlign = titleModel.get('top') || titleModel.get('bottom');

      if (textVerticalAlign === 'center') {
        textVerticalAlign = 'middle';
      }

      if (textVerticalAlign === 'bottom') {
        layoutRect.y += layoutRect.height;
      } else if (textVerticalAlign === 'middle') {
        layoutRect.y += layoutRect.height / 2;
      }

      textVerticalAlign = textVerticalAlign || 'top';
    }

    group.attr('position', [layoutRect.x, layoutRect.y]);
    var alignStyle = {
      textAlign: textAlign,
      textVerticalAlign: textVerticalAlign
    };
    textEl.setStyle(alignStyle);
    subTextEl.setStyle(alignStyle); // Render background
    // Get groupRect again because textAlign has been changed

    groupRect = group.getBoundingRect();
    var padding = layoutRect.margin;
    var style = titleModel.getItemStyle(['color', 'opacity']);
    style.fill = titleModel.get('backgroundColor');
    var rect = new graphic.Rect({
      shape: {
        x: groupRect.x - padding[3],
        y: groupRect.y - padding[0],
        width: groupRect.width + padding[1] + padding[3],
        height: groupRect.height + padding[0] + padding[2],
        r: titleModel.get('borderRadius')
      },
      style: style,
      subPixelOptimize: true,
      silent: true
    });
    group.add(rect);
  }
});

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var preprocessor = __webpack_require__(1777);

__webpack_require__(1778);

__webpack_require__(1779);

__webpack_require__(1780);

__webpack_require__(1782);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * DataZoom component entry
 */
echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(option) {
  var timelineOpt = option && option.timeline;

  if (!zrUtil.isArray(timelineOpt)) {
    timelineOpt = timelineOpt ? [timelineOpt] : [];
  }

  zrUtil.each(timelineOpt, function (opt) {
    if (!opt) {
      return;
    }

    compatibleEC2(opt);
  });
}

function compatibleEC2(opt) {
  var type = opt.type;
  var ec2Types = {
    'number': 'value',
    'time': 'time'
  }; // Compatible with ec2

  if (ec2Types[type]) {
    opt.axisType = ec2Types[type];
    delete opt.type;
  }

  transferItem(opt);

  if (has(opt, 'controlPosition')) {
    var controlStyle = opt.controlStyle || (opt.controlStyle = {});

    if (!has(controlStyle, 'position')) {
      controlStyle.position = opt.controlPosition;
    }

    if (controlStyle.position === 'none' && !has(controlStyle, 'show')) {
      controlStyle.show = false;
      delete controlStyle.position;
    }

    delete opt.controlPosition;
  }

  zrUtil.each(opt.data || [], function (dataItem) {
    if (zrUtil.isObject(dataItem) && !zrUtil.isArray(dataItem)) {
      if (!has(dataItem, 'value') && has(dataItem, 'name')) {
        // In ec2, using name as value.
        dataItem.value = dataItem.name;
      }

      transferItem(dataItem);
    }
  });
}

function transferItem(opt) {
  var itemStyle = opt.itemStyle || (opt.itemStyle = {});
  var itemStyleEmphasis = itemStyle.emphasis || (itemStyle.emphasis = {}); // Transfer label out

  var label = opt.label || opt.label || {};
  var labelNormal = label.normal || (label.normal = {});
  var excludeLabelAttr = {
    normal: 1,
    emphasis: 1
  };
  zrUtil.each(label, function (value, name) {
    if (!excludeLabelAttr[name] && !has(labelNormal, name)) {
      labelNormal[name] = value;
    }
  });

  if (itemStyleEmphasis.label && !has(label, 'emphasis')) {
    label.emphasis = itemStyleEmphasis.label;
    delete itemStyleEmphasis.label;
  }
}

function has(obj, attr) {
  return obj.hasOwnProperty(attr);
}

module.exports = _default;

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var Component = __webpack_require__(73);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
Component.registerSubTypeDefaulter('timeline', function () {
  // Only slider now.
  return 'slider';
});

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.registerAction({
  type: 'timelineChange',
  event: 'timelineChanged',
  update: 'prepareAndUpdate'
}, function (payload, ecModel) {
  var timelineModel = ecModel.getComponent('timeline');

  if (timelineModel && payload.currentIndex != null) {
    timelineModel.setCurrentIndex(payload.currentIndex);

    if (!timelineModel.get('loop', true) && timelineModel.isIndexMax()) {
      timelineModel.setPlayState(false);
    }
  } // Set normalized currentIndex to payload.


  ecModel.resetOption('timeline');
  return zrUtil.defaults({
    currentIndex: timelineModel.option.currentIndex
  }, payload);
});
echarts.registerAction({
  type: 'timelinePlayChange',
  event: 'timelinePlayChanged',
  update: 'update'
}, function (payload, ecModel) {
  var timelineModel = ecModel.getComponent('timeline');

  if (timelineModel && payload.playState != null) {
    timelineModel.setPlayState(payload.playState);
  }
});

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var TimelineModel = __webpack_require__(1781);

var dataFormatMixin = __webpack_require__(411);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var SliderTimelineModel = TimelineModel.extend({
  type: 'timeline.slider',

  /**
   * @protected
   */
  defaultOption: {
    backgroundColor: 'rgba(0,0,0,0)',
    // 时间轴背景颜色
    borderColor: '#ccc',
    // 时间轴边框颜色
    borderWidth: 0,
    // 时间轴边框线宽，单位px，默认为0（无边框）
    orient: 'horizontal',
    // 'vertical'
    inverse: false,
    tooltip: {
      // boolean or Object
      trigger: 'item' // data item may also have tootip attr.

    },
    symbol: 'emptyCircle',
    symbolSize: 10,
    lineStyle: {
      show: true,
      width: 2,
      color: '#304654'
    },
    label: {
      // 文本标签
      position: 'auto',
      // auto left right top bottom
      // When using number, label position is not
      // restricted by viewRect.
      // positive: right/bottom, negative: left/top
      show: true,
      interval: 'auto',
      rotate: 0,
      // formatter: null,
      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
      color: '#304654'
    },
    itemStyle: {
      color: '#304654',
      borderWidth: 1
    },
    checkpointStyle: {
      symbol: 'circle',
      symbolSize: 13,
      color: '#c23531',
      borderWidth: 5,
      borderColor: 'rgba(194,53,49, 0.5)',
      animation: true,
      animationDuration: 300,
      animationEasing: 'quinticInOut'
    },
    controlStyle: {
      show: true,
      showPlayBtn: true,
      showPrevBtn: true,
      showNextBtn: true,
      itemSize: 22,
      itemGap: 12,
      position: 'left',
      // 'left' 'right' 'top' 'bottom'
      playIcon: 'path://M31.6,53C17.5,53,6,41.5,6,27.4S17.5,1.8,31.6,1.8C45.7,1.8,57.2,13.3,57.2,27.4S45.7,53,31.6,53z M31.6,3.3 C18.4,3.3,7.5,14.1,7.5,27.4c0,13.3,10.8,24.1,24.1,24.1C44.9,51.5,55.7,40.7,55.7,27.4C55.7,14.1,44.9,3.3,31.6,3.3z M24.9,21.3 c0-2.2,1.6-3.1,3.5-2l10.5,6.1c1.899,1.1,1.899,2.9,0,4l-10.5,6.1c-1.9,1.1-3.5,0.2-3.5-2V21.3z',
      // jshint ignore:line
      stopIcon: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
      // jshint ignore:line
      nextIcon: 'path://M18.6,50.8l22.5-22.5c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7L18.7,4.4c-0.1-0.1-0.2-0.3-0.2-0.5 c0-0.4,0.3-0.8,0.8-0.8c0.2,0,0.5,0.1,0.6,0.3l23.5,23.5l0,0c0.2,0.2,0.3,0.4,0.3,0.7c0,0.3-0.1,0.5-0.3,0.7l-0.1,0.1L19.7,52 c-0.1,0.1-0.3,0.2-0.5,0.2c-0.4,0-0.8-0.3-0.8-0.8C18.4,51.2,18.5,51,18.6,50.8z',
      // jshint ignore:line
      prevIcon: 'path://M43,52.8L20.4,30.3c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.3,0.1-0.5,0.3-0.7L42.9,6.4c0.1-0.1,0.2-0.3,0.2-0.5 c0-0.4-0.3-0.8-0.8-0.8c-0.2,0-0.5,0.1-0.6,0.3L18.3,28.8l0,0c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7l0.1,0.1L41.9,54 c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0,0.8-0.3,0.8-0.8C43.2,53.2,43.1,53,43,52.8z',
      // jshint ignore:line
      color: '#304654',
      borderColor: '#304654',
      borderWidth: 1
    },
    emphasis: {
      label: {
        show: true,
        // 其余属性默认使用全局文本样式，详见TEXTSTYLE
        color: '#c23531'
      },
      itemStyle: {
        color: '#c23531'
      },
      controlStyle: {
        color: '#c23531',
        borderColor: '#c23531',
        borderWidth: 2
      }
    },
    data: []
  }
});
zrUtil.mixin(SliderTimelineModel, dataFormatMixin);
var _default = SliderTimelineModel;
module.exports = _default;

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var ComponentModel = __webpack_require__(73);

var List = __webpack_require__(98);

var modelUtil = __webpack_require__(44);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var TimelineModel = ComponentModel.extend({
  type: 'timeline',
  layoutMode: 'box',

  /**
   * @protected
   */
  defaultOption: {
    zlevel: 0,
    // 一级层叠
    z: 4,
    // 二级层叠
    show: true,
    axisType: 'time',
    // 模式是时间类型，支持 value, category
    realtime: true,
    left: '20%',
    top: null,
    right: '20%',
    bottom: 0,
    width: null,
    height: 40,
    padding: 5,
    controlPosition: 'left',
    // 'left' 'right' 'top' 'bottom' 'none'
    autoPlay: false,
    rewind: false,
    // 反向播放
    loop: true,
    playInterval: 2000,
    // 播放时间间隔，单位ms
    currentIndex: 0,
    itemStyle: {},
    label: {
      color: '#000'
    },
    data: []
  },

  /**
   * @override
   */
  init: function (option, parentModel, ecModel) {
    /**
     * @private
     * @type {module:echarts/data/List}
     */
    this._data;
    /**
     * @private
     * @type {Array.<string>}
     */

    this._names;
    this.mergeDefaultAndTheme(option, ecModel);

    this._initData();
  },

  /**
   * @override
   */
  mergeOption: function (option) {
    TimelineModel.superApply(this, 'mergeOption', arguments);

    this._initData();
  },

  /**
   * @param {number} [currentIndex]
   */
  setCurrentIndex: function (currentIndex) {
    if (currentIndex == null) {
      currentIndex = this.option.currentIndex;
    }

    var count = this._data.count();

    if (this.option.loop) {
      currentIndex = (currentIndex % count + count) % count;
    } else {
      currentIndex >= count && (currentIndex = count - 1);
      currentIndex < 0 && (currentIndex = 0);
    }

    this.option.currentIndex = currentIndex;
  },

  /**
   * @return {number} currentIndex
   */
  getCurrentIndex: function () {
    return this.option.currentIndex;
  },

  /**
   * @return {boolean}
   */
  isIndexMax: function () {
    return this.getCurrentIndex() >= this._data.count() - 1;
  },

  /**
   * @param {boolean} state true: play, false: stop
   */
  setPlayState: function (state) {
    this.option.autoPlay = !!state;
  },

  /**
   * @return {boolean} true: play, false: stop
   */
  getPlayState: function () {
    return !!this.option.autoPlay;
  },

  /**
   * @private
   */
  _initData: function () {
    var thisOption = this.option;
    var dataArr = thisOption.data || [];
    var axisType = thisOption.axisType;
    var names = this._names = [];

    if (axisType === 'category') {
      var idxArr = [];
      zrUtil.each(dataArr, function (item, index) {
        var value = modelUtil.getDataItemValue(item);
        var newItem;

        if (zrUtil.isObject(item)) {
          newItem = zrUtil.clone(item);
          newItem.value = index;
        } else {
          newItem = index;
        }

        idxArr.push(newItem);

        if (!zrUtil.isString(value) && (value == null || isNaN(value))) {
          value = '';
        }

        names.push(value + '');
      });
      dataArr = idxArr;
    }

    var dimType = {
      category: 'ordinal',
      time: 'time'
    }[axisType] || 'number';
    var data = this._data = new List([{
      name: 'value',
      type: dimType
    }], this);
    data.initData(dataArr, names);
  },
  getData: function () {
    return this._data;
  },

  /**
   * @public
   * @return {Array.<string>} categoreis
   */
  getCategories: function () {
    if (this.get('axisType') === 'category') {
      return this._names.slice();
    }
  }
});
var _default = TimelineModel;
module.exports = _default;

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var BoundingRect = __webpack_require__(57);

var matrix = __webpack_require__(82);

var graphic = __webpack_require__(27);

var layout = __webpack_require__(53);

var TimelineView = __webpack_require__(1783);

var TimelineAxis = __webpack_require__(1784);

var _symbol = __webpack_require__(99);

var createSymbol = _symbol.createSymbol;

var axisHelper = __webpack_require__(109);

var numberUtil = __webpack_require__(37);

var _format = __webpack_require__(54);

var encodeHTML = _format.encodeHTML;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var bind = zrUtil.bind;
var each = zrUtil.each;
var PI = Math.PI;

var _default = TimelineView.extend({
  type: 'timeline.slider',
  init: function (ecModel, api) {
    this.api = api;
    /**
     * @private
     * @type {module:echarts/component/timeline/TimelineAxis}
     */

    this._axis;
    /**
     * @private
     * @type {module:zrender/core/BoundingRect}
     */

    this._viewRect;
    /**
     * @type {number}
     */

    this._timer;
    /**
     * @type {module:zrender/Element}
     */

    this._currentPointer;
    /**
     * @type {module:zrender/container/Group}
     */

    this._mainGroup;
    /**
     * @type {module:zrender/container/Group}
     */

    this._labelGroup;
  },

  /**
   * @override
   */
  render: function (timelineModel, ecModel, api, payload) {
    this.model = timelineModel;
    this.api = api;
    this.ecModel = ecModel;
    this.group.removeAll();

    if (timelineModel.get('show', true)) {
      var layoutInfo = this._layout(timelineModel, api);

      var mainGroup = this._createGroup('mainGroup');

      var labelGroup = this._createGroup('labelGroup');
      /**
       * @private
       * @type {module:echarts/component/timeline/TimelineAxis}
       */


      var axis = this._axis = this._createAxis(layoutInfo, timelineModel);

      timelineModel.formatTooltip = function (dataIndex) {
        return encodeHTML(axis.scale.getLabel(dataIndex));
      };

      each(['AxisLine', 'AxisTick', 'Control', 'CurrentPointer'], function (name) {
        this['_render' + name](layoutInfo, mainGroup, axis, timelineModel);
      }, this);

      this._renderAxisLabel(layoutInfo, labelGroup, axis, timelineModel);

      this._position(layoutInfo, timelineModel);
    }

    this._doPlayStop();
  },

  /**
   * @override
   */
  remove: function () {
    this._clearTimer();

    this.group.removeAll();
  },

  /**
   * @override
   */
  dispose: function () {
    this._clearTimer();
  },
  _layout: function (timelineModel, api) {
    var labelPosOpt = timelineModel.get('label.position');
    var orient = timelineModel.get('orient');
    var viewRect = getViewRect(timelineModel, api); // Auto label offset.

    if (labelPosOpt == null || labelPosOpt === 'auto') {
      labelPosOpt = orient === 'horizontal' ? viewRect.y + viewRect.height / 2 < api.getHeight() / 2 ? '-' : '+' : viewRect.x + viewRect.width / 2 < api.getWidth() / 2 ? '+' : '-';
    } else if (isNaN(labelPosOpt)) {
      labelPosOpt = {
        horizontal: {
          top: '-',
          bottom: '+'
        },
        vertical: {
          left: '-',
          right: '+'
        }
      }[orient][labelPosOpt];
    }

    var labelAlignMap = {
      horizontal: 'center',
      vertical: labelPosOpt >= 0 || labelPosOpt === '+' ? 'left' : 'right'
    };
    var labelBaselineMap = {
      horizontal: labelPosOpt >= 0 || labelPosOpt === '+' ? 'top' : 'bottom',
      vertical: 'middle'
    };
    var rotationMap = {
      horizontal: 0,
      vertical: PI / 2
    }; // Position

    var mainLength = orient === 'vertical' ? viewRect.height : viewRect.width;
    var controlModel = timelineModel.getModel('controlStyle');
    var showControl = controlModel.get('show', true);
    var controlSize = showControl ? controlModel.get('itemSize') : 0;
    var controlGap = showControl ? controlModel.get('itemGap') : 0;
    var sizePlusGap = controlSize + controlGap; // Special label rotate.

    var labelRotation = timelineModel.get('label.rotate') || 0;
    labelRotation = labelRotation * PI / 180; // To radian.

    var playPosition;
    var prevBtnPosition;
    var nextBtnPosition;
    var axisExtent;
    var controlPosition = controlModel.get('position', true);
    var showPlayBtn = showControl && controlModel.get('showPlayBtn', true);
    var showPrevBtn = showControl && controlModel.get('showPrevBtn', true);
    var showNextBtn = showControl && controlModel.get('showNextBtn', true);
    var xLeft = 0;
    var xRight = mainLength; // position[0] means left, position[1] means middle.

    if (controlPosition === 'left' || controlPosition === 'bottom') {
      showPlayBtn && (playPosition = [0, 0], xLeft += sizePlusGap);
      showPrevBtn && (prevBtnPosition = [xLeft, 0], xLeft += sizePlusGap);
      showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
    } else {
      // 'top' 'right'
      showPlayBtn && (playPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
      showPrevBtn && (prevBtnPosition = [0, 0], xLeft += sizePlusGap);
      showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
    }

    axisExtent = [xLeft, xRight];

    if (timelineModel.get('inverse')) {
      axisExtent.reverse();
    }

    return {
      viewRect: viewRect,
      mainLength: mainLength,
      orient: orient,
      rotation: rotationMap[orient],
      labelRotation: labelRotation,
      labelPosOpt: labelPosOpt,
      labelAlign: timelineModel.get('label.align') || labelAlignMap[orient],
      labelBaseline: timelineModel.get('label.verticalAlign') || timelineModel.get('label.baseline') || labelBaselineMap[orient],
      // Based on mainGroup.
      playPosition: playPosition,
      prevBtnPosition: prevBtnPosition,
      nextBtnPosition: nextBtnPosition,
      axisExtent: axisExtent,
      controlSize: controlSize,
      controlGap: controlGap
    };
  },
  _position: function (layoutInfo, timelineModel) {
    // Position is be called finally, because bounding rect is needed for
    // adapt content to fill viewRect (auto adapt offset).
    // Timeline may be not all in the viewRect when 'offset' is specified
    // as a number, because it is more appropriate that label aligns at
    // 'offset' but not the other edge defined by viewRect.
    var mainGroup = this._mainGroup;
    var labelGroup = this._labelGroup;
    var viewRect = layoutInfo.viewRect;

    if (layoutInfo.orient === 'vertical') {
      // transform to horizontal, inverse rotate by left-top point.
      var m = matrix.create();
      var rotateOriginX = viewRect.x;
      var rotateOriginY = viewRect.y + viewRect.height;
      matrix.translate(m, m, [-rotateOriginX, -rotateOriginY]);
      matrix.rotate(m, m, -PI / 2);
      matrix.translate(m, m, [rotateOriginX, rotateOriginY]);
      viewRect = viewRect.clone();
      viewRect.applyTransform(m);
    }

    var viewBound = getBound(viewRect);
    var mainBound = getBound(mainGroup.getBoundingRect());
    var labelBound = getBound(labelGroup.getBoundingRect());
    var mainPosition = mainGroup.position;
    var labelsPosition = labelGroup.position;
    labelsPosition[0] = mainPosition[0] = viewBound[0][0];
    var labelPosOpt = layoutInfo.labelPosOpt;

    if (isNaN(labelPosOpt)) {
      // '+' or '-'
      var mainBoundIdx = labelPosOpt === '+' ? 0 : 1;
      toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
      toBound(labelsPosition, labelBound, viewBound, 1, 1 - mainBoundIdx);
    } else {
      var mainBoundIdx = labelPosOpt >= 0 ? 0 : 1;
      toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
      labelsPosition[1] = mainPosition[1] + labelPosOpt;
    }

    mainGroup.attr('position', mainPosition);
    labelGroup.attr('position', labelsPosition);
    mainGroup.rotation = labelGroup.rotation = layoutInfo.rotation;
    setOrigin(mainGroup);
    setOrigin(labelGroup);

    function setOrigin(targetGroup) {
      var pos = targetGroup.position;
      targetGroup.origin = [viewBound[0][0] - pos[0], viewBound[1][0] - pos[1]];
    }

    function getBound(rect) {
      // [[xmin, xmax], [ymin, ymax]]
      return [[rect.x, rect.x + rect.width], [rect.y, rect.y + rect.height]];
    }

    function toBound(fromPos, from, to, dimIdx, boundIdx) {
      fromPos[dimIdx] += to[dimIdx][boundIdx] - from[dimIdx][boundIdx];
    }
  },
  _createAxis: function (layoutInfo, timelineModel) {
    var data = timelineModel.getData();
    var axisType = timelineModel.get('axisType');
    var scale = axisHelper.createScaleByModel(timelineModel, axisType); // Customize scale. The `tickValue` is `dataIndex`.

    scale.getTicks = function () {
      return data.mapArray(['value'], function (value) {
        return value;
      });
    };

    var dataExtent = data.getDataExtent('value');
    scale.setExtent(dataExtent[0], dataExtent[1]);
    scale.niceTicks();
    var axis = new TimelineAxis('value', scale, layoutInfo.axisExtent, axisType);
    axis.model = timelineModel;
    return axis;
  },
  _createGroup: function (name) {
    var newGroup = this['_' + name] = new graphic.Group();
    this.group.add(newGroup);
    return newGroup;
  },
  _renderAxisLine: function (layoutInfo, group, axis, timelineModel) {
    var axisExtent = axis.getExtent();

    if (!timelineModel.get('lineStyle.show')) {
      return;
    }

    group.add(new graphic.Line({
      shape: {
        x1: axisExtent[0],
        y1: 0,
        x2: axisExtent[1],
        y2: 0
      },
      style: zrUtil.extend({
        lineCap: 'round'
      }, timelineModel.getModel('lineStyle').getLineStyle()),
      silent: true,
      z2: 1
    }));
  },

  /**
   * @private
   */
  _renderAxisTick: function (layoutInfo, group, axis, timelineModel) {
    var data = timelineModel.getData(); // Show all ticks, despite ignoring strategy.

    var ticks = axis.scale.getTicks(); // The value is dataIndex, see the costomized scale.

    each(ticks, function (value) {
      var tickCoord = axis.dataToCoord(value);
      var itemModel = data.getItemModel(value);
      var itemStyleModel = itemModel.getModel('itemStyle');
      var hoverStyleModel = itemModel.getModel('emphasis.itemStyle');
      var symbolOpt = {
        position: [tickCoord, 0],
        onclick: bind(this._changeTimeline, this, value)
      };
      var el = giveSymbol(itemModel, itemStyleModel, group, symbolOpt);
      graphic.setHoverStyle(el, hoverStyleModel.getItemStyle());

      if (itemModel.get('tooltip')) {
        el.dataIndex = value;
        el.dataModel = timelineModel;
      } else {
        el.dataIndex = el.dataModel = null;
      }
    }, this);
  },

  /**
   * @private
   */
  _renderAxisLabel: function (layoutInfo, group, axis, timelineModel) {
    var labelModel = axis.getLabelModel();

    if (!labelModel.get('show')) {
      return;
    }

    var data = timelineModel.getData();
    var labels = axis.getViewLabels();
    each(labels, function (labelItem) {
      // The tickValue is dataIndex, see the costomized scale.
      var dataIndex = labelItem.tickValue;
      var itemModel = data.getItemModel(dataIndex);
      var normalLabelModel = itemModel.getModel('label');
      var hoverLabelModel = itemModel.getModel('emphasis.label');
      var tickCoord = axis.dataToCoord(labelItem.tickValue);
      var textEl = new graphic.Text({
        position: [tickCoord, 0],
        rotation: layoutInfo.labelRotation - layoutInfo.rotation,
        onclick: bind(this._changeTimeline, this, dataIndex),
        silent: false
      });
      graphic.setTextStyle(textEl.style, normalLabelModel, {
        text: labelItem.formattedLabel,
        textAlign: layoutInfo.labelAlign,
        textVerticalAlign: layoutInfo.labelBaseline
      });
      group.add(textEl);
      graphic.setHoverStyle(textEl, graphic.setTextStyle({}, hoverLabelModel));
    }, this);
  },

  /**
   * @private
   */
  _renderControl: function (layoutInfo, group, axis, timelineModel) {
    var controlSize = layoutInfo.controlSize;
    var rotation = layoutInfo.rotation;
    var itemStyle = timelineModel.getModel('controlStyle').getItemStyle();
    var hoverStyle = timelineModel.getModel('emphasis.controlStyle').getItemStyle();
    var rect = [0, -controlSize / 2, controlSize, controlSize];
    var playState = timelineModel.getPlayState();
    var inverse = timelineModel.get('inverse', true);
    makeBtn(layoutInfo.nextBtnPosition, 'controlStyle.nextIcon', bind(this._changeTimeline, this, inverse ? '-' : '+'));
    makeBtn(layoutInfo.prevBtnPosition, 'controlStyle.prevIcon', bind(this._changeTimeline, this, inverse ? '+' : '-'));
    makeBtn(layoutInfo.playPosition, 'controlStyle.' + (playState ? 'stopIcon' : 'playIcon'), bind(this._handlePlayClick, this, !playState), true);

    function makeBtn(position, iconPath, onclick, willRotate) {
      if (!position) {
        return;
      }

      var opt = {
        position: position,
        origin: [controlSize / 2, 0],
        rotation: willRotate ? -rotation : 0,
        rectHover: true,
        style: itemStyle,
        onclick: onclick
      };
      var btn = makeIcon(timelineModel, iconPath, rect, opt);
      group.add(btn);
      graphic.setHoverStyle(btn, hoverStyle);
    }
  },
  _renderCurrentPointer: function (layoutInfo, group, axis, timelineModel) {
    var data = timelineModel.getData();
    var currentIndex = timelineModel.getCurrentIndex();
    var pointerModel = data.getItemModel(currentIndex).getModel('checkpointStyle');
    var me = this;
    var callback = {
      onCreate: function (pointer) {
        pointer.draggable = true;
        pointer.drift = bind(me._handlePointerDrag, me);
        pointer.ondragend = bind(me._handlePointerDragend, me);
        pointerMoveTo(pointer, currentIndex, axis, timelineModel, true);
      },
      onUpdate: function (pointer) {
        pointerMoveTo(pointer, currentIndex, axis, timelineModel);
      }
    }; // Reuse when exists, for animation and drag.

    this._currentPointer = giveSymbol(pointerModel, pointerModel, this._mainGroup, {}, this._currentPointer, callback);
  },
  _handlePlayClick: function (nextState) {
    this._clearTimer();

    this.api.dispatchAction({
      type: 'timelinePlayChange',
      playState: nextState,
      from: this.uid
    });
  },
  _handlePointerDrag: function (dx, dy, e) {
    this._clearTimer();

    this._pointerChangeTimeline([e.offsetX, e.offsetY]);
  },
  _handlePointerDragend: function (e) {
    this._pointerChangeTimeline([e.offsetX, e.offsetY], true);
  },
  _pointerChangeTimeline: function (mousePos, trigger) {
    var toCoord = this._toAxisCoord(mousePos)[0];

    var axis = this._axis;
    var axisExtent = numberUtil.asc(axis.getExtent().slice());
    toCoord > axisExtent[1] && (toCoord = axisExtent[1]);
    toCoord < axisExtent[0] && (toCoord = axisExtent[0]);
    this._currentPointer.position[0] = toCoord;

    this._currentPointer.dirty();

    var targetDataIndex = this._findNearestTick(toCoord);

    var timelineModel = this.model;

    if (trigger || targetDataIndex !== timelineModel.getCurrentIndex() && timelineModel.get('realtime')) {
      this._changeTimeline(targetDataIndex);
    }
  },
  _doPlayStop: function () {
    this._clearTimer();

    if (this.model.getPlayState()) {
      this._timer = setTimeout(bind(handleFrame, this), this.model.get('playInterval'));
    }

    function handleFrame() {
      // Do not cache
      var timelineModel = this.model;

      this._changeTimeline(timelineModel.getCurrentIndex() + (timelineModel.get('rewind', true) ? -1 : 1));
    }
  },
  _toAxisCoord: function (vertex) {
    var trans = this._mainGroup.getLocalTransform();

    return graphic.applyTransform(vertex, trans, true);
  },
  _findNearestTick: function (axisCoord) {
    var data = this.model.getData();
    var dist = Infinity;
    var targetDataIndex;
    var axis = this._axis;
    data.each(['value'], function (value, dataIndex) {
      var coord = axis.dataToCoord(value);
      var d = Math.abs(coord - axisCoord);

      if (d < dist) {
        dist = d;
        targetDataIndex = dataIndex;
      }
    });
    return targetDataIndex;
  },
  _clearTimer: function () {
    if (this._timer) {
      clearTimeout(this._timer);
      this._timer = null;
    }
  },
  _changeTimeline: function (nextIndex) {
    var currentIndex = this.model.getCurrentIndex();

    if (nextIndex === '+') {
      nextIndex = currentIndex + 1;
    } else if (nextIndex === '-') {
      nextIndex = currentIndex - 1;
    }

    this.api.dispatchAction({
      type: 'timelineChange',
      currentIndex: nextIndex,
      from: this.uid
    });
  }
});

function getViewRect(model, api) {
  return layout.getLayoutRect(model.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  }, model.get('padding'));
}

function makeIcon(timelineModel, objPath, rect, opts) {
  var style = opts.style;
  var icon = graphic.createIcon(timelineModel.get(objPath), opts || {}, new BoundingRect(rect[0], rect[1], rect[2], rect[3])); // TODO createIcon won't use style in opt.

  if (style) {
    icon.setStyle(style);
  }

  return icon;
}
/**
 * Create symbol or update symbol
 * opt: basic position and event handlers
 */


function giveSymbol(hostModel, itemStyleModel, group, opt, symbol, callback) {
  var color = itemStyleModel.get('color');

  if (!symbol) {
    var symbolType = hostModel.get('symbol');
    symbol = createSymbol(symbolType, -1, -1, 2, 2, color);
    symbol.setStyle('strokeNoScale', true);
    group.add(symbol);
    callback && callback.onCreate(symbol);
  } else {
    symbol.setColor(color);
    group.add(symbol); // Group may be new, also need to add.

    callback && callback.onUpdate(symbol);
  } // Style


  var itemStyle = itemStyleModel.getItemStyle(['color', 'symbol', 'symbolSize']);
  symbol.setStyle(itemStyle); // Transform and events.

  opt = zrUtil.merge({
    rectHover: true,
    z2: 100
  }, opt, true);
  var symbolSize = hostModel.get('symbolSize');
  symbolSize = symbolSize instanceof Array ? symbolSize.slice() : [+symbolSize, +symbolSize];
  symbolSize[0] /= 2;
  symbolSize[1] /= 2;
  opt.scale = symbolSize;
  var symbolOffset = hostModel.get('symbolOffset');

  if (symbolOffset) {
    var pos = opt.position = opt.position || [0, 0];
    pos[0] += numberUtil.parsePercent(symbolOffset[0], symbolSize[0]);
    pos[1] += numberUtil.parsePercent(symbolOffset[1], symbolSize[1]);
  }

  var symbolRotate = hostModel.get('symbolRotate');
  opt.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
  symbol.attr(opt); // FIXME
  // (1) When symbol.style.strokeNoScale is true and updateTransform is not performed,
  // getBoundingRect will return wrong result.
  // (This is supposed to be resolved in zrender, but it is a little difficult to
  // leverage performance and auto updateTransform)
  // (2) All of ancesters of symbol do not scale, so we can just updateTransform symbol.

  symbol.updateTransform();
  return symbol;
}

function pointerMoveTo(pointer, dataIndex, axis, timelineModel, noAnimation) {
  if (pointer.dragging) {
    return;
  }

  var pointerModel = timelineModel.getModel('checkpointStyle');
  var toCoord = axis.dataToCoord(timelineModel.getData().get(['value'], dataIndex));

  if (noAnimation || !pointerModel.get('animation', true)) {
    pointer.attr({
      position: [toCoord, 0]
    });
  } else {
    pointer.stopAnimation(true);
    pointer.animateTo({
      position: [toCoord, 0]
    }, pointerModel.get('animationDuration', true), pointerModel.get('animationEasing', true));
  }
}

module.exports = _default;

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var ComponentView = __webpack_require__(297);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = ComponentView.extend({
  type: 'timeline'
});

module.exports = _default;

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var Axis = __webpack_require__(150);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Extend axis 2d
 * @constructor module:echarts/coord/cartesian/Axis2D
 * @extends {module:echarts/coord/cartesian/Axis}
 * @param {string} dim
 * @param {*} scale
 * @param {Array.<number>} coordExtent
 * @param {string} axisType
 * @param {string} position
 */
var TimelineAxis = function (dim, scale, coordExtent, axisType) {
  Axis.call(this, dim, scale, coordExtent);
  /**
   * Axis type
   *  - 'category'
   *  - 'value'
   *  - 'time'
   *  - 'log'
   * @type {string}
   */

  this.type = axisType || 'value';
  /**
   * Axis model
   * @param {module:echarts/component/TimelineModel}
   */

  this.model = null;
};

TimelineAxis.prototype = {
  constructor: TimelineAxis,

  /**
   * @override
   */
  getLabelModel: function () {
    return this.model.getModel('label');
  },

  /**
   * @override
   */
  isHorizontal: function () {
    return this.model.get('orient') === 'horizontal';
  }
};
zrUtil.inherits(TimelineAxis, Axis);
var _default = TimelineAxis;
module.exports = _default;

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(1786);

__webpack_require__(1787);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// HINT Markpoint can't be used too much
echarts.registerPreprocessor(function (opt) {
  // Make sure markPoint component is enabled
  opt.markPoint = opt.markPoint || {};
});

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var MarkerModel = __webpack_require__(432);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = MarkerModel.extend({
  type: 'markPoint',
  defaultOption: {
    zlevel: 0,
    z: 5,
    symbol: 'pin',
    symbolSize: 50,
    //symbolRotate: 0,
    //symbolOffset: [0, 0]
    tooltip: {
      trigger: 'item'
    },
    label: {
      show: true,
      position: 'inside'
    },
    itemStyle: {
      borderWidth: 2
    },
    emphasis: {
      label: {
        show: true
      }
    }
  }
});

module.exports = _default;

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var SymbolDraw = __webpack_require__(239);

var numberUtil = __webpack_require__(37);

var List = __webpack_require__(98);

var markerHelper = __webpack_require__(433);

var MarkerView = __webpack_require__(434);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function updateMarkerLayout(mpData, seriesModel, api) {
  var coordSys = seriesModel.coordinateSystem;
  mpData.each(function (idx) {
    var itemModel = mpData.getItemModel(idx);
    var point;
    var xPx = numberUtil.parsePercent(itemModel.get('x'), api.getWidth());
    var yPx = numberUtil.parsePercent(itemModel.get('y'), api.getHeight());

    if (!isNaN(xPx) && !isNaN(yPx)) {
      point = [xPx, yPx];
    } // Chart like bar may have there own marker positioning logic
    else if (seriesModel.getMarkerPosition) {
        // Use the getMarkerPoisition
        point = seriesModel.getMarkerPosition(mpData.getValues(mpData.dimensions, idx));
      } else if (coordSys) {
        var x = mpData.get(coordSys.dimensions[0], idx);
        var y = mpData.get(coordSys.dimensions[1], idx);
        point = coordSys.dataToPoint([x, y]);
      } // Use x, y if has any


    if (!isNaN(xPx)) {
      point[0] = xPx;
    }

    if (!isNaN(yPx)) {
      point[1] = yPx;
    }

    mpData.setItemLayout(idx, point);
  });
}

var _default = MarkerView.extend({
  type: 'markPoint',
  // updateLayout: function (markPointModel, ecModel, api) {
  //     ecModel.eachSeries(function (seriesModel) {
  //         var mpModel = seriesModel.markPointModel;
  //         if (mpModel) {
  //             updateMarkerLayout(mpModel.getData(), seriesModel, api);
  //             this.markerGroupMap.get(seriesModel.id).updateLayout(mpModel);
  //         }
  //     }, this);
  // },
  updateTransform: function (markPointModel, ecModel, api) {
    ecModel.eachSeries(function (seriesModel) {
      var mpModel = seriesModel.markPointModel;

      if (mpModel) {
        updateMarkerLayout(mpModel.getData(), seriesModel, api);
        this.markerGroupMap.get(seriesModel.id).updateLayout(mpModel);
      }
    }, this);
  },
  renderSeries: function (seriesModel, mpModel, ecModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var seriesId = seriesModel.id;
    var seriesData = seriesModel.getData();
    var symbolDrawMap = this.markerGroupMap;
    var symbolDraw = symbolDrawMap.get(seriesId) || symbolDrawMap.set(seriesId, new SymbolDraw());
    var mpData = createList(coordSys, seriesModel, mpModel); // FIXME

    mpModel.setData(mpData);
    updateMarkerLayout(mpModel.getData(), seriesModel, api);
    mpData.each(function (idx) {
      var itemModel = mpData.getItemModel(idx);
      var symbol = itemModel.getShallow('symbol');
      var symbolSize = itemModel.getShallow('symbolSize');
      var symbolRotate = itemModel.getShallow('symbolRotate');
      var isFnSymbol = zrUtil.isFunction(symbol);
      var isFnSymbolSize = zrUtil.isFunction(symbolSize);
      var isFnSymbolRotate = zrUtil.isFunction(symbolRotate);

      if (isFnSymbol || isFnSymbolSize || isFnSymbolRotate) {
        var rawIdx = mpModel.getRawValue(idx);
        var dataParams = mpModel.getDataParams(idx);

        if (isFnSymbol) {
          symbol = symbol(rawIdx, dataParams);
        }

        if (isFnSymbolSize) {
          // FIXME 这里不兼容 ECharts 2.x，2.x 貌似参数是整个数据？
          symbolSize = symbolSize(rawIdx, dataParams);
        }

        if (isFnSymbolRotate) {
          symbolRotate = symbolRotate(rawIdx, dataParams);
        }
      }

      mpData.setItemVisual(idx, {
        symbol: symbol,
        symbolSize: symbolSize,
        symbolRotate: symbolRotate,
        color: itemModel.get('itemStyle.color') || seriesData.getVisual('color')
      });
    }); // TODO Text are wrong

    symbolDraw.updateData(mpData);
    this.group.add(symbolDraw.group); // Set host model for tooltip
    // FIXME

    mpData.eachItemGraphicEl(function (el) {
      el.traverse(function (child) {
        child.dataModel = mpModel;
      });
    });
    symbolDraw.__keep = true;
    symbolDraw.group.silent = mpModel.get('silent') || seriesModel.get('silent');
  }
});
/**
 * @inner
 * @param {module:echarts/coord/*} [coordSys]
 * @param {module:echarts/model/Series} seriesModel
 * @param {module:echarts/model/Model} mpModel
 */


function createList(coordSys, seriesModel, mpModel) {
  var coordDimsInfos;

  if (coordSys) {
    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
      var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys

      return zrUtil.defaults({
        name: coordDim
      }, info);
    });
  } else {
    coordDimsInfos = [{
      name: 'value',
      type: 'float'
    }];
  }

  var mpData = new List(coordDimsInfos, mpModel);
  var dataOpt = zrUtil.map(mpModel.get('data'), zrUtil.curry(markerHelper.dataTransform, seriesModel));

  if (coordSys) {
    dataOpt = zrUtil.filter(dataOpt, zrUtil.curry(markerHelper.dataFilter, coordSys));
  }

  mpData.initData(dataOpt, null, coordSys ? markerHelper.dimValueGetter : function (item) {
    return item.value;
  });
  return mpData;
}

module.exports = _default;

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(1789);

__webpack_require__(1790);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.registerPreprocessor(function (opt) {
  // Make sure markLine component is enabled
  opt.markLine = opt.markLine || {};
});

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var MarkerModel = __webpack_require__(432);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = MarkerModel.extend({
  type: 'markLine',
  defaultOption: {
    zlevel: 0,
    z: 5,
    symbol: ['circle', 'arrow'],
    symbolSize: [8, 16],
    //symbolRotate: 0,
    precision: 2,
    tooltip: {
      trigger: 'item'
    },
    label: {
      show: true,
      position: 'end',
      distance: 5
    },
    lineStyle: {
      type: 'dashed'
    },
    emphasis: {
      label: {
        show: true
      },
      lineStyle: {
        width: 3
      }
    },
    animationEasing: 'linear'
  }
});

module.exports = _default;

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var List = __webpack_require__(98);

var numberUtil = __webpack_require__(37);

var markerHelper = __webpack_require__(433);

var LineDraw = __webpack_require__(422);

var MarkerView = __webpack_require__(434);

var _dataStackHelper = __webpack_require__(124);

var getStackedDimension = _dataStackHelper.getStackedDimension;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var markLineTransform = function (seriesModel, coordSys, mlModel, item) {
  var data = seriesModel.getData(); // Special type markLine like 'min', 'max', 'average', 'median'

  var mlType = item.type;

  if (!zrUtil.isArray(item) && (mlType === 'min' || mlType === 'max' || mlType === 'average' || mlType === 'median' // In case
  // data: [{
  //   yAxis: 10
  // }]
  || item.xAxis != null || item.yAxis != null)) {
    var valueAxis;
    var value;

    if (item.yAxis != null || item.xAxis != null) {
      valueAxis = coordSys.getAxis(item.yAxis != null ? 'y' : 'x');
      value = zrUtil.retrieve(item.yAxis, item.xAxis);
    } else {
      var axisInfo = markerHelper.getAxisInfo(item, data, coordSys, seriesModel);
      valueAxis = axisInfo.valueAxis;
      var valueDataDim = getStackedDimension(data, axisInfo.valueDataDim);
      value = markerHelper.numCalculate(data, valueDataDim, mlType);
    }

    var valueIndex = valueAxis.dim === 'x' ? 0 : 1;
    var baseIndex = 1 - valueIndex;
    var mlFrom = zrUtil.clone(item);
    var mlTo = {};
    mlFrom.type = null;
    mlFrom.coord = [];
    mlTo.coord = [];
    mlFrom.coord[baseIndex] = -Infinity;
    mlTo.coord[baseIndex] = Infinity;
    var precision = mlModel.get('precision');

    if (precision >= 0 && typeof value === 'number') {
      value = +value.toFixed(Math.min(precision, 20));
    }

    mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
    item = [mlFrom, mlTo, {
      // Extra option for tooltip and label
      type: mlType,
      valueIndex: item.valueIndex,
      // Force to use the value of calculated value.
      value: value
    }];
  }

  item = [markerHelper.dataTransform(seriesModel, item[0]), markerHelper.dataTransform(seriesModel, item[1]), zrUtil.extend({}, item[2])]; // Avoid line data type is extended by from(to) data type

  item[2].type = item[2].type || ''; // Merge from option and to option into line option

  zrUtil.merge(item[2], item[0]);
  zrUtil.merge(item[2], item[1]);
  return item;
};

function isInifinity(val) {
  return !isNaN(val) && !isFinite(val);
} // If a markLine has one dim


function ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
  var otherDimIndex = 1 - dimIndex;
  var dimName = coordSys.dimensions[dimIndex];
  return isInifinity(fromCoord[otherDimIndex]) && isInifinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
}

function markLineFilter(coordSys, item) {
  if (coordSys.type === 'cartesian2d') {
    var fromCoord = item[0].coord;
    var toCoord = item[1].coord; // In case
    // {
    //  markLine: {
    //    data: [{ yAxis: 2 }]
    //  }
    // }

    if (fromCoord && toCoord && (ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) {
      return true;
    }
  }

  return markerHelper.dataFilter(coordSys, item[0]) && markerHelper.dataFilter(coordSys, item[1]);
}

function updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
  var coordSys = seriesModel.coordinateSystem;
  var itemModel = data.getItemModel(idx);
  var point;
  var xPx = numberUtil.parsePercent(itemModel.get('x'), api.getWidth());
  var yPx = numberUtil.parsePercent(itemModel.get('y'), api.getHeight());

  if (!isNaN(xPx) && !isNaN(yPx)) {
    point = [xPx, yPx];
  } else {
    // Chart like bar may have there own marker positioning logic
    if (seriesModel.getMarkerPosition) {
      // Use the getMarkerPoisition
      point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
    } else {
      var dims = coordSys.dimensions;
      var x = data.get(dims[0], idx);
      var y = data.get(dims[1], idx);
      point = coordSys.dataToPoint([x, y]);
    } // Expand line to the edge of grid if value on one axis is Inifnity
    // In case
    //  markLine: {
    //    data: [{
    //      yAxis: 2
    //      // or
    //      type: 'average'
    //    }]
    //  }


    if (coordSys.type === 'cartesian2d') {
      var xAxis = coordSys.getAxis('x');
      var yAxis = coordSys.getAxis('y');
      var dims = coordSys.dimensions;

      if (isInifinity(data.get(dims[0], idx))) {
        point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
      } else if (isInifinity(data.get(dims[1], idx))) {
        point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
      }
    } // Use x, y if has any


    if (!isNaN(xPx)) {
      point[0] = xPx;
    }

    if (!isNaN(yPx)) {
      point[1] = yPx;
    }
  }

  data.setItemLayout(idx, point);
}

var _default = MarkerView.extend({
  type: 'markLine',
  // updateLayout: function (markLineModel, ecModel, api) {
  //     ecModel.eachSeries(function (seriesModel) {
  //         var mlModel = seriesModel.markLineModel;
  //         if (mlModel) {
  //             var mlData = mlModel.getData();
  //             var fromData = mlModel.__from;
  //             var toData = mlModel.__to;
  //             // Update visual and layout of from symbol and to symbol
  //             fromData.each(function (idx) {
  //                 updateSingleMarkerEndLayout(fromData, idx, true, seriesModel, api);
  //                 updateSingleMarkerEndLayout(toData, idx, false, seriesModel, api);
  //             });
  //             // Update layout of line
  //             mlData.each(function (idx) {
  //                 mlData.setItemLayout(idx, [
  //                     fromData.getItemLayout(idx),
  //                     toData.getItemLayout(idx)
  //                 ]);
  //             });
  //             this.markerGroupMap.get(seriesModel.id).updateLayout();
  //         }
  //     }, this);
  // },
  updateTransform: function (markLineModel, ecModel, api) {
    ecModel.eachSeries(function (seriesModel) {
      var mlModel = seriesModel.markLineModel;

      if (mlModel) {
        var mlData = mlModel.getData();
        var fromData = mlModel.__from;
        var toData = mlModel.__to; // Update visual and layout of from symbol and to symbol

        fromData.each(function (idx) {
          updateSingleMarkerEndLayout(fromData, idx, true, seriesModel, api);
          updateSingleMarkerEndLayout(toData, idx, false, seriesModel, api);
        }); // Update layout of line

        mlData.each(function (idx) {
          mlData.setItemLayout(idx, [fromData.getItemLayout(idx), toData.getItemLayout(idx)]);
        });
        this.markerGroupMap.get(seriesModel.id).updateLayout();
      }
    }, this);
  },
  renderSeries: function (seriesModel, mlModel, ecModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var seriesId = seriesModel.id;
    var seriesData = seriesModel.getData();
    var lineDrawMap = this.markerGroupMap;
    var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new LineDraw());
    this.group.add(lineDraw.group);
    var mlData = createList(coordSys, seriesModel, mlModel);
    var fromData = mlData.from;
    var toData = mlData.to;
    var lineData = mlData.line;
    mlModel.__from = fromData;
    mlModel.__to = toData; // Line data for tooltip and formatter

    mlModel.setData(lineData);
    var symbolType = mlModel.get('symbol');
    var symbolSize = mlModel.get('symbolSize');

    if (!zrUtil.isArray(symbolType)) {
      symbolType = [symbolType, symbolType];
    }

    if (typeof symbolSize === 'number') {
      symbolSize = [symbolSize, symbolSize];
    } // Update visual and layout of from symbol and to symbol


    mlData.from.each(function (idx) {
      updateDataVisualAndLayout(fromData, idx, true);
      updateDataVisualAndLayout(toData, idx, false);
    }); // Update visual and layout of line

    lineData.each(function (idx) {
      var lineColor = lineData.getItemModel(idx).get('lineStyle.color');
      lineData.setItemVisual(idx, {
        color: lineColor || fromData.getItemVisual(idx, 'color')
      });
      lineData.setItemLayout(idx, [fromData.getItemLayout(idx), toData.getItemLayout(idx)]);
      lineData.setItemVisual(idx, {
        'fromSymbolRotate': fromData.getItemVisual(idx, 'symbolRotate'),
        'fromSymbolSize': fromData.getItemVisual(idx, 'symbolSize'),
        'fromSymbol': fromData.getItemVisual(idx, 'symbol'),
        'toSymbolRotate': toData.getItemVisual(idx, 'symbolRotate'),
        'toSymbolSize': toData.getItemVisual(idx, 'symbolSize'),
        'toSymbol': toData.getItemVisual(idx, 'symbol')
      });
    });
    lineDraw.updateData(lineData); // Set host model for tooltip
    // FIXME

    mlData.line.eachItemGraphicEl(function (el, idx) {
      el.traverse(function (child) {
        child.dataModel = mlModel;
      });
    });

    function updateDataVisualAndLayout(data, idx, isFrom) {
      var itemModel = data.getItemModel(idx);
      updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
      data.setItemVisual(idx, {
        symbolRotate: itemModel.get('symbolRotate'),
        symbolSize: itemModel.get('symbolSize') || symbolSize[isFrom ? 0 : 1],
        symbol: itemModel.get('symbol', true) || symbolType[isFrom ? 0 : 1],
        color: itemModel.get('itemStyle.color') || seriesData.getVisual('color')
      });
    }

    lineDraw.__keep = true;
    lineDraw.group.silent = mlModel.get('silent') || seriesModel.get('silent');
  }
});
/**
 * @inner
 * @param {module:echarts/coord/*} coordSys
 * @param {module:echarts/model/Series} seriesModel
 * @param {module:echarts/model/Model} mpModel
 */


function createList(coordSys, seriesModel, mlModel) {
  var coordDimsInfos;

  if (coordSys) {
    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
      var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys

      return zrUtil.defaults({
        name: coordDim
      }, info);
    });
  } else {
    coordDimsInfos = [{
      name: 'value',
      type: 'float'
    }];
  }

  var fromData = new List(coordDimsInfos, mlModel);
  var toData = new List(coordDimsInfos, mlModel); // No dimensions

  var lineData = new List([], mlModel);
  var optData = zrUtil.map(mlModel.get('data'), zrUtil.curry(markLineTransform, seriesModel, coordSys, mlModel));

  if (coordSys) {
    optData = zrUtil.filter(optData, zrUtil.curry(markLineFilter, coordSys));
  }

  var dimValueGetter = coordSys ? markerHelper.dimValueGetter : function (item) {
    return item.value;
  };
  fromData.initData(zrUtil.map(optData, function (item) {
    return item[0];
  }), null, dimValueGetter);
  toData.initData(zrUtil.map(optData, function (item) {
    return item[1];
  }), null, dimValueGetter);
  lineData.initData(zrUtil.map(optData, function (item) {
    return item[2];
  }));
  lineData.hasItemOption = true;
  return {
    from: fromData,
    to: toData,
    line: lineData
  };
}

module.exports = _default;

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

__webpack_require__(1792);

__webpack_require__(1793);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
echarts.registerPreprocessor(function (opt) {
  // Make sure markArea component is enabled
  opt.markArea = opt.markArea || {};
});

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var MarkerModel = __webpack_require__(432);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = MarkerModel.extend({
  type: 'markArea',
  defaultOption: {
    zlevel: 0,
    // PENDING
    z: 1,
    tooltip: {
      trigger: 'item'
    },
    // markArea should fixed on the coordinate system
    animation: false,
    label: {
      show: true,
      position: 'top'
    },
    itemStyle: {
      // color and borderColor default to use color from series
      // color: 'auto'
      // borderColor: 'auto'
      borderWidth: 0
    },
    emphasis: {
      label: {
        show: true,
        position: 'top'
      }
    }
  }
});

module.exports = _default;

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var colorUtil = __webpack_require__(122);

var List = __webpack_require__(98);

var numberUtil = __webpack_require__(37);

var graphic = __webpack_require__(27);

var markerHelper = __webpack_require__(433);

var MarkerView = __webpack_require__(434);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// TODO Better on polar
var markAreaTransform = function (seriesModel, coordSys, maModel, item) {
  var lt = markerHelper.dataTransform(seriesModel, item[0]);
  var rb = markerHelper.dataTransform(seriesModel, item[1]);
  var retrieve = zrUtil.retrieve; // FIXME make sure lt is less than rb

  var ltCoord = lt.coord;
  var rbCoord = rb.coord;
  ltCoord[0] = retrieve(ltCoord[0], -Infinity);
  ltCoord[1] = retrieve(ltCoord[1], -Infinity);
  rbCoord[0] = retrieve(rbCoord[0], Infinity);
  rbCoord[1] = retrieve(rbCoord[1], Infinity); // Merge option into one

  var result = zrUtil.mergeAll([{}, lt, rb]);
  result.coord = [lt.coord, rb.coord];
  result.x0 = lt.x;
  result.y0 = lt.y;
  result.x1 = rb.x;
  result.y1 = rb.y;
  return result;
};

function isInifinity(val) {
  return !isNaN(val) && !isFinite(val);
} // If a markArea has one dim


function ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
  var otherDimIndex = 1 - dimIndex;
  return isInifinity(fromCoord[otherDimIndex]) && isInifinity(toCoord[otherDimIndex]);
}

function markAreaFilter(coordSys, item) {
  var fromCoord = item.coord[0];
  var toCoord = item.coord[1];

  if (coordSys.type === 'cartesian2d') {
    // In case
    // {
    //  markArea: {
    //    data: [{ yAxis: 2 }]
    //  }
    // }
    if (fromCoord && toCoord && (ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) {
      return true;
    }
  }

  return markerHelper.dataFilter(coordSys, {
    coord: fromCoord,
    x: item.x0,
    y: item.y0
  }) || markerHelper.dataFilter(coordSys, {
    coord: toCoord,
    x: item.x1,
    y: item.y1
  });
} // dims can be ['x0', 'y0'], ['x1', 'y1'], ['x0', 'y1'], ['x1', 'y0']


function getSingleMarkerEndPoint(data, idx, dims, seriesModel, api) {
  var coordSys = seriesModel.coordinateSystem;
  var itemModel = data.getItemModel(idx);
  var point;
  var xPx = numberUtil.parsePercent(itemModel.get(dims[0]), api.getWidth());
  var yPx = numberUtil.parsePercent(itemModel.get(dims[1]), api.getHeight());

  if (!isNaN(xPx) && !isNaN(yPx)) {
    point = [xPx, yPx];
  } else {
    // Chart like bar may have there own marker positioning logic
    if (seriesModel.getMarkerPosition) {
      // Use the getMarkerPoisition
      point = seriesModel.getMarkerPosition(data.getValues(dims, idx));
    } else {
      var x = data.get(dims[0], idx);
      var y = data.get(dims[1], idx);
      var pt = [x, y];
      coordSys.clampData && coordSys.clampData(pt, pt);
      point = coordSys.dataToPoint(pt, true);
    }

    if (coordSys.type === 'cartesian2d') {
      var xAxis = coordSys.getAxis('x');
      var yAxis = coordSys.getAxis('y');
      var x = data.get(dims[0], idx);
      var y = data.get(dims[1], idx);

      if (isInifinity(x)) {
        point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[dims[0] === 'x0' ? 0 : 1]);
      } else if (isInifinity(y)) {
        point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[dims[1] === 'y0' ? 0 : 1]);
      }
    } // Use x, y if has any


    if (!isNaN(xPx)) {
      point[0] = xPx;
    }

    if (!isNaN(yPx)) {
      point[1] = yPx;
    }
  }

  return point;
}

var dimPermutations = [['x0', 'y0'], ['x1', 'y0'], ['x1', 'y1'], ['x0', 'y1']];
MarkerView.extend({
  type: 'markArea',
  // updateLayout: function (markAreaModel, ecModel, api) {
  //     ecModel.eachSeries(function (seriesModel) {
  //         var maModel = seriesModel.markAreaModel;
  //         if (maModel) {
  //             var areaData = maModel.getData();
  //             areaData.each(function (idx) {
  //                 var points = zrUtil.map(dimPermutations, function (dim) {
  //                     return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
  //                 });
  //                 // Layout
  //                 areaData.setItemLayout(idx, points);
  //                 var el = areaData.getItemGraphicEl(idx);
  //                 el.setShape('points', points);
  //             });
  //         }
  //     }, this);
  // },
  updateTransform: function (markAreaModel, ecModel, api) {
    ecModel.eachSeries(function (seriesModel) {
      var maModel = seriesModel.markAreaModel;

      if (maModel) {
        var areaData = maModel.getData();
        areaData.each(function (idx) {
          var points = zrUtil.map(dimPermutations, function (dim) {
            return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
          }); // Layout

          areaData.setItemLayout(idx, points);
          var el = areaData.getItemGraphicEl(idx);
          el.setShape('points', points);
        });
      }
    }, this);
  },
  renderSeries: function (seriesModel, maModel, ecModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var seriesId = seriesModel.id;
    var seriesData = seriesModel.getData();
    var areaGroupMap = this.markerGroupMap;
    var polygonGroup = areaGroupMap.get(seriesId) || areaGroupMap.set(seriesId, {
      group: new graphic.Group()
    });
    this.group.add(polygonGroup.group);
    polygonGroup.__keep = true;
    var areaData = createList(coordSys, seriesModel, maModel); // Line data for tooltip and formatter

    maModel.setData(areaData); // Update visual and layout of line

    areaData.each(function (idx) {
      // Layout
      var points = zrUtil.map(dimPermutations, function (dim) {
        return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
      }); // If none of the area is inside coordSys, allClipped is set to be true
      // in layout so that label will not be displayed. See #12591

      var allClipped = true;
      zrUtil.each(dimPermutations, function (dim) {
        if (!allClipped) {
          return;
        }

        var xValue = areaData.get(dim[0], idx);
        var yValue = areaData.get(dim[1], idx); // If is infinity, the axis should be considered not clipped

        if ((isInifinity(xValue) || coordSys.getAxis('x').containData(xValue)) && (isInifinity(yValue) || coordSys.getAxis('y').containData(yValue))) {
          allClipped = false;
        }
      });
      areaData.setItemLayout(idx, {
        points: points,
        allClipped: allClipped
      }); // Visual

      areaData.setItemVisual(idx, {
        color: seriesData.getVisual('color')
      });
    });
    areaData.diff(polygonGroup.__data).add(function (idx) {
      var layout = areaData.getItemLayout(idx);

      if (!layout.allClipped) {
        var polygon = new graphic.Polygon({
          shape: {
            points: layout.points
          }
        });
        areaData.setItemGraphicEl(idx, polygon);
        polygonGroup.group.add(polygon);
      }
    }).update(function (newIdx, oldIdx) {
      var polygon = polygonGroup.__data.getItemGraphicEl(oldIdx);

      var layout = areaData.getItemLayout(newIdx);

      if (!layout.allClipped) {
        if (polygon) {
          graphic.updateProps(polygon, {
            shape: {
              points: layout.points
            }
          }, maModel, newIdx);
        } else {
          polygon = new graphic.Polygon({
            shape: {
              points: layout.points
            }
          });
        }

        areaData.setItemGraphicEl(newIdx, polygon);
        polygonGroup.group.add(polygon);
      } else if (polygon) {
        polygonGroup.group.remove(polygon);
      }
    }).remove(function (idx) {
      var polygon = polygonGroup.__data.getItemGraphicEl(idx);

      polygonGroup.group.remove(polygon);
    }).execute();
    areaData.eachItemGraphicEl(function (polygon, idx) {
      var itemModel = areaData.getItemModel(idx);
      var labelModel = itemModel.getModel('label');
      var labelHoverModel = itemModel.getModel('emphasis.label');
      var color = areaData.getItemVisual(idx, 'color');
      polygon.useStyle(zrUtil.defaults(itemModel.getModel('itemStyle').getItemStyle(), {
        fill: colorUtil.modifyAlpha(color, 0.4),
        stroke: color
      }));
      polygon.hoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
      graphic.setLabelStyle(polygon.style, polygon.hoverStyle, labelModel, labelHoverModel, {
        labelFetcher: maModel,
        labelDataIndex: idx,
        defaultText: areaData.getName(idx) || '',
        isRectText: true,
        autoColor: color
      });
      graphic.setHoverStyle(polygon, {});
      polygon.dataModel = maModel;
    });
    polygonGroup.__data = areaData;
    polygonGroup.group.silent = maModel.get('silent') || seriesModel.get('silent');
  }
});
/**
 * @inner
 * @param {module:echarts/coord/*} coordSys
 * @param {module:echarts/model/Series} seriesModel
 * @param {module:echarts/model/Model} mpModel
 */

function createList(coordSys, seriesModel, maModel) {
  var coordDimsInfos;
  var areaData;
  var dims = ['x0', 'y0', 'x1', 'y1'];

  if (coordSys) {
    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
      var data = seriesModel.getData();
      var info = data.getDimensionInfo(data.mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys

      return zrUtil.defaults({
        name: coordDim
      }, info);
    });
    areaData = new List(zrUtil.map(dims, function (dim, idx) {
      return {
        name: dim,
        type: coordDimsInfos[idx % 2].type
      };
    }), maModel);
  } else {
    coordDimsInfos = [{
      name: 'value',
      type: 'float'
    }];
    areaData = new List(coordDimsInfos, maModel);
  }

  var optData = zrUtil.map(maModel.get('data'), zrUtil.curry(markAreaTransform, seriesModel, coordSys, maModel));

  if (coordSys) {
    optData = zrUtil.filter(optData, zrUtil.curry(markAreaFilter, coordSys));
  }

  var dimValueGetter = coordSys ? function (item, dimName, dataIndex, dimIndex) {
    return item.coord[Math.floor(dimIndex / 2)][dimIndex % 2];
  } : function (item) {
    return item.value;
  };
  areaData.initData(optData, null, dimValueGetter);
  areaData.hasItemOption = true;
  return areaData;
}

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

__webpack_require__(682);

__webpack_require__(1797);

__webpack_require__(1798);

__webpack_require__(1799);

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

var zrUtil = __webpack_require__(1);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function legendSelectActionHandler(methodName, payload, ecModel) {
  var selectedMap = {};
  var isToggleSelect = methodName === 'toggleSelected';
  var isSelected; // Update all legend components

  ecModel.eachComponent('legend', function (legendModel) {
    if (isToggleSelect && isSelected != null) {
      // Force other legend has same selected status
      // Or the first is toggled to true and other are toggled to false
      // In the case one legend has some item unSelected in option. And if other legend
      // doesn't has the item, they will assume it is selected.
      legendModel[isSelected ? 'select' : 'unSelect'](payload.name);
    } else if (methodName === 'allSelect' || methodName === 'inverseSelect') {
      legendModel[methodName]();
    } else {
      legendModel[methodName](payload.name);
      isSelected = legendModel.isSelected(payload.name);
    }

    var legendData = legendModel.getData();
    zrUtil.each(legendData, function (model) {
      var name = model.get('name'); // Wrap element

      if (name === '\n' || name === '') {
        return;
      }

      var isItemSelected = legendModel.isSelected(name);

      if (selectedMap.hasOwnProperty(name)) {
        // Unselected if any legend is unselected
        selectedMap[name] = selectedMap[name] && isItemSelected;
      } else {
        selectedMap[name] = isItemSelected;
      }
    });
  }); // Return the event explicitly

  return methodName === 'allSelect' || methodName === 'inverseSelect' ? {
    selected: selectedMap
  } : {
    name: payload.name,
    selected: selectedMap
  };
}
/**
 * @event legendToggleSelect
 * @type {Object}
 * @property {string} type 'legendToggleSelect'
 * @property {string} [from]
 * @property {string} name Series name or data item name
 */


echarts.registerAction('legendToggleSelect', 'legendselectchanged', zrUtil.curry(legendSelectActionHandler, 'toggleSelected'));
echarts.registerAction('legendAllSelect', 'legendselectall', zrUtil.curry(legendSelectActionHandler, 'allSelect'));
echarts.registerAction('legendInverseSelect', 'legendinverseselect', zrUtil.curry(legendSelectActionHandler, 'inverseSelect'));
/**
 * @event legendSelect
 * @type {Object}
 * @property {string} type 'legendSelect'
 * @property {string} name Series name or data item name
 */

echarts.registerAction('legendSelect', 'legendselected', zrUtil.curry(legendSelectActionHandler, 'select'));
/**
 * @event legendUnSelect
 * @type {Object}
 * @property {string} type 'legendUnSelect'
 * @property {string} name Series name or data item name
 */

echarts.registerAction('legendUnSelect', 'legendunselected', zrUtil.curry(legendSelectActionHandler, 'unSelect'));

/***/ }),
/* 1796 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(ecModel) {
  var legendModels = ecModel.findComponents({
    mainType: 'legend'
  });

  if (legendModels && legendModels.length) {
    ecModel.filterSeries(function (series) {
      // If in any legend component the status is not selected.
      // Because in legend series is assumed selected when it is not in the legend data.
      for (var i = 0; i < legendModels.length; i++) {
        if (!legendModels[i].isSelected(series.name)) {
          return false;
        }
      }

      return true;
    });
  }
}

module.exports = _default;

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var LegendModel = __webpack_require__(683);

var _layout = __webpack_require__(53);

var mergeLayoutParam = _layout.mergeLayoutParam;
var getLayoutParams = _layout.getLayoutParams;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var ScrollableLegendModel = LegendModel.extend({
  type: 'legend.scroll',

  /**
   * @param {number} scrollDataIndex
   */
  setScrollDataIndex: function (scrollDataIndex) {
    this.option.scrollDataIndex = scrollDataIndex;
  },
  defaultOption: {
    scrollDataIndex: 0,
    pageButtonItemGap: 5,
    pageButtonGap: null,
    pageButtonPosition: 'end',
    // 'start' or 'end'
    pageFormatter: '{current}/{total}',
    // If null/undefined, do not show page.
    pageIcons: {
      horizontal: ['M0,0L12,-10L12,10z', 'M0,0L-12,-10L-12,10z'],
      vertical: ['M0,0L20,0L10,-20z', 'M0,0L20,0L10,20z']
    },
    pageIconColor: '#2f4554',
    pageIconInactiveColor: '#aaa',
    pageIconSize: 15,
    // Can be [10, 3], which represents [width, height]
    pageTextStyle: {
      color: '#333'
    },
    animationDurationUpdate: 800
  },

  /**
   * @override
   */
  init: function (option, parentModel, ecModel, extraOpt) {
    var inputPositionParams = getLayoutParams(option);
    ScrollableLegendModel.superCall(this, 'init', option, parentModel, ecModel, extraOpt);
    mergeAndNormalizeLayoutParams(this, option, inputPositionParams);
  },

  /**
   * @override
   */
  mergeOption: function (option, extraOpt) {
    ScrollableLegendModel.superCall(this, 'mergeOption', option, extraOpt);
    mergeAndNormalizeLayoutParams(this, this.option, option);
  }
}); // Do not `ignoreSize` to enable setting {left: 10, right: 10}.

function mergeAndNormalizeLayoutParams(legendModel, target, raw) {
  var orient = legendModel.getOrient();
  var ignoreSize = [1, 1];
  ignoreSize[orient.index] = 0;
  mergeLayoutParam(target, raw, {
    type: 'box',
    ignoreSize: ignoreSize
  });
}

var _default = ScrollableLegendModel;
module.exports = _default;

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var graphic = __webpack_require__(27);

var layoutUtil = __webpack_require__(53);

var LegendView = __webpack_require__(684);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Separate legend and scrollable legend to reduce package size.
 */
var Group = graphic.Group;
var WH = ['width', 'height'];
var XY = ['x', 'y'];
var ScrollableLegendView = LegendView.extend({
  type: 'legend.scroll',
  newlineDisabled: true,
  init: function () {
    ScrollableLegendView.superCall(this, 'init');
    /**
     * @private
     * @type {number} For `scroll`.
     */

    this._currentIndex = 0;
    /**
     * @private
     * @type {module:zrender/container/Group}
     */

    this.group.add(this._containerGroup = new Group());

    this._containerGroup.add(this.getContentGroup());
    /**
     * @private
     * @type {module:zrender/container/Group}
     */


    this.group.add(this._controllerGroup = new Group());
    /**
     *
     * @private
     */

    this._showController;
  },

  /**
   * @override
   */
  resetInner: function () {
    ScrollableLegendView.superCall(this, 'resetInner');

    this._controllerGroup.removeAll();

    this._containerGroup.removeClipPath();

    this._containerGroup.__rectSize = null;
  },

  /**
   * @override
   */
  renderInner: function (itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
    var me = this; // Render content items.

    ScrollableLegendView.superCall(this, 'renderInner', itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
    var controllerGroup = this._controllerGroup; // FIXME: support be 'auto' adapt to size number text length,
    // e.g., '3/12345' should not overlap with the control arrow button.

    var pageIconSize = legendModel.get('pageIconSize', true);

    if (!zrUtil.isArray(pageIconSize)) {
      pageIconSize = [pageIconSize, pageIconSize];
    }

    createPageButton('pagePrev', 0);
    var pageTextStyleModel = legendModel.getModel('pageTextStyle');
    controllerGroup.add(new graphic.Text({
      name: 'pageText',
      style: {
        textFill: pageTextStyleModel.getTextColor(),
        font: pageTextStyleModel.getFont(),
        textVerticalAlign: 'middle',
        textAlign: 'center'
      },
      silent: true
    }));
    createPageButton('pageNext', 1);

    function createPageButton(name, iconIdx) {
      var pageDataIndexName = name + 'DataIndex';
      var icon = graphic.createIcon(legendModel.get('pageIcons', true)[legendModel.getOrient().name][iconIdx], {
        // Buttons will be created in each render, so we do not need
        // to worry about avoiding using legendModel kept in scope.
        onclick: zrUtil.bind(me._pageGo, me, pageDataIndexName, legendModel, api)
      }, {
        x: -pageIconSize[0] / 2,
        y: -pageIconSize[1] / 2,
        width: pageIconSize[0],
        height: pageIconSize[1]
      });
      icon.name = name;
      controllerGroup.add(icon);
    }
  },

  /**
   * @override
   */
  layoutInner: function (legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
    var selectorGroup = this.getSelectorGroup();
    var orientIdx = legendModel.getOrient().index;
    var wh = WH[orientIdx];
    var xy = XY[orientIdx];
    var hw = WH[1 - orientIdx];
    var yx = XY[1 - orientIdx];
    selector && layoutUtil.box( // Buttons in selectorGroup always layout horizontally
    'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
    var selectorButtonGap = legendModel.get('selectorButtonGap', true);
    var selectorRect = selectorGroup.getBoundingRect();
    var selectorPos = [-selectorRect.x, -selectorRect.y];
    var processMaxSize = zrUtil.clone(maxSize);
    selector && (processMaxSize[wh] = maxSize[wh] - selectorRect[wh] - selectorButtonGap);

    var mainRect = this._layoutContentAndController(legendModel, isFirstRender, processMaxSize, orientIdx, wh, hw, yx);

    if (selector) {
      if (selectorPosition === 'end') {
        selectorPos[orientIdx] += mainRect[wh] + selectorButtonGap;
      } else {
        var offset = selectorRect[wh] + selectorButtonGap;
        selectorPos[orientIdx] -= offset;
        mainRect[xy] -= offset;
      }

      mainRect[wh] += selectorRect[wh] + selectorButtonGap;
      selectorPos[1 - orientIdx] += mainRect[yx] + mainRect[hw] / 2 - selectorRect[hw] / 2;
      mainRect[hw] = Math.max(mainRect[hw], selectorRect[hw]);
      mainRect[yx] = Math.min(mainRect[yx], selectorRect[yx] + selectorPos[1 - orientIdx]);
      selectorGroup.attr('position', selectorPos);
    }

    return mainRect;
  },
  _layoutContentAndController: function (legendModel, isFirstRender, maxSize, orientIdx, wh, hw, yx) {
    var contentGroup = this.getContentGroup();
    var containerGroup = this._containerGroup;
    var controllerGroup = this._controllerGroup; // Place items in contentGroup.

    layoutUtil.box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
    layoutUtil.box( // Buttons in controller are layout always horizontally.
    'horizontal', controllerGroup, legendModel.get('pageButtonItemGap', true));
    var contentRect = contentGroup.getBoundingRect();
    var controllerRect = controllerGroup.getBoundingRect();
    var showController = this._showController = contentRect[wh] > maxSize[wh];
    var contentPos = [-contentRect.x, -contentRect.y]; // Remain contentPos when scroll animation perfroming.
    // If first rendering, `contentGroup.position` is [0, 0], which
    // does not make sense and may cause unexepcted animation if adopted.

    if (!isFirstRender) {
      contentPos[orientIdx] = contentGroup.position[orientIdx];
    } // Layout container group based on 0.


    var containerPos = [0, 0];
    var controllerPos = [-controllerRect.x, -controllerRect.y];
    var pageButtonGap = zrUtil.retrieve2(legendModel.get('pageButtonGap', true), legendModel.get('itemGap', true)); // Place containerGroup and controllerGroup and contentGroup.

    if (showController) {
      var pageButtonPosition = legendModel.get('pageButtonPosition', true); // controller is on the right / bottom.

      if (pageButtonPosition === 'end') {
        controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
      } // controller is on the left / top.
      else {
          containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
        }
    } // Always align controller to content as 'middle'.


    controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
    contentGroup.attr('position', contentPos);
    containerGroup.attr('position', containerPos);
    controllerGroup.attr('position', controllerPos); // Calculate `mainRect` and set `clipPath`.
    // mainRect should not be calculated by `this.group.getBoundingRect()`
    // for sake of the overflow.

    var mainRect = {
      x: 0,
      y: 0
    }; // Consider content may be overflow (should be clipped).

    mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
    mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]); // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.

    mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
    containerGroup.__rectSize = maxSize[wh];

    if (showController) {
      var clipShape = {
        x: 0,
        y: 0
      };
      clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
      clipShape[hw] = mainRect[hw];
      containerGroup.setClipPath(new graphic.Rect({
        shape: clipShape
      })); // Consider content may be larger than container, container rect
      // can not be obtained from `containerGroup.getBoundingRect()`.

      containerGroup.__rectSize = clipShape[wh];
    } else {
      // Do not remove or ignore controller. Keep them set as placeholders.
      controllerGroup.eachChild(function (child) {
        child.attr({
          invisible: true,
          silent: true
        });
      });
    } // Content translate animation.


    var pageInfo = this._getPageInfo(legendModel);

    pageInfo.pageIndex != null && graphic.updateProps(contentGroup, {
      position: pageInfo.contentPosition
    }, // When switch from "show controller" to "not show controller", view should be
    // updated immediately without animation, otherwise causes weird effect.
    showController ? legendModel : false);

    this._updatePageInfoView(legendModel, pageInfo);

    return mainRect;
  },
  _pageGo: function (to, legendModel, api) {
    var scrollDataIndex = this._getPageInfo(legendModel)[to];

    scrollDataIndex != null && api.dispatchAction({
      type: 'legendScroll',
      scrollDataIndex: scrollDataIndex,
      legendId: legendModel.id
    });
  },
  _updatePageInfoView: function (legendModel, pageInfo) {
    var controllerGroup = this._controllerGroup;
    zrUtil.each(['pagePrev', 'pageNext'], function (name) {
      var canJump = pageInfo[name + 'DataIndex'] != null;
      var icon = controllerGroup.childOfName(name);

      if (icon) {
        icon.setStyle('fill', canJump ? legendModel.get('pageIconColor', true) : legendModel.get('pageIconInactiveColor', true));
        icon.cursor = canJump ? 'pointer' : 'default';
      }
    });
    var pageText = controllerGroup.childOfName('pageText');
    var pageFormatter = legendModel.get('pageFormatter');
    var pageIndex = pageInfo.pageIndex;
    var current = pageIndex != null ? pageIndex + 1 : 0;
    var total = pageInfo.pageCount;
    pageText && pageFormatter && pageText.setStyle('text', zrUtil.isString(pageFormatter) ? pageFormatter.replace('{current}', current).replace('{total}', total) : pageFormatter({
      current: current,
      total: total
    }));
  },

  /**
   * @param {module:echarts/model/Model} legendModel
   * @return {Object} {
   *  contentPosition: Array.<number>, null when data item not found.
   *  pageIndex: number, null when data item not found.
   *  pageCount: number, always be a number, can be 0.
   *  pagePrevDataIndex: number, null when no previous page.
   *  pageNextDataIndex: number, null when no next page.
   * }
   */
  _getPageInfo: function (legendModel) {
    var scrollDataIndex = legendModel.get('scrollDataIndex', true);
    var contentGroup = this.getContentGroup();
    var containerRectSize = this._containerGroup.__rectSize;
    var orientIdx = legendModel.getOrient().index;
    var wh = WH[orientIdx];
    var xy = XY[orientIdx];

    var targetItemIndex = this._findTargetItemIndex(scrollDataIndex);

    var children = contentGroup.children();
    var targetItem = children[targetItemIndex];
    var itemCount = children.length;
    var pCount = !itemCount ? 0 : 1;
    var result = {
      contentPosition: contentGroup.position.slice(),
      pageCount: pCount,
      pageIndex: pCount - 1,
      pagePrevDataIndex: null,
      pageNextDataIndex: null
    };

    if (!targetItem) {
      return result;
    }

    var targetItemInfo = getItemInfo(targetItem);
    result.contentPosition[orientIdx] = -targetItemInfo.s; // Strategy:
    // (1) Always align based on the left/top most item.
    // (2) It is user-friendly that the last item shown in the
    // current window is shown at the begining of next window.
    // Otherwise if half of the last item is cut by the window,
    // it will have no chance to display entirely.
    // (3) Consider that item size probably be different, we
    // have calculate pageIndex by size rather than item index,
    // and we can not get page index directly by division.
    // (4) The window is to narrow to contain more than
    // one item, we should make sure that the page can be fliped.

    for (var i = targetItemIndex + 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i <= itemCount; ++i) {
      currItemInfo = getItemInfo(children[i]);

      if ( // Half of the last item is out of the window.
      !currItemInfo && winEndItemInfo.e > winStartItemInfo.s + containerRectSize || // If the current item does not intersect with the window, the new page
      // can be started at the current item or the last item.
      currItemInfo && !intersect(currItemInfo, winStartItemInfo.s)) {
        if (winEndItemInfo.i > winStartItemInfo.i) {
          winStartItemInfo = winEndItemInfo;
        } else {
          // e.g., when page size is smaller than item size.
          winStartItemInfo = currItemInfo;
        }

        if (winStartItemInfo) {
          if (result.pageNextDataIndex == null) {
            result.pageNextDataIndex = winStartItemInfo.i;
          }

          ++result.pageCount;
        }
      }

      winEndItemInfo = currItemInfo;
    }

    for (var i = targetItemIndex - 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i >= -1; --i) {
      currItemInfo = getItemInfo(children[i]);

      if ( // If the the end item does not intersect with the window started
      // from the current item, a page can be settled.
      (!currItemInfo || !intersect(winEndItemInfo, currItemInfo.s)) && // e.g., when page size is smaller than item size.
      winStartItemInfo.i < winEndItemInfo.i) {
        winEndItemInfo = winStartItemInfo;

        if (result.pagePrevDataIndex == null) {
          result.pagePrevDataIndex = winStartItemInfo.i;
        }

        ++result.pageCount;
        ++result.pageIndex;
      }

      winStartItemInfo = currItemInfo;
    }

    return result;

    function getItemInfo(el) {
      if (el) {
        var itemRect = el.getBoundingRect();
        var start = itemRect[xy] + el.position[orientIdx];
        return {
          s: start,
          e: start + itemRect[wh],
          i: el.__legendDataIndex
        };
      }
    }

    function intersect(itemInfo, winStart) {
      return itemInfo.e >= winStart && itemInfo.s <= winStart + containerRectSize;
    }
  },
  _findTargetItemIndex: function (targetDataIndex) {
    if (!this._showController) {
      return 0;
    }

    var index;
    var contentGroup = this.getContentGroup();
    var defaultIndex;
    contentGroup.eachChild(function (child, idx) {
      var legendDataIdx = child.__legendDataIndex; // FIXME
      // If the given targetDataIndex (from model) is illegal,
      // we use defaultIndex. But the index on the legend model and
      // action payload is still illegal. That case will not be
      // changed until some scenario requires.

      if (defaultIndex == null && legendDataIdx != null) {
        defaultIndex = idx;
      }

      if (legendDataIdx === targetDataIndex) {
        index = idx;
      }
    });
    return index != null ? index : defaultIndex;
  }
});
var _default = ScrollableLegendView;
module.exports = _default;

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(23);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @event legendScroll
 * @type {Object}
 * @property {string} type 'legendScroll'
 * @property {string} scrollDataIndex
 */
echarts.registerAction('legendScroll', 'legendscroll', function (payload, ecModel) {
  var scrollDataIndex = payload.scrollDataIndex;
  scrollDataIndex != null && ecModel.eachComponent({
    mainType: 'legend',
    subType: 'scroll',
    query: payload
  }, function (legendModel) {
    legendModel.setScrollDataIndex(scrollDataIndex);
  });
});

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

__webpack_require__(685);

__webpack_require__(686);

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var DataZoomModel = __webpack_require__(211);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var SliderZoomModel = DataZoomModel.extend({
  type: 'dataZoom.slider',
  layoutMode: 'box',

  /**
   * @protected
   */
  defaultOption: {
    show: true,
    // ph => placeholder. Using placehoder here because
    // deault value can only be drived in view stage.
    right: 'ph',
    // Default align to grid rect.
    top: 'ph',
    // Default align to grid rect.
    width: 'ph',
    // Default align to grid rect.
    height: 'ph',
    // Default align to grid rect.
    left: null,
    // Default align to grid rect.
    bottom: null,
    // Default align to grid rect.
    backgroundColor: 'rgba(47,69,84,0)',
    // Background of slider zoom component.
    // dataBackgroundColor: '#ddd',         // Background coor of data shadow and border of box,
    // highest priority, remain for compatibility of
    // previous version, but not recommended any more.
    dataBackground: {
      lineStyle: {
        color: '#2f4554',
        width: 0.5,
        opacity: 0.3
      },
      areaStyle: {
        color: 'rgba(47,69,84,0.3)',
        opacity: 0.3
      }
    },
    borderColor: '#ddd',
    // border color of the box. For compatibility,
    // if dataBackgroundColor is set, borderColor
    // is ignored.
    fillerColor: 'rgba(167,183,204,0.4)',
    // Color of selected area.
    // handleColor: 'rgba(89,170,216,0.95)',     // Color of handle.
    // handleIcon: 'path://M4.9,17.8c0-1.4,4.5-10.5,5.5-12.4c0-0.1,0.6-1.1,0.9-1.1c0.4,0,0.9,1,0.9,1.1c1.1,2.2,5.4,11,5.4,12.4v17.8c0,1.5-0.6,2.1-1.3,2.1H6.1c-0.7,0-1.3-0.6-1.3-2.1V17.8z',

    /* eslint-disable */
    handleIcon: 'M8.2,13.6V3.9H6.3v9.7H3.1v14.9h3.3v9.7h1.8v-9.7h3.3V13.6H8.2z M9.7,24.4H4.8v-1.4h4.9V24.4z M9.7,19.1H4.8v-1.4h4.9V19.1z',

    /* eslint-enable */
    // Percent of the slider height
    handleSize: '100%',
    handleStyle: {
      color: '#a7b7cc'
    },
    labelPrecision: null,
    labelFormatter: null,
    showDetail: true,
    showDataShadow: 'auto',
    // Default auto decision.
    realtime: true,
    zoomLock: false,
    // Whether disable zoom.
    textStyle: {
      color: '#333'
    }
  }
});
var _default = SliderZoomModel;
module.exports = _default;

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var eventTool = __webpack_require__(121);

var graphic = __webpack_require__(27);

var throttle = __webpack_require__(148);

var DataZoomView = __webpack_require__(212);

var numberUtil = __webpack_require__(37);

var layout = __webpack_require__(53);

var sliderMove = __webpack_require__(210);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var Rect = graphic.Rect;
var linearMap = numberUtil.linearMap;
var asc = numberUtil.asc;
var bind = zrUtil.bind;
var each = zrUtil.each; // Constants

var DEFAULT_LOCATION_EDGE_GAP = 7;
var DEFAULT_FRAME_BORDER_WIDTH = 1;
var DEFAULT_FILLER_SIZE = 30;
var HORIZONTAL = 'horizontal';
var VERTICAL = 'vertical';
var LABEL_GAP = 5;
var SHOW_DATA_SHADOW_SERIES_TYPE = ['line', 'bar', 'candlestick', 'scatter'];
var SliderZoomView = DataZoomView.extend({
  type: 'dataZoom.slider',
  init: function (ecModel, api) {
    /**
     * @private
     * @type {Object}
     */
    this._displayables = {};
    /**
     * @private
     * @type {string}
     */

    this._orient;
    /**
     * [0, 100]
     * @private
     */

    this._range;
    /**
     * [coord of the first handle, coord of the second handle]
     * @private
     */

    this._handleEnds;
    /**
     * [length, thick]
     * @private
     * @type {Array.<number>}
     */

    this._size;
    /**
     * @private
     * @type {number}
     */

    this._handleWidth;
    /**
     * @private
     * @type {number}
     */

    this._handleHeight;
    /**
     * @private
     */

    this._location;
    /**
     * @private
     */

    this._dragging;
    /**
     * @private
     */

    this._dataShadowInfo;
    this.api = api;
  },

  /**
   * @override
   */
  render: function (dataZoomModel, ecModel, api, payload) {
    SliderZoomView.superApply(this, 'render', arguments);
    throttle.createOrUpdate(this, '_dispatchZoomAction', this.dataZoomModel.get('throttle'), 'fixRate');
    this._orient = dataZoomModel.get('orient');

    if (this.dataZoomModel.get('show') === false) {
      this.group.removeAll();
      return;
    } // Notice: this._resetInterval() should not be executed when payload.type
    // is 'dataZoom', origin this._range should be maintained, otherwise 'pan'
    // or 'zoom' info will be missed because of 'throttle' of this.dispatchAction,


    if (!payload || payload.type !== 'dataZoom' || payload.from !== this.uid) {
      this._buildView();
    }

    this._updateView();
  },

  /**
   * @override
   */
  remove: function () {
    SliderZoomView.superApply(this, 'remove', arguments);
    throttle.clear(this, '_dispatchZoomAction');
  },

  /**
   * @override
   */
  dispose: function () {
    SliderZoomView.superApply(this, 'dispose', arguments);
    throttle.clear(this, '_dispatchZoomAction');
  },
  _buildView: function () {
    var thisGroup = this.group;
    thisGroup.removeAll();

    this._resetLocation();

    this._resetInterval();

    var barGroup = this._displayables.barGroup = new graphic.Group();

    this._renderBackground();

    this._renderHandle();

    this._renderDataShadow();

    thisGroup.add(barGroup);

    this._positionGroup();
  },

  /**
   * @private
   */
  _resetLocation: function () {
    var dataZoomModel = this.dataZoomModel;
    var api = this.api; // If some of x/y/width/height are not specified,
    // auto-adapt according to target grid.

    var coordRect = this._findCoordRect();

    var ecSize = {
      width: api.getWidth(),
      height: api.getHeight()
    }; // Default align by coordinate system rect.

    var positionInfo = this._orient === HORIZONTAL ? {
      // Why using 'right', because right should be used in vertical,
      // and it is better to be consistent for dealing with position param merge.
      right: ecSize.width - coordRect.x - coordRect.width,
      top: ecSize.height - DEFAULT_FILLER_SIZE - DEFAULT_LOCATION_EDGE_GAP,
      width: coordRect.width,
      height: DEFAULT_FILLER_SIZE
    } : {
      // vertical
      right: DEFAULT_LOCATION_EDGE_GAP,
      top: coordRect.y,
      width: DEFAULT_FILLER_SIZE,
      height: coordRect.height
    }; // Do not write back to option and replace value 'ph', because
    // the 'ph' value should be recalculated when resize.

    var layoutParams = layout.getLayoutParams(dataZoomModel.option); // Replace the placeholder value.

    zrUtil.each(['right', 'top', 'width', 'height'], function (name) {
      if (layoutParams[name] === 'ph') {
        layoutParams[name] = positionInfo[name];
      }
    });
    var layoutRect = layout.getLayoutRect(layoutParams, ecSize, dataZoomModel.padding);
    this._location = {
      x: layoutRect.x,
      y: layoutRect.y
    };
    this._size = [layoutRect.width, layoutRect.height];
    this._orient === VERTICAL && this._size.reverse();
  },

  /**
   * @private
   */
  _positionGroup: function () {
    var thisGroup = this.group;
    var location = this._location;
    var orient = this._orient; // Just use the first axis to determine mapping.

    var targetAxisModel = this.dataZoomModel.getFirstTargetAxisModel();
    var inverse = targetAxisModel && targetAxisModel.get('inverse');
    var barGroup = this._displayables.barGroup;
    var otherAxisInverse = (this._dataShadowInfo || {}).otherAxisInverse; // Transform barGroup.

    barGroup.attr(orient === HORIZONTAL && !inverse ? {
      scale: otherAxisInverse ? [1, 1] : [1, -1]
    } : orient === HORIZONTAL && inverse ? {
      scale: otherAxisInverse ? [-1, 1] : [-1, -1]
    } : orient === VERTICAL && !inverse ? {
      scale: otherAxisInverse ? [1, -1] : [1, 1],
      rotation: Math.PI / 2 // Dont use Math.PI, considering shadow direction.

    } : {
      scale: otherAxisInverse ? [-1, -1] : [-1, 1],
      rotation: Math.PI / 2
    }); // Position barGroup

    var rect = thisGroup.getBoundingRect([barGroup]);
    thisGroup.attr('position', [location.x - rect.x, location.y - rect.y]);
  },

  /**
   * @private
   */
  _getViewExtent: function () {
    return [0, this._size[0]];
  },
  _renderBackground: function () {
    var dataZoomModel = this.dataZoomModel;
    var size = this._size;
    var barGroup = this._displayables.barGroup;
    barGroup.add(new Rect({
      silent: true,
      shape: {
        x: 0,
        y: 0,
        width: size[0],
        height: size[1]
      },
      style: {
        fill: dataZoomModel.get('backgroundColor')
      },
      z2: -40
    })); // Click panel, over shadow, below handles.

    barGroup.add(new Rect({
      shape: {
        x: 0,
        y: 0,
        width: size[0],
        height: size[1]
      },
      style: {
        fill: 'transparent'
      },
      z2: 0,
      onclick: zrUtil.bind(this._onClickPanelClick, this)
    }));
  },
  _renderDataShadow: function () {
    var info = this._dataShadowInfo = this._prepareDataShadowInfo();

    if (!info) {
      return;
    }

    var size = this._size;
    var seriesModel = info.series;
    var data = seriesModel.getRawData();
    var otherDim = seriesModel.getShadowDim ? seriesModel.getShadowDim() // @see candlestick
    : info.otherDim;

    if (otherDim == null) {
      return;
    }

    var otherDataExtent = data.getDataExtent(otherDim); // Nice extent.

    var otherOffset = (otherDataExtent[1] - otherDataExtent[0]) * 0.3;
    otherDataExtent = [otherDataExtent[0] - otherOffset, otherDataExtent[1] + otherOffset];
    var otherShadowExtent = [0, size[1]];
    var thisShadowExtent = [0, size[0]];
    var areaPoints = [[size[0], 0], [0, 0]];
    var linePoints = [];
    var step = thisShadowExtent[1] / (data.count() - 1);
    var thisCoord = 0; // Optimize for large data shadow

    var stride = Math.round(data.count() / size[0]);
    var lastIsEmpty;
    data.each([otherDim], function (value, index) {
      if (stride > 0 && index % stride) {
        thisCoord += step;
        return;
      } // FIXME
      // Should consider axis.min/axis.max when drawing dataShadow.
      // FIXME
      // 应该使用统一的空判断？还是在list里进行空判断？


      var isEmpty = value == null || isNaN(value) || value === ''; // See #4235.

      var otherCoord = isEmpty ? 0 : linearMap(value, otherDataExtent, otherShadowExtent, true); // Attempt to draw data shadow precisely when there are empty value.

      if (isEmpty && !lastIsEmpty && index) {
        areaPoints.push([areaPoints[areaPoints.length - 1][0], 0]);
        linePoints.push([linePoints[linePoints.length - 1][0], 0]);
      } else if (!isEmpty && lastIsEmpty) {
        areaPoints.push([thisCoord, 0]);
        linePoints.push([thisCoord, 0]);
      }

      areaPoints.push([thisCoord, otherCoord]);
      linePoints.push([thisCoord, otherCoord]);
      thisCoord += step;
      lastIsEmpty = isEmpty;
    });
    var dataZoomModel = this.dataZoomModel; // var dataBackgroundModel = dataZoomModel.getModel('dataBackground');

    this._displayables.barGroup.add(new graphic.Polygon({
      shape: {
        points: areaPoints
      },
      style: zrUtil.defaults({
        fill: dataZoomModel.get('dataBackgroundColor')
      }, dataZoomModel.getModel('dataBackground.areaStyle').getAreaStyle()),
      silent: true,
      z2: -20
    }));

    this._displayables.barGroup.add(new graphic.Polyline({
      shape: {
        points: linePoints
      },
      style: dataZoomModel.getModel('dataBackground.lineStyle').getLineStyle(),
      silent: true,
      z2: -19
    }));
  },
  _prepareDataShadowInfo: function () {
    var dataZoomModel = this.dataZoomModel;
    var showDataShadow = dataZoomModel.get('showDataShadow');

    if (showDataShadow === false) {
      return;
    } // Find a representative series.


    var result;
    var ecModel = this.ecModel;
    dataZoomModel.eachTargetAxis(function (dimNames, axisIndex) {
      var seriesModels = dataZoomModel.getAxisProxy(dimNames.name, axisIndex).getTargetSeriesModels();
      zrUtil.each(seriesModels, function (seriesModel) {
        if (result) {
          return;
        }

        if (showDataShadow !== true && zrUtil.indexOf(SHOW_DATA_SHADOW_SERIES_TYPE, seriesModel.get('type')) < 0) {
          return;
        }

        var thisAxis = ecModel.getComponent(dimNames.axis, axisIndex).axis;
        var otherDim = getOtherDim(dimNames.name);
        var otherAxisInverse;
        var coordSys = seriesModel.coordinateSystem;

        if (otherDim != null && coordSys.getOtherAxis) {
          otherAxisInverse = coordSys.getOtherAxis(thisAxis).inverse;
        }

        otherDim = seriesModel.getData().mapDimension(otherDim);
        result = {
          thisAxis: thisAxis,
          series: seriesModel,
          thisDim: dimNames.name,
          otherDim: otherDim,
          otherAxisInverse: otherAxisInverse
        };
      }, this);
    }, this);
    return result;
  },
  _renderHandle: function () {
    var displaybles = this._displayables;
    var handles = displaybles.handles = [];
    var handleLabels = displaybles.handleLabels = [];
    var barGroup = this._displayables.barGroup;
    var size = this._size;
    var dataZoomModel = this.dataZoomModel;
    barGroup.add(displaybles.filler = new Rect({
      draggable: true,
      cursor: getCursor(this._orient),
      drift: bind(this._onDragMove, this, 'all'),
      ondragstart: bind(this._showDataInfo, this, true),
      ondragend: bind(this._onDragEnd, this),
      onmouseover: bind(this._showDataInfo, this, true),
      onmouseout: bind(this._showDataInfo, this, false),
      style: {
        fill: dataZoomModel.get('fillerColor'),
        textPosition: 'inside'
      }
    })); // Frame border.

    barGroup.add(new Rect({
      silent: true,
      subPixelOptimize: true,
      shape: {
        x: 0,
        y: 0,
        width: size[0],
        height: size[1]
      },
      style: {
        stroke: dataZoomModel.get('dataBackgroundColor') || dataZoomModel.get('borderColor'),
        lineWidth: DEFAULT_FRAME_BORDER_WIDTH,
        fill: 'rgba(0,0,0,0)'
      }
    }));
    each([0, 1], function (handleIndex) {
      var path = graphic.createIcon(dataZoomModel.get('handleIcon'), {
        cursor: getCursor(this._orient),
        draggable: true,
        drift: bind(this._onDragMove, this, handleIndex),
        ondragend: bind(this._onDragEnd, this),
        onmouseover: bind(this._showDataInfo, this, true),
        onmouseout: bind(this._showDataInfo, this, false)
      }, {
        x: -1,
        y: 0,
        width: 2,
        height: 2
      });
      var bRect = path.getBoundingRect();
      this._handleHeight = numberUtil.parsePercent(dataZoomModel.get('handleSize'), this._size[1]);
      this._handleWidth = bRect.width / bRect.height * this._handleHeight;
      path.setStyle(dataZoomModel.getModel('handleStyle').getItemStyle());
      var handleColor = dataZoomModel.get('handleColor'); // Compatitable with previous version

      if (handleColor != null) {
        path.style.fill = handleColor;
      }

      barGroup.add(handles[handleIndex] = path);
      var textStyleModel = dataZoomModel.textStyleModel;
      this.group.add(handleLabels[handleIndex] = new graphic.Text({
        silent: true,
        invisible: true,
        style: {
          x: 0,
          y: 0,
          text: '',
          textVerticalAlign: 'middle',
          textAlign: 'center',
          textFill: textStyleModel.getTextColor(),
          textFont: textStyleModel.getFont()
        },
        z2: 10
      }));
    }, this);
  },

  /**
   * @private
   */
  _resetInterval: function () {
    var range = this._range = this.dataZoomModel.getPercentRange();

    var viewExtent = this._getViewExtent();

    this._handleEnds = [linearMap(range[0], [0, 100], viewExtent, true), linearMap(range[1], [0, 100], viewExtent, true)];
  },

  /**
   * @private
   * @param {(number|string)} handleIndex 0 or 1 or 'all'
   * @param {number} delta
   * @return {boolean} changed
   */
  _updateInterval: function (handleIndex, delta) {
    var dataZoomModel = this.dataZoomModel;
    var handleEnds = this._handleEnds;

    var viewExtend = this._getViewExtent();

    var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
    var percentExtent = [0, 100];
    sliderMove(delta, handleEnds, viewExtend, dataZoomModel.get('zoomLock') ? 'all' : handleIndex, minMaxSpan.minSpan != null ? linearMap(minMaxSpan.minSpan, percentExtent, viewExtend, true) : null, minMaxSpan.maxSpan != null ? linearMap(minMaxSpan.maxSpan, percentExtent, viewExtend, true) : null);
    var lastRange = this._range;
    var range = this._range = asc([linearMap(handleEnds[0], viewExtend, percentExtent, true), linearMap(handleEnds[1], viewExtend, percentExtent, true)]);
    return !lastRange || lastRange[0] !== range[0] || lastRange[1] !== range[1];
  },

  /**
   * @private
   */
  _updateView: function (nonRealtime) {
    var displaybles = this._displayables;
    var handleEnds = this._handleEnds;
    var handleInterval = asc(handleEnds.slice());
    var size = this._size;
    each([0, 1], function (handleIndex) {
      // Handles
      var handle = displaybles.handles[handleIndex];
      var handleHeight = this._handleHeight;
      handle.attr({
        scale: [handleHeight / 2, handleHeight / 2],
        position: [handleEnds[handleIndex], size[1] / 2 - handleHeight / 2]
      });
    }, this); // Filler

    displaybles.filler.setShape({
      x: handleInterval[0],
      y: 0,
      width: handleInterval[1] - handleInterval[0],
      height: size[1]
    });

    this._updateDataInfo(nonRealtime);
  },

  /**
   * @private
   */
  _updateDataInfo: function (nonRealtime) {
    var dataZoomModel = this.dataZoomModel;
    var displaybles = this._displayables;
    var handleLabels = displaybles.handleLabels;
    var orient = this._orient;
    var labelTexts = ['', '']; // FIXME
    // date型，支持formatter，autoformatter（ec2 date.getAutoFormatter）

    if (dataZoomModel.get('showDetail')) {
      var axisProxy = dataZoomModel.findRepresentativeAxisProxy();

      if (axisProxy) {
        var axis = axisProxy.getAxisModel().axis;
        var range = this._range;
        var dataInterval = nonRealtime // See #4434, data and axis are not processed and reset yet in non-realtime mode.
        ? axisProxy.calculateDataWindow({
          start: range[0],
          end: range[1]
        }).valueWindow : axisProxy.getDataValueWindow();
        labelTexts = [this._formatLabel(dataInterval[0], axis), this._formatLabel(dataInterval[1], axis)];
      }
    }

    var orderedHandleEnds = asc(this._handleEnds.slice());
    setLabel.call(this, 0);
    setLabel.call(this, 1);

    function setLabel(handleIndex) {
      // Label
      // Text should not transform by barGroup.
      // Ignore handlers transform
      var barTransform = graphic.getTransform(displaybles.handles[handleIndex].parent, this.group);
      var direction = graphic.transformDirection(handleIndex === 0 ? 'right' : 'left', barTransform);
      var offset = this._handleWidth / 2 + LABEL_GAP;
      var textPoint = graphic.applyTransform([orderedHandleEnds[handleIndex] + (handleIndex === 0 ? -offset : offset), this._size[1] / 2], barTransform);
      handleLabels[handleIndex].setStyle({
        x: textPoint[0],
        y: textPoint[1],
        textVerticalAlign: orient === HORIZONTAL ? 'middle' : direction,
        textAlign: orient === HORIZONTAL ? direction : 'center',
        text: labelTexts[handleIndex]
      });
    }
  },

  /**
   * @private
   */
  _formatLabel: function (value, axis) {
    var dataZoomModel = this.dataZoomModel;
    var labelFormatter = dataZoomModel.get('labelFormatter');
    var labelPrecision = dataZoomModel.get('labelPrecision');

    if (labelPrecision == null || labelPrecision === 'auto') {
      labelPrecision = axis.getPixelPrecision();
    }

    var valueStr = value == null || isNaN(value) ? '' // FIXME Glue code
    : axis.type === 'category' || axis.type === 'time' ? axis.scale.getLabel(Math.round(value)) // param of toFixed should less then 20.
    : value.toFixed(Math.min(labelPrecision, 20));
    return zrUtil.isFunction(labelFormatter) ? labelFormatter(value, valueStr) : zrUtil.isString(labelFormatter) ? labelFormatter.replace('{value}', valueStr) : valueStr;
  },

  /**
   * @private
   * @param {boolean} showOrHide true: show, false: hide
   */
  _showDataInfo: function (showOrHide) {
    // Always show when drgging.
    showOrHide = this._dragging || showOrHide;
    var handleLabels = this._displayables.handleLabels;
    handleLabels[0].attr('invisible', !showOrHide);
    handleLabels[1].attr('invisible', !showOrHide);
  },
  _onDragMove: function (handleIndex, dx, dy, event) {
    this._dragging = true; // For mobile device, prevent screen slider on the button.

    eventTool.stop(event.event); // Transform dx, dy to bar coordination.

    var barTransform = this._displayables.barGroup.getLocalTransform();

    var vertex = graphic.applyTransform([dx, dy], barTransform, true);

    var changed = this._updateInterval(handleIndex, vertex[0]);

    var realtime = this.dataZoomModel.get('realtime');

    this._updateView(!realtime); // Avoid dispatch dataZoom repeatly but range not changed,
    // which cause bad visual effect when progressive enabled.


    changed && realtime && this._dispatchZoomAction();
  },
  _onDragEnd: function () {
    this._dragging = false;

    this._showDataInfo(false); // While in realtime mode and stream mode, dispatch action when
    // drag end will cause the whole view rerender, which is unnecessary.


    var realtime = this.dataZoomModel.get('realtime');
    !realtime && this._dispatchZoomAction();
  },
  _onClickPanelClick: function (e) {
    var size = this._size;

    var localPoint = this._displayables.barGroup.transformCoordToLocal(e.offsetX, e.offsetY);

    if (localPoint[0] < 0 || localPoint[0] > size[0] || localPoint[1] < 0 || localPoint[1] > size[1]) {
      return;
    }

    var handleEnds = this._handleEnds;
    var center = (handleEnds[0] + handleEnds[1]) / 2;

    var changed = this._updateInterval('all', localPoint[0] - center);

    this._updateView();

    changed && this._dispatchZoomAction();
  },

  /**
   * This action will be throttled.
   * @private
   */
  _dispatchZoomAction: function () {
    var range = this._range;
    this.api.dispatchAction({
      type: 'dataZoom',
      from: this.uid,
      dataZoomId: this.dataZoomModel.id,
      start: range[0],
      end: range[1]
    });
  },

  /**
   * @private
   */
  _findCoordRect: function () {
    // Find the grid coresponding to the first axis referred by dataZoom.
    var rect;
    each(this.getTargetCoordInfo(), function (coordInfoList) {
      if (!rect && coordInfoList.length) {
        var coordSys = coordInfoList[0].model.coordinateSystem;
        rect = coordSys.getRect && coordSys.getRect();
      }
    });

    if (!rect) {
      var width = this.api.getWidth();
      var height = this.api.getHeight();
      rect = {
        x: width * 0.2,
        y: height * 0.2,
        width: width * 0.6,
        height: height * 0.6
      };
    }

    return rect;
  }
});

function getOtherDim(thisDim) {
  // FIXME
  // 这个逻辑和getOtherAxis里一致，但是写在这里是否不好
  var map = {
    x: 'y',
    y: 'x',
    radius: 'angle',
    angle: 'radius'
  };
  return map[thisDim];
}

function getCursor(orient) {
  return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
}

var _default = SliderZoomView;
module.exports = _default;

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var DataZoomModel = __webpack_require__(211);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = DataZoomModel.extend({
  type: 'dataZoom.inside',

  /**
   * @protected
   */
  defaultOption: {
    disabled: false,
    // Whether disable this inside zoom.
    zoomLock: false,
    // Whether disable zoom but only pan.
    zoomOnMouseWheel: true,
    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
    moveOnMouseMove: true,
    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
    moveOnMouseWheel: false,
    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
    preventDefaultMouseMove: true
  }
});

module.exports = _default;

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var DataZoomView = __webpack_require__(212);

var sliderMove = __webpack_require__(210);

var roams = __webpack_require__(1805);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var bind = zrUtil.bind;
var InsideZoomView = DataZoomView.extend({
  type: 'dataZoom.inside',

  /**
   * @override
   */
  init: function (ecModel, api) {
    /**
     * 'throttle' is used in this.dispatchAction, so we save range
     * to avoid missing some 'pan' info.
     * @private
     * @type {Array.<number>}
     */
    this._range;
  },

  /**
   * @override
   */
  render: function (dataZoomModel, ecModel, api, payload) {
    InsideZoomView.superApply(this, 'render', arguments); // Hence the `throttle` util ensures to preserve command order,
    // here simply updating range all the time will not cause missing
    // any of the the roam change.

    this._range = dataZoomModel.getPercentRange(); // Reset controllers.

    zrUtil.each(this.getTargetCoordInfo(), function (coordInfoList, coordSysName) {
      var allCoordIds = zrUtil.map(coordInfoList, function (coordInfo) {
        return roams.generateCoordId(coordInfo.model);
      });
      zrUtil.each(coordInfoList, function (coordInfo) {
        var coordModel = coordInfo.model;
        var getRange = {};
        zrUtil.each(['pan', 'zoom', 'scrollMove'], function (eventName) {
          getRange[eventName] = bind(roamHandlers[eventName], this, coordInfo, coordSysName);
        }, this);
        roams.register(api, {
          coordId: roams.generateCoordId(coordModel),
          allCoordIds: allCoordIds,
          containsPoint: function (e, x, y) {
            return coordModel.coordinateSystem.containPoint([x, y]);
          },
          dataZoomId: dataZoomModel.id,
          dataZoomModel: dataZoomModel,
          getRange: getRange
        });
      }, this);
    }, this);
  },

  /**
   * @override
   */
  dispose: function () {
    roams.unregister(this.api, this.dataZoomModel.id);
    InsideZoomView.superApply(this, 'dispose', arguments);
    this._range = null;
  }
});
var roamHandlers = {
  /**
   * @this {module:echarts/component/dataZoom/InsideZoomView}
   */
  zoom: function (coordInfo, coordSysName, controller, e) {
    var lastRange = this._range;
    var range = lastRange.slice(); // Calculate transform by the first axis.

    var axisModel = coordInfo.axisModels[0];

    if (!axisModel) {
      return;
    }

    var directionInfo = getDirectionInfo[coordSysName](null, [e.originX, e.originY], axisModel, controller, coordInfo);
    var percentPoint = (directionInfo.signal > 0 ? directionInfo.pixelStart + directionInfo.pixelLength - directionInfo.pixel : directionInfo.pixel - directionInfo.pixelStart) / directionInfo.pixelLength * (range[1] - range[0]) + range[0];
    var scale = Math.max(1 / e.scale, 0);
    range[0] = (range[0] - percentPoint) * scale + percentPoint;
    range[1] = (range[1] - percentPoint) * scale + percentPoint; // Restrict range.

    var minMaxSpan = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
    sliderMove(0, range, [0, 100], 0, minMaxSpan.minSpan, minMaxSpan.maxSpan);
    this._range = range;

    if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) {
      return range;
    }
  },

  /**
   * @this {module:echarts/component/dataZoom/InsideZoomView}
   */
  pan: makeMover(function (range, axisModel, coordInfo, coordSysName, controller, e) {
    var directionInfo = getDirectionInfo[coordSysName]([e.oldX, e.oldY], [e.newX, e.newY], axisModel, controller, coordInfo);
    return directionInfo.signal * (range[1] - range[0]) * directionInfo.pixel / directionInfo.pixelLength;
  }),

  /**
   * @this {module:echarts/component/dataZoom/InsideZoomView}
   */
  scrollMove: makeMover(function (range, axisModel, coordInfo, coordSysName, controller, e) {
    var directionInfo = getDirectionInfo[coordSysName]([0, 0], [e.scrollDelta, e.scrollDelta], axisModel, controller, coordInfo);
    return directionInfo.signal * (range[1] - range[0]) * e.scrollDelta;
  })
};

function makeMover(getPercentDelta) {
  return function (coordInfo, coordSysName, controller, e) {
    var lastRange = this._range;
    var range = lastRange.slice(); // Calculate transform by the first axis.

    var axisModel = coordInfo.axisModels[0];

    if (!axisModel) {
      return;
    }

    var percentDelta = getPercentDelta(range, axisModel, coordInfo, coordSysName, controller, e);
    sliderMove(percentDelta, range, [0, 100], 'all');
    this._range = range;

    if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) {
      return range;
    }
  };
}

var getDirectionInfo = {
  grid: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
    var axis = axisModel.axis;
    var ret = {};
    var rect = coordInfo.model.coordinateSystem.getRect();
    oldPoint = oldPoint || [0, 0];

    if (axis.dim === 'x') {
      ret.pixel = newPoint[0] - oldPoint[0];
      ret.pixelLength = rect.width;
      ret.pixelStart = rect.x;
      ret.signal = axis.inverse ? 1 : -1;
    } else {
      // axis.dim === 'y'
      ret.pixel = newPoint[1] - oldPoint[1];
      ret.pixelLength = rect.height;
      ret.pixelStart = rect.y;
      ret.signal = axis.inverse ? -1 : 1;
    }

    return ret;
  },
  polar: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
    var axis = axisModel.axis;
    var ret = {};
    var polar = coordInfo.model.coordinateSystem;
    var radiusExtent = polar.getRadiusAxis().getExtent();
    var angleExtent = polar.getAngleAxis().getExtent();
    oldPoint = oldPoint ? polar.pointToCoord(oldPoint) : [0, 0];
    newPoint = polar.pointToCoord(newPoint);

    if (axisModel.mainType === 'radiusAxis') {
      ret.pixel = newPoint[0] - oldPoint[0]; // ret.pixelLength = Math.abs(radiusExtent[1] - radiusExtent[0]);
      // ret.pixelStart = Math.min(radiusExtent[0], radiusExtent[1]);

      ret.pixelLength = radiusExtent[1] - radiusExtent[0];
      ret.pixelStart = radiusExtent[0];
      ret.signal = axis.inverse ? 1 : -1;
    } else {
      // 'angleAxis'
      ret.pixel = newPoint[1] - oldPoint[1]; // ret.pixelLength = Math.abs(angleExtent[1] - angleExtent[0]);
      // ret.pixelStart = Math.min(angleExtent[0], angleExtent[1]);

      ret.pixelLength = angleExtent[1] - angleExtent[0];
      ret.pixelStart = angleExtent[0];
      ret.signal = axis.inverse ? -1 : 1;
    }

    return ret;
  },
  singleAxis: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
    var axis = axisModel.axis;
    var rect = coordInfo.model.coordinateSystem.getRect();
    var ret = {};
    oldPoint = oldPoint || [0, 0];

    if (axis.orient === 'horizontal') {
      ret.pixel = newPoint[0] - oldPoint[0];
      ret.pixelLength = rect.width;
      ret.pixelStart = rect.x;
      ret.signal = axis.inverse ? 1 : -1;
    } else {
      // 'vertical'
      ret.pixel = newPoint[1] - oldPoint[1];
      ret.pixelLength = rect.height;
      ret.pixelStart = rect.y;
      ret.signal = axis.inverse ? -1 : 1;
    }

    return ret;
  }
};
var _default = InsideZoomView;
module.exports = _default;

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var RoamController = __webpack_require__(245);

var throttleUtil = __webpack_require__(148);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Only create one roam controller for each coordinate system.
// one roam controller might be refered by two inside data zoom
// components (for example, one for x and one for y). When user
// pan or zoom, only dispatch one action for those data zoom
// components.
var ATTR = '\0_ec_dataZoom_roams';
/**
 * @public
 * @param {module:echarts/ExtensionAPI} api
 * @param {Object} dataZoomInfo
 * @param {string} dataZoomInfo.coordId
 * @param {Function} dataZoomInfo.containsPoint
 * @param {Array.<string>} dataZoomInfo.allCoordIds
 * @param {string} dataZoomInfo.dataZoomId
 * @param {Object} dataZoomInfo.getRange
 * @param {Function} dataZoomInfo.getRange.pan
 * @param {Function} dataZoomInfo.getRange.zoom
 * @param {Function} dataZoomInfo.getRange.scrollMove
 * @param {boolean} dataZoomInfo.dataZoomModel
 */

function register(api, dataZoomInfo) {
  var store = giveStore(api);
  var theDataZoomId = dataZoomInfo.dataZoomId;
  var theCoordId = dataZoomInfo.coordId; // Do clean when a dataZoom changes its target coordnate system.
  // Avoid memory leak, dispose all not-used-registered.

  zrUtil.each(store, function (record, coordId) {
    var dataZoomInfos = record.dataZoomInfos;

    if (dataZoomInfos[theDataZoomId] && zrUtil.indexOf(dataZoomInfo.allCoordIds, theCoordId) < 0) {
      delete dataZoomInfos[theDataZoomId];
      record.count--;
    }
  });
  cleanStore(store);
  var record = store[theCoordId]; // Create if needed.

  if (!record) {
    record = store[theCoordId] = {
      coordId: theCoordId,
      dataZoomInfos: {},
      count: 0
    };
    record.controller = createController(api, record);
    record.dispatchAction = zrUtil.curry(dispatchAction, api);
  } // Update reference of dataZoom.


  !record.dataZoomInfos[theDataZoomId] && record.count++;
  record.dataZoomInfos[theDataZoomId] = dataZoomInfo;
  var controllerParams = mergeControllerParams(record.dataZoomInfos);
  record.controller.enable(controllerParams.controlType, controllerParams.opt); // Consider resize, area should be always updated.

  record.controller.setPointerChecker(dataZoomInfo.containsPoint); // Update throttle.

  throttleUtil.createOrUpdate(record, 'dispatchAction', dataZoomInfo.dataZoomModel.get('throttle', true), 'fixRate');
}
/**
 * @public
 * @param {module:echarts/ExtensionAPI} api
 * @param {string} dataZoomId
 */


function unregister(api, dataZoomId) {
  var store = giveStore(api);
  zrUtil.each(store, function (record) {
    record.controller.dispose();
    var dataZoomInfos = record.dataZoomInfos;

    if (dataZoomInfos[dataZoomId]) {
      delete dataZoomInfos[dataZoomId];
      record.count--;
    }
  });
  cleanStore(store);
}
/**
 * @public
 */


function generateCoordId(coordModel) {
  return coordModel.type + '\0_' + coordModel.id;
}
/**
 * Key: coordId, value: {dataZoomInfos: [], count, controller}
 * @type {Array.<Object>}
 */


function giveStore(api) {
  // Mount store on zrender instance, so that we do not
  // need to worry about dispose.
  var zr = api.getZr();
  return zr[ATTR] || (zr[ATTR] = {});
}

function createController(api, newRecord) {
  var controller = new RoamController(api.getZr());
  zrUtil.each(['pan', 'zoom', 'scrollMove'], function (eventName) {
    controller.on(eventName, function (event) {
      var batch = [];
      zrUtil.each(newRecord.dataZoomInfos, function (info) {
        // Check whether the behaviors (zoomOnMouseWheel, moveOnMouseMove,
        // moveOnMouseWheel, ...) enabled.
        if (!event.isAvailableBehavior(info.dataZoomModel.option)) {
          return;
        }

        var method = (info.getRange || {})[eventName];
        var range = method && method(newRecord.controller, event);
        !info.dataZoomModel.get('disabled', true) && range && batch.push({
          dataZoomId: info.dataZoomId,
          start: range[0],
          end: range[1]
        });
      });
      batch.length && newRecord.dispatchAction(batch);
    });
  });
  return controller;
}

function cleanStore(store) {
  zrUtil.each(store, function (record, coordId) {
    if (!record.count) {
      record.controller.dispose();
      delete store[coordId];
    }
  });
}
/**
 * This action will be throttled.
 */


function dispatchAction(api, batch) {
  api.dispatchAction({
    type: 'dataZoom',
    batch: batch
  });
}
/**
 * Merge roamController settings when multiple dataZooms share one roamController.
 */


function mergeControllerParams(dataZoomInfos) {
  var controlType; // DO NOT use reserved word (true, false, undefined) as key literally. Even if encapsulated
  // as string, it is probably revert to reserved word by compress tool. See #7411.

  var prefix = 'type_';
  var typePriority = {
    'type_true': 2,
    'type_move': 1,
    'type_false': 0,
    'type_undefined': -1
  };
  var preventDefaultMouseMove = true;
  zrUtil.each(dataZoomInfos, function (dataZoomInfo) {
    var dataZoomModel = dataZoomInfo.dataZoomModel;
    var oneType = dataZoomModel.get('disabled', true) ? false : dataZoomModel.get('zoomLock', true) ? 'move' : true;

    if (typePriority[prefix + oneType] > typePriority[prefix + controlType]) {
      controlType = oneType;
    } // Prevent default move event by default. If one false, do not prevent. Otherwise
    // users may be confused why it does not work when multiple insideZooms exist.


    preventDefaultMouseMove &= dataZoomModel.get('preventDefaultMouseMove', true);
  });
  return {
    controlType: controlType,
    opt: {
      // RoamController will enable all of these functionalities,
      // and the final behavior is determined by its event listener
      // provided by each inside zoom.
      zoomOnMouseWheel: true,
      moveOnMouseMove: true,
      moveOnMouseWheel: true,
      preventDefaultMouseMove: !!preventDefaultMouseMove
    }
  };
}

exports.register = register;
exports.unregister = unregister;
exports.generateCoordId = generateCoordId;

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

__webpack_require__(687);

__webpack_require__(696);

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var VisualMapModel = __webpack_require__(691);

var numberUtil = __webpack_require__(37);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Constant
var DEFAULT_BAR_BOUND = [20, 140];
var ContinuousModel = VisualMapModel.extend({
  type: 'visualMap.continuous',

  /**
   * @protected
   */
  defaultOption: {
    align: 'auto',
    // 'auto', 'left', 'right', 'top', 'bottom'
    calculable: false,
    // This prop effect default component type determine,
    // See echarts/component/visualMap/typeDefaulter.
    range: null,
    // selected range. In default case `range` is [min, max]
    // and can auto change along with modification of min max,
    // util use specifid a range.
    realtime: true,
    // Whether realtime update.
    itemHeight: null,
    // The length of the range control edge.
    itemWidth: null,
    // The length of the other side.
    hoverLink: true,
    // Enable hover highlight.
    hoverLinkDataSize: null,
    // The size of hovered data.
    hoverLinkOnHandle: null // Whether trigger hoverLink when hover handle.
    // If not specified, follow the value of `realtime`.

  },

  /**
   * @override
   */
  optionUpdated: function (newOption, isInit) {
    ContinuousModel.superApply(this, 'optionUpdated', arguments);
    this.resetExtent();
    this.resetVisual(function (mappingOption) {
      mappingOption.mappingMethod = 'linear';
      mappingOption.dataExtent = this.getExtent();
    });

    this._resetRange();
  },

  /**
   * @protected
   * @override
   */
  resetItemSize: function () {
    ContinuousModel.superApply(this, 'resetItemSize', arguments);
    var itemSize = this.itemSize;
    this._orient === 'horizontal' && itemSize.reverse();
    (itemSize[0] == null || isNaN(itemSize[0])) && (itemSize[0] = DEFAULT_BAR_BOUND[0]);
    (itemSize[1] == null || isNaN(itemSize[1])) && (itemSize[1] = DEFAULT_BAR_BOUND[1]);
  },

  /**
   * @private
   */
  _resetRange: function () {
    var dataExtent = this.getExtent();
    var range = this.option.range;

    if (!range || range.auto) {
      // `range` should always be array (so we dont use other
      // value like 'auto') for user-friend. (consider getOption).
      dataExtent.auto = 1;
      this.option.range = dataExtent;
    } else if (zrUtil.isArray(range)) {
      if (range[0] > range[1]) {
        range.reverse();
      }

      range[0] = Math.max(range[0], dataExtent[0]);
      range[1] = Math.min(range[1], dataExtent[1]);
    }
  },

  /**
   * @protected
   * @override
   */
  completeVisualOption: function () {
    VisualMapModel.prototype.completeVisualOption.apply(this, arguments);
    zrUtil.each(this.stateList, function (state) {
      var symbolSize = this.option.controller[state].symbolSize;

      if (symbolSize && symbolSize[0] !== symbolSize[1]) {
        symbolSize[0] = 0; // For good looking.
      }
    }, this);
  },

  /**
   * @override
   */
  setSelected: function (selected) {
    this.option.range = selected.slice();

    this._resetRange();
  },

  /**
   * @public
   */
  getSelected: function () {
    var dataExtent = this.getExtent();
    var dataInterval = numberUtil.asc((this.get('range') || []).slice()); // Clamp

    dataInterval[0] > dataExtent[1] && (dataInterval[0] = dataExtent[1]);
    dataInterval[1] > dataExtent[1] && (dataInterval[1] = dataExtent[1]);
    dataInterval[0] < dataExtent[0] && (dataInterval[0] = dataExtent[0]);
    dataInterval[1] < dataExtent[0] && (dataInterval[1] = dataExtent[0]);
    return dataInterval;
  },

  /**
   * @override
   */
  getValueState: function (value) {
    var range = this.option.range;
    var dataExtent = this.getExtent(); // When range[0] === dataExtent[0], any value larger than dataExtent[0] maps to 'inRange'.
    // range[1] is processed likewise.

    return (range[0] <= dataExtent[0] || range[0] <= value) && (range[1] >= dataExtent[1] || value <= range[1]) ? 'inRange' : 'outOfRange';
  },

  /**
   * @params {Array.<number>} range target value: range[0] <= value && value <= range[1]
   * @return {Array.<Object>} [{seriesId, dataIndices: <Array.<number>>}, ...]
   */
  findTargetDataIndices: function (range) {
    var result = [];
    this.eachTargetSeries(function (seriesModel) {
      var dataIndices = [];
      var data = seriesModel.getData();
      data.each(this.getDataDimension(data), function (value, dataIndex) {
        range[0] <= value && value <= range[1] && dataIndices.push(dataIndex);
      }, this);
      result.push({
        seriesId: seriesModel.id,
        dataIndex: dataIndices
      });
    }, this);
    return result;
  },

  /**
   * @implement
   */
  getVisualMeta: function (getColorVisual) {
    var oVals = getColorStopValues(this, 'outOfRange', this.getExtent());
    var iVals = getColorStopValues(this, 'inRange', this.option.range.slice());
    var stops = [];

    function setStop(value, valueState) {
      stops.push({
        value: value,
        color: getColorVisual(value, valueState)
      });
    } // Format to: outOfRange -- inRange -- outOfRange.


    var iIdx = 0;
    var oIdx = 0;
    var iLen = iVals.length;
    var oLen = oVals.length;

    for (; oIdx < oLen && (!iVals.length || oVals[oIdx] <= iVals[0]); oIdx++) {
      // If oVal[oIdx] === iVals[iIdx], oVal[oIdx] should be ignored.
      if (oVals[oIdx] < iVals[iIdx]) {
        setStop(oVals[oIdx], 'outOfRange');
      }
    }

    for (var first = 1; iIdx < iLen; iIdx++, first = 0) {
      // If range is full, value beyond min, max will be clamped.
      // make a singularity
      first && stops.length && setStop(iVals[iIdx], 'outOfRange');
      setStop(iVals[iIdx], 'inRange');
    }

    for (var first = 1; oIdx < oLen; oIdx++) {
      if (!iVals.length || iVals[iVals.length - 1] < oVals[oIdx]) {
        // make a singularity
        if (first) {
          stops.length && setStop(stops[stops.length - 1].value, 'outOfRange');
          first = 0;
        }

        setStop(oVals[oIdx], 'outOfRange');
      }
    }

    var stopsLen = stops.length;
    return {
      stops: stops,
      outerColors: [stopsLen ? stops[0].color : 'transparent', stopsLen ? stops[stopsLen - 1].color : 'transparent']
    };
  }
});

function getColorStopValues(visualMapModel, valueState, dataExtent) {
  if (dataExtent[0] === dataExtent[1]) {
    return dataExtent.slice();
  } // When using colorHue mapping, it is not linear color any more.
  // Moreover, canvas gradient seems not to be accurate linear.
  // FIXME
  // Should be arbitrary value 100? or based on pixel size?


  var count = 200;
  var step = (dataExtent[1] - dataExtent[0]) / count;
  var value = dataExtent[0];
  var stopValues = [];

  for (var i = 0; i <= count && value < dataExtent[1]; i++) {
    stopValues.push(value);
    value += step;
  }

  stopValues.push(dataExtent[1]);
  return stopValues;
}

var _default = ContinuousModel;
module.exports = _default;

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var LinearGradient = __webpack_require__(409);

var eventTool = __webpack_require__(121);

var VisualMapView = __webpack_require__(693);

var graphic = __webpack_require__(27);

var numberUtil = __webpack_require__(37);

var sliderMove = __webpack_require__(210);

var helper = __webpack_require__(694);

var modelUtil = __webpack_require__(44);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var linearMap = numberUtil.linearMap;
var each = zrUtil.each;
var mathMin = Math.min;
var mathMax = Math.max; // Arbitrary value

var HOVER_LINK_SIZE = 12;
var HOVER_LINK_OUT = 6; // Notice:
// Any "interval" should be by the order of [low, high].
// "handle0" (handleIndex === 0) maps to
// low data value: this._dataInterval[0] and has low coord.
// "handle1" (handleIndex === 1) maps to
// high data value: this._dataInterval[1] and has high coord.
// The logic of transform is implemented in this._createBarGroup.

var ContinuousView = VisualMapView.extend({
  type: 'visualMap.continuous',

  /**
   * @override
   */
  init: function () {
    ContinuousView.superApply(this, 'init', arguments);
    /**
     * @private
     */

    this._shapes = {};
    /**
     * @private
     */

    this._dataInterval = [];
    /**
     * @private
     */

    this._handleEnds = [];
    /**
     * @private
     */

    this._orient;
    /**
     * @private
     */

    this._useHandle;
    /**
     * @private
     */

    this._hoverLinkDataIndices = [];
    /**
     * @private
     */

    this._dragging;
    /**
     * @private
     */

    this._hovering;
  },

  /**
   * @protected
   * @override
   */
  doRender: function (visualMapModel, ecModel, api, payload) {
    if (!payload || payload.type !== 'selectDataRange' || payload.from !== this.uid) {
      this._buildView();
    }
  },

  /**
   * @private
   */
  _buildView: function () {
    this.group.removeAll();
    var visualMapModel = this.visualMapModel;
    var thisGroup = this.group;
    this._orient = visualMapModel.get('orient');
    this._useHandle = visualMapModel.get('calculable');

    this._resetInterval();

    this._renderBar(thisGroup);

    var dataRangeText = visualMapModel.get('text');

    this._renderEndsText(thisGroup, dataRangeText, 0);

    this._renderEndsText(thisGroup, dataRangeText, 1); // Do this for background size calculation.


    this._updateView(true); // After updating view, inner shapes is built completely,
    // and then background can be rendered.


    this.renderBackground(thisGroup); // Real update view

    this._updateView();

    this._enableHoverLinkToSeries();

    this._enableHoverLinkFromSeries();

    this.positionGroup(thisGroup);
  },

  /**
   * @private
   */
  _renderEndsText: function (group, dataRangeText, endsIndex) {
    if (!dataRangeText) {
      return;
    } // Compatible with ec2, text[0] map to high value, text[1] map low value.


    var text = dataRangeText[1 - endsIndex];
    text = text != null ? text + '' : '';
    var visualMapModel = this.visualMapModel;
    var textGap = visualMapModel.get('textGap');
    var itemSize = visualMapModel.itemSize;
    var barGroup = this._shapes.barGroup;

    var position = this._applyTransform([itemSize[0] / 2, endsIndex === 0 ? -textGap : itemSize[1] + textGap], barGroup);

    var align = this._applyTransform(endsIndex === 0 ? 'bottom' : 'top', barGroup);

    var orient = this._orient;
    var textStyleModel = this.visualMapModel.textStyleModel;
    this.group.add(new graphic.Text({
      style: {
        x: position[0],
        y: position[1],
        textVerticalAlign: orient === 'horizontal' ? 'middle' : align,
        textAlign: orient === 'horizontal' ? align : 'center',
        text: text,
        textFont: textStyleModel.getFont(),
        textFill: textStyleModel.getTextColor()
      }
    }));
  },

  /**
   * @private
   */
  _renderBar: function (targetGroup) {
    var visualMapModel = this.visualMapModel;
    var shapes = this._shapes;
    var itemSize = visualMapModel.itemSize;
    var orient = this._orient;
    var useHandle = this._useHandle;
    var itemAlign = helper.getItemAlign(visualMapModel, this.api, itemSize);

    var barGroup = shapes.barGroup = this._createBarGroup(itemAlign); // Bar


    barGroup.add(shapes.outOfRange = createPolygon());
    barGroup.add(shapes.inRange = createPolygon(null, useHandle ? getCursor(this._orient) : null, zrUtil.bind(this._dragHandle, this, 'all', false), zrUtil.bind(this._dragHandle, this, 'all', true)));
    var textRect = visualMapModel.textStyleModel.getTextRect('国');
    var textSize = mathMax(textRect.width, textRect.height); // Handle

    if (useHandle) {
      shapes.handleThumbs = [];
      shapes.handleLabels = [];
      shapes.handleLabelPoints = [];

      this._createHandle(barGroup, 0, itemSize, textSize, orient, itemAlign);

      this._createHandle(barGroup, 1, itemSize, textSize, orient, itemAlign);
    }

    this._createIndicator(barGroup, itemSize, textSize, orient);

    targetGroup.add(barGroup);
  },

  /**
   * @private
   */
  _createHandle: function (barGroup, handleIndex, itemSize, textSize, orient) {
    var onDrift = zrUtil.bind(this._dragHandle, this, handleIndex, false);
    var onDragEnd = zrUtil.bind(this._dragHandle, this, handleIndex, true);
    var handleThumb = createPolygon(createHandlePoints(handleIndex, textSize), getCursor(this._orient), onDrift, onDragEnd);
    handleThumb.position[0] = itemSize[0];
    barGroup.add(handleThumb); // Text is always horizontal layout but should not be effected by
    // transform (orient/inverse). So label is built separately but not
    // use zrender/graphic/helper/RectText, and is located based on view
    // group (according to handleLabelPoint) but not barGroup.

    var textStyleModel = this.visualMapModel.textStyleModel;
    var handleLabel = new graphic.Text({
      draggable: true,
      drift: onDrift,
      onmousemove: function (e) {
        // Fot mobile devicem, prevent screen slider on the button.
        eventTool.stop(e.event);
      },
      ondragend: onDragEnd,
      style: {
        x: 0,
        y: 0,
        text: '',
        textFont: textStyleModel.getFont(),
        textFill: textStyleModel.getTextColor()
      }
    });
    this.group.add(handleLabel);
    var handleLabelPoint = [orient === 'horizontal' ? textSize / 2 : textSize * 1.5, orient === 'horizontal' ? handleIndex === 0 ? -(textSize * 1.5) : textSize * 1.5 : handleIndex === 0 ? -textSize / 2 : textSize / 2];
    var shapes = this._shapes;
    shapes.handleThumbs[handleIndex] = handleThumb;
    shapes.handleLabelPoints[handleIndex] = handleLabelPoint;
    shapes.handleLabels[handleIndex] = handleLabel;
  },

  /**
   * @private
   */
  _createIndicator: function (barGroup, itemSize, textSize, orient) {
    var indicator = createPolygon([[0, 0]], 'move');
    indicator.position[0] = itemSize[0];
    indicator.attr({
      invisible: true,
      silent: true
    });
    barGroup.add(indicator);
    var textStyleModel = this.visualMapModel.textStyleModel;
    var indicatorLabel = new graphic.Text({
      silent: true,
      invisible: true,
      style: {
        x: 0,
        y: 0,
        text: '',
        textFont: textStyleModel.getFont(),
        textFill: textStyleModel.getTextColor()
      }
    });
    this.group.add(indicatorLabel);
    var indicatorLabelPoint = [orient === 'horizontal' ? textSize / 2 : HOVER_LINK_OUT + 3, 0];
    var shapes = this._shapes;
    shapes.indicator = indicator;
    shapes.indicatorLabel = indicatorLabel;
    shapes.indicatorLabelPoint = indicatorLabelPoint;
  },

  /**
   * @private
   */
  _dragHandle: function (handleIndex, isEnd, dx, dy) {
    if (!this._useHandle) {
      return;
    }

    this._dragging = !isEnd;

    if (!isEnd) {
      // Transform dx, dy to bar coordination.
      var vertex = this._applyTransform([dx, dy], this._shapes.barGroup, true);

      this._updateInterval(handleIndex, vertex[1]); // Considering realtime, update view should be executed
      // before dispatch action.


      this._updateView();
    } // dragEnd do not dispatch action when realtime.


    if (isEnd === !this.visualMapModel.get('realtime')) {
      // jshint ignore:line
      this.api.dispatchAction({
        type: 'selectDataRange',
        from: this.uid,
        visualMapId: this.visualMapModel.id,
        selected: this._dataInterval.slice()
      });
    }

    if (isEnd) {
      !this._hovering && this._clearHoverLinkToSeries();
    } else if (useHoverLinkOnHandle(this.visualMapModel)) {
      this._doHoverLinkToSeries(this._handleEnds[handleIndex], false);
    }
  },

  /**
   * @private
   */
  _resetInterval: function () {
    var visualMapModel = this.visualMapModel;
    var dataInterval = this._dataInterval = visualMapModel.getSelected();
    var dataExtent = visualMapModel.getExtent();
    var sizeExtent = [0, visualMapModel.itemSize[1]];
    this._handleEnds = [linearMap(dataInterval[0], dataExtent, sizeExtent, true), linearMap(dataInterval[1], dataExtent, sizeExtent, true)];
  },

  /**
   * @private
   * @param {(number|string)} handleIndex 0 or 1 or 'all'
   * @param {number} dx
   * @param {number} dy
   */
  _updateInterval: function (handleIndex, delta) {
    delta = delta || 0;
    var visualMapModel = this.visualMapModel;
    var handleEnds = this._handleEnds;
    var sizeExtent = [0, visualMapModel.itemSize[1]];
    sliderMove(delta, handleEnds, sizeExtent, handleIndex, // cross is forbiden
    0);
    var dataExtent = visualMapModel.getExtent(); // Update data interval.

    this._dataInterval = [linearMap(handleEnds[0], sizeExtent, dataExtent, true), linearMap(handleEnds[1], sizeExtent, dataExtent, true)];
  },

  /**
   * @private
   */
  _updateView: function (forSketch) {
    var visualMapModel = this.visualMapModel;
    var dataExtent = visualMapModel.getExtent();
    var shapes = this._shapes;
    var outOfRangeHandleEnds = [0, visualMapModel.itemSize[1]];
    var inRangeHandleEnds = forSketch ? outOfRangeHandleEnds : this._handleEnds;

    var visualInRange = this._createBarVisual(this._dataInterval, dataExtent, inRangeHandleEnds, 'inRange');

    var visualOutOfRange = this._createBarVisual(dataExtent, dataExtent, outOfRangeHandleEnds, 'outOfRange');

    shapes.inRange.setStyle({
      fill: visualInRange.barColor,
      opacity: visualInRange.opacity
    }).setShape('points', visualInRange.barPoints);
    shapes.outOfRange.setStyle({
      fill: visualOutOfRange.barColor,
      opacity: visualOutOfRange.opacity
    }).setShape('points', visualOutOfRange.barPoints);

    this._updateHandle(inRangeHandleEnds, visualInRange);
  },

  /**
   * @private
   */
  _createBarVisual: function (dataInterval, dataExtent, handleEnds, forceState) {
    var opts = {
      forceState: forceState,
      convertOpacityToAlpha: true
    };

    var colorStops = this._makeColorGradient(dataInterval, opts);

    var symbolSizes = [this.getControllerVisual(dataInterval[0], 'symbolSize', opts), this.getControllerVisual(dataInterval[1], 'symbolSize', opts)];

    var barPoints = this._createBarPoints(handleEnds, symbolSizes);

    return {
      barColor: new LinearGradient(0, 0, 0, 1, colorStops),
      barPoints: barPoints,
      handlesColor: [colorStops[0].color, colorStops[colorStops.length - 1].color]
    };
  },

  /**
   * @private
   */
  _makeColorGradient: function (dataInterval, opts) {
    // Considering colorHue, which is not linear, so we have to sample
    // to calculate gradient color stops, but not only caculate head
    // and tail.
    var sampleNumber = 100; // Arbitrary value.

    var colorStops = [];
    var step = (dataInterval[1] - dataInterval[0]) / sampleNumber;
    colorStops.push({
      color: this.getControllerVisual(dataInterval[0], 'color', opts),
      offset: 0
    });

    for (var i = 1; i < sampleNumber; i++) {
      var currValue = dataInterval[0] + step * i;

      if (currValue > dataInterval[1]) {
        break;
      }

      colorStops.push({
        color: this.getControllerVisual(currValue, 'color', opts),
        offset: i / sampleNumber
      });
    }

    colorStops.push({
      color: this.getControllerVisual(dataInterval[1], 'color', opts),
      offset: 1
    });
    return colorStops;
  },

  /**
   * @private
   */
  _createBarPoints: function (handleEnds, symbolSizes) {
    var itemSize = this.visualMapModel.itemSize;
    return [[itemSize[0] - symbolSizes[0], handleEnds[0]], [itemSize[0], handleEnds[0]], [itemSize[0], handleEnds[1]], [itemSize[0] - symbolSizes[1], handleEnds[1]]];
  },

  /**
   * @private
   */
  _createBarGroup: function (itemAlign) {
    var orient = this._orient;
    var inverse = this.visualMapModel.get('inverse');
    return new graphic.Group(orient === 'horizontal' && !inverse ? {
      scale: itemAlign === 'bottom' ? [1, 1] : [-1, 1],
      rotation: Math.PI / 2
    } : orient === 'horizontal' && inverse ? {
      scale: itemAlign === 'bottom' ? [-1, 1] : [1, 1],
      rotation: -Math.PI / 2
    } : orient === 'vertical' && !inverse ? {
      scale: itemAlign === 'left' ? [1, -1] : [-1, -1]
    } : {
      scale: itemAlign === 'left' ? [1, 1] : [-1, 1]
    });
  },

  /**
   * @private
   */
  _updateHandle: function (handleEnds, visualInRange) {
    if (!this._useHandle) {
      return;
    }

    var shapes = this._shapes;
    var visualMapModel = this.visualMapModel;
    var handleThumbs = shapes.handleThumbs;
    var handleLabels = shapes.handleLabels;
    each([0, 1], function (handleIndex) {
      var handleThumb = handleThumbs[handleIndex];
      handleThumb.setStyle('fill', visualInRange.handlesColor[handleIndex]);
      handleThumb.position[1] = handleEnds[handleIndex]; // Update handle label position.

      var textPoint = graphic.applyTransform(shapes.handleLabelPoints[handleIndex], graphic.getTransform(handleThumb, this.group));
      handleLabels[handleIndex].setStyle({
        x: textPoint[0],
        y: textPoint[1],
        text: visualMapModel.formatValueText(this._dataInterval[handleIndex]),
        textVerticalAlign: 'middle',
        textAlign: this._applyTransform(this._orient === 'horizontal' ? handleIndex === 0 ? 'bottom' : 'top' : 'left', shapes.barGroup)
      });
    }, this);
  },

  /**
   * @private
   * @param {number} cursorValue
   * @param {number} textValue
   * @param {string} [rangeSymbol]
   * @param {number} [halfHoverLinkSize]
   */
  _showIndicator: function (cursorValue, textValue, rangeSymbol, halfHoverLinkSize) {
    var visualMapModel = this.visualMapModel;
    var dataExtent = visualMapModel.getExtent();
    var itemSize = visualMapModel.itemSize;
    var sizeExtent = [0, itemSize[1]];
    var pos = linearMap(cursorValue, dataExtent, sizeExtent, true);
    var shapes = this._shapes;
    var indicator = shapes.indicator;

    if (!indicator) {
      return;
    }

    indicator.position[1] = pos;
    indicator.attr('invisible', false);
    indicator.setShape('points', createIndicatorPoints(!!rangeSymbol, halfHoverLinkSize, pos, itemSize[1]));
    var opts = {
      convertOpacityToAlpha: true
    };
    var color = this.getControllerVisual(cursorValue, 'color', opts);
    indicator.setStyle('fill', color); // Update handle label position.

    var textPoint = graphic.applyTransform(shapes.indicatorLabelPoint, graphic.getTransform(indicator, this.group));
    var indicatorLabel = shapes.indicatorLabel;
    indicatorLabel.attr('invisible', false);

    var align = this._applyTransform('left', shapes.barGroup);

    var orient = this._orient;
    indicatorLabel.setStyle({
      text: (rangeSymbol ? rangeSymbol : '') + visualMapModel.formatValueText(textValue),
      textVerticalAlign: orient === 'horizontal' ? align : 'middle',
      textAlign: orient === 'horizontal' ? 'center' : align,
      x: textPoint[0],
      y: textPoint[1]
    });
  },

  /**
   * @private
   */
  _enableHoverLinkToSeries: function () {
    var self = this;

    this._shapes.barGroup.on('mousemove', function (e) {
      self._hovering = true;

      if (!self._dragging) {
        var itemSize = self.visualMapModel.itemSize;

        var pos = self._applyTransform([e.offsetX, e.offsetY], self._shapes.barGroup, true, true); // For hover link show when hover handle, which might be
        // below or upper than sizeExtent.


        pos[1] = mathMin(mathMax(0, pos[1]), itemSize[1]);

        self._doHoverLinkToSeries(pos[1], 0 <= pos[0] && pos[0] <= itemSize[0]);
      }
    }).on('mouseout', function () {
      // When mouse is out of handle, hoverLink still need
      // to be displayed when realtime is set as false.
      self._hovering = false;
      !self._dragging && self._clearHoverLinkToSeries();
    });
  },

  /**
   * @private
   */
  _enableHoverLinkFromSeries: function () {
    var zr = this.api.getZr();

    if (this.visualMapModel.option.hoverLink) {
      zr.on('mouseover', this._hoverLinkFromSeriesMouseOver, this);
      zr.on('mouseout', this._hideIndicator, this);
    } else {
      this._clearHoverLinkFromSeries();
    }
  },

  /**
   * @private
   */
  _doHoverLinkToSeries: function (cursorPos, hoverOnBar) {
    var visualMapModel = this.visualMapModel;
    var itemSize = visualMapModel.itemSize;

    if (!visualMapModel.option.hoverLink) {
      return;
    }

    var sizeExtent = [0, itemSize[1]];
    var dataExtent = visualMapModel.getExtent(); // For hover link show when hover handle, which might be below or upper than sizeExtent.

    cursorPos = mathMin(mathMax(sizeExtent[0], cursorPos), sizeExtent[1]);
    var halfHoverLinkSize = getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent);
    var hoverRange = [cursorPos - halfHoverLinkSize, cursorPos + halfHoverLinkSize];
    var cursorValue = linearMap(cursorPos, sizeExtent, dataExtent, true);
    var valueRange = [linearMap(hoverRange[0], sizeExtent, dataExtent, true), linearMap(hoverRange[1], sizeExtent, dataExtent, true)]; // Consider data range is out of visualMap range, see test/visualMap-continuous.html,
    // where china and india has very large population.

    hoverRange[0] < sizeExtent[0] && (valueRange[0] = -Infinity);
    hoverRange[1] > sizeExtent[1] && (valueRange[1] = Infinity); // Do not show indicator when mouse is over handle,
    // otherwise labels overlap, especially when dragging.

    if (hoverOnBar) {
      if (valueRange[0] === -Infinity) {
        this._showIndicator(cursorValue, valueRange[1], '< ', halfHoverLinkSize);
      } else if (valueRange[1] === Infinity) {
        this._showIndicator(cursorValue, valueRange[0], '> ', halfHoverLinkSize);
      } else {
        this._showIndicator(cursorValue, cursorValue, '≈ ', halfHoverLinkSize);
      }
    } // When realtime is set as false, handles, which are in barGroup,
    // also trigger hoverLink, which help user to realize where they
    // focus on when dragging. (see test/heatmap-large.html)
    // When realtime is set as true, highlight will not show when hover
    // handle, because the label on handle, which displays a exact value
    // but not range, might mislead users.


    var oldBatch = this._hoverLinkDataIndices;
    var newBatch = [];

    if (hoverOnBar || useHoverLinkOnHandle(visualMapModel)) {
      newBatch = this._hoverLinkDataIndices = visualMapModel.findTargetDataIndices(valueRange);
    }

    var resultBatches = modelUtil.compressBatches(oldBatch, newBatch);

    this._dispatchHighDown('downplay', helper.makeHighDownBatch(resultBatches[0], visualMapModel));

    this._dispatchHighDown('highlight', helper.makeHighDownBatch(resultBatches[1], visualMapModel));
  },

  /**
   * @private
   */
  _hoverLinkFromSeriesMouseOver: function (e) {
    var el = e.target;
    var visualMapModel = this.visualMapModel;

    if (!el || el.dataIndex == null) {
      return;
    }

    var dataModel = this.ecModel.getSeriesByIndex(el.seriesIndex);

    if (!visualMapModel.isTargetSeries(dataModel)) {
      return;
    }

    var data = dataModel.getData(el.dataType);
    var value = data.get(visualMapModel.getDataDimension(data), el.dataIndex, true);

    if (!isNaN(value)) {
      this._showIndicator(value, value);
    }
  },

  /**
   * @private
   */
  _hideIndicator: function () {
    var shapes = this._shapes;
    shapes.indicator && shapes.indicator.attr('invisible', true);
    shapes.indicatorLabel && shapes.indicatorLabel.attr('invisible', true);
  },

  /**
   * @private
   */
  _clearHoverLinkToSeries: function () {
    this._hideIndicator();

    var indices = this._hoverLinkDataIndices;

    this._dispatchHighDown('downplay', helper.makeHighDownBatch(indices, this.visualMapModel));

    indices.length = 0;
  },

  /**
   * @private
   */
  _clearHoverLinkFromSeries: function () {
    this._hideIndicator();

    var zr = this.api.getZr();
    zr.off('mouseover', this._hoverLinkFromSeriesMouseOver);
    zr.off('mouseout', this._hideIndicator);
  },

  /**
   * @private
   */
  _applyTransform: function (vertex, element, inverse, global) {
    var transform = graphic.getTransform(element, global ? null : this.group);
    return graphic[zrUtil.isArray(vertex) ? 'applyTransform' : 'transformDirection'](vertex, transform, inverse);
  },

  /**
   * @private
   */
  _dispatchHighDown: function (type, batch) {
    batch && batch.length && this.api.dispatchAction({
      type: type,
      batch: batch
    });
  },

  /**
   * @override
   */
  dispose: function () {
    this._clearHoverLinkFromSeries();

    this._clearHoverLinkToSeries();
  },

  /**
   * @override
   */
  remove: function () {
    this._clearHoverLinkFromSeries();

    this._clearHoverLinkToSeries();
  }
});

function createPolygon(points, cursor, onDrift, onDragEnd) {
  return new graphic.Polygon({
    shape: {
      points: points
    },
    draggable: !!onDrift,
    cursor: cursor,
    drift: onDrift,
    onmousemove: function (e) {
      // Fot mobile devicem, prevent screen slider on the button.
      eventTool.stop(e.event);
    },
    ondragend: onDragEnd
  });
}

function createHandlePoints(handleIndex, textSize) {
  return handleIndex === 0 ? [[0, 0], [textSize, 0], [textSize, -textSize]] : [[0, 0], [textSize, 0], [textSize, textSize]];
}

function createIndicatorPoints(isRange, halfHoverLinkSize, pos, extentMax) {
  return isRange ? [// indicate range
  [0, -mathMin(halfHoverLinkSize, mathMax(pos, 0))], [HOVER_LINK_OUT, 0], [0, mathMin(halfHoverLinkSize, mathMax(extentMax - pos, 0))]] : [// indicate single value
  [0, 0], [5, -5], [5, 5]];
}

function getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent) {
  var halfHoverLinkSize = HOVER_LINK_SIZE / 2;
  var hoverLinkDataSize = visualMapModel.get('hoverLinkDataSize');

  if (hoverLinkDataSize) {
    halfHoverLinkSize = linearMap(hoverLinkDataSize, dataExtent, sizeExtent, true) / 2;
  }

  return halfHoverLinkSize;
}

function useHoverLinkOnHandle(visualMapModel) {
  var hoverLinkOnHandle = visualMapModel.get('hoverLinkOnHandle');
  return !!(hoverLinkOnHandle == null ? visualMapModel.get('realtime') : hoverLinkOnHandle);
}

function getCursor(orient) {
  return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
}

var _default = ContinuousView;
module.exports = _default;

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(47);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(1);

var VisualMapModel = __webpack_require__(691);

var VisualMapping = __webpack_require__(181);

var visualDefault = __webpack_require__(692);

var _number = __webpack_require__(37);

var reformIntervals = _number.reformIntervals;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var PiecewiseModel = VisualMapModel.extend({
  type: 'visualMap.piecewise',

  /**
   * Order Rule:
   *
   * option.categories / option.pieces / option.text / option.selected:
   *     If !option.inverse,
   *     Order when vertical: ['top', ..., 'bottom'].
   *     Order when horizontal: ['left', ..., 'right'].
   *     If option.inverse, the meaning of
   *     the order should be reversed.
   *
   * this._pieceList:
   *     The order is always [low, ..., high].
   *
   * Mapping from location to low-high:
   *     If !option.inverse
   *     When vertical, top is high.
   *     When horizontal, right is high.
   *     If option.inverse, reverse.
   */

  /**
   * @protected
   */
  defaultOption: {
    selected: null,
    // Object. If not specified, means selected.
    // When pieces and splitNumber: {'0': true, '5': true}
    // When categories: {'cate1': false, 'cate3': true}
    // When selected === false, means all unselected.
    minOpen: false,
    // Whether include values that smaller than `min`.
    maxOpen: false,
    // Whether include values that bigger than `max`.
    align: 'auto',
    // 'auto', 'left', 'right'
    itemWidth: 20,
    // When put the controller vertically, it is the length of
    // horizontal side of each item. Otherwise, vertical side.
    itemHeight: 14,
    // When put the controller vertically, it is the length of
    // vertical side of each item. Otherwise, horizontal side.
    itemSymbol: 'roundRect',
    pieceList: null,
    // Each item is Object, with some of those attrs:
    // {min, max, lt, gt, lte, gte, value,
    // color, colorSaturation, colorAlpha, opacity,
    // symbol, symbolSize}, which customize the range or visual
    // coding of the certain piece. Besides, see "Order Rule".
    categories: null,
    // category names, like: ['some1', 'some2', 'some3'].
    // Attr min/max are ignored when categories set. See "Order Rule"
    splitNumber: 5,
    // If set to 5, auto split five pieces equally.
    // If set to 0 and component type not set, component type will be
    // determined as "continuous". (It is less reasonable but for ec2
    // compatibility, see echarts/component/visualMap/typeDefaulter)
    selectedMode: 'multiple',
    // Can be 'multiple' or 'single'.
    itemGap: 10,
    // The gap between two items, in px.
    hoverLink: true,
    // Enable hover highlight.
    showLabel: null // By default, when text is used, label will hide (the logic
    // is remained for compatibility reason)

  },

  /**
   * @override
   */
  optionUpdated: function (newOption, isInit) {
    PiecewiseModel.superApply(this, 'optionUpdated', arguments);
    /**
     * The order is always [low, ..., high].
     * [{text: string, interval: Array.<number>}, ...]
     * @private
     * @type {Array.<Object>}
     */

    this._pieceList = [];
    this.resetExtent();
    /**
     * 'pieces', 'categories', 'splitNumber'
     * @type {string}
     */

    var mode = this._mode = this._determineMode();

    resetMethods[this._mode].call(this);

    this._resetSelected(newOption, isInit);

    var categories = this.option.categories;
    this.resetVisual(function (mappingOption, state) {
      if (mode === 'categories') {
        mappingOption.mappingMethod = 'category';
        mappingOption.categories = zrUtil.clone(categories);
      } else {
        mappingOption.dataExtent = this.getExtent();
        mappingOption.mappingMethod = 'piecewise';
        mappingOption.pieceList = zrUtil.map(this._pieceList, function (piece) {
          var piece = zrUtil.clone(piece);

          if (state !== 'inRange') {
            // FIXME
            // outOfRange do not support special visual in pieces.
            piece.visual = null;
          }

          return piece;
        });
      }
    });
  },

  /**
   * @protected
   * @override
   */
  completeVisualOption: function () {
    // Consider this case:
    // visualMap: {
    //      pieces: [{symbol: 'circle', lt: 0}, {symbol: 'rect', gte: 0}]
    // }
    // where no inRange/outOfRange set but only pieces. So we should make
    // default inRange/outOfRange for this case, otherwise visuals that only
    // appear in `pieces` will not be taken into account in visual encoding.
    var option = this.option;
    var visualTypesInPieces = {};
    var visualTypes = VisualMapping.listVisualTypes();
    var isCategory = this.isCategory();
    zrUtil.each(option.pieces, function (piece) {
      zrUtil.each(visualTypes, function (visualType) {
        if (piece.hasOwnProperty(visualType)) {
          visualTypesInPieces[visualType] = 1;
        }
      });
    });
    zrUtil.each(visualTypesInPieces, function (v, visualType) {
      var exists = 0;
      zrUtil.each(this.stateList, function (state) {
        exists |= has(option, state, visualType) || has(option.target, state, visualType);
      }, this);
      !exists && zrUtil.each(this.stateList, function (state) {
        (option[state] || (option[state] = {}))[visualType] = visualDefault.get(visualType, state === 'inRange' ? 'active' : 'inactive', isCategory);
      });
    }, this);

    function has(obj, state, visualType) {
      return obj && obj[state] && (zrUtil.isObject(obj[state]) ? obj[state].hasOwnProperty(visualType) : obj[state] === visualType // e.g., inRange: 'symbol'
      );
    }

    VisualMapModel.prototype.completeVisualOption.apply(this, arguments);
  },
  _resetSelected: function (newOption, isInit) {
    var thisOption = this.option;
    var pieceList = this._pieceList; // Selected do not merge but all override.

    var selected = (isInit ? thisOption : newOption).selected || {};
    thisOption.selected = selected; // Consider 'not specified' means true.

    zrUtil.each(pieceList, function (piece, index) {
      var key = this.getSelectedMapKey(piece);

      if (!selected.hasOwnProperty(key)) {
        selected[key] = true;
      }
    }, this);

    if (thisOption.selectedMode === 'single') {
      // Ensure there is only one selected.
      var hasSel = false;
      zrUtil.each(pieceList, function (piece, index) {
        var key = this.getSelectedMapKey(piece);

        if (selected[key]) {
          hasSel ? selected[key] = false : hasSel = true;
        }
      }, this);
    } // thisOption.selectedMode === 'multiple', default: all selected.

  },

  /**
   * @public
   */
  getSelectedMapKey: function (piece) {
    return this._mode === 'categories' ? piece.value + '' : piece.index + '';
  },

  /**
   * @public
   */
  getPieceList: function () {
    return this._pieceList;
  },

  /**
   * @private
   * @return {string}
   */
  _determineMode: function () {
    var option = this.option;
    return option.pieces && option.pieces.length > 0 ? 'pieces' : this.option.categories ? 'categories' : 'splitNumber';
  },

  /**
   * @public
   * @override
   */
  setSelected: function (selected) {
    this.option.selected = zrUtil.clone(selected);
  },

  /**
   * @public
   * @override
   */
  getValueState: function (value) {
    var index = VisualMapping.findPieceIndex(value, this._pieceList);
    return index != null ? this.option.selected[this.getSelectedMapKey(this._pieceList[index])] ? 'inRange' : 'outOfRange' : 'outOfRange';
  },

  /**
   * @public
   * @params {number} pieceIndex piece index in visualMapModel.getPieceList()
   * @return {Array.<Object>} [{seriesId, dataIndex: <Array.<number>>}, ...]
   */
  findTargetDataIndices: function (pieceIndex) {
    var result = [];
    this.eachTargetSeries(function (seriesModel) {
      var dataIndices = [];
      var data = seriesModel.getData();
      data.each(this.getDataDimension(data), function (value, dataIndex) {
        // Should always base on model pieceList, because it is order sensitive.
        var pIdx = VisualMapping.findPieceIndex(value, this._pieceList);
        pIdx === pieceIndex && dataIndices.push(dataIndex);
      }, this);
      result.push({
        seriesId: seriesModel.id,
        dataIndex: dataIndices
      });
    }, this);
    return result;
  },

  /**
   * @private
   * @param {Object} piece piece.value or piece.interval is required.
   * @return {number} Can be Infinity or -Infinity
   */
  getRepresentValue: function (piece) {
    var representValue;

    if (this.isCategory()) {
      representValue = piece.value;
    } else {
      if (piece.value != null) {
        representValue = piece.value;
      } else {
        var pieceInterval = piece.interval || [];
        representValue = pieceInterval[0] === -Infinity && pieceInterval[1] === Infinity ? 0 : (pieceInterval[0] + pieceInterval[1]) / 2;
      }
    }

    return representValue;
  },
  getVisualMeta: function (getColorVisual) {
    // Do not support category. (category axis is ordinal, numerical)
    if (this.isCategory()) {
      return;
    }

    var stops = [];
    var outerColors = [];
    var visualMapModel = this;

    function setStop(interval, valueState) {
      var representValue = visualMapModel.getRepresentValue({
        interval: interval
      });

      if (!valueState) {
        valueState = visualMapModel.getValueState(representValue);
      }

      var color = getColorVisual(representValue, valueState);

      if (interval[0] === -Infinity) {
        outerColors[0] = color;
      } else if (interval[1] === Infinity) {
        outerColors[1] = color;
      } else {
        stops.push({
          value: interval[0],
          color: color
        }, {
          value: interval[1],
          color: color
        });
      }
    } // Suplement


    var pieceList = this._pieceList.slice();

    if (!pieceList.length) {
      pieceList.push({
        interval: [-Infinity, Infinity]
      });
    } else {
      var edge = pieceList[0].interval[0];
      edge !== -Infinity && pieceList.unshift({
        interval: [-Infinity, edge]
      });
      edge = pieceList[pieceList.length - 1].interval[1];
      edge !== Infinity && pieceList.push({
        interval: [edge, Infinity]
      });
    }

    var curr = -Infinity;
    zrUtil.each(pieceList, function (piece) {
      var interval = piece.interval;

      if (interval) {
        // Fulfill gap.
        interval[0] > curr && setStop([curr, interval[0]], 'outOfRange');
        setStop(interval.slice());
        curr = interval[1];
      }
    }, this);
    return {
      stops: stops,
      outerColors: outerColors
    };
  }
});
/**
 * Key is this._mode
 * @type {Object}
 * @this {module:echarts/component/viusalMap/PiecewiseMode}
 */

var resetMethods = {
  splitNumber: function () {
    var thisOption = this.option;
    var pieceList = this._pieceList;
    var precision = Math.min(thisOption.precision, 20);
    var dataExtent = this.getExtent();
    var splitNumber = thisOption.splitNumber;
    splitNumber = Math.max(parseInt(splitNumber, 10), 1);
    thisOption.splitNumber = splitNumber;
    var splitStep = (dataExtent[1] - dataExtent[0]) / splitNumber; // Precision auto-adaption

    while (+splitStep.toFixed(precision) !== splitStep && precision < 5) {
      precision++;
    }

    thisOption.precision = precision;
    splitStep = +splitStep.toFixed(precision);

    if (thisOption.minOpen) {
      pieceList.push({
        interval: [-Infinity, dataExtent[0]],
        close: [0, 0]
      });
    }

    for (var index = 0, curr = dataExtent[0]; index < splitNumber; curr += splitStep, index++) {
      var max = index === splitNumber - 1 ? dataExtent[1] : curr + splitStep;
      pieceList.push({
        interval: [curr, max],
        close: [1, 1]
      });
    }

    if (thisOption.maxOpen) {
      pieceList.push({
        interval: [dataExtent[1], Infinity],
        close: [0, 0]
      });
    }

    reformIntervals(pieceList);
    zrUtil.each(pieceList, function (piece, index) {
      piece.index = index;
      piece.text = this.formatValueText(piece.interval);
    }, this);
  },
  categories: function () {
    var thisOption = this.option;
    zrUtil.each(thisOption.categories, function (cate) {
      // FIXME category模式也使用pieceList，但在visualMapping中不是使用pieceList。
      // 是否改一致。
      this._pieceList.push({
        text: this.formatValueText(cate, true),
        value: cate
      });
    }, this); // See "Order Rule".

    normalizeReverse(thisOption, this._pieceList);
  },
  pieces: function () {
    var thisOption = this.option;
    var pieceList = this._pieceList;
    zrUtil.each(thisOption.pieces, function (pieceListItem, index) {
      if (!zrUtil.isObject(pieceListItem)) {
        pieceListItem = {
          value: pieceListItem
        };
      }

      var item = {
        text: '',
        index: index
      };

      if (pieceListItem.label != null) {
        item.text = pieceListItem.label;
      }

      if (pieceListItem.hasOwnProperty('value')) {
        var value = item.value = pieceListItem.value;
        item.interval = [value, value];
        item.close = [1, 1];
      } else {
        // `min` `max` is legacy option.
        // `lt` `gt` `lte` `gte` is recommanded.
        var interval = item.interval = [];
        var close = item.close = [0, 0];
        var closeList = [1, 0, 1];
        var infinityList = [-Infinity, Infinity];
        var useMinMax = [];

        for (var lg = 0; lg < 2; lg++) {
          var names = [['gte', 'gt', 'min'], ['lte', 'lt', 'max']][lg];

          for (var i = 0; i < 3 && interval[lg] == null; i++) {
            interval[lg] = pieceListItem[names[i]];
            close[lg] = closeList[i];
            useMinMax[lg] = i === 2;
          }

          interval[lg] == null && (interval[lg] = infinityList[lg]);
        }

        useMinMax[0] && interval[1] === Infinity && (close[0] = 0);
        useMinMax[1] && interval[0] === -Infinity && (close[1] = 0);

        if (interval[0] === interval[1] && close[0] && close[1]) {
          // Consider: [{min: 5, max: 5, visual: {...}}, {min: 0, max: 5}],
          // we use value to lift the priority when min === max
          item.value = interval[0];
        }
      }

      item.visual = VisualMapping.retrieveVisuals(pieceListItem);
      pieceList.push(item);
    }, this); // See "Order Rule".

    normalizeReverse(thisOption, pieceList); // Only pieces

    reformIntervals(pieceList);
    zrUtil.each(pieceList, function (piece) {
      var close = piece.close;
      var edgeSymbols = [['<', '≤'][close[1]], ['>', '≥'][close[0]]];
      piece.text = piece.text || this.formatValueText(piece.value != null ? piece.value : piece.interval, false, edgeSymbols);
    }, this);
  }
};

function normalizeReverse(thisOption, pieceList) {
  var inverse = thisOption.inverse;

  if (thisOption.orient === 'vertical' ? !inverse : inverse) {
    pieceList.reverse();
  }
}

var _default = PiecewiseModel;
module.exports = _default;

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(1);

var VisualMapView = __webpack_require__(693);

var graphic = __webpack_require__(27);

var _symbol = __webpack_require__(99);

var createSymbol = _symbol.createSymbol;

var layout = __webpack_require__(53);

var helper = __webpack_require__(694);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var PiecewiseVisualMapView = VisualMapView.extend({
  type: 'visualMap.piecewise',

  /**
   * @protected
   * @override
   */
  doRender: function () {
    var thisGroup = this.group;
    thisGroup.removeAll();
    var visualMapModel = this.visualMapModel;
    var textGap = visualMapModel.get('textGap');
    var textStyleModel = visualMapModel.textStyleModel;
    var textFont = textStyleModel.getFont();
    var textFill = textStyleModel.getTextColor();

    var itemAlign = this._getItemAlign();

    var itemSize = visualMapModel.itemSize;

    var viewData = this._getViewData();

    var endsText = viewData.endsText;
    var showLabel = zrUtil.retrieve(visualMapModel.get('showLabel', true), !endsText);
    endsText && this._renderEndsText(thisGroup, endsText[0], itemSize, showLabel, itemAlign);
    zrUtil.each(viewData.viewPieceList, renderItem, this);
    endsText && this._renderEndsText(thisGroup, endsText[1], itemSize, showLabel, itemAlign);
    layout.box(visualMapModel.get('orient'), thisGroup, visualMapModel.get('itemGap'));
    this.renderBackground(thisGroup);
    this.positionGroup(thisGroup);

    function renderItem(item) {
      var piece = item.piece;
      var itemGroup = new graphic.Group();
      itemGroup.onclick = zrUtil.bind(this._onItemClick, this, piece);

      this._enableHoverLink(itemGroup, item.indexInModelPieceList);

      var representValue = visualMapModel.getRepresentValue(piece);

      this._createItemSymbol(itemGroup, representValue, [0, 0, itemSize[0], itemSize[1]]);

      if (showLabel) {
        var visualState = this.visualMapModel.getValueState(representValue);
        itemGroup.add(new graphic.Text({
          style: {
            x: itemAlign === 'right' ? -textGap : itemSize[0] + textGap,
            y: itemSize[1] / 2,
            text: piece.text,
            textVerticalAlign: 'middle',
            textAlign: itemAlign,
            textFont: textFont,
            textFill: textFill,
            opacity: visualState === 'outOfRange' ? 0.5 : 1
          }
        }));
      }

      thisGroup.add(itemGroup);
    }
  },

  /**
   * @private
   */
  _enableHoverLink: function (itemGroup, pieceIndex) {
    itemGroup.on('mouseover', zrUtil.bind(onHoverLink, this, 'highlight')).on('mouseout', zrUtil.bind(onHoverLink, this, 'downplay'));

    function onHoverLink(method) {
      var visualMapModel = this.visualMapModel;
      visualMapModel.option.hoverLink && this.api.dispatchAction({
        type: method,
        batch: helper.makeHighDownBatch(visualMapModel.findTargetDataIndices(pieceIndex), visualMapModel)
      });
    }
  },

  /**
   * @private
   */
  _getItemAlign: function () {
    var visualMapModel = this.visualMapModel;
    var modelOption = visualMapModel.option;

    if (modelOption.orient === 'vertical') {
      return helper.getItemAlign(visualMapModel, this.api, visualMapModel.itemSize);
    } else {
      // horizontal, most case left unless specifying right.
      var align = modelOption.align;

      if (!align || align === 'auto') {
        align = 'left';
      }

      return align;
    }
  },

  /**
   * @private
   */
  _renderEndsText: function (group, text, itemSize, showLabel, itemAlign) {
    if (!text) {
      return;
    }

    var itemGroup = new graphic.Group();
    var textStyleModel = this.visualMapModel.textStyleModel;
    itemGroup.add(new graphic.Text({
      style: {
        x: showLabel ? itemAlign === 'right' ? itemSize[0] : 0 : itemSize[0] / 2,
        y: itemSize[1] / 2,
        textVerticalAlign: 'middle',
        textAlign: showLabel ? itemAlign : 'center',
        text: text,
        textFont: textStyleModel.getFont(),
        textFill: textStyleModel.getTextColor()
      }
    }));
    group.add(itemGroup);
  },

  /**
   * @private
   * @return {Object} {peiceList, endsText} The order is the same as screen pixel order.
   */
  _getViewData: function () {
    var visualMapModel = this.visualMapModel;
    var viewPieceList = zrUtil.map(visualMapModel.getPieceList(), function (piece, index) {
      return {
        piece: piece,
        indexInModelPieceList: index
      };
    });
    var endsText = visualMapModel.get('text'); // Consider orient and inverse.

    var orient = visualMapModel.get('orient');
    var inverse = visualMapModel.get('inverse'); // Order of model pieceList is always [low, ..., high]

    if (orient === 'horizontal' ? inverse : !inverse) {
      viewPieceList.reverse();
    } // Origin order of endsText is [high, low]
    else if (endsText) {
        endsText = endsText.slice().reverse();
      }

    return {
      viewPieceList: viewPieceList,
      endsText: endsText
    };
  },

  /**
   * @private
   */
  _createItemSymbol: function (group, representValue, shapeParam) {
    group.add(createSymbol(this.getControllerVisual(representValue, 'symbol'), shapeParam[0], shapeParam[1], shapeParam[2], shapeParam[3], this.getControllerVisual(representValue, 'color')));
  },

  /**
   * @private
   */
  _onItemClick: function (piece) {
    var visualMapModel = this.visualMapModel;
    var option = visualMapModel.option;
    var selected = zrUtil.clone(option.selected);
    var newKey = visualMapModel.getSelectedMapKey(piece);

    if (option.selectedMode === 'single') {
      selected[newKey] = true;
      zrUtil.each(selected, function (o, key) {
        selected[key] = key === newKey;
      });
    } else {
      selected[newKey] = !selected[newKey];
    }

    this.api.dispatchAction({
      type: 'selectDataRange',
      from: this.uid,
      visualMapId: this.visualMapModel.id,
      selected: selected
    });
  }
});
var _default = PiecewiseVisualMapView;
module.exports = _default;

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1812);

var _zrender = __webpack_require__(291);

var registerPainter = _zrender.registerPainter;

var Painter = __webpack_require__(1813);

registerPainter('vml', Painter);

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

var env = __webpack_require__(67);

var _vector = __webpack_require__(55);

var applyTransform = _vector.applyTransform;

var BoundingRect = __webpack_require__(57);

var colorTool = __webpack_require__(122);

var textContain = __webpack_require__(93);

var textHelper = __webpack_require__(295);

var RectText = __webpack_require__(621);

var Displayable = __webpack_require__(233);

var ZImage = __webpack_require__(203);

var Text = __webpack_require__(175);

var Path = __webpack_require__(65);

var PathProxy = __webpack_require__(205);

var Gradient = __webpack_require__(296);

var vmlCore = __webpack_require__(697);

// http://www.w3.org/TR/NOTE-VML
// TODO Use proxy like svg instead of overwrite brush methods
var CMD = PathProxy.CMD;
var round = Math.round;
var sqrt = Math.sqrt;
var abs = Math.abs;
var cos = Math.cos;
var sin = Math.sin;
var mathMax = Math.max;

if (!env.canvasSupported) {
  var comma = ',';
  var imageTransformPrefix = 'progid:DXImageTransform.Microsoft';
  var Z = 21600;
  var Z2 = Z / 2;
  var ZLEVEL_BASE = 100000;
  var Z_BASE = 1000;

  var initRootElStyle = function (el) {
    el.style.cssText = 'position:absolute;left:0;top:0;width:1px;height:1px;';
    el.coordsize = Z + ',' + Z;
    el.coordorigin = '0,0';
  };

  var encodeHtmlAttribute = function (s) {
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
  };

  var rgb2Str = function (r, g, b) {
    return 'rgb(' + [r, g, b].join(',') + ')';
  };

  var append = function (parent, child) {
    if (child && parent && child.parentNode !== parent) {
      parent.appendChild(child);
    }
  };

  var remove = function (parent, child) {
    if (child && parent && child.parentNode === parent) {
      parent.removeChild(child);
    }
  };

  var getZIndex = function (zlevel, z, z2) {
    // z 的取值范围为 [0, 1000]
    return (parseFloat(zlevel) || 0) * ZLEVEL_BASE + (parseFloat(z) || 0) * Z_BASE + z2;
  };

  var parsePercent = textHelper.parsePercent;
  /***************************************************
   * PATH
   **************************************************/

  var setColorAndOpacity = function (el, color, opacity) {
    var colorArr = colorTool.parse(color);
    opacity = +opacity;

    if (isNaN(opacity)) {
      opacity = 1;
    }

    if (colorArr) {
      el.color = rgb2Str(colorArr[0], colorArr[1], colorArr[2]);
      el.opacity = opacity * colorArr[3];
    }
  };

  var getColorAndAlpha = function (color) {
    var colorArr = colorTool.parse(color);
    return [rgb2Str(colorArr[0], colorArr[1], colorArr[2]), colorArr[3]];
  };

  var updateFillNode = function (el, style, zrEl) {
    // TODO pattern
    var fill = style.fill;

    if (fill != null) {
      // Modified from excanvas
      if (fill instanceof Gradient) {
        var gradientType;
        var angle = 0;
        var focus = [0, 0]; // additional offset

        var shift = 0; // scale factor for offset

        var expansion = 1;
        var rect = zrEl.getBoundingRect();
        var rectWidth = rect.width;
        var rectHeight = rect.height;

        if (fill.type === 'linear') {
          gradientType = 'gradient';
          var transform = zrEl.transform;
          var p0 = [fill.x * rectWidth, fill.y * rectHeight];
          var p1 = [fill.x2 * rectWidth, fill.y2 * rectHeight];

          if (transform) {
            applyTransform(p0, p0, transform);
            applyTransform(p1, p1, transform);
          }

          var dx = p1[0] - p0[0];
          var dy = p1[1] - p0[1];
          angle = Math.atan2(dx, dy) * 180 / Math.PI; // The angle should be a non-negative number.

          if (angle < 0) {
            angle += 360;
          } // Very small angles produce an unexpected result because they are
          // converted to a scientific notation string.


          if (angle < 1e-6) {
            angle = 0;
          }
        } else {
          gradientType = 'gradientradial';
          var p0 = [fill.x * rectWidth, fill.y * rectHeight];
          var transform = zrEl.transform;
          var scale = zrEl.scale;
          var width = rectWidth;
          var height = rectHeight;
          focus = [// Percent in bounding rect
          (p0[0] - rect.x) / width, (p0[1] - rect.y) / height];

          if (transform) {
            applyTransform(p0, p0, transform);
          }

          width /= scale[0] * Z;
          height /= scale[1] * Z;
          var dimension = mathMax(width, height);
          shift = 2 * 0 / dimension;
          expansion = 2 * fill.r / dimension - shift;
        } // We need to sort the color stops in ascending order by offset,
        // otherwise IE won't interpret it correctly.


        var stops = fill.colorStops.slice();
        stops.sort(function (cs1, cs2) {
          return cs1.offset - cs2.offset;
        });
        var length = stops.length; // Color and alpha list of first and last stop

        var colorAndAlphaList = [];
        var colors = [];

        for (var i = 0; i < length; i++) {
          var stop = stops[i];
          var colorAndAlpha = getColorAndAlpha(stop.color);
          colors.push(stop.offset * expansion + shift + ' ' + colorAndAlpha[0]);

          if (i === 0 || i === length - 1) {
            colorAndAlphaList.push(colorAndAlpha);
          }
        }

        if (length >= 2) {
          var color1 = colorAndAlphaList[0][0];
          var color2 = colorAndAlphaList[1][0];
          var opacity1 = colorAndAlphaList[0][1] * style.opacity;
          var opacity2 = colorAndAlphaList[1][1] * style.opacity;
          el.type = gradientType;
          el.method = 'none';
          el.focus = '100%';
          el.angle = angle;
          el.color = color1;
          el.color2 = color2;
          el.colors = colors.join(','); // When colors attribute is used, the meanings of opacity and o:opacity2
          // are reversed.

          el.opacity = opacity2; // FIXME g_o_:opacity ?

          el.opacity2 = opacity1;
        }

        if (gradientType === 'radial') {
          el.focusposition = focus.join(',');
        }
      } else {
        // FIXME Change from Gradient fill to color fill
        setColorAndOpacity(el, fill, style.opacity);
      }
    }
  };

  var updateStrokeNode = function (el, style) {
    // if (style.lineJoin != null) {
    //     el.joinstyle = style.lineJoin;
    // }
    // if (style.miterLimit != null) {
    //     el.miterlimit = style.miterLimit * Z;
    // }
    // if (style.lineCap != null) {
    //     el.endcap = style.lineCap;
    // }
    if (style.lineDash) {
      el.dashstyle = style.lineDash.join(' ');
    }

    if (style.stroke != null && !(style.stroke instanceof Gradient)) {
      setColorAndOpacity(el, style.stroke, style.opacity);
    }
  };

  var updateFillAndStroke = function (vmlEl, type, style, zrEl) {
    var isFill = type === 'fill';
    var el = vmlEl.getElementsByTagName(type)[0]; // Stroke must have lineWidth

    if (style[type] != null && style[type] !== 'none' && (isFill || !isFill && style.lineWidth)) {
      vmlEl[isFill ? 'filled' : 'stroked'] = 'true'; // FIXME Remove before updating, or set `colors` will throw error

      if (style[type] instanceof Gradient) {
        remove(vmlEl, el);
      }

      if (!el) {
        el = vmlCore.createNode(type);
      }

      isFill ? updateFillNode(el, style, zrEl) : updateStrokeNode(el, style);
      append(vmlEl, el);
    } else {
      vmlEl[isFill ? 'filled' : 'stroked'] = 'false';
      remove(vmlEl, el);
    }
  };

  var points = [[], [], []];

  var pathDataToString = function (path, m) {
    var M = CMD.M;
    var C = CMD.C;
    var L = CMD.L;
    var A = CMD.A;
    var Q = CMD.Q;
    var str = [];
    var nPoint;
    var cmdStr;
    var cmd;
    var i;
    var xi;
    var yi;
    var data = path.data;
    var dataLength = path.len();

    for (i = 0; i < dataLength;) {
      cmd = data[i++];
      cmdStr = '';
      nPoint = 0;

      switch (cmd) {
        case M:
          cmdStr = ' m ';
          nPoint = 1;
          xi = data[i++];
          yi = data[i++];
          points[0][0] = xi;
          points[0][1] = yi;
          break;

        case L:
          cmdStr = ' l ';
          nPoint = 1;
          xi = data[i++];
          yi = data[i++];
          points[0][0] = xi;
          points[0][1] = yi;
          break;

        case Q:
        case C:
          cmdStr = ' c ';
          nPoint = 3;
          var x1 = data[i++];
          var y1 = data[i++];
          var x2 = data[i++];
          var y2 = data[i++];
          var x3;
          var y3;

          if (cmd === Q) {
            // Convert quadratic to cubic using degree elevation
            x3 = x2;
            y3 = y2;
            x2 = (x2 + 2 * x1) / 3;
            y2 = (y2 + 2 * y1) / 3;
            x1 = (xi + 2 * x1) / 3;
            y1 = (yi + 2 * y1) / 3;
          } else {
            x3 = data[i++];
            y3 = data[i++];
          }

          points[0][0] = x1;
          points[0][1] = y1;
          points[1][0] = x2;
          points[1][1] = y2;
          points[2][0] = x3;
          points[2][1] = y3;
          xi = x3;
          yi = y3;
          break;

        case A:
          var x = 0;
          var y = 0;
          var sx = 1;
          var sy = 1;
          var angle = 0;

          if (m) {
            // Extract SRT from matrix
            x = m[4];
            y = m[5];
            sx = sqrt(m[0] * m[0] + m[1] * m[1]);
            sy = sqrt(m[2] * m[2] + m[3] * m[3]);
            angle = Math.atan2(-m[1] / sy, m[0] / sx);
          }

          var cx = data[i++];
          var cy = data[i++];
          var rx = data[i++];
          var ry = data[i++];
          var startAngle = data[i++] + angle;
          var endAngle = data[i++] + startAngle + angle; // FIXME
          // var psi = data[i++];

          i++;
          var clockwise = data[i++];
          var x0 = cx + cos(startAngle) * rx;
          var y0 = cy + sin(startAngle) * ry;
          var x1 = cx + cos(endAngle) * rx;
          var y1 = cy + sin(endAngle) * ry;
          var type = clockwise ? ' wa ' : ' at ';

          if (Math.abs(x0 - x1) < 1e-4) {
            // IE won't render arches drawn counter clockwise if x0 == x1.
            if (Math.abs(endAngle - startAngle) > 1e-2) {
              // Offset x0 by 1/80 of a pixel. Use something
              // that can be represented in binary
              if (clockwise) {
                x0 += 270 / Z;
              }
            } else {
              // Avoid case draw full circle
              if (Math.abs(y0 - cy) < 1e-4) {
                if (clockwise && x0 < cx || !clockwise && x0 > cx) {
                  y1 -= 270 / Z;
                } else {
                  y1 += 270 / Z;
                }
              } else if (clockwise && y0 < cy || !clockwise && y0 > cy) {
                x1 += 270 / Z;
              } else {
                x1 -= 270 / Z;
              }
            }
          }

          str.push(type, round(((cx - rx) * sx + x) * Z - Z2), comma, round(((cy - ry) * sy + y) * Z - Z2), comma, round(((cx + rx) * sx + x) * Z - Z2), comma, round(((cy + ry) * sy + y) * Z - Z2), comma, round((x0 * sx + x) * Z - Z2), comma, round((y0 * sy + y) * Z - Z2), comma, round((x1 * sx + x) * Z - Z2), comma, round((y1 * sy + y) * Z - Z2));
          xi = x1;
          yi = y1;
          break;

        case CMD.R:
          var p0 = points[0];
          var p1 = points[1]; // x0, y0

          p0[0] = data[i++];
          p0[1] = data[i++]; // x1, y1

          p1[0] = p0[0] + data[i++];
          p1[1] = p0[1] + data[i++];

          if (m) {
            applyTransform(p0, p0, m);
            applyTransform(p1, p1, m);
          }

          p0[0] = round(p0[0] * Z - Z2);
          p1[0] = round(p1[0] * Z - Z2);
          p0[1] = round(p0[1] * Z - Z2);
          p1[1] = round(p1[1] * Z - Z2);
          str.push( // x0, y0
          ' m ', p0[0], comma, p0[1], // x1, y0
          ' l ', p1[0], comma, p0[1], // x1, y1
          ' l ', p1[0], comma, p1[1], // x0, y1
          ' l ', p0[0], comma, p1[1]);
          break;

        case CMD.Z:
          // FIXME Update xi, yi
          str.push(' x ');
      }

      if (nPoint > 0) {
        str.push(cmdStr);

        for (var k = 0; k < nPoint; k++) {
          var p = points[k];
          m && applyTransform(p, p, m); // 不 round 会非常慢

          str.push(round(p[0] * Z - Z2), comma, round(p[1] * Z - Z2), k < nPoint - 1 ? comma : '');
        }
      }
    }

    return str.join('');
  }; // Rewrite the original path method


  Path.prototype.brushVML = function (vmlRoot) {
    var style = this.style;
    var vmlEl = this._vmlEl;

    if (!vmlEl) {
      vmlEl = vmlCore.createNode('shape');
      initRootElStyle(vmlEl);
      this._vmlEl = vmlEl;
    }

    updateFillAndStroke(vmlEl, 'fill', style, this);
    updateFillAndStroke(vmlEl, 'stroke', style, this);
    var m = this.transform;
    var needTransform = m != null;
    var strokeEl = vmlEl.getElementsByTagName('stroke')[0];

    if (strokeEl) {
      var lineWidth = style.lineWidth; // Get the line scale.
      // Determinant of this.m_ means how much the area is enlarged by the
      // transformation. So its square root can be used as a scale factor
      // for width.

      if (needTransform && !style.strokeNoScale) {
        var det = m[0] * m[3] - m[1] * m[2];
        lineWidth *= sqrt(abs(det));
      }

      strokeEl.weight = lineWidth + 'px';
    }

    var path = this.path || (this.path = new PathProxy());

    if (this.__dirtyPath) {
      path.beginPath();
      path.subPixelOptimize = false;
      this.buildPath(path, this.shape);
      path.toStatic();
      this.__dirtyPath = false;
    }

    vmlEl.path = pathDataToString(path, this.transform);
    vmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Append to root

    append(vmlRoot, vmlEl); // Text

    if (style.text != null) {
      this.drawRectText(vmlRoot, this.getBoundingRect());
    } else {
      this.removeRectText(vmlRoot);
    }
  };

  Path.prototype.onRemove = function (vmlRoot) {
    remove(vmlRoot, this._vmlEl);
    this.removeRectText(vmlRoot);
  };

  Path.prototype.onAdd = function (vmlRoot) {
    append(vmlRoot, this._vmlEl);
    this.appendRectText(vmlRoot);
  };
  /***************************************************
   * IMAGE
   **************************************************/


  var isImage = function (img) {
    // FIXME img instanceof Image 如果 img 是一个字符串的时候，IE8 下会报错
    return typeof img === 'object' && img.tagName && img.tagName.toUpperCase() === 'IMG'; // return img instanceof Image;
  }; // Rewrite the original path method


  ZImage.prototype.brushVML = function (vmlRoot) {
    var style = this.style;
    var image = style.image; // Image original width, height

    var ow;
    var oh;

    if (isImage(image)) {
      var src = image.src;

      if (src === this._imageSrc) {
        ow = this._imageWidth;
        oh = this._imageHeight;
      } else {
        var imageRuntimeStyle = image.runtimeStyle;
        var oldRuntimeWidth = imageRuntimeStyle.width;
        var oldRuntimeHeight = imageRuntimeStyle.height;
        imageRuntimeStyle.width = 'auto';
        imageRuntimeStyle.height = 'auto'; // get the original size

        ow = image.width;
        oh = image.height; // and remove overides

        imageRuntimeStyle.width = oldRuntimeWidth;
        imageRuntimeStyle.height = oldRuntimeHeight; // Caching image original width, height and src

        this._imageSrc = src;
        this._imageWidth = ow;
        this._imageHeight = oh;
      }

      image = src;
    } else {
      if (image === this._imageSrc) {
        ow = this._imageWidth;
        oh = this._imageHeight;
      }
    }

    if (!image) {
      return;
    }

    var x = style.x || 0;
    var y = style.y || 0;
    var dw = style.width;
    var dh = style.height;
    var sw = style.sWidth;
    var sh = style.sHeight;
    var sx = style.sx || 0;
    var sy = style.sy || 0;
    var hasCrop = sw && sh;
    var vmlEl = this._vmlEl;

    if (!vmlEl) {
      // FIXME 使用 group 在 left, top 都不是 0 的时候就无法显示了。
      // vmlEl = vmlCore.createNode('group');
      vmlEl = vmlCore.doc.createElement('div');
      initRootElStyle(vmlEl);
      this._vmlEl = vmlEl;
    }

    var vmlElStyle = vmlEl.style;
    var hasRotation = false;
    var m;
    var scaleX = 1;
    var scaleY = 1;

    if (this.transform) {
      m = this.transform;
      scaleX = sqrt(m[0] * m[0] + m[1] * m[1]);
      scaleY = sqrt(m[2] * m[2] + m[3] * m[3]);
      hasRotation = m[1] || m[2];
    }

    if (hasRotation) {
      // If filters are necessary (rotation exists), create them
      // filters are bog-slow, so only create them if abbsolutely necessary
      // The following check doesn't account for skews (which don't exist
      // in the canvas spec (yet) anyway.
      // From excanvas
      var p0 = [x, y];
      var p1 = [x + dw, y];
      var p2 = [x, y + dh];
      var p3 = [x + dw, y + dh];
      applyTransform(p0, p0, m);
      applyTransform(p1, p1, m);
      applyTransform(p2, p2, m);
      applyTransform(p3, p3, m);
      var maxX = mathMax(p0[0], p1[0], p2[0], p3[0]);
      var maxY = mathMax(p0[1], p1[1], p2[1], p3[1]);
      var transformFilter = [];
      transformFilter.push('M11=', m[0] / scaleX, comma, 'M12=', m[2] / scaleY, comma, 'M21=', m[1] / scaleX, comma, 'M22=', m[3] / scaleY, comma, 'Dx=', round(x * scaleX + m[4]), comma, 'Dy=', round(y * scaleY + m[5]));
      vmlElStyle.padding = '0 ' + round(maxX) + 'px ' + round(maxY) + 'px 0'; // FIXME DXImageTransform 在 IE11 的兼容模式下不起作用

      vmlElStyle.filter = imageTransformPrefix + '.Matrix(' + transformFilter.join('') + ', SizingMethod=clip)';
    } else {
      if (m) {
        x = x * scaleX + m[4];
        y = y * scaleY + m[5];
      }

      vmlElStyle.filter = '';
      vmlElStyle.left = round(x) + 'px';
      vmlElStyle.top = round(y) + 'px';
    }

    var imageEl = this._imageEl;
    var cropEl = this._cropEl;

    if (!imageEl) {
      imageEl = vmlCore.doc.createElement('div');
      this._imageEl = imageEl;
    }

    var imageELStyle = imageEl.style;

    if (hasCrop) {
      // Needs know image original width and height
      if (!(ow && oh)) {
        var tmpImage = new Image();
        var self = this;

        tmpImage.onload = function () {
          tmpImage.onload = null;
          ow = tmpImage.width;
          oh = tmpImage.height; // Adjust image width and height to fit the ratio destinationSize / sourceSize

          imageELStyle.width = round(scaleX * ow * dw / sw) + 'px';
          imageELStyle.height = round(scaleY * oh * dh / sh) + 'px'; // Caching image original width, height and src

          self._imageWidth = ow;
          self._imageHeight = oh;
          self._imageSrc = image;
        };

        tmpImage.src = image;
      } else {
        imageELStyle.width = round(scaleX * ow * dw / sw) + 'px';
        imageELStyle.height = round(scaleY * oh * dh / sh) + 'px';
      }

      if (!cropEl) {
        cropEl = vmlCore.doc.createElement('div');
        cropEl.style.overflow = 'hidden';
        this._cropEl = cropEl;
      }

      var cropElStyle = cropEl.style;
      cropElStyle.width = round((dw + sx * dw / sw) * scaleX);
      cropElStyle.height = round((dh + sy * dh / sh) * scaleY);
      cropElStyle.filter = imageTransformPrefix + '.Matrix(Dx=' + -sx * dw / sw * scaleX + ',Dy=' + -sy * dh / sh * scaleY + ')';

      if (!cropEl.parentNode) {
        vmlEl.appendChild(cropEl);
      }

      if (imageEl.parentNode !== cropEl) {
        cropEl.appendChild(imageEl);
      }
    } else {
      imageELStyle.width = round(scaleX * dw) + 'px';
      imageELStyle.height = round(scaleY * dh) + 'px';
      vmlEl.appendChild(imageEl);

      if (cropEl && cropEl.parentNode) {
        vmlEl.removeChild(cropEl);
        this._cropEl = null;
      }
    }

    var filterStr = '';
    var alpha = style.opacity;

    if (alpha < 1) {
      filterStr += '.Alpha(opacity=' + round(alpha * 100) + ') ';
    }

    filterStr += imageTransformPrefix + '.AlphaImageLoader(src=' + image + ', SizingMethod=scale)';
    imageELStyle.filter = filterStr;
    vmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Append to root

    append(vmlRoot, vmlEl); // Text

    if (style.text != null) {
      this.drawRectText(vmlRoot, this.getBoundingRect());
    }
  };

  ZImage.prototype.onRemove = function (vmlRoot) {
    remove(vmlRoot, this._vmlEl);
    this._vmlEl = null;
    this._cropEl = null;
    this._imageEl = null;
    this.removeRectText(vmlRoot);
  };

  ZImage.prototype.onAdd = function (vmlRoot) {
    append(vmlRoot, this._vmlEl);
    this.appendRectText(vmlRoot);
  };
  /***************************************************
   * TEXT
   **************************************************/


  var DEFAULT_STYLE_NORMAL = 'normal';
  var fontStyleCache = {};
  var fontStyleCacheCount = 0;
  var MAX_FONT_CACHE_SIZE = 100;
  var fontEl = document.createElement('div');

  var getFontStyle = function (fontString) {
    var fontStyle = fontStyleCache[fontString];

    if (!fontStyle) {
      // Clear cache
      if (fontStyleCacheCount > MAX_FONT_CACHE_SIZE) {
        fontStyleCacheCount = 0;
        fontStyleCache = {};
      }

      var style = fontEl.style;
      var fontFamily;

      try {
        style.font = fontString;
        fontFamily = style.fontFamily.split(',')[0];
      } catch (e) {}

      fontStyle = {
        style: style.fontStyle || DEFAULT_STYLE_NORMAL,
        variant: style.fontVariant || DEFAULT_STYLE_NORMAL,
        weight: style.fontWeight || DEFAULT_STYLE_NORMAL,
        size: parseFloat(style.fontSize || 12) | 0,
        family: fontFamily || 'Microsoft YaHei'
      };
      fontStyleCache[fontString] = fontStyle;
      fontStyleCacheCount++;
    }

    return fontStyle;
  };

  var textMeasureEl; // Overwrite measure text method

  textContain.$override('measureText', function (text, textFont) {
    var doc = vmlCore.doc;

    if (!textMeasureEl) {
      textMeasureEl = doc.createElement('div');
      textMeasureEl.style.cssText = 'position:absolute;top:-20000px;left:0;' + 'padding:0;margin:0;border:none;white-space:pre;';
      vmlCore.doc.body.appendChild(textMeasureEl);
    }

    try {
      textMeasureEl.style.font = textFont;
    } catch (ex) {// Ignore failures to set to invalid font.
    }

    textMeasureEl.innerHTML = ''; // Don't use innerHTML or innerText because they allow markup/whitespace.

    textMeasureEl.appendChild(doc.createTextNode(text));
    return {
      width: textMeasureEl.offsetWidth
    };
  });
  var tmpRect = new BoundingRect();

  var drawRectText = function (vmlRoot, rect, textRect, fromTextEl) {
    var style = this.style; // Optimize, avoid normalize every time.

    this.__dirty && textHelper.normalizeTextStyle(style, true);
    var text = style.text; // Convert to string

    text != null && (text += '');

    if (!text) {
      return;
    } // Convert rich text to plain text. Rich text is not supported in
    // IE8-, but tags in rich text template will be removed.


    if (style.rich) {
      var contentBlock = textContain.parseRichText(text, style);
      text = [];

      for (var i = 0; i < contentBlock.lines.length; i++) {
        var tokens = contentBlock.lines[i].tokens;
        var textLine = [];

        for (var j = 0; j < tokens.length; j++) {
          textLine.push(tokens[j].text);
        }

        text.push(textLine.join(''));
      }

      text = text.join('\n');
    }

    var x;
    var y;
    var align = style.textAlign;
    var verticalAlign = style.textVerticalAlign;
    var fontStyle = getFontStyle(style.font); // FIXME encodeHtmlAttribute ?

    var font = fontStyle.style + ' ' + fontStyle.variant + ' ' + fontStyle.weight + ' ' + fontStyle.size + 'px "' + fontStyle.family + '"';
    textRect = textRect || textContain.getBoundingRect(text, font, align, verticalAlign, style.textPadding, style.textLineHeight); // Transform rect to view space

    var m = this.transform; // Ignore transform for text in other element

    if (m && !fromTextEl) {
      tmpRect.copy(rect);
      tmpRect.applyTransform(m);
      rect = tmpRect;
    }

    if (!fromTextEl) {
      var textPosition = style.textPosition; // Text position represented by coord

      if (textPosition instanceof Array) {
        x = rect.x + parsePercent(textPosition[0], rect.width);
        y = rect.y + parsePercent(textPosition[1], rect.height);
        align = align || 'left';
      } else {
        var res = this.calculateTextPosition ? this.calculateTextPosition({}, style, rect) : textContain.calculateTextPosition({}, style, rect);
        x = res.x;
        y = res.y; // Default align and baseline when has textPosition

        align = align || res.textAlign;
        verticalAlign = verticalAlign || res.textVerticalAlign;
      }
    } else {
      x = rect.x;
      y = rect.y;
    }

    x = textContain.adjustTextX(x, textRect.width, align);
    y = textContain.adjustTextY(y, textRect.height, verticalAlign); // Force baseline 'middle'

    y += textRect.height / 2; // var fontSize = fontStyle.size;
    // 1.75 is an arbitrary number, as there is no info about the text baseline
    // switch (baseline) {
    // case 'hanging':
    // case 'top':
    //     y += fontSize / 1.75;
    //     break;
    //     case 'middle':
    //         break;
    //     default:
    //     // case null:
    //     // case 'alphabetic':
    //     // case 'ideographic':
    //     // case 'bottom':
    //         y -= fontSize / 2.25;
    //         break;
    // }
    // switch (align) {
    //     case 'left':
    //         break;
    //     case 'center':
    //         x -= textRect.width / 2;
    //         break;
    //     case 'right':
    //         x -= textRect.width;
    //         break;
    // case 'end':
    // align = elementStyle.direction == 'ltr' ? 'right' : 'left';
    // break;
    // case 'start':
    // align = elementStyle.direction == 'rtl' ? 'right' : 'left';
    // break;
    // default:
    //     align = 'left';
    // }

    var createNode = vmlCore.createNode;
    var textVmlEl = this._textVmlEl;
    var pathEl;
    var textPathEl;
    var skewEl;

    if (!textVmlEl) {
      textVmlEl = createNode('line');
      pathEl = createNode('path');
      textPathEl = createNode('textpath');
      skewEl = createNode('skew'); // FIXME Why here is not cammel case
      // Align 'center' seems wrong

      textPathEl.style['v-text-align'] = 'left';
      initRootElStyle(textVmlEl);
      pathEl.textpathok = true;
      textPathEl.on = true;
      textVmlEl.from = '0 0';
      textVmlEl.to = '1000 0.05';
      append(textVmlEl, skewEl);
      append(textVmlEl, pathEl);
      append(textVmlEl, textPathEl);
      this._textVmlEl = textVmlEl;
    } else {
      // 这里是在前面 appendChild 保证顺序的前提下
      skewEl = textVmlEl.firstChild;
      pathEl = skewEl.nextSibling;
      textPathEl = pathEl.nextSibling;
    }

    var coords = [x, y];
    var textVmlElStyle = textVmlEl.style; // Ignore transform for text in other element

    if (m && fromTextEl) {
      applyTransform(coords, coords, m);
      skewEl.on = true;
      skewEl.matrix = m[0].toFixed(3) + comma + m[2].toFixed(3) + comma + m[1].toFixed(3) + comma + m[3].toFixed(3) + ',0,0'; // Text position

      skewEl.offset = (round(coords[0]) || 0) + ',' + (round(coords[1]) || 0); // Left top point as origin

      skewEl.origin = '0 0';
      textVmlElStyle.left = '0px';
      textVmlElStyle.top = '0px';
    } else {
      skewEl.on = false;
      textVmlElStyle.left = round(x) + 'px';
      textVmlElStyle.top = round(y) + 'px';
    }

    textPathEl.string = encodeHtmlAttribute(text); // TODO

    try {
      textPathEl.style.font = font;
    } // Error font format
    catch (e) {}

    updateFillAndStroke(textVmlEl, 'fill', {
      fill: style.textFill,
      opacity: style.opacity
    }, this);
    updateFillAndStroke(textVmlEl, 'stroke', {
      stroke: style.textStroke,
      opacity: style.opacity,
      lineDash: style.lineDash || null // style.lineDash can be `false`.

    }, this);
    textVmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Attached to root

    append(vmlRoot, textVmlEl);
  };

  var removeRectText = function (vmlRoot) {
    remove(vmlRoot, this._textVmlEl);
    this._textVmlEl = null;
  };

  var appendRectText = function (vmlRoot) {
    append(vmlRoot, this._textVmlEl);
  };

  var list = [RectText, Displayable, ZImage, Path, Text]; // In case Displayable has been mixed in RectText

  for (var i = 0; i < list.length; i++) {
    var proto = list[i].prototype;
    proto.drawRectText = drawRectText;
    proto.removeRectText = removeRectText;
    proto.appendRectText = appendRectText;
  }

  Text.prototype.brushVML = function (vmlRoot) {
    var style = this.style;

    if (style.text != null) {
      this.drawRectText(vmlRoot, {
        x: style.x || 0,
        y: style.y || 0,
        width: 0,
        height: 0
      }, this.getBoundingRect(), true);
    } else {
      this.removeRectText(vmlRoot);
    }
  };

  Text.prototype.onRemove = function (vmlRoot) {
    this.removeRectText(vmlRoot);
  };

  Text.prototype.onAdd = function (vmlRoot) {
    this.appendRectText(vmlRoot);
  };
}

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

var logError = __webpack_require__(232);

var vmlCore = __webpack_require__(697);

var _util = __webpack_require__(1);

var each = _util.each;

/**
 * VML Painter.
 *
 * @module zrender/vml/Painter
 */
function parseInt10(val) {
  return parseInt(val, 10);
}
/**
 * @alias module:zrender/vml/Painter
 */


function VMLPainter(root, storage) {
  vmlCore.initVML();
  this.root = root;
  this.storage = storage;
  var vmlViewport = document.createElement('div');
  var vmlRoot = document.createElement('div');
  vmlViewport.style.cssText = 'display:inline-block;overflow:hidden;position:relative;width:300px;height:150px;';
  vmlRoot.style.cssText = 'position:absolute;left:0;top:0;';
  root.appendChild(vmlViewport);
  this._vmlRoot = vmlRoot;
  this._vmlViewport = vmlViewport;
  this.resize(); // Modify storage

  var oldDelFromStorage = storage.delFromStorage;
  var oldAddToStorage = storage.addToStorage;

  storage.delFromStorage = function (el) {
    oldDelFromStorage.call(storage, el);

    if (el) {
      el.onRemove && el.onRemove(vmlRoot);
    }
  };

  storage.addToStorage = function (el) {
    // Displayable already has a vml node
    el.onAdd && el.onAdd(vmlRoot);
    oldAddToStorage.call(storage, el);
  };

  this._firstPaint = true;
}

VMLPainter.prototype = {
  constructor: VMLPainter,
  getType: function () {
    return 'vml';
  },

  /**
   * @return {HTMLDivElement}
   */
  getViewportRoot: function () {
    return this._vmlViewport;
  },
  getViewportRootOffset: function () {
    var viewportRoot = this.getViewportRoot();

    if (viewportRoot) {
      return {
        offsetLeft: viewportRoot.offsetLeft || 0,
        offsetTop: viewportRoot.offsetTop || 0
      };
    }
  },

  /**
   * 刷新
   */
  refresh: function () {
    var list = this.storage.getDisplayList(true, true);

    this._paintList(list);
  },
  _paintList: function (list) {
    var vmlRoot = this._vmlRoot;

    for (var i = 0; i < list.length; i++) {
      var el = list[i];

      if (el.invisible || el.ignore) {
        if (!el.__alreadyNotVisible) {
          el.onRemove(vmlRoot);
        } // Set as already invisible


        el.__alreadyNotVisible = true;
      } else {
        if (el.__alreadyNotVisible) {
          el.onAdd(vmlRoot);
        }

        el.__alreadyNotVisible = false;

        if (el.__dirty) {
          el.beforeBrush && el.beforeBrush();
          (el.brushVML || el.brush).call(el, vmlRoot);
          el.afterBrush && el.afterBrush();
        }
      }

      el.__dirty = false;
    }

    if (this._firstPaint) {
      // Detached from document at first time
      // to avoid page refreshing too many times
      // FIXME 如果每次都先 removeChild 可能会导致一些填充和描边的效果改变
      this._vmlViewport.appendChild(vmlRoot);

      this._firstPaint = false;
    }
  },
  resize: function (width, height) {
    var width = width == null ? this._getWidth() : width;
    var height = height == null ? this._getHeight() : height;

    if (this._width !== width || this._height !== height) {
      this._width = width;
      this._height = height;
      var vmlViewportStyle = this._vmlViewport.style;
      vmlViewportStyle.width = width + 'px';
      vmlViewportStyle.height = height + 'px';
    }
  },
  dispose: function () {
    this.root.innerHTML = '';
    this._vmlRoot = this._vmlViewport = this.storage = null;
  },
  getWidth: function () {
    return this._width;
  },
  getHeight: function () {
    return this._height;
  },
  clear: function () {
    if (this._vmlViewport) {
      this.root.removeChild(this._vmlViewport);
    }
  },
  _getWidth: function () {
    var root = this.root;
    var stl = root.currentStyle;
    return (root.clientWidth || parseInt10(stl.width)) - parseInt10(stl.paddingLeft) - parseInt10(stl.paddingRight) | 0;
  },
  _getHeight: function () {
    var root = this.root;
    var stl = root.currentStyle;
    return (root.clientHeight || parseInt10(stl.height)) - parseInt10(stl.paddingTop) - parseInt10(stl.paddingBottom) | 0;
  }
}; // Not supported methods

function createMethodNotSupport(method) {
  return function () {
    logError('In IE8.0 VML mode painter not support method "' + method + '"');
  };
} // Unsupported methods


each(['getLayer', 'insertLayer', 'eachLayer', 'eachBuiltinLayer', 'eachOtherLayer', 'getLayers', 'modLayer', 'delLayer', 'clearLayer', 'toDataURL', 'pathToImage'], function (name) {
  VMLPainter.prototype[name] = createMethodNotSupport(name);
});
var _default = VMLPainter;
module.exports = _default;

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(435);

var _zrender = __webpack_require__(291);

var registerPainter = _zrender.registerPainter;

var Painter = __webpack_require__(1815);

registerPainter('svg', Painter);

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

var _core = __webpack_require__(436);

var createElement = _core.createElement;

var util = __webpack_require__(1);

var logError = __webpack_require__(232);

var Path = __webpack_require__(65);

var ZImage = __webpack_require__(203);

var ZText = __webpack_require__(175);

var arrayDiff = __webpack_require__(1816);

var GradientManager = __webpack_require__(1817);

var ClippathManager = __webpack_require__(1818);

var ShadowManager = __webpack_require__(1819);

var _graphic = __webpack_require__(435);

var svgPath = _graphic.path;
var svgImage = _graphic.image;
var svgText = _graphic.text;

/**
 * SVG Painter
 * @module zrender/svg/Painter
 */
function parseInt10(val) {
  return parseInt(val, 10);
}

function getSvgProxy(el) {
  if (el instanceof Path) {
    return svgPath;
  } else if (el instanceof ZImage) {
    return svgImage;
  } else if (el instanceof ZText) {
    return svgText;
  } else {
    return svgPath;
  }
}

function checkParentAvailable(parent, child) {
  return child && parent && child.parentNode !== parent;
}

function insertAfter(parent, child, prevSibling) {
  if (checkParentAvailable(parent, child) && prevSibling) {
    var nextSibling = prevSibling.nextSibling;
    nextSibling ? parent.insertBefore(child, nextSibling) : parent.appendChild(child);
  }
}

function prepend(parent, child) {
  if (checkParentAvailable(parent, child)) {
    var firstChild = parent.firstChild;
    firstChild ? parent.insertBefore(child, firstChild) : parent.appendChild(child);
  }
} // function append(parent, child) {
//     if (checkParentAvailable(parent, child)) {
//         parent.appendChild(child);
//     }
// }


function remove(parent, child) {
  if (child && parent && child.parentNode === parent) {
    parent.removeChild(child);
  }
}

function getTextSvgElement(displayable) {
  return displayable.__textSvgEl;
}

function getSvgElement(displayable) {
  return displayable.__svgEl;
}
/**
 * @alias module:zrender/svg/Painter
 * @constructor
 * @param {HTMLElement} root 绘图容器
 * @param {module:zrender/Storage} storage
 * @param {Object} opts
 */


var SVGPainter = function (root, storage, opts, zrId) {
  this.root = root;
  this.storage = storage;
  this._opts = opts = util.extend({}, opts || {});
  var svgDom = createElement('svg');
  svgDom.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  svgDom.setAttribute('version', '1.1');
  svgDom.setAttribute('baseProfile', 'full');
  svgDom.style.cssText = 'user-select:none;position:absolute;left:0;top:0;';
  var bgRoot = createElement('g');
  svgDom.appendChild(bgRoot);
  var svgRoot = createElement('g');
  svgDom.appendChild(svgRoot);
  this.gradientManager = new GradientManager(zrId, svgRoot);
  this.clipPathManager = new ClippathManager(zrId, svgRoot);
  this.shadowManager = new ShadowManager(zrId, svgRoot);
  var viewport = document.createElement('div');
  viewport.style.cssText = 'overflow:hidden;position:relative';
  this._svgDom = svgDom;
  this._svgRoot = svgRoot;
  this._backgroundRoot = bgRoot;
  this._viewport = viewport;
  root.appendChild(viewport);
  viewport.appendChild(svgDom);
  this.resize(opts.width, opts.height);
  this._visibleList = [];
};

SVGPainter.prototype = {
  constructor: SVGPainter,
  getType: function () {
    return 'svg';
  },
  getViewportRoot: function () {
    return this._viewport;
  },
  getSvgDom: function () {
    return this._svgDom;
  },
  getSvgRoot: function () {
    return this._svgRoot;
  },
  getViewportRootOffset: function () {
    var viewportRoot = this.getViewportRoot();

    if (viewportRoot) {
      return {
        offsetLeft: viewportRoot.offsetLeft || 0,
        offsetTop: viewportRoot.offsetTop || 0
      };
    }
  },
  refresh: function () {
    var list = this.storage.getDisplayList(true);

    this._paintList(list);
  },
  setBackgroundColor: function (backgroundColor) {
    // TODO gradient
    // Insert a bg rect instead of setting background to viewport.
    // Otherwise, the exported SVG don't have background.
    if (this._backgroundRoot && this._backgroundNode) {
      this._backgroundRoot.removeChild(this._backgroundNode);
    }

    var bgNode = createElement('rect');
    bgNode.setAttribute('width', this.getWidth());
    bgNode.setAttribute('height', this.getHeight());
    bgNode.setAttribute('x', 0);
    bgNode.setAttribute('y', 0);
    bgNode.setAttribute('id', 0);
    bgNode.style.fill = backgroundColor;

    this._backgroundRoot.appendChild(bgNode);

    this._backgroundNode = bgNode;
  },
  _paintList: function (list) {
    this.gradientManager.markAllUnused();
    this.clipPathManager.markAllUnused();
    this.shadowManager.markAllUnused();
    var svgRoot = this._svgRoot;
    var visibleList = this._visibleList;
    var listLen = list.length;
    var newVisibleList = [];
    var i;

    for (i = 0; i < listLen; i++) {
      var displayable = list[i];
      var svgProxy = getSvgProxy(displayable);
      var svgElement = getSvgElement(displayable) || getTextSvgElement(displayable);

      if (!displayable.invisible) {
        if (displayable.__dirty) {
          svgProxy && svgProxy.brush(displayable); // Update clipPath

          this.clipPathManager.update(displayable); // Update gradient and shadow

          if (displayable.style) {
            this.gradientManager.update(displayable.style.fill);
            this.gradientManager.update(displayable.style.stroke);
            this.shadowManager.update(svgElement, displayable);
          }

          displayable.__dirty = false;
        }

        newVisibleList.push(displayable);
      }
    }

    var diff = arrayDiff(visibleList, newVisibleList);
    var prevSvgElement; // First do remove, in case element moved to the head and do remove
    // after add

    for (i = 0; i < diff.length; i++) {
      var item = diff[i];

      if (item.removed) {
        for (var k = 0; k < item.count; k++) {
          var displayable = visibleList[item.indices[k]];
          var svgElement = getSvgElement(displayable);
          var textSvgElement = getTextSvgElement(displayable);
          remove(svgRoot, svgElement);
          remove(svgRoot, textSvgElement);
        }
      }
    }

    for (i = 0; i < diff.length; i++) {
      var item = diff[i];

      if (item.added) {
        for (var k = 0; k < item.count; k++) {
          var displayable = newVisibleList[item.indices[k]];
          var svgElement = getSvgElement(displayable);
          var textSvgElement = getTextSvgElement(displayable);
          prevSvgElement ? insertAfter(svgRoot, svgElement, prevSvgElement) : prepend(svgRoot, svgElement);

          if (svgElement) {
            insertAfter(svgRoot, textSvgElement, svgElement);
          } else if (prevSvgElement) {
            insertAfter(svgRoot, textSvgElement, prevSvgElement);
          } else {
            prepend(svgRoot, textSvgElement);
          } // Insert text


          insertAfter(svgRoot, textSvgElement, svgElement);
          prevSvgElement = textSvgElement || svgElement || prevSvgElement; // zrender.Text only create textSvgElement.

          this.gradientManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
          this.shadowManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
          this.clipPathManager.markUsed(displayable);
        }
      } else if (!item.removed) {
        for (var k = 0; k < item.count; k++) {
          var displayable = newVisibleList[item.indices[k]];
          var svgElement = getSvgElement(displayable);
          var textSvgElement = getTextSvgElement(displayable);
          var svgElement = getSvgElement(displayable);
          var textSvgElement = getTextSvgElement(displayable);
          this.gradientManager.markUsed(displayable);
          this.gradientManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
          this.shadowManager.markUsed(displayable);
          this.shadowManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
          this.clipPathManager.markUsed(displayable);

          if (textSvgElement) {
            // Insert text.
            insertAfter(svgRoot, textSvgElement, svgElement);
          }

          prevSvgElement = svgElement || textSvgElement || prevSvgElement;
        }
      }
    }

    this.gradientManager.removeUnused();
    this.clipPathManager.removeUnused();
    this.shadowManager.removeUnused();
    this._visibleList = newVisibleList;
  },
  _getDefs: function (isForceCreating) {
    var svgRoot = this._svgDom;
    var defs = svgRoot.getElementsByTagName('defs');

    if (defs.length === 0) {
      // Not exist
      if (isForceCreating) {
        var defs = svgRoot.insertBefore(createElement('defs'), // Create new tag
        svgRoot.firstChild // Insert in the front of svg
        );

        if (!defs.contains) {
          // IE doesn't support contains method
          defs.contains = function (el) {
            var children = defs.children;

            if (!children) {
              return false;
            }

            for (var i = children.length - 1; i >= 0; --i) {
              if (children[i] === el) {
                return true;
              }
            }

            return false;
          };
        }

        return defs;
      } else {
        return null;
      }
    } else {
      return defs[0];
    }
  },
  resize: function (width, height) {
    var viewport = this._viewport; // FIXME Why ?

    viewport.style.display = 'none'; // Save input w/h

    var opts = this._opts;
    width != null && (opts.width = width);
    height != null && (opts.height = height);
    width = this._getSize(0);
    height = this._getSize(1);
    viewport.style.display = '';

    if (this._width !== width || this._height !== height) {
      this._width = width;
      this._height = height;
      var viewportStyle = viewport.style;
      viewportStyle.width = width + 'px';
      viewportStyle.height = height + 'px';
      var svgRoot = this._svgDom; // Set width by 'svgRoot.width = width' is invalid

      svgRoot.setAttribute('width', width);
      svgRoot.setAttribute('height', height);
    }

    if (this._backgroundNode) {
      this._backgroundNode.setAttribute('width', width);

      this._backgroundNode.setAttribute('height', height);
    }
  },

  /**
   * 获取绘图区域宽度
   */
  getWidth: function () {
    return this._width;
  },

  /**
   * 获取绘图区域高度
   */
  getHeight: function () {
    return this._height;
  },
  _getSize: function (whIdx) {
    var opts = this._opts;
    var wh = ['width', 'height'][whIdx];
    var cwh = ['clientWidth', 'clientHeight'][whIdx];
    var plt = ['paddingLeft', 'paddingTop'][whIdx];
    var prb = ['paddingRight', 'paddingBottom'][whIdx];

    if (opts[wh] != null && opts[wh] !== 'auto') {
      return parseFloat(opts[wh]);
    }

    var root = this.root; // IE8 does not support getComputedStyle, but it use VML.

    var stl = document.defaultView.getComputedStyle(root);
    return (root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh])) - (parseInt10(stl[plt]) || 0) - (parseInt10(stl[prb]) || 0) | 0;
  },
  dispose: function () {
    this.root.innerHTML = '';
    this._svgRoot = this._backgroundRoot = this._svgDom = this._backgroundNode = this._viewport = this.storage = null;
  },
  clear: function () {
    if (this._viewport) {
      this.root.removeChild(this._viewport);
    }
  },
  toDataURL: function () {
    this.refresh();
    var html = encodeURIComponent(this._svgDom.outerHTML.replace(/></g, '>\n\r<'));
    return 'data:image/svg+xml;charset=UTF-8,' + html;
  }
}; // Not supported methods

function createMethodNotSupport(method) {
  return function () {
    logError('In SVG mode painter not support method "' + method + '"');
  };
} // Unsuppoted methods


util.each(['getLayer', 'insertLayer', 'eachLayer', 'eachBuiltinLayer', 'eachOtherLayer', 'getLayers', 'modLayer', 'delLayer', 'clearLayer', 'pathToImage'], function (name) {
  SVGPainter.prototype[name] = createMethodNotSupport(name);
});
var _default = SVGPainter;
module.exports = _default;

/***/ }),
/* 1816 */
/***/ (function(module, exports) {

// Myers' Diff Algorithm
// Modified from https://github.com/kpdecker/jsdiff/blob/master/src/diff/base.js
function Diff() {}

Diff.prototype = {
  diff: function (oldArr, newArr, equals) {
    if (!equals) {
      equals = function (a, b) {
        return a === b;
      };
    }

    this.equals = equals;
    var self = this;
    oldArr = oldArr.slice();
    newArr = newArr.slice(); // Allow subclasses to massage the input prior to running

    var newLen = newArr.length;
    var oldLen = oldArr.length;
    var editLength = 1;
    var maxEditLength = newLen + oldLen;
    var bestPath = [{
      newPos: -1,
      components: []
    }]; // Seed editLength = 0, i.e. the content starts with the same values

    var oldPos = this.extractCommon(bestPath[0], newArr, oldArr, 0);

    if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
      var indices = [];

      for (var i = 0; i < newArr.length; i++) {
        indices.push(i);
      } // Identity per the equality and tokenizer


      return [{
        indices: indices,
        count: newArr.length
      }];
    } // Main worker method. checks all permutations of a given edit length for acceptance.


    function execEditLength() {
      for (var diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2) {
        var basePath;
        var addPath = bestPath[diagonalPath - 1];
        var removePath = bestPath[diagonalPath + 1];
        var oldPos = (removePath ? removePath.newPos : 0) - diagonalPath;

        if (addPath) {
          // No one else is going to attempt to use this value, clear it
          bestPath[diagonalPath - 1] = undefined;
        }

        var canAdd = addPath && addPath.newPos + 1 < newLen;
        var canRemove = removePath && 0 <= oldPos && oldPos < oldLen;

        if (!canAdd && !canRemove) {
          // If this path is a terminal then prune
          bestPath[diagonalPath] = undefined;
          continue;
        } // Select the diagonal that we want to branch from. We select the prior
        // path whose position in the new string is the farthest from the origin
        // and does not pass the bounds of the diff graph


        if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
          basePath = clonePath(removePath);
          self.pushComponent(basePath.components, undefined, true);
        } else {
          basePath = addPath; // No need to clone, we've pulled it from the list

          basePath.newPos++;
          self.pushComponent(basePath.components, true, undefined);
        }

        oldPos = self.extractCommon(basePath, newArr, oldArr, diagonalPath); // If we have hit the end of both strings, then we are done

        if (basePath.newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
          return buildValues(self, basePath.components, newArr, oldArr);
        } else {
          // Otherwise track this path as a potential candidate and continue.
          bestPath[diagonalPath] = basePath;
        }
      }

      editLength++;
    }

    while (editLength <= maxEditLength) {
      var ret = execEditLength();

      if (ret) {
        return ret;
      }
    }
  },
  pushComponent: function (components, added, removed) {
    var last = components[components.length - 1];

    if (last && last.added === added && last.removed === removed) {
      // We need to clone here as the component clone operation is just
      // as shallow array clone
      components[components.length - 1] = {
        count: last.count + 1,
        added: added,
        removed: removed
      };
    } else {
      components.push({
        count: 1,
        added: added,
        removed: removed
      });
    }
  },
  extractCommon: function (basePath, newArr, oldArr, diagonalPath) {
    var newLen = newArr.length;
    var oldLen = oldArr.length;
    var newPos = basePath.newPos;
    var oldPos = newPos - diagonalPath;
    var commonCount = 0;

    while (newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(newArr[newPos + 1], oldArr[oldPos + 1])) {
      newPos++;
      oldPos++;
      commonCount++;
    }

    if (commonCount) {
      basePath.components.push({
        count: commonCount
      });
    }

    basePath.newPos = newPos;
    return oldPos;
  },
  tokenize: function (value) {
    return value.slice();
  },
  join: function (value) {
    return value.slice();
  }
};

function buildValues(diff, components, newArr, oldArr) {
  var componentPos = 0;
  var componentLen = components.length;
  var newPos = 0;
  var oldPos = 0;

  for (; componentPos < componentLen; componentPos++) {
    var component = components[componentPos];

    if (!component.removed) {
      var indices = [];

      for (var i = newPos; i < newPos + component.count; i++) {
        indices.push(i);
      }

      component.indices = indices;
      newPos += component.count; // Common case

      if (!component.added) {
        oldPos += component.count;
      }
    } else {
      var indices = [];

      for (var i = oldPos; i < oldPos + component.count; i++) {
        indices.push(i);
      }

      component.indices = indices;
      oldPos += component.count;
    }
  }

  return components;
}

function clonePath(path) {
  return {
    newPos: path.newPos,
    components: path.components.slice(0)
  };
}

var arrayDiff = new Diff();

function _default(oldArr, newArr, callback) {
  return arrayDiff.diff(oldArr, newArr, callback);
}

module.exports = _default;

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

var Definable = __webpack_require__(437);

var zrUtil = __webpack_require__(1);

var logError = __webpack_require__(232);

var colorTool = __webpack_require__(122);

/**
 * @file Manages SVG gradient elements.
 * @author Zhang Wenli
 */

/**
 * Manages SVG gradient elements.
 *
 * @class
 * @extends Definable
 * @param   {number}     zrId    zrender instance id
 * @param   {SVGElement} svgRoot root of SVG document
 */
function GradientManager(zrId, svgRoot) {
  Definable.call(this, zrId, svgRoot, ['linearGradient', 'radialGradient'], '__gradient_in_use__');
}

zrUtil.inherits(GradientManager, Definable);
/**
 * Create new gradient DOM for fill or stroke if not exist,
 * but will not update gradient if exists.
 *
 * @param {SvgElement}  svgElement   SVG element to paint
 * @param {Displayable} displayable  zrender displayable element
 */

GradientManager.prototype.addWithoutUpdate = function (svgElement, displayable) {
  if (displayable && displayable.style) {
    var that = this;
    zrUtil.each(['fill', 'stroke'], function (fillOrStroke) {
      if (displayable.style[fillOrStroke] && (displayable.style[fillOrStroke].type === 'linear' || displayable.style[fillOrStroke].type === 'radial')) {
        var gradient = displayable.style[fillOrStroke];
        var defs = that.getDefs(true); // Create dom in <defs> if not exists

        var dom;

        if (gradient._dom) {
          // Gradient exists
          dom = gradient._dom;

          if (!defs.contains(gradient._dom)) {
            // _dom is no longer in defs, recreate
            that.addDom(dom);
          }
        } else {
          // New dom
          dom = that.add(gradient);
        }

        that.markUsed(displayable);
        var id = dom.getAttribute('id');
        svgElement.setAttribute(fillOrStroke, 'url(#' + id + ')');
      }
    });
  }
};
/**
 * Add a new gradient tag in <defs>
 *
 * @param   {Gradient} gradient zr gradient instance
 * @return {SVGLinearGradientElement | SVGRadialGradientElement}
 *                            created DOM
 */


GradientManager.prototype.add = function (gradient) {
  var dom;

  if (gradient.type === 'linear') {
    dom = this.createElement('linearGradient');
  } else if (gradient.type === 'radial') {
    dom = this.createElement('radialGradient');
  } else {
    logError('Illegal gradient type.');
    return null;
  } // Set dom id with gradient id, since each gradient instance
  // will have no more than one dom element.
  // id may exists before for those dirty elements, in which case
  // id should remain the same, and other attributes should be
  // updated.


  gradient.id = gradient.id || this.nextId++;
  dom.setAttribute('id', 'zr' + this._zrId + '-gradient-' + gradient.id);
  this.updateDom(gradient, dom);
  this.addDom(dom);
  return dom;
};
/**
 * Update gradient.
 *
 * @param {Gradient} gradient zr gradient instance
 */


GradientManager.prototype.update = function (gradient) {
  var that = this;
  Definable.prototype.update.call(this, gradient, function () {
    var type = gradient.type;
    var tagName = gradient._dom.tagName;

    if (type === 'linear' && tagName === 'linearGradient' || type === 'radial' && tagName === 'radialGradient') {
      // Gradient type is not changed, update gradient
      that.updateDom(gradient, gradient._dom);
    } else {
      // Remove and re-create if type is changed
      that.removeDom(gradient);
      that.add(gradient);
    }
  });
};
/**
 * Update gradient dom
 *
 * @param {Gradient} gradient zr gradient instance
 * @param {SVGLinearGradientElement | SVGRadialGradientElement} dom
 *                            DOM to update
 */


GradientManager.prototype.updateDom = function (gradient, dom) {
  if (gradient.type === 'linear') {
    dom.setAttribute('x1', gradient.x);
    dom.setAttribute('y1', gradient.y);
    dom.setAttribute('x2', gradient.x2);
    dom.setAttribute('y2', gradient.y2);
  } else if (gradient.type === 'radial') {
    dom.setAttribute('cx', gradient.x);
    dom.setAttribute('cy', gradient.y);
    dom.setAttribute('r', gradient.r);
  } else {
    logError('Illegal gradient type.');
    return;
  }

  if (gradient.global) {
    // x1, x2, y1, y2 in range of 0 to canvas width or height
    dom.setAttribute('gradientUnits', 'userSpaceOnUse');
  } else {
    // x1, x2, y1, y2 in range of 0 to 1
    dom.setAttribute('gradientUnits', 'objectBoundingBox');
  } // Remove color stops if exists


  dom.innerHTML = ''; // Add color stops

  var colors = gradient.colorStops;

  for (var i = 0, len = colors.length; i < len; ++i) {
    var stop = this.createElement('stop');
    stop.setAttribute('offset', colors[i].offset * 100 + '%');
    var color = colors[i].color;

    if (color.indexOf('rgba') > -1) {
      // Fix Safari bug that stop-color not recognizing alpha #9014
      var opacity = colorTool.parse(color)[3];
      var hex = colorTool.toHex(color); // stop-color cannot be color, since:
      // The opacity value used for the gradient calculation is the
      // *product* of the value of stop-opacity and the opacity of the
      // value of stop-color.
      // See https://www.w3.org/TR/SVG2/pservers.html#StopOpacityProperty

      stop.setAttribute('stop-color', '#' + hex);
      stop.setAttribute('stop-opacity', opacity);
    } else {
      stop.setAttribute('stop-color', colors[i].color);
    }

    dom.appendChild(stop);
  } // Store dom element in gradient, to avoid creating multiple
  // dom instances for the same gradient element


  gradient._dom = dom;
};
/**
 * Mark a single gradient to be used
 *
 * @param {Displayable} displayable displayable element
 */


GradientManager.prototype.markUsed = function (displayable) {
  if (displayable.style) {
    var gradient = displayable.style.fill;

    if (gradient && gradient._dom) {
      Definable.prototype.markUsed.call(this, gradient._dom);
    }

    gradient = displayable.style.stroke;

    if (gradient && gradient._dom) {
      Definable.prototype.markUsed.call(this, gradient._dom);
    }
  }
};

var _default = GradientManager;
module.exports = _default;

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

var Definable = __webpack_require__(437);

var zrUtil = __webpack_require__(1);

var matrix = __webpack_require__(82);

/**
 * @file Manages SVG clipPath elements.
 * @author Zhang Wenli
 */

/**
 * Manages SVG clipPath elements.
 *
 * @class
 * @extends Definable
 * @param   {number}     zrId    zrender instance id
 * @param   {SVGElement} svgRoot root of SVG document
 */
function ClippathManager(zrId, svgRoot) {
  Definable.call(this, zrId, svgRoot, 'clipPath', '__clippath_in_use__');
}

zrUtil.inherits(ClippathManager, Definable);
/**
 * Update clipPath.
 *
 * @param {Displayable} displayable displayable element
 */

ClippathManager.prototype.update = function (displayable) {
  var svgEl = this.getSvgElement(displayable);

  if (svgEl) {
    this.updateDom(svgEl, displayable.__clipPaths, false);
  }

  var textEl = this.getTextSvgElement(displayable);

  if (textEl) {
    // Make another clipPath for text, since it's transform
    // matrix is not the same with svgElement
    this.updateDom(textEl, displayable.__clipPaths, true);
  }

  this.markUsed(displayable);
};
/**
 * Create an SVGElement of displayable and create a <clipPath> of its
 * clipPath
 *
 * @param {Displayable} parentEl  parent element
 * @param {ClipPath[]}  clipPaths clipPaths of parent element
 * @param {boolean}     isText    if parent element is Text
 */


ClippathManager.prototype.updateDom = function (parentEl, clipPaths, isText) {
  if (clipPaths && clipPaths.length > 0) {
    // Has clipPath, create <clipPath> with the first clipPath
    var defs = this.getDefs(true);
    var clipPath = clipPaths[0];
    var clipPathEl;
    var id;
    var dom = isText ? '_textDom' : '_dom';

    if (clipPath[dom]) {
      // Use a dom that is already in <defs>
      id = clipPath[dom].getAttribute('id');
      clipPathEl = clipPath[dom]; // Use a dom that is already in <defs>

      if (!defs.contains(clipPathEl)) {
        // This happens when set old clipPath that has
        // been previously removed
        defs.appendChild(clipPathEl);
      }
    } else {
      // New <clipPath>
      id = 'zr' + this._zrId + '-clip-' + this.nextId;
      ++this.nextId;
      clipPathEl = this.createElement('clipPath');
      clipPathEl.setAttribute('id', id);
      defs.appendChild(clipPathEl);
      clipPath[dom] = clipPathEl;
    } // Build path and add to <clipPath>


    var svgProxy = this.getSvgProxy(clipPath);

    if (clipPath.transform && clipPath.parent.invTransform && !isText) {
      /**
       * If a clipPath has a parent with transform, the transform
       * of parent should not be considered when setting transform
       * of clipPath. So we need to transform back from parent's
       * transform, which is done by multiplying parent's inverse
       * transform.
       */
      // Store old transform
      var transform = Array.prototype.slice.call(clipPath.transform); // Transform back from parent, and brush path

      matrix.mul(clipPath.transform, clipPath.parent.invTransform, clipPath.transform);
      svgProxy.brush(clipPath); // Set back transform of clipPath

      clipPath.transform = transform;
    } else {
      svgProxy.brush(clipPath);
    }

    var pathEl = this.getSvgElement(clipPath);
    clipPathEl.innerHTML = '';
    /**
     * Use `cloneNode()` here to appendChild to multiple parents,
     * which may happend when Text and other shapes are using the same
     * clipPath. Since Text will create an extra clipPath DOM due to
     * different transform rules.
     */

    clipPathEl.appendChild(pathEl.cloneNode());
    parentEl.setAttribute('clip-path', 'url(#' + id + ')');

    if (clipPaths.length > 1) {
      // Make the other clipPaths recursively
      this.updateDom(clipPathEl, clipPaths.slice(1), isText);
    }
  } else {
    // No clipPath
    if (parentEl) {
      parentEl.setAttribute('clip-path', 'none');
    }
  }
};
/**
 * Mark a single clipPath to be used
 *
 * @param {Displayable} displayable displayable element
 */


ClippathManager.prototype.markUsed = function (displayable) {
  var that = this; // displayable.__clipPaths can only be `null`/`undefined` or an non-empty array.

  if (displayable.__clipPaths) {
    zrUtil.each(displayable.__clipPaths, function (clipPath) {
      if (clipPath._dom) {
        Definable.prototype.markUsed.call(that, clipPath._dom);
      }

      if (clipPath._textDom) {
        Definable.prototype.markUsed.call(that, clipPath._textDom);
      }
    });
  }
};

var _default = ClippathManager;
module.exports = _default;

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

var Definable = __webpack_require__(437);

var zrUtil = __webpack_require__(1);

/**
 * @file Manages SVG shadow elements.
 * @author Zhang Wenli
 */

/**
 * Manages SVG shadow elements.
 *
 * @class
 * @extends Definable
 * @param   {number}     zrId    zrender instance id
 * @param   {SVGElement} svgRoot root of SVG document
 */
function ShadowManager(zrId, svgRoot) {
  Definable.call(this, zrId, svgRoot, ['filter'], '__filter_in_use__', '_shadowDom');
}

zrUtil.inherits(ShadowManager, Definable);
/**
 * Create new shadow DOM for fill or stroke if not exist,
 * but will not update shadow if exists.
 *
 * @param {SvgElement}  svgElement   SVG element to paint
 * @param {Displayable} displayable  zrender displayable element
 */

ShadowManager.prototype.addWithoutUpdate = function (svgElement, displayable) {
  if (displayable && hasShadow(displayable.style)) {
    // Create dom in <defs> if not exists
    var dom;

    if (displayable._shadowDom) {
      // Gradient exists
      dom = displayable._shadowDom;
      var defs = this.getDefs(true);

      if (!defs.contains(displayable._shadowDom)) {
        // _shadowDom is no longer in defs, recreate
        this.addDom(dom);
      }
    } else {
      // New dom
      dom = this.add(displayable);
    }

    this.markUsed(displayable);
    var id = dom.getAttribute('id');
    svgElement.style.filter = 'url(#' + id + ')';
  }
};
/**
 * Add a new shadow tag in <defs>
 *
 * @param {Displayable} displayable  zrender displayable element
 * @return {SVGFilterElement} created DOM
 */


ShadowManager.prototype.add = function (displayable) {
  var dom = this.createElement('filter'); // Set dom id with shadow id, since each shadow instance
  // will have no more than one dom element.
  // id may exists before for those dirty elements, in which case
  // id should remain the same, and other attributes should be
  // updated.

  displayable._shadowDomId = displayable._shadowDomId || this.nextId++;
  dom.setAttribute('id', 'zr' + this._zrId + '-shadow-' + displayable._shadowDomId);
  this.updateDom(displayable, dom);
  this.addDom(dom);
  return dom;
};
/**
 * Update shadow.
 *
 * @param {Displayable} displayable  zrender displayable element
 */


ShadowManager.prototype.update = function (svgElement, displayable) {
  var style = displayable.style;

  if (hasShadow(style)) {
    var that = this;
    Definable.prototype.update.call(this, displayable, function () {
      that.updateDom(displayable, displayable._shadowDom);
    });
  } else {
    // Remove shadow
    this.remove(svgElement, displayable);
  }
};
/**
 * Remove DOM and clear parent filter
 */


ShadowManager.prototype.remove = function (svgElement, displayable) {
  if (displayable._shadowDomId != null) {
    this.removeDom(svgElement);
    svgElement.style.filter = '';
  }
};
/**
 * Update shadow dom
 *
 * @param {Displayable} displayable  zrender displayable element
 * @param {SVGFilterElement} dom DOM to update
 */


ShadowManager.prototype.updateDom = function (displayable, dom) {
  var domChild = dom.getElementsByTagName('feDropShadow');

  if (domChild.length === 0) {
    domChild = this.createElement('feDropShadow');
  } else {
    domChild = domChild[0];
  }

  var style = displayable.style;
  var scaleX = displayable.scale ? displayable.scale[0] || 1 : 1;
  var scaleY = displayable.scale ? displayable.scale[1] || 1 : 1; // TODO: textBoxShadowBlur is not supported yet

  var offsetX;
  var offsetY;
  var blur;
  var color;

  if (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY) {
    offsetX = style.shadowOffsetX || 0;
    offsetY = style.shadowOffsetY || 0;
    blur = style.shadowBlur;
    color = style.shadowColor;
  } else if (style.textShadowBlur) {
    offsetX = style.textShadowOffsetX || 0;
    offsetY = style.textShadowOffsetY || 0;
    blur = style.textShadowBlur;
    color = style.textShadowColor;
  } else {
    // Remove shadow
    this.removeDom(dom, style);
    return;
  }

  domChild.setAttribute('dx', offsetX / scaleX);
  domChild.setAttribute('dy', offsetY / scaleY);
  domChild.setAttribute('flood-color', color); // Divide by two here so that it looks the same as in canvas
  // See: https://html.spec.whatwg.org/multipage/canvas.html#dom-context-2d-shadowblur

  var stdDx = blur / 2 / scaleX;
  var stdDy = blur / 2 / scaleY;
  var stdDeviation = stdDx + ' ' + stdDy;
  domChild.setAttribute('stdDeviation', stdDeviation); // Fix filter clipping problem

  dom.setAttribute('x', '-100%');
  dom.setAttribute('y', '-100%');
  dom.setAttribute('width', Math.ceil(blur / 2 * 200) + '%');
  dom.setAttribute('height', Math.ceil(blur / 2 * 200) + '%');
  dom.appendChild(domChild); // Store dom element in shadow, to avoid creating multiple
  // dom instances for the same shadow element

  displayable._shadowDom = dom;
};
/**
 * Mark a single shadow to be used
 *
 * @param {Displayable} displayable displayable element
 */


ShadowManager.prototype.markUsed = function (displayable) {
  if (displayable._shadowDom) {
    Definable.prototype.markUsed.call(this, displayable._shadowDom);
  }
};

function hasShadow(style) {
  // TODO: textBoxShadowBlur is not supported yet
  return style && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY || style.textShadowBlur || style.textShadowOffsetX || style.textShadowOffsetY);
}

var _default = ShadowManager;
module.exports = _default;

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _method=__webpack_require__(20);var _data=__webpack_require__(403);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=function(data,date){var month=(0,_moment2.default)(date).format('M');var budgetRev=['best_rev','corporate_rev','government_rev','packges_rev','wholesale_rev','commerce_rev','discounts_rev','business_rev','leisure_rev','contracts_rev'];// 动态赋值month status
data=data.map(function(item,index){var str='';if(index<42&&index!=40){str='';if(index%3==0)str="Budget";if(index%3==1)str=""+(Math.ceil((index+1)/3)<=month?'Actual':"Forecast");if(index%3==2)str="Actual Last Year";if(index==37)str="Actual";}if(index==46)str="Act/Fcst";if(index==45)str="Budget";if(index==44)str="YTD Actual";if(index==43)str="Y/E Fcast";if(index==42)str="YTD Actual";if(index==40)str="Act/Fcst";return _extends({},item,{month_status_name:str,name:_data.dataDefault[index].name});});//计算每月第一行Rev 和第二行ARR
data.forEach(function(item,i){budgetRev.forEach(function(name,j){var RN=name.split('_rev')[0]+'_rn';var ARR=name.split('_rev')[0]+'_arr';if(i<42&&i%3!=2){data[i][ARR]=item[RN]!=0?(item[name]/item[RN]).toFixed(2):0;}});});// YTD 累加到当前月份之前
budgetRev.forEach(function(name){var RN=name.split('_rev')[0]+'_rn';var ARR=name.split('_rev')[0]+'_arr';data[36][RN]=data.reduce(function(a,b,i){if(i<36&&Math.ceil((i+1)/3)<=month&&i%3==0){a+=(0,_method.numConvert)(b[RN]);}return a;},0).toFixed(2);data[37][RN]=data.reduce(function(a,b,i){if(i<36&&Math.ceil((i+1)/3)<=month&&i%3==1){a+=(0,_method.numConvert)(b[RN]);}return a;},0).toFixed(2);data[38][RN]=data.reduce(function(a,b,i){if(i<36&&Math.ceil((i+1)/3)<=month&&i%3==2){a+=(0,_method.numConvert)(b[RN]);}return a;},0).toFixed(2);data[36][name]=data.reduce(function(a,b,i){if(i<36&&Math.ceil((i+1)/3)<=month&&i%3==0){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);data[37][name]=data.reduce(function(a,b,i){if(i<36&&Math.ceil((i+1)/3)<=month&&i%3==1){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);data[38][name]=data.reduce(function(a,b,i){if(i<36&&Math.ceil((i+1)/3)<=month&&i%3==2){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);data[36][ARR]=data[36][RN]==0?0:(data[36][name]/data[36][RN]).toFixed(2);data[37][ARR]=data[37][RN]==0?0:(data[37][name]/data[37][RN]).toFixed(2);data[38][ARR]=data[38][RN]==0?0:(data[38][name]/data[38][RN]).toFixed(2);});['grand_rms','others_rev'].forEach(function(name){data[36][name]=data.reduce(function(a,b,i){if(i<36&&Math.ceil((i+1)/3)<=month&&i%3==0){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);data[37][name]=data.reduce(function(a,b,i){if(i<36&&Math.ceil((i+1)/3)<=month&&i%3==1){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);data[38][name]=data.reduce(function(a,b,i){if(i<36&&Math.ceil((i+1)/3)<=month&&i%3==2){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);});// Total
var totalListName=['best_rev','corporate_rev','government_rev','packges_rev','wholesale_rev','commerce_rev','discounts_rev'];data.forEach(function(item,i){if(i<39){// TOTAL TRANSIENT
data[i].total_rn=totalListName.reduce(function(a,b){var name=b.split('_rev')[0]+"_rn";return a+(0,_method.numConvert)(item[name]);},0).toFixed(2);data[i].total_rev=totalListName.reduce(function(a,b){return a+(0,_method.numConvert)(item[b]);},0).toFixed(2);data[i].total_arr=data[i].total_rn==0?0:(data[i].total_rev/data[i].total_rn).toFixed(2);// TOTAL GROUPS
data[i].group_total_rn=['business_rev','leisure_rev'].reduce(function(a,b){var name=b.split('_rev')[0]+"_rn";return a+(0,_method.numConvert)(item[name]);},0).toFixed(2);data[i].group_total_rev=['business_rev','leisure_rev'].reduce(function(a,b){return a+(0,_method.numConvert)(item[b]);},0).toFixed(2);data[i].group_total_arr=data[i].group_total_rn==0?0:(data[i].group_total_rev/data[i].group_total_rn).toFixed(2);// GRAND TOTAL
data[i].grand_rn=['total_rev','group_total_rev','contracts_rev'].reduce(function(a,b){var name=b.split('_rev')[0]+"_rn";return a+(0,_method.numConvert)(item[name]);},0).toFixed(2);data[i].grand_rev=['total_rev','group_total_rev','contracts_rev','others_rev'].reduce(function(a,b){return a+(0,_method.numConvert)(item[b]);},0).toFixed(2);data[i].grand_arr=data[i].grand_rn==0?0:(data[i].grand_rev/data[i].grand_rn).toFixed(2);data[i].grand_occ=data[i].grand_rms==0?0:(data[i].grand_rn/data[i].grand_rms).toFixed(4);data[i].grand_revpar=(data[i].grand_arr*data[i].grand_occ).toFixed(2);}});// Year End
var listName=["best_rn","corporate_rn","government_rn","packges_rn","wholesale_rn","commerce_rn","discounts_rn","total_rn","business_rn","leisure_rn","group_total_rn","contracts_rn","grand_rn"];var othersName=['others_rev','grand_rms'];[].concat(listName).forEach(function(name){var ARR=name.split('_rn')[0]+"_arr";var REV=name.split('_rn')[0]+"_rev";[name,REV].forEach(function(newName){data[39][newName]=data.reduce(function(a,b,i){if(i<36&&i%3==0){a+=(0,_method.numConvert)(b[newName]);}return a;},0).toFixed(2);data[40][newName]=data.reduce(function(a,b,i){if(i<36&&i%3==1){a+=(0,_method.numConvert)(b[newName]);}return a;},0).toFixed(2);data[41][newName]=data.reduce(function(a,b,i){if(i<36&&i%3==2){a+=(0,_method.numConvert)(b[newName]);}return a;},0).toFixed(2);});[39,40,41].forEach(function(index){data[index][ARR]=data[index][name]==0?0:(data[index][REV]/data[index][name]).toFixed(2);});});[].concat(othersName).forEach(function(name){data[39][name]=data.reduce(function(a,b,i){if(i<36&&i%3==0){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);data[40][name]=data.reduce(function(a,b,i){if(i<36&&i%3==1){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);data[41][name]=data.reduce(function(a,b,i){if(i<36&&i%3==2){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);});// 计算occ % 
data.forEach(function(item,i){if(i<41&&i>=39&&i%3!=2){data[i].grand_arr=data[i].grand_rn==0?0:(data[i].grand_rev/data[i].grand_rn).toFixed(2);data[i].grand_occ=data[i].grand_rms==0?0:(data[i].grand_rn/data[i].grand_rms).toFixed(4);data[i].grand_revpar=(data[i].grand_arr*data[i].grand_occ).toFixed(2);}});// % to Budget --- Year End Mix %
var allListName=["best_rn","best_arr","best_rev","corporate_rn","corporate_arr","corporate_rev","government_rn","government_arr","government_rev","packges_rn","packges_arr","packges_rev","wholesale_rn","wholesale_arr","wholesale_rev","commerce_rn","commerce_arr","commerce_rev","discounts_rn","discounts_arr","discounts_rev","total_rn","total_arr","total_rev","business_rn","business_arr","business_rev","leisure_rn","leisure_arr","leisure_rev","group_total_rn","group_total_arr","group_total_rev","contracts_rn","contracts_arr","contracts_rev","others_rev","grand_rn","grand_arr","grand_rev","grand_occ","grand_revpar","grand_rms"];allListName.forEach(function(name){data[42][name]=data[36][name]==0?0:((data[37][name]-data[36][name])/data[36][name]).toFixed(4);data[43][name]=data[39][name]==0?0:((data[40][name]-data[39][name])/data[39][name]).toFixed(4);data[44][name]=data[38][name]==0?0:((data[37][name]-data[38][name])/data[38][name]).toFixed(4);// if (!name.includes('grand_')) {
if(name.includes("_rn")){data[45][name]=data[39]['grand_rn']==0?0:(data[39][name]/data[39]['grand_rn']).toFixed(4);data[46][name]=data[40]['grand_rn']==0?0:(data[40][name]/data[40]['grand_rn']).toFixed(4);}if(name.includes("_rev")){data[45][name]=data[39]['grand_rev']==0?0:(data[39][name]/data[39]['grand_rev']).toFixed(4);data[46][name]=data[40]['grand_rev']==0?0:(data[40][name]/data[40]['grand_rev']).toFixed(4);}// }
});return data;};

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(1822);var _data2=_interopRequireDefault(_data);var _compute=__webpack_require__(1823);var _compute2=_interopRequireDefault(_compute);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var totalIndex=[];var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var _this$state=_this.state,date=_this$state.date,data4_1=_this$state.data4_1;data=(0,_compute2.default)(data,date,data4_1);_this.setState({data:data,loading:false});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var data,month,year,x;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_this.setState({loading:true});data=JSON.parse(JSON.stringify(_data2.default));month=(0,_moment2.default)(date).format('M');year=(0,_moment2.default)(date).format('YYYY');_context.next=7;return(0,_request2.default)("/t4_1_4info?year="+year+"&month="+month);case 7:x=_context.sent;if(x.data.data&&x.data.data.length>0){data=x.data.data.sort(function(a,b){return a.sort-b.sort;});}if(x.data.names.length){data=data.map(function(v,i){return _extends({},v,{name:x.data.names[i]});});}_this.setState({data4_1:x.data.data4_1||[]},function(){_this.computeNum(data,true);});_context.next=17;break;case 13:_context.prev=13;_context.t0=_context["catch"](0);_this.setState({loading:false});console.error(_context.t0);case 17:case"end":return _context.stop();}}},_callee,_this2,[[0,13]]);}));return function(_x){return _ref.apply(this,arguments);};}();_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var date,_timer,year,month,data,dataFrom,headres,x,timer,_timer2;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_this.setState({loadingSave:true});date=_this.state.date;if(date){_context2.next=7;break;}_message3.default.error('请选择年份月份');_timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer);},1000);return _context2.abrupt("return");case 7:year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month,sort:i});});dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context2.next=15;return(0,_request2.default)('/t4_1_4add',headres);case 15:x=_context2.sent;timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(!(x.status==1)){_context2.next=21;break;}_message3.default.success(x.msg);if(!data[0].id){_this.getData(_this.state.date);}return _context2.abrupt("return");case 21:_message3.default.error(x.msg);_context2.next=29;break;case 24:_context2.prev=24;_context2.t0=_context2["catch"](0);_timer2=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer2);},1000);console.error(_context2.t0);_message3.default.error('保存失败'+JSON.stringify(_context2.t0));case 29:case"end":return _context2.stop();}}},_callee2,_this2,[[0,24]]);}));_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('view4_1_4',1.5,'4.14',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+" "+(0,_moment2.default)(_this.state.date).format('YYYY')+" Monthly ADR By Room Type";var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById('table4_1_4').innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+".xls");_this.setState({print:false});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,data4_1:[]};return _this;}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print,loading=_state.loading;return _react2.default.createElement("div",{className:"table7_1_1 tableHeight"},_react2.default.createElement(_row2.default,{className:"title",id:"view4_1_4"},_react2.default.createElement(_row2.default,null,"4.1.4 Monthly ADR By Room Type"),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:"YYYY-MM",onChange:function onChange(date,str){_this3.setState({date:str,data:[]});_this3.getData(str);}})),_react2.default.createElement(_table2.default,{columns:(0,_compute.columns)(this.onChange,date,print),dataSource:data,size:"middle",id:"table4_1_4",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:"table-footer-btn"},_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:print},"\u5BFC\u51FAExcel"),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:"edit_4_1"},_react2.default.createElement(_button2.default,{type:"primary",style:{margin:'0 10px'},onClick:this.downloadSG,loading:print},"\u52A0\u5165pdf"),_react2.default.createElement(_button2.default,{type:"primary",onClick:this.onSave,loading:this.state.loadingSave},"\u4FDD\u5B58"))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=[{"name":"","sort":0,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":1,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":2,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":3,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":4,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":5,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":6,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":7,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":8,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":9,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":10,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":11,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":12,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":13,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":14,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":15,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":16,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":17,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":18,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":19,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"Entry Level Room Type","sort":20,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":21,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":22,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":23,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":24,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":25,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":26,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":27,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":28,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":29,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":30,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":31,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":32,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":33,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":34,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":35,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":36,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":37,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":38,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":39,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":40,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"Upscale Level Room Type","sort":41,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":42,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":43,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":44,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":45,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":46,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":47,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":48,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":49,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":50,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":51,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":52,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":53,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":54,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":55,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":56,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":57,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":58,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":59,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":60,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"","sort":61,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"Luxury Level Room Type","sort":62,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"Montly Grand Total","sort":63,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"Montly Grand Total(4.1.1)","sort":64,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"King Size Bed","sort":65,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"Twin Size Bed","sort":66,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0},{"name":"Montly Grand Total","sort":67,"inventory":0,"ava":0,"sold":0,"occ":0,"adr":0,"rev":0,"revp":0}];

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columns=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _method=__webpack_require__(20);var _method2=__webpack_require__(20);var _method3=_interopRequireDefault(_method2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=function(data,date,data4_1){var totalName=['inventory','ava','sold','rev'];var totalIndex=[20,41,62];totalIndex.forEach(function(index){totalName.forEach(function(name){data[index][name]=data.reduce(function(a,b,i){if(i<index&&i>=index-20)a+=(0,_method.numConvert)(b[name]);return a;},0).toFixed(2);});});// 计算总汇总
totalName.forEach(function(name){data[63][name]=totalIndex.reduce(function(a,b){return a+=(0,_method.numConvert)(data[b][name]);},0).toFixed(2);data[67][name]=[65,66].reduce(function(a,b){return a+=(0,_method.numConvert)(data[b][name]);},0).toFixed(2);});var index=((0,_moment2.default)(date).format('M')-1)*3+1;data[64].ava=(0,_method3.default)([index,'grand_rms'],data4_1);data[64].rev=(0,_method3.default)([index,'grand_rev'],data4_1);data[64].sold=(0,_method3.default)([index,'grand_rn'],data4_1);data.forEach(function(item,index){data[index].occ=(0,_method.calculation)(item.sold,item.ava,4);data[index].adr=(0,_method.calculation)(item.rev,item.sold);if(![64,67].includes(index))data[index].revp=(0,_method.calculation)(item.rev,data[63].rev,4);});return data;};var totalIndex=[20,41,62,63,64,67];var columns=exports.columns=function columns(onChange,date,print){return[{title:"Room Type Name",dataIndex:'name',key:'name',align:"center",width:200,render:function render(text,record,index){var title=['Room Type Name'];var props={text:text,index:index,type:(0,_moment2.default)(date).format('M')==1&&!totalIndex.includes(index)&&!print?'input':'text',name:"name",onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"Inventory",dataIndex:'inventory',key:'inventory',align:"center",width:150,render:function render(text,record,index){var title=['Inventory'];var props={text:text,index:index,type:!totalIndex.includes(index)&&!print?'inputNumber':'number',name:"inventory",onChange:onChange,totalIndex:totalIndex};if(index>62||index==20||index==41){props.compared={title:title,record:record,sqlName:"_4_1_4_new"};}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"Available Rooms",dataIndex:'ava',key:'ava',align:"center",width:150,render:function render(text,record,index){var title=['Available Rooms'];var props={text:text,index:index,type:!totalIndex.includes(index)&&!print?'inputNumber':'number',name:"ava",onChange:onChange,totalIndex:totalIndex};if(index>62||index==20||index==41){props.compared={title:title,record:record,sqlName:"_4_1_4_new"};}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"Sold Room",dataIndex:'sold',key:'sold',align:"center",width:150,render:function render(text,record,index){var title=['Sold Room'];var props={text:text,index:index,type:!totalIndex.includes(index)&&!print?'inputNumber':'number',name:"sold",onChange:onChange,totalIndex:totalIndex};if(index>62||index==20||index==41){props.compared={title:title,record:record,sqlName:"_4_1_4_new"};}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"Occ%",dataIndex:'occ',key:'occ',align:"center",width:150,render:function render(text,record,index){var title=['Occ%'];var props={text:text,index:index,type:'percent',name:"occ",onChange:onChange,totalIndex:totalIndex};if(index>62||index==20||index==41){props.compared={title:title,record:record,sqlName:"_4_1_4_new"};}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"ADR",dataIndex:'adr',key:'adr',align:"center",width:150,render:function render(text,record,index){var title=['ADR'];var props={text:text,index:index,type:'number',name:"adr",onChange:onChange,totalIndex:totalIndex};if(index>62||index==20||index==41){props.compared={title:title,record:record,sqlName:"_4_1_4_new"};}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"Room Revenue",dataIndex:'rev',key:'rev',align:"center",width:150,render:function render(text,record,index){var title=['Room Revenue'];var props={text:text,index:index,type:!totalIndex.includes(index)&&!print?'inputNumber':'number',name:"rev",onChange:onChange,totalIndex:totalIndex};if(index>62||index==20||index==41){props.compared={title:title,record:record,sqlName:"_4_1_4_new"};}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"Room Revenue %",dataIndex:'revp',key:'revp',align:"center",width:150,render:function render(text,record,index){var title=['Room Revenue %'];var props={text:text,index:index,type:'percent',name:"revp",onChange:onChange,totalIndex:totalIndex};if(index>62||index==20||index==41){props.compared={title:title,record:record,sqlName:"_4_1_4_new"};}return _react2.default.createElement(_TableText2.default,{data:props});}}];};

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(1825);var _data2=_interopRequireDefault(_data);var _compute=__webpack_require__(1826);var _compute2=_interopRequireDefault(_compute);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var date=_this.state.date;data=(0,_compute2.default)(data,date);_this.setState({data:data,loading:false});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var data,month,year,x;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_this.setState({loading:true});data=JSON.parse(JSON.stringify(_data2.default));month=(0,_moment2.default)(date).format('M');year=(0,_moment2.default)(date).format('YYYY');_context.next=7;return(0,_request2.default)("/t4_1_5info?year="+year+"&month="+month);case 7:x=_context.sent;if(x.data&&x.data.length>0){data=x.data.sort(function(a,b){return a.sort-b.sort;});}_this.computeNum(data,true);_context.next=16;break;case 12:_context.prev=12;_context.t0=_context["catch"](0);_this.setState({loading:false});console.error(_context.t0);case 16:case"end":return _context.stop();}}},_callee,_this2,[[0,12]]);}));return function(_x){return _ref.apply(this,arguments);};}();_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var date,_timer,year,month,data,dataFrom,headres,x,timer,_timer2;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_this.setState({loadingSave:true});date=_this.state.date;if(date){_context2.next=7;break;}_message3.default.error('请选择年份月份');_timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer);},1000);return _context2.abrupt("return");case 7:year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month,sort:i});});dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context2.next=15;return(0,_request2.default)('/t4_1_5add',headres);case 15:x=_context2.sent;timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(!(x.status==1)){_context2.next=21;break;}_message3.default.success(x.msg);if(!data[0].id){_this.getData(_this.state.date);}return _context2.abrupt("return");case 21:_message3.default.error(x.msg);_context2.next=29;break;case 24:_context2.prev=24;_context2.t0=_context2["catch"](0);_timer2=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer2);},1000);console.error(_context2.t0);_message3.default.error('保存失败'+JSON.stringify(_context2.t0));case 29:case"end":return _context2.stop();}}},_callee2,_this2,[[0,24]]);}));_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('view4_1_5',1.5,'4.14',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+" "+(0,_moment2.default)(_this.state.date).format('YYYY')+" 4.1.5 Corp. FIT monthly by pricing level";var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById('table4_1_5').innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+".xls");_this.setState({print:false});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,data4_1:[]};return _this;}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print,loading=_state.loading;return _react2.default.createElement("div",{className:"table7_1_1 tableHeight",style:{width:1000}},_react2.default.createElement(_row2.default,{className:"title",id:"view4_1_5"},_react2.default.createElement(_row2.default,null,"4.1.5 Corp. FIT monthly by pricing level"),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:"YYYY-MM",onChange:function onChange(date,str){_this3.setState({date:str,data:[]});_this3.getData(str);}})),_react2.default.createElement(_table2.default,{columns:(0,_compute.columns)(this.onChange,date,print),dataSource:data,size:"middle",id:"table4_1_5",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:"table-footer-btn"},_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:print},"\u5BFC\u51FAExcel"),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:"edit_4_1"},_react2.default.createElement(_button2.default,{type:"primary",style:{margin:'0 10px'},onClick:this.downloadSG,loading:print},"\u52A0\u5165pdf"),_react2.default.createElement(_button2.default,{type:"primary",onClick:this.onSave,loading:this.state.loadingSave},"\u4FDD\u5B58"))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=[{"name":"RFP","sort":0,"rate":0,"rooms":0,"rev":0,"adr":0,"mix":0},{"name":"Level1","sort":1,"rate":0,"rooms":0,"rev":0,"adr":0,"mix":0},{"name":"Level2","sort":2,"rate":0,"rooms":0,"rev":0,"adr":0,"mix":0},{"name":"Level3","sort":3,"rate":0,"rooms":0,"rev":0,"adr":0,"mix":0},{"name":"Level4","sort":4,"rate":0,"rooms":0,"rev":0,"adr":0,"mix":0},{"name":"Level5","sort":5,"rate":0,"rooms":0,"rev":0,"adr":0,"mix":0},{"name":"Without Contract","sort":6,"rate":0,"rooms":0,"rev":0,"adr":0,"mix":0},{"name":"Special Rate","sort":7,"rate":0,"rooms":0,"rev":0,"adr":0,"mix":0},{"name":"","sort":8,"rate":0,"rooms":0,"rev":0,"adr":0,"mix":0}];

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columns=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _method2=_interopRequireDefault(_method);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var totalIndex=[8];exports.default=function(data,date){['rev','rooms'].forEach(function(name){data[8][name]=data.reduce(function(a,b,i){return i<8?a+(0,_method.numConvert)(b[name]):a;},0).toFixed(2);});data.forEach(function(item,i){data[i].adr=(0,_method.calculation)(item.rev,item.rooms);data[i].mix=(0,_method.calculation)(item.rooms,data[8].rooms,4);});return data;};var columns=exports.columns=function columns(onChange,date,print){return[{title:"",dataIndex:'name',key:'name',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"Price Level",dataIndex:'rate',key:'rate',align:"center",width:150,render:function render(text,record,index){var title=['rate'];var props={text:text,index:index,type:!totalIndex.includes(index)&&!print?'inputNumber':'number',name:"rate",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_5_new"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"Rooms nights",dataIndex:'rooms',key:'rooms',align:"center",width:150,render:function render(text,record,index){var title=['rooms'];var props={text:text,index:index,type:!totalIndex.includes(index)&&!print?'inputNumber':'number',name:"rooms",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_5_new"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"Room Revenue",dataIndex:'rev',key:'rev',align:"center",width:150,render:function render(text,record,index){var title=['rev'];var props={text:text,index:index,type:!totalIndex.includes(index)&&!print?'inputNumber':'number',name:"rev",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_5_new"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"ADR",dataIndex:'adr',key:'adr',align:"center",width:150,render:function render(text,record,index){var title=['adr'];var props={text:text,index:index,type:'number',name:"adr",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_5_new"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"Mix%",dataIndex:'mix',key:'mix',align:"center",width:150,render:function render(text,record,index){var title=['mix'];var props={text:text,index:index,type:'percent',name:"mix",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_1_5_new"}};return _react2.default.createElement(_TableText2.default,{data:props});}}];};

/***/ }),
/* 1827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _radio=__webpack_require__(112);var _radio2=_interopRequireDefault(_radio);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(127);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);__webpack_require__(25);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _method=__webpack_require__(20);var _method2=_interopRequireDefault(_method);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _compute=__webpack_require__(438);var _data2=__webpack_require__(1829);var _=__webpack_require__(1830);var _2=_interopRequireDefault(_);__webpack_require__(1831);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextArea=_input2.default.TextArea;var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data,lastYearData,sprData){data=(0,_compute.compute)(data,lastYearData,_this.state.date,sprData);_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data,_this.state.lastYearData);};_this.getData=function(date,_fullYear){var data=JSON.parse(JSON.stringify(_data2.defaultData));var month=(0,_moment2.default)(date).format('M');var lastMonth=month;if(month==_compute.SPR[(0,_moment2.default)(date).format('Y')].m)lastMonth=_compute.SPR[(0,_moment2.default)(date).subtract(1,'year').format('Y')].m;fetch("/_4_2_daily?year="+(0,_moment2.default)(date).format('YYYY')+"&month="+month+"&lastmonth="+lastMonth+"&type="+_fullYear,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(_fullYear==1){var _data=x.data.data||[];var lastYearData=x.data.lastYearData||[];_data.push({name:"Total"});lastYearData.push({name:"Total"});// 计算全年
_this.setState({loading:false,note:x.data.comments||{comments:""},data:(0,_compute.computeYear)(_data,lastYearData)});return;}if(x.data.data&&x.data.data.length){data=x.data.data;}var listName=['ava','sold','occ','adr','revpar','rev'];var grandName=["grand_rms","grand_rn","grand_occ","grand_arr","grand_revpar","grand_rev"];var monthName=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];listName.forEach(function(name,i){data[33][name]=(0,_method2.default)([(month-1)*3+1,grandName[i]],x.data.data4_1);data[31][name]=(0,_method2.default)([i+1,monthName[month-1]],x.data.data2_1);});data[31]['total']=(0,_method2.default)([9,monthName[month-1]],x.data.data2_1);_this.setState({loading:false,note:x.data.comments||{comments:""},lastYearData:x.data.lastYearData||[],sprData:x.data.sprData||[]});_this.computeNum(data,x.data.lastYearData,x.data.sprData);}).catch(function(err){console.error(err);_this.setState({loading:false});});};_this.onSave=function(){var _this$state=_this.state,date=_this$state.date,data=_this$state.data,note=_this$state.note,fullYear=_this$state.fullYear;if(fullYear==1){_message3.default.error('请切换至当月保存数据！');return;}_this.setState({loadingSave:true});var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");data=data.map(function(x){return _extends({},x,{year:year,month:month});});note=_extends({},note,{year:year,month:month});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));dataFrom.append('note',JSON.stringify(note));dataFrom.append('year',year);dataFrom.append('month',month);var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_4_2_daily',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table7_6',1.5,'4.20',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+" 4.2 Daily Report \u65E5\u62A5\u8868";var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById('table4_2').innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+".xls");_this.setState({print:false});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],note:{comments:''},loading:true,print:false,loadingSave:false,loadingNote:false,lastYearData:[],sprData:[],fullYear:0,// 1 春节 2 五一 3 十一
holiday:0};return _this;}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date,this.state.fullYear);}},{key:"render",value:function render(){var _this2=this;var _state=this.state,data=_state.data,date=_state.date,note=_state.note,print=_state.print,loading=_state.loading,loadingNote=_state.loadingNote,fullYear=_state.fullYear;var columns=[{title:'Date',dataIndex:'name',key:'name',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Week',dataIndex:'week',key:'week',align:"center",width:100,render:function render(text,record,index){var week=['','周一','周二','周三','周四','周五','周六','周日'][(0,_moment2.default)(date+"-"+(index+1)).format('E')];var props={text:week,index:index,type:'text',name:"name"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Available room',dataIndex:'ava',key:'ava',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,onChange:_this2.onChange,type:index<31&&!print?'inputNumber':'number',name:"ava",compared:{title:['Available room'],record:record,sqlName:"_4_2_daily"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Sold Room',dataIndex:'sold',key:'sold',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,onChange:_this2.onChange,type:index<31&&!print?'inputNumber':'number',name:"sold",compared:{title:['Sold Room'],record:record,sqlName:"_4_2_daily"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Occupancy %',dataIndex:'occ',key:'occ',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,onChange:_this2.onChange,type:'percent',name:"occ",compared:{title:['Occupancy %'],record:record,sqlName:"_4_2_daily"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'ADR',dataIndex:'adr',key:'adr',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,onChange:_this2.onChange,type:'number',name:"adr",compared:{title:['ADR'],record:record,sqlName:"_4_2_daily"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'RevPAR',dataIndex:'revpar',key:'revpar',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,onChange:_this2.onChange,type:'number',name:"revpar",compared:{title:['RevPAR'],record:record,sqlName:"_4_2_daily"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Room Revenue',dataIndex:'rev',key:'rev',width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,onChange:_this2.onChange,type:index<31&&!print?'inputNumber':'number',name:"rev",compared:{title:['Room Revenue'],record:record,sqlName:"_4_2_daily"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Room Revenue %',dataIndex:'revper',key:'revper',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,onChange:_this2.onChange,type:'percent',name:"revper",compared:{title:['Room Revenue %'],record:record,sqlName:"_4_2_daily"}};if(index==33)props.type='';return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Hotel Total Revenue',dataIndex:'total',key:'total',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,onChange:_this2.onChange,type:index<31&&!print?'inputNumber':'number',name:"total",compared:{title:['Hotel Total Revenue'],record:record,sqlName:"_4_2_daily"}};if(index==33)props.type='';return _react2.default.createElement(_TableText2.default,{data:props});}}];var user=JSON.parse(sessionStorage.getItem('user')||"{}");return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement("div",{className:"table7_1_1 table7_6",id:"table7_6",style:{height:'auto'}},_react2.default.createElement(_row2.default,{className:"title"},_react2.default.createElement(_row2.default,null,"4.2.1 Daily Report \u65E5\u62A5\u8868"),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(date,"YYYY-MM"),format:"YYYY-MM",onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getData(str,fullYear);}}),_react2.default.createElement(_radio2.default.Group,{style:{marginLeft:10},onChange:function onChange(e){var _fullYear=e.target.value;_this2.setState({data:[],loading:true,fullYear:_fullYear},function(){_this2.getData(date,_fullYear);});},value:fullYear},_react2.default.createElement(_radio2.default,{value:1},"\u5168\u5E74"),_react2.default.createElement(_radio2.default,{value:0},"\u5F53\u6708"))),_react2.default.createElement(_table2.default,{columns:fullYear==0?columns:_data2.columnsYear.map(function(x){return _extends({},x,{dataIndex:x.key,align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:x.type?x.type:"number",name:x.key};return _react2.default.createElement(_TableText2.default,{data:props});}});}),dataSource:data,size:"middle",bordered:true,pagination:false,className:"content",id:"table4_2",scroll:print?{}:{y:500},rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_button2.default,{type:"primary",style:{float:'right',marginTop:20},onClick:function onClick(){_this2.setState({print:true},function(){_this2.downloadExcel();});},loading:this.state.print},"\u5BFC\u51FAExcel")),_react2.default.createElement(_row2.default,{className:"title"},_react2.default.createElement("div",{className:"chart-4-2"},_react2.default.createElement("div",{id:"chartOcc"}),_react2.default.createElement("div",{id:"chartAdr"}),_react2.default.createElement("div",{id:"chartRevpar"}),_react2.default.createElement("div",{id:"chartRoomRev"})),!loading&&_react2.default.createElement(_row2.default,null,"Comments\u5907\u6CE8: "),!loading&&_react2.default.createElement(TextArea,{autosize:{minRows:4},defaultValue:note.comments||"",onBlur:function onBlur(e){var n=_this2.state.note;n['comments']=e.target.value;_this2.setState({note:n});}}),_react2.default.createElement(_Auth2.default,{loading:loading,auth:"edit_4_2_1"},_react2.default.createElement(_row2.default,{className:"table-footer-btn",style:{display:print?'none':""}},_react2.default.createElement(_button2.default,{type:"primary",style:{marginRight:10},onClick:this.downloadSG,loading:print},"\u52A0\u5165pdf"),_react2.default.createElement(_button2.default,{type:"primary",onClick:this.onSave,loading:loadingNote},"\u4FDD\u5B58"))))),(['5','10'].includes((0,_moment2.default)(date).format("M"))||_compute.SPR[(0,_moment2.default)(date).format('Y')].m==(0,_moment2.default)(date).format('M'))&&_react2.default.createElement(_2.default,{data:data,date:date}));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var defaultData=exports.defaultData=[].concat(_toConsumableArray(new Array(31).fill(1).map(function(x,i){return{name:i+1,ava:0,sold:0,occ:0,adr:0,revpar:0,rev:0,revper:0,total:0};})),[{name:"Grand total <br/>(ES2.1数据）",ava:0,sold:0,occ:0,adr:0,revpar:0,rev:0,revper:0,total:0},{name:"Grand total<br/>(日报公式）",ava:0,sold:0,occ:0,adr:0,revpar:0,rev:0,revper:0,total:0},{name:"Grand total<br/>(ES4.1数据）",ava:0,sold:0,occ:0,adr:0,revpar:0,rev:0,revper:0,total:0}]);var columnsYear=exports.columnsYear=[{title:'Date',key:'name',type:"text"},{title:'Available room',key:'ava'},{title:'Sold Room',key:'sold'},{title:'Occupancy %',key:'occ',type:"percent"},{title:'ADR',key:'adr'},{title:'RevPAR',key:'revpar'},{title:'Room Revenue',key:'rev'},{title:'Room Revenue %',key:'revper',type:"percent"},{title:'Hotel Total Revenue',key:'total'}];

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _compute=__webpack_require__(438);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={loading:false,print:false},_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table4_2_2',1.5,'4.212',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});},_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+' 4.2.1.2 Golden Week or Public Holiday Booking Path report \u6CD5\u5B9A\u5C0F\u957F\u5047\u552E\u5356\u60C5\u51B5\u62A5\u8868';var innerHtml='\n          <caption>'+tableName+'</caption>\n          '+document.getElementById('table4_2_2_export').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n        ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+'.xls');_this.setState({print:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'render',value:function render(){var _this2=this;var _state=this.state,print=_state.print,loading=_state.loading;var _props=this.props,data=_props.data,date=_props.date;var columns=[{title:'Date',dataIndex:'name',key:'name',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Week',dataIndex:'week',key:'week',align:"center",width:100,render:function render(text,record,index){var spr=['除夕','初一','初二','初三','初四','初五','初六','初七'];var week=['','周一','周二','周三','周四','周五','周六','周日'][(0,_moment2.default)(date+'-'+(index+1)).format('E')];var props={text:week,index:index,type:'text',name:"name"};if(_compute.SPR[(0,_moment2.default)(date).format('Y')].m==(0,_moment2.default)(date).format('M')){props.text=spr[index];}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Available room',dataIndex:'ava',key:'ava',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"ava"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Sold Room',dataIndex:'sold',key:'sold',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"sold"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Occupancy %',dataIndex:'occ',key:'occ',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"occ"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'ADR',dataIndex:'adr',key:'adr',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"adr"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'RevPAR',dataIndex:'revpar',key:'revpar',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"revpar"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Room Revenue',dataIndex:'rev',key:'rev',width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"rev"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Room Revenue %',dataIndex:'revper',key:'revper',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"revper"};if(index==33)props.type='';return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Hotel Total Revenue',dataIndex:'total',key:'total',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"total"};if(index==33)props.type='';return _react2.default.createElement(_TableText2.default,{data:props});}}];var dataSource=[];if((0,_moment2.default)(date).format('M')==5||(0,_moment2.default)(date).format('M')==10){// 五一、十一
dataSource=data.slice(0,7);}else if(_compute.SPR[(0,_moment2.default)(date).format('Y')].m==(0,_moment2.default)(date).format('M')){// 春节
var _index=_compute.SPR[(0,_moment2.default)(date).format('Y')].d-1;dataSource=data.slice(_index,_index+7);}return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'table7_1_1 table7_6',id:'table4_2_2',style:{height:'auto'}},_react2.default.createElement(_row2.default,{className:'title'},_react2.default.createElement(_row2.default,null,'4.2.1.2 Golden Week or Public Holiday Booking Path report \u6CD5\u5B9A\u5C0F\u957F\u5047\u552E\u5356\u60C5\u51B5\u62A5\u8868'),_react2.default.createElement(_table2.default,{columns:columns,dataSource:dataSource,size:'middle',bordered:true,id:'table4_2_2_export',pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_button2.default,{type:'primary',style:{float:'right',marginTop:20},onClick:function onClick(){_this2.setState({print:true},function(){_this2.downloadExcel();});},loading:print},'\u5BFC\u51FAExcel')),_react2.default.createElement(_row2.default,{className:'title'},_react2.default.createElement('div',{className:'chart-4-2'},_react2.default.createElement('div',{id:'chartHolidayOcc'}),_react2.default.createElement('div',{id:'chartHolidayAdr'}),_react2.default.createElement('div',{id:'chartHolidayRevpar'}),_react2.default.createElement('div',{id:'chartHolidayRoomRev'})),_react2.default.createElement(_Auth2.default,{loading:loading,auth:'edit_4_2'},_react2.default.createElement(_row2.default,{className:'table-footer-btn',style:{display:print?'none':""}},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:print},'\u52A0\u5165pdf'))))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(8);__webpack_require__(14);__webpack_require__(4);__webpack_require__(10);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(1833);var _data2=_interopRequireDefault(_data);var _compute=__webpack_require__(1834);var _compute2=_interopRequireDefault(_compute);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().format('YYYY-MM-DD'),data:[],loading:true,loadingSave:false,print:false,last:[]},_this.computeNum=function(data){var _this$state=_this.state,date=_this$state.date,last=_this$state.last;data=(0,_compute2.default)(data,{date:date,last:last});_this.setState({data:data,loading:false});},_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var data,month,year,day,x;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_this.setState({loading:true});data=JSON.parse(JSON.stringify(_data2.default));month=(0,_moment2.default)(date).format('M');year=(0,_moment2.default)(date).format('YYYY');day=(0,_moment2.default)(date).format('D');_context.next=8;return(0,_request2.default)("/day4_2_2?year="+year+"&month="+month+"&day="+day);case 8:x=_context.sent;if(x.data.table&&x.data.table.length>0){data=x.data.table.sort(function(a,b){return a.sort-b.sort;});}data=(0,_compute.fillData)({data:data,date:date,e4_1_1:x.data.e4_1_1});_this.setState({last:x.data.last||[]},function(){_this.computeNum(data,true);});_context.next=18;break;case 14:_context.prev=14;_context.t0=_context["catch"](0);_this.setState({loading:false});console.error(_context.t0);case 18:case"end":return _context.stop();}}},_callee,_this2,[[0,14]]);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var date,_timer,year,month,day,data,dataFrom,headres,x,timer,_timer2;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_this.setState({loadingSave:true});date=_this.state.date;if(date){_context2.next=7;break;}_message3.default.error('请选择年份月份');_timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer);},1000);return _context2.abrupt("return");case 7:year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");day=(0,_moment2.default)(date).format("D");data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month,day:day,sort:i});});dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context2.next=16;return(0,_request2.default)('/saveDay4_2_2',headres);case 16:x=_context2.sent;timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(!(x.status==1)){_context2.next=22;break;}_message3.default.success(x.msg);if(!data[0].id){_this.getData(_this.state.date);}return _context2.abrupt("return");case 22:_message3.default.error(x.msg);_context2.next=30;break;case 25:_context2.prev=25;_context2.t0=_context2["catch"](0);_timer2=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer2);},1000);console.error(_context2.t0);_message3.default.error('保存失败'+JSON.stringify(_context2.t0));case 30:case"end":return _context2.stop();}}},_callee2,_this2,[[0,25]]);})),_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('view4_1_5',1.5,'4.22',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});},_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+" "+(0,_moment2.default)(_this.state.date).format('YYYY')+" 4.2.2 Daily Report by Segmentation";var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById('table4_1_5').innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+".xls");_this.setState({print:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print,loading=_state.loading;return _react2.default.createElement("div",{className:"table7_1_1 tableHeight"},_react2.default.createElement(_row2.default,{className:"title",id:"view4_1_5"},_react2.default.createElement(_row2.default,null,"4.2.2 Daily Report by Segmentation"),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(_datePicker2.default,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM-DD"),format:"YYYY-MM-DD",onChange:function onChange(date,str){_this3.setState({date:str,data:[]});_this3.getData(str);}})),_react2.default.createElement(_table2.default,{columns:(0,_compute.columns)(this.onChange,date,print),dataSource:data,size:"middle",id:"table4_1_5",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{x:4000},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:"table-footer-btn"},_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:print},"\u5BFC\u51FAExcel"),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:"edit_4_2_2"},_react2.default.createElement(_button2.default,{type:"primary",style:{margin:'0 10px'},onClick:this.downloadSG,loading:print},"\u52A0\u5165pdf"),_react2.default.createElement(_button2.default,{type:"primary",onClick:this.onSave,loading:this.state.loadingSave},"\u4FDD\u5B58"))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=[{"name":"最优价格","sort":0,"dayRn":0,"dayAbr":0,"dayAdr":0,"dayRev":0,"dayRevAbr":0,"monthRn":0,"monthAbr":0,"monthAdr":0,"monthRev":0,"monthRevAbr":0,"budgetRn":0,"budgetAbr":0,"budgetAdr":0,"budgetRev":0,"budgetRevAbr":0,"varRn":0,"varAdr":0,"varRev":0,"forecastRn":0,"forecastAbr":0,"forecastAdr":0,"forecastRev":0,"forecastRevAbr":0,"varForecastRn":0,"varForecastAdr":0,"varForecastRev":0,"lastRn":0,"lastAbr":0,"lastAdr":0,"lastRev":0,"lastRevAbr":0,"varLastRn":0,"varLastAdr":0,"varLastRev":0,"code":"最优价格"},{"name":"商务协议散客","sort":1,"dayRn":0,"dayAbr":0,"dayAdr":0,"dayRev":0,"dayRevAbr":0,"monthRn":0,"monthAbr":0,"monthAdr":0,"monthRev":0,"monthRevAbr":0,"budgetRn":0,"budgetAbr":0,"budgetAdr":0,"budgetRev":0,"budgetRevAbr":0,"varRn":0,"varAdr":0,"varRev":0,"forecastRn":0,"forecastAbr":0,"forecastAdr":0,"forecastRev":0,"forecastRevAbr":0,"varForecastRn":0,"varForecastAdr":0,"varForecastRev":0,"lastRn":0,"lastAbr":0,"lastAdr":0,"lastRev":0,"lastRevAbr":0,"varLastRn":0,"varLastAdr":0,"varLastRev":0,"code":"商务协议散客"},{"name":"政府协议散客","sort":2,"dayRn":0,"dayAbr":0,"dayAdr":0,"dayRev":0,"dayRevAbr":0,"monthRn":0,"monthAbr":0,"monthAdr":0,"monthRev":0,"monthRevAbr":0,"budgetRn":0,"budgetAbr":0,"budgetAdr":0,"budgetRev":0,"budgetRevAbr":0,"varRn":0,"varAdr":0,"varRev":0,"forecastRn":0,"forecastAbr":0,"forecastAdr":0,"forecastRev":0,"forecastRevAbr":0,"varForecastRn":0,"varForecastAdr":0,"varForecastRev":0,"lastRn":0,"lastAbr":0,"lastAdr":0,"lastRev":0,"lastRevAbr":0,"varLastRn":0,"varLastAdr":0,"varLastRev":0,"code":"政府协议散客"},{"name":"套餐","sort":3,"dayRn":0,"dayAbr":0,"dayAdr":0,"dayRev":0,"dayRevAbr":0,"monthRn":0,"monthAbr":0,"monthAdr":0,"monthRev":0,"monthRevAbr":0,"budgetRn":0,"budgetAbr":0,"budgetAdr":0,"budgetRev":0,"budgetRevAbr":0,"varRn":0,"varAdr":0,"varRev":0,"forecastRn":0,"forecastAbr":0,"forecastAdr":0,"forecastRev":0,"forecastRevAbr":0,"varForecastRn":0,"varForecastAdr":0,"varForecastRev":0,"lastRn":0,"lastAbr":0,"lastAdr":0,"lastRev":0,"lastRevAbr":0,"varLastRn":0,"varLastAdr":0,"varLastRev":0,"code":"套餐"},{"name":"旅行社","sort":4,"dayRn":0,"dayAbr":0,"dayAdr":0,"dayRev":0,"dayRevAbr":0,"monthRn":0,"monthAbr":0,"monthAdr":0,"monthRev":0,"monthRevAbr":0,"budgetRn":0,"budgetAbr":0,"budgetAdr":0,"budgetRev":0,"budgetRevAbr":0,"varRn":0,"varAdr":0,"varRev":0,"forecastRn":0,"forecastAbr":0,"forecastAdr":0,"forecastRev":0,"forecastRevAbr":0,"varForecastRn":0,"varForecastAdr":0,"varForecastRev":0,"lastRn":0,"lastAbr":0,"lastAdr":0,"lastRev":0,"lastRevAbr":0,"varLastRn":0,"varLastAdr":0,"varLastRev":0,"code":"旅行社"},{"name":"电子商务","sort":5,"dayRn":0,"dayAbr":0,"dayAdr":0,"dayRev":0,"dayRevAbr":0,"monthRn":0,"monthAbr":0,"monthAdr":0,"monthRev":0,"monthRevAbr":0,"budgetRn":0,"budgetAbr":0,"budgetAdr":0,"budgetRev":0,"budgetRevAbr":0,"varRn":0,"varAdr":0,"varRev":0,"forecastRn":0,"forecastAbr":0,"forecastAdr":0,"forecastRev":0,"forecastRevAbr":0,"varForecastRn":0,"varForecastAdr":0,"varForecastRev":0,"lastRn":0,"lastAbr":0,"lastAdr":0,"lastRev":0,"lastRevAbr":0,"varLastRn":0,"varLastAdr":0,"varLastRev":0,"code":"电子商务"},{"name":"折扣价","sort":6,"dayRn":0,"dayAbr":0,"dayAdr":0,"dayRev":0,"dayRevAbr":0,"monthRn":0,"monthAbr":0,"monthAdr":0,"monthRev":0,"monthRevAbr":0,"budgetRn":0,"budgetAbr":0,"budgetAdr":0,"budgetRev":0,"budgetRevAbr":0,"varRn":0,"varAdr":0,"varRev":0,"forecastRn":0,"forecastAbr":0,"forecastAdr":0,"forecastRev":0,"forecastRevAbr":0,"varForecastRn":0,"varForecastAdr":0,"varForecastRev":0,"lastRn":0,"lastAbr":0,"lastAdr":0,"lastRev":0,"lastRevAbr":0,"varLastRn":0,"varLastAdr":0,"varLastRev":0,"code":"折扣价"},{"name":"散客总计","sort":7,"dayRn":0,"dayAbr":0,"dayAdr":0,"dayRev":0,"dayRevAbr":0,"monthRn":0,"monthAbr":0,"monthAdr":0,"monthRev":0,"monthRevAbr":0,"budgetRn":0,"budgetAbr":0,"budgetAdr":0,"budgetRev":0,"budgetRevAbr":0,"varRn":0,"varAdr":0,"varRev":0,"forecastRn":0,"forecastAbr":0,"forecastAdr":0,"forecastRev":0,"forecastRevAbr":0,"varForecastRn":0,"varForecastAdr":0,"varForecastRev":0,"lastRn":0,"lastAbr":0,"lastAdr":0,"lastRev":0,"lastRevAbr":0,"varLastRn":0,"varLastAdr":0,"varLastRev":0,"code":"散客总计"},{"name":"公司团","sort":8,"dayRn":0,"dayAbr":0,"dayAdr":0,"dayRev":0,"dayRevAbr":0,"monthRn":0,"monthAbr":0,"monthAdr":0,"monthRev":0,"monthRevAbr":0,"budgetRn":0,"budgetAbr":0,"budgetAdr":0,"budgetRev":0,"budgetRevAbr":0,"varRn":0,"varAdr":0,"varRev":0,"forecastRn":0,"forecastAbr":0,"forecastAdr":0,"forecastRev":0,"forecastRevAbr":0,"varForecastRn":0,"varForecastAdr":0,"varForecastRev":0,"lastRn":0,"lastAbr":0,"lastAdr":0,"lastRev":0,"lastRevAbr":0,"varLastRn":0,"varLastAdr":0,"varLastRev":0,"code":"公司团"},{"name":"旅行团","sort":9,"dayRn":0,"dayAbr":0,"dayAdr":0,"dayRev":0,"dayRevAbr":0,"monthRn":0,"monthAbr":0,"monthAdr":0,"monthRev":0,"monthRevAbr":0,"budgetRn":0,"budgetAbr":0,"budgetAdr":0,"budgetRev":0,"budgetRevAbr":0,"varRn":0,"varAdr":0,"varRev":0,"forecastRn":0,"forecastAbr":0,"forecastAdr":0,"forecastRev":0,"forecastRevAbr":0,"varForecastRn":0,"varForecastAdr":0,"varForecastRev":0,"lastRn":0,"lastAbr":0,"lastAdr":0,"lastRev":0,"lastRevAbr":0,"varLastRn":0,"varLastAdr":0,"varLastRev":0,"code":"旅行团"},{"name":"团队总计","sort":10,"dayRn":0,"dayAbr":0,"dayAdr":0,"dayRev":0,"dayRevAbr":0,"monthRn":0,"monthAbr":0,"monthAdr":0,"monthRev":0,"monthRevAbr":0,"budgetRn":0,"budgetAbr":0,"budgetAdr":0,"budgetRev":0,"budgetRevAbr":0,"varRn":0,"varAdr":0,"varRev":0,"forecastRn":0,"forecastAbr":0,"forecastAdr":0,"forecastRev":0,"forecastRevAbr":0,"varForecastRn":0,"varForecastAdr":0,"varForecastRev":0,"lastRn":0,"lastAbr":0,"lastAdr":0,"lastRev":0,"lastRevAbr":0,"varLastRn":0,"varLastAdr":0,"varLastRev":0,"code":"团队总计"},{"name":"合同","sort":11,"dayRn":0,"dayAbr":0,"dayAdr":0,"dayRev":0,"dayRevAbr":0,"monthRn":0,"monthAbr":0,"monthAdr":0,"monthRev":0,"monthRevAbr":0,"budgetRn":0,"budgetAbr":0,"budgetAdr":0,"budgetRev":0,"budgetRevAbr":0,"varRn":0,"varAdr":0,"varRev":0,"forecastRn":0,"forecastAbr":0,"forecastAdr":0,"forecastRev":0,"forecastRevAbr":0,"varForecastRn":0,"varForecastAdr":0,"varForecastRev":0,"lastRn":0,"lastAbr":0,"lastAdr":0,"lastRev":0,"lastRevAbr":0,"varLastRn":0,"varLastAdr":0,"varLastRev":0,"code":"合同"},{"name":"其他","sort":12,"dayRn":0,"dayAbr":0,"dayAdr":0,"dayRev":0,"dayRevAbr":0,"monthRn":0,"monthAbr":0,"monthAdr":0,"monthRev":0,"monthRevAbr":0,"budgetRn":0,"budgetAbr":0,"budgetAdr":0,"budgetRev":0,"budgetRevAbr":0,"varRn":0,"varAdr":0,"varRev":0,"forecastRn":0,"forecastAbr":0,"forecastAdr":0,"forecastRev":0,"forecastRevAbr":0,"varForecastRn":0,"varForecastAdr":0,"varForecastRev":0,"lastRn":0,"lastAbr":0,"lastAdr":0,"lastRev":0,"lastRevAbr":0,"varLastRn":0,"varLastAdr":0,"varLastRev":0,"code":"其他"},{"name":"其他总计","sort":13,"dayRn":0,"dayAbr":0,"dayAdr":0,"dayRev":0,"dayRevAbr":0,"monthRn":0,"monthAbr":0,"monthAdr":0,"monthRev":0,"monthRevAbr":0,"budgetRn":0,"budgetAbr":0,"budgetAdr":0,"budgetRev":0,"budgetRevAbr":0,"varRn":0,"varAdr":0,"varRev":0,"forecastRn":0,"forecastAbr":0,"forecastAdr":0,"forecastRev":0,"forecastRevAbr":0,"varForecastRn":0,"varForecastAdr":0,"varForecastRev":0,"lastRn":0,"lastAbr":0,"lastAdr":0,"lastRev":0,"lastRevAbr":0,"varLastRn":0,"varLastAdr":0,"varLastRev":0,"code":"其他总计"},{"name":"总计","sort":14,"dayRn":0,"dayAbr":0,"dayAdr":0,"dayRev":0,"dayRevAbr":0,"monthRn":0,"monthAbr":0,"monthAdr":0,"monthRev":0,"monthRevAbr":0,"budgetRn":0,"budgetAbr":0,"budgetAdr":0,"budgetRev":0,"budgetRevAbr":0,"varRn":0,"varAdr":0,"varRev":0,"forecastRn":0,"forecastAbr":0,"forecastAdr":0,"forecastRev":0,"forecastRevAbr":0,"varForecastRn":0,"varForecastAdr":0,"varForecastRev":0,"lastRn":0,"lastAbr":0,"lastAdr":0,"lastRev":0,"lastRevAbr":0,"varLastRn":0,"varLastAdr":0,"varLastRev":0,"code":"总计"}];

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columns=exports.fillData=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var totalIndex=[7,10,13,14];exports.default=function(data,_ref){var date=_ref.date,last=_ref.last;var lastIndex=data.length-1;// 计算总计数据
data.forEach(function(item,i){['dayRn','dayRev'].forEach(function(name){data[7][name]=data.reduce(function(a,b,index){return index<7?a+(0,_method.numConvert)(b[name]):a;},0).toFixed(2);data[10][name]=(0,_method.sum)([data[8][name],data[9][name]]);data[13][name]=(0,_method.sum)([data[11][name],data[12][name]]);data[14][name]=(0,_method.sum)([data[7][name],data[10][name],data[13][name]]);});});// 计算当月MTD，利用昨日MTD加上今日数据
['Rn','Rev'].forEach(function(name){data.forEach(function(item,i){data[i]["month"+name]=(0,_method.sum)([_lodash2.default.get(last,i+".month"+name),_lodash2.default.get(data,i+".day"+name)]);});});// 计算占比、平均房价、房价占比
var listName=['day','month','budget','forecast','last'];listName.forEach(function(name){data.forEach(function(item,i){// 间夜占比
data[i][name+"Abr"]=(0,_method.calculation)(data[i][name+"Rn"],data[lastIndex][name+"Rn"],4);// 平均房价
data[i][name+"Adr"]=(0,_method.calculation)(data[i][name+"Rev"],data[i][name+"Rn"]);// 收益占比
data[i][name+"RevAbr"]=(0,_method.calculation)(data[i][name+"Rev"],data[lastIndex][name+"Rev"],4);});});// vs 对比数据
data.forEach(function(item,i){// 当月MTD VS 当月Budget % Variance
data[i].varRn=(0,_method.calculation)(data[i].monthRn-data[i].budgetRn,data[i].budgetRn,4);data[i].varAdr=(0,_method.calculation)(data[i].monthAdr-data[i].budgetAdr,data[i].budgetAdr,4);data[i].varRev=(0,_method.calculation)(data[i].monthRev-data[i].budgetRev,data[i].budgetRev,4);// 当月MTD VS 当月Forecast % Variance
data[i].varForecastRn=(0,_method.calculation)(data[i].monthRn-data[i].forecastRn,data[i].forecastRn,4);data[i].varForecastAdr=(0,_method.calculation)(data[i].monthAdr-data[i].forecastAdr,data[i].forecastAdr,4);data[i].varForecastRev=(0,_method.calculation)(data[i].monthRev-data[i].forecastRev,data[i].forecastRev,4);// 当月MTD VS 去年当月Actual % Variance
data[i].varLastRn=(0,_method.calculation)(data[i].monthRn-data[i].lastRn,data[i].lastRn,4);data[i].varLastAdr=(0,_method.calculation)(data[i].monthAdr-data[i].lastAdr,data[i].lastAdr,4);data[i].varLastRev=(0,_method.calculation)(data[i].monthRev-data[i].lastRev,data[i].lastRev,4);});return data;};var fillData=exports.fillData=function fillData(_ref2){var data=_ref2.data,e4_1_1=_ref2.e4_1_1,date=_ref2.date;var month=(0,_moment2.default)(date).format('M');var _index=(month-1)*3;var listName={'best':0,'corporate':1,'government':2,'packges':3,'wholesale':4,'commerce':5,'discounts':6,'total':7,'business':8,'leisure':9,'group_total':10,"contracts":11,'others':12,'grand':14};Object.keys(listName).forEach(function(name){// 例如 当前9.2 获取4.1.1 八月数据 sep的三行数据
// 从4.1.1 获取Budget 对应月份的数据填充
data[listName[name]].budgetRn=_lodash2.default.get(e4_1_1,_index+"."+name+"_rn",0);data[listName[name]].budgetRev=_lodash2.default.get(e4_1_1,_index+"."+name+"_rev",0);// 预测
data[listName[name]].forecastRn=_lodash2.default.get(e4_1_1,_index+1+"."+name+"_rn",0);data[listName[name]].forecastRev=_lodash2.default.get(e4_1_1,_index+1+"."+name+"_rev",0);// 去年
data[listName[name]].lastRn=_lodash2.default.get(e4_1_1,_index+2+"."+name+"_rn",0);data[listName[name]].lastRev=_lodash2.default.get(e4_1_1,_index+2+"."+name+"_rev",0);});return data;};var columns=exports.columns=function columns(onChange,date,print){return[{title:"\u7EC6\u5206\u5E02\u573A",dataIndex:'name',key:'name',align:"center",width:200,fixed:print?false:"left",render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5F53\u65E5Actual",width:750,children:[{title:"\u95F4\u591C",dataIndex:'dayRn',key:'dayRn',align:"center",width:150,render:function render(text,record,index){var title=['当日Actual','间夜'];var props={text:text,index:index,type:!totalIndex.includes(index)&&!print?'inputNumber':'number',name:"dayRn",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5360\u6BD4",dataIndex:'dayAbr',key:'dayAbr',align:"center",width:150,render:function render(text,record,index){var title=['当日Actual','占比'];var props={text:text,index:index,type:'percent',name:"dayAbr",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5E73\u5747\u623F\u4EF7",dataIndex:'dayAdr',key:'dayAdr',align:"center",width:150,render:function render(text,record,index){var title=['当日Actual','平均房价'];var props={text:text,index:index,type:'number',name:"dayAdr",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5BA2\u623F\u6536\u76CA",dataIndex:'dayRev',key:'dayRev',align:"center",width:150,render:function render(text,record,index){var title=['当日Actual','客房收益'];var props={text:text,index:index,type:!totalIndex.includes(index)&&!print?'inputNumber':'number',name:"dayRev",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5360\u6BD4",dataIndex:'dayRevAbr',key:'dayRevAbr',align:"center",width:150,render:function render(text,record,index){var title=['当日Actual','占比'];var props={text:text,index:index,type:'percent',name:"dayRevAbr",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"\u5F53\u6708MTD",width:750,children:[{title:"\u95F4\u591C",dataIndex:'monthRn',key:'monthRn',align:"center",width:150,render:function render(text,record,index){var title=['当月MTD','间夜'];var props={text:text,index:index,type:'number',name:"monthRn",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5360\u6BD4",dataIndex:'monthAbr',key:'monthAbr',align:"center",width:150,render:function render(text,record,index){var title=['当月MTD','占比'];var props={text:text,index:index,type:'percent',name:"monthAbr",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5E73\u5747\u623F\u4EF7",dataIndex:'monthAdr',key:'monthAdr',align:"center",width:150,render:function render(text,record,index){var title=['当月MTD','平均房价'];var props={text:text,index:index,type:'number',name:"monthAdr",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5BA2\u623F\u6536\u76CA",dataIndex:'monthRev',key:'monthRev',align:"center",width:150,render:function render(text,record,index){var title=['当月MTD','客房收益'];var props={text:text,index:index,type:'number',name:"monthRev",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5360\u6BD4",dataIndex:'monthRevAbr',key:'monthRevAbr',align:"center",width:150,render:function render(text,record,index){var title=['当月MTD','占比'];var props={text:text,index:index,type:'percent',name:"monthRevAbr",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"\u5F53\u6708Budget",width:750,children:[{title:"\u95F4\u591C",dataIndex:'budgetRn',key:'budgetRn',align:"center",width:150,render:function render(text,record,index){var title=['当月Budget','间夜'];var props={text:text,index:index,type:'number',name:"budgetRn",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5360\u6BD4",dataIndex:'budgetAbr',key:'budgetAbr',align:"center",width:150,render:function render(text,record,index){var title=['当月Budget','占比'];var props={text:text,index:index,type:'percent',name:"budgetAbr",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5E73\u5747\u623F\u4EF7",dataIndex:'budgetAdr',key:'budgetAdr',align:"center",width:150,render:function render(text,record,index){var title=['当月Budget','平均房价'];var props={text:text,index:index,type:'number',name:"budgetAdr",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5BA2\u623F\u6536\u76CA",dataIndex:'budgetRev',key:'budgetRev',align:"center",width:150,render:function render(text,record,index){var title=['当月Budget','客房收益'];var props={text:text,index:index,type:'number',name:"budgetRev",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5360\u6BD4",dataIndex:'budgetRevAbr',key:'budgetRevAbr',align:"center",width:150,render:function render(text,record,index){var title=['当月Budget','占比'];var props={text:text,index:index,type:'percent',name:"budgetRevAbr",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"\u5F53\u6708MTD VS \u5F53\u6708Budget % Variance",width:450,children:[{title:"\u95F4\u591C%",dataIndex:'varRn',key:'varRn',align:"center",width:150,render:function render(text,record,index){var title=['当月MTD VS 当月Budget % Variance','间夜%'];var props={text:text,index:index,type:'percent',name:"varRn",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5E73\u5747\u623F\u4EF7%",dataIndex:'varAdr',key:'varAdr',align:"center",width:150,render:function render(text,record,index){var title=['当月MTD VS 当月Budget % Variance','平均房价%'];var props={text:text,index:index,type:'percent',name:"varAdr",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5BA2\u623F\u6536\u76CA%",dataIndex:'varRev',key:'varRev',align:"center",width:150,render:function render(text,record,index){var title=['当月MTD VS 当月Budget % Variance','客房收益%'];var props={text:text,index:index,type:'number',name:"varRev",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"\u5F53\u6708Forecast",width:750,children:[{title:"\u95F4\u591C",dataIndex:'forecastRn',key:'forecastRn',align:"center",width:150,render:function render(text,record,index){var title=['当月Forecast','间夜'];var props={text:text,index:index,type:'number',name:"forecastRn",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5360\u6BD4",dataIndex:'forecastAbr',key:'forecastAbr',align:"center",width:150,render:function render(text,record,index){var title=['当月Forecast','占比'];var props={text:text,index:index,type:'percent',name:"forecastAbr",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5E73\u5747\u623F\u4EF7",dataIndex:'forecastAdr',key:'forecastAdr',align:"center",width:150,render:function render(text,record,index){var title=['当月Forecast','平均房价'];var props={text:text,index:index,type:'number',name:"forecastAdr",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5BA2\u623F\u6536\u76CA",dataIndex:'forecastRev',key:'forecastRev',align:"center",width:150,render:function render(text,record,index){var title=['当月Forecast','客房收益'];var props={text:text,index:index,type:'number',name:"forecastRev",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5360\u6BD4",dataIndex:'forecastRevAbr',key:'forecastRevAbr',align:"center",width:150,render:function render(text,record,index){var title=['当月Forecast','占比'];var props={text:text,index:index,type:'percent',name:"forecastRevAbr",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"\u5F53\u6708MTD VS \u5F53\u6708Forecast % Variance",width:450,children:[{title:"\u95F4\u591C%",dataIndex:'varForecastRn',key:'varForecastRn',align:"center",width:150,render:function render(text,record,index){var title=['当月MTD VS 当月Forecast % Variance','间夜%'];var props={text:text,index:index,type:'percent',name:"varForecastRn",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5E73\u5747\u623F\u4EF7%",dataIndex:'varForecastAdr',key:'varForecastAdr',align:"center",width:150,render:function render(text,record,index){var title=['当月MTD VS 当月Forecast % Variance','平均房价%'];var props={text:text,index:index,type:'percent',name:"varForecastAdr",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5BA2\u623F\u6536\u76CA%",dataIndex:'varForecastRev',key:'varForecastRev',align:"center",width:150,render:function render(text,record,index){var title=['当月MTD VS 当月Forecast % Variance','客房收益%'];var props={text:text,index:index,type:'number',name:"varForecastRev",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"\u53BB\u5E74\u5F53\u6708Actual",width:750,children:[{title:"\u95F4\u591C",dataIndex:'lastRn',key:'lastRn',align:"center",width:150,render:function render(text,record,index){var title=['去年当月Actual','间夜'];var props={text:text,index:index,type:'number',name:"lastRn",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5360\u6BD4",dataIndex:'lastAbr',key:'lastAbr',align:"center",width:150,render:function render(text,record,index){var title=['去年当月Actual','占比'];var props={text:text,index:index,type:'percent',name:"lastAbr",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5E73\u5747\u623F\u4EF7",dataIndex:'lastAdr',key:'lastAdr',align:"center",width:150,render:function render(text,record,index){var title=['去年当月Actual','平均房价'];var props={text:text,index:index,type:'number',name:"lastAdr",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5BA2\u623F\u6536\u76CA",dataIndex:'lastRev',key:'lastRev',align:"center",width:150,render:function render(text,record,index){var title=['去年当月Actual','客房收益'];var props={text:text,index:index,type:'number',name:"lastRev",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5360\u6BD4",dataIndex:'lastRevAbr',key:'lastRevAbr',align:"center",width:150,render:function render(text,record,index){var title=['去年当月Actual','占比'];var props={text:text,index:index,type:'percent',name:"lastRevAbr",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"\u5F53\u6708MTD VS \u53BB\u5E74\u5F53\u6708Actual % Variance",width:450,children:[{title:"\u95F4\u591C%",dataIndex:'varLastRn',key:'varLastRn',align:"center",width:150,render:function render(text,record,index){var title=['当月MTD VS 去年当月Actual % Variance','间夜%'];var props={text:text,index:index,type:'percent',name:"varLastRn",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5E73\u5747\u623F\u4EF7%",dataIndex:'varLastAdr',key:'varLastAdr',align:"center",width:150,render:function render(text,record,index){var title=['当月MTD VS 去年当月Actual % Variance','平均房价%'];var props={text:text,index:index,type:'percent',name:"varLastAdr",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5BA2\u623F\u6536\u76CA%",dataIndex:'varLastRev',key:'varLastRev',align:"center",width:150,render:function render(text,record,index){var title=['当月MTD VS 去年当月Actual % Variance','客房收益%'];var props={text:text,index:index,type:'number',name:"varLastRev",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_2_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}}]}];};

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(8);__webpack_require__(14);__webpack_require__(4);__webpack_require__(10);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(1836);var _data2=_interopRequireDefault(_data);var _compute=__webpack_require__(1837);var _compute2=_interopRequireDefault(_compute);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _method=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().format('YYYY-MM-DD'),data:[],loading:true,loadingSave:false,print:false,last:[],data4_1_1:[]},_this.computeNum=function(data){var _this$state=_this.state,date=_this$state.date,last=_this$state.last,data4_1_1=_this$state.data4_1_1;data=(0,_compute2.default)(data,{date:date,last:last,data4_1_1:data4_1_1});_this.setState({data:data,loading:false});},_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var data,month,year,day,x,_listName,isFirstDay,_index,_listNameRev;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_this.setState({loading:true});data=JSON.parse(JSON.stringify(_data2.default));month=(0,_moment2.default)(date).format('M');year=(0,_moment2.default)(date).format('YYYY');day=(0,_moment2.default)(date).format('D');_context.next=8;return(0,_request2.default)("/day4_2_3?year="+year+"&month="+month+"&day="+day);case 8:x=_context.sent;if(x.data.table&&x.data.table.length>0){data=x.data.table.sort(function(a,b){return a.sort-b.sort;});}// 填充4.1.1数据至表格
_listName=['best_rn','packges_rn','wholesale_rn','commerce_rn','discounts_rn'];isFirstDay=(0,_moment2.default)(date).format('D')==1;if(isFirstDay){_index=((0,_moment2.default)(date).format('M')-1)*3;// 商务散客
data[1].budget=(0,_method.sum)(_listName.map(function(_x){return _lodash2.default.get(x.data.data4_1_1,_index+"."+_x,0);}));data[1].forecast=(0,_method.sum)(_listName.map(function(_x){return _lodash2.default.get(x.data.data4_1_1,_index+1+"."+_x,0);}));data[1].last=(0,_method.sum)(_listName.map(function(_x){return _lodash2.default.get(x.data.data4_1_1,_index+2+"."+_x,0);}));// 休闲散客
data[2].budget=(0,_method.sum)(['corporate_rn','government_rn'].map(function(_x){return _lodash2.default.get(x.data.data4_1_1,_index+"."+_x,0);}));data[2].forecast=(0,_method.sum)(['corporate_rn','government_rn'].map(function(_x){return _lodash2.default.get(x.data.data4_1_1,_index+1+"."+_x,0);}));data[2].last=(0,_method.sum)(['corporate_rn','government_rn'].map(function(_x){return _lodash2.default.get(x.data.data4_1_1,_index+2+"."+_x,0);}));// 商务团
data[3].budget=_lodash2.default.get(x.data.data4_1_1,_index+".business_rn",0);data[3].forecast=_lodash2.default.get(x.data.data4_1_1,_index+1+".business_rn",0);data[3].last=_lodash2.default.get(x.data.data4_1_1,_index+2+".business_rn",0);// 休闲团
data[4].budget=_lodash2.default.get(x.data.data4_1_1,_index+".leisure_rn",0);data[4].forecast=_lodash2.default.get(x.data.data4_1_1,_index+1+".leisure_rn",0);data[4].last=_lodash2.default.get(x.data.data4_1_1,_index+2+".leisure_rn",0);// 免费房
data[9].budget=_lodash2.default.get(x.data.data4_1_1,_index+".grand_rms",0);data[9].forecast=_lodash2.default.get(x.data.data4_1_1,_index+1+".grand_rms",0);data[9].last=_lodash2.default.get(x.data.data4_1_1,_index+2+".grand_rms",0);// 收益
_listNameRev=['best_rev','packges_rev','wholesale_rev','commerce_rev','discounts_rev'];// 商务散客收益
data[32].budget=(0,_method.sum)(_listNameRev.map(function(_x){return _lodash2.default.get(x.data.data4_1_1,_index+"."+_x,0);}));data[32].forecast=(0,_method.sum)(_listNameRev.map(function(_x){return _lodash2.default.get(x.data.data4_1_1,_index+1+"."+_x,0);}));data[32].last=(0,_method.sum)(_listNameRev.map(function(_x){return _lodash2.default.get(x.data.data4_1_1,_index+2+"."+_x,0);}));// 休闲散客
data[33].budget=(0,_method.sum)(['corporate_rev','government_rev'].map(function(_x){return _lodash2.default.get(x.data.data4_1_1,_index+"."+_x,0);}));data[33].forecast=(0,_method.sum)(['corporate_rev','government_rev'].map(function(_x){return _lodash2.default.get(x.data.data4_1_1,_index+1+"."+_x,0);}));data[33].last=(0,_method.sum)(['corporate_rev','government_rev'].map(function(_x){return _lodash2.default.get(x.data.data4_1_1,_index+2+"."+_x,0);}));// 商务团
data[34].budget=_lodash2.default.get(x.data.data4_1_1,_index+".business_rev",0);data[34].forecast=_lodash2.default.get(x.data.data4_1_1,_index+1+".business_rev",0);data[34].last=_lodash2.default.get(x.data.data4_1_1,_index+2+".business_rev",0);// 休闲团
data[35].budget=_lodash2.default.get(x.data.data4_1_1,_index+".leisure_rev",0);data[35].forecast=_lodash2.default.get(x.data.data4_1_1,_index+1+".leisure_rev",0);data[35].last=_lodash2.default.get(x.data.data4_1_1,_index+2+".leisure_rev",0);}// 如果非当月第一天，填充预算、预测、去年数据
if(x.data.last&&x.data.last.length>0&&day!=1){data.forEach(function(item,i){data[i].budget=_lodash2.default.get(x,"data.last."+i+".budget",0);data[i].forecast=_lodash2.default.get(x,"data.last."+i+".forecast",0);data[i].last=_lodash2.default.get(x,"data.last."+i+".last",0);});}_this.setState({last:x.data.last||[],data4_1_1:x.data.data4_1_1||[]},function(){_this.computeNum(data,true);});_context.next=21;break;case 17:_context.prev=17;_context.t0=_context["catch"](0);_this.setState({loading:false});console.error(_context.t0);case 21:case"end":return _context.stop();}}},_callee,_this2,[[0,17]]);}));return function(_x2){return _ref2.apply(this,arguments);};}(),_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var date,_timer,year,month,day,data,dataFrom,headres,x,timer,_timer2;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_this.setState({loadingSave:true});date=_this.state.date;if(date){_context2.next=7;break;}_message3.default.error('请选择年份月份');_timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer);},1000);return _context2.abrupt("return");case 7:year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");day=(0,_moment2.default)(date).format("D");data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month,day:day,sort:i});});dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context2.next=16;return(0,_request2.default)('/saveDay4_2_3',headres);case 16:x=_context2.sent;timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(!(x.status==1)){_context2.next=22;break;}_message3.default.success(x.msg);if(!data[0].id){_this.getData(_this.state.date);}return _context2.abrupt("return");case 22:_message3.default.error(x.msg);_context2.next=30;break;case 25:_context2.prev=25;_context2.t0=_context2["catch"](0);_timer2=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer2);},1000);console.error(_context2.t0);_message3.default.error('保存失败'+JSON.stringify(_context2.t0));case 30:case"end":return _context2.stop();}}},_callee2,_this2,[[0,25]]);})),_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('view4_1_5',1.5,'4.23',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});},_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+" "+(0,_moment2.default)(_this.state.date).format('YYYY')+" 4.2.3 Early Bird Report";var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById('table4_1_5').innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+".xls");_this.setState({print:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print,loading=_state.loading;console.log(data);return _react2.default.createElement("div",{className:"table7_1_1 tableHeight"},_react2.default.createElement(_row2.default,{className:"title",id:"view4_1_5"},_react2.default.createElement(_row2.default,null,"4.2.3 Early Bird Report"),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(_datePicker2.default,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM-DD"),format:"YYYY-MM-DD",onChange:function onChange(date,str){_this3.setState({date:str,data:[]});_this3.getData(str);}})),_react2.default.createElement(_table2.default,{columns:(0,_compute.columns)(this.onChange,date,print),dataSource:data,size:"middle",id:"table4_1_5",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{y:600},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:"table-footer-btn"},_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:print},"\u5BFC\u51FAExcel"),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:"edit_4_2_3"},_react2.default.createElement(_button2.default,{type:"primary",style:{margin:'0 10px'},onClick:this.downloadSG,loading:print},"\u52A0\u5165pdf"),_react2.default.createElement(_button2.default,{type:"primary",onClick:this.onSave,loading:this.state.loadingSave},"\u4FDD\u5B58"))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=[{"name":"客房统计数字-间夜数","code":"客房统计数字","sort":0,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"商务散客","code":"商务散客","sort":1,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"休闲散客","code":"休闲散客","sort":2,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"商务团","code":"商务团","sort":3,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"休闲团","code":"休闲团","sort":4,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"其他","code":"其他","sort":5,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"免费房","code":"免费房","sort":6,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"已售房合计（不含免费房）","code":"不含免费房","sort":7,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"已售房合计（包含免费房）","code":"含免费房","sort":8,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"房间总计","code":"房间总计","sort":9,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"自用房","code":"自用房10","sort":10,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"坏房（六个月以上）","code":"坏房11","sort":11,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"可售房（剔除自用房和六个月以上的坏房）","code":"可售房12","sort":12,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"客人数","code":"客人数13","sort":13,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"住房率","code":"住房率14","sort":14,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"商务散客","code":"商务散客15","sort":15,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"休闲散客","code":"休闲散客16","sort":16,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"商务团","code":"商务团17","sort":17,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"休闲团","code":"休闲团18","sort":18,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"其他","sort":19,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"免费房","sort":20,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"住房率","sort":21,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"平均房价","sort":22,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"商务散客","sort":23,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"休闲散客","sort":24,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"商务团","sort":25,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"休闲团","sort":26,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"其他","sort":27,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"免费房","sort":28,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"已售房平均房价","sort":29,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"平均每房收入","sort":30,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"客房收益","sort":31,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"商务散客","sort":32,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"休闲散客","sort":33,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"商务团","sort":34,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"休闲团","sort":35,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"其他","sort":36,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"免费房","sort":37,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0},{"name":"客房收入合计","sort":38,"actual":0,"mtd":0,"budget":0,"budgetDiff":0,"forecast":0,"forecastDiff":0,"last":0,"lastDiff":0}];

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columns=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var totalIndex=[0,14,22,31];var TOTALINDEX=[0,14,22,31,7,21,8,29,30,38];var inputIndex=[1,2,3,4,5,6,9,10,11,13,32,33,34,35,36,37];var percenIndex=[15,16,17,18,19,20,21];exports.default=function(data,_ref){var date=_ref.date,data4_1_1=_ref.data4_1_1,last=_ref.last;// 累加mtd数据
data.forEach(function(item,i){data[i].mtd=(0,_method.sum)([_lodash2.default.get(last,i+".mtd",0),item.actual]);});var totalNames=['actual','mtd','budget','forecast','last'];// 计算合计数据
totalNames.forEach(function(name){data[7][name]=(0,_method.sum)([data[1][name],data[2][name],data[3][name],data[4][name],data[5][name]]);data[8][name]=(0,_method.sum)([data[6][name],data[7][name]]);data[12][name]=~~(data[9][name]-data[10][name]-data[11][name]);data[15][name]=(0,_method.calculation)(data[1][name],data[12][name],4);data[16][name]=(0,_method.calculation)(data[2][name],data[12][name],4);data[17][name]=(0,_method.calculation)(data[3][name],data[12][name],4);data[18][name]=(0,_method.calculation)(data[4][name],data[12][name],4);data[19][name]=(0,_method.calculation)(data[5][name],data[12][name],4);data[20][name]=(0,_method.calculation)(data[6][name],data[12][name],4);data[21][name]=(0,_method.calculation)(data[8][name],data[12][name],4);data[23][name]=(0,_method.calculation)(data[32][name],(0,_method.sum)([data[1][name],data[6][name]]));data[24][name]=(0,_method.calculation)(data[33][name],data[2][name]);data[25][name]=(0,_method.calculation)(data[34][name],data[3][name]);data[26][name]=(0,_method.calculation)(data[35][name],data[4][name]);console.log(data[32][name],(0,_method.sum)([data[1][name]],data[6][name]));// 客房收入合计
data[38][name]=(0,_method.sum)([data[32][name],data[33][name],data[35][name],data[36][name],data[37][name],data[34][name]]);data[29][name]=(0,_method.calculation)(data[38][name],data[8][name]);data[30][name]=((0,_method.numConvert)(data[29][name])*(0,_method.numConvert)(data[21][name])).toFixed(2);});// 计算差异
data.forEach(function(item,i){if([15,16,17,18,19,20,21].includes(i)){data[i].budgetDiff=(item.mtd-item.budget).toFixed(4);data[i].forecastDiff=(item.mtd-item.forecast).toFixed(4);data[i].lastDiff=(item.mtd-item.last).toFixed(4);}else{data[i].budgetDiff=(0,_method.calculation)(item.mtd-item.budget,item.budget,4);data[i].forecastDiff=(0,_method.calculation)(item.mtd-item.forecast,item.forecast,4);data[i].lastDiff=(0,_method.calculation)(item.mtd-item.last,item.last,4);}});console.log(data);return data;};var columns=exports.columns=function columns(onChange,date,print){var isFirstDay=(0,_moment2.default)(date).format('D')==1;return[{title:"",dataIndex:'name',key:'name',align:"center",width:250,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:onChange,totalIndex:TOTALINDEX};if(totalIndex.includes(index))return{props:{colSpan:9},children:_react2.default.createElement(_TableText2.default,{data:props})};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5F53\u5929Actual",dataIndex:'actual',key:'actual',align:"center",width:150,render:function render(text,record,index){if(totalIndex.includes(index))return{props:{colSpan:0}};var title=['当天Actual'];var props={text:text,index:index,type:inputIndex.includes(index)&&!print?'inputNumber':percenIndex.includes(index)?"percent":'number',name:"actual",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:title,record:record,sqlName:"_4_2_3_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5F53\u6708MTD",dataIndex:'mtd',key:'mtd',align:"center",width:150,render:function render(text,record,index){if(totalIndex.includes(index))return{props:{colSpan:0}};var title=['当月MTD'];var props={text:text,index:index,type:percenIndex.includes(index)?"percent":'number',name:"mtd",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:title,record:record,sqlName:"_4_2_3_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5F53\u6708Budget",dataIndex:'budget',key:'budget',align:"center",width:150,render:function render(text,record,index){if(totalIndex.includes(index))return{props:{colSpan:0}};var title=['当月Budget'];var props={text:text,index:index,type:inputIndex.includes(index)&&!print&&isFirstDay?'inputNumber':percenIndex.includes(index)?"percent":'number',name:"budget",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:title,record:record,sqlName:"_4_2_3_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5DEE\u5F02",dataIndex:'budgetDiff',key:'budgetDiff',align:"center",width:100,render:function render(text,record,index){if(totalIndex.includes(index))return{props:{colSpan:0}};var title=['差异'];var props={text:text,index:index,type:'percent',name:"budgetDiff",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:title,record:record,sqlName:"_4_2_3_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5F53\u6708Forecast",dataIndex:'forecast',key:'forecast',align:"center",width:150,render:function render(text,record,index){if(totalIndex.includes(index))return{props:{colSpan:0}};var title=['当月Forecast'];var props={text:text,index:index,type:inputIndex.includes(index)&&!print&&isFirstDay?'inputNumber':percenIndex.includes(index)?"percent":'number',name:"forecast",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:title,record:record,sqlName:"_4_2_3_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5DEE\u5F02",dataIndex:'forecastDiff',key:'forecastDiff',align:"center",width:100,render:function render(text,record,index){if(totalIndex.includes(index))return{props:{colSpan:0}};var title=['差异'];var props={text:text,index:index,type:'percent',name:"forecastDiff",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:title,record:record,sqlName:"_4_2_3_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u53BB\u5E74\u5F53\u6708 Actual",dataIndex:'last',key:'last',align:"center",width:150,render:function render(text,record,index){if(totalIndex.includes(index))return{props:{colSpan:0}};var title=['去年当月 Actual'];var props={text:text,index:index,type:inputIndex.includes(index)&&!print&&isFirstDay?'inputNumber':percenIndex.includes(index)?"percent":'number',name:"last",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:title,record:record,sqlName:"_4_2_3_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5DEE\u5F02",dataIndex:'lastDiff',key:'lastDiff',align:"center",width:100,render:function render(text,record,index){if(totalIndex.includes(index))return{props:{colSpan:0}};var title=['差异'];var props={text:text,index:index,type:'percent',name:"lastDiff",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:title,record:record,sqlName:"_4_2_3_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}}];};

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(8);__webpack_require__(14);__webpack_require__(4);__webpack_require__(10);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(1839);var _data2=_interopRequireDefault(_data);var _compute=__webpack_require__(1840);var _compute2=_interopRequireDefault(_compute);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().format('YYYY-MM-DD'),data:[],loading:true,loadingSave:false,print:false,last:[],e4_1_1:[]},_this.computeNum=function(data){var _this$state=_this.state,date=_this$state.date,last=_this$state.last,e4_1_1=_this$state.e4_1_1;data=(0,_compute2.default)(data,{date:date,last:last,e4_1_1:e4_1_1});_this.setState({data:data,loading:false});},_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var data,month,year,day,x;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_this.setState({loading:true});data=JSON.parse(JSON.stringify((0,_data2.default)(date)));month=(0,_moment2.default)(date).format('M');year=(0,_moment2.default)(date).format('YYYY');day=(0,_moment2.default)(date).format('D');_context.next=8;return(0,_request2.default)("/day4_2_4?year="+year+"&month="+month+"&day="+day);case 8:x=_context.sent;if(x.data.table&&x.data.table.length>0){data=x.data.table.sort(function(a,b){return a.sort-b.sort;});}_this.setState({last:(x.data.last||[]).sort(function(a,b){return a.sort-b.sort;}),e4_1_1:(x.data.e4_1_1||[]).sort(function(a,b){return a.sort-b.sort;})},function(){_this.computeNum(data,true);});_context.next=17;break;case 13:_context.prev=13;_context.t0=_context["catch"](0);_this.setState({loading:false});console.error(_context.t0);case 17:case"end":return _context.stop();}}},_callee,_this2,[[0,13]]);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var date,_timer,year,month,day,data,dataFrom,headres,x,timer,_timer2;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_this.setState({loadingSave:true});date=_this.state.date;if(date){_context2.next=7;break;}_message3.default.error('请选择年份月份');_timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer);},1000);return _context2.abrupt("return");case 7:year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");day=(0,_moment2.default)(date).format("D");data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month,day:day,sort:i});});dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context2.next=16;return(0,_request2.default)('/saveDay4_2_4',headres);case 16:x=_context2.sent;timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(!(x.status==1)){_context2.next=22;break;}_message3.default.success(x.msg);if(!data[0].id){_this.getData(_this.state.date);}return _context2.abrupt("return");case 22:_message3.default.error(x.msg);_context2.next=30;break;case 25:_context2.prev=25;_context2.t0=_context2["catch"](0);_timer2=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer2);},1000);console.error(_context2.t0);_message3.default.error('保存失败'+JSON.stringify(_context2.t0));case 30:case"end":return _context2.stop();}}},_callee2,_this2,[[0,25]]);})),_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('view4_1_5',1.5,'4.24',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});},_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+" "+(0,_moment2.default)(_this.state.date).format('YYYY')+" 4.2.4 3 Monthly Biz On-book Outlook";var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById('table4_1_5').innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+".xls");_this.setState({print:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print,loading=_state.loading;return _react2.default.createElement("div",{className:"table7_1_1 tableHeight"},_react2.default.createElement(_row2.default,{className:"title",id:"view4_1_5"},_react2.default.createElement(_row2.default,null,"4.2.4 3 Monthly Biz On-book Outlook"),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(_datePicker2.default,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM-DD"),format:"YYYY-MM-DD",onChange:function onChange(date,str){_this3.setState({date:str,data:[]});_this3.getData(str);}})),_react2.default.createElement(_table2.default,{columns:(0,_compute.columns)(this.onChange,date,print),dataSource:data,size:"middle",id:"table4_1_5",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{y:600},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:"table-footer-btn"},_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:print},"\u5BFC\u51FAExcel"),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:"edit_4_2_4"},_react2.default.createElement(_button2.default,{type:"primary",style:{margin:'0 10px'},onClick:this.downloadSG,loading:print},"\u52A0\u5165pdf"),_react2.default.createElement(_button2.default,{type:"primary",onClick:this.onSave,loading:this.state.loadingSave},"\u4FDD\u5B58"))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=function(date){return[{name:(0,_moment2.default)(date).format('YYYY-MM'),otb:0,forecast:0,otbForecast:0,otbForecastS:0,budget:0,otbBudget:0,otbBudgetS:0,last:0,otbLast:0,otbLastS:0,dayPU:0},{name:"Room Nights",otb:0,forecast:0,otbForecast:0,otbForecastS:0,budget:0,otbBudget:0,otbBudgetS:0,last:0,otbLast:0,otbLastS:0,dayPU:0},{name:"OCC%",otb:0,forecast:0,otbForecast:0,otbForecastS:0,budget:0,otbBudget:0,otbBudgetS:0,last:0,otbLast:0,otbLastS:0,dayPU:0},{name:"ADR",otb:0,forecast:0,otbForecast:0,otbForecastS:0,budget:0,otbBudget:0,otbBudgetS:0,last:0,otbLast:0,otbLastS:0,dayPU:0},{name:"Room Revenue",otb:0,forecast:0,otbForecast:0,otbForecastS:0,budget:0,otbBudget:0,otbBudgetS:0,last:0,otbLast:0,otbLastS:0,dayPU:0},{name:"RevPAR",otb:0,forecast:0,otbForecast:0,otbForecastS:0,budget:0,otbBudget:0,otbBudgetS:0,last:0,otbLast:0,otbLastS:0,dayPU:0},{name:(0,_moment2.default)(date).add(1,'month').format("YYYY-MM"),otb:0,forecast:0,otbForecast:0,otbForecastS:0,budget:0,otbBudget:0,otbBudgetS:0,last:0,otbLast:0,otbLastS:0,dayPU:0},{name:"Room Nights",otb:0,forecast:0,otbForecast:0,otbForecastS:0,budget:0,otbBudget:0,otbBudgetS:0,last:0,otbLast:0,otbLastS:0,dayPU:0},{name:"OCC%",otb:0,forecast:0,otbForecast:0,otbForecastS:0,budget:0,otbBudget:0,otbBudgetS:0,last:0,otbLast:0,otbLastS:0,dayPU:0},{name:"ADR",otb:0,forecast:0,otbForecast:0,otbForecastS:0,budget:0,otbBudget:0,otbBudgetS:0,last:0,otbLast:0,otbLastS:0,dayPU:0},{name:"Room Revenue",otb:0,forecast:0,otbForecast:0,otbForecastS:0,budget:0,otbBudget:0,otbBudgetS:0,last:0,otbLast:0,otbLastS:0,dayPU:0},{name:"RevPAR",otb:0,forecast:0,otbForecast:0,otbForecastS:0,budget:0,otbBudget:0,otbBudgetS:0,last:0,otbLast:0,otbLastS:0,dayPU:0},{name:(0,_moment2.default)(date).add(2,'month').format("YYYY-MM"),otb:0,forecast:0,otbForecast:0,otbForecastS:0,budget:0,otbBudget:0,otbBudgetS:0,last:0,otbLast:0,otbLastS:0,dayPU:0},{name:"Room Nights",otb:0,forecast:0,otbForecast:0,otbForecastS:0,budget:0,otbBudget:0,otbBudgetS:0,last:0,otbLast:0,otbLastS:0,dayPU:0},{name:"OCC%",otb:0,forecast:0,otbForecast:0,otbForecastS:0,budget:0,otbBudget:0,otbBudgetS:0,last:0,otbLast:0,otbLastS:0,dayPU:0},{name:"ADR",otb:0,forecast:0,otbForecast:0,otbForecastS:0,budget:0,otbBudget:0,otbBudgetS:0,last:0,otbLast:0,otbLastS:0,dayPU:0},{name:"Room Revenue",otb:0,forecast:0,otbForecast:0,otbForecastS:0,budget:0,otbBudget:0,otbBudgetS:0,last:0,otbLast:0,otbLastS:0,dayPU:0},{name:"RevPAR",otb:0,forecast:0,otbForecast:0,otbForecastS:0,budget:0,otbBudget:0,otbBudgetS:0,last:0,otbLast:0,otbLastS:0,dayPU:0}].map(function(x,i){return _extends({},x,{sort:i,code:i});});};

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columns=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var totalIndex=[0,6,12];var inputIndex=[1,2,4,7,8,10,13,14,16];var percentIndex=[2,8,14];var getType=function getType(index,print){if(percentIndex.includes(index)&&inputIndex.includes(index)&&!print)return"inputPercent";if(percentIndex.includes(index))return"percent";if(inputIndex.includes(index)&&!print)return"inputNumber";return"number";};exports.default=function(data,_ref){var date=_ref.date,last=_ref.last,e4_1_1=_ref.e4_1_1;var month=(0,_moment2.default)(date).format('M');var nameGrandData={1:"grand_rn",2:"grand_occ",3:"grand_arr",4:"grand_rev",5:"grand_revpar",7:"grand_rn",8:"grand_occ",9:"grand_arr",10:"grand_rev",11:"grand_revpar",13:"grand_rn",14:"grand_occ",15:"grand_arr",16:"grand_rev",17:"grand_revpar"};Object.keys(nameGrandData).map(function(i){var _month=i<7?month:i<13?~~month+1:~~month+2;data[i].forecast=_lodash2.default.get(e4_1_1,(_month-1)*3+1+"."+nameGrandData[i],0);data[i].budget=_lodash2.default.get(e4_1_1,(_month-1)*3+"."+nameGrandData[i],0);data[i].last=_lodash2.default.get(e4_1_1,(_month-1)*3+2+"."+nameGrandData[i],0);});data[3].otb=(0,_method.calculation)(data[4].otb,data[1].otb);data[5].otb=(data[2].otb*data[3].otb).toFixed(2);data[9].otb=(0,_method.calculation)(data[10].otb,data[7].otb);data[11].otb=(data[8].otb*data[9].otb).toFixed(2);data[15].otb=(0,_method.calculation)(data[16].otb,data[13].otb);data[17].otb=(data[14].otb*data[15].otb).toFixed(2);// 计算vs one
data.forEach(function(item,i){data[i].otbForecast=(item.otb-item.forecast).toFixed(4);data[i].otbBudget=(item.otb-item.budget).toFixed(4);data[i].otbLast=(item.otb-item.last).toFixed(4);data[i].otbForecastS=(0,_method.calculation)(data[i].otbForecast,item.forecast,4);data[i].otbBudgetS=(0,_method.calculation)(data[i].otbBudget,item.budget,4);data[i].otbLastS=(0,_method.calculation)(data[i].otbLast,item.last,4);});// 填充昨日数据 
data.forEach(function(item,i){data[i].dayPU=(item.otb-_lodash2.default.get(last,i+".otb",0)).toFixed(4);});//   daily计算
data[3].dayPU=(0,_method.calculation)(data[4].dayPU,data[1].dayPU);data[5].dayPU=(data[2].dayPU*data[3].dayPU).toFixed(2);data[9].dayPU=(0,_method.calculation)(data[10].dayPU,data[7].dayPU);data[11].dayPU=(data[8].dayPU*data[9].dayPU).toFixed(2);data[15].dayPU=(0,_method.calculation)(data[16].dayPU,data[13].dayPU);data[17].dayPU=(data[14].dayPU*data[15].dayPU).toFixed(2);return data;};var columns=exports.columns=function columns(onChange,date,print){return[{title:"",dataIndex:'name',key:'name',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:onChange,totalIndex:totalIndex};if(totalIndex.includes(index))return{props:{colSpan:12},children:_react2.default.createElement(_TableText2.default,{data:props})};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"OTB",dataIndex:'otb',key:'otb',align:"center",width:100,render:function render(text,record,index){if(totalIndex.includes(index))return{props:{colSpan:0}};var title=['OTB'];var props={text:text,index:index,type:getType(index,print),name:"otb",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_4_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"Forecast",dataIndex:'forecast',key:'forecast',align:"center",width:100,render:function render(text,record,index){if(totalIndex.includes(index))return{props:{colSpan:0}};var title=['Forecast'];var props={text:text,index:index,type:getType(index,true),name:"forecast",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_4_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"OTB VS Forecast",children:[{dataIndex:'otbForecast',key:'otbForecast',align:"center",width:100,render:function render(text,record,index){if(totalIndex.includes(index))return{props:{colSpan:0}};var title=['OTB VS Forecast'];var props={text:text,index:index,type:getType(index,true),name:"otbForecast",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_4_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{dataIndex:'otbForecastS',key:'otbForecastS',align:"center",width:100,render:function render(text,record,index){if(totalIndex.includes(index))return{props:{colSpan:0}};var title=['OTB VS Forecast'];var props={text:text,index:index,type:'percent',name:"otbForecastS",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_4_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"Budget",dataIndex:'budget',key:'budget',align:"center",width:100,render:function render(text,record,index){if(totalIndex.includes(index))return{props:{colSpan:0}};var title=['Budget'];var props={text:text,index:index,type:getType(index,true),name:"budget",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_4_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"OTB VS Budget",children:[{dataIndex:'otbBudget',key:'otbBudget',align:"center",width:100,render:function render(text,record,index){if(totalIndex.includes(index))return{props:{colSpan:0}};var title=['OTB VS Budget'];var props={text:text,index:index,type:getType(index,true),name:"otbBudget",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_4_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{dataIndex:'otbBudgetS',key:'otbBudgetS',align:"center",width:100,render:function render(text,record,index){if(totalIndex.includes(index))return{props:{colSpan:0}};var title=['OTB VS Budget'];var props={text:text,index:index,type:'percent',name:"otbBudgetS",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_4_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"LY",dataIndex:'last',key:'last',align:"center",width:100,render:function render(text,record,index){if(totalIndex.includes(index))return{props:{colSpan:0}};var title=['LY'];var props={text:text,index:index,type:getType(index,true),name:"last",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_4_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"OTB VS LY",children:[{dataIndex:'otbLast',key:'otbLast',align:"center",width:100,render:function render(text,record,index){if(totalIndex.includes(index))return{props:{colSpan:0}};var title=['OTB VS LY'];var props={text:text,index:index,type:getType(index,true),name:"otbLast",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_4_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{dataIndex:'otbLastS',key:'otbLastS',align:"center",width:100,render:function render(text,record,index){if(totalIndex.includes(index))return{props:{colSpan:0}};var title=['OTB VS LY'];var props={text:text,index:index,type:'percent',name:"otbLastS",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_4_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"Daily P/U",dataIndex:'dayPU',key:'dayPU',align:"center",width:100,render:function render(text,record,index){if(totalIndex.includes(index))return{props:{colSpan:0}};var title=['Daily P/U'];var props={text:text,index:index,type:getType(index,true),name:"dayPU",onChange:onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_4_2_4_day"}};return _react2.default.createElement(_TableText2.default,{data:props});}}];};

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(1842);var _data2=_interopRequireDefault(_data);var _compute=__webpack_require__(1843);var _compute2=_interopRequireDefault(_compute);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _analysis=__webpack_require__(125);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,last:[],e4_2_4:[]},_this.computeNum=function(data){var _this$state=_this.state,date=_this$state.date,last=_this$state.last,e4_2_4=_this$state.e4_2_4;data=(0,_compute2.default)(data,{date:date,last:last,e4_2_4:e4_2_4});_this.setState({data:data,loading:false});var days=(0,_moment2.default)(date).daysInMonth();// 更新图表
(0,_analysis.setKarte)({id:"chart",title:"日度Pickup走势图",grid:{left:50,right:50,top:80},titleOption:{left:"center"},dataX:new Array(days).fill(1).map(function(x,i){return(0,_moment2.default)(date+"-"+(i+1)).format('M-D')+"\n\n"+_compute.weeks[(0,_moment2.default)(date+"-"+(i+1)).day()].replace('星期','');}),dataY:[{name:"Room Nights",data:new Array(days).fill(1).map(function(x,i){return data[0]["m"+(i+1)];}),type:"line",yAxisIndex:1},{name:"Room Revenue",data:new Array(days).fill(1).map(function(x,i){return data[1]["m"+(i+1)];}),type:"bar",yAxisIndex:0}],yAxis:[{type:'value'},{type:'value'}]});},_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var data,month,year,x;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_this.setState({loading:true});data=JSON.parse(JSON.stringify((0,_data2.default)(date)));console.log(data);month=(0,_moment2.default)(date).format('M');year=(0,_moment2.default)(date).format('YYYY');_context.next=8;return(0,_request2.default)("/day4_2_5?year="+year+"&month="+month);case 8:x=_context.sent;if(x.data.table&&x.data.table.length>0){data=x.data.table.sort(function(a,b){return a.sort-b.sort;});}_this.setState({e4_2_4:x.data.e4_2_4||{}},function(){_this.computeNum(data,true);});_context.next=17;break;case 13:_context.prev=13;_context.t0=_context["catch"](0);_this.setState({loading:false});console.error(_context.t0);case 17:case"end":return _context.stop();}}},_callee,_this2,[[0,13]]);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var date,_timer,year,month,data,dataFrom,headres,x,timer,_timer2;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_this.setState({loadingSave:true});date=_this.state.date;if(date){_context2.next=7;break;}_message3.default.error('请选择年份月份');_timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer);},1000);return _context2.abrupt("return");case 7:year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month,sort:i});});dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context2.next=15;return(0,_request2.default)('/saveDay4_2_5',headres);case 15:x=_context2.sent;timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(!(x.status==1)){_context2.next=21;break;}_message3.default.success(x.msg);if(!data[0].id){_this.getData(_this.state.date);}return _context2.abrupt("return");case 21:_message3.default.error(x.msg);_context2.next=29;break;case 24:_context2.prev=24;_context2.t0=_context2["catch"](0);_timer2=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer2);},1000);console.error(_context2.t0);_message3.default.error('保存失败'+JSON.stringify(_context2.t0));case 29:case"end":return _context2.stop();}}},_callee2,_this2,[[0,24]]);})),_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('view4_1_5',1.5,'4.25',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});},_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+" "+(0,_moment2.default)(_this.state.date).format('YYYY')+" 4.2.5 Daily Pick up Trend";var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById('table4_1_5').innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+".xls");_this.setState({print:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print,loading=_state.loading;return _react2.default.createElement("div",{className:"table7_1_1 tableHeight"},_react2.default.createElement(_row2.default,{className:"title",id:"view4_1_5"},_react2.default.createElement(_row2.default,null,"4.2.5 Daily Pick up Trend"),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:"YYYY-MM",onChange:function onChange(date,str){_this3.setState({date:str,data:[]});_this3.getData(str);}})),_react2.default.createElement(_table2.default,{columns:(0,_compute.columns)(this.onChange,date,print),dataSource:data,size:"middle",id:"table4_1_5",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{x:1500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:"table-footer-btn"},_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:print},"\u5BFC\u51FAExcel"),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:"edit_4_2_5"},_react2.default.createElement(_button2.default,{type:"primary",style:{margin:'0 10px'},onClick:this.downloadSG,loading:print},"\u52A0\u5165pdf"),_react2.default.createElement(_button2.default,{type:"primary",onClick:this.onSave,loading:this.state.loadingSave},"\u4FDD\u5B58"))),_react2.default.createElement("div",{id:"chart",style:{height:500,width:'100%',marginBottom:50}}));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}exports.default=function(date){var keys=new Array(31).fill(1).reduce(function(a,b,i){return _extends({},a,_defineProperty({},"m"+(i+1),0));},{});return[_extends({name:"Pickup总计",type:"Room Nights",total:0,otb:0,msc:0,sort:0},keys),_extends({name:"Pickup总计",type:"Room Revenue",total:0,otb:0,msc:0,sort:1},keys),_extends({name:(0,_moment2.default)(date).format("YYYY年MM月"),type:"Room Nights",total:0,otb:0,msc:0,sort:2},keys),_extends({name:(0,_moment2.default)(date).format("YYYY年MM月"),type:"Room Revenue",total:0,otb:0,msc:0,sort:3},keys),_extends({name:(0,_moment2.default)(date).add(1,'month').format("YYYY年MM月"),type:"Room Nights",total:0,otb:0,msc:0,sort:4},keys),_extends({name:(0,_moment2.default)(date).add(1,'month').format("YYYY年MM月"),type:"Room Revenue",total:0,otb:0,msc:0,sort:5},keys),_extends({name:(0,_moment2.default)(date).add(2,'month').format("YYYY年MM月"),type:"Room Nights",total:0,otb:0,msc:0,sort:6},keys),_extends({name:(0,_moment2.default)(date).add(2,'month').format("YYYY年MM月"),type:"Room Revenue",total:0,otb:0,msc:0,sort:7},keys)];};

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columns=exports.weeks=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var totalIndex=[];var weeks=exports.weeks={0:"星期日",1:"星期一",2:"星期二",3:"星期三",4:"星期四",5:"星期五",6:"星期六"};var keys=new Array(31).fill(1).map(function(x,i){return"m"+(i+1);});exports.default=function(data,_ref){var date=_ref.date,last=_ref.last,e4_2_4=_ref.e4_2_4;keys.forEach(function(name,i){data[2][name]=_lodash2.default.get(e4_2_4,i+1+".rn",0)||0;data[3][name]=_lodash2.default.get(e4_2_4,i+1+".rev",0)||0;data[4][name]=_lodash2.default.get(e4_2_4,i+1+".nextRn",0)||0;data[5][name]=_lodash2.default.get(e4_2_4,i+1+".nextRev",0)||0;data[6][name]=_lodash2.default.get(e4_2_4,i+1+".afterRn",0)||0;data[7][name]=_lodash2.default.get(e4_2_4,i+1+".afterRev",0)||0;});// Pickup总计
keys.forEach(function(name,i){data[0][name]=(0,_method.sum)([data[2][name],data[4][name],data[6][name]]);data[1][name]=(0,_method.sum)([data[3][name],data[5][name],data[7][name]]);});// 当月Total Pickup
data.forEach(function(item,i){data[i].total=keys.reduce(function(a,b,i){return a+=(0,_method.numConvert)(item[b]);},0).toFixed(2);// 当月收官情况
if(i>1){data[i].msc=(0,_method.sum)([data[i].total,data[i].otb]);}});return data;};var columns=exports.columns=function columns(onChange,date,print){// 获取当月天数
var days=(0,_moment2.default)(date).daysInMonth();return[{title:"",dataIndex:'name',key:'name',align:"center",fixed:!print&&"left",width:100,render:function render(text,record,index){if(index%2){return{props:{rowSpan:0}};}var props={text:text,index:index,type:'text',name:"name",onChange:onChange,totalIndex:totalIndex};return{props:{rowSpan:2},children:_react2.default.createElement(_TableText2.default,{data:props})};}},{title:"\u661F\u671F",align:"center",fixed:!print&&"left",width:150,children:[{title:"Pickup\u65E5\u671F",align:"center",fixed:!print&&"left",width:150,dataIndex:'type',key:'type',render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"type",onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]}].concat(_toConsumableArray(new Array(days).fill(1).reduce(function(a,b,i){return[].concat(_toConsumableArray(a),[{title:weeks[(0,_moment2.default)(date+"-"+(i+1)).day()],align:"center",children:[{title:(0,_moment2.default)(date+"-"+(i+1)).format('MM-D'),dataIndex:"m"+(i+1),key:"m"+(i+1),align:"center",width:120,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"m"+(i+1),onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]}]);},[])),[{title:"\u5F53\u6708Total Pickup",dataIndex:'total',key:'total',align:"center",width:120,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"total",onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u622A\u6B62\u5230\u4E0A\u6708\u5E95\u65F6\u7684OTB\u60C5\u51B5",dataIndex:'otb',key:'otb',align:"center",width:120,render:function render(text,record,index){var props={text:text,index:index,type:print?'number':index>1?'inputNumber':'',name:"otb",onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5F53\u6708\u6536\u5B98\u60C5\u51B5",dataIndex:'msc',key:'msc',align:"center",width:120,render:function render(text,record,index){var props={text:text,index:index,type:index>1?'number':"",name:"msc",onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]);};

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(1845);var _data2=_interopRequireDefault(_data);var _compute=__webpack_require__(1846);var _compute2=_interopRequireDefault(_compute);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _analysis=__webpack_require__(125);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,last:[],e4_2_4:[]},_this.computeNum=function(data,isUpdate){var _this$state=_this.state,date=_this$state.date,last=_this$state.last,e4_2_4=_this$state.e4_2_4;data=(0,_compute2.default)(data,{date:date,last:last,e4_2_4:e4_2_4});_this.setState({data:data,loading:false});if(isUpdate)_this.setChart(data);},_this.setChart=function(data){var date=_this.state.date;var days=(0,_moment2.default)(date).daysInMonth();// 更新图表
(0,_analysis.setKarte)({id:"chart",grid:{left:50,right:50,top:80},titleOption:{left:"center"},color:["#4572a8",'#aa4643','#89a64e','#715890','#4299b0','#dc853d','#93aacf','#d19493','#b9ce97','#a99cbd','#92c4d5'],dataX:new Array(days).fill(1).map(function(x,i){return(0,_moment2.default)(date+"-"+(i+1)).format('M-D')+"\n\n"+_compute.weeks[(0,_moment2.default)(date+"-"+(i+1)).day()].replace('星期','');}),dataY:data.filter(function(x,i){return i<11;}).map(function(x,i){return{name:x.name,data:new Array(days).fill(1).map(function(x,_i){return data[i]["m"+(_i+1)];}),type:"bar",stack:'sum'};})});},_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var data,month,year,x;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_this.setState({loading:true});data=JSON.parse(JSON.stringify((0,_data2.default)(date)));console.log(data);month=(0,_moment2.default)(date).format('M');year=(0,_moment2.default)(date).format('YYYY');_context.next=8;return(0,_request2.default)("/day4_2_6?year="+year+"&month="+month);case 8:x=_context.sent;if(x.data.table&&x.data.table.length>0){data=x.data.table.sort(function(a,b){return a.sort-b.sort;});}_this.setState({e4_2_4:x.data.e4_2_4||{}},function(){_this.computeNum(data,true);});_context.next=17;break;case 13:_context.prev=13;_context.t0=_context["catch"](0);_this.setState({loading:false});console.error(_context.t0);case 17:case"end":return _context.stop();}}},_callee,_this2,[[0,13]]);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var date,_timer,year,month,data,dataFrom,headres,x,timer,_timer2;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_this.setState({loadingSave:true});date=_this.state.date;if(date){_context2.next=7;break;}_message3.default.error('请选择年份月份');_timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer);},1000);return _context2.abrupt("return");case 7:year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month,sort:i});});dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context2.next=15;return(0,_request2.default)('/saveDay4_2_6',headres);case 15:x=_context2.sent;timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(!(x.status==1)){_context2.next=22;break;}_this.setChart(data);_message3.default.success(x.msg);if(!data[0].id){_this.getData(_this.state.date);}return _context2.abrupt("return");case 22:_message3.default.error(x.msg);_context2.next=30;break;case 25:_context2.prev=25;_context2.t0=_context2["catch"](0);_timer2=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer2);},1000);console.error(_context2.t0);_message3.default.error('保存失败'+JSON.stringify(_context2.t0));case 30:case"end":return _context2.stop();}}},_callee2,_this2,[[0,25]]);})),_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('view4_1_5',1.5,'4.26',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});},_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+" "+(0,_moment2.default)(_this.state.date).format('YYYY')+" 4.2.6 Daily Pick up by Segmentation";var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById('table4_1_5').innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+".xls");_this.setState({print:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print,loading=_state.loading;return _react2.default.createElement("div",{className:"table7_1_1 tableHeight"},_react2.default.createElement(_row2.default,{className:"title",id:"view4_1_5"},_react2.default.createElement(_row2.default,null,"4.2.6 Daily Pick up by Segmentation"),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:"YYYY-MM",onChange:function onChange(date,str){_this3.setState({date:str,data:[]});_this3.getData(str);}})),_react2.default.createElement(_table2.default,{columns:(0,_compute.columns)(this.onChange,date,print),dataSource:data,size:"middle",id:"table4_1_5",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{x:1500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:"table-footer-btn"},_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:print},"\u5BFC\u51FAExcel"),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:"edit_4_2_6"},_react2.default.createElement(_button2.default,{type:"primary",style:{margin:'0 10px'},onClick:this.downloadSG,loading:print},"\u52A0\u5165pdf"),_react2.default.createElement(_button2.default,{type:"primary",onClick:this.onSave,loading:this.state.loadingSave},"\u4FDD\u5B58"))),_react2.default.createElement("div",{id:"chart",style:{height:500,width:'100%',marginBottom:50}}));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}exports.default=function(date){var keys=new Array(31).fill(1).reduce(function(a,b,i){return _extends({},a,_defineProperty({},"m"+(i+1),0));},{});return[_extends({name:"最优价格",total:0,sort:0},keys),_extends({name:"商务协议散客",total:0,sort:1},keys),_extends({name:"政府协议散客",total:0,sort:2},keys),_extends({name:"套餐",total:0,sort:3},keys),_extends({name:"旅行社",total:0,sort:4},keys),_extends({name:"电子商务",total:0,sort:5},keys),_extends({name:"折扣价",total:0,sort:6},keys),_extends({name:"公司团",total:0,sort:7},keys),_extends({name:"旅行团",total:0,sort:8},keys),_extends({name:"合同",total:0,sort:9},keys),_extends({name:"其他",total:0,sort:10},keys),_extends({name:"Pickup总计",total:0,sort:11},keys)].map(function(x){return _extends({},x,{code:x.name});});};

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columns=exports.weeks=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var totalIndex=[11];var weeks=exports.weeks={0:"日",1:"一",2:"二",3:"三",4:"四",5:"五",6:"六"};var keys=new Array(31).fill(1).map(function(x,i){return"m"+(i+1);});exports.default=function(data){// Total
data.forEach(function(item,i){data[i].total=keys.reduce(function(a,b){return a+=(0,_method.numConvert)(item[b]);},0).toFixed(2);});[].concat(_toConsumableArray(keys),['total']).forEach(function(name){data[11][name]=data.reduce(function(a,b,i){return i<11?a+(0,_method.numConvert)(b[name]):a;},0).toFixed(2);});return data;};var columns=exports.columns=function columns(onChange,date,print){// 获取当月天数
var days=(0,_moment2.default)(date).daysInMonth();return[{title:"Pickup \u65E5\u671F",dataIndex:'name',key:'name',align:"center",fixed:!print&&"left",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}].concat(_toConsumableArray(new Array(days).fill(1).reduce(function(a,b,i){return[].concat(_toConsumableArray(a),[{title:weeks[(0,_moment2.default)(date+"-"+(i+1)).day()],align:"center",children:[{title:(0,_moment2.default)(date+"-"+(i+1)).format('MM-D'),dataIndex:"m"+(i+1),key:"m"+(i+1),align:"center",width:120,render:function render(text,record,index){var props={text:text,index:index,type:totalIndex.includes(index)?'number':'inputNumber',name:"m"+(i+1),onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]}]);},[])),[{title:"Total",dataIndex:'total',key:'total',align:"center",width:120,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"total",onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]);};

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(8);__webpack_require__(14);__webpack_require__(4);__webpack_require__(10);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(1848);var _data2=_interopRequireDefault(_data);var _compute=__webpack_require__(1849);var _compute2=_interopRequireDefault(_compute);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _analysis=__webpack_require__(125);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().format('YYYY-MM-DD'),data:[],loading:true,loadingSave:false,print:false,last:[],e4_2_4:[]},_this.computeNum=function(data,isUpdate){var _this$state=_this.state,date=_this$state.date,last=_this$state.last,e4_2_4=_this$state.e4_2_4;data=(0,_compute2.default)(data,{date:date,last:last,e4_2_4:e4_2_4});_this.setState({data:data,loading:false});if(isUpdate)_this.setChart(data);},_this.setChart=function(data){var date=_this.state.date;var _date=(0,_moment2.default)(date).format('YYYY-MM');var days=(0,_moment2.default)(date).daysInMonth();// 更新图表
(0,_analysis.setKarte)({id:"chart",title:"日度On-book情况",grid:{left:50,right:50,top:80},titleOption:{left:"center"},color:["#4572a8",'#aa4643','#89a64e','#715890','#4299b0','#dc853d','#93aacf','#d19493','#b9ce97','#a99cbd','#92c4d5'],dataX:new Array(days).fill(1).map(function(x,i){return(0,_moment2.default)(_date+"-"+(i+1)).format('M-D')+"\n\n"+_compute.weeks[(0,_moment2.default)(_date+"-"+(i+1)).day()].replace('星期','');}),dataY:data.filter(function(x,i){return i<4;}).map(function(x,i){return{name:x.name,data:new Array(days).fill(1).map(function(x,_i){return data[i]["m"+(_i+1)];}),type:"bar",stack:'sum'};})});},_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var data,month,day,year,x;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_this.setState({loading:true});data=JSON.parse(JSON.stringify((0,_data2.default)(date)));console.log(data);month=(0,_moment2.default)(date).format('M');day=(0,_moment2.default)(date).format('D');year=(0,_moment2.default)(date).format('YYYY');_context.next=9;return(0,_request2.default)("/day4_2_7?year="+year+"&month="+month+"&day="+day);case 9:x=_context.sent;if(x.data.table&&x.data.table.length>0){data=x.data.table.sort(function(a,b){return a.sort-b.sort;});}else if(x.data.last&&x.data.last.length>0){data=x.data.last.sort(function(a,b){return a.sort-b.sort;}).map(function(x){delete x.id;return x;});}_this.setState({e4_2_4:x.data.e4_2_4||{}},function(){_this.computeNum(data,true);});_context.next=18;break;case 14:_context.prev=14;_context.t0=_context["catch"](0);_this.setState({loading:false});console.error(_context.t0);case 18:case"end":return _context.stop();}}},_callee,_this2,[[0,14]]);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var date,_timer,year,day,month,data,dataFrom,headres,x,timer,_timer2;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_this.setState({loadingSave:true});date=_this.state.date;if(date){_context2.next=7;break;}_message3.default.error('请选择年份月份');_timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer);},1000);return _context2.abrupt("return");case 7:year=(0,_moment2.default)(date).format("YYYY");day=(0,_moment2.default)(date).format("D");month=(0,_moment2.default)(date).format("M");data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month,day:day,sort:i});});dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context2.next=16;return(0,_request2.default)('/saveDay4_2_7',headres);case 16:x=_context2.sent;timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(!(x.status==1)){_context2.next=23;break;}_this.setChart(data);_message3.default.success(x.msg);if(!data[0].id){_this.getData(_this.state.date);}return _context2.abrupt("return");case 23:_message3.default.error(x.msg);_context2.next=31;break;case 26:_context2.prev=26;_context2.t0=_context2["catch"](0);_timer2=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer2);},1000);console.error(_context2.t0);_message3.default.error('保存失败'+JSON.stringify(_context2.t0));case 31:case"end":return _context2.stop();}}},_callee2,_this2,[[0,26]]);})),_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('view4_1_5',1.5,'4.27',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});},_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+" "+(0,_moment2.default)(_this.state.date).format('YYYY')+" 4.2.5 Daily On-book by Status";var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById('table4_1_5').innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+".xls");_this.setState({print:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print,loading=_state.loading;return _react2.default.createElement("div",{className:"table7_1_1 tableHeight"},_react2.default.createElement(_row2.default,{className:"title",id:"view4_1_5"},_react2.default.createElement(_row2.default,null,"4.2.7 Daily On-book by Status"),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(_datePicker2.default,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM-DD"),format:"YYYY-MM-DD",onChange:function onChange(date,str){_this3.setState({date:str,data:[]});_this3.getData(str);}})),_react2.default.createElement(_table2.default,{columns:(0,_compute.columns)(this.onChange,date,print),dataSource:data,size:"middle",id:"table4_1_5",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{x:1500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:"table-footer-btn"},_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:print},"\u5BFC\u51FAExcel"),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:"edit_4_2_6"},_react2.default.createElement(_button2.default,{type:"primary",style:{margin:'0 10px'},onClick:this.downloadSG,loading:print},"\u52A0\u5165pdf"),_react2.default.createElement(_button2.default,{type:"primary",onClick:this.onSave,loading:this.state.loadingSave},"\u4FDD\u5B58"))),_react2.default.createElement("div",{id:"chart",style:{height:500,width:'100%',marginBottom:50}}));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}exports.default=function(date){var keys=new Array(31).fill(1).reduce(function(a,b,i){return _extends({},a,_defineProperty({},"m"+(i+1),0));},{});return[_extends({name:"Def. Group",sort:0},keys),_extends({name:"Non-def. Group",sort:1},keys),_extends({name:"GTD FIT",sort:2},keys),_extends({name:"Non-gtd FIT",sort:3},keys),_extends({name:"On-book总计",sort:4},keys),_extends({name:"当日可售房量",sort:5},keys),_extends({name:"住房率 %",sort:6},keys)].map(function(x){return _extends({},x,{code:x.name});});};

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columns=exports.weeks=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var totalIndex=[4,6];var weeks=exports.weeks={0:"日",1:"一",2:"二",3:"三",4:"四",5:"五",6:"六"};var keys=new Array(31).fill(1).map(function(x,i){return"m"+(i+1);});exports.default=function(data){keys.forEach(function(name){data[4][name]=(0,_method.sum)([data[0][name],data[1][name],data[2][name],data[3][name]]);data[6][name]=(0,_method.calculation)(data[4][name],data[5][name],4);});return data;};var columns=exports.columns=function columns(onChange,date,print){// 获取当月天数
var days=(0,_moment2.default)(date).daysInMonth();var _date=(0,_moment2.default)(date).format('YYYY-MM');return[{title:"\u7EC6\u5206\u5E02\u573A",dataIndex:'name',key:'name',align:"center",fixed:!print&&"left",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}].concat(_toConsumableArray(new Array(days).fill(1).reduce(function(a,b,i){return[].concat(_toConsumableArray(a),[{title:weeks[(0,_moment2.default)(_date+"-"+(i+1)).day()],align:"center",children:[{title:(0,_moment2.default)(_date+"-"+(i+1)).format('MM-D'),dataIndex:"m"+(i+1),key:"m"+(i+1),align:"center",width:120,render:function render(text,record,index){var props={text:text,index:index,type:index==6?'percent':totalIndex.includes(index)?'number':'inputNumber',name:"m"+(i+1),onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]}]);},[])));};

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _radio=__webpack_require__(112);var _radio2=_interopRequireDefault(_radio);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(127);__webpack_require__(4);__webpack_require__(10);__webpack_require__(42);__webpack_require__(14);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _compute=__webpack_require__(438);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _compute2=__webpack_require__(1851);var _compute3=_interopRequireDefault(_compute2);__webpack_require__(1852);var _method=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var Option=_select2.default.Option;var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.setChart=function(data,lastData){var len=data.length-1;var dataX=data.filter(function(x,i){return i<len;}).map(function(x){return x.hotel_name;});(0,_compute2.setKarte)({dataY:[data.filter(function(x,i){return i<len;}).map(function(x){return(x.occ*100).toFixed(2);}),lastData.filter(function(x,i){return i<len;}).map(function(x){return(x.occ*100).toFixed(2);})],name:"Occ%",dataX:dataX,id:'chartOcc'});(0,_compute2.setKarte)({dataY:[data.filter(function(x,i){return i<len;}).map(function(x){return(0,_method.numConvert)(x.adr).toFixed(2);}),lastData.filter(function(x,i){return i<len;}).map(function(x){return(0,_method.numConvert)(x.adr).toFixed(2);})],name:"ADR",dataX:dataX,id:'chartAdr'});(0,_compute2.setKarte)({dataY:[data.filter(function(x,i){return i<len;}).map(function(x){return(0,_method.numConvert)(x.revpar).toFixed(2);}),lastData.filter(function(x,i){return i<len;}).map(function(x){return(0,_method.numConvert)(x.revpar).toFixed(2);})],name:"REVPAR",dataX:dataX,id:'chartRevpar'});(0,_compute2.setKarte)({dataY:[data.filter(function(x,i){return i<len;}).map(function(x){return(0,_method.numConvert)(x.rev).toFixed(2);}),lastData.filter(function(x,i){return i<len;}).map(function(x){return(0,_method.numConvert)(x.rev).toFixed(2);})],name:"ROOM REVENUE",dataX:dataX,id:'chartRoomRev'});_this.setState({data:data,lastData:lastData});};_this.getData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2){var date=_ref2.date,area=_ref2.area,fullYear=_ref2.fullYear;var year,month,res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;year=(0,_moment2.default)(date).format('YYYY');month=(0,_moment2.default)(date).format('M');_context.next=5;return(0,_request2.default)('/_4_2_daily/summary?year='+year+'&month='+month+'&area='+area+'&fullYear='+fullYear);case 5:res=_context.sent;_this.setChart((0,_compute3.default)(res.data.data||[]),(0,_compute3.default)(res.data.lastdata||[]));_this.setState({loading:false});_context.next=14;break;case 10:_context.prev=10;_context.t0=_context['catch'](0);console.log(_context.t0);_this.setState({loading:false});case 14:case'end':return _context.stop();}}},_callee,_this2,[[0,10]]);}));return function(_x){return _ref.apply(this,arguments);};}();_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table4_2_2',1.5,'4.22',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+' Daily Report \u533A\u57DF\u62A5\u8868';var innerHtml='\n          <caption>'+tableName+'</caption>\n          '+document.getElementById('table4_2_2_export').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n        ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+'.xls');_this.setState({print:false});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],lastdata:[],loading:true,loadingSave:false,print:false,dateData:[],area:"东南华南",fullYear:0};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData({date:this.state.date,area:this.state.area,fullYear:0});}},{key:'render',value:function render(){var _this3=this;var _state=this.state,print=_state.print,loading=_state.loading,data=_state.data,date=_state.date,fullYear=_state.fullYear,area=_state.area;var columns=[{title:'Hotel',dataIndex:'hotel_name',key:'hotel_name',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"hotel_name"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Available room',dataIndex:'ava',key:'ava',align:"center",width:100,render:function render(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var record=arguments[1];var index=arguments[2];var props={text:text,index:index,type:'number',name:"ava"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Sold Room',dataIndex:'sold',key:'sold',align:"center",width:100,render:function render(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var record=arguments[1];var index=arguments[2];var props={text:text,index:index,type:'number',name:"sold"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Occupancy %',dataIndex:'occ',key:'occ',align:"center",width:100,render:function render(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var record=arguments[1];var index=arguments[2];var props={text:text,index:index,type:'percent',name:"occ"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'ADR',dataIndex:'adr',key:'adr',align:"center",width:100,render:function render(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var record=arguments[1];var index=arguments[2];var props={text:text,index:index,type:'number',name:"adr"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'RevPAR',dataIndex:'revpar',key:'revpar',align:"center",width:100,render:function render(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var record=arguments[1];var index=arguments[2];var props={text:text,index:index,type:'number',name:"revpar"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Room Revenue',dataIndex:'rev',key:'rev',width:100,align:"center",render:function render(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var record=arguments[1];var index=arguments[2];var props={text:text,index:index,type:'number',name:"rev"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Room Revenue %',dataIndex:'revper',key:'revper',align:"center",width:100,render:function render(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var record=arguments[1];var index=arguments[2];var props={text:text,index:index,type:'percent',name:"revper"};if(index==33)props.type='';return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Hotel Total Revenue',dataIndex:'total',key:'total',align:"center",width:100,render:function render(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var record=arguments[1];var index=arguments[2];var props={text:text,index:index,type:'number',name:"total"};if(index==33)props.type='';return _react2.default.createElement(_TableText2.default,{data:props});}}];var dataSource=[];if((0,_moment2.default)(date).format('M')==5||(0,_moment2.default)(date).format('M')==10){// 五一、十一
dataSource=data.slice(0,7);}else if(_compute.SPR[(0,_moment2.default)(date).format('Y')].m==(0,_moment2.default)(date).format('M')){// 春节
var _index=_compute.SPR[(0,_moment2.default)(date).format('Y')].d-1;dataSource=data.slice(_index,_index+7);}return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'table7_1_1 table7_6 table4_2_summary',id:'table4_2_2',style:{height:'auto'}},_react2.default.createElement(_row2.default,{className:'title'},_react2.default.createElement(_row2.default,null,'Daily Report \u533A\u57DF\u62A5\u8868'),_react2.default.createElement('div',{className:'title-select'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getData({date:str,area:area});}}),_react2.default.createElement(_select2.default,{allowClear:true,defaultValue:area,style:{width:200,marginLeft:20},onChange:function onChange(value){_this3.setState({data:[],loading:true,area:value},function(){_this3.getData({date:date,area:value});});}},_react2.default.createElement(Option,{value:'\u4E1C\u5357\u534E\u5357'},'\u4E1C\u5357\u534E\u5357'),_react2.default.createElement(Option,{value:'\u534E\u5317\u534E\u4E2D'},'\u534E\u5317\u534E\u4E2D'),_react2.default.createElement(Option,{value:'\u6C5F\u6D59\u6CAA\u7696'},'\u6C5F\u6D59\u6CAA\u7696'),_react2.default.createElement(Option,{value:'\u897F\u5357'},'\u897F\u5357')),_react2.default.createElement(_radio2.default.Group,{style:{marginLeft:10},onChange:function onChange(e){var _fullYear=e.target.value;_this3.setState({data:[],loading:true,fullYear:_fullYear},function(){_this3.getData({date:date,area:area,fullYear:_fullYear});});},value:fullYear},_react2.default.createElement(_radio2.default,{value:1},'\u5168\u5E74'),_react2.default.createElement(_radio2.default,{value:0},'\u5F53\u6708'))),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'table4_2_2_export',pagination:false,className:'content',scroll:print?{}:{y:500,x:false},rowKey:function rowKey(record,index){return record.hotel_name;}}),_react2.default.createElement(_button2.default,{type:'primary',style:{float:'right',marginTop:20},onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:print},'\u5BFC\u51FAExcel')),_react2.default.createElement(_row2.default,{className:'title'},_react2.default.createElement('div',{className:'chart-4-2'},_react2.default.createElement('div',{id:'chartOcc'}),_react2.default.createElement('div',{id:'chartAdr'}),_react2.default.createElement('div',{id:'chartRevpar'}),_react2.default.createElement('div',{id:'chartRoomRev'})),_react2.default.createElement(_Auth2.default,{loading:loading,auth:'edit_4_2'},_react2.default.createElement(_row2.default,{className:'table-footer-btn',style:{display:print?'none':""}},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:print},'\u52A0\u5165pdf'))))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setKarte=undefined;exports.default=function(data){var listName=['ava','sold','revpar','rev','total'];data.push({hotel_name:"Total"});var len=data.length-1;listName.forEach(function(name){data[len][name]=data.reduce(function(a,b,i){return a+=i<len?(0,_method.numConvert)(b[name]):0;},0).toFixed(4);});data.forEach(function(item,i){data[i].revper=(0,_method.calculation)(item.rev,item.total,4);data[i].occ=(0,_method.calculation)(item.sold,item.ava,4);data[i].adr=(0,_method.calculation)(item.rev,item.sold,2);data[i].revpar=(0,_method.calculation)(item.rev,item.ava,2);});return data;};var _method=__webpack_require__(20);var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var color=['#4c9bf2','#4AC18E','#D9534F','#67A8E4'];var setKarte=exports.setKarte=function setKarte(_ref,isOnResize){var name=_ref.name,dataY=_ref.dataY,id=_ref.id,dataX=_ref.dataX;var myChart=_echarts2.default.init(document.getElementById(id));myChart.resize();if(isOnResize){return;}var option={title:{text:name,textStyle:{align:'left',color:'#333',fontSize:20},top:'5%',left:'left'},grid:{bottom:80},legend:{top:'30',data:['this year','last year']},color:color,xAxis:{splitLine:{lineStyle:{show:true}},"axisLabel":{textStyle:{fontSize:12,color:'#000'},minInterval:1,rotate:-30},data:dataX},yAxis:{name:name=='Occ%'?'%':'',type:'value'},tooltip:{trigger:'axis'// formatter: `{b}日<br/>{a} : {c}${name == 'Occ%' ? '%' : ''}` 
},toolbox:{id:id,right:20,feature:{saveAsImage:{type:'png',//	设置图片格式 png或者'jpeg
name:name,backgroundColor:'#FFF',excludeComponents:['toolbox'],show:true,title:'保存图片'}}},series:[{name:"this year",type:'bar',barMaxWidth:20,data:dataY[0]},{name:"last year",type:'bar',barMaxWidth:20,data:dataY[1]}]};myChart.setOption(option);};

/***/ }),
/* 1852 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(42);__webpack_require__(14);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _compute=__webpack_require__(1854);var _compute2=_interopRequireDefault(_compute);__webpack_require__(1855);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var Option=_select2.default.Option;var index=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],lastdata:[],loading:true,loadingSave:false,print:false,dateData:[],area:"东南华南"},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(_ref3){var date=_ref3.date,area=_ref3.area,fullYear=_ref3.fullYear;var year,month,res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;year=(0,_moment2.default)(date).format('YYYY');month=(0,_moment2.default)(date).format('M');_context.next=5;return(0,_request2.default)('/_4_2_daily/fullRoom?year='+year+'&month='+month+'&area='+area);case 5:res=_context.sent;_this.setState({loading:false,data:(0,_compute2.default)(res.data||[],date)});_context.next=13;break;case 9:_context.prev=9;_context.t0=_context['catch'](0);console.log(_context.t0);_this.setState({loading:false});case 13:case'end':return _context.stop();}}},_callee,_this2,[[0,9]]);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table4_2_2',1.5,'4.22',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});},_this.downloadExcel=function(){var tableName='\u533A\u57DF\u6EE1\u623F\u62A5\u8868';var innerHtml='\n          <caption>'+tableName+'</caption>\n          '+document.getElementById('table4_2_2_export').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n        ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+'.xls');_this.setState({print:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData({date:this.state.date,area:this.state.area});}},{key:'render',value:function render(){var _this3=this;var _state=this.state,print=_state.print,loading=_state.loading,data=_state.data,date=_state.date,area=_state.area;console.log(data);var columnsMonth=new Array((0,_moment2.default)(date).daysInMonth()).fill(1).reduce(function(a,b,i){return[].concat(_toConsumableArray(a),[{title:date+'-'+(i+1),dataIndex:'m'+(i+1),key:'m'+(i+1),align:"center",width:120,render:function render(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var record=arguments[1];var index=arguments[2];var props={text:text,index:index,type:'percent',name:'m'+(i+1)};return _react2.default.createElement(_TableText2.default,{data:props});}}]);},[]);var columns=[{title:'Hotel',dataIndex:'name',key:'name',align:"center",width:200,fixed:!print&&"left",render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name"};return _react2.default.createElement(_TableText2.default,{data:props});}}].concat(_toConsumableArray(columnsMonth),[{title:'满房天数',dataIndex:'total',key:'total',align:"center",width:120,render:function render(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var record=arguments[1];var index=arguments[2];var props={text:text,index:index,type:'number',name:"total"};if(index==33)props.type='';return _react2.default.createElement(_TableText2.default,{data:props});}}]);return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'table7_1_1 table7_6 table4_2_summary',id:'table4_2_2',style:{height:'auto'}},_react2.default.createElement(_row2.default,{className:'title'},_react2.default.createElement(_row2.default,null,'\u533A\u57DF\u6EE1\u623F\u62A5\u8868'),_react2.default.createElement('div',{className:'title-select'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getData({date:str,area:area});}}),_react2.default.createElement(_select2.default,{allowClear:true,defaultValue:area,style:{width:200,marginLeft:20},onChange:function onChange(value){_this3.setState({data:[],loading:true,area:value},function(){_this3.getData({date:date,area:value});});}},_react2.default.createElement(Option,{value:'\u4E1C\u5357\u534E\u5357'},'\u4E1C\u5357\u534E\u5357'),_react2.default.createElement(Option,{value:'\u534E\u5317\u534E\u4E2D'},'\u534E\u5317\u534E\u4E2D'),_react2.default.createElement(Option,{value:'\u6C5F\u6D59\u6CAA\u7696'},'\u6C5F\u6D59\u6CAA\u7696'),_react2.default.createElement(Option,{value:'\u897F\u5357'},'\u897F\u5357'))),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'table4_2_2_export',pagination:false,className:'content',scroll:print?{}:{y:500,x:1920},rowKey:function rowKey(record,index){return record.name;}}),_react2.default.createElement(_button2.default,{type:'primary',style:{float:'right',marginTop:20},onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:print},'\u5BFC\u51FAExcel'))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setKarte=undefined;exports.default=function(data,date){data.forEach(function(item,i){data[i].total=new Array((0,_moment2.default)(date).daysInMonth()).fill(1).reduce(function(a,b,index){return item["m"+(index+1)]>=1?a+1:a;},0);data[i].name=item.short||item.name||"";});return data;};var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var color=['#4c9bf2','#4AC18E','#D9534F','#67A8E4'];var setKarte=exports.setKarte=function setKarte(_ref,isOnResize){var name=_ref.name,dataY=_ref.dataY,id=_ref.id,dataX=_ref.dataX;var myChart=_echarts2.default.init(document.getElementById(id));myChart.resize();if(isOnResize){return;}var option={title:{text:name,textStyle:{align:'left',color:'#333',fontSize:20},top:'5%',left:'left'},grid:{bottom:80},legend:{top:'30',data:['this year','last year']},color:color,xAxis:{splitLine:{lineStyle:{show:true}},"axisLabel":{textStyle:{fontSize:12,color:'#000'},minInterval:1,rotate:-30},data:dataX},yAxis:{name:name=='Occ%'?'%':'',type:'value'},tooltip:{trigger:'axis'// formatter: `{b}日<br/>{a} : {c}${name == 'Occ%' ? '%' : ''}` 
},toolbox:{id:id,right:20,feature:{saveAsImage:{type:'png',//	设置图片格式 png或者'jpeg
name:name,backgroundColor:'#FFF',excludeComponents:['toolbox'],show:true,title:'保存图片'}}},series:[{name:"this year",type:'bar',barMaxWidth:20,data:dataY[0]},{name:"last year",type:'bar',barMaxWidth:20,data:dataY[1]}]};myChart.setOption(option);};

/***/ }),
/* 1855 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(42);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _data2=__webpack_require__(247);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _method=__webpack_require__(20);var _method2=_interopRequireDefault(_method);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);__webpack_require__(1857);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.setChart=function(data,lastData){_this.setState({data:data,lastData:lastData});};_this.getData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2){var area=_ref2.area;var year,month,lastmonth,res,_index2,lastIndex,data;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;year=(0,_moment2.default)().format('YYYY');month=_data2.chineseNewYear[(0,_moment2.default)().format('Y')].m;lastmonth=_data2.chineseNewYear[(0,_moment2.default)().subtract(1,'year').format('Y')].m;if(area==2){month=5;lastmonth=5;}if(area==3){month=10;lastmonth=10;}_context.next=8;return(0,_request2.default)("/_4_2_daily/holidays?year="+year+"&month="+month+"&lastmonth="+lastmonth);case 8:res=_context.sent;_index2=0;lastIndex=0;if(area==1){// 春节
_index2=_data2.chineseNewYear[(0,_moment2.default)().format('Y')].d-1;lastIndex=_data2.chineseNewYear[(0,_moment2.default)().subtract(1,'year').format('Y')].d-1;}data=res.data.map(function(x){return _extends({name:x.name},new Array(14).fill(1).reduce(function(a,b,i){var _data=i%2==1?x.data:x.lastdata;var _index=(i%2==1?_index2:lastIndex)+Math.floor(i/2);a["%"+(i+1)]=(0,_method2.default)([_index,'occ'],_data);a["ADR"+(i+1)]=(0,_method2.default)([_index,'adr'],_data);return a;},{}));});_this.setState({loading:false,data:data});_context.next=20;break;case 16:_context.prev=16;_context.t0=_context["catch"](0);console.log(_context.t0);_this.setState({loading:false});case 20:case"end":return _context.stop();}}},_callee,_this2,[[0,16]]);}));return function(_x){return _ref.apply(this,arguments);};}();_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table4_2_2',1.5,'4.22',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.downloadExcel=function(){var tableName="4.2.2 \u8282\u65E5\u6C47\u603B\u8868 "+{1:"春节",2:'五一',3:"十一"}[_this.state.area];var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById('table4_2_2_export').innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+".xls");_this.setState({print:false});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,area:"1"};return _this;}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData({area:this.state.area});}},{key:"render",value:function render(){var _this3=this;var _state=this.state,print=_state.print,loading=_state.loading,data=_state.data,area=_state.area;var year=(0,_moment2.default)().format('YYYY');var month=_data2.chineseNewYear[(0,_moment2.default)().format('Y')].m;var lastMonth=_data2.chineseNewYear[(0,_moment2.default)().subtract(1,'year').format('Y')].m;if(area==2)month=lastMonth=5;if(area==3)month=lastMonth=10;var date=year+"-"+month;var lastDate=year-1+"-"+lastMonth;var index=0;var lastIndex=0;if(area==1){// 春节
index=_data2.chineseNewYear[(0,_moment2.default)(date).format('Y')].d-1;lastIndex=_data2.chineseNewYear[(0,_moment2.default)(date).subtract(1,'year').format('Y')].d-1;}var columns=[{title:'Hotel',dataIndex:'name',key:'name',align:"center",width:150,fixed:!print&&'left',render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name"};return _react2.default.createElement(_TableText2.default,{data:props});}}].concat(_toConsumableArray(new Array(14).fill(1).map(function(x,i){var day='';if(Math.floor(i/2)+1+(i%2==1?index:lastIndex)>31)day='-';return{title:(i%2==1?date:lastDate)+("-"+(day||Math.floor(i/2)+1+(i%2==1?index:lastIndex))),children:[{title:'%',dataIndex:"%"+(i+1),key:"%"+(i+1),align:"center",width:100,render:function render(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var record=arguments[1];// const _data = i % 2 == 1 ? record.data : record.lastdata;
// const _index = i % 2 == 1 ? index : lastIndex;
// const value = day ? 0 : getJson([_index, 'occ'], _data);
var props={text:text,index:index,type:'percent',name:"ava"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'ADR',dataIndex:"ADR"+(i+1),key:"ADR"+(i+1),align:"center",width:100,render:function render(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var record=arguments[1];var index=arguments[2];// const _data = i % 2 == 1 ? record.data : record.lastdata;
// const _index = i % 2 == 1 ? index : lastIndex;
// const value = day ? 0 : getJson([_index, 'adr'], _data);
var props={text:text,index:index,type:'number',name:"ava"};return _react2.default.createElement(_TableText2.default,{data:props});}}]};})));return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement("div",{className:"table7_1_1 table7_6 table4_2_summary",id:"table4_2_2",style:{height:'auto'}},_react2.default.createElement(_row2.default,{className:"title"},_react2.default.createElement(_row2.default,null,"4.2.2 \u8282\u65E5\u6C47\u603B\u8868"),_react2.default.createElement("div",{className:"title-select"},_react2.default.createElement(_select2.default,{allowClear:true,defaultValue:area,style:{width:200},onChange:function onChange(value){_this3.setState({data:[],loading:true,area:value},function(){_this3.getData({date:date,area:value});});}},_react2.default.createElement(Option,{value:"1"},"\u6625\u8282"),_react2.default.createElement(Option,{value:"2"},"\u4E94\u4E00"),_react2.default.createElement(Option,{value:"3"},"\u5341\u4E00"))),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:"middle",bordered:true,id:"table4_2_2_export",pagination:false,className:"content",scroll:print?{}:{y:500,x:2950},rowKey:function rowKey(record,index){return record.name;}}),_react2.default.createElement(_button2.default,{type:"primary",style:{float:'right',marginTop:20},onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:print},"\u5BFC\u51FAExcel"))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1857 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _=__webpack_require__(1859);var _2=_interopRequireDefault(_);var _3=__webpack_require__(1860);var _4=_interopRequireDefault(_3);var _5=__webpack_require__(1861);var _6=_interopRequireDefault(_5);var _7=__webpack_require__(1862);var _8=_interopRequireDefault(_7);var _9=__webpack_require__(1863);var _10=_interopRequireDefault(_9);var _11=__webpack_require__(1864);var _12=_interopRequireDefault(_11);var _13=__webpack_require__(1865);var _14=_interopRequireDefault(_13);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",null,_react2.default.createElement(_row2.default,{style:{margin:"24px 0 24px 24px",fontSize:22,color:"#333"}},"4.3 Top Account Analysis \u5173\u952E\u5BA2\u6237\u5206\u6790"),_react2.default.createElement(_2.default,{key:1}),_react2.default.createElement(_4.default,{key:2}),_react2.default.createElement(_8.default,{key:4}),_react2.default.createElement(_10.default,{key:5}));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(25);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(310);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker,RangePicker=_datePicker2.default.RangePicker;function numChange(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'0';var html=Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');return html;}function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var totalName=['m_this_RN','m_this_REV','m_last_RN','m_last_REV','y_this_RN','y_this_REV','y_last_RN','y_last_REV'];var _loop=function _loop(i){data[5][totalName[i]]=data.reduce(function(a,b,index){if(index<5){a+=numConvert(b[totalName[i]]);}return a;},0);data[5][totalName[i]]=data[5][totalName[i]].toFixed(2);};for(var i=0;i<totalName.length;i++){_loop(i);}for(var i=0;i<data.length;i++){data[i].m_this_ADR=(numConvert(data[i].m_this_RN)==0?0:numConvert(data[i].m_this_REV)/numConvert(data[i].m_this_RN)).toFixed(2);data[i].m_last_ADR=(numConvert(data[i].m_last_RN)==0?0:numConvert(data[i].m_last_REV)/numConvert(data[i].m_last_RN)).toFixed(2);data[i].m_ratio_RN=(numConvert(data[i].m_this_RN)-numConvert(data[i].m_last_RN)).toFixed(2);data[i].m_RN_percent=(numConvert(data[i].m_last_RN)==0?0:numConvert(data[i].m_ratio_RN)/numConvert(data[i].m_last_RN)).toFixed(3);data[i].m_ratio_ADR=(numConvert(data[i].m_this_ADR)-numConvert(data[i].m_last_ADR)).toFixed(2);data[i].m_ADR_percent=(numConvert(data[i].m_last_ADR)==0?0:numConvert(data[i].m_ratio_ADR)/numConvert(data[i].m_last_ADR)).toFixed(3);data[i].m_ratio_REV=(numConvert(data[i].m_this_REV)-numConvert(data[i].m_last_REV)).toFixed(2);data[i].m_REV_percent=(numConvert(data[i].m_last_REV)==0?0:numConvert(data[i].m_ratio_REV)/numConvert(data[i].m_last_REV)).toFixed(3);data[i].y_this_ADR=(numConvert(data[i].y_this_RN)==0?0:numConvert(data[i].y_this_REV)/numConvert(data[i].y_this_RN)).toFixed(2);data[i].y_last_ADR=(numConvert(data[i].y_last_RN)==0?0:numConvert(data[i].y_last_REV)/numConvert(data[i].y_last_RN)).toFixed(2);data[i].y_ratio_RN=(numConvert(data[i].y_this_RN)-numConvert(data[i].y_last_RN)).toFixed(2);data[i].y_RN_percent=(numConvert(data[i].y_last_RN)==0?0:numConvert(data[i].y_ratio_RN)/numConvert(data[i].y_last_RN)).toFixed(3);data[i].y_ratio_ADR=(numConvert(data[i].y_this_ADR)-numConvert(data[i].y_last_ADR)).toFixed(2);data[i].y_ADR_percent=(numConvert(data[i].y_last_ADR)==0?0:numConvert(data[i].y_ratio_ADR)/numConvert(data[i].y_last_ADR)).toFixed(3);data[i].y_ratio_REV=(numConvert(data[i].y_this_REV)-numConvert(data[i].y_last_REV)).toFixed(2);}_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data2_4);var data=JSON.parse(dataBegin);fetch('/_4_3_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this.setState({loading:false});if(x.data&&x.data.length>0){if(x.data.length>6){data=[].concat(_toConsumableArray(x.data.filter(function(v,i){return i<=4;})),[x.data[x.data.length-1]]);}else{data=x.data;}}_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_4_3_1',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table4_3_1',1.5,'4.31',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loadingSave:false,loading:true,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var width=document.body.offsetWidth-3450>300?document.body.offsetWidth-3450:300;var columns=[{title:_react2.default.createElement('div',null,'Top 5 E-Commence \u7535\u5B50\u5546\u52A1 \u524D\u4E94\u4F4D'),dataIndex:'name',key:'name',align:"center",fixed:"left",width:width,render:function render(text,record,index){if(index!=5){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var data=_this2.state.data;data[index].name=e.target.value||"";data[index].name_code=e.target.value||"";_this2.setState({data:data});}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' ',style:{textAlign:"left"}},text);}}},{title:'MTD 月累计',align:"center",children:[{align:"center",title:'MTD Actual - This Year 本年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'m_this_RN',key:'m_this_RN',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - This Year 本年当月实际数','R/Ns 间夜'];if(index!=5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_RN',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('m_this_RN',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_RN',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'m_this_ADR',key:'m_this_ADR',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - This Year 本年当月实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_ADR',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'m_this_REV',key:'m_this_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - This Year 本年当月实际数','REV 收益'];if(index==5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_REV',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_REV',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('m_this_REV',value,index);}})));}}}]},{align:"center",title:'MTD Actual - Last Year 去年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'m_last_RN',key:'m_last_RN',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - Last Year 去年当月实际数','R/Ns 间夜'];if(index==5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_RN',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_RN',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('m_last_RN',value,index);}})));}}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'m_last_ADR',key:'m_last_ADR',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - Last Year 去年当月实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_ADR',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'m_last_REV',key:'m_last_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - Last Year 去年当月实际数','REV 收益'];if(index==5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_REV',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_REV',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('m_last_REV',value,index);}})));}}}]},{align:"center",title:'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年',width:900,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'m_ratio_RN',key:'m_ratio_RN',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance-This Year vs. Last Year 当月差异-今年对比去年','R/Ns 间夜'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ratio_RN',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'m_RN_percent',key:'m_RN_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance-This Year vs. Last Year 当月差异-今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_RN_percent',title:title,sqlName:"_4_3_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==5?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'ADR  \u5E73\u5747\u623F\u4EF7'),dataIndex:'m_ratio_ADR',key:'m_ratio_ADR',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance-This Year vs. Last Year 当月差异-今年对比去年','ADR  平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ratio_ADR',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'m_ADR_percent',key:'m_ADR_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance-This Year vs. Last Year 当月差异-今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ADR_percent',title:title,sqlName:"_4_3_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==5?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'m_ratio_REV',key:'m_ratio_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance-This Year vs. Last Year 当月差异-今年对比去年','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ratio_REV',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'m_REV_percent',key:'m_REV_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance-This Year vs. Last Year 当月差异-今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_REV_percent',title:title,sqlName:"_4_3_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==5?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}}]}]},{title:'YTD 本年累计',align:"center",children:[{align:"center",title:'YTD Actual - This Year 本年累计实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'y_this_RN',key:'y_this_RN',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - This Year 本年累计实际数','R/Ns 间夜'];if(index!=5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_RN',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('y_this_RN',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_RN',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'y_this_ADR',key:'y_this_ADR',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - This Year 本年累计实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_ADR',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'y_this_REV',key:'y_this_REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - This Year 本年累计实际数','REV 收益'];if(index==5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_REV',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_REV',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('y_this_REV',value,index);}})));}}}]},{align:"center",title:'YTD Actual - Last Year 去年累计实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'y_last_RN',key:'y_last_RN',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - Last Year 去年累计实际数','R/Ns 间夜'];if(index==5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_RN',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_RN',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('y_last_RN',value,index);}})));}}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'y_last_ADR',key:'y_last_ADR',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - Last Year 去年累计实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_ADR',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'y_last_REV',key:'y_last_REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - Last Year 去年累计实际数','REV 收益'];if(index==5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_REV',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_REV',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('y_last_REV',value,index);}})));}}}]},{align:"center",title:'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',width:900,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'y_ratio_RN',key:'y_ratio_RN',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance-This Year vs. Last Year 年累计差异-今年对比去年','R/Ns 间夜'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ratio_RN',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'y_RN_percent',key:'y_RN_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance-This Year vs. Last Year 年累计差异-今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_RN_percent',title:title,sqlName:"_4_3_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==5?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'ADR  \u5E73\u5747\u623F\u4EF7'),dataIndex:'y_ratio_ADR',key:'y_ratio_ADR',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance-This Year vs. Last Year 年累计差异-今年对比去年','ADR  平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ratio_ADR',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'y_ADR_percent',key:'y_ADR_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance-This Year vs. Last Year 年累计差异-今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ADR_percent',title:title,sqlName:"_4_3_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==5?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'y_ratio_REV',key:'y_ratio_REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance-This Year vs. Last Year 年累计差异-今年对比去年','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ratio_REV',title:title,sqlName:"_4_3_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}}]}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_3_1',style:{width:this.state.print?3800:'auto'}},_react2.default.createElement(_row2.default,null,'4.3.1 E-Commence\u7535\u5B50\u5546\u52A1'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',style:{width:this.state.print?3750:'auto'},scroll:this.state.print?{}:{x:3750,y:550},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_4_3'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(8);__webpack_require__(6);__webpack_require__(4);__webpack_require__(35);__webpack_require__(25);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(698);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker,RangePicker=_datePicker2.default.RangePicker;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};function numChange(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'0';var html=Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');return html;}function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var totalName=['m_this_RN','m_this_REV','m_last_RN','m_last_REV','y_this_RN','y_this_REV','y_last_RN','y_last_REV'];var _loop=function _loop(i){data[10][totalName[i]]=data.reduce(function(a,b,index){if(index<10){a+=numConvert(b[totalName[i]]);}return a;},0);data[10][totalName[i]]=data[10][totalName[i]].toFixed(2);};for(var i=0;i<totalName.length;i++){_loop(i);}for(var i=0;i<data.length;i++){data[i].m_this_ADR=(numConvert(data[i].m_this_RN)==0?0:numConvert(data[i].m_this_REV)/numConvert(data[i].m_this_RN)).toFixed(2);data[i].m_last_ADR=(numConvert(data[i].m_last_RN)==0?0:numConvert(data[i].m_last_REV)/numConvert(data[i].m_last_RN)).toFixed(2);data[i].m_ratio_RN=(numConvert(data[i].m_this_RN)-numConvert(data[i].m_last_RN)).toFixed(2);data[i].m_RN_percent=(numConvert(data[i].m_last_RN)==0?0:numConvert(data[i].m_ratio_RN)/numConvert(data[i].m_last_RN)).toFixed(3);data[i].m_ratio_ADR=(numConvert(data[i].m_this_ADR)-numConvert(data[i].m_last_ADR)).toFixed(2);data[i].m_ADR_percent=(numConvert(data[i].m_last_ADR)==0?0:numConvert(data[i].m_ratio_ADR)/numConvert(data[i].m_last_ADR)).toFixed(3);data[i].m_ratio_REV=(numConvert(data[i].m_this_REV)-numConvert(data[i].m_last_REV)).toFixed(2);data[i].m_REV_percent=(numConvert(data[i].m_last_REV)==0?0:numConvert(data[i].m_ratio_REV)/numConvert(data[i].m_last_REV)).toFixed(3);data[i].y_this_ADR=(numConvert(data[i].y_this_RN)==0?0:numConvert(data[i].y_this_REV)/numConvert(data[i].y_this_RN)).toFixed(2);data[i].y_last_ADR=(numConvert(data[i].y_last_RN)==0?0:numConvert(data[i].y_last_REV)/numConvert(data[i].y_last_RN)).toFixed(2);data[i].y_ratio_RN=(numConvert(data[i].y_this_RN)-numConvert(data[i].y_last_RN)).toFixed(2);data[i].y_RN_percent=(numConvert(data[i].y_last_RN)==0?0:numConvert(data[i].y_ratio_RN)/numConvert(data[i].y_last_RN)).toFixed(3);data[i].y_ratio_ADR=(numConvert(data[i].y_this_ADR)-numConvert(data[i].y_last_ADR)).toFixed(2);data[i].y_ADR_percent=(numConvert(data[i].y_last_ADR)==0?0:numConvert(data[i].y_ratio_ADR)/numConvert(data[i].y_last_ADR)).toFixed(3);data[i].y_ratio_REV=(numConvert(data[i].y_this_REV)-numConvert(data[i].y_last_REV)).toFixed(2);}_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data4_3_2);var data=JSON.parse(dataBegin);fetch('/_4_3_2_all?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this.setState({loading:false});if(x.data.now&&x.data.now.length>0){if(x.data.now.length>10){data=[].concat(_toConsumableArray(x.data.now.filter(function(v,i){return i<=9;})),[x.data.now[x.data.now.length-1]]);}else{data=x.data.now;}}else if(x.data.last&&x.data.last.length>0){}_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_4_3_2',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table4_3_2',1.5,'4.32',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.onFillLastMonth=function(){if(_this.state.data[0]&&_this.state.data[0].id){_message3.default.error('当前月份数据已存在!');_this.setState({loading:false});return;}_this.setState({loading:true,data:[]});var date=_this.state.date;var dataBegin=JSON.stringify(_data.data4_3_2);var data=JSON.parse(dataBegin);fetch('/_4_3_2_all?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.last&&x.data.last.length>0&&(x.data.now||[]).length<=0){data=x.data.last.map(function(v){delete v.id;delete v.month;delete v.year;return v;});};_message3.default.info('数据填充成功！');_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loadingSave:false,loading:true,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);// this.computeNum(this.state.data)
}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var width=document.body.offsetWidth-2450>300?document.body.offsetWidth-2450:300;var columns=[{title:_react2.default.createElement('div',null,'  Corporate Volume Account ',_react2.default.createElement('br',null),' \u534F\u8BAE\u516C\u53F8\u4EA7\u91CF\u6392\u540D'),dataIndex:'name',key:'name',align:"center",fixed:"left",width:width,render:function render(text,record,index){if(index!=10){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var data=_this2.state.data;data[index].name=e.target.value||"";data[index].name_code=e.target.value||"";_this2.setState({data:data});}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' ',style:{textAlign:"left"}},text);}}},{title:'MTD 月累计',align:"center",children:[{align:"center",title:'MTD Actual - This Year 本年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'m_this_RN',key:'m_this_RN',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - This Year 本年当月实际数','R/Ns 间夜'];if(index!=10){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_RN',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('m_this_RN',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_RN',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'m_this_ADR',key:'m_this_ADR',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - This Year 本年当月实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_ADR',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'m_this_REV',key:'m_this_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - This Year 本年当月实际数','REV 收益'];if(index==10){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_REV',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_REV',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('m_this_REV',value,index);}})));}}}]},{align:"center",title:'MTD Actual - Last Year 去年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'m_last_RN',key:'m_last_RN',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - Last Year 去年当月实际数','R/Ns 间夜'];if(index==10){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_RN',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_RN',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('m_last_RN',value,index);}})));}}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'m_last_ADR',key:'m_last_ADR',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - Last Year 去年当月实际数','R/Ns 间夜'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_ADR',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'m_last_REV',key:'m_last_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - Last Year 去年当月实际数','REV 收益'];if(index==10){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_REV',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_REV',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('m_last_REV',value,index);}})));}}}]},{align:"center",title:'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年',width:900,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'m_ratio_RN',key:'m_ratio_RN',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','R/Ns 间夜'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ratio_RN',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'m_RN_percent',key:'m_RN_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_RN_percent',title:title,sqlName:"_4_3_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==10?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'ADR  \u5E73\u5747\u623F\u4EF7'),dataIndex:'m_ratio_ADR',key:'m_ratio_ADR',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','ADR  平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ratio_ADR',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'m_ADR_percent',key:'m_ADR_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ADR_percent',title:title,sqlName:"_4_3_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==10?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'m_ratio_REV',key:'m_ratio_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ratio_REV',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'m_REV_percent',key:'m_REV_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_REV_percent',title:title,sqlName:"_4_3_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==10?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}}]}]},{title:'YTD 本年累计',align:"center",children:[{align:"center",title:'YTD Actual - This Year 本年累计实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'y_this_RN',key:'y_this_RN',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - This Year 本年累计实际数','R/Ns 间夜'];if(index!=10){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_RN',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('y_this_RN',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_RN',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'y_this_ADR',key:'y_this_ADR',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - This Year 本年累计实际数','DR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_ADR',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'y_this_REV',key:'y_this_REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - This Year 本年累计实际数','REV 收益'];if(index==10){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_REV',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_REV',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('y_this_REV',value,index);}})));}}}]},{align:"center",title:'YTD Actual - Last Year 去年累计实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'y_last_RN',key:'y_last_RN',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - Last Year 去年累计实际数','R/Ns 间夜'];if(index==10){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_RN',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_RN',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('y_last_RN',value,index);}})));}}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'y_last_ADR',key:'y_last_ADR',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - Last Year 去年累计实际数','R/Ns 间夜'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_ADR',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'y_last_REV',key:'y_last_REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - Last Year 去年累计实际数','REV 收益'];if(index==10){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_REV',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_REV',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('y_last_REV',value,index);}})));}}}]},{align:"center",title:'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',width:900,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'y_ratio_RN',key:'y_ratio_RN',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','R/Ns 间夜'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ratio_RN',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'y_RN_percent',key:'y_RN_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_RN_percent',title:title,sqlName:"_4_3_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==10?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'ADR  \u5E73\u5747\u623F\u4EF7'),dataIndex:'y_ratio_ADR',key:'y_ratio_ADR',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','ADR  平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ratio_ADR',title:title,sqlName:"_4_3_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'y_ADR_percent',key:'y_ADR_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ADR_percent',title:title,sqlName:"_4_3_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==10?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'y_ratio_REV',key:'y_ratio_REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ratio_REV',title:title,sqlName:"_4_3_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}}]}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_3_2',style:{width:this.state.print?3800:'auto'}},_react2.default.createElement(_row2.default,null,'4.3.2 Top 10 Corporate Account \u534F\u8BAE\u516C\u53F8\u524D\u5341\u4F4D'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}}),_react2.default.createElement(_button2.default,{type:'primary',style:{marginLeft:10,display:this.state.print?'none':''},onClick:this.onFillLastMonth},'\u586B\u5145\u4E0A\u6708\u6570\u636E')),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',style:{width:this.state.print?3750:'auto'},scroll:this.state.print?{}:{x:3750,y:550},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_4_3'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(8);__webpack_require__(6);__webpack_require__(4);__webpack_require__(35);__webpack_require__(25);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(310);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker,RangePicker=_datePicker2.default.RangePicker;function numChange(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'0';var html=Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');return html;}function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var totalName=['m_this_RN','m_this_REV','m_last_RN','m_last_REV','y_this_RN','y_this_REV','y_last_RN','y_last_REV'];var _loop=function _loop(i){data[20][totalName[i]]=data.reduce(function(a,b,index){if(index<20){a+=numConvert(b[totalName[i]]);}return a;},0);data[20][totalName[i]]=data[20][totalName[i]].toFixed(2);};for(var i=0;i<totalName.length;i++){_loop(i);}for(var i=0;i<data.length;i++){data[i].m_this_ADR=(numConvert(data[i].m_this_RN)==0?0:numConvert(data[i].m_this_REV)/numConvert(data[i].m_this_RN)).toFixed(2);data[i].m_last_ADR=(numConvert(data[i].m_last_RN)==0?0:numConvert(data[i].m_last_REV)/numConvert(data[i].m_last_RN)).toFixed(2);data[i].m_ratio_RN=(numConvert(data[i].m_this_RN)-numConvert(data[i].m_last_RN)).toFixed(2);data[i].m_RN_percent=(numConvert(data[i].m_last_RN)==0?0:numConvert(data[i].m_ratio_RN)/numConvert(data[i].m_last_RN)).toFixed(3);data[i].m_ratio_ADR=(numConvert(data[i].m_this_ADR)-numConvert(data[i].m_last_ADR)).toFixed(2);data[i].m_ADR_percent=(numConvert(data[i].m_last_ADR)==0?0:numConvert(data[i].m_ratio_ADR)/numConvert(data[i].m_last_ADR)).toFixed(3);data[i].m_ratio_REV=(numConvert(data[i].m_this_REV)-numConvert(data[i].m_last_REV)).toFixed(2);data[i].m_REV_percent=(numConvert(data[i].m_last_REV)==0?0:numConvert(data[i].m_ratio_REV)/numConvert(data[i].m_last_REV)).toFixed(3);data[i].y_this_ADR=(numConvert(data[i].y_this_RN)==0?0:numConvert(data[i].y_this_REV)/numConvert(data[i].y_this_RN)).toFixed(2);data[i].y_last_ADR=(numConvert(data[i].y_last_RN)==0?0:numConvert(data[i].y_last_REV)/numConvert(data[i].y_last_RN)).toFixed(2);data[i].y_ratio_RN=(numConvert(data[i].y_this_RN)-numConvert(data[i].y_last_RN)).toFixed(2);data[i].y_RN_percent=(numConvert(data[i].y_last_RN)==0?0:numConvert(data[i].y_ratio_RN)/numConvert(data[i].y_last_RN)).toFixed(3);data[i].y_ratio_ADR=(numConvert(data[i].y_this_ADR)-numConvert(data[i].y_last_ADR)).toFixed(2);data[i].y_ADR_percent=(numConvert(data[i].y_last_ADR)==0?0:numConvert(data[i].y_ratio_ADR)/numConvert(data[i].y_last_ADR)).toFixed(3);data[i].y_ratio_REV=(numConvert(data[i].y_this_REV)-numConvert(data[i].y_last_REV)).toFixed(2);}_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;// this.setState({
//     data
// });
_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data2_4);var data=JSON.parse(dataBegin);fetch('/_4_3_3_all?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this.setState({loading:false});if(x.data.now&&x.data.now.length>0){data=x.data.now;}else if(x.data.last&&x.data.last.length>0){// data = x.data.last;
}_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_4_3_3',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table4_3_3',1.5,'4.33',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.onFillLastMonth=function(){if(_this.state.data[0]&&_this.state.data[0].id){_message3.default.error('当前月份数据已存在!');_this.setState({loading:false});return;}_this.setState({loading:true,data:[]});var date=_this.state.date;var dataBegin=JSON.stringify(_data.data2_4);var data=JSON.parse(dataBegin);fetch('/_4_3_2_all?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.last&&x.data.last.length>0&&(x.data.now||[]).length<=0){data=x.data.last.map(function(v){delete v.id;delete v.month;delete v.year;return v;});};_message3.default.info('数据填充成功！');_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loadingSave:false,loading:true,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);// this.computeNum(this.state.data)
}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var width=document.body.offsetWidth-3450>300?document.body.offsetWidth-3450:300;var columns=[{title:_react2.default.createElement('div',null,' Government Account  ',_react2.default.createElement('br',null),'\u653F\u5E9C\u5355\u4F4D\u4EA7\u91CF\u6392\u540D '),dataIndex:'name',key:'name',align:"center",fixed:"left",width:width,render:function render(text,record,index){if(index!=20){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var data=_this2.state.data;data[index].name=e.target.value||"";data[index].name_code=e.target.value||"";_this2.setState({data:data});}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index==20?'table-color-footer':'')+' ',style:{textAlign:"left"}},text);}}},{title:'MTD 月累计',align:"center",children:[{align:"center",title:'MTD Actual - This Year 本年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'m_this_RN',key:'m_this_RN',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - This Year 本年当月实际数','R/Ns 间夜'];if(index!=20){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_RN',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('m_this_RN',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_RN',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==20?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'m_this_ADR',key:'m_this_ADR',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - This Year 本年当月实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_ADR',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==20?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'m_this_REV',key:'m_this_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - This Year 本年当月实际数','REV 收益'];if(index==20){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_REV',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_REV',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('m_this_REV',value,index);}})));}}}]},{align:"center",title:'MTD Actual - Last Year 去年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'m_last_RN',key:'m_last_RN',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - Last Year 去年当月实际数','R/Ns 间夜'];if(index==20){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_RN',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_RN',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('m_last_RN',value,index);}})));}}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'m_last_ADR',key:'m_last_ADR',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - Last Year 去年当月实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_ADR',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==20?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'m_last_REV',key:'m_last_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - Last Year 去年当月实际数','REV 收益'];if(index==20){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_REV',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_REV',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('m_last_REV',value,index);}})));}}}]},{align:"center",title:'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年',width:900,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'m_ratio_RN',key:'m_ratio_RN',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance-This Year vs. Last Year 当月差异-今年对比去年','R/Ns 间夜'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ratio_RN',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==20?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'m_RN_percent',key:'m_RN_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance-This Year vs. Last Year 当月差异-今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_RN_percent',title:title,sqlName:"_4_3_3",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==20?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'ADR  \u5E73\u5747\u623F\u4EF7'),dataIndex:'m_ratio_ADR',key:'m_ratio_ADR',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance-This Year vs. Last Year 当月差异-今年对比去年','ADR  平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ratio_ADR',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==20?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'m_ADR_percent',key:'m_ADR_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance-This Year vs. Last Year 当月差异-今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ADR_percent',title:title,sqlName:"_4_3_3",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==20?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'m_ratio_REV',key:'m_ratio_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance-This Year vs. Last Year 当月差异-今年对比去年','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ratio_REV',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==20?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'m_REV_percent',key:'m_REV_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance-This Year vs. Last Year 当月差异-今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_REV_percent',title:title,sqlName:"_4_3_3",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==20?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}}]}]},{title:'YTD 本年累计',align:"center",children:[{align:"center",title:'YTD Actual - This Year 本年累计实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'y_this_RN',key:'y_this_RN',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - This Year 本年累计实际数','R/Ns 间夜'];if(index!=20){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_RN',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('y_this_RN',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_RN',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==20?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'y_this_ADR',key:'y_this_ADR',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - This Year 本年累计实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_ADR',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==20?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'y_this_REV',key:'y_this_REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - This Year 本年累计实际数','REV 收益'];if(index==20){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_REV',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_REV',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('y_this_REV',value,index);}})));}}}]},{align:"center",title:'YTD Actual - Last Year 去年累计实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'y_last_RN',key:'y_last_RN',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - Last Year 去年累计实际数','R/Ns 间夜'];if(index==20){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_RN',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_RN',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('y_last_RN',value,index);}})));}}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'y_last_ADR',key:'y_last_ADR',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - Last Year 去年累计实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_ADR',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==20?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'y_last_REV',key:'y_last_REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - Last Year 去年累计实际数','REV 收益'];if(index==20){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_REV',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_REV',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('y_last_REV',value,index);}})));}}}]},{align:"center",title:'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',width:900,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'y_ratio_RN',key:'y_ratio_RN',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','R/Ns 间夜'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ratio_RN',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==20?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'y_RN_percent',key:'y_RN_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_RN_percent',title:title,sqlName:"_4_3_3",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==20?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'ADR  \u5E73\u5747\u623F\u4EF7'),dataIndex:'y_ratio_ADR',key:'y_ratio_ADR',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','ADR  平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ratio_ADR',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==20?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'y_ADR_percent',key:'y_ADR_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ADR_percent',title:title,sqlName:"_4_3_3",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==20?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'y_ratio_REV',key:'y_ratio_REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ratio_REV',title:title,sqlName:"_4_3_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==20?'table-color-footer':'')+' '},numChange(text)));}}]}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_3_3',style:{width:this.state.print?3800:'auto'}},_react2.default.createElement(_row2.default,null,'4.3.3 Government Account \u653F\u5E9C\u5355\u4F4D'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}}),_react2.default.createElement(_button2.default,{type:'primary',style:{marginLeft:10,display:this.state.print?'none':''},onClick:this.onFillLastMonth},'\u586B\u5145\u4E0A\u6708\u6570\u636E')),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',style:{width:this.state.print?3750:'auto'},scroll:this.state.print?{}:{x:3750,y:550},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_4_3'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(25);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(698);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker,RangePicker=_datePicker2.default.RangePicker;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};function numChange(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'0';var html=Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');return html;}function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var totalName=['m_this_RN','m_this_REV','m_last_RN','m_last_REV','y_this_RN','y_this_REV','y_last_RN','y_last_REV'];var _loop=function _loop(i){data[10][totalName[i]]=data.reduce(function(a,b,index){if(index<10){a+=numConvert(b[totalName[i]]);}return a;},0);data[10][totalName[i]]=data[10][totalName[i]].toFixed(2);};for(var i=0;i<totalName.length;i++){_loop(i);}for(var i=0;i<data.length;i++){data[i].m_this_ADR=(numConvert(data[i].m_this_RN)==0?0:numConvert(data[i].m_this_REV)/numConvert(data[i].m_this_RN)).toFixed(2);data[i].m_last_ADR=(numConvert(data[i].m_last_RN)==0?0:numConvert(data[i].m_last_REV)/numConvert(data[i].m_last_RN)).toFixed(2);data[i].m_ratio_RN=(numConvert(data[i].m_this_RN)-numConvert(data[i].m_last_RN)).toFixed(2);data[i].m_RN_percent=(numConvert(data[i].m_last_RN)==0?0:numConvert(data[i].m_ratio_RN)/numConvert(data[i].m_last_RN)).toFixed(3);data[i].m_ratio_ADR=(numConvert(data[i].m_this_ADR)-numConvert(data[i].m_last_ADR)).toFixed(2);data[i].m_ADR_percent=(numConvert(data[i].m_last_ADR)==0?0:numConvert(data[i].m_ratio_ADR)/numConvert(data[i].m_last_ADR)).toFixed(3);data[i].m_ratio_REV=(numConvert(data[i].m_this_REV)-numConvert(data[i].m_last_REV)).toFixed(2);data[i].m_REV_percent=(numConvert(data[i].m_last_REV)==0?0:numConvert(data[i].m_ratio_REV)/numConvert(data[i].m_last_REV)).toFixed(3);data[i].y_this_ADR=(numConvert(data[i].y_this_RN)==0?0:numConvert(data[i].y_this_REV)/numConvert(data[i].y_this_RN)).toFixed(2);data[i].y_last_ADR=(numConvert(data[i].y_last_RN)==0?0:numConvert(data[i].y_last_REV)/numConvert(data[i].y_last_RN)).toFixed(2);data[i].y_ratio_RN=(numConvert(data[i].y_this_RN)-numConvert(data[i].y_last_RN)).toFixed(2);data[i].y_RN_percent=(numConvert(data[i].y_last_RN)==0?0:numConvert(data[i].y_ratio_RN)/numConvert(data[i].y_last_RN)).toFixed(3);data[i].y_ratio_ADR=(numConvert(data[i].y_this_ADR)-numConvert(data[i].y_last_ADR)).toFixed(2);data[i].y_ADR_percent=(numConvert(data[i].y_last_ADR)==0?0:numConvert(data[i].y_ratio_ADR)/numConvert(data[i].y_last_ADR)).toFixed(3);data[i].y_ratio_REV=(numConvert(data[i].y_this_REV)-numConvert(data[i].y_last_REV)).toFixed(2);}_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data4_3_2);var data=JSON.parse(dataBegin);fetch('/_4_3_4_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this.setState({loading:false});if(x.data&&x.data.length>0){if(x.data.length>10){data=[].concat(_toConsumableArray(x.data.filter(function(v,i){return i<=9;})),[x.data[x.data.length-1]]);}else{data=x.data;}}_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_4_3_4',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table4_3_4',1.5,'4.33',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loadingSave:false,loading:true,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);// this.computeNum(this.state.data)
}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var width=document.body.offsetWidth-3450>300?document.body.offsetWidth-3450:300;var columns=[{title:_react2.default.createElement('div',null,'Top 10 Group\uFF08Biz Group & Leisure Group\uFF09',_react2.default.createElement('br',null),' \u56E2\u961F\u5BA2\u6237\u524D\u5341\u4F4D'),dataIndex:'name',key:'name',align:"center",fixed:"left",width:width,render:function render(text,record,index){if(index!=10){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var data=_this2.state.data;data[index].name=e.target.value||"";data[index].name_code=e.target.value||"";_this2.setState({data:data});}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' ',style:{textAlign:"left"}},text);}}},{title:'MTD 月累计',align:"center",children:[{align:"center",title:'MTD Actual - This Year 本年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'m_this_RN',key:'m_this_RN',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - This Year 本年当月实际数','R/Ns 间夜'];if(index!=10){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_RN',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('m_this_RN',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_RN',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'m_this_ADR',key:'m_this_ADR',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - This Year 本年当月实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_ADR',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'m_this_REV',key:'m_this_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - This Year 本年当月实际数','REV 收益'];if(index==10){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_REV',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_REV',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('m_this_REV',value,index);}})));}}}]},{align:"center",title:'MTD Actual - Last Year 去年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'m_last_RN',key:'m_last_RN',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - Last Year 去年当月实际数','R/Ns 间夜'];if(index==10){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_RN',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_RN',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('m_last_RN',value,index);}})));}}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'m_last_ADR',key:'m_last_ADR',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - Last Year 去年当月实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_ADR',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'m_last_REV',key:'m_last_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - Last Year 去年当月实际数','REV 收益'];if(index==10){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_REV',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_REV',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('m_last_REV',value,index);}})));}}}]},{align:"center",title:'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年',width:900,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'m_ratio_RN',key:'m_ratio_RN',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','R/Ns 间夜'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ratio_RN',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'m_RN_percent',key:'m_RN_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_RN_percent',title:title,sqlName:"_4_3_4",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==10?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'ADR  \u5E73\u5747\u623F\u4EF7'),dataIndex:'m_ratio_ADR',key:'m_ratio_ADR',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ratio_ADR',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'m_ADR_percent',key:'m_ADR_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ADR_percent',title:title,sqlName:"_4_3_4",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==10?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'m_ratio_REV',key:'m_ratio_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ratio_REV',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'m_REV_percent',key:'m_REV_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_REV_percent',title:title,sqlName:"_4_3_4",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==10?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}}]}]},{title:'YTD 本年累计',align:"center",children:[{align:"center",title:'YTD Actual - This Year 本年累计实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'y_this_RN',key:'y_this_RN',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - This Year 本年累计实际数','R/Ns 间夜'];if(index!=10){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_RN',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('y_this_RN',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_RN',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'y_this_ADR',key:'y_this_ADR',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - This Year 本年累计实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_ADR',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'y_this_REV',key:'y_this_REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - This Year 本年累计实际数','REV 收益'];if(index==10){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_REV',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_REV',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('y_this_REV',value,index);}})));}}}]},{align:"center",title:'YTD Actual - Last Year 去年累计实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'y_last_RN',key:'y_last_RN',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - Last Year 去年累计实际数','R/Ns 间夜'];if(index==10){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_RN',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_RN',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('y_last_RN',value,index);}})));}}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'y_last_ADR',key:'y_last_ADR',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - Last Year 去年累计实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_ADR',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'y_last_REV',key:'y_last_REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - Last Year 去年累计实际数','REV 收益'];if(index==10){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_REV',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_REV',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('y_last_REV',value,index);}})));}}}]},{align:"center",title:'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',width:900,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'y_ratio_RN',key:'y_ratio_RN',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','R/Ns 间夜'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ratio_RN',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'y_RN_percent',key:'y_RN_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_RN_percent',title:title,sqlName:"_4_3_4",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==10?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'ADR  \u5E73\u5747\u623F\u4EF7'),dataIndex:'y_ratio_ADR',key:'y_ratio_ADR',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','ADR  平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ratio_ADR',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'y_ADR_percent',key:'y_ADR_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ADR_percent',title:title,sqlName:"_4_3_4",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==10?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'y_ratio_REV',key:'y_ratio_REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ratio_REV',title:title,sqlName:"_4_3_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==10?'table-color-footer':'')+' '},numChange(text)));}}]}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_3_4',style:{width:this.state.print?3800:'auto'}},_react2.default.createElement(_row2.default,null,'4.3.3  Group\uFF08Biz Group & Leisure Group\uFF09\u56E2\u961F\u5BA2\u6237 '),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',style:{width:this.state.print?3750:'auto'},scroll:this.state.print?{}:{x:3750,y:550},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_4_3'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(25);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(310);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker,RangePicker=_datePicker2.default.RangePicker;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};function numChange(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'0';var html=Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');return html;}function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var totalName=['m_this_RN','m_this_REV','m_last_RN','m_last_REV','y_this_RN','y_this_REV','y_last_RN','y_last_REV'];var _loop=function _loop(i){data[5][totalName[i]]=data.reduce(function(a,b,index){if(index<5){a+=numConvert(b[totalName[i]]);}return a;},0);data[5][totalName[i]]=data[5][totalName[i]].toFixed(2);};for(var i=0;i<totalName.length;i++){_loop(i);}for(var i=0;i<data.length;i++){data[i].m_this_ADR=(numConvert(data[i].m_this_RN)==0?0:numConvert(data[i].m_this_REV)/numConvert(data[i].m_this_RN)).toFixed(2);data[i].m_last_ADR=(numConvert(data[i].m_last_RN)==0?0:numConvert(data[i].m_last_REV)/numConvert(data[i].m_last_RN)).toFixed(2);data[i].m_ratio_RN=(numConvert(data[i].m_this_RN)-numConvert(data[i].m_last_RN)).toFixed(2);data[i].m_RN_percent=(numConvert(data[i].m_last_RN)==0?0:numConvert(data[i].m_ratio_RN)/numConvert(data[i].m_last_RN)).toFixed(3);data[i].m_ratio_ADR=(numConvert(data[i].m_this_ADR)-numConvert(data[i].m_last_ADR)).toFixed(2);data[i].m_ADR_percent=(numConvert(data[i].m_last_ADR)==0?0:numConvert(data[i].m_ratio_ADR)/numConvert(data[i].m_last_ADR)).toFixed(3);data[i].m_ratio_REV=(numConvert(data[i].m_this_REV)-numConvert(data[i].m_last_REV)).toFixed(2);data[i].m_REV_percent=(numConvert(data[i].m_last_REV)==0?0:numConvert(data[i].m_ratio_REV)/numConvert(data[i].m_last_REV)).toFixed(3);data[i].y_this_ADR=(numConvert(data[i].y_this_RN)==0?0:numConvert(data[i].y_this_REV)/numConvert(data[i].y_this_RN)).toFixed(2);data[i].y_last_ADR=(numConvert(data[i].y_last_RN)==0?0:numConvert(data[i].y_last_REV)/numConvert(data[i].y_last_RN)).toFixed(2);data[i].y_ratio_RN=(numConvert(data[i].y_this_RN)-numConvert(data[i].y_last_RN)).toFixed(2);data[i].y_RN_percent=(numConvert(data[i].y_last_RN)==0?0:numConvert(data[i].y_ratio_RN)/numConvert(data[i].y_last_RN)).toFixed(3);data[i].y_ratio_ADR=(numConvert(data[i].y_this_ADR)-numConvert(data[i].y_last_ADR)).toFixed(2);data[i].y_ADR_percent=(numConvert(data[i].y_last_ADR)==0?0:numConvert(data[i].y_ratio_ADR)/numConvert(data[i].y_last_ADR)).toFixed(3);data[i].y_ratio_REV=(numConvert(data[i].y_this_REV)-numConvert(data[i].y_last_REV)).toFixed(2);}_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;// this.setState({
//     data
// });
_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data2_4);var data=JSON.parse(dataBegin);fetch('/_4_3_5_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this.setState({loading:false});if(x.data&&x.data.length>0){if(x.data.length>6){data=[].concat(_toConsumableArray(x.data.filter(function(v,i){return i<=4;})),[x.data[x.data.length-1]]);}else{data=x.data;}}_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_4_3_5',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table4_3_5',1.5,'4.34',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loadingSave:false,loading:true,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);// this.computeNum(this.state.data)
}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var width=document.body.offsetWidth-3450>300?document.body.offsetWidth-3450:300;var columns=[{title:_react2.default.createElement('div',null,'Top 5 Wholesaler Agent Account',_react2.default.createElement('br',null),' \u65C5\u884C\u793E\u6279\u53D1\u5546\u4EA7\u91CF\u6392\u540D\u524D\u4E94\u4F4D'),dataIndex:'name',key:'name',align:"center",fixed:"left",width:width,render:function render(text,record,index){if(index!=5){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var data=_this2.state.data;data[index].name=e.target.value||"";data[index].name_code=e.target.value||"";_this2.setState({data:data});}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' ',style:{textAlign:"left"}},text);}}},{title:'MTD 月累计',align:"center",children:[{align:"center",title:'MTD Actual - This Year 本年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'m_this_RN',key:'m_this_RN',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - This Year 本年当月实际数','R/Ns 间夜'];if(index!=5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_RN',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('m_this_RN',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_RN',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'m_this_ADR',key:'m_this_ADR',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - This Year 本年当月实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_ADR',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'m_this_REV',key:'m_this_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - This Year 本年当月实际数','REV 收益'];if(index==5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_REV',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_REV',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('m_this_REV',value,index);}})));}}}]},{align:"center",title:'MTD Actual - Last Year 去年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'m_last_RN',key:'m_last_RN',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - Last Year 去年当月实际数','R/Ns 间夜'];if(index==5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_RN',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_RN',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('m_last_RN',value,index);}})));}}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'m_last_ADR',key:'m_last_ADR',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - Last Year 去年当月实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_ADR',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'m_last_REV',key:'m_last_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - Last Year 去年当月实际数','REV 收益'];if(index==5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_REV',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_REV',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('m_last_REV',value,index);}})));}}}]},{align:"center",title:'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年',width:900,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'m_ratio_RN',key:'m_ratio_RN',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','R/Ns 间夜'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ratio_RN',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'m_RN_percent',key:'m_RN_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_RN_percent',title:title,sqlName:"_4_3_5",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==5?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'ADR  \u5E73\u5747\u623F\u4EF7'),dataIndex:'m_ratio_ADR',key:'m_ratio_ADR',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','ADR  平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ratio_ADR',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'m_ADR_percent',key:'m_ADR_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ADR_percent',title:title,sqlName:"_4_3_5",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==5?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'m_ratio_REV',key:'m_ratio_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ratio_REV',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'m_REV_percent',key:'m_REV_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_REV_percent',title:title,sqlName:"_4_3_5",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==5?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}}]}]},{title:'YTD 本年累计',align:"center",children:[{align:"center",title:'YTD Actual - This Year 本年累计实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'y_this_RN',key:'y_this_RN',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - This Year 本年累计实际数','R/Ns 间夜'];if(index!=5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_RN',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('y_this_RN',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_RN',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'y_this_ADR',key:'y_this_ADR',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - This Year 本年累计实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_ADR',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'y_this_REV',key:'y_this_REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - This Year 本年累计实际数','REV 收益'];if(index==5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_REV',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_REV',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('y_this_REV',value,index);}})));}}}]},{align:"center",title:'YTD Actual - Last Year 去年累计实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'y_last_RN',key:'y_last_RN',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - Last Year 去年累计实际数','R/Ns 间夜'];if(index==5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_RN',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_RN',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('y_last_RN',value,index);}})));}}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'y_last_ADR',key:'y_last_ADR',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - Last Year 去年累计实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_ADR',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'y_last_REV',key:'y_last_REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - Last Year 去年累计实际数','REV 收益'];if(index==5){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_REV',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-footer '},numChange(text)));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_REV',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('y_last_REV',value,index);}})));}}}]},{align:"center",title:'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',width:900,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'y_ratio_RN',key:'y_ratio_RN',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','R/Ns 间夜'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ratio_RN',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'y_RN_percent',key:'y_RN_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_RN_percent',title:title,sqlName:"_4_3_5",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==5?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'ADR  \u5E73\u5747\u623F\u4EF7'),dataIndex:'y_ratio_ADR',key:'y_ratio_ADR',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','ADR  平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ratio_ADR',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'y_ADR_percent',key:'y_ADR_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ADR_percent',title:title,sqlName:"_4_3_5",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index==5?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'y_ratio_REV',key:'y_ratio_REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ratio_REV',title:title,sqlName:"_4_3_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')+' '},numChange(text)));}}]}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_3_5',style:{width:this.state.print?3800:'auto'}},_react2.default.createElement(_row2.default,null,'4.3.4 Wholesaler \u65C5\u884C\u793E\u6279\u53D1\u5546 '),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',style:{width:this.state.print?3750:'auto'},scroll:this.state.print?{}:{x:3750,y:550},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_4_3'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(310);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker,RangePicker=_datePicker2.default.RangePicker;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};function numChange(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'0';var html=Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');return html;}function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var totalName=['m_this_RN','m_this_REV','m_last_RN','m_last_REV','m_ratio_RN','m_ratio_REV','y_this_RN','y_this_REV','y_last_RN','y_last_REV','y_ratio_RN','y_ratio_REV'];var _loop=function _loop(i){data[5][totalName[i]]=data.reduce(function(a,b,index){if(index<5){a+=numConvert(b[totalName[i]]);}return a;},0);data[5][totalName[i]]=data[5][totalName[i]].toFixed(2);};for(var i=0;i<totalName.length;i++){_loop(i);}data[5].m_this_ADR=(numConvert(data[5].m_this_RN)==0?0:numConvert(data[5].m_this_REV)/numConvert(data[5].m_this_RN)).toFixed(2);data[5].m_last_ADR=(numConvert(data[5].m_last_RN)==0?0:numConvert(data[5].m_last_REV)/numConvert(data[5].m_last_RN)).toFixed(2);data[5].m_RN_percent=(numConvert(data[5].m_last_RN)==0?0:numConvert(data[5].m_ratio_RN)/numConvert(data[5].m_last_RN)).toFixed(3);data[5].m_ratio_ADR=(numConvert(data[5].m_this_ADR)-numConvert(data[5].m_last_ADR)).toFixed(2);data[5].m_ADR_percent=(numConvert(data[5].m_last_ADR)==0?0:numConvert(data[5].m_ratio_ADR)/numConvert(data[5].m_last_ADR)).toFixed(3);data[5].m_REV_percent=(numConvert(data[5].m_last_REV)==0?0:numConvert(data[5].m_ratio_REV)/numConvert(data[5].m_last_REV)).toFixed(3);data[5].y_this_ADR=(numConvert(data[5].y_this_RN)==0?0:numConvert(data[5].y_this_REV)/numConvert(data[5].y_this_RN)).toFixed(2);data[5].y_last_ADR=(numConvert(data[5].y_last_RN)==0?0:numConvert(data[5].y_last_REV)/numConvert(data[5].y_last_RN)).toFixed(2);data[5].y_RN_percent=(numConvert(data[5].y_last_RN)==0?0:numConvert(data[5].y_ratio_RN)/numConvert(data[5].y_last_RN)).toFixed(3);data[5].y_ratio_ADR=(numConvert(data[5].y_this_ADR)-numConvert(data[5].y_last_ADR)).toFixed(2);data[5].y_ADR_percent=(numConvert(data[5].y_last_ADR)==0?0:numConvert(data[5].y_ratio_ADR)/numConvert(data[5].y_last_ADR)).toFixed(3);data[7].m_this_RN=(numConvert(data[6].m_this_RN)==0?0:numConvert(data[5].m_this_RN)/numConvert(data[6].m_this_RN)).toFixed(3);data[7].m_this_REV=(numConvert(data[6].m_this_REV)==0?0:numConvert(data[5].m_this_REV)/numConvert(data[6].m_this_REV)).toFixed(3);data[7].m_last_RN=(numConvert(data[6].m_last_RN)==0?0:numConvert(data[5].m_last_RN)/numConvert(data[6].m_last_RN)).toFixed(3);data[7].m_last_REV=(numConvert(data[6].m_last_REV)==0?0:numConvert(data[5].m_last_REV)/numConvert(data[6].m_last_REV)).toFixed(3);data[7].y_this_RN=(numConvert(data[6].y_this_RN)==0?0:numConvert(data[5].y_this_RN)/numConvert(data[6].y_this_RN)).toFixed(3);data[7].y_this_REV=(numConvert(data[6].y_this_REV)==0?0:numConvert(data[5].y_this_REV)/numConvert(data[6].y_this_REV)).toFixed(3);data[7].y_last_RN=(numConvert(data[6].y_last_RN)==0?0:numConvert(data[5].y_last_RN)/numConvert(data[6].y_last_RN)).toFixed(3);data[7].y_last_REV=(numConvert(data[6].y_last_REV)==0?0:numConvert(data[5].y_last_REV)/numConvert(data[6].y_last_REV)).toFixed(3);_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;// this.setState({
//     data
// });
_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data4_3_6);var data=JSON.parse(dataBegin);fetch('/_4_3_6_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this.setState({loading:false});if(x.data['4_3_1']&&x.data['4_3_1'].length>0){data[0]=_extends({},x.data['4_3_1'][20],{name:data[0].name,name_code:data[0].name_code});}if(x.data['4_3_2']&&x.data['4_3_2'].length>0){data[1]=_extends({},x.data['4_3_2'][40],{name:data[1].name,name_code:data[1].name_code});}if(x.data['4_3_3']&&x.data['4_3_3'].length>0){data[2]=_extends({},x.data['4_3_3'][20],{name:data[2].name,name_code:data[2].name_code});}if(x.data['4_3_4']&&x.data['4_3_4'].length>0){data[3]=_extends({},x.data['4_3_4'][20],{name:data[3].name,name_code:data[3].name_code});}if(x.data['4_3_5']&&x.data['4_3_5'].length>0){data[4]=_extends({},x.data['4_3_5'][20],{name:data[4].name,name_code:data[4].name_code});}if(x.data['1_1']&&x.data['1_1'].length>0){data[6]=_extends({},data[6],{m_this_RN:x.data['1_1'][1].actual,m_this_ADR:x.data['1_1'][3].actual,m_this_REV:x.data['1_1'][5].actual,m_last_RN:x.data['1_1'][1].last_year,m_last_ADR:x.data['1_1'][3].last_year,m_last_REV:x.data['1_1'][5].last_year,y_this_RN:x.data['1_1'][1].year_actual,y_this_ADR:x.data['1_1'][3].year_actual,y_this_REV:x.data['1_1'][5].year_actual,y_last_RN:x.data['1_1'][1].year_last_year,y_last_ADR:x.data['1_1'][3].year_last_year,y_last_REV:x.data['1_1'][5].year_last_year});}_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_4_3_6',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table4_3_6',1.5,'4.36',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loadingSave:false,loading:true,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);// this.computeNum(this.state.data)
}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var width=document.body.offsetWidth-3450>400?document.body.offsetWidth-3450:400;var columns=[{title:'Statistics 统计数据',dataIndex:'name',key:'name',align:"center",fixed:"left",width:width,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index>4?'table-color-footer':'')+' ',style:{textAlign:"left"}},text);}},{title:'MTD 月累计',align:"center",children:[{align:"center",title:'MTD Actual - This Year 本年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'m_this_RN',key:'m_this_RN',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - This Year 本年当月实际数','R/Ns 间夜'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_RN',title:title,sqlName:"_4_3_6",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>4?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'m_this_ADR',key:'m_this_ADR',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - This Year 本年当月实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_ADR',title:title,sqlName:"_4_3_6",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>4?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'m_this_REV',key:'m_this_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - This Year 本年当月实际数','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_this_REV',title:title,sqlName:"_4_3_6",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>4?'table-color-footer':'')+' '},numChange(text)));}}]},{align:"center",title:'MTD Actual - Last Year 去年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'m_last_RN',key:'m_last_RN',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - Last Year 去年当月实际数','R/Ns 间夜'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_RN',title:title,sqlName:"_4_3_6",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>4?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'m_last_ADR',key:'m_last_ADR',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - Last Year 去年当月实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_ADR',title:title,sqlName:"_4_3_6",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>4?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'m_last_REV',key:'m_last_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Actual - Last Year 去年当月实际数','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_last_REV',title:title,sqlName:"_4_3_6",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>4?'table-color-footer':'')+' '},numChange(text)));}}]},{align:"center",title:'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年',width:900,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'m_ratio_RN',key:'m_ratio_RN',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','R/Ns 间夜'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ratio_RN',title:title,sqlName:"_4_3_6",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>4?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'m_RN_percent',key:'m_RN_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_RN_percent',title:title,sqlName:"_4_3_6",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index>4?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'ADR  \u5E73\u5747\u623F\u4EF7'),dataIndex:'m_ratio_ADR',key:'m_ratio_ADR',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','ADR  平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ratio_ADR',title:title,sqlName:"_4_3_6",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>4?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'m_ADR_percent',key:'m_ADR_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ADR_percent',title:title,sqlName:"_4_3_6",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index>4?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'m_ratio_REV',key:'m_ratio_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_ratio_REV',title:title,sqlName:"_4_3_6",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>4?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'m_REV_percent',key:'m_REV_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD 月累计','MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_REV_percent',title:title,sqlName:"_4_3_6",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index>4?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}}]}]},{title:'YTD 本年累计',align:"center",children:[{align:"center",title:'YTD Actual - This Year 本年累计实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'y_this_RN',key:'y_this_RN',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - This Year 本年累计实际数','R/Ns 间夜'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_RN',title:title,sqlName:"_4_3_6",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>4?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'y_this_ADR',key:'y_this_ADR',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - This Year 本年累计实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_ADR',title:title,sqlName:"_4_3_6",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>4?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'y_this_REV',key:'y_this_REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - This Year 本年累计实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_this_REV',title:title,sqlName:"_4_3_6",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>4?'table-color-footer':'')+' '},numChange(text)));}}]},{align:"center",title:'YTD Actual - Last Year 去年累计实际数',width:450,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'y_last_RN',key:'y_last_RN',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - Last Year 去年累计实际数','R/Ns 间夜'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_RN',title:title,sqlName:"_4_3_6",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>4?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'ADR \u5E73\u5747\u623F\u4EF7'),dataIndex:'y_last_ADR',key:'y_last_ADR',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - Last Year 去年累计实际数','ADR 平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_ADR',title:title,sqlName:"_4_3_6",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>4?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'y_last_REV',key:'y_last_REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Actual - Last Year 去年累计实际数','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_last_REV',title:title,sqlName:"_4_3_6",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>4?'table-color-footer':'')+' '},numChange(text)));}}]},{align:"center",title:'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',width:900,children:[{title:_react2.default.createElement('div',null,'R/Ns \u95F4\u591C'),dataIndex:'y_ratio_RN',key:'y_ratio_RN',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','R/Ns 间夜'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ratio_RN',title:title,sqlName:"_4_3_6",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>4?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'y_RN_percent',key:'y_RN_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_RN_percent',title:title,sqlName:"_4_3_6",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index>4?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'ADR  \u5E73\u5747\u623F\u4EF7'),dataIndex:'y_ratio_ADR',key:'y_ratio_ADR',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','ADR  平均房价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ratio_ADR',title:title,sqlName:"_4_3_6",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>4?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'% \u767E\u5206\u6BD4'),dataIndex:'y_ADR_percent',key:'y_ADR_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ADR_percent',title:title,sqlName:"_4_3_6",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-color '+(index>4?'table-color-footer':''),style:{textAlign:"right",padding:"5px"}},html));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'y_ratio_REV',key:'y_ratio_REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD 本年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'y_ratio_REV',title:title,sqlName:"_4_3_6",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index>4?'table-color-footer':'')+' '},numChange(text)));}}]}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_3_6',style:{width:this.state.print?3900:'auto'}},_react2.default.createElement(_row2.default,null,'4.3.6 Statistics \u7EDF\u8BA1\u6570\u636E'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',style:{width:this.state.print?3850:'auto'},scroll:this.state.print?{}:{x:3850},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_4_3'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:0},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(6);__webpack_require__(4);__webpack_require__(10);__webpack_require__(25);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TextArea=_input2.default.TextArea;var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.getData=function(date){fetch('/_4_3_7_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this.setState({note:_extends({},x.data[0])});}).catch(function(err){console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=[_extends({},_this.state.note,{year:year,month:month})];if(!data[0].note){_message3.default.error('备注不能为空！');var _timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer);},1000);return;}var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_4_3_7',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table4_3_7',1.5,'4.37',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),note:{note:""},loadingSave:false,print:false};return _this;}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){this.getData(this.state.date);}},{key:'render',value:function render(){var _this2=this;return _react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{id:'table4_3_7',style:{padding:20}},_react2.default.createElement(_row2.default,{style:{fontSize:20,color:"#333"}},'4.3.7 Remarks \u5907\u6CE8:'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true,note:{note:""}});_this2.getData(str);}})),_react2.default.createElement(_row2.default,{style:{marginTop:20}},_react2.default.createElement(TextArea,{rows:4,value:this.state.note.note,placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',onChange:function onChange(e){_this2.setState({note:_extends({},_this2.state.note,{note:e.target.value})});}}))),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_4_3'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58'))));}}]);return App;}(_react.Component);exports.default=App;

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(1867);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _compute=__webpack_require__(1868);var _compute2=_interopRequireDefault(_compute);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){data=(0,_compute2.default)(data);_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data2_4);var data=JSON.parse(dataBegin);fetch('/_4_4_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this.setState({loading:false});if(x.data&&x.data.length>0){data=x.data;}_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_4_4',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table4_4_1',1.5,'4.40',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loadingSave:false,loading:true,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,date=_state.date;var width=document.body.offsetWidth-2700>300?document.body.offsetWidth-2700:300;var totalIndex=[10];var columns=[{title:'City(Domestic)/ Country(oversea) Top 10',dataIndex:'name',key:'name',align:"center",fixed:"left",width:width,render:function render(text,record,index){var props={text:text,index:index,type:index==10?'text':'input',name:"name",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}].concat(_toConsumableArray((0,_data.columnsData)(date).map(function(item){return{title:item.title,children:item.children.map(function(x){return{title:x.title,dataIndex:x.key,key:x.key,width:150,render:function render(text,record,index){var props={text:text,index:index,type:index==10&&x.type=='inputNumber'?"number":x.type,name:x.key,onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}};})};})));return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_4_1',style:{width:this.state.print?3050:'auto'}},_react2.default.createElement(_row2.default,null,'4.4 Geographic City(Domestic)/Country(oversea) Top 10'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}}),_react2.default.createElement('span',{style:{color:"#666",fontSize:12,marginLeft:10}},'\u6570\u636E\u6708\u4EFD')),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',style:{width:this.state.print?3000:'auto'},scroll:this.state.print?{}:{x:3000,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_4_4'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data2_4=exports.data2_4=[{name:"",m_rn:0,m_adr:0,m_rev:0,lastm_rn:0,lastm_adr:0,lastm_rev:0,varm_rn:0,varm_adr:0,varm_rev:0,y_rn:0,y_adr:0,y_rev:0,lasty_rn:0,lasty_adr:0,lasty_rev:0,vary_rn:0,vary_adr:0,vary_rev:0},{name:"",m_rn:0,m_adr:0,m_rev:0,lastm_rn:0,lastm_adr:0,lastm_rev:0,varm_rn:0,varm_adr:0,varm_rev:0,y_rn:0,y_adr:0,y_rev:0,lasty_rn:0,lasty_adr:0,lasty_rev:0,vary_rn:0,vary_adr:0,vary_rev:0},{name:"",m_rn:0,m_adr:0,m_rev:0,lastm_rn:0,lastm_adr:0,lastm_rev:0,varm_rn:0,varm_adr:0,varm_rev:0,y_rn:0,y_adr:0,y_rev:0,lasty_rn:0,lasty_adr:0,lasty_rev:0,vary_rn:0,vary_adr:0,vary_rev:0},{name:"",m_rn:0,m_adr:0,m_rev:0,lastm_rn:0,lastm_adr:0,lastm_rev:0,varm_rn:0,varm_adr:0,varm_rev:0,y_rn:0,y_adr:0,y_rev:0,lasty_rn:0,lasty_adr:0,lasty_rev:0,vary_rn:0,vary_adr:0,vary_rev:0},{name:"",m_rn:0,m_adr:0,m_rev:0,lastm_rn:0,lastm_adr:0,lastm_rev:0,varm_rn:0,varm_adr:0,varm_rev:0,y_rn:0,y_adr:0,y_rev:0,lasty_rn:0,lasty_adr:0,lasty_rev:0,vary_rn:0,vary_adr:0,vary_rev:0},{name:"",m_rn:0,m_adr:0,m_rev:0,lastm_rn:0,lastm_adr:0,lastm_rev:0,varm_rn:0,varm_adr:0,varm_rev:0,y_rn:0,y_adr:0,y_rev:0,lasty_rn:0,lasty_adr:0,lasty_rev:0,vary_rn:0,vary_adr:0,vary_rev:0},{name:"",m_rn:0,m_adr:0,m_rev:0,lastm_rn:0,lastm_adr:0,lastm_rev:0,varm_rn:0,varm_adr:0,varm_rev:0,y_rn:0,y_adr:0,y_rev:0,lasty_rn:0,lasty_adr:0,lasty_rev:0,vary_rn:0,vary_adr:0,vary_rev:0},{name:"",m_rn:0,m_adr:0,m_rev:0,lastm_rn:0,lastm_adr:0,lastm_rev:0,varm_rn:0,varm_adr:0,varm_rev:0,y_rn:0,y_adr:0,y_rev:0,lasty_rn:0,lasty_adr:0,lasty_rev:0,vary_rn:0,vary_adr:0,vary_rev:0},{name:"",m_rn:0,m_adr:0,m_rev:0,lastm_rn:0,lastm_adr:0,lastm_rev:0,varm_rn:0,varm_adr:0,varm_rev:0,y_rn:0,y_adr:0,y_rev:0,lasty_rn:0,lasty_adr:0,lasty_rev:0,vary_rn:0,vary_adr:0,vary_rev:0},{name:"",m_rn:0,m_adr:0,m_rev:0,lastm_rn:0,lastm_adr:0,lastm_rev:0,varm_rn:0,varm_adr:0,varm_rev:0,y_rn:0,y_adr:0,y_rev:0,lasty_rn:0,lasty_adr:0,lasty_rev:0,vary_rn:0,vary_adr:0,vary_rev:0}];var columnsData=exports.columnsData=function columnsData(date){var monthName=new Date(date).toDateString().split(" ")[1];return[{title:monthName,children:[{title:"Room Nts",key:"m_rn",type:"inputNumber"},{title:"ADR",key:"m_adr",type:"number"},{title:"Revenue",key:"m_rev",type:"inputNumber"}]},{title:"LY "+monthName,children:[{title:"Room Nts",key:"lastm_rn",type:"inputNumber"},{title:"ADR",key:"lastm_adr",type:"number"},{title:"Revenue",key:"lastm_rev",type:"inputNumber"}]},{title:"Variance - Monthly",children:[{title:"Room Nts",key:"varm_rn",type:"percent"},{title:"ADR",key:"varm_adr",type:"percent"},{title:"Revenue",key:"varm_rev",type:"percent"}]},{title:"YTD",children:[{title:"Room Nts",key:"y_rn",type:"inputNumber"},{title:"ADR",key:"y_adr",type:"number"},{title:"Revenue",key:"y_rev",type:"inputNumber"}]},{title:"LY YTD",children:[{title:"Room Nts",key:"lasty_rn",type:"inputNumber"},{title:"ADR",key:"lasty_adr",type:"number"},{title:"Revenue",key:"lasty_rev",type:"inputNumber"}]},{title:"Variance - Yearly",children:[{title:"Room Nts",key:"vary_rn",type:"percent"},{title:"ADR",key:"vary_adr",type:"percent"},{title:"Revenue",key:"vary_rev",type:"percent"}]}];};

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=compute;var _method=__webpack_require__(20);function compute(data){var adrName=['m_adr','lastm_adr','y_adr','lasty_adr'];// ADR
adrName.forEach(function(name){var RN=name.split('_')[0]+'_rn';var REV=name.split('_')[0]+'_rev';data.forEach(function(item,i){data[i][name]=(0,_method.calculation)(item[REV],item[RN]);});});// Variance
data.forEach(function(item,i){data[i].varm_rn=(0,_method.calculation)(item.m_rn-item.lastm_rn,item.lastm_rn,4);data[i].varm_adr=(0,_method.calculation)(item.m_adr-item.lastm_adr,item.lastm_adr,4);data[i].varm_rev=(0,_method.calculation)(item.m_rev-item.lastm_rev,item.lastm_rev,4);data[i].vary_rn=(0,_method.calculation)(item.y_rn-item.lasty_rn,item.lasty_rn,4);data[i].vary_adr=(0,_method.calculation)(item.y_adr-item.lasty_adr,item.lasty_adr,4);data[i].vary_rev=(0,_method.calculation)(item.y_rev-item.lasty_rev,item.lasty_rev,4);});return data;}

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _=__webpack_require__(1870);var _2=_interopRequireDefault(_);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",null,_react2.default.createElement(_2.default,{key:1}));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(42);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(1871);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _compute=__webpack_require__(1872);var _compute2=_interopRequireDefault(_compute);var _method=__webpack_require__(20);var _InputNumber=__webpack_require__(1873);var _InputNumber2=_interopRequireDefault(_InputNumber);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var Option=_select2.default.Option;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(4,exponent)+0.5)/Math.pow(4,exponent);}else{return parseInt(this*Math.pow(4,exponent)-0.5)/Math.pow(4,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){data=(0,_compute2.default)(data,_this.state.date);_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.onChangeTitle=function(name,value){var data=_this.state.titleData;data[name]=value;_this.setState({titleData:data});};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data2_4);var data=JSON.parse(dataBegin);var dataBeginTitle=JSON.stringify(_data.defaultTitleData);var titleData=JSON.parse(dataBeginTitle);fetch('/_4_5_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data&&x.data.data.length>0){data=x.data.data;}if(x.data.title&&x.data.title.id){titleData=x.data.title;}_this.computeNum(data);_this.setState({titleData:titleData,loading:false});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));dataFrom.append('titleData',JSON.stringify(_extends({},_this.state.titleData,{year:year})));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_4_5',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id||!_this.state.titleData.id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table4_5',1.5,'4.50',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY'),dateData:[],data:[],loadingSave:false,loading:true,print:false,titleData:{}};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);var date=Number(this.state.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});}},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,titleData=_state.titleData,loading=_state.loading;var width=document.body.offsetWidth-5850>300?document.body.offsetWidth-5850:300;var totalIndex=[];var columns=[{title:'-',fixed:'left',children:[{fixed:'left',title:_react2.default.createElement('div',null,'Upselling','\n','Total Revenue'),children:[{title:'Room Type',dataIndex:'name',key:'name',align:'center',width:width,render:function render(text,record,index){var props={text:text,index:index,type:'input',name:"name",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]}]},{title:'Jan.',children:[{title:!loading&&_react2.default.createElement(_InputNumber2.default,{text:titleData['Jan'],name:'Jan',onChange:this.onChangeTitle}),children:[{title:'Room Nts',key:'Jan_Room_Nts',dataIndex:"Jan_Room_Nts",align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Jan_Room_Nts",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'ADR',key:'Jan_ADR',dataIndex:'Jan_ADR',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"Jan_ADR",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Revenue',key:'Jan_Revenue',dataIndex:'Jan_Revenue',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Jan_Revenue",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]}]},{title:'Feb.',children:[{title:!loading&&_react2.default.createElement(_InputNumber2.default,{text:titleData['Feb'],name:'Feb',onChange:this.onChangeTitle}),children:[{title:'Room Nts',key:'Feb_Room_Nts',dataIndex:"Feb_Room_Nts",align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Feb_Room_Nts",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'ADR',key:'Feb_ADR',dataIndex:'Feb_ADR',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"Feb_ADR",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Revenue',key:'Feb_Revenue',dataIndex:'Feb_Revenue',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Feb_Revenue",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]}]},{title:'Mar.',children:[{title:!loading&&_react2.default.createElement(_InputNumber2.default,{text:titleData['Mar'],name:'Mar',onChange:this.onChangeTitle}),children:[{title:'Room Nts',key:'Mar_Room_Nts',dataIndex:"Mar_Room_Nts",align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Mar_Room_Nts",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'ADR',key:'Mar_ADR',dataIndex:'Mar_ADR',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"Mar_ADR",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Revenue',key:'Mar_Revenue',dataIndex:'Mar_Revenue',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Mar_Revenue",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]}]},{title:'Apr.',children:[{title:!loading&&_react2.default.createElement(_InputNumber2.default,{text:titleData['Apr'],name:'Apr',onChange:this.onChangeTitle}),children:[{title:'Room Nts',key:'Apr_Room_Nts',dataIndex:"Apr_Room_Nts",align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Apr_Room_Nts",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'ADR',key:'Apr_ADR',dataIndex:'Apr_ADR',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"Apr_ADR",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Revenue',key:'Apr_Revenue',dataIndex:'Apr_Revenue',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Apr_Revenue",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]}]},{title:'May.',children:[{title:!loading&&_react2.default.createElement(_InputNumber2.default,{text:titleData['May'],name:'May',onChange:this.onChangeTitle}),children:[{title:'Room Nts',key:'May_Room_Nts',dataIndex:"May_Room_Nts",align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"May_Room_Nts",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'ADR',key:'May_ADR',dataIndex:'May_ADR',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"May_ADR",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Revenue',key:'May_Revenue',dataIndex:'May_Revenue',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"May_Revenue",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]}]},{title:'Jun.',children:[{title:!loading&&_react2.default.createElement(_InputNumber2.default,{text:titleData['Jun'],name:'Jun',onChange:this.onChangeTitle}),children:[{title:'Room Nts',key:'Jun_Room_Nts',dataIndex:"Jun_Room_Nts",align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Jun_Room_Nts",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'ADR',key:'Jun_ADR',dataIndex:'Jun_ADR',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"Jun_ADR",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Revenue',key:'Jun_Revenue',dataIndex:'Jun_Revenue',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Jun_Revenue",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]}]},{title:'Jul.',children:[{title:!loading&&_react2.default.createElement(_InputNumber2.default,{text:titleData['Jul'],name:'Jul',onChange:this.onChangeTitle}),children:[{title:'Room Nts',key:'Jul_Room_Nts',dataIndex:"Jul_Room_Nts",align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Jul_Room_Nts",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'ADR',key:'Jul_ADR',dataIndex:'Jul_ADR',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"Jul_ADR",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Revenue',key:'Jul_Revenue',dataIndex:'Jul_Revenue',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Jul_Revenue",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]}]},{title:'Aug.',children:[{title:!loading&&_react2.default.createElement(_InputNumber2.default,{text:titleData['Aug'],name:'Aug',onChange:this.onChangeTitle}),children:[{title:'Room Nts',key:'Aug_Room_Nts',dataIndex:"Aug_Room_Nts",align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Aug_Room_Nts",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'ADR',key:'Aug_ADR',dataIndex:'Aug_ADR',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"Aug_ADR",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Revenue',key:'Aug_Revenue',dataIndex:'Aug_Revenue',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Aug_Revenue",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]}]},{title:'Sep.',children:[{title:!loading&&_react2.default.createElement(_InputNumber2.default,{text:titleData['Sep'],name:'Sep',onChange:this.onChangeTitle}),children:[{title:'Room Nts',key:'Sep_Room_Nts',dataIndex:"Sep_Room_Nts",align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Sep_Room_Nts",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'ADR',key:'Sep_ADR',dataIndex:'Sep_ADR',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"Sep_ADR",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Revenue',key:'Sep_Revenue',dataIndex:'Sep_Revenue',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Sep_Revenue",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]}]},{title:'Oct.',children:[{title:!loading&&_react2.default.createElement(_InputNumber2.default,{text:titleData['Oct'],name:'Oct',onChange:this.onChangeTitle}),children:[{title:'Room Nts',key:'Oct_Room_Nts',dataIndex:"Oct_Room_Nts",align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Oct_Room_Nts",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'ADR',key:'Oct_ADR',dataIndex:'Oct_ADR',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"Oct_ADR",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Revenue',key:'Oct_Revenue',dataIndex:'Oct_Revenue',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Oct_Revenue",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]}]},{title:'Nov.',children:[{title:!loading&&_react2.default.createElement(_InputNumber2.default,{text:titleData['Nov'],name:'Nov',onChange:this.onChangeTitle}),children:[{title:'Room Nts',key:'Nov_Room_Nts',dataIndex:"Nov_Room_Nts",align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Nov_Room_Nts",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'ADR',key:'Nov_ADR',dataIndex:'Nov_ADR',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"Nov_ADR",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Revenue',key:'Nov_Revenue',dataIndex:'Nov_Revenue',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Nov_Revenue",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]}]},{title:'Dec.',children:[{title:!loading&&_react2.default.createElement(_InputNumber2.default,{text:titleData['Dec'],name:'Dec',onChange:this.onChangeTitle}),children:[{title:'Room Nts',key:'Dec_Room_Nts',dataIndex:"Dec_Room_Nts",align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Dec_Room_Nts",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'ADR',key:'Dec_ADR',dataIndex:'Dec_ADR',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"Dec_ADR",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Revenue',key:'Dec_Revenue',dataIndex:'Dec_Revenue',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"Dec_Revenue",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]}]},{title:'YTD',children:[{title:!loading&&_react2.default.createElement(_InputNumber2.default,{text:titleData['YTD'],name:'YTD',onChange:this.onChangeTitle}),children:[{title:'Room Nts',key:'YTD_Room_Nts',dataIndex:'YTD_Room_Nts',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"YTD_Room_Nts",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'ADR',key:'YTD_ADR',dataIndex:'YTD_ADR',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"YTD_ADR",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Revenue',key:'YTD_Revenue',dataIndex:'YTD_Revenue',align:'center',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"YTD_Revenue",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}]}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_5',style:{width:this.state.print?6200:'auto'}},_react2.default.createElement(_row2.default,null,'4.5 Rooms Revenue Up-selling Program \u5BA2\u623F\u6536\u5165\u589E\u9500\u8BA1\u5212'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(_select2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u4EFD',style:{width:120},value:this.state.date,onChange:function onChange(str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}},this.state.dateData.map(function(x,i){return _react2.default.createElement(Option,{value:x,key:x},x);}))),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',style:{width:this.state.print?6150:'auto'},scroll:this.state.print?{}:{x:6150,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_4_5'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data2_4=exports.data2_4=[{name:'',Jan_Room_Nts:'0',Jan_ADR:'0',Jan_Revenue:'0',Feb_Room_Nts:'0',Feb_ADR:'0',Feb_Revenue:'0',Mar_Room_Nts:'0',Mar_ADR:'0',Mar_Revenue:'0',Apr_Room_Nts:'0',Apr_ADR:'0',Apr_Revenue:'0',May_Room_Nts:'0',May_ADR:'0',May_Revenue:'0',Jun_Room_Nts:'0',Jun_ADR:'0',Jun_Revenue:'0',Jul_Room_Nts:'0',Jul_ADR:'0',Jul_Revenue:'0',Aug_Room_Nts:'0',Aug_ADR:'0',Aug_Revenue:'0',Sep_Room_Nts:'0',Sep_ADR:'0',Sep_Revenue:'0',Oct_Room_Nts:'0',Oct_ADR:'0',Oct_Revenue:'0',Nov_Room_Nts:'0',Nov_ADR:'0',Nov_Revenue:'0',Dec_Room_Nts:'0',Dec_ADR:'0',Dec_Revenue:'0',YTD_Room_Nts:'0',YTD_ADR:'0',YTD_Revenue:'0'},{name:'',Jan_Room_Nts:'0',Jan_ADR:'0',Jan_Revenue:'0',Feb_Room_Nts:'0',Feb_ADR:'0',Feb_Revenue:'0',Mar_Room_Nts:'0',Mar_ADR:'0',Mar_Revenue:'0',Apr_Room_Nts:'0',Apr_ADR:'0',Apr_Revenue:'0',May_Room_Nts:'0',May_ADR:'0',May_Revenue:'0',Jun_Room_Nts:'0',Jun_ADR:'0',Jun_Revenue:'0',Jul_Room_Nts:'0',Jul_ADR:'0',Jul_Revenue:'0',Aug_Room_Nts:'0',Aug_ADR:'0',Aug_Revenue:'0',Sep_Room_Nts:'0',Sep_ADR:'0',Sep_Revenue:'0',Oct_Room_Nts:'0',Oct_ADR:'0',Oct_Revenue:'0',Nov_Room_Nts:'0',Nov_ADR:'0',Nov_Revenue:'0',Dec_Room_Nts:'0',Dec_ADR:'0',Dec_Revenue:'0',YTD_Room_Nts:'0',YTD_ADR:'0',YTD_Revenue:'0'},{name:'',Jan_Room_Nts:'0',Jan_ADR:'0',Jan_Revenue:'0',Feb_Room_Nts:'0',Feb_ADR:'0',Feb_Revenue:'0',Mar_Room_Nts:'0',Mar_ADR:'0',Mar_Revenue:'0',Apr_Room_Nts:'0',Apr_ADR:'0',Apr_Revenue:'0',May_Room_Nts:'0',May_ADR:'0',May_Revenue:'0',Jun_Room_Nts:'0',Jun_ADR:'0',Jun_Revenue:'0',Jul_Room_Nts:'0',Jul_ADR:'0',Jul_Revenue:'0',Aug_Room_Nts:'0',Aug_ADR:'0',Aug_Revenue:'0',Sep_Room_Nts:'0',Sep_ADR:'0',Sep_Revenue:'0',Oct_Room_Nts:'0',Oct_ADR:'0',Oct_Revenue:'0',Nov_Room_Nts:'0',Nov_ADR:'0',Nov_Revenue:'0',Dec_Room_Nts:'0',Dec_ADR:'0',Dec_Revenue:'0',YTD_Room_Nts:'0',YTD_ADR:'0',YTD_Revenue:'0'},{name:'',Jan_Room_Nts:'0',Jan_ADR:'0',Jan_Revenue:'0',Feb_Room_Nts:'0',Feb_ADR:'0',Feb_Revenue:'0',Mar_Room_Nts:'0',Mar_ADR:'0',Mar_Revenue:'0',Apr_Room_Nts:'0',Apr_ADR:'0',Apr_Revenue:'0',May_Room_Nts:'0',May_ADR:'0',May_Revenue:'0',Jun_Room_Nts:'0',Jun_ADR:'0',Jun_Revenue:'0',Jul_Room_Nts:'0',Jul_ADR:'0',Jul_Revenue:'0',Aug_Room_Nts:'0',Aug_ADR:'0',Aug_Revenue:'0',Sep_Room_Nts:'0',Sep_ADR:'0',Sep_Revenue:'0',Oct_Room_Nts:'0',Oct_ADR:'0',Oct_Revenue:'0',Nov_Room_Nts:'0',Nov_ADR:'0',Nov_Revenue:'0',Dec_Room_Nts:'0',Dec_ADR:'0',Dec_Revenue:'0',YTD_Room_Nts:'0',YTD_ADR:'0',YTD_Revenue:'0'},{name:'',Jan_Room_Nts:'0',Jan_ADR:'0',Jan_Revenue:'0',Feb_Room_Nts:'0',Feb_ADR:'0',Feb_Revenue:'0',Mar_Room_Nts:'0',Mar_ADR:'0',Mar_Revenue:'0',Apr_Room_Nts:'0',Apr_ADR:'0',Apr_Revenue:'0',May_Room_Nts:'0',May_ADR:'0',May_Revenue:'0',Jun_Room_Nts:'0',Jun_ADR:'0',Jun_Revenue:'0',Jul_Room_Nts:'0',Jul_ADR:'0',Jul_Revenue:'0',Aug_Room_Nts:'0',Aug_ADR:'0',Aug_Revenue:'0',Sep_Room_Nts:'0',Sep_ADR:'0',Sep_Revenue:'0',Oct_Room_Nts:'0',Oct_ADR:'0',Oct_Revenue:'0',Nov_Room_Nts:'0',Nov_ADR:'0',Nov_Revenue:'0',Dec_Room_Nts:'0',Dec_ADR:'0',Dec_Revenue:'0',YTD_Room_Nts:'0',YTD_ADR:'0',YTD_Revenue:'0'},{name:'',Jan_Room_Nts:'0',Jan_ADR:'0',Jan_Revenue:'0',Feb_Room_Nts:'0',Feb_ADR:'0',Feb_Revenue:'0',Mar_Room_Nts:'0',Mar_ADR:'0',Mar_Revenue:'0',Apr_Room_Nts:'0',Apr_ADR:'0',Apr_Revenue:'0',May_Room_Nts:'0',May_ADR:'0',May_Revenue:'0',Jun_Room_Nts:'0',Jun_ADR:'0',Jun_Revenue:'0',Jul_Room_Nts:'0',Jul_ADR:'0',Jul_Revenue:'0',Aug_Room_Nts:'0',Aug_ADR:'0',Aug_Revenue:'0',Sep_Room_Nts:'0',Sep_ADR:'0',Sep_Revenue:'0',Oct_Room_Nts:'0',Oct_ADR:'0',Oct_Revenue:'0',Nov_Room_Nts:'0',Nov_ADR:'0',Nov_Revenue:'0',Dec_Room_Nts:'0',Dec_ADR:'0',Dec_Revenue:'0',YTD_Room_Nts:'0',YTD_ADR:'0',YTD_Revenue:'0'},{name:'',Jan_Room_Nts:'0',Jan_ADR:'0',Jan_Revenue:'0',Feb_Room_Nts:'0',Feb_ADR:'0',Feb_Revenue:'0',Mar_Room_Nts:'0',Mar_ADR:'0',Mar_Revenue:'0',Apr_Room_Nts:'0',Apr_ADR:'0',Apr_Revenue:'0',May_Room_Nts:'0',May_ADR:'0',May_Revenue:'0',Jun_Room_Nts:'0',Jun_ADR:'0',Jun_Revenue:'0',Jul_Room_Nts:'0',Jul_ADR:'0',Jul_Revenue:'0',Aug_Room_Nts:'0',Aug_ADR:'0',Aug_Revenue:'0',Sep_Room_Nts:'0',Sep_ADR:'0',Sep_Revenue:'0',Oct_Room_Nts:'0',Oct_ADR:'0',Oct_Revenue:'0',Nov_Room_Nts:'0',Nov_ADR:'0',Nov_Revenue:'0',Dec_Room_Nts:'0',Dec_ADR:'0',Dec_Revenue:'0',YTD_Room_Nts:'0',YTD_ADR:'0',YTD_Revenue:'0'},{name:'',Jan_Room_Nts:'0',Jan_ADR:'0',Jan_Revenue:'0',Feb_Room_Nts:'0',Feb_ADR:'0',Feb_Revenue:'0',Mar_Room_Nts:'0',Mar_ADR:'0',Mar_Revenue:'0',Apr_Room_Nts:'0',Apr_ADR:'0',Apr_Revenue:'0',May_Room_Nts:'0',May_ADR:'0',May_Revenue:'0',Jun_Room_Nts:'0',Jun_ADR:'0',Jun_Revenue:'0',Jul_Room_Nts:'0',Jul_ADR:'0',Jul_Revenue:'0',Aug_Room_Nts:'0',Aug_ADR:'0',Aug_Revenue:'0',Sep_Room_Nts:'0',Sep_ADR:'0',Sep_Revenue:'0',Oct_Room_Nts:'0',Oct_ADR:'0',Oct_Revenue:'0',Nov_Room_Nts:'0',Nov_ADR:'0',Nov_Revenue:'0',Dec_Room_Nts:'0',Dec_ADR:'0',Dec_Revenue:'0',YTD_Room_Nts:'0',YTD_ADR:'0',YTD_Revenue:'0'},{name:'',Jan_Room_Nts:'0',Jan_ADR:'0',Jan_Revenue:'0',Feb_Room_Nts:'0',Feb_ADR:'0',Feb_Revenue:'0',Mar_Room_Nts:'0',Mar_ADR:'0',Mar_Revenue:'0',Apr_Room_Nts:'0',Apr_ADR:'0',Apr_Revenue:'0',May_Room_Nts:'0',May_ADR:'0',May_Revenue:'0',Jun_Room_Nts:'0',Jun_ADR:'0',Jun_Revenue:'0',Jul_Room_Nts:'0',Jul_ADR:'0',Jul_Revenue:'0',Aug_Room_Nts:'0',Aug_ADR:'0',Aug_Revenue:'0',Sep_Room_Nts:'0',Sep_ADR:'0',Sep_Revenue:'0',Oct_Room_Nts:'0',Oct_ADR:'0',Oct_Revenue:'0',Nov_Room_Nts:'0',Nov_ADR:'0',Nov_Revenue:'0',Dec_Room_Nts:'0',Dec_ADR:'0',Dec_Revenue:'0',YTD_Room_Nts:'0',YTD_ADR:'0',YTD_Revenue:'0'},{name:'',Jan_Room_Nts:'0',Jan_ADR:'0',Jan_Revenue:'0',Feb_Room_Nts:'0',Feb_ADR:'0',Feb_Revenue:'0',Mar_Room_Nts:'0',Mar_ADR:'0',Mar_Revenue:'0',Apr_Room_Nts:'0',Apr_ADR:'0',Apr_Revenue:'0',May_Room_Nts:'0',May_ADR:'0',May_Revenue:'0',Jun_Room_Nts:'0',Jun_ADR:'0',Jun_Revenue:'0',Jul_Room_Nts:'0',Jul_ADR:'0',Jul_Revenue:'0',Aug_Room_Nts:'0',Aug_ADR:'0',Aug_Revenue:'0',Sep_Room_Nts:'0',Sep_ADR:'0',Sep_Revenue:'0',Oct_Room_Nts:'0',Oct_ADR:'0',Oct_Revenue:'0',Nov_Room_Nts:'0',Nov_ADR:'0',Nov_Revenue:'0',Dec_Room_Nts:'0',Dec_ADR:'0',Dec_Revenue:'0',YTD_Room_Nts:'0',YTD_ADR:'0',YTD_Revenue:'0'},{name:'',Jan_Room_Nts:'0',Jan_ADR:'0',Jan_Revenue:'0',Feb_Room_Nts:'0',Feb_ADR:'0',Feb_Revenue:'0',Mar_Room_Nts:'0',Mar_ADR:'0',Mar_Revenue:'0',Apr_Room_Nts:'0',Apr_ADR:'0',Apr_Revenue:'0',May_Room_Nts:'0',May_ADR:'0',May_Revenue:'0',Jun_Room_Nts:'0',Jun_ADR:'0',Jun_Revenue:'0',Jul_Room_Nts:'0',Jul_ADR:'0',Jul_Revenue:'0',Aug_Room_Nts:'0',Aug_ADR:'0',Aug_Revenue:'0',Sep_Room_Nts:'0',Sep_ADR:'0',Sep_Revenue:'0',Oct_Room_Nts:'0',Oct_ADR:'0',Oct_Revenue:'0',Nov_Room_Nts:'0',Nov_ADR:'0',Nov_Revenue:'0',Dec_Room_Nts:'0',Dec_ADR:'0',Dec_Revenue:'0',YTD_Room_Nts:'0',YTD_ADR:'0',YTD_Revenue:'0'},{name:'',Jan_Room_Nts:'0',Jan_ADR:'0',Jan_Revenue:'0',Feb_Room_Nts:'0',Feb_ADR:'0',Feb_Revenue:'0',Mar_Room_Nts:'0',Mar_ADR:'0',Mar_Revenue:'0',Apr_Room_Nts:'0',Apr_ADR:'0',Apr_Revenue:'0',May_Room_Nts:'0',May_ADR:'0',May_Revenue:'0',Jun_Room_Nts:'0',Jun_ADR:'0',Jun_Revenue:'0',Jul_Room_Nts:'0',Jul_ADR:'0',Jul_Revenue:'0',Aug_Room_Nts:'0',Aug_ADR:'0',Aug_Revenue:'0',Sep_Room_Nts:'0',Sep_ADR:'0',Sep_Revenue:'0',Oct_Room_Nts:'0',Oct_ADR:'0',Oct_Revenue:'0',Nov_Room_Nts:'0',Nov_ADR:'0',Nov_Revenue:'0',Dec_Room_Nts:'0',Dec_ADR:'0',Dec_Revenue:'0',YTD_Room_Nts:'0',YTD_ADR:'0',YTD_Revenue:'0'},{name:'',Jan_Room_Nts:'0',Jan_ADR:'0',Jan_Revenue:'0',Feb_Room_Nts:'0',Feb_ADR:'0',Feb_Revenue:'0',Mar_Room_Nts:'0',Mar_ADR:'0',Mar_Revenue:'0',Apr_Room_Nts:'0',Apr_ADR:'0',Apr_Revenue:'0',May_Room_Nts:'0',May_ADR:'0',May_Revenue:'0',Jun_Room_Nts:'0',Jun_ADR:'0',Jun_Revenue:'0',Jul_Room_Nts:'0',Jul_ADR:'0',Jul_Revenue:'0',Aug_Room_Nts:'0',Aug_ADR:'0',Aug_Revenue:'0',Sep_Room_Nts:'0',Sep_ADR:'0',Sep_Revenue:'0',Oct_Room_Nts:'0',Oct_ADR:'0',Oct_Revenue:'0',Nov_Room_Nts:'0',Nov_ADR:'0',Nov_Revenue:'0',Dec_Room_Nts:'0',Dec_ADR:'0',Dec_Revenue:'0',YTD_Room_Nts:'0',YTD_ADR:'0',YTD_Revenue:'0'},{name:'',Jan_Room_Nts:'0',Jan_ADR:'0',Jan_Revenue:'0',Feb_Room_Nts:'0',Feb_ADR:'0',Feb_Revenue:'0',Mar_Room_Nts:'0',Mar_ADR:'0',Mar_Revenue:'0',Apr_Room_Nts:'0',Apr_ADR:'0',Apr_Revenue:'0',May_Room_Nts:'0',May_ADR:'0',May_Revenue:'0',Jun_Room_Nts:'0',Jun_ADR:'0',Jun_Revenue:'0',Jul_Room_Nts:'0',Jul_ADR:'0',Jul_Revenue:'0',Aug_Room_Nts:'0',Aug_ADR:'0',Aug_Revenue:'0',Sep_Room_Nts:'0',Sep_ADR:'0',Sep_Revenue:'0',Oct_Room_Nts:'0',Oct_ADR:'0',Oct_Revenue:'0',Nov_Room_Nts:'0',Nov_ADR:'0',Nov_Revenue:'0',Dec_Room_Nts:'0',Dec_ADR:'0',Dec_Revenue:'0',YTD_Room_Nts:'0',YTD_ADR:'0',YTD_Revenue:'0'},{name:'',Jan_Room_Nts:'0',Jan_ADR:'0',Jan_Revenue:'0',Feb_Room_Nts:'0',Feb_ADR:'0',Feb_Revenue:'0',Mar_Room_Nts:'0',Mar_ADR:'0',Mar_Revenue:'0',Apr_Room_Nts:'0',Apr_ADR:'0',Apr_Revenue:'0',May_Room_Nts:'0',May_ADR:'0',May_Revenue:'0',Jun_Room_Nts:'0',Jun_ADR:'0',Jun_Revenue:'0',Jul_Room_Nts:'0',Jul_ADR:'0',Jul_Revenue:'0',Aug_Room_Nts:'0',Aug_ADR:'0',Aug_Revenue:'0',Sep_Room_Nts:'0',Sep_ADR:'0',Sep_Revenue:'0',Oct_Room_Nts:'0',Oct_ADR:'0',Oct_Revenue:'0',Nov_Room_Nts:'0',Nov_ADR:'0',Nov_Revenue:'0',Dec_Room_Nts:'0',Dec_ADR:'0',Dec_Revenue:'0',YTD_Room_Nts:'0',YTD_ADR:'0',YTD_Revenue:'0'},{name:'',Jan_Room_Nts:'0',Jan_ADR:'0',Jan_Revenue:'0',Feb_Room_Nts:'0',Feb_ADR:'0',Feb_Revenue:'0',Mar_Room_Nts:'0',Mar_ADR:'0',Mar_Revenue:'0',Apr_Room_Nts:'0',Apr_ADR:'0',Apr_Revenue:'0',May_Room_Nts:'0',May_ADR:'0',May_Revenue:'0',Jun_Room_Nts:'0',Jun_ADR:'0',Jun_Revenue:'0',Jul_Room_Nts:'0',Jul_ADR:'0',Jul_Revenue:'0',Aug_Room_Nts:'0',Aug_ADR:'0',Aug_Revenue:'0',Sep_Room_Nts:'0',Sep_ADR:'0',Sep_Revenue:'0',Oct_Room_Nts:'0',Oct_ADR:'0',Oct_Revenue:'0',Nov_Room_Nts:'0',Nov_ADR:'0',Nov_Revenue:'0',Dec_Room_Nts:'0',Dec_ADR:'0',Dec_Revenue:'0',YTD_Room_Nts:'0',YTD_ADR:'0',YTD_Revenue:'0'},{name:'',Jan_Room_Nts:'0',Jan_ADR:'0',Jan_Revenue:'0',Feb_Room_Nts:'0',Feb_ADR:'0',Feb_Revenue:'0',Mar_Room_Nts:'0',Mar_ADR:'0',Mar_Revenue:'0',Apr_Room_Nts:'0',Apr_ADR:'0',Apr_Revenue:'0',May_Room_Nts:'0',May_ADR:'0',May_Revenue:'0',Jun_Room_Nts:'0',Jun_ADR:'0',Jun_Revenue:'0',Jul_Room_Nts:'0',Jul_ADR:'0',Jul_Revenue:'0',Aug_Room_Nts:'0',Aug_ADR:'0',Aug_Revenue:'0',Sep_Room_Nts:'0',Sep_ADR:'0',Sep_Revenue:'0',Oct_Room_Nts:'0',Oct_ADR:'0',Oct_Revenue:'0',Nov_Room_Nts:'0',Nov_ADR:'0',Nov_Revenue:'0',Dec_Room_Nts:'0',Dec_ADR:'0',Dec_Revenue:'0',YTD_Room_Nts:'0',YTD_ADR:'0',YTD_Revenue:'0'},{name:'',Jan_Room_Nts:'0',Jan_ADR:'0',Jan_Revenue:'0',Feb_Room_Nts:'0',Feb_ADR:'0',Feb_Revenue:'0',Mar_Room_Nts:'0',Mar_ADR:'0',Mar_Revenue:'0',Apr_Room_Nts:'0',Apr_ADR:'0',Apr_Revenue:'0',May_Room_Nts:'0',May_ADR:'0',May_Revenue:'0',Jun_Room_Nts:'0',Jun_ADR:'0',Jun_Revenue:'0',Jul_Room_Nts:'0',Jul_ADR:'0',Jul_Revenue:'0',Aug_Room_Nts:'0',Aug_ADR:'0',Aug_Revenue:'0',Sep_Room_Nts:'0',Sep_ADR:'0',Sep_Revenue:'0',Oct_Room_Nts:'0',Oct_ADR:'0',Oct_Revenue:'0',Nov_Room_Nts:'0',Nov_ADR:'0',Nov_Revenue:'0',Dec_Room_Nts:'0',Dec_ADR:'0',Dec_Revenue:'0',YTD_Room_Nts:'0',YTD_ADR:'0',YTD_Revenue:'0'},{name:'',Jan_Room_Nts:'0',Jan_ADR:'0',Jan_Revenue:'0',Feb_Room_Nts:'0',Feb_ADR:'0',Feb_Revenue:'0',Mar_Room_Nts:'0',Mar_ADR:'0',Mar_Revenue:'0',Apr_Room_Nts:'0',Apr_ADR:'0',Apr_Revenue:'0',May_Room_Nts:'0',May_ADR:'0',May_Revenue:'0',Jun_Room_Nts:'0',Jun_ADR:'0',Jun_Revenue:'0',Jul_Room_Nts:'0',Jul_ADR:'0',Jul_Revenue:'0',Aug_Room_Nts:'0',Aug_ADR:'0',Aug_Revenue:'0',Sep_Room_Nts:'0',Sep_ADR:'0',Sep_Revenue:'0',Oct_Room_Nts:'0',Oct_ADR:'0',Oct_Revenue:'0',Nov_Room_Nts:'0',Nov_ADR:'0',Nov_Revenue:'0',Dec_Room_Nts:'0',Dec_ADR:'0',Dec_Revenue:'0',YTD_Room_Nts:'0',YTD_ADR:'0',YTD_Revenue:'0'},{name:'',Jan_Room_Nts:'0',Jan_ADR:'0',Jan_Revenue:'0',Feb_Room_Nts:'0',Feb_ADR:'0',Feb_Revenue:'0',Mar_Room_Nts:'0',Mar_ADR:'0',Mar_Revenue:'0',Apr_Room_Nts:'0',Apr_ADR:'0',Apr_Revenue:'0',May_Room_Nts:'0',May_ADR:'0',May_Revenue:'0',Jun_Room_Nts:'0',Jun_ADR:'0',Jun_Revenue:'0',Jul_Room_Nts:'0',Jul_ADR:'0',Jul_Revenue:'0',Aug_Room_Nts:'0',Aug_ADR:'0',Aug_Revenue:'0',Sep_Room_Nts:'0',Sep_ADR:'0',Sep_Revenue:'0',Oct_Room_Nts:'0',Oct_ADR:'0',Oct_Revenue:'0',Nov_Room_Nts:'0',Nov_ADR:'0',Nov_Revenue:'0',Dec_Room_Nts:'0',Dec_ADR:'0',Dec_Revenue:'0',YTD_Room_Nts:'0',YTD_ADR:'0',YTD_Revenue:'0'},{name:'',Jan_Room_Nts:'0',Jan_ADR:'0',Jan_Revenue:'0',Feb_Room_Nts:'0',Feb_ADR:'0',Feb_Revenue:'0',Mar_Room_Nts:'0',Mar_ADR:'0',Mar_Revenue:'0',Apr_Room_Nts:'0',Apr_ADR:'0',Apr_Revenue:'0',May_Room_Nts:'0',May_ADR:'0',May_Revenue:'0',Jun_Room_Nts:'0',Jun_ADR:'0',Jun_Revenue:'0',Jul_Room_Nts:'0',Jul_ADR:'0',Jul_Revenue:'0',Aug_Room_Nts:'0',Aug_ADR:'0',Aug_Revenue:'0',Sep_Room_Nts:'0',Sep_ADR:'0',Sep_Revenue:'0',Oct_Room_Nts:'0',Oct_ADR:'0',Oct_Revenue:'0',Nov_Room_Nts:'0',Nov_ADR:'0',Nov_Revenue:'0',Dec_Room_Nts:'0',Dec_ADR:'0',Dec_Revenue:'0',YTD_Room_Nts:'0',YTD_ADR:'0',YTD_Revenue:'0'}];var defaultTitleData=exports.defaultTitleData={Jan:0,Feb:0,Mar:0,Apr:0,May:0,Jun:0,Jul:0,Aug:0,Sep:0,Oct:0,Nov:0,Dec:0,YTD:0};

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=compute;var _method=__webpack_require__(20);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function compute(data,date){var listName=['Jan_ADR','Feb_ADR','Mar_ADR','Apr_ADR','May_ADR','Jun_ADR','Jul_ADR','Aug_ADR','Sep_ADR','Oct_ADR','Nov_ADR','Dec_ADR'];// YTD RN REV
data.forEach(function(item,i){data[i].YTD_Room_Nts=listName.reduce(function(a,b,i){if((0,_moment2.default)().format('M')>i+1){a+=(0,_method.numConvert)(item[b.split('_')[0]+'_Room_Nts']);}return a;},0).toFixed(2);data[i].YTD_Revenue=listName.reduce(function(a,b,i){if((0,_moment2.default)().format('M')>i+1){a+=(0,_method.numConvert)(item[b.split('_')[0]+'_Revenue']);}return a;},0).toFixed(2);});[].concat(listName,['YTD_ADR']).forEach(function(name){var RN=name.split('_')[0]+'_Room_Nts';var REV=name.split('_')[0]+'_Revenue';data.forEach(function(item,i){data[i][name]=(0,_method.calculation)(data[i][REV],data[i][RN]);});});return data;}

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(35);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1874);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){var _props=this.props,text=_props.text,onChange=_props.onChange,name=_props.name;return _react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,defaultValue:Number(text||"0")||"",className:'title-InputNumber',placeholder:'\u8BF7\u8F93\u5165',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));onChange(name,value);}});}}]);return App;}(_react.Component);exports.default=App;

/***/ }),
/* 1874 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(4);__webpack_require__(42);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _data=__webpack_require__(247);var _compute=__webpack_require__(1876);__webpack_require__(1877);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2){var date=_ref2.date,area=_ref2.area;var month,lastmonth,year,res,data;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;month=_data.chineseNewYear[(0,_moment2.default)().format('Y')].m;lastmonth=_data.chineseNewYear[(0,_moment2.default)().subtract(1,'year').format('Y')].m;year=(0,_moment2.default)(date).format('YYYY');_context.next=6;return(0,_request2.default)('/_4_2_daily/area_holidays?year='+year+'&month='+month+'&area='+area+'&lastmonth='+lastmonth);case 6:res=_context.sent;data=res.data||[];data.forEach(function(item,i){// 春节
var index=_data.chineseNewYear[(0,_moment2.default)(date).format('Y')].d-1;var lastIndex=_data.chineseNewYear[(0,_moment2.default)(date).subtract(1,'years').format('Y')].d-1;data[i].data=item.data.slice(index,index+7);data[i].lastdata=item.lastdata.slice(lastIndex,lastIndex+7);});console.log(data);// adr occ
(0,_compute.setKarte)({id:"chartOcc",title:date-1+'\u5E74 ADR+OCC',dataName:data.map(function(x){return x.name;}),dataY:data.reduce(function(a,b,i){a.push({name:b.name,type:"percent",data:b.lastdata.map(function(_x){return(_x.occ*100).toFixed(1);})});a.push({name:b.name,data:b.lastdata.map(function(_x){return Number(_x.adr).toFixed(0);})});return a;},[])});(0,_compute.setKarte)({id:"chartAdr",title:date+'\u5E74 ADR+OCC',dataName:data.map(function(x){return x.name;}),dataY:data.reduce(function(a,b,i){a.push({name:b.name,type:"percent",data:b.data.map(function(_x){return(_x.occ*100).toFixed(1);})});a.push({name:b.name,data:b.data.map(function(_x){return Number(_x.adr).toFixed(0);})});return a;},[])});// revpar
(0,_compute.setKarte)({id:"revpar_year",title:date-1+'\u5E74 RevPAR',dataName:data.map(function(x){return x.name;}),dataY:data.map(function(x){return{name:x.name,data:x.lastdata.map(function(y){return Number(y.revpar).toFixed(0);})};})});(0,_compute.setKarte)({id:"revpar_last",title:date+'\u5E74 RevPAR',dataName:data.map(function(x){return x.name;}),dataY:data.map(function(x){return{name:x.name,data:x.data.map(function(y){return Number(y.revpar).toFixed(0);})};})});// room rev
(0,_compute.setKarte)({id:"roomrev_year",title:date-1+'\u5E74 Room Revenue',dataName:data.map(function(x){return x.name;}),dataY:data.map(function(x){return{name:x.name,data:x.lastdata.map(function(y){return Number(y.rev).toFixed(0);})};})});(0,_compute.setKarte)({id:"roomrev_last",title:date+'\u5E74 Room Revenue',dataName:data.map(function(x){return x.name;}),dataY:data.map(function(x){return{name:x.name,data:x.data.map(function(y){return Number(y.rev).toFixed(0);})};})});_this.setState({data:data,loading:false});_context.next=23;break;case 19:_context.prev=19;_context.t0=_context['catch'](0);console.log(_context.t0);_this.setState({loading:false});case 23:case'end':return _context.stop();}}},_callee,_this2,[[0,19]]);}));return function(_x2){return _ref.apply(this,arguments);};}();_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY'),data:[],lastdata:[],loading:true,loadingSave:false,print:false,dateData:[],area:"东南华南"};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){var date=Number(this.state.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});this.getData({date:this.state.date,area:this.state.area});}},{key:'render',value:function render(){var _this3=this;var _state=this.state,dateData=_state.dateData,loading=_state.loading,data=_state.data,date=_state.date,area=_state.area;return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'table7_1_1 table7_6 table4_2_area_summary',id:'table4_2_2',style:{height:'auto'}},_react2.default.createElement(_row2.default,{className:'title'},_react2.default.createElement(_row2.default,null,'\u6625\u8282\u533A\u57DF\u62A5\u8868'),_react2.default.createElement('div',{className:'title-select'},_react2.default.createElement(_select2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u4EFD',style:{width:120},value:date,onChange:function onChange(str){_this3.setState({date:str,data:[],loading:true},function(){_this3.getData({date:str,area:area});});}},dateData.map(function(x,i){return _react2.default.createElement(Option,{value:x,key:x},x,'\u5E74');})),_react2.default.createElement(_select2.default,{allowClear:true,defaultValue:area,style:{width:200,marginLeft:20},onChange:function onChange(value){_this3.setState({data:[],loading:true,area:value},function(){_this3.getData({date:date,area:value});});}},_react2.default.createElement(Option,{value:'\u4E1C\u5357\u534E\u5357'},'\u4E1C\u5357\u534E\u5357'),_react2.default.createElement(Option,{value:'\u534E\u5317\u534E\u4E2D'},'\u534E\u5317\u534E\u4E2D'),_react2.default.createElement(Option,{value:'\u6C5F\u6D59\u6CAA\u7696'},'\u6C5F\u6D59\u6CAA\u7696'),_react2.default.createElement(Option,{value:'\u897F\u5357'},'\u897F\u5357')))),_react2.default.createElement(_row2.default,{className:'title'},_react2.default.createElement('div',{className:'chart-4-2'},_react2.default.createElement('div',{id:'chartOcc'}),_react2.default.createElement('div',{id:'chartAdr'}),_react2.default.createElement('div',{id:'revpar_year'}),_react2.default.createElement('div',{id:'revpar_last'}),_react2.default.createElement('div',{id:'roomrev_year'}),_react2.default.createElement('div',{id:'roomrev_last'})))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setKarte=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);var _method=__webpack_require__(20);var _method2=_interopRequireDefault(_method);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var color=['#C4BD97','#F79646','#FF2500','#C01900','#92D050','#000000','#45A1B9','#98747F','#3DCFC5','#62AAA3','#6AF910','#948A54','#984808','#9F2397','#B3A2C7'];var setKarte=exports.setKarte=function setKarte(_ref,isOnResize){var dataX=_ref.dataX,dataY=_ref.dataY,id=_ref.id,title=_ref.title,yAxis=_ref.yAxis,axisLabel=_ref.axisLabel;var myChart=_echarts2.default.init(document.getElementById(id));myChart.resize();if(isOnResize){return;}var option={color:color,title:{text:title},tooltip:{trigger:'axis',axisPointer:{type:'cross'}},grid:{top:120},legend:{top:30,data:dataY.map(function(x){return x.name;})},toolbox:{feature:{saveAsImage:{show:true}}},xAxis:[{type:'category',axisLabel:_extends({color:"black",fontSize:14},axisLabel),data:dataX||['除夕','春节','初二','初三','初四','初五','初六']}],yAxis:yAxis||[{type:'value',name:'',axisLabel:{formatter:'{value}'}},{type:'value',name:'',axisLabel:{formatter:'{value} %'}}],series:dataY.map(function(x,i){return{name:x.name,type:x.type&&x.type=='percent'?"line":'bar',data:x.data,yAxisIndex:x.type==="percent"?1:0};})};myChart.setOption(option);};

/***/ }),
/* 1877 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(4);__webpack_require__(42);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _compute=__webpack_require__(1879);__webpack_require__(1880);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2){var date=_ref2.date,area=_ref2.area;var year,res,data;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;year=(0,_moment2.default)(date).format('YYYY');_context.next=4;return(0,_request2.default)('/_4_2_daily/area_holidays?year='+year+'&month=5&area='+area+'&lastmonth=5');case 4:res=_context.sent;data=res.data||[];data.forEach(function(item,i){// 五一、十一
data[i].data=item.data.slice(0,7);data[i].lastdata=item.lastdata.slice(0,7);});// adr occ
(0,_compute.setKarte)({id:"chartOcc",title:date-1+'\u5E74 ADR+OCC',dataName:data.map(function(x){return x.name;}),dataY:data.reduce(function(a,b,i){a.push({name:b.name,type:"percent",data:b.lastdata.map(function(_x){return(_x.occ*100).toFixed(1);})});a.push({name:b.name,data:b.lastdata.map(function(_x){return Number(_x.adr).toFixed(0);})});return a;},[])});(0,_compute.setKarte)({id:"chartAdr",title:date+'\u5E74 ADR+OCC',dataName:data.map(function(x){return x.name;}),dataY:data.reduce(function(a,b,i){a.push({name:b.name,type:"percent",data:b.data.map(function(_x){return(_x.occ*100).toFixed(1);})});a.push({name:b.name,data:b.data.map(function(_x){return Number(_x.adr).toFixed(0);})});return a;},[])});// revpar
(0,_compute.setKarte)({id:"revpar_year",title:date-1+'\u5E74 RevPAR',dataName:data.map(function(x){return x.name;}),dataY:data.map(function(x){return{name:x.name,data:x.lastdata.map(function(y){return Number(y.revpar).toFixed(0);})};})});(0,_compute.setKarte)({id:"revpar_last",title:date+'\u5E74 RevPAR',dataName:data.map(function(x){return x.name;}),dataY:data.map(function(x){return{name:x.name,data:x.data.map(function(y){return Number(y.revpar).toFixed(0);})};})});// room rev
(0,_compute.setKarte)({id:"roomrev_year",title:date-1+'\u5E74 Room Revenue',dataName:data.map(function(x){return x.name;}),dataY:data.map(function(x){return{name:x.name,data:x.lastdata.map(function(y){return Number(y.rev).toFixed(0);})};})});(0,_compute.setKarte)({id:"roomrev_last",title:date+'\u5E74 Room Revenue',dataName:data.map(function(x){return x.name;}),dataY:data.map(function(x){return{name:x.name,data:x.data.map(function(y){return Number(y.rev).toFixed(0);})};})});_this.setState({data:data,loading:false});_context.next=20;break;case 16:_context.prev=16;_context.t0=_context['catch'](0);console.log(_context.t0);_this.setState({loading:false});case 20:case'end':return _context.stop();}}},_callee,_this2,[[0,16]]);}));return function(_x2){return _ref.apply(this,arguments);};}();_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY'),data:[],lastdata:[],loading:true,loadingSave:false,print:false,dateData:[],area:"东南华南"};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){var date=Number(this.state.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});this.getData({date:this.state.date,area:this.state.area});}},{key:'render',value:function render(){var _this3=this;var _state=this.state,dateData=_state.dateData,loading=_state.loading,data=_state.data,date=_state.date,area=_state.area;return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'table7_1_1 table7_6 table4_2_area_summary',id:'table4_2_2',style:{height:'auto'}},_react2.default.createElement(_row2.default,{className:'title'},_react2.default.createElement(_row2.default,null,'\u4E94\u4E00\u533A\u57DF\u62A5\u8868'),_react2.default.createElement('div',{className:'title-select'},_react2.default.createElement(_select2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u4EFD',style:{width:120},value:date,onChange:function onChange(str){_this3.setState({date:str,data:[],loading:true},function(){_this3.getData({date:str,area:area});});}},dateData.map(function(x,i){return _react2.default.createElement(Option,{value:x,key:x},x,'\u5E74');})),_react2.default.createElement(_select2.default,{allowClear:true,defaultValue:area,style:{width:200,marginLeft:20},onChange:function onChange(value){_this3.setState({data:[],loading:true,area:value},function(){_this3.getData({date:date,area:value});});}},_react2.default.createElement(Option,{value:'\u4E1C\u5357\u534E\u5357'},'\u4E1C\u5357\u534E\u5357'),_react2.default.createElement(Option,{value:'\u534E\u5317\u534E\u4E2D'},'\u534E\u5317\u534E\u4E2D'),_react2.default.createElement(Option,{value:'\u6C5F\u6D59\u6CAA\u7696'},'\u6C5F\u6D59\u6CAA\u7696'),_react2.default.createElement(Option,{value:'\u897F\u5357'},'\u897F\u5357')))),_react2.default.createElement(_row2.default,{className:'title'},_react2.default.createElement('div',{className:'chart-4-2'},_react2.default.createElement('div',{id:'chartOcc'}),_react2.default.createElement('div',{id:'chartAdr'}),_react2.default.createElement('div',{id:'revpar_year'}),_react2.default.createElement('div',{id:'revpar_last'}),_react2.default.createElement('div',{id:'roomrev_year'}),_react2.default.createElement('div',{id:'roomrev_last'})))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setKarte=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);var _method=__webpack_require__(20);var _method2=_interopRequireDefault(_method);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var color=['#C4BD97','#F79646','#FF2500','#C01900','#92D050','#000000','#45A1B9','#98747F','#3DCFC5','#62AAA3','#6AF910','#948A54','#984808','#9F2397','#B3A2C7'];var setKarte=exports.setKarte=function setKarte(_ref,isOnResize){var dataX=_ref.dataX,dataY=_ref.dataY,id=_ref.id,title=_ref.title,yAxis=_ref.yAxis,axisLabel=_ref.axisLabel;var myChart=_echarts2.default.init(document.getElementById(id));myChart.resize();if(isOnResize){return;}var option={color:color,title:{text:title},tooltip:{trigger:'axis',axisPointer:{type:'cross'}},grid:{top:120},legend:{top:30,data:dataY.map(function(x){return x.name;})},toolbox:{feature:{saveAsImage:{show:true}}},xAxis:[{type:'category',axisLabel:_extends({color:"black",fontSize:14},axisLabel),data:dataX||['5/1','5/2','5/3','5/4','5/5','5/6','5/7']}],yAxis:yAxis||[{type:'value',name:'',axisLabel:{formatter:'{value}'}},{type:'value',name:'',axisLabel:{formatter:'{value} %'}}],series:dataY.map(function(x,i){return{name:x.name,type:x.type&&x.type=='percent'?"line":'bar',data:x.data,yAxisIndex:x.type==="percent"?1:0};})};myChart.setOption(option);};

/***/ }),
/* 1880 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(4);__webpack_require__(42);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _compute=__webpack_require__(1882);__webpack_require__(1883);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2){var date=_ref2.date,area=_ref2.area;var year,res,data;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;year=(0,_moment2.default)(date).format('YYYY');_context.next=4;return(0,_request2.default)('/_4_2_daily/area_holidays?year='+year+'&month=10&area='+area+'&lastmonth=10');case 4:res=_context.sent;data=res.data||[];data.forEach(function(item,i){// 五一、十一
data[i].data=item.data.slice(0,7);data[i].lastdata=item.lastdata.slice(0,7);});// adr occ
(0,_compute.setKarte)({id:"chartOcc",title:date-1+'\u5E74 ADR+OCC',dataName:data.map(function(x){return x.name;}),dataY:data.reduce(function(a,b,i){a.push({name:b.name,type:"percent",data:b.lastdata.map(function(_x){return(_x.occ*100).toFixed(1);})});a.push({name:b.name,data:b.lastdata.map(function(_x){return Number(_x.adr).toFixed(0);})});return a;},[])});(0,_compute.setKarte)({id:"chartAdr",title:date+'\u5E74 ADR+OCC',dataName:data.map(function(x){return x.name;}),dataY:data.reduce(function(a,b,i){a.push({name:b.name,type:"percent",data:b.data.map(function(_x){return(_x.occ*100).toFixed(1);})});a.push({name:b.name,data:b.data.map(function(_x){return Number(_x.adr).toFixed(0);})});return a;},[])});// revpar
(0,_compute.setKarte)({id:"revpar_year",title:date-1+'\u5E74 RevPAR',dataName:data.map(function(x){return x.name;}),dataY:data.map(function(x){return{name:x.name,data:x.lastdata.map(function(y){return Number(y.revpar).toFixed(0);})};})});(0,_compute.setKarte)({id:"revpar_last",title:date+'\u5E74 RevPAR',dataName:data.map(function(x){return x.name;}),dataY:data.map(function(x){return{name:x.name,data:x.data.map(function(y){return Number(y.revpar).toFixed(0);})};})});// room rev
(0,_compute.setKarte)({id:"roomrev_year",title:date-1+'\u5E74 Room Revenue',dataName:data.map(function(x){return x.name;}),dataY:data.map(function(x){return{name:x.name,data:x.lastdata.map(function(y){return Number(y.rev).toFixed(0);})};})});(0,_compute.setKarte)({id:"roomrev_last",title:date+'\u5E74 Room Revenue',dataName:data.map(function(x){return x.name;}),dataY:data.map(function(x){return{name:x.name,data:x.data.map(function(y){return Number(y.rev).toFixed(0);})};})});_this.setState({data:data,loading:false});_context.next=20;break;case 16:_context.prev=16;_context.t0=_context['catch'](0);console.log(_context.t0);_this.setState({loading:false});case 20:case'end':return _context.stop();}}},_callee,_this2,[[0,16]]);}));return function(_x2){return _ref.apply(this,arguments);};}();_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY'),data:[],lastdata:[],loading:true,loadingSave:false,print:false,dateData:[],area:"东南华南"};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){var date=Number(this.state.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});this.getData({date:this.state.date,area:this.state.area});}},{key:'render',value:function render(){var _this3=this;var _state=this.state,dateData=_state.dateData,loading=_state.loading,data=_state.data,date=_state.date,area=_state.area;return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'table7_1_1 table7_6 table4_2_area_summary',id:'table4_2_2',style:{height:'auto'}},_react2.default.createElement(_row2.default,{className:'title'},_react2.default.createElement(_row2.default,null,'\u5341\u4E00\u533A\u57DF\u62A5\u8868'),_react2.default.createElement('div',{className:'title-select'},_react2.default.createElement(_select2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u4EFD',style:{width:120},value:date,onChange:function onChange(str){_this3.setState({date:str,data:[],loading:true},function(){_this3.getData({date:str,area:area});});}},dateData.map(function(x,i){return _react2.default.createElement(Option,{value:x,key:x},x,'\u5E74');})),_react2.default.createElement(_select2.default,{allowClear:true,defaultValue:area,style:{width:200,marginLeft:20},onChange:function onChange(value){_this3.setState({data:[],loading:true,area:value},function(){_this3.getData({date:date,area:value});});}},_react2.default.createElement(Option,{value:'\u4E1C\u5357\u534E\u5357'},'\u4E1C\u5357\u534E\u5357'),_react2.default.createElement(Option,{value:'\u534E\u5317\u534E\u4E2D'},'\u534E\u5317\u534E\u4E2D'),_react2.default.createElement(Option,{value:'\u6C5F\u6D59\u6CAA\u7696'},'\u6C5F\u6D59\u6CAA\u7696'),_react2.default.createElement(Option,{value:'\u897F\u5357'},'\u897F\u5357')))),_react2.default.createElement(_row2.default,{className:'title'},_react2.default.createElement('div',{className:'chart-4-2'},_react2.default.createElement('div',{id:'chartOcc'}),_react2.default.createElement('div',{id:'chartAdr'}),_react2.default.createElement('div',{id:'revpar_year'}),_react2.default.createElement('div',{id:'revpar_last'}),_react2.default.createElement('div',{id:'roomrev_year'}),_react2.default.createElement('div',{id:'roomrev_last'})))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setKarte=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);var _method=__webpack_require__(20);var _method2=_interopRequireDefault(_method);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var color=['#C4BD97','#F79646','#FF2500','#C01900','#92D050','#000000','#45A1B9','#98747F','#3DCFC5','#62AAA3','#6AF910','#948A54','#984808','#9F2397','#B3A2C7'];var setKarte=exports.setKarte=function setKarte(_ref,isOnResize){var dataX=_ref.dataX,dataY=_ref.dataY,id=_ref.id,title=_ref.title,yAxis=_ref.yAxis,axisLabel=_ref.axisLabel;var myChart=_echarts2.default.init(document.getElementById(id));myChart.resize();if(isOnResize){return;}var option={color:color,title:{text:title},tooltip:{trigger:'axis',axisPointer:{type:'cross'}},grid:{top:120},legend:{top:30,data:dataY.map(function(x){return x.name;})},toolbox:{feature:{saveAsImage:{show:true}}},xAxis:[{type:'category',axisLabel:_extends({color:"black",fontSize:14},axisLabel),data:dataX||['10/1','10/2','10/3','10/4','10/5','10/6','10/7']}],yAxis:yAxis||[{type:'value',name:'',axisLabel:{formatter:'{value}'}},{type:'value',name:'',axisLabel:{formatter:'{value} %'}}],series:dataY.map(function(x,i){return{name:x.name,type:x.type&&x.type=='percent'?"line":'bar',data:x.data,yAxisIndex:x.type==="percent"?1:0};})};myChart.setOption(option);};

/***/ }),
/* 1883 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(4);__webpack_require__(42);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _compute=__webpack_require__(1885);__webpack_require__(1886);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2){var date=_ref2.date,area=_ref2.area;var year,res,data;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;year=(0,_moment2.default)(date).format('YYYY');_context.next=4;return(0,_request2.default)('/_4_2_daily/area_holidays?year='+year+'&month=all&area='+area);case 4:res=_context.sent;data=(0,_compute.compute)(res.data||[]);console.log(data);// adr occ
(0,_compute.setKarte)({id:"chartOcc",title:date-1+'\u5E74 ADR+OCC',dataName:data.map(function(x){return x.name;}),dataY:data.reduce(function(a,b,i){a.push({name:b.name,type:"percent",data:b.lastdata.map(function(_x){return Number(_x.occ).toFixed(1);})});a.push({name:b.name,data:b.lastdata.map(function(_x){return Number(_x.adr).toFixed(0);})});return a;},[])});(0,_compute.setKarte)({id:"chartAdr",title:date+'\u5E74 ADR+OCC',dataName:data.map(function(x){return x.name;}),dataY:data.reduce(function(a,b,i){a.push({name:b.name,type:"percent",data:b.data.map(function(_x){return Number(_x.occ).toFixed(1);})});a.push({name:b.name,data:b.data.map(function(_x){return Number(_x.adr).toFixed(0);})});return a;},[])});// revpar
(0,_compute.setKarte)({id:"revpar_year",title:date-1+'\u5E74 RevPAR',dataName:data.map(function(x){return x.name;}),dataY:data.map(function(x){return{name:x.name,data:x.lastdata.map(function(y){return Number(y.revpar).toFixed(0);})};})});(0,_compute.setKarte)({id:"revpar_last",title:date+'\u5E74 RevPAR',dataName:data.map(function(x){return x.name;}),dataY:data.map(function(x){return{name:x.name,data:x.data.map(function(y){return Number(y.revpar).toFixed(0);})};})});// room rev
(0,_compute.setKarte)({id:"roomrev_year",title:date-1+'\u5E74 Room Revenue',dataName:data.map(function(x){return x.name;}),dataY:data.map(function(x){return{name:x.name,data:x.lastdata.map(function(y){return Number(y.rev).toFixed(0);})};})});(0,_compute.setKarte)({id:"roomrev_last",title:date+'\u5E74 Room Revenue',dataName:data.map(function(x){return x.name;}),dataY:data.map(function(x){return{name:x.name,data:x.data.map(function(y){return Number(y.rev).toFixed(0);})};})});_this.setState({data:data,loading:false});_context.next=20;break;case 16:_context.prev=16;_context.t0=_context['catch'](0);console.log(_context.t0);_this.setState({loading:false});case 20:case'end':return _context.stop();}}},_callee,_this2,[[0,16]]);}));return function(_x2){return _ref.apply(this,arguments);};}();_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY'),data:[],lastdata:[],loading:true,loadingSave:false,print:false,dateData:[],area:"东南华南"};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){var date=Number(this.state.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});this.getData({date:this.state.date,area:this.state.area});}},{key:'render',value:function render(){var _this3=this;var _state=this.state,dateData=_state.dateData,loading=_state.loading,data=_state.data,date=_state.date,area=_state.area;return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'table7_1_1 table7_6 table4_2_area_summary',id:'table4_2_2',style:{height:'auto'}},_react2.default.createElement(_row2.default,{className:'title'},_react2.default.createElement(_row2.default,null,'\u5E74\u5EA6\u533A\u57DF\u62A5\u8868'),_react2.default.createElement('div',{className:'title-select'},_react2.default.createElement(_select2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u4EFD',style:{width:120},value:date,onChange:function onChange(str){_this3.setState({date:str,data:[],loading:true},function(){_this3.getData({date:str,area:area});});}},dateData.map(function(x,i){return _react2.default.createElement(Option,{value:x,key:x},x,'\u5E74');})),_react2.default.createElement(_select2.default,{allowClear:true,defaultValue:area,style:{width:200,marginLeft:20},onChange:function onChange(value){_this3.setState({data:[],loading:true,area:value},function(){_this3.getData({date:date,area:value});});}},_react2.default.createElement(Option,{value:'\u4E1C\u5357\u534E\u5357'},'\u4E1C\u5357\u534E\u5357'),_react2.default.createElement(Option,{value:'\u534E\u5317\u534E\u4E2D'},'\u534E\u5317\u534E\u4E2D'),_react2.default.createElement(Option,{value:'\u6C5F\u6D59\u6CAA\u7696'},'\u6C5F\u6D59\u6CAA\u7696'),_react2.default.createElement(Option,{value:'\u897F\u5357'},'\u897F\u5357')))),_react2.default.createElement(_row2.default,{className:'title'},_react2.default.createElement('div',{className:'chart-4-2'},_react2.default.createElement('div',{id:'chartOcc'}),_react2.default.createElement('div',{id:'chartAdr'}),_react2.default.createElement('div',{id:'revpar_year'}),_react2.default.createElement('div',{id:'revpar_last'}),_react2.default.createElement('div',{id:'roomrev_year'}),_react2.default.createElement('div',{id:'roomrev_last'})))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.compute=exports.setKarte=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);var _method=__webpack_require__(20);var _method2=_interopRequireDefault(_method);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var color=['#C4BD97','#F79646','#FF2500','#C01900','#92D050','#000000','#45A1B9','#98747F','#3DCFC5','#62AAA3','#6AF910','#948A54','#984808','#9F2397','#B3A2C7'];var setKarte=exports.setKarte=function setKarte(_ref,isOnResize){var _ref$dataX=_ref.dataX,dataX=_ref$dataX===undefined?new Array(12).fill(1).map(function(x,i){return i+1+"\u6708";}):_ref$dataX,dataY=_ref.dataY,id=_ref.id,title=_ref.title,yAxis=_ref.yAxis,axisLabel=_ref.axisLabel;var myChart=_echarts2.default.init(document.getElementById(id));myChart.resize();if(isOnResize){return;}var option={color:color,title:{text:title},tooltip:{trigger:'axis',axisPointer:{type:'cross'}},grid:{top:120},legend:{top:30,data:dataY.map(function(x){return x.name;})},toolbox:{feature:{saveAsImage:{show:true}}},xAxis:[{type:'category',axisLabel:_extends({color:"black",fontSize:14},axisLabel),data:dataX}],yAxis:yAxis||[{type:'value',name:'',axisLabel:{formatter:'{value}'}},{type:'value',name:'',axisLabel:{formatter:'{value} %'}}],series:dataY.map(function(x,i){return{name:x.name,type:x.type&&x.type=='percent'?"line":'bar',data:x.data,yAxisIndex:x.type==="percent"?1:0};})};myChart.setOption(option);};var compute=exports.compute=function compute(data){data.forEach(function(hotel,i){data[i].data=Array.prototype.slice.call(hotel.data).map(function(item){return _extends({},item,{revper:(0,_method.calculation)(item.rev,item.total,2),occ:((0,_method.calculation)(item.sold,item.ava,3)*100).toFixed(1),adr:(0,_method.calculation)(item.rev,item.sold,2),revpar:(0,_method.calculation)(item.rev,item.ava,2)});});data[i].lastdata=Array.prototype.slice.call(hotel.lastdata).map(function(item){return _extends({},item,{revper:(0,_method.calculation)(item.rev,item.total,2),occ:((0,_method.calculation)(item.sold,item.ava,3)*100).toFixed(1),adr:(0,_method.calculation)(item.rev,item.sold,2),revpar:(0,_method.calculation)(item.rev,item.ava,2)});});});return data;};

/***/ }),
/* 1886 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _forecast=__webpack_require__(1888);var _forecast2=_interopRequireDefault(_forecast);var _history=__webpack_require__(1891);var _history2=_interopRequireDefault(_history);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){return _react2.default.createElement('div',null,_react2.default.createElement(_forecast2.default,null),_react2.default.createElement(_history2.default,null));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(8);__webpack_require__(6);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(1889);var _data2=_interopRequireDefault(_data);var _compute=__webpack_require__(1890);var _axios=__webpack_require__(86);var _axios2=_interopRequireDefault(_axios);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().isBefore((0,_moment2.default)('2023-12-31'))?'2024-01':(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,data4_1:[],key:"4_3_1_new_f",data1_1:[]},_this.computeNum=function(data){data=(0,_compute.compute)(data);_this.setState({data:data,loading:false});},_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var data,month,year,res,last,name;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_this.setState({loading:true});data=JSON.parse(JSON.stringify(_data2.default));month=(0,_moment2.default)(date).format('M');year=(0,_moment2.default)(date).format('YYYY');if(_this.state.key==='_4new_4_3_1_budget')month=null;_context.next=8;return _axios2.default.get('/api/data',{year:year,month:month,key:_this.state.key});case 8:res=_context.sent;if(res.data&&res.data.length)data=res.data;// 强制填充实际数据
if(!(_this.state.key!='_4new_4_3_1_budget')){_context.next=19;break;}_context.next=13;return _axios2.default.post('/api/data',{list:[{year:year,month:month-1,key:_this.state.key,name:'last'},{year:year,key:"_4new_4_3_1_budget",name:'budget'}]});case 13:last=_context.sent;console.log(last);name=["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"][~~(month-1)];// 当月预测数据不填充 
if(last.data.last&&last.data.last.length&&!res.data.length)data=last.data.last.map(function(x){var _extends2;delete x.id;return _extends({},x,(_extends2={},_defineProperty(_extends2,name+"_adr",0),_defineProperty(_extends2,name+"_rev",0),_defineProperty(_extends2,name+"_rn",0),_defineProperty(_extends2,"month",month),_defineProperty(_extends2,"year",year),_extends2));});if(last.data.last&&last.data.last.length)data=last.data.last.map(function(x,index){delete x.id;return _extends({},data[index],["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"].reduce(function(a,b,i){if(i<~~(month-1)){var _extends3;a=_extends({},a,(_extends3={},_defineProperty(_extends3,b+"_adr",x[b+"_adr"]),_defineProperty(_extends3,b+"_rev",x[b+"_rev"]),_defineProperty(_extends3,b+"_rn",x[b+"_rn"]),_extends3));}return a;},{}),{month:month,year:year});});// 预算的实际可售房数填充
if(last.data.budget&&last.data.budget.length){_compute.nameList.forEach(function(name){data[35][name+"_rn"]=data[35][name+"_rn"]||_lodash2.default.get(last.data.budget,"35."+name+"_rn",0);});}case 19:_this.computeNum(data);_this.getKpis(date);_context.next=27;break;case 23:_context.prev=23;_context.t0=_context["catch"](0);_this.setState({loading:false});console.error(_context.t0);case 27:case"end":return _context.stop();}}},_callee,_this2,[[0,23]]);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.getKpis=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(date){return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:fetch("/kpiInfo?year="+(0,_moment2.default)(date).format('YYYY')+"&month="+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this.setState({data1_1:x.data||[]});});case 1:case"end":return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}(),_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(){var _this$state,date,key,year,month,data,postData,x;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;_this$state=_this.state,date=_this$state.date,key=_this$state.key;if(date){_context3.next=4;break;}return _context3.abrupt("return",_message3.default.error('请选择年份月份'));case 4:_this.setState({loadingSave:true});year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");data=_this.state.data.map(function(x,i){var res=_extends({},x,{year:year,sort:i});if(key!='_4new_4_3_1_budget')res.month=month;return res;});postData={data:data,year:year,key:key};if(key!='_4new_4_3_1_budget')postData.month=month;_context3.next=12;return _axios2.default.post("/api/save",postData);case 12:x=_context3.sent;_this.setState({loadingSave:false});if(x.code==200){_message3.default.success("保存成功！");if(!data[0].id)_this.getData(_this.state.date);}_context3.next=21;break;case 17:_context3.prev=17;_context3.t0=_context3["catch"](0);_this.setState({loadingSave:false});console.error(_context3.t0);case 21:case"end":return _context3.stop();}}},_callee3,_this2,[[0,17]]);})),_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('view4_1_4',1.5,'4.31',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});},_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+" "+(0,_moment2.default)(_this.state.date).format('YYYY')+" 4.3.1 Market Segment by Month \u5E02\u573A\u7EC6\u5206\u660E\u7EC6\u8868\u6708\u5EA6\u5206\u89E3";var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById('table4_1_4').innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+".xls");_this.setState({print:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print,loading=_state.loading,key=_state.key,data1_1=_state.data1_1;return _react2.default.createElement("div",{className:"table7_1_1 tableHeight"},_react2.default.createElement(_row2.default,{className:"title",id:"view4_1_4",style:{width:print?6150:'auto'}},_react2.default.createElement(_row2.default,null,"4.3.1 Market Segment by Month \u5E02\u573A\u7EC6\u5206\u660E\u7EC6\u8868\u6708\u5EA6\u5206\u89E3"),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},value:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:"YYYY-MM",disabledDate:function disabledDate(v){if((0,_moment2.default)(v).isAfter((0,_moment2.default)('2023-12-31')))return false;return true;},onChange:function onChange(date,str){_this3.setState({date:str,data:[]});_this3.getData(str);}}),_react2.default.createElement(_button2.default,{type:key=="4_3_1_new_f"?'primary':'default',style:{marginLeft:10},onClick:function onClick(){if(key==="4_3_1_new_f")return;_this3.setState({key:"4_3_1_new_f",data:[]},function(){_this3.getData(date);});}},"\u9884\u6D4B/\u5B9E\u9645"),_react2.default.createElement(_button2.default,{type:key=="_4new_4_3_1_budget"?'primary':'default',style:{marginLeft:10},onClick:function onClick(){if(key==="_4new_4_3_1_budget")return;_this3.setState({key:"_4new_4_3_1_budget",data:[]},function(){_this3.getData(date);});}},"\u9884\u7B97")),_react2.default.createElement(_table2.default,{columns:(0,_compute.columns)(this.onChange,date,key=='4_3_1_new_f'?1:key=='_4new_4_3_1_budget'?3:2,print,data1_1),dataSource:data,size:"middle",id:"table4_1_4",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{x:true,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:"table-footer-btn"},_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:print},"\u5BFC\u51FAExcel"),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:"edit_4_3_1_new"},_react2.default.createElement(_button2.default,{type:"primary",style:{margin:'0 10px'},onClick:this.downloadSG,loading:print},"\u52A0\u5165pdf"),_react2.default.createElement(_button2.default,{type:"primary",onClick:this.onSave,loading:this.state.loadingSave},"\u4FDD\u5B58"))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=["BAR 最优门市价","Package & Promotion 包价和促销","E-commerce 电子商务价","Total Retail 零售散客合计","Traditional Wholesale 传统旅游批发商","Online Wholesale 在线旅游批发商","Total Wholesale 旅游批发商合计","TMC 商旅管理公司价","Local Negotiate 本地协议价","National Key Account 全国性协议价","Total Corporate 公司散客合计","Government/Diplomat 政府价","Qualified Discount 特殊折扣价","Award&Redemption 积分奖励和兑换","Total Discount&Award 折扣与奖励合计","Total Transient 散客合计","MICE Group 会议团","Government Group 政府团","Total Business Group 商务团队合计","Group Tour Series 系列旅游团","Group Ad Hoc 一次性旅游团","Group Others 其他团队","Total Tour Group 旅游团队合计","Total Group 团队合计","Long Stay 长住","Air Crew 机组","Flight Layover 误机客","Total Contracts 合同价合计","Barter ","House Use 自用房","Comp Room 免费房","Other Revenue 其他收入","Service Charge 服务费","Total Others 其它合计","总计 （不含免房）","Net Available Rooms 实际可卖房量","Unsold Rooms 未售出房量","出租率/平均房价/每房收益"].map(function(name,i){return{name:name,key:name,sort:i,jan_rn:0,jan_adr:0,jan_rev:0,janf_rn:0,janf_adr:0,janf_rev:0,feb_rn:0,feb_adr:0,feb_rev:0,mar_rn:0,mar_adr:0,mar_rev:0,apr_rn:0,apr_adr:0,apr_rev:0,may_rn:0,may_adr:0,may_rev:0,jun_rn:0,jun_adr:0,jun_rev:0,jul_rn:0,jul_adr:0,jul_rev:0,aug_rn:0,aug_adr:0,aug_rev:0,sep_rn:0,sep_adr:0,sep_rev:0,oct_rn:0,oct_adr:0,oct_rev:0,nov_rn:0,nov_adr:0,nov_rev:0,dec_rn:0,dec_adr:0,dec_rev:0,full_rn:0,full_adr:0,full_rev:0};});

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columns=exports.compute=exports.nameList=undefined;var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _method=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var totalIndex=[3,6,10,14,15,18,22,23,27,33,34,37];var percentIndex=[37];var nameList=exports.nameList=["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec",'full'];var compute=exports.compute=function compute(data){var sumIndex={3:[0,1,2],6:[4,5],10:[7,8,9],14:[12,13],15:[3,6,10,11,14],18:[16,17],22:[19,20,21],23:[18,22],27:[24,25,26],33:[28,29,30,31,32],34:[15,23,27,28]};['janf'].concat(nameList).forEach(function(name){if(name!='full'){var rn=name+"_rn";var rev=name+"_rev";Object.entries(sumIndex).forEach(function(index){data[index[0]][rn]=index[1].reduce(function(a,b){return a+=(0,_method.numConvert)(data[b][rn]);},0).toFixed(2);data[index[0]][rev]=[].concat(_toConsumableArray(index[1]),_toConsumableArray(index[0]==34?[31,32]:[])).reduce(function(a,b){return a+=(0,_method.numConvert)(data[b][rev]);},0).toFixed(2);});}});data.forEach(function(item,index){data[index]['full_rn']=nameList.reduce(function(a,b){if(b=='full')return a;return a+(0,_method.numConvert)(item[b+"_rn"]);},0).toFixed(2);data[index]['full_rev']=nameList.reduce(function(a,b){if(b=='full')return a;return a+(0,_method.numConvert)(item[b+"_rev"]);},0).toFixed(2);});data.forEach(function(item,index){if(index!=37)['janf'].concat(nameList).forEach(function(name){data[index][name+"_adr"]=(0,_method.calculation)(data[index][name+"_rev"],data[index][name+"_rn"]);});});['janf'].concat(nameList).forEach(function(name){data[36][name+"_rn"]=~~(data[35][name+"_rn"]-data[34][name+"_rn"]);data[37][name+"_rn"]=(0,_method.calculation)(data[34][name+"_rn"],data[35][name+"_rn"],4);data[37][name+"_adr"]=(0,_method.calculation)(data[34][name+"_rev"],data[34][name+"_rn"],2);data[37][name+"_rev"]=(data[37][name+"_rn"]*data[37][name+"_adr"]).toFixed(2);});return data;};var columns=exports.columns=function columns(onChange,date,type,print,data1_1){// type 1 forecast 2 actual
var month=(0,_moment2.default)(date).format('M');var year=(0,_moment2.default)(date).format('YYYY');var sqlName=type==1?"_4new_4_3_1_forecast":type==2?"_4new_4_3_1_actual":'_4new_4_3_1_budget';// 对比1.1 平均房价
var _data1_1=_lodash2.default.get(data1_1,"3."+(type==1?'prediction':type==2?'actual':'budget'),0);var key=[];if(false)key=[{title:"Index",dataIndex:'index',key:'index',align:"center",fixed:print?false:"left",width:50,render:function render(text,record,index){var props={text:""+index,index:index,type:'text',name:"index",onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}];return[].concat(_toConsumableArray(key),[{title:year,dataIndex:'name',key:'name',align:"center",fixed:print?false:"left",width:300,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:onChange,totalIndex:totalIndex,compared:{title:['name'],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}}],_toConsumableArray(nameList.map(function(name,i){var title=type==3?'Budget':name=='full'?'Actual/Forecast':i<month?'Actual':'Forecast';var childTitle=name=='full'?"FULL YEAR":~~(i+1)+"\u6708";return{title:year+" "+title,align:"center",width:450,children:[{title:childTitle,align:"center",width:450,children:[{title:"RNs",dataIndex:name+"_rn",key:name+"_rn",width:150,align:"center",render:function render(text,record,index){var title=[title,childTitle,'RNs'];var props={text:text,index:index,type:[31,32].includes(index)?'':percentIndex.includes(index)?'percent':name=='full'||print||i<~~(month-1)?'number':[].concat(totalIndex,[36]).includes(index)?'number':"inputNumber",name:name+"_rn",onChange:onChange,totalIndex:totalIndex};props.compared={title:title,record:record,sqlName:sqlName};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"ADR",dataIndex:name+"_adr",key:name+"_adr",width:150,align:"center",render:function render(text,record,index){var title=[title,childTitle,'ADR'];var props={text:text,index:index,type:[29,30,31,32,35,36].includes(index)?'':"number",name:name+"_adr",onChange:onChange,totalIndex:totalIndex,yellowText:index==34&&i==~~(month-1)&&_data1_1!=text?'与1.1对比不一致，请检查':''};props.compared={title:title,record:record,sqlName:sqlName};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"REVENUE",dataIndex:name+"_rev",key:name+"_rev",width:150,align:"center",render:function render(text,record,index){var title=[title,childTitle,'REVENUE'];var props={text:text,index:index,type:[29,30,35,36].includes(index)?'':name=='full'||print||i<~~(month-1)?'number':[].concat(totalIndex,[36]).includes(index)?'number':"inputNumber",name:name+"_rev",onChange:onChange,totalIndex:totalIndex};props.compared={title:title,record:record,sqlName:sqlName};return _react2.default.createElement(_TableText2.default,{data:props});}}]}]};})));};

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _forecast=__webpack_require__(1892);var _forecast2=_interopRequireDefault(_forecast);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){return _react2.default.createElement('div',null,_react2.default.createElement(_forecast2.default,null));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data2=__webpack_require__(1893);var _data3=_interopRequireDefault(_data2);var _compute=__webpack_require__(1894);var _axios=__webpack_require__(86);var _axios2=_interopRequireDefault(_axios);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().isAfter((0,_moment2.default)('2023-12-31'))?'2023-12':(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,data4_1:[],key:"_4_1_rev"},_this.computeNum=function(data){var other=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];data=(0,_compute.compute)(data,other);_this.setState({data:data,loading:false},function(){_this.onSave();});},_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var data,month,year,res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_this.setState({loading:true});data=JSON.parse(JSON.stringify(_data3.default));month=(0,_moment2.default)(date).format('M');year=(0,_moment2.default)(date).format('YYYY');_context.next=7;return _axios2.default.post('/api/data',{list:[{name:"data",key:_this.state.key,year:year,month:month},{name:"actual",key:"_4new_4_3_1_history",year:year,month:month}]});case 7:res=_context.sent;if(res.data.actual&&res.data.actual.length)data=res.data.actual||[];_this.computeNum(data,res.data.data);_context.next=16;break;case 12:_context.prev=12;_context.t0=_context["catch"](0);_this.setState({loading:false});console.error(_context.t0);case 16:case"end":return _context.stop();}}},_callee,_this2,[[0,12]]);}));return function(_x2){return _ref2.apply(this,arguments);};}(),_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var _this$state,date,_data,year,month,data,postData,x;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_this$state=_this.state,date=_this$state.date,_data=_this$state.data;if(date){_context2.next=4;break;}return _context2.abrupt("return",_message3.default.error('请选择年份月份'));case 4:_this.setState({loadingSave:true});year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");data=_data.map(function(x,i){return _extends({},x,{year:year,sort:i,month:month});});postData={data:data,year:year,month:month,key:"_4new_4_3_1_history"};_context2.next=11;return _axios2.default.post("/api/save",postData);case 11:x=_context2.sent;_this.setState({loadingSave:false});if(x.code==200){if(!data[0].id)_this.getData(_this.state.date);}_context2.next=20;break;case 16:_context2.prev=16;_context2.t0=_context2["catch"](0);_this.setState({loadingSave:false});console.error(_context2.t0);case 20:case"end":return _context2.stop();}}},_callee2,_this2,[[0,16]]);})),_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('view4_1_4_history',1.5,'4.311',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});},_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+" "+(0,_moment2.default)(_this.state.date).format('YYYY')+" 4.3.1 Market Segment by Month \u5E02\u573A\u7EC6\u5206\u660E\u7EC6\u8868\u6708\u5EA6\u5206\u89E3";var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById('table4_1_4').innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+".xls");_this.setState({print:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print,loading=_state.loading,key=_state.key;return _react2.default.createElement("div",{className:"table7_1_1 tableHeight"},_react2.default.createElement(_row2.default,{className:"title",id:"view4_1_4_history",style:{width:print?6150:'auto'}},_react2.default.createElement(_row2.default,null,"4.3.1 Market Segment by Month \u5E02\u573A\u7EC6\u5206\u660E\u7EC6\u8868\u6708\u5EA6\u5206\u89E3(\u539F4.1.1\u6570\u636E)"),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},disabledDate:function disabledDate(v){if((0,_moment2.default)(v).isBefore((0,_moment2.default)('2023-12-31')))return false;return true;},value:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:"YYYY-MM",onChange:function onChange(date,str){_this3.setState({date:str,data:[]});_this3.getData(str);}})),_react2.default.createElement(_table2.default,{columns:(0,_compute.columns)(this.onChange,date,key=='4_3_1_new_f'?1:key=='_4new_4_3_1_budget'?3:2,print),dataSource:data,size:"middle",id:"table4_1_4",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{x:true,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:"table-footer-btn"},_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:print},"\u5BFC\u51FAExcel")));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=["BAR 最优门市价","Package & Promotion 包价和促销","E-commerce 电子商务价","Total Retail 零售散客合计","Traditional Wholesale 传统旅游批发商","Online Wholesale 在线旅游批发商","Total Wholesale 旅游批发商合计","TMC 商旅管理公司价","Local Negotiate 本地协议价","National Key Account 全国性协议价","Total Corporate 公司散客合计","Government/Diplomat 政府价","Qualified Discount 特殊折扣价","Award&Redemption 积分奖励和兑换","Total Discount&Award 折扣与奖励合计","Total Transient 散客合计","MICE Group 会议团","Government Group 政府团","Total Business Group 商务团队合计","Group Tour Series 系列旅游团","Group Ad Hoc 一次性旅游团","Group Others 其他团队","Total Tour Group 旅游团队合计","Total Group 团队合计","Long Stay 长住","Air Crew 机组","Flight Layover 误机客","Total Contracts 合同价合计","Barter ","House Use 自用房","Comp Room 免费房","Other Revenue 其他收入","Service Charge 服务费","Total Others 其它合计","总计 （不含免房）","Net Available Rooms 实际可卖房量","Unsold Rooms 未售出房量","出租率/平均房价/每房收益"].map(function(name,i){return{name:name,key:name,sort:i,jan_rn:0,jan_adr:0,jan_rev:0,feb_rn:0,feb_adr:0,feb_rev:0,mar_rn:0,mar_adr:0,mar_rev:0,apr_rn:0,apr_adr:0,apr_rev:0,may_rn:0,may_adr:0,may_rev:0,jun_rn:0,jun_adr:0,jun_rev:0,jul_rn:0,jul_adr:0,jul_rev:0,aug_rn:0,aug_adr:0,aug_rev:0,sep_rn:0,sep_adr:0,sep_rev:0,oct_rn:0,oct_adr:0,oct_rev:0,nov_rn:0,nov_adr:0,nov_rev:0,dec_rn:0,dec_adr:0,dec_rev:0,full_rn:0,full_adr:0,full_rev:0};});

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columns=exports.compute=undefined;var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _method=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var totalIndex=[3,6,10,14,15,18,22,23,27,33,34,37];var percentIndex=[37];var nameList=["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec",'full'];var compute=exports.compute=function compute(data,last){// 对应下历史数据
var correspond={0:"best",1:"packges",2:"commerce",5:"wholesale",8:"corporate",11:"government",12:"discounts",15:"total",16:"business",19:"leisure",23:"group_total",24:"contracts",31:"others",34:"grand"};nameList.forEach(function(name,i){var index=i*3+1;Object.entries(correspond).forEach(function(item){data[item[0]][name+"_rn"]=_lodash2.default.get(last,index+"."+item[1]+"_rn",0);data[item[0]][name+"_rev"]=_lodash2.default.get(last,index+"."+item[1]+"_rev",0);});data[35][name+"_rn"]=_lodash2.default.get(last,index+".grand_rms",0);});var sumIndex={3:[0,1,2],6:[4,5],10:[7,8,9],14:[12,13],15:[3,6,10,11,14],18:[16,17],22:[19,20,21],23:[18,22],27:[24,25,26],33:[28,29,30,31,32],34:[15,23,27,28]};nameList.forEach(function(name){if(name!='full'){var rn=name+"_rn";var rev=name+"_rev";Object.entries(sumIndex).forEach(function(index){data[index[0]][rn]=index[1].reduce(function(a,b){return a+=(0,_method.numConvert)(data[b][rn]);},0).toFixed(2);data[index[0]][rev]=[].concat(_toConsumableArray(index[1]),_toConsumableArray(index[0]==34?[31,32]:[])).reduce(function(a,b){return a+=(0,_method.numConvert)(data[b][rev]);},0).toFixed(2);});}});data.forEach(function(item,index){data[index]['full_rn']=nameList.reduce(function(a,b){if(b=='full')return a;return a+(0,_method.numConvert)(item[b+"_rn"]);},0).toFixed(2);data[index]['full_rev']=nameList.reduce(function(a,b){if(b=='full')return a;return a+(0,_method.numConvert)(item[b+"_rev"]);},0).toFixed(2);});data.forEach(function(item,index){if(index!=37)nameList.forEach(function(name){data[index][name+"_adr"]=(0,_method.calculation)(data[index][name+"_rev"],data[index][name+"_rn"]);});});nameList.forEach(function(name){data[36][name+"_rn"]=~~(data[35][name+"_rn"]-data[34][name+"_rn"]);data[37][name+"_rn"]=(0,_method.calculation)(data[34][name+"_rn"],data[35][name+"_rn"],4);data[37][name+"_adr"]=(0,_method.calculation)(data[34][name+"_rev"],data[34][name+"_rn"],2);data[37][name+"_rev"]=(data[37][name+"_rn"]*data[37][name+"_adr"]).toFixed(2);});return data;};var columns=exports.columns=function columns(onChange,date,type,print){// type 1 forecast 2 actual
var month=(0,_moment2.default)(date).format('M');var year=(0,_moment2.default)(date).format('YYYY');var sqlName=type==1?"_4new_4_3_1_forecast":type==2?"_4new_4_3_1_actual":'_4new_4_3_1_budget';return[{title:year,dataIndex:'name',key:'name',align:"center",fixed:print?false:"left",width:300,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:onChange,totalIndex:totalIndex,compared:{title:['name'],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}}].concat(_toConsumableArray(nameList.map(function(name,i){var title=type==1?'Forecast':type==2?'Actual':'Budget';var childTitle=name=='full'?"FULL YEAR":~~(i+1)+"\u6708";return{title:year+" "+title,align:"center",width:450,children:[{title:childTitle,align:"center",width:450,children:[{title:"RNs",dataIndex:name+"_rn",key:name+"_rn",width:150,align:"center",render:function render(text,record,index){var title=[title,childTitle,'RNs'];var props={text:text,index:index,type:percentIndex.includes(index)?'percent':"number",name:name+"_rn",onChange:onChange,totalIndex:totalIndex};props.compared={title:title,record:record,sqlName:sqlName};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"ADR",dataIndex:name+"_adr",key:name+"_adr",width:150,align:"center",render:function render(text,record,index){var title=[title,childTitle,'ADR'];var props={text:text,index:index,type:"number",name:name+"_adr",onChange:onChange,totalIndex:totalIndex};props.compared={title:title,record:record,sqlName:sqlName};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"REVENUE",dataIndex:name+"_rev",key:name+"_rev",width:150,align:"center",render:function render(text,record,index){var title=[title,childTitle,'REVENUE'];var props={text:text,index:index,type:"number",name:name+"_rev",onChange:onChange,totalIndex:totalIndex};props.compared={title:title,record:record,sqlName:sqlName};return _react2.default.createElement(_TableText2.default,{data:props});}}]}]};})));};

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data2=__webpack_require__(1896);var _data3=_interopRequireDefault(_data2);var _compute=__webpack_require__(1897);var _axios=__webpack_require__(86);var _axios2=_interopRequireDefault(_axios);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TITLE="4.3.2 Key Market Segment By Month 市场细分月度汇总表";var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,data4_1:[],key:"_4_1_rev"},_this.computeNum=function(data){var other=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];data=(0,_compute.compute)(data,other);_this.setState({data:data,loading:false},function(){_this.onSave();});},_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var month,year,data,res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;month=(0,_moment2.default)(date).format('M');year=(0,_moment2.default)(date).format('YYYY');data=JSON.parse(JSON.stringify((0,_data3.default)(year,month)));_this.setState({loading:true});_context.next=7;return _axios2.default.get('/es/4_3_2',{year:year,month:month});case 7:res=_context.sent;if(res.data.data&&res.data.data.length)data=res.data.data;_this.setState({data:(0,_compute.compute)(data,_extends({},res.data,{month:month,year:year})),loading:false},function(){_this.onSave();});_context.next=16;break;case 12:_context.prev=12;_context.t0=_context["catch"](0);_this.setState({loading:false});console.error(_context.t0);case 16:case"end":return _context.stop();}}},_callee,_this2,[[0,12]]);}));return function(_x2){return _ref2.apply(this,arguments);};}(),_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var _this$state,date,_data,year,month,data,postData,x;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_this$state=_this.state,date=_this$state.date,_data=_this$state.data;if(date){_context2.next=4;break;}return _context2.abrupt("return",_message3.default.error('请选择年份月份'));case 4:_this.setState({loadingSave:true});year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");data=_data.map(function(x,i){return _extends({},x,{year:year,sort:i,month:month});});postData={data:data,year:year,month:month,key:"_4new_4_3_2"};_context2.next=11;return _axios2.default.post("/api/save",postData);case 11:x=_context2.sent;_this.setState({loadingSave:false});if(x.code==200){_message3.default.success("保存成功！");if(!data[0].id)_this.getData(_this.state.date);}_context2.next=20;break;case 16:_context2.prev=16;_context2.t0=_context2["catch"](0);_this.setState({loadingSave:false});console.error(_context2.t0);case 20:case"end":return _context2.stop();}}},_callee2,_this2,[[0,16]]);})),_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('view4_1_4_history',1.5,'4.311',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});},_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+" "+(0,_moment2.default)(_this.state.date).format('YYYY')+" "+TITLE;var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById('table4_1_4').innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+".xls");_this.setState({print:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print,loading=_state.loading,key=_state.key;return _react2.default.createElement("div",{className:"table7_1_1 tableHeight"},_react2.default.createElement(_row2.default,{className:"title",id:"view4_1_4_history",style:{width:print?6150:'auto'}},_react2.default.createElement(_row2.default,null,TITLE),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},disabledDate:function disabledDate(v){if((0,_moment2.default)(v).isAfter((0,_moment2.default)('2023-12-31')))return false;return true;},value:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:"YYYY-MM",onChange:function onChange(date,str){_this3.setState({date:str,data:[]});_this3.getData(str);}})),_react2.default.createElement(_table2.default,{columns:(0,_compute.columns)(this.onChange,date,print),dataSource:data,size:"middle",id:"table4_1_4",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{x:true,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:"table-footer-btn"},_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:print},"\u5BFC\u51FAExcel")));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var keys=["retail","wholesale","coprorate","government","discount","transient","business","leisure","groups","contracts","others","total"];exports.default=function(year,month){return[].concat(_toConsumableArray(["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec","Q1","Q2","Q3","Q4","YTD","Year End"].reduce(function(a,b,i){return[].concat(_toConsumableArray(a),[_extends({month_name:b,year_name:year+" "+(i<12?i<month?'Actual':'Forecast ':'Actual')},keys.reduce(function(c,d){var _extends2;return _extends({},c,(_extends2={},_defineProperty(_extends2,d+"_rn",0),_defineProperty(_extends2,d+"_adr",0),_defineProperty(_extends2,d+"_rev",0),_extends2));},{})),_extends({month_name:b,year_name:year+" Budget"},keys.reduce(function(c,d){var _extends3;return _extends({},c,(_extends3={},_defineProperty(_extends3,d+"_rn",0),_defineProperty(_extends3,d+"_adr",0),_defineProperty(_extends3,d+"_rev",0),_extends3));},{})),_extends({month_name:b,year_name:year-1+" Actual"},keys.reduce(function(c,d){var _extends4;return _extends({},c,(_extends4={},_defineProperty(_extends4,d+"_rn",0),_defineProperty(_extends4,d+"_adr",0),_defineProperty(_extends4,d+"_rev",0),_extends4));},{}))]);},[])),[_extends({month_name:"% to Budget "+~~year,year_name:"YTD Actual "+year},keys.reduce(function(c,d){var _extends5;return _extends({},c,(_extends5={},_defineProperty(_extends5,d+"_rn",0),_defineProperty(_extends5,d+"_adr",0),_defineProperty(_extends5,d+"_rev",0),_extends5));},{})),_extends({month_name:"% to Budget "+~~year,year_name:"Y/E Fcast "+year},keys.reduce(function(c,d){var _extends6;return _extends({},c,(_extends6={},_defineProperty(_extends6,d+"_rn",0),_defineProperty(_extends6,d+"_adr",0),_defineProperty(_extends6,d+"_rev",0),_extends6));},{})),_extends({month_name:"% to YTD Last Year",year_name:"YTD Actual "+year},keys.reduce(function(c,d){var _extends7;return _extends({},c,(_extends7={},_defineProperty(_extends7,d+"_rn",0),_defineProperty(_extends7,d+"_adr",0),_defineProperty(_extends7,d+"_rev",0),_extends7));},{})),_extends({month_name:"Year End Mix %",year_name:"Budget "+year},keys.reduce(function(c,d){var _extends8;return _extends({},c,(_extends8={},_defineProperty(_extends8,d+"_rn",0),_defineProperty(_extends8,d+"_adr",0),_defineProperty(_extends8,d+"_rev",0),_extends8));},{})),_extends({month_name:"Year End Mix %",year_name:"Act/Fcst "+year},keys.reduce(function(c,d){var _extends9;return _extends({},c,(_extends9={},_defineProperty(_extends9,d+"_rn",0),_defineProperty(_extends9,d+"_adr",0),_defineProperty(_extends9,d+"_rev",0),_extends9));},{}))]).map(function(x,i){return _extends({},x,{sort:i});});};

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columns=exports.compute=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _method=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var totalIndex=[];var percentIndex=[54,55,56,57,58];var nameList=["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];var keys=[{name:"RETAIL",key:"retail"},{name:"WHOLESALE",key:"wholesale"},{name:"CORPORATE NEGOTIATE",key:"coprorate"},{name:"GOVERNMENT / DIPLOMAT",key:"government"},{name:"DISCOUNT & AWARDS",key:"discount"},{name:"TOTAL TRANSIENT",key:"transient"},{name:"TOTAL BUSINESS GROUP",key:"business"},{name:"TOTAL LEISURE GROUP",key:"leisure"},{name:"TOTAL GROUPS",key:"groups"},{name:"CONTRACTS",key:"contracts"},{name:"OTHERS",key:"others"},{name:"GRAND TOTAL",key:"total"}];var compute=exports.compute=function compute(data,_ref){var budget=_ref.budget,last=_ref.last,actual=_ref.actual,month=_ref.month;//    填充数据
var corresponding={retail:3,wholesale:6,coprorate:10,government:11,discount:14,transient:15,business:18,leisure:22,groups:23,contracts:27,others:33,total:34};Object.entries(corresponding).forEach(function(_ref2){var _ref3=_slicedToArray(_ref2,2),key=_ref3[0],index=_ref3[1];nameList.forEach(function(name,i){// 预算 
data[i*3+1][key+"_rn"]=_lodash2.default.get(budget,index+"."+name+"_rn",0);data[i*3+1][key+"_adr"]=_lodash2.default.get(budget,index+"."+name+"_adr",0);data[i*3+1][key+"_rev"]=_lodash2.default.get(budget,index+"."+name+"_rev",0);// 实际  
// if (i < ~~month) {
data[i*3][key+"_rn"]=_lodash2.default.get(actual,index+"."+name+"_rn",0);data[i*3][key+"_adr"]=_lodash2.default.get(actual,index+"."+name+"_adr",0);data[i*3][key+"_rev"]=_lodash2.default.get(actual,index+"."+name+"_rev",0);// }
// 去年
data[i*3+2][key+"_rn"]=_lodash2.default.get(last,index+"."+name+"_rn",0);data[i*3+2][key+"_adr"]=_lodash2.default.get(last,index+"."+name+"_adr",0);data[i*3+2][key+"_rev"]=_lodash2.default.get(last,index+"."+name+"_rev",0);});});// Q1 - Q4
keys.forEach(function(_ref4){var key=_ref4.key;[12,13,14,15].forEach(function(index,i){var INDEX=~~(index*3);data[INDEX][key+"_rn"]=(0,_method.sum)([data[~~((i*2+index-12)*3)][key+"_rn"],data[~~((i*2+index-11)*3)][key+"_rn"],data[~~((i*2+index-10)*3)][key+"_rn"]]);data[INDEX+1][key+"_rn"]=(0,_method.sum)([data[~~((i*2+index-12)*3)+1][key+"_rn"],data[~~((i*2+index-11)*3)+1][key+"_rn"],data[~~((i*2+index-10)*3)+1][key+"_rn"]]);data[INDEX+2][key+"_rn"]=(0,_method.sum)([data[~~((i*2+index-12)*3)+2][key+"_rn"],data[~~((i*2+index-11)*3)+2][key+"_rn"],data[~~((i*2+index-10)*3)+2][key+"_rn"]]);data[INDEX][key+"_rev"]=(0,_method.sum)([data[~~((i*2+index-12)*3)][key+"_rev"],data[~~((i*2+index-11)*3)][key+"_rev"],data[~~((i*2+index-10)*3)][key+"_rev"]]);data[INDEX+1][key+"_rev"]=(0,_method.sum)([data[~~((i*2+index-12)*3)+1][key+"_rev"],data[~~((i*2+index-11)*3)+1][key+"_rev"],data[~~((i*2+index-10)*3)+1][key+"_rev"]]);data[INDEX+2][key+"_rev"]=(0,_method.sum)([data[~~((i*2+index-12)*3)+2][key+"_rev"],data[~~((i*2+index-11)*3)+2][key+"_rev"],data[~~((i*2+index-10)*3)+2][key+"_rev"]]);data[INDEX][key+"_adr"]=(0,_method.calculation)((0,_method.sum)([data[~~((i*2+index-12)*3)][key+"_rev"],data[~~((i*2+index-11)*3)][key+"_rev"],data[~~((i*2+index-10)*3)][key+"_rev"]]),(0,_method.sum)([data[~~((i*2+index-12)*3)][key+"_rn"],data[~~((i*2+index-11)*3)][key+"_rn"],data[~~((i*2+index-10)*3)][key+"_rn"]]),2);data[INDEX+1][key+"_adr"]=(0,_method.calculation)((0,_method.sum)([data[~~((i*2+index-12)*3)+1][key+"_rev"],data[~~((i*2+index-11)*3)+1][key+"_rev"],data[~~((i*2+index-10)*3)+1][key+"_rev"]]),(0,_method.sum)([data[~~((i*2+index-12)*3)+1][key+"_rn"],data[~~((i*2+index-11)*3)+1][key+"_rn"],data[~~((i*2+index-10)*3)+1][key+"_rn"]]),2);data[INDEX+2][key+"_adr"]=(0,_method.calculation)((0,_method.sum)([data[~~((i*2+index-12)*3)+2][key+"_rev"],data[~~((i*2+index-11)*3)+2][key+"_rev"],data[~~((i*2+index-10)*3)+2][key+"_rev"]]),(0,_method.sum)([data[~~((i*2+index-12)*3)+2][key+"_rn"],data[~~((i*2+index-11)*3)+2][key+"_rn"],data[~~((i*2+index-10)*3)+2][key+"_rn"]]),2);});});// YTD
keys.forEach(function(_ref5){var key=_ref5.key;var RN=key+"_rn";var ARR=key+"_adr";var name=key+"_rev";data[48][RN]=data.reduce(function(a,b,i){if(i<48&&Math.ceil((i+1)/3)<=month&&i%3==0){a+=(0,_method.numConvert)(b[RN]);}return a;},0).toFixed(2);data[49][RN]=data.reduce(function(a,b,i){if(i<48&&Math.ceil((i+1)/3)<=month&&i%3==1){a+=(0,_method.numConvert)(b[RN]);}return a;},0).toFixed(2);data[50][RN]=data.reduce(function(a,b,i){if(i<48&&Math.ceil((i+1)/3)<=month&&i%3==2){a+=(0,_method.numConvert)(b[RN]);}return a;},0).toFixed(2);data[48][name]=data.reduce(function(a,b,i){if(i<48&&Math.ceil((i+1)/3)<=month&&i%3==0){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);data[49][name]=data.reduce(function(a,b,i){if(i<48&&Math.ceil((i+1)/3)<=month&&i%3==1){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);data[50][name]=data.reduce(function(a,b,i){if(i<48&&Math.ceil((i+1)/3)<=month&&i%3==2){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);data[48][ARR]=data[48][RN]==0?0:(data[48][name]/data[48][RN]).toFixed(2);data[49][ARR]=data[49][RN]==0?0:(data[49][name]/data[49][RN]).toFixed(2);data[50][ARR]=data[50][RN]==0?0:(data[50][name]/data[50][RN]).toFixed(2);[RN,name].forEach(function(newName){data[51][newName]=data.reduce(function(a,b,i){if(i<36&&i%3==0){a+=(0,_method.numConvert)(b[newName]);}return a;},0).toFixed(2);data[52][newName]=data.reduce(function(a,b,i){if(i<36&&i%3==1){a+=(0,_method.numConvert)(b[newName]);}return a;},0).toFixed(2);data[53][newName]=data.reduce(function(a,b,i){if(i<36&&i%3==2){a+=(0,_method.numConvert)(b[newName]);}return a;},0).toFixed(2);});[51,52,53].forEach(function(index){data[index][ARR]=data[index][RN]==0?0:(data[index][name]/data[index][RN]).toFixed(2);});});// % to Budget --- Year End Mix %
keys.forEach(function(_ref6){var key=_ref6.key;var RN=key+"_rn";var ARR=key+"_adr";var REV=key+"_rev";[RN,ARR,REV].forEach(function(name){data[54][name]=data[49][name]==0?0:((data[48][name]-data[49][name])/data[49][name]).toFixed(4);data[55][name]=data[52][name]==0?0:((data[51][name]-data[52][name])/data[52][name]).toFixed(4);data[56][name]=data[50][name]==0?0:((data[48][name]-data[50][name])/data[50][name]).toFixed(4);if(name.includes("_rn")||name.includes("_rev")){data[57][name]=(0,_method.calculation)(data[48][name],data[51][name],4);data[58][name]=(0,_method.calculation)(data[49][name],data[52][name],4);}});});return data;};var columns=exports.columns=function columns(onChange,date,print){var sqlName="_4new_4_3_2";return[{title:'key',dataIndex:'sort',key:'sort',align:"center",fixed:print?false:"left",width:50,render:function render(t){return t;}},{title:'MONTH',dataIndex:'month_name',key:'month_name',align:"center",fixed:print?false:"left",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"month_name",onChange:onChange,totalIndex:totalIndex,compared:{title:['MONTH'],record:record,sqlName:sqlName}};if(index<54){if(index%3===0)return{props:{rowSpan:3},children:_react2.default.createElement(_TableText2.default,{data:props})};return{props:{rowSpan:0}};}if([54,55,57,58].includes(index)){if(index==54||index==57)return{props:{rowSpan:2},children:_react2.default.createElement(_TableText2.default,{data:props})};return{props:{rowSpan:0}};}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'YEAR',dataIndex:'year_name',key:'year_name',align:"center",fixed:print?false:"left",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"year_name",onChange:onChange,totalIndex:totalIndex,compared:{title:['YEAR'],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}}].concat(_toConsumableArray(keys.map(function(item,i){return{title:item.name,align:"center",width:450,children:[{title:"R/Nts",dataIndex:item.key+"_rn",key:item.key+"_rn",width:150,align:"center",render:function render(text,record,index){var title=[item.name,'R/Nts'];var props={text:text,index:index,type:percentIndex.includes(index)?'percent':"number",name:item.key+"_rn",onChange:onChange,totalIndex:totalIndex};props.compared={title:title,record:record,sqlName:sqlName};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"ADR",dataIndex:item.key+"_adr",key:item.key+"_adr",width:150,align:"center",render:function render(text,record,index){var title=[item.name,'ADR'];var props={text:text,index:index,type:[57,58].includes(index)?'':percentIndex.includes(index)?'percent':"number",name:item.key+"_adr",onChange:onChange,totalIndex:totalIndex};props.compared={title:title,record:record,sqlName:sqlName};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"Revenue",dataIndex:item.key+"_rev",key:item.key+"_rev",width:150,align:"center",render:function render(text,record,index){var title=[item.name,'Revenue'];var props={text:text,index:index,type:percentIndex.includes(index)?'percent':"number",name:item.key+"_rev",onChange:onChange,totalIndex:totalIndex};props.compared={title:title,record:record,sqlName:sqlName};return _react2.default.createElement(_TableText2.default,{data:props});}}]};})));};

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _forecast=__webpack_require__(1899);var _forecast2=_interopRequireDefault(_forecast);var _diff=__webpack_require__(1902);var _diff2=_interopRequireDefault(_diff);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={id:new Date().valueOf()},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'render',value:function render(){var _this2=this;return _react2.default.createElement('div',null,_react2.default.createElement(_forecast2.default,{update:function update(){_this2.setState({id:new Date().valueOf()});}}),_react2.default.createElement(_diff2.default,{id:this.state.id}));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(1900);var _data2=_interopRequireDefault(_data);var _compute=__webpack_require__(1901);var _axios=__webpack_require__(86);var _axios2=_interopRequireDefault(_axios);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().isBefore((0,_moment2.default)('2023-12-31'))?'2024-01':(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,data4_1:[],elseData:{},key:"_4_2_1_new"},_this.computeNum=function(data,elseData){data=(0,_compute.compute)(data,elseData);_this.setState({data:data,loading:false});},_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data,_this.state.elseData);},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var data,month,year,res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_this.setState({loading:true});data=JSON.parse(JSON.stringify(_data2.default));month=(0,_moment2.default)(date).format('M');year=(0,_moment2.default)(date).format('YYYY');_context.next=7;return _axios2.default.post('/api/data',{list:[{name:"data",key:_this.state.key,year:year,month:month},{name:"budget",key:"_4new_4_3_1_budget",year:year},{name:"actual",key:"_4new_4_3_1_forecast",year:year,month:month},{name:"forecast",key:'_4new_4_3_1_forecast',year:(0,_moment2.default)(date).subtract(1,'month').format('YYYY'),month:(0,_moment2.default)(date).subtract(1,'month').format('M')},{name:"last",key:year>2024?"_4new_4_3_1_forecast":'_4_1_rev',year:~~(year-1),month:month}]});case 7:res=_context.sent;if(res.data.data&&res.data.data.length)data=res.data.data;_this.computeNum(data,_extends({},res.data,{month:month,year:year}));_this.setState({elseData:_extends({},res.data,{month:month,year:year})});_context.next=17;break;case 13:_context.prev=13;_context.t0=_context["catch"](0);_this.setState({loading:false});console.error(_context.t0);case 17:case"end":return _context.stop();}}},_callee,_this2,[[0,13]]);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var _this$state,date,key,year,month,data,postData,x;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_this$state=_this.state,date=_this$state.date,key=_this$state.key;if(date){_context2.next=4;break;}return _context2.abrupt("return",_message3.default.error('请选择年份月份'));case 4:_this.setState({loadingSave:true});year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");data=_this.state.data.map(function(x,i){var res=_extends({},x,{year:year,sort:i,month:month});return res;});postData={data:data,year:year,key:key,month:month};_context2.next=11;return _axios2.default.post("/api/save",postData);case 11:x=_context2.sent;_this.setState({loadingSave:false});if(x.code==200){_message3.default.success("保存成功！");if(!data[0].id)_this.getData(_this.state.date);_this.props.update();}_context2.next=20;break;case 16:_context2.prev=16;_context2.t0=_context2["catch"](0);_this.setState({loadingSave:false});console.error(_context2.t0);case 20:case"end":return _context2.stop();}}},_callee2,_this2,[[0,16]]);})),_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('view4_1_4',1.5,'4.21',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});},_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+" "+(0,_moment2.default)(_this.state.date).format('YYYY')+" 4.2.1 Monthly Market Segment Report \u6708\u5EA6\u5E02\u573A\u7EC6\u5206\u8868";var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById('table4_1_4').innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+".xls");_this.setState({print:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print,loading=_state.loading,key=_state.key;return _react2.default.createElement("div",{className:"table7_1_1 tableHeight"},_react2.default.createElement(_row2.default,{className:"title",id:"view4_1_4",style:{width:print?6150:'auto'}},_react2.default.createElement(_row2.default,null,"4.2.1 Monthly Market Segment Report \u6708\u5EA6\u5E02\u573A\u7EC6\u5206\u8868"),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},disabledDate:function disabledDate(v){if((0,_moment2.default)(v).isAfter((0,_moment2.default)('2023-12-31')))return false;return true;},value:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:"YYYY-MM",onChange:function onChange(date,str){_this3.setState({date:str,data:[]});_this3.getData(str);}})),_react2.default.createElement(_table2.default,{columns:(0,_compute.columns)(this.onChange,date,print),dataSource:data,size:"middle",id:"table4_1_4",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{x:true,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:"table-footer-btn"},_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:print},"\u5BFC\u51FAExcel"),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:"edit_4_2_1_new"},_react2.default.createElement(_button2.default,{type:"primary",style:{margin:'0 10px'},onClick:this.downloadSG,loading:print},"\u52A0\u5165pdf"),_react2.default.createElement(_button2.default,{type:"primary",onClick:this.onSave,loading:this.state.loadingSave},"\u4FDD\u5B58"))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=["BAR 最优门市价","Package & Promotion 包价和促销","E-commerce 电子商务价","Total Retail 零售散客合计","Traditional Wholesale 传统旅游批发商","Online Wholesale 在线旅游批发商","Total Wholesale 旅游批发商合计","TMC 商旅管理公司价","Local Negotiate 本地协议价","National Key Account 全国性协议价","Total Corporate 公司散客合计","Government/Diplomat 政府价","Qualified Discount 特殊折扣价","Award&Redemption 积分奖励和兑换","Total Discount&Award 折扣与奖励合计","Total Transient 散客合计","MICE Group 会议团","Government Group 政府团","Total Business Group 商务团队合计","Group Tour Series 系列旅游团","Group Ad Hoc 一次性旅游团","Group Others 其他团队","Total Tour Group 旅游团队合计","Total Group 团队合计","Long Stay 长住","Air Crew 机组","Flight Layover 误机客","Total Contracts 合同价合计","Barter ","House Use 自用房","Comp Room 免费房","Other Revenue 其他收入","Service Charge 服务费","Total Others 其它合计","总计 （不含免房）","Net Available Rooms 实际可卖房量","Unsold Rooms 未售出房量","出租率/平均房价/每房收益"].map(function(name,i){return{name:name,key:name,sort:i,actual_rn:0,actual_adr:0,actual_rev:0,last_rn:0,last_adr:0,last_rev:0,forecast_rn:0,forecast_adr:0,forecast_rev:0,budget_rn:0,budget_adr:0,budget_rev:0,vslast_rn:0,vslast_adr:0,vslast_rev:0,vsforecast_rn:0,vsforecast_adr:0,vsforecast_rev:0,vsbudget_rn:0,vsbudget_adr:0,vsbudget_rev:0,mixrn_rn:0,mixrn_adr:0,mixrn_rev:0,mixrev_rn:0,mixrev_adr:0,mixrev_rev:0};});

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columns=exports.compute=undefined;var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _method=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var totalIndex=[3,6,10,14,15,18,22,23,27,33,34,37];var percentIndex=[37];var nameList=['actual','last','forecast','budget','vslast','vsforecast','vsbudget'];var monthList=["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec",'full'];var nameKeyLst=[{name:"TY Actual",key:"actual"},{name:"LY Actual",key:"last"},{name:"Forecast",key:"forecast"},{name:"Budget",key:"budget"},{name:"Actual TY vs. LY",key:"vslast"},{name:"Actual vs. Forecast",key:"vsforecast"},{name:"Actual vs. Budget",key:"vsbudget"},{name:"MIX% (RNTS)",key:"mixrn"},{name:"MIX% (REV)",key:"mixrev"}];var sumIndex={3:[0,1,2],6:[4,5],10:[7,8,9],14:[12,13],15:[3,6,10,11,14],18:[16,17],22:[19,20,21],23:[18,22],27:[24,25,26],33:[28,29,30,31,32],34:[15,23,27,28]};var compute=exports.compute=function compute(data,_ref){var budget=_ref.budget,actual=_ref.actual,forecast=_ref.forecast,month=_ref.month,year=_ref.year,last=_ref.last;if(year<=2024){var index=(month-1)*3+1;var correspond={0:"best",1:"packges",2:"commerce",5:"wholesale",8:"corporate",11:"government",12:"discounts",15:"total",16:"business",19:"leisure",23:"group_total",24:"contracts",31:"others",34:"grand"};Object.entries(correspond).forEach(function(item){data[item[0]].last_rn=_lodash2.default.get(last,index+"."+item[1]+"_rn",0);data[item[0]].last_rev=_lodash2.default.get(last,index+"."+item[1]+"_rev",0);});data[35].last_rn=_lodash2.default.get(last,index+".grand_rms",0);data[36].last_rn=~~(data[35].last_rn-data[34].last_rn);var rn="last_rn";var rev="last_rev";Object.entries(sumIndex).forEach(function(index){data[index[0]][rn]=index[1].reduce(function(a,b){return a+=(0,_method.numConvert)(data[b][rn]);},0).toFixed(2);data[index[0]][rev]=[].concat(_toConsumableArray(index[1]),_toConsumableArray(index[0]==34?[31,32]:[])).reduce(function(a,b){return a+=(0,_method.numConvert)(data[b][rev]);},0).toFixed(2);});}data.forEach(function(item,i){data[i].actual_rn=_lodash2.default.get(actual,i+"."+monthList[~~(month-1)]+"_rn",0);data[i].actual_rev=_lodash2.default.get(actual,i+"."+monthList[~~(month-1)]+"_rev",0);if(month>1){data[i].forecast_rn=_lodash2.default.get(forecast,i+"."+monthList[~~(month-1)]+"_rn",0);data[i].forecast_rev=_lodash2.default.get(forecast,i+"."+monthList[~~(month-1)]+"_rev",0);}data[i].budget_rn=_lodash2.default.get(budget,i+"."+monthList[~~(month-1)]+"_rn",0);data[i].budget_rev=_lodash2.default.get(budget,i+"."+monthList[~~(month-1)]+"_rev",0);if(year>2024){data[i].last_rn=_lodash2.default.get(last,i+"."+monthList[~~(month-1)]+"_rn",0);data[i].last_rev=_lodash2.default.get(last,i+"."+monthList[~~(month-1)]+"_rev",0);}});if(month==1){['forecast_rn','forecast_adr','forecast_rev'].forEach(function(name){Object.entries(sumIndex).forEach(function(index){data[index[0]][name]=[].concat(_toConsumableArray(index[1]),_toConsumableArray(name=='forecast_rev'&&index[0]==34?[31,32]:[])).reduce(function(a,b){return a+=(0,_method.numConvert)(data[b][name]);},0).toFixed(2);});});}nameList.forEach(function(name){if(!name.includes('vs')){data.forEach(function(item,i){data[i][name+"_adr"]=(0,_method.calculation)(item[name+"_rev"],item[name+"_rn"]);});data[37][name+"_adr"]=(0,_method.calculation)(data[34][name+"_rev"],data[34][name+"_rn"]);data[37][name+"_rn"]=(0,_method.calculation)(data[34][name+"_rn"],data[35][name+"_rn"],4);data[37][name+"_rev"]=(data[37][name+"_adr"]*data[37][name+"_rn"]).toFixed(2);}});data.forEach(function(item,i){data[i].vslast_rn=(item.actual_rn-item.last_rn).toFixed(2);data[i].vslast_adr=(item.actual_adr-item.last_adr).toFixed(2);data[i].vslast_rev=(item.actual_rev-item.last_rev).toFixed(2);data[i].vsforecast_rn=(item.actual_rn-item.forecast_rn).toFixed(2);data[i].vsforecast_rev=(item.actual_rev-item.forecast_rev).toFixed(2);data[i].vsforecast_adr=(item.actual_adr-item.forecast_adr).toFixed(2);data[i].vsbudget_rn=(item.actual_rn-item.budget_rn).toFixed(2);data[i].vsbudget_rev=(item.actual_rev-item.budget_rev).toFixed(2);data[i].vsbudget_adr=(item.actual_adr-item.budget_adr).toFixed(2);});data.forEach(function(item,i){if(i<35){data[i]["mixrn_rn"]=(0,_method.calculation)(data[i]["actual_rn"],(0,_method.sum)([data[34]["actual_rn"],data[30]["actual_rn"],data[29]["actual_rn"]]),4);data[i]["mixrn_adr"]=(0,_method.calculation)(data[i]["last_rn"],(0,_method.sum)([data[34]["last_rn"],data[30]["last_rn"],data[29]["last_rn"]]),4);data[i]["mixrn_rev"]=(0,_method.calculation)(data[i]["budget_rn"],(0,_method.sum)([data[34]["budget_rn"],data[30]["budget_rn"],data[29]["budget_rn"]]),4);data[i]["mixrev_rn"]=(0,_method.calculation)(data[i]["actual_rev"],(0,_method.sum)([data[34]["actual_rev"],data[30]["actual_rev"],data[29]["actual_rev"]]),4);data[i]["mixrev_adr"]=(0,_method.calculation)(data[i]["last_rev"],(0,_method.sum)([data[34]["last_rev"],data[30]["last_rev"],data[29]["last_rev"]]),4);data[i]["mixrev_rev"]=(0,_method.calculation)(data[i]["budget_rev"],(0,_method.sum)([data[34]["budget_rev"],data[30]["budget_rev"],data[29]["budget_rev"]]),4);}});data[36]["forecast_rn"]=~~(data[35]["forecast_rn"]-data[34]["forecast_rn"]);return data;};var columns=exports.columns=function columns(onChange,date,print){var year=(0,_moment2.default)(date).format('YYYY');var month=(0,_moment2.default)(date).format('M');var sqlName='_4_2_1_new';var key=[];if(false)key=[{title:"Index",dataIndex:'index',key:'index',align:"center",fixed:print?false:"left",width:50,render:function render(text,record,index){var props={text:""+index,index:index,type:'text',name:"index",onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}];return[].concat(_toConsumableArray(key),[{title:year,dataIndex:'name',key:'name',align:"center",fixed:print?false:"left",width:300,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:onChange,totalIndex:totalIndex,compared:{title:['name'],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}}],_toConsumableArray(nameKeyLst.map(function(x,i){return{title:"FULL MONTH",align:"center",width:450,children:[{title:x.name,align:"center",width:450,children:[{title:x.key.includes('mix')?"TYA":"RNs",dataIndex:x.key+"_rn",key:x.key+"_rn",width:150,align:"center",render:function render(text,record,index){var title=["FULL MONTH",x.name,x.key.includes('mix')?"TYA":"RNs"];var props={text:text,index:index,type:[31,32].includes(index)?'':month==1&&x.key=='forecast'&&![].concat(totalIndex,[36]).includes(index)&&!print?'inputNumber':percentIndex.includes(index)||x.key.includes('mix')?'percent':"number",name:x.key+"_rn",onChange:onChange,totalIndex:totalIndex};props.compared={title:title,record:record,sqlName:sqlName};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:x.key.includes('mix')?"LYA":"ADR",dataIndex:x.key+"_adr",key:x.key+"_adr",width:150,align:"center",render:function render(text,record,index){var title=["FULL MONTH",x.name,x.key.includes('mix')?"LYA":"ADR"];var props={text:text,index:index,type:[29,30,31,32,35].includes(index)?'':x.key.includes('mix')?'percent':"number",name:x.key+"_adr",onChange:onChange,totalIndex:totalIndex};props.compared={title:title,record:record,sqlName:sqlName};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:x.key.includes('mix')?"BDGT":"REVENUE",dataIndex:x.key+"_rev",key:x.key+"_rev",width:150,align:"center",render:function render(text,record,index){var title=["FULL MONTH",x.name,x.key.includes('mix')?"BDGT":'REVENUE'];var props={text:text,index:index,type:[29,30,35].includes(index)?'':month==1&&x.key=='forecast'&&![].concat(totalIndex,[36]).includes(index)&&!print?'inputNumber':x.key.includes('mix')?'percent':"number",name:x.key+"_rev",onChange:onChange,totalIndex:totalIndex};props.compared={title:title,record:record,sqlName:sqlName};return _react2.default.createElement(_TableText2.default,{data:props});}}]}]};})));};

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(1903);var _data2=_interopRequireDefault(_data);var _compute=__webpack_require__(1904);var _axios=__webpack_require__(86);var _axios2=_interopRequireDefault(_axios);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().isBefore((0,_moment2.default)('2023-12-31'))?'2024-01':(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,data4_1:[],key:"_4_2_1_new_diff"},_this.computeNum=function(data,elseData){data=(0,_compute.compute)(data,elseData);_this.setState({data:data,loading:false});},_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.setState({data:data});},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var data,month,year,res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_this.setState({loading:true});data=JSON.parse(JSON.stringify(_data2.default));month=(0,_moment2.default)(date).format('M');year=(0,_moment2.default)(date).format('YYYY');_context.next=7;return _axios2.default.post('/api/data',{list:[{name:"data",key:_this.state.key,year:year,month:month},{name:"data4_2_1",key:"_4_2_1_new",year:year,month:month}]});case 7:res=_context.sent;if(res.data.data&&res.data.data.length)data=res.data.data;_this.computeNum(data,_extends({},res.data,{month:month,year:year}));_context.next=16;break;case 12:_context.prev=12;_context.t0=_context["catch"](0);_this.setState({loading:false});console.error(_context.t0);case 16:case"end":return _context.stop();}}},_callee,_this2,[[0,12]]);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var _this$state,date,key,year,month,data,postData,x;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_this$state=_this.state,date=_this$state.date,key=_this$state.key;if(date){_context2.next=4;break;}return _context2.abrupt("return",_message3.default.error('请选择年份月份'));case 4:_this.setState({loadingSave:true});year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");data=_this.state.data.map(function(x,i){var res=_extends({},x,{year:year,sort:i,month:month});return res;});postData={data:data,year:year,key:key,month:month};_context2.next=11;return _axios2.default.post("/api/save",postData);case 11:x=_context2.sent;_this.setState({loadingSave:false});if(x.code==200){_message3.default.success("保存成功！");if(!data[0].id)_this.getData(_this.state.date);}_context2.next=20;break;case 16:_context2.prev=16;_context2.t0=_context2["catch"](0);_this.setState({loadingSave:false});console.error(_context2.t0);case 20:case"end":return _context2.stop();}}},_callee2,_this2,[[0,16]]);})),_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('view4_1_4',1.5,'4.21',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});},_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+" "+(0,_moment2.default)(_this.state.date).format('YYYY')+" 4.2.1 Monthly Market Segment Report \u6708\u5EA6\u5E02\u573A\u7EC6\u5206\u8868";var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById('table4_1_4').innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+".xls");_this.setState({print:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.props.id!=nextProps.id)this.getData(this.state.date);}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print,loading=_state.loading,key=_state.key;return _react2.default.createElement("div",{className:"table7_1_1 tableHeight"},_react2.default.createElement(_row2.default,{className:"title",id:"view4_1_4",style:{width:print?6150:'auto'}},_react2.default.createElement(_row2.default,null,"4.2.1 Monthly Market Segment Report \u6708\u5EA6\u5E02\u573A\u7EC6\u5206\u8868"),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},disabledDate:function disabledDate(v){if((0,_moment2.default)(v).isAfter((0,_moment2.default)('2023-12-31')))return false;return true;},value:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:"YYYY-MM",onChange:function onChange(date,str){_this3.setState({date:str,data:[]});_this3.getData(str);}})),_react2.default.createElement(_table2.default,{columns:(0,_compute.columns)(this.onChange,date,print),dataSource:data,size:"middle",id:"table4_1_4",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{x:true},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:"table-footer-btn"},_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:print},"\u5BFC\u51FAExcel"),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:"edit_4_2_1_new"},_react2.default.createElement(_button2.default,{type:"primary",style:{margin:'0 10px'},onClick:this.downloadSG,loading:print},"\u52A0\u5165pdf"),_react2.default.createElement(_button2.default,{type:"primary",onClick:this.onSave,loading:this.state.loadingSave},"\u4FDD\u5B58"))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=["1. \u96F6\u552E\u6563\u5BA2<br/>Retail (BAR+PKG+E-commerce)","2. 旅游批发商<br/>Wholesale (traditional+online WHL)","3. 公司协议价<br/>Corporate Negotiate (local+national)","4. 政府价<br/>Government","5. 折扣和奖励<br/>Discount & Award","6. 商务团队<br/>Business Group (MICE+Government)","7. 休闲团队<br/>Leisure Group (Series+One-time)","8. 合同<br/>Contracts (long-stay+crew+layover)"].map(function(name,i){return{name:name,key:name,sort:i,rn_forecast:0,rn_budget:0,rn_actual:0,avg_forecast:0,avg_budget:0,avg_actual:0,rev_forecast:0,rev_budget:0,rev_actual:0,vsforecast:0,vsbudget:0,note:''};});

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columns=exports.compute=undefined;var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _method=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var totalIndex=[];var compute=exports.compute=function compute(data){var _ref=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},data4_2_1=_ref.data4_2_1;var corresponding={0:3,1:6,2:10,3:11,4:14,5:18,6:22,7:27};Object.entries(corresponding).forEach(function(item){data[item[0]].rn_forecast=_lodash2.default.get(data4_2_1,item[1]+".forecast_rn",0);data[item[0]].rn_budget=_lodash2.default.get(data4_2_1,item[1]+".budget_rn",0);data[item[0]].rn_actual=_lodash2.default.get(data4_2_1,item[1]+".actual_rn",0);data[item[0]].avg_forecast=_lodash2.default.get(data4_2_1,item[1]+".forecast_adr",0);data[item[0]].avg_budget=_lodash2.default.get(data4_2_1,item[1]+".budget_adr",0);data[item[0]].avg_actual=_lodash2.default.get(data4_2_1,item[1]+".actual_adr",0);data[item[0]].rev_forecast=_lodash2.default.get(data4_2_1,item[1]+".forecast_rev",0);data[item[0]].rev_budget=_lodash2.default.get(data4_2_1,item[1]+".budget_rev",0);data[item[0]].rev_actual=_lodash2.default.get(data4_2_1,item[1]+".actual_rev",0);});data.forEach(function(item,i){data[i].vsforecast=(item.rev_actual-item.rev_forecast).toFixed(2);data[i].vsbudget=(item.rev_actual-item.rev_budget).toFixed(2);});return data;};var columns=exports.columns=function columns(onChange,date,print){var month=(0,_moment2.default)(date).format('M');var sqlName='_4_2_1_new_diff';return[{title:"No. 序号",align:"center",fixed:print?false:"left",width:300,children:[{title:_react2.default.createElement("div",null,"\u4E3B\u8981\u5E02\u573A\u7EC6\u5206 Key Market Segments"),dataIndex:'name',key:'name',align:"center",fixed:print?false:"left",width:300,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:onChange,totalIndex:totalIndex,compared:{title:['No. 序号',"\u4E3B\u8981\u5E02\u573A\u7EC6\u5206<br />Key Market Segments"],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"Room Nights \u95F4\u591C\u6570",children:[{title:month+"\u6708(\u9884\u6D4B)",dataIndex:'rn_forecast',key:'rn_forecast',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"rn_forecast",onChange:onChange,totalIndex:totalIndex,compared:{title:['Room Nights 间夜数',"\u9884\u6D4B"],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:month+"\u6708(\u9884\u7B97)",dataIndex:'rn_budget',key:'rn_budget',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"rn_budget",onChange:onChange,totalIndex:totalIndex,compared:{title:['Room Nights 间夜数',"\u9884\u7B97"],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:month+"\u6708(\u5B9E\u9645)",dataIndex:'rn_actual',key:'rn_actual',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"rn_actual",onChange:onChange,totalIndex:totalIndex,compared:{title:['Room Nights 间夜数',"\u5B9E\u9645"],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"Average Rate \u5E73\u5747\u623F\u4EF7",children:[{title:month+"\u6708(\u9884\u6D4B)",dataIndex:'avg_forecast',key:'avg_forecast',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"avg_forecast",onChange:onChange,totalIndex:totalIndex,compared:{title:['Average Rate 平均房价',"\u9884\u6D4B"],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:month+"\u6708(\u9884\u7B97)",dataIndex:'avg_budget',key:'avg_budget',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"avg_budget",onChange:onChange,totalIndex:totalIndex,compared:{title:['Average Rate 平均房价',"\u9884\u7B97"],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:month+"\u6708(\u5B9E\u9645)",dataIndex:'avg_actual',key:'avg_actual',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"avg_actual",onChange:onChange,totalIndex:totalIndex,compared:{title:['Average Rate 平均房价',"\u5B9E\u9645"],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"Room Revenue \u5BA2\u623F\u6536\u5165",children:[{title:month+"\u6708(\u9884\u6D4B)",dataIndex:'rev_forecast',key:'rev_forecast',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"rev_forecast",onChange:onChange,totalIndex:totalIndex,compared:{title:['Room Revenue 客房收入',"\u9884\u6D4B"],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:month+"\u6708(\u9884\u7B97)",dataIndex:'rev_budget',key:'rev_budget',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"rev_budget",onChange:onChange,totalIndex:totalIndex,compared:{title:['Room Revenue 客房收入',"\u9884\u7B97"],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:month+"\u6708(\u5B9E\u9645)",dataIndex:'rev_actual',key:'rev_actual',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"rev_actual",onChange:onChange,totalIndex:totalIndex,compared:{title:['Room Revenue 客房收入',"\u5B9E\u9645"],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"REV Variance \u6574\u4F53\u6536\u5165\u5DEE\u5F02",children:[{title:"\u5BF9\u6BD4\u9884\u6D4B",dataIndex:'vsforecast',key:'vsforecast',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"vsforecast",onChange:onChange,totalIndex:totalIndex,compared:{title:['REV Variance 整体收入差异',"\u5BF9\u6BD4\u9884\u6D4B"],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5BF9\u6BD4\u9884\u7B97",dataIndex:'vsbudget',key:'vsbudget',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"vsbudget",onChange:onChange,totalIndex:totalIndex,compared:{title:['REV Variance 整体收入差异',"\u5BF9\u6BD4\u9884\u7B97"],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"Variance Explanation",align:"center",children:[{title:_react2.default.createElement("div",null,"\u843D\u540E\u6216\u8D85\u51FA\u76EE\u6807\u7684\u4E3B\u8981\u539F\u56E0"),dataIndex:'note',key:'note',align:"center",width:300,render:function render(text,record,index){var props={text:text,index:index,type:'textArea',name:"note",onChange:onChange,totalIndex:totalIndex,minRows:2,compared:{title:['Variance Explanation',"\u843D\u540E\u6216\u8D85\u51FA\u76EE\u6807\u7684\u4E3B\u8981\u539F\u56E0"],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}}]}];};

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(1906);var _data2=_interopRequireDefault(_data);var _compute=__webpack_require__(1907);var _axios=__webpack_require__(86);var _axios2=_interopRequireDefault(_axios);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().format('YYYY-MM'),table1:[],table2:[],table3:[],loading:true,loadingSave:false,print:false,data4_1:[],key:"_4_2_2_new"},_this.computeNum=function(data,key){var _this$setState;data=(0,_compute.compute)(data);_this.setState((_this$setState={},_defineProperty(_this$setState,key,data),_defineProperty(_this$setState,"loading",false),_this$setState));},_this.onChange=function(name,value,i){var key=arguments.length>3&&arguments[3]!==undefined?arguments[3]:"talbe1";var data=_this.state[key];data[i][name]=value;_this.computeNum(data,key);},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var table1,table2,table3,month,year,nextYear,needData,res,fill;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_this.setState({loading:true,table1:[],table2:[],table3:[]});table1=JSON.parse(JSON.stringify(_data2.default));table2=JSON.parse(JSON.stringify(_data2.default));table3=JSON.parse(JSON.stringify(_data2.default));month=(0,_moment2.default)(date).format('M');year=(0,_moment2.default)(date).format('YYYY');nextYear=(0,_moment2.default)(date).add(3,'month').format('YYYY');needData=[{name:"budget",key:"_4new_4_3_1_budget",year:year}];if(month<10){needData.push({name:"fone",key:"_4new_4_3_1_forecast",year:(0,_moment2.default)(date).format('YYYY'),month:(0,_moment2.default)(date).format('M')},{name:"ftwo",key:"_4new_4_3_1_forecast",year:(0,_moment2.default)(date).format('YYYY'),month:(0,_moment2.default)(date).format('M')},{name:"fthree",key:"_4new_4_3_1_forecast",year:(0,_moment2.default)(date).format('YYYY'),month:(0,_moment2.default)(date).format('M')});}if(month==10){needData.push({name:"fone",key:"_4new_4_3_1_forecast",year:year,month:10},{name:"ftwo",key:"_4new_4_3_1_forecast",year:year,month:10},{name:"fthree",key:"_4_2_1_new",year:nextYear,month:1});}if(month==11){needData.push({name:"fone",key:"_4new_4_3_1_forecast",year:year,month:11},{name:"ftwo",key:"_4_2_1_new",year:nextYear,month:1},{name:"fthree",key:"_4new_4_3_1_forecast",year:nextYear,month:1});}if(month==12){needData.push({name:"fone",key:"_4_2_1_new",year:nextYear,month:1},{name:"ftwo",key:"_4new_4_3_1_forecast",year:nextYear,month:1},{name:"fthree",key:"_4new_4_3_1_forecast",year:nextYear,month:1});}if(month>=10){needData.push({name:"budgetNext",key:"_4new_4_3_1_budget",year:nextYear});}_context.next=16;return _axios2.default.post('/api/data',{list:[{name:"table1",key:_this.state.key,year:year,month:month},{name:"table2",key:"_4_2_2_new_2",year:year,month:month},{name:"table3",key:"_4_2_2_new_3",year:year,month:month}].concat(needData)});case 16:res=_context.sent;if(res.data.table1&&res.data.table1.length)table1=res.data.table1;if(res.data.table2&&res.data.table2.length)table2=res.data.table2;if(res.data.table3&&res.data.table3.length)table3=res.data.table3;fill=(0,_compute.fillData)({table1:table1,table2:table2,table3:table3},_extends({},res.data,{date:date,year:year,month:month}));console.log(fill);_this.setState({table1:fill.table1,table2:fill.table2,table3:fill.table3,loading:false});_context.next=29;break;case 25:_context.prev=25;_context.t0=_context["catch"](0);_this.setState({loading:false});console.error(_context.t0);case 29:case"end":return _context.stop();}}},_callee,_this2,[[0,25]]);}));return function(_x2){return _ref2.apply(this,arguments);};}(),_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var _this$state,date,key,table1,table2,table3,year,month,data,postData,x;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_this$state=_this.state,date=_this$state.date,key=_this$state.key,table1=_this$state.table1,table2=_this$state.table2,table3=_this$state.table3;if(date){_context2.next=4;break;}return _context2.abrupt("return",_message3.default.error('请选择年份月份'));case 4:_this.setState({loadingSave:true});year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");data=table1.map(function(x,i){var res=_extends({},x,{year:year,sort:i,month:month});return res;});postData={data:data,year:year,key:key,month:month};_context2.next=11;return Promise.all([_axios2.default.post("/api/save",postData),_axios2.default.post("/api/save",{data:table2.map(function(x,i){var res=_extends({},x,{year:year,sort:i,month:month});return res;}),year:year,key:"_4_2_2_new_2",month:month}),_axios2.default.post("/api/save",{data:table3.map(function(x,i){var res=_extends({},x,{year:year,sort:i,month:month});return res;}),year:year,key:'_4_2_2_new_3',month:month})]);case 11:x=_context2.sent;_this.setState({loadingSave:false});if(x[0].code==200){_message3.default.success("保存成功！");if(!data[0].id)_this.getData(_this.state.date);}_context2.next=20;break;case 16:_context2.prev=16;_context2.t0=_context2["catch"](0);_this.setState({loadingSave:false});console.error(_context2.t0);case 20:case"end":return _context2.stop();}}},_callee2,_this2,[[0,16]]);})),_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('view4_1_4',1.5,'4.22',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});},_this.downloadExcel=function(id){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+" "+(0,_moment2.default)(_this.state.date).format('YYYY')+" 4.2.2 \u672A\u67653\u4E2A\u6708\u9500\u552E\u7B56\u7565\u548C\u884C\u52A8\u8BA1\u5212";var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById(id).innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+".xls");_this.setState({print:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);}},{key:"render",value:function render(){var _this3=this;var _state=this.state,table1=_state.table1,table2=_state.table2,table3=_state.table3,date=_state.date,print=_state.print,loading=_state.loading,key=_state.key;return _react2.default.createElement("div",{className:"table7_1_1 tableHeight"},_react2.default.createElement(_row2.default,{className:"title",id:"view4_1_4"},_react2.default.createElement(_row2.default,null,"4.2.2 \u672A\u67653\u4E2A\u6708\u9500\u552E\u7B56\u7565\u548C\u884C\u52A8\u8BA1\u5212"),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},value:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:"YYYY-MM",onChange:function onChange(date,str){_this3.setState({date:str,data:[]});_this3.getData(str);}})),_react2.default.createElement(_table2.default,{columns:(0,_compute.columns)(function(name,value,i){return _this3.onChange(name,value,i,'table1');},date,print,'table1'),dataSource:table1,size:"middle",id:"table1",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{y:500},rowKey:function rowKey(record,index){return index;}}),!print&&_react2.default.createElement(_button2.default,{type:"primary",style:{marginTop:20,marginLeft:"calc(100% - 200px)"},onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel('table1');});},loading:print},"\u5BFC\u51FAExcel"),_react2.default.createElement(_table2.default,{columns:(0,_compute.columns)(function(name,value,i){return _this3.onChange(name,value,i,'table2');},date,print,'table2'),dataSource:table2,size:"middle",id:"table2",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{y:500},rowKey:function rowKey(record,index){return index;}}),!print&&_react2.default.createElement(_button2.default,{type:"primary",style:{marginTop:20,marginLeft:"calc(100% - 200px)"},onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel('table2');});},loading:print},"\u5BFC\u51FAExcel"),_react2.default.createElement(_table2.default,{columns:(0,_compute.columns)(function(name,value,i){return _this3.onChange(name,value,i,'table3');},date,print,'table3'),dataSource:table3,size:"middle",id:"table3",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{y:500},rowKey:function rowKey(record,index){return index;}}),!print&&_react2.default.createElement(_button2.default,{type:"primary",style:{marginTop:20,marginLeft:"calc(100% - 200px)"},onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel('table3');});},loading:print},"\u5BFC\u51FAExcel")),_react2.default.createElement(_row2.default,{className:"table-footer-btn",style:{marginTop:10}},_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:"edit_4_2_2_new"},_react2.default.createElement(_button2.default,{type:"primary",style:{margin:'0 10px'},onClick:this.downloadSG,loading:print},"\u52A0\u5165pdf"),_react2.default.createElement(_button2.default,{type:"primary",onClick:this.onSave,loading:this.state.loadingSave},"\u4FDD\u5B58"))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=["\u6700\u4F18\u4EF7<br/>Best Available Rate","包价和促销<br/>Package & Promotion","电子商务<br/>E-Commerce","旅游批发商<br/>Wholesale (traditional+online WHL)","公司协议价<br/>Corporate Negotiate (local+national)","政府价<br/>Government","折扣和奖励<br/>Discount & Award","商务团队<br/>Business Group (MICE+Gov)","\u4F11\u95F2\u56E2\u961F<br/>Leisure Group (Series+One-time)","\u5408\u540C<br/>Contracts (long-stay+crew+layover)","Total"].map(function(name,i){return{name:name,key:name,sort:i,otb:0,trend:0,forecast:0,budget:0,plans:'',strategy:""};});

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columns=exports.compute=exports.fillData=undefined;var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _method=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var totalIndex=[10];var monthList=["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];var fillData=exports.fillData=function fillData(_ref,_ref2){var table1=_ref.table1,table2=_ref.table2,table3=_ref.table3;var year=_ref2.year,date=_ref2.date,budget=_ref2.budget,budgetNext=_ref2.budgetNext,ftwo=_ref2.ftwo,fthree=_ref2.fthree,fone=_ref2.fone,month=_ref2.month;// const correspond = [0, 1, 2, 5, 8, 11, 12, 16, 19, 24];
var correspond=[0,1,2,6,10,11,14,18,22,27];// 下月预测、预算填充 
Object.entries(correspond).forEach(function(item){var forecastName=month<12?monthList[month]:'forecast';var budgetData=month<12?budget:budgetNext;table1[item[0]].forecast=_lodash2.default.get(fone,item[1]+"."+forecastName+"_rn",0);table1[item[0]].budget=_lodash2.default.get(budgetData,item[1]+"."+monthList[~~((0,_moment2.default)(date).add(1,'month').format('M')-1)]+"_rn",0);var forecast2Name=month==12?'feb':month<11?monthList[~~(~~month+1)]:'forecast';var budget2Data=month<11?budget:budgetNext;table2[item[0]].forecast=_lodash2.default.get(ftwo,item[1]+"."+forecast2Name+"_rn",0);table2[item[0]].budget=_lodash2.default.get(budget2Data,item[1]+"."+monthList[~~((0,_moment2.default)(date).add(2,'month').format('M')-1)]+"_rn",0);var forecast3Name=month<10?monthList[~~(~~month+2)]:month==10?'forecast':month==11?'feb':'mar';var budget3Data=month<10?budget:budgetNext;table3[item[0]].forecast=_lodash2.default.get(fthree,item[1]+"."+forecast3Name+"_rn",0);table3[item[0]].budget=_lodash2.default.get(budget3Data,item[1]+"."+monthList[~~((0,_moment2.default)(date).add(3,'month').format('M')-1)]+"_rn",0);});return{table1:compute(table1),table2:compute(table2),table3:compute(table3)};};var compute=exports.compute=function compute(data){['otb','trend','forecast','budget'].forEach(function(name){data[10][name]=data.reduce(function(a,b,i){if(i<10)a+=(0,_method.numConvert)(b[name]);return a;},0).toFixed(2);});return _lodash2.default.cloneDeep(data);};var columns=exports.columns=function columns(onChange,date,print,table){var month=(0,_moment2.default)(date).add(1,'month').format('M');var sqlName='_4_2_2_new';if(table=='table2'){sqlName='_4_2_2_new_2';month=(0,_moment2.default)(date).add(2,'month').format('M');}if(table=='table3'){sqlName='_4_2_2_new_3';month=(0,_moment2.default)(date).add(3,'month').format('M');}return[{title:_react2.default.createElement("div",null,"No.",_react2.default.createElement("br",null),"\u5E8F\u53F7"),dataIndex:'sort',key:'sort',align:"center",width:60,render:function render(text,record,index){var props={text:totalIndex.includes(index)?'':~~(index+1),index:index,type:'text',name:"sort",onChange:onChange,totalIndex:totalIndex,compared:{title:['No. 序号'],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:_react2.default.createElement("div",null,"Market Segment",_react2.default.createElement("br",null),"\u7EC6\u5206\u5E02\u573A"),dataIndex:'name',key:'name',align:"center",width:250,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:onChange,totalIndex:totalIndex,compared:{title:['Market Segment<br />细分市场'],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:_react2.default.createElement("div",null,"On-hand bookings",_react2.default.createElement("br",null),"\u5728\u624B\u9884\u8BA2\u95F4\u591C"),align:"center",children:[{title:month+"\u6708 OTB",dataIndex:'otb',key:'otb',align:"center",width:120,render:function render(text,record,index){var props={text:text,index:index,type:totalIndex.includes(index)?'number':'inputNumber',name:"otb",onChange:onChange,totalIndex:totalIndex,compared:{title:['On-hand bookings<br />在手预订间夜',month+"\u6708 OTB"],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:_react2.default.createElement("div",null,"Rnts Pickup from last Mth",_react2.default.createElement("br",null),"30\u5929\u95F4\u591C+/-"),align:"center",children:[{title:"\u9884\u8BA2\u8D8B\u52BF",dataIndex:'trend',key:'trend',align:"center",width:120,render:function render(text,record,index){var props={text:text,index:index,type:totalIndex.includes(index)?'number':'inputNumber',name:"trend",onChange:onChange,totalIndex:totalIndex,compared:{title:['Rnts Pickup from last Mth<br />30天间夜+/-',"\u9884\u8BA2\u8D8B\u52BF"],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"Target Room Nts \u76EE\u6807\u95F4\u591C",children:[{title:month+"\u6708\u9884\u6D4B",dataIndex:'forecast',key:'forecast',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"forecast",onChange:onChange,totalIndex:totalIndex,compared:{title:['Target Room Nts 目标间夜',"\u9884\u6D4B"],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:month+"\u6708\u9884\u7B97",dataIndex:'budget',key:'budget',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"budget",onChange:onChange,totalIndex:totalIndex,compared:{title:['Target Room Nts 目标间夜',"\u9884\u7B97"],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:_react2.default.createElement("div",null,"Key Strategy",_react2.default.createElement("br",null),"\u4E3B\u8981\u7B56\u7565"),dataIndex:'strategy',key:'strategy',align:"center",width:300,render:function render(text,record,index){var props={text:text,index:index,type:totalIndex.includes(index)?'text':'textArea',name:"strategy",onChange:onChange,totalIndex:totalIndex,minRows:2,compared:{title:["Key Strategy<br />\u4E3B\u8981\u7B56\u7565"],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:_react2.default.createElement("div",null,"Action Plans",_react2.default.createElement("br",null),"\u884C\u52A8\u8BA1\u5212"),dataIndex:'plans',key:'plans',align:"center",width:300,render:function render(text,record,index){var props={text:text,index:index,type:totalIndex.includes(index)?'text':'textArea',name:"plans",onChange:onChange,totalIndex:totalIndex,minRows:2,compared:{title:["Action Plans<br />\u884C\u52A8\u8BA1\u5212"],record:record,sqlName:sqlName}};return _react2.default.createElement(_TableText2.default,{data:props});}}];};

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _alert=__webpack_require__(83);var _alert2=_interopRequireDefault(_alert);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(84);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _data=__webpack_require__(1909);var _data2=_interopRequireDefault(_data);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _IsLableAuth=__webpack_require__(107);var _IsLableAuth2=_interopRequireDefault(_IsLableAuth);var _ExportExcel=__webpack_require__(79);var _ExportExcel2=_interopRequireDefault(_ExportExcel);var _compute=__webpack_require__(1910);var _compute2=_interopRequireDefault(_compute);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){data=(0,_compute2.default)(data,_this.state.last);_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);_this.setState({isEdit:true});};_this.getDateData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var dataBegin,data,res,x;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;dataBegin=JSON.stringify(_data2.default);data=JSON.parse(dataBegin);_context.next=5;return fetch('/t5Lst?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'});case 5:res=_context.sent;_context.next=8;return res.json();case 8:x=_context.sent;if(x.data.data&&x.data.data.length>0){data=x.data.data.sort(function(a,b){return a.sort-b.sort;});}data=(0,_compute.fillData)(data,x.data,date);_this.setState({loading:false,last:x.data.last});_this.computeNum(data,x.data);_context.next=19;break;case 15:_context.prev=15;_context.t0=_context['catch'](0);_this.setState({loading:false});console.error(_context.t0);case 19:case'end':return _context.stop();}}},_callee,_this2,[[0,15]]);}));return function(_x){return _ref.apply(this,arguments);};}();_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/t5Save  ',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false,isEdit:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table5_1_1',1.5,'5.00',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,isEdit:false,last:[]};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print;return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',style:{width:this.state.print?3800:'auto'}},_react2.default.createElement(_row2.default,null,'5.0 F&B Summary \u9910\u996E\u5173\u952E\u7EE9\u6548\u6307\u6570'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:(0,_compute.columns)({print:print,onChange:this.onChange}),dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',id:'table5_1_1',style:{width:this.state.print?3800:'auto'},scroll:this.state.print?{}:{x:3800,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_alert2.default,{message:_react2.default.createElement('div',null,'\u8868\u683C\u5173\u8054',_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:'read_1'},this.props,{path:'/table/1'}),'1.1'),' -',_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:'read_7_1'},this.props,{path:'/table/7_1'}),'7.1'),' -',_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:'read_7_7'},this.props,{path:'/table/7_7'}),'7.7'),' -',_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:'read_7_8'},this.props,{path:'/table/7_8'}),'7.8')),type:'info',showIcon:true,style:{display:"inline-block",marginRight:10}}),_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this3.setState({print:true,loading:true},function(){(0,_ExportExcel2.default)({id:"table5_1_1",date:date,name:"5.0 F&B Summary 餐饮关键绩效指数"});_this3.setState({print:false,loading:false});});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_5_0'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=[{"name":"F&B Revenue 餐饮收入","sort":0,"actual":0,"forecast":0,"budget":0,"last":0,"actVsFcst":0,"actVsBgt":0,"actVsLy":0,"ytdActual":0,"ytdBudget":0,"ytdLast":0,"ytdActVsBgt":0,"ytdActVsLy":0,"threeActual":0,"threeBudget":0,"threeLast":0,"threeActVsLy":0,"threeActVsBgt":0,"wholeActual":0,"wholeBudget":0,"wholeLast":0,"wholeActVsLy":0,"wholeActVsBgt":0,"name_code":"F&B Revenue 餐饮收入"},{"name":"F&B Dep't Profit 餐饮部门利润","sort":1,"actual":0,"forecast":0,"budget":0,"last":0,"actVsFcst":0,"actVsBgt":0,"actVsLy":0,"ytdActual":0,"ytdBudget":0,"ytdLast":0,"ytdActVsBgt":0,"ytdActVsLy":0,"threeActual":0,"threeBudget":0,"threeLast":0,"threeActVsLy":0,"threeActVsBgt":0,"wholeActual":0,"wholeBudget":0,"wholeLast":0,"wholeActVsLy":0,"wholeActVsBgt":0,"name_code":"F&B Dep't Profit 餐饮部门利润"},{"name":"F&B Dep't Profit % 餐饮部门利润率","sort":2,"actual":0,"forecast":0,"budget":0,"last":0,"actVsFcst":0,"actVsBgt":0,"actVsLy":0,"ytdActual":0,"ytdBudget":0,"ytdLast":0,"ytdActVsBgt":0,"ytdActVsLy":0,"threeActual":0,"threeBudget":0,"threeLast":0,"threeActVsLy":0,"threeActVsBgt":0,"wholeActual":0,"wholeBudget":0,"wholeLast":0,"wholeActVsLy":0,"wholeActVsBgt":0,"name_code":"F&B Dep't Profit % 餐饮部门利润率"},{"name":"F&B Beverage Cost 饮品成本","sort":3,"actual":0,"forecast":0,"budget":0,"last":0,"actVsFcst":0,"actVsBgt":0,"actVsLy":0,"ytdActual":0,"ytdBudget":0,"ytdLast":0,"ytdActVsBgt":0,"ytdActVsLy":0,"threeActual":0,"threeBudget":0,"threeLast":0,"threeActVsLy":0,"threeActVsBgt":0,"wholeActual":0,"wholeBudget":0,"wholeLast":0,"wholeActVsLy":0,"wholeActVsBgt":0,"name_code":"F&B Beverage Cost 饮品成本"},{"name":"F&B Beverage Cost % 饮品成本率","sort":4,"actual":0,"forecast":0,"budget":0,"last":0,"actVsFcst":0,"actVsBgt":0,"actVsLy":0,"ytdActual":0,"ytdBudget":0,"ytdLast":0,"ytdActVsBgt":0,"ytdActVsLy":0,"threeActual":0,"threeBudget":0,"threeLast":0,"threeActVsLy":0,"threeActVsBgt":0,"wholeActual":0,"wholeBudget":0,"wholeLast":0,"wholeActVsLy":0,"wholeActVsBgt":0,"name_code":"F&B Beverage Cost % 饮品成本率"},{"name":"F&B Food Cost 食品成本","sort":5,"actual":0,"forecast":0,"budget":0,"last":0,"actVsFcst":0,"actVsBgt":0,"actVsLy":0,"ytdActual":0,"ytdBudget":0,"ytdLast":0,"ytdActVsBgt":0,"ytdActVsLy":0,"threeActual":0,"threeBudget":0,"threeLast":0,"threeActVsLy":0,"threeActVsBgt":0,"wholeActual":0,"wholeBudget":0,"wholeLast":0,"wholeActVsLy":0,"wholeActVsBgt":0,"name_code":"F&B Food Cost 食品成本"},{"name":"F&B Food Cost % 食品成本率","sort":6,"actual":0,"forecast":0,"budget":0,"last":0,"actVsFcst":0,"actVsBgt":0,"actVsLy":0,"ytdActual":0,"ytdBudget":0,"ytdLast":0,"ytdActVsBgt":0,"ytdActVsLy":0,"threeActual":0,"threeBudget":0,"threeLast":0,"threeActVsLy":0,"threeActVsBgt":0,"wholeActual":0,"wholeBudget":0,"wholeLast":0,"wholeActVsLy":0,"wholeActVsBgt":0,"name_code":"F&B Food Cost % 食品成本率"},{"name":"F&B Staff 餐饮部员工总数","sort":7,"actual":0,"forecast":0,"budget":0,"last":0,"actVsFcst":0,"actVsBgt":0,"actVsLy":0,"ytdActual":0,"ytdBudget":0,"ytdLast":0,"ytdActVsBgt":0,"ytdActVsLy":0,"threeActual":0,"threeBudget":0,"threeLast":0,"threeActVsLy":0,"threeActVsBgt":0,"wholeActual":0,"wholeBudget":0,"wholeLast":0,"wholeActVsLy":0,"wholeActVsBgt":0,"name_code":"F&B Staff 餐饮部员工总数"},{"name":"F&B Labor Outsourcing Staff 餐饮部外包员工总数","sort":8,"actual":0,"forecast":0,"budget":0,"last":0,"actVsFcst":0,"actVsBgt":0,"actVsLy":0,"ytdActual":0,"ytdBudget":0,"ytdLast":0,"ytdActVsBgt":0,"ytdActVsLy":0,"threeActual":0,"threeBudget":0,"threeLast":0,"threeActVsLy":0,"threeActVsBgt":0,"wholeActual":0,"wholeBudget":0,"wholeLast":0,"wholeActVsLy":0,"wholeActVsBgt":0,"name_code":"F&B Labor Outsourcing Staff 餐饮部外包员工总数"},{"name":"F&B total staff 餐饮部员工总数","sort":9,"actual":0,"forecast":0,"budget":0,"last":0,"actVsFcst":0,"actVsBgt":0,"actVsLy":0,"ytdActual":0,"ytdBudget":0,"ytdLast":0,"ytdActVsBgt":0,"ytdActVsLy":0,"threeActual":0,"threeBudget":0,"threeLast":0,"threeActVsLy":0,"threeActVsBgt":0,"wholeActual":0,"wholeBudget":0,"wholeLast":0,"wholeActVsLy":0,"wholeActVsBgt":0,"name_code":"F&B total staff 餐饮部员工总数"},{"name":"F&B Total Payroll and Expenses 餐饮部门薪酬及相关福利合计","sort":10,"actual":0,"forecast":0,"budget":0,"last":0,"actVsFcst":0,"actVsBgt":0,"actVsLy":0,"ytdActual":0,"ytdBudget":0,"ytdLast":0,"ytdActVsBgt":0,"ytdActVsLy":0,"threeActual":0,"threeBudget":0,"threeLast":0,"threeActVsLy":0,"threeActVsBgt":0,"wholeActual":0,"wholeBudget":0,"wholeLast":0,"wholeActVsLy":0,"wholeActVsBgt":0,"name_code":"F&B Salary 餐饮部门员工工资（仅工资）"},{"name":"F&B Labor Outsourcing Expenses 餐饮部门劳务费用合计","sort":11,"actual":0,"forecast":0,"budget":0,"last":0,"actVsFcst":0,"actVsBgt":0,"actVsLy":0,"ytdActual":0,"ytdBudget":0,"ytdLast":0,"ytdActVsBgt":0,"ytdActVsLy":0,"threeActual":0,"threeBudget":0,"threeLast":0,"threeActVsLy":0,"threeActVsBgt":0,"wholeActual":0,"wholeBudget":0,"wholeLast":0,"wholeActVsLy":0,"wholeActVsBgt":0,"name_code":"F&B Labor Outsourcing Expenses 餐饮部门劳务费用合计"},{"name":"F&B Labor Expenses 餐饮部门总人工成本及劳务费用","sort":12,"actual":0,"forecast":0,"budget":0,"last":0,"actVsFcst":0,"actVsBgt":0,"actVsLy":0,"ytdActual":0,"ytdBudget":0,"ytdLast":0,"ytdActVsBgt":0,"ytdActVsLy":0,"threeActual":0,"threeBudget":0,"threeLast":0,"threeActVsLy":0,"threeActVsBgt":0,"wholeActual":0,"wholeBudget":0,"wholeLast":0,"wholeActVsLy":0,"wholeActVsBgt":0,"name_code":"F&B Labor Expenses 餐饮部门人工费用总计"},{"name":"F&B Revenue/ Total Revenue % 餐饮收入占酒店总收入%","sort":13,"actual":0,"forecast":0,"budget":0,"last":0,"actVsFcst":0,"actVsBgt":0,"actVsLy":0,"ytdActual":0,"ytdBudget":0,"ytdLast":0,"ytdActVsBgt":0,"ytdActVsLy":0,"threeActual":0,"threeBudget":0,"threeLast":0,"threeActVsLy":0,"threeActVsBgt":0,"wholeActual":0,"wholeBudget":0,"wholeLast":0,"wholeActVsLy":0,"wholeActVsBgt":0,"name_code":"F&B Revenue/ Total Revenue % 餐饮收入占酒店总收入%"},{"name":"Productivity 劳动生产率 - F&B Revenue / F&B Staff 餐饮部每位员工所创造的收入","sort":14,"actual":0,"forecast":0,"budget":0,"last":0,"actVsFcst":0,"actVsBgt":0,"actVsLy":0,"ytdActual":0,"ytdBudget":0,"ytdLast":0,"ytdActVsBgt":0,"ytdActVsLy":0,"threeActual":0,"threeBudget":0,"threeLast":0,"threeActVsLy":0,"threeActVsBgt":0,"wholeActual":0,"wholeBudget":0,"wholeLast":0,"wholeActVsLy":0,"wholeActVsBgt":0,"name_code":"Productivity 劳动生产率 - F&B Revenue / F&B Staff 餐饮部每位员工所创造的收入"},{"name":"Productivity 劳动生产率 - F&B Revenue / F&B Staff(Full time + Outsources <br/>餐饮部每位员工（正式员工+外包）所创造的收入","sort":15,"actual":0,"forecast":0,"budget":0,"last":0,"actVsFcst":0,"actVsBgt":0,"actVsLy":0,"ytdActual":0,"ytdBudget":0,"ytdLast":0,"ytdActVsBgt":0,"ytdActVsLy":0,"threeActual":0,"threeBudget":0,"threeLast":0,"threeActVsLy":0,"threeActVsBgt":0,"wholeActual":0,"wholeBudget":0,"wholeLast":0,"wholeActVsLy":0,"wholeActVsBgt":0,"name_code":"Productivity 劳动生产率 - F&B Revenue / F&B Staff(Full time + Outsources <br/>餐饮部每位员工（正式员工+外包）所创造的收入"},{"name":"F&B Other rexpense 其它费用","sort":16,"actual":0,"forecast":0,"budget":0,"last":0,"actVsFcst":0,"actVsBgt":0,"actVsLy":0,"ytdActual":0,"ytdBudget":0,"ytdLast":0,"ytdActVsBgt":0,"ytdActVsLy":0,"threeActual":0,"threeBudget":0,"threeLast":0,"threeActVsLy":0,"threeActVsBgt":0,"wholeActual":0,"wholeBudget":0,"wholeLast":0,"wholeActVsLy":0,"wholeActVsBgt":0,"name_code":"F&B Other rexpense 其它费用"}];

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columns=exports.fillData=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _method=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TOTALINDEX=[];var PERCENTINDEX=[2,4,6,13];exports.default=function(data,dataLast){var listName=['actual','forecast','budget','last','ytdActual','ytdBudget','ytdLast','threeActual','threeBudget','threeLast','wholeActual','wholeBudget','wholeLast'];// 计算年度累计
data[7].ytdBudget=(0,_method.sum)([_lodash2.default.get(dataLast,'7.ytdBudget',0),data[7].budget]);data[8].ytdBudget=(0,_method.sum)([_lodash2.default.get(dataLast,'8.ytdBudget',0),data[8].budget]);listName.forEach(function(name){data[2][name]=(0,_method.calculation)(data[1][name],data[0][name],4);data[4][name]=(0,_method.calculation)(data[3][name],data[0][name],4);data[6][name]=(0,_method.calculation)(data[5][name],data[0][name],4);data[9][name]=(0,_method.sum)([data[8][name],data[7][name]]);data[12][name]=(0,_method.sum)([data[11][name],data[10][name]]);data[14][name]=(0,_method.calculation)(data[0][name],data[7][name],4);data[15][name]=(0,_method.calculation)(data[0][name],data[9][name],4);});// 计算chang变化百分比
for(var i=0;i<data.length;i++){var item=data[i];data[i].actVsFcst=(0,_method.calculation)(item.actual,item.forecast,4);data[i].actVsBgt=(0,_method.calculation)(item.actual,item.budget,4);data[i].actVsLy=(0,_method.calculation)(item.actual,item.last,4);data[i].ytdActVsBgt=(0,_method.calculation)(item.ytdActual,item.ytdBudget,4);data[i].ytdActVsLy=(0,_method.calculation)(item.ytdActual,item.ytdLast,4);data[i].threeActVsLy=(0,_method.calculation)(item.threeActual,item.threeLast,4);data[i].threeActVsBgt=(0,_method.calculation)(item.threeActual,item.threeBudget,4);data[i].wholeActVsLy=(0,_method.calculation)(item.wholeActual,item.wholeLast,4);data[i].wholeActVsBgt=(0,_method.calculation)(item.wholeActual,item.wholeBudget,4);}return data;};var fillData=exports.fillData=function fillData(data,dataAll,date){// 从1.1获取数据,只在获取数据时填充
var correspond={actual:'actual',forecast:"prediction",budget:"budget",last:"last_year",ytdActual:"year_actual",ytdBudget:"year_budget",ytdLast:"year_last_year",threeActual:"three_actual",threeBudget:"three_budget",threeLast:"three_last_year",wholeActual:"whole_actual",wholeBudget:"whole_budget",wholeLast:"whole_last_year"};Object.keys(correspond).forEach(function(name){data[0][name]=_lodash2.default.get(dataAll,'data1.6.'+correspond[name],0);data[1][name]=_lodash2.default.get(dataAll,'data1.11.'+correspond[name],0);data[13][name]=(0,_method.calculation)(_lodash2.default.get(dataAll,'data1.6.'+correspond[name],0),_lodash2.default.get(dataAll,'data1.8.'+correspond[name],0),4);});data[7].actual=_lodash2.default.get(dataAll,'data7_7.9.actual',0);data[7].last=_lodash2.default.get(dataAll,'data7_7.9.last',0);data[10].actual=_lodash2.default.get(dataAll,'data7_7.11.actual',0);data[10].last=_lodash2.default.get(dataAll,'data7_7.11.last',0);data[8].actual=_lodash2.default.get(dataAll,'data7_1.17.thisy_employee_num',0);data[8].last=_lodash2.default.get(dataAll,'data7_1.17.lasty_employee_num',0);data[8].ytdActual=_lodash2.default.get(dataAll,'data7_1.17.year_thisy_employee_num',0);data[8].ytdLast=_lodash2.default.get(dataAll,'data7_1.17.year_lasty_employee_num',0);data[11].actual=_lodash2.default.get(dataAll,'data7_1.17.thisy_payroll_cost',0);data[11].last=_lodash2.default.get(dataAll,'data7_1.17.lasty_payroll_cost',0);data[7].ytdActual=_lodash2.default.get(dataAll,'data7_8.35.now_year',0);data[7].ytdLast=_lodash2.default.get(dataAll,'data7_8.35.last_year',0);data[10].ytdActual=_lodash2.default.get(dataAll,'data7_8.37.now_year',0);data[10].ytdLast=_lodash2.default.get(dataAll,'data7_8.37.last_year',0);data[11].ytdActual=_lodash2.default.get(dataAll,'data7_8.66.now_year',0);data[11].ytdLast=_lodash2.default.get(dataAll,'data7_8.66.last_year',0);var listName=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];var month=listName[(0,_moment2.default)(date).format("M")-1];data[7].budget=_lodash2.default.get(dataAll,'data16_1.6.number',0);data[10].budget=_lodash2.default.get(dataAll,'data16_1.11.'+month,0);return data;};var columns=exports.columns=function columns(_ref){var print=_ref.print,onChange=_ref.onChange;return[// {
//     title: 'key',
//     dataIndex: 'sort',
//     key: 'sort',
//     align: "center",
//     fixed: !print && "left",
// },
{title:'Key Performance Indicator 关键绩效指数',dataIndex:'name',key:'name',align:"center",fixed:!print&&"left",width:500,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:onChange,totalIndex:TOTALINDEX};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'MTD 月累计',children:[{title:'Actual 实际',dataIndex:'actual',key:'actual',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:PERCENTINDEX.includes(index)?'percent':[3,5,16].includes(index)&&!print?'inputNumber':"number",name:"actual",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['MTD 月累计','Actual 实际'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Forecast 预测',dataIndex:'forecast',key:'forecast',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:PERCENTINDEX.includes(index)?'percent':[3,5,7,8,10,11,16].includes(index)&&!print?'inputNumber':"number",name:"forecast",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['MTD 月累计','Forecast 预测'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Budget 预算',dataIndex:'budget',key:'budget',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:PERCENTINDEX.includes(index)?'percent':[3,5,8,11,16].includes(index)&&!print?'inputNumber':"number",name:"budget",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['MTD 月累计','Budget 预算'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Last Year 去年',dataIndex:'last',key:'last',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:PERCENTINDEX.includes(index)?'percent':[3,5,16].includes(index)&&!print?'inputNumber':"number",name:"last",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['MTD 月累计','Last Year 去年'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'% Change 变化百分比',children:[{title:'Act vs. Fcst. 实际对比预测',dataIndex:'actVsFcst',key:'actVsFcst',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:"percent",name:"actVsFcst",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['MTD 月累计','% Change 变化百分比','Act vs. Fcst. 实际对比预测'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Act vs. Bgt. 实际对比预算',dataIndex:'actVsBgt',key:'actVsBgt',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:"percent",name:"actVsBgt",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['MTD 月累计','% Change 变化百分比','Act vs. Bgt. 实际对比预算'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Act vs. LY 实际对比去年',dataIndex:'actVsLy',key:'actVsLy',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:"percent",name:"actVsLy",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['MTD 月累计','% Change 变化百分比','Act vs. LY 实际对比去年'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]},{title:'YTD 年累计',children:[{title:'Actual 实际',dataIndex:'ytdActual',key:'ytdActual',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:PERCENTINDEX.includes(index)?'percent':[3,5,16].includes(index)&&!print?'inputNumber':"number",name:"ytdActual",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['YTD 年累计','Actual 实际'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Budget 预算',dataIndex:'ytdBudget',key:'ytdBudget',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:PERCENTINDEX.includes(index)?'percent':[3,5,10,11,16].includes(index)&&!print?'inputNumber':"number",name:"ytdBudget",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['YTD 年累计','Budget 预算'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Last Year 去年',dataIndex:'ytdLast',key:'ytdLast',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:PERCENTINDEX.includes(index)?'percent':[3,5,16].includes(index)&&!print?'inputNumber':"number",name:"ytdLast",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['YTD 年累计','Last Year 去年'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'% Change 变化百分比',children:[{title:'Act vs. Bgt. 实际对比预算',dataIndex:'ytdActVsBgt',key:'ytdActVsBgt',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:"percent",name:"ytdActVsBgt",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['YTD 年累计','% Change 变化百分比','Act vs. Bgt. 实际对比预算'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Act vs. LY 实际对比去年',dataIndex:'ytdActVsLy',key:'ytdActVsLy',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:"percent",name:"ytdActVsLy",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['YTD 年累计','% Change 变化百分比','Act vs. LY 实际对比去年'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]},{title:'3-Month-Rolling Forecast 后三个月滚动预测',children:[{title:'Actual 实际',dataIndex:'threeActual',key:'threeActual',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:PERCENTINDEX.includes(index)?'percent':[3,5,7,8,10,11,16].includes(index)&&!print?'inputNumber':"number",name:"threeActual",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['3-Month-Rolling Forecast 后三个月滚动预测','Actual 实际'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Budget 预算',dataIndex:'threeBudget',key:'threeBudget',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:PERCENTINDEX.includes(index)?'percent':[3,5,7,8,10,11,16].includes(index)&&!print?'inputNumber':"number",name:"threeBudget",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['3-Month-Rolling Forecast 后三个月滚动预测','Budget 预算'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Last Year 去年',dataIndex:'threeLast',key:'threeLast',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:PERCENTINDEX.includes(index)?'percent':[3,5,7,8,10,11,16].includes(index)&&!print?'inputNumber':"number",name:"threeLast",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['3-Month-Rolling Forecast 后三个月滚动预测','Last Year 去年'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'% Change 变化百分比',children:[{title:'Act vs. Bgt. 实际对比预算',dataIndex:'threeActVsLy',key:'threeActVsLy',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:"percent",name:"threeActVsLy",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['3-Month-Rolling Forecast 后三个月滚动预测','% Change 变化百分比','Act vs. Bgt. 实际对比预算'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Act vs. LY 实际对比去年',dataIndex:'threeActVsBgt',key:'threeActVsBgt',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:"percent",name:"threeActVsBgt",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['3-Month-Rolling Forecast 后三个月滚动预测','% Change 变化百分比','Act vs. LY 实际对比去年'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]},{title:'Whole Year Forecast Total 整年预测',children:[{title:'Actual 实际',dataIndex:'wholeActual',key:'wholeActual',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:PERCENTINDEX.includes(index)?'percent':[3,5,7,8,10,11,16].includes(index)&&!print?'inputNumber':"number",name:"wholeActual",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['MTD 月累计','Actual 实际'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Budget 预算',dataIndex:'wholeBudget',key:'wholeBudget',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:PERCENTINDEX.includes(index)?'percent':[3,5,7,8,10,11,16].includes(index)&&!print?'inputNumber':"number",name:"wholeBudget",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['MTD 月累计','Budget 预算'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Last Year 去年',dataIndex:'wholeLast',key:'wholeLast',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:PERCENTINDEX.includes(index)?'percent':[3,5,7,8,10,11,16].includes(index)&&!print?'inputNumber':"number",name:"wholeLast",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['MTD 月累计','Last Year 去年'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'% Change 变化百分比',children:[{title:'Act vs. Bgt. 实际对比预算',dataIndex:'wholeActVsBgt',key:'wholeActVsBgt',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:"percent",name:"wholeActVsBgt",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['MTD 月累计','% Change 变化百分比','Act vs. Bgt. 实际对比预算'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Act vs. LY 实际对比去年',dataIndex:'wholeActVsLy',key:'wholeActVsLy',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:"percent",name:"wholeActVsLy",onChange:onChange,totalIndex:TOTALINDEX,compared:{title:['MTD 月累计','% Change 变化百分比','Act vs. LY 实际对比去年'],record:record,sqlName:"_5"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]}];};

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _=__webpack_require__(1912);var _2=_interopRequireDefault(_);var _3=__webpack_require__(1913);var _4=_interopRequireDefault(_3);var _5=__webpack_require__(1914);var _6=_interopRequireDefault(_5);var _7=__webpack_require__(1915);var _8=_interopRequireDefault(_7);var _9=__webpack_require__(1916);var _10=_interopRequireDefault(_9);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.onChange=function(name,value){_this.setState(_defineProperty({},name,value));};_this.state={update5_1:false,update5_1_3:false};return _this;}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",null,_react2.default.createElement(_row2.default,{style:{margin:"24px 0 24px 24px",fontSize:22,color:"#333"}},"5.1 F&B Revenue Analysis By Outlets \u9910\u996E\u6536\u5165\u5206\u6790-\u6309\u9910\u5385"),_react2.default.createElement(_2.default,Object.assign({},this.props,{onChange:this.onChange})),_react2.default.createElement(_4.default,Object.assign({},this.props,{onChange:this.onChange,update:this.state.update5_1})),_react2.default.createElement(_6.default,Object.assign({},this.props,{onChange:this.onChange,update:this.state.update5_1})),_react2.default.createElement(_8.default,Object.assign({},this.props,{onChange:this.onChange,update:this.state.update5_1_3})),_react2.default.createElement(_10.default,this.props));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(25);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _data=__webpack_require__(311);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _reactRouterDom=__webpack_require__(85);var _ExportExcel=__webpack_require__(79);var _ExportExcel2=_interopRequireDefault(_ExportExcel);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;function numChange(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var html=Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');return html;}var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.handleWindowClose=function(ev){var confirmationMessage="5.1.1 数据还未保存,确定要离开吗?";(ev||window.event).returnValue=confirmationMessage;if(_this.state.isEdit){return confirmationMessage;}};_this.computeNum=function(data,isUpdate){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};// 计算total
var totalNameData=['covers','REV','cost','m_covers','m_REV','m_cost'];var _loop=function _loop(i){data[13][totalNameData[i]]=data.reduce(function(a,b,index){if(index!=13&&index!=14&&index!=15&&index!=16){a+=Number(b[totalNameData[i]]||'0');}return a;},0);data[13][totalNameData[i]]=data[13][totalNameData[i]].toFixed(0);};for(var i=0;i<totalNameData.length;i++){_loop(i);};for(var i=0;i<14;i++){data[i].business=(numConvert(data[13].covers)==0?0:numConvert(data[i].covers)/numConvert(data[13].covers)).toFixed(3);data[i].AC=(numConvert(data[i].covers)==0?0:numConvert(data[i].REV)/numConvert(data[i].covers)).toFixed(0);data[i].revenue=(numConvert(data[13].REV)==0?0:numConvert(data[i].REV)/numConvert(data[13].REV)).toFixed(3);data[i].cost_percent=(numConvert(data[i].REV)==0?0:numConvert(data[i].cost)/numConvert(data[i].REV)).toFixed(3);data[i].m_business=(numConvert(data[13].m_covers)==0?0:numConvert(data[i].m_covers)/numConvert(data[13].m_covers)).toFixed(3);data[i].m_AC=(numConvert(data[i].m_covers)==0?0:numConvert(data[i].m_REV)/numConvert(data[i].m_covers)).toFixed(0);data[i].m_revenue=(numConvert(data[13].m_REV)==0?0:numConvert(data[i].m_REV)/numConvert(data[13].m_REV)).toFixed(3);data[i].m_cost_percent=(numConvert(data[i].m_REV)==0?0:numConvert(data[i].m_cost)/numConvert(data[i].m_REV)).toFixed(3);data[i].b_covers=(numConvert(data[i].covers)-numConvert(data[i].m_covers)).toFixed(0);data[i].b_business=(numConvert(data[i].business)-numConvert(data[i].m_business)).toFixed(3);data[i].b_AC=(numConvert(data[i].AC)-numConvert(data[i].m_AC)).toFixed(0);data[i].b_REV=(numConvert(data[i].REV)-numConvert(data[i].m_REV)).toFixed(0);data[i].b_revenue=(numConvert(data[i].revenue)-numConvert(data[i].m_revenue)).toFixed(3);data[i].b_cost=(numConvert(data[i].cost)-numConvert(data[i].m_cost)).toFixed(0);data[i].b_cost_percent=(numConvert(data[i].cost_percent)-numConvert(data[i].m_cost_percent)).toFixed(3);}// 计算设施收入 其他收入 合计收入
data[16].REV=(numConvert(data[15].REV)+numConvert(data[14].REV)+numConvert(data[13].REV)).toFixed(0);data[16].m_REV=(numConvert(data[15].m_REV)+numConvert(data[14].m_REV)+numConvert(data[13].m_REV)).toFixed(0);data[14].b_REV=(numConvert(data[14].REV)-numConvert(data[14].m_REV)).toFixed(0);data[15].b_REV=(numConvert(data[15].REV)-numConvert(data[15].m_REV)).toFixed(0);data[16].b_REV=(numConvert(data[16].REV)-numConvert(data[16].m_REV)).toFixed(0);_this.setState({data:data},function(){if(isUpdate){_this.onSave();}});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);_this.setState({isEdit:true});};_this.getDateData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var dataBegin,data,res,x;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;dataBegin=JSON.stringify(_data.data3_2_1);data=JSON.parse(dataBegin);_context.next=5;return fetch('/_5_1_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'});case 5:res=_context.sent;_context.next=8;return res.json();case 8:x=_context.sent;if(x.data&&x.data.length>0){data=x.data;}_this.setState({loading:false});_this.computeNum(data,true);_context.next=18;break;case 14:_context.prev=14;_context.t0=_context['catch'](0);_this.setState({loading:false});console.error(_context.t0);case 18:case'end':return _context.stop();}}},_callee,_this2,[[0,14]]);}));return function(_x3){return _ref.apply(this,arguments);};}();_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_5_1_1  ',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false,isEdit:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);_this.props.onChange('update5_1',true);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table5_1_1',1.5,'5.11',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,isEdit:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;//在关闭页面时弹出确认提示窗口
window.addEventListener('beforeunload',this.handleWindowClose);this.props.store.revenue.getData(this.state.date).then(function(x){var dataBegin=JSON.stringify(_data.data3_2_1);var data=JSON.parse(dataBegin);if(x.data&&x.data.length>0){data=x.data;}_this3.setState({loading:false});_this3.computeNum(data,true);}).catch(function(err){console.error(err);_this3.setState({loading:false});});}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('beforeunload',this.handleWindowClose);}},{key:'render',value:function render(){var _this4=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print;var width=document.body.offsetWidth-3150>300?document.body.offsetWidth-3150:300;var noInputData=[13,14,15,16];var columns=[{title:'Outlets & Others 餐厅及其他',dataIndex:'name',key:'name',align:"center",fixed:!print&&"left",width:width,render:function render(text,record,index){var isInput=(0,_moment2.default)(_this4.state.date).isBefore('2019-06');var _arr=[].concat(noInputData,[0,1,2,3,4,5]);if(!(0,_moment2.default)(_this4.state.date).isBefore('2020-10'))_arr.push(6);if((!_arr.includes(index)||isInput)&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";var data=_this4.state.data;data[index].name=value;_this4.setState({data:data});}}));}return _react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' ',style:{textAlign:"left"}},text);}},{title:'MTD Actual - This Year 月累计 -今年',width:1050,children:[{title:_react2.default.createElement('div',null,'Covers ',_react2.default.createElement('br',null),'\u4EBA\u6570'),dataIndex:'covers',key:'covers',align:"center",width:150,render:function render(text,record,index){var title=['MTD Actual - This Year 月累计 -今年','Covers 人数'];if(!noInputData.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'covers',title:title,sqlName:"_5_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this4.onChange('covers',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'covers',title:title,sqlName:"_5_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Business Mix ',_react2.default.createElement('br',null),'\u4E1A\u52A1\u4EFD\u989D'),dataIndex:'business',key:'business',align:"center",width:150,render:function render(text,record,index){var title=['MTD Actual - This Year 月累计 -今年','Business Mix 业务份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'business',title:title,sqlName:"_5_1_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'A/C ',_react2.default.createElement('br',null),'\u4EBA\u5747\u6D88\u8D39'),dataIndex:'AC',key:'AC',align:"center",width:150,render:function render(text,record,index){var title=['MTD Actual - This Year 月累计 -今年','A/C 人均消费'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'AC',title:title,sqlName:"_5_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV ',_react2.default.createElement('br',null),'\u6536\u76CA'),dataIndex:'REV',key:'REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD Actual - This Year 月累计 -今年','REV 收益'];if((!noInputData.includes(index)||index==14||index==15)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'REV',title:title,sqlName:"_5_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this4.onChange('REV',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'REV',title:title,sqlName:"_5_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'Revenue Mix',_react2.default.createElement('br',null),' \u6536\u5165\u4EFD\u989D'),dataIndex:'revenue',key:'revenue',align:"center",width:150,render:function render(text,record,index){var title=['MTD Actual - This Year 月累计 -今年','Revenue Mix 收入份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revenue',title:title,sqlName:"_5_1_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost Amount ',_react2.default.createElement('br',null),' \u6210\u672C\u91D1\u989D'),dataIndex:'cost',key:'cost',align:"center",width:150,render:function render(text,record,index){var title=['MTD Actual - This Year 月累计 -今年','Cost Amount 成本金额'];if(!noInputData.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cost',title:title,sqlName:"_5_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this4.onChange('cost',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cost',title:title,sqlName:"_5_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'Cost %  ',_react2.default.createElement('br',null),' \u6210\u672C\u767E\u5206\u6BD4'),dataIndex:'cost_percent',key:'cost_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD Actual - This Year 月累计 -今年','Cost % 成本百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cost_percent',title:title,sqlName:"_5_1_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]},{title:'MTD Budget - This Year 月累计 - 今年预算',width:1050,children:[{title:_react2.default.createElement('div',null,'Covers ',_react2.default.createElement('br',null),'\u4EBA\u6570'),dataIndex:'m_covers',key:'m_covers',align:"center",width:150,render:function render(text,record,index){var title=['MTD Budget - This Year 月累计 - 今年预算','Covers 人数'];if(!noInputData.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_covers',title:title,sqlName:"_5_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this4.onChange('m_covers',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_covers',title:title,sqlName:"_5_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},text));}}},{title:_react2.default.createElement('div',null,'Business Mix ',_react2.default.createElement('br',null),'\u4E1A\u52A1\u4EFD\u989D'),dataIndex:'m_business',key:'m_business',align:"center",width:150,render:function render(text,record,index){var title=['MTD Budget - This Year 月累计 - 今年预算','Business Mix 业务份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_business',title:title,sqlName:"_5_1_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'A/C ',_react2.default.createElement('br',null),'\u4EBA\u5747\u6D88\u8D39'),dataIndex:'m_AC',key:'m_AC',align:"center",width:150,render:function render(text,record,index){var title=['MTD Budget - This Year 月累计 - 今年预算','A/C 人均消费'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_AC',title:title,sqlName:"_5_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV ',_react2.default.createElement('br',null),'\u6536\u76CA'),dataIndex:'m_REV',key:'m_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD Budget - This Year 月累计 - 今年预算','REV 收益'];if((!noInputData.includes(index)||index==14||index==15)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_REV',title:title,sqlName:"_5_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this4.onChange('m_REV',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_REV',title:title,sqlName:"_5_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'Revenue Mix',_react2.default.createElement('br',null),' \u6536\u5165\u4EFD\u989D'),dataIndex:'m_revenue',key:'m_revenue',align:"center",width:150,render:function render(text,record,index){var title=['MTD Budget - This Year 月累计 - 今年预算','Revenue Mix 收入份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_revenue',title:title,sqlName:"_5_1_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost Amount ',_react2.default.createElement('br',null),' \u6210\u672C\u91D1\u989D'),dataIndex:'m_cost',key:'m_cost',align:"center",width:150,render:function render(text,record,index){var title=['MTD Budget - This Year 月累计 - 今年预算','Cost Amount 成本金额'];if(!noInputData.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_cost',title:title,sqlName:"_5_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this4.onChange('m_cost',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_cost',title:title,sqlName:"_5_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'Cost %  ',_react2.default.createElement('br',null),' \u6210\u672C\u767E\u5206\u6BD4'),dataIndex:'m_cost_percent',key:'m_cost_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD Budget - This Year 月累计 - 今年预算','Cost % 成本百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_cost_percent',title:title,sqlName:"_5_1_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]},{title:'MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算',width:1050,children:[{title:_react2.default.createElement('div',null,'Covers ',_react2.default.createElement('br',null),'\u4EBA\u6570'),dataIndex:'b_covers',key:'b_covers',align:"center",width:150,render:function render(text,record,index){var title=['MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算','Covers 人数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_covers',title:title,sqlName:"_5_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'Business Mix ',_react2.default.createElement('br',null),'\u4E1A\u52A1\u4EFD\u989D'),dataIndex:'b_business',key:'b_business',align:"center",width:150,render:function render(text,record,index){var title=['MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算','Business Mix 业务份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_business',title:title,sqlName:"_5_1_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'A/C ',_react2.default.createElement('br',null),'\u4EBA\u5747\u6D88\u8D39'),dataIndex:'b_AC',key:'b_AC',align:"center",width:150,render:function render(text,record,index){var title=['MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算','A/C 人均消费'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_AC',title:title,sqlName:"_5_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV ',_react2.default.createElement('br',null),'\u6536\u76CA'),dataIndex:'b_REV',key:'b_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_REV',title:title,sqlName:"_5_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'Revenue Mix',_react2.default.createElement('br',null),' \u6536\u5165\u4EFD\u989D'),dataIndex:'b_revenue',key:'b_revenue',align:"center",width:150,render:function render(text,record,index){var title=['MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算','Revenue Mix 收入份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_revenue',title:title,sqlName:"_5_1_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost Amount ',_react2.default.createElement('br',null),' \u6210\u672C\u91D1\u989D'),dataIndex:'b_cost',key:'b_cost',align:"center",width:150,render:function render(text,record,index){var title=['MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算','Cost Amount 成本金额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_cost',title:title,sqlName:"_5_1_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'Cost %  ',_react2.default.createElement('br',null),' \u6210\u672C\u767E\u5206\u6BD4'),dataIndex:'b_cost_percent',key:'b_cost_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算','Cost %  成本百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_cost_percent',title:title,sqlName:"_5_1_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table5_1_1',style:{width:this.state.print?3200:'auto'}},_react2.default.createElement(_row2.default,null,'5.1.1 MTD - This Year Actual Vs. Budget \u6708\u7D2F\u8BA1\u5B9E\u9645\u5BF9\u6BD4\u9884\u7B97'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this4.setState({date:str,data:[],loading:true});_this4.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',id:'table5_1_1',style:{width:this.state.print?3150:'auto'},scroll:this.state.print?{}:{x:3150},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this4.setState({print:true,loading:true},function(){(0,_ExportExcel2.default)({id:"table5_1_1",date:date,name:"5.1.1 MTD - This Year Actual Vs. Budget 月累计实际对比预算"});_this4.setState({print:false,loading:false});});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_5_1'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58'))),this.state.isEdit&&_react2.default.createElement(_reactRouterDom.Prompt,{message:'5.1.1 \u6570\u636E\u8FD8\u672A\u4FDD\u5B58,\u786E\u5B9A\u8981\u79BB\u5F00\u5417?'})));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _data=__webpack_require__(311);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _reactRouterDom=__webpack_require__(85);var _ExportExcel=__webpack_require__(79);var _ExportExcel2=_interopRequireDefault(_ExportExcel);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;function numChange(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var html=Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');return html;}var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.handleWindowClose=function(ev){var confirmationMessage="5.1.2 数据还未保存,确定要离开吗?";(ev||window.event).returnValue=confirmationMessage;if(_this.state.isEdit){return confirmationMessage;}};_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};// 计算total
var totalNameData=['covers','REV','cost','m_covers','m_REV','m_cost'];var _loop=function _loop(i){data[13][totalNameData[i]]=data.reduce(function(a,b,index){if(index!=13&&index!=14&&index!=15&&index!=16){a+=Number(b[totalNameData[i]]||'0');}return a;},0);data[13][totalNameData[i]]=data[13][totalNameData[i]].toFixed(0);};for(var i=0;i<totalNameData.length;i++){_loop(i);};for(var i=0;i<14;i++){data[i].business=(numConvert(data[13].covers)==0?0:numConvert(data[i].covers)/numConvert(data[13].covers)).toFixed(3);data[i].AC=(numConvert(data[i].covers)==0?0:numConvert(data[i].REV)/numConvert(data[i].covers)).toFixed(0);data[i].revenue=(numConvert(data[13].REV)==0?0:numConvert(data[i].REV)/numConvert(data[13].REV)).toFixed(3);data[i].cost_percent=(numConvert(data[i].REV)==0?0:numConvert(data[i].cost)/numConvert(data[i].REV)).toFixed(3);data[i].m_business=(numConvert(data[13].m_covers)==0?0:numConvert(data[i].m_covers)/numConvert(data[13].m_covers)).toFixed(3);data[i].m_AC=(numConvert(data[i].m_covers)==0?0:numConvert(data[i].m_REV)/numConvert(data[i].m_covers)).toFixed(0);data[i].m_revenue=(numConvert(data[13].m_REV)==0?0:numConvert(data[i].m_REV)/numConvert(data[13].m_REV)).toFixed(3);data[i].m_cost_percent=(numConvert(data[i].m_REV)==0?0:numConvert(data[i].m_cost)/numConvert(data[i].m_REV)).toFixed(3);data[i].b_covers=(numConvert(data[i].covers)-numConvert(data[i].m_covers)).toFixed(0);data[i].b_business=(numConvert(data[i].business)-numConvert(data[i].m_business)).toFixed(3);data[i].b_AC=(numConvert(data[i].AC)-numConvert(data[i].m_AC)).toFixed(0);data[i].b_REV=(numConvert(data[i].REV)-numConvert(data[i].m_REV)).toFixed(0);data[i].b_revenue=(numConvert(data[i].revenue)-numConvert(data[i].m_revenue)).toFixed(3);data[i].b_cost=(numConvert(data[i].cost)-numConvert(data[i].m_cost)).toFixed(0);data[i].b_cost_percent=(numConvert(data[i].cost_percent)-numConvert(data[i].m_cost_percent)).toFixed(3);}// 计算设施收入 其他收入 合计收入
data[16].REV=(numConvert(data[15].REV)+numConvert(data[14].REV)+numConvert(data[13].REV)).toFixed(0);data[16].m_REV=(numConvert(data[15].m_REV)+numConvert(data[14].m_REV)+numConvert(data[13].m_REV)).toFixed(0);data[14].b_REV=(numConvert(data[14].REV)-numConvert(data[14].m_REV)).toFixed(0);data[15].b_REV=(numConvert(data[15].REV)-numConvert(data[15].m_REV)).toFixed(0);data[16].b_REV=(numConvert(data[16].REV)-numConvert(data[16].m_REV)).toFixed(0);_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);_this.setState({isEdit:true});};_this.getDateData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var dataBegin,data,d5_1,j5_1,d5_2,j5_2,lastd5_1,lastj5_1;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dataBegin=JSON.stringify(_data.data3_2_1);data=JSON.parse(dataBegin);_context.prev=2;_context.next=5;return fetch('/_5_1_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'});case 5:d5_1=_context.sent;_context.next=8;return d5_1.json();case 8:j5_1=_context.sent;_context.next=11;return fetch('/_5_1_2_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'});case 11:d5_2=_context.sent;_context.next=14;return d5_2.json();case 14:j5_2=_context.sent;_context.next=17;return fetch('/_5_1_1_info?year='+((0,_moment2.default)(date).format('YYYY')-1)+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'});case 17:lastd5_1=_context.sent;_context.next=20;return lastd5_1.json();case 20:lastj5_1=_context.sent;if(j5_2.data&&j5_2.data.length>0){data=j5_2.data;}// 插入5——1——1数据
if(j5_1.data&&j5_1.data.length>0){data=data.map(function(z,i){return _extends({},z,{name:j5_1.data[i].name,name_code:j5_1.data[i].name_code,covers:j5_1.data[i].covers,business:j5_1.data[i].business,AC:j5_1.data[i].AC,REV:j5_1.data[i].REV,revenue:j5_1.data[i].revenue,cost:j5_1.data[i].cost,cost_percent:j5_1.data[i].cost_percent});});}// 插入去年当月5——1数据
if(lastj5_1.data&&lastj5_1.data.length>0){data=data.map(function(z,i){if(z.name!=lastj5_1.data[i].name){return _extends({},z);}return _extends({},z,{m_covers:z.m_covers!=0?z.m_covers:lastj5_1.data[i].covers,m_business:z.m_business!=0?z.m_business:lastj5_1.data[i].business,m_AC:z.m_AC!=0?z.m_AC:lastj5_1.data[i].AC,m_REV:z.m_REV!=0?z.m_REV:lastj5_1.data[i].REV,m_revenue:z.m_revenue!=0?z.m_revenue:lastj5_1.data[i].revenue,m_cost:z.m_cost!=0?z.m_cost:lastj5_1.data[i].cost,m_cost_percent:z.m_cost_percent!=0?z.m_cost_percent:lastj5_1.data[i].cost_percent});});}_this.setState({loading:false});_this.computeNum(data);_context.next=32;break;case 28:_context.prev=28;_context.t0=_context['catch'](2);_this.setState({loading:false});console.error(_context.t0);case 32:case'end':return _context.stop();}}},_callee,_this2,[[2,28]]);}));return function(_x3){return _ref.apply(this,arguments);};}();_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month});});// if (!data.every(x => x.name)) {
//     message.error('名称不能为空，请到3-1-1设置名称！');
//     return
// }
var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_5_1_2',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false,isEdit:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table5_1_2',1.5,'5.12',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,isEdit:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);//在关闭页面时弹出确认提示窗口
window.addEventListener('beforeunload',this.handleWindowClose);}// 监测5.1.1保存情况
},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.update!=this.props.update&&nextProps.update){this.setState({data:[],loading:true});this.getDateData(this.state.date);this.props.onChange('update5_1',false);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('beforeunload',this.handleWindowClose);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,data=_state.data,print=_state.print,date=_state.date;var width=document.body.offsetWidth-3150>300?document.body.offsetWidth-3150:300;var noInputData=[13,14,15,16];var columns=[{title:'Outlets & Others 餐厅及其他',dataIndex:'name',key:'name',align:"center",fixed:!print&&"left",width:width,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' ',style:{textAlign:"left"}},text);}},{title:'MTD Actual - This Year 月累计 -今年',width:1050,children:[{title:_react2.default.createElement('div',null,'Covers ',_react2.default.createElement('br',null),'\u4EBA\u6570'),dataIndex:'covers',key:'covers',align:"center",width:150,render:function render(text,record,index){var title=['MTD Actual - This Year 月累计 -今年','Covers 人数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'covers',title:title,sqlName:"_5_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Business Mix ',_react2.default.createElement('br',null),'\u4E1A\u52A1\u4EFD\u989D'),dataIndex:'business',key:'business',align:"center",width:150,render:function render(text,record,index){var title=['MTD Actual - This Year 月累计 -今年','Business Mix 业务份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'business',title:title,sqlName:"_5_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'A/C ',_react2.default.createElement('br',null),'\u4EBA\u5747\u6D88\u8D39'),dataIndex:'AC',key:'AC',align:"center",width:150,render:function render(text,record,index){var title=['MTD Actual - This Year 月累计 -今年','A/C 人均消费'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'AC',title:title,sqlName:"_5_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV ',_react2.default.createElement('br',null),'\u6536\u76CA'),dataIndex:'REV',key:'REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD Actual - This Year 月累计 -今年','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'REV',title:title,sqlName:"_5_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'Revenue Mix',_react2.default.createElement('br',null),' \u6536\u5165\u4EFD\u989D'),dataIndex:'revenue',key:'revenue',align:"center",width:150,render:function render(text,record,index){var title=['MTD Actual - This Year 月累计 -今年','Revenue Mix 收入份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revenue',title:title,sqlName:"_5_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost Amount ',_react2.default.createElement('br',null),' \u6210\u672C\u91D1\u989D'),dataIndex:'cost',key:'cost',align:"center",width:150,render:function render(text,record,index){var title=['MTD Actual - This Year 月累计 -今年','Cost Amount 成本金额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cost',title:title,sqlName:"_5_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'Cost %  ',_react2.default.createElement('br',null),' \u6210\u672C\u767E\u5206\u6BD4'),dataIndex:'cost_percent',key:'cost_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD Actual - This Year 月累计 -今年','Cost % 成本百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cost_percent',title:title,sqlName:"_5_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]},{title:'MTD Actual - Last Year 月累计 - 去年实际',width:1050,children:[{title:_react2.default.createElement('div',null,'Covers ',_react2.default.createElement('br',null),'\u4EBA\u6570'),dataIndex:'m_covers',key:'m_covers',align:"center",width:150,render:function render(text,record,index){var title=['MTD Actual - This Year 月累计 -今年','Covers 人数'];if(!noInputData.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_covers',title:title,sqlName:"_5_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this3.onChange('m_covers',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_covers',title:title,sqlName:"_5_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},text));}}},{title:_react2.default.createElement('div',null,'Business Mix ',_react2.default.createElement('br',null),'\u4E1A\u52A1\u4EFD\u989D'),dataIndex:'m_business',key:'m_business',align:"center",width:150,render:function render(text,record,index){var title=['MTD Actual - This Year 月累计 -今年','Business Mix 业务份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_business',title:title,sqlName:"_5_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'A/C ',_react2.default.createElement('br',null),'\u4EBA\u5747\u6D88\u8D39'),dataIndex:'m_AC',key:'m_AC',align:"center",width:150,render:function render(text,record,index){var title=['MTD Actual - This Year 月累计 -今年','A/C 人均消费'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_AC',title:title,sqlName:"_5_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV ',_react2.default.createElement('br',null),'\u6536\u76CA'),dataIndex:'m_REV',key:'m_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD Actual - This Year 月累计 -今年','REV 收益'];if((!noInputData.includes(index)||index==14||index==15)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_REV',title:title,sqlName:"_5_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this3.onChange('m_REV',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_REV',title:title,sqlName:"_5_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'Revenue Mix',_react2.default.createElement('br',null),' \u6536\u5165\u4EFD\u989D'),dataIndex:'m_revenue',key:'m_revenue',align:"center",width:150,render:function render(text,record,index){var title=['MTD Actual - This Year 月累计 -今年','Revenue Mix 收入份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_revenue',title:title,sqlName:"_5_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost Amount ',_react2.default.createElement('br',null),' \u6210\u672C\u91D1\u989D'),dataIndex:'m_cost',key:'m_cost',align:"center",width:150,render:function render(text,record,index){var title=['MTD Actual - This Year 月累计 -今年','Cost Amount 成本金额'];if(!noInputData.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_cost',title:title,sqlName:"_5_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this3.onChange('m_cost',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_cost',title:title,sqlName:"_5_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'Cost %  ',_react2.default.createElement('br',null),' \u6210\u672C\u767E\u5206\u6BD4'),dataIndex:'m_cost_percent',key:'m_cost_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD Actual - This Year 月累计 -今年','Cost %  成本百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_cost_percent',title:title,sqlName:"_5_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]},{title:'MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算',width:1050,children:[{title:_react2.default.createElement('div',null,'Covers ',_react2.default.createElement('br',null),'\u4EBA\u6570'),dataIndex:'b_covers',key:'b_covers',align:"center",width:150,render:function render(text,record,index){var title=['MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算','Covers  人数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_covers',title:title,sqlName:"_5_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'Business Mix ',_react2.default.createElement('br',null),'\u4E1A\u52A1\u4EFD\u989D'),dataIndex:'b_business',key:'b_business',align:"center",width:150,render:function render(text,record,index){var title=['MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算','Business Mix  业务份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_business',title:title,sqlName:"_5_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'A/C ',_react2.default.createElement('br',null),'\u4EBA\u5747\u6D88\u8D39'),dataIndex:'b_AC',key:'b_AC',align:"center",width:150,render:function render(text,record,index){var title=['MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算','A/C  人均消费'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_AC',title:title,sqlName:"_5_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV ',_react2.default.createElement('br',null),'\u6536\u76CA'),dataIndex:'b_REV',key:'b_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算','REV  收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_REV',title:title,sqlName:"_5_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'Revenue Mix',_react2.default.createElement('br',null),' \u6536\u5165\u4EFD\u989D'),dataIndex:'b_revenue',key:'b_revenue',align:"center",width:150,render:function render(text,record,index){var title=['MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算','Revenue Mix  收入份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_revenue',title:title,sqlName:"_5_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost Amount ',_react2.default.createElement('br',null),' \u6210\u672C\u91D1\u989D'),dataIndex:'b_cost',key:'b_cost',align:"center",width:150,render:function render(text,record,index){var title=['MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算','Cost Amount  成本金额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_cost',title:title,sqlName:"_5_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'Cost %  ',_react2.default.createElement('br',null),' \u6210\u672C\u767E\u5206\u6BD4'),dataIndex:'b_cost_percent',key:'b_cost_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算','Cost %  成本百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_cost_percent',title:title,sqlName:"_5_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table5_1_2',style:{width:this.state.print?3200:'auto'}},_react2.default.createElement(_row2.default,null,'5.1.2 MTD - This Year Actual Vs. Last Year \u6708\u7D2F\u8BA1\u5B9E\u9645\u5BF9\u6BD4\u53BB\u5E74'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'table5_1_2',pagination:false,className:'content',style:{width:this.state.print?3150:'auto'},scroll:this.state.print?{}:{x:3150},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this3.setState({print:true,loading:true},function(){(0,_ExportExcel2.default)({id:"table5_1_2",date:date,name:"5.1.2 MTD - This Year Actual Vs. Last Year 月累计实际对比去年"});_this3.setState({print:false,loading:false});});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_5_1'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58'))),this.state.isEdit&&_react2.default.createElement(_reactRouterDom.Prompt,{message:'5.1.2 \u6570\u636E\u8FD8\u672A\u4FDD\u5B58,\u786E\u5B9A\u8981\u79BB\u5F00\u5417?'})));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(311);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _reactRouterDom=__webpack_require__(85);var _ExportExcel=__webpack_require__(79);var _ExportExcel2=_interopRequireDefault(_ExportExcel);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;function numChange(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var html=Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');return html;}var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.handleWindowClose=function(ev){var confirmationMessage="5.1.3 数据还未保存,确定要离开吗?";(ev||window.event).returnValue=confirmationMessage;if(_this.state.isEdit){return confirmationMessage;}};_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};// 计算total
var totalNameData=['covers','REV','cost','m_covers','m_REV','m_cost'];var _loop=function _loop(i){data[13][totalNameData[i]]=data.reduce(function(a,b,index){if(index!=13&&index!=14&&index!=15&&index!=16){a+=Number(b[totalNameData[i]]||'0');}return a;},0);data[13][totalNameData[i]]=data[13][totalNameData[i]].toFixed(0);};for(var i=0;i<totalNameData.length;i++){_loop(i);};for(var i=0;i<14;i++){data[i].business=(numConvert(data[13].covers)==0?0:numConvert(data[i].covers)/numConvert(data[13].covers)).toFixed(3);data[i].AC=(numConvert(data[i].covers)==0?0:numConvert(data[i].REV)/numConvert(data[i].covers)).toFixed(0);data[i].revenue=(numConvert(data[13].REV)==0?0:numConvert(data[i].REV)/numConvert(data[13].REV)).toFixed(3);data[i].cost_percent=(numConvert(data[i].REV)==0?0:numConvert(data[i].cost)/numConvert(data[i].REV)).toFixed(3);data[i].m_business=(numConvert(data[13].m_covers)==0?0:numConvert(data[i].m_covers)/numConvert(data[13].m_covers)).toFixed(3);data[i].m_AC=(numConvert(data[i].m_covers)==0?0:numConvert(data[i].m_REV)/numConvert(data[i].m_covers)).toFixed(0);data[i].m_revenue=(numConvert(data[13].m_REV)==0?0:numConvert(data[i].m_REV)/numConvert(data[13].m_REV)).toFixed(3);data[i].m_cost_percent=(numConvert(data[i].m_REV)==0?0:numConvert(data[i].m_cost)/numConvert(data[i].m_REV)).toFixed(3);data[i].b_covers=(numConvert(data[i].covers)-numConvert(data[i].m_covers)).toFixed(0);data[i].b_business=(numConvert(data[i].business)-numConvert(data[i].m_business)).toFixed(3);data[i].b_AC=(numConvert(data[i].AC)-numConvert(data[i].m_AC)).toFixed(0);data[i].b_REV=(numConvert(data[i].REV)-numConvert(data[i].m_REV)).toFixed(0);data[i].b_revenue=(numConvert(data[i].revenue)-numConvert(data[i].m_revenue)).toFixed(3);data[i].b_cost=(numConvert(data[i].cost)-numConvert(data[i].m_cost)).toFixed(0);data[i].b_cost_percent=(numConvert(data[i].cost_percent)-numConvert(data[i].m_cost_percent)).toFixed(3);}// 计算设施收入 其他收入 合计收入
data[16].REV=(numConvert(data[15].REV)+numConvert(data[14].REV)+numConvert(data[13].REV)).toFixed(0);data[16].m_REV=(numConvert(data[15].m_REV)+numConvert(data[14].m_REV)+numConvert(data[13].m_REV)).toFixed(0);data[14].b_REV=(numConvert(data[14].REV)-numConvert(data[14].m_REV)).toFixed(0);data[15].b_REV=(numConvert(data[15].REV)-numConvert(data[15].m_REV)).toFixed(0);data[16].b_REV=(numConvert(data[16].REV)-numConvert(data[16].m_REV)).toFixed(0);_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);_this.setState({isEdit:true});};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data3_2_1);var data=JSON.parse(dataBegin);fetch('/_5_1_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){fetch('/_5_1_3_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(d){return d.json();}).then(function(d){if(d.data&&d.data.length>0){data=d.data;}if(x.data&&x.data.length>0){data=data.map(function(z,i){return _extends({},z,{name:x.data[i].name,name_code:x.data[i].name_code});});}_this.setState({loading:false});_this.computeNum(data);});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month});});// if (!data.every(x => x.name)) {
//     message.error('名称不能为空，请到3-1-1设置名称！');
//     return
// }
var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_5_1_3',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false,isEdit:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);_this.props.onChange('update5_1_3',true);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table5_1_3',1.5,'5.13',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,isEdit:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);//在关闭页面时弹出确认提示窗口
window.addEventListener('beforeunload',this.handleWindowClose);}// 监测5.1.1保存情况
},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.update!=this.props.update&&nextProps.update){this.setState({data:[],loading:true});this.getDateData(this.state.date);this.props.onChange('update5_1',false);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('beforeunload',this.handleWindowClose);}},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print;var width=document.body.offsetWidth-3150>300?document.body.offsetWidth-3150:300;var noInputData=[13,14,15,16];var columns=[{title:'Outlets & Others 餐厅及其他',dataIndex:'name',key:'name',align:"center",fixed:!print&&"left",width:width,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' ',style:{textAlign:"left"}},text);}},{title:'YTD Actual - This Year 年累计实际-今年',width:1050,children:[{title:_react2.default.createElement('div',null,'Covers ',_react2.default.createElement('br',null),'\u4EBA\u6570'),dataIndex:'covers',key:'covers',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - This Year 年累计实际-今年','Covers 人数'];if(!noInputData.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'covers',title:title,sqlName:"_5_1_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('covers',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'covers',title:title,sqlName:"_5_1_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Business Mix ',_react2.default.createElement('br',null),'\u4E1A\u52A1\u4EFD\u989D'),dataIndex:'business',key:'business',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - This Year 年累计实际-今年','Business Mix 业务份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'business',title:title,sqlName:"_5_1_3",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'A/C ',_react2.default.createElement('br',null),'\u4EBA\u5747\u6D88\u8D39'),dataIndex:'AC',key:'AC',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - This Year 年累计实际-今年','A/C 人均消费'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'AC',title:title,sqlName:"_5_1_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV ',_react2.default.createElement('br',null),'\u6536\u76CA'),dataIndex:'REV',key:'REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - This Year 年累计实际-今年','REV 收益'];if((!noInputData.includes(index)||index==14||index==15)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'REV',title:title,sqlName:"_5_1_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('REV',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'REV',title:title,sqlName:"_5_1_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'Revenue Mix',_react2.default.createElement('br',null),' \u6536\u5165\u4EFD\u989D'),dataIndex:'revenue',key:'revenue',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - This Year 年累计实际-今年','Revenue Mix 收入份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revenue',title:title,sqlName:"_5_1_3",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost Amount ',_react2.default.createElement('br',null),' \u6210\u672C\u91D1\u989D'),dataIndex:'cost',key:'cost',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - This Year 年累计实际-今年','Cost Amount 成本金额'];if(!noInputData.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cost',title:title,sqlName:"_5_1_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('cost',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cost',title:title,sqlName:"_5_1_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'Cost %  ',_react2.default.createElement('br',null),' \u6210\u672C\u767E\u5206\u6BD4'),dataIndex:'cost_percent',key:'cost_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - This Year 年累计实际-今年','Cost % 成本百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cost_percent',title:title,sqlName:"_5_1_3",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]},{title:'YTD Budget - This Year 年累计预算-今年',width:1050,children:[{title:_react2.default.createElement('div',null,'Covers ',_react2.default.createElement('br',null),'\u4EBA\u6570'),dataIndex:'m_covers',key:'m_covers',align:"center",width:150,render:function render(text,record,index){var title=['YTD Budget - This Year 年累计预算-今年','Covers 人数'];if(!noInputData.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_covers',title:title,sqlName:"_5_1_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('m_covers',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_covers',title:title,sqlName:"_5_1_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},text));}}},{title:_react2.default.createElement('div',null,'Business Mix ',_react2.default.createElement('br',null),'\u4E1A\u52A1\u4EFD\u989D'),dataIndex:'m_business',key:'m_business',align:"center",width:150,render:function render(text,record,index){var title=['YTD Budget - This Year 年累计预算-今年','Business Mix 业务份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_business',title:title,sqlName:"_5_1_3",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'A/C ',_react2.default.createElement('br',null),'\u4EBA\u5747\u6D88\u8D39'),dataIndex:'m_AC',key:'m_AC',align:"center",width:150,render:function render(text,record,index){var title=['YTD Budget - This Year 年累计预算-今年','A/C 人均消费'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_AC',title:title,sqlName:"_5_1_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV ',_react2.default.createElement('br',null),'\u6536\u76CA'),dataIndex:'m_REV',key:'m_REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD Budget - This Year 年累计预算-今年','REV 收益'];if((!noInputData.includes(index)||index==14||index==15)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_REV',title:title,sqlName:"_5_1_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('m_REV',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_REV',title:title,sqlName:"_5_1_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'Revenue Mix',_react2.default.createElement('br',null),' \u6536\u5165\u4EFD\u989D'),dataIndex:'m_revenue',key:'m_revenue',align:"center",width:150,render:function render(text,record,index){var title=['YTD Budget - This Year 年累计预算-今年','Revenue Mix 收入份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_revenue',title:title,sqlName:"_5_1_3",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost Amount ',_react2.default.createElement('br',null),' \u6210\u672C\u91D1\u989D'),dataIndex:'m_cost',key:'m_cost',align:"center",width:150,render:function render(text,record,index){var title=['YTD Budget - This Year 年累计预算-今年','Cost Amount 成本金额'];if(!noInputData.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_cost',title:title,sqlName:"_5_1_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('m_cost',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_cost',title:title,sqlName:"_5_1_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'Cost %  ',_react2.default.createElement('br',null),' \u6210\u672C\u767E\u5206\u6BD4'),dataIndex:'m_cost_percent',key:'m_cost_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD Budget - This Year 年累计预算-今年','Cost % 成本百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_cost_percent',title:title,sqlName:"_5_1_3",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]},{title:'MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算',width:1050,children:[{title:_react2.default.createElement('div',null,'Covers ',_react2.default.createElement('br',null),'\u4EBA\u6570'),dataIndex:'b_covers',key:'b_covers',align:"center",width:150,render:function render(text,record,index){var title=['MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算','Covers 人数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_covers',title:title,sqlName:"_5_1_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'Business Mix ',_react2.default.createElement('br',null),'\u4E1A\u52A1\u4EFD\u989D'),dataIndex:'b_business',key:'b_business',align:"center",width:150,render:function render(text,record,index){var title=['MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算','Business Mix 业务份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_business',title:title,sqlName:"_5_1_3",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'A/C ',_react2.default.createElement('br',null),'\u4EBA\u5747\u6D88\u8D39'),dataIndex:'b_AC',key:'b_AC',align:"center",width:150,render:function render(text,record,index){var title=['MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算','A/C 人均消费'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_AC',title:title,sqlName:"_5_1_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV ',_react2.default.createElement('br',null),'\u6536\u76CA'),dataIndex:'b_REV',key:'b_REV',align:"center",width:150,render:function render(text,record,index){var title=['MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_REV',title:title,sqlName:"_5_1_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'Revenue Mix',_react2.default.createElement('br',null),' \u6536\u5165\u4EFD\u989D'),dataIndex:'b_revenue',key:'b_revenue',align:"center",width:150,render:function render(text,record,index){var title=['MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算','Revenue Mix 收入份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_revenue',title:title,sqlName:"_5_1_3",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost Amount ',_react2.default.createElement('br',null),' \u6210\u672C\u91D1\u989D'),dataIndex:'b_cost',key:'b_cost',align:"center",width:150,render:function render(text,record,index){var title=['MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算','Cost Amount 成本金额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_cost',title:title,sqlName:"_5_1_3",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'Cost %  ',_react2.default.createElement('br',null),' \u6210\u672C\u767E\u5206\u6BD4'),dataIndex:'b_cost_percent',key:'b_cost_percent',align:"center",width:150,render:function render(text,record,index){var title=['MTD Variance - Actual vs. Budget 月累计差异 - 实际对比预算','Cost % 成本百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_cost_percent',title:title,sqlName:"_5_1_3",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table5_1_3',style:{width:this.state.print?3200:'auto'}},_react2.default.createElement(_row2.default,null,'5.1.3 YTD - Actual Vs. Budget \u5E74\u7D2F\u8BA1 - \u5B9E\u9645\u5BF9\u6BD4\u9884\u7B97'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'table5_1_3',pagination:false,className:'content',style:{width:this.state.print?3150:'auto'},scroll:this.state.print?{}:{x:3150},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this2.setState({print:true,loading:true},function(){(0,_ExportExcel2.default)({id:"table5_1_3",date:date,name:"5.1.3 YTD - Actual Vs. Budget 年累计 - 实际对比预算"});_this2.setState({print:false,loading:false});});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_5_1'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58'))),this.state.isEdit&&_react2.default.createElement(_reactRouterDom.Prompt,{message:'5.1.3 \u6570\u636E\u8FD8\u672A\u4FDD\u5B58,\u786E\u5B9A\u8981\u79BB\u5F00\u5417?'})));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(311);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _reactRouterDom=__webpack_require__(85);var _ExportExcel=__webpack_require__(79);var _ExportExcel2=_interopRequireDefault(_ExportExcel);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;function numChange(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var html=Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');return html;}var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.handleWindowClose=function(ev){var confirmationMessage="5.1.4 数据还未保存,确定要离开吗?";(ev||window.event).returnValue=confirmationMessage;if(_this.state.isEdit){return confirmationMessage;}};_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};// 计算total
var totalNameData=['covers','REV','cost','m_covers','m_REV','m_cost'];var _loop=function _loop(i){data[13][totalNameData[i]]=data.reduce(function(a,b,index){if(index!=13&&index!=14&&index!=15&&index!=16){a+=Number(b[totalNameData[i]]||'0');}return a;},0);data[13][totalNameData[i]]=data[13][totalNameData[i]].toFixed(0);};for(var i=0;i<totalNameData.length;i++){_loop(i);};for(var i=0;i<14;i++){data[i].business=(numConvert(data[13].covers)==0?0:numConvert(data[i].covers)/numConvert(data[13].covers)).toFixed(3);data[i].AC=(numConvert(data[i].covers)==0?0:numConvert(data[i].REV)/numConvert(data[i].covers)).toFixed(0);data[i].revenue=(numConvert(data[13].REV)==0?0:numConvert(data[i].REV)/numConvert(data[13].REV)).toFixed(3);data[i].cost_percent=(numConvert(data[i].REV)==0?0:numConvert(data[i].cost)/numConvert(data[i].REV)).toFixed(3);data[i].m_business=(numConvert(data[13].m_covers)==0?0:numConvert(data[i].m_covers)/numConvert(data[13].m_covers)).toFixed(3);data[i].m_AC=(numConvert(data[i].m_covers)==0?0:numConvert(data[i].m_REV)/numConvert(data[i].m_covers)).toFixed(0);data[i].m_revenue=(numConvert(data[13].m_REV)==0?0:numConvert(data[i].m_REV)/numConvert(data[13].m_REV)).toFixed(3);data[i].m_cost_percent=(numConvert(data[i].m_REV)==0?0:numConvert(data[i].m_cost)/numConvert(data[i].m_REV)).toFixed(3);data[i].b_covers=(numConvert(data[i].covers)-numConvert(data[i].m_covers)).toFixed(0);data[i].b_business=(numConvert(data[i].business)-numConvert(data[i].m_business)).toFixed(3);data[i].b_AC=(numConvert(data[i].AC)-numConvert(data[i].m_AC)).toFixed(0);data[i].b_REV=(numConvert(data[i].REV)-numConvert(data[i].m_REV)).toFixed(0);data[i].b_revenue=(numConvert(data[i].revenue)-numConvert(data[i].m_revenue)).toFixed(3);data[i].b_cost=(numConvert(data[i].cost)-numConvert(data[i].m_cost)).toFixed(0);data[i].b_cost_percent=(numConvert(data[i].cost_percent)-numConvert(data[i].m_cost_percent)).toFixed(3);}// 计算设施收入 其他收入 合计收入
data[16].REV=(numConvert(data[15].REV)+numConvert(data[14].REV)+numConvert(data[13].REV)).toFixed(0);data[16].m_REV=(numConvert(data[15].m_REV)+numConvert(data[14].m_REV)+numConvert(data[13].m_REV)).toFixed(0);data[14].b_REV=(numConvert(data[14].REV)-numConvert(data[14].m_REV)).toFixed(0);data[15].b_REV=(numConvert(data[15].REV)-numConvert(data[15].m_REV)).toFixed(0);data[16].b_REV=(numConvert(data[16].REV)-numConvert(data[16].m_REV)).toFixed(0);_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);_this.setState({isEdit:true});};_this.getDateData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var dataBegin,data,d5_3,j5_3,d5_4,j5_4,lastd5_3,lastj5_3;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dataBegin=JSON.stringify(_data.data3_2_1);data=JSON.parse(dataBegin);_context.prev=2;_context.next=5;return fetch('/_5_1_3_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'});case 5:d5_3=_context.sent;_context.next=8;return d5_3.json();case 8:j5_3=_context.sent;_context.next=11;return fetch('/_5_1_4_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'});case 11:d5_4=_context.sent;_context.next=14;return d5_4.json();case 14:j5_4=_context.sent;_context.next=17;return fetch('/_5_1_3_info?year='+((0,_moment2.default)(date).format('YYYY')-1)+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'});case 17:lastd5_3=_context.sent;_context.next=20;return lastd5_3.json();case 20:lastj5_3=_context.sent;if(j5_4.data&&j5_4.data.length>0){data=j5_4.data;}if(j5_3.data&&j5_3.data.length>0){data=data.map(function(z,i){return _extends({},z,{name:j5_3.data[i].name,name_code:j5_3.data[i].name_code,covers:j5_3.data[i].covers,business:j5_3.data[i].business,AC:j5_3.data[i].AC,REV:j5_3.data[i].REV,revenue:j5_3.data[i].revenue,cost:j5_3.data[i].cost,cost_percent:j5_3.data[i].cost_percent});});}// 插入去年当月5——3数据
if(lastj5_3.data&&lastj5_3.data.length>0){data=data.map(function(z,i){if(z.name!=lastj5_3.data[i].name){return _extends({},z);}return _extends({},z,{m_covers:z.m_covers!=0?z.m_covers:lastj5_3.data[i].covers,m_business:z.m_business!=0?z.m_business:lastj5_3.data[i].business,m_AC:z.m_AC!=0?z.m_AC:lastj5_3.data[i].AC,m_REV:z.m_REV!=0?z.m_REV:lastj5_3.data[i].REV,m_revenue:z.m_revenue!=0?z.m_revenue:lastj5_3.data[i].revenue,m_cost:z.m_cost!=0?z.m_cost:lastj5_3.data[i].cost,m_cost_percent:z.m_cost_percent!=0?z.m_cost_percent:lastj5_3.data[i].cost_percent});});}_this.setState({loading:false});_this.computeNum(data);_context.next=32;break;case 28:_context.prev=28;_context.t0=_context['catch'](2);console.log(_context.t0);_this.setState({loading:false});case 32:case'end':return _context.stop();}}},_callee,_this2,[[2,28]]);}));return function(_x3){return _ref.apply(this,arguments);};}();_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month});});// if (!data.every(x => x.name)) {
//     message.error('名称不能为空，请到3-1-1设置名称！');
//     return
// }
var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_5_1_4',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false,isEdit:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table5_1_4',1.5,'5.14',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,isEdit:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);//在关闭页面时弹出确认提示窗口
window.addEventListener('beforeunload',this.handleWindowClose);}// 监测5.1.3保存情况
},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.update!=this.props.update&&nextProps.update){this.setState({data:[],loading:true});this.getDateData(this.state.date);this.props.onChange('update5_1_3',false);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('beforeunload',this.handleWindowClose);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print;var width=document.body.offsetWidth-3150>300?document.body.offsetWidth-3150:300;var noInputData=[13,14,15,16];var columns=[{title:'Outlets & Others 餐厅及其他',dataIndex:'name',key:'name',align:"center",fixed:!print&&"left",width:width,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' ',style:{textAlign:"left"}},text);}},{title:'YTD Actual - This Year 年累计实际-今年',width:1050,children:[{title:_react2.default.createElement('div',null,'Covers ',_react2.default.createElement('br',null),'\u4EBA\u6570'),dataIndex:'covers',key:'covers',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - This Year 年累计实际-今年','Covers 人数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'covers',title:title,sqlName:"_5_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Business Mix ',_react2.default.createElement('br',null),'\u4E1A\u52A1\u4EFD\u989D'),dataIndex:'business',key:'business',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - This Year 年累计实际-今年','Business Mix 业务份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'business',title:title,sqlName:"_5_1_4",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'A/C ',_react2.default.createElement('br',null),'\u4EBA\u5747\u6D88\u8D39'),dataIndex:'AC',key:'AC',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - This Year 年累计实际-今年','A/C 人均消费'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'AC',title:title,sqlName:"_5_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV ',_react2.default.createElement('br',null),'\u6536\u76CA'),dataIndex:'REV',key:'REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - This Year 年累计实际-今年','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'REV',title:title,sqlName:"_5_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'Revenue Mix',_react2.default.createElement('br',null),' \u6536\u5165\u4EFD\u989D'),dataIndex:'revenue',key:'revenue',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - This Year 年累计实际-今年','Revenue Mix 收入份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revenue',title:title,sqlName:"_5_1_4",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost Amount ',_react2.default.createElement('br',null),' \u6210\u672C\u91D1\u989D'),dataIndex:'cost',key:'cost',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - This Year 年累计实际-今年','Cost Amount 成本金额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cost',title:title,sqlName:"_5_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'Cost %  ',_react2.default.createElement('br',null),' \u6210\u672C\u767E\u5206\u6BD4'),dataIndex:'cost_percent',key:'cost_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - This Year 年累计实际-今年','Cost % 成本百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cost_percent',title:title,sqlName:"_5_1_4",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]},{title:'YTD Actual - Last Year 年累计实际-去年',width:1050,children:[{title:_react2.default.createElement('div',null,'Covers ',_react2.default.createElement('br',null),'\u4EBA\u6570'),dataIndex:'m_covers',key:'m_covers',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - Last Year 年累计实际-去年','Covers 人数'];if(!noInputData.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_covers',title:title,sqlName:"_5_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this3.onChange('m_covers',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_covers',title:title,sqlName:"_5_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},text));}}},{title:_react2.default.createElement('div',null,'Business Mix ',_react2.default.createElement('br',null),'\u4E1A\u52A1\u4EFD\u989D'),dataIndex:'m_business',key:'m_business',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - Last Year 年累计实际-去年','Business Mix 业务份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_business',title:title,sqlName:"_5_1_4",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'A/C ',_react2.default.createElement('br',null),'\u4EBA\u5747\u6D88\u8D39'),dataIndex:'m_AC',key:'m_AC',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - Last Year 年累计实际-去年','A/C 人均消费'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_AC',title:title,sqlName:"_5_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV ',_react2.default.createElement('br',null),'\u6536\u76CA'),dataIndex:'m_REV',key:'m_REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - Last Year 年累计实际-去年','REV 收益'];if((!noInputData.includes(index)||index==14||index==15)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_REV',title:title,sqlName:"_5_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this3.onChange('m_REV',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_REV',title:title,sqlName:"_5_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'Revenue Mix',_react2.default.createElement('br',null),' \u6536\u5165\u4EFD\u989D'),dataIndex:'m_revenue',key:'m_revenue',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - Last Year 年累计实际-去年','Revenue Mix 收入份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_revenue',title:title,sqlName:"_5_1_4",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost Amount ',_react2.default.createElement('br',null),' \u6210\u672C\u91D1\u989D'),dataIndex:'m_cost',key:'m_cost',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - Last Year 年累计实际-去年','Cost Amount 成本金额'];if(!noInputData.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_cost',title:title,sqlName:"_5_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this3.onChange('m_cost',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_cost',title:title,sqlName:"_5_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'Cost %  ',_react2.default.createElement('br',null),' \u6210\u672C\u767E\u5206\u6BD4'),dataIndex:'m_cost_percent',key:'m_cost_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - Last Year 年累计实际-去年','Cost % 成本百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_cost_percent',title:title,sqlName:"_5_1_4",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]},{title:'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',width:1050,children:[{title:_react2.default.createElement('div',null,'Covers ',_react2.default.createElement('br',null),'\u4EBA\u6570'),dataIndex:'b_covers',key:'b_covers',align:"center",width:150,render:function render(text,record,index){var title=['YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','Covers 人数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_covers',title:title,sqlName:"_5_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'Business Mix ',_react2.default.createElement('br',null),'\u4E1A\u52A1\u4EFD\u989D'),dataIndex:'b_business',key:'b_business',align:"center",width:150,render:function render(text,record,index){var title=['YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','Business Mix 业务份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_business',title:title,sqlName:"_5_1_4",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'A/C ',_react2.default.createElement('br',null),'\u4EBA\u5747\u6D88\u8D39'),dataIndex:'b_AC',key:'b_AC',align:"center",width:150,render:function render(text,record,index){var title=['YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','A/C 人均消费'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_AC',title:title,sqlName:"_5_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV ',_react2.default.createElement('br',null),'\u6536\u76CA'),dataIndex:'b_REV',key:'b_REV',align:"center",width:150,render:function render(text,record,index){var title=['YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_REV',title:title,sqlName:"_5_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'Revenue Mix',_react2.default.createElement('br',null),' \u6536\u5165\u4EFD\u989D'),dataIndex:'b_revenue',key:'b_revenue',align:"center",width:150,render:function render(text,record,index){var title=['YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','Revenue Mix 收入份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_revenue',title:title,sqlName:"_5_1_4",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost Amount ',_react2.default.createElement('br',null),' \u6210\u672C\u91D1\u989D'),dataIndex:'b_cost',key:'b_cost',align:"center",width:150,render:function render(text,record,index){var title=['YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','Cost Amount 成本金额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_cost',title:title,sqlName:"_5_1_4",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'Cost %  ',_react2.default.createElement('br',null),' \u6210\u672C\u767E\u5206\u6BD4'),dataIndex:'b_cost_percent',key:'b_cost_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','Cost % 成本百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_cost_percent',title:title,sqlName:"_5_1_4",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table5_1_4',style:{width:this.state.print?3200:'auto'}},_react2.default.createElement(_row2.default,null,'5.1.4 YTD - Actual Vs. Last Year \u5E74\u7D2F\u8BA1 - \u5B9E\u9645\u5BF9\u6BD4\u53BB\u5E74'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'table5_1_4',pagination:false,className:'content',style:{width:this.state.print?3150:'auto'},scroll:this.state.print?{}:{x:3150},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this3.setState({print:true,loading:true},function(){(0,_ExportExcel2.default)({id:"table5_1_4",date:date,name:"5.1.4 YTD - Actual Vs. Last Year 年累计 - 实际对比去年"});_this3.setState({print:false,loading:false});});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_5_1'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58'))),this.state.isEdit&&_react2.default.createElement(_reactRouterDom.Prompt,{message:'5.1.4 \u6570\u636E\u8FD8\u672A\u4FDD\u5B58,\u786E\u5B9A\u8981\u79BB\u5F00\u5417?'})));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextArea=_input2.default.TextArea;var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getNote=function(date){fetch('/_5_1_5_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){var note={};if(x.data&&x.data.length>0){note=_extends({},x.data[0]);}_this.setState({loading:false,note:note});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSaveNote=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=[_extends({},_this.state.note,{year:year,month:month})];var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_5_1_5',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getNote(_this.state.date);}return;}_message3.default.error('备注保存失败：'+x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table5_1_5',1.5,'5.15',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),note:{note:""},loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getNote(this.state.date);}},{key:'render',value:function render(){var _this2=this;return _react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement(_row2.default,{className:'title',id:'table5_1_5'},_react2.default.createElement(_row2.default,{style:{margin:"20px 0"}},_react2.default.createElement(_row2.default,{style:{margin:"10px 0"}},'5.1.5  Please critique if variance above +/- 5% \u82E5\u5DEE\u5F02\u6570\u8D85\u8FC7\u4E0A\u4E0B\u767E\u5206\u4E4B\u4E94\u5219\u9700\u505A\u51FA\u4E66\u9762\u89E3\u91CA'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,loading:true,note:{}});_this2.getNote(str);}})),_react2.default.createElement(TextArea,{autosize:{minRows:4},style:{marginTop:20},placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',value:this.state.note.note,onChange:function onChange(e){_this2.setState({note:_extends({},_this2.state.note,{note:e.target.value})});}}))),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_5_1'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSaveNote,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _=__webpack_require__(1918);var _2=_interopRequireDefault(_);var _3=__webpack_require__(1919);var _4=_interopRequireDefault(_3);var _5=__webpack_require__(1920);var _6=_interopRequireDefault(_5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.onChange=function(value){_this.setState({update:value});};_this.state={update:false};return _this;}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",null,_react2.default.createElement(_row2.default,{style:{margin:"24px 0 24px 24px",fontSize:22,color:"#333"}},"5.2 Three Months Rolling Forecast \u540E\u4E09\u4E2A\u6708\u6EDA\u52A8\u9884\u6D4B"),_react2.default.createElement(_2.default,Object.assign({},this.props,{onChange:this.onChange})),_react2.default.createElement(_4.default,Object.assign({},this.props,{onChange:this.onChange,update:this.state.update})),_react2.default.createElement(_6.default,this.props));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _alert=__webpack_require__(83);var _alert2=_interopRequireDefault(_alert);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(84);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(699);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _IsLableAuth=__webpack_require__(107);var _IsLableAuth2=_interopRequireDefault(_IsLableAuth);var _ExportExcel=__webpack_require__(79);var _ExportExcel2=_interopRequireDefault(_ExportExcel);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;function numChange(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var html=Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');return html;}var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};// 计算total
var totalNameData=['covers','REV','cost','m_covers','m_REV','m_cost','b_covers','b_REV','b_cost'];var _loop=function _loop(i){data[13][totalNameData[i]]=data.reduce(function(a,b,index){if(index!=13&&index!=14&&index!=15&&index!=16){a+=Number(b[totalNameData[i]]||'0');}return a;},0);data[13][totalNameData[i]]=data[13][totalNameData[i]].toFixed(0);};for(var i=0;i<totalNameData.length;i++){_loop(i);};for(var i=0;i<14;i++){data[i].business=(numConvert(data[13].covers)==0?0:numConvert(data[i].covers)/numConvert(data[13].covers)).toFixed(3);data[i].AC=(numConvert(data[i].covers)==0?0:numConvert(data[i].REV)/numConvert(data[i].covers)).toFixed(0);data[i].revenue=(numConvert(data[13].REV)==0?0:numConvert(data[i].REV)/numConvert(data[13].REV)).toFixed(3);data[i].cost_percent=(numConvert(data[i].REV)==0?0:numConvert(data[i].cost)/numConvert(data[i].REV)).toFixed(3);data[i].m_business=(numConvert(data[13].m_covers)==0?0:numConvert(data[i].m_covers)/numConvert(data[13].m_covers)).toFixed(3);data[i].m_AC=(numConvert(data[i].m_covers)==0?0:numConvert(data[i].m_REV)/numConvert(data[i].m_covers)).toFixed(0);data[i].m_revenue=(numConvert(data[13].m_REV)==0?0:numConvert(data[i].m_REV)/numConvert(data[13].m_REV)).toFixed(3);data[i].m_cost_percent=(numConvert(data[i].m_REV)==0?0:numConvert(data[i].m_cost)/numConvert(data[i].m_REV)).toFixed(3);// data[i].b_covers = (numConvert(data[i].covers) - numConvert(data[i].m_covers)).toFixed(0);
data[i].b_business=(numConvert(data[13].b_covers)==0?0:numConvert(data[i].b_covers)/numConvert(data[13].b_covers)).toFixed(3);data[i].b_AC=(numConvert(data[i].b_covers)==0?0:numConvert(data[i].b_REV)/numConvert(data[i].b_covers)).toFixed(0);// data[i].b_REV = (numConvert(data[i].REV) - numConvert(data[i].m_REV)).toFixed(0);
data[i].b_revenue=(numConvert(data[13].b_REV)==0?0:numConvert(data[i].b_REV)/numConvert(data[13].b_REV)).toFixed(3);// data[i].b_cost = (numConvert(data[i].cost) - numConvert(data[i].m_cost)).toFixed(0);
data[i].b_cost_percent=(numConvert(data[i].b_REV)==0?0:numConvert(data[i].b_cost)/numConvert(data[i].b_REV)).toFixed(3);}// 计算设施收入 其他收入 合计收入
data[16].REV=(numConvert(data[15].REV)+numConvert(data[14].REV)+numConvert(data[13].REV)).toFixed(0);data[16].m_REV=(numConvert(data[15].m_REV)+numConvert(data[14].m_REV)+numConvert(data[13].m_REV)).toFixed(0);// data[14].b_REV = (numConvert(data[14].REV) - numConvert(data[14].m_REV)).toFixed(0);
// data[15].b_REV = (numConvert(data[15].REV) - numConvert(data[15].m_REV)).toFixed(0);
data[16].b_REV=(numConvert(data[13].b_REV)+numConvert(data[14].b_REV)+numConvert(data[15].b_REV)).toFixed(0);_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data3_2_1);var data=JSON.parse(dataBegin);fetch('/_5_2_1_all?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data5_2&&x.data.data5_2.length>0){data=x.data.data5_2;}if(x.data.data5_1&&x.data.data5_1.length>0){data=data.map(function(z,i){return _extends({},z,{name:x.data.data5_1[i].name,name_code:x.data.data5_1[i].name_code});});}// 自动填充所需要的上个月数据
if(x.data.datalast&&x.data.datalast.length>0&&!data[0].id){var datalast=x.data.datalast;var listName=['covers','business','AC','REV','revenue','cost','cost_percent'];data.forEach(function(item,i){listName.forEach(function(name){data[i][name]=data[i][name]!=0?data[i][name]:datalast[i]['m_'+name];data[i]['m_'+name]=data[i]['m_'+name]!=0?data[i]['m_'+name]:datalast[i]['b_'+name];});});}_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month});});// if (!data.every(x => x.name)) {
//     message.error('名称不能为空，请到3-1-1设置名称！');
//     return
// }
var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_5_2_1',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}_this.props.onChange(true);return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table5_2_1',1.5,'5.21',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);// this.computeNum(this.state.data)
}},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print;var width=document.body.offsetWidth-3150>300?document.body.offsetWidth-3150:300;var noInputData=[13,14,15,16];var columns=[{title:'Outlets & Others 餐厅及其他',dataIndex:'name',key:'name',align:"center",fixed:!print&&"left",width:width,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' ',style:{textAlign:"left"}},text);}},{title:'Next Month 下个月',children:[{title:_react2.default.createElement('div',null,'Covers ',_react2.default.createElement('br',null),'\u4EBA\u6570'),dataIndex:'covers',key:'covers',align:"center",width:150,render:function render(text,record,index){var title=['Next Month 下个月','Covers 人数'];if(!noInputData.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'covers',title:title,sqlName:"_5_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('covers',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'covers',title:title,sqlName:"_5_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Business Mix ',_react2.default.createElement('br',null),'\u4E1A\u52A1\u4EFD\u989D'),dataIndex:'business',key:'business',align:"center",width:150,render:function render(text,record,index){var title=['Next Month 下个月','Business Mix 业务份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'business',title:title,sqlName:"_5_2_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'A/C ',_react2.default.createElement('br',null),'\u4EBA\u5747\u6D88\u8D39'),dataIndex:'AC',key:'AC',align:"center",width:150,render:function render(text,record,index){var title=['Next Month 下个月','A/C 人均消费'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'AC',title:title,sqlName:"_5_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV ',_react2.default.createElement('br',null),'\u6536\u76CA'),dataIndex:'REV',key:'REV',align:"center",width:150,render:function render(text,record,index){var title=['Next Month 下个月','REV 收益'];if((!noInputData.includes(index)||index==14||index==15)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'REV',title:title,sqlName:"_5_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('REV',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'REV',title:title,sqlName:"_5_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'Revenue Mix',_react2.default.createElement('br',null),' \u6536\u5165\u4EFD\u989D'),dataIndex:'revenue',key:'revenue',align:"center",width:150,render:function render(text,record,index){var title=['Next Month 下个月','Revenue Mix 收入份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revenue',title:title,sqlName:"_5_2_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost Amount ',_react2.default.createElement('br',null),' \u6210\u672C\u91D1\u989D'),dataIndex:'cost',key:'cost',align:"center",width:150,render:function render(text,record,index){var title=['Next Month 下个月','Cost Amount 成本金额'];if(!noInputData.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cost',title:title,sqlName:"_5_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('cost',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cost',title:title,sqlName:"_5_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'Cost %  ',_react2.default.createElement('br',null),' \u6210\u672C\u767E\u5206\u6BD4'),dataIndex:'cost_percent',key:'cost_percent',align:"center",width:150,render:function render(text,record,index){var title=['Next Month 下个月','Cost % 成本百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cost_percent',title:title,sqlName:"_5_2_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]},{title:'3rd Month 第三个月',children:[{title:_react2.default.createElement('div',null,'Covers ',_react2.default.createElement('br',null),'\u4EBA\u6570'),dataIndex:'m_covers',key:'m_covers',align:"center",width:150,render:function render(text,record,index){var title=['3rd Month 第三个月','Covers 人数'];if(!noInputData.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_covers',title:title,sqlName:"_5_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('m_covers',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_covers',title:title,sqlName:"_5_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},text));}}},{title:_react2.default.createElement('div',null,'Business Mix ',_react2.default.createElement('br',null),'\u4E1A\u52A1\u4EFD\u989D'),dataIndex:'m_business',key:'m_business',align:"center",width:150,render:function render(text,record,index){var title=['3rd Month 第三个月','Business Mix 业务份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_business',title:title,sqlName:"_5_2_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'A/C ',_react2.default.createElement('br',null),'\u4EBA\u5747\u6D88\u8D39'),dataIndex:'m_AC',key:'m_AC',align:"center",width:150,render:function render(text,record,index){var title=['3rd Month 第三个月','A/C 人均消费'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_AC',title:title,sqlName:"_5_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV ',_react2.default.createElement('br',null),'\u6536\u76CA'),dataIndex:'m_REV',key:'m_REV',align:"center",width:150,render:function render(text,record,index){var title=['3rd Month 第三个月','REV 收益'];if((!noInputData.includes(index)||index==14||index==15)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_REV',title:title,sqlName:"_5_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('m_REV',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_REV',title:title,sqlName:"_5_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'Revenue Mix',_react2.default.createElement('br',null),' \u6536\u5165\u4EFD\u989D'),dataIndex:'m_revenue',key:'m_revenue',align:"center",width:150,render:function render(text,record,index){var title=['3rd Month 第三个月','Revenue Mix 收入份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_revenue',title:title,sqlName:"_5_2_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost Amount ',_react2.default.createElement('br',null),' \u6210\u672C\u91D1\u989D'),dataIndex:'m_cost',key:'m_cost',align:"center",width:150,render:function render(text,record,index){var title=['3rd Month 第三个月','Cost Amount 成本金额'];if(!noInputData.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_cost',title:title,sqlName:"_5_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('m_cost',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_cost',title:title,sqlName:"_5_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'Cost %  ',_react2.default.createElement('br',null),' \u6210\u672C\u767E\u5206\u6BD4'),dataIndex:'m_cost_percent',key:'m_cost_percent',align:"center",width:150,render:function render(text,record,index){var title=['3rd Month 第三个月','Cost % 成本百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_cost_percent',title:title,sqlName:"_5_2_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]},{title:'4th Month 第四个月',children:[{title:_react2.default.createElement('div',null,'Covers ',_react2.default.createElement('br',null),'\u4EBA\u6570'),dataIndex:'b_covers',key:'b_covers',align:"center",width:150,render:function render(text,record,index){var title=['4th Month 第四个月','Covers 人数'];if(!noInputData.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_covers',title:title,sqlName:"_5_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('b_covers',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_covers',title:title,sqlName:"_5_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Business Mix ',_react2.default.createElement('br',null),'\u4E1A\u52A1\u4EFD\u989D'),dataIndex:'b_business',key:'b_business',align:"center",width:150,render:function render(text,record,index){var title=['4th Month 第四个月','Business Mix 业务份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_business',title:title,sqlName:"_5_2_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'A/C ',_react2.default.createElement('br',null),'\u4EBA\u5747\u6D88\u8D39'),dataIndex:'b_AC',key:'b_AC',align:"center",width:150,render:function render(text,record,index){var title=['4th Month 第四个月','A/C 人均消费'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_AC',title:title,sqlName:"_5_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV ',_react2.default.createElement('br',null),'\u6536\u76CA'),dataIndex:'b_REV',key:'b_REV',align:"center",width:150,render:function render(text,record,index){var title=['4th Month 第四个月','REV 收益'];if((!noInputData.includes(index)||index==14||index==15)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_REV',title:title,sqlName:"_5_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('b_REV',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_REV',title:title,sqlName:"_5_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Revenue Mix',_react2.default.createElement('br',null),' \u6536\u5165\u4EFD\u989D'),dataIndex:'b_revenue',key:'b_revenue',align:"center",width:150,render:function render(text,record,index){var title=['4th Month 第四个月','Revenue Mix 收入份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_revenue',title:title,sqlName:"_5_2_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost Amount ',_react2.default.createElement('br',null),' \u6210\u672C\u91D1\u989D'),dataIndex:'b_cost',key:'b_cost',align:"center",width:150,render:function render(text,record,index){var title=['4th Month 第四个月','Cost Amount 成本金额'];if(!noInputData.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_cost',title:title,sqlName:"_5_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('b_cost',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_cost',title:title,sqlName:"_5_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Cost %  ',_react2.default.createElement('br',null),' \u6210\u672C\u767E\u5206\u6BD4'),dataIndex:'b_cost_percent',key:'b_cost_percent',align:"center",width:150,render:function render(text,record,index){var title=['4th Month 第四个月','Cost  成本百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_cost_percent',title:title,sqlName:"_5_2_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1',id:'table5_2_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table5_2_1',style:{width:this.state.print?3500:'auto'}},_react2.default.createElement(_row2.default,null,'5.2.1 Three Months Rolling Forecast By Outlets & Others \u6309\u9910\u5385\u53CA\u5176\u4ED6\u7EC6\u5206\u540E\u4E09\u4E2A\u6708\u6EDA\u52A8\u9884\u6D4B'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,id:'export5_2_1',className:'content',style:{width:this.state.print?3450:'auto'},scroll:this.state.print?{}:{x:3450,y:550},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_alert2.default,{message:_react2.default.createElement('div',null,'\u8868\u683C\u5173\u8054',_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:'read_5_1'},this.props,{path:'/table/5_1'}),'5.1')),type:'info',showIcon:true,style:{display:"inline-block",marginRight:10}}),_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this2.setState({print:true,loading:true},function(){(0,_ExportExcel2.default)({id:"export5_2_1",date:date,name:"5.2.1 Three Months Rolling Forecast By Outlets & Others 按餐厅及其他细分后三个月滚动预测"});_this2.setState({print:false,loading:false});});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_5_2'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _alert=__webpack_require__(83);var _alert2=_interopRequireDefault(_alert);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(84);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _data=__webpack_require__(699);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _IsLableAuth=__webpack_require__(107);var _IsLableAuth2=_interopRequireDefault(_IsLableAuth);var _ExportExcel=__webpack_require__(79);var _ExportExcel2=_interopRequireDefault(_ExportExcel);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;function numChange(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var html=Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');return html;}function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};// 计算total
var totalNameData=['covers','REV','cost','m_covers','m_REV','m_cost'];var _loop=function _loop(i){data[13][totalNameData[i]]=data.reduce(function(a,b,index){if(index!=13&&index!=14&&index!=15&&index!=16){a+=Number(b[totalNameData[i]]||'0');}return a;},0);data[13][totalNameData[i]]=data[13][totalNameData[i]].toFixed(0);};for(var i=0;i<totalNameData.length;i++){_loop(i);};for(var i=0;i<14;i++){data[i].business=(numConvert(data[13].covers)==0?0:numConvert(data[i].covers)/numConvert(data[13].covers)).toFixed(3);data[i].AC=(numConvert(data[i].covers)==0?0:numConvert(data[i].REV)/numConvert(data[i].covers)).toFixed(0);data[i].revenue=(numConvert(data[13].REV)==0?0:numConvert(data[i].REV)/numConvert(data[13].REV)).toFixed(3);data[i].cost_percent=(numConvert(data[i].REV)==0?0:numConvert(data[i].cost)/numConvert(data[i].REV)).toFixed(3);data[i].m_business=(numConvert(data[13].m_covers)==0?0:numConvert(data[i].m_covers)/numConvert(data[13].m_covers)).toFixed(3);data[i].m_AC=(numConvert(data[i].m_covers)==0?0:numConvert(data[i].m_REV)/numConvert(data[i].m_covers)).toFixed(0);data[i].m_revenue=(numConvert(data[13].m_REV)==0?0:numConvert(data[i].m_REV)/numConvert(data[13].m_REV)).toFixed(3);data[i].m_cost_percent=(numConvert(data[i].m_REV)==0?0:numConvert(data[i].m_cost)/numConvert(data[i].m_REV)).toFixed(3);data[i].b_covers=(numConvert(data[i].covers)-numConvert(data[i].m_covers)).toFixed(0);data[i].b_business=(numConvert(data[i].business)-numConvert(data[i].m_business)).toFixed(3);data[i].b_AC=(numConvert(data[i].AC)-numConvert(data[i].m_AC)).toFixed(0);data[i].b_REV=(numConvert(data[i].REV)-numConvert(data[i].m_REV)).toFixed(0);data[i].b_revenue=(numConvert(data[i].revenue)-numConvert(data[i].m_revenue)).toFixed(3);data[i].b_cost=(numConvert(data[i].cost)-numConvert(data[i].m_cost)).toFixed(0);data[i].b_cost_percent=(numConvert(data[i].cost_percent)-numConvert(data[i].m_cost_percent)).toFixed(3);}// 计算设施收入 其他收入 合计收入
data[16].REV=(numConvert(data[15].REV)+numConvert(data[14].REV)+numConvert(data[13].REV)).toFixed(0);data[16].m_REV=(numConvert(data[15].m_REV)+numConvert(data[14].m_REV)+numConvert(data[13].m_REV)).toFixed(0);data[14].b_REV=(numConvert(data[14].REV)-numConvert(data[14].m_REV)).toFixed(0);data[15].b_REV=(numConvert(data[15].REV)-numConvert(data[15].m_REV)).toFixed(0);data[16].b_REV=(numConvert(data[16].REV)-numConvert(data[16].m_REV)).toFixed(0);_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data3_2_1);var data=JSON.parse(dataBegin);fetch('/_5_2_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){fetch('/_5_2_2_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(d){return d.json();}).then(function(d){if(d.data&&d.data.length>0){data=d.data;}if(x.data&&x.data.length>0){data=data.map(function(z,i){return _extends({},z,{name:x.data[i].name,name_code:x.data[i].name_code,covers:(numConvert(x.data[i].covers)+numConvert(x.data[i].m_covers)+numConvert(x.data[i].b_covers)).toFixed(0),business:x.data[i].business,AC:x.data[i].AC,REV:(numConvert(x.data[i].REV)+numConvert(x.data[i].m_REV)+numConvert(x.data[i].b_REV)).toFixed(0),revenue:x.data[i].revenue,cost:(numConvert(x.data[i].cost)+numConvert(x.data[i].m_cost)+numConvert(x.data[i].b_cost)).toFixed(0),cost_percent:x.data[i].cost_percent});});}_this.setState({loading:false});_this.computeNum(data);});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month});});// if (!data.every(x => x.name)) {
//     message.error('名称不能为空，请到3-1-1设置名称！');
//     return
// }
var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_5_2_2',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table5_2_2',1.5,'5.22',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);// this.computeNum(this.state.data)
}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){// 检测5_2_1保存情况
if(nextProps.update!=this.props.update&&nextProps.update){this.setState({data:[],loading:true});this.getDateData(this.state.date);this.props.onChange(false);}}},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,print=_state.print,date=_state.date;var width=document.body.offsetWidth-3150>300?document.body.offsetWidth-3150:300;var noInputData=[13,14,15,16];var columns=[{title:'Outlets & Others 餐厅及其他',dataIndex:'name',key:'name',align:"center",fixed:!print&&"left",width:width,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' ',style:{textAlign:"left"}},text);}},{title:'3 Months Forecast Total 后三个月预测合计',width:1050,children:[{title:_react2.default.createElement('div',null,'Covers ',_react2.default.createElement('br',null),'\u4EBA\u6570'),dataIndex:'covers',key:'covers',align:"center",width:150,render:function render(text,record,index){var title=['3 Months Forecast Total 后三个月预测合计','Covers 人数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'covers',title:title,sqlName:"_5_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Business Mix ',_react2.default.createElement('br',null),'\u4E1A\u52A1\u4EFD\u989D'),dataIndex:'business',key:'business',align:"center",width:150,render:function render(text,record,index){var title=['3 Months Forecast Total 后三个月预测合计','Business Mix 业务份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'business',title:title,sqlName:"_5_2_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'A/C ',_react2.default.createElement('br',null),'\u4EBA\u5747\u6D88\u8D39'),dataIndex:'AC',key:'AC',align:"center",width:150,render:function render(text,record,index){var title=['3 Months Forecast Total 后三个月预测合计','A/C 人均消费'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'AC',title:title,sqlName:"_5_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV ',_react2.default.createElement('br',null),'\u6536\u76CA'),dataIndex:'REV',key:'REV',align:"center",width:150,render:function render(text,record,index){var title=['3 Months Forecast Total 后三个月预测合计','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'REV',title:title,sqlName:"_5_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'Revenue Mix',_react2.default.createElement('br',null),' \u6536\u5165\u4EFD\u989D'),dataIndex:'revenue',key:'revenue',align:"center",width:150,render:function render(text,record,index){var title=['3 Months Forecast Total 后三个月预测合计','Revenue Mix 收入份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'revenue',title:title,sqlName:"_5_2_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost Amount ',_react2.default.createElement('br',null),' \u6210\u672C\u91D1\u989D'),dataIndex:'cost',key:'cost',align:"center",width:150,render:function render(text,record,index){var title=['3 Months Forecast Total 后三个月预测合计','Cost Amount 成本金额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cost',title:title,sqlName:"_5_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'Cost %  ',_react2.default.createElement('br',null),' \u6210\u672C\u767E\u5206\u6BD4'),dataIndex:'cost_percent',key:'cost_percent',align:"center",width:150,render:function render(text,record,index){var title=['3 Months Forecast Total 后三个月预测合计','Cost % 成本百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cost_percent',title:title,sqlName:"_5_2_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]},{title:'3 Months Budget Total 后三个月预算合计',width:1050,children:[{title:_react2.default.createElement('div',null,'Covers ',_react2.default.createElement('br',null),'\u4EBA\u6570'),dataIndex:'m_covers',key:'m_covers',align:"center",width:150,render:function render(text,record,index){var title=['3 Months Budget Total 后三个月预算合计','Covers 人数'];if(!noInputData.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_covers',title:title,sqlName:"_5_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('m_covers',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_covers',title:title,sqlName:"_5_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},text));}}},{title:_react2.default.createElement('div',null,'Business Mix ',_react2.default.createElement('br',null),'\u4E1A\u52A1\u4EFD\u989D'),dataIndex:'m_business',key:'m_business',align:"center",width:150,render:function render(text,record,index){var title=['3 Months Budget Total 后三个月预算合计','Business Mix 业务份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_business',title:title,sqlName:"_5_2_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'A/C ',_react2.default.createElement('br',null),'\u4EBA\u5747\u6D88\u8D39'),dataIndex:'m_AC',key:'m_AC',align:"center",width:150,render:function render(text,record,index){var title=['3 Months Budget Total 后三个月预算合计','A/C 人均消费'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_AC',title:title,sqlName:"_5_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV ',_react2.default.createElement('br',null),'\u6536\u76CA'),dataIndex:'m_REV',key:'m_REV',align:"center",width:150,render:function render(text,record,index){var title=['3 Months Budget Total 后三个月预算合计','REV 收益'];if((!noInputData.includes(index)||index==14||index==15)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_REV',title:title,sqlName:"_5_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('m_REV',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_REV',title:title,sqlName:"_5_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'Revenue Mix',_react2.default.createElement('br',null),' \u6536\u5165\u4EFD\u989D'),dataIndex:'m_revenue',key:'m_revenue',align:"center",width:150,render:function render(text,record,index){var title=['3 Months Budget Total 后三个月预算合计','Revenue Mix 收入份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_revenue',title:title,sqlName:"_5_2_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost Amount ',_react2.default.createElement('br',null),' \u6210\u672C\u91D1\u989D'),dataIndex:'m_cost',key:'m_cost',align:"center",width:150,render:function render(text,record,index){var title=['3 Months Budget Total 后三个月预算合计','Cost Amount 成本金额'];if(!noInputData.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_cost',title:title,sqlName:"_5_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('m_cost',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_cost',title:title,sqlName:"_5_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}}},{title:_react2.default.createElement('div',null,'Cost %  ',_react2.default.createElement('br',null),' \u6210\u672C\u767E\u5206\u6BD4'),dataIndex:'m_cost_percent',key:'m_cost_percent',align:"center",width:150,render:function render(text,record,index){var title=['3 Months Budget Total 后三个月预算合计','Cost % 成本百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'m_cost_percent',title:title,sqlName:"_5_2_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]},{title:'Three Months Rolling Forecast vs. Three Months Budget 后三个月滚动预测与三个月预算的差异',width:1050,children:[{title:_react2.default.createElement('div',null,'Covers ',_react2.default.createElement('br',null),'\u4EBA\u6570'),dataIndex:'b_covers',key:'b_covers',align:"center",width:150,render:function render(text,record,index){var title=['Three Months Rolling Forecast vs. Three Months Budget 后三个月滚动预测与三个月预算的差异','Covers 人数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_covers',title:title,sqlName:"_5_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'Business Mix ',_react2.default.createElement('br',null),'\u4E1A\u52A1\u4EFD\u989D'),dataIndex:'b_business',key:'b_business',align:"center",width:150,render:function render(text,record,index){var title=['Three Months Rolling Forecast vs. Three Months Budget 后三个月滚动预测与三个月预算的差异','Business Mix 业务份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_business',title:title,sqlName:"_5_2_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'A/C ',_react2.default.createElement('br',null),'\u4EBA\u5747\u6D88\u8D39'),dataIndex:'b_AC',key:'b_AC',align:"center",width:150,render:function render(text,record,index){var title=['Three Months Rolling Forecast vs. Three Months Budget 后三个月滚动预测与三个月预算的差异','A/C 人均消费'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_AC',title:title,sqlName:"_5_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'REV ',_react2.default.createElement('br',null),'\u6536\u76CA'),dataIndex:'b_REV',key:'b_REV',align:"center",width:150,render:function render(text,record,index){var title=['Three Months Rolling Forecast vs. Three Months Budget 后三个月滚动预测与三个月预算的差异','REV 收益'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_REV',title:title,sqlName:"_5_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'Revenue Mix',_react2.default.createElement('br',null),' \u6536\u5165\u4EFD\u989D'),dataIndex:'b_revenue',key:'b_revenue',align:"center",width:150,render:function render(text,record,index){var title=['Three Months Rolling Forecast vs. Three Months Budget 后三个月滚动预测与三个月预算的差异','Revenue Mix 收入份额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_revenue',title:title,sqlName:"_5_2_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost Amount ',_react2.default.createElement('br',null),' \u6210\u672C\u91D1\u989D'),dataIndex:'b_cost',key:'b_cost',align:"center",width:150,render:function render(text,record,index){var title=['Three Months Rolling Forecast vs. Three Months Budget 后三个月滚动预测与三个月预算的差异','Cost Amount 成本金额'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_cost',title:title,sqlName:"_5_2_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text)));}},{title:_react2.default.createElement('div',null,'Cost %  ',_react2.default.createElement('br',null),' \u6210\u672C\u767E\u5206\u6BD4'),dataIndex:'b_cost_percent',key:'b_cost_percent',align:"center",width:150,render:function render(text,record,index){var title=['Three Months Rolling Forecast vs. Three Months Budget 后三个月滚动预测与三个月预算的差异','Cost % 成本百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'b_cost_percent',title:title,sqlName:"_5_2_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table5_2_2',style:{width:this.state.print?3500:'auto'}},_react2.default.createElement(_row2.default,null,'5.2.2 Three Months Rolling Forecast vs. Three Months Budget \u540E\u4E09\u4E2A\u6708\u6EDA\u52A8\u9884\u6D4B\u4E0E\u4E09\u4E2A\u6708\u9884\u7B97\u7684\u5DEE\u5F02'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'export5_2_2',pagination:false,className:'content',style:{width:this.state.print?3450:'auto'},scroll:this.state.print?{}:{x:3450,y:550},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_alert2.default,{message:_react2.default.createElement('div',null,'\u8868\u683C\u5173\u8054',_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:'read_5_2'},this.props,{path:'#table5_2_1'}),'5.2.1')),type:'info',showIcon:true,style:{display:"inline-block",marginRight:10}}),_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this2.setState({print:true,loading:true},function(){(0,_ExportExcel2.default)({id:"export5_2_2",date:date,name:"5.2.2 Three Months Rolling Forecast vs. Three Months Budget 后三个月滚动预测与三个月预算的差异"});_this2.setState({print:false,loading:false});});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_5_2'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextArea=_input2.default.TextArea;var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getNote=function(date){fetch('/_5_2_3_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){var note={};if(x.data&&x.data.length>0){note=_extends({},x.data[0]);}_this.setState({loading:false,note:note});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSaveNote=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=[_extends({},_this.state.note,{year:year,month:month})];var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_5_2_3',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getNote(_this.state.date);}return;}_message3.default.error('备注保存失败：'+x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table5_2_3',1.5,'5.23',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),note:{note:""},loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getNote(this.state.date);}},{key:'render',value:function render(){var _this2=this;return _react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement(_row2.default,{className:'title',id:'table5_2_3'},_react2.default.createElement(_row2.default,{style:{margin:"20px 0"}},_react2.default.createElement(_row2.default,{style:{margin:"10px 0"}},'5.2.3  Please critique if variance above +/- 5% \u82E5\u5DEE\u5F02\u6570\u8D85\u8FC7\u4E0A\u4E0B\u767E\u5206\u4E4B\u4E94\u5219\u9700\u505A\u51FA\u4E66\u9762\u89E3\u91CA'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,loading:true,note:{}});_this2.getNote(str);}})),_react2.default.createElement(TextArea,{autosize:{minRows:4},style:{marginTop:20},placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',value:this.state.note.note,onChange:function onChange(e){_this2.setState({note:_extends({},_this2.state.note,{note:e.target.value})});}}))),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_5_2'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSaveNote,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _=__webpack_require__(1922);var _2=_interopRequireDefault(_);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Table5_4 from "./5_4";
var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",null,_react2.default.createElement(_2.default,this.props));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _data=__webpack_require__(1923);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _ExportExcel=__webpack_require__(79);var _ExportExcel2=_interopRequireDefault(_ExportExcel);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextArea=_input2.default.TextArea;var MonthPicker=_datePicker2.default.MonthPicker;function numChange(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var html=Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');return html;}var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.setState({data:data});};_this.getTable5_3=function(date){var dataBegin=JSON.stringify(_data.data5_3);var data=JSON.parse(dataBegin);fetch('/_5_3_all?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.dataNow&&x.data.dataNow.length>0){data=x.data.dataNow;}if(x.data.datalast&&x.data.datalast.length>0){var datalast=x.data.datalast;var listName=['strategy','action_plan','target','deadline','action_by'];data.forEach(function(item,i){listName.forEach(function(name){data[i]['next_'+name]=data[i]['next_'+name]?data[i]['next_'+name]:datalast[i]['third_'+name];data[i]['third_'+name]=data[i]['third_'+name]?data[i]['third_'+name]:datalast[i]['fourth_'+name];});});}_this.setState({loading:false,data:data},function(){_this.onChange('next_strategy',data[0].next_strategy,0);});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month});});// if (!data.every(x => x.name)) {
//     message.error('名称不能为空，请到3-1-1设置名称！');
//     return
// }
var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_5_3',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getTable5_3(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table5_3',1.5,'5.30',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getTable5_3(this.state.date);}// 获取表格5_3的内容
},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,print=_state.print,date=_state.date;var width=document.body.offsetWidth-3150>300?document.body.offsetWidth-3150:300;var noInputData=[13,14,15,16];var columns=[{title:'Outlets 餐厅',dataIndex:'outlets',key:'outlets',align:"center",fixed:!print&&"left",width:width,render:function render(text,record,index){return _react2.default.createElement('div',null,text);}},{title:'Next Month 下个月',width:900,children:[{title:_react2.default.createElement('div',null,'Strategy ',_react2.default.createElement('br',null),'\u7B56\u7565'),dataIndex:'next_strategy',key:'next_strategy',align:"center",width:200,render:function render(text,record,index){if(print)return text;return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(TextArea,{className:'input-width',autosize:{minRows:3,maxRows:6},defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('next_strategy',value,index);}}));}},{title:_react2.default.createElement('div',null,'Action Plan & F&B Promotion Plan ',_react2.default.createElement('br',null),'\u884C\u52A8\u65B9\u6848\u53CA\u9910\u996E\u4FC3\u9500\u8BA1\u5212'),dataIndex:'next_action_plan',key:'next_action_plan',align:"center",width:400,render:function render(text,record,index){if(print)return text;return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(TextArea,{className:'input-width',autosize:{minRows:3,maxRows:6},defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('next_action_plan',value,index);}}));}},{title:_react2.default.createElement('div',null,'Target ',_react2.default.createElement('br',null),'\u76EE\u6807'),dataIndex:'next_target',key:'next_target',align:"center",width:200,render:function render(text,record,index){if(print)return text;return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(TextArea,{className:'input-width',autosize:{minRows:3,maxRows:6},defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('next_target',value,index);}}));}},{title:_react2.default.createElement('div',null,'Deadline',_react2.default.createElement('br',null),' \u65F6\u95F4\u9650\u5B9A'),dataIndex:'next_deadline',key:'next_deadline',align:"center",width:200,render:function render(text,record,index){if(print)return text;return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(TextArea,{className:'input-width',autosize:{minRows:3,maxRows:6},defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('next_deadline',value,index);}}));}},{title:_react2.default.createElement('div',null,'Action By ',_react2.default.createElement('br',null),' \u6267\u884C\u8005'),dataIndex:'next_action_by',key:'next_action_by',align:"center",width:200,render:function render(text,record,index){if(print)return text;if(!noInputData.includes(index)){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(TextArea,{autosize:{minRows:3,maxRows:6},className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('next_action_by',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index==13||index==16?'table-color-footer':'')+' '},numChange(text));}}}]},{title:'3rd Month 第三个月',width:900,children:[{title:_react2.default.createElement('div',null,'Strategy ',_react2.default.createElement('br',null),'\u7B56\u7565'),dataIndex:'third_strategy',key:'third_strategy',align:"center",width:200,render:function render(text,record,index){if(print)return text;return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(TextArea,{className:'input-width',autosize:{minRows:3,maxRows:6},defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('third_strategy',value,index);}}));}},{title:_react2.default.createElement('div',null,'Action Plan & F&B Promotion Plan ',_react2.default.createElement('br',null),'\u884C\u52A8\u65B9\u6848\u53CA\u9910\u996E\u4FC3\u9500\u8BA1\u5212'),dataIndex:'third_action_plan',key:'third_action_plan',align:"center",width:400,render:function render(text,record,index){if(print)return text;return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(TextArea,{className:'input-width',autosize:{minRows:3,maxRows:6},defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('third_action_plan',value,index);}}));}},{title:_react2.default.createElement('div',null,'Target ',_react2.default.createElement('br',null),'\u76EE\u6807'),dataIndex:'third_target',key:'third_target',align:"center",width:200,render:function render(text,record,index){if(print){return _react2.default.createElement(_TableText2.default,{data:{text:text,index:index,type:"text",onChange:_this2.onChange}});}return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(TextArea,{className:'input-width',autosize:{minRows:3,maxRows:6},defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('third_target',value,index);}}));}},{title:_react2.default.createElement('div',null,'Deadline',_react2.default.createElement('br',null),' \u65F6\u95F4\u9650\u5B9A'),dataIndex:'third_deadline',key:'third_deadline',align:"center",width:200,render:function render(text,record,index){if(print){return _react2.default.createElement(_TableText2.default,{data:{text:text,index:index,type:"text",onChange:_this2.onChange}});}return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(TextArea,{className:'input-width',autosize:{minRows:3,maxRows:6},defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('third_deadline',value,index);}}));}},{title:_react2.default.createElement('div',null,'Action By ',_react2.default.createElement('br',null),' \u6267\u884C\u8005'),dataIndex:'third_action_by',key:'third_action_by',align:"center",width:200,render:function render(text,record,index){if(print){return _react2.default.createElement(_TableText2.default,{data:{text:text,index:index,type:"text",onChange:_this2.onChange}});}return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(TextArea,{className:'input-width',autosize:{minRows:3,maxRows:6},defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('third_action_by',value,index);}}));}}]},{title:'4th Month 第四个月',width:900,children:[{title:_react2.default.createElement('div',null,'Strategy ',_react2.default.createElement('br',null),'\u7B56\u7565'),dataIndex:'fourth_strategy',key:'fourth_strategy',align:"center",width:200,render:function render(text,record,index){if(print){return _react2.default.createElement(_TableText2.default,{data:{text:text,index:index,type:"text",onChange:_this2.onChange}});}return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(TextArea,{className:'input-width',autosize:{minRows:3,maxRows:6},defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('fourth_strategy',value,index);}}));}},{title:_react2.default.createElement('div',null,'Action Plan & F&B Promotion Plan ',_react2.default.createElement('br',null),'\u884C\u52A8\u65B9\u6848\u53CA\u9910\u996E\u4FC3\u9500\u8BA1\u5212'),dataIndex:'fourth_action_plan',key:'fourth_action_plan',align:"center",width:400,render:function render(text,record,index){if(print){return _react2.default.createElement(_TableText2.default,{data:{text:text,index:index,type:"text",onChange:_this2.onChange}});}return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(TextArea,{className:'input-width',autosize:{minRows:3,maxRows:6},defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('fourth_action_plan',value,index);}}));}},{title:_react2.default.createElement('div',null,'Target ',_react2.default.createElement('br',null),'\u76EE\u6807'),dataIndex:'fourth_target',key:'fourth_target',align:"center",width:200,render:function render(text,record,index){if(print){return _react2.default.createElement(_TableText2.default,{data:{text:text,index:index,type:"text",onChange:_this2.onChange}});}return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(TextArea,{className:'input-width',autosize:{minRows:3,maxRows:6},defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('fourth_target',value,index);}}));}},{title:_react2.default.createElement('div',null,'Deadline',_react2.default.createElement('br',null),' \u65F6\u95F4\u9650\u5B9A'),dataIndex:'fourth_deadline',key:'fourth_deadline',align:"center",width:200,render:function render(text,record,index){if(print){return _react2.default.createElement(_TableText2.default,{data:{text:text,index:index,type:"text",onChange:_this2.onChange}});}return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(TextArea,{className:'input-width',autosize:{minRows:3,maxRows:6},defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('fourth_deadline',value,index);}}));}},{title:_react2.default.createElement('div',null,'Action By ',_react2.default.createElement('br',null),' \u6267\u884C\u8005'),dataIndex:'fourth_action_by',key:'fourth_action_by',align:"center",width:200,render:function render(text,record,index){if(print){return _react2.default.createElement(_TableText2.default,{data:{text:text,index:index,type:"text",onChange:_this2.onChange}});}return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(TextArea,{className:'input-width',autosize:{minRows:3,maxRows:6},defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('fourth_action_by',value,index);}}));}}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table5_3',style:{width:this.state.print?3900:'auto'}},_react2.default.createElement(_row2.default,null,'5.3 F&B 3 Month Rolling Action Plan By Outlets \u4E09\u4E2A\u6708\u6309\u7167\u9910\u5385\u7EC6\u5206\u7684\u6EDA\u52A8\u884C\u52A8\u8BA1\u5212'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getTable5_3(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'export5_3_1',pagination:false,className:'content',style:{width:this.state.print?3850:'auto'},scroll:this.state.print?{}:{x:3850,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this2.setState({print:true,loading:true},function(){(0,_ExportExcel2.default)({id:"export5_3_1",date:date,name:"5.3 F&B 3 Month Rolling Action Plan By Outlets 三个月按照餐厅细分的滚动行动计划"});_this2.setState({print:false,loading:false});});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_5_3'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data5_3=exports.data5_3=[{outlets:'Overall Direction 总体方向',next_strategy:'',next_action_plan:'',next_target:'',next_deadline:'',next_action_by:'',third_strategy:'',third_action_plan:'',third_target:'',third_deadline:'',third_action_by:'',fourth_strategy:'',fourth_action_plan:'',fourth_target:'',fourth_deadline:'',fourth_action_by:''},{outlets:'Café/All Day Dinning 西餐厅',next_strategy:'',next_action_plan:'',next_target:'',next_deadline:'',next_action_by:'',third_strategy:'',third_action_plan:'',third_target:'',third_deadline:'',third_action_by:'',fourth_strategy:'',fourth_action_plan:'',fourth_target:'',fourth_deadline:'',fourth_action_by:''},{outlets:'Chinese Restaurant/Lotus 中餐厅',next_strategy:'',next_action_plan:'',next_target:'',next_deadline:'',next_action_by:'',third_strategy:'',third_action_plan:'',third_target:'',third_deadline:'',third_action_by:'',fourth_strategy:'',fourth_action_plan:'',fourth_target:'',fourth_deadline:'',fourth_action_by:''},{outlets:'Specialty Restaurant 特色餐厅',next_strategy:'',next_action_plan:'',next_target:'',next_deadline:'',next_action_by:'',third_strategy:'',third_action_plan:'',third_target:'',third_deadline:'',third_action_by:'',fourth_strategy:'',fourth_action_plan:'',fourth_target:'',fourth_deadline:'',fourth_action_by:''},{outlets:'Room Service 送餐服务',next_strategy:'',next_action_plan:'',next_target:'',next_deadline:'',next_action_by:'',third_strategy:'',third_action_plan:'',third_target:'',third_deadline:'',third_action_by:'',fourth_strategy:'',fourth_action_plan:'',fourth_target:'',fourth_deadline:'',fourth_action_by:''},{outlets:'Lobby Lounge 大堂酒吧',next_strategy:'',next_action_plan:'',next_target:'',next_deadline:'',next_action_by:'',third_strategy:'',third_action_plan:'',third_target:'',third_deadline:'',third_action_by:'',fourth_strategy:'',fourth_action_plan:'',fourth_target:'',fourth_deadline:'',fourth_action_by:''},{outlets:'Club Lounge 行政酒廊',next_strategy:'',next_action_plan:'',next_target:'',next_deadline:'',next_action_by:'',third_strategy:'',third_action_plan:'',third_target:'',third_deadline:'',third_action_by:'',fourth_strategy:'',fourth_action_plan:'',fourth_target:'',fourth_deadline:'',fourth_action_by:''},{outlets:'Mini Bar 客房迷你吧',next_strategy:'',next_action_plan:'',next_target:'',next_deadline:'',next_action_by:'',third_strategy:'',third_action_plan:'',third_target:'',third_deadline:'',third_action_by:'',fourth_strategy:'',fourth_action_plan:'',fourth_target:'',fourth_deadline:'',fourth_action_by:''},{outlets:'Other Outlets 其他餐厅',next_strategy:'',next_action_plan:'',next_target:'',next_deadline:'',next_action_by:'',third_strategy:'',third_action_plan:'',third_target:'',third_deadline:'',third_action_by:'',fourth_strategy:'',fourth_action_plan:'',fourth_target:'',fourth_deadline:'',fourth_action_by:''}];

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(25);__webpack_require__(42);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(1925);var _data=__webpack_require__(1926);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _ExportExcel=__webpack_require__(79);var _ExportExcel2=_interopRequireDefault(_ExportExcel);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var Option=_select2.default.Option;var TextArea=_input2.default.TextArea;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var totalNum=[4,6,8,9,13,14,15,19,20,21];var totalName=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];// // 早餐划归餐饮部金额
// for (let index = 0; index < totalName.length; index++) {
//     data[8][totalName[index]] = (numConvert(data[7][totalName[index]]) + numConvert(data[6][totalName[index]])).toFixed(4);
// }
var _loop=function _loop(_index){data[totalNum[_index]].whole=totalName.reduce(function(a,b){a+=numConvert(data[totalNum[_index]][b]);return a;},0);data[totalNum[_index]].whole=data[totalNum[_index]].whole.toFixed(4);};for(var _index=0;_index<totalNum.length;_index++){_loop(_index);}data[7].last=(numConvert(data[6].last)==0?0:numConvert(data[5].last)/numConvert(data[6].last)).toFixed(3);var otherName=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec','whole','last'];for(var i=0;i<otherName.length;i++){data[3][otherName[i]]=(numConvert(data[2][otherName[i]])==0?0:numConvert(data[4][otherName[i]])/numConvert(data[2][otherName[i]])).toFixed(3);data[5][otherName[i]]=(numConvert(data[4][otherName[i]])==0?0:numConvert(data[6][otherName[i]])/numConvert(data[4][otherName[i]])).toFixed(3);if(otherName[i]!='whole'&&otherName[i]!='last'){data[8][otherName[i]]=(numConvert(data[6][otherName[i]])*numConvert(data[7][otherName[i]])).toFixed(4);}// if (otherName[i] != 'whole' || otherName[i] != 'last') {
//     data[10][otherName[i]] = (numConvert(data[8][otherName[i]]) == 0 ? 0 : (numConvert(data[9][otherName[i]]) / numConvert(data[8][otherName[i]]))).toFixed(3);
// }
data[10][otherName[i]]=(numConvert(data[8][otherName[i]])==0?0:numConvert(data[9][otherName[i]])/numConvert(data[8][otherName[i]])).toFixed(3);data[11][otherName[i]]=(numConvert(data[8][otherName[i]])-numConvert(data[9][otherName[i]])).toFixed(4);data[16][otherName[i]]=(numConvert(data[14][otherName[i]])==0?0:numConvert(data[15][otherName[i]])/numConvert(data[14][otherName[i]])).toFixed(3);data[17][otherName[i]]=(numConvert(data[13][otherName[i]])==0?0:numConvert(data[14][otherName[i]])/numConvert(data[13][otherName[i]])).toFixed(3);data[18][otherName[i]]=(numConvert(data[14][otherName[i]])==0?0:numConvert(data[19][otherName[i]])/numConvert(data[14][otherName[i]])).toFixed(4);data[22][otherName[i]]=(numConvert(data[21][otherName[i]])+numConvert(data[20][otherName[i]])).toFixed(4);data[23][otherName[i]]=(numConvert(data[14][otherName[i]])==0?0:numConvert(data[22][otherName[i]])/numConvert(data[14][otherName[i]])).toFixed(4);data[24][otherName[i]]=(numConvert(data[19][otherName[i]])-numConvert(data[20][otherName[i]])-numConvert(data[21][otherName[i]])).toFixed(4);}// 早餐划归餐饮部金额 全年预测
data[8].whole=totalName.reduce(function(a,b){a+=numConvert(data[8][b]);return a;},0);data[8].whole=data[8].whole.toFixed(4);// 单份早餐配给金额 整年单独结算
data[7].whole=(numConvert(data[6].whole)==0?0:numConvert(data[8].whole)/numConvert(data[6].whole)).toFixed(3);// 单份早餐去年
data[7].last=(numConvert(data[6].last)==0?0:numConvert(data[8].last)/numConvert(data[6].last)).toFixed(3);for(var _i=0;_i<data.length;_i++){if(_i!=0||_i!=1||_i!=12){data[_i].variance=(numConvert(data[_i].last)==0?0:numConvert(data[_i].whole)/numConvert(data[_i].last)).toFixed(3);}}_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;i++;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data2_1);var data=JSON.parse(dataBegin);fetch('/_5_5_all_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){var nameData=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec','whole'];if(x.data.d5_5&&x.data.d5_5.length>0){// let dataNow = x.data.d5_5.filter(item => item.month == moment(date).format("MM"));
// if (dataNow && dataNow.length > 0) {
//     data = dataNow;
// }
// let dataLast = x.data.d5_5.filter(item => item.month == (moment(date).format("MM") - 1));
// let len = moment(date).format("MM") - 1;
// // 从上月数据中填充历史数据
// if (dataLast && dataLast.length > 0) {
//     for (let i = 0; i < len; i++) {
//         data = data.map((z, index) => ({ ...z, [nameData[i]]: dataLast[index][nameData[i]] == 0 ? z[nameData[i]] : dataLast[index][nameData[i]] }));
//     }
// }
data=x.data.d5_5;}if(x.data.d2_1&&x.data.d2_1.length>0){for(var _index2=0;_index2<nameData.length;_index2++){data[2][nameData[_index2]]=x.data.d2_1[2][nameData[_index2]];}}var note={};if(x.data.d5_5_1&&x.data.d5_5_1.length>0){note=_extends({},x.data.d5_5_1[0]);}_this.setState({loading:false,note:note});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var data=_this.state.data.map(function(x){return _extends({},x,{year:year});});var dataFrom=new FormData();if(_this.state.note.note){_this.onSaveNote([_extends({},_this.state.note,{year:year})]);}dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_5_5',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.onSaveNote=function(data){var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_5_5_1',headres).then(function(x){return x.json();}).then(function(x){if(x.status==1){if(!_this.state.note.id){_this.getNote(_this.state.date);}return;}_message3.default.error('备注保存失败：'+x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);});};_this.onChangeSelect=function(name,value){var data=_this.state.data;data[0][name]=value.key;_this.setState({data:data});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table5_5',1.5,'5.50',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,note:{note:""},print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _ref,_this2=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print;var width=document.body.offsetWidth>2825?document.body.offsetWidth-2400:425;var inputIndex=[3,5,6,8,12,13,14,18,19,20];var percentData=[4,9,15,16];var totalData=[0,11,23];var columns=[(_ref={align:"center",title:_react2.default.createElement('div',null,'Breakfast Revenue Allocation ',_react2.default.createElement('br',null),'  \u65E9\u9910\u53CA\u884C\u653F\u9152\u5ECA\u6536\u5165\u5206\u914D'),width:width,fixed:!print&&"left",dataIndex:'name',key:'name'},_defineProperty(_ref,'width',width),_defineProperty(_ref,'render',function render(text,record,index){return _react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"left"}},text);}),_ref),{title:'Jan 一月',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{labelInValue:true,style:{width:"100%"},defaultValue:{key:data[0]?Number(data[0].Jan).toFixed(0).toString():1},onChange:function onChange(value){_this2.onChangeSelect('Jan',value);}},_react2.default.createElement(Option,{value:'1'},'Actual\u5B9E\u9645'),_react2.default.createElement(Option,{value:'2'},'Forecast\u9884\u6D4B')),align:"center",width:150,dataIndex:'Jan',key:'Jan',render:function render(text,record,index){var title=['Jan 一月',{1:'Actual实际',2:'Forecast预测'}[data[0]?Number(data[0].Jan).toFixed(4).toString():1]];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Jan',title:title,sqlName:"_5_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:4,defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(4));_this2.onChange('Jan',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Jan',title:title,sqlName:"_5_5",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]},{title:'Feb 二月',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{labelInValue:true,style:{width:"100%"},defaultValue:{key:data[0]?Number(data[0].Feb).toFixed(0).toString():1},onChange:function onChange(value){_this2.onChangeSelect('Feb',value);}},_react2.default.createElement(Option,{value:'1'},'Actual\u5B9E\u9645'),_react2.default.createElement(Option,{value:'2'},'Forecast\u9884\u6D4B')),align:"center",width:150,dataIndex:'Feb',key:'Feb',render:function render(text,record,index){var title=['Feb 二月',{1:'Actual实际',2:'Forecast预测'}[data[0]?Number(data[0].Feb).toFixed(4).toString():1]];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Feb',title:title,sqlName:"_5_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:4,defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(4));_this2.onChange('Feb',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Feb',title:title,sqlName:"_5_5",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]},{title:'Mar 三月',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{labelInValue:true,style:{width:"100%"},defaultValue:{key:data[0]?Number(data[0].Mar).toFixed(0).toString():1},onChange:function onChange(value){_this2.onChangeSelect('Mar',value);}},_react2.default.createElement(Option,{value:'1'},'Actual\u5B9E\u9645'),_react2.default.createElement(Option,{value:'2'},'Forecast\u9884\u6D4B')),align:"center",width:150,dataIndex:'Mar',key:'Mar',render:function render(text,record,index){var title=['Mar 三月',{1:'Actual实际',2:'Forecast预测'}[data[0]?Number(data[0].Mar).toFixed(4).toString():1]];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Mar',title:title,sqlName:"_5_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:4,defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(4));_this2.onChange('Mar',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Mar',title:title,sqlName:"_5_5",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]},{title:'Apr 四月',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{labelInValue:true,style:{width:"100%"},defaultValue:{key:data[0]?Number(data[0].Apr).toFixed(0).toString():1},onChange:function onChange(value){_this2.onChangeSelect('Apr',value);}},_react2.default.createElement(Option,{value:'1'},'Actual\u5B9E\u9645'),_react2.default.createElement(Option,{value:'2'},'Forecast\u9884\u6D4B')),align:"center",width:150,dataIndex:'Apr',key:'Apr',render:function render(text,record,index){var title=['Apr 四月',{1:'Actual实际',2:'Forecast预测'}[data[0]?Number(data[0].Apr).toFixed(4).toString():1]];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Apr',title:title,sqlName:"_5_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:4,defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(4));_this2.onChange('Apr',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Apr',title:title,sqlName:"_5_5",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]},{title:'May 五月',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{labelInValue:true,style:{width:"100%"},defaultValue:{key:data[0]?Number(data[0].May).toFixed(0).toString():1},onChange:function onChange(value){_this2.onChangeSelect('May',value);}},_react2.default.createElement(Option,{value:'1'},'Actual\u5B9E\u9645'),_react2.default.createElement(Option,{value:'2'},'Forecast\u9884\u6D4B')),align:"center",width:150,dataIndex:'May',key:'May',render:function render(text,record,index){var title=['May 五月',{1:'Actual实际',2:'Forecast预测'}[data[0]?Number(data[0].May).toFixed(4).toString():1]];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'May',title:title,sqlName:"_5_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:4,defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(4));_this2.onChange('May',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'May',title:title,sqlName:"_5_5",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]},{title:'Jun 六月',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{labelInValue:true,style:{width:"100%"},defaultValue:{key:data[0]?Number(data[0].Jun).toFixed(0).toString():1},onChange:function onChange(value){_this2.onChangeSelect('Jun',value);}},_react2.default.createElement(Option,{value:'1'},'Actual\u5B9E\u9645'),_react2.default.createElement(Option,{value:'2'},'Forecast\u9884\u6D4B')),align:"center",width:150,dataIndex:'Jun',key:'Jun',render:function render(text,record,index){var title=['Jun 六月',{1:'Actual实际',2:'Forecast预测'}[data[0]?Number(data[0].Jun).toFixed(4).toString():1]];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Jun',title:title,sqlName:"_5_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:4,defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(4));_this2.onChange('Jun',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Jun',title:title,sqlName:"_5_5",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]},{title:'Jul 七月',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{labelInValue:true,style:{width:"100%"},defaultValue:{key:data[0]?Number(data[0].Jul).toFixed(0).toString():1},onChange:function onChange(value){_this2.onChangeSelect('Jul',value);}},_react2.default.createElement(Option,{value:'1'},'Actual\u5B9E\u9645'),_react2.default.createElement(Option,{value:'2'},'Forecast\u9884\u6D4B')),align:"center",width:150,dataIndex:'Jul',key:'Jul',render:function render(text,record,index){var title=['Jul 七月',{1:'Actual实际',2:'Forecast预测'}[data[0]?Number(data[0].Jul).toFixed(4).toString():1]];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Jul',title:title,sqlName:"_5_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:4,defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(4));_this2.onChange('Jul',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Jul',title:title,sqlName:"_5_5",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]},{title:'Aug 八月',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{labelInValue:true,style:{width:"100%"},defaultValue:{key:data[0]?Number(data[0].Aug).toFixed(0).toString():1},onChange:function onChange(value){_this2.onChangeSelect('Aug',value);}},_react2.default.createElement(Option,{value:'1'},'Actual\u5B9E\u9645'),_react2.default.createElement(Option,{value:'2'},'Forecast\u9884\u6D4B')),align:"center",width:150,dataIndex:'Aug',key:'Aug',render:function render(text,record,index){var title=['Aug 八月',{1:'Actual实际',2:'Forecast预测'}[data[0]?Number(data[0].Aug).toFixed(4).toString():1]];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Aug',title:title,sqlName:"_5_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:4,defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(4));_this2.onChange('Aug',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Aug',title:title,sqlName:"_5_5",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]},{title:'Sep 九月',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{labelInValue:true,style:{width:"100%"},defaultValue:{key:data[0]?Number(data[0].Sep).toFixed(0).toString():1},onChange:function onChange(value){_this2.onChangeSelect('Sep',value);}},_react2.default.createElement(Option,{value:'1'},'Actual\u5B9E\u9645'),_react2.default.createElement(Option,{value:'2'},'Forecast\u9884\u6D4B')),align:"center",width:150,dataIndex:'Sep',key:'Sep',render:function render(text,record,index){var title=['Sep 九月',{1:'Actual实际',2:'Forecast预测'}[data[0]?Number(data[0].Sep).toFixed(4).toString():1]];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Sep',title:title,sqlName:"_5_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:4,defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(4));_this2.onChange('Sep',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Sep',title:title,sqlName:"_5_5",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]},{title:'Oct 十月',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{labelInValue:true,style:{width:"100%"},defaultValue:{key:data[0]?Number(data[0].Oct).toFixed(0).toString():1},onChange:function onChange(value){_this2.onChangeSelect('Oct',value);}},_react2.default.createElement(Option,{value:'1'},'Actual\u5B9E\u9645'),_react2.default.createElement(Option,{value:'2'},'Forecast\u9884\u6D4B')),align:"center",width:150,dataIndex:'Oct',key:'Oct',render:function render(text,record,index){var title=['Oct 十月',{1:'Actual实际',2:'Forecast预测'}[data[0]?Number(data[0].Oct).toFixed(4).toString():1]];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Oct',title:title,sqlName:"_5_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:4,defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(4));_this2.onChange('Oct',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Oct',title:title,sqlName:"_5_5",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]},{title:'Nov 十一月',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{labelInValue:true,style:{width:"100%"},defaultValue:{key:data[0]?Number(data[0].Nov).toFixed(0).toString():1},onChange:function onChange(value){_this2.onChangeSelect('Nov',value);}},_react2.default.createElement(Option,{value:'1'},'Actual\u5B9E\u9645'),_react2.default.createElement(Option,{value:'2'},'Forecast\u9884\u6D4B')),align:"center",width:150,dataIndex:'Nov',key:'Nov',render:function render(text,record,index){var title=['Nov 十一月',{1:'Actual实际',2:'Forecast预测'}[data[0]?Number(data[0].Nov).toFixed(4).toString():1]];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Nov',title:title,sqlName:"_5_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:4,defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(4));_this2.onChange('Nov',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Nov',title:title,sqlName:"_5_5",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]},{title:'Dec 十二月',align:"center",width:150,children:[{title:_react2.default.createElement(_select2.default,{labelInValue:true,style:{width:"100%"},defaultValue:{key:data[0]?Number(data[0].Dec).toFixed(0).toString():1},onChange:function onChange(value){_this2.onChangeSelect('Dec',value);}},_react2.default.createElement(Option,{value:'1'},'Actual\u5B9E\u9645'),_react2.default.createElement(Option,{value:'2'},'Forecast\u9884\u6D4B')),align:"center",width:150,dataIndex:'Dec',key:'Dec',render:function render(text,record,index){var title=['Dec 十二月',{1:'Actual实际',2:'Forecast预测'}[data[0]?Number(data[0].Dec).toFixed(4).toString():1]];if(inputIndex.includes(index)&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Dec',title:title,sqlName:"_5_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:4,defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(4));_this2.onChange('Dec',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'Dec',title:title,sqlName:"_5_5",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}}]},{title:_react2.default.createElement('div',null,'Whole Year Forecast ',_react2.default.createElement('br',null),' \u5168\u5E74\u9884\u6D4B'),align:"center",width:200,dataIndex:'whole',key:'whole',render:function render(text,record,index){var title=['Whole Year Forecast  全年预测'];var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'whole',title:title,sqlName:"_5_5",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}},{title:_react2.default.createElement('div',null,'Last Year Actual ',_react2.default.createElement('br',null),' \u53BB\u5E74\u5B9E\u9645'),align:"center",width:200,dataIndex:'last',key:'last',render:function render(text,record,index){var title=['Last Year Actual  去年实际'];if((inputIndex.includes(index)||index==7||index==1)&&index!=6&&!print){return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'last',title:title,sqlName:"_5_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{className:'input-width',formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:4,defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(4));_this2.onChange('last',value,index);}})));}else{var html=null;if(percentData.includes(index)){if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}}else{if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')');}}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'last',title:title,sqlName:"_5_5",name:record.name,type:percentData.includes(index)?'percent':'number'}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}},{title:_react2.default.createElement('div',null,'Variance \u5DEE\u5F02'),align:"center",width:200,dataIndex:'variance',key:'variance',render:function render(text,record,index){var title=['Variance 差异'];var html=null;if(Number(text||"0")>=0){html=_react2.default.createElement('span',null,(Number(text||"0")*100).toFixed(1)+'%');}else{html=_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")*100).toFixed(1)+'%',')');}return _react2.default.createElement(_Compared2.default,{data:{index:index+1,key:'variance',title:title,sqlName:"_5_5",name:record.name,type:"percent"}},_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':'')},html));}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table table2_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table5_5',style:{width:this.state.print?2875:'auto'}},_react2.default.createElement(_row2.default,null,'5.5 Breakfast & Club Lounge Revenue Allocation \u65E9\u9910\u6536\u5165\u5206\u914D'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}})),data.length>0?_react2.default.createElement(_row2.default,null,_react2.default.createElement(_table2.default,{columns:columns,dataSource:data.filter(function(x){return x.name;}),size:'middle',className:'content',bordered:true,id:'export5_5',pagination:false,style:{width:this.state.print?2825:'auto'},scroll:this.state.print?{}:{x:2825,y:550},rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_row2.default,{style:{margin:"20px 0"}},_react2.default.createElement(_row2.default,{style:{margin:"10px 0"}},'5.5.1 Comments \u5907\u6CE8: '),_react2.default.createElement(TextArea,{autosize:{minRows:4},placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',defaultValue:this.state.note.note,onBlur:function onBlur(e){_this2.setState({note:_extends({},_this2.state.note,{note:e.target.value})});}}))):""),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this2.setState({print:true,loading:true},function(){(0,_ExportExcel2.default)({id:"export5_5",date:date,name:"5.5 Breakfast & Club Lounge Revenue Allocation 早餐收入分配"});_this2.setState({print:false,loading:false});});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_5_5'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1925 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data2_1=exports.data2_1=[{name:'',name_code:"",Jan:"1",Feb:"1",Mar:"1",Apr:"1",May:"1",Jun:"1",Jul:"1",Aug:'1',Sep:"1",Oct:"1",Nov:"1",Dec:"1",whole:"0",last:"0",variance:"0"},{name:'Café/All Day Dinning 西餐厅',name_code:"Café/All_Day_Dinning",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'Rooms Sold 出租房间',name_code:"Rooms_Sold",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'Double Occupancy Rate 双人入住率',name_code:"Double_Occupancy_Rate",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'No. of In-house Guest 住店客人人数',name_code:"No._of_In-house_Guest",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'In-house Capture Ratio % 住店客人用餐率',name_code:"In-house_Capture_Ratio",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'Actual Breakfast Covers 实际用早餐人数',name_code:"Actual_Breakfast_Covers",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'Breakfast Allocation 单份早餐配给金额',name_code:"Breakfast_Allocation",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'Breakfast Total Allocation to F&B 早餐划归餐饮部金额',name_code:"Breakfast_Total_Allocation_to_F&B",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'Breakfast F&B Cost 早餐食品及饮料成本',name_code:"Breakfast_F&B_Cost",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'Breakfast F&B Cost % 早餐食品饮料成本率',name_code:"Breakfast_F&B_Cost",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'Breakfast Net Income 早餐收入',name_code:"Breakfast_Net_Income",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'Club Lounge 行政酒廊',name_code:"Club_Lounge",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'Club & Suites Available 行政楼及套房可出租数',name_code:"Club_Suites_Available",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'Club & Suites Sold 行政楼及套房实际出租数',name_code:"Club_Suites_Sold",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'Club & Suites No. of Guest 行政楼及套房客人数',name_code:"Club_Suites_No_of_Guest",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'Club & Suites Double Occ Rate 行政楼及套房双人入住率',name_code:"Club_&_Suites_Double_Occ_Rate",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'Club & Suites Occupancy 行政楼及套房入住率',name_code:"Club_Suites_Occupancy",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'Club & Suites ADR 行政楼及套房平均房价',name_code:"Club_&_Suites_ADR",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'Club & Suites Room Revenue 行政楼及套房客房收入',name_code:"Club_&_Suites_Room_Revenue",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'Cost of Breakfast at Club Lounge 早餐食品饮料成本划分总金额',name_code:"Cost_of_Breakfast_at_Club_Lounge",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'Afternoon Tea & Evening Cocktail Cost 下午茶及欢乐时光成本',name_code:"Afternoon_Tea_&_Evening_Cocktail_Cost",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'Club & Suites F&B Total Cost',name_code:"Club_Suites_F&B_Total_Cost",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'Club & Suites F&B Cost Per Room',name_code:"Club_&_Suites_F&B_Cost_Per_Room",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"},{name:'Club & Suites Net Room Income 行政楼及套房净客房收入',name_code:"Club_&_Suites_Net_Room_Income",Jan:"0",Feb:"0",Mar:"0",Apr:"0",May:"0",Jun:"0",Jul:"0",Aug:'0',Sep:"0",Oct:"0",Nov:"0",Dec:"0",whole:"0",last:"0",variance:"0"}];

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.index=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _=__webpack_require__(1928);var _2=_interopRequireDefault(_);var _3=__webpack_require__(1930);var _4=_interopRequireDefault(_3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=exports.index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",null,_react2.default.createElement(_2.default,this.props),_react2.default.createElement(_4.default,this.props));}}]);return index;}(_react.Component);;exports.default=index;

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(25);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(1929);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _ExportExcel=__webpack_require__(79);var _ExportExcel2=_interopRequireDefault(_ExportExcel);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TextArea=_input2.default.TextArea;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var totalName=['cm_thisyear_covers','cm_thisyear_rev','cm_lastyear_covers','cm_lastyear_rev','ytd_thisyear_covers','ytd_thisyear_rev','ytd_lastyear_covers','ytd_lastyear_rev'];for(var i in totalName){data[20][totalName[i]]=0;}// 计算总的统计
for(var _i in totalName){for(var j=0;j<20;j++){data[20][totalName[_i]]+=Number(data[j][totalName[_i]]);}}// console.log(data , '计算前');return;
// 计算其他需要计算的值
for(var _j=0;_j<=20;_j++){// current_month计算
data[_j]['cm_thisyear_ac']=Number(data[_j]['cm_thisyear_covers'])==0?0:(Number(data[_j]['cm_thisyear_rev'])/Number(data[_j]['cm_thisyear_covers'])).toFixed(2);data[_j]['cm_lastyear_ac']=Number(data[_j]['cm_lastyear_covers'])==0?0:(Number(data[_j]['cm_lastyear_rev'])/Number(data[_j]['cm_lastyear_covers'])).toFixed(2);data[_j]['cm_comparison_covers']=Number(data[_j]['cm_thisyear_covers'])-Number(data[_j]['cm_lastyear_covers']);data[_j]['cm_covers_percent']=Number(data[_j]['cm_lastyear_covers'])==0?0:(Number(data[_j]['cm_comparison_covers'])/Number(data[_j]['cm_lastyear_covers'])).toFixed(2);data[_j]['cm_comparison_ac']=(Number(data[_j]['cm_thisyear_ac'])-Number(data[_j]['cm_lastyear_ac'])).toFixed(2);data[_j]['cm_ac_percent']=Number(data[_j]['cm_lastyear_ac'])==0?0:(Number(data[_j]['cm_comparison_ac'])/Number(data[_j]['cm_lastyear_ac'])).toFixed(2);data[_j]['cm_comparison_rev']=(Number(data[_j]['cm_thisyear_rev'])-Number(data[_j]['cm_lastyear_rev'])).toFixed(2);data[_j]['cm_rev_percent']=Number(data[_j]['cm_lastyear_rev'])==0?0:(Number(data[_j]['cm_comparison_rev'])/Number(data[_j]['cm_lastyear_rev'])).toFixed(2);// 本年度计算
data[_j]['ytd_thisyear_ac']=Number(data[_j]['ytd_thisyear_covers'])==0?0:(Number(data[_j]['ytd_thisyear_rev'])/Number(data[_j]['ytd_thisyear_covers'])).toFixed(2);data[_j]['ytd_lastyear_ac']=Number(data[_j]['ytd_lastyear_covers'])==0?0:(Number(data[_j]['ytd_lastyear_rev'])/Number(data[_j]['ytd_lastyear_covers'])).toFixed(2);data[_j]['ytd_comparison_covers']=Number(data[_j]['ytd_thisyear_covers'])-Number(data[_j]['ytd_lastyear_covers']);data[_j]['ytd_covers_percent']=Number(data[_j]['ytd_lastyear_covers'])==0?0:(Number(data[_j]['ytd_comparison_covers'])/Number(data[_j]['ytd_lastyear_covers'])).toFixed(2);data[_j]['ytd_comparison_ac']=(Number(data[_j]['ytd_thisyear_ac'])-Number(data[_j]['ytd_lastyear_ac'])).toFixed(2);data[_j]['ytd_ac_percent']=Number(data[_j]['ytd_lastyear_ac'])==0?0:(Number(data[_j]['ytd_comparison_ac'])/Number(data[_j]['ytd_lastyear_ac'])).toFixed(2);data[_j]['ytd_comparison_rev']=(Number(data[_j]['ytd_thisyear_rev'])-Number(data[_j]['ytd_lastyear_rev'])).toFixed(2);data[_j]['ytd_rev_percent']=Number(data[_j]['ytd_lastyear_rev'])==0?0:(Number(data[_j]['ytd_comparison_rev'])/Number(data[_j]['ytd_lastyear_rev'])).toFixed(2);}_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;// this.setState({
//     data
// });
_this.computeNum(data);};_this.getTable5_6_1=function(date){var dataBegin=JSON.stringify(_data.data5_6_1);var data=JSON.parse(dataBegin);fetch('/_5_6_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}_this.computeNum(data);_this.setState({loading:false});}).catch(function(err){console.error(err);_this.setState({loading:false});});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_5_6_1',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getTable5_6_1(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table5_6_1',1.5,'5.61',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],note:{note:""},loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getTable5_6_1(this.state.date);// this.computeNum(this.state.data)
}// 获取表格5_6_1内容
// 保存表格5-6-1内容
},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print;var columns=[{title:_react2.default.createElement('div',null,'Top 20  F&B Unit Account ',_react2.default.createElement('br',null),' \u9910\u996E\u6D88\u8D39\u5355\u4F4D\u8D26\u53F7\u6392\u540D\u524D\u4E8C\u5341\u4F4D '),dataIndex:'top20_account',key:'top20_account',align:"center",fixed:!print&&"left",width:300,render:function render(text,record,index){if(index<20){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){_this2.onChange('top20_account',e.target.value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding table-color-footer'},text);}}},{title:'Current Month 本年当月',align:"center",width:1800,children:[{align:"center",title:'Current Month Actual - This Year 本年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,'Covers \u4EBA\u6570'),dataIndex:'cm_thisyear_covers',key:'cm_thisyear_covers',align:"center",width:150,render:function render(text,record,index){if(index<20&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('cm_thisyear_covers',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},text);}}},{title:_react2.default.createElement('div',null,'A/C  \u4EBA\u5747\u6D88\u8D39'),dataIndex:'cm_thisyear_ac',key:'cm_thisyear_ac',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},text);}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'cm_thisyear_rev',key:'cm_thisyear_rev',align:"center",width:150,render:function render(text,record,index){if(index<20&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('cm_thisyear_rev',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},text);}}}]},{align:"center",title:'Current Month Actual - Last Year 去年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,'Covers \u4EBA\u6570'),dataIndex:'cm_lastyear_covers',key:'cm_lastyear_covers',align:"center",width:150,render:function render(text,record,index){if(index<20&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('cm_lastyear_covers',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},text);}}},{title:_react2.default.createElement('div',null,'A/C  \u4EBA\u5747\u6D88\u8D39'),dataIndex:'cm_lastyear_ac',key:'cm_lastyear_ac',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},text);}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'cm_lastyear_rev',key:'cm_lastyear_rev',align:"center",width:150,render:function render(text,record,index){if(index<20&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('cm_lastyear_rev',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},text);}}}]},{align:"center",title:'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年',width:900,children:[{title:_react2.default.createElement('div',null,'Covers \u4EBA\u6570'),dataIndex:'cm_comparison_covers',key:'cm_comparison_covers',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:'% 百分比',dataIndex:'cm_covers_percent',key:'cm_covers_percent',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%');}},{title:_react2.default.createElement('div',null,'A/C \u4EBA\u5747\u6D88\u8D39'),dataIndex:'cm_comparison_ac',key:'cm_comparison_ac',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:'% 百分比',dataIndex:'cm_ac_percent',align:"cm_ac_percent",key:'vap_percent',width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%');}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'cm_comparison_rev',key:'cm_comparison_rev',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:'% 百分比',dataIndex:'cm_rev_percent',key:'cm_rev_percent',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%');}}]}]},{title:'YTD 本年累计',align:"center",width:1800,children:[{align:"center",title:'YTD Actual - This Year 本年累计实际数',width:450,children:[{title:_react2.default.createElement('div',null,'Covers \u4EBA\u6570'),dataIndex:'ytd_thisyear_covers',key:'ytd_thisyear_covers',align:"center",width:150,render:function render(text,record,index){if(index<20&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('ytd_thisyear_covers',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}},{title:_react2.default.createElement('div',null,'A/C  \u4EBA\u5747\u6D88\u8D39'),dataIndex:'ytd_thisyear_ac',key:'ytd_thisyear_ac',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'ytd_thisyear_rev',key:'ytd_thisyear_rev',align:"center",width:150,render:function render(text,record,index){if(index<20&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('ytd_thisyear_rev',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}}]},{align:"center",title:'YTD Actual - Last Year 去年累计实际数',width:450,children:[{title:_react2.default.createElement('div',null,'Covers \u4EBA\u6570'),dataIndex:'ytd_lastyear_covers',key:'ytd_lastyear_covers',align:"center",width:150,render:function render(text,record,index){if(index<20&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('ytd_lastyear_covers',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}},{title:_react2.default.createElement('div',null,'A/C  \u4EBA\u5747\u6D88\u8D39'),dataIndex:'ytd_lastyear_ac',key:'ytd_lastyear_ac',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'ytd_lastyear_rev',key:'ytd_lastyear_rev',align:"center",width:150,render:function render(text,record,index){if(index<20&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('ytd_lastyear_rev',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}}]},{align:"center",title:'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',width:900,children:[{title:_react2.default.createElement('div',null,'Covers \u4EBA\u6570'),dataIndex:'ytd_comparison_covers',key:'ytd_comparison_covers',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding  '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:'% 百分比',dataIndex:'ytd_covers_percent',key:'ytd_covers_percent',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%');}},{title:_react2.default.createElement('div',null,'A/C \u4EBA\u5747\u6D88\u8D39'),dataIndex:'ytd_comparison_ac',key:'ytd_comparison_ac',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:'% 百分比',dataIndex:'ytd_ac_percent',align:"center",key:'ytd_ac_percent',width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%');}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'ytd_comparison_rev',key:'ytd_comparison_rev',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:'% 百分比',dataIndex:'ytd_rev_percent',key:'ytd_rev_percent',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%');}}]}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title ',id:'table5_6_1',style:{width:this.state.print?3950:'auto'}},_react2.default.createElement(_row2.default,null,'5.6.1 Top 20  F&B Unit Account \u9910\u996E\u6D88\u8D39\u5355\u4F4D\u8D26\u53F7\u6392\u540D\u524D\u4E8C\u5341\u4F4D '),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true,note:{note:""}});_this2.getTable5_6_1(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'export5_6_1',pagination:false,className:'content',style:{width:this.state.print?3900:'auto'},scroll:this.state.print?{}:{x:3900,y:550},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this2.setState({print:true,loading:true},function(){(0,_ExportExcel2.default)({id:"export5_6_1",date:date,name:"5.6.1 Top 20 F&B Unit Account 餐饮消费单位账号排名前二十位"});_this2.setState({print:false,loading:false});});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_5_6'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data5_6_1=exports.data5_6_1=[{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'Sub-Total 小计',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0}];

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(25);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(1931);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _ExportExcel=__webpack_require__(79);var _ExportExcel2=_interopRequireDefault(_ExportExcel);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TextArea=_input2.default.TextArea;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var totalName=['cm_thisyear_covers','cm_thisyear_rev','cm_lastyear_covers','cm_lastyear_rev','ytd_thisyear_covers','ytd_thisyear_rev','ytd_lastyear_covers','ytd_lastyear_rev'];for(var i in totalName){data[20][totalName[i]]=0;}// 计算总的统计
for(var _i in totalName){for(var j=0;j<20;j++){data[20][totalName[_i]]+=Number(data[j][totalName[_i]]);}}// console.log(data , '计算前');return;
// 计算其他需要计算的值
for(var _j=0;_j<=20;_j++){// current_month计算
data[_j]['cm_thisyear_ac']=Number(data[_j]['cm_thisyear_covers'])==0?0:(Number(data[_j]['cm_thisyear_rev'])/Number(data[_j]['cm_thisyear_covers'])).toFixed(2);data[_j]['cm_lastyear_ac']=Number(data[_j]['cm_lastyear_covers'])==0?0:(Number(data[_j]['cm_lastyear_rev'])/Number(data[_j]['cm_lastyear_covers'])).toFixed(2);data[_j]['cm_comparison_covers']=Number(data[_j]['cm_thisyear_covers'])-Number(data[_j]['cm_lastyear_covers']);data[_j]['cm_covers_percent']=Number(data[_j]['cm_lastyear_covers'])==0?0:(Number(data[_j]['cm_comparison_covers'])/Number(data[_j]['cm_lastyear_covers'])).toFixed(2);data[_j]['cm_comparison_ac']=(Number(data[_j]['cm_thisyear_ac'])-Number(data[_j]['cm_lastyear_ac'])).toFixed(2);data[_j]['cm_ac_percent']=Number(data[_j]['cm_lastyear_ac'])==0?0:(Number(data[_j]['cm_comparison_ac'])/Number(data[_j]['cm_lastyear_ac'])).toFixed(2);data[_j]['cm_comparison_rev']=(Number(data[_j]['cm_thisyear_rev'])-Number(data[_j]['cm_lastyear_rev'])).toFixed(2);data[_j]['cm_rev_percent']=Number(data[_j]['cm_lastyear_rev'])==0?0:(Number(data[_j]['cm_comparison_rev'])/Number(data[_j]['cm_lastyear_rev'])).toFixed(2);// 本年度计算
data[_j]['ytd_thisyear_ac']=Number(data[_j]['ytd_thisyear_covers'])==0?0:(Number(data[_j]['ytd_thisyear_rev'])/Number(data[_j]['ytd_thisyear_covers'])).toFixed(2);data[_j]['ytd_lastyear_ac']=Number(data[_j]['ytd_lastyear_covers'])==0?0:(Number(data[_j]['ytd_lastyear_rev'])/Number(data[_j]['ytd_lastyear_covers'])).toFixed(2);data[_j]['ytd_comparison_covers']=Number(data[_j]['ytd_thisyear_covers'])-Number(data[_j]['ytd_lastyear_covers']);data[_j]['ytd_covers_percent']=Number(data[_j]['ytd_lastyear_covers'])==0?0:(Number(data[_j]['ytd_comparison_covers'])/Number(data[_j]['ytd_lastyear_covers'])).toFixed(2);data[_j]['ytd_comparison_ac']=(Number(data[_j]['ytd_thisyear_ac'])-Number(data[_j]['ytd_lastyear_ac'])).toFixed(2);data[_j]['ytd_ac_percent']=Number(data[_j]['ytd_lastyear_ac'])==0?0:(Number(data[_j]['ytd_comparison_ac'])/Number(data[_j]['ytd_lastyear_ac'])).toFixed(2);data[_j]['ytd_comparison_rev']=(Number(data[_j]['ytd_thisyear_rev'])-Number(data[_j]['ytd_lastyear_rev'])).toFixed(2);data[_j]['ytd_rev_percent']=Number(data[_j]['ytd_lastyear_rev'])==0?0:(Number(data[_j]['ytd_comparison_rev'])/Number(data[_j]['ytd_lastyear_rev'])).toFixed(2);}_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;// this.setState({
//     data
// });
_this.computeNum(data);};_this.getTable5_6_2=function(date){var dataBegin=JSON.stringify(_data.data5_6_2);var data=JSON.parse(dataBegin);fetch('/_5_6_2_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}_this.computeNum(data);_this.setState({loading:false});}).catch(function(err){console.error(err);_this.setState({loading:false});});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_5_6_2',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getTable5_6_2(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table5_6_2',1.5,'5.62',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],note:{note:""},loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getTable5_6_2(this.state.date);// this.computeNum(this.state.data)
}// 获取表格5_6_2内容
// 保存表格5-6-2内容
},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print;var columns=[{title:_react2.default.createElement('div',null,'Top 20  F&B Individual Account ',_react2.default.createElement('br',null),' \u9910\u996E\u6D88\u8D39\u4E2A\u4EBA\u8D26\u53F7\u6392\u540D\u524D\u4E8C\u5341\u4F4D '),dataIndex:'top20_account',key:'top20_account',align:"center",fixed:!print&&"left",width:300,render:function render(text,record,index){if(index<20&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){_this2.onChange('top20_account',e.target.value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding table-color-footer'},text);}}},{title:'Current Month 本年当月',align:"center",width:1800,children:[{align:"center",title:'Current Month Actual - This Year 本年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,'Covers \u4EBA\u6570'),dataIndex:'cm_thisyear_covers',key:'cm_thisyear_covers',align:"center",width:150,render:function render(text,record,index){if(index<20&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('cm_thisyear_covers',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},text);}}},{title:_react2.default.createElement('div',null,'A/C  \u4EBA\u5747\u6D88\u8D39'),dataIndex:'cm_thisyear_ac',key:'cm_thisyear_ac',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},text);}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'cm_thisyear_rev',key:'cm_thisyear_rev',align:"center",width:150,render:function render(text,record,index){if(index<20&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('cm_thisyear_rev',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},text);}}}]},{align:"center",title:'Current Month Actual - Last Year 去年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,'Covers \u4EBA\u6570'),dataIndex:'cm_lastyear_covers',key:'cm_lastyear_covers',align:"center",width:150,render:function render(text,record,index){if(index<20&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('cm_lastyear_covers',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},text);}}},{title:_react2.default.createElement('div',null,'A/C  \u4EBA\u5747\u6D88\u8D39'),dataIndex:'cm_lastyear_ac',key:'cm_lastyear_ac',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},text);}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'cm_lastyear_rev',key:'cm_lastyear_rev',align:"center",width:150,render:function render(text,record,index){if(index<20&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('cm_lastyear_rev',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},text);}}}]},{align:"center",title:'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年',width:900,children:[{title:_react2.default.createElement('div',null,'Covers \u4EBA\u6570'),dataIndex:'cm_comparison_covers',key:'cm_comparison_covers',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:'% 百分比',dataIndex:'cm_covers_percent',key:'cm_covers_percent',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%');}},{title:_react2.default.createElement('div',null,'A/C \u4EBA\u5747\u6D88\u8D39'),dataIndex:'cm_comparison_ac',key:'cm_comparison_ac',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:'% 百分比',dataIndex:'cm_ac_percent',align:"cm_ac_percent",key:'vap_percent',width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%');}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'cm_comparison_rev',key:'cm_comparison_rev',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:'% 百分比',dataIndex:'cm_rev_percent',key:'cm_rev_percent',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%');}}]}]},{title:'YTD 本年累计',align:"center",width:1800,children:[{align:"center",title:'YTD Actual - This Year 本年累计实际数',width:450,children:[{title:_react2.default.createElement('div',null,'Covers \u4EBA\u6570'),dataIndex:'ytd_thisyear_covers',key:'ytd_thisyear_covers',align:"center",width:150,render:function render(text,record,index){if(index<20&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('ytd_thisyear_covers',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}},{title:_react2.default.createElement('div',null,'A/C  \u4EBA\u5747\u6D88\u8D39'),dataIndex:'ytd_thisyear_ac',key:'ytd_thisyear_ac',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'ytd_thisyear_rev',key:'ytd_thisyear_rev',align:"center",width:150,render:function render(text,record,index){if(index<20&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('ytd_thisyear_rev',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}}]},{align:"center",title:'YTD Actual - Last Year 去年累计实际数',width:450,children:[{title:_react2.default.createElement('div',null,'Covers \u4EBA\u6570'),dataIndex:'ytd_lastyear_covers',key:'ytd_lastyear_covers',align:"center",width:150,render:function render(text,record,index){if(index<20){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('ytd_lastyear_covers',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}},{title:_react2.default.createElement('div',null,'A/C  \u4EBA\u5747\u6D88\u8D39'),dataIndex:'ytd_lastyear_ac',key:'ytd_lastyear_ac',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'ytd_lastyear_rev',key:'ytd_lastyear_rev',align:"center",width:150,render:function render(text,record,index){if(index<20&&!print){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('ytd_lastyear_rev',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}}]},{align:"center",title:'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',width:900,children:[{title:_react2.default.createElement('div',null,'Covers \u4EBA\u6570'),dataIndex:'ytd_comparison_covers',key:'ytd_comparison_covers',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding  '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:'% 百分比',dataIndex:'ytd_covers_percent',key:'ytd_covers_percent',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%');}},{title:_react2.default.createElement('div',null,'A/C \u4EBA\u5747\u6D88\u8D39'),dataIndex:'ytd_comparison_ac',key:'ytd_comparison_ac',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:'% 百分比',dataIndex:'ytd_ac_percent',align:"center",key:'ytd_ac_percent',width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%');}},{title:_react2.default.createElement('div',null,'REV \u6536\u76CA'),dataIndex:'ytd_comparison_rev',key:'ytd_comparison_rev',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:'% 百分比',dataIndex:'ytd_rev_percent',key:'ytd_rev_percent',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index<20?'':'table-color-footer')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%');}}]}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table5_6_2',style:{width:this.state.print?3950:'auto'}},_react2.default.createElement(_row2.default,null,'5.6.2 Top 20  F&B Individual Account \u9910\u996E\u6D88\u8D39\u4E2A\u4EBA\u8D26\u53F7\u6392\u540D\u524D\u4E8C\u5341\u4F4D '),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true,note:{note:""}});_this2.getTable5_6_2(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'export5_6_2',pagination:false,className:'content',style:{width:this.state.print?3900:'auto'},scroll:this.state.print?{}:{x:3900,y:550},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this2.setState({print:true,loading:true},function(){(0,_ExportExcel2.default)({id:"export5_6_2",date:date,name:"5.6.2 Top 20 F&B Individual Account 餐饮消费个人账号排名前二十位"});_this2.setState({print:false,loading:false});});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_5_6'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data5_6_2=exports.data5_6_2=[{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0},{top20_account:'Sub-Total 小计',//名称
cm_thisyear_covers:0,cm_thisyear_ac:0,cm_thisyear_rev:0,cm_lastyear_covers:0,cm_lastyear_ac:0,cm_lastyear_rev:0,cm_comparison_covers:0,cm_covers_percent:0,cm_comparison_ac:0,cm_ac_percent:0,cm_comparison_rev:0,cm_rev_percent:0,ytd_thisyear_covers:0,ytd_thisyear_ac:0,ytd_thisyear_rev:0,ytd_lastyear_covers:0,ytd_lastyear_ac:0,ytd_lastyear_rev:0,ytd_comparison_covers:0,ytd_covers_percent:0,ytd_comparison_ac:0,ytd_ac_percent:0,ytd_comparison_rev:0,ytd_rev_percent:0}];

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.index=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _=__webpack_require__(1933);var _2=_interopRequireDefault(_);var _3=__webpack_require__(1935);var _4=_interopRequireDefault(_3);__webpack_require__(1937);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=exports.index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"tb5_8"},_react2.default.createElement("div",{className:"tb5_8-title"},"5.8 Chinese Restaurant Top 10 Favorite & Unpopular Dish Sales Summary \u4E2D\u9910\u5385\u83DC\u54C1\u9500\u552E\u603B\u7ED3\u76D8\u70B9"),_react2.default.createElement(_2.default,this.props),_react2.default.createElement(_4.default,this.props));}}]);return index;}(_react.Component);;exports.default=index;

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(1934);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _ExportExcel=__webpack_require__(79);var _ExportExcel2=_interopRequireDefault(_ExportExcel);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){data.forEach(function(v,i){data[i].price=(0,_method.calculation)(v.total_sales,v.qty);data[i].total_cost=(v.qty*v.cost).toFixed(2);data[i].percent=(0,_method.calculation)(v.total_cost,v.total_sales,4);});_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getData=function(date){fetch('/_5_8_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){var data=JSON.parse(JSON.stringify(_data.dataDefault));var d=(0,_method.getJson)(['data','data'],x,[]);if(d.length>0)data=d;_this.computeNum(data);_this.setState({loading:false});}).catch(function(err){console.error(err);_this.setState({loading:false});});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_5_8_1',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table5_6_1',1.5,'5.81',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],note:{note:""},loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData(this.state.date);}// 获取表格5_6_1内容
// 保存表格5-6-1内容
},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print;var columns=[{title:"Food Items 食品项目",children:[{title:"NO.",dataIndex:'sort',key:'sort',align:"center",width:50,render:function render(text){return text+1;}},{title:"Description 描述",dataIndex:'des',key:'des',align:"center",width:300,render:function render(text,record,index){if(print)return text;var props={text:text,index:index,type:'input',name:"des",onChange:_this2.onChange};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Qty 数量",dataIndex:'qty',key:'qty',align:"center",width:150,render:function render(text,record,index){if(print)return text;var props={text:text,index:index,type:'inputNumber',name:"qty",onChange:_this2.onChange,compared:{title:["Qty 数量"],record:record,sqlName:"_5_8_1"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Unit cost 单位成本",dataIndex:'cost',key:'cost',align:"center",width:150,render:function render(text,record,index){if(print)return text;var props={text:text,index:index,type:'inputNumber',name:"cost",onChange:_this2.onChange,compared:{title:["Unit cost 单位成本"],record:record,sqlName:"_5_8_1"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Unit Price 单价",dataIndex:'price',key:'price',align:"center",width:150,render:function render(text,record,index){if(print)return text;var props={text:text,index:index,type:'number',name:"price",onChange:_this2.onChange,compared:{title:["Unit Price 单价"],record:record,sqlName:"_5_8_1"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Total cost 总成本",dataIndex:'total_cost',key:'total_cost',align:"center",width:150,render:function render(text,record,index){if(print)return text;var props={text:text,index:index,type:'number',name:"total_cost",onChange:_this2.onChange,compared:{title:["Total cost 总成本"],record:record,sqlName:"_5_8_1"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Total sales 销售总额",dataIndex:'total_sales',key:'total_sales',align:"center",width:150,render:function render(text,record,index){if(print)return text;var props={text:text,index:index,type:'inputNumber',name:"total_sales",onChange:_this2.onChange,compared:{title:["Total sales 销售总额"],record:record,sqlName:"_5_8_1"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Cost% 成本百分比",dataIndex:'percent',key:'percent',align:"center",width:150,render:function render(text,record,index){if(print)return text;var props={text:text,index:index,type:'percent',name:"percent",onChange:_this2.onChange,compared:{title:["Cost% 成本百分比"],record:record,sqlName:"_5_8_1"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title ',id:'table5_6_1'},_react2.default.createElement(_row2.default,null,'5.8.1  Top 10 Favorite \u5341\u5927\u53D7\u6B22\u8FCE\u83DC\u54C1  '),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true,note:{note:""}});_this2.getData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'export5_8_1',pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this2.setState({print:true,loading:true},function(){(0,_ExportExcel2.default)({id:"export5_8_1",date:date,name:"5.8.1 Top 10 Favorite 十大受欢迎菜品"});_this2.setState({print:false,loading:false});});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_5_8'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var dataDefault=exports.dataDefault=[{sort:0,des:"",qty:0,cost:0,price:0,total_cost:0,total_sales:0,percent:0},{sort:1,des:"",qty:0,cost:0,price:0,total_cost:0,total_sales:0,percent:0},{sort:2,des:"",qty:0,cost:0,price:0,total_cost:0,total_sales:0,percent:0},{sort:3,des:"",qty:0,cost:0,price:0,total_cost:0,total_sales:0,percent:0},{sort:4,des:"",qty:0,cost:0,price:0,total_cost:0,total_sales:0,percent:0},{sort:5,des:"",qty:0,cost:0,price:0,total_cost:0,total_sales:0,percent:0},{sort:6,des:"",qty:0,cost:0,price:0,total_cost:0,total_sales:0,percent:0},{sort:7,des:"",qty:0,cost:0,price:0,total_cost:0,total_sales:0,percent:0},{sort:8,des:"",qty:0,cost:0,price:0,total_cost:0,total_sales:0,percent:0},{sort:9,des:"",qty:0,cost:0,price:0,total_cost:0,total_sales:0,percent:0}];

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(1936);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _ExportExcel=__webpack_require__(79);var _ExportExcel2=_interopRequireDefault(_ExportExcel);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){data.forEach(function(v,i){data[i].price=(0,_method.calculation)(v.total_sales,v.qty);data[i].total_cost=(v.qty*v.cost).toFixed(2);data[i].percent=(0,_method.calculation)(v.total_cost,v.total_sales,4);});_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getData=function(date){fetch('/_5_8_2_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){var data=JSON.parse(JSON.stringify(_data.dataDefault));var d=(0,_method.getJson)(['data','data'],x,[]);if(d.length>0)data=d;_this.computeNum(data);_this.setState({loading:false});}).catch(function(err){console.error(err);_this.setState({loading:false});});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_5_8_2',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table5_6_1',1.5,'5.82',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],note:{note:""},loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData(this.state.date);}// 获取表格5_6_1内容
// 保存表格5-6-1内容
},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print;var columns=[{title:"Food Items 食品项目",children:[{title:"NO.",dataIndex:'sort',key:'sort',align:"center",width:50,render:function render(text){return text+1;}},{title:"Description 描述",dataIndex:'des',key:'des',align:"center",width:300,render:function render(text,record,index){if(print)return text;var props={text:text,index:index,type:'input',name:"des",onChange:_this2.onChange};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Qty 数量",dataIndex:'qty',key:'qty',align:"center",width:150,render:function render(text,record,index){if(print)return text;var props={text:text,index:index,type:'inputNumber',name:"qty",onChange:_this2.onChange,compared:{title:["Qty 数量"],record:record,sqlName:"_5_8_2"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Unit cost 单位成本",dataIndex:'cost',key:'cost',align:"center",width:150,render:function render(text,record,index){if(print)return text;var props={text:text,index:index,type:'inputNumber',name:"cost",onChange:_this2.onChange,compared:{title:["Unit cost 单位成本"],record:record,sqlName:"_5_8_2"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Unit Price 单价",dataIndex:'price',key:'price',align:"center",width:150,render:function render(text,record,index){if(print)return text;var props={text:text,index:index,type:'number',name:"price",onChange:_this2.onChange,compared:{title:["Unit Price 单价"],record:record,sqlName:"_5_8_2"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Total cost 总成本",dataIndex:'total_cost',key:'total_cost',align:"center",width:150,render:function render(text,record,index){if(print)return text;var props={text:text,index:index,type:'number',name:"total_cost",onChange:_this2.onChange,compared:{title:["Total cost 总成本"],record:record,sqlName:"_5_8_2"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Total sales 销售总额",dataIndex:'total_sales',key:'total_sales',align:"center",width:150,render:function render(text,record,index){if(print)return text;var props={text:text,index:index,type:'inputNumber',name:"total_sales",onChange:_this2.onChange,compared:{title:["Total sales 销售总额"],record:record,sqlName:"_5_8_2"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:"Cost% 成本百分比",dataIndex:'percent',key:'percent',align:"center",width:150,render:function render(text,record,index){if(print)return text;var props={text:text,index:index,type:'percent',name:"percent",onChange:_this2.onChange,compared:{title:["Cost% 成本百分比"],record:record,sqlName:"_5_8_2"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title ',id:'table5_6_1'},_react2.default.createElement(_row2.default,null,'5.8.2 Top 10 Unpopular  \u5341\u5927\u4E0D\u53D7\u6B22\u8FCE\u83DC\u54C1  '),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true,note:{note:""}});_this2.getData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'export5_8_2',pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this2.setState({print:true,loading:true},function(){(0,_ExportExcel2.default)({id:"export5_8_2",date:date,name:"5.8.2 Top 10 Unpopular 十大不受欢迎菜品"});_this2.setState({print:false,loading:false});});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_5_8'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var dataDefault=exports.dataDefault=[{sort:0,des:"",qty:0,cost:0,price:0,total_cost:0,total_sales:0,percent:0},{sort:1,des:"",qty:0,cost:0,price:0,total_cost:0,total_sales:0,percent:0},{sort:2,des:"",qty:0,cost:0,price:0,total_cost:0,total_sales:0,percent:0},{sort:3,des:"",qty:0,cost:0,price:0,total_cost:0,total_sales:0,percent:0},{sort:4,des:"",qty:0,cost:0,price:0,total_cost:0,total_sales:0,percent:0},{sort:5,des:"",qty:0,cost:0,price:0,total_cost:0,total_sales:0,percent:0},{sort:6,des:"",qty:0,cost:0,price:0,total_cost:0,total_sales:0,percent:0},{sort:7,des:"",qty:0,cost:0,price:0,total_cost:0,total_sales:0,percent:0},{sort:8,des:"",qty:0,cost:0,price:0,total_cost:0,total_sales:0,percent:0},{sort:9,des:"",qty:0,cost:0,price:0,total_cost:0,total_sales:0,percent:0}];

/***/ }),
/* 1937 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.index=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _=__webpack_require__(1939);var _2=_interopRequireDefault(_);var _3=__webpack_require__(1940);var _4=_interopRequireDefault(_3);var _5=__webpack_require__(1941);var _6=_interopRequireDefault(_5);__webpack_require__(1942);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=exports.index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"tb5_8 tb5_9"},_react2.default.createElement("div",{className:"tb5_8-title"},"5.9 \u7F8E\u56E2\u70B9\u8BC4\u5957\u9910\u9500\u91CF\u7EDF\u8BA1 Meituan Dianping Package Sales Summary"),_react2.default.createElement(_2.default,this.props),_react2.default.createElement(_4.default,this.props),_react2.default.createElement(_6.default,this.props));}}]);return index;}(_react.Component);;exports.default=index;

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _data2=__webpack_require__(439);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _Title=__webpack_require__(440);var _Title2=_interopRequireDefault(_Title);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){data.forEach(function(v,i){data[i].price=(0,_method.calculation)(v.total_sales,v.qty);data[i].total_cost=(v.qty*v.cost).toFixed(2);data[i].percent=(0,_method.calculation)(v.total_cost,v.total_sales,4);});};_this.onChange=function(name,value,i){var data=_this.state.dataReview;data[i][name]=value;_this.setState({dataReview:data});};_this.getData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var res,data,dataReview,dataPackage,dataRecommend;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_request2.default)('/es5_9?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M')+'&type=1');case 2:res=_context.sent;data=JSON.parse(JSON.stringify(_data2.defaultData));dataReview=JSON.parse(JSON.stringify(_data2.data1));dataPackage=JSON.parse(JSON.stringify(_data2.data2));dataRecommend=JSON.parse(JSON.stringify(_data2.data3));if(res.data.data)data=res.data.data;if(res.data.dataReview&&res.data.dataReview.length)dataReview=res.data.dataReview.sort(function(a,b){return a.sort-b.sort;});if(res.data.dataPackage&&res.data.dataPackage.length)dataPackage=res.data.dataPackage.sort(function(a,b){return a.sort-b.sort;});if(res.data.dataRecommend&&res.data.dataRecommend.length)dataRecommend=res.data.dataRecommend.sort(function(a,b){return a.sort-b.sort;});_this.setState({loading:false,data:data,dataReview:dataReview,dataPackage:dataPackage,dataRecommend:dataRecommend});case 12:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var _this$state,date,data,dataReview,dataPackage,dataRecommend,_timer,year,month,dataFrom,headres,x,timer,_timer2;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_this.setState({loadingSave:true});_this$state=_this.state,date=_this$state.date,data=_this$state.data,dataReview=_this$state.dataReview,dataPackage=_this$state.dataPackage,dataRecommend=_this$state.dataRecommend;if(date){_context2.next=7;break;}_message3.default.error('请选择年份月份');_timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer);},1000);return _context2.abrupt('return');case 7:year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");data=[_extends({},data,{year:year,month:month,t_type:1})];dataReview=dataReview.map(function(x){return _extends({},x,{year:year,month:month,t_type:1});});dataPackage=dataPackage.map(function(x){return _extends({},x,{year:year,month:month,t_type:1});});dataRecommend=dataRecommend.map(function(x){return _extends({},x,{year:year,month:month,t_type:1});});dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));dataFrom.append('dataReview',JSON.stringify(dataReview));dataFrom.append('dataPackage',JSON.stringify(dataPackage));dataFrom.append('dataRecommend',JSON.stringify(dataRecommend));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context2.next=21;return(0,_request2.default)('/add5_9',headres);case 21:x=_context2.sent;timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(!(x.status==1)){_context2.next=27;break;}_message3.default.success(x.msg);if(!data[0].id){_this.getData(_this.state.date);}return _context2.abrupt('return');case 27:_message3.default.error(x.msg);_context2.next=35;break;case 30:_context2.prev=30;_context2.t0=_context2['catch'](0);_timer2=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer2);},1000);console.error(_context2.t0);_message3.default.error('保存失败'+JSON.stringify(_context2.t0));case 35:case'end':return _context2.stop();}}},_callee2,_this2,[[0,30]]);}));_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table5_6_1',1.5,'5.91',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:{},dataReview:[],dataPackage:[],dataRecommend:[],note:{note:""},loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData(this.state.date);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,data=_state.data,dataReview=_state.dataReview,dataPackage=_state.dataPackage,dataRecommend=_state.dataRecommend,loading=_state.loading;return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title ',id:'table5_6_1'},_react2.default.createElement(_row2.default,{className:'subtitle'},'\u897F\u9910\u5385'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:{},dataReview:[],dataPackage:[],dataRecommend:[],loading:true,note:{note:""}});_this3.getData(str);}})),!loading&&_react2.default.createElement(_Title2.default,{data:data,t_type:1,name:'\u897F\u9910\u5385',onChange:function onChange(name,value){var _data=_extends({},data);_data[name]=value;_this3.setState({data:_data});}}),_react2.default.createElement('div',{className:'list'},_react2.default.createElement('span',{className:'list-name'},'\u699C\u5355\u4E0A\u699C\u60C5\u51B5'),_react2.default.createElement(_table2.default,{columns:(0,_data2.columns1)({onChange:this.onChange,t_type:1}),dataSource:dataReview,size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(v){return v.sort;}})),_react2.default.createElement('div',{className:'list'},_react2.default.createElement('span',{className:'list-name'},'\u5957\u9910\u60C5\u51B5'),_react2.default.createElement(_table2.default,{columns:(0,_data2.columns2)({onChange:function onChange(name,value,i){var data=_this3.state.dataPackage;data[i][name]=value;_this3.setState({dataPackage:data});},t_type:1}),dataSource:dataPackage,size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(v){return v.sort;}})),_react2.default.createElement('div',{className:'list'},_react2.default.createElement('span',{className:'list-name'},'\u63A8\u8350\u83DC\u54C1 TOP3'),_react2.default.createElement(_table2.default,{columns:(0,_data2.columns3)({onChange:function onChange(name,value,i){var data=_this3.state.dataRecommend;data[i][name]=value;_this3.setState({dataRecommend:data});},t_type:1}),dataSource:dataRecommend,size:'middle',bordered:true,pagination:false,className:'content',style:{width:600},rowKey:function rowKey(v){return v.sort;}}))),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_5_9'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _data2=__webpack_require__(439);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _Title=__webpack_require__(440);var _Title2=_interopRequireDefault(_Title);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){data.forEach(function(v,i){data[i].price=(0,_method.calculation)(v.total_sales,v.qty);data[i].total_cost=(v.qty*v.cost).toFixed(2);data[i].percent=(0,_method.calculation)(v.total_cost,v.total_sales,4);});};_this.onChange=function(name,value,i){var data=_this.state.dataReview;data[i][name]=value;_this.setState({dataReview:data});};_this.getData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var res,data,dataReview,dataPackage,dataRecommend;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_request2.default)('/es5_9?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M')+'&type=2');case 2:res=_context.sent;data=JSON.parse(JSON.stringify(_data2.defaultData));dataReview=JSON.parse(JSON.stringify(_data2.data1));dataPackage=JSON.parse(JSON.stringify(_data2.data2));dataRecommend=JSON.parse(JSON.stringify(_data2.data3));if(res.data.data)data=res.data.data;if(res.data.dataReview&&res.data.dataReview.length)dataReview=res.data.dataReview.sort(function(a,b){return a.sort-b.sort;});if(res.data.dataPackage&&res.data.dataPackage.length)dataPackage=res.data.dataPackage.sort(function(a,b){return a.sort-b.sort;});if(res.data.dataRecommend&&res.data.dataRecommend.length)dataRecommend=res.data.dataRecommend.sort(function(a,b){return a.sort-b.sort;});_this.setState({loading:false,data:data,dataReview:dataReview,dataPackage:dataPackage,dataRecommend:dataRecommend});case 12:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var _this$state,date,data,dataReview,dataPackage,dataRecommend,_timer,year,month,dataFrom,headres,x,timer,_timer2;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_this.setState({loadingSave:true});_this$state=_this.state,date=_this$state.date,data=_this$state.data,dataReview=_this$state.dataReview,dataPackage=_this$state.dataPackage,dataRecommend=_this$state.dataRecommend;if(date){_context2.next=7;break;}_message3.default.error('请选择年份月份');_timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer);},1000);return _context2.abrupt('return');case 7:year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");data=[_extends({},data,{year:year,month:month,t_type:2})];dataReview=dataReview.map(function(x){return _extends({},x,{year:year,month:month,t_type:2});});dataPackage=dataPackage.map(function(x){return _extends({},x,{year:year,month:month,t_type:2});});dataRecommend=dataRecommend.map(function(x){return _extends({},x,{year:year,month:month,t_type:2});});dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));dataFrom.append('dataReview',JSON.stringify(dataReview));dataFrom.append('dataPackage',JSON.stringify(dataPackage));dataFrom.append('dataRecommend',JSON.stringify(dataRecommend));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context2.next=21;return(0,_request2.default)('/add5_9',headres);case 21:x=_context2.sent;timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(!(x.status==1)){_context2.next=27;break;}_message3.default.success(x.msg);if(!data[0].id){_this.getData(_this.state.date);}return _context2.abrupt('return');case 27:_message3.default.error(x.msg);_context2.next=35;break;case 30:_context2.prev=30;_context2.t0=_context2['catch'](0);_timer2=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer2);},1000);console.error(_context2.t0);_message3.default.error('保存失败'+JSON.stringify(_context2.t0));case 35:case'end':return _context2.stop();}}},_callee2,_this2,[[0,30]]);}));_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table5_6_2',1.5,'5.92',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:{},dataReview:[],dataPackage:[],dataRecommend:[],note:{note:""},loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData(this.state.date);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,data=_state.data,dataReview=_state.dataReview,dataPackage=_state.dataPackage,dataRecommend=_state.dataRecommend,loading=_state.loading;return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title ',id:'table5_6_2'},_react2.default.createElement(_row2.default,{className:'subtitle'},'\u4E2D\u9910\u5385'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:{},dataReview:[],dataPackage:[],dataRecommend:[],loading:true,note:{note:""}});_this3.getData(str);}})),!loading&&_react2.default.createElement(_Title2.default,{data:data,t_type:2,name:'\u4E2D\u9910\u5385',onChange:function onChange(name,value){var _data=_extends({},data);_data[name]=value;_this3.setState({data:_data});}}),_react2.default.createElement('div',{className:'list'},_react2.default.createElement('span',{className:'list-name'},'\u699C\u5355\u4E0A\u699C\u60C5\u51B5'),_react2.default.createElement(_table2.default,{columns:(0,_data2.columns1)({onChange:this.onChange,t_type:2}),dataSource:dataReview,size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(v){return v.sort;}})),_react2.default.createElement('div',{className:'list'},_react2.default.createElement('span',{className:'list-name'},'\u5957\u9910\u60C5\u51B5'),_react2.default.createElement(_table2.default,{columns:(0,_data2.columns2)({onChange:function onChange(name,value,i){var data=_this3.state.dataPackage;data[i][name]=value;_this3.setState({dataPackage:data});},t_type:2}),dataSource:dataPackage,size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(v){return v.sort;}})),_react2.default.createElement('div',{className:'list'},_react2.default.createElement('span',{className:'list-name'},'\u63A8\u8350\u83DC\u54C1 TOP3'),_react2.default.createElement(_table2.default,{columns:(0,_data2.columns3)({onChange:function onChange(name,value,i){var data=_this3.state.dataRecommend;data[i][name]=value;_this3.setState({dataRecommend:data});},t_type:2}),dataSource:dataRecommend,size:'middle',bordered:true,pagination:false,className:'content',style:{width:600},rowKey:function rowKey(v){return v.sort;}}))),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_5_9'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _data2=__webpack_require__(439);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _Title=__webpack_require__(440);var _Title2=_interopRequireDefault(_Title);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){data.forEach(function(v,i){data[i].price=(0,_method.calculation)(v.total_sales,v.qty);data[i].total_cost=(v.qty*v.cost).toFixed(2);data[i].percent=(0,_method.calculation)(v.total_cost,v.total_sales,4);});};_this.onChange=function(name,value,i){var data=_this.state.dataReview;data[i][name]=value;_this.setState({dataReview:data});};_this.getData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var res,data,dataReview,dataPackage,dataRecommend;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_request2.default)('/es5_9?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M')+'&type=3');case 2:res=_context.sent;data=JSON.parse(JSON.stringify(_data2.defaultData));dataReview=JSON.parse(JSON.stringify(_data2.data1));dataPackage=JSON.parse(JSON.stringify(_data2.data2));dataRecommend=JSON.parse(JSON.stringify(_data2.data3));if(res.data.data)data=res.data.data;if(res.data.dataReview&&res.data.dataReview.length)dataReview=res.data.dataReview.sort(function(a,b){return a.sort-b.sort;});if(res.data.dataPackage&&res.data.dataPackage.length)dataPackage=res.data.dataPackage.sort(function(a,b){return a.sort-b.sort;});if(res.data.dataRecommend&&res.data.dataRecommend.length)dataRecommend=res.data.dataRecommend.sort(function(a,b){return a.sort-b.sort;});_this.setState({loading:false,data:data,dataReview:dataReview,dataPackage:dataPackage,dataRecommend:dataRecommend});case 12:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var _this$state,date,data,dataReview,dataPackage,dataRecommend,_timer,year,month,dataFrom,headres,x,timer,_timer2;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_this.setState({loadingSave:true});_this$state=_this.state,date=_this$state.date,data=_this$state.data,dataReview=_this$state.dataReview,dataPackage=_this$state.dataPackage,dataRecommend=_this$state.dataRecommend;if(date){_context2.next=7;break;}_message3.default.error('请选择年份月份');_timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer);},1000);return _context2.abrupt('return');case 7:year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");data=[_extends({},data,{year:year,month:month,t_type:3})];dataReview=dataReview.map(function(x){return _extends({},x,{year:year,month:month,t_type:3});});dataPackage=dataPackage.map(function(x){return _extends({},x,{year:year,month:month,t_type:3});});dataRecommend=dataRecommend.map(function(x){return _extends({},x,{year:year,month:month,t_type:3});});dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));dataFrom.append('dataReview',JSON.stringify(dataReview));dataFrom.append('dataPackage',JSON.stringify(dataPackage));dataFrom.append('dataRecommend',JSON.stringify(dataRecommend));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context2.next=21;return(0,_request2.default)('/add5_9',headres);case 21:x=_context2.sent;timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(!(x.status==1)){_context2.next=27;break;}_message3.default.success(x.msg);if(!data[0].id){_this.getData(_this.state.date);}return _context2.abrupt('return');case 27:_message3.default.error(x.msg);_context2.next=35;break;case 30:_context2.prev=30;_context2.t0=_context2['catch'](0);_timer2=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer2);},1000);console.error(_context2.t0);_message3.default.error('保存失败'+JSON.stringify(_context2.t0));case 35:case'end':return _context2.stop();}}},_callee2,_this2,[[0,30]]);}));_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table5_6_3',1.5,'5.93',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:{},dataReview:[],dataPackage:[],dataRecommend:[],note:{note:""},loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData(this.state.date);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,data=_state.data,dataReview=_state.dataReview,dataPackage=_state.dataPackage,dataRecommend=_state.dataRecommend,loading=_state.loading;return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title ',id:'table5_6_3'},_react2.default.createElement(_row2.default,{className:'subtitle'},'\u5176\u4ED6\u9910\u5385'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:{},dataReview:[],dataPackage:[],dataRecommend:[],loading:true,note:{note:""}});_this3.getData(str);}})),!loading&&_react2.default.createElement(_Title2.default,{data:data,t_type:3,name:'\u5176\u4ED6\u9910\u5385',onChange:function onChange(name,value){var _data=_extends({},data);_data[name]=value;_this3.setState({data:_data});}}),_react2.default.createElement('div',{className:'list'},_react2.default.createElement('span',{className:'list-name'},'\u699C\u5355\u4E0A\u699C\u60C5\u51B5'),_react2.default.createElement(_table2.default,{columns:(0,_data2.columns1)({onChange:this.onChange,t_type:3}),dataSource:dataReview,size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(v){return v.sort;}})),_react2.default.createElement('div',{className:'list'},_react2.default.createElement('span',{className:'list-name'},'\u5957\u9910\u60C5\u51B5'),_react2.default.createElement(_table2.default,{columns:(0,_data2.columns2)({onChange:function onChange(name,value,i){var data=_this3.state.dataPackage;data[i][name]=value;_this3.setState({dataPackage:data});},t_type:3}),dataSource:dataPackage,size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(v){return v.sort;}})),_react2.default.createElement('div',{className:'list'},_react2.default.createElement('span',{className:'list-name'},'\u63A8\u8350\u83DC\u54C1 TOP3'),_react2.default.createElement(_table2.default,{columns:(0,_data2.columns3)({onChange:function onChange(name,value,i){var data=_this3.state.dataRecommend;data[i][name]=value;_this3.setState({dataRecommend:data});},t_type:3}),dataSource:dataRecommend,size:'middle',bordered:true,pagination:false,className:'content',style:{width:600},rowKey:function rowKey(v){return v.sort;}}))),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_5_9'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1942 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.index=undefined;var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(4);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Table5_10_=__webpack_require__(1944);var _Table5_10_2=_interopRequireDefault(_Table5_10_);var _Table5_10_3=__webpack_require__(1945);var _Table5_10_4=_interopRequireDefault(_Table5_10_3);var _Table5_10_5=__webpack_require__(1946);var _Table5_10_6=_interopRequireDefault(_Table5_10_5);var _Table5_10_7=__webpack_require__(1947);var _Table5_10_8=_interopRequireDefault(_Table5_10_7);var _Table5_10_9=__webpack_require__(1948);var _Table5_10_10=_interopRequireDefault(_Table5_10_9);var _Table5_10_11=__webpack_require__(1949);var _Table5_10_12=_interopRequireDefault(_Table5_10_11);var _Table5_10_13=__webpack_require__(1950);var _Table5_10_14=_interopRequireDefault(_Table5_10_13);var _Table5_10_15=__webpack_require__(1951);var _Table5_10_16=_interopRequireDefault(_Table5_10_15);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _compute=__webpack_require__(1952);var _compute2=_interopRequireDefault(_compute);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _ExportExcel=__webpack_require__(79);var _ExportExcel2=_interopRequireDefault(_ExportExcel);__webpack_require__(1953);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=exports.index=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:{},loading:true,loadingSave:false,print:false},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_request2.default)("/es5_10Info?year="+(0,_moment2.default)(date).format('YYYY')+"&month="+(0,_moment2.default)(date).format('M'));case 2:res=_context.sent;_this.setState({loading:false,data:(0,_compute2.default)(res.data)});case 4:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table5_6_1',1.5,'5.10',_this.state.date).then(function(x){if(x.status==1){message.info('添加成功！');}else{message.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});},_this.onExport=function(id){var name=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"单店分析";_this.setState({print:true,loading:true},function(){(0,_ExportExcel2.default)({id:id,date:_this.state.date,name:name});_this.setState({print:false,loading:false});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,loading=_state.loading,print=_state.print;return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement("div",{className:"table7_1_1"},_react2.default.createElement(_row2.default,{className:"title ",id:"table5_6_1",style:{width:print?3400:'auto'}},_react2.default.createElement(_row2.default,{className:"subtitle"},"5.10 \u5355\u5E97\u5206\u6790"),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:"YYYY-MM",onChange:function onChange(date,str){_this3.setState({date:str,data:{},loading:true});_this3.getData(str);}})),_react2.default.createElement(_Table5_10_2.default,Object.assign({},this.props,{data:data,print:print,onExport:this.onExport})),_react2.default.createElement(_Table5_10_4.default,Object.assign({},this.props,{data:data,print:print,onExport:this.onExport})),_react2.default.createElement(_Table5_10_6.default,Object.assign({},this.props,{data:data,print:print,onExport:this.onExport})),_react2.default.createElement(_Table5_10_8.default,Object.assign({},this.props,{data:data,print:print,onExport:this.onExport})),_react2.default.createElement(_Table5_10_10.default,Object.assign({},this.props,{data:data,print:print,onExport:this.onExport})),_react2.default.createElement(_Table5_10_12.default,Object.assign({},this.props,{data:data,print:print,onExport:this.onExport})),_react2.default.createElement(_Table5_10_14.default,Object.assign({},this.props,{data:data,print:print,onExport:this.onExport})),_react2.default.createElement(_Table5_10_16.default,Object.assign({},this.props,{data:data,print:print,onExport:this.onExport}))),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:"edit_5_9"},_react2.default.createElement(_row2.default,{className:"table-footer-btn"},_react2.default.createElement(_button2.default,{type:"primary",style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},"\u52A0\u5165pdf")))));}}]);return index;}(_react.Component);;exports.default=index;

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(6);__webpack_require__(8);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _data=__webpack_require__(138);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){var _props=this.props,data=_props.data,print=_props.print,onExport=_props.onExport;return _react2.default.createElement('div',null,_react2.default.createElement(_table2.default,{columns:(0,_data.columns1)(print),dataSource:data.data1,size:'middle',bordered:true,id:'table5_10_1',pagination:false,className:'content',scroll:print?{}:{x:3350,y:false},rowKey:function rowKey(v){return v.sort;}}),print?null:_react2.default.createElement(_button2.default,{className:'export-btn',type:'primary',onClick:function onClick(){return onExport('table5_10_1');},loading:print},'\u5BFC\u51FAExcel'));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(6);__webpack_require__(8);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _data=__webpack_require__(138);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){var _props=this.props,data=_props.data,print=_props.print,onExport=_props.onExport;return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:'table-title'},'Banquet Key Performance Indicator \u5BB4\u4F1A\u5173\u952E\u7EE9\u6548\u6307\u6570'),_react2.default.createElement(_table2.default,{columns:(0,_data.columns2)(),dataSource:data.data2,size:'middle',bordered:true,id:'table5_10_2',pagination:false,className:'content',scroll:print?{}:{x:3350,y:false},rowKey:function rowKey(v){return v.sort;}}),print?null:_react2.default.createElement(_button2.default,{className:'export-btn',type:'primary',onClick:function onClick(){return onExport('table5_10_2','Banquet Key Performance Indicator 宴会关键绩效指数');},loading:print},'\u5BFC\u51FAExcel'));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(6);__webpack_require__(8);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _data=__webpack_require__(138);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){var _props=this.props,data=_props.data,print=_props.print,onExport=_props.onExport;return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:'table-title'},'Coffee Shop Key Performance Indicator \u5496\u5561\u5385\u5173\u952E\u7EE9\u6548\u6307\u6570'),_react2.default.createElement(_table2.default,{columns:(0,_data.columns3)(),dataSource:data.data3,size:'middle',bordered:true,pagination:false,className:'content',id:'table5_10_3',scroll:print?{}:{x:3350,y:false},rowKey:function rowKey(v){return v.sort;}}),print?null:_react2.default.createElement(_button2.default,{className:'export-btn',type:'primary',onClick:function onClick(){return onExport('table5_10_3','Coffee Shop Key Performance Indicator 咖啡厅关键绩效指数');},loading:print},'\u5BFC\u51FAExcel'));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(6);__webpack_require__(8);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _data=__webpack_require__(138);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){var _props=this.props,data=_props.data,print=_props.print,onExport=_props.onExport;return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:'table-title'},'Chinese Restaurant Key Performance Indicator \u4E2D\u9910\u5385\u5173\u952E\u7EE9\u6548\u6307\u6570'),_react2.default.createElement(_table2.default,{columns:(0,_data.columns4)(),dataSource:data.data4,size:'middle',bordered:true,id:'table5_10_4',pagination:false,className:'content',scroll:print?{}:{x:3350,y:false},rowKey:function rowKey(v){return v.sort;}}),print?null:_react2.default.createElement(_button2.default,{className:'export-btn',type:'primary',onClick:function onClick(){return onExport('table5_10_4','Chinese Restaurant Key Performance Indicator 中餐厅关键绩效指数');},loading:print},'\u5BFC\u51FAExcel'));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(6);__webpack_require__(8);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _data=__webpack_require__(138);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){var _props=this.props,data=_props.data,print=_props.print,onExport=_props.onExport;return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:'table-title'},'Special Restaurant Key Performance Indicator \u7279\u8272\u9910\u5385\u5173\u952E\u7EE9\u6548\u6307\u6570'),_react2.default.createElement(_table2.default,{columns:(0,_data.columns5)(),dataSource:data.data5,size:'middle',bordered:true,pagination:false,className:'content',id:'table5_10_5',scroll:print?{}:{x:3350,y:false},rowKey:function rowKey(v){return v.sort;}}),print?null:_react2.default.createElement(_button2.default,{className:'export-btn',type:'primary',onClick:function onClick(){return onExport('table5_10_5','Special Restaurant Key Performance Indicator 特色餐厅关键绩效指数');},loading:print},'\u5BFC\u51FAExcel'));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(6);__webpack_require__(8);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _data=__webpack_require__(138);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){var _props=this.props,data=_props.data,print=_props.print,onExport=_props.onExport;return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:'table-title'},'Lobby Bar Key Performance Indicator \u5927\u5802\u5427\u5173\u952E\u7EE9\u6548\u6307\u6570'),_react2.default.createElement(_table2.default,{columns:(0,_data.columns6)(),dataSource:data.data6,size:'middle',bordered:true,pagination:false,id:'table5_10_6',className:'content',scroll:print?{}:{x:3350,y:false},rowKey:function rowKey(v){return v.sort;}}),print?null:_react2.default.createElement(_button2.default,{className:'export-btn',type:'primary',onClick:function onClick(){return onExport('table5_10_6','Lobby Bar Key Performance Indicator 大堂吧关键绩效指数');},loading:print},'\u5BFC\u51FAExcel'));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(6);__webpack_require__(8);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _data=__webpack_require__(138);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){var _props=this.props,data=_props.data,print=_props.print,onExport=_props.onExport;return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:'table-title'},'Room Service Key Performance Indicator \u5BA2\u623F\u9001\u9910\u5173\u952E\u7EE9\u6548\u6307\u6570'),_react2.default.createElement(_table2.default,{columns:(0,_data.columns7)(),dataSource:data.data7,size:'middle',bordered:true,pagination:false,className:'content',id:'table5_10_7',scroll:print?{}:{x:3350,y:false},rowKey:function rowKey(v){return v.sort;}}),print?null:_react2.default.createElement(_button2.default,{className:'export-btn',type:'primary',onClick:function onClick(){return onExport('table5_10_7','Room Service Key Performance Indicator 客房送餐关键绩效指数');},loading:print},'\u5BFC\u51FAExcel'));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(6);__webpack_require__(8);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _data=__webpack_require__(138);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){var _props=this.props,data=_props.data,print=_props.print,onExport=_props.onExport;return _react2.default.createElement('div',null,_react2.default.createElement(_table2.default,{columns:(0,_data.columns8)(print),dataSource:data.data,size:'middle',bordered:true,pagination:false,id:'table5_10_8',className:'content',scroll:print?{}:{x:1800,y:false},rowKey:function rowKey(v){return v.sort;}}),print?null:_react2.default.createElement(_button2.default,{className:'export-btn',type:'primary',onClick:function onClick(){return onExport('table5_10_8','Key Performance Indicator 关键数据');}},'\u5BFC\u51FAExcel'));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _data=__webpack_require__(138);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _method=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=function(_ref){var data1_1=_ref.data1_1,data5_0=_ref.data5_0,data5_1_1=_ref.data5_1_1,data5_1_3=_ref.data5_1_3,last1=_ref.last1,last5_0=_ref.last5_0,last5_1_1=_ref.last5_1_1,last5_1_3=_ref.last5_1_3,list2_1=_ref.list2_1,list2_2=_ref.list2_2,max=_ref.max;var data1=_lodash2.default.cloneDeep(_data.data1);var data2=_lodash2.default.cloneDeep(_data.data2);var data3=_lodash2.default.cloneDeep(_data.data2);var data4=_lodash2.default.cloneDeep(_data.data2);var data5=_lodash2.default.cloneDeep(_data.data2);var data6=_lodash2.default.cloneDeep(_data.data2);var data7=_lodash2.default.cloneDeep(_data.data2);var data=_lodash2.default.cloneDeep(_data.data);for(var index=0;index<2;index++){data1[index].fb=_lodash2.default.get(data5_0,'0.ytdActual',0);data1[index].fb_prop=_lodash2.default.get(data5_0,'13.ytdActual',0);data1[index].ac=_lodash2.default.get(data5_1_3,'13.m_AC',0);data1[index].covers=_lodash2.default.get(data5_1_3,'13.m_covers',0);data1[index].fb_profit=_lodash2.default.get(data5_0,'2.ytdActual',0);data1[index].fb_payroll=(0,_method.calculation)(_lodash2.default.get(data5_0,'12.ytdActual',0),_lodash2.default.get(data5_0,'0.ytdActual',0),4);data1[index].fb_sales=_lodash2.default.get(data1_1,'14.year_actual',0);data1[index+2].fb=_lodash2.default.get(data5_0,'0.actual',0);data1[index+2].fb_prop=_lodash2.default.get(data5_0,'13.actual',0);data1[index+2].ac=_lodash2.default.get(data5_1_1,'13.m_AC',0);data1[index+2].covers=_lodash2.default.get(data5_1_1,'13.m_covers',0);data1[index+2].fb_profit=_lodash2.default.get(data5_0,'2.actual',0);data1[index+2].fb_payroll=(0,_method.calculation)(_lodash2.default.get(data5_0,'12.actual',0),_lodash2.default.get(data5_0,'0.actual',0),4);data1[index+2].fb_sales=_lodash2.default.get(data1_1,'14.actual',0);}data1[0].fb_last=_lodash2.default.get(last5_0,'0.ytdActual',0);data1[0].fb_prop_last=_lodash2.default.get(last5_0,'13.ytdActual',0);data1[0].ac_last=_lodash2.default.get(last5_1_3,'13.m_AC',0);data1[0].covers_last=_lodash2.default.get(last5_1_3,'13.m_covers',0);data1[0].fb_profit_last=_lodash2.default.get(last5_0,'2.ytdActual',0);data1[0].fb_payroll_last=(0,_method.calculation)(_lodash2.default.get(last5_0,'12.ytdActual',0),_lodash2.default.get(last5_0,'0.ytdActual',0),4);data1[0].fb_sales_last=_lodash2.default.get(last1,'14.year_actual',0);data1[1].fb_last=_lodash2.default.get(data5_0,'0.ytdBudget',0);data1[1].fb_prop_last=_lodash2.default.get(data5_0,'13.ytdBudget',0);data1[1].ac_last=_lodash2.default.get(data5_1_3,'13.b_AC',0);data1[1].covers_last=_lodash2.default.get(data5_1_3,'13.b_covers',0);data1[1].fb_profit_last=_lodash2.default.get(data5_0,'2.ytdBudget',0);data1[1].fb_payroll_last=(0,_method.calculation)(_lodash2.default.get(data5_0,'12.ytdBudget',0),_lodash2.default.get(data5_0,'0.ytdBudget',0),4);data1[1].fb_sales_last=_lodash2.default.get(data1_1,'14.year_budget',0);data1[2].fb_last=_lodash2.default.get(last5_0,'0.actual',0);data1[2].fb_prop_last=_lodash2.default.get(last5_0,'13.actual',0);data1[2].ac_last=_lodash2.default.get(last5_1_1,'13.m_AC',0);data1[2].covers_last=_lodash2.default.get(last5_1_1,'13.m_covers',0);data1[2].fb_profit_last=_lodash2.default.get(last5_0,'2.actual',0);data1[2].fb_payroll_last=(0,_method.calculation)(_lodash2.default.get(last5_0,'12.actual',0),_lodash2.default.get(last5_0,'0.actual',0),4);data1[2].fb_sales_last=_lodash2.default.get(last1,'14.actual',0);data1[3].fb_last=_lodash2.default.get(data5_0,'0.budget',0);data1[3].fb_prop_last=_lodash2.default.get(data5_0,'13.budget',0);data1[3].ac_last=_lodash2.default.get(data5_1_1,'13.b_AC',0);data1[3].covers_last=_lodash2.default.get(data5_1_1,'13.b_covers',0);data1[3].fb_profit_last=_lodash2.default.get(data5_0,'2.budget',0);data1[3].fb_payroll_last=(0,_method.calculation)(_lodash2.default.get(data5_0,'12.budget',0),_lodash2.default.get(data5_0,'0.budget',0),4);data1[3].fb_sales_last=_lodash2.default.get(data1_1,'14.budget',0);for(var i=0;i<data1.length;i++){data1[i].fb_vs=(0,_method.numConvert)(data1[i].fb-data1[i].fb_last,4);data1[i].fb_prop_vs=(0,_method.numConvert)(data1[i].fb_prop-data1[i].fb_prop_last,4);data1[i].ac_vs=(0,_method.numConvert)(data1[i].ac-data1[i].ac_last,4);data1[i].covers_vs=(0,_method.numConvert)(data1[i].covers-data1[i].covers_last,4);data1[i].fb_profit_vs=(0,_method.numConvert)(data1[i].fb_profit-data1[i].fb_profit_last,4);data1[i].fb_payroll_vs=(0,_method.numConvert)(data1[i].fb_payroll-data1[i].fb_payroll_last,4);data1[i].fb_sales_vs=(0,_method.numConvert)(data1[i].fb_sales-data1[i].fb_sales_last,4);}// table2
data2[1].rev=_lodash2.default.get(data5_1_3,'2.REV',0);data2[3].rev=_lodash2.default.get(data5_1_1,'2.REV',0);data2[1].mix=_lodash2.default.get(data5_1_3,'2.revenue',0);data2[3].mix=_lodash2.default.get(data5_1_1,'2.revenue',0);data2[1].ac=_lodash2.default.get(data5_1_3,'2.AC',0);data2[3].ac=_lodash2.default.get(data5_1_1,'2.AC',0);data2[1].cost=_lodash2.default.get(data5_1_3,'2.cost_percent',0);data2[3].cost=_lodash2.default.get(data5_1_1,'2.cost_percent',0);data2[1].covers=_lodash2.default.get(data5_1_3,'2.covers',0);data2[3].covers=_lodash2.default.get(data5_1_1,'2.covers',0);data2[1].brev=_lodash2.default.get(data5_1_3,'2.m_REV',0);data2[3].brev=_lodash2.default.get(data5_1_1,'2.m_REV',0);data2[1].bmix=_lodash2.default.get(data5_1_3,'2.m_revenue',0);data2[3].bmix=_lodash2.default.get(data5_1_1,'2.m_revenue',0);data2[1].bac=_lodash2.default.get(data5_1_3,'2.m_AC',0);data2[3].bac=_lodash2.default.get(data5_1_1,'2.m_AC',0);data2[1].bcost=_lodash2.default.get(data5_1_3,'2.m_cost_percent',0);data2[3].bcost=_lodash2.default.get(data5_1_1,'2.m_cost_percent',0);data2[1].bcovers=_lodash2.default.get(data5_1_3,'2.m_covers',0);data2[3].bcovers=_lodash2.default.get(data5_1_1,'2.m_covers',0);data2[1].last_rev=_lodash2.default.get(last5_1_3,'2.m_REV',0);data2[3].last_rev=_lodash2.default.get(last5_1_1,'2.m_REV',0);data2[1].last_mix=_lodash2.default.get(last5_1_3,'2.m_revenue',0);data2[3].last_mix=_lodash2.default.get(last5_1_1,'2.m_revenue',0);data2[1].last_ac=_lodash2.default.get(last5_1_3,'2.m_AC',0);data2[3].last_ac=_lodash2.default.get(last5_1_1,'2.m_AC',0);data2[1].last_cost=_lodash2.default.get(last5_1_3,'2.m_cost_percent',0);data2[3].last_cost=_lodash2.default.get(last5_1_1,'2.m_cost_percent',0);data2[1].last_covers=_lodash2.default.get(last5_1_3,'2.m_covers',0);data2[3].last_covers=_lodash2.default.get(last5_1_1,'2.m_covers',0);for(var _i=0;_i<data2.length;_i++){data2[_i].vs=(data2[_i].rev-data2[_i].brev).toFixed(4);data2[_i].bvs=(data2[_i].mix-data2[_i].bmix).toFixed(4);data2[_i].bac_vs=(data2[_i].ac-data2[_i].bac).toFixed(4);data2[_i].bcost_vs=(data2[_i].cost-data2[_i].bcost).toFixed(4);data2[_i].bcovers_vs=(data2[_i].covers-data2[_i].bcovers).toFixed(4);data2[_i].last_vs=(data2[_i].rev-data2[_i].last_rev).toFixed(4);data2[_i].last_mix_vs=(data2[_i].mix-data2[_i].last_mix).toFixed(4);data2[_i].last_ac_vs=(data2[_i].ac-data2[_i].last_ac).toFixed(4);data2[_i].last_cost_vs=(data2[_i].cost-data2[_i].last_cost).toFixed(4);data2[_i].last_covers_vs=(data2[_i].covers-data2[_i].last_covers).toFixed(4);}// table3
data3[1].rev=_lodash2.default.get(data5_1_3,'0.REV',0);data3[3].rev=_lodash2.default.get(data5_1_1,'0.REV',0);data3[1].mix=_lodash2.default.get(data5_1_3,'0.revenue',0);data3[3].mix=_lodash2.default.get(data5_1_1,'0.revenue',0);data3[1].ac=_lodash2.default.get(data5_1_3,'0.AC',0);data3[3].ac=_lodash2.default.get(data5_1_1,'0.AC',0);data3[1].cost=_lodash2.default.get(data5_1_3,'0.cost_percent',0);data3[3].cost=_lodash2.default.get(data5_1_1,'0.cost_percent',0);data3[1].covers=_lodash2.default.get(data5_1_3,'0.covers',0);data3[3].covers=_lodash2.default.get(data5_1_1,'0.covers',0);data3[1].brev=_lodash2.default.get(data5_1_3,'0.m_REV',0);data3[3].brev=_lodash2.default.get(data5_1_1,'0.m_REV',0);data3[1].bmix=_lodash2.default.get(data5_1_3,'0.m_revenue',0);data3[3].bmix=_lodash2.default.get(data5_1_1,'0.m_revenue',0);data3[1].bac=_lodash2.default.get(data5_1_3,'0.m_AC',0);data3[3].bac=_lodash2.default.get(data5_1_1,'0.m_AC',0);data3[1].bcost=_lodash2.default.get(data5_1_3,'0.m_cost_percent',0);data3[3].bcost=_lodash2.default.get(data5_1_1,'0.m_cost_percent',0);data3[1].bcovers=_lodash2.default.get(data5_1_3,'0.m_covers',0);data3[3].bcovers=_lodash2.default.get(data5_1_1,'0.m_covers',0);data3[1].last_rev=_lodash2.default.get(last5_1_3,'0.m_REV',0);data3[3].last_rev=_lodash2.default.get(last5_1_1,'0.m_REV',0);data3[1].last_mix=_lodash2.default.get(last5_1_3,'0.m_revenue',0);data3[3].last_mix=_lodash2.default.get(last5_1_1,'0.m_revenue',0);data3[1].last_ac=_lodash2.default.get(last5_1_3,'0.m_AC',0);data3[3].last_ac=_lodash2.default.get(last5_1_1,'0.m_AC',0);data3[1].last_cost=_lodash2.default.get(last5_1_3,'0.m_cost_percent',0);data3[3].last_cost=_lodash2.default.get(last5_1_1,'0.m_cost_percent',0);data3[1].last_covers=_lodash2.default.get(last5_1_3,'0.m_covers',0);data3[3].last_covers=_lodash2.default.get(last5_1_1,'0.m_covers',0);for(var _i2=0;_i2<data3.length;_i2++){data3[_i2].vs=(data3[_i2].rev-data3[_i2].brev).toFixed(4);data3[_i2].bvs=(data3[_i2].mix-data3[_i2].bmix).toFixed(4);data3[_i2].bac_vs=(data3[_i2].ac-data3[_i2].bac).toFixed(4);data3[_i2].bcost_vs=(data3[_i2].cost-data3[_i2].bcost).toFixed(4);data3[_i2].bcovers_vs=(data3[_i2].covers-data3[_i2].bcovers).toFixed(4);data3[_i2].last_vs=(data3[_i2].rev-data3[_i2].last_rev).toFixed(4);data3[_i2].last_mix_vs=(data3[_i2].mix-data3[_i2].last_mix).toFixed(4);data3[_i2].last_ac_vs=(data3[_i2].ac-data3[_i2].last_ac).toFixed(4);data3[_i2].last_cost_vs=(data3[_i2].cost-data3[_i2].last_cost).toFixed(4);data3[_i2].last_covers_vs=(data3[_i2].covers-data3[_i2].last_covers).toFixed(4);}// table4
data4[1].rev=_lodash2.default.get(data5_1_3,'1.REV',0);data4[3].rev=_lodash2.default.get(data5_1_1,'1.REV',0);data4[1].mix=_lodash2.default.get(data5_1_3,'1.revenue',0);data4[3].mix=_lodash2.default.get(data5_1_1,'1.revenue',0);data4[1].ac=_lodash2.default.get(data5_1_3,'1.AC',0);data4[3].ac=_lodash2.default.get(data5_1_1,'1.AC',0);data4[1].cost=_lodash2.default.get(data5_1_3,'1.cost_percent',0);data4[3].cost=_lodash2.default.get(data5_1_1,'1.cost_percent',0);data4[1].covers=_lodash2.default.get(data5_1_3,'1.covers',0);data4[3].covers=_lodash2.default.get(data5_1_1,'1.covers',0);data4[1].brev=_lodash2.default.get(data5_1_3,'1.m_REV',0);data4[3].brev=_lodash2.default.get(data5_1_1,'1.m_REV',0);data4[1].bmix=_lodash2.default.get(data5_1_3,'1.m_revenue',0);data4[3].bmix=_lodash2.default.get(data5_1_1,'1.m_revenue',0);data4[1].bac=_lodash2.default.get(data5_1_3,'1.m_AC',0);data4[3].bac=_lodash2.default.get(data5_1_1,'1.m_AC',0);data4[1].bcost=_lodash2.default.get(data5_1_3,'1.m_cost_percent',0);data4[3].bcost=_lodash2.default.get(data5_1_1,'1.m_cost_percent',0);data4[1].bcovers=_lodash2.default.get(data5_1_3,'1.m_covers',0);data4[3].bcovers=_lodash2.default.get(data5_1_1,'1.m_covers',0);data4[1].last_rev=_lodash2.default.get(last5_1_3,'1.m_REV',0);data4[3].last_rev=_lodash2.default.get(last5_1_1,'1.m_REV',0);data4[1].last_mix=_lodash2.default.get(last5_1_3,'1.m_revenue',0);data4[3].last_mix=_lodash2.default.get(last5_1_1,'1.m_revenue',0);data4[1].last_ac=_lodash2.default.get(last5_1_3,'1.m_AC',0);data4[3].last_ac=_lodash2.default.get(last5_1_1,'1.m_AC',0);data4[1].last_cost=_lodash2.default.get(last5_1_3,'1.m_cost_percent',0);data4[3].last_cost=_lodash2.default.get(last5_1_1,'1.m_cost_percent',0);data4[1].last_covers=_lodash2.default.get(last5_1_3,'1.m_covers',0);data4[3].last_covers=_lodash2.default.get(last5_1_1,'1.m_covers',0);for(var _i3=0;_i3<data4.length;_i3++){data4[_i3].vs=(data4[_i3].rev-data4[_i3].brev).toFixed(4);data4[_i3].bvs=(data4[_i3].mix-data4[_i3].bmix).toFixed(4);data4[_i3].bac_vs=(data4[_i3].ac-data4[_i3].bac).toFixed(4);data4[_i3].bcost_vs=(data4[_i3].cost-data4[_i3].bcost).toFixed(4);data4[_i3].bcovers_vs=(data4[_i3].covers-data4[_i3].bcovers).toFixed(4);data4[_i3].last_vs=(data4[_i3].rev-data4[_i3].last_rev).toFixed(4);data4[_i3].last_mix_vs=(data4[_i3].mix-data4[_i3].last_mix).toFixed(4);data4[_i3].last_ac_vs=(data4[_i3].ac-data4[_i3].last_ac).toFixed(4);data4[_i3].last_cost_vs=(data4[_i3].cost-data4[_i3].last_cost).toFixed(4);data4[_i3].last_covers_vs=(data4[_i3].covers-data4[_i3].last_covers).toFixed(4);}// table5
data5[1].rev=_lodash2.default.get(data5_1_3,'3.REV',0);data5[3].rev=_lodash2.default.get(data5_1_1,'3.REV',0);data5[1].mix=_lodash2.default.get(data5_1_3,'3.revenue',0);data5[3].mix=_lodash2.default.get(data5_1_1,'3.revenue',0);data5[1].ac=_lodash2.default.get(data5_1_3,'3.AC',0);data5[3].ac=_lodash2.default.get(data5_1_1,'3.AC',0);data5[1].cost=_lodash2.default.get(data5_1_3,'3.cost_percent',0);data5[3].cost=_lodash2.default.get(data5_1_1,'3.cost_percent',0);data5[1].covers=_lodash2.default.get(data5_1_3,'3.covers',0);data5[3].covers=_lodash2.default.get(data5_1_1,'3.covers',0);data5[1].brev=_lodash2.default.get(data5_1_3,'3.m_REV',0);data5[3].brev=_lodash2.default.get(data5_1_1,'3.m_REV',0);data5[1].bmix=_lodash2.default.get(data5_1_3,'3.m_revenue',0);data5[3].bmix=_lodash2.default.get(data5_1_1,'3.m_revenue',0);data5[1].bac=_lodash2.default.get(data5_1_3,'3.m_AC',0);data5[3].bac=_lodash2.default.get(data5_1_1,'3.m_AC',0);data5[1].bcost=_lodash2.default.get(data5_1_3,'3.m_cost_percent',0);data5[3].bcost=_lodash2.default.get(data5_1_1,'3.m_cost_percent',0);data5[1].bcovers=_lodash2.default.get(data5_1_3,'3.m_covers',0);data5[3].bcovers=_lodash2.default.get(data5_1_1,'3.m_covers',0);data5[1].last_rev=_lodash2.default.get(last5_1_3,'3.m_REV',0);data5[3].last_rev=_lodash2.default.get(last5_1_1,'3.m_REV',0);data5[1].last_mix=_lodash2.default.get(last5_1_3,'3.m_revenue',0);data5[3].last_mix=_lodash2.default.get(last5_1_1,'3.m_revenue',0);data5[1].last_ac=_lodash2.default.get(last5_1_3,'3.m_AC',0);data5[3].last_ac=_lodash2.default.get(last5_1_1,'3.m_AC',0);data5[1].last_cost=_lodash2.default.get(last5_1_3,'3.m_cost_percent',0);data5[3].last_cost=_lodash2.default.get(last5_1_1,'3.m_cost_percent',0);data5[1].last_covers=_lodash2.default.get(last5_1_3,'3.m_covers',0);data5[3].last_covers=_lodash2.default.get(last5_1_1,'3.m_covers',0);for(var _i4=0;_i4<data5.length;_i4++){data5[_i4].vs=(data5[_i4].rev-data5[_i4].brev).toFixed(4);data5[_i4].bvs=(data5[_i4].mix-data5[_i4].bmix).toFixed(4);data5[_i4].bac_vs=(data5[_i4].ac-data5[_i4].bac).toFixed(4);data5[_i4].bcost_vs=(data5[_i4].cost-data5[_i4].bcost).toFixed(4);data5[_i4].bcovers_vs=(data5[_i4].covers-data5[_i4].bcovers).toFixed(4);data5[_i4].last_vs=(data5[_i4].rev-data5[_i4].last_rev).toFixed(4);data5[_i4].last_mix_vs=(data5[_i4].mix-data5[_i4].last_mix).toFixed(4);data5[_i4].last_ac_vs=(data5[_i4].ac-data5[_i4].last_ac).toFixed(4);data5[_i4].last_cost_vs=(data5[_i4].cost-data5[_i4].last_cost).toFixed(4);data5[_i4].last_covers_vs=(data5[_i4].covers-data5[_i4].last_covers).toFixed(4);}// table6
data6[1].rev=_lodash2.default.get(data5_1_3,'4.REV',0);data6[3].rev=_lodash2.default.get(data5_1_1,'4.REV',0);data6[1].mix=_lodash2.default.get(data5_1_3,'4.revenue',0);data6[3].mix=_lodash2.default.get(data5_1_1,'4.revenue',0);data6[1].ac=_lodash2.default.get(data5_1_3,'4.AC',0);data6[3].ac=_lodash2.default.get(data5_1_1,'4.AC',0);data6[1].cost=_lodash2.default.get(data5_1_3,'4.cost_percent',0);data6[3].cost=_lodash2.default.get(data5_1_1,'4.cost_percent',0);data6[1].covers=_lodash2.default.get(data5_1_3,'4.covers',0);data6[3].covers=_lodash2.default.get(data5_1_1,'4.covers',0);data6[1].brev=_lodash2.default.get(data5_1_3,'4.m_REV',0);data6[3].brev=_lodash2.default.get(data5_1_1,'4.m_REV',0);data6[1].bmix=_lodash2.default.get(data5_1_3,'4.m_revenue',0);data6[3].bmix=_lodash2.default.get(data5_1_1,'4.m_revenue',0);data6[1].bac=_lodash2.default.get(data5_1_3,'4.m_AC',0);data6[3].bac=_lodash2.default.get(data5_1_1,'4.m_AC',0);data6[1].bcost=_lodash2.default.get(data5_1_3,'4.m_cost_percent',0);data6[3].bcost=_lodash2.default.get(data5_1_1,'4.m_cost_percent',0);data6[1].bcovers=_lodash2.default.get(data5_1_3,'4.m_covers',0);data6[3].bcovers=_lodash2.default.get(data5_1_1,'4.m_covers',0);data6[1].last_rev=_lodash2.default.get(last5_1_3,'4.m_REV',0);data6[3].last_rev=_lodash2.default.get(last5_1_1,'4.m_REV',0);data6[1].last_mix=_lodash2.default.get(last5_1_3,'4.m_revenue',0);data6[3].last_mix=_lodash2.default.get(last5_1_1,'4.m_revenue',0);data6[1].last_ac=_lodash2.default.get(last5_1_3,'4.m_AC',0);data6[3].last_ac=_lodash2.default.get(last5_1_1,'4.m_AC',0);data6[1].last_cost=_lodash2.default.get(last5_1_3,'4.m_cost_percent',0);data6[3].last_cost=_lodash2.default.get(last5_1_1,'4.m_cost_percent',0);data6[1].last_covers=_lodash2.default.get(last5_1_3,'4.m_covers',0);data6[3].last_covers=_lodash2.default.get(last5_1_1,'4.m_covers',0);for(var _i5=0;_i5<data5.length;_i5++){data6[_i5].vs=(data6[_i5].rev-data6[_i5].brev).toFixed(4);data6[_i5].bvs=(data6[_i5].mix-data6[_i5].bmix).toFixed(4);data6[_i5].bac_vs=(data6[_i5].ac-data6[_i5].bac).toFixed(4);data6[_i5].bcost_vs=(data6[_i5].cost-data6[_i5].bcost).toFixed(4);data6[_i5].bcovers_vs=(data6[_i5].covers-data6[_i5].bcovers).toFixed(4);data6[_i5].last_vs=(data6[_i5].rev-data6[_i5].last_rev).toFixed(4);data6[_i5].last_mix_vs=(data6[_i5].mix-data6[_i5].last_mix).toFixed(4);data6[_i5].last_ac_vs=(data6[_i5].ac-data6[_i5].last_ac).toFixed(4);data6[_i5].last_cost_vs=(data6[_i5].cost-data6[_i5].last_cost).toFixed(4);data6[_i5].last_covers_vs=(data6[_i5].covers-data6[_i5].last_covers).toFixed(4);}// table7
data7[1].rev=_lodash2.default.get(data5_1_3,'5.REV',0);data7[3].rev=_lodash2.default.get(data5_1_1,'5.REV',0);data7[1].mix=_lodash2.default.get(data5_1_3,'5.revenue',0);data7[3].mix=_lodash2.default.get(data5_1_1,'5.revenue',0);data7[1].ac=_lodash2.default.get(data5_1_3,'5.AC',0);data7[3].ac=_lodash2.default.get(data5_1_1,'5.AC',0);data7[1].cost=_lodash2.default.get(data5_1_3,'5.cost_percent',0);data7[3].cost=_lodash2.default.get(data5_1_1,'5.cost_percent',0);data7[1].covers=_lodash2.default.get(data5_1_3,'5.covers',0);data7[3].covers=_lodash2.default.get(data5_1_1,'5.covers',0);data7[1].brev=_lodash2.default.get(data5_1_3,'5.m_REV',0);data7[3].brev=_lodash2.default.get(data5_1_1,'5.m_REV',0);data7[1].bmix=_lodash2.default.get(data5_1_3,'5.m_revenue',0);data7[3].bmix=_lodash2.default.get(data5_1_1,'5.m_revenue',0);data7[1].bac=_lodash2.default.get(data5_1_3,'5.m_AC',0);data7[3].bac=_lodash2.default.get(data5_1_1,'5.m_AC',0);data7[1].bcost=_lodash2.default.get(data5_1_3,'5.m_cost_percent',0);data7[3].bcost=_lodash2.default.get(data5_1_1,'5.m_cost_percent',0);data7[1].bcovers=_lodash2.default.get(data5_1_3,'5.m_covers',0);data7[3].bcovers=_lodash2.default.get(data5_1_1,'5.m_covers',0);data7[1].last_rev=_lodash2.default.get(last5_1_3,'5.m_REV',0);data7[3].last_rev=_lodash2.default.get(last5_1_1,'5.m_REV',0);data7[1].last_mix=_lodash2.default.get(last5_1_3,'5.m_revenue',0);data7[3].last_mix=_lodash2.default.get(last5_1_1,'5.m_revenue',0);data7[1].last_ac=_lodash2.default.get(last5_1_3,'5.m_AC',0);data7[3].last_ac=_lodash2.default.get(last5_1_1,'5.m_AC',0);data7[1].last_cost=_lodash2.default.get(last5_1_3,'5.m_cost_percent',0);data7[3].last_cost=_lodash2.default.get(last5_1_1,'5.m_cost_percent',0);data7[1].last_covers=_lodash2.default.get(last5_1_3,'5.m_covers',0);data7[3].last_covers=_lodash2.default.get(last5_1_1,'5.m_covers',0);for(var _i6=0;_i6<data5.length;_i6++){data7[_i6].vs=(data7[_i6].rev-data7[_i6].brev).toFixed(4);data7[_i6].bvs=(data7[_i6].mix-data7[_i6].bmix).toFixed(4);data7[_i6].bac_vs=(data7[_i6].ac-data7[_i6].bac).toFixed(4);data7[_i6].bcost_vs=(data7[_i6].cost-data7[_i6].bcost).toFixed(4);data7[_i6].bcovers_vs=(data7[_i6].covers-data7[_i6].bcovers).toFixed(4);data7[_i6].last_vs=(data7[_i6].rev-data7[_i6].last_rev).toFixed(4);data7[_i6].last_mix_vs=(data7[_i6].mix-data7[_i6].last_mix).toFixed(4);data7[_i6].last_ac_vs=(data7[_i6].ac-data7[_i6].last_ac).toFixed(4);data7[_i6].last_cost_vs=(data7[_i6].cost-data7[_i6].last_cost).toFixed(4);data7[_i6].last_covers_vs=(data7[_i6].covers-data7[_i6].last_covers).toFixed(4);}// table8
var listName=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];for(var _i7=0;_i7<listName.length;_i7++){var name=listName[_i7].toLowerCase();data[0][name]=_lodash2.default.get(list2_2,'0.'+listName[_i7],0);data[1][name]=_lodash2.default.get(list2_1,'0.'+listName[_i7],0);}data[0].actual=_lodash2.default.get(max,'ytdActual',0);data[0].budget=(0,_method.sum)(listName.map(function(name){return data[0][name.toLowerCase()];}));data[0].forecast=(0,_method.sum)(listName.map(function(name){return data[1][name.toLowerCase()];}));return{data:data,data1:data1,data2:data2,data3:data3,data4:data4,data5:data5,data6:data6,data7:data7};};

/***/ }),
/* 1953 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _=__webpack_require__(1955);var _2=_interopRequireDefault(_);var _3=__webpack_require__(1959);var _4=_interopRequireDefault(_3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",null,_react2.default.createElement(_2.default,null),_react2.default.createElement(_4.default,null));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(62);__webpack_require__(25);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _data=__webpack_require__(1956);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _compute=__webpack_require__(1957);var _compute2=_interopRequireDefault(_compute);__webpack_require__(1958);var _method=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TextArea=_input2.default.TextArea;var confirm=_modal2.default.confirm;var totalIndex=[3,4,5,9,10,11,,15,16,17,21,22,23,27,28,29,33,34,35];var allListName=["wedding_covers","wedding_ac","wedding_rev","wedding_room","wedding_other","wedding_total","wedding_proportion","social_covers","social_ac","social_rev","social_room","social_other","social_total","social_proportion","group_covers","group_ac","group_rev","group_room","group_other","group_total","group_proportion","grand_covers","grand_ac","grand_rev","grand_room","grand_other","grand_total"];Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){data=(0,_compute2.default)(data,_this.state.date);_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.dataDefault);var data=JSON.parse(dataBegin);fetch('/_6_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data&&x.data.data.length>0){data=x.data.data.sort(function(a,b){return a.sort-b.sort;});}var month=(0,_moment2.default)(date).format('M');// 自动填充上个月的数据,一月份不适用此方法
if(x.data.lastMonthData&&x.data.lastMonthData.length>0&&month>1){var lastMonthData=x.data.lastMonthData.sort(function(a,b){return a.sort-b.sort;});data=lastMonthData.map(function(item,i){delete item.id;if(data[i].id){item.id=data[i].id;}if(Math.ceil((i+1)/3)<=Number(month)+2&&Math.ceil((i+1)/3)>month-1&&i%3==1){return _extends({},data[i]);}return item;});}// 填充预算数据，从当年一月份数据获取
if(x.data.jan&&x.data.jan.length>0&&month>1){var jan=x.data.jan.sort(function(a,b){return a.sort-b.sort;});// 去年的实际数据填充到Actual Last Year
data=data.map(function(item,i){if(i<=43&&i%3==0){allListName.forEach(function(name){item[name]=(0,_method.getJson)([i,name],jan);});return item;}else{return item;}});}if(x.data.lastYearData&&x.data.lastYearData.length>0){var lastYearData=x.data.lastYearData.sort(function(a,b){return a.sort-b.sort;});// 去年的实际数据填充到Actual Last Year
data=data.map(function(item,i){if(i<=43&&i%3==2){allListName.forEach(function(name){item[name]=(0,_method.getJson)([i-1,name],lastYearData);});return item;}else{return item;}});}if(!data[0].id){_this.setState({loading:false,data:data,note:x.data.note||{}},function(){_this.onSave();});return;}_this.setState({loading:false,note:x.data.note||{}});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month});});if(month==1){var _allListName=["wedding_covers","wedding_ac","wedding_rev","wedding_room","wedding_other","wedding_total","wedding_proportion","social_covers","social_ac","social_rev","social_room","social_other","social_total","social_proportion","group_covers","group_ac","group_rev","group_room","group_other","group_total","group_proportion","grand_covers","grand_ac","grand_rev","grand_room","grand_other","grand_total"];data.forEach(function(item,i){if(i<=43&&i%3==1&&i>=8){_allListName.forEach(function(name){data[i][name]=data[i-1][name];});}});_this.setState({data:data});}var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));dataFrom.append('isAllId',data.every(function(x){return x.id;})?1:0);dataFrom.append('isAllNull',data.every(function(x){return!x.id;})?1:0);dataFrom.append('note',JSON.stringify(_extends({},_this.state.note,{year:year,month:month})));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_6_1',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if((data||[]).every(function(x){return!x.id;})){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table4_1_1',1.5,'6.11',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=(0,_moment2.default)(_this.state.date).format('YYYY')+' Catering & Events (C&E) Analysis By Market Segment \u5BB4\u4F1A\u6D3B\u52A8\u5206\u6790 - \u6309\u5E02\u573A\u7EC6\u5206';var innerHtml='\n          <caption>'+tableName+'</caption>\n          '+document.getElementById('table1').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n        ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+'.xls');_this.setState({print:false});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,note:{}};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var year=(0,_moment2.default)(this.state.date).format('YYYY');var month=(0,_moment2.default)(this.state.date).format('M');var width=document.body.offsetWidth-4050>300?document.body.offsetWidth-4050:300;var print=this.state.print;var columns=[{title:'MONTH',dataIndex:'name',key:'name',align:"center",fixed:this.state.print?false:"left",width:width*0.5,render:function render(text,record,index){var props={text:text,index:index,type:'textcenter',name:"name",onChange:_this2.onChange,totalIndex:totalIndex};if(index<42&&index%3==0){return{props:{rowSpan:3},children:_react2.default.createElement(_TableText2.default,{data:props})};}if(index===42||index===45){return{props:{rowSpan:2},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{text:index==42?'% to Budget '+year:text})})};}if(index===44){return _react2.default.createElement(_TableText2.default,{data:props});}return{props:{rowSpan:0}};}},{title:'',dataIndex:'month_status',key:'month_status',align:"center",fixed:this.state.print?false:"left",width:width*0.5,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this2.onChange,totalIndex:totalIndex};if(index<40&&index!=38){var str='';if(index%3==0)str='Budget '+year;if(index%3==1){if(Math.ceil((index+1)/3)>month&&Math.ceil((index+1)/3)<=Number(month)+2){str='Forecast '+year;}else{str=(Math.ceil((index+1)/3)<=month?'Actual':"Budget")+' '+year;}};if(index%3==2)str='Actual Last Year';// if (index == 34) {
//     if (index % 3 == 1) str = `${Math.ceil((index + 1) / 3) == month ? `Actual ${year}` : `Budget ${year}`} `;
// }
if(index==37)str='Actual '+year;return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{text:str})});}var t='';if(index==40)t='Act/Fcst '+year;if(index==38)t='Variance%';if(index==41)t='Variance%';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{text:t})});}},{title:'Wedding',width:450,children:[{title:'Covers\xA0\u4EBA\u6570',dataIndex:'wedding_covers',key:'wedding_covers',align:"center",width:150,render:function render(text,record,index){var title=['Wedding','Covers\xA0\u4EBA\u6570',record.month_status_name];var props={text:text,index:index,type:'number',name:"wedding_covers",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'A/C\xA0\u4EBA\u5747\u6D88\u8D39',dataIndex:'wedding_ac',key:'wedding_ac',width:150,align:"center",render:function render(text,record,index){var title=['Wedding','A/C\xA0\u4EBA\u5747\u6D88\u8D39',record.month_status_name];var props={text:text,index:index,type:'number',name:"wedding_ac",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'REV\xA0\u6536\u76CA',dataIndex:'wedding_rev',key:'wedding_rev',align:"center",width:150,render:function render(text,record,index){var title=['Wedding','REV\xA0\u6536\u76CA',record.month_status_name];var props={text:text,index:index,type:'number',name:"wedding_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Meeting Room Rental\xA0\u573A\u79DF',dataIndex:'wedding_room',key:'wedding_room',align:"center",width:150,render:function render(text,record,index){var title=['Wedding','Meeting Room Rental\xA0\u573A\u79DF',record.month_status_name];var props={text:text,index:index,type:'number',name:"wedding_room",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Other Revenue \u5176\u4ED6\u6536\u5165',dataIndex:'wedding_other',key:'wedding_other',align:"center",width:150,render:function render(text,record,index){var title=['Wedding','Other Revenue \u5176\u4ED6\u6536\u5165',record.month_status_name];var props={text:text,index:index,type:'number',name:"wedding_other",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Total Revenue \u603B\u6536\u76CA\xA0',dataIndex:'wedding_total',key:'wedding_total',align:"center",width:150,render:function render(text,record,index){var title=['Wedding','Total Revenue \u603B\u6536\u76CA\xA0',record.month_status_name];var props={text:text,index:index,type:'number',name:"wedding_total",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Total Revenue% \u603B\u6536\u76CA\u5360\u6BD4',dataIndex:'wedding_proportion',key:'wedding_proportion',align:"center",width:150,render:function render(text,record,index){var title=['Wedding','Total Revenue% \u603B\u6536\u76CA\u5360\u6BD4',record.month_status_name];var props={text:text,index:index,type:'percent',name:"wedding_proportion",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]},{title:'Social Events',width:450,children:[{title:'Covers\xA0\u4EBA\u6570',dataIndex:'social_covers',key:'social_covers',align:"center",width:150,render:function render(text,record,index){var title=['Social Events','Covers\xA0\u4EBA\u6570',record.month_status_name];var props={text:text,index:index,type:'number',name:"social_covers",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'A/C\xA0\u4EBA\u5747\u6D88\u8D39',dataIndex:'social_ac',key:'social_ac',width:150,align:"center",render:function render(text,record,index){var title=['Social Events','A/C\xA0\u4EBA\u5747\u6D88\u8D39',record.month_status_name];var props={text:text,index:index,type:'number',name:"social_ac",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'REV\xA0\u6536\u76CA',dataIndex:'social_rev',key:'social_rev',align:"center",width:150,render:function render(text,record,index){var title=['Social Events','REV\xA0\u6536\u76CA',record.month_status_name];var props={text:text,index:index,type:'number',name:"social_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Meeting Room Rental\xA0\u573A\u79DF',dataIndex:'social_room',key:'social_room',align:"center",width:150,render:function render(text,record,index){var title=['Social Events','Meeting Room Rental\xA0\u573A\u79DF',record.month_status_name];var props={text:text,index:index,type:'number',name:"social_room",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Other Revenue \u5176\u4ED6\u6536\u5165',dataIndex:'social_other',key:'social_other',align:"center",width:150,render:function render(text,record,index){var title=['Social Events','Other Revenue \u5176\u4ED6\u6536\u5165',record.month_status_name];var props={text:text,index:index,type:'number',name:"social_other",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Total Revenue \u603B\u6536\u76CA\xA0',dataIndex:'social_total',key:'social_total',align:"center",width:150,render:function render(text,record,index){var title=['Social Events','Total Revenue \u603B\u6536\u76CA\xA0',record.month_status_name];var props={text:text,index:index,type:'number',name:"social_total",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Total Revenue% \u603B\u6536\u76CA\u5360\u6BD4',dataIndex:'social_proportion',key:'social_proportion',align:"center",width:150,render:function render(text,record,index){var title=['Social Events','Total Revenue% \u603B\u6536\u76CA\u5360\u6BD4',record.month_status_name];var props={text:text,index:index,type:'percent',name:"social_proportion",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]},{title:'Group Events',width:450,children:[{title:'Covers\xA0\u4EBA\u6570',dataIndex:'group_covers',key:'group_covers',align:"center",width:150,render:function render(text,record,index){var title=['Group Events','Covers\xA0\u4EBA\u6570',record.month_status_name];var props={text:text,index:index,type:'number',name:"group_covers",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'A/C\xA0\u4EBA\u5747\u6D88\u8D39',dataIndex:'group_ac',key:'group_ac',width:150,align:"center",render:function render(text,record,index){var title=['Group Events','A/C\xA0\u4EBA\u5747\u6D88\u8D39',record.month_status_name];var props={text:text,index:index,type:'number',name:"group_ac",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'REV\xA0\u6536\u76CA',dataIndex:'group_rev',key:'group_rev',align:"center",width:150,render:function render(text,record,index){var title=['Group Events','REV\xA0\u6536\u76CA',record.month_status_name];var props={text:text,index:index,type:'number',name:"group_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Meeting Room Rental\xA0\u573A\u79DF',dataIndex:'group_room',key:'group_room',align:"center",width:150,render:function render(text,record,index){var title=['Group Events','Meeting Room Rental\xA0\u573A\u79DF',record.month_status_name];var props={text:text,index:index,type:'number',name:"group_room",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Other Revenue \u5176\u4ED6\u6536\u5165',dataIndex:'group_other',key:'group_other',align:"center",width:150,render:function render(text,record,index){var title=['Group Events','Other Revenue \u5176\u4ED6\u6536\u5165',record.month_status_name];var props={text:text,index:index,type:'number',name:"group_other",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Total Revenue \u603B\u6536\u76CA\xA0',dataIndex:'group_total',key:'group_total',align:"center",width:150,render:function render(text,record,index){var title=['Group Events','Total Revenue \u603B\u6536\u76CA\xA0',record.month_status_name];var props={text:text,index:index,type:'number',name:"group_total",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Total Revenue% \u603B\u6536\u76CA\u5360\u6BD4',dataIndex:'group_proportion',key:'group_proportion',align:"center",width:150,render:function render(text,record,index){var title=['Group Events','Total Revenue% \u603B\u6536\u76CA\u5360\u6BD4',record.month_status_name];var props={text:text,index:index,type:'percent',name:"group_proportion",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]},{title:'Grand Total',width:450,children:[{title:'Covers\xA0\u4EBA\u6570',dataIndex:'grand_covers',key:'grand_covers',align:"center",width:150,render:function render(text,record,index){var title=['Grand Total','Covers\xA0\u4EBA\u6570',record.month_status_name];var props={text:text,index:index,type:'number',name:"grand_covers",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'A/C\xA0\u4EBA\u5747\u6D88\u8D39',dataIndex:'grand_ac',key:'grand_ac',width:150,align:"center",render:function render(text,record,index){var title=['Grand Total','A/C\xA0\u4EBA\u5747\u6D88\u8D39',record.month_status_name];var props={text:text,index:index,type:'number',name:"grand_ac",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'REV\xA0\u6536\u76CA',dataIndex:'grand_rev',key:'grand_rev',align:"center",width:150,render:function render(text,record,index){var title=['Grand Total','REV\xA0\u6536\u76CA',record.month_status_name];var props={text:text,index:index,type:'number',name:"grand_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Meeting Room Rental\xA0\u573A\u79DF',dataIndex:'grand_room',key:'grand_room',align:"center",width:150,render:function render(text,record,index){var title=['Grand Total','Meeting Room Rental\xA0\u573A\u79DF',record.month_status_name];var props={text:text,index:index,type:'number',name:"grand_room",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Other Revenue \u5176\u4ED6\u6536\u5165',dataIndex:'grand_other',key:'grand_other',align:"center",width:150,render:function render(text,record,index){var title=['Grand Total','Other Revenue \u5176\u4ED6\u6536\u5165',record.month_status_name];var props={text:text,index:index,type:'number',name:"grand_other",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Total Revenue \u603B\u6536\u76CA\xA0',dataIndex:'grand_total',key:'grand_total',align:"center",width:150,render:function render(text,record,index){var title=['Grand Total','Total Revenue \u603B\u6536\u76CA\xA0',record.month_status_name];var props={text:text,index:index,type:'number',name:"grand_total",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1 tableHeight'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_1_1',style:{width:this.state.print?4400:'auto'}},_react2.default.createElement(_row2.default,null,'6.1.1 Catering & Events (C&E) Analysis By Market Segment \u5BB4\u4F1A\u6D3B\u52A8\u5206\u6790 - \u6309\u5E02\u573A\u7EC6\u5206'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',id:'table1',bordered:true,pagination:false,rowClassName:'protruding',className:'content',style:{width:this.state.print?4350:'auto'},scroll:this.state.print?{}:{x:4350,y:500},rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_row2.default,{style:{margin:"30px 0 0 10px"}},'Please critique if variance above +/- 5% \u82E5\u5DEE\u5F02\u6570\u8D85\u8FC7\u4E0A\u4E0B\u767E\u5206\u4E4B\u4E94\u5219\u9700\u505A\u51FA\u4E66\u9762\u89E3\u91CA'),!this.state.loading&&_react2.default.createElement(TextArea,{rows:4,defaultValue:this.state.note.note||"",onBlur:function onBlur(e){var value=e.target.value||"";_this2.setState({note:_extends({},_this2.state.note,{note:value})});},style:{marginTop:20}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){_this2.setState({print:true},function(){_this2.downloadExcel();});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_6_1'},_react2.default.createElement(_button2.default,{type:'primary',style:{margin:'0 10px'},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var dataDefault=exports.dataDefault=[{"name":"Jan","sort":0,"month_status":"Budget",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Jan","sort":1,"month_status":"Actual",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Jan","sort":2,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Feb","sort":3,"month_status":"Budget",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Feb","sort":4,"month_status":"Actual",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Feb","sort":5,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Mar","sort":6,"month_status":"Budget",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Mar","sort":7,"month_status":"Actual",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Mar","sort":8,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Apr","sort":9,"month_status":"Budget",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Apr","sort":10,"month_status":"Actual",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Apr","sort":11,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"May","sort":12,"month_status":"Budget",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"May","sort":13,"month_status":"Actual",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"May","sort":14,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Jun","sort":15,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Jun","sort":16,"month_status":"Actual",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Jun","sort":17,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Jul","sort":18,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Jul","sort":19,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Jul","sort":20,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Aug","sort":21,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Aug","sort":22,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Aug","sort":23,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Sep","sort":24,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Sep","sort":25,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Sep","sort":26,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Oct","sort":27,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Oct","sort":28,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Oct","sort":29,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Nov","sort":30,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Nov","sort":31,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Nov","sort":32,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Dec","sort":33,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Dec","sort":34,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Dec","sort":35,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"YTD","sort":36,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"YTD","sort":37,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"YTD","sort":38,"month_status":"Variance%",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Year End","sort":39,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Year End","sort":40,"month_status":"Act/Fcst ",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Year End","sort":41,"month_status":"Variance%",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0}];

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=compute;var _method=__webpack_require__(20);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function compute(data,date){var month=(0,_moment2.default)(date).format('M');var totalName=['grand_covers','grand_rev','grand_room','grand_other'];var leftName=['wedding','social','group'];// grandtotal
totalName.forEach(function(name){data.forEach(function(item,i){if(![38,41].includes(i)){data[i][name]=leftName.reduce(function(a,b){a+=(0,_method.numConvert)(item[b+'_'+name.split('_')[1]]);return a;},0).toFixed(2);}});});// 计算收益
[].concat(leftName,['grand']).forEach(function(name){data.forEach(function(item,i){if(![38,41].includes(i)){data[i][name+'_ac']=(0,_method.calculation)(data[i][name+'_rev'],data[i][name+'_covers']);data[i][name+'_total']=(0,_method.sum)([data[i][name+'_rev'],data[i][name+'_room'],data[i][name+'_other']]);}});});// YTD 累加到当前月份之前  Year End
[].concat(leftName,['grand']).forEach(function(left){['_covers','_ac','_rev','_room','_other','_total'].forEach(function(right){data[36][left+right]=data.reduce(function(a,b,i){if(i<36&&Math.ceil((i+1)/3)<=month&&i%3==0){a+=(0,_method.numConvert)(b[left+right]);}return a;},0).toFixed(2);data[37][left+right]=data.reduce(function(a,b,i){if(i<36&&Math.ceil((i+1)/3)<=month&&i%3==1){a+=(0,_method.numConvert)(b[left+right]);}return a;},0).toFixed(2);data[39][left+right]=data.reduce(function(a,b,i){if(i<36&&i%3==0){a+=(0,_method.numConvert)(b[left+right]);}return a;},0).toFixed(2);data[40][left+right]=data.reduce(function(a,b,i){if(i<36&&i%3==1){a+=(0,_method.numConvert)(b[left+right]);}return a;},0).toFixed(2);});});// 收益占比
[].concat(leftName,['grand']).forEach(function(name){data.forEach(function(item,i){// 计算YTD Year-End人均消费
if(i>=36){data[i][name+'_ac']=(0,_method.calculation)(data[i][name+'_rev'],data[i][name+'_covers'],2);}if(![38,41].includes(i)&&name!='grand'){data[i][name+'_proportion']=(0,_method.calculation)(data[i][name+'_total'],data[i]['grand_total'],4);}});});// Variance%
[].concat(leftName,['grand']).forEach(function(left){['_covers','_ac','_rev','_room','_other','_total'].forEach(function(right){data[41][left+right]=(0,_method.calculation)(data[40][left+right]-data[39][left+right],data[39][left+right],4);data[38][left+right]=(0,_method.calculation)(data[37][left+right]-data[36][left+right],data[36][left+right],4);});});return data;}

/***/ }),
/* 1958 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(62);__webpack_require__(25);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _data=__webpack_require__(1960);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _compute=__webpack_require__(1961);var _compute2=_interopRequireDefault(_compute);__webpack_require__(1962);var _method=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TextArea=_input2.default.TextArea;var confirm=_modal2.default.confirm;var totalIndex=[3,4,5,9,10,11,,15,16,17,21,22,23,27,28,29,33,34,35];Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){data=(0,_compute2.default)(data,_this.state.date);_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.dataDefault);var data=JSON.parse(dataBegin);fetch('/_6_1_2_new_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data&&x.data.data.length>0){data=x.data.data.sort(function(a,b){return a.sort-b.sort;});}var month=(0,_moment2.default)(date).format('M');// 自动填充上个月的数据,一月份不适用此方法
if(x.data.lastMonthData&&x.data.lastMonthData.length>0&&month>1){var lastMonthData=x.data.lastMonthData.sort(function(a,b){return a.sort-b.sort;});data=lastMonthData.map(function(item,i){delete item.id;if(data[i].id){item.id=data[i].id;}if(Math.ceil((i+1)/3)<=Number(month)+2&&Math.ceil((i+1)/3)>month-1&&i%3==1){return _extends({},data[i]);}return item;});}if(x.data.lastYearData&&x.data.lastYearData.length>0){var allListName=["wedding_covers","wedding_ac","wedding_rev","wedding_room","wedding_other","wedding_total","wedding_proportion","social_covers","social_ac","social_rev","social_room","social_other","social_total","social_proportion","group_covers","group_ac","group_rev","group_room","group_other","group_total","group_proportion","grand_covers","grand_ac","grand_rev","grand_room","grand_other","grand_total"];var lastYearData=x.data.lastYearData.sort(function(a,b){return a.sort-b.sort;});// 去年的实际数据填充到Actual Last Year
data=data.map(function(item,i){if(i<=43&&i%3==2){allListName.forEach(function(name){item[name]=(0,_method.getJson)([i-1,name],lastYearData);});return item;}else{return item;}});}if(!data[0].id){_this.setState({loading:false,data:data,note:x.data.note||{}},function(){_this.onSave();});return;}_this.setState({loading:false,note:x.data.note||{}});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month});});if(month==1){var allListName=["wedding_covers","wedding_ac","wedding_rev","wedding_room","wedding_other","wedding_total","wedding_proportion","social_covers","social_ac","social_rev","social_room","social_other","social_total","social_proportion","group_covers","group_ac","group_rev","group_room","group_other","group_total","group_proportion","grand_covers","grand_ac","grand_rev","grand_room","grand_other","grand_total"];data.forEach(function(item,i){if(i<=43&&i%3==1&&i>=8){allListName.forEach(function(name){data[i][name]=data[i-1][name];});}});_this.setState({data:data});}var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));dataFrom.append('isAllId',data.every(function(x){return x.id;})?1:0);dataFrom.append('isAllNull',data.every(function(x){return!x.id;})?1:0);dataFrom.append('note',JSON.stringify(_extends({},_this.state.note,{year:year,month:month})));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_6_1_2new',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if((data||[]).every(function(x){return!x.id;})){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table4_1_2',1.5,'6.12',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.downloadExcel=function(){var tableName=(0,_moment2.default)(_this.state.date).format('YYYY')+' 6.1.2 Social Event Analysis\u793E\u4F1A\u5BB4\u4F1A\u6D3B\u52A8\u5206\u6790';var innerHtml='\n          <caption>'+tableName+'</caption>\n          '+document.getElementById('table2').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n        ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+'.xls');_this.setState({print:false});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,note:{}};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var year=(0,_moment2.default)(this.state.date).format('YYYY');var month=(0,_moment2.default)(this.state.date).format('M');var width=document.body.offsetWidth-4050>300?document.body.offsetWidth-4050:300;var print=this.state.print;var columns=[{title:'MONTH',dataIndex:'name',key:'name',align:"center",fixed:this.state.print?false:"left",width:width*0.5,render:function render(text,record,index){var props={text:text,index:index,type:'textcenter',name:"name",onChange:_this2.onChange,totalIndex:totalIndex};if(index<42&&index%3==0){return{props:{rowSpan:3},children:_react2.default.createElement(_TableText2.default,{data:props})};}if(index===42||index===45){return{props:{rowSpan:2},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{text:index==42?'% to Budget '+year:text})})};}if(index===44){return _react2.default.createElement(_TableText2.default,{data:props});}return{props:{rowSpan:0}};}},{title:'',dataIndex:'month_status',key:'month_status',align:"center",fixed:this.state.print?false:"left",width:width*0.5,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this2.onChange,totalIndex:totalIndex};if(index<40&&index!=38){var str='';if(index%3==0)str='Budget '+year;if(index%3==1){if(Math.ceil((index+1)/3)>month&&Math.ceil((index+1)/3)<=Number(month)+2){str='Forecast '+year;}else{str=(Math.ceil((index+1)/3)<=month?'Actual':"Budget")+' '+year;}};if(index%3==2)str='Actual Last Year';// if (index == 34) {
//     if (index % 3 == 1) str = `${Math.ceil((index + 1) / 3) == month ? `Actual ${year}` : `Budget ${year}`} `;
// }
if(index==37)str='Actual '+year;return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{text:str})});}var t='';if(index==40)t='Act/Fcst '+year;if(index==38)t='Variance%';if(index==41)t='Variance%';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{text:t})});}},{title:'Social Event-Corp.',width:450,children:[{title:'Covers\xA0\u4EBA\u6570',dataIndex:'wedding_covers',key:'wedding_covers',align:"center",width:150,render:function render(text,record,index){var title=['Social Event-Corp.','Covers\xA0\u4EBA\u6570',record.month_status_name];var props={text:text,index:index,type:'number',name:"wedding_covers",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'A/C\xA0\u4EBA\u5747\u6D88\u8D39',dataIndex:'wedding_ac',key:'wedding_ac',width:150,align:"center",render:function render(text,record,index){var title=['Social Event-Corp.','A/C\xA0\u4EBA\u5747\u6D88\u8D39',record.month_status_name];var props={text:text,index:index,type:'number',name:"wedding_ac",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'REV\xA0\u6536\u76CA',dataIndex:'wedding_rev',key:'wedding_rev',align:"center",width:150,render:function render(text,record,index){var title=['Social Event-Corp.','REV\xA0\u6536\u76CA',record.month_status_name];var props={text:text,index:index,type:'number',name:"wedding_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Meeting Room Rental\xA0\u573A\u79DF',dataIndex:'wedding_room',key:'wedding_room',align:"center",width:150,render:function render(text,record,index){var title=['Social Event-Corp.','Meeting Room Rental\xA0\u573A\u79DF',record.month_status_name];var props={text:text,index:index,type:'number',name:"wedding_room",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Other Revenue \u5176\u4ED6\u6536\u5165',dataIndex:'wedding_other',key:'wedding_other',align:"center",width:150,render:function render(text,record,index){var title=['Social Event-Corp.','Other Revenue \u5176\u4ED6\u6536\u5165',record.month_status_name];var props={text:text,index:index,type:'number',name:"wedding_other",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Total Revenue \u603B\u6536\u76CA\xA0',dataIndex:'wedding_total',key:'wedding_total',align:"center",width:150,render:function render(text,record,index){var title=['Social Event-Corp.','Total Revenue \u603B\u6536\u76CA\xA0',record.month_status_name];var props={text:text,index:index,type:'number',name:"wedding_total",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Total Revenue% \u603B\u6536\u76CA\u5360\u6BD4',dataIndex:'wedding_proportion',key:'wedding_proportion',align:"center",width:150,render:function render(text,record,index){var title=['Social Event-Corp.','Total Revenue% \u603B\u6536\u76CA\u5360\u6BD4',record.month_status_name];var props={text:text,index:index,type:'percent',name:"wedding_proportion",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]},{title:'Social Event-Gov.',width:450,children:[{title:'Covers\xA0\u4EBA\u6570',dataIndex:'social_covers',key:'social_covers',align:"center",width:150,render:function render(text,record,index){var title=['Social Event-Gov.','Covers\xA0\u4EBA\u6570',record.month_status_name];var props={text:text,index:index,type:'number',name:"social_covers",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'A/C\xA0\u4EBA\u5747\u6D88\u8D39',dataIndex:'social_ac',key:'social_ac',width:150,align:"center",render:function render(text,record,index){var title=['Social Event-Gov.','A/C\xA0\u4EBA\u5747\u6D88\u8D39',record.month_status_name];var props={text:text,index:index,type:'number',name:"social_ac",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'REV\xA0\u6536\u76CA',dataIndex:'social_rev',key:'social_rev',align:"center",width:150,render:function render(text,record,index){var title=['Social Event-Gov.','REV\xA0\u6536\u76CA',record.month_status_name];var props={text:text,index:index,type:'number',name:"social_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Meeting Room Rental\xA0\u573A\u79DF',dataIndex:'social_room',key:'social_room',align:"center",width:150,render:function render(text,record,index){var title=['Social Event-Gov.','Meeting Room Rental\xA0\u573A\u79DF',record.month_status_name];var props={text:text,index:index,type:'number',name:"social_room",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Other Revenue \u5176\u4ED6\u6536\u5165',dataIndex:'social_other',key:'social_other',align:"center",width:150,render:function render(text,record,index){var title=['Social Event-Gov.','Other Revenue \u5176\u4ED6\u6536\u5165',record.month_status_name];var props={text:text,index:index,type:'number',name:"social_other",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Total Revenue \u603B\u6536\u76CA\xA0',dataIndex:'social_total',key:'social_total',align:"center",width:150,render:function render(text,record,index){var title=['Social Event-Gov.','Total Revenue \u603B\u6536\u76CA\xA0',record.month_status_name];var props={text:text,index:index,type:'number',name:"social_total",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Total Revenue% \u603B\u6536\u76CA\u5360\u6BD4',dataIndex:'social_proportion',key:'social_proportion',align:"center",width:150,render:function render(text,record,index){var title=['Social Event-Gov.','Total Revenue% \u603B\u6536\u76CA\u5360\u6BD4',record.month_status_name];var props={text:text,index:index,type:'percent',name:"social_proportion",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]},{title:'Social Event-others',width:450,children:[{title:'Covers\xA0\u4EBA\u6570',dataIndex:'group_covers',key:'group_covers',align:"center",width:150,render:function render(text,record,index){var title=['Social Event-others','Covers\xA0\u4EBA\u6570',record.month_status_name];var props={text:text,index:index,type:'number',name:"group_covers",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'A/C\xA0\u4EBA\u5747\u6D88\u8D39',dataIndex:'group_ac',key:'group_ac',width:150,align:"center",render:function render(text,record,index){var title=['Social Event-others','A/C\xA0\u4EBA\u5747\u6D88\u8D39',record.month_status_name];var props={text:text,index:index,type:'number',name:"group_ac",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'REV\xA0\u6536\u76CA',dataIndex:'group_rev',key:'group_rev',align:"center",width:150,render:function render(text,record,index){var title=['Social Event-others','REV\xA0\u6536\u76CA',record.month_status_name];var props={text:text,index:index,type:'number',name:"group_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Meeting Room Rental\xA0\u573A\u79DF',dataIndex:'group_room',key:'group_room',align:"center",width:150,render:function render(text,record,index){var title=['Social Event-others','Meeting Room Rental\xA0\u573A\u79DF',record.month_status_name];var props={text:text,index:index,type:'number',name:"group_room",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Other Revenue \u5176\u4ED6\u6536\u5165',dataIndex:'group_other',key:'group_other',align:"center",width:150,render:function render(text,record,index){var title=['Social Event-others','Other Revenue \u5176\u4ED6\u6536\u5165',record.month_status_name];var props={text:text,index:index,type:'number',name:"group_other",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index<36&&index%3==0&&month==1&&!print)type='inputNumber';// 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
if(!print&&index<36&&index%3==1&&Math.ceil((index+1)/3)>month-1&&Math.ceil((index+1)/3)<=(0,_method.numConvert)(month)+2){type='inputNumber';}if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Total Revenue \u603B\u6536\u76CA\xA0',dataIndex:'group_total',key:'group_total',align:"center",width:150,render:function render(text,record,index){var title=['Social Event-others','Total Revenue \u603B\u6536\u76CA\xA0',record.month_status_name];var props={text:text,index:index,type:'number',name:"group_total",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Total Revenue% \u603B\u6536\u76CA\u5360\u6BD4',dataIndex:'group_proportion',key:'group_proportion',align:"center",width:150,render:function render(text,record,index){var title=['Social Event-others','Total Revenue% \u603B\u6536\u76CA\u5360\u6BD4',record.month_status_name];var props={text:text,index:index,type:'percent',name:"group_proportion",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]},{title:'Grand Total',width:450,children:[{title:'Covers\xA0\u4EBA\u6570',dataIndex:'grand_covers',key:'grand_covers',align:"center",width:150,render:function render(text,record,index){var title=['Grand Total','Covers\xA0\u4EBA\u6570',record.month_status_name];var props={text:text,index:index,type:'number',name:"grand_covers",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'A/C\xA0\u4EBA\u5747\u6D88\u8D39',dataIndex:'grand_ac',key:'grand_ac',width:150,align:"center",render:function render(text,record,index){var title=['Grand Total','A/C\xA0\u4EBA\u5747\u6D88\u8D39',record.month_status_name];var props={text:text,index:index,type:'number',name:"grand_ac",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'REV\xA0\u6536\u76CA',dataIndex:'grand_rev',key:'grand_rev',align:"center",width:150,render:function render(text,record,index){var title=['Grand Total','REV\xA0\u6536\u76CA',record.month_status_name];var props={text:text,index:index,type:'number',name:"grand_rev",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Meeting Room Rental\xA0\u573A\u79DF',dataIndex:'grand_room',key:'grand_room',align:"center",width:150,render:function render(text,record,index){var title=['Grand Total','Meeting Room Rental\xA0\u573A\u79DF',record.month_status_name];var props={text:text,index:index,type:'number',name:"grand_room",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Other Revenue \u5176\u4ED6\u6536\u5165',dataIndex:'grand_other',key:'grand_other',align:"center",width:150,render:function render(text,record,index){var title=['Grand Total','Other Revenue \u5176\u4ED6\u6536\u5165',record.month_status_name];var props={text:text,index:index,type:'number',name:"grand_other",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:'Total Revenue \u603B\u6536\u76CA\xA0',dataIndex:'grand_total',key:'grand_total',align:"center",width:150,render:function render(text,record,index){var title=['Grand Total','Total Revenue \u603B\u6536\u76CA\xA0',record.month_status_name];var props={text:text,index:index,type:'number',name:"grand_total",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"_6_1new"}};var type='number';if(index===41||index===38)type='percent';return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1 tableHeight'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_1_2',style:{width:this.state.print?4400:'auto'}},_react2.default.createElement(_row2.default,null,'6.1.2 Social Event Analysis\u793E\u4F1A\u5BB4\u4F1A\u6D3B\u52A8\u5206\u6790'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',id:'table2',bordered:true,pagination:false,rowClassName:'protruding',className:'content',style:{width:this.state.print?4350:'auto'},scroll:this.state.print?{}:{x:4350,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){_this2.setState({print:true},function(){_this2.downloadExcel();});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_6_1'},_react2.default.createElement(_button2.default,{type:'primary',style:{margin:'0 10px'},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var dataDefault=exports.dataDefault=[{"name":"Jan","sort":0,"month_status":"Budget",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Jan","sort":1,"month_status":"Actual",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Jan","sort":2,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Feb","sort":3,"month_status":"Budget",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Feb","sort":4,"month_status":"Actual",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Feb","sort":5,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Mar","sort":6,"month_status":"Budget",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Mar","sort":7,"month_status":"Actual",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Mar","sort":8,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Apr","sort":9,"month_status":"Budget",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Apr","sort":10,"month_status":"Actual",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Apr","sort":11,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"May","sort":12,"month_status":"Budget",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"May","sort":13,"month_status":"Actual",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"May","sort":14,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Jun","sort":15,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Jun","sort":16,"month_status":"Actual",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Jun","sort":17,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Jul","sort":18,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Jul","sort":19,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Jul","sort":20,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Aug","sort":21,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Aug","sort":22,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Aug","sort":23,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Sep","sort":24,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Sep","sort":25,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Sep","sort":26,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Oct","sort":27,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Oct","sort":28,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Oct","sort":29,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Nov","sort":30,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Nov","sort":31,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Nov","sort":32,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Dec","sort":33,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Dec","sort":34,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Dec","sort":35,"month_status":"Actual Last Year",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"YTD","sort":36,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"YTD","sort":37,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"YTD","sort":38,"month_status":"Variance%",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Year End","sort":39,"month_status":"",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Year End","sort":40,"month_status":"Act/Fcst ",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0},{"name":"Year End","sort":41,"month_status":"Variance%",wedding_covers:0,wedding_ac:0,wedding_rev:0,wedding_room:0,wedding_other:0,wedding_total:0,wedding_proportion:0,social_covers:0,social_ac:0,social_rev:0,social_room:0,social_other:0,social_total:0,social_proportion:0,group_covers:0,group_ac:0,group_rev:0,group_room:0,group_other:0,group_total:0,group_proportion:0,grand_covers:0,grand_ac:0,grand_rev:0,grand_room:0,grand_other:0,grand_total:0}];

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=compute;var _method=__webpack_require__(20);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function compute(data,date){var month=(0,_moment2.default)(date).format('M');var totalName=['grand_covers','grand_rev','grand_room','grand_other'];var leftName=['wedding','social','group'];// grandtotal
totalName.forEach(function(name){data.forEach(function(item,i){if(![38,41].includes(i)){data[i][name]=leftName.reduce(function(a,b){a+=(0,_method.numConvert)(item[b+'_'+name.split('_')[1]]);return a;},0).toFixed(2);}});});// 计算收益
[].concat(leftName,['grand']).forEach(function(name){data.forEach(function(item,i){if(![38,41].includes(i)){data[i][name+'_ac']=(0,_method.calculation)(data[i][name+'_rev'],data[i][name+'_covers']);data[i][name+'_total']=(0,_method.sum)([data[i][name+'_rev'],data[i][name+'_room'],data[i][name+'_other']]);}});});// YTD 累加到当前月份之前  Year End
[].concat(leftName,['grand']).forEach(function(left){['_covers','_ac','_rev','_room','_other','_total'].forEach(function(right){data[36][left+right]=data.reduce(function(a,b,i){if(i<36&&Math.ceil((i+1)/3)<month&&i%3==0){a+=(0,_method.numConvert)(b[left+right]);}return a;},0).toFixed(2);data[37][left+right]=data.reduce(function(a,b,i){if(i<36&&Math.ceil((i+1)/3)<month&&i%3==1){a+=(0,_method.numConvert)(b[left+right]);}return a;},0).toFixed(2);data[39][left+right]=data.reduce(function(a,b,i){if(i<36&&i%3==0){a+=(0,_method.numConvert)(b[left+right]);}return a;},0).toFixed(2);data[40][left+right]=data.reduce(function(a,b,i){if(i<36&&i%3==1){a+=(0,_method.numConvert)(b[left+right]);}return a;},0).toFixed(2);});});// 收益占比
[].concat(leftName,['grand']).forEach(function(name){data.forEach(function(item,i){// 计算YTD Year-End人均消费
if(i>=36){data[i][name+'_ac']=(0,_method.calculation)(data[i][name+'_rev'],data[i][name+'_covers'],2);}if(![38,41].includes(i)&&name!='grand'){data[i][name+'_proportion']=(0,_method.calculation)(data[i][name+'_total'],data[i]['grand_total'],4);}});});// Variance%
[].concat(leftName,['grand']).forEach(function(left){['_covers','_ac','_rev','_room','_other','_total'].forEach(function(right){data[41][left+right]=(0,_method.calculation)(data[40][left+right]-data[39][left+right],data[39][left+right],4);data[38][left+right]=(0,_method.calculation)(data[37][left+right]-data[36][left+right],data[36][left+right],4);});});return data;}

/***/ }),
/* 1962 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(700);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _compute=__webpack_require__(701);var _compute2=_interopRequireDefault(_compute);var _=__webpack_require__(1964);var _2=_interopRequireDefault(_);__webpack_require__(1965);var _getJson=__webpack_require__(252);var _getJson2=_interopRequireDefault(_getJson);var _method=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var totalIndex=[0,3,14,25,46,47];var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){data=(0,_compute2.default)([].concat(_toConsumableArray(data)),_this.state.date);data[47].total=(data[46].total-(0,_method.sum)([(0,_getJson2.default)([2,'REV'],_this.state.data5_1_1),(0,_getJson2.default)([14,'REV'],_this.state.data5_1_1)])).toFixed(2);_this.setState({data:data});};_this.onChangeUpdate=function(data){_this.setState({isUpdate:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getData=function(date){var dataBegin=JSON.stringify(_data.dataDefault);var data=JSON.parse(dataBegin);fetch('/_6_2_all?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.now&&x.data.now.length>0){data=x.data.now.sort(function(a,b){return a.sort-b.sort;});// 数据结构多次变化， 无法兼容，此表从头开始
// if (data.length === 18) {
//     data.push({
//         name: "Total<br/>总计",
//         meet: 0,
//         space: 0,
//         no: 0,
//         sold: 0,
//         occ: 0,
//         total: 0,
//         sc: 0,
//         rev: 0,
//         sort: 18,
//     });
// }
}data.forEach(function(item,i){if(!totalIndex.includes(i)){data[i].meet=(0,_getJson2.default)([index,'conference_num'],x.data.b17_1||[]);}});_this.setState({loading:false,data5_1_1:x.data.data5_1_1||[]},function(){_this.computeNum(data);});}).catch(function(err){console.error(err);_this.setState({loading:false});});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_6_2',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getData(_this.state.date);}_this.setState({isUpdate:true});return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table6_2',1.5,'6.21',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.onFillLastMonth=function(){if(_this.state.data[0]&&_this.state.data[0].id){_message3.default.error('当前月份数据已存在!');_this.setState({loading:false});return;}_this.setState({loading:true,data:[]});var date=_this.state.date;var dataBegin=JSON.stringify(_data.dataDefault);var data=JSON.parse(dataBegin);fetch('/_6_2_all?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.last&&x.data.last.length>0&&(x.data.now||[]).length<=0){data=x.data.last.map(function(v){delete v.id;delete v.month;delete v.year;return v;}).sort(function(a,b){return a.sort-b.sort;});;};_message3.default.info('数据填充成功！');_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],note:{note:""},loading:true,loadingSave:false,print:false,isUpdate:false,data5_1_1:[]};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData(this.state.date);}// 获取表格5_6_1内容
// 保存表格5-6-1内容
},{key:'render',value:function render(){var _this2=this;var _state=this.state,isUpdate=_state.isUpdate,data=_state.data;var columns=[{title:_react2.default.createElement('div',null,'Meeting Room/Ballroom ',_react2.default.createElement('br',null),' \u4F1A\u8BAE\u5BA4/\u5BB4\u4F1A\u5385'),dataIndex:'name',key:'name',align:"center",fixed:"left",width:300,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this2.onChange,totalIndex:totalIndex};if(index===47){return _react2.default.createElement('div',{style:{wordWrap:'break-word',wordBreak:'break-all'}},_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:''})}));}return _react2.default.createElement('div',{style:{wordWrap:'break-word',wordBreak:'break-all'}},_react2.default.createElement(_TableText2.default,{data:_extends({},props)}));}},{title:_react2.default.createElement('div',null,'Meeting/Banquet Space SQM ',_react2.default.createElement('br',null),' \u573A\u5730\u9762\u79EF\uFF08\u5E73\u65B9\u7C73\uFF09'),dataIndex:'meet',key:'meet',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"meet",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['Meeting/Banquet Space SQM <br /> 场地面积（平方米）'],record:record,sqlName:"_6_2_new"}};if(index===47){return _react2.default.createElement('div',{style:{wordWrap:'break-word',wordBreak:'break-all'}},_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:''})}));}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Space Available SQM',_react2.default.createElement('br',null),' \u53EF\u552E\u603B\u9762\u79EF\uFF08\u5E73\u65B9\u7C73\uFF09'),dataIndex:'space',key:'space',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"space",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['Space Available SQM<br /> 可售总面积（平方米）'],record:record,sqlName:"_6_2_new"}};if(index===47){return _react2.default.createElement('div',{style:{wordWrap:'break-word',wordBreak:'break-all'}},_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:''})}));}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'No. of Meeting/Events ',_react2.default.createElement('br',null),' \u4F1A\u8BAE\u573A\u6B21'),dataIndex:'no',key:'no',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,name:"no",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['No. of Meeting/Events <br /> 会议场次'],record:record,sqlName:"_6_2_new"}};var type="number";if(!totalIndex.includes(index)){type='inputNumber';}if(index===47){return _react2.default.createElement('div',{style:{wordWrap:'break-word',wordBreak:'break-all'}},_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:''})}));}return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:_react2.default.createElement('div',null,'Sold Space',_react2.default.createElement('br',null),' \u51FA\u552E\u603B\u9762\u79EF\uFF08\u5E73\u65B9\u7C73\uFF09'),dataIndex:'sold',key:'sold',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,name:"sold",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['Sold Space<br /> 出售总面积（平方米）'],record:record,sqlName:"_6_2_new"}};var type="number";if(!totalIndex.includes(index)){type='inputNumber';}if(index===47){return _react2.default.createElement('div',{style:{wordWrap:'break-word',wordBreak:'break-all'}},_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:''})}));}return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:_react2.default.createElement('div',null,'Space Occupancy',_react2.default.createElement('br',null),' \u4F1A\u8BAE\u573A\u5730\u51FA\u79DF\u7387'),dataIndex:'occ',key:'occ',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,name:"occ",type:"percent",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['Space Occupancy<br /> 会议场地出租率'],record:record,sqlName:"_6_2_new"}};if(index===47){return _react2.default.createElement('div',{style:{wordWrap:'break-word',wordBreak:'break-all'}},_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:''})}));}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Total Catering Revenue',_react2.default.createElement('br',null),' \u5BB4\u4F1A\u6D3B\u52A8\u603B\u6536\u5165'),dataIndex:'total',key:'total',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,name:"total",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['Total Catering Revenue<br /> 宴会活动总收入'],record:record,sqlName:"_6_2_new"}};var type="number";if(!totalIndex.includes(index)){type='inputNumber';}return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:_react2.default.createElement('div',null,'S/C',_react2.default.createElement('br',null),' \u6BCF\u5E73\u65B9\u7C73\u5E73\u5747\u6D88\u8D39'),dataIndex:'sc',key:'sc',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,name:"sc",type:"number",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['S/C<br /> 每平方米平均消费'],record:record,sqlName:"_6_2_new"}};if(index===47){return _react2.default.createElement('div',{style:{wordWrap:'break-word',wordBreak:'break-all'}},_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:''})}));}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'RevPASP ',_react2.default.createElement('br',null),' \u53EF\u552E\u573A\u5730\u9762\u79EF\u5E73\u5747\u6536\u5165'),dataIndex:'rev',key:'rev',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,name:"rev",type:"number",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['RevPASP <br /> 可售场地面积平均收入'],record:record,sqlName:"_6_2_new"}};if(index===47){return _react2.default.createElement('div',{style:{wordWrap:'break-word',wordBreak:'break-all'}},_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:''})}));}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1 height-52'},_react2.default.createElement(_row2.default,{className:'first-title'},'6.2 F&B Catering/Banquet KPI Analysis \u9910\u996E\u90E8\u5BB4\u4F1A\u6D3B\u52A8\u5173\u952E\u7EE9\u6548\u6307\u6570\u5206\u6790'),_react2.default.createElement(_row2.default,{className:'title',id:'table6_2',style:{width:this.state.print?1950:'auto'}},_react2.default.createElement(_row2.default,null,'6.2.1 MTD This Year \u6708\u7D2F\u8BA1 - \u672C\u5E74\u5F53\u6708'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true,note:{note:""}});_this2.getData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,scroll:this.state.print?{}:{x:1900,y:500},className:'content',rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_6_2'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))),_react2.default.createElement(_2.default,{update:isUpdate,onChange:this.onChangeUpdate}));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(700);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _compute=__webpack_require__(701);var _compute2=_interopRequireDefault(_compute);var _method=__webpack_require__(20);var _getJson=__webpack_require__(252);var _getJson2=_interopRequireDefault(_getJson);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var totalIndex=[0,3,14,25,46,47];Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){data=(0,_compute2.default)([].concat(_toConsumableArray(data)));data[47].total=(data[46].total-(0,_method.sum)([(0,_getJson2.default)([2,'REV'],_this.state.data5_1_3),(0,_getJson2.default)([14,'REV'],_this.state.data5_1_3)])).toFixed(2);_this.setState({data:data});_this.props.onChange(false);};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getData=function(date){var dataBegin=JSON.stringify(_data.dataDefault);var data=JSON.parse(dataBegin);var listname=['meet','space','no','sold','total'];fetch('/_6_2_2?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){data.forEach(function(item,i){listname.forEach(function(name){if(i!=47){data[i][name]=(x.data.data||[]).filter(function(v){return v.sort===item.sort;}).reduce(function(a,b){a+=(0,_method.numConvert)(b[name]);return a;},0).toFixed(2);}});});_this.setState({loading:false,data5_1_3:x.data.data5_1_3||[]},function(){_this.computeNum(data);});}).catch(function(err){console.error(err);_this.setState({loading:false});});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table6_2_2',1.5,'6.22',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],note:{note:""},loading:true,loadingSave:false,print:false,data5_1_3:[]};return _this;}_createClass(index,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.update&&nextProps.update!=this.props.update){this.setState({data:[],loading:true});this.getData(this.state.date);}}},{key:'componentDidMount',value:function componentDidMount(){this.getData(this.state.date);}// 获取表格5_6_1内容
},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,date=_state.date;var columns=[{title:_react2.default.createElement('div',null,'Meeting Room/Ballroom ',_react2.default.createElement('br',null),' \u4F1A\u8BAE\u5BA4/\u5BB4\u4F1A\u5385'),dataIndex:'name',key:'name',align:"center",width:300,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this2.onChange,totalIndex:totalIndex};if(index===47){return _react2.default.createElement('div',{style:{wordWrap:'break-word',wordBreak:'break-all'}},_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:''})}));}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Meeting/Banquet Space SQM ',_react2.default.createElement('br',null),' \u573A\u5730\u9762\u79EF\uFF08\u5E73\u65B9\u7C73\uFF09'),dataIndex:'meet',key:'meet',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"meet",onChange:_this2.onChange,totalIndex:totalIndex// compared: {
//     title: ['Meeting/Banquet Space SQM <br /> 场地面积（平方米）'],
//     record,
//     sqlName: "_6_2_new"
// }
};if(index===47){return _react2.default.createElement('div',{style:{wordWrap:'break-word',wordBreak:'break-all'}},_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:''})}));}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Space Available SQM',_react2.default.createElement('br',null),' \u53EF\u552E\u603B\u9762\u79EF\uFF08\u5E73\u65B9\u7C73\uFF09'),dataIndex:'space',key:'space',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"space",onChange:_this2.onChange,totalIndex:totalIndex// compared: {
//     title: ['Space Available SQM<br /> 可售总面积（平方米）'],
//     record,
//     sqlName: "_6_2_new"
// }
};if(index===47){return _react2.default.createElement('div',{style:{wordWrap:'break-word',wordBreak:'break-all'}},_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:''})}));}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'No. of Meeting/Events ',_react2.default.createElement('br',null),' \u4F1A\u8BAE\u573A\u6B21'),dataIndex:'no',key:'no',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,name:"no",onChange:_this2.onChange,totalIndex:totalIndex// compared: {
//     title: ['No. of Meeting/Events <br /> 会议场次'],
//     record,
//     sqlName: "_6_2_new"
// }
};var type="number";if(index===47){return _react2.default.createElement('div',{style:{wordWrap:'break-word',wordBreak:'break-all'}},_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:''})}));}return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:_react2.default.createElement('div',null,'Sold Space',_react2.default.createElement('br',null),' \u51FA\u552E\u603B\u9762\u79EF\uFF08\u5E73\u65B9\u7C73\uFF09'),dataIndex:'sold',key:'sold',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,name:"sold",onChange:_this2.onChange,totalIndex:totalIndex// compared: {
//     title: ['Sold Space<br /> 出售总面积（平方米）'],
//     record,
//     sqlName: "_6_2_new"
// }
};var type="number";if(index===47){return _react2.default.createElement('div',{style:{wordWrap:'break-word',wordBreak:'break-all'}},_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:''})}));}return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:_react2.default.createElement('div',null,'Space Occupancy',_react2.default.createElement('br',null),' \u4F1A\u8BAE\u573A\u5730\u51FA\u79DF\u7387'),dataIndex:'occ',key:'occ',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,name:"occ",type:"percent",onChange:_this2.onChange,totalIndex:totalIndex// compared: {
//     title: ['Space Occupancy<br /> 会议场地出租率'],
//     record,
//     sqlName: "_6_2_new"
// }
};if(index===47){return _react2.default.createElement('div',{style:{wordWrap:'break-word',wordBreak:'break-all'}},_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:''})}));}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Total Catering Revenue',_react2.default.createElement('br',null),' \u5BB4\u4F1A\u6D3B\u52A8\u603B\u6536\u5165'),dataIndex:'total',key:'total',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,name:"total",onChange:_this2.onChange,totalIndex:totalIndex// compared: {
//     title: ['Total Catering Revenue<br /> 宴会活动总收入'],
//     record,
//     sqlName: "_6_2_new"
// }
};var type="number";return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:type})});}},{title:_react2.default.createElement('div',null,'S/C',_react2.default.createElement('br',null),' \u6BCF\u5E73\u65B9\u7C73\u5E73\u5747\u6D88\u8D39'),dataIndex:'sc',key:'sc',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,name:"sc",type:"number",onChange:_this2.onChange,totalIndex:totalIndex// compared: {
//     title: ['S/C<br /> 每平方米平均消费'],
//     record,
//     sqlName: "_6_2_new"
// }
};if(index===47){return _react2.default.createElement('div',{style:{wordWrap:'break-word',wordBreak:'break-all'}},_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:''})}));}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'RevPASP ',_react2.default.createElement('br',null),' \u53EF\u552E\u573A\u5730\u9762\u79EF\u5E73\u5747\u6536\u5165'),dataIndex:'rev',key:'rev',align:"center",width:100,render:function render(text,record,index){var props={text:text,index:index,name:"rev",type:"number",onChange:_this2.onChange,totalIndex:totalIndex// compared: {
//     title: ['RevPASP <br /> 可售场地面积平均收入'],
//     record,
//     sqlName: "_6_2_new"
// }
};if(index===47){return _react2.default.createElement('div',{style:{wordWrap:'break-word',wordBreak:'break-all'}},_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:''})}));}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1 height-52'},_react2.default.createElement(_row2.default,{className:'title',id:'table6_2_2'},_react2.default.createElement(_row2.default,null,'6.2.2 YTD This Year \u5E74\u7D2F\u8BA1\u672C\u5E74'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true,note:{note:""}});_this2.getData(str);}}),(0,_moment2.default)(date).format('YYYY')==2019&&_react2.default.createElement('span',{style:{fontSize:14,marginLeft:10}},'2019\u5E74\u4ECE7\u6708\u5F00\u59CB\u7D2F\u8BA1\u6570\u636E')),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,scroll:this.state.print?{}:{y:500},className:'content',rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_6_2'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1965 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(8);__webpack_require__(6);__webpack_require__(4);__webpack_require__(10);__webpack_require__(25);__webpack_require__(42);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(1967);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var Option=_select2.default.Option;var TextArea=_input2.default.TextArea;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;};_this.getDateData=function(date,isLastMonth){var dataBegin=JSON.stringify(_data.data2_1);var data=JSON.parse(dataBegin);if(isLastMonth){date=(0,_moment2.default)(date).subtract(1,'month').format('YYYY-MM');if(_this.state.data.some(function(x){return x.id;}))return _message3.default.error('当月数据已存在，无法填充！');_this.setState({data:[],loading:true});}fetch('/_6_5_all?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.dataNow&&x.data.dataNow.length>0){data=x.data.dataNow;}if(isLastMonth){data=data.map(function(x){delete x.id;return x;});}_this.setState({loading:false,data:data});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();if(_this.state.note.note){_this.onSaveNote([_extends({},_this.state.note,{year:year,month:month})]);}dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_6_3',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.onSaveNote=function(data){var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_6_3_1',headres).then(function(x){return x.json();}).then(function(x){if(x.status==1){if(!_this.state.note.id){_this.getDateData(_this.state.date);}return;}_message3.default.error('备注保存失败：'+x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败！');console.error(err);});};_this.onChangeSelect=function(name,value){var data=_this.state.data;data[0][name]=value.key;_this.setState({data:data});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table6_3',1.5,'6.30',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,note:{note:""},print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var width=document.body.offsetWidth>2425?document.body.offsetWidth-2000:425;var totalData=[8,12,13];var columns=[{align:"center",title:_react2.default.createElement('div',null),dataIndex:'name',key:'name',width:width,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"left"}},text);}},{title:'Action Plan for Next 3months',dataIndex:'Comments',key:'Comments',align:"center",render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(TextArea,{autosize:{minRows:3},className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('Comments',value,index);}}));}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table table2_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table6_3',style:{width:this.state.print?2475:'auto'}},_react2.default.createElement(_row2.default,null,'6.3 C&E 3 Month Rolling Action Plan By Outlets \u4E09\u4E2A\u6708\u6309\u7167\u9910\u5385\u7EC6\u5206\u7684\u6EDA\u52A8\u884C\u52A8\u8BA1\u5212'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}}),_react2.default.createElement(_button2.default,{type:'primary',style:{marginLeft:10,display:this.state.print?'none':''},onClick:this.getDateData.bind(this,this.state.date,true)},'\u586B\u5145\u4E0A\u6708\u6570\u636E')),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',className:'content',bordered:true,pagination:false,rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_6_3'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data2_1=exports.data2_1=[{name:'Wedding',Comments:""},{name:'Social Events',Comments:""},{name:'Group Events',Comments:""}];

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _PayrollCostByLevel=__webpack_require__(702);var _PayrollCostByLevel2=_interopRequireDefault(_PayrollCostByLevel);var _PayrollCostByDepartment=__webpack_require__(705);var _PayrollCostByDepartment2=_interopRequireDefault(_PayrollCostByDepartment);var _=__webpack_require__(1970);var _2=_interopRequireDefault(_);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",null,_react2.default.createElement(_row2.default,{style:{margin:"24px 0 24px 24px",fontSize:22,color:"#333"}},"7.1 Total Payroll Cost Analysis \u85AA\u916C\u603B\u6210\u672C\u5206\u6790"),_react2.default.createElement(_PayrollCostByLevel2.default,this.props),_react2.default.createElement(_PayrollCostByDepartment2.default,this.props),_react2.default.createElement(_2.default,null));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _popover=__webpack_require__(396);var _popover2=_interopRequireDefault(_popover);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(287);__webpack_require__(6);__webpack_require__(10);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Compared=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Compared,_Component);function Compared(props){_classCallCheck(this,Compared);var _this=_possibleConstructorReturn(this,(Compared.__proto__||Object.getPrototypeOf(Compared)).call(this,props));_this.addCompared=function(){_this.setState({loading:true});var data=_this.props.data;data=_extends({},data,{title:data.title.toString(),add_time:(0,_moment2.default)().format('YYYY-MM-DD HH:mm:ss')});var headres={method:'post',credentials:'include',headers:{contentType:"application/json;charset=utf-8"},body:JSON.stringify(data)};var esData=["hr_9"];// console.log(data);
// return
var url=esData.includes(data.sqlName)?'/addECompared':"/addHrCompared";fetch(url,headres).then(function(x){return x.json();}).then(function(x){if(x.status==1){_message3.default.success('添加成功');}else{_message3.default.error('添加失败！');}_this.setState({loading:false});}).catch(function(err){console.error(err);_this.setState({loading:false});});};_this.state={loading:false};return _this;}_createClass(Compared,[{key:'render',value:function render(){var content=_react2.default.createElement(_button2.default,{style:{width:"100%"},onClick:this.addCompared,loading:this.state.loading},'\u6DFB\u52A0');// return (
//     <Popover content={content} title="点击添加到对比数据">
//         {this.props.children}
//     </Popover>
// )
if(this.props.store.compared.state){return _react2.default.createElement(_popover2.default,{content:content,title:_react2.default.createElement('div',{style:{textAlign:'center'}},'\u70B9\u51FB\u6DFB\u52A0\u5230\u5BF9\u6BD4\u6570\u636E')},this.props.children);}return this.props.children;}}]);return Compared;}(_react.Component))||_class)||_class);exports.default=Compared;

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _compute=__webpack_require__(1971);var _data=__webpack_require__(1972);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);__webpack_require__(1973);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],key:0,loading:true},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var data,year,month,res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:data=_lodash2.default.cloneDeep(_data.defaultData);_context.prev=1;year=(0,_moment2.default)(date).format('YYYY');month=(0,_moment2.default)(date).format('M');_context.next=6;return(0,_request2.default)('/t7_1_3chart?year='+year+'&month='+month);case 6:res=_context.sent;if(res.data.data&&res.data.data.length){data=res.data.data.sort(function(a,b){return a.sort-b.sort;});}data=(0,_compute.compute)(res.data,data);_this.setState({loading:false,data:data},function(){_this.onSave();_this.setChart(_this.state.key);});_context.next=16;break;case 12:_context.prev=12;_context.t0=_context['catch'](1);console.error(_context.t0,'数据加载错误！');_this.setState({loading:false});case 16:case'end':return _context.stop();}}},_callee,_this2,[[1,12]]);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.onSelectKey=function(key){_this.setState({key:key});_this.setChart(key);},_this.setChart=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var key=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var date,year,month,res,list,dataY;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;date=_this.state.date;year=(0,_moment2.default)(date).format('YYYY');month=(0,_moment2.default)(date).format('M');_context2.next=6;return(0,_request2.default)('/t7_1_3chartLst?year='+year+'&month='+month);case 6:res=_context2.sent;list=new Array(12).fill(1).map(function(x,i){return i+1;});dataY=[{name:"酒店总收入",data:list.map(function(x){return _lodash2.default.get(res,'data.total.'+x);})},{name:"酒店总人力成本",data:list.map(function(x){return _lodash2.default.get(res,'data.totalHr.'+x);})},{name:"客房部门收入",data:list.map(function(x){return _lodash2.default.get(res,'data.room.'+x);})},{name:"客房部门人力成本",data:list.map(function(x){return _lodash2.default.get(res,'data.roomHr.'+x);})},{name:"客房部门帮工费用",data:list.map(function(x){return _lodash2.default.get(res,'data.roomLab.'+x);})},{name:"餐饮部门收入",data:list.map(function(x){return _lodash2.default.get(res,'data.food.'+x);})},{name:"餐饮部门人力成本",data:list.map(function(x){return _lodash2.default.get(res,'data.foodHr.'+x);})},{name:"餐饮部门帮工费用",data:list.map(function(x){return _lodash2.default.get(res,'data.foodLab.'+x);})},{name:"其他营业部门收入",data:list.map(function(x){return _lodash2.default.get(res,'data.other.'+x);})},{name:"其他营业部门人力成本",data:list.map(function(x){return _lodash2.default.get(res,'data.otherHr.'+x);})}];if(key==0)dataY=dataY.slice(0,2);if(key==1)dataY=dataY.slice(2,5);if(key==2)dataY=dataY.slice(5,8);if(key==3)dataY=dataY.slice(8);(0,_compute.setKarte)({dataY:dataY});_context2.next=19;break;case 16:_context2.prev=16;_context2.t0=_context2['catch'](0);console.log(_context2.t0);case 19:case'end':return _context2.stop();}}},_callee2,_this2,[[0,16]]);}));return function(){return _ref3.apply(this,arguments);};}(),_this.getValue=function(){var v=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var type=arguments[1];if(type=='percent')return(v*100).toFixed(2).toString()+'%';return v.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');},_this.onSave=function(){var date=_this.state.date;var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/t7_1_3chartSave',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData(this.state.date);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,loading=_state.loading,data=_state.data;return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'table7_1_1 table7_1_3'},_react2.default.createElement(_row2.default,{className:'title'},_react2.default.createElement(_row2.default,null,'7.1.3 \u6570\u636E\u53EF\u89C6\u5316'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getData(str);}})),_react2.default.createElement('div',{className:'chart-list'},_react2.default.createElement('div',{className:'item',onClick:function onClick(){return _this3.onSelectKey(0);}},_react2.default.createElement('div',{className:'child',style:{backgroundColor:_lodash2.default.get(data,'0.diff',0)<0?"#50B07A":"#E37646"}},_react2.default.createElement('div',{className:'name'},'\u9152\u5E97\u603B\u6536\u5165'),_react2.default.createElement('div',{className:'value'},'\u8F83\u53BB\u5E74\u540C\u671F\u5DEE\u503C ',this.getValue(_lodash2.default.get(data,'0.diff',0))),_react2.default.createElement('div',{className:'value'},'\u8F83\u53BB\u5E74\u540C\u671F\u6BD4\u503C ',this.getValue(_lodash2.default.get(data,'0.rat',0),'percent'))),_react2.default.createElement('div',{className:'child',style:{backgroundColor:_lodash2.default.get(data,'1.diff',0)<0?"#50B07A":"#E37646"}},_react2.default.createElement('div',{className:'name'},'\u9152\u5E97\u603B\u4EBA\u529B\u6210\u672C'),_react2.default.createElement('div',{className:'value'},'\u8F83\u53BB\u5E74\u540C\u671F\u5DEE\u503C ',this.getValue(_lodash2.default.get(data,'1.diff',0))),_react2.default.createElement('div',{className:'value'},'\u8F83\u53BB\u5E74\u540C\u671F\u6BD4\u503C ',this.getValue(_lodash2.default.get(data,'1.rat',0),'percent')))),_react2.default.createElement('div',{className:'item',onClick:function onClick(){return _this3.onSelectKey(1);}},_react2.default.createElement('div',{className:'child',style:{backgroundColor:_lodash2.default.get(data,'2.diff',0)<0?"#50B07A":"#E37646"}},_react2.default.createElement('div',{className:'name'},'\u5BA2\u623F\u90E8\u95E8\u6536\u5165'),_react2.default.createElement('div',{className:'value'},'\u8F83\u53BB\u5E74\u540C\u671F\u5DEE\u503C ',this.getValue(_lodash2.default.get(data,'2.diff',0))),_react2.default.createElement('div',{className:'value'},'\u8F83\u53BB\u5E74\u540C\u671F\u6BD4\u503C ',this.getValue(_lodash2.default.get(data,'2.rat',0),'percent'))),_react2.default.createElement('div',{className:'child',style:{backgroundColor:_lodash2.default.get(data,'3.diff',0)<0?"#50B07A":"#E37646"}},_react2.default.createElement('div',{className:'name'},'\u5BA2\u623F\u90E8\u95E8\u4EBA\u529B\u6210\u672C'),_react2.default.createElement('div',{className:'value'},'\u8F83\u53BB\u5E74\u540C\u671F\u5DEE\u503C ',this.getValue(_lodash2.default.get(data,'3.diff',0))),_react2.default.createElement('div',{className:'value'},'\u8F83\u53BB\u5E74\u540C\u671F\u6BD4\u503C ',this.getValue(_lodash2.default.get(data,'3.rat',0),'percent'))),_react2.default.createElement('div',{className:'child',style:{backgroundColor:_lodash2.default.get(data,'4.diff',0)<0?"#50B07A":"#E37646"}},_react2.default.createElement('div',{className:'name'},'\u5BA2\u623F\u90E8\u95E8\u5E2E\u5DE5\u8D39\u7528'),_react2.default.createElement('div',{className:'value'},'\u8F83\u53BB\u5E74\u540C\u671F\u5DEE\u503C ',this.getValue(_lodash2.default.get(data,'4.diff',0))),_react2.default.createElement('div',{className:'value'},'\u8F83\u53BB\u5E74\u540C\u671F\u6BD4\u503C ',this.getValue(_lodash2.default.get(data,'4.rat',0),'percent')))),_react2.default.createElement('div',{className:'item',onClick:function onClick(){return _this3.onSelectKey(2);}},_react2.default.createElement('div',{className:'child',style:{backgroundColor:_lodash2.default.get(data,'5.diff',0)<0?"#50B07A":"#E37646"}},_react2.default.createElement('div',{className:'name'},'\u9910\u996E\u90E8\u95E8\u6536\u5165'),_react2.default.createElement('div',{className:'value'},'\u8F83\u53BB\u5E74\u540C\u671F\u5DEE\u503C ',this.getValue(_lodash2.default.get(data,'5.diff',0))),_react2.default.createElement('div',{className:'value'},'\u8F83\u53BB\u5E74\u540C\u671F\u6BD4\u503C ',this.getValue(_lodash2.default.get(data,'5.rat',0),'percent'))),_react2.default.createElement('div',{className:'child',style:{backgroundColor:_lodash2.default.get(data,'6.diff',0)<0?"#50B07A":"#E37646"}},_react2.default.createElement('div',{className:'name'},'\u9910\u996E\u90E8\u95E8\u4EBA\u529B\u6210\u672C'),_react2.default.createElement('div',{className:'value'},'\u8F83\u53BB\u5E74\u540C\u671F\u5DEE\u503C ',this.getValue(_lodash2.default.get(data,'6.diff',0))),_react2.default.createElement('div',{className:'value'},'\u8F83\u53BB\u5E74\u540C\u671F\u6BD4\u503C ',this.getValue(_lodash2.default.get(data,'6.rat',0),'percent'))),_react2.default.createElement('div',{className:'child',style:{backgroundColor:_lodash2.default.get(data,'7.diff',0)<0?"#50B07A":"#E37646"}},_react2.default.createElement('div',{className:'name'},'\u9910\u996E\u90E8\u95E8\u5E2E\u5DE5\u8D39\u7528'),_react2.default.createElement('div',{className:'value'},'\u8F83\u53BB\u5E74\u540C\u671F\u5DEE\u503C ',this.getValue(_lodash2.default.get(data,'7.diff',0))),_react2.default.createElement('div',{className:'value'},'\u8F83\u53BB\u5E74\u540C\u671F\u6BD4\u503C ',this.getValue(_lodash2.default.get(data,'7.rat',0),'percent')))),_react2.default.createElement('div',{className:'item',onClick:function onClick(){return _this3.onSelectKey(3);}},_react2.default.createElement('div',{className:'child',style:{backgroundColor:_lodash2.default.get(data,'8.diff',0)<0?"#50B07A":"#E37646"}},_react2.default.createElement('div',{className:'name'},'\u5176\u4ED6\u8425\u4E1A\u90E8\u95E8\u6536\u5165'),_react2.default.createElement('div',{className:'value'},'\u8F83\u53BB\u5E74\u540C\u671F\u5DEE\u503C ',this.getValue(_lodash2.default.get(data,'8.diff',0))),_react2.default.createElement('div',{className:'value'},'\u8F83\u53BB\u5E74\u540C\u671F\u6BD4\u503C ',this.getValue(_lodash2.default.get(data,'8.rat',0),'percent'))),_react2.default.createElement('div',{className:'child',style:{backgroundColor:_lodash2.default.get(data,'9.diff',0)<0?"#50B07A":"#E37646"}},_react2.default.createElement('div',{className:'name'},'\u5176\u4ED6\u8425\u4E1A\u90E8\u95E8\u4EBA\u529B\u6210\u672C'),_react2.default.createElement('div',{className:'value'},'\u8F83\u53BB\u5E74\u540C\u671F\u5DEE\u503C ',this.getValue(_lodash2.default.get(data,'9.diff',0))),_react2.default.createElement('div',{className:'value'},'\u8F83\u53BB\u5E74\u540C\u671F\u6BD4\u503C ',this.getValue(_lodash2.default.get(data,'9.rat',0),'percent')))))),_react2.default.createElement('div',{className:'chart-content',style:{background:"#fff"}},_react2.default.createElement('div',{id:'chart',style:{height:400}},' '))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setKarte=undefined;exports.compute=compute;var _method=__webpack_require__(20);var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var color=['#7079df','#d15b7f','#fb6e6c','#ff9f69','#feb64d','#ffda43','#ffe88e'];exports.default=function(_ref,day){var _ref$data=_ref.data,data=_ref$data===undefined?[]:_ref$data,_ref$last=_ref.last,last=_ref$last===undefined?[]:_ref$last,_ref$area=_ref.area,area=_ref$area===undefined?[]:_ref$area,_ref$arealast=_ref.arealast,arealast=_ref$arealast===undefined?[]:_ref$arealast,_ref$interval=_ref.interval,interval=_ref$interval===undefined?[]:_ref$interval,_ref$intervallast=_ref.intervallast,intervallast=_ref$intervallast===undefined?[]:_ref$intervallast,_ref$areaLen=_ref.areaLen,areaLen=_ref$areaLen===undefined?1:_ref$areaLen,_ref$intervalLen=_ref.intervalLen,intervalLen=_ref$intervalLen===undefined?1:_ref$intervalLen;return{data:compute({data:data,day:day}),last:compute({data:last,day:day}),area:compute({data:area,day:day,length:areaLen}),arealast:compute({data:arealast,day:day,length:areaLen}),interval:compute({data:interval,day:day,length:intervalLen}),intervallast:compute({data:intervallast,day:day,length:intervalLen})};};function compute(_ref2,data){var totalFee1=_ref2.totalFee1,totalFee2_3=_ref2.totalFee2_3,roomFee1=_ref2.roomFee1,roomFee2_3=_ref2.roomFee2_3,foodFee1=_ref2.foodFee1,foodFee2_3=_ref2.foodFee2_3,elseFee1=_ref2.elseFee1,elseFee2_3=_ref2.elseFee2_3,data7_7=_ref2.data7_7,data7_1=_ref2.data7_1;data[0].diff=((0,_method.numConvert)(totalFee1)-(0,_method.numConvert)(totalFee2_3)).toFixed(2);data[0].rat=(0,_method.calculation)((0,_method.numConvert)(totalFee1)-(0,_method.numConvert)(totalFee2_3),totalFee2_3,4);data[2].diff=((0,_method.numConvert)(roomFee1)-(0,_method.numConvert)(roomFee2_3)).toFixed(2);data[2].rat=(0,_method.calculation)((0,_method.numConvert)(roomFee1)-(0,_method.numConvert)(roomFee2_3),roomFee2_3,4);data[5].diff=((0,_method.numConvert)(foodFee1)-(0,_method.numConvert)(foodFee2_3)).toFixed(2);data[5].rat=(0,_method.calculation)((0,_method.numConvert)(foodFee1)-(0,_method.numConvert)(foodFee2_3),foodFee2_3,4);data[8].diff=((0,_method.numConvert)(elseFee1)-(0,_method.numConvert)(elseFee2_3)).toFixed(2);data[8].rat=(0,_method.calculation)((0,_method.numConvert)(elseFee1)-(0,_method.numConvert)(elseFee2_3),elseFee2_3,4);data[1].diff=((0,_method.numConvert)(_lodash2.default.get(data7_1,'16.thisy_payroll_cost'))+(0,_method.numConvert)(_lodash2.default.get(data7_1,'19.thisy_payroll_cost'))-(0,_method.numConvert)(_lodash2.default.get(data7_1,'16.lasty_payroll_cost'))-(0,_method.numConvert)(_lodash2.default.get(data7_1,'19.lasty_payroll_cost'))).toFixed(2);data[3].diff=((0,_method.numConvert)(_lodash2.default.get(data7_7,'6.actual'))+(0,_method.numConvert)(_lodash2.default.get(data7_1,'18.thisy_payroll_cost'))-(0,_method.numConvert)(_lodash2.default.get(data7_7,'6.last'))-(0,_method.numConvert)(_lodash2.default.get(data7_1,'18.lasty_payroll_cost'))).toFixed(2);data[4].diff=((0,_method.numConvert)(_lodash2.default.get(data7_1,'18.thisy_payroll_cost'))-(0,_method.numConvert)(_lodash2.default.get(data7_1,'18.lasty_payroll_cost'))).toFixed(2);data[6].diff=((0,_method.numConvert)(_lodash2.default.get(data7_7,'10.actual'))+(0,_method.numConvert)(_lodash2.default.get(data7_1,'17.thisy_payroll_cost'))-(0,_method.numConvert)(_lodash2.default.get(data7_7,'10.last'))-(0,_method.numConvert)(_lodash2.default.get(data7_1,'17.lasty_payroll_cost'))).toFixed(2);data[7].diff=((0,_method.numConvert)(_lodash2.default.get(data7_1,'17.thisy_payroll_cost'))-(0,_method.numConvert)(_lodash2.default.get(data7_1,'17.lasty_payroll_cost'))).toFixed(2);data[9].diff=((0,_method.numConvert)(_lodash2.default.get(data7_7,'14.actual'))-(0,_method.numConvert)(_lodash2.default.get(data7_7,'14.last'))).toFixed(2);data[1].rat=(0,_method.calculation)(data[1].diff,(0,_method.numConvert)(_lodash2.default.get(data7_1,'16.lasty_payroll_cost'))+(0,_method.numConvert)(_lodash2.default.get(data7_1,'19.lasty_payroll_cost')),4);data[3].rat=(0,_method.calculation)(data[3].diff,(0,_method.numConvert)(_lodash2.default.get(data7_7,'6.last'))+(0,_method.numConvert)(_lodash2.default.get(data7_1,'18.lasty_payroll_cost')),4);data[4].rat=(0,_method.calculation)(data[4].diff,(0,_method.numConvert)(_lodash2.default.get(data7_1,'18.lasty_payroll_cost')),4);data[6].rat=(0,_method.calculation)(data[6].diff,(0,_method.numConvert)(_lodash2.default.get(data7_7,'10.last'))+(0,_method.numConvert)(_lodash2.default.get(data7_1,'17.lasty_payroll_cost')),4);data[7].rat=(0,_method.calculation)(data[7].diff,(0,_method.numConvert)(_lodash2.default.get(data7_1,'17.lasty_payroll_cost')),4);data[9].rat=(0,_method.calculation)(data[9].diff,(0,_method.numConvert)(_lodash2.default.get(data7_7,'14.last')),4);return data;}var setKarte=exports.setKarte=function setKarte(_ref3,isOnResize){var dataY=_ref3.dataY,title=_ref3.title;var myChart=_echarts2.default.init(document.getElementById("chart"));myChart.resize();if(isOnResize){return;}var option={color:color,title:{text:title,textStyle:{fontSize:20}},tooltip:{trigger:'axis',axisPointer:{type:'cross'}},grid:{top:120},legend:{top:30,data:dataY.map(function(x){return x.name;}),textStyle:{fontSize:18}// selected: dataY.reduce((a, b) => ({ ...a, [b.name]: false }), {}),
},toolbox:{feature:{saveAsImage:{show:true}}},xAxis:[{type:'category',axisLabel:{color:"black",fontSize:14},data:new Array(12).fill(1).map(function(x,i){return i+1+"\u6708";})}],yAxis:{type:'value',name:'',axisLabel:{formatter:"{value}%"}},series:dataY.map(function(x,i){return{name:x.name,type:"line",smooth:true,data:x.data.map(function(x){return(x*100).toFixed(1);})};})};myChart.setOption(option,true);};

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.defaultData=exports.columns=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(139);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var columns=exports.columns=[{title:'',dataIndex:'name',key:'name',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'较去年同期差值',dataIndex:'diff',key:'diff',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"diff"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'较去年同期比值',dataIndex:'rat',key:'rat',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"rat"};return _react2.default.createElement(_TableText2.default,{data:props});}}];var defaultData=exports.defaultData=[{name:"酒店总收入",diff:0,rat:0,sort:0},{name:"酒店总人力成本",diff:0,rat:0,sort:1},{name:"客房部门收入",diff:0,rat:0,sort:2},{name:"客房部门人力成本",diff:0,rat:0,sort:3},{name:"客房部门帮工费用",diff:0,rat:0,sort:4},{name:"餐饮部门收入",diff:0,rat:0,sort:5},{name:"餐饮部门人力成本",diff:0,rat:0,sort:6},{name:"餐饮部门帮工费用",diff:0,rat:0,sort:7},{name:"其他营业部门收入",diff:0,rat:0,sort:8},{name:"其他营业部门人力成本",diff:0,rat:0,sort:9}];

/***/ }),
/* 1973 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _tooltip=__webpack_require__(87);var _tooltip2=_interopRequireDefault(_tooltip);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(100);__webpack_require__(35);__webpack_require__(10);__webpack_require__(25);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(1975);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _method=__webpack_require__(20);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _Chart=__webpack_require__(1976);var _Chart2=_interopRequireDefault(_Chart);var _compute=__webpack_require__(1978);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TextArea=_input2.default.TextArea;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data,last){var date=_this.state.date;var isJan=(0,_moment2.default)(date).format('M')==1;var totalName=['thisy_employee_num','thisy_average_payroll','lasty_employee_num','lasty_average_payroll','year_thisy_employee_num','year_thisy_average_payroll','year_lasty_employee_num','year_lasty_average_payroll'];var isOpenLastFill=(0,_moment2.default)(date).isBefore((0,_moment2.default)("2022-02"));// 填充年累计
if(!isOpenLastFill){for(var i=0;i<data.length;i++){data[i].year_thisy_employee_num=(0,_method.sum)([data[i].thisy_employee_num,_lodash2.default.get(last,i+'.year_thisy_employee_num',0)]);data[i].year_thisy_average_payroll=(0,_method.sum)([data[i].thisy_average_payroll,_lodash2.default.get(last,i+'.year_thisy_average_payroll',0)]);data[i].year_lasty_employee_num=(0,_method.sum)([data[i].lasty_employee_num,_lodash2.default.get(last,i+'.year_lasty_employee_num',0)]);data[i].year_lasty_average_payroll=(0,_method.sum)([data[i].lasty_average_payroll,_lodash2.default.get(last,i+'.year_lasty_average_payroll',0)]);}}var _loop=function _loop(_i){data[7][totalName[_i]]=data.reduce(function(a,b,index){if(index<7){if(index>2){a-=(0,_method.numConvert)(b[totalName[_i]]);}else{a+=(0,_method.numConvert)(b[totalName[_i]]);}return a;}return a;},0);data[7][totalName[_i]]=data[7][totalName[_i]].toFixed(2);};for(var _i=0;_i<totalName.length;_i++){_loop(_i);};for(var _i2=0;_i2<data.length;_i2++){if(_i2<=7){data[_i2].thisy_payroll_cost=((0,_method.numConvert)(data[_i2].thisy_employee_num)+(0,_method.numConvert)(data[_i2].thisy_average_payroll)).toFixed(2);data[_i2].lasty_payroll_cost=((0,_method.numConvert)(data[_i2].lasty_employee_num)+(0,_method.numConvert)(data[_i2].lasty_average_payroll)).toFixed(2);data[_i2].variance_emplyee_num=((0,_method.numConvert)(data[_i2].thisy_employee_num)-(0,_method.numConvert)(data[_i2].lasty_employee_num)).toFixed(2);data[_i2].ven_percent=((0,_method.numConvert)(data[_i2].lasty_employee_num)==0?0:(0,_method.numConvert)(data[_i2].variance_emplyee_num)/(0,_method.numConvert)(data[_i2].lasty_employee_num)).toFixed(4);data[_i2].variance_average_payroll=((0,_method.numConvert)(data[_i2].thisy_average_payroll)-(0,_method.numConvert)(data[_i2].lasty_average_payroll)).toFixed(2);data[_i2].vap_percent=((0,_method.numConvert)(data[_i2].lasty_average_payroll)==0?0:(0,_method.numConvert)(data[_i2].variance_average_payroll)/(0,_method.numConvert)(data[_i2].lasty_average_payroll)).toFixed(4);data[_i2].variance_payroll=((0,_method.numConvert)(data[_i2].thisy_payroll_cost)-(0,_method.numConvert)(data[_i2].lasty_payroll_cost)).toFixed(2);data[_i2].vp_percent=((0,_method.numConvert)(data[_i2].lasty_payroll_cost)==0?0:(0,_method.numConvert)(data[_i2].variance_payroll)/(0,_method.numConvert)(data[_i2].lasty_payroll_cost)).toFixed(4);data[_i2].year_thisy_payroll_cost=((0,_method.numConvert)(data[_i2].year_thisy_employee_num)+(0,_method.numConvert)(data[_i2].year_thisy_average_payroll)).toFixed(2);data[_i2].year_lasty_payroll_cost=((0,_method.numConvert)(data[_i2].year_lasty_employee_num)+(0,_method.numConvert)(data[_i2].year_lasty_average_payroll)).toFixed(2);data[_i2].year_variance_emplyee_num=((0,_method.numConvert)(data[_i2].year_thisy_employee_num)-(0,_method.numConvert)(data[_i2].year_lasty_employee_num)).toFixed(2);data[_i2].year_ven_percent=((0,_method.numConvert)(data[_i2].year_lasty_employee_num)==0?0:(0,_method.numConvert)(data[_i2].year_variance_emplyee_num)/(0,_method.numConvert)(data[_i2].year_lasty_employee_num)).toFixed(4);data[_i2].year_variance_average_payroll=((0,_method.numConvert)(data[_i2].year_thisy_average_payroll)-(0,_method.numConvert)(data[_i2].year_lasty_average_payroll)).toFixed(2);data[_i2].year_vap_percent=((0,_method.numConvert)(data[_i2].year_lasty_average_payroll)==0?0:(0,_method.numConvert)(data[_i2].year_variance_average_payroll)/(0,_method.numConvert)(data[_i2].year_lasty_average_payroll)).toFixed(4);data[_i2].year_variance_payroll=((0,_method.numConvert)(data[_i2].year_thisy_payroll_cost)-(0,_method.numConvert)(data[_i2].year_lasty_payroll_cost)).toFixed(2);}}var footName=['thisy_employee_num','thisy_average_payroll','thisy_payroll_cost','lasty_employee_num','lasty_average_payroll','lasty_payroll_cost','year_thisy_employee_num','year_thisy_average_payroll','year_thisy_payroll_cost','year_lasty_employee_num','year_lasty_average_payroll','year_lasty_payroll_cost'];for(var _i3=0;_i3<footName.length;_i3++){data[8][footName[_i3]]=((0,_method.numConvert)(data[3][footName[_i3]])+(0,_method.numConvert)(data[4][footName[_i3]])+(0,_method.numConvert)(data[5][footName[_i3]])+(0,_method.numConvert)(data[6][footName[_i3]])).toFixed(2);};// 流动数
data[8].variance_emplyee_num=((0,_method.numConvert)(data[8].thisy_employee_num)-(0,_method.numConvert)(data[8].lasty_employee_num)).toFixed(2);data[8].ven_percent=((0,_method.numConvert)(data[8].variance_emplyee_num)==0?0:(0,_method.numConvert)(data[8].lasty_employee_num)/(0,_method.numConvert)(data[8].variance_emplyee_num)).toFixed(4);data[8].variance_average_payroll=((0,_method.numConvert)(data[8].thisy_average_payroll)-(0,_method.numConvert)(data[8].lasty_average_payroll)).toFixed(2);data[8].vap_percent=((0,_method.numConvert)(data[8].lasty_average_payroll)==0?0:(0,_method.numConvert)(data[8].variance_average_payroll)/(0,_method.numConvert)(data[8].lasty_average_payroll)).toFixed(4);data[8].variance_payroll=((0,_method.numConvert)(data[8].thisy_payroll_cost)-(0,_method.numConvert)(data[8].lasty_payroll_cost)).toFixed(2);data[8].vp_percent=((0,_method.numConvert)(data[8].lasty_payroll_cost)==0?0:(0,_method.numConvert)(data[8].variance_payroll)/(0,_method.numConvert)(data[8].lasty_payroll_cost)).toFixed(4);data[8].year_variance_emplyee_num=((0,_method.numConvert)(data[8].year_thisy_employee_num)-(0,_method.numConvert)(data[8].year_lasty_employee_num)).toFixed(2);data[8].vp_percent=((0,_method.numConvert)(data[8].year_lasty_employee_num)==0?0:(0,_method.numConvert)(data[8].year_variance_emplyee_num)/(0,_method.numConvert)(data[8].year_lasty_employee_num)).toFixed(4);data[8].year_variance_average_payroll=((0,_method.numConvert)(data[8].year_thisy_average_payroll)-(0,_method.numConvert)(data[8].year_lasty_average_payroll)).toFixed(2);data[8].vp_percent=((0,_method.numConvert)(data[8].year_lasty_average_payroll)==0?0:(0,_method.numConvert)(data[8].year_variance_average_payroll)/(0,_method.numConvert)(data[8].year_lasty_average_payroll)).toFixed(4);data[8].year_variance_emplyee_num=((0,_method.numConvert)(data[8].year_thisy_payroll_cost)-(0,_method.numConvert)(data[8].year_lasty_payroll_cost)).toFixed(2);for(var _i4=0;_i4<footName.length;_i4++){if(!footName[_i4].includes('year'))data[9][footName[_i4]]=(0,_method.calculation)((0,_method.numConvert)(data[8][footName[_i4]]),isJan?(0,_method.numConvert)(data[7][footName[_i4]]):((0,_method.numConvert)(data[0][footName[_i4]])+(0,_method.numConvert)(data[7][footName[_i4]]))/2,2);if(footName[_i4].includes('year'))data[9][footName[_i4]]=(0,_method.calculation)((0,_method.numConvert)(data[8][footName[_i4]]),isJan?(0,_method.numConvert)(data[7][footName[_i4]]):data[7][footName[_i4]]/(0,_moment2.default)(date).format('M'),2);};// 流失率
data[9].variance_emplyee_num=((0,_method.numConvert)(data[9].thisy_employee_num)-(0,_method.numConvert)(data[9].lasty_employee_num)).toFixed(2);data[9].variance_average_payroll=((0,_method.numConvert)(data[9].thisy_average_payroll)-(0,_method.numConvert)(data[9].lasty_average_payroll)).toFixed(2);data[9].year_variance_emplyee_num=((0,_method.numConvert)(data[9].year_thisy_employee_num)-(0,_method.numConvert)(data[9].year_lasty_employee_num)).toFixed(2);data[9].year_variance_average_payroll=((0,_method.numConvert)(data[9].year_thisy_average_payroll)-(0,_method.numConvert)(data[9].year_lasty_average_payroll)).toFixed(2);_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data,_this.state.last);};_this.getDateData=function(date){var data=JSON.parse(JSON.stringify(_data.data7_1_2));fetch('/t7_2_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data&&x.data.data.length>0){data=x.data.data;}data=data.map(function(_x,i){return _extends({},_x,{lasty_employee_num:~~_lodash2.default.get(x,'data.last.['+i+'].thisy_employee_num',0),lasty_average_payroll:~~_lodash2.default.get(x,'data.last.['+i+'].thisy_average_payroll',0)});});_this.computeNum(data,x.data.lastMonth);_this.setState({loading:false,last:x.data.lastMonth||[],data7_1:x.data.data7_1,note:_extends({},x.data.note)});(0,_compute.getChart)((0,_moment2.default)(date).format('YYYY'));}).catch(function(err){console.error(err);_this.setState({loading:false});});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};if(_this.state.note){_this.onSaveNote([_extends({},_this.state.note,{month:month,year:year})]);}fetch('/add_7_2_1',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.onSaveNote=function(data){var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_7_2_2',headres).then(function(x){return x.json();}).then(function(x){if(x.status==1){// message.success(x.msg);
return;}_message3.default.error('备注保存失败：'+x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table7_2',1.5,'7.20',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],note:{note:""},loading:true,loadingSave:false,print:false,last:[],data7_1:[]};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,data7_1=_state.data7_1,date=_state.date;var isOpenLastFill=(0,_moment2.default)(date).isBefore((0,_moment2.default)("2022-02"));var columns=[{title:'Key Index 关键数据',dataIndex:'name',key:'name',align:"center",fixed:"left",width:300,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':''),style:{textAlign:"left"}},text);}},{title:'Current Month 本年当月',align:"center",width:1800,children:[{align:"center",title:'MTD Actual - This Year 本年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,'Full Time \u5168\u804C'),dataIndex:'thisy_employee_num',key:'thisy_employee_num',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','MTD Actual - This Year 本年当月实际数','Full Time 全职'];if(index==9)return _react2.default.createElement(_TableText2.default,{data:{text:text,index:index,type:'percent',name:"thisy_employee_num",onChange:_this2.onChange,compared:{title:title,record:record,sqlName:"_7_2_1"}}});if(index!=7&&index!=8&&index!=9){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'thisy_employee_num',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('thisy_employee_num',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'thisy_employee_num',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement(_tooltip2.default,{title:index==7&&~~text!=~~(_lodash2.default.get(data7_1,'[11].thisy_employee_num')-_lodash2.default.get(data7_1,'[10].thisy_employee_num'))?'该项设置ES 7.1的数据不一致，请检查':''},_react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':'')+' '+(index==7&&~~text!=~~(_lodash2.default.get(data7_1,'[11].thisy_employee_num')-_lodash2.default.get(data7_1,'[10].thisy_employee_num'))?'yellowWaring':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),index==9?'%':'')));}}},{title:_react2.default.createElement('div',null,'Trainee \u5B9E\u4E60\u751F'),dataIndex:'thisy_average_payroll',key:'thisy_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','MTD Actual - This Year 本年当月实际数','Trainee 实习生'];if(index==9){return _react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':''),style:{textAlign:"left"}},'-');}if(index!=7&&index!=8&&index!=9){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'thisy_average_payroll',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('thisy_average_payroll',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'thisy_average_payroll',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement(_tooltip2.default,{title:index==7&&~~text!=~~_lodash2.default.get(data7_1,'[10].thisy_employee_num')?'该项设置ES 7.1的数据不一致，请检查':''},_react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':'')+' '+(index==7&&~~text!=~~_lodash2.default.get(data7_1,'[10].thisy_employee_num')?'yellowWaring':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),index==9?'%':'')));}}},{title:_react2.default.createElement('div',null,'FTE \u5168\u4F53\u5458\u5DE5'),dataIndex:'thisy_payroll_cost',key:'thisy_payroll_cost',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','MTD Actual - This Year 本年当月实际数','FTE 全体员工'];if(index==9){return _react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':''),style:{textAlign:"left"}},'-');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'thisy_payroll_cost',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement(_tooltip2.default,{title:index==7&&~~text!=~~_lodash2.default.get(data7_1,'[11].thisy_employee_num')?'该项设置ES 7.1的数据不一致，请检查':''},_react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':'')+' '+(index==7&&~~text!=~~_lodash2.default.get(data7_1,'[11].thisy_employee_num')?'yellowWaring':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),index==9?'%':'')));}}]},{align:"center",title:'MTD Actual - Last Year 去年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,'Full Time \u5168\u804C'),dataIndex:'lasty_employee_num',key:'lasty_employee_num',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','MTD Actual - Last Year 去年当月实际数','Full Time 全职'];if(index==9)return _react2.default.createElement(_TableText2.default,{data:{text:text,index:index,type:'percent',name:"lasty_employee_num",onChange:_this2.onChange,compared:{title:title,record:record,sqlName:"_7_2_1"}}});return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lasty_employee_num',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),index==9?'%':''));}},{title:_react2.default.createElement('div',null,'Trainee \u5B9E\u4E60\u751F'),dataIndex:'lasty_average_payroll',key:'lasty_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','MTD Actual - Last Year 去年当月实际数','Trainee 实习生'];if(index==9){return _react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':''),style:{textAlign:"left"}},'-');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lasty_average_payroll',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),index==9?'%':''));}},{title:_react2.default.createElement('div',null,'FTE \u5168\u4F53\u5458\u5DE5'),dataIndex:'lasty_payroll_cost',key:'lasty_payroll_cost',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','MTD Actual - Last Year 去年当月实际数','FTE 全体员工'];if(index==9){return _react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':''),style:{textAlign:"left"}},'-');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lasty_payroll_cost',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}]},{align:"center",title:'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年',width:900,children:[{title:_react2.default.createElement('div',null,'Full Time \u5168\u804C'),dataIndex:'variance_emplyee_num',key:'variance_emplyee_num',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年','Full Time 全职'];if(index==9)return _react2.default.createElement(_TableText2.default,{data:{text:text,index:index,type:'percent',name:"variance_emplyee_num",onChange:_this2.onChange,compared:{title:title,record:record,sqlName:"_7_2_1"}}});return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'variance_emplyee_num',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding  '+(index==7?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),index==9?'%':''));}},{title:'% 百分比',dataIndex:'ven_percent',key:'ven_percent',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];if(index==9)return _react2.default.createElement(_TableText2.default,{data:{text:text,index:index,type:'percent',name:"ven_percent",onChange:_this2.onChange,compared:{title:title,record:record,sqlName:"_7_2_1"}}});return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ven_percent',title:title,sqlName:"_7_2_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Trainee \u5B9E\u4E60\u751F'),dataIndex:'variance_average_payroll',key:'variance_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年','Trainee 实习生'];if(index==9){return _react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':''),style:{textAlign:"left"}},'-');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'variance_average_payroll',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),index==9?'%':''));}},{title:'% 百分比',dataIndex:'vap_percent',align:"center",key:'vap_percent',width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'vap_percent',title:title,sqlName:"_7_2_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'FTE \u5168\u4F53\u5458\u5DE5'),dataIndex:'variance_payroll',key:'variance_payroll',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年','FTE 全体员工'];if(index==9){return _react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':''),style:{textAlign:"left"}},'-');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'variance_payroll',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'vp_percent',key:'vp_percent',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'vp_percent',title:title,sqlName:"_7_2_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding  '+(index==7?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]}]},{title:'YTD 年累计',align:"center",width:1650,children:[{align:"center",title:'YTD Actual - This Year 年累计实际 - 今年',width:450,children:[{title:_react2.default.createElement('div',null,'Full Time \u5168\u804C'),dataIndex:'year_thisy_employee_num',key:'year_thisy_employee_num',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - This Year 年累计实际 - 今年','Full Time 全职'];if(index==9)return _react2.default.createElement(_TableText2.default,{data:{text:text,index:index,type:'percent',name:"year_thisy_employee_num",onChange:_this2.onChange,compared:{title:title,record:record,sqlName:"_7_2_1"}}});if(index!=7&&index!=8&&index!=9&&isOpenLastFill){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_thisy_employee_num',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('year_thisy_employee_num',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_thisy_employee_num',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement(_tooltip2.default,{title:index==7&&~~text!=~~_lodash2.default.get(data7_1,'[11].year_thisy_employee_num')-~~_lodash2.default.get(data7_1,'[10].year_thisy_employee_num')?'该项设置ES 7.1的数据不一致，请检查':''},_react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':'')+' '+(index==7&&~~text!=~~_lodash2.default.get(data7_1,'[11].year_thisy_employee_num')-~~_lodash2.default.get(data7_1,'[10].year_thisy_employee_num')?'yellowWaring':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),index==9?'%':'')));}}},{title:_react2.default.createElement('div',null,'Trainee \u5B9E\u4E60\u751F'),dataIndex:'year_thisy_average_payroll',key:'year_thisy_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - This Year 年累计实际 - 今年','Trainee 实习生'];if(index==9){return _react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':''),style:{textAlign:"left"}},'-');}if(index!=7&&index!=8&&index!=9&&isOpenLastFill){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_thisy_average_payroll',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('year_thisy_average_payroll',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_thisy_average_payroll',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement(_tooltip2.default,{title:index==7&&~~text!=~~_lodash2.default.get(data7_1,'[10].year_thisy_employee_num')?'该项设置ES 7.1的数据不一致，请检查':''},_react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':'')+' '+(index==7&&~~text!=~~_lodash2.default.get(data7_1,'[10].year_thisy_employee_num')?'yellowWaring':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),index==9?'%':'')));}}},{title:_react2.default.createElement('div',null,'FTE \u5168\u4F53\u5458\u5DE5'),dataIndex:'year_thisy_payroll_cost',key:'year_thisy_payroll_cost',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - This Year 年累计实际 - 今年','FTE 全体员工'];if(index==9){return _react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':''),style:{textAlign:"left"}},'-');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_thisy_payroll_cost',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement(_tooltip2.default,{title:index==7&&~~text!=~~_lodash2.default.get(data7_1,'[11].year_thisy_employee_num')?'该项设置ES 7.1的数据不一致，请检查':''},_react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':'')+' '+(index==7&&~~text!=~~_lodash2.default.get(data7_1,'[11].year_thisy_employee_num')?'yellowWaring':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),index==9?'%':'')));}}]},{align:"center",title:'YTD Actual - Last Year 年累计实际 - 去年',width:450,children:[{title:_react2.default.createElement('div',null,'Full Time \u5168\u804C'),dataIndex:'year_lasty_employee_num',key:'year_lasty_employee_num',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - Last Year 年累计实际 - 去年','Full Time 全职'];if(index==9)return _react2.default.createElement(_TableText2.default,{data:{text:text,index:index,type:'percent',name:"year_lasty_employee_num",onChange:_this2.onChange,compared:{title:title,record:record,sqlName:"_7_2_1"}}});if(index!=7&&index!=8&&index!=9&&isOpenLastFill){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_lasty_employee_num',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('year_lasty_employee_num',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_lasty_employee_num',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),index==9?'%':''));}}},{title:_react2.default.createElement('div',null,'Trainee \u5B9E\u4E60\u751F'),dataIndex:'year_lasty_average_payroll',key:'year_lasty_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - Last Year 年累计实际 - 去年','Trainee 实习生'];if(index==9){return _react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':''),style:{textAlign:"left"}},'-');}if(index!=7&&index!=8&&index!=9&&isOpenLastFill){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_lasty_average_payroll',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('year_lasty_average_payroll',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_lasty_average_payroll',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),index==9?'%':''));}}},{title:_react2.default.createElement('div',null,'FTE \u5168\u4F53\u5458\u5DE5'),dataIndex:'year_lasty_payroll_cost',key:'year_lasty_payroll_cost',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - Last Year 年累计实际 - 去年','FTE 全体员工'];if(index==9){return _react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':''),style:{textAlign:"left"}},'-');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_lasty_payroll_cost',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}]},{align:"center",title:'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',width:750,children:[{title:_react2.default.createElement('div',null,'Full Time \u5168\u804C'),dataIndex:'year_variance_emplyee_num',key:'year_variance_emplyee_num',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','Full Time 全职'];if(index==9)return _react2.default.createElement(_TableText2.default,{data:{text:text,index:index,type:'percent',name:"year_variance_emplyee_num",onChange:_this2.onChange,compared:{title:title,record:record,sqlName:"_7_2_1"}}});return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_variance_emplyee_num',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding  '+(index==7?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'year_ven_percent',key:'year_ven_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_ven_percent',title:title,sqlName:"_7_2_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Trainee \u5B9E\u4E60\u751F'),dataIndex:'year_variance_average_payroll',key:'year_variance_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','Trainee 实习生'];if(index==9)return _react2.default.createElement(_TableText2.default,{data:{text:text,index:index,type:'percent',name:"year_variance_average_payroll",onChange:_this2.onChange,compared:{title:title,record:record,sqlName:"_7_2_1"}}});return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_variance_average_payroll',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'year_vap_percent',align:"center",key:'year_vap_percent',width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];if(index==9){return _react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':''),style:{textAlign:"left"}},'-');}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_vap_percent',title:title,sqlName:"_7_2_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'FTE \u5168\u4F53\u5458\u5DE5'),dataIndex:'year_variance_payroll',key:'year_variance_payroll',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','FTE 全体员工'];if(index==9)return _react2.default.createElement(_TableText2.default,{data:{text:text,index:index,type:'percent',name:"year_variance_payroll",onChange:_this2.onChange,compared:{title:title,record:record,sqlName:"_7_2_1"}}});return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_variance_payroll',title:title,sqlName:"_7_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}]}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table7_2',style:{width:this.state.print?3800:'auto'}},_react2.default.createElement(_row2.default,null,'7.2 Associate Turnover \u5458\u5DE5\u79BB\u804C\u7387'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true,note:{note:""}});_this2.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',style:{width:this.state.print?3750:'auto'},scroll:this.state.print?{}:{x:3750},rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_row2.default,{style:{margin:"20px 0"}},_react2.default.createElement(_row2.default,{style:{margin:"10px 0"}},'7.2.1 Comments\u5907\u6CE8: '),this.state.data.length>0?_react2.default.createElement(TextArea,{rows:4,placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',defaultValue:this.state.note.note,onBlur:function onBlur(e){_this2.setState({note:_extends({},_this2.state.note,{note:e.target.value})});}}):null)),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_7_2'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))),_react2.default.createElement(_Chart2.default,null));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data7_1_2=exports.data7_1_2=[{name:'Beginning 期初数',//名称
name_code:"Beginning",//名称
thisy_employee_num:0,//Full Time 全职
thisy_average_payroll:0,//Trainee 实习生
thisy_payroll_cost:0,//FTE 全体员工
lasty_employee_num:0,//Full Time 全职
lasty_average_payroll:0,//Trainee 实习生
lasty_payroll_cost:0,//FTE 全体员工
variance_emplyee_num:0,//Full Time 全职
ven_percent:0,//% 百分比
variance_average_payroll:0,//名称
vap_percent:0,//名称
variance_payroll:0,//名称
vp_percent:0,//名称
year_thisy_employee_num:0,//名称
year_thisy_average_payroll:0,//名称
year_thisy_payroll_cost:0,//名称
year_lasty_employee_num:0,//名称
year_lasty_average_payroll:0,//名称
year_lasty_payroll_cost:0,//名称
year_variance_emplyee_num:0,//名称
year_ven_percent:0,//名称
year_variance_average_payroll:0,//名称
year_vap_percent:0,//名称
year_variance_payroll:0//名称
},{name:'New Hires 新入职',name_code:"New_Hires",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'Transfer In 内部转入',name_code:"Transfer_In",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'Resignation 辞职',name_code:"Resignation",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'Termination 终止',name_code:"Termination",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'Retirement  退休',name_code:"Retirement",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'Transfer Out 内部转出',name_code:"Transfer_Out",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'End 期末数',name_code:"End",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'离职人数总计',name_code:"Movement",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0},{name:'Turnover % 员工离职率',name_code:"Turnover",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0,year_vp_percent:0}];

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1977);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Chart=function(_Component){_inherits(Chart,_Component);function Chart(){_classCallCheck(this,Chart);return _possibleConstructorReturn(this,(Chart.__proto__||Object.getPrototypeOf(Chart)).apply(this,arguments));}_createClass(Chart,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"t7_2-chart"},_react2.default.createElement("div",{id:"row1",className:"t7_2-chart-content"}));}}]);return Chart;}(_react.Component);exports.default=Chart;

/***/ }),
/* 1977 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getChart=undefined;var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _method=__webpack_require__(20);var _analysis=__webpack_require__(125);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var getChart=exports.getChart=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(year){var _ref2,_ref2$data,_ref2$data$data,data,_ref2$data$area,area,_ref2$data$last,last,dataX;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_request2.default)('/chartData7_2?year='+year);case 2:_ref2=_context.sent;_ref2$data=_ref2.data;_ref2$data$data=_ref2$data.data;data=_ref2$data$data===undefined?[]:_ref2$data$data;_ref2$data$area=_ref2$data.area;area=_ref2$data$area===undefined?[]:_ref2$data$area;_ref2$data$last=_ref2$data.last;last=_ref2$data$last===undefined?[]:_ref2$data$last;dataX=new Array(12).fill(1).map(function(x,i){return i+1+'\u6708';});console.log(data);(0,_analysis.setKarte)({id:"row1",title:"Associate Turnover % 员工离职率%",color:['#00C5BD','#42585D','#FE5F5F'],yAxis:{max:15,interval:1},dataX:dataX,dataY:[{name:"今年",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.find(function(_x){return _x.month==i+1;}),'thisy_employee_num',0)*100).toFixed(2);})},{name:"去年",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.find(function(_x){return _x.month==i+1;}),'lasty_employee_num',0)*100).toFixed(2);})},{name:"区域",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(area.find(function(_x){return _x.month==i+1;}),'thisy_employee_num',0)*100).toFixed(2);})}]});case 13:case'end':return _context.stop();}}},_callee,undefined);}));return function getChart(_x2){return _ref.apply(this,arguments);};}();

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(14);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(1980);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);__webpack_require__(1981);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextArea=_input2.default.TextArea;var MonthPicker=_datePicker2.default.MonthPicker;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){data[10].no_employee=data.reduce(function(a,b,i){if(i<10){a+=Number(b.no_employee||"0");}return a;},0).toFixed(0);_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;// this.setState({
//     data
// });
_this.computeNum(data);};_this.getTable7_3=function(date){var dataBegin=JSON.stringify(_data.data7_3_default);var data=JSON.parse(dataBegin);fetch('/_7_3_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}if(!data[0].id){_this.setState({loading:false,data:data},function(){_this.onSave();});return;}_this.setState({loading:false,data:data});}).catch(function(err){console.error(err);_this.setState({loading:false});});};_this.getTable7_3_1=function(date){var dataBegin=JSON.stringify(_data.data7_3_default);var data=JSON.parse(dataBegin);fetch('/_7_3_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}_this.setState({loading:false,data7_3_1:data});}).catch(function(err){console.error(err);_this.setState({loading:false});});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_7_3',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getTable7_3(_this.state.date);_this.getTable7_3_1(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){console.error(err);var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.onSave7_3_1=function(){_this.setState({loadingNote:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');_this.setState({loadingNote:false});return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data7_3_1.map(function(x){return _extends({},x,{year:year});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_7_3_1',headres).then(function(x){return x.json();}).then(function(x){_this.setState({loadingNote:false});if(x.status==1){_message3.default.success(x.msg);return;}_message3.default.error(x.msg);}).catch(function(err){_this.setState({loadingNote:false});console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table7_3',1.5,'7.30',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],data7_3_1:[{'comments':''}],loading:true,print:false,loadingSave:false,loadingNote:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getTable7_3(this.state.date);this.getTable7_3_1(this.state.date);// this.computeNum(this.state.data)
}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var columns=[{title:'Title 职位名称',dataIndex:'title',key:'title',align:"center",// fixed: "left",
// width: 100,
render:function render(text,record,index){if(index==10){return _react2.default.createElement('div',{className:'table-padding table-color-footer'},text);}return _react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_input2.default,{className:'input-width',precision:0,defaultValue:text,onBlur:function onBlur(e){var value=e.target.value;_this2.onChange('title',value,index);}// onChange={(value) => {
//     this.onChange('actual', value, index)
// }}
}));}},{title:'Level 职级',dataIndex:'level',key:'level',align:"center",// width: 100,
render:function render(text,record,index){if(index==10){return _react2.default.createElement('div',{className:'table-padding table-color-footer'},'-');}return _react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_input2.default,{className:'input-width',precision:0,defaultValue:text,onBlur:function onBlur(e){var value=e.target.value;_this2.onChange('level',value,index);}// onChange={(value) => {
//     this.onChange('actual', value, index)
// }}
}));}},{title:_react2.default.createElement('div',null,'Vacant Since  ',_react2.default.createElement('br',null),' \u81EA\u4F55\u65F6\u5F00\u59CB\u7A7A\u7F3A'),dataIndex:'vacant_since',key:'vacant_since',align:"center",// width: 100,
render:function render(text,record,index){if(index==10){return _react2.default.createElement('div',{className:'table-padding table-color-footer'},'-');}return _react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_input2.default,{className:'input-width',precision:0,defaultValue:text,onBlur:function onBlur(e){var value=e.target.value;_this2.onChange('vacant_since',value,index);}}));}},{title:_react2.default.createElement('div',null,'No. of Employee   ',_react2.default.createElement('br',null),' \u62DB\u8058\u4EBA\u6570'),dataIndex:'no_employee',key:'no_employee',align:"center",// width: 100,
render:function render(text,record,index){if(index==10){return _react2.default.createElement('div',{className:'table-padding table-color-footer',style:{textAlign:"right"}},text);}return _react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('no_employee',value,index);}}));}},{title:_react2.default.createElement('div',null,'Internal Development Plan ',_react2.default.createElement('br',null),' \u5185\u90E8\u53D1\u5C55\u8BA1\u5212'),dataIndex:'internal_develop_plan',key:'internal_develop_plan',align:"center",// width: 100,
render:function render(text,record,index){if(index==10){return _react2.default.createElement('div',{className:'table-padding table-color-footer'},'-');}return _react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_input2.default,{className:'input-width',precision:0,defaultValue:text,onBlur:function onBlur(e){var value=e.target.value;_this2.onChange('internal_develop_plan',value,index);}// onChange={(value) => {
//     this.onChange('actual', value, index)
// }}
}));}},{title:_react2.default.createElement('div',null,'Recruit Channel  ',_react2.default.createElement('br',null),' \u62DB\u8058\u6E20\u9053'),dataIndex:'recruit_channel',key:'recruit_channel',align:"center",// width: 100,
render:function render(text,record,index){if(index==10){return _react2.default.createElement('div',{className:'table-padding table-color-footer'},'-');}return _react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_input2.default,{className:'input-width',precision:0,defaultValue:text,onBlur:function onBlur(e){var value=e.target.value;_this2.onChange('recruit_channel',value,index);}// onChange={(value) => {
//     this.onChange('actual', value, index)
// }}
}));}},{title:_react2.default.createElement('div',null,'Plans and Actions  ',_react2.default.createElement('br',null),' \u8BA1\u5212\u53CA\u884C\u52A8\u65B9\u6848'),dataIndex:'plan_action',key:'plan_action',align:"center",// width: 100,
render:function render(text,record,index){if(index==10){return _react2.default.createElement('div',{className:'table-padding table-color-footer'},'-');}return _react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_input2.default,{className:'input-width',precision:0,defaultValue:text,onBlur:function onBlur(e){var value=e.target.value;_this2.onChange('plan_action',value,index);}// onChange={(value) => {
//     this.onChange('actual', value, index)
// }}
}));}},{title:'Remarks 备注',dataIndex:'remarks',key:'remarks',align:"center",// width: 100,
render:function render(text,record,index){if(index==10){return _react2.default.createElement('div',{className:'table-padding table-color-footer'},'-');}return _react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_input2.default,{className:'input-width',precision:0,defaultValue:text,onBlur:function onBlur(e){var value=e.target.value;_this2.onChange('remarks',value,index);}// onChange={(value) => {
//     this.onChange('actual', value, index)
// }}
}));}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1 table7_3',id:'table7_3'},_react2.default.createElement(_row2.default,{className:'title'},_react2.default.createElement(_row2.default,null,'7.3 Recruitment Plan (B2 and above, Vacant Positions) & Succession Plan \u7A7A\u7F3A\u804C\u4F4D\u62DB\u8058(B2\u7EA7\u4EE5\u4E0A\uFF09\u53CA\u63A5\u73ED\u4EBA\u8BA1\u5212'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[]});_this2.getTable7_3(_this2.state.date);_this2.getTable7_3_1(_this2.state.date);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_row2.default,{className:'table-footer-btn',style:{display:this.state.print?'none':""}},_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58'))),_react2.default.createElement(_row2.default,{className:'title'},_react2.default.createElement(_row2.default,null,'7.3.1 Comments\u5907\u6CE8: '),_react2.default.createElement(TextArea,{autosize:{minRows:4},value:this.state.data7_3_1[0]?this.state.data7_3_1[0]['comments']:'',onChange:function onChange(e){var data7_3_1=_this2.state.data7_3_1;data7_3_1[0]['comments']=e.target.value;_this2.setState({data7_3_1:data7_3_1});}}),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_7_3'},_react2.default.createElement(_row2.default,{className:'table-footer-btn',style:{display:this.state.print?'none':""}},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave7_3_1,loading:this.state.loadingNote},'\u4FDD\u5B58'))))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data7_3_default=exports.data7_3_default=[{title:'',level:"",vacant_since:"",no_employee:"0",internal_develop_plan:"",recruit_channel:"",plan_action:"",remarks:""},{title:'',level:"",vacant_since:"",no_employee:"0",internal_develop_plan:"",recruit_channel:"",plan_action:"",remarks:""},{title:'',level:"",vacant_since:"",no_employee:"0",internal_develop_plan:"",recruit_channel:"",plan_action:"",remarks:""},{title:'',level:"",vacant_since:"",no_employee:"0",internal_develop_plan:"",recruit_channel:"",plan_action:"",remarks:""},{title:'',level:"",vacant_since:"",no_employee:"0",internal_develop_plan:"",recruit_channel:"",plan_action:"",remarks:""},{title:'',level:"",vacant_since:"",no_employee:"0",internal_develop_plan:"",recruit_channel:"",plan_action:"",remarks:""},{title:'',level:"",vacant_since:"",no_employee:"0",internal_develop_plan:"",recruit_channel:"",plan_action:"",remarks:""},{title:'',level:"",vacant_since:"",no_employee:"0",internal_develop_plan:"",recruit_channel:"",plan_action:"",remarks:""},{title:'',level:"",vacant_since:"",no_employee:"0",internal_develop_plan:"",recruit_channel:"",plan_action:"",remarks:""},{title:'',level:"",vacant_since:"",no_employee:"0",internal_develop_plan:"",recruit_channel:"",plan_action:"",remarks:""},{title:'Total',level:"",vacant_since:"",no_employee:"0",internal_develop_plan:"",recruit_channel:"",plan_action:"",remarks:""}];

/***/ }),
/* 1981 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _alert=__webpack_require__(83);var _alert2=_interopRequireDefault(_alert);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(84);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(1983);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _IsLableAuth=__webpack_require__(107);var _IsLableAuth2=_interopRequireDefault(_IsLableAuth);var _compute=__webpack_require__(1984);var _method=__webpack_require__(20);var _chart=__webpack_require__(1985);var _chart2=_interopRequireDefault(_chart);var _chart3=__webpack_require__(1987);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){// 薪酬合计
var totalData=['thisy_employee_num','thisy_payroll_cost','lasty_employee_num','lasty_payroll_cost','year_thisy_employee_num','year_thisy_payroll_cost','year_lasty_employee_num','year_lasty_payroll_cost'];for(var _index=0;_index<totalData.length;_index++){data[7][totalData[_index]]=0;}for(var _index2=0;_index2<7;_index2++){for(var i=0;i<totalData.length;i++){if(_index2!=6)data[7][totalData[i]]=Number(data[_index2][totalData[i]])+Number(data[7][totalData[i]]);}}var toFixedData={7:['thisy_employee_num','thisy_payroll_cost','lasty_employee_num','lasty_payroll_cost','year_thisy_employee_num','year_thisy_payroll_cost','year_lasty_employee_num','year_lasty_payroll_cost']};for(var key in toFixedData){if(toFixedData.hasOwnProperty(key)){for(var _index3=0;_index3<toFixedData[key].length;_index3++){data[key][toFixedData[key][_index3]]=data[key][toFixedData[key][_index3]].toFixed(1);}}}// 计算百分比  **对比**
for(var _index4=0;_index4<data.length;_index4++){// data[index].thisy_average_payroll = Number((Number(data[index].thisy_employee_num || "0") ? Number(data[index].thisy_payroll_cost || "0") / Number(data[index].thisy_employee_num || "0") : 0).toFixed(1));
// data[index].lasty_average_payroll = Number((Number(data[index].lasty_employee_num || "0") ? Number(data[index].lasty_payroll_cost || "0") / Number(data[index].lasty_employee_num || "0") : 0).toFixed(1))
data[_index4].variance_emplyee_num=Number((data[_index4].thisy_employee_num-data[_index4].lasty_employee_num).toFixed(1));data[_index4].ven_percent=Number((Number(data[_index4].lasty_employee_num||"0")?Number(data[_index4].variance_emplyee_num||"0")/Number(data[_index4].lasty_employee_num||"0"):0).toFixed(3));data[_index4].variance_average_payroll=Number((data[_index4].thisy_average_payroll-data[_index4].lasty_average_payroll).toFixed(1));data[_index4].vap_percent=Number((Number(data[_index4].lasty_average_payroll||"0")?Number(data[_index4].variance_average_payroll||"0")/Number(data[_index4].lasty_average_payroll||"0"):0).toFixed(3));data[_index4].variance_payroll=Number((data[_index4].thisy_payroll_cost-data[_index4].lasty_payroll_cost).toFixed(1));data[_index4].vp_percent=Number((Number(data[_index4].lasty_payroll_cost||"0")?Number(data[_index4].variance_payroll||"0")/Number(data[_index4].lasty_payroll_cost||"0"):0).toFixed(3));// 年累计
// data[index].year_thisy_average_payroll = Number((Number(data[index].year_thisy_employee_num || "0") ? Number(data[index].year_thisy_payroll_cost || "0") / Number(data[index].year_thisy_employee_num || "0") : 0).toFixed(1));
// data[index].year_lasty_average_payroll = Number((Number(data[index].year_lasty_employee_num || "0") ? Number(data[index].year_lasty_payroll_cost || "0") / Number(data[index].year_lasty_employee_num || "0") : 0).toFixed(1))
data[_index4].year_variance_emplyee_num=Number((data[_index4].year_thisy_employee_num-data[_index4].year_lasty_employee_num).toFixed(1));data[_index4].year_ven_percent=Number((Number(data[_index4].year_lasty_employee_num||"0")?Number(data[_index4].year_variance_emplyee_num||"0")/Number(data[_index4].year_lasty_employee_num||"0"):0).toFixed(3));data[_index4].year_variance_average_payroll=Number((data[_index4].year_thisy_average_payroll-data[_index4].year_lasty_average_payroll).toFixed(1));data[_index4].year_vap_percent=Number((Number(data[_index4].year_lasty_average_payroll||"0")?Number(data[_index4].year_variance_average_payroll||"0")/Number(data[_index4].year_lasty_average_payroll||"0"):0).toFixed(3));data[_index4].year_variance_payroll=Number((data[_index4].year_thisy_payroll_cost-data[_index4].year_lasty_payroll_cost).toFixed(1));}data[7].thisy_average_payroll=(0,_method.calculation)(data[7].thisy_payroll_cost,data[7].thisy_employee_num);data[7].year_thisy_average_payroll=(0,_method.calculation)(data[7].year_thisy_payroll_cost,data[7].year_thisy_employee_num);_this.setState({data:data},function(){_this.onSave();});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data7_1_2);var data=JSON.parse(dataBegin);fetch('/_7_4_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data&&x.data.data.length>0){data=x.data.data;}_this.setState({loading:false,note:_extends({note:""},x.data.note)});_this.computeNum((0,_compute.correspond)(_extends({},x.data,{data:data})));}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_7_4_1',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}(0,_chart3.getChart)(year);return;}_message3.default.error(x.msg);}).catch(function(err){_message3.default.error('保存失败'+JSON.stringify(err));var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table7_4',1.5,'7.40',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,note:{note:""},loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var columns=[{title:'Department 部门',dataIndex:'name',key:'name',align:"center",// fixed: "left",
width:300,render:function render(text,record,index){if(index==6)return{props:{rowSpan:0}};return _react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':''),style:{textAlign:"left"}},text);}},{title:'Current Month 本年当月',align:"center",width:1800,children:[{align:"center",title:'Current Month Actual - This Year 本年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,'No. of Participants ',_react2.default.createElement('br',null),'\u53D7\u8BAD\u4EBA\u6570'),dataIndex:'thisy_employee_num',key:'thisy_employee_num',align:"center",width:150,render:function render(text,record,index){if(index==6)return{props:{rowSpan:0}};return _react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:_react2.default.createElement('div',null,'Average Training Hours',_react2.default.createElement('br',null),'\u4EBA\u5747\u53D7\u8BAD\u65F6\u95F4'),dataIndex:'thisy_average_payroll',key:'thisy_average_payroll',align:"center",width:150,render:function render(text,record,index){if(index==6)return{props:{rowSpan:0}};return _react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:_react2.default.createElement('div',null,'Total Training Hours ',_react2.default.createElement('br',null),'\u57F9\u8BAD\u65F6\u95F4\u603B\u8BA1'),dataIndex:'thisy_payroll_cost',key:'thisy_payroll_cost',align:"center",width:150,render:function render(text,record,index){if(index==6)return{props:{rowSpan:0}};return _react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}]}]},{title:'YTD 年累计',align:"center",width:1650,children:[{align:"center",title:'YTD Actual - This Year 年累计实际 - 今年',width:450,children:[{title:_react2.default.createElement('div',null,'No. of Participants ',_react2.default.createElement('br',null),'\u53D7\u8BAD\u4EBA\u6570'),dataIndex:'year_thisy_employee_num',key:'year_thisy_employee_num',align:"center",width:150,render:function render(text,record,index){if(index==6)return{props:{rowSpan:0}};return _react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:_react2.default.createElement('div',null,'Average Training Hours',_react2.default.createElement('br',null),'\u4EBA\u5747\u53D7\u8BAD\u65F6\u95F4'),dataIndex:'year_thisy_average_payroll',key:'year_thisy_average_payroll',align:"center",width:150,render:function render(text,record,index){if(index==6)return{props:{rowSpan:0}};return _react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:_react2.default.createElement('div',null,'Total Training Hours ',_react2.default.createElement('br',null),'\u57F9\u8BAD\u65F6\u95F4\u603B\u8BA1'),dataIndex:'year_thisy_payroll_cost',key:'year_thisy_payroll_cost',align:"center",width:150,render:function render(text,record,index){if(index==6)return{props:{rowSpan:0}};return _react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}]}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table7_4',style:{width:this.state.print?3800:'auto'}},_react2.default.createElement(_row2.default,null,'7.4 Training Statistics By Department \u6309\u90E8\u95E8\u57F9\u8BAD\u8BB0\u5F55\u7EDF\u8BA1'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true,note:{note:""}});_this2.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_7_4'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_alert2.default,{message:_react2.default.createElement('div',null,'\u8868\u683C\u5173\u8054',_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:'read_4_1'},this.props,{path:'/hr/4_1'}),'HR 4.1.3')),type:'info',showIcon:true,style:{display:"inline-block",marginRight:10}}),_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58'))),_react2.default.createElement(_chart2.default,null)));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data7_1_2=exports.data7_1_2=[{name:'Rooms 房务',name_code:"Rooms",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0},{name:'Administration& General 行政办 、财务、保安',name_code:"Administration_General",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0},{name:'Human Resources 人力资源部',name_code:"Human_Resources",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0},{name:'Sales & Marketing 市场销售部',name_code:"Sales_Marketing",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0},{name:'Engineering 工程部',name_code:"Property_Operation_Maintenance",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0},{name:'Other Operated Departments 其它运营部门',name_code:"Other_Operated_Departments",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0},{name:'Total 合计',name_code:"Payroll_Total",thisy_employee_num:0,thisy_average_payroll:0,thisy_payroll_cost:0,lasty_employee_num:0,lasty_average_payroll:0,lasty_payroll_cost:0,variance_emplyee_num:0,ven_percent:0,variance_average_payroll:0,vap_percent:0,variance_payroll:0,vp_percent:0,year_thisy_employee_num:0,year_thisy_average_payroll:0,year_thisy_payroll_cost:0,year_lasty_employee_num:0,year_lasty_average_payroll:0,year_lasty_payroll_cost:0,year_variance_emplyee_num:0,year_ven_percent:0,year_variance_average_payroll:0,year_vap_percent:0,year_variance_payroll:0}];

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.correspond=undefined;var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _method=__webpack_require__(20);var _method2=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var correspond=function correspond(_ref){var _ref$sumData=_ref.sumData,sumData=_ref$sumData===undefined?[]:_ref$sumData,data=_ref.data,dataAll=_objectWithoutProperties(_ref,['sumData','data']);data=_lodash2.default.cloneDeep(data);var correspondIndex={0:[3,4],1:[5],2:[0,2,8],3:[1],4:[6],5:[7]};var correspondKey={thisy_employee_num:{key:'actual_count',value:"hr4_1_3"},thisy_average_payroll:{key:'average_month',value:"hr4_1_3"},// lasty_employee_num: {
//     key: 'actual_count',
//     value: "hr4_1_3_last"
// },
// lasty_average_payroll: {
//     key: 'average_month',
//     value: "hr4_1_3_last"
// },
year_thisy_average_payroll:{key:'average_date',value:"hr4_1_3"},year_thisy_payroll_cost:{key:'training_date',value:"hr4_1_3"}};// 填充4.1.3数据
Object.entries(correspondIndex).forEach(function(item){Object.entries(correspondKey).forEach(function(_item){// 阅读人均受训时间
if(_item[0]=='thisy_average_payroll'){data[item[0]][_item[0]]=(0,_method2.calculation)((0,_method.sum)(item[1].map(function(x){return _lodash2.default.get(dataAll,_item[1].value+'['+x+'].training_month',0);})),(0,_method.sum)(item[1].map(function(x){return _lodash2.default.get(dataAll,_item[1].value+'['+x+'].actual_count',0);})));}// 年度人均受训时间
// if (_item[0] == 'year_thisy_average_payroll') {
//     data[item[0]][_item[0]] = calculation(
//         sum(item[1].map(x => {
//             return _.get(dataAll, `${_item[1].value}[${x}].training_date`, 0)
//         })),
//         sum(item[1].map(x => {
//             return _.get(dataAll, `${_item[1].value}[${x}].actual_count`, 0)
//         })),
//     );
// }
// 年度培训小时人次数
if(_item[0]=='year_thisy_payroll_cost'){data[item[0]][_item[0]]=(0,_method.sum)(item[1].map(function(x){return _lodash2.default.get(dataAll,_item[1].value+'['+x+'].'+_item[1].key,0);}));}// 部门人数
if(_item[0]=='thisy_employee_num'){data[item[0]][_item[0]]=(0,_method.sum)(item[1].map(function(x){return _lodash2.default.get(dataAll,_item[1].value+'['+x+'].'+_item[1].key,0);}));}});});// 填充年累计
data.forEach(function(item,index){data[index].year_thisy_employee_num=((0,_method2.numConvert)(_lodash2.default.get(sumData.find(function(x){return x.name==item.name;}),'thisy_employee_num',0))+(0,_method2.numConvert)(item['thisy_employee_num'])).toFixed(2);data[index].year_thisy_average_payroll=(0,_method2.calculation)(data[index].year_thisy_payroll_cost,data[index].year_thisy_employee_num);//    计算培训时间总计
data[index].thisy_payroll_cost=(data[index].thisy_employee_num*data[index].thisy_average_payroll).toFixed(2);data[index].lasty_payroll_cost=(data[index].lasty_employee_num*data[index].lasty_average_payroll).toFixed(2);});return data;};exports.correspond=correspond;

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1986);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"table-7-4-chart"},_react2.default.createElement("div",{id:"c1"}),_react2.default.createElement("div",{className:"row"},_react2.default.createElement("div",{className:"col-c",id:"c2"}),_react2.default.createElement("div",{className:"col-c",id:"c3"}),_react2.default.createElement("div",{className:"col-c",id:"c4"}),_react2.default.createElement("div",{className:"col-c",id:"c5"}),_react2.default.createElement("div",{className:"col-c",id:"c6"}),_react2.default.createElement("div",{className:"col-c",id:"c7"})));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1986 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getChart=undefined;var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _method=__webpack_require__(20);var _analysis=__webpack_require__(125);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var getChart=exports.getChart=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(year){var _ref2,data,dataX;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_request2.default)('/EsCahrt7_2?year='+year);case 2:_ref2=_context.sent;data=_ref2.data;dataX=new Array(12).fill(1).map(function(x,i){return i+1+'\u6708';});(0,_analysis.setKarte)({id:"c1",title:"酒店人均受训时间",color:["#E46C0A","#00B050",'#FE5F5F'],yAxis:[{max:10,min:1,interval:1},{min:1}],dataX:dataX,dataY:[{name:"今年",type:"bar",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.averageTraining.find(function(_x){return _x.month==i+1;}),'actual',0)).toFixed(2);})},{name:"去年",type:"bar",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.averageTraining.find(function(_x){return _x.month==i+1;}),'last',0)).toFixed(2);})},{yAxisIndex:1,name:"客人满意度",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.ranking.find(function(_x){return _x.month==i+1;}),'sort',0)).toFixed(2);})}]});(0,_analysis.setKarte)({id:"c2",title:"Rooms 房务",color:["#E46C0A","#00B050",'#FE5F5F'],yAxis:{max:10,min:1,interval:1},dataX:dataX,dataY:[{name:"今年",type:"bar",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.rooms.find(function(_x){return _x.month==i+1;}),'actual',0)).toFixed(2);})},{name:"去年",type:"bar",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.rooms.find(function(_x){return _x.month==i+1;}),'last',0)).toFixed(2);})}]});(0,_analysis.setKarte)({id:"c3",title:"Food & Beverage 餐饮",color:["#E46C0A","#00B050",'#FE5F5F'],yAxis:{max:10,min:1,interval:1},dataX:dataX,dataY:[{name:"今年",type:"bar",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.fb.find(function(_x){return _x.month==i+1;}),'actual',0)).toFixed(2);})},{name:"去年",type:"bar",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.fb.find(function(_x){return _x.month==i+1;}),'last',0)).toFixed(2);})}]});(0,_analysis.setKarte)({id:"c4",title:"Administration& General 行政办 、财务、保安",color:["#E46C0A","#00B050",'#FE5F5F'],yAxis:{max:10,min:1,interval:1},dataX:dataX,dataY:[{name:"今年",type:"bar",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.general.find(function(_x){return _x.month==i+1;}),'actual',0)).toFixed(2);})},{name:"去年",type:"bar",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.general.find(function(_x){return _x.month==i+1;}),'last',0)).toFixed(2);})}]});(0,_analysis.setKarte)({id:"c5",title:"Human Resources 人力资源部",color:["#E46C0A","#00B050",'#FE5F5F'],yAxis:{max:10,min:1,interval:1},dataX:dataX,dataY:[{name:"今年",type:"bar",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.hr.find(function(_x){return _x.month==i+1;}),'actual',0)).toFixed(2);})},{name:"去年",type:"bar",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.hr.find(function(_x){return _x.month==i+1;}),'last',0)).toFixed(2);})}]});(0,_analysis.setKarte)({id:"c6",title:"Sales & Marketing 市场销售部",color:["#E46C0A","#00B050",'#FE5F5F'],yAxis:{max:10,min:1,interval:1},dataX:dataX,dataY:[{name:"今年",type:"bar",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.sm.find(function(_x){return _x.month==i+1;}),'actual',0)).toFixed(2);})},{name:"去年",type:"bar",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.sm.find(function(_x){return _x.month==i+1;}),'last',0)).toFixed(2);})}]});(0,_analysis.setKarte)({id:"c7",title:"Engineering 工程部",color:["#E46C0A","#00B050",'#FE5F5F'],yAxis:{max:10,min:1,interval:1},dataX:dataX,dataY:[{name:"今年",type:"bar",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.engineering.find(function(_x){return _x.month==i+1;}),'actual',0)).toFixed(2);})},{name:"去年",type:"bar",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.engineering.find(function(_x){return _x.month==i+1;}),'last',0)).toFixed(2);})}]});case 12:case'end':return _context.stop();}}},_callee,undefined);}));return function getChart(_x2){return _ref.apply(this,arguments);};}();

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _=__webpack_require__(1989);var _2=_interopRequireDefault(_);var _3=__webpack_require__(1990);var _4=_interopRequireDefault(_3);var _Chart=__webpack_require__(1991);var _Chart2=_interopRequireDefault(_Chart);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){return _react2.default.createElement('div',null,_react2.default.createElement(_2.default,null),_react2.default.createElement(_4.default,null),_react2.default.createElement(_Chart2.default,null));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(706);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _compute=__webpack_require__(707);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){// 薪酬合计
var totalData=['thisy_employee_num','thisy_payroll_cost','lasty_employee_num','lasty_payroll_cost','year_thisy_employee_num','year_thisy_payroll_cost','year_lasty_employee_num','year_lasty_payroll_cost'];for(var _index=0;_index<totalData.length;_index++){data[7][totalData[_index]]=0;}for(var _index2=0;_index2<7;_index2++){for(var i=0;i<totalData.length;i++){data[7][totalData[i]]=Number(data[_index2][totalData[i]])+Number(data[7][totalData[i]]);}}var toFixedData={7:['thisy_employee_num','thisy_payroll_cost','lasty_employee_num','lasty_payroll_cost','year_thisy_employee_num','year_thisy_payroll_cost','year_lasty_employee_num','year_lasty_payroll_cost']};for(var key in toFixedData){if(toFixedData.hasOwnProperty(key)){for(var _index3=0;_index3<toFixedData[key].length;_index3++){data[key][toFixedData[key][_index3]]=data[key][toFixedData[key][_index3]].toFixed(1);}}}// 计算百分比  **对比**
for(var _index4=0;_index4<data.length;_index4++){data[_index4].thisy_average_payroll=Number((Number(data[_index4].thisy_employee_num||"0")?Number(data[_index4].thisy_payroll_cost||"0")/Number(data[_index4].thisy_employee_num||"0"):0).toFixed(1));data[_index4].lasty_average_payroll=Number((Number(data[_index4].lasty_employee_num||"0")?Number(data[_index4].lasty_payroll_cost||"0")/Number(data[_index4].lasty_employee_num||"0"):0).toFixed(1));data[_index4].variance_emplyee_num=Number((data[_index4].thisy_employee_num-data[_index4].lasty_employee_num).toFixed(1));data[_index4].ven_percent=Number((Number(data[_index4].lasty_employee_num||"0")?Number(data[_index4].variance_emplyee_num||"0")/Number(data[_index4].lasty_employee_num||"0"):0).toFixed(3));data[_index4].variance_average_payroll=Number((data[_index4].thisy_average_payroll-data[_index4].lasty_average_payroll).toFixed(1));data[_index4].vap_percent=Number((Number(data[_index4].lasty_average_payroll||"0")?Number(data[_index4].variance_average_payroll||"0")/Number(data[_index4].lasty_average_payroll||"0"):0).toFixed(3));data[_index4].variance_payroll=Number((data[_index4].thisy_payroll_cost-data[_index4].lasty_payroll_cost).toFixed(1));data[_index4].vp_percent=Number((Number(data[_index4].lasty_payroll_cost||"0")?Number(data[_index4].variance_payroll||"0")/Number(data[_index4].lasty_payroll_cost||"0"):0).toFixed(3));// 年累计
data[_index4].year_thisy_average_payroll=Number((Number(data[_index4].year_thisy_employee_num||"0")?Number(data[_index4].year_thisy_payroll_cost||"0")/Number(data[_index4].year_thisy_employee_num||"0"):0).toFixed(1));data[_index4].year_lasty_average_payroll=Number((Number(data[_index4].year_lasty_employee_num||"0")?Number(data[_index4].year_lasty_payroll_cost||"0")/Number(data[_index4].year_lasty_employee_num||"0"):0).toFixed(1));data[_index4].year_variance_emplyee_num=Number((data[_index4].year_thisy_employee_num-data[_index4].year_lasty_employee_num).toFixed(1));data[_index4].year_ven_percent=Number((Number(data[_index4].year_lasty_employee_num||"0")?Number(data[_index4].year_variance_emplyee_num||"0")/Number(data[_index4].year_lasty_employee_num||"0"):0).toFixed(3));data[_index4].year_variance_average_payroll=Number((data[_index4].year_thisy_average_payroll-data[_index4].year_lasty_average_payroll).toFixed(1));data[_index4].year_vap_percent=Number((Number(data[_index4].year_lasty_average_payroll||"0")?Number(data[_index4].year_variance_average_payroll||"0")/Number(data[_index4].year_lasty_average_payroll||"0"):0).toFixed(3));data[_index4].year_variance_payroll=Number((data[_index4].year_thisy_payroll_cost-data[_index4].year_lasty_payroll_cost).toFixed(1));}_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;// this.setState({
//     data
// });
_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data7_1_2);var data=JSON.parse(dataBegin);fetch('/_7_5_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data&&x.data.data.length>0){data=x.data.data;}if(!(0,_moment2.default)(_this.state.date).isBefore((0,_moment2.default)("2022-02"))){for(var i=0;i<data.length;i++){data[i].lasty_employee_num=~~_.get(x,'data.lastYear.'+i+'.thisy_employee_num',0);data[i].lasty_payroll_cost=~~_.get(x,'data.lastYear.'+i+'.thisy_payroll_cost',0);}}_this.setState({loading:false});_this.computeNum(data);(0,_compute.getChart)((0,_moment2.default)(date).format('YYYY'));}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_7_5',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){(0,_compute.getChart)((0,_moment2.default)(date).format('YYYY'));_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败'+JSON.stringify(err));console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table7_5_1',1.5,'7.51',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,note:{note:""},loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);// this.computeNum(this.state.data)
}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var isOpenLastFill=(0,_moment2.default)(this.state.date).isBefore((0,_moment2.default)("2022-02"));var width=document.body.offsetWidth-1800>350?document.body.offsetWidth-1800:350;var columns=[{title:'Department 部门',dataIndex:'name',key:'name',align:"center",fixed:"left",width:width,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':''),style:{textAlign:"left"}},text);}},{title:'Annual Leave 年假',align:"center",width:1800,children:[{align:"center",title:'YTD Actual - This Year 年累计实际 - 今年',width:450,children:[{title:_react2.default.createElement('div',null,'No. of Employee ',_react2.default.createElement('br',null),'\u5458\u5DE5\u6570'),dataIndex:'thisy_employee_num',key:'thisy_employee_num',align:"center",width:150,render:function render(text,record,index){var title=['Annual Leave 年假','YTD Actual - This Year 年累计实际 - 今年','No. of Employee 员工数'];if(index>=0&&index<=6){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'thisy_employee_num',title:title,sqlName:"_7_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('thisy_employee_num',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'thisy_employee_num',title:title,sqlName:"_7_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Average Days ',_react2.default.createElement('br',null),'\u4EBA\u5747\u5929\u6570'),dataIndex:'thisy_average_payroll',key:'thisy_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['Annual Leave 年假','YTD Actual - This Year 年累计实际 - 今年','Average Days  人均天数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'thisy_average_payroll',title:title,sqlName:"_7_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Annual Leave Balance (Days) ',_react2.default.createElement('br',null),'\u671F\u672B\u5E74\u5047 (\u5929\u6570)'),dataIndex:'thisy_payroll_cost',key:'thisy_payroll_cost',align:"center",width:150,render:function render(text,record,index){var title=['Annual Leave 年假','YTD Actual - This Year 年累计实际 - 今年','Annual Leave Balance (Days) 期末年假 (天数)'];if(index==7||index==15||index==16){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'thisy_payroll_cost',title:title,sqlName:"_7_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'thisy_payroll_cost',title:title,sqlName:"_7_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('thisy_payroll_cost',value,index);}})));}}}]},{align:"center",title:'YTD Actual - Last Year 年累计实际 - 去年',width:450,children:[{title:_react2.default.createElement('div',null,'No. of Employee ',_react2.default.createElement('br',null),'\u5458\u5DE5\u6570'),dataIndex:'lasty_employee_num',key:'lasty_employee_num',align:"center",width:150,render:function render(text,record,index){var title=['Annual Leave 年假','YTD Actual - Last Year 年累计实际 - 去年','No. of Employee 员工数'];if(index>=0&&index<=6&&isOpenLastFill){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lasty_employee_num',title:title,sqlName:"_7_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('lasty_employee_num',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lasty_employee_num',title:title,sqlName:"_7_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Average Days ',_react2.default.createElement('br',null),'\u4EBA\u5747\u5929\u6570'),dataIndex:'lasty_average_payroll',key:'lasty_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['Annual Leave 年假','YTD Actual - Last Year 年累计实际 - 去年','Average Days 人均天数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lasty_average_payroll',title:title,sqlName:"_7_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Annual Leave Balance (Days) ',_react2.default.createElement('br',null),'\u671F\u672B\u5E74\u5047 (\u5929\u6570)'),dataIndex:'lasty_payroll_cost',key:'lasty_payroll_cost',align:"center",width:150,render:function render(text,record,index){var title=['Annual Leave 年假','YTD Actual - Last Year 年累计实际 - 去年','Annual Leave Balance (Days) 期末年假 (天数)'];if(index==7||index==15||index==16||!isOpenLastFill){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lasty_payroll_cost',title:title,sqlName:"_7_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lasty_payroll_cost',title:title,sqlName:"_7_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('lasty_payroll_cost',value,index);}})));}}}]},{align:"center",title:'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',width:900,children:[{title:_react2.default.createElement('div',null,'No. of Employee ',_react2.default.createElement('br',null),'\u5458\u5DE5\u6570'),dataIndex:'variance_emplyee_num',key:'variance_emplyee_num',align:"center",width:150,render:function render(text,record,index){var title=['Annual Leave 年假','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','No. of Employee 员工数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'variance_emplyee_num',title:title,sqlName:"_7_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding  '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'ven_percent',key:'ven_percent',align:"center",width:150,render:function render(text,record,index){var title=['Annual Leave 年假','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ven_percent',title:title,sqlName:"_7_5",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Average Days ',_react2.default.createElement('br',null),'\u4EBA\u5747\u5929\u6570'),dataIndex:'variance_average_payroll',key:'variance_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['Annual Leave 年假','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','Average Days 人均天数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'variance_average_payroll',title:title,sqlName:"_7_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'vap_percent',align:"center",key:'vap_percent',width:150,render:function render(text,record,index){var title=['Annual Leave 年假','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'vap_percent',title:title,sqlName:"_7_5",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Annual Leave Balance (Days) ',_react2.default.createElement('br',null),'\u671F\u672B\u5E74\u5047 (\u5929\u6570)'),dataIndex:'variance_payroll',key:'variance_payroll',align:"center",width:150,render:function render(text,record,index){var title=['Annual Leave 年假','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','Annual Leave Balance (Days) 期末年假 (天数)'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'variance_payroll',title:title,sqlName:"_7_5",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'vp_percent',key:'vp_percent',align:"center",width:150,render:function render(text,record,index){var title=['Annual Leave 年假','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'vp_percent',title:title,sqlName:"_7_5",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding  '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table7_5_1',style:{width:this.state.print?2150:'auto'}},_react2.default.createElement(_row2.default,null,'7.5.1 Annual Leave \u5E74\u5047'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true,note:{note:""}});_this2.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',style:{width:this.state.print?2100:'auto'},scroll:this.state.print?{}:{x:2100},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_7_5'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(25);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(706);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _compute=__webpack_require__(707);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TextArea=_input2.default.TextArea;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){// 薪酬合计
var totalData=['thisy_employee_num','thisy_payroll_cost','lasty_employee_num','lasty_payroll_cost','year_thisy_employee_num','year_thisy_payroll_cost','year_lasty_employee_num','year_lasty_payroll_cost'];for(var _index=0;_index<totalData.length;_index++){data[7][totalData[_index]]=0;}for(var _index2=0;_index2<7;_index2++){for(var i=0;i<totalData.length;i++){data[7][totalData[i]]=Number(data[_index2][totalData[i]])+Number(data[7][totalData[i]]);}}var toFixedData={7:['thisy_employee_num','thisy_payroll_cost','lasty_employee_num','lasty_payroll_cost','year_thisy_employee_num','year_thisy_payroll_cost','year_lasty_employee_num','year_lasty_payroll_cost']};for(var key in toFixedData){if(toFixedData.hasOwnProperty(key)){for(var _index3=0;_index3<toFixedData[key].length;_index3++){data[key][toFixedData[key][_index3]]=data[key][toFixedData[key][_index3]].toFixed(1);}}}// 计算百分比  **对比**
for(var _index4=0;_index4<data.length;_index4++){data[_index4].thisy_average_payroll=Number((Number(data[_index4].thisy_employee_num||"0")?Number(data[_index4].thisy_payroll_cost||"0")/Number(data[_index4].thisy_employee_num||"0"):0).toFixed(1));data[_index4].lasty_average_payroll=Number((Number(data[_index4].lasty_employee_num||"0")?Number(data[_index4].lasty_payroll_cost||"0")/Number(data[_index4].lasty_employee_num||"0"):0).toFixed(1));data[_index4].variance_emplyee_num=Number((data[_index4].thisy_employee_num-data[_index4].lasty_employee_num).toFixed(1));data[_index4].ven_percent=Number((Number(data[_index4].lasty_employee_num||"0")?Number(data[_index4].variance_emplyee_num||"0")/Number(data[_index4].lasty_employee_num||"0"):0).toFixed(3));data[_index4].variance_average_payroll=Number((data[_index4].thisy_average_payroll-data[_index4].lasty_average_payroll).toFixed(1));data[_index4].vap_percent=Number((Number(data[_index4].lasty_average_payroll||"0")?Number(data[_index4].variance_average_payroll||"0")/Number(data[_index4].lasty_average_payroll||"0"):0).toFixed(3));data[_index4].variance_payroll=Number((data[_index4].thisy_payroll_cost-data[_index4].lasty_payroll_cost).toFixed(1));data[_index4].vp_percent=Number((Number(data[_index4].lasty_payroll_cost||"0")?Number(data[_index4].variance_payroll||"0")/Number(data[_index4].lasty_payroll_cost||"0"):0).toFixed(3));// 年累计
data[_index4].year_thisy_average_payroll=Number((Number(data[_index4].year_thisy_employee_num||"0")?Number(data[_index4].year_thisy_payroll_cost||"0")/Number(data[_index4].year_thisy_employee_num||"0"):0).toFixed(1));data[_index4].year_lasty_average_payroll=Number((Number(data[_index4].year_lasty_employee_num||"0")?Number(data[_index4].year_lasty_payroll_cost||"0")/Number(data[_index4].year_lasty_employee_num||"0"):0).toFixed(1));data[_index4].year_variance_emplyee_num=Number((data[_index4].year_thisy_employee_num-data[_index4].year_lasty_employee_num).toFixed(1));data[_index4].year_ven_percent=Number((Number(data[_index4].year_lasty_employee_num||"0")?Number(data[_index4].year_variance_emplyee_num||"0")/Number(data[_index4].year_lasty_employee_num||"0"):0).toFixed(3));data[_index4].year_variance_average_payroll=Number((data[_index4].year_thisy_average_payroll-data[_index4].year_lasty_average_payroll).toFixed(1));data[_index4].year_vap_percent=Number((Number(data[_index4].year_lasty_average_payroll||"0")?Number(data[_index4].year_variance_average_payroll||"0")/Number(data[_index4].year_lasty_average_payroll||"0"):0).toFixed(3));data[_index4].year_variance_payroll=Number((data[_index4].year_thisy_payroll_cost-data[_index4].year_lasty_payroll_cost).toFixed(1));}_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;// this.setState({
//     data
// });
_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data7_1_2);var data=JSON.parse(dataBegin);_this.getNote(date);fetch('/_7_5_2_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data&&x.data.data.length>0){data=x.data.data;}if(!(0,_moment2.default)(_this.state.date).isBefore((0,_moment2.default)("2022-02"))){for(var i=0;i<data.length;i++){data[i].year_lasty_employee_num=~~_.get(x,'data.lastYear.'+i+'.year_thisy_employee_num',0);data[i].year_lasty_payroll_cost=~~_.get(x,'data.lastYear.'+i+'.year_thisy_payroll_cost',0);}}_this.setState({loading:false});_this.computeNum(data);(0,_compute.getChart2)((0,_moment2.default)(date).format('YYYY'));}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.getNote=function(date){fetch('/_7_5_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){_this.setState({note:_extends({},x.data[0])});}}).catch(function(err){console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};if(_this.state.note){_this.onSaveNote([_extends({},_this.state.note,{year:year,month:month})]);}fetch('/add_7_5_2',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){(0,_compute.getChart2)((0,_moment2.default)(date).format('YYYY'));_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败'+JSON.stringify(err));console.error(err);});};_this.onSaveNote=function(data){var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_7_5_1',headres).then(function(x){return x.json();}).then(function(x){if(x.status==1){// message.success(x.msg);
return;}_message3.default.error('备注保存失败：'+x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table7_5_2',1.5,'7.52',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,note:{note:""},loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);// this.computeNum(this.state.data)
}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var isOpenLastFill=(0,_moment2.default)(this.state.date).isBefore((0,_moment2.default)("2022-02"));var width=document.body.offsetWidth-1650>350?document.body.offsetWidth-1650:350;var columns=[{title:'Department 部门',dataIndex:'name',key:'name',align:"center",fixed:"left",width:width,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':''),style:{textAlign:"left"}},text);}},{title:'Overtime 加班',align:"center",width:1650,children:[{align:"center",title:'YTD Actual - This Year 年累计实际 - 今年',width:450,children:[{title:_react2.default.createElement('div',null,'No. of Employee ',_react2.default.createElement('br',null),'\u5458\u5DE5\u6570'),dataIndex:'year_thisy_employee_num',key:'year_thisy_employee_num',align:"center",width:150,render:function render(text,record,index){var title=['Overtime 加班','YTD Actual - This Year 年累计实际 - 今年','No. of Employee 员工数'];if(index>=0&&index<=6){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_thisy_employee_num',title:title,sqlName:"_7_5_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('year_thisy_employee_num',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_thisy_employee_num',title:title,sqlName:"_7_5_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Average Hours ',_react2.default.createElement('br',null),'\u4EBA\u5747\u5C0F\u65F6\u6570'),dataIndex:'year_thisy_average_payroll',key:'year_thisy_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['Overtime 加班','YTD Actual - This Year 年累计实际 - 今年','Average Hours 人均小时数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_thisy_average_payroll',title:title,sqlName:"_7_5_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Overtime Balance (Hours) ',_react2.default.createElement('br',null),'\u671F\u672B\u52A0\u73ED\u5C0F\u65F6\u6570'),dataIndex:'year_thisy_payroll_cost',key:'year_thisy_payroll_cost',align:"center",width:150,render:function render(text,record,index){var title=['Overtime 加班','YTD Actual - This Year 年累计实际 - 今年','Overtime Balance (Hours) 期末加班小时数'];if(index==7||index==15||index==16){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_thisy_payroll_cost',title:title,sqlName:"_7_5_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_thisy_payroll_cost',title:title,sqlName:"_7_5_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('year_thisy_payroll_cost',value,index);}})));}}}]},{align:"center",title:'YTD Actual - Last Year 年累计实际 - 去年',width:450,children:[{title:_react2.default.createElement('div',null,'No. of Employee ',_react2.default.createElement('br',null),'\u5458\u5DE5\u6570'),dataIndex:'year_lasty_employee_num',key:'year_lasty_employee_num',align:"center",width:150,render:function render(text,record,index){var title=['Overtime 加班','YTD Actual - Last Year 年累计实际 - 去年','No. of Employee 员工数'];if(index>=0&&index<=6&&isOpenLastFill){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_lasty_employee_num',title:title,sqlName:"_7_5_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('year_lasty_employee_num',value,index);},onCha:true})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_lasty_employee_num',title:title,sqlName:"_7_5_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Average Hours ',_react2.default.createElement('br',null),'\u4EBA\u5747\u5C0F\u65F6\u6570'),dataIndex:'year_lasty_average_payroll',key:'year_lasty_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['Overtime 加班','YTD Actual - Last Year 年累计实际 - 去年','Average Hours 人均小时数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_lasty_average_payroll',title:title,sqlName:"_7_5_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Overtime Balance (Hours) ',_react2.default.createElement('br',null),'\u671F\u672B\u52A0\u73ED\u5C0F\u65F6\u6570'),dataIndex:'year_lasty_payroll_cost',key:'year_lasty_payroll_cost',align:"center",width:150,render:function render(text,record,index){var title=['Overtime 加班','YTD Actual - Last Year 年累计实际 - 去年','Overtime Balance (Hours) 期末加班小时数'];if(index==7||index==15||index==16||!isOpenLastFill){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_lasty_payroll_cost',title:title,sqlName:"_7_5_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_lasty_payroll_cost',title:title,sqlName:"_7_5_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('year_lasty_payroll_cost',value,index);}})));}}}]},{align:"center",title:'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',width:750,children:[{title:_react2.default.createElement('div',null,'No. of Employee ',_react2.default.createElement('br',null),'\u5458\u5DE5\u6570'),dataIndex:'year_variance_emplyee_num',key:'year_variance_emplyee_num',align:"center",width:150,render:function render(text,record,index){var title=['Overtime 加班','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','No. of Employee 员工数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_variance_emplyee_num',title:title,sqlName:"_7_5_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding  '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'year_ven_percent',key:'year_ven_percent',align:"center",width:150,render:function render(text,record,index){var title=['Overtime 加班','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_ven_percent',title:title,sqlName:"_7_5_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Average Hours ',_react2.default.createElement('br',null),'\u4EBA\u5747\u5C0F\u65F6\u6570'),dataIndex:'year_variance_average_payroll',key:'year_variance_average_payroll',align:"center",width:150,render:function render(text,record,index){var title=['Overtime 加班','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','Average Hours 人均小时数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_variance_average_payroll',title:title,sqlName:"_7_5_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'year_vap_percent',align:"center",key:'year_vap_percent',width:150,render:function render(text,record,index){var title=['Overtime 加班','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_vap_percent',title:title,sqlName:"_7_5_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Overtime Balance (Hours) ',_react2.default.createElement('br',null),'\u671F\u672B\u52A0\u73ED\u5C0F\u65F6\u6570'),dataIndex:'year_variance_payroll',key:'year_variance_payroll',align:"center",width:150,render:function render(text,record,index){var title=['Overtime 加班','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','Overtime Balance (Hours) 期末加班小时数'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_variance_payroll',title:title,sqlName:"_7_5_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==7||index==15||index==16?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}]}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table7_5_2',style:{width:this.state.print?2000:'auto'}},_react2.default.createElement(_row2.default,null,'7.5.2 Overtime \u52A0\u73ED'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true,note:{note:""}});_this2.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',style:{width:this.state.print?1950:'auto'},scroll:this.state.print?{}:{x:1950},rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_row2.default,{style:{margin:"20px 0"}},_react2.default.createElement(_row2.default,{style:{margin:"10px 0"}},'7.5.3 Comments\u5907\u6CE8:  '),!this.state.loading||this.state.print?_react2.default.createElement(TextArea,{autosize:{minRows:4},placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',defaultValue:this.state.note.note,onBlur:function onBlur(e){_this2.setState({note:_extends({},_this2.state.note,{note:e.target.value})});}}):null)),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_7_5'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1992);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Chart=function(_Component){_inherits(Chart,_Component);function Chart(){_classCallCheck(this,Chart);return _possibleConstructorReturn(this,(Chart.__proto__||Object.getPrototypeOf(Chart)).apply(this,arguments));}_createClass(Chart,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"t7_5_2-chart"},_react2.default.createElement("div",{id:"row1",className:"t7_2-chart-content"}),_react2.default.createElement("div",{id:"row2",className:"t7_2-chart-content"}));}}]);return Chart;}(_react.Component);exports.default=Chart;

/***/ }),
/* 1992 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(8);__webpack_require__(6);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(14);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(1994);var _data7_6_=__webpack_require__(1995);__webpack_require__(1996);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextArea=_input2.default.TextArea;var MonthPicker=_datePicker2.default.MonthPicker;function numChange(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'0';var html=Number(text||'0')<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(Number(text||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');return html;}function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){for(var i=0;i<data.length;i++){data[i].total_hours=numConvert(data[i].duration_hours)*numConvert(data[i].participants_num).toFixed(2);}_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getTable7_6=function(date){var dataBegin=JSON.stringify(_data.data7_6_default);var data=JSON.parse(dataBegin);fetch('/_7_6_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){console.error(err);_this.setState({loading:false});});};_this.getTable7_6_1=function(date){var dataBegin=JSON.stringify(_data7_6_.data7_6_1_default);var data=JSON.parse(dataBegin);fetch('/_7_6_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}_this.setState({loading:false,data7_6_1:data});}).catch(function(err){console.error(err);_this.setState({loading:false});});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});_this.onSave7_6_1();var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_7_6',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getTable7_6(_this.state.date);_this.getTable7_6_1(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.onSave7_6_1=function(){_this.setState({loadingNote:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');_this.setState({loadingNote:false});return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data7_6_1.map(function(x){return _extends({},x,{year:year});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_7_6_1',headres).then(function(x){return x.json();}).then(function(x){_this.setState({loadingNote:false});if(x.status==1){return;}_message3.default.error(x.msg);}).catch(function(err){_this.setState({loadingNote:false});console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table7_6',1.5,'7.60',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.onFillLastMonth=function(){if(_this.state.data[0]&&_this.state.data[0].id){_message3.default.error('当前月份数据已存在!');_this.setState({loading:false});return;}_this.setState({loading:true,data:[]});var date=(0,_moment2.default)(_this.state.date).subtract(1,'month').format('YYYY-MM');var dataBegin=JSON.stringify(_data.data7_6_default);var data=JSON.parse(dataBegin);fetch('/_7_6_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_message3.default.info('数据填充成功！');if(x.data&&x.data.length>0){data=x.data.map(function(v){delete v.id;delete v.month;delete v.year;return v;});}_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],data7_6_1:[{'comments':''}],loading:true,print:false,loadingSave:false,loadingNote:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getTable7_6(this.state.date);this.getTable7_6_1(this.state.date);// this.computeNum(this.state.data)
}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var columns=[{title:'Training Topics 培训主题',dataIndex:'training_topics',key:'training_topics',align:"center",// fixed: "left",
// width: 100,
render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_input2.default,{className:'input-width',precision:0,defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('training_topics',value,index);}}));}},{title:'Department 部门',dataIndex:'department',key:'department',align:"center",// width: 100,
render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_input2.default,{className:'input-width',precision:0,defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('department',value,index);}}));}},{title:'Facilitator 培训师',dataIndex:'facilitator',key:'facilitator',align:"center",// width: 100,
render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_input2.default,{className:'input-width',precision:0,defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('facilitator',value,index);}}));}},{title:'Title 职称',dataIndex:'title',key:'title',align:"center",// width: 100,
render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_input2.default,{className:'input-width',precision:0,defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('title',value,index);}}));}},{title:_react2.default.createElement('div',null,'Duration (Hours)',_react2.default.createElement('br',null),'\u5355\u8BFE\u8BFE\u65F6'),dataIndex:'duration_hours',key:'duration_hours',align:"center",// width: 100,
render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('duration_hours',value,index);}}));}},{title:_react2.default.createElement('div',null,'No. of Participants',_react2.default.createElement('br',null),'\u9884\u8BA1\u53D7\u8BAD\u4EBA\u6570'),dataIndex:'participants_num',key:'participants_num',align:"center",// width: 100,
render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('participants_num',value,index);}}));}},{title:_react2.default.createElement('div',null,'Total Hours',_react2.default.createElement('br',null),'\u603B\u8BA1\u8BFE\u65F6'),dataIndex:'total_hours',key:'total_hours',align:"center",// width: 100,
render:function render(text,record,index){var title=['Total Hours 总计课时'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'total_hours',title:title,sqlName:"_7_6",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},numChange(text)))// <div className="table-color table-color-number">
//     <Input
//         className="input-width"
//         precision={0}
//         defaultValue={text}
//         onBlur={(e) => {
//             let value = e.target.value || "0";
//             this.onChange('total_hours', value, index)
//         }}
//     />
// </div>
;}},{title:'Remarks 备注',dataIndex:'remarks',key:'remarks',align:"center",// width: 100,
render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-color table-color-number'},_react2.default.createElement(_input2.default,{className:'input-width',precision:0,defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"0";_this2.onChange('remarks',value,index);}}));}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1 table7_6',id:'table7_6'},_react2.default.createElement(_row2.default,{className:'title'},_react2.default.createElement(_row2.default,null,'7.6 Training Plan For Next 1 Month \u540E\u4E00\u4E2A\u6708\u4E3B\u8981\u57F9\u8BAD\u8BA1\u5212'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[]});_this2.getTable7_6(str);_this2.getTable7_6_1(str);}}),_react2.default.createElement(_button2.default,{type:'primary',style:{marginLeft:10,display:this.state.print?'none':''},onClick:this.onFillLastMonth},'\u586B\u5145\u4E0A\u6708\u6570\u636E')),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',scroll:{y:600},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'title'},_react2.default.createElement(_row2.default,null,'7.6.1 Comments\u5907\u6CE8: '),_react2.default.createElement(TextArea,{autosize:{minRows:4},value:this.state.data7_6_1[0]?this.state.data7_6_1[0]['comments']:'',onChange:function onChange(e){var data7_6_1=_this2.state.data7_6_1;data7_6_1[0]['comments']=e.target.value;_this2.setState({data7_6_1:data7_6_1});}}),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_7_6'},_react2.default.createElement(_row2.default,{className:'table-footer-btn',style:{display:this.state.print?'none':""}},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingNote},'\u4FDD\u5B58'))))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _ref,_ref2,_ref3,_ref4,_ref5,_ref6,_ref7,_ref8,_ref9,_ref10,_ref11,_ref12,_ref13,_ref14,_ref15,_ref16,_ref17,_ref18,_ref19,_ref20,_ref21,_ref22,_ref23,_ref24,_ref25,_ref26,_ref27,_ref28,_ref29,_ref30;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var data7_6_default=exports.data7_6_default=[(_ref={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref,"participants_num",0),_defineProperty(_ref,"remarks",""),_ref),(_ref2={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref2,"participants_num",0),_defineProperty(_ref2,"remarks",""),_ref2),(_ref3={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref3,"participants_num",0),_defineProperty(_ref3,"remarks",""),_ref3),(_ref4={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref4,"participants_num",0),_defineProperty(_ref4,"remarks",""),_ref4),(_ref5={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref5,"participants_num",0),_defineProperty(_ref5,"remarks",""),_ref5),(_ref6={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref6,"participants_num",0),_defineProperty(_ref6,"remarks",""),_ref6),(_ref7={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref7,"participants_num",0),_defineProperty(_ref7,"remarks",""),_ref7),(_ref8={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref8,"participants_num",0),_defineProperty(_ref8,"remarks",""),_ref8),(_ref9={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref9,"participants_num",0),_defineProperty(_ref9,"remarks",""),_ref9),(_ref10={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref10,"participants_num",0),_defineProperty(_ref10,"remarks",""),_ref10),(_ref11={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref11,"participants_num",0),_defineProperty(_ref11,"remarks",""),_ref11),(_ref12={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref12,"participants_num",0),_defineProperty(_ref12,"remarks",""),_ref12),(_ref13={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref13,"participants_num",0),_defineProperty(_ref13,"remarks",""),_ref13),(_ref14={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref14,"participants_num",0),_defineProperty(_ref14,"remarks",""),_ref14),(_ref15={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref15,"participants_num",0),_defineProperty(_ref15,"remarks",""),_ref15),(_ref16={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref16,"participants_num",0),_defineProperty(_ref16,"remarks",""),_ref16),(_ref17={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref17,"participants_num",0),_defineProperty(_ref17,"remarks",""),_ref17),(_ref18={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref18,"participants_num",0),_defineProperty(_ref18,"remarks",""),_ref18),(_ref19={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref19,"participants_num",0),_defineProperty(_ref19,"remarks",""),_ref19),(_ref20={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref20,"participants_num",0),_defineProperty(_ref20,"remarks",""),_ref20),(_ref21={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref21,"participants_num",0),_defineProperty(_ref21,"remarks",""),_ref21),(_ref22={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref22,"participants_num",0),_defineProperty(_ref22,"remarks",""),_ref22),(_ref23={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref23,"participants_num",0),_defineProperty(_ref23,"remarks",""),_ref23),(_ref24={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref24,"participants_num",0),_defineProperty(_ref24,"remarks",""),_ref24),(_ref25={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref25,"participants_num",0),_defineProperty(_ref25,"remarks",""),_ref25),(_ref26={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref26,"participants_num",0),_defineProperty(_ref26,"remarks",""),_ref26),(_ref27={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref27,"participants_num",0),_defineProperty(_ref27,"remarks",""),_ref27),(_ref28={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref28,"participants_num",0),_defineProperty(_ref28,"remarks",""),_ref28),(_ref29={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref29,"participants_num",0),_defineProperty(_ref29,"remarks",""),_ref29),(_ref30={training_topics:'',department:"",facilitator:"",title:"",duration_hours:"",participants_num:0},_defineProperty(_ref30,"participants_num",0),_defineProperty(_ref30,"remarks",""),_ref30)];

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data7_6_1_default=exports.data7_6_1_default=[{comments:''}];

/***/ }),
/* 1996 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _alert=__webpack_require__(83);var _alert2=_interopRequireDefault(_alert);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(84);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(1998);var _data2=_interopRequireDefault(_data);var _compute=__webpack_require__(1999);var _compute2=_interopRequireDefault(_compute);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _method=__webpack_require__(20);var _Chart=__webpack_require__(2000);var _Chart2=_interopRequireDefault(_Chart);var _IsLableAuth=__webpack_require__(107);var _IsLableAuth2=_interopRequireDefault(_IsLableAuth);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var _this$state=_this.state,date=_this$state.date,data7_1=_this$state.data7_1,data1_1=_this$state.data1_1,data7_1_2=_this$state.data7_1_2;data=(0,_compute2.default)(data,{date:date,data1_1:data1_1,data7_1:data7_1,data7_1_2:data7_1_2});_this.setState({data:data,loading:false});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var data,month,year,x,isOpenLastFill,i;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_this.setState({loading:true});data=JSON.parse(JSON.stringify(_data2.default));month=(0,_moment2.default)(date).format('M');year=(0,_moment2.default)(date).format('YYYY');_context.next=7;return(0,_request2.default)("/t7_7_info?year="+year+"&month="+month);case 7:x=_context.sent;if(x.data.data&&x.data.data.length>0){data=x.data.data;}isOpenLastFill=(0,_moment2.default)(date).isBefore((0,_moment2.default)("2022-02"));if(!isOpenLastFill){for(i=0;i<data.length;i++){data[i].last=(0,_method.numConvert)(_lodash2.default.get(x,"data.lastYear."+i+".actual",0)).toFixed(2);}}_this.setState({data1_1:x.data.data1_1||[],data7_1:x.data.data7_1||[],data7_1_2:x.data.data7_1_2||[]},function(){_this.computeNum(data);});_context.next=18;break;case 14:_context.prev=14;_context.t0=_context["catch"](0);_this.setState({loading:false});console.error(_context.t0);case 18:case"end":return _context.stop();}}},_callee,_this2,[[0,14]]);}));return function(_x){return _ref.apply(this,arguments);};}();_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var date,_timer,year,month,data,dataFrom,headres,x,timer,_timer2;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_this.setState({loadingSave:true});date=_this.state.date;if(date){_context2.next=7;break;}_message3.default.error('请选择年份月份');_timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer);},1000);return _context2.abrupt("return");case 7:year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month,sort:i});});dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context2.next=15;return(0,_request2.default)('/t7_7_save',headres);case 15:x=_context2.sent;timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(!(x.status==1)){_context2.next=22;break;}_message3.default.success(x.msg);if(!data[0].id){_this.getData(_this.state.date);}(0,_compute.getChart)(year);return _context2.abrupt("return");case 22:_message3.default.error(x.msg);_context2.next=30;break;case 25:_context2.prev=25;_context2.t0=_context2["catch"](0);_timer2=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer2);},1000);console.error(_context2.t0);_message3.default.error('保存失败'+JSON.stringify(_context2.t0));case 30:case"end":return _context2.stop();}}},_callee2,_this2,[[0,25]]);}));_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('view4_1_4',1.5,'7.7',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+" "+(0,_moment2.default)(_this.state.date).format('YYYY')+" 7.7 Data Visualization \u4EBA\u6548\u6570\u636E\u53EF\u89C6\u5316";var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById('table4_1_4').innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+".xls");_this.setState({print:false});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,data7_1:[],data1_1:[],data7_1_2:[]};return _this;}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);(0,_compute.getChart)((0,_moment2.default)(this.state.date).format('YYYY'));}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print,loading=_state.loading;return _react2.default.createElement("div",{className:"table7_1_1 tableHeight"},_react2.default.createElement(_row2.default,{className:"title",id:"view4_1_4"},_react2.default.createElement(_row2.default,null,"7.7 Data Visualization \u4EBA\u6548\u6570\u636E\u53EF\u89C6\u5316"),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:"YYYY-MM",onChange:function onChange(date,str){_this3.setState({date:str,data:[]});_this3.getData(str);(0,_compute.getChart)((0,_moment2.default)(str).format('YYYY'));}})),_react2.default.createElement(_table2.default,{columns:(0,_compute.columns)(this.onChange,print,date),dataSource:data,size:"middle",id:"table4_1_4",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:"table-footer-btn"},_react2.default.createElement(_alert2.default,{message:_react2.default.createElement("div",null,"\u8868\u683C\u5173\u8054",_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:"read_1"},this.props,{path:"/table/1"}),"1.1")," -",_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:"read_7_1"},this.props,{path:"/table/7_1"}),"7.1")),type:"info",showIcon:true,style:{display:"inline-block",marginRight:10}}),_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:print},"\u5BFC\u51FAExcel"),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:"edit_7_7"},_react2.default.createElement(_button2.default,{type:"primary",style:{margin:'0 10px'},onClick:this.downloadSG,loading:print},"\u52A0\u5165pdf"),_react2.default.createElement(_button2.default,{type:"primary",onClick:this.onSave,loading:this.state.loadingSave},"\u4FDD\u5B58"))),_react2.default.createElement(_Chart2.default,null));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=[{"name":"酒店整体情况","sort":0,"actual":0,"last":0,"contrast":0},{"name":"本年度经营月份","sort":1,"actual":0,"last":0,"contrast":0},{"name":"本月实际经营天数","sort":2,"actual":0,"last":0,"contrast":0},{"name":"Total Staff Number 本月员工总数 （包含实习生，不包含临时工)","sort":3,"actual":0,"last":0,"contrast":0},{"name":"客房部","sort":4,"actual":0,"last":0,"contrast":0},{"name":"Rooms Staff 客房部员工总数 (包括前台)","sort":5,"actual":0,"last":0,"contrast":0},{"name":"Rooms Labor Cost 客房部门人力成本（包含工资及福利费用合计，不含劳务外包及帮工费用）","sort":6,"actual":0,"last":0,"contrast":0},{"name":"Rooms Total Salary 客房部门员工工资（仅工资）","sort":7,"actual":0,"last":0,"contrast":0},{"name":"餐饮部","sort":8,"actual":0,"last":0,"contrast":0},{"name":"F&B Staff 餐饮部员工总数","sort":9,"actual":0,"last":0,"contrast":0},{"name":"F&B Labor Cost 餐饮部门人力成本（包含工资及福利费用合计，不含劳务外包及帮工费用）","sort":10,"actual":0,"last":0,"contrast":0},{"name":"F&B Total Salary 餐饮部门员工工资（仅工资）","sort":11,"actual":0,"last":0,"contrast":0},{"name":"其他营业部门","sort":12,"actual":0,"last":0,"contrast":0},{"name":"Other Operating Staff 其他营业部门员工总数","sort":13,"actual":0,"last":0,"contrast":0},{"name":"Other Operating Labor Cost 其他营业部门人力成本","sort":14,"actual":0,"last":0,"contrast":0},{"name":"Other Operating Salary 其他营业部门员工工资 (仅工资)","sort":15,"actual":0,"last":0,"contrast":0},{"name":"后台部门","sort":16,"actual":0,"last":0,"contrast":0},{"name":"Undistributed Staff 后台部门员工总数","sort":17,"actual":0,"last":0,"contrast":0},{"name":"Undistributed Labor Cost 后台部门人力成本","sort":18,"actual":0,"last":0,"contrast":0},{"name":"Undistributed Salary 后台部门员工工资 (仅工资)","sort":19,"actual":0,"last":0,"contrast":0},{"name":"实习生","sort":20,"actual":0,"last":0,"contrast":0},{"name":"Trainee 总实习生人数","sort":21,"actual":0,"last":0,"contrast":0},{"name":"Trainee Cost 总培训生费用支出 - 工资","sort":22,"actual":0,"last":0,"contrast":0},{"name":"Trainee Cost 总培训生费用支出 - 管理费 ","sort":23,"actual":0,"last":0,"contrast":0},{"name":"人效指数","sort":24,"actual":0,"last":0,"contrast":0},{"name":"酒店整体人效指数","sort":25,"actual":0,"last":0,"contrast":0},{"name":"F&B人效指数","sort":26,"actual":0,"last":0,"contrast":0},{"name":"Rooms人效指数","sort":27,"actual":0,"last":0,"contrast":0},{"name":"劳动生产率","sort":28,"actual":0,"last":0,"contrast":0},{"name":"F&B劳动生产率","sort":29,"actual":0,"last":0,"contrast":0},{"name":"Rooms劳动生产率","sort":30,"actual":0,"last":0,"contrast":0}];

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getChart=exports.columns=undefined;var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _analysis=__webpack_require__(125);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}exports.default=function(data,_ref){var date=_ref.date,data1_1=_ref.data1_1,data7_1=_ref.data7_1,data7_1_2=_ref.data7_1_2;// 数据链接2022-02开始
var isOpenLastFill=(0,_moment2.default)(date).isBefore((0,_moment2.default)("2022-02"));if(!isOpenLastFill){data[5].actual=(0,_method.numConvert)(_lodash2.default.get(data7_1_2,"0.thisy_employee_num",0),2);data[7].actual=(0,_method.numConvert)(_lodash2.default.get(data7_1_2,"0.thisy_payroll_cost",0),2);data[9].actual=(0,_method.numConvert)(_lodash2.default.get(data7_1_2,"1.thisy_employee_num",0),2);data[11].actual=(0,_method.numConvert)(_lodash2.default.get(data7_1_2,"1.thisy_payroll_cost",0),2);data[13].actual=(0,_method.numConvert)(_lodash2.default.get(data7_1_2,"6.thisy_employee_num",0),2);data[15].actual=(0,_method.numConvert)(_lodash2.default.get(data7_1_2,"6.thisy_payroll_cost",0),2);data[17].actual=(0,_method.sum)([_lodash2.default.get(data7_1_2,"2.thisy_employee_num",0),_lodash2.default.get(data7_1_2,"3.thisy_employee_num",0),_lodash2.default.get(data7_1_2,"4.thisy_employee_num",0),_lodash2.default.get(data7_1_2,"5.thisy_employee_num",0)],2);data[19].actual=(0,_method.sum)([_lodash2.default.get(data7_1_2,"2.thisy_payroll_cost",0),_lodash2.default.get(data7_1_2,"3.thisy_payroll_cost",0),_lodash2.default.get(data7_1_2,"4.thisy_payroll_cost",0),_lodash2.default.get(data7_1_2,"5.thisy_payroll_cost",0)],2);data[21].actual=(0,_method.numConvert)(_lodash2.default.get(data7_1,"10.thisy_employee_num",0),2);}// 人效指数
data[25].actual=(0,_method.calculation)(_lodash2.default.get(data1_1,"8.actual"),(0,_method.sum)([_lodash2.default.get(data7_1,"16.thisy_payroll_cost"),_lodash2.default.get(data7_1,"19.thisy_payroll_cost")]),2);data[25].last=(0,_method.calculation)(_lodash2.default.get(data1_1,"8.last_year"),(0,_method.sum)([_lodash2.default.get(data7_1,"16.lasty_payroll_cost"),_lodash2.default.get(data7_1,"19.lasty_payroll_cost")]),2);data[26].actual=(0,_method.calculation)(_lodash2.default.get(data1_1,"6.actual"),(0,_method.sum)([_lodash2.default.get(data7_1,"17.thisy_payroll_cost"),_lodash2.default.get(data,"10.actual")]),2);data[26].last=(0,_method.calculation)(_lodash2.default.get(data1_1,"6.last_year"),(0,_method.sum)([_lodash2.default.get(data7_1,"17.lasty_payroll_cost"),_lodash2.default.get(data,"10.last")]),2);data[27].actual=(0,_method.calculation)(_lodash2.default.get(data1_1,"5.actual"),(0,_method.sum)([_lodash2.default.get(data7_1,"18.thisy_payroll_cost"),_lodash2.default.get(data,"6.actual")]),2);data[27].last=(0,_method.calculation)(_lodash2.default.get(data1_1,"5.last_year"),(0,_method.sum)([_lodash2.default.get(data7_1,"18.lasty_payroll_cost"),_lodash2.default.get(data,"6.last")]),2);//劳动生产率
data[29].actual=(0,_method.calculation)(_lodash2.default.get(data1_1,"6.actual"),_lodash2.default.get(data,"9.actual"),2);data[29].last=(0,_method.calculation)(_lodash2.default.get(data1_1,"6.last_year"),_lodash2.default.get(data,"9.last"),2);data[30].actual=(0,_method.calculation)(_lodash2.default.get(data1_1,"5.actual"),_lodash2.default.get(data,"5.actual"),2);data[30].last=(0,_method.calculation)(_lodash2.default.get(data1_1,"5.last_year"),_lodash2.default.get(data,"5.last"),2);data.forEach(function(item,i){data[i].contrast=(0,_method.calculation)(item.actual-item.last,item.last,4);});return data;};var totalIndex=[0,4,8,12,16,20,24,28];var columns=exports.columns=function columns(onChange,print,date){var isOpenLastFill=(0,_moment2.default)(date).isBefore((0,_moment2.default)("2022-02"));var openIndex=[5,7,9,11,13,15,17,19,21];if(isOpenLastFill)openIndex=[];return[{title:'',dataIndex:'name',key:'name',align:"center",width:400,render:function render(text,record,index){var title=[];var props={text:text,index:index,type:'text',name:"name",onChange:onChange,totalIndex:totalIndex};if(totalIndex.includes(index))return{props:{colSpan:4},children:_react2.default.createElement(_TableText2.default,{data:props})};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u4ECA\u5E74\u5F53\u6708\u5B9E\u9645",dataIndex:'actual',key:'actual',align:"center",width:150,render:function render(text,record,index){var title=['今年当月实际'];var props={text:text,index:index,type:!totalIndex.includes(index)&&!openIndex.includes(index)&&!print&&index<24?'inputNumber':'number',name:"actual",onChange:onChange,totalIndex:totalIndex};props.compared={title:title,record:record,sqlName:"_7_7"};if(!totalIndex.includes(index))return _react2.default.createElement(_TableText2.default,{data:props});return{props:{colSpan:0}};}},{title:"\u53BB\u5E74\u5F53\u6708\u5B9E\u9645",dataIndex:'last',key:'last',align:"center",width:150,render:function render(text,record,index){var title=['去年当月实际'];var props={text:text,index:index,type:!totalIndex.includes(index)&&!print&&index<24&&isOpenLastFill?'inputNumber':'number',name:"last",onChange:onChange,totalIndex:totalIndex};props.compared={title:title,record:record,sqlName:"_7_7"};if(!totalIndex.includes(index))return _react2.default.createElement(_TableText2.default,{data:props});return{props:{colSpan:0}};}},{title:"",dataIndex:'contrast',key:'contrast',align:"center",width:150,render:function render(text,record,index){var title=[];var props={text:text,index:index,type:'percent',name:"contrast",onChange:onChange,totalIndex:totalIndex};props.compared={title:title,record:record,sqlName:"_7_7"};if(!totalIndex.includes(index))return _react2.default.createElement(_TableText2.default,{data:props});return{props:{colSpan:0}};}}];};var getChart=exports.getChart=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(year){var _ref3,data,dataX,xAxis;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_request2.default)("/chartData?year="+year);case 2:_ref3=_context.sent;data=_ref3.data;dataX=new Array(12).fill(1).map(function(x,i){return i+1+"\u6708";});xAxis=[{type:'category',axisLabel:{color:"black",fontSize:14,rotate:40,interval:0},data:new Array(12).fill(1).map(function(x,i){return year+"-"+(i+1);})},{type:'category',axisLabel:{color:"black",interval:0,rotate:40,fontSize:14},data:new Array(12).fill(1).map(function(x,i){return year-1+"-"+(i+1);})}];(0,_analysis.setKarte)({id:"row1",title:"去年人效指数",color:['#00C5BD','#42585D','#FE5F5F'],yAxis:{max:5,min:0,interval:0.5},dataX:dataX,dataY:[{name:"酒店数据",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.peopleWork.find(function(_x){return _x.month==i+1;}),'last',0)).toFixed(2);})},{name:"区域数据",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.area.find(function(_x){return _x.month==i+1;}),'last',0)).toFixed(2);})},{name:"收入区间数据",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.interval.find(function(_x){return _x.month==i+1;}),'last',0)).toFixed(2);})}]});(0,_analysis.setKarte)({id:"row2",title:"当年人效指数",color:['#00C5BD','#42585D','#FE5F5F'],yAxis:{max:5,min:0,interval:0.5},dataX:dataX,dataY:[{name:"酒店数据",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.peopleWork.find(function(_x){return _x.month==i+1;}),'actual',0)).toFixed(2);})},{name:"区域数据",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.area.find(function(_x){return _x.month==i+1;}),'actual',0)).toFixed(2);})},{name:"收入区间数据",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.interval.find(function(_x){return _x.month==i+1;}),'actual',0)).toFixed(2);})}]});(0,_analysis.setOption)({id:"chart1",title:"酒店整体人效指数",dataX:dataX,xAxis:xAxis,yAxis:{max:5,min:0,interval:0.5},dataY:[{name:year+" \u5F53\u5E74",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.peopleWork.find(function(_x){return _x.month==i+1;}),'actual',0)).toFixed(2);})},{name:year-1+" \u53BB\u5E74",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.peopleWork.find(function(_x){return _x.month==i+1;}),'last',0)).toFixed(2);})}]});(0,_analysis.setOption)({id:"chart2",title:"后台人力成本占比",dataX:dataX,xAxis:xAxis,yAxis:{max:1,min:0,interval:0.1},dataY:[{name:year+" \u5F53\u5E74",data:dataX.map(function(x,i){return(0,_method.calculation)(_lodash2.default.get(data.humanCost.find(function(_x){return _x.month==i+1;}),'actual',0),_lodash2.default.get(data.data7_1.find(function(_x){return _x.month==i+1;}),'actual',0));})},{name:year-1+" \u53BB\u5E74",data:dataX.map(function(x,i){return(0,_method.calculation)(_lodash2.default.get(data.humanCost.find(function(_x){return _x.month==i+1;}),'last',0),_lodash2.default.get(data.data7_1.find(function(_x){return _x.month==i+1;}),'last',0));})}]});(0,_analysis.setOption)({id:"chart3",title:"Rooms 人效指数",dataX:dataX,xAxis:xAxis,yAxis:{max:10,min:0,interval:1},dataY:[{name:year+" \u5F53\u5E74",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.roomH.find(function(_x){return _x.month==i+1;}),'actual',0)).toFixed(2);})},{name:year-1+" \u53BB\u5E74",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.roomH.find(function(_x){return _x.month==i+1;}),'last',0)).toFixed(2);})}]});(0,_analysis.setOption)({id:"chart4",title:"Rooms劳动生产率",dataX:dataX,xAxis:xAxis,yAxis:{max:80000,min:0,interval:10000},dataY:[{name:year+" \u5F53\u5E74",type:"bar",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.roomP.find(function(_x){return _x.month==i+1;}),'actual',0)).toFixed(2);})},{name:year-1+" \u53BB\u5E74",type:"bar",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.roomP.find(function(_x){return _x.month==i+1;}),'last',0)).toFixed(2);})}]});(0,_analysis.setOption)({id:"chart5",title:"F&B人效指数",dataX:dataX,xAxis:xAxis,yAxis:{max:10,min:0,interval:1},dataY:[{name:year+" \u5F53\u5E74",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.fbH.find(function(_x){return _x.month==i+1;}),'actual',0)).toFixed(2);})},{name:year-1+" \u53BB\u5E74",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.fbH.find(function(_x){return _x.month==i+1;}),'last',0)).toFixed(2);})}]});(0,_analysis.setOption)({id:"chart6",title:"F&B劳动生产率",dataX:dataX,xAxis:xAxis,yAxis:{max:80000,min:0,interval:10000},dataY:[{name:year+" \u5F53\u5E74",type:"bar",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.fbP.find(function(_x){return _x.month==i+1;}),'actual',0)).toFixed(2);})},{name:year-1+" \u53BB\u5E74",type:"bar",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.fbP.find(function(_x){return _x.month==i+1;}),'last',0)).toFixed(2);})}]});case 14:case"end":return _context.stop();}}},_callee,undefined);}));return function getChart(_x2){return _ref2.apply(this,arguments);};}();

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(2001);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Chart=function(_Component){_inherits(Chart,_Component);function Chart(){_classCallCheck(this,Chart);return _possibleConstructorReturn(this,(Chart.__proto__||Object.getPrototypeOf(Chart)).apply(this,arguments));}_createClass(Chart,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"t7_7-chart"},_react2.default.createElement("div",{className:"list-chart"},_react2.default.createElement("div",{id:"row1"}),_react2.default.createElement("div",{id:"row2"}),_react2.default.createElement("div",{id:"chart1"}),_react2.default.createElement("div",{id:"chart2"}),_react2.default.createElement("div",{id:"chart3"}),_react2.default.createElement("div",{id:"chart4"}),_react2.default.createElement("div",{id:"chart5"}),_react2.default.createElement("div",{id:"chart6"})));}}]);return Chart;}(_react.Component);exports.default=Chart;

/***/ }),
/* 2001 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var dataDefault=exports.dataDefault=[{sort:0,name:"Labor Cost 人力成本",now_year:0,last_year:0,variance:0},{sort:1,name:"Total Available Rooms 总房数",now_year:0,last_year:0,variance:0},{sort:2,name:"Total Rooms Occupied 总出租房",now_year:0,last_year:0,variance:0},{sort:3,name:"Occupancy % 出租率%",now_year:0,last_year:0,variance:0},{sort:4,name:"Average Room Rate 平均每天房价",now_year:0,last_year:0,variance:0},{sort:5,name:"Total Revenue 总收入",now_year:0,last_year:0,variance:0},{sort:6,name:"Rooms Revenue 客房收入",now_year:0,last_year:0,variance:0},{sort:7,name:"F&B Revenue 餐饮收入",now_year:0,last_year:0,variance:0},{sort:8,name:"Other Revenue 其他收入",now_year:0,last_year:0,variance:0},{sort:9,name:"GOP 经营利润",now_year:0,last_year:0,variance:0},{sort:10,name:"Salary 工资 (纯工资)",now_year:0,last_year:0,variance:0},{sort:11,name:"Incentive Program/Bonus Provision 绩效考核奖金/年终奖预提",now_year:0,last_year:0,variance:0},{sort:12,name:"Overtime 加班工资",now_year:0,last_year:0,variance:0},{sort:13,name:"Vacation 法定假期",now_year:0,last_year:0,variance:0},{sort:14,name:"Meal 工作餐费",now_year:0,last_year:0,variance:0},{sort:15,name:"Social Insurance and Housing Fund 社保和公积金",now_year:0,last_year:0,variance:0},{sort:16,name:"Other Related Benefits 其他福利 <br/>(包括合同津贴，交通、住宿、通讯补贴， 加班工资，法定假期，工作餐费等)",now_year:0,last_year:0,variance:0},{sort:17,name:"Total Labor Cost 人力成本总计<br/>（包含工资及福利费用合计，不含劳务外包及帮工费用）",now_year:0,last_year:0,variance:0},{sort:18,name:"Productivity 生产率",now_year:0,last_year:0,variance:0},{sort:19,name:"本年度实际经营月份数",now_year:0,last_year:0,variance:0},{sort:20,name:"本年度实际经营天数",now_year:0,last_year:0,variance:0},{sort:21,name:"Total Staff Number 员工总数 (累计数，包含实习生，不包含临时工)",now_year:0,last_year:0,variance:0},{sort:22,name:"Average Staff Number 平均每月员工数",now_year:0,last_year:0,variance:0},{sort:23,name:"Staff Numbers / Total Available Rooms 员工总数/ 总房数",now_year:0,last_year:0,variance:0},{sort:24,name:"Total Labor Cost / Total Revenue 总人力成本/ 总收入",now_year:0,last_year:0,variance:0},{sort:25,name:"Total Labor Cost / Total Staff Numbers<br/> 总人力成本/ 员工总数",now_year:0,last_year:0,variance:0},{sort:30,name:"Total Salary / Total Staff Numbers 总员工工资/ 员工总数",now_year:0,last_year:0,variance:0},{sort:31,name:"Rooms Staff 客房部员工总数 (包括前台)",now_year:0,last_year:0,variance:0},{sort:32,name:"Rooms Labor Cost 客房部门人力成本",now_year:0,last_year:0,variance:0},{sort:33,name:"Rooms Total Salary 客房部门员工工资（仅工资）",now_year:0,last_year:0,variance:0},{sort:34,name:"Rooms Revenue / Total Revenue 客房收入/ 总收入",now_year:0,last_year:0,variance:0},{sort:35,name:"Rooms Labor Cost / Total Labor Cost<br/> 客房部门人力成本/ 总人力成本",now_year:0,last_year:0,variance:0},{sort:36,name:"Rooms Labor Cost / Rooms Staff<br/> 客房部门人力成本/ 客房部员工总数 ",now_year:0,last_year:0,variance:0},{sort:37,name:"Rooms Total Salary / Rooms Staff<br/> 客房部门员工工资/ 客房部员工总数 ",now_year:0,last_year:0,variance:0},{sort:38,name:"Rooms Revenue / Rooms Staff 客房收入/ 客房部员工数（Productivity 劳动生产率）",now_year:0,last_year:0,variance:0},{sort:39,name:"F&B Staff 餐饮部员工总数",now_year:0,last_year:0,variance:0},{sort:40,name:"F&B Labor Cost 餐饮部门人力成本",now_year:0,last_year:0,variance:0},{sort:41,name:"F&B Total Salary 餐饮部门员工工资（仅工资）",now_year:0,last_year:0,variance:0},{sort:42,name:"F&B Revenue / Total Revenue 餐饮收入/ 总收入",now_year:0,last_year:0,variance:0},{sort:43,name:"F&B Labor Cost / Total Labor Cost 餐饮部门人力成本/ 总人力成本",now_year:0,last_year:0,variance:0},{sort:44,name:"F&B Labor Cost / F&B Staff 餐饮部门人力成本/ 餐饮部员工总数 ",now_year:0,last_year:0,variance:0},{sort:45,name:"F&B Total Salary / F&B Staff 餐饮部门员工工资/ 餐饮部员工总数 ",now_year:0,last_year:0,variance:0},{sort:46,name:"F&B Revenue / F&B Staff 餐饮收入/ 餐饮部员工人数 （Productivity 劳动生产率）",now_year:0,last_year:0,variance:0},{sort:47,name:"Other Operating Staff 其他营业部门员工总数",now_year:0,last_year:0,variance:0},{sort:48,name:"Other Operating Labor Cost 其他营业部门人力成本",now_year:0,last_year:0,variance:0},{sort:49,name:"Other Operating Salary 其他营业部门员工工资 (仅工资)",now_year:0,last_year:0,variance:0},{sort:50,name:"Other Operating Revenue / Total Revenue 其他营业部门收入/ 总收入",now_year:0,last_year:0,variance:0},{sort:51,name:"Other Operating Labor Cost / Total Labor Cost<br/> 其他营业部门人力成本/ 总人力成本",now_year:0,last_year:0,variance:0},{sort:52,name:"Other Operating Labor Cost / Other Operating Staff <br/> 其他营业部门人力成本/ 其他营业部门员工总数 ",now_year:0,last_year:0,variance:0},{sort:53,name:"Other Operating Total Salary / Other Operating Staff<br/> 其他营业部门员工工资/ 其他营业部门员工总数 ",now_year:0,last_year:0,variance:0},{sort:54,name:"Other Operating Revenue / Other Operating Staff<br/> 其他营业部门收入/ 其他营业部门员工人数 （Productivity 劳动生产率）",now_year:0,last_year:0,variance:0},{sort:55,name:"Undistributed Staff 后台部门员工总数",now_year:0,last_year:0,variance:0},{sort:56,name:"Undistributed Labor Cost 后台部门人力成本",now_year:0,last_year:0,variance:0},{sort:57,name:"Undistributed Salary 后台部门员工工资 (仅工资)",now_year:0,last_year:0,variance:0},{sort:58,name:"Undistributed Labor Cost / Total Labor Cost<br/> 后台部门人力成本/ 总人力成本",now_year:0,last_year:0,variance:0},{sort:59,name:"Undistributed Labor Cost / Undistributed Staff <br/>后台部门人力成本/ 后台部门员工总数 ",now_year:0,last_year:0,variance:0},{sort:60,name:"Undistributed Total Salary / Undistributed Staff <br/>后台部门员工工资/ 后台部门员工总数 ",now_year:0,last_year:0,variance:0},{sort:61,name:" Staff No. Check",now_year:0,last_year:0,variance:0},{sort:62,name:"Labor Cost Check",now_year:0,last_year:0,variance:0},{sort:63,name:"Including 其中：",now_year:0,last_year:0,variance:0},{sort:64,name:"Trainee 总实习生人数",now_year:0,last_year:0,variance:0},{sort:65,name:"Total Trainee / Total Staff Number 总实习生人数/ 员工总数",now_year:0,last_year:0,variance:0},{sort:66,name:"Trainee Cost 总实习生费用支出 - 工资",now_year:0,last_year:0,variance:0},{sort:67,name:"Trainee Cost 总实习生费用支出 - 管理费 ",now_year:0,last_year:0,variance:0},{sort:68,name:"Average of Trainee Cost 每个实习生平均费用 ",now_year:0,last_year:0,variance:0},{sort:69,name:"Departments Expenses 各部门劳务费用（包括临时帮工及外包费用）",now_year:0,last_year:0,variance:0},{sort:70,name:"F&B 酒店餐饮劳务费用",now_year:0,last_year:0,variance:0},{sort:71,name:"Rooms 酒店房务劳务费用",now_year:0,last_year:0,variance:0},{sort:72,name:"Total Labor Outsourcing Expenses 酒店劳务费用合计",now_year:0,last_year:0,variance:0},{sort:73,name:"Total Labor Outsourcing Expenses / Total Labor Cost 酒店劳务费用合计/总人力成本",now_year:0,last_year:0,variance:0}];

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.compute=compute;__webpack_require__(8);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _method2=_interopRequireDefault(_method);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultData=[{name:"酒店整体人效指数",name_code:"hotel",now_year:0,last_year:0,variance:0},{name:"F&B人效指数",name_code:"fb",now_year:0,last_year:0,variance:0},{name:"Rooms人效指数",name_code:"rooms",now_year:0,last_year:0,variance:0}];var Productivity=function(_Component){_inherits(Productivity,_Component);function Productivity(){_classCallCheck(this,Productivity);return _possibleConstructorReturn(this,(Productivity.__proto__||Object.getPrototypeOf(Productivity)).apply(this,arguments));}_createClass(Productivity,[{key:'render',value:function render(){var year=(0,_moment2.default)(this.props.date).format('YYYY');var columns=[{title:'',dataIndex:'name',key:'name',align:"center",width:500,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'\u4ECA\u5E74YTD\u5E74\u7D2F\u8BA1',dataIndex:'now_year',key:'now_year',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"now_year",compared:{title:['\u4ECA\u5E74YTD\u5E74\u7D2F\u8BA1'],record:record,sqlName:"_7_7_index"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'\u53BB\u5E74YTD\u5E74\u7D2F\u8BA1',dataIndex:'last_year',key:'last_year',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_year",compared:{title:['\u53BB\u5E74YTD\u5E74\u7D2F\u8BA1'],record:record,sqlName:"_7_7_index"}};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"Variance",dataIndex:'variance',key:'variance',align:"center",width:300,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"variance",compared:{title:['Variance'],record:record,sqlName:"_7_7_index"}};return _react2.default.createElement(_TableText2.default,{data:props});}}];var _props=this.props,data=_props.data,data7_1=_props.data7_1,dataSource=_props.dataSource;return _react2.default.createElement(_table2.default,{style:{marginTop:20},columns:columns,dataSource:compute(data,data7_1,dataSource),size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record){return record.name;}});}}]);return Productivity;}(_react.Component);exports.default=Productivity;function compute(data,data7_1,dataSource){dataSource=dataSource&&dataSource.length>0?[].concat(_toConsumableArray(dataSource)):[].concat(defaultData);['now_year','last_year'].forEach(function(name){var name7_1=name=='now_year'?"year_thisy_payroll_cost":'year_lasty_payroll_cost';dataSource[0][name]=(0,_method.calculation)((0,_method2.default)([5,name],data),(0,_method.sum)([(0,_method2.default)([16,name7_1],data7_1),(0,_method2.default)([19,name7_1],data7_1)]));dataSource[1][name]=(0,_method.calculation)((0,_method2.default)([7,name],data),(0,_method.sum)([(0,_method2.default)([17,name7_1],data7_1),(0,_method2.default)([36,name],data)]));dataSource[2][name]=(0,_method.calculation)((0,_method2.default)([6,name],data),(0,_method.sum)([(0,_method2.default)([28,name],data),(0,_method2.default)([18,name7_1],data7_1)]));});dataSource.forEach(function(item,i){dataSource[i].variance=(0,_method.calculation)(dataSource[i].now_year-dataSource[i].last_year,dataSource[i].last_year,4);});return dataSource;}

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getChart=undefined;var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _method=__webpack_require__(20);var _analysis=__webpack_require__(125);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var correspondData7_7={// 19: 1,
20:2,21:3,27:5,28:6,29:7,35:9,36:10,37:11,43:13,44:14,45:15,51:17,52:18,53:19,60:21,62:22,63:23};var getChart=exports.getChart=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(year){var _ref2,_ref2$data,_ref2$data$data,data,_ref2$data$fb,fb,_ref2$data$room,room,total,dataX;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_request2.default)('/chartData7_8?year='+year);case 2:_ref2=_context.sent;_ref2$data=_ref2.data;_ref2$data$data=_ref2$data.data;data=_ref2$data$data===undefined?[]:_ref2$data$data;_ref2$data$fb=_ref2$data.fb;fb=_ref2$data$fb===undefined?[]:_ref2$data$fb;_ref2$data$room=_ref2$data.room;room=_ref2$data$room===undefined?[]:_ref2$data$room;total=_ref2$data.total;dataX=new Array(12).fill(1).map(function(x,i){return i+1+'\u6708';});(0,_analysis.setKarte)({id:"row1",title:"酒店整体人效指数",color:['#00C5BD','#42585D','#FE5F5F'],yAxis:{min:0,interval:0.5,max:5},dataX:dataX,dataY:[{name:"今年",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.find(function(_x){return _x.month==i+1;}),'now_year',0)).toFixed(2);})},{name:"去年",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(data.find(function(_x){return _x.month==i+1;}),'last_year',0)).toFixed(2);})},{name:"预算",data:dataX.map(function(x,i){return(0,_method.numConvert)(total).toFixed(2);})}]});(0,_analysis.setKarte)({id:"row2",title:"F&B人效指数",color:['#00C5BD','#42585D','#FE5F5F'],yAxis:{min:0,interval:1,max:10},dataX:dataX,dataY:[{name:"今年",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(fb.find(function(_x){return _x.month==i+1;}),'now_year',0)).toFixed(2);})},{name:"去年",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(fb.find(function(_x){return _x.month==i+1;}),'last_year',0)).toFixed(2);})}]});(0,_analysis.setKarte)({id:"row3",title:"Rooms人效指数",color:['#00C5BD','#42585D','#FE5F5F'],yAxis:{min:0,interval:1,max:10},dataX:dataX,dataY:[{name:"今年",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(room.find(function(_x){return _x.month==i+1;}),'now_year',0)).toFixed(2);})},{name:"去年",data:dataX.map(function(x,i){return(0,_method.numConvert)(_lodash2.default.get(room.find(function(_x){return _x.month==i+1;}),'last_year',0)).toFixed(2);})}]});case 15:case'end':return _context.stop();}}},_callee,undefined);}));return function getChart(_x2){return _ref.apply(this,arguments);};}();exports.default=function(_ref3){var data=_ref3.data,date=_ref3.date,data7_7=_ref3.data7_7;var month=(0,_moment2.default)(date).format('M');data[19].now_year=month;data[19].last_year=month;Object.entries(correspondData7_7).forEach(function(item){data[item[0]].now_year=_lodash2.default.get(data7_7,item[1]+'.actual');data[item[0]].last_year=_lodash2.default.get(data7_7,item[1]+'.last');});return data;};

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(2006);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Chart=function(_Component){_inherits(Chart,_Component);function Chart(){_classCallCheck(this,Chart);return _possibleConstructorReturn(this,(Chart.__proto__||Object.getPrototypeOf(Chart)).apply(this,arguments));}_createClass(Chart,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"t7_5-chart"},_react2.default.createElement("div",{id:"row1",className:"t7_2-chart-content first"}),_react2.default.createElement("div",{id:"row2",className:"t7_2-chart-content"}),_react2.default.createElement("div",{id:"row3",className:"t7_2-chart-content"}));}}]);return Chart;}(_react.Component);exports.default=Chart;

/***/ }),
/* 2006 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(25);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2008);var _compute=__webpack_require__(2009);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _=__webpack_require__(2010);var _2=_interopRequireDefault(_);var _3=__webpack_require__(2011);var _4=_interopRequireDefault(_3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Table3 from "./8-1-3";
var MonthPicker=_datePicker2.default.MonthPicker;var TextArea=_input2.default.TextArea;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var getJson=function getJson(arr,obj){var value=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;return arr.reduce(function(a,b){return a&&a[b]?a[b]:value;},obj);};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){data.forEach(function(item,i){data[i].cma_thisyear_average=(numConvert(data[i].cma_thisyear_consumption)==0?0:numConvert(data[i].cma_thisyear_cost)/numConvert(data[i].cma_thisyear_consumption)).toFixed(2);data[i].cma_lastyear_average=(numConvert(data[i].cma_lastyear_consumption)==0?0:numConvert(data[i].cma_lastyear_cost)/numConvert(data[i].cma_lastyear_consumption)).toFixed(2);data[i].cma_lastyear_lastmonth_average=(numConvert(data[i].cma_lastyear_lastmonth_consumption)==0?0:numConvert(data[i].cma_lastyear_lastmonth_cost)/numConvert(data[i].cma_lastyear_lastmonth_consumption)).toFixed(2);data[i].cmv_comparison_consumption=(numConvert(data[i].cma_thisyear_consumption)-numConvert(data[i].cma_lastyear_consumption)).toFixed(2);data[i].cmv_comparison_consumption_percent=(numConvert(data[i].cma_lastyear_consumption)==0?0:numConvert(data[i].cmv_comparison_consumption)/numConvert(data[i].cma_lastyear_consumption)).toFixed(3);data[i].cmv_comparison_average=(numConvert(data[i].cma_thisyear_average)-numConvert(data[i].cma_lastyear_average)).toFixed(2);data[i].cmv_comparison_average_percent=(numConvert(data[i].cma_lastyear_average)==0?0:numConvert(data[i].cmv_comparison_average)/numConvert(data[i].cma_lastyear_average)).toFixed(3);data[i].cmv_comparison_cost=(numConvert(data[i].cma_thisyear_cost)-numConvert(data[i].cma_lastyear_cost)).toFixed(2);data[i].cmv_comparison_cost_percent=(numConvert(data[i].cma_lastyear_cost)==0?0:numConvert(data[i].cmv_comparison_cost)/numConvert(data[i].cma_lastyear_cost)).toFixed(3);data[i].ytda_thisyear_average=(numConvert(data[i].ytda_thisyear_consumption)==0?0:numConvert(data[i].ytda_thisyear_cost)/numConvert(data[i].ytda_thisyear_consumption)).toFixed(2);data[i].ytda_lastyear_average=(numConvert(data[i].ytda_lastyear_consumption)==0?0:numConvert(data[i].ytda_lastyear_cost)/numConvert(data[i].ytda_lastyear_consumption)).toFixed(2);data[i].ytdv_comparison_consumption=(numConvert(data[i].ytda_thisyear_consumption)-numConvert(data[i].ytda_lastyear_consumption)).toFixed(2);data[i].ytdv_comparison_consumption_percent=(numConvert(data[i].ytda_lastyear_consumption)==0?0:numConvert(data[i].ytdv_comparison_consumption)/numConvert(data[i].ytda_lastyear_consumption)).toFixed(3);data[i].ytdv_comparison_average=(numConvert(data[i].ytda_thisyear_average)-numConvert(data[i].ytda_lastyear_average)).toFixed(2);data[i].ytdv_comparison_average_percent=(numConvert(data[i].ytda_lastyear_average)==0?0:numConvert(data[i].ytdv_comparison_average)/numConvert(data[i].ytda_lastyear_average)).toFixed(3);data[i].ytdv_comparison_cost=(numConvert(data[i].ytda_thisyear_cost)-numConvert(data[i].ytda_lastyear_cost)).toFixed(2);data[i].ytdv_comparison_cost_percent=(numConvert(data[i].ytda_lastyear_cost)==0?0:numConvert(data[i].ytdv_comparison_cost)/numConvert(data[i].ytda_lastyear_cost)).toFixed(3);//  新增 Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月
data[i].ytdv_lastmonth_comparison_consumption=(numConvert(data[i].cma_thisyear_consumption)-numConvert(data[i].cma_lastyear_lastmonth_consumption)).toFixed(2);data[i].ytdv_lastmonth_comparison_consumption_percent=(numConvert(data[i].cma_lastyear_lastmonth_consumption)==0?0:numConvert(data[i].ytdv_lastmonth_comparison_consumption)/numConvert(data[i].cma_lastyear_lastmonth_consumption)).toFixed(3);data[i].ytdv_lastmonth_comparison_average=(numConvert(data[i].cma_thisyear_average)-numConvert(data[i].cma_lastyear_lastmonth_average)).toFixed(2);data[i].ytdv_lastmonth_comparison_average_percent=(numConvert(data[i].cma_lastyear_lastmonth_average)==0?0:numConvert(data[i].ytdv_lastmonth_comparison_average)/numConvert(data[i].cma_lastyear_lastmonth_average)).toFixed(3);data[i].ytdv_lastmonth_comparison_cost=(numConvert(data[i].cma_thisyear_cost)-numConvert(data[i].cma_lastyear_lastmonth_cost)).toFixed(2);data[i].ytdv_lastmonth_comparison_cost_percent=(numConvert(data[i].cma_lastyear_lastmonth_cost)==0?0:numConvert(data[i].ytdv_lastmonth_comparison_cost)/numConvert(data[i].cma_lastyear_lastmonth_cost)).toFixed(3);});_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getTable8_1=function(date){var dataBegin=JSON.stringify(_data.data8_1_default);var data=JSON.parse(dataBegin);var dataBegin2=JSON.stringify(_data.data8_1_2);var data2=JSON.parse(dataBegin2);var dataBegin3=JSON.stringify(_data.data8_1_3);var data3=JSON.parse(dataBegin3);var dataBegin4=JSON.stringify(_data.data8_2_1);var data4=JSON.parse(dataBegin4);_this.getNote(date);_this.getNote8_2(date);fetch('/_8_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data8_1&&x.data.data8_1.length>0){data=x.data.data8_1;}if(x.data.data8_1_2&&x.data.data8_1_2.length>0){data2=x.data.data8_1_2;}if(x.data.data8_1_3&&x.data.data8_1_3.length>0){data3=x.data.data8_1_3;}if(x.data.data8_2_1&&x.data.data8_2_1.length>0){data4=x.data.data8_2_1;}// 从5.1.1获取人数总计
data3[3].cma_thisyear_consumption=getJson([13,'covers'],x.data.data5_1||[],0);data3[3].cma_lastyear_lastmonth_consumption=getJson([13,'covers'],x.data.dataLast5_1||[],0);data3[3].cma_lastyear_consumption=getJson([13,'covers'],x.data.dataYear5_1||[],0);// 从1.1获取出租客房间夜数
data2[2].cma_thisyear_consumption=getJson([1,'actual'],x.data.data1_1||[],0);data2[2].cma_lastyear_lastmonth_consumption=getJson([1,'actual'],x.data.dataLast1_1||[],0);data2[2].cma_lastyear_consumption=getJson([1,'actual'],x.data.dataYear1_1||[],0);data2[2].ytda_thisyear_consumption=getJson([1,'year_actual'],x.data.data1_1||[],0);data2[2].ytda_lastyear_consumption=getJson([1,'year_actual'],x.data.dataYear1_1||[],0);_this.computeNum(data);_this.computeNum8_2(data4);_this.setState({loading:false,data8_1_2:(0,_compute.compute8_1_2)(data2),data8_1_3:(0,_compute.compute8_1_3)(data3)});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.computeNum8_2=function(data){data.forEach(function(item,i){data[i].lastYear_fee=(numConvert(item.year_now_actual)-numConvert(item.lastYear_now_actual)).toFixed(2);data[i].lastYear_percent=(numConvert(item.lastYear_now_actual)==0?0:numConvert(item.lastYear_fee)/numConvert(item.lastYear_now_actual)).toFixed(4);data[i].year_fee=(numConvert(item.year_now_actual)-numConvert(item.year_last_actual)).toFixed(2);data[i].year_percent=(numConvert(item.year_last_actual)==0?0:numConvert(item.year_fee)/numConvert(item.year_last_actual)).toFixed(4);data[i].last_fee=(numConvert(item.year_actual)-numConvert(item.lastYear_actual)).toFixed(2);data[i].last_percent=(numConvert(item.lastYear_actual)==0?0:numConvert(item.last_fee)/numConvert(item.lastYear_actual)).toFixed(4);});_this.setState({data8_2_1:data});};_this.getNote=function(date){fetch('/_8_1_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){_this.setState({note:_extends({},x.data[0])});}else{_this.setState({note:{note:""}});}}).catch(function(err){console.error(err);});};_this.getNote8_2=function(date){fetch('/_8_2_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){_this.setState({note8_2:_extends({},x.data[0])});}else{_this.setState({note8_2:{comments:""}});}}).catch(function(err){console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var data8_1_2=_this.state.data8_1_2.map(function(x){return _extends({},x,{year:year,month:month});});var data8_1_3=_this.state.data8_1_3.map(function(x){return _extends({},x,{year:year,month:month});});var data8_2_1=_this.state.data8_2_1.map(function(x){return _extends({},x,{year:year,month:month});});if(!data[0].squmareMeter||data[0].squmareMeter==0){_message3.default.error('酒店平方米不能为空！');var _timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer);},1000);return;}var dataFrom=new FormData();dataFrom.append('data',JSON.stringify({data:data,data8_1_2:data8_1_2,data8_1_3:data8_1_3,data8_2_1:data8_2_1}));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};if(_this.state.note){_this.onSaveNote([_extends({},_this.state.note,{month:month,year:year})]);}if(_this.state.note8_2){_this.onSaveNote8_2([_extends({},_this.state.note8_2,{month:month,year:year})]);}fetch('/add_8_1',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id||!data8_1_2[0].id||!data8_1_3[0].id){_this.getTable8_1(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){_message3.default.error('保存失败'+JSON.stringify(err));var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);});};_this.onChangeChild=function(name,data){};_this.onSaveNote=function(data){var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_8_1_1',headres).then(function(x){return x.json();}).then(function(x){if(x.status==1){// message.success(x.msg);
return;}_message3.default.error('备注保存失败：'+x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.onSaveNote8_2=function(data){var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_8_2',headres).then(function(x){return x.json();}).then(function(x){if(x.status==1){// message.success(x.msg);
return;}_message3.default.error('备注保存失败：'+x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table8',1.5,'8.00',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,note:{note:""},note8_2:{comments:""},loadingSave:false,print:false,data8_1_2:[],data8_1_3:[],data8_2_1:[]};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getTable8_1(this.state.date);}// 获取表格8-1的内容
// 获取表格8-1-1的内容
// 获取表格8-2的内容
},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var columns=[{title:'Utility Item 能源项目',dataIndex:'utility_item',key:'utility_item',align:"center",fixed:"left",width:300,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':''),style:{textAlign:"left"}},text);}},{title:'Current Month 本年当月',align:"center",children:[{align:"center",title:'Current Month Actual - This Year 本年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,' Consumption ',_react2.default.createElement('br',null),' \u6D88\u8017\u91CF '),dataIndex:'cma_thisyear_consumption',key:'cma_thisyear_consumption',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Actual - This Year 本年当月实际数','Consumption 消耗量'];if(index>=0&&index<=3){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_thisyear_consumption',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('cma_thisyear_consumption',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_thisyear_consumption',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,' Average Unit Price ',_react2.default.createElement('br',null),' \u5E73\u5747\u5355\u4EF7 '),dataIndex:'cma_thisyear_average',key:'cma_thisyear_average',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Actual - This Year 本年当月实际数','Average Unit Price 平均单价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_thisyear_average',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,' Cost  ',_react2.default.createElement('br',null),' \u6210\u672C\u8D39\u7528 '),dataIndex:'cma_thisyear_cost',key:'cma_thisyear_cost',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Actual - This Year 本年当月实际数','Cost 成本费用'];if(index==4){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_thisyear_cost',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_thisyear_cost',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('cma_thisyear_cost',value,index);}})));}}}]},{align:"center",title:'Last Month Actual - Current Year 本年上月实际数',width:450,children:[{title:_react2.default.createElement('div',null,' Consumption ',_react2.default.createElement('br',null),' \u6D88\u8017\u91CF '),dataIndex:'cma_lastyear_lastmonth_consumption',key:'cma_lastyear_lastmonth_consumption',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Last Month Actual - Current Year 本年上月实际数','Consumption 消耗量'];if(index>=0&&index<=3){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_lastmonth_consumption',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('cma_lastyear_lastmonth_consumption',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_lastmonth_consumption',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,' Average Unit Price ',_react2.default.createElement('br',null),' \u5E73\u5747\u5355\u4EF7 '),dataIndex:'cma_lastyear_lastmonth_average',key:'cma_lastyear_lastmonth_average',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Last Month Actual - Current Year 本年上月实际数','Average Unit Price 平均单价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_lastmonth_average',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,' Cost  ',_react2.default.createElement('br',null),' \u6210\u672C\u8D39\u7528 '),dataIndex:'cma_lastyear_lastmonth_cost',key:'cma_lastyear_lastmonth_cost',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Last Month Actual - Current Year 本年上月实际数','Cost 成本费用'];if(index==4){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_lastmonth_cost',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_lastmonth_cost',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('cma_lastyear_lastmonth_cost',value,index);}})));}}}]},{align:"center",title:'Current Month Actual - Last Year 去年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,' Consumption ',_react2.default.createElement('br',null),' \u6D88\u8017\u91CF '),dataIndex:'cma_lastyear_consumption',key:'cma_lastyear_consumption',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Actual - Last Year 去年当月实际数','Consumption 消耗量'];if(index>=0&&index<=3){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_consumption',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('cma_lastyear_consumption',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_consumption',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,' Average Unit Price ',_react2.default.createElement('br',null),' \u5E73\u5747\u5355\u4EF7 '),dataIndex:'cma_lastyear_average',key:'cma_lastyear_average',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Actual - Last Year 去年当月实际数','Average Unit Price 平均单价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_average',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,' Cost  ',_react2.default.createElement('br',null),' \u6210\u672C\u8D39\u7528 '),dataIndex:'cma_lastyear_cost',key:'cma_lastyear_cost',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Actual - Last Year 去年当月实际数','Cost 成本费用'];if(index==4){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_cost',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_cost',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('cma_lastyear_cost',value,index);}})));}}}]},{align:"center",title:'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年',width:900,children:[{title:_react2.default.createElement('div',null,'Consumption  ',_react2.default.createElement('br',null),'\u6D88\u8017\u91CF'),dataIndex:'cmv_comparison_consumption',key:'cmv_comparison_consumption',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年','Consumption 消耗量'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cmv_comparison_consumption',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding  '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'cmv_comparison_consumption_percent',key:'cmv_comparison_consumption_percent',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cmv_comparison_consumption_percent',title:title,sqlName:"_8_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Average Unit Price',_react2.default.createElement('br',null),'\u5E73\u5747\u5355\u4EF7'),dataIndex:'cmv_comparison_average',key:'cmv_comparison_average',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年','Average Unit Price 平均单价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cmv_comparison_average',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'cmv_comparison_average_percent',align:"center",key:'cmv_comparison_average_percent',width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cmv_comparison_average_percent',title:title,sqlName:"_8_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost ',_react2.default.createElement('br',null),'\u6210\u672C\u8D39\u7528'),dataIndex:'cmv_comparison_cost',key:'cmv_comparison_cost',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年','Cost 成本费用'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cmv_comparison_cost',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'cmv_comparison_cost_percent',key:'cmv_comparison_cost_percent',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cmv_comparison_cost_percent',title:title,sqlName:"_8_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding  '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]}]},{title:'YTD 年累计',align:"center",width:1650,children:[{align:"center",title:'YTD Actual - This Year 年累计实际 - 今年',width:450,children:[{title:_react2.default.createElement('div',null,'Consumption  ',_react2.default.createElement('br',null),'\u6D88\u8017\u91CF'),dataIndex:'ytda_thisyear_consumption',key:'ytda_thisyear_consumption',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - This Year 年累计实际 - 今年','Consumption 消耗量'];if(index>=0&&index<=3){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_thisyear_consumption',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('ytda_thisyear_consumption',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_thisyear_consumption',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Average Unit Price',_react2.default.createElement('br',null),'\u5E73\u5747\u5355\u4EF7'),dataIndex:'ytda_thisyear_average',key:'ytda_thisyear_average',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - This Year 年累计实际 - 今年','Average Unit Price 平均单价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_thisyear_average',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Cost ',_react2.default.createElement('br',null),'\u6210\u672C\u8D39\u7528'),dataIndex:'ytda_thisyear_cost',key:'ytda_thisyear_cost',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - This Year 年累计实际 - 今年','Cost 成本费用'];if(index==4){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_thisyear_cost',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_thisyear_cost',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('ytda_thisyear_cost',value,index);},onCha:true})));}}}]},{align:"center",title:'YTD Actual - Last Year 年累计实际 - 去年',width:450,children:[{title:_react2.default.createElement('div',null,'Consumption  ',_react2.default.createElement('br',null),'\u6D88\u8017\u91CF'),dataIndex:'ytda_lastyear_consumption',key:'ytda_lastyear_consumption',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - Last Year 年累计实际 - 去年','Consumption 消耗量'];if(index>=0&&index<=3){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_lastyear_consumption',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('ytda_lastyear_consumption',value,index);},onCha:true})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_lastyear_consumption',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Average Unit Price',_react2.default.createElement('br',null),'\u5E73\u5747\u5355\u4EF7'),dataIndex:'ytda_lastyear_average',key:'ytda_lastyear_average',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - Last Year 年累计实际 - 去年','Average Unit Price 平均单价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_lastyear_average',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Cost ',_react2.default.createElement('br',null),'\u6210\u672C\u8D39\u7528'),dataIndex:'ytda_lastyear_cost',key:'ytda_lastyear_cost',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - Last Year 年累计实际 - 去年','Cost 成本费用'];if(index==4){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_lastyear_cost',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_lastyear_cost',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('ytda_lastyear_cost',value,index);}})));}}}]},{align:"center",title:'Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月',width:750,children:[{title:_react2.default.createElement('div',null,'Consumption ',_react2.default.createElement('br',null),'\u6D88\u8017\u91CF'),dataIndex:'ytdv_lastmonth_comparison_consumption',key:'ytdv_lastmonth_comparison_consumption',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月','Consumption 消耗量'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_lastmonth_comparison_consumption',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding  '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'ytdv_lastmonth_comparison_consumption_percent',key:'ytdv_lastmonth_comparison_consumption_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_lastmonth_comparison_consumption_percent',title:title,sqlName:"_8_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Average Unit Price',_react2.default.createElement('br',null),'\u5E73\u5747\u5355\u4EF7'),dataIndex:'ytdv_lastmonth_comparison_average',key:'ytdv_lastmonth_comparison_average',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月','Average Unit Price 平均单价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_lastmonth_comparison_average',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'ytdv_lastmonth_comparison_average_percent',align:"center",key:'ytdv_lastmonth_comparison_average_percent',width:150,render:function render(text,record,index){var title=['YTD 年累计','Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_lastmonth_comparison_average_percent',title:title,sqlName:"_8_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost ',_react2.default.createElement('br',null),'\u6210\u672C\u8D39\u7528'),dataIndex:'ytdv_lastmonth_comparison_cost',key:'ytdv_lastmonth_comparison_cost',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月','Cost 成本费用'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_lastmonth_comparison_cost',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'ytdv_lastmonth_comparison_cost_percent',align:"center",key:'ytdv_lastmonth_comparison_cost_percent',width:150,render:function render(text,record,index){var title=['YTD 年累计','Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_lastmonth_comparison_cost_percent',title:title,sqlName:"_8_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]},{align:"center",title:'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',width:750,children:[{title:_react2.default.createElement('div',null,'Consumption ',_react2.default.createElement('br',null),'\u6D88\u8017\u91CF'),dataIndex:'ytdv_comparison_consumption',key:'ytdv_comparison_consumption',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','Consumption 消耗量'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_comparison_consumption',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding  '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'ytdv_comparison_consumption_percent',key:'ytdv_comparison_consumption_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_comparison_consumption_percent',title:title,sqlName:"_8_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Average Unit Price',_react2.default.createElement('br',null),'\u5E73\u5747\u5355\u4EF7'),dataIndex:'ytdv_comparison_average',key:'ytdv_comparison_average',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','Average Unit Price 平均单价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_comparison_average',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'ytdv_comparison_average_percent',align:"center",key:'ytdv_comparison_average_percent',width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_comparison_average_percent',title:title,sqlName:"_8_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost ',_react2.default.createElement('br',null),'\u6210\u672C\u8D39\u7528'),dataIndex:'ytdv_comparison_cost',key:'ytdv_comparison_cost',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','Cost 成本费用'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_comparison_cost',title:title,sqlName:"_8_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'ytdv_comparison_cost_percent',align:"center",key:'ytdv_comparison_cost_percent',width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_comparison_cost_percent',title:title,sqlName:"_8_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==4?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]}]}];var squmareMeterStyle={float:"right",fontSize:16};var squmareInputStyle={marginLeft:10,width:120};return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table8',style:{width:this.state.print?5300:'auto'}},_react2.default.createElement(_row2.default,{style:{marginBottom:20,fontSize:24}},'8.0 Utility Cost Trend Analysis \u80FD\u6E90\u6210\u672C\u8D8B\u52BF\u5206\u6790'),_react2.default.createElement(_row2.default,null,'8.1.1 Total Hotel Engergy consumption \u9152\u5E97\u603B\u80FD\u8017\u7EDF\u8BA1'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){var _this2$setState;_this2.setState((_this2$setState={date:str,data:[],note:{note:""},note8_2:{comments:""},loading:true},_defineProperty(_this2$setState,'note',{note:""}),_defineProperty(_this2$setState,'data8_1_2',[]),_defineProperty(_this2$setState,'data8_1_3',[]),_defineProperty(_this2$setState,'data8_2_1',[]),_this2$setState));_this2.getTable8_1(str);}}),_react2.default.createElement(_row2.default,{style:squmareMeterStyle},'\u9152\u5E97\u5E73\u65B9\u7C73 :',!this.state.loading?_react2.default.createElement(_Compared2.default,{data:{index:0,key:'squmareMeter',title:[],sqlName:"_8_1",name:"酒店平方米",type:'number'}},_react2.default.createElement(_input2.default,{defaultValue:data[0]?Number(data[0].squmareMeter):"",style:squmareInputStyle,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('squmareMeter',value,0);}})):null,' m\xB2')),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',style:{width:this.state.print?5250:'auto'},scroll:this.state.print?{}:{x:5250},rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_row2.default,{style:{margin:"20px 0"}},_react2.default.createElement(_row2.default,{style:{margin:"10px 0"}},'8.1.4  Please critique if variance above +/- 5% \u82E5\u5DEE\u5F02\u6570\u8D85\u8FC7\u4E0A\u4E0B\u767E\u5206\u4E4B\u4E94\u5219\u9700\u505A\u51FA\u4E66\u9762\u89E3\u91CA'),!this.state.loading||this.state.print?_react2.default.createElement(TextArea,{autosize:{minRows:4},placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',defaultValue:this.state.note.note,onBlur:function onBlur(e){_this2.setState({note:_extends({},_this2.state.note,{note:e.target.value})});}}):null),_react2.default.createElement(_row2.default,{style:{margin:"20px 0"}},_react2.default.createElement(_row2.default,{style:{margin:"10px 0"}},'8.1.5 Utility Conservation Measures \u80FD\u6E90\u63A7\u5236\u63AA\u65BD'),!this.state.loading||this.state.print?_react2.default.createElement(TextArea,{autosize:{minRows:4},placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',defaultValue:this.state.note8_2.comments,onBlur:function onBlur(e){_this2.setState({note8_2:_extends({},_this2.state.note8_2,{comments:e.target.value})});}}):null),_react2.default.createElement(_4.default,{onChange:this.computeNum8_2,date:this.state.date,data:this.state.data8_2_1})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_8_1'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data8_1_default=exports.data8_1_default=[{utility_item:'Electricity 电能 (KWH 千瓦时)',//name
cma_thisyear_consumption:0,// Consumption 消耗量
cma_thisyear_average:"",//Average Unit Price 平均单价
cma_thisyear_cost:0,//Cost 成本费用
cma_lastyear_consumption:0,//Consumption 消耗量
cma_lastyear_average:"",//Average Unit Price 平均单价
cma_lastyear_cost:0,//Cost 成本费用
cmv_comparison_consumption:"",//Consumption 消耗量
cmv_comparison_consumption_percent:"",//% 百分比
cmv_comparison_average:"",//Average Unit Price 平均单价
cmv_comparison_average_percent:"",//% 百分比
cmv_comparison_cost:"",//Cost 成本费用
cmv_comparison_cost_percent:"",//% 百分比
ytda_thisyear_consumption:0,//Consumption 消耗量
ytda_thisyear_average:"",//Average Unit Price 平均单价
ytda_thisyear_cost:0,//Cost 成本费用
ytda_lastyear_consumption:0,//Consumption 消耗量
ytda_lastyear_average:"",//Average Unit Price 平均单价
ytda_lastyear_cost:0,//Cost 成本费用
ytdv_comparison_consumption:"",//Consumption 消耗量
ytdv_comparison_consumption_percent:"",//% 百分比
ytdv_comparison_average:"",//Average Unit Price 平均单价
ytdv_comparison_average_percent:"",//% 百分比
ytdv_comparison_cost:"",//Cost 成本费用、 
ytdv_comparison_cost_percent:"",//Cost 成本费用百分比
cma_lastyear_lastmonth_consumption:0,cma_lastyear_lastmonth_average:0,cma_lastyear_lastmonth_cost:0,ytdv_lastmonth_comparison_consumption:0,ytdv_lastmonth_comparison_consumption_percent:0,ytdv_lastmonth_comparison_average:0,ytdv_lastmonth_comparison_average_percent:0,ytdv_lastmonth_comparison_cost:0,ytdv_lastmonth_comparison_cost_percent:0,squmareMeter:0},{utility_item:'Water 水 (m³ 立方)',cma_thisyear_consumption:0,cma_thisyear_average:"",cma_thisyear_cost:0,cma_lastyear_consumption:0,cma_lastyear_average:"",cma_lastyear_cost:0,cmv_comparison_consumption:"",cmv_comparison_consumption_percent:"",cmv_comparison_average:"",cmv_comparison_average_percent:"",cmv_comparison_cost:"",cmv_comparison_cost_percent:"",ytda_thisyear_consumption:0,ytda_thisyear_average:"",ytda_thisyear_cost:0,ytda_lastyear_consumption:0,ytda_lastyear_average:"",ytda_lastyear_cost:0,ytdv_comparison_consumption:"",ytdv_comparison_consumption_percent:"",ytdv_comparison_average:"",ytdv_comparison_average_percent:"",ytdv_comparison_cost:"",ytdv_comparison_cost_percent:"",//Cost 成本费用百分比
cma_lastyear_lastmonth_consumption:0,cma_lastyear_lastmonth_average:0,cma_lastyear_lastmonth_cost:0,ytdv_lastmonth_comparison_consumption:0,ytdv_lastmonth_comparison_consumption_percent:0,ytdv_lastmonth_comparison_average:0,ytdv_lastmonth_comparison_average_percent:0,ytdv_lastmonth_comparison_cost:0,ytdv_lastmonth_comparison_cost_percent:0,squmareMeter:0},{utility_item:'Gas 燃气 (m³ 立方)',cma_thisyear_consumption:0,cma_thisyear_average:"",cma_thisyear_cost:0,cma_lastyear_consumption:0,cma_lastyear_average:"",cma_lastyear_cost:0,cmv_comparison_consumption:"",cmv_comparison_consumption_percent:"",cmv_comparison_average:"",cmv_comparison_average_percent:"",cmv_comparison_cost:"",cmv_comparison_cost_percent:"",ytda_thisyear_consumption:0,ytda_thisyear_average:"",ytda_thisyear_cost:0,ytda_lastyear_consumption:0,ytda_lastyear_average:"",ytda_lastyear_cost:0,ytdv_comparison_consumption:"",ytdv_comparison_consumption_percent:"",ytdv_comparison_average:"",ytdv_comparison_average_percent:"",ytdv_comparison_cost:"",ytdv_comparison_cost_percent:"",//Cost 成本费用百分比
cma_lastyear_lastmonth_consumption:0,cma_lastyear_lastmonth_average:0,cma_lastyear_lastmonth_cost:0,ytdv_lastmonth_comparison_consumption:0,ytdv_lastmonth_comparison_consumption_percent:0,ytdv_lastmonth_comparison_average:0,ytdv_lastmonth_comparison_average_percent:0,ytdv_lastmonth_comparison_cost:0,ytdv_lastmonth_comparison_cost_percent:0,squmareMeter:0},{utility_item:'Others 其他',cma_thisyear_consumption:0,cma_thisyear_average:"",cma_thisyear_cost:0,cma_lastyear_consumption:0,cma_lastyear_average:"",cma_lastyear_cost:0,cmv_comparison_consumption:"",cmv_comparison_consumption_percent:"",cmv_comparison_average:"",cmv_comparison_average_percent:"",cmv_comparison_cost:"",cmv_comparison_cost_percent:"",ytda_thisyear_consumption:0,ytda_thisyear_average:"",ytda_thisyear_cost:0,ytda_lastyear_consumption:0,ytda_lastyear_average:"",ytda_lastyear_cost:0,ytdv_comparison_consumption:"",ytdv_comparison_consumption_percent:"",ytdv_comparison_average:"",ytdv_comparison_average_percent:"",ytdv_comparison_cost:"",ytdv_comparison_cost_percent:"",//Cost 成本费用百分比
cma_lastyear_lastmonth_consumption:0,cma_lastyear_lastmonth_average:0,cma_lastyear_lastmonth_cost:0,ytdv_lastmonth_comparison_consumption:0,ytdv_lastmonth_comparison_consumption_percent:0,ytdv_lastmonth_comparison_average:0,ytdv_lastmonth_comparison_average_percent:0,ytdv_lastmonth_comparison_cost:0,ytdv_lastmonth_comparison_cost_percent:0,squmareMeter:0}];var data8_1_2=exports.data8_1_2=[{utility_item:'Electricity 电能 (KWH 千瓦时)',//name
cma_thisyear_consumption:0,// Consumption 消耗量
cma_thisyear_average:"",//Average Unit Price 平均单价
cma_thisyear_cost:0,//Cost 成本费用
cma_lastyear_consumption:0,//Consumption 消耗量
cma_lastyear_average:"",//Average Unit Price 平均单价
cma_lastyear_cost:0,//Cost 成本费用
cmv_comparison_consumption:"",//Consumption 消耗量
cmv_comparison_consumption_percent:"",//% 百分比
cmv_comparison_average:"",//Average Unit Price 平均单价
cmv_comparison_average_percent:"",//% 百分比
cmv_comparison_cost:"",//Cost 成本费用
cmv_comparison_cost_percent:"",//% 百分比
ytda_thisyear_consumption:0,//Consumption 消耗量
ytda_thisyear_average:"",//Average Unit Price 平均单价
ytda_thisyear_cost:0,//Cost 成本费用
ytda_lastyear_consumption:0,//Consumption 消耗量
ytda_lastyear_average:"",//Average Unit Price 平均单价
ytda_lastyear_cost:0,//Cost 成本费用
ytdv_comparison_consumption:"",//Consumption 消耗量
ytdv_comparison_consumption_percent:"",//% 百分比
ytdv_comparison_average:"",//Average Unit Price 平均单价
ytdv_comparison_average_percent:"",//% 百分比
ytdv_comparison_cost:"",//Cost 成本费用
ytdv_comparison_cost_percent:"",//Cost 成本费用百分比
cma_lastyear_lastmonth_consumption:0,cma_lastyear_lastmonth_average:0,cma_lastyear_lastmonth_cost:0,ytdv_lastmonth_comparison_consumption:0,ytdv_lastmonth_comparison_consumption_percent:0,ytdv_lastmonth_comparison_average:0,ytdv_lastmonth_comparison_average_percent:0,ytdv_lastmonth_comparison_cost:0,ytdv_lastmonth_comparison_cost_percent:0},{utility_item:'Water 水 (m³ 立方)',cma_thisyear_consumption:0,cma_thisyear_average:"",cma_thisyear_cost:0,cma_lastyear_consumption:0,cma_lastyear_average:"",cma_lastyear_cost:0,cmv_comparison_consumption:"",cmv_comparison_consumption_percent:"",cmv_comparison_average:"",cmv_comparison_average_percent:"",cmv_comparison_cost:"",cmv_comparison_cost_percent:"",ytda_thisyear_consumption:0,ytda_thisyear_average:"",ytda_thisyear_cost:0,ytda_lastyear_consumption:0,ytda_lastyear_average:"",ytda_lastyear_cost:0,ytdv_comparison_consumption:"",ytdv_comparison_consumption_percent:"",ytdv_comparison_average:"",ytdv_comparison_average_percent:"",ytdv_comparison_cost:"",ytdv_comparison_cost_percent:"",//Cost 成本费用百分比
cma_lastyear_lastmonth_consumption:0,cma_lastyear_lastmonth_average:0,cma_lastyear_lastmonth_cost:0,ytdv_lastmonth_comparison_consumption:0,ytdv_lastmonth_comparison_consumption_percent:0,ytdv_lastmonth_comparison_average:0,ytdv_lastmonth_comparison_average_percent:0,ytdv_lastmonth_comparison_cost:0,ytdv_lastmonth_comparison_cost_percent:0},{utility_item:'Rooms Occupied 出租客房间夜数 （与1.1中数据同步）',cma_thisyear_consumption:0,cma_thisyear_average:"",cma_thisyear_cost:0,cma_lastyear_consumption:0,cma_lastyear_average:"",cma_lastyear_cost:0,cmv_comparison_consumption:"",cmv_comparison_consumption_percent:"",cmv_comparison_average:"",cmv_comparison_average_percent:"",cmv_comparison_cost:"",cmv_comparison_cost_percent:"",ytda_thisyear_consumption:0,ytda_thisyear_average:"",ytda_thisyear_cost:0,ytda_lastyear_consumption:0,ytda_lastyear_average:"",ytda_lastyear_cost:0,ytdv_comparison_consumption:"",ytdv_comparison_consumption_percent:"",ytdv_comparison_average:"",ytdv_comparison_average_percent:"",ytdv_comparison_cost:"",ytdv_comparison_cost_percent:"",//Cost 成本费用百分比
cma_lastyear_lastmonth_consumption:0,cma_lastyear_lastmonth_average:0,cma_lastyear_lastmonth_cost:0,ytdv_lastmonth_comparison_consumption:0,ytdv_lastmonth_comparison_consumption_percent:0,ytdv_lastmonth_comparison_average:0,ytdv_lastmonth_comparison_average_percent:0,ytdv_lastmonth_comparison_cost:0,ytdv_lastmonth_comparison_cost_percent:0},{utility_item:'Average electricity  consumption per guestroom <br/>每客房人均能源消耗量 （电能）(KWH 千瓦时)',cma_thisyear_consumption:0,cma_thisyear_average:"",cma_thisyear_cost:0,cma_lastyear_consumption:0,cma_lastyear_average:"",cma_lastyear_cost:0,cmv_comparison_consumption:"",cmv_comparison_consumption_percent:"",cmv_comparison_average:"",cmv_comparison_average_percent:"",cmv_comparison_cost:"",cmv_comparison_cost_percent:"",ytda_thisyear_consumption:0,ytda_thisyear_average:"",ytda_thisyear_cost:0,ytda_lastyear_consumption:0,ytda_lastyear_average:"",ytda_lastyear_cost:0,ytdv_comparison_consumption:"",ytdv_comparison_consumption_percent:"",ytdv_comparison_average:"",ytdv_comparison_average_percent:"",ytdv_comparison_cost:"",ytdv_comparison_cost_percent:"",//Cost 成本费用百分比
cma_lastyear_lastmonth_consumption:0,cma_lastyear_lastmonth_average:0,cma_lastyear_lastmonth_cost:0,ytdv_lastmonth_comparison_consumption:0,ytdv_lastmonth_comparison_consumption_percent:0,ytdv_lastmonth_comparison_average:0,ytdv_lastmonth_comparison_average_percent:0,ytdv_lastmonth_comparison_cost:0,ytdv_lastmonth_comparison_cost_percent:0},{utility_item:'Average water consumption per guestroom   <br/>每客房人均能源消耗量 （水） (m³ 立方)',cma_thisyear_consumption:0,cma_thisyear_average:"",cma_thisyear_cost:0,cma_lastyear_consumption:0,cma_lastyear_average:"",cma_lastyear_cost:0,cmv_comparison_consumption:"",cmv_comparison_consumption_percent:"",cmv_comparison_average:"",cmv_comparison_average_percent:"",cmv_comparison_cost:"",cmv_comparison_cost_percent:"",ytda_thisyear_consumption:0,ytda_thisyear_average:"",ytda_thisyear_cost:0,ytda_lastyear_consumption:0,ytda_lastyear_average:"",ytda_lastyear_cost:0,ytdv_comparison_consumption:"",ytdv_comparison_consumption_percent:"",ytdv_comparison_average:"",ytdv_comparison_average_percent:"",ytdv_comparison_cost:"",ytdv_comparison_cost_percent:"",//Cost 成本费用百分比
cma_lastyear_lastmonth_consumption:0,cma_lastyear_lastmonth_average:0,cma_lastyear_lastmonth_cost:0,ytdv_lastmonth_comparison_consumption:0,ytdv_lastmonth_comparison_consumption_percent:0,ytdv_lastmonth_comparison_average:0,ytdv_lastmonth_comparison_average_percent:0,ytdv_lastmonth_comparison_cost:0,ytdv_lastmonth_comparison_cost_percent:0}];var data8_1_3=exports.data8_1_3=[{utility_item:'Electricity 电能 (KWH 千瓦时)',//name
cma_thisyear_consumption:0,// Consumption 消耗量
cma_thisyear_average:"",//Average Unit Price 平均单价
cma_thisyear_cost:0,//Cost 成本费用
cma_lastyear_consumption:0,//Consumption 消耗量
cma_lastyear_average:"",//Average Unit Price 平均单价
cma_lastyear_cost:0,//Cost 成本费用
cmv_comparison_consumption:"",//Consumption 消耗量
cmv_comparison_consumption_percent:"",//% 百分比
cmv_comparison_average:"",//Average Unit Price 平均单价
cmv_comparison_average_percent:"",//% 百分比
cmv_comparison_cost:"",//Cost 成本费用
cmv_comparison_cost_percent:"",//% 百分比
ytda_thisyear_consumption:0,//Consumption 消耗量
ytda_thisyear_average:"",//Average Unit Price 平均单价
ytda_thisyear_cost:0,//Cost 成本费用
ytda_lastyear_consumption:0,//Consumption 消耗量
ytda_lastyear_average:"",//Average Unit Price 平均单价
ytda_lastyear_cost:0,//Cost 成本费用
ytdv_comparison_consumption:"",//Consumption 消耗量
ytdv_comparison_consumption_percent:"",//% 百分比
ytdv_comparison_average:"",//Average Unit Price 平均单价
ytdv_comparison_average_percent:"",//% 百分比
ytdv_comparison_cost:"",//Cost 成本费用
ytdv_comparison_cost_percent:"",//Cost 成本费用百分比
cma_lastyear_lastmonth_consumption:0,cma_lastyear_lastmonth_average:0,cma_lastyear_lastmonth_cost:0,ytdv_lastmonth_comparison_consumption:0,ytdv_lastmonth_comparison_consumption_percent:0,ytdv_lastmonth_comparison_average:0,ytdv_lastmonth_comparison_average_percent:0,ytdv_lastmonth_comparison_cost:0,ytdv_lastmonth_comparison_cost_percent:0},{utility_item:'Water 水 (m³ 立方)',cma_thisyear_consumption:0,cma_thisyear_average:"",cma_thisyear_cost:0,cma_lastyear_consumption:0,cma_lastyear_average:"",cma_lastyear_cost:0,cmv_comparison_consumption:"",cmv_comparison_consumption_percent:"",cmv_comparison_average:"",cmv_comparison_average_percent:"",cmv_comparison_cost:"",cmv_comparison_cost_percent:"",ytda_thisyear_consumption:0,ytda_thisyear_average:"",ytda_thisyear_cost:0,ytda_lastyear_consumption:0,ytda_lastyear_average:"",ytda_lastyear_cost:0,ytdv_comparison_consumption:"",ytdv_comparison_consumption_percent:"",ytdv_comparison_average:"",ytdv_comparison_average_percent:"",ytdv_comparison_cost:"",ytdv_comparison_cost_percent:"",//Cost 成本费用百分比
cma_lastyear_lastmonth_consumption:0,cma_lastyear_lastmonth_average:0,cma_lastyear_lastmonth_cost:0,ytdv_lastmonth_comparison_consumption:0,ytdv_lastmonth_comparison_consumption_percent:0,ytdv_lastmonth_comparison_average:0,ytdv_lastmonth_comparison_average_percent:0,ytdv_lastmonth_comparison_cost:0,ytdv_lastmonth_comparison_cost_percent:0},{utility_item:'Gas 燃气 (m³ 立方)',cma_thisyear_consumption:0,cma_thisyear_average:"",cma_thisyear_cost:0,cma_lastyear_consumption:0,cma_lastyear_average:"",cma_lastyear_cost:0,cmv_comparison_consumption:"",cmv_comparison_consumption_percent:"",cmv_comparison_average:"",cmv_comparison_average_percent:"",cmv_comparison_cost:"",cmv_comparison_cost_percent:"",ytda_thisyear_consumption:0,ytda_thisyear_average:"",ytda_thisyear_cost:0,ytda_lastyear_consumption:0,ytda_lastyear_average:"",ytda_lastyear_cost:0,ytdv_comparison_consumption:"",ytdv_comparison_consumption_percent:"",ytdv_comparison_average:"",ytdv_comparison_average_percent:"",ytdv_comparison_cost:"",ytdv_comparison_cost_percent:"",//Cost 成本费用百分比
cma_lastyear_lastmonth_consumption:0,cma_lastyear_lastmonth_average:0,cma_lastyear_lastmonth_cost:0,ytdv_lastmonth_comparison_consumption:0,ytdv_lastmonth_comparison_consumption_percent:0,ytdv_lastmonth_comparison_average:0,ytdv_lastmonth_comparison_average_percent:0,ytdv_lastmonth_comparison_cost:0,ytdv_lastmonth_comparison_cost_percent:0},{utility_item:'Covers of Outlet -F&B ( same as 5.1.1) <br/>餐饮就餐人数 （与5.1.1 同步）',cma_thisyear_consumption:0,cma_thisyear_average:"",cma_thisyear_cost:0,cma_lastyear_consumption:0,cma_lastyear_average:"",cma_lastyear_cost:0,cmv_comparison_consumption:"",cmv_comparison_consumption_percent:"",cmv_comparison_average:"",cmv_comparison_average_percent:"",cmv_comparison_cost:"",cmv_comparison_cost_percent:"",ytda_thisyear_consumption:0,ytda_thisyear_average:"",ytda_thisyear_cost:0,ytda_lastyear_consumption:0,ytda_lastyear_average:"",ytda_lastyear_cost:0,ytdv_comparison_consumption:"",ytdv_comparison_consumption_percent:"",ytdv_comparison_average:"",ytdv_comparison_average_percent:"",ytdv_comparison_cost:"",ytdv_comparison_cost_percent:"",//Cost 成本费用百分比
cma_lastyear_lastmonth_consumption:0,cma_lastyear_lastmonth_average:0,cma_lastyear_lastmonth_cost:0,ytdv_lastmonth_comparison_consumption:0,ytdv_lastmonth_comparison_consumption_percent:0,ytdv_lastmonth_comparison_average:0,ytdv_lastmonth_comparison_average_percent:0,ytdv_lastmonth_comparison_cost:0,ytdv_lastmonth_comparison_cost_percent:0},{utility_item:'Average electricity  consumption by kitchen <br/>厨房人均能源消耗量 （电能）(KWH 千瓦时)',cma_thisyear_consumption:0,cma_thisyear_average:"",cma_thisyear_cost:0,cma_lastyear_consumption:0,cma_lastyear_average:"",cma_lastyear_cost:0,cmv_comparison_consumption:"",cmv_comparison_consumption_percent:"",cmv_comparison_average:"",cmv_comparison_average_percent:"",cmv_comparison_cost:"",cmv_comparison_cost_percent:"",ytda_thisyear_consumption:0,ytda_thisyear_average:"",ytda_thisyear_cost:0,ytda_lastyear_consumption:0,ytda_lastyear_average:"",ytda_lastyear_cost:0,ytdv_comparison_consumption:"",ytdv_comparison_consumption_percent:"",ytdv_comparison_average:"",ytdv_comparison_average_percent:"",ytdv_comparison_cost:"",ytdv_comparison_cost_percent:"",//Cost 成本费用百分比
cma_lastyear_lastmonth_consumption:0,cma_lastyear_lastmonth_average:0,cma_lastyear_lastmonth_cost:0,ytdv_lastmonth_comparison_consumption:0,ytdv_lastmonth_comparison_consumption_percent:0,ytdv_lastmonth_comparison_average:0,ytdv_lastmonth_comparison_average_percent:0,ytdv_lastmonth_comparison_cost:0,ytdv_lastmonth_comparison_cost_percent:0},{utility_item:'Average water  consumption by kitchen <br/> 厨房人均能源消耗量 （水） (m³ 立方)',cma_thisyear_consumption:0,cma_thisyear_average:"",cma_thisyear_cost:0,cma_lastyear_consumption:0,cma_lastyear_average:"",cma_lastyear_cost:0,cmv_comparison_consumption:"",cmv_comparison_consumption_percent:"",cmv_comparison_average:"",cmv_comparison_average_percent:"",cmv_comparison_cost:"",cmv_comparison_cost_percent:"",ytda_thisyear_consumption:0,ytda_thisyear_average:"",ytda_thisyear_cost:0,ytda_lastyear_consumption:0,ytda_lastyear_average:"",ytda_lastyear_cost:0,ytdv_comparison_consumption:"",ytdv_comparison_consumption_percent:"",ytdv_comparison_average:"",ytdv_comparison_average_percent:"",ytdv_comparison_cost:"",ytdv_comparison_cost_percent:"",//Cost 成本费用百分比
cma_lastyear_lastmonth_consumption:0,cma_lastyear_lastmonth_average:0,cma_lastyear_lastmonth_cost:0,ytdv_lastmonth_comparison_consumption:0,ytdv_lastmonth_comparison_consumption_percent:0,ytdv_lastmonth_comparison_average:0,ytdv_lastmonth_comparison_average_percent:0,ytdv_lastmonth_comparison_cost:0,ytdv_lastmonth_comparison_cost_percent:0},{utility_item:'Average gas  consumption by kitchen <br/> 厨房人均能源消耗量 （燃气） (m³ 立方)',cma_thisyear_consumption:0,cma_thisyear_average:"",cma_thisyear_cost:0,cma_lastyear_consumption:0,cma_lastyear_average:"",cma_lastyear_cost:0,cmv_comparison_consumption:"",cmv_comparison_consumption_percent:"",cmv_comparison_average:"",cmv_comparison_average_percent:"",cmv_comparison_cost:"",cmv_comparison_cost_percent:"",ytda_thisyear_consumption:0,ytda_thisyear_average:"",ytda_thisyear_cost:0,ytda_lastyear_consumption:0,ytda_lastyear_average:"",ytda_lastyear_cost:0,ytdv_comparison_consumption:"",ytdv_comparison_consumption_percent:"",ytdv_comparison_average:"",ytdv_comparison_average_percent:"",ytdv_comparison_cost:"",ytdv_comparison_cost_percent:"",//Cost 成本费用百分比
cma_lastyear_lastmonth_consumption:0,cma_lastyear_lastmonth_average:0,cma_lastyear_lastmonth_cost:0,ytdv_lastmonth_comparison_consumption:0,ytdv_lastmonth_comparison_consumption_percent:0,ytdv_lastmonth_comparison_average:0,ytdv_lastmonth_comparison_average_percent:0,ytdv_lastmonth_comparison_cost:0,ytdv_lastmonth_comparison_cost_percent:0}];var data8_2_1=exports.data8_2_1=[{name:"8.2.1 Maintenance Material cost 维修材料费用统计",year_now_actual:0,year_last_actual:0,lastYear_now_actual:0,year_actual:0,lastYear_actual:0,lastYear_fee:0,lastYear_percent:0,year_fee:0,year_percent:0,last_fee:0,last_percent:0},{name:"8.2.2  Maintenance/ Testing cost 保养/检测费用统计",year_now_actual:0,year_last_actual:0,lastYear_now_actual:0,year_actual:0,lastYear_actual:0,lastYear_fee:0,lastYear_percent:0,year_fee:0,year_percent:0,last_fee:0,last_percent:0}];

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var compute8_1_2=exports.compute8_1_2=function compute8_1_2(data){var listName=['cma_thisyear_consumption','cma_thisyear_cost','cma_lastyear_lastmonth_consumption','cma_lastyear_lastmonth_cost','cma_lastyear_consumption','cma_lastyear_cost','ytda_thisyear_consumption','ytda_thisyear_cost','ytda_lastyear_consumption','ytda_lastyear_cost'];listName.forEach(function(name){var coverName=name.replace('cost','consumption');data[3][name]=(numConvert(data[2][coverName])==0?0:numConvert(data[0][name])/numConvert(data[2][coverName])).toFixed(2);data[4][name]=(numConvert(data[2][coverName])==0?0:numConvert(data[1][name])/numConvert(data[2][coverName])).toFixed(2);});data.forEach(function(item,i){data[i].cma_thisyear_average=(numConvert(data[i].cma_thisyear_consumption)==0?0:numConvert(data[i].cma_thisyear_cost)/numConvert(data[i].cma_thisyear_consumption)).toFixed(2);data[i].cma_lastyear_lastmonth_average=(numConvert(data[i].cma_lastyear_lastmonth_consumption)==0?0:numConvert(data[i].cma_lastyear_lastmonth_cost)/numConvert(data[i].cma_lastyear_lastmonth_consumption)).toFixed(2);data[i].cma_lastyear_average=(numConvert(data[i].cma_lastyear_consumption)==0?0:numConvert(data[i].cma_lastyear_cost)/numConvert(data[i].cma_lastyear_consumption)).toFixed(2);data[i].cmv_comparison_consumption=(numConvert(data[i].cma_thisyear_consumption)-numConvert(data[i].cma_lastyear_consumption)).toFixed(2);data[i].cmv_comparison_consumption_percent=(numConvert(data[i].cma_lastyear_consumption)==0?0:numConvert(data[i].cmv_comparison_consumption)/numConvert(data[i].cma_lastyear_consumption)).toFixed(3);data[i].cmv_comparison_average=(numConvert(data[i].cma_thisyear_average)-numConvert(data[i].cma_lastyear_average)).toFixed(2);data[i].cmv_comparison_average_percent=(numConvert(data[i].cma_lastyear_average)==0?0:numConvert(data[i].cmv_comparison_average)/numConvert(data[i].cma_lastyear_average)).toFixed(3);data[i].cmv_comparison_cost=(numConvert(data[i].cma_thisyear_cost)-numConvert(data[i].cma_lastyear_cost)).toFixed(2);data[i].cmv_comparison_cost_percent=(numConvert(data[i].cma_lastyear_cost)==0?0:numConvert(data[i].cmv_comparison_cost)/numConvert(data[i].cma_lastyear_cost)).toFixed(3);data[i].ytda_thisyear_average=(numConvert(data[i].ytda_thisyear_consumption)==0?0:numConvert(data[i].ytda_thisyear_cost)/numConvert(data[i].ytda_thisyear_consumption)).toFixed(2);data[i].ytda_lastyear_average=(numConvert(data[i].ytda_lastyear_consumption)==0?0:numConvert(data[i].ytda_lastyear_cost)/numConvert(data[i].ytda_lastyear_consumption)).toFixed(2);data[i].ytdv_comparison_consumption=(numConvert(data[i].ytda_thisyear_consumption)-numConvert(data[i].ytda_lastyear_consumption)).toFixed(2);data[i].ytdv_comparison_consumption_percent=(numConvert(data[i].ytda_lastyear_consumption)==0?0:numConvert(data[i].ytdv_comparison_consumption)/numConvert(data[i].ytda_lastyear_consumption)).toFixed(3);data[i].ytdv_comparison_average=(numConvert(data[i].ytda_thisyear_average)-numConvert(data[i].ytda_lastyear_average)).toFixed(2);data[i].ytdv_comparison_average_percent=(numConvert(data[i].ytda_lastyear_average)==0?0:numConvert(data[i].ytdv_comparison_average)/numConvert(data[i].ytda_lastyear_average)).toFixed(3);data[i].ytdv_comparison_cost=(numConvert(data[i].ytda_thisyear_cost)-numConvert(data[i].ytda_lastyear_cost)).toFixed(2);data[i].ytdv_comparison_cost_percent=(numConvert(data[i].ytda_lastyear_cost)==0?0:numConvert(data[i].ytdv_comparison_cost)/numConvert(data[i].ytda_lastyear_cost)).toFixed(3);//  新增 Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月
data[i].ytdv_lastmonth_comparison_consumption=(numConvert(data[i].cma_thisyear_consumption)-numConvert(data[i].cma_lastyear_lastmonth_consumption)).toFixed(2);data[i].ytdv_lastmonth_comparison_consumption_percent=(numConvert(data[i].cma_lastyear_lastmonth_consumption)==0?0:numConvert(data[i].ytdv_lastmonth_comparison_consumption)/numConvert(data[i].cma_lastyear_lastmonth_consumption)).toFixed(3);data[i].ytdv_lastmonth_comparison_average=(numConvert(data[i].cma_thisyear_average)-numConvert(data[i].cma_lastyear_lastmonth_average)).toFixed(2);data[i].ytdv_lastmonth_comparison_average_percent=(numConvert(data[i].cma_lastyear_lastmonth_average)==0?0:numConvert(data[i].ytdv_lastmonth_comparison_average)/numConvert(data[i].cma_lastyear_lastmonth_average)).toFixed(3);data[i].ytdv_lastmonth_comparison_cost=(numConvert(data[i].cma_thisyear_cost)-numConvert(data[i].cma_lastyear_lastmonth_cost)).toFixed(2);data[i].ytdv_lastmonth_comparison_cost_percent=(numConvert(data[i].cma_lastyear_lastmonth_cost)==0?0:numConvert(data[i].ytdv_lastmonth_comparison_cost)/numConvert(data[i].cma_lastyear_lastmonth_cost)).toFixed(3);});return data;};var compute8_1_3=exports.compute8_1_3=function compute8_1_3(data){var listName=['cma_thisyear_consumption','cma_thisyear_cost','cma_lastyear_lastmonth_consumption','cma_lastyear_lastmonth_cost','cma_lastyear_consumption','cma_lastyear_cost','ytda_thisyear_consumption','ytda_thisyear_cost','ytda_lastyear_consumption','ytda_lastyear_cost'];listName.forEach(function(name){var coverName=name.replace('cost','consumption');data[4][name]=(numConvert(data[3][coverName])==0?0:numConvert(data[0][name])/numConvert(data[3][coverName])).toFixed(2);data[5][name]=(numConvert(data[3][coverName])==0?0:numConvert(data[1][name])/numConvert(data[3][coverName])).toFixed(2);data[6][name]=(numConvert(data[3][coverName])==0?0:numConvert(data[2][name])/numConvert(data[3][coverName])).toFixed(2);});data.forEach(function(item,i){data[i].cma_thisyear_average=(numConvert(data[i].cma_thisyear_consumption)==0?0:numConvert(data[i].cma_thisyear_cost)/numConvert(data[i].cma_thisyear_consumption)).toFixed(2);data[i].cma_lastyear_lastmonth_average=(numConvert(data[i].cma_lastyear_lastmonth_consumption)==0?0:numConvert(data[i].cma_lastyear_lastmonth_cost)/numConvert(data[i].cma_lastyear_lastmonth_consumption)).toFixed(2);data[i].cma_lastyear_average=(numConvert(data[i].cma_lastyear_consumption)==0?0:numConvert(data[i].cma_lastyear_cost)/numConvert(data[i].cma_lastyear_consumption)).toFixed(2);data[i].cmv_comparison_consumption=(numConvert(data[i].cma_thisyear_consumption)-numConvert(data[i].cma_lastyear_consumption)).toFixed(2);data[i].cmv_comparison_consumption_percent=(numConvert(data[i].cma_lastyear_consumption)==0?0:numConvert(data[i].cmv_comparison_consumption)/numConvert(data[i].cma_lastyear_consumption)).toFixed(3);data[i].cmv_comparison_average=(numConvert(data[i].cma_thisyear_average)-numConvert(data[i].cma_lastyear_average)).toFixed(2);data[i].cmv_comparison_average_percent=(numConvert(data[i].cma_lastyear_average)==0?0:numConvert(data[i].cmv_comparison_average)/numConvert(data[i].cma_lastyear_average)).toFixed(3);data[i].cmv_comparison_cost=(numConvert(data[i].cma_thisyear_cost)-numConvert(data[i].cma_lastyear_cost)).toFixed(2);data[i].cmv_comparison_cost_percent=(numConvert(data[i].cma_lastyear_cost)==0?0:numConvert(data[i].cmv_comparison_cost)/numConvert(data[i].cma_lastyear_cost)).toFixed(3);data[i].ytda_thisyear_average=(numConvert(data[i].ytda_thisyear_consumption)==0?0:numConvert(data[i].ytda_thisyear_cost)/numConvert(data[i].ytda_thisyear_consumption)).toFixed(2);data[i].ytda_lastyear_average=(numConvert(data[i].ytda_lastyear_consumption)==0?0:numConvert(data[i].ytda_lastyear_cost)/numConvert(data[i].ytda_lastyear_consumption)).toFixed(2);data[i].ytdv_comparison_consumption=(numConvert(data[i].ytda_thisyear_consumption)-numConvert(data[i].ytda_lastyear_consumption)).toFixed(2);data[i].ytdv_comparison_consumption_percent=(numConvert(data[i].ytda_lastyear_consumption)==0?0:numConvert(data[i].ytdv_comparison_consumption)/numConvert(data[i].ytda_lastyear_consumption)).toFixed(3);data[i].ytdv_comparison_average=(numConvert(data[i].ytda_thisyear_average)-numConvert(data[i].ytda_lastyear_average)).toFixed(2);data[i].ytdv_comparison_average_percent=(numConvert(data[i].ytda_lastyear_average)==0?0:numConvert(data[i].ytdv_comparison_average)/numConvert(data[i].ytda_lastyear_average)).toFixed(3);data[i].ytdv_comparison_cost=(numConvert(data[i].ytda_thisyear_cost)-numConvert(data[i].ytda_lastyear_cost)).toFixed(2);data[i].ytdv_comparison_cost_percent=(numConvert(data[i].ytda_lastyear_cost)==0?0:numConvert(data[i].ytdv_comparison_cost)/numConvert(data[i].ytda_lastyear_cost)).toFixed(3);//  新增 Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月
data[i].ytdv_lastmonth_comparison_consumption=(numConvert(data[i].cma_thisyear_consumption)-numConvert(data[i].cma_lastyear_lastmonth_consumption)).toFixed(2);data[i].ytdv_lastmonth_comparison_consumption_percent=(numConvert(data[i].cma_lastyear_lastmonth_consumption)==0?0:numConvert(data[i].ytdv_lastmonth_comparison_consumption)/numConvert(data[i].cma_lastyear_lastmonth_consumption)).toFixed(3);data[i].ytdv_lastmonth_comparison_average=(numConvert(data[i].cma_thisyear_average)-numConvert(data[i].cma_lastyear_lastmonth_average)).toFixed(2);data[i].ytdv_lastmonth_comparison_average_percent=(numConvert(data[i].cma_lastyear_lastmonth_average)==0?0:numConvert(data[i].ytdv_lastmonth_comparison_average)/numConvert(data[i].cma_lastyear_lastmonth_average)).toFixed(3);data[i].ytdv_lastmonth_comparison_cost=(numConvert(data[i].cma_thisyear_cost)-numConvert(data[i].cma_lastyear_lastmonth_cost)).toFixed(2);data[i].ytdv_lastmonth_comparison_cost_percent=(numConvert(data[i].cma_lastyear_lastmonth_cost)==0?0:numConvert(data[i].ytdv_lastmonth_comparison_cost)/numConvert(data[i].cma_lastyear_lastmonth_cost)).toFixed(3);});return data;};

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.onChange=function(name,value,i){var data=_this.props.data;data[i][name]=value;_this.props.onChange('data8_1_2',data);};_this.state={date:props.date,data:[],loading:true,note:{note:""},note8_2:{comments:""},loadingSave:false,print:false};return _this;}_createClass(index,[{key:'render',value:function render(){var _this2=this;var data=this.props.data;var columns=[{title:'Utility Item 能源项目',dataIndex:'utility_item',key:'utility_item',align:"center",fixed:"left",width:400,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding',style:{textAlign:"left"},dangerouslySetInnerHTML:{__html:text||"-"}});}},{title:'Current Month 本年当月',align:"center",children:[{align:"center",title:'Current Month Actual - This Year 本年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,' Consumption ',_react2.default.createElement('br',null),' \u6D88\u8017\u91CF '),dataIndex:'cma_thisyear_consumption',key:'cma_thisyear_consumption',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Actual - This Year 本年当月实际数','Consumption 消耗量'];// 人数单独两列
if(index==2){return{children:_react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_thisyear_consumption',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','))),props:{colSpan:3}};}if(index>=0&&index<2){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_thisyear_consumption',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('cma_thisyear_consumption',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_thisyear_consumption',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,' Average Unit Price ',_react2.default.createElement('br',null),' \u5E73\u5747\u5355\u4EF7 '),dataIndex:'cma_thisyear_average',key:'cma_thisyear_average',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Actual - This Year 本年当月实际数','Average Unit Price 平均单价'];if(index==2){return{props:{colSpan:0}};}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_thisyear_average',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,' Cost  ',_react2.default.createElement('br',null),' \u6210\u672C\u8D39\u7528 '),dataIndex:'cma_thisyear_cost',key:'cma_thisyear_cost',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Actual - This Year 本年当月实际数','Cost 成本费用'];if(index==2){return{props:{colSpan:0}};}if(index==4||index==3){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_thisyear_cost',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_thisyear_cost',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('cma_thisyear_cost',value,index);}})));}}}]},{align:"center",title:'Last Month Actual - Current Year 本年上月实际数',width:450,children:[{title:_react2.default.createElement('div',null,' Consumption ',_react2.default.createElement('br',null),' \u6D88\u8017\u91CF '),dataIndex:'cma_lastyear_lastmonth_consumption',key:'cma_lastyear_lastmonth_consumption',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Last Month Actual - Current Year 本年上月实际数','Consumption 消耗量'];// 人数单独两列
if(index==2){return{children:_react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_lastmonth_consumption',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','))),props:{colSpan:3}};}if(index>=0&&index<=2){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_lastmonth_consumption',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('cma_lastyear_lastmonth_consumption',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_lastmonth_consumption',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,' Average Unit Price ',_react2.default.createElement('br',null),' \u5E73\u5747\u5355\u4EF7 '),dataIndex:'cma_lastyear_lastmonth_average',key:'cma_lastyear_lastmonth_average',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Last Month Actual - Current Year 本年上月实际数','Average Unit Price 平均单价'];if(index==2){return{props:{colSpan:0}};}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_lastmonth_average',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,' Cost  ',_react2.default.createElement('br',null),' \u6210\u672C\u8D39\u7528 '),dataIndex:'cma_lastyear_lastmonth_cost',key:'cma_lastyear_lastmonth_cost',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Last Month Actual - Current Year 本年上月实际数','Cost 成本费用'];if(index==2){return{props:{colSpan:0}};}if(index==4||index==3){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_lastmonth_cost',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_lastmonth_cost',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('cma_lastyear_lastmonth_cost',value,index);}})));}}}]},{align:"center",title:'Current Month Actual - Last Year 去年当月实际数',width:450,children:[{title:_react2.default.createElement('div',null,' Consumption ',_react2.default.createElement('br',null),' \u6D88\u8017\u91CF '),dataIndex:'cma_lastyear_consumption',key:'cma_lastyear_consumption',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Actual - Last Year 去年当月实际数','Consumption 消耗量'];// 人数单独两列
if(index==2){return{children:_react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_consumption',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','))),props:{colSpan:3}};}if(index>=0&&index<=2){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_consumption',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('cma_lastyear_consumption',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_consumption',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,' Average Unit Price ',_react2.default.createElement('br',null),' \u5E73\u5747\u5355\u4EF7 '),dataIndex:'cma_lastyear_average',key:'cma_lastyear_average',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Actual - Last Year 去年当月实际数','Average Unit Price 平均单价'];if(index==2){return{props:{colSpan:0}};}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_average',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,' Cost  ',_react2.default.createElement('br',null),' \u6210\u672C\u8D39\u7528 '),dataIndex:'cma_lastyear_cost',key:'cma_lastyear_cost',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Actual - Last Year 去年当月实际数','Cost 成本费用'];if(index==2){return{props:{colSpan:0}};}if(index==4||index==3){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_cost',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cma_lastyear_cost',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('cma_lastyear_cost',value,index);}})));}}}]},{align:"center",title:'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年',width:900,children:[{title:_react2.default.createElement('div',null,'Consumption  ',_react2.default.createElement('br',null),'\u6D88\u8017\u91CF'),dataIndex:'cmv_comparison_consumption',key:'cmv_comparison_consumption',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年','Consumption 消耗量'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cmv_comparison_consumption',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'cmv_comparison_consumption_percent',key:'cmv_comparison_consumption_percent',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cmv_comparison_consumption_percent',title:title,sqlName:"_8_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Average Unit Price',_react2.default.createElement('br',null),'\u5E73\u5747\u5355\u4EF7'),dataIndex:'cmv_comparison_average',key:'cmv_comparison_average',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年','Average Unit Price 平均单价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cmv_comparison_average',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'cmv_comparison_average_percent',align:"center",key:'cmv_comparison_average_percent',width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cmv_comparison_average_percent',title:title,sqlName:"_8_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost ',_react2.default.createElement('br',null),'\u6210\u672C\u8D39\u7528'),dataIndex:'cmv_comparison_cost',key:'cmv_comparison_cost',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年','Cost 成本费用'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cmv_comparison_cost',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'cmv_comparison_cost_percent',key:'cmv_comparison_cost_percent',align:"center",width:150,render:function render(text,record,index){var title=['Current Month 本年当月','Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'cmv_comparison_cost_percent',title:title,sqlName:"_8_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]}]},{title:'YTD 年累计',align:"center",width:1650,children:[{align:"center",title:'YTD Actual - This Year 年累计实际 - 今年',width:450,children:[{title:_react2.default.createElement('div',null,'Consumption  ',_react2.default.createElement('br',null),'\u6D88\u8017\u91CF'),dataIndex:'ytda_thisyear_consumption',key:'ytda_thisyear_consumption',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - This Year 年累计实际 - 今年','Consumption 消耗量'];// 人数单独两列
if(index==2){return{children:_react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_thisyear_consumption',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','))),props:{colSpan:3}};}if(index>=0&&index<=2){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_thisyear_consumption',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('ytda_thisyear_consumption',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_thisyear_consumption',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Average Unit Price',_react2.default.createElement('br',null),'\u5E73\u5747\u5355\u4EF7'),dataIndex:'ytda_thisyear_average',key:'ytda_thisyear_average',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - This Year 年累计实际 - 今年','Average Unit Price 平均单价'];if(index==2){return{props:{colSpan:0}};}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_thisyear_average',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Cost ',_react2.default.createElement('br',null),'\u6210\u672C\u8D39\u7528'),dataIndex:'ytda_thisyear_cost',key:'ytda_thisyear_cost',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - This Year 年累计实际 - 今年','Cost 成本费用'];if(index==2){return{props:{colSpan:0}};}if(index==4||index==3){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_thisyear_cost',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_thisyear_cost',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('ytda_thisyear_cost',value,index);},onCha:true})));}}}]},{align:"center",title:'YTD Actual - Last Year 年累计实际 - 去年',width:450,children:[{title:_react2.default.createElement('div',null,'Consumption  ',_react2.default.createElement('br',null),'\u6D88\u8017\u91CF'),dataIndex:'ytda_lastyear_consumption',key:'ytda_lastyear_consumption',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - Last Year 年累计实际 - 去年','Consumption 消耗量'];// 人数单独两列
if(index==2){return{children:_react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_lastyear_consumption',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','))),props:{colSpan:3}};}if(index>=0&&index<=2){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_lastyear_consumption',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('ytda_lastyear_consumption',value,index);},onCha:true})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_lastyear_consumption',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Average Unit Price',_react2.default.createElement('br',null),'\u5E73\u5747\u5355\u4EF7'),dataIndex:'ytda_lastyear_average',key:'ytda_lastyear_average',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - Last Year 年累计实际 - 去年','Average Unit Price 平均单价'];if(index==2){return{props:{colSpan:0}};}return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_lastyear_average',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Cost ',_react2.default.createElement('br',null),'\u6210\u672C\u8D39\u7528'),dataIndex:'ytda_lastyear_cost',key:'ytda_lastyear_cost',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual - Last Year 年累计实际 - 去年','Cost 成本费用'];if(index==2){return{props:{colSpan:0}};}if(index==4||index==3){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_lastyear_cost',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytda_lastyear_cost',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('ytda_lastyear_cost',value,index);}})));}}}]},{align:"center",title:'Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月',width:750,children:[{title:_react2.default.createElement('div',null,'Consumption ',_react2.default.createElement('br',null),'\u6D88\u8017\u91CF'),dataIndex:'ytdv_lastmonth_comparison_consumption',key:'ytdv_lastmonth_comparison_consumption',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月','Consumption 消耗量'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_lastmonth_comparison_consumption',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'ytdv_lastmonth_comparison_consumption_percent',key:'ytdv_lastmonth_comparison_consumption_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_lastmonth_comparison_consumption_percent',title:title,sqlName:"_8_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Average Unit Price',_react2.default.createElement('br',null),'\u5E73\u5747\u5355\u4EF7'),dataIndex:'ytdv_lastmonth_comparison_average',key:'ytdv_lastmonth_comparison_average',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月','Average Unit Price 平均单价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_lastmonth_comparison_average',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'ytdv_lastmonth_comparison_average_percent',align:"center",key:'ytdv_lastmonth_comparison_average_percent',width:150,render:function render(text,record,index){var title=['YTD 年累计','Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_lastmonth_comparison_average_percent',title:title,sqlName:"_8_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost ',_react2.default.createElement('br',null),'\u6210\u672C\u8D39\u7528'),dataIndex:'ytdv_lastmonth_comparison_cost',key:'ytdv_lastmonth_comparison_cost',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月','Cost 成本费用'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_lastmonth_comparison_cost',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'ytdv_lastmonth_comparison_cost_percent',align:"center",key:'ytdv_lastmonth_comparison_cost_percent',width:150,render:function render(text,record,index){var title=['YTD 年累计','Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_lastmonth_comparison_cost_percent',title:title,sqlName:"_8_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]},{align:"center",title:'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',width:750,children:[{title:_react2.default.createElement('div',null,'Consumption ',_react2.default.createElement('br',null),'\u6D88\u8017\u91CF'),dataIndex:'ytdv_comparison_consumption',key:'ytdv_comparison_consumption',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','Consumption 消耗量'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_comparison_consumption',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'ytdv_comparison_consumption_percent',key:'ytdv_comparison_consumption_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_comparison_consumption_percent',title:title,sqlName:"_8_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Average Unit Price',_react2.default.createElement('br',null),'\u5E73\u5747\u5355\u4EF7'),dataIndex:'ytdv_comparison_average',key:'ytdv_comparison_average',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','Average Unit Price 平均单价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_comparison_average',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'ytdv_comparison_average_percent',align:"center",key:'ytdv_comparison_average_percent',width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_comparison_average_percent',title:title,sqlName:"_8_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}},{title:_react2.default.createElement('div',null,'Cost ',_react2.default.createElement('br',null),'\u6210\u672C\u8D39\u7528'),dataIndex:'ytdv_comparison_cost',key:'ytdv_comparison_cost',align:"center",width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','Cost 成本费用'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_comparison_cost',title:title,sqlName:"_8_1_2",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'ytdv_comparison_cost_percent',align:"center",key:'ytdv_comparison_cost_percent',width:150,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'ytdv_comparison_cost_percent',title:title,sqlName:"_8_1_2",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding'},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]}]}];return _react2.default.createElement('div',{style:{margin:"20px 0"}},_react2.default.createElement(_row2.default,{style:{width:this.props.print?5400:'auto'}},_react2.default.createElement(_row2.default,null,'8.1.2  Energy Consumption - Guestroom Area  \u5BA2\u623F\u533A\u57DF\u80FD\u8017\u7EDF\u8BA1'),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',style:{width:this.props.print?5350:'auto'},scroll:this.props.print?{}:{x:5350},rowKey:function rowKey(record,index){return index;}})));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.onChange=function(name,value,i){var data=_this.props.data;data[i][name]=value;_this.props.onChange(data);};_this.state={date:props.date,data:[],loading:true,note:{note:""},note8_2:{comments:""},loadingSave:false,print:false};return _this;}_createClass(index,[{key:'render',value:function render(){var _this2=this;var data=this.props.data;var width=document.body.offsetWidth>2050?document.body.offsetWidth-1650:400;var columns=[{title:'Cost of Maintenance 维修费用统计',dataIndex:'name',key:'name',align:"center",fixed:"left",width:width,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding ',style:{textAlign:"left"}},text);}},{title:_react2.default.createElement('div',null,' Current Month Actual ',_react2.default.createElement('br',null),' This Year \u672C\u5E74\u5F53\u6708\u5B9E\u9645\u6570 '),children:[{title:"RMB 费用（元）",dataIndex:'year_now_actual',key:'year_now_actual',align:"center",width:150,render:function render(text,record,index){var title=['Current Month Actual This Year 本年当月实际数','RMB 费用（元）'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_now_actual',title:title,sqlName:"_8_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('year_now_actual',value,index);}})));}}]},{title:_react2.default.createElement('div',null,'Last Month Actual - Current Year',_react2.default.createElement('br',null),' \u672C\u5E74\u4E0A\u6708\u5B9E\u9645\u6570 '),children:[{title:"RMB 费用（元）",dataIndex:'year_last_actual',key:'year_last_actual',align:"center",width:150,render:function render(text,record,index){var title=['Last Month Actual - Current Year 本年上月实际数','RMB 费用（元）'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_last_actual',title:title,sqlName:"_8_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('year_last_actual',value,index);}})));}}]},{title:_react2.default.createElement('div',null,' Current Month Actual - Last Year ',_react2.default.createElement('br',null),'   \u53BB\u5E74\u5F53\u6708\u5B9E\u9645\u6570 '),children:[{title:"RMB 费用（元）",dataIndex:'lastYear_now_actual',key:'lastYear_now_actual',align:"center",width:150,render:function render(text,record,index){var title=['Current Month Actual - Last Year 去年当月实际数','RMB 费用（元）'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lastYear_now_actual',title:title,sqlName:"_8_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('lastYear_now_actual',value,index);}})));}}]},{title:_react2.default.createElement('div',null,' YTD Actual - This Year ',_react2.default.createElement('br',null),'\u5E74\u7D2F\u8BA1\u5B9E\u9645 - \u4ECA\u5E74 '),children:[{title:"RMB 费用（元）",dataIndex:'year_actual',key:'year_actual',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - This Year 年累计实际 - 今年','RMB 费用（元）'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_actual',title:title,sqlName:"_8_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('year_actual',value,index);}})));}}]},{title:_react2.default.createElement('div',null,' YTD Actual - Last Year ',_react2.default.createElement('br',null),' \u5E74\u7D2F\u8BA1\u5B9E\u9645 - \u53BB\u5E74 '),children:[{title:"RMB 费用（元）",dataIndex:'lastYear_actual',key:'lastYear_actual',align:"center",width:150,render:function render(text,record,index){var title=['YTD Actual - Last Year 年累计实际 - 去年','RMB 费用（元）'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lastYear_actual',title:title,sqlName:"_8_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('lastYear_actual',value,index);}})));}}]},{title:_react2.default.createElement('div',null,' Current Month Variance - This Year vs. Last Year  ',_react2.default.createElement('br',null),' \u5F53\u6708\u5DEE\u5F02 - \u4ECA\u5E74\u5BF9\u6BD4\u53BB\u5E74 '),children:[{title:"RMB 费用（元）",dataIndex:'lastYear_fee',key:'lastYear_fee',align:"center",width:150,render:function render(text,record,index){var title=['Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年','RMB 费用（元）'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lastYear_fee',title:title,sqlName:"_8_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:"% 百分比",dataIndex:'lastYear_percent',key:'lastYear_percent',align:"center",width:150,render:function render(text,record,index){var title=['Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'lastYear_percent',title:title,sqlName:"_8_2_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]},{title:_react2.default.createElement('div',null,' Month Variance - This month vs. Last month  ',_react2.default.createElement('br',null),' \u6708\u5EA6\u5DEE\u5F02 - \u4ECA\u5E74\u5F53\u6708\u5BF9\u6BD4\u4ECA\u5E74\u4E0A\u6708 '),children:[{title:"RMB 费用（元）",dataIndex:'year_fee',key:'year_fee',align:"center",width:150,render:function render(text,record,index){var title=['Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月','RMB 费用（元）'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_fee',title:title,sqlName:"_8_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:"% 百分比",dataIndex:'year_percent',key:'year_percent',align:"center",width:150,render:function render(text,record,index){var title=['Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_percent',title:title,sqlName:"_8_2_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]},{title:_react2.default.createElement('div',null,' YTD Variance - This Year vs. Last Year   ',_react2.default.createElement('br',null),' \u5E74\u7D2F\u8BA1\u5DEE\u5F02 - \u4ECA\u5E74\u5BF9\u6BD4\u53BB\u5E74 '),children:[{title:"RMB 费用（元）",dataIndex:'last_fee',key:'last_fee',align:"center",width:150,render:function render(text,record,index){var title=['YTD Variance - This Year vs. Last Year  年累计差异 - 今年对比去年','RMB 费用（元）'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'last_fee',title:title,sqlName:"_8_2_1",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:"% 百分比",dataIndex:'last_percent',key:'last_percent',align:"center",width:150,render:function render(text,record,index){var title=['YTD Variance - This Year vs. Last Year  年累计差异 - 今年对比去年','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'last_percent',title:title,sqlName:"_8_2_1",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]}];return _react2.default.createElement('div',{style:{margin:"20px 0"}},_react2.default.createElement(_row2.default,{style:{width:this.props.print?2050:'auto',maxWidth:2050}},_react2.default.createElement(_row2.default,null,'8.2 Cost of Maintenance \u7EF4\u4FEE\u8D39\u7528\u7EDF\u8BA1'),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',style:{width:this.props.print?2050:'auto'},scroll:this.props.print?{}:{x:2050},rowKey:function rowKey(record,index){return index;}})));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(25);__webpack_require__(35);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2013);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var totalName=['Adjusted','Debit','Credit'];var _loop=function _loop(i){data[i].Current=totalName.reduce(function(a,b,index){a+=numConvert(data[i][b]);return a;},0);data[i].Current=numConvert(data[i].Current).toFixed(2);};for(var i=0;i<data.length;i++){_loop(i);}_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data3_2_1);var data=JSON.parse(dataBegin);fetch('/_9_1_all?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.dataNow&&x.data.dataNow.length>0){data=x.data.dataNow;}if(x.data.datalast&&x.data.datalast.length>0){var datalast=x.data.datalast;data=data.map(function(v,i){return _extends({},v,{Adjusted:datalast[i].Current||"0"});});}_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});// if (!data.every(x => x.name)) {
//     message.error('名称不能为空，请到3-1-1设置名称！');
//     return
// }
var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_9_1',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table9_1',1.5,'9.10',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);// this.computeNum(this.state.data)
}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var width=document.body.offsetWidth-2150>300?document.body.offsetWidth-2150:300;var columns=[{title:'Account Name 账户名',dataIndex:'name',key:'name',align:"center",render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding ',style:{textAlign:"left"}},text);}},{title:_react2.default.createElement('div',null,'Adjusted Balance of Last Month ',_react2.default.createElement('br',null),'\u671F\u521D\u6570'),dataIndex:'Adjusted',key:'Adjusted',align:"center",render:function render(text,record,index){return(// <div className="table-padding table-color-number">
//     <InputNumber
//         formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
//         parser={value => value.replace(/\$\s?|(,*)/g, '')}
//         precision={2}
//         className="table_numInput"
//         defaultValue={Number(text || "0") || ''}
//         onBlur={(e) => {
//             let value = Number(e.target.value.replace(/,/g, '') || '0');
//             value = Number(value.toFixed(2));
//             this.onChange('Adjusted', value, index)
//         }}
//     />
// </div>
_react2.default.createElement('div',{className:'table-padding '},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Debit ',_react2.default.createElement('br',null),'\u501F\u8BB0/\u672C\u671F\u589E\u52A0'),dataIndex:'Debit',key:'Debit',align:"center",render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Debit',value,index);}}));}},{title:_react2.default.createElement('div',null,'Credit ',_react2.default.createElement('br',null),'\u8D37\u8BB0/\u672C\u671F\u51CF\u5C11'),dataIndex:'Credit',key:'Credit',align:"center",render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:Number(text||"0")||'',onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('Credit',value,index);}}));}},{title:_react2.default.createElement('div',null,'Balance of Current Month ',_react2.default.createElement('br',null),'\u671F\u672B\u6570'),dataIndex:'Current',key:'Current',align:"center",render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '},Number(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:_react2.default.createElement('div',null,'GM/DOF Comments ',_react2.default.createElement('br',null),' \u8D22\u52A1\u603B\u76D1\u5907\u6CE8'),dataIndex:'Comments',key:'Comments',align:"center",render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";_this2.onChange('Comments',value,index);}}));}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table9_1'},_react2.default.createElement(_row2.default,null,'9.1 Balance Sheet \u8D44\u4EA7\u8D1F\u503A\u8868'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_9_1'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165PDF'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data3_2_1=exports.data3_2_1=[{name:'Cash 现金',name_code:'Cash',Adjusted:'0',Debit:'0',Credit:'0',Current:'0',Comments:''},{name:'Bank Deposit 银行存款',name_code:'Bank_Deposit',Adjusted:'0',Debit:'0',Credit:'0',Current:'0',Comments:''},{name:'Account Receivable 应收账款',name_code:'Account_Receivable',Adjusted:'0',Debit:'0',Credit:'0',Current:'0',Comments:''},{name:'Inventories 存货',name_code:'Inventories',Adjusted:'0',Debit:'0',Credit:'0',Current:'0',Comments:''},{name:'Account Payable 应付账款',name_code:'Account_Payable',Adjusted:'0',Debit:'0',Credit:'0',Current:'0',Comments:''},{name:'Payroll Payable 应付职工薪酬',name_code:'Payroll_Payable',Adjusted:'0',Debit:'0',Credit:'0',Current:'0',Comments:''},{name:'Taxes  Payable 应付税金',name_code:'Taxes_Payable',Adjusted:'0',Debit:'0',Credit:'0',Current:'0',Comments:''}];

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(25);__webpack_require__(60);__webpack_require__(35);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(2015);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2016);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var nameData=['zeroDay','threeDay','sixDay','nineDay','overDay','totalDay'];data[0].totalDay=nameData.reduce(function(a,b){if(b!='totalDay'){a+=numConvert(data[0][b]);}return a;},0);data[0].totalDay=data[0].totalDay.toFixed(0);var percentData=['zeroPercent','threePercent','sixPercent','ninePercent','overPercent','totalPercent'];for(var i=0;i<6;i++){data[0][percentData[i]]=(numConvert(data[0].totalDay)==0?0:numConvert(data[0][nameData[i]])/numConvert(data[0].totalDay)).toFixed(3);}return data;};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data3_2_1);var data=JSON.parse(dataBegin);_this.getTitle(date);fetch('/_9_2_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}_this.setState({data:data});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.getTitle=function(date){var dataBegin=JSON.stringify(_data.data9_2);var data=JSON.parse(dataBegin);fetch('/_9_2_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}_this.setState({data9:data,loading:false});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(_this.state.data9[0].day<=0){_message3.default.error('请填写周转天数！');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};_this.onSaveTitle();fetch('/add_9_2',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.onSaveTitle=function(){var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data9.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_9_2_1',headres).then(function(x){return x.json();}).then(function(x){if(x.status==1){return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table9_2',1.5,'9.20',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],data9:[{}],loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var data9=this.state.data9;return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1 receivable'},_react2.default.createElement(_row2.default,{className:'title',id:'table9_2'},_react2.default.createElement(_row2.default,null,'9.2 Accounts Receivable \u5E94\u6536\u8D26\u6B3E '),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}}),_react2.default.createElement('span',{style:{marginLeft:10,fontSize:16}},'\u6CE8:\u53EA\u9700\u586B\u4E0A5\u4E07\u4EE5\u4E0A\u7684\u5E94\u6536\u6B3E')),this.state.loading&&!this.state.print?null:_react2.default.createElement('div',null,_react2.default.createElement('div',{className:'receive-row',style:{marginTop:20}},_react2.default.createElement('div',{className:'row-left'},'Days of Credit Sales Outstanding (DCSO) \u5468\u8F6C\u5929\u6570'),_react2.default.createElement('div',{className:'row-right'},_react2.default.createElement(_row2.default,null,_react2.default.createElement(_Compared2.default,{data:{index:0,key:'day',title:[''],sqlName:"_9_2_1",name:'Days of Credit Sales Outstanding (DCSO) 周转天数',type:'number'}},_react2.default.createElement(_col2.default,{span:8,style:{padding:"0 10px"},className:'border-right-input'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',style:{width:'100%',marginTop:5},defaultValue:Number(data9[0].day||'0')||'',onBlur:function onBlur(e){var data9=_this2.state.data9;var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));data9[0].day=value;_this2.setState({data9:data9});}}))),_react2.default.createElement(_col2.default,{span:16})))),_react2.default.createElement('div',{className:'receive-row'},_react2.default.createElement('div',{className:'row-left'},'Aging \u8D26\u9F84'),_react2.default.createElement('div',{className:'row-right'},_react2.default.createElement(_row2.default,{style:{textAlign:"center"}},_react2.default.createElement(_col2.default,{span:4,className:'border-right-background'},'0-30Days'),_react2.default.createElement(_col2.default,{span:4,className:'border-right-background'},'31-60Days'),_react2.default.createElement(_col2.default,{span:4,className:'border-right-background'},'61-90Days'),_react2.default.createElement(_col2.default,{span:4,className:'border-right-background'},'91-120Days'),_react2.default.createElement(_col2.default,{span:4,className:'border-right-background'},'Over 120 Days'),_react2.default.createElement(_col2.default,{span:4,className:'border-right-background'},'Total Balance')))),_react2.default.createElement('div',{className:'receive-row'},_react2.default.createElement('div',{className:'row-left'},'Amount \u91D1\u989D'),_react2.default.createElement('div',{className:'row-right'},_react2.default.createElement(_row2.default,{style:{textAlign:"center"}},_react2.default.createElement(_col2.default,{span:4,className:'border-right-input'},_react2.default.createElement(_Compared2.default,{data:{index:0,key:'zeroDay',title:['0-30Days'],sqlName:"_9_2_1",name:'Amount 金额',type:'number'}},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(data9[0].zeroDay||'0')||'',onBlur:function onBlur(e){var data9=_this2.state.data9;var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));data9[0].zeroDay=value;data9=_this2.computeNum(data9);_this2.setState({data9:data9});}}))),_react2.default.createElement(_col2.default,{span:4,className:'border-right-input'},_react2.default.createElement(_Compared2.default,{data:{index:0,key:'threeDay',title:['31-60Days'],sqlName:"_9_2_1",name:'Amount 金额',type:'number'}},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(data9[0].threeDay||'0')||'',onBlur:function onBlur(e){var data9=_this2.state.data9;var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));data9[0].threeDay=value;data9=_this2.computeNum(data9);_this2.setState({data9:data9});}}))),_react2.default.createElement(_col2.default,{span:4,className:'border-right-input'},_react2.default.createElement(_Compared2.default,{data:{index:0,key:'sixDay',title:['61-90Days'],sqlName:"_9_2_1",name:'Amount 金额',type:'number'}},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(data9[0].sixDay||'0')||'',onBlur:function onBlur(e){var data9=_this2.state.data9;var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));data9[0].sixDay=value;data9=_this2.computeNum(data9);_this2.setState({data9:data9});}}))),_react2.default.createElement(_col2.default,{span:4,className:'border-right-input'},_react2.default.createElement(_Compared2.default,{data:{index:0,key:'nineDay',title:['91-120Days'],sqlName:"_9_2_1",name:'Amount 金额',type:'number'}},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(data9[0].nineDay||'0')||'',onBlur:function onBlur(e){var data9=_this2.state.data9;var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));data9[0].nineDay=value;data9=_this2.computeNum(data9);_this2.setState({data9:data9});}}))),_react2.default.createElement(_col2.default,{span:4,className:'border-right-input'},_react2.default.createElement(_Compared2.default,{data:{index:0,key:'overDay',title:['Over 120 Days'],sqlName:"_9_2_1",name:'Amount 金额',type:'number'}},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(data9[0].overDay||'0')||'',onBlur:function onBlur(e){var data9=_this2.state.data9;var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));data9[0].overDay=value;data9=_this2.computeNum(data9);_this2.setState({data9:data9});}}))),_react2.default.createElement(_col2.default,{span:4,className:'border-right'},_react2.default.createElement(_Compared2.default,{data:{index:0,key:'totalDay',title:['Total Balance'],sqlName:"_9_2_1",name:'Amount 金额',type:'number'}},Math.abs(Number(data9[0].totalDay||"0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')))))),_react2.default.createElement('div',{className:'receive-row'},_react2.default.createElement('div',{className:'row-left'},'% \u767E\u5206\u6BD4'),_react2.default.createElement('div',{className:'row-right'},_react2.default.createElement(_row2.default,{style:{textAlign:"center"}},_react2.default.createElement(_col2.default,{span:4,className:'border-right'},_react2.default.createElement(_Compared2.default,{data:{index:0,key:'zeroPercent',title:['0-30Days'],sqlName:"_9_2_1",name:'% 百分比',type:'percent'}},Number(data9[0].zeroPercent||"0")<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(data9[0].zeroPercent||"0")*100).toFixed(1)+'%',')'):(Number(data9[0].zeroPercent||"0")*100).toFixed(1)+'%')),_react2.default.createElement(_col2.default,{span:4,className:'border-right'},_react2.default.createElement(_Compared2.default,{data:{index:0,key:'threePercent',title:['31-60Days'],sqlName:"_9_2_1",name:'% 百分比',type:'percent'}},Number(data9[0].threePercent||"0")<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(data9[0].threePercent||"0")*100).toFixed(1)+'%',')'):(Number(data9[0].threePercent||"0")*100).toFixed(1)+'%')),_react2.default.createElement(_col2.default,{span:4,className:'border-right'},_react2.default.createElement(_Compared2.default,{data:{index:0,key:'sixPercent',title:['61-90Days'],sqlName:"_9_2_1",name:'% 百分比',type:'percent'}},Number(data9[0].sixPercent||"0")<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(data9[0].sixPercent||"0")*100).toFixed(1)+'%',')'):(Number(data9[0].sixPercent||"0")*100).toFixed(1)+'%')),_react2.default.createElement(_col2.default,{span:4,className:'border-right'},_react2.default.createElement(_Compared2.default,{data:{index:0,key:'ninePercent',title:['91-120Days'],sqlName:"_9_2_1",name:'% 百分比',type:'percent'}},Number(data9[0].ninePercent||"0")<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(data9[0].ninePercent||"0")*100).toFixed(1)+'%',')'):(Number(data9[0].ninePercent||"0")*100).toFixed(1)+'%')),_react2.default.createElement(_col2.default,{span:4,className:'border-right'},_react2.default.createElement(_Compared2.default,{data:{index:0,key:'overPercent',title:['Over 120 Days'],sqlName:"_9_2_1",name:'% 百分比',type:'percent'}},Number(data9[0].overPercent||"0")<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(data9[0].overPercent||"0")*100).toFixed(1)+'%',')'):(Number(data9[0].overPercent||"0")*100).toFixed(1)+'%')),_react2.default.createElement(_col2.default,{span:4,className:'border-right'},_react2.default.createElement(_Compared2.default,{data:{index:0,key:'totalPercent',title:['Total Balance'],sqlName:"_9_2_1",name:'% 百分比',type:'percent'}},Number(data9[0].totalPercent||"0")<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(data9[0].totalPercent||"0")*100).toFixed(1)+'%',')'):(Number(data9[0].totalPercent||"0")*100).toFixed(1)+'%'))))),_react2.default.createElement('div',{className:'receive-row'},_react2.default.createElement('div',{className:'row-left'},'Accounts over 90 Days \u8D8590\u5929\u5E94\u6536\u8D26\u8D26\u6237\u540D'),_react2.default.createElement('div',{className:'row-right'},_react2.default.createElement(_row2.default,{style:{textAlign:"center"}},_react2.default.createElement(_col2.default,{span:4,className:'border-right-background'},'Amount \u91D1\u989D'),_react2.default.createElement(_col2.default,{span:20,className:'border-right-background'},'GM and DOF Comments \u603B\u7ECF\u7406\u53CA\u8D22\u52A1\u603B\u76D1\u5907\u6CE8'))))),_react2.default.createElement('div',null,this.state.loading&&!this.state.print?null:data.map(function(x,i){if(i===data.length-1){return _react2.default.createElement('div',{className:'receive-row',key:i},_react2.default.createElement('div',{className:'border-total'},x.name),_react2.default.createElement('div',{className:'row-right'},_react2.default.createElement(_row2.default,{style:{textAlign:"center"}},_react2.default.createElement(_col2.default,{span:4,className:'border-right-bottom'},Number(x.money)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(x.money),')'):x.money.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')),_react2.default.createElement(_col2.default,{span:20,className:'border-right-bottom',style:{textAlign:"center"}},'-'))));}return _react2.default.createElement('div',{className:'receive-row',key:i},_react2.default.createElement('div',{className:'border-bottom-left-total'},_react2.default.createElement(_input2.default,{defaultValue:x.name,className:'table_numInput',onBlur:function onBlur(e){var data=_this2.state.data;data[i].name=e.target.value;data[i].name_code=e.target.value;_this2.setState({data:data});}})),_react2.default.createElement('div',{className:'row-right'},_react2.default.createElement(_row2.default,{style:{textAlign:"center"}},_react2.default.createElement(_col2.default,{span:4,className:'border-right-input'},_react2.default.createElement(_Compared2.default,{data:{index:i,key:'money',title:['Amount 金额'],sqlName:"_9_2",name:x.name,type:'number'}},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,defaultValue:Number(x.money||'0')||'',className:'table_numInput',onBlur:function onBlur(e){var data=_this2.state.data;var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));data[i].money=value;var money=data.reduce(function(a,b){if(b.name!="Total"){a+=Number(b.money||"0");}return a;},0);data[data.length-1].money=money;_this2.setState({data:data});}}))),_react2.default.createElement(_col2.default,{span:20,className:'border-right-input'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:x.note,onBlur:function onBlur(e){var data=_this2.state.data;data[i].note=e.target.value;_this2.setState({data:data});}})))));}))),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_9_2'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2015 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data3_2_1=exports.data3_2_1=[{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'Total',name_code:'Total',money:"0",note:""}];var data9_2=exports.data9_2=[{day:"0",zeroDay:"0",threeDay:"0",sixDay:"0",nineDay:"0",overDay:"0",totalDay:"0",zeroPercent:"0",threePercent:"0",sixPercent:"0",ninePercent:"0",overPercent:"0",totalPercent:"0"}];

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(25);__webpack_require__(35);__webpack_require__(60);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(2018);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2019);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var nameData=['zeroDay','threeDay','sixDay','nineDay','overDay','totalDay'];data[0].totalDay=nameData.reduce(function(a,b){if(b!='totalDay'){a+=numConvert(data[0][b]);}return a;},0);data[0].totalDay=data[0].totalDay.toFixed(0);var percentData=['zeroPercent','threePercent','sixPercent','ninePercent','overPercent','totalPercent'];for(var i=0;i<6;i++){data[0][percentData[i]]=(numConvert(data[0].totalDay)==0?0:numConvert(data[0][nameData[i]])/numConvert(data[0].totalDay)).toFixed(3);}return data;};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data3_2_1);var data=JSON.parse(dataBegin);_this.getTitle(date);fetch('/_9_3_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}_this.setState({data:data});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.getTitle=function(date){var dataBegin=JSON.stringify(_data.data9_2);var data=JSON.parse(dataBegin);fetch('/_9_3_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}_this.setState({data9:data,loading:false});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};_this.onSaveTitle();fetch('/add_9_3',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.onSaveTitle=function(){var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data9.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_9_3_1',headres).then(function(x){return x.json();}).then(function(x){if(x.status==1){return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table9_3',1.5,'9.30',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_message3.default.error('添加失败');_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],data9:[{}],loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);// this.computeNum(this.state.data)
}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var data9=this.state.data9;return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1 receivable'},_react2.default.createElement(_row2.default,{className:'title',id:'table9_3'},_react2.default.createElement(_row2.default,null,'9.3 Accounts Payable \u5E94\u4ED8\u8D26\u6B3E'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}})),this.state.loading&&!this.state.print?null:_react2.default.createElement('div',null,_react2.default.createElement('div',{className:'receive-row',style:{marginTop:20}},_react2.default.createElement('div',{className:'row-left'},'Aging \u8D26\u9F84'),_react2.default.createElement('div',{className:'row-right'},_react2.default.createElement(_row2.default,{style:{textAlign:"center"}},_react2.default.createElement(_col2.default,{span:4,className:'border-right-background'},'0-30Days'),_react2.default.createElement(_col2.default,{span:4,className:'border-right-background'},'31-60Days'),_react2.default.createElement(_col2.default,{span:4,className:'border-right-background'},'61-90Days'),_react2.default.createElement(_col2.default,{span:4,className:'border-right-background'},'91-120Days'),_react2.default.createElement(_col2.default,{span:4,className:'border-right-background'},'Over 120 Days'),_react2.default.createElement(_col2.default,{span:4,className:'border-right-background'},'Total Balance')))),_react2.default.createElement('div',{className:'receive-row'},_react2.default.createElement('div',{className:'row-left'},'Amount \u91D1\u989D'),_react2.default.createElement('div',{className:'row-right'},_react2.default.createElement(_row2.default,{style:{textAlign:"center"}},_react2.default.createElement(_col2.default,{span:4,className:'border-right-input'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:data9[0].zeroDay==0?"":data9[0].zeroDay,onBlur:function onBlur(e){var data9=_this2.state.data9;var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));data9[0].zeroDay=value;data9=_this2.computeNum(data9);_this2.setState({data9:data9});}})),_react2.default.createElement(_col2.default,{span:4,className:'border-right-input'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:data9[0].threeDay==0?"":data9[0].threeDay,onBlur:function onBlur(e){var data9=_this2.state.data9;var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));data9[0].threeDay=value;data9=_this2.computeNum(data9);_this2.setState({data9:data9});}})),_react2.default.createElement(_col2.default,{span:4,className:'border-right-input'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:data9[0].sixDay==0?"":data9[0].sixDay,onBlur:function onBlur(e){var data9=_this2.state.data9;var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));data9[0].sixDay=value;data9=_this2.computeNum(data9);_this2.setState({data9:data9});}})),_react2.default.createElement(_col2.default,{span:4,className:'border-right-input'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:data9[0].nineDay==0?"":data9[0].nineDay,onBlur:function onBlur(e){var data9=_this2.state.data9;var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));data9[0].nineDay=value;data9=_this2.computeNum(data9);_this2.setState({data9:data9});}})),_react2.default.createElement(_col2.default,{span:4,className:'border-right-input'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:data9[0].overDay==0?"":data9[0].overDay,onBlur:function onBlur(e){var data9=_this2.state.data9;var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));data9[0].overDay=value;data9=_this2.computeNum(data9);_this2.setState({data9:data9});}})),_react2.default.createElement(_col2.default,{span:4,className:'border-right'},data9[0].totalDay)))),_react2.default.createElement('div',{className:'receive-row'},_react2.default.createElement('div',{className:'row-left'},'% \u767E\u5206\u6BD4'),_react2.default.createElement('div',{className:'row-right'},_react2.default.createElement(_row2.default,{style:{textAlign:"center"}},_react2.default.createElement(_col2.default,{span:4,className:'border-right'},Number(data9[0].zeroPercent||"0")<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(data9[0].zeroPercent||"0")*100).toFixed(1)+'%',')'):(Number(data9[0].zeroPercent||"0")*100).toFixed(1)+'%'),_react2.default.createElement(_col2.default,{span:4,className:'border-right'},Number(data9[0].threePercent||"0")<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(data9[0].threePercent||"0")*100).toFixed(1)+'%',')'):(Number(data9[0].threePercent||"0")*100).toFixed(1)+'%'),_react2.default.createElement(_col2.default,{span:4,className:'border-right'},Number(data9[0].sixPercent||"0")<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(data9[0].sixPercent||"0")*100).toFixed(1)+'%',')'):(Number(data9[0].sixPercent||"0")*100).toFixed(1)+'%'),_react2.default.createElement(_col2.default,{span:4,className:'border-right'},Number(data9[0].ninePercent||"0")<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(data9[0].ninePercent||"0")*100).toFixed(1)+'%',')'):(Number(data9[0].ninePercent||"0")*100).toFixed(1)+'%'),_react2.default.createElement(_col2.default,{span:4,className:'border-right'},Number(data9[0].overPercent||"0")<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(data9[0].overPercent||"0")*100).toFixed(1)+'%',')'):(Number(data9[0].overPercent||"0")*100).toFixed(1)+'%'),_react2.default.createElement(_col2.default,{span:4,className:'border-right'},Number(data9[0].totalPercent||"0")<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(data9[0].totalPercent||"0")*100).toFixed(1)+'%',')'):(Number(data9[0].totalPercent||"0")*100).toFixed(1)+'%')))),_react2.default.createElement('div',{className:'receive-row'},_react2.default.createElement('div',{className:'row-left'},'Accounts over 90 Days \u8D8590\u5929\u5E94\u4ED8\u5E10\u8D26\u6237\u540D'),_react2.default.createElement('div',{className:'row-right'},_react2.default.createElement(_row2.default,{style:{textAlign:"center"}},_react2.default.createElement(_col2.default,{span:4,className:'border-right-background'},'Amount \u91D1\u989D'),_react2.default.createElement(_col2.default,{span:20,className:'border-right-background'},'GM and DOF Comments \u603B\u7ECF\u7406\u53CA\u8D22\u52A1\u603B\u76D1\u5907\u6CE8'))))),_react2.default.createElement('div',{style:{height:this.state.print?900:550,overflow:"auto"}},this.state.loading&&!this.state.print?null:data.map(function(x,i){if(i===data.length-1){return _react2.default.createElement('div',{className:'receive-row',key:i},_react2.default.createElement('div',{className:'border-total'},x.name),_react2.default.createElement('div',{className:'row-right'},_react2.default.createElement(_row2.default,{style:{textAlign:"center"}},_react2.default.createElement(_col2.default,{span:4,className:'border-right-bottom'},Number(x.money)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(x.money),')'):x.money.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')),_react2.default.createElement(_col2.default,{span:20,className:'border-right-bottom',style:{textAlign:"center"}},'-'))));}return _react2.default.createElement('div',{className:'receive-row',key:i},_react2.default.createElement('div',{className:'border-bottom-left-total'},_react2.default.createElement(_input2.default,{defaultValue:x.name,className:'table_numInput',onBlur:function onBlur(e){var data=_this2.state.data;data[i].name=e.target.value;data[i].name_code=e.target.value;_this2.setState({data:data});}})),_react2.default.createElement('div',{className:'row-right'},_react2.default.createElement(_row2.default,{style:{textAlign:"center"}},_react2.default.createElement(_col2.default,{span:4,className:'border-right-input'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,defaultValue:x.money==0?"":x.money,className:'table_numInput',onBlur:function onBlur(e){var data=_this2.state.data;var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));data[i].money=value;var money=data.reduce(function(a,b){if(b.name!="Total"){a+=Number(b.money||"0");}return a;},0);data[data.length-1].money=money;_this2.setState({data:data});}})),_react2.default.createElement(_col2.default,{span:20,className:'border-right-input'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:x.note,onBlur:function onBlur(e){var data=_this2.state.data;data[i].note=e.target.value;_this2.setState({data:data});}})))));}))),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_9_3'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2018 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data3_2_1=exports.data3_2_1=[{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'',name_code:'',money:"0",note:""},{name:'Total',name_code:'Total',money:"0",note:""}];var data9_2=exports.data9_2=[{zeroDay:"0",threeDay:"0",sixDay:"0",nineDay:"0",overDay:"0",totalDay:"0",zeroPercent:"0",threePercent:"0",sixPercent:"0",ninePercent:"0",overPercent:"0",totalPercent:"0"}];

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(8);__webpack_require__(6);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(25);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2021);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _=__webpack_require__(2022);var _2=_interopRequireDefault(_);var _compute=__webpack_require__(708);var _compute2=_interopRequireDefault(_compute);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TextArea=_input2.default.TextArea;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};data[5].system=data.reduce(function(a,b){if(b.name!='Total'){a+=numConvert(b.system);}return a;},0);data[5].stock=data.reduce(function(a,b){if(b.name!='Total'){a+=numConvert(b.stock);}return a;},0);data[5].system=data[5].system.toFixed(0);data[5].stock=data[5].stock.toFixed(0);for(var i=0;i<5;i++){data[i].diff=(numConvert(data[i].stock)-numConvert(data[i].system)).toFixed(0);}data[5].diff=data.reduce(function(a,b){if(b.name!='Total'){a+=numConvert(b.diff);}return a;},0);data[5].diff=data[5].diff.toFixed(0);for(var _i=0;_i<6;_i++){data[_i].percent=(numConvert(data[_i].system)==0?0:numConvert(data[_i].diff)/numConvert(data[_i].system)).toFixed(4);}_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data9_4);var data=JSON.parse(dataBegin);var dataBeginTitle=JSON.stringify(_data.dataTitle);var data2=JSON.parse(dataBeginTitle);var dataBeginContent=JSON.stringify(_data.dataContent);var data1=JSON.parse(dataBeginContent);fetch('/_9_4_allInfo?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.table&&x.data.table.length>0){data=x.data.table;}if(x.data.dataTitle&&x.data.dataTitle.length>0){data2=x.data.dataTitle;}if(x.data.dataContent&&x.data.dataContent.length>0){data1=x.data.dataContent;}_this.setState({loading:false,dataTitle:data2,data1:(0,_compute2.default)(data1,data2),note:_extends({},x.data.note[0])});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();var data2=_this.state.dataTitle.map(function(x){return _extends({},x,{year:year,month:month});});var data1=_this.state.data1.map(function(x){return _extends({},x,{year:year,month:month});});dataFrom.append('data',JSON.stringify({data:data,note:[_extends({},_this.state.note,{year:year,month:month})],dataTitle:data2,dataContent:data1}));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_9_4',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败'+JSON.stringify(err));console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table9_4',1.5,'9.40',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.onChildChange=function(name,value){_this.setState(_defineProperty({},name,value));};_this.onFillLastMonth=function(){if(_this.state.data[0]&&_this.state.data[0].id){_message3.default.error('当前月份数据已存在!');return;}_this.setState({data:[],data1:[],dataTitle:[],loading:true,note:{note:""}});var dataBegin=JSON.stringify(_data.data9_4);var data=JSON.parse(dataBegin);var dataBeginTitle=JSON.stringify(_data.dataTitle);var data2=JSON.parse(dataBeginTitle);var dataBeginContent=JSON.stringify(_data.dataContent);var data1=JSON.parse(dataBeginContent);var date=(0,_moment2.default)(_this.state.date).subtract(1,'month').format('YYYY-MM');fetch('/_9_4_allInfo?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.table&&x.data.table.length>0){data=x.data.table.map(function(x){delete x.id;return x;});}if(x.data.dataTitle&&x.data.dataTitle.length>0){data2=x.data.dataTitle.map(function(x){delete x.id;return x;});;}if(x.data.dataContent&&x.data.dataContent.length>0){data1=x.data.dataContent.map(function(x){delete x.id;return x;});;}_this.setState({loading:false,dataTitle:data2,data1:(0,_compute2.default)(data1,data2),note:_extends({},x.data.note[0])});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,note:{note:""},loadingSave:false,print:false,data1:[],dataTitle:[]};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var columns=[{title:'Items 项目',dataIndex:'name',key:'name',align:"center",render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':''),style:{textAlign:"left"}},text);}},{title:_react2.default.createElement('div',null,'Amount',_react2.default.createElement('br',null),'System \u7CFB\u7EDF\u6570'),dataIndex:'system',key:'system',align:"center",render:function render(text,record,index){if(index<=4){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text==0?"":text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('system',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}},{title:_react2.default.createElement('div',null,'Amount',_react2.default.createElement('br',null),'Stock taken \u76D8\u70B9\u6570'),dataIndex:'stock',key:'stock',align:"center",render:function render(text,record,index){if(index<=4){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text==0?"":text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('stock',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}},{title:_react2.default.createElement('div',null,'Diff \u5DEE\u5F02'),dataIndex:'diff',key:'diff',align:"center",render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:'% 百分比',dataIndex:'percent',align:"center",key:'percent',render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%');}},{title:_react2.default.createElement('div',null,'GM/DOF Comments',_react2.default.createElement('br',null),'\u603B\u7ECF\u7406\u53CA\u8D22\u52A1\u603B\u76D1\u5907\u6CE8'),dataIndex:'note',key:'note',align:"center",render:function render(text,record,index){if(index<=4){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var data=_this2.state.data;data[index].note=e.target.value;_this2.setState({data:data});}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':''),style:{textAlign:"center"}},'-');}}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table9_4'},_react2.default.createElement(_row2.default,null,'9.4.1 Operating Equipment Stock taken Summary \u8425\u8FD0\u5DE5\u5177\u76D8\u70B9\u6C47\u603B (at least Quarterly)'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],data1:[],dataTitle:[],loading:true,note:{note:""}});_this2.getDateData(str);}}),_react2.default.createElement(_button2.default,{type:'primary',style:{marginLeft:10,display:this.state.print?'none':''},onClick:this.onFillLastMonth},'\u586B\u5145\u4E0A\u6708\u6570\u636E')),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_2.default,{data:this.state.data1,dataTitle:this.state.dataTitle,onChange:this.onChildChange,print:this.state.print}),_react2.default.createElement(_row2.default,{style:{margin:"20px 0"}},_react2.default.createElement(_row2.default,{style:{margin:"10px 0"}},'9.4.3 Please provide the action plan on the variance. \u8BF7\u63D0\u4F9B\u9488\u5BF9\u4EE5\u4E0A\u5DEE\u5F02\u7684\u540E\u7EED\u8DDF\u8FDB\u62A5\u544A\u3002'),!this.state.loading||this.state.print?_react2.default.createElement(TextArea,{autosize:{minRows:4},placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',defaultValue:this.state.note.note,onBlur:function onBlur(e){_this2.setState({note:_extends({},_this2.state.note,{note:e.target.value})});}}):null)),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_9_4'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data9_4=exports.data9_4=[{name:"Linen 布草",name_code:"Linen",system:"0",stock:"0",diff:"0",percent:"0",note:""},{name:"Uniform 制服",name_code:"Uniform",system:"0",stock:"0",diff:"0",percent:"0",note:""},{name:"Chinaware 瓷器",name_code:"Chinaware",system:"0",stock:"0",diff:"0",percent:"0",note:""},{name:"Glasswares 玻璃器皿",name_code:"Glasswares",system:"0",stock:"0",diff:"0",percent:"0",note:""},{name:"Silverwares 银器",name_code:"Silverwares",system:"0",stock:"0",diff:"0",percent:"0",note:""},{name:"Total",name_code:"Total",system:"0",stock:"0",diff:"0",percent:"0",note:""}];var dataTitle=exports.dataTitle=[{name:"Days of the Current Period 本期期间天数:",day:0,datename:"Stock-taken Date This Time 本次盘点日期:",date:""},{name:"Days of the Last Period 上期期间天数:",day:0,datename:"Stock-taken Date Last Time 上次盘点日期:",date:""}];var dataContent=exports.dataContent=[{name:"CHINAWARE 瓷器",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Opening Balance 期初余额",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Add: Purchase 加：本期采购",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Add: Transfer in 加：本期转入",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Less: Transfer out 减：本期转出",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Less: Compensation 减：客人赔偿",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Closing Balance 期末余额",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Loss & Breakage Value 丢失破损值",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Loss & Breakage % 丢失破损比",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Outlets Loss & Breakage % 各餐厅丢失破损占比",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"其中：Breakage Value 报损金额 ",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Loss Value 丢失金额",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"GLASSWARE 玻璃",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Opening Balance 期初余额",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Add: Purchase 加：本期采购",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Add: Transfer in 加：本期转入",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Less: Transfer out 减：本期转出",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Less: Compensation 减：客人赔偿",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Closing Balance 期末余额",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Loss & Breakage Value 丢失破损值",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Loss & Breakage % 丢失破损比",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Outlets Loss & Breakage % 各餐厅丢失破损占比",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"其中：Breakage Value 报损金额 ",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Loss Value 丢失金额",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"SILVERWARE 银器",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Opening Balance 期初余额",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Add: Purchase 加：本期采购",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Add: Transfer in 加：本期转入",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Less: Transfer out 减：本期转出",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Less: Compensation 减：客人赔偿",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Closing Balance 期末余额",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Loss & Breakage Value 丢失破损值",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Loss & Breakage % 丢失破损比",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Outlets Loss & Breakage % 各餐厅丢失破损占比",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"其中：Breakage Value 报损金额 ",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Loss Value 丢失金额",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"LINEN 布草",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Opening Balance 期初余额",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Add: Purchase 加：本期采购",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Add: Transfer in 加：本期转入",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Less: Transfer out 减：本期转出",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Less: Compensation 减：客人赔偿",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Closing Balance 期末余额",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Loss & Breakage Value 丢失破损值",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Loss & Breakage % 丢失破损比",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Outlets Loss & Breakage % 各餐厅丢失破损占比",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"其中：Breakage Value 报损金额 ",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Loss Value 丢失金额",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Total Loss & Breakage Value 丢失破损值总计",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Total Loss & Breakage % 丢失破损比总计",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Outlets Total Loss & Breakage % 各餐厅丢失破损占比总计",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"其中：Breakage Value 报损金额 ",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Loss Value 丢失金额",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Total F&B (Rooms) Covers: 餐厅用餐（客房）人数总计",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Total F & B (Rooms) Revenue: 餐厅（客房）总收入",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Loss & Breakage Per Cover: 丢失破损值分摊至每位客人",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Loss & Breakage by Day: 丢失破损值分摊至每天",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Breakage % to F & B (Rooms) Revenue: 破损值与餐厅（客房）收入占比",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0},{name:"Loss  % to F & B (Rooms) Revenue: 丢失值与餐厅（客房）收入占比",shop:0,Chinese:0,Thai:0,banquet:0,lounge:0,stewarding:0,total:0,last:0,var:0,rooms:0,last_total:0,last_var:0,others:0}];

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(8);__webpack_require__(25);__webpack_require__(35);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(139);var _TableText2=_interopRequireDefault(_TableText);var _compute=__webpack_require__(708);var _compute2=_interopRequireDefault(_compute);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var inputIndex=[1,2,3,4,5,6,10,13,14,15,16,17,18,22,25,26,27,28,29,30,34,37,38,39,40,41,42,46,53,54];var totalIndex=[0,12,24,36];var percentIndex=[8,9,20,21,32,33,44,45,49,50,57,58];var Index=function(_Component){_inherits(Index,_Component);function Index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Index.__proto__||Object.getPrototypeOf(Index)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(name,value,i){var json=JSON.stringify(_this.props.data);var data=JSON.parse(json);data[i][name]=value;data=(0,_compute2.default)(data,_this.props.dataTitle);_this.props.onChange('data1',data);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Index,[{key:'render',value:function render(){var _this2=this;var columns=[{title:'名称',dataIndex:'name',key:'name',render:function render(text,record,index){return _react2.default.createElement('div',{style:{textAlign:"center"}},text);}},{title:'天数',dataIndex:'day',key:'day',render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:Number(text||"0")||"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));var data=_this2.props.dataTitle;data[index].day=value;_this2.props.onChange('dataTitle',data);}}));}},{title:'日期名称',dataIndex:'datename',key:'datename',render:function render(text,record,index){return _react2.default.createElement('div',{style:{textAlign:"center"}},text);}},{title:'日期',dataIndex:'date',key:'date',render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var value=e.target.value||"";var data=_this2.props.dataTitle;data[index].date=value;_this2.props.onChange('dataTitle',data);}}));}}];var columnsContent=[{title:'-',dataIndex:'name',key:'name',fixed:"left",width:500,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':''),style:{textAlign:"left"}},text);}},{title:'Coffee Shop',dataIndex:'shop',key:'shop',width:150,align:"center",render:function render(text,record,index){var type=inputIndex.includes(index)?'inputNumber':percentIndex.includes(index)?"percent":'number';var props={text:text,index:index,type:type,name:"shop",onChange:_this2.onChange,totalIndex:totalIndex};if(totalIndex.includes(index)){return{children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:""})}),props:{colSpan:12}};}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Chinese Restaurant',dataIndex:'Chinese',key:'Chinese',width:150,align:"center",render:function render(text,record,index){var type=inputIndex.includes(index)?'inputNumber':percentIndex.includes(index)?"percent":'number';var props={text:text,index:index,type:type,name:"Chinese",onChange:_this2.onChange,totalIndex:totalIndex};if(totalIndex.includes(index)){return{children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:""})}),props:{colSpan:0}};}return _react2.default.createElement(_TableText2.default,{data:props});}},//  {
//     title: 'Thai Restaurant ',
//     dataIndex: 'Thai',
//     key: 'Thai',
//     width: 150,
//     align: "center",
//     render: (text, record, index) => {
//         const type = inputIndex.includes(index) ? 'inputNumber' : percentIndex.includes(index) ? "percent" : 'number';
//         const props = { text, index, type, name: "Thai", onChange: this.onChange, totalIndex };
//         if (totalIndex.includes(index)) {
//             return {
//                 children: <TableText data={{ ...props, type: "" }} />,
//                 props: {
//                     colSpan: 0
//                 }
//             }
//         }
//         return (
//             <TableText data={props} />
//         )
//     }
// },
{title:'Banquet ',dataIndex:'banquet',key:'banquet',width:150,align:"center",render:function render(text,record,index){var type=inputIndex.includes(index)?'inputNumber':percentIndex.includes(index)?"percent":'number';var props={text:text,index:index,type:type,name:"banquet",onChange:_this2.onChange,totalIndex:totalIndex};if(totalIndex.includes(index)){return{children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:""})}),props:{colSpan:0}};}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Lobby Lounge',dataIndex:'lounge',key:'lounge',width:150,align:"center",render:function render(text,record,index){var type=inputIndex.includes(index)?'inputNumber':percentIndex.includes(index)?"percent":'number';var props={text:text,index:index,type:type,name:"lounge",onChange:_this2.onChange,totalIndex:totalIndex};if(totalIndex.includes(index)){return{children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:""})}),props:{colSpan:0}};}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'STEWARDING',dataIndex:'stewarding',key:'stewarding',width:150,align:"center",render:function render(text,record,index){var type=inputIndex.includes(index)?'inputNumber':percentIndex.includes(index)?"percent":'number';var props={text:text,index:index,type:type,name:"stewarding",onChange:_this2.onChange,totalIndex:totalIndex};if(totalIndex.includes(index)){return{children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:""})}),props:{colSpan:0}};}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Others',dataIndex:'others',key:'others',width:150,align:"center",render:function render(text,record,index){var type=inputIndex.includes(index)?'inputNumber':percentIndex.includes(index)?"percent":'number';var props={text:text,index:index,type:type,name:"others",onChange:_this2.onChange,totalIndex:totalIndex};if(totalIndex.includes(index)){return{children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:""})}),props:{colSpan:0}};}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Total',dataIndex:'total',key:'total',width:150,align:"center",render:function render(text,record,index){var type=percentIndex.includes(index)?"percent":'number';var props={text:text,index:index,type:type,name:"stewarding",onChange:_this2.onChange,totalIndex:totalIndex};if(totalIndex.includes(index)){return{children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:""})}),props:{colSpan:0}};}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Last Period Total',dataIndex:'last',key:'last',width:150,align:"center",render:function render(text,record,index){var type=inputIndex.includes(index)?'inputNumber':percentIndex.includes(index)?"percent":'number';var props={text:text,index:index,type:type,name:"last",onChange:_this2.onChange,totalIndex:totalIndex};if(totalIndex.includes(index)){return{children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:""})}),props:{colSpan:0}};}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Var.',dataIndex:'var',key:'var',width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"percent",name:"var",onChange:_this2.onChange,totalIndex:totalIndex};if(totalIndex.includes(index)){return{children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:""})}),props:{colSpan:0}};}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Rooms',dataIndex:'rooms',key:'rooms',width:150,align:"center",render:function render(text,record,index){var type=inputIndex.includes(index)?'inputNumber':percentIndex.includes(index)?"percent":'number';var props={text:text,index:index,type:type,name:"rooms",onChange:_this2.onChange,totalIndex:totalIndex};if(totalIndex.includes(index)){return{children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:""})}),props:{colSpan:0}};}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Last Period Total',dataIndex:'last_total',key:'last_total',width:150,align:"center",render:function render(text,record,index){var type=inputIndex.includes(index)?'inputNumber':percentIndex.includes(index)?"percent":'number';var props={text:text,index:index,type:type,name:"last_total",onChange:_this2.onChange,totalIndex:totalIndex};if(totalIndex.includes(index)){return{children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:""})}),props:{colSpan:0}};}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Var.',dataIndex:'last_var',key:'last_var',width:150,align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"percent",name:"last_var",onChange:_this2.onChange,totalIndex:totalIndex};if(totalIndex.includes(index)){return{children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:""})}),props:{colSpan:0}};}return _react2.default.createElement(_TableText2.default,{data:props});}}];return _react2.default.createElement('div',{style:{marginTop:30,width:this.props.print?2350:'auto'},className:'table7_1_1'},_react2.default.createElement('div',null,'9.4.2 Operating Equipment Loss & Breakage Analysis  \u8425\u8FD0\u5DE5\u5177\u4E22\u5931\u7834\u635F\u5206\u6790'),_react2.default.createElement(_table2.default,{columns:columns,dataSource:this.props.dataTitle,showHeader:false,style:{width:1000},pagination:false,bordered:true,className:'content',size:'middle',rowKey:function rowKey(record){return record.name;}}),_react2.default.createElement(_table2.default,{columns:columnsContent,dataSource:this.props.data,pagination:false,bordered:true,className:'content',size:'middle',rowKey:function rowKey(record,i){return i;},scroll:this.props.print?{}:{y:500,x:2300}}));}}]);return Index;}(_react.Component);exports.default=Index;

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(8);__webpack_require__(6);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(25);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2024);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TextArea=_input2.default.TextArea;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};data[5].system=data.reduce(function(a,b){if(b.name!='Total'){a+=numConvert(b.system);}return a;},0);data[5].stock=data.reduce(function(a,b){if(b.name!='Total'){a+=numConvert(b.stock);}return a;},0);data[5].system=data[5].system.toFixed(0);data[5].stock=data[5].stock.toFixed(0);for(var i=0;i<5;i++){data[i].diff=(numConvert(data[i].stock)-numConvert(data[i].system)).toFixed(0);}data[5].diff=data.reduce(function(a,b){if(b.name!='Total'){a+=numConvert(b.diff);}return a;},0);data[5].diff=data[5].diff.toFixed(0);for(var _i=0;_i<6;_i++){data[_i].percent=(numConvert(data[_i].system)==0?0:numConvert(data[_i].diff)/numConvert(data[_i].system)).toFixed(4);}_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data9_4);var data=JSON.parse(dataBegin);_this.getNote(date);fetch('/_9_5_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.getNote=function(date){fetch('/_9_5_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){_this.setState({note:_extends({},x.data[0])});}}).catch(function(err){console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};if(_this.state.note){_this.onSaveNote([_extends({},_this.state.note,{year:year,month:month})]);}fetch('/add_9_5',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败'+JSON.stringify(err));console.error(err);});};_this.onSaveNote=function(data){var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_9_5_1',headres).then(function(x){return x.json();}).then(function(x){if(x.status==1){// message.success(x.msg);
return;}_message3.default.error('备注保存失败：'+x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table9_5',1.5,'9.50',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.onFillLastMonth=function(){if(_this.state.data[0]&&_this.state.data[0].id){_message3.default.error('当前月份数据已存在!');_this.setState({loading:false});return;}_this.setState({loading:true,data:[]});var date=_this.state.date;var data=JSON.parse(JSON.stringify(_data.data9_4));fetch('/_9_5_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).subtract(1,'month').format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data.map(function(v){delete v.id;delete v.month;delete v.year;return v;});};_message3.default.info('数据填充成功！');_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,note:{note:""},loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);// this.computeNum(this.state.data)
}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var columns=[{title:'Items 项目',dataIndex:'name',key:'name',align:"center",render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':''),style:{textAlign:"left"}},text);}},{title:_react2.default.createElement('div',null,'Amount',_react2.default.createElement('br',null),'System \u53F0\u8D26\u6570'),dataIndex:'system',key:'system',align:"center",render:function render(text,record,index){if(index<=4){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text==0?"":text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('system',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}},{title:_react2.default.createElement('div',null,'Amount',_react2.default.createElement('br',null),'Stock taken \u76D8\u70B9\u6570'),dataIndex:'stock',key:'stock',align:"center",render:function render(text,record,index){if(index<=4){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text==0?"":text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('stock',value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}},{title:_react2.default.createElement('div',null,'Diff \u5DEE\u5F02'),dataIndex:'diff',key:'diff',align:"center",render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}},{title:'% 百分比',dataIndex:'percent',align:"center",key:'percent',render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%');}},{title:_react2.default.createElement('div',null,'GM/DOF Comments',_react2.default.createElement('br',null),'\u603B\u7ECF\u7406\u53CA\u8D22\u52A1\u603B\u76D1\u5907\u6CE8'),dataIndex:'note',key:'note',align:"center",render:function render(text,record,index){if(index<=4){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){var data=_this2.state.data;data[index].note=e.target.value;_this2.setState({data:data});}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':''),style:{textAlign:"center"}},'-');}}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table9_5'},_react2.default.createElement(_row2.default,null,'9.5 FFE Site Inspection Summary \u56FA\u5B9A\u8D44\u4EA7\u76D8\u70B9\u6C47\u603B (at least half-yearly)'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true,note:{note:""}});_this2.getDateData(str);}}),_react2.default.createElement(_button2.default,{type:'primary',style:{marginLeft:10,display:this.state.print?'none':''},onClick:this.onFillLastMonth},'\u586B\u5145\u4E0A\u6708\u6570\u636E')),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_row2.default,{style:{margin:"20px 0"}},_react2.default.createElement(_row2.default,{style:{margin:"10px 0"}},'9.5.1 Please provide the action plan on the variance. \u8BF7\u63D0\u4F9B\u9488\u5BF9\u4EE5\u4E0A\u5DEE\u5F02\u7684\u540E\u7EED\u8DDF\u8FDB\u62A5\u544A\u3002'),!this.state.loading||this.state.print?_react2.default.createElement(TextArea,{autosize:{minRows:4},placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',defaultValue:this.state.note.note,onBlur:function onBlur(e){_this2.setState({note:_extends({},_this2.state.note,{note:e.target.value})});}}):null)),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_9_5'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data9_4=exports.data9_4=[{name:"Machinery Equipment 机器设备",name_code:"Machinery_Equipment",system:"0",stock:"0",diff:"0",percent:"0",note:""},{name:"Furniture & Fixture 家具及摆设",name_code:"Furniture_Fixture",system:"0",stock:"0",diff:"0",percent:"0",note:""},{name:"Transportation and communication equipment 交通运输设备",name_code:"Transportation_and_communication_equipment",system:"0",stock:"0",diff:"0",percent:"0",note:""},{name:"Electrical and electronic equipment 电子电器设备",name_code:"Electrical_and_electronic_equipment",system:"0",stock:"0",diff:"0",percent:"0",note:""},{name:"Others 其他设备",name_code:"Others",system:"0",stock:"0",diff:"0",percent:"0",note:""},{name:"Total",name_code:"Total",system:"0",stock:"0",diff:"0",percent:"0",note:""}];

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(25);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2026);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TextArea=_input2.default.TextArea;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};data[0].balance=(numConvert(data[0].year_c)+numConvert(data[0].YTD)-numConvert(data[0].charges)).toFixed(0);_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data9_4);var data=JSON.parse(dataBegin);fetch('/_9_6_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_9_6',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败'+JSON.stringify(err));console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table9_6',1.5,'9.60',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);// this.computeNum(this.state.data)
}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var columns=[{title:'%  百分比',dataIndex:'percent',key:'percent',align:"center",render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(value+'%').replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){var parseValue=value;parseValue=value.replace('%','').replace(/\$\s?|(,*)/g,'');return parseValue;},className:'table_numInput',defaultValue:text==0?"":(Number(text||"0")*100).toFixed(3),precision:1,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/%|,/g,'')||'0');value=(Number(value||"0")/100).toFixed(3);_this2.onChange('percent',value,index);}}));}},{title:_react2.default.createElement('div',null,'Beginning of the Year \u5E74\u521D\u6570'),dataIndex:'year_c',key:'year_c',align:"center",render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text==0?"":text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('year_c',value,index);}}));}},{title:_react2.default.createElement('div',null,'CAPEX & FF&E Reserve Provision YTD ',_react2.default.createElement('br',null),'\u5E74\u7D2F\u8BA1 - \u56FA\u5B9A\u8D44\u4EA7\u53CAFF&E\u8BA1\u63D0'),dataIndex:'YTD',key:'YTD',align:"center",render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text==0?"":text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('YTD',value,index);}}));}},{title:_react2.default.createElement('div',null,'YTD Charges  \u5E74\u7D2F\u8BA1 - \u652F\u51FA'),dataIndex:'charges',key:'charges',align:"center",render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text==0?"":text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('charges',value,index);}}));}},{title:'Closing Balance 当期期末数',dataIndex:'balance',align:"center",key:'balance',render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==5?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):(text||"0").toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title ',id:'table9_6'},_react2.default.createElement(_row2.default,null,'9.6 Capital Expenditure (CAPEX) and FF&E Reserve \u56FA\u5B9A\u8D44\u4EA7\u53CAFF&E\u8BA1\u63D0 :'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_row2.default,{style:{margin:"20px 0"}},_react2.default.createElement(_row2.default,{style:{margin:"10px 0"}},'9.6.1 Comments: (Please list out major CAPEX replacement) \u5907\u6CE8\uFF1A\uFF08\u8BF7\u5217\u4E3E\u4E3B\u8981\u56FA\u5B9A\u8D44\u4EA7\u66F4\u6362\u9879\u76EE\uFF09'),!this.state.loading||this.state.print?_react2.default.createElement(TextArea,{autosize:{minRows:4},placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',value:this.state.data[0]?this.state.data[0].note:"",onChange:function onChange(e){var data=_this2.state.data;data[0].note=e.target.value||"";_this2.setState({data:data});}}):null)),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_9_6'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data9_4=exports.data9_4=[{percent:"0",note:"",year_c:'0',YTD:'0',charges:"0",balance:"0"}];

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(25);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2028);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TextArea=_input2.default.TextArea;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var totalName=['this_Actual','last_Actual','year_this_Actual','year_last_Actual'];var _loop=function _loop(i){data[12][totalName[i]]=data.reduce(function(a,b){if(b.name!='Total'){a+=numConvert(b[totalName[i]]);}return a;},0);data[12][totalName[i]]=data[12][totalName[i]].toFixed(0);};for(var i=0;i<totalName.length;i++){_loop(i);}for(var i=0;i<data.length;i++){data[i].contrast=(numConvert(data[i].this_Actual)-numConvert(data[i].last_Actual)).toFixed(0);data[i].percent=(numConvert(data[i].last_Actual)==0?0:numConvert(data[i].contrast)/numConvert(data[i].last_Actual)).toFixed(3);data[i].year_contrast=(numConvert(data[i].year_this_Actual)-numConvert(data[i].year_last_Actual)).toFixed(0);data[i].year_percent=(numConvert(data[i].year_last_Actual)==0?0:numConvert(data[i].year_contrast)/numConvert(data[i].year_last_Actual)).toFixed(3);}_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;// this.setState({
//     data
// });
_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data7_1_2);var data=JSON.parse(dataBegin);_this.getNote(date);fetch('/_9_7_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.getNote=function(date){fetch('/_9_7_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){_this.setState({note:_extends({},x.data[0])});}}).catch(function(err){console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};if(_this.state.note){_this.onSaveNote([_extends({},_this.state.note,{year:year,month:month})]);}fetch('/add_9_7',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败'+JSON.stringify(err));console.error(err);});};_this.onSaveNote=function(data){var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_9_7_1',headres).then(function(x){return x.json();}).then(function(x){if(x.status==1){// message.success(x.msg);
return;}_message3.default.error('备注保存失败：'+x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table9_7',1.5,'9.70',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,note:{note:""},loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);// this.computeNum(this.state.data)
}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var columns=[{title:'Expenses Item 费用项目',dataIndex:'name',key:'name',align:"center",width:250,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(index==12?'table-color-footer':''),style:{textAlign:"left"}},text);}},{align:"center",title:'Current Month 月累计',children:[{title:_react2.default.createElement('div',null,'Current Month Actual',_react2.default.createElement('br',null),' This Year ',_react2.default.createElement('br',null),'\u672C\u5E74\u5F53\u6708\u5B9E\u9645\u6570'),dataIndex:'this_Actual',key:'this_Actual',align:"center",width:100,render:function render(text,record,index){var title=['Current Month 月累计','Current Month Actual This Year 本年当月实际数'];if(index<=11){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'this_Actual',title:title,sqlName:"_9_7",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text==0?'':text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('this_Actual',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'this_Actual',title:title,sqlName:"_9_7",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==12?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Current Month Actual',_react2.default.createElement('br',null),' Last Year ',_react2.default.createElement('br',null),'\u53BB\u5E74\u5F53\u6708\u5B9E\u9645\u6570'),dataIndex:'last_Actual',key:'last_Actual',align:"center",width:100,render:function render(text,record,index){var title=['Current Month 月累计','Current Month Actual Last Year 去年当月实际数'];if(index<=11){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'last_Actual',title:title,sqlName:"_9_7",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text==0?'':text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('last_Actual',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'last_Actual',title:title,sqlName:"_9_7",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==12?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Current Month Variance',_react2.default.createElement('br',null),'This Year vs. Last Year',_react2.default.createElement('br',null),' \u5F53\u6708\u5DEE\u5F02-\u4ECA\u5E74\u5BF9\u6BD4\u53BB\u5E74'),dataIndex:'contrast',key:'contrast',align:"center",width:100,render:function render(text,record,index){var title=['Current Month 月累计','Current Month Variance This Year vs. Last Year 当月差异-今年对比去年'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'contrast',title:title,sqlName:"_9_7",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==12?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'percent',key:'percent',align:"center",width:100,render:function render(text,record,index){var title=['Current Month 月累计','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'percent',title:title,sqlName:"_9_7",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==12?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]},{align:"center",title:'YTD 年累计',children:[{title:_react2.default.createElement('div',null,'YTD Actual ',_react2.default.createElement('br',null),'This Year',_react2.default.createElement('br',null),'\u5E74\u7D2F\u8BA1\u5B9E\u9645-\u4ECA\u5E74'),dataIndex:'year_this_Actual',key:'year_this_Actual',align:"center",width:100,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual This Year 年累计实际-今年'];if(index<=11){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_this_Actual',title:title,sqlName:"_9_7",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text==0?'':text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('year_this_Actual',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_this_Actual',title:title,sqlName:"_9_7",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==12?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'YTD Actual ',_react2.default.createElement('br',null),' Last Year',_react2.default.createElement('br',null),'\u5E74\u7D2F\u8BA1\u5B9E\u9645-\u53BB\u5E74'),dataIndex:'year_last_Actual',key:'year_last_Actual',align:"center",width:100,render:function render(text,record,index){var title=['YTD 年累计','YTD Actual Last Year 年累计实际-去年'];if(index<=11){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_last_Actual',title:title,sqlName:"_9_7",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',defaultValue:text==0?'':text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(0));_this2.onChange('year_last_Actual',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_last_Actual',title:title,sqlName:"_9_7",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==12?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'YTD Variance',_react2.default.createElement('br',null),'This Year vs. Last Year',_react2.default.createElement('br',null),'\u5E74\u7D2F\u8BA1\u5DEE\u5F02-\u4ECA\u5E74\u5BF9\u6BD4\u53BB\u5E74'),dataIndex:'year_contrast',key:'year_contrast',align:"center",width:100,render:function render(text,record,index){var title=['YTD 年累计','YTD Variance This Year vs. Last Year 年累计差异-今年对比去年'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_contrast',title:title,sqlName:"_9_7",name:record.name,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index==12?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',Math.abs(text),')'):text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:'% 百分比',dataIndex:'year_percent',key:'year_percent',align:"center",width:100,render:function render(text,record,index){var title=['YTD 年累计','% 百分比'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'year_percent',title:title,sqlName:"_9_7",name:record.name,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index==12?'table-color-footer':'')},Number(text)<0?_react2.default.createElement('span',{style:{color:"red"}},'(',(Math.abs(text)*100).toFixed(1)+'%',')'):(text*100).toFixed(1)+'%'));}}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table9_7',style:{width:this.state.print?1850:'auto'}},_react2.default.createElement(_row2.default,null,'9.7 Department Expenses \u90E8\u95E8\u8D39\u7528'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true,note:{note:""}});_this2.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,style:{width:this.state.print?1800:'auto'},scroll:this.state.print?{}:{x:1800},className:'content',rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_row2.default,{style:{margin:"20px 0"}},_react2.default.createElement(_row2.default,{style:{margin:"10px 0"}},'9.7.1  Please critique if variance above +/- 5% \u82E5\u5DEE\u5F02\u6570\u8D85\u8FC7\u4E0A\u4E0B\u767E\u5206\u4E4B\u4E94\u5219\u9700\u505A\u51FA\u4E66\u9762\u89E3\u91CA'),!this.state.loading||this.state.print?_react2.default.createElement(TextArea,{autosize:{minRows:4},placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',defaultValue:this.state.note.note,onBlur:function onBlur(e){_this2.setState({note:_extends({},_this2.state.note,{note:e.target.value})});}}):null)),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_9_7'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data7_1_2=exports.data7_1_2=[{name:"Rooms - Commission 客房 - 佣金",name_code:'Rooms_Commission',this_Actual:"0",last_Actual:"0",contrast:"0",percent:"0",year_this_Actual:"0",year_last_Actual:"0",year_contrast:"0",year_percent:"0"},{name:"Rooms - Complimentary F&B 客房 - 免费餐饮",name_code:'Rooms_Complimentary_F&B',this_Actual:"0",last_Actual:"0",contrast:"0",percent:"0",year_this_Actual:"0",year_last_Actual:"0",year_contrast:"0",year_percent:"0"},{name:"Rooms - Guest Supplies 客房 - 客用品",name_code:'Rooms_Guest_Supplies',this_Actual:"0",last_Actual:"0",contrast:"0",percent:"0",year_this_Actual:"0",year_last_Actual:"0",year_contrast:"0",year_percent:"0"},{name:"Food and Beverage - Entertainment 餐饮 - 宴请",name_code:'Food_and_Beverage_Entertainment',this_Actual:"0",last_Actual:"0",contrast:"0",percent:"0",year_this_Actual:"0",year_last_Actual:"0",year_contrast:"0",year_percent:"0"},{name:"Total Minor Operating 其他总费用",name_code:'Total_Minor_Operating',this_Actual:"0",last_Actual:"0",contrast:"0",percent:"0",year_this_Actual:"0",year_last_Actual:"0",year_contrast:"0",year_percent:"0"},{name:"Executive Office 行政办",name_code:'Executive_Office',this_Actual:"0",last_Actual:"0",contrast:"0",percent:"0",year_this_Actual:"0",year_last_Actual:"0",year_contrast:"0",year_percent:"0"},{name:"Sales & Marketing - Advertisement 市场销售 - 广告费",name_code:'Sales_Marketing_Advertisement',this_Actual:"0",last_Actual:"0",contrast:"0",percent:"0",year_this_Actual:"0",year_last_Actual:"0",year_contrast:"0",year_percent:"0"},{name:"Sales & Marketing - Promotion 市场销售 - 促销费",name_code:'Sales_Marketing_Promotion',this_Actual:"0",last_Actual:"0",contrast:"0",percent:"0",year_this_Actual:"0",year_last_Actual:"0",year_contrast:"0",year_percent:"0"},{name:"Sales & Marketing - Entertainment 市场销售 - 宴请",name_code:'Sales_Marketing_Entertainment',this_Actual:"0",last_Actual:"0",contrast:"0",percent:"0",year_this_Actual:"0",year_last_Actual:"0",year_contrast:"0",year_percent:"0"},{name:"Sales & Marketing - Others 市场销售 - 其他 (不含品牌服务费)",name_code:'Sales_Marketing_Others',this_Actual:"0",last_Actual:"0",contrast:"0",percent:"0",year_this_Actual:"0",year_last_Actual:"0",year_contrast:"0",year_percent:"0"},{name:"Human Resources 人力资源",name_code:'Human_Resources',this_Actual:"0",last_Actual:"0",contrast:"0",percent:"0",year_this_Actual:"0",year_last_Actual:"0",year_contrast:"0",year_percent:"0"},{name:"Maintenance 工程维护费用",name_code:'Maintenance',this_Actual:"0",last_Actual:"0",contrast:"0",percent:"0",year_this_Actual:"0",year_last_Actual:"0",year_contrast:"0",year_percent:"0"},{name:"Total",name_code:'Total',this_Actual:"0",last_Actual:"0",contrast:"0",percent:"0",year_this_Actual:"0",year_last_Actual:"0",year_contrast:"0",year_percent:"0"}];

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.index=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _=__webpack_require__(2030);var _2=_interopRequireDefault(_);var _3=__webpack_require__(2032);var _4=_interopRequireDefault(_3);var _5=__webpack_require__(2034);var _6=_interopRequireDefault(_5);var _7=__webpack_require__(2036);var _8=_interopRequireDefault(_7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=exports.index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",null,_react2.default.createElement(_2.default,this.props),_react2.default.createElement(_4.default,this.props),_react2.default.createElement(_6.default,this.props),_react2.default.createElement(_8.default,this.props));}}]);return index;}(_react.Component);;exports.default=index;

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(25);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2031);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _reactRouterDom=__webpack_require__(85);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TextArea=_input2.default.TextArea;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.handleWindowClose=function(ev){var confirmationMessage="9.8.1 数据还未保存,确定要离开吗?";(ev||window.event).returnValue=confirmationMessage;if(_this.state.isEdit){return confirmationMessage;}};_this.computeNum=function(data){// 计算总额
data[15]['quantity']=0;data[15]['total_amount']=0;for(var i=0;i<15;i++){data[15]['quantity']+=Number(data[i]['quantity']);data[15]['total_amount']+=Number(data[i]['total_amount']);}data[15]['quantity']=data[15]['quantity'].toFixed(2);data[15]['total_amount']=data[15]['total_amount'].toFixed(2);for(var _i=0;_i<16;_i++){data[_i]['average_unit_price']=Number(data[_i]['quantity'])==0?0:(Number(data[_i]['total_amount'])/Number(data[_i]['quantity'])).toFixed(2);data[_i]['total_purchase_percent']=Number(data[15]['total_amount'])==0?0:(Number(data[_i]['total_amount'])/Number(data[15]['total_amount'])*100).toFixed(2);}data[17]['total_amount']=Number(data[16]['total_amount'])==0?0:(Number(data[15]['total_amount'])/Number(data[16]['total_amount'])*100).toFixed(2);_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);_this.setState({isEdit:true});};_this.getTable9_8=function(date){var dataBegin=JSON.stringify(_data.data9_8_default);var data=JSON.parse(dataBegin);// this.setState({
//     data
// })
fetch('/_9_8_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_9_8',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false,isEdit:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getTable9_8(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败'+JSON.stringify(err));console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table9_8_1',1.5,'9.81',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,note:{note:""},loadingSave:false,print:false,isEdit:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getTable9_8(this.state.date);//在关闭页面时弹出确认提示窗口
window.addEventListener('beforeunload',this.handleWindowClose);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('beforeunload',this.handleWindowClose);}// 查询表格9_8的内容
},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var columns=[{title:'Purchase Item 采购项目',dataIndex:'purchase_item',key:'purchase_item',align:"center",render:function render(text,record,index){if(index>=0&&index<=14){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){_this2.onChange('purchase_item',e.target.value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index>14&&index!=16?'table-color-footer':''),style:{textAlign:"left"}},text);}}},{title:'Unit 计量单位',dataIndex:'unit',key:'unit',align:"center",render:function render(text,record,index){if(index>=0&&index<=14){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){_this2.onChange('unit',e.target.value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index>14&&index!=16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}},{title:'Kitchen 厨房',dataIndex:'kitchen',key:'kitchen',align:"center",render:function render(text,record,index){if(index>=0&&index<=14){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){_this2.onChange('kitchen',e.target.value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index>14&&index!=16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}},{align:"center",title:'Current Month Actual - This Year 本年当月',children:[{title:_react2.default.createElement('div',null,'Quantity ',_react2.default.createElement('br',null),'\u91C7\u8D2D\u91CF'),dataIndex:'quantity',key:'quantity',align:"center",render:function render(text,record,index){var title=['Current Month Actual - This Year 本年当月','Quantity 采购量'];if(index>=0&&index<=14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'quantity',title:title,sqlName:"_9_8",name:record.purchase_item,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text==0?'':text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('quantity',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'quantity',title:title,sqlName:"_9_8",name:record.purchase_item,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>14&&index!=16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Average Unit Price',_react2.default.createElement('br',null),'\u5E73\u5747\u5355\u4EF7'),dataIndex:'average_unit_price',key:'average_unit_price',align:"center",render:function render(text,record,index){var title=['Current Month Actual - This Year 本年当月','Average Unit Price 平均单价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'average_unit_price',title:title,sqlName:"_9_8",name:record.purchase_item,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>14&&index!=16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Total Amount',_react2.default.createElement('br',null),'\u91C7\u8D2D\u603B\u91D1\u989D'),dataIndex:'total_amount',key:'total_amount',align:"center",render:function render(text,record,index){var title=['Current Month Actual - This Year 本年当月','Total Amount 采购总金额'];if(index>=0&&index<=14||index==16){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'total_amount',title:title,sqlName:"_9_8",name:record.purchase_item,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text==0?'':text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('total_amount',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'total_amount',title:title,sqlName:"_9_8",name:record.purchase_item,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>14&&index!=16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')+(index==17?'%':'')));}}},{title:'%of Total Purchase',dataIndex:'total_purchase_percent',key:'total_purchase_percent',align:"center",width:140,render:function render(text,record,index){var title=['Current Month Actual - This Year 本年当月','%of Total Purchase'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'total_purchase_percent',title:title,sqlName:"_9_8",name:record.purchase_item,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index>14&&index!=16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')+(index>15?'':'%')));}}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table9_8_1'},_react2.default.createElement(_row2.default,null,'9.8 Food Purchase Top 15 List \u98DF\u54C1\u91C7\u8D2D\u524D15\u4F4D\u6E05\u5355'),_react2.default.createElement(_row2.default,null,'9.8.1 MTD \u6708\u7D2F\u8BA1'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true,note:{note:""}});_this2.getTable9_8(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_9_8'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58'))),this.state.isEdit&&_react2.default.createElement(_reactRouterDom.Prompt,{message:'9.8.1 \u6570\u636E\u8FD8\u672A\u4FDD\u5B58,\u786E\u5B9A\u8981\u79BB\u5F00\u5417?'})));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data9_8_default=exports.data9_8_default=[{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"Top 15 Total 前15位合计",unit:"-",kitchen:"-",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"Total Food Purchase 食品采购总额",unit:"-",kitchen:"-",quantity:"-",average_unit_price:"-",total_amount:0,total_purchase_percent:"-"},{purchase_item:"Top 15 Vs. Total Purchase 前15位采购占总额比率",unit:"-",kitchen:"-",quantity:"-",average_unit_price:"-",total_amount:0,total_purchase_percent:"-"}];

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(35);__webpack_require__(10);__webpack_require__(25);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2033);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _Compared=__webpack_require__(43);var _Compared2=_interopRequireDefault(_Compared);var _reactRouterDom=__webpack_require__(85);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TextArea=_input2.default.TextArea;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.handleWindowClose=function(ev){var confirmationMessage="9.8.2 数据还未保存,确定要离开吗?";(ev||window.event).returnValue=confirmationMessage;if(_this.state.isEdit){return confirmationMessage;}};_this.computeNum=function(data){// 计算总额
data[15]['quantity']=0;data[15]['total_amount']=0;for(var i=0;i<15;i++){data[15]['quantity']+=Number(data[i]['quantity']);data[15]['total_amount']+=Number(data[i]['total_amount']);}data[15]['quantity']=data[15]['quantity'].toFixed(2);data[15]['total_amount']=data[15]['total_amount'].toFixed(2);for(var _i=0;_i<16;_i++){data[_i]['average_unit_price']=Number(data[_i]['quantity'])==0?0:(Number(data[_i]['total_amount'])/Number(data[_i]['quantity'])).toFixed(2);data[_i]['total_purchase_percent']=Number(data[15]['total_amount'])==0?0:(Number(data[_i]['total_amount'])/Number(data[15]['total_amount'])*100).toFixed(2);}data[17]['total_amount']=(Number(data[16]['total_amount'])==0?0:Number(data[15]['total_amount'])/Number(data[16]['total_amount'])*100).toFixed(2);_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);_this.setState({isEdit:true});};_this.getTable9_8=function(date){var dataBegin=JSON.stringify(_data.data9_8_2_default);var data=JSON.parse(dataBegin);fetch('/_9_8_2_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_9_8_2',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false,isEdit:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getTable9_8(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败'+JSON.stringify(err));console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table9_8_2',1.5,'9.82',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,note:{note:""},loadingSave:false,print:false,isEdit:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getTable9_8(this.state.date);//在关闭页面时弹出确认提示窗口
window.addEventListener('beforeunload',this.handleWindowClose);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('beforeunload',this.handleWindowClose);}// 查询表格9_8的内容
},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var columns=[{title:'Purchase Item 采购项目',dataIndex:'purchase_item',key:'purchase_item',align:"center",render:function render(text,record,index){if(index>=0&&index<=14){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){_this2.onChange('purchase_item',e.target.value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index>14&&index!=16?'table-color-footer':''),style:{textAlign:"left"}},text);}}},{title:'Unit 计量单位',dataIndex:'unit',key:'unit',align:"center",render:function render(text,record,index){if(index>=0&&index<=14){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){_this2.onChange('unit',e.target.value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index>14&&index!=16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}},{title:'Kitchen 厨房',dataIndex:'kitchen',key:'kitchen',align:"center",render:function render(text,record,index){if(index>=0&&index<=14){return _react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_input2.default,{className:'table_numInput',defaultValue:text,onBlur:function onBlur(e){_this2.onChange('kitchen',e.target.value,index);}}));}else{return _react2.default.createElement('div',{className:'table-padding '+(index>14&&index!=16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}},{align:"center",title:'Current Month Actual - This Year 本年当月',children:[{title:_react2.default.createElement('div',null,'Quantity ',_react2.default.createElement('br',null),'\u91C7\u8D2D\u91CF'),dataIndex:'quantity',key:'quantity',align:"center",render:function render(text,record,index){var title=['Current Month Actual - This Year 本年当月','Quantity 采购量'];if(index>=0&&index<=14){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'quantity',title:title,sqlName:"_9_8_2",name:record.purchase_item,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text==0?'':text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('quantity',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'quantity',title:title,sqlName:"_9_8_2",name:record.purchase_item,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>14&&index!=16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}}},{title:_react2.default.createElement('div',null,'Average Unit Price',_react2.default.createElement('br',null),'\u5E73\u5747\u5355\u4EF7'),dataIndex:'average_unit_price',key:'average_unit_price',align:"center",render:function render(text,record,index){var title=['Current Month Actual - This Year 本年当月','Average Unit Price 平均单价'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'average_unit_price',title:title,sqlName:"_9_8_2",name:record.purchase_item,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>14&&index!=16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')));}},{title:_react2.default.createElement('div',null,'Total Amount',_react2.default.createElement('br',null),'\u91C7\u8D2D\u603B\u91D1\u989D'),dataIndex:'total_amount',key:'total_amount',align:"center",render:function render(text,record,index){var title=['Current Month Actual - This Year 本年当月','Total Amount 采购总金额'];if(index>=0&&index<=14||index==16){return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'total_amount',title:title,sqlName:"_9_8_2",name:record.purchase_item,type:'number'}},_react2.default.createElement('div',{className:'table-padding table-color-number'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:text==0?'':text,onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this2.onChange('total_amount',value,index);}})));}else{return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'total_amount',title:title,sqlName:"_9_8_2",name:record.purchase_item,type:'number'}},_react2.default.createElement('div',{className:'table-padding '+(index>14&&index!=16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')+(index==17?'%':'')));}}},{title:'%of Total Purchase',dataIndex:'total_purchase_percent',key:'total_purchase_percent',align:"center",width:140,render:function render(text,record,index){var title=['Current Month Actual - This Year 本年当月','%of Total Purchase'];return _react2.default.createElement(_Compared2.default,{data:{index:index,key:'total_purchase_percent',title:title,sqlName:"_9_8_2",name:record.purchase_item,type:'percent'}},_react2.default.createElement('div',{className:'table-padding '+(index>14&&index!=16?'table-color-footer':'')},text.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')+(index>15?'':'%')));}}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table9_8_2'},_react2.default.createElement(_row2.default,null,'9.8.2 YTD \u5E74\u7D2F\u8BA1'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getTable9_8(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_9_8'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58'))),this.state.isEdit&&_react2.default.createElement(_reactRouterDom.Prompt,{message:'9.8.2 \u6570\u636E\u8FD8\u672A\u4FDD\u5B58,\u786E\u5B9A\u8981\u79BB\u5F00\u5417?'})));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data9_8_2_default=exports.data9_8_2_default=[{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"",unit:"",kitchen:"",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"Top 15 Total 前15位合计",unit:"-",kitchen:"-",quantity:0,average_unit_price:0,total_amount:0,total_purchase_percent:0},{purchase_item:"Total Food Purchase 食品采购总额",unit:"-",kitchen:"-",quantity:"-",average_unit_price:"-",total_amount:0,total_purchase_percent:"-"},{purchase_item:"Top 15 Vs. Total Purchase 前15位采购占总额比率",unit:"-",kitchen:"-",quantity:"-",average_unit_price:"-",total_amount:0,total_purchase_percent:"-"}];

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2035);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);_this.setState({isEdit:true});};_this.getTable9_8=function(date){var dataBegin=JSON.stringify(_data.data9_8_2_default);var data=JSON.parse(dataBegin);fetch('/_9_8_3_food_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}else if(x.msg.length){data=x.msg.map(function(v){delete v.id;return v;});}_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_9_8_3_food',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false,isEdit:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getTable9_8(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败'+JSON.stringify(err));console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table9_8_3',1.5,'9.83',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+' '+(0,_moment2.default)(_this.state.date).format('YYYY')+'-\u98DF\u54C1';var innerHtml='\n          <caption>'+tableName+'</caption>\n          <br> \n          '+document.getElementById('t_9_8_3').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n        ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+'.xls');_this.setState({print:false});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,isEdit:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getTable9_8(this.state.date);}// 查询表格9_8的内容
},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,print=_state.print;var columns=[{title:'序号',dataIndex:'index',key:'index',align:"center",render:function render(text,record,index){var props={text:index+1,index:index,type:'text',name:"index",onChange:_this2.onChange,totalIndex:[]};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'类别',dataIndex:'name',key:'name',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this2.onChange,totalIndex:[],compared:{title:['类别'],record:record,sqlName:"_9_8_3_food"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'品牌',dataIndex:'brand',key:'brand',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:print?'text':'input',name:"brand",onChange:_this2.onChange,totalIndex:[],compared:{title:['品牌'],record:record,sqlName:"_9_8_3_food"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'产品名称',dataIndex:'type',key:'type',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:print?'text':'input',name:"type",onChange:_this2.onChange,totalIndex:[],compared:{title:['产品名称'],record:record,sqlName:"_9_8_3_food"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'规格',dataIndex:'size',key:'size',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:print?'text':'input',name:"size",onChange:_this2.onChange,totalIndex:[],compared:{title:['规格'],record:record,sqlName:"_9_8_3_food"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'单位',dataIndex:'unit',key:'unit',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:print?'text':'input',name:"unit",onChange:_this2.onChange,totalIndex:[],compared:{title:['单位'],record:record,sqlName:"_9_8_3_food"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'单价',dataIndex:'price',key:'price',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:print?'number':'inputNumber',name:"price",onChange:_this2.onChange,totalIndex:[],compared:{title:['单价'],record:record,sqlName:"_9_8_3_food"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'年度用量',dataIndex:'annual',key:'annual',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:print?'text':'input',name:"annual",onChange:_this2.onChange,totalIndex:[],compared:{title:['年度用量'],record:record,sqlName:"_9_8_3_food"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'平均每月用量',dataIndex:'aMonth',key:'aMonth',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:print?'text':'input',name:"aMonth",onChange:_this2.onChange,totalIndex:[],compared:{title:['平均每月用量'],record:record,sqlName:"_9_8_3_food"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table9_8_3'},_react2.default.createElement(_row2.default,null,'9.8.3 \u9152\u5E97\u4EA7\u54C1\u4FE1\u606F\u7EDF\u8BA1 - \u98DF\u54C1'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getTable9_8(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'t_9_8_3',pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this2.setState({print:true},function(){_this2.downloadExcel();});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_9_8'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data9_8_2_default=exports.data9_8_2_default=[{name:"茶包",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"茶包",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"速溶咖啡包",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"员工用油",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"客用油",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"客用米",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"员工米",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"矿泉水",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"牛奶",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"早餐肠",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"培根",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"谷物",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"果汁（自助餐）",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""}];

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2037);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);_this.setState({isEdit:true});};_this.getTable9_8=function(date){var dataBegin=JSON.stringify(_data.data9_8_2_default);var data=JSON.parse(dataBegin);fetch('/_9_8_4_supplies_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}else if(x.msg.length){data=x.msg.map(function(v){delete v.id;return v;});}_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_9_8_4_supplies',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false,isEdit:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getTable9_8(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败'+JSON.stringify(err));console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table9_8_4',1.5,'9.84',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+' '+(0,_moment2.default)(_this.state.date).format('YYYY')+'-\u7528\u54C1';var innerHtml='\n          <caption>'+tableName+'</caption>\n          <br> \n          '+document.getElementById('t_9_8_4').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n        ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+'.xls');_this.setState({print:false});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,isEdit:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getTable9_8(this.state.date);}// 查询表格9_8的内容
},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,print=_state.print;var columns=[{title:'序号',dataIndex:'index',key:'index',align:"center",render:function render(text,record,index){var props={text:index+1,index:index,type:'text',name:"index",onChange:_this2.onChange,totalIndex:[]};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'类别',dataIndex:'name',key:'name',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this2.onChange,totalIndex:[]};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'品牌',dataIndex:'brand',key:'brand',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:print?'text':'input',name:"brand",onChange:_this2.onChange,totalIndex:[],compared:{title:['品牌'],record:record,sqlName:"_9_8_4_supplies"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'产品名称',dataIndex:'type',key:'type',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:print?'text':'input',name:"type",onChange:_this2.onChange,totalIndex:[],compared:{title:['产品名称'],record:record,sqlName:"_9_8_4_supplies"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'规格',dataIndex:'size',key:'size',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:print?'text':'input',name:"size",onChange:_this2.onChange,totalIndex:[],compared:{title:['规格'],record:record,sqlName:"_9_8_4_supplies"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'单位',dataIndex:'unit',key:'unit',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:print?'text':'input',name:"unit",onChange:_this2.onChange,totalIndex:[],compared:{title:['单位'],record:record,sqlName:"_9_8_4_supplies"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'单价',dataIndex:'price',key:'price',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:print?'number':'inputNumber',name:"price",onChange:_this2.onChange,totalIndex:[],compared:{title:['单价'],record:record,sqlName:"_9_8_4_supplies"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'年度用量',dataIndex:'annual',key:'annual',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:print?'text':'input',name:"annual",onChange:_this2.onChange,totalIndex:[],compared:{title:['年度用量'],record:record,sqlName:"_9_8_4_supplies"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'平均每月用量',dataIndex:'aMonth',key:'aMonth',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:print?'text':'input',name:"aMonth",onChange:_this2.onChange,totalIndex:[],compared:{title:['平均每月用量'],record:record,sqlName:"_9_8_4_supplies"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table9_8_4'},_react2.default.createElement(_row2.default,null,'9.8.4 \u9152\u5E97\u4EA7\u54C1\u4FE1\u606F\u7EDF\u8BA1 - \u7528\u54C1'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getTable9_8(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'t_9_8_4',pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this2.setState({print:true},function(){_this2.downloadExcel();});},loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_9_8'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data9_8_2_default=exports.data9_8_2_default=[{name:"餐饮用纸",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"客房用纸",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"餐饮洗涤剂",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"餐饮催干剂",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"客房全能水",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"客房高泡地毯水",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"洗衣房主洗液",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"洗衣房碱液",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"洗衣房柔顺剂",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"拖鞋",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"洗发水",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"护发素",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"沐浴露",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""},{name:"润肤露",type:"",brand:"",size:"",unit:"",price:0,annual:"",aMonth:""}];

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _alert=__webpack_require__(83);var _alert2=_interopRequireDefault(_alert);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(84);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2039);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _compute=__webpack_require__(2040);var _compute2=_interopRequireDefault(_compute);var _IsLableAuth=__webpack_require__(107);var _IsLableAuth2=_interopRequireDefault(_IsLableAuth);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){data=(0,_compute2.default)(data);_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.dataDefault);var data=JSON.parse(dataBegin);fetch('/_9_9_info?year='+(0,_moment2.default)(date).format('YYYY'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var data=_this.state.data.map(function(x){return _extends({},x,{year:year});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_9_9',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败'+JSON.stringify(err));console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table9_7',1.5,'9.90',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().format('YYYY'),data:[],loading:true,loadingSave:false,print:false,dateData:[]};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);var date=Number(this.state.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var totalIndex=[9,11];var width=document.body.offsetWidth-1950>300?document.body.offsetWidth-1950:300;var columns=[{title:'-',dataIndex:'name',key:'name',fixed:'left',align:"center",width:width,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}].concat(_toConsumableArray(_data.dataColumns.map(function(item){return{title:item.title,dataIndex:item.name,key:item.name,align:"center",width:150,render:function render(text,record,index){var type=item.type;if([].concat(totalIndex,[10]).includes(index)){type="number";}if(index>9&&item.name==='Total'){type="-";}var props={text:text,index:index,type:type,name:item.name,onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:[item.title],record:record,sqlName:"_9_9"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}};})));return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table9_7',style:{width:this.state.print?2300:'auto'}},_react2.default.createElement(_row2.default,null,'9.9 Rebate Summary \u6536\u5165\u62B5\u51CF\u6C47\u603B'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(_select2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u4EFD',style:{width:120},value:this.state.date,onChange:function onChange(str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}},this.state.dateData.map(function(x,i){return _react2.default.createElement(Option,{value:x,key:x},x);}))),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,style:{width:this.state.print?2250:'auto'},scroll:this.state.print?{}:{x:2250},className:'content',rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_alert2.default,{message:_react2.default.createElement('div',null,'\u8868\u683C\u5173\u8054',_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:'read_1'},this.props,{path:'/table/1'}),'1.1')),type:'info',showIcon:true,style:{display:"inline-block",marginRight:10}}),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_9_7'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var dataDefault=exports.dataDefault=[{name:"Room Charge 房费",Jan:0,Feb:0,Mar:0,Apr:0,May:0,Jun:0,Jul:0,Aug:0,Sep:0,Oct:0,Nov:0,Dec:0,Total:0},{name:"Telephone Charge 电话费",Jan:0,Feb:0,Mar:0,Apr:0,May:0,Jun:0,Jul:0,Aug:0,Sep:0,Oct:0,Nov:0,Dec:0,Total:0},{name:"Business Centre 商务中心",Jan:0,Feb:0,Mar:0,Apr:0,May:0,Jun:0,Jul:0,Aug:0,Sep:0,Oct:0,Nov:0,Dec:0,Total:0},{name:"Laundry 洗衣",Jan:0,Feb:0,Mar:0,Apr:0,May:0,Jun:0,Jul:0,Aug:0,Sep:0,Oct:0,Nov:0,Dec:0,Total:0},{name:"Limousine 车费",Jan:0,Feb:0,Mar:0,Apr:0,May:0,Jun:0,Jul:0,Aug:0,Sep:0,Oct:0,Nov:0,Dec:0,Total:0},{name:"Tenant's Ledger 外租单位挂帐",Jan:0,Feb:0,Mar:0,Apr:0,May:0,Jun:0,Jul:0,Aug:0,Sep:0,Oct:0,Nov:0,Dec:0,Total:0},{name:"Misc.& Other 杂费及其它",Jan:0,Feb:0,Mar:0,Apr:0,May:0,Jun:0,Jul:0,Aug:0,Sep:0,Oct:0,Nov:0,Dec:0,Total:0},{name:"Food & Beverage 食品及酒水",Jan:0,Feb:0,Mar:0,Apr:0,May:0,Jun:0,Jul:0,Aug:0,Sep:0,Oct:0,Nov:0,Dec:0,Total:0},{name:"Mini Bar Charge 迷你吧",Jan:0,Feb:0,Mar:0,Apr:0,May:0,Jun:0,Jul:0,Aug:0,Sep:0,Oct:0,Nov:0,Dec:0,Total:0},{name:"Total",Jan:0,Feb:0,Mar:0,Apr:0,May:0,Jun:0,Jul:0,Aug:0,Sep:0,Oct:0,Nov:0,Dec:0,Total:0},{name:"Rooms & F&B Revenue ",Jan:0,Feb:0,Mar:0,Apr:0,May:0,Jun:0,Jul:0,Aug:0,Sep:0,Oct:0,Nov:0,Dec:0,Total:0},{name:"-",Jan:0,Feb:0,Mar:0,Apr:0,May:0,Jun:0,Jul:0,Aug:0,Sep:0,Oct:0,Nov:0,Dec:0,Total:0}];var dataColumns=exports.dataColumns=[{title:"Jan",name:"Jan",type:"inputNumber"},{title:"Feb",name:"Feb",type:"inputNumber"},{title:"Mar",name:"Mar",type:"inputNumber"},{title:"Apr",name:"Apr",type:"inputNumber"},{title:"May",name:"May",type:"inputNumber"},{title:"Jun",name:"Jun",type:"inputNumber"},{title:"Jul",name:"Jul",type:"inputNumber"},{title:"Aug",name:"Aug",type:"inputNumber"},{title:"Sep",name:"Sep",type:"inputNumber"},{title:"Oct",name:"Oct",type:"inputNumber"},{title:"Nov",name:"Nov",type:"inputNumber"},{title:"Dec",name:"Dec",type:"inputNumber"},{title:"Total",name:"Total",type:"number"}];

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=compute;var _method=__webpack_require__(20);function compute(data){var listName=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];listName.forEach(function(name){data[9][name]=data.reduce(function(a,b,i){if(i<9){a+=(0,_method.numConvert)(b[name]);}return a;},0).toFixed(2);});data.forEach(function(item,i){if(i<10){data[i]['Total']=listName.reduce(function(a,b){a+=(0,_method.numConvert)(item[b]);return a;},0).toFixed(2);}});[].concat(listName,['Total']).forEach(function(name){data[11][name]=(0,_method.calculation)(data[9][name],data[10][name],2);});return data;}

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(6);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2042);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _=__webpack_require__(2043);var _2=_interopRequireDefault(_);var _3=__webpack_require__(2044);var _4=_interopRequireDefault(_3);var _5=__webpack_require__(2045);var _6=_interopRequireDefault(_5);var _7=__webpack_require__(2046);var _8=_interopRequireDefault(_7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var totalIndexFooter=[0,24,26,32,44,50,54,59];var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(data){var dataTotal,dataFoot;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dataTotal=[];totalIndexFooter.forEach(function(index,i){var file=data.reduce(function(a,b,j){if(j>index&&j<(totalIndexFooter[i+1]||data.length)){a+=numConvert(b.name);}return a;},0).toFixed(2);dataTotal[i]=_extends({},data[index],{file:file,control:(numConvert(data[index].risks)==0?0:file/numConvert(data[index].risks)).toFixed(4)});});dataTotal.push({name:"-",sort:dataTotal.length,risks:dataTotal.reduce(function(a,b){a+=numConvert(b.risks);return a;},0).toFixed(2),file:"",control:""});dataFoot=[{value:dataTotal.reduce(function(a,b){a+=numConvert(b.file);return a;},0).toFixed(2),name:"Total Points"},{name:"Total Target Points",value:dataTotal[dataTotal.length-1].risks},{name:"%",value:(numConvert(dataTotal[dataTotal.length-1].risks)==0?0:dataTotal.reduce(function(a,b){a+=numConvert(b.file);return a;},0)/numConvert(dataTotal[dataTotal.length-1].risks)).toFixed(2)}];_this.setState({data:data,dataTotal:dataTotal,dataFoot:dataFoot});case 5:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x2){return _ref.apply(this,arguments);};}();_this.onChange=function(name,data,flag){if(flag){_this.setState(_defineProperty({},data,data));return;}_this.computeNum(data);};_this.getDateData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(date,isLastMonth){var dataBegin,data,dataBeginInput,dataInput;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dataBegin=JSON.stringify(_data.dataDefault);data=JSON.parse(dataBegin);dataBeginInput=JSON.stringify(_data.dataInputDefault);dataInput=JSON.parse(dataBeginInput);if(!isLastMonth){_context2.next=9;break;}date=(0,_moment2.default)(date).subtract(1,'month').format('YYYY-MM');if(!_this.state.data.some(function(x){return x.id;})){_context2.next=8;break;}return _context2.abrupt('return',_message3.default.error('当月数据已存在，无法填充！'));case 8:_this.setState({data:[],dataInput:[],loading:true});case 9:fetch('/_controll_2_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('MM'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.table&&x.data.table.length>0){data=x.data.table.sort(function(a,b){return numConvert(a.sort)-numConvert(b.sort);});}if(x.data.dataInput&&x.data.dataInput.length>0){dataInput=x.data.dataInput;}if(isLastMonth){data=data.map(function(x){delete x.id;return x;});dataInput=dataInput.map(function(x){delete x.id;return x;});}_this.setState({loading:false,dataInput:dataInput},function(){_this.computeNum(data);});}).catch(function(err){_this.setState({loading:false});console.error(err);});case 10:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x3,_x4){return _ref2.apply(this,arguments);};}();_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("MM");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataInput=_this.state.dataInput.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify({data:data,dataInput:dataInput}));console.log({data:data,dataInput:dataInput});var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/controllAdd_2_1',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data.every(function(x){return x.id;})){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table2_1',1.5,'9.10',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,update:false,dataTotal:[],dataFoot:[],dataInput:[]};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this3=this;return _react2.default.createElement('div',{className:'table'},_react2.default.createElement(_row2.default,{className:'title',id:'table2_1'},_react2.default.createElement(_row2.default,null,'9.10 Finance Internal Control Checklist \u8D22\u52A1\u5185\u90E8\u63A7\u5236\u6E05\u5355'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true,dataInput:[],dataFoot:[],dataTotal:[]});_this3.getDateData(str);}}),_react2.default.createElement(_button2.default,{type:'primary',style:{marginLeft:10,display:this.state.print?'none':''},onClick:this.getDateData.bind(this,this.state.date,true)},'\u586B\u5145\u4E0A\u6708\u6570\u636E')),_react2.default.createElement(_2.default,{loading:this.state.loading,print:this.state.print,data:this.state.data,onChange:this.onChange}),_react2.default.createElement(_4.default,{loading:this.state.loading,print:this.state.print,data:this.state.dataTotal}),_react2.default.createElement(_6.default,{loading:this.state.loading,print:this.state.print,data:this.state.dataFoot}),_react2.default.createElement(_8.default,{loading:this.state.loading,print:this.state.print,data:this.state.dataInput,onChange:this.onChange})),_react2.default.createElement(_Auth2.default,{auth:'edit_9_10'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58'))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var dataDefault=exports.dataDefault=[{sort:0,name:"Accounting",risks:"23",file:"",control:""},{sort:1,name:"0",risks:"Cash Audit\t once per week performed by someone other than General Cashier. Forwarded to\n    DOF once per week.  Cash Flow should be as the same as System. Discrepancies are \n    documented\t and followed up on promptly.<br/>\n    \u603B\u51FA\u7EB3\u5907\u7528\u91D1\u5E94\u6BCF\u5468\u7531\u975E\u603B\u51FA\u7EB3\u4EBA\u5458\u53C2\u4E0E\u68C0\u67E5\u4E00\u6B21 \uFF0C\u5C06\u7ED3\u679C\u6284\u9001\u8D22\u52A1\u603B\u76D1\u3002\u73B0\u91D1\u6D41\u5E94\u4E0E\u7CFB\u7EDF\u8BB0\u5F55\u4E00\n    \u81F4\u3002\u6240\u6709\u5DEE\u5F02\u5E94\u6B63\u786E\u8BB0\u5F55\u5E76\u7ACB\u5373\u8DDF\u8FDB \u3002\n    ",file:"总出纳现金盘点表",control:""},{sort:2,name:"0",risks:"Bank audits\t performed by General Cashier and another hotel associate each month \n    Discrepancies are documented and followed up on promptly.  All bank reconciliations \n    completed once per month and approved by DOF.  All reconciliations should be completed\n    within 10 days.<br/>\n    \u94F6\u884C\u8D26\u6237\u5BA1\u67E5\u5E94\u7531\u603B\u51FA\u7EB3\u548C\u5176\u4ED6\u5458\u5DE5\u6BCF\u6708\u8FDB\u884C\u4E00\u6B21\t\uFF0C\u6240\u6709\u5DEE\u5F02\u5E94\u6B63\u786E\u8BB0\u5F55\u5E76\u8DDF\u8FDB\u3002\u6240\u6709\u94F6\u884C\u4F59\u989D\u8C03\n    \u8282\u8868\u9700\u6BCF\u6708\u5B8C\u6210\t\uFF0C\u5E76\u4EA4\u8D22\u52A1\u603B\u76D1\u5BA1\u9605\u3002\u6240\u6709\u7684\u8C03\u8282\u9879\u76EE\u5E94\u5728\u6708\u521D\u5341\u65E5\u5185\u5B8C\u6210\u3002\n    ",file:"银行余额调节表",control:""},{sort:3,name:"0",risks:"Rebates, discounts,\t complimentary, entertainment, duty meal audited and forwarded to \n    DOF/GM. And\t reviewed in the monthly P&L Meeting.<br/>\n    \u62B5\u51CF\uFF0C\u6298\u6263\t\uFF0C\u514D\u8D39\uFF0C\u5BB4\u8BF7\uFF0C\u5185\u90E8\u8D26\u5355\uFF0C\u7B49\u6536\u5165\u51CF\u9879\u9700\u6BCF\u6708\u5236\u4F5C\u6C47\u603B\u8868\uFF0C\u4EA4\u7531\u8D22\u52A1\u603B\u76D1\uFF0C\u603B\u7ECF\u7406\u5BA1 \n    \u9605\uFF0C\u5E76\u5728\u6BCF\u6708\u635F\u76CA\u4F1A\u4E0A\u5BA1\u9605 \u3002\n    ",file:"收入减项月度汇总表",control:""},{sort:4,name:"0",risks:"All local and Country tax regulations are properly administered. Tax payments are made timely \n    and in accordance with local laws.<br/>\n    \u6240\u6709\u56FD\u5BB6\u548C\u5F53\u5730\u7684\u7A0E\u52A1\u6CD5\u89C4\u5E94\u6B63\u786E\u5B9E\u65BD\t\u3002\u6BCF\u6708\u5E94\u6309\u7167\u6CD5\u5F8B\u6CD5\u89C4\u53CA\u65F6\u7F34\u7EB3\u5404\u79CD\u7A0E\u8D39\u3002\n    ",file:"",control:""},{sort:5,name:"0",risks:"Guest Ledger to City Ledger Tracking in place to determine number of days to produce and\n    send a bill. Transfer to City Ledger takes less than 3 days. Cycle time, including issuing a bill, \n    is six days or less.<br/>\n    \u5BA2\u8D26\u8F6C\u57CE\u5E02\u6302\u8D26\u7684\u8F6C\u79FB\u5E94\u53CA\u65F6\u8DDF\u8FDB\t\uFF0C\u5E76\u57283\u65E5\u5185\u5B8C\u6210\u3002\u5728\u6700\u591A6\u65E5\u5185\u5B8C\u6210\u5185\u90E8\u5BA1\u6279\uFF0C\u5BC4\u51FA\u8D26\u5355\u3002\n    ",file:"当日假房清单",control:""},{sort:6,name:"0",risks:"DCSO (days of credit sales outstanding) tracking mechanism in place to monitor weekly and \n    monthly collection results. A/R aging report reviewed weekly by A/R supervisor and monthly by \n    DOF.<br/>\n    \u5E94\u6536\u8D26\u6B3E\u8D26\u9F84\u5206\u6790\u5E94\u5728\u6BCF\u5468\u548C\u6BCF\u6708\u8FDB\u884C\u603B\u7ED3\u3002\u8D26\u9F84\u5206\u6790\u8868\u5E94\u5728\u6BCF\u5468\u4EA4\u7531\u5E94\u6536\u4E3B\u7BA1\u5BA1\u9605\uFF0C\u6BCF\u6708\u7531\u8D22\u52A1 \n    \u603B\u76D1\u5BA1\u9605\u3002\n    ",file:"应收账款账龄表",control:""},{sort:7,name:"0",risks:"A/R Supervisor forwards weekly recap of all incoming credit decision to sales, catering, for the \n    next 30-45 days.  A/R supervises daily balances of in house groups to ensure credit limits are \n    not exceeded. Credit Meeting and Meeting Minutes should be taken each month and recorded. <br/>\n    \u5E94\u6536\u4E3B\u7BA1\u5E94\u6BCF\u5468\u5236\u4F5C\u5E94\u6536\u8D26\u6B3E\u5206\u6790\u8868\uFF0C\u5E76\u786E\u8BA4\u5BA2\u6237\u7684\u6743\u9650\u672A\u8D85\u51FA\u989D\u5EA6\u548C\u6536\u6B3E\u65F6\u9650\u3002\u4FE1\u8D37\u4F1A\u8BAE\u5E94\u5728\u6700 \n    \u5C11\u6BCF\u6708\u53EC\u5F00\u4E00\u6B21\u5E76\u6709\u4F1A\u8BAE\u8BB0\u5F55\u3002 \n    ",file:"连续三次的信贷会议纪要",control:""},{sort:8,name:"0",risks:"A/R accounts for Airline crews, wholesalers, Wyndham rewards, and credit cards are \n    reconciled. Any non-current balances in these accounts have documented collection efforts \n    underway.<br/>\n    \u9488\u5BF9\u673A\u7EC4\uFF0C\u65C5\u884C\u793E\u3001\u6E29\u5FB7\u59C6\u79EF\u5206\u8BA1\u5212\u3001\u4FE1\u7528\u5361\u7B49\u7684\u5E94\u6536\u8D26\u6237\u5E94\u53CA\u65F6\u66F4\u65B0\u3002\u5982\u6709\u5386\u53F2\u95EE\u9898\uFF0C\u5E94\u53CA\u65F6\u8FFD \n    \u6536\u89E3\u51B3\uFF0C\u76F8\u5173\u6587\u4EF6\u5E94\u5F52\u6863\u3002\n    ",file:"积分计划会员列表前30位",control:""},{sort:9,name:"0",risks:"Credit card refunds charge back are restricted to non A/R clerk.\xA0 The GM and DOF approves  \n    monthly refunds and charge-back reconciliation.<br/>\n    \u4FE1\u7528\u5361\u9000\u6B3E\u4E1A\u52A1\u5FC5\u987B\u7ECF\u7531\u5E94\u6536\u8D26\u6B3E\u6587\u5458\u64CD\u4F5C\uFF0C\u8D22\u52A1\u603B\u76D1\u548C\u603B\u7ECF\u7406\u5BF9\u6BCF\u6708\u7684\u9000\u6B3E\u8FDB\u884C\u5BA1\u6279\u3002\n    ",file:"信用卡退款实例现金支付实例",control:""},{sort:10,name:"0",risks:"Complete reconciliation of all checks written, voided, destroyed, stored, and lost is maintained \n    by Accounts Payable.<br/>\n    \u6240\u6709\u652F\u7968\u7684\u586B\u5199\uFF0C\u65E0\u6548\uFF0C\u4F5C\u5E9F\uFF0C\u4FDD\u5B58\uFF0C\u4E22\u5931\u7684\u8BB0\u5F55\u5747\u5E94\u7531\u5E94\u4ED8\u8D26\u6B3E\u8D1F\u8D23\u3002\n    ",file:"支票记录表",control:""},{sort:11,name:"0",risks:"Howard Johnson Inter-Company billings are posted and paid on a timely basis. Wire transfer \n    payments are properly processed and there are no unapplied payment amounts on the \n    Corporate A/R aging report.<br/>\n    \u53CA\u65F6\u8BB0\u5F55\u548C\u652F\u4ED8\u96C6\u56E2\u9152\u5E97\u4E4B\u95F4\u7684\u5E10\u76EE , \u6B63\u786E\u5904\u7406\u7535\u6C47 , \u5E76\u786E\u4FDD\u6309\u65F6\u652F\u4ED8\u603B\u90E8\u7684\u6B3E\u9879\u3002\n    ",file:"未支付总部款项清单",control:""},{sort:12,name:"0",risks:"Balance sheet reconciliations are completed and approved by the DOF/General Manager in\n    accordance with Corporate policy.  Exception is followed up and resolved where applicable and\n    repeat issues are minimized.<br/>\n    \u8D44\u4EA7\u8D1F\u503A\u8868\u8C03\u8282\u5E94\u6BCF\u6708\u5B8C\u6210\uFF0C\u5E76\u4EA4\u7531\u8D22\u52A1\u603B\u76D1\u3001\u603B\u7ECF\u7406\u5BA1\u9605\u3002\u6240\u6709\u8C03\u6574\u9879\u5E94\u53CA\u65F6\u8C03\u6574\uFF0C\u51CF\u5C11\u91CD\u590D\u6027 \n    \u95EE\u9898\u3002\n    ",file:"资产负债表调节表",control:""},{sort:13,name:"0",risks:"Cash Flow Projection Analysis reviewed by DOF/GM each month.  Analysis comparing actual \n    balances with standards are reviewed.  Actions taken to resolve significant variations are \n    documented.<br/>\n    \u73B0\u91D1\u6D41\u91CF\u9884\u6D4B\u5206\u6790\u5E94\u6BCF\u6708\u7531\u8D22\u52A1\u603B\u76D1\u548C\u603B\u7ECF\u7406\u5BA1\u9605\u3002\u5E94\u6709\u5177\u4F53\u7684\u884C\u52A8\u8BA1\u5212\u89E3\u51B3\u91CD\u8981\u7684\u5DEE\u5F02\u5E76\u5907\u6848\u3002\n    ",file:"现金流量月度分析",control:""},{sort:14,name:"0",risks:"Inventory stock taken is finished properly monthly. All the results should be followed. Slow \n    moving items list should be reviewed by management. <br/>\n    \u5B58\u8D27\u76D8\u70B9\u5E94\u6BCF\u6708\u6B63\u786E\u5B8C\u6210\u3002\u76D8\u76C8\u76D8\u4E8F\u7684\u7ED3\u679C\u5E94\u53CA\u65F6\u8DDF\u8FDB\u3002\u6EDE\u9500\u54C1\u9879\u76EE\u6E05\u5355\u5E94\u7531\u7BA1\u7406\u5C42\u5BA1\u9605\u3002\n    ",file:"存货盘点清单，以及跟进报告，滞销品清单",control:""},{sort:15,name:"0",risks:"Procurement policy is established at the hotel.  Policy hi-lights approval level required for \n    purchase orders and bid requirements.  A segregation of duty exists between purchasing and\n    receiving.<br/>\n    \u91C7\u8D2D\u653F\u7B56\u5E94\u5EFA\u7ACB\uFF0C\u5BF9\u4E8E\u91C7\u8D2D\u8BA2\u5355\u7684\u5BA1\u6279\u548C\u62DB\u6807\u8981\u6C42\u5E94\u91CD\u70B9\u8DDF\u8FDB\u3002\u91C7\u8D2D\u548C\u6536\u8D27\u7684\u6743\u8D23\u5206\u79BB\u5E94\u660E\u786E\u3002\n    ",file:"采购制度",control:""},{sort:16,name:"0",risks:"Expenses reports audited by DOF and approved by General Manager.<br/>\n    \u8D39\u7528\u62A5\u544A\u5E94\u7531\u8D22\u52A1\u603B\u76D1\u5BA1\u9605\uFF0C\u5E76\u7531\u603B\u7ECF\u7406\u5BA1\u6279\u3002\n    ",file:"费用报告",control:""},{sort:17,name:"0",risks:"Contracts, Permits, Licenses, and Insurance certificates maintained and expiration listing \n    reviewed on a quarterly basis by DOF and General Manager.<br/>\n    \u5408\u540C\uFF0C\u8BB8\u53EF\u8BC1\uFF0C\u6267\u7167\u4EE5\u53CA\u4FDD\u9669\u5408\u540C\uFF0C\u5E94\u5F52\u6863\u3002\u5E76\u5EFA\u7ACB\u671F\u9650\u6E05\u5355\u6BCF\u5B63\u5EA6\u4EA4\u7531\u8D22\u52A1\u603B\u76D1\u548C\u603B\u7ECF\u7406\u5BA1\u9605\u3002\n    ",file:"文件资料归档清单",control:""},{sort:18,name:"0",risks:"Appropriate segregation of duties exists for the preparation, review, and approval of all journal \n    vouchers prior to their being posted into accounting system.<br/>\n    \u5BF9\u4E8E\u4F1A\u8BA1\u51ED\u8BC1\u7684\u7F16\u8F91\u3001\u68C0\u67E5\u548C\u5BA1\u6279\uFF0C\u5E94\u6709\u5408\u9002\u7684\u6743\u8D23\u5206\u79BB\u3002\n    ",file:"最近一月财务凭证审查",control:""},{sort:19,name:"0",risks:"Shopping audits in place twice a year.<br/>\u795E\u79D8\u8BBF\u5BA2\u5E94\u6BCF\u534A\u5E74\u5B89\u6392\u4E00\u6B21\u3002",file:"最近一次神秘访客报告",control:""},{sort:20,name:"0",risks:"Follow the guideline of Operating Equipments Accounting Treatment. Do the physical  \n    inspection on quarter basis and analysis on the consumption.<br/>\n    \u6267\u884C\u8425\u8FD0\u5DE5\u5177\u4F1A\u8BA1\u5904\u7406\uFF0C\u6BCF\u5B63\u5EA6\u8FDB\u884C\u5B9E\u7269\u76D8\u70B9\u5E76\u8DDF\u8FDB\u5206\u6790\u3002\n    ",file:"最近一期的营运工具盘点分析报告",control:""},{sort:21,name:"0",risks:"The policy of Owner's discount is accomplished according to the Standard Operating \n    Procedure.<br/>\n    \u4E25\u683C\u9075\u5B88SOP\u4E2D\u4E1A\u4E3B\u6298\u6263\u7684\u89C4\u5B9A\u3002\n    ",file:"业主消费的会计凭证",control:""},{sort:22,name:"0",risks:"The vacation and overtime are recorded properly. <br/>\n    \u5047\u671F\u548C\u52A0\u73ED\u5E94\u6B63\u786E\u8BB0\u5F55\u3002\n    ",file:"假期和加班的会计凭证",control:""},{sort:23,name:"0",risks:"Year End Bonus provision are accrued and adjusted according to the Standard Operating  \n    Procedure.<br/>\n    \u5E74\u5EA6\u5956\u91D1\u9884\u63D0\u548C\u8C03\u6574\u5E94\u6839\u636E\u6807\u51C6\u64CD\u4F5C\u6D41\u7A0B\u6267\u884C\u3002\n    ",file:"奖金预提会计凭证",control:""},{sort:24,name:"Sales & Marketing",risks:"1",file:"",control:""},{sort:25,name:"0",risks:"Three-month rolling forecast is prepared and reviewed. Segment breakout need dates hi-\n    lighted for pricing and promotional opportunities every month.  Group booking pace reviewed at \n    forecast meeting.  Forecast accuracy reviewed in every forecast meeting.<br/>\n    \u7F16\u8F91\u548C\u5BA1\u9605\u9152\u5E973\u4E2A\u6708\u7684\u6536\u5165\u9884\u6D4B\u62A5\u544A\u3002\u5E02\u573A\u5206\u5272\u5E94\u6CE8\u660E\u6BCF\u6708\u8FDB\u884C\u4EF7\u683C\u8C03\u6574\u548C\u4FC3\u9500\u7684\u7279\u5B9A\u65E5\u671F\u3002\u56E2 \n    \u961F\u9884\u5B9A\u60C5\u51B5\u5E94\u5728\u9884\u6D4B\u4F1A\u8BAE\u4E2D\u5BA1\u9605\u3002 \u5728\u6536\u5165\u9884\u6D4B\u4F1A\u8BAE\u4E2D\u5E94\u5BA1\u9605\u6574\u4F53\u9884\u6D4B\u7684\u51C6\u786E\u6027\u3002\n    ",file:"收入预测报告",control:""},{sort:26,name:"Rooms",risks:"5",file:"",control:""},{sort:27,name:"0",risks:"Rooms Revenue Audit performed by General Manager (designated person) against a room\n    revenue policy.  Comps, Rebates and write -offs reviewed and approved appropriately; include \n    evidence of review.<br/>\n    \u603B\u7ECF\u7406 ( \u6216\u6307\u6D3E\u4ED6\u4EBA ) \u6BCF\u65E5\u68C0\u67E5\u5BA2\u623F\u6536\u5165\u3002\u5E76\u68C0\u67E5\u5305\u62EC \u514D\u8D39\u623F , \u623F\u4EF7\u51CF\u514D\u53CA\u53D6\u6D88\u7684\u5BA1\u6279 , \u53CA\u4E66\u9762\u6279\u793A\u3002\n    ",file:"",control:""},{sort:28,name:"0",risks:"Market codes and rates are reviewed according to sale strategy.<br/>\n    \u6839\u636E\u9500\u552E\u8BA1\u5212\u68C0\u67E5\u5E02\u573A\u4EE3\u7801\u548C\u623F\u4EF7\n    ",file:"",control:""},{sort:29,name:"0",risks:"Rate changes and upgrades reviewed daily by DOR.<br/>\n    \u623F\u52A1\u603B\u76D1\u6BCF\u65E5\u68C0\u67E5\u623F\u4EF7\u53D8\u66F4\u548C\u5347\u7EA7\n    ",file:"",control:""},{sort:30,name:"0",risks:"Top Wyndham report is reviewed and signed by the General Manager and all Executive \n    Committee members to indicate that all individuals listed on the report are identified as VIPs.\n    \u603B\u7ECF\u7406\u5BA1\u9605\u5E76\u7B7E\u6279\u6E29\u5FB7\u59C6\u5BA2\u4EBA\u6C47\u603B\u62A5\u8868\uFF0C\u5176\u4E2D\u7684\u6563\u5BA2\u540D\u5355\uFF0C\u7ECF\u884C\u653F\u59D4\u5458\u4F1A\u6210\u5458\u5546\u8BA8\u540E\uFF0C\u53EF\u5C06\u4F5C\u4E3A\u9152<br/>\n    \u5E97\u7684\u91CD\u8981\u5BA2\u4EBA\u3002\n    ",file:"温德姆客人汇总报表",control:""},{sort:31,name:"0",risks:"Housekeeping Discrepancy report.  Housekeeping and Front Office to prepare daily  \n    discrepancy report.  Reports for week to be forwarded to General Manager and DOF weekly. <br/>\n    \u5BA2\u623F\u90E8\u4E0E\u524D\u53F0\u6BCF\u65E5\u4E0A\u62A5\u5BA2\u623F\u5DEE\u5F02\u62A5\u544A\uFF0C\u6BCF\u5468\u5448\u9001 \u603B\u7ECF\u7406\u548C\u8D22\u52A1\u603B\u76D1\u5BA1\u9605\u3002\n    ",file:"客房差异报告",control:""},{sort:32,name:"Food and Beverage",risks:"11",file:"",control:""},{sort:33,name:"0",risks:"Key food and beverage revenue controls in place and audited daily by Accounting.  Open Food /  \n    Beverage, void & cancel, and discount control reviewed by management.<br/>\n    \u8D22\u52A1\u90E8\u6BCF\u65E5\u5BA1\u8BA1\u9910\u996E\u6536\u5165\u3002\u5F00\u4EF7\u98DF\u54C1/\u9152\u6C34\uFF0C\u83DC\u54C1\u53D6\u6D88\u53CA\u83DC\u5355\u6574\u5F20\u53D6\u6D88\u5E94\u7531\u7BA1\u7406\u5C42\u5BA1\u6838\u3002\n    ",file:"",control:""},{sort:34,name:"0",risks:"All package pricing is correctly programmed in PMS (property management system) to fairly\n    allocate revenues to appropriate outlets. Outlet postings of actual customer usage is properly \n    recorded and routinely audited for accuracy. Breakage is analyzed and package pricing and \n    allocation reviewed accordingly. <br/>\n    \u6240\u6709\u5957\u9910\u552E\u4EF7\u5E94\u6B63\u786E\u8F93\u5165\u7BA1\u7406\u7CFB\u7EDF\uFF0C\u4EE5\u4FBF\u5408\u7406\u5206\u914D\u90E8\u95E8\u6536\u5165\u3002 \u6B63\u786E\u8BB0\u5F55\u5E76\u51C6\u786E\u68C0\u67E5\u5BA2\u4EBA\u5728\u8425\u4E1A\u573A \n    \u6240\u7684\u5B9E\u9645\u6D88\u8D39\uFF0C\u68C0\u67E5\u6574\u4F53\u5305\u4EF7\u548C\u6536\u5165\u5206\u914D\u3002\n    ",file:"",control:""},{sort:35,name:"0",risks:"Outlet cashier and bartender surprise audits completed monthly. <br/>\n    \u9910\u5385\u7684\u6536\u94F6\u5458\u548C\u5427\u5458\u5E94\u6BCF\u6708\u505A\u4E00\u6B21\u672A\u901A\u77E5\u68C0\u67E5\u3002\n    ",file:"检查报告",control:""},{sort:36,name:"0",risks:"Event Order should be audited by cost control at advance. Banquet checks are audited nightly \n    to BEO's (banquet event orders), daily event sheet, and Group Master instructions. <br/>\n    \u6210\u672C\u90E8\u5E94\u4E8B\u5148\u5BF9\u5BB4\u4F1A\u9884\u8BA2\u5355\u8FDB\u884C\u6210\u672C\u5206\u6790\u3002\u5BB4\u4F1A\u8D26\u5355\uFF0C\u9884\u8BA2\u5355\u4EE5\u53CA\u56E2\u961F\u8D26\u5355\u5E94\u53CA\u65F6\u5BA1\u6838\u3002\n    ",file:"",control:""},{sort:37,name:"0",risks:"Beverage Perpetual inventory is audited on a monthly basis and results compared to actual \n    once per month.<br/>\n    \u996E\u54C1\u5B58\u8D27\u5E94\u6BCF\u6708\u76D8\u70B9\uFF0C\u5E76\u8D26\u5B9E\u76F8\u7B26\u3002\n    ",file:"",control:""},{sort:38,name:"0",risks:"Banquet Beverage controls are documented and in place.  Banquet  bar requisitions are \n    completed for each banquet bar.  Deposit drop procedures are posted and adhered to. <br/>\n    \u5BB4\u4F1A\u9152\u6C34\u4F7F\u7528\u548C\u63A7\u5236\u5E94\u8BB0\u5F55\u5B58\u6863\uFF0C\u5BB4\u4F1A\u9152\u6C34\u63D0\u8D27\u5355\u8981\u7ED3\u5408\u5BB4\u4F1A\u9884\u8BA2\u5355\uFF0C\u8BB0\u5F55\u5E76\u8DDF\u8E2A\u5176\u4ED8\u6B3E\u65B9\u5F0F\u3002\n    ",file:"食品饮品成本分析报告",control:""},{sort:39,name:"0",risks:"Food and Beverage cost should be reviewed and taken action monthly.<br/>\n    \u98DF\u54C1\u996E\u54C1\u6210\u672C\u5E94\u6BCF\u6708\u5BA1\u9605\u5E76\u8DDF\u8FDB\u3002\n    ",file:"",control:""},{sort:40,name:"0",risks:"Food sanitation audit performed by Sr. Food and Beverage Manager monthly and copied to \n    General Manager.  HRD should be responsible for the staffs' canteen sanitation audit. HCTTP\n    should be covered in the training and recorded. <br/>\n    \u98DF\u54C1\u536B\u751F\u5E94\u6BCF\u6708\u7531\u9910\u996E\u603B\u76D1\u68C0\u67E5\uFF0C\u5E76\u4E66\u9762\u62A5\u544A\u603B\u7ECF\u7406\u3002\u4EBA\u529B\u8D44\u6E90\u603B\u76D1\u5E94\u5BF9\u5458\u5DE5\u9910\u5385\u7684\u98DF\u54C1\u536B\u751F\u8D1F\u8D23 \n    \u3002HACCP\u5E94\u5B9A\u671F\u57F9\u8BAD\uFF0C\u5E76\u6709\u53C2\u4E0E\u57F9\u8BAD\u4EBA\u5458\u7B7E\u5B57\u3002\n    ",file:"食品卫生检查报告HACCP培训签到表",control:""},{sort:41,name:"0",risks:"Food and Beverage Cost are recorded on the Matching Principle. <br/>\n    \u98DF\u54C1\u996E\u54C1\u6210\u672C\u5E94\u4E25\u683C\u6309\u7167\u914D\u6BD4\u539F\u5219\u8BB0\u5F55\u3002\n    ",file:"",control:""},{sort:42,name:"0",risks:"Hotel package and breakfast are allocated properly among the related departments.<br/>\n    \u9152\u5E97\u5305\u4EF7\u548C\u65E9\u9910\u5E94\u5728\u76F8\u5173\u90E8\u95E8\u95F4\u5408\u7406\u5206\u914D\u3002\n    ",file:"",control:""},{sort:43,name:"0",risks:"Check and review the quality of the suppliers, and make sure the quality could be reached the \n    VAT requirements, and could be share the VAT benefits. <br/>\n    \u68C0\u67E5\u4F9B\u5E94\u5546\u8D44\u8D28\uFF0C\u786E\u4FDD\u4F9B\u5E94\u5546\u8D44\u8D28\u7B26\u5408\u589E\u503C\u7A0E\u5F00\u7968\u8981\u6C42\uFF0C\u5E76\u4EAB\u53D7\u589E\u503C\u7A0E\u6539\u9769\u798F\u5229\u3002\n    ",file:"",control:""},{sort:44,name:"Human Resources",risks:"5",file:"",control:""},{sort:45,name:"0",risks:"All adjustments to payroll registers, timesheets, and rates of pay are properly calculated, \n    approved, and supported by written documentation.  Appropriate segregation of duties exists\n    between payroll processing and payroll administration.<br/>\n    \u6240\u6709\u5DE5\u8D44\u8BB0\u5F55 , \u8003\u52E4\u8868 , \u5DE5\u8D44\u91D1\u989D\u7684\u8C03\u6574 , \u5FC5\u987B\u6B63\u786E\u8BA1\u7B97 , \u5BA1\u6279\u4E14\u540E\u9644\u4E66\u9762\u62A5\u544A , \u5408\u7406\u5206\u5DE5\u5DE5\u8D44\u8BA1\u7B97 \n    \u548C\u5DE5\u8D44\u76D1\u7BA1\u7684\u8D23\u4EFB\u3002\n    ",file:"出勤记录表",control:""},{sort:46,name:"0",risks:"Labor cost action plan and target reviewed, manning guide reviewed each quarter.<br/>\n    \u4EBA\u529B\u6210\u672C\u5E94\u6709\u5177\u4F53\u7684\u8DDF\u8FDB\u8BA1\u5212\u548C\u65B9\u6848\u3002\u4EBA\u5458\u5C97\u4F4D\u5B89\u6392\u5E94\u6BCF\u5B63\u5EA6\u5BA1\u9605\u4E00\u6B21\u3002\n    ",file:"人力成本跟进方案",control:""},{sort:47,name:"0",risks:"Duty Roster should be reviewed monthly.<br/>\n    \u5C97\u4F4D\u6392\u73ED\u8868\u5E94\u6BCF\u6708\u5BA1\u9605\u4E00\u6B21\u3002\n    ",file:"岗位排班表",control:""},{sort:48,name:"0",risks:"OT and annual leave should be reviewed monthly and recorded properly.<br/>\n    \u52A0\u73ED\u548C\u5E74\u5047\u9700\u8981\u6BCF\u6708\u5BA1\u9605\u4E00\u6B21\uFF0C\u5E76\u5408\u7406\u6B63\u786E\u8BB0\u5F55\u3002\n    ",file:"加班记录表，年假清单",control:""},{sort:49,name:"0",risks:"Job description for all associates and managers assigned to cash handling and revenue \n    recording tasks are updated and signed by associates. <br/>\n    \u6240\u6709\u6D89\u53CA\u6301\u6709\u73B0\u91D1\u548C\u6536\u5165\u8BB0\u5F55\u7684\u5458\u5DE5\u548C\u7ECF\u7406\u4EBA\u5458\uFF0C\u5E94\u5177\u5907\u5C97\u4F4D\u5DE5\u4F5C\u804C\u8D23\u5E76\u4E14\u7B7E\u5B57\u3002 \n    ",file:"岗位职责",control:""},{sort:50,name:"Engineering",risks:"3",file:"",control:""},{sort:51,name:"0",risks:"Engineering completes period preventive maintenance on major mechanical equipment  \n    (boilers, chillers, pumps, hot water heaters).  All preventive maintenance is fully documented.<br/>\n    \u5DE5\u7A0B\u90E8\u8981\u5B8C\u5584\u5BF9\u4E3B\u8981\u673A\u5668\u8BBE\u5907\u7684\u9884\u9632\u6027\u5B9A\u671F\u7EF4\u4FEE - \u5305\u62EC \u9505\u7089\uFF0C\u51B7\u5E93\uFF0C\u6C34\u6CF5\uFF0C\u70ED\u6C34\u5668 \u7B49\u3002 \u6240\u6709\u5B9A\u671F \n    \u7EF4\u4FEE\u8981\u5168\u90E8\u5B58\u6863\u3002\n    ",file:"工程定期维修表",control:""},{sort:52,name:"0",risks:"Energy cost saving should be taken place on a monthly basis. The meeting minutes should be \n    filed. <br/>\n    \u8282\u80FD\u4F1A\u8BAE\u6BCF\u6708\u53EC\u5F00\uFF0C\u4E14\u8282\u80FD\u65B9\u6848\u5E94\u8DDF\u8FDB\u5B9E\u65BD\uFF0C\u4F1A\u8BAE\u7EAA\u8981\u5E94\u5F52\u6863\u3002\n    ",file:"节能方案连续三次节能会议纪要",control:""},{sort:53,name:"0",risks:"Engineering and Security Department completes fire drills as frequently as required by law  \n    (once per year at a minimum), and forwards results to the GM.<br/>\n    \u5DE5\u7A0B\u90E8\u548C\u4FDD\u5B89\u90E8\u8981\u6309\u5F53\u5730\u89C4\u5B9A\uFF0C\u5B8C\u5584\u5B9A\u671F\u6D88\u9632\u8BAD\u7EC3\uFF0C\u81F3\u5C11\u4E00\u5E74\u4E00\u6B21\uFF0C\u76F8\u5173\u62A5\u544A\u4EA4\u7531\u603B\u7ECF\u7406\u5BA1\u9605\u3002\n    ",file:"消防演习报告",control:""},{sort:54,name:"IT",risks:"4",file:"",control:""},{sort:55,name:"0",risks:"Associate exit policy exists in hotel.<br/>\n    \u9152\u5E97\u5458\u5DE5\u79BB\u804C\u5236\u5EA6\uFF0C\u4EE5\u53CA\u76F8\u5173\u7684\u4FE1\u606F\u5907\u4EFD\u548C\u4FDD\u62A4\u3002\n    ",file:"",control:""},{sort:56,name:"0",risks:"All systems passwords updated. Information integrity maintained. Confidential information,  \n    personally identifiable information, and credit card information is properly protected.<br/>\n    \u9152\u5E97\u6240\u6709\u7CFB\u7EDF\u7684\u5BC6\u7801\u4FDD\u62A4\u653F\u7B56\u4EE5\u53CA\u4FE1\u606F\u4FDD\u5B58\u7684\u5B8C\u6574\u6027\u3002\u6B63\u786E\u4FDD\u62A4\u673A\u5BC6\u4FE1\u606F\uFF0C\u79C1\u4EBA\u4FE1\u606F\u548C\u4FE1\u7528\u5361\u4FE1\u606F\u3002\n    ",file:"",control:""},{sort:57,name:"0",risks:"Systems back-up performed by appointed systems manager regularly for PMS, accounting  \n    system, POS and hotel server.<br/>\n    \u7535\u8111\u623F\u5E94\u7531\u4E13\u4EBA\u6309\u65F6\u505A\u7CFB\u7EDF\u5907\u4EFD\uFF0C\u5982 \u7BA1\u7406\u7CFB\u7EDF\uFF0C\u8D22\u52A1\u7CFB\u7EDF\uFF0C\u6536\u94F6\u7CFB\u7EDF\u53CA\u670D\u52A1\u5668\u3002\n    ",file:"",control:""},{sort:58,name:"0",risks:"Tapes stored at remote locations from CPU's.  (Indicate storage location)<br/>\n    \u78C1\u5E26\u5B58\u653E\u5904\u8981\u8FDC\u79BB CPU\uFF0C\u5E76\u6307\u660E\u5B58\u653E\u5904\u3002\n    ",file:"",control:""},{sort:59,name:"Total Hotel",risks:"4",file:"",control:""},{sort:60,name:"0",risks:"The following up reports of Operating Equipments from every related department should be  \n    reviewed by General Manager and taken action by hotel team on a quarterly basis.<br/>\n    \u6240\u6709\u76F8\u5173\u90E8\u95E8\u7684\u8425\u8FD0\u5DE5\u5177\u76D8\u70B9\u8DDF\u8FDB\u62A5\u544A\u7531\u603B\u7ECF\u7406\u5BA1\u9605\u5E76\u7531\u9152\u5E97\u56E2\u961F\u6BCF\u5B63\u5EA6\u5B9E\u65BD\u3002\n    ",file:"",control:""},{sort:61,name:"0",risks:"All Management / Lease Agreement provisions are adhered to. Owner reporting due dates and \n    format are strictly enforced. FF&E accounting is handled in accordance with the Agreement. \n    Minutes for all meetings are kept (Owners, finance, credit meetings).  Owner correspondence\n    and customer correspondence is tracked appropriately.<br/>\n    \u6267\u884C\u7BA1\u7406\u5408\u540C\u4E2D\u7684\u6240\u6709\u89C4\u5B9A\uFF0C\u4E25\u683C\u6267\u884C\u4E1A\u4E3B\u6240\u9700\u62A5\u8868\u7684\u65E5\u671F\u548C\u5185\u5BB9\uFF0C\u4F9D\u7167\u5408\u540C\u5904\u7406\u56FA\u5B9A\u8D44\u4EA7\u5E10\u76EE\uFF0C \n    \u4FDD\u5B58\u6240\u6709\u4F1A\u8BAE\u7EAA\u8981\uFF0C\u4E0E\u4E1A\u4E3B\u65B9\u548C\u5BA2\u4EBA\u4E4B\u95F4\u7684\u5F80\u6765\u4FE1\u4EF6\u9700\u53CA\u65F6\u8DDF\u8FDB\u3002\n    ",file:"",control:""},{sort:62,name:"0",risks:"Local Standard Operating Procedures are approved by the relevant disciplines and Vice \n    President - Operations before implementation. All approval must be filed in the hotels for the \n    inspection. <br/>\n    \u6240\u6709\u9152\u5E97\u4E2A\u4F53\u7684\u6807\u51C6\u64CD\u4F5C\u6D41\u7A0B\u9700\u8981\u7531\u76F8\u5173\u90E8\u95E8\u7684\u8FD0\u8425\u526F\u603B\u88C1\u5BA1\u6279\u540E\uFF0C\u65B9\u53EF\u5B9E\u65BD\u3002\u6240\u6709\u5BA1\u6279\u6587\u4EF6\u9700\u53CA \n    \u65F6\u5F52\u6863\u5907\u67E5\u3002\n    ",file:"",control:""},{sort:63,name:"0",risks:"Self assessment audits of the Control Environment Diagnostic Tool are completed quarterly. \n    Compliance scores of Green, Yellow, Red ratings are assigned to managers.  General Manger \n    holds managers accountable for assessment scores.  Managers who achieve greens audits \n    are recognized and celebrated.  Self audits are completed and plans and actions exist for \n    identified weaknesses.  Plans and actions are updated and corrective measures are in place. \n    General Manager should be responsible for the final results.<br/>\n    \u6B64\u68C0\u67E5\u8868\u683C\u4E3A\u9152\u5E97\u6BCF\u5B63\u5EA6\u5B8C\u5584\u81EA\u6211\u68C0\u67E5\u5DE5\u5177\uFF0C\u6267\u884C\u5206\u6570\uFF08\u7EFF\u8272\uFF0C\u9EC4\u8272\u548C\u7EA2\u8272\uFF09\u9700\u8981\u6307\u5B9A\u5230\u76F8\u5173\u7BA1\u7406\n    \u4EBA\u5458\uFF0C\u603B\u7ECF\u7406\u5E94\u638C\u63E1\u8D1F\u8D23\u8BC4\u5206\u7684\u7BA1\u7406\u4EBA\u5458\uFF0C\u8FBE\u5230\u7EFF\u8272\u5206\u6570\u7684\u7BA1\u7406\u4EBA\u5458\u5E94\u9F13\u52B1\u3002\u901A\u8FC7\u81EA\u6211\u68C0\u67E5\uFF0C\u53EF\u4EE5\n    \u5BF9\u76EE\u524D\u4E0D\u8DB3\u4E4B\u51FA\u8FDB\u884C\u6574\u6539\uFF0C\u4EE5\u786E\u4FDD\u6539\u8FDB\u63AA\u65BD\u884C\u4E4B\u6709\u6548\u3002\u603B\u7ECF\u7406\u5E94\u5BF9\u6700\u7EC8\u7684\u7ED3\u679C\u8D1F\u8D23\u3002\n    ",file:"",control:""}];var dataInputDefault=exports.dataInputDefault=[{name:"Audited by Director of Finance / Date:",value:""},{name:"Reviewed / signed by General Manager / Date: ",value:""}];

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(8);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var totalIndexFooter=[0,24,26,32,44,50,54,59];var index=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(name,value,i){// 简单粗暴的深拷贝
var data=JSON.parse(JSON.stringify(_this.props.data));data[i][name]=value;_this.props.onChange('name',data);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'render',value:function render(){var _this2=this;var data=this.props.data;var columns=[{title:'-',dataIndex:'name',key:'name',align:"center",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(totalIndexFooter.includes(index)?'table-color-footer':''),style:{textAlign:"left"}},!totalIndexFooter.includes(index)?_react2.default.createElement(_select2.default,{style:{width:"100%",textAlign:"right"},defaultValue:text,onChange:function onChange(v){return _this2.onChange('name',v,index);}},_react2.default.createElement(Option,{value:0},'0'),_react2.default.createElement(Option,{value:1},'1')):text);}},{title:'RISKS / CONTROLS',dataIndex:'risks',key:'risks',align:"center",width:650,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"risks",onChange:_this2.onChange,totalIndex:totalIndexFooter};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'File Reference',dataIndex:'file',key:'file',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"file",onChange:_this2.onChange,totalIndex:totalIndexFooter};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Comments',dataIndex:'control',key:'control',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:totalIndexFooter.includes(index)?'text':"textArea",name:"control",onChange:_this2.onChange,totalIndex:totalIndexFooter};return _react2.default.createElement(_TableText2.default,{data:props});}}];return _react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,loading:this.props.loading,className:'content',scroll:this.props.print?{}:{y:500},rowKey:function rowKey(record,index){return record.id||record.sort;}});}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(8);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(name,value,i){},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'render',value:function render(){var _this2=this;var data=this.props.data;var columns=[{title:'Departments',dataIndex:'name',key:'name',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this2.onChange,totalIndex:[8]};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Target',dataIndex:'risks',key:'risks',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"risks",onChange:_this2.onChange,totalIndex:[8]};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Actual',dataIndex:'file',key:'file',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"file",onChange:_this2.onChange,totalIndex:[8]};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'%',dataIndex:'control',key:'control',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"percent",name:"control",onChange:_this2.onChange,totalIndex:[8]};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'-',dataIndex:'total',key:'total',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:"number",name:"total",onChange:_this2.onChange,totalIndex:[8],warn:true};return _react2.default.createElement(_TableText2.default,{data:props});}}];return _react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,loading:this.props.loading,className:'content',rowKey:function rowKey(record,index){return index;}});}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(8);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(name,value,i){},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'render',value:function render(){var _this2=this;var data=this.props.data;var columns=[{title:'Departments',dataIndex:'value',key:'value',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"value",onChange:_this2.onChange,totalIndex:[8]};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'-',dataIndex:'name',key:'name',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this2.onChange,totalIndex:[8]};return _react2.default.createElement(_TableText2.default,{data:props});}}];return _react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,showHeader:false,loading:this.props.loading,className:'content',rowKey:function rowKey(record,index){return index;}});}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(8);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(name,value,i){var data=_this.props.data;data[i][name]=value;_this.props.onChange('dataInput',data,true);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'render',value:function render(){var _this2=this;var data=this.props.data;var columns=[{title:'Departments',dataIndex:'name',key:'name',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this2.onChange,totalIndex:[]};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'-',dataIndex:'value',key:'value',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'input',name:"value",onChange:_this2.onChange,totalIndex:[]};return _react2.default.createElement(_TableText2.default,{data:props});}}];return _react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,pagination:false,showHeader:false,loading:this.props.loading,className:'content',rowKey:function rowKey(record,index){return index;}});}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(4);__webpack_require__(10);__webpack_require__(25);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TextArea=_input2.default.TextArea;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getDateData=function(date){var data=_this.state.data;fetch('/_10_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this.setState({loading:false,data:x.data||[]});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/add_10',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(data[0]&&!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败'+JSON.stringify(err));console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table10',1.5,'10.00',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[{note:"",other:""}],loading:true,loadingSave:false,print:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);// this.computeNum(this.state.data)
}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1',id:'table10'},_react2.default.createElement(_row2.default,{style:{margin:"20px 0"},className:'title'},_react2.default.createElement(_row2.default,null,_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,loading:true,data:[]});_this2.getDateData(str);}})),_react2.default.createElement(_row2.default,{style:{margin:"10px 0",marginTop:20}},'10.0 CSR and Community Activities \u4F01\u4E1A\u793E\u4F1A\u8D23\u4EFB\u53CA\u793E\u533A\u6D3B\u52A8'),!this.state.loading||this.state.print?_react2.default.createElement(TextArea,{rows:4,placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',value:this.state.data[0]?this.state.data[0].note:"",onChange:function onChange(e){var data=_this2.state.data;data[0]=_extends({},data[0],{note:e.target.value||""});_this2.setState({data:data});}}):null),_react2.default.createElement(_row2.default,{style:{margin:"20px 0"},className:'title'},_react2.default.createElement(_row2.default,{style:{margin:"10px 0"}},'11.0 Other Issues \u5176\u4ED6\u4E8B\u5B9C'),!this.state.loading||this.state.print?_react2.default.createElement(TextArea,{rows:4,placeholder:'\u8BF7\u8F93\u5165\u5907\u6CE8\uFF01',value:this.state.data[0]?this.state.data[0].other:"",onChange:function onChange(e){var data=_this2.state.data;data[0]=_extends({},data[0],{other:e.target.value||""});_this2.setState({data:data});}}):null)),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_10'},_react2.default.createElement(_row2.default,{className:'table-footer-btn',style:{textAlign:"right",paddingRight:24}},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58'))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _table=__webpack_require__(2049);var _table2=_interopRequireDefault(_table);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){return _react2.default.createElement(_table2.default,this.props,'  ');}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _alert=__webpack_require__(83);var _alert2=_interopRequireDefault(_alert);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(84);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(2050);var _data2=_interopRequireDefault(_data);var _compute=__webpack_require__(2051);var _compute2=_interopRequireDefault(_compute);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _IsLableAuth=__webpack_require__(107);var _IsLableAuth2=_interopRequireDefault(_IsLableAuth);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var _this$state=_this.state,date=_this$state.date,data4_1=_this$state.data4_1;data=(0,_compute2.default)(data,{date:date,data4_1:data4_1});_this.setState({data:data,loading:false});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var data,month,year,x;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_this.setState({loading:true});data=JSON.parse(JSON.stringify(_data2.default));month=(0,_moment2.default)(date).format('M');year=(0,_moment2.default)(date).format('YYYY');_context.next=7;return(0,_request2.default)("/e12List?year="+year+"&month="+month);case 7:x=_context.sent;if(x.data.table&&x.data.table.length>0){data=x.data.table;}data=(0,_compute.fillData)(data,x.data);_this.setState({data4_1:x.data.e4_1_1||[]},function(){_this.computeNum(data);});_context.next=17;break;case 13:_context.prev=13;_context.t0=_context["catch"](0);_this.setState({loading:false});console.error(_context.t0);case 17:case"end":return _context.stop();}}},_callee,_this2,[[0,13]]);}));return function(_x){return _ref.apply(this,arguments);};}();_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var date,_timer,year,month,data,dataFrom,headres,x,timer,_timer2;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_this.setState({loadingSave:true});date=_this.state.date;if(date){_context2.next=7;break;}_message3.default.error('请选择年份月份');_timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer);},1000);return _context2.abrupt("return");case 7:year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");data=_this.state.data.map(function(x,i){return _extends({},x,{year:year,month:month,sort:i});});dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context2.next=15;return(0,_request2.default)('/e12Save',headres);case 15:x=_context2.sent;timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(!(x.status==1)){_context2.next=21;break;}_message3.default.success(x.msg);if(!data[0].id){_this.getData(_this.state.date);}return _context2.abrupt("return");case 21:_message3.default.error(x.msg);_context2.next=29;break;case 24:_context2.prev=24;_context2.t0=_context2["catch"](0);_timer2=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer2);},1000);console.error(_context2.t0);_message3.default.error('保存失败'+JSON.stringify(_context2.t0));case 29:case"end":return _context2.stop();}}},_callee2,_this2,[[0,24]]);}));_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('view4_1_4',1.5,'12.1',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+" "+(0,_moment2.default)(_this.state.date).format('YYYY')+" 12.1 Club GCH \u8C6A\u5EF7\u6703";var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById('table4_1_4').innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+".xls");_this.setState({print:false});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,data4_1:[]};return _this;}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print,loading=_state.loading;return _react2.default.createElement("div",{className:"table7_1_1 tableHeight"},_react2.default.createElement(_row2.default,{className:"title",id:"view4_1_4",style:{width:print?2250:'auto'}},_react2.default.createElement(_row2.default,null,"12.1 Club GCH \u8C6A\u5EF7\u6703"),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:"YYYY-MM",onChange:function onChange(date,str){_this3.setState({date:str,data:[]});_this3.getData(str);}})),_react2.default.createElement(_table2.default,{columns:(0,_compute.columns)(this.onChange,print,date),dataSource:data,size:"middle",id:"table4_1_4",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{x:true,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:"table-footer-btn"},_react2.default.createElement(_alert2.default,{message:_react2.default.createElement("div",null,"\u8868\u683C\u5173\u8054",_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:"read_2_1"},this.props,{path:"/table/2_1"}),"2.1")," -",_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:"read_2_2"},this.props,{path:"/table/2_2"}),"2.2")," -",_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:"read_4_1"},this.props,{path:"/table/4_1"}),"4.1.1")," -",_react2.default.createElement(_IsLableAuth2.default,Object.assign({auth:"read_5_1"},this.props,{path:"/table/5_1"}),"5.1.1")),type:"info",showIcon:true,style:{display:"inline-block",marginRight:10}}),_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:print},"\u5BFC\u51FAExcel"),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:"edit_12"},_react2.default.createElement(_button2.default,{type:"primary",style:{margin:'0 10px'},onClick:this.downloadSG,loading:print},"\u52A0\u5165pdf"),_react2.default.createElement(_button2.default,{type:"primary",onClick:this.onSave,loading:this.state.loadingSave},"\u4FDD\u5B58"))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=[{"name":"Part 1 Club GCH Members豪廷會会员拉新","sort":0,"Jan":0,"Feb":0,"Mar":0,"Apr":0,"May":0,"Jun":0,"Jul":0,"Aug":0,"Sep":0,"Oct":0,"Nov":0,"Dec":0,"total":0},{"name":"Rooms Nights-Actual实际客房间夜","sort":1,"Jan":0,"Feb":0,"Mar":0,"Apr":0,"May":0,"Jun":0,"Jul":0,"Aug":0,"Sep":0,"Oct":0,"Nov":0,"Dec":0,"total":0},{"name":"F&B Covers-Actual实际餐饮人数","sort":2,"Jan":0,"Feb":0,"Mar":0,"Apr":0,"May":0,"Jun":0,"Jul":0,"Aug":0,"Sep":0,"Oct":0,"Nov":0,"Dec":0,"total":0},{"name":"Rooms Nights-Budget预算客房间夜","sort":3,"Jan":0,"Feb":0,"Mar":0,"Apr":0,"May":0,"Jun":0,"Jul":0,"Aug":0,"Sep":0,"Oct":0,"Nov":0,"Dec":0,"total":0},{"name":"F&B Covers-Budget预算餐饮人数","sort":4,"Jan":0,"Feb":0,"Mar":0,"Apr":0,"May":0,"Jun":0,"Jul":0,"Aug":0,"Sep":0,"Oct":0,"Nov":0,"Dec":0,"total":0},{"name":"Rooms Members-Budget(Target)客房拉新目标","sort":5,"Jan":0,"Feb":0,"Mar":0,"Apr":0,"May":0,"Jun":0,"Jul":0,"Aug":0,"Sep":0,"Oct":0,"Nov":0,"Dec":0,"total":0},{"name":"F&B Members-Budget(Target)餐饮拉新目标","sort":6,"Jan":0,"Feb":0,"Mar":0,"Apr":0,"May":0,"Jun":0,"Jul":0,"Aug":0,"Sep":0,"Oct":0,"Nov":0,"Dec":0,"total":0},{"name":"Total Members-Budget(Target)会员拉新总目标","sort":7,"Jan":0,"Feb":0,"Mar":0,"Apr":0,"May":0,"Jun":0,"Jul":0,"Aug":0,"Sep":0,"Oct":0,"Nov":0,"Dec":0,"total":0},{"name":"Total Members-Actual实际会员拉新总数","sort":8,"Jan":0,"Feb":0,"Mar":0,"Apr":0,"May":0,"Jun":0,"Jul":0,"Aug":0,"Sep":0,"Oct":0,"Nov":0,"Dec":0,"total":0},{"name":"Target completion rate(%)会员拉新完成率","sort":9,"Jan":0,"Feb":0,"Mar":0,"Apr":0,"May":0,"Jun":0,"Jul":0,"Aug":0,"Sep":0,"Oct":0,"Nov":0,"Dec":0,"total":0},{"name":"Part 2 Club GCH Revenue豪廷會产量","sort":10,"Jan":0,"Feb":0,"Mar":0,"Apr":0,"May":0,"Jun":0,"Jul":0,"Aug":0,"Sep":0,"Oct":0,"Nov":0,"Dec":0,"total":0},{"name":"Walkin Revenue-ActualWalkin实际收入","sort":11,"Jan":0,"Feb":0,"Mar":0,"Apr":0,"May":0,"Jun":0,"Jul":0,"Aug":0,"Sep":0,"Oct":0,"Nov":0,"Dec":0,"total":0},{"name":"F&B Revenue-Actual（Excluding Banquet Revenue）<br />餐饮实际收入（不含宴会收入）","sort":12,"Jan":0,"Feb":0,"Mar":0,"Apr":0,"May":0,"Jun":0,"Jul":0,"Aug":0,"Sep":0,"Oct":0,"Nov":0,"Dec":0,"total":0},{"name":"Walkin Revenue-Budget Walkin预算收入","sort":13,"Jan":0,"Feb":0,"Mar":0,"Apr":0,"May":0,"Jun":0,"Jul":0,"Aug":0,"Sep":0,"Oct":0,"Nov":0,"Dec":0,"total":0},{"name":"F&B Revenue-Budget（Excluding Banquet Revenue）<br/>餐饮预算收入（不含宴会收入）","sort":14,"Jan":0,"Feb":0,"Mar":0,"Apr":0,"May":0,"Jun":0,"Jul":0,"Aug":0,"Sep":0,"Oct":0,"Nov":0,"Dec":0,"total":0},{"name":"Walkin Revenue-Budget(Target)Walkin收入目标","sort":15,"Jan":0,"Feb":0,"Mar":0,"Apr":0,"May":0,"Jun":0,"Jul":0,"Aug":0,"Sep":0,"Oct":0,"Nov":0,"Dec":0,"total":0},{"name":"F&B Revenue-Budget(Target)餐饮收入目标","sort":16,"Jan":0,"Feb":0,"Mar":0,"Apr":0,"May":0,"Jun":0,"Jul":0,"Aug":0,"Sep":0,"Oct":0,"Nov":0,"Dec":0,"total":0},{"name":"Total Revenue-Budget(Target)收入总目标","sort":17,"Jan":0,"Feb":0,"Mar":0,"Apr":0,"May":0,"Jun":0,"Jul":0,"Aug":0,"Sep":0,"Oct":0,"Nov":0,"Dec":0,"total":0},{"name":"Total Revenue-Actual实际总收入","sort":18,"Jan":0,"Feb":0,"Mar":0,"Apr":0,"May":0,"Jun":0,"Jul":0,"Aug":0,"Sep":0,"Oct":0,"Nov":0,"Dec":0,"total":0},{"name":"Target completion rate(%)收入完成率","sort":19,"Jan":0,"Feb":0,"Mar":0,"Apr":0,"May":0,"Jun":0,"Jul":0,"Aug":0,"Sep":0,"Oct":0,"Nov":0,"Dec":0,"total":0}];

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columns=exports.fillData=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _detaultData=__webpack_require__(2052);var _detaultData2=_interopRequireDefault(_detaultData);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var listName=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];exports.default=function(data,_ref){var date=_ref.date;var month=(0,_moment2.default)(date).format('M');var user=JSON.parse(sessionStorage.getItem('user')||"{}");var hotelData=_detaultData2.default.find(function(x){return x.id==user.comid;});listName.forEach(function(name){if(hotelData){data[7][name]=hotelData.laxin||0;data[17][name]=hotelData.income||0;}data[9][name]=(0,_method.calculation)(data[8][name],data[7][name],4);data[19][name]=(0,_method.calculation)(data[18][name],data[17][name],4);});data.forEach(function(item,i){data[i].total=listName.reduce(function(a,b,index){if(index<month)a+=(0,_method.numConvert)(data[i][b]);return a;},0).toFixed(2);});data[9].total=(0,_method.calculation)(data[8].total,data[7].total,4);data[19].total=(0,_method.calculation)(data[18].total,data[17].total,4);return data;};var fillData=exports.fillData=function fillData(data,_ref2){var e2_1=_ref2.e2_1,e2_2=_ref2.e2_2,e4_1_1=_ref2.e4_1_1,e5_1=_ref2.e5_1,last=_ref2.last;// 2.1数据填充至实际客房数
listName.forEach(function(name,index){data[1][name]=_lodash2.default.get(e2_1,"2."+name,0);data[3][name]=_lodash2.default.get(e2_2,"2."+name,0);// 餐饮人数和收益
data[2][name]=_lodash2.default.get(e5_1.find(function(x){return x.month==~~(index+1);}),"covers",0);data[4][name]=_lodash2.default.get(e5_1.find(function(x){return x.month==~~(index+1);}),"m_covers",0);data[11][name]=_lodash2.default.get(e4_1_1,index*3+1+".best_rev",0);data[13][name]=_lodash2.default.get(e4_1_1,index*3+".best_rev",0);data[12][name]=_lodash2.default.get(e5_1.find(function(x){return x.month==~~(index+1);}),"REV",0);data[14][name]=_lodash2.default.get(e5_1.find(function(x){return x.month==~~(index+1);}),"m_REV",0);});// 上个月数据填充
if(last&&last.length&&!_lodash2.default.get(data,'0.id')){listName.forEach(function(name,index){data[8][name]=last[8][name];data[18][name]=last[18][name];});}return data;};var totalIndex=[0,10];var percentIndex=[9,19];var hideIndex=[5,6,15,16];var columns=exports.columns=function columns(onChange,print,date){var month=(0,_moment2.default)(date).format('M');return[{title:'名称',dataIndex:'name',key:'name',align:"center",fixed:"left",width:300,render:function render(text,record,index){if(hideIndex.includes(index)){return{props:{colSpan:0}};}var props={text:text,index:index,type:'text',name:"name",onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}].concat(_toConsumableArray(["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"].map(function(name,_M){return{title:name,dataIndex:name,key:name,align:"center",width:150,render:function render(text,record,index){var title=[name];if(hideIndex.includes(index)){return{props:{colSpan:0}};}var props={text:text,index:index,type:percentIndex.includes(index)?'percent':[8,18].includes(index)?'inputNumber':'number',name:name,onChange:onChange,totalIndex:totalIndex};props.compared={title:title,record:record,sqlName:"_12"};if(index==0){return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:month>_M?'Actual':"Forecast",compared:false})});}if(index==10)return{props:{colSpan:name=='Jan'?13:0},children:name=='Jan'?_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:'text',text:" ",compared:false})}):null};return _react2.default.createElement(_TableText2.default,{data:props});}};})),[{title:"YTD",dataIndex:"total",key:"total",align:"center",width:150,render:function render(text,record,index){var title=["YTD"];var props={text:text,index:index,type:percentIndex.includes(index)?'percent':'number',name:"total",onChange:onChange,totalIndex:totalIndex};if(hideIndex.includes(index)){return{props:{colSpan:0}};}props.compared={title:title,record:record,sqlName:"_12"};if(index==0){return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"text",text:" ",compared:false})});}if(index==10)return{props:{colSpan:0},children:null};return _react2.default.createElement(_TableText2.default,{data:props});}}]);};

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=[{"name":"江城明珠豪生大酒店","income":63841.2,"laxin":2619.55,"id":5},{"name":"宁波华侨温德姆至尊豪廷大酒店","income":63780.26,"laxin":4286.85,"id":7},{"name":"大连百年汇豪生酒店","income":14722.46,"laxin":679.07,"id":10},{"name":"合肥两淮豪生大酒店","income":35812.1,"laxin":2438.77,"id":12},{"name":"宁波逸东豪生大酒店","income":33646.37,"laxin":1855.59,"id":28},{"name":"蚌埠南山豪生大酒店","income":35952.01,"laxin":2166.04,"id":37},{"name":"滁州凯迪温德姆至尊豪廷大酒店","income":35086.1,"laxin":2250.78,"id":65},{"name":"南京卧龙湖温德姆至尊豪廷度假酒店","income":13382.6,"laxin":863.28,"id":80},{"name":"长兴温德姆至尊豪廷大酒店","income":37831.74,"laxin":2490.49,"id":82},{"name":"阜阳宝龙温德姆至尊豪廷大酒店","income":33676.19,"laxin":2167.75,"id":84},{"name":"安吉凯承温德姆至尊豪廷大酒店","income":50434.92,"laxin":2638.85,"id":91},{"name":"武汉光谷豪生行政公寓","income":32332.06,"laxin":1373.85,"id":902},{"name":"淮北静安豪生酒店","income":22064.04,"laxin":1508.7,"id":905},{"name":"昆明南亚风情园豪生大酒店","income":29282.54,"laxin":2339.62,"id":23},{"name":"昆明七彩云南温德姆至尊豪廷大酒店","income":60394.73,"laxin":3067.17,"id":32},{"name":"成都高新豪生大酒店","income":45967.33,"laxin":2138.85,"id":39},{"name":"重庆普惠豪生大酒店","income":22559.95,"laxin":3026.23,"id":40},{"name":"成都雅居乐豪生大酒店","income":37165.56,"laxin":3350.49,"id":46},{"name":"重庆秀山豪生大酒店","income":14304.18,"laxin":1263.89,"id":49},{"name":"重庆华宇温德姆至尊豪廷大酒店","income":44502.88,"laxin":2017.94,"id":54},{"name":"漳州明发温德姆至尊豪廷大酒店","income":31131.63,"laxin":2009.67,"id":57},{"name":"重庆锦怡豪生酒店","income":23424.84,"laxin":1390.51,"id":60},{"name":"丽江金林豪生大酒店","income":32268,"laxin":1950,"id":83},{"name":"重庆渝融豪生酒店","income":49090.72,"laxin":2179.44,"id":88},{"name":"厦门集美湖豪生大酒店","income":68937.66,"laxin":4375.28,"id":89},{"name":"资阳鼎晟泓府豪生大酒店","income":29971.03,"laxin":3728.23,"id":90},{"name":"厦门禹洲温德姆至尊豪廷大酒店","income":80762.47,"laxin":3362.42,"id":92},{"name":"成都宏鼎温德姆至尊豪廷大酒店","income":46261.54,"laxin":3106.21,"id":101},{"name":"昭通温德姆至尊豪廷大酒店","income":24655.18,"laxin":1859.53,"id":893},{"name":"昆明滇池豪生酒店","income":18505.28,"laxin":1108.47,"id":899},{"name":"丽江金林温德姆至尊豪廷度假酒店（全别墅型）","income":51949,"laxin":1798,"id":904},{"name":"梅州昌盛豪生大酒店","income":34164.08,"laxin":2804.57,"id":38},{"name":"郴州温德姆至尊豪廷大酒店","income":46038.16,"laxin":3643.86,"id":50},{"name":"邵阳湘林温德姆至尊豪廷大酒店","income":41711.4,"laxin":3006.09,"id":55},{"name":"文昌温德姆至尊豪廷大酒店","income":33116.6,"laxin":1548.25,"id":67},{"name":"抚州仙盖山温德姆至尊豪廷大酒店","income":11250,"laxin":355.66,"id":918}];

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _popconfirm=__webpack_require__(110);var _popconfirm2=_interopRequireDefault(_popconfirm);var _icon=__webpack_require__(38);var _icon2=_interopRequireDefault(_icon);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(62);__webpack_require__(25);__webpack_require__(12);__webpack_require__(8);__webpack_require__(4);__webpack_require__(6);__webpack_require__(111);__webpack_require__(75);__webpack_require__(10);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(85);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(197);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getHotel=function(){fetch('/getHotel?id='+_this.state.id,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.status==1){_this.setState({hotelData:_extends({},x.data[0])});return;}_message3.default.error('数据获取失败！'+JSON.stringify(x.msg));}).catch(function(err){console.error(err);_message3.default.error('数据获取失败！'+JSON.stringify(err));});};_this.getData=function(){fetch('/getUser?comid='+_this.state.id,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this.setState({loading:false});if(x.status==1){_this.setState({data:x.data||[],auth:x.msg||""});return;}_message3.default.error('数据获取失败！'+JSON.stringify(x.msg));}).catch(function(err){_this.setState({loading:false});console.error(err);_message3.default.error('数据获取失败！'+JSON.stringify(err));});};_this.showModal=function(){_this.setState({visible:true});};_this.handleOk=function(e){_this.setState({loadingSave:true});var dataTotal=_this.state.data;var data=_extends({},_this.state.hotel);data.comid=_this.state.id;data.created_at=(0,_moment2.default)().format('YYYY-MM-DD HH:mm:ss');if(!data.name||!data.email||!data.password){_message3.default.error('员工信息不能为空');_this.setState({loadingSave:false});return;}if(data.id){var arr=dataTotal.filter(function(x){return data.id;});if(arr[0].password===data.password){delete data.password;};}delete data.add_time;var dataFrom=new FormData();for(var key in data){if(data.hasOwnProperty(key)){dataFrom.append(key,data[key]);}}var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/addUser',headres).then(function(x){return x.json();}).then(function(x){if(x.status==1){_message3.default.info('保存成功！');_this.getData();_this.setState({visible:false,loadingSave:false,loading:true,hotel:{name:"",email:"",password:""}});return;}_message3.default.error('保存失败！'+x.msg);_this.setState({loadingSave:false});}).catch(function(err){console.error(err);_message3.default.error('数据添加失败！');_this.setState({loadingSave:false});});};_this.handleCancel=function(e){_this.setState({visible:false,hotel:{name:"",email:"",password:""}});};_this.confirm=function(data){if(_this.state.info.data.email!='admin'){_message3.default.error('权限不足！');return;}fetch('/deleteUser?id='+data.id,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.status==1){_this.getData();_message3.default.info('删除成功！');return;}_message3.default.info('删除失败！');}).catch(function(err){_message3.default.info('删除失败！');console.error(err);});};_this.state={id:props.match.params.id||"",data:[],visible:false,loadingSave:false,loading:true,hotel:{name:"",email:"",password:""},type:"",hotelData:{},info:sessionStorage.getItem('info')?JSON.parse(sessionStorage.getItem('info')):{data:{}},auth:""};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getHotel();this.getData();}},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,auth=_state.auth;var columns=[{title:'名称',dataIndex:'name',key:'name'},{title:'账号',dataIndex:'email',key:'email'}];if(auth=='admin'){columns.push({title:'操作',key:'add_time',render:function render(record){return _react2.default.createElement('div',null,_react2.default.createElement('span',{style:{color:"#1890ff",cursor:"pointer"},onClick:function onClick(){var hotel=_extends({},record);_this2.setState({hotel:hotel,visible:true});}},'\u7F16\u8F91'),_react2.default.createElement('span',null,_react2.default.createElement(_icon2.default,{type:'minus'}),_react2.default.createElement(_popconfirm2.default,{title:'\u786E\u5B9A\u8981\u5220\u9664\u8FD9\u4E2A\u6210\u5458?',onConfirm:_this2.confirm.bind(_this2,record),onCancel:function onCancel(){},okText:'\u662F',cancelText:'\u5426'},_react2.default.createElement('span',{style:{color:"#1890ff",cursor:"pointer"}},'\u5220\u9664'))));}});}return _react2.default.createElement('div',{className:'settings'},_react2.default.createElement(_row2.default,{style:{margin:'20px 0'},type:'flex',justify:'space-between',textAlign:'center'},_react2.default.createElement('span',{style:{fontSize:20,color:"black"}},this.state.hotelData.name||""),auth=='admin'&&_react2.default.createElement(_button2.default,{type:'primary',onClick:this.showModal},'\u65B0\u589E\u5458\u5DE5')),_react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement(_table2.default,{style:{marginTop:20},columns:columns,dataSource:data,bordered:true,pagination:false,rowKey:function rowKey(item,index){return index;}})),_react2.default.createElement(_row2.default,{style:{textAlign:"right",marginTop:20}},_react2.default.createElement(_button2.default,{key:'submit',type:'primary',onClick:function onClick(){_this2.props.history.goBack();}},'\u8FD4\u56DE')),_react2.default.createElement(_modal2.default,{title:this.state.hotel.id?'员工编辑':"员工添加",visible:this.state.visible,onOk:this.handleOk,onCancel:this.handleCancel,footer:[_react2.default.createElement(_button2.default,{key:'back',onClick:this.handleCancel},'\u53D6\u6D88'),_react2.default.createElement(_button2.default,{key:'submit',type:'primary',loading:this.state.loadingSave,onClick:this.handleOk},'\u4FDD\u5B58')]},_react2.default.createElement(_row2.default,{className:'modal'},_react2.default.createElement(_row2.default,null,_react2.default.createElement('span',null,'\u5458\u5DE5\u540D\u79F0\uFF1A'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u5458\u5DE5\u540D\u79F0',style:{width:'60%',marginLeft:10},value:this.state.hotel.name,onChange:function onChange(e){var value=e.target.value;var hotel=_this2.state.hotel;hotel.name=value;_this2.setState({hotel:hotel});}})),_react2.default.createElement(_row2.default,{className:'settings-modal-content'},_react2.default.createElement('span',null,'\u767B\u5F55\u8D26\u53F7\uFF1A'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u767B\u5F55\u8D26\u53F7',style:{width:'60%',marginLeft:10},value:this.state.hotel.email,onChange:function onChange(e){var value=e.target.value;var hotel=_this2.state.hotel;hotel.email=value;_this2.setState({hotel:hotel});}})),_react2.default.createElement(_row2.default,{className:'settings-modal-content'},_react2.default.createElement('span',null,'\u5BC6\u7801\uFF1A'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u5BC6\u7801',style:{width:'60%',marginLeft:38,display:"none"},value:this.state.hotel.password,type:'password',name:'ppp',onChange:function onChange(e){var value=e.target.value;var hotel=_this2.state.hotel;hotel.password=value;_this2.setState({hotel:hotel});}}),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u5BC6\u7801',style:{width:'60%',marginLeft:38},value:this.state.hotel.password,type:'password',name:'ppp',onChange:function onChange(e){var value=e.target.value;var hotel=_this2.state.hotel;hotel.password=value;_this2.setState({hotel:hotel});}})))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var user=function(_Component){_inherits(user,_Component);function user(){_classCallCheck(this,user);return _possibleConstructorReturn(this,(user.__proto__||Object.getPrototypeOf(user)).apply(this,arguments));}_createClass(user,[{key:'render',value:function render(){return _react2.default.createElement('div',null);}}]);return user;}(_react.Component);exports.default=user;

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _upload=__webpack_require__(171);var _upload2=_interopRequireDefault(_upload);var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _popconfirm=__webpack_require__(110);var _popconfirm2=_interopRequireDefault(_popconfirm);var _icon=__webpack_require__(38);var _icon2=_interopRequireDefault(_icon);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _tree=__webpack_require__(224);var _tree2=_interopRequireDefault(_tree);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(62);__webpack_require__(172);__webpack_require__(12);__webpack_require__(8);__webpack_require__(60);__webpack_require__(4);__webpack_require__(6);__webpack_require__(25);__webpack_require__(111);__webpack_require__(75);__webpack_require__(10);__webpack_require__(225);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(85);__webpack_require__(197);var _DisplaySwitch=__webpack_require__(2056);var _DisplaySwitch2=_interopRequireDefault(_DisplaySwitch);var _data=__webpack_require__(348);var _data2=__webpack_require__(247);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var TreeNode=_tree2.default.TreeNode;var authName=[{name:"GM/HM 总经理/酒店经理",value:"GM"},{name:"RM/EAM 驻店经理/行政助理经理",value:"EAM"},{name:"DOF 财务总监",value:"DOF"},{name:"FM 财务经理",value:"FIN"},{name:"Income Audit",value:"IA"},{name:"DHR 人力资源总监",value:"HR"},{name:"DOSM 市场营销总监",value:"SM"},{name:"DFB 餐饮总监",value:"FB"},{name:"DOC 宴会统筹总监",value:"BQT"},{name:"DOR 房务总监/EHK 行政管家/FOM 前厅经理",value:"Rooms"},{name:"DOE 工程总监",value:"ENG"},{name:"REVM 收益经理",value:"REV"},{name:"Training",value:"Training"}];var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getData=function(){fetch('/getHotels',{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this.setState({loading:false});var hotels=x.data.hotels||[];if(x.status==1){_this.setState({data:hotels,type:x.data.type||[],dataTotal:hotels});_this.onSearch();return;}_message3.default.error('数据获取失败！'+JSON.stringify(x.msg));}).catch(function(err){_this.setState({loading:false});console.error(err);_message3.default.error('数据获取失败！'+JSON.stringify(err));});};_this.showModal=function(){_this.setState({visible:true});};_this.handleOk=function(e){_this.setState({loadingSave:true});var data=JSON.parse(JSON.stringify(_this.state.hotel));if(!data.name||!data.code){_message3.default.error('酒店信息不能为空');_this.setState({loadingSave:false});return;}data.img=JSON.stringify(data.img.map(function(x){return{uid:x.uid,url:x.url||(x.response?x.response.data:'')};}));delete data.typename;data.type=(data.type||"").toString();delete data.add_time;var dataFrom=new FormData();for(var key in data){if(data.hasOwnProperty(key)){dataFrom.append(key,data[key]||"");}}var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/addHotel',headres).then(function(x){return x.json();}).then(function(x){if(x.status==1){_message3.default.info('保存成功！');_this.getData();_this.setState({visible:false,loadingSave:false,loading:true,hotel:{name:"",tel:"",address:"",contacts:"",code:""}});return;}_message3.default.error(x.msg);_this.setState({loadingSave:false});}).catch(function(err){console.error(err);_message3.default.error('数据添加失败！');_this.setState({loadingSave:false});});};_this.handleCancel=function(e){_this.setState({visible:false,hotel:{name:"",tel:"",address:"",contacts:""}});};_this.getAuthData=function(){fetch('/getAuth?user='+_this.state.hotelAuthName,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){var checkedKeys=x.data[0].data.split(',');_this.setState({auth:x.data[0],checkedKeys:checkedKeys,authLoading:false});}else{_this.setState({auth:{},checkedKeys:[],authLoading:false});}}).catch(function(err){console.error(err);_this.setState({authLoading:false});});};_this.authshowModal=function(){if(_this.state.info.email!='admin'){_message3.default.error('权限不足！');return;}_this.setState({authVisible:true,authLoading:true});_this.getAuthData();};_this.authhandleOk=function(e){if(_this.state.info.email!='admin'){_message3.default.error('权限不足！');return;}_this.setState({loadingAuth:true});var checkedKeys=_this.state.checkedKeys;var hotelAuthName=_this.state.hotelAuthName;// console.log(checkedKeys)
var data=_extends({},_this.state.auth,{user:hotelAuthName,data:checkedKeys.toString()});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/addAuth',headres).then(function(x){return x.json();}).then(function(x){_this.setState({loadingAuth:false});if(x.status==1){_message3.default.success('保存成功');return;}_message3.default.error('保存失败！');}).catch(function(err){console.error(err);_this.setState({loadingAuth:false});});};_this.authhandleCancel=function(e){_this.setState({authVisible:false});};_this.onChange=function(value,lable,extra){_this.setState({selectAuth:value});};_this.onExpand=function(expandedKeys){// if not set autoExpandParent to false, if children expanded, parent can not collapse.
// or, you can remove all expanded children keys.
_this.setState({expandedKeys:expandedKeys,autoExpandParent:false});};_this.onCheck=function(checkedKeys,checkedNodes){_this.setState({checkedKeys:checkedKeys});};_this.onSelect=function(selectedKeys,info){_this.setState({selectedKeys:selectedKeys});};_this.renderTreeNodes=function(data){return data.map(function(item){if(item.children){return _react2.default.createElement(TreeNode,{title:item.title,key:item.key,dataRef:item},_this.renderTreeNodes(item.children));}return _react2.default.createElement(TreeNode,item);});};_this.onSearch=function(){var _this$state=_this.state,dataTotal=_this$state.dataTotal,_this$state$searchDat=_this$state.searchData,_this$state$searchDat2=_this$state$searchDat.name,name=_this$state$searchDat2===undefined?"":_this$state$searchDat2,_this$state$searchDat3=_this$state$searchDat.abridge,abridge=_this$state$searchDat3===undefined?"":_this$state$searchDat3,_this$state$searchDat4=_this$state$searchDat.area,area=_this$state$searchDat4===undefined?"":_this$state$searchDat4,_this$state$searchDat5=_this$state$searchDat.income,income=_this$state$searchDat5===undefined?"":_this$state$searchDat5;var data=dataTotal.filter(function(x){return(x.name||"").trim().includes(name)&&(x.code||"").trim().toUpperCase().includes(abridge.trim().toUpperCase())&&(x.area||"").trim().includes(area)&&(x.income_interval==income||!income);});_this.setState({data:data});};_this.onDeleteHotel=function(data){fetch('/deleteHotel?id='+data.id,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.status==1){_message3.default.info('删除成功！');_this.getData();return;}_message3.default.error(x.msg);}).catch(function(err){console.error(err);});};_this.resetPassword=function(data){fetch('/resetPassword?id='+data.id,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.status==1){_message3.default.info('密码重置成功，请牢记新密码: 1212');return;}_message3.default.error('操作失败！');}).catch(function(err){_message3.default.error('操作失败！');console.error(err);});};_this.state={data:[],type:[],visible:false,loadingSave:false,loading:true,uplading:false,hotel:{name:"",tel:"",address:"",contacts:"",code:"",type:[],typename:[],img:[]},loadingAuth:false,authData:[],authVisible:false,hotelAuthName:"FIN",expandedKeys:[],autoExpandParent:true,checkedKeys:[],selectedKeys:[],auth:{},authLoading:false,info:sessionStorage.getItem('user')?JSON.parse(sessionStorage.getItem('user')):{},dataTotal:[],searchData:{name:"",abridge:"",area:"",income:''}};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData();}// 权限
},{key:'render',value:function render(){var _this2=this;var _state=this.state,searchData=_state.searchData,data=_state.data,hotel=_state.hotel,uplading=_state.uplading;var uploadButton=_react2.default.createElement('div',null,_react2.default.createElement(_icon2.default,{type:uplading?'loading':'plus'}),_react2.default.createElement('div',{className:'ant-upload-text'},uplading?'上传中...':'上传'));var columns=[{title:'序号',dataIndex:'id',key:'id'},{title:'酒店名称',dataIndex:'name',key:'name',render:function render(text,record){return _react2.default.createElement(_reactRouterDom.Link,{to:'/table/hotel/'+record.id},text);}},{title:'缩写',dataIndex:'code',key:'code'},{title:'性质',dataIndex:'nature',key:'nature'},{title:'开业时间',dataIndex:'openDate',key:'openDate'},{title:'集团合同到期日',dataIndex:'groupExpireDate',key:'groupExpireDate'},{title:'温德姆编码',dataIndex:'wdm_number',key:'wdm_number'},{title:'区域',key:'area',dataIndex:'area'},{title:'收入区间',key:'income_interval',dataIndex:'income_interval',render:function render(text,record){return _data2.incomeRange[text]||"";}},{title:'操作',key:'add_time',render:function render(record){return _react2.default.createElement('div',null,_react2.default.createElement(_reactRouterDom.Link,{to:'/table/hotel/'+record.id},'\u67E5\u770B'),_react2.default.createElement(_icon2.default,{type:'minus'}),_react2.default.createElement('span',{style:{color:"#1890ff",cursor:"pointer"},onClick:function onClick(){var thistype=(record.type||"").split(',');var typename=[];thistype.forEach(function(element){(_this2.state.type||[]).forEach(function(item){if(item.id==element){typename.push(item.name);}});});var hotel=_extends({},record,{type:(record.type||"").split(','),typename:typename});_this2.setState({hotel:hotel,visible:true});console.log(_this2.state.hotel.type);}},'\u7F16\u8F91'),_react2.default.createElement(_icon2.default,{type:'minus'}),_react2.default.createElement(_popconfirm2.default,{title:'\u786E\u5B9A\u8981\u5220\u9664\u9152\u5E97?',onConfirm:_this2.onDeleteHotel.bind(_this2,record),onCancel:function onCancel(){},okText:'\u662F',cancelText:'\u5426'},_react2.default.createElement('span',{style:{color:"#1890ff",cursor:"pointer"}},'\u5220\u9664')),_react2.default.createElement('span',null,_react2.default.createElement(_icon2.default,{type:'minus'}),_react2.default.createElement(_popconfirm2.default,{title:'\u786E\u5B9A\u8981\u91CD\u7F6E\u5BC6\u7801\u5417?',onConfirm:_this2.resetPassword.bind(_this2,record),onCancel:function onCancel(){},okText:'\u662F',cancelText:'\u5426'},_react2.default.createElement('span',{style:{color:"#1890ff",cursor:"pointer"}},'\u91CD\u7F6E\u5BC6\u7801'))));}}];return _react2.default.createElement('div',{className:'settings'},_react2.default.createElement(_row2.default,{style:{margin:'20px 0'}},_react2.default.createElement('span',null,'\u9152\u5E97\u540D\u79F0\uFF1A'),_react2.default.createElement(_input2.default,{style:{width:150,margin:"0 10px"},value:searchData.name,onChange:function onChange(e){_this2.setState({searchData:_extends({},searchData,{name:e.target.value||""})});},onPressEnter:this.onSearch}),_react2.default.createElement('span',null,'\u7F29\u5199\uFF1A'),_react2.default.createElement(_input2.default,{style:{width:150,margin:"0 10px"},value:searchData.abridge,onChange:function onChange(e){_this2.setState({searchData:_extends({},searchData,{abridge:e.target.value||""})});},onPressEnter:this.onSearch}),_react2.default.createElement('span',null,'\u533A\u57DF\uFF1A'),_react2.default.createElement(_input2.default,{style:{width:150,margin:"0 10px"},value:searchData.area,onChange:function onChange(e){_this2.setState({searchData:_extends({},searchData,{area:e.target.value||""})});},onPressEnter:this.onSearch}),_react2.default.createElement('span',null,'\u6536\u5165\u533A\u95F4\uFF1A'),_react2.default.createElement(_select2.default,{allowClear:true,value:searchData.income,style:{width:200,margin:"0 10px"},onChange:function onChange(value){_this2.setState({searchData:_extends({},searchData,{income:value||""})});}},_react2.default.createElement(Option,{value:'1'},'\u4E00\u4EBF\u4EE5\u4E0A'),_react2.default.createElement(Option,{value:'2'},'8000\u4E07-1\u4EBF'),_react2.default.createElement(Option,{value:'3'},'6500\u4E07-8000\u4E07'),_react2.default.createElement(Option,{value:'4'},'5500\u4E07-6500\u4E07'),_react2.default.createElement(Option,{value:'5'},'4500\u4E07-5500\u4E07'),_react2.default.createElement(Option,{value:'6'},'3500\u4E07-4500\u4E07'),_react2.default.createElement(Option,{value:'7'},'2000\u4E07-3500\u4E07'),_react2.default.createElement(Option,{value:'9'},'1000\u4E07-2000\u4E07'),_react2.default.createElement(Option,{value:'10'},'\u5C0F\u4E8E1000\u4E07')),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSearch},'\u641C\u7D22'),_react2.default.createElement(_button2.default,{style:{margin:"0 10px"},onClick:function onClick(){_this2.setState({searchData:{name:"",abridge:"",area:"",income:''}},function(){_this2.onSearch();});}},'\u91CD\u7F6E')),_react2.default.createElement(_row2.default,{style:{margin:'20px 0'}},_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement(_button2.default,{type:'primary',onClick:this.showModal,style:{marginRight:10}},'\u65B0\u589E\u9152\u5E97'),_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){_this2.props.history.push('/table/labelmanagement');}},'\u9152\u5E97\u6807\u7B7E')),_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement(_row2.default,{type:'flex',justify:'end'},_react2.default.createElement(_DisplaySwitch2.default,null),_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){_this2.props.history.push('/table/BpSave');},style:{marginRight:10}},'BP\u4FDD\u5B58\u6743\u9650\u8BBE\u7F6E'),_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){_this2.props.history.push('/table/headquarters');},style:{marginRight:10}},'\u603B\u90E8\u4EBA\u5458\u7BA1\u7406'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.authshowModal},'\u6743\u9650\u8BBE\u7F6E')))),_react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement(_table2.default,{style:{marginTop:20},columns:columns,dataSource:data,bordered:true,rowKey:function rowKey(item,index){return index;}})),_react2.default.createElement(_modal2.default,{title:this.state.hotel.id?'酒店编辑':"酒店添加",visible:this.state.visible,onOk:this.handleOk,onCancel:this.handleCancel,footer:[_react2.default.createElement(_button2.default,{key:'back',onClick:this.handleCancel},'\u53D6\u6D88'),_react2.default.createElement(_button2.default,{key:'submit',type:'primary',loading:this.state.loadingSave,onClick:this.handleOk},'\u4FDD\u5B58')]},_react2.default.createElement(_row2.default,{className:'modal'},_react2.default.createElement(_row2.default,null,_react2.default.createElement('span',null,'\u9152\u5E97\u540D\u79F0\uFF1A'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u9152\u5E97\u540D\u79F0',style:{width:'60%',marginLeft:24},value:this.state.hotel.name,onChange:function onChange(e){var value=e.target.value;var hotel=_this2.state.hotel;hotel.name=value;_this2.setState({hotel:hotel});}})),_react2.default.createElement(_row2.default,{className:'settings-modal-content'},_react2.default.createElement('span',null,'\u533A\u57DF\uFF1A'),_react2.default.createElement(_select2.default,{allowClear:true,value:this.state.hotel.area,style:{width:'60%',marginLeft:50},onChange:function onChange(value){var hotel=_this2.state.hotel;hotel.area=value||"";_this2.setState({hotel:hotel});}},_react2.default.createElement(Option,{value:'\u4E1C\u5357\u534E\u5357'},'\u4E1C\u5357\u534E\u5357'),_react2.default.createElement(Option,{value:'\u534E\u5317\u534E\u4E2D'},'\u534E\u5317\u534E\u4E2D'),_react2.default.createElement(Option,{value:'\u6C5F\u6D59\u6CAA\u7696'},'\u6C5F\u6D59\u6CAA\u7696'),_react2.default.createElement(Option,{value:'\u897F\u5357'},'\u897F\u5357'),_react2.default.createElement(Option,{value:'\u534E\u4E1C'},'\u534E\u4E1C'))),_react2.default.createElement(_row2.default,{className:'settings-modal-content'},_react2.default.createElement('span',null,'\u6536\u5165\u533A\u95F4\uFF1A'),_react2.default.createElement(_select2.default,{allowClear:true,value:this.state.hotel.income_interval,style:{width:'60%',marginLeft:24},onChange:function onChange(value){var hotel=_this2.state.hotel;hotel.income_interval=value||"";_this2.setState({hotel:hotel});}},Object.entries(_data2.incomeRange).map(function(x){return _react2.default.createElement(Option,{value:x[0]},x[1]);}))),_react2.default.createElement(_row2.default,{className:'settings-modal-content'},_react2.default.createElement('span',null,'\u8054\u7CFB\u4EBA\uFF1A'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u8054\u7CFB\u4EBA',style:{width:'60%',marginLeft:38},value:this.state.hotel.contacts,onChange:function onChange(e){var value=e.target.value;var hotel=_this2.state.hotel;hotel.contacts=value;_this2.setState({hotel:hotel});}})),_react2.default.createElement(_row2.default,{className:'settings-modal-content'},_react2.default.createElement('span',null,'\u9152\u5E97\u5730\u5740\uFF1A'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u9152\u5E97\u5730\u5740',style:{width:'60%',marginLeft:24},value:this.state.hotel.address,onChange:function onChange(e){var value=e.target.value;var hotel=_this2.state.hotel;hotel.address=value;_this2.setState({hotel:hotel});}})),_react2.default.createElement(_row2.default,{className:'settings-modal-content'},_react2.default.createElement('span',null,'\u8054\u7CFB\u7535\u8BDD\uFF1A'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u8054\u7CFB\u7535\u8BDD',style:{width:'60%',marginLeft:24},value:this.state.hotel.tel,onChange:function onChange(e){var value=e.target.value;var hotel=_this2.state.hotel;hotel.tel=value;_this2.setState({hotel:hotel});}})),_react2.default.createElement(_row2.default,{className:'settings-modal-content'},_react2.default.createElement('span',null,'\u4EE3\u7801\u6807\u8BC6\uFF1A'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u4EE3\u7801\u6807\u8BC6',style:{width:'60%',marginLeft:24},value:this.state.hotel.code,disabled:this.state.hotel.id,onChange:function onChange(e){var value=e.target.value;var hotel=_this2.state.hotel;hotel.code=value;_this2.setState({hotel:hotel});}})),_react2.default.createElement(_row2.default,{className:'settings-modal-content'},_react2.default.createElement('span',null,'\u6E29\u5FB7\u59C6\u7F16\u7801\uFF1A'),_react2.default.createElement(_input2.default,{placeholder:'\u8BF7\u8F93\u5165\u4EE3\u7801\u6807\u8BC6',style:{width:'60%',marginLeft:10},value:this.state.hotel.wdm_number,onChange:function onChange(e){var value=e.target.value;var hotel=_this2.state.hotel;hotel.wdm_number=value;_this2.setState({hotel:hotel});}})),_react2.default.createElement(_row2.default,{className:'list-item'},_react2.default.createElement('span',{className:'label'},'\u9152\u5E97\u56FE\u7247\uFF1A'),_react2.default.createElement(_upload2.default,{className:'value',action:'/qiansheng/open/upload',listType:'picture-card',fileList:hotel.img,onChange:function onChange(info){_this2.setState({hotel:_extends({},hotel,{img:info.fileList})});if(info.file.status==='uploading'){_this2.setState({uplading:true});return;}if(info.file.status==='done'){_this2.setState({uplading:false});}}},(hotel.img||[]).length>=8?null:uploadButton)))),_react2.default.createElement(_modal2.default,{title:'\u6743\u9650\u8BBE\u7F6E',visible:this.state.authVisible,onOk:this.authhandleOk,onCancel:this.authhandleCancel,footer:[_react2.default.createElement(_button2.default,{key:'back',onClick:this.authhandleCancel},'\u53D6\u6D88'),_react2.default.createElement(_button2.default,{key:'submit',type:'primary',loading:this.state.loadingAuth,onClick:this.authhandleOk},'\u4FDD\u5B58')]},_react2.default.createElement(_spin2.default,{spinning:this.state.authLoading},_react2.default.createElement(_row2.default,{className:'modal'},_react2.default.createElement(_row2.default,null,_react2.default.createElement('span',null,'\u9009\u62E9\u4EBA\u5458\uFF1A'),_react2.default.createElement(_select2.default,{value:this.state.hotelAuthName,style:{width:300},onChange:function onChange(value){_this2.setState({hotelAuthName:value,authLoading:true},function(){_this2.getAuthData();});}},authName.map(function(x,i){return _react2.default.createElement(Option,{key:x.value},x.name);}))),_react2.default.createElement(_row2.default,{className:'authCotent'},_react2.default.createElement(_row2.default,null,'\u6743\u9650\u914D\u7F6E'),_react2.default.createElement(_tree2.default,{checkable:true// checkStrictly={true}
,onExpand:this.onExpand,expandedKeys:this.state.expandedKeys,autoExpandParent:this.state.autoExpandParent,onCheck:this.onCheck,checkedKeys:this.state.checkedKeys,onSelect:this.onSelect,selectedKeys:this.state.selectedKeys},this.renderTreeNodes(_data.authData)))))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _switch=__webpack_require__(249);var _switch2=_interopRequireDefault(_switch);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(62);__webpack_require__(250);__webpack_require__(6);__webpack_require__(10);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DisplaySwitch=function(_Component){_inherits(DisplaySwitch,_Component);function DisplaySwitch(props){_classCallCheck(this,DisplaySwitch);var _this=_possibleConstructorReturn(this,(DisplaySwitch.__proto__||Object.getPrototypeOf(DisplaySwitch)).call(this,props));_this.showModal=function(){_this.setState({switchLoading:true,visible:true});fetch('/getTableSwitch',{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this.setState({data:x.data||{es:0,bp:0,hr:0},switchLoading:false});}).catch(function(err){console.error(err);_message3.default.error('获取失败！'+JSON.stringify(err));_this.setState({switchLoading:false});});};_this.handleCancel=function(){_this.setState({visible:false});};_this.handleOk=function(){var data=_this.state.data;_this.setState({loading:true});var headres={method:'post',credentials:'include',headers:{},body:JSON.stringify(data)};fetch('/addTableSwitch',headres).then(function(x){return x.json();}).then(function(x){_this.setState({loading:false});if(x.status==1){_message3.default.info('保存成功！');_this.setState({visible:false});}else{_message3.default.error('保存失败！'+x.msg);}}).catch(function(err){console.error(err);_message3.default.error('保存失败！'+JSON.stringify(err));_this.setState({loading:false});});};_this.state={visible:false,loading:false,data:{es:0,bp:0,hr:0},switchLoading:false};return _this;}_createClass(DisplaySwitch,[{key:'render',value:function render(){var _this2=this;var data=this.state.data;return _react2.default.createElement('div',null,_react2.default.createElement(_button2.default,{type:'primary',className:'diplay-switch',onClick:this.showModal},'\u663E\u793A\u8BBE\u7F6E'),_react2.default.createElement(_modal2.default,{title:'\u8868\u683C\u663E\u793A\u8BBE\u7F6E',visible:this.state.visible,onOk:this.handleOk,onCancel:this.handleCancel,footer:[_react2.default.createElement(_button2.default,{key:'back',onClick:this.handleCancel},'\u53D6\u6D88'),_react2.default.createElement(_button2.default,{key:'submit',type:'primary',loading:this.state.loading,onClick:this.handleOk},'\u4FDD\u5B58')]},_react2.default.createElement('div',null,_react2.default.createElement('span',{style:{marginRight:10}},'Executive Summary Report \u6708\u5EA6\u7ECF\u8425\u62A5\u544A'),_react2.default.createElement(_switch2.default,{checkedChildren:'\u5F00',unCheckedChildren:'\u5173',checked:data.es==1?true:false,loading:this.state.switchLoading,onChange:function onChange(checked){_this2.setState({data:_extends({},data,{es:checked?1:0})});}})),_react2.default.createElement('div',{style:{marginTop:10}},_react2.default.createElement('span',{style:{marginRight:10}},'Business Plan \u5E74\u5EA6\u7ECF\u8425\u8BA1\u5212'),_react2.default.createElement(_switch2.default,{checkedChildren:'\u5F00',unCheckedChildren:'\u5173',checked:data.bp==1?true:false,loading:this.state.switchLoading,onChange:function onChange(checked){_this2.setState({data:_extends({},data,{bp:checked?1:0})});}})),_react2.default.createElement('div',{style:{marginTop:10}},_react2.default.createElement('span',{style:{marginRight:10}},'Human Resources \u4EBA\u529B\u8D44\u6E90\u62A5\u544A'),_react2.default.createElement(_switch2.default,{checkedChildren:'\u5F00',unCheckedChildren:'\u5173',checked:data.hr==1?true:false,loading:this.state.switchLoading,onChange:function onChange(checked){_this2.setState({data:_extends({},data,{hr:checked?1:0})});}}))));}}]);return DisplaySwitch;}(_react.Component);exports.default=DisplaySwitch;

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _Food=__webpack_require__(2058);var _Food2=_interopRequireDefault(_Food);__webpack_require__(2061);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"daily-s"},_react2.default.createElement(_Food2.default,null));}}]);return App;}(_react.Component))||_class)||_class);exports.default=App;

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(8);__webpack_require__(14);__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _mobx=__webpack_require__(30);var _Total=__webpack_require__(2059);var _Total2=_interopRequireDefault(_Total);var _Rooms=__webpack_require__(2060);var _Rooms2=_interopRequireDefault(_Rooms);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var totalIndex=[];var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(name,value,i){var _this$props$store$dai=_this.props.store.daily,roomData=_this$props$store$dai.roomData,dayData=_this$props$store$dai.dayData,foodData=_this$props$store$dai.foodData;var data=[].concat(_toConsumableArray((0,_mobx.toJS)(foodData)));data[i][name]=value;_this.props.store.daily.onChange({roomData:roomData,foodData:data,dayData:dayData});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){var _props$store$daily=this.props.store.daily,getData=_props$store$daily.getData,date=_props$store$daily.date;getData(date);}},{key:'render',value:function render(){var _this2=this;var _props$store$daily2=this.props.store.daily,print=_props$store$daily2.print,loading=_props$store$daily2.loading,foodData=_props$store$daily2.foodData,saveLoading=_props$store$daily2.saveLoading;var columns=[{title:_react2.default.createElement('span',null,'Food&Beverage',_react2.default.createElement('br',null),' \u9910\u996E'),dataIndex:'name',key:'name',align:"center",// width: 200,
render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Today',_react2.default.createElement('br',null),' \u4ECA\u65E5\u5B9E\u9645'),children:[{title:_react2.default.createElement('span',null,'Actual',_react2.default.createElement('br',null),' \u5B9E\u9645\u6536\u5165'),dataIndex:'actual',key:'actual',align:"center",// width: 150,
render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"actual",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['Today<br /> 今日实际',"Actual<br /> 实际收入"],record:record,sqlName:"daily"}};if(index==10)props.type="number";return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Covers',_react2.default.createElement('br',null),' \u4EBA\u6570'),dataIndex:'covers',key:'covers',align:"center",// width: 150,
render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"covers",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['Today<br /> 今日实际',"Covers<br /> 人数"],record:record,sqlName:"daily"}};if(index==10)props.type="number";if(index==9)props.type="";return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Average Check',_react2.default.createElement('br',null),' \u4EBA\u5747\u6D88\u8D39'),dataIndex:'average',key:'average',align:"center",// width: 150,
render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"average",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['Today<br /> 今日实际',"Average Check<br /> 人均消费"],record:record,sqlName:"daily"}};if(index==9)props.type="";return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]},{title:_react2.default.createElement('span',null,'Last Year ',_react2.default.createElement('br',null),' \u53BB\u5E74\u5F53\u65E5'),children:[{title:_react2.default.createElement('span',null,'Actual',_react2.default.createElement('br',null),' \u5B9E\u9645\u6536\u5165'),dataIndex:'last_actual',key:'last_actual',align:"center",// width: 150,
render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"last_actual",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['Last Year <br /> 去年当日',"Actual<br /> 实际收入"],record:record,sqlName:"daily"}};if(index==10)props.type="number";return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Covers',_react2.default.createElement('br',null),' \u4EBA\u6570'),dataIndex:'last_covers',key:'last_covers',align:"center",// width: 150,
render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"last_covers",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['Last Year <br /> 去年当日',"Covers<br /> 人数"],record:record,sqlName:"daily"}};if(index==10)props.type="number";if(index==9)props.type="";return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Average Check',_react2.default.createElement('br',null),' \u4EBA\u5747\u6D88\u8D39'),dataIndex:'last_average',key:'last_average',align:"center",// width: 150,
render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_average",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['Last Year <br /> 去年当日',"Average Check<br /> 人均消费"],record:record,sqlName:"daily"}};if(index==9)props.type="";return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}];return _react2.default.createElement('div',{className:'table7_1_1 '},_react2.default.createElement('div',{id:'daily'},_react2.default.createElement(_row2.default,{className:'title'},_react2.default.createElement(_row2.default,null,' Daily Revenue Report \u6BCF\u65E5\u7ECF\u8425\u62A5\u8868'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(_datePicker2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.props.store.daily.date,"YYYY-MM-DD"),format:'YYYY-MM-DD',onChange:function onChange(date,str){_this2.props.store.daily.getData(str);(0,_mobx.runInAction)(function(){_this2.props.store.daily.date=str;});}}),' ')),_react2.default.createElement('div',{className:'daily'},_react2.default.createElement('div',{className:'month'},_react2.default.createElement(_Rooms2.default,null)),_react2.default.createElement('div',{className:'day'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_1_1'},_react2.default.createElement(_table2.default,{columns:columns,dataSource:(0,_mobx.toJS)(foodData),size:'middle',bordered:true,pagination:false,loading:loading,className:'content',rowKey:function rowKey(record,index){return index;}})))),_react2.default.createElement(_Total2.default,null)),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},!print&&_react2.default.createElement(_button2.default,{type:'primary',onClick:this.props.store.daily.onSave,loading:saveLoading},'\u4FDD\u5B58')));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(8);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _mobxReact=__webpack_require__(18);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(name,value,i){var _this$props$store$dai=_this.props.store.daily,roomData=_this$props$store$dai.roomData,dayData=_this$props$store$dai.dayData,foodData=_this$props$store$dai.foodData;var data=[].concat(_toConsumableArray((0,_mobx.toJS)(dayData)));data[i][name]=value;_this.props.store.daily.onChange({roomData:roomData,foodData:foodData,dayData:data});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'render',value:function render(){var _this2=this;var _props$store$daily=this.props.store.daily,dayData=_props$store$daily.dayData,loading=_props$store$daily.loading;var columns=[{title:_react2.default.createElement('span',null,'Other Revenue ',_react2.default.createElement('br',null),' \u5176\u4ED6\u6536\u5165'),dataIndex:'name',key:'name',align:"center",width:300,render:function render(text,record,index){var props={text:"Total Other Revenue <br/> 其他收入总计",index:index,type:'text',name:"name"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Today ',_react2.default.createElement('br',null),' \u4ECA\u65E5\u5B9E\u9645'),dataIndex:'other_day',key:'other_day',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"other_day",onChange:_this2.onChange,compared:{title:['Today <br /> 今日实际'],record:_extends({},record,{name:"Total Other Revenue <br/> 其他收入总计"}),sqlName:"daily_total"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Last Year ',_react2.default.createElement('br',null),' \u53BB\u5E74\u5F53\u65E5'),dataIndex:'other_last',key:'other_last',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"other_last",onChange:_this2.onChange,compared:{title:['Last Year <br /> 去年当日'],record:_extends({},record,{name:"Total Other Revenue <br/> 其他收入总计"}),sqlName:"daily_total"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];var columnsRev=[{title:_react2.default.createElement('span',null,'Daily Revenue',_react2.default.createElement('br',null),' \u6BCF\u65E5\u603B\u6536\u5165'),dataIndex:'name',key:'name',align:"center",width:300,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Today ',_react2.default.createElement('br',null),' \u4ECA\u65E5\u5B9E\u9645'),dataIndex:'rev_day',key:'rev_day',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"rev_day",compared:{title:['Today <br /> 今日实际'],record:record,sqlName:"daily_total"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Last Year ',_react2.default.createElement('br',null),' \u53BB\u5E74\u5F53\u65E5'),dataIndex:'rev_last',key:'rev_last',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"rev_last",compared:{title:['Last Year <br /> 去年当日'],record:record,sqlName:"daily_total"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];return _react2.default.createElement('div',{className:'total-table'},_react2.default.createElement(_table2.default,{columns:columns,dataSource:(0,_mobx.toJS)(dayData),size:'middle',bordered:true,pagination:false,loading:loading,className:'content',rowKey:function rowKey(record,index){return record.name;}}),_react2.default.createElement(_table2.default,{columns:columnsRev,dataSource:(0,_mobx.toJS)(dayData),size:'middle',bordered:true,pagination:false,loading:loading,className:'content',rowKey:function rowKey(record,index){return record.name;}}));}}]);return App;}(_react.Component))||_class)||_class);exports.default=App;

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(4);__webpack_require__(8);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var totalIndex=[];var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(name,value,i){var _this$props$store$dai=_this.props.store.daily,roomData=_this$props$store$dai.roomData,dayData=_this$props$store$dai.dayData,foodData=_this$props$store$dai.foodData;var data=[].concat(_toConsumableArray((0,_mobx.toJS)(roomData)));data[i][name]=value;_this.props.store.daily.onChange({roomData:data,foodData:foodData,dayData:dayData});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'render',value:function render(){var _this2=this;var _props$store$daily=this.props.store.daily,roomData=_props$store$daily.roomData,loading=_props$store$daily.loading;var inputIndex=[0,1,2,6,7];var columns=[{title:_react2.default.createElement('span',null,'Rooms',_react2.default.createElement('br',null),' \u5BA2\u623F'),dataIndex:'name',key:'name',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Today',_react2.default.createElement('br',null),' \u4ECA\u65E5\u5B9E\u9645'),dataIndex:'actual',key:'actual',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"actual",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['Today<br /> 今日实际'],record:record,sqlName:"daily_month"}};if(inputIndex.includes(index))props.type="inputNumber";if([3,8].includes(index))props.type="percent";return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Last Year ',_react2.default.createElement('br',null),' \u53BB\u5E74\u5F53\u65E5'),dataIndex:'last',key:'last',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['Last Year <br /> 去年当日'],record:record,sqlName:"daily_month"}};if(inputIndex.includes(index))props.type="inputNumber";if([3,8].includes(index))props.type="percent";return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];return _react2.default.createElement('div',{className:'table7_1_1 '},_react2.default.createElement(_row2.default,{className:'title',id:'table4_1_1'},_react2.default.createElement(_table2.default,{columns:columns,dataSource:(0,_mobx.toJS)(roomData),size:'middle',bordered:true,pagination:false,loading:loading,className:'content',rowKey:function rowKey(record,index){return index;}})));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2061 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2062 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Auth=function(_Component){_inherits(Auth,_Component);function Auth(props){_classCallCheck(this,Auth);var _this=_possibleConstructorReturn(this,(Auth.__proto__||Object.getPrototypeOf(Auth)).call(this,props));_this.getJson=function(){var arr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var obj=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return arr.reduce(function(a,b){return a&&a[b]?a[b]:'';},obj);};_this.state={user:{}};return _this;}_createClass(Auth,[{key:'componentDidMount',value:function componentDidMount(){try{var user=JSON.parse(sessionStorage.getItem('user'));this.setState({user:user});}catch(error){console.error(error);this.setState({user:{}});}}// 获取深度嵌套json
},{key:'render',value:function render(){var user=this.state.user;if(this.getJson(['email'],user).toUpperCase().includes('DOO')){return this.props.children;}// 判断是否有管理员权限
if(!this.getJson(['email'],user).toUpperCase().includes('ADMIN')){return null;}if(!this.getJson(['email'],user).toUpperCase().includes(this.props.name)&&this.getJson(['email'],user).toUpperCase()!='ADMIN'){return null;}return this.props.children;}}]);return Auth;}(_react.Component);exports.default=Auth;

/***/ }),
/* 2064 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(4);__webpack_require__(60);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ADR=__webpack_require__(2066);var _ADR2=_interopRequireDefault(_ADR);var _FB=__webpack_require__(2067);var _FB2=_interopRequireDefault(_FB);var _Market=__webpack_require__(2068);var _Market2=_interopRequireDefault(_Market);var _REV=__webpack_require__(2069);var _REV2=_interopRequireDefault(_REV);var _Revenue=__webpack_require__(2070);var _Revenue2=_interopRequireDefault(_Revenue);var _Room=__webpack_require__(2071);var _Room2=_interopRequireDefault(_Room);var _title=__webpack_require__(709);var _title2=_interopRequireDefault(_title);__webpack_require__(2076);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.state={data:{}};return _this;}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;fetch('/bi_statistics',{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this2.setState({data:x.data||{}});}).catch(function(err){console.error(err);});}},{key:"render",value:function render(){return _react2.default.createElement("div",{className:"BI_chart"},_react2.default.createElement(_title2.default,{data:this.state.data}),_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:12,className:"bizcharts_bck"},_react2.default.createElement(_ADR2.default,{data:this.state.data})),_react2.default.createElement(_col2.default,{span:12,className:"bizcharts_bck"},_react2.default.createElement(_Room2.default,{data:this.state.data}))),_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:12,className:"bizcharts_bck"},_react2.default.createElement(_FB2.default,{data:this.state.data})),_react2.default.createElement(_col2.default,{span:12,className:"bizcharts_bck"},_react2.default.createElement(_Revenue2.default,{data:this.state.data}))),_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:12,className:"bizcharts_bck"},_react2.default.createElement(_REV2.default,{data:this.state.data})),_react2.default.createElement(_col2.default,{span:12,className:"bizcharts_bck"},_react2.default.createElement(_Market2.default,{data:this.state.data}))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _getChartLine=__webpack_require__(441);var _getChartLine2=_interopRequireDefault(_getChartLine);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ADR=function(_Component){_inherits(ADR,_Component);function ADR(){_classCallCheck(this,ADR);return _possibleConstructorReturn(this,(ADR.__proto__||Object.getPrototypeOf(ADR)).apply(this,arguments));}_createClass(ADR,[{key:"componentDidMount",value:function componentDidMount(){var data=this.props.data.IncomeBudget||{};var dataY=[];for(var key in data){if(data.hasOwnProperty(key)){dataY.push({title:key,data:Object.entries(data[key]).map(function(x){return Number(x[1])||0;})});}}var defaultData={id:"ADR",title:"Total Revenue 总收入",dataY:dataY};(0,_getChartLine2.default)(defaultData);window.addEventListener('resize',function(){(0,_getChartLine2.default)(defaultData,null,true);});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var data=nextProps.data.IncomeBudget||{};var dataY=[];for(var key in data){if(data.hasOwnProperty(key)){dataY.push({title:key,data:Object.entries(data[key]).map(function(x){return Number(x[1])||0;})});}}var defaultData={id:"ADR",title:"Total Revenue 总收入",dataY:dataY};(0,_getChartLine2.default)(defaultData,true);}},{key:"componentWillUnmount",value:function componentWillUnmount(){window.removeEventListener('resize',function(){});}},{key:"render",value:function render(){return _react2.default.createElement("div",null,_react2.default.createElement("div",{className:"total_style"},"Total Revenue \u603B\u6536\u5165 "),_react2.default.createElement("div",{id:"ADR",style:{height:400,width:'100%'}}));}}]);return ADR;}(_react.Component);exports.default=ADR;

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FB=function(_Component){_inherits(FB,_Component);function FB(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FB);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FB.__proto__||Object.getPrototypeOf(FB)).call.apply(_ref,[this].concat(args))),_this),_this.setChart=function(dataX,dataY,update,isOnResize){var myChart=_echarts2.default.init(document.getElementById('FB'));myChart.resize();if(isOnResize){return;}if(update){myChart.setOption({xAxis:[{data:dataX}],series:[{data:dataY}]});return;}var option={// title: {
//     text: "FB Revenue",
//     subtext: '',
//     x: 'left'
// },
legend:{data:['Room Revenue'],align:'left',textStyle:{color:'rgba(102, 102, 102, 1)',padding:[0,0,0,16]}},color:['rgba(50, 122, 183, 1)'],tooltip:{trigger:'axis',axisPointer:{// 坐标轴指示器，坐标轴触发有效
type:'shadow'// 默认为直线，可选为：'line' | 'shadow'
}},grid:{left:'3%',right:'4%',bottom:'3%',containLabel:true},xAxis:[{type:'category',data:[],axisTick:{alignWithLabel:true}}],yAxis:[{type:'value'}],series:[{name:'Room Revenue',type:'bar',barWidth:'50%',data:[]}]};myChart.setOption(option);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FB,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var data=this.props.data.totalRev||{};var dataX=Object.entries(data).map(function(x){return x[0]+'月';});var dataY=Object.entries(data).map(function(x){return Number(x[1]);});this.setChart(dataX,dataY);window.addEventListener('resize',function(){_this2.setChart(dataX,dataY,true,true);});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data.totalRev||{};var dataX=Object.entries(data).map(function(x){return x[0]+'月';});var dataY=Object.entries(data).map(function(x){return Number(x[1]);});this.setChart(dataX,dataY,true);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',function(){});}},{key:'render',value:function render(){return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:'total_style'},'\u672C\u5E74\u635F\u76CA\u5206\u6790-\u603B\u6536\u5165'),_react2.default.createElement('div',{id:'FB',style:{height:400,width:'100%'}}));}}]);return FB;}(_react.Component);exports.default=FB;

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Market=function(_Component){_inherits(Market,_Component);function Market(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Market);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Market.__proto__||Object.getPrototypeOf(Market)).call.apply(_ref,[this].concat(args))),_this),_this.setChart=function(data,update,isOnResize){// 基于准备好的dom，初始化echarts实例
var myChart=_echarts2.default.init(document.getElementById('Market'));// 适应屏幕变化
myChart.resize();if(isOnResize){return;}// 更新数据
if(update){myChart.setOption({series:[{data:data}]});return;}var option={color:['#327AB7','#4AC18E','#D9534F','#67A8E4','#FFC61D'],tooltip:{trigger:'item',formatter:"{a} <br/>{b} : {c} ({d}%)"},series:[{name:'Cost',type:'pie',radius:'55%',center:['50%','50%'],data:[],itemStyle:{emphasis:{shadowBlur:10,shadowOffsetX:0,shadowColor:'rgba(0, 0, 0, 0.5)'}}}]};// 使用刚指定的配置项和数据显示图表。
myChart.setOption(option);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Market,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var data=this.props.data.REV||{};var dataSource=Object.entries(data).map(function(x){return{name:x[0],value:Number(x[1])||0};});dataSource.sort(function(a,b){return a.value-b.value;});this.setChart(dataSource);window.addEventListener('resize',function(){_this2.setChart(dataSource,true,true);});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data.REV||{};var dataSource=Object.entries(data).map(function(x){return{name:x[0],value:Number(x[1])||0};});dataSource.sort(function(a,b){return a.value-b.value;});this.setChart(dataSource,true);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',function(){});}},{key:'render',value:function render(){return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:'total_style'},'Cost'),_react2.default.createElement('div',{id:'Market',style:{height:400,width:'100%'}}));}}]);return Market;}(_react.Component);exports.default=Market;

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _getChartLine=__webpack_require__(441);var _getChartLine2=_interopRequireDefault(_getChartLine);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var REV=function(_Component){_inherits(REV,_Component);function REV(){_classCallCheck(this,REV);return _possibleConstructorReturn(this,(REV.__proto__||Object.getPrototypeOf(REV)).apply(this,arguments));}_createClass(REV,[{key:"componentDidMount",value:function componentDidMount(){var data=this.props.data.GOPCompared||{};var dataY=[];for(var key in data){if(data.hasOwnProperty(key)){dataY.push({title:key,data:Object.entries(data[key]).map(function(x){return Number(x[1])||0;})});}}var defaultData={id:"REV",dataY:dataY};(0,_getChartLine2.default)(defaultData);window.addEventListener('resize',function(){(0,_getChartLine2.default)(defaultData,null,true);});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var data=nextProps.data.GOPCompared||{};var dataY=[];for(var key in data){if(data.hasOwnProperty(key)){dataY.push({title:key,data:Object.entries(data[key]).map(function(x){return Number(x[1])||0;})});}}var defaultData={id:"REV",dataY:dataY};(0,_getChartLine2.default)(defaultData,true);}},{key:"componentWillUnmount",value:function componentWillUnmount(){window.removeEventListener('resize',function(){});}},{key:"render",value:function render(){return _react2.default.createElement("div",null,_react2.default.createElement("div",{className:"total_style"},"\u7ECF\u8425\u6BDB\u5229\u6DA6"),_react2.default.createElement("div",{id:"REV",style:{height:400,width:'100%'}}));}}]);return REV;}(_react.Component);exports.default=REV;

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Revenue=function(_Component){_inherits(Revenue,_Component);function Revenue(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Revenue);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Revenue.__proto__||Object.getPrototypeOf(Revenue)).call.apply(_ref,[this].concat(args))),_this),_this.setChart=function(dataX,dataY,update,isOnResize){var myChart=_echarts2.default.init(document.getElementById('Revenue'));myChart.resize();if(isOnResize){return;}if(update){myChart.setOption({xAxis:[{data:dataX}],series:[{data:dataY}]});return;}var option={// title: {
//     text: "Total Revenue",
//     subtext: '',
//     x: 'left'
// },
legend:{data:['Food and Beverage Bevenue'],align:'left',textStyle:{color:'rgba(102, 102, 102, 1)',padding:[0,0,0,16]}},color:['rgba(50, 122, 183, 1)'],tooltip:{trigger:'axis',axisPointer:{// 坐标轴指示器，坐标轴触发有效
type:'shadow'// 默认为直线，可选为：'line' | 'shadow'
}},grid:{left:'3%',right:'4%',bottom:'3%',containLabel:true},xAxis:[{type:'category',data:[],axisTick:{alignWithLabel:true}}],yAxis:[{type:'value'}],series:[{name:'Food and Beverage Bevenue',type:'bar',barWidth:'50%',data:[]}]};myChart.setOption(option);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Revenue,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var data=this.props.data.GOP||{};var dataX=Object.entries(data).map(function(x){return x[0]+'月';});var dataY=Object.entries(data).map(function(x){return Number(x[1]);});this.setChart(dataX,dataY);window.addEventListener('resize',function(){_this2.setChart(dataX,dataY,true,true);});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data.GOP||{};var dataX=Object.entries(data).map(function(x){return x[0]+'月';});var dataY=Object.entries(data).map(function(x){return Number(x[1]);});this.setChart(dataX,dataY,true);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',function(){});}},{key:'render',value:function render(){return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:'total_style'},'\u672C\u5E74\u635F\u76CA\u5206\u6790 \u6BDB\u5229\u6DA6'),_react2.default.createElement('div',{id:'Revenue',style:{height:400,width:'100%'}}));}}]);return Revenue;}(_react.Component);exports.default=Revenue;

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _getChartLine=__webpack_require__(441);var _getChartLine2=_interopRequireDefault(_getChartLine);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Rooms=function(_Component){_inherits(Rooms,_Component);function Rooms(){_classCallCheck(this,Rooms);return _possibleConstructorReturn(this,(Rooms.__proto__||Object.getPrototypeOf(Rooms)).apply(this,arguments));}_createClass(Rooms,[{key:"componentDidMount",value:function componentDidMount(){var data=this.props.data.rooms||{};var dataY=[];for(var key in data){if(data.hasOwnProperty(key)){dataY.push({title:key,data:Object.entries(data[key]).map(function(x){return Number(x[1])||0;})});}}var defaultData={id:"Rooms",dataY:dataY};(0,_getChartLine2.default)(defaultData);window.addEventListener('resize',function(){(0,_getChartLine2.default)(defaultData,null,true);});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var data=nextProps.data.rooms||{};var dataY=[];for(var key in data){if(data.hasOwnProperty(key)){dataY.push({title:key,data:Object.entries(data[key]).map(function(x){return Number(x[1])||0;})});}}var defaultData={id:"Rooms",dataY:dataY};(0,_getChartLine2.default)(defaultData,true);}},{key:"componentWillUnmount",value:function componentWillUnmount(){window.removeEventListener('resize',function(){});}},{key:"render",value:function render(){return _react2.default.createElement("div",null,_react2.default.createElement("div",{className:"total_style"},"Rooms"),_react2.default.createElement("div",{id:"Rooms",style:{height:400,width:'100%'}}));}}]);return Rooms;}(_react.Component);exports.default=Rooms;

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Left=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Left,_Component);function Left(){_classCallCheck(this,Left);return _possibleConstructorReturn(this,(Left.__proto__||Object.getPrototypeOf(Left)).apply(this,arguments));}_createClass(Left,[{key:'render',value:function render(){var data=this.props.store.general.data;var Occupancy=data.Occupancy||{};var Occ=(Object.entries(Occupancy).map(function(x){return x[1];}).reduce(function(a,b){return a<=Number(b)?Number(b):a;},0)*100).toFixed(2);return _react2.default.createElement('div',{className:'content'},_react2.default.createElement('div',{className:'title'},'\u5165\u4F4F\u7387 Occ%'),_react2.default.createElement('div',{id:'BI_title_center',style:{height:160}},' '),_react2.default.createElement('div',{className:'foot'},'\u6700\u9AD8\u5165\u4F4F\u7387 Highest\uFF1A',Occ,'%'));}}]);return Left;}(_react.Component))||_class)||_class);exports.default=Left;

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Left=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Left,_Component);function Left(){_classCallCheck(this,Left);return _possibleConstructorReturn(this,(Left.__proto__||Object.getPrototypeOf(Left)).apply(this,arguments));}_createClass(Left,[{key:'render',value:function render(){var data=this.props.store.general.data;var Amount_occupancy=Object.entries(data.Amount_occupancy||{}).map(function(x){return x[1];});var totalNum=Amount_occupancy.reduce(function(a,b){return a+Number(b);},0).toFixed(0);var monthNum=Amount_occupancy.reduce(function(a,b){return a<=Number(b)?Number(b):a;},0).toFixed(0);return _react2.default.createElement('div',{className:'content'},_react2.default.createElement('div',{className:'title'},'\u5360\u7528\u623F\u6570 Occupied Rooms ',totalNum),_react2.default.createElement('div',{id:'BI_title_left',style:{height:160,width:"100%"}},' '),_react2.default.createElement('div',{className:'foot'},'\u6700\u9AD8\u5360\u7528\u623F\u6570 Highest\uFF1A',monthNum));}}]);return Left;}(_react.Component))||_class)||_class);exports.default=Left;

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Left=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Left,_Component);function Left(){_classCallCheck(this,Left);return _possibleConstructorReturn(this,(Left.__proto__||Object.getPrototypeOf(Left)).apply(this,arguments));}_createClass(Left,[{key:'render',value:function render(){var data=this.props.store.general.data;var ADR=Object.entries(data.ADR||{}).map(function(x){return x[1];});var totalNum=ADR.reduce(function(a,b){return a+Number(b);},0).toFixed(0);var monthNum=ADR.reduce(function(a,b){return a<=Number(b)?Number(b):a;},0).toFixed(0);return _react2.default.createElement('div',{className:'content'},_react2.default.createElement('div',{className:'title'},'\u5E73\u5747\u623F\u4EF7 ADR'),_react2.default.createElement('div',{className:'text'}),_react2.default.createElement('div',{id:'BI_title_right',style:{height:160,width:"100%"}},' '),_react2.default.createElement('div',{className:'foot'},'\u6700\u9AD8\u5E73\u5747\u623F\u4EF7 Highest\uFF1A',monthNum));}}]);return Left;}(_react.Component))||_class)||_class);exports.default=Left;

/***/ }),
/* 2075 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2076 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(4);__webpack_require__(6);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _imgtopdf=__webpack_require__(128);var _imgtopdf2=_interopRequireDefault(_imgtopdf);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);__webpack_require__(2078);var _rooms=__webpack_require__(2079);var _rooms2=_interopRequireDefault(_rooms);var _food=__webpack_require__(2080);var _food2=_interopRequireDefault(_food);var _Staff=__webpack_require__(2081);var _Staff2=_interopRequireDefault(_Staff);var _title=__webpack_require__(709);var _title2=_interopRequireDefault(_title);var _Cost=__webpack_require__(2082);var _Cost2=_interopRequireDefault(_Cost);var _Day=__webpack_require__(2083);var _Day2=_interopRequireDefault(_Day);var _Month=__webpack_require__(2084);var _Month2=_interopRequireDefault(_Month);var _NetworkRating=__webpack_require__(2085);var _NetworkRating2=_interopRequireDefault(_NetworkRating);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var imgToPdf=_imgtopdf2.default.imgToPdf;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM-DD'),print:false},_this.onExport=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var data,dataFrom,headres,res,j,file;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return _this.setState({print:true});case 3:_context.next=5;return imgToPdf("general_bi",1.5);case 5:data=_context.sent;dataFrom=new FormData();dataFrom.append('img',data['img']);dataFrom.append('height',data['canvas'].height);dataFrom.append('width',data['canvas'].width);headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context.next=13;return fetch('/imgToPdf',headres);case 13:res=_context.sent;_context.next=16;return res.blob();case 16:j=_context.sent;file=new Blob([j],{type:"application/pdf"});_fileSaver2.default.saveAs(file,"BI Structure - Hotel \u9152\u5E97\u6570\u636E\u5E73\u53F0 "+_this.state.date+".pdf");_context.next=21;return _this.setState({print:false});case 21:_context.next=27;break;case 23:_context.prev=23;_context.t0=_context["catch"](0);_this.setState({print:false});console.error(_context.t0);case 27:case"end":return _context.stop();}}},_callee,_this2,[[0,23]]);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){var _this3=this;this.props.store.general.getData((0,_moment2.default)(this.state.date).format('YYYY'),(0,_moment2.default)(this.state.date).format('M'),(0,_moment2.default)(this.state.date).format('w'));window.addEventListener('resize',function(){if(window.location.hash==='#/table/general'){_this3.props.store.general.onResize();}});}},{key:"render",value:function render(){var _props$store$general=this.props.store.general,loading=_props$store$general.loading,getData=_props$store$general.getData;var _state=this.state,date=_state.date,print=_state.print;var dateFormat="YYYY-MM-DD";return _react2.default.createElement(_spin2.default,{tip:"\u52A0\u8F7D\u4E2D...",spinning:loading||print},_react2.default.createElement("div",{className:"general BI_chart",id:"general_bi"},_react2.default.createElement(_row2.default,{className:"title"},"BI Structure - Hotel \u9152\u5E97\u6570\u636E\u5E73\u53F0",_react2.default.createElement("span",{className:"bi-date"},_react2.default.createElement(_datePicker2.default,{defaultValue:(0,_moment2.default)(date,dateFormat),format:dateFormat,onChange:function onChange(m,s){getData((0,_moment2.default)(s).format('YYYY'),(0,_moment2.default)(s).format('M'),(0,_moment2.default)(s).format('w'));}})),!print&&_react2.default.createElement(_button2.default,{className:"export-to-pdf",type:"primary",onClick:this.onExport},"\u5BFC\u51FApdf")),_react2.default.createElement(_title2.default,null),_react2.default.createElement(_NetworkRating2.default,null),_react2.default.createElement(_Month2.default,null),_react2.default.createElement(_rooms2.default,null),_react2.default.createElement(_food2.default,null),_react2.default.createElement(_Staff2.default,null),_react2.default.createElement(_Cost2.default,null)));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2078 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(60);__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var rooms=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(rooms,_Component);function rooms(){_classCallCheck(this,rooms);return _possibleConstructorReturn(this,(rooms.__proto__||Object.getPrototypeOf(rooms)).apply(this,arguments));}_createClass(rooms,[{key:"render",value:function render(){var _props$store$general=this.props.store.general,onChangeTime=_props$store$general.onChangeTime,selectData=_props$store$general.selectData;var selected={color:'#4c84ff'};return _react2.default.createElement("div",{className:"rooms"},_react2.default.createElement(_row2.default,{className:"title"},"\u5BA2\u623F\u7C7B\u6570\u636E"),_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement("div",{className:"total_style title_style"},_react2.default.createElement("span",null,"\u5BA2\u623F\u6570\u636E")),_react2.default.createElement("div",{id:"room_left",style:{height:400,width:'100%'}})),_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement("div",{className:"total_style title_style"},_react2.default.createElement("span",null,"\u576A\u6548")),_react2.default.createElement("div",{id:"room_right",style:{height:400,width:'100%'}}))));}}]);return rooms;}(_react.Component))||_class)||_class);exports.default=rooms;

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(60);__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var rooms=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(rooms,_Component);function rooms(){_classCallCheck(this,rooms);return _possibleConstructorReturn(this,(rooms.__proto__||Object.getPrototypeOf(rooms)).apply(this,arguments));}_createClass(rooms,[{key:"render",value:function render(){var _props$store$general=this.props.store.general,selectData=_props$store$general.selectData,onChangeTime=_props$store$general.onChangeTime;var selected={color:'#4c84ff'};return _react2.default.createElement("div",{className:"rooms"},_react2.default.createElement(_row2.default,{className:"title"},"\u9910\u996E\u7C7B\u6570\u636E"),_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement("div",{className:"total_style title_style"},_react2.default.createElement("span",null,"\u6536\u5165\u5206\u5E03")),_react2.default.createElement("div",{id:"food_left",style:{height:400,width:'100%'}})),_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement("div",{className:"total_style title_style"},_react2.default.createElement("span",null,"\u6536\u5165\u4E0E\u6210\u672C\u5360\u6BD4"),_react2.default.createElement("div",null)),_react2.default.createElement("div",{id:"food_right",style:{height:400,width:'100%'}}))));}}]);return rooms;}(_react.Component))||_class)||_class);exports.default=rooms;

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(4);__webpack_require__(60);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var rooms=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(rooms,_Component);function rooms(){_classCallCheck(this,rooms);return _possibleConstructorReturn(this,(rooms.__proto__||Object.getPrototypeOf(rooms)).apply(this,arguments));}_createClass(rooms,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"rooms"},_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement("div",{className:"total_style"},"\u7ADE\u4E89\u5BF9\u624B\u5BA2\u623F\u6570\u636E"),_react2.default.createElement("div",{id:"staff_left",style:{height:400,width:'100%'}})),_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement("div",{className:"total_style"},"\u5458\u5DE5\u4EA7\u91CF"),_react2.default.createElement("div",{id:"staff_right",style:{height:400,width:'100%'}}))));}}]);return rooms;}(_react.Component))||_class)||_class);exports.default=rooms;

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cost=function(_Component){_inherits(Cost,_Component);function Cost(){_classCallCheck(this,Cost);return _possibleConstructorReturn(this,(Cost.__proto__||Object.getPrototypeOf(Cost)).apply(this,arguments));}_createClass(Cost,[{key:"render",value:function render(){return _react2.default.createElement("div",{id:"cost"});}}]);return Cost;}(_react.Component);exports.default=Cost;

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(60);__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var rooms=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(rooms,_Component);function rooms(){_classCallCheck(this,rooms);return _possibleConstructorReturn(this,(rooms.__proto__||Object.getPrototypeOf(rooms)).apply(this,arguments));}_createClass(rooms,[{key:"render",value:function render(){var _props$store$general=this.props.store.general,onChangeTime=_props$store$general.onChangeTime,selectData=_props$store$general.selectData;var selected={color:'#4c84ff'};return _react2.default.createElement("div",{className:"rooms"},_react2.default.createElement(_row2.default,{className:"title"},"\u6BCF\u5468\u6570\u636E\u6C47\u603B"),_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement("div",{className:"total_style title_style"},"\u5BA2\u623F\u6570\u636E"),_react2.default.createElement("div",{id:"day-rooms",style:{height:400,width:'100%'}})),_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement("div",{className:"total_style title_style"},_react2.default.createElement("span",null,"\u6536\u5165\u5206\u5E03")),_react2.default.createElement("div",{style:{height:400,width:'100%'},id:"day-rev"}))));}}]);return rooms;}(_react.Component))||_class)||_class);exports.default=rooms;

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(60);__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var rooms=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(rooms,_Component);function rooms(){_classCallCheck(this,rooms);return _possibleConstructorReturn(this,(rooms.__proto__||Object.getPrototypeOf(rooms)).apply(this,arguments));}_createClass(rooms,[{key:"render",value:function render(){var _props$store$general=this.props.store.general,onChangeTime=_props$store$general.onChangeTime,selectData=_props$store$general.selectData;var selected={color:'#4c84ff'};return _react2.default.createElement("div",{className:"rooms"},_react2.default.createElement(_row2.default,{className:"title"},"\u6708\u5EA6\u6570\u636E\u6C47\u603B"),_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement("div",{className:"total_style title_style"},"\u5BA2\u623F\u6570\u636E"),_react2.default.createElement("div",{id:"month-rooms",style:{height:400,width:'100%'}})),_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement("div",{className:"total_style title_style"},_react2.default.createElement("span",null,"\u6536\u5165\u5206\u5E03")),_react2.default.createElement("div",{style:{height:400,width:'100%'},id:"month-rev"}))));}}]);return rooms;}(_react.Component))||_class)||_class);exports.default=rooms;

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(4);__webpack_require__(8);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var rooms=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(rooms,_Component);function rooms(){_classCallCheck(this,rooms);return _possibleConstructorReturn(this,(rooms.__proto__||Object.getPrototypeOf(rooms)).apply(this,arguments));}_createClass(rooms,[{key:"render",value:function render(){var _props$store$general$=this.props.store.general.score,score=_props$store$general$===undefined?[]:_props$store$general$;var columns=[{title:'酒店名称',dataIndex:'name',key:'name',width:150},{title:'携程',dataIndex:'ctrip',key:'ctrip',align:"center",width:100,sorter:function sorter(a,b){return a.ctrip-b.ctrip;},render:function render(text,record){return _react2.default.createElement("div",{style:{textAlign:"center",paddingRight:24}},text);}},{title:'艺龙',dataIndex:'elong',key:'elong',align:"center",width:100,sorter:function sorter(a,b){return a.elong-b.elong;},render:function render(text,record){return _react2.default.createElement("div",{style:{textAlign:"center",paddingRight:24}},text);}},{title:'booking.com',dataIndex:'book',key:'book',align:"center",width:100,sorter:function sorter(a,b){return a.book-b.book;},render:function render(text,record){return _react2.default.createElement("div",{style:{textAlign:"center",paddingRight:24}},text);}}];return _react2.default.createElement("div",{className:"rooms"},_react2.default.createElement(_row2.default,{className:"score"},_react2.default.createElement("div",{className:"total_style"},_react2.default.createElement("span",null,"\u7F51\u7EDC\u8BC4\u5206")),_react2.default.createElement(_table2.default,{columns:columns,dataSource:(0,_mobx.toJS)(score),size:"middle",className:"content",bordered:true,pagination:false,rowKey:function rowKey(record,index){return index;}})));}}]);return rooms;}(_react.Component))||_class)||_class);exports.default=rooms;

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _Pdf=__webpack_require__(2087);var _Pdf2=_interopRequireDefault(_Pdf);var _Rank=__webpack_require__(2088);var _Rank2=_interopRequireDefault(_Rank);var _Proportion=__webpack_require__(2089);var _Proportion2=_interopRequireDefault(_Proportion);var _RoomsRank=__webpack_require__(2091);var _RoomsRank2=_interopRequireDefault(_RoomsRank);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(2092);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;this.props.store.allHotel.getData();window.addEventListener('resize',function(){if(window.location.hash==='#/table/bi_headquarters'){_this2.props.store.allHotel.onResize();}});}},{key:"render",value:function render(){var _props$store$allHotel=this.props.store.allHotel.loading,loading=_props$store$allHotel===undefined?false:_props$store$allHotel;return _react2.default.createElement("div",{className:"general"},_react2.default.createElement(_row2.default,{className:"title"},"BI Structure - Corporate Office \u603B\u90E8\u6570\u636E\u5E73\u53F0 ",_react2.default.createElement("span",{className:"bi-date"},(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'))),_react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement(_Rank2.default,null),_react2.default.createElement(_RoomsRank2.default,null),_react2.default.createElement(_Proportion2.default,null),_react2.default.createElement(_Pdf2.default,null)));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _progress=__webpack_require__(602);var _progress2=_interopRequireDefault(_progress);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(4);__webpack_require__(60);__webpack_require__(8);__webpack_require__(605);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoomsRank=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(RoomsRank,_Component);function RoomsRank(){_classCallCheck(this,RoomsRank);return _possibleConstructorReturn(this,(RoomsRank.__proto__||Object.getPrototypeOf(RoomsRank)).apply(this,arguments));}_createClass(RoomsRank,[{key:"render",value:function render(){var data=this.props.store.allHotel.data;var pdf=data.map(function(x){return _extends({},x,{pdf:x.pdf/89*100>100?100:(x.pdf/89*100).toFixed(2)});}).sort(function(a,b){return b.pdf-a.pdf;}).map(function(x,i){return _extends({},x,{index:i+1});});var columns=[{title:'排名',key:'排名',dataIndex:'index',width:100,render:function render(text,record,i){return _react2.default.createElement("div",{className:"rank rank"+text},text);}},{title:'酒店名称',dataIndex:'name',key:'name'},{title:'报表保存进度',dataIndex:'pdf',key:'pdf',width:600,sorter:function sorter(a,b){return a.pdf-b.pdf;},render:function render(text,record,i){return _react2.default.createElement("div",null,_react2.default.createElement(_progress2.default,{percent:Number(text),className:"schedule",strokeWidth:15,showInfo:false,strokeLinecap:"square",strokeColor:"#13C2C2"}),_react2.default.createElement("span",null,text,"%"));}}];var pagination={total:data.length,pageSize:5};return _react2.default.createElement("div",{className:"rooms head-pdf"},_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:24},_react2.default.createElement("div",{className:"total_style"},"\u62A5\u8868\u4FDD\u5B58\u8FDB\u5EA6 Report Save Progress"),_react2.default.createElement(_table2.default,{className:"rank-table ",columns:columns,dataSource:(0,_mobx.toJS)(pdf),rowKey:function rowKey(record,index){return record.id;},pagination:pagination}))));}}]);return RoomsRank;}(_react.Component))||_class)||_class);exports.default=RoomsRank;

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(4);__webpack_require__(60);__webpack_require__(8);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoomsRank=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(RoomsRank,_Component);function RoomsRank(){_classCallCheck(this,RoomsRank);return _possibleConstructorReturn(this,(RoomsRank.__proto__||Object.getPrototypeOf(RoomsRank)).apply(this,arguments));}_createClass(RoomsRank,[{key:"render",value:function render(){var _props$store$allHotel=this.props.store.allHotel,revenue=_props$store$allHotel.revenue,profit=_props$store$allHotel.profit;var columns=[{title:'排名',key:'排名',dataIndex:'index',width:80,render:function render(text,record,i){return _react2.default.createElement("div",{className:"rank rank"+text},text);}},{title:'酒店名称',dataIndex:'name',key:'name'},{title:'总收入',dataIndex:'revenue',key:'revenue',width:150,sorter:function sorter(a,b){return a.revenue-b.revenue;},render:function render(text,record,i){return _react2.default.createElement("span",null,"\uFFE5",Number(text).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}];var profitColumns=[{title:'排名',key:'排名',dataIndex:'index',width:80,render:function render(text,record,i){return _react2.default.createElement("div",{className:"rank rank"+text},text);}},{title:'酒店名称',dataIndex:'name',key:'name'},{title:'总利润',dataIndex:'profit',key:'profit',width:150,sorter:function sorter(a,b){return a.profit-b.profit;},render:function render(text,record,i){return _react2.default.createElement("span",null,"\uFFE5",Number(text).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}];var pagination={total:revenue.length,pageSize:5};return _react2.default.createElement("div",{className:"rooms"},_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement("div",{className:"total_style"},"\u603B\u6536\u5165\u6392\u540D Total Revenue Ranking "),_react2.default.createElement(_table2.default,{className:"rank-table ",columns:columns,dataSource:(0,_mobx.toJS)(revenue),rowKey:function rowKey(record,index){return record.id;},pagination:pagination})),_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement("div",{className:"total_style"},"\u7ECF\u8425\u5229\u6DA6\u6392\u540D GOP Ranking"),_react2.default.createElement(_table2.default,{className:"rank-table ",columns:profitColumns,dataSource:(0,_mobx.toJS)(profit),rowKey:function rowKey(record,index){return record.id;},pagination:pagination}))));}}]);return RoomsRank;}(_react.Component))||_class)||_class);exports.default=RoomsRank;

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _tooltip=__webpack_require__(87);var _tooltip2=_interopRequireDefault(_tooltip);var _icon=__webpack_require__(38);var _icon2=_interopRequireDefault(_icon);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(100);__webpack_require__(75);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _SelectHotel=__webpack_require__(2090);var _SelectHotel2=_interopRequireDefault(_SelectHotel);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var karte={height:400,width:"100%"};var App=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:"componentWillUnmount",value:function componentWillUnmount(){this.props.store.allHotel.onChangeHotelId(1);}},{key:"render",value:function render(){var _props$store$selectHo=this.props.store.selectHotel,selectedRowKeys=_props$store$selectHo.selectedRowKeys,onShow=_props$store$selectHo.onShow;var _props$store$allHotel=this.props.store.allHotel,data=_props$store$allHotel.data,hotel_id=_props$store$allHotel.hotel_id,onChangeHotelId=_props$store$allHotel.onChangeHotelId;return _react2.default.createElement("div",{className:"rooms"},_react2.default.createElement("div",{className:"hotel_name"},_react2.default.createElement(_tooltip2.default,{title:"\u70B9\u51FB\u5207\u6362\u9152\u5E97",placement:"topLeft"},_react2.default.createElement("span",{onClick:onShow.bind(this,hotel_id)},(data.find(function(x){return x.id==(hotel_id||1);})||{})['name'],_react2.default.createElement(_icon2.default,{type:"swap"})))),_react2.default.createElement("div",{id:"Proportion",style:karte}),_react2.default.createElement(_SelectHotel2.default,Object.assign({},this.props,{promiseFn:onChangeHotelId})));}}]);return App;}(_react.Component))||_class)||_class);exports.default=App;

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(62);__webpack_require__(8);__webpack_require__(4);__webpack_require__(25);__webpack_require__(6);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _mobx=__webpack_require__(30);__webpack_require__(315);__webpack_require__(197);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectHotel=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(SelectHotel,_Component);function SelectHotel(){_classCallCheck(this,SelectHotel);return _possibleConstructorReturn(this,(SelectHotel.__proto__||Object.getPrototypeOf(SelectHotel)).apply(this,arguments));}_createClass(SelectHotel,[{key:"componentDidMount",value:function componentDidMount(){this.props.store.selectHotel.getData();}},{key:"render",value:function render(){var _props$store$selectHo=this.props.store.selectHotel,visible=_props$store$selectHo.visible,onChange=_props$store$selectHo.onChange,onSearch=_props$store$selectHo.onSearch,onOk=_props$store$selectHo.onOk,onCancel=_props$store$selectHo.onCancel,name=_props$store$selectHo.name,hotel=_props$store$selectHo.hotel,selectedRowKeys=_props$store$selectHo.selectedRowKeys,onChangeRowKeys=_props$store$selectHo.onChangeRowKeys;var promiseFn=this.props.promiseFn;// 酒店列表
var columnsHotel=[{title:'key',dataIndex:'id',key:'id'},{title:'酒店名称',dataIndex:'name',key:'name'},{title:'联系人',dataIndex:'contacts',key:'contacts'},{title:'地址',dataIndex:'address',key:'address'},{title:'联系电话',key:'tel',dataIndex:'tel'}];var rowSelection={selectedRowKeys:selectedRowKeys,onChange:onChangeRowKeys,type:'radio'};return _react2.default.createElement(_modal2.default,{title:'酒店选择',visible:visible,onOk:onOk.bind(this,promiseFn),onCancel:onCancel,className:"compared-modal",footer:[_react2.default.createElement(_button2.default,{key:"back",onClick:onCancel},"\u53D6\u6D88"),_react2.default.createElement(_button2.default,{key:"submit",type:"primary",onClick:onOk.bind(this,promiseFn)},"\u786E\u5B9A")]},_react2.default.createElement(_row2.default,null,_react2.default.createElement("span",null,"\u9152\u5E97\u540D\u79F0\uFF1A"),_react2.default.createElement(_input2.default,{style:{width:200,marginRight:10},value:name,onChange:onChange,onPressEnter:onSearch}),_react2.default.createElement(_button2.default,{type:"primary",onClick:onSearch},"\u641C\u7D22")),_react2.default.createElement(_table2.default,{style:{marginTop:10},columns:columnsHotel,dataSource:(0,_mobx.toJS)(hotel),bordered:true,className:"hotelModal",rowSelection:rowSelection,rowKey:function rowKey(item){return item.id;}}));}}]);return SelectHotel;}(_react.Component))||_class)||_class);exports.default=SelectHotel;

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(4);__webpack_require__(60);__webpack_require__(8);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoomsRank=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(RoomsRank,_Component);function RoomsRank(){_classCallCheck(this,RoomsRank);return _possibleConstructorReturn(this,(RoomsRank.__proto__||Object.getPrototypeOf(RoomsRank)).apply(this,arguments));}_createClass(RoomsRank,[{key:"render",value:function render(){var _props$store$allHotel=this.props.store.allHotel,occ=_props$store$allHotel.occ,arr=_props$store$allHotel.arr;var columns=[{title:'排名',key:'排名',dataIndex:'index',width:80,render:function render(text,record,i){return _react2.default.createElement("div",{className:"rank rank"+text},text);}},{title:'酒店名称',dataIndex:'name',key:'name'},{title:'出租率',dataIndex:'occ',key:'occ',width:150,sorter:function sorter(a,b){return a.occ-b.occ;},render:function render(text,record,i){return _react2.default.createElement("span",null,Number(text*100).toFixed(4)+"%");}}];var arrColumns=[{title:'排名',key:'排名',dataIndex:'index',width:80,render:function render(text,record,i){return _react2.default.createElement("div",{className:"rank rank"+text},text);}},{title:'酒店名称',dataIndex:'name',key:'name'},{title:'平均房价',dataIndex:'arr',key:'arr',width:150,sorter:function sorter(a,b){return a.arr-b.arr;},render:function render(text,record,i){return _react2.default.createElement("span",null,"\uFFE5",Number(text).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','));}}];var pagination={total:occ.length,pageSize:5};return _react2.default.createElement("div",{className:"rooms"},_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement("div",{className:"total_style"},"\u51FA\u79DF\u7387\u6392\u540D Occ Ranking"),_react2.default.createElement(_table2.default,{className:"rank-table ",columns:columns,dataSource:(0,_mobx.toJS)(occ),rowKey:function rowKey(record,index){return record.id;},pagination:pagination})),_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement("div",{className:"total_style"},"\u5E73\u5747\u623F\u4EF7\u6392\u540D ADR Ranking"),_react2.default.createElement(_table2.default,{className:"rank-table ",columns:arrColumns,dataSource:(0,_mobx.toJS)(arr),rowKey:function rowKey(record,index){return record.id;},pagination:pagination}))));}}]);return RoomsRank;}(_react.Component))||_class)||_class);exports.default=RoomsRank;

/***/ }),
/* 2092 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(35);__webpack_require__(4);__webpack_require__(10);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(2094);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getData=function(date){fetch('/extrapProfitInfo?year='+date,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){_this.setState({data:_extends({money:0},x.data)});}).catch(function(err){_this.setState({loading:false});console.error(err);});_this.setState({loading:false});};_this.onSave=function(){var data=_this.state.data;var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var dataFrom=new FormData();data=_extends({},data,{year:year});dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/extrapProfitAdd',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败！');console.error(err);});};_this.state={dateData:[],date:(0,_moment2.default)().add(1,'y').format('YYYY'),loading:true,data:{money:0},loadingSave:false};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){var date=Number(this.state.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});this.getData(this.state.date);}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;return _react2.default.createElement('div',{className:'profit'},_react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement(_row2.default,{className:'title'},'\u60C5\u51B5\u5206\u6790\u5229\u6DA6\u8C03\u6574'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(_select2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u4EFD',style:{width:120},value:this.state.date,onChange:function onChange(str){console.log(str);_this2.setState({date:str,loading:true});_this2.getData(str);}},this.state.dateData.map(function(x,i){return _react2.default.createElement(Option,{value:x,key:x},x,'\u5E74');}))),_react2.default.createElement(_row2.default,null,_react2.default.createElement(_inputNumber2.default,{className:'input',value:data.money||0,formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},onChange:function onChange(e){var newData=data;newData.money=e;_this2.setState({data:newData});}})),_react2.default.createElement(_row2.default,null,_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58'))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2094 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(6);__webpack_require__(8);__webpack_require__(35);__webpack_require__(4);__webpack_require__(10);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(2096);var _saveImg=__webpack_require__(214);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(2097);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(139);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};// 计算year的行总和
var totalIndex=[0,1,2,7,8,9,12,13,16,17,18,21,22,23,26,27,28,38,39,40,41,44,45,46,47,48,52,53,54,57,58,59];var totalName=['Jan_actual','Feb_actual','Mar_actual','Jan_budget','Feb_budget','Mar_budget','Jan_forecast','Feb_forecast','Mar_forecast'];for(var i=0;i<totalName.length;i++){data[1][totalName[i]]=(numConvert(data[0][totalName[i]])*numConvert(data[0].cover)).toFixed(2);}var _loop=function _loop(_i){data[totalIndex[_i]].total=totalName.reduce(function(a,b){a+=numConvert(data[totalIndex[_i]][b]);return a;},0).toFixed(2);};for(var _i=0;_i<totalIndex.length;_i++){_loop(_i);}var uniteIndex=[3,4,5,10,14,19,24,29,30,32,33,34,35,42,48,49,50,51,55,60,61,63,64,65,66,67,68,69,70,71,72,73,74];var uniteName=['Jan_actual','Jan_forecast','Jan_budget','Feb_actual','Feb_forecast','Feb_budget','Mar_actual','Mar_forecast','Mar_budget','total'];// 每行计算方式不同，无法统一循环
for(var _i2=0;_i2<uniteName.length;_i2++){data[3][uniteName[_i2]]=(numConvert(data[1][uniteName[_i2]])==0?0:numConvert(data[2][uniteName[_i2]])/numConvert(data[1][uniteName[_i2]])).toFixed(3);data[4][uniteName[_i2]]=(numConvert(data[2][uniteName[_i2]])==0?0:numConvert(data[7][uniteName[_i2]])/numConvert(data[2][uniteName[_i2]])).toFixed(2);data[5][uniteName[_i2]]=(numConvert(data[4][uniteName[_i2]])*numConvert(data[3][uniteName[_i2]])).toFixed(2);data[10][uniteName[_i2]]=(numConvert(data[9][uniteName[_i2]])+numConvert(data[8][uniteName[_i2]])+numConvert(data[7][uniteName[_i2]])).toFixed(2);data[14][uniteName[_i2]]=(numConvert(data[12][uniteName[_i2]])+numConvert(data[13][uniteName[_i2]])).toFixed(2);data[19][uniteName[_i2]]=(numConvert(data[18][uniteName[_i2]])+numConvert(data[17][uniteName[_i2]])+numConvert(data[16][uniteName[_i2]])).toFixed(2);data[24][uniteName[_i2]]=(numConvert(data[23][uniteName[_i2]])+numConvert(data[22][uniteName[_i2]])+numConvert(data[21][uniteName[_i2]])).toFixed(2);data[29][uniteName[_i2]]=(numConvert(data[28][uniteName[_i2]])+numConvert(data[27][uniteName[_i2]])+numConvert(data[26][uniteName[_i2]])).toFixed(2);data[30][uniteName[_i2]]=(numConvert(data[29][uniteName[_i2]])+numConvert(data[24][uniteName[_i2]])+numConvert(data[19][uniteName[_i2]])+numConvert(data[14][uniteName[_i2]])).toFixed(2);data[32][uniteName[_i2]]=(numConvert(data[7][uniteName[_i2]])-numConvert(data[16][uniteName[_i2]])-numConvert(data[21][uniteName[_i2]])-numConvert(data[26][uniteName[_i2]])).toFixed(2);data[33][uniteName[_i2]]=(numConvert(data[8][uniteName[_i2]])-numConvert(data[12][uniteName[_i2]])-numConvert(data[17][uniteName[_i2]])-numConvert(data[22][uniteName[_i2]])-numConvert(data[27][uniteName[_i2]])).toFixed(2);data[34][uniteName[_i2]]=(numConvert(data[9][uniteName[_i2]])-numConvert(data[13][uniteName[_i2]])-numConvert(data[18][uniteName[_i2]])-numConvert(data[23][uniteName[_i2]])-numConvert(data[28][uniteName[_i2]])).toFixed(2);data[35][uniteName[_i2]]=(numConvert(data[34][uniteName[_i2]])+numConvert(data[33][uniteName[_i2]])+numConvert(data[32][uniteName[_i2]])).toFixed(2);data[42][uniteName[_i2]]=(numConvert(data[41][uniteName[_i2]])+numConvert(data[40][uniteName[_i2]])+numConvert(data[39][uniteName[_i2]])+numConvert(data[38][uniteName[_i2]])).toFixed(2);data[49][uniteName[_i2]]=(numConvert(data[48][uniteName[_i2]])+numConvert(data[47][uniteName[_i2]])+numConvert(data[46][uniteName[_i2]])+numConvert(data[45][uniteName[_i2]])+numConvert(data[44][uniteName[_i2]])).toFixed(2);data[50][uniteName[_i2]]=(numConvert(data[42][uniteName[_i2]])+numConvert(data[49][uniteName[_i2]])).toFixed(2);data[51][uniteName[_i2]]=(numConvert(data[35][uniteName[_i2]])-numConvert(data[50][uniteName[_i2]])).toFixed(2);data[55][uniteName[_i2]]=(numConvert(data[51][uniteName[_i2]])-numConvert(data[52][uniteName[_i2]])-numConvert(data[53][uniteName[_i2]])-numConvert(data[54][uniteName[_i2]])).toFixed(2);data[60][uniteName[_i2]]=(numConvert(data[59][uniteName[_i2]])+numConvert(data[58][uniteName[_i2]])+numConvert(data[57][uniteName[_i2]])).toFixed(2);data[61][uniteName[_i2]]=(numConvert(data[55][uniteName[_i2]])-numConvert(data[60][uniteName[_i2]])).toFixed(2);data[63][uniteName[_i2]]=(numConvert(data[7][uniteName[_i2]])==0?0:numConvert(data[32][uniteName[_i2]])/numConvert(data[7][uniteName[_i2]])).toFixed(3);data[64][uniteName[_i2]]=(numConvert(data[8][uniteName[_i2]])==0?0:numConvert(data[33][uniteName[_i2]])/numConvert(data[8][uniteName[_i2]])).toFixed(3);data[65][uniteName[_i2]]=(numConvert(data[10][uniteName[_i2]])==0?0:numConvert(data[19][uniteName[_i2]])/numConvert(data[10][uniteName[_i2]])).toFixed(3);data[66][uniteName[_i2]]=(numConvert(data[10][uniteName[_i2]])==0?0:numConvert(data[42][uniteName[_i2]])/numConvert(data[10][uniteName[_i2]])).toFixed(3);data[67][uniteName[_i2]]=(numConvert(data[65][uniteName[_i2]])+numConvert(data[66][uniteName[_i2]])).toFixed(3);data[68][uniteName[_i2]]=(numConvert(data[8][uniteName[_i2]])==0?0:numConvert(data[12][uniteName[_i2]])/numConvert(data[8][uniteName[_i2]])).toFixed(3);data[69][uniteName[_i2]]=(numConvert(data[10][uniteName[_i2]])==0?0:numConvert(data[48][uniteName[_i2]])/numConvert(data[10][uniteName[_i2]])).toFixed(3);data[70][uniteName[_i2]]=(numConvert(data[10][uniteName[_i2]])==0?0:(numConvert(data[12][uniteName[_i2]])+numConvert(data[19][uniteName[_i2]])+numConvert(data[42][uniteName[_i2]])+numConvert(data[48][uniteName[_i2]]))/numConvert(data[10][uniteName[_i2]])).toFixed(3);data[71][uniteName[_i2]]=(numConvert(data[7][uniteName[_i2]])-numConvert(data[32][uniteName[_i2]])).toFixed(2);data[72][uniteName[_i2]]=(numConvert(data[8][uniteName[_i2]])-numConvert(data[33][uniteName[_i2]])).toFixed(2);if(uniteName[_i2]=='total'){data[73][uniteName[_i2]]=((numConvert(data[10][uniteName[_i2]])-numConvert(data[55][uniteName[_i2]]))/12).toFixed(2);}else{data[73][uniteName[_i2]]=(numConvert(data[10][uniteName[_i2]])-numConvert(data[55][uniteName[_i2]])).toFixed(2);}data[74][uniteName[_i2]]=(numConvert(data[19][uniteName[_i2]])+numConvert(data[42][uniteName[_i2]])).toFixed(2);}// 计算三
_this.setState({data:data,loading:false});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var dataBegin,data,bp,data1_1;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dataBegin=JSON.stringify(_data.data2_1);data=JSON.parse(dataBegin);_context.prev=2;_context.next=5;return fetch('/chart_first_lst?year='+(0,_moment2.default)(date).format('YYYY'),{credentials:'include'});case 5:bp=_context.sent;_context.next=8;return bp.json();case 8:data1_1=_context.sent;if(data1_1.data&&data1_1.data.length>0){data=data1_1.data;}_this.computeNum(data);_context.next=17;break;case 13:_context.prev=13;_context.t0=_context['catch'](2);_this.setState({loading:false});console.error(_context.t0);case 17:case'end':return _context.stop();}}},_callee,_this2,[[2,13]]);}));return function(_x2){return _ref.apply(this,arguments);};}();_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var data=[].concat(_toConsumableArray(_this.state.data.map(function(x){return _extends({},x,{year:year});})));var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/chart_first_add',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败！');console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table2_1',1.5,'0.10',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};var month=(0,_moment2.default)().format('M');_this.state={date:month<3?(0,_moment2.default)().format('YYYY'):(0,_moment2.default)().add(1,'y').format('YYYY'),data:[],loading:true,loadingSave:false,print:false,dateData:[],cover:0};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){var date=Number(this.state.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this3=this,_ref2;var data=this.state.data;var width=document.body.offsetWidth>1925?document.body.offsetWidth-1500:425;var inputIndex=[0,2,7,8,9,12,13,16,17,18,21,22,23,26,27,28,38,39,40,41,44,45,46,47,48,52,53,54,57,58,59];var percentData=[3,63,64,65,66,67,68,69,70];var totalData=[10,35,55];var blankData=[6,11,15,20,25,31,36,37,43,56,62];var columns=[(_ref2={align:"center",title:'',width:width,fixed:"left",dataIndex:'name',key:'name'},_defineProperty(_ref2,'width',width),_defineProperty(_ref2,'render',function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:16},children:_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"left"}},text)};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}),_ref2),{title:this.state.date-1,align:"center",children:[{title:"Jan",align:"center",children:[{title:'Actual',align:"center",dataIndex:'Jan_actual',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Jan_actual",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Budget',align:"center",dataIndex:'Jan_budget',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Jan_budget",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Forecast',align:"center",dataIndex:'Jan_forecast',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Jan_forecast",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]},{title:this.state.date-1,align:"center",children:[{title:"Feb",align:"center",children:[{title:'Actual',align:"center",dataIndex:'Feb_actual',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Feb_actual",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Budget',align:"center",dataIndex:'Feb_budget',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Feb_budget",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Forecast',align:"center",dataIndex:'Feb_forecast',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Feb_forecast",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]},{title:this.state.date-1,align:"center",children:[{title:"Mar",align:"center",children:[{title:'Actual',align:"center",dataIndex:'Mar_actual',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Mar_actual",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Budget',align:"center",dataIndex:'Mar_budget',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Mar_budget",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Forecast',align:"center",dataIndex:'Mar_forecast',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Mar_forecast",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]},{title:this.state.date-1,align:"center",children:[{title:'Year',align:"center",children:[{title:"Total",align:"center",width:150,dataIndex:'total',key:'total',render:function render(text,record,index){var props={text:text,index:index,type:percentData.includes(index)?'percent':"number",name:"Mar_forecast",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]}];return _react2.default.createElement('div',{className:'table table2_1'},_react2.default.createElement(_row2.default,{className:'title',style:{width:this.state.print?1975:'auto'},id:'table2_1'},_react2.default.createElement(_row2.default,null,'\u7B2C\u4E00\u5B63\u5EA6 DATA INPUT ',this.state.date-2,' and ',this.state.date-1,' \u6570\u636E\u8F93\u5165 ',this.state.date-2,' and ',this.state.date-1),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(_select2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u4EFD',style:{width:120},value:this.state.date,onChange:function onChange(str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}},this.state.dateData.map(function(x,i){return _react2.default.createElement(Option,{value:x,key:x},x,'\u5E74');})),_react2.default.createElement('div',{className:'chart_cover'},_react2.default.createElement('span',null,'\u5BA2\u623F\u6570\u91CF : '),!this.state.loading?_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:data[0]?Number(data[0].cover)||"":"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('cover',value,0);}}):null)),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',className:'content',bordered:true,loading:this.state.loading,pagination:false,style:{width:this.state.print?1925:'auto'},scroll:this.state.print?{}:{x:1925,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_one'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58'))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2096 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data2_1=exports.data2_1=[{name:'Days 日数',name_code:"Days",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Available Rooms 总房间数量',name_code:"Total_Available_Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Rooms Occupied 总出租房',name_code:"Total_Rooms_Occupied",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Occupancy % 出租率%',name_code:"Occupancy",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Average Room Rate 平均每天房价',name_code:"Average_Room_Rate",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'RevPAR 单房产值',name_code:"RevPAR",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Revenue 收入',name_code:"Revenue",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Rooms 客房收入',name_code:"Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮收入',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门收入',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Revenues 总收入',name_code:"Total_Revenues",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Cost of Sales 销售成本',name_code:"Cost_of_Sales",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮成本',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门成本',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Cost of Sales 总成本',name_code:"Total_Cost_of_Sales",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Payroll Expenses 工资福利',name_code:"Payroll_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Rooms 客房',name_code:"Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Payroll Expenses 总工资福利',name_code:"Total_Payroll_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Provision for O.E. 营运工具預提',name_code:"Provision_for_O.E.",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Rooms 客房',name_code:"Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Provision for O.E. 总营运工具預提',name_code:"Total_Provision_for_O.E.",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Expenses 其它费用',name_code:"Other_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Rooms 客房',name_code:"Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Other Expenses 总其它费用',name_code:"Total_Other_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Department Cost/Expenses 部门总成本和费用',name_code:"Total_Department_Cost/Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Departmental Profit 部门利润',name_code:"Departmental_Profit",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Rooms 客房',name_code:"Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Departmental profit 总部门利润',name_code:"Total_Departmental_profit",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Undistributed Operating Expenses 未分配部门费用',name_code:"Undistributed_Operating_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Payroll Expenses 工资福利',name_code:"Payroll_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Administration & General 行政办',name_code:"Administration_General",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Human Resources 人力资源部',name_code:"Human_Resources",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Sales & Marketing 市场销售部',name_code:"Sales_Marketing",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Property Operation & Maintenance 工程部',name_code:"Property_Operation_Maintenance",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Payroll Expenses 总工资福利',name_code:"Total_Payroll_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Expenses 其它费用',name_code:"Other_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Administration & General 行政办',name_code:"Administration_General",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Human Resources 人力资源部',name_code:"Human_Resources",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Sales & Marketing 市场销售部',name_code:"Sales_Marketing",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Property Operation & Maintenance 工程部',name_code:"Property_Operation_Maintenance",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Energy Costs 能源费用',name_code:"Energy_Costs",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Other Expenses 总其它费用',name_code:"Total_Other_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Undistributed Operating Expenses 未分配部门费用总计',name_code:"Total_Undistributed_Operating_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Income After Undistributed Operating Expenses',name_code:"Income_After_Undistributed_Operating_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Insurance 保险',name_code:"Insurance",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Base Fee 基本管理费',name_code:"Base_Fee",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Brand Service Fee 品牌维护费',name_code:"Brand_Service_Fee",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Gross Operating Profit/(Loss) 总毛利润/(亏损)',name_code:"Gross_Operating_Profit/(Loss)",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Deductions 其它扣除',name_code:"Other_Deductions",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Incentive Fees 奖励性管理费',name_code:"Incentive_Fees",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Reserve for Capital Expenditure 固定资产备用',name_code:"Reserve_for_Capital_Expenditure",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Others 其它',name_code:"Others",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Other Deductions 其它扣除总计',name_code:"Total_Other_Deductions",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:"Owner's Profit/(Loss) 业主利润/(亏损)",name_code:"Owner's Profit/(Loss) 业主利润/(亏损)",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Index',name_code:"Index",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Departmental Income - Rooms',name_code:"Departmental_Income_Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Departmental Income - F&B',name_code:"Departmental_Income_F&B",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Payroll Percentage for Operating Departments',name_code:"Payroll_Percentage_for_Operating_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Payroll Percentage for Undistributed Departments',name_code:"Payroll_Percentage_for_Undistributed_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Labor Cost Percentage',name_code:"Total_Labor_Cost_Percentage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Tota F&B Cost Percentage',name_code:"Tota_F&B_Cost_Percentage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Energy Cost Percentage',name_code:"Total_Energy_Cost_Percentage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Three Main Costs Percentage',name_code:"Three_Main_Costs_Percentage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Monthly Cost and Expenses - Rooms',name_code:"Monthly_Cost_and_Expenses_Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Monthly Cost and Expenses - F&B',name_code:"Monthly_Cost_and_Expenses_F&B",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Breakeven Point',name_code:"Breakeven_Point",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Labor Cost',name_code:"Labor_Cost",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0}];

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(6);__webpack_require__(8);__webpack_require__(35);__webpack_require__(4);__webpack_require__(10);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(2099);var _saveImg=__webpack_require__(214);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(2100);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(139);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};// 计算year的行总和
var totalIndex=[0,1,2,7,8,9,12,13,16,17,18,21,22,23,26,27,28,38,39,40,41,44,45,46,47,48,52,53,54,57,58,59];var totalName=['Jan_actual','Feb_actual','Mar_actual','Jan_budget','Feb_budget','Mar_budget','Jan_forecast','Feb_forecast','Mar_forecast'];for(var i=0;i<totalName.length;i++){data[1][totalName[i]]=(numConvert(data[0][totalName[i]])*numConvert(data[0].cover)).toFixed(2);}var _loop=function _loop(_i){data[totalIndex[_i]].total=totalName.reduce(function(a,b){a+=numConvert(data[totalIndex[_i]][b]);return a;},0).toFixed(2);};for(var _i=0;_i<totalIndex.length;_i++){_loop(_i);}var uniteIndex=[3,4,5,10,14,19,24,29,30,32,33,34,35,42,48,49,50,51,55,60,61,63,64,65,66,67,68,69,70,71,72,73,74];var uniteName=['Jan_actual','Jan_forecast','Jan_budget','Feb_actual','Feb_forecast','Feb_budget','Mar_actual','Mar_forecast','Mar_budget','total'];// 每行计算方式不同，无法统一循环
for(var _i2=0;_i2<uniteName.length;_i2++){data[3][uniteName[_i2]]=(numConvert(data[1][uniteName[_i2]])==0?0:numConvert(data[2][uniteName[_i2]])/numConvert(data[1][uniteName[_i2]])).toFixed(3);data[4][uniteName[_i2]]=(numConvert(data[2][uniteName[_i2]])==0?0:numConvert(data[7][uniteName[_i2]])/numConvert(data[2][uniteName[_i2]])).toFixed(2);data[5][uniteName[_i2]]=(numConvert(data[4][uniteName[_i2]])*numConvert(data[3][uniteName[_i2]])).toFixed(2);data[10][uniteName[_i2]]=(numConvert(data[9][uniteName[_i2]])+numConvert(data[8][uniteName[_i2]])+numConvert(data[7][uniteName[_i2]])).toFixed(2);data[14][uniteName[_i2]]=(numConvert(data[12][uniteName[_i2]])+numConvert(data[13][uniteName[_i2]])).toFixed(2);data[19][uniteName[_i2]]=(numConvert(data[18][uniteName[_i2]])+numConvert(data[17][uniteName[_i2]])+numConvert(data[16][uniteName[_i2]])).toFixed(2);data[24][uniteName[_i2]]=(numConvert(data[23][uniteName[_i2]])+numConvert(data[22][uniteName[_i2]])+numConvert(data[21][uniteName[_i2]])).toFixed(2);data[29][uniteName[_i2]]=(numConvert(data[28][uniteName[_i2]])+numConvert(data[27][uniteName[_i2]])+numConvert(data[26][uniteName[_i2]])).toFixed(2);data[30][uniteName[_i2]]=(numConvert(data[29][uniteName[_i2]])+numConvert(data[24][uniteName[_i2]])+numConvert(data[19][uniteName[_i2]])+numConvert(data[14][uniteName[_i2]])).toFixed(2);data[32][uniteName[_i2]]=(numConvert(data[7][uniteName[_i2]])-numConvert(data[16][uniteName[_i2]])-numConvert(data[21][uniteName[_i2]])-numConvert(data[26][uniteName[_i2]])).toFixed(2);data[33][uniteName[_i2]]=(numConvert(data[8][uniteName[_i2]])-numConvert(data[12][uniteName[_i2]])-numConvert(data[17][uniteName[_i2]])-numConvert(data[22][uniteName[_i2]])-numConvert(data[27][uniteName[_i2]])).toFixed(2);data[34][uniteName[_i2]]=(numConvert(data[9][uniteName[_i2]])-numConvert(data[13][uniteName[_i2]])-numConvert(data[18][uniteName[_i2]])-numConvert(data[23][uniteName[_i2]])-numConvert(data[28][uniteName[_i2]])).toFixed(2);data[35][uniteName[_i2]]=(numConvert(data[34][uniteName[_i2]])+numConvert(data[33][uniteName[_i2]])+numConvert(data[32][uniteName[_i2]])).toFixed(2);data[42][uniteName[_i2]]=(numConvert(data[41][uniteName[_i2]])+numConvert(data[40][uniteName[_i2]])+numConvert(data[39][uniteName[_i2]])+numConvert(data[38][uniteName[_i2]])).toFixed(2);data[49][uniteName[_i2]]=(numConvert(data[48][uniteName[_i2]])+numConvert(data[47][uniteName[_i2]])+numConvert(data[46][uniteName[_i2]])+numConvert(data[45][uniteName[_i2]])+numConvert(data[44][uniteName[_i2]])).toFixed(2);data[50][uniteName[_i2]]=(numConvert(data[42][uniteName[_i2]])+numConvert(data[49][uniteName[_i2]])).toFixed(2);data[51][uniteName[_i2]]=(numConvert(data[35][uniteName[_i2]])-numConvert(data[50][uniteName[_i2]])).toFixed(2);data[55][uniteName[_i2]]=(numConvert(data[51][uniteName[_i2]])-numConvert(data[52][uniteName[_i2]])-numConvert(data[53][uniteName[_i2]])-numConvert(data[54][uniteName[_i2]])).toFixed(2);data[60][uniteName[_i2]]=(numConvert(data[59][uniteName[_i2]])+numConvert(data[58][uniteName[_i2]])+numConvert(data[57][uniteName[_i2]])).toFixed(2);data[61][uniteName[_i2]]=(numConvert(data[55][uniteName[_i2]])-numConvert(data[60][uniteName[_i2]])).toFixed(2);data[63][uniteName[_i2]]=(numConvert(data[7][uniteName[_i2]])==0?0:numConvert(data[32][uniteName[_i2]])/numConvert(data[7][uniteName[_i2]])).toFixed(3);data[64][uniteName[_i2]]=(numConvert(data[8][uniteName[_i2]])==0?0:numConvert(data[33][uniteName[_i2]])/numConvert(data[8][uniteName[_i2]])).toFixed(3);data[65][uniteName[_i2]]=(numConvert(data[10][uniteName[_i2]])==0?0:numConvert(data[19][uniteName[_i2]])/numConvert(data[10][uniteName[_i2]])).toFixed(3);data[66][uniteName[_i2]]=(numConvert(data[10][uniteName[_i2]])==0?0:numConvert(data[42][uniteName[_i2]])/numConvert(data[10][uniteName[_i2]])).toFixed(3);data[67][uniteName[_i2]]=(numConvert(data[65][uniteName[_i2]])+numConvert(data[66][uniteName[_i2]])).toFixed(3);data[68][uniteName[_i2]]=(numConvert(data[8][uniteName[_i2]])==0?0:numConvert(data[12][uniteName[_i2]])/numConvert(data[8][uniteName[_i2]])).toFixed(3);data[69][uniteName[_i2]]=(numConvert(data[10][uniteName[_i2]])==0?0:numConvert(data[48][uniteName[_i2]])/numConvert(data[10][uniteName[_i2]])).toFixed(3);data[70][uniteName[_i2]]=(numConvert(data[10][uniteName[_i2]])==0?0:(numConvert(data[12][uniteName[_i2]])+numConvert(data[19][uniteName[_i2]])+numConvert(data[42][uniteName[_i2]])+numConvert(data[48][uniteName[_i2]]))/numConvert(data[10][uniteName[_i2]])).toFixed(3);data[71][uniteName[_i2]]=(numConvert(data[7][uniteName[_i2]])-numConvert(data[32][uniteName[_i2]])).toFixed(2);data[72][uniteName[_i2]]=(numConvert(data[8][uniteName[_i2]])-numConvert(data[33][uniteName[_i2]])).toFixed(2);if(uniteName[_i2]=='total'){data[73][uniteName[_i2]]=((numConvert(data[10][uniteName[_i2]])-numConvert(data[55][uniteName[_i2]]))/12).toFixed(2);}else{data[73][uniteName[_i2]]=(numConvert(data[10][uniteName[_i2]])-numConvert(data[55][uniteName[_i2]])).toFixed(2);}data[74][uniteName[_i2]]=(numConvert(data[19][uniteName[_i2]])+numConvert(data[42][uniteName[_i2]])).toFixed(2);}// 计算三
_this.setState({data:data,loading:false});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var dataBegin,data,bp,data1_1;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dataBegin=JSON.stringify(_data.data2_1);data=JSON.parse(dataBegin);_context.prev=2;_context.next=5;return fetch('/chart_second_lst?year='+(0,_moment2.default)(date).format('YYYY'),{credentials:'include'});case 5:bp=_context.sent;_context.next=8;return bp.json();case 8:data1_1=_context.sent;if(data1_1.data&&data1_1.data.length>0){data=data1_1.data;}_this.computeNum(data);_context.next=17;break;case 13:_context.prev=13;_context.t0=_context['catch'](2);_this.setState({loading:false});console.error(_context.t0);case 17:case'end':return _context.stop();}}},_callee,_this2,[[2,13]]);}));return function(_x2){return _ref.apply(this,arguments);};}();_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var data=[].concat(_toConsumableArray(_this.state.data.map(function(x){return _extends({},x,{year:year});})));var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/chart_second_add',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败！');console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table2_1',1.5,'0.20',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};var month=(0,_moment2.default)().format('M');_this.state={date:month<3?(0,_moment2.default)().format('YYYY'):(0,_moment2.default)().add(1,'y').format('YYYY'),data:[],loading:true,loadingSave:false,print:false,dateData:[],cover:0};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){var date=Number(this.state.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this3=this,_ref2;var data=this.state.data;var width=document.body.offsetWidth>1925?document.body.offsetWidth-1500:425;var inputIndex=[0,2,7,8,9,12,13,16,17,18,21,22,23,26,27,28,38,39,40,41,44,45,46,47,48,52,53,54,57,58,59];var percentData=[3,63,64,65,66,67,68,69,70];var totalData=[10,35,55];var blankData=[6,11,15,20,25,31,36,37,43,56,62];var columns=[(_ref2={align:"center",title:'',width:width,fixed:"left",dataIndex:'name',key:'name'},_defineProperty(_ref2,'width',width),_defineProperty(_ref2,'render',function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:16},children:_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"left"}},text)};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}),_ref2),{title:this.state.date-1,align:"center",children:[{title:"Apr",align:"center",children:[{title:'Actual',align:"center",dataIndex:'Jan_actual',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Jan_actual",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Budget',align:"center",dataIndex:'Jan_budget',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Jan_budget",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Forecast',align:"center",dataIndex:'Jan_forecast',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Jan_forecast",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]},{title:this.state.date-1,align:"center",children:[{title:"May",align:"center",children:[{title:'Actual',align:"center",dataIndex:'Feb_actual',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Feb_actual",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Budget',align:"center",dataIndex:'Feb_budget',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Feb_budget",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Forecast',align:"center",dataIndex:'Feb_forecast',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Feb_forecast",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]},{title:this.state.date-1,align:"center",children:[{title:"Jun",align:"center",children:[{title:'Actual',align:"center",dataIndex:'Mar_actual',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Mar_actual",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Budget',align:"center",dataIndex:'Mar_budget',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Mar_budget",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Forecast',align:"center",dataIndex:'Mar_forecast',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Mar_forecast",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]},{title:this.state.date-1,align:"center",children:[{title:'Year',align:"center",children:[{title:"Total",align:"center",width:150,dataIndex:'total',key:'total',render:function render(text,record,index){var props={text:text,index:index,type:percentData.includes(index)?'percent':"number",name:"Mar_forecast",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]}];return _react2.default.createElement('div',{className:'table table2_1'},_react2.default.createElement(_row2.default,{className:'title',style:{width:this.state.print?1975:'auto'},id:'table2_1'},_react2.default.createElement(_row2.default,null,'\u7B2C\u4E8C\u5B63\u5EA6 DATA INPUT ',this.state.date-2,' and ',this.state.date-1,' \u6570\u636E\u8F93\u5165 ',this.state.date-2,' and ',this.state.date-1),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(_select2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u4EFD',style:{width:120},value:this.state.date,onChange:function onChange(str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}},this.state.dateData.map(function(x,i){return _react2.default.createElement(Option,{value:x,key:x},x,'\u5E74');})),_react2.default.createElement('div',{className:'chart_cover'},_react2.default.createElement('span',null,'\u5BA2\u623F\u6570\u91CF : '),!this.state.loading?_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:data[0]?Number(data[0].cover)||"":"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('cover',value,0);}}):null)),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',className:'content',bordered:true,loading:this.state.loading,pagination:false,style:{width:this.state.print?1925:'auto'},scroll:this.state.print?{}:{x:1925,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_two'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58'))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2099 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data2_1=exports.data2_1=[{name:'Days 日数',name_code:"Days",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Available Rooms 总房间数量',name_code:"Total_Available_Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Rooms Occupied 总出租房',name_code:"Total_Rooms_Occupied",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Occupancy % 出租率%',name_code:"Occupancy",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Average Room Rate 平均每天房价',name_code:"Average_Room_Rate",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'RevPAR 单房产值',name_code:"RevPAR",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Revenue 收入',name_code:"Revenue",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Rooms 客房收入',name_code:"Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮收入',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门收入',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Revenues 总收入',name_code:"Total_Revenues",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Cost of Sales 销售成本',name_code:"Cost_of_Sales",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮成本',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门成本',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Cost of Sales 总成本',name_code:"Total_Cost_of_Sales",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Payroll Expenses 工资福利',name_code:"Payroll_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Rooms 客房',name_code:"Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Payroll Expenses 总工资福利',name_code:"Total_Payroll_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Provision for O.E. 营运工具預提',name_code:"Provision_for_O.E.",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Rooms 客房',name_code:"Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Provision for O.E. 总营运工具預提',name_code:"Total_Provision_for_O.E.",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Expenses 其它费用',name_code:"Other_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Rooms 客房',name_code:"Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Other Expenses 总其它费用',name_code:"Total_Other_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Department Cost/Expenses 部门总成本和费用',name_code:"Total_Department_Cost/Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Departmental Profit 部门利润',name_code:"Departmental_Profit",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Rooms 客房',name_code:"Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Departmental profit 总部门利润',name_code:"Total_Departmental_profit",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Undistributed Operating Expenses 未分配部门费用',name_code:"Undistributed_Operating_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Payroll Expenses 工资福利',name_code:"Payroll_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Administration & General 行政办',name_code:"Administration_General",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Human Resources 人力资源部',name_code:"Human_Resources",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Sales & Marketing 市场销售部',name_code:"Sales_Marketing",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Property Operation & Maintenance 工程部',name_code:"Property_Operation_Maintenance",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Payroll Expenses 总工资福利',name_code:"Total_Payroll_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Expenses 其它费用',name_code:"Other_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Administration & General 行政办',name_code:"Administration_General",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Human Resources 人力资源部',name_code:"Human_Resources",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Sales & Marketing 市场销售部',name_code:"Sales_Marketing",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Property Operation & Maintenance 工程部',name_code:"Property_Operation_Maintenance",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Energy Costs 能源费用',name_code:"Energy_Costs",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Other Expenses 总其它费用',name_code:"Total_Other_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Undistributed Operating Expenses 未分配部门费用总计',name_code:"Total_Undistributed_Operating_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Income After Undistributed Operating Expenses',name_code:"Income_After_Undistributed_Operating_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Insurance 保险',name_code:"Insurance",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Base Fee 基本管理费',name_code:"Base_Fee",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Brand Service Fee 品牌维护费',name_code:"Brand_Service_Fee",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Gross Operating Profit/(Loss) 总毛利润/(亏损)',name_code:"Gross_Operating_Profit/(Loss)",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Deductions 其它扣除',name_code:"Other_Deductions",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Incentive Fees 奖励性管理费',name_code:"Incentive_Fees",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Reserve for Capital Expenditure 固定资产备用',name_code:"Reserve_for_Capital_Expenditure",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Others 其它',name_code:"Others",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Other Deductions 其它扣除总计',name_code:"Total_Other_Deductions",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:"Owner's Profit/(Loss) 业主利润/(亏损)",name_code:"Owner's Profit/(Loss) 业主利润/(亏损)",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Index',name_code:"Index",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Departmental Income - Rooms',name_code:"Departmental_Income_Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Departmental Income - F&B',name_code:"Departmental_Income_F&B",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Payroll Percentage for Operating Departments',name_code:"Payroll_Percentage_for_Operating_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Payroll Percentage for Undistributed Departments',name_code:"Payroll_Percentage_for_Undistributed_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Labor Cost Percentage',name_code:"Total_Labor_Cost_Percentage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Tota F&B Cost Percentage',name_code:"Tota_F&B_Cost_Percentage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Energy Cost Percentage',name_code:"Total_Energy_Cost_Percentage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Three Main Costs Percentage',name_code:"Three_Main_Costs_Percentage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Monthly Cost and Expenses - Rooms',name_code:"Monthly_Cost_and_Expenses_Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Monthly Cost and Expenses - F&B',name_code:"Monthly_Cost_and_Expenses_F&B",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Breakeven Point',name_code:"Breakeven_Point",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Labor Cost',name_code:"Labor_Cost",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0}];

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(6);__webpack_require__(8);__webpack_require__(35);__webpack_require__(4);__webpack_require__(10);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(2102);var _saveImg=__webpack_require__(214);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(2103);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(139);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};// 计算year的行总和
var totalIndex=[0,1,2,7,8,9,12,13,16,17,18,21,22,23,26,27,28,38,39,40,41,44,45,46,47,48,52,53,54,57,58,59];var totalName=['Jan_actual','Feb_actual','Mar_actual','Jan_budget','Feb_budget','Mar_budget','Jan_forecast','Feb_forecast','Mar_forecast'];for(var i=0;i<totalName.length;i++){data[1][totalName[i]]=(numConvert(data[0][totalName[i]])*numConvert(data[0].cover)).toFixed(2);}var _loop=function _loop(_i){data[totalIndex[_i]].total=totalName.reduce(function(a,b){a+=numConvert(data[totalIndex[_i]][b]);return a;},0).toFixed(2);};for(var _i=0;_i<totalIndex.length;_i++){_loop(_i);}var uniteIndex=[3,4,5,10,14,19,24,29,30,32,33,34,35,42,48,49,50,51,55,60,61,63,64,65,66,67,68,69,70,71,72,73,74];var uniteName=['Jan_actual','Jan_forecast','Jan_budget','Feb_actual','Feb_forecast','Feb_budget','Mar_actual','Mar_forecast','Mar_budget','total'];// 每行计算方式不同，无法统一循环
for(var _i2=0;_i2<uniteName.length;_i2++){data[3][uniteName[_i2]]=(numConvert(data[1][uniteName[_i2]])==0?0:numConvert(data[2][uniteName[_i2]])/numConvert(data[1][uniteName[_i2]])).toFixed(3);data[4][uniteName[_i2]]=(numConvert(data[2][uniteName[_i2]])==0?0:numConvert(data[7][uniteName[_i2]])/numConvert(data[2][uniteName[_i2]])).toFixed(2);data[5][uniteName[_i2]]=(numConvert(data[4][uniteName[_i2]])*numConvert(data[3][uniteName[_i2]])).toFixed(2);data[10][uniteName[_i2]]=(numConvert(data[9][uniteName[_i2]])+numConvert(data[8][uniteName[_i2]])+numConvert(data[7][uniteName[_i2]])).toFixed(2);data[14][uniteName[_i2]]=(numConvert(data[12][uniteName[_i2]])+numConvert(data[13][uniteName[_i2]])).toFixed(2);data[19][uniteName[_i2]]=(numConvert(data[18][uniteName[_i2]])+numConvert(data[17][uniteName[_i2]])+numConvert(data[16][uniteName[_i2]])).toFixed(2);data[24][uniteName[_i2]]=(numConvert(data[23][uniteName[_i2]])+numConvert(data[22][uniteName[_i2]])+numConvert(data[21][uniteName[_i2]])).toFixed(2);data[29][uniteName[_i2]]=(numConvert(data[28][uniteName[_i2]])+numConvert(data[27][uniteName[_i2]])+numConvert(data[26][uniteName[_i2]])).toFixed(2);data[30][uniteName[_i2]]=(numConvert(data[29][uniteName[_i2]])+numConvert(data[24][uniteName[_i2]])+numConvert(data[19][uniteName[_i2]])+numConvert(data[14][uniteName[_i2]])).toFixed(2);data[32][uniteName[_i2]]=(numConvert(data[7][uniteName[_i2]])-numConvert(data[16][uniteName[_i2]])-numConvert(data[21][uniteName[_i2]])-numConvert(data[26][uniteName[_i2]])).toFixed(2);data[33][uniteName[_i2]]=(numConvert(data[8][uniteName[_i2]])-numConvert(data[12][uniteName[_i2]])-numConvert(data[17][uniteName[_i2]])-numConvert(data[22][uniteName[_i2]])-numConvert(data[27][uniteName[_i2]])).toFixed(2);data[34][uniteName[_i2]]=(numConvert(data[9][uniteName[_i2]])-numConvert(data[13][uniteName[_i2]])-numConvert(data[18][uniteName[_i2]])-numConvert(data[23][uniteName[_i2]])-numConvert(data[28][uniteName[_i2]])).toFixed(2);data[35][uniteName[_i2]]=(numConvert(data[34][uniteName[_i2]])+numConvert(data[33][uniteName[_i2]])+numConvert(data[32][uniteName[_i2]])).toFixed(2);data[42][uniteName[_i2]]=(numConvert(data[41][uniteName[_i2]])+numConvert(data[40][uniteName[_i2]])+numConvert(data[39][uniteName[_i2]])+numConvert(data[38][uniteName[_i2]])).toFixed(2);data[49][uniteName[_i2]]=(numConvert(data[48][uniteName[_i2]])+numConvert(data[47][uniteName[_i2]])+numConvert(data[46][uniteName[_i2]])+numConvert(data[45][uniteName[_i2]])+numConvert(data[44][uniteName[_i2]])).toFixed(2);data[50][uniteName[_i2]]=(numConvert(data[42][uniteName[_i2]])+numConvert(data[49][uniteName[_i2]])).toFixed(2);data[51][uniteName[_i2]]=(numConvert(data[35][uniteName[_i2]])-numConvert(data[50][uniteName[_i2]])).toFixed(2);data[55][uniteName[_i2]]=(numConvert(data[51][uniteName[_i2]])-numConvert(data[52][uniteName[_i2]])-numConvert(data[53][uniteName[_i2]])-numConvert(data[54][uniteName[_i2]])).toFixed(2);data[60][uniteName[_i2]]=(numConvert(data[59][uniteName[_i2]])+numConvert(data[58][uniteName[_i2]])+numConvert(data[57][uniteName[_i2]])).toFixed(2);data[61][uniteName[_i2]]=(numConvert(data[55][uniteName[_i2]])-numConvert(data[60][uniteName[_i2]])).toFixed(2);data[63][uniteName[_i2]]=(numConvert(data[7][uniteName[_i2]])==0?0:numConvert(data[32][uniteName[_i2]])/numConvert(data[7][uniteName[_i2]])).toFixed(3);data[64][uniteName[_i2]]=(numConvert(data[8][uniteName[_i2]])==0?0:numConvert(data[33][uniteName[_i2]])/numConvert(data[8][uniteName[_i2]])).toFixed(3);data[65][uniteName[_i2]]=(numConvert(data[10][uniteName[_i2]])==0?0:numConvert(data[19][uniteName[_i2]])/numConvert(data[10][uniteName[_i2]])).toFixed(3);data[66][uniteName[_i2]]=(numConvert(data[10][uniteName[_i2]])==0?0:numConvert(data[42][uniteName[_i2]])/numConvert(data[10][uniteName[_i2]])).toFixed(3);data[67][uniteName[_i2]]=(numConvert(data[65][uniteName[_i2]])+numConvert(data[66][uniteName[_i2]])).toFixed(3);data[68][uniteName[_i2]]=(numConvert(data[8][uniteName[_i2]])==0?0:numConvert(data[12][uniteName[_i2]])/numConvert(data[8][uniteName[_i2]])).toFixed(3);data[69][uniteName[_i2]]=(numConvert(data[10][uniteName[_i2]])==0?0:numConvert(data[48][uniteName[_i2]])/numConvert(data[10][uniteName[_i2]])).toFixed(3);data[70][uniteName[_i2]]=(numConvert(data[10][uniteName[_i2]])==0?0:(numConvert(data[12][uniteName[_i2]])+numConvert(data[19][uniteName[_i2]])+numConvert(data[42][uniteName[_i2]])+numConvert(data[48][uniteName[_i2]]))/numConvert(data[10][uniteName[_i2]])).toFixed(3);data[71][uniteName[_i2]]=(numConvert(data[7][uniteName[_i2]])-numConvert(data[32][uniteName[_i2]])).toFixed(2);data[72][uniteName[_i2]]=(numConvert(data[8][uniteName[_i2]])-numConvert(data[33][uniteName[_i2]])).toFixed(2);if(uniteName[_i2]=='total'){data[73][uniteName[_i2]]=((numConvert(data[10][uniteName[_i2]])-numConvert(data[55][uniteName[_i2]]))/12).toFixed(2);}else{data[73][uniteName[_i2]]=(numConvert(data[10][uniteName[_i2]])-numConvert(data[55][uniteName[_i2]])).toFixed(2);}data[74][uniteName[_i2]]=(numConvert(data[19][uniteName[_i2]])+numConvert(data[42][uniteName[_i2]])).toFixed(2);}// 计算三
_this.setState({data:data,loading:false});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var dataBegin,data,bp,data1_1;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dataBegin=JSON.stringify(_data.data2_1);data=JSON.parse(dataBegin);_context.prev=2;_context.next=5;return fetch('/chart_third_lst?year='+(0,_moment2.default)(date).format('YYYY'),{credentials:'include'});case 5:bp=_context.sent;_context.next=8;return bp.json();case 8:data1_1=_context.sent;if(data1_1.data&&data1_1.data.length>0){data=data1_1.data;}_this.computeNum(data);_context.next=17;break;case 13:_context.prev=13;_context.t0=_context['catch'](2);_this.setState({loading:false});console.error(_context.t0);case 17:case'end':return _context.stop();}}},_callee,_this2,[[2,13]]);}));return function(_x2){return _ref.apply(this,arguments);};}();_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var data=[].concat(_toConsumableArray(_this.state.data.map(function(x){return _extends({},x,{year:year});})));var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/chart_third_add',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败！');console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table2_1',1.5,'0.30',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};var month=(0,_moment2.default)().format('M');_this.state={date:month<3?(0,_moment2.default)().format('YYYY'):(0,_moment2.default)().add(1,'y').format('YYYY'),data:[],loading:true,loadingSave:false,print:false,dateData:[],cover:0};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){var date=Number(this.state.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this3=this,_ref2;var data=this.state.data;var width=document.body.offsetWidth>1925?document.body.offsetWidth-1500:425;var inputIndex=[0,2,7,8,9,12,13,16,17,18,21,22,23,26,27,28,38,39,40,41,44,45,46,47,48,52,53,54,57,58,59];var percentData=[3,63,64,65,66,67,68,69,70];var totalData=[10,35,55];var blankData=[6,11,15,20,25,31,36,37,43,56,62];var columns=[(_ref2={align:"center",title:'',width:width,fixed:"left",dataIndex:'name',key:'name'},_defineProperty(_ref2,'width',width),_defineProperty(_ref2,'render',function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:16},children:_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"left"}},text)};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}),_ref2),{title:this.state.date-1,align:"center",children:[{title:"Jul",align:"center",children:[{title:'Actual',align:"center",dataIndex:'Jan_actual',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Jan_actual",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Budget',align:"center",dataIndex:'Jan_budget',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Jan_budget",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Forecast',align:"center",dataIndex:'Jan_forecast',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Jan_forecast",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]},{title:this.state.date-1,align:"center",children:[{title:"Aug",align:"center",children:[{title:'Actual',align:"center",dataIndex:'Feb_actual',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Feb_actual",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Budget',align:"center",dataIndex:'Feb_budget',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Feb_budget",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Forecast',align:"center",dataIndex:'Feb_forecast',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Feb_forecast",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]},{title:this.state.date-1,align:"center",children:[{title:"Sep",align:"center",children:[{title:'Actual',align:"center",dataIndex:'Mar_actual',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Mar_actual",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Budget',align:"center",dataIndex:'Mar_budget',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Mar_budget",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Forecast',align:"center",dataIndex:'Mar_forecast',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Mar_forecast",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]},{title:this.state.date-1,align:"center",children:[{title:'Year',align:"center",children:[{title:"Total",align:"center",width:150,dataIndex:'total',key:'total',render:function render(text,record,index){var props={text:text,index:index,type:percentData.includes(index)?'percent':"number",name:"Mar_forecast",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]}];return _react2.default.createElement('div',{className:'table table2_1'},_react2.default.createElement(_row2.default,{className:'title',style:{width:this.state.print?1975:'auto'},id:'table2_1'},_react2.default.createElement(_row2.default,null,'\u7B2C\u4E09\u5B63\u5EA6 DATA INPUT ',this.state.date-2,' and ',this.state.date-1,' \u6570\u636E\u8F93\u5165 ',this.state.date-2,' and ',this.state.date-1),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(_select2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u4EFD',style:{width:120},value:this.state.date,onChange:function onChange(str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}},this.state.dateData.map(function(x,i){return _react2.default.createElement(Option,{value:x,key:x},x,'\u5E74');})),_react2.default.createElement('div',{className:'chart_cover'},_react2.default.createElement('span',null,'\u5BA2\u623F\u6570\u91CF : '),!this.state.loading?_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:data[0]?Number(data[0].cover)||"":"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('cover',value,0);}}):null)),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',className:'content',bordered:true,loading:this.state.loading,pagination:false,style:{width:this.state.print?1925:'auto'},scroll:this.state.print?{}:{x:1925,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_three'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58'))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data2_1=exports.data2_1=[{name:'Days 日数',name_code:"Days",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Available Rooms 总房间数量',name_code:"Total_Available_Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Rooms Occupied 总出租房',name_code:"Total_Rooms_Occupied",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Occupancy % 出租率%',name_code:"Occupancy",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Average Room Rate 平均每天房价',name_code:"Average_Room_Rate",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'RevPAR 单房产值',name_code:"RevPAR",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Revenue 收入',name_code:"Revenue",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Rooms 客房收入',name_code:"Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮收入',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门收入',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Revenues 总收入',name_code:"Total_Revenues",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Cost of Sales 销售成本',name_code:"Cost_of_Sales",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮成本',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门成本',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Cost of Sales 总成本',name_code:"Total_Cost_of_Sales",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Payroll Expenses 工资福利',name_code:"Payroll_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Rooms 客房',name_code:"Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Payroll Expenses 总工资福利',name_code:"Total_Payroll_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Provision for O.E. 营运工具預提',name_code:"Provision_for_O.E.",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Rooms 客房',name_code:"Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Provision for O.E. 总营运工具預提',name_code:"Total_Provision_for_O.E.",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Expenses 其它费用',name_code:"Other_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Rooms 客房',name_code:"Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Other Expenses 总其它费用',name_code:"Total_Other_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Department Cost/Expenses 部门总成本和费用',name_code:"Total_Department_Cost/Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Departmental Profit 部门利润',name_code:"Departmental_Profit",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Rooms 客房',name_code:"Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Departmental profit 总部门利润',name_code:"Total_Departmental_profit",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Undistributed Operating Expenses 未分配部门费用',name_code:"Undistributed_Operating_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Payroll Expenses 工资福利',name_code:"Payroll_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Administration & General 行政办',name_code:"Administration_General",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Human Resources 人力资源部',name_code:"Human_Resources",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Sales & Marketing 市场销售部',name_code:"Sales_Marketing",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Property Operation & Maintenance 工程部',name_code:"Property_Operation_Maintenance",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Payroll Expenses 总工资福利',name_code:"Total_Payroll_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Expenses 其它费用',name_code:"Other_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Administration & General 行政办',name_code:"Administration_General",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Human Resources 人力资源部',name_code:"Human_Resources",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Sales & Marketing 市场销售部',name_code:"Sales_Marketing",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Property Operation & Maintenance 工程部',name_code:"Property_Operation_Maintenance",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Energy Costs 能源费用',name_code:"Energy_Costs",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Other Expenses 总其它费用',name_code:"Total_Other_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Undistributed Operating Expenses 未分配部门费用总计',name_code:"Total_Undistributed_Operating_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Income After Undistributed Operating Expenses',name_code:"Income_After_Undistributed_Operating_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Insurance 保险',name_code:"Insurance",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Base Fee 基本管理费',name_code:"Base_Fee",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Brand Service Fee 品牌维护费',name_code:"Brand_Service_Fee",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Gross Operating Profit/(Loss) 总毛利润/(亏损)',name_code:"Gross_Operating_Profit/(Loss)",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Deductions 其它扣除',name_code:"Other_Deductions",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Incentive Fees 奖励性管理费',name_code:"Incentive_Fees",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Reserve for Capital Expenditure 固定资产备用',name_code:"Reserve_for_Capital_Expenditure",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Others 其它',name_code:"Others",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Other Deductions 其它扣除总计',name_code:"Total_Other_Deductions",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:"Owner's Profit/(Loss) 业主利润/(亏损)",name_code:"Owner's Profit/(Loss) 业主利润/(亏损)",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Index',name_code:"Index",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Departmental Income - Rooms',name_code:"Departmental_Income_Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Departmental Income - F&B',name_code:"Departmental_Income_F&B",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Payroll Percentage for Operating Departments',name_code:"Payroll_Percentage_for_Operating_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Payroll Percentage for Undistributed Departments',name_code:"Payroll_Percentage_for_Undistributed_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Labor Cost Percentage',name_code:"Total_Labor_Cost_Percentage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Tota F&B Cost Percentage',name_code:"Tota_F&B_Cost_Percentage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Energy Cost Percentage',name_code:"Total_Energy_Cost_Percentage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Three Main Costs Percentage',name_code:"Three_Main_Costs_Percentage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Monthly Cost and Expenses - Rooms',name_code:"Monthly_Cost_and_Expenses_Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Monthly Cost and Expenses - F&B',name_code:"Monthly_Cost_and_Expenses_F&B",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Breakeven Point',name_code:"Breakeven_Point",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Labor Cost',name_code:"Labor_Cost",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0}];

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(6);__webpack_require__(8);__webpack_require__(35);__webpack_require__(4);__webpack_require__(10);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(2105);var _saveImg=__webpack_require__(214);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(2106);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(139);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};// 计算year的行总和
var totalIndex=[0,1,2,7,8,9,12,13,16,17,18,21,22,23,26,27,28,38,39,40,41,44,45,46,47,48,52,53,54,57,58,59];var totalName=['Jan_actual','Feb_actual','Mar_actual','Jan_budget','Feb_budget','Mar_budget','Jan_forecast','Feb_forecast','Mar_forecast'];for(var i=0;i<totalName.length;i++){data[1][totalName[i]]=(numConvert(data[0][totalName[i]])*numConvert(data[0].cover)).toFixed(2);}var _loop=function _loop(_i){data[totalIndex[_i]].total=totalName.reduce(function(a,b){a+=numConvert(data[totalIndex[_i]][b]);return a;},0).toFixed(2);};for(var _i=0;_i<totalIndex.length;_i++){_loop(_i);}var uniteIndex=[3,4,5,10,14,19,24,29,30,32,33,34,35,42,48,49,50,51,55,60,61,63,64,65,66,67,68,69,70,71,72,73,74];var uniteName=['Jan_actual','Jan_forecast','Jan_budget','Feb_actual','Feb_forecast','Feb_budget','Mar_actual','Mar_forecast','Mar_budget','total'];// 每行计算方式不同，无法统一循环
for(var _i2=0;_i2<uniteName.length;_i2++){data[3][uniteName[_i2]]=(numConvert(data[1][uniteName[_i2]])==0?0:numConvert(data[2][uniteName[_i2]])/numConvert(data[1][uniteName[_i2]])).toFixed(3);data[4][uniteName[_i2]]=(numConvert(data[2][uniteName[_i2]])==0?0:numConvert(data[7][uniteName[_i2]])/numConvert(data[2][uniteName[_i2]])).toFixed(2);data[5][uniteName[_i2]]=(numConvert(data[4][uniteName[_i2]])*numConvert(data[3][uniteName[_i2]])).toFixed(2);data[10][uniteName[_i2]]=(numConvert(data[9][uniteName[_i2]])+numConvert(data[8][uniteName[_i2]])+numConvert(data[7][uniteName[_i2]])).toFixed(2);data[14][uniteName[_i2]]=(numConvert(data[12][uniteName[_i2]])+numConvert(data[13][uniteName[_i2]])).toFixed(2);data[19][uniteName[_i2]]=(numConvert(data[18][uniteName[_i2]])+numConvert(data[17][uniteName[_i2]])+numConvert(data[16][uniteName[_i2]])).toFixed(2);data[24][uniteName[_i2]]=(numConvert(data[23][uniteName[_i2]])+numConvert(data[22][uniteName[_i2]])+numConvert(data[21][uniteName[_i2]])).toFixed(2);data[29][uniteName[_i2]]=(numConvert(data[28][uniteName[_i2]])+numConvert(data[27][uniteName[_i2]])+numConvert(data[26][uniteName[_i2]])).toFixed(2);data[30][uniteName[_i2]]=(numConvert(data[29][uniteName[_i2]])+numConvert(data[24][uniteName[_i2]])+numConvert(data[19][uniteName[_i2]])+numConvert(data[14][uniteName[_i2]])).toFixed(2);data[32][uniteName[_i2]]=(numConvert(data[7][uniteName[_i2]])-numConvert(data[16][uniteName[_i2]])-numConvert(data[21][uniteName[_i2]])-numConvert(data[26][uniteName[_i2]])).toFixed(2);data[33][uniteName[_i2]]=(numConvert(data[8][uniteName[_i2]])-numConvert(data[12][uniteName[_i2]])-numConvert(data[17][uniteName[_i2]])-numConvert(data[22][uniteName[_i2]])-numConvert(data[27][uniteName[_i2]])).toFixed(2);data[34][uniteName[_i2]]=(numConvert(data[9][uniteName[_i2]])-numConvert(data[13][uniteName[_i2]])-numConvert(data[18][uniteName[_i2]])-numConvert(data[23][uniteName[_i2]])-numConvert(data[28][uniteName[_i2]])).toFixed(2);data[35][uniteName[_i2]]=(numConvert(data[34][uniteName[_i2]])+numConvert(data[33][uniteName[_i2]])+numConvert(data[32][uniteName[_i2]])).toFixed(2);data[42][uniteName[_i2]]=(numConvert(data[41][uniteName[_i2]])+numConvert(data[40][uniteName[_i2]])+numConvert(data[39][uniteName[_i2]])+numConvert(data[38][uniteName[_i2]])).toFixed(2);data[49][uniteName[_i2]]=(numConvert(data[48][uniteName[_i2]])+numConvert(data[47][uniteName[_i2]])+numConvert(data[46][uniteName[_i2]])+numConvert(data[45][uniteName[_i2]])+numConvert(data[44][uniteName[_i2]])).toFixed(2);data[50][uniteName[_i2]]=(numConvert(data[42][uniteName[_i2]])+numConvert(data[49][uniteName[_i2]])).toFixed(2);data[51][uniteName[_i2]]=(numConvert(data[35][uniteName[_i2]])-numConvert(data[50][uniteName[_i2]])).toFixed(2);data[55][uniteName[_i2]]=(numConvert(data[51][uniteName[_i2]])-numConvert(data[52][uniteName[_i2]])-numConvert(data[53][uniteName[_i2]])-numConvert(data[54][uniteName[_i2]])).toFixed(2);data[60][uniteName[_i2]]=(numConvert(data[59][uniteName[_i2]])+numConvert(data[58][uniteName[_i2]])+numConvert(data[57][uniteName[_i2]])).toFixed(2);data[61][uniteName[_i2]]=(numConvert(data[55][uniteName[_i2]])-numConvert(data[60][uniteName[_i2]])).toFixed(2);data[63][uniteName[_i2]]=(numConvert(data[7][uniteName[_i2]])==0?0:numConvert(data[32][uniteName[_i2]])/numConvert(data[7][uniteName[_i2]])).toFixed(3);data[64][uniteName[_i2]]=(numConvert(data[8][uniteName[_i2]])==0?0:numConvert(data[33][uniteName[_i2]])/numConvert(data[8][uniteName[_i2]])).toFixed(3);data[65][uniteName[_i2]]=(numConvert(data[10][uniteName[_i2]])==0?0:numConvert(data[19][uniteName[_i2]])/numConvert(data[10][uniteName[_i2]])).toFixed(3);data[66][uniteName[_i2]]=(numConvert(data[10][uniteName[_i2]])==0?0:numConvert(data[42][uniteName[_i2]])/numConvert(data[10][uniteName[_i2]])).toFixed(3);data[67][uniteName[_i2]]=(numConvert(data[65][uniteName[_i2]])+numConvert(data[66][uniteName[_i2]])).toFixed(3);data[68][uniteName[_i2]]=(numConvert(data[8][uniteName[_i2]])==0?0:numConvert(data[12][uniteName[_i2]])/numConvert(data[8][uniteName[_i2]])).toFixed(3);data[69][uniteName[_i2]]=(numConvert(data[10][uniteName[_i2]])==0?0:numConvert(data[48][uniteName[_i2]])/numConvert(data[10][uniteName[_i2]])).toFixed(3);data[70][uniteName[_i2]]=(numConvert(data[10][uniteName[_i2]])==0?0:(numConvert(data[12][uniteName[_i2]])+numConvert(data[19][uniteName[_i2]])+numConvert(data[42][uniteName[_i2]])+numConvert(data[48][uniteName[_i2]]))/numConvert(data[10][uniteName[_i2]])).toFixed(3);data[71][uniteName[_i2]]=(numConvert(data[7][uniteName[_i2]])-numConvert(data[32][uniteName[_i2]])).toFixed(2);data[72][uniteName[_i2]]=(numConvert(data[8][uniteName[_i2]])-numConvert(data[33][uniteName[_i2]])).toFixed(2);if(uniteName[_i2]=='total'){data[73][uniteName[_i2]]=((numConvert(data[10][uniteName[_i2]])-numConvert(data[55][uniteName[_i2]]))/12).toFixed(2);}else{data[73][uniteName[_i2]]=(numConvert(data[10][uniteName[_i2]])-numConvert(data[55][uniteName[_i2]])).toFixed(2);}data[74][uniteName[_i2]]=(numConvert(data[19][uniteName[_i2]])+numConvert(data[42][uniteName[_i2]])).toFixed(2);}// 计算三
_this.setState({data:data,loading:false});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var dataBegin,data,bp,data1_1;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dataBegin=JSON.stringify(_data.data2_1);data=JSON.parse(dataBegin);_context.prev=2;_context.next=5;return fetch('/chart_fourth_lst?year='+(0,_moment2.default)(date).format('YYYY'),{credentials:'include'});case 5:bp=_context.sent;_context.next=8;return bp.json();case 8:data1_1=_context.sent;if(data1_1.data&&data1_1.data.length>0){data=data1_1.data;}_this.computeNum(data);_context.next=17;break;case 13:_context.prev=13;_context.t0=_context['catch'](2);_this.setState({loading:false});console.error(_context.t0);case 17:case'end':return _context.stop();}}},_callee,_this2,[[2,13]]);}));return function(_x2){return _ref.apply(this,arguments);};}();_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var data=[].concat(_toConsumableArray(_this.state.data.map(function(x){return _extends({},x,{year:year});})));var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/chart_fourth_add',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);_message3.default.error('保存失败！');console.error(err);});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table2_1',1.5,'0.40',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};var month=(0,_moment2.default)().format('M');_this.state={date:month<3?(0,_moment2.default)().format('YYYY'):(0,_moment2.default)().add(1,'y').format('YYYY'),data:[],loading:true,loadingSave:false,print:false,dateData:[],cover:0};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){var date=Number(this.state.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this3=this,_ref2;var data=this.state.data;var width=document.body.offsetWidth>1925?document.body.offsetWidth-1500:425;var inputIndex=[0,2,7,8,9,12,13,16,17,18,21,22,23,26,27,28,38,39,40,41,44,45,46,47,48,52,53,54,57,58,59];var percentData=[3,63,64,65,66,67,68,69,70];var totalData=[10,35,55];var blankData=[6,11,15,20,25,31,36,37,43,56,62];var columns=[(_ref2={align:"center",title:'',width:width,fixed:"left",dataIndex:'name',key:'name'},_defineProperty(_ref2,'width',width),_defineProperty(_ref2,'render',function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:16},children:_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"left"}},text)};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}),_ref2),{title:this.state.date-1,align:"center",children:[{title:"Oct",align:"center",children:[{title:'Actual',align:"center",dataIndex:'Jan_actual',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Jan_actual",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Budget',align:"center",dataIndex:'Jan_budget',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Jan_budget",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Forecast',align:"center",dataIndex:'Jan_forecast',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Jan_forecast",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]},{title:this.state.date-1,align:"center",children:[{title:"Nov",align:"center",children:[{title:'Actual',align:"center",dataIndex:'Feb_actual',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Feb_actual",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Budget',align:"center",dataIndex:'Feb_budget',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Feb_budget",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Forecast',align:"center",dataIndex:'Feb_forecast',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Feb_forecast",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]},{title:this.state.date-1,align:"center",children:[{title:"Dec",align:"center",children:[{title:'Actual',align:"center",dataIndex:'Mar_actual',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Mar_actual",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Budget',align:"center",dataIndex:'Mar_budget',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Mar_budget",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Forecast',align:"center",dataIndex:'Mar_forecast',width:150,render:function render(text,record,index){var props={text:text,index:index,type:inputIndex.includes(index)?'inputNumber':percentData.includes(index)?'percent':"number",name:"Mar_forecast",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]},{title:this.state.date-1,align:"center",children:[{title:'Year',align:"center",children:[{title:"Total",align:"center",width:150,dataIndex:'total',key:'total',render:function render(text,record,index){var props={text:text,index:index,type:percentData.includes(index)?'percent':"number",name:"Mar_forecast",onChange:_this3.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]}];return _react2.default.createElement('div',{className:'table table2_1'},_react2.default.createElement(_row2.default,{className:'title',style:{width:this.state.print?1975:'auto'},id:'table2_1'},_react2.default.createElement(_row2.default,null,'\u7B2C\u56DB\u5B63\u5EA6 DATA INPUT ',this.state.date-2,' and ',this.state.date-1,' \u6570\u636E\u8F93\u5165 ',this.state.date-2,' and ',this.state.date-1),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(_select2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u4EFD',style:{width:120},value:this.state.date,onChange:function onChange(str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}},this.state.dateData.map(function(x,i){return _react2.default.createElement(Option,{value:x,key:x},x,'\u5E74');})),_react2.default.createElement('div',{className:'chart_cover'},_react2.default.createElement('span',null,'\u5BA2\u623F\u6570\u91CF : '),!this.state.loading?_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:2,className:'table_numInput',defaultValue:data[0]?Number(data[0].cover)||"":"",onBlur:function onBlur(e){var value=Number(e.target.value.replace(/,/g,'')||'0');value=Number(value.toFixed(2));_this3.onChange('cover',value,0);}}):null)),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',className:'content',bordered:true,loading:this.state.loading,pagination:false,style:{width:this.state.print?1925:'auto'},scroll:this.state.print?{}:{x:1925,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_four'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58'))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data2_1=exports.data2_1=[{name:'Days 日数',name_code:"Days",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Available Rooms 总房间数量',name_code:"Total_Available_Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Rooms Occupied 总出租房',name_code:"Total_Rooms_Occupied",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Occupancy % 出租率%',name_code:"Occupancy",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Average Room Rate 平均每天房价',name_code:"Average_Room_Rate",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'RevPAR 单房产值',name_code:"RevPAR",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Revenue 收入',name_code:"Revenue",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Rooms 客房收入',name_code:"Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮收入',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门收入',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Revenues 总收入',name_code:"Total_Revenues",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Cost of Sales 销售成本',name_code:"Cost_of_Sales",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮成本',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门成本',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Cost of Sales 总成本',name_code:"Total_Cost_of_Sales",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Payroll Expenses 工资福利',name_code:"Payroll_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Rooms 客房',name_code:"Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Payroll Expenses 总工资福利',name_code:"Total_Payroll_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Provision for O.E. 营运工具預提',name_code:"Provision_for_O.E.",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Rooms 客房',name_code:"Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Provision for O.E. 总营运工具預提',name_code:"Total_Provision_for_O.E.",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Expenses 其它费用',name_code:"Other_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Rooms 客房',name_code:"Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Other Expenses 总其它费用',name_code:"Total_Other_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Department Cost/Expenses 部门总成本和费用',name_code:"Total_Department_Cost/Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Departmental Profit 部门利润',name_code:"Departmental_Profit",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Rooms 客房',name_code:"Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Operated Departments 其它部门',name_code:"Other_Operated_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Departmental profit 总部门利润',name_code:"Total_Departmental_profit",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Undistributed Operating Expenses 未分配部门费用',name_code:"Undistributed_Operating_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Payroll Expenses 工资福利',name_code:"Payroll_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Administration & General 行政办',name_code:"Administration_General",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Human Resources 人力资源部',name_code:"Human_Resources",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Sales & Marketing 市场销售部',name_code:"Sales_Marketing",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Property Operation & Maintenance 工程部',name_code:"Property_Operation_Maintenance",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Payroll Expenses 总工资福利',name_code:"Total_Payroll_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Expenses 其它费用',name_code:"Other_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Administration & General 行政办',name_code:"Administration_General",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Human Resources 人力资源部',name_code:"Human_Resources",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Sales & Marketing 市场销售部',name_code:"Sales_Marketing",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Property Operation & Maintenance 工程部',name_code:"Property_Operation_Maintenance",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Energy Costs 能源费用',name_code:"Energy_Costs",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Other Expenses 总其它费用',name_code:"Total_Other_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Undistributed Operating Expenses 未分配部门费用总计',name_code:"Total_Undistributed_Operating_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Income After Undistributed Operating Expenses',name_code:"Income_After_Undistributed_Operating_Expenses",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Insurance 保险',name_code:"Insurance",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Base Fee 基本管理费',name_code:"Base_Fee",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Brand Service Fee 品牌维护费',name_code:"Brand_Service_Fee",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Gross Operating Profit/(Loss) 总毛利润/(亏损)',name_code:"Gross_Operating_Profit/(Loss)",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Other Deductions 其它扣除',name_code:"Other_Deductions",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Incentive Fees 奖励性管理费',name_code:"Incentive_Fees",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Reserve for Capital Expenditure 固定资产备用',name_code:"Reserve_for_Capital_Expenditure",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Others 其它',name_code:"Others",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Other Deductions 其它扣除总计',name_code:"Total_Other_Deductions",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:"Owner's Profit/(Loss) 业主利润/(亏损)",name_code:"Owner's Profit/(Loss) 业主利润/(亏损)",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Index',name_code:"Index",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Departmental Income - Rooms',name_code:"Departmental_Income_Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Departmental Income - F&B',name_code:"Departmental_Income_F&B",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Payroll Percentage for Operating Departments',name_code:"Payroll_Percentage_for_Operating_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Payroll Percentage for Undistributed Departments',name_code:"Payroll_Percentage_for_Undistributed_Departments",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Labor Cost Percentage',name_code:"Total_Labor_Cost_Percentage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Tota F&B Cost Percentage',name_code:"Tota_F&B_Cost_Percentage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Total Energy Cost Percentage',name_code:"Total_Energy_Cost_Percentage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Three Main Costs Percentage',name_code:"Three_Main_Costs_Percentage",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Monthly Cost and Expenses - Rooms',name_code:"Monthly_Cost_and_Expenses_Rooms",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Monthly Cost and Expenses - F&B',name_code:"Monthly_Cost_and_Expenses_F&B",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Breakeven Point',name_code:"Breakeven_Point",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0},{name:'Labor Cost',name_code:"Labor_Cost",Jan_actual:0,Jan_forecast:0,Jan_budget:0,Feb_actual:0,Feb_forecast:0,Feb_budget:0,Mar_actual:0,Mar_forecast:0,Mar_budget:0,total:0,cover:0}];

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_initialiseProps;__webpack_require__(10);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(2108);var _saveImg=__webpack_require__(214);var _saveImg2=_interopRequireDefault(_saveImg);var _data=__webpack_require__(2109);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(139);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _method2=_interopRequireDefault(_method);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=(_temp=_class=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_initialiseProps.call(_this);var month=(0,_moment2.default)().format('M');_this.state={date:month<3?(0,_moment2.default)().format('YYYY'):(0,_moment2.default)().add(1,'y').format('YYYY'),data:[],loading:true,loadingSave:false,print:false,dateData:[],cover:0,dataSelect:[]};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){var date=Number(this.state.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this2=this;var data=this.state.data;var width=document.body.offsetWidth>2225?document.body.offsetWidth-1800:425;var percentData=[3,63,64,65,66,67,68,69,70];var totalData=[10,35,55];var blankData=[6,11,15,20,25,31,36,37,43,56,62];var columns=[// {
//     align: "center",
//     title: 'key',
//     width: 50,
//     fixed: 'left',
//     render: (text, record, index) => {
//         return index
//     }
// },
{align:"center",title:'',width:width,fixed:'left',dataIndex:'name',key:'name',render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this2.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:16},children:_react2.default.createElement('div',{className:'table-color '+(totalData.includes(index)?'table-color-footer':''),style:{textAlign:"left"}},text)};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'THIS MONTH 本月',align:"center",children:[{title:'ACTUAL  实际',align:"center",width:150,dataIndex:'month_actual',key:'month_actual',render:function render(text,record,index){var props={text:text,index:index,type:percentData.includes(index)?'percent':"number",name:"Jan_actual",onChange:_this2.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]},{title:'(%)',align:"center",dataIndex:'month_actual_percent',key:'month_actual_percent',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"month_actual_percent",onChange:_this2.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'THIS MONTH 本月',align:"center",children:[{title:'BUDGET  预算',align:"center",width:150,dataIndex:'month_budget',key:'month_budget',render:function render(text,record,index){var props={text:text,index:index,type:percentData.includes(index)?'percent':"number",name:"month_budget",onChange:_this2.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]},{title:'(%)',align:"center",dataIndex:'month_budget_percent',key:'month_budget_percent',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"month_budget_percent",onChange:_this2.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'THIS MONTH 本月',align:"center",children:[{title:'LAST YEAR  上年',align:"center",width:150,dataIndex:'month_last',key:'month_last',render:function render(text,record,index){var props={text:text,index:index,type:percentData.includes(index)?'percent':"number",name:"month_last",onChange:_this2.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]},{title:'(%)',align:"center",dataIndex:'month_last_percent',key:'month_last_percent',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"month_last_percent",onChange:_this2.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Y-T-D  本年累计',align:"center",children:[{title:'ACTUAL  实际',align:"center",width:150,dataIndex:'year_actual',key:'year_actual',render:function render(text,record,index){var props={text:text,index:index,type:percentData.includes(index)?'percent':"number",name:"year_actual",onChange:_this2.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]},{title:'(%)',align:"center",dataIndex:'year_actual_percent',key:'year_actual_percent',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"year_actual_percent",onChange:_this2.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Y-T-D  本年累计',align:"center",children:[{title:'BUDGET  预算',align:"center",width:150,dataIndex:'year_budget',key:'year_budget',render:function render(text,record,index){var props={text:text,index:index,type:percentData.includes(index)?'percent':"number",name:"year_budget",onChange:_this2.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]},{title:'(%)',align:"center",dataIndex:'year_budget_percent',key:'year_budget_percent',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"year_budget_percent",onChange:_this2.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Y-T-D  年累计',align:"center",children:[{title:'LAST YEAR  上年',align:"center",width:150,dataIndex:'year_last',key:'year_last',render:function render(text,record,index){var props={text:text,index:index,type:percentData.includes(index)?'percent':"number",name:"year_last",onChange:_this2.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]},{title:'(%)',align:"center",dataIndex:'year_last_percent',key:'year_last_percent',width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"year_last_percent",onChange:_this2.onChange,totalIndex:totalData};if(blankData.includes(index)){return{props:{colSpan:0,children:""}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];return _react2.default.createElement('div',{className:'table table2_1'},_react2.default.createElement(_row2.default,{className:'title',style:{width:this.state.print?1775:'auto'},id:'table2_1'},_react2.default.createElement(_row2.default,null,'Summary Table \u6C47\u603B\u8868'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(_select2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u4EFD',style:{width:120},value:this.state.date,onChange:function onChange(str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}},this.state.dateData.map(function(x,i){return _react2.default.createElement(Option,{value:x,key:x},x,'\u5E74');}))),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',className:'content',bordered:true,loading:this.state.loading,pagination:false,style:{width:this.state.print?2225:'auto'},scroll:this.state.print?{}:{y:500,x:2225},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_summary'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u52A0\u5165pdf'))));}}]);return index;}(_react.Component),_initialiseProps=function _initialiseProps(){var _this3=this;this.computeNum=function(data){var numConvert=function numConvert(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;num=Number(num||"0");return num;};var listName=['month_actual','month_budget','month_last','year_actual','year_budget','year_last'];//14 单独
var formula=[[7,10],[8,10],[9,10],[10,10],[12,8],[13,9]];listName.forEach(function(name,index){data[14][name+"_percent"]=(numConvert(data[8][name])+numConvert(data[8][name])==0?0:data[14][name]/(numConvert(data[8][name])+numConvert(data[8][name]))).toFixed(4);formula.forEach(function(x,i){data[x[0]][name+"_percent"]=(numConvert(data[x[1]][name])==0?0:numConvert(data[x[0]][name])/numConvert(data[x[1]][name])).toFixed(4);});data.forEach(function(item,i){if(i>=16){data[i][name+'_percent']=(numConvert(data[10][name])==0?0:numConvert(data[i][name])/numConvert(data[10][name])).toFixed(3);}});});_this3.setState({data:data});};this.onChange=function(name,value,i){var data=_this3.state.data;data[i][name]=value;_this3.computeNum(data);};this.getDateData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var dataBegin,data,res,json,one,two,three,four,lastone,lasttwo,lastthree,lastfour,month,monthname,dataList,dataLastList,name,dataSource,dataLastSource;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dataBegin=JSON.stringify(_data.data2_1);data=JSON.parse(dataBegin);_context.prev=2;_context.next=5;return fetch('/charter_summary?year='+(0,_moment2.default)(date).format('YYYY'),{credentials:'include'});case 5:res=_context.sent;_context.next=8;return res.json();case 8:json=_context.sent;one=json.data.one||[];two=json.data.two||[];three=json.data.three||[];four=json.data.four||[];lastone=json.data.lastone||[];lasttwo=json.data.lasttwo||[];lastthree=json.data.lastthree||[];lastfour=json.data.lastfour||[];month=(0,_moment2.default)().format('M')-1;monthname=['Jan','Feb','Mar','Jan','Feb','Mar','Jan','Feb','Mar','Jan','Feb','Mar'];dataList=[one,one,one,two,two,two,three,three,three,four,four,four];dataLastList=[lastone,lastone,lastone,lasttwo,lasttwo,lasttwo,lastthree,lastthree,lastthree,lastfour,lastfour,lastfour];name=monthname[month];dataSource=dataList[month];dataLastSource=dataLastList[month];data=data.map(function(item,i){return _extends({},item,{month_actual:(0,_method2.default)([i,name+"_actual"],dataSource),month_budget:(0,_method2.default)([i,name+"_budget"],dataSource),month_last:(0,_method2.default)([i,name+"_actual"],dataLastSource),year_actual:dataList.reduce(function(a,b,index){a+=Number((0,_method2.default)([i,monthname[index]+'_actual'],b));return a;},0),year_budget:dataList.reduce(function(a,b,index){a+=Number((0,_method2.default)([i,monthname[index]+'_budget'],b));return a;},0),year_last:dataLastList.reduce(function(a,b,index){a+=Number((0,_method2.default)([i,monthname[index]+'_actual'],b));return a;},0)});});_this3.setState({loading:false},function(){_this3.computeNum(data);});_context.next=32;break;case 28:_context.prev=28;_context.t0=_context['catch'](2);_this3.setState({loading:false});console.error(_context.t0);case 32:case'end':return _context.stop();}}},_callee,_this3,[[2,28]]);}));return function(_x2){return _ref.apply(this,arguments);};}();this.downloadSG=function(){_this3.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table2_1',1.5,'0.50',_this3.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this3.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this3.setState({print:false,loading:false});});});};},_temp);exports.default=index;

/***/ }),
/* 2108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data2_1=exports.data2_1=[{name:'Days 日数',name_code:"Days",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Total Available Rooms 总房间数量',name_code:"Total_Available_Rooms",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Total Rooms Occupied 总出租房',name_code:"Total_Rooms_Occupied",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Occupancy % 出租率%',name_code:"Occupancy",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Average Room Rate 平均每天房价',name_code:"Average_Room_Rate",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'RevPAR 单房产值',name_code:"RevPAR",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Revenue 收入',name_code:"Revenue",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Rooms 客房收入',name_code:"Rooms",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Food & Beverage 餐饮收入',name_code:"Food_Beverage",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Other Operated Departments 其它部门收入',name_code:"Other_Operated_Departments",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Total Revenues 总收入',name_code:"Total_Revenues",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Cost of Sales 销售成本',name_code:"Cost_of_Sales",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Food & Beverage 餐饮成本',name_code:"Food_Beverage",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Other Operated Departments 其它部门成本',name_code:"Other_Operated_Departments",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Total Cost of Sales 总成本',name_code:"Total_Cost_of_Sales",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Payroll Expenses 工资福利',name_code:"Payroll_Expenses",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Rooms 客房',name_code:"Rooms",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Other Operated Departments 其它部门',name_code:"Other_Operated_Departments",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Total Payroll Expenses 总工资福利',name_code:"Total_Payroll_Expenses",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Provision for O.E. 营运工具預提',name_code:"Provision_for_O.E.",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Rooms 客房',name_code:"Rooms",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Other Operated Departments 其它部门',name_code:"Other_Operated_Departments",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Total Provision for O.E. 总营运工具預提',name_code:"Total_Provision_for_O.E.",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Other Expenses 其它费用',name_code:"Other_Expenses",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Rooms 客房',name_code:"Rooms",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Other Operated Departments 其它部门',name_code:"Other_Operated_Departments",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Total Other Expenses 总其它费用',name_code:"Total_Other_Expenses",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Total Department Cost/Expenses 部门总成本和费用',name_code:"Total_Department_Cost/Expenses",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Departmental Profit 部门利润',name_code:"Departmental_Profit",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Rooms 客房',name_code:"Rooms",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Food & Beverage 餐饮',name_code:"Food_Beverage",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Other Operated Departments 其它部门',name_code:"Other_Operated_Departments",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Total Departmental profit 总部门利润',name_code:"Total_Departmental_profit",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Undistributed Operating Expenses 未分配部门费用',name_code:"Undistributed_Operating_Expenses",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Payroll Expenses 工资福利',name_code:"Payroll_Expenses",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Administration & General 行政办',name_code:"Administration_General",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Human Resources 人力资源部',name_code:"Human_Resources",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Sales & Marketing 市场销售部',name_code:"Sales_Marketing",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Property Operation & Maintenance 工程部',name_code:"Property_Operation_Maintenance",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Total Payroll Expenses 总工资福利',name_code:"Total_Payroll_Expenses",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Other Expenses 其它费用',name_code:"Other_Expenses",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Administration & General 行政办',name_code:"Administration_General",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Human Resources 人力资源部',name_code:"Human_Resources",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Sales & Marketing 市场销售部',name_code:"Sales_Marketing",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Property Operation & Maintenance 工程部',name_code:"Property_Operation_Maintenance",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Energy Costs 能源费用',name_code:"Energy_Costs",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Total Other Expenses 总其它费用',name_code:"Total_Other_Expenses",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Total Undistributed Operating Expenses 未分配部门费用总计',name_code:"Total_Undistributed_Operating_Expenses",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Income After Undistributed Operating Expenses',name_code:"Income_After_Undistributed_Operating_Expenses",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Insurance 保险',name_code:"Insurance",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Base Fee 基本管理费',name_code:"Base_Fee",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Brand Service Fee 品牌维护费',name_code:"Brand_Service_Fee",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Gross Operating Profit/(Loss) 总毛利润/(亏损)',name_code:"Gross_Operating_Profit/(Loss)",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Other Deductions 其它扣除',name_code:"Other_Deductions",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Incentive Fees 奖励性管理费',name_code:"Incentive_Fees",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Reserve for Capital Expenditure 固定资产备用',name_code:"Reserve_for_Capital_Expenditure",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Others 其它',name_code:"Others",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:'Total Other Deductions 其它扣除总计',name_code:"Total_Other_Deductions",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0},{name:"Owner's Profit/(Loss) 业主利润/(亏损)",name_code:"Owner's Profit/(Loss) 业主利润/(亏损)",month_actual:0,month_actual_percent:0,month_budget:0,month_budget_percent:0,month_last:0,month_last_percent:0,year_actual:0,year_actual_percent:0,year_budget:0,year_budget_percent:0,year_last:0,year_last_percent:0}];

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _data=__webpack_require__(2111);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _compute=__webpack_require__(2112);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var totalIndex=[];Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(data){return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_compute.compute)(data);case 2:data=_context.sent;console.log(data);_this.setState({data:data});case 5:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.data3_2_1);var data=JSON.parse(dataBegin);var year=(0,_moment2.default)(date).format('YYYY');var month=(0,_moment2.default)(date).format('M');fetch('/getHeadquartersMonth?year='+year+'&month='+month,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>=0){data=x.data;}_this.setState({loading:false},function(){_this.computeNum(data);});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.downloadExcel=function(){var tableName=(0,_moment2.default)(_this.state.date).format('YYYY-MM')+' Revenue monthly summary \u5355\u4F53\u9152\u5E97\u6708\u5EA6\u6536\u76CA\u62A5\u8868';var innerHtml='\n          <caption>'+tableName+'</caption>\n          '+document.getElementById('table').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n        ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+'.xls');_this.setState({print:false});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),dateData:[],data:[],loading:true,loadingSave:false,print:false,monthDataAll:{}};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this3=this;var data=this.state.data;var width=document.body.offsetWidth-3700>700?document.body.offsetWidth-3700:700;var columns=[{title:'SITE NO.',dataIndex:'wdm_number',key:'NO',align:"center",fixed:this.state.print?false:"left",width:100,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"left"}},text);}},{title:'Hotel Name',dataIndex:'name',key:'name',align:"center",fixed:this.state.print?false:"left",width:width*(7/12),render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"left"}},record.name.replace(/[^a-zA-Z0-9\s]/g,''));}},{title:'酒店名称',dataIndex:'name_cn',key:'name_cn',align:"center",fixed:this.state.print?false:"left",width:width*(5/12),render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"left"}},record.name.replace(/[^\u4E00-\u9FA5]/g,""));}},{title:'Year End',children:[{title:'Budget',align:"center",children:[{title:'Nts',align:"center",width:150,dataIndex:'end_budget_nts',key:'end_budget_nts',sorter:function sorter(a,b){return a.end_budget_nts-b.end_budget_nts;},render:function render(text,record,index){var title=['Year End','Budget','Nts'];var props={text:text,index:index,type:'number',name:"end_budget_nts",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'ADR',align:"center",width:150,dataIndex:'end_budget_adr',key:'end_budget_adr',sorter:function sorter(a,b){return a.end_budget_adr-b.end_budget_adr;},render:function render(text,record,index){var title=['Year End','Budget','ADR'];var props={text:text,index:index,type:'number',name:"end_budget_adr",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Revenue',align:"center",width:150,dataIndex:'end_budget_rev',key:'end_budget_rev',sorter:function sorter(a,b){return a.end_budget_rev-b.end_budget_rev;},render:function render(text,record,index){var title=['Year End','Budget','Revenue'];var props={text:text,index:index,type:'number',name:"end_budget_rev",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Occ%',align:"center",width:150,dataIndex:'end_budget_occ',key:'end_budget_occ',sorter:function sorter(a,b){return a.end_budget_occ-b.end_budget_occ;},render:function render(text,record,index){var title=['Year End','Budget','Occ%'];var props={text:text,index:index,type:'percent',name:"end_budget_occ",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]},{title:'Acutal+Forecast',align:"center",width:150,children:[{title:'Nts',align:"center",width:150,dataIndex:'end_actual_nts',key:'end_actual_nts',sorter:function sorter(a,b){return a.end_actual_nts-b.end_actual_nts;},render:function render(text,record,index){var title=['Year End','Acutal+Budget','Nts'];var props={text:text,index:index,type:'number',name:"end_actual_nts",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'ADR',align:"center",width:150,dataIndex:'end_actual_adr',key:'end_actual_adr',sorter:function sorter(a,b){return a.end_actual_adr-b.end_actual_adr;},render:function render(text,record,index){var title=['Year End','Acutal+Budget','ADR'];var props={text:text,index:index,type:'number',name:"end_actual_adr",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Revenue',align:"center",width:150,dataIndex:'end_actual_rev',key:'end_actual_rev',sorter:function sorter(a,b){return a.end_actual_rev-b.end_actual_rev;},render:function render(text,record,index){var title=['Year End','Acutal+Budget','Revenue'];var props={text:text,index:index,type:'number',name:"end_actual_rev",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Occ%',align:"center",width:150,dataIndex:'end_actual_occ',key:'end_actual_occ',sorter:function sorter(a,b){return a.end_actual_occ-b.end_actual_occ;},render:function render(text,record,index){var title=['Year End','Acutal+Budget','Occ%'];var props={text:text,index:index,type:'percent',name:"end_actual_occ",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]},{title:'Varies',align:"center",width:150,children:[{title:'Nts',align:"center",width:150,dataIndex:'end_varies_nts',key:'end_varies_nts',sorter:function sorter(a,b){return a.end_varies_nts-b.end_varies_nts;},render:function render(text,record,index){var title=['Year End','Varies','Nts'];var props={text:text,index:index,type:'percent',name:"end_varies_nts",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'ADR',align:"center",width:150,dataIndex:'end_varies_adr',key:'end_varies_adr',sorter:function sorter(a,b){return a.end_varies_adr-b.end_varies_adr;},render:function render(text,record,index){var title=['Year End','Varies','ADR'];var props={text:text,index:index,type:'percent',name:"end_varies_adr",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Revenue',align:"center",width:150,dataIndex:'end_varies_rev',key:'end_varies_rev',sorter:function sorter(a,b){return a.end_varies_rev-b.end_varies_rev;},render:function render(text,record,index){var title=['Year End','Varies','Revenue'];var props={text:text,index:index,type:'percent',name:"end_varies_rev",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Occ%',align:"center",width:150,dataIndex:'end_varies_occ',key:'end_varies_occ',sorter:function sorter(a,b){return a.end_varies_occ-b.end_varies_occ;},render:function render(text,record,index){var title=['Year End','Varies','Occ%'];var props={text:text,index:index,type:'percent',name:"end_varies_occ",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]},{title:'YTD',children:[{title:'Budget',align:"center",children:[{title:'Nts',align:"center",width:150,dataIndex:'ytd_budget_nts',key:'ytd_budget_nts',sorter:function sorter(a,b){return a.ytd_budget_nts-b.ytd_budget_nts;},render:function render(text,record,index){var title=['YTD','Budget','Nts'];var props={text:text,index:index,type:'number',name:"ytd_budget_nts",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'ADR',align:"center",width:150,dataIndex:'ytd_budget_adr',key:'ytd_budget_adr',sorter:function sorter(a,b){return a.ytd_budget_adr-b.ytd_budget_adr;},render:function render(text,record,index){var title=['YTD','Budget','ADR'];var props={text:text,index:index,type:'number',name:"ytd_budget_adr",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Revenue',align:"center",width:150,dataIndex:'ytd_budget_rev',key:'ytd_budget_rev',sorter:function sorter(a,b){return a.ytd_budget_rev-b.ytd_budget_rev;},render:function render(text,record,index){var title=['YTD','Budget','Revenue'];var props={text:text,index:index,type:'number',name:"ytd_budget_rev",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Occ%',align:"center",width:150,dataIndex:'ytd_budget_occ',key:'ytd_budget_occ',sorter:function sorter(a,b){return a.ytd_budget_occ-b.ytd_budget_occ;},render:function render(text,record,index){var title=['YTD','Budget','Occ%'];var props={text:text,index:index,type:'percent',name:"ytd_budget_occ",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]},{title:'Acutal',align:"center",width:150,children:[{title:'Nts',align:"center",width:150,dataIndex:'ytd_actual_nts',key:'ytd_actual_nts',sorter:function sorter(a,b){return a.ytd_actual_nts-b.ytd_actual_nts;},render:function render(text,record,index){var title=['YTD','Acutal','Nts'];var props={text:text,index:index,type:'number',name:"ytd_actual_nts",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'ADR',align:"center",width:150,dataIndex:'ytd_actual_adr',key:'ytd_actual_adr',sorter:function sorter(a,b){return a.ytd_actual_adr-b.ytd_actual_adr;},render:function render(text,record,index){var title=['YTD','Acutal','ADR'];var props={text:text,index:index,type:'number',name:"ytd_actual_adr",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Revenue',align:"center",width:150,dataIndex:'ytd_actual_rev',key:'ytd_actual_rev',sorter:function sorter(a,b){return a.ytd_actual_rev-b.ytd_actual_rev;},render:function render(text,record,index){var title=['YTD','Acutal','Revenue'];var props={text:text,index:index,type:'number',name:"ytd_actual_rev",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Occ%',align:"center",width:150,dataIndex:'ytd_actual_occ',key:'ytd_actual_occ',sorter:function sorter(a,b){return a.ytd_actual_occ-b.ytd_actual_occ;},render:function render(text,record,index){var title=['YTD','Acutal','Occ%'];var props={text:text,index:index,type:'percent',name:"ytd_actual_occ",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]},{title:'Varies',align:"center",width:150,children:[{title:'Nts',align:"center",width:150,dataIndex:'ytd_varies_nts',key:'ytd_varies_nts',sorter:function sorter(a,b){return a.ytd_varies_nts-b.ytd_varies_nts;},render:function render(text,record,index){var title=['YTD','Varies','Nts'];var props={text:text,index:index,type:'percent',name:"ytd_varies_nts",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'ADR',align:"center",width:150,dataIndex:'ytd_varies_adr',key:'ytd_varies_adr',sorter:function sorter(a,b){return a.ytd_varies_adr-b.ytd_varies_adr;},render:function render(text,record,index){var title=['YTD','Varies','ADR'];var props={text:text,index:index,type:'percent',name:"ytd_varies_adr",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Revenue',align:"center",width:150,dataIndex:'ytd_varies_rev',key:'ytd_varies_rev',sorter:function sorter(a,b){return a.ytd_varies_rev-b.ytd_varies_rev;},render:function render(text,record,index){var title=['YTD','Varies','Revenue'];var props={text:text,index:index,type:'percent',name:"ytd_varies_rev",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Occ%',align:"center",width:150,dataIndex:'ytd_varies_occ',key:'ytd_varies_occ',sorter:function sorter(a,b){return a.ytd_varies_occ-b.ytd_varies_occ;},render:function render(text,record,index){var title=['YTD','Varies','Occ%'];var props={text:text,index:index,type:'percent',name:"ytd_varies_occ",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}]}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_1_1',style:{width:this.state.print?4450:'auto'}},_react2.default.createElement(_row2.default,null,'Revenue monthly summary \u5355\u4F53\u9152\u5E97\u6708\u5EA6\u6536\u76CA\u62A5\u8868'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',id:'table',bordered:true,pagination:false,className:'content',style:{width:this.state.print?4400:'auto'},scroll:this.state.print?{}:{x:4400,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_4_1'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:this.state.print},'\u5BFC\u51FAExcel')))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var data3_2_1=exports.data3_2_1=[{name:"酒店名称",end_budget_nts:0,end_budget_adr:1,end_budget_rev:2,end_budget_occ:3,end_actual_nts:4,end_actual_adr:5,end_actual_rev:6,end_actual_occ:7,end_varies_nts:8,end_varies_adr:9,end_varies_rev:10,end_varies_occ:11,ytd_budget_nts:12,ytd_budget_adr:13,ytd_budget_rev:14,ytd_budget_occ:15,ytd_actual_nts:16,ytd_actual_adr:17,ytd_actual_rev:18,ytd_actual_occ:19,ytd_varies_nts:20,ytd_varies_adr:21,ytd_varies_rev:22,ytd_varies_occ:23}];

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.compute=compute;var _method=__webpack_require__(20);function compute(data){var listName=['end_varies_nts','end_varies_adr','end_varies_rev','end_varies_occ','ytd_varies_nts','ytd_varies_adr','ytd_varies_rev','ytd_varies_occ'];listName.forEach(function(name){var BUDGET=name.split('_')[0]+'_budget_'+name.split('_')[2];var ACTUAL=name.split('_')[0]+'_actual_'+name.split('_')[2];data.forEach(function(item,i){data[i][name]=(0,_method.numConvert)(item[BUDGET])==0?0:(((0,_method.numConvert)(item[ACTUAL])-(0,_method.numConvert)(item[BUDGET]))/(0,_method.numConvert)(item[BUDGET])).toFixed(4);});});return data;}

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _data=__webpack_require__(2114);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _compute=__webpack_require__(2115);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var totalIndex=[];Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(data){return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_compute.compute)(data);case 2:data=_context.sent;_this.setState({data:data});case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var data=[];var year=(0,_moment2.default)(date).format('YYYY');var month=(0,_moment2.default)(date).format('M');fetch('/getHeadquartersYear?year='+year+'&month='+month,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>=0){data=x.data;}_this.setState({loading:false},function(){_this.computeNum(data);});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.downloadExcel=function(){var tableName=(0,_moment2.default)(_this.state.date).format('YYYY-MM')+' Monthly completion trend \u5355\u4F53\u9152\u5E97\u6708\u5EA6\u5B8C\u6210\u8D8B\u52BF';var innerHtml='\n          <caption>'+tableName+'</caption>\n          '+document.getElementById('table').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n        ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+'.xls');_this.setState({print:false});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),dateData:[],data:[],loading:true,loadingSave:false,print:false,monthDataAll:{}};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this3=this;var data=this.state.data;var width=document.body.offsetWidth-9880>650?document.body.offsetWidth-9880:650;var columns=[{title:'SITE NO.',key:'NO',align:"center",dataIndex:'wdm_number',fixed:this.state.print?false:"left",width:80,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"left"}},text);}},{title:'Hotel Name',dataIndex:'name',key:'name',align:"center",fixed:this.state.print?false:"left",width:width*(8/15),render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"left"}},record.name.replace(/[^a-zA-Z0-9\s]/g,''));}},{title:'酒店名称',dataIndex:'name_cn',key:'name_cn',align:"center",fixed:this.state.print?false:"left",width:width*(7/15),render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"left"}},record.name.replace(/[^\u4E00-\u9FA5]/g,""));}}].concat(_toConsumableArray(_data.columnsData.map(function(item){return{title:item.title,children:item.children.map(function(x){return{title:x.title,align:"center",width:150,dataIndex:x.key,key:x.key,sorter:function sorter(a,b){return b[x.key]-a[x.key];},render:function render(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var record=arguments[1];var index=arguments[2];var props={text:text,index:index,type:x.key.includes('occ')?'percent':'number',name:x.key,onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}};})};})));return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_1_1',style:{width:this.state.print?10580:'auto'}},_react2.default.createElement(_row2.default,null,'Monthly completion trend \u5355\u4F53\u9152\u5E97\u6708\u5EA6\u5B8C\u6210\u8D8B\u52BF'),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',id:'table',bordered:true,pagination:false,className:'content',style:{width:this.state.print?10530:'auto'},scroll:this.state.print?{}:{x:10530,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_4_1'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:this.state.print},'\u5BFC\u51FAExcel')))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var monthName=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];var listName=['nts','adr','rev','occ','revpar'];var listTitle=['Nts','ADR','Revenue','Occ%','RevPar'];var columnsData=exports.columnsData=[{title:"Budget",key:"budget",children:listName.map(function(name,index){return{key:'budget_'+name,title:listTitle[index]};})}].concat(_toConsumableArray(monthName.map(function(x){return{title:'Actual YTD till '+x+'.',key:x,children:listName.map(function(name,index){return{key:x+'_'+name,title:listTitle[index]};})};})));

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.compute=compute;var _method=__webpack_require__(20);function compute(data){return data;}

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _data=__webpack_require__(2117);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var totalIndex=[];Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(data){return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({data:data});case 1:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var data=[];var year=(0,_moment2.default)(date).format('YYYY');var month=(0,_moment2.default)(date).format('M');fetch('/getHRoomsKPIAnalysisSummary?year='+year+'&month='+month,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>=0){data=x.data;}_this.setState({loading:false},function(){_this.computeNum(data);});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.downloadExcel=function(){var tableName=(0,_moment2.default)(_this.state.date).format('YYYY-MM')+' Rooms KPI Analysis Summary \u5BA2\u623F\u5173\u952E\u7EE9\u6548\u6307\u6570\u5206\u6790\u6C47\u603B';var innerHtml='\n          <caption>'+tableName+'</caption>\n          '+document.getElementById('table').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n        ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+'.xls');_this.setState({print:false});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),dateData:[],data:[],loading:true,loadingSave:false,print:false,monthDataAll:{}};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this3=this;var data=this.state.data;var width=document.body.offsetWidth-2200>700?document.body.offsetWidth-2200:700;var columns=[{title:'SITE No.',dataIndex:'wdm_number',key:'NO',align:"center",fixed:this.state.print?false:"left",width:100,render:function render(text,record,index){if(index%2!=0){return{props:{rowSpan:0}};}return{props:{rowSpan:2},children:_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"left"}},text)};}},{title:'Hotel Name',dataIndex:'hotel_name',key:'hotel_name',align:"center",fixed:this.state.print?false:"left",width:width*(8/15),render:function render(text,record,index){if(index%2!=0){return{props:{rowSpan:0}};}return{props:{rowSpan:2},children:_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"left"}},record.hotel_name.replace(/[^a-zA-Z0-9\s]/g,''))};}},{title:'酒店名称',dataIndex:'name_cn',key:'name_cn',align:"center",fixed:this.state.print?false:"left",width:width*(7/15),render:function render(text,record,index){if(index%2!=0){return{props:{rowSpan:0}};}return{props:{rowSpan:2},children:_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"left"}},record.hotel_name.replace(/[^\u4E00-\u9FA5]/g,""))};}},{title:'-',dataIndex:'year',key:'year',align:"center",fixed:this.state.print?false:"left",width:150,render:function render(text,record,index){return _react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"left"}},index%2!=1?'YTD This Year':"YTD Last Year");}}].concat(_toConsumableArray(_data.columnsData.map(function(item){return{title:_react2.default.createElement('div',{dangerouslySetInnerHTML:{__html:item.name}}),align:"center",width:150,dataIndex:item.key,key:item.key,sorter:function sorter(a,b){return b[item.key]-a[item.key];},render:function render(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var record=arguments[1];var index=arguments[2];var props={text:text,index:index,type:item.type,name:item.key,onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}};})));return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_1_1',style:{width:this.state.print?2950:'auto'}},_react2.default.createElement(_row2.default,null,'Rooms KPI Analysis Summary \u5BA2\u623F\u5173\u952E\u7EE9\u6548\u6307\u6570\u5206\u6790\u6C47\u603B'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',id:'table',bordered:true,pagination:false,className:'content',style:{width:this.state.print?2900:'auto'},scroll:this.state.print?{}:{x:2900,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_4_1'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:this.state.print},'\u5BFC\u51FAExcel')))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var columnsData=exports.columnsData=[{name:"MPI  <br/> 市场渗透率指数",key:"mpi",type:"number"},{name:"Ranking  <br/> 排名",key:"mpi_ranking",type:"number"},{name:"ARI  <br/> 平均房价指数",key:"ari",type:"number"},{name:"Ranking  <br/> 排名",key:"ari_ranking",type:"number"},{name:"RGI  <br/> 收益率指数",key:"rgi",type:"number"},{name:"Ranking  <br/> 排名",key:"rgi_ranking",type:"number"},{name:"Rooms <br/> 客房数",key:"rooms",type:"number"},{name:"Rms Avaliable <br/> 可售客房数",key:"rooms_avaliable",type:"number"},{name:"Rms Sold <br/>售出房数",key:"rooms_sold",type:"number"},{name:"OCC<br/> 客房率",key:"occ",type:"string"},{name:"Revn <br/>客房收入",key:"revn",type:"number"},{name:"Avg Rate  <br/> 平均房价",key:"avg_rate",type:"number"},{name:"RevPAR  <br/> 可售房平均收入",key:"revpar",type:"number"}];

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _upload=__webpack_require__(171);var _upload2=_interopRequireDefault(_upload);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _icon=__webpack_require__(38);var _icon2=_interopRequireDefault(_icon);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(172);__webpack_require__(6);__webpack_require__(75);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(2119);var _Target=__webpack_require__(2120);var _Target2=_interopRequireDefault(_Target);var _Contract=__webpack_require__(2121);var _Contract2=_interopRequireDefault(_Contract);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),loading:false,fileList:[]},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'render',value:function render(){var _this2=this;var _state=this.state,date=_state.date,loading=_state.loading,fileList=_state.fileList;var that=this;var props={name:'file',action:'/guestExcel',accept:".csv,.xls,.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",headers:{authorization:'authorization-text'},data:{month:(0,_moment2.default)(date).format('M'),year:(0,_moment2.default)(date).format('YYYY')},fileList:fileList,onChange:function onChange(info){that.setState({fileList:[info.file],loading:true});if(info.file.status==='done'){if(info.file.response.status==1){_message3.default.success(date+' \u6570\u636E\u5DF2\u7ECF\u66F4\u65B0\u6210\u529F\uFF01');}else{_message3.default.error(date+' \u66F4\u65B0\u5931\u8D25\uFF0C\u8BF7\u91CD\u65B0\u4E0A\u4F20\u6216\u8054\u7CFB\u7BA1\u7406\u5458\uFF01');}that.setState({loading:false});return;}else if(info.file.status==='error'){_message3.default.error('\u8868\u683C\u4E0A\u4F20\u5931\u8D25\uFF01');that.setState({loading:false});}}};return _react2.default.createElement('div',{className:'excel-upload'},_react2.default.createElement('div',{className:'list'},_react2.default.createElement('div',{className:'title'},'WynReview - Medallia \u5BA2\u4EBA\u8BC4\u5206'),_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str});}}),_react2.default.createElement(_upload2.default,props,_react2.default.createElement(_button2.default,{loading:loading},_react2.default.createElement(_icon2.default,{type:'upload'}),' ',loading?'文件上传中。。。':"上传"))),_react2.default.createElement(_Target2.default,null),_react2.default.createElement(_Contract2.default,null));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _upload=__webpack_require__(171);var _upload2=_interopRequireDefault(_upload);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _icon=__webpack_require__(38);var _icon2=_interopRequireDefault(_icon);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(172);__webpack_require__(6);__webpack_require__(75);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),loading:false,fileList:[]},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'render',value:function render(){var _this2=this;var _state=this.state,date=_state.date,loading=_state.loading,fileList=_state.fileList;var that=this;var props={name:'file',action:'/targetExcel',accept:".csv,.xls,.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",headers:{authorization:'authorization-text'},data:{month:(0,_moment2.default)(date).format('M'),year:(0,_moment2.default)(date).format('YYYY')},fileList:fileList,onChange:function onChange(info){that.setState({fileList:[info.file],loading:true});if(info.file.status==='done'){if(info.file.response.status==1){_message3.default.success(date+' \u6570\u636E\u5DF2\u7ECF\u66F4\u65B0\u6210\u529F\uFF01');}else{_message3.default.error(date+' \u66F4\u65B0\u5931\u8D25\uFF0C\u8BF7\u91CD\u65B0\u4E0A\u4F20\u6216\u8054\u7CFB\u7BA1\u7406\u5458\uFF01');}that.setState({loading:false});return;}else if(info.file.status==='error'){_message3.default.error('\u8868\u683C\u4E0A\u4F20\u5931\u8D25\uFF01');that.setState({loading:false});}}};return _react2.default.createElement('div',{className:'list'},_react2.default.createElement('div',{className:'title'},'Corporate Office Target \u96C6\u56E2\u6307\u6807'),_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str});}}),_react2.default.createElement(_upload2.default,props,_react2.default.createElement(_button2.default,{loading:loading},_react2.default.createElement(_icon2.default,{type:'upload'}),' ',loading?'文件上传中。。。':"上传")));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _upload=__webpack_require__(171);var _upload2=_interopRequireDefault(_upload);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _icon=__webpack_require__(38);var _icon2=_interopRequireDefault(_icon);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(172);__webpack_require__(6);__webpack_require__(75);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={loading:false,fileList:[]},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'render',value:function render(){var _state=this.state,date=_state.date,loading=_state.loading,fileList=_state.fileList;var that=this;var props={name:'file',action:'/openDateExcel',accept:".csv,.xls,.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",headers:{authorization:'authorization-text'},fileList:fileList,onChange:function onChange(info){that.setState({fileList:[info.file],loading:true});if(info.file.status==='done'){if(info.file.response.status==1){_message3.default.success(date+' \u6570\u636E\u5DF2\u7ECF\u66F4\u65B0\u6210\u529F\uFF01');}else{_message3.default.error(date+' \u66F4\u65B0\u5931\u8D25\uFF0C\u8BF7\u91CD\u65B0\u4E0A\u4F20\u6216\u8054\u7CFB\u7BA1\u7406\u5458\uFF01');}that.setState({loading:false});return;}else if(info.file.status==='error'){_message3.default.error('\u8868\u683C\u4E0A\u4F20\u5931\u8D25\uFF01');that.setState({loading:false});}}};return _react2.default.createElement('div',{className:'list'},_react2.default.createElement('div',{className:'title'},'\u9152\u5E97\u5F00\u4E1A\u65E5\u671F\u3001\u5408\u540C\u5230\u671F\u65F6\u95F4\u5BFC\u5165'),_react2.default.createElement(_upload2.default,props,_react2.default.createElement(_button2.default,{loading:loading},_react2.default.createElement(_icon2.default,{type:'upload'}),' ',loading?'文件上传中。。。':"上传")));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Income=__webpack_require__(2123);var _Income2=_interopRequireDefault(_Income);var _Compared=__webpack_require__(2124);var _Compared2=_interopRequireDefault(_Compared);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(2125);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"render",// componentDidMount() {
//     this.fetchAll();
// }
// fetchAll = async () => {
//     try {
//         const year = moment().format('YYYY');
//         const month = moment().subtract(1, 'month').format('M');
//         let j = await fetch(`/performanceReview?year=${year}&month=${month}`, { credentials: 'include' });
//         let res = await j.json();
//         console.log(res);
//         this.setState({
//             data: res.data || {}
//         });
//     } catch (error) {
//         console.error(error);
//         message.error('获取数据失败！');
//     }
// }
value:function render(){return _react2.default.createElement("div",{className:"performanceReview"},_react2.default.createElement("div",{className:"title"},"1.4 Performance Review 2019\u4E0A\u534A\u5E74\u9152\u5E97\u7ECF\u8425\u60C5\u51B5\u56DE\u987E"),_react2.default.createElement(_Income2.default,null),_react2.default.createElement(_Compared2.default,null));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Income=function(_Component){_inherits(Income,_Component);function Income(){_classCallCheck(this,Income);return _possibleConstructorReturn(this,(Income.__proto__||Object.getPrototypeOf(Income)).apply(this,arguments));}_createClass(Income,[{key:"render",value:function render(){var data=this.props.data;return _react2.default.createElement("div",{className:"row"},_react2.default.createElement("div",{className:"content"},_react2.default.createElement("div",{className:"title"},"\u603B\u6536\u5165\uFF08Total Revenue)",_react2.default.createElement("br",null),"Top 10"),['Wyndham Grand Plaza Royale Ningbo 宁波华侨豪生温德姆至尊豪廷大酒店',"Howard Johnson City of Flower Hotel Kunming 昆明花之城豪生酒店","Wyndham Grand Plaza Royale Hangzhou 杭州温德姆至尊豪廷大酒店","Howard Johnson Resort Sanya Bay 三亚国光豪生度假酒店","Wyndham Grand Plaza Royale Oriental Shanghai 上海兴荣温德姆至尊豪廷酒店 ","Howard Johnson Tian Mu Lake Plaza Liyang 溧阳天目湖豪生大酒店","Wyndham Grand Plaza Royale Furongguo Changsha 长沙芙蓉国温德姆至尊豪廷大酒店","Howard Johnson Huachen Plaza Changsha 长沙华晨豪生大酒店","Wyndham Grand Plaza Royale Colorful Yunnan Kunming 昆明七彩云南温德姆至尊豪廷大酒店","Howard Johnson Zunyue Hotel Chengdu 成都尊悦豪生酒店"].map(function(x,i){return _react2.default.createElement("div",{className:"item",key:x},_react2.default.createElement("div",null,i+1),_react2.default.createElement("div",null,x.replace(/[^a-zA-Z0-9\s]/g,''),_react2.default.createElement("br",null),x.replace(/[^\u4E00-\u9FA5]/g,"")));})),_react2.default.createElement("div",{className:"content"},_react2.default.createElement("div",{className:"title"},"\u7ECF\u8425\u5229\u6DA6\uFF08GOP\uFF09",_react2.default.createElement("br",null),"Top 10"),['Howard Johnson City of Flower Hotel Kunming 昆明花之城豪生酒店',"Wyndham Grand Plaza Royale Ningbo 宁波华侨豪生温德姆至尊豪廷大酒店","Wyndham Grand Plaza Royale Hangzhou 杭州温德姆至尊豪廷大酒店","Wyndham Grand Plaza Royale Oriental Shanghai 上海兴荣温德姆至尊豪廷酒店 ","Wyndham Bund East Shanghai 上海兴荣温德姆酒店","Wyndham Grand Plaza Royale Furongguo Changsha 长沙芙蓉国温德姆至尊豪廷大酒店","Howard Johnson Zunyue Hotel Chengdu 成都尊悦豪生酒店","Howard Johnson Paragon Hotel Beijing 北京宝辰饭店","Howard Johnson Sunshine Plaza Ningbo 宁波阳光豪生大酒店","Howard Johnson Sandalwoods Hot Spring Resort Shuangyue Bay Huizhou 惠州双月湾檀悦豪生温泉度假酒店"].map(function(x,i){return _react2.default.createElement("div",{className:"item",key:x},_react2.default.createElement("div",null,i+1),_react2.default.createElement("div",null,x.replace(/[^a-zA-Z0-9\s]/g,''),_react2.default.createElement("br",null),x.replace(/[^\u4E00-\u9FA5]/g,"")));})),_react2.default.createElement("div",{className:"content"},_react2.default.createElement("div",{className:"title"},"\u7ECF\u8425\u5229\u6DA6\u7387\uFF08GOP%\uFF09",_react2.default.createElement("br",null),"Top 10"),["Howard Johnson Riverview Hotel Guangzhou 广州桃花江豪生酒店","Howard Johnson Zhujiang Plaza ChongQing 重庆珠江豪生大酒店","Wyndham Bund East Shanghai 上海兴荣温德姆酒店","Wyndham Grand Plaza Royale Oriental Shanghai 上海兴荣温德姆至尊豪廷酒店 ","Howard Johnson Paragon Hotel Beijing 北京宝辰饭店","Howard Johnson City of Flower Hotel Kunming 昆明花之城豪生酒店","Wyndham Grand Plaza Royale Hangzhou 杭州温德姆至尊豪廷大酒店","Howard Johnson Jinghope Serviced Residence Suzhou 苏州晋合豪生行政公寓","Howard Johnson Caida Plaza Shanghai 上海财大豪生大酒店","Howard Johnson Sandalwoods Hot Spring Resort Shuangyue Bay Huizhou 惠州双月湾檀悦豪生温泉度假酒店"].map(function(x,i){return _react2.default.createElement("div",{className:"item",key:x},_react2.default.createElement("div",null,i+1),_react2.default.createElement("div",null,x.replace(/[^a-zA-Z0-9\s]/g,''),_react2.default.createElement("br",null),x.replace(/[^\u4E00-\u9FA5]/g,"")));})));}}]);return Income;}(_react.Component);exports.default=Income;

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Income=function(_Component){_inherits(Income,_Component);function Income(){_classCallCheck(this,Income);return _possibleConstructorReturn(this,(Income.__proto__||Object.getPrototypeOf(Income)).apply(this,arguments));}_createClass(Income,[{key:"render",value:function render(){var data=this.props.data;return _react2.default.createElement("div",{className:"row compared-list"},_react2.default.createElement("div",{className:"content"},_react2.default.createElement("div",{className:"title"},"\u9884\u7B97\u5B8C\u6210\u7387\uFF08Budget%\uFF09",_react2.default.createElement("br",null),"Top 10"),["Wyndham Grand Plaza Royale Yuzhou Xiamen 厦门禹洲温德姆至尊豪廷大酒店","Howard Johnson Plaza Ningbo 宁波华侨豪生大酒店","Howard Johnson Jinyi Hotel Chongqing 重庆锦怡豪生酒店","Howard Johnson Paragon Hotel Beijing 北京宝辰饭店","Wyndham Grand Plaza Royale Kaidi 凯迪温德姆至尊豪廷大酒店","Howard Johnson Tech Center Plaza Hefei 合肥两淮豪生大酒店","Howard Johnson Jimei Lake Plaza Xiamen 厦门集美湖豪生大酒店","Howard Johnson Pearl Plaza Wuhan 江城明珠豪生大酒店","Howard Johnson Hi-Tech Plaza Chengdu 成都高新豪生大酒店","Howard Johnson Tropical Garden Plaza Kunming 昆明南亚风情园豪生大酒店"].map(function(x,i){return _react2.default.createElement("div",{className:"item",key:x},_react2.default.createElement("div",null,i+1),_react2.default.createElement("div",null,x.replace(/[^a-zA-Z0-9\s]/g,''),_react2.default.createElement("br",null),x.replace(/[^\u4E00-\u9FA5]/g,"")));})),_react2.default.createElement("div",{className:"content"},_react2.default.createElement("div",{className:"title"},"\u6536\u5165\u8F83\u53BB\u5E74\u589E\u957F\u5E45\u5EA6\uFF08Rev. vs LY%)",_react2.default.createElement("br",null),"Top 10"),["Howard Johnson Xiangyu Plaza Linyi 山东临沂翔宇豪生大酒店","Wyndham Grand Plaza Royale Huayu Chongqing 重庆华宇温德姆至尊豪廷大酒店","Howard Johnson Riverview Hotel Guangzhou 广州桃花江豪生酒店","Wyndham Grand Plaza Royale Kaidi 凯迪温德姆至尊豪廷大酒店","Howard Johnson Yacht Club Hotel Changsha 长沙湘江豪生酒店","Wyndham Grand Plaza Royale Chenzhou 郴州温德姆至尊豪廷大酒店","Howard Johnson Huachen Plaza Changsha 长沙华晨豪生大酒店","Howard Johnson Sunshine Plaza Ningbo 宁波阳光豪生大酒店","Wyndham Grand Plaza Royale Mingfa Zhangzhou 漳州明发温德姆至尊豪廷大酒店","Howard Johnson Zunyue Hotel Chengdu 成都尊悦豪生酒店"].map(function(x,i){return _react2.default.createElement("div",{className:"item",key:x},_react2.default.createElement("div",null,i+1),_react2.default.createElement("div",null,x.replace(/[^a-zA-Z0-9\s]/g,''),_react2.default.createElement("br",null),x.replace(/[^\u4E00-\u9FA5]/g,"")));})),_react2.default.createElement("div",{className:"content"},_react2.default.createElement("div",{className:"title"},"\u5BA2\u4EBA\u8BC4\u5206\uFF08WYN Review - Medallia\uFF09",_react2.default.createElement("br",null),"Top 10"),["Wyndham Grand Plaza Royale Wenchang 文昌温德姆至尊豪廷大酒店","Howard Johnson Kangda Plaza Qingdao 青岛康大豪生大酒店","Howard Johnson Dream Sea Resort Weihai 威海香海豪生度假酒店 ","Wyndham Grand Plaza Royale Chenzhou 郴州温德姆至尊豪廷大酒店","Howard Johnson Tianzhu Plaza Fuyang 阜阳天筑豪生大酒店","Howard Johnson Hot Spring Resort Anshun 安顺豪生温泉度假酒店","Wyndham Grand Plaza Royale Furongguo Changsha 长沙芙蓉国温德姆至尊豪廷大酒店","Howard Johnson Downtown Hotel Chongqing 重庆渝融豪生酒店","Howard Johnson Jinling Plaza Lijiang 丽江金林豪生大酒店","Howard Johnson Agile Plaza Chengdu 成都雅居乐豪生大酒店"].map(function(x,i){return _react2.default.createElement("div",{className:"item",key:x},_react2.default.createElement("div",null,i+1),_react2.default.createElement("div",null,x.replace(/[^a-zA-Z0-9\s]/g,''),_react2.default.createElement("br",null),x.replace(/[^\u4E00-\u9FA5]/g,"")));})));}}]);return Income;}(_react.Component);exports.default=Income;

/***/ }),
/* 2125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _MTD=__webpack_require__(710);var _MTD2=_interopRequireDefault(_MTD);var _YTD=__webpack_require__(2127);var _YTD2=_interopRequireDefault(_YTD);var _Seasonal=__webpack_require__(2128);var _Seasonal2=_interopRequireDefault(_Seasonal);var _Disclaimer=__webpack_require__(2129);var _Disclaimer2=_interopRequireDefault(_Disclaimer);__webpack_require__(213);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"performanceReview"},_react2.default.createElement(_MTD2.default,null),_react2.default.createElement(_YTD2.default,null),_react2.default.createElement(_Seasonal2.default,null),_react2.default.createElement(_Disclaimer2.default,null));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(312);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);__webpack_require__(213);var _method=__webpack_require__(20);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data,_ref){var _ref$sum1_=_ref.sum1_1,sum1_1=_ref$sum1_===undefined?{}:_ref$sum1_,_ref$inter_sum1_=_ref.inter_sum1_1,inter_sum1_1=_ref$inter_sum1_===undefined?{}:_ref$inter_sum1_,_ref$es1_=_ref.es1_1,es1_1=_ref$es1_===undefined?[]:_ref$es1_,_ref$purchase=_ref.purchase,purchase=_ref$purchase===undefined?0:_ref$purchase,es9_8_2=_ref.es9_8_2,_ref$inter_purchase=_ref.inter_purchase,inter_purchase=_ref$inter_purchase===undefined?0:_ref$inter_purchase;// 区域平台数据
data[0].area=(0,_method.calculation)(sum1_1['Rooms Revenue 客房收入'],sum1_1['Total Revenue 总收入'],4).toFixed(3);data[1].area=(0,_method.calculation)(sum1_1['F&B Revenue 餐饮收入'],sum1_1['Total Revenue 总收入'],4).toFixed(3);data[2].area=(0,_method.calculation)(sum1_1['Other Revenue 其他部门收入'],sum1_1['Total Revenue 总收入'],4).toFixed(3);data[3].area=(0,_method.calculation)(sum1_1["Rooms Dep't Profit 客房部门利润"],sum1_1['Rooms Revenue 客房收入'],4).toFixed(3);data[4].area=(0,_method.calculation)(sum1_1["F&B Dep't Profit 餐饮部门利润"],sum1_1["F&B Revenue 餐饮收入"],4).toFixed(3);data[5].area=(0,_method.calculation)(sum1_1["F&B Total Cost 食品及饮品成本"],sum1_1["F&B Revenue 餐饮收入"],4).toFixed(3);data[6].area=(0,_method.calculation)(sum1_1["Total Payroll Expense 人力资源总费用/薪酬及相关福利总费用"],sum1_1['Total Revenue 总收入'],4).toFixed(3);data[7].area=(0,_method.calculation)(sum1_1['Utility Cost 能源成本'],sum1_1['Total Revenue 总收入'],4).toFixed(3);data[8].area=(0,_method.calculation)(sum1_1["Other Expense and Cost 其他费用及成本"],sum1_1["Total Revenue 总收入"],4).toFixed(3);data[9].area=(0,_method.numConvert)(purchase).toFixed(3);// 收入区间
data[0].interval=(0,_method.calculation)(inter_sum1_1['Rooms Revenue 客房收入'],inter_sum1_1['Total Revenue 总收入'],4).toFixed(3);data[1].interval=(0,_method.calculation)(inter_sum1_1['F&B Revenue 餐饮收入'],inter_sum1_1['Total Revenue 总收入'],4).toFixed(3);data[2].interval=(0,_method.calculation)(inter_sum1_1['Other Revenue 其他部门收入'],inter_sum1_1['Total Revenue 总收入'],4).toFixed(3);data[3].interval=(0,_method.calculation)(inter_sum1_1["Rooms Dep't Profit 客房部门利润"],inter_sum1_1['Rooms Revenue 客房收入'],4).toFixed(3);data[4].interval=(0,_method.calculation)(inter_sum1_1["F&B Dep't Profit 餐饮部门利润"],inter_sum1_1["F&B Revenue 餐饮收入"],4).toFixed(3);data[5].interval=(0,_method.calculation)(inter_sum1_1["F&B Total Cost 食品及饮品成本"],inter_sum1_1["F&B Revenue 餐饮收入"],4).toFixed(3);data[6].interval=(0,_method.calculation)(inter_sum1_1["Total Payroll Expense 人力资源总费用/薪酬及相关福利总费用"],inter_sum1_1['Total Revenue 总收入'],4).toFixed(3);data[7].interval=(0,_method.calculation)(inter_sum1_1['Utility Cost 能源成本'],inter_sum1_1['Total Revenue 总收入'],4).toFixed(3);data[8].interval=(0,_method.calculation)(inter_sum1_1["Other Expense and Cost 其他费用及成本"],inter_sum1_1["Total Revenue 总收入"],4).toFixed(3);data[9].interval=(0,_method.numConvert)(inter_purchase).toFixed(3);// 本酒店数据
data[0].hotel=(0,_method.calculation)((0,_method.getJson)([5,'year_actual'],es1_1),(0,_method.getJson)([8,'year_actual'],es1_1),4).toFixed(3);data[1].hotel=(0,_method.calculation)((0,_method.getJson)([6,'year_actual'],es1_1),(0,_method.getJson)([8,'year_actual'],es1_1),4).toFixed(3);data[2].hotel=(0,_method.calculation)((0,_method.getJson)([7,'year_actual'],es1_1),(0,_method.getJson)([8,'year_actual'],es1_1),4).toFixed(3);data[3].hotel=(0,_method.numConvert)((0,_method.getJson)([10,'year_actual'],es1_1)).toFixed(3);data[4].hotel=(0,_method.numConvert)((0,_method.getJson)([12,'year_actual'],es1_1)).toFixed(3);data[5].hotel=(0,_method.numConvert)((0,_method.getJson)([14,'year_actual'],es1_1)).toFixed(3);data[6].hotel=(0,_method.numConvert)((0,_method.getJson)([16,'year_actual'],es1_1)).toFixed(3);data[7].hotel=(0,_method.numConvert)((0,_method.getJson)([18,'year_actual'],es1_1)).toFixed(3);data[8].hotel=(0,_method.numConvert)((0,_method.getJson)([20,'year_actual'],es1_1)).toFixed(3);data[9].hotel=(0,_method.numConvert)((0,_method.getJson)([17,'total_amount'],es9_8_2)/100).toFixed(3);_this.setState({data:data},function(){_this.onSave();});};_this.onChangeUpdate=function(data){_this.setState({isUpdate:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data,_this.state.dataAll);};_this.getData=function(date){var dataBegin=JSON.stringify(_data.dataDefaultYear);var data=JSON.parse(dataBegin);fetch('/performanceYTDInfo?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data.length>0){data=x.data.data.sort(function(a,b){return a.sort-b.sort;});// 使用固定的行业平均数据
data=data.map(function(item,i){return _extends({},item,{industry:_data.dataDefaultYear[i].industry});});}if(x.data.es1_1&&x.data.es1_1.length>0){x.data.es1_1[11].year_actual=(0,_method.sum)([x.data.extra_profit,x.data.es1_1[11].year_actual]);x.data.es1_1[12].year_actual=(0,_method.calculation)(x.data.es1_1[11].year_actual,x.data.es1_1[6].year_actual,3);}_this.computeNum(data,x.data||{});_this.setState({loading:false,dataAll:x.data||{}});}).catch(function(err){console.error(err);_this.setState({loading:false});});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/performanceYTDAdd',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_this.setState({isUpdate:true});return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.onExpoetExcel=function(){_this.setState({print:true,loading:true},function(){var name='Performance Analysis \u9152\u5E97\u7ECF\u8425\u60C5\u51B5\u5206\u6790 YTD '+_this.state.date;var innerHtml='\n              <caption>'+name+'</caption>\n              '+document.getElementById('table1').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n            ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,name+'.xls');_this.setState({print:false,loading:false});});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table6_3',1.5,'6.20',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().format('D')<=10?(0,_moment2.default)().subtract(2,'month').format('YYYY-MM'):(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],note:{note:""},loading:true,loadingSave:false,print:false,isUpdate:false,dataAll:{}};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData(this.state.date);}// 获取表格5_6_1内容
// 保存表格5-6-1内容
},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,print=_state.print,date=_state.date;var columns=[{dataIndex:'name',key:'name',align:"center",width:300,render:function render(text,record,index){if(new Date('2019-07').valueOf()>new Date(date).valueOf()&&index>=5&&index<=10){return{props:{rowSpa:0,colSpan:0}};}var props={text:text,index:index,type:'text',name:"name",onChange:_this2.onChange};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Average Industry Performance Data ',_react2.default.createElement('br',null),' \u884C\u4E1A\u5E73\u5747\u6570\u636E'),dataIndex:'industry',key:'industry',align:"center",width:200,render:function render(text,record,index){if(new Date('2019-07').valueOf()>new Date(date).valueOf()&&index>=5&&index<=10){return{props:{rowSpa:0,colSpan:0}};}var props={text:text,index:index,type:"percent",name:"industry",onChange:_this2.onChange,compared:{title:["Average Industry Performance Data <br /> 行业平均数据"],record:record,sqlName:"performance_ytd"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Average Area Performance Data',_react2.default.createElement('br',null),' \u533A\u57DF\u5E73\u5747\u6570\u636E ',_react2.default.createElement('br',null),' ',(0,_method.getJson)(['hotel','area'],this.state.dataAll,"")),dataIndex:'area',key:'area',align:"center",width:200,render:function render(text,record,index){if(new Date('2019-07').valueOf()>new Date(date).valueOf()&&index>=5&&index<=10){return{props:{rowSpa:0,colSpan:0}};}var props={text:text,index:index,type:'percent',name:"area",onChange:_this2.onChange,compared:{title:["Average Area Performance Data<br /> 区域平均数据"],record:record,sqlName:"performance_ytd"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Revenue Range (RMB) ',_react2.default.createElement('br',null),' \u6536\u5165\u533A\u95F4 \uFF08\u5355\u4F4D\uFF1A\u5143\uFF09',_react2.default.createElement('br',null),_data.intervalData[(0,_method.getJson)(['hotel','income_interval'],this.state.dataAll,"")]),dataIndex:'interval',key:'interval',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"interval",onChange:_this2.onChange,compared:{title:["Revenue Range (RMB) <br /> 收入区间 （单位：元）"],record:record,sqlName:"performance_ytd"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Hotel Performance Data',_react2.default.createElement('br',null),' \u672C\u9152\u5E97\u6570\u636E'),dataIndex:'hotel',key:'hotel',align:"center",width:200,render:function render(text,record,index){if(new Date('2019-07').valueOf()>new Date(date).valueOf()&&index>=5&&index<=10){return{props:{rowSpa:0,colSpan:0}};}var props={text:text,index:index,type:'percent',name:"hotel",onChange:_this2.onChange,compared:{title:["Hotel Performance Data<br /> 本酒店数据"],record:record,sqlName:"performance_ytd"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1 style-center'},_react2.default.createElement(_row2.default,{className:'title',id:'table6_3'},_react2.default.createElement(_row2.default,null,'1.1.2 YTD \u5E74\u7D2F\u8BA1'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true,note:{note:""}});_this2.getData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'table1',pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_6_2'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this2.setState({print:true},function(){_this2.onExpoetExcel();});}},'\u5BFC\u51FAExcel')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(312);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);__webpack_require__(213);var _method=__webpack_require__(20);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _method2=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data,_ref){var _ref$es5_1_=_ref.es5_1_2,es5_1_2=_ref$es5_1_===undefined?[]:_ref$es5_1_,_ref$banquet=_ref.banquet,banquet=_ref$banquet===undefined?{}:_ref$banquet,_ref$outlets=_ref.outlets,outlets=_ref$outlets===undefined?{}:_ref$outlets,_ref$Chinese=_ref.Chinese,Chinese=_ref$Chinese===undefined?{}:_ref$Chinese,_ref$coffee=_ref.coffee,coffee=_ref$coffee===undefined?{}:_ref$coffee,_ref$inter_banquet=_ref.inter_banquet,inter_banquet=_ref$inter_banquet===undefined?{}:_ref$inter_banquet,_ref$inter_outlets=_ref.inter_outlets,inter_outlets=_ref$inter_outlets===undefined?{}:_ref$inter_outlets,_ref$inter_Chinese=_ref.inter_Chinese,inter_Chinese=_ref$inter_Chinese===undefined?{}:_ref$inter_Chinese,_ref$inter_coffee=_ref.inter_coffee,inter_coffee=_ref$inter_coffee===undefined?{}:_ref$inter_coffee;// 区域平台数据
data[1].area=(0,_method.calculation)(coffee['cost'],coffee['REV'],4).toFixed(3);data[0].area=(0,_method.calculation)(coffee['REV'],outlets['REV'],4).toFixed(3);data[3].area=(0,_method.calculation)(Chinese['cost'],Chinese['REV'],4).toFixed(3);data[2].area=(0,_method.calculation)(Chinese['REV'],outlets['REV'],4).toFixed(3);data[5].area=(0,_method.calculation)(banquet['cost'],banquet['REV'],4).toFixed(3);data[4].area=(0,_method.calculation)(banquet['REV'],outlets['REV'],4).toFixed(3);// 收入区间数据
data[1].interval=(0,_method.calculation)(inter_coffee['cost'],inter_coffee['REV'],4).toFixed(3);data[0].interval=(0,_method.calculation)(inter_coffee['REV'],inter_outlets['REV'],4).toFixed(3);data[3].interval=(0,_method.calculation)(inter_Chinese['cost'],inter_Chinese['REV'],4).toFixed(3);data[2].interval=(0,_method.calculation)(inter_Chinese['REV'],inter_outlets['REV'],4).toFixed(3);data[5].interval=(0,_method.calculation)(inter_banquet['cost'],inter_banquet['REV'],4).toFixed(3);data[4].interval=(0,_method.calculation)(inter_banquet['REV'],inter_outlets['REV'],4).toFixed(3);// 本酒店数据
data[1].hotel=(0,_method2.numConvert)((0,_method.getJson)([0,'cost_percent'],es5_1_2)).toFixed(3);data[0].hotel=(0,_method2.numConvert)((0,_method.getJson)([0,'revenue'],es5_1_2)).toFixed(3);data[3].hotel=(0,_method2.numConvert)((0,_method.getJson)([1,'cost_percent'],es5_1_2)).toFixed(3);data[2].hotel=(0,_method2.numConvert)((0,_method.getJson)([1,'revenue'],es5_1_2)).toFixed(3);data[5].hotel=(0,_method2.numConvert)((0,_method.getJson)([2,'cost_percent'],es5_1_2)).toFixed(3);data[4].hotel=(0,_method2.numConvert)((0,_method.getJson)([2,'revenue'],es5_1_2)).toFixed(3);console.log(data);_this.setState({data:data},function(){_this.onSave();});};_this.onChangeUpdate=function(data){_this.setState({isUpdate:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data,_this.state.dataAll);};_this.getData=function(date){var dataBegin=JSON.stringify(_data.dataSeasonal);var data=JSON.parse(dataBegin);fetch('/performanceSeasonal?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data.length>0){data=x.data.data.sort(function(a,b){return a.sort-b.sort;});}_this.computeNum(data,x.data||{});_this.setState({loading:false,dataAll:x.data||{}});}).catch(function(err){console.error(err);_this.setState({loading:false});});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/performanceSeasonalAdd',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_this.setState({isUpdate:true});return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.onExpoetExcel=function(){_this.setState({print:true,loading:true},function(){var name='Performance Analysis \u9152\u5E97\u7ECF\u8425\u60C5\u51B5\u5206\u6790 YTD '+_this.state.date;var innerHtml='\n              <caption>'+name+'</caption>\n              '+document.getElementById('table2').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n            ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,name+'.xls');_this.setState({print:false,loading:false});});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('table6_3',1.5,'6.20',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});};_this.state={date:(0,_moment2.default)().format('D')<=10?(0,_moment2.default)().subtract(2,'month').format('YYYY-MM'):(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],note:{note:""},loading:true,loadingSave:false,print:false,isUpdate:false,dataAll:{}};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData(this.state.date);}// 获取表格5_6_1内容
// 保存表格5-6-1内容
},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,print=_state.print,date=_state.date;var seasonalMonth=['3','6','9','12'];var isDisplay=seasonalMonth.includes((0,_moment2.default)(date).format('M'));var columns=[{dataIndex:'name',key:'name',align:"center",width:300,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this2.onChange};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Average Area Performance Data',_react2.default.createElement('br',null),' \u533A\u57DF\u5E73\u5747\u6570\u636E ',_react2.default.createElement('br',null),' ',(0,_method.getJson)(['hotel','area'],this.state.dataAll,"")),dataIndex:'area',key:'area',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"area",onChange:_this2.onChange,compared:{title:["Average Area Performance Data<br /> 区域平均数据"],record:record,sqlName:"performance_seasonal"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Revenue Range (RMB) ',_react2.default.createElement('br',null),' \u6536\u5165\u533A\u95F4 \uFF08\u5355\u4F4D\uFF1A\u5143\uFF09',_react2.default.createElement('br',null),_data.intervalData[(0,_method.getJson)(['hotel','income_interval'],this.state.dataAll,"")]),dataIndex:'interval',key:'interval',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"interval",onChange:_this2.onChange,compared:{title:["Revenue Range (RMB) <br /> 收入区间 （单位：元）"],record:record,sqlName:"performance_seasonal"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Hotel Performance Data',_react2.default.createElement('br',null),' \u672C\u9152\u5E97\u6570\u636E'),dataIndex:'hotel',key:'hotel',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"hotel",onChange:_this2.onChange,compared:{title:["Hotel Performance Data<br /> 本酒店数据"],record:record,sqlName:"performance_seasonal"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1 style-center'},_react2.default.createElement(_row2.default,{className:'title',id:'table6_3'},_react2.default.createElement(_row2.default,null,'1.1.3 Seasonal Cost % \u5B63\u5EA6\u7D2F\u8BA1'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true,note:{note:""}});_this2.getData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:isDisplay?data:[],size:'middle',bordered:true,id:'table2',pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_6_2'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this2.setState({print:true},function(){_this2.onExpoetExcel();});}},'\u5BFC\u51FAExcel')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:'table7_1_1 style-center disclaimer'},_react2.default.createElement(_row2.default,{className:'title',id:'table6_3'},_react2.default.createElement(_row2.default,null,'1.1.4 Disclaimer \u514D\u8D23\u58F0\u660E'),_react2.default.createElement('div',{style:{background:"#fff",padding:"24px 0",marginTop:20}},_react2.default.createElement('div',{style:{padding:'0 24px'}},_react2.default.createElement('div',{className:'content_title'},'Disclaimer'),_react2.default.createElement('div',{className:'content_text'},_react2.default.createElement('span',{className:'em'},' Performance Analysis'),'has been prepared solely for general information purposes. The information on which it has been based has been derived from',_react2.default.createElement('span',{className:'em'},'Executive Summary Report'),', which we believe to be reliable, but we have not independently verified such information and we do not guarantee its accuracy or completeness. All opinions and estimates included in',_react2.default.createElement('span',{className:'em'},'Performance Analysis'),'constitute our judgement as of the date of publication. They are subject to change without notice.'),_react2.default.createElement('div',{className:'content_text'},_react2.default.createElement('span',{className:'em'},'Performance Analysis'),' base on confidentiality agreement, which with data masking. Your hotel data also under the confidentiality agreement and it is only visible to whom be granted access. ',_react2.default.createElement('span',{className:'em'},'Performance Analysis'),' only provides the area average data for comparison.'),_react2.default.createElement('div',{className:'content_text'},_react2.default.createElement('span',{className:'em'},'Performance Analysis'),' is for internal use only, not for any performance appraisal or budget data. Transactions should not be entered into in reliance upon the information, opinions and estimates set out herein. We accept no responsibility to any person in any way in respect of any action taken or any failure to act in reliance upon the information contained herein.')),_react2.default.createElement('div',{style:{padding:'0 24px'}},_react2.default.createElement('div',{className:'content_title'},'\u514D\u8D23\u58F0\u660E'),_react2.default.createElement('div',{className:'content_text'},'\u300A\u9152\u5E97\u7ECF\u8425\u60C5\u51B5\u5206\u6790\u300B\u4EC5\u4E3A\u96C6\u56E2\u9152\u5E97\u63D0\u4F9B\u4E00\u822C\u6027\u7EDF\u8BA1\u53C2\u8003\u800C\u51C6\u5907\u3002\u672C\u5206\u6790\u6240\u4F9D\u636E\u7684\u6240\u6709\u4FE1\u606F\u5747\u6765\u6E90\u4E8E\u300A\u6708\u5EA6\u7ECF\u8425\u62A5\u544A\u300B\u3002\u6211\u4EEC\u76F8\u4FE1\u62A5\u544A\u4E2D\u6240\u586B\u5199\u7684\u4FE1\u606F\u662F\u771F\u5B9E\u7684\uFF0C\u4F46\u6211\u4EEC\u5E76\u672A\u5BF9\u8FD9\u4E9B\u4FE1\u606F\u8FDB\u884C\u9010\u9879\u786E\u8BA4\uFF0C\u56E0\u6B64\u4E5F\u65E0\u6CD5\u4FDD\u8BC1\u4ED6\u4EEC\u7684\u771F\u5B9E\u6027\u548C\u5B8C\u6574\u6027\u3002\u6DB5\u76D6\u5728\u6B64\u5206\u6790\u4E2D\u7684\u6240\u6709\u5224\u65AD\u548C\u5206\u6790\u5747\u6765\u81EA\u5206\u6790\u53D1\u8868\u524D\u6240\u83B7\u5F97\u7684\u4FE1\u606F\u3002'),_react2.default.createElement('div',{className:'content_text'},'\u57FA\u4E8E\u4FDD\u5BC6\u534F\u8BAE\uFF0C\u300A\u9152\u5E97\u7ECF\u8425\u60C5\u51B5\u5206\u6790\u300B\u4E2D\u6211\u4EEC\u5DF2\u7ECF\u5C06\u6570\u636E\u8131\u654F\u5904\u7406\u3002\u60A8\u6240\u5728\u9152\u5E97\u7684\u6240\u6709\u5177\u4F53\u6570\u503C\uFF0C\u4EC5\u7531\u60A8\u9152\u5E97\u76F8\u5173\u540C\u4E8B\u6309\u4E0D\u540C\u6743\u9650\u53EF\u89C1\uFF0C\u5E76\u4E14\u6240\u6709\u9152\u5E97\u4E5F\u5E94\u9075\u5B88\u4FDD\u5BC6\u6761\u6B3E\uFF0C\u4E0D\u5F97\u64C5\u81EA\u5206\u4EAB\u6570\u636E\u3002\u9488\u5BF9\u5404\u7EF4\u5EA6\u6BD4\u8F83\u6570\u636E\uFF0C\u6211\u4EEC\u4EC5\u63D0\u4F9B\u8131\u654F\u5904\u7406\u540E\u7684\u533A\u95F4\u5E73\u5747\u503C\u3002'),_react2.default.createElement('div',{className:'content_text'},'\u672C\u6570\u636E\u4EC5\u4F9B\u96C6\u56E2\u5185\u90E8\u4EA4\u6D41\u4E4B\u7528\uFF0C\u4E0D\u4F5C\u4E3A\u4EFB\u4F55\u7EE9\u6548\u8003\u6838\u548C\u9884\u7B97\u6570\u636E\u7684\u4F9D\u636E\u3002\u4EFB\u4F55\u4E2A\u4EBA\u3001\u5355\u4F4D\u4EE5\u4EFB\u4F55\u65B9\u5F0F\u4F9D\u636E\u6B64\u7EDF\u8BA1\u7684\u4FE1\u606F\u6240\u8FDB\u884C\u7684\u5546\u4E1A\u884C\u4E3A\u548C\u8D44\u4EA7\u4EA4\u6613\u3001\u6216\u8005\u7531\u4E8E\u4F7F\u7528\u6B64\u7EDF\u8BA1\u6570\u636E\u9020\u6210\u7684\u540E\u679C\uFF0C\u6211\u4EEC\u4E0D\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\u3002\u672A\u7ECF\u5927\u4E2D\u83EF\u9152\u5E97\uFF08\u9999\u6E2F\uFF09\u6709\u9650\u516C\u53F8\u4E66\u9762\u8BB8\u53EF\uFF0C\u6B64\u5206\u6790\u7684\u5185\u5BB9\u4E0D\u5F97\u5DF2\u4EFB\u4F55\u5F62\u5F0F\u590D\u5236\u3001\u5F15\u7528\u53CA\u8F6C\u6458\u3002')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(8);__webpack_require__(4);__webpack_require__(60);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(213);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){var columns=[{dataIndex:'name',key:'name',render:function render(text){return _react2.default.createElement('div',{style:{padding:"10px",textAlign:'center'},dangerouslySetInnerHTML:{__html:text}});}},{dataIndex:'desc',key:'desc',render:function render(text){return _react2.default.createElement('div',{style:{padding:"10px",textAlign:'center'},dangerouslySetInnerHTML:{__html:text}});}}];return _react2.default.createElement('div',{className:'derformanceDes'},_react2.default.createElement('div',{className:'title'},'1.3.1 Breakdown Statistics Data \u7EDF\u8BA1\u6570\u636E\u5F52\u96C6\u4F9D\u636E'),_react2.default.createElement('div',{className:'text_center'},_react2.default.createElement('div',null,'Average Industry Performance Data Source: China Hotel Industry Study 2021 & Statistical Communique of The People\'s Republic of China on the 2022 Q1 Star Hotel'),_react2.default.createElement('div',null,'\u884C\u4E1A\u6570\u636E\u6765\u6E90 \u300A2021\u5E74\u4E2D\u56FD\u996D\u5E97\u4E1A\u7EDF\u8BA1\uFF082020\u8D22\u653F\u5E74\u5EA6\uFF09\u300B\uFF08\u6D69\u534E\u7BA1\u7406\u987E\u95EE\u516C\u53F8\uFF09\u548C\u300A2022\u5E74\u7B2C\u4E00\u5B63\u5EA6\u5168\u56FD\u661F\u7EA7\u996D\u5E97\u7EDF\u8BA1\u516C\u62A5\u300B\uFF08\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u6587\u5316\u548C\u65C5\u6E38\u90E8\u5E02\u573A\u7BA1\u7406\u53F8\uFF09')),_react2.default.createElement(_row2.default,{className:'table_title'},_react2.default.createElement(_col2.default,{className:'align',span:24},'Average Area Performance Data  \u533A\u57DF\u5E73\u5747\u6570\u636E')),_react2.default.createElement(_row2.default,{gutter:56},_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement('div',{className:'table_border'},_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:24},'Southeastern & Southern China \u4E1C\u5357\u534E\u5357')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6D77\u5357\u9F99\u6C90\u6E7E\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Hainan Longmu Bay ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6587\u660C\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Wenchang ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6885\u5DDE\u660C\u76DB\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Changsheng Plaza Meizhou')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6F33\u5DDE\u660E\u53D1\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Mingfa Zhangzhou')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u53A6\u95E8\u96C6\u7F8E\u6E56\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Jimei Lake Plaza Xiamen')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6D77\u53E3\u661F\u6D77\u6E7E\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO New Port Resort Haikou')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u53A6\u95E8\u79B9\u6D32\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Yuzhou Xiamen')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5E7F\u897F\u957F\u878D\u8C6A\u5B9C\u9152\u5E97 '),_react2.default.createElement(_col2.default,{span:12},'HOJO Life Changrong Guangxi')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5B89\u987A\u8C6A\u751F\u6E29\u6CC9\u5EA6\u5047\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Hot Spring Resort Anshun')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u9E70\u6F6D\u6C81\u5E90\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Qinlu Plaza Yingtan')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5E7F\u5DDE\u6843\u82B1\u6C5F\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Riverview Hotel Guangzhou')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6F84\u6D77\u56FD\u745E\u8C6A\u751F\u9152\u5E97 '),_react2.default.createElement(_col2.default,{span:12},'HOJO Glory Hotel Chenghai')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u8D35\u5DDE\u5929\u6021\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Plaza Guiyang')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u60E0\u5DDE\u53CC\u6708\u6E7E\u6A80\u60A6\u8C6A\u751F\u6E29\u6CC9\u5EA6\u5047\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Shuangyue Bay Huizhou')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E09\u4E9A\u56FD\u5149\u8C6A\u751F\u5EA6\u5047\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Resort Sanya Bay')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5357\u5B81\u4F1A\u5C55\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO CAEXPO Plaza NanNing')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4F59\u5E86\u7B2C\u4E09\u5730\u8C6A\u5B9C\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Life Parkview Yuqing')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u8D35\u5DDE\u745E\u8302\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Ruimao Guizhou')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u53A6\u95E8\u6D77\u65C5\u6E29\u5FB7\u59C6\u81F3\u5C0A\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WG Xiamen Haicang')),_react2.default.createElement(_row2.default,{className:'bg_w',style:{border:'none'}},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u8D35\u5DDE\u7FA4\u5347\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Qunsheng Plaza Guizhou')))),_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement('div',{className:'table_border'},_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:24},'Northern & Central China \u534E\u5317\u534E\u4E2D')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u957F\u6C99\u8299\u84C9\u56FD\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Furongguo Changsha ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u957F\u6C99\u6E58\u6C5F\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Yacht Club Hotel Changsha')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5927\u8FDE\u767E\u5E74\u6C47\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Parkland Hotel Dalian')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5A01\u6D77\u9999\u6D77\u8C6A\u751F\u5EA6\u5047\u9152\u5E97 '),_react2.default.createElement(_col2.default,{span:12},'HOJO Dream Sea Resort Weihai')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u90B5\u9633\u6E58\u6797\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Xianglin Shaoyang ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u90F4\u5DDE\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Chenzhou ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6C5F\u57CE\u660E\u73E0\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Pearl Plaza Wuhan')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5C71\u4E1C\u4E34\u6C82\u7FD4\u5B87\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Xiangyu Plaza Linyi')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u8425\u53E3\u4E94\u77FF\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Minmetals Plaza Yingkou')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6C88\u9633\u9526\u8054\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Jinlian Business Club Shenyang')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u897F\u5B89\u91D1\u82B1\u8C6A\u751F\u56FD\u9645\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Ginwa Plaza Xi\'an')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u9752\u5C9B\u5EB7\u5927\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Plaza Kangda Qingda')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5C71\u4E1C\u4E34\u6C82\u7FD4\u5B87\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Xiangyu Plaza Linyi')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u9102\u5C14\u591A\u65AF\u535A\u6E90\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Parkview Plaza Erdos')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5317\u4EAC\u5B9D\u8FB0\u996D\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Paragon Hotel Beijing')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E4C\u5170\u5BDF\u5E03\u591A\u8499\u5FB7\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Plaza Wulanchabu')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u957F\u6C99\u534E\u6668\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Huachen Plaza Changsha')),_react2.default.createElement(_row2.default,{className:'bg_w',style:{border:'none'}},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u682A\u6D32\u9AD8\u79D1\u8C6A\u5B9C\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Geckor Zhuzhou'))))),_react2.default.createElement(_row2.default,{gutter:56,style:{marginTop:40}},_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement('div',{className:'table_border'},_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:24},'Jiangsu, Zhejiang, Shanghai & Anhui \u6C5F\u6D59\u6CAA\u7696')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E0A\u6D77\u8679\u6865\u91D1\u53E4\u6E90\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Hongqiao Airport Hotel SH')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5357\u4EAC\u5367\u9F99\u6E56\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5EA6\u5047\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Lake Crouching Dragon Resort Nanjing')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5B81\u6CE2\u534E\u4FA8\u8C6A\u751F\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Ningbo')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u676D\u5DDE\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Hangzhou')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u868C\u57E0\u5357\u5C71\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Nanshan Plaza Bengbu')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u961C\u9633\u5B9D\u9F99\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Baolong Fuyang')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5B89\u5409\u51EF\u627F\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Kaicheng Anji')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u51EF\u8FEA\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Kaidi')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5408\u80A5\u4E24\u6DEE\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Tech Center Plaza Hefei')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5B81\u6CE2\u9038\u4E1C\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO IFC Plaza Ningbo')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6C5F\u9634\u957F\u665F\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Changsheng Jiangyin')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E0A\u6D77\u5174\u8363\u6E29\u5FB7\u59C6\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'Wyndham Bund East SH')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u961C\u9633\u5929\u7B51\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Tianzhu Plaza Fuyang')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E0A\u6D77\u5174\u8363\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u9152\u5E97 '),_react2.default.createElement(_col2.default,{span:12},'WGPR Oriental SH')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5B81\u6CE2\u5353\u8FDC\u8C6A\u5B9C\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Life Zhuoyuan Ningbo')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E0A\u6D77\u4E34\u6E2F\u8C6A\u751F\u5927\u9152\u5E97 '),_react2.default.createElement(_col2.default,{span:12},'HOJO Plaza Lingang SH')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5E90\u5C71\u5609\u8C6A\u6DEE\u6D77\u56FD\u9645\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Huaihai Resort Lushan')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5929\u76EE\u6E56\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Tian Mu Lake Plaza Liyang')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u9EC4\u5C71\u65B0\u534E\u8054\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Macrolink Plaza Huangshan')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5E38\u5DDE\u51EF\u7EB3\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Kaina Plaza Changzhou')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u82CF\u5DDE\u664B\u5408\u8C6A\u751F\u884C\u653F\u516C\u5BD3'),_react2.default.createElement(_col2.default,{span:12},'HOJO Jinhope Suzhou ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E0A\u6D77\u8D22\u5927\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Caida Plaza SH')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u7ECD\u5174\u4E2D\u91D1\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Business Club Hotel Shaoxing')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E0A\u6D77\u5609\u8C6A\u6DEE\u6D77\u56FD\u9645\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Huaihai Hotel SH')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5B81\u6CE2\u77F3\u6D66\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Shipu Plaza Ningbo')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5B81\u6CE2\u534E\u4FA8\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Plaza Ningbo')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5B81\u6CE2\u9633\u5149\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Sunshine Plaza Ningbo')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u8BF8\u66A8\u540C\u65B9\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Tongfang Plaza Zhuji')),_react2.default.createElement(_row2.default,{className:'bg_w',style:{border:'none'}},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E0A\u6D77\u4E3D\u6602\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Leonora Plaza Shanghai')))),_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement('div',{className:'table_border'},_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:24},'Southwestern China \u897F\u5357')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6210\u90FD\u5C71\u666F\u8C6A\u5B9C\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Life Mountain View CD ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u91CD\u5E86\u79C0\u5C71\u8C6A\u751F\u5E7F\u573A\u56FD\u9645\u9152\u5E97 '),_react2.default.createElement(_col2.default,{span:12},'HOJO Xiushan Plaza CQ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u91CD\u5E86\u6E1D\u878D\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Yurong Hotel CQ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E3D\u6C5F\u91D1\u6797\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Jinling Plaza Lijiang')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u91CD\u5E86\u666E\u60E0\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Puhui Plaza CQ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u91CD\u5E86\u9526\u6021\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Jinyi Hotel CQ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u8D44\u9633\u9F0E\u665F\u6CD3\u5E9C\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO New District Plaza Ziyang')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6606\u660E\u5357\u4E9A\u98CE\u60C5\u56ED\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Tropical Garden Plaza Kunming')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6210\u90FD\u5929\u4E4B\u5E9C\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Palace CD')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6210\u90FD\u96C5\u5C45\u4E50\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Agile Plaza CD')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6210\u90FD\u9AD8\u65B0\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Hi-Tech Plaza CD')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u91CD\u5E86\u534E\u5B87\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Huayu CQ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6606\u660E\u4E03\u5F69\u4E91\u5357\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Colorful Yunnan Kunming')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6210\u90FD\u9752\u57CE\u8C6A\u751F\u56FD\u9645\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Conference Resort CD')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u91CD\u5E86\u5929\u559C\u8C6A\u751F\u5927\u9152\u5E97 '),_react2.default.createElement(_col2.default,{span:12},'HOJO Tianxi Plaza Chongqing')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6606\u660E\u82B1\u4E4B\u57CE\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO City of Flower Hotel Kunming ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u91CD\u5E86\u73E0\u6C5F\u8C6A\u751F\u5927\u9152\u5E97 '),_react2.default.createElement(_col2.default,{span:12},'HOJO Zhujiang Plaza ChongQing')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6210\u90FD\u5C0A\u60A6\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Zunyue Hotel CD')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E5D\u5BE8\u6C9F\u5929\u6E90\u8C6A\u751F\u5EA6\u5047\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Tianyuan Resort Jiuzhaigou')),_react2.default.createElement(_row2.default,{className:'bg_w',style:{border:'none'}},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u621B\u6D12\u5916\u6EE9\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'Howard Johnson The Bund Hotel Gasa'))))),_react2.default.createElement('div',{className:'title_2'},'1.3.2 Revenue Range (RMB) \u6536\u5165\u533A\u95F4 \uFF08\u5355\u4F4D\uFF1A\u5143\uFF09'),_react2.default.createElement('div',{className:'table_border table7_1_1',style:{width:500}},_react2.default.createElement(_table2.default,{columns:columns,dataSource:[{name:"<1 Million <1000万",desc:"40-65 Million 4000-6500万"},{name:"10-20 Million 1000-2000万",desc:"65-100 Million 6500-10000万"},{name:"20-30 Million 2000-3000万",desc:">100 Million 1亿以上"},{name:"30-40 Million 3000-4000万",desc:""}],pagination:false,showHeader:false,size:'middle',bordered:true,className:'content'})),_react2.default.createElement('div',{className:'title_2'},'1.3.3 Definition of Terms \u672F\u8BED\u89E3\u91CA'),_react2.default.createElement('div',{className:'table_border'},_react2.default.createElement(_row2.default,{className:'definition_row_top'},_react2.default.createElement(_col2.default,{span:5,className:'left'}),_react2.default.createElement(_col2.default,{span:8,className:'left'},_react2.default.createElement(_row2.default,{className:'definition_title'},'Average Area Performance Data',_react2.default.createElement('br',null),'\u533A\u57DF\u5E73\u5747\u6570\u636E'),_react2.default.createElement(_row2.default,{className:'definition_title',style:{border:'none'}},'\u653E\u7F6E\u533A\u57DF\u540D\u79F0')),_react2.default.createElement(_col2.default,{span:8,className:'left'},_react2.default.createElement(_row2.default,{className:'definition_title'},'Revenue Range',_react2.default.createElement('br',null),'\u6536\u5165\u533A\u95F4'),_react2.default.createElement(_row2.default,{className:'definition_title',style:{border:'none'}},'\u653E\u7F6E\u6536\u5165\u533A\u95F4\u540D\u79F0')),_react2.default.createElement(_col2.default,{className:'definition_title',span:3},'Hotel Performance Data',_react2.default.createElement('br',null),'\u672C\u9152\u5E97\u6570\u636E')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:5,className:'left'},'Rooms Revenue % \u5BA2\u623F\u6536\u5165\u5360\u6BD4'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u5BA2\u623F\u6536\u5165\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u603B\u6536\u5165\uFF09'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u5BA2\u623F\u6536\u5165\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u603B\u6536\u5165\uFF09'),_react2.default.createElement(_col2.default,{span:3},' = \uFF08ES1.1 MTD/YTD \u5B9E\u9645\u5BA2\u623F\u6536\u5165\uFF09/\uFF08ES1.1 MTD/YTD \u5B9E\u9645\u603B\u6536\u5165\uFF09')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:5,className:'left'},'F&B Revenue % \u9910\u996E\u6536\u5165\u5360\u6BD4'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u9910\u996E\u6536\u5165\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u603B\u6536\u5165\uFF09'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u9910\u996E\u6536\u5165\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u603B\u6536\u5165\uFF09'),_react2.default.createElement(_col2.default,{span:3},' = \uFF08ES1.1 MTD/YTD \u5B9E\u9645\u9910\u996E\u6536\u5165\uFF09/\uFF08ES1.1 MTD/YTD \u5B9E\u9645\u603B\u6536\u5165\uFF09')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:5,className:'left'},'Other Revenue % \u5176\u4ED6\u90E8\u95E8\u6536\u5165\u5360\u6BD4'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u5176\u4ED6\u90E8\u95E8\u6536\u5165\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u603B\u6536\u5165\uFF09'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u5176\u4ED6\u90E8\u95E8\u6536\u5165\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u603B\u6536\u5165\uFF09'),_react2.default.createElement(_col2.default,{span:3},' = \uFF08ES1.1 MTD/YTD \u5B9E\u9645\u5176\u4ED6\u90E8\u95E8\u6536\u5165\uFF09/\uFF08ES1.1 MTD/YTD \u5B9E\u9645\u603B\u6536\u5165\uFF09')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:5,className:'left'},'Rooms Dept Profit % \u5BA2\u623F\u90E8\u95E8\u5229\u6DA6\u7387'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u5BA2\u623F\u90E8\u95E8\u5229\u6DA6\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u5BA2\u623F\u6536\u5165\uFF09'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u5BA2\u623F\u90E8\u95E8\u5229\u6DA6\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u5BA2\u623F\u6536\u5165\uFF09'),_react2.default.createElement(_col2.default,{span:3},' = ES1.1 MTD/YTD \u5B9E\u9645\u5BA2\u623F\u90E8\u95E8\u5229\u6DA6\u7387')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:5,className:'left'},'F&B Dept Profit % \u9910\u996E\u90E8\u95E8\u5229\u6DA6\u7387'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u9910\u996E\u90E8\u95E8\u5229\u6DA6\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u9910\u996E\u6536\u5165\uFF09'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u9910\u996E\u90E8\u95E8\u5229\u6DA6\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u9910\u996E\u6536\u5165\uFF09'),_react2.default.createElement(_col2.default,{span:3},' = ES1.1 MTD/YTD \u5B9E\u9645\u9910\u996E\u90E8\u95E8\u5229\u6DA6\u7387')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:5,className:'left'},'F&B Cost % \u9910\u996E\u6210\u672C\u7387'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u98DF\u54C1\u53CA\u996E\u54C1\u6210\u672C\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u9910\u996E\u6536\u5165\uFF09'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u98DF\u54C1\u53CA\u996E\u54C1\u6210\u672C\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u9910\u996E\u6536\u5165\uFF09'),_react2.default.createElement(_col2.default,{span:3},' = ES1.1 MTD/YTD \u5B9E\u9645\u98DF\u54C1\u6210\u672C\u7387')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:5,className:'left'},'Other Expense and Cost % \u5176\u4ED6\u8D39\u7528\u53CA\u6210\u672C\u7387'),_react2.default.createElement(_col2.default,{span:8,className:'left'},'  = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD \u5B9E\u9645\u5176\u4ED6\u8D39\u7528\u53CA\u6210\u672C\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD \u5B9E\u9645\u603B\u6536\u5165\uFF09'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD \u5B9E\u9645\u5176\u4ED6\u8D39\u7528\u53CA\u6210\u672C\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD \u5B9E\u9645\u603B\u6536\u5165\uFF09'),_react2.default.createElement(_col2.default,{span:3},' = ES1.1 MTD/YTD \u5B9E\u9645\u5176\u4ED6\u8D39\u7528\u53CA\u6210\u672C\u7387')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:5,className:'left'},'Coffee Shop Cost % \u5496\u5561\u5385\u6210\u672C\u7387'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.1 MTD/YTD Coffee Shop \u6210\u672C\u91D1\u989D\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.1 MTD/YTD Coffee Shop \u6536\u76CA\uFF09'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.1 MTD/YTD Coffee Shop \u6210\u672C\u91D1\u989D\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.3 MTD/YTD Coffee Shop \u6536\u76CA\uFF09'),_react2.default.createElement(_col2.default,{span:3},' = ES5.1.1 MTD/YTD  \u6210\u672C\u767E\u5206\u6BD4')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:5,className:'left'},'Coffee Shop Revenue % \u5496\u5561\u5385\u6536\u5165\u5360\u6BD4'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.1 MTD/YTD Coffee Shop \u6536\u76CA\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.1 MTD/YTD \u9910\u5385\u5408\u8BA1\u6536\u76CA\uFF09'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.1 MTD/YTD Coffee Shop \u6536\u76CA\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.3 MTD/YTD \u9910\u5385\u5408\u8BA1\u6536\u76CA\uFF09'),_react2.default.createElement(_col2.default,{span:3},' = ES5.1.1 MTD/YTD   \u6536\u5165\u4EFD\u989D')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:5,className:'left'},'Chinese Restaurant Cost % \u4E2D\u9910\u5385\u6210\u672C\u7387'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.1 MTD/YTD Chinese Restaurant \u6210\u672C\u91D1\u989D\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.1 MTD/YTD Chinese Restaurant \u6536\u76CA\uFF09'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.1 MTD/YTD Chinese Restaurant \u6210\u672C\u91D1\u989D\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.3 MTD/YTD Chinese Restaurant \u6536\u76CA\uFF09'),_react2.default.createElement(_col2.default,{span:3},' = ES5.1.1 MTD/YTD   \u6210\u672C\u767E\u5206\u6BD4')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:5,className:'left'},'Chinese Restaurant Revenue % \u4E2D\u9910\u5385\u6536\u5165\u5360\u6BD4'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.1 MTD/YTD Chinese Restaurant \u6536\u76CA\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.1 MTD/YTD \u9910\u5385\u5408\u8BA1\u6536\u76CA\uFF09'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.1 MTD/YTD Chinese Restaurant \u6536\u76CA\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.3 MTD/YTD \u9910\u5385\u5408\u8BA1\u6536\u76CA\uFF09'),_react2.default.createElement(_col2.default,{span:3},' = ES5.1.1 MTD/YTD   \u6536\u5165\u4EFD\u989D')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:5,className:'left'},'Banquet Cost % \u5BB4\u4F1A\u6210\u672C\u7387'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.1 MTD/YTD Banquet\u6210\u672C\u91D1\u989D\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.1 MTD/YTD Banquet\u6536\u76CA\uFF09'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.1 MTD/YTD Banquet\u6210\u672C\u91D1\u989D\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.3 MTD/YTD Banquet\u6536\u76CA\uFF09'),_react2.default.createElement(_col2.default,{span:3},' = ES5.1.1 MTD/YTD   \u4F1A\u8BAE\u573A\u5730\u8BBE\u65BD\u6536\u5165\u6210\u672C\u767E\u5206\u6BD4')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:5,className:'left'},'Banquet Revenue % \u5BB4\u4F1A\u6536\u5165\u5360\u6BD4'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.1 MTD/YTD Banquet\u6536\u76CA\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.1 MTD/YTD \u9910\u5385\u5408\u8BA1\u6536\u76CA\uFF09'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.1 MTD/YTD Banquet\u6536\u76CA\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES5.1.3 MTD/YTD \u9910\u5385\u5408\u8BA1\u6536\u76CA\uFF09'),_react2.default.createElement(_col2.default,{span:3},' = ES5.1.1 MTD/YTD   \u4F1A\u8BAE\u573A\u5730\u8BBE\u65BD\u6536\u5165\u6536\u5165\u4EFD\u989D')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:5,className:'left'},'Labor Cost % \u4EBA\u529B\u6210\u672C\u7387'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u4EBA\u529B\u8D44\u6E90\u603B\u8D39\u7528/\u85AA\u916C\u53CA\u76F8\u5173\u798F\u5229\u603B\u8D39\u7528\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD\u5B9E\u9645\u603B\u6536\u5165\uFF09'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u4EBA\u529B\u8D44\u6E90\u603B\u8D39\u7528/\u85AA\u916C\u53CA\u76F8\u5173\u798F\u5229\u603B\u8D39\u7528\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD\u5B9E\u9645\u603B\u6536\u5165\uFF09'),_react2.default.createElement(_col2.default,{span:3},' = ES1.1 MTD/YTD \u5B9E\u9645\u4EBA\u529B\u8D44\u6E90\u603B\u8D39\u7528\u7387/\u4EBA\u529B\u6210\u672C\u7387')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:5,className:'left'},'Utility Cost % \u80FD\u6E90\u6210\u672C\u7387'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u80FD\u6E90\u6210\u672C\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD\u5B9E\u9645\u603B\u6536\u5165\uFF09'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD \u5B9E\u9645\u80FD\u6E90\u6210\u672C\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709\u9152\u5E97ES1.1 MTD/YTD\u5B9E\u9645\u603B\u6536\u5165\uFF09'),_react2.default.createElement(_col2.default,{span:3},' = ES1.1 MTD/YTD \u5B9E\u9645\u80FD\u6E90\u6210\u672C\u7387')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:5,className:'left'},'Top 15 Vs. Total Purchase \u524D15\u4F4D\u91C7\u8D2D\u5360\u603B\u989D\u6BD4\u7387'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709ES9.8.1 MTD/YTD \u524D15\u4F4D\u5408\u8BA1 \u91C7\u8D2D\u603B\u91D1\u989D\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709ES9.8.1 MTD/YTD \u98DF\u54C1\u91C7\u8D2D\u603B\u989D \u91C7\u8D2D\u603B\u91D1\u989D\uFF09'),_react2.default.createElement(_col2.default,{span:8,className:'left'},' = \uFF08\u533A\u57DF\u5185\u6240\u6709ES9.8.1 MTD/YTD \u524D15\u4F4D\u5408\u8BA1 \u91C7\u8D2D\u603B\u91D1\u989D\uFF09/\uFF08\u533A\u57DF\u5185\u6240\u6709ES9.8.2 MTD/YTD \u98DF\u54C1\u91C7\u8D2D\u603B\u989D \u91C7\u8D2D\u603B\u91D1\u989D\uFF09'),_react2.default.createElement(_col2.default,{span:3},' = ES9.8.1 Top 15 Vs. Total Purchase \u524D15\u4F4D\u91C7\u8D2D\u5360\u603B\u989D\u6BD4\u7387'))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(4);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(312);__webpack_require__(213);var _revenue=__webpack_require__(2132);var _revenue2=_interopRequireDefault(_revenue);var _purchase=__webpack_require__(2133);var _purchase2=_interopRequireDefault(_purchase);var _room=__webpack_require__(2134);var _room2=_interopRequireDefault(_room);var _food=__webpack_require__(2135);var _food2=_interopRequireDefault(_food);var _human=__webpack_require__(2136);var _human2=_interopRequireDefault(_human);var _energy=__webpack_require__(2137);var _energy2=_interopRequireDefault(_energy);var _foodBeverage=__webpack_require__(2138);var _foodBeverage2=_interopRequireDefault(_foodBeverage);var _other=__webpack_require__(2139);var _other2=_interopRequireDefault(_other);var _RestaurantIncome=__webpack_require__(2140);var _RestaurantIncome2=_interopRequireDefault(_RestaurantIncome);var _RestaurantCost=__webpack_require__(2141);var _RestaurantCost2=_interopRequireDefault(_RestaurantCost);var _mobx=__webpack_require__(30);var _getJson=__webpack_require__(252);var _getJson2=_interopRequireDefault(_getJson);var _MTD=__webpack_require__(710);var _MTD2=_interopRequireDefault(_MTD);var _=__webpack_require__(2142);var _2=_interopRequireDefault(_);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_ComponentData){_inherits(index,_ComponentData);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"componentDidMount",value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var _this2=this;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.getData(this.props.store.analysis.date).then(function(x){var timer=setTimeout(function(){_this2.props.store.analysis.getData();clearTimeout(timer);},500);});window.addEventListener('resize',function(){if(window.location.hash==='#/table/analysisChart'){_this2.props.store.analysis.onResize();}});case 2:case"end":return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:"render",value:function render(){var _this3=this;var _props$store$analysis=this.props.store.analysis,loading=_props$store$analysis.loading,date=_props$store$analysis.date,getData=_props$store$analysis.getData,data=_props$store$analysis.data;var style={marginLeft:10,color:"#195A95"};return _react2.default.createElement(_spin2.default,{tip:"\u52A0\u8F7D\u4E2D...",spinning:loading},_react2.default.createElement(_2.default,null),_react2.default.createElement("div",{className:"analysisChart",id:"analysisChart"},_react2.default.createElement(_row2.default,null,_react2.default.createElement(_row2.default,{className:"table-title"},"1.2.2 Monthly Visual Diagram \u6708\u5EA6\u53EF\u89C6\u5316\u56FE\u8868 "),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(date,"YYYY-MM"),format:"YYYY-MM",onChange:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(date,str){return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:(0,_mobx.runInAction)(function(){_this3.props.store.analysis.date=str;_this3.props.store.analysis.loading=true;});_this3.getData(str).then(function(x){var timer=setTimeout(function(){getData();clearTimeout(timer);},700);});case 2:case"end":return _context2.stop();}}},_callee2,_this3);}));return function(_x,_x2){return _ref2.apply(this,arguments);};}()}),_react2.default.createElement("span",{style:style},"\u533A\u57DF : ",(0,_getJson2.default)(['hotel','area'],data,"")," "),_react2.default.createElement("span",{style:style},"\u6536\u5165\u533A\u95F4 : ",_data.intervalData[(0,_getJson2.default)(['hotel','income_interval'],data,"")]," "))),_react2.default.createElement("div",{className:"list"},_react2.default.createElement(_revenue2.default,null),_react2.default.createElement(_purchase2.default,null),_react2.default.createElement(_room2.default,null),_react2.default.createElement(_food2.default,null),_react2.default.createElement(_human2.default,null),_react2.default.createElement(_foodBeverage2.default,null),_react2.default.createElement(_energy2.default,null),_react2.default.createElement(_other2.default,null),_react2.default.createElement(_RestaurantIncome2.default,null),_react2.default.createElement(_RestaurantCost2.default,null))));}}]);return index;}(_MTD2.default))||_class)||_class);exports.default=index;

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(126);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"theChart"},_react2.default.createElement(_row2.default,{className:"title"},"Revenue % \u6536\u5165\u5360\u6BD4"),_react2.default.createElement(_row2.default,null,_react2.default.createElement("div",{id:"revenue",style:{height:420,width:'100%'}})));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(126);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"theChart"},_react2.default.createElement(_row2.default,{className:"title"},"Top 15 Vs. Total Purchase \u524D15\u4F4D\u91C7\u8D2D\u5360\u603B\u989D\u6BD4"),_react2.default.createElement(_row2.default,null,_react2.default.createElement("div",{id:"purchase",style:{height:400,width:'100%'}})));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(126);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"theChart"},"Rooms Dept Profit %  \u5BA2\u623F\u90E8\u95E8\u5229\u6DA6\u7387",_react2.default.createElement("div",{id:"room",style:{height:400,width:'100%'}}));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(126);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"theChart"},"F&B Dept Profit %  \u9910\u996E\u90E8\u95E8\u5229\u6DA6\u7387",_react2.default.createElement("div",{id:"food",style:{height:400,width:'100%'}}));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _method=__webpack_require__(20);var _method2=_interopRequireDefault(_method);__webpack_require__(126);var _=__webpack_require__(711);var _2=_interopRequireDefault(_);var _3=__webpack_require__(712);var _4=_interopRequireDefault(_3);var _5=__webpack_require__(713);var _6=_interopRequireDefault(_5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){var data=this.props.store.analysis.data;return _react2.default.createElement('div',{className:'theChart'},_react2.default.createElement('div',null,'Labor Cost %  \u4EBA\u529B\u6210\u672C\u7387'),_react2.default.createElement('div',{className:'other'},_react2.default.createElement('div',{className:'canvas-item'},_react2.default.createElement('img',{src:_2.default,alt:''}),_react2.default.createElement('span',{className:'text-p'},'  ',((0,_method2.default)([12,'area'],data.mtd)*100).toFixed(3),'%'),_react2.default.createElement('div',null,_react2.default.createElement('span',null,'Area Data '),_react2.default.createElement('span',null,'\u533A\u57DF\u6570\u636E'))),_react2.default.createElement('div',{className:'canvas-item'},_react2.default.createElement('img',{src:_4.default,alt:''}),_react2.default.createElement('span',{className:'text-p'},'  ',((0,_method2.default)([12,'interval'],data.mtd)*100).toFixed(3),'%'),_react2.default.createElement('div',null,_react2.default.createElement('span',null,'Revenue Range Data '),_react2.default.createElement('span',null,'\u6536\u5165\u533A\u95F4\u6570\u636E'))),_react2.default.createElement('div',{className:'canvas-item'},_react2.default.createElement('img',{src:_6.default,alt:''}),_react2.default.createElement('span',{className:'text-p'},'  ',((0,_method2.default)([12,'hotel'],data.mtd)*100).toFixed(3),'%'),_react2.default.createElement('div',null,_react2.default.createElement('span',null,'Hotel Data '),_react2.default.createElement('span',null,'\u9152\u5E97\u6570\u636E')))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _method=__webpack_require__(20);var _method2=_interopRequireDefault(_method);__webpack_require__(126);var _=__webpack_require__(714);var _2=_interopRequireDefault(_);var _3=__webpack_require__(715);var _4=_interopRequireDefault(_3);var _5=__webpack_require__(716);var _6=_interopRequireDefault(_5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){var data=this.props.store.analysis.data;return _react2.default.createElement('div',{className:'theChart'},_react2.default.createElement('div',null,'Utility Cost %  \u80FD\u6E90\u6210\u672C\u7387'),_react2.default.createElement('div',{className:'other'},_react2.default.createElement('div',{className:'canvas-item'},_react2.default.createElement('img',{src:_2.default,alt:''}),_react2.default.createElement('span',{className:'text-p'},((0,_method2.default)([13,'area'],data.mtd)*100).toFixed(3),'%'),_react2.default.createElement('div',null,_react2.default.createElement('span',null,'Area Data '),_react2.default.createElement('span',null,'\u533A\u57DF\u6570\u636E'))),_react2.default.createElement('div',{className:'canvas-item'},_react2.default.createElement('img',{src:_4.default,alt:''}),_react2.default.createElement('span',{className:'text-p'},((0,_method2.default)([13,'interval'],data.mtd)*100).toFixed(3),'%'),_react2.default.createElement('div',null,_react2.default.createElement('span',null,'Revenue Range Data '),_react2.default.createElement('span',null,'\u6536\u5165\u533A\u95F4\u6570\u636E'))),_react2.default.createElement('div',{className:'canvas-item'},_react2.default.createElement('img',{src:_6.default,alt:''}),_react2.default.createElement('span',{className:'text-p'},((0,_method2.default)([13,'hotel'],data.mtd)*100).toFixed(3),'%'),_react2.default.createElement('div',null,_react2.default.createElement('span',null,'Hotel Data '),_react2.default.createElement('span',null,'\u9152\u5E97\u6570\u636E')))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _method=__webpack_require__(20);var _method2=_interopRequireDefault(_method);__webpack_require__(126);var _=__webpack_require__(714);var _2=_interopRequireDefault(_);var _3=__webpack_require__(715);var _4=_interopRequireDefault(_3);var _5=__webpack_require__(716);var _6=_interopRequireDefault(_5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){var data=this.props.store.analysis.data;return _react2.default.createElement('div',{className:'theChart'},_react2.default.createElement('div',null,'F&B Cost %  \u9910\u996E\u6210\u672C\u7387'),_react2.default.createElement('div',{className:'other'},_react2.default.createElement('div',{className:'canvas-item'},_react2.default.createElement('img',{src:_2.default,alt:''}),_react2.default.createElement('span',{className:'text-p'},((0,_method2.default)([5,'area'],data.mtd)*100).toFixed(3),'%'),_react2.default.createElement('div',null,_react2.default.createElement('span',null,'Area Data '),_react2.default.createElement('span',null,'\u533A\u57DF\u6570\u636E'))),_react2.default.createElement('div',{className:'canvas-item'},_react2.default.createElement('img',{src:_4.default,alt:''}),_react2.default.createElement('span',{className:'text-p'},((0,_method2.default)([5,'interval'],data.mtd)*100).toFixed(3),'%'),_react2.default.createElement('div',null,_react2.default.createElement('span',null,'Revenue Range Data '),_react2.default.createElement('span',null,'\u6536\u5165\u533A\u95F4\u6570\u636E'))),_react2.default.createElement('div',{className:'canvas-item'},_react2.default.createElement('img',{src:_6.default,alt:''}),_react2.default.createElement('span',{className:'text-p'},((0,_method2.default)([5,'hotel'],data.mtd)*100).toFixed(3),'%'),_react2.default.createElement('div',null,_react2.default.createElement('span',null,'Hotel Data '),_react2.default.createElement('span',null,'\u9152\u5E97\u6570\u636E')))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _method=__webpack_require__(20);var _method2=_interopRequireDefault(_method);__webpack_require__(126);var _=__webpack_require__(711);var _2=_interopRequireDefault(_);var _3=__webpack_require__(712);var _4=_interopRequireDefault(_3);var _5=__webpack_require__(713);var _6=_interopRequireDefault(_5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){var data=this.props.store.analysis.data;return _react2.default.createElement('div',{className:'theChart'},_react2.default.createElement('div',null,'Other Cost %  \u5176\u4ED6\u6210\u672C\u7387'),_react2.default.createElement('div',{className:'other'},_react2.default.createElement('div',{className:'canvas-item'},_react2.default.createElement('img',{src:_2.default,alt:''}),_react2.default.createElement('span',{className:'text-p'},((0,_method2.default)([14,'area'],data.mtd)*100).toFixed(3),'%'),_react2.default.createElement('div',null,_react2.default.createElement('span',null,'Area Data '),_react2.default.createElement('span',null,'\u533A\u57DF\u6570\u636E'))),_react2.default.createElement('div',{className:'canvas-item'},_react2.default.createElement('img',{src:_4.default,alt:''}),_react2.default.createElement('span',{className:'text-p'},((0,_method2.default)([14,'interval'],data.mtd)*100).toFixed(3),'%'),_react2.default.createElement('div',null,_react2.default.createElement('span',null,'Revenue Range Data '),_react2.default.createElement('span',null,'\u6536\u5165\u533A\u95F4\u6570\u636E'))),_react2.default.createElement('div',{className:'canvas-item'},_react2.default.createElement('img',{src:_6.default,alt:''}),_react2.default.createElement('span',{className:'text-p'},((0,_method2.default)([14,'hotel'],data.mtd)*100).toFixed(3),'%'),_react2.default.createElement('div',null,_react2.default.createElement('span',null,'Hotel Data '),_react2.default.createElement('span',null,'\u9152\u5E97\u6570\u636E')))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(126);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"theChart"},"\u5404\u9910\u5385\u6536\u5165\u5360\u6BD4 Restaurant Revenue %",_react2.default.createElement("div",{id:"RestaurantIncome",style:{height:400,width:'100%'}}));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(126);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"theChart"},"\u5404\u9910\u5385\u9910\u996E\u6210\u672C\u7387 Restaurant F&B Cost %",_react2.default.createElement("div",{id:"RestaurantCost",style:{height:400,width:'100%'}}));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _icon=__webpack_require__(38);var _icon2=_interopRequireDefault(_icon);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(75);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _compute=__webpack_require__(2143);var _compute2=_interopRequireDefault(_compute);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);__webpack_require__(2144);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().subtract(1,'days').format('YYYY-MM-DD'),dataAll:[],year:1,value:"OCC",loading:true},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var year,month,day,res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;year=(0,_moment2.default)(date).format('YYYY');month=(0,_moment2.default)(date).format('M');day=(0,_moment2.default)(date).format('D');_context.next=6;return(0,_request2.default)('/data/visualization?year='+year+'&month='+month+'&day='+day);case 6:res=_context.sent;_this.setState({loading:false,dataAll:(0,_compute2.default)(res.data||{},day)},function(){_this.onChange(_this.state.value,_this.state.year);});_context.next=14;break;case 10:_context.prev=10;_context.t0=_context['catch'](0);console.log(_context.t0,'数据加载错误！');_this.setState({loading:false});case 14:case'end':return _context.stop();}}},_callee,_this2,[[0,10]]);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.onChange=function(value,year){_this.setState({value:value,year:year});var _this$state=_this.state,date=_this$state.date,dataAll=_this$state.dataAll;var month=(0,_moment2.default)(date).format('M');var day=(0,_moment2.default)(date).format('D');var name={"OCC":'occ',"ADR":'adr',"RevPAR":'revpar',"客房收入":'roomrev',"餐饮收入":'fb',"总收入":'total'};(0,_compute.setKarte)({title:value,day:day,month:month,type:value=='OCC'?'percent':'',dataY:[{name:"酒店",data:(year==1?dataAll.data:dataAll.last).map(function(x){return x[name[value]];})},{name:"区域",data:(year==1?dataAll.area:dataAll.arealast).map(function(x){return x[name[value]];})},{name:"收入区间",data:(year==1?dataAll.interval:dataAll.intervallast).map(function(x){return x[name[value]];})}]});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData(this.state.date);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,date=_state.date,year=_state.year,loading=_state.loading,value=_state.value,_state$dataAll=_state.dataAll,data=_state$dataAll.data,last=_state$dataAll.last;var day=(0,_moment2.default)(date).format('D');var _data=data;if(value==2)_data=last;return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'data-Visualization'},_react2.default.createElement('div',{className:'title'},'1.2 Data Visualization \u6570\u636E\u53EF\u89C6\u5316'),_react2.default.createElement('div',{className:'title'},'1.2.1 Daily Visual Diagram \u65E5\u6570\u636E\u53EF\u89C6\u5316\u56FE\u8868'),_react2.default.createElement('div',{className:'content'},_react2.default.createElement('div',{className:'item',onClick:function onClick(){return _this3.onChange("OCC",year);},style:{backgroundColor:_lodash2.default.get(_data,day-1+'.occ_g')<0?"#50B07A":"#E37646"}},_react2.default.createElement('span',{className:'name'},'OCC'),_react2.default.createElement('span',{className:'num'},(_lodash2.default.get(_data,day-1+'.occ',0)*100).toFixed(1),'%'),_react2.default.createElement('span',{className:'data'},_react2.default.createElement('span',null,'\u8F83\u524D\u65E5\u540C\u65F6\u6BB5'),_react2.default.createElement('span',null,(_lodash2.default.get(_data,day-1+'.occ_g')*100||0).toFixed(1),'%',_lodash2.default.get(_data,day-1+'.occ_g')>0&&_react2.default.createElement(_icon2.default,{className:'up',type:'arrow-up'}),_lodash2.default.get(_data,day-1+'.occ_g')<0&&_react2.default.createElement(_icon2.default,{className:'down',type:'arrow-down'})))),_react2.default.createElement('div',{className:'item',onClick:function onClick(){return _this3.onChange("ADR",year);},style:{backgroundColor:_lodash2.default.get(_data,day-1+'.adr_g')<0?"#50B07A":"#E37646"}},_react2.default.createElement('span',{className:'name'},'ADR'),_react2.default.createElement('span',{className:'num'},(_lodash2.default.get(_data,day-1+'.adr',0)*1).toFixed(2)),_react2.default.createElement('span',{className:'data'},_react2.default.createElement('span',null,'\u8F83\u524D\u65E5\u540C\u65F6\u6BB5'),_react2.default.createElement('span',null,(_lodash2.default.get(_data,day-1+'.adr_g')*100||0).toFixed(1),'%',_lodash2.default.get(_data,day-1+'.adr_g')>0&&_react2.default.createElement(_icon2.default,{className:'up',type:'arrow-up'}),_lodash2.default.get(_data,day-1+'.adr_g')<0&&_react2.default.createElement(_icon2.default,{className:'down',type:'arrow-down'})))),_react2.default.createElement('div',{className:'item',style:{backgroundColor:_lodash2.default.get(_data,day-1+'.revpar_g')<0?"#50B07A":"#E37646"},onClick:function onClick(){return _this3.onChange("RevPAR",year);}},_react2.default.createElement('span',{className:'name'},'RevPAR'),_react2.default.createElement('span',{className:'num'},(_lodash2.default.get(_data,day-1+'.revpar',0)*1).toFixed(2)),_react2.default.createElement('span',{className:'data'},_react2.default.createElement('span',null,'\u8F83\u524D\u65E5\u540C\u65F6\u6BB5'),_react2.default.createElement('span',null,(_lodash2.default.get(_data,day-1+'.revpar_g')*100||0).toFixed(1),'%',_lodash2.default.get(_data,day-1+'.revpar_g')>0&&_react2.default.createElement(_icon2.default,{className:'up',type:'arrow-up'}),_lodash2.default.get(_data,day-1+'.revpar_g')<0&&_react2.default.createElement(_icon2.default,{className:'down',type:'arrow-down'})))),_react2.default.createElement('div',{className:'item',style:{backgroundColor:_lodash2.default.get(_data,day-1+'.roomrev_g')<0?"#50B07A":"#E37646"},onClick:function onClick(){return _this3.onChange("客房收入",year);}},_react2.default.createElement('span',{className:'name'},'\u5BA2\u623F\u6536\u5165'),_react2.default.createElement('span',{className:'num'},(_lodash2.default.get(_data,day-1+'.roomrev',0)*1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')),_react2.default.createElement('span',{className:'data'},_react2.default.createElement('span',null,'\u8F83\u524D\u65E5\u540C\u65F6\u6BB5'),_react2.default.createElement('span',null,(_lodash2.default.get(_data,day-1+'.roomrev_g')*100||0).toFixed(1),'%',_lodash2.default.get(_data,day-1+'.roomrev_g')>0&&_react2.default.createElement(_icon2.default,{className:'up',type:'arrow-up'}),_lodash2.default.get(_data,day-1+'.roomrev_g')<0&&_react2.default.createElement(_icon2.default,{className:'down',type:'arrow-down'})))),_react2.default.createElement('div',{className:'item',style:{backgroundColor:_lodash2.default.get(_data,day-1+'.fb_g')<0?"#50B07A":"#E37646"},onClick:function onClick(){return _this3.onChange("餐饮收入",year);}},_react2.default.createElement('span',{className:'name'},'\u9910\u996E\u6536\u5165'),_react2.default.createElement('span',{className:'num'},(_lodash2.default.get(_data,day-1+'.fb',0)*1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')),_react2.default.createElement('span',{className:'data'},_react2.default.createElement('span',null,'\u8F83\u524D\u65E5\u540C\u65F6\u6BB5'),_react2.default.createElement('span',null,(_lodash2.default.get(_data,day-1+'.fb_g')*100||0).toFixed(1),'%',_lodash2.default.get(_data,day-1+'.fb_g')>0&&_react2.default.createElement(_icon2.default,{className:'up',type:'arrow-up'}),_lodash2.default.get(_data,day-1+'.fb_g')<0&&_react2.default.createElement(_icon2.default,{className:'down',type:'arrow-down'})))),_react2.default.createElement('div',{className:'item',style:{backgroundColor:_lodash2.default.get(_data,day-1+'.total_g')<0?"#50B07A":"#E37646"},onClick:function onClick(){return _this3.onChange("总收入",year);}},_react2.default.createElement('span',{className:'name'},'\u603B\u6536\u5165'),_react2.default.createElement('span',{className:'num'},(_lodash2.default.get(_data,day-1+'.total',0)*1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')),_react2.default.createElement('span',{className:'data'},_react2.default.createElement('span',null,'\u8F83\u524D\u65E5\u540C\u65F6\u6BB5'),_react2.default.createElement('span',null,(_lodash2.default.get(_data,day-1+'.total_g')*100||0).toFixed(1),'%',_lodash2.default.get(_data,day-1+'.total_g')>0&&_react2.default.createElement(_icon2.default,{className:'up',type:'arrow-up'}),_lodash2.default.get(_data,day-1+'.total_g')<0&&_react2.default.createElement(_icon2.default,{className:'down',type:'arrow-down'}))))),_react2.default.createElement('div',{className:'selected'},_react2.default.createElement(_button2.default,{type:year==1?'primary':'',onClick:function onClick(){return _this3.onChange(value,1);}},'\u4ECA\u5E74'),_react2.default.createElement(_button2.default,{onClick:function onClick(){return _this3.onChange(value,2);},type:year==2?'primary':''},'\u53BB\u5E74')),_react2.default.createElement('div',{className:'chart-content'},_react2.default.createElement('div',{id:'chart'},' '))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setKarte=undefined;var _method=__webpack_require__(20);var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var color=['#00C6BD','#42585D','#FF605F'];exports.default=function(_ref,day){var _ref$data=_ref.data,data=_ref$data===undefined?[]:_ref$data,_ref$last=_ref.last,last=_ref$last===undefined?[]:_ref$last,_ref$area=_ref.area,area=_ref$area===undefined?[]:_ref$area,_ref$arealast=_ref.arealast,arealast=_ref$arealast===undefined?[]:_ref$arealast,_ref$interval=_ref.interval,interval=_ref$interval===undefined?[]:_ref$interval,_ref$intervallast=_ref.intervallast,intervallast=_ref$intervallast===undefined?[]:_ref$intervallast,_ref$areaLen=_ref.areaLen,areaLen=_ref$areaLen===undefined?1:_ref$areaLen,_ref$intervalLen=_ref.intervalLen,intervalLen=_ref$intervalLen===undefined?1:_ref$intervalLen;return{data:compute({data:data,day:day}),last:compute({data:last,day:day}),area:compute({data:area,day:day,length:areaLen}),arealast:compute({data:arealast,day:day,length:areaLen}),interval:compute({data:interval,day:day,length:intervalLen}),intervallast:compute({data:intervallast,day:day,length:intervalLen})};};function compute(_ref2){var data=_ref2.data,day=_ref2.day,length=_ref2.length;data.forEach(function(item,i){data[i].occ=(0,_method.calculation)(item.sold,item.ava,4);data[i].adr=(0,_method.calculation)(item.roomrev,item.sold,4);data[i].revpar=(data[i].occ*data[i].adr).toFixed(2);if(day-1==i&&day>1){data[i].occ_g=(0,_method.calculation)(data[i].occ-data[i-1].occ,data[i].occ,4);data[i].adr_g=(0,_method.calculation)(data[i].adr-data[i-1].adr,data[i].adr,4);data[i].revpar_g=(0,_method.calculation)(data[i].revpar-data[i-1].revpar,data[i].revpar,4);data[i].roomrev_g=(0,_method.calculation)(data[i].roomrev-data[i-1].roomrev,data[i].roomrev,4);data[i].fb_g=(0,_method.calculation)(data[i].fb-data[i-1].fb,data[i].fb,4);data[i].total_g=(0,_method.calculation)(data[i].total-data[i-1].total,data[i].total,4);}if(length&&length>=1){data[i].roomrev=(data[i].roomrev/length).toFixed(2);data[i].fb=(data[i].fb/length).toFixed(2);data[i].total=(data[i].total/length).toFixed(2);}});return data;}var setKarte=exports.setKarte=function setKarte(_ref3,isOnResize){var month=_ref3.month,day=_ref3.day,dataY=_ref3.dataY,title=_ref3.title,_ref3$type=_ref3.type,type=_ref3$type===undefined?"":_ref3$type;var myChart=_echarts2.default.init(document.getElementById("chart"));myChart.resize();if(isOnResize){return;}var option={color:color,title:{text:title,textStyle:{fontSize:20}},tooltip:{trigger:'axis',axisPointer:{type:'cross'}},grid:{top:120},legend:{top:30,data:dataY.map(function(x){return x.name;}),textStyle:{fontSize:18}},toolbox:{feature:{saveAsImage:{show:true}}},xAxis:[{type:'category',axisLabel:{color:"black",fontSize:14},data:new Array(Number(day)).fill(1).map(function(x,i){return month+"/"+(i+1);})}],yAxis:{type:'value',name:'',axisLabel:{formatter:type=='perncet'?'{value}%':'{value}'}},series:dataY.map(function(x,i){return{name:x.name,type:"line",smooth:true,data:type=="percent"?x.data.map(function(x){return(x*100).toFixed(1);}):x.data};})};myChart.setOption(option);};

/***/ }),
/* 2144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _upload=__webpack_require__(171);var _upload2=_interopRequireDefault(_upload);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _icon=__webpack_require__(38);var _icon2=_interopRequireDefault(_icon);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(172);__webpack_require__(6);__webpack_require__(75);__webpack_require__(10);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _compute=__webpack_require__(2146);var _compute2=_interopRequireDefault(_compute);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);__webpack_require__(2147);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().subtract(1,'week').format('YYYY-WW'),dataAll:{},year:1,value:"OCC",loading:true,uploading:false,fileList:[],kpi:{},lastKpi:{}},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var year,week,month,res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;year=(0,_moment2.default)(date,'YYYY-WW').format('YYYY');week=(0,_moment2.default)(date,'YYYY-WW').format('WW');month=(0,_moment2.default)(date,'YYYY-WW').format('M');_context.next=6;return(0,_request2.default)('/data/groupvisualization?year='+year+'&week='+week+'&month='+month);case 6:res=_context.sent;_this.setState({loading:false,lastKpi:res.data.lastKpi||{},kpi:res.data.kpi||{},dataAll:(0,_compute2.default)(res.data||{},week)},function(){_this.onChange(_this.state.value,_this.state.year);});_context.next=14;break;case 10:_context.prev=10;_context.t0=_context['catch'](0);console.log(_context.t0,'数据加载错误！');_this.setState({loading:false});case 14:case'end':return _context.stop();}}},_callee,_this2,[[0,10]]);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.onChange=function(value,year){_this.setState({value:value,year:year});var _this$state=_this.state,date=_this$state.date,dataAll=_this$state.dataAll,kpi=_this$state.kpi,lastKpi=_this$state.lastKpi;var week=(0,_moment2.default)(date,'YYYY-WW').format('WW');var name={"OCC":'occ',"ADR":'adr',"RevPAR":'revpar',"餐饮收入":'fb'};var dataY=[{name:"酒店",data:(year==1?dataAll.data:dataAll.last).map(function(x){return x[name[value]];})},{name:"区域",data:(year==1?dataAll.area:dataAll.arealast).map(function(x){return x[name[value]];})},{name:"收入区间",data:(year==1?dataAll.interval:dataAll.intervallast).map(function(x){return x[name[value]];})}];var _kpi=year==1?kpi:lastKpi;dataY.push({name:"KPI",data:dataAll.data.map(function(x){return _kpi[name[value]];})});(0,_compute.setKarte)({title:value,year:(0,_moment2.default)(date,'YYYY-WW').format('YYYY'),week:week,type:value=='OCC'?'percent':'',dataY:dataY});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData(this.state.date);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,date=_state.date,year=_state.year,loading=_state.loading,fileList=_state.fileList,uploading=_state.uploading,value=_state.value,_state$dataAll=_state.dataAll,data=_state$dataAll.data,last=_state$dataAll.last;var _data=data;if(value==2)_data=last;var len=(_data||[]).length-1;var that=this;var props={name:'file',action:'/qiansheng/open/kpiImportExcel',accept:".csv,.xls,.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",headers:{authorization:'authorization-text'},data:{month:(0,_moment2.default)(date).format('M'),year:(0,_moment2.default)(date).format('YYYY')},fileList:fileList,onChange:function onChange(info){that.setState({fileList:[info.file],uploading:true});if(info.file.status==='done'){if(info.file.response.code==200){_message3.default.success(date+' \u6570\u636E\u5DF2\u7ECF\u66F4\u65B0\u6210\u529F\uFF01');}else{_message3.default.error(date+' \u66F4\u65B0\u5931\u8D25\uFF0C\u8BF7\u91CD\u65B0\u4E0A\u4F20\u6216\u8054\u7CFB\u7BA1\u7406\u5458\uFF01');}that.setState({uploading:false});return;}else if(info.file.status==='error'){_message3.default.error('\u8868\u683C\u4E0A\u4F20\u5931\u8D25\uFF01');that.setState({uploading:false});}}};return _react2.default.createElement('div',{className:'data-Visualization'},_react2.default.createElement('div',{className:'title'},'1.6 Daily Visual Diagram \u65E5\u6570\u636E\u53EF\u89C6\u5316\u56FE\u8868 ',date),_react2.default.createElement(_Auth2.default,{loading:loading,auth:'edit_groupanalysisChart'},_react2.default.createElement(_upload2.default,props,_react2.default.createElement(_button2.default,{loading:uploading},_react2.default.createElement(_icon2.default,{type:'upload'}),' ',uploading?'文件上传中。。。':"上传KPI"))),_react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'content',style:{marginTop:20}},_react2.default.createElement('div',{className:'item',onClick:function onClick(){return _this3.onChange("OCC",year);},style:{backgroundColor:_lodash2.default.get(_data,len+'.occ_g')<0?"#50B07A":"#E37646"}},_react2.default.createElement('span',{className:'name'},'OCC'),_react2.default.createElement('span',{className:'num'},(_lodash2.default.get(_data,len+'.occ',0)*100).toFixed(1),'%'),_react2.default.createElement('span',{className:'data'},_react2.default.createElement('span',null,'\u8F83\u4E0A\u5468\u540C\u65F6\u6BB5'),_react2.default.createElement('span',null,(_lodash2.default.get(_data,len+'.occ_g')*100||0).toFixed(1),'%',_lodash2.default.get(_data,len+'.occ_g')>0&&_react2.default.createElement(_icon2.default,{className:'up',type:'arrow-up'}),_lodash2.default.get(_data,len+'.occ_g')<0&&_react2.default.createElement(_icon2.default,{className:'down',type:'arrow-down'})))),_react2.default.createElement('div',{className:'item',onClick:function onClick(){return _this3.onChange("ADR",year);},style:{backgroundColor:_lodash2.default.get(_data,len+'.adr_g')<0?"#50B07A":"#E37646"}},_react2.default.createElement('span',{className:'name'},'ADR'),_react2.default.createElement('span',{className:'num'},(_lodash2.default.get(_data,len+'.adr',0)*1).toFixed(2)),_react2.default.createElement('span',{className:'data'},_react2.default.createElement('span',null,'\u8F83\u4E0A\u5468\u540C\u65F6\u6BB5'),_react2.default.createElement('span',null,(_lodash2.default.get(_data,len+'.adr_g')*100||0).toFixed(1),'%',_lodash2.default.get(_data,len+'.adr_g')>0&&_react2.default.createElement(_icon2.default,{className:'up',type:'arrow-up'}),_lodash2.default.get(_data,len+'.adr_g')<0&&_react2.default.createElement(_icon2.default,{className:'down',type:'arrow-down'})))),_react2.default.createElement('div',{className:'item',style:{backgroundColor:_lodash2.default.get(_data,len+'.revpar_g')<0?"#50B07A":"#E37646"},onClick:function onClick(){return _this3.onChange("RevPAR",year);}},_react2.default.createElement('span',{className:'name'},'RevPAR'),_react2.default.createElement('span',{className:'num'},(_lodash2.default.get(_data,len+'.revpar',0)*1).toFixed(2)),_react2.default.createElement('span',{className:'data'},_react2.default.createElement('span',null,'\u8F83\u4E0A\u5468\u540C\u65F6\u6BB5'),_react2.default.createElement('span',null,(_lodash2.default.get(_data,len+'.revpar_g')*100||0).toFixed(1),'%',_lodash2.default.get(_data,len+'.revpar_g')>0&&_react2.default.createElement(_icon2.default,{className:'up',type:'arrow-up'}),_lodash2.default.get(_data,len+'.revpar_g')<0&&_react2.default.createElement(_icon2.default,{className:'down',type:'arrow-down'})))),_react2.default.createElement('div',{className:'item',style:{backgroundColor:_lodash2.default.get(_data,len+'.fb_g')<0?"#50B07A":"#E37646"},onClick:function onClick(){return _this3.onChange("餐饮收入",year);}},_react2.default.createElement('span',{className:'name'},'\u9910\u996E\u6536\u5165'),_react2.default.createElement('span',{className:'num'},(_lodash2.default.get(_data,len+'.fb',0)*1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')),_react2.default.createElement('span',{className:'data'},_react2.default.createElement('span',null,'\u8F83\u4E0A\u5468\u540C\u65F6\u6BB5'),_react2.default.createElement('span',null,(_lodash2.default.get(_data,len+'.fb_g')*100||0).toFixed(1),'%',_lodash2.default.get(_data,len+'.fb_g')>0&&_react2.default.createElement(_icon2.default,{className:'up',type:'arrow-up'}),_lodash2.default.get(_data,len+'.fb_g')<0&&_react2.default.createElement(_icon2.default,{className:'down',type:'arrow-down'}))))),_react2.default.createElement('div',{className:'selected'},_react2.default.createElement(_button2.default,{type:year==1?'primary':'',onClick:function onClick(){return _this3.onChange(value,1);}},'\u4ECA\u5E74'),_react2.default.createElement(_button2.default,{onClick:function onClick(){return _this3.onChange(value,2);},type:year==2?'primary':''},'\u53BB\u5E74')),_react2.default.createElement('div',{className:'chart-content'},_react2.default.createElement('div',{id:'chart'},' '))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setKarte=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _method=__webpack_require__(20);var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var color=['#00C6BD','#42585D','#FF605F','#FFD700'];exports.default=function(_ref,week){var _ref$data=_ref.data,data=_ref$data===undefined?[]:_ref$data,_ref$last=_ref.last,last=_ref$last===undefined?[]:_ref$last,_ref$area=_ref.area,area=_ref$area===undefined?[]:_ref$area,_ref$arealast=_ref.arealast,arealast=_ref$arealast===undefined?[]:_ref$arealast,_ref$interval=_ref.interval,interval=_ref$interval===undefined?[]:_ref$interval,_ref$intervallast=_ref.intervallast,intervallast=_ref$intervallast===undefined?[]:_ref$intervallast,_ref$areaLen=_ref.areaLen,areaLen=_ref$areaLen===undefined?1:_ref$areaLen,_ref$intervalLen=_ref.intervalLen,intervalLen=_ref$intervalLen===undefined?1:_ref$intervalLen;return{data:compute({data:data,week:week}),last:compute({data:last,week:week}),area:compute({data:area,week:week,length:areaLen}),arealast:compute({data:arealast,week:week,length:areaLen}),interval:compute({data:interval,week:week,length:intervalLen}),intervallast:compute({data:intervallast,week:week,length:intervalLen})};};function compute(_ref2){var data=_ref2.data,week=_ref2.week,length=_ref2.length;var _data=[];Object.entries(data).forEach(function(item,i){var _item=_extends({},item[1],{occ:(0,_method.calculation)(item[1].sold,item[1].ava,4),adr:(0,_method.calculation)(item[1].roomrev,item[1].sold,4)});_item.revpar=(_item.occ*_item.adr).toFixed(2);if(i>0){_item.occ_g=(0,_method.calculation)(_item.occ-_data[i-1].occ,_item.occ,4);_item.adr_g=(0,_method.calculation)(_item.adr-_data[i-1].adr,_item.adr,4);_item.revpar_g=(0,_method.calculation)(_item.revpar-_data[i-1].revpar,_item.revpar,4);_item.fb_g=(0,_method.calculation)(_item.fb-_data[i-1].fb,_item.fb,4);}if(length&&length>=1){_item.fb=(_item.fb/length).toFixed(2);}_data[i]=_item;});return _data;}var setKarte=exports.setKarte=function setKarte(_ref3,isOnResize){var year=_ref3.year,week=_ref3.week,dataY=_ref3.dataY,title=_ref3.title,_ref3$type=_ref3.type,type=_ref3$type===undefined?"":_ref3$type;var myChart=_echarts2.default.init(document.getElementById("chart"));myChart.resize();if(isOnResize){return;}var option={color:color,title:{text:title,textStyle:{fontSize:20}},tooltip:{trigger:'axis',axisPointer:{type:'cross'}},grid:{top:120},legend:{top:30,data:dataY.map(function(x){return x.name;}),textStyle:{fontSize:18}},toolbox:{feature:{saveAsImage:{show:true}}},xAxis:[{type:'category',axisLabel:{color:"black",fontSize:14},data:new Array(Number(week<10?week:10)).fill(1).map(function(x,i){return year+"-"+~~(week-(week<10?week:10)+i+1);})}],yAxis:{type:'value',name:'',axisLabel:{formatter:type=='perncet'?'{value}%':'{value}'}},series:dataY.map(function(x,i){return{name:x.name,type:"line",smooth:true,data:type=="percent"?x.data.map(function(x){return(x*100).toFixed(1);}):x.data};})};myChart.setOption(option);};

/***/ }),
/* 2147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _list=__webpack_require__(2149);var _list2=_interopRequireDefault(_list);var _popconfirm=__webpack_require__(110);var _popconfirm2=_interopRequireDefault(_popconfirm);var _inputNumber=__webpack_require__(34);var _inputNumber2=_interopRequireDefault(_inputNumber);var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(2152);__webpack_require__(111);__webpack_require__(35);__webpack_require__(60);__webpack_require__(4);__webpack_require__(10);__webpack_require__(42);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);__webpack_require__(2154);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var Option=_select2.default.Option;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getDateData=function(date){var data=new Array(10).fill({name:"",hotel_id:"",num:0}).map(function(x){return _extends({},x);});var year=(0,_moment2.default)(date).format('YYYY');var month=(0,_moment2.default)(date).format('M');fetch('/getOtaFillIn?year='+year+'&month='+month,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data&&x.data.data.length>0){data=x.data.data;}_this.setState({loading:false,data:data,hotels:x.data.hotels});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("M");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/addOtaFillIn',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false,isEdit:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.onChange=function(name,value,i){var data=[].concat(_toConsumableArray(_this.state.data));data[i][name]=value;_this.setState({data:data});};_this.onDelete=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(item,index){var data,res,json;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;data=[].concat(_toConsumableArray(_this.state.data));if(item.id){_context.next=6;break;}data.splice(index,1);_this.setState({data:data});return _context.abrupt('return');case 6:_context.next=8;return fetch('/deleteOtaFillIn?id='+item.id,{credentials:'include'});case 8:res=_context.sent;_context.next=11;return res.json();case 11:json=_context.sent;if(!(json.status==1)){_context.next=16;break;}data.splice(index,1);_this.setState({data:data});return _context.abrupt('return');case 16:_message3.default.error(json.msg);_context.next=23;break;case 19:_context.prev=19;_context.t0=_context['catch'](0);console.log(_context.t0);_message3.default.error('删除错误');case 23:case'end':return _context.stop();}}},_callee,_this2,[[0,19]]);}));return function(_x,_x2){return _ref.apply(this,arguments);};}();_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),dateData:[],data:[],loading:true,loadingSave:false,print:false,hotels:[]};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,data=_state.data,hotels=_state.hotels,loading=_state.loading,print=_state.print,date=_state.date;return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'table7_1_1 ota-channel'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_1_1',style:{width:print?4450:'auto'}},_react2.default.createElement(_row2.default,null,'Hotel OTA Channel Performance \u9152\u5E97OTA\u6E20\u9053\u8868\u73B0'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}}))),_react2.default.createElement(_row2.default,{className:'content'},_react2.default.createElement(_list2.default,{className:''+(data.length>=11&&'padding-right-scroll'),header:_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:2,className:'border-right padding'},'key'),_react2.default.createElement(_col2.default,{span:14,className:'border-right padding '},'\u9152\u5E97\u540D\u79F0'),_react2.default.createElement(_col2.default,{span:6,className:'border-right padding'},'\u6570\u91CF'),_react2.default.createElement(_col2.default,{span:2,className:'padding'},'\u64CD\u4F5C'))},[].concat(_toConsumableArray(data)).map(function(item,index){return _react2.default.createElement(_list2.default.Item,{key:index},_react2.default.createElement(_col2.default,{span:2,className:'padding border-right',style:{display:"flex",alignItems:"center",height:48}},index+1),_react2.default.createElement(_col2.default,{span:14,className:'input_color padding'},_react2.default.createElement(_select2.default,{showSearch:true,placeholder:'\u8BF7\u9009\u62E9\u9152\u5E97',className:'table_numInput',optionFilterProp:'children',value:item.name,onChange:function onChange(v){var hotel=hotels.find(function(x){return x.name.includes(v);})||{};_this3.onChange('name',v,index);_this3.onChange('hotel_id',hotel.id||"",index);}},hotels.map(function(x){var name=x.name.replace(/[^\u4E00-\u9FA5]/g,"");return _react2.default.createElement(Option,{key:name},name);}))),_react2.default.createElement(_col2.default,{span:6,className:'input_color padding'},_react2.default.createElement(_inputNumber2.default,{formatter:function formatter(value){return(''+value).replace(/\B(?=(\d{3})+(?!\d))/g,',');},parser:function parser(value){return value.replace(/\$\s?|(,*)/g,'');},precision:0,className:'table_numInput',value:Number(item.num||"0")||"",onChange:function onChange(v){_this3.onChange('num',v,index);}})),_react2.default.createElement(_popconfirm2.default,{title:'\u786E\u5B9A\u5220\u9664\u5417,\u4E00\u5355\u5220\u9664\u5C06\u4E0D\u53EF\u6062\u590D?',onConfirm:_this3.onDelete.bind(_this3,item,index),okText:'\u786E\u5B9A',cancelText:'\u53D6\u6D88'},_react2.default.createElement(_col2.default,{span:2,className:'padding',style:{display:"flex",alignItems:"center",color:"#4c9bf2"}},'\u5220\u9664')));}))),_react2.default.createElement(_button2.default,{ghost:true,className:'add-hotel',icon:'plus',type:'primary',onClick:function onClick(){var data=[].concat(_toConsumableArray(_this3.state.data));data.push({name:"",hotel_id:"",num:0});_this3.setState({data:data});}},'\u6DFB\u52A0\u9152\u5E97'),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_otafillin'},_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(19));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _omit = _interopRequireDefault(__webpack_require__(71));

var _spin = _interopRequireDefault(__webpack_require__(11));

var _configProvider = __webpack_require__(39);

var _pagination = _interopRequireDefault(__webpack_require__(363));

var _grid = __webpack_require__(261);

var _Item = _interopRequireDefault(__webpack_require__(2150));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var List = /*#__PURE__*/function (_React$Component) {
  _inherits(List, _React$Component);

  var _super = _createSuper(List);

  function List(props) {
    var _this;

    _classCallCheck(this, List);

    _this = _super.call(this, props);
    _this.defaultPaginationProps = {
      current: 1,
      total: 0
    };
    _this.keys = {};
    _this.onPaginationChange = _this.triggerPaginationEvent('onChange');
    _this.onPaginationShowSizeChange = _this.triggerPaginationEvent('onShowSizeChange');

    _this.renderItem = function (item, index) {
      var _this$props = _this.props,
          renderItem = _this$props.renderItem,
          rowKey = _this$props.rowKey;
      if (!renderItem) return null;
      var key;

      if (typeof rowKey === 'function') {
        key = rowKey(item);
      } else if (typeof rowKey === 'string') {
        key = item[rowKey];
      } else {
        key = item.key;
      }

      if (!key) {
        key = "list-item-".concat(index);
      }

      _this.keys[index] = key;
      return renderItem(item, index);
    };

    _this.renderEmpty = function (prefixCls, renderEmpty) {
      var locale = _this.props.locale;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-empty-text")
      }, locale && locale.emptyText || renderEmpty('List'));
    };

    _this.renderList = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls,
          renderEmpty = _ref.renderEmpty;
      var _this$state = _this.state,
          paginationCurrent = _this$state.paginationCurrent,
          paginationSize = _this$state.paginationSize;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          bordered = _a.bordered,
          split = _a.split,
          className = _a.className,
          children = _a.children,
          itemLayout = _a.itemLayout,
          loadMore = _a.loadMore,
          pagination = _a.pagination,
          grid = _a.grid,
          _a$dataSource = _a.dataSource,
          dataSource = _a$dataSource === void 0 ? [] : _a$dataSource,
          size = _a.size,
          header = _a.header,
          footer = _a.footer,
          loading = _a.loading,
          rest = __rest(_a, ["prefixCls", "bordered", "split", "className", "children", "itemLayout", "loadMore", "pagination", "grid", "dataSource", "size", "header", "footer", "loading"]);

      var prefixCls = getPrefixCls('list', customizePrefixCls);
      var loadingProp = loading;

      if (typeof loadingProp === 'boolean') {
        loadingProp = {
          spinning: loadingProp
        };
      }

      var isLoading = loadingProp && loadingProp.spinning; // large => lg
      // small => sm

      var sizeCls = '';

      switch (size) {
        case 'large':
          sizeCls = 'lg';
          break;

        case 'small':
          sizeCls = 'sm';
          break;

        default:
          break;
      }

      var classString = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), itemLayout === 'vertical'), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), _defineProperty(_classNames, "".concat(prefixCls, "-split"), split), _defineProperty(_classNames, "".concat(prefixCls, "-bordered"), bordered), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), isLoading), _defineProperty(_classNames, "".concat(prefixCls, "-grid"), grid), _defineProperty(_classNames, "".concat(prefixCls, "-something-after-last-item"), _this.isSomethingAfterLastItem()), _classNames));

      var paginationProps = _extends(_extends(_extends({}, _this.defaultPaginationProps), {
        total: dataSource.length,
        current: paginationCurrent,
        pageSize: paginationSize
      }), pagination || {});

      var largestPage = Math.ceil(paginationProps.total / paginationProps.pageSize);

      if (paginationProps.current > largestPage) {
        paginationProps.current = largestPage;
      }

      var paginationContent = pagination ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-pagination")
      }, /*#__PURE__*/React.createElement(_pagination["default"], _extends({}, paginationProps, {
        onChange: _this.onPaginationChange,
        onShowSizeChange: _this.onPaginationShowSizeChange
      }))) : null;

      var splitDataSource = _toConsumableArray(dataSource);

      if (pagination) {
        if (dataSource.length > (paginationProps.current - 1) * paginationProps.pageSize) {
          splitDataSource = _toConsumableArray(dataSource).splice((paginationProps.current - 1) * paginationProps.pageSize, paginationProps.pageSize);
        }
      }

      var childrenContent;
      childrenContent = isLoading && /*#__PURE__*/React.createElement("div", {
        style: {
          minHeight: 53
        }
      });

      if (splitDataSource.length > 0) {
        var items = splitDataSource.map(function (item, index) {
          return _this.renderItem(item, index);
        });
        var childrenList = [];
        React.Children.forEach(items, function (child, index) {
          childrenList.push( /*#__PURE__*/React.cloneElement(child, {
            key: _this.keys[index]
          }));
        });
        childrenContent = grid ? /*#__PURE__*/React.createElement(_grid.Row, {
          gutter: grid.gutter
        }, childrenList) : /*#__PURE__*/React.createElement("ul", {
          className: "".concat(prefixCls, "-items")
        }, childrenList);
      } else if (!children && !isLoading) {
        childrenContent = _this.renderEmpty(prefixCls, renderEmpty);
      }

      var paginationPosition = paginationProps.position || 'bottom';
      return /*#__PURE__*/React.createElement("div", _extends({
        className: classString
      }, (0, _omit["default"])(rest, ['rowKey', 'renderItem', 'locale'])), (paginationPosition === 'top' || paginationPosition === 'both') && paginationContent, header && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-header")
      }, header), /*#__PURE__*/React.createElement(_spin["default"], loadingProp, childrenContent, children), footer && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-footer")
      }, footer), loadMore || (paginationPosition === 'bottom' || paginationPosition === 'both') && paginationContent);
    };

    var pagination = props.pagination;
    var paginationObj = pagination && _typeof(pagination) === 'object' ? pagination : {};
    _this.state = {
      paginationCurrent: paginationObj.defaultCurrent || 1,
      paginationSize: paginationObj.defaultPageSize || 10
    };
    return _this;
  }

  _createClass(List, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        grid: this.props.grid,
        itemLayout: this.props.itemLayout
      };
    }
  }, {
    key: "triggerPaginationEvent",
    value: function triggerPaginationEvent(eventName) {
      var _this2 = this;

      return function (page, pageSize) {
        var pagination = _this2.props.pagination;

        _this2.setState({
          paginationCurrent: page,
          paginationSize: pageSize
        });

        if (pagination && pagination[eventName]) {
          pagination[eventName](page, pageSize);
        }
      };
    }
  }, {
    key: "isSomethingAfterLastItem",
    value: function isSomethingAfterLastItem() {
      var _this$props2 = this.props,
          loadMore = _this$props2.loadMore,
          pagination = _this$props2.pagination,
          footer = _this$props2.footer;
      return !!(loadMore || pagination || footer);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderList);
    }
  }]);

  return List;
}(React.Component);

exports["default"] = List;
List.Item = _Item["default"];
List.childContextTypes = {
  grid: PropTypes.any,
  itemLayout: PropTypes.string
};
List.defaultProps = {
  dataSource: [],
  bordered: false,
  split: true,
  loading: false,
  pagination: false
};

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Meta = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(19));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _grid = __webpack_require__(261);

var _configProvider = __webpack_require__(39);

var _reactNode = __webpack_require__(2151);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Meta = function Meta(props) {
  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;

    var customizePrefixCls = props.prefixCls,
        className = props.className,
        avatar = props.avatar,
        title = props.title,
        description = props.description,
        others = __rest(props, ["prefixCls", "className", "avatar", "title", "description"]);

    var prefixCls = getPrefixCls('list', customizePrefixCls);
    var classString = (0, _classnames["default"])("".concat(prefixCls, "-item-meta"), className);
    var content = /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-item-meta-content")
    }, title && /*#__PURE__*/React.createElement("h4", {
      className: "".concat(prefixCls, "-item-meta-title")
    }, title), description && /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-item-meta-description")
    }, description));
    return /*#__PURE__*/React.createElement("div", _extends({}, others, {
      className: classString
    }), avatar && /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-item-meta-avatar")
    }, avatar), (title || description) && content);
  });
};

exports.Meta = Meta;

function getGrid(grid, t) {
  return grid[t] && Math.floor(24 / grid[t]);
}

var Item = /*#__PURE__*/function (_React$Component) {
  _inherits(Item, _React$Component);

  var _super = _createSuper(Item);

  function Item() {
    var _this;

    _classCallCheck(this, Item);

    _this = _super.apply(this, arguments);

    _this.renderItem = function (_ref2) {
      var getPrefixCls = _ref2.getPrefixCls;
      var _this$context = _this.context,
          grid = _this$context.grid,
          itemLayout = _this$context.itemLayout;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          children = _a.children,
          actions = _a.actions,
          extra = _a.extra,
          className = _a.className,
          others = __rest(_a, ["prefixCls", "children", "actions", "extra", "className"]);

      var prefixCls = getPrefixCls('list', customizePrefixCls);
      var actionsContent = actions && actions.length > 0 && /*#__PURE__*/React.createElement("ul", {
        className: "".concat(prefixCls, "-item-action"),
        key: "actions"
      }, actions.map(function (action, i) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          React.createElement("li", {
            key: "".concat(prefixCls, "-item-action-").concat(i)
          }, action, i !== actions.length - 1 && /*#__PURE__*/React.createElement("em", {
            className: "".concat(prefixCls, "-item-action-split")
          }))
        );
      }));
      var Tag = grid ? 'div' : 'li';
      var itemChildren = /*#__PURE__*/React.createElement(Tag, _extends({}, others, {
        // `li` element `onCopy` prop args is not same as `div`
        className: (0, _classnames["default"])("".concat(prefixCls, "-item"), className, _defineProperty({}, "".concat(prefixCls, "-item-no-flex"), !_this.isFlexMode()))
      }), itemLayout === 'vertical' && extra ? [/*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-item-main"),
        key: "content"
      }, children, actionsContent), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-item-extra"),
        key: "extra"
      }, extra)] : [children, actionsContent, (0, _reactNode.cloneElement)(extra, {
        key: 'extra'
      })]);
      return grid ? /*#__PURE__*/React.createElement(_grid.Col, {
        span: getGrid(grid, 'column'),
        xs: getGrid(grid, 'xs'),
        sm: getGrid(grid, 'sm'),
        md: getGrid(grid, 'md'),
        lg: getGrid(grid, 'lg'),
        xl: getGrid(grid, 'xl'),
        xxl: getGrid(grid, 'xxl')
      }, itemChildren) : itemChildren;
    };

    return _this;
  }

  _createClass(Item, [{
    key: "isItemContainsTextNodeAndNotSingular",
    value: function isItemContainsTextNodeAndNotSingular() {
      var children = this.props.children;
      var result;
      React.Children.forEach(children, function (element) {
        if (typeof element === 'string') {
          result = true;
        }
      });
      return result && React.Children.count(children) > 1;
    }
  }, {
    key: "isFlexMode",
    value: function isFlexMode() {
      var extra = this.props.extra;
      var itemLayout = this.context.itemLayout;

      if (itemLayout === 'vertical') {
        return !!extra;
      }

      return !this.isItemContainsTextNodeAndNotSingular();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderItem);
    }
  }]);

  return Item;
}(React.Component);

exports["default"] = Item;
Item.Meta = Meta;
Item.contextTypes = {
  grid: PropTypes.any,
  itemLayout: PropTypes.string
};

/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneElement = cloneElement;

var React = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// eslint-disable-next-line import/prefer-default-export
function cloneElement(element) {
  if (! /*#__PURE__*/React.isValidElement(element)) return element;

  for (var _len = arguments.length, restArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    restArgs[_key - 1] = arguments[_key];
  }

  return React.cloneElement.apply(React, [element].concat(restArgs));
}

/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(2153);

__webpack_require__(365);

__webpack_require__(12);

__webpack_require__(367);

__webpack_require__(345);

/***/ }),
/* 2153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _analysis=__webpack_require__(125);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _method=__webpack_require__(20);var _imgtopdf=__webpack_require__(128);var _jspdf=__webpack_require__(183);var _jspdf2=_interopRequireDefault(_jspdf);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var App=function(_Component){_inherits(App,_Component);function App(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,dataSelect:[]},_this.getDateData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var year,month;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:year=(0,_moment2.default)(date).format('YYYY');month=(0,_moment2.default)(date).format('M');fetch("/getOtaFillIn?year="+year+"&month="+month,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){var maxNum=(x.data.data||[]).reduce(function(a,b){return b.num>a?b.num:a;},1);var data=(x.data.data||[]).filter(function(item){return item.num>0;}).map(function(item){return{name:item.name,num:(0,_method.calculation)(item.num,maxNum,3)};}).sort(function(a,b){return a.num-b.num;});var otashow={id:"otashow",dataX:[{name:"集团飞猪旗舰店当月客房间夜数销售排名",data:data.map(function(x){return x.num;})}],dataY:data.map(function(x){return x.name;}),color:['#4c9bf2'],grid:{left:300}};(0,_analysis.setYCategory)(otashow,false);_this.setState({loading:false,data:data});}).catch(function(err){_this.setState({loading:false});console.error(err);});case 3:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.onExportPdf=function(){_this.setState({print:true,loading:true},function(){(0,_imgtopdf.imgToPdf)('table4_1_1',1.5).then(function(x){var canvas=x.canvas;var pageData=canvas.toDataURL('image/png',1);//方向默认横向，尺寸ponits, 按照图片大小进行输出
var pdf=new _jspdf2.default('l','pt',[canvas.width*0.4,canvas.height]);//需要dataUrl格式
pdf.addImage(pageData,'PNG',0,0,canvas.width,canvas.height);pdf.save("Fliggy Store Rooms Nights Ranking - Current Month \u96C6\u56E2\u98DE\u732A\u65D7\u8230\u5E97\u5F53\u6708\u5BA2\u623F\u95F4\u591C\u6570\u9500\u552E\u6392\u540D "+_this.state.date+".pdf");_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_message3.default.error('导出失败请重试！');_this.setState({print:false,loading:false});});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:"componentDidMount",value:function componentDidMount(){this.getDateData(this.state.date);window.addEventListener('resize',function(){if(window.location.hash==='#/table/otashow'){(0,_analysis.setYCategory)({id:"otashow"},true);}});}},{key:"render",value:function render(){var _this3=this;var _state=this.state,loading=_state.loading,print=_state.print,date=_state.date;return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement("div",{className:"table7_1_1"},_react2.default.createElement(_row2.default,{className:"title",id:"table4_1_1",style:{width:print?4450:'auto'}},_react2.default.createElement(_row2.default,null,"1.1 Fliggy Store Rooms Nights Ranking - Current Month \u96C6\u56E2\u98DE\u732A\u65D7\u8230\u5E97\u5F53\u6708\u5BA2\u623F\u95F4\u591C\u6570\u9500\u552E\u6392\u540D"),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(date,"YYYY-MM"),format:"YYYY-MM",onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}})),_react2.default.createElement("div",{id:"otashow",style:{height:650,width:"calc(100% - 48px)",marginTop:20}})),_react2.default.createElement(_row2.default,{className:"table-footer-btn"},_react2.default.createElement(_button2.default,{type:"primary",onClick:this.onExportPdf,loading:this.state.print},"\u5BFC\u51FAPDF"))));}}]);return App;}(_react.Component);exports.default=App;

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(4);__webpack_require__(14);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);__webpack_require__(2157);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={data:{},date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM')},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData(this.state.date);}},{key:'getData',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(_date){var res,revs,rooms;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_request2.default)('/api/data/xiecheng/lst?year='+(0,_moment2.default)(_date).format('YYYY')+'&month='+(0,_moment2.default)(_date).format('M'));case 2:res=_context.sent;revs=[],rooms=[];try{revs=JSON.parse(res.data.revs||"[]")||[];rooms=JSON.parse(res.data.rooms||"[]")||[];}catch(error){console.error('解析错误',error);}this.setState({data:_extends({},res.data,{revs:revs,rooms:rooms})});case 6:case'end':return _context.stop();}}},_callee,this);}));function getData(_x){return _ref2.apply(this,arguments);}return getData;}()},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,date=_state.date;var month=(0,_moment2.default)(date).format('M');return _react2.default.createElement('div',{className:'performanceReview otashowctrip'},_react2.default.createElement('div',{className:'title'},'1.2 ',data.title||'Ctrip Rooms Revenue & Nights Ranking - Current Year \uFF081-'+month+' YTD\uFF09\n                    \u643A\u7A0B\u5E73\u53F0\u96C6\u56E2\u9152\u5E97\u5F53\u5E74\u5BA2\u623F\u6536\u76CA\u4E0E\u95F4\u591C\u6570\uFF081-'+month+'\u6708\uFF09\u9500\u552E\u6392\u540D',_react2.default.createElement('span',{style:{fontSize:14}},'\uFF08\u4E0D\u542B\u4F9B\u5E94\u5546\u6570\u636E\uFF09'),_react2.default.createElement(_row2.default,{className:'table-month',style:{marginTop:10}},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(date,'YYYY-MM'),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:{},loading:true});_this2.getData(str);}}))),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'content'},_react2.default.createElement('div',{className:'title'},'Revenue TOP 20 \u6309\u6536\u76CA\u6392\u540D\u524D20'),(data.revs||[]).map(function(x,i){return _react2.default.createElement('div',{className:'item',key:x},_react2.default.createElement('div',null,i+1),_react2.default.createElement('div',null,x));})),_react2.default.createElement('div',{className:'content'},_react2.default.createElement('div',{className:'title'},'Room Nights TOP 20 \u6309\u95F4\u591C\u6392\u540D\u524D20'),(data.rooms||[]).map(function(x,i){return _react2.default.createElement('div',{className:'item',key:x},_react2.default.createElement('div',null,i+1),_react2.default.createElement('div',null,x));}))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(4);__webpack_require__(14);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);__webpack_require__(2159);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={data:{},date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM')},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData(this.state.date);}},{key:'getData',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(_date){var res,revs,rooms;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_request2.default)('/api/data/meituan/lst?year='+(0,_moment2.default)(_date).format('YYYY')+'&month='+(0,_moment2.default)(_date).format('M'));case 2:res=_context.sent;revs=[],rooms=[];try{revs=JSON.parse(res.data.revs||"[]")||[];rooms=JSON.parse(res.data.rooms||"[]")||[];}catch(error){console.error('解析错误',error);}this.setState({data:_extends({},res.data,{revs:revs,rooms:rooms})});case 6:case'end':return _context.stop();}}},_callee,this);}));function getData(_x){return _ref2.apply(this,arguments);}return getData;}()},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,date=_state.date;var month=(0,_moment2.default)(date).format('M');return _react2.default.createElement('div',{className:'performanceReview otashowctrip'},_react2.default.createElement('div',{className:'title'},'1.3 ',data.title||'Meituan Rooms Revenue & Nights Ranking - Current Year \uFF081-'+month+' YTD\uFF09\n                    \u7F8E\u56E2\u5E73\u53F0\u96C6\u56E2\u9152\u5E97\u5F53\u5E74\u5BA2\u623F\u6536\u76CA\u4E0E\u95F4\u591C\u6570\uFF081-'+month+'\u6708\uFF09\u9500\u552E\u6392\u540D',_react2.default.createElement('span',{style:{fontSize:14}},'\uFF08\u4E0D\u542B\u4F9B\u5E94\u5546\u6570\u636E\uFF09'),_react2.default.createElement(_row2.default,{className:'table-month',style:{marginTop:10}},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(date,'YYYY-MM'),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:{},loading:true});_this2.getData(str);}}))),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'content'},_react2.default.createElement('div',{className:'title'},'Revenue TOP 20 \u6309\u6536\u76CA\u6392\u540D\u524D20'),(data.revs||[]).map(function(x,i){return _react2.default.createElement('div',{className:'item',key:x},_react2.default.createElement('div',null,i+1),_react2.default.createElement('div',null,x));})),_react2.default.createElement('div',{className:'content'},_react2.default.createElement('div',{className:'title'},'Room Nights TOP 20 \u6309\u95F4\u591C\u6392\u540D\u524D20'),(data.rooms||[]).map(function(x,i){return _react2.default.createElement('div',{className:'item',key:x},_react2.default.createElement('div',null,i+1),_react2.default.createElement('div',null,x));}))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(2161);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * @Descripttion: 
 * @version: 
 * @Author: HanBeiBei
 * @Date: 2020-09-05 21:51:31
 * @LastEditors: HanBeiBei
 * @LastEditTime: 2020-09-13 13:00:31
 */var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={data:[],date:(0,_moment2.default)().subtract(1,'M').format('YYYY-MM')},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var year,month,res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;year=(0,_moment2.default)(date).format('YYYY');month=(0,_moment2.default)(date).format('M');_context.next=5;return(0,_request2.default)("/charge/appletpv?year="+year+"&month="+month);case 5:res=_context.sent;_this.setState({data:res.data||[]});_context.next=12;break;case 9:_context.prev=9;_context.t0=_context["catch"](0);console.log(_context.t0);case 12:case"end":return _context.stop();}}},_callee,_this2,[[0,9]]);}));return function(_x){return _ref2.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);}},{key:"render",value:function render(){var _this3=this;var data=this.state.data;return _react2.default.createElement("div",{className:"performanceReview performanceReview-applet"},_react2.default.createElement("div",{className:"title"},"1.5 GCH Mini Program Page View Ranking - Current Month \u96C6\u56E2\u5C0F\u7A0B\u5E8F\u5F53\u6708\u8BBF\u95EE\u91CF\u6392\u540D"),_react2.default.createElement("div",null,_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:"YYYY-MM",onChange:function onChange(date,str){_this3.setState({date:str,data:[]});_this3.getData(str);}})),_react2.default.createElement("div",{className:"row"},_react2.default.createElement("div",{className:"content"},_react2.default.createElement("div",{className:"title"},"GCH Mini Program Page View Ranking TOP 20 \u5C0F\u7A0B\u5E8F\u8BBF\u95EE\u91CF\u6392\u540D\u524D\u4E8C\u5341"),(data||[]).map(function(x,i){return _react2.default.createElement("div",{className:"item",key:x.name},_react2.default.createElement("div",null,i+1),_react2.default.createElement("div",null,x.name),_react2.default.createElement("div",null,x.count));}))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);__webpack_require__(2163);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * @Descripttion: 
 * @version: 
 * @Author: HanBeiBei
 * @Date: 2020-09-05 21:51:31
 * @LastEditors: HanBeiBei
 * @LastEditTime: 2020-09-13 13:00:31
 */var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={data:[],rn:[],date:(0,_moment2.default)().subtract(1,'M').format('YYYY-MM')},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var year,month,res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;year=(0,_moment2.default)(date).format('YYYY');month=(0,_moment2.default)(date).format('M');_context.next=5;return(0,_request2.default)("/charge/otaappletrn?year="+year+"&month="+month);case 5:res=_context.sent;_this.setState(_extends({},res.data));_context.next=12;break;case 9:_context.prev=9;_context.t0=_context["catch"](0);console.log(_context.t0);case 12:case"end":return _context.stop();}}},_callee,_this2,[[0,9]]);}));return function(_x){return _ref2.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,rn=_state.rn;return _react2.default.createElement("div",{className:"performanceReview performanceReview-applet"},_react2.default.createElement("div",{className:"title"},"1.4 GCH Mini Program Rooms Revenue & Nights Ranking - Current Month \u96C6\u56E2\u5B98\u7F51\u5C0F\u7A0B\u5E8F\u5F53\u6708\u5BA2\u623F\u6536\u76CA\u4E0E\u95F4\u591C\u6570\u9500\u552E\u6392\u540D"),_react2.default.createElement("div",null,_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:"YYYY-MM",onChange:function onChange(date,str){_this3.setState({date:str,data:[]});_this3.getData(str);}})),_react2.default.createElement("div",{className:"row"},_react2.default.createElement("div",{className:"content"},_react2.default.createElement("div",{className:"title"},"GCH Mini Program Products Ranking  \u5C0F\u7A0B\u5E8F\u4EA7\u91CF\u6392\u540D"),(data||[]).map(function(x,i){return _react2.default.createElement("div",{className:"item",key:x.name},_react2.default.createElement("div",null,i+1),_react2.default.createElement("div",null,x.name));})),_react2.default.createElement("div",{className:"content"},_react2.default.createElement("div",{className:"title"},"GCH Mini Program RN Ranking  \u5C0F\u7A0B\u5E8F\u623F\u665A\u6392\u540D"),(rn||[]).map(function(x,i){return _react2.default.createElement("div",{className:"item",key:x.name},_react2.default.createElement("div",null,i+1),_react2.default.createElement("div",null,x.name));}))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _Food=__webpack_require__(2165);var _Food2=_interopRequireDefault(_Food);__webpack_require__(2168);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:"daily-s"},_react2.default.createElement(_Food2.default,null));}}]);return App;}(_react.Component))||_class)||_class);exports.default=App;

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(8);__webpack_require__(6);__webpack_require__(4);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _mobx=__webpack_require__(30);var _Total=__webpack_require__(2166);var _Total2=_interopRequireDefault(_Total);var _Rooms=__webpack_require__(2167);var _Rooms2=_interopRequireDefault(_Rooms);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var totalIndex=[];var MonthPicker=_datePicker2.default.MonthPicker;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(name,value,i){var _this$props$store$dai=_this.props.store.dailyMonth,roomData=_this$props$store$dai.roomData,dayData=_this$props$store$dai.dayData,foodData=_this$props$store$dai.foodData;var data=[].concat(_toConsumableArray((0,_mobx.toJS)(foodData)));data[i][name]=value;_this.props.store.dailyMonth.onChange({roomData:roomData,foodData:data,dayData:dayData});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){var _props$store$dailyMon=this.props.store.dailyMonth,getData=_props$store$dailyMon.getData,date=_props$store$dailyMon.date;getData(date);}},{key:'render',value:function render(){var _this2=this;var _props$store$dailyMon2=this.props.store.dailyMonth,print=_props$store$dailyMon2.print,loading=_props$store$dailyMon2.loading,foodData=_props$store$dailyMon2.foodData,date=_props$store$dailyMon2.date;var columns=[{title:_react2.default.createElement('span',null,'Food&Beverage',_react2.default.createElement('br',null),' \u9910\u996E'),dataIndex:'name',key:'name',align:"center",// width: 200,
render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Today',_react2.default.createElement('br',null),' \u4ECA\u65E5\u5B9E\u9645'),children:[{title:_react2.default.createElement('span',null,'Actual',_react2.default.createElement('br',null),' \u5B9E\u9645\u6536\u5165'),dataIndex:'actual',key:'actual',align:"center",// width: 150,
render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"actual",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['Today<br /> 今日实际',"Actual<br /> 实际收入"],record:record,sqlName:"m_daily"}};if(index==10)props.type="number";return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Covers',_react2.default.createElement('br',null),' \u4EBA\u6570'),dataIndex:'covers',key:'covers',align:"center",// width: 150,
render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"covers",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['Today<br /> 今日实际',"Covers<br /> 人数"],record:record,sqlName:"m_daily"}};if(index==10)props.type="number";if(index==9)props.type="";return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Average Check',_react2.default.createElement('br',null),' \u4EBA\u5747\u6D88\u8D39'),dataIndex:'average',key:'average',align:"center",// width: 150,
render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"average",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['Today<br /> 今日实际',"Average Check<br /> 人均消费"],record:record,sqlName:"m_daily"}};if(index==9)props.type="";return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]},{title:_react2.default.createElement('span',null,'Last Year ',_react2.default.createElement('br',null),' \u53BB\u5E74\u5F53\u65E5'),children:[{title:_react2.default.createElement('span',null,'Actual',_react2.default.createElement('br',null),' \u5B9E\u9645\u6536\u5165'),dataIndex:'last_actual',key:'last_actual',align:"center",// width: 150,
render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_actual",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['Last Year <br /> 去年当日',"Actual<br /> 实际收入"],record:record,sqlName:"m_daily"}};if(index==10)props.type="number";return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Covers',_react2.default.createElement('br',null),' \u4EBA\u6570'),dataIndex:'last_covers',key:'last_covers',align:"center",// width: 150,
render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_covers",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['Last Year <br /> 去年当日',"Covers<br /> 人数"],record:record,sqlName:"m_daily"}};if(index==10)props.type="number";if(index==9)props.type="";return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Average Check',_react2.default.createElement('br',null),' \u4EBA\u5747\u6D88\u8D39'),dataIndex:'last_average',key:'last_average',align:"center",// width: 150,
render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last_average",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['Last Year <br /> 去年当日',"Average Check<br /> 人均消费"],record:record,sqlName:"m_daily"}};if(index==9)props.type="";return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]}];return _react2.default.createElement('div',{className:'table7_1_1 '},_react2.default.createElement('div',{id:'daily'},_react2.default.createElement(_row2.default,{className:'title'},_react2.default.createElement(_row2.default,null,' Daily Revenue Report \u6BCF\u65E5\u7ECF\u8425\u62A5\u8868'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.props.store.dailyMonth.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.props.store.dailyMonth.getData(str);(0,_mobx.runInAction)(function(){_this2.props.store.dailyMonth.date=str;});}}),_react2.default.createElement(_button2.default,{type:'primary',style:{marginLeft:10},onClick:function onClick(){return _this2.props.store.dailyMonth.aKeyToSave(date);},loading:print},'\u4E00\u952E\u4FDD\u5B58'))),_react2.default.createElement('div',{className:'daily'},_react2.default.createElement('div',{className:'month'},_react2.default.createElement(_Rooms2.default,null)),_react2.default.createElement('div',{className:'day'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_1_1'},_react2.default.createElement(_table2.default,{columns:columns,dataSource:(0,_mobx.toJS)(foodData),size:'middle',bordered:true,pagination:false,loading:loading,className:'content',rowKey:function rowKey(record,index){return index;}})))),_react2.default.createElement(_Total2.default,null)),_react2.default.createElement(_row2.default,{className:'table-footer-btn'}));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(8);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _mobxReact=__webpack_require__(18);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(name,value,i){var _this$props$store$dai=_this.props.store.dailyMonth,roomData=_this$props$store$dai.roomData,dayData=_this$props$store$dai.dayData,foodData=_this$props$store$dai.foodData;var data=[].concat(_toConsumableArray((0,_mobx.toJS)(dayData)));data[i][name]=value;_this.props.store.dailyMonth.onChange({roomData:roomData,foodData:foodData,dayData:data});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'render',value:function render(){var _this2=this;var _props$store$dailyMon=this.props.store.dailyMonth,dayData=_props$store$dailyMon.dayData,loading=_props$store$dailyMon.loading;var columns=[{title:_react2.default.createElement('span',null,'Other Revenue ',_react2.default.createElement('br',null),' \u5176\u4ED6\u6536\u5165'),dataIndex:'name',key:'name',align:"center",width:300,render:function render(text,record,index){var props={text:"Total Other Revenue <br/> 其他收入总计",index:index,type:'text',name:"name"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Today ',_react2.default.createElement('br',null),' \u4ECA\u65E5\u5B9E\u9645'),dataIndex:'other_day',key:'other_day',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"other_day",onChange:_this2.onChange,compared:{title:['Today <br /> 今日实际'],record:record,sqlName:"m_daily_total"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Last Year ',_react2.default.createElement('br',null),' \u53BB\u5E74\u5F53\u65E5'),dataIndex:'other_last',key:'other_last',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"other_last",onChange:_this2.onChange,compared:{title:['Last Year <br /> 去年当日'],record:record,sqlName:"m_daily_total"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];var columnsRev=[{title:_react2.default.createElement('span',null,'Daily Revenue',_react2.default.createElement('br',null),' \u6BCF\u65E5\u603B\u6536\u5165'),dataIndex:'name',key:'name',align:"center",width:300,render:function render(text,record,index){var props={text:"Grand Total<br/>总计",index:index,type:'text',name:"name"};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Today ',_react2.default.createElement('br',null),' \u4ECA\u65E5\u5B9E\u9645'),dataIndex:'rev_day',key:'rev_day',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"rev_day",compared:{title:['Today <br /> 今日实际'],record:record,sqlName:"m_daily_total"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Last Year ',_react2.default.createElement('br',null),' \u53BB\u5E74\u5F53\u65E5'),dataIndex:'rev_last',key:'rev_last',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"rev_last",compared:{title:['Last Year <br /> 去年当日'],record:record,sqlName:"m_daily_total"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];return _react2.default.createElement('div',{className:'total-table'},_react2.default.createElement(_table2.default,{columns:columns,dataSource:(0,_mobx.toJS)(dayData),size:'middle',bordered:true,pagination:false,loading:loading,className:'content',rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_table2.default,{columns:columnsRev,dataSource:(0,_mobx.toJS)(dayData),size:'middle',bordered:true,pagination:false,loading:loading,className:'content',rowKey:function rowKey(record,index){return index;}}));}}]);return App;}(_react.Component))||_class)||_class);exports.default=App;

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(4);__webpack_require__(8);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var totalIndex=[];var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(name,value,i){var _this$props$store$dai=_this.props.store.dailyMonth,roomData=_this$props$store$dai.roomData,dayData=_this$props$store$dai.dayData,foodData=_this$props$store$dai.foodData;var data=[].concat(_toConsumableArray((0,_mobx.toJS)(roomData)));data[i][name]=value;_this.props.store.dailyMonth.onChange({roomData:data,foodData:foodData,dayData:dayData});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'render',value:function render(){var _this2=this;var _props$store$dailyMon=this.props.store.dailyMonth,roomData=_props$store$dailyMon.roomData,loading=_props$store$dailyMon.loading;var inputIndex=[0,1,2,6,7];var columns=[{title:_react2.default.createElement('span',null,'Rooms',_react2.default.createElement('br',null),' \u5BA2\u623F'),dataIndex:'name',key:'name',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Today',_react2.default.createElement('br',null),' \u4ECA\u65E5\u5B9E\u9645'),dataIndex:'actual',key:'actual',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"actual",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['Today<br /> 今日实际'],record:record,sqlName:"m_daily_month"}};if(inputIndex.includes(index))props.type="number";if([3,8].includes(index))props.type="percent";return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('span',null,'Last Year ',_react2.default.createElement('br',null),' \u53BB\u5E74\u5F53\u65E5'),dataIndex:'last',key:'last',align:"center",render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"last",onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:['Last Year <br /> 去年当日'],record:record,sqlName:"m_daily_month"}};if(inputIndex.includes(index))props.type="number";if([3,8].includes(index))props.type="percent";return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];return _react2.default.createElement('div',{className:'table7_1_1 '},_react2.default.createElement(_row2.default,{className:'title',id:'table4_1_1'},_react2.default.createElement(_table2.default,{columns:columns,dataSource:(0,_mobx.toJS)(roomData),size:'middle',bordered:true,pagination:false,loading:loading,className:'content',rowKey:function rowKey(record,index){return index;}})));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(10);__webpack_require__(42);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2170);var _data2=_interopRequireDefault(_data);var _chart=__webpack_require__(2171);var _chart2=_interopRequireDefault(_chart);__webpack_require__(2172);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RangePicker=_datePicker2.default.RangePicker;var Option=_select2.default.Option;var App=function(_Component){_inherits(App,_Component);function App(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_this.state={startTime:(0,_moment2.default)().format('YYYY-MM')+"-01",endTime:(0,_moment2.default)().format('YYYY-MM-DD'),data:{type:"daily_month",name:"Total Rooms <br/>总房数",key:"actual,last"},loading:false},_this.onSubmit=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var _extends2,_this$state,data,startTime,endTime,key,dataFrom,headres,json,res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({loading:true});_context.prev=1;_this$state=_this.state,data=_this$state.data,startTime=_this$state.startTime,endTime=_this$state.endTime;if(!((0,_moment2.default)(startTime).format('YYYY')!=(0,_moment2.default)(endTime).format('YYYY'))){_context.next=7;break;}_message3.default.error('请选择相同年份！');_this.setState({loading:false});return _context.abrupt('return');case 7:key=data.key.split(",");dataFrom=new FormData();dataFrom.append('data',JSON.stringify(_extends({},data,(_extends2={year:key[0],last:key[1],type:data.type.includes("total")?'daily_total':data.type},_defineProperty(_extends2,'year',(0,_moment2.default)(startTime).format('YYYY')),_defineProperty(_extends2,'startMonth',(0,_moment2.default)(startTime).format('M')),_defineProperty(_extends2,'startDay',(0,_moment2.default)(startTime).format('D')),_defineProperty(_extends2,'endDay',(0,_moment2.default)(endTime).format('D')),_defineProperty(_extends2,'endMonth',(0,_moment2.default)(endTime).format('M')),_extends2))));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context.next=13;return fetch('/dayChart  ',headres);case 13:json=_context.sent;_context.next=16;return json.json();case 16:res=_context.sent;(0,_chart2.default)(res.data,data);_this.setState({loading:false});_context.next=26;break;case 21:_context.prev=21;_context.t0=_context['catch'](1);console.log(_context.t0);_message3.default.error('数据处理失败！');_this.setState({loading:false});case 26:case'end':return _context.stop();}}},_callee,_this2,[[1,21]]);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){this.onSubmit();}},{key:'render',value:function render(){var _this3=this;var _state=this.state,startTime=_state.startTime,endTime=_state.endTime,data=_state.data,loading=_state.loading;var nameList=_data2.default.find(function(x){return x.value===data.type;}).children||[];var keyList=nameList.find(function(x){return x.value===data.name;}).children||[];return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'dailyChart'},_react2.default.createElement('div',{className:'title'},'1.2 \u5355\u9152\u5E97\u6708\u5EA6\u6570\u636E\u53BB\u5E74\u540C\u6BD4\u5206\u6790'),_react2.default.createElement('div',{className:'month-select'},_react2.default.createElement(RangePicker,{value:[(0,_moment2.default)(startTime,'YYYY-MM-DD'),(0,_moment2.default)(endTime,'YYYY-MM-DD')],onChange:function onChange(date,str){_this3.setState({startTime:str[0],endTime:str[1]});}})),_react2.default.createElement('div',{style:{marginTop:20}},_react2.default.createElement(_select2.default,{className:'select-style',value:data.type,onChange:function onChange(v){var d=_extends({},data,{type:v});var name=_data2.default.find(function(x){return x.value===v;}).children;d.name=name[0].value;var key=name.find(function(x){return x.value===d.name;}).children;d.key=key[0].value;_this3.setState({data:d});}},_data2.default.map(function(v){return _react2.default.createElement(Option,{key:v.value,value:v.value},v.name.replace("<br/>"," "));})),_react2.default.createElement(_select2.default,{className:'select-style',value:data.name,onChange:function onChange(v){var d=_extends({},data,{name:v});d.key=nameList.find(function(x){return x.value===v;}).children[0].value;_this3.setState({data:d});}},nameList.map(function(v){return _react2.default.createElement(Option,{key:v.value,value:v.value},v.name.replace("<br/>"," "));})),_react2.default.createElement(_select2.default,{className:'select-style',value:data.key,onChange:function onChange(v){var d=_extends({},data,{key:v});_this3.setState({data:d});}},keyList.map(function(v){return _react2.default.createElement(Option,{key:v.value,value:v.value},v.name.replace("<br/>"," "));})),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSubmit},'\u786E\u5B9A')),_react2.default.createElement('div',{id:'chart-element',style:{height:400,marginTop:20}})));}}]);return App;}(_react.Component);exports.default=App;

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=[// 客房
{name:"Rooms 客房",value:"daily_month",children:[{name:"Total Rooms <br/>总房数",value:"Total Rooms <br/>总房数",children:[{name:"Today 今日实际",value:"actual,last"}]},{name:"Total Rooms Available<br/>可售房",value:"Total Rooms Available<br/>可售房",children:[{name:"Today 今日实际",value:"actual,last"}]},{name:"Total Occupied<br/>占用房合计",value:"Total Occupied<br/>占用房合计",children:[{name:"Today 今日实际",value:"actual,last"}]},{name:"Paid Occupancy%<br/>出租率",value:"Paid Occupancy%<br/>出租率",children:[{name:"Today 今日实际",value:"actual,last"}]},{name:"Average RM Rate(RMB)<br/>平均房价（人民币）",value:"Average RM Rate(RMB)<br/>平均房价（人民币）",children:[{name:"Today 今日实际",value:"actual,last"}]},{name:"Revpar<br/>平均每间房收益",value:"Revpar<br/>平均每间房收益",children:[{name:"Today 今日实际",value:"actual,last"}]},{name:"Total Room Revenue<br/>房费合计",value:"Total Room Revenue<br/>房费合计",children:[{name:"Today 今日实际",value:"actual,last"}]},{name:"Total No. Of Guest<br/>住店客人数",value:"Total No. Of Guest<br/>住店客人数",children:[{name:"Today 今日实际",value:"actual,last"}]},{name:"Double Occupancy%<br/>双人入住率",value:"Double Occupancy%<br/>双人入住率",children:[{name:"Today 今日实际",value:"actual,last"}]}]},{name:"Food&Beverage 餐饮",value:"daily",children:[{name:"Coffee Shop (BF)<br/>豪生咖啡厅（早餐）",value:"Coffee Shop (BF)<br/>豪生咖啡厅（早餐）",children:[{name:"Actual 实际收入",value:"actual,last_actual"},{name:"Covers 人数",value:"covers,last_covers"},{name:"Average Check 人均消费",value:"average,last_average"}]},{name:"Coffee Shop (L&D)<br/>豪生咖啡厅（午晚餐）",value:"Coffee Shop (L&D)<br/>豪生咖啡厅（午晚餐）",children:[{name:"Actual 实际收入",value:"actual,last_actual"},{name:"Covers 人数",value:"covers,last_covers"},{name:"Average Check 人均消费",value:"average,last_average"}]},{name:"Chinese Restaurant<br/>中餐厅",value:"Chinese Restaurant<br/>中餐厅",children:[{name:"Actual 实际收入",value:"actual,last_actual"},{name:"Covers 人数",value:"covers,last_covers"},{name:"Average Check 人均消费",value:"average,last_average"}]},{name:"Special Restaurant<br/>特色餐厅",value:"Special Restaurant<br/>特色餐厅",children:[{name:"Actual 实际收入",value:"actual,last_actual"},{name:"Covers 人数",value:"covers,last_covers"},{name:"Average Check 人均消费",value:"average,last_average"}]},{name:"Lobby Lounge<br/>大堂酒吧",value:"Lobby Lounge<br/>大堂酒吧",children:[{name:"Actual 实际收入",value:"actual,last_actual"},{name:"Covers 人数",value:"covers,last_covers"},{name:"Average Check 人均消费",value:"average,last_average"}]},{name:"Room Service<br/>送餐服务",value:"Room Service<br/>送餐服务",children:[{name:"Actual 实际收入",value:"actual,last_actual"},{name:"Covers 人数",value:"covers,last_covers"},{name:"Average Check 人均消费",value:"average,last_average"}]},{name:"Banquet<br/>宴会厅",value:"Banquet<br/>宴会厅",children:[{name:"Actual 实际收入",value:"actual,last_actual"},{name:"Covers 人数",value:"covers,last_covers"},{name:"Average Check 人均消费",value:"average,last_average"}]},{name:"Mini Bar<br/>迷你吧",value:"Mini Bar<br/>迷你吧",children:[{name:"Actual 实际收入",value:"actual,last_actual"},{name:"Covers 人数",value:"covers,last_covers"},{name:"Average Check 人均消费",value:"average,last_average"}]},{name:"Executive Club<br/>行政楼层",value:"Executive Club<br/>行政楼层",children:[{name:"Actual 实际收入",value:"actual,last_actual"},{name:"Covers 人数",value:"covers,last_covers"},{name:"Average Check 人均消费",value:"average,last_average"}]},{name:"Other Income<br/>其他收入",value:"Other Income<br/>其他收入",children:[{name:"Actual 实际收入",value:"actual,last_actual"},{name:"Covers 人数",value:"covers,last_covers"},{name:"Average Check 人均消费",value:"average,last_average"}]},{name:"Total F&B Revenue<br/>餐饮合计",value:"Total F&B Revenue<br/>餐饮合计",children:[{name:"Actual 实际收入",value:"actual,last_actual"},{name:"Covers 人数",value:"covers,last_covers"},{name:"Average Check 人均消费",value:"average,last_average"}]}]},{name:"Other Revenue 其他收入",value:"daily_total",children:[{name:"Total Other Revenue <br/> 其他收入总计",value:"Total Other Revenue <br/> 其他收入总计",children:[{name:"Today 今日实际",value:"other_day,other_last"}]}]},{name:"Daily Revenue 每日总收入",value:"total",children:[{name:"Grand Total<br/>总计",value:"Grand Total<br/>总计",children:[{name:"Today 今日实际",value:"rev_day,rev_last"}]}]}];

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=function(data,_ref){var key=_ref.key,name=_ref.name;var listName=['Today 今日实际','Last Year 去年当日'];var myChart=_echarts2.default.init(document.getElementById('chart-element'));// 做下去重处理，以防重复
data=data.reduce(function(a,b){if(!a.find(function(item){return item.month==b.month&&item.day==b.day;}))a.push(b);return a;},[]);data.sort(function(a,b){return a.month-b.month||a.day-b.day;});key=key.split(',');var dataX=data.map(function(x){return x.month+"-"+x.day;});var isPercent=name.includes('%');var option={color:color,backgroundColor:"#fff",tooltip:{trigger:'axis'},legend:{data:listName,bottom:"5%"},grid:{left:'10%',right:'10%',bottom:'20%'},xAxis:{type:'category',boundaryGap:false,data:dataX},yAxis:{type:'value',axisLine:{show:false}},series:key.map(function(x,i){return{name:listName[i],type:'line',smooth:true,data:data.map(function(v){return isPercent?(0,_method.numConvert)(v[x]*100).toFixed(1):(0,_method.numConvert)(v[x]).toFixed(2);})};})};myChart.setOption(option);};var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);var _method=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var color=['#4c9bf2','#4AC18E','#D9534F','#67A8E4'];

/***/ }),
/* 2172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _radio=__webpack_require__(112);var _radio2=_interopRequireDefault(_radio);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(127);__webpack_require__(4);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _data=__webpack_require__(2174);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getDateData=function(date){var year=(0,_moment2.default)(date).format('YYYY');var month=(0,_moment2.default)(date).format('M');var days=(0,_moment2.default)(date).daysInMonth();var name=_this.state.name;fetch('/dailyHotels?year='+year+'&month='+month+'&days='+days+'&name='+name,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){var data=x.data||[];var hotels=data.map(function(x){return{name:x.name,code:x.code};});var dataSource=[];var _loop=function _loop(_index){dataSource[_index]=_extends({day:_index==days?'Total':_index+1},data.reduce(function(a,b,i){var d={};var code=b.code||i*i;if(_index==days){var _d;d=(_d={},_defineProperty(_d,code+'occ',b.occ),_defineProperty(_d,code+'arr',b.arr),_defineProperty(_d,code+'rev',b.rev),_defineProperty(_d,code+'revpar',b.revpar),_defineProperty(_d,code+'total',b.total),_defineProperty(_d,code+'available',b.available),_defineProperty(_d,code+'occupied',b.occupied),_defineProperty(_d,code+'fb',b.fb),_d);}else{var _d2;d=(_d2={},_defineProperty(_d2,code+'occ',b.data[_index].occ),_defineProperty(_d2,code+'arr',b.data[_index].arr),_defineProperty(_d2,code+'rev',b.data[_index].rev),_defineProperty(_d2,code+'revpar',b.data[_index].revpar),_defineProperty(_d2,code+'total',b.data[_index].total),_defineProperty(_d2,code+'available',b.data[_index].available),_defineProperty(_d2,code+'occupied',b.data[_index].occupied),_defineProperty(_d2,code+'fb',b.data[_index].fb),_d2);}return _extends({},a,d);},{}));};for(var _index=0;_index<=days;_index++){_loop(_index);}_this.setState({loading:false,hotels:hotels,data:dataSource});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.downloadExcel=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var tableName,innerHtml,html,blob;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:tableName=''+(0,_moment2.default)(_this.state.date).format('YYYY-MM');innerHtml='\n          <caption>'+tableName+'</caption>\n          '+document.getElementById('table').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n        ';html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+'.xls');_this.setState({print:false});case 6:case'end':return _context.stop();}}},_callee,_this2);}));_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],print:false,hotels:[],name:"actual"};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print,hotels=_state.hotels;var columns=[].concat(_toConsumableArray((0,_data.columnsData)(hotels,date,print)));var width=hotels.length*800+70;return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_1_1',style:{width:this.state.print?width*2:'auto'}},_react2.default.createElement(_row2.default,null,'1.3 \u9152\u5E97\u6708\u5EA6\u7EDF\u8BA1\u6C47\u603B'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}}),_react2.default.createElement(_radio2.default.Group,{style:{marginLeft:10},defaultValue:this.state.name,onChange:function onChange(e){_this3.setState({name:e.target.value||"actual",loading:true,data:[]},function(){_this3.getDateData(_this3.state.date);});}},_react2.default.createElement(_radio2.default,{value:'actual'},'This Year'),_react2.default.createElement(_radio2.default,{value:'last_year'},'Last Year'))),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',id:'table',bordered:true,pagination:false,className:'content',style:{width:'auto'},scroll:this.state.print?{}:{x:width,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_4_1'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:this.state.print},'\u5BFC\u51FAExcel')))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columnsData=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var columnsData=exports.columnsData=function columnsData(data,date,print){var totalIndex=[].concat(_toConsumableArray(new Array((0,_moment2.default)(date).daysInMonth()).fill(1).map(function(x,i){return i+1;}).filter(function(x){return(0,_moment2.default)(date+("-"+x)).format('E')>5;}).map(function(x){return x-1;})),[(0,_moment2.default)(date).daysInMonth()]);return[{title:(0,_moment2.default)(date).format('YY-MMM'),key:'day',align:"center",dataIndex:'day',fixed:print?false:"left",width:70,render:function render(text,record,index){return _react2.default.createElement("div",{className:"table-padding "+(totalIndex.includes(index)?'table-color-footer':'')+" ",style:{textAlign:"left"}},text);}}].concat(_toConsumableArray(data.map(function(x,i){return{title:_react2.default.createElement("span",null,x.name.replace(/[^a-zA-Z0-9\s]/g,''),_react2.default.createElement("br",null),x.name.replace(/[^\u4E00-\u9FA5]/g,"")),align:"center",children:[,{title:'Available',dataIndex:(x.code||i*i)+"available",key:(x.code||i*i)+"available",align:"center",width:100,render:function render(text,record,index){var props={text:text||0,index:index,type:"number",name:x.key,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Occupied',dataIndex:(x.code||i*i)+"occupied",key:(x.code||i*i)+"occupied",align:"center",width:100,render:function render(text,record,index){var props={text:text||0,index:index,type:"number",name:x.key,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'%',dataIndex:(x.code||i*i)+"occ",key:(x.code||i*i)+"occ",align:"center",width:100,render:function render(text,record,index){var props={text:text||0,index:index,type:"percent",name:x.key,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'ADR',dataIndex:(x.code||i*i)+"arr",key:(x.code||i*i)+"arr",align:"center",width:100,render:function render(text,record,index){var props={text:text||0,index:index,type:"number",name:x.key,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'RevPAR',dataIndex:(x.code||i*i)+"revpar",key:(x.code||i*i)+"revpar",align:"center",width:100,render:function render(text,record,index){var props={text:text||0,index:index,type:"number",name:x.key,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'Rm Rev',dataIndex:(x.code||i*i)+"rev",key:(x.code||i*i)+"rev",align:"center",width:100,render:function render(text,record,index){var props={text:text||0,index:index,type:"number",name:x.key,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'F&B',dataIndex:(x.code||i*i)+"fb",key:(x.code||i*i)+"fb",align:"center",width:100,render:function render(text,record,index){var props={text:text||0,index:index,type:"number",name:x.key,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'TTL Rev',dataIndex:(x.code||i*i)+"total",key:(x.code||i*i)+"total",align:"center",width:100,render:function render(text,record,index){var props={text:text||0,index:index,type:"number",name:x.key,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]};})));};

/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _radio=__webpack_require__(112);var _radio2=_interopRequireDefault(_radio);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(127);__webpack_require__(4);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _data=__webpack_require__(2176);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _axios=__webpack_require__(86);var _axios2=_interopRequireDefault(_axios);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.getDateData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var year,month,days,name,x,data,hotels,dataSource,_loop,_index;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:year=(0,_moment2.default)(date).format('YYYY');month=(0,_moment2.default)(date).format('M');days=(0,_moment2.default)(date).daysInMonth();name=_this.state.name;_context.next=6;return _axios2.default.get('/api/dailyHotels?year='+year+'&month='+month+'&days='+days+'&name='+name);case 6:x=_context.sent;data=x.data||[];hotels=data.map(function(x){return{name:x.name,code:x.code};});dataSource=[];_loop=function _loop(_index){dataSource[_index]=_extends({day:_index==days?'Total':_index+1},data.reduce(function(a,b,i){var d={};var code=b.code||i*i;if(_index==days){var _d;d=(_d={},_defineProperty(_d,code+'coffeeBF',b.coffeeBF),_defineProperty(_d,code+'coffeeLD',b.coffeeLD),_defineProperty(_d,code+'Chinese',b.Chinese),_defineProperty(_d,code+'Special',b.Special),_defineProperty(_d,code+'Lobby',b.Lobby),_defineProperty(_d,code+'Room',b.Room),_defineProperty(_d,code+'Banquet',b.Banquet),_defineProperty(_d,code+'Mini',b.Mini),_defineProperty(_d,code+'Executive',b.Executive),_defineProperty(_d,code+'Other',b.Other),_defineProperty(_d,code+'Total',b.Total),_d);}else{var _d2;d=(_d2={},_defineProperty(_d2,code+'coffeeBF',b.data[_index].coffeeBF),_defineProperty(_d2,code+'coffeeLD',b.data[_index].coffeeLD),_defineProperty(_d2,code+'Chinese',b.data[_index].Chinese),_defineProperty(_d2,code+'Special',b.data[_index].Special),_defineProperty(_d2,code+'Lobby',b.data[_index].Lobby),_defineProperty(_d2,code+'Room',b.data[_index].Room),_defineProperty(_d2,code+'Banquet',b.data[_index].Banquet),_defineProperty(_d2,code+'Mini',b.data[_index].Mini),_defineProperty(_d2,code+'Executive',b.data[_index].Executive),_defineProperty(_d2,code+'Other',b.data[_index].Other),_defineProperty(_d2,code+'Total',b.data[_index].Total),_d2);}return _extends({},a,d);},{}));};for(_index=0;_index<=days;_index++){_loop(_index);}_this.setState({loading:false,hotels:hotels,data:dataSource});case 13:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.downloadExcel=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var tableName,innerHtml,html,blob;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:tableName=''+(0,_moment2.default)(_this.state.date).format('YYYY-MM');innerHtml='\n          <caption>'+tableName+'</caption>\n          '+document.getElementById('table').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n        ';html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+'.xls');_this.setState({print:false});case 6:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],print:false,hotels:[],name:"actual"};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print,hotels=_state.hotels;var columns=[].concat(_toConsumableArray((0,_data.columnsData)(hotels,date,print)));var width=hotels.length*800+70;return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_1_1',style:{width:this.state.print?width*2:'auto'}},_react2.default.createElement(_row2.default,null,'1.4 \u9152\u5E97\u6708\u5EA6\u9910\u996E\u7EDF\u8BA1\u6C47\u603B'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}}),_react2.default.createElement(_radio2.default.Group,{style:{marginLeft:10},defaultValue:this.state.name,onChange:function onChange(e){_this3.setState({name:e.target.value||"actual",loading:true,data:[]},function(){_this3.getDateData(_this3.state.date);});}},_react2.default.createElement(_radio2.default,{value:'actual'},'This Year'),_react2.default.createElement(_radio2.default,{value:'last_year'},'Last Year'))),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',id:'table',bordered:true,pagination:false,className:'content',style:{width:'auto'},scroll:this.state.print?{}:{x:width,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_4_1'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:this.state.print},'\u5BFC\u51FAExcel')))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columnsData=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var columnsData=exports.columnsData=function columnsData(data,date,print){var totalIndex=[].concat(_toConsumableArray(new Array((0,_moment2.default)(date).daysInMonth()).fill(1).map(function(x,i){return i+1;}).filter(function(x){return(0,_moment2.default)(date+("-"+x)).format('E')>5;}).map(function(x){return x-1;})),[(0,_moment2.default)(date).daysInMonth()]);return[{title:(0,_moment2.default)(date).format('YY-MMM'),key:'day',align:"center",dataIndex:'day',fixed:print?false:"left",width:70,render:function render(text,record,index){return _react2.default.createElement("div",{className:"table-padding "+(totalIndex.includes(index)?'table-color-footer':'')+" ",style:{textAlign:"left"}},text);}}].concat(_toConsumableArray(data.map(function(x,i){return{title:_react2.default.createElement("span",null,x.name.replace(/[^a-zA-Z0-9\s]/g,''),_react2.default.createElement("br",null),x.name.replace(/[^\u4E00-\u9FA5]/g,"")),align:"center",children:[,{title:_react2.default.createElement("span",null,"Coffee Shop (BF)",_react2.default.createElement("br",null),"\u8C6A\u751F\u5496\u5561\u5385\uFF08\u65E9\u9910\uFF09"),dataIndex:(x.code||i*i)+"coffeeBF",key:(x.code||i*i)+"coffeeBF",align:"center",width:100,render:function render(text,record,index){var props={text:text||0,index:index,type:"number",name:x.key,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("span",null,"Coffee Shop (L&D)",_react2.default.createElement("br",null),"\u8C6A\u751F\u5496\u5561\u5385\uFF08\u5348\u665A\u9910\uFF09"),dataIndex:(x.code||i*i)+"coffeeLD",key:(x.code||i*i)+"coffeeLD",align:"center",width:100,render:function render(text,record,index){var props={text:text||0,index:index,type:"number",name:x.key,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("span",null,"Chinese Restaurant",_react2.default.createElement("br",null),"\u4E2D\u9910\u5385"),dataIndex:(x.code||i*i)+"Chinese",key:(x.code||i*i)+"Chinese",align:"center",width:100,render:function render(text,record,index){var props={text:text||0,index:index,type:"number",name:x.key,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("span",null,"Special Restaurant",_react2.default.createElement("br",null),"\u7279\u8272\u9910\u5385"),dataIndex:(x.code||i*i)+"Special",key:(x.code||i*i)+"Special",align:"center",width:100,render:function render(text,record,index){var props={text:text||0,index:index,type:"number",name:x.key,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("span",null,"Lobby Lounge",_react2.default.createElement("br",null),"\u5927\u5802\u9152\u5427"),dataIndex:(x.code||i*i)+"Lobby",key:(x.code||i*i)+"Lobby",align:"center",width:100,render:function render(text,record,index){var props={text:text||0,index:index,type:"number",name:x.key,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("span",null,"Room Service",_react2.default.createElement("br",null),"\u9001\u9910\u670D\u52A1"),dataIndex:(x.code||i*i)+"Room",key:(x.code||i*i)+"Room",align:"center",width:100,render:function render(text,record,index){var props={text:text||0,index:index,type:"number",name:x.key,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("span",null,"Banquet",_react2.default.createElement("br",null),"\u5BB4\u4F1A\u5385"),dataIndex:(x.code||i*i)+"Banquet",key:(x.code||i*i)+"Banquet",align:"center",width:100,render:function render(text,record,index){var props={text:text||0,index:index,type:"number",name:x.key,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("span",null,"Mini Bar",_react2.default.createElement("br",null),"\u8FF7\u4F60\u5427"),dataIndex:(x.code||i*i)+"Mini",key:(x.code||i*i)+"Mini",align:"center",width:100,render:function render(text,record,index){var props={text:text||0,index:index,type:"number",name:x.key,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("span",null,"Executive Club",_react2.default.createElement("br",null),"\u884C\u653F\u697C\u5C42"),dataIndex:(x.code||i*i)+"Executive",key:(x.code||i*i)+"Executive",align:"center",width:100,render:function render(text,record,index){var props={text:text||0,index:index,type:"number",name:x.key,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("span",null,"Other Income",_react2.default.createElement("br",null),"\u5176\u4ED6\u6536\u5165"),dataIndex:(x.code||i*i)+"Other",key:(x.code||i*i)+"Other",align:"center",width:100,render:function render(text,record,index){var props={text:text||0,index:index,type:"number",name:x.key,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement("span",null,"Total F&B Revenue",_react2.default.createElement("br",null),"\u9910\u996E\u5408\u8BA1"),dataIndex:(x.code||i*i)+"Total",key:(x.code||i*i)+"Total",align:"center",width:100,render:function render(text,record,index){var props={text:text||0,index:index,type:"number",name:x.key,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}]};})));};

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(8);__webpack_require__(14);__webpack_require__(4);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _compute=__webpack_require__(2178);var _axios=__webpack_require__(86);var _axios2=_interopRequireDefault(_axios);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().format('YYYY-MM-DD'),data:[],loading:true,loadingSave:false,print:false,key:"daily_warn"},_this.computeNum=function(data,key){var _this$setState;data=(0,_compute.compute)(data);_this.setState((_this$setState={},_defineProperty(_this$setState,key,data),_defineProperty(_this$setState,"loading",false),_this$setState));},_this.onChange=function(name,value,i){var key=arguments.length>3&&arguments[3]!==undefined?arguments[3]:"talbe1";var data=_this.state[key];data[i][name]=value;_this.computeNum(data,key);},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_this.setState({loading:true,data:[]});_context.next=4;return _axios2.default.get('/api/daily1_5',{params:{date:date}});case 4:res=_context.sent;_this.setState({data:res.data,loading:false});_context.next=12;break;case 8:_context.prev=8;_context.t0=_context["catch"](0);_this.setState({loading:false});console.error(_context.t0);case 12:case"end":return _context.stop();}}},_callee,_this2,[[0,8]]);}));return function(_x2){return _ref2.apply(this,arguments);};}(),_this.downloadExcel=function(id){var tableName=_this.state.date+" 1.5 \u6BCF\u65E5\u7ECF\u8425\u62A5\u8868\u62A5\u8B66\u8BB0\u5F55";var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById(id).innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+".xls");_this.setState({print:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print,loading=_state.loading,key=_state.key;return _react2.default.createElement("div",{className:"table7_1_1 tableHeight"},_react2.default.createElement(_row2.default,{className:"title",id:"view4_1_4"},_react2.default.createElement(_row2.default,null,"1.5 \u6BCF\u65E5\u7ECF\u8425\u62A5\u8868\u62A5\u8B66\u8BB0\u5F55"),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(_datePicker2.default,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(date,"YYYY-MM-DD"),format:"YYYY-MM-DD",onChange:function onChange(date,str){_this3.getData(date);}})),_react2.default.createElement(_table2.default,{columns:(0,_compute.columns)(function(){},date,print),dataSource:data,size:"middle",id:"table1",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{y:500},rowKey:function rowKey(record,index){return index;}}),!print&&_react2.default.createElement(_button2.default,{type:"primary",style:{marginTop:20,marginLeft:"calc(100% - 200px)"},onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel('table1');});},loading:print},"\u5BFC\u51FAExcel")));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columns=exports.compute=undefined;var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var totalIndex=[];var compute=exports.compute=function compute(data){return _lodash2.default.cloneDeep(data);};var columns=exports.columns=function columns(onChange,date){return[{title:_react2.default.createElement("div",null,"\u9152\u5E97\u540D\u79F0"),dataIndex:'name',key:'name',align:"center",width:250,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u51FA\u79DF\u7387",dataIndex:'occ',key:'occ',align:"center",width:120,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"occ",onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5E73\u5747\u623F\u4EF7\uFF08\u4EBA\u6C11\u5E01\uFF09",dataIndex:'adr',key:'adr',align:"center",width:120,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"adr",onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5E73\u5747\u6BCF\u95F4\u623F\u6536\u76CA",dataIndex:'revpar',key:'revpar',align:"center",width:120,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"revpar",onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u623F\u8D39\u5408\u8BA1",dataIndex:'room',key:'room',align:"center",width:120,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"room",onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u9910\u996E\u5408\u8BA1",dataIndex:'fb',key:'fb',align:"center",width:120,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"fb",onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5176\u4ED6\u6536\u5165\u603B\u8BA1",dataIndex:'other',key:'other',align:"center",width:120,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"other",onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u6BCF\u65E5\u603B\u6536\u5165\u603B\u8BA1",dataIndex:'rev',key:'rev',align:"center",width:120,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"rev",onChange:onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}}];};

/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _data=__webpack_require__(717);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var totalIndex=[];var Option=_select2.default.Option;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.onChange=function(name,value,i){};_this.getDateData=function(date){fetch('/bp/headquarters/8?year='+(0,_moment2.default)(date).format('YYYY'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){var data=x.data||[];_this.setState({data:data,loading:false});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var data=_this.state.data.map(function(x,i){return _extends({},x,{year:year});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/bpAdd_8_0_new',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadExcel=function(id){var tableName='Budget Summary';var innerHtml='\n          <caption>'+tableName+'</caption>\n          '+document.getElementById(id).innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n        ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+'.xls');_this.setState({print:false});};var month=(0,_moment2.default)().format('M');_this.state={date:month<3?(0,_moment2.default)().format('YYYY'):(0,_moment2.default)().add(1,'y').format('YYYY'),loadingSave:false,print:false,data:[],loading:true,columnData:[],dateData:[]};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){var date=Number(this.state.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this2=this;var _state=this.state,print=_state.print,data=_state.data,date=_state.date,loading=_state.loading,columnData=_state.columnData;var width=document.body.offsetWidth-4800>500?document.body.offsetWidth-4800:500;var columnsData=(0,_data.columns)(date).map(function(item){if(item.children){return{title:item.name,children:item.children.map(function(v){return{title:v.name,dataIndex:v.key,key:v.key,align:"center",width:150,render:function render(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var record=arguments[1];var index=arguments[2];var title=[item.name,v.name];var props={text:text||0,index:index,type:v.type,name:v.key,onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:title,record:record,sqlName:"b8_0new_budget"}};return _react2.default.createElement(_TableText2.default,{data:props});}};})};}return{title:item.name,dataIndex:item.key,key:item.key,align:"center",width:width,fixed:print?false:"left",render:function render(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var record=arguments[1];var index=arguments[2];var title=[item.name,item.name,record.name];var props={text:text,index:index,type:item.type,name:item.key,onChange:_this2.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}};});return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:'table7_1_1 tableHeight'},_react2.default.createElement(_row2.default,{className:'title',style:{width:print?5350:'auto'}},_react2.default.createElement(_row2.default,null,'Budget Summary'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(_select2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u4EFD',style:{width:120,marginTop:20},value:this.state.date,onChange:function onChange(str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}},this.state.dateData.map(function(x,i){return _react2.default.createElement(Option,{value:x,key:x},x,'\u5E74');}))),_react2.default.createElement(_table2.default,{columns:columnsData,dataSource:data,size:'middle',id:'table4_1_5',bordered:true,loading:loading,pagination:false,rowClassName:'protruding',className:'content',style:{width:print?5300:'auto'},scroll:print?{}:{x:5300,y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){_this2.setState({print:true},function(){_this2.downloadExcel("table4_1_5");});},loading:this.state.print},'\u5BFC\u51FAExcel'))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _data2=__webpack_require__(717);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var totalIndex=[];var Option=_select2.default.Option;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.onChange=function(name,value,i){};_this.getDateData=function(date){fetch('/bp/headquarters/8?year='+(0,_moment2.default)(date).format('YYYY'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){var data=x.data||[];var _data=data.reduce(function(a,b,i){var year=(0,_moment2.default)(date).format('Y');var names=['ava','rn','occ','arr','revpar','rev'];var years=['Actual  '+(year-2),'Budget  '+(year-1),'Act+ Fcst '+(year-1),'Budget '+year];var _loop=function _loop(_i){a.push(_extends({name:b.name,typename:years[_i]},names.reduce(function(x,y,j){x[y]=b[_data2.listName[j][_i]]||0;return x;},{})));};for(var _i=0;_i<years.length;_i++){_loop(_i);}return a;},[]);_this.setState({data:data,loading:false,columnData:_data});}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var data=_this.state.data.map(function(x,i){return _extends({},x,{year:year});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/bpAdd_8_0_new',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadExcel=function(id){var tableName='Budget Summary';var innerHtml='\n          <caption>'+tableName+'</caption>\n          '+document.getElementById(id).innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n        ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+'.xls');_this.setState({print:false});};var month=(0,_moment2.default)().format('M');_this.state={date:month<3?(0,_moment2.default)().format('YYYY'):(0,_moment2.default)().add(1,'y').format('YYYY'),loadingSave:false,print:false,data:[],loading:true,columnData:[],dateData:[]};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){var date=Number(this.state.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this2=this;var _state=this.state,print=_state.print,data=_state.data,date=_state.date,loading=_state.loading,columnData=_state.columnData;var width=document.body.offsetWidth-4800>500?document.body.offsetWidth-4800:500;return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:'table7_1_1 tableHeight'},_react2.default.createElement(_row2.default,{className:'title',style:{width:print?5350:'auto'}},_react2.default.createElement(_row2.default,null,'BP8.2.1 Budget By Market Segment\u6C47\u603B\u8868'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(_select2.default,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u4EFD',style:{width:120,marginTop:20},value:date,onChange:function onChange(str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}},this.state.dateData.map(function(x,i){return _react2.default.createElement(Option,{value:x,key:x},x,'\u5E74');}))),_react2.default.createElement(_table2.default,{columns:_data2.columnsColumn.map(function(x){return{title:x.name,key:x.key,dataIndex:x.key,width:x.key=='name'?300:100,render:function render(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var record=arguments[1];var index=arguments[2];var props={text:text,index:index,type:x.type,name:x.key};if(x.key=='name'){return{props:{rowSpan:index%4==0?4:0},children:_react2.default.createElement(_TableText2.default,{data:props})};}return _react2.default.createElement(_TableText2.default,{data:props});}};}),dataSource:columnData,size:'middle',id:'table4_1_6',bordered:true,loading:loading,pagination:false,rowClassName:'protruding',className:'content',scroll:print?{}:{y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){_this2.setState({print:true},function(){_this2.downloadExcel("table4_1_6");});},loading:this.state.print},'\u5BFC\u51FAExcel'))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _Actual=__webpack_require__(2182);var _Actual2=_interopRequireDefault(_Actual);var _Forecast=__webpack_require__(2183);var _Forecast2=_interopRequireDefault(_Forecast);var _Budget=__webpack_require__(2184);var _Budget2=_interopRequireDefault(_Budget);__webpack_require__(248);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={dateData:[]},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){var date=Number(this.props.store.effectActual.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});this.props.store.effectActual.getData();}},{key:"render",value:function render(){var _props$store$effectAc=this.props.store.effectActual,date=_props$store$effectAc.date,onChangeDate=_props$store$effectAc.onChangeDate;return _react2.default.createElement("div",{className:"performanceReview effect"},_react2.default.createElement("div",{className:"first-title"},_react2.default.createElement("div",null," 1.1 Efficiency Per Square Meter Analysis \u9152\u5E97\u576A\u6548\u7ECF\u8425\u60C5\u51B5\u5206\u6790"),_react2.default.createElement("div",{className:"table-month"},_react2.default.createElement(_select2.default,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u4EFD",style:{width:120},value:date,onChange:function onChange(str){onChangeDate(str);}},this.state.dateData.map(function(x,i){return _react2.default.createElement(Option,{value:x,key:x},x,"\u5E74");})))),_react2.default.createElement(_Forecast2.default,null),_react2.default.createElement(_Budget2.default,null),_react2.default.createElement(_Actual2.default,null));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(215);var _TableText2=_interopRequireDefault(_TableText);var _mobxReact=__webpack_require__(18);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _method=__webpack_require__(20);var _data=__webpack_require__(313);__webpack_require__(248);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TOTALINDEX=[0,1,2,3];var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.onExpoetExcel=function(){var name='1.1.3 Actual '+_this.props.store.effectActual.date+' \u5E74\u5B9E\u9645\u576A\u6548';var innerHtml='\n              <caption>'+name+'</caption>\n              '+document.getElementById('table').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n            ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,name+'.xls');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'render',value:function render(){var _this2=this;var _props$store$effectAc=this.props.store.effectActual,data=_props$store$effectAc.data,date=_props$store$effectAc.date,dataAll=_props$store$effectAc.dataAll,loading=_props$store$effectAc.loading;var columns=[{dataIndex:'name',key:'name',align:"center",width:300,render:function render(text,record,index){var props={text:text,index:index>4?index-1:index,type:'text',name:"name",totalIndex:TOTALINDEX};if(index===4){return{children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter"})}),props:{colSpan:4}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Average Area Performance Data',_react2.default.createElement('br',null),' \u533A\u57DF\u5E73\u5747\u6570\u636E ',_react2.default.createElement('br',null),' ',(0,_method.getJson)(['hotel','area'],dataAll,"")),dataIndex:'area',key:'area',align:"center",width:200,render:function render(text,record,index){if(index===4){return{props:{colSpan:0}};}var props={text:text,index:index>4?index-1:index,type:'number',name:"area",totalIndex:TOTALINDEX,compared:{title:['Average Area Performance Data<br /> 区域平均数据'],record:record,sqlName:"effect_actual"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Revenue Range (RMB) ',_react2.default.createElement('br',null),' \u6536\u5165\u533A\u95F4 \uFF08\u5355\u4F4D\uFF1A\u5143\uFF09',_react2.default.createElement('br',null),_data.intervalData[(0,_method.getJson)(['hotel','income_interval'],dataAll,"")]),dataIndex:'interval',key:'interval',align:"center",width:200,render:function render(text,record,index){if(index===4){return{props:{colSpan:0}};}var props={text:text,index:index>4?index-1:index,type:'number',name:"interval",totalIndex:TOTALINDEX,compared:{title:['Revenue Range (RMB) <br /> 收入区间 （单位：元）'],record:record,sqlName:"effect_actual"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Hotel Performance Data',_react2.default.createElement('br',null),' \u672C\u9152\u5E97\u6570\u636E'),dataIndex:'hotel',key:'hotel',align:"center",width:200,render:function render(text,record,index){if(index===4){return{props:{colSpan:0}};}var props={text:text,index:index>4?index-1:index,type:'number',name:"hotel",totalIndex:TOTALINDEX,compared:{title:['Hotel Performance Data<br /> 本酒店数据'],record:record,sqlName:"effect_actual"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];var dataSource=JSON.parse(JSON.stringify((0,_mobx.toJS)(data)));dataSource.splice(4,0,{name:"",interval:0,area:0,hotel:0,sort:0});return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'table7_1_1 style-center'},_react2.default.createElement(_row2.default,{className:'title',id:'table6_2'},_react2.default.createElement(_row2.default,null,'1.1.3 Actual ',date-2,' \u5E74\u5B9E\u9645\u576A\u6548',_react2.default.createElement('span',{style:{float:"right",fontSize:16}},'RMB/Per SQM(Seat)',_react2.default.createElement('br',null),'\u5143/\u5E73\u7C73\uFF08\u4F4D\uFF09')),_react2.default.createElement(_table2.default,{columns:columns,dataSource:dataSource,size:'middle',bordered:true,id:'table',pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:loading,auth:'edit_6_2'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this2.setState({print:true},function(){_this2.onExpoetExcel();});}},'\u5BFC\u51FAExcel')))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(215);var _TableText2=_interopRequireDefault(_TableText);var _mobxReact=__webpack_require__(18);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _method=__webpack_require__(20);var _data=__webpack_require__(313);__webpack_require__(248);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TOTALINDEX=[0,1,2,3];var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.onExpoetExcel=function(){var name='1.1.1 Forecast '+_this.props.store.effectActual.date+' \u5E74\u9884\u6D4B\u576A\u6548';var innerHtml='\n              <caption>'+name+'</caption>\n              '+document.getElementById('table1').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n            ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,name+'.xls');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'render',value:function render(){var _this2=this;var _props$store$effectAc=this.props.store.effectActual,forecast=_props$store$effectAc.forecast,date=_props$store$effectAc.date,dataAll=_props$store$effectAc.dataAll,loading=_props$store$effectAc.loading;var columns=[{dataIndex:'name',key:'name',align:"center",width:300,render:function render(text,record,index){var props={text:text,index:index>4?index-1:index,type:'text',name:"name",totalIndex:TOTALINDEX};if(index===4){return{children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter"})}),props:{colSpan:4}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Average Area Performance Data',_react2.default.createElement('br',null),' \u533A\u57DF\u5E73\u5747\u6570\u636E ',_react2.default.createElement('br',null),' ',(0,_method.getJson)(['hotel','area'],dataAll,"")),dataIndex:'area',key:'area',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index>4?index-1:index,type:'number',name:"area",compared:{title:['Average Area Performance Data<br /> 区域平均数据'],record:record,sqlName:"effect_forecast"},totalIndex:TOTALINDEX};if(index===4){return{props:{colSpan:0}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Revenue Range (RMB) ',_react2.default.createElement('br',null),' \u6536\u5165\u533A\u95F4 \uFF08\u5355\u4F4D\uFF1A\u5143\uFF09',_react2.default.createElement('br',null),_data.intervalData[(0,_method.getJson)(['hotel','income_interval'],dataAll,"")]),dataIndex:'interval',key:'interval',align:"center",width:200,render:function render(text,record,index){if(index===4){return{props:{colSpan:0}};}var props={text:text,index:index>4?index-1:index,type:'number',name:"interval",compared:{title:['Revenue Range (RMB) <br /> 收入区间 （单位：元）'],record:record,sqlName:"effect_forecast"},totalIndex:TOTALINDEX};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Hotel Performance Data',_react2.default.createElement('br',null),' \u672C\u9152\u5E97\u6570\u636E'),dataIndex:'hotel',key:'hotel',align:"center",width:200,render:function render(text,record,index){if(index===4){return{props:{colSpan:0}};}var props={text:text,index:index>4?index-1:index,type:'number',name:"hotel",compared:{title:['Hotel Performance Data<br /> 本酒店数据'],record:record,sqlName:"effect_forecast"},totalIndex:TOTALINDEX};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];var dataSource=JSON.parse(JSON.stringify((0,_mobx.toJS)(forecast)));dataSource.splice(4,0,{name:"",interval:0,area:0,hotel:0,sort:0});return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'table7_1_1 style-center'},_react2.default.createElement(_row2.default,{className:'title',id:'table6_2'},_react2.default.createElement(_row2.default,null,'1.1.1 Forecast ',date-1,' \u5E74\u9884\u6D4B\u576A\u6548',_react2.default.createElement('span',{style:{float:"right",fontSize:16}},'RMB/Per SQM(Seat)',_react2.default.createElement('br',null),'\u5143/\u5E73\u7C73\uFF08\u4F4D\uFF09')),_react2.default.createElement(_table2.default,{columns:columns,dataSource:dataSource,size:'middle',bordered:true,id:'table1',pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:loading,auth:'edit_6_2'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this2.setState({print:true},function(){_this2.onExpoetExcel();});}},'\u5BFC\u51FAExcel')))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(215);var _TableText2=_interopRequireDefault(_TableText);var _mobxReact=__webpack_require__(18);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _method=__webpack_require__(20);var _data=__webpack_require__(313);__webpack_require__(248);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TOTALINDEX=[0,1,2,3];var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.onExpoetExcel=function(){var name='1.1.2 Actual '+_this.props.store.effectActual.date+' \u5E74\u5B9E\u9645\u576A\u6548';var innerHtml='\n              <caption>'+name+'</caption>\n              '+document.getElementById('table2').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n            ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,name+'.xls');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'render',value:function render(){var _this2=this;var _props$store$effectAc=this.props.store.effectActual,budget=_props$store$effectAc.budget,date=_props$store$effectAc.date,dataAll=_props$store$effectAc.dataAll,loading=_props$store$effectAc.loading;var columns=[{dataIndex:'name',key:'name',align:"center",width:300,render:function render(text,record,index){var props={text:text,index:index>4?index-1:index,type:'text',name:"name",totalIndex:TOTALINDEX};if(index===4){return{children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter"})}),props:{colSpan:4}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Average Area Performance Data',_react2.default.createElement('br',null),' \u533A\u57DF\u5E73\u5747\u6570\u636E ',_react2.default.createElement('br',null),' ',(0,_method.getJson)(['hotel','area'],dataAll,"")),dataIndex:'area',key:'area',align:"center",width:200,render:function render(text,record,index){if(index===4){return{props:{colSpan:0}};}var props={text:text,index:index>4?index-1:index,type:'number',name:"area",compared:{title:['Average Area Performance Data<br /> 区域平均数据'],record:record,sqlName:"effect_budget"},totalIndex:TOTALINDEX};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Revenue Range (RMB) ',_react2.default.createElement('br',null),' \u6536\u5165\u533A\u95F4 \uFF08\u5355\u4F4D\uFF1A\u5143\uFF09',_react2.default.createElement('br',null),_data.intervalData[(0,_method.getJson)(['hotel','income_interval'],dataAll,"")]),dataIndex:'interval',key:'interval',align:"center",width:200,render:function render(text,record,index){if(index===4){return{props:{colSpan:0}};}var props={text:text,index:index>4?index-1:index,type:'number',name:"interval",compared:{title:['Revenue Range (RMB) <br /> 收入区间 （单位：元）'],record:record,sqlName:"effect_budget"},totalIndex:TOTALINDEX};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Hotel Performance Data',_react2.default.createElement('br',null),' \u672C\u9152\u5E97\u6570\u636E'),dataIndex:'hotel',key:'hotel',align:"center",width:200,render:function render(text,record,index){if(index===4){return{props:{colSpan:0}};}var props={text:text,index:index>4?index-1:index,type:'number',name:"hotel",compared:{title:['Hotel Performance Data<br /> 本酒店数据'],record:record,sqlName:"effect_budget"},totalIndex:TOTALINDEX};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];var dataSource=JSON.parse(JSON.stringify((0,_mobx.toJS)(budget)));dataSource.splice(4,0,{name:"",interval:0,area:0,hotel:0,sort:0});return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'table7_1_1 style-center'},_react2.default.createElement(_row2.default,{className:'title',id:'table6_2'},_react2.default.createElement(_row2.default,null,'1.1.2 Budget ',date,' \u5E74\u9884\u7B97\u576A\u6548',_react2.default.createElement('span',{style:{float:"right",fontSize:16}},'RMB/Per SQM(Seat)',_react2.default.createElement('br',null),'\u5143/\u5E73\u7C73\uFF08\u4F4D\uFF09')),_react2.default.createElement(_table2.default,{columns:columns,dataSource:dataSource,size:'middle',bordered:true,id:'table2',pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:loading,auth:'edit_6_2'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this2.setState({print:true},function(){_this2.onExpoetExcel();});}},'\u5BFC\u51FAExcel')))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _col=__webpack_require__(59);var _col2=_interopRequireDefault(_col);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(8);__webpack_require__(4);__webpack_require__(60);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(248);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){_classCallCheck(this,index);return _possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).apply(this,arguments));}_createClass(index,[{key:'render',value:function render(){var columns=[{dataIndex:'name',key:'name',render:function render(text){return _react2.default.createElement('div',{style:{padding:"10px",textAlign:'center'},dangerouslySetInnerHTML:{__html:text}});}},{dataIndex:'desc',key:'desc',render:function render(text){return _react2.default.createElement('div',{style:{padding:"10px",textAlign:'center'},dangerouslySetInnerHTML:{__html:text}});}}];return _react2.default.createElement('div',{className:'derformanceDes'},_react2.default.createElement('div',{className:'title'},'1.3.1 Breakdown Statistics Data \u7EDF\u8BA1\u6570\u636E\u5F52\u96C6\u4F9D\u636E'),_react2.default.createElement('div',{className:'text_center'},_react2.default.createElement('div',null,'Average Industry Performance Data Source: China Hotel Industry Study 2021 & Statistical Communique of The People\'s Republic of China on the 2022 Q1 Star Hotel'),_react2.default.createElement('div',null,'\u884C\u4E1A\u6570\u636E\u6765\u6E90 \u300A2021\u5E74\u4E2D\u56FD\u996D\u5E97\u4E1A\u7EDF\u8BA1\uFF082020\u8D22\u653F\u5E74\u5EA6\uFF09\u300B\uFF08\u6D69\u534E\u7BA1\u7406\u987E\u95EE\u516C\u53F8\uFF09\u548C\u300A2022\u5E74\u7B2C\u4E00\u5B63\u5EA6\u5168\u56FD\u661F\u7EA7\u996D\u5E97\u7EDF\u8BA1\u516C\u62A5\u300B\uFF08\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u6587\u5316\u548C\u65C5\u6E38\u90E8\u5E02\u573A\u7BA1\u7406\u53F8\uFF09')),_react2.default.createElement(_row2.default,{className:'table_title'},_react2.default.createElement(_col2.default,{className:'align',span:24},'Average Area Performance Data  \u533A\u57DF\u5E73\u5747\u6570\u636E')),_react2.default.createElement(_row2.default,{gutter:56},_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement('div',{className:'table_border'},_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:24},'Southeastern & Southern China \u4E1C\u5357\u534E\u5357')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6D77\u5357\u9F99\u6C90\u6E7E\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Hainan Longmu Bay ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6587\u660C\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Wenchang ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6885\u5DDE\u660C\u76DB\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Changsheng Plaza Meizhou')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6F33\u5DDE\u660E\u53D1\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Mingfa Zhangzhou')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u53A6\u95E8\u96C6\u7F8E\u6E56\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Jimei Lake Plaza Xiamen')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6D77\u53E3\u661F\u6D77\u6E7E\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO New Port Resort Haikou')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u53A6\u95E8\u79B9\u6D32\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Yuzhou Xiamen')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5E7F\u897F\u957F\u878D\u8C6A\u5B9C\u9152\u5E97 '),_react2.default.createElement(_col2.default,{span:12},'HOJO Life Changrong Guangxi')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5B89\u987A\u8C6A\u751F\u6E29\u6CC9\u5EA6\u5047\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Hot Spring Resort Anshun')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u9E70\u6F6D\u6C81\u5E90\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Qinlu Plaza Yingtan')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5E7F\u5DDE\u6843\u82B1\u6C5F\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Riverview Hotel Guangzhou')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6F84\u6D77\u56FD\u745E\u8C6A\u751F\u9152\u5E97 '),_react2.default.createElement(_col2.default,{span:12},'HOJO Glory Hotel Chenghai')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u8D35\u5DDE\u5929\u6021\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Plaza Guiyang')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u60E0\u5DDE\u53CC\u6708\u6E7E\u6A80\u60A6\u8C6A\u751F\u6E29\u6CC9\u5EA6\u5047\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Shuangyue Bay Huizhou')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E09\u4E9A\u56FD\u5149\u8C6A\u751F\u5EA6\u5047\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Resort Sanya Bay')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5357\u5B81\u4F1A\u5C55\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO CAEXPO Plaza NanNing')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4F59\u5E86\u7B2C\u4E09\u5730\u8C6A\u5B9C\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Life Parkview Yuqing')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u8D35\u5DDE\u745E\u8302\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Ruimao Guizhou')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u53A6\u95E8\u6D77\u65C5\u6E29\u5FB7\u59C6\u81F3\u5C0A\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WG Xiamen Haicang')),_react2.default.createElement(_row2.default,{className:'bg_w',style:{border:'none'}},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u8D35\u5DDE\u7FA4\u5347\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Qunsheng Plaza Guizhou')))),_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement('div',{className:'table_border'},_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:24},'Northern & Central China \u534E\u5317\u534E\u4E2D')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u957F\u6C99\u8299\u84C9\u56FD\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Furongguo Changsha ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u957F\u6C99\u6E58\u6C5F\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Yacht Club Hotel Changsha')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5927\u8FDE\u767E\u5E74\u6C47\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Parkland Hotel Dalian')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5A01\u6D77\u9999\u6D77\u8C6A\u751F\u5EA6\u5047\u9152\u5E97 '),_react2.default.createElement(_col2.default,{span:12},'HOJO Dream Sea Resort Weihai')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u90B5\u9633\u6E58\u6797\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Xianglin Shaoyang ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u90F4\u5DDE\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Chenzhou ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6C5F\u57CE\u660E\u73E0\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Pearl Plaza Wuhan')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5C71\u4E1C\u4E34\u6C82\u7FD4\u5B87\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Xiangyu Plaza Linyi')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u8425\u53E3\u4E94\u77FF\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Minmetals Plaza Yingkou')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6C88\u9633\u9526\u8054\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Jinlian Business Club Shenyang')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u897F\u5B89\u91D1\u82B1\u8C6A\u751F\u56FD\u9645\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Ginwa Plaza Xi\'an')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u9752\u5C9B\u5EB7\u5927\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Plaza Kangda Qingda')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5C71\u4E1C\u4E34\u6C82\u7FD4\u5B87\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Xiangyu Plaza Linyi')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u9102\u5C14\u591A\u65AF\u535A\u6E90\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Parkview Plaza Erdos')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5317\u4EAC\u5B9D\u8FB0\u996D\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Paragon Hotel Beijing')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E4C\u5170\u5BDF\u5E03\u591A\u8499\u5FB7\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Plaza Wulanchabu')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u957F\u6C99\u534E\u6668\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Huachen Plaza Changsha')),_react2.default.createElement(_row2.default,{className:'bg_w',style:{border:'none'}},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u682A\u6D32\u9AD8\u79D1\u8C6A\u5B9C\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Geckor Zhuzhou'))))),_react2.default.createElement(_row2.default,{gutter:56,style:{marginTop:40}},_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement('div',{className:'table_border'},_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:24},'Jiangsu, Zhejiang, Shanghai & Anhui \u6C5F\u6D59\u6CAA\u7696')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E0A\u6D77\u8679\u6865\u91D1\u53E4\u6E90\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Hongqiao Airport Hotel SH')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5357\u4EAC\u5367\u9F99\u6E56\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5EA6\u5047\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Lake Crouching Dragon Resort Nanjing')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5B81\u6CE2\u534E\u4FA8\u8C6A\u751F\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Ningbo')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u676D\u5DDE\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Hangzhou')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u868C\u57E0\u5357\u5C71\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Nanshan Plaza Bengbu')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u961C\u9633\u5B9D\u9F99\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Baolong Fuyang')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5B89\u5409\u51EF\u627F\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Kaicheng Anji')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u51EF\u8FEA\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Kaidi')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5408\u80A5\u4E24\u6DEE\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Tech Center Plaza Hefei')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5B81\u6CE2\u9038\u4E1C\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO IFC Plaza Ningbo')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6C5F\u9634\u957F\u665F\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Changsheng Jiangyin')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E0A\u6D77\u5174\u8363\u6E29\u5FB7\u59C6\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'Wyndham Bund East SH')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u961C\u9633\u5929\u7B51\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Tianzhu Plaza Fuyang')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E0A\u6D77\u5174\u8363\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u9152\u5E97 '),_react2.default.createElement(_col2.default,{span:12},'WGPR Oriental SH')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5B81\u6CE2\u5353\u8FDC\u8C6A\u5B9C\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Life Zhuoyuan Ningbo')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E0A\u6D77\u4E34\u6E2F\u8C6A\u751F\u5927\u9152\u5E97 '),_react2.default.createElement(_col2.default,{span:12},'HOJO Plaza Lingang SH')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5E90\u5C71\u5609\u8C6A\u6DEE\u6D77\u56FD\u9645\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Huaihai Resort Lushan')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5929\u76EE\u6E56\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Tian Mu Lake Plaza Liyang')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u9EC4\u5C71\u65B0\u534E\u8054\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Macrolink Plaza Huangshan')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5E38\u5DDE\u51EF\u7EB3\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Kaina Plaza Changzhou')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u82CF\u5DDE\u664B\u5408\u8C6A\u751F\u884C\u653F\u516C\u5BD3'),_react2.default.createElement(_col2.default,{span:12},'HOJO Jinhope Suzhou ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E0A\u6D77\u8D22\u5927\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Caida Plaza SH')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u7ECD\u5174\u4E2D\u91D1\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Business Club Hotel Shaoxing')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E0A\u6D77\u5609\u8C6A\u6DEE\u6D77\u56FD\u9645\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Huaihai Hotel SH')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5B81\u6CE2\u77F3\u6D66\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Shipu Plaza Ningbo')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5B81\u6CE2\u534E\u4FA8\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Plaza Ningbo')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u5B81\u6CE2\u9633\u5149\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Sunshine Plaza Ningbo')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u8BF8\u66A8\u540C\u65B9\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Tongfang Plaza Zhuji')),_react2.default.createElement(_row2.default,{className:'bg_w',style:{border:'none'}},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E0A\u6D77\u4E3D\u6602\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Leonora Plaza Shanghai')))),_react2.default.createElement(_col2.default,{span:12},_react2.default.createElement('div',{className:'table_border'},_react2.default.createElement(_row2.default,null,_react2.default.createElement(_col2.default,{span:24},'Southwestern China \u897F\u5357')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6210\u90FD\u5C71\u666F\u8C6A\u5B9C\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Life Mountain View CD ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u91CD\u5E86\u79C0\u5C71\u8C6A\u751F\u5E7F\u573A\u56FD\u9645\u9152\u5E97 '),_react2.default.createElement(_col2.default,{span:12},'HOJO Xiushan Plaza CQ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u91CD\u5E86\u6E1D\u878D\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Yurong Hotel CQ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E3D\u6C5F\u91D1\u6797\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Jinling Plaza Lijiang')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u91CD\u5E86\u666E\u60E0\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Puhui Plaza CQ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u91CD\u5E86\u9526\u6021\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Jinyi Hotel CQ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u8D44\u9633\u9F0E\u665F\u6CD3\u5E9C\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO New District Plaza Ziyang')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6606\u660E\u5357\u4E9A\u98CE\u60C5\u56ED\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Tropical Garden Plaza Kunming')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6210\u90FD\u5929\u4E4B\u5E9C\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Palace CD')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6210\u90FD\u96C5\u5C45\u4E50\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Agile Plaza CD')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6210\u90FD\u9AD8\u65B0\u8C6A\u751F\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Hi-Tech Plaza CD')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u91CD\u5E86\u534E\u5B87\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Huayu CQ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6606\u660E\u4E03\u5F69\u4E91\u5357\u6E29\u5FB7\u59C6\u81F3\u5C0A\u8C6A\u5EF7\u5927\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'WGPR Colorful Yunnan Kunming')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6210\u90FD\u9752\u57CE\u8C6A\u751F\u56FD\u9645\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Conference Resort CD')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u91CD\u5E86\u5929\u559C\u8C6A\u751F\u5927\u9152\u5E97 '),_react2.default.createElement(_col2.default,{span:12},'HOJO Tianxi Plaza Chongqing')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6606\u660E\u82B1\u4E4B\u57CE\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO City of Flower Hotel Kunming ')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u91CD\u5E86\u73E0\u6C5F\u8C6A\u751F\u5927\u9152\u5E97 '),_react2.default.createElement(_col2.default,{span:12},'HOJO Zhujiang Plaza ChongQing')),_react2.default.createElement(_row2.default,{className:'bg_w'},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u6210\u90FD\u5C0A\u60A6\u8C6A\u751F\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Zunyue Hotel CD')),_react2.default.createElement(_row2.default,{className:'bg_w',style:{border:'none'}},_react2.default.createElement(_col2.default,{span:12,className:'left'},'\u4E5D\u5BE8\u6C9F\u5929\u6E90\u8C6A\u751F\u5EA6\u5047\u9152\u5E97'),_react2.default.createElement(_col2.default,{span:12},'HOJO Tianyuan Resort Jiuzhaigou'))))),_react2.default.createElement('div',{className:'title_2'},'1.3.2 Revenue Range (RMB) \u6536\u5165\u533A\u95F4 \uFF08\u5355\u4F4D\uFF1A\u5143\uFF09'),_react2.default.createElement('div',{className:'table_border table7_1_1',style:{width:500}},_react2.default.createElement(_table2.default,{columns:columns,dataSource:[{name:"<10 Million <1000万",desc:"55-65 Million 5500-6500万"},{name:"10-25 Million 1000-2500万",desc:"65-80 Million 6500-8000万"},{name:"25-35 Million 2500-3500万",desc:"80-100 Million 8000万-1亿"},{name:"35-45 Million 3500-4500万",desc:">100 Million 1亿以上"},{name:"45-55 Million 4500-5500万",desc:""}],pagination:false,showHeader:false,size:'middle',bordered:true,className:'content'})),_react2.default.createElement('div',{className:'title_2'},'1.3.3 Definition of Terms \u672F\u8BED\u89E3\u91CA'),_react2.default.createElement('div',{className:'table_border'},_react2.default.createElement(_row2.default,{className:'definition_row_top'},_react2.default.createElement(_col2.default,{span:7,className:'left'}),_react2.default.createElement(_col2.default,{span:6,className:'left'},_react2.default.createElement(_row2.default,{className:'definition_title'},'Average Area Performance Data',_react2.default.createElement('br',null),'\u533A\u57DF\u5E73\u5747\u6570\u636E'),_react2.default.createElement(_row2.default,{className:'definition_title',style:{border:'none'}},'\u653E\u7F6E\u533A\u57DF\u540D\u79F0')),_react2.default.createElement(_col2.default,{span:6,className:'left'},_react2.default.createElement(_row2.default,{className:'definition_title'},'Revenue Range',_react2.default.createElement('br',null),'\u6536\u5165\u533A\u95F4'),_react2.default.createElement(_row2.default,{className:'definition_title',style:{border:'none'}},'\u653E\u7F6E\u6536\u5165\u533A\u95F4\u540D\u79F0')),_react2.default.createElement(_col2.default,{className:'definition_title',span:5},'Hotel Performance Data',_react2.default.createElement('br',null),'\u672C\u9152\u5E97\u6570\u636E')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:7,className:'left'},'Efficiency Per Total Room Area SQM \u5BA2\u623F\u53EF\u552E\u603B\u9762\u79EF\u576A\u6548'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u57DF\u5185 BP 18.0 Budget/Forecast/Actual \u5BA2\u623F\u6536\u5165 \u603B\u548C/(\u533A\u57DF\u5185 BP 17.1 \u5BA2\u623F\u603B\u9762\u79EF \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u95F4\u5185 BP 18.0 Budget/Forecast/Actual \u5BA2\u623F\u6536\u5165 \u603B\u548C/(\u533A\u95F4\u5185 BP 17.1 \u5BA2\u623F\u603B\u9762\u79EF \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:5},'  = BP 18.0 Budget/Forecast/Actual \u5BA2\u623F\u6536\u5165/(BP 17.1 \u5BA2\u623F\u603B\u9762\u79EF * \u5F53\u5E74\u5929\u6570)')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:7,className:'left'},'Total Conference Space SQM \u4F1A\u8BAE\u5BA4\u53EF\u552E\u603B\u9762\u79EF'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u57DF\u5185\u9152\u5E97 (BP 12.0 Budget/Forecast/Actual \u5BB4\u4F1A Revenue + BP 12.0 Budget/Forecast/Actual \u4F1A\u8BAE\u573A\u5730\u8BBE\u65BD\u6536\u5165 Revenue) \u603B\u548C/\u533A\u57DF\u5185\u9152\u5E97 (BP 17.1 \u4F1A\u8BAE\u5BA4\u603B\u9762\u79EF * \u5F53\u5E74\u5929\u6570) \u603B\u548C'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u95F4\u5185\u9152\u5E97 (BP 12.0 Budget/Forecast/Actual \u5BB4\u4F1A Revenue + BP 12.0 Budget/Forecast/Actual \u4F1A\u8BAE\u573A\u5730\u8BBE\u65BD\u6536\u5165 Revenue) \u603B\u548C/\u533A\u95F4\u5185\u9152\u5E97(BP 17.1 \u4F1A\u8BAE\u5BA4\u603B\u9762\u79EF * \u5F53\u5E74\u5929\u6570) \u603B\u548C'),_react2.default.createElement(_col2.default,{span:5},'  = (BP 12.0 Budget/Forecast/Actual \u5BB4\u4F1A Revenue + BP 12.0 Budget/Forecast/Actual \u4F1A\u8BAE\u573A\u5730\u8BBE\u65BD\u6536\u5165 Revenue)/(BP 17.1 \u4F1A\u8BAE\u5BA4\u603B\u9762\u79EF * \u5F53\u5E74\u5929\u6570) \u603B\u548C')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:7,className:'left'},'Efficiency Per Seat No. of All Day Dinning \u5168\u65E5\u9910\u5385\u4F4D\u6570\u576A\u6548'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u57DF\u5185 BP 12.0 Cafe Budget/Forecast/Actual Revenue \u603B\u548C/(\u533A\u57DF\u5185 BP 17.1 \u5168\u65E5\u9910\u5385\u4F4D\u6570 \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u95F4\u5185 BP 12.0 Cafe Budget/Forecast/Actual Revenue \u603B\u548C/(\u533A\u57DF\u5185 BP 17.1 \u5168\u65E5\u9910\u5385\u4F4D\u6570 \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:5},'  = BP 12.0 Cafe Budget/Forecast/Actual Revenue/BP 17.1 \u5168\u65E5\u9910\u5385\u4F4D\u6570 * \u5F53\u5E74\u5929\u6570')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:7,className:'left'},'Efficiency Per All Day Dinning Space SQM \u5168\u65E5\u9910\u5385\u9762\u79EF\u576A\u6548'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u57DF\u5185 BP 12.0 Cafe Budget/Forecast/Actual Revenue \u603B\u548C/(\u533A\u57DF\u5185 BP 17.1 \u5168\u65E5\u9910\u5385\u9762\u79EF \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u95F4\u5185 BP 12.0 Cafe Budget/Forecast/Actual Revenue \u603B\u548C/(\u533A\u57DF\u5185 BP 17.1 \u5168\u65E5\u9910\u5385\u9762\u79EF \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:5},'  = BP 12.0 Cafe Budget/Forecast/Actual Revenue/BP 17.1 \u5168\u65E5\u9910\u5385\u9762\u79EF * \u5F53\u5E74\u5929\u6570')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:7,className:'left'},'Efficiency Per Seat No. of Chinese Restaurant \u4E2D\u9910\u5927\u5385\u4F4D\u6570\u576A\u6548'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u57DF\u5185 BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue \u603B\u548C/(\u533A\u57DF\u5185 BP 17.1 \u4E2D\u9910\u5927\u5385\u4F4D\u6570 \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u95F4\u5185 BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue \u603B\u548C/(\u533A\u95F4\u5185 BP 17.1 \u4E2D\u9910\u5927\u5385\u4F4D\u6570 \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:5},'  = BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue/BP 17.1 \u4E2D\u9910\u5927\u5385\u4F4D\u6570 * \u5F53\u5E74\u5929\u6570')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:7,className:'left'},'Efficiency Per Chinese Restaurant Space SQM \u4E2D\u9910\u5385\u9762\u79EF\u576A\u6548'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u57DF\u5185 BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue \u603B\u548C/(\u533A\u57DF\u5185 BP 17.1 \u4E2D\u9910\u5385\u9762\u79EF \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u95F4\u5185 BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue \u603B\u548C/(\u533A\u95F4\u5185 BP 17.1 \u4E2D\u9910\u5385\u9762\u79EF \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:5},'  = BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue/BP 17.1 \u4E2D\u9910\u5385\u9762\u79EF * \u5F53\u5E74\u5929\u6570')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:7,className:'left'},'Efficiency Per Seat No. of Lounge/Bar \u5927\u5802\u5427/\u9152\u5427\u9910\u4F4D\u6570\u576A\u6548'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'   = \u533A\u57DF\u5185 BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue \u603B\u548C/(\u533A\u57DF\u5185 BP 17.1 \u5927\u5802\u5427/\u9152\u5427\u9910\u4F4D\u6570 \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u95F4\u5185 BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue \u603B\u548C/(\u533A\u95F4\u5185 BP 17.1 \u5927\u5802\u5427/\u9152\u5427\u9910\u4F4D\u6570 \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:5},'  = BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue/BP 17.1 \u5927\u5802\u5427/\u9152\u5427\u9910\u4F4D\u6570 * \u5F53\u5E74\u5929\u6570')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:7,className:'left'},'Efficiency Per Lounge/Bar Space SQM \u5927\u5802\u5427\u9762\u79EF\u576A\u6548'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u57DF\u5185 BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue \u603B\u548C/(\u533A\u57DF\u5185 BP 17.1 \u5927\u5802\u5427/\u9152\u5427\u9762\u79EF \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u95F4\u5185 BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue \u603B\u548C/(\u533A\u95F4\u5185 BP 17.1 \u5927\u5802\u5427/\u9152\u5427\u9762\u79EF \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:5},'  = BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue/BP 17.1 \u5927\u5802\u5427/\u9152\u5427\u9762\u79EF * \u5F53\u5E74\u5929\u6570')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:7,className:'left'},'Efficiency Per Seat No. of Special Restaurant \u7279\u8272\u9910\u5385\u9910\u4F4D\u6570\u576A\u6548'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u57DF\u5185 BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue \u603B\u548C/(\u533A\u57DF\u5185 BP 17.1 \u7279\u8272\u9910\u5385\u9910\u4F4D\u6570 \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u95F4\u5185 BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue \u603B\u548C/(\u533A\u95F4\u5185 BP 17.1 \u7279\u8272\u9910\u5385\u9910\u4F4D\u6570 \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:5},'  = BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue/BP 17.1 \u7279\u8272\u9910\u5385\u9910\u4F4D\u6570 * \u5F53\u5E74\u5929\u6570')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:7,className:'left'},'Efficiency Per Spacial Restaurant Space SQM \u7279\u8272\u9910\u5385\u9762\u79EF\u576A\u6548'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u57DF\u5185 BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue \u603B\u548C/(\u533A\u57DF\u5185 BP 17.1 \u7279\u8272\u9910\u5385\u9762\u79EF \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u95F4\u5185 BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue \u603B\u548C/(\u533A\u95F4\u5185 BP 17.1 \u7279\u8272\u9910\u5385\u9762\u79EF \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:5},'  = BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue/BP 17.1 \u7279\u8272\u9910\u5385\u9762\u79EF * \u5F53\u5E74\u5929\u6570')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:7,className:'left'},'Efficiency Per Seat No. of Other Outlets \u5176\u4ED6\u9910\u5385\u9910\u4F4D\u6570\u576A\u6548'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u57DF\u5185 BP 12.0 Other Outlets Budget/Forecast/Actual Revenue \u603B\u548C/(\u533A\u57DF\u5185 BP 17.1 \u5176\u4ED6\u9910\u5385A+B\u9910\u4F4D\u6570 \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u95F4\u5185 BP 12.0 Other Outlets Budget/Forecast/Actual Revenue \u603B\u548C/(\u533A\u95F4\u5185 BP 17.1 \u5176\u4ED6\u9910\u5385A+B\u9910\u4F4D\u6570 \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:5},'  = BP 12.0 Other Outlets Budget/Forecast/Actual Revenue/BP 17.1 \u7279\u8272\u9910\u5385\u9910\u4F4D\u6570 * \u5F53\u5E74\u5929\u6570')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:7,className:'left'},'Efficiency Per Other Outlets Space SQM \u5176\u4ED6\u9910\u5385\u9762\u79EF\u576A\u6548'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'    = \u533A\u57DF\u5185 BP 12.0 Other Outlets Budget/Forecast/Actual Revenue \u603B\u548C/(\u533A\u57DF\u5185 BP 17.1 \u5176\u4ED6\u9910\u5385A+B\u9762\u79EF \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'    = \u533A\u95F4\u5185 BP 12.0 Other Outlets Budget/Forecast/Actual Revenue \u603B\u548C/(\u533A\u95F4\u5185 BP 17.1 \u5176\u4ED6\u9910\u5385A+B\u9762\u79EF \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:5},'    = BP 12.0 Other Outlets Budget/Forecast/Actual Revenue/BP 17.1 \u5176\u4ED6\u9910\u5385A+B\u9762\u79EF * \u5F53\u5E74\u5929\u6570')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:7,className:'left'},'Efficiency Per Seat No. of Total Restaurant \u9910\u5385\u603B\u9910\u4F4D\u6570\u576A\u6548'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u57DF\u5185 (BP 12.0 Cafe Budget/Forecast/Actual Revenue + BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue + BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue + BP 12.0 Other Outlets Budget/Forecast/Actual Revenue + BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue) \u603B\u548C/(\u533A\u57DF\u5185 (BP 17.1 \u4E2D\u9910\u5385\u9910\u4F4D\u6570 + BP 17.1 \u5168\u65E5\u9910\u5385\u9910\u4F4D\u6570 + BP 17.1 \u5927\u5802\u5427/\u9152\u5427\u9910\u4F4D\u6570 + BP 17.1 \u7279\u8272\u9910\u5385\u9910\u4F4D\u6570 + BP 17.1 \u5176\u4ED6\u9910\u5385A\u9910\u4F4D\u6570 + BP 17.1 \u5176\u4ED6\u9910\u5385B\u9910\u4F4D\u6570) \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u95F4\u5185 (BP 12.0 Cafe Budget/Forecast/Actual Revenue + BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue + BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue + BP 12.0 Other Outlets Budget/Forecast/Actual Revenue + BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue) \u603B\u548C/(\u533A\u95F4\u5185 (BP 17.1 \u4E2D\u9910\u5385\u9910\u4F4D\u6570 + BP 17.1 \u5168\u65E5\u9910\u5385\u9910\u4F4D\u6570 + BP 17.1 \u5927\u5802\u5427/\u9152\u5427\u9910\u4F4D\u6570 + BP 17.1 \u7279\u8272\u9910\u5385\u9910\u4F4D\u6570 + BP 17.1 \u5176\u4ED6\u9910\u5385A\u9910\u4F4D\u6570 + BP 17.1 \u5176\u4ED6\u9910\u5385B\u9910\u4F4D\u6570) \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:5},'  = (BP 12.0 Cafe Budget/Forecast/Actual Revenue + BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue + BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue + BP 12.0 Other Outlets Budget/Forecast/Actual Revenue + BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue)/((BP 17.1 \u4E2D\u9910\u5385\u9910\u4F4D\u6570 + BP 17.1 \u5168\u65E5\u9910\u5385\u9910\u4F4D\u6570 + BP 17.1 \u5927\u5802\u5427/\u9152\u5427\u9910\u4F4D\u6570 + BP 17.1 \u7279\u8272\u9910\u5385\u9910\u4F4D\u6570 + BP 17.1 \u5176\u4ED6\u9910\u5385A\u9910\u4F4D\u6570 + BP 17.1 \u5176\u4ED6\u9910\u5385B\u9910\u4F4D\u6570) * \u5F53\u5E74\u5929\u6570)')),_react2.default.createElement(_row2.default,{className:'definition_bg_w'},_react2.default.createElement(_col2.default,{span:7,className:'left'},'Efficiency Per Total Restaurant Space SQM \u9910\u5385\u603B\u9762\u79EF\u576A\u6548'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u57DF\u5185 (BP 12.0 Cafe Budget/Forecast/Actual Revenue + BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue + BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue + BP 12.0 Other Outlets Budget/Forecast/Actual Revenue + BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue) \u603B\u548C/(\u533A\u57DF\u5185 (BP 17.1 \u4E2D\u9910\u5385\u9762\u79EF + BP 17.1 \u5168\u65E5\u9910\u5385\u9762\u79EF + BP 17.1 \u5927\u5802\u5427/\u9152\u5427\u9762\u79EF + BP 17.1 \u7279\u8272\u9910\u5385\u9762\u79EF + BP 17.1 \u5176\u4ED6\u9910\u5385A\u9762\u79EF + BP 17.1 \u5176\u4ED6\u9910\u5385B\u9762\u79EF) \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:6,className:'left'},'  = \u533A\u95F4\u5185 (BP 12.0 Cafe Budget/Forecast/Actual Revenue + BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue + BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue + BP 12.0 Other Outlets Budget/Forecast/Actual Revenue + BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue) \u603B\u548C/(\u533A\u95F4\u5185 (BP 17.1 \u4E2D\u9910\u5385\u9762\u79EF + BP 17.1 \u5168\u65E5\u9910\u5385\u9762\u79EF + BP 17.1 \u5927\u5802\u5427/\u9152\u5427\u9762\u79EF + BP 17.1 \u7279\u8272\u9910\u5385\u9762\u79EF + BP 17.1 \u5176\u4ED6\u9910\u5385A\u9762\u79EF + BP 17.1 \u5176\u4ED6\u9910\u5385B\u9762\u79EF) \u603B\u548C * \u5F53\u5E74\u5929\u6570)'),_react2.default.createElement(_col2.default,{span:5},'  = (BP 12.0 Cafe Budget/Forecast/Actual Revenue + BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue + BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue + BP 12.0 Other Outlets Budget/Forecast/Actual Revenue + BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue) /((BP 17.1 \u4E2D\u9910\u5385\u9762\u79EF + BP 17.1 \u5168\u65E5\u9910\u5385\u9762\u79EF + BP 17.1 \u5927\u5802\u5427/\u9152\u5427\u9762\u79EF + BP 17.1 \u7279\u8272\u9910\u5385\u9762\u79EF + BP 17.1 \u5176\u4ED6\u9910\u5385A\u9762\u79EF + BP 17.1 \u5176\u4ED6\u9910\u5385B\u9762\u79EF) * \u5F53\u5E74\u5929\u6570)'))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(18);var _Area=__webpack_require__(2187);var _Area2=_interopRequireDefault(_Area);var _Income=__webpack_require__(2188);var _Income2=_interopRequireDefault(_Income);__webpack_require__(442);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={dateData:[]},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){var date=Number(this.props.store.effectOcc.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});this.props.store.effectOcc.getData();}},{key:"render",value:function render(){var _props$store$effectOc=this.props.store.effectOcc,date=_props$store$effectOc.date,onChangeDate=_props$store$effectOc.onChangeDate;return _react2.default.createElement("div",{className:"performanceReview effect"},_react2.default.createElement("div",{className:"first-title"},_react2.default.createElement("div",null," 1.2 Meeting Room Occ \u4F1A\u8BAE\u5BA4\u9700\u6C42\u7EDF\u8BA1"),_react2.default.createElement("div",{className:"table-month"},_react2.default.createElement(_select2.default,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u4EFD",style:{width:120},value:date,onChange:function onChange(str){onChangeDate(str);}},this.state.dateData.map(function(x,i){return _react2.default.createElement(Option,{value:x,key:x},x,"\u5E74");})))),_react2.default.createElement(_Area2.default,null),_react2.default.createElement(_Income2.default,null));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(215);var _TableText2=_interopRequireDefault(_TableText);var _mobxReact=__webpack_require__(18);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);__webpack_require__(442);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TOTALINDEX=[];var TITLE="1.2.1 分区域酒店会议场地出租率";var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={print:false},_this.onExpoetExcel=function(){var name=''+TITLE;var innerHtml='\n              <caption>'+name+'</caption>\n              '+document.getElementById('table').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n            ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,name+'.xls');_this.setState({print:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'render',value:function render(){var _this2=this;var _props$store$effectOc=this.props.store.effectOcc,area=_props$store$effectOc.area,date=_props$store$effectOc.date,dataAll=_props$store$effectOc.dataAll,loading=_props$store$effectOc.loading;var columns=[{dataIndex:'name',key:'name',align:"center",width:300,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",totalIndex:TOTALINDEX};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Space Occupancy',_react2.default.createElement('br',null),'\u4E1C\u5357\u534E\u5357\u4F1A\u8BAE\u573A\u5730\u51FA\u79DF\u7387'),dataIndex:'space1',key:'space1',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"space1",totalIndex:TOTALINDEX,compared:{title:['Space Occupancy<br />东南华南会议场地出租率'],record:record,sqlName:"effect_area"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Space Occupancy',_react2.default.createElement('br',null),'\u534E\u5317\u534E\u4E2D\u4F1A\u8BAE\u573A\u5730\u51FA\u79DF\u7387'),dataIndex:'space2',key:'space2',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"space2",totalIndex:TOTALINDEX,compared:{title:['Space Occupancy<br />华北华中会议场地出租率'],record:record,sqlName:"effect_area"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Space Occupancy',_react2.default.createElement('br',null),'\u6C5F\u6D59\u6CAA\u7696\u4F1A\u8BAE\u573A\u5730\u51FA\u79DF\u7387'),dataIndex:'space3',key:'space3',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"space3",totalIndex:TOTALINDEX,compared:{title:['Space Occupancy<br />江浙沪皖会议场地出租率'],record:record,sqlName:"effect_area"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Space Occupancy',_react2.default.createElement('br',null),'\u897F\u5357\u4F1A\u8BAE\u573A\u5730\u51FA\u79DF\u7387'),dataIndex:'space4',key:'space4',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"space4",totalIndex:TOTALINDEX,compared:{title:['Space Occupancy<br />西南会议场地出租率'],record:record,sqlName:"effect_area"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'table7_1_1 style-center'},_react2.default.createElement(_row2.default,{className:'title',id:'table6_2'},_react2.default.createElement(_row2.default,null,' ',TITLE),_react2.default.createElement(_table2.default,{columns:columns,dataSource:(0,_mobx.toJS)(area),size:'middle',bordered:true,id:'table',pagination:false,className:'content',rowKey:function rowKey(record,index){return index;},scroll:this.state.print?{}:{y:500}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this2.setState({print:true},function(){_this2.onExpoetExcel();});}},'\u5BFC\u51FAExcel'))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(215);var _TableText2=_interopRequireDefault(_TableText);var _mobxReact=__webpack_require__(18);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);__webpack_require__(442);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TOTALINDEX=[];var TITLE="1.2.2 收入区间酒店会议场地出租率";var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={print:false},_this.onExpoetExcel=function(){var name=''+TITLE;var innerHtml='\n              <caption>'+name+'</caption>\n              '+document.getElementById('table1').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n            ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,name+'.xls');_this.setState({print:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'render',value:function render(){var _this2=this;var _props$store$effectOc=this.props.store.effectOcc,interval=_props$store$effectOc.interval,date=_props$store$effectOc.date,dataAll=_props$store$effectOc.dataAll,loading=_props$store$effectOc.loading;var columns=[{dataIndex:'name',key:'name',align:"center",width:300,fixed:!this.state.print&&"left",render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",totalIndex:TOTALINDEX};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Space Occupancy',_react2.default.createElement('br',null),'<1000\u4E07\u533A\u95F4\u4F1A\u8BAE\u573A\u5730\u51FA\u79DF\u7387'),dataIndex:'space1',key:'space1',align:"center",width:250,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"space1",totalIndex:TOTALINDEX,compared:{title:['Space Occupancy<br />&lt;1000万区间会议场地出租率'],record:record,sqlName:"effect_interval"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Space Occupancy',_react2.default.createElement('br',null),'1000-2000\u4E07\u533A\u95F4\u4F1A\u8BAE\u573A\u5730\u51FA\u79DF\u7387'),dataIndex:'space2',key:'space2',align:"center",width:250,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"space2",totalIndex:TOTALINDEX,compared:{title:['Space Occupancy<br />1000-2000万区间会议场地出租率'],record:record,sqlName:"effect_interval"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Space Occupancy',_react2.default.createElement('br',null),'2000-3500\u4E07\u533A\u95F4\u4F1A\u8BAE\u573A\u5730\u51FA\u79DF\u7387'),dataIndex:'space3',key:'space3',align:"center",width:250,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"space3",totalIndex:TOTALINDEX,compared:{title:['Space Occupancy<br />2000-3500万区间会议场地出租率'],record:record,sqlName:"effect_interval"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Space Occupancy',_react2.default.createElement('br',null),'3500-4500\u4E07\u533A\u95F4\u4F1A\u8BAE\u573A\u5730\u51FA\u79DF\u7387'),dataIndex:'space4',key:'space4',align:"center",width:250,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"space4",totalIndex:TOTALINDEX,compared:{title:['Space Occupancy<br />3500-4500万区间会议场地出租率'],record:record,sqlName:"effect_interval"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Space Occupancy',_react2.default.createElement('br',null),'4500-5500\u4E07\u533A\u95F4\u4F1A\u8BAE\u573A\u5730\u51FA\u79DF\u7387'),dataIndex:'space5',key:'space5',align:"center",width:250,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"space5",totalIndex:TOTALINDEX,compared:{title:['Space Occupancy<br />4500-5500万区间会议场地出租率'],record:record,sqlName:"effect_interval"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Space Occupancy',_react2.default.createElement('br',null),'5500-6500\u4E07\u533A\u95F4\u4F1A\u8BAE\u573A\u5730\u51FA\u79DF\u7387'),dataIndex:'space6',key:'space6',align:"center",width:250,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"space6",totalIndex:TOTALINDEX,compared:{title:['Space Occupancy<br />5500-6500万区间会议场地出租率'],record:record,sqlName:"effect_interval"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:_react2.default.createElement('div',null,'Space Occupancy',_react2.default.createElement('br',null),'6500-8000\u4E07\u533A\u95F4\u4F1A\u8BAE\u573A\u5730\u51FA\u79DF\u7387'),dataIndex:'space7',key:'space7',align:"center",width:250,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"space7",totalIndex:TOTALINDEX,compared:{title:['Space Occupancy<br />6500-8000万区间会议场地出租率'],record:record,sqlName:"effect_interval"}};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'table7_1_1 style-center'},_react2.default.createElement(_row2.default,{className:'title',id:'table6_2'},_react2.default.createElement(_row2.default,null,TITLE),_react2.default.createElement(_table2.default,{columns:columns,dataSource:(0,_mobx.toJS)(interval),size:'middle',bordered:true,id:'table1',pagination:false,className:'content',rowKey:function rowKey(record,index){return index;},scroll:this.state.print?{}:{x:2050,y:500}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this2.setState({print:true},function(){_this2.onExpoetExcel();});}},'\u5BFC\u51FAExcel'))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _data=__webpack_require__(718);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _compute=__webpack_require__(2190);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var totalIndex=[];var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(data){return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_compute.compute)(data);case 2:data=_context.sent;_this.setState({data:data});case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(date){var dataBegin=JSON.stringify(_data.defaultData);var data=JSON.parse(dataBegin);var year=(0,_moment2.default)(date).format('YYYY');var month=(0,_moment2.default)(date).format('M');fetch('/getPriceRepairing?year='+year+'&month='+month,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data&&x.data.length>0){data=x.data;}_this.setState({loading:false});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.downloadExcel=function(){var tableName=(0,_moment2.default)(_this.state.date).format('YYYY-MM')+' 1.1  Price Repairing \u5B98\u7F51\u6BD4\u4EF7';var innerHtml='\n          <caption>'+tableName+'</caption>\n          '+document.getElementById('table').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n        ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+'.xls');_this.setState({print:false});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),dateData:[],data:[],loading:true,loadingSave:false,print:false,monthDataAll:{}};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this3=this;var data=this.state.data;var columns=[{title:'',dataIndex:'name',key:'name',align:"center",width:100,render:function render(text,record,index){if(!(index%2)){return{props:{rowSpan:2},children:_react2.default.createElement('div',{className:'table-padding '+(totalIndex.includes(index)?'table-color-footer':'')+' ',style:{textAlign:"left"}},text)};}return{props:{rowSpan:0}};}},{title:'',align:"center",width:150,dataIndex:'room_type',key:'room_type',render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"room_type",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'2nd Day',align:"center",width:150,dataIndex:'day2',key:'day2',render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"day2",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'3nd Day',align:"center",width:150,dataIndex:'day3',key:'day3',render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"day3",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'4nd Day',align:"center",width:150,dataIndex:'day4',key:'day4',render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"day4",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'5nd Day',align:"center",width:150,dataIndex:'day5',key:'day5',render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"day5",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'6nd Day',align:"center",width:150,dataIndex:'day6',key:'day6',render:function render(text,record,index){var title=['Year End','Budget','Occ%'];var props={text:text,index:index,type:'number',name:"day6",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}},{title:'7nd Day',align:"center",width:150,dataIndex:'day7',key:'day7',render:function render(text,record,index){var props={text:text,index:index,type:'number',name:"day7",onChange:_this3.onChange,totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_1_1'},_react2.default.createElement(_row2.default,null,'1.1  Price Repairing \u5B98\u7F51\u6BD4\u4EF7'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',id:'table',bordered:true,pagination:false,className:'content',rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_4_1'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:this.state.print},'\u5BFC\u51FAExcel')))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.compute=compute;var _method=__webpack_require__(20);function compute(data){return data;}

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(12);__webpack_require__(6);__webpack_require__(4);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _mobxReact=__webpack_require__(18);var _data=__webpack_require__(718);__webpack_require__(2192);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,select:{room:"房型一",type:"携程"}},_this.onChange=function(name,value){var select=_this.state.select;select[name]=value;_this.setState({select:select});},_this.getDateData=function(date){var year=(0,_moment2.default)(date).format('YYYY');var month=(0,_moment2.default)(date).format('M');fetch('/getPriceRepairing?year='+year+'&month='+month,{credentials:'include'}).then(function(x){return x.json();}).then(function(x){var data=JSON.parse(JSON.stringify(_data.defaultData));if(x.data&&x.data.length>0){data=x.data;}_this.setState({loading:false,data:data});}).catch(function(err){_this.setState({loading:false});console.error(err);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,select=_state.select;return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1 price-visual-diagram'},_react2.default.createElement(_row2.default,{className:'title',id:'table4_1_1'},_react2.default.createElement(_row2.default,null,'1.2  Price Repairing Visual Diagram \u5B98\u7F51\u6BD4\u4EF7\u53EF\u89C6\u5316'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str,data:[],loading:true});_this2.getDateData(str);}}))),_react2.default.createElement('div',{className:'price-content'},_react2.default.createElement('div',{className:'select-type'},_react2.default.createElement(_button2.default,{type:'primary',ghost:select.type!="携程",onClick:function onClick(){return _this2.onChange('type','携程');}},'\u643A\u7A0B'),_react2.default.createElement(_button2.default,{type:'primary',ghost:select.type!="美团",onClick:function onClick(){return _this2.onChange('type',"美团");}},'\u7F8E\u56E2'),_react2.default.createElement(_button2.default,{type:'primary',ghost:select.type!="温德姆中文",onClick:function onClick(){return _this2.onChange('type',"温德姆中文");}},'\u6E29\u5FB7\u59C6\u4E2D\u6587'),_react2.default.createElement(_button2.default,{type:'primary',ghost:select.type!="温德姆英文",onClick:function onClick(){return _this2.onChange('type',"温德姆英文");}},'\u6E29\u5FB7\u59C6\u82F1\u6587')),_react2.default.createElement('div',{className:'select-type'},_react2.default.createElement(_button2.default,{type:'primary',ghost:select.room!="房型一",onClick:function onClick(){return _this2.onChange('room',"房型一");}},'\u623F\u578B\u4E00'),_react2.default.createElement(_button2.default,{type:'primary',ghost:select.room!="房型二",onClick:function onClick(){return _this2.onChange('room',"房型二");}},'\u623F\u578B\u4E8C'))),_react2.default.createElement('div',{className:'list'},['day2','day3','day4','day5','day6','day7'].map(function(name,i){var item=data.find(function(v){return v.name==select.type&&v.room_type==select.room;})||{};var websiteData=data.find(function(v){return v.room_type==select.room&&v.name=="GCH官网";})||{};var className='';if(websiteData[name]>item[name])className='red';if(websiteData[name]==item[name])className='yellow';return _react2.default.createElement('div',{className:'item '+className,key:name},_react2.default.createElement('div',{className:'day'},i+1,_react2.default.createElement('span',null,'th'),' day'),_react2.default.createElement('div',null,_react2.default.createElement('span',null,websiteData[name]||0),_react2.default.createElement('span',null,item[name]||0)));}))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _upload=__webpack_require__(171);var _upload2=_interopRequireDefault(_upload);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _icon=__webpack_require__(38);var _icon2=_interopRequireDefault(_icon);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(172);__webpack_require__(6);__webpack_require__(75);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),loading:false,fileList:[]},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'render',value:function render(){var _this2=this;var _state=this.state,date=_state.date,loading=_state.loading,fileList=_state.fileList;var that=this;var props={name:'file',action:'/priceExcel',accept:".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",headers:{authorization:'authorization-text'},data:{month:(0,_moment2.default)(date).format('M'),year:(0,_moment2.default)(date).format('YYYY')},fileList:fileList,onChange:function onChange(info){that.setState({fileList:[info.file],loading:true});if(info.file.status==='done'){if(info.file.response.status==1){_message3.default.success(date+' \u6570\u636E\u5DF2\u7ECF\u66F4\u65B0\u6210\u529F\uFF01');}else{_message3.default.error(date+' \u66F4\u65B0\u5931\u8D25\uFF0C\u8BF7\u91CD\u65B0\u4E0A\u4F20\u6216\u8054\u7CFB\u7BA1\u7406\u5458\uFF01');}that.setState({loading:false});return;}else if(info.file.status==='error'){_message3.default.error('\u8868\u683C\u4E0A\u4F20\u5931\u8D25\uFF01');that.setState({loading:false});}}};return _react2.default.createElement('div',{className:'excel-upload'},_react2.default.createElement('div',{className:'list'},_react2.default.createElement('div',{className:'title'},'1.3 Price Repairing File Upload \u5B98\u7F51\u6BD4\u4EF7\u6587\u4EF6\u4E0A\u4F20'),_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this2.setState({date:str});}}),_react2.default.createElement(_upload2.default,props,_react2.default.createElement(_button2.default,{loading:loading},_react2.default.createElement(_icon2.default,{type:'upload'}),' ',loading?'文件上传中。。。':"本地上传"))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _slider=__webpack_require__(2195);var _slider2=_interopRequireDefault(_slider);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(2216);__webpack_require__(6);__webpack_require__(42);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);__webpack_require__(2218);var _method=__webpack_require__(20);var _method2=_interopRequireDefault(_method);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var index=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={data:[],value:"",width:localStorage.getItem('width')||1200,type:'',list:[]},_this.getData=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var res,type,list;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return(0,_request2.default)("/consulting/lst");case 3:res=_context.sent;type=res.data[0]?res.data[0].type:"";list=[].concat(_toConsumableArray(new Set((res.data||[]).map(function(x){return x.type;}))));_this.setState({type:type,list:list,data:res.data||[],value:(0,_method2.default)([0,'name'],res.data||[],'')});_context.next=12;break;case 9:_context.prev=9;_context.t0=_context['catch'](0);console.log(_context.t0);case 12:case'end':return _context.stop();}}},_callee,_this2,[[0,9]]);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData();}},{key:'render',value:function render(){var _this3=this;var _state=this.state,data=_state.data,value=_state.value,width=_state.width,type=_state.type,list=_state.list;var item=data.find(function(x){return x.name==value;})||{};return _react2.default.createElement('div',{className:'consulting'},_react2.default.createElement('div',{className:'title'},'Consulting Reports \u7B2C\u4E09\u65B9\u884C\u4E1A\u8D44\u8BAF\u62A5\u544A\u6458\u8981'),_react2.default.createElement('div',{className:'type'},list.map(function(x){return _react2.default.createElement(_button2.default,{onClick:function onClick(){_this3.setState({type:x,value:(data.find(function(v){return v.type==x;})||{}).name||""});},type:x==type?'primary':''},x);})),_react2.default.createElement('div',{className:'select'},_react2.default.createElement(_select2.default,{value:value,showSearch:true,onChange:function onChange(value){return _this3.setState({value:value});}},data.filter(function(x){return x.type==type;}).map(function(x){return _react2.default.createElement(Option,{key:x.name},x.name);}))),_react2.default.createElement('div',{className:'content'},_react2.default.createElement('div',{className:'item-title'},item.name||""),_react2.default.createElement('div',{className:'desc'},item.source?item.source:''),_react2.default.createElement(_slider2.default,{value:width,min:800,max:1800,onChange:function onChange(v){localStorage.setItem('width',v);_this3.setState({width:v});}}),JSON.parse(item.img||"[]").map(function(x){return _react2.default.createElement('img',{key:x.uid,style:{width:width},src:x.url,alt:'',className:'img-item'});})));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _Slider = _interopRequireDefault(__webpack_require__(2196));

var _Range = _interopRequireDefault(__webpack_require__(2215));

var _Handle = _interopRequireDefault(__webpack_require__(722));

var _tooltip = _interopRequireDefault(__webpack_require__(87));

var _configProvider = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Slider = /*#__PURE__*/function (_React$Component) {
  _inherits(Slider, _React$Component);

  var _super = _createSuper(Slider);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _super.call(this, props);

    _this.toggleTooltipVisible = function (index, visible) {
      _this.setState(function (_ref) {
        var visibles = _ref.visibles;
        return {
          visibles: _extends(_extends({}, visibles), _defineProperty({}, index, visible))
        };
      });
    };

    _this.handleWithTooltip = function (_a) {
      var tooltipPrefixCls = _a.tooltipPrefixCls,
          prefixCls = _a.prefixCls,
          _b = _a.info,
          value = _b.value,
          dragging = _b.dragging,
          index = _b.index,
          restProps = __rest(_b, ["value", "dragging", "index"]);

      var _this$props = _this.props,
          tipFormatter = _this$props.tipFormatter,
          tooltipVisible = _this$props.tooltipVisible,
          tooltipPlacement = _this$props.tooltipPlacement,
          getTooltipPopupContainer = _this$props.getTooltipPopupContainer;
      var visibles = _this.state.visibles;
      var isTipFormatter = tipFormatter ? visibles[index] || dragging : false;
      var visible = tooltipVisible || tooltipVisible === undefined && isTipFormatter;
      return /*#__PURE__*/React.createElement(_tooltip["default"], {
        prefixCls: tooltipPrefixCls,
        title: tipFormatter ? tipFormatter(value) : '',
        visible: visible,
        placement: tooltipPlacement || 'top',
        transitionName: "zoom-down",
        key: index,
        overlayClassName: "".concat(prefixCls, "-tooltip"),
        getPopupContainer: getTooltipPopupContainer || function () {
          return document.body;
        }
      }, /*#__PURE__*/React.createElement(_Handle["default"], _extends({}, restProps, {
        value: value,
        onMouseEnter: function onMouseEnter() {
          return _this.toggleTooltipVisible(index, true);
        },
        onMouseLeave: function onMouseLeave() {
          return _this.toggleTooltipVisible(index, false);
        }
      })));
    };

    _this.saveSlider = function (node) {
      _this.rcSlider = node;
    };

    _this.renderSlider = function (_ref2) {
      var getPrefixCls = _ref2.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          customizeTooltipPrefixCls = _a.tooltipPrefixCls,
          range = _a.range,
          restProps = __rest(_a, ["prefixCls", "tooltipPrefixCls", "range"]);

      var prefixCls = getPrefixCls('slider', customizePrefixCls);
      var tooltipPrefixCls = getPrefixCls('tooltip', customizeTooltipPrefixCls);

      if (range) {
        return /*#__PURE__*/React.createElement(_Range["default"], _extends({}, restProps, {
          ref: _this.saveSlider,
          handle: function handle(info) {
            return _this.handleWithTooltip({
              tooltipPrefixCls: tooltipPrefixCls,
              prefixCls: prefixCls,
              info: info
            });
          },
          prefixCls: prefixCls,
          tooltipPrefixCls: tooltipPrefixCls
        }));
      }

      return /*#__PURE__*/React.createElement(_Slider["default"], _extends({}, restProps, {
        ref: _this.saveSlider,
        handle: function handle(info) {
          return _this.handleWithTooltip({
            tooltipPrefixCls: tooltipPrefixCls,
            prefixCls: prefixCls,
            info: info
          });
        },
        prefixCls: prefixCls,
        tooltipPrefixCls: tooltipPrefixCls
      }));
    };

    _this.state = {
      visibles: {}
    };
    return _this;
  }

  _createClass(Slider, [{
    key: "focus",
    value: function focus() {
      this.rcSlider.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.rcSlider.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSlider);
    }
  }]);

  return Slider;
}(React.Component);

exports["default"] = Slider;
Slider.defaultProps = {
  tipFormatter: function tipFormatter(value) {
    return value.toString();
  }
};

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(48);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(31);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(72);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(32);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(76);

var _warning2 = _interopRequireDefault(_warning);

var _Track = __webpack_require__(719);

var _Track2 = _interopRequireDefault(_Track);

var _createSlider = __webpack_require__(720);

var _createSlider2 = _interopRequireDefault(_createSlider);

var _utils = __webpack_require__(443);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* eslint-disable react/prop-types */
var Slider = function (_React$Component) {
  (0, _inherits3['default'])(Slider, _React$Component);

  function Slider(props) {
    (0, _classCallCheck3['default'])(this, Slider);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

    _this.onEnd = function (force) {
      var dragging = _this.state.dragging;

      _this.removeDocumentEvents();
      if (dragging || force) {
        _this.props.onAfterChange(_this.getValue());
      }
      _this.setState({ dragging: false });
    };

    var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
    var value = props.value !== undefined ? props.value : defaultValue;

    _this.state = {
      value: _this.trimAlignValue(value),
      dragging: false
    };

    (0, _warning2['default'])(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecated, please use trackStyle instead.');
    (0, _warning2['default'])(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecated, please use railStyle instead.');
    return _this;
  }

  (0, _createClass3['default'])(Slider, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (!('value' in this.props || 'min' in this.props || 'max' in this.props)) {
        return;
      }
      var _props = this.props,
          value = _props.value,
          onChange = _props.onChange;

      var theValue = value !== undefined ? value : prevState.value;
      var nextValue = this.trimAlignValue(theValue, this.props);
      if (nextValue !== prevState.value) {
        // eslint-disable-next-line
        this.setState({ value: nextValue });
        if (utils.isValueOutOfRange(theValue, this.props)) {
          onChange(nextValue);
        }
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      var nextState = state.value > this.props.max ? (0, _extends3['default'])({}, state, { value: this.props.max }) : state;
      if (isNotControlled) {
        this.setState(nextState);
      }

      var changedValue = nextState.value;
      props.onChange(changedValue);
    }
  }, {
    key: 'onStart',
    value: function onStart(position) {
      this.setState({ dragging: true });
      var props = this.props;
      var prevValue = this.getValue();
      props.onBeforeChange(prevValue);

      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;

      if (value === prevValue) return;

      this.prevMovedHandleIndex = 0;

      this.onChange({ value: value });
    }
  }, {
    key: 'onMove',
    value: function onMove(e, position) {
      utils.pauseEvent(e);
      var oldValue = this.state.value;

      var value = this.calcValueByPos(position);
      if (value === oldValue) return;

      this.onChange({ value: value });
    }
  }, {
    key: 'onKeyboard',
    value: function onKeyboard(e) {
      var _props2 = this.props,
          reverse = _props2.reverse,
          vertical = _props2.vertical;

      var valueMutator = utils.getKeyboardValueMutator(e, vertical, reverse);
      if (valueMutator) {
        utils.pauseEvent(e);
        var state = this.state;
        var oldValue = state.value;
        var mutatedValue = valueMutator(oldValue, this.props);
        var value = this.trimAlignValue(mutatedValue);
        if (value === oldValue) return;

        this.onChange({ value: value });
        this.props.onAfterChange(value);
        this.onEnd();
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: 'getLowerBound',
    value: function getLowerBound() {
      return this.props.min;
    }
  }, {
    key: 'getUpperBound',
    value: function getUpperBound() {
      return this.state.value;
    }
  }, {
    key: 'trimAlignValue',
    value: function trimAlignValue(v) {
      var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (v === null) {
        return null;
      }

      var mergedProps = (0, _extends3['default'])({}, this.props, nextProps);
      var val = utils.ensureValueInRange(v, mergedProps);
      return utils.ensureValuePrecision(val, mergedProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          prefixCls = _props3.prefixCls,
          vertical = _props3.vertical,
          included = _props3.included,
          disabled = _props3.disabled,
          minimumTrackStyle = _props3.minimumTrackStyle,
          trackStyle = _props3.trackStyle,
          handleStyle = _props3.handleStyle,
          tabIndex = _props3.tabIndex,
          min = _props3.min,
          max = _props3.max,
          reverse = _props3.reverse,
          handleGenerator = _props3.handle;
      var _state = this.state,
          value = _state.value,
          dragging = _state.dragging;

      var offset = this.calcOffset(value);
      var handle = handleGenerator({
        className: prefixCls + '-handle',
        prefixCls: prefixCls,
        vertical: vertical,
        offset: offset,
        value: value,
        dragging: dragging,
        disabled: disabled,
        min: min,
        max: max,
        reverse: reverse,
        index: 0,
        tabIndex: tabIndex,
        style: handleStyle[0] || handleStyle,
        ref: function ref(h) {
          return _this2.saveHandle(0, h);
        }
      });

      var _trackStyle = trackStyle[0] || trackStyle;
      var track = _react2['default'].createElement(_Track2['default'], {
        className: prefixCls + '-track',
        vertical: vertical,
        included: included,
        offset: 0,
        reverse: reverse,
        length: offset,
        style: (0, _extends3['default'])({}, minimumTrackStyle, _trackStyle)
      });

      return { tracks: track, handles: handle };
    }
  }]);
  return Slider;
}(_react2['default'].Component);

Slider.propTypes = {
  defaultValue: _propTypes2['default'].number,
  value: _propTypes2['default'].number,
  disabled: _propTypes2['default'].bool,
  autoFocus: _propTypes2['default'].bool,
  tabIndex: _propTypes2['default'].number,
  reverse: _propTypes2['default'].bool,
  min: _propTypes2['default'].number,
  max: _propTypes2['default'].number
};
exports['default'] = (0, _createSlider2['default'])(Slider);
module.exports = exports['default'];

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__(2198);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__(2201);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2199), __esModule: true };

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2200);
module.exports = __webpack_require__(88).Object.getPrototypeOf;


/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(217);
var $getPrototypeOf = __webpack_require__(459);

__webpack_require__(721)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2202), __esModule: true };

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2203);
var $Object = __webpack_require__(88).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(155);
var $getOwnPropertyDescriptor = __webpack_require__(330).f;

__webpack_require__(721)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(78);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__(48);

var _extends5 = _interopRequireDefault(_extends4);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(22);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(76);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
  (0, _warning2['default'])(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
  var points = Object.keys(marks).map(parseFloat).sort(function (a, b) {
    return a - b;
  });
  if (dots && step) {
    for (var i = min; i <= max; i += step) {
      if (points.indexOf(i) === -1) {
        points.push(i);
      }
    }
  }
  return points;
};

var Steps = function Steps(_ref) {
  var prefixCls = _ref.prefixCls,
      vertical = _ref.vertical,
      reverse = _ref.reverse,
      marks = _ref.marks,
      dots = _ref.dots,
      step = _ref.step,
      included = _ref.included,
      lowerBound = _ref.lowerBound,
      upperBound = _ref.upperBound,
      max = _ref.max,
      min = _ref.min,
      dotStyle = _ref.dotStyle,
      activeDotStyle = _ref.activeDotStyle;

  var range = max - min;
  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
    var _classNames;

    var offset = Math.abs(point - min) / range * 100 + '%';

    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var style = vertical ? (0, _extends5['default'])({}, dotStyle, (0, _defineProperty3['default'])({}, reverse ? 'top' : 'bottom', offset)) : (0, _extends5['default'])({}, dotStyle, (0, _defineProperty3['default'])({}, reverse ? 'right' : 'left', offset));
    if (isActived) {
      style = (0, _extends5['default'])({}, style, activeDotStyle);
    }

    var pointClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot-active', isActived), (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot-reverse', reverse), _classNames));

    return _react2['default'].createElement('span', { className: pointClassName, style: style, key: point });
  });

  return _react2['default'].createElement(
    'div',
    { className: prefixCls + '-step' },
    elements
  );
};

Steps.propTypes = {
  prefixCls: _propTypes2['default'].string,
  activeDotStyle: _propTypes2['default'].object,
  dotStyle: _propTypes2['default'].object,
  min: _propTypes2['default'].number,
  max: _propTypes2['default'].number,
  upperBound: _propTypes2['default'].number,
  lowerBound: _propTypes2['default'].number,
  included: _propTypes2['default'].bool,
  dots: _propTypes2['default'].bool,
  step: _propTypes2['default'].number,
  marks: _propTypes2['default'].object,
  vertical: _propTypes2['default'].bool,
  reverse: _propTypes2['default'].bool
};

exports['default'] = Steps;
module.exports = exports['default'];

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(48);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(78);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(22);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Marks = function Marks(_ref) {
  var className = _ref.className,
      vertical = _ref.vertical,
      reverse = _ref.reverse,
      marks = _ref.marks,
      included = _ref.included,
      upperBound = _ref.upperBound,
      lowerBound = _ref.lowerBound,
      max = _ref.max,
      min = _ref.min,
      onClickLabel = _ref.onClickLabel;

  var marksKeys = Object.keys(marks);

  var range = max - min;
  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
    return a - b;
  }).map(function (point) {
    var _classNames;

    var markPoint = marks[point];
    var markPointIsObject = typeof markPoint === 'object' && !_react2['default'].isValidElement(markPoint);
    var markLabel = markPointIsObject ? markPoint.label : markPoint;
    if (!markLabel && markLabel !== 0) {
      return null;
    }

    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var markClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, className + '-text', true), (0, _defineProperty3['default'])(_classNames, className + '-text-active', isActive), _classNames));

    var bottomStyle = (0, _defineProperty3['default'])({
      marginBottom: '-50%'
    }, reverse ? 'top' : 'bottom', (point - min) / range * 100 + '%');

    var leftStyle = (0, _defineProperty3['default'])({
      transform: 'translateX(-50%)',
      msTransform: 'translateX(-50%)'
    }, reverse ? 'right' : 'left', reverse ? (point - min / 4) / range * 100 + '%' : (point - min) / range * 100 + '%');

    var style = vertical ? bottomStyle : leftStyle;
    var markStyle = markPointIsObject ? (0, _extends3['default'])({}, style, markPoint.style) : style;
    return _react2['default'].createElement(
      'span',
      {
        className: markClassName,
        style: markStyle,
        key: point,
        onMouseDown: function onMouseDown(e) {
          return onClickLabel(e, point);
        },
        onTouchStart: function onTouchStart(e) {
          return onClickLabel(e, point);
        }
      },
      markLabel
    );
  });

  return _react2['default'].createElement(
    'div',
    { className: className },
    elements
  );
};

Marks.propTypes = {
  className: _propTypes2['default'].string,
  vertical: _propTypes2['default'].bool,
  reverse: _propTypes2['default'].bool,
  marks: _propTypes2['default'].object,
  included: _propTypes2['default'].bool,
  upperBound: _propTypes2['default'].number,
  lowerBound: _propTypes2['default'].number,
  max: _propTypes2['default'].number,
  min: _propTypes2['default'].number,
  onClickLabel: _propTypes2['default'].func
};

exports['default'] = Marks;
module.exports = exports['default'];

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2207), __esModule: true };

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(456);
__webpack_require__(2208);
module.exports = __webpack_require__(88).Array.from;


/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(316);
var $export = __webpack_require__(140);
var toObject = __webpack_require__(217);
var call = __webpack_require__(2209);
var isArrayIter = __webpack_require__(2210);
var toLength = __webpack_require__(453);
var createProperty = __webpack_require__(2211);
var getIterFn = __webpack_require__(2212);

$export($export.S + $export.F * !__webpack_require__(2214)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(185);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(218);
var ITERATOR = __webpack_require__(114)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(142);
var createDesc = __webpack_require__(216);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(2213);
var ITERATOR = __webpack_require__(114)('iterator');
var Iterators = __webpack_require__(218);
module.exports = __webpack_require__(88).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(318);
var TAG = __webpack_require__(114)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(114)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(78);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(48);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(723);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(31);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(72);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(32);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(19);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(22);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactLifecyclesCompat = __webpack_require__(36);

var _shallowequal = __webpack_require__(89);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _Track = __webpack_require__(719);

var _Track2 = _interopRequireDefault(_Track);

var _createSlider = __webpack_require__(720);

var _createSlider2 = _interopRequireDefault(_createSlider);

var _utils = __webpack_require__(443);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* eslint-disable react/prop-types */
var _trimAlignValue = function _trimAlignValue(_ref) {
  var value = _ref.value,
      handle = _ref.handle,
      bounds = _ref.bounds,
      props = _ref.props;
  var allowCross = props.allowCross,
      pushable = props.pushable;

  var thershold = Number(pushable);
  var valInRange = utils.ensureValueInRange(value, props);
  var valNotConflict = valInRange;
  if (!allowCross && handle != null && bounds !== undefined) {
    if (handle > 0 && valInRange <= bounds[handle - 1] + thershold) {
      valNotConflict = bounds[handle - 1] + thershold;
    }
    if (handle < bounds.length - 1 && valInRange >= bounds[handle + 1] - thershold) {
      valNotConflict = bounds[handle + 1] - thershold;
    }
  }
  return utils.ensureValuePrecision(valNotConflict, props);
};

var Range = function (_React$Component) {
  (0, _inherits3['default'])(Range, _React$Component);

  function Range(props) {
    (0, _classCallCheck3['default'])(this, Range);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, props));

    _this.onEnd = function (force) {
      var handle = _this.state.handle;

      _this.removeDocumentEvents();

      if (handle !== null || force) {
        _this.props.onAfterChange(_this.getValue());
      }

      _this.setState({
        handle: null
      });
    };

    var count = props.count,
        min = props.min,
        max = props.max;

    var initialValue = Array.apply(undefined, (0, _toConsumableArray3['default'])(Array(count + 1))).map(function () {
      return min;
    });
    var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
    var value = props.value !== undefined ? props.value : defaultValue;
    var bounds = value.map(function (v, i) {
      return _trimAlignValue({
        value: v,
        handle: i,
        props: props
      });
    });
    var recent = bounds[0] === max ? 0 : bounds.length - 1;

    _this.state = {
      handle: null,
      recent: recent,
      bounds: bounds
    };
    return _this;
  }

  (0, _createClass3['default'])(Range, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (!('value' in this.props || 'min' in this.props || 'max' in this.props)) {
        return;
      }
      if (this.props.min === prevProps.min && this.props.max === prevProps.max && (0, _shallowequal2['default'])(this.props.value, prevProps.value)) {
        return;
      }
      var _props = this.props,
          onChange = _props.onChange,
          value = _props.value;

      var currentValue = value || prevState.bounds;
      if (currentValue.some(function (v) {
        return utils.isValueOutOfRange(v, _this2.props);
      })) {
        var newValues = currentValue.map(function (v) {
          return utils.ensureValueInRange(v, _this2.props);
        });
        onChange(newValues);
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      if (isNotControlled) {
        this.setState(state);
      } else {
        var controlledState = {};

        ['handle', 'recent'].forEach(function (item) {
          if (state[item] !== undefined) {
            controlledState[item] = state[item];
          }
        });

        if (Object.keys(controlledState).length) {
          this.setState(controlledState);
        }
      }

      var data = (0, _extends3['default'])({}, this.state, state);
      var changedValue = data.bounds;
      props.onChange(changedValue);
    }
  }, {
    key: 'onStart',
    value: function onStart(position) {
      var props = this.props;
      var state = this.state;
      var bounds = this.getValue();
      props.onBeforeChange(bounds);

      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;

      var closestBound = this.getClosestBound(value);
      this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);

      this.setState({
        handle: this.prevMovedHandleIndex,
        recent: this.prevMovedHandleIndex
      });

      var prevValue = bounds[this.prevMovedHandleIndex];
      if (value === prevValue) return;

      var nextBounds = [].concat((0, _toConsumableArray3['default'])(state.bounds));
      nextBounds[this.prevMovedHandleIndex] = value;
      this.onChange({ bounds: nextBounds });
    }
  }, {
    key: 'onMove',
    value: function onMove(e, position) {
      utils.pauseEvent(e);
      var state = this.state;

      var value = this.calcValueByPos(position);
      var oldValue = state.bounds[state.handle];
      if (value === oldValue) return;

      this.moveTo(value);
    }
  }, {
    key: 'onKeyboard',
    value: function onKeyboard(e) {
      var _props2 = this.props,
          reverse = _props2.reverse,
          vertical = _props2.vertical;

      var valueMutator = utils.getKeyboardValueMutator(e, vertical, reverse);

      if (valueMutator) {
        utils.pauseEvent(e);
        var state = this.state,
            props = this.props;
        var bounds = state.bounds,
            handle = state.handle;

        var oldValue = bounds[handle === null ? state.recent : handle];
        var mutatedValue = valueMutator(oldValue, props);
        var value = _trimAlignValue({
          value: mutatedValue,
          handle: handle,
          bounds: state.bounds,
          props: props
        });
        if (value === oldValue) return;
        var isFromKeyboardEvent = true;
        this.moveTo(value, isFromKeyboardEvent);
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.bounds;
    }
  }, {
    key: 'getClosestBound',
    value: function getClosestBound(value) {
      var bounds = this.state.bounds;

      var closestBound = 0;
      for (var i = 1; i < bounds.length - 1; ++i) {
        if (value >= bounds[i]) {
          closestBound = i;
        }
      }
      if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
        closestBound += 1;
      }
      return closestBound;
    }
  }, {
    key: 'getBoundNeedMoving',
    value: function getBoundNeedMoving(value, closestBound) {
      var _state = this.state,
          bounds = _state.bounds,
          recent = _state.recent;

      var boundNeedMoving = closestBound;
      var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];

      if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
        boundNeedMoving = recent;
      }

      if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
        boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
      }
      return boundNeedMoving;
    }
  }, {
    key: 'getLowerBound',
    value: function getLowerBound() {
      return this.state.bounds[0];
    }
  }, {
    key: 'getUpperBound',
    value: function getUpperBound() {
      var bounds = this.state.bounds;

      return bounds[bounds.length - 1];
    }

    /**
     * Returns an array of possible slider points, taking into account both
     * `marks` and `step`. The result is cached.
     */

  }, {
    key: 'getPoints',
    value: function getPoints() {
      var _props3 = this.props,
          marks = _props3.marks,
          step = _props3.step,
          min = _props3.min,
          max = _props3.max;

      var cache = this._getPointsCache;
      if (!cache || cache.marks !== marks || cache.step !== step) {
        var pointsObject = (0, _extends3['default'])({}, marks);
        if (step !== null) {
          for (var point = min; point <= max; point += step) {
            pointsObject[point] = point;
          }
        }
        var points = Object.keys(pointsObject).map(parseFloat);
        points.sort(function (a, b) {
          return a - b;
        });
        this._getPointsCache = { marks: marks, step: step, points: points };
      }
      return this._getPointsCache.points;
    }
  }, {
    key: 'moveTo',
    value: function moveTo(value, isFromKeyboardEvent) {
      var _this3 = this;

      var state = this.state,
          props = this.props;

      var nextBounds = [].concat((0, _toConsumableArray3['default'])(state.bounds));
      var handle = state.handle === null ? state.recent : state.handle;
      nextBounds[handle] = value;
      var nextHandle = handle;
      if (props.pushable !== false) {
        this.pushSurroundingHandles(nextBounds, nextHandle);
      } else if (props.allowCross) {
        nextBounds.sort(function (a, b) {
          return a - b;
        });
        nextHandle = nextBounds.indexOf(value);
      }
      this.onChange({
        recent: nextHandle,
        handle: nextHandle,
        bounds: nextBounds
      });
      if (isFromKeyboardEvent) {
        // known problem: because setState is async,
        // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
        // cause onBeforeChange and onAfterChange receive wrong value.
        // here use setState callback to hack，but not elegant
        this.props.onAfterChange(nextBounds);
        this.setState({}, function () {
          _this3.handlesRefs[nextHandle].focus();
        });
        this.onEnd();
      }
    }
  }, {
    key: 'pushSurroundingHandles',
    value: function pushSurroundingHandles(bounds, handle) {
      var value = bounds[handle];
      var threshold = this.props.pushable;

      threshold = Number(threshold);

      var direction = 0;
      if (bounds[handle + 1] - value < threshold) {
        direction = +1; // push to right
      }
      if (value - bounds[handle - 1] < threshold) {
        direction = -1; // push to left
      }

      if (direction === 0) {
        return;
      }

      var nextHandle = handle + direction;
      var diffToNext = direction * (bounds[nextHandle] - value);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // revert to original value if pushing is impossible
        bounds[handle] = bounds[nextHandle] - direction * threshold;
      }
    }
  }, {
    key: 'pushHandle',
    value: function pushHandle(bounds, handle, direction, amount) {
      var originalValue = bounds[handle];
      var currentValue = bounds[handle];
      while (direction * (currentValue - originalValue) < amount) {
        if (!this.pushHandleOnePoint(bounds, handle, direction)) {
          // can't push handle enough to create the needed `amount` gap, so we
          // revert its position to the original value
          bounds[handle] = originalValue;
          return false;
        }
        currentValue = bounds[handle];
      }
      // the handle was pushed enough to create the needed `amount` gap
      return true;
    }
  }, {
    key: 'pushHandleOnePoint',
    value: function pushHandleOnePoint(bounds, handle, direction) {
      var points = this.getPoints();
      var pointIndex = points.indexOf(bounds[handle]);
      var nextPointIndex = pointIndex + direction;
      if (nextPointIndex >= points.length || nextPointIndex < 0) {
        // reached the minimum or maximum available point, can't push anymore
        return false;
      }
      var nextHandle = handle + direction;
      var nextValue = points[nextPointIndex];
      var threshold = this.props.pushable;

      var diffToNext = direction * (bounds[nextHandle] - nextValue);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // couldn't push next handle, so we won't push this one either
        return false;
      }
      // push the handle
      bounds[handle] = nextValue;
      return true;
    }
  }, {
    key: 'trimAlignValue',
    value: function trimAlignValue(value) {
      var _state2 = this.state,
          handle = _state2.handle,
          bounds = _state2.bounds;

      return _trimAlignValue({
        value: value,
        handle: handle,
        bounds: bounds,
        props: this.props
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state3 = this.state,
          handle = _state3.handle,
          bounds = _state3.bounds;
      var _props4 = this.props,
          prefixCls = _props4.prefixCls,
          vertical = _props4.vertical,
          included = _props4.included,
          disabled = _props4.disabled,
          min = _props4.min,
          max = _props4.max,
          reverse = _props4.reverse,
          handleGenerator = _props4.handle,
          trackStyle = _props4.trackStyle,
          handleStyle = _props4.handleStyle,
          tabIndex = _props4.tabIndex;


      var offsets = bounds.map(function (v) {
        return _this4.calcOffset(v);
      });

      var handleClassName = prefixCls + '-handle';
      var handles = bounds.map(function (v, i) {
        var _classNames;

        var _tabIndex = tabIndex[i] || 0;
        if (disabled || tabIndex[i] === null) {
          _tabIndex = null;
        }
        return handleGenerator({
          className: (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, handleClassName, true), (0, _defineProperty3['default'])(_classNames, handleClassName + '-' + (i + 1), true), _classNames)),
          prefixCls: prefixCls,
          vertical: vertical,
          offset: offsets[i],
          value: v,
          dragging: handle === i,
          index: i,
          tabIndex: _tabIndex,
          min: min,
          max: max,
          reverse: reverse,
          disabled: disabled,
          style: handleStyle[i],
          ref: function ref(h) {
            return _this4.saveHandle(i, h);
          }
        });
      });

      var tracks = bounds.slice(0, -1).map(function (_, index) {
        var _classNames2;

        var i = index + 1;
        var trackClassName = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-track', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-track-' + i, true), _classNames2));
        return _react2['default'].createElement(_Track2['default'], {
          className: trackClassName,
          vertical: vertical,
          reverse: reverse,
          included: included,
          offset: offsets[i - 1],
          length: offsets[i] - offsets[i - 1],
          style: trackStyle[index],
          key: i
        });
      });

      return { tracks: tracks, handles: handles };
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if ('value' in props || 'min' in props || 'max' in props) {
        var value = props.value || state.bounds;
        var nextBounds = value.map(function (v, i) {
          return _trimAlignValue({
            value: v,
            handle: i,
            bounds: state.bounds,
            props: props
          });
        });
        if (nextBounds.length === state.bounds.length && nextBounds.every(function (v, i) {
          return v === state.bounds[i];
        })) {
          return null;
        }
        return (0, _extends3['default'])({}, state, {
          bounds: nextBounds
        });
      }
      return null;
    }
  }]);
  return Range;
}(_react2['default'].Component);

Range.displayName = 'Range';
Range.propTypes = {
  autoFocus: _propTypes2['default'].bool,
  defaultValue: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
  value: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
  count: _propTypes2['default'].number,
  pushable: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].number]),
  allowCross: _propTypes2['default'].bool,
  disabled: _propTypes2['default'].bool,
  reverse: _propTypes2['default'].bool,
  tabIndex: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
  min: _propTypes2['default'].number,
  max: _propTypes2['default'].number
};
Range.defaultProps = {
  count: 1,
  allowCross: true,
  pushable: false,
  tabIndex: []
};


(0, _reactLifecyclesCompat.polyfill)(Range);

exports['default'] = (0, _createSlider2['default'])(Range);
module.exports = exports['default'];

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50);

__webpack_require__(2217);

__webpack_require__(100);

/***/ }),
/* 2217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _input=__webpack_require__(26);var _input2=_interopRequireDefault(_input);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(25);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2220);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextArea=_input2.default.TextArea;var totalIndex=[6,13,20];var index=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(data){var sumName=['room','breakfast','westernRestaurant','chineseRestaurant','wedd','otherParty','foodServiceIncome','canSell','takeUpRoom','human','hisHelper'];totalIndex.forEach(function(index){sumName.forEach(function(name){data[index][name]=data.reduce(function(a,b,i){if(i<index&&i>=index-6)a+=(0,_method.numConvert)(b[name]);return a;},0).toFixed(2);});});// 计算occ adr
data.forEach(function(item,index){data[index].occ=(0,_method.calculation)(item.takeUpRoom,item.canSell,3);data[index].adr=(0,_method.calculation)(item.room,item.takeUpRoom,0);data[index].peopleWork=(0,_method.calculation)((0,_method.sum)([item.room,item.foodServiceIncome]),(0,_method.sum)([item.human,item.hisHelper]),2);});_this.setState({data:data});};_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);};_this.getData=function(date){var data=_lodash2.default.cloneDeep((0,_data.dataDefault)(date));fetch('/mayDayInfo?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data&&x.data.data.length>0){data=x.data.data;}_this.setState({loading:false,note:x.data.note||{note:""}});_this.computeNum(data);}).catch(function(err){_this.setState({loading:false});console.error(err);});};_this.onSave=function(){_this.setState({loadingSave:true});var date=_this.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var data=_this.state.data.map(function(x){return _extends({},x,{year:year});});var note=_extends({},_this.state.note,{year:year});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));dataFrom.append('note',JSON.stringify(note));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/mayDaySave',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this.getData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){var name='2021\u5E74\u4E94\u4E00\u5047\u671F\u4E1A\u7EE9\u60C5\u51B5 '+(0,_moment2.default)(_this.state.date).format('YYYY-MM');var innerHtml='\n              <caption>'+name+'</caption>\n              '+document.getElementById('table').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n            ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,name+'.xls');_this.setState({print:false,loading:false});});};_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,note:{note:""}};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData(this.state.date);}},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print;var columns=(0,_data.columnsData)(print).map(function(item){return{title:item.title,dataIndex:item.key,key:item.key,width:item.width||80,align:"center",fixed:item.fixed||false,render:function render(text,record,index){var props={text:text,index:index,type:item.type,name:item.key,onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:[item.title,record.title],record:record,sqlName:"_mayday"}};if(item.key=='human111'&&index==0){return{children:_react2.default.createElement(_TableText2.default,{data:_extends({},props)}),props:{rowSpan:21}};}else if(item.key=='human111')return{props:{rowSpan:0}};if(props.type.includes('input')&&totalIndex.includes(index)){props.type=props.type.includes('percent')?'percent':'number';}if(item.key=='title'&&index%7==0){return{children:_react2.default.createElement(_TableText2.default,{data:_extends({},props)}),props:{rowSpan:7}};}else if(item.key=='title'){return{props:{rowSpan:0}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}};});return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1 tableHeight'},_react2.default.createElement(_row2.default,{className:'title',id:'table9_1'},_react2.default.createElement(_row2.default,null,(0,_moment2.default)(date).format('YYYY'),'\u5E74\u4E94\u4E00\u5047\u671F\u4E1A\u7EE9\u60C5\u51B5'),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'table',pagination:false,className:'content',rowKey:function rowKey(record,index){return index;},scroll:this.state.print?{}:{y:500}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_mayday'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columnsData=exports.dataDefault=undefined;var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var dataDefault=exports.dataDefault=function dataDefault(date){var year=(0,_moment2.default)(date).format('YYYY');return[{name:'4.30',title:year+' \u9884\u6D4B\u6570',occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'5.1',title:year,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'5.2',title:year,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'5.3',title:year,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'5.4',title:year,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'5.5',title:year,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'总计',title:year,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'4.29',title:year-1+' 实际数',occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'4.30',title:year-1,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'5.1',title:year-1,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'5.2',title:year-1,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'5.3',title:year-1,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'5.4',title:year-1,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'总计',title:year-1,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'4.30',title:year-2+' 实际数',occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'5.1',title:year-2,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'5.2',title:year-2,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'5.3',title:year-2,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'5.4',title:year-2,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'5.5',title:year-2,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'总计',title:year-2,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0}];};var columnsData=exports.columnsData=function columnsData(print){return[{title:"",key:"title",type:"text",width:80},{title:"",key:"name",type:"textcenter",width:50},{title:"OCC",key:"occ",type:"percent",width:60},{title:"ADR",key:"adr",type:"number",width:60},{title:"客房收入",key:"room",type:print?"number":"inputNumber"},{title:"早餐收入",key:"breakfast",type:print?"number":"inputNumber"},{title:"西餐厅（除早）",key:"westernRestaurant",type:print?"number":"inputNumber"},{title:"中餐厅",key:"chineseRestaurant",type:print?"number":"inputNumber"},{title:"婚宴",key:"wedd",type:print?"number":"inputNumber"},{title:"其他宴会",key:"otherParty",type:print?"number":"inputNumber"},{title:"餐饮总收入",key:"foodServiceIncome",type:print?"number":"inputNumber"},{title:"可售房合计",key:"canSell",type:print?"number":"inputNumber"},{title:"占用房合计",key:"takeUpRoom",type:print?"number":"inputNumber"},{title:"",key:"human111",type:"text",width:20},{title:"人力成本",key:"human",type:print?"number":"inputNumber"},{title:"帮工费用",key:"hisHelper",type:print?"number":"inputNumber"},{title:"人效",key:"peopleWork",type:"number",width:60}];};

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_initialiseProps;__webpack_require__(10);__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2222);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=(_temp=_class=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_initialiseProps.call(_this);var year=(0,_moment2.default)().subtract(1,'month').format('YYYY');var totalIndex=[8,17,26];if(year>2022)totalIndex=[10,21,32];_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,totalIndex:totalIndex,note:{note:""}};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getData(this.state.date);}},{key:'render',value:function render(){var _this2=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print,totalIndex=_state.totalIndex;var columns=(0,_data.columnsData)(print).map(function(item){return{title:item.title,dataIndex:item.key,key:item.key,width:item.width||80,align:"center",fixed:item.fixed||false,render:function render(text,record,index){var props={text:text,index:index,type:item.type,name:item.key,onChange:_this2.onChange,totalIndex:totalIndex,compared:{title:[item.title,record.title],record:record,sqlName:"national_day"}};if(item.key=='human111'&&index==0){return{children:_react2.default.createElement(_TableText2.default,{data:_extends({},props)}),props:{rowSpan:33}};}else if(item.key=='human111')return{props:{rowSpan:0}};if(props.type.includes('input')&&totalIndex.includes(index)){props.type=props.type.includes('percent')?'percent':'number';}if(item.key=='title'&&index%11==0){return{children:_react2.default.createElement(_TableText2.default,{data:_extends({},props)}),props:{rowSpan:11}};}else if(item.key=='title'){return{props:{rowSpan:0}};}return _react2.default.createElement(_TableText2.default,{data:_extends({},props)});}};});return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table7_1_1 tableHeight'},_react2.default.createElement(_row2.default,{className:'title',id:'table9_1'},_react2.default.createElement(_row2.default,null,(0,_moment2.default)(date).format('YYYY'),'\u5E74\u56FD\u5E86\u5047\u671F\u4E1A\u7EE9\u60C5\u51B5'),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'table',pagination:false,className:'content',rowKey:function rowKey(record,index){return index;},scroll:this.state.print?{}:{y:500}})),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_nationalDay'},_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:this.downloadSG,loading:this.state.print},'\u5BFC\u51FAExcel'),_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component),_initialiseProps=function _initialiseProps(){var _this3=this;this.computeNum=function(data){var sumName=['room','breakfast','westernRestaurant','chineseRestaurant','wedd','otherParty','foodServiceIncome','canSell','takeUpRoom','human','hisHelper'];_this3.state.totalIndex.forEach(function(index){sumName.forEach(function(name){data[index][name]=data.reduce(function(a,b,i){if(i<index&&i>=index-10)a+=(0,_method.numConvert)(b[name]);return a;},0).toFixed(2);});});// 计算occ adr
data.forEach(function(item,index){data[index].occ=(0,_method.calculation)(item.takeUpRoom,item.canSell,3);data[index].adr=(0,_method.calculation)(item.room,item.takeUpRoom,0);data[index].peopleWork=(0,_method.calculation)((0,_method.sum)([item.room,item.foodServiceIncome]),(0,_method.sum)([item.human,item.hisHelper]),2);});_this3.setState({data:data});};this.onChange=function(name,value,i){var data=_this3.state.data;data[i][name]=value;_this3.computeNum(data);};this.getData=function(date){var data=_lodash2.default.cloneDeep((0,_data.dataDefault)(date));fetch('/nationalDayInfo?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data&&x.data.data.length>0){data=x.data.data;}_this3.setState({loading:false,note:x.data.note||{note:""}});_this3.computeNum(data);}).catch(function(err){_this3.setState({loading:false});console.error(err);});};this.onSave=function(){_this3.setState({loadingSave:true});var date=_this3.state.date;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this3.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var data=_this3.state.data.map(function(x){return _extends({},x,{year:year});});var note=_extends({},_this3.state.note,{year:year});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));dataFrom.append('note',JSON.stringify(note));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/nationalDaySave',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this3.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(!data[0].id){_this3.getData(_this3.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this3.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};this.downloadSG=function(){_this3.setState({print:true,loading:true},function(){var name='2021\u5E74\u56FD\u5E86\u5047\u671F\u4E1A\u7EE9\u60C5\u51B5 '+(0,_moment2.default)(_this3.state.date).format('YYYY-MM');var innerHtml='\n              <caption>'+name+'</caption>\n              '+document.getElementById('table').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n            ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,name+'.xls');_this3.setState({print:false,loading:false});});};},_temp);exports.default=index;

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columnsData=exports.dataDefault=undefined;var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var dataDefault=exports.dataDefault=function dataDefault(date){var year=(0,_moment2.default)(date).format('YYYY');return[{name:'9.28',title:year+' \u9884\u6D4B\u6570',occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'9.29',title:year+' \u9884\u6D4B\u6570',occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'9.30',title:year+' \u9884\u6D4B\u6570',occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'10.1',title:year,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'10.2',title:year,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'10.3',title:year,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'10.4',title:year,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'10.5',title:year,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'10.6',title:year,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'10.7',title:year,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'总计',title:year,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'9.28',title:year-1+' 实际数',occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'9.29',title:year-1+' 实际数',occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'9.30',title:year-1+' 实际数',occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'10.1',title:year-1,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'10.2',title:year-1,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'10.3',title:year-1,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'10.4',title:year-1,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'10.5',title:year-1,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'10.6',title:year-1,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'10.7',title:year-1,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'总计',title:year-1,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'9.28',title:year-2+' 实际数',occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'9.29',title:year-2+' 实际数',occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'9.30',title:year-2+' 实际数',occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'10.1',title:year-2,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'10.2',title:year-2,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'10.3',title:year-2,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'10.4',title:year-2,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'10.5',title:year-2,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'10.6',title:year-2,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'10.7',title:year-2,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0},{name:'总计',title:year-2,occ:0,adr:0,room:0,breakfast:0,westernRestaurant:0,chineseRestaurant:0,wedd:0,otherParty:0,foodServiceIncome:0,canSell:0,takeUpRoom:0,human:0,hisHelper:0,peopleWork:0}];};var columnsData=exports.columnsData=function columnsData(print){return[{title:"",key:"title",type:"text",width:80},{title:"",key:"name",type:"textcenter",width:50},{title:"OCC",key:"occ",type:"percent",width:60},{title:"ADR",key:"adr",type:"number",width:60},{title:"客房收入",key:"room",type:print?"number":"inputNumber"},{title:"早餐收入",key:"breakfast",type:print?"number":"inputNumber"},{title:"西餐厅（除早）",key:"westernRestaurant",type:print?"number":"inputNumber"},{title:"中餐厅",key:"chineseRestaurant",type:print?"number":"inputNumber"},{title:"婚宴",key:"wedd",type:print?"number":"inputNumber"},{title:"其他宴会",key:"otherParty",type:print?"number":"inputNumber"},{title:"餐饮总收入",key:"foodServiceIncome",type:print?"number":"inputNumber"},{title:"可售房合计",key:"canSell",type:print?"number":"inputNumber"},{title:"占用房合计",key:"takeUpRoom",type:print?"number":"inputNumber"},{title:"",key:"human111",type:"text",width:20},{title:"人力成本",key:"human",type:print?"number":"inputNumber"},{title:"帮工费用",key:"hisHelper",type:print?"number":"inputNumber"},{title:"人效",key:"peopleWork",type:"number",width:60}];};

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _radio=__webpack_require__(112);var _radio2=_interopRequireDefault(_radio);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(8);__webpack_require__(127);__webpack_require__(4);__webpack_require__(10);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var totalIndex=[];var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={data:[],loading:true,loadingSave:false,print:false,type:1},_this.getData=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var type,x,data;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:type=_this.state.type;_context.prev=1;_this.setState({loading:true});_context.next=5;return(0,_request2.default)("/api/banquetFacilitiesInfo?type="+type);case 5:x=_context.sent;data=void 0;if(type==1)data=[x.data||{name:"会议室及宴会厅使用面积（不含过道）",value:0}];if(type==2)data=x.data;_this.setState({loading:false,data:data});_context.next=16;break;case 12:_context.prev=12;_context.t0=_context["catch"](1);_this.setState({loading:false});console.error(_context.t0);case 16:case"end":return _context.stop();}}},_callee,_this2,[[1,12]]);})),_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var _this$state,type,data,dataFrom,headres,x,timer,_timer;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_this$state=_this.state,type=_this$state.type,data=_this$state.data;if(!(type==2)){_context2.next=4;break;}return _context2.abrupt("return");case 4:_this.setState({loadingSave:true});dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context2.next=10;return(0,_request2.default)('/api/banquetFacilitiesSave',headres);case 10:x=_context2.sent;timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(!(x.status==1)){_context2.next=16;break;}_message3.default.success(x.msg);if(!data[0].id){_this.getData();}return _context2.abrupt("return");case 16:_message3.default.error(x.msg);_context2.next=24;break;case 19:_context2.prev=19;_context2.t0=_context2["catch"](0);_timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer);},1000);console.error(_context2.t0);_message3.default.error('保存失败'+JSON.stringify(_context2.t0));case 24:case"end":return _context2.stop();}}},_callee2,_this2,[[0,19]]);})),_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('view4_1_4',1.5,'7.7',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});},_this.downloadExcel=function(){var tableName=(0,_moment2.default)(_this.state.date).format('YYYY')+" \u5BB4\u4F1A\u8BBE\u65BD\u7EDF\u8BA1";var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById('table4_1_4').innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+".xls");_this.setState({print:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData();}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,print=_state.print,loading=_state.loading,type=_state.type;var user=this.props.store.auth.user;return _react2.default.createElement("div",{className:"table7_1_1 tableHeight",style:{width:800}},_react2.default.createElement(_row2.default,{className:"title",id:"view4_1_4"},_react2.default.createElement(_row2.default,null,"\u5BB4\u4F1A\u8BBE\u65BD\u7EDF\u8BA1"),user.email==='admin'&&_react2.default.createElement(_radio2.default.Group,{onChange:function onChange(e){_this3.setState({type:e.target.value},function(){_this3.getData();});},value:type},_react2.default.createElement(_radio2.default,{value:1},"\u5355\u4F53\u9152\u5E97"),_react2.default.createElement(_radio2.default,{value:2},"\u5168\u90E8\u9152\u5E97"))),_react2.default.createElement(_table2.default,{columns:[{title:'',dataIndex:'name',key:'name',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u4F1A\u8BAE\u5BA4\u53CA\u5BB4\u4F1A\u5385\u4F7F\u7528\u9762\u79EF\uFF08\u4E0D\u542B\u8FC7\u9053\uFF09",dataIndex:'value',key:'value',align:"center",width:300,render:function render(text,record,index){var props={text:text,index:index,type:!totalIndex.includes(index)&&type==1&&!print?'inputNumber':'number',name:"value",onChange:function onChange(name,value,index){var _data=[].concat(_toConsumableArray(data));_data[index][name]=value;_this3.setState({data:_data});},totalIndex:totalIndex};if(!totalIndex.includes(index))return _react2.default.createElement(_TableText2.default,{data:props});}}],dataSource:data,size:"middle",id:"table4_1_4",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{y:500},rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_row2.default,{className:"table-footer-btn"},_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},style:{marginRight:10},loading:print},"\u5BFC\u51FAExcel"),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:"edit_banquetFacilities"},_react2.default.createElement(_button2.default,{type:"primary",onClick:this.onSave,loading:this.state.loadingSave},"\u4FDD\u5B58"))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _radio=__webpack_require__(112);var _radio2=_interopRequireDefault(_radio);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(8);__webpack_require__(127);__webpack_require__(4);__webpack_require__(10);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var totalIndex=[];var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={data:[],loading:true,loadingSave:false,print:false,type:1},_this.getData=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var type,x,data;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:type=_this.state.type;_context.prev=1;_this.setState({loading:true});_context.next=5;return(0,_request2.default)("/api/systemStatisticalInfo?type="+type);case 5:x=_context.sent;data=void 0;if(type==1)data=[x.data||{pms:"",pmsPrice:0,fmis:"",fmisPrice:0}];if(type==2)data=x.data;_this.setState({loading:false,data:data});_context.next=16;break;case 12:_context.prev=12;_context.t0=_context["catch"](1);_this.setState({loading:false});console.error(_context.t0);case 16:case"end":return _context.stop();}}},_callee,_this2,[[1,12]]);})),_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var _this$state,type,data,dataFrom,headres,x,timer,_timer;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_this$state=_this.state,type=_this$state.type,data=_this$state.data;if(!(type==2)){_context2.next=4;break;}return _context2.abrupt("return");case 4:_this.setState({loadingSave:true});dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context2.next=10;return(0,_request2.default)('/api/systemStatisticalSave',headres);case 10:x=_context2.sent;timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(!(x.status==1)){_context2.next=16;break;}_message3.default.success(x.msg);if(!data[0].id){_this.getData();}return _context2.abrupt("return");case 16:_message3.default.error(x.msg);_context2.next=24;break;case 19:_context2.prev=19;_context2.t0=_context2["catch"](0);_timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(_timer);},1000);console.error(_context2.t0);_message3.default.error('保存失败'+JSON.stringify(_context2.t0));case 24:case"end":return _context2.stop();}}},_callee2,_this2,[[0,19]]);})),_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('view4_1_4',1.5,'7.7',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});},_this.downloadExcel=function(){var tableName=(0,_moment2.default)(_this.state.date).format('YYYY')+" \u9152\u5E97\u7CFB\u7EDF\u7EDF\u8BA1";var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById('table4_1_4').innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+".xls");_this.setState({print:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData();}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,print=_state.print,loading=_state.loading,type=_state.type;var user=this.props.store.auth.user;return _react2.default.createElement("div",{className:"table7_1_1 tableHeight",style:{width:1200}},_react2.default.createElement(_row2.default,{className:"title",id:"view4_1_4"},_react2.default.createElement(_row2.default,null,"\u9152\u5E97\u7CFB\u7EDF\u7EDF\u8BA1"),user.email==='admin'&&_react2.default.createElement(_radio2.default.Group,{onChange:function onChange(e){_this3.setState({type:e.target.value},function(){_this3.getData();});},value:type},_react2.default.createElement(_radio2.default,{value:1},"\u5355\u4F53\u9152\u5E97"),_react2.default.createElement(_radio2.default,{value:2},"\u5168\u90E8\u9152\u5E97"))),_react2.default.createElement(_table2.default,{columns:[{title:'',dataIndex:'name',key:'name',align:"center",width:300,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",totalIndex:totalIndex};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"PMS\u7CFB\u7EDF\u540D\u79F0",dataIndex:'pms',key:'pms',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:!totalIndex.includes(index)&&type==1&&!print?'input':'text',name:"pms",onChange:function onChange(name,value,index){var _data=[].concat(_toConsumableArray(data));_data[index][name]=value;_this3.setState({data:_data});},totalIndex:totalIndex};if(!totalIndex.includes(index))return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5E74\u7EF4\u62A4\u8D39",dataIndex:'pmsPrice',key:'pmsPrice',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:!totalIndex.includes(index)&&type==1&&!print?'inputNumber':'number',name:"pmsPrice",onChange:function onChange(name,value,index){var _data=[].concat(_toConsumableArray(data));_data[index][name]=value;_this3.setState({data:_data});},totalIndex:totalIndex};if(!totalIndex.includes(index))return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u8D22\u52A1\u7CFB\u7EDF\u540D\u79F0",dataIndex:'fmis',key:'fmis',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:!totalIndex.includes(index)&&type==1&&!print?'input':'text',name:"fmis",onChange:function onChange(name,value,index){var _data=[].concat(_toConsumableArray(data));_data[index][name]=value;_this3.setState({data:_data});},totalIndex:totalIndex};if(!totalIndex.includes(index))return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"\u5E74\u7EF4\u62A4\u8D39",dataIndex:'fmisPrice',key:'fmisPrice',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:!totalIndex.includes(index)&&type==1&&!print?'inputNumber':'number',name:"fmisPrice",onChange:function onChange(name,value,index){var _data=[].concat(_toConsumableArray(data));_data[index][name]=value;_this3.setState({data:_data});},totalIndex:totalIndex};if(!totalIndex.includes(index))return _react2.default.createElement(_TableText2.default,{data:props});}}],dataSource:data,size:"middle",id:"table4_1_4",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{y:500},rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement(_row2.default,{className:"table-footer-btn"},_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},style:{marginRight:10},loading:print},"\u5BFC\u51FAExcel"),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:"edit_systemStatistical"},_react2.default.createElement(_button2.default,{type:"primary",onClick:this.onSave,loading:this.state.loadingSave},"\u4FDD\u5B58"))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(8);__webpack_require__(4);__webpack_require__(42);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _compute=__webpack_require__(724);var _compute2=_interopRequireDefault(_compute);var _MonthPicker=__webpack_require__(402);var _MonthPicker2=_interopRequireDefault(_MonthPicker);var _method=__webpack_require__(20);var _MTD=__webpack_require__(2226);var _MTD2=_interopRequireDefault(_MTD);__webpack_require__(725);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var index=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,dateData:[],print:false,dataSelect:[]},_this.getDateData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var year,month,_ref3,_ref3$data,data;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:year=(0,_moment2.default)(date).format('YYYY');month=(0,_moment2.default)(date).format('M');_context.next=4;return(0,_request2.default)('/doobi?year='+year+'&month='+month);case 4:_ref3=_context.sent;_ref3$data=_ref3.data;data=_ref3$data===undefined?[]:_ref3$data;data[1].actual=(0,_method.calculation)(data[0].actual,data[8].actual);data[1].budget=(0,_method.calculation)(data[0].budget,data[8].budget);(0,_compute2.default)(data);_this.setState({loading:false,data:data});case 11:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.onExpoetExcel=function(){_this.setState({print:true,loading:true},function(){var name='Current Year P&L Analysis (Whole Year Budget) \u672C\u5E74\u635F\u76CA\u5206\u6790 \uFF08\u5168\u5E74\u9884\u7B97\uFF09'+(0,_moment2.default)(_this.state.date).format('YYYY-MM');var innerHtml='\n              <caption>'+name+'</caption>\n              '+document.getElementById('table').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n            ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,name+'.xls');_this.setState({print:false,loading:false});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);var date=Number(this.state.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});}},{key:'render',value:function render(){var _this3=this;var _state=this.state,date=_state.date,data=_state.data,loading=_state.loading;var percentData=[1,2];var columns=[{title:"P&L Index 损益指数",dataIndex:'name',key:'name',render:function render(text,r,index){var props={text:text,index:index,type:'text',name:"name"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"Actual 实际",width:150,dataIndex:'actual',key:'actual',render:function render(text,r,index){var props={text:text,index:index,type:percentData.includes(index)?'percent':'number',name:"actual"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"Budget 预算",width:150,dataIndex:'budget',key:'budget',render:function render(text,r,index){var props={text:text,index:index,type:percentData.includes(index)?'percent':'number',name:"budget"};return _react2.default.createElement(_TableText2.default,{data:props});}}];return _react2.default.createElement('div',null,_react2.default.createElement(_MTD2.default,null),_react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'table table2_1 doobi'},_react2.default.createElement(_row2.default,{className:'title',id:'table2_2'},_react2.default.createElement(_row2.default,null,'BI Structure YTD - DOO \u603B\u90E8\u6570\u636E\u5E73\u53F0 YTD - DOO'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(_MonthPicker2.default,{date:date,onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}})),_react2.default.createElement('div',{className:'content'},_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',id:'table',bordered:true,style:{width:600},pagination:false,rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement('div',{className:'chart'},_react2.default.createElement('div',{id:'chart1'}),_react2.default.createElement('div',{id:'chart2'})))))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _select=__webpack_require__(41);var _select2=_interopRequireDefault(_select);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(8);__webpack_require__(4);__webpack_require__(42);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _request=__webpack_require__(40);var _request2=_interopRequireDefault(_request);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _compute=__webpack_require__(724);var _compute2=_interopRequireDefault(_compute);var _MonthPicker=__webpack_require__(402);var _MonthPicker2=_interopRequireDefault(_MonthPicker);var _method=__webpack_require__(20);__webpack_require__(725);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=_select2.default.Option;var index=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,dateData:[],print:false,dataSelect:[]},_this.getDateData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var year,month,_ref3,_ref3$data,data;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:year=(0,_moment2.default)(date).format('YYYY');month=(0,_moment2.default)(date).format('M');_context.next=4;return(0,_request2.default)('/doobiMtd?year='+year+'&month='+month);case 4:_ref3=_context.sent;_ref3$data=_ref3.data;data=_ref3$data===undefined?[]:_ref3$data;data[1].actual=(0,_method.calculation)(data[0].actual,data[8].actual);data[1].budget=(0,_method.calculation)(data[0].budget,data[8].budget);(0,_compute2.default)(data,'mtd-chart');_this.setState({loading:false,data:data});case 11:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);var date=Number(this.state.date||"0");var dateData=[];var len=date-2018+3;for(var i=0;i<len;i++){dateData.push((2018+i).toString());}this.setState({dateData:dateData});}},{key:'render',value:function render(){var _this3=this;var _state=this.state,date=_state.date,data=_state.data,loading=_state.loading;var percentData=[1,2];var columns=[{title:"P&L Index 损益指数",dataIndex:'name',key:'name',render:function render(text,r,index){var props={text:text,index:index,type:'text',name:"name"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"Actual 实际",width:150,dataIndex:'actual',key:'actual',render:function render(text,r,index){var props={text:text,index:index,type:percentData.includes(index)?'percent':'number',name:"actual"};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"Budget 预算",width:150,dataIndex:'budget',key:'budget',render:function render(text,r,index){var props={text:text,index:index,type:percentData.includes(index)?'percent':'number',name:"budget"};return _react2.default.createElement(_TableText2.default,{data:props});}}];return _react2.default.createElement(_spin2.default,{spinning:loading},_react2.default.createElement('div',{className:'table table2_1 doobi'},_react2.default.createElement(_row2.default,{className:'title',id:'table2_2'},_react2.default.createElement(_row2.default,null,'BI Structure MTD - DOO \u603B\u90E8\u6570\u636E\u5E73\u53F0 MTD - DOO'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(_MonthPicker2.default,{date:date,onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}})),_react2.default.createElement('div',{className:'content'},_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',id:'table',bordered:true,style:{width:600},pagination:false,rowKey:function rowKey(record,index){return index;}}),_react2.default.createElement('div',{className:'chart'},_react2.default.createElement('div',{id:'mtd-chart1'}),_react2.default.createElement('div',{id:'mtd-chart2'}))))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _spin=__webpack_require__(11);var _spin2=_interopRequireDefault(_spin);var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(12);__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2228);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _method=__webpack_require__(20);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var index=function(_Component){_inherits(index,_Component);function index(props){var _this2=this;_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.computeNum=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(data){return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({data:data});case 1:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.onChange=function(name,value,i){// 简单粗暴的深拷贝
var data=JSON.parse(JSON.stringify(_this.state.data));data[i][name]=value;_this.computeNum(data);};_this.getDateData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(date){var dataBegin,data;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dataBegin=JSON.stringify(_data.dataDefault);data=JSON.parse(dataBegin);fetch('/urgentInfo?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('MM'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.data.data&&x.data.data.length>0){data=x.data.data.sort(function(a,b){return(0,_method.numConvert)(a.sort)-(0,_method.numConvert)(b.sort);});}_this.setState({loading:false},function(){_this.computeNum(data);});}).catch(function(err){_this.setState({loading:false});console.error(err);});case 3:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref2.apply(this,arguments);};}();_this.onSave=function(){_this.setState({loadingSave:true});var _this$state=_this.state,date=_this$state.date,title=_this$state.title;if(!date){_message3.default.error('请选择年份月份');var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);return;}var year=(0,_moment2.default)(date).format("YYYY");var month=(0,_moment2.default)(date).format("MM");var data=_this.state.data.map(function(x){return _extends({},x,{year:year,month:month});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/urgentSave',headres).then(function(x){return x.json();}).then(function(x){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);if(x.status==1){_message3.default.success(x.msg);if(data.some(function(item){return!item.id;})){_this.getDateData(_this.state.date);}return;}_message3.default.error(x.msg);}).catch(function(err){var timer=setTimeout(function(){_this.setState({loadingSave:false});clearTimeout(timer);},1000);console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};_this.onExpoetExcel=function(){_this.setState({print:true,loading:true},function(){var name='Hotel Emergency Report \u9152\u5E97\u7D27\u6025\u4E8B\u4EF6\u62A5\u544A '+(0,_moment2.default)(_this.state.date).format('YYYY-MM');var innerHtml='\n              <caption>'+name+'</caption>\n              '+document.getElementById('table').innerHTML.replace(/<table class="">/g,'<table border="1">')+'\n            ';var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,name+'.xls');_this.setState({print:false,loading:false});});};_this.state={date:(0,_moment2.default)().format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,update:false,hotelName:sessionStorage.getItem('hotelName')||""};return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.getDateData(this.state.date);}},{key:'render',value:function render(){var _this3=this;var data=this.state.data;var columns=[{title:'序号',dataIndex:'sort',key:'sort',align:"center",width:50,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"sort",onChange:_this3.onChange};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"紧急事件描述",dataIndex:'describe',key:'describe',align:"center",width:300,render:function render(text,record,index){var title=['describe'];var props={text:text,index:index,type:'textArea',name:"describe",onChange:_this3.onChange};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"风险等级（3级、2级必填）",dataIndex:'level',key:'level',align:"center",width:300,render:function render(text,record,index){var props={text:text,index:index,type:'textArea',name:"level",onChange:_this3.onChange};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"处理结果",dataIndex:'result',key:'result',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'textArea',name:"result",onChange:_this3.onChange};return _react2.default.createElement(_TableText2.default,{data:props});}},{title:"酒店损失金额（元）",dataIndex:'loss',key:'loss',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'inputNumber',name:"loss",onChange:_this3.onChange};return _react2.default.createElement(_TableText2.default,{data:props});}}];return _react2.default.createElement(_spin2.default,{spinning:this.state.loading},_react2.default.createElement('div',{className:'table'},_react2.default.createElement(_row2.default,{className:'title',id:'table3_3_4'},_react2.default.createElement(_row2.default,null,'Hotel Emergency Report  \u9152\u5E97\u7D27\u6025\u4E8B\u4EF6\u62A5\u544A'),_react2.default.createElement(_row2.default,{className:'table-month'},_react2.default.createElement(MonthPicker,{placeholder:'\u8BF7\u9009\u62E9\u5E74\u6708',monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},defaultValue:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:'YYYY-MM',onChange:function onChange(date,str){_this3.setState({date:str,data:[],loading:true});_this3.getDateData(str);}})),_react2.default.createElement(_table2.default,{columns:columns,dataSource:data,size:'middle',bordered:true,id:'table',pagination:false,className:'content',scroll:this.state.print?{}:{y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:'table-footer-btn'},_react2.default.createElement(_button2.default,{type:'primary',style:{marginRight:10},onClick:function onClick(){_this3.setState({print:true},function(){_this3.onExpoetExcel();});}},'\u5BFC\u51FAExcel'),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:'edit_meetingMinutes'},_react2.default.createElement(_button2.default,{type:'primary',onClick:this.onSave,loading:this.state.loadingSave},'\u4FDD\u5B58')))));}}]);return index;}(_react.Component);exports.default=index;

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var dataDefault=exports.dataDefault=[{sort:1,describe:"",level:"",result:"",loss:0},{sort:2,describe:"",level:"",result:"",loss:0},{sort:3,describe:"",level:"",result:"",loss:0},{sort:4,describe:"",level:"",result:"",loss:0},{sort:5,describe:"",level:"",result:"",loss:0},{sort:6,describe:"",level:"",result:"",loss:0}];

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(5);var _button2=_interopRequireDefault(_button);var _table=__webpack_require__(7);var _table2=_interopRequireDefault(_table);var _row=__webpack_require__(3);var _row2=_interopRequireDefault(_row);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _datePicker=__webpack_require__(13);var _datePicker2=_interopRequireDefault(_datePicker);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;__webpack_require__(6);__webpack_require__(8);__webpack_require__(4);__webpack_require__(10);__webpack_require__(14);var _fileSaver=__webpack_require__(28);var _fileSaver2=_interopRequireDefault(_fileSaver);var _mobxReact=__webpack_require__(18);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _saveImg=__webpack_require__(21);var _saveImg2=_interopRequireDefault(_saveImg);var _data2=__webpack_require__(2230);var _data3=_interopRequireDefault(_data2);var _compute=__webpack_require__(2231);var _axios=__webpack_require__(86);var _axios2=_interopRequireDefault(_axios);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _Auth=__webpack_require__(16);var _Auth2=_interopRequireDefault(_Auth);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonthPicker=_datePicker2.default.MonthPicker;var TITLE="月度回顾表 Monthly ES Review";var index=(_dec=(0,_mobxReact.inject)('store'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){_inherits(index,_Component);function index(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={date:(0,_moment2.default)().subtract(1,'month').format('YYYY-MM'),data:[],loading:true,loadingSave:false,print:false,data4_1:[],key:"month_review"},_this.computeNum=function(data){var other=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];data=(0,_compute.compute)(data,other);_this.setState({data:data,loading:false});},_this.onChange=function(name,value,i){var data=_this.state.data;data[i][name]=value;_this.computeNum(data);},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var month,year,data,res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;month=(0,_moment2.default)(date).format('M');year=(0,_moment2.default)(date).format('YYYY');data=_lodash2.default.cloneDeep(_data3.default);_this.setState({loading:true});_context.next=7;return _axios2.default.post('/api/data',{list:[{name:"data",key:_this.state.key,year:year,month:month},{name:"_5_1_1",key:"_5_1_1",year:year,month:month,noSort:1},{name:"_5_1_2",key:"_5_1_2",year:year,month:month,noSort:1},{name:"_5_1_3",key:"_5_1_3",year:year,month:month,noSort:1},{name:"_5_1_4",key:"_5_1_4",year:year,month:month,noSort:1},{name:"kpis",key:"kpis",year:year,month:month,noSort:1},{name:"_8_1",key:"_8_1",year:year,month:month,noSort:1}]});case 7:res=_context.sent;if(res.data.data&&res.data.data.length)data=res.data.data;console.log(data);_this.setState({data:(0,_compute.compute)(data,_extends({},res.data,{month:month,year:year})),loading:false},function(){// this.onSave();
});_context.next=17;break;case 13:_context.prev=13;_context.t0=_context["catch"](0);_this.setState({loading:false});console.error(_context.t0);case 17:case"end":return _context.stop();}}},_callee,_this2,[[0,13]]);}));return function(_x2){return _ref2.apply(this,arguments);};}(),_this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var _this$state,date,_data,key,year,month,data,postData,x;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_this$state=_this.state,date=_this$state.date,_data=_this$state.data,key=_this$state.key;if(date){_context2.next=4;break;}return _context2.abrupt("return",_message3.default.error('请选择年份月份'));case 4:_this.setState({loadingSave:true});year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");data=_data.map(function(x,i){return _extends({},x,{year:year,sort:i,month:month});});postData={data:data,year:year,month:month,key:key};_context2.next=11;return _axios2.default.post("/api/save",postData);case 11:x=_context2.sent;_this.setState({loadingSave:false});if(x.code==200){_message3.default.success("保存成功！");if(!data[0].id)_this.getData(_this.state.date);}_context2.next=20;break;case 16:_context2.prev=16;_context2.t0=_context2["catch"](0);_this.setState({loadingSave:false});console.error(_context2.t0);case 20:case"end":return _context2.stop();}}},_callee2,_this2,[[0,16]]);})),_this.downloadSG=function(){_this.setState({print:true,loading:true},function(){(0,_saveImg2.default)('view4_1_4_history',1.5,'4.311',_this.state.date).then(function(x){if(x.status==1){_message3.default.info('添加成功！');}else{_message3.default.error('添加失败'+x.msg);}_this.setState({print:false,loading:false});}).catch(function(err){console.error(err);_this.setState({print:false,loading:false});});});},_this.downloadExcel=function(){var hotel=sessionStorage.getItem('hotelName')||"";var tableName=hotel+" "+(0,_moment2.default)(_this.state.date).format('YYYY')+" "+TITLE;var innerHtml="\n          <caption>"+tableName+"</caption>\n          "+document.getElementById('table4_1_4').innerHTML.replace(/<table class="">/g,'<table border="1">')+"\n        ";var html="<html><head><meta charset='utf-8' /></head><body>"+innerHtml+"</body></html>";var blob=new Blob([html],{type:"application/vnd.ms-excel"});_fileSaver2.default.saveAs(blob,tableName+_this.state.date+".xls");_this.setState({print:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"componentDidMount",value:function componentDidMount(){this.getData(this.state.date);}},{key:"render",value:function render(){var _this3=this;var _state=this.state,data=_state.data,date=_state.date,print=_state.print,loading=_state.loading,key=_state.key;return _react2.default.createElement("div",{className:"table7_1_1 tableHeight"},_react2.default.createElement(_row2.default,{className:"title",id:"view4_1_4_history"},_react2.default.createElement(_row2.default,null,TITLE),_react2.default.createElement(_row2.default,{className:"table-month"},_react2.default.createElement(MonthPicker,{placeholder:"\u8BF7\u9009\u62E9\u5E74\u6708",monthCellContentRender:function monthCellContentRender(date,local){return(0,_moment2.default)(date).format('M月');},disabledDate:function disabledDate(v){if((0,_moment2.default)(v).isAfter((0,_moment2.default)('2023-12-31')))return false;return true;},value:(0,_moment2.default)(this.state.date,"YYYY-MM"),format:"YYYY-MM",onChange:function onChange(date,str){_this3.setState({date:str,data:[]});_this3.getData(str);}})),_react2.default.createElement(_table2.default,{columns:(0,_compute.columns)(this.onChange,date,print),dataSource:data,size:"middle",id:"table4_1_4",bordered:true,loading:loading,pagination:false,rowClassName:"protruding",className:"content",scroll:print?{}:{y:500},rowKey:function rowKey(record,index){return index;}})),_react2.default.createElement(_row2.default,{className:"table-footer-btn"},_react2.default.createElement(_button2.default,{type:"primary",onClick:function onClick(){_this3.setState({print:true},function(){_this3.downloadExcel();});},loading:print},"\u5BFC\u51FAExcel"),_react2.default.createElement(_Auth2.default,{loading:this.state.loading,auth:"edit_monthlyreview"},_react2.default.createElement(_button2.default,{type:"primary",style:{margin:'0 10px'},onClick:this.onSave,loading:this.state.loadingSave},"\u4FDD\u5B58"))));}}]);return index;}(_react.Component))||_class)||_class);exports.default=index;

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=[{"name":"Revenue 收入","key":"Revenue 收入","sort":0,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"a. Room Revenue 客房收入","key":"a. Room Revenue 客房收入","sort":1,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"OCC%出租率","key":"OCC%出租率","sort":2,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"ADR平均房价","key":"ADR平均房价","sort":3,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"RevPar单房收益","key":"RevPar单房收益","sort":4,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"b. F&B Revenue 餐饮收入","key":"b. F&B Revenue 餐饮收入","sort":5,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"F&B Dep't Profit % 餐饮部门利润率","key":"F&B Dep't Profit % 餐饮部门利润率","sort":6,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"Banquet Revenue 宴会收入","key":"Banquet Revenue 宴会收入","sort":7,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"CR Revenue 中餐厅收入","key":"CR Revenue 中餐厅收入","sort":8,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"—A/C人均消费","key":"—A/C人均消费","sort":9,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"—Covers 就餐人数","key":"—Covers 就餐人数","sort":10,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"ADD Revenue 收入","key":"ADD Revenue 收入","sort":11,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"—A/C 人均消费","key":"—A/C 人均消费","sort":12,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"—Covers 就餐人数","key":"—Covers 就餐人数","sort":13,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"SR  Revenue 特色餐厅收入","key":"SR  Revenue 特色餐厅收入","sort":14,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"LB  Revenue 大堂吧收入","key":"LB  Revenue 大堂吧收入","sort":15,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"RS  Revenue 客房送餐收入","key":"RS  Revenue 客房送餐收入","sort":16,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"c. Other Revenue 其他收入","key":"c. Other Revenue 其他收入","sort":17,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"d.Total Revenue 总收入","key":"d.Total Revenue 总收入","sort":18,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"GOP 利润","key":"GOP 利润","sort":19,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"a. Payroll Cost 人力成本","key":"a. Payroll Cost 人力成本","sort":20,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"% 人力成本率","key":"% 人力成本率","sort":21,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"b. Utility Cost 能耗成本","key":"b. Utility Cost 能耗成本","sort":22,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"% 能耗成本率","key":"% 能耗成本率","sort":23,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"（仅使用于能耗成本指标以下内容）","key":"（仅使用于能耗成本指标以下内容）","sort":24,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"OCC% 出租率","key":"OCC% 出租率","sort":25,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"F&B Revenue 餐饮收入","key":"F&B Revenue 餐饮收入","sort":26,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"Electricity 用电量  (KWH)","key":"Electricity 用电量  (KWH)","sort":27,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"Water 用水量 (m³ )","key":"Water 用水量 (m³ )","sort":28,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"Gas 燃气用量 (m³ )","key":"Gas 燃气用量 (m³ )","sort":29,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"Steam 蒸汽用量 (m³ )","key":"Steam 蒸汽用量 (m³ )","sort":30,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"c. F&B Cost 餐饮成本","key":"c. F&B Cost 餐饮成本","sort":31,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"% 餐饮成本率","key":"% 餐饮成本率","sort":32,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"餐饮收入","key":"餐饮收入","sort":33,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"Banquet Revenue 宴会收入（仅餐厅）","key":"Banquet Revenue 宴会收入（仅餐厅）","sort":34,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"—成本百分比 Cost %","key":"—成本百分比 Cost %","sort":35,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"CR Revenue 中餐厅收入","key":"CR Revenue 中餐厅收入","sort":36,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"—成本百分比 Cost %","key":"—成本百分比 Cost %","sort":37,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"ADD Revenue 收入","key":"Revenue 收入","sort":38,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"—成本百分比 Cost %","key":"—成本百分比 Cost %","sort":39,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"SR  Revenue 特色餐厅收入","key":"SR  Revenue 特色餐厅收入","sort":40,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"—成本百分比 Cost %","key":"—成本百分比 Cost %","sort":41,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"是否参与HACCP审核","key":"是否参与HACCP审核","sort":42,"m_act":"","m_bud":0,"m_var":0,"y_act":"","y_bud":0,"y_var":0},{"name":"d. GOP 总毛利润","key":"d. GOP 总毛利润","sort":43,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"GOP% 总毛利率","key":"GOP% 总毛利率","sort":44,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"e. Flow Through 边际盈利率","key":"e. Flow Through 边际盈利率","sort":45,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"Guest Satisfaction 客户满意度","key":"Guest Satisfaction 客户满意度","sort":46,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"a. Score 华客OTA平均点评分","key":"a. Score 华客OTA平均点评分","sort":47,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"Number 评论数","key":"Number 评论数","sort":48,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"b. 是否完成神秘访客计划","key":"b. 是否完成神秘访客计划","sort":49,"m_act":"","m_bud":0,"m_var":0,"y_act":"","y_bud":0,"y_var":0},{"name":"Club GCH 豪廷會","key":"Club GCH 豪廷會","sort":50,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"Club GCH 128 Member 豪廷會128会员售卖","key":"Club GCH 128 Member 豪廷會128会员售卖","sort":51,"m_act":0,"m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0},{"name":"Action Taken by Hotel 酒店提升行动","key":"Action Taken by Hotel 酒店提升行动","sort":52,"m_act":"","m_bud":0,"m_var":0,"y_act":0,"y_bud":0,"y_var":0}];

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.columns=exports.compute=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _TableText=__webpack_require__(24);var _TableText2=_interopRequireDefault(_TableText);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _method=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var totalIndex=[0,19,24,46,50];var oneRow=[0,19,46,50];var inputIndex=[47,48,51];var percentIndex=[2,6,21,23,25,32,35,37,39,41,44];var corKpis={1:5,2:2,3:3,4:4,5:6,6:12,17:7,18:8,20:15,21:16,22:17,23:18};var corKpisLast={25:2,26:6,31:13,32:14,33:6,43:21,44:22};var cor5={7:2,8:1,9:{index:1,name:'AC'},10:{index:1,name:'covers'},11:0,12:{index:0,name:'AC'},13:{index:0,name:'covers'},14:3,15:4,16:5};var cor5Last={34:13,35:{index:13,name:'cost_percent'},36:1,37:{index:1,name:'cost_percent'},38:0,39:{index:0,name:'cost_percent'},40:3,41:{index:3,name:'cost_percent'}};var cor8={27:0,28:1,29:2,30:3};var compute=exports.compute=function compute(data,_ref){var _5_1_1=_ref._5_1_1,_5_1_3=_ref._5_1_3,_5_1_4=_ref._5_1_4,_5_1_2=_ref._5_1_2,kpis=_ref.kpis,_8_1=_ref._8_1;Object.entries(corKpis).forEach(function(x){data[x[0]].m_act=_lodash2.default.get(kpis,x[1]+".actual",0);data[x[0]].m_bud=_lodash2.default.get(kpis,x[1]+".budget",0);data[x[0]].m_var=_lodash2.default.get(kpis,x[1]+".actual_budget",0);data[x[0]].y_act=_lodash2.default.get(kpis,x[1]+".year_actual",0);data[x[0]].y_bud=_lodash2.default.get(kpis,x[1]+".budget",0);data[x[0]].y_var=_lodash2.default.get(kpis,x[1]+".actual_budget",0);});Object.entries(cor5).forEach(function(x){var name="REV";var index=x[1];if(_typeof(x[1])==='object'){name=x[1].name;index=x[1].index;}data[x[0]].m_act=_lodash2.default.get(_5_1_1,index+"."+name,0);data[x[0]].m_bud=_lodash2.default.get(_5_1_1,index+".m_"+name,0);// data[x[0]].m_var = _.get(_5_1_1, `${index}.b_${name}`, 0);
data[x[0]].m_var=(0,_method.calculation)(data[x[0]].m_act-data[x[0]].m_bud,data[x[0]].m_bud);data[x[0]].y_act=_lodash2.default.get(_5_1_3,index+"."+name,0);data[x[0]].y_bud=_lodash2.default.get(_5_1_3,index+".m_"+name,0);// data[x[0]].y_var = _.get(_5_1_3, `${index}.b_${name}`, 0);
data[x[0]].y_var=(0,_method.calculation)(data[x[0]].y_act-data[x[0]].y_bud,data[x[0]].y_bud);});Object.entries(cor8).forEach(function(x){data[x[0]].m_act=_lodash2.default.get(_8_1,x[1]+".cma_thisyear_consumption",0);data[x[0]].m_bud=_lodash2.default.get(_8_1,x[1]+".cma_lastyear_consumption",0);data[x[0]].m_var=_lodash2.default.get(_8_1,x[1]+".cmv_comparison_consumption_percent",0);data[x[0]].y_act=_lodash2.default.get(_8_1,x[1]+".ytda_thisyear_consumption",0);data[x[0]].y_bud=_lodash2.default.get(_8_1,x[1]+".ytda_lastyear_consumption",0);data[x[0]].y_var=_lodash2.default.get(_8_1,x[1]+".ytdv_comparison_consumption_percent",0);});Object.entries(corKpisLast).forEach(function(x){data[x[0]].m_act=_lodash2.default.get(kpis,x[1]+".actual",0);data[x[0]].m_bud=_lodash2.default.get(kpis,x[1]+".last_year",0);data[x[0]].m_var=_lodash2.default.get(kpis,x[1]+".actual_last_year",0);data[x[0]].y_act=_lodash2.default.get(kpis,x[1]+".year_actual",0);data[x[0]].y_bud=_lodash2.default.get(kpis,x[1]+".year_last_year",0);data[x[0]].y_var=_lodash2.default.get(kpis,x[1]+".year_actual_last_year",0);});Object.entries(cor5Last).forEach(function(x){var name="REV";var index=x[1];if(_typeof(x[1])==='object'){name=x[1].name;index=x[1].index;}data[x[0]].m_act=_lodash2.default.get(_5_1_2,index+"."+name,0);data[x[0]].m_bud=_lodash2.default.get(_5_1_2,index+".m_"+name,0);// data[x[0]].m_var = _.get(_5_1_2, `${index}.b_${name}`, 0);
data[x[0]].m_var=(0,_method.calculation)(data[x[0]].m_act-data[x[0]].m_bud,data[x[0]].m_bud);data[x[0]].y_act=_lodash2.default.get(_5_1_4,index+"."+name,0);data[x[0]].y_bud=_lodash2.default.get(_5_1_4,index+".m_"+name,0);// data[x[0]].y_var = _.get(_5_1_4, `${index}.b_${name}`, 0);
data[x[0]].y_var=(0,_method.calculation)(data[x[0]].y_act-data[x[0]].y_bud,data[x[0]].y_bud);});return data;};var columns=exports.columns=function columns(onChange,date,print){var sqlName="month_review";var month=(0,_moment2.default)(date).format('MMMM');var key=[{title:'key',dataIndex:'sort',key:'sort',align:"center",width:50,render:function render(t){return t;}}];if(true)key=[];return[].concat(_toConsumableArray(key),[{title:'指标',dataIndex:'name',key:'name',align:"center",width:200,render:function render(text,record,index){var props={text:text,index:index,type:'text',name:"name",onChange:onChange,totalIndex:totalIndex};if(oneRow.includes(index)){return{props:{colSpan:7},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter"})})};}return _react2.default.createElement(_TableText2.default,{data:props});}},{title:month,align:"center",children:[{title:'Actual',dataIndex:'m_act',key:'m_act',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:percentIndex.includes(index)?"percent":'number',name:"m_act",onChange:onChange,totalIndex:totalIndex};if(oneRow.includes(index)){return{props:{colSpan:0}};}if(index===24){return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:"Actual"})});}if(index===52){return{props:{colSpan:6},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:'textArea'})})};}if([42,49].includes(index)){return{props:{colSpan:3},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:'input'})})};}if(index==45){return{props:{colSpan:3},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:'inputPercent'})})};}if(inputIndex.includes(index))props.type="inputNumber";return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Budget',dataIndex:'m_bud',key:'m_bud',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:percentIndex.includes(index)?"percent":'number',name:"m_bud",onChange:onChange,totalIndex:totalIndex};if(oneRow.includes(index)){return{props:{colSpan:0}};}if(index===24){return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:"Last Year"})});}if([42,45,49,52].includes(index)){return{props:{colSpan:0}};}if(inputIndex.includes(index))props.type="inputNumber";return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Var%',dataIndex:'m_var',key:'m_var',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"m_var",onChange:onChange,totalIndex:totalIndex};if(oneRow.includes(index)){return{props:{colSpan:0}};}if(index===24){return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:"Var%"})});}if([42,45,49,52].includes(index)){return{props:{colSpan:0}};}if(inputIndex.includes(index))props.type="inputPercent";return _react2.default.createElement(_TableText2.default,{data:props});}}]},{title:"YTD-"+month,align:"center",children:[{title:'Actual',dataIndex:'y_act',key:'y_act',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:percentIndex.includes(index)?"percent":'number',name:"y_act",onChange:onChange,totalIndex:totalIndex};if([].concat(oneRow,[52]).includes(index)){return{props:{colSpan:0}};}if(index===24){return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:"Actual"})});}if([42,49].includes(index)){return{props:{colSpan:3},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:'input'})})};}if(index==45){return{props:{colSpan:3},children:_react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:'inputPercent'})})};}if(inputIndex.includes(index))props.type="inputNumber";return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Budget',dataIndex:'y_bud',key:'y_bud',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:percentIndex.includes(index)?"percent":'number',name:"y_bud",onChange:onChange,totalIndex:totalIndex};if(oneRow.includes(index)){return{props:{colSpan:0}};}if([42,45,49,52].includes(index)){return{props:{colSpan:0}};}if(index===24){return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:"Last Year"})});}if(inputIndex.includes(index))props.type="inputNumber";return _react2.default.createElement(_TableText2.default,{data:props});}},{title:'Var%',dataIndex:'y_var',key:'y_var',align:"center",width:150,render:function render(text,record,index){var props={text:text,index:index,type:'percent',name:"y_var",onChange:onChange,totalIndex:totalIndex};if(oneRow.includes(index)){return{props:{colSpan:0}};}if([42,45,49,52].includes(index)){return{props:{colSpan:0}};}if(index===24){return _react2.default.createElement(_TableText2.default,{data:_extends({},props,{type:"textcenter",text:"Var%"})});}if(inputIndex.includes(index))props.type="inputPercent";return _react2.default.createElement(_TableText2.default,{data:props});}}]}]);};

/***/ }),
/* 2232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);__webpack_require__(62);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var confirm=_modal2.default.confirm;exports.default=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var open,noRemind,data,timer;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:try{open=true;noRemind=['pay','关于千乘财务管理系统收费的通知','payselect','login'];data=JSON.parse(sessionStorage.getItem('chargeNotice')||"{}");if(data&&data.switch==1){timer=setInterval(function(){var isPath=noRemind.every(function(x){return!window.location.hash.includes(x);});var res=open&&isPath&&confirm({title:data.name,content:_react2.default.createElement('div',{className:'home-richText',dangerouslySetInnerHTML:{__html:data.content||""}}),cancelText:"关闭",okText:"查看付费详情",onOk:function onOk(){open=true;window.location.href="/#/pay";},onCancel:function onCancel(){open=true;}});open=!isPath?true:false;},20000);}}catch(error){console.log(error);}case 1:case'end':return _context.stop();}}},_callee,undefined);}));

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Bundle=function(_Component){_inherits(Bundle,_Component);function Bundle(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Bundle);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Bundle.__proto__||Object.getPrototypeOf(Bundle)).call.apply(_ref,[this].concat(args))),_this),_this.state={// short for "module" but that's a keyword in js, so "mod"
mod:null},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Bundle,[{key:"componentWillMount",value:function componentWillMount(){this.load(this.props);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.load!==this.props.load){this.load(nextProps);}}},{key:"load",value:function load(props){var _this2=this;this.setState({mod:null});//注意这里，使用Promise对象; mod.default导出默认
props.load().then(function(mod){_this2.setState({mod:mod.default?mod.default:mod});});}},{key:"render",value:function render(){return this.state.mod?this.props.children(this.state.mod):"";}}]);return Bundle;}(_react.Component);exports.default=Bundle;

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _kpi=__webpack_require__(2236);var _kpi2=_interopRequireDefault(_kpi);var _revenue=__webpack_require__(2237);var _revenue2=_interopRequireDefault(_revenue);var _compared=__webpack_require__(2238);var _compared2=_interopRequireDefault(_compared);var _tableSwitch=__webpack_require__(2239);var _tableSwitch2=_interopRequireDefault(_tableSwitch);var _index=__webpack_require__(2240);var _index2=_interopRequireDefault(_index);var _general=__webpack_require__(2241);var _general2=_interopRequireDefault(_general);var _allHotel=__webpack_require__(2242);var _allHotel2=_interopRequireDefault(_allHotel);var _selectHotel=__webpack_require__(2243);var _selectHotel2=_interopRequireDefault(_selectHotel);var _summary=__webpack_require__(2244);var _summary2=_interopRequireDefault(_summary);var _store=__webpack_require__(2245);var _store2=_interopRequireDefault(_store);var _store3=__webpack_require__(2246);var _store4=_interopRequireDefault(_store3);var _store5=__webpack_require__(2247);var _store6=_interopRequireDefault(_store5);var _analysis=__webpack_require__(2248);var _analysis2=_interopRequireDefault(_analysis);var _auth=__webpack_require__(2249);var _auth2=_interopRequireDefault(_auth);var _groupChannels=__webpack_require__(2250);var _groupChannels2=_interopRequireDefault(_groupChannels);var _criticism=__webpack_require__(2251);var _criticism2=_interopRequireDefault(_criticism);var _actual=__webpack_require__(2252);var _actual2=_interopRequireDefault(_actual);var _store7=__webpack_require__(2253);var _store8=_interopRequireDefault(_store7);var _store9=__webpack_require__(2255);var _store10=_interopRequireDefault(_store9);var _store11=__webpack_require__(2259);var _store12=_interopRequireDefault(_store11);var _store13=__webpack_require__(2263);var _store14=_interopRequireDefault(_store13);var _store15=__webpack_require__(2264);var _store16=_interopRequireDefault(_store15);var _store17=__webpack_require__(2265);var _store18=_interopRequireDefault(_store17);var _store19=__webpack_require__(2266);var _store20=_interopRequireDefault(_store19);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var stores={salesPersonnel:_store20.default,financePersonnel:_store16.default,kpifollow:_store18.default,kpi:_kpi2.default,revenue:_revenue2.default,compared:_compared2.default,tableSwitch:_tableSwitch2.default,menu:_index2.default,general:_general2.default,allHotel:_allHotel2.default,selectHotel:_selectHotel2.default,summary:_summary2.default,applybilling:_store2.default,applyexpress:_store4.default,applycontract:_store6.default,auth:_auth2.default,analysis:_analysis2.default,groupChannels:_groupChannels2.default,criticism:_criticism2.default,effectActual:_actual2.default,effectOcc:_store8.default,daily:_store10.default,dailyMonth:_store12.default,monthlyAnalysis:_store14.default};exports.default=stores;

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _desc,_value,_class,_descriptor;var _mobx=__webpack_require__(30);function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var store=(_class=function store(){_classCallCheck(this,store);_initDefineProp(this,'data',_descriptor,this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'data',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}})),_class);var kpi=new store();exports.default=kpi;

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _desc,_value,_class,_descriptor;var _mobx=__webpack_require__(30);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var store=(_class=function store(){var _this=this;_classCallCheck(this,store);_initDefineProp(this,'data',_descriptor,this);this.getData=function(date){return new Promise(function(res,rej){fetch('/_5_1_1_info?year='+(0,_moment2.default)(date).format('YYYY')+'&month='+(0,_moment2.default)(date).format('M'),{credentials:'include'}).then(function(x){return x.json();}).then(function(x){(0,_mobx.runInAction)(function(){_this.data=x.data||[];});res(x);}).catch(function(err){rej(err);});});};},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'data',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}})),_class);var revenue=new store();exports.default=revenue;

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;var _mobx=__webpack_require__(30);function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Store=(_class=function Store(){_classCallCheck(this,Store);_initDefineProp(this,"state",_descriptor,this);_initDefineProp(this,"name",_descriptor2,this);_initDefineProp(this,"onChange",_descriptor3,this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,"state",[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,"name",[_mobx.observable],{enumerable:true,initializer:function initializer(){return"";}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,"onChange",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this=this;return function(state){_this.state=state;};}})),_class);var compared=new Store();exports.default=compared;

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _desc,_value,_class,_descriptor,_descriptor2;var _mobx=__webpack_require__(30);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var store=(_class=function store(){var _this=this;_classCallCheck(this,store);_initDefineProp(this,'data',_descriptor,this);this.getData=function(){fetch('/getTableSwitch',{credentials:'include'}).then(function(x){return x.json();}).then(function(x){(0,_mobx.runInAction)(function(){_this.data=x.data||{};});}).catch(function(err){console.error(err);});};_initDefineProp(this,'onClearData',_descriptor2,this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'data',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'onClearData',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){_this2.data={};};}})),_class);var revenue=new store();exports.default=revenue;

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9;__webpack_require__(10);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Store=(_class=function Store(){var _this=this;_classCallCheck(this,Store);_initDefineProp(this,"hotel",_descriptor,this);_initDefineProp(this,"hotelTotal",_descriptor2,this);_initDefineProp(this,"group",_descriptor3,this);this.getHeadquartersHotels=function(){return new Promise(function(res,rej){if(_this.hotelTotal.length>0){res((0,_mobx.toJS)(_this.hotelTotal));return;}fetch('/getHeadquartersHotels',{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.status==1){(0,_mobx.runInAction)(function(){_this.hotel=x.data.hotels||[];_this.hotelTotal=x.data.hotels||[];_this.group=x.data.group||[];});res(x.data.hotels||[]);}else{rej('数据获取失败！');}}).catch(function(err){rej(err);});});};_initDefineProp(this,"hotelInfo",_descriptor4,this);this.getHotelInfo=function(){return new Promise(function(res,rej){//如果数据存在禁止重复请求
if(_this.hotelInfo.id){res(_this.hotelInfo);return;}fetch('/getHotelInfo',{credentials:'include'}).then(function(x){return x.json();}).then(function(x){(0,_mobx.runInAction)(function(){_this.hotelInfo=x.data[0]?x.data[0]:{};});res(x.data[0]?x.data[0]:{});}).catch(function(err){rej(err);});});};_initDefineProp(this,"userInfo",_descriptor5,this);this.getUserInfo=function(){return new Promise(function(res,rej){if(_this.userInfo.id){res(_this.userInfo);return;}fetch('/getUserInfo',{credentials:'include'}).then(function(x){return x.json();}).then(function(x){(0,_mobx.runInAction)(function(){_this.userInfo=x.data||{};});res(x.data||{});}).catch(function(err){rej(err);});});};_initDefineProp(this,"onClearData",_descriptor6,this);_initDefineProp(this,"onLogout",_descriptor7,this);_initDefineProp(this,"display",_descriptor8,this);_initDefineProp(this,"onChangeDisplay",_descriptor9,this);}//酒店列表
//自定义表格列表
// 总部人员查询权限范围内的酒店信息
//当前酒店信息
// 当前登录用户信息
// 手动清除数据
,(_descriptor=_applyDecoratedDescriptor(_class.prototype,"hotel",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,"hotelTotal",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,"group",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,"hotelInfo",[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,"userInfo",[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,"onClearData",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){_this2.userInfo={};_this2.hotelInfo={};_this2.hotel=[];_this2.hotelTotal=[];_this2.group=[];};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,"onLogout",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(props){var keys=document.cookie.match(/[^ =;]+(?=\=)/g);if(keys){for(var i=keys.length;i--;){document.cookie=keys[i]+'=0;expires='+new Date(0).toUTCString();}};sessionStorage.clear();_message3.default.info('退出成功！');_this3.onClearData();props.store.tableSwitch.onClearData();window.location.href='/#/login';};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,"display",[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,"onChangeDisplay",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return function(){var value=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";_this4.display=value;};}})),_class);var menu=new Store();exports.default=menu;

/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6;__webpack_require__(10);var _mobx=__webpack_require__(30);var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);var _method=__webpack_require__(20);var _method2=_interopRequireDefault(_method);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}// 暖色调['#7079df', '#d15b7f', '#fb6e6c', '#ff9f69', '#feb64d', '#ffda43', '#ffe88e']
// 冷色调 ['#60acfc', '#23c2db', '#33d3eb', '#9cdc82', '#d4ec59', '#ffe168']
var color=['#4A5BB9','#F9BD5B','#A8B0C9','#8F98B3','#C2BBD8','#FFD590'];var columnColor=['#7079df','#d15b7f','#fb6e6c','#ff9f69','#feb64d','#ffda43','#ffe88e'];var textStyle={color:"#000",fontSize:14};var titleColor=['#4594B8','#00536E','#5DB8E5','#8CD9FF'];Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var store=(_class=function store(){var _this=this;_classCallCheck(this,store);_initDefineProp(this,"data",_descriptor,this);_initDefineProp(this,"score",_descriptor2,this);_initDefineProp(this,"loading",_descriptor3,this);_initDefineProp(this,"selectData",_descriptor4,this);_initDefineProp(this,"getData",_descriptor5,this);this.setCostPie=function(data,isOnResize){var myChart=_echarts2.default.init(document.getElementById('cost'));myChart.resize();if(isOnResize){return;}var option={color:color,title:[{text:'客房区域能耗统计',x:'20%',y:'5%',textAlign:'center'},{text:'厨房区域能耗统计',x:'47%',y:'5%',textAlign:'center'},{text:'酒店总能耗统计',x:'77%',y:'5%',textAlign:'center'}],textStyle:textStyle,tooltip:{trigger:'item',formatter:"{a} <br/>{b} {c} ({d}%)"},legend:[{orient:'horizontal',left:'10%',top:'85%',width:'33%',data:data[0].map(function(x){return x.name;})},{orient:'horizontal',left:'40%',top:'85%',width:'33%',data:data[1].map(function(x){return x.name;})},{orient:'horizontal',left:'70%',top:'85%',width:'33%',data:data[2].map(function(x){return x.name;})}],series:[{name:'客房区域能耗统计',type:'pie',radius:'50%',center:["20%",'50%'],data:data[0],label:{normal:{textStyle:{fontSize:14},formatter:function formatter(param){return param.name+':\n'+param.percent+'%';}}},itemStyle:{emphasis:{shadowBlur:10,shadowOffsetX:0,shadowColor:'rgba(0, 0, 0, 0.5)'}}},{name:'厨房区域能耗统计',type:'pie',radius:'50%',center:["47%",'50%'],data:data[1],label:{normal:{textStyle:{fontSize:14},formatter:function formatter(param){return param.name+':\n'+param.percent+'%';}}},itemStyle:{emphasis:{shadowBlur:10,shadowOffsetX:0,shadowColor:'rgba(0, 0, 0, 0.5)'}}},{name:'酒店总能耗统计计',type:'pie',radius:'50%',center:["77%",'50%'],data:data[0],label:{normal:{textStyle:{fontSize:14},formatter:function formatter(param){return param.name+':\n'+param.percent+'%';}}},itemStyle:{emphasis:{shadowBlur:10,shadowOffsetX:0,shadowColor:'rgba(0, 0, 0, 0.5)'}}}]};myChart.setOption(option);};this.setTitleCenter=function(data,isOnResize){var dataX=data.dataX,dataY=data.dataY,titleColor=data.titleColor;var myChart=_echarts2.default.init(document.getElementById('BI_title_center'));myChart.resize();if(isOnResize){return;}var option={tooltip:{trigger:'axis'// formatter: `{b}<br/>{a} : {c}%`
},color:titleColor||color,textStyle:textStyle,calculable:true,grid:{left:30,right:30,bottom:45},xAxis:[{type:'category',boundaryGap:false,show:false,data:dataX,axisLabel:{// d
color:"black",fontSize:14}}],yAxis:{type:'value',show:false},series:[{name:'入住率',type:'bar',smooth:true,barWidth:10,itemStyle:{normal:{areaStyle:{type:'default'},label:{show:false,formatter:function formatter(p){return p.value+'%';}}}},data:dataY}]};myChart.setOption(option);};this.setTitleLeft=function(data,isOnResize){var dataX=data.dataX,dataY=data.dataY,id=data.id,name=data.name,titleColor=data.titleColor;var myChart=_echarts2.default.init(document.getElementById(id));myChart.resize();if(isOnResize){return;}var option={tooltip:{trigger:'axis'},color:titleColor||color,textStyle:textStyle,calculable:true,grid:{left:20,right:20,bottom:45},xAxis:[{type:'category',boundaryGap:false,show:false,axisLabel:{// d
color:"black",fontSize:14},data:dataX}],yAxis:{type:'value',show:false},series:[{name:name,type:'line',smooth:true,itemStyle:{normal:{areaStyle:id==="BI_title_left"&&{type:'default'}}},data:dataY}]};myChart.setOption(option);};this.setRoomsLeft=function(data,isOnResize){var dataX=data.dataX,dataY=data.dataY,id=data.id,titleColor=data.titleColor,yAxis=data.yAxis,axisLabel=data.axisLabel;var myChart=_echarts2.default.init(document.getElementById(id));myChart.resize();if(isOnResize){return;}var min=Math.min.apply(Math,_toConsumableArray((0,_method2.default)([3,'data'],dataY,[0])))||0;var option={color:titleColor||columnColor,textStyle:textStyle,tooltip:{trigger:'axis',axisPointer:{type:'cross'}},grid:{top:100},legend:{data:dataY.map(function(x){return x.name;})},xAxis:[{type:'category',axisLabel:_extends({color:"black",fontSize:14},axisLabel),data:dataX||['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']}],yAxis:yAxis||[{type:'value',name:'价格',axisLabel:{formatter:'{value}'},min:min},{type:'value',name:'出租率',axisLabel:{formatter:'{value} %'}}],series:dataY.map(function(x,i){var yAxisIndex=i>=2?1:0;if(x.type==="percent"){yAxisIndex=0;}return{name:x.name,type:x.type&&x.type!='percent'?x.type:i>=2?'line':"bar",data:x.data.map(function(item){return i%2?"\n"+item:item;}),yAxisIndex:yAxisIndex};})};myChart.setOption(option);};this.setRoomRight=function(data,isOnResize){var myChart=_echarts2.default.init(document.getElementById('room_right'));var dataY=data.dataY,dataX=data.dataX;myChart.resize();if(isOnResize){return;}var option={color:['#48A7E5'],tooltip:{trigger:'axis',axisPointer:{type:'cross'}},textStyle:textStyle,legend:{data:['坪效']},xAxis:[{type:'category',axisLabel:{// d
color:"black",fontSize:14},data:dataX||['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']}],yAxis:[{type:'value',name:'收入',axisLabel:{formatter:'{value}'}}],series:{name:'坪效',type:"bar",data:dataY}};myChart.setOption(option);};this.setPie=function(data,isOnResize,isClear){var id=data.id,dataSource=data.dataSource,_data$title=data.title,title=_data$title===undefined?"":_data$title;var myChart=_echarts2.default.init(document.getElementById(id));myChart.resize();if(isClear){myChart.clear();}if(isOnResize){return;}var option={color:color,textStyle:textStyle,tooltip:{trigger:'item',formatter:"{a} <br/>{b} : {c} ({d}%)"},legend:{data:dataSource.map(function(x){return x.name;})},series:[{name:title,type:'pie',radius:'50%',center:['50%','60%'],data:dataSource,label:{normal:{textStyle:{fontSize:14},formatter:function formatter(param){return param.name+':\n'+param.percent+'%';}}},itemStyle:{emphasis:{shadowBlur:10,shadowOffsetX:0,shadowColor:'rgba(0, 0, 0, 0.5)'}}}]};myChart.setOption(option);};this.setCoolPie=function(data,isOnResize,isClear){var id=data.id,dataX=data.dataX,dataY=data.dataY,_data$title2=data.title,title=_data$title2===undefined?"":_data$title2,_data$labelShow=data.labelShow,labelShow=_data$labelShow===undefined?{}:_data$labelShow;var myChart=_echarts2.default.init(document.getElementById(id));myChart.resize();if(isClear){myChart.clear();}if(isOnResize){return;}var option={color:['#8FA0FF','#FFD590','#D1D5E1','#4A5BB9','#F9BD5B','#A8B0C9'],tooltip:{trigger:'item',formatter:"{a} <br/>{b}: {c} ({d}%)"},legend:{data:dataX},textStyle:textStyle,series:[{name:'本月',type:'pie',radius:[0,'30%'],label:_extends({// normal: {
//     position: 'outer'
// },
show:true,formatter:'{b}: {d}%'},labelShow),labelLine:{normal:_extends({show:true},labelShow)},data:dataY[0]},{name:'年累计',type:'pie',radius:['55%','70%'],label:_extends({show:true,formatter:'{b}: {d}%'},labelShow),data:dataY[1]}]};myChart.setOption(option);};this.setColumn=function(data,isOnResize){var id=data.id,_data$dataX=data.dataX,dataX=_data$dataX===undefined?[]:_data$dataX,_data$dataY=data.dataY,dataY=_data$dataY===undefined?[]:_data$dataY,tooltip=data.tooltip;var myChart=_echarts2.default.init(document.getElementById(id));myChart.resize();if(isOnResize){return;}dataY=dataY.length<=0?[{name:"",data:[]}]:dataY;var option={color:columnColor,textStyle:textStyle,tooltip:_extends({trigger:'axis',axisPointer:{type:'cross'}},tooltip),legend:{data:dataY.map(function(x){return x.name;})},xAxis:[{data:dataX,axisLabel:{// d
color:"black",fontSize:14,align:"center"}}],yAxis:dataY.map(function(x){return{type:'value',axisLabel:x.axisLabel||""};}),series:dataY.map(function(x){return{name:x.name,type:'bar',data:x.data};})};myChart.setOption(option);};this.setTotal=function(data,isOnResize){var id=data.id,_data$dataX2=data.dataX,dataX=_data$dataX2===undefined?[]:_data$dataX2,_data$dataY2=data.dataY,dataY=_data$dataY2===undefined?[]:_data$dataY2,_data$tooltip=data.tooltip,tooltip=_data$tooltip===undefined?{}:_data$tooltip,titleColor=data.titleColor;var myChart=_echarts2.default.init(document.getElementById(id));myChart.resize();if(isOnResize){return;}var option={color:titleColor||columnColor,textStyle:textStyle,tooltip:_extends({trigger:'axis',axisPointer:{type:'cross'}},tooltip),grid:{left:80},legend:{data:['Rooms Revenue 客房收入','Food & Beverage 餐饮收入','Other Revenue 其他收入']},xAxis:[{data:dataX,"type":"category","splitLine":{"show":false},"axisTick":{"show":false},"splitArea":{"show":false},axisLabel:{// d
color:"black",fontSize:14,align:"center"}}],yAxis:[{"type":"value","splitLine":{"show":false},"axisTick":{"show":false},"axisLabel":{"interval":0},"splitArea":{"show":false}}],series:[].concat(_toConsumableArray(dataY.map(function(x,i){return{name:x.name,type:'bar',stack:"总量",data:x.data};})),[{"name":"总数","type":"line","itemStyle":{"normal":{"label":{"show":true,"textStyle":{"color":"#333"},"top":-20,formatter:function formatter(p){var money=Math.abs(Number(p.value||"0")).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');return p.value>0?money:'';}}}},data:dataY[0].data.map(function(x,i){return((0,_method.numConvert)(x)+(0,_method.numConvert)(dataY[1].data[i])+(0,_method.numConvert)(dataY[2].data[i])).toFixed(2);})}])};myChart.setOption(option);};this.onResize=function(){// 屏幕变化时自动适配
_this.setRoomsLeft({id:"room_left"},true);_this.setRoomRight({},true);_this.setPie({id:"food_left"},true);_this.setColumn({id:"food_right"},true);_this.setRoomsLeft({id:"staff_left"},true);_this.setColumn({id:"staff_right"},true);_this.setTitleLeft({id:"BI_title_left"},true);_this.setTitleLeft({id:"BI_title_right"},true);_this.setTitleCenter({},true);_this.setCostPie({},true);_this.setRoomsLeft({id:"month-rooms"},true);_this.setPie({id:"month-rev"},true);// this.setRoomsLeft({ id: "day-rooms" }, true);
// this.setTotal({ id: "day-rev" }, true);
};_initDefineProp(this,"onChangeTime",_descriptor6,this);}/*
     *  rooms       客房数据 1：本月 2：本年 
     *  operating   每可用房经营收入
     *  income      1:收入分类 2：收入份额
     *  month       1 总收入  2 餐饮收入  
     *  day         1 总收入  2 餐饮收入   3 其他收入
    */,(_descriptor=_applyDecoratedDescriptor(_class.prototype,"data",[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,"score",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,"loading",[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,"selectData",[_mobx.observable],{enumerable:true,initializer:function initializer(){return{rooms:2,operating:2,income:1,month:1,day:1};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,"getData",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(year,month,week){var res,json,data,resm,jsonm,roomsLeft,roomsRight,foodLeft,foodRight,score,competitor_room,staff_left,staffRight,titleLeft,titleRight,titleCenter,listName,costData,monthRooms,monthRev;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this2.loading=true;_context.prev=1;_context.next=4;return fetch("/bi_general?year="+year+"&month="+month+"&week="+week,{credentials:'include'});case 4:res=_context.sent;_context.next=7;return res.json();case 7:json=_context.sent;data=json.data||{};_context.next=11;return fetch("/getRoomsMonth?year="+year+"&month="+month+"&week="+week,{credentials:'include'});case 11:resm=_context.sent;_context.next=14;return resm.json();case 14:jsonm=_context.sent;roomsLeft={id:"room_left",dataY:(jsonm.data||[]).map(function(x,i){return{name:x.name,data:Object.entries(x.data||{}).map(function(item){return i>=2?Number(item[1]*100).toFixed(4):Number(item[1]).toFixed(2);})};}),dataX:['Actual 实际','Forecast 预测','Budget 预算','Last Year 去年'],titleColor:['#7079df','#d15b7f','#fb6e6c','#ff8b4a']};_this2.setRoomsLeft(roomsLeft);roomsRight={dataY:Object.entries(data.opera.total||{}).map(function(x){return(Number(data.opera.rooms[x[0]])==0?0:x[1]/data.opera.rooms[x[0]]).toFixed(2);})};_this2.setRoomRight(roomsRight);foodLeft={id:"food_left",title:"收入份额",dataSource:Object.entries(data.revenueShare||{}).map(function(x){return{name:x[0],value:Number(x[1]).toFixed(2)};})};_this2.setPie(foodLeft,false,true);foodRight={id:"food_right",title:"占比",dataX:Object.entries(data.PlacingRate.MTD||{}).map(function(x){return x[0];}),dataY:[{name:"MTD",type:"percent",data:Object.entries(data.PlacingRate.MTD||{}).map(function(x){return(0,_method.numConvert)(x[1]*100).toFixed(2);})},{name:"YTD",type:"percent",data:Object.entries(data.PlacingRate.YTD||{}).map(function(x){return(0,_method.numConvert)(x[1]*100).toFixed(2);})}],yAxis:[{type:'value',name:'收入与成本占比',axisLabel:{formatter:'{value} %'}}]};_this2.setRoomsLeft(foodRight);score=(data.score.name||[]).map(function(x,i){return{name:x.name,ctrip:parseFloat((0,_method2.default)([3,"col"+(i+1)+"2"],data.score.data)),elong:parseFloat((0,_method2.default)([4,"col"+(i+1)+"2"],data.score.data)),book:parseFloat((0,_method2.default)([5,"col"+(i+1)+"2"],data.score.data))};});competitor_room=data.competitor_room;staff_left={id:"staff_left",dataX:Object.entries(competitor_room).map(function(x,i){if(x[0].includes('酒店')){return""+(i%2?'':'\n\n')+x[0].split('酒店')[0]+"\u9152\u5E97";}return x[0];}),dataY:[{name:"平均房价 ADR",data:Object.entries(competitor_room).map(function(x){return x[1]['平均房价 ADR'];})},{name:"Revpar",data:Object.entries(competitor_room).map(function(x){return x[1]['Revpar'];})},{name:"入住率 Occ %",data:Object.entries(competitor_room).map(function(x){return(x[1]['入住率 Occ']||"").replace('%','');})}],axisLabel:{'interval':0,showMinLabel:true,showMaxLabel:true,// padding: [0, -10, 0, -10],
rotate:0,formatter:function formatter(params,index){// 超出省略
params=params.toString();var maxlength=8;if(index==1){return params.substring(0,maxlength-1)+'...';}return params;}},yAxis:[{type:'value',name:'价格',axisLabel:{formatter:'{value}'}},{type:'value',name:'入住率',max:100,axisLabel:{formatter:'{value} %'}}]};_this2.setRoomsLeft(staff_left);// 客房与员工数据
staffRight={id:"staff_right",title:"",dataX:Object.entries(data.employee_output.room||{}).map(function(x,i){return i+1+"月";}),dataY:[{name:"客房部门",data:Object.entries(data.employee_output.room||{}).map(function(x){return Number(x[1]).toFixed(2);})},{name:"餐饮部门",data:Object.entries(data.employee_output.food||{}).map(function(x){return Number(x[1]).toFixed(2);})},{name:"其他部门",data:Object.entries(data.employee_output.else||{}).map(function(x){return Number(x[1]).toFixed(2);})}]};_this2.setColumn(staffRight);titleLeft={dataX:Object.entries(data.Amount_occupancy||{}).map(function(x){return x[0]+'月';}),dataY:Object.entries(data.Amount_occupancy||{}).map(function(x){return Number(x[1]);}),id:"BI_title_left",name:"最高占用房数",titleColor:titleColor};_this2.setTitleLeft(titleLeft);titleRight={dataX:Object.entries(data.ADR||{}).map(function(x){return x[0]+'月';}),dataY:Object.entries(data.ADR||{}).map(function(x){return Number(x[1]);}),id:"BI_title_right",name:"平均房价",titleColor:titleColor};_this2.setTitleLeft(titleRight);titleCenter={titleColor:titleColor,dataX:Object.entries(data.Occupancy||{}).map(function(x){return x[0]+'月';}),dataY:Object.entries(data.Occupancy||{}).map(function(x){return Number((x[1]*100).toFixed(2));})};_this2.setTitleCenter(titleCenter);listName=['Electricity 电能 \n(KWH 千瓦时)',"Water 水 \n(m³ 立方)",'Gas 燃气 \n(m³ 立方)'];costData=Object.entries(data.cost||{}).map(function(x){var arr=x[1].map(function(item,i){return{name:listName[i],value:Number(item).toFixed(2)};});return arr;});_this2.setCostPie(costData);// 月度汇总
monthRooms={id:"month-rooms",dataY:Object.entries(data.month.room||{}).map(function(x,i){return{name:x[0],data:Object.entries(x[1]).map(function(item){return(0,_method.numConvert)(i==2?100*item[1]:item[1]).toFixed(2);})};})};_this2.setRoomsLeft(monthRooms);monthRev={id:"month-rev",labelShow:{show:false},dataY:Object.entries(data.month.rev||{}).map(function(x,index){return Object.entries(x[1]).map(function(item){return{name:(index===0?'月':"")+" "+item[0],value:(0,_method.numConvert)(item[1]).toFixed(2)};});})};_this2.setCoolPie(monthRev);// 每日数据汇总
// const dayRooms = {
//     id: "day-rooms",
//     dataX: Object.entries(data.day.room['arr'] || {}).map(x => `${x[0]}周`),
//     dataY: [{
//         name: "平均房价 ADR",
//         data: Object.entries(data.day.room['arr'] || {}).map(x => numConvert(x[1])),
//     }, {
//         name: "Revpar",
//         data: Object.entries(data.day.room['revpar'] || {}).map(x => numConvert(x[1])),
//     }, {
//         name: "入住率 Occ%",
//         data: Object.entries(data.day.room['occ'] || {}).map(x => (x[1] * 100).toFixed(2)),
//     }],
//     titleColor,
// };
// this.setRoomsLeft(dayRooms);
// const nameList = {
//     food: "Food & Beverage 餐饮收入",
//     other: 'Other Revenue 其他收入',
//     room: "Rooms Revenue 客房收入"
// };
// const dayRev = {
//     id: "day-rev",
//     dataX: Object.entries(data.day.rev['food'] || {}).map(x => `${x[0]}周`),
//     dataY: Object.entries(data.day.rev || {}).map(x => {
//         return {
//             name: nameList[x[0]],
//             data: [...Object.entries(x[1]).map(item => item[1])]
//         }
//     }),
//     titleColor,
// };
// this.setTotal(dayRev);
(0,_mobx.runInAction)(function(){_this2.score=score;_this2.data=data;_this2.loading=false;});_context.next=50;break;case 45:_context.prev=45;_context.t0=_context["catch"](1);console.log(_context.t0);_message3.default.error('数据获取失败！');(0,_mobx.runInAction)(function(){_this2.loading=false;});case 50:case"end":return _context.stop();}}},_callee,_this2,[[1,45]]);}));return function(_x,_x2,_x3){return _ref.apply(this,arguments);};}();}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,"onChangeTime",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(name,value){var selectData,data,roomsLeft,res,json,_roomsLeft,roomsRight,_res,_json,_roomsRight,foodLeft,_foodLeft,monthRev,_monthRev;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:selectData=(0,_mobx.toJS)(_this3.selectData);if(!(value==selectData[name])){_context2.next=3;break;}return _context2.abrupt("return");case 3:selectData[name]=value;_this3.selectData=selectData;data=(0,_mobx.toJS)(_this3.data);_context2.t0=name;_context2.next=_context2.t0==='rooms'?9:_context2.t0==='operating'?23:_context2.t0==='income'?37:_context2.t0==='month'?39:41;break;case 9:if(!(value==2)){_context2.next=14;break;}roomsLeft={id:"room_left",dataY:(data.rooms||[]).map(function(x,i){return{name:x.name,data:Object.entries(x.data||{}).map(function(item){return i>=2?Number(item[1]*100).toFixed(4):Number(item[1]).toFixed(2);})};})};_this3.setRoomsLeft(roomsLeft);_context2.next=22;break;case 14:_context2.next=16;return fetch('/getRoomsMonth',{credentials:'include'});case 16:res=_context2.sent;_context2.next=19;return res.json();case 19:json=_context2.sent;_roomsLeft={id:"room_left",dataY:(json.data||[]).map(function(x,i){return{name:x.name,data:Object.entries(x.data||{}).map(function(item){return i>=2?Number(item[1]*100).toFixed(4):Number(item[1]).toFixed(2);})};}),dataX:['Actual 实际','Forecast 预测','Budget 预算','Last Year 去年']};_this3.setRoomsLeft(_roomsLeft);case 22:return _context2.abrupt("break",42);case 23:if(!(value==2)){_context2.next=28;break;}roomsRight={dataY:Object.entries(data.opera.total||{}).map(function(x){return(Number(data.opera.rooms[x[0]])==0?0:x[1]/data.opera.rooms[x[0]]).toFixed(2);})};_this3.setRoomRight(roomsRight);_context2.next=36;break;case 28:_context2.next=30;return fetch('/getOperatingMonth',{credentials:'include'});case 30:_res=_context2.sent;_context2.next=33;return _res.json();case 33:_json=_context2.sent;_roomsRight={dataY:Object.entries(_json.data.total||{}).map(function(x){return(Number(_json.data.rooms[x[0]])==0?0:x[1]/_json.data.rooms[x[0]]).toFixed(2);}),dataX:['Actual 实际','Forecast 预测','Budget 预算','Last Year 去年']};_this3.setRoomRight(_roomsRight);case 36:return _context2.abrupt("break",42);case 37:if(value==2){foodLeft={id:"food_left",title:"收入份额",dataSource:Object.entries(data.revenueShare||{}).map(function(x){return{name:x[0],value:Number(x[1]).toFixed(2)};})};_this3.setPie(foodLeft,false,true);}else{_foodLeft={id:"food_left",title:"收入份额",dataX:(data.revenueSort||[]).map(function(x){return x.name;}),dataY:(data.revenueSort||[]).map(function(x){return Number(x.value).toFixed(2);})};_this3.setColumn(_foodLeft);}return _context2.abrupt("break",42);case 39:if(value==2){monthRev={id:"month-rev",dataSource:Object.entries(data.month.food||{}).map(function(x){return{name:x[0],value:(0,_method.numConvert)(x[1])};})};_this3.setPie(monthRev,false,true);}else{_monthRev={id:"month-rev",dataSource:Object.entries(data.month.total||{}).map(function(x){return{name:x[0],value:(0,_method.numConvert)(x[1])};})};_this3.setPie(_monthRev,false,true);}return _context2.abrupt("break",42);case 41:return _context2.abrupt("break",42);case 42:case"end":return _context2.stop();}}},_callee2,_this3);}));return function(_x4,_x5){return _ref2.apply(this,arguments);};}();}})),_class);var revenue=new store();exports.default=revenue;

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9;var _mobx=__webpack_require__(30);var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var color=['#4c9bf2','#4AC18E','#D9534F','#67A8E4'];var dataName={FB:"F&B Revenue 餐饮收入",Other_Cost:"Other Expense and Cost 其他费用及成本",Payroll_Expense:"Total Payroll Expense 人力资源总费用",Utility:"Utility Cost 能源成本",food:"F&B Total Cost 食品及饮品成本",occupied:"出租可房间夜数",other_revenue:"Other Revenue 其他部门收入 ",profit:"总利润",revenue:"总收入",rooms:"Rooms Revenue 客房收入"};Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var store=(_class=function store(){var _this=this;_classCallCheck(this,store);_initDefineProp(this,'data',_descriptor,this);_initDefineProp(this,'loading',_descriptor2,this);_initDefineProp(this,'profit',_descriptor3,this);_initDefineProp(this,'revenue',_descriptor4,this);_initDefineProp(this,'occ',_descriptor5,this);_initDefineProp(this,'arr',_descriptor6,this);_initDefineProp(this,'hotel_id',_descriptor7,this);_initDefineProp(this,'getData',_descriptor8,this);this.setKarte=function(data,isOnResize){var id=data.id,dataX=data.dataX,dataY=data.dataY;var myChart=_echarts2.default.init(document.getElementById(id));myChart.resize();if(isOnResize){return;}var option={backgroundColor:'#fff',legend:{top:'30',data:dataY.map(function(x){return x.name;})},color:color,grid:{bottom:'35%'// right: '18%',
// left: '18%',
// top: '15%'
},xAxis:{splitLine:{lineStyle:{show:true,type:'dashed'}},"axisLabel":{"interval":5,rotate:40,textStyle:{fontSize:12,color:'#000'}},data:dataX},yAxis:{name:'张',splitLine:{lineStyle:{type:'dashed'}}},tooltip:{trigger:'item',formatter:'{b}<br/>{a} : {c}'},series:dataY.map(function(item){return{name:item.name,// symbolSize: function (data) {
//     return Math.sqrt(data) * 2;
// },
type:'scatter',data:item.data,markPoint:{data:[{type:'max',name:'最大值'},{type:'min',name:'最小值'}]},markLine:{data:[{type:'average',name:'平均值'}]}};})};myChart.setOption(option);};this.setProportion=function(data,isOnResize){var id=data.id,dataRevenue=data.dataRevenue,dataProfit=data.dataProfit,dataRooms=data.dataRooms;var myChart=_echarts2.default.init(document.getElementById(id));myChart.resize();if(isOnResize){return;}var option={title:[{text:"收入占比",x:'1%',y:'1%',textStyle:{color:"#333",fontSize:"16"}},{text:"成本占比",x:'55%',y:'1%',textStyle:{color:"#333",fontSize:"16"}}],grid:[{x:'60%',y:'7%',width:'45%',height:'90%'}],tooltip:{formatter:'{b} ({c})'},series:[{name:'收入占比',type:'pie',radius:'70%',center:['20%','60%'],data:dataRevenue,color:color,itemStyle:{normal:{label:{show:true,formatter:'{b} \n ({d}%)',textStyle:{color:'#333'}}}}},{name:'成本占比',type:'pie',radius:'70%',center:['75%','60%'],color:color,data:dataProfit,itemStyle:{normal:{label:{show:true,formatter:'{b} \n ({d}%)',textStyle:{color:'#333'}}}}}]};myChart.setOption(option);};this.onResize=function(){_this.setProportion({id:"Proportion"},true);};_initDefineProp(this,'onChangeHotelId',_descriptor9,this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'data',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'profit',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'revenue',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'occ',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'arr',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'hotel_id',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return _asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var res,json,data,revenue,profit,occ,arr,dataRevenue,dataProfit;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this2.loading=true;_context.prev=1;_context.next=4;return fetch('/bi_headquarters',{credentials:'include'});case 4:res=_context.sent;_context.next=7;return res.json();case 7:json=_context.sent;data=json.data||{};revenue=data.sort(function(a,b){return b.revenue-a.revenue;}).map(function(item,i){return _extends({},item,{index:i+1});});profit=data.sort(function(a,b){return b.profit-a.profit;}).map(function(item,i){return _extends({},item,{index:i+1});});occ=data.sort(function(a,b){return b.occ-a.occ;}).map(function(item,i){return _extends({},item,{index:i+1});});arr=data.sort(function(a,b){return b.arr-a.arr;}).map(function(item,i){return _extends({},item,{index:i+1});});dataRevenue=['rooms','FB','other_revenue'];dataProfit=['food','Payroll_Expense','Utility','Other_Cost'];_this2.setProportion({id:"Proportion",dataRevenue:dataRevenue.map(function(name){var d=data.find(function(x,i){return x.id==1;})||{};return{name:dataName[name],value:Number(d[name]).toFixed(2)};}),dataProfit:dataProfit.map(function(name){var d=data.find(function(x,i){return x.id==1;})||{};return{name:dataName[name],value:Number(d[name]).toFixed(2)};}),dataRooms:data.sort(function(a,b){return b.occupied-a.occupied;}).filter(function(x,i){return i<=9;}).map(function(x){return{name:x.name,value:Number(x.occupied).toFixed(0)};})});(0,_mobx.runInAction)(function(){_this2.loading=false;_this2.revenue=revenue;_this2.profit=profit;_this2.occ=occ;_this2.arr=arr;_this2.data=data;});_context.next=23;break;case 19:_context.prev=19;_context.t0=_context['catch'](1);console.error(_context.t0);(0,_mobx.runInAction)(function(){_this2.loading=false;});case 23:case'end':return _context.stop();}}},_callee,_this2,[[1,19]]);}));}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'onChangeHotelId',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(id){_this3.hotel_id=id;var data=(0,_mobx.toJS)(_this3.data);var dataRevenue=['rooms','FB','other_revenue'];var dataProfit=['food','Payroll_Expense','Utility','Other_Cost'];_this3.setProportion({id:"Proportion",dataRevenue:dataRevenue.map(function(name){var d=data.find(function(x,i){return x.id==id;})||{};return{name:dataName[name],value:Number(d[name]).toFixed(2)};}),dataProfit:dataProfit.map(function(name){var d=data.find(function(x,i){return x.id==id;})||{};return{name:dataName[name],value:Number(d[name]).toFixed(2)};}),dataRooms:data.sort(function(a,b){return b.occupied-a.occupied;}).filter(function(x,i){return i<=9;}).map(function(x){return{name:x.name,value:Number(x.occupied).toFixed(0)};})});};}})),_class);;var allHotel=new store();exports.default=allHotel;

/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12;var _mobx=__webpack_require__(30);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var store=(_class=function store(){_classCallCheck(this,store);_initDefineProp(this,'visible',_descriptor,this);_initDefineProp(this,'name',_descriptor2,this);_initDefineProp(this,'hotel',_descriptor3,this);_initDefineProp(this,'hotelTotal',_descriptor4,this);_initDefineProp(this,'selectedRowKeys',_descriptor5,this);_initDefineProp(this,'getData',_descriptor6,this);_initDefineProp(this,'onShow',_descriptor7,this);_initDefineProp(this,'onCancel',_descriptor8,this);_initDefineProp(this,'onChange',_descriptor9,this);_initDefineProp(this,'onSearch',_descriptor10,this);_initDefineProp(this,'onOk',_descriptor11,this);_initDefineProp(this,'onChangeRowKeys',_descriptor12,this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'visible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'name',[_mobx.observable],{enumerable:true,initializer:function initializer(){return"";}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'hotel',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'hotelTotal',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'selectedRowKeys',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this=this;return function(){fetch('/getHeadquartersHotels',{credentials:'include'}).then(function(x){return x.json();}).then(function(x){if(x.status==1){(0,_mobx.runInAction)(function(){_this.hotel=x.data.hotels||[];_this.hotelTotal=x.data.hotels||[];});}}).catch(function(err){console.error(err);});};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'onShow',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(id){_this2.visible=true;if(id)_this2.selectedRowKeys=[id];};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'onCancel',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(){_this3.visible=false;};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'onChange',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return function(e){_this4.name=(e.target.value||"").trim();};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'onSearch',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this5=this;return function(){var hotelTotal=[].concat(_toConsumableArray((0,_mobx.toJS)(_this5.hotelTotal)));var name=_this5.name;// 去除所有空格不区分大小写
var hotel=hotelTotal.filter(function(x){return x.name.toUpperCase().replace(/\s+/g,"").includes(name.toUpperCase().replace(/\s+/g,""));});_this5.hotel=hotel;};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'onOk',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this6=this;return function(fn){_this6.visible=false;if(fn)fn(_this6.selectedRowKeys[0]);};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'onChangeRowKeys',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this7=this;return function(key,selectedRows){_this7.selectedRowKeys=key;};}})),_class);var selectHotel=new store();exports.default=selectHotel;

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _desc,_value,_class,_descriptor,_descriptor2;var _mobx=__webpack_require__(30);function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var store=(_class=function store(){_classCallCheck(this,store);_initDefineProp(this,"data",_descriptor,this);_initDefineProp(this,"onChange",_descriptor2,this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,"data",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,"onChange",[_mobx.observable],{enumerable:true,initializer:function initializer(){return function(name,value){};}})),_class);var summery=new store();exports.default=summery;

/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8;__webpack_require__(10);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Store=(_class=function Store(){_classCallCheck(this,Store);_initDefineProp(this,"visible",_descriptor,this);_initDefineProp(this,"loading",_descriptor2,this);_initDefineProp(this,"data",_descriptor3,this);_initDefineProp(this,"onChange",_descriptor4,this);_initDefineProp(this,"onShow",_descriptor5,this);_initDefineProp(this,"onCancel",_descriptor6,this);_initDefineProp(this,"onOk",_descriptor7,this);_initDefineProp(this,"clearData",_descriptor8,this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,"visible",[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,"loading",[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,"data",[_mobx.observable],{enumerable:true,initializer:function initializer(){return{billing_name:"",billing_bank:"",billing_number:"",billing_bank_account:"",billing_tel:"",billing_addr:"",out_trade_no:'',billing_invoice:"",company_phone:"",company_addr:""};}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,"onChange",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this=this;return function(name){var value=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';_this.data[name]=value;};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,"onShow",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(item){_this2.data={out_trade_no:item.out_trade_no,billing_name:item.name,billing_bank:item.billing_bank,billing_number:item.billing_number,billing_bank_account:item.billing_bank_account,billing_tel:item.tel,billing_invoice:item.billing_invoice,email:item.email,company_phone:item.company_phone,company_addr:item.company_addr};_this2.visible=true;};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,"onCancel",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(){_this3.visible=false;_this3.clearData();};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,"onOk",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(getData){var data,dataFrom,key,headres,res,x;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:data=(0,_mobx.toJS)(_this4.data);if(/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(data.email)){_context.next=4;break;}_message3.default.error('邮箱格式不正确!');return _context.abrupt("return");case 4:if(!(!data.billing_bank||!data.billing_bank_account)){_context.next=7;break;}_message3.default.error('开户行信息不能为空!');return _context.abrupt("return");case 7:if(data.billing_number){_context.next=10;break;}_message3.default.error('请输入纳税人识别号!');return _context.abrupt("return");case 10:if(data.company_phone){_context.next=13;break;}_message3.default.error('请输入公司电话!');return _context.abrupt("return");case 13:_context.next=15;return true;case 15:_this4.loading=_context.sent;dataFrom=new FormData();for(key in data){if(data.hasOwnProperty(key)){dataFrom.append(key,data[key]);}}headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context.prev=19;_context.next=22;return fetch('/applyBilling',headres);case 22:res=_context.sent;_context.next=25;return res.json();case 25:x=_context.sent;_this4.loading=false;if(!(x.status==1)){_context.next=32;break;}_message3.default.info('申请开票成功！');(0,_mobx.runInAction)(function(){_this4.visible=false;_this4.clearData();});getData&&getData();return _context.abrupt("return");case 32:_message3.default.error(x.msg);_context.next=40;break;case 35:_context.prev=35;_context.t0=_context["catch"](19);_message3.default.error(_context.t0.message);_this4.loading=false;console.error(_context.t0);case 40:case"end":return _context.stop();}}},_callee,_this4,[[19,35]]);}));return function(_x2){return _ref.apply(this,arguments);};}();}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,"clearData",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this5=this;return function(){_this5.data={billing_name:"",billing_bank:"",billing_number:"",billing_bank_account:"",billing_tel:"",billing_addr:"",out_trade_no:'',billing_invoice:"",company_phone:"",company_addr:""};};}})),_class);var applybilling=new Store();exports.default=applybilling;

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;var _mobx=__webpack_require__(30);function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Store=(_class=function Store(){_classCallCheck(this,Store);_initDefineProp(this,"visible",_descriptor,this);_initDefineProp(this,"onShow",_descriptor2,this);_initDefineProp(this,"onCancel",_descriptor3,this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,"visible",[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,"onShow",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this=this;return function(){_this.visible=true;};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,"onCancel",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){_this2.visible=false;};}})),_class);var applybilling=new Store();exports.default=applybilling;

/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8;__webpack_require__(10);var _mobx=__webpack_require__(30);var _imgtopdf=__webpack_require__(128);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Store=(_class=function Store(){_classCallCheck(this,Store);_initDefineProp(this,"visible",_descriptor,this);_initDefineProp(this,"loading",_descriptor2,this);_initDefineProp(this,"data",_descriptor3,this);_initDefineProp(this,"onChange",_descriptor4,this);_initDefineProp(this,"onShow",_descriptor5,this);_initDefineProp(this,"onCancel",_descriptor6,this);_initDefineProp(this,"onOk",_descriptor7,this);_initDefineProp(this,"clearData",_descriptor8,this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,"visible",[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,"loading",[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,"data",[_mobx.observable],{enumerable:true,initializer:function initializer(){var _ref;return _ref={billing_addr:"",billing_tel:"",billing_name:"",email:"",//接受者邮箱
name:"",//接收人
tel:"",//接收人电话
addr:"",//地址
out_trade_no:"",//订单编号
hotel_name:"",//酒店名称
add_time:"",//申请时间
current_time:"",//当前过期时间 
expire_date:"",//付费后过期时间 
account:"",//申请账号
money:"9600.00"},_defineProperty(_ref,"current_time",(0,_moment2.default)().format('YYYY-MM-DD')),_defineProperty(_ref,"expire_date",(0,_moment2.default)().add(1,'year').subtract(1,'day').format('YYYY-MM-DD')),_ref;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,"onChange",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this=this;return function(name){var value=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';_this.data[name]=value;};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,"onShow",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(data,hotel){var _extends2;var hotelName=data.billing_invoice||sessionStorage.getItem('hotelName')||hotel.name;var account=JSON.parse(sessionStorage.getItem('user')||"{}")['email']||"";console.log(data);_this2.data=_extends({},_this2.data,(_extends2={name:data.name||"",tel:data.tel||'',addr:data.addr||"",billing_name:data.billing_name||"",billing_tel:data.company_phone||data.billing_tel||'',billing_addr:data.company_addr||data.billing_addr||"",out_trade_no:data.out_trade_no||"",hotel_name:data.billing_invoice||hotelName,add_time:(0,_moment2.default)(data.add_time||null).format('YYYY-MM-DD'),current_time:data.current_time||"",expire_date:data.expire_date||"",account:account=='admin'?(hotel.code||"")+"_FIN":account,money:data.money||"9600"},_defineProperty(_extends2,"current_time",(0,_moment2.default)(data.current_time||null).format('YYYY-MM-DD')),_defineProperty(_extends2,"expire_date",(0,_moment2.default)(data.current_time||null).add(1,'year').subtract(1,'day').format('YYYY-MM-DD')),_extends2));_this2.visible=true;};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,"onCancel",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(){if(_this3.loading){return;}_this3.visible=false;_this3.clearData();};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,"onOk",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(type){var data,test,img,dataFrom,key,headres,json,d;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:data=(0,_mobx.toJS)(_this4.data);// if (!(/^1[3456789]\d{9}$/.test(data.billing_tel)) && !/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(data.billing_tel)) {
//     message.error('请输入正确的电话号码!');
//     return
// }
test=/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;if(test.test(data.email)){_context.next=5;break;}_message3.default.error('请输入正确的邮箱!');return _context.abrupt("return");case 5:if(data.billing_name){_context.next=8;break;}_message3.default.error('姓名不能为空!');return _context.abrupt("return");case 8:if(data.hotel_name){_context.next=11;break;}_message3.default.error('单位名称不能为空!');return _context.abrupt("return");case 11:if(!(type==2&&(!data.addr||!data.tel||!data.name))){_context.next=14;break;}_message3.default.error('您申请的是纸质合同，请填写收件信息!');return _context.abrupt("return");case 14:_context.next=16;return true;case 16:_this4.loading=_context.sent;_context.prev=17;_context.next=20;return(0,_imgtopdf.imgToPdf)('contract',2);case 20:img=_context.sent;dataFrom=new FormData();dataFrom.append('img',img.img||"");// 2 纸质合同  1电子合同
dataFrom.append('type',type);for(key in data){if(data.hasOwnProperty(key)){if(data[key]&&data[key].includes('time'))data[key]=(0,_moment2.default)(data[key]).format('YYYY-MM-DD');dataFrom.append(key,data[key]||"");}}headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context.next=28;return fetch('/applycontract',headres);case 28:json=_context.sent;_context.next=31;return json.json();case 31:d=_context.sent;_context.next=34;return false;case 34:_this4.loading=_context.sent;if(!(d.status==1)){_context.next=39;break;}_message3.default.info('合同发送成功，请注意查收');_this4.onCancel();return _context.abrupt("return");case 39:_message3.default.error('邮件发送失败，请重新发送！');_context.next=49;break;case 42:_context.prev=42;_context.t0=_context["catch"](17);_context.next=46;return false;case 46:_this4.loading=_context.sent;_message3.default.error('系统处理错误，请重新申请！');console.error(_context.t0);case 49:case"end":return _context.stop();}}},_callee,_this4,[[17,42]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,"clearData",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this5=this;return function(){_this5.data={email:"",name:"",tel:"",addr:"",out_trade_no:"",hotel_name:"",add_time:"",current_time:"",expire_date:"",account:""};};}})),_class);var applybilling=new Store();exports.default=applybilling;

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4;__webpack_require__(10);var _mobx=__webpack_require__(30);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _analysis=__webpack_require__(125);var _method=__webpack_require__(20);var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var label={"formatter":"{c}%","show":true,position:'inner',fontWeight:"bold",fontSize:14};var defaultDate=(0,_moment2.default)().format('D')<=10?(0,_moment2.default)().subtract(2,'month').format('YYYY-MM'):(0,_moment2.default)().subtract(1,'month').format('YYYY-MM');var store=(_class=function store(){var _this=this;_classCallCheck(this,store);_initDefineProp(this,'data',_descriptor,this);_initDefineProp(this,'loading',_descriptor2,this);_initDefineProp(this,'date',_descriptor3,this);_initDefineProp(this,'getData',_descriptor4,this);this.setRoom=function(data,isOnResize){var _ref,_ref2,_ref3;var myChart=_echarts2.default.init(document.getElementById('room'));myChart.resize();if(isOnResize){return;}var room_data=(data.mtd||[]).find(function(item){return item.name=="Rooms Dept Profit % 客房部门利润率";})||{};var color=['#fb734e','#e32f46','#94d96c','#0bbcb7','#1a9bfc','#7049f0'];var dataStyle={normal:{label:{show:false},labelLine:{show:false},shadowBlur:40,borderWidth:10,shadowColor:'rgba(0, 0, 0, 0)'//边框阴影
}};var placeHolderStyle={normal:{color:'#EFF0F0',label:{show:false},labelLine:{show:false}},emphasis:{color:'rgba(239, 240, 240, 0.8)'}};var option={backgroundColor:'#fff',title:{text:'',x:'center',y:'center',textStyle:{fontWeight:'normal',fontSize:24,color:"#fff"}},tooltip:{trigger:'item',show:true,formatter:"{b} : <br/>{d}%",backgroundColor:'rgba(0,0,0,0.7)',// 背景
padding:[8,10],//内边距
extraCssText:'box-shadow: 0 0 3px rgba(255, 255, 255, 0.4);'//添加阴影
},legend:{left:'center',bottom:'0',itemGap:20,data:['Hotel Data 酒店数据','Revenue Range Data 收入区间数据','Area Data 区域数据','04','05','06'],textStyle:{color:'#fft'}},series:[(_ref={name:'Line 1',type:'pie',clockWise:true,radius:[136,176],center:['50%','45%'],itemStyle:dataStyle,hoverAnimation:false,startAngle:90},_defineProperty(_ref,'hoverAnimation',false),_defineProperty(_ref,"z",3),_defineProperty(_ref,'data',[{value:(Number(room_data.area||0)*100).toFixed(1),name:'Area Data 区域数据',itemStyle:{normal:{color:'rgba(178, 204, 228, 1)'}},label:label},{value:Number(room_data.area||0)*100<0?2*Math.abs((Number(room_data.area||0)*100).toFixed(1)):100-Number(room_data.area||0)*100,name:'',tooltip:{show:false},labelLine:{show:false},itemStyle:placeHolderStyle}]),_ref),(_ref2={name:'Line 2',type:'pie',clockWise:true,radius:[90,130],center:['50%','45%'],itemStyle:dataStyle,hoverAnimation:false,startAngle:90,"z":4},_defineProperty(_ref2,'hoverAnimation',false),_defineProperty(_ref2,'data',[{value:(Number(room_data.interval||0)*100).toFixed(1),name:'Revenue Range Data 收入区间数据',itemStyle:{normal:{color:'rgba(112, 164, 213, 1)'}},label:label},{value:Number(room_data.interval||0)*100<0?2*Math.abs((Number(room_data.interval||0)*100).toFixed(1)):100-Number(room_data.interval||0)*100,name:'',tooltip:{show:false},labelLine:{show:false},itemStyle:placeHolderStyle}]),_ref2),(_ref3={name:'Line 3',type:'pie',clockWise:true,radius:[50,84],center:['50%','45%'],itemStyle:dataStyle,hoverAnimation:false,startAngle:90},_defineProperty(_ref3,'hoverAnimation',false),_defineProperty(_ref3,"z",5),_defineProperty(_ref3,'data',[{value:(Number(room_data.hotel||0)*100).toFixed(1),name:'Hotel Data 酒店数据',itemStyle:{normal:{color:'rgba(33, 114, 188, 1)'}},label:label},{value:Number(room_data.hotel||0)*100<0?2*Math.abs((Number(room_data.hotel||0)*100).toFixed(1)):100-Number(room_data.hotel||0)*100,name:'',tooltip:{show:false},labelLine:{show:false},itemStyle:placeHolderStyle}]),_ref3)]};myChart.setOption(option);};this.setFood=function(data,isOnResize){var _ref4,_ref5,_ref6;var myChart=_echarts2.default.init(document.getElementById('food'));if(isOnResize){return;}var food_data=(data.mtd||[]).find(function(item){return item.name=="F&B Dept Profit % 餐饮部门利润率";})||{};var dataStyle={normal:{label:{show:false},labelLine:{show:false},shadowBlur:40,borderWidth:10,shadowColor:'rgba(0, 0, 0, 0)'//边框阴影
}};var placeHolderStyle={normal:{color:'#EFF0F0',label:{show:false},labelLine:{show:false}},emphasis:{color:'rgba(239, 240, 240, 0.8)'}};var option={backgroundColor:'#fff',title:{text:'',x:'center',y:'center',textStyle:{fontWeight:'normal',fontSize:24,color:"#fff"}},tooltip:{trigger:'item',show:true,formatter:"{b} : <br/>{d}%",backgroundColor:'rgba(0,0,0,0.7)',// 背景
padding:[8,10],//内边距
extraCssText:'box-shadow: 0 0 3px rgba(255, 255, 255, 0.4);'//添加阴影
},legend:{// orient: 'vertical',
// icon: 'circle',
left:'center',// top: '20',
bottom:'0',itemGap:20,data:['Hotel Data 酒店数据','Revenue Range Data 收入区间数据','Area Data 区域数据','04','05','06'],textStyle:{color:'#fft'}},series:[(_ref4={name:'Line 1',type:'pie',clockWise:true,radius:[136,176],center:['50%','45%'],itemStyle:dataStyle,hoverAnimation:false,startAngle:90},_defineProperty(_ref4,'hoverAnimation',false),_defineProperty(_ref4,"z",3),_defineProperty(_ref4,'data',[{value:(Number(food_data.area||0)*100).toFixed(1),name:'Area Data 区域数据',itemStyle:{normal:{color:'rgba(240, 179, 190, 1)'}},label:label},{value:Number(food_data.area||0)*100<0?2*Math.abs((Number(food_data.area||0)*100).toFixed(1)):100-Number(food_data.area||0)*100,name:'',tooltip:{show:false},labelLine:{show:false},itemStyle:placeHolderStyle}]),_ref4),(_ref5={name:'Line 2',type:'pie',clockWise:true,radius:[90,130],center:['50%','45%'],itemStyle:dataStyle,hoverAnimation:false,startAngle:90,"z":4},_defineProperty(_ref5,'hoverAnimation',false),_defineProperty(_ref5,'data',[{value:(Number(food_data.interval||0)*100).toFixed(1),name:'Revenue Range Data 收入区间数据',itemStyle:{normal:{color:'rgba(202, 113, 186, 1)'}},label:label},{value:Number(food_data.interval||0)*100<0?2*Math.abs((Number(food_data.interval||0)*100).toFixed(1)):100-Number(food_data.interval||0)*100,name:'',tooltip:{show:false},labelLine:{show:false},itemStyle:placeHolderStyle}]),_ref5),(_ref6={name:'Line 3',type:'pie',clockWise:true,radius:[50,84],center:['50%','45%'],itemStyle:dataStyle,hoverAnimation:false,startAngle:90},_defineProperty(_ref6,'hoverAnimation',false),_defineProperty(_ref6,"z",5),_defineProperty(_ref6,'data',[{value:(Number(food_data.hotel||0)*100).toFixed(1),name:'Hotel Data 酒店数据',itemStyle:{normal:{color:'rgba(117, 54, 164, 1)'}},label:label},{value:Number(food_data.hotel||0)*100<0?2*Math.abs((Number(food_data.hotel||0)*100).toFixed(1)):100-Number(food_data.hotel||0)*100,name:'',tooltip:{show:false},labelLine:{show:false},itemStyle:placeHolderStyle}]),_ref6)]};myChart.setOption(option);};this.onResize=function(){_this.setRoom(_this.data,true);_this.setFood(_this.data,true);};},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'data',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'date',[_mobx.observable],{enumerable:true,initializer:function initializer(){return defaultDate;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return _asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var month,year,j,data,_data$data,_data$data$mtd,mtd,_data$data$ytd,ytd,_data$data$seasonal,seasonal,revenueData,purchase,cost,RestaurantIncome;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:(0,_mobx.runInAction)(function(){_this2.loading=true;});_context.prev=1;month=(0,_moment2.default)(_this2.date).format('M');year=(0,_moment2.default)(_this2.date).format('YYYY');_context.next=6;return fetch('/performanceAll?month='+month+'&year='+year,{credentials:'include'});case 6:j=_context.sent;_context.next=9;return j.json();case 9:data=_context.sent;_data$data=data.data,_data$data$mtd=_data$data.mtd,mtd=_data$data$mtd===undefined?[]:_data$data$mtd,_data$data$ytd=_data$data.ytd,ytd=_data$data$ytd===undefined?[]:_data$data$ytd,_data$data$seasonal=_data$data.seasonal,seasonal=_data$data$seasonal===undefined?[]:_data$data$seasonal;revenueData={color:['#CD4B3F','#3C5764','#76A9B6'],id:"revenue",dataX:['Rooms Revenue % \n 客房收入占比','F&B Revenue % \n 餐饮收入占比','Other Revenue % \n 其他部门收入占比'],dataY:[{name:"Area Data 区域数据",data:[(0,_method.getJson)([0,'area'],mtd),(0,_method.getJson)([1,'area'],mtd),(0,_method.getJson)([2,'area'],mtd)]},{name:"Revenue Range Data 收入区间数据",data:[(0,_method.getJson)([0,'interval'],mtd),(0,_method.getJson)([1,'interval'],mtd),(0,_method.getJson)([2,'interval'],mtd)]},{name:"Hotel Data 酒店数据",data:[(0,_method.getJson)([0,'hotel'],mtd),(0,_method.getJson)([1,'hotel'],mtd),(0,_method.getJson)([2,'hotel'],mtd)]}]};(0,_analysis.setColumn)(revenueData,false);purchase={color:['#CD4B3F','#3C5764','#76A9B6'],id:"purchase",dataX:['Top 15 Vs. Total Purchase 前15位采购占总额比'],dataY:[{name:"Area Data 区域数据",data:[(0,_method.getJson)([15,'area'],mtd)]},{name:"Revenue Range Data 收入区间数据",data:[(0,_method.getJson)([15,'interval'],mtd)]},{name:"Hotel Data 酒店数据",data:[(0,_method.getJson)([15,'hotel'],mtd)]}]};(0,_analysis.setColumn)(purchase,false);cost={color:['#00C6BD','#42585D','#FF605F'],id:"RestaurantCost",dataY:['Banquet \n  宴会','Chinese \n  Restaurant \n  中餐厅','Coffee Shop \n  咖啡厅 '],dataX:[{name:"Area Data 区域数据",data:[(0,_method.getJson)([11,'area'],mtd),(0,_method.getJson)([9,'area'],mtd),(0,_method.getJson)([7,'area'],mtd)]},{name:"Revenue Range  Data 收入区间数据",data:[(0,_method.getJson)([11,'interval'],mtd),(0,_method.getJson)([9,'interval'],mtd),(0,_method.getJson)([7,'interval'],mtd)]},{name:"Hotel Data 酒店数据",data:[(0,_method.getJson)([11,'hotel'],mtd),(0,_method.getJson)([9,'hotel'],mtd),(0,_method.getJson)([7,'hotel'],mtd)]}]};(0,_analysis.setYCategory)(cost,false);RestaurantIncome={color:['#00C6BD','#42585D','#FF605F'],id:"RestaurantIncome",dataY:['Banquet \n  宴会','Chinese \n  Restaurant \n  中餐厅','Coffee Shop \n  咖啡厅 '],dataX:[{name:"Area Data 区域数据",data:[(0,_method.getJson)([10,'area'],mtd),(0,_method.getJson)([8,'area'],mtd),(0,_method.getJson)([6,'area'],mtd)]},{name:"Revenue Range  Data 收入区间数据",data:[(0,_method.getJson)([10,'interval'],mtd),(0,_method.getJson)([8,'interval'],mtd),(0,_method.getJson)([6,'interval'],mtd)]},{name:"Hotel Data 酒店数据",data:[(0,_method.getJson)([10,'hotel'],mtd),(0,_method.getJson)([8,'hotel'],mtd),(0,_method.getJson)([6,'hotel'],mtd)]}]};(0,_analysis.setYCategory)(RestaurantIncome,false);(0,_mobx.runInAction)(function(){_this2.loading=false;_this2.data=data.data;});_this2.data=data.data;_this2.setRoom(data.data);_this2.setFood(data.data);_context.next=30;break;case 25:_context.prev=25;_context.t0=_context['catch'](1);(0,_mobx.runInAction)(function(){_this2.loading=false;});console.error(_context.t0);_message3.default.error('数据获取错误!');case 30:case'end':return _context.stop();}}},_callee,_this2,[[1,25]]);}));}})),_class);var analysis=new store();exports.default=analysis;

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9;__webpack_require__(10);var _mobx=__webpack_require__(30);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Store=(_class=function Store(){var _this=this;_classCallCheck(this,Store);_initDefineProp(this,"ES",_descriptor,this);_initDefineProp(this,"user",_descriptor2,this);_initDefineProp(this,"BP",_descriptor3,this);_initDefineProp(this,"HR",_descriptor4,this);_initDefineProp(this,"isCloseMonth",_descriptor5,this);_initDefineProp(this,"isView",_descriptor6,this);_initDefineProp(this,"isCloseBP",_descriptor7,this);_initDefineProp(this,"isSave",_descriptor8,this);this.getAuth=function(name,key){if(_this.user.email==='admin')return true;return _this[name].includes(key);};_initDefineProp(this,"getESAuth",_descriptor9,this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,"ES",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,"user",[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,"BP",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,"HR",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,"isCloseMonth",[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,"isView",[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,"isCloseBP",[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,"isSave",[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,"getESAuth",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return _asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var usersession,uj,userAuthName,j,res,_auth;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;usersession=sessionStorage.getItem('user');uj=JSON.parse(usersession);userAuthName=void 0;if((uj.email||'').includes('admin')){userAuthName=uj.email;}else{userAuthName=(uj.email||'').split('_')[1];}_context.next=7;return fetch('/getMenuAuth?user='+userAuthName,{credentials:'include'});case 7:j=_context.sent;_context.next=10;return j.json();case 10:res=_context.sent;_auth=res.data||{};(0,_mobx.runInAction)(function(){_this2.ES=((_auth.ES||{}).data||"").split(',')||[];_this2.BP=((_auth.BP||{}).data||"").split(',')||[];_this2.HR=((_auth.HR||{}).data||"").split(',')||[];_this2.isCloseMonth=_auth.isCloseMonth;_this2.isCloseBP=_auth.isCloseBP;_this2.isSave=_auth.isSave;_this2.user=uj;_this2.isView=!!_auth.isView;});_context.next=19;break;case 15:_context.prev=15;_context.t0=_context["catch"](0);console.error(_context.t0);_message3.default.error('获取权限错误！');case 19:case"end":return _context.stop();}}},_callee,_this2,[[0,15]]);}));}})),_class);var auth=new Store();exports.default=auth;

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19;__webpack_require__(10);var _mobx=__webpack_require__(30);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _axios=__webpack_require__(86);var _axios2=_interopRequireDefault(_axios);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}Number.prototype.toFixed=function(exponent){if(this>0){return parseInt(this*Math.pow(10,exponent)+0.5)/Math.pow(10,exponent);}else{return parseInt(this*Math.pow(10,exponent)-0.5)/Math.pow(10,exponent);}};var store=(_class=function store(){var _this=this;_classCallCheck(this,store);_initDefineProp(this,'data',_descriptor,this);_initDefineProp(this,'data_copy',_descriptor2,this);_initDefineProp(this,'checkVal',_descriptor3,this);_initDefineProp(this,'area',_descriptor4,this);_initDefineProp(this,'all_num',_descriptor5,this);_initDefineProp(this,'list_count',_descriptor6,this);_initDefineProp(this,'bad_num',_descriptor7,this);_initDefineProp(this,'is_return_num',_descriptor8,this);_initDefineProp(this,'loading',_descriptor9,this);_initDefineProp(this,'comments_loading',_descriptor10,this);_initDefineProp(this,'page',_descriptor11,this);_initDefineProp(this,'date',_descriptor12,this);_initDefineProp(this,'initial_check',_descriptor13,this);_initDefineProp(this,'total',_descriptor14,this);_initDefineProp(this,'rivalData',_descriptor15,this);_initDefineProp(this,'rival',_descriptor16,this);_initDefineProp(this,'getData',_descriptor17,this);_initDefineProp(this,'getDataCount',_descriptor18,this);_initDefineProp(this,'getRival',_descriptor19,this);this.radioChange=function(e){_this.initial_check=false;_this.page=1;var platform=e.target.value;_this.getData('5.0','',platform,1,1,_this.rival);_this.checkVal=[];_this.area=platform;};this.checkChange=function(e){_this.initial_check=false;_this.checkVal=e;_this.page=1;var score=e.includes('bad')?'2.0':'5.0';var replys=e.includes('no_response')?'2':'1';var platform=_this.area==='all'?'':_this.area;_this.getData(score,'',platform,1,replys,_this.rival);};this.onChangePage=function(page,pageSize){_this.page=page;var score=(_this.checkVal||[]).includes('bad')?'3.0':'5.0';var replys=(_this.checkVal||[]).includes('no_response')?'2':'1';var platform=_this.area==='all'?'':_this.area;_this.getData(score,'',platform,page,replys);window.scrollTo({top:650,behavior:'smooth'});};},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'data',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'data_copy',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'checkVal',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'area',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'all';}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'all_num',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'list_count',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'bad_num',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'is_return_num',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'comments_loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'page',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'date',[_mobx.observable],{enumerable:true,initializer:function initializer(){return(0,_moment2.default)().subtract(1,'month').format('YYYY-MM');}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'initial_check',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'total',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'rivalData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'rival',[_mobx.observable],{enumerable:true,initializer:function initializer(){return"";}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var score=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'5.0';var content=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var platform=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var page=arguments.length>3&&arguments[3]!==undefined?arguments[3]:1;var replys=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'1';var name=arguments.length>5&&arguments[5]!==undefined?arguments[5]:"";var user,j,Data,count,data;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:(0,_mobx.runInAction)(function(){_this2.comments_loading=true;});_context.prev=1;user=JSON.parse(sessionStorage.getItem('user'))||{};_context.next=5;return _axios2.default.get('/ota/comment?score='+score+'&replys='+replys+'&name='+name+'&content='+content+'&platform='+(platform!="all"&&platform||"")+'&sys_id='+user['comid']+'&page='+page);case 5:j=_context.sent;Data=j.data||{};count=Data.total||0;data=Data.rows||[];if(_this2.area==='all'){if(_this2.initial_check){(0,_mobx.runInAction)(function(){_this2.data_copy=data;});}}(0,_mobx.runInAction)(function(){_this2.total=count;_this2.data=data;_this2.comments_loading=false;});_context.next=18;break;case 13:_context.prev=13;_context.t0=_context['catch'](1);(0,_mobx.runInAction)(function(){_this2.comments_loading=false;});console.error(_context.t0);_message3.default.error('数据获取错误!');case 18:case'end':return _context.stop();}}},_callee,_this2,[[1,13]]);}));return function(){return _ref.apply(this,arguments);};}();}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'getDataCount',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var name=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var user,res,num;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:user=JSON.parse(sessionStorage.getItem('user'))||{};_context2.next=3;return _axios2.default.get('/ota/groupPlatform?sys_id='+user['comid']+'&score=5.0&name='+name);case 3:res=_context2.sent;num=(res.data||[]).reduce(function(a,b){a.num+=b.num;a.bad+=b.bad;a.unanswered+=b.unanswered;return a;},{num:0,bad:0,unanswered:0,name:"all"});(0,_mobx.runInAction)(function(){_this3.list_count=[num].concat(_toConsumableArray(res.data));_this3.all_num=num.all;});case 6:case'end':return _context2.stop();}}},_callee2,_this3);}));return function(){return _ref2.apply(this,arguments);};}();}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'getRival',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return _asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(){var user,res;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:user=JSON.parse(sessionStorage.getItem('user'))||{};_context3.next=3;return _axios2.default.get('/ota/rivalComments?id='+user['comid']);case 3:res=_context3.sent;(0,_mobx.runInAction)(function(){_this4.rivalData=res.data||[];});case 5:case'end':return _context3.stop();}}},_callee3,_this4);}));}})),_class);var groupChannels=new store();exports.default=groupChannels;

/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;__webpack_require__(10);var _mobx=__webpack_require__(30);var _echarts=__webpack_require__(64);var _echarts2=_interopRequireDefault(_echarts);var _method=__webpack_require__(20);var _axios=__webpack_require__(86);var _axios2=_interopRequireDefault(_axios);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var store=(_class=function store(){var _this=this;_classCallCheck(this,store);_initDefineProp(this,'data',_descriptor,this);_initDefineProp(this,'criticismData',_descriptor2,this);_initDefineProp(this,'loading',_descriptor3,this);this.getData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var name=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var user,res,data;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;(0,_mobx.runInAction)(function(){_this.loading=true;});user=JSON.parse(sessionStorage.getItem('user'))||{};_context.next=5;return _axios2.default.get('/ota/keywordsnum?sys_id='+user['comid']+'&name='+name);case 5:res=_context.sent;data=res.data||[];data=data.sort(function(a,b){return b.num-a.num;});_this.setChart(data);(0,_mobx.runInAction)(function(){_this.data=data;_this.loading=false;});_context.next=17;break;case 12:_context.prev=12;_context.t0=_context['catch'](0);console.error(_context.t0);_message3.default.error('数据获取错误！');(0,_mobx.runInAction)(function(){_this.loading=false;});case 17:case'end':return _context.stop();}}},_callee,_this,[[0,12]]);}));return function(){return _ref.apply(this,arguments);};}();this.getCriticism=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(content){var name=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var user,url,res,data;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;(0,_mobx.runInAction)(function(){_this.loading=true;});user=JSON.parse(sessionStorage.getItem('user'))||{};url='sys_id='+user['comid']+'&content='+content+'&score=3.0&name='+name;_context2.next=6;return fetch('/index/comment/criticism?'+url,{credentials:'include'});case 6:res=_context2.sent;_context2.next=9;return res.json();case 9:data=_context2.sent;(0,_mobx.runInAction)(function(){_this.criticismData=data;_this.loading=false;});_context2.next=18;break;case 13:_context2.prev=13;_context2.t0=_context2['catch'](0);console.error(_context2.t0);_message3.default.error('数据获取错误！');(0,_mobx.runInAction)(function(){_this.loading=false;});case 18:case'end':return _context2.stop();}}},_callee2,_this,[[0,13]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();this.setChart=function(data,isOnResize){var myChart=_echarts2.default.init(document.getElementById('chart'));var listName={'早餐':"Breakfast",'周边环境':"Environment",'位置':"Location",'交通':"Transportation",'卫生':"Clean",'房间环境':"Rooms",'服务':"Service"};myChart.resize();if(isOnResize){return;}// 指定图表的配置项和数据
/*
        *   data1 差评
        *   data2 好评
        *   data3 总和
        */var data1=data.map(function(x){return x.num;});var data2=data.map(function(x){return x.num2;});var data3=data.map(function(x){return(0,_method.sum)([x.num2,x.num],0);});var datacity=data.map(function(x){return x.name+' '+listName[x.name];});var option={color:['#2E75B6','#9DC3E6'],tooltip:{trigger:'axis',axisPointer:{type:'shadow'}},toolbox:{show:true},legend:{bottom:'8%',data:['表扬 Positive','批评 Negative'],itemGap:112,itemWidth:16,itemHeight:16},grid:{//图表的位置
top:'14%',left:'3%',right:'4%',bottom:'20%',containLabel:true},yAxis:[{type:'value',max:Math.max.apply(Math,_toConsumableArray(data3)),axisLabel:{show:true,interval:'auto',formatter:'{value} '},splitLine:{show:true,lineStyle:{type:'solid',color:'#D8D8D8'}},axisLine:{show:false,lineStyle:{color:"rgba(102,102,102,0.5);"}},show:true}],xAxis:[{type:'category',axisLabel:{interval:0,show:true,splitNumber:15,textStyle:{fontSize:12,color:'#666666'}},data:datacity}],series:[{name:'表扬 Positive',type:'bar',stack:'sum',barWidth:'32px',data:data2},{name:'批评 Negative',type:'bar',barWidth:'32px',stack:'sum',data:data1,label:{normal:{// offset: ['50', '100'],
show:true,position:'top',formatter:'{c}',textStyle:{color:'#333',fontSize:16}}}},{name:'总数',type:'bar',stack:'sum',itemStyle:{normal:{color:'rgba(128, 128, 128, 0)'}},data:data3}]};myChart.setOption(option);};},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'data',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'criticismData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}})),_class);var revenue=new store();exports.default=revenue;

/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9;__webpack_require__(10);var _mobx=__webpack_require__(30);var _method=__webpack_require__(20);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(313);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var month=(0,_moment2.default)().format('M');var store=(_class=function store(){var _this=this;_classCallCheck(this,store);_initDefineProp(this,'data',_descriptor,this);_initDefineProp(this,'forecast',_descriptor2,this);_initDefineProp(this,'budget',_descriptor3,this);_initDefineProp(this,'date',_descriptor4,this);_initDefineProp(this,'loading',_descriptor5,this);_initDefineProp(this,'dataAll',_descriptor6,this);this.getData=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var data,forecast,budget,date,res,x,_x$data,_x$data$actualData,actualData,_x$data$forecastData,forecastData,_x$data$budgetData,budgetData,_x$data$b,b12,_x$data$b2,b17,_x$data$b3,b18;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:data=JSON.parse(JSON.stringify(_data.dataDefault));forecast=JSON.parse(JSON.stringify(_data.dataDefault));budget=JSON.parse(JSON.stringify(_data.dataDefault));date=_this.date;(0,_mobx.runInAction)(function(){_this.loading=true;});_context.prev=5;_context.next=8;return fetch('/efficiencyInfo?year='+(0,_moment2.default)(date).format('YYYY'),{credentials:'include'});case 8:res=_context.sent;_context.next=11;return res.json();case 11:x=_context.sent;_x$data=x.data,_x$data$actualData=_x$data.actualData,actualData=_x$data$actualData===undefined?{}:_x$data$actualData,_x$data$forecastData=_x$data.forecastData,forecastData=_x$data$forecastData===undefined?{}:_x$data$forecastData,_x$data$budgetData=_x$data.budgetData,budgetData=_x$data$budgetData===undefined?{}:_x$data$budgetData,_x$data$b=_x$data.b12,b12=_x$data$b===undefined?[]:_x$data$b,_x$data$b2=_x$data.b17,b17=_x$data$b2===undefined?[]:_x$data$b2,_x$data$b3=_x$data.b18,b18=_x$data$b3===undefined?[]:_x$data$b3;if(actualData.data.length>0){data=actualData.data.sort(function(a,b){return a.sort-b.sort;});}if(forecastData.data.length>0){forecast=forecastData.data.sort(function(a,b){return a.sort-b.sort;});}if(budgetData.data.length>0){budget=budgetData.data.sort(function(a,b){return a.sort-b.sort;});}_context.next=18;return _this.computeNum(data,_extends({},actualData,{b12:b12,b17:b17,b18:b18}),1);case 18:data=_context.sent;_context.next=21;return _this.computeNum(forecast,_extends({},forecastData,{b12:b12,b17:b17,b18:b18}),2);case 21:forecast=_context.sent;_context.next=24;return _this.computeNum(budget,_extends({},budgetData,{b12:b12,b17:b17,b18:b18}),3);case 24:budget=_context.sent;_context.next=27;return(0,_mobx.runInAction)(function(){_this.data=data;_this.forecast=forecast;_this.budget=budget;_this.loading=false;_this.dataAll=x.data;});case 27:setTimeout(function(){_this.onSave();},1000);_context.next=35;break;case 30:_context.prev=30;_context.t0=_context['catch'](5);console.error(_context.t0);_message3.default.error('获取数据失败');(0,_mobx.runInAction)(function(){_this.loading=false;});case 35:case'end':return _context.stop();}}},_callee,_this,[[5,30]]);}));_initDefineProp(this,'onSave',_descriptor7,this);_initDefineProp(this,'onChangeDate',_descriptor8,this);_initDefineProp(this,'computeNum',_descriptor9,this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'data',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'forecast',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'budget',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'date',[_mobx.observable],{enumerable:true,initializer:function initializer(){return month<3?(0,_moment2.default)().format('YYYY'):(0,_moment2.default)().add(1,'y').format('YYYY');}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'dataAll',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'onSave',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){var data=[].concat(_toConsumableArray(_this2.data)).map(function(x){return _extends({},x,{year:_this2.date});});var forecast=[].concat(_toConsumableArray(_this2.forecast)).map(function(x){return _extends({},x,{year:_this2.date});});var budget=[].concat(_toConsumableArray(_this2.budget)).map(function(x){return _extends({},x,{year:_this2.date});});var dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));dataFrom.append('forecast',JSON.stringify(forecast));dataFrom.append('budget',JSON.stringify(budget));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/efficiencyAdd',headres).then(function(x){return x.json();}).then(function(x){if(x.status!=1)_message3.default.error(x.msg);}).catch(function(err){console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'onChangeDate',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(str){_this3.date=str;_this3.data=[];_this3.forecast=[];_this3.budget=[];_this3.getData();};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'computeNum',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return function(data,_ref2){var b12=_ref2.b12,b17=_ref2.b17,b18=_ref2.b18,meet=_ref2.meet,rooms=_ref2.rooms,_ref2$t=_ref2.t12,t12=_ref2$t===undefined?{}:_ref2$t,_ref2$t2=_ref2.t17,t17=_ref2$t2===undefined?{}:_ref2$t2,inter_rooms=_ref2.inter_rooms,inter_meet=_ref2.inter_meet,inter12=_ref2.inter12,inter17=_ref2.inter17;var type=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;var name=type==1?'before_revenue':type==2?"last_revenue":"year_revenue";var name18=type==1?'before':type==2?"last_end":"year_end";var days=(0,_moment2.default)(_this4.date).subtract(3-type,'year').isLeapYear()?366:365;// 区域数据
data[0].area=(0,_method.calculation)(rooms,t17.Room*days,2);data[1].area=(0,_method.calculation)((0,_method.sum)([t12.Banquet,t12.Meeting]),meet*days,2);data[4].area=(0,_method.calculation)(t12.Cafe,t17.AllDay_num*days,2);data[5].area=(0,_method.calculation)(t12.Cafe,t17.AllDay*days,2);data[6].area=(0,_method.calculation)(t12.Chinese,t17.Chinese_num*days,2);data[7].area=(0,_method.calculation)(t12.Chinese,t17.Chinese*days,2);data[8].area=(0,_method.calculation)(t12.Lobby,t17.Lounge_num*days,2);data[9].area=(0,_method.calculation)(t12.Lobby,t17.Lounge*days,2);data[10].area=(0,_method.calculation)(t12.Specialty,t17.Special_num*days,2);data[11].area=(0,_method.calculation)(t12.Specialty,t17.Special*days,2);data[12].area=(0,_method.calculation)(t12.Other,(0,_method.sum)([t17.Other_num,t17.B_num])*days,2);data[13].area=(0,_method.calculation)(t12.Other,(0,_method.sum)([t17.Other,t17.B])*days,2);data[2].area=(0,_method.calculation)((0,_method.sum)([t12.Cafe,t12.Chinese,t12.Lobby,t12.Specialty,t12.Other]),(0,_method.sum)([t17.Chinese_num,t17.AllDay_num,t17.Lounge_num,t17.Special_num,t17.Other_num,t17.B_num,t17.private_num])*days,2);data[3].area=(0,_method.calculation)((0,_method.sum)([t12.Cafe,t12.Chinese,t12.Lobby,t12.Specialty,t12.Other]),(0,_method.sum)([t17.Chinese,t17.AllDay,t17.Lounge,t17.Special,t17.Other,t17.B,t17.private])*days,2);// 收入区间数据 
data[0].interval=(0,_method.calculation)(inter_rooms,inter17.Room*days,2);data[1].interval=(0,_method.calculation)((0,_method.sum)([inter12.Banquet,inter12.Meeting]),inter_meet*days,2);data[4].interval=(0,_method.calculation)(inter12.Cafe,inter17.AllDay_num*days,2);data[5].interval=(0,_method.calculation)(inter12.Cafe,inter17.AllDay*days,2);data[6].interval=(0,_method.calculation)(inter12.Chinese,inter17.Chinese_num*days,2);data[7].interval=(0,_method.calculation)(inter12.Chinese,inter17.Chinese*days,2);data[8].interval=(0,_method.calculation)(inter12.Lobby,inter17.Lounge_num*days,2);data[9].interval=(0,_method.calculation)(inter12.Lobby,inter17.Lounge*days,2);data[10].interval=(0,_method.calculation)(inter12.Specialty,inter17.Special_num*days,2);data[11].interval=(0,_method.calculation)(inter12.Specialty,inter17.Special*days,2);data[12].interval=(0,_method.calculation)(inter12.Other,(0,_method.sum)([inter17.Other_num,inter17.B_num])*days,2);data[13].interval=(0,_method.calculation)(inter12.Other,(0,_method.sum)([inter17.Other,inter17.B])*days,2);data[2].interval=(0,_method.calculation)((0,_method.sum)([inter12.Cafe,inter12.Chinese,inter12.Lobby,inter12.Specialty,inter12.Other]),(0,_method.sum)([inter17.Chinese_num,inter17.AllDay_num,inter17.Lounge_num,inter17.Special_num,inter17.Other_num,inter17.B_num,inter17.private_num])*days,2);data[3].interval=(0,_method.calculation)((0,_method.sum)([inter12.Cafe,inter12.Chinese,inter12.Lobby,inter12.Specialty,inter12.Other]),(0,_method.sum)([inter17.Chinese,inter17.AllDay,inter17.Lounge,inter17.Special,inter17.Other,inter17.B,inter17.private])*days,2);// 酒店数据
data[0].hotel=(0,_method.calculation)((0,_method.getJson)([7,name18],b18),(0,_method.getJson)([2,'rooms_fb_num'],b17)*days,2);data[1].hotel=(0,_method.calculation)((0,_method.sum)([(0,_method.getJson)([7,name],b12),(0,_method.getJson)([11,name],b12)]),(0,_method.getJson)([19,'conference_num'],b17)*days,2);data[4].hotel=(0,_method.calculation)((0,_method.getJson)([2,name],b12),(0,_method.getJson)([12,'rooms_fb_num'],b17)*days,2);data[5].hotel=(0,_method.calculation)((0,_method.getJson)([2,name],b12),(0,_method.getJson)([13,'rooms_fb_num'],b17)*days,2);data[6].hotel=(0,_method.calculation)((0,_method.getJson)([3,name],b12),(0,_method.getJson)([8,'rooms_fb_num'],b17)*days,2);data[7].hotel=(0,_method.calculation)((0,_method.getJson)([3,name],b12),(0,_method.getJson)([9,'rooms_fb_num'],b17)*days,2);data[8].hotel=(0,_method.calculation)((0,_method.getJson)([6,name],b12),(0,_method.getJson)([14,'rooms_fb_num'],b17)*days,2);data[9].hotel=(0,_method.calculation)((0,_method.getJson)([6,name],b12),(0,_method.getJson)([15,'rooms_fb_num'],b17)*days,2);data[10].hotel=(0,_method.calculation)((0,_method.getJson)([4,name],b12),(0,_method.getJson)([16,'rooms_fb_num'],b17)*days,2);data[11].hotel=(0,_method.calculation)((0,_method.getJson)([4,name],b12),(0,_method.getJson)([17,'rooms_fb_num'],b17)*days,2);data[12].hotel=(0,_method.calculation)((0,_method.getJson)([10,name],b12),(0,_method.sum)([(0,_method.getJson)([18,'rooms_fb_num'],b17),(0,_method.getJson)([20,'rooms_fb_num'],b17)])*days,2);data[13].hotel=(0,_method.calculation)((0,_method.getJson)([10,name],b12),(0,_method.sum)([(0,_method.getJson)([19,'rooms_fb_num'],b17),(0,_method.getJson)([21,'rooms_fb_num'],b17)])*days,2);data[2].hotel=(0,_method.calculation)((0,_method.sum)([(0,_method.getJson)([2,name],b12),(0,_method.getJson)([3,name],b12),(0,_method.getJson)([4,name],b12),(0,_method.getJson)([6,name],b12),(0,_method.getJson)([10,name],b12)]),(0,_method.sum)([(0,_method.getJson)([8,'rooms_fb_num'],b17),(0,_method.getJson)([12,'rooms_fb_num'],b17),(0,_method.getJson)([14,'rooms_fb_num'],b17),(0,_method.getJson)([16,'rooms_fb_num'],b17),(0,_method.getJson)([18,'rooms_fb_num'],b17),(0,_method.getJson)([20,'rooms_fb_num'],b17),(0,_method.getJson)([10,'rooms_fb_num'],b17)])*days,2);data[3].hotel=(0,_method.calculation)((0,_method.sum)([(0,_method.getJson)([2,name],b12),(0,_method.getJson)([3,name],b12),(0,_method.getJson)([4,name],b12),(0,_method.getJson)([6,name],b12),(0,_method.getJson)([10,name],b12)]),(0,_method.sum)([(0,_method.getJson)([9,'rooms_fb_num'],b17),(0,_method.getJson)([13,'rooms_fb_num'],b17),(0,_method.getJson)([15,'rooms_fb_num'],b17),(0,_method.getJson)([17,'rooms_fb_num'],b17),(0,_method.getJson)([19,'rooms_fb_num'],b17),(0,_method.getJson)([21,'rooms_fb_num'],b17),(0,_method.getJson)([11,'rooms_fb_num'],b17)])*days,2);return data;};}})),_class);var Actual=new store();exports.default=Actual;

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8;__webpack_require__(10);var _mobx=__webpack_require__(30);var _method=__webpack_require__(20);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2254);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var store=(_class=function store(){var _this=this;_classCallCheck(this,store);_initDefineProp(this,'area',_descriptor,this);_initDefineProp(this,'interval',_descriptor2,this);_initDefineProp(this,'date',_descriptor3,this);_initDefineProp(this,'loading',_descriptor4,this);_initDefineProp(this,'dataAll',_descriptor5,this);this.getData=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var area,interval,date,res,x;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:area=JSON.parse(JSON.stringify(_data.dataDefault));interval=JSON.parse(JSON.stringify(_data.dataDefault));date=_this.date;(0,_mobx.runInAction)(function(){_this.loading=true;});_context.prev=4;_context.next=7;return fetch('/effectOcc?year='+(0,_moment2.default)(date).format('YYYY'),{credentials:'include'});case 7:res=_context.sent;_context.next=10;return res.json();case 10:x=_context.sent;if(x.data.area&&x.data.area.length>0){area=x.data.area.sort(function(a,b){return a.sort-b.sort;});}if(x.data.interval&&x.data.interval.length>0){interval=x.data.interval.sort(function(a,b){return a.sort-b.sort;});}_context.next=15;return _this.computeNum(area,[x.data['东南华南'],x.data['华北华中'],x.data['江浙沪皖'],x.data['西南']]);case 15:area=_context.sent;_context.next=18;return _this.computeNum(interval,[x.data['10'],x.data['9'],x.data['7'],x.data['6'],x.data['5'],x.data['4'],x.data['3']]);case 18:interval=_context.sent;_context.next=21;return(0,_mobx.runInAction)(function(){_this.area=area;_this.interval=interval;_this.loading=false;_this.dataAll=x.data;});case 21:_this.onSave();_context.next=29;break;case 24:_context.prev=24;_context.t0=_context['catch'](4);console.error(_context.t0);_message3.default.error('获取数据失败');(0,_mobx.runInAction)(function(){_this.loading=false;});case 29:case'end':return _context.stop();}}},_callee,_this,[[4,24]]);}));_initDefineProp(this,'onSave',_descriptor6,this);_initDefineProp(this,'onChangeDate',_descriptor7,this);_initDefineProp(this,'computeNum',_descriptor8,this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'area',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'interval',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'date',[_mobx.observable],{enumerable:true,initializer:function initializer(){return(0,_moment2.default)().format('YYYY');}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'dataAll',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'onSave',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){var area=[].concat(_toConsumableArray(_this2.area)).map(function(x){return _extends({},x,{year:_this2.date});});var interval=[].concat(_toConsumableArray(_this2.interval)).map(function(x){return _extends({},x,{year:_this2.date});});var dataFrom=new FormData();dataFrom.append('area',JSON.stringify(area));dataFrom.append('interval',JSON.stringify(interval));var headres={method:'post',credentials:'include',headers:{},body:dataFrom};fetch('/effectOccAdd',headres).then(function(x){return x.json();}).then(function(x){if(x.status==1){_message3.default.success('保存成功！');return;}_message3.default.error(x.msg);}).catch(function(err){console.error(err);_message3.default.error('保存失败'+JSON.stringify(err));});};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'onChangeDate',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(str){_this3.date=str;_this3.data=[];_this3.forecast=[];_this3.budget=[];_this3.getData();};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'computeNum',[_mobx.action],{enumerable:true,initializer:function initializer(){return function(data,list){list.forEach(function(item,i){var key='space'+(i+1);var num=(0,_method.sum)([item['200<=Conference Area<500 <br/>200<=会议厅面积<500'],item['500<=Conference Area<1000 <br/>500<=会议厅面积<1000'],item['1000&lt;Conference Area<br/>1000&lt;会议厅面积'],item['Conference Area<200 <br/>会议厅面积<200']]);data[1][key]=(0,_method.calculation)(item['Ballroom A <br/>多功能宴会厅A'],num,4);data[2][key]=(0,_method.calculation)(item['Ballroom B <br/>多功能宴会厅B'],num,4);data[4][key]=(0,_method.calculation)(item['Conference A <br/>大会议室A'],num,4);data[5][key]=(0,_method.calculation)(item['Conference B <br/>大会议室B'],num,4);data[6][key]=(0,_method.calculation)(item['Conference C<br/>大会议室C'],num,4);data[7][key]=(0,_method.calculation)(item['Conference D <br/>大会议室D'],num,4);data[9][key]=(0,_method.calculation)(item['Conference A<br/>中会议室A'],num,4);data[10][key]=(0,_method.calculation)(item['Conference B<br/>中会议室B'],num,4);data[11][key]=(0,_method.calculation)(item['Conference C <br/>中会议室C'],num,4);data[12][key]=(0,_method.calculation)(item['Conference D <br/>中会议室D'],num,4);data[14][key]=(0,_method.calculation)(item['Conference A<br/>小会议室A'],num,4);data[15][key]=(0,_method.calculation)(item['Conference B <br/>小会议室B'],num,4);data[16][key]=(0,_method.calculation)(item['Conference C<br/>小会议室C'],num,4);data[17][key]=(0,_method.calculation)(item['Conference D<br/>小会议室D'],num,4);data[0][key]=(0,_method.sum)([data[1][key],data[2][key]],4);data[3][key]=(0,_method.sum)([data[4][key],data[5][key],data[6][key],data[7][key]],4);data[8][key]=(0,_method.sum)([data[9][key],data[10][key],data[11][key],data[12][key]],4);data[13][key]=(0,_method.sum)([data[14][key],data[15][key],data[16][key],data[17][key]],4);});return data;};}})),_class);var Actual=new store();exports.default=Actual;

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var dataDefault=exports.dataDefault=[{name:"1000&lt;Conference Area<br/>1000&lt;会议厅面积",space1:0,space2:0,space3:0,space4:0,space5:0,space6:0,space7:0,sort:0},{name:"Ballroom A <br/>多功能宴会厅A",space1:0,space2:0,space3:0,space4:0,space5:0,space6:0,space7:0,sort:1},{name:"Ballroom B <br/>多功能宴会厅B",space1:0,space2:0,space3:0,space4:0,space5:0,space6:0,space7:0,sort:2},{name:"500<=Conference Area<1000 <br/>500<=会议厅面积<1000",space1:0,space2:0,space3:0,space4:0,space5:0,space6:0,space7:0,sort:3},{name:"Conference A <br/>大会议室A",space1:0,space2:0,space3:0,space4:0,space5:0,space6:0,space7:0,sort:4},{name:"Conference B <br/>大会议室B",space1:0,space2:0,space3:0,space4:0,space5:0,space6:0,space7:0,sort:5},{name:"Conference C<br/>大会议室C",space1:0,space2:0,space3:0,space4:0,space5:0,space6:0,space7:0,sort:6},{name:"Conference D <br/>大会议室D",space1:0,space2:0,space3:0,space4:0,space5:0,space6:0,space7:0,sort:7},{name:"200<=Conference Area<500 <br/>200<=会议厅面积<500",space1:0,space2:0,space3:0,space4:0,space5:0,space6:0,space7:0,sort:8},{name:"Conference A<br/>中会议室A",space1:0,space2:0,space3:0,space4:0,space5:0,space6:0,space7:0,sort:9},{name:"Conference B<br/>中会议室B",space1:0,space2:0,space3:0,space4:0,space5:0,space6:0,space7:0,sort:10},{name:"Conference C <br/>中会议室C",space1:0,space2:0,space3:0,space4:0,space5:0,space6:0,space7:0,sort:11},{name:"Conference D <br/>中会议室D",space1:0,space2:0,space3:0,space4:0,space5:0,space6:0,space7:0,sort:12},{name:"Conference Area<200 <br/>会议厅面积<200",space1:0,space2:0,space3:0,space4:0,space5:0,space6:0,space7:0,sort:13},{name:"Conference A<br/>小会议室A",space1:0,space2:0,space3:0,space4:0,space5:0,space6:0,space7:0,sort:14},{name:"Conference B <br/>小会议室B",space1:0,space2:0,space3:0,space4:0,space5:0,space6:0,space7:0,sort:15},{name:"Conference C<br/>小会议室C",space1:0,space2:0,space3:0,space4:0,space5:0,space6:0,space7:0,sort:16},{name:"Conference D<br/>小会议室D",space1:0,space2:0,space3:0,space4:0,space5:0,space6:0,space7:0,sort:17}];var intervalData=exports.intervalData={1:"一亿以上",2:"8000万-1亿",3:"6500万-8000万",4:"5500万-6500万",5:"4500万-5500万",6:"3500万-4500万",7:"2500万-3500万",8:"1000万-2500万",9:"小于1000万"};

/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.defaultDayData=undefined;var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _modal=__webpack_require__(61);var _modal2=_interopRequireDefault(_modal);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10;__webpack_require__(10);__webpack_require__(62);var _mobx=__webpack_require__(30);var _imgtopdf=__webpack_require__(128);var _jspdf=__webpack_require__(183);var _jspdf2=_interopRequireDefault(_jspdf);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2256);var _data2=_interopRequireDefault(_data);var _data3=__webpack_require__(2257);var _data4=_interopRequireDefault(_data3);var _compute=__webpack_require__(2258);var _compute2=_interopRequireDefault(_compute);var _method=__webpack_require__(20);var _method2=_interopRequireDefault(_method);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var confirm=_modal2.default.confirm;var defaultDayData=exports.defaultDayData=[{name:"Grand Total<br/>总计",other_day:0,other_last:0,rev_day:0,rev_last:0}];var Store=(_class=function Store(){var _this=this;_classCallCheck(this,Store);_initDefineProp(this,"print",_descriptor,this);_initDefineProp(this,"loading",_descriptor2,this);_initDefineProp(this,"saveLoading",_descriptor3,this);_initDefineProp(this,"roomData",_descriptor4,this);_initDefineProp(this,"foodData",_descriptor5,this);_initDefineProp(this,"dayData",_descriptor6,this);_initDefineProp(this,"date",_descriptor7,this);_initDefineProp(this,"getData",_descriptor8,this);_initDefineProp(this,"onChange",_descriptor9,this);this.onSave=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var date,year,month,day,roomData,foodData,dayData,dataFrom,headres,json,res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:(0,_mobx.runInAction)(function(){_this.saveLoading=true;});_context.prev=1;date=_this.date;year=(0,_moment2.default)(date).format("YYYY");month=(0,_moment2.default)(date).format("M");day=(0,_moment2.default)(date).format("D");roomData=_this.roomData.map(function(x,i){return _extends({},x,{year:year,month:month,day:day});});foodData=_this.foodData.map(function(x,i){return _extends({},x,{year:year,month:month,day:day});});dayData=_this.dayData.map(function(x,i){return _extends({},x,{year:year,month:month,day:day});});// 检查入住率是否合规，超过100% 禁止保存
if(!((0,_method2.default)([3,'last'],roomData)>1||(0,_method2.default)([3,'actual'],roomData)>1)){_context.next=13;break;}confirm({title:'出租率不能超100%，请检查无误后再保存!',cancelText:"取消",okText:"确定"});(0,_mobx.runInAction)(function(){_this.saveLoading=false;});return _context.abrupt("return");case 13:dataFrom=new FormData();dataFrom.append('roomData',JSON.stringify(roomData));dataFrom.append('foodData',JSON.stringify(foodData));dataFrom.append('dayData',JSON.stringify(dayData));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context.next=20;return fetch('/add_day',headres);case 20:json=_context.sent;_context.next=23;return json.json();case 23:res=_context.sent;if(res.status==1){if(!dayData[0].id)_this.getData(date);_message3.default.success('保存成功！');}else _message3.default.error(res.msg);(0,_mobx.runInAction)(function(){_this.saveLoading=false;});_context.next=32;break;case 28:_context.prev=28;_context.t0=_context["catch"](1);(0,_mobx.runInAction)(function(){_this.saveLoading=false;});console.log(_context.t0);case 32:case"end":return _context.stop();}}},_callee,_this,[[1,28]]);}));_initDefineProp(this,"download",_descriptor10,this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,"print",[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,"loading",[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,"saveLoading",[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,"roomData",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,"foodData",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,"dayData",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[].concat(defaultDayData);}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,"date",[_mobx.observable],{enumerable:true,initializer:function initializer(){return(0,_moment2.default)().format('YYYY-MM-DD');}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,"getData",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(date){var roomData,foodData,dayData,url,json,res;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:(0,_mobx.runInAction)(function(){_this2.loading=true;_this2.roomData=[];_this2.foodData=[];_this2.dayData=[];});_context2.prev=1;roomData=JSON.parse(JSON.stringify(_data2.default));foodData=JSON.parse(JSON.stringify(_data4.default));dayData=JSON.parse(JSON.stringify(defaultDayData));url="/_day_info?year="+(0,_moment2.default)(date).format('YYYY')+"&month="+(0,_moment2.default)(date).format('M')+"&day="+(0,_moment2.default)(date).format('D');_context2.next=8;return fetch(url,{credentials:'include'});case 8:json=_context2.sent;_context2.next=11;return json.json();case 11:res=_context2.sent;if(res.data.foodData&&res.data.foodData.length>0){foodData=res.data.foodData.sort(function(a,b){return a.sort-b.sort;});}if(res.data.roomData&&res.data.roomData.length>0){roomData=res.data.roomData.sort(function(a,b){return a.sort-b.sort;});}if(res.data.dayData){dayData=[_extends({},res.data.dayData)];}_context2.next=17;return _this2.onChange({roomData:roomData,foodData:foodData,dayData:dayData});case 17:(0,_mobx.runInAction)(function(){_this2.loading=false;});_context2.next=24;break;case 20:_context2.prev=20;_context2.t0=_context2["catch"](1);(0,_mobx.runInAction)(function(){_this2.loading=false;});console.log(_context2.t0);case 24:case"end":return _context2.stop();}}},_callee2,_this2,[[1,20]]);}));return function(_x){return _ref2.apply(this,arguments);};}();}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,"onChange",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(_ref3){var roomData=_ref3.roomData,foodData=_ref3.foodData,dayData=_ref3.dayData;var data=(0,_compute2.default)({roomData:roomData,foodData:foodData,dayData:dayData});_this3.roomData=data.roomData;_this3.foodData=data.foodData;_this3.dayData=data.dayData;};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,"download",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return _asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(){var res,canvas,pageData,pdf;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:(0,_mobx.runInAction)(function(){_this4.print=true;});_context3.prev=1;_context3.next=4;return(0,_imgtopdf.imgToPdf)('daily',1.5);case 4:res=_context3.sent;canvas=res.canvas;pageData=canvas.toDataURL('image/png',0.7);//方向默认横向，尺寸ponits, 按照图片大小进行输出
pdf=new _jspdf2.default('l','pt',[canvas.width,canvas.height]);//需要dataUrl格式
pdf.addImage(pageData,'PNG',0,0,canvas.width,canvas.height);pdf.save("Daily Revenue Report \u6BCF\u65E5\u7ECF\u8425\u62A5\u8868.pdf");(0,_mobx.runInAction)(function(){_this4.print=false;});_context3.next=17;break;case 13:_context3.prev=13;_context3.t0=_context3["catch"](1);(0,_mobx.runInAction)(function(){_this4.print=false;});console.error(_context3.t0);case 17:case"end":return _context3.stop();}}},_callee3,_this4,[[1,13]]);}));}})),_class);var daily=new Store();exports.default=daily;

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=[{name:"Total Rooms <br/>总房数",actual:0,last:0,sort:0},{name:"Total Rooms Available<br/>可售房",actual:0,last:0,sort:1},{name:"Total Occupied<br/>占用房合计",actual:0,last:0,sort:2},{name:"Paid Occupancy%<br/>出租率",actual:0,last:0,sort:3},{name:"Average RM Rate(RMB)<br/>平均房价（人民币）",actual:0,last:0,sort:4},{name:"Revpar<br/>平均每间房收益",actual:0,last:0,sort:5},{name:"Total Room Revenue<br/>房费合计",actual:0,last:0,sort:6},{name:"Total No. Of Guest<br/>住店客人数",actual:0,last:0,sort:7},{name:"Double Occupancy%<br/>双人入住率",actual:0,last:0,sort:8}];

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=[{name:"Coffee Shop (BF)<br/>豪生咖啡厅（早餐）",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:0},{name:"Coffee Shop (L&D)<br/>豪生咖啡厅（午晚餐）",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:1},{name:"Chinese Restaurant<br/>中餐厅",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:2},{name:"Special Restaurant<br/>特色餐厅",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:3},{name:"Lobby Lounge<br/>大堂酒吧",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:4},{name:"Room Service<br/>送餐服务",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:5},{name:"Banquet<br/>宴会厅",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:6},{name:"Mini Bar<br/>迷你吧",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:7},{name:"Executive Club<br/>行政楼层",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:8},{name:"Other Income<br/>其他收入",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:9},{name:"Total F&B Revenue<br/>餐饮合计",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:10}];

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=function(_ref){var _ref$roomData=_ref.roomData,roomData=_ref$roomData===undefined?[]:_ref$roomData,_ref$foodData=_ref.foodData,foodData=_ref$foodData===undefined?[]:_ref$foodData,_ref$dayData=_ref.dayData,dayData=_ref$dayData===undefined?[]:_ref$dayData;// 计算餐饮收入
['actual','covers','last_actual','last_covers'].forEach(function(name){foodData[10][name]=foodData.reduce(function(a,b,i){if(i<10)a+=(0,_method.numConvert)(b[name]);return a;},0).toFixed(2);});foodData.forEach(function(item,i){foodData[i].average=(0,_method.calculation)(item.actual,item.covers);foodData[i].last_average=(0,_method.calculation)(item.last_actual,item.last_covers);if(i===10){foodData[i].average=(0,_method.calculation)(item.actual-foodData[9].actual,item.covers);foodData[i].last_average=(0,_method.calculation)(item.last_actual-foodData[9].last_actual,item.last_covers);}});// 计算客房
['actual','last'].forEach(function(name){roomData[3][name]=(0,_method.calculation)(roomData[2][name],roomData[1][name],4);roomData[4][name]=(0,_method.calculation)(roomData[6][name],roomData[2][name],2);roomData[5][name]=(roomData[4][name]*roomData[3][name]).toFixed(2);roomData[8][name]=(0,_method.calculation)(roomData[7][name],roomData[2][name],4);});// 计算总收入
dayData[0].rev_day=((0,_method.numConvert)(dayData[0].other_day)+(0,_method.numConvert)((0,_method.getJson)([10,'actual'],foodData))+(0,_method.numConvert)((0,_method.getJson)([6,'actual'],roomData))).toFixed(2);dayData[0].rev_last=(0,_method.sum)([dayData[0].other_last,(0,_method.getJson)([10,'last_actual'],foodData),(0,_method.getJson)([6,'last'],roomData)],2);return{roomData:roomData,foodData:foodData,dayData:dayData};};var _method=__webpack_require__(20);

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.defaultDayData=undefined;var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11;__webpack_require__(10);var _mobx=__webpack_require__(30);var _imgtopdf=__webpack_require__(128);var _jspdf=__webpack_require__(183);var _jspdf2=_interopRequireDefault(_jspdf);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _data=__webpack_require__(2260);var _data2=_interopRequireDefault(_data);var _data3=__webpack_require__(2261);var _data4=_interopRequireDefault(_data3);var _compute=__webpack_require__(2262);var _compute2=_interopRequireDefault(_compute);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var defaultDayData=exports.defaultDayData=[{name:"Grand Total<br/>总计",other_day:0,other_last:0,rev_day:0,rev_last:0}];var Store=(_class=function Store(){_classCallCheck(this,Store);_initDefineProp(this,"print",_descriptor,this);_initDefineProp(this,"loading",_descriptor2,this);_initDefineProp(this,"saveLoading",_descriptor3,this);_initDefineProp(this,"roomData",_descriptor4,this);_initDefineProp(this,"foodData",_descriptor5,this);_initDefineProp(this,"dayData",_descriptor6,this);_initDefineProp(this,"date",_descriptor7,this);_initDefineProp(this,"getData",_descriptor8,this);_initDefineProp(this,"aKeyToSave",_descriptor9,this);_initDefineProp(this,"onChange",_descriptor10,this);_initDefineProp(this,"download",_descriptor11,this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,"print",[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,"loading",[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,"saveLoading",[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,"roomData",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,"foodData",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,"dayData",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[].concat(defaultDayData);}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,"date",[_mobx.observable],{enumerable:true,initializer:function initializer(){return(0,_moment2.default)().format('YYYY-MM');}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,"getData",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var year,month,roomData,foodData,dayData,url,json,res,dataFrom,headres,saveres;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:(0,_mobx.runInAction)(function(){_this.loading=true;_this.roomData=[];_this.foodData=[];_this.dayData=[];});_context.prev=1;year=(0,_moment2.default)(date).format('YYYY');month=(0,_moment2.default)(date).format('M');roomData=JSON.parse(JSON.stringify(_data2.default));foodData=JSON.parse(JSON.stringify(_data4.default));dayData=JSON.parse(JSON.stringify(defaultDayData));url="/dayMonth?year="+year+"&month="+month;_context.next=10;return fetch(url,{credentials:'include'});case 10:json=_context.sent;_context.next=13;return json.json();case 13:res=_context.sent;if(res.data.food){foodData=Object.entries(res.data.food).map(function(v){return _extends({},v[1],{name:v[0]});});}if(res.data.room){roomData=Object.entries(res.data.room).map(function(v){return _extends({},v[1],{name:v[0]});});}if(res.data.total){dayData=[_extends({},res.data.total)];}_context.next=19;return _this.onChange({roomData:roomData,foodData:foodData,dayData:dayData});case 19:dataFrom=new FormData();dataFrom.append('data',JSON.stringify({roomData:roomData,foodData:foodData,dayData:dayData}));dataFrom.append('year',year);dataFrom.append('month',month);headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context.next=26;return fetch('/dayMonthSave',headres);case 26:saveres=_context.sent;_context.next=29;return saveres.json();case 29:(0,_mobx.runInAction)(function(){_this.loading=false;});_context.next=36;break;case 32:_context.prev=32;_context.t0=_context["catch"](1);(0,_mobx.runInAction)(function(){_this.loading=false;});console.log(_context.t0);case 36:case"end":return _context.stop();}}},_callee,_this,[[1,32]]);}));return function(_x){return _ref.apply(this,arguments);};}();}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,"aKeyToSave",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(date){var year,month,url,json,res,dataAll,index,item,roomData,foodData,dayData,dataFrom,headres,saveres;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:(0,_mobx.runInAction)(function(){_this2.loading=true;_this2.print=true;});_context2.prev=1;year=(0,_moment2.default)(date).format('YYYY');month=(0,_moment2.default)(date).format('M');url="/getAll/dayMonth?year="+year+"&month="+month;_context2.next=7;return fetch(url,{credentials:'include'});case 7:json=_context2.sent;_context2.next=10;return json.json();case 10:res=_context2.sent;dataAll=[];for(index=0;index<res.data.length;index++){item=res.data[index];roomData=JSON.parse(JSON.stringify(_data2.default));foodData=JSON.parse(JSON.stringify(_data4.default));dayData=JSON.parse(JSON.stringify(defaultDayData));if(item.food){foodData=Object.entries(item.food).map(function(v){return _extends({},v[1],{name:v[0]});});}if(item.room){roomData=Object.entries(item.room).map(function(v){return _extends({},v[1],{name:v[0]});});}if(item.total){dayData=[_extends({},item.total)];}dataAll.push({comid:item.id,year:year,month:month,foodData:foodData,roomData:roomData,dayData:dayData});}dataFrom=new FormData();dataFrom.append('data',JSON.stringify(dataAll));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context2.next=18;return fetch('/saveAll/dayMonthSave',headres);case 18:saveres=_context2.sent;_context2.next=21;return saveres.json();case 21:_message3.default.success('全部酒店数据保存成功！');(0,_mobx.runInAction)(function(){_this2.loading=false;_this2.print=false;});_context2.next=29;break;case 25:_context2.prev=25;_context2.t0=_context2["catch"](1);(0,_mobx.runInAction)(function(){_this2.loading=false;_this2.print=false;});console.log(_context2.t0);case 29:case"end":return _context2.stop();}}},_callee2,_this2,[[1,25]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,"onChange",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(_ref3){var roomData=_ref3.roomData,foodData=_ref3.foodData,dayData=_ref3.dayData;var data=(0,_compute2.default)({roomData:roomData,foodData:foodData,dayData:dayData});_this3.roomData=data.roomData;_this3.foodData=data.foodData;_this3.dayData=data.dayData;};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,"download",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return _asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(){var res,canvas,pageData,pdf;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:(0,_mobx.runInAction)(function(){_this4.print=true;});_context3.prev=1;_context3.next=4;return(0,_imgtopdf.imgToPdf)('daily',1.5);case 4:res=_context3.sent;canvas=res.canvas;pageData=canvas.toDataURL('image/png',0.7);//方向默认横向，尺寸ponits, 按照图片大小进行输出
pdf=new _jspdf2.default('l','pt',[canvas.width,canvas.height]);//需要dataUrl格式
pdf.addImage(pageData,'PNG',0,0,canvas.width,canvas.height);pdf.save("Daily Revenue Report \u6BCF\u65E5\u7ECF\u8425\u62A5\u8868.pdf");(0,_mobx.runInAction)(function(){_this4.print=false;});_context3.next=17;break;case 13:_context3.prev=13;_context3.t0=_context3["catch"](1);(0,_mobx.runInAction)(function(){_this4.print=false;});console.error(_context3.t0);case 17:case"end":return _context3.stop();}}},_callee3,_this4,[[1,13]]);}));}})),_class);var daily=new Store();exports.default=daily;

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=[{name:"Total Rooms <br/>总房数",actual:0,last:0,sort:0},{name:"Total Rooms Available<br/>可售房",actual:0,last:0,sort:1},{name:"Total Occupied<br/>占用房合计",actual:0,last:0,sort:2},{name:"Paid Occupancy%<br/>出租率",actual:0,last:0,sort:3},{name:"Average RM Rate(RMB)<br/>平均房价（人民币）",actual:0,last:0,sort:4},{name:"Revpar<br/>平均每间房收益",actual:0,last:0,sort:5},{name:"Total Room Revenue<br/>房费合计",actual:0,last:0,sort:6},{name:"Total No. Of Guest<br/>住店客人数",actual:0,last:0,sort:7},{name:"Double Occupancy%<br/>双人入住率",actual:0,last:0,sort:8}];

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=[{name:"Coffee Shop (BF)<br/>豪生咖啡厅（早餐）",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:0},{name:"Coffee Shop (L&D)<br/>豪生咖啡厅（午晚餐）",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:1},{name:"Chinese Restaurant<br/>中餐厅",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:2},{name:"Special Restaurant<br/>特色餐厅",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:3},{name:"Lobby Lounge<br/>大堂酒吧",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:4},{name:"Room Service<br/>送餐服务",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:5},{name:"Banquet<br/>宴会厅",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:6},{name:"Mini Bar<br/>迷你吧",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:7},{name:"Executive Club<br/>行政楼层",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:8},{name:"Other Income<br/>其他收入",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:9},{name:"Total F&B Revenue<br/>餐饮合计",actual:0,covers:0,average:0,last_actual:0,last_covers:0,last_average:0,sort:10}];

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=function(_ref){var _ref$roomData=_ref.roomData,roomData=_ref$roomData===undefined?[]:_ref$roomData,_ref$foodData=_ref.foodData,foodData=_ref$foodData===undefined?[]:_ref$foodData,_ref$dayData=_ref.dayData,dayData=_ref$dayData===undefined?[]:_ref$dayData;// 计算餐饮收入
['actual','covers','last_actual','last_covers'].forEach(function(name){foodData[10][name]=foodData.reduce(function(a,b,i){if(i<10)a+=(0,_method.numConvert)(b[name]);return a;},0).toFixed(2);});foodData.forEach(function(item,i){foodData[i].average=(0,_method.calculation)(item.actual,item.covers);foodData[i].last_average=(0,_method.calculation)(item.last_actual,item.last_covers);if(i===10){foodData[i].average=(0,_method.calculation)(item.actual-foodData[9].actual,item.covers);foodData[i].last_average=(0,_method.calculation)(item.last_actual-foodData[9].last_actual,item.last_covers);}});// 计算客房
['actual','last'].forEach(function(name){roomData[3][name]=(0,_method.calculation)(roomData[2][name],roomData[1][name],4);roomData[4][name]=(0,_method.calculation)(roomData[6][name],roomData[2][name],2);roomData[5][name]=(roomData[4][name]*roomData[3][name]).toFixed(2);roomData[8][name]=(0,_method.calculation)(roomData[7][name],roomData[2][name],4);});// 计算总收入
dayData[0].rev_day=((0,_method.numConvert)(dayData[0].other_day)+(0,_method.numConvert)((0,_method.getJson)([10,'actual'],foodData))+(0,_method.numConvert)((0,_method.getJson)([6,'actual'],roomData))).toFixed(2);dayData[0].rev_last=(0,_method.sum)([dayData[0].other_last,(0,_method.getJson)([10,'last_actual'],foodData),(0,_method.getJson)([6,'last'],roomData)],2);return{roomData:roomData,foodData:foodData,dayData:dayData};};var _method=__webpack_require__(20);

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9;__webpack_require__(10);var _mobx=__webpack_require__(30);var _data=__webpack_require__(289);var _data2=_interopRequireDefault(_data);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _method=__webpack_require__(20);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var listName=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];var defaultNotes={cashFlow:"",accountsReceivable:"",inventory:"",profit:"",business:"",cost:"",name:"",date:(0,_moment2.default)().format('YYYY-MM-DD')};var store=(_class=function store(){_classCallCheck(this,store);_initDefineProp(this,'date',_descriptor,this);_initDefineProp(this,'data',_descriptor2,this);_initDefineProp(this,'loading',_descriptor3,this);_initDefineProp(this,'saving',_descriptor4,this);_initDefineProp(this,'notes',_descriptor5,this);_initDefineProp(this,'cost',_descriptor6,this);_initDefineProp(this,'deposit',_descriptor7,this);_initDefineProp(this,'getData',_descriptor8,this);_initDefineProp(this,'onSave',_descriptor9,this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'date',[_mobx.observable],{enumerable:true,initializer:function initializer(){return(0,_moment2.default)().subtract(1,'month').format('YYYY');}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'data',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[].concat(_toConsumableArray(_data2.default));}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'saving',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'notes',[_mobx.observable],{enumerable:true,initializer:function initializer(){return _extends({},defaultNotes);}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'cost',[_mobx.observable],{enumerable:true,initializer:function initializer(){return _lodash2.default.cloneDeep(_data.costData);}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'deposit',[_mobx.observable],{enumerable:true,initializer:function initializer(){return _lodash2.default.cloneDeep(_data.depositData);}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var year,url,json,res,_deposit,deposit,data,cost;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:(0,_mobx.runInAction)(function(){_this.loading=true;_this.data=[];});_context.prev=1;year=(0,_moment2.default)(date).format('YYYY');url='/monthlyAnalysis?year='+year;_context.next=6;return fetch(url,{credentials:'include'});case 6:json=_context.sent;_context.next=9;return json.json();case 9:res=_context.sent;_deposit=(res.data.deposit||[]).reduce(function(a,b){a[b.month]=b;return a;},{});deposit=_lodash2.default.cloneDeep(_data.depositData);if(res.data.deposit&&res.data.deposit.length)deposit=['Adjusted','Debit','Credit','Current'].map(function(name,j){return _extends({name:_data.depositData[j].name},listName.reduce(function(a,b,i){a[b]=(_deposit[i+1]||{})[name]||0;return a;},{}));});console.log(deposit);data=compute(res.data);cost=computeCost(res.data);(0,_mobx.runInAction)(function(){_this.loading=false;_this.deposit=deposit;_this.data=data&&data.length>0?data:[].concat(_toConsumableArray(_data2.default));_this.notes=_extends({},defaultNotes,res.data.notes);_this.cost=cost&&cost.length>0?cost:_lodash2.default.cloneDeep(_data.costData);});_context.next=24;break;case 19:_context.prev=19;_context.t0=_context['catch'](1);console.error(_context.t0);_message3.default.error('数据处理失败！');(0,_mobx.runInAction)(function(){_this.loading=false;});case 24:case'end':return _context.stop();}}},_callee,_this,[[1,19]]);}));return function(_x){return _ref.apply(this,arguments);};}();}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'onSave',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return _asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var date,data,cost,notes,dataFrom,headres,json,res;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:date=_this2.date;data=(0,_mobx.toJS)(_this2.data).map(function(x){return Object.keys(x).reduce(function(a,b){if(!b.includes('minus'))a[b]=x[b];return a;},{year:date});});cost=(0,_mobx.toJS)(_this2.cost).map(function(x){return _extends({},x,{year:date});});notes=_extends({},(0,_mobx.toJS)(_this2.notes),{year:date});if(notes.name){_context2.next=6;break;}return _context2.abrupt('return',_message3.default.error('请输入填写人姓名'));case 6:(0,_mobx.runInAction)(function(){_this2.saving=true;});_context2.prev=7;dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));dataFrom.append('cost',JSON.stringify(cost));dataFrom.append('notes',JSON.stringify(notes));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context2.next=15;return fetch('/addMonthlyAnalysis',headres);case 15:json=_context2.sent;_context2.next=18;return json.json();case 18:res=_context2.sent;if(res.status==1){_message3.default.success('保存成功！');if(!data[0].id||!notes.id){_this2.getData(_this2.date);}}else{_message3.default.error(res.msg);}(0,_mobx.runInAction)(function(){_this2.saving=false;});_context2.next=28;break;case 23:_context2.prev=23;_context2.t0=_context2['catch'](7);_message3.default.error('保存失败！');console.error(_context2.t0);(0,_mobx.runInAction)(function(){_this2.saving=false;});case 28:case'end':return _context2.stop();}}},_callee2,_this2,[[7,23]]);}));}})),_class);var Month=new store();exports.default=Month;function compute(_ref3){var _ref3$data=_ref3.data,data=_ref3$data===undefined?[]:_ref3$data,_ref3$cash=_ref3.cash,cash=_ref3$cash===undefined?[]:_ref3$cash,_ref3$income=_ref3.income,income=_ref3$income===undefined?[]:_ref3$income,_ref3$room=_ref3.room,room=_ref3$room===undefined?[]:_ref3$room,_ref3$fb=_ref3.fb,fb=_ref3$fb===undefined?[]:_ref3$fb,_ref3$gop=_ref3.gop,gop=_ref3$gop===undefined?[]:_ref3$gop,_ref3$account=_ref3.account,account=_ref3$account===undefined?[]:_ref3$account,_ref3$inventories=_ref3.inventories,inventories=_ref3$inventories===undefined?[]:_ref3$inventories,_ref3$food=_ref3.food,food=_ref3$food===undefined?[]:_ref3$food,_ref3$gops=_ref3.gops,gops=_ref3$gops===undefined?[]:_ref3$gops,_ref3$incomeLast=_ref3.incomeLast,incomeLast=_ref3$incomeLast===undefined?[]:_ref3$incomeLast,_ref3$gopsLast=_ref3.gopsLast,gopsLast=_ref3$gopsLast===undefined?[]:_ref3$gopsLast;if(!data.length)data=_data2.default;cash=cash.reduce(function(a,b){a[b.month]=b;return a;},{});income=income.reduce(function(a,b){a[b.month]=b;return a;},{});income[0]=_lodash2.default.get(incomeLast,'0')||{actual:0};account=account.reduce(function(a,b){a[b.month]=b;return a;},{});inventories=inventories.reduce(function(a,b){a[b.month]=b;return a;},{});food=food.reduce(function(a,b){a[b.month]=b;return a;},{});gops=gops.reduce(function(a,b){a[b.month]=b;return a;},{});gops[0]=_lodash2.default.get(gopsLast,'0')||{actual:0};room=room.reduce(function(a,b){a[b.month]=b;return a;},{});fb=fb.reduce(function(a,b){a[b.month]=b;return a;},{});gop=gop.reduce(function(a,b){a[b.month]=b;return a;},{});['Adjusted','Debit','Credit','Current'].forEach(function(name,i){data[i]=listName.reduce(function(a,b,i){a[b]=_lodash2.default.get(cash,i+1+'.'+name)||0;return a;},_extends({},data[i]));});data[4]=listName.reduce(function(a,b,i){var index=i+1;a[b]=(30/(_lodash2.default.get(income,index+'.actual')/((_lodash2.default.get(account,index+'.Adjusted')||0)/2+_lodash2.default.get(account,index+'.Current')/2))||0).toFixed(0);return a;},_extends({},data[4]));data[5]=listName.reduce(function(a,b,i){var index=i+1;a[b]=(30/(_lodash2.default.get(food,index+'.actual')/((_lodash2.default.get(inventories,index+'.Adjusted')||0)/2+_lodash2.default.get(inventories,index+'.Current')/2))||0).toFixed(0);return a;},_extends({},data[5]));data[6]=listName.reduce(function(a,b,i){a[b]=_lodash2.default.get(room,i+1+'.actual')||0;return a;},_extends({},data[6]));data[7]=listName.reduce(function(a,b,i){a[b]=_lodash2.default.get(fb,i+1+'.actual')||0;return a;},_extends({},data[7]));data[8]=listName.reduce(function(a,b,i){a[b]=_lodash2.default.get(gop,i+1+'.actual')||0;return a;},_extends({},data[8]));data[9]=listName.reduce(function(a,b,i){var index=i+1;a[b]=(0,_method.calculation)(_lodash2.default.get(income,index+'.actual',0)-_lodash2.default.get(income,index-1+'.actual',0),_lodash2.default.get(income,index-1+'.actual',0),4);return a;},_extends({},data[9]));data[10]=listName.reduce(function(a,b,i){var index=i+1;a[b]=(0,_method.calculation)(_lodash2.default.get(gops,index+'.actual',0)-_lodash2.default.get(gops,index-1+'.actual',0),_lodash2.default.get(gops,index-1+'.actual',0),4);if(index>0&&_lodash2.default.get(gops,index+'.actual',0)>_lodash2.default.get(gops,index-1+'.actual',0)&&_lodash2.default.get(gops,index-1+'.actual',0)<0){a[b+'minus']=true;}return a;},_extends({},data[10]));return data;}function computeCost(_ref4){var cost=_ref4.cost,costRate=_ref4.costRate;if(!cost.length)cost=_lodash2.default.cloneDeep(_data.costData);var costName=['food','human','energy','other'];cost=costName.map(function(name,i){return _extends({},cost[i],listName.reduce(function(a,b,j){a[b]=(costRate[name].find(function(x){return x.month==j+1;})||{}).actual||0;return a;},{}));});return cost;}

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7;__webpack_require__(10);var _mobx=__webpack_require__(30);var _data=__webpack_require__(398);var _data2=_interopRequireDefault(_data);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var store=(_class=function store(){_classCallCheck(this,store);_initDefineProp(this,'date',_descriptor,this);_initDefineProp(this,'data',_descriptor2,this);_initDefineProp(this,'loading',_descriptor3,this);_initDefineProp(this,'saving',_descriptor4,this);_initDefineProp(this,'recommend',_descriptor5,this);_initDefineProp(this,'getData',_descriptor6,this);_initDefineProp(this,'onSave',_descriptor7,this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'date',[_mobx.observable],{enumerable:true,initializer:function initializer(){return(0,_moment2.default)().subtract(1,'month').format('YYYY');}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'data',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[].concat(_toConsumableArray(_data2.default));}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'saving',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'recommend',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[].concat(_toConsumableArray(_data.recommend));}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var year,url,json,res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:(0,_mobx.runInAction)(function(){_this.loading=true;_this.data=[];});_context.prev=1;year=(0,_moment2.default)(date).format('YYYY');url='/financePersonnelInfo?year='+year;_context.next=6;return fetch(url,{credentials:'include'});case 6:json=_context.sent;_context.next=9;return json.json();case 9:res=_context.sent;console.log(res.data);(0,_mobx.runInAction)(function(){_this.loading=false;_this.recommend=res.data.recommend.length?res.data.recommend:[].concat(_toConsumableArray(_data.recommend));_this.data=res.data.data.length?res.data.data:[].concat(_toConsumableArray(_data2.default));});_context.next=19;break;case 14:_context.prev=14;_context.t0=_context['catch'](1);console.error(_context.t0);_message3.default.error('数据处理失败！');(0,_mobx.runInAction)(function(){_this.loading=false;});case 19:case'end':return _context.stop();}}},_callee,_this,[[1,14]]);}));return function(_x){return _ref.apply(this,arguments);};}();}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'onSave',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return _asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var date,data,recommend,dataFrom,headres,json,res;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:date=_this2.date;data=(0,_mobx.toJS)(_this2.data).map(function(x){return _extends({},x,{year:date});});recommend=(0,_mobx.toJS)(_this2.recommend).map(function(x){return _extends({},x,{year:date});});(0,_mobx.runInAction)(function(){_this2.saving=true;});_context2.prev=4;dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));dataFrom.append('recommend',JSON.stringify(recommend));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context2.next=11;return fetch('/financePersonnelSave',headres);case 11:json=_context2.sent;_context2.next=14;return json.json();case 14:res=_context2.sent;if(res.status==1){_message3.default.success('保存成功！');if(!data[0].id||!recommend[0].id){_this2.getData(_this2.date);}}else{_message3.default.error(res.msg);}(0,_mobx.runInAction)(function(){_this2.saving=false;});_context2.next=24;break;case 19:_context2.prev=19;_context2.t0=_context2['catch'](4);_message3.default.error('保存失败！');console.error(_context2.t0);(0,_mobx.runInAction)(function(){_this2.saving=false;});case 24:case'end':return _context2.stop();}}},_callee2,_this2,[[4,19]]);}));}})),_class);var Month=new store();exports.default=Month;

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11;__webpack_require__(10);var _mobx=__webpack_require__(30);var _data=__webpack_require__(588);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);var _axios=__webpack_require__(86);var _axios2=_interopRequireDefault(_axios);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var store=(_class=function store(){_classCallCheck(this,store);_initDefineProp(this,"date",_descriptor,this);_initDefineProp(this,"loading",_descriptor2,this);_initDefineProp(this,"saving",_descriptor3,this);_initDefineProp(this,"room",_descriptor4,this);_initDefineProp(this,"customers",_descriptor5,this);_initDefineProp(this,"food",_descriptor6,this);_initDefineProp(this,"comments",_descriptor7,this);_initDefineProp(this,"platform",_descriptor8,this);_initDefineProp(this,"submarket",_descriptor9,this);_initDefineProp(this,"getData",_descriptor10,this);_initDefineProp(this,"onSave",_descriptor11,this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,"date",[_mobx.observable],{enumerable:true,initializer:function initializer(){return(0,_moment2.default)().format("YYYY-W");}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,"loading",[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,"saving",[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,"room",[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,"customers",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,"food",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,"comments",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,"platform",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,"submarket",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,"getData",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var year,week,res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:(0,_mobx.runInAction)(function(){_this.loading=true;_this.customers=[];_this.food=[];_this.comments=[];_this.platform=[];_this.submarket=[];_this.date=date;});_context.prev=1;year=(0,_moment2.default)(date,"YYYY-W").format("YYYY");week=(0,_moment2.default)(date,"YYYY-W").format("W");_context.next=6;return _axios2.default.post("/api/data",{list:[{name:"comments",key:"kpi_comments",year:year,week:week},{name:"customer",key:"kpi_customer",year:year,week:week},{name:"food",key:"kpi_food",year:year,week:week},{name:"platform",key:"kpi_platform",year:year,week:week},{name:"submarket",key:"kpi_submarket",year:year,week:week}]});case 6:res=_context.sent;console.log(res);(0,_mobx.runInAction)(function(){_this.loading=false;_this.customers=res.data.customer.length?res.data.customer:JSON.parse(JSON.stringify(_data.customersData));_this.food=res.data.food.length?res.data.food:JSON.parse(JSON.stringify(_data.foodData));_this.comments=res.data.comments.length?res.data.comments:JSON.parse(JSON.stringify(_data.commentsData));_this.platform=res.data.platform.length?res.data.platform:JSON.parse(JSON.stringify(_data.platformData));_this.submarket=res.data.submarket.length?res.data.submarket:JSON.parse(JSON.stringify(_data.submarketData));_this.room=_lodash2.default.get(res,"data.customer.[0].room",0);});_context.next=16;break;case 11:_context.prev=11;_context.t0=_context["catch"](1);console.error(_context.t0);_message3.default.error("数据处理失败！");(0,_mobx.runInAction)(function(){_this.loading=false;});case 16:case"end":return _context.stop();}}},_callee,_this,[[1,11]]);}));return function(_x){return _ref.apply(this,arguments);};}();}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,"onSave",[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return _asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var date,year,week,customers,food,comments,platform,submarket,res;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:date=_this2.date;year=(0,_moment2.default)(date,"YYYY-W").format("YYYY");week=(0,_moment2.default)(date,"YYYY-W").format("W");customers=(0,_mobx.toJS)(_this2.customers).map(function(x){return _extends({},x,{room:_this2.room,year:year,week:week});});food=(0,_mobx.toJS)(_this2.food).map(function(x){return _extends({},x,{year:year,week:week});});comments=(0,_mobx.toJS)(_this2.comments).map(function(x){return _extends({},x,{year:year,week:week});});platform=(0,_mobx.toJS)(_this2.platform).map(function(x){return _extends({},x,{year:year,week:week});});submarket=(0,_mobx.toJS)(_this2.submarket).map(function(x){return _extends({},x,{year:year,week:week});});(0,_mobx.runInAction)(function(){_this2.saving=true;});_context2.prev=9;_context2.next=12;return _axios2.default.post("/es/kpifollow",{customers:customers,food:food,comments:comments,platform:platform,submarket:submarket,year:year,week:week});case 12:res=_context2.sent;if(res.code==200){_message3.default.success("保存成功！");if(!customers[0].id){_this2.getData(_this2.date);}}else{_message3.default.error(res.msg);}(0,_mobx.runInAction)(function(){_this2.saving=false;});_context2.next=22;break;case 17:_context2.prev=17;_context2.t0=_context2["catch"](9);_message3.default.error("保存失败！");console.error(_context2.t0);(0,_mobx.runInAction)(function(){_this2.saving=false;});case 22:case"end":return _context2.stop();}}},_callee2,_this2,[[9,17]]);}));}})),_class);var Month=new store();exports.default=Month;

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _regenerator=__webpack_require__(17);var _regenerator2=_interopRequireDefault(_regenerator);var _message2=__webpack_require__(9);var _message3=_interopRequireDefault(_message2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7;__webpack_require__(10);var _mobx=__webpack_require__(30);var _data=__webpack_require__(399);var _data2=_interopRequireDefault(_data);var _moment=__webpack_require__(2);var _moment2=_interopRequireDefault(_moment);var _lodash=__webpack_require__(29);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var store=(_class=function store(){_classCallCheck(this,store);_initDefineProp(this,'date',_descriptor,this);_initDefineProp(this,'data',_descriptor2,this);_initDefineProp(this,'loading',_descriptor3,this);_initDefineProp(this,'saving',_descriptor4,this);_initDefineProp(this,'recommend',_descriptor5,this);_initDefineProp(this,'getData',_descriptor6,this);_initDefineProp(this,'onSave',_descriptor7,this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'date',[_mobx.observable],{enumerable:true,initializer:function initializer(){return(0,_moment2.default)().subtract(1,'month').format('YYYY');}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'data',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[].concat(_toConsumableArray(_data2.default));}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'saving',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'recommend',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[].concat(_toConsumableArray(_data.recommend));}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(date){var year,url,json,res;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:(0,_mobx.runInAction)(function(){_this.loading=true;_this.data=[];});_context.prev=1;year=(0,_moment2.default)(date).format('YYYY');url='/salesPersonnelInfo?year='+year;_context.next=6;return fetch(url,{credentials:'include'});case 6:json=_context.sent;_context.next=9;return json.json();case 9:res=_context.sent;console.log(res.data);(0,_mobx.runInAction)(function(){_this.loading=false;_this.recommend=res.data.recommend.length?res.data.recommend:[].concat(_toConsumableArray(_data.recommend));_this.data=res.data.data.length?res.data.data:[].concat(_toConsumableArray(_data2.default));});_context.next=19;break;case 14:_context.prev=14;_context.t0=_context['catch'](1);console.error(_context.t0);_message3.default.error('数据处理失败！');(0,_mobx.runInAction)(function(){_this.loading=false;});case 19:case'end':return _context.stop();}}},_callee,_this,[[1,14]]);}));return function(_x){return _ref.apply(this,arguments);};}();}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'onSave',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return _asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var date,data,recommend,dataFrom,headres,json,res;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:date=_this2.date;data=(0,_mobx.toJS)(_this2.data).map(function(x){return _extends({},x,{year:date});});recommend=(0,_mobx.toJS)(_this2.recommend).map(function(x){return _extends({},x,{year:date});});(0,_mobx.runInAction)(function(){_this2.saving=true;});_context2.prev=4;dataFrom=new FormData();dataFrom.append('data',JSON.stringify(data));dataFrom.append('recommend',JSON.stringify(recommend));headres={method:'post',credentials:'include',headers:{},body:dataFrom};_context2.next=11;return fetch('/salesPersonnelSave',headres);case 11:json=_context2.sent;_context2.next=14;return json.json();case 14:res=_context2.sent;if(res.status==1){_message3.default.success('保存成功！');if(!data[0].id||!recommend[0].id){_this2.getData(_this2.date);}}else{_message3.default.error(res.msg);}(0,_mobx.runInAction)(function(){_this2.saving=false;});_context2.next=24;break;case 19:_context2.prev=19;_context2.t0=_context2['catch'](4);_message3.default.error('保存失败！');console.error(_context2.t0);(0,_mobx.runInAction)(function(){_this2.saving=false;});case 24:case'end':return _context2.stop();}}},_callee2,_this2,[[4,19]]);}));}})),_class);var Month=new store();exports.default=Month;

/***/ }),
/* 2267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2268 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(830);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.e664fed9.js